import "./web-src.dd548044.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree364"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree364"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6C64U", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $4d0b01b42c984508$export$ffb0004e005737fa, (v) => $4d0b01b42c984508$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $4d0b01b42c984508$export$34b9dba7ce09269b, (v) => $4d0b01b42c984508$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $4d0b01b42c984508$export$25062201e9e25d76, (v) => $4d0b01b42c984508$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4d0b01b42c984508$export$ffb0004e005737fa;
var $4d0b01b42c984508$export$34b9dba7ce09269b;
var $4d0b01b42c984508$export$25062201e9e25d76;
"use strict";
var $4d0b01b42c984508$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $4d0b01b42c984508$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $4d0b01b42c984508$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $4d0b01b42c984508$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$4d0b01b42c984508$export$ffb0004e005737fa = $4d0b01b42c984508$var$REACT_FRAGMENT_TYPE;
$4d0b01b42c984508$export$34b9dba7ce09269b = $4d0b01b42c984508$var$jsxProd;
$4d0b01b42c984508$export$25062201e9e25d76 = $4d0b01b42c984508$var$jsxProd;

});

parcelRegister("iBv3y", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $jOxUT = parcelRequire("jOxUT");
function isNodeEnv() {
    return !(0, $jOxUT.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("jOxUT", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $e6ccfef61053daf6$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $e6ccfef61053daf6$export$8ad33f488b1ab046);
function $e6ccfef61053daf6$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $e6ccfef61053daf6$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("eF4cA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kTkM8"));

});
parcelRegister("kTkM8", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $f3590f42eabe4270$export$9c16c1426311996d, (v) => $f3590f42eabe4270$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $f3590f42eabe4270$export$dca3b0875bd9a954, (v) => $f3590f42eabe4270$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $f3590f42eabe4270$export$16fa2f45be04daa8, (v) => $f3590f42eabe4270$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $f3590f42eabe4270$export$ffb0004e005737fa, (v) => $f3590f42eabe4270$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $f3590f42eabe4270$export$e2c29f18771995cb, (v) => $f3590f42eabe4270$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $f3590f42eabe4270$export$221d75b3f55bb0bd, (v) => $f3590f42eabe4270$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $f3590f42eabe4270$export$5f8d39834fd61797, (v) => $f3590f42eabe4270$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $f3590f42eabe4270$export$74bf444e3cd11ea5, (v) => $f3590f42eabe4270$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $f3590f42eabe4270$export$8cdaa4703948c5e9, (v) => $f3590f42eabe4270$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $f3590f42eabe4270$export$1ced07cd6b1985ce, (v) => $f3590f42eabe4270$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $f3590f42eabe4270$export$abd8e32b826d7ea7, (v) => $f3590f42eabe4270$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $f3590f42eabe4270$export$87c99536b1b8cdd8, (v) => $f3590f42eabe4270$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $f3590f42eabe4270$export$69a3209f1a06c04d, (v) => $f3590f42eabe4270$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $f3590f42eabe4270$export$8c538325882c7eec, (v) => $f3590f42eabe4270$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $f3590f42eabe4270$export$e530037191fcd5d7, (v) => $f3590f42eabe4270$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $f3590f42eabe4270$export$fd42f52fd3ae1109, (v) => $f3590f42eabe4270$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $f3590f42eabe4270$export$c8a8987d4410bf2d, (v) => $f3590f42eabe4270$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $f3590f42eabe4270$export$7d1e3a5e95ceca43, (v) => $f3590f42eabe4270$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $f3590f42eabe4270$export$257a8862b851cb5b, (v) => $f3590f42eabe4270$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $f3590f42eabe4270$export$a8257692ac88316c, (v) => $f3590f42eabe4270$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $f3590f42eabe4270$export$488013bae63b21da, (v) => $f3590f42eabe4270$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $f3590f42eabe4270$export$7c73462e0d25e514, (v) => $f3590f42eabe4270$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $f3590f42eabe4270$export$7568632d0d33d16d, (v) => $f3590f42eabe4270$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $f3590f42eabe4270$export$f93f40ac0ca7e3a8, (v) => $f3590f42eabe4270$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $f3590f42eabe4270$export$1f96ae73734a86cc, (v) => $f3590f42eabe4270$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $f3590f42eabe4270$export$9a47ced3238df325, (v) => $f3590f42eabe4270$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $f3590f42eabe4270$export$35808ee640e87ca7, (v) => $f3590f42eabe4270$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $f3590f42eabe4270$export$fae74005e78b1a27, (v) => $f3590f42eabe4270$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $f3590f42eabe4270$export$dc8fbce3eb94dc1e, (v) => $f3590f42eabe4270$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $f3590f42eabe4270$export$6a7bc4e911dc01cf, (v) => $f3590f42eabe4270$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $f3590f42eabe4270$export$6d9c69b0de29b591, (v) => $f3590f42eabe4270$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $f3590f42eabe4270$export$7f54fc3180508a52, (v) => $f3590f42eabe4270$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $f3590f42eabe4270$export$f680877a34711e37, (v) => $f3590f42eabe4270$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $f3590f42eabe4270$export$d5a552a76deda3c2, (v) => $f3590f42eabe4270$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $f3590f42eabe4270$export$aaabe4eda9ed9969, (v) => $f3590f42eabe4270$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $f3590f42eabe4270$export$e5c5a5f917a5871c, (v) => $f3590f42eabe4270$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $f3590f42eabe4270$export$1538c33de8887b59, (v) => $f3590f42eabe4270$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $f3590f42eabe4270$export$fca7f784ae7a249a, (v) => $f3590f42eabe4270$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $f3590f42eabe4270$export$13e3392192263954, (v) => $f3590f42eabe4270$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $f3590f42eabe4270$export$b8f5890fc79d6aca, (v) => $f3590f42eabe4270$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $f3590f42eabe4270$export$60241385465d0a34, (v) => $f3590f42eabe4270$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $f3590f42eabe4270$export$306c0aa65ff9ec16, (v) => $f3590f42eabe4270$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $f3590f42eabe4270$export$7b286972b8d8ccbf, (v) => $f3590f42eabe4270$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $f3590f42eabe4270$export$83d89fbfd8236492, (v) => $f3590f42eabe4270$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f3590f42eabe4270$export$9c16c1426311996d;
var $f3590f42eabe4270$export$dca3b0875bd9a954;
var $f3590f42eabe4270$export$16fa2f45be04daa8;
var $f3590f42eabe4270$export$ffb0004e005737fa;
var $f3590f42eabe4270$export$e2c29f18771995cb;
var $f3590f42eabe4270$export$221d75b3f55bb0bd;
var $f3590f42eabe4270$export$5f8d39834fd61797;
var $f3590f42eabe4270$export$74bf444e3cd11ea5;
var $f3590f42eabe4270$export$8cdaa4703948c5e9;
var $f3590f42eabe4270$export$1ced07cd6b1985ce;
var $f3590f42eabe4270$export$abd8e32b826d7ea7;
var $f3590f42eabe4270$export$87c99536b1b8cdd8;
var $f3590f42eabe4270$export$69a3209f1a06c04d;
var $f3590f42eabe4270$export$8c538325882c7eec;
var $f3590f42eabe4270$export$e530037191fcd5d7;
var $f3590f42eabe4270$export$fd42f52fd3ae1109;
var $f3590f42eabe4270$export$c8a8987d4410bf2d;
var $f3590f42eabe4270$export$7d1e3a5e95ceca43;
var $f3590f42eabe4270$export$257a8862b851cb5b;
var $f3590f42eabe4270$export$a8257692ac88316c;
var $f3590f42eabe4270$export$488013bae63b21da;
var $f3590f42eabe4270$export$7c73462e0d25e514;
var $f3590f42eabe4270$export$7568632d0d33d16d;
var $f3590f42eabe4270$export$f93f40ac0ca7e3a8;
var $f3590f42eabe4270$export$1f96ae73734a86cc;
var $f3590f42eabe4270$export$9a47ced3238df325;
var $f3590f42eabe4270$export$35808ee640e87ca7;
var $f3590f42eabe4270$export$fae74005e78b1a27;
var $f3590f42eabe4270$export$dc8fbce3eb94dc1e;
var $f3590f42eabe4270$export$6a7bc4e911dc01cf;
var $f3590f42eabe4270$export$6d9c69b0de29b591;
var $f3590f42eabe4270$export$7f54fc3180508a52;
var $f3590f42eabe4270$export$f680877a34711e37;
var $f3590f42eabe4270$export$d5a552a76deda3c2;
var $f3590f42eabe4270$export$aaabe4eda9ed9969;
var $f3590f42eabe4270$export$e5c5a5f917a5871c;
var $f3590f42eabe4270$export$1538c33de8887b59;
var $f3590f42eabe4270$export$fca7f784ae7a249a;
var $f3590f42eabe4270$export$13e3392192263954;
var $f3590f42eabe4270$export$b8f5890fc79d6aca;
var $f3590f42eabe4270$export$60241385465d0a34;
var $f3590f42eabe4270$export$306c0aa65ff9ec16;
var $f3590f42eabe4270$export$7b286972b8d8ccbf;
var $f3590f42eabe4270$export$83d89fbfd8236492;
"use strict";
var $f3590f42eabe4270$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f3590f42eabe4270$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f3590f42eabe4270$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f3590f42eabe4270$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f3590f42eabe4270$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f3590f42eabe4270$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f3590f42eabe4270$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f3590f42eabe4270$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f3590f42eabe4270$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f3590f42eabe4270$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f3590f42eabe4270$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $f3590f42eabe4270$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $f3590f42eabe4270$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $f3590f42eabe4270$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f3590f42eabe4270$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f3590f42eabe4270$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f3590f42eabe4270$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f3590f42eabe4270$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f3590f42eabe4270$var$assign = Object.assign, $f3590f42eabe4270$var$emptyObject = {};
function $f3590f42eabe4270$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $f3590f42eabe4270$var$emptyObject;
    this.updater = updater || $f3590f42eabe4270$var$ReactNoopUpdateQueue;
}
$f3590f42eabe4270$var$Component.prototype.isReactComponent = {};
$f3590f42eabe4270$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$f3590f42eabe4270$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $f3590f42eabe4270$var$ComponentDummy() {}
$f3590f42eabe4270$var$ComponentDummy.prototype = $f3590f42eabe4270$var$Component.prototype;
function $f3590f42eabe4270$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $f3590f42eabe4270$var$emptyObject;
    this.updater = updater || $f3590f42eabe4270$var$ReactNoopUpdateQueue;
}
var $f3590f42eabe4270$var$pureComponentPrototype = $f3590f42eabe4270$var$PureComponent.prototype = new $f3590f42eabe4270$var$ComponentDummy();
$f3590f42eabe4270$var$pureComponentPrototype.constructor = $f3590f42eabe4270$var$PureComponent;
$f3590f42eabe4270$var$assign($f3590f42eabe4270$var$pureComponentPrototype, $f3590f42eabe4270$var$Component.prototype);
$f3590f42eabe4270$var$pureComponentPrototype.isPureReactComponent = !0;
var $f3590f42eabe4270$var$isArrayImpl = Array.isArray;
function $f3590f42eabe4270$var$noop() {}
var $f3590f42eabe4270$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $f3590f42eabe4270$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f3590f42eabe4270$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $f3590f42eabe4270$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $f3590f42eabe4270$var$cloneAndReplaceKey(oldElement, newKey) {
    return $f3590f42eabe4270$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $f3590f42eabe4270$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $f3590f42eabe4270$var$REACT_ELEMENT_TYPE;
}
function $f3590f42eabe4270$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $f3590f42eabe4270$var$userProvidedKeyEscapeRegex = /\/+/g;
function $f3590f42eabe4270$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $f3590f42eabe4270$var$escape("" + element.key) : index.toString(36);
}
function $f3590f42eabe4270$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($f3590f42eabe4270$var$noop, $f3590f42eabe4270$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $f3590f42eabe4270$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $f3590f42eabe4270$var$REACT_ELEMENT_TYPE:
                case $f3590f42eabe4270$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $f3590f42eabe4270$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $f3590f42eabe4270$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $f3590f42eabe4270$var$getElementKey(children, 0) : nameSoFar, $f3590f42eabe4270$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($f3590f42eabe4270$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $f3590f42eabe4270$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($f3590f42eabe4270$var$isValidElement(callback) && (callback = $f3590f42eabe4270$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($f3590f42eabe4270$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($f3590f42eabe4270$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $f3590f42eabe4270$var$getElementKey(nameSoFar, i), invokeCallback += $f3590f42eabe4270$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $f3590f42eabe4270$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $f3590f42eabe4270$var$getElementKey(nameSoFar, i++), invokeCallback += $f3590f42eabe4270$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $f3590f42eabe4270$var$mapIntoArray($f3590f42eabe4270$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $f3590f42eabe4270$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $f3590f42eabe4270$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $f3590f42eabe4270$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $f3590f42eabe4270$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $f3590f42eabe4270$var$startTransition(scope) {
    var prevTransition = $f3590f42eabe4270$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $f3590f42eabe4270$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $f3590f42eabe4270$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($f3590f42eabe4270$var$noop, $f3590f42eabe4270$var$reportGlobalError);
    } catch (error) {
        $f3590f42eabe4270$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f3590f42eabe4270$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f3590f42eabe4270$var$addTransitionType(type) {
    var transition = $f3590f42eabe4270$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $f3590f42eabe4270$var$startTransition($f3590f42eabe4270$var$addTransitionType.bind(null, type));
}
var $f3590f42eabe4270$var$Children = {
    map: $f3590f42eabe4270$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $f3590f42eabe4270$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $f3590f42eabe4270$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $f3590f42eabe4270$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$f3590f42eabe4270$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$f3590f42eabe4270$export$9c16c1426311996d = $f3590f42eabe4270$var$REACT_ACTIVITY_TYPE;
$f3590f42eabe4270$export$dca3b0875bd9a954 = $f3590f42eabe4270$var$Children;
$f3590f42eabe4270$export$16fa2f45be04daa8 = $f3590f42eabe4270$var$Component;
$f3590f42eabe4270$export$ffb0004e005737fa = $f3590f42eabe4270$var$REACT_FRAGMENT_TYPE;
$f3590f42eabe4270$export$e2c29f18771995cb = $f3590f42eabe4270$var$REACT_PROFILER_TYPE;
$f3590f42eabe4270$export$221d75b3f55bb0bd = $f3590f42eabe4270$var$PureComponent;
$f3590f42eabe4270$export$5f8d39834fd61797 = $f3590f42eabe4270$var$REACT_STRICT_MODE_TYPE;
$f3590f42eabe4270$export$74bf444e3cd11ea5 = $f3590f42eabe4270$var$REACT_SUSPENSE_TYPE;
$f3590f42eabe4270$export$8cdaa4703948c5e9 = $f3590f42eabe4270$var$REACT_VIEW_TRANSITION_TYPE;
$f3590f42eabe4270$export$1ced07cd6b1985ce = $f3590f42eabe4270$var$ReactSharedInternals;
$f3590f42eabe4270$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $f3590f42eabe4270$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$f3590f42eabe4270$export$87c99536b1b8cdd8 = $f3590f42eabe4270$var$addTransitionType;
$f3590f42eabe4270$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$f3590f42eabe4270$export$8c538325882c7eec = function() {
    return null;
};
$f3590f42eabe4270$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $f3590f42eabe4270$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$f3590f42eabe4270$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $f3590f42eabe4270$var$ReactElement(element.type, key, props);
};
$f3590f42eabe4270$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $f3590f42eabe4270$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $f3590f42eabe4270$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$f3590f42eabe4270$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$f3590f42eabe4270$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $f3590f42eabe4270$var$ReactElement(type, key, props);
};
$f3590f42eabe4270$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f3590f42eabe4270$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $f3590f42eabe4270$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$f3590f42eabe4270$export$a8257692ac88316c = $f3590f42eabe4270$var$isValidElement;
$f3590f42eabe4270$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $f3590f42eabe4270$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $f3590f42eabe4270$var$lazyInitializer
    };
};
$f3590f42eabe4270$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $f3590f42eabe4270$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$f3590f42eabe4270$export$7568632d0d33d16d = $f3590f42eabe4270$var$startTransition;
$f3590f42eabe4270$export$f93f40ac0ca7e3a8 = function() {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useCacheRefresh();
};
$f3590f42eabe4270$export$1f96ae73734a86cc = function(usable) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.use(usable);
};
$f3590f42eabe4270$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$f3590f42eabe4270$export$35808ee640e87ca7 = function(callback, deps) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$f3590f42eabe4270$export$fae74005e78b1a27 = function(Context) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useContext(Context);
};
$f3590f42eabe4270$export$dc8fbce3eb94dc1e = function() {};
$f3590f42eabe4270$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$f3590f42eabe4270$export$6d9c69b0de29b591 = function(create, deps) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useEffect(create, deps);
};
$f3590f42eabe4270$export$7f54fc3180508a52 = function(callback) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$f3590f42eabe4270$export$f680877a34711e37 = function() {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useId();
};
$f3590f42eabe4270$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$f3590f42eabe4270$export$aaabe4eda9ed9969 = function(create, deps) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$f3590f42eabe4270$export$e5c5a5f917a5871c = function(create, deps) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$f3590f42eabe4270$export$1538c33de8887b59 = function(create, deps) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useMemo(create, deps);
};
$f3590f42eabe4270$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$f3590f42eabe4270$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$f3590f42eabe4270$export$b8f5890fc79d6aca = function(initialValue) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useRef(initialValue);
};
$f3590f42eabe4270$export$60241385465d0a34 = function(initialState) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useState(initialState);
};
$f3590f42eabe4270$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$f3590f42eabe4270$export$7b286972b8d8ccbf = function() {
    return $f3590f42eabe4270$var$ReactSharedInternals.H.useTransition();
};
$f3590f42eabe4270$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("5RTBg", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $445d0804e4c539a4$export$882461b6382ed46c, (v) => $445d0804e4c539a4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $445d0804e4c539a4$export$757ceba2d55c277e, (v) => $445d0804e4c539a4$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $445d0804e4c539a4$export$83d89fbfd8236492, (v) => $445d0804e4c539a4$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $445d0804e4c539a4$export$882461b6382ed46c;
var $445d0804e4c539a4$export$757ceba2d55c277e;
var $445d0804e4c539a4$export$83d89fbfd8236492;
"use strict";

var $dK4EW = parcelRequire("dK4EW");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");
function $445d0804e4c539a4$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $445d0804e4c539a4$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $445d0804e4c539a4$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $445d0804e4c539a4$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $445d0804e4c539a4$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $445d0804e4c539a4$var$assertIsMounted(fiber) {
    if ($445d0804e4c539a4$var$getNearestMountedFiber(fiber) !== fiber) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(188));
}
function $445d0804e4c539a4$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $445d0804e4c539a4$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $445d0804e4c539a4$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $445d0804e4c539a4$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $445d0804e4c539a4$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $445d0804e4c539a4$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $445d0804e4c539a4$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $445d0804e4c539a4$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $445d0804e4c539a4$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $445d0804e4c539a4$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $445d0804e4c539a4$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $445d0804e4c539a4$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(559));
    }
}
var $445d0804e4c539a4$var$searchTarget = null, $445d0804e4c539a4$var$searchBoundary = null;
function $445d0804e4c539a4$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($445d0804e4c539a4$var$searchTarget = child, !0) : !1;
}
function $445d0804e4c539a4$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($445d0804e4c539a4$var$searchBoundary = child, !1) : child === target ? (null !== $445d0804e4c539a4$var$searchBoundary && ($445d0804e4c539a4$var$searchTarget = child), !0) : !1;
}
function $445d0804e4c539a4$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $445d0804e4c539a4$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $445d0804e4c539a4$var$assign = Object.assign, $445d0804e4c539a4$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $445d0804e4c539a4$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $445d0804e4c539a4$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $445d0804e4c539a4$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $445d0804e4c539a4$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $445d0804e4c539a4$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $445d0804e4c539a4$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $445d0804e4c539a4$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $445d0804e4c539a4$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $445d0804e4c539a4$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $445d0804e4c539a4$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $445d0804e4c539a4$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $445d0804e4c539a4$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $445d0804e4c539a4$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $445d0804e4c539a4$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $445d0804e4c539a4$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $445d0804e4c539a4$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $445d0804e4c539a4$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $445d0804e4c539a4$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $445d0804e4c539a4$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$445d0804e4c539a4$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $445d0804e4c539a4$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $445d0804e4c539a4$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $445d0804e4c539a4$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $445d0804e4c539a4$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $445d0804e4c539a4$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $445d0804e4c539a4$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $445d0804e4c539a4$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $445d0804e4c539a4$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $445d0804e4c539a4$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $445d0804e4c539a4$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $445d0804e4c539a4$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $445d0804e4c539a4$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $445d0804e4c539a4$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $445d0804e4c539a4$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $445d0804e4c539a4$var$getComponentNameFromType(type.type) || "Memo";
        case $445d0804e4c539a4$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $445d0804e4c539a4$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $445d0804e4c539a4$var$isArrayImpl = Array.isArray, $445d0804e4c539a4$var$ReactSharedInternals = $eF4cA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $445d0804e4c539a4$var$ReactDOMSharedInternals = $l19Vn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $445d0804e4c539a4$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $445d0804e4c539a4$var$valueStack = [], $445d0804e4c539a4$var$index = -1;
function $445d0804e4c539a4$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $445d0804e4c539a4$var$pop(cursor) {
    0 > $445d0804e4c539a4$var$index || (cursor.current = $445d0804e4c539a4$var$valueStack[$445d0804e4c539a4$var$index], $445d0804e4c539a4$var$valueStack[$445d0804e4c539a4$var$index] = null, $445d0804e4c539a4$var$index--);
}
function $445d0804e4c539a4$var$push(cursor, value) {
    $445d0804e4c539a4$var$index++;
    $445d0804e4c539a4$var$valueStack[$445d0804e4c539a4$var$index] = cursor.current;
    cursor.current = value;
}
var $445d0804e4c539a4$var$contextStackCursor = $445d0804e4c539a4$var$createCursor(null), $445d0804e4c539a4$var$contextFiberStackCursor = $445d0804e4c539a4$var$createCursor(null), $445d0804e4c539a4$var$rootInstanceStackCursor = $445d0804e4c539a4$var$createCursor(null), $445d0804e4c539a4$var$hostTransitionProviderCursor = $445d0804e4c539a4$var$createCursor(null);
function $445d0804e4c539a4$var$pushHostContainer(fiber, nextRootInstance) {
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$rootInstanceStackCursor, nextRootInstance);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$contextFiberStackCursor, fiber);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $445d0804e4c539a4$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $445d0804e4c539a4$var$getOwnHostContext(nextRootInstance), fiber = $445d0804e4c539a4$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$contextStackCursor);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$contextStackCursor, fiber);
}
function $445d0804e4c539a4$var$popHostContainer() {
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$contextStackCursor);
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$contextFiberStackCursor);
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$rootInstanceStackCursor);
}
function $445d0804e4c539a4$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($445d0804e4c539a4$var$HostTransitionContext._currentValue = stateHook.memoizedState, $445d0804e4c539a4$var$push($445d0804e4c539a4$var$hostTransitionProviderCursor, fiber));
    stateHook = $445d0804e4c539a4$var$contextStackCursor.current;
    var JSCompiler_inline_result = $445d0804e4c539a4$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($445d0804e4c539a4$var$push($445d0804e4c539a4$var$contextFiberStackCursor, fiber), $445d0804e4c539a4$var$push($445d0804e4c539a4$var$contextStackCursor, JSCompiler_inline_result));
}
function $445d0804e4c539a4$var$popHostContext(fiber) {
    $445d0804e4c539a4$var$contextFiberStackCursor.current === fiber && ($445d0804e4c539a4$var$pop($445d0804e4c539a4$var$contextStackCursor), $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$contextFiberStackCursor));
    $445d0804e4c539a4$var$hostTransitionProviderCursor.current === fiber && ($445d0804e4c539a4$var$pop($445d0804e4c539a4$var$hostTransitionProviderCursor), $445d0804e4c539a4$var$HostTransitionContext._currentValue = $445d0804e4c539a4$var$sharedNotPendingObject);
}
var $445d0804e4c539a4$var$prefix, $445d0804e4c539a4$var$suffix;
function $445d0804e4c539a4$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $445d0804e4c539a4$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $445d0804e4c539a4$var$prefix = match && match[1] || "";
        $445d0804e4c539a4$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $445d0804e4c539a4$var$prefix + name + $445d0804e4c539a4$var$suffix;
}
var $445d0804e4c539a4$var$reentry = !1;
function $445d0804e4c539a4$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $445d0804e4c539a4$var$reentry) return "";
    $445d0804e4c539a4$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $445d0804e4c539a4$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $445d0804e4c539a4$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $445d0804e4c539a4$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $445d0804e4c539a4$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $445d0804e4c539a4$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $445d0804e4c539a4$var$describeBuiltInComponentFrame("Suspense Fallback") : $445d0804e4c539a4$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $445d0804e4c539a4$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $445d0804e4c539a4$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $445d0804e4c539a4$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $445d0804e4c539a4$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $445d0804e4c539a4$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $445d0804e4c539a4$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $445d0804e4c539a4$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $445d0804e4c539a4$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $445d0804e4c539a4$var$hasOwnProperty = Object.prototype.hasOwnProperty, $445d0804e4c539a4$var$scheduleCallback$3 = $dK4EW.unstable_scheduleCallback, $445d0804e4c539a4$var$cancelCallback$1 = $dK4EW.unstable_cancelCallback, $445d0804e4c539a4$var$shouldYield = $dK4EW.unstable_shouldYield, $445d0804e4c539a4$var$requestPaint = $dK4EW.unstable_requestPaint, $445d0804e4c539a4$var$now = $dK4EW.unstable_now, $445d0804e4c539a4$var$getCurrentPriorityLevel = $dK4EW.unstable_getCurrentPriorityLevel, $445d0804e4c539a4$var$ImmediatePriority = $dK4EW.unstable_ImmediatePriority, $445d0804e4c539a4$var$UserBlockingPriority = $dK4EW.unstable_UserBlockingPriority, $445d0804e4c539a4$var$NormalPriority$1 = $dK4EW.unstable_NormalPriority, $445d0804e4c539a4$var$LowPriority = $dK4EW.unstable_LowPriority, $445d0804e4c539a4$var$IdlePriority = $dK4EW.unstable_IdlePriority, $445d0804e4c539a4$var$log$1 = $dK4EW.log, $445d0804e4c539a4$var$unstable_setDisableYieldValue = $dK4EW.unstable_setDisableYieldValue, $445d0804e4c539a4$var$rendererID = null, $445d0804e4c539a4$var$injectedHook = null;
function $445d0804e4c539a4$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $445d0804e4c539a4$var$log$1 && $445d0804e4c539a4$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($445d0804e4c539a4$var$injectedHook && "function" === typeof $445d0804e4c539a4$var$injectedHook.setStrictMode) try {
        $445d0804e4c539a4$var$injectedHook.setStrictMode($445d0804e4c539a4$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $445d0804e4c539a4$var$clz32 = Math.clz32 ? Math.clz32 : $445d0804e4c539a4$var$clz32Fallback, $445d0804e4c539a4$var$log = Math.log, $445d0804e4c539a4$var$LN2 = Math.LN2;
function $445d0804e4c539a4$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($445d0804e4c539a4$var$log(x) / $445d0804e4c539a4$var$LN2 | 0) | 0;
}
var $445d0804e4c539a4$var$nextTransitionUpdateLane = 256, $445d0804e4c539a4$var$nextTransitionDeferredLane = 262144, $445d0804e4c539a4$var$nextRetryLane = 4194304;
function $445d0804e4c539a4$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $445d0804e4c539a4$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $445d0804e4c539a4$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $445d0804e4c539a4$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $445d0804e4c539a4$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $445d0804e4c539a4$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $445d0804e4c539a4$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $445d0804e4c539a4$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $445d0804e4c539a4$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $445d0804e4c539a4$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $445d0804e4c539a4$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $445d0804e4c539a4$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $445d0804e4c539a4$var$claimNextRetryLane() {
    var lane = $445d0804e4c539a4$var$nextRetryLane;
    $445d0804e4c539a4$var$nextRetryLane <<= 1;
    0 === ($445d0804e4c539a4$var$nextRetryLane & 62914560) && ($445d0804e4c539a4$var$nextRetryLane = 4194304);
    return lane;
}
function $445d0804e4c539a4$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $445d0804e4c539a4$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $445d0804e4c539a4$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $445d0804e4c539a4$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $445d0804e4c539a4$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $445d0804e4c539a4$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $445d0804e4c539a4$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $445d0804e4c539a4$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $445d0804e4c539a4$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $445d0804e4c539a4$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $445d0804e4c539a4$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $445d0804e4c539a4$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $445d0804e4c539a4$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $445d0804e4c539a4$var$resolveUpdatePriority() {
    var updatePriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $445d0804e4c539a4$var$getEventPriority(updatePriority.type);
}
function $445d0804e4c539a4$var$runWithPriority(priority, fn) {
    var previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
    try {
        return $445d0804e4c539a4$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $445d0804e4c539a4$var$randomKey = Math.random().toString(36).slice(2), $445d0804e4c539a4$var$internalInstanceKey = "__reactFiber$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalPropsKey = "__reactProps$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalContainerInstanceKey = "__reactContainer$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalEventHandlersKey = "__reactEvents$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalEventHandlerListenersKey = "__reactListeners$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalEventHandlesSetKey = "__reactHandles$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalRootNodeResourcesKey = "__reactResources$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalHoistableMarker = "__reactMarker$" + $445d0804e4c539a4$var$randomKey, $445d0804e4c539a4$var$internalLoadPendingKey = "__reactLoad$" + $445d0804e4c539a4$var$randomKey;
function $445d0804e4c539a4$var$detachDeletedInstance(node) {
    delete node[$445d0804e4c539a4$var$internalInstanceKey];
    delete node[$445d0804e4c539a4$var$internalPropsKey];
    delete node[$445d0804e4c539a4$var$internalEventHandlerListenersKey];
    delete node[$445d0804e4c539a4$var$internalEventHandlesSetKey];
}
function $445d0804e4c539a4$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$445d0804e4c539a4$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$445d0804e4c539a4$var$internalContainerInstanceKey] || parentNode[$445d0804e4c539a4$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $445d0804e4c539a4$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$445d0804e4c539a4$var$internalInstanceKey]) return parentNode;
                targetNode = $445d0804e4c539a4$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $445d0804e4c539a4$var$getInstanceFromNode(node) {
    if (node = node[$445d0804e4c539a4$var$internalInstanceKey] || node[$445d0804e4c539a4$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $445d0804e4c539a4$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(33));
}
function $445d0804e4c539a4$var$getResourcesFromRoot(root) {
    var resources = root[$445d0804e4c539a4$var$internalRootNodeResourcesKey];
    resources || (resources = root[$445d0804e4c539a4$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $445d0804e4c539a4$var$markNodeAsHoistable(node) {
    node[$445d0804e4c539a4$var$internalHoistableMarker] = !0;
}
function $445d0804e4c539a4$var$clearPendingLoadOnNode(node) {
    node[$445d0804e4c539a4$var$internalLoadPendingKey] = void 0;
}
var $445d0804e4c539a4$var$allNativeEvents = new Set(), $445d0804e4c539a4$var$registrationNameDependencies = {};
function $445d0804e4c539a4$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $445d0804e4c539a4$var$registerDirectEvent(registrationName, dependencies);
    $445d0804e4c539a4$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $445d0804e4c539a4$var$registerDirectEvent(registrationName, dependencies) {
    $445d0804e4c539a4$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$445d0804e4c539a4$var$allNativeEvents.add(dependencies[registrationName]);
}
var $445d0804e4c539a4$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $445d0804e4c539a4$var$illegalAttributeNameCache = {}, $445d0804e4c539a4$var$validatedAttributeNameCache = {};
function $445d0804e4c539a4$var$isAttributeNameSafe(attributeName) {
    if ($445d0804e4c539a4$var$hasOwnProperty.call($445d0804e4c539a4$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($445d0804e4c539a4$var$hasOwnProperty.call($445d0804e4c539a4$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($445d0804e4c539a4$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $445d0804e4c539a4$var$validatedAttributeNameCache[attributeName] = !0;
    $445d0804e4c539a4$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $445d0804e4c539a4$var$viewTransitionMutationContext = !1;
function $445d0804e4c539a4$var$pushMutationContext() {
    var prev = $445d0804e4c539a4$var$viewTransitionMutationContext;
    $445d0804e4c539a4$var$viewTransitionMutationContext = !1;
    return prev;
}
function $445d0804e4c539a4$var$setValueForAttribute(node, name, value) {
    if ($445d0804e4c539a4$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $445d0804e4c539a4$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $445d0804e4c539a4$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $445d0804e4c539a4$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $445d0804e4c539a4$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $445d0804e4c539a4$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $445d0804e4c539a4$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $445d0804e4c539a4$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $445d0804e4c539a4$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $445d0804e4c539a4$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $445d0804e4c539a4$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $445d0804e4c539a4$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $445d0804e4c539a4$var$getToStringValue(value);
        } else element.value !== "" + $445d0804e4c539a4$var$getToStringValue(value) && (element.value = "" + $445d0804e4c539a4$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $445d0804e4c539a4$var$setDefaultValue(element, $445d0804e4c539a4$var$getToStringValue(element.value)) : $445d0804e4c539a4$var$setDefaultValue(element, $445d0804e4c539a4$var$getToStringValue(value)) : null != defaultValue ? $445d0804e4c539a4$var$setDefaultValue(element, $445d0804e4c539a4$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $445d0804e4c539a4$var$getToStringValue(name) : element.removeAttribute("name");
}
function $445d0804e4c539a4$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $445d0804e4c539a4$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $445d0804e4c539a4$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $445d0804e4c539a4$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $445d0804e4c539a4$var$track(element);
}
function $445d0804e4c539a4$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $445d0804e4c539a4$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $445d0804e4c539a4$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $445d0804e4c539a4$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $445d0804e4c539a4$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $445d0804e4c539a4$var$getToStringValue(defaultValue) : "";
}
function $445d0804e4c539a4$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(92));
            if ($445d0804e4c539a4$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $445d0804e4c539a4$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $445d0804e4c539a4$var$track(element);
}
function $445d0804e4c539a4$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $445d0804e4c539a4$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $445d0804e4c539a4$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $445d0804e4c539a4$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $445d0804e4c539a4$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $445d0804e4c539a4$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($445d0804e4c539a4$var$setValueForStyle(node, styleName$16, styleName), $445d0804e4c539a4$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $445d0804e4c539a4$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $445d0804e4c539a4$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $445d0804e4c539a4$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $445d0804e4c539a4$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $445d0804e4c539a4$var$sanitizeURL(url) {
    return $445d0804e4c539a4$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $445d0804e4c539a4$var$noop$1() {}
var $445d0804e4c539a4$var$currentReplayingEvent = null;
function $445d0804e4c539a4$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $445d0804e4c539a4$var$restoreTarget = null, $445d0804e4c539a4$var$restoreQueue = null;
function $445d0804e4c539a4$var$restoreStateOfTarget(target) {
    var internalInstance = $445d0804e4c539a4$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$445d0804e4c539a4$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $445d0804e4c539a4$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$445d0804e4c539a4$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(90));
                            $445d0804e4c539a4$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $445d0804e4c539a4$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $445d0804e4c539a4$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $445d0804e4c539a4$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $445d0804e4c539a4$var$isInsideEventHandler = !1;
function $445d0804e4c539a4$var$batchedUpdates$1(fn, a, b) {
    if ($445d0804e4c539a4$var$isInsideEventHandler) return fn(a, b);
    $445d0804e4c539a4$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($445d0804e4c539a4$var$isInsideEventHandler = !1, null !== $445d0804e4c539a4$var$restoreTarget || null !== $445d0804e4c539a4$var$restoreQueue) {
            if ($445d0804e4c539a4$var$flushSyncWork$1(), $445d0804e4c539a4$var$restoreTarget && (a = $445d0804e4c539a4$var$restoreTarget, fn = $445d0804e4c539a4$var$restoreQueue, $445d0804e4c539a4$var$restoreQueue = $445d0804e4c539a4$var$restoreTarget = null, $445d0804e4c539a4$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$445d0804e4c539a4$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $445d0804e4c539a4$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$445d0804e4c539a4$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $445d0804e4c539a4$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $445d0804e4c539a4$var$passiveBrowserEventsSupported = !1;
if ($445d0804e4c539a4$var$canUseDOM) try {
    var $445d0804e4c539a4$var$options = {};
    Object.defineProperty($445d0804e4c539a4$var$options, "passive", {
        get: function() {
            $445d0804e4c539a4$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $445d0804e4c539a4$var$options, $445d0804e4c539a4$var$options);
    window.removeEventListener("test", $445d0804e4c539a4$var$options, $445d0804e4c539a4$var$options);
} catch (e) {
    $445d0804e4c539a4$var$passiveBrowserEventsSupported = !1;
}
var $445d0804e4c539a4$var$root = null, $445d0804e4c539a4$var$startText = null, $445d0804e4c539a4$var$fallbackText = null;
function $445d0804e4c539a4$var$getData() {
    if ($445d0804e4c539a4$var$fallbackText) return $445d0804e4c539a4$var$fallbackText;
    var start, startValue = $445d0804e4c539a4$var$startText, startLength = startValue.length, end, endValue = "value" in $445d0804e4c539a4$var$root ? $445d0804e4c539a4$var$root.value : $445d0804e4c539a4$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $445d0804e4c539a4$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $445d0804e4c539a4$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $445d0804e4c539a4$var$functionThatReturnsTrue() {
    return !0;
}
function $445d0804e4c539a4$var$functionThatReturnsFalse() {
    return !1;
}
function $445d0804e4c539a4$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $445d0804e4c539a4$var$functionThatReturnsTrue : $445d0804e4c539a4$var$functionThatReturnsFalse;
        this.isPropagationStopped = $445d0804e4c539a4$var$functionThatReturnsFalse;
        return this;
    }
    $445d0804e4c539a4$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $445d0804e4c539a4$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $445d0804e4c539a4$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $445d0804e4c539a4$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $445d0804e4c539a4$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $445d0804e4c539a4$var$SyntheticEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$EventInterface), $445d0804e4c539a4$var$UIEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    view: 0,
    detail: 0
}), $445d0804e4c539a4$var$SyntheticUIEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$UIEventInterface), $445d0804e4c539a4$var$lastMovementX, $445d0804e4c539a4$var$lastMovementY, $445d0804e4c539a4$var$lastMouseEvent, $445d0804e4c539a4$var$MouseEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $445d0804e4c539a4$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $445d0804e4c539a4$var$lastMouseEvent && ($445d0804e4c539a4$var$lastMouseEvent && "mousemove" === event.type ? ($445d0804e4c539a4$var$lastMovementX = event.screenX - $445d0804e4c539a4$var$lastMouseEvent.screenX, $445d0804e4c539a4$var$lastMovementY = event.screenY - $445d0804e4c539a4$var$lastMouseEvent.screenY) : $445d0804e4c539a4$var$lastMovementY = $445d0804e4c539a4$var$lastMovementX = 0, $445d0804e4c539a4$var$lastMouseEvent = event);
        return $445d0804e4c539a4$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $445d0804e4c539a4$var$lastMovementY;
    }
}), $445d0804e4c539a4$var$SyntheticMouseEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$MouseEventInterface), $445d0804e4c539a4$var$DragEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$MouseEventInterface, {
    dataTransfer: 0
}), $445d0804e4c539a4$var$SyntheticDragEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$DragEventInterface), $445d0804e4c539a4$var$FocusEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$UIEventInterface, {
    relatedTarget: 0
}), $445d0804e4c539a4$var$SyntheticFocusEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$FocusEventInterface), $445d0804e4c539a4$var$AnimationEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $445d0804e4c539a4$var$SyntheticAnimationEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$AnimationEventInterface), $445d0804e4c539a4$var$ClipboardEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $445d0804e4c539a4$var$SyntheticClipboardEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$ClipboardEventInterface), $445d0804e4c539a4$var$CompositionEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    data: 0
}), $445d0804e4c539a4$var$SyntheticCompositionEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$CompositionEventInterface), $445d0804e4c539a4$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $445d0804e4c539a4$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $445d0804e4c539a4$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $445d0804e4c539a4$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $445d0804e4c539a4$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $445d0804e4c539a4$var$getEventModifierState() {
    return $445d0804e4c539a4$var$modifierStateGetter;
}
var $445d0804e4c539a4$var$KeyboardEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $445d0804e4c539a4$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $445d0804e4c539a4$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $445d0804e4c539a4$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $445d0804e4c539a4$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $445d0804e4c539a4$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $445d0804e4c539a4$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $445d0804e4c539a4$var$SyntheticKeyboardEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$KeyboardEventInterface), $445d0804e4c539a4$var$PointerEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $445d0804e4c539a4$var$SyntheticPointerEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$PointerEventInterface), $445d0804e4c539a4$var$SubmitEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    submitter: 0
}), $445d0804e4c539a4$var$SyntheticSubmitEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$SubmitEventInterface), $445d0804e4c539a4$var$TouchEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $445d0804e4c539a4$var$getEventModifierState
}), $445d0804e4c539a4$var$SyntheticTouchEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$TouchEventInterface), $445d0804e4c539a4$var$TransitionEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $445d0804e4c539a4$var$SyntheticTransitionEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$TransitionEventInterface), $445d0804e4c539a4$var$WheelEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $445d0804e4c539a4$var$SyntheticWheelEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$WheelEventInterface), $445d0804e4c539a4$var$ToggleEventInterface = $445d0804e4c539a4$var$assign({}, $445d0804e4c539a4$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $445d0804e4c539a4$var$SyntheticToggleEvent = $445d0804e4c539a4$var$createSyntheticEvent($445d0804e4c539a4$var$ToggleEventInterface), $445d0804e4c539a4$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $445d0804e4c539a4$var$canUseCompositionEvent = $445d0804e4c539a4$var$canUseDOM && "CompositionEvent" in window, $445d0804e4c539a4$var$documentMode = null;
$445d0804e4c539a4$var$canUseDOM && "documentMode" in document && ($445d0804e4c539a4$var$documentMode = document.documentMode);
var $445d0804e4c539a4$var$canUseTextInputEvent = $445d0804e4c539a4$var$canUseDOM && "TextEvent" in window && !$445d0804e4c539a4$var$documentMode, $445d0804e4c539a4$var$useFallbackCompositionData = $445d0804e4c539a4$var$canUseDOM && (!$445d0804e4c539a4$var$canUseCompositionEvent || $445d0804e4c539a4$var$documentMode && 8 < $445d0804e4c539a4$var$documentMode && 11 >= $445d0804e4c539a4$var$documentMode), $445d0804e4c539a4$var$SPACEBAR_CHAR = String.fromCharCode(32), $445d0804e4c539a4$var$hasSpaceKeypress = !1;
function $445d0804e4c539a4$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $445d0804e4c539a4$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $445d0804e4c539a4$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $445d0804e4c539a4$var$isComposing = !1;
function $445d0804e4c539a4$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $445d0804e4c539a4$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $445d0804e4c539a4$var$hasSpaceKeypress = !0;
            return $445d0804e4c539a4$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $445d0804e4c539a4$var$SPACEBAR_CHAR && $445d0804e4c539a4$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $445d0804e4c539a4$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($445d0804e4c539a4$var$isComposing) return "compositionend" === domEventName || !$445d0804e4c539a4$var$canUseCompositionEvent && $445d0804e4c539a4$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $445d0804e4c539a4$var$getData(), $445d0804e4c539a4$var$fallbackText = $445d0804e4c539a4$var$startText = $445d0804e4c539a4$var$root = null, $445d0804e4c539a4$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $445d0804e4c539a4$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $445d0804e4c539a4$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $445d0804e4c539a4$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$445d0804e4c539a4$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $445d0804e4c539a4$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $445d0804e4c539a4$var$restoreTarget ? $445d0804e4c539a4$var$restoreQueue ? $445d0804e4c539a4$var$restoreQueue.push(target) : $445d0804e4c539a4$var$restoreQueue = [
        target
    ] : $445d0804e4c539a4$var$restoreTarget = target;
    inst = $445d0804e4c539a4$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $445d0804e4c539a4$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $445d0804e4c539a4$var$activeElement$1 = null, $445d0804e4c539a4$var$activeElementInst$1 = null;
function $445d0804e4c539a4$var$runEventInBatch(dispatchQueue) {
    $445d0804e4c539a4$var$processDispatchQueue(dispatchQueue, 0);
}
function $445d0804e4c539a4$var$getInstIfValueChanged(targetInst) {
    var targetNode = $445d0804e4c539a4$var$getNodeFromInstance(targetInst);
    if ($445d0804e4c539a4$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $445d0804e4c539a4$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $445d0804e4c539a4$var$isInputEventSupported = !1;
if ($445d0804e4c539a4$var$canUseDOM) {
    var $445d0804e4c539a4$var$JSCompiler_inline_result$jscomp$318;
    if ($445d0804e4c539a4$var$canUseDOM) {
        var $445d0804e4c539a4$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$445d0804e4c539a4$var$isSupported$jscomp$inline_474) {
            var $445d0804e4c539a4$var$element$jscomp$inline_475 = document.createElement("div");
            $445d0804e4c539a4$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $445d0804e4c539a4$var$isSupported$jscomp$inline_474 = "function" === typeof $445d0804e4c539a4$var$element$jscomp$inline_475.oninput;
        }
        $445d0804e4c539a4$var$JSCompiler_inline_result$jscomp$318 = $445d0804e4c539a4$var$isSupported$jscomp$inline_474;
    } else $445d0804e4c539a4$var$JSCompiler_inline_result$jscomp$318 = !1;
    $445d0804e4c539a4$var$isInputEventSupported = $445d0804e4c539a4$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $445d0804e4c539a4$var$stopWatchingForValueChange() {
    $445d0804e4c539a4$var$activeElement$1 && ($445d0804e4c539a4$var$activeElement$1.detachEvent("onpropertychange", $445d0804e4c539a4$var$handlePropertyChange), $445d0804e4c539a4$var$activeElementInst$1 = $445d0804e4c539a4$var$activeElement$1 = null);
}
function $445d0804e4c539a4$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $445d0804e4c539a4$var$getInstIfValueChanged($445d0804e4c539a4$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $445d0804e4c539a4$var$createAndAccumulateChangeEvent(dispatchQueue, $445d0804e4c539a4$var$activeElementInst$1, nativeEvent, $445d0804e4c539a4$var$getEventTarget(nativeEvent));
        $445d0804e4c539a4$var$batchedUpdates$1($445d0804e4c539a4$var$runEventInBatch, dispatchQueue);
    }
}
function $445d0804e4c539a4$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($445d0804e4c539a4$var$stopWatchingForValueChange(), $445d0804e4c539a4$var$activeElement$1 = target, $445d0804e4c539a4$var$activeElementInst$1 = targetInst, $445d0804e4c539a4$var$activeElement$1.attachEvent("onpropertychange", $445d0804e4c539a4$var$handlePropertyChange)) : "focusout" === domEventName && $445d0804e4c539a4$var$stopWatchingForValueChange();
}
function $445d0804e4c539a4$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $445d0804e4c539a4$var$getInstIfValueChanged($445d0804e4c539a4$var$activeElementInst$1);
}
function $445d0804e4c539a4$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $445d0804e4c539a4$var$getInstIfValueChanged(targetInst);
}
function $445d0804e4c539a4$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $445d0804e4c539a4$var$getInstIfValueChanged(targetInst);
}
function $445d0804e4c539a4$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $445d0804e4c539a4$var$objectIs = "function" === typeof Object.is ? Object.is : $445d0804e4c539a4$var$is;
function $445d0804e4c539a4$var$shallowEqual(objA, objB) {
    if ($445d0804e4c539a4$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$445d0804e4c539a4$var$hasOwnProperty.call(objB, currentKey) || !$445d0804e4c539a4$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $445d0804e4c539a4$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $445d0804e4c539a4$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $445d0804e4c539a4$var$getNodeForCharacterOffset(root, offset) {
    var node = $445d0804e4c539a4$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $445d0804e4c539a4$var$getLeafNode(node);
    }
}
function $445d0804e4c539a4$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $445d0804e4c539a4$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $445d0804e4c539a4$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $445d0804e4c539a4$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $445d0804e4c539a4$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $445d0804e4c539a4$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $445d0804e4c539a4$var$skipSelectionChangeEvent = $445d0804e4c539a4$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $445d0804e4c539a4$var$activeElement = null, $445d0804e4c539a4$var$activeElementInst = null, $445d0804e4c539a4$var$lastSelection = null, $445d0804e4c539a4$var$mouseDown = !1;
function $445d0804e4c539a4$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $445d0804e4c539a4$var$mouseDown || null == $445d0804e4c539a4$var$activeElement || $445d0804e4c539a4$var$activeElement !== $445d0804e4c539a4$var$getActiveElement(doc) || (doc = $445d0804e4c539a4$var$activeElement, "selectionStart" in doc && $445d0804e4c539a4$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $445d0804e4c539a4$var$lastSelection && $445d0804e4c539a4$var$shallowEqual($445d0804e4c539a4$var$lastSelection, doc) || ($445d0804e4c539a4$var$lastSelection = doc, doc = $445d0804e4c539a4$var$accumulateTwoPhaseListeners($445d0804e4c539a4$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $445d0804e4c539a4$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $445d0804e4c539a4$var$activeElement)));
}
function $445d0804e4c539a4$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $445d0804e4c539a4$var$vendorPrefixes = {
    animationend: $445d0804e4c539a4$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $445d0804e4c539a4$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $445d0804e4c539a4$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $445d0804e4c539a4$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $445d0804e4c539a4$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $445d0804e4c539a4$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $445d0804e4c539a4$var$makePrefixMap("Transition", "TransitionEnd")
}, $445d0804e4c539a4$var$prefixedEventNames = {}, $445d0804e4c539a4$var$style = {};
$445d0804e4c539a4$var$canUseDOM && ($445d0804e4c539a4$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $445d0804e4c539a4$var$vendorPrefixes.animationend.animation, delete $445d0804e4c539a4$var$vendorPrefixes.animationiteration.animation, delete $445d0804e4c539a4$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $445d0804e4c539a4$var$vendorPrefixes.transitionend.transition);
function $445d0804e4c539a4$var$getVendorPrefixedEventName(eventName) {
    if ($445d0804e4c539a4$var$prefixedEventNames[eventName]) return $445d0804e4c539a4$var$prefixedEventNames[eventName];
    if (!$445d0804e4c539a4$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $445d0804e4c539a4$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $445d0804e4c539a4$var$style) return $445d0804e4c539a4$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $445d0804e4c539a4$var$ANIMATION_END = $445d0804e4c539a4$var$getVendorPrefixedEventName("animationend"), $445d0804e4c539a4$var$ANIMATION_ITERATION = $445d0804e4c539a4$var$getVendorPrefixedEventName("animationiteration"), $445d0804e4c539a4$var$ANIMATION_START = $445d0804e4c539a4$var$getVendorPrefixedEventName("animationstart"), $445d0804e4c539a4$var$TRANSITION_RUN = $445d0804e4c539a4$var$getVendorPrefixedEventName("transitionrun"), $445d0804e4c539a4$var$TRANSITION_START = $445d0804e4c539a4$var$getVendorPrefixedEventName("transitionstart"), $445d0804e4c539a4$var$TRANSITION_CANCEL = $445d0804e4c539a4$var$getVendorPrefixedEventName("transitioncancel"), $445d0804e4c539a4$var$TRANSITION_END = $445d0804e4c539a4$var$getVendorPrefixedEventName("transitionend"), $445d0804e4c539a4$var$topLevelEventsToReactNames = new Map(), $445d0804e4c539a4$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$445d0804e4c539a4$var$simpleEventPluginEvents.push("scrollEnd");
function $445d0804e4c539a4$var$registerSimpleEvent(domEventName, reactName) {
    $445d0804e4c539a4$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $445d0804e4c539a4$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $445d0804e4c539a4$var$globalClientIdCounter$1 = 0;
function $445d0804e4c539a4$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $445d0804e4c539a4$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $445d0804e4c539a4$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $445d0804e4c539a4$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $445d0804e4c539a4$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $445d0804e4c539a4$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $445d0804e4c539a4$var$getClassNameByType(defaultClass);
    eventClass = $445d0804e4c539a4$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $445d0804e4c539a4$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $445d0804e4c539a4$var$concurrentQueues = [], $445d0804e4c539a4$var$concurrentQueuesIndex = 0, $445d0804e4c539a4$var$concurrentlyUpdatedLanes = 0;
function $445d0804e4c539a4$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $445d0804e4c539a4$var$concurrentQueuesIndex, i = $445d0804e4c539a4$var$concurrentlyUpdatedLanes = $445d0804e4c539a4$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $445d0804e4c539a4$var$concurrentQueues[i];
        $445d0804e4c539a4$var$concurrentQueues[i++] = null;
        var queue = $445d0804e4c539a4$var$concurrentQueues[i];
        $445d0804e4c539a4$var$concurrentQueues[i++] = null;
        var update = $445d0804e4c539a4$var$concurrentQueues[i];
        $445d0804e4c539a4$var$concurrentQueues[i++] = null;
        var lane = $445d0804e4c539a4$var$concurrentQueues[i];
        $445d0804e4c539a4$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $445d0804e4c539a4$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $445d0804e4c539a4$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $445d0804e4c539a4$var$concurrentQueues[$445d0804e4c539a4$var$concurrentQueuesIndex++] = fiber;
    $445d0804e4c539a4$var$concurrentQueues[$445d0804e4c539a4$var$concurrentQueuesIndex++] = queue;
    $445d0804e4c539a4$var$concurrentQueues[$445d0804e4c539a4$var$concurrentQueuesIndex++] = update;
    $445d0804e4c539a4$var$concurrentQueues[$445d0804e4c539a4$var$concurrentQueuesIndex++] = lane;
    $445d0804e4c539a4$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $445d0804e4c539a4$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $445d0804e4c539a4$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $445d0804e4c539a4$var$getRootForUpdatedFiber(fiber);
}
function $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $445d0804e4c539a4$var$enqueueUpdate$1(fiber, null, null, lane);
    return $445d0804e4c539a4$var$getRootForUpdatedFiber(fiber);
}
function $445d0804e4c539a4$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $445d0804e4c539a4$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $445d0804e4c539a4$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $445d0804e4c539a4$var$nestedUpdateCount) throw $445d0804e4c539a4$var$nestedUpdateCount = 0, $445d0804e4c539a4$var$rootWithNestedUpdates = null, Error($445d0804e4c539a4$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $445d0804e4c539a4$var$emptyContextObject = {};
function $445d0804e4c539a4$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $445d0804e4c539a4$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $445d0804e4c539a4$var$FiberNode(tag, pendingProps, key, mode);
}
function $445d0804e4c539a4$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $445d0804e4c539a4$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $445d0804e4c539a4$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $445d0804e4c539a4$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $445d0804e4c539a4$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $445d0804e4c539a4$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $445d0804e4c539a4$var$isHostHoistableType(type, pendingProps, $445d0804e4c539a4$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $445d0804e4c539a4$var$REACT_ACTIVITY_TYPE:
            return type = $445d0804e4c539a4$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $445d0804e4c539a4$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE:
            return $445d0804e4c539a4$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $445d0804e4c539a4$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $445d0804e4c539a4$var$REACT_PROFILER_TYPE:
            return type = $445d0804e4c539a4$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $445d0804e4c539a4$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $445d0804e4c539a4$var$REACT_SUSPENSE_TYPE:
            return type = $445d0804e4c539a4$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $445d0804e4c539a4$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $445d0804e4c539a4$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $445d0804e4c539a4$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $445d0804e4c539a4$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $445d0804e4c539a4$var$REACT_LEGACY_HIDDEN_TYPE:
        case $445d0804e4c539a4$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $445d0804e4c539a4$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $445d0804e4c539a4$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $445d0804e4c539a4$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $445d0804e4c539a4$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $445d0804e4c539a4$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $445d0804e4c539a4$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $445d0804e4c539a4$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($445d0804e4c539a4$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $445d0804e4c539a4$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $445d0804e4c539a4$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $445d0804e4c539a4$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $445d0804e4c539a4$var$createFiberFromText(content, mode, lanes) {
    content = $445d0804e4c539a4$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $445d0804e4c539a4$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $445d0804e4c539a4$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $445d0804e4c539a4$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $445d0804e4c539a4$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $445d0804e4c539a4$var$CapturedStacks = new WeakMap();
function $445d0804e4c539a4$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $445d0804e4c539a4$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $445d0804e4c539a4$var$getStackByFiberInDevAndProd(source)
        };
        $445d0804e4c539a4$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $445d0804e4c539a4$var$getStackByFiberInDevAndProd(source)
    };
}
var $445d0804e4c539a4$var$forkStack = [], $445d0804e4c539a4$var$forkStackIndex = 0, $445d0804e4c539a4$var$treeForkProvider = null, $445d0804e4c539a4$var$treeForkCount = 0, $445d0804e4c539a4$var$idStack = [], $445d0804e4c539a4$var$idStackIndex = 0, $445d0804e4c539a4$var$treeContextProvider = null, $445d0804e4c539a4$var$treeContextId = 1, $445d0804e4c539a4$var$treeContextOverflow = "";
function $445d0804e4c539a4$var$pushTreeFork(workInProgress, totalChildren) {
    $445d0804e4c539a4$var$forkStack[$445d0804e4c539a4$var$forkStackIndex++] = $445d0804e4c539a4$var$treeForkCount;
    $445d0804e4c539a4$var$forkStack[$445d0804e4c539a4$var$forkStackIndex++] = $445d0804e4c539a4$var$treeForkProvider;
    $445d0804e4c539a4$var$treeForkProvider = workInProgress;
    $445d0804e4c539a4$var$treeForkCount = totalChildren;
}
function $445d0804e4c539a4$var$pushTreeId(workInProgress, totalChildren, index) {
    $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex++] = $445d0804e4c539a4$var$treeContextId;
    $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex++] = $445d0804e4c539a4$var$treeContextOverflow;
    $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex++] = $445d0804e4c539a4$var$treeContextProvider;
    $445d0804e4c539a4$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $445d0804e4c539a4$var$treeContextId;
    workInProgress = $445d0804e4c539a4$var$treeContextOverflow;
    var baseLength = 32 - $445d0804e4c539a4$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $445d0804e4c539a4$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $445d0804e4c539a4$var$treeContextId = 1 << 32 - $445d0804e4c539a4$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $445d0804e4c539a4$var$treeContextOverflow = length + workInProgress;
    } else $445d0804e4c539a4$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $445d0804e4c539a4$var$treeContextOverflow = workInProgress;
}
function $445d0804e4c539a4$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($445d0804e4c539a4$var$pushTreeFork(workInProgress, 1), $445d0804e4c539a4$var$pushTreeId(workInProgress, 1, 0));
}
function $445d0804e4c539a4$var$popTreeContext(workInProgress) {
    for(; workInProgress === $445d0804e4c539a4$var$treeForkProvider;)$445d0804e4c539a4$var$treeForkProvider = $445d0804e4c539a4$var$forkStack[--$445d0804e4c539a4$var$forkStackIndex], $445d0804e4c539a4$var$forkStack[$445d0804e4c539a4$var$forkStackIndex] = null, $445d0804e4c539a4$var$treeForkCount = $445d0804e4c539a4$var$forkStack[--$445d0804e4c539a4$var$forkStackIndex], $445d0804e4c539a4$var$forkStack[$445d0804e4c539a4$var$forkStackIndex] = null;
    for(; workInProgress === $445d0804e4c539a4$var$treeContextProvider;)$445d0804e4c539a4$var$treeContextProvider = $445d0804e4c539a4$var$idStack[--$445d0804e4c539a4$var$idStackIndex], $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex] = null, $445d0804e4c539a4$var$treeContextOverflow = $445d0804e4c539a4$var$idStack[--$445d0804e4c539a4$var$idStackIndex], $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex] = null, $445d0804e4c539a4$var$treeContextId = $445d0804e4c539a4$var$idStack[--$445d0804e4c539a4$var$idStackIndex], $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex] = null;
}
function $445d0804e4c539a4$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex++] = $445d0804e4c539a4$var$treeContextId;
    $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex++] = $445d0804e4c539a4$var$treeContextOverflow;
    $445d0804e4c539a4$var$idStack[$445d0804e4c539a4$var$idStackIndex++] = $445d0804e4c539a4$var$treeContextProvider;
    $445d0804e4c539a4$var$treeContextId = suspendedContext.id;
    $445d0804e4c539a4$var$treeContextOverflow = suspendedContext.overflow;
    $445d0804e4c539a4$var$treeContextProvider = workInProgress;
}
var $445d0804e4c539a4$var$hydrationParentFiber = null, $445d0804e4c539a4$var$nextHydratableInstance = null, $445d0804e4c539a4$var$isHydrating = !1, $445d0804e4c539a4$var$hydrationErrors = null, $445d0804e4c539a4$var$rootOrSingletonContext = !1, $445d0804e4c539a4$var$HydrationMismatchException = Error($445d0804e4c539a4$var$formatProdErrorMessage(519));
function $445d0804e4c539a4$var$throwOnHydrationMismatch(fiber) {
    var error = Error($445d0804e4c539a4$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $445d0804e4c539a4$var$queueHydrationError($445d0804e4c539a4$var$createCapturedValueAtFiber(error, fiber));
    throw $445d0804e4c539a4$var$HydrationMismatchException;
}
function $445d0804e4c539a4$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$445d0804e4c539a4$var$internalInstanceKey] = fiber;
    instance[$445d0804e4c539a4$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("cancel", instance);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $445d0804e4c539a4$var$mediaEventTypes.length; type++)$445d0804e4c539a4$var$listenToNonDelegatedEvent($445d0804e4c539a4$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("error", instance);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("invalid", instance);
            $445d0804e4c539a4$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("invalid", instance), $445d0804e4c539a4$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $445d0804e4c539a4$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($445d0804e4c539a4$var$listenToNonDelegatedEvent("beforetoggle", instance), $445d0804e4c539a4$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $445d0804e4c539a4$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $445d0804e4c539a4$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $445d0804e4c539a4$var$noop$1), instance = !0) : instance = !1;
    instance || $445d0804e4c539a4$var$throwOnHydrationMismatch(fiber, !0);
}
function $445d0804e4c539a4$var$popToNextHostParent(fiber) {
    for($445d0804e4c539a4$var$hydrationParentFiber = fiber.return; $445d0804e4c539a4$var$hydrationParentFiber;)switch($445d0804e4c539a4$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $445d0804e4c539a4$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $445d0804e4c539a4$var$rootOrSingletonContext = !0;
            return;
        default:
            $445d0804e4c539a4$var$hydrationParentFiber = $445d0804e4c539a4$var$hydrationParentFiber.return;
    }
}
function $445d0804e4c539a4$var$popHydrationState(fiber) {
    if (fiber !== $445d0804e4c539a4$var$hydrationParentFiber) return !1;
    if (!$445d0804e4c539a4$var$isHydrating) return $445d0804e4c539a4$var$popToNextHostParent(fiber), $445d0804e4c539a4$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $445d0804e4c539a4$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $445d0804e4c539a4$var$nextHydratableInstance && $445d0804e4c539a4$var$throwOnHydrationMismatch(fiber);
    $445d0804e4c539a4$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(317));
        $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(317));
        $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $445d0804e4c539a4$var$nextHydratableInstance, $445d0804e4c539a4$var$isSingletonScope(fiber.type) ? (fiber = $445d0804e4c539a4$var$previousHydratableOnEnteringScopedSingleton, $445d0804e4c539a4$var$previousHydratableOnEnteringScopedSingleton = null, $445d0804e4c539a4$var$nextHydratableInstance = fiber) : $445d0804e4c539a4$var$nextHydratableInstance = tag) : $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$hydrationParentFiber ? $445d0804e4c539a4$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $445d0804e4c539a4$var$resetHydrationState() {
    $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$hydrationParentFiber = null;
    $445d0804e4c539a4$var$isHydrating = !1;
}
function $445d0804e4c539a4$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $445d0804e4c539a4$var$hydrationErrors;
    null !== queuedErrors && (null === $445d0804e4c539a4$var$workInProgressRootRecoverableErrors ? $445d0804e4c539a4$var$workInProgressRootRecoverableErrors = queuedErrors : $445d0804e4c539a4$var$workInProgressRootRecoverableErrors.push.apply($445d0804e4c539a4$var$workInProgressRootRecoverableErrors, queuedErrors), $445d0804e4c539a4$var$hydrationErrors = null);
    return queuedErrors;
}
function $445d0804e4c539a4$var$queueHydrationError(error) {
    null === $445d0804e4c539a4$var$hydrationErrors ? $445d0804e4c539a4$var$hydrationErrors = [
        error
    ] : $445d0804e4c539a4$var$hydrationErrors.push(error);
}
var $445d0804e4c539a4$var$valueCursor = $445d0804e4c539a4$var$createCursor(null), $445d0804e4c539a4$var$currentlyRenderingFiber$1 = null, $445d0804e4c539a4$var$lastContextDependency = null;
function $445d0804e4c539a4$var$pushProvider(providerFiber, context, nextValue) {
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $445d0804e4c539a4$var$popProvider(context) {
    context._currentValue = $445d0804e4c539a4$var$valueCursor.current;
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$valueCursor);
}
function $445d0804e4c539a4$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $445d0804e4c539a4$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $445d0804e4c539a4$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $445d0804e4c539a4$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $445d0804e4c539a4$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $445d0804e4c539a4$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $445d0804e4c539a4$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($445d0804e4c539a4$var$HostTransitionContext) : current = [
                $445d0804e4c539a4$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $445d0804e4c539a4$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $445d0804e4c539a4$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$445d0804e4c539a4$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $445d0804e4c539a4$var$prepareToReadContext(workInProgress) {
    $445d0804e4c539a4$var$currentlyRenderingFiber$1 = workInProgress;
    $445d0804e4c539a4$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $445d0804e4c539a4$var$readContext(context) {
    return $445d0804e4c539a4$var$readContextForConsumer($445d0804e4c539a4$var$currentlyRenderingFiber$1, context);
}
function $445d0804e4c539a4$var$readContextDuringReconciliation(consumer, context) {
    null === $445d0804e4c539a4$var$currentlyRenderingFiber$1 && $445d0804e4c539a4$var$prepareToReadContext(consumer);
    return $445d0804e4c539a4$var$readContextForConsumer(consumer, context);
}
function $445d0804e4c539a4$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $445d0804e4c539a4$var$lastContextDependency) {
        if (null === consumer) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(308));
        $445d0804e4c539a4$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $445d0804e4c539a4$var$lastContextDependency = $445d0804e4c539a4$var$lastContextDependency.next = context;
    return value;
}
var $445d0804e4c539a4$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $445d0804e4c539a4$var$scheduleCallback$2 = $dK4EW.unstable_scheduleCallback, $445d0804e4c539a4$var$NormalPriority = $dK4EW.unstable_NormalPriority, $445d0804e4c539a4$var$CacheContext = {
    $$typeof: $445d0804e4c539a4$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $445d0804e4c539a4$var$createCache() {
    return {
        controller: new $445d0804e4c539a4$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $445d0804e4c539a4$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $445d0804e4c539a4$var$scheduleCallback$2($445d0804e4c539a4$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $445d0804e4c539a4$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $445d0804e4c539a4$var$entangledTransitionTypes = null;
function $445d0804e4c539a4$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $445d0804e4c539a4$var$currentEntangledListeners = null, $445d0804e4c539a4$var$currentEntangledPendingCount = 0, $445d0804e4c539a4$var$currentEntangledLane = 0, $445d0804e4c539a4$var$currentEntangledActionThenable = null;
function $445d0804e4c539a4$var$entangleAsyncAction(transition, thenable) {
    if (null === $445d0804e4c539a4$var$currentEntangledListeners) {
        var entangledListeners = $445d0804e4c539a4$var$currentEntangledListeners = [];
        $445d0804e4c539a4$var$currentEntangledPendingCount = 0;
        $445d0804e4c539a4$var$currentEntangledLane = $445d0804e4c539a4$var$requestTransitionLane();
        $445d0804e4c539a4$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $445d0804e4c539a4$var$currentEntangledPendingCount++;
    thenable.then($445d0804e4c539a4$var$pingEngtangledActionScope, $445d0804e4c539a4$var$pingEngtangledActionScope);
    return thenable;
}
function $445d0804e4c539a4$var$pingEngtangledActionScope() {
    if (0 === --$445d0804e4c539a4$var$currentEntangledPendingCount && ($445d0804e4c539a4$var$entangledTransitionTypes = null, null !== $445d0804e4c539a4$var$currentEntangledListeners)) {
        null !== $445d0804e4c539a4$var$currentEntangledActionThenable && ($445d0804e4c539a4$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $445d0804e4c539a4$var$currentEntangledListeners;
        $445d0804e4c539a4$var$currentEntangledListeners = null;
        $445d0804e4c539a4$var$currentEntangledLane = 0;
        $445d0804e4c539a4$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $445d0804e4c539a4$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $445d0804e4c539a4$var$prevOnStartTransitionFinish = $445d0804e4c539a4$var$ReactSharedInternals.S;
$445d0804e4c539a4$var$ReactSharedInternals.S = function(transition, returnValue) {
    $445d0804e4c539a4$var$globalMostRecentTransitionTime = $445d0804e4c539a4$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $445d0804e4c539a4$var$entangleAsyncAction(transition, returnValue);
    if (null !== $445d0804e4c539a4$var$entangledTransitionTypes) for(var root$28 = $445d0804e4c539a4$var$firstScheduledRoot; null !== root$28;)$445d0804e4c539a4$var$queueTransitionTypes(root$28, $445d0804e4c539a4$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $445d0804e4c539a4$var$firstScheduledRoot; null !== root$29;)$445d0804e4c539a4$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $445d0804e4c539a4$var$currentEntangledLane) {
            root$29 = $445d0804e4c539a4$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $445d0804e4c539a4$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $445d0804e4c539a4$var$prevOnStartTransitionFinish && $445d0804e4c539a4$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $445d0804e4c539a4$var$resumedCache = $445d0804e4c539a4$var$createCursor(null);
function $445d0804e4c539a4$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $445d0804e4c539a4$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $445d0804e4c539a4$var$workInProgressRoot.pooledCache;
}
function $445d0804e4c539a4$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $445d0804e4c539a4$var$push($445d0804e4c539a4$var$resumedCache, $445d0804e4c539a4$var$resumedCache.current) : $445d0804e4c539a4$var$push($445d0804e4c539a4$var$resumedCache, prevCachePool.pool);
}
function $445d0804e4c539a4$var$getSuspendedCache() {
    var cacheFromPool = $445d0804e4c539a4$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $445d0804e4c539a4$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $445d0804e4c539a4$var$SuspenseException = Error($445d0804e4c539a4$var$formatProdErrorMessage(460)), $445d0804e4c539a4$var$SuspenseyCommitException = Error($445d0804e4c539a4$var$formatProdErrorMessage(474)), $445d0804e4c539a4$var$SuspenseActionException = Error($445d0804e4c539a4$var$formatProdErrorMessage(542)), $445d0804e4c539a4$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $445d0804e4c539a4$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $445d0804e4c539a4$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($445d0804e4c539a4$var$noop$1, $445d0804e4c539a4$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $445d0804e4c539a4$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($445d0804e4c539a4$var$noop$1, $445d0804e4c539a4$var$noop$1);
            else {
                thenableState = $445d0804e4c539a4$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $445d0804e4c539a4$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $445d0804e4c539a4$var$suspendedThenable = thenable;
            throw $445d0804e4c539a4$var$SuspenseException;
    }
}
function $445d0804e4c539a4$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $445d0804e4c539a4$var$suspendedThenable = x, $445d0804e4c539a4$var$SuspenseException;
        throw x;
    }
}
var $445d0804e4c539a4$var$suspendedThenable = null;
function $445d0804e4c539a4$var$getSuspendedThenable() {
    if (null === $445d0804e4c539a4$var$suspendedThenable) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(459));
    var thenable = $445d0804e4c539a4$var$suspendedThenable;
    $445d0804e4c539a4$var$suspendedThenable = null;
    return thenable;
}
function $445d0804e4c539a4$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $445d0804e4c539a4$var$SuspenseException || rejectedReason === $445d0804e4c539a4$var$SuspenseActionException) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(483));
}
var $445d0804e4c539a4$var$thenableState$1 = null, $445d0804e4c539a4$var$thenableIndexCounter$1 = 0;
function $445d0804e4c539a4$var$unwrapThenable(thenable) {
    var index = $445d0804e4c539a4$var$thenableIndexCounter$1;
    $445d0804e4c539a4$var$thenableIndexCounter$1 += 1;
    null === $445d0804e4c539a4$var$thenableState$1 && ($445d0804e4c539a4$var$thenableState$1 = []);
    return $445d0804e4c539a4$var$trackUsedThenable($445d0804e4c539a4$var$thenableState$1, thenable, index);
}
function $445d0804e4c539a4$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $445d0804e4c539a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $445d0804e4c539a4$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $445d0804e4c539a4$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $445d0804e4c539a4$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $445d0804e4c539a4$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $445d0804e4c539a4$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $445d0804e4c539a4$var$REACT_LAZY_TYPE && $445d0804e4c539a4$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $445d0804e4c539a4$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $445d0804e4c539a4$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $445d0804e4c539a4$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $445d0804e4c539a4$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $445d0804e4c539a4$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $445d0804e4c539a4$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $445d0804e4c539a4$var$REACT_ELEMENT_TYPE:
                    return lanes = $445d0804e4c539a4$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $445d0804e4c539a4$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $445d0804e4c539a4$var$REACT_PORTAL_TYPE:
                    return newChild = $445d0804e4c539a4$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $445d0804e4c539a4$var$REACT_LAZY_TYPE:
                    return newChild = $445d0804e4c539a4$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($445d0804e4c539a4$var$isArrayImpl(newChild) || $445d0804e4c539a4$var$getIteratorFn(newChild)) return newChild = $445d0804e4c539a4$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $445d0804e4c539a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $445d0804e4c539a4$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $445d0804e4c539a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $445d0804e4c539a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $445d0804e4c539a4$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $445d0804e4c539a4$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $445d0804e4c539a4$var$REACT_LAZY_TYPE:
                    return newChild = $445d0804e4c539a4$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($445d0804e4c539a4$var$isArrayImpl(newChild) || $445d0804e4c539a4$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $445d0804e4c539a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $445d0804e4c539a4$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $445d0804e4c539a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $445d0804e4c539a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $445d0804e4c539a4$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $445d0804e4c539a4$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $445d0804e4c539a4$var$REACT_LAZY_TYPE:
                    return newChild = $445d0804e4c539a4$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($445d0804e4c539a4$var$isArrayImpl(newChild) || $445d0804e4c539a4$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $445d0804e4c539a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $445d0804e4c539a4$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $445d0804e4c539a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $445d0804e4c539a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $445d0804e4c539a4$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $445d0804e4c539a4$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $445d0804e4c539a4$var$REACT_LAZY_TYPE && $445d0804e4c539a4$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $445d0804e4c539a4$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $445d0804e4c539a4$var$REACT_FRAGMENT_TYPE ? (lanes = $445d0804e4c539a4$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $445d0804e4c539a4$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $445d0804e4c539a4$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $445d0804e4c539a4$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $445d0804e4c539a4$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $445d0804e4c539a4$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $445d0804e4c539a4$var$REACT_LAZY_TYPE:
                    return newChild = $445d0804e4c539a4$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($445d0804e4c539a4$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($445d0804e4c539a4$var$getIteratorFn(newChild)) {
                key = $445d0804e4c539a4$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $445d0804e4c539a4$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $445d0804e4c539a4$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $445d0804e4c539a4$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $445d0804e4c539a4$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $445d0804e4c539a4$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $445d0804e4c539a4$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $445d0804e4c539a4$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $445d0804e4c539a4$var$SuspenseException || x === $445d0804e4c539a4$var$SuspenseActionException) throw x;
            var fiber = $445d0804e4c539a4$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $445d0804e4c539a4$var$reconcileChildFibers = $445d0804e4c539a4$var$createChildReconciler(!0), $445d0804e4c539a4$var$mountChildFibers = $445d0804e4c539a4$var$createChildReconciler(!1), $445d0804e4c539a4$var$hasForceUpdate = !1;
function $445d0804e4c539a4$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $445d0804e4c539a4$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $445d0804e4c539a4$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $445d0804e4c539a4$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($445d0804e4c539a4$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $445d0804e4c539a4$var$getRootForUpdatedFiber(fiber);
        $445d0804e4c539a4$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $445d0804e4c539a4$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $445d0804e4c539a4$var$getRootForUpdatedFiber(fiber);
}
function $445d0804e4c539a4$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $445d0804e4c539a4$var$markRootEntangled(root, lane);
    }
}
function $445d0804e4c539a4$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $445d0804e4c539a4$var$didReadFromEntangledAsyncAction = !1;
function $445d0804e4c539a4$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($445d0804e4c539a4$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $445d0804e4c539a4$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $445d0804e4c539a4$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $445d0804e4c539a4$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $445d0804e4c539a4$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($445d0804e4c539a4$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $445d0804e4c539a4$var$currentEntangledLane && ($445d0804e4c539a4$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $445d0804e4c539a4$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $445d0804e4c539a4$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $445d0804e4c539a4$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $445d0804e4c539a4$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $445d0804e4c539a4$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$445d0804e4c539a4$var$callCallback(callbacks[updateQueue], context);
}
var $445d0804e4c539a4$var$currentTreeHiddenStackCursor = $445d0804e4c539a4$var$createCursor(null), $445d0804e4c539a4$var$prevEntangledRenderLanesCursor = $445d0804e4c539a4$var$createCursor(0);
function $445d0804e4c539a4$var$pushHiddenContext(fiber, context) {
    fiber = $445d0804e4c539a4$var$entangledRenderLanes;
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$prevEntangledRenderLanesCursor, fiber);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$currentTreeHiddenStackCursor, context);
    $445d0804e4c539a4$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $445d0804e4c539a4$var$reuseHiddenContextOnStack() {
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$prevEntangledRenderLanesCursor, $445d0804e4c539a4$var$entangledRenderLanes);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$currentTreeHiddenStackCursor, $445d0804e4c539a4$var$currentTreeHiddenStackCursor.current);
}
function $445d0804e4c539a4$var$popHiddenContext() {
    $445d0804e4c539a4$var$entangledRenderLanes = $445d0804e4c539a4$var$prevEntangledRenderLanesCursor.current;
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$currentTreeHiddenStackCursor);
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$prevEntangledRenderLanesCursor);
}
var $445d0804e4c539a4$var$suspenseHandlerStackCursor = $445d0804e4c539a4$var$createCursor(null), $445d0804e4c539a4$var$shellBoundary = null;
function $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseStackCursor, $445d0804e4c539a4$var$suspenseStackCursor.current & 1);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseHandlerStackCursor, handler);
    null === $445d0804e4c539a4$var$shellBoundary && (null === current || null !== $445d0804e4c539a4$var$currentTreeHiddenStackCursor.current ? $445d0804e4c539a4$var$shellBoundary = handler : null !== current.memoizedState && ($445d0804e4c539a4$var$shellBoundary = handler));
}
function $445d0804e4c539a4$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseStackCursor, $445d0804e4c539a4$var$suspenseStackCursor.current);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseHandlerStackCursor, fiber);
    null === $445d0804e4c539a4$var$shellBoundary && ($445d0804e4c539a4$var$shellBoundary = fiber);
}
function $445d0804e4c539a4$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseStackCursor, $445d0804e4c539a4$var$suspenseStackCursor.current), $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseHandlerStackCursor, fiber), null === $445d0804e4c539a4$var$shellBoundary && ($445d0804e4c539a4$var$shellBoundary = fiber)) : $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack();
}
function $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack() {
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseStackCursor, $445d0804e4c539a4$var$suspenseStackCursor.current);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseHandlerStackCursor, $445d0804e4c539a4$var$suspenseHandlerStackCursor.current);
}
function $445d0804e4c539a4$var$popSuspenseHandler(fiber) {
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$suspenseHandlerStackCursor);
    $445d0804e4c539a4$var$shellBoundary === fiber && ($445d0804e4c539a4$var$shellBoundary = null);
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$suspenseStackCursor);
}
var $445d0804e4c539a4$var$suspenseStackCursor = $445d0804e4c539a4$var$createCursor(0);
function $445d0804e4c539a4$var$pushSuspenseListContext(fiber, newContext) {
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseHandlerStackCursor, $445d0804e4c539a4$var$suspenseHandlerStackCursor.current);
    $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseStackCursor, newContext);
}
function $445d0804e4c539a4$var$popSuspenseListContext(fiber) {
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$suspenseStackCursor);
    $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$suspenseHandlerStackCursor);
    $445d0804e4c539a4$var$shellBoundary === fiber && ($445d0804e4c539a4$var$shellBoundary = null);
}
function $445d0804e4c539a4$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $445d0804e4c539a4$var$isSuspenseInstancePending(state) || $445d0804e4c539a4$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $445d0804e4c539a4$var$renderLanes = 0, $445d0804e4c539a4$var$currentlyRenderingFiber = null, $445d0804e4c539a4$var$currentHook = null, $445d0804e4c539a4$var$workInProgressHook = null, $445d0804e4c539a4$var$didScheduleRenderPhaseUpdate = !1, $445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $445d0804e4c539a4$var$localIdCounter = 0, $445d0804e4c539a4$var$thenableIndexCounter = 0, $445d0804e4c539a4$var$thenableState = null, $445d0804e4c539a4$var$globalClientIdCounter = 0;
function $445d0804e4c539a4$var$throwInvalidHookError() {
    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(321));
}
function $445d0804e4c539a4$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$445d0804e4c539a4$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $445d0804e4c539a4$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $445d0804e4c539a4$var$renderLanes = nextRenderLanes;
    $445d0804e4c539a4$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $445d0804e4c539a4$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $445d0804e4c539a4$var$HooksDispatcherOnMount : $445d0804e4c539a4$var$HooksDispatcherOnUpdate;
    $445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $445d0804e4c539a4$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $445d0804e4c539a4$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $445d0804e4c539a4$var$finishRenderingHooks(current) {
    $445d0804e4c539a4$var$ReactSharedInternals.H = $445d0804e4c539a4$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $445d0804e4c539a4$var$currentHook && null !== $445d0804e4c539a4$var$currentHook.next;
    $445d0804e4c539a4$var$renderLanes = 0;
    $445d0804e4c539a4$var$workInProgressHook = $445d0804e4c539a4$var$currentHook = $445d0804e4c539a4$var$currentlyRenderingFiber = null;
    $445d0804e4c539a4$var$didScheduleRenderPhaseUpdate = !1;
    $445d0804e4c539a4$var$thenableIndexCounter = 0;
    $445d0804e4c539a4$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(300));
    null === current || $445d0804e4c539a4$var$didReceiveUpdate || (current = current.dependencies, null !== current && $445d0804e4c539a4$var$checkIfContextChanged(current) && ($445d0804e4c539a4$var$didReceiveUpdate = !0));
}
function $445d0804e4c539a4$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $445d0804e4c539a4$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass && ($445d0804e4c539a4$var$thenableState = null);
        $445d0804e4c539a4$var$thenableIndexCounter = 0;
        $445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $445d0804e4c539a4$var$workInProgressHook = $445d0804e4c539a4$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $445d0804e4c539a4$var$ReactSharedInternals.H = $445d0804e4c539a4$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $445d0804e4c539a4$var$TransitionAwareHostComponent() {
    var dispatcher = $445d0804e4c539a4$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $445d0804e4c539a4$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $445d0804e4c539a4$var$currentHook ? $445d0804e4c539a4$var$currentHook.memoizedState : null) !== dispatcher && ($445d0804e4c539a4$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $445d0804e4c539a4$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $445d0804e4c539a4$var$localIdCounter;
    $445d0804e4c539a4$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $445d0804e4c539a4$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $445d0804e4c539a4$var$resetHooksOnUnwind(workInProgress) {
    if ($445d0804e4c539a4$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $445d0804e4c539a4$var$didScheduleRenderPhaseUpdate = !1;
    }
    $445d0804e4c539a4$var$renderLanes = 0;
    $445d0804e4c539a4$var$workInProgressHook = $445d0804e4c539a4$var$currentHook = $445d0804e4c539a4$var$currentlyRenderingFiber = null;
    $445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $445d0804e4c539a4$var$thenableIndexCounter = $445d0804e4c539a4$var$localIdCounter = 0;
    $445d0804e4c539a4$var$thenableState = null;
}
function $445d0804e4c539a4$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $445d0804e4c539a4$var$workInProgressHook ? $445d0804e4c539a4$var$currentlyRenderingFiber.memoizedState = $445d0804e4c539a4$var$workInProgressHook = hook : $445d0804e4c539a4$var$workInProgressHook = $445d0804e4c539a4$var$workInProgressHook.next = hook;
    return $445d0804e4c539a4$var$workInProgressHook;
}
function $445d0804e4c539a4$var$updateWorkInProgressHook() {
    if (null === $445d0804e4c539a4$var$currentHook) {
        var nextCurrentHook = $445d0804e4c539a4$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $445d0804e4c539a4$var$currentHook.next;
    var nextWorkInProgressHook = null === $445d0804e4c539a4$var$workInProgressHook ? $445d0804e4c539a4$var$currentlyRenderingFiber.memoizedState : $445d0804e4c539a4$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $445d0804e4c539a4$var$workInProgressHook = nextWorkInProgressHook, $445d0804e4c539a4$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $445d0804e4c539a4$var$currentlyRenderingFiber.alternate) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(467));
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(310));
        }
        $445d0804e4c539a4$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $445d0804e4c539a4$var$currentHook.memoizedState,
            baseState: $445d0804e4c539a4$var$currentHook.baseState,
            baseQueue: $445d0804e4c539a4$var$currentHook.baseQueue,
            queue: $445d0804e4c539a4$var$currentHook.queue,
            next: null
        };
        null === $445d0804e4c539a4$var$workInProgressHook ? $445d0804e4c539a4$var$currentlyRenderingFiber.memoizedState = $445d0804e4c539a4$var$workInProgressHook = nextCurrentHook : $445d0804e4c539a4$var$workInProgressHook = $445d0804e4c539a4$var$workInProgressHook.next = nextCurrentHook;
    }
    return $445d0804e4c539a4$var$workInProgressHook;
}
function $445d0804e4c539a4$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $445d0804e4c539a4$var$useThenable(thenable) {
    var index = $445d0804e4c539a4$var$thenableIndexCounter;
    $445d0804e4c539a4$var$thenableIndexCounter += 1;
    null === $445d0804e4c539a4$var$thenableState && ($445d0804e4c539a4$var$thenableState = []);
    thenable = $445d0804e4c539a4$var$trackUsedThenable($445d0804e4c539a4$var$thenableState, thenable, index);
    index = $445d0804e4c539a4$var$currentlyRenderingFiber;
    null === (null === $445d0804e4c539a4$var$workInProgressHook ? index.memoizedState : $445d0804e4c539a4$var$workInProgressHook.next) && (index = index.alternate, $445d0804e4c539a4$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $445d0804e4c539a4$var$HooksDispatcherOnMount : $445d0804e4c539a4$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $445d0804e4c539a4$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $445d0804e4c539a4$var$useThenable(usable);
        if (usable.$$typeof === $445d0804e4c539a4$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $445d0804e4c539a4$var$REACT_CONTEXT_TYPE) return $445d0804e4c539a4$var$readContext(usable);
    }
    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(438, String(usable)));
}
function $445d0804e4c539a4$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $445d0804e4c539a4$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $445d0804e4c539a4$var$createFunctionComponentUpdateQueue(), $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $445d0804e4c539a4$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $445d0804e4c539a4$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $445d0804e4c539a4$var$updateReducer(reducer) {
    var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    return $445d0804e4c539a4$var$updateReducerImpl(hook, $445d0804e4c539a4$var$currentHook, reducer);
}
function $445d0804e4c539a4$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($445d0804e4c539a4$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($445d0804e4c539a4$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $445d0804e4c539a4$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($445d0804e4c539a4$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $445d0804e4c539a4$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $445d0804e4c539a4$var$currentlyRenderingFiber.lanes |= revertLane, $445d0804e4c539a4$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $445d0804e4c539a4$var$currentlyRenderingFiber.lanes |= updateLane, $445d0804e4c539a4$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$445d0804e4c539a4$var$objectIs(pendingQueue, hook.memoizedState) && ($445d0804e4c539a4$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $445d0804e4c539a4$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $445d0804e4c539a4$var$rerenderReducer(reducer) {
    var hook = $445d0804e4c539a4$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $445d0804e4c539a4$var$objectIs(newState, hook.memoizedState) || ($445d0804e4c539a4$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $445d0804e4c539a4$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $445d0804e4c539a4$var$currentlyRenderingFiber, hook = $445d0804e4c539a4$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $445d0804e4c539a4$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$445d0804e4c539a4$var$objectIs(($445d0804e4c539a4$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $445d0804e4c539a4$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $445d0804e4c539a4$var$updateEffect($445d0804e4c539a4$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $445d0804e4c539a4$var$workInProgressHook && 0 !== ($445d0804e4c539a4$var$workInProgressHook.memoizedState.tag & 1);
    $445d0804e4c539a4$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $445d0804e4c539a4$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $445d0804e4c539a4$var$workInProgressRoot) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($445d0804e4c539a4$var$renderLanes & 127) || $445d0804e4c539a4$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $445d0804e4c539a4$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $445d0804e4c539a4$var$createFunctionComponentUpdateQueue(), $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $445d0804e4c539a4$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $445d0804e4c539a4$var$checkIfSnapshotChanged(inst) && $445d0804e4c539a4$var$forceStoreRerender(fiber);
}
function $445d0804e4c539a4$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $445d0804e4c539a4$var$checkIfSnapshotChanged(inst) && $445d0804e4c539a4$var$forceStoreRerender(fiber);
    });
}
function $445d0804e4c539a4$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$445d0804e4c539a4$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $445d0804e4c539a4$var$forceStoreRerender(fiber) {
    var root = $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $445d0804e4c539a4$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $445d0804e4c539a4$var$mountStateImpl(initialState) {
    var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $445d0804e4c539a4$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $445d0804e4c539a4$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $445d0804e4c539a4$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $445d0804e4c539a4$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $445d0804e4c539a4$var$updateReducerImpl(hook, $445d0804e4c539a4$var$currentHook, "function" === typeof reducer ? reducer : $445d0804e4c539a4$var$basicStateReducer);
}
function $445d0804e4c539a4$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($445d0804e4c539a4$var$isRenderPhaseUpdate(fiber)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $445d0804e4c539a4$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $445d0804e4c539a4$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $445d0804e4c539a4$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $445d0804e4c539a4$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $445d0804e4c539a4$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $445d0804e4c539a4$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $445d0804e4c539a4$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $445d0804e4c539a4$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $445d0804e4c539a4$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $445d0804e4c539a4$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $445d0804e4c539a4$var$onActionError(actionQueue, node, error$70);
    }
}
function $445d0804e4c539a4$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $445d0804e4c539a4$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $445d0804e4c539a4$var$onActionError(actionQueue, node, error);
    }) : $445d0804e4c539a4$var$onActionSuccess(actionQueue, node, returnValue);
}
function $445d0804e4c539a4$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $445d0804e4c539a4$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $445d0804e4c539a4$var$runActionStateAction(actionQueue, nextState)));
}
function $445d0804e4c539a4$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $445d0804e4c539a4$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $445d0804e4c539a4$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $445d0804e4c539a4$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $445d0804e4c539a4$var$mountActionState(action, initialStateProp) {
    if ($445d0804e4c539a4$var$isHydrating) {
        var ssrFormState = $445d0804e4c539a4$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $445d0804e4c539a4$var$currentlyRenderingFiber;
                if ($445d0804e4c539a4$var$isHydrating) {
                    if ($445d0804e4c539a4$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $445d0804e4c539a4$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $445d0804e4c539a4$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $445d0804e4c539a4$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $445d0804e4c539a4$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $445d0804e4c539a4$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $445d0804e4c539a4$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $445d0804e4c539a4$var$dispatchSetState.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $445d0804e4c539a4$var$mountStateImpl(!1);
    inRootOrSingleton = $445d0804e4c539a4$var$dispatchOptimisticSetState.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $445d0804e4c539a4$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $445d0804e4c539a4$var$dispatchActionState.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $445d0804e4c539a4$var$updateActionState(action) {
    var stateHook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    return $445d0804e4c539a4$var$updateActionStateImpl(stateHook, $445d0804e4c539a4$var$currentHook, action);
}
function $445d0804e4c539a4$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $445d0804e4c539a4$var$updateReducerImpl(stateHook, currentStateHook, $445d0804e4c539a4$var$actionStateReducer)[0];
    stateHook = $445d0804e4c539a4$var$updateReducer($445d0804e4c539a4$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $445d0804e4c539a4$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $445d0804e4c539a4$var$SuspenseException) throw $445d0804e4c539a4$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($445d0804e4c539a4$var$currentlyRenderingFiber.flags |= 2048, $445d0804e4c539a4$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $445d0804e4c539a4$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $445d0804e4c539a4$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $445d0804e4c539a4$var$rerenderActionState(action) {
    var stateHook = $445d0804e4c539a4$var$updateWorkInProgressHook(), currentStateHook = $445d0804e4c539a4$var$currentHook;
    if (null !== currentStateHook) return $445d0804e4c539a4$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $445d0804e4c539a4$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $445d0804e4c539a4$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $445d0804e4c539a4$var$createFunctionComponentUpdateQueue(), $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $445d0804e4c539a4$var$updateRef() {
    return $445d0804e4c539a4$var$updateWorkInProgressHook().memoizedState;
}
function $445d0804e4c539a4$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
    $445d0804e4c539a4$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $445d0804e4c539a4$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $445d0804e4c539a4$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $445d0804e4c539a4$var$currentHook && null !== deps && $445d0804e4c539a4$var$areHookInputsEqual(deps, $445d0804e4c539a4$var$currentHook.memoizedState.deps) ? hook.memoizedState = $445d0804e4c539a4$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($445d0804e4c539a4$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $445d0804e4c539a4$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $445d0804e4c539a4$var$mountEffect(create, deps) {
    $445d0804e4c539a4$var$mountEffectImpl(8390656, 8, create, deps);
}
function $445d0804e4c539a4$var$updateEffect(create, deps) {
    $445d0804e4c539a4$var$updateEffectImpl(2048, 8, create, deps);
}
function $445d0804e4c539a4$var$useEffectEventImpl(payload) {
    $445d0804e4c539a4$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $445d0804e4c539a4$var$createFunctionComponentUpdateQueue(), $445d0804e4c539a4$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $445d0804e4c539a4$var$updateEvent(callback) {
    var ref = $445d0804e4c539a4$var$updateWorkInProgressHook().memoizedState;
    $445d0804e4c539a4$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($445d0804e4c539a4$var$executionContext & 2)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $445d0804e4c539a4$var$updateInsertionEffect(create, deps) {
    return $445d0804e4c539a4$var$updateEffectImpl(4, 2, create, deps);
}
function $445d0804e4c539a4$var$updateLayoutEffect(create, deps) {
    return $445d0804e4c539a4$var$updateEffectImpl(4, 4, create, deps);
}
function $445d0804e4c539a4$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $445d0804e4c539a4$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $445d0804e4c539a4$var$updateEffectImpl(4, 4, $445d0804e4c539a4$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $445d0804e4c539a4$var$mountDebugValue() {}
function $445d0804e4c539a4$var$updateCallback(callback, deps) {
    var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $445d0804e4c539a4$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $445d0804e4c539a4$var$updateMemo(nextCreate, deps) {
    var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $445d0804e4c539a4$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $445d0804e4c539a4$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $445d0804e4c539a4$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $445d0804e4c539a4$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($445d0804e4c539a4$var$renderLanes & 1073741824) && 0 === ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $445d0804e4c539a4$var$requestDeferredLane();
    $445d0804e4c539a4$var$currentlyRenderingFiber.lanes |= hook;
    $445d0804e4c539a4$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $445d0804e4c539a4$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($445d0804e4c539a4$var$objectIs(value, prevValue)) return value;
    if (null !== $445d0804e4c539a4$var$currentTreeHiddenStackCursor.current) return hook = $445d0804e4c539a4$var$mountDeferredValueImpl(hook, value, initialValue), $445d0804e4c539a4$var$objectIs(hook, prevValue) || ($445d0804e4c539a4$var$didReceiveUpdate = !0), hook;
    if (0 === ($445d0804e4c539a4$var$renderLanes & 106) || 0 !== ($445d0804e4c539a4$var$renderLanes & 1073741824) && 0 === ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 261930)) return $445d0804e4c539a4$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $445d0804e4c539a4$var$requestDeferredLane();
    $445d0804e4c539a4$var$currentlyRenderingFiber.lanes |= hook;
    $445d0804e4c539a4$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $445d0804e4c539a4$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
    $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $445d0804e4c539a4$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $445d0804e4c539a4$var$ReactSharedInternals.T = currentTransition;
    $445d0804e4c539a4$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $445d0804e4c539a4$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $445d0804e4c539a4$var$chainThenableValue(returnValue, finishedState);
            $445d0804e4c539a4$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $445d0804e4c539a4$var$requestUpdateLane(fiber));
        } else $445d0804e4c539a4$var$dispatchSetStateInternal(fiber, queue, finishedState, $445d0804e4c539a4$var$requestUpdateLane(fiber));
    } catch (error) {
        $445d0804e4c539a4$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $445d0804e4c539a4$var$requestUpdateLane());
    } finally{
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $445d0804e4c539a4$var$ReactSharedInternals.T = prevTransition;
    }
}
function $445d0804e4c539a4$var$noop() {}
function $445d0804e4c539a4$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(476));
    var queue = $445d0804e4c539a4$var$ensureFormComponentIsStateful(formFiber).queue;
    $445d0804e4c539a4$var$startTransition(formFiber, queue, pendingState, $445d0804e4c539a4$var$sharedNotPendingObject, null === action ? $445d0804e4c539a4$var$noop : function() {
        $445d0804e4c539a4$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $445d0804e4c539a4$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $445d0804e4c539a4$var$sharedNotPendingObject,
        baseState: $445d0804e4c539a4$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $445d0804e4c539a4$var$basicStateReducer,
            lastRenderedState: $445d0804e4c539a4$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $445d0804e4c539a4$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $445d0804e4c539a4$var$requestFormReset$1(formFiber) {
    var stateHook = $445d0804e4c539a4$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $445d0804e4c539a4$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $445d0804e4c539a4$var$requestUpdateLane());
}
function $445d0804e4c539a4$var$useHostTransitionStatus() {
    return $445d0804e4c539a4$var$readContext($445d0804e4c539a4$var$HostTransitionContext);
}
function $445d0804e4c539a4$var$updateId() {
    return $445d0804e4c539a4$var$updateWorkInProgressHook().memoizedState;
}
function $445d0804e4c539a4$var$updateRefresh() {
    return $445d0804e4c539a4$var$updateWorkInProgressHook().memoizedState;
}
function $445d0804e4c539a4$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $445d0804e4c539a4$var$requestUpdateLane();
                fiber = $445d0804e4c539a4$var$createUpdate(lane);
                var root$73 = $445d0804e4c539a4$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($445d0804e4c539a4$var$scheduleUpdateOnFiber(root$73, provider, lane), $445d0804e4c539a4$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $445d0804e4c539a4$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $445d0804e4c539a4$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $445d0804e4c539a4$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $445d0804e4c539a4$var$isRenderPhaseUpdate(fiber) ? $445d0804e4c539a4$var$enqueueRenderPhaseUpdate(queue, action) : (action = $445d0804e4c539a4$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($445d0804e4c539a4$var$scheduleUpdateOnFiber(action, fiber, lane), $445d0804e4c539a4$var$entangleTransitionUpdate(action, queue, lane)));
}
function $445d0804e4c539a4$var$dispatchSetState(fiber, queue, action) {
    var lane = $445d0804e4c539a4$var$requestUpdateLane();
    $445d0804e4c539a4$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $445d0804e4c539a4$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($445d0804e4c539a4$var$isRenderPhaseUpdate(fiber)) $445d0804e4c539a4$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($445d0804e4c539a4$var$objectIs(eagerState, currentState)) return $445d0804e4c539a4$var$enqueueUpdate$1(fiber, queue, update, 0), null === $445d0804e4c539a4$var$workInProgressRoot && $445d0804e4c539a4$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $445d0804e4c539a4$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $445d0804e4c539a4$var$scheduleUpdateOnFiber(action, fiber, lane), $445d0804e4c539a4$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $445d0804e4c539a4$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $445d0804e4c539a4$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($445d0804e4c539a4$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $445d0804e4c539a4$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $445d0804e4c539a4$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $445d0804e4c539a4$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $445d0804e4c539a4$var$currentlyRenderingFiber || null !== alternate && alternate === $445d0804e4c539a4$var$currentlyRenderingFiber;
}
function $445d0804e4c539a4$var$enqueueRenderPhaseUpdate(queue, update) {
    $445d0804e4c539a4$var$didScheduleRenderPhaseUpdateDuringThisPass = $445d0804e4c539a4$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $445d0804e4c539a4$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $445d0804e4c539a4$var$markRootEntangled(root, lane);
    }
}
var $445d0804e4c539a4$var$ContextOnlyDispatcher = {
    readContext: $445d0804e4c539a4$var$readContext,
    use: $445d0804e4c539a4$var$use,
    useCallback: $445d0804e4c539a4$var$throwInvalidHookError,
    useContext: $445d0804e4c539a4$var$throwInvalidHookError,
    useEffect: $445d0804e4c539a4$var$throwInvalidHookError,
    useImperativeHandle: $445d0804e4c539a4$var$throwInvalidHookError,
    useLayoutEffect: $445d0804e4c539a4$var$throwInvalidHookError,
    useInsertionEffect: $445d0804e4c539a4$var$throwInvalidHookError,
    useMemo: $445d0804e4c539a4$var$throwInvalidHookError,
    useReducer: $445d0804e4c539a4$var$throwInvalidHookError,
    useRef: $445d0804e4c539a4$var$throwInvalidHookError,
    useState: $445d0804e4c539a4$var$throwInvalidHookError,
    useDebugValue: $445d0804e4c539a4$var$throwInvalidHookError,
    useDeferredValue: $445d0804e4c539a4$var$throwInvalidHookError,
    useTransition: $445d0804e4c539a4$var$throwInvalidHookError,
    useSyncExternalStore: $445d0804e4c539a4$var$throwInvalidHookError,
    useId: $445d0804e4c539a4$var$throwInvalidHookError,
    useHostTransitionStatus: $445d0804e4c539a4$var$throwInvalidHookError,
    useFormState: $445d0804e4c539a4$var$throwInvalidHookError,
    useActionState: $445d0804e4c539a4$var$throwInvalidHookError,
    useOptimistic: $445d0804e4c539a4$var$throwInvalidHookError,
    useMemoCache: $445d0804e4c539a4$var$throwInvalidHookError,
    useCacheRefresh: $445d0804e4c539a4$var$throwInvalidHookError,
    useEffectEvent: $445d0804e4c539a4$var$throwInvalidHookError
}, $445d0804e4c539a4$var$HooksDispatcherOnMount = {
    readContext: $445d0804e4c539a4$var$readContext,
    use: $445d0804e4c539a4$var$use,
    useCallback: function(callback, deps) {
        $445d0804e4c539a4$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $445d0804e4c539a4$var$readContext,
    useEffect: $445d0804e4c539a4$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $445d0804e4c539a4$var$mountEffectImpl(4194308, 4, $445d0804e4c539a4$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $445d0804e4c539a4$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $445d0804e4c539a4$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $445d0804e4c539a4$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $445d0804e4c539a4$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($445d0804e4c539a4$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $445d0804e4c539a4$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $445d0804e4c539a4$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $445d0804e4c539a4$var$dispatchReducerAction.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $445d0804e4c539a4$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $445d0804e4c539a4$var$dispatchSetState.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $445d0804e4c539a4$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
        return $445d0804e4c539a4$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $445d0804e4c539a4$var$mountStateImpl(!1);
        stateHook = $445d0804e4c539a4$var$startTransition.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $445d0804e4c539a4$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $445d0804e4c539a4$var$currentlyRenderingFiber, hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
        if ($445d0804e4c539a4$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $445d0804e4c539a4$var$workInProgressRoot) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(349));
            0 !== ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 127) || $445d0804e4c539a4$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $445d0804e4c539a4$var$mountEffect($445d0804e4c539a4$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $445d0804e4c539a4$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $445d0804e4c539a4$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook(), identifierPrefix = $445d0804e4c539a4$var$workInProgressRoot.identifierPrefix;
        if ($445d0804e4c539a4$var$isHydrating) {
            var JSCompiler_inline_result = $445d0804e4c539a4$var$treeContextOverflow;
            var idWithLeadingBit = $445d0804e4c539a4$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $445d0804e4c539a4$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $445d0804e4c539a4$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $445d0804e4c539a4$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $445d0804e4c539a4$var$useHostTransitionStatus,
    useFormState: $445d0804e4c539a4$var$mountActionState,
    useActionState: $445d0804e4c539a4$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $445d0804e4c539a4$var$dispatchOptimisticSetState.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $445d0804e4c539a4$var$useMemoCache,
    useCacheRefresh: function() {
        return $445d0804e4c539a4$var$mountWorkInProgressHook().memoizedState = $445d0804e4c539a4$var$refreshCache.bind(null, $445d0804e4c539a4$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $445d0804e4c539a4$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($445d0804e4c539a4$var$executionContext & 2)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $445d0804e4c539a4$var$HooksDispatcherOnUpdate = {
    readContext: $445d0804e4c539a4$var$readContext,
    use: $445d0804e4c539a4$var$use,
    useCallback: $445d0804e4c539a4$var$updateCallback,
    useContext: $445d0804e4c539a4$var$readContext,
    useEffect: $445d0804e4c539a4$var$updateEffect,
    useImperativeHandle: $445d0804e4c539a4$var$updateImperativeHandle,
    useInsertionEffect: $445d0804e4c539a4$var$updateInsertionEffect,
    useLayoutEffect: $445d0804e4c539a4$var$updateLayoutEffect,
    useMemo: $445d0804e4c539a4$var$updateMemo,
    useReducer: $445d0804e4c539a4$var$updateReducer,
    useRef: $445d0804e4c539a4$var$updateRef,
    useState: function() {
        return $445d0804e4c539a4$var$updateReducer($445d0804e4c539a4$var$basicStateReducer);
    },
    useDebugValue: $445d0804e4c539a4$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
        return $445d0804e4c539a4$var$updateDeferredValueImpl(hook, $445d0804e4c539a4$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $445d0804e4c539a4$var$updateReducer($445d0804e4c539a4$var$basicStateReducer)[0], start = $445d0804e4c539a4$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $445d0804e4c539a4$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $445d0804e4c539a4$var$updateSyncExternalStore,
    useId: $445d0804e4c539a4$var$updateId,
    useHostTransitionStatus: $445d0804e4c539a4$var$useHostTransitionStatus,
    useFormState: $445d0804e4c539a4$var$updateActionState,
    useActionState: $445d0804e4c539a4$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
        return $445d0804e4c539a4$var$updateOptimisticImpl(hook, $445d0804e4c539a4$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $445d0804e4c539a4$var$useMemoCache,
    useCacheRefresh: $445d0804e4c539a4$var$updateRefresh,
    useEffectEvent: $445d0804e4c539a4$var$updateEvent
}, $445d0804e4c539a4$var$HooksDispatcherOnRerender = {
    readContext: $445d0804e4c539a4$var$readContext,
    use: $445d0804e4c539a4$var$use,
    useCallback: $445d0804e4c539a4$var$updateCallback,
    useContext: $445d0804e4c539a4$var$readContext,
    useEffect: $445d0804e4c539a4$var$updateEffect,
    useImperativeHandle: $445d0804e4c539a4$var$updateImperativeHandle,
    useInsertionEffect: $445d0804e4c539a4$var$updateInsertionEffect,
    useLayoutEffect: $445d0804e4c539a4$var$updateLayoutEffect,
    useMemo: $445d0804e4c539a4$var$updateMemo,
    useReducer: $445d0804e4c539a4$var$rerenderReducer,
    useRef: $445d0804e4c539a4$var$updateRef,
    useState: function() {
        return $445d0804e4c539a4$var$rerenderReducer($445d0804e4c539a4$var$basicStateReducer);
    },
    useDebugValue: $445d0804e4c539a4$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
        return null === $445d0804e4c539a4$var$currentHook ? $445d0804e4c539a4$var$mountDeferredValueImpl(hook, value, initialValue) : $445d0804e4c539a4$var$updateDeferredValueImpl(hook, $445d0804e4c539a4$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $445d0804e4c539a4$var$rerenderReducer($445d0804e4c539a4$var$basicStateReducer)[0], start = $445d0804e4c539a4$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $445d0804e4c539a4$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $445d0804e4c539a4$var$updateSyncExternalStore,
    useId: $445d0804e4c539a4$var$updateId,
    useHostTransitionStatus: $445d0804e4c539a4$var$useHostTransitionStatus,
    useFormState: $445d0804e4c539a4$var$rerenderActionState,
    useActionState: $445d0804e4c539a4$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $445d0804e4c539a4$var$updateWorkInProgressHook();
        if (null !== $445d0804e4c539a4$var$currentHook) return $445d0804e4c539a4$var$updateOptimisticImpl(hook, $445d0804e4c539a4$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $445d0804e4c539a4$var$useMemoCache,
    useCacheRefresh: $445d0804e4c539a4$var$updateRefresh,
    useEffectEvent: $445d0804e4c539a4$var$updateEvent
};
function $445d0804e4c539a4$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $445d0804e4c539a4$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $445d0804e4c539a4$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $445d0804e4c539a4$var$requestUpdateLane(), update = $445d0804e4c539a4$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $445d0804e4c539a4$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($445d0804e4c539a4$var$scheduleUpdateOnFiber(payload, inst, lane), $445d0804e4c539a4$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $445d0804e4c539a4$var$requestUpdateLane(), update = $445d0804e4c539a4$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $445d0804e4c539a4$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($445d0804e4c539a4$var$scheduleUpdateOnFiber(payload, inst, lane), $445d0804e4c539a4$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $445d0804e4c539a4$var$requestUpdateLane(), update = $445d0804e4c539a4$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $445d0804e4c539a4$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($445d0804e4c539a4$var$scheduleUpdateOnFiber(callback, inst, lane), $445d0804e4c539a4$var$entangleTransitions(callback, inst, lane));
    }
};
function $445d0804e4c539a4$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$445d0804e4c539a4$var$shallowEqual(oldProps, newProps) || !$445d0804e4c539a4$var$shallowEqual(oldState, newState) : !0;
}
function $445d0804e4c539a4$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $445d0804e4c539a4$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $445d0804e4c539a4$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $445d0804e4c539a4$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $445d0804e4c539a4$var$defaultOnUncaughtError(error) {
    $445d0804e4c539a4$var$reportGlobalError(error);
}
function $445d0804e4c539a4$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $445d0804e4c539a4$var$defaultOnRecoverableError(error) {
    $445d0804e4c539a4$var$reportGlobalError(error);
}
function $445d0804e4c539a4$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $445d0804e4c539a4$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $445d0804e4c539a4$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $445d0804e4c539a4$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $445d0804e4c539a4$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $445d0804e4c539a4$var$createClassErrorUpdate(lane) {
    lane = $445d0804e4c539a4$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $445d0804e4c539a4$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $445d0804e4c539a4$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $445d0804e4c539a4$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed ? $445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $445d0804e4c539a4$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $445d0804e4c539a4$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $445d0804e4c539a4$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $445d0804e4c539a4$var$shellBoundary ? $445d0804e4c539a4$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $445d0804e4c539a4$var$workInProgressRootExitStatus && ($445d0804e4c539a4$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $445d0804e4c539a4$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $445d0804e4c539a4$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $445d0804e4c539a4$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $445d0804e4c539a4$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $445d0804e4c539a4$var$attachPingListener(root, value, rootRenderLanes);
        $445d0804e4c539a4$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($445d0804e4c539a4$var$isHydrating) return returnFiber = $445d0804e4c539a4$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $445d0804e4c539a4$var$HydrationMismatchException && (root = Error($445d0804e4c539a4$var$formatProdErrorMessage(422), {
        cause: value
    }), $445d0804e4c539a4$var$queueHydrationError($445d0804e4c539a4$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $445d0804e4c539a4$var$HydrationMismatchException && (returnFiber = Error($445d0804e4c539a4$var$formatProdErrorMessage(423), {
        cause: value
    }), $445d0804e4c539a4$var$queueHydrationError($445d0804e4c539a4$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $445d0804e4c539a4$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $445d0804e4c539a4$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $445d0804e4c539a4$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $445d0804e4c539a4$var$workInProgressRootExitStatus && ($445d0804e4c539a4$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($445d0804e4c539a4$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $445d0804e4c539a4$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $445d0804e4c539a4$var$workInProgressRootConcurrentErrors ? $445d0804e4c539a4$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $445d0804e4c539a4$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $445d0804e4c539a4$var$workInProgressRootExitStatus && ($445d0804e4c539a4$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $445d0804e4c539a4$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $445d0804e4c539a4$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $445d0804e4c539a4$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed || !$445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $445d0804e4c539a4$var$createClassErrorUpdate(rootRenderLanes), $445d0804e4c539a4$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $445d0804e4c539a4$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $445d0804e4c539a4$var$SelectiveHydrationException = Error($445d0804e4c539a4$var$formatProdErrorMessage(461)), $445d0804e4c539a4$var$didReceiveUpdate = !1;
function $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $445d0804e4c539a4$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $445d0804e4c539a4$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $445d0804e4c539a4$var$prepareToReadContext(workInProgress);
    nextProps = $445d0804e4c539a4$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $445d0804e4c539a4$var$checkDidRenderIdHook();
    if (null !== current && !$445d0804e4c539a4$var$didReceiveUpdate) return $445d0804e4c539a4$var$bailoutHooks(current, workInProgress, renderLanes), $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $445d0804e4c539a4$var$isHydrating && key && $445d0804e4c539a4$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $445d0804e4c539a4$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$445d0804e4c539a4$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $445d0804e4c539a4$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $445d0804e4c539a4$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$445d0804e4c539a4$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $445d0804e4c539a4$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $445d0804e4c539a4$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $445d0804e4c539a4$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($445d0804e4c539a4$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($445d0804e4c539a4$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $445d0804e4c539a4$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($445d0804e4c539a4$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $445d0804e4c539a4$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $445d0804e4c539a4$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $445d0804e4c539a4$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $445d0804e4c539a4$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $445d0804e4c539a4$var$pushHiddenContext(workInProgress, prevState) : $445d0804e4c539a4$var$reuseHiddenContextOnStack(), $445d0804e4c539a4$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $445d0804e4c539a4$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($445d0804e4c539a4$var$pushTransition(workInProgress, prevState.cachePool), $445d0804e4c539a4$var$pushHiddenContext(workInProgress, prevState), $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $445d0804e4c539a4$var$pushTransition(workInProgress, null), $445d0804e4c539a4$var$reuseHiddenContextOnStack(), $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack());
    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $445d0804e4c539a4$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $445d0804e4c539a4$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $445d0804e4c539a4$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $445d0804e4c539a4$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $445d0804e4c539a4$var$pushTransition(workInProgress, null);
    $445d0804e4c539a4$var$reuseHiddenContextOnStack();
    $445d0804e4c539a4$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $445d0804e4c539a4$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $445d0804e4c539a4$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $445d0804e4c539a4$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $445d0804e4c539a4$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $445d0804e4c539a4$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $445d0804e4c539a4$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($445d0804e4c539a4$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $445d0804e4c539a4$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $445d0804e4c539a4$var$bailoutOffscreenComponent(null, current);
            $445d0804e4c539a4$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $445d0804e4c539a4$var$nextHydratableInstance) ? (current = $445d0804e4c539a4$var$canHydrateHydrationBoundary(current, $445d0804e4c539a4$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $445d0804e4c539a4$var$treeContextProvider ? {
                    id: $445d0804e4c539a4$var$treeContextId,
                    overflow: $445d0804e4c539a4$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $445d0804e4c539a4$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $445d0804e4c539a4$var$hydrationParentFiber = workInProgress, $445d0804e4c539a4$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $445d0804e4c539a4$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $445d0804e4c539a4$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $445d0804e4c539a4$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $445d0804e4c539a4$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($445d0804e4c539a4$var$formatProdErrorMessage(558));
        } else if ($445d0804e4c539a4$var$didReceiveUpdate || $445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $445d0804e4c539a4$var$didReceiveUpdate || didSuspend) {
            if (null === $445d0804e4c539a4$var$currentTreeHiddenStackCursor.current) {
                nextProps = $445d0804e4c539a4$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $445d0804e4c539a4$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(current, dehydrated), $445d0804e4c539a4$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $445d0804e4c539a4$var$SelectiveHydrationException;
                $445d0804e4c539a4$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $445d0804e4c539a4$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratable(dehydrated.nextSibling), $445d0804e4c539a4$var$hydrationParentFiber = workInProgress, $445d0804e4c539a4$var$isHydrating = !0, $445d0804e4c539a4$var$hydrationErrors = null, $445d0804e4c539a4$var$rootOrSingletonContext = !1, null !== current && $445d0804e4c539a4$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $445d0804e4c539a4$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $445d0804e4c539a4$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $445d0804e4c539a4$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $445d0804e4c539a4$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $445d0804e4c539a4$var$prepareToReadContext(workInProgress);
    Component = $445d0804e4c539a4$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $445d0804e4c539a4$var$checkDidRenderIdHook();
    if (null !== current && !$445d0804e4c539a4$var$didReceiveUpdate) return $445d0804e4c539a4$var$bailoutHooks(current, workInProgress, renderLanes), $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $445d0804e4c539a4$var$isHydrating && nextProps && $445d0804e4c539a4$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $445d0804e4c539a4$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $445d0804e4c539a4$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $445d0804e4c539a4$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $445d0804e4c539a4$var$finishRenderingHooks(current);
    Component = $445d0804e4c539a4$var$checkDidRenderIdHook();
    if (null !== current && !$445d0804e4c539a4$var$didReceiveUpdate) return $445d0804e4c539a4$var$bailoutHooks(current, workInProgress, renderLanes), $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $445d0804e4c539a4$var$isHydrating && Component && $445d0804e4c539a4$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $445d0804e4c539a4$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $445d0804e4c539a4$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $445d0804e4c539a4$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $445d0804e4c539a4$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $445d0804e4c539a4$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $445d0804e4c539a4$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $445d0804e4c539a4$var$readContext(contextType) : $445d0804e4c539a4$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($445d0804e4c539a4$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $445d0804e4c539a4$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $445d0804e4c539a4$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $445d0804e4c539a4$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $445d0804e4c539a4$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $445d0804e4c539a4$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $445d0804e4c539a4$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $445d0804e4c539a4$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $445d0804e4c539a4$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $445d0804e4c539a4$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $445d0804e4c539a4$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $445d0804e4c539a4$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($445d0804e4c539a4$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $445d0804e4c539a4$var$hasForceUpdate || $445d0804e4c539a4$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $445d0804e4c539a4$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $445d0804e4c539a4$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $445d0804e4c539a4$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $445d0804e4c539a4$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $445d0804e4c539a4$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $445d0804e4c539a4$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $445d0804e4c539a4$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $445d0804e4c539a4$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $445d0804e4c539a4$var$hasForceUpdate || null !== current && null !== current.dependencies && $445d0804e4c539a4$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($445d0804e4c539a4$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $445d0804e4c539a4$var$hasForceUpdate || $445d0804e4c539a4$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $445d0804e4c539a4$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $445d0804e4c539a4$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $445d0804e4c539a4$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $445d0804e4c539a4$var$resetHydrationState();
    workInProgress.flags |= 256;
    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $445d0804e4c539a4$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $445d0804e4c539a4$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $445d0804e4c539a4$var$getSuspendedCache()
    };
}
function $445d0804e4c539a4$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $445d0804e4c539a4$var$workInProgressDeferredLane);
    return current;
}
function $445d0804e4c539a4$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($445d0804e4c539a4$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($445d0804e4c539a4$var$isHydrating) {
            showFallback ? $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack();
            (current = $445d0804e4c539a4$var$nextHydratableInstance) ? (current = $445d0804e4c539a4$var$canHydrateHydrationBoundary(current, $445d0804e4c539a4$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $445d0804e4c539a4$var$treeContextProvider ? {
                    id: $445d0804e4c539a4$var$treeContextId,
                    overflow: $445d0804e4c539a4$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $445d0804e4c539a4$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $445d0804e4c539a4$var$hydrationParentFiber = workInProgress, $445d0804e4c539a4$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $445d0804e4c539a4$var$throwOnHydrationMismatch(workInProgress);
            $445d0804e4c539a4$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $445d0804e4c539a4$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $445d0804e4c539a4$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $445d0804e4c539a4$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $445d0804e4c539a4$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $445d0804e4c539a4$var$SUSPENDED_MARKER, $445d0804e4c539a4$var$bailoutOffscreenComponent(null, nextProps);
        $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $445d0804e4c539a4$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $445d0804e4c539a4$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $445d0804e4c539a4$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $445d0804e4c539a4$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $445d0804e4c539a4$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $445d0804e4c539a4$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $445d0804e4c539a4$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $445d0804e4c539a4$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $445d0804e4c539a4$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $445d0804e4c539a4$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $445d0804e4c539a4$var$SUSPENDED_MARKER, $445d0804e4c539a4$var$bailoutOffscreenComponent(current.child, nextProps);
    $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $445d0804e4c539a4$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $445d0804e4c539a4$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $445d0804e4c539a4$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $445d0804e4c539a4$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $445d0804e4c539a4$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $445d0804e4c539a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $445d0804e4c539a4$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $445d0804e4c539a4$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $445d0804e4c539a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $445d0804e4c539a4$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $445d0804e4c539a4$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $445d0804e4c539a4$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $445d0804e4c539a4$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $445d0804e4c539a4$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $445d0804e4c539a4$var$SUSPENDED_MARKER;
        return $445d0804e4c539a4$var$bailoutOffscreenComponent(null, nextProps);
    }
    $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($445d0804e4c539a4$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($445d0804e4c539a4$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $445d0804e4c539a4$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $445d0804e4c539a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $445d0804e4c539a4$var$didReceiveUpdate || $445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($445d0804e4c539a4$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $445d0804e4c539a4$var$currentTreeHiddenStackCursor.current) return $445d0804e4c539a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $445d0804e4c539a4$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $445d0804e4c539a4$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(current, nextProps), $445d0804e4c539a4$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $445d0804e4c539a4$var$SelectiveHydrationException;
        $445d0804e4c539a4$var$isSuspenseInstancePending(suspenseInstance) || $445d0804e4c539a4$var$renderDidSuspendDelayIfPossible();
        return $445d0804e4c539a4$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($445d0804e4c539a4$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratable(suspenseInstance.nextSibling);
    $445d0804e4c539a4$var$hydrationParentFiber = workInProgress;
    $445d0804e4c539a4$var$isHydrating = !0;
    $445d0804e4c539a4$var$hydrationErrors = null;
    $445d0804e4c539a4$var$rootOrSingletonContext = !1;
    null !== current && $445d0804e4c539a4$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $445d0804e4c539a4$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $445d0804e4c539a4$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $445d0804e4c539a4$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $445d0804e4c539a4$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $445d0804e4c539a4$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $445d0804e4c539a4$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $445d0804e4c539a4$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $445d0804e4c539a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $445d0804e4c539a4$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $445d0804e4c539a4$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $445d0804e4c539a4$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($445d0804e4c539a4$var$reverseChildren(current), $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $445d0804e4c539a4$var$reverseChildren(current)) : $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $445d0804e4c539a4$var$isHydrating ? $445d0804e4c539a4$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $445d0804e4c539a4$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $445d0804e4c539a4$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $445d0804e4c539a4$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $445d0804e4c539a4$var$reverseChildren(workInProgress));
            $445d0804e4c539a4$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $445d0804e4c539a4$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $445d0804e4c539a4$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $445d0804e4c539a4$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $445d0804e4c539a4$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $445d0804e4c539a4$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $445d0804e4c539a4$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $445d0804e4c539a4$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $445d0804e4c539a4$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $445d0804e4c539a4$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $445d0804e4c539a4$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $445d0804e4c539a4$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $445d0804e4c539a4$var$checkIfContextChanged(current) ? !0 : !1;
}
function $445d0804e4c539a4$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $445d0804e4c539a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $445d0804e4c539a4$var$pushProvider(workInProgress, $445d0804e4c539a4$var$CacheContext, current.memoizedState.cache);
            $445d0804e4c539a4$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $445d0804e4c539a4$var$pushHostContext(workInProgress);
            break;
        case 4:
            $445d0804e4c539a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $445d0804e4c539a4$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $445d0804e4c539a4$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $445d0804e4c539a4$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $445d0804e4c539a4$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $445d0804e4c539a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($445d0804e4c539a4$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $445d0804e4c539a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $445d0804e4c539a4$var$pushSuspenseListContext(workInProgress, $445d0804e4c539a4$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $445d0804e4c539a4$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $445d0804e4c539a4$var$pushProvider(workInProgress, $445d0804e4c539a4$var$CacheContext, current.memoizedState.cache);
    }
    return $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $445d0804e4c539a4$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $445d0804e4c539a4$var$didReceiveUpdate = !0;
        else {
            if (!$445d0804e4c539a4$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $445d0804e4c539a4$var$didReceiveUpdate = !1, $445d0804e4c539a4$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $445d0804e4c539a4$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $445d0804e4c539a4$var$didReceiveUpdate = !1, $445d0804e4c539a4$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $445d0804e4c539a4$var$pushTreeId(workInProgress, $445d0804e4c539a4$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $445d0804e4c539a4$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $445d0804e4c539a4$var$shouldConstruct(current) ? (props = $445d0804e4c539a4$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $445d0804e4c539a4$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $445d0804e4c539a4$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $445d0804e4c539a4$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $445d0804e4c539a4$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $445d0804e4c539a4$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $445d0804e4c539a4$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $445d0804e4c539a4$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $445d0804e4c539a4$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $445d0804e4c539a4$var$getComponentNameFromType(current) || current;
                    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $445d0804e4c539a4$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $445d0804e4c539a4$var$resolveClassComponentProps(props, workInProgress.pendingProps), $445d0804e4c539a4$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $445d0804e4c539a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $445d0804e4c539a4$var$cloneUpdateQueue(current, workInProgress);
                $445d0804e4c539a4$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $445d0804e4c539a4$var$pushProvider(workInProgress, $445d0804e4c539a4$var$CacheContext, props);
                props !== prevState.cache && $445d0804e4c539a4$var$propagateContextChanges(workInProgress, [
                    $445d0804e4c539a4$var$CacheContext
                ], renderLanes, !0);
                $445d0804e4c539a4$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $445d0804e4c539a4$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $445d0804e4c539a4$var$createCapturedValueAtFiber(Error($445d0804e4c539a4$var$formatProdErrorMessage(424)), workInProgress);
                        $445d0804e4c539a4$var$queueHydrationError($$typeof);
                        workInProgress = $445d0804e4c539a4$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratable(current.firstChild);
                        $445d0804e4c539a4$var$hydrationParentFiber = workInProgress;
                        $445d0804e4c539a4$var$isHydrating = !0;
                        $445d0804e4c539a4$var$hydrationErrors = null;
                        $445d0804e4c539a4$var$rootOrSingletonContext = !0;
                        renderLanes = $445d0804e4c539a4$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $445d0804e4c539a4$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $445d0804e4c539a4$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $445d0804e4c539a4$var$markRef(current, workInProgress), null === current ? (renderLanes = $445d0804e4c539a4$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $445d0804e4c539a4$var$isHydrating || (workInProgress.stateNode = $445d0804e4c539a4$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $445d0804e4c539a4$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $445d0804e4c539a4$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $445d0804e4c539a4$var$pushHostContext(workInProgress), null === current && $445d0804e4c539a4$var$isHydrating && (props = workInProgress.stateNode = $445d0804e4c539a4$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $445d0804e4c539a4$var$rootInstanceStackCursor.current), $445d0804e4c539a4$var$hydrationParentFiber = workInProgress, $445d0804e4c539a4$var$rootOrSingletonContext = !0, $$typeof = $445d0804e4c539a4$var$nextHydratableInstance, $445d0804e4c539a4$var$isSingletonScope(workInProgress.type) ? ($445d0804e4c539a4$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratable(props.firstChild)) : $445d0804e4c539a4$var$nextHydratableInstance = $$typeof), $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $445d0804e4c539a4$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $445d0804e4c539a4$var$isHydrating) {
                if ($$typeof = props = $445d0804e4c539a4$var$nextHydratableInstance) props = $445d0804e4c539a4$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $445d0804e4c539a4$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $445d0804e4c539a4$var$hydrationParentFiber = workInProgress, $445d0804e4c539a4$var$nextHydratableInstance = $445d0804e4c539a4$var$getNextHydratable(props.firstChild), $445d0804e4c539a4$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $445d0804e4c539a4$var$throwOnHydrationMismatch(workInProgress);
            }
            $445d0804e4c539a4$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $445d0804e4c539a4$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $445d0804e4c539a4$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $445d0804e4c539a4$var$renderWithHooks(current, workInProgress, $445d0804e4c539a4$var$TransitionAwareHostComponent, null, null, renderLanes), $445d0804e4c539a4$var$HostTransitionContext._currentValue = $$typeof);
            $445d0804e4c539a4$var$markRef(current, workInProgress);
            $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $445d0804e4c539a4$var$isHydrating) {
                if (current = renderLanes = $445d0804e4c539a4$var$nextHydratableInstance) renderLanes = $445d0804e4c539a4$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $445d0804e4c539a4$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $445d0804e4c539a4$var$hydrationParentFiber = workInProgress, $445d0804e4c539a4$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $445d0804e4c539a4$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $445d0804e4c539a4$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $445d0804e4c539a4$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $445d0804e4c539a4$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $445d0804e4c539a4$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $445d0804e4c539a4$var$markRef(current, workInProgress), $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $445d0804e4c539a4$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $445d0804e4c539a4$var$prepareToReadContext(workInProgress), $$typeof = $445d0804e4c539a4$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $445d0804e4c539a4$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $445d0804e4c539a4$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $445d0804e4c539a4$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $445d0804e4c539a4$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $445d0804e4c539a4$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $445d0804e4c539a4$var$prepareToReadContext(workInProgress), props = $445d0804e4c539a4$var$readContext($445d0804e4c539a4$var$CacheContext), null === current ? ($$typeof = $445d0804e4c539a4$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $445d0804e4c539a4$var$workInProgressRoot, prevState = $445d0804e4c539a4$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $445d0804e4c539a4$var$initializeUpdateQueue(workInProgress), $445d0804e4c539a4$var$pushProvider(workInProgress, $445d0804e4c539a4$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($445d0804e4c539a4$var$cloneUpdateQueue(current, workInProgress), $445d0804e4c539a4$var$processUpdateQueue(workInProgress, null, null, renderLanes), $445d0804e4c539a4$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $445d0804e4c539a4$var$pushProvider(workInProgress, $445d0804e4c539a4$var$CacheContext, props)) : (props = prevState.cache, $445d0804e4c539a4$var$pushProvider(workInProgress, $445d0804e4c539a4$var$CacheContext, props), props !== $$typeof.cache && $445d0804e4c539a4$var$propagateContextChanges(workInProgress, [
                $445d0804e4c539a4$var$CacheContext
            ], renderLanes, !0))), $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $445d0804e4c539a4$var$markRef(current, workInProgress), $445d0804e4c539a4$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $445d0804e4c539a4$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $445d0804e4c539a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $445d0804e4c539a4$var$maySuspendCommit(type, newProps) : $445d0804e4c539a4$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($445d0804e4c539a4$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $445d0804e4c539a4$var$suspendedThenable = $445d0804e4c539a4$var$noopSuspenseyCommitThenable, $445d0804e4c539a4$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $445d0804e4c539a4$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$445d0804e4c539a4$var$preloadResource(resource)) {
        if ($445d0804e4c539a4$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $445d0804e4c539a4$var$suspendedThenable = $445d0804e4c539a4$var$noopSuspenseyCommitThenable, $445d0804e4c539a4$var$SuspenseyCommitException;
    }
}
function $445d0804e4c539a4$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $445d0804e4c539a4$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $445d0804e4c539a4$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $445d0804e4c539a4$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$445d0804e4c539a4$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $445d0804e4c539a4$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $445d0804e4c539a4$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $445d0804e4c539a4$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
        case 1:
            return $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $445d0804e4c539a4$var$popProvider($445d0804e4c539a4$var$CacheContext);
            $445d0804e4c539a4$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $445d0804e4c539a4$var$popHydrationState(workInProgress) ? $445d0804e4c539a4$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $445d0804e4c539a4$var$upgradeHydrationErrorsToRecoverable());
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($445d0804e4c539a4$var$markUpdate(workInProgress), null !== nextResource ? ($445d0804e4c539a4$var$bubbleProperties(workInProgress), $445d0804e4c539a4$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($445d0804e4c539a4$var$bubbleProperties(workInProgress), $445d0804e4c539a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($445d0804e4c539a4$var$markUpdate(workInProgress), $445d0804e4c539a4$var$bubbleProperties(workInProgress), $445d0804e4c539a4$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($445d0804e4c539a4$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $445d0804e4c539a4$var$markUpdate(workInProgress), $445d0804e4c539a4$var$bubbleProperties(workInProgress), $445d0804e4c539a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $445d0804e4c539a4$var$popHostContext(workInProgress);
            renderLanes = $445d0804e4c539a4$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $445d0804e4c539a4$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(166));
                    $445d0804e4c539a4$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $445d0804e4c539a4$var$contextStackCursor.current;
                $445d0804e4c539a4$var$popHydrationState(workInProgress) ? $445d0804e4c539a4$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $445d0804e4c539a4$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $445d0804e4c539a4$var$markUpdate(workInProgress));
            }
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $445d0804e4c539a4$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $445d0804e4c539a4$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(166));
                    $445d0804e4c539a4$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $445d0804e4c539a4$var$contextStackCursor.current;
                if ($445d0804e4c539a4$var$popHydrationState(workInProgress)) $445d0804e4c539a4$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $445d0804e4c539a4$var$getOwnerDocumentFromRootContainer($445d0804e4c539a4$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$445d0804e4c539a4$var$internalInstanceKey] = workInProgress;
                    nextResource[$445d0804e4c539a4$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($445d0804e4c539a4$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $445d0804e4c539a4$var$markUpdate(workInProgress);
                }
            }
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $445d0804e4c539a4$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $445d0804e4c539a4$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(166));
                current = $445d0804e4c539a4$var$rootInstanceStackCursor.current;
                if ($445d0804e4c539a4$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $445d0804e4c539a4$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$445d0804e4c539a4$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $445d0804e4c539a4$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $445d0804e4c539a4$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $445d0804e4c539a4$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$445d0804e4c539a4$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $445d0804e4c539a4$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(557));
                        current[$445d0804e4c539a4$var$internalInstanceKey] = workInProgress;
                    } else $445d0804e4c539a4$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $445d0804e4c539a4$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $445d0804e4c539a4$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $445d0804e4c539a4$var$popSuspenseHandler(workInProgress), workInProgress;
                    $445d0804e4c539a4$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(558));
            }
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $445d0804e4c539a4$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(317));
                        type[$445d0804e4c539a4$var$internalInstanceKey] = workInProgress;
                    } else $445d0804e4c539a4$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $445d0804e4c539a4$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $445d0804e4c539a4$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $445d0804e4c539a4$var$popSuspenseHandler(workInProgress), workInProgress;
                    $445d0804e4c539a4$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $445d0804e4c539a4$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $445d0804e4c539a4$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $445d0804e4c539a4$var$popHostContainer(), null === current && $445d0804e4c539a4$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
        case 10:
            return $445d0804e4c539a4$var$popProvider(workInProgress.type), $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
        case 19:
            $445d0804e4c539a4$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $445d0804e4c539a4$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $445d0804e4c539a4$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $445d0804e4c539a4$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $445d0804e4c539a4$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $445d0804e4c539a4$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$445d0804e4c539a4$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $445d0804e4c539a4$var$pushSuspenseListContext(workInProgress, $445d0804e4c539a4$var$suspenseStackCursor.current & 1 | 2);
                            $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $445d0804e4c539a4$var$now() > $445d0804e4c539a4$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $445d0804e4c539a4$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $445d0804e4c539a4$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $445d0804e4c539a4$var$scheduleRetryEffect(workInProgress, current), $445d0804e4c539a4$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$445d0804e4c539a4$var$isHydrating) return $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
                    } else 2 * $445d0804e4c539a4$var$now() - newProps.renderingStartTime > $445d0804e4c539a4$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $445d0804e4c539a4$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $445d0804e4c539a4$var$now();
                current.sibling = null;
                nextResource = $445d0804e4c539a4$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $445d0804e4c539a4$var$isHydrating ? $445d0804e4c539a4$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseHandlerStackCursor, workInProgress), $445d0804e4c539a4$var$push($445d0804e4c539a4$var$suspenseStackCursor, renderLanes), null === $445d0804e4c539a4$var$shellBoundary && ($445d0804e4c539a4$var$shellBoundary = workInProgress));
                $445d0804e4c539a4$var$isHydrating && $445d0804e4c539a4$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $445d0804e4c539a4$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $445d0804e4c539a4$var$popSuspenseHandler(workInProgress), $445d0804e4c539a4$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($445d0804e4c539a4$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $445d0804e4c539a4$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $445d0804e4c539a4$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $445d0804e4c539a4$var$popProvider($445d0804e4c539a4$var$CacheContext), $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $445d0804e4c539a4$var$bubbleProperties(workInProgress), null;
    }
    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $445d0804e4c539a4$var$unwindWork(current, workInProgress) {
    $445d0804e4c539a4$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $445d0804e4c539a4$var$popProvider($445d0804e4c539a4$var$CacheContext), $445d0804e4c539a4$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $445d0804e4c539a4$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $445d0804e4c539a4$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(340));
                $445d0804e4c539a4$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $445d0804e4c539a4$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(340));
                $445d0804e4c539a4$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $445d0804e4c539a4$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $445d0804e4c539a4$var$popHostContainer(), null;
        case 10:
            return $445d0804e4c539a4$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $445d0804e4c539a4$var$popSuspenseHandler(workInProgress), $445d0804e4c539a4$var$popHiddenContext(), null !== current && $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $445d0804e4c539a4$var$popProvider($445d0804e4c539a4$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $445d0804e4c539a4$var$unwindInterruptedWork(current, interruptedWork) {
    $445d0804e4c539a4$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $445d0804e4c539a4$var$popProvider($445d0804e4c539a4$var$CacheContext);
            $445d0804e4c539a4$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $445d0804e4c539a4$var$popHostContext(interruptedWork);
            break;
        case 4:
            $445d0804e4c539a4$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $445d0804e4c539a4$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $445d0804e4c539a4$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $445d0804e4c539a4$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $445d0804e4c539a4$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $445d0804e4c539a4$var$popSuspenseHandler(interruptedWork);
            $445d0804e4c539a4$var$popHiddenContext();
            null !== current && $445d0804e4c539a4$var$pop($445d0804e4c539a4$var$resumedCache);
            break;
        case 24:
            $445d0804e4c539a4$var$popProvider($445d0804e4c539a4$var$CacheContext);
    }
}
function $445d0804e4c539a4$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $445d0804e4c539a4$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $445d0804e4c539a4$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $445d0804e4c539a4$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $445d0804e4c539a4$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $445d0804e4c539a4$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $445d0804e4c539a4$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $445d0804e4c539a4$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $445d0804e4c539a4$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $445d0804e4c539a4$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $445d0804e4c539a4$var$FragmentInstance(current);
                        $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $445d0804e4c539a4$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $445d0804e4c539a4$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $445d0804e4c539a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $445d0804e4c539a4$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $445d0804e4c539a4$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$445d0804e4c539a4$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $445d0804e4c539a4$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $445d0804e4c539a4$var$isFragmentInstanceParent(parent) && $445d0804e4c539a4$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($445d0804e4c539a4$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $445d0804e4c539a4$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $445d0804e4c539a4$var$isFragmentInstanceParent(parent) && $445d0804e4c539a4$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($445d0804e4c539a4$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $445d0804e4c539a4$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $445d0804e4c539a4$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $445d0804e4c539a4$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $445d0804e4c539a4$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $445d0804e4c539a4$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$445d0804e4c539a4$var$internalPropsKey] = newProps;
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $445d0804e4c539a4$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $445d0804e4c539a4$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $445d0804e4c539a4$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $445d0804e4c539a4$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $445d0804e4c539a4$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $445d0804e4c539a4$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $445d0804e4c539a4$var$noop$1)), $445d0804e4c539a4$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($445d0804e4c539a4$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $445d0804e4c539a4$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($445d0804e4c539a4$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$445d0804e4c539a4$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $445d0804e4c539a4$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $445d0804e4c539a4$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($445d0804e4c539a4$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $445d0804e4c539a4$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($445d0804e4c539a4$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$445d0804e4c539a4$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $445d0804e4c539a4$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $445d0804e4c539a4$var$setInitialProperties(singleton, type, props);
        singleton[$445d0804e4c539a4$var$internalInstanceKey] = finishedWork;
        singleton[$445d0804e4c539a4$var$internalPropsKey] = props;
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $445d0804e4c539a4$var$shouldStartViewTransition = !1, $445d0804e4c539a4$var$appearingViewTransitions = null;
function $445d0804e4c539a4$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $445d0804e4c539a4$var$shouldStartViewTransition = !0;
}
var $445d0804e4c539a4$var$viewTransitionCancelableChildren = null;
function $445d0804e4c539a4$var$pushViewTransitionCancelableScope() {
    var prevChildren = $445d0804e4c539a4$var$viewTransitionCancelableChildren;
    $445d0804e4c539a4$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $445d0804e4c539a4$var$viewTransitionHostInstanceIdx = 0;
function $445d0804e4c539a4$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $445d0804e4c539a4$var$viewTransitionHostInstanceIdx = 0;
    return $445d0804e4c539a4$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $445d0804e4c539a4$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $445d0804e4c539a4$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $445d0804e4c539a4$var$measureInstance(instance).view && (inViewport = !0);
            $445d0804e4c539a4$var$shouldStartViewTransition = !0;
            $445d0804e4c539a4$var$applyViewTransitionName(instance, 0 === $445d0804e4c539a4$var$viewTransitionHostInstanceIdx ? name : name + "_" + $445d0804e4c539a4$var$viewTransitionHostInstanceIdx, className);
            $445d0804e4c539a4$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $445d0804e4c539a4$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $445d0804e4c539a4$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $445d0804e4c539a4$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($445d0804e4c539a4$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($445d0804e4c539a4$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $445d0804e4c539a4$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $445d0804e4c539a4$var$getViewTransitionName(props, state), className = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $445d0804e4c539a4$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($445d0804e4c539a4$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $445d0804e4c539a4$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $445d0804e4c539a4$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$445d0804e4c539a4$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $445d0804e4c539a4$var$commitAppearingPairViewTransitions(placement);
}
function $445d0804e4c539a4$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $445d0804e4c539a4$var$appearingViewTransitions && 0 !== $445d0804e4c539a4$var$appearingViewTransitions.size) {
        var pairs = $445d0804e4c539a4$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($445d0804e4c539a4$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $445d0804e4c539a4$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $445d0804e4c539a4$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $445d0804e4c539a4$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $445d0804e4c539a4$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $445d0804e4c539a4$var$appearingViewTransitions ? $445d0804e4c539a4$var$appearingViewTransitions.get(name) : void 0, className = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($445d0804e4c539a4$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $445d0804e4c539a4$var$appearingViewTransitions.delete(name), $445d0804e4c539a4$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $445d0804e4c539a4$var$scheduleViewTransitionEvent(deletion, props.onExit) : $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $445d0804e4c539a4$var$appearingViewTransitions && $445d0804e4c539a4$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$445d0804e4c539a4$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $445d0804e4c539a4$var$appearingViewTransitions && $445d0804e4c539a4$var$commitDeletedPairViewTransitions(deletion);
}
function $445d0804e4c539a4$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $445d0804e4c539a4$var$getViewTransitionName(props, changedParent.stateNode);
            props = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $445d0804e4c539a4$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $445d0804e4c539a4$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $445d0804e4c539a4$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $445d0804e4c539a4$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $445d0804e4c539a4$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $445d0804e4c539a4$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$445d0804e4c539a4$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $445d0804e4c539a4$var$restorePairedViewTransitions(fiber);
}
function $445d0804e4c539a4$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $445d0804e4c539a4$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $445d0804e4c539a4$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $445d0804e4c539a4$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$445d0804e4c539a4$var$viewTransitionHostInstanceIdx], nextMeasurement = $445d0804e4c539a4$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $445d0804e4c539a4$var$applyViewTransitionName(instance, 0 === $445d0804e4c539a4$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $445d0804e4c539a4$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $445d0804e4c539a4$var$viewTransitionCancelableChildren && ($445d0804e4c539a4$var$viewTransitionCancelableChildren = []), $445d0804e4c539a4$var$viewTransitionCancelableChildren.push(instance, 0 === $445d0804e4c539a4$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $445d0804e4c539a4$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $445d0804e4c539a4$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $445d0804e4c539a4$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $445d0804e4c539a4$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $445d0804e4c539a4$var$getViewTransitionName(props, state), className = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($445d0804e4c539a4$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $445d0804e4c539a4$var$viewTransitionHostInstanceIdx = 0;
            name = $445d0804e4c539a4$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $445d0804e4c539a4$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $445d0804e4c539a4$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $445d0804e4c539a4$var$offscreenSubtreeIsHidden = !1, $445d0804e4c539a4$var$offscreenSubtreeWasHidden = !1, $445d0804e4c539a4$var$offscreenDirectParentIsHidden = !1, $445d0804e4c539a4$var$needsFormReset = !1, $445d0804e4c539a4$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $445d0804e4c539a4$var$nextEffect = null, $445d0804e4c539a4$var$viewTransitionContextChanged = !1, $445d0804e4c539a4$var$inUpdateViewTransition = !1, $445d0804e4c539a4$var$rootViewTransitionAffected = !1, $445d0804e4c539a4$var$rootViewTransitionNameCanceled = !1;
function $445d0804e4c539a4$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $445d0804e4c539a4$var$eventsEnabled = $445d0804e4c539a4$var$_enabled;
    root = $445d0804e4c539a4$var$getActiveElementDeep(root);
    if ($445d0804e4c539a4$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $445d0804e4c539a4$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $445d0804e4c539a4$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $445d0804e4c539a4$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $445d0804e4c539a4$var$nextEffect;){
        root = $445d0804e4c539a4$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $445d0804e4c539a4$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $445d0804e4c539a4$var$trackEnterViewTransitions(root), $445d0804e4c539a4$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $445d0804e4c539a4$var$commitExitViewTransitions(JSCompiler_temp);
                    $445d0804e4c539a4$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $445d0804e4c539a4$var$trackEnterViewTransitions(root);
                    $445d0804e4c539a4$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $445d0804e4c539a4$var$nextEffect = JSCompiler_temp) : (committedLanes && $445d0804e4c539a4$var$commitNestedViewTransitions(root), $445d0804e4c539a4$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $445d0804e4c539a4$var$appearingViewTransitions = null;
}
function $445d0804e4c539a4$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $445d0804e4c539a4$var$nextEffect;){
        var fiber = $445d0804e4c539a4$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $445d0804e4c539a4$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $445d0804e4c539a4$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $445d0804e4c539a4$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $445d0804e4c539a4$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $445d0804e4c539a4$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $445d0804e4c539a4$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $445d0804e4c539a4$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $445d0804e4c539a4$var$nextEffect = current;
            break;
        }
        $445d0804e4c539a4$var$nextEffect = fiber.return;
    }
}
function $445d0804e4c539a4$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $445d0804e4c539a4$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $445d0804e4c539a4$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $445d0804e4c539a4$var$commitClassCallbacks(finishedWork);
            flags & 512 && $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $445d0804e4c539a4$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $445d0804e4c539a4$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $445d0804e4c539a4$var$commitHostMount(finishedWork);
            flags & 512 && $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $445d0804e4c539a4$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $445d0804e4c539a4$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $445d0804e4c539a4$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $445d0804e4c539a4$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $445d0804e4c539a4$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $445d0804e4c539a4$var$offscreenSubtreeWasHidden;
                current = $445d0804e4c539a4$var$offscreenSubtreeIsHidden;
                prevProps = $445d0804e4c539a4$var$offscreenSubtreeWasHidden;
                $445d0804e4c539a4$var$offscreenSubtreeIsHidden = flags;
                ($445d0804e4c539a4$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $445d0804e4c539a4$var$offscreenSubtreeIsHidden = current;
                $445d0804e4c539a4$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $445d0804e4c539a4$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $445d0804e4c539a4$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $445d0804e4c539a4$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $445d0804e4c539a4$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $445d0804e4c539a4$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $445d0804e4c539a4$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $445d0804e4c539a4$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $445d0804e4c539a4$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $445d0804e4c539a4$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $445d0804e4c539a4$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $445d0804e4c539a4$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $445d0804e4c539a4$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $445d0804e4c539a4$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $445d0804e4c539a4$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $445d0804e4c539a4$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $445d0804e4c539a4$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $445d0804e4c539a4$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $445d0804e4c539a4$var$hostParent = null, $445d0804e4c539a4$var$hostParentIsContainer = !1;
function $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$445d0804e4c539a4$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $445d0804e4c539a4$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($445d0804e4c539a4$var$injectedHook && "function" === typeof $445d0804e4c539a4$var$injectedHook.onCommitFiberUnmount) try {
        $445d0804e4c539a4$var$injectedHook.onCommitFiberUnmount($445d0804e4c539a4$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden || $445d0804e4c539a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$445d0804e4c539a4$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden || $445d0804e4c539a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $445d0804e4c539a4$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $445d0804e4c539a4$var$hostParent, prevHostParentIsContainer = $445d0804e4c539a4$var$hostParentIsContainer;
            $445d0804e4c539a4$var$isSingletonScope(deletedFiber.type) && ($445d0804e4c539a4$var$hostParent = deletedFiber.stateNode, $445d0804e4c539a4$var$hostParentIsContainer = !1);
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $445d0804e4c539a4$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $445d0804e4c539a4$var$hostParent = prevHostParent;
            $445d0804e4c539a4$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden || $445d0804e4c539a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $445d0804e4c539a4$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $445d0804e4c539a4$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $445d0804e4c539a4$var$hostParent;
            prevHostParentIsContainer = $445d0804e4c539a4$var$hostParentIsContainer;
            $445d0804e4c539a4$var$hostParent = null;
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $445d0804e4c539a4$var$hostParent = prevHostParent;
            $445d0804e4c539a4$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $445d0804e4c539a4$var$hostParent) {
                if ($445d0804e4c539a4$var$hostParentIsContainer) try {
                    (9 === $445d0804e4c539a4$var$hostParent.nodeType ? $445d0804e4c539a4$var$hostParent.body : "HTML" === $445d0804e4c539a4$var$hostParent.nodeName ? $445d0804e4c539a4$var$hostParent.ownerDocument.body : $445d0804e4c539a4$var$hostParent).removeChild(deletedFiber.stateNode), $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $445d0804e4c539a4$var$hostParent.removeChild(deletedFiber.stateNode), $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $445d0804e4c539a4$var$hostParent && ($445d0804e4c539a4$var$hostParentIsContainer ? (finishedRoot = $445d0804e4c539a4$var$hostParent, $445d0804e4c539a4$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $445d0804e4c539a4$var$retryIfBlockedOn(finishedRoot)) : $445d0804e4c539a4$var$clearHydrationBoundary($445d0804e4c539a4$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $445d0804e4c539a4$var$hostParent;
            prevHostParentIsContainer = $445d0804e4c539a4$var$hostParentIsContainer;
            $445d0804e4c539a4$var$hostParent = deletedFiber.stateNode.containerInfo;
            $445d0804e4c539a4$var$hostParentIsContainer = !0;
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $445d0804e4c539a4$var$hostParent = prevHostParent;
            $445d0804e4c539a4$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $445d0804e4c539a4$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden || $445d0804e4c539a4$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden || ($445d0804e4c539a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $445d0804e4c539a4$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden = (prevHostParent = $445d0804e4c539a4$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $445d0804e4c539a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden || $445d0804e4c539a4$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $445d0804e4c539a4$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $445d0804e4c539a4$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $445d0804e4c539a4$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $445d0804e4c539a4$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $445d0804e4c539a4$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $445d0804e4c539a4$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $445d0804e4c539a4$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $445d0804e4c539a4$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $445d0804e4c539a4$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $445d0804e4c539a4$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $445d0804e4c539a4$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($445d0804e4c539a4$var$isSingletonScope(parent.type)) {
                        $445d0804e4c539a4$var$hostParent = parent.stateNode;
                        $445d0804e4c539a4$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $445d0804e4c539a4$var$hostParent = parent.stateNode;
                    $445d0804e4c539a4$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $445d0804e4c539a4$var$hostParent = parent.stateNode.containerInfo;
                    $445d0804e4c539a4$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $445d0804e4c539a4$var$hostParent) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(160));
        $445d0804e4c539a4$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $445d0804e4c539a4$var$hostParent = null;
        $445d0804e4c539a4$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $445d0804e4c539a4$var$currentHoistableRoot = null;
function $445d0804e4c539a4$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($445d0804e4c539a4$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $445d0804e4c539a4$var$commitHookEffectListMount(3, finishedWork), $445d0804e4c539a4$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($445d0804e4c539a4$var$offscreenSubtreeWasHidden || null === current || $445d0804e4c539a4$var$safelyDetachRef(current, current.return));
            flags & 64 && $445d0804e4c539a4$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $445d0804e4c539a4$var$currentHoistableRoot;
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($445d0804e4c539a4$var$offscreenSubtreeWasHidden || null === current || $445d0804e4c539a4$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($445d0804e4c539a4$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $445d0804e4c539a4$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$445d0804e4c539a4$var$internalHoistableMarker] || current[$445d0804e4c539a4$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $445d0804e4c539a4$var$setInitialProperties(current, root, lanes);
                                            current[$445d0804e4c539a4$var$internalInstanceKey] = finishedWork;
                                            $445d0804e4c539a4$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $445d0804e4c539a4$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $445d0804e4c539a4$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $445d0804e4c539a4$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $445d0804e4c539a4$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$445d0804e4c539a4$var$internalInstanceKey] = finishedWork;
                                    $445d0804e4c539a4$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $445d0804e4c539a4$var$offscreenSubtreeIsHidden || $445d0804e4c539a4$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $445d0804e4c539a4$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $445d0804e4c539a4$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $445d0804e4c539a4$var$offscreenSubtreeIsHidden || $445d0804e4c539a4$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $445d0804e4c539a4$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $445d0804e4c539a4$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($445d0804e4c539a4$var$offscreenSubtreeWasHidden || null === current || $445d0804e4c539a4$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $445d0804e4c539a4$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $445d0804e4c539a4$var$offscreenDirectParentIsHidden;
            $445d0804e4c539a4$var$offscreenDirectParentIsHidden = !1;
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$offscreenDirectParentIsHidden = ii;
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($445d0804e4c539a4$var$offscreenSubtreeWasHidden || null === current || $445d0804e4c539a4$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $445d0804e4c539a4$var$setTextContent(root, ""), $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $445d0804e4c539a4$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($445d0804e4c539a4$var$needsFormReset = !0);
            break;
        case 6:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $445d0804e4c539a4$var$viewTransitionMutationContext = !1;
            $445d0804e4c539a4$var$tagCaches = null;
            ii = $445d0804e4c539a4$var$currentHoistableRoot;
            $445d0804e4c539a4$var$currentHoistableRoot = $445d0804e4c539a4$var$getHoistableRoot(root.containerInfo);
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$currentHoistableRoot = ii;
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $445d0804e4c539a4$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $445d0804e4c539a4$var$needsFormReset && ($445d0804e4c539a4$var$needsFormReset = !1, $445d0804e4c539a4$var$recursivelyResetForms(finishedWork));
            $445d0804e4c539a4$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $445d0804e4c539a4$var$offscreenDirectParentIsHidden;
            $445d0804e4c539a4$var$offscreenDirectParentIsHidden = $445d0804e4c539a4$var$offscreenSubtreeIsHidden;
            current = $445d0804e4c539a4$var$pushMutationContext();
            ii = $445d0804e4c539a4$var$currentHoistableRoot;
            $445d0804e4c539a4$var$currentHoistableRoot = $445d0804e4c539a4$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            $445d0804e4c539a4$var$currentHoistableRoot = ii;
            $445d0804e4c539a4$var$viewTransitionMutationContext && $445d0804e4c539a4$var$inUpdateViewTransition && ($445d0804e4c539a4$var$rootViewTransitionAffected = !0);
            $445d0804e4c539a4$var$viewTransitionMutationContext = current;
            $445d0804e4c539a4$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $445d0804e4c539a4$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($445d0804e4c539a4$var$globalMostRecentFallbackTime = $445d0804e4c539a4$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $445d0804e4c539a4$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $445d0804e4c539a4$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $445d0804e4c539a4$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $445d0804e4c539a4$var$offscreenDirectParentIsHidden;
            $445d0804e4c539a4$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $445d0804e4c539a4$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $445d0804e4c539a4$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $445d0804e4c539a4$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $445d0804e4c539a4$var$offscreenSubtreeIsHidden || $445d0804e4c539a4$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $445d0804e4c539a4$var$offscreenSubtreeWasHidden, lanes = $445d0804e4c539a4$var$offscreenSubtreeIsHidden, current = $445d0804e4c539a4$var$offscreenSubtreeWasHidden, $445d0804e4c539a4$var$offscreenSubtreeIsHidden = ii || $445d0804e4c539a4$var$offscreenSubtreeIsHidden, $445d0804e4c539a4$var$offscreenSubtreeWasHidden = root, $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $445d0804e4c539a4$var$offscreenSubtreeIsHidden = lanes, $445d0804e4c539a4$var$offscreenSubtreeWasHidden = current), !ii && $445d0804e4c539a4$var$offscreenDirectParentIsHidden || $445d0804e4c539a4$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $445d0804e4c539a4$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $445d0804e4c539a4$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($445d0804e4c539a4$var$offscreenSubtreeWasHidden || null === current || $445d0804e4c539a4$var$safelyDetachRef(current, current.return));
            flags = $445d0804e4c539a4$var$pushMutationContext();
            ii = $445d0804e4c539a4$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $445d0804e4c539a4$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $445d0804e4c539a4$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $445d0804e4c539a4$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $445d0804e4c539a4$var$inUpdateViewTransition = ii;
            $445d0804e4c539a4$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($445d0804e4c539a4$var$offscreenSubtreeWasHidden || null === current || $445d0804e4c539a4$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $445d0804e4c539a4$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork);
    }
}
function $445d0804e4c539a4$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($445d0804e4c539a4$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($445d0804e4c539a4$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($445d0804e4c539a4$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $445d0804e4c539a4$var$getHostSibling(finishedWork);
                    $445d0804e4c539a4$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($445d0804e4c539a4$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $445d0804e4c539a4$var$getHostSibling(finishedWork);
                    $445d0804e4c539a4$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $445d0804e4c539a4$var$getHostSibling(finishedWork);
                    $445d0804e4c539a4$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $445d0804e4c539a4$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $445d0804e4c539a4$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $445d0804e4c539a4$var$_enabled = !0, fiber.reset(), $445d0804e4c539a4$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $445d0804e4c539a4$var$measureNestedViewTransitions(parentFiber, !1);
}
function $445d0804e4c539a4$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $445d0804e4c539a4$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $445d0804e4c539a4$var$rootViewTransitionNameCanceled = $445d0804e4c539a4$var$viewTransitionContextChanged = !1;
            $445d0804e4c539a4$var$pushViewTransitionCancelableScope();
            $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$445d0804e4c539a4$var$viewTransitionContextChanged && !$445d0804e4c539a4$var$rootViewTransitionAffected) {
                finishedWork = $445d0804e4c539a4$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $445d0804e4c539a4$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $445d0804e4c539a4$var$rootViewTransitionNameCanceled = !0;
            }
            $445d0804e4c539a4$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $445d0804e4c539a4$var$viewTransitionContextChanged;
            $445d0804e4c539a4$var$viewTransitionContextChanged = !1;
            $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $445d0804e4c539a4$var$viewTransitionContextChanged && ($445d0804e4c539a4$var$rootViewTransitionAffected = !0);
            $445d0804e4c539a4$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $445d0804e4c539a4$var$commitEnterViewTransitions(finishedWork, !1) : $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $445d0804e4c539a4$var$viewTransitionContextChanged;
            oldName = $445d0804e4c539a4$var$pushViewTransitionCancelableScope();
            $445d0804e4c539a4$var$viewTransitionContextChanged = !1;
            $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $445d0804e4c539a4$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $445d0804e4c539a4$var$getViewTransitionName(props, state);
            state = $445d0804e4c539a4$var$getViewTransitionName(current.memoizedProps, state);
            var className = $445d0804e4c539a4$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $445d0804e4c539a4$var$viewTransitionHostInstanceIdx = 0, root = $445d0804e4c539a4$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $445d0804e4c539a4$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($445d0804e4c539a4$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $445d0804e4c539a4$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $445d0804e4c539a4$var$viewTransitionCancelableChildren), $445d0804e4c539a4$var$viewTransitionCancelableChildren = oldName);
            $445d0804e4c539a4$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $445d0804e4c539a4$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $445d0804e4c539a4$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $445d0804e4c539a4$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $445d0804e4c539a4$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $445d0804e4c539a4$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $445d0804e4c539a4$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $445d0804e4c539a4$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $445d0804e4c539a4$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $445d0804e4c539a4$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $445d0804e4c539a4$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $445d0804e4c539a4$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $445d0804e4c539a4$var$safelyDetachRef(finishedWork, finishedWork.return);
                $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $445d0804e4c539a4$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $445d0804e4c539a4$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $445d0804e4c539a4$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$445d0804e4c539a4$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $445d0804e4c539a4$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $445d0804e4c539a4$var$commitClassCallbacks(finishedWork);
                $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $445d0804e4c539a4$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $445d0804e4c539a4$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $445d0804e4c539a4$var$commitHostMount(finishedWork);
                $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $445d0804e4c539a4$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $445d0804e4c539a4$var$offscreenSubtreeIsHidden || $445d0804e4c539a4$var$mountHoistable($445d0804e4c539a4$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $445d0804e4c539a4$var$commitHostMount(finishedWork);
                $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $445d0804e4c539a4$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $445d0804e4c539a4$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $445d0804e4c539a4$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $445d0804e4c539a4$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $445d0804e4c539a4$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $445d0804e4c539a4$var$releaseCache(previousCache));
}
function $445d0804e4c539a4$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $445d0804e4c539a4$var$releaseCache(current));
}
function $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $445d0804e4c539a4$var$restoreNestedViewTransitions(parentFiber);
}
function $445d0804e4c539a4$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $445d0804e4c539a4$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $445d0804e4c539a4$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $445d0804e4c539a4$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $445d0804e4c539a4$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $445d0804e4c539a4$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $445d0804e4c539a4$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $445d0804e4c539a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $445d0804e4c539a4$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $445d0804e4c539a4$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $445d0804e4c539a4$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(flags.child, !0), $445d0804e4c539a4$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $445d0804e4c539a4$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $445d0804e4c539a4$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $445d0804e4c539a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $445d0804e4c539a4$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $445d0804e4c539a4$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $445d0804e4c539a4$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $445d0804e4c539a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $445d0804e4c539a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $445d0804e4c539a4$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $445d0804e4c539a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $445d0804e4c539a4$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $445d0804e4c539a4$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $445d0804e4c539a4$var$suspenseyCommitFlag = 8192;
function $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $445d0804e4c539a4$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $445d0804e4c539a4$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $445d0804e4c539a4$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $445d0804e4c539a4$var$suspendResource(suspendedState, $445d0804e4c539a4$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $445d0804e4c539a4$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $445d0804e4c539a4$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $445d0804e4c539a4$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $445d0804e4c539a4$var$currentHoistableRoot;
            $445d0804e4c539a4$var$currentHoistableRoot = $445d0804e4c539a4$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $445d0804e4c539a4$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $445d0804e4c539a4$var$suspenseyCommitFlag, $445d0804e4c539a4$var$suspenseyCommitFlag = 16777216, $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $445d0804e4c539a4$var$suspenseyCommitFlag = previousHoistableRoot) : $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $445d0804e4c539a4$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $445d0804e4c539a4$var$appearingViewTransitions && ($445d0804e4c539a4$var$appearingViewTransitions = new Map());
                $445d0804e4c539a4$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $445d0804e4c539a4$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $445d0804e4c539a4$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $445d0804e4c539a4$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $445d0804e4c539a4$var$nextEffect = childToDelete;
            $445d0804e4c539a4$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $445d0804e4c539a4$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$445d0804e4c539a4$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $445d0804e4c539a4$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $445d0804e4c539a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $445d0804e4c539a4$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $445d0804e4c539a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $445d0804e4c539a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $445d0804e4c539a4$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $445d0804e4c539a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $445d0804e4c539a4$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $445d0804e4c539a4$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $445d0804e4c539a4$var$nextEffect = childToDelete;
            $445d0804e4c539a4$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $445d0804e4c539a4$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $445d0804e4c539a4$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $445d0804e4c539a4$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $445d0804e4c539a4$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $445d0804e4c539a4$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $445d0804e4c539a4$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $445d0804e4c539a4$var$nextEffect;){
        var fiber = $445d0804e4c539a4$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $445d0804e4c539a4$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $445d0804e4c539a4$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $445d0804e4c539a4$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $445d0804e4c539a4$var$nextEffect;){
            cache = $445d0804e4c539a4$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $445d0804e4c539a4$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $445d0804e4c539a4$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $445d0804e4c539a4$var$nextEffect = sibling;
                break a;
            }
            $445d0804e4c539a4$var$nextEffect = returnFiber;
        }
    }
}
var $445d0804e4c539a4$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $445d0804e4c539a4$var$readContext($445d0804e4c539a4$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $445d0804e4c539a4$var$readContext($445d0804e4c539a4$var$CacheContext).controller.signal;
    }
}, $445d0804e4c539a4$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $445d0804e4c539a4$var$executionContext = 0, $445d0804e4c539a4$var$workInProgressRoot = null, $445d0804e4c539a4$var$workInProgress = null, $445d0804e4c539a4$var$workInProgressRootRenderLanes = 0, $445d0804e4c539a4$var$workInProgressSuspendedReason = 0, $445d0804e4c539a4$var$workInProgressThrownValue = null, $445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings = !1, $445d0804e4c539a4$var$workInProgressRootIsPrerendering = !1, $445d0804e4c539a4$var$workInProgressRootDidAttachPingListener = !1, $445d0804e4c539a4$var$entangledRenderLanes = 0, $445d0804e4c539a4$var$workInProgressRootExitStatus = 0, $445d0804e4c539a4$var$workInProgressRootSkippedLanes = 0, $445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes = 0, $445d0804e4c539a4$var$workInProgressRootPingedLanes = 0, $445d0804e4c539a4$var$workInProgressDeferredLane = 0, $445d0804e4c539a4$var$workInProgressSuspendedRetryLanes = 0, $445d0804e4c539a4$var$workInProgressRootConcurrentErrors = null, $445d0804e4c539a4$var$workInProgressRootRecoverableErrors = null, $445d0804e4c539a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $445d0804e4c539a4$var$globalMostRecentFallbackTime = 0, $445d0804e4c539a4$var$globalMostRecentTransitionTime = 0, $445d0804e4c539a4$var$workInProgressRootRenderTargetTime = Infinity, $445d0804e4c539a4$var$workInProgressTransitions = null, $445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed = null, $445d0804e4c539a4$var$pendingEffectsStatus = 0, $445d0804e4c539a4$var$pendingEffectsRoot = null, $445d0804e4c539a4$var$pendingFinishedWork = null, $445d0804e4c539a4$var$pendingEffectsLanes = 0, $445d0804e4c539a4$var$pendingEffectsRemainingLanes = 0, $445d0804e4c539a4$var$pendingPassiveTransitions = null, $445d0804e4c539a4$var$pendingRecoverableErrors = null, $445d0804e4c539a4$var$pendingViewTransition = null, $445d0804e4c539a4$var$pendingViewTransitionEvents = null, $445d0804e4c539a4$var$pendingTransitionTypes = null, $445d0804e4c539a4$var$nestedUpdateCount = 0, $445d0804e4c539a4$var$rootWithNestedUpdates = null;
function $445d0804e4c539a4$var$requestUpdateLane() {
    return 0 !== ($445d0804e4c539a4$var$executionContext & 2) && 0 !== $445d0804e4c539a4$var$workInProgressRootRenderLanes ? $445d0804e4c539a4$var$workInProgressRootRenderLanes & -$445d0804e4c539a4$var$workInProgressRootRenderLanes : null !== $445d0804e4c539a4$var$ReactSharedInternals.T ? $445d0804e4c539a4$var$requestTransitionLane() : $445d0804e4c539a4$var$resolveUpdatePriority();
}
function $445d0804e4c539a4$var$requestDeferredLane() {
    if (0 === $445d0804e4c539a4$var$workInProgressDeferredLane) {
        if (0 === ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 536870912) || $445d0804e4c539a4$var$isHydrating) {
            var lane = $445d0804e4c539a4$var$nextTransitionDeferredLane;
            $445d0804e4c539a4$var$nextTransitionDeferredLane <<= 1;
            0 === ($445d0804e4c539a4$var$nextTransitionDeferredLane & 3932160) && ($445d0804e4c539a4$var$nextTransitionDeferredLane = 262144);
            $445d0804e4c539a4$var$workInProgressDeferredLane = lane;
        } else $445d0804e4c539a4$var$workInProgressDeferredLane = 536870912;
    }
    lane = $445d0804e4c539a4$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $445d0804e4c539a4$var$workInProgressDeferredLane;
}
function $445d0804e4c539a4$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $445d0804e4c539a4$var$createViewTransitionInstance($445d0804e4c539a4$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $445d0804e4c539a4$var$pendingViewTransitionEvents && ($445d0804e4c539a4$var$pendingViewTransitionEvents = []);
        $445d0804e4c539a4$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $445d0804e4c539a4$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $445d0804e4c539a4$var$workInProgressRoot && (2 === $445d0804e4c539a4$var$workInProgressSuspendedReason || 9 === $445d0804e4c539a4$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $445d0804e4c539a4$var$prepareFreshStack(root, 0), $445d0804e4c539a4$var$markRootSuspended(root, $445d0804e4c539a4$var$workInProgressRootRenderLanes, $445d0804e4c539a4$var$workInProgressDeferredLane, !1);
    $445d0804e4c539a4$var$markRootUpdated$1(root, lane);
    if (0 === ($445d0804e4c539a4$var$executionContext & 2) || root !== $445d0804e4c539a4$var$workInProgressRoot) root === $445d0804e4c539a4$var$workInProgressRoot && (0 === ($445d0804e4c539a4$var$executionContext & 2) && ($445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $445d0804e4c539a4$var$workInProgressRootExitStatus && $445d0804e4c539a4$var$markRootSuspended(root, $445d0804e4c539a4$var$workInProgressRootRenderLanes, $445d0804e4c539a4$var$workInProgressDeferredLane, !1)), $445d0804e4c539a4$var$ensureRootIsScheduled(root);
}
function $445d0804e4c539a4$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($445d0804e4c539a4$var$executionContext & 6)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $445d0804e4c539a4$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $445d0804e4c539a4$var$renderRootConcurrent(root$jscomp$0, lanes) : $445d0804e4c539a4$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $445d0804e4c539a4$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $445d0804e4c539a4$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$445d0804e4c539a4$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $445d0804e4c539a4$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $445d0804e4c539a4$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($445d0804e4c539a4$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $445d0804e4c539a4$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($445d0804e4c539a4$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $445d0804e4c539a4$var$workInProgressRootRecoverableErrors;
                            $445d0804e4c539a4$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $445d0804e4c539a4$var$workInProgressRootRecoverableErrors ? $445d0804e4c539a4$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $445d0804e4c539a4$var$workInProgressRootRecoverableErrors.push.apply($445d0804e4c539a4$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $445d0804e4c539a4$var$prepareFreshStack(root$jscomp$0, 0);
                $445d0804e4c539a4$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($445d0804e4c539a4$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $445d0804e4c539a4$var$markRootSuspended(shouldTimeSlice, lanes, $445d0804e4c539a4$var$workInProgressDeferredLane, !$445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $445d0804e4c539a4$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($445d0804e4c539a4$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $445d0804e4c539a4$var$globalMostRecentFallbackTime + 300 - $445d0804e4c539a4$var$now(), 10 < exitStatus)) {
                    $445d0804e4c539a4$var$markRootSuspended(shouldTimeSlice, lanes, $445d0804e4c539a4$var$workInProgressDeferredLane, !$445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $445d0804e4c539a4$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $445d0804e4c539a4$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $445d0804e4c539a4$var$scheduleTimeout($445d0804e4c539a4$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $445d0804e4c539a4$var$workInProgressRootRecoverableErrors, $445d0804e4c539a4$var$workInProgressTransitions, $445d0804e4c539a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $445d0804e4c539a4$var$workInProgressDeferredLane, $445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes, $445d0804e4c539a4$var$workInProgressSuspendedRetryLanes, $445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $445d0804e4c539a4$var$completeRootWhenReady(shouldTimeSlice, forceSync, $445d0804e4c539a4$var$workInProgressRootRecoverableErrors, $445d0804e4c539a4$var$workInProgressTransitions, $445d0804e4c539a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $445d0804e4c539a4$var$workInProgressDeferredLane, $445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes, $445d0804e4c539a4$var$workInProgressSuspendedRetryLanes, $445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $445d0804e4c539a4$var$ensureRootIsScheduled(root$jscomp$0);
}
function $445d0804e4c539a4$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $445d0804e4c539a4$var$noop$1
        }, $445d0804e4c539a4$var$appearingViewTransitions = null, $445d0804e4c539a4$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $445d0804e4c539a4$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $445d0804e4c539a4$var$globalMostRecentFallbackTime - $445d0804e4c539a4$var$now() : (lanes & 4194048) === lanes ? $445d0804e4c539a4$var$globalMostRecentTransitionTime - $445d0804e4c539a4$var$now() : 0, subtreeFlags = $445d0804e4c539a4$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $445d0804e4c539a4$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($445d0804e4c539a4$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $445d0804e4c539a4$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $445d0804e4c539a4$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $445d0804e4c539a4$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$445d0804e4c539a4$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $445d0804e4c539a4$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $445d0804e4c539a4$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$445d0804e4c539a4$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $445d0804e4c539a4$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $445d0804e4c539a4$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $445d0804e4c539a4$var$flushSyncWork$1() {
    return 0 === ($445d0804e4c539a4$var$executionContext & 6) ? ($445d0804e4c539a4$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $445d0804e4c539a4$var$resetWorkInProgressStack() {
    if (null !== $445d0804e4c539a4$var$workInProgress) {
        if (0 === $445d0804e4c539a4$var$workInProgressSuspendedReason) var interruptedWork = $445d0804e4c539a4$var$workInProgress.return;
        else interruptedWork = $445d0804e4c539a4$var$workInProgress, $445d0804e4c539a4$var$lastContextDependency = $445d0804e4c539a4$var$currentlyRenderingFiber$1 = null, $445d0804e4c539a4$var$resetHooksOnUnwind(interruptedWork), $445d0804e4c539a4$var$thenableState$1 = null, $445d0804e4c539a4$var$thenableIndexCounter$1 = 0, interruptedWork = $445d0804e4c539a4$var$workInProgress;
        for(; null !== interruptedWork;)$445d0804e4c539a4$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $445d0804e4c539a4$var$workInProgress = null;
    }
}
function $445d0804e4c539a4$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $445d0804e4c539a4$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $445d0804e4c539a4$var$pendingEffectsLanes = 0;
    $445d0804e4c539a4$var$resetWorkInProgressStack();
    $445d0804e4c539a4$var$workInProgressRoot = root;
    $445d0804e4c539a4$var$workInProgress = timeoutHandle = $445d0804e4c539a4$var$createWorkInProgress(root.current, null);
    $445d0804e4c539a4$var$workInProgressRootRenderLanes = lanes;
    $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
    $445d0804e4c539a4$var$workInProgressThrownValue = null;
    $445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $445d0804e4c539a4$var$workInProgressRootIsPrerendering = $445d0804e4c539a4$var$checkIfRootIsPrerendering(root, lanes);
    $445d0804e4c539a4$var$workInProgressRootDidAttachPingListener = !1;
    $445d0804e4c539a4$var$workInProgressSuspendedRetryLanes = $445d0804e4c539a4$var$workInProgressDeferredLane = $445d0804e4c539a4$var$workInProgressRootPingedLanes = $445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes = $445d0804e4c539a4$var$workInProgressRootSkippedLanes = $445d0804e4c539a4$var$workInProgressRootExitStatus = 0;
    $445d0804e4c539a4$var$workInProgressRootRecoverableErrors = $445d0804e4c539a4$var$workInProgressRootConcurrentErrors = null;
    $445d0804e4c539a4$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $445d0804e4c539a4$var$entangledRenderLanes = $445d0804e4c539a4$var$getEntangledLanes(root, lanes);
    $445d0804e4c539a4$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $445d0804e4c539a4$var$handleThrow(root, thrownValue) {
    $445d0804e4c539a4$var$currentlyRenderingFiber = null;
    $445d0804e4c539a4$var$ReactSharedInternals.H = $445d0804e4c539a4$var$ContextOnlyDispatcher;
    thrownValue === $445d0804e4c539a4$var$SuspenseException || thrownValue === $445d0804e4c539a4$var$SuspenseActionException ? (thrownValue = $445d0804e4c539a4$var$getSuspendedThenable(), $445d0804e4c539a4$var$workInProgressSuspendedReason = 3) : thrownValue === $445d0804e4c539a4$var$SuspenseyCommitException ? (thrownValue = $445d0804e4c539a4$var$getSuspendedThenable(), $445d0804e4c539a4$var$workInProgressSuspendedReason = 4) : $445d0804e4c539a4$var$workInProgressSuspendedReason = thrownValue === $445d0804e4c539a4$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $445d0804e4c539a4$var$workInProgressThrownValue = thrownValue;
    null === $445d0804e4c539a4$var$workInProgress && ($445d0804e4c539a4$var$workInProgressRootExitStatus = 1, $445d0804e4c539a4$var$logUncaughtError(root, $445d0804e4c539a4$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $445d0804e4c539a4$var$shouldRemainOnPreviousScreen() {
    var handler = $445d0804e4c539a4$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 4194048) === $445d0804e4c539a4$var$workInProgressRootRenderLanes ? null === $445d0804e4c539a4$var$shellBoundary ? !0 : !1 : ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 62914560) === $445d0804e4c539a4$var$workInProgressRootRenderLanes || 0 !== ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 536870912) ? handler === $445d0804e4c539a4$var$shellBoundary : !1;
}
function $445d0804e4c539a4$var$pushDispatcher() {
    var prevDispatcher = $445d0804e4c539a4$var$ReactSharedInternals.H;
    $445d0804e4c539a4$var$ReactSharedInternals.H = $445d0804e4c539a4$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $445d0804e4c539a4$var$ContextOnlyDispatcher : prevDispatcher;
}
function $445d0804e4c539a4$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $445d0804e4c539a4$var$ReactSharedInternals.A;
    $445d0804e4c539a4$var$ReactSharedInternals.A = $445d0804e4c539a4$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $445d0804e4c539a4$var$renderDidSuspendDelayIfPossible() {
    $445d0804e4c539a4$var$workInProgressRootExitStatus = 4;
    $445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings || ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 4194048) !== $445d0804e4c539a4$var$workInProgressRootRenderLanes && null !== $445d0804e4c539a4$var$suspenseHandlerStackCursor.current || ($445d0804e4c539a4$var$workInProgressRootIsPrerendering = !0);
    0 === ($445d0804e4c539a4$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($445d0804e4c539a4$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $445d0804e4c539a4$var$workInProgressRoot || $445d0804e4c539a4$var$markRootSuspended($445d0804e4c539a4$var$workInProgressRoot, $445d0804e4c539a4$var$workInProgressRootRenderLanes, $445d0804e4c539a4$var$workInProgressDeferredLane, !1);
}
function $445d0804e4c539a4$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $445d0804e4c539a4$var$executionContext;
    $445d0804e4c539a4$var$executionContext |= 2;
    var prevDispatcher = $445d0804e4c539a4$var$pushDispatcher(), prevAsyncDispatcher = $445d0804e4c539a4$var$pushAsyncDispatcher();
    if ($445d0804e4c539a4$var$workInProgressRoot !== root || $445d0804e4c539a4$var$workInProgressRootRenderLanes !== lanes) $445d0804e4c539a4$var$workInProgressTransitions = null, $445d0804e4c539a4$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $445d0804e4c539a4$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $445d0804e4c539a4$var$workInProgressSuspendedReason && null !== $445d0804e4c539a4$var$workInProgress) {
            var unitOfWork = $445d0804e4c539a4$var$workInProgress, thrownValue = $445d0804e4c539a4$var$workInProgressThrownValue;
            switch($445d0804e4c539a4$var$workInProgressSuspendedReason){
                case 8:
                    $445d0804e4c539a4$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $445d0804e4c539a4$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $445d0804e4c539a4$var$workInProgressSuspendedReason;
                    $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
                    $445d0804e4c539a4$var$workInProgressThrownValue = null;
                    $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $445d0804e4c539a4$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $445d0804e4c539a4$var$workInProgressSuspendedReason, $445d0804e4c539a4$var$workInProgressSuspendedReason = 0, $445d0804e4c539a4$var$workInProgressThrownValue = null, $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $445d0804e4c539a4$var$workLoopSync();
        exitStatus = $445d0804e4c539a4$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $445d0804e4c539a4$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $445d0804e4c539a4$var$lastContextDependency = $445d0804e4c539a4$var$currentlyRenderingFiber$1 = null;
    $445d0804e4c539a4$var$executionContext = prevExecutionContext;
    $445d0804e4c539a4$var$ReactSharedInternals.H = prevDispatcher;
    $445d0804e4c539a4$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $445d0804e4c539a4$var$workInProgress && ($445d0804e4c539a4$var$workInProgressRoot = null, $445d0804e4c539a4$var$workInProgressRootRenderLanes = 0, $445d0804e4c539a4$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $445d0804e4c539a4$var$workLoopSync() {
    for(; null !== $445d0804e4c539a4$var$workInProgress;)$445d0804e4c539a4$var$performUnitOfWork($445d0804e4c539a4$var$workInProgress);
}
function $445d0804e4c539a4$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $445d0804e4c539a4$var$executionContext;
    $445d0804e4c539a4$var$executionContext |= 2;
    var prevDispatcher = $445d0804e4c539a4$var$pushDispatcher(), prevAsyncDispatcher = $445d0804e4c539a4$var$pushAsyncDispatcher();
    $445d0804e4c539a4$var$workInProgressRoot !== root || $445d0804e4c539a4$var$workInProgressRootRenderLanes !== lanes ? ($445d0804e4c539a4$var$workInProgressTransitions = null, $445d0804e4c539a4$var$workInProgressRootRenderTargetTime = $445d0804e4c539a4$var$now() + 500, $445d0804e4c539a4$var$prepareFreshStack(root, lanes)) : $445d0804e4c539a4$var$workInProgressRootIsPrerendering = $445d0804e4c539a4$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $445d0804e4c539a4$var$workInProgressSuspendedReason && null !== $445d0804e4c539a4$var$workInProgress) {
            lanes = $445d0804e4c539a4$var$workInProgress;
            var thrownValue = $445d0804e4c539a4$var$workInProgressThrownValue;
            b: switch($445d0804e4c539a4$var$workInProgressSuspendedReason){
                case 1:
                    $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
                    $445d0804e4c539a4$var$workInProgressThrownValue = null;
                    $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($445d0804e4c539a4$var$isThenableResolved(thrownValue)) {
                        $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
                        $445d0804e4c539a4$var$workInProgressThrownValue = null;
                        $445d0804e4c539a4$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $445d0804e4c539a4$var$workInProgressSuspendedReason && 9 !== $445d0804e4c539a4$var$workInProgressSuspendedReason || $445d0804e4c539a4$var$workInProgressRoot !== root || ($445d0804e4c539a4$var$workInProgressSuspendedReason = 7);
                        $445d0804e4c539a4$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $445d0804e4c539a4$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $445d0804e4c539a4$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $445d0804e4c539a4$var$isThenableResolved(thrownValue) ? ($445d0804e4c539a4$var$workInProgressSuspendedReason = 0, $445d0804e4c539a4$var$workInProgressThrownValue = null, $445d0804e4c539a4$var$replaySuspendedUnitOfWork(lanes)) : ($445d0804e4c539a4$var$workInProgressSuspendedReason = 0, $445d0804e4c539a4$var$workInProgressThrownValue = null, $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($445d0804e4c539a4$var$workInProgress.tag){
                        case 26:
                            resource = $445d0804e4c539a4$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $445d0804e4c539a4$var$workInProgress;
                            if (resource ? $445d0804e4c539a4$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
                                $445d0804e4c539a4$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $445d0804e4c539a4$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($445d0804e4c539a4$var$workInProgress = returnFiber, $445d0804e4c539a4$var$completeUnitOfWork(returnFiber)) : $445d0804e4c539a4$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
                    $445d0804e4c539a4$var$workInProgressThrownValue = null;
                    $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $445d0804e4c539a4$var$workInProgressSuspendedReason = 0;
                    $445d0804e4c539a4$var$workInProgressThrownValue = null;
                    $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $445d0804e4c539a4$var$resetWorkInProgressStack();
                    $445d0804e4c539a4$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(462));
            }
        }
        $445d0804e4c539a4$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $445d0804e4c539a4$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $445d0804e4c539a4$var$lastContextDependency = $445d0804e4c539a4$var$currentlyRenderingFiber$1 = null;
    $445d0804e4c539a4$var$ReactSharedInternals.H = prevDispatcher;
    $445d0804e4c539a4$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $445d0804e4c539a4$var$executionContext = prevExecutionContext;
    if (null !== $445d0804e4c539a4$var$workInProgress) return 0;
    $445d0804e4c539a4$var$workInProgressRoot = null;
    $445d0804e4c539a4$var$workInProgressRootRenderLanes = 0;
    $445d0804e4c539a4$var$finishQueueingConcurrentUpdates();
    return $445d0804e4c539a4$var$workInProgressRootExitStatus;
}
function $445d0804e4c539a4$var$workLoopConcurrentByScheduler() {
    for(; null !== $445d0804e4c539a4$var$workInProgress && !$445d0804e4c539a4$var$shouldYield();)$445d0804e4c539a4$var$performUnitOfWork($445d0804e4c539a4$var$workInProgress);
}
function $445d0804e4c539a4$var$performUnitOfWork(unitOfWork) {
    var next = $445d0804e4c539a4$var$beginWork(unitOfWork.alternate, unitOfWork, $445d0804e4c539a4$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $445d0804e4c539a4$var$completeUnitOfWork(unitOfWork) : $445d0804e4c539a4$var$workInProgress = next;
}
function $445d0804e4c539a4$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $445d0804e4c539a4$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $445d0804e4c539a4$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $445d0804e4c539a4$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $445d0804e4c539a4$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $445d0804e4c539a4$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $445d0804e4c539a4$var$hydrationParentFiber && ($445d0804e4c539a4$var$isHydrating ? ($445d0804e4c539a4$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($445d0804e4c539a4$var$nextHydratableInstance = fiber.stateNode)) : ($445d0804e4c539a4$var$popToNextHostParent(fiber), $445d0804e4c539a4$var$isHydrating = !0));
        default:
            $445d0804e4c539a4$var$unwindInterruptedWork(current, next), next = $445d0804e4c539a4$var$workInProgress = $445d0804e4c539a4$var$resetWorkInProgress(next, $445d0804e4c539a4$var$entangledRenderLanes), next = $445d0804e4c539a4$var$beginWork(current, next, $445d0804e4c539a4$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $445d0804e4c539a4$var$completeUnitOfWork(unitOfWork) : $445d0804e4c539a4$var$workInProgress = next;
}
function $445d0804e4c539a4$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $445d0804e4c539a4$var$lastContextDependency = $445d0804e4c539a4$var$currentlyRenderingFiber$1 = null;
    $445d0804e4c539a4$var$resetHooksOnUnwind(unitOfWork);
    $445d0804e4c539a4$var$thenableState$1 = null;
    $445d0804e4c539a4$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($445d0804e4c539a4$var$throwException(root, returnFiber, unitOfWork, thrownValue, $445d0804e4c539a4$var$workInProgressRootRenderLanes)) {
            $445d0804e4c539a4$var$workInProgressRootExitStatus = 1;
            $445d0804e4c539a4$var$logUncaughtError(root, $445d0804e4c539a4$var$createCapturedValueAtFiber(thrownValue, root.current));
            $445d0804e4c539a4$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $445d0804e4c539a4$var$workInProgress = returnFiber, error;
        $445d0804e4c539a4$var$workInProgressRootExitStatus = 1;
        $445d0804e4c539a4$var$logUncaughtError(root, $445d0804e4c539a4$var$createCapturedValueAtFiber(thrownValue, root.current));
        $445d0804e4c539a4$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($445d0804e4c539a4$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($445d0804e4c539a4$var$workInProgressRootIsPrerendering || 0 !== ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $445d0804e4c539a4$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $445d0804e4c539a4$var$unwindUnitOfWork(unitOfWork, root);
    } else $445d0804e4c539a4$var$completeUnitOfWork(unitOfWork);
}
function $445d0804e4c539a4$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $445d0804e4c539a4$var$unwindUnitOfWork(completedWork, $445d0804e4c539a4$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $445d0804e4c539a4$var$completeWork(completedWork.alternate, completedWork, $445d0804e4c539a4$var$entangledRenderLanes);
        if (null !== next) {
            $445d0804e4c539a4$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $445d0804e4c539a4$var$workInProgress = completedWork;
            return;
        }
        $445d0804e4c539a4$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $445d0804e4c539a4$var$workInProgressRootExitStatus && ($445d0804e4c539a4$var$workInProgressRootExitStatus = 5);
}
function $445d0804e4c539a4$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $445d0804e4c539a4$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $445d0804e4c539a4$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $445d0804e4c539a4$var$workInProgress = unitOfWork;
            return;
        }
        $445d0804e4c539a4$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $445d0804e4c539a4$var$workInProgressRootExitStatus = 6;
    $445d0804e4c539a4$var$workInProgress = null;
}
function $445d0804e4c539a4$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $445d0804e4c539a4$var$flushPendingEffects();
    while (0 !== $445d0804e4c539a4$var$pendingEffectsStatus);
    if (0 !== ($445d0804e4c539a4$var$executionContext & 6)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(177));
        root === $445d0804e4c539a4$var$workInProgressRoot && ($445d0804e4c539a4$var$workInProgress = $445d0804e4c539a4$var$workInProgressRoot = null, $445d0804e4c539a4$var$workInProgressRootRenderLanes = 0);
        $445d0804e4c539a4$var$pendingFinishedWork = finishedWork;
        $445d0804e4c539a4$var$pendingEffectsRoot = root;
        $445d0804e4c539a4$var$pendingEffectsLanes = lanes;
        $445d0804e4c539a4$var$pendingPassiveTransitions = transitions;
        $445d0804e4c539a4$var$pendingRecoverableErrors = recoverableErrors;
        $445d0804e4c539a4$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $445d0804e4c539a4$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $445d0804e4c539a4$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $445d0804e4c539a4$var$concurrentlyUpdatedLanes;
    $445d0804e4c539a4$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $445d0804e4c539a4$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($445d0804e4c539a4$var$pendingTransitionTypes = $445d0804e4c539a4$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($445d0804e4c539a4$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $445d0804e4c539a4$var$scheduleCallback$1($445d0804e4c539a4$var$NormalPriority$1, function() {
        $445d0804e4c539a4$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $445d0804e4c539a4$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $445d0804e4c539a4$var$ReactSharedInternals.T;
        $445d0804e4c539a4$var$ReactSharedInternals.T = null;
        updatedLanes = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $445d0804e4c539a4$var$executionContext;
        $445d0804e4c539a4$var$executionContext |= 4;
        try {
            $445d0804e4c539a4$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $445d0804e4c539a4$var$executionContext = suspendedRetryLanes, $445d0804e4c539a4$var$ReactDOMSharedInternals.p = updatedLanes, $445d0804e4c539a4$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $445d0804e4c539a4$var$pendingEffectsStatus = 1;
    $445d0804e4c539a4$var$shouldStartViewTransition ? $445d0804e4c539a4$var$pendingViewTransition = $445d0804e4c539a4$var$startViewTransition(suspendedState, root.containerInfo, $445d0804e4c539a4$var$pendingTransitionTypes, $445d0804e4c539a4$var$flushMutationEffects, $445d0804e4c539a4$var$flushLayoutEffects, $445d0804e4c539a4$var$flushAfterMutationEffects, $445d0804e4c539a4$var$flushSpawnedWork, $445d0804e4c539a4$var$flushPassiveEffects, $445d0804e4c539a4$var$reportViewTransitionError, null, null) : ($445d0804e4c539a4$var$flushMutationEffects(), $445d0804e4c539a4$var$flushLayoutEffects(), $445d0804e4c539a4$var$flushSpawnedWork());
}
function $445d0804e4c539a4$var$reportViewTransitionError(error) {
    if (0 !== $445d0804e4c539a4$var$pendingEffectsStatus) {
        var onRecoverableError = $445d0804e4c539a4$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $445d0804e4c539a4$var$flushAfterMutationEffects() {
    3 === $445d0804e4c539a4$var$pendingEffectsStatus && ($445d0804e4c539a4$var$pendingEffectsStatus = 0, $445d0804e4c539a4$var$commitAfterMutationEffectsOnFiber($445d0804e4c539a4$var$pendingFinishedWork, $445d0804e4c539a4$var$pendingEffectsRoot), $445d0804e4c539a4$var$pendingEffectsStatus = 4);
}
function $445d0804e4c539a4$var$flushMutationEffects() {
    if (1 === $445d0804e4c539a4$var$pendingEffectsStatus) {
        $445d0804e4c539a4$var$pendingEffectsStatus = 0;
        var root = $445d0804e4c539a4$var$pendingEffectsRoot, finishedWork = $445d0804e4c539a4$var$pendingFinishedWork, lanes = $445d0804e4c539a4$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $445d0804e4c539a4$var$ReactSharedInternals.T;
            $445d0804e4c539a4$var$ReactSharedInternals.T = null;
            var previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
            $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $445d0804e4c539a4$var$executionContext;
            $445d0804e4c539a4$var$executionContext |= 4;
            try {
                $445d0804e4c539a4$var$inUpdateViewTransition = $445d0804e4c539a4$var$rootViewTransitionAffected = !1;
                $445d0804e4c539a4$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $445d0804e4c539a4$var$selectionInformation;
                var curFocusedElem = $445d0804e4c539a4$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $445d0804e4c539a4$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $445d0804e4c539a4$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $445d0804e4c539a4$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $445d0804e4c539a4$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $445d0804e4c539a4$var$_enabled = !!$445d0804e4c539a4$var$eventsEnabled;
                $445d0804e4c539a4$var$selectionInformation = $445d0804e4c539a4$var$eventsEnabled = null;
            } finally{
                $445d0804e4c539a4$var$executionContext = prevExecutionContext, $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority, $445d0804e4c539a4$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $445d0804e4c539a4$var$pendingEffectsStatus = 2;
    }
}
function $445d0804e4c539a4$var$flushLayoutEffects() {
    if (2 === $445d0804e4c539a4$var$pendingEffectsStatus) {
        $445d0804e4c539a4$var$pendingEffectsStatus = 0;
        var root = $445d0804e4c539a4$var$pendingEffectsRoot, finishedWork = $445d0804e4c539a4$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $445d0804e4c539a4$var$ReactSharedInternals.T;
            $445d0804e4c539a4$var$ReactSharedInternals.T = null;
            var previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
            $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $445d0804e4c539a4$var$executionContext;
            $445d0804e4c539a4$var$executionContext |= 4;
            try {
                $445d0804e4c539a4$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $445d0804e4c539a4$var$executionContext = prevExecutionContext, $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority, $445d0804e4c539a4$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $445d0804e4c539a4$var$pendingEffectsStatus = 3;
    }
}
function $445d0804e4c539a4$var$flushSpawnedWork() {
    if (4 === $445d0804e4c539a4$var$pendingEffectsStatus || 3 === $445d0804e4c539a4$var$pendingEffectsStatus) {
        $445d0804e4c539a4$var$pendingEffectsStatus = 0;
        var committedViewTransition = $445d0804e4c539a4$var$pendingViewTransition;
        $445d0804e4c539a4$var$pendingViewTransition = null;
        $445d0804e4c539a4$var$requestPaint();
        var root = $445d0804e4c539a4$var$pendingEffectsRoot, finishedWork = $445d0804e4c539a4$var$pendingFinishedWork, lanes = $445d0804e4c539a4$var$pendingEffectsLanes, recoverableErrors = $445d0804e4c539a4$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $445d0804e4c539a4$var$pendingEffectsStatus = 5 : ($445d0804e4c539a4$var$pendingEffectsStatus = 0, $445d0804e4c539a4$var$pendingFinishedWork = $445d0804e4c539a4$var$pendingEffectsRoot = null, $445d0804e4c539a4$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $445d0804e4c539a4$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($445d0804e4c539a4$var$injectedHook && "function" === typeof $445d0804e4c539a4$var$injectedHook.onCommitFiberRoot) try {
            $445d0804e4c539a4$var$injectedHook.onCommitFiberRoot($445d0804e4c539a4$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $445d0804e4c539a4$var$ReactSharedInternals.T;
            passiveSubtreeMask = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
            $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 2;
            $445d0804e4c539a4$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $445d0804e4c539a4$var$ReactSharedInternals.T = finishedWork, $445d0804e4c539a4$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $445d0804e4c539a4$var$pendingViewTransitionEvents;
        onRecoverableError = $445d0804e4c539a4$var$pendingTransitionTypes;
        $445d0804e4c539a4$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($445d0804e4c539a4$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($445d0804e4c539a4$var$pendingEffectsLanes & 3) && $445d0804e4c539a4$var$flushPendingEffects();
        $445d0804e4c539a4$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $445d0804e4c539a4$var$rootWithNestedUpdates ? $445d0804e4c539a4$var$nestedUpdateCount++ : ($445d0804e4c539a4$var$nestedUpdateCount = 0, $445d0804e4c539a4$var$rootWithNestedUpdates = root) : ($445d0804e4c539a4$var$nestedUpdateCount = 0, $445d0804e4c539a4$var$rootWithNestedUpdates = null);
        $445d0804e4c539a4$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $445d0804e4c539a4$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $445d0804e4c539a4$var$releaseCache(remainingLanes)));
}
function $445d0804e4c539a4$var$flushPendingEffects() {
    null !== $445d0804e4c539a4$var$pendingViewTransition && ($445d0804e4c539a4$var$pendingViewTransition.skipTransition(), $445d0804e4c539a4$var$pendingViewTransition = null);
    $445d0804e4c539a4$var$flushMutationEffects();
    $445d0804e4c539a4$var$flushLayoutEffects();
    $445d0804e4c539a4$var$flushSpawnedWork();
    return $445d0804e4c539a4$var$flushPassiveEffects();
}
function $445d0804e4c539a4$var$flushPassiveEffects() {
    if (5 !== $445d0804e4c539a4$var$pendingEffectsStatus) return !1;
    var root = $445d0804e4c539a4$var$pendingEffectsRoot, remainingLanes = $445d0804e4c539a4$var$pendingEffectsRemainingLanes;
    $445d0804e4c539a4$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $445d0804e4c539a4$var$lanesToEventPriority($445d0804e4c539a4$var$pendingEffectsLanes), prevTransition = $445d0804e4c539a4$var$ReactSharedInternals.T, previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
    try {
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $445d0804e4c539a4$var$ReactSharedInternals.T = null;
        renderPriority = $445d0804e4c539a4$var$pendingPassiveTransitions;
        $445d0804e4c539a4$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $445d0804e4c539a4$var$pendingEffectsRoot, lanes = $445d0804e4c539a4$var$pendingEffectsLanes;
        $445d0804e4c539a4$var$pendingEffectsStatus = 0;
        $445d0804e4c539a4$var$pendingFinishedWork = $445d0804e4c539a4$var$pendingEffectsRoot = null;
        $445d0804e4c539a4$var$pendingEffectsLanes = 0;
        if (0 !== ($445d0804e4c539a4$var$executionContext & 6)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(331));
        var prevExecutionContext = $445d0804e4c539a4$var$executionContext;
        $445d0804e4c539a4$var$executionContext |= 4;
        $445d0804e4c539a4$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $445d0804e4c539a4$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $445d0804e4c539a4$var$executionContext = prevExecutionContext;
        $445d0804e4c539a4$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($445d0804e4c539a4$var$injectedHook && "function" === typeof $445d0804e4c539a4$var$injectedHook.onPostCommitFiberRoot) try {
            $445d0804e4c539a4$var$injectedHook.onPostCommitFiberRoot($445d0804e4c539a4$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority, $445d0804e4c539a4$var$ReactSharedInternals.T = prevTransition, $445d0804e4c539a4$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $445d0804e4c539a4$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $445d0804e4c539a4$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $445d0804e4c539a4$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $445d0804e4c539a4$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($445d0804e4c539a4$var$markRootUpdated$1(rootFiber, 2), $445d0804e4c539a4$var$ensureRootIsScheduled(rootFiber));
}
function $445d0804e4c539a4$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $445d0804e4c539a4$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $445d0804e4c539a4$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed || !$445d0804e4c539a4$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $445d0804e4c539a4$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $445d0804e4c539a4$var$createClassErrorUpdate(2);
                instance = $445d0804e4c539a4$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($445d0804e4c539a4$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $445d0804e4c539a4$var$markRootUpdated$1(instance, 2), $445d0804e4c539a4$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $445d0804e4c539a4$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $445d0804e4c539a4$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($445d0804e4c539a4$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $445d0804e4c539a4$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $445d0804e4c539a4$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $445d0804e4c539a4$var$workInProgressRoot === root && ($445d0804e4c539a4$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $445d0804e4c539a4$var$workInProgressRootExitStatus || 3 === $445d0804e4c539a4$var$workInProgressRootExitStatus && ($445d0804e4c539a4$var$workInProgressRootRenderLanes & 62914560) === $445d0804e4c539a4$var$workInProgressRootRenderLanes && 300 > $445d0804e4c539a4$var$now() - $445d0804e4c539a4$var$globalMostRecentFallbackTime ? 0 === ($445d0804e4c539a4$var$executionContext & 2) ? $445d0804e4c539a4$var$prepareFreshStack(root, 0) : $445d0804e4c539a4$var$workInProgressRootPingedLanes |= pingedLanes : $445d0804e4c539a4$var$workInProgressRootPingedLanes |= pingedLanes, $445d0804e4c539a4$var$workInProgressSuspendedRetryLanes === $445d0804e4c539a4$var$workInProgressRootRenderLanes && ($445d0804e4c539a4$var$workInProgressSuspendedRetryLanes = 0));
    $445d0804e4c539a4$var$ensureRootIsScheduled(root);
}
function $445d0804e4c539a4$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $445d0804e4c539a4$var$claimNextRetryLane());
    boundaryFiber = $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($445d0804e4c539a4$var$markRootUpdated$1(boundaryFiber, retryLane), $445d0804e4c539a4$var$ensureRootIsScheduled(boundaryFiber));
}
function $445d0804e4c539a4$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $445d0804e4c539a4$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $445d0804e4c539a4$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $445d0804e4c539a4$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $445d0804e4c539a4$var$scheduleCallback$1(priorityLevel, callback) {
    return $445d0804e4c539a4$var$scheduleCallback$3(priorityLevel, callback);
}
var $445d0804e4c539a4$var$firstScheduledRoot = null, $445d0804e4c539a4$var$lastScheduledRoot = null, $445d0804e4c539a4$var$didScheduleMicrotask = !1, $445d0804e4c539a4$var$mightHavePendingSyncWork = !1, $445d0804e4c539a4$var$isFlushingWork = !1, $445d0804e4c539a4$var$currentEventTransitionLane = 0;
function $445d0804e4c539a4$var$ensureRootIsScheduled(root) {
    root !== $445d0804e4c539a4$var$lastScheduledRoot && null === root.next && (null === $445d0804e4c539a4$var$lastScheduledRoot ? $445d0804e4c539a4$var$firstScheduledRoot = $445d0804e4c539a4$var$lastScheduledRoot = root : $445d0804e4c539a4$var$lastScheduledRoot = $445d0804e4c539a4$var$lastScheduledRoot.next = root);
    $445d0804e4c539a4$var$mightHavePendingSyncWork = !0;
    $445d0804e4c539a4$var$didScheduleMicrotask || ($445d0804e4c539a4$var$didScheduleMicrotask = !0, $445d0804e4c539a4$var$scheduleImmediateRootScheduleTask());
}
function $445d0804e4c539a4$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$445d0804e4c539a4$var$isFlushingWork && $445d0804e4c539a4$var$mightHavePendingSyncWork) {
        $445d0804e4c539a4$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $445d0804e4c539a4$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $445d0804e4c539a4$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $445d0804e4c539a4$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $445d0804e4c539a4$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $445d0804e4c539a4$var$getNextLanes(root$190, root$190 === $445d0804e4c539a4$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $445d0804e4c539a4$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $445d0804e4c539a4$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $445d0804e4c539a4$var$isFlushingWork = !1;
    }
}
function $445d0804e4c539a4$var$processRootScheduleInImmediateTask() {
    $445d0804e4c539a4$var$processRootScheduleInMicrotask();
}
function $445d0804e4c539a4$var$processRootScheduleInMicrotask() {
    $445d0804e4c539a4$var$mightHavePendingSyncWork = $445d0804e4c539a4$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $445d0804e4c539a4$var$currentEventTransitionLane && $445d0804e4c539a4$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $445d0804e4c539a4$var$currentEventTransitionLane);
    for(var currentTime = $445d0804e4c539a4$var$now(), prev = null, root = $445d0804e4c539a4$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $445d0804e4c539a4$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $445d0804e4c539a4$var$firstScheduledRoot = next : prev.next = next, null === next && ($445d0804e4c539a4$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $445d0804e4c539a4$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $445d0804e4c539a4$var$pendingEffectsStatus && 5 !== $445d0804e4c539a4$var$pendingEffectsStatus || $445d0804e4c539a4$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $445d0804e4c539a4$var$currentEventTransitionLane && ($445d0804e4c539a4$var$currentEventTransitionLane = 0);
}
function $445d0804e4c539a4$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $445d0804e4c539a4$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $445d0804e4c539a4$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $445d0804e4c539a4$var$workInProgressRoot;
    suspendedLanes = $445d0804e4c539a4$var$workInProgressRootRenderLanes;
    suspendedLanes = $445d0804e4c539a4$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $445d0804e4c539a4$var$workInProgressSuspendedReason || 9 === $445d0804e4c539a4$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $445d0804e4c539a4$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $445d0804e4c539a4$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $445d0804e4c539a4$var$cancelCallback$1(pingedLanes);
        switch($445d0804e4c539a4$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $445d0804e4c539a4$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $445d0804e4c539a4$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $445d0804e4c539a4$var$IdlePriority;
                break;
            default:
                suspendedLanes = $445d0804e4c539a4$var$NormalPriority$1;
        }
        pingedLanes = $445d0804e4c539a4$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $445d0804e4c539a4$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $445d0804e4c539a4$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $445d0804e4c539a4$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $445d0804e4c539a4$var$pendingEffectsStatus && 5 !== $445d0804e4c539a4$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($445d0804e4c539a4$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $445d0804e4c539a4$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $445d0804e4c539a4$var$getNextLanes(root, root === $445d0804e4c539a4$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $445d0804e4c539a4$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $445d0804e4c539a4$var$scheduleTaskForRootDuringMicrotask(root, $445d0804e4c539a4$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $445d0804e4c539a4$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $445d0804e4c539a4$var$performSyncWorkOnRoot(root, lanes) {
    if ($445d0804e4c539a4$var$flushPendingEffects()) return null;
    $445d0804e4c539a4$var$performWorkOnRoot(root, lanes, !0);
}
function $445d0804e4c539a4$var$scheduleImmediateRootScheduleTask() {
    $445d0804e4c539a4$var$scheduleMicrotask(function() {
        0 !== ($445d0804e4c539a4$var$executionContext & 6) ? $445d0804e4c539a4$var$scheduleCallback$3($445d0804e4c539a4$var$ImmediatePriority, $445d0804e4c539a4$var$processRootScheduleInImmediateTask) : $445d0804e4c539a4$var$processRootScheduleInMicrotask();
    });
}
function $445d0804e4c539a4$var$requestTransitionLane() {
    if (0 === $445d0804e4c539a4$var$currentEventTransitionLane) {
        var actionScopeLane = $445d0804e4c539a4$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $445d0804e4c539a4$var$nextTransitionUpdateLane, $445d0804e4c539a4$var$nextTransitionUpdateLane <<= 1, 0 === ($445d0804e4c539a4$var$nextTransitionUpdateLane & 261888) && ($445d0804e4c539a4$var$nextTransitionUpdateLane = 256));
        $445d0804e4c539a4$var$currentEventTransitionLane = actionScopeLane;
    }
    return $445d0804e4c539a4$var$currentEventTransitionLane;
}
function $445d0804e4c539a4$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $445d0804e4c539a4$var$sanitizeURL(actionProp);
}
function $445d0804e4c539a4$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $445d0804e4c539a4$var$coerceFormActionProp((nativeEventTarget[$445d0804e4c539a4$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$445d0804e4c539a4$var$internalPropsKey] || null) ? $445d0804e4c539a4$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $445d0804e4c539a4$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $445d0804e4c539a4$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $445d0804e4c539a4$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $445d0804e4c539a4$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $445d0804e4c539a4$var$i$jscomp$inline_1667 = 0; $445d0804e4c539a4$var$i$jscomp$inline_1667 < $445d0804e4c539a4$var$simpleEventPluginEvents.length; $445d0804e4c539a4$var$i$jscomp$inline_1667++){
    var $445d0804e4c539a4$var$eventName$jscomp$inline_1668 = $445d0804e4c539a4$var$simpleEventPluginEvents[$445d0804e4c539a4$var$i$jscomp$inline_1667], $445d0804e4c539a4$var$domEventName$jscomp$inline_1669 = $445d0804e4c539a4$var$eventName$jscomp$inline_1668.toLowerCase(), $445d0804e4c539a4$var$capitalizedEvent$jscomp$inline_1670 = $445d0804e4c539a4$var$eventName$jscomp$inline_1668[0].toUpperCase() + $445d0804e4c539a4$var$eventName$jscomp$inline_1668.slice(1);
    $445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$domEventName$jscomp$inline_1669, "on" + $445d0804e4c539a4$var$capitalizedEvent$jscomp$inline_1670);
}
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$ANIMATION_END, "onAnimationEnd");
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$ANIMATION_ITERATION, "onAnimationIteration");
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$ANIMATION_START, "onAnimationStart");
$445d0804e4c539a4$var$registerSimpleEvent("dblclick", "onDoubleClick");
$445d0804e4c539a4$var$registerSimpleEvent("focusin", "onFocus");
$445d0804e4c539a4$var$registerSimpleEvent("focusout", "onBlur");
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$TRANSITION_RUN, "onTransitionRun");
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$TRANSITION_START, "onTransitionStart");
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$TRANSITION_CANCEL, "onTransitionCancel");
$445d0804e4c539a4$var$registerSimpleEvent($445d0804e4c539a4$var$TRANSITION_END, "onTransitionEnd");
$445d0804e4c539a4$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$445d0804e4c539a4$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$445d0804e4c539a4$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$445d0804e4c539a4$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$445d0804e4c539a4$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$445d0804e4c539a4$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$445d0804e4c539a4$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$445d0804e4c539a4$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$445d0804e4c539a4$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$445d0804e4c539a4$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $445d0804e4c539a4$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $445d0804e4c539a4$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($445d0804e4c539a4$var$mediaEventTypes));
function $445d0804e4c539a4$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $445d0804e4c539a4$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $445d0804e4c539a4$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $445d0804e4c539a4$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$445d0804e4c539a4$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$445d0804e4c539a4$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($445d0804e4c539a4$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $445d0804e4c539a4$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $445d0804e4c539a4$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $445d0804e4c539a4$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $445d0804e4c539a4$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$445d0804e4c539a4$var$listeningMarker]) {
        rootContainerElement[$445d0804e4c539a4$var$listeningMarker] = !0;
        $445d0804e4c539a4$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($445d0804e4c539a4$var$nonDelegatedEvents.has(domEventName) || $445d0804e4c539a4$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $445d0804e4c539a4$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$445d0804e4c539a4$var$listeningMarker] || (ownerDocument[$445d0804e4c539a4$var$listeningMarker] = !0, $445d0804e4c539a4$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $445d0804e4c539a4$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($445d0804e4c539a4$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $445d0804e4c539a4$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $445d0804e4c539a4$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $445d0804e4c539a4$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$445d0804e4c539a4$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $445d0804e4c539a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $445d0804e4c539a4$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $445d0804e4c539a4$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $445d0804e4c539a4$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $445d0804e4c539a4$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $445d0804e4c539a4$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticTouchEvent;
                        break;
                    case $445d0804e4c539a4$var$ANIMATION_END:
                    case $445d0804e4c539a4$var$ANIMATION_ITERATION:
                    case $445d0804e4c539a4$var$ANIMATION_START:
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticAnimationEvent;
                        break;
                    case $445d0804e4c539a4$var$TRANSITION_END:
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $445d0804e4c539a4$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $445d0804e4c539a4$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($445d0804e4c539a4$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $445d0804e4c539a4$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($445d0804e4c539a4$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$445d0804e4c539a4$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $445d0804e4c539a4$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $445d0804e4c539a4$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $445d0804e4c539a4$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $445d0804e4c539a4$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $445d0804e4c539a4$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $445d0804e4c539a4$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $445d0804e4c539a4$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $445d0804e4c539a4$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $445d0804e4c539a4$var$getParent) : null;
                        null !== reactName && $445d0804e4c539a4$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $445d0804e4c539a4$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $445d0804e4c539a4$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $445d0804e4c539a4$var$getTargetInstForChangeEvent;
                else if ($445d0804e4c539a4$var$isTextInputElement(reactName)) {
                    if ($445d0804e4c539a4$var$isInputEventSupported) getTargetInstFunc = $445d0804e4c539a4$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $445d0804e4c539a4$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $445d0804e4c539a4$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $445d0804e4c539a4$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $445d0804e4c539a4$var$getTargetInstForChangeEvent) : getTargetInstFunc = $445d0804e4c539a4$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $445d0804e4c539a4$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $445d0804e4c539a4$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($445d0804e4c539a4$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $445d0804e4c539a4$var$activeElement = handleEventFunc, $445d0804e4c539a4$var$activeElementInst = targetInst, $445d0804e4c539a4$var$lastSelection = null;
                    break;
                case "focusout":
                    $445d0804e4c539a4$var$lastSelection = $445d0804e4c539a4$var$activeElementInst = $445d0804e4c539a4$var$activeElement = null;
                    break;
                case "mousedown":
                    $445d0804e4c539a4$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $445d0804e4c539a4$var$mouseDown = !1;
                    $445d0804e4c539a4$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($445d0804e4c539a4$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $445d0804e4c539a4$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($445d0804e4c539a4$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $445d0804e4c539a4$var$isComposing ? $445d0804e4c539a4$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($445d0804e4c539a4$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($445d0804e4c539a4$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $445d0804e4c539a4$var$isComposing && (fallbackData = $445d0804e4c539a4$var$getData()) : ($445d0804e4c539a4$var$root = nativeEventTarget, $445d0804e4c539a4$var$startText = "value" in $445d0804e4c539a4$var$root ? $445d0804e4c539a4$var$root.value : $445d0804e4c539a4$var$root.textContent, $445d0804e4c539a4$var$isComposing = !0)), handleEventFunc = $445d0804e4c539a4$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $445d0804e4c539a4$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $445d0804e4c539a4$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $445d0804e4c539a4$var$canUseTextInputEvent ? $445d0804e4c539a4$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $445d0804e4c539a4$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $445d0804e4c539a4$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $445d0804e4c539a4$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $445d0804e4c539a4$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $445d0804e4c539a4$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $445d0804e4c539a4$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $445d0804e4c539a4$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $445d0804e4c539a4$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($445d0804e4c539a4$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $445d0804e4c539a4$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($445d0804e4c539a4$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $445d0804e4c539a4$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $445d0804e4c539a4$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $445d0804e4c539a4$var$getListener(target, registrationName), null != stateNode && listeners.unshift($445d0804e4c539a4$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $445d0804e4c539a4$var$getListener(target, registrationName), null != stateNode && listeners.push($445d0804e4c539a4$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $445d0804e4c539a4$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $445d0804e4c539a4$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $445d0804e4c539a4$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($445d0804e4c539a4$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($445d0804e4c539a4$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $445d0804e4c539a4$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $445d0804e4c539a4$var$normalizeMarkupForTextOrAttribute(clientText);
    return $445d0804e4c539a4$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $445d0804e4c539a4$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $445d0804e4c539a4$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $445d0804e4c539a4$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $445d0804e4c539a4$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $445d0804e4c539a4$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $445d0804e4c539a4$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $445d0804e4c539a4$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $445d0804e4c539a4$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $445d0804e4c539a4$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $445d0804e4c539a4$var$setProp(domElement, tag, "name", props.name, props, null), $445d0804e4c539a4$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $445d0804e4c539a4$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $445d0804e4c539a4$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($445d0804e4c539a4$var$setProp(domElement, tag, "encType", props.encType, props, null), $445d0804e4c539a4$var$setProp(domElement, tag, "method", props.method, props, null), $445d0804e4c539a4$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $445d0804e4c539a4$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $445d0804e4c539a4$var$noop$1);
            return;
        case "onScroll":
            null != value && $445d0804e4c539a4$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $445d0804e4c539a4$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $445d0804e4c539a4$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("toggle", domElement);
            $445d0804e4c539a4$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $445d0804e4c539a4$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $445d0804e4c539a4$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $445d0804e4c539a4$var$aliases.get(key) || key, $445d0804e4c539a4$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
}
function $445d0804e4c539a4$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $445d0804e4c539a4$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $445d0804e4c539a4$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $445d0804e4c539a4$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $445d0804e4c539a4$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $445d0804e4c539a4$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $445d0804e4c539a4$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$445d0804e4c539a4$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$445d0804e4c539a4$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $445d0804e4c539a4$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $445d0804e4c539a4$var$viewTransitionMutationContext = !0;
}
function $445d0804e4c539a4$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("error", domElement);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($445d0804e4c539a4$var$formatProdErrorMessage(137, tag));
                    default:
                        $445d0804e4c539a4$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $445d0804e4c539a4$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $445d0804e4c539a4$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $445d0804e4c539a4$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $445d0804e4c539a4$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $445d0804e4c539a4$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $445d0804e4c539a4$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(91));
                    break;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $445d0804e4c539a4$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("toggle", domElement);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("cancel", domElement);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $445d0804e4c539a4$var$mediaEventTypes.length; hasSrc++)$445d0804e4c539a4$var$listenToNonDelegatedEvent($445d0804e4c539a4$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("error", domElement);
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $445d0804e4c539a4$var$listenToNonDelegatedEvent("error", domElement), $445d0804e4c539a4$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($445d0804e4c539a4$var$formatProdErrorMessage(137, tag));
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($445d0804e4c539a4$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $445d0804e4c539a4$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $445d0804e4c539a4$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $445d0804e4c539a4$var$emptyProps = {};
function $445d0804e4c539a4$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $445d0804e4c539a4$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $445d0804e4c539a4$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $445d0804e4c539a4$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $445d0804e4c539a4$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $445d0804e4c539a4$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $445d0804e4c539a4$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $445d0804e4c539a4$var$updateOptions(domElement, !!lastProps, tag, !0) : $445d0804e4c539a4$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $445d0804e4c539a4$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $445d0804e4c539a4$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($445d0804e4c539a4$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $445d0804e4c539a4$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $445d0804e4c539a4$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($445d0804e4c539a4$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $445d0804e4c539a4$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $445d0804e4c539a4$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $445d0804e4c539a4$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $445d0804e4c539a4$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $445d0804e4c539a4$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $445d0804e4c539a4$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $445d0804e4c539a4$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $445d0804e4c539a4$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $445d0804e4c539a4$var$eventsEnabled = null, $445d0804e4c539a4$var$selectionInformation = null;
function $445d0804e4c539a4$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $445d0804e4c539a4$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $445d0804e4c539a4$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $445d0804e4c539a4$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $445d0804e4c539a4$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$445d0804e4c539a4$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$445d0804e4c539a4$var$internalPropsKey] = props;
    $445d0804e4c539a4$var$setInitialProperties(rootContainerInstance, type, props);
    $445d0804e4c539a4$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $445d0804e4c539a4$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $445d0804e4c539a4$var$currentPopstateTransitionEvent = null;
function $445d0804e4c539a4$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $445d0804e4c539a4$var$currentPopstateTransitionEvent) return !1;
        $445d0804e4c539a4$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $445d0804e4c539a4$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $445d0804e4c539a4$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $445d0804e4c539a4$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $445d0804e4c539a4$var$localPromise = "function" === typeof Promise ? Promise : void 0, $445d0804e4c539a4$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $445d0804e4c539a4$var$scheduleTimeout, $445d0804e4c539a4$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $445d0804e4c539a4$var$localPromise ? function(callback) {
    return $445d0804e4c539a4$var$localPromise.resolve(null).then(callback).catch($445d0804e4c539a4$var$handleErrorInNextTick);
} : $445d0804e4c539a4$var$scheduleTimeout;
function $445d0804e4c539a4$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $445d0804e4c539a4$var$isSingletonScope(type) {
    return "head" === type;
}
function $445d0804e4c539a4$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $445d0804e4c539a4$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $445d0804e4c539a4$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $445d0804e4c539a4$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$445d0804e4c539a4$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $445d0804e4c539a4$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $445d0804e4c539a4$var$retryIfBlockedOn(hydrationInstance);
}
function $445d0804e4c539a4$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $445d0804e4c539a4$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $445d0804e4c539a4$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $445d0804e4c539a4$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $445d0804e4c539a4$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $445d0804e4c539a4$var$createMeasurement(rect, computedStyle, instance);
}
function $445d0804e4c539a4$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $445d0804e4c539a4$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $445d0804e4c539a4$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $445d0804e4c539a4$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $445d0804e4c539a4$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($445d0804e4c539a4$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $445d0804e4c539a4$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $445d0804e4c539a4$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($445d0804e4c539a4$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $445d0804e4c539a4$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$445d0804e4c539a4$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $445d0804e4c539a4$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$445d0804e4c539a4$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$445d0804e4c539a4$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $445d0804e4c539a4$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $445d0804e4c539a4$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $445d0804e4c539a4$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $445d0804e4c539a4$var$ViewTransitionPseudoElement("old", name),
        new: new $445d0804e4c539a4$var$ViewTransitionPseudoElement("new", name)
    };
}
function $445d0804e4c539a4$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $445d0804e4c539a4$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $445d0804e4c539a4$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $445d0804e4c539a4$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $445d0804e4c539a4$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $445d0804e4c539a4$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $445d0804e4c539a4$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $445d0804e4c539a4$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $445d0804e4c539a4$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $445d0804e4c539a4$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $445d0804e4c539a4$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $445d0804e4c539a4$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $445d0804e4c539a4$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $445d0804e4c539a4$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $445d0804e4c539a4$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $445d0804e4c539a4$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $445d0804e4c539a4$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$445d0804e4c539a4$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $445d0804e4c539a4$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $445d0804e4c539a4$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $445d0804e4c539a4$var$getInstanceFromHostFiber(fiber);
    return $445d0804e4c539a4$var$setFocusIfFocusable(fiber, focusOptions);
}
$445d0804e4c539a4$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $445d0804e4c539a4$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$445d0804e4c539a4$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $445d0804e4c539a4$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $445d0804e4c539a4$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $445d0804e4c539a4$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $445d0804e4c539a4$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $445d0804e4c539a4$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$observeChild, observer, void 0, void 0);
};
function $445d0804e4c539a4$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $445d0804e4c539a4$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $445d0804e4c539a4$var$pendingIntersectionUnobserves.length; i++){
            var pending = $445d0804e4c539a4$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $445d0804e4c539a4$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $445d0804e4c539a4$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $445d0804e4c539a4$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $445d0804e4c539a4$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $445d0804e4c539a4$var$pendingIntersectionUnobserves = [], $445d0804e4c539a4$var$intersectionUnobserveScheduled = !1;
function $445d0804e4c539a4$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $445d0804e4c539a4$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $445d0804e4c539a4$var$intersectionUnobserveScheduled || ($445d0804e4c539a4$var$intersectionUnobserveScheduled = !0, $445d0804e4c539a4$var$requestPostPaintCallback(function() {
        $445d0804e4c539a4$var$intersectionUnobserveScheduled = !1;
        var pending = $445d0804e4c539a4$var$pendingIntersectionUnobserves;
        $445d0804e4c539a4$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$445d0804e4c539a4$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $445d0804e4c539a4$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $445d0804e4c539a4$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$445d0804e4c539a4$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $445d0804e4c539a4$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$445d0804e4c539a4$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $445d0804e4c539a4$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($445d0804e4c539a4$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $445d0804e4c539a4$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $445d0804e4c539a4$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $445d0804e4c539a4$var$getInstanceFromHostFiber(children[0]);
    result = $445d0804e4c539a4$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $445d0804e4c539a4$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $445d0804e4c539a4$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $445d0804e4c539a4$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $445d0804e4c539a4$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $445d0804e4c539a4$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $445d0804e4c539a4$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $445d0804e4c539a4$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $445d0804e4c539a4$var$searchTarget, $445d0804e4c539a4$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $445d0804e4c539a4$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $445d0804e4c539a4$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $445d0804e4c539a4$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $445d0804e4c539a4$var$searchTarget, $445d0804e4c539a4$var$searchBoundary = $445d0804e4c539a4$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $445d0804e4c539a4$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$445d0804e4c539a4$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(566));
    var children = [];
    $445d0804e4c539a4$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $445d0804e4c539a4$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $445d0804e4c539a4$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $445d0804e4c539a4$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $445d0804e4c539a4$var$getInstanceFromHostFiber(hostSiblings);
            $445d0804e4c539a4$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $445d0804e4c539a4$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $445d0804e4c539a4$var$getInstanceFromHostFiber(child), $445d0804e4c539a4$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $445d0804e4c539a4$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $445d0804e4c539a4$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $445d0804e4c539a4$var$getInstanceFromHostFiber(child);
    $445d0804e4c539a4$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $445d0804e4c539a4$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $445d0804e4c539a4$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $445d0804e4c539a4$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $445d0804e4c539a4$var$pendingIntersectionUnobserves.length; i++){
            var pending = $445d0804e4c539a4$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $445d0804e4c539a4$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $445d0804e4c539a4$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $445d0804e4c539a4$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $445d0804e4c539a4$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $445d0804e4c539a4$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $445d0804e4c539a4$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $445d0804e4c539a4$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $445d0804e4c539a4$var$clearContainerSparingly(node);
                $445d0804e4c539a4$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $445d0804e4c539a4$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$445d0804e4c539a4$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $445d0804e4c539a4$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $445d0804e4c539a4$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $445d0804e4c539a4$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $445d0804e4c539a4$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $445d0804e4c539a4$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $445d0804e4c539a4$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $445d0804e4c539a4$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $445d0804e4c539a4$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $445d0804e4c539a4$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $445d0804e4c539a4$var$previousHydratableOnEnteringScopedSingleton = null;
function $445d0804e4c539a4$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $445d0804e4c539a4$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $445d0804e4c539a4$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $445d0804e4c539a4$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $445d0804e4c539a4$var$requestPostPaintCallback(callback) {
    $445d0804e4c539a4$var$localRequestAnimationFrame(function() {
        $445d0804e4c539a4$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $445d0804e4c539a4$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $445d0804e4c539a4$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(451));
    }
}
function $445d0804e4c539a4$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $445d0804e4c539a4$var$setProp(instance, type, propKey, null, $445d0804e4c539a4$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $445d0804e4c539a4$var$noop$1 && (instance.onclick = null);
    $445d0804e4c539a4$var$detachDeletedInstance(instance);
}
function $445d0804e4c539a4$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $445d0804e4c539a4$var$detachDeletedInstance(instance);
}
var $445d0804e4c539a4$var$preloadPropsMap = new Map(), $445d0804e4c539a4$var$preconnectsSet = new Set();
function $445d0804e4c539a4$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $445d0804e4c539a4$var$previousDispatcher = $445d0804e4c539a4$var$ReactDOMSharedInternals.d;
$445d0804e4c539a4$var$ReactDOMSharedInternals.d = {
    f: $445d0804e4c539a4$var$flushSyncWork,
    r: $445d0804e4c539a4$var$requestFormReset,
    D: $445d0804e4c539a4$var$prefetchDNS,
    C: $445d0804e4c539a4$var$preconnect,
    L: $445d0804e4c539a4$var$preload,
    m: $445d0804e4c539a4$var$preloadModule,
    X: $445d0804e4c539a4$var$preinitScript,
    S: $445d0804e4c539a4$var$preinitStyle,
    M: $445d0804e4c539a4$var$preinitModuleScript
};
function $445d0804e4c539a4$var$flushSyncWork() {
    var previousWasRendering = $445d0804e4c539a4$var$previousDispatcher.f(), wasRendering = $445d0804e4c539a4$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $445d0804e4c539a4$var$requestFormReset(form) {
    var formInst = $445d0804e4c539a4$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $445d0804e4c539a4$var$requestFormReset$1(formInst) : $445d0804e4c539a4$var$previousDispatcher.r(form);
}
var $445d0804e4c539a4$var$globalDocument = "undefined" === typeof document ? null : document;
function $445d0804e4c539a4$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $445d0804e4c539a4$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $445d0804e4c539a4$var$preconnectsSet.has(limitedEscapedHref) || ($445d0804e4c539a4$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $445d0804e4c539a4$var$setInitialProperties(href, "link", rel), $445d0804e4c539a4$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $445d0804e4c539a4$var$prefetchDNS(href) {
    $445d0804e4c539a4$var$previousDispatcher.D(href);
    $445d0804e4c539a4$var$preconnectAs("dns-prefetch", href, null);
}
function $445d0804e4c539a4$var$preconnect(href, crossOrigin) {
    $445d0804e4c539a4$var$previousDispatcher.C(href, crossOrigin);
    $445d0804e4c539a4$var$preconnectAs("preconnect", href, crossOrigin);
}
function $445d0804e4c539a4$var$preload(href, as, options) {
    $445d0804e4c539a4$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $445d0804e4c539a4$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $445d0804e4c539a4$var$getStyleKey(href);
                break;
            case "script":
                key = $445d0804e4c539a4$var$getScriptKey(href);
        }
        if (!($445d0804e4c539a4$var$preloadPropsMap.has(key) || (href = $445d0804e4c539a4$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $445d0804e4c539a4$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($445d0804e4c539a4$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($445d0804e4c539a4$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $445d0804e4c539a4$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$445d0804e4c539a4$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $445d0804e4c539a4$var$clearPendingLoadOnNode(instance);
            });
            $445d0804e4c539a4$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $445d0804e4c539a4$var$preloadModule(href, options) {
    $445d0804e4c539a4$var$previousDispatcher.m(href, options);
    var ownerDocument = $445d0804e4c539a4$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $445d0804e4c539a4$var$getScriptKey(href);
        }
        if (!$445d0804e4c539a4$var$preloadPropsMap.has(key) && (href = $445d0804e4c539a4$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $445d0804e4c539a4$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($445d0804e4c539a4$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $445d0804e4c539a4$var$setInitialProperties(as, "link", href);
            $445d0804e4c539a4$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $445d0804e4c539a4$var$preinitStyle(href, precedence, options) {
    $445d0804e4c539a4$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $445d0804e4c539a4$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $445d0804e4c539a4$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $445d0804e4c539a4$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($445d0804e4c539a4$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $445d0804e4c539a4$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $445d0804e4c539a4$var$preloadPropsMap.get(key)) && $445d0804e4c539a4$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $445d0804e4c539a4$var$markNodeAsHoistable(link);
                $445d0804e4c539a4$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $445d0804e4c539a4$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $445d0804e4c539a4$var$preinitScript(src, options) {
    $445d0804e4c539a4$var$previousDispatcher.X(src, options);
    var ownerDocument = $445d0804e4c539a4$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $445d0804e4c539a4$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $445d0804e4c539a4$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($445d0804e4c539a4$var$getScriptSelectorFromKey(key)), resource || (src = $445d0804e4c539a4$var$assign({
            src: src,
            async: !0
        }, options), (options = $445d0804e4c539a4$var$preloadPropsMap.get(key)) && $445d0804e4c539a4$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $445d0804e4c539a4$var$markNodeAsHoistable(resource), $445d0804e4c539a4$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $445d0804e4c539a4$var$preinitModuleScript(src, options) {
    $445d0804e4c539a4$var$previousDispatcher.M(src, options);
    var ownerDocument = $445d0804e4c539a4$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $445d0804e4c539a4$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $445d0804e4c539a4$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($445d0804e4c539a4$var$getScriptSelectorFromKey(key)), resource || (src = $445d0804e4c539a4$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $445d0804e4c539a4$var$preloadPropsMap.get(key)) && $445d0804e4c539a4$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $445d0804e4c539a4$var$markNodeAsHoistable(resource), $445d0804e4c539a4$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $445d0804e4c539a4$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $445d0804e4c539a4$var$rootInstanceStackCursor.current) ? $445d0804e4c539a4$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $445d0804e4c539a4$var$getStyleKey(pendingProps.href), currentProps = $445d0804e4c539a4$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $445d0804e4c539a4$var$getStyleKey(pendingProps.href);
                var styles$268 = $445d0804e4c539a4$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($445d0804e4c539a4$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $445d0804e4c539a4$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $445d0804e4c539a4$var$preloadPropsMap.set(type, styles$268)), $445d0804e4c539a4$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $445d0804e4c539a4$var$getScriptKey(pendingProps), currentProps = $445d0804e4c539a4$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(444, type));
    }
}
function $445d0804e4c539a4$var$getStyleKey(href) {
    return 'href="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $445d0804e4c539a4$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $445d0804e4c539a4$var$stylesheetPropsFromRawProps(rawProps) {
    return $445d0804e4c539a4$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $445d0804e4c539a4$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$445d0804e4c539a4$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$445d0804e4c539a4$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $445d0804e4c539a4$var$clearPendingLoadOnNode.bind(null, key), $445d0804e4c539a4$var$setInitialProperties(key, "link", preloadProps), $445d0804e4c539a4$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $445d0804e4c539a4$var$getScriptKey(src) {
    return '[src="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $445d0804e4c539a4$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $445d0804e4c539a4$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $445d0804e4c539a4$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $445d0804e4c539a4$var$markNodeAsHoistable(instance), instance;
            var styleProps = $445d0804e4c539a4$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $445d0804e4c539a4$var$markNodeAsHoistable(instance);
            $445d0804e4c539a4$var$setInitialProperties(instance, "style", styleProps);
            $445d0804e4c539a4$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $445d0804e4c539a4$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($445d0804e4c539a4$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $445d0804e4c539a4$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $445d0804e4c539a4$var$stylesheetPropsFromRawProps(props);
            (styleProps = $445d0804e4c539a4$var$preloadPropsMap.get(styleProps)) && $445d0804e4c539a4$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $445d0804e4c539a4$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $445d0804e4c539a4$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $445d0804e4c539a4$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $445d0804e4c539a4$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($445d0804e4c539a4$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $445d0804e4c539a4$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $445d0804e4c539a4$var$preloadPropsMap.get(instance$274)) instance = $445d0804e4c539a4$var$assign({}, props), $445d0804e4c539a4$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $445d0804e4c539a4$var$markNodeAsHoistable(styleProps);
            $445d0804e4c539a4$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($445d0804e4c539a4$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $445d0804e4c539a4$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $445d0804e4c539a4$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $445d0804e4c539a4$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $445d0804e4c539a4$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $445d0804e4c539a4$var$tagCaches = null;
function $445d0804e4c539a4$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $445d0804e4c539a4$var$tagCaches) {
        var cache = new Map();
        var caches = $445d0804e4c539a4$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $445d0804e4c539a4$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$445d0804e4c539a4$var$internalHoistableMarker] || node[$445d0804e4c539a4$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $445d0804e4c539a4$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $445d0804e4c539a4$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $445d0804e4c539a4$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $445d0804e4c539a4$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $445d0804e4c539a4$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $445d0804e4c539a4$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $445d0804e4c539a4$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $445d0804e4c539a4$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $445d0804e4c539a4$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $445d0804e4c539a4$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($445d0804e4c539a4$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $445d0804e4c539a4$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $445d0804e4c539a4$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $445d0804e4c539a4$var$stylesheetPropsFromRawProps(props);
            (key = $445d0804e4c539a4$var$preloadPropsMap.get(key)) && $445d0804e4c539a4$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $445d0804e4c539a4$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $445d0804e4c539a4$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $445d0804e4c539a4$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $445d0804e4c539a4$var$estimatedBytesWithinLimit = 0;
function $445d0804e4c539a4$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $445d0804e4c539a4$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $445d0804e4c539a4$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $445d0804e4c539a4$var$estimatedBytesWithinLimit && ($445d0804e4c539a4$var$estimatedBytesWithinLimit = 62500 * $445d0804e4c539a4$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $445d0804e4c539a4$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $445d0804e4c539a4$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $445d0804e4c539a4$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $445d0804e4c539a4$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $445d0804e4c539a4$var$onUnsuspend() {
    this.count--;
    $445d0804e4c539a4$var$checkIfFullyUnsuspended(this);
}
function $445d0804e4c539a4$var$onUnsuspendImg() {
    this.imgCount--;
    $445d0804e4c539a4$var$checkIfFullyUnsuspended(this);
}
var $445d0804e4c539a4$var$precedencesByRoot = null;
function $445d0804e4c539a4$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $445d0804e4c539a4$var$precedencesByRoot = new Map(), resources.forEach($445d0804e4c539a4$var$insertStylesheetIntoRoot, state), $445d0804e4c539a4$var$precedencesByRoot = null, $445d0804e4c539a4$var$onUnsuspend.call(state));
}
function $445d0804e4c539a4$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $445d0804e4c539a4$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $445d0804e4c539a4$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $445d0804e4c539a4$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $445d0804e4c539a4$var$HostTransitionContext = {
    $$typeof: $445d0804e4c539a4$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $445d0804e4c539a4$var$sharedNotPendingObject,
    _currentValue2: $445d0804e4c539a4$var$sharedNotPendingObject,
    _threadCount: 0
};
function $445d0804e4c539a4$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $445d0804e4c539a4$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $445d0804e4c539a4$var$createLaneMap(0);
    this.hiddenUpdates = $445d0804e4c539a4$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $445d0804e4c539a4$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $445d0804e4c539a4$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $445d0804e4c539a4$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $445d0804e4c539a4$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $445d0804e4c539a4$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $445d0804e4c539a4$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $445d0804e4c539a4$var$emptyContextObject;
    parentComponent = $445d0804e4c539a4$var$emptyContextObject;
    return parentComponent;
}
function $445d0804e4c539a4$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $445d0804e4c539a4$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $445d0804e4c539a4$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $445d0804e4c539a4$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($445d0804e4c539a4$var$scheduleUpdateOnFiber(element, rootFiber, lane), $445d0804e4c539a4$var$entangleTransitions(element, rootFiber, lane));
}
function $445d0804e4c539a4$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $445d0804e4c539a4$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $445d0804e4c539a4$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $445d0804e4c539a4$var$markRetryLaneImpl(fiber, retryLane);
}
function $445d0804e4c539a4$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $445d0804e4c539a4$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $445d0804e4c539a4$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $445d0804e4c539a4$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $445d0804e4c539a4$var$requestUpdateLane();
        lane = $445d0804e4c539a4$var$getBumpedLaneForHydrationByLane(lane);
        var root = $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $445d0804e4c539a4$var$scheduleUpdateOnFiber(root, fiber, lane);
        $445d0804e4c539a4$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $445d0804e4c539a4$var$_enabled = !0;
function $445d0804e4c539a4$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $445d0804e4c539a4$var$ReactSharedInternals.T;
    $445d0804e4c539a4$var$ReactSharedInternals.T = null;
    var previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
    try {
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 2, $445d0804e4c539a4$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority, $445d0804e4c539a4$var$ReactSharedInternals.T = prevTransition;
    }
}
function $445d0804e4c539a4$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $445d0804e4c539a4$var$ReactSharedInternals.T;
    $445d0804e4c539a4$var$ReactSharedInternals.T = null;
    var previousPriority = $445d0804e4c539a4$var$ReactDOMSharedInternals.p;
    try {
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = 8, $445d0804e4c539a4$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $445d0804e4c539a4$var$ReactDOMSharedInternals.p = previousPriority, $445d0804e4c539a4$var$ReactSharedInternals.T = prevTransition;
    }
}
function $445d0804e4c539a4$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($445d0804e4c539a4$var$_enabled) {
        var blockedOn = $445d0804e4c539a4$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $445d0804e4c539a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $445d0804e4c539a4$var$return_targetInst, targetContainer), $445d0804e4c539a4$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($445d0804e4c539a4$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($445d0804e4c539a4$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $445d0804e4c539a4$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $445d0804e4c539a4$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $445d0804e4c539a4$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $445d0804e4c539a4$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $445d0804e4c539a4$var$ensureRootIsScheduled(fiber);
                                0 === ($445d0804e4c539a4$var$executionContext & 6) && ($445d0804e4c539a4$var$workInProgressRootRenderTargetTime = $445d0804e4c539a4$var$now() + 500, $445d0804e4c539a4$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $445d0804e4c539a4$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $445d0804e4c539a4$var$scheduleUpdateOnFiber(root, fiber, 2), $445d0804e4c539a4$var$flushSyncWork$1(), $445d0804e4c539a4$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $445d0804e4c539a4$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $445d0804e4c539a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $445d0804e4c539a4$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $445d0804e4c539a4$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $445d0804e4c539a4$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $445d0804e4c539a4$var$getEventTarget(nativeEvent);
    return $445d0804e4c539a4$var$findInstanceBlockingTarget(nativeEvent);
}
var $445d0804e4c539a4$var$return_targetInst = null;
function $445d0804e4c539a4$var$findInstanceBlockingTarget(targetNode) {
    $445d0804e4c539a4$var$return_targetInst = null;
    targetNode = $445d0804e4c539a4$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $445d0804e4c539a4$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $445d0804e4c539a4$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $445d0804e4c539a4$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $445d0804e4c539a4$var$return_targetInst = targetNode;
    return null;
}
function $445d0804e4c539a4$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($445d0804e4c539a4$var$getCurrentPriorityLevel()){
                case $445d0804e4c539a4$var$ImmediatePriority:
                    return 2;
                case $445d0804e4c539a4$var$UserBlockingPriority:
                    return 8;
                case $445d0804e4c539a4$var$NormalPriority$1:
                case $445d0804e4c539a4$var$LowPriority:
                    return 32;
                case $445d0804e4c539a4$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $445d0804e4c539a4$var$hasScheduledReplayAttempt = !1, $445d0804e4c539a4$var$queuedFocus = null, $445d0804e4c539a4$var$queuedDrag = null, $445d0804e4c539a4$var$queuedMouse = null, $445d0804e4c539a4$var$queuedPointers = new Map(), $445d0804e4c539a4$var$queuedPointerCaptures = new Map(), $445d0804e4c539a4$var$queuedExplicitHydrationTargets = [], $445d0804e4c539a4$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $445d0804e4c539a4$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $445d0804e4c539a4$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $445d0804e4c539a4$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $445d0804e4c539a4$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $445d0804e4c539a4$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $445d0804e4c539a4$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $445d0804e4c539a4$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $445d0804e4c539a4$var$getInstanceFromNode(blockedOn), null !== blockedOn && $445d0804e4c539a4$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $445d0804e4c539a4$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $445d0804e4c539a4$var$queuedFocus = $445d0804e4c539a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($445d0804e4c539a4$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $445d0804e4c539a4$var$queuedDrag = $445d0804e4c539a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($445d0804e4c539a4$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $445d0804e4c539a4$var$queuedMouse = $445d0804e4c539a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($445d0804e4c539a4$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $445d0804e4c539a4$var$queuedPointers.set(pointerId, $445d0804e4c539a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($445d0804e4c539a4$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $445d0804e4c539a4$var$queuedPointerCaptures.set(pointerId, $445d0804e4c539a4$var$accumulateOrCreateContinuousQueuedReplayableEvent($445d0804e4c539a4$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $445d0804e4c539a4$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $445d0804e4c539a4$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $445d0804e4c539a4$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $445d0804e4c539a4$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $445d0804e4c539a4$var$runWithPriority(queuedTarget.priority, function() {
                        $445d0804e4c539a4$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $445d0804e4c539a4$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $445d0804e4c539a4$var$runWithPriority(queuedTarget.priority, function() {
                        $445d0804e4c539a4$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $445d0804e4c539a4$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $445d0804e4c539a4$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $445d0804e4c539a4$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $445d0804e4c539a4$var$currentReplayingEvent = null;
        } else return targetContainers = $445d0804e4c539a4$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $445d0804e4c539a4$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $445d0804e4c539a4$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $445d0804e4c539a4$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $445d0804e4c539a4$var$replayUnblockedEvents() {
    $445d0804e4c539a4$var$hasScheduledReplayAttempt = !1;
    null !== $445d0804e4c539a4$var$queuedFocus && $445d0804e4c539a4$var$attemptReplayContinuousQueuedEvent($445d0804e4c539a4$var$queuedFocus) && ($445d0804e4c539a4$var$queuedFocus = null);
    null !== $445d0804e4c539a4$var$queuedDrag && $445d0804e4c539a4$var$attemptReplayContinuousQueuedEvent($445d0804e4c539a4$var$queuedDrag) && ($445d0804e4c539a4$var$queuedDrag = null);
    null !== $445d0804e4c539a4$var$queuedMouse && $445d0804e4c539a4$var$attemptReplayContinuousQueuedEvent($445d0804e4c539a4$var$queuedMouse) && ($445d0804e4c539a4$var$queuedMouse = null);
    $445d0804e4c539a4$var$queuedPointers.forEach($445d0804e4c539a4$var$attemptReplayContinuousQueuedEventInMap);
    $445d0804e4c539a4$var$queuedPointerCaptures.forEach($445d0804e4c539a4$var$attemptReplayContinuousQueuedEventInMap);
}
function $445d0804e4c539a4$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $445d0804e4c539a4$var$hasScheduledReplayAttempt || ($445d0804e4c539a4$var$hasScheduledReplayAttempt = !0, $dK4EW.unstable_scheduleCallback($dK4EW.unstable_NormalPriority, $445d0804e4c539a4$var$replayUnblockedEvents)));
}
var $445d0804e4c539a4$var$lastScheduledReplayQueue = null;
function $445d0804e4c539a4$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $445d0804e4c539a4$var$lastScheduledReplayQueue !== formReplayingQueue && ($445d0804e4c539a4$var$lastScheduledReplayQueue = formReplayingQueue, $dK4EW.unstable_scheduleCallback($dK4EW.unstable_NormalPriority, function() {
        $445d0804e4c539a4$var$lastScheduledReplayQueue === formReplayingQueue && ($445d0804e4c539a4$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $445d0804e4c539a4$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $445d0804e4c539a4$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $445d0804e4c539a4$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $445d0804e4c539a4$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $445d0804e4c539a4$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $445d0804e4c539a4$var$queuedFocus && $445d0804e4c539a4$var$scheduleCallbackIfUnblocked($445d0804e4c539a4$var$queuedFocus, unblocked);
    null !== $445d0804e4c539a4$var$queuedDrag && $445d0804e4c539a4$var$scheduleCallbackIfUnblocked($445d0804e4c539a4$var$queuedDrag, unblocked);
    null !== $445d0804e4c539a4$var$queuedMouse && $445d0804e4c539a4$var$scheduleCallbackIfUnblocked($445d0804e4c539a4$var$queuedMouse, unblocked);
    $445d0804e4c539a4$var$queuedPointers.forEach(unblock);
    $445d0804e4c539a4$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $445d0804e4c539a4$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $445d0804e4c539a4$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $445d0804e4c539a4$var$queuedExplicitHydrationTargets.length && (i = $445d0804e4c539a4$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$445d0804e4c539a4$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $445d0804e4c539a4$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$445d0804e4c539a4$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $445d0804e4c539a4$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$445d0804e4c539a4$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $445d0804e4c539a4$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $445d0804e4c539a4$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $445d0804e4c539a4$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $445d0804e4c539a4$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$445d0804e4c539a4$var$ReactDOMHydrationRoot.prototype.render = $445d0804e4c539a4$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(409));
    var current = root.current, lane = $445d0804e4c539a4$var$requestUpdateLane();
    $445d0804e4c539a4$var$updateContainerImpl(current, lane, children, root, null, null);
};
$445d0804e4c539a4$var$ReactDOMHydrationRoot.prototype.unmount = $445d0804e4c539a4$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $445d0804e4c539a4$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $445d0804e4c539a4$var$flushSyncWork$1();
        container[$445d0804e4c539a4$var$internalContainerInstanceKey] = null;
    }
};
function $445d0804e4c539a4$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$445d0804e4c539a4$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $445d0804e4c539a4$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $445d0804e4c539a4$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $445d0804e4c539a4$var$queuedExplicitHydrationTargets[i].priority; i++);
        $445d0804e4c539a4$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $445d0804e4c539a4$var$attemptExplicitHydrationTarget(target);
    }
};
var $445d0804e4c539a4$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $eF4cA.version;
if ("19.3.1" !== $445d0804e4c539a4$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(527, $445d0804e4c539a4$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$445d0804e4c539a4$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($445d0804e4c539a4$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $445d0804e4c539a4$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $445d0804e4c539a4$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $445d0804e4c539a4$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $445d0804e4c539a4$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $445d0804e4c539a4$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$445d0804e4c539a4$var$hook$jscomp$inline_2587.isDisabled && $445d0804e4c539a4$var$hook$jscomp$inline_2587.supportsFiber) try {
        $445d0804e4c539a4$var$rendererID = $445d0804e4c539a4$var$hook$jscomp$inline_2587.inject($445d0804e4c539a4$var$internals$jscomp$inline_2586), $445d0804e4c539a4$var$injectedHook = $445d0804e4c539a4$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$445d0804e4c539a4$export$882461b6382ed46c = function(container, options) {
    if (!$445d0804e4c539a4$var$isValidContainer(container)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $445d0804e4c539a4$var$defaultOnUncaughtError, onCaughtError = $445d0804e4c539a4$var$defaultOnCaughtError, onRecoverableError = $445d0804e4c539a4$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $445d0804e4c539a4$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $445d0804e4c539a4$var$defaultOnDefaultTransitionIndicator);
    container[$445d0804e4c539a4$var$internalContainerInstanceKey] = options.current;
    $445d0804e4c539a4$var$listenToAllSupportedEvents(container);
    return new $445d0804e4c539a4$var$ReactDOMRoot(options);
};
$445d0804e4c539a4$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$445d0804e4c539a4$var$isValidContainer(container)) throw Error($445d0804e4c539a4$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $445d0804e4c539a4$var$defaultOnUncaughtError, onCaughtError = $445d0804e4c539a4$var$defaultOnCaughtError, onRecoverableError = $445d0804e4c539a4$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $445d0804e4c539a4$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $445d0804e4c539a4$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $445d0804e4c539a4$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $445d0804e4c539a4$var$requestUpdateLane();
    isStrictMode = $445d0804e4c539a4$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $445d0804e4c539a4$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $445d0804e4c539a4$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $445d0804e4c539a4$var$markRootUpdated$1(initialChildren, options);
    $445d0804e4c539a4$var$ensureRootIsScheduled(initialChildren);
    container[$445d0804e4c539a4$var$internalContainerInstanceKey] = initialChildren.current;
    $445d0804e4c539a4$var$listenToAllSupportedEvents(container);
    return new $445d0804e4c539a4$var$ReactDOMHydrationRoot(initialChildren);
};
$445d0804e4c539a4$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("dK4EW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gVPIA"));

});
parcelRegister("gVPIA", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $c53a1661193aa97b$export$c4744153514ff05d, (v) => $c53a1661193aa97b$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $c53a1661193aa97b$export$3e506c1ccc9cc1a7, (v) => $c53a1661193aa97b$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $c53a1661193aa97b$export$e26fe2ed2fa76875, (v) => $c53a1661193aa97b$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $c53a1661193aa97b$export$502329bbf4b505b1, (v) => $c53a1661193aa97b$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $c53a1661193aa97b$export$6e3807111c4874c4, (v) => $c53a1661193aa97b$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $c53a1661193aa97b$export$c27134553091fb3a, (v) => $c53a1661193aa97b$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $c53a1661193aa97b$export$33ee1acdc04fd2a2, (v) => $c53a1661193aa97b$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $c53a1661193aa97b$export$b00a404bbd5edef2, (v) => $c53a1661193aa97b$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $c53a1661193aa97b$export$d66a1c1c77bd778b, (v) => $c53a1661193aa97b$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $c53a1661193aa97b$export$d3dfb8e4810cb555, (v) => $c53a1661193aa97b$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $c53a1661193aa97b$export$72fdf0e06517287b, (v) => $c53a1661193aa97b$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $c53a1661193aa97b$export$816d2913ae6b83b1, (v) => $c53a1661193aa97b$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $c53a1661193aa97b$export$61bcfe829111a1d0, (v) => $c53a1661193aa97b$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $c53a1661193aa97b$export$7ee8c9beb337bc3f, (v) => $c53a1661193aa97b$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $c53a1661193aa97b$export$b5836b71941fa3ed, (v) => $c53a1661193aa97b$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $c53a1661193aa97b$export$cf845f2c119da08a, (v) => $c53a1661193aa97b$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c53a1661193aa97b$export$c4744153514ff05d;
var $c53a1661193aa97b$export$3e506c1ccc9cc1a7;
var $c53a1661193aa97b$export$e26fe2ed2fa76875;
var $c53a1661193aa97b$export$502329bbf4b505b1;
var $c53a1661193aa97b$export$6e3807111c4874c4;
var $c53a1661193aa97b$export$c27134553091fb3a;
var $c53a1661193aa97b$export$33ee1acdc04fd2a2;
var $c53a1661193aa97b$export$b00a404bbd5edef2;
var $c53a1661193aa97b$export$d66a1c1c77bd778b;
var $c53a1661193aa97b$export$d3dfb8e4810cb555;
var $c53a1661193aa97b$export$72fdf0e06517287b;
var $c53a1661193aa97b$export$816d2913ae6b83b1;
var $c53a1661193aa97b$export$61bcfe829111a1d0;
var $c53a1661193aa97b$export$7ee8c9beb337bc3f;
var $c53a1661193aa97b$export$b5836b71941fa3ed;
var $c53a1661193aa97b$export$cf845f2c119da08a;
"use strict";
function $c53a1661193aa97b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $c53a1661193aa97b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $c53a1661193aa97b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $c53a1661193aa97b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $c53a1661193aa97b$var$compare(left, last)) rightIndex < length && 0 > $c53a1661193aa97b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $c53a1661193aa97b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $c53a1661193aa97b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$c53a1661193aa97b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c53a1661193aa97b$var$localPerformance = performance;
    $c53a1661193aa97b$export$c4744153514ff05d = function() {
        return $c53a1661193aa97b$var$localPerformance.now();
    };
} else {
    var $c53a1661193aa97b$var$localDate = Date, $c53a1661193aa97b$var$initialTime = $c53a1661193aa97b$var$localDate.now();
    $c53a1661193aa97b$export$c4744153514ff05d = function() {
        return $c53a1661193aa97b$var$localDate.now() - $c53a1661193aa97b$var$initialTime;
    };
}
var $c53a1661193aa97b$var$taskQueue = [], $c53a1661193aa97b$var$timerQueue = [], $c53a1661193aa97b$var$taskIdCounter = 1, $c53a1661193aa97b$var$currentTask = null, $c53a1661193aa97b$var$currentPriorityLevel = 3, $c53a1661193aa97b$var$isPerformingWork = !1, $c53a1661193aa97b$var$isHostCallbackScheduled = !1, $c53a1661193aa97b$var$isHostTimeoutScheduled = !1, $c53a1661193aa97b$var$needsPaint = !1, $c53a1661193aa97b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $c53a1661193aa97b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $c53a1661193aa97b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $c53a1661193aa97b$var$advanceTimers(currentTime) {
    for(var timer = $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $c53a1661193aa97b$var$pop($c53a1661193aa97b$var$timerQueue);
        else if (timer.startTime <= currentTime) $c53a1661193aa97b$var$pop($c53a1661193aa97b$var$timerQueue), timer.sortIndex = timer.expirationTime, $c53a1661193aa97b$var$push($c53a1661193aa97b$var$taskQueue, timer);
        else break;
        timer = $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$timerQueue);
    }
}
function $c53a1661193aa97b$var$handleTimeout(currentTime) {
    $c53a1661193aa97b$var$isHostTimeoutScheduled = !1;
    $c53a1661193aa97b$var$advanceTimers(currentTime);
    if (!$c53a1661193aa97b$var$isHostCallbackScheduled) {
        if (null !== $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$taskQueue)) $c53a1661193aa97b$var$isHostCallbackScheduled = !0, $c53a1661193aa97b$var$isMessageLoopRunning || ($c53a1661193aa97b$var$isMessageLoopRunning = !0, $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$timerQueue);
            null !== firstTimer && $c53a1661193aa97b$var$requestHostTimeout($c53a1661193aa97b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $c53a1661193aa97b$var$isMessageLoopRunning = !1, $c53a1661193aa97b$var$taskTimeoutID = -1, $c53a1661193aa97b$var$frameInterval = 5, $c53a1661193aa97b$var$startTime = -1;
function $c53a1661193aa97b$var$shouldYieldToHost() {
    return $c53a1661193aa97b$var$needsPaint ? !0 : $c53a1661193aa97b$export$c4744153514ff05d() - $c53a1661193aa97b$var$startTime < $c53a1661193aa97b$var$frameInterval ? !1 : !0;
}
function $c53a1661193aa97b$var$performWorkUntilDeadline() {
    $c53a1661193aa97b$var$needsPaint = !1;
    if ($c53a1661193aa97b$var$isMessageLoopRunning) {
        var currentTime = $c53a1661193aa97b$export$c4744153514ff05d();
        $c53a1661193aa97b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $c53a1661193aa97b$var$isHostCallbackScheduled = !1;
                $c53a1661193aa97b$var$isHostTimeoutScheduled && ($c53a1661193aa97b$var$isHostTimeoutScheduled = !1, $c53a1661193aa97b$var$localClearTimeout($c53a1661193aa97b$var$taskTimeoutID), $c53a1661193aa97b$var$taskTimeoutID = -1);
                $c53a1661193aa97b$var$isPerformingWork = !0;
                var previousPriorityLevel = $c53a1661193aa97b$var$currentPriorityLevel;
                try {
                    b: {
                        $c53a1661193aa97b$var$advanceTimers(currentTime);
                        for($c53a1661193aa97b$var$currentTask = $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$taskQueue); null !== $c53a1661193aa97b$var$currentTask && !($c53a1661193aa97b$var$currentTask.expirationTime > currentTime && $c53a1661193aa97b$var$shouldYieldToHost());){
                            var callback = $c53a1661193aa97b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $c53a1661193aa97b$var$currentTask.callback = null;
                                $c53a1661193aa97b$var$currentPriorityLevel = $c53a1661193aa97b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($c53a1661193aa97b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $c53a1661193aa97b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $c53a1661193aa97b$var$currentTask.callback = continuationCallback;
                                    $c53a1661193aa97b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $c53a1661193aa97b$var$currentTask === $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$taskQueue) && $c53a1661193aa97b$var$pop($c53a1661193aa97b$var$taskQueue);
                                $c53a1661193aa97b$var$advanceTimers(currentTime);
                            } else $c53a1661193aa97b$var$pop($c53a1661193aa97b$var$taskQueue);
                            $c53a1661193aa97b$var$currentTask = $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$taskQueue);
                        }
                        if (null !== $c53a1661193aa97b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$timerQueue);
                            null !== firstTimer && $c53a1661193aa97b$var$requestHostTimeout($c53a1661193aa97b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $c53a1661193aa97b$var$currentTask = null, $c53a1661193aa97b$var$currentPriorityLevel = previousPriorityLevel, $c53a1661193aa97b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline() : $c53a1661193aa97b$var$isMessageLoopRunning = !1;
        }
    }
}
var $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $c53a1661193aa97b$var$localSetImmediate) $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline = function() {
    $c53a1661193aa97b$var$localSetImmediate($c53a1661193aa97b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c53a1661193aa97b$var$channel = new MessageChannel(), $c53a1661193aa97b$var$port = $c53a1661193aa97b$var$channel.port2;
    $c53a1661193aa97b$var$channel.port1.onmessage = $c53a1661193aa97b$var$performWorkUntilDeadline;
    $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline = function() {
        $c53a1661193aa97b$var$port.postMessage(null);
    };
} else $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline = function() {
    $c53a1661193aa97b$var$localSetTimeout($c53a1661193aa97b$var$performWorkUntilDeadline, 0);
};
function $c53a1661193aa97b$var$requestHostTimeout(callback, ms) {
    $c53a1661193aa97b$var$taskTimeoutID = $c53a1661193aa97b$var$localSetTimeout(function() {
        callback($c53a1661193aa97b$export$c4744153514ff05d());
    }, ms);
}
$c53a1661193aa97b$export$3e506c1ccc9cc1a7 = 5;
$c53a1661193aa97b$export$e26fe2ed2fa76875 = 1;
$c53a1661193aa97b$export$502329bbf4b505b1 = 4;
$c53a1661193aa97b$export$6e3807111c4874c4 = 3;
$c53a1661193aa97b$export$c27134553091fb3a = null;
$c53a1661193aa97b$export$33ee1acdc04fd2a2 = 2;
$c53a1661193aa97b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$c53a1661193aa97b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c53a1661193aa97b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$c53a1661193aa97b$export$d3dfb8e4810cb555 = function() {
    return $c53a1661193aa97b$var$currentPriorityLevel;
};
$c53a1661193aa97b$export$72fdf0e06517287b = function(eventHandler) {
    switch($c53a1661193aa97b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $c53a1661193aa97b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $c53a1661193aa97b$var$currentPriorityLevel;
    $c53a1661193aa97b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $c53a1661193aa97b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$c53a1661193aa97b$export$816d2913ae6b83b1 = function() {
    $c53a1661193aa97b$var$needsPaint = !0;
};
$c53a1661193aa97b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $c53a1661193aa97b$var$currentPriorityLevel;
    $c53a1661193aa97b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $c53a1661193aa97b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$c53a1661193aa97b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $c53a1661193aa97b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $c53a1661193aa97b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $c53a1661193aa97b$var$push($c53a1661193aa97b$var$timerQueue, priorityLevel), null === $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$taskQueue) && priorityLevel === $c53a1661193aa97b$var$peek($c53a1661193aa97b$var$timerQueue) && ($c53a1661193aa97b$var$isHostTimeoutScheduled ? ($c53a1661193aa97b$var$localClearTimeout($c53a1661193aa97b$var$taskTimeoutID), $c53a1661193aa97b$var$taskTimeoutID = -1) : $c53a1661193aa97b$var$isHostTimeoutScheduled = !0, $c53a1661193aa97b$var$requestHostTimeout($c53a1661193aa97b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $c53a1661193aa97b$var$push($c53a1661193aa97b$var$taskQueue, priorityLevel), $c53a1661193aa97b$var$isHostCallbackScheduled || $c53a1661193aa97b$var$isPerformingWork || ($c53a1661193aa97b$var$isHostCallbackScheduled = !0, $c53a1661193aa97b$var$isMessageLoopRunning || ($c53a1661193aa97b$var$isMessageLoopRunning = !0, $c53a1661193aa97b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$c53a1661193aa97b$export$b5836b71941fa3ed = $c53a1661193aa97b$var$shouldYieldToHost;
$c53a1661193aa97b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $c53a1661193aa97b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $c53a1661193aa97b$var$currentPriorityLevel;
        $c53a1661193aa97b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $c53a1661193aa97b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("l19Vn", function(module, exports) {
'use strict';
function $f4d163c6b63ab4e8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f4d163c6b63ab4e8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f4d163c6b63ab4e8$var$checkDCE();

module.exports = (parcelRequire("fzDNL"));

});
parcelRegister("fzDNL", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $b568ffa8e28279b2$export$69ce8ef3fe5cead0, (v) => $b568ffa8e28279b2$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $b568ffa8e28279b2$export$3f2684e5d7cb1006, (v) => $b568ffa8e28279b2$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $b568ffa8e28279b2$export$d39a5bbd09211389, (v) => $b568ffa8e28279b2$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $b568ffa8e28279b2$export$cd75ccfd720a3cd4, (v) => $b568ffa8e28279b2$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $b568ffa8e28279b2$export$a0816fa17a9e79be, (v) => $b568ffa8e28279b2$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $b568ffa8e28279b2$export$7292efcadded39f3, (v) => $b568ffa8e28279b2$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $b568ffa8e28279b2$export$da407abadb9b8f86, (v) => $b568ffa8e28279b2$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $b568ffa8e28279b2$export$314cfea32580671c, (v) => $b568ffa8e28279b2$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $b568ffa8e28279b2$export$513ccb98c53b8039, (v) => $b568ffa8e28279b2$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $b568ffa8e28279b2$export$dbca993bc2d264a, (v) => $b568ffa8e28279b2$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $b568ffa8e28279b2$export$4797a8006f0655d0, (v) => $b568ffa8e28279b2$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $b568ffa8e28279b2$export$c78a37762a8d58e1, (v) => $b568ffa8e28279b2$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $b568ffa8e28279b2$export$606f11b2eb45ecc6, (v) => $b568ffa8e28279b2$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $b568ffa8e28279b2$export$f7e8a0bf92324b1e, (v) => $b568ffa8e28279b2$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $b568ffa8e28279b2$export$83d89fbfd8236492, (v) => $b568ffa8e28279b2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b568ffa8e28279b2$export$69ce8ef3fe5cead0;
var $b568ffa8e28279b2$export$3f2684e5d7cb1006;
var $b568ffa8e28279b2$export$d39a5bbd09211389;
var $b568ffa8e28279b2$export$cd75ccfd720a3cd4;
var $b568ffa8e28279b2$export$a0816fa17a9e79be;
var $b568ffa8e28279b2$export$7292efcadded39f3;
var $b568ffa8e28279b2$export$da407abadb9b8f86;
var $b568ffa8e28279b2$export$314cfea32580671c;
var $b568ffa8e28279b2$export$513ccb98c53b8039;
var $b568ffa8e28279b2$export$dbca993bc2d264a;
var $b568ffa8e28279b2$export$4797a8006f0655d0;
var $b568ffa8e28279b2$export$c78a37762a8d58e1;
var $b568ffa8e28279b2$export$606f11b2eb45ecc6;
var $b568ffa8e28279b2$export$f7e8a0bf92324b1e;
var $b568ffa8e28279b2$export$83d89fbfd8236492;
"use strict";

var $eF4cA = parcelRequire("eF4cA");
function $b568ffa8e28279b2$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b568ffa8e28279b2$var$noop() {}
var $b568ffa8e28279b2$var$Internals = {
    d: {
        f: $b568ffa8e28279b2$var$noop,
        r: function() {
            throw Error($b568ffa8e28279b2$var$formatProdErrorMessage(522));
        },
        D: $b568ffa8e28279b2$var$noop,
        C: $b568ffa8e28279b2$var$noop,
        L: $b568ffa8e28279b2$var$noop,
        m: $b568ffa8e28279b2$var$noop,
        X: $b568ffa8e28279b2$var$noop,
        S: $b568ffa8e28279b2$var$noop,
        M: $b568ffa8e28279b2$var$noop
    },
    p: 0,
    findDOMNode: null
}, $b568ffa8e28279b2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b568ffa8e28279b2$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $b568ffa8e28279b2$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $b568ffa8e28279b2$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b568ffa8e28279b2$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $b568ffa8e28279b2$var$REACT_OPTIMISTIC_KEY ? $b568ffa8e28279b2$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $b568ffa8e28279b2$var$ReactSharedInternals = $eF4cA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $b568ffa8e28279b2$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$b568ffa8e28279b2$export$69ce8ef3fe5cead0 = $b568ffa8e28279b2$var$Internals;
$b568ffa8e28279b2$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $b568ffa8e28279b2$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$b568ffa8e28279b2$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($b568ffa8e28279b2$var$formatProdErrorMessage(299));
    return $b568ffa8e28279b2$var$createPortal$1(children, container, null, key);
};
$b568ffa8e28279b2$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $b568ffa8e28279b2$var$ReactSharedInternals.T, previousUpdatePriority = $b568ffa8e28279b2$var$Internals.p;
    try {
        if ($b568ffa8e28279b2$var$ReactSharedInternals.T = null, $b568ffa8e28279b2$var$Internals.p = 2, fn) return fn();
    } finally{
        $b568ffa8e28279b2$var$ReactSharedInternals.T = previousTransition, $b568ffa8e28279b2$var$Internals.p = previousUpdatePriority, $b568ffa8e28279b2$var$Internals.d.f();
    }
};
$b568ffa8e28279b2$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $b568ffa8e28279b2$var$Internals.d.C(href, options));
};
$b568ffa8e28279b2$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $b568ffa8e28279b2$var$Internals.d.D(href);
};
$b568ffa8e28279b2$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $b568ffa8e28279b2$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $b568ffa8e28279b2$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $b568ffa8e28279b2$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$b568ffa8e28279b2$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $b568ffa8e28279b2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $b568ffa8e28279b2$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $b568ffa8e28279b2$var$Internals.d.M(href);
    }
};
$b568ffa8e28279b2$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $b568ffa8e28279b2$var$getCrossOriginStringAs(as, options.crossOrigin);
        $b568ffa8e28279b2$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$b568ffa8e28279b2$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $b568ffa8e28279b2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $b568ffa8e28279b2$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $b568ffa8e28279b2$var$Internals.d.m(href);
    }
};
$b568ffa8e28279b2$export$4797a8006f0655d0 = function(form) {
    $b568ffa8e28279b2$var$Internals.d.r(form);
};
$b568ffa8e28279b2$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$b568ffa8e28279b2$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $b568ffa8e28279b2$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$b568ffa8e28279b2$export$f7e8a0bf92324b1e = function() {
    return $b568ffa8e28279b2$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$b568ffa8e28279b2$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("gqoBv", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $bf5228de52cef165$export$306c0aa65ff9ec16, (v) => $bf5228de52cef165$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bf5228de52cef165$export$306c0aa65ff9ec16;
"use strict";

var $eF4cA = parcelRequire("eF4cA");
function $bf5228de52cef165$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $bf5228de52cef165$var$objectIs = "function" === typeof Object.is ? Object.is : $bf5228de52cef165$var$is, $bf5228de52cef165$var$useState = $eF4cA.useState, $bf5228de52cef165$var$useEffect = $eF4cA.useEffect, $bf5228de52cef165$var$useLayoutEffect = $eF4cA.useLayoutEffect, $bf5228de52cef165$var$useDebugValue = $eF4cA.useDebugValue;
function $bf5228de52cef165$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $bf5228de52cef165$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $bf5228de52cef165$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $bf5228de52cef165$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $bf5228de52cef165$var$useEffect(function() {
        $bf5228de52cef165$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $bf5228de52cef165$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $bf5228de52cef165$var$useDebugValue(value);
    return value;
}
function $bf5228de52cef165$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$bf5228de52cef165$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $bf5228de52cef165$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $bf5228de52cef165$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $bf5228de52cef165$var$useSyncExternalStore$1 : $bf5228de52cef165$var$useSyncExternalStore$2;
$bf5228de52cef165$export$306c0aa65ff9ec16 = void 0 !== $eF4cA.useSyncExternalStore ? $eF4cA.useSyncExternalStore : $bf5228de52cef165$var$shim;

});

parcelRegister("jHhWe", function(module, exports) {
module.exports = import("5S2EZ").then(()=>parcelRequire('hMoWK'));

});

parcelRegister("fYHD4", function(module, exports) {
/*! Axios v1.21.0 Copyright (c) 2026 Matt Zabriskie and contributors */ 'use strict';
/**
 * Create a bound version of a function with a specified `this` context
 *
 * @param {Function} fn - The function to bind
 * @param {*} thisArg - The value to be passed as the `this` parameter
 * @returns {Function} A new function that will call the original function with the specified `this` context
 */ function $1281b49b6089594d$var$bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}
// utils is a library of generic helper functions non-specific to axios
const { toString: $1281b49b6089594d$var$toString } = Object.prototype;
const { getPrototypeOf: $1281b49b6089594d$var$getPrototypeOf } = Object;
const { iterator: $1281b49b6089594d$var$iterator, toStringTag: $1281b49b6089594d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $1281b49b6089594d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $1281b49b6089594d$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $1281b49b6089594d$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $1281b49b6089594d$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($1281b49b6089594d$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $1281b49b6089594d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $1281b49b6089594d$var$getPrototypeOf(obj);
        if ($1281b49b6089594d$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($1281b49b6089594d$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $1281b49b6089594d$var$getSafeProp = (obj, prop)=>obj != null && $1281b49b6089594d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $1281b49b6089594d$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $1281b49b6089594d$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $1281b49b6089594d$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $1281b49b6089594d$var$getPrototypeOf(current);
        if ($1281b49b6089594d$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($1281b49b6089594d$var$isUnsafeObjectKey(prop)) continue;
            if (!$1281b49b6089594d$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $1281b49b6089594d$var$kindOf = ((cache)=>(thing)=>{
        const str = $1281b49b6089594d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $1281b49b6089594d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$1281b49b6089594d$var$kindOf(thing) === type;
};
const $1281b49b6089594d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $1281b49b6089594d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $1281b49b6089594d$var$isUndefined = $1281b49b6089594d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $1281b49b6089594d$var$isBuffer(val) {
    return val !== null && !$1281b49b6089594d$var$isUndefined(val) && val.constructor !== null && !$1281b49b6089594d$var$isUndefined(val.constructor) && $1281b49b6089594d$var$isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $1281b49b6089594d$var$isArrayBuffer = $1281b49b6089594d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $1281b49b6089594d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $1281b49b6089594d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $1281b49b6089594d$var$isString = $1281b49b6089594d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $1281b49b6089594d$var$isFunction$1 = $1281b49b6089594d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $1281b49b6089594d$var$isNumber = $1281b49b6089594d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $1281b49b6089594d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $1281b49b6089594d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $1281b49b6089594d$var$isPlainObject = (val)=>{
    if (!$1281b49b6089594d$var$isObject(val)) return false;
    const prototype = $1281b49b6089594d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $1281b49b6089594d$var$getPrototypeOf(prototype) === null) && // Treat own Symbol.toStringTag or Symbol.iterator members as evidence the
    // value is tagged/iterable, ignoring members reachable only through shared
    // or terminal prototype boundaries. This is exactly what
    // hasOwnInPrototypeChain(val, prop) computes here: every prototype admitted
    // above (null, Object.prototype, or a terminal null-prototype template) is
    // a boundary, so the walk never inspects anything but `val`'s own members,
    // and stops before even those when `val` is itself the boundary
    // Object.prototype. Checking that inline avoids allocating the walker's
    // `seen` list twice per call on the mergeConfig / merge hot path.
    ($1281b49b6089594d$var$isPrototypeBoundary(val, prototype, true) || !$1281b49b6089594d$var$hasOwnProperty(val, $1281b49b6089594d$var$toStringTag) && !$1281b49b6089594d$var$hasOwnProperty(val, $1281b49b6089594d$var$iterator));
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $1281b49b6089594d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$1281b49b6089594d$var$isObject(val) || $1281b49b6089594d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $1281b49b6089594d$var$isDate = $1281b49b6089594d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $1281b49b6089594d$var$isFile = $1281b49b6089594d$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $1281b49b6089594d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $1281b49b6089594d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $1281b49b6089594d$var$isBlob = $1281b49b6089594d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $1281b49b6089594d$var$isFileList = $1281b49b6089594d$var$kindOfTest('FileList');
const $1281b49b6089594d$var$isSet = $1281b49b6089594d$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $1281b49b6089594d$var$isStream = (val)=>$1281b49b6089594d$var$isObject(val) && $1281b49b6089594d$var$isFunction$1(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $1281b49b6089594d$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $1281b49b6089594d$var$G = $1281b49b6089594d$var$getGlobal();
const $1281b49b6089594d$var$FormDataCtor = typeof $1281b49b6089594d$var$G.FormData !== 'undefined' ? $1281b49b6089594d$var$G.FormData : undefined;
const $1281b49b6089594d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($1281b49b6089594d$var$FormDataCtor && thing instanceof $1281b49b6089594d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $1281b49b6089594d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$1281b49b6089594d$var$isFunction$1(thing.append)) return false;
    const kind = $1281b49b6089594d$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $1281b49b6089594d$var$isFunction$1(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $1281b49b6089594d$var$isURLSearchParams = $1281b49b6089594d$var$kindOfTest('URLSearchParams');
const [$1281b49b6089594d$var$isReadableStream, $1281b49b6089594d$var$isRequest, $1281b49b6089594d$var$isResponse, $1281b49b6089594d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($1281b49b6089594d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $1281b49b6089594d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $1281b49b6089594d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($1281b49b6089594d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($1281b49b6089594d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $1281b49b6089594d$var$findKey(obj, key) {
    if ($1281b49b6089594d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $1281b49b6089594d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $1281b49b6089594d$var$isContextDefined = (context)=>!$1281b49b6089594d$var$isUndefined(context) && context !== $1281b49b6089594d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $1281b49b6089594d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $1281b49b6089594d$var$isContextDefined(this) && this || {};
    const result = {};
    // Caseless lookup only applies to string keys — symbol keys are
    // identity-matched. Every string key that reaches `result` passes through
    // this index first, so it can never hold two case variants of one key and a
    // lowercase -> key map is exactly what findKey(result, key) would rescan
    // Object.keys(result) for on each assignment.
    const lowerCaseKeys = caseless ? Object.create(null) : null;
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        let targetKey = key;
        if (lowerCaseKeys && typeof key === 'string') {
            const lowerKey = key.toLowerCase();
            const knownKey = lowerCaseKeys[lowerKey];
            // A key recorded but absent from `result` was skipped by skipUndefined;
            // the later spelling wins then, as it does for findKey.
            if (knownKey !== undefined && $1281b49b6089594d$var$hasOwnProperty(result, knownKey)) targetKey = knownKey;
            else lowerCaseKeys[lowerKey] = key;
        }
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $1281b49b6089594d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($1281b49b6089594d$var$isPlainObject(existing) && $1281b49b6089594d$var$isPlainObject(val)) result[targetKey] = $1281b49b6089594d$var$merge(existing, val);
        else if ($1281b49b6089594d$var$isPlainObject(val)) result[targetKey] = $1281b49b6089594d$var$merge({}, val);
        else if ($1281b49b6089594d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$1281b49b6089594d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $1281b49b6089594d$var$isBuffer(source)) continue;
        $1281b49b6089594d$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $1281b49b6089594d$var$isArray(source) || !Object.getOwnPropertySymbols) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($1281b49b6089594d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $1281b49b6089594d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $1281b49b6089594d$var$forEach(b, (val, key)=>{
        if (thisArg && $1281b49b6089594d$var$isFunction$1(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: $1281b49b6089594d$var$bind(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $1281b49b6089594d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $1281b49b6089594d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $1281b49b6089594d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $1281b49b6089594d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $1281b49b6089594d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $1281b49b6089594d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($1281b49b6089594d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!Number.isSafeInteger(i) || i < 0 || i > 0xffffffff) return null;
    // Bound the copy by actual indexed properties, including hidden and inherited
    // members of array-like collections, rather than by the declared length alone.
    const indexes = new Set();
    const seen = new Set();
    let source = thing;
    while(source != null && indexes.size < i){
        if (seen.has(source)) return null;
        seen.add(source);
        const prototype = $1281b49b6089594d$var$getPrototypeOf(source);
        if ($1281b49b6089594d$var$isPrototypeBoundary(source, prototype, source === thing)) break;
        Object.getOwnPropertyNames(source).forEach((key)=>{
            const index = +key;
            if (Number.isInteger(index) && index >= 0 && index < i && String(index) === key && $1281b49b6089594d$var$hasOwnProperty(source, key)) indexes.add(index);
        });
        source = prototype;
    }
    if (indexes.size !== i) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $1281b49b6089594d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $1281b49b6089594d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $1281b49b6089594d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$1281b49b6089594d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $1281b49b6089594d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $1281b49b6089594d$var$isHTMLForm = $1281b49b6089594d$var$kindOfTest('HTMLFormElement');
const $1281b49b6089594d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $1281b49b6089594d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $1281b49b6089594d$var$isRegExp = $1281b49b6089594d$var$kindOfTest('RegExp');
const $1281b49b6089594d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $1281b49b6089594d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $1281b49b6089594d$var$freezeMethods = (obj)=>{
    $1281b49b6089594d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($1281b49b6089594d$var$isFunction$1(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$1281b49b6089594d$var$isFunction$1(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $1281b49b6089594d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $1281b49b6089594d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $1281b49b6089594d$var$noop = ()=>{};
const $1281b49b6089594d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $1281b49b6089594d$var$isSpecCompliantForm(thing) {
    return !!(thing && $1281b49b6089594d$var$isFunction$1(thing.append) && thing[$1281b49b6089594d$var$toStringTag] === 'FormData' && thing[$1281b49b6089594d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $1281b49b6089594d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($1281b49b6089594d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($1281b49b6089594d$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($1281b49b6089594d$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$1281b49b6089594d$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $1281b49b6089594d$var$isArray(source) ? [] : {};
                    $1281b49b6089594d$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$1281b49b6089594d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $1281b49b6089594d$var$isAsyncFn = $1281b49b6089594d$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $1281b49b6089594d$var$isThenable = (thing)=>thing && ($1281b49b6089594d$var$isObject(thing) || $1281b49b6089594d$var$isFunction$1(thing)) && $1281b49b6089594d$var$isFunction$1(thing.then) && $1281b49b6089594d$var$isFunction$1(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $1281b49b6089594d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $1281b49b6089594d$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $1281b49b6089594d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $1281b49b6089594d$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $1281b49b6089594d$var$isFunction$1($1281b49b6089594d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $1281b49b6089594d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($1281b49b6089594d$var$_global) : $1281b49b6089594d$var$_setImmediate;
// *********************
const $1281b49b6089594d$var$isIterable = (thing)=>thing != null && $1281b49b6089594d$var$isFunction$1(thing[$1281b49b6089594d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $1281b49b6089594d$var$isSafeIterable = (thing)=>thing != null && $1281b49b6089594d$var$hasOwnInPrototypeChain(thing, $1281b49b6089594d$var$iterator) && $1281b49b6089594d$var$isIterable(thing);
var $1281b49b6089594d$var$utils$1 = {
    isArray: $1281b49b6089594d$var$isArray,
    isArrayBuffer: $1281b49b6089594d$var$isArrayBuffer,
    isBuffer: $1281b49b6089594d$var$isBuffer,
    isFormData: $1281b49b6089594d$var$isFormData,
    isArrayBufferView: $1281b49b6089594d$var$isArrayBufferView,
    isString: $1281b49b6089594d$var$isString,
    isNumber: $1281b49b6089594d$var$isNumber,
    isBoolean: $1281b49b6089594d$var$isBoolean,
    isObject: $1281b49b6089594d$var$isObject,
    isPlainObject: $1281b49b6089594d$var$isPlainObject,
    isEmptyObject: $1281b49b6089594d$var$isEmptyObject,
    isReadableStream: $1281b49b6089594d$var$isReadableStream,
    isRequest: $1281b49b6089594d$var$isRequest,
    isResponse: $1281b49b6089594d$var$isResponse,
    isHeaders: $1281b49b6089594d$var$isHeaders,
    isUndefined: $1281b49b6089594d$var$isUndefined,
    isDate: $1281b49b6089594d$var$isDate,
    isFile: $1281b49b6089594d$var$isFile,
    isReactNativeBlob: $1281b49b6089594d$var$isReactNativeBlob,
    isReactNative: $1281b49b6089594d$var$isReactNative,
    isBlob: $1281b49b6089594d$var$isBlob,
    isRegExp: $1281b49b6089594d$var$isRegExp,
    isFunction: $1281b49b6089594d$var$isFunction$1,
    isStream: $1281b49b6089594d$var$isStream,
    isURLSearchParams: $1281b49b6089594d$var$isURLSearchParams,
    isTypedArray: $1281b49b6089594d$var$isTypedArray,
    isFileList: $1281b49b6089594d$var$isFileList,
    forEach: $1281b49b6089594d$var$forEach,
    merge: $1281b49b6089594d$var$merge,
    extend: $1281b49b6089594d$var$extend,
    trim: $1281b49b6089594d$var$trim,
    stripBOM: $1281b49b6089594d$var$stripBOM,
    inherits: $1281b49b6089594d$var$inherits,
    toFlatObject: $1281b49b6089594d$var$toFlatObject,
    kindOf: $1281b49b6089594d$var$kindOf,
    kindOfTest: $1281b49b6089594d$var$kindOfTest,
    endsWith: $1281b49b6089594d$var$endsWith,
    toArray: $1281b49b6089594d$var$toArray,
    forEachEntry: $1281b49b6089594d$var$forEachEntry,
    matchAll: $1281b49b6089594d$var$matchAll,
    isHTMLForm: $1281b49b6089594d$var$isHTMLForm,
    hasOwnProperty: $1281b49b6089594d$var$hasOwnProperty,
    hasOwnProp: $1281b49b6089594d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $1281b49b6089594d$var$hasOwnInPrototypeChain,
    getSafeProp: $1281b49b6089594d$var$getSafeProp,
    toSafeFlatObject: $1281b49b6089594d$var$toSafeFlatObject,
    reduceDescriptors: $1281b49b6089594d$var$reduceDescriptors,
    freezeMethods: $1281b49b6089594d$var$freezeMethods,
    toObjectSet: $1281b49b6089594d$var$toObjectSet,
    toCamelCase: $1281b49b6089594d$var$toCamelCase,
    noop: $1281b49b6089594d$var$noop,
    toFiniteNumber: $1281b49b6089594d$var$toFiniteNumber,
    findKey: $1281b49b6089594d$var$findKey,
    global: $1281b49b6089594d$var$_global,
    isContextDefined: $1281b49b6089594d$var$isContextDefined,
    isSpecCompliantForm: $1281b49b6089594d$var$isSpecCompliantForm,
    toJSONObject: $1281b49b6089594d$var$toJSONObject,
    isAsyncFn: $1281b49b6089594d$var$isAsyncFn,
    isThenable: $1281b49b6089594d$var$isThenable,
    setImmediate: $1281b49b6089594d$var$_setImmediate,
    asap: $1281b49b6089594d$var$asap,
    isIterable: $1281b49b6089594d$var$isIterable,
    isSafeIterable: $1281b49b6089594d$var$isSafeIterable
};
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $1281b49b6089594d$var$ignoreDuplicateOf = $1281b49b6089594d$var$utils$1.toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ var $1281b49b6089594d$var$parseHeaders = (rawHeaders)=>{
    // Header names are data, including __proto__; avoid inherited setters.
    const parsed = Object.create(null);
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = $1281b49b6089594d$var$utils$1.hasOwnProp(parsed, key);
        if (!key || hasKey && $1281b49b6089594d$var$utils$1.hasOwnProp($1281b49b6089594d$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};
function $1281b49b6089594d$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $1281b49b6089594d$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $1281b49b6089594d$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $1281b49b6089594d$var$sanitizeValue(value, invalidChars) {
    if ($1281b49b6089594d$var$utils$1.isArray(value)) return value.map((item)=>$1281b49b6089594d$var$sanitizeValue(item, invalidChars));
    return $1281b49b6089594d$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $1281b49b6089594d$var$sanitizeHeaderValue = (value)=>$1281b49b6089594d$var$sanitizeValue(value, $1281b49b6089594d$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $1281b49b6089594d$var$sanitizeByteStringHeaderValue = (value)=>$1281b49b6089594d$var$sanitizeValue(value, $1281b49b6089594d$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $1281b49b6089594d$var$toByteStringHeaderObject(headers) {
    const byteStringHeaders = Object.create(null);
    $1281b49b6089594d$var$utils$1.forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $1281b49b6089594d$var$sanitizeByteStringHeaderValue(value);
    });
    return byteStringHeaders;
}
const $1281b49b6089594d$var$$internals$1 = Symbol('internals');
function $1281b49b6089594d$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $1281b49b6089594d$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return $1281b49b6089594d$var$utils$1.isArray(value) ? value.map($1281b49b6089594d$var$normalizeValue) : $1281b49b6089594d$var$sanitizeHeaderValue(String(value));
}
function $1281b49b6089594d$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $1281b49b6089594d$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $1281b49b6089594d$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $1281b49b6089594d$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $1281b49b6089594d$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $1281b49b6089594d$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $1281b49b6089594d$var$trimOWS(part.slice(0, equals));
        if (!$1281b49b6089594d$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $1281b49b6089594d$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $1281b49b6089594d$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $1281b49b6089594d$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
// `__proto__` is a valid field name, and the one name the uppercase mapping at
// the bottom of this file cannot reach: it is inherited from Object.prototype
// instead of being declared on AxiosHeaders.prototype, so `self.__proto__ = v`
// runs the inherited setter. That silently discards the header, and an array
// value replaces the instance prototype, taking every method with it.
// Store it under the same kind of case variant that mapping uses for `set` and
// `constructor`. Header lookup is caseless, so it reads back under either
// spelling, and no own `__proto__` slot is ever created for a later
// `Object.assign` to copy onto a plain object through the same setter.
const $1281b49b6089594d$var$PROTO_HEADER_SLOT = '__Proto__';
const $1281b49b6089594d$var$headerSlot = (name)=>name === '__proto__' ? $1281b49b6089594d$var$PROTO_HEADER_SLOT : name;
function $1281b49b6089594d$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ($1281b49b6089594d$var$utils$1.isFunction(filter)) return filter.call(context, value, header);
    if (isHeaderNameFilter) value = header;
    if (!$1281b49b6089594d$var$utils$1.isString(value)) return;
    if ($1281b49b6089594d$var$utils$1.isString(filter)) return value.indexOf(filter) !== -1;
    if ($1281b49b6089594d$var$utils$1.isRegExp(filter)) return filter.test(value);
}
function $1281b49b6089594d$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $1281b49b6089594d$var$buildAccessors(obj, header) {
    const accessorName = $1281b49b6089594d$var$utils$1.toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $1281b49b6089594d$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self1 = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $1281b49b6089594d$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = $1281b49b6089594d$var$utils$1.findKey(self1, lHeader);
            if (!key || self1[key] === undefined || _rewrite === true || _rewrite === undefined && self1[key] !== false) self1[$1281b49b6089594d$var$headerSlot(key || _header)] = $1281b49b6089594d$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>$1281b49b6089594d$var$utils$1.forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ($1281b49b6089594d$var$utils$1.isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ($1281b49b6089594d$var$utils$1.isString(header) && (header = header.trim()) && !$1281b49b6089594d$var$isValidHeaderName(header)) setHeaders($1281b49b6089594d$var$parseHeaders(header), valueOrRewrite);
        else if ($1281b49b6089594d$var$utils$1.isObject(header) && $1281b49b6089594d$var$utils$1.isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!$1281b49b6089594d$var$utils$1.isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ($1281b49b6089594d$var$utils$1.hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = $1281b49b6089594d$var$utils$1.isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $1281b49b6089594d$var$normalizeHeader(header);
        if (header) {
            const key = $1281b49b6089594d$var$utils$1.findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $1281b49b6089594d$var$parseTokens(value);
                if ($1281b49b6089594d$var$utils$1.isFunction(parser)) return parser.call(this, value, key);
                if ($1281b49b6089594d$var$utils$1.isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $1281b49b6089594d$var$normalizeHeader(header);
        if (header) {
            const key = $1281b49b6089594d$var$utils$1.findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $1281b49b6089594d$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self1 = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $1281b49b6089594d$var$normalizeHeader(_header);
            if (_header) {
                const key = $1281b49b6089594d$var$utils$1.findKey(self1, _header);
                if (key && (!matcher || $1281b49b6089594d$var$matchHeaderValue(self1, self1[key], key, matcher))) {
                    delete self1[key];
                    deleted = true;
                }
            }
        }
        if ($1281b49b6089594d$var$utils$1.isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $1281b49b6089594d$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self1 = this;
        const headers = Object.create(null);
        $1281b49b6089594d$var$utils$1.forEach(this, (value, header)=>{
            const key = $1281b49b6089594d$var$utils$1.findKey(headers, header);
            if (key) {
                self1[key] = $1281b49b6089594d$var$normalizeValue(value);
                delete self1[header];
                return;
            }
            const normalized = $1281b49b6089594d$var$headerSlot(format ? $1281b49b6089594d$var$formatHeader(header) : String(header).trim());
            if (normalized !== header) delete self1[header];
            self1[normalized] = $1281b49b6089594d$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        $1281b49b6089594d$var$utils$1.forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && $1281b49b6089594d$var$utils$1.isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return $1281b49b6089594d$var$utils$1.isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $1281b49b6089594d$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$1281b49b6089594d$var$$internals$1] = this[$1281b49b6089594d$var$$internals$1] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $1281b49b6089594d$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $1281b49b6089594d$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        $1281b49b6089594d$var$utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$1281b49b6089594d$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
$1281b49b6089594d$var$utils$1.reduceDescriptors($1281b49b6089594d$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
$1281b49b6089594d$var$utils$1.freezeMethods($1281b49b6089594d$var$AxiosHeaders);
const $1281b49b6089594d$var$REDACTED = '[REDACTED ****]';
function $1281b49b6089594d$var$hasOwnOrPrototypeToJSON(source) {
    if ($1281b49b6089594d$var$utils$1.hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ($1281b49b6089594d$var$utils$1.hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $1281b49b6089594d$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ($1281b49b6089594d$var$utils$1.isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof $1281b49b6089594d$var$AxiosHeaders) source = source.toJSON();
        seen.push(source);
        let result;
        if ($1281b49b6089594d$var$utils$1.isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!$1281b49b6089594d$var$utils$1.isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!$1281b49b6089594d$var$utils$1.isPlainObject(source) && $1281b49b6089594d$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $1281b49b6089594d$var$REDACTED : visit(value);
                if (!$1281b49b6089594d$var$utils$1.isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $1281b49b6089594d$var$stringifySafely$1(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $1281b49b6089594d$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $1281b49b6089594d$var$stringifySafely$1(entry.message) : $1281b49b6089594d$var$stringifySafely$1(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
// Shared with `Axios.prototype.request`, which splices the reconstructed
// caller frames in ahead of this marker.
const $1281b49b6089594d$var$CAUSED_BY_SEPARATOR = '\nCaused by: ';
const $1281b49b6089594d$var$$causeStack = Symbol('causeStack');
// Match the section we appended, not marker-like text in an error message or
// a replacement stack supplied by the caller. Do not re-read the cause's stack.
function $1281b49b6089594d$var$getCauseStackIndex(error, stack) {
    const causeStack = $1281b49b6089594d$var$utils$1.hasOwnProp(error, $1281b49b6089594d$var$$causeStack) && error[$1281b49b6089594d$var$$causeStack];
    return causeStack && stack.endsWith(causeStack) ? stack.length - causeStack.length : -1;
}
/**
 * Append the stack of a wrapped error to `target.stack`.
 *
 * `cause` already exposes the original error for tooling that walks the standard
 * cause chain, but many error reporters read `stack` and nothing else. Inlining
 * the wrapped stack there means those reporters surface the underlying failure
 * instead of the axios frames that normalized it (see #6670).
 *
 * Every read is defensive: a custom `Error.prepareStackTrace` hook, a runtime
 * without stack support, or a replaced `stack` property can leave the value
 * missing, non-string, or read-only, and normalizing an error must not throw
 * because of that.
 *
 * @param {Error} target The AxiosError being built.
 * @param {Error} source The error being wrapped.
 *
 * @returns {void}
 */ function $1281b49b6089594d$var$appendCauseStack(target, source) {
    try {
        const sourceStack = source && source.stack;
        if (typeof sourceStack !== 'string' || !sourceStack) return;
        const targetStack = target.stack;
        if (typeof targetStack !== 'string' || !targetStack) return;
        // Each call to `from()` creates a fresh target. Re-wrapping includes the
        // previous stack verbatim, adding one cause section per wrap.
        const causeStack = $1281b49b6089594d$var$CAUSED_BY_SEPARATOR + sourceStack;
        target.stack = targetStack + causeStack;
        Object.defineProperty(target, $1281b49b6089594d$var$$causeStack, {
            __proto__: null,
            value: causeStack
        });
    } catch (e) {
    // Ignore failures from custom stack hooks or un-writable stack properties.
    }
}
class $1281b49b6089594d$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && $1281b49b6089594d$var$utils$1.isArray(error.errors) && error.errors.length) message = $1281b49b6089594d$var$aggregateErrorMessage(error);
        const axiosError = new $1281b49b6089594d$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Inline the wrapped stack for reporters that read only `stack`; the `cause`
        // property above already covers cause-aware tooling.
        $1281b49b6089594d$var$appendCauseStack(axiosError, error);
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && $1281b49b6089594d$var$utils$1.hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = $1281b49b6089594d$var$utils$1.isArray(redactKeys) && redactKeys.length > 0 ? $1281b49b6089594d$var$redactConfig(config, redactKeys) : $1281b49b6089594d$var$utils$1.toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$1281b49b6089594d$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$1281b49b6089594d$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$1281b49b6089594d$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$1281b49b6089594d$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$1281b49b6089594d$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$1281b49b6089594d$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$1281b49b6089594d$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$1281b49b6089594d$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$1281b49b6089594d$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$1281b49b6089594d$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
// eslint-disable-next-line strict
var $1281b49b6089594d$var$httpAdapter = null;
// Default nesting limit shared with the inverse transform (formDataToJSON) so
// the FormData <-> JSON round-trip stays symmetric.
const $1281b49b6089594d$var$DEFAULT_FORM_DATA_MAX_DEPTH = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $1281b49b6089594d$var$isVisitable(thing) {
    return $1281b49b6089594d$var$utils$1.isPlainObject(thing) || $1281b49b6089594d$var$utils$1.isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $1281b49b6089594d$var$removeBrackets(key) {
    return $1281b49b6089594d$var$utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $1281b49b6089594d$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $1281b49b6089594d$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $1281b49b6089594d$var$isFlatArray(arr) {
    return $1281b49b6089594d$var$utils$1.isArray(arr) && !arr.some($1281b49b6089594d$var$isVisitable);
}
const $1281b49b6089594d$var$predicates = $1281b49b6089594d$var$utils$1.toFlatObject($1281b49b6089594d$var$utils$1, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $1281b49b6089594d$var$toFormData(obj, formData, options) {
    if (!$1281b49b6089594d$var$utils$1.isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    const option = (name, fallback)=>{
        const value = $1281b49b6089594d$var$utils$1.getSafeProp(options, name);
        return $1281b49b6089594d$var$utils$1.isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $1281b49b6089594d$var$DEFAULT_FORM_DATA_MAX_DEPTH);
    const useBlob = _Blob && $1281b49b6089594d$var$utils$1.isSpecCompliantForm(formData);
    const stack = [];
    if (!$1281b49b6089594d$var$utils$1.isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ($1281b49b6089594d$var$utils$1.isDate(value)) return value.toISOString();
        if ($1281b49b6089594d$var$utils$1.isBoolean(value)) return value.toString();
        if (!useBlob && $1281b49b6089594d$var$utils$1.isBlob(value)) throw new $1281b49b6089594d$var$AxiosError('Blob is not supported. Use a Buffer instead.');
        if ($1281b49b6089594d$var$utils$1.isArrayBuffer(value) || $1281b49b6089594d$var$utils$1.isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            throw new $1281b49b6089594d$var$AxiosError('Blob is not supported. Use a Buffer instead.', $1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new $1281b49b6089594d$var$AxiosError('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, $1281b49b6089594d$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!$1281b49b6089594d$var$utils$1.isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ($1281b49b6089594d$var$utils$1.isReactNative(formData) && $1281b49b6089594d$var$utils$1.isReactNativeBlob(value)) {
            formData.append($1281b49b6089594d$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ($1281b49b6089594d$var$utils$1.endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ($1281b49b6089594d$var$utils$1.isArray(value) && $1281b49b6089594d$var$isFlatArray(value) || ($1281b49b6089594d$var$utils$1.isFileList(value) || $1281b49b6089594d$var$utils$1.endsWith(key, '[]')) && (arr = $1281b49b6089594d$var$utils$1.toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $1281b49b6089594d$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !($1281b49b6089594d$var$utils$1.isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $1281b49b6089594d$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($1281b49b6089594d$var$isVisitable(value)) return true;
        formData.append($1281b49b6089594d$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($1281b49b6089594d$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $1281b49b6089594d$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ($1281b49b6089594d$var$utils$1.isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        $1281b49b6089594d$var$utils$1.forEach(value, function each(el, key) {
            const result = !($1281b49b6089594d$var$utils$1.isUndefined(el) || el === null) && visitor.call(formData, el, $1281b49b6089594d$var$utils$1.isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!$1281b49b6089594d$var$utils$1.isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $1281b49b6089594d$var$encode$1(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $1281b49b6089594d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && $1281b49b6089594d$var$toFormData(params, this, options);
}
const $1281b49b6089594d$var$prototype = $1281b49b6089594d$var$AxiosURLSearchParams.prototype;
$1281b49b6089594d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$1281b49b6089594d$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $1281b49b6089594d$var$encode$1) : $1281b49b6089594d$var$encode$1;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $1281b49b6089594d$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */ function $1281b49b6089594d$var$buildURL(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = $1281b49b6089594d$var$utils$1.isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = $1281b49b6089594d$var$utils$1.getSafeProp(_options, 'encode') || $1281b49b6089594d$var$encode;
    const serializeFn = $1281b49b6089594d$var$utils$1.getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = $1281b49b6089594d$var$utils$1.isURLSearchParams(params) ? params.toString() : new $1281b49b6089594d$var$AxiosURLSearchParams(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}
const $1281b49b6089594d$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $1281b49b6089594d$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $1281b49b6089594d$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
// Preserve the array-key coercion used before IDs were stored in a Map, without
// treating null, empty strings, or noncanonical numeric strings as ID zero.
function $1281b49b6089594d$var$normalizeHandlerId(id) {
    if (typeof id === 'string' && id !== '' && String(Number(id)) === id) return Number(id);
    return id;
}
function $1281b49b6089594d$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $1281b49b6089594d$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $1281b49b6089594d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$1281b49b6089594d$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$1281b49b6089594d$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $1281b49b6089594d$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$1281b49b6089594d$var$$internals];
        $1281b49b6089594d$var$syncHandlerEntries(this, internals);
        const handlerId = $1281b49b6089594d$var$normalizeHandlerId(id);
        const entry = internals.handlerEntries.get(handlerId);
        if (entry) {
            internals.handlerEntries.delete(handlerId);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $1281b49b6089594d$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $1281b49b6089594d$var$syncHandlerEntries(this, this[$1281b49b6089594d$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$1281b49b6089594d$var$$internals];
        $1281b49b6089594d$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            $1281b49b6089594d$var$utils$1.forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $1281b49b6089594d$var$syncHandlerEntries(this, internals);
                $1281b49b6089594d$var$trimHandlers(this.handlers);
                internals.handlersLength = $1281b49b6089594d$var$countHandlers(this.handlers);
            }
        }
    }
}
var $1281b49b6089594d$var$transitionalDefaults = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true,
    encodeBasicAuthUsername: false
};
var $1281b49b6089594d$var$URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : $1281b49b6089594d$var$AxiosURLSearchParams;
var $1281b49b6089594d$var$FormData$1 = typeof FormData !== 'undefined' ? FormData : null;
var $1281b49b6089594d$var$Blob$1 = typeof Blob !== 'undefined' ? Blob : null;
var $1281b49b6089594d$var$platform$1 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $1281b49b6089594d$var$URLSearchParams$1,
        FormData: $1281b49b6089594d$var$FormData$1,
        Blob: $1281b49b6089594d$var$Blob$1
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};
const $1281b49b6089594d$var$hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1281b49b6089594d$var$_navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1281b49b6089594d$var$hasStandardBrowserEnv = $1281b49b6089594d$var$hasBrowserEnv && (!$1281b49b6089594d$var$_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1281b49b6089594d$var$_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1281b49b6089594d$var$hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1281b49b6089594d$var$origin = $1281b49b6089594d$var$hasBrowserEnv && window.location.href || 'http://localhost';
var $1281b49b6089594d$var$utils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    hasBrowserEnv: $1281b49b6089594d$var$hasBrowserEnv,
    hasStandardBrowserEnv: $1281b49b6089594d$var$hasStandardBrowserEnv,
    hasStandardBrowserWebWorkerEnv: $1281b49b6089594d$var$hasStandardBrowserWebWorkerEnv,
    navigator: $1281b49b6089594d$var$_navigator,
    origin: $1281b49b6089594d$var$origin
});
var $1281b49b6089594d$var$platform = {
    ...$1281b49b6089594d$var$utils,
    ...$1281b49b6089594d$var$platform$1
};
function $1281b49b6089594d$var$toURLEncodedForm(data, options) {
    return $1281b49b6089594d$var$toFormData(data, new $1281b49b6089594d$var$platform.classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ($1281b49b6089594d$var$platform.isNode && $1281b49b6089594d$var$utils$1.isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}
const $1281b49b6089594d$var$MAX_DEPTH = $1281b49b6089594d$var$DEFAULT_FORM_DATA_MAX_DEPTH;
function $1281b49b6089594d$var$throwIfDepthExceeded(index) {
    if (index > $1281b49b6089594d$var$MAX_DEPTH) throw new $1281b49b6089594d$var$AxiosError('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $1281b49b6089594d$var$MAX_DEPTH, $1281b49b6089594d$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $1281b49b6089594d$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $1281b49b6089594d$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $1281b49b6089594d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
function $1281b49b6089594d$var$normalizeArray(value) {
    if (!$1281b49b6089594d$var$utils$1.isArray(value)) return value;
    const keys = Object.keys(value);
    return keys.length !== value.length || keys.some((key, index)=>key !== String(index)) ? $1281b49b6089594d$var$arrayToObject(value) : value;
}
function $1281b49b6089594d$var$normalizeArrays(obj) {
    const pending = [
        obj
    ];
    while(pending.length){
        const target = pending.pop();
        Object.keys(target).forEach((key)=>{
            const value = target[key] = $1281b49b6089594d$var$normalizeArray(target[key]);
            if ($1281b49b6089594d$var$utils$1.isArray(value) || $1281b49b6089594d$var$utils$1.isPlainObject(value)) pending.push(value);
        });
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $1281b49b6089594d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $1281b49b6089594d$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && $1281b49b6089594d$var$utils$1.isArray(target) ? target.length : name;
        if (isLast) {
            if ($1281b49b6089594d$var$utils$1.hasOwnProp(target, name)) {
                target[name] = $1281b49b6089594d$var$normalizeArray(target[name]);
                target[name] = $1281b49b6089594d$var$utils$1.isArray(target[name]) ? target[name].concat(value) : [
                    target[name],
                    value
                ];
            } else target[name] = value;
            return !isNumericKey;
        }
        if (!$1281b49b6089594d$var$utils$1.hasOwnProp(target, name) || !$1281b49b6089594d$var$utils$1.isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && $1281b49b6089594d$var$utils$1.isArray(target[name])) target[name] = $1281b49b6089594d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ($1281b49b6089594d$var$utils$1.isFormData(formData) && $1281b49b6089594d$var$utils$1.isFunction(formData.entries)) {
        const obj = {};
        $1281b49b6089594d$var$utils$1.forEachEntry(formData, (name, value)=>{
            buildPath($1281b49b6089594d$var$parsePropPath(name), value, obj, 0);
        });
        return $1281b49b6089594d$var$normalizeArrays(obj);
    }
    return null;
}
const $1281b49b6089594d$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
const $1281b49b6089594d$var$own = (obj, key)=>obj != null && $1281b49b6089594d$var$utils$1.hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $1281b49b6089594d$var$stringifySafely(rawValue, parser, encoder) {
    if ($1281b49b6089594d$var$utils$1.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $1281b49b6089594d$var$utils$1.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $1281b49b6089594d$var$defaults = {
    transitional: $1281b49b6089594d$var$transitionalDefaults,
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = $1281b49b6089594d$var$utils$1.isObject(data);
            if (isObjectPayload && $1281b49b6089594d$var$utils$1.isHTMLForm(data)) data = new FormData(data);
            const isFormData = $1281b49b6089594d$var$utils$1.isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify($1281b49b6089594d$var$formDataToJSON(data)) : data;
            if ($1281b49b6089594d$var$utils$1.isArrayBuffer(data) || $1281b49b6089594d$var$utils$1.isBuffer(data) || $1281b49b6089594d$var$utils$1.isStream(data) || $1281b49b6089594d$var$utils$1.isFile(data) || $1281b49b6089594d$var$utils$1.isBlob(data) || $1281b49b6089594d$var$utils$1.isReadableStream(data)) return data;
            if ($1281b49b6089594d$var$utils$1.isArrayBufferView(data)) return data.buffer;
            if ($1281b49b6089594d$var$utils$1.isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $1281b49b6089594d$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return $1281b49b6089594d$var$toURLEncodedForm(data, formSerializer).toString();
                if ((isFileList = $1281b49b6089594d$var$utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $1281b49b6089594d$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return $1281b49b6089594d$var$toFormData(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $1281b49b6089594d$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $1281b49b6089594d$var$own(this, 'transitional') || $1281b49b6089594d$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $1281b49b6089594d$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ($1281b49b6089594d$var$utils$1.isResponse(data) || $1281b49b6089594d$var$utils$1.isReadableStream(data)) return data;
            if (data && $1281b49b6089594d$var$utils$1.isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $1281b49b6089594d$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw $1281b49b6089594d$var$AxiosError.from(e, $1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE, this, null, $1281b49b6089594d$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: $1281b49b6089594d$var$platform.classes.FormData,
        Blob: $1281b49b6089594d$var$platform.classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
$1281b49b6089594d$var$utils$1.forEach($1281b49b6089594d$var$methodList, (method)=>{
    $1281b49b6089594d$var$defaults.headers[method] = {};
});
/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */ function $1281b49b6089594d$var$transformData(fns, response) {
    const config = this || $1281b49b6089594d$var$defaults;
    const context = response || config;
    const headers = $1281b49b6089594d$var$AxiosHeaders.from(context.headers);
    let data = context.data;
    $1281b49b6089594d$var$utils$1.forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}
function $1281b49b6089594d$var$isCancel(value) {
    return !!(value && value.__CANCEL__);
}
class $1281b49b6089594d$var$CanceledError extends $1281b49b6089594d$var$AxiosError {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, $1281b49b6089594d$var$AxiosError.ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */ function $1281b49b6089594d$var$settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $1281b49b6089594d$var$AxiosError('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? $1281b49b6089594d$var$AxiosError.ERR_BAD_REQUEST : $1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response));
}
const $1281b49b6089594d$var$urlParserControlCharacters = /[\t\n\r]/g;
/**
 * Match WHATWG URL preprocessing before checking a URL's protocol.
 *
 * @param {string} url
 *
 * @returns {string}
 */ function $1281b49b6089594d$var$normalizeURLForProtocolCheck(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($1281b49b6089594d$var$urlParserControlCharacters, '');
}
function $1281b49b6089594d$var$parseProtocol(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1].toLowerCase() || '';
}
const $1281b49b6089594d$var$decodeCookieValue = (value)=>{
    try {
        return decodeURIComponent(value);
    } catch (e) {
        return value;
    }
};
var $1281b49b6089594d$var$cookies = $1281b49b6089594d$var$platform.hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ($1281b49b6089594d$var$utils$1.isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ($1281b49b6089594d$var$utils$1.isString(path)) cookie.push(`path=${path}`);
        if ($1281b49b6089594d$var$utils$1.isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ($1281b49b6089594d$var$utils$1.isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const cookieString = document.cookie;
        if (!cookieString) return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = cookieString.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return $1281b49b6089594d$var$decodeCookieValue(cookie.slice(eq + 1));
        }
        return null;
    },
    async readAsync (name) {
        try {
            const store = typeof window !== 'undefined' && window.cookieStore;
            if (store && $1281b49b6089594d$var$utils$1.isFunction(store.get)) {
                const cookie = await store.get(name);
                // Both APIs expose stored bytes; preserve Axios's existing URI decoding.
                return cookie ? $1281b49b6089594d$var$decodeCookieValue(cookie.value) : null;
            }
        } catch (e) {
        // Restricted or unavailable storage retains the synchronous fallback.
        }
        return this.read(name);
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    async readAsync () {
        return null;
    },
    remove () {}
};
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $1281b49b6089594d$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $1281b49b6089594d$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
const $1281b49b6089594d$var$progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = $1281b49b6089594d$var$speedometer(50, 250);
    return $1281b49b6089594d$var$throttle((e)=>{
        if (!e || !$1281b49b6089594d$var$utils$1.isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1281b49b6089594d$var$progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1281b49b6089594d$var$asyncDecorator = (fn, scheduler = $1281b49b6089594d$var$utils$1.asap)=>(...args)=>scheduler(()=>fn(...args));
var $1281b49b6089594d$var$isURLSameOrigin = $1281b49b6089594d$var$platform.hasStandardBrowserEnv ? ((origin)=>(url)=>{
        url = new URL(url, document.baseURI || $1281b49b6089594d$var$platform.origin);
        return origin.protocol === url.protocol && origin.host === url.host && origin.port === url.port;
    })(new URL($1281b49b6089594d$var$platform.origin)) : ()=>true;
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ function $1281b49b6089594d$var$isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */ function $1281b49b6089594d$var$combineURLs(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}
const $1281b49b6089594d$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $1281b49b6089594d$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${$1281b49b6089594d$var$REDACTED}`;
    });
}
function $1281b49b6089594d$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${$1281b49b6089594d$var$REDACTED}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${$1281b49b6089594d$var$REDACTED}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$1281b49b6089594d$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $1281b49b6089594d$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $1281b49b6089594d$var$normalizeURLForProtocolCheck(url);
        if ($1281b49b6089594d$var$malformedHttpProtocol.test(normalizedURL)) throw new $1281b49b6089594d$var$AxiosError(`Invalid URL ${JSON.stringify($1281b49b6089594d$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, $1281b49b6089594d$var$AxiosError.ERR_INVALID_URL, config);
    }
}
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */ function $1281b49b6089594d$var$buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $1281b49b6089594d$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !$1281b49b6089594d$var$isAbsoluteURL(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $1281b49b6089594d$var$assertValidHttpProtocolURL(baseURL, config);
        return $1281b49b6089594d$var$combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
}
function $1281b49b6089594d$var$assertParamsAcyclic(params) {
    const pending = [
        {
            value: params
        }
    ];
    const active = new WeakSet();
    const visited = new WeakSet();
    while(pending.length){
        const { value: value, done: done } = pending.pop();
        if (!$1281b49b6089594d$var$utils$1.isPlainObject(value) && !$1281b49b6089594d$var$utils$1.isArray(value)) continue;
        if (done) {
            active.delete(value);
            continue;
        }
        if (active.has(value)) throw new $1281b49b6089594d$var$AxiosError('Circular reference detected in params', $1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION_VALUE);
        if (visited.has(value)) continue;
        visited.add(value);
        active.add(value);
        pending.push({
            value: value,
            done: true
        });
        const keys = Object.keys(value);
        if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) Object.getOwnPropertySymbols(value).forEach((key)=>{
            const descriptor = Object.getOwnPropertyDescriptor(value, key);
            if (descriptor && descriptor.enumerable) keys.push(key);
        });
        // Shallow array elements retain fields filtered during plain-object merges.
        // Inspect reserved data properties without evaluating their accessors.
        keys.forEach((key)=>{
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
                const descriptor = Object.getOwnPropertyDescriptor(value, key);
                if (descriptor && $1281b49b6089594d$var$utils$1.hasOwnProp(descriptor, 'value')) pending.push({
                    value: descriptor.value
                });
            } else pending.push({
                value: value[key]
            });
        });
    }
}
const $1281b49b6089594d$var$headersToObject = (thing)=>thing instanceof $1281b49b6089594d$var$AxiosHeaders ? {
        ...thing
    } : thing;
const $1281b49b6089594d$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>{
        const descriptor = Object.getOwnPropertyDescriptor(thing, symbol);
        return descriptor && descriptor.enumerable;
    }));
    return Object.keys(thing);
};
// Copy params without recursive merges so the serializer remains responsible
// for its depth policy. Only visit defaults that contribute to the result.
function $1281b49b6089594d$var$mergeParams(a, b) {
    const pending = [];
    const copies = new WeakMap();
    const empty = {};
    function copy(target, source) {
        if (!$1281b49b6089594d$var$utils$1.isPlainObject(source)) return $1281b49b6089594d$var$utils$1.isArray(source) ? source.slice() : source;
        const base = $1281b49b6089594d$var$utils$1.isPlainObject(target) ? target : empty;
        let bases = copies.get(source);
        if (!bases) {
            bases = new WeakMap();
            copies.set(source, bases);
        }
        if (bases.has(base)) return bases.get(base);
        const result = {};
        bases.set(base, result);
        pending.push({
            base: base,
            source: source,
            result: result
        });
        return result;
    }
    const result = $1281b49b6089594d$var$utils$1.isUndefined(b) ? copy(undefined, a) : copy(a, b);
    while(pending.length){
        const { base: base, source: source, result: target } = pending.pop();
        const baseKeys = new Set($1281b49b6089594d$var$ownEnumerableKeys(base));
        const sourceKeys = new Set($1281b49b6089594d$var$ownEnumerableKeys(source));
        const keys = new Set([
            ...baseKeys,
            ...sourceKeys
        ]);
        keys.forEach((key)=>{
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
            const hasSource = sourceKeys.has(key);
            const value = hasSource ? source[key] : undefined;
            const previous = (!hasSource || $1281b49b6089594d$var$utils$1.isPlainObject(value)) && baseKeys.has(key) ? base[key] : undefined;
            target[key] = hasSource ? copy(previous, value) : copy(undefined, previous);
        });
    }
    $1281b49b6089594d$var$assertParamsAcyclic(result);
    return result;
}
function $1281b49b6089594d$var$getMergedValue(target, source, prop, caseless) {
    if ($1281b49b6089594d$var$utils$1.isPlainObject(target) && $1281b49b6089594d$var$utils$1.isPlainObject(source)) return $1281b49b6089594d$var$utils$1.merge.call({
        caseless: caseless
    }, target, source);
    else if ($1281b49b6089594d$var$utils$1.isPlainObject(source)) return $1281b49b6089594d$var$utils$1.merge({}, source);
    else if ($1281b49b6089594d$var$utils$1.isArray(source)) return source.slice();
    return source;
}
function $1281b49b6089594d$var$mergeDeepProperties(a, b, prop, caseless) {
    if (!$1281b49b6089594d$var$utils$1.isUndefined(b)) return $1281b49b6089594d$var$getMergedValue(a, b, prop, caseless);
    else if (!$1281b49b6089594d$var$utils$1.isUndefined(a)) return $1281b49b6089594d$var$getMergedValue(undefined, a, prop, caseless);
}
// eslint-disable-next-line consistent-return
function $1281b49b6089594d$var$valueFromConfig2(a, b) {
    if (!$1281b49b6089594d$var$utils$1.isUndefined(b)) return $1281b49b6089594d$var$getMergedValue(undefined, b);
}
// eslint-disable-next-line consistent-return
function $1281b49b6089594d$var$defaultToConfig2(a, b) {
    if (!$1281b49b6089594d$var$utils$1.isUndefined(b)) return $1281b49b6089594d$var$getMergedValue(undefined, b);
    else if (!$1281b49b6089594d$var$utils$1.isUndefined(a)) return $1281b49b6089594d$var$getMergedValue(undefined, a);
}
function $1281b49b6089594d$var$getMergedTransitionalOption(config1, config2, prop) {
    const transitional2 = $1281b49b6089594d$var$utils$1.hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
    if (!$1281b49b6089594d$var$utils$1.isUndefined(transitional2)) {
        if ($1281b49b6089594d$var$utils$1.isPlainObject(transitional2)) {
            if ($1281b49b6089594d$var$utils$1.hasOwnProp(transitional2, prop)) return transitional2[prop];
        } else return undefined;
    }
    const transitional1 = $1281b49b6089594d$var$utils$1.hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
    if ($1281b49b6089594d$var$utils$1.isPlainObject(transitional1) && $1281b49b6089594d$var$utils$1.hasOwnProp(transitional1, prop)) return transitional1[prop];
    return undefined;
}
// eslint-disable-next-line consistent-return
function $1281b49b6089594d$var$mergeDirectKeys(a, b, prop, config1, config2) {
    if ($1281b49b6089594d$var$utils$1.hasOwnProp(config2, prop)) return $1281b49b6089594d$var$getMergedValue(a, b);
    else if ($1281b49b6089594d$var$utils$1.hasOwnProp(config1, prop)) return $1281b49b6089594d$var$getMergedValue(undefined, a);
}
function $1281b49b6089594d$var$mergeHeaders(a, b, prop) {
    return $1281b49b6089594d$var$mergeDeepProperties($1281b49b6089594d$var$headersToObject(a), $1281b49b6089594d$var$headersToObject(b), prop, true);
}
// Null-proto, frozen descriptor so a polluted Object.prototype.get cannot turn
// this data descriptor into an accessor descriptor on the way in.
// defineProperty only reads it, so one shared instance serves every call.
const $1281b49b6089594d$var$hasOwnPropertyDescriptor = Object.freeze({
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: false,
    writable: true,
    configurable: true
});
// The strategy table and the strategies above are stateless, so they are
// built once at module load instead of on every call: mergeConfig runs at
// most twice per request (once from a method alias, once from `_request`).
const $1281b49b6089594d$var$mergeMap = {
    url: $1281b49b6089594d$var$valueFromConfig2,
    method: $1281b49b6089594d$var$valueFromConfig2,
    data: $1281b49b6089594d$var$valueFromConfig2,
    baseURL: $1281b49b6089594d$var$defaultToConfig2,
    transformRequest: $1281b49b6089594d$var$defaultToConfig2,
    transformResponse: $1281b49b6089594d$var$defaultToConfig2,
    params: $1281b49b6089594d$var$mergeParams,
    paramsSerializer: $1281b49b6089594d$var$defaultToConfig2,
    timeout: $1281b49b6089594d$var$defaultToConfig2,
    timeoutErrorMessage: $1281b49b6089594d$var$defaultToConfig2,
    withCredentials: $1281b49b6089594d$var$defaultToConfig2,
    withXSRFToken: $1281b49b6089594d$var$defaultToConfig2,
    adapter: $1281b49b6089594d$var$defaultToConfig2,
    responseType: $1281b49b6089594d$var$defaultToConfig2,
    xsrfCookieName: $1281b49b6089594d$var$defaultToConfig2,
    xsrfHeaderName: $1281b49b6089594d$var$defaultToConfig2,
    onUploadProgress: $1281b49b6089594d$var$defaultToConfig2,
    onDownloadProgress: $1281b49b6089594d$var$defaultToConfig2,
    decompress: $1281b49b6089594d$var$defaultToConfig2,
    maxContentLength: $1281b49b6089594d$var$defaultToConfig2,
    maxBodyLength: $1281b49b6089594d$var$defaultToConfig2,
    beforeRedirect: $1281b49b6089594d$var$defaultToConfig2,
    transport: $1281b49b6089594d$var$defaultToConfig2,
    httpAgent: $1281b49b6089594d$var$defaultToConfig2,
    httpsAgent: $1281b49b6089594d$var$defaultToConfig2,
    cancelToken: $1281b49b6089594d$var$defaultToConfig2,
    socketPath: $1281b49b6089594d$var$defaultToConfig2,
    allowedSocketPaths: $1281b49b6089594d$var$defaultToConfig2,
    responseEncoding: $1281b49b6089594d$var$defaultToConfig2,
    validateStatus: $1281b49b6089594d$var$mergeDirectKeys,
    headers: $1281b49b6089594d$var$mergeHeaders
};
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */ function $1281b49b6089594d$var$mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', $1281b49b6089594d$var$hasOwnPropertyDescriptor);
    const keys = $1281b49b6089594d$var$ownEnumerableKeys({
        ...config1,
        ...config2
    });
    for(let i = 0, len = keys.length; i < len; i++){
        const prop = keys[i];
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') continue;
        const merge = $1281b49b6089594d$var$utils$1.hasOwnProp($1281b49b6089594d$var$mergeMap, prop) ? $1281b49b6089594d$var$mergeMap[prop] : $1281b49b6089594d$var$mergeDeepProperties;
        const a = $1281b49b6089594d$var$utils$1.hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = $1281b49b6089594d$var$utils$1.hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge === $1281b49b6089594d$var$mergeDirectKeys ? merge(a, b, prop, config1, config2) : merge(a, b, prop);
        $1281b49b6089594d$var$utils$1.isUndefined(configValue) && merge !== $1281b49b6089594d$var$mergeDirectKeys || (config[prop] = configValue);
    }
    if ($1281b49b6089594d$var$utils$1.hasOwnProp(config2, 'validateStatus') && $1281b49b6089594d$var$utils$1.isUndefined(config2.validateStatus) && $1281b49b6089594d$var$getMergedTransitionalOption(config1, config2, 'validateStatusUndefinedResolves') === false) {
        if ($1281b49b6089594d$var$utils$1.hasOwnProp(config1, 'validateStatus')) config.validateStatus = $1281b49b6089594d$var$getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}
const $1281b49b6089594d$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
/**
 * Apply the headers generated by a FormData implementation to the request headers,
 * honoring the `formDataHeaderPolicy` option: with 'content-only', copy only the
 * content-* headers; otherwise merge all of them.
 *
 * @param {AxiosHeaders} headers - the request headers to mutate
 * @param {Object | null | undefined} formHeaders - headers produced by the FormData implementation
 * @param {String} [policy] - the resolved `formDataHeaderPolicy` config value
 *
 * @returns {void}
 */ function $1281b49b6089594d$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($1281b49b6089594d$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $1281b49b6089594d$var$encodeUTF8$1 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
const $1281b49b6089594d$var$readCookie = (name)=>$1281b49b6089594d$var$cookies.read(name);
function $1281b49b6089594d$var$resolveConfig(config, readXsrfCookie = $1281b49b6089594d$var$readCookie) {
    const newConfig = $1281b49b6089594d$var$mergeConfig({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>$1281b49b6089594d$var$utils$1.hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = $1281b49b6089594d$var$AxiosHeaders.from(headers);
    newConfig.url = $1281b49b6089594d$var$buildURL($1281b49b6089594d$var$buildFullPath(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = $1281b49b6089594d$var$utils$1.getSafeProp(auth, 'username') || '';
        const password = $1281b49b6089594d$var$utils$1.getSafeProp(auth, 'password') || '';
        const transitional = own('transitional');
        const encodeUsername = transitional && $1281b49b6089594d$var$utils$1.hasOwnProp(transitional, 'encodeBasicAuthUsername') && transitional.encodeBasicAuthUsername === true;
        try {
            headers.set('Authorization', // Preserve legacy username bytes unless the caller opts in to UTF-8.
            'Basic ' + btoa((encodeUsername ? $1281b49b6089594d$var$encodeUTF8$1(username) : username) + ':' + (password ? $1281b49b6089594d$var$encodeUTF8$1(password) : '')));
        } catch (e) {
            throw $1281b49b6089594d$var$AxiosError.from(e, $1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ($1281b49b6089594d$var$utils$1.isFormData(data)) {
        const getHeaders = $1281b49b6089594d$var$utils$1.getSafeProp(data, 'getHeaders');
        if ($1281b49b6089594d$var$platform.hasStandardBrowserEnv || $1281b49b6089594d$var$platform.hasStandardBrowserWebWorkerEnv || $1281b49b6089594d$var$utils$1.isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ($1281b49b6089594d$var$utils$1.isFunction(getHeaders)) // Node.js FormData (like form-data package)
        $1281b49b6089594d$var$setFormDataHeaders(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ($1281b49b6089594d$var$platform.hasStandardBrowserEnv) {
        if ($1281b49b6089594d$var$utils$1.isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && $1281b49b6089594d$var$isURLSameOrigin(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && readXsrfCookie(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
const $1281b49b6089594d$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $1281b49b6089594d$var$xhrAdapter = $1281b49b6089594d$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let useAsyncXsrf;
        try {
            const store = $1281b49b6089594d$var$platform.hasStandardBrowserEnv && typeof window !== 'undefined' && window.cookieStore;
            useAsyncXsrf = store && $1281b49b6089594d$var$utils$1.isFunction(store.get);
        } catch (e) {
        // A restricted Cookie Store getter must retain the synchronous fallback.
        }
        let xsrfCookieName;
        const _config = $1281b49b6089594d$var$resolveConfig(config, useAsyncXsrf ? (name)=>{
            xsrfCookieName = name;
            return null;
        } : undefined);
        let requestData = _config.data;
        const requestHeaders = $1281b49b6089594d$var$AxiosHeaders.from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let timeoutId;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            clearTimeout(timeoutId);
            // A final progress callback must not prevent the remaining cleanup.
            // Report errors asynchronously, as onloadend and the throttle timer do.
            try {
                flushUpload && flushUpload(); // flush events
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            try {
                flushDownload && flushDownload(); // flush events
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A flush can synchronously cancel the request and reenter done().
            // In that case the inner call has already detached these listeners.
            if (request) {
                downloadThrottled && request.removeEventListener('progress', downloadThrottled);
                if (request.upload) {
                    uploadThrottled && request.upload.removeEventListener('progress', uploadThrottled);
                    flushUpload && request.upload.removeEventListener('loadend', flushUpload);
                }
            }
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ($1281b49b6089594d$var$parseProtocol($1281b49b6089594d$var$normalizeURLForProtocolCheck(_config.url)) || $1281b49b6089594d$var$parseProtocol($1281b49b6089594d$var$platform.origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new $1281b49b6089594d$var$AxiosError('Request aborted', $1281b49b6089594d$var$AxiosError.ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = $1281b49b6089594d$var$AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1281b49b6089594d$var$settle(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $1281b49b6089594d$var$AxiosError('Request aborted', $1281b49b6089594d$var$AxiosError.ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new $1281b49b6089594d$var$AxiosError(msg, $1281b49b6089594d$var$AxiosError.ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            if (!request) return;
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || $1281b49b6089594d$var$transitionalDefaults;
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new $1281b49b6089594d$var$AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? $1281b49b6089594d$var$AxiosError.ETIMEDOUT : $1281b49b6089594d$var$AxiosError.ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add withCredentials to request if needed
        if (!$1281b49b6089594d$var$utils$1.isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = $1281b49b6089594d$var$progressEventReducer(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = $1281b49b6089594d$var$progressEventReducer(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new $1281b49b6089594d$var$CanceledError(null, config, request) : cancel);
                const xhr = request;
                done();
                request = null;
                xhr.abort();
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (!request) return;
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        if (!request) return;
        const protocol = $1281b49b6089594d$var$parseProtocol(_config.url);
        if (protocol && !$1281b49b6089594d$var$platform.protocols.includes(protocol)) {
            reject(new $1281b49b6089594d$var$AxiosError('Unsupported protocol ' + protocol + ':', $1281b49b6089594d$var$AxiosError.ERR_BAD_REQUEST, config));
            done();
            return;
        }
        const sendRequest = ()=>{
            if (!request) return;
            // Apply headers after an asynchronous XSRF read so existing headers are
            // replaced through AxiosHeaders rather than appended by the native XHR.
            if ('setRequestHeader' in request) $1281b49b6089594d$var$utils$1.forEach($1281b49b6089594d$var$toByteStringHeaderObject(requestHeaders), function setRequestHeader(val, key) {
                request.setRequestHeader(key, val);
            });
            request.send(requestData || null);
        };
        if (xsrfCookieName) {
            // Native XHR timeout starts at send(). Cover cookie preparation and the
            // subsequent request with the same budget and existing timeout handler.
            const now = typeof performance !== 'undefined' && $1281b49b6089594d$var$utils$1.isFunction(performance.now) ? ()=>performance.now() : Date.now;
            const deadline = request.timeout > 0 ? now() + Number(request.timeout) : undefined;
            const abortOnTimeout = ()=>{
                if (!request) return;
                const xhr = request;
                xhr.ontimeout();
                xhr.abort();
            };
            if (deadline !== undefined) {
                const scheduleTimeout = ()=>{
                    const remaining = deadline - now();
                    if (remaining > 0) // Browser timers overflow above the signed 32-bit delay limit.
                    timeoutId = setTimeout(scheduleTimeout, Math.min(remaining, 0x7fffffff));
                    else abortOnTimeout();
                };
                scheduleTimeout();
            }
            $1281b49b6089594d$var$cookies.readAsync(xsrfCookieName).then((value)=>{
                if (!request) return;
                // Promise callbacks may run before an overdue timer after a busy task.
                if (deadline !== undefined && now() >= deadline) {
                    abortOnTimeout();
                    return;
                }
                if (value) {
                    const headerName = $1281b49b6089594d$var$utils$1.hasOwnProp(_config, 'xsrfHeaderName') && _config.xsrfHeaderName;
                    requestHeaders.set(headerName, value);
                }
                sendRequest();
            }).catch((error)=>{
                if (!request) return;
                reject($1281b49b6089594d$var$AxiosError.from(error, null, config, request));
                done();
                request = null;
            });
        } else sendRequest();
    });
};
const $1281b49b6089594d$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof $1281b49b6089594d$var$AxiosError ? err : new $1281b49b6089594d$var$CanceledError(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new $1281b49b6089594d$var$AxiosError(`timeout of ${timeout}ms exceeded`, $1281b49b6089594d$var$AxiosError.ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            const unsubscribeSignal = $1281b49b6089594d$var$utils$1.getSafeProp(signal, 'unsubscribe');
            $1281b49b6089594d$var$utils$1.isFunction(unsubscribeSignal) ? unsubscribeSignal.call(signal, onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>$1281b49b6089594d$var$utils$1.asap(unsubscribe);
    return signal;
};
const $1281b49b6089594d$var$streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $1281b49b6089594d$var$readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of $1281b49b6089594d$var$readStream(iterable))yield* $1281b49b6089594d$var$streamChunk(chunk, chunkSize);
};
const $1281b49b6089594d$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $1281b49b6089594d$var$trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $1281b49b6089594d$var$readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};
const $1281b49b6089594d$var$CRLF = '\r\n';
const $1281b49b6089594d$var$normalizeLines = (value)=>String(value).replace(/\r\n|\r|\n/g, $1281b49b6089594d$var$CRLF);
const $1281b49b6089594d$var$escapeName = (value)=>String(value).replace(/[\r\n"]/g, (char)=>char === '\r' ? '%0D' : char === '\n' ? '%0A' : '%22');
// Count UTF-8 bytes without allocating an encoded copy of a field. FormData
// string values normalize line endings; Blob/File contents remain unchanged.
const $1281b49b6089594d$var$stringBytes = (value, normalize)=>{
    let length = 0;
    for(let i = 0; i < value.length; i++){
        const code = value.charCodeAt(i);
        if (normalize && (code === 13 || code === 10)) {
            if (code === 13 && value.charCodeAt(i + 1) === 10) i++;
            length += 2;
        } else if (code < 0x80) length++;
        else if (code < 0x800) length += 2;
        else if (code >= 0xd800 && code <= 0xdbff && value.charCodeAt(i + 1) >= 0xdc00 && value.charCodeAt(i + 1) <= 0xdfff) {
            length += 4;
            i++;
        } else length += 3;
    }
    return length;
};
// Describe serialization failures independently of any request library.
class $1281b49b6089594d$var$FormDataError extends TypeError {
    constructor(message, reason){
        super(message);
        this.name = 'FormDataError';
        this.reason = reason;
    }
}
// The caller supplies the boundary, Blob implementation, and limit error.
function $1281b49b6089594d$var$formDataToBlob(form, Blob1, limit, limitError, boundary) {
    if (!$1281b49b6089594d$var$utils$1.isFunction(Blob1)) throw new $1281b49b6089594d$var$FormDataError('Blob is not supported', 'blob');
    if (!$1281b49b6089594d$var$utils$1.isString(boundary) || !/^[A-Za-z0-9'()+_,./:=? -]{1,70}$/.test(boundary) || / $/.test(boundary)) throw new $1281b49b6089594d$var$FormDataError('Invalid multipart boundary', 'boundary');
    const footer = '--' + boundary + '--' + $1281b49b6089594d$var$CRLF;
    let length = footer.length;
    const parts = [];
    const checkLength = (extra)=>{
        if (length + extra > limit) throw limitError();
    };
    checkLength(0);
    for (const [name, value] of form){
        const isString = $1281b49b6089594d$var$utils$1.isString(value);
        const valueLength = isString ? $1281b49b6089594d$var$stringBytes(value, true) : value.size;
        if (!Number.isFinite(valueLength) || valueLength < 0) throw new $1281b49b6089594d$var$FormDataError('Unsupported FormData part size', 'part');
        // Reject large values and names before building normalized header strings.
        checkLength(valueLength + $1281b49b6089594d$var$stringBytes(name, true) + (!isString && value.name ? $1281b49b6089594d$var$stringBytes(value.name, false) : 0) + (!isString && value.type ? $1281b49b6089594d$var$stringBytes(value.type, false) : 0));
        let header = '--' + boundary + $1281b49b6089594d$var$CRLF + 'Content-Disposition: form-data; name="' + $1281b49b6089594d$var$escapeName($1281b49b6089594d$var$normalizeLines(name)) + '"';
        if (!isString) header += '; filename="' + $1281b49b6089594d$var$escapeName($1281b49b6089594d$var$utils$1.isString(value.name) ? value.name : 'blob') + '"' + $1281b49b6089594d$var$CRLF + 'Content-Type: ' + String(value.type || 'application/octet-stream').replace(/[\r\n]/g, '');
        header += $1281b49b6089594d$var$CRLF + $1281b49b6089594d$var$CRLF;
        const partLength = $1281b49b6089594d$var$stringBytes(header, false) + valueLength + $1281b49b6089594d$var$CRLF.length;
        checkLength(partLength);
        length += partLength;
        parts.push({
            header: header,
            value: value,
            isString: isString
        });
    }
    // Native Blob composition retains existing Blob/File data. No file is read
    // and no complete multipart ArrayBuffer is created to determine its length.
    const blobParts = [];
    for (const part of parts)blobParts.push(part.header, part.isString ? $1281b49b6089594d$var$normalizeLines(part.value) : part.value, $1281b49b6089594d$var$CRLF);
    blobParts.push(footer);
    return new Blob1(blobParts, {
        type: 'multipart/form-data; boundary=' + boundary
    });
}
function $1281b49b6089594d$var$createMultipartBody(form, Blob1, limit, limitError, boundary) {
    // Report missing Blob support before trying to select a random source.
    if (!$1281b49b6089594d$var$utils$1.isFunction(Blob1)) throw new $1281b49b6089594d$var$AxiosError('Blob is not supported', $1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT);
    if (boundary === undefined) {
        if ($1281b49b6089594d$var$utils$1.isFunction($1281b49b6089594d$var$platform.generateString)) boundary = 'axios-' + $1281b49b6089594d$var$platform.generateString(36, '0123456789abcdef');
        else {
            const crypto = $1281b49b6089594d$var$utils$1.global.crypto;
            if (!crypto || !$1281b49b6089594d$var$utils$1.isFunction(crypto.getRandomValues)) throw new $1281b49b6089594d$var$AxiosError('Random byte generation is not supported', $1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT);
            const random = new Uint8Array(18);
            crypto.getRandomValues(random);
            boundary = 'axios-' + Array.from(random, (value)=>('0' + value.toString(16)).slice(-2)).join('');
        }
    }
    try {
        return $1281b49b6089594d$var$formDataToBlob(form, Blob1, limit, limitError, boundary);
    } catch (error) {
        if (error instanceof $1281b49b6089594d$var$FormDataError) {
            const code = error.reason === 'boundary' ? $1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION_VALUE : $1281b49b6089594d$var$AxiosError.ERR_BAD_REQUEST;
            throw new $1281b49b6089594d$var$AxiosError(error.message, code);
        }
        throw error;
    }
}
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   percent-decoded body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $1281b49b6089594d$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $1281b49b6089594d$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $1281b49b6089594d$var$isHexDigit(str.charCodeAt(i + 1)) && $1281b49b6089594d$var$isHexDigit(str.charCodeAt(i + 2));
const $1281b49b6089594d$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $1281b49b6089594d$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $1281b49b6089594d$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $1281b49b6089594d$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $1281b49b6089594d$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $1281b49b6089594d$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $1281b49b6089594d$var$isPercentEncodedByte(body, i, len)) {
            code = $1281b49b6089594d$var$hexValue(body.charCodeAt(i + 1)) * 16 + $1281b49b6089594d$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($1281b49b6089594d$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$1281b49b6089594d$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $1281b49b6089594d$var$estimateBase64BufferAllocation(body);
    return $1281b49b6089594d$var$base64Bytes(significant);
};
const $1281b49b6089594d$var$estimateDataURLBytes = (url, estimateBase64, base64Pattern)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!/^data:/i.test(url)) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = base64Pattern.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $1281b49b6089594d$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
/**
 * Estimate the percent-decoded payload size used by Fetch data: URLs.
 *
 * @param {string} url
 * @returns {number}
 */ function $1281b49b6089594d$var$estimateDataURLDecodedBytes(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $1281b49b6089594d$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $1281b49b6089594d$var$estimatePercentDecodedBase64Bytes, /; *base64[\t\n\f\r ]*$/i);
}
const $1281b49b6089594d$var$VERSION = "1.21.0";
const $1281b49b6089594d$var$DEFAULT_CHUNK_SIZE = 65536;
const $1281b49b6089594d$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $1281b49b6089594d$var$isFunction } = $1281b49b6089594d$var$utils$1;
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $1281b49b6089594d$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $1281b49b6089594d$var$decodeURIComponentSafe = (value)=>{
    if (!$1281b49b6089594d$var$utils$1.isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $1281b49b6089594d$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $1281b49b6089594d$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $1281b49b6089594d$var$factory = (env)=>{
    const globalObject = $1281b49b6089594d$var$utils$1.global !== undefined && $1281b49b6089594d$var$utils$1.global !== null ? $1281b49b6089594d$var$utils$1.global : globalThis;
    const { ReadableStream: ReadableStream1, TextEncoder: TextEncoder } = globalObject;
    env = $1281b49b6089594d$var$utils$1.merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response,
        Blob: globalObject.Blob
    }, env);
    const envFetch = $1281b49b6089594d$var$utils$1.hasOwnProp(env, 'fetch') ? env.fetch : undefined;
    const { Request: Request, Response: Response, Blob: Blob1 } = env;
    const isFetchSupported = envFetch ? $1281b49b6089594d$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $1281b49b6089594d$var$isFunction(Request);
    const isResponseSupported = $1281b49b6089594d$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $1281b49b6089594d$var$isFunction(ReadableStream1);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $1281b49b6089594d$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request($1281b49b6089594d$var$platform.origin, {
            body: new ReadableStream1(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $1281b49b6089594d$var$test(()=>$1281b49b6089594d$var$utils$1.isReadableStream(new Response('').body));
    // Some runtimes reject every explicit cache mode. Use own defaults for both
    // probes so unrelated polluted options cannot affect cache-mode detection.
    const requestDefaults = Object.assign(Object.create(null), $1281b49b6089594d$var$DEFAULT_REQUEST_OPTIONS);
    if (isRequestSupported && !$1281b49b6089594d$var$test(()=>new Request($1281b49b6089594d$var$platform.origin, requestDefaults))) {
        delete requestDefaults.cache;
        // Only omit cache when that makes Request construction succeed. Otherwise
        // retain the explicit default that protects supporting runtimes from pollution.
        if (!$1281b49b6089594d$var$test(()=>new Request($1281b49b6089594d$var$platform.origin, requestDefaults))) requestDefaults.cache = $1281b49b6089594d$var$DEFAULT_REQUEST_OPTIONS.cache;
    }
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new $1281b49b6089594d$var$AxiosError(`Response type '${type}' is not supported`, $1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ($1281b49b6089594d$var$utils$1.isBlob(body)) return body.size;
        if ($1281b49b6089594d$var$utils$1.isArrayBufferView(body) || $1281b49b6089594d$var$utils$1.isArrayBuffer(body)) return body.byteLength;
        if ($1281b49b6089594d$var$utils$1.isURLSearchParams(body)) body = body + '';
        if ($1281b49b6089594d$var$utils$1.isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = $1281b49b6089594d$var$utils$1.toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = $1281b49b6089594d$var$resolveConfig(config);
        const hasMaxContentLength = $1281b49b6089594d$var$utils$1.isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = $1281b49b6089594d$var$utils$1.isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>$1281b49b6089594d$var$utils$1.hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = $1281b49b6089594d$var$composeSignals([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosErrors we raise while request or response bodies are being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        let pendingResponseError = null;
        const maxBodyLengthError = ()=>new $1281b49b6089594d$var$AxiosError('Request body larger than maxBodyLength limit', $1281b49b6089594d$var$AxiosError.ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = $1281b49b6089594d$var$utils$1.getSafeProp(configAuth, 'username') || '';
                const password = $1281b49b6089594d$var$utils$1.getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            let parsedURL;
            if ($1281b49b6089594d$var$maybeWithAuthCredentials(url)) {
                parsedURL = new URL(url, $1281b49b6089594d$var$platform.origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $1281b49b6089594d$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $1281b49b6089594d$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($1281b49b6089594d$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && parsedURL && parsedURL.protocol === 'data:') {
                const estimated = $1281b49b6089594d$var$estimateDataURLDecodedBytes(parsedURL.href);
                if (estimated > maxContentLength) throw new $1281b49b6089594d$var$AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', $1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE, config, request);
            }
            const formContentType = $1281b49b6089594d$var$utils$1.isSpecCompliantForm(data) && $1281b49b6089594d$var$AxiosHeaders.from(own('headers')).getContentType();
            let formBoundary;
            if ($1281b49b6089594d$var$utils$1.isString(formContentType) && /^multipart\/form-data(?:\s*;|$)/i.test(formContentType.trim())) {
                const parameters = $1281b49b6089594d$var$AxiosHeaders.parseParameters(formContentType);
                if ($1281b49b6089594d$var$utils$1.hasOwnProp(parameters, 'boundary')) formBoundary = parameters.boundary;
            }
            if ($1281b49b6089594d$var$utils$1.isSpecCompliantForm(data) && method !== 'get' && method !== 'head' && (hasMaxBodyLength || onUploadProgress && supportsRequestStream || formBoundary !== undefined)) {
                data = $1281b49b6089594d$var$createMultipartBody(data, Blob1, hasMaxBodyLength ? maxBodyLength : Infinity, maxBodyLengthError, formBoundary);
                // Blob.type lowercases its value, including a case-sensitive boundary.
                // Retain the caller's header when an explicit boundary was serialized.
                headers.setContentType(formBoundary === undefined ? data.type : formContentType);
                requestContentLength = data.size;
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ($1281b49b6089594d$var$utils$1.isReadableStream(data) || $1281b49b6089594d$var$utils$1.isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>$1281b49b6089594d$var$trackStream(stream, $1281b49b6089594d$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ($1281b49b6089594d$var$utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && $1281b49b6089594d$var$progressEventDecorator(requestContentLength, $1281b49b6089594d$var$progressEventReducer($1281b49b6089594d$var$asyncDecorator(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new $1281b49b6089594d$var$AxiosError('Stream request bodies are not supported by the current fetch implementation', $1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT, config, request);
            if (!$1281b49b6089594d$var$utils$1.isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ($1281b49b6089594d$var$utils$1.isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + $1281b49b6089594d$var$VERSION, false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: $1281b49b6089594d$var$toByteStringHeaderObject(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                $1281b49b6089594d$var$utils$1.forEach(requestDefaults, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = $1281b49b6089594d$var$AxiosHeaders.from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = $1281b49b6089594d$var$utils$1.toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new $1281b49b6089594d$var$AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', $1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = $1281b49b6089594d$var$utils$1.toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && $1281b49b6089594d$var$progressEventDecorator(responseContentLength, $1281b49b6089594d$var$progressEventReducer($1281b49b6089594d$var$asyncDecorator(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw pendingResponseError = new $1281b49b6089594d$var$AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', $1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response($1281b49b6089594d$var$trackStream(response.body, $1281b49b6089594d$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[$1281b49b6089594d$var$utils$1.findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new $1281b49b6089594d$var$AxiosError('maxContentLength size of ' + maxContentLength + ' exceeded', $1281b49b6089594d$var$AxiosError.ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                $1281b49b6089594d$var$settle(resolve, reject, {
                    data: responseData,
                    headers: $1281b49b6089594d$var$AxiosHeaders.from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof $1281b49b6089594d$var$AxiosError) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Keeping the original error (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            if (pendingResponseError) throw pendingResponseError;
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof $1281b49b6089594d$var$AxiosError) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new $1281b49b6089594d$var$AxiosError('Network Error', $1281b49b6089594d$var$AxiosError.ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw $1281b49b6089594d$var$AxiosError.from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $1281b49b6089594d$var$seedCache = new Map();
const $1281b49b6089594d$var$getFetch = (config)=>{
    const env = Object.create(null);
    const configuredEnv = config && $1281b49b6089594d$var$utils$1.hasOwnProp(config, 'env') && config.env;
    [
        'fetch',
        'Request',
        'Response',
        'Blob'
    ].forEach((key)=>{
        if (configuredEnv && $1281b49b6089594d$var$utils$1.hasOwnProp(configuredEnv, key)) env[key] = configuredEnv[key];
    });
    const { fetch: fetch1, Request: Request, Response: Response, Blob: Blob1 } = env;
    const seeds = [
        Request,
        Response,
        fetch1,
        Blob1
    ];
    let len = seeds.length, i = len, seed, target, map = $1281b49b6089594d$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $1281b49b6089594d$var$factory(env));
        map = target;
    }
    return target;
};
$1281b49b6089594d$var$getFetch();
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $1281b49b6089594d$var$knownAdapters = {
    http: $1281b49b6089594d$var$httpAdapter,
    xhr: $1281b49b6089594d$var$xhrAdapter,
    fetch: {
        get: $1281b49b6089594d$var$getFetch
    }
};
// Assign adapter names for easier debugging and identification
$1281b49b6089594d$var$utils$1.forEach($1281b49b6089594d$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $1281b49b6089594d$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $1281b49b6089594d$var$isResolvedHandle = (adapter)=>$1281b49b6089594d$var$utils$1.isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $1281b49b6089594d$var$getAdapter(adapters, config) {
    adapters = $1281b49b6089594d$var$utils$1.isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$1281b49b6089594d$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $1281b49b6089594d$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new $1281b49b6089594d$var$AxiosError(`Unknown adapter '${id}'`);
        }
        if (adapter && ($1281b49b6089594d$var$utils$1.isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($1281b49b6089594d$var$renderReason).join('\n') : ' ' + $1281b49b6089594d$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new $1281b49b6089594d$var$AxiosError(`There is no suitable adapter to dispatch the request ` + s, $1281b49b6089594d$var$AxiosError.ERR_NOT_SUPPORT);
    }
    return adapter;
}
/**
 * Exports Axios adapters and utility to resolve an adapter
 */ var $1281b49b6089594d$var$adapters = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $1281b49b6089594d$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $1281b49b6089594d$var$knownAdapters
};
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1281b49b6089594d$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $1281b49b6089594d$var$CanceledError(null, config);
}
/**
 * Milliseconds elapsed since `start`, floored at zero.
 *
 * Wall-clock, to match the rest of the codebase (speedometer, throttle,
 * AxiosTransformStream). A backwards clock adjustment mid-request would
 * otherwise produce a negative duration, so the result is clamped.
 *
 * @param {number} start Timestamp from `Date.now()`
 *
 * @returns {number} Non-negative elapsed milliseconds
 */ function $1281b49b6089594d$var$elapsedSince(start) {
    return Math.max(0, Date.now() - start);
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */ function $1281b49b6089594d$var$dispatchRequest(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = $1281b49b6089594d$var$utils$1.toSafeFlatObject(_config);
    $1281b49b6089594d$var$throwIfCancellationRequested(config);
    config.headers = $1281b49b6089594d$var$AxiosHeaders.from($1281b49b6089594d$var$utils$1.getSafeProp(config, 'headers'));
    // Transform request data
    config.data = $1281b49b6089594d$var$transformData.call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = $1281b49b6089594d$var$adapters.getAdapter(config.adapter || $1281b49b6089594d$var$defaults.adapter, config);
    const start = Date.now();
    return adapter(config).then(function onAdapterResolution(response) {
        $1281b49b6089594d$var$throwIfCancellationRequested(config);
        response.duration = $1281b49b6089594d$var$elapsedSince(start);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = $1281b49b6089594d$var$transformData.call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = $1281b49b6089594d$var$AxiosHeaders.from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$1281b49b6089594d$var$isCancel(reason)) {
            $1281b49b6089594d$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.duration = $1281b49b6089594d$var$elapsedSince(start);
                config.response = reason.response;
                try {
                    reason.response.data = $1281b49b6089594d$var$transformData.call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = $1281b49b6089594d$var$AxiosHeaders.from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}
const $1281b49b6089594d$var$validators$1 = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1281b49b6089594d$var$validators$1[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1281b49b6089594d$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1281b49b6089594d$var$validators$1.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $1281b49b6089594d$var$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new $1281b49b6089594d$var$AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $1281b49b6089594d$var$AxiosError.ERR_DEPRECATED);
        if (version && !$1281b49b6089594d$var$deprecatedWarnings[opt]) {
            $1281b49b6089594d$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1281b49b6089594d$var$validators$1.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1281b49b6089594d$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new $1281b49b6089594d$var$AxiosError('options must be an object', $1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $1281b49b6089594d$var$AxiosError('option ' + opt + ' must be ' + result, $1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $1281b49b6089594d$var$AxiosError('Unknown option ' + opt, $1281b49b6089594d$var$AxiosError.ERR_BAD_OPTION);
    }
}
var $1281b49b6089594d$var$validator = {
    assertOptions: $1281b49b6089594d$var$assertOptions,
    validators: $1281b49b6089594d$var$validators$1
};
const $1281b49b6089594d$var$validators = $1281b49b6089594d$var$validator.validators;
// Recognize header maps without consuming objects intended as literal values.
// AxiosHeaders from other builds share a brand and header-container interface,
// but not constructor identity. A tag and toJSON alone can describe a literal.
const $1281b49b6089594d$var$isHeadersBucket = (value)=>{
    if (value == null || $1281b49b6089594d$var$utils$1.isPlainObject(value) || value instanceof $1281b49b6089594d$var$AxiosHeaders) return true;
    try {
        return $1281b49b6089594d$var$utils$1.isObject(value) && $1281b49b6089594d$var$utils$1.getSafeProp(value, Symbol.toStringTag) === 'AxiosHeaders' && [
            'toJSON',
            'set',
            'get',
            'has',
            'delete',
            'clear',
            'normalize',
            'concat',
            'toString',
            Symbol.iterator
        ].every((method)=>$1281b49b6089594d$var$utils$1.isFunction($1281b49b6089594d$var$utils$1.getSafeProp(value, method)));
    } catch (e) {
        // A failed optional brand probe must not prevent literal header serialization.
        return false;
    }
};
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1281b49b6089594d$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new $1281b49b6089594d$var$InterceptorManager(),
            response: new $1281b49b6089594d$var$InterceptorManager()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    // Match a common suffix after the 2 top frames when available,
                    // otherwise compare the full reconstructed stack.
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const duplicateCheckSuffix = secondNewlineIndex === -1 ? stack : stack.slice(secondNewlineIndex + 1);
                    // `AxiosError.from()` may have already inlined the wrapped error's
                    // stack under a `Caused by:` marker. Keep the reconstructed caller
                    // frames ahead of that marker so stack-only reporters do not read
                    // them as part of the low-level cause.
                    const currentStack = String(err.stack);
                    const causeIndex = $1281b49b6089594d$var$getCauseStackIndex(err, currentStack);
                    const stackHead = causeIndex === -1 ? currentStack : currentStack.slice(0, causeIndex);
                    const causeSection = causeIndex === -1 ? '' : currentStack.slice(causeIndex);
                    if (!stackHead.endsWith(duplicateCheckSuffix)) err.stack = stackHead + '\n' + stack + causeSection;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = $1281b49b6089594d$var$mergeConfig(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) $1281b49b6089594d$var$validator.assertOptions(transitional, {
            silentJSONParsing: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean),
            forcedJSONParsing: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean),
            clarifyTimeoutError: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean),
            legacyInterceptorReqResOrdering: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean),
            advertiseZstdAcceptEncoding: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean),
            validateStatusUndefinedResolves: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean),
            encodeBasicAuthUsername: $1281b49b6089594d$var$validators.transitional($1281b49b6089594d$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ($1281b49b6089594d$var$utils$1.isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else $1281b49b6089594d$var$validator.assertOptions(paramsSerializer, {
                encode: $1281b49b6089594d$var$validators.function,
                serialize: $1281b49b6089594d$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if ($1281b49b6089594d$var$utils$1.hasOwnProp(this.defaults, 'allowAbsoluteUrls') && this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        $1281b49b6089594d$var$validator.assertOptions(config, {
            baseUrl: $1281b49b6089594d$var$validators.spelling('baseURL'),
            withXsrfToken: $1281b49b6089594d$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ($1281b49b6089594d$var$utils$1.getSafeProp(config, 'method') || $1281b49b6089594d$var$utils$1.getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten header defaults without consuming literal method-named headers.
        const commonHeaders = $1281b49b6089594d$var$utils$1.getSafeProp(headers, 'common');
        const methodHeaders = $1281b49b6089594d$var$utils$1.getSafeProp(headers, config.method);
        const contextHeaders = headers && $1281b49b6089594d$var$utils$1.merge($1281b49b6089594d$var$isHeadersBucket(commonHeaders) ? commonHeaders : undefined, $1281b49b6089594d$var$isHeadersBucket(methodHeaders) ? methodHeaders : undefined);
        headers && $1281b49b6089594d$var$utils$1.forEach($1281b49b6089594d$var$methodList.concat('common'), (method)=>{
            if ($1281b49b6089594d$var$isHeadersBucket($1281b49b6089594d$var$utils$1.getSafeProp(headers, method))) delete headers[method];
        });
        config.headers = $1281b49b6089594d$var$AxiosHeaders.concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || $1281b49b6089594d$var$transitionalDefaults;
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                $1281b49b6089594d$var$dispatchRequest.bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ($1281b49b6089594d$var$utils$1.isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>$1281b49b6089594d$var$dispatchRequest.call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = $1281b49b6089594d$var$dispatchRequest.call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = $1281b49b6089594d$var$mergeConfig(this.defaults, config);
        const fullPath = $1281b49b6089594d$var$buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return $1281b49b6089594d$var$buildURL(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
$1281b49b6089594d$var$utils$1.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1281b49b6089594d$var$Axios.prototype[method] = async function(url, config) {
        return this.request($1281b49b6089594d$var$mergeConfig(config || {}, {
            method: method,
            url: url,
            data: config && $1281b49b6089594d$var$utils$1.hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
$1281b49b6089594d$var$utils$1.forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return async function httpMethod(url, data, config) {
            return this.request($1281b49b6089594d$var$mergeConfig(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1281b49b6089594d$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $1281b49b6089594d$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $1281b49b6089594d$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new $1281b49b6089594d$var$CanceledError(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $1281b49b6089594d$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  const args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */ function $1281b49b6089594d$var$spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ function $1281b49b6089594d$var$isAxiosError(payload) {
    return $1281b49b6089594d$var$utils$1.isObject(payload) && payload.isAxiosError === true;
}
const $1281b49b6089594d$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($1281b49b6089594d$var$HttpStatusCode).forEach(([key, value])=>{
    if ($1281b49b6089594d$var$HttpStatusCode[value] === undefined) $1281b49b6089594d$var$HttpStatusCode[value] = key;
});
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $1281b49b6089594d$var$createInstance(defaultConfig) {
    const context = new $1281b49b6089594d$var$Axios(defaultConfig);
    const instance = $1281b49b6089594d$var$bind($1281b49b6089594d$var$Axios.prototype.request, context);
    // Copy axios.prototype to instance
    $1281b49b6089594d$var$utils$1.extend(instance, $1281b49b6089594d$var$Axios.prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    $1281b49b6089594d$var$utils$1.extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $1281b49b6089594d$var$createInstance($1281b49b6089594d$var$mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $1281b49b6089594d$var$axios = $1281b49b6089594d$var$createInstance($1281b49b6089594d$var$defaults);
// Expose Axios class to allow class inheritance
$1281b49b6089594d$var$axios.Axios = $1281b49b6089594d$var$Axios;
// Expose Cancel & CancelToken
$1281b49b6089594d$var$axios.CanceledError = $1281b49b6089594d$var$CanceledError;
$1281b49b6089594d$var$axios.CancelToken = $1281b49b6089594d$var$CancelToken;
$1281b49b6089594d$var$axios.isCancel = $1281b49b6089594d$var$isCancel;
$1281b49b6089594d$var$axios.VERSION = $1281b49b6089594d$var$VERSION;
$1281b49b6089594d$var$axios.toFormData = $1281b49b6089594d$var$toFormData;
// Expose AxiosError class
$1281b49b6089594d$var$axios.AxiosError = $1281b49b6089594d$var$AxiosError;
// alias for CanceledError for backward compatibility
$1281b49b6089594d$var$axios.Cancel = $1281b49b6089594d$var$axios.CanceledError;
// Expose all/spread
$1281b49b6089594d$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$1281b49b6089594d$var$axios.spread = $1281b49b6089594d$var$spread;
// Expose isAxiosError
$1281b49b6089594d$var$axios.isAxiosError = $1281b49b6089594d$var$isAxiosError;
// Expose mergeConfig
$1281b49b6089594d$var$axios.mergeConfig = $1281b49b6089594d$var$mergeConfig;
$1281b49b6089594d$var$axios.AxiosHeaders = $1281b49b6089594d$var$AxiosHeaders;
$1281b49b6089594d$var$axios.formToJSON = (thing)=>$1281b49b6089594d$var$formDataToJSON($1281b49b6089594d$var$utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
$1281b49b6089594d$var$axios.getAdapter = $1281b49b6089594d$var$adapters.getAdapter;
$1281b49b6089594d$var$axios.HttpStatusCode = $1281b49b6089594d$var$HttpStatusCode;
$1281b49b6089594d$var$axios.default = $1281b49b6089594d$var$axios;
module.exports = $1281b49b6089594d$var$axios;

});

parcelRegister("lqNQx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $fGUw8 = parcelRequire("fGUw8");
function $f9a2b1213d29bbc6$var$emptyFunction() {}
function $f9a2b1213d29bbc6$var$emptyFunctionWithReset() {}
$f9a2b1213d29bbc6$var$emptyFunctionWithReset.resetWarningCache = $f9a2b1213d29bbc6$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fGUw8) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9a2b1213d29bbc6$var$emptyFunctionWithReset,
        resetWarningCache: $f9a2b1213d29bbc6$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fGUw8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b6c69e64b08c17dc$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b6c69e64b08c17dc$var$ReactPropTypesSecret;

});


parcelRegister("ccHAb", function(module, exports) {



module.exports = {
    "urn_aaid_sc_VA6C2_2a1076ea-24e8-4ed3-b5d1-94f0450c26df": ()=>(parcelRequire("5c1Du")),
    "urn_aaid_sc_VA6C2_6ca3816e-c54e-4a19-9d60-3744b2f905b8": ()=>(parcelRequire("2akQa")),
    "urn_aaid_sc_VA6C2_d94f3cee-5fcd-59ca-8b62-9c2a870bd964": ()=>(parcelRequire("hwLJl"))
};

});
parcelRegister("5c1Du", function(module, exports) {
module.exports = import("7rj1Q").then(()=>parcelRequire('atnS4'));

});

parcelRegister("2akQa", function(module, exports) {
module.exports = import("5kTZM").then(()=>parcelRequire('jIrfE'));

});

parcelRegister("hwLJl", function(module, exports) {
module.exports = import("5luZr").then(()=>parcelRequire('1OZII'));

});


parcelRegister("lHGo8", function(module, exports) {

$parcel$export(module.exports, "CampaignField", () => CampaignField);
$parcel$export(module.exports, "CampaignGroupHeader", () => CampaignGroupHeader);
$parcel$export(module.exports, "CampaignGridHeader", () => CampaignGridHeader);
$parcel$export(module.exports, "CampaignFieldRows", () => CampaignFieldRows);
$parcel$export(module.exports, "CampaignPreview", () => CampaignPreview);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $f16Ml = parcelRequire("f16Ml");
var $8Muzv = parcelRequire("8Muzv");
var $208Op = parcelRequire("208Op");
var $3YPmU = parcelRequire("3YPmU");
var $34HUQ = parcelRequire("34HUQ");

var $15xG7 = parcelRequire("15xG7");

var $fmJ8d = parcelRequire("fmJ8d");

var $3NGKk = parcelRequire("3NGKk");

var $lb17q = parcelRequire("lb17q");

var $ij7W2 = parcelRequire("ij7W2");
const formatter = new Intl.ListFormat("en", {
    style: "long",
    type: "conjunction"
});
const EditButton = ({ value })=>{
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const setPromptHint = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setPromptHint);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
        "aria-label": "Edit",
        isQuiet: true,
        size: "XS",
        styles: " Iv182",
        UNSAFE_style: {
            display: "inline-grid",
            verticalAlign: "text-bottom"
        },
        onPress: ()=>{
            setPromptHint(`Edit ${formatter.format((Array.isArray(value) ? value : [
                value
            ]).map((v)=>`"${v}"`))}: `);
        },
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {
            UNSAFE_className: function anonymous(props) {
                let rules = " ";
                if (props.colorScheme === "light") rules += ' psvEhre182';
                else if (props.colorScheme === "dark") rules += ' pAnB4Le182';
                return rules;
            }({
                colorScheme: colorScheme
            })
        })
    });
};
EditButton.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    setPromptHint: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};
const CampaignField = ({ selectedCampaign = {}, selectedPersona = {}, label, value, size = "L", isDisabled })=>{
    const [isEditing, setIsEditing] = (0, $eF4cA.useState)(false);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            if (props.size === "XXXL") rules += ' JC182';
            else if (props.size === "XXL") rules += ' JC182';
            else if (props.size === "XL") rules += ' JC182';
            else if (props.size === "L") rules += ' Jx182';
            else if (props.size === "M") rules += ' Js182';
            else if (props.size === "S") rules += ' Js182';
            if (props.size === "XXXL") rules += ' GC182';
            else if (props.size === "XXL") rules += ' GC182';
            else if (props.size === "XL") rules += ' GC182';
            else if (props.size === "L") rules += ' Gx182';
            else if (props.size === "M") rules += ' Gs182';
            else if (props.size === "S") rules += ' Gs182';
            return rules;
        }({
            size: size
        }),
        children: [
            !!label && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    if (props.size === "XXXL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XXL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "L") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "M") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "S") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' -_6BNtrc-d182';
                        rules += ' vx182';
                    } else if (props.size === "XXL") {
                        rules += ' -_6BNtrc-d182';
                        rules += ' vx182';
                    } else if (props.size === "XL") {
                        rules += ' -_6BNtrc-d182';
                        rules += ' vx182';
                    } else if (props.size === "L") {
                        rules += ' -_6BNtrc-c182';
                        rules += ' vx182';
                    } else if (props.size === "M") {
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    } else if (props.size === "S") {
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "XXL") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "XL") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "L") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "M") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "S") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "XXL") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "XL") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "L") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "M") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "S") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    }
                    if (props.size === "XXXL") rules += ' pn182';
                    else if (props.size === "XXL") rules += ' pn182';
                    else if (props.size === "XL") rules += ' pn182';
                    else if (props.size === "L") rules += ' pn182';
                    else if (props.size === "M") rules += ' pn182';
                    else if (props.size === "S") rules += ' pn182';
                    return rules;
                }({
                    size: size
                }),
                children: label
            }),
            !isEditing && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' sf182';
                    rules += ' eb182';
                    if (props.size === "XXXL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XXL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "L") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "M") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "S") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' -_6BNtrc-KaY1Ce182';
                        rules += ' vx182';
                    } else if (props.size === "XXL") {
                        rules += ' -_6BNtrc-g182';
                        rules += ' vx182';
                    } else if (props.size === "XL") {
                        rules += ' -_6BNtrc-f182';
                        rules += ' vx182';
                    } else if (props.size === "L") {
                        rules += ' -_6BNtrc-e182';
                        rules += ' vx182';
                    } else if (props.size === "M") {
                        rules += ' -_6BNtrc-d182';
                        rules += ' vx182';
                    } else if (props.size === "S") {
                        rules += ' -_6BNtrc-c182';
                        rules += ' vx182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "XXL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "XL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "L") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "M") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "S") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "XXL") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "XL") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "L") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "M") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "S") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    }
                    if (props.size === "XXXL") rules += ' pt182';
                    else if (props.size === "XXL") rules += ' pt182';
                    else if (props.size === "XL") rules += ' pt182';
                    else if (props.size === "L") rules += ' pt182';
                    else if (props.size === "M") rules += ' pn182';
                    else if (props.size === "S") rules += ' pn182';
                    return rules;
                }({
                    size: size
                }),
                children: [
                    (Array.isArray(value) ? value : [
                        value
                    ]).map((val, idx)=>{
                        if ((selectedCampaign?.[val] ?? "")?.startsWith("http")) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                            variant: "primary",
                            href: selectedCampaign?.[val] ?? "",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: eval(`selectedCampaign["${val}"] ?? ""`)
                        }, `${val}-${idx}`);
                        return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                            children: [
                                val === "Persona-1-name" && !!selectedPersona?.avatarUrl && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                                    src: selectedPersona?.avatarUrl,
                                    alt: "Persona avatar",
                                    size: 80,
                                    isOverBackground: true,
                                    styles: " Gx182"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: (selectedCampaign?.[val] ?? "") + " "
                                })
                            ]
                        }, `${val}-${idx}`);
                    }),
                    !isDisabled && /*#__PURE__*/ (0, $dx4lB.jsx)(EditButton, {
                        value: value
                    })
                ]
            })
        ]
    });
};
CampaignField.propTypes = {
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    ]).isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL"
    ]),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
const CampaignGroupHeader = ({ title, description })=>{
    if (!title && !description) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Ue182 qe182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                level: 2,
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182 Iy182 Hy182",
                children: title
            }),
            !!description && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                children: description
            })
        ]
    });
};
CampaignGroupHeader.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const CampaignPreviewLinks = ({ links = [], password })=>{
    if (!links.length) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3NGKk.PreviewPasswordPopover), {
        password: password,
        styles: " sd182 eb182 Ue182 qe182 _wb182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                children: "Preview"
            }),
            links.map(({ href, label, target, rel }, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                    href: href,
                    target: target,
                    rel: rel,
                    variant: "secondary",
                    staticColor: "auto",
                    size: "S",
                    children: label
                }, `${href}-${idx}`))
        ]
    });
};
CampaignPreviewLinks.propTypes = {
    links: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        href: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        target: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        rel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
    })),
    password: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const CampaignGridHeader = ({ title, description, previewLinks, previewPassword, actions })=>{
    const hasPreviewLinks = !!previewLinks?.length;
    if (!title && !description && !actions && !hasPreviewLinks) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Ue182 qe182",
        children: [
            (!!title || !!actions || hasPreviewLinks) && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _tb182 _toc182 ea182 Ul182 ql182",
                children: [
                    !!title && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        level: 3,
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182 Iy182 Hy182",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)(CampaignPreviewLinks, {
                        links: previewLinks,
                        password: previewPassword
                    }),
                    actions
                ]
            }),
            !!description && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                children: description
            })
        ]
    });
};
CampaignGridHeader.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    previewLinks: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    previewPassword: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const MAX_COLUMN_WIDTH = "calc(18.75rem * var(--s2-scale))";
// A grid's rows as one CSS grid, positioned through the CSS variables
// `CampaignFieldRows` sets — static styles can't take dynamic values. Below
// `md` it is a single column, its cells stacked in order.
// Lines are as tall as their own content (`--grid-rows`, see `getGridRows`).
const GRID_STYLES = {
    none: " se182 DfQhdHc182 DonbaCQb182 Eh3TDrc182 EoL9ufWc182 ed182 qi182 Uh182",
    variations: " se182 DfQhdHc182 DonbaCQb182 Eh3TDrc182 EoL9ufWc182 ed182 qi182 Uj182",
    // The tracks of the cell it fills — itself a subgrid (see `isSubgrid`).
    subgrid: " se182 DfQhdHc182 DoLwlgod182 Eh3TDrc182 EoL9ufWc182 z2mU182 yzZKy182 ed182 qi182 Uh182"
};
const GRID_CELL_STYLE = " Na182 zQgYBrc182 zo6DD6Vd182 yQgYBrc182 yolNiro182 BQgYBrc182 BoAq1wZ182 AQgYBrc182 AoxYP50182";
// A cell passing the tracks it spans on to its content, a subgrid in turn.
const GRID_SUBGRID_CELL_STYLE = " Na182 zQgYBrc182 zo6DD6Vd182 yQgYBrc182 yolNiro182 BQgYBrc182 BoAq1wZ182 AQgYBrc182 AoxYP50182 se182 DfQhdHc182 DoLwlgod182";
/**
 * The row tracks of a laid out grid with cells spanning rows, or `undefined`
 * without any. A spanning cell would otherwise split its height equally
 * between the `auto` lines it covers, so each line would be as tall as the
 * tallest. A flexible last line takes what the spanning cell needs beyond the
 * lines above it instead, those staying as tall as their own content.
 */ const getGridRows = ({ lines, cells })=>{
    const spanEnds = new Set(cells.filter((c)=>c.rowSpan > 1).map((c)=>c.line + c.rowSpan - 1));
    return spanEnds.size ? Array.from({
        length: lines
    }, (_, idx)=>spanEnds.has(idx + 1) ? "minmax(auto, 1fr)" : "auto").join(" ") : undefined;
};
const CampaignFieldRows = ({ rows = [], columns, rowGap = "none", subgrid = false, renderField })=>{
    const layout = (0, $ij7W2.layoutGridRows)(rows, {
        columns: columns,
        fillLines: subgrid
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: subgrid ? GRID_STYLES.subgrid : GRID_STYLES[rowGap] ?? GRID_STYLES.none,
        style: {
            "--grid-columns": subgrid ? undefined : layout.columns,
            "--grid-rows": getGridRows(layout)
        },
        children: layout.cells.map(({ cell, rowIdx, cellIdx, column, colSpan, line, rowSpan })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: cell?.isSubgrid ? GRID_SUBGRID_CELL_STYLE : GRID_CELL_STYLE,
                style: {
                    "--cell-column": column,
                    "--cell-col-span": colSpan,
                    "--cell-line": line,
                    "--cell-row-span": rowSpan
                },
                children: cell ? renderField(cell, cellIdx) : null
            }, `${rowIdx}-${cellIdx}`))
    });
};
CampaignFieldRows.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
    rowGap: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "none",
        "variations"
    ]),
    subgrid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object)),
    renderField: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};
const CampaignPreview = ({ selectedCampaign = {}, selectedPersona = {}, campaignStructure = [], templateData })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " Za182 Lb4QY4182 IM182 HM182 __Wc182",
        children: campaignStructure.map((group, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                        size: "S"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " _oa182 Za182 Sh182 Rh182 Jx182 GI182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)(CampaignGroupHeader, {
                                title: group.title,
                                description: group.description
                            }),
                            (0, $lb17q.getGroupGrids)(group).filter((grid)=>grid.type !== (0, $lb17q.GRID_TYPE).VARIATIONS).map((grid, gridIdx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)(CampaignGridHeader, {
                                            title: grid.title,
                                            description: grid.description,
                                            previewLinks: (0, $lb17q.getPreviewLinks)(grid.previewLinks, templateData?.previewUrl),
                                            previewPassword: templateData?.previewPassword
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)(CampaignFieldRows, {
                                            rows: grid.rows,
                                            renderField: (cell)=>{
                                                const { label, value, size = "L", disabled = false } = cell;
                                                // A link is shown by the visuals preview only.
                                                return !(0, $lb17q.isTextCell)(cell) && (0, $lb17q.getCellLink)(cell) ? null : /*#__PURE__*/ (0, $dx4lB.jsx)(CampaignField, {
                                                    selectedCampaign: selectedCampaign,
                                                    selectedPersona: selectedPersona,
                                                    label: label,
                                                    value: value,
                                                    size: size,
                                                    isDisabled: disabled
                                                });
                                            }
                                        })
                                    ]
                                }, gridIdx))
                        ]
                    })
                ]
            }, idx))
    });
};
CampaignPreview.propTypes = {
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    selectedPersona: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    campaignStructure: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};

});
parcelRegister("dx4lB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6C64U"));

});

parcelRegister("5IZkx", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $8b5a8914ac654a56$export$6ccbb43953eebf8);

var $eF4cA = parcelRequire("eF4cA");

var $6ywA8 = parcelRequire("6ywA8");
const $8b5a8914ac654a56$var$identity = (arg)=>arg;
function $8b5a8914ac654a56$export$6ccbb43953eebf8(api, selector = $8b5a8914ac654a56$var$identity) {
    const slice = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useSyncExternalStore(api.subscribe, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), ()=>selector(api.getInitialState()));
    (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useDebugValue(slice);
    return slice;
}
const $8b5a8914ac654a56$var$createImpl = (createState)=>{
    const api = (0, $6ywA8.createStore)(createState);
    const useBoundStore = (selector)=>$8b5a8914ac654a56$export$6ccbb43953eebf8(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $8b5a8914ac654a56$export$185802fd694ee1f5 = (createState)=>createState ? $8b5a8914ac654a56$var$createImpl(createState) : $8b5a8914ac654a56$var$createImpl;

});
parcelRegister("6ywA8", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $4692c1c4805bb379$export$f51a9068ac82ea43);
const $4692c1c4805bb379$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $4692c1c4805bb379$export$f51a9068ac82ea43 = (createState)=>createState ? $4692c1c4805bb379$var$createStoreImpl(createState) : $4692c1c4805bb379$var$createStoreImpl;

});


parcelRegister("9eyCh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b9045f3b99763a8$var$ReactIs, $6b9045f3b99763a8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lqNQx"))();

});

parcelRegister("4W5AG", function(module, exports) {

$parcel$export(module.exports, "btnStyles", () => $f99ed08cd8f2c290$export$446543cff2a0f496);
$parcel$export(module.exports, "ActionButtonContext", () => $f99ed08cd8f2c290$export$2ff682723a46d413);
$parcel$export(module.exports, "ActionButton", () => $f99ed08cd8f2c290$export$cfc7921d29ef7b80);


var $waxwa = parcelRequire("waxwa");

var $f16Ml = parcelRequire("f16Ml");

var $8OJ2z = parcelRequire("8OJ2z");

var $7PKMq = parcelRequire("7PKMq");

var $dm5H1 = parcelRequire("dm5H1");

var $8g9SZ = parcelRequire("8g9SZ");

var $fL4LX = parcelRequire("fL4LX");

var $aJzBQ = parcelRequire("aJzBQ");

var $i93Vd = parcelRequire("i93Vd");

var $fZShI = parcelRequire("fZShI");

var $91SAk = parcelRequire("91SAk");

var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $j3pTw = parcelRequire("j3pTw");

var $34HUQ = parcelRequire("34HUQ");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $8gDpA = parcelRequire("8gDpA");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");
function $f99ed08cd8f2c290$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // These styles handle both ActionButton and ToggleButton
const $f99ed08cd8f2c290$var$$da878a05ab4a403e$var$iconOnly = ':has([slot=icon], [slot=avatar]):not(:has([data-rsp-slot=text]))';
const $f99ed08cd8f2c290$var$$da878a05ab4a403e$var$avatarOnly = ':has([slot=avatar]):not(:has([slot=icon], [data-rsp-slot=text]))';
const $f99ed08cd8f2c290$var$$da878a05ab4a403e$var$textOnly = ':has([data-rsp-slot=text]):not(:has([slot=icon], [slot=avatar]))';
const $f99ed08cd8f2c290$var$$da878a05ab4a403e$var$controlStyle = {
    font: {
        "default": "ui",
        size: {
            XS: "ui-xs",
            S: "ui-sm",
            L: "ui-lg",
            XL: "ui-xl"
        }
    },
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    paddingX: {
        "default": "edge-to-text",
        ":has([slot=icon]):not(:has([data-rsp-slot=text]))": 0
    },
    minWidth: {
        "default": 32,
        size: {
            XS: 20,
            S: 24,
            L: 40,
            XL: 48
        }
    },
    "--size": {
        type: "order",
        value: {
            "default": 1,
            size: {
                XS: 0.7901234567901234,
                S: 0.8888888888888888,
                L: 1.125,
                XL: 1.265625
            }
        }
    },
    "--radius": {
        type: "borderTopStartRadius",
        value: "default"
    },
    borderRadius: "round(var(--radius) * var(--size), 1px)",
    columnGap: "text-to-visual",
    "--iconMargin": {
        type: "marginStart",
        value: {
            "default": "[-0.14285714285714285em]",
            ":has([slot=icon]):not(:has([data-rsp-slot=text]))": 0
        }
    },
    height: {
        "default": 32,
        size: {
            XS: 20,
            S: 24,
            L: 40,
            XL: 48
        }
    }
};
const $f99ed08cd8f2c290$export$446543cff2a0f496 = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let flexShrink = false;
    let flexGrow = false;
    let flexBasis = false;
    let width = false;
    let position = false;
    let zIndex = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_s") flexBasis = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "_9") zIndex = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    if (props.isStaticColor) rules += ' Oe182';
    else rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' xc182';
    rules += ' _xa182';
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isStaticColor) {
        if (props.isDisabled) rules += ' pi182';
        else if (props.isSelected) rules += ' ph182';
        else rules += ' pl182';
    } else if (props.isDisabled) rules += ' pp182';
    else if (props.isSelected) {
        if (props.isEmphasized) rules += ' px182';
        else rules += ' pr182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    if (props.isDisabled) rules += ' plc182';
    else if (props.isSelected) rules += ' ple182';
    else rules += ' plb182';
    rules += ' se182';
    rules += ' eb182';
    rules += ' _oa182';
    rules += ' Sv182';
    rules += ' SgLWx3bd182';
    rules += ' SsAUsHd182';
    rules += ' Rv182';
    rules += ' RgLWx3bd182';
    rules += ' RsAUsHd182';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl182';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj182';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf182';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne182';
    } else if (!minWidth) rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    if (props.density === "compact") {
        rules += ' od182';
        rules += ' obj182';
    } else rules += ' oj182';
    if (props.density === "compact") {
        if (props.orientation === "vertical") {
            rules += ' nd182';
            rules += ' nbj182';
        } else if (props.orientation === "horizontal") {
            rules += ' nd182';
            rules += ' nkj182';
        } else rules += ' nd182';
    } else rules += ' nj182';
    if (props.density === "compact") {
        if (props.orientation === "vertical") {
            rules += ' kd182';
            rules += ' kkj182';
        } else if (props.orientation === "horizontal") {
            rules += ' kd182';
            rules += ' kbj182';
        } else rules += ' kd182';
    } else rules += ' kj182';
    if (props.density === "compact") {
        rules += ' jd182';
        rules += ' jkj182';
    } else rules += ' jj182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-y5UFLdIy182';
    rules += ' -Qg41Lb-sAUsHIy182';
    rules += ' FRuFGYc182';
    rules += ' _Ca182';
    if (props.isInGroup) {
        if (!flexShrink) rules += ' _va182';
    } else if (!flexShrink) rules += ' _vb182';
    if (props.isJustified) {
        if (!flexGrow) rules += ' _ub182';
    }
    if (props.isJustified) {
        if (!flexBasis) rules += ' _sb182';
    }
    if (props.isInGroup) {
        if (props.orientation === "vertical") {
            if (!width) rules += ' Za182';
        }
    } else if (!width) rules += ' ZJ182';
    rules += ' _4c182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _yb182';
    if (!position) rules += ' _Pc182';
    rules += ' CjpxCZ182';
    rules += ' Cy5UFLd2sgPTb182';
    rules += ' CwAP22cUolIUb182';
    rules += ' DZQmDFe182';
    rules += ' Dy5UFLdQgYBrc182';
    rules += ' DwAP22cQgYBrc182';
    rules += ' gqMFGYc182';
    rules += ' -_8sjo0b-t5ZbAob182';
    rules += ' _je182';
    if (props.isFocusVisible) {
        if (!zIndex) rules += ' _9d182';
    }
    rules += ' __ca182';
    rules += ' -B5H9Ae-WXN7eQb182';
    rules += ' -B5H9Ae-wAP22cWr182';
    rules += ' -SqFa4c-ZObNfn182';
    rules += ' -dcAs1c-ZaP94G182';
    rules += ' -dcAs1c-wAP22cZa182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    else if (props.size === "XS") rules += ' -F_-Fn182';
    else rules += ' -F_-Fx182';
    if (props.isStaticColor) {
        if (props.isSelected) {
            if (props.isDisabled) {
                if (props.isQuiet) rules += ' -g_-g9182';
                else rules += ' -g_-gf182';
            } else {
                if (props.isPressed) rules += ' -g_-gj182';
                else if (props.isFocusVisible) rules += ' -g_-gj182';
                else if (props.isHovered) rules += ' -g_-gj182';
                else rules += ' -g_-gi182';
            }
        } else if (props.isPressed) rules += ' -g_-gg182';
        else if (props.isFocusVisible) rules += ' -g_-gg182';
        else if (props.isHovered) rules += ' -g_-gg182';
        else if (props.isQuiet) rules += ' -g_-g9182';
        else rules += ' -g_-gf182';
    } else if (props.isSelected) {
        if (props.isDisabled) {
            if (props.isQuiet) rules += ' -g_-g9182';
            else rules += ' -g_-gH182';
        } else if (props.isEmphasized) {
            if (props.isFocusVisible) rules += ' -g_-gUgARdd182';
            else if (props.isPressed) rules += ' -g_-gUgARdd182';
            else if (props.isHovered) rules += ' -g_-gUgARdd182';
            else rules += ' -g_-g5qAiPc182';
        } else {
            if (props.isPressed) rules += ' -g_-gu182';
            else if (props.isFocusVisible) rules += ' -g_-gu182';
            else if (props.isHovered) rules += ' -g_-gu182';
            else rules += ' -g_-g0182';
        }
    } else {
        if (props.isPressed) rules += ' -g_-gF182';
        else if (props.isFocusVisible) rules += ' -g_-gF182';
        else if (props.isHovered) rules += ' -g_-gF182';
        else if (props.isQuiet) rules += ' -g_-g9182';
        else rules += ' -g_-gH182';
    }
    if (props.isSelected) {
        if (props.isDisabled) rules += ' -g_-lgb182';
        else rules += ' -g_-lge182';
    } else rules += ' -g_-lgb182';
    return rules;
};
const $f99ed08cd8f2c290$export$2ff682723a46d413 = (0, $eF4cA.createContext)(null);
const $f99ed08cd8f2c290$export$cfc7921d29ef7b80 = (0, $eF4cA.forwardRef)(function ActionButton(props1, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $f99ed08cd8f2c290$export$2ff682723a46d413);
    props1 = (0, $j3pTw.useFormProps)(props1);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($f99ed08cd8f2c290$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { isPending: isPending = false, holdAffordance: holdAffordance } = props1;
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let overlayTriggerState = (0, $eF4cA.useContext)((0, $8gDpA.OverlayTriggerStateContext));
    let ctx = (0, $fDYaM.useSlottedContext)((0, $waxwa.ActionButtonGroupContext));
    let isInGroup = !!ctx;
    let { density: density = 'regular', isJustified: isJustified, orientation: orientation = 'horizontal', staticColor: staticColor = props1.staticColor, isQuiet: isQuiet = props1.isQuiet, size: size = props1.size || 'M', isDisabled: isDisabled } = ctx || {};
    let { isProgressVisible: isProgressVisible } = (0, $34HUQ.usePendingState)(isPending);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        ...props1,
        isDisabled: props1.isDisabled ?? isDisabled,
        ref: domRef,
        style: (0, $i93Vd.pressScale)(domRef, props1.UNSAFE_style),
        className: (renderProps)=>(props1.UNSAFE_className || '') + $f99ed08cd8f2c290$export$446543cff2a0f496({
                ...renderProps,
                // Retain hover styles when an overlay is open.
                isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                isDisabled: renderProps.isDisabled || isProgressVisible,
                staticColor: staticColor,
                isStaticColor: !!staticColor,
                size: size,
                isQuiet: isQuiet,
                density: density,
                isJustified: isJustified,
                orientation: orientation,
                isInGroup: isInGroup
            }, props1.styles),
        children: ({ isDisabled: isDisabled })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $91SAk.SkeletonContext),
                                null
                            ],
                            [
                                (0, $208Op.TextContext),
                                {
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' zYoLErc182';
                                        rules += ' yYoLErc182';
                                        rules += ' BYoLErc182';
                                        rules += ' AYoLErc182';
                                        rules += ' _Nc182';
                                        rules += ' Pc182';
                                        rules += ' _Yb182';
                                        rules += ' _7c182';
                                        if (props.isProgressVisible) rules += ' _6b182';
                                        return rules;
                                    }({
                                        isProgressVisible: isProgressVisible
                                    })
                                }
                            ],
                            [
                                (0, $dm5H1.IconContext),
                                {
                                    render: (0, $8OJ2z.centerBaseline)({
                                        slot: 'icon',
                                        styles: " z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182"
                                    }),
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' ZObNfn182';
                                        rules += ' FObNfn182';
                                        rules += ' I67logd182';
                                        if (props.isProgressVisible) rules += ' _6b182';
                                        return rules;
                                    }({
                                        isProgressVisible: isProgressVisible
                                    })
                                }
                            ],
                            [
                                (0, $f16Ml.AvatarContext),
                                {
                                    size: '1lh',
                                    styles: " I67logd182 z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182"
                                }
                            ],
                            [
                                (0, $8g9SZ.ImageContext),
                                {
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        if (props.isProgressVisible) rules += ' _6b182';
                                        return rules;
                                    }({
                                        isProgressVisible: isProgressVisible
                                    })
                                }
                            ],
                            [
                                (0, $aJzBQ.NotificationBadgeContext),
                                {
                                    staticColor: staticColor,
                                    size: props1.size === 'XS' ? undefined : props1.size,
                                    isDisabled: isDisabled,
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' _Pa182';
                                        rules += ' WtedXZc182';
                                        rules += ' JlZStSb182';
                                        rules += ' Ijgro3c182';
                                        rules += ' z2mU182';
                                        rules += ' _A1IiWH182';
                                        if (props.isProgressVisible) rules += ' _6b182';
                                        return rules;
                                    }({
                                        isProgressVisible: isProgressVisible
                                    })
                                }
                            ]
                        ],
                        children: [
                            typeof props1.children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: props1.children
                            }) : props1.children,
                            isPending && (0, $dx4lB.jsx)("div", {
                                className: function anonymous(props) {
                                    let rules = " ";
                                    rules += ' _Pa182';
                                    rules += ' WF182';
                                    rules += ' _EF182';
                                    rules += ' _Zc182';
                                    if (props.isProgressVisible) rules += ' _6c182';
                                    else rules += ' _6b182';
                                    return rules;
                                }({
                                    isProgressVisible: isProgressVisible,
                                    isPending: isPending
                                }),
                                children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                    isIndeterminate: true,
                                    "aria-label": stringFormatter.format('actionbutton.pending'),
                                    size: "S",
                                    staticColor: staticColor,
                                    styles: " ZObNfn182 FObNfn182"
                                })
                            })
                        ]
                    }),
                    holdAffordance && (0, $dx4lB.jsx)((0, $7PKMq.default), {
                        size: size === 'XS' ? 'S' : size,
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' _Pa182';
                            if (props.size === "XL") rules += ' _zWJpoB182';
                            else if (props.size === "L") rules += ' _zC1otk182';
                            else if (props.size === "M") rules += ' _zE182';
                            else if (props.size === "S") rules += ' _zwtfhvc182';
                            else if (props.size === "XS") rules += ' _zwtfhvc182';
                            if (props.size === "XL") rules += ' _lWJpoB182';
                            else if (props.size === "L") rules += ' _lC1otk182';
                            else if (props.size === "M") rules += ' _lE182';
                            else if (props.size === "S") rules += ' _lwtfhvc182';
                            else if (props.size === "XS") rules += ' _lwtfhvc182';
                            if (props.direction === "rtl") {
                                rules += ' -Z4Pn4c-a182';
                                rules += ' __Ha182';
                            }
                            return rules;
                        }({
                            direction: direction,
                            size: size
                        })
                    })
                ]
            })
    });
// oxlint-enable react/react-compiler
});

});
parcelRegister("waxwa", function(module, exports) {

$parcel$export(module.exports, "actionGroupStyle", () => $d061239d72094da5$export$641cbcd1f6f6802f);
$parcel$export(module.exports, "ActionButtonGroupContext", () => $d061239d72094da5$export$33f5f2f2cb85d743);
$parcel$export(module.exports, "ActionButtonGroup", () => $d061239d72094da5$export$73d695ae27330056);


var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $hgdoa = parcelRequire("hgdoa");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d061239d72094da5$export$641cbcd1f6f6802f = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g) || []).join('');
    rules += ' sd182';
    if (props.orientation === "vertical") rules += ' _ta182';
    else if (props.orientation === "horizontal") rules += ' _tc182';
    if (props.density === "regular") {
        if (props.size === "XL") rules += ' Ue182';
        else if (props.size === "L") rules += ' Ue182';
        else if (props.size === "M") rules += ' Ue182';
        else if (props.size === "S") rules += ' Ub182';
        else if (props.size === "XS") rules += ' Ub182';
    } else if (props.density === "compact") rules += ' Ua182';
    if (props.density === "regular") {
        if (props.size === "XL") rules += ' qe182';
        else if (props.size === "L") rules += ' qe182';
        else if (props.size === "M") rules += ' qe182';
        else if (props.size === "S") rules += ' qb182';
        else if (props.size === "XS") rules += ' qb182';
    } else if (props.density === "compact") rules += ' qa182';
    return rules;
};
const $d061239d72094da5$export$33f5f2f2cb85d743 = (0, $eF4cA.createContext)(null);
const $d061239d72094da5$export$73d695ae27330056 = (0, $eF4cA.forwardRef)(function ActionButtonGroup(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $d061239d72094da5$export$33f5f2f2cb85d743);
    let { density: density = 'regular', size: size = 'M', orientation: orientation = 'horizontal', isJustified: isJustified, isQuiet: isQuiet, staticColor: staticColor, isDisabled: isDisabled, children: children, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles } = props;
    // Make sure we get all the same defaults as the ActionButtonGroup
    let context = (0, $eF4cA.useMemo)(()=>({
            size: size,
            density: density,
            orientation: orientation,
            isJustified: isJustified,
            isQuiet: isQuiet,
            staticColor: staticColor,
            isDisabled: isDisabled
        }), [
        size,
        density,
        orientation,
        isJustified,
        isQuiet,
        staticColor,
        isDisabled
    ]);
    return (0, $dx4lB.jsx)((0, $hgdoa.Toolbar), {
        ...props,
        ref: ref,
        style: UNSAFE_style,
        className: UNSAFE_className + $d061239d72094da5$export$641cbcd1f6f6802f({
            size: size,
            density: density,
            orientation: orientation,
            isJustified: isJustified
        }, styles),
        children: (0, $dx4lB.jsx)($d061239d72094da5$export$33f5f2f2cb85d743.Provider, {
            value: context,
            children: children
        })
    });
});

});
parcelRegister("5t6Bv", function(module, exports) {

$parcel$export(module.exports, "useSpectrumContextProps", () => $d3c59c7b398ed4d1$export$764f6146fadd77f7);

var $5nTep = parcelRequire("5nTep");

var $eF4cA = parcelRequire("eF4cA");

var $fDYaM = parcelRequire("fDYaM");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d3c59c7b398ed4d1$export$764f6146fadd77f7(props, ref, context) {
    let ctx = (0, $fDYaM.useSlottedContext)(context, props.slot) || {};
    let { ref: contextRef, ...contextProps } = ctx;
    let mergedRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(ref, contextRef), [
        ref,
        contextRef
    ]));
    let mergedProps = (0, $lhKAD.mergeProps)(contextProps, props);
    // mergeProps does not merge `UNSAFE_style`
    if ('UNSAFE_style' in contextProps && contextProps.UNSAFE_style && 'UNSAFE_style' in props && props.UNSAFE_style) mergedProps.UNSAFE_style = {
        ...contextProps.UNSAFE_style,
        ...props.UNSAFE_style
    };
    // Merge macro styles.
    if ('styles' in contextProps && contextProps.styles && 'styles' in props && props.styles) mergedProps.styles = (0, $5nTep.mergeStyles)(contextProps.styles, props.styles);
    return [
        mergedProps,
        mergedRef
    ];
}

});
parcelRegister("5nTep", function(module, exports) {

$parcel$export(module.exports, "mergeStyles", () => $6f31b0b9a82dc9d5$export$e618dc39ac9ad607);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6f31b0b9a82dc9d5$export$e618dc39ac9ad607(...styles) {
    let definedStyles = styles.filter(Boolean);
    if (definedStyles.length === 1) {
        let first = definedStyles[0];
        if (typeof first !== 'string') // it's automatically called in other places, but for our merging, we have to call it ourselves
        return first.toString();
        return first;
    }
    let map = new Map();
    for (let style of definedStyles){
        // must call toString here for the static macro
        let str = style.toString();
        for (let [k, v] of $6f31b0b9a82dc9d5$var$$feb886035e0d4633$var$parse(str))map.set(k, v);
    }
    let res = '';
    for (let value of map.values())res += value;
    return res;
}
function $6f31b0b9a82dc9d5$var$$feb886035e0d4633$var$parse(s) {
    let properties = new Map();
    let i = 0;
    while(i < s.length){
        while(i < s.length && s[i] === ' ')i++;
        let start = i;
        readValue(); // property index
        // read conditions (up to the last segment)
        let condition = i;
        while(i < s.length && s[i] !== ' ')readValue();
        let property = s.slice(start, condition);
        properties.set(property, (properties.get(property) || '') + ' ' + s.slice(start, i));
    }
    function readValue() {
        if (s[i] === '-') while(i < s.length && s[i] !== ' '){
            i++;
            if (s[i] === '-') {
                i++;
                break;
            }
        }
        else {
            while(i < s.length)if (s[i] === '_') i++;
            else {
                i++;
                break;
            }
        }
    }
    return properties;
}

});

parcelRegister("fDYaM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SLOT", () => $125d71e757f7ebd5$export$c62b8e45d58ddad9);
$parcel$export(module.exports, "Provider", () => $125d71e757f7ebd5$export$2881499e37b75b9a);
$parcel$export(module.exports, "useRenderProps", () => $125d71e757f7ebd5$export$4d86445c2cf5e3);
$parcel$export(module.exports, "composeRenderProps", () => $125d71e757f7ebd5$export$c245e6201fed2f75);
$parcel$export(module.exports, "useSlottedContext", () => $125d71e757f7ebd5$export$fabf2dc03a41866e);
$parcel$export(module.exports, "useContextProps", () => $125d71e757f7ebd5$export$29f1550f4b0d4415);
$parcel$export(module.exports, "useSlot", () => $125d71e757f7ebd5$export$9d4c57ee4c6ffdd8);
$parcel$export(module.exports, "removeDataAttributes", () => $125d71e757f7ebd5$export$ef03459518577ad4);
$parcel$export(module.exports, "dom", () => $125d71e757f7ebd5$export$df3a06d6289f983e);

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $eF4cA = parcelRequire("eF4cA");

var $4skXn = parcelRequire("4skXn");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $125d71e757f7ebd5$export$c62b8e45d58ddad9 = Symbol('default');
function $125d71e757f7ebd5$export$2881499e37b75b9a({ values: values, children: children }) {
    for (let [Context, value] of values)children = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(Context.Provider, {
        value: value
    }, children);
    return children;
}
function $125d71e757f7ebd5$export$4d86445c2cf5e3(props) {
    let { className: className, style: style, children: children, defaultClassName: defaultClassName, defaultChildren: defaultChildren, defaultStyle: defaultStyle, values: values, render: render } = props;
    return (0, $eF4cA.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === 'function') computedClassName = className({
            ...values,
            defaultClassName: defaultClassName
        });
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style({
            ...values,
            defaultStyle: defaultStyle || {}
        });
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children({
            ...values,
            defaultChildren: defaultChildren
        });
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName ?? defaultClassName,
            style: computedStyle || defaultStyle ? {
                ...defaultStyle,
                ...computedStyle
            } : undefined,
            children: computedChildren ?? defaultChildren,
            'data-rac': '',
            render: render ? (props)=>render(props, values) : undefined
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values,
        render
    ]);
}
function $125d71e757f7ebd5$export$c245e6201fed2f75(value, wrap) {
    return (renderProps)=>wrap(typeof value === 'function' ? value(renderProps) : value, renderProps);
}
function $125d71e757f7ebd5$export$fabf2dc03a41866e(context, slot) {
    let ctx = (0, $eF4cA.useContext)(context);
    if (slot === null) return null;
    if (ctx && typeof ctx === 'object' && 'slots' in ctx && ctx.slots) {
        let slotKey = slot || $125d71e757f7ebd5$export$c62b8e45d58ddad9;
        if (!ctx.slots[slotKey]) {
            let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p)=>`"${p}"`));
            let errorMessage = slot ? `Invalid slot "${slot}".` : 'A slot prop is required.';
            throw new Error(`${errorMessage} Valid slot names are ${availableSlots}.`);
        }
        return ctx.slots[slotKey];
    }
    // @ts-ignore
    return ctx;
}
function $125d71e757f7ebd5$export$29f1550f4b0d4415(props, ref, context) {
    let ctx = $125d71e757f7ebd5$export$fabf2dc03a41866e(context, props.slot) || {};
    let { ref: contextRef, ...contextProps } = ctx;
    let mergedRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(ref, contextRef), [
        ref,
        contextRef
    ]));
    let mergedProps = (0, $lhKAD.mergeProps)(contextProps, props);
    // mergeProps does not merge `style`. Adding this there might be a breaking change.
    if ('style' in contextProps && contextProps.style && 'style' in props && props.style) {
        if (typeof contextProps.style === 'function' || typeof props.style === 'function') mergedProps.style = (renderProps)=>{
            let contextStyle = typeof contextProps.style === 'function' ? contextProps.style(renderProps) : contextProps.style;
            let defaultStyle = {
                ...renderProps.defaultStyle,
                ...contextStyle
            };
            let style = typeof props.style === 'function' ? props.style({
                ...renderProps,
                defaultStyle: defaultStyle
            }) : props.style;
            return {
                ...defaultStyle,
                ...style
            };
        };
        else mergedProps.style = {
            ...contextProps.style,
            ...props.style
        };
    }
    return [
        mergedProps,
        mergedRef
    ];
}
function $125d71e757f7ebd5$export$9d4c57ee4c6ffdd8(initialState = true) {
    // Initial state is typically based on the parent having an aria-label or aria-labelledby.
    // If it does, this value should be false so that we don't update the state and cause a rerender when we go through the layoutEffect
    let [hasSlot, setHasSlot] = (0, $eF4cA.useState)(initialState);
    let hasRun = (0, $eF4cA.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    let ref = (0, $eF4cA.useCallback)((el)=>{
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function $125d71e757f7ebd5$export$ef03459518577ad4(props) {
    const prefix = /^(data-.*)$/;
    let filteredProps = {};
    for(const prop in props)if (!prefix.test(prop)) filteredProps[prop] = props[prop];
    return filteredProps;
}
function $125d71e757f7ebd5$var$$7230ffa83bc0c2cf$var$DOMElement(ElementType, props, forwardedRef) {
    let { render: render, ...otherProps } = props;
    let elementRef = (0, $eF4cA.useRef)(null);
    let ref = (0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(forwardedRef, elementRef), [
        forwardedRef,
        elementRef
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{}, [
        ElementType,
        render
    ]);
    let domProps = {
        ...otherProps,
        ref: ref
    };
    if (render) return render(domProps, undefined);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, domProps);
}
const $125d71e757f7ebd5$var$$7230ffa83bc0c2cf$var$domComponentCache = {};
const $125d71e757f7ebd5$export$df3a06d6289f983e = new Proxy({}, {
    get (target, elementType) {
        if (typeof elementType !== 'string') return undefined;
        let res = $125d71e757f7ebd5$var$$7230ffa83bc0c2cf$var$domComponentCache[elementType];
        if (!res) {
            res = (0, $eF4cA.forwardRef)($125d71e757f7ebd5$var$$7230ffa83bc0c2cf$var$DOMElement.bind(null, elementType));
            $125d71e757f7ebd5$var$$7230ffa83bc0c2cf$var$domComponentCache[elementType] = res;
        }
        return res;
    }
});

});
parcelRegister("lhKAD", function(module, exports) {

$parcel$export(module.exports, "mergeProps", () => $2a1ff9b396fcb6c5$export$9d1611c77c2fe928);

var $d8j5I = parcelRequire("d8j5I");

var $25dFS = parcelRequire("25dFS");

var $bkjeZ = parcelRequire("bkjeZ");

var $hkwY6 = parcelRequire("hkwY6");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2a1ff9b396fcb6c5$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $d8j5I.chain)(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (0, $hkwY6.default)(a, b);
            else if (key === 'id' && a && b) result.id = (0, $25dFS.mergeIds)(a, b);
            else if (key === 'ref' && a && b) result.ref = (0, $bkjeZ.mergeRefs)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

});
parcelRegister("d8j5I", function(module, exports) {

$parcel$export(module.exports, "chain", () => $a8b66f2030c1d79d$export$e08e3b67e392101e);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $a8b66f2030c1d79d$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}

});

parcelRegister("25dFS", function(module, exports) {

$parcel$export(module.exports, "useId", () => $a185733e93e2cef0$export$f680877a34711e37);
$parcel$export(module.exports, "mergeIds", () => $a185733e93e2cef0$export$cd8c9cb68f842629);
$parcel$export(module.exports, "useSlotId", () => $a185733e93e2cef0$export$b4cc09c592e8fdb8);

var $4skXn = parcelRequire("4skXn");

var $hWe38 = parcelRequire("hWe38");

var $axOIF = parcelRequire("axOIF");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $a185733e93e2cef0$var$$390e54f620492c70$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $a185733e93e2cef0$export$d41a04c74483c6ef = new Map();
// This allows us to clean up the idsUpdaterMap when the id is no longer used.
// Map is a strong reference, so unused ids wouldn't be cleaned up otherwise.
// This can happen in suspended components where mount/unmount is not called.
let $a185733e93e2cef0$var$$390e54f620492c70$var$registry;
if (typeof FinalizationRegistry !== 'undefined') $a185733e93e2cef0$var$$390e54f620492c70$var$registry = new FinalizationRegistry((heldValue)=>{
    $a185733e93e2cef0$export$d41a04c74483c6ef.delete(heldValue);
});
let $a185733e93e2cef0$var$$390e54f620492c70$var$registeredIds = new WeakMap();
function $a185733e93e2cef0$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $eF4cA.useState)(defaultId);
    let nextId = (0, $eF4cA.useRef)(null);
    let res = (0, $hWe38.useSSRSafeId)(value);
    let cleanupRef = (0, $eF4cA.useRef)(null);
    // These are intentionally disabled the compiler, these functions just read the identity
    // of the ref, not the value inside current.
    // oxlint-disable-next-line react/react-compiler
    let registeredId = $a185733e93e2cef0$var$$390e54f620492c70$var$registeredIds.get(cleanupRef);
    if ($a185733e93e2cef0$var$$390e54f620492c70$var$registry && registeredId !== res) {
        if (registeredId != null) $a185733e93e2cef0$var$$390e54f620492c70$var$registry.unregister(cleanupRef);
        // oxlint-disable-next-line react/react-compiler
        $a185733e93e2cef0$var$$390e54f620492c70$var$registry.register(cleanupRef, res, cleanupRef);
        // oxlint-disable-next-line react/react-compiler
        $a185733e93e2cef0$var$$390e54f620492c70$var$registeredIds.set(cleanupRef, res);
    }
    if ($a185733e93e2cef0$var$$390e54f620492c70$var$canUseDOM) {
        const cacheIdRef = $a185733e93e2cef0$export$d41a04c74483c6ef.get(res);
        // oxlint-disable-next-line react/react-compiler
        if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
        else $a185733e93e2cef0$export$d41a04c74483c6ef.set(res, [
            nextId
        ]);
    }
    (0, $4skXn.useLayoutEffect)(()=>{
        let r = res;
        return ()=>{
            // In Suspense, the cleanup function may be not called
            // when it is though, also remove it from the finalization registry.
            if ($a185733e93e2cef0$var$$390e54f620492c70$var$registry) {
                $a185733e93e2cef0$var$$390e54f620492c70$var$registry.unregister(cleanupRef);
                $a185733e93e2cef0$var$$390e54f620492c70$var$registeredIds.delete(cleanupRef);
            }
            $a185733e93e2cef0$export$d41a04c74483c6ef.delete(r);
        };
    }, [
        res
    ]);
    (0, $eF4cA.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) setValue(newId);
        return ()=>{
            if (newId) nextId.current = null;
        };
    });
    return res;
}
function $a185733e93e2cef0$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdsA = $a185733e93e2cef0$export$d41a04c74483c6ef.get(idA);
    if (setIdsA) {
        setIdsA.forEach((ref)=>ref.current = idB);
        return idB;
    }
    let setIdsB = $a185733e93e2cef0$export$d41a04c74483c6ef.get(idB);
    if (setIdsB) {
        setIdsB.forEach((ref)=>ref.current = idA);
        return idA;
    }
    return idB;
}
function $a185733e93e2cef0$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $a185733e93e2cef0$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $axOIF.useValueEffect)(id);
    let updateId = (0, $eF4cA.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    // oxlint-disable-next-line react/react-compiler
    }, [
        id,
        setResolvedId
    ]);
    (0, $4skXn.useLayoutEffect)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}

});
parcelRegister("4skXn", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $6736905945f5a69b$export$e5c5a5f917a5871c);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6736905945f5a69b$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useLayoutEffect : ()=>{};

});

parcelRegister("hWe38", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", () => $d690c424be65157d$export$535bd6ca7f90a273);
$parcel$export(module.exports, "useSSRSafeId", () => $d690c424be65157d$export$619500959fc48b26);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $d690c424be65157d$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $d690c424be65157d$var$$c7eafbbe1ea5834e$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext($d690c424be65157d$var$$c7eafbbe1ea5834e$var$defaultContext);
const $d690c424be65157d$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(false);
// This is only used in React < 18.
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $eF4cA.useContext)($d690c424be65157d$var$$c7eafbbe1ea5834e$var$SSRContext);
    let counter = $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useCounter(cur === $d690c424be65157d$var$$c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $eF4cA.useState)(true);
    let value = (0, $eF4cA.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $d690c424be65157d$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $eF4cA.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d690c424be65157d$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d690c424be65157d$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $d690c424be65157d$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $d690c424be65157d$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d690c424be65157d$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $d690c424be65157d$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $d690c424be65157d$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, $eF4cA.useContext)($d690c424be65157d$var$$c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, $eF4cA.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $d690c424be65157d$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $d690c424be65157d$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $d690c424be65157d$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $eF4cA.useContext)($d690c424be65157d$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $d690c424be65157d$var$$c7eafbbe1ea5834e$var$defaultContext && $d690c424be65157d$var$$c7eafbbe1ea5834e$var$canUseDOM;
    let counter = $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useId();
    let [didSSR] = (0, $eF4cA.useState)($d690c424be65157d$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$d690c424be65157d$var$$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $d690c424be65157d$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useId'] === 'function' ? $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $d690c424be65157d$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $d690c424be65157d$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $d690c424be65157d$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useSyncExternalStore']($d690c424be65157d$var$$c7eafbbe1ea5834e$var$subscribe, $d690c424be65157d$var$$c7eafbbe1ea5834e$var$getSnapshot, $d690c424be65157d$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $eF4cA.useContext)($d690c424be65157d$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}

});

parcelRegister("axOIF", function(module, exports) {

$parcel$export(module.exports, "useValueEffect", () => $20246dd839154d6e$export$14d238f342723f25);

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $20246dd839154d6e$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $eF4cA.useState)(defaultValue);
    // Keep an up to date copy of value in a ref so we can access the current value in the generator.
    // This allows us to maintain a stable queue function.
    let currValue = (0, $eF4cA.useRef)(value);
    let effect = (0, $eF4cA.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $eF4cA.useRef)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (currValue.current === newValue.value) nextRef.current();
        else setValue(newValue.value);
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        currValue.current = value;
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (0, $eF4cA.useCallback)((fn)=>{
        effect.current = fn(currValue.current);
        nextRef.current();
    }, [
        nextRef
    ]);
    return [
        value,
        queue
    ];
}

});


parcelRegister("bkjeZ", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $10810428db8665e6$export$c9058316764c140e);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $10810428db8665e6$export$c9058316764c140e(...refs) {
    if (refs.length === 1 && refs[0]) return refs[0];
    return (value)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $10810428db8665e6$var$$4064df0d6f9620e1$var$setRef(ref, value);
            hasCleanup ||= typeof cleanup == 'function';
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            cleanups.forEach((cleanup, i)=>{
                if (typeof cleanup === 'function') cleanup();
                else $10810428db8665e6$var$$4064df0d6f9620e1$var$setRef(refs[i], null);
            });
        };
    };
}
function $10810428db8665e6$var$$4064df0d6f9620e1$var$setRef(ref, value) {
    if (typeof ref === 'function') return ref(value);
    else if (ref != null) ref.current = value;
}

});

parcelRegister("hkwY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5e54757405747b$export$2e2bcd8739ae039);
function $1b5e54757405747b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $1b5e54757405747b$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $1b5e54757405747b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $1b5e54757405747b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $1b5e54757405747b$export$2e2bcd8739ae039 = $1b5e54757405747b$export$4f5d2d50c9deca37;

});


parcelRegister("26CkO", function(module, exports) {

$parcel$export(module.exports, "useObjectRef", () => $95f970a1d10aa9ba$export$4338b53315abf666);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $95f970a1d10aa9ba$export$4338b53315abf666(ref) {
    const objRef = (0, $eF4cA.useRef)(null);
    const cleanupRef = (0, $eF4cA.useRef)(undefined);
    const refEffect = (0, $eF4cA.useCallback)((instance)=>{
        if (typeof ref === 'function') {
            const refCallback = ref;
            const refCleanup = refCallback(instance);
            return ()=>{
                if (typeof refCleanup === 'function') refCleanup();
                else refCallback(null);
            };
        } else if (ref) {
            // oxlint-disable-next-line react/react-compiler
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        }
    }, [
        ref
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (cleanupRef.current) {
                    cleanupRef.current();
                    cleanupRef.current = undefined;
                }
                if (value != null) cleanupRef.current = refEffect(value);
            }
        }), [
        refEffect
    ]);
}

});



parcelRegister("hgdoa", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $db6e65edf3c72315$export$4c260019440d418f);

var $fDYaM = parcelRequire("fDYaM");

var $3usOD = parcelRequire("3usOD");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $db6e65edf3c72315$export$6311e7ab80ef752f = (0, $eF4cA.createContext)({});
const $db6e65edf3c72315$export$4c260019440d418f = (0, $eF4cA.forwardRef)(function Toolbar(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $db6e65edf3c72315$export$6311e7ab80ef752f);
    let { toolbarProps: toolbarProps } = (0, $3usOD.useToolbar)(props, ref);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            orientation: props.orientation || 'horizontal'
        },
        defaultClassName: 'react-aria-Toolbar'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, toolbarProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'horizontal'
    }, renderProps.children);
});

});
parcelRegister("3usOD", function(module, exports) {

$parcel$export(module.exports, "useToolbar", () => $2f9cb8be91d07413$export$fa142eb1681c520);

var $6pgkA = parcelRequire("6pgkA");

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2f9cb8be91d07413$export$fa142eb1681c520(props, ref) {
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, orientation: orientation = 'horizontal' } = props;
    let [isInToolbar, setInToolbar] = (0, $eF4cA.useState)(false);
    (0, $4skXn.useLayoutEffect)(()=>{
        setInToolbar(!!(ref.current && ref.current.parentElement?.closest('[role="toolbar"]')));
    });
    const { direction: direction } = (0, $1ntKq.useLocale)();
    const shouldReverse = direction === 'rtl' && orientation === 'horizontal';
    // oxlint-disable-next-line react/react-compiler
    let focusManager = (0, $6pgkA.createFocusManager)(ref);
    const onKeyDown = (e)=>{
        // don't handle portalled events
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
        if (orientation === 'horizontal' && e.key === 'ArrowRight' || orientation === 'vertical' && e.key === 'ArrowDown') {
            if (shouldReverse) focusManager.focusPrevious();
            else focusManager.focusNext();
        } else if (orientation === 'horizontal' && e.key === 'ArrowLeft' || orientation === 'vertical' && e.key === 'ArrowUp') {
            if (shouldReverse) focusManager.focusNext();
            else focusManager.focusPrevious();
        } else if (e.key === 'Tab') {
            // When the tab key is pressed, we want to move focus
            // out of the entire toolbar. To do this, move focus
            // to the first or last focusable child, and let the
            // browser handle the Tab key as usual from there.
            lastFocused.current = (0, $fvyIQ.getActiveElement)();
            if (e.shiftKey) focusManager.focusFirst();
            else focusManager.focusLast();
            return;
        } else return;
        // Prevent arrow keys from being handled by nested action groups.
        e.stopPropagation();
        e.preventDefault();
    };
    // Record the last focused child when focus moves out of the toolbar.
    const lastFocused = (0, $eF4cA.useRef)(null);
    const onBlur = (e)=>{
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, e.relatedTarget) && !lastFocused.current) lastFocused.current = (0, $fvyIQ.getEventTarget)(e);
    };
    // Restore focus to the last focused child when focus returns into the toolbar.
    // If the element was removed, do nothing, either the first item in the first group,
    // or the last item in the last group will be focused, depending on direction.
    const onFocus = (e)=>{
        if (lastFocused.current && !(0, $fvyIQ.nodeContains)(e.currentTarget, e.relatedTarget) && (0, $fvyIQ.nodeContains)(ref.current, (0, $fvyIQ.getEventTarget)(e))) {
            lastFocused.current?.focus();
            lastFocused.current = null;
        }
    };
    return {
        toolbarProps: {
            ...(0, $fVfXf.filterDOMProps)(props, {
                labelable: true
            }),
            role: !isInToolbar ? 'toolbar' : 'group',
            'aria-orientation': orientation,
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabel == null ? ariaLabelledBy : undefined,
            onKeyDownCapture: !isInToolbar ? onKeyDown : undefined,
            onFocusCapture: !isInToolbar ? onFocus : undefined,
            onBlurCapture: !isInToolbar ? onBlur : undefined
        }
    };
}

});
parcelRegister("6pgkA", function(module, exports) {

$parcel$export(module.exports, "FocusScope", () => $5fc6a23c5c8d2425$export$20e40289641fbbb6);
$parcel$export(module.exports, "getFocusableTreeWalker", () => $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa);
$parcel$export(module.exports, "isElementInChildOfActiveScope", () => $5fc6a23c5c8d2425$export$1258395f99bf9cbf);
$parcel$export(module.exports, "createFocusManager", () => $5fc6a23c5c8d2425$export$c5251b9e124bf29);

var $3xzD4 = parcelRequire("3xzD4");

var $eNuje = parcelRequire("eNuje");

var $fvyIQ = parcelRequire("fvyIQ");

var $YxOvP = parcelRequire("YxOvP");

var $7ByPJ = parcelRequire("7ByPJ");

var $11FxZ = parcelRequire("11FxZ");

var $3OYqT = parcelRequire("3OYqT");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
const $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT = 'react-aria-focus-scope-restore';
let $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = null;
function $5fc6a23c5c8d2425$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $eF4cA.useRef)(null);
    let endRef = (0, $eF4cA.useRef)(null);
    let scopeRef = (0, $eF4cA.useRef)([]);
    let { parentNode: parentNode } = (0, $eF4cA.useContext)($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $eF4cA.useMemo)(()=>new $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $5fc6a23c5c8d2425$export$d06fae2ee68b101e.root;
        if ($5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope && !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isAncestorScope($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope, parent.scopeRef)) {
            let activeNode = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $5fc6a23c5c8d2425$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        let node = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current?.nextSibling;
        let nodes = [];
        let stopPropagation = (e)=>e.stopPropagation();
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return ()=>{
            for (let node of nodes)node.removeEventListener($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT, stopPropagation);
        };
    }, [
        children
    ]);
    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useFocusContainment(scopeRef, contain);
    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useAutoFocus(scopeRef, autoFocus);
    (0, $eF4cA.useEffect)(()=>{
        const activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined));
        let scope = null;
        if ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $5fc6a23c5c8d2425$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        return ()=>{
            // Scope may have been re-parented.
            let parentScope = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scopeRef)?.parent?.scopeRef ?? null;
            if ((scopeRef === $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope || $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isAncestorScope(scopeRef, $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope)) && (!parentScope || $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(parentScope))) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = parentScope;
            $5fc6a23c5c8d2425$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    // oxlint-disable-next-line react/react-compiler
    let focusManager = (0, $eF4cA.useMemo)(()=>$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $eF4cA.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $5fc6a23c5c8d2425$export$10c5169755ce7bd7() {
    return (0, $eF4cA.useContext)($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$FocusContext)?.focusManager;
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(scope[0] ?? undefined));
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(scope[0] ?? undefined));
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) {
    let scope = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getRadiosInGroup(element) {
    if (!element.form) return Array.from((0, $7ByPJ.getOwnerDocument)(element).querySelectorAll(`input[type="radio"][name="${CSS.escape(element.name)}"]`)).filter((radio)=>!radio.form);
    // namedItem returns RadioNodeList (iterable) for 2+ elements, but a single Element for exactly 1.
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormControlsCollection/namedItem
    const radioList = element.form.elements.namedItem(element.name);
    let ownerWindow = (0, $7ByPJ.getOwnerWindow)(element);
    if (radioList instanceof ownerWindow.RadioNodeList) return Array.from(radioList).filter((el)=>el instanceof ownerWindow.HTMLInputElement);
    if (radioList instanceof ownerWindow.HTMLInputElement) return [
        radioList
    ];
    return [];
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isTabbableRadio(element) {
    if (element.checked) return true;
    const radios = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getRadiosInGroup(element);
    return radios.length > 0 && !radios.some((radio)=>radio.checked);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $eF4cA.useRef)(undefined);
    let raf = (0, $eF4cA.useRef)(undefined);
    (0, $4skXn.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
            let scope = scopeRef.current;
            if (!scope || !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) {
                $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nextElement, true);
                if (nextElement instanceof (0, $7ByPJ.getOwnerWindow)(nextElement).HTMLInputElement) nextElement.select();
            }
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope || $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isAncestorScope($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope, scopeRef)) && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope((0, $fvyIQ.getEventTarget)(e), scopeRef.current)) {
                $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
                focusedNode.current = (0, $fvyIQ.getEventTarget)(e);
            } else if ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) && !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope((0, $fvyIQ.getEventTarget)(e), scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(focusedNode.current);
                else if ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope.current) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusFirstInScope($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope.current);
            } else if ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef)) focusedNode.current = (0, $fvyIQ.getEventTarget)(e);
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Patches infinite focus coersion loop for Android Talkback where the user isn't able to move the virtual cursor
                // if within a containing focus scope. Bug filed against Chrome: https://issuetracker.google.com/issues/384844019.
                // Note that this means focus can leave focus containing modals due to this, but it is isolated to Chrome Talkback.
                let modality = (0, $YxOvP.getInteractionModality)();
                let shouldSkipFocusRestore = (modality === 'virtual' || modality === null) && (0, $11FxZ.isAndroid)() && (0, $11FxZ.isChrome)();
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                let activeElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
                if (!shouldSkipFocusRestore && activeElement && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) && !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(activeElement, scopeRef)) {
                    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
                    let target = (0, $fvyIQ.getEventTarget)(e);
                    if (target && target.isConnected) {
                        focusedNode.current = target;
                        $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(focusedNode.current);
                    } else if ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope.current) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusFirstInScope($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener('keydown', onKeyDown, false);
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope?.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        scope?.forEach((element)=>element.addEventListener('focusout', onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener('keydown', onKeyDown, false);
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope?.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
            scope?.forEach((element)=>element.removeEventListener('focusout', onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInAnyScope(element) {
    return $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(element);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>(0, $fvyIQ.nodeContains)(node, element));
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $5fc6a23c5c8d2425$export$d06fae2ee68b101e.traverse($5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $5fc6a23c5c8d2425$export$1258395f99bf9cbf(element) {
    return $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(element, $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isAncestorScope(ancestor, scope) {
    let parent = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scope)?.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $eNuje.focusSafely)(element);
    } catch  {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch  {
    // ignore
    }
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
    let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getScopeRoot(scope);
        walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    // TreeWalker.nextNode() returns null when the scope contains no focusable element.
    return nextNode;
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusFirstInScope(scope, tabbable = true) {
    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getFirstInScope(scope, tabbable));
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useRef(autoFocus);
    (0, $eF4cA.useEffect)(()=>{
        if (autoFocusRef.current) {
            $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
            const ownerDocument = (0, $7ByPJ.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope((0, $fvyIQ.getActiveElement)(ownerDocument), $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope.current) && scopeRef.current) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $4skXn.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = (0, $fvyIQ.getEventTarget)(e);
            if ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(target, scopeRef.current)) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
            else if (!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInAnyScope(target)) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = null;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope?.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope?.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldRestoreFocus(scopeRef) {
    let scope = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return scope?.scopeRef === scopeRef;
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (0, $eF4cA.useRef)(typeof document !== 'undefined' ? (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined)) : null);
    (0, $4skXn.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope || $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isAncestorScope($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope, scopeRef)) && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope((0, $fvyIQ.getActiveElement)(ownerDocument), scopeRef.current)) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope?.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope?.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(focusedElement, scopeRef) || !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldRestoreFocus(scopeRef)) return;
            let treeNode = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !nodeToRestore.isConnected || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(nextElement, scopeRef));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        treeNode.nodeToRestore = nodeToRestoreRef.current ?? undefined;
        return ()=>{
            let treeNode = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            let activeElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
            if (restoreFocus && nodeToRestore && (activeElement && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInChildScope(activeElement, scopeRef) || activeElement === ownerDocument.body && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $5fc6a23c5c8d2425$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && // TODO: this is probably a false positive based on naming, it's not a real ref, rename.
                            // oxlint-disable-next-line react-hooks/exhaustive-deps
                            treeNode.scopeRef.current && $5fc6a23c5c8d2425$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                // oxlint-disable-next-line react-hooks/exhaustive-deps
                                let node = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$getFirstInScope(treeNode.scopeRef.current, true);
                                // The scope may have nothing focusable in it, e.g. if its focusable
                                // content was removed or hidden. Keep walking up in that case.
                                if (node) {
                                    $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$restoreFocusToElement(node);
                                    return;
                                }
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(node);
}
function $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(root, opts, scope) {
    let filter = opts?.tabbable ? (0, $3OYqT.isTabbable) : (0, $3OYqT.isFocusable);
    // Ensure that root is an Element or fall back appropriately
    let rootElement = root?.nodeType === Node.ELEMENT_NODE ? root : null;
    // Determine the document to use
    let doc = (0, $7ByPJ.getOwnerDocument)(rootElement);
    // Create a TreeWalker, ensuring the root is an Element or Document
    let walker = (0, $3xzD4.createShadowTreeWalker)(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // Skip nodes inside the starting node.
            if ((0, $fvyIQ.nodeContains)(opts?.from, node)) return NodeFilter.FILTER_REJECT;
            if (opts?.tabbable && node.tagName === 'INPUT' && node.getAttribute('type') === 'radio') {
                // If the radio is in a form, we can get all the other radios by name
                if (!$5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isTabbableRadio(node)) return NodeFilter.FILTER_REJECT;
                // If the radio is in the same group as the current node and none are selected, we can skip it
                if (walker.currentNode.tagName === 'INPUT' && walker.currentNode.type === 'radio' && walker.currentNode.name === node.name) return NodeFilter.FILTER_REJECT;
            }
            if (filter(node) && (!scope || $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(node, scope)) && (!opts?.accept || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts?.from) walker.currentNode = opts.from;
    return walker;
}
function $5fc6a23c5c8d2425$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(root));
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if ((0, $fvyIQ.nodeContains)(root, node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(root));
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if ((0, $fvyIQ.nodeContains)(root, node)) walker.currentNode = node;
            else {
                let next = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$last(walker);
                if (next) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(next, true);
                return next ?? null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(previousNode, true);
            return previousNode ?? null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $5fc6a23c5c8d2425$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$last(walker);
            if (next) $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$focusElement(next, true);
            return next ?? null;
        }
    };
}
function $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$Tree {
    constructor(){
        this.fastMap = new Map();
        this.root = new $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent ?? null);
        if (!parentNode) return;
        let node = new $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        let newTree = new $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$Tree();
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, node.parent?.scopeRef ?? null, node.nodeToRestore);
        return newTree;
    }
}
class $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$TreeNode {
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
}
let $5fc6a23c5c8d2425$export$d06fae2ee68b101e = new $5fc6a23c5c8d2425$var$$535772f9d2c1f38d$var$Tree();

});
parcelRegister("3xzD4", function(module, exports) {

$parcel$export(module.exports, "createShadowTreeWalker", () => $bd56694d33d4b7f8$export$4d0f8be8b12a7ef6);

var $fvyIQ = parcelRequire("fvyIQ");

var $6ReTa = parcelRequire("6ReTa");
// https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/ShadowTreeWalker.ts
class $bd56694d33d4b7f8$export$63eb3ababa9c55c4 {
    constructor(doc, root, whatToShow, filter){
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = (node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                const shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    if (typeof this.filter === 'function') return this.filter(node);
                    else if (this.filter?.acceptNode) return this.filter.acceptNode(node);
                    else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter ?? null;
        this.whatToShow = whatToShow ?? NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        const shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
    get currentNode() {
        return this._currentNode;
    }
    set currentNode(node) {
        if (!(0, $fvyIQ.nodeContains)(this.root, node)) throw new Error('Cannot set currentNode to a node that is not contained by the root node.');
        const walkers = [];
        let curNode = node;
        let currentWalkerCurrentNode = node;
        this._currentNode = node;
        while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            const shadowRoot = curNode;
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            walkers.push(walker);
            walker.currentNode = currentWalkerCurrentNode;
            this._currentSetFor.add(walker);
            curNode = currentWalkerCurrentNode = shadowRoot.host;
        } else curNode = curNode.parentNode;
        const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
            acceptNode: this._acceptNode
        });
        walkers.push(walker);
        walker.currentNode = currentWalkerCurrentNode;
        this._currentSetFor.add(walker);
        this._walkerStack = walkers;
    }
    get doc() {
        return this._doc;
    }
    firstChild() {
        let currentNode = this.currentNode;
        let newNode = this.nextNode();
        if (!(0, $fvyIQ.nodeContains)(currentNode, newNode)) {
            this.currentNode = currentNode;
            return null;
        }
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    lastChild() {
        let walker = this._walkerStack[0];
        let newNode = walker.lastChild();
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    nextNode() {
        const nextNode = this._walkerStack[0].nextNode();
        if (nextNode) {
            const shadowRoot = nextNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(nextNode);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    this.currentNode = nextNode;
                    return nextNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (nextNode) this.currentNode = nextNode;
            return nextNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    previousNode() {
        const currentWalker = this._walkerStack[0];
        if (currentWalker.currentNode === currentWalker.root) {
            if (this._currentSetFor.has(currentWalker)) {
                this._currentSetFor.delete(currentWalker);
                if (this._walkerStack.length > 1) {
                    this._walkerStack.shift();
                    let newNode = this.previousNode();
                    if (newNode) this.currentNode = newNode;
                    return newNode;
                } else return null;
            }
            return null;
        }
        const previousNode = currentWalker.previousNode();
        if (previousNode) {
            const shadowRoot = previousNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(previousNode);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    if (previousNode) this.currentNode = previousNode;
                    return previousNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.lastChild();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (previousNode) this.currentNode = previousNode;
            return previousNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.previousNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    /**
   * @deprecated
   */ nextSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
   * @deprecated
   */ previousSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
   * @deprecated
   */ parentNode() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
}
function $bd56694d33d4b7f8$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
    if ((0, $6ReTa.shadowDOM)()) return new $bd56694d33d4b7f8$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
    return doc.createTreeWalker(root, whatToShow, filter);
}

});
parcelRegister("fvyIQ", function(module, exports) {

$parcel$export(module.exports, "nodeContains", () => $433b9182868adf14$export$4282f70798064fe0);
$parcel$export(module.exports, "getActiveElement", () => $433b9182868adf14$export$cd4e5573fbe2b576);
$parcel$export(module.exports, "getEventTarget", () => $433b9182868adf14$export$e58f029f0fbfdb29);
$parcel$export(module.exports, "getPropagationTargets", () => $433b9182868adf14$export$da7af4355d792141);
$parcel$export(module.exports, "isFocusWithin", () => $433b9182868adf14$export$b4f377a2b6254582);

var $7ByPJ = parcelRequire("7ByPJ");

var $6ReTa = parcelRequire("6ReTa");
// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
/* eslint-disable rsp-rules/no-non-shadow-contains, rsp-rules/safe-event-target */ function $433b9182868adf14$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $6ReTa.shadowDOM)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode != null){
        if (currentNode === node) return true;
        if (typeof currentNode.assignedElements !== 'function' && currentNode.assignedSlot?.parentNode) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $7ByPJ.isShadowRoot)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
const $433b9182868adf14$export$cd4e5573fbe2b576 = (doc = document)=>{
    if (!(0, $6ReTa.shadowDOM)()) return doc.activeElement;
    let activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && activeElement.shadowRoot?.activeElement)activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $433b9182868adf14$export$e58f029f0fbfdb29(event) {
    if ((0, $6ReTa.shadowDOM)() && event.target instanceof Element && event.target.shadowRoot) {
        if ('composedPath' in event) return event.composedPath()[0] ?? null;
        else if ('composedPath' in event.nativeEvent) return event.nativeEvent.composedPath()[0] ?? null;
    }
    return event.target;
}
function $433b9182868adf14$export$da7af4355d792141(from, to) {
    // If `to` is coming from a ref, its type technically allows `null`.
    // In practice, this function will generally be called from within a useEffect.
    // If the ref has not resolved by that point, then a coding error has been made.
    // Better to return an empty array than `[window]`, which may appear to work
    // in the light DOM, but fail in the shadow DOM.
    if (to === null) return [];
    to = to ?? (0, $7ByPJ.getOwnerWindow)(from);
    let targets = [
        to
    ];
    if (!(0, $6ReTa.shadowDOM)() || !from || from === to) return targets;
    // The root `to` itself lives in. The event already reaches `to` once
    // it is inside this root, so we must NOT collect this root or anything above
    // it — only the shadow roots strictly between `refNode` and `to`.
    // `window` has no getRootNode; its boundary is the document, which the walk
    // reaches naturally (the document is not a ShadowRoot, so the loop exits).
    let toRoot = 'getRootNode' in to ? to.getRootNode() : null;
    let current = from.getRootNode() ?? null;
    while((0, $7ByPJ.isShadowRoot)(current) && current !== toRoot){
        // order shouldn't matter
        targets.push(current);
        current = current.host.getRootNode();
    }
    return targets;
}
function $433b9182868adf14$export$b4f377a2b6254582(node) {
    if (!node) return false;
    // Get the active element within the node's parent shadow root (or the document). Can return null.
    let root = node.getRootNode();
    let ownerWindow = (0, $7ByPJ.getOwnerWindow)(node);
    if (!(root instanceof ownerWindow.Document || root instanceof ownerWindow.ShadowRoot)) return false;
    let activeElement = root.activeElement;
    // Check if the active element is within this node. These nodes are within the same shadow root.
    return activeElement != null && node.contains(activeElement);
}

});
parcelRegister("7ByPJ", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $9cc8494d98686627$export$b204af158042fbac);
$parcel$export(module.exports, "getOwnerWindow", () => $9cc8494d98686627$export$f21a1ffae260145a);
$parcel$export(module.exports, "isNode", () => $9cc8494d98686627$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isShadowRoot", () => $9cc8494d98686627$export$af51f0f06c0f328a);
$parcel$export(module.exports, "addEvent", () => $9cc8494d98686627$export$f531f92e2a15358f);
$parcel$export(module.exports, "setStyle", () => $9cc8494d98686627$export$37a5fde709c1db82);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9cc8494d98686627$export$b204af158042fbac = (target)=>{
    if ($9cc8494d98686627$var$$d447af545b77c9f1$var$isWindow(target)) return target.document;
    if ($9cc8494d98686627$export$62858bae88b53fd0(target)) return target;
    // @ts-expect-error Ensure safe access in SSR environments.
    return target?.ownerDocument ?? (typeof document !== 'undefined' ? document : undefined);
};
const $9cc8494d98686627$export$f21a1ffae260145a = (target)=>{
    let ownerDocument = $9cc8494d98686627$export$b204af158042fbac(target);
    // @ts-expect-error Ensure safe access in SSR environments.
    return ownerDocument?.defaultView ?? (typeof window !== 'undefined' ? window : undefined);
};
function $9cc8494d98686627$export$8ee0fc9ee280b4ee(value) {
    return value !== null && typeof value === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
/**
 * Type guard that checks if a value is a Window. Uses window self reference checks to
 * distinguish Window from other values.
 */ function $9cc8494d98686627$var$$d447af545b77c9f1$var$isWindow(value) {
    return typeof value === 'object' && value != null && 'window' in value && value.window === value;
}
function $9cc8494d98686627$export$62858bae88b53fd0(value) {
    return $9cc8494d98686627$export$8ee0fc9ee280b4ee(value) && value.nodeType === 9;
}
function $9cc8494d98686627$export$af51f0f06c0f328a(value) {
    // 11 = DOCUMENT_FRAGMENT_NODE
    return $9cc8494d98686627$export$8ee0fc9ee280b4ee(value) && value.nodeType === 11 && 'host' in value;
}
function $9cc8494d98686627$export$f531f92e2a15358f(target, event, listener, options) {
    if (listener == null || target == null) return ()=>{};
    let eventTargets = Array.isArray(target) ? target : [
        target
    ];
    for (let eventTarget of eventTargets)eventTarget.addEventListener(event, listener, options);
    return ()=>{
        for (let eventTarget of eventTargets)eventTarget.removeEventListener(event, listener, options);
    };
}
function $9cc8494d98686627$export$37a5fde709c1db82(target, property, value, priority) {
    if (target == null) return ()=>{};
    let restore = new Array();
    let styleTargets = Array.isArray(target) ? target : [
        target
    ];
    for (let styleTarget of styleTargets){
        let initialValue = styleTarget.style.getPropertyValue(property);
        let initialPriority = styleTarget.style.getPropertyPriority(property);
        styleTarget.style.setProperty(property, value, priority);
        restore.unshift(()=>{
            if (initialValue) styleTarget.style.setProperty(property, initialValue, initialPriority);
            else styleTarget.style.removeProperty(property);
        });
    }
    return ()=>{
        for (let cleanup of restore)cleanup();
    };
}

});

parcelRegister("6ReTa", function(module, exports) {

$parcel$export(module.exports, "shadowDOM", () => $f7511f51bbbe337f$export$98658e8c59125e6a);
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $f7511f51bbbe337f$var$$6a20a7989e6c817a$var$_tableNestedRows = false;
let $f7511f51bbbe337f$var$$6a20a7989e6c817a$var$_shadowDOM = false;
function $f7511f51bbbe337f$export$d9d8a0f82de49530() {
    $f7511f51bbbe337f$var$$6a20a7989e6c817a$var$_tableNestedRows = true;
}
function $f7511f51bbbe337f$export$1b00cb14a96194e6() {
    return $f7511f51bbbe337f$var$$6a20a7989e6c817a$var$_tableNestedRows;
}
function $f7511f51bbbe337f$export$12b151d9882e9985() {
    $f7511f51bbbe337f$var$$6a20a7989e6c817a$var$_shadowDOM = true;
}
function $f7511f51bbbe337f$export$98658e8c59125e6a() {
    return $f7511f51bbbe337f$var$$6a20a7989e6c817a$var$_shadowDOM;
}

});



parcelRegister("eNuje", function(module, exports) {

$parcel$export(module.exports, "focusSafely", () => $ef39fe3dbf82ff17$export$80f3e147d781571c);

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $YxOvP = parcelRequire("YxOvP");

var $7ByPJ = parcelRequire("7ByPJ");

var $iUhPJ = parcelRequire("iUhPJ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ef39fe3dbf82ff17$export$80f3e147d781571c(element) {
    if (!element.isConnected) return;
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $7ByPJ.getOwnerDocument)(element);
    if ((0, $YxOvP.getInteractionModality)() === 'virtual') {
        let lastFocusedElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
        (0, $iUhPJ.runAfterTransition)(()=>{
            const activeElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
            // If focus did not move or focus was lost to the body, and the element is still in the document, focus it.
            if ((activeElement === lastFocusedElement || activeElement === ownerDocument.body) && element.isConnected) (0, $2jk5s.focusWithoutScrolling)(element);
        });
    } else (0, $2jk5s.focusWithoutScrolling)(element);
}

});
parcelRegister("2jk5s", function(module, exports) {

$parcel$export(module.exports, "focusWithoutScrolling", () => $ff8e33a9d13b7b88$export$de79e2c695e052f3);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ff8e33a9d13b7b88$export$de79e2c695e052f3(element) {
    element.focus({
        preventScroll: true
    });
}

});

parcelRegister("YxOvP", function(module, exports) {

$parcel$export(module.exports, "setInteractionModality", () => $b7babb4580f3648f$export$8397ddfc504fdb9a);
$parcel$export(module.exports, "isFocusVisible", () => $b7babb4580f3648f$export$b9b3dfddab17db27);
$parcel$export(module.exports, "getInteractionModality", () => $b7babb4580f3648f$export$630ff653c5ada6a9);
$parcel$export(module.exports, "getPointerType", () => $b7babb4580f3648f$export$887a228355cf7d95);
$parcel$export(module.exports, "useInteractionModality", () => $b7babb4580f3648f$export$98e20ec92f614cfe);
$parcel$export(module.exports, "useFocusVisible", () => $b7babb4580f3648f$export$ffd9e5021c1fb2d6);
$parcel$export(module.exports, "useFocusVisibleListener", () => $b7babb4580f3648f$export$ec71b4b83ac08ec3);

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $wjtfD = parcelRequire("wjtfD");

var $11FxZ = parcelRequire("11FxZ");

var $9J8wU = parcelRequire("9J8wU");

var $aGgVM = parcelRequire("aGgVM");

var $hWe38 = parcelRequire("hWe38");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality = null;
let $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType = 'keyboard';
const $b7babb4580f3648f$export$901e90a13c50a14e = new Set();
let $b7babb4580f3648f$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = false;
let $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b7babb4580f3648f$var$$8f5a2122b0992be3$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b7babb4580f3648f$export$901e90a13c50a14e)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus
 * styles visible.
 */ function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $11FxZ.isMac)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleKeyboardEvent(e) {
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
    if (!(0, $aGgVM.openLink).isOpening && $b7babb4580f3648f$var$$8f5a2122b0992be3$var$isValidKey(e)) {
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality = 'keyboard';
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType = 'keyboard';
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$triggerChangeHandlers('keyboard', e);
    }
}
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent(e) {
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality = 'pointer';
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType = 'pointerType' in e ? e.pointerType : 'mouse';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$triggerChangeHandlers('pointer', e);
    }
}
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleClickEvent(e) {
    if (!(0, $aGgVM.openLink).isOpening && (0, $9J8wU.isVirtualClick)(e)) {
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality = 'virtual';
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType = 'virtual';
    }
}
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleFocusEvent(e) {
    if (0, $wjtfD.ignoreFocusEvent) return;
    let target = (0, $fvyIQ.getEventTarget)(e);
    let ownerWindow = (0, $7ByPJ.getOwnerWindow)(target);
    let ownerDocument = (0, $7ByPJ.getOwnerDocument)(target);
    // When the window regains focus, the browser restores focus to the element that was focused
    // before, firing a focus event the user did not initiate. handleWindowBlur sets
    // hasBlurredWindowRecently so restored focus doesn't switch to virtual modality below, but
    // Safari fires the window/element focus pair twice when returning to a tab or app and the first
    // element focus event clears the flag, so re-arm it whenever the window itself is focused.
    // Like handleWindowBlur, this intentionally doesn't check isTrusted.
    if (target === ownerWindow) {
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = true;
        return;
    }
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (target === ownerDocument || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus && !$b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently) {
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality = 'virtual';
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType = 'virtual';
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$triggerChangeHandlers('virtual', e);
    }
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = false;
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = false;
}
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleWindowBlur() {
    if (0, $wjtfD.ignoreFocusEvent) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = false;
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasBlurredWindowRecently = true;
}
function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleInvalidEvent(e) {
    let startingActiveElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)((0, $fvyIQ.getEventTarget)(e)));
    queueMicrotask(()=>{
        // If focus was moved to a different element after the form became invalid,
        // then it was likely a forms library that moved focus to the first invalid field.
        // In this case, we want to set the modality to keyboard.
        if ((0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)((0, $fvyIQ.getEventTarget)(e))) !== startingActiveElement) $b7babb4580f3648f$export$8397ddfc504fdb9a('keyboard');
    });
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents(element) {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const windowObject = (0, $7ByPJ.getOwnerWindow)(element);
    const documentObject = (0, $7ByPJ.getOwnerDocument)(element);
    if ($b7babb4580f3648f$export$d90243b58daecda7.get(windowObject)) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    // defineProperty (not assignment) so this works even if `focus` is currently
    // a getter-only accessor — e.g. when @testing-library/user-event's setup()
    // has instrumented it. Plain assignment throws in that case.
    let focus = windowObject.HTMLElement.prototype.focus;
    Reflect.defineProperty(windowObject.HTMLElement.prototype, 'focus', {
        configurable: true,
        writable: true,
        value: function() {
            $b7babb4580f3648f$var$$8f5a2122b0992be3$var$hasEventBeforeFocus = true;
            focus.apply(this, arguments);
        }
    });
    documentObject.addEventListener('keydown', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleClickEvent, true);
    documentObject.addEventListener('invalid', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleInvalidEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $b7babb4580f3648f$var$$8f5a2122b0992be3$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b7babb4580f3648f$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b7babb4580f3648f$var$$8f5a2122b0992be3$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $7ByPJ.getOwnerWindow)(element);
    const documentObject = (0, $7ByPJ.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$b7babb4580f3648f$export$d90243b58daecda7.has(windowObject)) return;
    Reflect.defineProperty(windowObject.HTMLElement.prototype, 'focus', {
        configurable: true,
        writable: true,
        value: $b7babb4580f3648f$export$d90243b58daecda7.get(windowObject).focus
    });
    documentObject.removeEventListener('keydown', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleClickEvent, true);
    documentObject.removeEventListener('invalid', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleInvalidEvent, true);
    windowObject.removeEventListener('focus', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $b7babb4580f3648f$var$$8f5a2122b0992be3$var$handlePointerEvent, true);
    }
    $b7babb4580f3648f$export$d90243b58daecda7.delete(windowObject);
};
function $b7babb4580f3648f$export$2f1888112f558a7d(element) {
    const documentObject = (0, $7ByPJ.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $b7babb4580f3648f$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b7babb4580f3648f$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$b7babb4580f3648f$var$$8f5a2122b0992be3$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $b7babb4580f3648f$export$2f1888112f558a7d();
function $b7babb4580f3648f$export$b9b3dfddab17db27() {
    return $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality !== 'pointer';
}
function $b7babb4580f3648f$export$630ff653c5ada6a9() {
    return $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality;
}
function $b7babb4580f3648f$export$8397ddfc504fdb9a(modality) {
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality = modality;
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType = modality === 'pointer' ? 'mouse' : modality;
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$triggerChangeHandlers(modality, null);
}
function $b7babb4580f3648f$export$887a228355cf7d95() {
    return $b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentPointerType;
}
function $b7babb4580f3648f$export$98e20ec92f614cfe() {
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $eF4cA.useState)($b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality);
    (0, $eF4cA.useEffect)(()=>{
        let handler = ()=>{
            setModality($b7babb4580f3648f$var$$8f5a2122b0992be3$var$currentModality);
        };
        $b7babb4580f3648f$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $b7babb4580f3648f$export$901e90a13c50a14e.delete(handler);
        };
    }, []);
    return (0, $hWe38.useIsSSR)() ? null : modality;
}
const $b7babb4580f3648f$var$$8f5a2122b0992be3$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape
 * keys pressed) so that focus visible style can be properly set.
 */ function $b7babb4580f3648f$var$$8f5a2122b0992be3$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    let eventTarget = e ? (0, $fvyIQ.getEventTarget)(e) : undefined;
    let ownerDocument = (0, $7ByPJ.getOwnerDocument)(eventTarget);
    let ownerWindow = (0, $7ByPJ.getOwnerWindow)(eventTarget);
    const IHTMLInputElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof ownerWindow !== 'undefined' ? ownerWindow.HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof ownerWindow !== 'undefined' ? ownerWindow.KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    let activeElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
    isTextInput = isTextInput || activeElement instanceof IHTMLInputElement && !$b7babb4580f3648f$var$$8f5a2122b0992be3$var$nonTextInputTypes.has(activeElement.type) || activeElement instanceof IHTMLTextAreaElement || activeElement instanceof IHTMLElement && activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$b7babb4580f3648f$var$$8f5a2122b0992be3$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b7babb4580f3648f$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $eF4cA.useState)(autoFocus || $b7babb4580f3648f$export$b9b3dfddab17db27());
    $b7babb4580f3648f$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b7babb4580f3648f$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b7babb4580f3648f$var$$8f5a2122b0992be3$var$setupGlobalFocusEvents();
    (0, $eF4cA.useEffect)(()=>{
        if (opts?.enabled === false) return;
        let handler = (modality, e)=>{
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$b7babb4580f3648f$var$$8f5a2122b0992be3$var$isKeyboardFocusEvent(!!opts?.isTextInput, modality, e)) return;
            fn($b7babb4580f3648f$export$b9b3dfddab17db27());
        };
        $b7babb4580f3648f$export$901e90a13c50a14e.add(handler);
        return ()=>{
            $b7babb4580f3648f$export$901e90a13c50a14e.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("wjtfD", function(module, exports) {

$parcel$export(module.exports, "createSyntheticEvent", () => $2f11e7bfb6d300ab$export$525bc4921d56d4a);
$parcel$export(module.exports, "setEventTarget", () => $2f11e7bfb6d300ab$export$c2b7abe5d61ec696);
$parcel$export(module.exports, "useSyntheticBlurEvent", () => $2f11e7bfb6d300ab$export$715c682d09d639cc);
$parcel$export(module.exports, "ignoreFocusEvent", () => $2f11e7bfb6d300ab$export$fda7da73ab5d4c48);
$parcel$export(module.exports, "preventFocus", () => $2f11e7bfb6d300ab$export$cabe61c495ee3649);

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $3OYqT = parcelRequire("3OYqT");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2f11e7bfb6d300ab$export$525bc4921d56d4a(nativeEvent) {
    let event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = ()=>event.defaultPrevented;
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = ()=>event.cancelBubble;
    event.persist = ()=>{};
    return event;
}
function $2f11e7bfb6d300ab$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $2f11e7bfb6d300ab$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $eF4cA.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $eF4cA.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        let eventTarget = (0, $fvyIQ.getEventTarget)(e);
        if (eventTarget instanceof HTMLButtonElement || eventTarget instanceof HTMLInputElement || eventTarget instanceof HTMLTextAreaElement || eventTarget instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = eventTarget;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    let event = $2f11e7bfb6d300ab$export$525bc4921d56d4a(e);
                    onBlur?.(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    stateRef.current.observer?.disconnect();
                    let relatedTargetEl = target === (0, $fvyIQ.getActiveElement)() ? null : (0, $fvyIQ.getActiveElement)();
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        onBlur
    ]);
}
let $2f11e7bfb6d300ab$export$fda7da73ab5d4c48 = false;
function $2f11e7bfb6d300ab$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $3OYqT.isFocusable)(target, {
        skipVisibilityCheck: true
    }))target = target.parentElement;
    let ownerWindow = (0, $7ByPJ.getOwnerWindow)(target);
    let activeElement = (0, $fvyIQ.getActiveElement)(ownerWindow.document);
    if (!activeElement || activeElement === target) return;
    // Listen on the target's root (document or shadow root) so we catch focus events inside
    // shadow DOM; they do not reach the main window.
    let targetRoot = target?.getRootNode();
    let root = targetRoot != null && (0, $7ByPJ.isShadowRoot)(targetRoot) ? targetRoot : (0, $7ByPJ.getOwnerWindow)(target);
    // Focus is "moving to target" when it moves to the button or to a descendant of the button
    // (e.g. SVG icon)
    let isFocusMovingToTarget = (focusTarget)=>focusTarget === target || (0, $7ByPJ.isNode)(focusTarget) && (0, $fvyIQ.nodeContains)(target, focusTarget);
    // Blur/focusout events have their target as the element losing focus. Stop propagation when
    // that is the previously focused element (activeElement) or a descendant (e.g. in shadow DOM).
    let isBlurFromActiveElement = (eventTarget)=>eventTarget === activeElement || activeElement != null && (0, $7ByPJ.isNode)(eventTarget) && (0, $fvyIQ.nodeContains)(activeElement, eventTarget);
    $2f11e7bfb6d300ab$export$fda7da73ab5d4c48 = true;
    let isRefocusing = false;
    let onBlur = (e)=>{
        if (isBlurFromActiveElement((0, $fvyIQ.getEventTarget)(e)) || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusOut = (e)=>{
        if (isBlurFromActiveElement((0, $fvyIQ.getEventTarget)(e)) || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $2jk5s.focusWithoutScrolling)(activeElement);
                cleanup();
            }
        }
    };
    let onFocus = (e)=>{
        if (isFocusMovingToTarget((0, $fvyIQ.getEventTarget)(e)) || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusIn = (e)=>{
        if (isFocusMovingToTarget((0, $fvyIQ.getEventTarget)(e)) || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $2jk5s.focusWithoutScrolling)(activeElement);
                cleanup();
            }
        }
    };
    root.addEventListener('blur', onBlur, true);
    root.addEventListener('focusout', onFocusOut, true);
    root.addEventListener('focusin', onFocusIn, true);
    root.addEventListener('focus', onFocus, true);
    let cleanup = ()=>{
        cancelAnimationFrame(raf);
        root.removeEventListener('blur', onBlur, true);
        root.removeEventListener('focusout', onFocusOut, true);
        root.removeEventListener('focusin', onFocusIn, true);
        root.removeEventListener('focus', onFocus, true);
        $2f11e7bfb6d300ab$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    let raf = requestAnimationFrame(cleanup);
    return cleanup;
}

});
parcelRegister("3OYqT", function(module, exports) {

$parcel$export(module.exports, "isFocusable", () => $2490f3e06cb6e0ba$export$4c063cf1350e6fed);
$parcel$export(module.exports, "isTabbable", () => $2490f3e06cb6e0ba$export$bebd5a1431fec25d);

var $7ByPJ = parcelRequire("7ByPJ");

var $030rU = parcelRequire("030rU");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])',
    'permission'
];
const $2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$FOCUSABLE_ELEMENT_SELECTOR = $2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$TABBABLE_ELEMENT_SELECTOR = $2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $2490f3e06cb6e0ba$export$4c063cf1350e6fed(element, options) {
    return element.matches($2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$FOCUSABLE_ELEMENT_SELECTOR) && !$2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$isInert(element) && (options?.skipVisibilityCheck || (0, $030rU.isElementVisible)(element));
}
function $2490f3e06cb6e0ba$export$bebd5a1431fec25d(element) {
    return element.matches($2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$TABBABLE_ELEMENT_SELECTOR) && (0, $030rU.isElementVisible)(element) && !$2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$isInert(element);
}
function $2490f3e06cb6e0ba$var$$3b8b240c1bf84ab9$var$isInert(element) {
    let node = element;
    while(node != null){
        if (node instanceof (0, $7ByPJ.getOwnerWindow)(node).HTMLElement && node.inert) return true;
        node = node.parentElement;
    }
    return false;
}

});
parcelRegister("030rU", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", () => $a438b220bffaffe9$export$e989c0fffaa6b27a);

var $7ByPJ = parcelRequire("7ByPJ");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a438b220bffaffe9$var$$ae77152785188400$var$supportsCheckVisibility = typeof Element !== 'undefined' && 'checkVisibility' in Element.prototype;
function $a438b220bffaffe9$var$$ae77152785188400$var$isStyleVisible(element) {
    const windowObject = (0, $7ByPJ.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = (0, $7ByPJ.getOwnerWindow)(element);
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $a438b220bffaffe9$var$$ae77152785188400$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $a438b220bffaffe9$export$e989c0fffaa6b27a(element, childElement) {
    if ($a438b220bffaffe9$var$$ae77152785188400$var$supportsCheckVisibility) return element.checkVisibility({
        visibilityProperty: true
    }) && !element.closest('[data-react-aria-prevent-focus]');
    return element.nodeName !== '#comment' && $a438b220bffaffe9$var$$ae77152785188400$var$isStyleVisible(element) && $a438b220bffaffe9$var$$ae77152785188400$var$isAttributeVisible(element, childElement) && (!element.parentElement || $a438b220bffaffe9$export$e989c0fffaa6b27a(element.parentElement, element));
}

});



parcelRegister("11FxZ", function(module, exports) {

$parcel$export(module.exports, "isMac", () => $0ce0d2ea54f4b24d$export$9ac100e40613ea10);
$parcel$export(module.exports, "isIPhone", () => $0ce0d2ea54f4b24d$export$186c6964ca17d99);
$parcel$export(module.exports, "isIPad", () => $0ce0d2ea54f4b24d$export$7bef049ce92e4224);
$parcel$export(module.exports, "isIOS", () => $0ce0d2ea54f4b24d$export$fedb369cb70207f1);
$parcel$export(module.exports, "isAppleDevice", () => $0ce0d2ea54f4b24d$export$e1865c3bedcd822b);
$parcel$export(module.exports, "isWebKit", () => $0ce0d2ea54f4b24d$export$78551043582a6a98);
$parcel$export(module.exports, "isChrome", () => $0ce0d2ea54f4b24d$export$6446a186d09e379e);
$parcel$export(module.exports, "isAndroid", () => $0ce0d2ea54f4b24d$export$a11b0059900ceec8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testUserAgent(re) {
    if (typeof window === 'undefined' || window.navigator == null) return false;
    let brands = window.navigator['userAgentData']?.brands;
    return Array.isArray(brands) && brands.some((brand)=>re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $0ce0d2ea54f4b24d$export$9ac100e40613ea10 = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testPlatform(/^Mac/i);
});
const $0ce0d2ea54f4b24d$export$186c6964ca17d99 = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testPlatform(/^iPhone/i);
});
const $0ce0d2ea54f4b24d$export$7bef049ce92e4224 = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $0ce0d2ea54f4b24d$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $0ce0d2ea54f4b24d$export$fedb369cb70207f1 = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$export$186c6964ca17d99() || $0ce0d2ea54f4b24d$export$7bef049ce92e4224();
});
const $0ce0d2ea54f4b24d$export$e1865c3bedcd822b = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$export$9ac100e40613ea10() || $0ce0d2ea54f4b24d$export$fedb369cb70207f1();
});
const $0ce0d2ea54f4b24d$export$78551043582a6a98 = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testUserAgent(/AppleWebKit/i) && ($0ce0d2ea54f4b24d$export$fedb369cb70207f1() || !$0ce0d2ea54f4b24d$export$6446a186d09e379e());
});
const $0ce0d2ea54f4b24d$export$95df08bae54cb4df = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$export$78551043582a6a98() && !$0ce0d2ea54f4b24d$export$6446a186d09e379e() && !$0ce0d2ea54f4b24d$export$b7d78993b74f766d();
});
const $0ce0d2ea54f4b24d$export$6446a186d09e379e = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testUserAgent(/Chrome|CriOS|CrMo/i);
});
const $0ce0d2ea54f4b24d$export$a11b0059900ceec8 = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testUserAgent(/Android/i);
});
const $0ce0d2ea54f4b24d$export$b7d78993b74f766d = $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$cached(function() {
    return $0ce0d2ea54f4b24d$var$$2add3ce32c6007eb$var$testUserAgent(/(Firefox|FxiOS)/i);
});

});

parcelRegister("9J8wU", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", () => $3c69a55f9d307690$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $3c69a55f9d307690$export$29bf1b5f2c56cf63);

var $11FxZ = parcelRequire("11FxZ");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3c69a55f9d307690$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.pointerType === '' && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $11FxZ.isAndroid)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $3c69a55f9d307690$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $11FxZ.isAndroid)() && event.width === 0 && event.height === 0 || (0, $11FxZ.isAndroid)() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}

});

parcelRegister("aGgVM", function(module, exports) {

$parcel$export(module.exports, "RouterProvider", () => $4f99560df6369e4c$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "openLink", () => $4f99560df6369e4c$export$95185d699e05d4d7);
$parcel$export(module.exports, "useRouter", () => $4f99560df6369e4c$export$9a302a45f65d0572);
$parcel$export(module.exports, "useSyntheticLinkProps", () => $4f99560df6369e4c$export$bdc77b0c0a3a85d6);
$parcel$export(module.exports, "useLinkProps", () => $4f99560df6369e4c$export$7e924b3091a3bd18);
$parcel$export(module.exports, "handleLinkClick", () => $4f99560df6369e4c$export$13aea1a3cb5e3f1f);

var $2jk5s = parcelRequire("2jk5s");

var $11FxZ = parcelRequire("11FxZ");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4f99560df6369e4c$var$$caaf0dd3060ed57c$var$RouterContext = (0, $eF4cA.createContext)({
    isNative: true,
    open: $4f99560df6369e4c$var$$caaf0dd3060ed57c$var$openSyntheticLink,
    useHref: (href)=>href
});
function $4f99560df6369e4c$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $eF4cA.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $4f99560df6369e4c$var$$caaf0dd3060ed57c$var$getSyntheticLink(target, (link)=>{
                    if ($4f99560df6369e4c$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $4f99560df6369e4c$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($4f99560df6369e4c$var$$caaf0dd3060ed57c$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $4f99560df6369e4c$export$9a302a45f65d0572() {
    return (0, $eF4cA.useContext)($4f99560df6369e4c$var$$caaf0dd3060ed57c$var$RouterContext);
}
function $4f99560df6369e4c$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $4f99560df6369e4c$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $11FxZ.isWebKit)() && (0, $11FxZ.isMac)() && !(0, $11FxZ.isIPad)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        detail: 1,
        bubbles: true,
        cancelable: true
    });
    $4f99560df6369e4c$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $2jk5s.focusWithoutScrolling)(target);
    target.dispatchEvent(event);
    $4f99560df6369e4c$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$4f99560df6369e4c$export$95185d699e05d4d7.isOpening = false;
function $4f99560df6369e4c$var$$caaf0dd3060ed57c$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        let link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $4f99560df6369e4c$var$$caaf0dd3060ed57c$var$openSyntheticLink(target, modifiers) {
    $4f99560df6369e4c$var$$caaf0dd3060ed57c$var$getSyntheticLink(target, (link)=>$4f99560df6369e4c$export$95185d699e05d4d7(link, modifiers));
}
function $4f99560df6369e4c$export$bdc77b0c0a3a85d6(props) {
    let router = $4f99560df6369e4c$export$9a302a45f65d0572();
    // oxlint-disable-next-line react/react-compiler
    const href = router.useHref(props.href ?? '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $4f99560df6369e4c$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $4f99560df6369e4c$export$7e924b3091a3bd18(props) {
    let router = $4f99560df6369e4c$export$9a302a45f65d0572();
    // oxlint-disable-next-line react/react-compiler
    const href = router.useHref(props?.href ?? '');
    let linkProps = {};
    if (props) {
        for (let key of [
            'href',
            'target',
            'rel',
            'download',
            'ping',
            'referrerPolicy'
        ])if (key in props && props[key] !== undefined) linkProps[key] = key === 'href' ? href : props[key];
    }
    return linkProps;
}
function $4f99560df6369e4c$export$13aea1a3cb5e3f1f(e, router, href, routerOptions) {
    // If a custom router is provided, prevent default and forward if this link should client navigate.
    if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
    !e.isDefaultPrevented() && $4f99560df6369e4c$export$efa8c9099e530235(e.currentTarget, e) && href) {
        e.preventDefault();
        router.open(e.currentTarget, e, href, routerOptions);
    }
}

});


parcelRegister("iUhPJ", function(module, exports) {

$parcel$export(module.exports, "runAfterTransition", () => $55ce0f5ada01f845$export$24490316f764c430);

var $7ByPJ = parcelRequire("7ByPJ");

var $fvyIQ = parcelRequire("fvyIQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
const $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement = new Map();
const $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionCallbacks = new Set();
function $55ce0f5ada01f845$var$$081cb5757e08788e$var$isTransitionEvent(event) {
    return 'propertyName' in event;
}
function $55ce0f5ada01f845$var$$081cb5757e08788e$var$onTransitionStart(e) {
    let eventTarget = (0, $fvyIQ.getEventTarget)(e);
    if (!$55ce0f5ada01f845$var$$081cb5757e08788e$var$isTransitionEvent(e) || !eventTarget) return;
    // Add the transitioning property to the list for this element.
    let transitions = $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.get(eventTarget);
    if (!transitions) {
        transitions = new Set();
        $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.set(eventTarget, transitions);
        // The transitioncancel event must be registered on the element itself, rather than as a global
        // event. This enables us to handle when the node is deleted from the document while it is transitioning.
        // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
        eventTarget.addEventListener('transitioncancel', $55ce0f5ada01f845$var$$081cb5757e08788e$var$onTransitionEnd, {
            once: true
        });
    }
    transitions.add(e.propertyName);
}
function $55ce0f5ada01f845$var$$081cb5757e08788e$var$onTransitionEnd(e) {
    let eventTarget = (0, $fvyIQ.getEventTarget)(e);
    if (!$55ce0f5ada01f845$var$$081cb5757e08788e$var$isTransitionEvent(e) || !eventTarget) return;
    // Remove property from list of transitioning properties.
    let properties = $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.get(eventTarget);
    if (!properties) return;
    properties.delete(e.propertyName);
    // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
    if (properties.size === 0) {
        eventTarget.removeEventListener('transitioncancel', $55ce0f5ada01f845$var$$081cb5757e08788e$var$onTransitionEnd);
        $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.delete(eventTarget);
    }
    // If no transitioning elements, call all of the queued callbacks.
    if ($55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.size === 0) for (let callback of $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionCallbacks){
        callback(true);
        $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionCallbacks.delete(callback);
    }
}
function $55ce0f5ada01f845$var$$081cb5757e08788e$var$setupGlobalEvents() {
    (0, $7ByPJ.addEvent)(document, 'transitionrun', $55ce0f5ada01f845$var$$081cb5757e08788e$var$onTransitionStart);
    (0, $7ByPJ.addEvent)(document, 'transitionend', $55ce0f5ada01f845$var$$081cb5757e08788e$var$onTransitionEnd);
}
/**
 * Cleans up any elements that are no longer in the document.
 * This is necessary because we can't rely on transitionend events to fire
 * for elements that are removed from the document while transitioning.
 */ function $55ce0f5ada01f845$var$$081cb5757e08788e$var$cleanupDetachedElements() {
    for (const [eventTarget] of $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement)// the explicit instanceof check, since it may be different in different contexts.
    if ('isConnected' in eventTarget && !eventTarget.isConnected) $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.delete(eventTarget);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $55ce0f5ada01f845$var$$081cb5757e08788e$var$setupGlobalEvents();
    else (0, $7ByPJ.addEvent)(document, 'DOMContentLoaded', $55ce0f5ada01f845$var$$081cb5757e08788e$var$setupGlobalEvents);
}
function $55ce0f5ada01f845$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    let frame = window.requestAnimationFrame(()=>{
        $55ce0f5ada01f845$var$$081cb5757e08788e$var$cleanupDetachedElements();
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionsByElement.size === 0) return fn(false);
        $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionCallbacks.add(fn);
    });
    return ()=>{
        window.cancelAnimationFrame(frame);
        $55ce0f5ada01f845$var$$081cb5757e08788e$var$transitionCallbacks.delete(fn);
    };
}

});



parcelRegister("fVfXf", function(module, exports) {

$parcel$export(module.exports, "filterDOMProps", () => $5ed4e26d982447f5$export$457c3d6518dd4c6f);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$DOMPropNames = new Set([
    'id'
]);
const $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
// See LinkDOMProps in dom.d.ts.
const $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$linkPropNames = new Set([
    'href',
    'hrefLang',
    'target',
    'rel',
    'download',
    'ping',
    'referrerPolicy'
]);
const $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$globalAttrs = new Set([
    'dir',
    'lang',
    'hidden',
    'inert',
    'translate',
    'suppressHydrationWarning'
]);
const $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$globalEvents = new Set([
    'onClick',
    'onAuxClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onScroll',
    'onWheel',
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration',
    'onTransitionCancel',
    'onTransitionEnd',
    'onTransitionRun',
    'onTransitionStart'
]);
const $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$propRe = /^(data-.*)$/;
function $5ed4e26d982447f5$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, global: global, events: events = global, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$DOMPropNames.has(prop) || labelable && $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$labelablePropNames.has(prop) || isLink && $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$linkPropNames.has(prop) || global && $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$globalAttrs.has(prop) || events && ($5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$globalEvents.has(prop) || prop.endsWith('Capture') && $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$globalEvents.has(prop.slice(0, -7))) || propNames?.has(prop) || $5ed4e26d982447f5$var$$8e9d2fae0ecb9001$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}

});

parcelRegister("1ntKq", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => $d5974044424d7778$export$a54013f0d02a8f82);
$parcel$export(module.exports, "useLocale", () => $d5974044424d7778$export$43bb16f9c6d9e3f7);

var $6z3VT = parcelRequire("6z3VT");

var $2nHog = parcelRequire("2nHog");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
/**
 * Internal component that handles the case when locale is provided.
 */ function $d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithLocale(props) {
    let { locale: locale, children: children } = props;
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useMemo(()=>({
            locale: locale,
            direction: (0, $6z3VT.isRTL)(locale) ? 'rtl' : 'ltr'
        }), [
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nContext.Provider, {
        value: value
    }, children);
}
/**
 * Internal component that handles the case when no locale is provided.
 */ function $d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithDefaultLocale(props) {
    let { children: children } = props;
    let defaultLocale = (0, $2nHog.useDefaultLocale)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nContext.Provider, {
        value: defaultLocale
    }, children);
}
function $d5974044424d7778$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    // Conditionally render different components to avoid calling useDefaultLocale.
    // This is necessary because useDefaultLocale triggers a re-render.
    if (locale) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithLocale, {
        locale: locale,
        children: children
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nProviderWithDefaultLocale, {
        children: children
    });
}
function $d5974044424d7778$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $2nHog.useDefaultLocale)();
    let context = (0, $eF4cA.useContext)($d5974044424d7778$var$$2eb8e6d23f3d0cb0$var$I18nContext);
    return context || defaultLocale;
}

});
parcelRegister("6z3VT", function(module, exports) {

$parcel$export(module.exports, "isRTL", () => $a7f2a6d4c9e15026$export$702d680b21cbd764);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $a7f2a6d4c9e15026$var$$d805ff57cab8bee2$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
const $a7f2a6d4c9e15026$var$$d805ff57cab8bee2$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $a7f2a6d4c9e15026$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === 'rtl';
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $a7f2a6d4c9e15026$var$$d805ff57cab8bee2$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split('-')[0];
    return $a7f2a6d4c9e15026$var$$d805ff57cab8bee2$var$RTL_LANGS.has(lang);
}

});

parcelRegister("2nHog", function(module, exports) {

$parcel$export(module.exports, "useDefaultLocale", () => $3a7503cc978f5621$export$188ec29ebc2bdc3a);

var $6z3VT = parcelRequire("6z3VT");

var $hWe38 = parcelRequire("hWe38");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $3a7503cc978f5621$var$$520a025cdb0d710d$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $3a7503cc978f5621$export$f09106e7c6677ec5() {
    let locale = typeof window !== 'undefined' && window[$3a7503cc978f5621$var$$520a025cdb0d710d$var$localeSymbol] || // @ts-ignore
    typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: (0, $6z3VT.isRTL)(locale) ? 'rtl' : 'ltr'
    };
}
let $3a7503cc978f5621$var$$520a025cdb0d710d$var$currentLocale = $3a7503cc978f5621$export$f09106e7c6677ec5();
let $3a7503cc978f5621$var$$520a025cdb0d710d$var$listeners = new Set();
function $3a7503cc978f5621$var$$520a025cdb0d710d$var$updateLocale() {
    $3a7503cc978f5621$var$$520a025cdb0d710d$var$currentLocale = $3a7503cc978f5621$export$f09106e7c6677ec5();
    for (let listener of $3a7503cc978f5621$var$$520a025cdb0d710d$var$listeners)listener($3a7503cc978f5621$var$$520a025cdb0d710d$var$currentLocale);
}
function $3a7503cc978f5621$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $hWe38.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $eF4cA.useState)($3a7503cc978f5621$var$$520a025cdb0d710d$var$currentLocale);
    (0, $eF4cA.useEffect)(()=>{
        if ($3a7503cc978f5621$var$$520a025cdb0d710d$var$listeners.size === 0) window.addEventListener('languagechange', $3a7503cc978f5621$var$$520a025cdb0d710d$var$updateLocale);
        $3a7503cc978f5621$var$$520a025cdb0d710d$var$listeners.add(setDefaultLocale);
        return ()=>{
            $3a7503cc978f5621$var$$520a025cdb0d710d$var$listeners.delete(setDefaultLocale);
            if ($3a7503cc978f5621$var$$520a025cdb0d710d$var$listeners.size === 0) window.removeEventListener('languagechange', $3a7503cc978f5621$var$$520a025cdb0d710d$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) {
        let locale = typeof window !== 'undefined' && window[$3a7503cc978f5621$var$$520a025cdb0d710d$var$localeSymbol];
        return {
            locale: locale || 'en-US',
            direction: 'ltr'
        };
    }
    return defaultLocale;
}

});





parcelRegister("f16Ml", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $0bca4316ffd28e17$export$a20dad690e1279e2);
$parcel$export(module.exports, "Avatar", () => $0bca4316ffd28e17$export$e2255cf6045e8d47);


var $8OJ2z = parcelRequire("8OJ2z");

var $8g9SZ = parcelRequire("8g9SZ");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0bca4316ffd28e17$var$$3ffa2cd930156220$var$imageStyles = function anonymous(props, overrides) {
    let rules = " ";
    let flexShrink = false;
    let flexGrow = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_u") flexGrow = true;
        rules += p[0];
    }
    rules += ' sd182';
    rules += ' eb182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' Zm182';
    rules += ' Fn182';
    if (!flexShrink) rules += ' _va182';
    if (!flexGrow) rules += ' _ua182';
    rules += ' __ca182';
    if (props.isOverBackground) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' OEzkoQe182';
    if (props.isLH) rules += ' _MBJrsse182';
    else if (props.isLarge) rules += ' _Mc182';
    else rules += ' _Mb182';
    return rules;
};
const $0bca4316ffd28e17$export$a20dad690e1279e2 = (0, $eF4cA.createContext)(null);
const $0bca4316ffd28e17$export$e2255cf6045e8d47 = (0, $eF4cA.forwardRef)(function Avatar(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $0bca4316ffd28e17$export$a20dad690e1279e2);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { alt: alt = '', src: src, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', size: size = 24, isOverBackground: isOverBackground, slot: slot = 'avatar', ...otherProps } = props;
    const domProps = (0, $fVfXf.filterDOMProps)(otherProps);
    // In the docs build, we need to be able to simulate font scaling.
    let remSize;
    let isLarge = false;
    let isLH = false;
    if (typeof size === 'string') {
        remSize = size;
        isLH = size.endsWith('lh');
    } else {
        remSize = `${size / 16}rem`;
        isLarge = size >= 64;
    }
    return (0, $dx4lB.jsx)((0, $8g9SZ.ImageContext).Provider, {
        value: {},
        children: (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
            ...domProps,
            ref: domRef,
            slot: slot,
            alt: alt,
            UNSAFE_style: {
                ...UNSAFE_style,
                width: remSize,
                height: remSize
            },
            UNSAFE_className: UNSAFE_className + ' ' + (0, $8OJ2z.centerBaselineBefore),
            styles: $0bca4316ffd28e17$var$$3ffa2cd930156220$var$imageStyles({
                isOverBackground: isOverBackground,
                isLarge: isLarge,
                isLH: isLH
            }, props.styles),
            src: src
        })
    });
});

});
parcelRegister("8OJ2z", function(module, exports) {

$parcel$export(module.exports, "CenterBaseline", () => $4f360afa8b3d5322$export$768dac55bb57081d);
$parcel$export(module.exports, "centerBaselineBefore", () => $4f360afa8b3d5322$export$179e9489a09b14ac);
$parcel$export(module.exports, "centerBaseline", () => $4f360afa8b3d5322$export$9d7e2342a7e53afa);


var $5nTep = parcelRequire("5nTep");

var $dx4lB = parcelRequire("dx4lB");

var $fVfXf = parcelRequire("fVfXf");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4f360afa8b3d5322$var$$1f4b04be3f24aae3$var$styles = " sd182 eb182";
function $4f360afa8b3d5322$export$768dac55bb57081d(props) {
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    return (0, $dx4lB.jsx)("div", {
        ...domProps,
        slot: props.slot,
        style: props.style,
        className: (0, $5nTep.mergeStyles)($4f360afa8b3d5322$var$$1f4b04be3f24aae3$var$styles, props.styles) + ' ' + $4f360afa8b3d5322$export$179e9489a09b14ac,
        children: props.children
    });
}
const $4f360afa8b3d5322$export$179e9489a09b14ac = "FRGfhd";
function $4f360afa8b3d5322$export$9d7e2342a7e53afa(props = {}) {
    return (icon)=>(0, $dx4lB.jsx)($4f360afa8b3d5322$export$768dac55bb57081d, {
            ...props,
            children: icon
        });
}

});

parcelRegister("8g9SZ", function(module, exports) {

$parcel$export(module.exports, "ImageContext", () => $5ba12613ccb8cb72$export$8151eb379fcf2442);
$parcel$export(module.exports, "Image", () => $5ba12613ccb8cb72$export$3e431a229df88919);


var $arisx = parcelRequire("arisx");

var $jTg9X = parcelRequire("jTg9X");

var $91SAk = parcelRequire("91SAk");

var $5nTep = parcelRequire("5nTep");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4skXn = parcelRequire("4skXn");
const $5ba12613ccb8cb72$export$8151eb379fcf2442 = (0, $eF4cA.createContext)(null);
function $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$createState(src) {
    return {
        state: 'loading',
        src: src,
        startTime: Date.now(),
        loadTime: 0
    };
}
function $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$reducer(state, action) {
    switch(action.type){
        case 'update':
            return {
                state: 'loading',
                src: action.src,
                startTime: Date.now(),
                loadTime: 0
            };
        case 'loaded':
        case 'error':
            return {
                ...state,
                state: action.type
            };
        case 'revealed':
            return {
                ...state,
                state: 'revealed',
                loadTime: Date.now() - state.startTime
            };
        default:
            return state;
    }
}
const $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$wrapperStyles = " gH182 _Nc182 Pc182";
const $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$imgStyles = function anonymous(props) {
    let rules = " ";
    rules += ' sb182';
    rules += ' Za182';
    rules += ' Fb182';
    rules += ' _H40ub4c182';
    rules += ' __D40ub4c182';
    if (props.isRevealed) rules += ' _Ib182';
    else rules += ' _Ia182';
    if (props.isTransitioning) rules += ' Yf182';
    else rules += ' Ye182';
    rules += ' Xe182';
    if (props.isTransitioning) rules += ' _2b182';
    else rules += ' _2b182';
    return rules;
};
const $5ba12613ccb8cb72$export$3e431a229df88919 = (0, $eF4cA.forwardRef)(function Image(props, domRef) {
    [props, domRef] = (0, $5t6Bv.useSpectrumContextProps)(props, domRef, $5ba12613ccb8cb72$export$8151eb379fcf2442);
    let { src: srcProp = '', styles: styles, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, renderError: renderError, group: group = (0, $jTg9X.DefaultImageGroup), alt: // srcSet,
    // sizes,
    alt, crossOrigin: crossOrigin, decoding: decoding, fetchPriority: fetchPriority, loading: loading, referrerPolicy: referrerPolicy, slot: slot, width: width, height: height, itemProp: itemProp } = props;
    let hidden = props.hidden;
    let colorScheme = (0, $eF4cA.useContext)((0, $arisx.ColorSchemeContext));
    let cacheKey = (0, $eF4cA.useMemo)(()=>typeof srcProp === 'object' ? JSON.stringify(srcProp) : srcProp, [
        srcProp
    ]);
    let { revealAll: revealAll, register: register, unregister: unregister, load: load } = (0, $eF4cA.useContext)(group);
    let [{ state: state, src: lastCacheKey, loadTime: loadTime }, dispatch] = (0, $eF4cA.useReducer)($5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$reducer, cacheKey, $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$createState);
    if (cacheKey !== lastCacheKey && !hidden) dispatch({
        type: 'update',
        src: cacheKey
    });
    if (state === 'loaded' && revealAll && !hidden) dispatch({
        type: 'revealed'
    });
    let imgRef = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (hidden) return;
        register(cacheKey);
        return ()=>{
            unregister(cacheKey);
        };
    }, [
        hidden,
        register,
        unregister,
        cacheKey
    ]);
    let onLoad = (0, $eF4cA.useCallback)(()=>{
        load(cacheKey);
        dispatch({
            type: 'loaded'
        });
    }, [
        load,
        cacheKey
    ]);
    let onError = (0, $eF4cA.useCallback)(()=>{
        dispatch({
            type: 'error'
        });
        unregister(cacheKey);
    }, [
        unregister,
        cacheKey
    ]);
    let isSkeleton = (0, $91SAk.useIsSkeleton)();
    let isAnimating = isSkeleton || state === 'loading' || state === 'loaded';
    let animation = (0, $91SAk.useLoadingAnimation)(isAnimating);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (hidden) return;
        // In React act environments, run immediately.
        let isTestEnv = typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined';
        let runTask = isTestEnv ? (fn)=>fn() : queueMicrotask;
        // If the image is already loaded, update state immediately instead of waiting for onLoad.
        let img = imgRef.current;
        if (state === 'loading' && img?.complete) {
            if (img.naturalWidth === 0 && img.naturalHeight === 0) // TODO: is this necessary?
            runTask(onError);
            else runTask(onLoad);
        }
        animation(domRef.current);
    });
    props.alt;
    let errorState = !isSkeleton && state === 'error' && renderError?.();
    let isRevealed = state === 'revealed' && !isSkeleton;
    let isTransitioning = isRevealed && loadTime > 200;
    return (0, $eF4cA.useMemo)(()=>{
        let img = (0, $dx4lB.jsx)("img", {
            ...$5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$getFetchPriorityProp(fetchPriority),
            src: typeof srcProp === 'string' && srcProp ? srcProp : undefined,
            alt: alt,
            crossOrigin: crossOrigin,
            decoding: decoding,
            loading: loading,
            referrerPolicy: referrerPolicy,
            width: width,
            height: height,
            ref: imgRef,
            itemProp: itemProp,
            onLoad: onLoad,
            onError: onError,
            className: $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$imgStyles({
                isRevealed: isRevealed,
                isTransitioning: isTransitioning
            })
        });
        if (Array.isArray(srcProp)) img = (0, $dx4lB.jsxs)("picture", {
            className: " _H40ub4c182 __D40ub4c182",
            children: [
                srcProp.map((source, i)=>{
                    let { colorScheme: sourceColorScheme, ...sourceProps } = source;
                    if (sourceColorScheme) {
                        if (!colorScheme || colorScheme === 'light dark') return (0, $dx4lB.jsx)("source", {
                            ...sourceProps,
                            media: `${source.media ? `${source.media} and ` : ''}(prefers-color-scheme: ${sourceColorScheme})`
                        }, i);
                        return sourceColorScheme === colorScheme ? (0, $dx4lB.jsx)("source", {
                            ...sourceProps
                        }, i) : null;
                    } else return (0, $dx4lB.jsx)("source", {
                        ...sourceProps
                    }, i);
                }),
                img
            ]
        });
        return hidden ? null : (0, $dx4lB.jsxs)("div", {
            ref: domRef,
            slot: slot || undefined,
            style: UNSAFE_style,
            className: UNSAFE_className + (0, $5nTep.mergeStyles)($5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$wrapperStyles, styles) + ' ' + (isAnimating ? (0, $91SAk.loadingStyle) : ''),
            children: [
                errorState,
                !errorState && img
            ]
        });
    }, [
        slot,
        hidden,
        domRef,
        UNSAFE_style,
        UNSAFE_className,
        styles,
        isAnimating,
        errorState,
        alt,
        crossOrigin,
        decoding,
        fetchPriority,
        loading,
        referrerPolicy,
        width,
        height,
        onLoad,
        onError,
        isRevealed,
        isTransitioning,
        srcProp,
        itemProp,
        colorScheme
    ]);
});
function $5ba12613ccb8cb72$var$$dbd6f0b2503b938c$var$getFetchPriorityProp(fetchPriority) {
    const pieces = (0, $eF4cA.version).split('.');
    const major = parseInt(pieces[0], 10);
    if (major >= 19) return {
        fetchPriority: fetchPriority
    };
    return {
        fetchpriority: fetchPriority
    };
}

});
parcelRegister("arisx", function(module, exports) {

$parcel$export(module.exports, "ColorSchemeContext", () => $072433b8c1bcc20b$export$374e0245597d19a3);
$parcel$export(module.exports, "Provider", () => $072433b8c1bcc20b$export$2881499e37b75b9a);


var $3xnfL = parcelRequire("3xnfL");

var $5nTep = parcelRequire("5nTep");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $1ntKq = parcelRequire("1ntKq");

var $aGgVM = parcelRequire("aGgVM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $072433b8c1bcc20b$export$374e0245597d19a3 = (0, $eF4cA.createContext)(null);
function $072433b8c1bcc20b$export$2881499e37b75b9a(props) {
    let result = (0, $dx4lB.jsx)($072433b8c1bcc20b$var$$9affbfa4e13b9582$var$ProviderInner, {
        ...props
    });
    let parentColorScheme = (0, $eF4cA.useContext)($072433b8c1bcc20b$export$374e0245597d19a3);
    let colorScheme = props.colorScheme || parentColorScheme;
    result = (0, $dx4lB.jsx)($072433b8c1bcc20b$export$374e0245597d19a3.Provider, {
        value: colorScheme,
        children: result
    });
    if (props.locale) result = (0, $dx4lB.jsx)((0, $1ntKq.I18nProvider), {
        locale: props.locale,
        children: result
    });
    if (props.router) result = (0, $dx4lB.jsx)((0, $aGgVM.RouterProvider), {
        ...props.router,
        children: result
    });
    return result;
}
undefined;
let $072433b8c1bcc20b$var$$9affbfa4e13b9582$var$providerStyles = function anonymous(props) {
    let rules = " ";
    if (props.colorScheme === "dark") rules += ' -ICUGx-_pa182';
    else if (props.colorScheme === "light") rules += ' -ICUGx-_pb182';
    else if (props.colorScheme === "light dark") {
        rules += ' -ICUGx-_pb182';
        rules += ' -ICUGx-D1v0V_pa182';
    }
    rules += ' _pK8eoyd182';
    if (props.colorScheme === "dark") rules += ' -NvXmrd-_ZLmU182';
    else if (props.colorScheme === "light") rules += ' -NvXmrd-_ZN8Gi4c182';
    else if (props.colorScheme === "light dark") {
        rules += ' -NvXmrd-_ZN8Gi4c182';
        rules += ' -NvXmrd-D1v0V_ZLmU182';
    }
    if (props.colorScheme === "dark") rules += ' -j9blY-_ZN8Gi4c182';
    else if (props.colorScheme === "light") rules += ' -j9blY-_ZLmU182';
    else if (props.colorScheme === "light dark") {
        rules += ' -j9blY-_ZLmU182';
        rules += ' -j9blY-D1v0V_ZN8Gi4c182';
    }
    if (props.background === "layer-2") rules += ' -Ovbhqd-g_g182';
    else if (props.background === "layer-1") rules += ' -Ovbhqd-gqlRAZb182';
    else if (props.background === "base") rules += ' -Ovbhqd-gX182';
    if (props.background === "layer-2") rules += ' gEzkoQe182';
    else if (props.background === "layer-1") rules += ' gEzkoQe182';
    else if (props.background === "base") rules += ' gEzkoQe182';
    rules += ' _Bb182';
    return rules;
};
function $072433b8c1bcc20b$var$$9affbfa4e13b9582$var$ProviderInner(props) {
    let { elementType: Element = 'div', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', styles: styles, children: children, background: background = Element === 'html' ? 'base' : undefined, colorScheme: colorScheme } = props;
    let { locale: locale, direction: direction } = (0, $1ntKq.useLocale)();
    return (0, $dx4lB.jsxs)(Element, {
        ...(0, $fVfXf.filterDOMProps)(props),
        lang: locale,
        dir: direction,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, $5nTep.mergeStyles)(styles, $072433b8c1bcc20b$var$$9affbfa4e13b9582$var$providerStyles({
            background: background,
            colorScheme: colorScheme
        })),
        children: [
            (0, $dx4lB.jsx)((0, $3xnfL.Fonts), {}),
            children
        ]
    });
}

});
parcelRegister("3xnfL", function(module, exports) {

$parcel$export(module.exports, "Fonts", () => $a0e9456316aba118$export$20f257fc407da7a3);



var $dx4lB = parcelRequire("dx4lB");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
// Typekit ids for each CJK locale. These use dynamic subsetting, so cannot be loaded as CSS.
// Because of the large size of the JS, we only download the script for the locale that is used.
// Each of these kits includes regular, bold, extra bold, and black weights. Spectrum 2 does not use any lighter weights.
let $a0e9456316aba118$var$$f333e78089fdffab$var$scripts = {
    ja: 'pyb4hbv',
    ko: 'pux4zom',
    'zh-Hans': 'qwy0qqd',
    'zh-CN': 'qwy0qqd',
    'zh-SG': 'qwy0qqd',
    'zh-HK': 'wrf0dsa',
    'zh-Hant': 'twr1oiz',
    zh: 'twr1oiz'
};
// Font URLs from fonts.css to preload for each locale.
let $a0e9456316aba118$var$$f333e78089fdffab$var$preloads = {
    // Currently no preloads for arabic and hebrew, because we don't know which weights will be used ahead of time.
    // Browsers will emit warnings for unused preloads.
    // ar: [
    // 'https://use.typekit.net/af/dfb464/00000000000000007735a2f9/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n7&v=3',
    // 'https://use.typekit.net/af/560a53/00000000000000007735a300/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3',
    // 'https://use.typekit.net/af/0f9162/00000000000000007735a307/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n6&v=3',
    // 'https://use.typekit.net/af/ab2792/00000000000000007735a309/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n9&v=3'
    // 'https://use.typekit.net/af/560a53/00000000000000007735a300/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3'
    // ],
    // he: [
    // 'https://use.typekit.net/af/ffca46/00000000000000007735a30a/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n7&v=3',
    // 'https://use.typekit.net/af/e90860/00000000000000007735a313/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3',
    // 'https://use.typekit.net/af/619974/00000000000000007735a31f/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n6&v=3'
    // 'https://use.typekit.net/af/e90860/00000000000000007735a313/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3'
    // ],
    en: [
        // Preload Adobe Clean Spectrum VF.
        'https://use.typekit.net/af/ca4cba/0000000000000000775c55a1/31/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n1&v=3'
    ]
};
function $a0e9456316aba118$export$20f257fc407da7a3() {
    let { locale: localeString } = (0, $1ntKq.useLocale)();
    let locale = (0, $eF4cA.useMemo)(()=>new Intl.Locale(localeString), [
        localeString
    ]);
    let languageAndRegion = locale.language + (locale.region ? '-' + locale.region : '');
    let languageAndScript = locale.language + (locale.script ? '-' + locale.script : '');
    // Load script tag for CJK font
    let typekitId = $a0e9456316aba118$var$$f333e78089fdffab$var$scripts[locale.baseName] || $a0e9456316aba118$var$$f333e78089fdffab$var$scripts[languageAndRegion] || $a0e9456316aba118$var$$f333e78089fdffab$var$scripts[languageAndScript] || $a0e9456316aba118$var$$f333e78089fdffab$var$scripts[locale.language];
    let script = typekitId ? `https://use.typekit.net/${typekitId}.js` : null;
    let scriptRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        let scriptEl = scriptRef.current;
        // In older React versions, we must manually insert scripts into the <head>.
        // Scripts rendered by React are never executed.
        if (script && parseInt((0, $eF4cA.version), 10) < 19) {
            scriptEl = Array.from(document.scripts).find((s)=>s.src === script) || null;
            if (!scriptEl) {
                scriptEl = document.createElement('script');
                scriptEl.async = true;
                scriptEl.src = script;
                document.head.appendChild(scriptEl);
            }
        }
        if (scriptEl) scriptEl.onload = ()=>{
            if (typeof window['Typekit'] !== 'undefined' && typeof window['Typekit'].load === 'function') window['Typekit'].load();
        };
    }, [
        scriptRef,
        script
    ]);
    // When using React 19, async scripts are automatically deduped and hoisted into the <head>.
    // This also works during SSR.
    if (script && parseInt((0, $eF4cA.version), 10) >= 19) return (0, $dx4lB.jsx)("script", {
        async: true,
        src: script,
        ref: scriptRef
    }, script);
    // Preload fonts referenced by CSS file using React 19's preloading mechanism (when available).
    // This will insert a <link rel="preload"> tag in the <head>, which is useful during SSR to start
    // font loading before the CSS downloads.
    let preloadUrls = $a0e9456316aba118$var$$f333e78089fdffab$var$preloads[locale.language] || $a0e9456316aba118$var$$f333e78089fdffab$var$preloads.en;
    if (preloadUrls && typeof (0, (/*@__PURE__*/$parcel$interopDefault($l19Vn)))['preload'] === 'function') for (let url of preloadUrls)(0, (/*@__PURE__*/$parcel$interopDefault($l19Vn))).preload(url, {
        as: 'font',
        type: 'font/woff2',
        crossOrigin: ''
    });
    return null;
}

});


parcelRegister("jTg9X", function(module, exports) {

$parcel$export(module.exports, "DefaultImageGroup", () => $9813279f43f6e5a4$export$a37e899304e5fef0);
$parcel$export(module.exports, "ImageCoordinator", () => $9813279f43f6e5a4$export$1b926c015f09611d);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$defaultContext = {
    revealAll: true,
    register () {},
    unregister () {},
    load () {}
};
const $9813279f43f6e5a4$export$a37e899304e5fef0 = $9813279f43f6e5a4$export$c991cd1e9f87d921();
function $9813279f43f6e5a4$export$c991cd1e9f87d921() {
    return (0, $eF4cA.createContext)($9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$defaultContext);
}
function $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$reducer(state, action) {
    switch(action.type){
        case 'register':
            if (state.loaded.get(action.url) !== false) {
                let loaded = new Map(state.loaded);
                loaded.set(action.url, false);
                return {
                    loadedAll: false,
                    // If we had previously loaded all items, then reset the timed out state
                    // since this is the first item of a new batch.
                    timedOut: state.loadedAll ? false : state.timedOut,
                    loadStartTime: state.loadedAll ? Date.now() : state.loadStartTime,
                    loaded: loaded
                };
            }
            return state;
        case 'unregister':
            if (state.loaded.has(action.url)) {
                let loaded = new Map(state.loaded);
                loaded.delete(action.url);
                return {
                    loadedAll: $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$isAllLoaded(loaded),
                    timedOut: state.timedOut,
                    loadStartTime: state.loadStartTime,
                    loaded: loaded
                };
            }
            return state;
        case 'load':
            if (state.loaded.get(action.url) === false) {
                let loaded = new Map(state.loaded);
                loaded.set(action.url, true);
                return {
                    loadedAll: $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$isAllLoaded(loaded),
                    timedOut: state.timedOut,
                    loadStartTime: state.loadStartTime,
                    loaded: loaded
                };
            }
            return state;
        case 'timeout':
            if (!state.loadedAll && !state.timedOut) return {
                ...state,
                timedOut: true
            };
            return state;
        default:
            return state;
    }
}
function $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$isAllLoaded(loaded) {
    for (let isLoaded of loaded.values()){
        if (!isLoaded) return false;
    }
    return true;
}
function $9813279f43f6e5a4$export$1b926c015f09611d(props) {
    // If we are already inside another ImageCoordinator, just pass
    // through children and coordinate loading at the root.
    let ctx = (0, $eF4cA.useContext)(props.group || $9813279f43f6e5a4$export$a37e899304e5fef0);
    if (ctx !== $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$defaultContext) return props.children;
    return (0, $dx4lB.jsx)($9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$ImageCoordinatorRoot, {
        ...props
    });
}
function $9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$ImageCoordinatorRoot(props) {
    let { children: children, timeout: timeout = 5000, group: group = $9813279f43f6e5a4$export$a37e899304e5fef0 } = props;
    let [{ loadedAll: loadedAll, timedOut: timedOut, loadStartTime: loadStartTime }, dispatch] = (0, $eF4cA.useReducer)($9813279f43f6e5a4$var$$4b5e069e9e001e8b$var$reducer, {
        loadedAll: true,
        timedOut: false,
        loadStartTime: 0,
        loaded: new Map()
    });
    let register = (0, $eF4cA.useCallback)((url)=>dispatch({
            type: 'register',
            url: url
        }), []);
    let unregister = (0, $eF4cA.useCallback)((url)=>dispatch({
            type: 'unregister',
            url: url
        }), []);
    let load = (0, $eF4cA.useCallback)((url)=>dispatch({
            type: 'load',
            url: url
        }), []);
    (0, $eF4cA.useEffect)(()=>{
        if (!loadedAll) {
            let timeoutId = setTimeout(()=>{
                dispatch({
                    type: 'timeout'
                });
            }, loadStartTime + timeout - Date.now());
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        loadStartTime,
        loadedAll,
        timeout
    ]);
    let revealAll = loadedAll || timedOut;
    return (0, $eF4cA.useMemo)(()=>(0, $dx4lB.jsx)(group.Provider, {
            value: {
                revealAll: revealAll,
                register: register,
                unregister: unregister,
                load: load
            },
            children: children
        }), [
        group,
        children,
        revealAll,
        register,
        unregister,
        load
    ]);
}

});

parcelRegister("91SAk", function(module, exports) {

$parcel$export(module.exports, "useLoadingAnimation", () => $6117660dffb4b363$export$6b288fe07640c94c);
$parcel$export(module.exports, "SkeletonContext", () => $6117660dffb4b363$export$74e166679b1f49ee);
$parcel$export(module.exports, "useIsSkeleton", () => $6117660dffb4b363$export$4f8dc7555740235c);
$parcel$export(module.exports, "Skeleton", () => $6117660dffb4b363$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "loadingStyle", () => $6117660dffb4b363$export$d2353276f167b21f);
$parcel$export(module.exports, "useSkeletonText", () => $6117660dffb4b363$export$a05a0b8a311cd65f);
$parcel$export(module.exports, "SkeletonWrapper", () => $6117660dffb4b363$export$6069cbe61f690103);
$parcel$export(module.exports, "useSkeletonIcon", () => $6117660dffb4b363$export$4b7803c08fe9a32b);


var $5nTep = parcelRequire("5nTep");

var $5nuB1 = parcelRequire("5nuB1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $gF3YT = parcelRequire("gF3YT");

var $bkjeZ = parcelRequire("bkjeZ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6117660dffb4b363$export$6b288fe07640c94c(isAnimating) {
    let animationRef = (0, $eF4cA.useRef)(null);
    let reduceMotion = (0, $5nuB1.useMediaQuery)('(prefers-reduced-motion: reduce)');
    return (0, $eF4cA.useCallback)((element)=>{
        if (isAnimating && !animationRef.current && element && !reduceMotion && typeof element.animate === 'function') {
            // Use web animation API instead of CSS animations so that we can
            // synchronize it between all loading elements on the page (via startTime).
            animationRef.current = element.animate([
                {
                    backgroundPosition: '100%'
                },
                {
                    backgroundPosition: '0%'
                }
            ], {
                duration: 2000,
                iterations: Infinity,
                easing: 'ease-in-out'
            });
            animationRef.current.startTime = 0;
        } else if (!isAnimating && animationRef.current) {
            animationRef.current.cancel();
            animationRef.current = null;
        }
    }, [
        isAnimating,
        reduceMotion
    ]);
}
const $6117660dffb4b363$export$74e166679b1f49ee = (0, $eF4cA.createContext)(null);
function $6117660dffb4b363$export$4f8dc7555740235c() {
    return (0, $eF4cA.useContext)($6117660dffb4b363$export$74e166679b1f49ee) || false;
}
function $6117660dffb4b363$export$8f31e4c4a37b8e9c({ children: children, isLoading: isLoading }) {
    // Disable all form components inside a skeleton.
    return (0, $dx4lB.jsx)($6117660dffb4b363$export$74e166679b1f49ee.Provider, {
        value: isLoading,
        children: children
    });
}
const $6117660dffb4b363$export$d2353276f167b21f = "bNU3Fb"; // add to a separate layer so it overrides default style macro styles
function $6117660dffb4b363$export$a05a0b8a311cd65f(children, style) {
    let isSkeleton = (0, $eF4cA.useContext)($6117660dffb4b363$export$74e166679b1f49ee);
    if (isSkeleton) {
        children = (0, $dx4lB.jsx)($6117660dffb4b363$export$cb6ddd830302c2a8, {
            children: children
        });
        style = {
            ...style,
            // This ensures the ellipsis on truncated text is also hidden.
            // -webkit-text-fill-color overrides any `color` property that is also set.
            WebkitTextFillColor: 'transparent'
        };
    }
    return [
        children,
        style
    ];
}
function $6117660dffb4b363$export$cb6ddd830302c2a8({ children: children }) {
    return (0, $dx4lB.jsx)("span", {
        // @ts-ignore - compatibility with React < 19
        inert: (0, $gF3YT.inertValue)(true),
        ref: $6117660dffb4b363$export$6b288fe07640c94c(true),
        className: $6117660dffb4b363$export$d2353276f167b21f + " pw182 _ma182 oa182 na182 ka182 ja182",
        children: children
    });
}
function $6117660dffb4b363$export$6069cbe61f690103({ children: children }) {
    let isLoading = (0, $eF4cA.useContext)($6117660dffb4b363$export$74e166679b1f49ee);
    let animation = $6117660dffb4b363$export$6b288fe07640c94c(isLoading || false);
    if (isLoading == null) return children;
    let childRef = 'ref' in children && !Object.getOwnPropertyDescriptor(children, 'ref')?.get ? children.ref : children.props.ref;
    return (0, $dx4lB.jsx)($6117660dffb4b363$export$74e166679b1f49ee.Provider, {
        value: null,
        children: isLoading ? (0, $eF4cA.cloneElement)(children, {
            ref: (0, $bkjeZ.mergeRefs)(childRef, animation),
            className: (children.props.className || '') + ' ' + $6117660dffb4b363$export$d2353276f167b21f,
            // @ts-ignore - compatibility with React < 19
            inert: (0, $gF3YT.inertValue)(true)
        }) : children
    });
}
function $6117660dffb4b363$export$4b7803c08fe9a32b(styles) {
    let isSkeleton = (0, $eF4cA.useContext)($6117660dffb4b363$export$74e166679b1f49ee);
    if (isSkeleton) return (0, $5nTep.mergeStyles)(" oa182 na182 ka182 ja182", styles);
    return styles || '';
}

});
parcelRegister("5nuB1", function(module, exports) {

$parcel$export(module.exports, "useMediaQuery", () => $2cedf7f310358e5c$export$32d5543ab307c01);

var $eF4cA = parcelRequire("eF4cA");

var $hWe38 = parcelRequire("hWe38");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2cedf7f310358e5c$export$32d5543ab307c01(query) {
    let supportsMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    let [matches, setMatches] = (0, $eF4cA.useState)(()=>supportsMatchMedia ? window.matchMedia(query).matches : false);
    (0, $eF4cA.useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let mq = window.matchMedia(query);
        let onChange = (evt)=>{
            setMatches(evt.matches);
        };
        mq.addListener(onChange);
        return ()=>{
            mq.removeListener(onChange);
        };
    }, [
        supportsMatchMedia,
        query
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, $hWe38.useIsSSR)();
    return isSSR ? false : matches;
}

});

parcelRegister("gF3YT", function(module, exports) {

$parcel$export(module.exports, "inertValue", () => $b1bf7c31d3c4797b$export$a9d04c5684123369);

var $eF4cA = parcelRequire("eF4cA");
function $b1bf7c31d3c4797b$export$a9d04c5684123369(value) {
    const pieces = (0, $eF4cA.version).split('.');
    const major = parseInt(pieces[0], 10);
    if (major >= 19) return value;
    // compatibility with React < 19
    return value ? 'true' : undefined;
}

});



parcelRegister("3PqDc", function(module, exports) {

$parcel$export(module.exports, "createFocusableRef", () => $58c03fbec7b530e9$export$79d69eee6ae4b329);
$parcel$export(module.exports, "useDOMRef", () => $58c03fbec7b530e9$export$c2c55ef9111cafd8);
$parcel$export(module.exports, "useFocusableRef", () => $58c03fbec7b530e9$export$96a734597687c040);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $58c03fbec7b530e9$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $58c03fbec7b530e9$export$79d69eee6ae4b329(domRef, focusableRef) {
    let resolvedFocusableRef = focusableRef || domRef;
    return {
        ...$58c03fbec7b530e9$export$a5795cc979dfae80(domRef),
        focus () {
            if (resolvedFocusableRef.current) resolvedFocusableRef.current.focus();
        }
    };
}
function $58c03fbec7b530e9$export$c2c55ef9111cafd8(ref) {
    let domRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>$58c03fbec7b530e9$export$a5795cc979dfae80(domRef));
    return domRef;
}
function $58c03fbec7b530e9$export$96a734597687c040(ref, focusableRef) {
    let domRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>$58c03fbec7b530e9$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $58c03fbec7b530e9$export$c7e28c72a4823176(ref) {
    return {
        get current () {
            return ref.current && ref.current.UNSAFE_getDOMNode();
        }
    };
}
function $58c03fbec7b530e9$export$1d5cc31d9d8df817(ref) {
    return (0, $eF4cA.useMemo)(()=>$58c03fbec7b530e9$export$c7e28c72a4823176(ref), [
        ref
    ]);
}

});


parcelRegister("7PKMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bbca58b98618ec$export$2e2bcd8739ae039);


var $5A9Xi = parcelRequire("5A9Xi");

var $1Wrpf = parcelRequire("1Wrpf");

var $cO4x8 = parcelRequire("cO4x8");

var $4fc7M = parcelRequire("4fc7M");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $64bbca58b98618ec$var$$dc67c4e34e45a62a$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' ZydxGIe182';
    else if (props.size === "XL") rules += ' ZsWXEHc182';
    else if (props.size === "L") rules += ' Zg182';
    else if (props.size === "M") rules += ' ZydxGIe182';
    if (props.size === "S") rules += ' Ff182';
    else if (props.size === "XL") rules += ' FsWXEHc182';
    else if (props.size === "L") rules += ' Fg182';
    else if (props.size === "M") rules += ' Ff182';
    return rules;
};
function $64bbca58b98618ec$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $1Wrpf.default), {
                ...otherProps,
                className: (otherProps.className || '') + $64bbca58b98618ec$var$$dc67c4e34e45a62a$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $5A9Xi.default), {
                ...otherProps,
                className: (otherProps.className || '') + $64bbca58b98618ec$var$$dc67c4e34e45a62a$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $4fc7M.default), {
                ...otherProps,
                className: (otherProps.className || '') + $64bbca58b98618ec$var$$dc67c4e34e45a62a$var$styles({
                    size: size
                })
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $cO4x8.default), {
                ...otherProps,
                className: (otherProps.className || '') + $64bbca58b98618ec$var$$dc67c4e34e45a62a$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("5A9Xi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2839f556a80ffc92$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $2839f556a80ffc92$var$$b02ba09d8ed42b76$var$SvgS2CornerTriangleSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 6,
        viewBox: "0 0 6 6",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M.826 5.146 5.147.826a.5.5 0 0 1 .854.353L6 5.25a.75.75 0 0 1-.75.75H1.18a.5.5 0 0 1-.354-.854"
        })
    });
var $2839f556a80ffc92$export$2e2bcd8739ae039 = $2839f556a80ffc92$var$$b02ba09d8ed42b76$var$SvgS2CornerTriangleSize200;

});

parcelRegister("1Wrpf", function(module, exports) {

$parcel$export(module.exports, "default", () => $faf439049d326354$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $faf439049d326354$var$$b7774514db903160$var$SvgS2CornerTriangleSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 5,
        height: 5,
        viewBox: "0 0 5 5",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M.154 4.146 4.147.154A.5.5 0 0 1 5 .507V4.25a.75.75 0 0 1-.75.75H.507a.5.5 0 0 1-.354-.854"
        })
    });
var $faf439049d326354$export$2e2bcd8739ae039 = $faf439049d326354$var$$b7774514db903160$var$SvgS2CornerTriangleSize100;

});

parcelRegister("cO4x8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ab8bb17022ea1e4$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $8ab8bb17022ea1e4$var$$96a511a77483b03c$var$SvgS2CornerTriangleSize75 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 5,
        height: 5,
        viewBox: "0 0 5 5",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M.764 4.488 4.489.762a.3.3 0 0 1 .513.212L5 4.25a.75.75 0 0 1-.75.75H.976a.3.3 0 0 1-.212-.512"
        })
    });
var $8ab8bb17022ea1e4$export$2e2bcd8739ae039 = $8ab8bb17022ea1e4$var$$96a511a77483b03c$var$SvgS2CornerTriangleSize75;

});

parcelRegister("4fc7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4359e4274e96561c$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $4359e4274e96561c$var$$ea5d4480fb979063$var$SvgS2CornerTriangleSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 7,
        height: 7,
        viewBox: "0 0 7 7",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M.821 6.146 6.147.821A.5.5 0 0 1 7 1.175L6.999 6.25a.75.75 0 0 1-.75.75H1.174a.5.5 0 0 1-.353-.854"
        })
    });
var $4359e4274e96561c$export$2e2bcd8739ae039 = $4359e4274e96561c$var$$ea5d4480fb979063$var$SvgS2CornerTriangleSize300;

});


parcelRegister("dm5H1", function(module, exports) {

$parcel$export(module.exports, "IconContext", () => $ffbea0ae8b644fa6$export$a49f528ae1a4d0ed);
$parcel$export(module.exports, "IllustrationContext", () => $ffbea0ae8b644fa6$export$207c7561471de4bd);
$parcel$export(module.exports, "createIcon", () => $ffbea0ae8b644fa6$export$274edc73af1ae9c8);
$parcel$export(module.exports, "createIllustration", () => $ffbea0ae8b644fa6$export$4d00e7be716a0093);


var $5nTep = parcelRequire("5nTep");

var $91SAk = parcelRequire("91SAk");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Custom list of overrides, excluding width/height/flexGrow/flexShrink/flexBasis
const $ffbea0ae8b644fa6$var$$ac8c32e6775ddd1f$var$allowedOverrides = [
    'margin',
    'marginStart',
    'marginEnd',
    'marginTop',
    'marginBottom',
    'marginX',
    'marginY',
    'justifySelf',
    'alignSelf',
    'order',
    'gridArea',
    'gridRowStart',
    'gridRowEnd',
    'gridColumnStart',
    'gridColumnEnd',
    'position',
    'zIndex',
    'top',
    'bottom',
    'inset',
    'insetX',
    'insetY',
    'insetStart',
    'insetEnd',
    'rotate',
    '--iconPrimary',
    'size'
];
const $ffbea0ae8b644fa6$export$a49f528ae1a4d0ed = (0, $eF4cA.createContext)({});
const $ffbea0ae8b644fa6$export$207c7561471de4bd = (0, $eF4cA.createContext)({});
const $ffbea0ae8b644fa6$var$$ac8c32e6775ddd1f$var$iconStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let height = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_S|-_8sjo0b-|Z|F)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "F") height = true;
        rules += p[0];
    }
    if (!width) rules += ' Zm182';
    if (!height) rules += ' Fn182';
    rules += ' _va182';
    return rules;
};
function $ffbea0ae8b644fa6$export$274edc73af1ae9c8(Component, context = $ffbea0ae8b644fa6$export$a49f528ae1a4d0ed) {
    return (props)=>{
        let ref = (0, $eF4cA.useRef)(null);
        let ctx;
        // TODO: remove this default once we release RAC and use DEFAULT_SLOT.
        [ctx, ref] = (0, $5t6Bv.useSpectrumContextProps)({
            slot: props.slot || 'icon'
        }, ref, context);
        let { render: render, styles: ctxStyles } = ctx;
        let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, slot: slot, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, styles: styles, ...otherProps } = props;
        if (!ariaHidden) ariaHidden = undefined;
        let svg = (0, $dx4lB.jsx)((0, $91SAk.SkeletonWrapper), {
            children: (0, $dx4lB.jsx)(Component, {
                ...otherProps,
                focusable: false,
                "aria-label": ariaLabel,
                "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
                role: "img",
                "data-slot": slot,
                className: (UNSAFE_className ?? '') + ' ' + (0, $91SAk.useSkeletonIcon)((0, $5nTep.mergeStyles)($ffbea0ae8b644fa6$var$$ac8c32e6775ddd1f$var$iconStyles(null, styles), ctxStyles)),
                style: UNSAFE_style
            })
        });
        if (render) return render(svg);
        return svg;
    };
}
const $ffbea0ae8b644fa6$var$$ac8c32e6775ddd1f$var$illustrationStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let height = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_S|-_8sjo0b-|Z|F)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "F") height = true;
        rules += p[0];
    }
    if (props.size === "L") {
        if (!width) rules += ' Zq182';
    } else if (props.size === "M") {
        if (!width) rules += ' ZH182';
    } else if (props.size === "S") {
        if (!width) rules += ' ZF182';
    }
    if (props.size === "L") {
        if (!height) rules += ' Fr182';
    } else if (props.size === "M") {
        if (!height) rules += ' FB182';
    } else if (props.size === "S") {
        if (!height) rules += ' Fz182';
    }
    rules += ' _va182';
    return rules;
};
function $ffbea0ae8b644fa6$export$4d00e7be716a0093(Component) {
    return (props)=>{
        let ref = (0, $eF4cA.useRef)(null);
        let ctx;
        [ctx, ref] = (0, $5t6Bv.useSpectrumContextProps)({
            slot: props.slot || 'icon'
        }, ref, $ffbea0ae8b644fa6$export$207c7561471de4bd);
        let { styles: ctxStyles } = ctx;
        let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, slot: slot, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, size: size = ctx.size || 'M', styles: styles, render: render, ...otherProps } = props;
        if (!ariaHidden) ariaHidden = undefined;
        let svg = (0, $dx4lB.jsx)(Component, {
            ...otherProps,
            // @ts-ignore
            size: size,
            focusable: false,
            "aria-label": ariaLabel,
            "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
            role: "img",
            "data-slot": slot,
            className: (UNSAFE_className ?? '') + ' ' + $ffbea0ae8b644fa6$var$$ac8c32e6775ddd1f$var$illustrationStyles({
                size: size
            }, styles) + (ctxStyles || ''),
            style: UNSAFE_style
        });
        if (render) return render(svg);
        return svg;
    };
}

});

parcelRegister("fL4LX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dbdfb20c7d12c28$export$2e2bcd8739ae039);

var $43fUq = parcelRequire("43fUq");

var $amOUD = parcelRequire("amOUD");

var $2W1iK = parcelRequire("2W1iK");

var $bldnd = parcelRequire("bldnd");

var $kqxqC = parcelRequire("kqxqC");

var $bWHhR = parcelRequire("bWHhR");

var $4HqLo = parcelRequire("4HqLo");

var $9SkqN = parcelRequire("9SkqN");

var $hfQck = parcelRequire("hfQck");

var $iqc6m = parcelRequire("iqc6m");

var $2uGrh = parcelRequire("2uGrh");

var $3e6Rm = parcelRequire("3e6Rm");

var $a7HKl = parcelRequire("a7HKl");

var $cGoWM = parcelRequire("cGoWM");

var $5X7Si = parcelRequire("5X7Si");

var $bv0dB = parcelRequire("bv0dB");

var $jPF8s = parcelRequire("jPF8s");

var $i8FW1 = parcelRequire("i8FW1");

var $fUrYd = parcelRequire("fUrYd");

var $foKXL = parcelRequire("foKXL");

var $aMrQ9 = parcelRequire("aMrQ9");

var $d1523 = parcelRequire("d1523");

var $3nle0 = parcelRequire("3nle0");

var $eIs9f = parcelRequire("eIs9f");

var $lVZPF = parcelRequire("lVZPF");

var $6mBFH = parcelRequire("6mBFH");

var $aS80E = parcelRequire("aS80E");

var $6Y8N9 = parcelRequire("6Y8N9");

var $gZeC4 = parcelRequire("gZeC4");

var $e5vw3 = parcelRequire("e5vw3");

var $2YYUo = parcelRequire("2YYUo");

var $fYKMa = parcelRequire("fYKMa");

var $cfHOy = parcelRequire("cfHOy");

var $3pU8B = parcelRequire("3pU8B");
var $8dbdfb20c7d12c28$export$2e2bcd8739ae039 = {};
$8dbdfb20c7d12c28$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $43fUq.default),
    "bg-BG": (0, $amOUD.default),
    "cs-CZ": (0, $2W1iK.default),
    "da-DK": (0, $bldnd.default),
    "de-DE": (0, $kqxqC.default),
    "el-GR": (0, $bWHhR.default),
    "en-US": (0, $4HqLo.default),
    "es-ES": (0, $9SkqN.default),
    "et-EE": (0, $hfQck.default),
    "fi-FI": (0, $iqc6m.default),
    "fr-FR": (0, $2uGrh.default),
    "he-IL": (0, $3e6Rm.default),
    "hr-HR": (0, $a7HKl.default),
    "hu-HU": (0, $cGoWM.default),
    "it-IT": (0, $5X7Si.default),
    "ja-JP": (0, $bv0dB.default),
    "ko-KR": (0, $jPF8s.default),
    "lt-LT": (0, $i8FW1.default),
    "lv-LV": (0, $fUrYd.default),
    "nb-NO": (0, $foKXL.default),
    "nl-NL": (0, $aMrQ9.default),
    "pl-PL": (0, $d1523.default),
    "pt-BR": (0, $3nle0.default),
    "pt-PT": (0, $eIs9f.default),
    "ro-RO": (0, $lVZPF.default),
    "ru-RU": (0, $6mBFH.default),
    "sk-SK": (0, $aS80E.default),
    "sl-SI": (0, $6Y8N9.default),
    "sr-SP": (0, $gZeC4.default),
    "sv-SE": (0, $e5vw3.default),
    "tr-TR": (0, $2YYUo.default),
    "uk-UA": (0, $fYKMa.default),
    "zh-CN": (0, $cfHOy.default),
    "zh-TW": (0, $3pU8B.default)
};

});
parcelRegister("43fUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $824c66d00afc7a03$export$2e2bcd8739ae039);
var $824c66d00afc7a03$export$2e2bcd8739ae039 = {};
$824c66d00afc7a03$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "actionbar.actionsAvailable": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    "actionbar.clearSelection": `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{645}\u{62D}\u{62F}\u{62F}`
        })}`,
    "actionbar.selectedAll": `\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{644}`,
    "actionbutton.pending": `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    "breadcrumbs.more": `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631}`,
    "button.pending": `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
            other: `\u{627}\u{644}\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E}`
        })} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}/\u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{648}\u{641}\u{631}\u{629}.`,
    "combobox.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "combobox.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "combobox.noResults": `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C}`,
    "contextualhelp.help": `\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}`,
    "contextualhelp.info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "datepicker.endTime": `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    "datepicker.startTime": `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    "datepicker.time": `\u{627}\u{644}\u{648}\u{642}\u{62A}`,
    "dialog.alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dialog.dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`,
    "dropzone.replaceMessage": `\u{644}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{62F}\u{627}\u{644}\u{60C} \u{642}\u{645} \u{628}\u{625}\u{641}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{644}\u{641}`,
    "inlinealert.informative": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "inlinealert.negative": `\u{62E}\u{637}\u{623}`,
    "inlinealert.notice": `\u{62A}\u{62D}\u{630}\u{64A}\u{631}`,
    "inlinealert.positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`,
    "label.(optional)": `(\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A})`,
    "label.(required)": `(\u{645}\u{637}\u{644}\u{648}\u{628})`,
    "listview.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "listview.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "menu.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "menu.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "menu.moreActions": `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "menu.noResults": `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C}`,
    "menu.unavailable": `\u{63A}\u{64A}\u{631} \u{645}\u{64F}\u{62A}\u{648}\u{641}\u{631}\u{60C} \u{642}\u{64F}\u{645} \u{628}\u{627}\u{644}\u{62A}\u{648}\u{633}\u{64A}\u{639} \u{644}\u{644}\u{62D}\u{635}\u{648}\u{644} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644}`,
    "notificationbadge.indicatorOnly": `\u{646}\u{634}\u{627}\u{637} \u{62C}\u{62F}\u{64A}\u{62F}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "picker.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "picker.placeholder": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{623}\u{64A} \u{639}\u{646}\u{635}\u{631}`,
            one: `\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{635}\u{631} \u{648}\u{627}\u{62D}\u{62F}`,
            two: `\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{635}\u{631}\u{64A}\u{646}`,
            few: ()=>`\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} ${formatter.number(args.count)} \u{639}\u{646}\u{627}\u{635}\u{631}`,
            other: ()=>`\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} ${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631}`
        })}`,
    "sidepanel.collapse": `\u{637}\u{64A} \u{627}\u{644}\u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{62C}\u{627}\u{646}\u{628}\u{64A}\u{629}`,
    "sidepanel.expand": `\u{62A}\u{648}\u{633}\u{64A}\u{639} \u{627}\u{644}\u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{62C}\u{627}\u{646}\u{628}\u{64A}\u{629}`,
    "slider.maximum": `\u{623}\u{642}\u{635}\u{649}`,
    "slider.minimum": `\u{623}\u{62F}\u{646}\u{649}`,
    "table.cancel": `\u{625}\u{644}\u{63A}\u{627}\u{621}`,
    "table.drag": `\u{633}\u{62D}\u{628}`,
    "table.editCell": `\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{62E}\u{644}\u{64A}\u{629}`,
    "table.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "table.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "table.resizeColumn": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{62D}\u{62C}\u{645} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F}`,
    "table.save": `\u{62D}\u{641}\u{638}`,
    "table.sortAscending": `\u{641}\u{631}\u{632} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "table.sortDescending": `\u{641}\u{631}\u{632} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "tag.actions": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "tag.hideButtonLabel": `\u{625}\u{638}\u{647}\u{627}\u{631} \u{623}\u{642}\u{644}`,
    "tag.noTags": `\u{628}\u{62F}\u{648}\u{646}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{639}\u{631}\u{636} \u{627}\u{644}\u{643}\u{644} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{643}\u{644}`,
    "toast.collapse": `\u{637}\u{64A}`,
    "toast.showAll": `\u{625}\u{638}\u{647}\u{627}\u{631} \u{627}\u{644}\u{643}\u{644}`,
    "treeview.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};

});

parcelRegister("amOUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a8af4d85a1650d$export$2e2bcd8739ae039);
var $a0a8af4d85a1650d$export$2e2bcd8739ae039 = {};
$a0a8af4d85a1650d$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "actionbar.actionsAvailable": `\u{41D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{438} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}.`,
    "actionbar.clearSelection": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{438}\u{437}\u{431}\u{43E}\u{440}\u{430}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
        })}`,
    "actionbar.selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
    "actionbutton.pending": `\u{43D}\u{435}\u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    "breadcrumbs.more": `\u{41E}\u{449}\u{435} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
    "button.pending": `\u{43D}\u{435}\u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435} \u{435} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430}`,
            other: `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{430}\u{442}\u{438} \u{43D}\u{435} \u{441}\u{430} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{438}`
        })}.`,
    "combobox.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "combobox.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "combobox.noResults": `\u{41D}\u{44F}\u{43C}\u{430} \u{440}\u{435}\u{437}\u{443}\u{43B}\u{442}\u{430}\u{442}\u{438}`,
    "contextualhelp.help": `\u{41F}\u{43E}\u{43C}\u{43E}\u{449}`,
    "contextualhelp.info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "datepicker.endTime": `\u{41A}\u{440}\u{430}\u{435}\u{43D} \u{447}\u{430}\u{441}`,
    "datepicker.startTime": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{435}\u{43D} \u{447}\u{430}\u{441}`,
    "datepicker.time": `\u{412}\u{440}\u{435}\u{43C}\u{435}`,
    "dialog.alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dialog.dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`,
    "dropzone.replaceMessage": `\u{41F}\u{443}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{437}\u{430} \u{437}\u{430}\u{43C}\u{44F}\u{43D}\u{430}`,
    "inlinealert.informative": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "inlinealert.negative": `\u{413}\u{440}\u{435}\u{448}\u{43A}\u{430}`,
    "inlinealert.notice": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "inlinealert.positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`,
    "label.(optional)": `(\u{43D}\u{435}\u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E})`,
    "label.(required)": `(\u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E})`,
    "listview.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "listview.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "menu.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "menu.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "menu.moreActions": `\u{41F}\u{43E}\u{432}\u{435}\u{447}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "menu.noResults": `\u{41D}\u{44F}\u{43C}\u{430} \u{440}\u{435}\u{437}\u{443}\u{43B}\u{442}\u{430}\u{442}\u{438}`,
    "menu.unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{44A}\u{43F}\u{43D}\u{43E}, \u{440}\u{430}\u{437}\u{433}\u{44A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    "notificationbadge.indicatorOnly": `\u{41D}\u{43E}\u{432}\u{430} \u{434}\u{435}\u{439}\u{43D}\u{43E}\u{441}\u{442}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "picker.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "picker.placeholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`
        })}`,
    "sidepanel.collapse": `\u{421}\u{433}\u{44A}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{43D}\u{438}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}`,
    "sidepanel.expand": `\u{420}\u{430}\u{437}\u{433}\u{44A}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{447}\u{43D}\u{438}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}`,
    "slider.maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "slider.minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`,
    "table.cancel": `\u{41E}\u{442}\u{43A}\u{430}\u{437}`,
    "table.drag": `\u{41F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435}`,
    "table.editCell": `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43A}\u{43B}\u{435}\u{442}\u{43A}\u{430}`,
    "table.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "table.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "table.resizeColumn": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`,
    "table.save": `\u{417}\u{430}\u{43F}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435}`,
    "table.sortAscending": `\u{412}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{43E} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435}`,
    "table.sortDescending": `\u{41D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{43E} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435} `,
    "tag.actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "tag.hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43F}\u{43E}-\u{43C}\u{430}\u{43B}\u{43A}\u{43E}`,
    "tag.noTags": `\u{41D}\u{438}\u{442}\u{43E} \u{435}\u{434}\u{438}\u{43D}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{438} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{438} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{438}`,
    "toast.collapse": `\u{421}\u{432}\u{438}\u{432}\u{430}\u{43D}\u{435}`,
    "toast.showAll": `\u{41F}\u{43E}\u{43A}\u{430}\u{436}\u{438} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{438}`,
    "treeview.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`
};

});

parcelRegister("2W1iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $09951b411411f08f$export$2e2bcd8739ae039);
var $09951b411411f08f$export$2e2bcd8739ae039 = {};
$09951b411411f08f$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Akce`,
    "actionbar.actionsAvailable": `Dostupn\xe9 akce.`,
    "actionbar.clearSelection": `Vymazat v\xfdb\u{11B}r`,
    "actionbar.selected": (args)=>`Vybr\xe1no: ${args.count}`,
    "actionbar.selectedAll": `Vybr\xe1no v\u{161}e`,
    "actionbutton.pending": `\u{10D}ek\xe1 na vy\u{159}\xedzen\xed`,
    "breadcrumbs.more": `Dal\u{161}\xed polo\u{17E}ky`,
    "button.pending": `\u{10D}ek\xe1 na vy\u{159}\xedzen\xed`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybran\xe9 datum nen\xed`,
            other: `Vybran\xe1 data nejsou`
        })} k dispozici.`,
    "combobox.loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "combobox.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "combobox.noResults": `\u{17D}\xe1dn\xe9 v\xfdsledky`,
    "contextualhelp.help": `N\xe1pov\u{11B}da`,
    "contextualhelp.info": `Informace`,
    "datepicker.endTime": `Kone\u{10D}n\xfd \u{10D}as`,
    "datepicker.startTime": `Po\u{10D}\xe1te\u{10D}n\xed \u{10D}as`,
    "datepicker.time": `\u{10C}as`,
    "dialog.alert": `V\xfdstraha`,
    "dialog.dismiss": `Odstranit`,
    "dropzone.replaceMessage": `P\u{159}et\xe1hn\u{11B}te soubor k nahrazen\xed`,
    "inlinealert.informative": `Informace`,
    "inlinealert.negative": `Chyba`,
    "inlinealert.notice": `Varov\xe1n\xed`,
    "inlinealert.positive": `\xdasp\u{11B}ch`,
    "label.(optional)": `(voliteln\u{11B})`,
    "label.(required)": `(po\u{17E}adov\xe1no)`,
    "listview.loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "listview.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "menu.loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "menu.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "menu.moreActions": `Dal\u{161}\xed akce`,
    "menu.noResults": `\u{17D}\xe1dn\xe9 v\xfdsledky`,
    "menu.unavailable": `Nen\xed k dispozici, rozbalen\xedm zobraz\xedte podrobnosti`,
    "notificationbadge.indicatorOnly": `Nov\xe1 aktivita`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "picker.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "picker.placeholder": `Vybrat\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nevybr\xe1ny \u{17E}\xe1dn\xe9 polo\u{17E}ky`,
            one: ()=>`Vybr\xe1na ${formatter.number(args.count)} polo\u{17E}ka`,
            few: ()=>`Vybr\xe1ny ${formatter.number(args.count)} polo\u{17E}ky`,
            other: ()=>`Vybr\xe1no ${formatter.number(args.count)} polo\u{17E}ek`
        })}`,
    "sidepanel.collapse": `Sbalit postrann\xed panel`,
    "sidepanel.expand": `Rozbalit postrann\xed panel`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Zru\u{161}it`,
    "table.drag": `P\u{159}et\xe1hnout`,
    "table.editCell": `Upravit bu\u{148}ku`,
    "table.loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "table.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "table.resizeColumn": `Zm\u{11B}nit velikost sloupce`,
    "table.save": `Ulo\u{17E}it`,
    "table.sortAscending": `Se\u{159}adit vzestupn\u{11B}`,
    "table.sortDescending": `Se\u{159}adit sestupn\u{11B}`,
    "tag.actions": `Akce`,
    "tag.hideButtonLabel": `Zobrazit m\xe9n\u{11B}`,
    "tag.noTags": `\u{17D}\xe1dn\xfd`,
    "tag.showAllButtonLabel": (args, formatter)=>`Zobrazit v\u{161}e (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Smazat v\u{161}e`,
    "toast.collapse": `Sbalit`,
    "toast.showAll": `Zobrazit v\u{161}e`,
    "treeview.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};

});

parcelRegister("bldnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba0a3bbfb4b0794$export$2e2bcd8739ae039);
var $5ba0a3bbfb4b0794$export$2e2bcd8739ae039 = {};
$5ba0a3bbfb4b0794$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Handlinger`,
    "actionbar.actionsAvailable": `Tilg\xe6ngelige handlinger.`,
    "actionbar.clearSelection": `Ryd markering`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen valgt`,
            other: ()=>`${formatter.number(args.count)} valgt`
        })}`,
    "actionbar.selectedAll": `Alle valgt`,
    "actionbutton.pending": `afventende`,
    "breadcrumbs.more": `Flere elementer`,
    "button.pending": `afventende`,
    "calendar.invalidSelection": (args, formatter)=>`Valgte ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} ikke ledige.`,
    "combobox.loading": `Indl\xe6ser...`,
    "combobox.loadingMore": `Indl\xe6ser flere...`,
    "combobox.noResults": `Ingen resultater`,
    "contextualhelp.help": `Hj\xe6lp`,
    "contextualhelp.info": `Oplysninger`,
    "datepicker.endTime": `Sluttidspunkt`,
    "datepicker.startTime": `Starttidspunkt`,
    "datepicker.time": `Klokkesl\xe6t`,
    "dialog.alert": `Advarsel`,
    "dialog.dismiss": `Luk`,
    "dropzone.replaceMessage": `Drop fil for at erstatte`,
    "inlinealert.informative": `Oplysninger`,
    "inlinealert.negative": `Fejl`,
    "inlinealert.notice": `Advarsel`,
    "inlinealert.positive": `Fuldf\xf8rt`,
    "label.(optional)": `(valgfrit)`,
    "label.(required)": `(obligatorisk)`,
    "listview.loading": `Indl\xe6ser...`,
    "listview.loadingMore": `Indl\xe6ser flere...`,
    "menu.loading": `Indl\xe6ser...`,
    "menu.loadingMore": `Indl\xe6ser flere...`,
    "menu.moreActions": `Flere handlinger`,
    "menu.noResults": `Ingen resultater`,
    "menu.unavailable": `Ikke tilg\xe6ngelig, udvid for detaljer`,
    "notificationbadge.indicatorOnly": `Ny aktivitet`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Indl\xe6ser...`,
    "picker.loadingMore": `Indl\xe6ser flere...`,
    "picker.placeholder": `V\xe6lg\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer valgt`,
            one: ()=>`${formatter.number(args.count)} element valgt`,
            other: ()=>`${formatter.number(args.count)} elementer valgt`
        })}`,
    "sidepanel.collapse": `Skjul sidepanel`,
    "sidepanel.expand": `Udvid sidepanel`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Annuller`,
    "table.drag": `Tr\xe6k`,
    "table.editCell": `Rediger celle`,
    "table.loading": `Indl\xe6ser...`,
    "table.loadingMore": `Indl\xe6ser flere...`,
    "table.resizeColumn": `Tilpas st\xf8rrelse p\xe5 kolonne`,
    "table.save": `Gem`,
    "table.sortAscending": `Sorter stigende`,
    "table.sortDescending": `Sorter faldende`,
    "tag.actions": `Handlinger`,
    "tag.hideButtonLabel": `Vis mindre`,
    "tag.noTags": `Ingen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Ryd alle`,
    "toast.collapse": `Skjul`,
    "toast.showAll": `Vis alle`,
    "treeview.loadingMore": `Indl\xe6ser flere...`
};

});

parcelRegister("kqxqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f24d98fa08e3cc$export$2e2bcd8739ae039);
var $28f24d98fa08e3cc$export$2e2bcd8739ae039 = {};
$28f24d98fa08e3cc$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Aktionen`,
    "actionbar.actionsAvailable": `Aktionen verf\xfcgbar.`,
    "actionbar.clearSelection": `Auswahl l\xf6schen`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nichts ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlt`
        })}`,
    "actionbar.selectedAll": `Alles ausgew\xe4hlt`,
    "actionbutton.pending": `Ausstehend`,
    "breadcrumbs.more": `Weitere Elemente`,
    "button.pending": `Ausstehend`,
    "calendar.invalidSelection": (args, formatter)=>`Ausgew\xe4hlte(s) ${formatter.plural(args.selectedCount, {
            one: `Datum`,
            other: `Daten`
        })} nicht verf\xfcgbar.`,
    "combobox.loading": `Laden...`,
    "combobox.loadingMore": `Mehr laden ...`,
    "combobox.noResults": `Keine Ergebnisse`,
    "contextualhelp.help": `Hilfe`,
    "contextualhelp.info": `Informationen`,
    "datepicker.endTime": `Endzeit`,
    "datepicker.startTime": `Startzeit`,
    "datepicker.time": `Uhrzeit`,
    "dialog.alert": `Warnhinweis`,
    "dialog.dismiss": `Schlie\xdfen`,
    "dropzone.replaceMessage": `Datei zum Ersetzen ablegen`,
    "inlinealert.informative": `Informationen`,
    "inlinealert.negative": `Fehler`,
    "inlinealert.notice": `Warnung`,
    "inlinealert.positive": `Erfolg`,
    "label.(optional)": `(optional)`,
    "label.(required)": `(erforderlich)`,
    "listview.loading": `Laden...`,
    "listview.loadingMore": `Mehr laden ...`,
    "menu.loading": `Laden...`,
    "menu.loadingMore": `Mehr laden ...`,
    "menu.moreActions": `Mehr Aktionen`,
    "menu.noResults": `Keine Ergebnisse`,
    "menu.unavailable": `Nicht verf\xfcgbar, f\xfcr Details erweitern`,
    "notificationbadge.indicatorOnly": `Neue Aktivit\xe4t`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Laden...`,
    "picker.loadingMore": `Mehr laden ...`,
    "picker.placeholder": `Ausw\xe4hlen\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Keine Elemente ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} Element ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} Elemente ausgew\xe4hlt`
        })}`,
    "sidepanel.collapse": `Seitliches Panel reduzieren`,
    "sidepanel.expand": `Seitliches Panel erweitern`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Abbrechen`,
    "table.drag": `Ziehen`,
    "table.editCell": `Zelle bearbeiten`,
    "table.loading": `Laden...`,
    "table.loadingMore": `Mehr laden ...`,
    "table.resizeColumn": `Spaltengr\xf6\xdfe \xe4ndern`,
    "table.save": `Speichern`,
    "table.sortAscending": `Aufsteigend sortieren`,
    "table.sortDescending": `Absteigend sortieren`,
    "tag.actions": `Aktionen`,
    "tag.hideButtonLabel": `Weniger zeigen`,
    "tag.noTags": `Keine`,
    "tag.showAllButtonLabel": (args, formatter)=>`Alle anzeigen (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Alle l\xf6schen`,
    "toast.collapse": `Reduzieren`,
    "toast.showAll": `Alle anzeigen`,
    "treeview.loadingMore": `Mehr laden ...`
};

});

parcelRegister("bWHhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e943b40186cb95ca$export$2e2bcd8739ae039);
var $e943b40186cb95ca$export$2e2bcd8739ae039 = {};
$e943b40186cb95ca$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{395}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "actionbar.actionsAvailable": `\u{3A5}\u{3C0}\u{3AC}\u{3C1}\u{3C7}\u{3BF}\u{3C5}\u{3BD} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2} \u{3B5}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}.`,
    "actionbar.clearSelection": `\u{395}\u{3BA}\u{3BA}\u{3B1}\u{3B8}\u{3AC}\u{3C1}\u{3B9}\u{3C3}\u{3B7} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3BA}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1}`,
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1}`
        })}`,
    "actionbar.selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1}`,
    "actionbutton.pending": `\u{3C3}\u{3B5} \u{3B5}\u{3BA}\u{3BA}\u{3C1}\u{3B5}\u{3BC}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "breadcrumbs.more": `\u{3A0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
    "button.pending": `\u{3C3}\u{3B5} \u{3B5}\u{3BA}\u{3BA}\u{3C1}\u{3B5}\u{3BC}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{397} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7}`,
            other: `\u{39F}\u{3B9} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B5}\u{3C2} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B5}\u{3C2} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2}`
        })}.`,
    "combobox.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "combobox.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "combobox.noResults": `\u{39A}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1} \u{3B1}\u{3C0}\u{3BF}\u{3C4}\u{3AD}\u{3BB}\u{3B5}\u{3C3}\u{3BC}\u{3B1}`,
    "contextualhelp.help": `\u{392}\u{3BF}\u{3AE}\u{3B8}\u{3B5}\u{3B9}\u{3B1}`,
    "contextualhelp.info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "datepicker.endTime": `\u{3A7}\u{3C1}\u{3CC}\u{3BD}\u{3BF}\u{3C2} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}`,
    "datepicker.startTime": `\u{38F}\u{3C1}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2}`,
    "datepicker.time": `\u{3A7}\u{3C1}\u{3CC}\u{3BD}\u{3BF}\u{3C2}`,
    "dialog.alert": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "dialog.dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`,
    "dropzone.replaceMessage": `\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3B1}\u{3C1}\u{3C7}\u{3B5}\u{3AF}\u{3BF}\u{3C5} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B1}\u{3C4}\u{3AC}\u{3C3}\u{3C4}\u{3B1}\u{3C3}\u{3B7}`,
    "inlinealert.informative": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "inlinealert.negative": `\u{3A3}\u{3C6}\u{3AC}\u{3BB}\u{3BC}\u{3B1}`,
    "inlinealert.notice": `\u{3A0}\u{3C1}\u{3BF}\u{3B5}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "inlinealert.positive": `\u{395}\u{3C0}\u{3B9}\u{3C4}\u{3C5}\u{3C7}\u{3AF}\u{3B1}`,
    "label.(optional)": `(\u{3C0}\u{3C1}\u{3BF}\u{3B1}\u{3B9}\u{3C1}\u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3CC})`,
    "label.(required)": `(\u{3B1}\u{3C0}\u{3B1}\u{3B9}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B1}\u{3B9})`,
    "listview.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "listview.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "menu.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "menu.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "menu.moreActions": `\u{3A0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B5}\u{3C2} \u{3B5}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "menu.noResults": `\u{39A}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1} \u{3B1}\u{3C0}\u{3BF}\u{3C4}\u{3AD}\u{3BB}\u{3B5}\u{3C3}\u{3BC}\u{3B1}`,
    "menu.unavailable": `\u{39C}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3BF}, \u{3B1}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7} \u{3B3}\u{3B9}\u{3B1} \u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3BF}\u{3BC}\u{3AD}\u{3C1}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "notificationbadge.indicatorOnly": `\u{39D}\u{3AD}\u{3B1} \u{3B4}\u{3C1}\u{3B1}\u{3C3}\u{3C4}\u{3B7}\u{3C1}\u{3B9}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "picker.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "picker.placeholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
            one: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}`,
    "sidepanel.collapse": `\u{3A3}\u{3CD}\u{3BC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7} \u{3C0}\u{3BB}\u{3B5}\u{3C5}\u{3C1}\u{3B9}\u{3BA}\u{3BF}\u{3CD} \u{3C0}\u{3BB}\u{3B1}\u{3B9}\u{3C3}\u{3AF}\u{3BF}\u{3C5}`,
    "sidepanel.expand": `\u{395}\u{3C0}\u{3AD}\u{3BA}\u{3C4}\u{3B1}\u{3C3}\u{3B7} \u{3C0}\u{3BB}\u{3B5}\u{3C5}\u{3C1}\u{3B9}\u{3BA}\u{3BF}\u{3CD} \u{3C0}\u{3BB}\u{3B1}\u{3B9}\u{3C3}\u{3AF}\u{3BF}\u{3C5}`,
    "slider.maximum": `\u{39C}\u{3AD}\u{3B3}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "slider.minimum": `\u{395}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "table.cancel": `\u{391}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7}`,
    "table.drag": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}`,
    "table.editCell": `\u{395}\u{3C0}\u{3B5}\u{3BE}\u{3B5}\u{3C1}\u{3B3}\u{3B1}\u{3C3}\u{3AF}\u{3B1} \u{3BA}\u{3B5}\u{3BB}\u{3B9}\u{3BF}\u{3CD}`,
    "table.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "table.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "table.resizeColumn": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7}\u{3C2}`,
    "table.save": `\u{391}\u{3C0}\u{3BF}\u{3B8}\u{3AE}\u{3BA}\u{3B5}\u{3C5}\u{3C3}\u{3B7}`,
    "table.sortAscending": `\u{3A4}\u{3B1}\u{3BE}\u{3B9}\u{3BD}\u{3CC}\u{3BC}\u{3B7}\u{3C3}\u{3B7} \u{3BA}\u{3B1}\u{3C4}\u{3AC} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "table.sortDescending": `\u{3A4}\u{3B1}\u{3BE}\u{3B9}\u{3BD}\u{3CC}\u{3BC}\u{3B7}\u{3C3}\u{3B7} \u{3BA}\u{3B1}\u{3C4}\u{3AC} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "tag.actions": `\u{395}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "tag.hideButtonLabel": `\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3BB}\u{3B9}\u{3B3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}`,
    "tag.noTags": `\u{39A}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3CC}\u{3BB}\u{3C9}\u{3BD} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{395}\u{3BA}\u{3BA}\u{3B1}\u{3B8}\u{3AC}\u{3C1}\u{3B9}\u{3C3}\u{3B7} \u{3CC}\u{3BB}\u{3C9}\u{3BD}`,
    "toast.collapse": `\u{3A3}\u{3CD}\u{3BC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "toast.showAll": `\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3CC}\u{3BB}\u{3C9}\u{3BD}`,
    "treeview.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`
};

});

parcelRegister("4HqLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $733b6371447201f2$export$2e2bcd8739ae039);
var $733b6371447201f2$export$2e2bcd8739ae039 = {};
$733b6371447201f2$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Actions`,
    "actionbar.actionsAvailable": `Actions available.`,
    "actionbar.clearSelection": `Clear selection`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `None selected`,
            other: ()=>`${formatter.number(args.count)} selected`
        })}`,
    "actionbar.selectedAll": `All selected`,
    "actionbutton.pending": `pending`,
    "breadcrumbs.more": `More items`,
    "button.pending": `pending`,
    "calendar.invalidSelection": (args, formatter)=>`Selected ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} unavailable.`,
    "combobox.loading": `Loading\u{2026}`,
    "combobox.loadingMore": `Loading more\u{2026}`,
    "combobox.noResults": `No results`,
    "contextualhelp.help": `Help`,
    "contextualhelp.info": `Information`,
    "datepicker.endTime": `End time`,
    "datepicker.startTime": `Start time`,
    "datepicker.time": `Time`,
    "dialog.alert": `Alert`,
    "dialog.dismiss": `Dismiss`,
    "dropzone.replaceMessage": `Drop file to replace`,
    "inlinealert.informative": `Information`,
    "inlinealert.negative": `Error`,
    "inlinealert.notice": `Warning`,
    "inlinealert.positive": `Success`,
    "label.(optional)": `(optional)`,
    "label.(required)": `(required)`,
    "listview.loading": `Loading\u{2026}`,
    "listview.loadingMore": `Loading more\u{2026}`,
    "menu.loading": `Loading\u{2026}`,
    "menu.loadingMore": `Loading more\u{2026}`,
    "menu.moreActions": `More actions`,
    "menu.noResults": `No results`,
    "menu.unavailable": `Unavailable, expand for details`,
    "notificationbadge.indicatorOnly": `New activity`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Loading\u{2026}`,
    "picker.loadingMore": `Loading more\u{2026}`,
    "picker.placeholder": `Select\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}`,
    "sidepanel.collapse": `Collapse side panel`,
    "sidepanel.expand": `Expand side panel`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Cancel`,
    "table.drag": `Drag`,
    "table.editCell": `Edit cell`,
    "table.loading": `Loading\u{2026}`,
    "table.loadingMore": `Loading more\u{2026}`,
    "table.resizeColumn": `Resize column`,
    "table.save": `Save`,
    "table.sortAscending": `Sort Ascending`,
    "table.sortDescending": `Sort Descending`,
    "tag.actions": `Actions`,
    "tag.hideButtonLabel": `Show less`,
    "tag.noTags": `None`,
    "tag.showAllButtonLabel": (args, formatter)=>`Show all (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Clear all`,
    "toast.collapse": `Collapse`,
    "toast.showAll": `Show all`,
    "treeview.loadingMore": `Loading more\u{2026}`
};

});

parcelRegister("9SkqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb5fac92d5108c05$export$2e2bcd8739ae039);
var $cb5fac92d5108c05$export$2e2bcd8739ae039 = {};
$cb5fac92d5108c05$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Acciones`,
    "actionbar.actionsAvailable": `Acciones disponibles.`,
    "actionbar.clearSelection": `Borrar selecci\xf3n`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nada seleccionado`,
            one: ()=>`${formatter.number(args.count)} seleccionado`,
            other: ()=>`${formatter.number(args.count)} seleccionados`
        })}`,
    "actionbar.selectedAll": `Todos seleccionados`,
    "actionbutton.pending": `pendiente`,
    "breadcrumbs.more": `M\xe1s elementos`,
    "button.pending": `pendiente`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La fecha seleccionada no est\xe1 disponible`,
            other: `Las fechas seleccionadas no est\xe1n disponibles`
        })}.`,
    "combobox.loading": `Cargando\u{2026}`,
    "combobox.loadingMore": `Cargando m\xe1s\u{2026}`,
    "combobox.noResults": `Sin resultados`,
    "contextualhelp.help": `Ayuda`,
    "contextualhelp.info": `Informaci\xf3n`,
    "datepicker.endTime": `Hora de finalizaci\xf3n`,
    "datepicker.startTime": `Hora de inicio`,
    "datepicker.time": `Hora`,
    "dialog.alert": `Alerta`,
    "dialog.dismiss": `Descartar`,
    "dropzone.replaceMessage": `Suelte el archivo para reemplazar`,
    "inlinealert.informative": `Informaci\xf3n`,
    "inlinealert.negative": `Error`,
    "inlinealert.notice": `Advertencia`,
    "inlinealert.positive": `\xc9xito`,
    "label.(optional)": `(opcional)`,
    "label.(required)": `(obligatorio)`,
    "listview.loading": `Cargando\u{2026}`,
    "listview.loadingMore": `Cargando m\xe1s\u{2026}`,
    "menu.loading": `Cargando\u{2026}`,
    "menu.loadingMore": `Cargando m\xe1s\u{2026}`,
    "menu.moreActions": `M\xe1s acciones`,
    "menu.noResults": `Sin resultados`,
    "menu.unavailable": `No disponible, ampliar para m\xe1s detalles`,
    "notificationbadge.indicatorOnly": `Nueva actividad`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Cargando\u{2026}`,
    "picker.loadingMore": `Cargando m\xe1s\u{2026}`,
    "picker.placeholder": `Seleccionar\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ning\xfan elemento seleccionado`,
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}`,
    "sidepanel.collapse": `Contraer el panel lateral`,
    "sidepanel.expand": `Expandir el panel lateral`,
    "slider.maximum": `M\xe1ximo`,
    "slider.minimum": `M\xednimo`,
    "table.cancel": `Cancelar`,
    "table.drag": `Arrastrar`,
    "table.editCell": `Editar celda`,
    "table.loading": `Cargando\u{2026}`,
    "table.loadingMore": `Cargando m\xe1s\u{2026}`,
    "table.resizeColumn": `Cambiar el tama\xf1o de la columna`,
    "table.save": `Guardar`,
    "table.sortAscending": `Orden ascendente`,
    "table.sortDescending": `Orden descendente`,
    "tag.actions": `Acciones`,
    "tag.hideButtonLabel": `Mostrar menos`,
    "tag.noTags": `Ninguno`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostrar todo (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Borrar todo`,
    "toast.collapse": `Contraer`,
    "toast.showAll": `Mostrar todo`,
    "treeview.loadingMore": `Cargando m\xe1s\u{2026}`
};

});

parcelRegister("hfQck", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d852494d77c749$export$2e2bcd8739ae039);
var $95d852494d77c749$export$2e2bcd8739ae039 = {};
$95d852494d77c749$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Toimingud`,
    "actionbar.actionsAvailable": `Toimingud saadaval.`,
    "actionbar.clearSelection": `Puhasta valik`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Pole valitud`,
            other: ()=>`${formatter.number(args.count)} valitud`
        })}`,
    "actionbar.selectedAll": `K\xf5ik valitud`,
    "actionbutton.pending": `ootel`,
    "breadcrumbs.more": `Veel \xfcksusi`,
    "button.pending": `ootel`,
    "calendar.invalidSelection": (args, formatter)=>`Valitud ${formatter.plural(args.selectedCount, {
            one: `kuup\xe4ev`,
            other: `kuup\xe4evad`
        })} pole saadaval.`,
    "combobox.loading": `Laadimine...`,
    "combobox.loadingMore": `Laadi rohkem...`,
    "combobox.noResults": `Tulemusi pole`,
    "contextualhelp.help": `Spikker`,
    "contextualhelp.info": `Teave`,
    "datepicker.endTime": `L\xf5puaeg`,
    "datepicker.startTime": `Algusaeg`,
    "datepicker.time": `Aeg`,
    "dialog.alert": `Teade`,
    "dialog.dismiss": `L\xf5peta`,
    "dropzone.replaceMessage": `Kukuta fail asendamiseks`,
    "inlinealert.informative": `Teave`,
    "inlinealert.negative": `Viga`,
    "inlinealert.notice": `Hoiatus`,
    "inlinealert.positive": `Valmis`,
    "label.(optional)": `(valikuline)`,
    "label.(required)": `(n\xf5utav)`,
    "listview.loading": `Laadimine...`,
    "listview.loadingMore": `Laadi rohkem...`,
    "menu.loading": `Laadimine...`,
    "menu.loadingMore": `Laadi rohkem...`,
    "menu.moreActions": `Veel toiminguid`,
    "menu.noResults": `Tulemusi pole`,
    "menu.unavailable": `Pole k\xe4ttesaadav, \xfcksikasjade vaatamiseks laiendage`,
    "notificationbadge.indicatorOnly": `Uus tegevus`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Laadimine...`,
    "picker.loadingMore": `Laadi rohkem...`,
    "picker.placeholder": `Valige\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\xfcksuseid pole valitud`,
            one: ()=>`${formatter.number(args.count)} \xfcksus valitud`,
            other: ()=>`${formatter.number(args.count)} \xfcksust valitud`
        })}`,
    "sidepanel.collapse": `Ahenda k\xfclgpaneel`,
    "sidepanel.expand": `Laienda k\xfclgpaneel`,
    "slider.maximum": `Maksimaalne`,
    "slider.minimum": `Minimaalne`,
    "table.cancel": `T\xfchista`,
    "table.drag": `Lohista`,
    "table.editCell": `Muuda lahtrit`,
    "table.loading": `Laadimine...`,
    "table.loadingMore": `Laadi rohkem...`,
    "table.resizeColumn": `Muuda veeru suurust`,
    "table.save": `Salvesta`,
    "table.sortAscending": `Sordi kasvavalt`,
    "table.sortDescending": `Sordi kahanevalt`,
    "tag.actions": `Toimingud`,
    "tag.hideButtonLabel": `Kuva v\xe4hem`,
    "tag.noTags": `Puudub`,
    "tag.showAllButtonLabel": (args, formatter)=>`Kuva k\xf5ik (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `T\xfchjenda k\xf5ik`,
    "toast.collapse": `Ahenda`,
    "toast.showAll": `Kuva k\xf5ik`,
    "treeview.loadingMore": `Laadi rohkem...`
};

});

parcelRegister("iqc6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $519e61ee6e3120dd$export$2e2bcd8739ae039);
var $519e61ee6e3120dd$export$2e2bcd8739ae039 = {};
$519e61ee6e3120dd$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Toiminnot`,
    "actionbar.actionsAvailable": `Toiminnot k\xe4ytett\xe4viss\xe4.`,
    "actionbar.clearSelection": `Poista valinta`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei mit\xe4\xe4n valittu`,
            other: ()=>`${formatter.number(args.count)} valittu`
        })}`,
    "actionbar.selectedAll": `Kaikki valittu`,
    "actionbutton.pending": `odottaa`,
    "breadcrumbs.more": `Lis\xe4\xe4 kohteita`,
    "button.pending": `odottaa`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole`,
            other: `Valitut p\xe4iv\xe4m\xe4\xe4r\xe4t eiv\xe4t ole`
        })} saatavilla.`,
    "combobox.loading": `Ladataan\u{2026}`,
    "combobox.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "combobox.noResults": `Ei tuloksia`,
    "contextualhelp.help": `Ohje`,
    "contextualhelp.info": `Tiedot`,
    "datepicker.endTime": `P\xe4\xe4ttymisaika`,
    "datepicker.startTime": `Alkamisaika`,
    "datepicker.time": `Aika`,
    "dialog.alert": `H\xe4lytys`,
    "dialog.dismiss": `Hylk\xe4\xe4`,
    "dropzone.replaceMessage": `Pudota korvaava tiedosto`,
    "inlinealert.informative": `Tiedot`,
    "inlinealert.negative": `Virhe`,
    "inlinealert.notice": `Varoitus`,
    "inlinealert.positive": `Onnistui`,
    "label.(optional)": `(valinnainen)`,
    "label.(required)": `(pakollinen)`,
    "listview.loading": `Ladataan\u{2026}`,
    "listview.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "menu.loading": `Ladataan\u{2026}`,
    "menu.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "menu.moreActions": `Lis\xe4\xe4 toimintoja`,
    "menu.noResults": `Ei tuloksia`,
    "menu.unavailable": `Ei saatavilla, laajenna saadaksesi lis\xe4tietoja`,
    "notificationbadge.indicatorOnly": `Uusi toiminta`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Ladataan\u{2026}`,
    "picker.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "picker.placeholder": `Valitse\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Kohteita ei ole valittu`,
            one: ()=>`${formatter.number(args.count)} kohde valittu`,
            other: ()=>`${formatter.number(args.count)} kohdetta valittu`
        })}`,
    "sidepanel.collapse": `Kutista sivupaneeli`,
    "sidepanel.expand": `Laajenna sivupaneelia`,
    "slider.maximum": `Maksimi`,
    "slider.minimum": `Minimi`,
    "table.cancel": `Peruuta`,
    "table.drag": `Ved\xe4`,
    "table.editCell": `Muokkaa solua`,
    "table.loading": `Ladataan\u{2026}`,
    "table.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "table.resizeColumn": `Muuta sarakkeen kokoa`,
    "table.save": `Tallenna`,
    "table.sortAscending": `Lajitteluj\xe4rjestys: nouseva`,
    "table.sortDescending": `Lajitteluj\xe4rjestys: laskeva`,
    "tag.actions": `Toiminnot`,
    "tag.hideButtonLabel": `N\xe4yt\xe4 v\xe4hemm\xe4n`,
    "tag.noTags": `Ei mit\xe4\xe4n`,
    "tag.showAllButtonLabel": (args, formatter)=>`N\xe4yt\xe4 kaikki (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Tyhjenn\xe4 kaikki`,
    "toast.collapse": `Pienenn\xe4`,
    "toast.showAll": `N\xe4yt\xe4 kaikki`,
    "treeview.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};

});

parcelRegister("2uGrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $185b6f7be4dae018$export$2e2bcd8739ae039);
var $185b6f7be4dae018$export$2e2bcd8739ae039 = {};
$185b6f7be4dae018$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Actions`,
    "actionbar.actionsAvailable": `Actions disponibles.`,
    "actionbar.clearSelection": `Supprimer la s\xe9lection`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} s\xe9lectionn\xe9s`
        })}`,
    "actionbar.selectedAll": `Toute la s\xe9lection`,
    "actionbutton.pending": `En attente`,
    "breadcrumbs.more": `Plus d\u{2019}\xe9l\xe9ments`,
    "button.pending": `En attente`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La date s\xe9lectionn\xe9e est indisponible`,
            other: `Les dates s\xe9lectionn\xe9es sont indisponibles`
        })}.`,
    "combobox.loading": `Chargement...`,
    "combobox.loadingMore": `Chargement suppl\xe9mentaire...`,
    "combobox.noResults": `Aucun r\xe9sultat`,
    "contextualhelp.help": `Aide`,
    "contextualhelp.info": `Informations`,
    "datepicker.endTime": `Heure de fin`,
    "datepicker.startTime": `Heure de d\xe9but`,
    "datepicker.time": `Heure`,
    "dialog.alert": `Alerte`,
    "dialog.dismiss": `Rejeter`,
    "dropzone.replaceMessage": `D\xe9poser le fichier \xe0 remplacer`,
    "inlinealert.informative": `Informations`,
    "inlinealert.negative": `Erreur`,
    "inlinealert.notice": `Avertissement`,
    "inlinealert.positive": `Succ\xe8s`,
    "label.(optional)": `(facultatif)`,
    "label.(required)": `(requis)`,
    "listview.loading": `Chargement...`,
    "listview.loadingMore": `Chargement suppl\xe9mentaire...`,
    "menu.loading": `Chargement...`,
    "menu.loadingMore": `Chargement suppl\xe9mentaire...`,
    "menu.moreActions": `Autres actions`,
    "menu.noResults": `Aucun r\xe9sultat`,
    "menu.unavailable": `Indisponible, d\xe9velopper pour plus de d\xe9tails`,
    "notificationbadge.indicatorOnly": `Nouvelle activit\xe9`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Chargement...`,
    "picker.loadingMore": `Chargement suppl\xe9mentaire...`,
    "picker.placeholder": `S\xe9lectionner\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}`,
    "sidepanel.collapse": `R\xe9duire le panneau lat\xe9ral`,
    "sidepanel.expand": `D\xe9velopper le panneau lat\xe9ral`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Annuler`,
    "table.drag": `Faire glisser`,
    "table.editCell": `Modifier la cellule`,
    "table.loading": `Chargement...`,
    "table.loadingMore": `Chargement suppl\xe9mentaire...`,
    "table.resizeColumn": `Redimensionner la colonne`,
    "table.save": `Enregistrer`,
    "table.sortAscending": `Trier par ordre croissant`,
    "table.sortDescending": `Trier par ordre d\xe9croissant`,
    "tag.actions": `Actions`,
    "tag.hideButtonLabel": `Afficher moins`,
    "tag.noTags": `Aucun`,
    "tag.showAllButtonLabel": (args, formatter)=>`Tout afficher (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Tout effacer`,
    "toast.collapse": `R\xe9duire`,
    "toast.showAll": `Tout afficher`,
    "treeview.loadingMore": `Chargement suppl\xe9mentaire...`
};

});

parcelRegister("3e6Rm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0112cb612b465dc$export$2e2bcd8739ae039);
var $f0112cb612b465dc$export$2e2bcd8739ae039 = {};
$f0112cb612b465dc$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA}`,
    "actionbar.actionsAvailable": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5D6}\u{5DE}\u{5D9}\u{5E0}\u{5D5}\u{5EA}.`,
    "actionbar.clearSelection": `\u{5E0}\u{5E7}\u{5D4} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5D1}\u{5D5}\u{5E6}\u{5E2}\u{5D4} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}`,
            one: ()=>` ${formatter.number(args.count)} \u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}",`,
    "actionbar.selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`,
    "actionbutton.pending": `\u{5DE}\u{5DE}\u{5EA}\u{5D9}\u{5DF} \u{5DC}`,
    "breadcrumbs.more": `\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D5}\u{5E1}\u{5E4}\u{5D9}\u{5DD}`,
    "button.pending": `\u{5DE}\u{5DE}\u{5EA}\u{5D9}\u{5DF} \u{5DC}`,
    "calendar.invalidSelection": (args, formatter)=>`\u{5E0}\u{5D1}\u{5D7}\u{5E8} ${formatter.plural(args.selectedCount, {
            one: `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA}`,
            other: `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DB}\u{5D9}\u{5DD}`
        })} \u{5D0}\u{5D9}\u{5E0}\u{5D5} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`,
    "combobox.loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "combobox.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "combobox.noResults": `\u{5D0}\u{5D9}\u{5DF} \u{5EA}\u{5D5}\u{5E6}\u{5D0}\u{5D5}\u{5EA}`,
    "contextualhelp.help": `\u{5E2}\u{5D6}\u{5E8}\u{5D4}`,
    "contextualhelp.info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "datepicker.endTime": `\u{5E9}\u{5E2}\u{5EA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "datepicker.startTime": `\u{5E9}\u{5E2}\u{5EA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "datepicker.time": `\u{5D6}\u{5DE}\u{5DF}`,
    "dialog.alert": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
    "dialog.dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`,
    "dropzone.replaceMessage": `\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5D0}\u{5EA} \u{5D4}\u{5E7}\u{5D5}\u{5D1}\u{5E5} \u{5DC}\u{5D4}\u{5D7}\u{5DC}\u{5E4}\u{5D4}`,
    "inlinealert.informative": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "inlinealert.negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "inlinealert.notice": `\u{5D0}\u{5D6}\u{5D4}\u{5E8}\u{5D4}`,
    "inlinealert.positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`,
    "label.(optional)": `(\u{5D0}\u{5D5}\u{5E4}\u{5E6}\u{5D9}\u{5D5}\u{5E0}\u{5DC}\u{5D9})`,
    "label.(required)": `(\u{5E0}\u{5D3}\u{5E8}\u{5E9})`,
    "listview.loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "listview.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "menu.loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "menu.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "menu.moreActions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5E0}\u{5D5}\u{5E1}\u{5E4}\u{5D5}\u{5EA}`,
    "menu.noResults": `\u{5D0}\u{5D9}\u{5DF} \u{5EA}\u{5D5}\u{5E6}\u{5D0}\u{5D5}\u{5EA}`,
    "menu.unavailable": `\u{5DC}\u{5D0} \u{5D6}\u{5DE}\u{5D9}\u{5DF}, \u{5D4}\u{5E8}\u{5D7}\u{5D1} \u{5DC}\u{5E4}\u{5E8}\u{5D8}\u{5D9}\u{5DD}`,
    "notificationbadge.indicatorOnly": `\u{5E4}\u{5E2}\u{5D9}\u{5DC}\u{5D5}\u{5EA} \u{5D7}\u{5D3}\u{5E9}\u{5D4}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "picker.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "picker.placeholder": `\u{5D1}\u{5D7}\u{5E8}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD}`,
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} ${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}`,
    "sidepanel.collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5} \u{5D0}\u{5EA} \u{5D4}\u{5DC}\u{5D5}\u{5D7} \u{5D4}\u{5E6}\u{5D3}\u{5D3}\u{5D9}`,
    "sidepanel.expand": `\u{5D4}\u{5E8}\u{5D7}\u{5D1} \u{5D0}\u{5EA} \u{5D4}\u{5DC}\u{5D5}\u{5D7} \u{5D4}\u{5E6}\u{5D3}\u{5D3}\u{5D9}`,
    "slider.maximum": `\u{5DE}\u{5E7}\u{5E1}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "slider.minimum": `\u{5DE}\u{5D9}\u{5E0}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "table.cancel": `\u{5D1}\u{5D9}\u{5D8}\u{5D5}\u{5DC}`,
    "table.drag": `\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}`,
    "table.editCell": `\u{5E2}\u{5E8}\u{5D9}\u{5DB}\u{5EA} \u{5EA}\u{5D0}`,
    "table.loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "table.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "table.resizeColumn": `\u{5E9}\u{5E0}\u{5D4} \u{5D0}\u{5EA} \u{5D2}\u{5D5}\u{5D3}\u{5DC} \u{5D4}\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4}`,
    "table.save": `\u{5E9}\u{5DE}\u{5D9}\u{5E8}\u{5D4}`,
    "table.sortAscending": `\u{5DE}\u{5D9}\u{5D9}\u{5DF} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "table.sortDescending": `\u{5DE}\u{5D9}\u{5D9}\u{5DF} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "tag.actions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA}`,
    "tag.hideButtonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5E4}\u{5D7}\u{5D5}\u{5EA}`,
    "tag.noTags": `\u{5DC}\u{5DC}\u{5D0}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5DB}\u{5DC} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{5E0}\u{5E7}\u{5D4} \u{5D4}\u{5DB}\u{5D5}\u{5DC}`,
    "toast.collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5}`,
    "toast.showAll": `\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5DB}\u{5D5}\u{5DC}`,
    "treeview.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};

});

parcelRegister("a7HKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce160b52dfd11c0b$export$2e2bcd8739ae039);
var $ce160b52dfd11c0b$export$2e2bcd8739ae039 = {};
$ce160b52dfd11c0b$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Radnje`,
    "actionbar.actionsAvailable": `Dostupne radnje.`,
    "actionbar.clearSelection": `Poni\u{161}ti odabir`,
    "actionbar.selected": (args)=>`Odabrano: ${args.count}`,
    "actionbar.selectedAll": `Sve odabrano`,
    "actionbutton.pending": `u tijeku`,
    "breadcrumbs.more": `Vi\u{161}e stavki`,
    "button.pending": `u tijeku`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Odabrani datum nije dostupan`,
            other: `Odabrani datumi nisu dostupni`
        })}.`,
    "combobox.loading": `U\u{10D}itavam...`,
    "combobox.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "combobox.noResults": `Nema rezultata`,
    "contextualhelp.help": `Pomo\u{107}`,
    "contextualhelp.info": `Informacije`,
    "datepicker.endTime": `Vrijeme zavr\u{161}etka`,
    "datepicker.startTime": `Vrijeme po\u{10D}etka`,
    "datepicker.time": `Vrijeme`,
    "dialog.alert": `Upozorenje`,
    "dialog.dismiss": `Odbaci`,
    "dropzone.replaceMessage": `Ispustite datoteku za zamjenu`,
    "inlinealert.informative": `Informacije`,
    "inlinealert.negative": `Pogre\u{161}ka`,
    "inlinealert.notice": `Upozorenje`,
    "inlinealert.positive": `Uspje\u{161}no`,
    "label.(optional)": `(opcionalno)`,
    "label.(required)": `(obvezno)`,
    "listview.loading": `U\u{10D}itavam...`,
    "listview.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "menu.loading": `U\u{10D}itavam...`,
    "menu.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "menu.moreActions": `Dodatne radnje`,
    "menu.noResults": `Nema rezultata`,
    "menu.unavailable": `Nije dostupno, pro\u{161}iri za detalje`,
    "notificationbadge.indicatorOnly": `Nova aktivnost`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `U\u{10D}itavam...`,
    "picker.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "picker.placeholder": `Odaberite\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije odabrana nijedna stavka`,
            one: ()=>`Odabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Odabrano je ${formatter.number(args.count)} stavki`
        })}`,
    "sidepanel.collapse": `Sklapanje bo\u{10D}nog panela`,
    "sidepanel.expand": `Pro\u{161}irenje bo\u{10D}ne plo\u{10D}e`,
    "slider.maximum": `Najvi\u{161}e`,
    "slider.minimum": `Najmanje`,
    "table.cancel": `Poni\u{161}ti`,
    "table.drag": `Povucite`,
    "table.editCell": `Uredi \u{107}eliju`,
    "table.loading": `U\u{10D}itavam...`,
    "table.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "table.resizeColumn": `Promijeni veli\u{10D}inu stupca`,
    "table.save": `Spremi`,
    "table.sortAscending": `Sortiraj uzlazno`,
    "table.sortDescending": `Sortiraj silazno`,
    "tag.actions": `Radnje`,
    "tag.hideButtonLabel": `Prika\u{17E}i manje`,
    "tag.noTags": `Nema`,
    "tag.showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Poni\u{161}ti sve`,
    "toast.collapse": `Sa\u{17E}mi`,
    "toast.showAll": `Prika\u{17E}i sve`,
    "treeview.loadingMore": `U\u{10D}itavam jo\u{161}...`
};

});

parcelRegister("cGoWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a75860e99990c8c$export$2e2bcd8739ae039);
var $9a75860e99990c8c$export$2e2bcd8739ae039 = {};
$9a75860e99990c8c$export$2e2bcd8739ae039 = {
    "actionbar.actions": `M\u{171}veletek`,
    "actionbar.actionsAvailable": `M\u{171}veletek \xe1llnak rendelkez\xe9sre.`,
    "actionbar.clearSelection": `Kijel\xf6l\xe9s t\xf6rl\xe9se`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy sincs kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lve`
        })}`,
    "actionbar.selectedAll": `Mind kijel\xf6lve`,
    "actionbutton.pending": `f\xfcgg\u{151}ben lev\u{151}`,
    "breadcrumbs.more": `Tov\xe1bbi elemek`,
    "button.pending": `f\xfcgg\u{151}ben lev\u{151}`,
    "calendar.invalidSelection": (args, formatter)=>`A kijel\xf6lt ${formatter.plural(args.selectedCount, {
            one: `d\xe1tum nem \xe9rhet\u{151} el`,
            other: `d\xe1tumok nem \xe9rhet\u{151}ek el`
        })}.`,
    "combobox.loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "combobox.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "combobox.noResults": `Nincsenek tal\xe1latok`,
    "contextualhelp.help": `S\xfag\xf3`,
    "contextualhelp.info": `Inform\xe1ci\xf3`,
    "datepicker.endTime": `Befejez\xe9s ideje`,
    "datepicker.startTime": `Kezd\xe9s ideje`,
    "datepicker.time": `Id\u{151}`,
    "dialog.alert": `Figyelmeztet\xe9s`,
    "dialog.dismiss": `Elutas\xedt\xe1s`,
    "dropzone.replaceMessage": `Ejtse le a f\xe1jlt a cser\xe9hez`,
    "inlinealert.informative": `Inform\xe1ci\xf3`,
    "inlinealert.negative": `Hiba`,
    "inlinealert.notice": `Figyelmeztet\xe9s`,
    "inlinealert.positive": `Siker`,
    "label.(optional)": `(opcion\xe1lis)`,
    "label.(required)": `(k\xf6telez\u{151})`,
    "listview.loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "listview.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "menu.loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "menu.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "menu.moreActions": `Tov\xe1bbi lehet\u{151}s\xe9gek`,
    "menu.noResults": `Nincsenek tal\xe1latok`,
    "menu.unavailable": `Nem \xe9rhet\u{151} el, a r\xe9szletek\xe9rt bontsa ki`,
    "notificationbadge.indicatorOnly": `\xdaj tev\xe9kenys\xe9g`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "picker.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "picker.placeholder": `Kiv\xe1laszt\xe1s\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nincs kijel\xf6lve elem`,
            one: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`
        })}`,
    "sidepanel.collapse": `Oldalpanel \xf6sszecsuk\xe1sa`,
    "sidepanel.expand": `Oldalpanel kibont\xe1sa`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `M\xe9gse`,
    "table.drag": `H\xfaz\xe1s`,
    "table.editCell": `Cella szerkeszt\xe9se`,
    "table.loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "table.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "table.resizeColumn": `Oszlop \xe1tm\xe9retez\xe9se`,
    "table.save": `Ment\xe9s`,
    "table.sortAscending": `N\xf6vekv\u{151} rendez\xe9s`,
    "table.sortDescending": `Cs\xf6kken\u{151} rendez\xe9s`,
    "tag.actions": `M\u{171}veletek`,
    "tag.hideButtonLabel": `Mutass kevesebbet`,
    "tag.noTags": `Egyik sem`,
    "tag.showAllButtonLabel": (args, formatter)=>`Az \xf6sszes megjelen\xedt\xe9se (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\xd6sszes t\xf6rl\xe9se`,
    "toast.collapse": `\xd6sszecsuk\xe1s`,
    "toast.showAll": `\xd6sszes megjelen\xedt\xe9se`,
    "treeview.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};

});

parcelRegister("5X7Si", function(module, exports) {

$parcel$export(module.exports, "default", () => $624801b9770dcfb6$export$2e2bcd8739ae039);
var $624801b9770dcfb6$export$2e2bcd8739ae039 = {};
$624801b9770dcfb6$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Azioni`,
    "actionbar.actionsAvailable": `Azioni disponibili.`,
    "actionbar.clearSelection": `Annulla selezione`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessuno selezionato`,
            one: ()=>`${formatter.number(args.count)} selezionato`,
            other: ()=>`${formatter.number(args.count)} selezionati`
        })}`,
    "actionbar.selectedAll": `Tutti selezionati`,
    "actionbutton.pending": `in sospeso`,
    "breadcrumbs.more": `Altri elementi`,
    "button.pending": `in sospeso`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selezionata non disponibile`,
            other: `Date selezionate non disponibili`
        })}.`,
    "combobox.loading": `Caricamento...`,
    "combobox.loadingMore": `Caricamento altri...`,
    "combobox.noResults": `Nessun risultato`,
    "contextualhelp.help": `Aiuto`,
    "contextualhelp.info": `Informazioni`,
    "datepicker.endTime": `Ora di fine`,
    "datepicker.startTime": `Ora di inizio`,
    "datepicker.time": `Ora`,
    "dialog.alert": `Avviso`,
    "dialog.dismiss": `Ignora`,
    "dropzone.replaceMessage": `Rilascia il file da sostituire`,
    "inlinealert.informative": `Informazioni`,
    "inlinealert.negative": `Errore`,
    "inlinealert.notice": `Avvertenza`,
    "inlinealert.positive": `Operazione riuscita`,
    "label.(optional)": `(facoltativo)`,
    "label.(required)": `(obbligatorio)`,
    "listview.loading": `Caricamento...`,
    "listview.loadingMore": `Caricamento altri...`,
    "menu.loading": `Caricamento...`,
    "menu.loadingMore": `Caricamento altri...`,
    "menu.moreActions": `Altre azioni`,
    "menu.noResults": `Nessun risultato`,
    "menu.unavailable": `Non disponibile, espandi per i dettagli`,
    "notificationbadge.indicatorOnly": `Nuova attivit\xe0`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Caricamento...`,
    "picker.loadingMore": `Caricamento altri...`,
    "picker.placeholder": `Seleziona\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessun elemento selezionato`,
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}`,
    "sidepanel.collapse": `Comprimi pannello laterale`,
    "sidepanel.expand": `Espandi pannello laterale`,
    "slider.maximum": `Massimo`,
    "slider.minimum": `Minimo`,
    "table.cancel": `Annulla`,
    "table.drag": `Trascina`,
    "table.editCell": `Modifica cella`,
    "table.loading": `Caricamento...`,
    "table.loadingMore": `Caricamento altri...`,
    "table.resizeColumn": `Ridimensiona colonna`,
    "table.save": `Salva`,
    "table.sortAscending": `Ordinamento crescente`,
    "table.sortDescending": `Ordinamento decrescente`,
    "tag.actions": `Azioni`,
    "tag.hideButtonLabel": `Mostra meno`,
    "tag.noTags": `Nessuno`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostra tutto (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Cancella tutto`,
    "toast.collapse": `Comprimi`,
    "toast.showAll": `Mostra tutto`,
    "treeview.loadingMore": `Caricamento altri...`
};

});

parcelRegister("bv0dB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d471f78cc7c310$export$2e2bcd8739ae039);
var $e7d471f78cc7c310$export$2e2bcd8739ae039 = {};
$e7d471f78cc7c310$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "actionbar.actionsAvailable": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "actionbar.clearSelection": `\u{9078}\u{629E}\u{3092}\u{30AF}\u{30EA}\u{30A2}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}`,
    "actionbar.selectedAll": `\u{3059}\u{3079}\u{3066}\u{3092}\u{9078}\u{629E}`,
    "actionbutton.pending": `\u{4FDD}\u{7559}`,
    "breadcrumbs.more": `\u{305D}\u{306E}\u{4ED6}\u{306E}\u{9805}\u{76EE}`,
    "button.pending": `\u{4FDD}\u{7559}`,
    "calendar.invalidSelection": (args, formatter)=>`\u{9078}\u{629E}\u{3057}\u{305F}${formatter.plural(args.selectedCount, {
            one: `\u{65E5}\u{4ED8}`,
            other: `\u{65E5}\u{4ED8}`
        })}\u{306F}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    "combobox.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "combobox.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "combobox.noResults": `\u{7D50}\u{679C}\u{306A}\u{3057}`,
    "contextualhelp.help": `\u{30D8}\u{30EB}\u{30D7}`,
    "contextualhelp.info": `\u{60C5}\u{5831}`,
    "datepicker.endTime": `\u{7D42}\u{4E86}\u{6642}\u{523B}`,
    "datepicker.startTime": `\u{958B}\u{59CB}\u{6642}\u{523B}`,
    "datepicker.time": `\u{6642}\u{523B}`,
    "dialog.alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dialog.dismiss": `\u{9589}\u{3058}\u{308B}`,
    "dropzone.replaceMessage": `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{7F6E}\u{63DB}`,
    "inlinealert.informative": `\u{60C5}\u{5831}`,
    "inlinealert.negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "inlinealert.notice": `\u{8B66}\u{544A}`,
    "inlinealert.positive": `\u{6210}\u{529F}`,
    "label.(optional)": `\u{FF08}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{FF09}`,
    "label.(required)": `\u{FF08}\u{5FC5}\u{9808}\u{FF09}`,
    "listview.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "listview.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "menu.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "menu.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "menu.moreActions": `\u{305D}\u{306E}\u{4ED6}\u{306E}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "menu.noResults": `\u{7D50}\u{679C}\u{306A}\u{3057}`,
    "menu.unavailable": `\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{8A73}\u{3057}\u{304F}\u{306F}\u{3001}\u{5C55}\u{958B}\u{3057}\u{3066}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    "notificationbadge.indicatorOnly": `\u{65B0}\u{898F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "picker.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "picker.placeholder": `\u{9078}\u{629E}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9805}\u{76EE}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            one: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`,
            other: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}`,
    "sidepanel.collapse": `\u{30B5}\u{30A4}\u{30C9}\u{30D1}\u{30CD}\u{30EB}\u{3092}\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "sidepanel.expand": `\u{30B5}\u{30A4}\u{30C9}\u{30D1}\u{30CD}\u{30EB}\u{3092}\u{5C55}\u{958B}`,
    "slider.maximum": `\u{6700}\u{5927}`,
    "slider.minimum": `\u{6700}\u{5C0F}`,
    "table.cancel": `\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}`,
    "table.drag": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}`,
    "table.editCell": `\u{30BB}\u{30EB}\u{3092}\u{7DE8}\u{96C6}`,
    "table.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "table.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "table.resizeColumn": `\u{5217}\u{5E45}\u{3092}\u{5909}\u{66F4}`,
    "table.save": `\u{4FDD}\u{5B58}`,
    "table.sortAscending": `\u{6607}\u{9806}\u{306B}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "table.sortDescending": `\u{964D}\u{9806}\u{306B}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "tag.actions": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "tag.hideButtonLabel": `\u{8868}\u{793A}\u{3092}\u{6E1B}\u{3089}\u{3059}`,
    "tag.noTags": `\u{306A}\u{3057}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{3059}\u{3079}\u{3066}\u{306E} (${formatter.number(args.tagCount)}) \u{3092}\u{8868}\u{793A}`,
    "toast.clearAll": `\u{3059}\u{3079}\u{3066}\u{30AF}\u{30EA}\u{30A2}`,
    "toast.collapse": `\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "toast.showAll": `\u{3059}\u{3079}\u{3066}\u{3092}\u{8868}\u{793A}`,
    "treeview.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};

});

parcelRegister("jPF8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3cda04b22ce1cb6$export$2e2bcd8739ae039);
var $d3cda04b22ce1cb6$export$2e2bcd8739ae039 = {};
$d3cda04b22ce1cb6$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{C561}\u{C158}`,
    "actionbar.actionsAvailable": `\u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C561}\u{C158}`,
    "actionbar.clearSelection": `\u{C120}\u{D0DD} \u{D56D}\u{BAA9} \u{C9C0}\u{C6B0}\u{AE30}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9} \u{C5C6}\u{C74C}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD}\u{B428}`
        })}`,
    "actionbar.selectedAll": `\u{BAA8}\u{B450} \u{C120}\u{D0DD}\u{B428}`,
    "actionbutton.pending": `\u{BCF4}\u{B958} \u{C911}`,
    "breadcrumbs.more": `\u{AE30}\u{D0C0} \u{D56D}\u{BAA9}`,
    "button.pending": `\u{BCF4}\u{B958} \u{C911}`,
    "calendar.invalidSelection": (args, formatter)=>`\u{C120}\u{D0DD}\u{D55C} ${formatter.plural(args.selectedCount, {
            one: `\u{C77C}\u{C790}\u{B97C}`,
            other: `\u{C77C}\u{C790}\u{B97C}`
        })} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "combobox.loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "combobox.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "combobox.noResults": `\u{ACB0}\u{ACFC} \u{C5C6}\u{C74C}`,
    "contextualhelp.help": `\u{B3C4}\u{C6C0}\u{B9D0}`,
    "contextualhelp.info": `\u{C815}\u{BCF4}`,
    "datepicker.endTime": `\u{C885}\u{B8CC} \u{C2DC}\u{AC04}`,
    "datepicker.startTime": `\u{C2DC}\u{C791} \u{C2DC}\u{AC04}`,
    "datepicker.time": `\u{C2DC}\u{AC04}`,
    "dialog.alert": `\u{ACBD}\u{ACE0}`,
    "dialog.dismiss": `\u{BB34}\u{C2DC}`,
    "dropzone.replaceMessage": `\u{D30C}\u{C77C}\u{C744} \u{B4DC}\u{B86D}\u{D558}\u{C5EC} \u{BC14}\u{AFB8}\u{AE30}`,
    "inlinealert.informative": `\u{C815}\u{BCF4}`,
    "inlinealert.negative": `\u{C624}\u{B958}`,
    "inlinealert.notice": `\u{ACBD}\u{ACE0}`,
    "inlinealert.positive": `\u{C131}\u{ACF5}`,
    "label.(optional)": `(\u{C120}\u{D0DD} \u{C0AC}\u{D56D})`,
    "label.(required)": `(\u{D544}\u{C218} \u{C0AC}\u{D56D})`,
    "listview.loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "listview.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "menu.loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "menu.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "menu.moreActions": `\u{AE30}\u{D0C0} \u{C561}\u{C158}`,
    "menu.noResults": `\u{ACB0}\u{ACFC} \u{C5C6}\u{C74C}`,
    "menu.unavailable": `\u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C74C}, \u{C790}\u{C138}\u{D788} \u{BCF4}\u{B824}\u{BA74} \u{D3BC}\u{CE58}\u{AE30}`,
    "notificationbadge.indicatorOnly": `\u{C0C8}\u{B85C}\u{C6B4} \u{D65C}\u{B3D9}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "picker.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "picker.placeholder": `\u{C120}\u{D0DD}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{D55C} \u{D56D}\u{BAA9} \u{C5C6}\u{C74C}`,
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9} \u{C120}\u{D0DD}\u{B428}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9} \u{C120}\u{D0DD}\u{B428}`
        })}`,
    "sidepanel.collapse": `\u{C0AC}\u{C774}\u{B4DC} \u{D328}\u{B110} \u{CD95}\u{C18C}`,
    "sidepanel.expand": `\u{C0AC}\u{C774}\u{B4DC} \u{D328}\u{B110} \u{D655}\u{C7A5}`,
    "slider.maximum": `\u{CD5C}\u{B300}`,
    "slider.minimum": `\u{CD5C}\u{C18C}`,
    "table.cancel": `\u{CDE8}\u{C18C}`,
    "table.drag": `\u{B4DC}\u{B798}\u{ADF8}`,
    "table.editCell": `\u{C140} \u{D3B8}\u{C9D1}`,
    "table.loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "table.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "table.resizeColumn": `\u{C5F4} \u{D06C}\u{AE30} \u{C870}\u{C815}`,
    "table.save": `\u{C800}\u{C7A5}`,
    "table.sortAscending": `\u{C624}\u{B984}\u{CC28}\u{C21C} \u{C815}\u{B82C}`,
    "table.sortDescending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C} \u{C815}\u{B82C}`,
    "tag.actions": `\u{C561}\u{C158}`,
    "tag.hideButtonLabel": `\u{AC04}\u{B7B5}\u{D788} \u{BCF4}\u{AE30}`,
    "tag.noTags": `\u{C5C6}\u{C74C}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{BAA8}\u{B450} \u{D45C}\u{C2DC} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{BAA8}\u{B450} \u{C9C0}\u{C6B0}\u{AE30}`,
    "toast.collapse": `\u{C811}\u{AE30}`,
    "toast.showAll": `\u{BAA8}\u{B450} \u{D45C}\u{C2DC}`,
    "treeview.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`
};

});

parcelRegister("i8FW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $419b0a236218fac0$export$2e2bcd8739ae039);
var $419b0a236218fac0$export$2e2bcd8739ae039 = {};
$419b0a236218fac0$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Veiksmai`,
    "actionbar.actionsAvailable": `Galimi veiksmai.`,
    "actionbar.clearSelection": `I\u{161}valyti pasirinkim\u{105}`,
    "actionbar.selected": (args)=>`Pasirinkta: ${args.count}`,
    "actionbar.selectedAll": `Pasirinkta viskas`,
    "actionbutton.pending": `laukiama`,
    "breadcrumbs.more": `Daugiau element\u{173}`,
    "button.pending": `laukiama`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Datos`,
            other: `Dat\u{173}`
        })} pasirinkimas negalimas.`,
    "combobox.loading": `\u{12E}keliama...`,
    "combobox.loadingMore": `\u{12E}keliama daugiau...`,
    "combobox.noResults": `Rezultat\u{173} n\u{117}ra`,
    "contextualhelp.help": `\u{17D}inynas`,
    "contextualhelp.info": `Informacija`,
    "datepicker.endTime": `Pabaigos laikas`,
    "datepicker.startTime": `Prad\u{17E}ios laikas`,
    "datepicker.time": `Laikas`,
    "dialog.alert": `\u{12E}sp\u{117}jimas`,
    "dialog.dismiss": `Atmesti`,
    "dropzone.replaceMessage": `Pa\u{161}alinkite fail\u{105}, kad pakeistum\u{117}te`,
    "inlinealert.informative": `Informacija`,
    "inlinealert.negative": `Klaida`,
    "inlinealert.notice": `\u{12E}sp\u{117}jimas`,
    "inlinealert.positive": `S\u{117}kmingai`,
    "label.(optional)": `(pasirenkama)`,
    "label.(required)": `(privaloma)`,
    "listview.loading": `\u{12E}keliama...`,
    "listview.loadingMore": `\u{12E}keliama daugiau...`,
    "menu.loading": `\u{12E}keliama...`,
    "menu.loadingMore": `\u{12E}keliama daugiau...`,
    "menu.moreActions": `Daugiau veiksm\u{173}`,
    "menu.noResults": `Rezultat\u{173} n\u{117}ra`,
    "menu.unavailable": `Nepasiekiama, nor\u{117}dami gauti daugiau informacijos, i\u{161}skleiskite`,
    "notificationbadge.indicatorOnly": `Nauja veikla`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{12E}keliama...`,
    "picker.loadingMore": `\u{12E}keliama daugiau...`,
    "picker.placeholder": `Pasirinkite\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nepasirinktas n\u{117} vienas elementas`,
            one: ()=>`Pasirinktas ${formatter.number(args.count)} elementas`,
            other: ()=>`Pasirinkta element\u{173}: ${formatter.number(args.count)}`
        })}`,
    "sidepanel.collapse": `Sutraukti \u{161}onin\u{119} srit\u{12F}`,
    "sidepanel.expand": `I\u{161}skleisti \u{161}onin\u{119} srit\u{12F}`,
    "slider.maximum": `Daugiausia`,
    "slider.minimum": `Ma\u{17E}iausia`,
    "table.cancel": `At\u{161}aukti`,
    "table.drag": `Vilkti`,
    "table.editCell": `Redaguoti langel\u{12F}`,
    "table.loading": `\u{12E}keliama...`,
    "table.loadingMore": `\u{12E}keliama daugiau...`,
    "table.resizeColumn": `Keisti stulpelio dyd\u{12F}`,
    "table.save": `\u{12E}ra\u{161}yti`,
    "table.sortAscending": `Rikiuoti did\u{117}jimo tvarka`,
    "table.sortDescending": `Rikiuoti ma\u{17E}\u{117}jimo tvarka`,
    "tag.actions": `Veiksmai`,
    "tag.hideButtonLabel": `Rodyti ma\u{17E}iau`,
    "tag.noTags": `N\u{117}ra`,
    "tag.showAllButtonLabel": (args, formatter)=>`Rodyti visk\u{105} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `I\u{161}valyti visk\u{105}`,
    "toast.collapse": `Sutraukti`,
    "toast.showAll": `Rodyti visk\u{105}`,
    "treeview.loadingMore": `\u{12E}keliama daugiau...`
};

});

parcelRegister("fUrYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69bbc57d2007fb8$export$2e2bcd8739ae039);
var $b69bbc57d2007fb8$export$2e2bcd8739ae039 = {};
$b69bbc57d2007fb8$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Darb\u{12B}bas`,
    "actionbar.actionsAvailable": `Pieejamas darb\u{12B}bas.`,
    "actionbar.clearSelection": `Not\u{12B}r\u{12B}t atlasi`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts nekas`,
            other: ()=>`Atlas\u{12B}ts(-i): ${formatter.number(args.count)}`
        })}`,
    "actionbar.selectedAll": `Atlas\u{12B}ts viss`,
    "actionbutton.pending": `gaida`,
    "breadcrumbs.more": `Vair\u{101}k vienumu`,
    "button.pending": `gaida`,
    "calendar.invalidSelection": (args, formatter)=>`Atlas\u{12B}tais(-ie) ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nav pieejams(-i).`,
    "combobox.loading": `Notiek iel\u{101}de...`,
    "combobox.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "combobox.noResults": `Nav rezult\u{101}tu`,
    "contextualhelp.help": `Pal\u{12B}dz\u{12B}ba`,
    "contextualhelp.info": `Inform\u{101}cija`,
    "datepicker.endTime": `Beigu laiks`,
    "datepicker.startTime": `S\u{101}kuma laiks`,
    "datepicker.time": `Laiks`,
    "dialog.alert": `Br\u{12B}din\u{101}jums`,
    "dialog.dismiss": `Ner\u{101}d\u{12B}t`,
    "dropzone.replaceMessage": `Lai aizst\u{101}tu, nometiet failu`,
    "inlinealert.informative": `Inform\u{101}cija`,
    "inlinealert.negative": `K\u{13C}\u{16B}da`,
    "inlinealert.notice": `Br\u{12B}din\u{101}jums`,
    "inlinealert.positive": `Izdev\u{101}s`,
    "label.(optional)": `(neoblig\u{101}ti)`,
    "label.(required)": `(oblig\u{101}ti)`,
    "listview.loading": `Notiek iel\u{101}de...`,
    "listview.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "menu.loading": `Notiek iel\u{101}de...`,
    "menu.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "menu.moreActions": `Citas darb\u{12B}bas`,
    "menu.noResults": `Nav rezult\u{101}tu`,
    "menu.unavailable": `Nav pieejams, izv\u{113}rsiet, lai skat\u{12B}tu s\u{12B}k\u{101}ku inform\u{101}ciju`,
    "notificationbadge.indicatorOnly": `Jauna aktivit\u{101}te`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Notiek iel\u{101}de...`,
    "picker.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "picker.placeholder": `Izv\u{113}l\u{113}ties\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts neviens vienums`,
            one: ()=>`${formatter.number(args.count)} vienums atlas\u{12B}ts`,
            other: ()=>`${formatter.number(args.count)} ieraksti vienumi`
        })}`,
    "sidepanel.collapse": `Sak\u{13C}aut s\u{101}nu paneli`,
    "sidepanel.expand": `Izv\u{113}rst s\u{101}nu paneli`,
    "slider.maximum": `Maksim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "slider.minimum": `Minim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "table.cancel": `Atcelt`,
    "table.drag": `Vilk\u{161}ana`,
    "table.editCell": `Redi\u{123}\u{113}t \u{161}\u{16B}nu`,
    "table.loading": `Notiek iel\u{101}de...`,
    "table.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "table.resizeColumn": `Main\u{12B}t kolonnas lielumu`,
    "table.save": `Saglab\u{101}t`,
    "table.sortAscending": `K\u{101}rtot augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "table.sortDescending": `K\u{101}rtot dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "tag.actions": `Darb\u{12B}bas`,
    "tag.hideButtonLabel": `R\u{101}d\u{12B}t maz\u{101}k`,
    "tag.noTags": `Nav`,
    "tag.showAllButtonLabel": (args, formatter)=>`R\u{101}d\u{12B}t visu (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Not\u{12B}r\u{12B}t visu`,
    "toast.collapse": `Sak\u{13C}aut`,
    "toast.showAll": `R\u{101}d\u{12B}t visu`,
    "treeview.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};

});

parcelRegister("foKXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c23f2d571e4a36$export$2e2bcd8739ae039);
var $c9c23f2d571e4a36$export$2e2bcd8739ae039 = {};
$c9c23f2d571e4a36$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Handlinger`,
    "actionbar.actionsAvailable": `Tilgjengelige handlinger.`,
    "actionbar.clearSelection": `T\xf8m utvalg`,
    "actionbar.selected": (args)=>`Valde element: ${args.count}`,
    "actionbar.selectedAll": `Alle er valgt`,
    "actionbutton.pending": `avventer`,
    "breadcrumbs.more": `Flere elementer`,
    "button.pending": `avventer`,
    "calendar.invalidSelection": (args, formatter)=>`Valgt(e) ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} er utilgjengelig.`,
    "combobox.loading": `Laster inn...`,
    "combobox.loadingMore": `Laster inn flere...`,
    "combobox.noResults": `Ingen resultater`,
    "contextualhelp.help": `Hjelp`,
    "contextualhelp.info": `Informasjon`,
    "datepicker.endTime": `Sluttid`,
    "datepicker.startTime": `Starttid`,
    "datepicker.time": `Tid`,
    "dialog.alert": `Varsel`,
    "dialog.dismiss": `Lukk`,
    "dropzone.replaceMessage": `Slipp filen for \xe5 erstatte`,
    "inlinealert.informative": `Informasjon`,
    "inlinealert.negative": `Feil`,
    "inlinealert.notice": `Advarsel`,
    "inlinealert.positive": `Vellykket`,
    "label.(optional)": `(valgfritt)`,
    "label.(required)": `(obligatorisk)`,
    "listview.loading": `Laster inn...`,
    "listview.loadingMore": `Laster inn flere...`,
    "menu.loading": `Laster inn...`,
    "menu.loadingMore": `Laster inn flere...`,
    "menu.moreActions": `Flere handlinger`,
    "menu.noResults": `Ingen resultater`,
    "menu.unavailable": `Utilgjengelig, utvid for detaljer`,
    "notificationbadge.indicatorOnly": `Ny aktivitet`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Laster inn...`,
    "picker.loadingMore": `Laster inn flere...`,
    "picker.placeholder": `Velg \u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer er valgt`,
            one: ()=>`${formatter.number(args.count)} element er valgt`,
            other: ()=>`${formatter.number(args.count)} elementer er valgt`
        })}`,
    "sidepanel.collapse": `Skjul sidepanelet`,
    "sidepanel.expand": `Vis sidepanelet`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Avbryt`,
    "table.drag": `Dra`,
    "table.editCell": `Rediger celle`,
    "table.loading": `Laster inn...`,
    "table.loadingMore": `Laster inn flere...`,
    "table.resizeColumn": `Endre st\xf8rrelse p\xe5 kolonne`,
    "table.save": `Lagre`,
    "table.sortAscending": `Sorter stigende`,
    "table.sortDescending": `Sorter synkende`,
    "tag.actions": `Handlinger`,
    "tag.hideButtonLabel": `Vis mindre`,
    "tag.noTags": `Ingen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Fjern alle`,
    "toast.collapse": `Skjul`,
    "toast.showAll": `Vis alle`,
    "treeview.loadingMore": `Laster inn flere...`
};

});

parcelRegister("aMrQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $172220cb062cc6d8$export$2e2bcd8739ae039);
var $172220cb062cc6d8$export$2e2bcd8739ae039 = {};
$172220cb062cc6d8$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Acties`,
    "actionbar.actionsAvailable": `Acties beschikbaar.`,
    "actionbar.clearSelection": `Selectie wissen`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niets geselecteerd`,
            other: ()=>`${formatter.number(args.count)} geselecteerd`
        })}`,
    "actionbar.selectedAll": `Alles geselecteerd`,
    "actionbutton.pending": `in behandeling`,
    "breadcrumbs.more": `Meer items`,
    "button.pending": `in behandeling`,
    "calendar.invalidSelection": (args, formatter)=>`Geselecteerde ${formatter.plural(args.selectedCount, {
            one: `datum`,
            other: `datums`
        })} niet beschikbaar.`,
    "combobox.loading": `Laden...`,
    "combobox.loadingMore": `Meer laden...`,
    "combobox.noResults": `Geen resultaten`,
    "contextualhelp.help": `Help`,
    "contextualhelp.info": `Informatie`,
    "datepicker.endTime": `Eindtijd`,
    "datepicker.startTime": `Starttijd`,
    "datepicker.time": `Tijd`,
    "dialog.alert": `Melding`,
    "dialog.dismiss": `Negeren`,
    "dropzone.replaceMessage": `Bestand neerzetten om te vervangen`,
    "inlinealert.informative": `Informatie`,
    "inlinealert.negative": `Fout`,
    "inlinealert.notice": `Waarschuwing`,
    "inlinealert.positive": `Geslaagd`,
    "label.(optional)": `(optioneel)`,
    "label.(required)": `(vereist)`,
    "listview.loading": `Laden...`,
    "listview.loadingMore": `Meer laden...`,
    "menu.loading": `Laden...`,
    "menu.loadingMore": `Meer laden...`,
    "menu.moreActions": `Meer handelingen`,
    "menu.noResults": `Geen resultaten`,
    "menu.unavailable": `Niet beschikbaar, uitvouwen voor meer informatie`,
    "notificationbadge.indicatorOnly": `Nieuwe activiteit`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Laden...`,
    "picker.loadingMore": `Meer laden...`,
    "picker.placeholder": `Selecteren\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Geen items geselecteerd`,
            one: ()=>`${formatter.number(args.count)} item geselecteerd`,
            other: ()=>`${formatter.number(args.count)} items geselecteerd`
        })}`,
    "sidepanel.collapse": `Zijpaneel samenvouwen`,
    "sidepanel.expand": `Zijpaneel uitvouwen`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Annuleren`,
    "table.drag": `Slepen`,
    "table.editCell": `Cel bewerken`,
    "table.loading": `Laden...`,
    "table.loadingMore": `Meer laden...`,
    "table.resizeColumn": `Kolomgrootte wijzigen`,
    "table.save": `Opslaan`,
    "table.sortAscending": `Oplopend sorteren`,
    "table.sortDescending": `Aflopend sorteren`,
    "tag.actions": `Acties`,
    "tag.hideButtonLabel": `Minder weergeven`,
    "tag.noTags": `Geen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Alles tonen (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Alles wissen`,
    "toast.collapse": `Samenvouwen`,
    "toast.showAll": `Alles weergeven`,
    "treeview.loadingMore": `Meer laden...`
};

});

parcelRegister("d1523", function(module, exports) {

$parcel$export(module.exports, "default", () => $94ca68f784a022f6$export$2e2bcd8739ae039);
var $94ca68f784a022f6$export$2e2bcd8739ae039 = {};
$94ca68f784a022f6$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Dzia\u{142}ania`,
    "actionbar.actionsAvailable": `Dost\u{119}pne dzia\u{142}ania.`,
    "actionbar.clearSelection": `Wyczy\u{15B}\u{107} zaznaczenie`,
    "actionbar.selected": (args)=>`Zaznaczono: ${args.count}`,
    "actionbar.selectedAll": `Wszystkie zaznaczone`,
    "actionbutton.pending": `oczekuj\u{105}ce`,
    "breadcrumbs.more": `Wi\u{119}cej element\xf3w`,
    "button.pending": `oczekuj\u{105}ce`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Wybrana data jest niedost\u{119}pna`,
            other: `Wybrane daty s\u{105} niedost\u{119}pne`
        })}.`,
    "combobox.loading": `Wczytywanie...`,
    "combobox.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "combobox.noResults": `Brak wynik\xf3w`,
    "contextualhelp.help": `Pomoc`,
    "contextualhelp.info": `Informacja`,
    "datepicker.endTime": `Godzina ko\u{144}cowa`,
    "datepicker.startTime": `Godzina pocz\u{105}tkowa`,
    "datepicker.time": `Godzina`,
    "dialog.alert": `Ostrze\u{17C}enie`,
    "dialog.dismiss": `Zignoruj`,
    "dropzone.replaceMessage": `Upu\u{15B}\u{107} plik, aby zast\u{105}pi\u{107}`,
    "inlinealert.informative": `Informacja`,
    "inlinealert.negative": `B\u{142}\u{105}d`,
    "inlinealert.notice": `Ostrze\u{17C}enie`,
    "inlinealert.positive": `Powodzenie`,
    "label.(optional)": `(opcjonalne)`,
    "label.(required)": `(wymagane)`,
    "listview.loading": `Wczytywanie...`,
    "listview.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "menu.loading": `Wczytywanie...`,
    "menu.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "menu.moreActions": `Wi\u{119}cej akcji`,
    "menu.noResults": `Brak wynik\xf3w`,
    "menu.unavailable": `Niedost\u{119}pne, rozwi\u{144}, aby zobaczy\u{107} szczeg\xf3\u{142}y`,
    "notificationbadge.indicatorOnly": `Nowa aktywno\u{15B}\u{107}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Wczytywanie...`,
    "picker.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "picker.placeholder": `Zaznacz\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nie zaznaczono \u{17C}adnych element\xf3w`,
            one: ()=>`${formatter.number(args.count)} zaznaczony element`,
            few: ()=>`${formatter.number(args.count)} zaznaczone elementy`,
            many: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`,
            other: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`
        })}`,
    "sidepanel.collapse": `Zwi\u{144} panel boczny`,
    "sidepanel.expand": `Rozwi\u{144} panel boczny`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Anuluj`,
    "table.drag": `Przeci\u{105}gnij`,
    "table.editCell": `Edytuj kom\xf3rk\u{119}`,
    "table.loading": `Wczytywanie...`,
    "table.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "table.resizeColumn": `Zmie\u{144} rozmiar kolumny`,
    "table.save": `Zapisz`,
    "table.sortAscending": `Sortuj rosn\u{105}co`,
    "table.sortDescending": `Sortuj malej\u{105}co`,
    "tag.actions": `Dzia\u{142}ania`,
    "tag.hideButtonLabel": `Wy\u{15B}wietl mniej`,
    "tag.noTags": `Brak`,
    "tag.showAllButtonLabel": (args, formatter)=>`Poka\u{17C} wszystko (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Wyczy\u{15B}\u{107} wszystko`,
    "toast.collapse": `Zwi\u{144}`,
    "toast.showAll": `Poka\u{17C} wszystko`,
    "treeview.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};

});

parcelRegister("3nle0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae2750cd59b6d83$export$2e2bcd8739ae039);
var $9ae2750cd59b6d83$export$2e2bcd8739ae039 = {};
$9ae2750cd59b6d83$export$2e2bcd8739ae039 = {
    "actionbar.actions": `A\xe7\xf5es`,
    "actionbar.actionsAvailable": `A\xe7\xf5es dispon\xedveis.`,
    "actionbar.clearSelection": `Limpar sele\xe7\xe3o`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum selecionado`,
            one: ()=>`${formatter.number(args.count)} selecionado`,
            other: ()=>`${formatter.number(args.count)} selecionados`
        })}`,
    "actionbar.selectedAll": `Todos selecionados`,
    "actionbutton.pending": `pendente`,
    "breadcrumbs.more": `Mais itens`,
    "button.pending": `pendente`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data`,
            other: `Datas`
        })} selecionada(s) indispon\xedvel(is).`,
    "combobox.loading": `Carregando...`,
    "combobox.loadingMore": `Carregando mais...`,
    "combobox.noResults": `Nenhum resultado`,
    "contextualhelp.help": `Ajuda`,
    "contextualhelp.info": `Informa\xe7\xf5es`,
    "datepicker.endTime": `Hora final`,
    "datepicker.startTime": `Hora inicial`,
    "datepicker.time": `Hora`,
    "dialog.alert": `Alerta`,
    "dialog.dismiss": `Descartar`,
    "dropzone.replaceMessage": `Solte o arquivo para substituir`,
    "inlinealert.informative": `Informa\xe7\xf5es`,
    "inlinealert.negative": `Erro`,
    "inlinealert.notice": `Aviso`,
    "inlinealert.positive": `Sucesso`,
    "label.(optional)": `(opcional)`,
    "label.(required)": `(obrigat\xf3rio)`,
    "listview.loading": `Carregando...`,
    "listview.loadingMore": `Carregando mais...`,
    "menu.loading": `Carregando...`,
    "menu.loadingMore": `Carregando mais...`,
    "menu.moreActions": `Mais a\xe7\xf5es`,
    "menu.noResults": `Nenhum resultado`,
    "menu.unavailable": `Indispon\xedvel. Expanda para ver os detalhes`,
    "notificationbadge.indicatorOnly": `Nova atividade`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Carregando...`,
    "picker.loadingMore": `Carregando mais...`,
    "picker.placeholder": `Selecionar\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}`,
    "sidepanel.collapse": `Recolher o painel lateral`,
    "sidepanel.expand": `Expandir o painel lateral`,
    "slider.maximum": `M\xe1ximo`,
    "slider.minimum": `M\xednimo`,
    "table.cancel": `Cancelar`,
    "table.drag": `Arraste`,
    "table.editCell": `Editar c\xe9lula`,
    "table.loading": `Carregando...`,
    "table.loadingMore": `Carregando mais...`,
    "table.resizeColumn": `Redimensionar coluna`,
    "table.save": `Salvar`,
    "table.sortAscending": `Ordenar por ordem crescente`,
    "table.sortDescending": `Ordenar por ordem decrescente`,
    "tag.actions": `A\xe7\xf5es`,
    "tag.hideButtonLabel": `Mostrar menos`,
    "tag.noTags": `Nenhum`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Limpar tudo`,
    "toast.collapse": `Recolher`,
    "toast.showAll": `Mostrar tudo`,
    "treeview.loadingMore": `Carregando mais...`
};

});

parcelRegister("eIs9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $84f61bfec5efc86e$export$2e2bcd8739ae039);
var $84f61bfec5efc86e$export$2e2bcd8739ae039 = {};
$84f61bfec5efc86e$export$2e2bcd8739ae039 = {
    "actionbar.actions": `A\xe7\xf5es`,
    "actionbar.actionsAvailable": `A\xe7\xf5es dispon\xedveis.`,
    "actionbar.clearSelection": `Limpar sele\xe7\xe3o`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum selecionado`,
            one: ()=>`${formatter.number(args.count)} selecionado`,
            other: ()=>`${formatter.number(args.count)} selecionados`
        })}`,
    "actionbar.selectedAll": `Tudo selecionado`,
    "actionbutton.pending": `pendente`,
    "breadcrumbs.more": `Mais artigos`,
    "button.pending": `pendente`,
    "calendar.invalidSelection": (args, formatter)=>`A(s) ${formatter.plural(args.selectedCount, {
            one: `data`,
            other: `datas`
        })} selecionada(s) n\xe3o est\xe1(\xe3o) dispon\xedvel/dispon\xedvel(eis).`,
    "combobox.loading": `A carregar...`,
    "combobox.loadingMore": `A carregar mais...`,
    "combobox.noResults": `Sem resultados`,
    "contextualhelp.help": `Ajuda`,
    "contextualhelp.info": `Informa\xe7\xe3o`,
    "datepicker.endTime": `Terminar tempo`,
    "datepicker.startTime": `Iniciar tempo`,
    "datepicker.time": `Tempo`,
    "dialog.alert": `Alerta`,
    "dialog.dismiss": `Dispensar`,
    "dropzone.replaceMessage": `Largar ficheiro para substituir`,
    "inlinealert.informative": `Informa\xe7\xe3o`,
    "inlinealert.negative": `Erro`,
    "inlinealert.notice": `Aviso`,
    "inlinealert.positive": `Sucesso`,
    "label.(optional)": `(opcional)`,
    "label.(required)": `(obrigat\xf3rio)`,
    "listview.loading": `A carregar...`,
    "listview.loadingMore": `A carregar mais...`,
    "menu.loading": `A carregar...`,
    "menu.loadingMore": `A carregar mais...`,
    "menu.moreActions": `Mais a\xe7\xf5es`,
    "menu.noResults": `Sem resultados`,
    "menu.unavailable": `Indispon\xedvel, expandir para mais detalhes`,
    "notificationbadge.indicatorOnly": `Nova atividade`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `A carregar...`,
    "picker.loadingMore": `A carregar mais...`,
    "picker.placeholder": `Selecionar\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "sidepanel.collapse": `Fechar o painel lateral`,
    "sidepanel.expand": `Expandir o painel lateral`,
    "slider.maximum": `M\xe1ximo`,
    "slider.minimum": `M\xednimo`,
    "table.cancel": `Cancelar`,
    "table.drag": `Arrastar`,
    "table.editCell": `Editar c\xe9lula`,
    "table.loading": `A carregar...`,
    "table.loadingMore": `A carregar mais...`,
    "table.resizeColumn": `Redimensionar coluna`,
    "table.save": `Guardar`,
    "table.sortAscending": `Ordenar por ordem ascendente`,
    "table.sortDescending": `Ordenar por ordem decrescente`,
    "tag.actions": `A\xe7\xf5es`,
    "tag.hideButtonLabel": `Mostrar menos`,
    "tag.noTags": `Nenhum`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Limpar tudo`,
    "toast.collapse": `Colapsar`,
    "toast.showAll": `Mostrar tudo`,
    "treeview.loadingMore": `A carregar mais...`
};

});

parcelRegister("lVZPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41e06e79efae88e$export$2e2bcd8739ae039);
var $e41e06e79efae88e$export$2e2bcd8739ae039 = {};
$e41e06e79efae88e$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Ac\u{21B}iuni`,
    "actionbar.actionsAvailable": `Ac\u{21B}iuni disponibile.`,
    "actionbar.clearSelection": `Goli\u{21B}i selec\u{21B}ia`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciunul selectat`,
            one: ()=>` ${formatter.number(args.count)} selectat`,
            other: ()=>`${formatter.number(args.count)} selectate`
        })}`,
    "actionbar.selectedAll": `Toate elementele selectate`,
    "actionbutton.pending": `\xeen a\u{219}teptare`,
    "breadcrumbs.more": `Mai multe articole`,
    "button.pending": `\xeen a\u{219}teptare`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selectat\u{103} nu este disponibil\u{103}`,
            other: `Datele selectate nu sunt disponibile`
        })}.`,
    "combobox.loading": `Se \xeencarc\u{103}...`,
    "combobox.loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "combobox.noResults": `Niciun rezultat`,
    "contextualhelp.help": `Ajutor`,
    "contextualhelp.info": `Informa\u{21B}ii`,
    "datepicker.endTime": `Ora de sf\xe2r\u{219}it`,
    "datepicker.startTime": `Ora de \xeenceput`,
    "datepicker.time": `Ora`,
    "dialog.alert": `Alert\u{103}`,
    "dialog.dismiss": `Revocare`,
    "dropzone.replaceMessage": `Plasa\u{21B}i fi\u{219}ierul pentru a \xeenlocui`,
    "inlinealert.informative": `Informa\u{21B}ii`,
    "inlinealert.negative": `Eroare`,
    "inlinealert.notice": `Avertisment`,
    "inlinealert.positive": `Succes`,
    "label.(optional)": `(op\u{163}ional)`,
    "label.(required)": `(obligatoriu)`,
    "listview.loading": `Se \xeencarc\u{103}...`,
    "listview.loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "menu.loading": `Se \xeencarc\u{103}...`,
    "menu.loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "menu.moreActions": `Mai multe ac\u{21B}iuni`,
    "menu.noResults": `Niciun rezultat`,
    "menu.unavailable": `Indisponibil, extinde\u{21B}i pentru detalii`,
    "notificationbadge.indicatorOnly": `Activitate nou\u{103}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Se \xeencarc\u{103}...`,
    "picker.loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "picker.placeholder": `Selecta\u{21B}i\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciun articol selectat`,
            one: ()=>`${formatter.number(args.count)} articol selectat`,
            other: ()=>`${formatter.number(args.count)} articole selectate`
        })}`,
    "sidepanel.collapse": `Restr\xe2nge\u{21B}i panoul lateral`,
    "sidepanel.expand": ` Extinde\u{21B}i panoul lateral`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Anulare`,
    "table.drag": `Trage\u{21B}i`,
    "table.editCell": `Edita\u{21B}i celula`,
    "table.loading": `Se \xeencarc\u{103}...`,
    "table.loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "table.resizeColumn": `Redimensiona\u{21B}i coloana`,
    "table.save": `Salva\u{21B}i`,
    "table.sortAscending": `Sorta\u{21B}i cresc\u{103}tor`,
    "table.sortDescending": `Sorta\u{21B}i descresc\u{103}tor`,
    "tag.actions": `Ac\u{21B}iuni`,
    "tag.hideButtonLabel": `Se afi\u{219}eaz\u{103} mai pu\u{21B}in`,
    "tag.noTags": `Niciuna`,
    "tag.showAllButtonLabel": (args, formatter)=>`Se afi\u{219}eaz\u{103} tot (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Goli\u{21B}i tot`,
    "toast.collapse": `Restr\xe2nge\u{21B}i`,
    "toast.showAll": `Afi\u{219}a\u{21B}i tot`,
    "treeview.loadingMore": `Se \xeencarc\u{103} mai multe...`
};

});

parcelRegister("6mBFH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bdc4fc54bddb317$export$2e2bcd8739ae039);
var $7bdc4fc54bddb317$export$2e2bcd8739ae039 = {};
$7bdc4fc54bddb317$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "actionbar.actionsAvailable": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}.`,
    "actionbar.clearSelection": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${formatter.number(args.count)}`
        })}`,
    "actionbar.selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{441}\u{435}`,
    "actionbutton.pending": `\u{432} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`,
    "breadcrumbs.more": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    "button.pending": `\u{432} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}`,
            other: `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{434}\u{430}\u{442}\u{44B} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}`
        })}.`,
    "combobox.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "combobox.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "combobox.noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{44B} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{442}`,
    "contextualhelp.help": `\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}`,
    "contextualhelp.info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "datepicker.endTime": `\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    "datepicker.startTime": `\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    "datepicker.time": `\u{412}\u{440}\u{435}\u{43C}\u{44F}`,
    "dialog.alert": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "dialog.dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`,
    "dropzone.replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{435}\u{43D}\u{44B}`,
    "inlinealert.informative": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "inlinealert.negative": `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    "inlinealert.notice": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "inlinealert.positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`,
    "label.(optional)": `(\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "label.(required)": `(\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "listview.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "listview.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "menu.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "menu.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "menu.moreActions": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "menu.noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{44B} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{442}`,
    "menu.unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}, \u{440}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439}`,
    "notificationbadge.indicatorOnly": `\u{41D}\u{43E}\u{432}\u{430}\u{44F} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "picker.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "picker.placeholder": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
            one: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}. \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
        })}`,
    "sidepanel.collapse": `\u{421}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C} \u{431}\u{43E}\u{43A}\u{43E}\u{432}\u{443}\u{44E} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C}`,
    "sidepanel.expand": `\u{420}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C} \u{431}\u{43E}\u{43A}\u{43E}\u{432}\u{443}\u{44E} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C}`,
    "slider.maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "slider.minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`,
    "table.cancel": `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{430}`,
    "table.drag": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    "table.editCell": `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44F}\u{447}\u{435}\u{439}\u{43A}\u{443}`,
    "table.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "table.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "table.resizeColumn": `\u{418}\u{437}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{446}\u{430}`,
    "table.save": `\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C}`,
    "table.sortAscending": `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{43E} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44E}`,
    "table.sortDescending": `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{43E} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44E}`,
    "tag.actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "tag.hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435}`,
    "tag.noTags": `\u{41D}\u{435}\u{442}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    "toast.collapse": `\u{421}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "toast.showAll": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    "treeview.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`
};

});

parcelRegister("aS80E", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3406d8f58e1423f$export$2e2bcd8739ae039);
var $c3406d8f58e1423f$export$2e2bcd8739ae039 = {};
$c3406d8f58e1423f$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Akcie`,
    "actionbar.actionsAvailable": `Dostupn\xe9 akcie.`,
    "actionbar.clearSelection": `Vymaza\u{165} v\xfdber`,
    "actionbar.selected": (args)=>`Vybran\xe9 polo\u{17E}ky: ${args.count}`,
    "actionbar.selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky`,
    "actionbutton.pending": `\u{10D}akaj\xface`,
    "breadcrumbs.more": `\u{10E}al\u{161}ie polo\u{17E}ky`,
    "button.pending": `\u{10D}akaj\xface`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybrat\xfd d\xe1tum`,
            other: `Vybrat\xe9 d\xe1tumy`
        })}: nedostupn\xe9.`,
    "combobox.loading": `Na\u{10D}\xedtava sa...`,
    "combobox.loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "combobox.noResults": `\u{17D}iadne v\xfdsledky`,
    "contextualhelp.help": `Pomoc`,
    "contextualhelp.info": `Inform\xe1cie`,
    "datepicker.endTime": `\u{10C}as ukon\u{10D}enia`,
    "datepicker.startTime": `\u{10C}as za\u{10D}iatku`,
    "datepicker.time": `\u{10C}as`,
    "dialog.alert": `Upozornenie`,
    "dialog.dismiss": `Zru\u{161}i\u{165}`,
    "dropzone.replaceMessage": `Presu\u{148}te s\xfabor, ktor\xfd chcete nahradi\u{165}`,
    "inlinealert.informative": `Inform\xe1cie`,
    "inlinealert.negative": `Chyba`,
    "inlinealert.notice": `Upozornenie`,
    "inlinealert.positive": `\xdaspech`,
    "label.(optional)": `(nepovinn\xe9)`,
    "label.(required)": `(povinn\xe9)`,
    "listview.loading": `Na\u{10D}\xedtava sa...`,
    "listview.loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "menu.loading": `Na\u{10D}\xedtava sa...`,
    "menu.loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "menu.moreActions": `\u{10E}al\u{161}ie akcie`,
    "menu.noResults": `\u{17D}iadne v\xfdsledky`,
    "menu.unavailable": `Nedostupn\xe9, rozba\u{13E}te podrobnosti`,
    "notificationbadge.indicatorOnly": `Nov\xe1 aktivita`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Na\u{10D}\xedtava sa...`,
    "picker.loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "picker.placeholder": `Vybra\u{165}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{17D}iadne vybrat\xe9 polo\u{17E}ky`,
            one: ()=>`${formatter.number(args.count)} vybrat\xe1 polo\u{17E}ka`,
            other: ()=>`Po\u{10D}et vybrat\xfdch polo\u{17E}iek ${formatter.number(args.count)}`
        })}`,
    "sidepanel.collapse": `Zbali\u{165} bo\u{10D}n\xfd panel`,
    "sidepanel.expand": `Rozbali\u{165} bo\u{10D}n\xfd panel`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Zru\u{161}i\u{165}`,
    "table.drag": `Presun\xfa\u{165}`,
    "table.editCell": `Upravi\u{165} bunku`,
    "table.loading": `Na\u{10D}\xedtava sa...`,
    "table.loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "table.resizeColumn": `Zmeni\u{165} ve\u{13E}kos\u{165} st\u{13A}pca`,
    "table.save": `Ulo\u{17E}i\u{165}`,
    "table.sortAscending": `Zoradi\u{165} vzostupne`,
    "table.sortDescending": `Zoradi\u{165} zostupne`,
    "tag.actions": `Akcie`,
    "tag.hideButtonLabel": `Zobrazi\u{165} menej`,
    "tag.noTags": `\u{17D}iadne`,
    "tag.showAllButtonLabel": (args, formatter)=>`Zobrazi\u{165} v\u{161}etko (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Vymaza\u{165} v\u{161}etko`,
    "toast.collapse": `Zbali\u{165}`,
    "toast.showAll": `Zobrazi\u{165} v\u{161}etko`,
    "treeview.loadingMore": `Na\u{10D}\xedtava sa viac...`
};

});

parcelRegister("6Y8N9", function(module, exports) {

$parcel$export(module.exports, "default", () => $243526c10cde0762$export$2e2bcd8739ae039);
var $243526c10cde0762$export$2e2bcd8739ae039 = {};
$243526c10cde0762$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Dejanja`,
    "actionbar.actionsAvailable": `Na voljo so dejanja.`,
    "actionbar.clearSelection": `Po\u{10D}isti izbor`,
    "actionbar.selected": (args)=>`Izbrano: ${args.count}`,
    "actionbar.selectedAll": `Izbrano vse`,
    "actionbutton.pending": `v teku`,
    "breadcrumbs.more": `Ve\u{10D} elementov`,
    "button.pending": `v teku`,
    "calendar.invalidSelection": (args, formatter)=>`Izbrano ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} ni na voljo.`,
    "combobox.loading": `Nalaganje...`,
    "combobox.loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "combobox.noResults": `Ni rezultatov`,
    "contextualhelp.help": `Pomo\u{10D}`,
    "contextualhelp.info": `Informacije`,
    "datepicker.endTime": `Kon\u{10D}ni \u{10D}as`,
    "datepicker.startTime": `Za\u{10D}etni \u{10D}as`,
    "datepicker.time": `\u{10C}as`,
    "dialog.alert": `Opozorilo`,
    "dialog.dismiss": `Opusti`,
    "dropzone.replaceMessage": `Spustite datoteko za zamenjavo`,
    "inlinealert.informative": `Informacije`,
    "inlinealert.negative": `Napaka`,
    "inlinealert.notice": `Opozorilo`,
    "inlinealert.positive": `Uspe\u{161}no`,
    "label.(optional)": `(opcijsko)`,
    "label.(required)": `(obvezno)`,
    "listview.loading": `Nalaganje...`,
    "listview.loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "menu.loading": `Nalaganje...`,
    "menu.loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "menu.moreActions": `Ve\u{10D} mo\u{17E}nosti`,
    "menu.noResults": `Ni rezultatov`,
    "menu.unavailable": `Ni na voljo, raz\u{161}irite za podrobnosti`,
    "notificationbadge.indicatorOnly": `Nova dejavnost`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Nalaganje...`,
    "picker.loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "picker.placeholder": `Izberite\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ni izbranih elementov`,
            one: ()=>`izbran je ${formatter.number(args.count)} element`,
            other: ()=>`izbranih je ${formatter.number(args.count)} elementov`
        })}.`,
    "sidepanel.collapse": `Strni stransko podokno`,
    "sidepanel.expand": `Raz\u{161}iri stransko podokno`,
    "slider.maximum": `Najve\u{10D}ji`,
    "slider.minimum": `Najmanj`,
    "table.cancel": `Prekli\u{10D}i`,
    "table.drag": `Povleci`,
    "table.editCell": `Uredi celico`,
    "table.loading": `Nalaganje...`,
    "table.loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "table.resizeColumn": `Spremeni velikost stolpca`,
    "table.save": `Shrani`,
    "table.sortAscending": `Razvrsti nara\u{161}\u{10D}ajo\u{10D}e`,
    "table.sortDescending": `Razvrsti padajo\u{10D}e`,
    "tag.actions": `Dejanja`,
    "tag.hideButtonLabel": `Prika\u{17E}i manj`,
    "tag.noTags": `Ni\u{10D}`,
    "tag.showAllButtonLabel": (args, formatter)=>`Prika\u{17E} vse (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Po\u{10D}isti vse`,
    "toast.collapse": `Strni`,
    "toast.showAll": `Prika\u{17E}i vse`,
    "treeview.loadingMore": `Nalaganje ve\u{10D} vsebine...`
};

});

parcelRegister("gZeC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7394465582df0e5e$export$2e2bcd8739ae039);
var $7394465582df0e5e$export$2e2bcd8739ae039 = {};
$7394465582df0e5e$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Radnje`,
    "actionbar.actionsAvailable": `Dostupne su radnje.`,
    "actionbar.clearSelection": `Poni\u{161}ti izbor`,
    "actionbar.selected": (args)=>`Izabrano: ${args.count}`,
    "actionbar.selectedAll": `Sve je izabrano`,
    "actionbutton.pending": `nere\u{161}eno`,
    "breadcrumbs.more": `Vi\u{161}e stavki`,
    "button.pending": `nere\u{161}eno`,
    "calendar.invalidSelection": (args, formatter)=>`Izabrani ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nije dostupan.`,
    "combobox.loading": `U\u{10D}itavam...`,
    "combobox.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "combobox.noResults": `Nema rezultata`,
    "contextualhelp.help": `Pomo\u{107}`,
    "contextualhelp.info": `Informacije`,
    "datepicker.endTime": `Zavr\u{161}no vreme`,
    "datepicker.startTime": `Po\u{10D}etno vreme`,
    "datepicker.time": `Vreme`,
    "dialog.alert": `Upozorenje`,
    "dialog.dismiss": `Odbaci`,
    "dropzone.replaceMessage": `Otpustite datoteku radi zamene`,
    "inlinealert.informative": `Informacije`,
    "inlinealert.negative": `Gre\u{161}ka`,
    "inlinealert.notice": `Upozorenje`,
    "inlinealert.positive": `Uspe\u{161}no`,
    "label.(optional)": `(opciono)`,
    "label.(required)": `(obavezno)`,
    "listview.loading": `U\u{10D}itavam...`,
    "listview.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "menu.loading": `U\u{10D}itavam...`,
    "menu.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "menu.moreActions": `Dodatne radnje`,
    "menu.noResults": `Nema rezultata`,
    "menu.unavailable": `Nije dostupno, pro\u{161}irite za detalje`,
    "notificationbadge.indicatorOnly": `Nova aktivnost`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `U\u{10D}itavam...`,
    "picker.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "picker.placeholder": `Izaberite...`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije izabrana nijedna stavka`,
            one: ()=>`Izabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Izabrano je ${formatter.number(args.count)} stavki`
        })}`,
    "sidepanel.collapse": `Skupi bo\u{10D}nu tablu`,
    "sidepanel.expand": `Pro\u{161}iri bo\u{10D}nu tablu`,
    "slider.maximum": `Najvi\u{161}e`,
    "slider.minimum": `Najmanje`,
    "table.cancel": `Otka\u{17E}i`,
    "table.drag": `Prevuci`,
    "table.editCell": `Uredi \u{107}eliju`,
    "table.loading": `U\u{10D}itavam...`,
    "table.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "table.resizeColumn": `Promeni veli\u{10D}inu kolone`,
    "table.save": `Sa\u{10D}uvaj`,
    "table.sortAscending": `Sortiraj po rastu\u{107}em redosledu`,
    "table.sortDescending": `Sortiraj po opadaju\u{107}em redosledu`,
    "tag.actions": `Radnje`,
    "tag.hideButtonLabel": `Prika\u{17E}i manje`,
    "tag.noTags": `Ne postoji`,
    "tag.showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Obri\u{161}i sve`,
    "toast.collapse": ` Skupi`,
    "toast.showAll": `Prika\u{17E}i sve`,
    "treeview.loadingMore": `U\u{10D}itavam jo\u{161}...`
};

});

parcelRegister("e5vw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $abc088500c50e214$export$2e2bcd8739ae039);
var $abc088500c50e214$export$2e2bcd8739ae039 = {};
$abc088500c50e214$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\xc5tg\xe4rder`,
    "actionbar.actionsAvailable": `\xc5tg\xe4rder finns.`,
    "actionbar.clearSelection": `Rensa markering`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga valda`,
            one: ()=>`${formatter.number(args.count)} vald`,
            other: ()=>`${formatter.number(args.count)} valda`
        })}`,
    "actionbar.selectedAll": `Alla markerade`,
    "actionbutton.pending": `v\xe4ntande`,
    "breadcrumbs.more": `Fler artiklar`,
    "button.pending": `v\xe4ntande`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Valt datum \xe4r inte tillg\xe4ngligt.`,
            other: `Valda datum \xe4r inte tillg\xe4ngliga.`
        })}`,
    "combobox.loading": `L\xe4ser in...`,
    "combobox.loadingMore": `L\xe4ser in mer...`,
    "combobox.noResults": `Inga resultat`,
    "contextualhelp.help": `Hj\xe4lp`,
    "contextualhelp.info": `Information`,
    "datepicker.endTime": `Sluttid`,
    "datepicker.startTime": `Starttid`,
    "datepicker.time": `Tid`,
    "dialog.alert": `Varning`,
    "dialog.dismiss": `Avvisa`,
    "dropzone.replaceMessage": `Sl\xe4pp filen f\xf6r att ers\xe4tta`,
    "inlinealert.informative": `Information`,
    "inlinealert.negative": `Fel`,
    "inlinealert.notice": `Varning`,
    "inlinealert.positive": `Lyckades`,
    "label.(optional)": `(valfritt)`,
    "label.(required)": `(kr\xe4vs)`,
    "listview.loading": `L\xe4ser in...`,
    "listview.loadingMore": `L\xe4ser in mer...`,
    "menu.loading": `L\xe4ser in...`,
    "menu.loadingMore": `L\xe4ser in mer...`,
    "menu.moreActions": `Fler \xe5tg\xe4rder`,
    "menu.noResults": `Inga resultat`,
    "menu.unavailable": `Ej tillg\xe4nglig, expandera f\xf6r mer information`,
    "notificationbadge.indicatorOnly": `Ny aktivitet`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `L\xe4ser in...`,
    "picker.loadingMore": `L\xe4ser in mer...`,
    "picker.placeholder": `V\xe4lj\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga objekt markerade`,
            one: ()=>`${formatter.number(args.count)} objekt markerat`,
            other: ()=>`${formatter.number(args.count)} objekt markerade`
        })}.`,
    "sidepanel.collapse": `D\xf6lj sidopanelen`,
    "sidepanel.expand": `Expandera sidopanelen`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `Avbryt`,
    "table.drag": `Dra`,
    "table.editCell": `Redigera cell`,
    "table.loading": `L\xe4ser in...`,
    "table.loadingMore": `L\xe4ser in mer...`,
    "table.resizeColumn": `\xc4ndra storlek p\xe5 kolumn`,
    "table.save": `Spara`,
    "table.sortAscending": `Sortera i stigande ordning`,
    "table.sortDescending": `Sortera i fallande ordning`,
    "tag.actions": `\xc5tg\xe4rder`,
    "tag.hideButtonLabel": `Visa mindre`,
    "tag.noTags": `Ingen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Visa alla (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `Rensa alla`,
    "toast.collapse": `D\xf6lj`,
    "toast.showAll": `Visa alla`,
    "treeview.loadingMore": `L\xe4ser in mer...`
};

});

parcelRegister("2YYUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf952ad05e55634$export$2e2bcd8739ae039);
var $bcf952ad05e55634$export$2e2bcd8739ae039 = {};
$bcf952ad05e55634$export$2e2bcd8739ae039 = {
    "actionbar.actions": `Eylemler`,
    "actionbar.actionsAvailable": `Eylemler mevcut.`,
    "actionbar.clearSelection": `Se\xe7imi temizle`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7biri se\xe7ilmedi`,
            other: ()=>`${formatter.number(args.count)} se\xe7ildi`
        })}`,
    "actionbar.selectedAll": `T\xfcm\xfc se\xe7ildi`,
    "actionbutton.pending": `beklemede`,
    "breadcrumbs.more": `Daha fazla \xf6\u{11F}e`,
    "button.pending": `beklemede`,
    "calendar.invalidSelection": (args, formatter)=>`Se\xe7ilen ${formatter.plural(args.selectedCount, {
            one: `tarih`,
            other: `tarihler`
        })} m\xfcsait de\u{11F}il.`,
    "combobox.loading": `Y\xfckleniyor...`,
    "combobox.loadingMore": `Daha fazla y\xfckleniyor...`,
    "combobox.noResults": `Sonu\xe7 yok`,
    "contextualhelp.help": `Yard\u{131}m`,
    "contextualhelp.info": `Bilgiler`,
    "datepicker.endTime": `Biti\u{15F} saati`,
    "datepicker.startTime": `Ba\u{15F}lang\u{131}\xe7 saati`,
    "datepicker.time": `Saat`,
    "dialog.alert": `Uyar\u{131}`,
    "dialog.dismiss": `Kapat`,
    "dropzone.replaceMessage": `De\u{11F}i\u{15F}tirmek i\xe7in dosyay\u{131} b\u{131}rak\u{131}n`,
    "inlinealert.informative": `Bilgiler`,
    "inlinealert.negative": `Hata`,
    "inlinealert.notice": `Uyar\u{131}`,
    "inlinealert.positive": `Ba\u{15F}ar\u{131}l\u{131}`,
    "label.(optional)": `(iste\u{11F}e ba\u{11F}l\u{131})`,
    "label.(required)": `(gerekli)`,
    "listview.loading": `Y\xfckleniyor...`,
    "listview.loadingMore": `Daha fazla y\xfckleniyor...`,
    "menu.loading": `Y\xfckleniyor...`,
    "menu.loadingMore": `Daha fazla y\xfckleniyor...`,
    "menu.moreActions": `Daha fazla eylem`,
    "menu.noResults": `Sonu\xe7 yok`,
    "menu.unavailable": `Kullan\u{131}lam\u{131}yor, ayr\u{131}nt\u{131}lar\u{131} g\xf6rmek i\xe7in geni\u{15F}letin`,
    "notificationbadge.indicatorOnly": `Yeni etkinlik`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `Y\xfckleniyor...`,
    "picker.loadingMore": `Daha fazla y\xfckleniyor...`,
    "picker.placeholder": `Se\xe7in\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7bir \xf6ge se\xe7ilmedi`,
            one: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`,
            other: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`
        })}`,
    "sidepanel.collapse": `Yan paneli daralt`,
    "sidepanel.expand": `Yan paneli geni\u{15F}let`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.cancel": `\u{130}ptal et`,
    "table.drag": `S\xfcr\xfckle`,
    "table.editCell": `H\xfccreyi d\xfczenle`,
    "table.loading": `Y\xfckleniyor...`,
    "table.loadingMore": `Daha fazla y\xfckleniyor...`,
    "table.resizeColumn": `S\xfctunu yeniden boyutland\u{131}r`,
    "table.save": `Kaydet`,
    "table.sortAscending": `Artan S\u{131}ralama`,
    "table.sortDescending": `Azalan S\u{131}ralama`,
    "tag.actions": `Eylemler`,
    "tag.hideButtonLabel": `Daha az g\xf6ster`,
    "tag.noTags": `Hi\xe7biri`,
    "tag.showAllButtonLabel": (args, formatter)=>`T\xfcm\xfcn\xfc g\xf6ster (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `T\xfcm\xfcn\xfc temizle`,
    "toast.collapse": `Daralt`,
    "toast.showAll": `T\xfcm\xfcn\xfc g\xf6ster`,
    "treeview.loadingMore": `Daha fazla y\xfckleniyor...`
};

});

parcelRegister("fYKMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae8c31cfa19a60d2$export$2e2bcd8739ae039);
var $ae8c31cfa19a60d2$export$2e2bcd8739ae039 = {};
$ae8c31cfa19a60d2$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{414}\u{456}\u{457}`,
    "actionbar.actionsAvailable": `\u{414}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{456} \u{434}\u{456}\u{457}.`,
    "actionbar.clearSelection": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{432}\u{438}\u{431}\u{456}\u{440}`,
    "actionbar.selected": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}: ${args.count}`,
    "actionbar.selectedAll": `\u{423}\u{441}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
    "actionbutton.pending": `\u{432} \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{456}`,
    "breadcrumbs.more": `\u{411}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}`,
    "button.pending": `\u{432} \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{456}`,
    "calendar.invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}`,
            other: `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{456} \u{434}\u{430}\u{442}\u{438} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{456}`
        })}.`,
    "combobox.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "combobox.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "combobox.noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{456}\u{432} \u{43D}\u{435}\u{43C}\u{430}\u{454}`,
    "contextualhelp.help": `\u{414}\u{43E}\u{432}\u{456}\u{434}\u{43A}\u{430}`,
    "contextualhelp.info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "datepicker.endTime": `\u{427}\u{430}\u{441} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}`,
    "datepicker.startTime": `\u{427}\u{430}\u{441} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443}`,
    "datepicker.time": `\u{427}\u{430}\u{441}`,
    "dialog.alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dialog.dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`,
    "dropzone.replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{456}\u{442}\u{44C} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{456}\u{43D}\u{438}`,
    "inlinealert.informative": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "inlinealert.negative": `\u{41F}\u{43E}\u{43C}\u{438}\u{43B}\u{43A}\u{430}`,
    "inlinealert.notice": `\u{41F}\u{43E}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{436}\u{435}\u{43D}\u{43D}\u{44F}`,
    "inlinealert.positive": `\u{423}\u{441}\u{43F}\u{456}\u{448}\u{43D}\u{43E}`,
    "label.(optional)": `(\u{43D}\u{435}\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "label.(required)": `(\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "listview.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "listview.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "menu.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "menu.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "menu.moreActions": `\u{411}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{434}\u{456}\u{439}`,
    "menu.noResults": `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{456}\u{432} \u{43D}\u{435}\u{43C}\u{430}\u{454}`,
    "menu.unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}, \u{440}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{434}\u{43E}\u{43A}\u{43B}\u{430}\u{434}\u{43D}\u{456}\u{448}\u{43E}\u{457} \u{456}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{457}`,
    "notificationbadge.indicatorOnly": `\u{41D}\u{43E}\u{432}\u{430} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{456}\u{441}\u{442}\u{44C}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "picker.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "picker.placeholder": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{416}\u{43E}\u{434}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            one: ()=>`${formatter.number(args.count)} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{415}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}: ${formatter.number(args.count)}`
        })}`,
    "sidepanel.collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438} \u{431}\u{456}\u{447}\u{43D}\u{443} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C}`,
    "sidepanel.expand": `\u{420}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438} \u{431}\u{456}\u{447}\u{43D}\u{443} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C}`,
    "slider.maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "slider.minimum": `\u{41C}\u{456}\u{43D}\u{456}\u{43C}\u{443}\u{43C}`,
    "table.cancel": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`,
    "table.drag": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}`,
    "table.editCell": `\u{420}\u{435}\u{434}\u{430}\u{433}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43A}\u{43B}\u{456}\u{442}\u{438}\u{43D}\u{43A}\u{443}`,
    "table.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "table.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "table.resizeColumn": `\u{417}\u{43C}\u{456}\u{43D}\u{438}\u{442}\u{438} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{44F}`,
    "table.save": `\u{417}\u{431}\u{435}\u{440}\u{435}\u{433}\u{442}\u{438}`,
    "table.sortAscending": `\u{421}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{437}\u{430} \u{437}\u{440}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}`,
    "table.sortDescending": `\u{421}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{437}\u{430} \u{441}\u{43F}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}`,
    "tag.actions": `\u{414}\u{456}\u{457}`,
    "tag.hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{448}\u{435}`,
    "tag.noTags": `\u{41D}\u{435}\u{43C}\u{430}\u{454}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{432}\u{441}\u{456} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{432}\u{441}\u{435}`,
    "toast.collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "toast.showAll": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{432}\u{441}\u{435}`,
    "treeview.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`
};

});

parcelRegister("cfHOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $496780a8ed4d92de$export$2e2bcd8739ae039);
var $496780a8ed4d92de$export$2e2bcd8739ae039 = {};
$496780a8ed4d92de$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{64CD}\u{4F5C}`,
    "actionbar.actionsAvailable": `\u{6709}\u{53EF}\u{7528}\u{64CD}\u{4F5C}\u{3002}`,
    "actionbar.clearSelection": `\u{6E05}\u{9664}\u{9009}\u{62E9}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{65E0}\u{9009}\u{62E9}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}`
        })}`,
    "actionbar.selectedAll": `\u{5168}\u{9009}`,
    "actionbutton.pending": `\u{5F85}\u{5904}\u{7406}`,
    "breadcrumbs.more": `\u{66F4}\u{591A}\u{9879}\u{76EE}`,
    "button.pending": `\u{5F85}\u{5904}\u{7406}`,
    "calendar.invalidSelection": (args, formatter)=>`\u{9009}\u{5B9A}\u{7684} ${formatter.plural(args.selectedCount, {
            one: `\u{4E2A}\u{65E5}\u{671F}`,
            other: `\u{4E2A}\u{65E5}\u{671F}`
        })} \u{4E0D}\u{53EF}\u{7528}\u{3002}`,
    "combobox.loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "combobox.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "combobox.noResults": `\u{65E0}\u{7ED3}\u{679C}`,
    "contextualhelp.help": `\u{5E2E}\u{52A9}`,
    "contextualhelp.info": `\u{4FE1}\u{606F}`,
    "datepicker.endTime": `\u{7ED3}\u{675F}\u{65F6}\u{95F4}`,
    "datepicker.startTime": `\u{5F00}\u{59CB}\u{65F6}\u{95F4}`,
    "datepicker.time": `\u{65F6}\u{95F4}`,
    "dialog.alert": `\u{8B66}\u{62A5}`,
    "dialog.dismiss": `\u{53D6}\u{6D88}`,
    "dropzone.replaceMessage": `\u{5220}\u{9664}\u{8981}\u{66FF}\u{6362}\u{7684}\u{6587}\u{4EF6}`,
    "inlinealert.informative": `\u{4FE1}\u{606F}`,
    "inlinealert.negative": `\u{9519}\u{8BEF}`,
    "inlinealert.notice": `\u{8B66}\u{544A}`,
    "inlinealert.positive": `\u{6210}\u{529F}`,
    "label.(optional)": `\u{FF08}\u{975E}\u{5FC5}\u{987B}\u{FF09}`,
    "label.(required)": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`,
    "listview.loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "listview.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "menu.loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "menu.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "menu.moreActions": `\u{66F4}\u{591A}\u{64CD}\u{4F5C}`,
    "menu.noResults": `\u{65E0}\u{7ED3}\u{679C}`,
    "menu.unavailable": `\u{4E0D}\u{53EF}\u{7528}\u{FF0C}\u{5C55}\u{5F00}\u{4EE5}\u{67E5}\u{770B}\u{8BE6}\u{7EC6}\u{4FE1}\u{606F}`,
    "notificationbadge.indicatorOnly": `\u{65B0}\u{6D3B}\u{52A8}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "picker.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "picker.placeholder": `\u{8BF7}\u{9009}\u{62E9}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9009}\u{62E9}\u{4EFB}\u{4F55}\u{9879}`,
            one: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}`
        })}`,
    "sidepanel.collapse": `\u{6298}\u{53E0}\u{4FA7}\u{9762}\u{677F}`,
    "sidepanel.expand": `\u{5C55}\u{5F00}\u{4FA7}\u{9762}\u{677F}`,
    "slider.maximum": `\u{6700}\u{5927}`,
    "slider.minimum": `\u{6700}\u{5C0F}`,
    "table.cancel": `\u{53D6}\u{6D88}`,
    "table.drag": `\u{62D6}\u{52A8}`,
    "table.editCell": `\u{7F16}\u{8F91}\u{5355}\u{5143}\u{683C}`,
    "table.loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "table.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "table.resizeColumn": `\u{8C03}\u{6574}\u{5217}\u{5927}\u{5C0F}`,
    "table.save": `\u{4FDD}\u{5B58}`,
    "table.sortAscending": `\u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "table.sortDescending": `\u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "tag.actions": `\u{64CD}\u{4F5C}`,
    "tag.hideButtonLabel": `\u{663E}\u{793A}\u{66F4}\u{5C11}`,
    "tag.noTags": `\u{65E0}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{5168}\u{90E8}\u{663E}\u{793A} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{5168}\u{90E8}\u{6E05}\u{9664}`,
    "toast.collapse": `\u{6298}\u{53E0}`,
    "toast.showAll": `\u{663E}\u{793A}\u{5168}\u{90E8}`,
    "treeview.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};

});

parcelRegister("3pU8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d094a0ef25fec32$export$2e2bcd8739ae039);
var $9d094a0ef25fec32$export$2e2bcd8739ae039 = {};
$9d094a0ef25fec32$export$2e2bcd8739ae039 = {
    "actionbar.actions": `\u{52D5}\u{4F5C}`,
    "actionbar.actionsAvailable": `\u{53EF}\u{57F7}\u{884C}\u{7684}\u{52D5}\u{4F5C}\u{3002}`,
    "actionbar.clearSelection": `\u{6E05}\u{9664}\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "actionbar.selected": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}`
        })}`,
    "actionbar.selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}`,
    "actionbutton.pending": `\u{5F85}\u{8655}\u{7406}`,
    "breadcrumbs.more": `\u{66F4}\u{591A}\u{9805}\u{76EE}`,
    "button.pending": `\u{5F85}\u{8655}\u{7406}`,
    "calendar.invalidSelection": (args, formatter)=>`\u{6240}\u{9078}\u{7684}${formatter.plural(args.selectedCount, {
            one: `\u{65E5}\u{671F}`,
            other: `\u{65E5}\u{671F}`
        })}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{3002}`,
    "combobox.loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "combobox.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "combobox.noResults": `\u{7121}\u{4EFB}\u{4F55}\u{7D50}\u{679C}`,
    "contextualhelp.help": `\u{8AAA}\u{660E}`,
    "contextualhelp.info": `\u{8CC7}\u{8A0A}`,
    "datepicker.endTime": `\u{7D50}\u{675F}\u{6642}\u{9593}`,
    "datepicker.startTime": `\u{958B}\u{59CB}\u{6642}\u{9593}`,
    "datepicker.time": `\u{6642}\u{9593}`,
    "dialog.alert": `\u{8B66}\u{793A}`,
    "dialog.dismiss": `\u{95DC}\u{9589}`,
    "dropzone.replaceMessage": `\u{653E}\u{7F6E}\u{8981}\u{53D6}\u{4EE3}\u{7684}\u{6A94}\u{6848}`,
    "inlinealert.informative": `\u{8CC7}\u{8A0A}`,
    "inlinealert.negative": `\u{932F}\u{8AA4}`,
    "inlinealert.notice": `\u{8B66}\u{544A}`,
    "inlinealert.positive": `\u{6210}\u{529F}`,
    "label.(optional)": `(\u{9078}\u{586B})`,
    "label.(required)": `(\u{5FC5}\u{586B})`,
    "listview.loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "listview.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "menu.loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "menu.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "menu.moreActions": `\u{66F4}\u{591A}\u{52D5}\u{4F5C}`,
    "menu.noResults": `\u{7121}\u{4EFB}\u{4F55}\u{7D50}\u{679C}`,
    "menu.unavailable": `\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{FF0C}\u{5C55}\u{958B}\u{4EE5}\u{53D6}\u{5F97}\u{8A73}\u{7D30}\u{8CC7}\u{6599}`,
    "notificationbadge.indicatorOnly": `\u{65B0}\u{6D3B}\u{52D5}`,
    "notificationbadge.plus": (args)=>`${args.notifications}+`,
    "picker.loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "picker.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "picker.placeholder": `\u{9078}\u{53D6}\u{2026}`,
    "picker.selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`
        })}`,
    "sidepanel.collapse": `\u{6536}\u{5408}\u{5074}\u{9762}\u{677F}`,
    "sidepanel.expand": `\u{5C55}\u{958B}\u{5074}\u{9762}\u{677F}`,
    "slider.maximum": `\u{6700}\u{5927}\u{503C}`,
    "slider.minimum": `\u{6700}\u{5C0F}\u{503C}`,
    "table.cancel": `\u{53D6}\u{6D88}`,
    "table.drag": `\u{62D6}\u{66F3}`,
    "table.editCell": `\u{7DE8}\u{8F2F}\u{5132}\u{5B58}\u{683C}`,
    "table.loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "table.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "table.resizeColumn": `\u{8ABF}\u{6574}\u{6B04}\u{5927}\u{5C0F}`,
    "table.save": `\u{5132}\u{5B58}`,
    "table.sortAscending": `\u{905E}\u{589E}\u{6392}\u{5E8F}`,
    "table.sortDescending": `\u{905E}\u{6E1B}\u{6392}\u{5E8F}`,
    "tag.actions": `\u{52D5}\u{4F5C}`,
    "tag.hideButtonLabel": `\u{986F}\u{793A}\u{8F03}\u{5C11}`,
    "tag.noTags": `\u{7121}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{986F}\u{793A}\u{5168}\u{90E8} (${formatter.number(args.tagCount)})`,
    "toast.clearAll": `\u{5168}\u{90E8}\u{6E05}\u{9664}`,
    "toast.collapse": `\u{6536}\u{5408}`,
    "toast.showAll": `\u{986F}\u{793A}\u{5168}\u{90E8}`,
    "treeview.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};

});


parcelRegister("aJzBQ", function(module, exports) {

$parcel$export(module.exports, "NotificationBadgeContext", () => $c3aa053278084e41$export$9ab75c96ebaa396c);
$parcel$export(module.exports, "NotificationBadge", () => $c3aa053278084e41$export$529cab0ca6be204e);


var $fL4LX = parcelRequire("fL4LX");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fVfXf = parcelRequire("fVfXf");

var $l3v5Z = parcelRequire("l3v5Z");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");
function $c3aa053278084e41$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c3aa053278084e41$export$9ab75c96ebaa396c = (0, $eF4cA.createContext)(null);
const $c3aa053278084e41$var$$bfb270fb056fefc5$var$badge = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    if (props.isDisabled) rules += ' sk182';
    else rules += ' sd182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    }
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.isStaticColor) rules += ' ph182';
    else rules += ' px182';
    rules += ' plb182';
    rules += ' _jlf182';
    rules += ' _klb182';
    rules += ' hlb182';
    rules += ' mlb182';
    rules += ' llb182';
    rules += ' ila182';
    rules += ' _Ca182';
    rules += ' eb182';
    rules += ' gqMFGYc182';
    rules += ' FRuFGYc182';
    if (props.isSingleDigit) rules += ' fa182';
    else if (props.isIndicatorOnly) rules += ' fa182';
    if (!width) rules += ' ZK182';
    if (props.isDoubleDigit) rules += ' Sv182';
    if (props.isDoubleDigit) rules += ' Rv182';
    rules += ' oh182';
    rules += ' nh182';
    rules += ' kh182';
    rules += ' jh182';
    if (props.isStaticColor) rules += ' -g_-g_c182';
    else rules += ' -g_-g2182';
    rules += ' -g_-lgb182';
    if (props.size === "XL") {
        if (props.isIndicatorOnly) rules += ' -F_-Fspvr8c182';
        else rules += ' -F_-Fm182';
    } else if (props.size === "L") {
        if (props.isIndicatorOnly) rules += ' -F_-Fspvr8c182';
        else rules += ' -F_-Ft182';
    } else if (props.size === "M") {
        if (props.isIndicatorOnly) rules += ' -F_-Fi182';
        else rules += ' -F_-FObNfn182';
    } else if (props.size === "S") {
        if (props.isIndicatorOnly) rules += ' -F_-Fi182';
        else rules += ' -F_-Fk182';
    }
    return rules;
};
const $c3aa053278084e41$export$529cab0ca6be204e = (0, $eF4cA.forwardRef)(function Badge(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($c3aa053278084e41$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $c3aa053278084e41$export$9ab75c96ebaa396c);
    let { size: size = 'S', value: value, isDisabled: isDisabled = false, staticColor: staticColor, ...otherProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let formattedValue = '';
    let isIndicatorOnly = false;
    let isSingleDigit = false;
    let isDoubleDigit = false;
    if (value == null) isIndicatorOnly = true;
    else if (value <= 0) throw new Error('Value cannot be negative or zero');
    else if (!Number.isInteger(value)) throw new Error('Value must be a positive integer');
    else {
        formattedValue = new (0, $l3v5Z.NumberFormatter)(locale).format(Math.min(value, 99));
        let length = Math.log(value <= 99 ? value : 99) * Math.LOG10E + 1 | 0; // for positive integers (https://stackoverflow.com/questions/14879691/get-number-of-digits-with-javascript)
        if (length === 1) isSingleDigit = true;
        else if (length === 2) isDoubleDigit = true;
        if (value > 99) formattedValue = stringFormatter.format('notificationbadge.plus', {
            notifications: formattedValue
        });
    }
    let ariaLabel = props['aria-label'] || undefined;
    if (ariaLabel === undefined && isIndicatorOnly) ariaLabel = stringFormatter.format('notificationbadge.indicatorOnly');
    return (0, $dx4lB.jsx)("span", {
        ...(0, $fVfXf.filterDOMProps)(otherProps, {
            labelable: true
        }),
        role: ariaLabel && 'img',
        "aria-label": ariaLabel,
        className: (props.UNSAFE_className || '') + $c3aa053278084e41$var$$bfb270fb056fefc5$var$badge({
            size: size,
            isIndicatorOnly: isIndicatorOnly,
            isSingleDigit: isSingleDigit,
            isDoubleDigit: isDoubleDigit,
            isDisabled: isDisabled,
            isStaticColor: !!staticColor
        }, props.styles),
        style: props.UNSAFE_style,
        ref: domRef,
        children: formattedValue
    });
});

});
parcelRegister("l3v5Z", function(module, exports) {

$parcel$export(module.exports, "NumberFormatter", () => $edd20167504aa060$export$cc77c4ff7e8673c5);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $edd20167504aa060$var$$1dfb119a85e764e5$var$formatterCache = new Map();
let $edd20167504aa060$var$$1dfb119a85e764e5$var$supportsSignDisplay = false;
try {
    $edd20167504aa060$var$$1dfb119a85e764e5$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
        signDisplay: 'exceptZero'
    }).resolvedOptions().signDisplay === 'exceptZero';
// eslint-disable-next-line no-empty
} catch  {}
class $edd20167504aa060$export$cc77c4ff7e8673c5 {
    constructor(locale, options = {}){
        this.numberFormatter = $edd20167504aa060$var$$1dfb119a85e764e5$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
    /**
   * Formats a number value as a string, according to the locale and options provided to the
   * constructor.
   */ format(value) {
        let res = '';
        if (!$edd20167504aa060$var$$1dfb119a85e764e5$var$supportsSignDisplay && this.options.signDisplay != null) res = $edd20167504aa060$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        if (typeof this.numberFormatter.formatRange === 'function') return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        if (typeof this.numberFormatter.formatRangeToParts === 'function') return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$edd20167504aa060$var$$1dfb119a85e764e5$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        return options;
    }
}
function $edd20167504aa060$var$$1dfb119a85e764e5$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes('-nu-')) {
        if (!locale.includes('-u-')) locale += '-u-';
        locale += `-nu-${numberingSystem}`;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($edd20167504aa060$var$$1dfb119a85e764e5$var$formatterCache.has(cacheKey)) return $edd20167504aa060$var$$1dfb119a85e764e5$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $edd20167504aa060$var$$1dfb119a85e764e5$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $edd20167504aa060$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === 'auto') return numberFormat.format(num);
    else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === 'exceptZero') {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
            if ([
                ...minus
            ].length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
            let positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

});

parcelRegister("gI8Gw", function(module, exports) {

$parcel$export(module.exports, "useLocalizedStringDictionary", () => $724ca42c7e68309e$export$87b761675e8eaa10);
$parcel$export(module.exports, "useLocalizedStringFormatter", () => $724ca42c7e68309e$export$f12b703ca79dfbb1);

var $1ntKq = parcelRequire("1ntKq");

var $4EK5Y = parcelRequire("4EK5Y");
var $aLZXd = parcelRequire("aLZXd");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $724ca42c7e68309e$var$$cf2482eff2eeeec2$var$cache = new WeakMap();
function $724ca42c7e68309e$var$$cf2482eff2eeeec2$var$getCachedDictionary(strings) {
    let dictionary = $724ca42c7e68309e$var$$cf2482eff2eeeec2$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $4EK5Y.LocalizedStringDictionary)(strings);
        $724ca42c7e68309e$var$$cf2482eff2eeeec2$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $724ca42c7e68309e$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $4EK5Y.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $724ca42c7e68309e$var$$cf2482eff2eeeec2$var$getCachedDictionary(strings);
}
function $724ca42c7e68309e$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let dictionary = $724ca42c7e68309e$export$87b761675e8eaa10(strings, packageName);
    return (0, $eF4cA.useMemo)(()=>new (0, $aLZXd.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}

});
parcelRegister("4EK5Y", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringDictionary", () => $8d455afc3cab690a$export$c17fa47878dc55b6);
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8d455afc3cab690a$var$$a747a10fe70a57da$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
const $8d455afc3cab690a$var$$a747a10fe70a57da$var$stringsSymbol = Symbol.for('react-aria.i18n.strings');
let $8d455afc3cab690a$var$$a747a10fe70a57da$var$cachedGlobalStrings = undefined;
class $8d455afc3cab690a$export$c17fa47878dc55b6 {
    constructor(messages, defaultLocale = 'en-US'){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $8d455afc3cab690a$var$$a747a10fe70a57da$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === 'undefined') return null;
        let locale = window[$8d455afc3cab690a$var$$a747a10fe70a57da$var$localeSymbol];
        if ($8d455afc3cab690a$var$$a747a10fe70a57da$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$8d455afc3cab690a$var$$a747a10fe70a57da$var$stringsSymbol];
            if (!globalStrings) return null;
            $8d455afc3cab690a$var$$a747a10fe70a57da$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$8d455afc3cab690a$var$$a747a10fe70a57da$var$cachedGlobalStrings[pkg] = new $8d455afc3cab690a$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $8d455afc3cab690a$var$$a747a10fe70a57da$var$cachedGlobalStrings?.[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
}
function $8d455afc3cab690a$var$$a747a10fe70a57da$var$getStringsForLocale(locale, strings, defaultLocale = 'en-US') {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $8d455afc3cab690a$var$$a747a10fe70a57da$var$getLanguage(locale);
    // If the locale has an explicit script (e.g. sr-Latn-RS), prefer a
    // language-script match (sr-Latn) over a language-only match (sr), since
    // those may represent entirely different scripts.
    let script = $8d455afc3cab690a$var$$a747a10fe70a57da$var$getScript(locale);
    if (script && strings[`${language}-${script}`]) return strings[`${language}-${script}`];
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + '-')) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $8d455afc3cab690a$var$$a747a10fe70a57da$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split('-')[0];
}
function $8d455afc3cab690a$var$$a747a10fe70a57da$var$getScript(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).script;
    return undefined;
}

});

parcelRegister("aLZXd", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringFormatter", () => $ee6fe8aac3dbd98a$export$2f817fcdc4b89ae0);
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ee6fe8aac3dbd98a$var$$b27c684a33948c64$var$pluralRulesCache = new Map();
const $ee6fe8aac3dbd98a$var$$b27c684a33948c64$var$numberFormatCache = new Map();
class $ee6fe8aac3dbd98a$export$2f817fcdc4b89ae0 {
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === 'function' ? message(variables, this) : message;
    }
    plural(count, options, type = 'cardinal') {
        let opt = options['=' + count];
        if (opt) return typeof opt === 'function' ? opt() : opt;
        let key = this.locale + ':' + type;
        let pluralRules = $ee6fe8aac3dbd98a$var$$b27c684a33948c64$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $ee6fe8aac3dbd98a$var$$b27c684a33948c64$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
    number(value) {
        let numberFormat = $ee6fe8aac3dbd98a$var$$b27c684a33948c64$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $ee6fe8aac3dbd98a$var$$b27c684a33948c64$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
}

});



parcelRegister("i93Vd", function(module, exports) {

$parcel$export(module.exports, "pressScale", () => $caa00e02f02b2ee1$export$56e8cba416805d8d);

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $caa00e02f02b2ee1$export$56e8cba416805d8d(ref, style) {
    return (0, $fDYaM.composeRenderProps)(style, (style, renderProps)=>{
        if (renderProps.isPressed && ref.current) {
            let { width: width = 0, height: height = 0 } = ref.current.getBoundingClientRect() ?? {};
            return {
                ...style,
                willChange: `${style?.willChange ?? ''} transform`,
                transform: `${style?.transform ?? ''} perspective(${Math.max(height, width / 3, 24)}px) translate3d(0, 0, -2px)`
            };
        } else return {
            ...style,
            willChange: `${style?.willChange ?? ''} transform`
        };
    });
}

});

parcelRegister("fZShI", function(module, exports) {

$parcel$export(module.exports, "ProgressCircle", () => $2519233ec363a58d$export$c79b9d6b4cc92af7);


var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $lrZgx = parcelRequire("lrZgx");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$pxToRemDynamic = (px)=>px / 16 + 'rem';
const $2519233ec363a58d$export$afffa1e5edf12209 = (0, $eF4cA.createContext)(null);
// Double check the types passed to each style, may not need all for each
const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let height = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "F") height = true;
        rules += p[0];
    }
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    if (props.size === "L") {
        if (!width) rules += ' ZG182';
    } else if (props.size === "S") {
        if (!width) rules += ' Zu182';
    } else if (!width) rules += ' ZC182';
    if (props.size === "L") {
        if (!height) rules += ' FA182';
    } else if (props.size === "S") {
        if (!height) rules += ' Ft182';
    } else if (!height) rules += ' Fx182';
    rules += ' fa182';
    return rules;
};
const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$track = function anonymous(props) {
    let rules = " ";
    if (props.isStaticColor) rules += ' Vd182';
    else rules += ' Vf182';
    rules += ' Vla182';
    if (props.size === "L") rules += ' _VuNalie182';
    else if (props.size === "S") rules += ' _V7m7Gv182';
    else rules += ' _Vwtfhvc182';
    if (props.size === "L") rules += ' _Vlwtfhvc182';
    else if (props.size === "S") rules += ' _Vlai5a0182';
    else rules += ' _Vl7m7Gv182';
    return rules;
};
const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$fill = function anonymous(props) {
    let rules = " ";
    if (props.isStaticColor) rules += ' Ve182';
    else rules += ' Vh182';
    rules += ' VlUG8Hlc182';
    rules += ' _Sa182';
    rules += ' _0d182';
    if (props.size === "L") rules += ' _VuNalie182';
    else if (props.size === "S") rules += ' _V7m7Gv182';
    else rules += ' _Vwtfhvc182';
    return rules;
};
const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$hcmStroke = function anonymous(props) {
    let rules = " ";
    rules += ' VRWHrbc182';
    rules += ' VlUG8Hlc182';
    if (props.size === "L") rules += ' _VuNalie182';
    else if (props.size === "S") rules += ' _V7m7Gv182';
    else rules += ' _Vwtfhvc182';
    return rules;
};
const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$rotationAnimation = "Z8Un9b";
// stroke-dashoffset represents `100 - percentage`. See below for how this works.
const $2519233ec363a58d$var$$41ddd91dbbf0c389$var$dashoffsetAnimation = "uw9JJd";
const $2519233ec363a58d$export$c79b9d6b4cc92af7 = (0, $eF4cA.forwardRef)(function ProgressCircle(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $2519233ec363a58d$export$afffa1e5edf12209);
    let { size: size = 'M', staticColor: staticColor, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let strokeWidth = 3;
    if (size === 'S') strokeWidth = 2;
    else if (size === 'L') strokeWidth = 4;
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let radius = `calc(50% - ${$2519233ec363a58d$var$$41ddd91dbbf0c389$var$pxToRemDynamic(strokeWidth / 2)})`;
    let isStaticColor = !!staticColor;
    return (0, $dx4lB.jsx)((0, $lrZgx.ProgressBar), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + $2519233ec363a58d$var$$41ddd91dbbf0c389$var$wrapper({
                ...renderProps,
                size: size,
                staticColor: staticColor
            }, props.styles),
        children: ({ percentage: percentage, isIndeterminate: isIndeterminate })=>(0, $dx4lB.jsxs)("svg", {
                fill: "none",
                width: "100%",
                height: "100%",
                style: {
                    display: 'block'
                },
                children: [
                    (0, $dx4lB.jsx)("circle", {
                        cx: "50%",
                        cy: "50%",
                        r: radius,
                        className: $2519233ec363a58d$var$$41ddd91dbbf0c389$var$hcmStroke({
                            size: size
                        })
                    }),
                    (0, $dx4lB.jsx)("circle", {
                        cx: "50%",
                        cy: "50%",
                        r: radius,
                        className: $2519233ec363a58d$var$$41ddd91dbbf0c389$var$track({
                            isStaticColor: isStaticColor,
                            size: size
                        })
                    }),
                    (0, $dx4lB.jsx)("circle", {
                        cx: "50%",
                        cy: "50%",
                        r: radius,
                        className: $2519233ec363a58d$var$$41ddd91dbbf0c389$var$fill({
                            isStaticColor: isStaticColor,
                            size: size
                        }),
                        style: {
                            // These cubic-bezier timing functions were derived from the previous animation keyframes
                            // using a best fit algorithm, and then manually adjusted to approximate the original animation.
                            animation: isIndeterminate ? `${$2519233ec363a58d$var$$41ddd91dbbf0c389$var$rotationAnimation} 1s cubic-bezier(.6, .1, .3, .9) infinite, ${$2519233ec363a58d$var$$41ddd91dbbf0c389$var$dashoffsetAnimation} 1s cubic-bezier(.25, .1, .25, 1.3) infinite` : undefined
                        },
                        // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                        pathLength: "100",
                        // Add extra gap between dashes so 0% works in Chrome.
                        strokeDasharray: "100 200",
                        strokeDashoffset: isIndeterminate || percentage == null ? undefined : 100 - percentage,
                        strokeLinecap: "round"
                    })
                ]
            })
    });
});

});
parcelRegister("lrZgx", function(module, exports) {

$parcel$export(module.exports, "ProgressBarContext", () => $86ca1fff96237a45$export$e9f3bf65a26ce129);
$parcel$export(module.exports, "ProgressBar", () => $86ca1fff96237a45$export$c17561cb55d4db30);

var $fDYaM = parcelRequire("fDYaM");

var $8UElq = parcelRequire("8UElq");

var $ekg5Y = parcelRequire("ekg5Y");

var $g8XbY = parcelRequire("g8XbY");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $86ca1fff96237a45$export$e9f3bf65a26ce129 = (0, $eF4cA.createContext)(null);
const $86ca1fff96237a45$export$c17561cb55d4db30 = (0, $eF4cA.forwardRef)(function ProgressBar(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $86ca1fff96237a45$export$e9f3bf65a26ce129);
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, isIndeterminate: isIndeterminate = false } = props;
    value = (0, $g8XbY.clamp)(value, minValue, maxValue);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { progressBarProps: progressBarProps, labelProps: labelProps } = (0, $ekg5Y.useProgressBar)({
        ...props,
        label: label
    });
    let range = maxValue - minValue;
    // Calculate the width of the progress bar as a percentage
    let percentage = undefined;
    if (!isIndeterminate) {
        if (range === 0) percentage = 0;
        else percentage = (value - minValue) / range * 100;
    }
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ProgressBar',
        values: {
            percentage: percentage,
            valueText: progressBarProps['aria-valuetext'],
            isIndeterminate: isIndeterminate
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, progressBarProps),
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8UElq.LabelContext).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: 'span'
        }
    }, renderProps.children));
});

});
parcelRegister("8UElq", function(module, exports) {

$parcel$export(module.exports, "LabelContext", () => $a08de43e76bb5e36$export$75b6ee27786ba447);
$parcel$export(module.exports, "Label", () => $a08de43e76bb5e36$export$b04be29aa201d4f5);

var $fDYaM = parcelRequire("fDYaM");

var $19ZgV = parcelRequire("19ZgV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a08de43e76bb5e36$export$75b6ee27786ba447 = (0, $eF4cA.createContext)({});
const $a08de43e76bb5e36$export$b04be29aa201d4f5 = (0, $19ZgV.createHideableComponent)(function Label(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $a08de43e76bb5e36$export$75b6ee27786ba447);
    let { elementType: elementType = 'label', ...labelProps } = props;
    let ElementType = (0, $fDYaM.dom)[elementType];
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        className: "react-aria-Label",
        ...labelProps,
        ref: ref
    });
});

});
parcelRegister("19ZgV", function(module, exports) {

$parcel$export(module.exports, "Hidden", () => $4d944846e6ce1698$export$8dc98ba7eadeaa56);
$parcel$export(module.exports, "createHideableComponent", () => $4d944846e6ce1698$export$86427a43e3e48ebb);
$parcel$export(module.exports, "useIsHidden", () => $4d944846e6ce1698$export$b5d7cc18bb8d2b59);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React doesn't understand the <template> element, which doesn't have children like a normal element.
// It will throw an error during hydration when it expects the firstChild to contain content rendered
// on the server, when in reality, the browser will have placed this inside the `content` document fragment.
// This monkey patches the firstChild property for our special hidden template elements to work around this error.
// does the same for appendChild/removeChild/insertBefore as per the issue below
// See https://github.com/facebook/react/issues/19932
if (typeof HTMLTemplateElement !== 'undefined') {
    Object.defineProperty(HTMLTemplateElement.prototype, 'firstChild', {
        configurable: true,
        enumerable: true,
        get: function() {
            return this.content.firstChild;
        }
    });
    Object.defineProperty(HTMLTemplateElement.prototype, 'appendChild', {
        configurable: true,
        enumerable: true,
        value: function(node) {
            return this.content.appendChild(node);
        }
    });
    Object.defineProperty(HTMLTemplateElement.prototype, 'removeChild', {
        configurable: true,
        enumerable: true,
        value: function(node) {
            return this.content.removeChild(node);
        }
    });
    Object.defineProperty(HTMLTemplateElement.prototype, 'insertBefore', {
        configurable: true,
        enumerable: true,
        value: function(node, child) {
            return this.content.insertBefore(node, child);
        }
    });
}
const $4d944846e6ce1698$export$94b6d0abf7d33e8c = (0, $eF4cA.createContext)(false);
function $4d944846e6ce1698$export$8dc98ba7eadeaa56(props) {
    let isHidden = (0, $eF4cA.useContext)($4d944846e6ce1698$export$94b6d0abf7d33e8c);
    if (isHidden) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, props.children);
    let children = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($4d944846e6ce1698$export$94b6d0abf7d33e8c.Provider, {
        value: true
    }, props.children);
    // In SSR, portals are not supported by React. Instead, always render into a <template>
    // element, which the browser will never display to the user. In addition, the
    // content is not part of the accessible DOM tree, so it won't affect ids or other accessibility attributes.
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("template", null, children);
}
function $4d944846e6ce1698$export$86427a43e3e48ebb(fn) {
    let Wrapper = (props, ref)=>{
        let isHidden = (0, $eF4cA.useContext)($4d944846e6ce1698$export$94b6d0abf7d33e8c);
        if (isHidden) return null;
        // oxlint-disable-next-line react/react-compiler
        return fn(props, ref);
    };
    // @ts-ignore - for react dev tools
    Wrapper.displayName = fn.displayName || fn.name;
    return (0, $eF4cA.forwardRef)(Wrapper);
}
function $4d944846e6ce1698$export$b5d7cc18bb8d2b59() {
    return (0, $eF4cA.useContext)($4d944846e6ce1698$export$94b6d0abf7d33e8c);
}

});


parcelRegister("ekg5Y", function(module, exports) {

$parcel$export(module.exports, "useProgressBar", () => $52a4f36175040abb$export$ed5abd763a836edc);

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $jrZXQ = parcelRequire("jrZXQ");

var $e62p6 = parcelRequire("e62p6");

var $g8XbY = parcelRequire("g8XbY");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $52a4f36175040abb$export$ed5abd763a836edc(props) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, valueLabel: valueLabel, isIndeterminate: isIndeterminate, formatOptions: formatOptions = {
        style: 'percent'
    } } = props;
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $jrZXQ.useLabel)({
        ...props,
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    value = (0, $g8XbY.clamp)(value, minValue, maxValue);
    let range = maxValue - minValue;
    let percentage = range === 0 ? 0 : (value - minValue) / range;
    let formatter = (0, $e62p6.useNumberFormatter)(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        let valueToFormat = formatOptions.style === 'percent' ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: (0, $lhKAD.mergeProps)(domProps, {
            ...fieldProps,
            'aria-valuenow': isIndeterminate ? undefined : value,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-valuetext': isIndeterminate ? undefined : valueLabel,
            role: 'progressbar'
        }),
        labelProps: labelProps
    };
}

});
parcelRegister("jrZXQ", function(module, exports) {

$parcel$export(module.exports, "useLabel", () => $ab9edfc79598cf7b$export$8467354a121f1b9f);

var $25dFS = parcelRequire("25dFS");

var $dkaC0 = parcelRequire("dkaC0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ab9edfc79598cf7b$export$8467354a121f1b9f(props) {
    let { id: id, label: label, 'aria-labelledby': ariaLabelledby, 'aria-label': ariaLabel, labelElementType: labelElementType = 'label' } = props;
    id = (0, $25dFS.useId)(id);
    let labelId = (0, $25dFS.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else !ariaLabelledby && ariaLabel;
    let fieldProps = (0, $dkaC0.useLabels)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}

});
parcelRegister("dkaC0", function(module, exports) {

$parcel$export(module.exports, "useLabels", () => $8db1d854affa0d17$export$d6875122194c7b44);

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8db1d854affa0d17$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, 'aria-label': label, 'aria-labelledby': labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $25dFS.useId)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}

});


parcelRegister("e62p6", function(module, exports) {

$parcel$export(module.exports, "useNumberFormatter", () => $66615a4e46944147$export$b7a616150fdb9f44);

var $1ntKq = parcelRequire("1ntKq");

var $l3v5Z = parcelRequire("l3v5Z");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $66615a4e46944147$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    return (0, $eF4cA.useMemo)(()=>new (0, $l3v5Z.NumberFormatter)(locale, options), [
        locale,
        options
    ]);
}

});

parcelRegister("g8XbY", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $c5a0cdf07754d561$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "snapValueToStep", () => $c5a0cdf07754d561$export$cb6e0bb50bc19463);
$parcel$export(module.exports, "toFixedNumber", () => $c5a0cdf07754d561$export$b6268554fba451f);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest
 * valid step.
 */ function $c5a0cdf07754d561$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $c5a0cdf07754d561$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let precision = 0;
    let stepString = step.toString();
    // Handle negative exponents in exponential notation (e.g., "1e-7" → precision 8)
    let eIndex = stepString.toLowerCase().indexOf('e-');
    if (eIndex > 0) precision = Math.abs(Math.floor(Math.log10(Math.abs(step)))) + eIndex;
    else {
        let pointIndex = stepString.indexOf('.');
        if (pointIndex >= 0) precision = stepString.length - pointIndex;
    }
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $c5a0cdf07754d561$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $c5a0cdf07754d561$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($c5a0cdf07754d561$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($c5a0cdf07754d561$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $c5a0cdf07754d561$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $c5a0cdf07754d561$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});




parcelRegister("208Op", function(module, exports) {

$parcel$export(module.exports, "HeadingContext", () => $211efeed9ba8085c$export$d688439359537581);
$parcel$export(module.exports, "Heading", () => $211efeed9ba8085c$export$a8a3e93435678ff9);
$parcel$export(module.exports, "HeaderContext", () => $211efeed9ba8085c$export$e0e4026c12a8bdbb);
$parcel$export(module.exports, "Header", () => $211efeed9ba8085c$export$8b251419efc915eb);
$parcel$export(module.exports, "ContentContext", () => $211efeed9ba8085c$export$1cbdd774077931b4);
$parcel$export(module.exports, "Content", () => $211efeed9ba8085c$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "TextContext", () => $211efeed9ba8085c$export$9afb8bc826b033ea);
$parcel$export(module.exports, "Text", () => $211efeed9ba8085c$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "KeyboardContext", () => $211efeed9ba8085c$export$744d98a3b8a94e1c);
$parcel$export(module.exports, "Keyboard", () => $211efeed9ba8085c$export$16e4d70cc375e707);
$parcel$export(module.exports, "FooterContext", () => $211efeed9ba8085c$export$5630640b68817ed6);
$parcel$export(module.exports, "Footer", () => $211efeed9ba8085c$export$a06f1c675e846f6f);

var $3PqDc = parcelRequire("3PqDc");

var $91SAk = parcelRequire("91SAk");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $gF3YT = parcelRequire("gF3YT");

var $2AolA = parcelRequire("2AolA");

var $1etmN = parcelRequire("1etmN");

var $1O9kP = parcelRequire("1O9kP");

var $c1ibQ = parcelRequire("c1ibQ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $211efeed9ba8085c$export$d688439359537581 = (0, $eF4cA.createContext)(null);
const $211efeed9ba8085c$export$a8a3e93435678ff9 = (0, $eF4cA.forwardRef)(function Heading(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $211efeed9ba8085c$export$d688439359537581);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles = '', isHidden: isHidden, slot: slot, ...otherProps } = props;
    if (isHidden) return null;
    return (0, $dx4lB.jsx)((0, $1O9kP.Heading), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
});
const $211efeed9ba8085c$export$e0e4026c12a8bdbb = (0, $eF4cA.createContext)(null);
const $211efeed9ba8085c$export$8b251419efc915eb = (0, $eF4cA.forwardRef)(function Header(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $211efeed9ba8085c$export$e0e4026c12a8bdbb);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles = '', isHidden: isHidden, slot: slot, ...otherProps } = props;
    if (isHidden) return null;
    return (0, $dx4lB.jsx)((0, $1etmN.Header), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
});
const $211efeed9ba8085c$export$1cbdd774077931b4 = (0, $eF4cA.createContext)(null);
const $211efeed9ba8085c$export$7c6e2c02157bb7d2 = (0, $eF4cA.forwardRef)(function Content(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $211efeed9ba8085c$export$1cbdd774077931b4);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles = '', isHidden: isHidden, slot: slot, ...otherProps } = props;
    if (isHidden) return null;
    return (0, $dx4lB.jsx)("div", {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
});
const $211efeed9ba8085c$export$9afb8bc826b033ea = (0, $eF4cA.createContext)(null);
const $211efeed9ba8085c$export$5f1af8db9871e1d6 = (0, $eF4cA.forwardRef)(function Text(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $211efeed9ba8085c$export$9afb8bc826b033ea);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles = '', isHidden: isHidden, slot: slot, children: children, ...otherProps } = props;
    let racContext = (0, $eF4cA.useContext)((0, $c1ibQ.TextContext));
    let isSkeleton = (0, $91SAk.useIsSkeleton)();
    [children, UNSAFE_style] = (0, $91SAk.useSkeletonText)(children, UNSAFE_style);
    if (isHidden) return null;
    let text = (0, $dx4lB.jsx)((0, $c1ibQ.Text), {
        ...otherProps,
        ref: domRef,
        // @ts-ignore - compatibility with React < 19
        inert: (0, $gF3YT.inertValue)(isSkeleton),
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined,
        "data-rsp-slot": "text",
        children: children
    });
    if (slot && racContext && 'slots' in racContext && !racContext.slots?.[slot]) return (0, $dx4lB.jsx)((0, $c1ibQ.TextContext).Provider, {
        value: null,
        children: text
    });
    return text;
});
const $211efeed9ba8085c$export$744d98a3b8a94e1c = (0, $eF4cA.createContext)({});
const $211efeed9ba8085c$export$16e4d70cc375e707 = (0, $eF4cA.forwardRef)(function Keyboard(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $211efeed9ba8085c$export$744d98a3b8a94e1c);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles = '', isHidden: isHidden, slot: slot, ...otherProps } = props;
    if (isHidden) return null;
    return (0, $dx4lB.jsx)((0, $2AolA.Keyboard), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
});
const $211efeed9ba8085c$export$5630640b68817ed6 = (0, $eF4cA.createContext)({});
const $211efeed9ba8085c$export$a06f1c675e846f6f = (0, $eF4cA.forwardRef)(function Footer(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $211efeed9ba8085c$export$5630640b68817ed6);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles = '', isHidden: isHidden, slot: slot, ...otherProps } = props;
    if (isHidden) return null;
    return (0, $dx4lB.jsx)("footer", {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
});

});
parcelRegister("2AolA", function(module, exports) {

$parcel$export(module.exports, "KeyboardContext", () => $1a2400fdef4a1743$export$744d98a3b8a94e1c);
$parcel$export(module.exports, "Keyboard", () => $1a2400fdef4a1743$export$16e4d70cc375e707);

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1a2400fdef4a1743$export$744d98a3b8a94e1c = (0, $eF4cA.createContext)({});
const $1a2400fdef4a1743$export$16e4d70cc375e707 = (0, $eF4cA.forwardRef)(function Keyboard(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $1a2400fdef4a1743$export$744d98a3b8a94e1c);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).kbd, {
        dir: "ltr",
        ...props,
        ref: ref
    });
});

});

parcelRegister("1etmN", function(module, exports) {

$parcel$export(module.exports, "HeaderContext", () => $dbe7e207ae3fcb00$export$e0e4026c12a8bdbb);
$parcel$export(module.exports, "Header", () => $dbe7e207ae3fcb00$export$8b251419efc915eb);

var $fDYaM = parcelRequire("fDYaM");

var $3g2oV = parcelRequire("3g2oV");

var $bWhaY = parcelRequire("bWhaY");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dbe7e207ae3fcb00$export$e0e4026c12a8bdbb = (0, $eF4cA.createContext)({});
const $dbe7e207ae3fcb00$export$8b251419efc915eb = (0, $3g2oV.createLeafComponent)((0, $bWhaY.HeaderNode), function Header(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $dbe7e207ae3fcb00$export$e0e4026c12a8bdbb);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).header, {
        className: "react-aria-Header",
        ...props,
        ref: ref
    }, props.children);
});

});
parcelRegister("3g2oV", function(module, exports) {

$parcel$export(module.exports, "CollectionBuilder", () => $7686cfbbdcef2323$export$bf788dd355e3a401);
$parcel$export(module.exports, "createLeafComponent", () => $7686cfbbdcef2323$export$18af5c7a9e9b3664);
$parcel$export(module.exports, "createBranchComponent", () => $7686cfbbdcef2323$export$e953bb1cd0f19726);
$parcel$export(module.exports, "Collection", () => $7686cfbbdcef2323$export$fb8073518f34e6ec);

var $bWhaY = parcelRequire("bWhaY");

var $ladWL = parcelRequire("ladWL");

var $1kw8g = parcelRequire("1kw8g");

var $8M8Qw = parcelRequire("8M8Qw");

var $19ZgV = parcelRequire("19ZgV");

var $hWe38 = parcelRequire("hWe38");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");

var $5LhCr = parcelRequire("5LhCr");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$ShallowRenderContext = (0, $eF4cA.createContext)(false);
const $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionDocumentContext = (0, $eF4cA.createContext)(null);
function $7686cfbbdcef2323$export$bf788dd355e3a401(props) {
    // If a document was provided above us, we're already in a hidden tree. Just render the content.
    let doc = (0, $eF4cA.useContext)($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionDocumentContext);
    if (doc) // even though the actual implementation since React 16 did.
    // We must return ReactElement so that TS does not complain that <CollectionBuilder>
    // is not a valid JSX element with React 16 and 17 types.
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return props.content;
    // Otherwise, render a hidden copy of the children so that we can build the collection before constructing the state.
    // This should always come before the real DOM content so we have built the collection by the time it renders during SSR.
    // This is fine. CollectionDocumentContext never changes after mounting.
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    let { collection: collection, document: document } = $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useCollectionDocument(props.createCollection);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $19ZgV.Hidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionDocumentContext.Provider, {
        value: document
    }, props.content)), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionInner, {
        render: props.children,
        collection: collection
    }));
}
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionInner({ collection: collection, render: render }) {
    return render(collection);
}
// React 16 and 17 don't support useSyncExternalStore natively, and the shim provided by React does not support getServerSnapshot.
// This wrapper uses the shim, but additionally calls getServerSnapshot during SSR (according to SSRProvider).
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSyncExternalStoreFallback(subscribe, getSnapshot, getServerSnapshot) {
    let isSSR = (0, $hWe38.useIsSSR)();
    let isSSRRef = (0, $eF4cA.useRef)(isSSR);
    // This is read immediately inside the wrapper, which also runs during render.
    // We just need a ref to avoid invalidating the callback itself, which
    // would cause React to re-run the callback more than necessary.
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    isSSRRef.current = isSSR;
    let getSnapshotWrapper = (0, $eF4cA.useCallback)(()=>{
        return isSSRRef.current ? getServerSnapshot() : getSnapshot();
    }, [
        getSnapshot,
        getServerSnapshot
    ]);
    return (0, $5LhCr.useSyncExternalStore)(subscribe, getSnapshotWrapper);
}
const $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSyncExternalStore = typeof (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useSyncExternalStore'] === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useSyncExternalStore'] : $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSyncExternalStoreFallback;
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useCollectionDocument(createCollection) {
    // The document instance is mutable, and should never change between renders.
    // useSyncExternalStore is used to subscribe to updates, which vends immutable Collection objects.
    let [document] = (0, $eF4cA.useState)(()=>new (0, $ladWL.Document)(createCollection?.() || new (0, $bWhaY.BaseCollection)()));
    let subscribe = (0, $eF4cA.useCallback)((fn)=>document.subscribe(fn), [
        document
    ]);
    let getSnapshot = (0, $eF4cA.useCallback)(()=>{
        let collection = document.getCollection();
        if (document.isSSR) // We do this _after_ getting the collection above so that the collection still has content in it from SSR
        // during the current render, before React has finished the client render.
        document.resetAfterSSR();
        return collection;
    }, [
        document
    ]);
    let getServerSnapshot = (0, $eF4cA.useCallback)(()=>{
        // oxlint-disable-next-line react/react-compiler
        document.isSSR = true;
        return document.getCollection();
    }, [
        document
    ]);
    let collection = $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return {
        collection: collection,
        document: document
    };
}
const $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$SSRContext = (0, $eF4cA.createContext)(null);
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$createCollectionNodeClass(type) {
    let NodeClass = class extends (0, $bWhaY.CollectionNode) {
        static{
            this.type = type;
        }
    };
    return NodeClass;
}
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSSRCollectionNode(CollectionNodeClass, props, ref, rendered, children, render) {
    // To prevent breaking change, if CollectionNodeClass is a string, create a CollectionNodeClass using the string as the type
    if (typeof CollectionNodeClass === 'string') CollectionNodeClass = $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$createCollectionNodeClass(CollectionNodeClass);
    // During SSR, portals are not supported, so the collection children will be wrapped in an SSRContext.
    // Since SSR occurs only once, we assume that the elements are rendered in order and never re-render.
    // Therefore we can create elements in our collection document during render so that they are in the
    // collection by the time we need to use the collection to render to the real DOM.
    // After hydration, we switch to client rendering using the portal.
    let itemRef = (0, $eF4cA.useCallback)((element)=>{
        element?.setProps(props, ref, CollectionNodeClass, rendered, render);
    }, [
        props,
        ref,
        rendered,
        render,
        CollectionNodeClass
    ]);
    let parentNode = (0, $eF4cA.useContext)($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$SSRContext);
    if (parentNode) {
        // Guard against double rendering in strict mode.
        let element = parentNode.ownerDocument.nodesByProps.get(props);
        if (!element) {
            element = parentNode.ownerDocument.createElement(CollectionNodeClass.type);
            element.setProps(props, ref, CollectionNodeClass, rendered, render);
            parentNode.appendChild(element);
            parentNode.ownerDocument.updateCollection();
            parentNode.ownerDocument.nodesByProps.set(props, element);
        }
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$SSRContext.Provider, {
            value: element
        }, children) : null;
    }
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionNodeClass.type, {
        ref: itemRef
    }, children);
}
function $7686cfbbdcef2323$export$18af5c7a9e9b3664(CollectionNodeClass, render) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $eF4cA.forwardRef)((props, ref)=>{
        let focusableProps = (0, $eF4cA.useContext)((0, $8M8Qw.FocusableContext));
        let isShallow = (0, $eF4cA.useContext)($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$ShallowRenderContext);
        if (!isShallow) {
            if (render.length >= 3) throw new Error(render.name + ' cannot be rendered outside a collection.');
            return render(props, ref);
        }
        return $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSSRCollectionNode(CollectionNodeClass, props, ref, 'children' in props ? props.children : null, null, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8M8Qw.FocusableContext).Provider, {
                value: focusableProps
            }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(Component, {
                node: node
            })));
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $7686cfbbdcef2323$export$e953bb1cd0f19726(CollectionNodeClass, render, useChildren = $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useCollectionChildren) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $eF4cA.forwardRef)((props, ref)=>{
        let children = useChildren(props);
        return $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useSSRCollectionNode(CollectionNodeClass, props, ref, null, children, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(Component, {
                node: node
            })) ?? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null);
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useCollectionChildren(options) {
    return (0, $1kw8g.useCachedChildren)({
        ...options,
        addIdAndValue: true
    });
}
const $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionContext = (0, $eF4cA.createContext)(null);
function $7686cfbbdcef2323$export$fb8073518f34e6ec(props) {
    let ctx = (0, $eF4cA.useContext)($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionContext);
    let dependencies = (ctx?.dependencies || []).concat(props.dependencies);
    let idScope = props.idScope ?? ctx?.idScope;
    let children = $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$useCollectionChildren({
        ...props,
        idScope: idScope,
        dependencies: dependencies
    });
    let doc = (0, $eF4cA.useContext)($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionDocumentContext);
    if (doc) children = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionRoot, null, children);
    // Propagate dependencies and idScope to child collections.
    ctx = (0, $eF4cA.useMemo)(()=>({
            dependencies: dependencies,
            idScope: idScope
        }), // oxlint-disable-next-line react/react-compiler, react-hooks/exhaustive-deps
    [
        idScope,
        ...dependencies
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionContext.Provider, {
        value: ctx
    }, children);
}
function $7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionRoot({ children: children }) {
    let doc = (0, $eF4cA.useContext)($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionDocumentContext);
    let wrappedChildren = (0, $eF4cA.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$CollectionDocumentContext.Provider, {
            value: null
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$ShallowRenderContext.Provider, {
            value: true
        }, children)), [
        children
    ]);
    // During SSR, we render the content directly, and append nodes to the document during render.
    // The collection children return null so that nothing is actually rendered into the HTML.
    return (0, $hWe38.useIsSSR)() ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7686cfbbdcef2323$var$$42ceafc619f9c3ba$var$SSRContext.Provider, {
        value: doc
    }, wrappedChildren) : (0, $l19Vn.createPortal)(wrappedChildren, doc);
}

});
parcelRegister("bWhaY", function(module, exports) {

$parcel$export(module.exports, "CollectionNode", () => $2b0fa7b7a7374834$export$d68d59712b04d9d1);
$parcel$export(module.exports, "FilterableNode", () => $2b0fa7b7a7374834$export$b1918e978f1ee46f);
$parcel$export(module.exports, "HeaderNode", () => $2b0fa7b7a7374834$export$5ae2504e948afce5);
$parcel$export(module.exports, "LoaderNode", () => $2b0fa7b7a7374834$export$8258a0665a675899);
$parcel$export(module.exports, "ItemNode", () => $2b0fa7b7a7374834$export$fd11f34e1d07f134);
$parcel$export(module.exports, "SectionNode", () => $2b0fa7b7a7374834$export$437f11dc9b403b78);
$parcel$export(module.exports, "BaseCollection", () => $2b0fa7b7a7374834$export$408d25a4e12db025);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $2b0fa7b7a7374834$export$d68d59712b04d9d1 {
    constructor(key){
        this.value = null;
        this.level = 0;
        this.hasChildNodes = false;
        this.rendered = null;
        this.textValue = '';
        this['aria-label'] = undefined;
        this.index = 0;
        this.parentKey = null;
        this.prevKey = null;
        this.nextKey = null;
        this.firstChildKey = null;
        this.lastChildKey = null;
        this.props = {};
        this.colSpan = null;
        this.colIndex = null;
        this.type = this.constructor.type;
        this.key = key;
    }
    get childNodes() {
        throw new Error('childNodes is not supported');
    }
    clone() {
        let node = new this.constructor(this.key);
        node.value = this.value;
        node.level = this.level;
        node.hasChildNodes = this.hasChildNodes;
        node.rendered = this.rendered;
        node.textValue = this.textValue;
        node['aria-label'] = this['aria-label'];
        node.index = this.index;
        node.parentKey = this.parentKey;
        node.prevKey = this.prevKey;
        node.nextKey = this.nextKey;
        node.firstChildKey = this.firstChildKey;
        node.lastChildKey = this.lastChildKey;
        node.props = this.props;
        node.render = this.render;
        node.colSpan = this.colSpan;
        node.colIndex = this.colIndex;
        return node;
    }
    filter(collection, newCollection, filterFn) {
        let clone = this.clone();
        newCollection.addDescendants(clone, collection);
        return clone;
    }
}
class $2b0fa7b7a7374834$export$b1918e978f1ee46f extends $2b0fa7b7a7374834$export$d68d59712b04d9d1 {
    filter(collection, newCollection, filterFn) {
        let [firstKey, lastKey] = $2b0fa7b7a7374834$var$$6f0c29017aeec335$var$filterChildren(collection, newCollection, this.firstChildKey, filterFn);
        let newNode = this.clone();
        newNode.firstChildKey = firstKey;
        newNode.lastChildKey = lastKey;
        return newNode;
    }
}
class $2b0fa7b7a7374834$export$5ae2504e948afce5 extends $2b0fa7b7a7374834$export$d68d59712b04d9d1 {
    static{
        this.type = 'header';
    }
}
class $2b0fa7b7a7374834$export$8258a0665a675899 extends $2b0fa7b7a7374834$export$d68d59712b04d9d1 {
    static{
        this.type = 'loader';
    }
}
class $2b0fa7b7a7374834$export$fd11f34e1d07f134 extends $2b0fa7b7a7374834$export$b1918e978f1ee46f {
    static{
        this.type = 'item';
    }
    filter(collection, newCollection, filterFn) {
        if (filterFn(this.textValue, this)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
class $2b0fa7b7a7374834$export$437f11dc9b403b78 extends $2b0fa7b7a7374834$export$b1918e978f1ee46f {
    static{
        this.type = 'section';
    }
    filter(collection, newCollection, filterFn) {
        let filteredSection = super.filter(collection, newCollection, filterFn);
        if (filteredSection) {
            if (filteredSection.lastChildKey !== null) {
                let lastChild = collection.getItem(filteredSection.lastChildKey);
                if (lastChild && lastChild.type !== 'header') return filteredSection;
            }
        }
        return null;
    }
}
class $2b0fa7b7a7374834$export$408d25a4e12db025 {
    get size() {
        return this.itemCount;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    *[Symbol.iterator]() {
        let node = this.firstKey != null ? this.keyMap.get(this.firstKey) : undefined;
        while(node){
            yield node;
            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : undefined;
        }
    }
    getChildren(key) {
        let keyMap = this.keyMap;
        return {
            *[Symbol.iterator] () {
                let parent = keyMap.get(key);
                let node = parent?.firstChildKey != null ? keyMap.get(parent.firstChildKey) : null;
                while(node){
                    yield node;
                    node = node.nextKey != null ? keyMap.get(node.nextKey) : undefined;
                }
            }
        };
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.prevKey != null) {
            node = this.keyMap.get(node.prevKey);
            while(node && node.type !== 'item' && node.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
            return node?.key ?? null;
        }
        return node.parentKey;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.type !== 'item' && node.firstChildKey != null) return node.firstChildKey;
        while(node){
            if (node.nextKey != null) return node.nextKey;
            if (node.parentKey != null) node = this.keyMap.get(node.parentKey);
            else return null;
        }
        return null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        let node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
        while(node?.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
        return node?.key ?? null;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at() {
        throw new Error('Not implemented');
    }
    clone() {
        // We need to clone using this.constructor so that subclasses have the right prototype.
        // TypeScript isn't happy about this yet.
        // https://github.com/microsoft/TypeScript/issues/3841
        let Constructor = this.constructor;
        let collection = new Constructor();
        collection.keyMap = new Map(this.keyMap);
        collection.firstKey = this.firstKey;
        collection.lastKey = this.lastKey;
        collection.itemCount = this.itemCount;
        return collection;
    }
    addNode(node) {
        if (this.frozen) throw new Error('Cannot add a node to a frozen collection');
        if (node.type === 'item' && this.keyMap.get(node.key) == null) this.itemCount++;
        this.keyMap.set(node.key, node);
    }
    // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
    addDescendants(node, oldCollection) {
        this.addNode(node);
        let children = oldCollection.getChildren(node.key);
        for (let child of children)this.addDescendants(child, oldCollection);
    }
    removeNode(key) {
        if (this.frozen) throw new Error('Cannot remove a node to a frozen collection');
        let node = this.keyMap.get(key);
        if (node != null && node.type === 'item') this.itemCount--;
        this.keyMap.delete(key);
    }
    commit(firstKey, lastKey, isSSR = false) {
        if (this.frozen) throw new Error('Cannot commit a frozen collection');
        this.firstKey = firstKey;
        this.lastKey = lastKey;
        this.frozen = !isSSR;
    }
    filter(filterFn) {
        let newCollection = new this.constructor();
        let [firstKey, lastKey] = $2b0fa7b7a7374834$var$$6f0c29017aeec335$var$filterChildren(this, newCollection, this.firstKey, filterFn);
        newCollection?.commit(firstKey, lastKey);
        return newCollection;
    }
    constructor(){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.frozen = false;
        this.itemCount = 0;
    }
}
function $2b0fa7b7a7374834$var$$6f0c29017aeec335$var$filterChildren(collection, newCollection, firstChildKey, filterFn) {
    // loop over the siblings for firstChildKey
    // create new nodes based on calling node.filter for each child
    // if it returns null then don't include it, otherwise update its prev/next keys
    // add them to the newCollection
    if (firstChildKey == null) return [
        null,
        null
    ];
    let firstNode = null;
    let lastNode = null;
    let currentNode = collection.getItem(firstChildKey);
    while(currentNode != null){
        let newNode = currentNode.filter(collection, newCollection, filterFn);
        if (newNode != null) {
            newNode.nextKey = null;
            if (lastNode) {
                newNode.prevKey = lastNode.key;
                lastNode.nextKey = newNode.key;
            }
            if (firstNode == null) firstNode = newNode;
            newCollection.addNode(newNode);
            lastNode = newNode;
        }
        currentNode = currentNode.nextKey != null ? collection.getItem(currentNode.nextKey) : null;
    }
    // TODO: this is pretty specific to dividers but doesn't feel like there is a good way to get around it since we only can know
    // to filter the last separator in a collection only after performing a filter for the rest of the contents after it
    // Its gross that it needs to live here, might be nice if somehow we could have this live in the separator code
    if (lastNode && lastNode.type === 'separator') {
        let prevKey = lastNode.prevKey;
        newCollection.removeNode(lastNode.key);
        if (prevKey != null) {
            lastNode = newCollection.getItem(prevKey);
            lastNode.nextKey = null;
        } else lastNode = null;
    }
    return [
        firstNode?.key ?? null,
        lastNode?.key ?? null
    ];
}

});

parcelRegister("ladWL", function(module, exports) {

$parcel$export(module.exports, "Document", () => $9f23298218d85439$export$b34a105447964f9f);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $9f23298218d85439$export$410b0c854570d131 {
    constructor(ownerDocument){
        this._firstChild = null;
        this._lastChild = null;
        this._previousSibling = null;
        this._nextSibling = null;
        this._parentNode = null;
        this._minInvalidChildIndex = null;
        this.ownerDocument = ownerDocument;
    }
    *[Symbol.iterator]() {
        let node = this.firstChild;
        while(node){
            yield node;
            node = node.nextSibling;
        }
    }
    get firstChild() {
        return this._firstChild;
    }
    set firstChild(firstChild) {
        this._firstChild = firstChild;
        this.ownerDocument.markDirty(this);
    }
    get lastChild() {
        return this._lastChild;
    }
    set lastChild(lastChild) {
        this._lastChild = lastChild;
        this.ownerDocument.markDirty(this);
    }
    get previousSibling() {
        return this._previousSibling;
    }
    set previousSibling(previousSibling) {
        this._previousSibling = previousSibling;
        this.ownerDocument.markDirty(this);
    }
    get nextSibling() {
        return this._nextSibling;
    }
    set nextSibling(nextSibling) {
        this._nextSibling = nextSibling;
        this.ownerDocument.markDirty(this);
    }
    get parentNode() {
        return this._parentNode;
    }
    set parentNode(parentNode) {
        this._parentNode = parentNode;
        this.ownerDocument.markDirty(this);
    }
    get isConnected() {
        return this.parentNode?.isConnected || false;
    }
    invalidateChildIndices(child) {
        if (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || child.index < this._minInvalidChildIndex.index) {
            this._minInvalidChildIndex = child;
            this.ownerDocument.markDirty(this);
        }
    }
    updateChildIndices() {
        let node = this._minInvalidChildIndex;
        while(node){
            node.index = node.previousSibling ? node.previousSibling.index + 1 : 0;
            node = node.nextSibling;
        }
        this._minInvalidChildIndex = null;
    }
    appendChild(child) {
        if (child.parentNode) child.parentNode.removeChild(child);
        if (this.firstChild == null) this.firstChild = child;
        if (this.lastChild) {
            this.lastChild.nextSibling = child;
            child.index = this.lastChild.index + 1;
            child.previousSibling = this.lastChild;
        } else {
            child.previousSibling = null;
            child.index = 0;
        }
        child.parentNode = this;
        child.nextSibling = null;
        this.lastChild = child;
        this.ownerDocument.markDirty(this);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    insertBefore(newNode, referenceNode) {
        if (referenceNode == null) return this.appendChild(newNode);
        if (newNode.parentNode) newNode.parentNode.removeChild(newNode);
        newNode.nextSibling = referenceNode;
        newNode.previousSibling = referenceNode.previousSibling;
        // Ensure that the newNode's index is less than that of the reference node so that
        // invalidateChildIndices will properly use the newNode as the _minInvalidChildIndex, thus making sure
        // we will properly update the indexes of all sibiling nodes after the newNode. The value here doesn't matter
        // since updateChildIndices should calculate the proper indexes.
        newNode.index = referenceNode.index - 1;
        if (this.firstChild === referenceNode) this.firstChild = newNode;
        else if (referenceNode.previousSibling) referenceNode.previousSibling.nextSibling = newNode;
        referenceNode.previousSibling = newNode;
        newNode.parentNode = referenceNode.parentNode;
        this.invalidateChildIndices(newNode);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    removeChild(child) {
        if (child.parentNode !== this) return;
        if (this._minInvalidChildIndex === child) this._minInvalidChildIndex = null;
        if (child.nextSibling) {
            this.invalidateChildIndices(child.nextSibling);
            child.nextSibling.previousSibling = child.previousSibling;
        }
        if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
        if (this.firstChild === child) this.firstChild = child.nextSibling;
        if (this.lastChild === child) this.lastChild = child.previousSibling;
        child.parentNode = null;
        child.nextSibling = null;
        child.previousSibling = null;
        child.index = 0;
        this.ownerDocument.markDirty(child);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    addEventListener() {}
    removeEventListener() {}
    get previousVisibleSibling() {
        let node = this.previousSibling;
        while(node && node.isHidden)node = node.previousSibling;
        return node;
    }
    get nextVisibleSibling() {
        let node = this.nextSibling;
        while(node && node.isHidden)node = node.nextSibling;
        return node;
    }
    get firstVisibleChild() {
        let node = this.firstChild;
        while(node && node.isHidden)node = node.nextSibling;
        return node;
    }
    get lastVisibleChild() {
        let node = this.lastChild;
        while(node && node.isHidden)node = node.previousSibling;
        return node;
    }
}
class $9f23298218d85439$export$dc064fe9e59310fd extends $9f23298218d85439$export$410b0c854570d131 {
    constructor(type, ownerDocument){
        super(ownerDocument), this.nodeType = 8 // COMMENT_NODE (we'd use ELEMENT_NODE but React DevTools will fail to get its dimensions)
        , this.isMutated = true, this._index = 0, this.isHidden = false;
        this.node = null;
    }
    get index() {
        return this._index;
    }
    set index(index) {
        this._index = index;
        this.ownerDocument.markDirty(this);
    }
    get level() {
        if (this.parentNode instanceof $9f23298218d85439$export$dc064fe9e59310fd) return this.parentNode.level + (this.parentNode.node?.type === 'item' ? 1 : 0);
        return 0;
    }
    /**
   * Lazily gets a mutable instance of a Node. If the node has already
   * been cloned during this update cycle, it just returns the existing one.
   */ getMutableNode() {
        if (this.node == null) return null;
        if (!this.isMutated) {
            this.node = this.node.clone();
            this.isMutated = true;
        }
        this.ownerDocument.markDirty(this);
        return this.node;
    }
    updateNode() {
        let nextSibling = this.nextVisibleSibling;
        let node = this.getMutableNode();
        if (node == null) return;
        node.index = this.index;
        node.level = this.level;
        node.parentKey = this.parentNode instanceof $9f23298218d85439$export$dc064fe9e59310fd ? this.parentNode.node?.key ?? null : null;
        node.prevKey = this.previousVisibleSibling?.node?.key ?? null;
        node.nextKey = nextSibling?.node?.key ?? null;
        node.hasChildNodes = !!this.firstChild;
        node.firstChildKey = this.firstVisibleChild?.node?.key ?? null;
        node.lastChildKey = this.lastVisibleChild?.node?.key ?? null;
        // Update the colIndex of sibling nodes if this node has a colSpan.
        if ((node.colSpan != null || node.colIndex != null) && nextSibling) {
            // This queues the next sibling for update, which means this happens recursively.
            let nextColIndex = (node.colIndex ?? node.index) + (node.colSpan ?? 1);
            if (nextSibling.node != null && nextColIndex !== nextSibling.node.colIndex) {
                let siblingNode = nextSibling.getMutableNode();
                siblingNode.colIndex = nextColIndex;
            }
        }
    }
    setProps(obj, ref, CollectionNodeClass, rendered, render) {
        let node;
        let { value: value1, textValue: textValue, id: id, ...props } = obj;
        if (this.node == null) {
            node = new CollectionNodeClass(id ?? `react-aria-${++this.ownerDocument.nodeId}`);
            this.node = node;
        } else node = this.getMutableNode();
        props.ref = ref;
        node.props = props;
        node.rendered = rendered;
        node.render = render;
        node.value = value1;
        if (obj['aria-label']) node['aria-label'] = obj['aria-label'];
        node.textValue = textValue || (typeof props.children === 'string' ? props.children : '') || obj['aria-label'] || '';
        if (id != null && id !== node.key) throw new Error('Cannot change the id of an item');
        if (props.colSpan != null) node.colSpan = props.colSpan;
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    get style() {
        // React sets display: none to hide elements during Suspense.
        // We'll handle this by setting the element to hidden and invalidating
        // its siblings/parent. Hidden elements remain in the Document, but
        // are removed from the Collection.
        let element = this;
        return {
            get display () {
                return element.isHidden ? 'none' : '';
            },
            set display (value){
                let isHidden = value === 'none';
                if (element.isHidden !== isHidden) {
                    // Mark parent node dirty if this element is currently the first or last visible child.
                    if (element.parentNode?.firstVisibleChild === element || element.parentNode?.lastVisibleChild === element) element.ownerDocument.markDirty(element.parentNode);
                    // Mark sibling visible elements dirty.
                    let prev = element.previousVisibleSibling;
                    let next = element.nextVisibleSibling;
                    if (prev) element.ownerDocument.markDirty(prev);
                    if (next) element.ownerDocument.markDirty(next);
                    // Mark self dirty.
                    element.isHidden = isHidden;
                    element.ownerDocument.markDirty(element);
                }
            }
        };
    }
    hasAttribute() {}
    setAttribute() {}
    setAttributeNS() {}
    removeAttribute() {}
}
class $9f23298218d85439$export$b34a105447964f9f extends $9f23298218d85439$export$410b0c854570d131 {
    constructor(collection){
        // @ts-ignore
        super(null), this.nodeType = 11 // DOCUMENT_FRAGMENT_NODE
        , this.ownerDocument = this, this.dirtyNodes = new Set(), this.isSSR = false, this.nodeId = 0, this.nodesByProps = new WeakMap(), this.keyOwners = new Map(), this.nextCollection = null, this.subscriptions = new Set(), this.queuedRender = false, this.inSubscription = false;
        this.collection = collection;
        this.nextCollection = collection;
    }
    get isConnected() {
        return true;
    }
    createElement(type) {
        return new $9f23298218d85439$export$dc064fe9e59310fd(type, this);
    }
    getMutableCollection() {
        if (!this.nextCollection) this.nextCollection = this.collection.clone();
        return this.nextCollection;
    }
    markDirty(node) {
        this.dirtyNodes.add(node);
    }
    addNode(element) {
        if (element.isHidden || element.node == null) return;
        let collection = this.getMutableCollection();
        if (!collection.getItem(element.node.key)) for (let child of element)this.addNode(child);
        collection.addNode(element.node);
    }
    removeNode(node) {
        for (let child of node)this.removeNode(child);
        if (node.node) {
            let collection = this.getMutableCollection();
            collection.removeNode(node.node.key);
        }
    }
    /** Finalizes the collection update, updating all nodes and freezing the collection. */ getCollection() {
        // If in a subscription update, return return the existing collection.
        // React will call getCollection again during render, at which point all the updates will be complete.
        if (this.inSubscription) return this.collection;
        // Reset queuedRender to false when getCollection is called during render.
        this.queuedRender = false;
        this.updateCollection();
        return this.collection;
    }
    updateCollection() {
        // First, remove disconnected nodes and update the indices of dirty element children.
        for (let element of this.dirtyNodes)if (element instanceof $9f23298218d85439$export$dc064fe9e59310fd && (!element.isConnected || element.isHidden)) this.removeNode(element);
        else element.updateChildIndices();
        // Next, update dirty collection nodes.
        for (let element of this.dirtyNodes)if (element instanceof $9f23298218d85439$export$dc064fe9e59310fd) {
            if (element.isConnected && !element.isHidden) {
                element.updateNode();
                this.addNode(element);
            }
            if (element.node) this.dirtyNodes.delete(element);
            element.isMutated = false;
        } else this.dirtyNodes.delete(element);
        // Finally, update the collection.
        if (this.nextCollection) {
            this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR);
            if (!this.isSSR) {
                this.collection = this.nextCollection;
                this.nextCollection = null;
            }
        }
    }
    queueUpdate() {
        if (this.dirtyNodes.size === 0 || this.queuedRender) return;
        // Only trigger subscriptions once during an update, when the first item changes.
        // React's useSyncExternalStore will call getCollection immediately, to check whether the snapshot changed.
        // If so, React will queue a render to happen after the current commit to our fake DOM finishes.
        // We track whether getCollection is called in a subscription, and once it is called during render,
        // we reset queuedRender back to false.
        this.queuedRender = true;
        this.inSubscription = true;
        // Clone the collection to ensure that React queues a render. It will call getCollection again
        // during render, at which point all the updates will be complete and we can return
        // the new collection.
        if (!this.isSSR) this.collection = this.collection.clone();
        for (let fn of this.subscriptions)fn();
        this.inSubscription = false;
    }
    subscribe(fn) {
        this.subscriptions.add(fn);
        // Ensure that React reads the collection if we re-subscribe after updates were
        // already queued. When a hidden Activity is revealed, child nodes re-attach and call
        // queueUpdate before we can re-subscribe, so the notification is lost.
        if (this.queuedRender) fn();
        return ()=>this.subscriptions.delete(fn);
    }
    resetAfterSSR() {
        if (this.isSSR) {
            this.isSSR = false;
            this.firstChild = null;
            this.lastChild = null;
            this.nodeId = 0;
            this.keyOwners.clear();
        }
    }
}

});

parcelRegister("1kw8g", function(module, exports) {

$parcel$export(module.exports, "useCachedChildren", () => $d4a27a5e512a0e26$export$727c8fc270210f13);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d4a27a5e512a0e26$export$727c8fc270210f13(props) {
    let { children: children, items: items, idScope: idScope, addIdAndValue: addIdAndValue, dependencies: dependencies = [] } = props;
    // In development, invalidate when the children function updates (e.g. HMR).
    let childrenString = (0, $eF4cA.useMemo)(()=>undefined, [
        children
    ]);
    // Invalidate the cache whenever dependencies change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // oxlint-disable-next-line react/react-compiler, react-hooks/exhaustive-deps
    let cache = (0, $eF4cA.useMemo)(()=>new WeakMap(), [
        ...dependencies,
        childrenString
    ]);
    return (0, $eF4cA.useMemo)(()=>{
        if (items && typeof children === 'function') {
            let res = [];
            for (let item of items){
                let cacheKey = $d4a27a5e512a0e26$var$$a80bd3e9349588e7$var$isWeakKey(item) ? item : null;
                let rendered = cacheKey ? cache.get(cacheKey) : null;
                if (!rendered) {
                    rendered = children(item);
                    // @ts-ignore
                    let id = rendered.props.id ?? item?.key ?? item?.id;
                    if (idScope != null && rendered.props.id == null && id != null) id = idScope + ':' + id;
                    // If no id is inferred from data, use the index as the React key.
                    // An id will be generated by the collection document.
                    let key = id ?? res.length;
                    // Note: only works if wrapped Item passes through id...
                    rendered = (0, $eF4cA.cloneElement)(rendered, addIdAndValue ? {
                        key: key,
                        id: id,
                        value: item
                    } : {
                        key: key
                    });
                    if (cacheKey) cache.set(cacheKey, rendered);
                }
                res.push(rendered);
            }
            return res;
        } else if (typeof children !== 'function') return children;
    }, [
        children,
        items,
        cache,
        idScope,
        addIdAndValue
    ]);
}
function $d4a27a5e512a0e26$var$$a80bd3e9349588e7$var$isWeakKey(value) {
    switch(typeof value){
        case 'object':
            return value != null;
        case 'function':
        case 'symbol':
            return true;
        default:
            return false;
    }
}

});

parcelRegister("8M8Qw", function(module, exports) {

$parcel$export(module.exports, "FocusableContext", () => $82c341a8967f488a$export$f9762fab77588ecb);
$parcel$export(module.exports, "FocusableProvider", () => $82c341a8967f488a$export$13f3202a3e5ddd5);
$parcel$export(module.exports, "useFocusable", () => $82c341a8967f488a$export$4c014de7c8940b4c);
$parcel$export(module.exports, "Focusable", () => $82c341a8967f488a$export$35a3bebf7ef2d934);

var $eNuje = parcelRequire("eNuje");



var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $4bE7h = parcelRequire("4bE7h");

var $aGDvF = parcelRequire("aGDvF");

var $26CkO = parcelRequire("26CkO");

var $eLOK5 = parcelRequire("eLOK5");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $82c341a8967f488a$export$f9762fab77588ecb = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
function $82c341a8967f488a$var$$d1116acdf220c2da$var$useFocusableContext(ref) {
    let context = (0, $eF4cA.useContext)($82c341a8967f488a$export$f9762fab77588ecb) || {};
    (0, $eLOK5.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
const $82c341a8967f488a$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef(function FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $26CkO.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($82c341a8967f488a$export$f9762fab77588ecb.Provider, {
        value: context
    }, children);
});
function $82c341a8967f488a$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $4bE7h.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)(props);
    let interactions = (0, $lhKAD.mergeProps)(focusProps, keyboardProps);
    let domProps = $82c341a8967f488a$var$$d1116acdf220c2da$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $eF4cA.useRef)(props.autoFocus);
    (0, $eF4cA.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $eNuje.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    // Always set a tabIndex so that Safari allows focusing native buttons and inputs.
    let tabIndex = props.excludeFromTabOrder ? -1 : 0;
    if (props.isDisabled) tabIndex = undefined;
    return {
        focusableProps: (0, $lhKAD.mergeProps)({
            ...interactions,
            tabIndex: tabIndex
        }, interactionProps)
    };
}
const $82c341a8967f488a$export$35a3bebf7ef2d934 = (0, $eF4cA.forwardRef)(({ children: children, ...props }, ref)=>{
    ref = (0, $26CkO.useObjectRef)(ref);
    let { focusableProps: focusableProps } = $82c341a8967f488a$export$4c014de7c8940b4c(props, ref);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.only(children);
    (0, $eF4cA.useEffect)(()=>{
        return;
    }, [
        ref,
        props.isDisabled
    ]);
    // @ts-ignore
    let childRef = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).version, 10) < 19 ? child.ref : child.props.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).cloneElement(child, {
        ...(0, $lhKAD.mergeProps)(focusableProps, child.props),
        // @ts-ignore
        // oxlint-disable-next-line react/react-compiler
        ref: (0, $bkjeZ.mergeRefs)(childRef, ref)
    });
});

});
parcelRegister("4bE7h", function(module, exports) {

$parcel$export(module.exports, "useFocus", () => $36edfe5bd40cbdea$export$f8168d8dd8fd66e6);

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $wjtfD = parcelRequire("wjtfD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $36edfe5bd40cbdea$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $eF4cA.useCallback)((e)=>{
        if ((0, $fvyIQ.getEventTarget)(e) === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $wjtfD.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $eF4cA.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $fvyIQ.getEventTarget)(e);
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(eventTarget);
        const activeElement = ownerDocument ? (0, $fvyIQ.getActiveElement)(ownerDocument) : (0, $fvyIQ.getActiveElement)();
        if (eventTarget === e.currentTarget && eventTarget === activeElement) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});

parcelRegister("aGDvF", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", () => $5235a2f05ce21da6$export$8f71654801c2f7cd);

var $d8j5I = parcelRequire("d8j5I");

var $cO6xl = parcelRequire("cO6xl");

var $apSAA = parcelRequire("apSAA");

var $fvyIQ = parcelRequire("fvyIQ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5235a2f05ce21da6$export$8f71654801c2f7cd(props) {
    let { shortcuts: shortcuts, allowRepeats: allowRepeats = false, allowComposing: allowComposing = false } = props;
    let onKeyDown;
    let onKeyUp;
    if (shortcuts) {
        let shortcutHandler = (0, $apSAA.createKeyboardShortcutHandler)(shortcuts);
        let shortcutOnKeyDown = (0, $cO6xl.createEventHandler)((e)=>{
            // If keyboard event didn't originate from a child of the current target,
            // then it's a React event coming through a portal. We should ignore it.
            if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) {
                e.continuePropagation();
                return;
            }
            if (e.nativeEvent?.repeat && !allowRepeats || e.nativeEvent?.isComposing && !allowComposing) {
                e.continuePropagation();
                return;
            }
            shortcutHandler(e);
        });
        let shortcutOnKeyUp = (0, $cO6xl.createEventHandler)((e)=>{
            // If keyboard event didn't originate from a child of the current target,
            // then it's a React event coming through a portal. We should ignore it.
            if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) {
                e.continuePropagation();
                return;
            }
            if (e.nativeEvent?.repeat && !allowRepeats || e.nativeEvent?.isComposing && !allowComposing) {
                e.continuePropagation();
                return;
            }
            // implement shortcut handler on keyup, what should the map be called? or should it be another syntax on shortcuts?
            e.continuePropagation();
        });
        onKeyDown = props.onKeyDown ? (0, $d8j5I.chain)(props.onKeyDown, shortcutOnKeyDown) : shortcutOnKeyDown;
        onKeyUp = props.onKeyUp ? (0, $d8j5I.chain)(props.onKeyUp, shortcutOnKeyUp) : shortcutOnKeyUp;
    } else {
        onKeyDown = (0, $cO6xl.createEventHandler)(props.onKeyDown);
        onKeyUp = (0, $cO6xl.createEventHandler)(props.onKeyUp);
    }
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }
    };
}

});
parcelRegister("cO6xl", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", () => $2799ba81872de5a4$export$48d1ea6320830260);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2799ba81872de5a4$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    return (e)=>{
        let shouldStopPropagation = true;
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                shouldStopPropagation = true;
            },
            continuePropagation () {
                shouldStopPropagation = false;
                // nested createEventHandler might have set continue propagation so we should continue
                // propagation on wrappers
                if (typeof e.continuePropagation === 'function') e.continuePropagation();
            },
            isPropagationStopped () {
                return shouldStopPropagation;
            }
        };
        handler(event);
        // nested createEventHandler calls may already have stopped propagation
        if (shouldStopPropagation && !(typeof e.isPropagationStopped === 'function' && e.isPropagationStopped())) e.stopPropagation();
    };
}

});

parcelRegister("apSAA", function(module, exports) {

$parcel$export(module.exports, "createKeyboardShortcutHandler", () => $6413074239e2b8ac$export$2fd1fc8039383ae1);

var $11FxZ = parcelRequire("11FxZ");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /** Modifier names in shortcut strings (case-insensitive). Order in the string does not matter. */ const $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$MODIFIER_NAMES = new Set([
    'shift',
    'alt',
    'control',
    'meta',
    'mod' // OS dependent - Cmd on Mac, Control on Windows/Linux
]);
/** Canonical modifier order for stable keys (sorted, fixed order). */ const $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$CANONICAL_MODIFIER_ORDER = [
    'Alt',
    'Control',
    'Meta',
    'Shift'
];
function $6413074239e2b8ac$export$9932402e211e7315(parsed) {
    let set = new Set();
    if (parsed.alt) set.add('Alt');
    if (parsed.shift) set.add('Shift');
    if (parsed.ctrl) set.add('Control');
    if (parsed.meta) set.add('Meta');
    if (parsed.mod) set.add((0, $11FxZ.isMac)() ? 'Meta' : 'Control');
    return set;
}
function $6413074239e2b8ac$export$bf26c410e1f8fe6d(e) {
    let set = new Set();
    if (e.altKey) set.add('Alt');
    if (e.ctrlKey) set.add('Control');
    if (e.metaKey) set.add('Meta');
    if (e.shiftKey) set.add('Shift');
    return set;
}
function $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$sortedModifierTokens(set) {
    return $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$CANONICAL_MODIFIER_ORDER.filter((name)=>set.has(name));
}
function $6413074239e2b8ac$export$d636f01a2eaffd51(spec) {
    let parts = spec.split('+').reduce((prev, part)=>{
        let lower = part.toLowerCase();
        if ($6413074239e2b8ac$var$$cbf729ad7eb217b0$var$MODIFIER_NAMES.has(lower)) {
            if (lower === 'shift') prev.shift = true;
            else if (lower === 'alt') prev.alt = true;
            else if (lower === 'control') prev.ctrl = true;
            else if (lower === 'meta') prev.meta = true;
            else if (lower === 'mod') prev.mod = true;
        } else prev.key = part;
        return prev;
    }, {
        shift: false,
        alt: false,
        ctrl: false,
        meta: false,
        mod: false,
        key: ''
    });
    if (parts.key === '') throw new Error(`Invalid keyboard shortcut: "${spec}". Must include exactly one non-modifier key (e.g. "a", "Enter", "ArrowDown"). Combine any of Shift, Alt, Ctrl, Meta, and Mod.`);
    return parts;
}
function $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$normalizeEventKey(key) {
    return key.toLowerCase();
}
/** Short aliases for common keys (shortcut side, before match). */ const $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$KEY_ALIASES = {
    space: ' ',
    esc: 'escape',
    del: 'delete',
    ins: 'insert',
    left: 'arrowleft',
    right: 'arrowright',
    up: 'arrowup',
    down: 'arrowdown',
    pageup: 'pageup',
    pagedown: 'pagedown'
};
/** Canonical key segment (lowercase); aliases like `down` → `arrowdown`. */ function $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$canonicalKeyFromSpecKey(specKey) {
    let k = $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$normalizeEventKey(specKey);
    let aliased = $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$KEY_ALIASES[k];
    return aliased != null ? aliased : k;
}
function $6413074239e2b8ac$export$6cfa2ace150c84a5(parsed) {
    let mods = $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$sortedModifierTokens($6413074239e2b8ac$export$9932402e211e7315(parsed));
    let key = $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$canonicalKeyFromSpecKey(parsed.key);
    return mods.length > 0 ? `${mods.join('+')}+${key}` : key;
}
function $6413074239e2b8ac$export$786304bda41dd69f(e) {
    let mods = $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$sortedModifierTokens($6413074239e2b8ac$export$bf26c410e1f8fe6d(e));
    let key = $6413074239e2b8ac$var$$cbf729ad7eb217b0$var$normalizeEventKey(e.key);
    let prefix = mods.length > 0 ? `${mods.join('+')}+` : '';
    return prefix + key;
}
function $6413074239e2b8ac$export$2fd1fc8039383ae1(bindings) {
    let map = new Map();
    for (let [spec, action] of Object.entries(bindings)){
        let parsed = $6413074239e2b8ac$export$d636f01a2eaffd51(spec);
        map.set($6413074239e2b8ac$export$6cfa2ace150c84a5(parsed), action);
    }
    return (e)=>{
        let canonical = $6413074239e2b8ac$export$786304bda41dd69f(e);
        let action = map.get(canonical);
        let result = action?.(e);
        if (result === undefined && action !== undefined) result = {
            shouldContinuePropagation: false,
            shouldPreventDefault: true
        };
        else if (typeof result === 'boolean') result = {
            shouldContinuePropagation: !result,
            shouldPreventDefault: result
        };
        if (result?.shouldPreventDefault) e.preventDefault();
        if (!action || result?.shouldContinuePropagation) e.continuePropagation();
    };
}

});


parcelRegister("eLOK5", function(module, exports) {

$parcel$export(module.exports, "useSyncRef", () => $5428ed243c1c63bb$export$4debdb1a3f0fa79e);

var $4skXn = parcelRequire("4skXn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5428ed243c1c63bb$export$4debdb1a3f0fa79e(context, ref) {
    (0, $4skXn.useLayoutEffect)(()=>{
        if (context && context.ref && ref) {
            // oxlint-disable-next-line react/react-compiler
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}

});


parcelRegister("5LhCr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gqoBv"));

});



parcelRegister("1O9kP", function(module, exports) {

$parcel$export(module.exports, "HeadingContext", () => $256e825b2e3bc064$export$d688439359537581);
$parcel$export(module.exports, "Heading", () => $256e825b2e3bc064$export$a8a3e93435678ff9);

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $256e825b2e3bc064$export$d688439359537581 = (0, $eF4cA.createContext)({});
const $256e825b2e3bc064$export$a8a3e93435678ff9 = (0, $eF4cA.forwardRef)(function Heading(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $256e825b2e3bc064$export$d688439359537581);
    let { children: children, level: level = 3, className: className, ...domProps } = props;
    let Element = (0, $fDYaM.dom)[`h${level}`];
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(Element, {
        ...domProps,
        ref: ref,
        className: className ?? 'react-aria-Heading'
    }, children);
});

});

parcelRegister("c1ibQ", function(module, exports) {

$parcel$export(module.exports, "TextContext", () => $f810c0671c06f609$export$9afb8bc826b033ea);
$parcel$export(module.exports, "Text", () => $f810c0671c06f609$export$5f1af8db9871e1d6);

var $fDYaM = parcelRequire("fDYaM");

var $19ZgV = parcelRequire("19ZgV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f810c0671c06f609$export$9afb8bc826b033ea = (0, $eF4cA.createContext)({});
const $f810c0671c06f609$export$5f1af8db9871e1d6 = (0, $19ZgV.createHideableComponent)(function Text(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $f810c0671c06f609$export$9afb8bc826b033ea);
    let { elementType: elementType = 'span', ...domProps } = props;
    let ElementType = (0, $fDYaM.dom)[elementType];
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        className: "react-aria-Text",
        ...domProps,
        ref: ref
    });
});

});


parcelRegister("j3pTw", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $feedcc038946aff4$export$c24727297075ec6a);
$parcel$export(module.exports, "useFormProps", () => $feedcc038946aff4$export$a6b5be5c6b451665);
$parcel$export(module.exports, "Form", () => $feedcc038946aff4$export$a7fed597f4b8afd8);


var $3PqDc = parcelRequire("3PqDc");

var $91SAk = parcelRequire("91SAk");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $i0SpD = parcelRequire("i0SpD");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $feedcc038946aff4$export$c24727297075ec6a = (0, $eF4cA.createContext)(null);
function $feedcc038946aff4$export$a6b5be5c6b451665(props) {
    let ctx = (0, $eF4cA.useContext)($feedcc038946aff4$export$c24727297075ec6a);
    let isSkeleton = (0, $91SAk.useIsSkeleton)();
    return (0, $eF4cA.useMemo)(()=>{
        let result = props;
        if (ctx || isSkeleton) result = {
            ...props
        };
        if (ctx) {
            // This is a subset of mergeProps. We just need to merge non-undefined values.
            for(let key in ctx)if (result[key] === undefined) result[key] = ctx[key];
        }
        // Skeleton always wins over local props.
        if (isSkeleton) result.isDisabled = true;
        return result;
    }, [
        ctx,
        props,
        isSkeleton
    ]);
}
const $feedcc038946aff4$export$a7fed597f4b8afd8 = (0, $eF4cA.forwardRef)(function Form(props, ref) {
    let { labelPosition: labelPosition = 'top', labelAlign: labelAlign, necessityIndicator: necessityIndicator, isRequired: isRequired, isDisabled: isDisabled, isEmphasized: isEmphasized, size: size = 'M', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', ...formProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $i0SpD.Form), {
        ...formProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
            rules += ' se182';
            if (props.labelPosition === "side") rules += ' Dfzkwne182';
            else if (props.labelPosition === "top") rules += ' DS1aTJb182';
            if (props.size === "XL") rules += ' Un182';
            else if (props.size === "L") rules += ' Up182';
            else if (props.size === "M") rules += ' Uj182';
            else if (props.size === "S") rules += ' Ui182';
            else if (props.size === "XS") rules += ' Ul182';
            rules += ' qf182';
            return rules;
        }({
            labelPosition: labelPosition,
            size: size
        }, props.styles),
        children: (0, $dx4lB.jsx)($feedcc038946aff4$export$c24727297075ec6a.Provider, {
            value: {
                labelPosition: labelPosition,
                labelAlign: labelAlign,
                necessityIndicator: necessityIndicator,
                isRequired: isRequired,
                isDisabled: isDisabled,
                isEmphasized: isEmphasized,
                size: size
            },
            children: props.children
        })
    });
});

});
parcelRegister("i0SpD", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $2b33a50ca1be037c$export$c24727297075ec6a);
$parcel$export(module.exports, "Form", () => $2b33a50ca1be037c$export$a7fed597f4b8afd8);

var $fDYaM = parcelRequire("fDYaM");

var $iEwfj = parcelRequire("iEwfj");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2b33a50ca1be037c$export$c24727297075ec6a = (0, $eF4cA.createContext)(null);
const $2b33a50ca1be037c$export$a7fed597f4b8afd8 = (0, $eF4cA.forwardRef)(function Form(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $2b33a50ca1be037c$export$c24727297075ec6a);
    let { validationErrors: validationErrors, validationBehavior: validationBehavior = 'native', children: children, className: className, ...domProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).form, {
        noValidate: validationBehavior !== 'native',
        ...domProps,
        ref: ref,
        className: className || 'react-aria-Form'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($2b33a50ca1be037c$export$c24727297075ec6a.Provider, {
        value: {
            ...props,
            validationBehavior: validationBehavior
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $iEwfj.FormValidationContext).Provider, {
        value: validationErrors ?? {}
    }, children)));
});

});
parcelRegister("iEwfj", function(module, exports) {

$parcel$export(module.exports, "VALID_VALIDITY_STATE", () => $8440a819f901a679$export$aca958c65c314e6c);
$parcel$export(module.exports, "DEFAULT_VALIDATION_RESULT", () => $8440a819f901a679$export$dad6ae84456c676a);
$parcel$export(module.exports, "FormValidationContext", () => $8440a819f901a679$export$571b5131b7e65c11);
$parcel$export(module.exports, "privateValidationStateProp", () => $8440a819f901a679$export$a763b9476acd3eb);
$parcel$export(module.exports, "useFormValidationState", () => $8440a819f901a679$export$fc1a364ae1f3ff10);
$parcel$export(module.exports, "mergeValidation", () => $8440a819f901a679$export$75ee7c75d68f5b0e);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8440a819f901a679$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $8440a819f901a679$var$$fd2148440a13ec26$var$CUSTOM_VALIDITY_STATE = {
    ...$8440a819f901a679$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $8440a819f901a679$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $8440a819f901a679$export$aca958c65c314e6c,
    validationErrors: []
};
const $8440a819f901a679$export$571b5131b7e65c11 = (0, $eF4cA.createContext)({});
const $8440a819f901a679$export$a763b9476acd3eb = '__reactAriaFormValidationState';
function $8440a819f901a679$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$8440a819f901a679$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$8440a819f901a679$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return $8440a819f901a679$var$$fd2148440a13ec26$var$useFormValidationStateImpl(props);
}
function $8440a819f901a679$var$$fd2148440a13ec26$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = 'aria' } = props;
    // backward compatibility.
    if (validationState) isInvalid ||= validationState === 'invalid';
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $8440a819f901a679$var$$fd2148440a13ec26$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $eF4cA.useMemo)(()=>{
        if (!validate || value == null) return null;
        let validateErrors = $8440a819f901a679$var$$fd2148440a13ec26$var$runValidate(validate, value);
        return $8440a819f901a679$var$$fd2148440a13ec26$var$getValidationResult(validateErrors);
    }, [
        validate,
        value
    ]);
    if (builtinValidation?.validationDetails.valid) builtinValidation = undefined;
    // Get relevant server errors from the form.
    let serverErrors = (0, $eF4cA.useContext)($8440a819f901a679$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $eF4cA.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$8440a819f901a679$var$$fd2148440a13ec26$var$asArray(serverErrors[name])) : $8440a819f901a679$var$$fd2148440a13ec26$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $eF4cA.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $eF4cA.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $eF4cA.useMemo)(()=>$8440a819f901a679$var$$fd2148440a13ec26$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $eF4cA.useRef)($8440a819f901a679$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $eF4cA.useState)($8440a819f901a679$export$dad6ae84456c676a);
    let lastError = (0, $eF4cA.useRef)($8440a819f901a679$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$8440a819f901a679$var$$fd2148440a13ec26$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $8440a819f901a679$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === 'native' ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === 'aria' && !$8440a819f901a679$var$$fd2148440a13ec26$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $8440a819f901a679$export$dad6ae84456c676a;
            if (!$8440a819f901a679$var$$fd2148440a13ec26$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === 'native') setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === 'native') setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $8440a819f901a679$var$$fd2148440a13ec26$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $8440a819f901a679$var$$fd2148440a13ec26$var$runValidate(validate, value) {
    if (typeof validate === 'function') {
        let e = validate(value);
        if (e && typeof e !== 'boolean') return $8440a819f901a679$var$$fd2148440a13ec26$var$asArray(e);
    }
    return [];
}
function $8440a819f901a679$var$$fd2148440a13ec26$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $8440a819f901a679$var$$fd2148440a13ec26$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $8440a819f901a679$var$$fd2148440a13ec26$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $8440a819f901a679$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$8440a819f901a679$export$aca958c65c314e6c
    };
    for (let v of results){
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid ||= v.isInvalid;
        for(let key in validationDetails)validationDetails[key] ||= v.validationDetails[key];
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}

});



parcelRegister("34HUQ", function(module, exports) {

$parcel$export(module.exports, "ButtonContext", () => $6433db038b207b9a$export$24d547caef80ccd1);
$parcel$export(module.exports, "LinkButtonContext", () => $6433db038b207b9a$export$1c1a176f3b9e48d3);
$parcel$export(module.exports, "usePendingState", () => $6433db038b207b9a$export$edc9ced5c3e5ff00);
$parcel$export(module.exports, "Button", () => $6433db038b207b9a$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $6433db038b207b9a$export$29d11c0fe2fc51d8);


var $8OJ2z = parcelRequire("8OJ2z");

var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $i93Vd = parcelRequire("i93Vd");

var $fZShI = parcelRequire("fZShI");

var $91SAk = parcelRequire("91SAk");

var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $j3pTw = parcelRequire("j3pTw");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $k8kxd = parcelRequire("k8kxd");

var $8gDpA = parcelRequire("8gDpA");

var $gI8Gw = parcelRequire("gI8Gw");
function $6433db038b207b9a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6433db038b207b9a$export$24d547caef80ccd1 = (0, $eF4cA.createContext)(null);
const $6433db038b207b9a$export$1c1a176f3b9e48d3 = (0, $eF4cA.createContext)(null);
const $6433db038b207b9a$var$$067ea9f64ccd4e8e$var$button = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    if (props.isStaticColor) rules += ' Oe182';
    else rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isStaticColor) {
        if (props.isDisabled) rules += ' pi182';
        else if (props.fillStyle === "outline") {
            if (props.variant === "genai") rules += ' px182';
            else if (props.variant === "premium") rules += ' px182';
            else {
                if (props.isPressed) rules += ' pl182';
                else if (props.isFocusVisible) rules += ' pl182';
                else if (props.isHovered) rules += ' pl182';
                else rules += ' pl182';
            }
        } else if (props.fillStyle === "fill") {
            if (props.variant === "genai") rules += ' px182';
            else if (props.variant === "premium") rules += ' px182';
            else if (props.variant === "secondary") {
                if (props.isPressed) rules += ' pl182';
                else if (props.isFocusVisible) rules += ' pl182';
                else if (props.isHovered) rules += ' pl182';
                else rules += ' pl182';
            } else if (props.variant === "primary") rules += ' ph182';
        }
    } else if (props.fillStyle === "outline") {
        if (props.isDisabled) rules += ' pp182';
        else if (props.variant === "genai") rules += ' px182';
        else if (props.variant === "premium") rules += ' px182';
        else {
            if (props.isPressed) rules += ' po182';
            else if (props.isFocusVisible) rules += ' po182';
            else if (props.isHovered) rules += ' po182';
            else rules += ' pt182';
        }
    } else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' pp182';
        else if (props.variant === "genai") rules += ' px182';
        else if (props.variant === "premium") rules += ' px182';
        else if (props.variant === "negative") rules += ' px182';
        else if (props.variant === "accent") rules += ' px182';
        else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' po182';
            else if (props.isFocusVisible) rules += ' po182';
            else if (props.isHovered) rules += ' po182';
            else rules += ' pt182';
        } else if (props.variant === "primary") rules += ' pr182';
    }
    if (props.fillStyle === "outline") {
        if (props.isDisabled) rules += ' plc182';
        else rules += ' plb182';
    } else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' ple182';
        else rules += ' pla182';
    }
    rules += ' sd182';
    rules += ' ea182';
    rules += ' egLWx3bb182';
    rules += ' _oa182';
    rules += ' Sw182';
    rules += ' SgLWx3bd182';
    rules += ' Rw182';
    rules += ' RgLWx3bd182';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl182';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj182';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf182';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne182';
    } else if (!minWidth) rules += ' Nk182';
    rules += ' oh182';
    rules += ' nh182';
    rules += ' kh182';
    rules += ' jh182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' MAyFGYc182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' -aRvJDd-Tu7Fubd182';
    if (!position) rules += ' _Pc182';
    rules += ' _Ca182';
    rules += ' _Wd182';
    rules += ' _4c182';
    if (!width) rules += ' ZJ182';
    rules += ' _Xa182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _jf182';
    rules += ' _kJ8iPYd182';
    rules += ' hXMFGYc182';
    if (props.variant === "genai") rules += ' ma182';
    else if (props.variant === "premium") rules += ' ma182';
    else if (props.fillStyle === "outline") rules += ' mc182';
    else if (props.fillStyle === "fill") rules += ' ma182';
    if (props.variant === "genai") rules += ' la182';
    else if (props.variant === "premium") rules += ' la182';
    else if (props.fillStyle === "outline") rules += ' lc182';
    else if (props.fillStyle === "fill") rules += ' la182';
    if (props.isStaticColor) {
        if (props.isDisabled) rules += ' ig182';
        else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' ih182';
            else if (props.isFocusVisible) rules += ' ih182';
            else if (props.isHovered) rules += ' ih182';
            else rules += ' ig182';
        } else if (props.variant === "primary") {
            if (props.isPressed) rules += ' ij182';
            else if (props.isFocusVisible) rules += ' ij182';
            else if (props.isHovered) rules += ' ij182';
            else rules += ' ii182';
        }
    } else if (props.isDisabled) rules += ' iq182';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' io182';
        else if (props.isFocusVisible) rules += ' io182';
        else if (props.isHovered) rules += ' io182';
        else rules += ' iq182';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' in182';
        else if (props.isFocusVisible) rules += ' in182';
        else if (props.isHovered) rules += ' in182';
        else rules += ' iv182';
    }
    if (props.isDisabled) rules += ' ilc182';
    else if (props.isHovered) rules += ' ild182';
    else rules += ' ila182';
    rules += ' gqMFGYc182';
    rules += ' -_8sjo0b-t5ZbAob182';
    rules += ' _yb182';
    rules += ' __ca182';
    if (props.size === "XL") rules += ' -M_-Mk182';
    else if (props.size === "L") rules += ' -M_-Mh182';
    else if (props.size === "S") rules += ' -M_-Mg182';
    else if (props.size === "XS") rules += ' -M_-Mf182';
    else rules += ' -M_-Mi182';
    if (props.variant === "genai") rules += ' -_k_-_ka182';
    else if (props.variant === "premium") rules += ' -_k_-_ka182';
    else if (props.fillStyle === "outline") rules += ' -_k_-_kc182';
    else if (props.fillStyle === "fill") rules += ' -_k_-_ka182';
    if (props.variant === "genai") rules += ' -h_-ha182';
    else if (props.variant === "premium") rules += ' -h_-ha182';
    else if (props.fillStyle === "outline") rules += ' -h_-hc182';
    else if (props.fillStyle === "fill") rules += ' -h_-ha182';
    if (props.isStaticColor) {
        if (props.fillStyle === "outline") {
            if (props.isDisabled) {
                if (props.variant === "genai") rules += ' -g_-gf182';
                else if (props.variant === "premium") rules += ' -g_-gf182';
                else rules += ' -g_-g9182';
            } else if (props.isFocusVisible) rules += ' -g_-gf182';
            else if (props.isPressed) rules += ' -g_-gf182';
            else if (props.isHovered) rules += ' -g_-gf182';
            else if (props.variant === "genai") rules += ' -g_-gf182';
            else if (props.variant === "premium") rules += ' -g_-gf182';
            else rules += ' -g_-g9182';
        } else if (props.fillStyle === "fill") {
            if (props.isDisabled) rules += ' -g_-gf182';
            else if (props.variant === "genai") rules += ' -g_-gf182';
            else if (props.variant === "premium") rules += ' -g_-gf182';
            else if (props.variant === "secondary") {
                if (props.isPressed) rules += ' -g_-gg182';
                else if (props.isFocusVisible) rules += ' -g_-gg182';
                else if (props.isHovered) rules += ' -g_-gg182';
                else rules += ' -g_-gf182';
            } else if (props.variant === "primary") {
                if (props.isPressed) rules += ' -g_-gj182';
                else if (props.isFocusVisible) rules += ' -g_-gj182';
                else if (props.isHovered) rules += ' -g_-gj182';
                else rules += ' -g_-gi182';
            }
        }
    } else if (props.fillStyle === "outline") {
        if (props.isDisabled) {
            if (props.variant === "genai") rules += ' -g_-gH182';
            else if (props.variant === "premium") rules += ' -g_-gH182';
            else rules += ' -g_-g9182';
        } else if (props.isFocusVisible) rules += ' -g_-gH182';
        else if (props.isPressed) rules += ' -g_-gH182';
        else if (props.isHovered) rules += ' -g_-gH182';
        else if (props.variant === "genai") rules += ' -g_-gH182';
        else if (props.variant === "premium") rules += ' -g_-gH182';
        else rules += ' -g_-g9182';
    } else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' -g_-gH182';
        else if (props.variant === "genai") rules += ' -g_-gH182';
        else if (props.variant === "premium") rules += ' -g_-gH182';
        else if (props.variant === "negative") {
            if (props.isFocusVisible) rules += ' -g_-gYvV9s182';
            else if (props.isPressed) rules += ' -g_-gYvV9s182';
            else if (props.isHovered) rules += ' -g_-gYvV9s182';
            else rules += ' -g_-g7aei8182';
        } else if (props.variant === "accent") {
            if (props.isFocusVisible) rules += ' -g_-gUgARdd182';
            else if (props.isPressed) rules += ' -g_-gUgARdd182';
            else if (props.isHovered) rules += ' -g_-gUgARdd182';
            else rules += ' -g_-g5qAiPc182';
        } else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' -g_-gF182';
            else if (props.isFocusVisible) rules += ' -g_-gF182';
            else if (props.isHovered) rules += ' -g_-gF182';
            else rules += ' -g_-gH182';
        } else if (props.variant === "primary") {
            if (props.isPressed) rules += ' -g_-gu182';
            else if (props.isFocusVisible) rules += ' -g_-gu182';
            else if (props.isHovered) rules += ' -g_-gu182';
            else rules += ' -g_-g0182';
        }
    }
    if (props.fillStyle === "outline") rules += ' -g_-lgb182';
    else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' -g_-lgd182';
        else if (props.isHovered) rules += ' -g_-lge182';
        else rules += ' -g_-lgc182';
    }
    return rules;
};
// Put the gradient background on a separate element from the button to work around a Safari
// bug where transitions of custom properties cause layout flickering if any properties use rems. 🤣
// https://bugs.webkit.org/show_bug.cgi?id=285622
const $6433db038b207b9a$var$$067ea9f64ccd4e8e$var$gradient = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _lr182';
    rules += ' _Ar182';
    rules += ' _zr182';
    rules += ' _9a182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' oi182';
    rules += ' ni182';
    rules += ' ki182';
    rules += ' ji182';
    if (props.isDisabled) rules += ' _ic182';
    else if (props.variant === "genai") {
        if (props.isFocusVisible) {
            rules += ' _ia182';
            rules += ' -yBNtrc-37ZLpd182';
            rules += ' -zBNtrc-plLfSc182';
            rules += ' -ABNtrc-z2bZib182';
            rules += ' -ACNtrc-tQ56Od182';
        } else if (props.isPressed) {
            rules += ' _ia182';
            rules += ' -yBNtrc-37ZLpd182';
            rules += ' -zBNtrc-plLfSc182';
            rules += ' -ABNtrc-z2bZib182';
            rules += ' -ACNtrc-tQ56Od182';
        } else if (props.isHovered) {
            rules += ' _ia182';
            rules += ' -yBNtrc-37ZLpd182';
            rules += ' -zBNtrc-plLfSc182';
            rules += ' -ABNtrc-z2bZib182';
            rules += ' -ACNtrc-tQ56Od182';
        } else {
            rules += ' _ia182';
            rules += ' -yBNtrc-Nitqwc182';
            rules += ' -zBNtrc-ugAmz182';
            rules += ' -ABNtrc-j7ulPc182';
            rules += ' -ACNtrc-tQ56Od182';
        }
    } else if (props.variant === "premium") {
        if (props.isFocusVisible) {
            rules += ' _ib182';
            rules += ' -yBNtrc-1gYRFc182';
            rules += ' -zBNtrc-z2bZib182';
            rules += ' -ABNtrc-BorWLb182';
            rules += ' -ACNtrc-tQ56Od182';
        } else if (props.isPressed) {
            rules += ' _ib182';
            rules += ' -yBNtrc-1gYRFc182';
            rules += ' -zBNtrc-z2bZib182';
            rules += ' -ABNtrc-BorWLb182';
            rules += ' -ACNtrc-tQ56Od182';
        } else if (props.isHovered) {
            rules += ' _ib182';
            rules += ' -yBNtrc-1gYRFc182';
            rules += ' -zBNtrc-z2bZib182';
            rules += ' -ABNtrc-BorWLb182';
            rules += ' -ACNtrc-tQ56Od182';
        } else {
            rules += ' _ib182';
            rules += ' -yBNtrc-X7W3Sb182';
            rules += ' -zBNtrc-j7ulPc182';
            rules += ' -ABNtrc-fHZGqb182';
            rules += ' -ACNtrc-tQ56Od182';
        }
    }
    rules += ' _ilc182';
    if (props.variant === "genai") rules += ' _pb182';
    else if (props.variant === "premium") rules += ' _pb182';
    return rules;
};
function $6433db038b207b9a$export$edc9ced5c3e5ff00(isPending) {
    let [isProgressVisible, setIsProgressVisible] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(()=>{
        let timeout;
        if (isPending) timeout = setTimeout(()=>{
            setIsProgressVisible(true);
        }, 1000);
        else setIsProgressVisible(false);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        isPending
    ]);
    return {
        isProgressVisible: isProgressVisible
    };
}
const $6433db038b207b9a$export$353f5b6fc5456de1 = (0, $eF4cA.forwardRef)(function Button(props1, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $6433db038b207b9a$export$24d547caef80ccd1);
    props1 = (0, $j3pTw.useFormProps)(props1);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($6433db038b207b9a$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { isPending: isPending = false, variant: variant = 'primary', fillStyle: fillStyle = 'fill', size: size = 'M', staticColor: staticColor } = props1;
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let overlayTriggerState = (0, $eF4cA.useContext)((0, $8gDpA.OverlayTriggerStateContext));
    let { isProgressVisible: isProgressVisible } = $6433db038b207b9a$export$edc9ced5c3e5ff00(isPending);
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        ...props1,
        ref: domRef,
        style: (0, $i93Vd.pressScale)(domRef, props1.UNSAFE_style),
        className: (renderProps)=>(props1.UNSAFE_className || '') + $6433db038b207b9a$var$$067ea9f64ccd4e8e$var$button({
                ...renderProps,
                // Retain hover styles when an overlay is open.
                isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                isDisabled: renderProps.isDisabled || isProgressVisible,
                variant: variant,
                fillStyle: fillStyle,
                size: size,
                staticColor: staticColor,
                isStaticColor: !!staticColor
            }, props1.styles),
        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    variant === 'genai' || variant === 'premium' ? (0, $dx4lB.jsx)("span", {
                        className: $6433db038b207b9a$var$$067ea9f64ccd4e8e$var$gradient({
                            ...renderProps,
                            // Retain hover styles when an overlay is open.
                            isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                            isDisabled: renderProps.isDisabled || isProgressVisible,
                            variant: variant
                        })
                    }) : null,
                    (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $91SAk.SkeletonContext),
                                null
                            ],
                            [
                                (0, $208Op.TextContext),
                                {
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' TAzEcG182';
                                        rules += ' QAzEcG182';
                                        rules += ' _Jb182';
                                        if (props.isProgressVisible) rules += ' _6b182';
                                        return rules;
                                    }({
                                        isProgressVisible: isProgressVisible
                                    }),
                                    // @ts-ignore data-attributes allowed on all JSX elements, but adding to DOMProps has been problematic in the past
                                    'data-rsp-slot': 'text'
                                }
                            ],
                            [
                                (0, $dm5H1.IconContext),
                                {
                                    render: (0, $8OJ2z.centerBaseline)({
                                        slot: 'icon',
                                        styles: " _Ja182"
                                    }),
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' ZObNfn182';
                                        rules += ' FObNfn182';
                                        rules += ' I67logd182';
                                        rules += ' _va182';
                                        if (props.isProgressVisible) rules += ' _6b182';
                                        return rules;
                                    }({
                                        isProgressVisible: isProgressVisible
                                    })
                                }
                            ]
                        ],
                        children: [
                            typeof props1.children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: props1.children
                            }) : props1.children,
                            isPending && (0, $dx4lB.jsx)("div", {
                                className: function anonymous(props) {
                                    let rules = " ";
                                    rules += ' _Pa182';
                                    rules += ' WF182';
                                    rules += ' _EF182';
                                    rules += ' _Zc182';
                                    if (props.isProgressVisible) rules += ' _6c182';
                                    else rules += ' _6b182';
                                    return rules;
                                }({
                                    isProgressVisible: isProgressVisible,
                                    isPending: isPending
                                }),
                                children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                    isIndeterminate: true,
                                    "aria-label": stringFormatter.format('button.pending'),
                                    size: "S",
                                    staticColor: staticColor,
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        if (props.size === "XL") rules += ' Zo182';
                                        else if (props.size === "L") rules += ' Zm182';
                                        else if (props.size === "M") rules += ' Zl182';
                                        else if (props.size === "S") rules += ' Zk182';
                                        if (props.size === "XL") rules += ' Fp182';
                                        else if (props.size === "L") rules += ' Fn182';
                                        else if (props.size === "M") rules += ' Fm182';
                                        else if (props.size === "S") rules += ' Fl182';
                                        return rules;
                                    }({
                                        size: size
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
    });
// oxlint-enable react/react-compiler
});
const $6433db038b207b9a$export$29d11c0fe2fc51d8 = (0, $eF4cA.forwardRef)(function LinkButton(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $6433db038b207b9a$export$1c1a176f3b9e48d3);
    props = (0, $j3pTw.useFormProps)(props);
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let overlayTriggerState = (0, $eF4cA.useContext)((0, $8gDpA.OverlayTriggerStateContext));
    let { fillStyle: fillStyle = 'fill', size: size = 'M', variant: variant = 'primary', staticColor: staticColor, styles: styles, children: children } = props;
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $k8kxd.Link), {
        ...props,
        ref: domRef,
        style: (0, $i93Vd.pressScale)(domRef, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + $6433db038b207b9a$var$$067ea9f64ccd4e8e$var$button({
                ...renderProps,
                // Retain hover styles when an overlay is open.
                isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                variant: variant,
                fillStyle: fillStyle,
                size: size,
                staticColor: staticColor,
                isStaticColor: !!staticColor,
                isPending: false
            }, styles),
        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    variant === 'genai' || variant === 'premium' ? (0, $dx4lB.jsx)("span", {
                        className: $6433db038b207b9a$var$$067ea9f64ccd4e8e$var$gradient({
                            ...renderProps,
                            // Retain hover styles when an overlay is open.
                            isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                            variant: variant
                        })
                    }) : null,
                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $91SAk.SkeletonContext),
                                null
                            ],
                            [
                                (0, $208Op.TextContext),
                                {
                                    styles: " TAzEcG182 QAzEcG182 _Jb182",
                                    // @ts-ignore data-attributes allowed on all JSX elements, but adding to DOMProps has been problematic in the past
                                    'data-rsp-slot': 'text'
                                }
                            ],
                            [
                                (0, $dm5H1.IconContext),
                                {
                                    render: (0, $8OJ2z.centerBaseline)({
                                        slot: 'icon',
                                        styles: " _Ja182"
                                    }),
                                    styles: " ZObNfn182 FObNfn182 I67logd182 _va182"
                                }
                            ]
                        ],
                        children: typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: children
                        }) : children
                    })
                ]
            })
    });
// oxlint-enable react/react-compiler
});

});
parcelRegister("k5Pnh", function(module, exports) {

$parcel$export(module.exports, "ButtonContext", () => $8c983293789b3e79$export$24d547caef80ccd1);
$parcel$export(module.exports, "Button", () => $8c983293789b3e79$export$353f5b6fc5456de1);

var $fDYaM = parcelRequire("fDYaM");

var $lrZgx = parcelRequire("lrZgx");

var $4HiHF = parcelRequire("4HiHF");

var $fipJz = parcelRequire("fipJz");

var $19ZgV = parcelRequire("19ZgV");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8c983293789b3e79$export$24d547caef80ccd1 = (0, $eF4cA.createContext)({});
const $8c983293789b3e79$export$353f5b6fc5456de1 = (0, $19ZgV.createHideableComponent)(function Button(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $8c983293789b3e79$export$24d547caef80ccd1);
    let ctx = props;
    let { isPending: isPending } = ctx;
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $fipJz.useButton)(props, ref);
    buttonProps = $8c983293789b3e79$var$$7705c033048f6da7$var$useDisableInteractions(buttonProps, isPending);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...props,
        isDisabled: props.isDisabled || isPending
    });
    let renderValues = {
        isHovered: isHovered,
        isPressed: (ctx.isPressed || isPressed) && !isPending,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: props.isDisabled || false,
        isPending: isPending ?? false
    };
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: renderValues,
        defaultClassName: 'react-aria-Button'
    });
    let buttonId = (0, $25dFS.useId)(buttonProps.id);
    let progressId = (0, $25dFS.useId)();
    let ariaLabelledby = buttonProps['aria-labelledby'];
    if (isPending) {
        // aria-labelledby wins over aria-label
        // https://www.w3.org/TR/accname-1.2/#computation-steps
        if (ariaLabelledby) ariaLabelledby = `${ariaLabelledby} ${progressId}`;
        else if (buttonProps['aria-label']) ariaLabelledby = `${buttonId} ${progressId}`;
    }
    let wasPending = (0, $eF4cA.useRef)(isPending);
    (0, $eF4cA.useEffect)(()=>{
        let message = {
            'aria-labelledby': ariaLabelledby || buttonId
        };
        if (!wasPending.current && isFocused && isPending) (0, $4HiHF.announce)(message, 'assertive');
        else if (wasPending.current && isFocused && !isPending) (0, $4HiHF.announce)(message, 'assertive');
        wasPending.current = isPending;
    }, [
        isPending,
        isFocused,
        ariaLabelledby,
        buttonId
    ]);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).button, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, buttonProps, focusProps, hoverProps),
        // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
        // We do this by changing the button's type to button.
        type: buttonProps.type === 'submit' && isPending ? 'button' : buttonProps.type,
        id: buttonId,
        ref: ref,
        "aria-labelledby": ariaLabelledby,
        slot: props.slot || undefined,
        "aria-disabled": isPending ? 'true' : buttonProps['aria-disabled'],
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": renderValues.isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-pending": isPending || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $lrZgx.ProgressBarContext).Provider, {
        value: {
            id: progressId
        }
    }, renderProps.children));
});
// Events to preserve when isPending is true (for tooltips and other overlays)
const $8c983293789b3e79$var$$7705c033048f6da7$var$PRESERVED_EVENT_PATTERN = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function $8c983293789b3e79$var$$7705c033048f6da7$var$useDisableInteractions(props, isPending) {
    if (isPending) {
        for(const key in props)if (key.startsWith('on') && !$8c983293789b3e79$var$$7705c033048f6da7$var$PRESERVED_EVENT_PATTERN.test(key)) props[key] = undefined;
        props.href = undefined;
        props.target = undefined;
    }
    return props;
}

});
parcelRegister("4HiHF", function(module, exports) {

$parcel$export(module.exports, "announce", () => $cc27aba742b1ddb7$export$a9b970dcc4ae71a9);
$parcel$export(module.exports, "clearAnnouncer", () => $cc27aba742b1ddb7$export$d10ae4f68404609a);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer = null;
function $cc27aba742b1ddb7$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer) {
        $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer = new $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$LiveAnnouncer();
        // wait for the live announcer regions to be added to the dom, then announce
        // otherwise Safari won't announce the message if it's added too quickly
        // found most times less than 100ms were not consistent when announcing with Safari
        // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
        // https://github.com/reactwg/react-18/discussions/102
        // if we're in a test environment, announce without waiting
        if (!(typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined')) setTimeout(()=>{
            if ($cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer?.isAttached()) $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer?.announce(message, assertiveness, timeout);
        }, 100);
        else $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer.announce(message, assertiveness, timeout);
    } else $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $cc27aba742b1ddb7$export$d10ae4f68404609a(assertiveness) {
    if ($cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer) $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer.clear(assertiveness);
}
function $cc27aba742b1ddb7$export$d8686216b8b81b2f() {
    if ($cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer) {
        $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer.destroy();
        $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$LiveAnnouncer {
    constructor(){
        this.node = null;
        this.assertiveLog = null;
        this.politeLog = null;
        if (typeof document !== 'undefined') {
            this.node = document.createElement('div');
            this.node.dataset.liveAnnouncer = 'true';
            // copied from VisuallyHidden
            Object.assign(this.node.style, {
                border: 0,
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap'
            });
            this.assertiveLog = this.createLog('assertive');
            this.node.appendChild(this.assertiveLog);
            this.politeLog = this.createLog('polite');
            this.node.appendChild(this.politeLog);
            document.body.prepend(this.node);
        }
    }
    isAttached() {
        return this.node?.isConnected;
    }
    createLog(ariaLive) {
        let node = document.createElement('div');
        node.setAttribute('role', 'log');
        node.setAttribute('aria-live', ariaLive);
        node.setAttribute('aria-relevant', 'additions');
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = 'assertive', timeout = $cc27aba742b1ddb7$var$$a46cf152bb926da5$var$LIVEREGION_TIMEOUT_DELAY) {
        if (!this.node) return;
        let node = document.createElement('div');
        if (typeof message === 'object') {
            // To read an aria-labelledby, the element must have an appropriate role, such as img.
            node.setAttribute('role', 'img');
            node.setAttribute('aria-labelledby', message['aria-labelledby']);
        } else node.textContent = message;
        if (assertiveness === 'assertive') this.assertiveLog?.appendChild(node);
        else this.politeLog?.appendChild(node);
        if (message !== '') setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if ((!assertiveness || assertiveness === 'assertive') && this.assertiveLog) this.assertiveLog.innerHTML = '';
        if ((!assertiveness || assertiveness === 'polite') && this.politeLog) this.politeLog.innerHTML = '';
    }
}

});

parcelRegister("fipJz", function(module, exports) {

$parcel$export(module.exports, "useButton", () => $1e71380cd282f624$export$ea18c227d4417cc3);

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $bEes0 = parcelRequire("bEes0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e71380cd282f624$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = 'button', isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: onClick, href: href, target: target, rel: rel, type: type = 'button' } = props;
    let additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled,
        form: props.form,
        formAction: props.formAction,
        formEncType: props.formEncType,
        formMethod: props.formMethod,
        formNoValidate: props.formNoValidate,
        formTarget: props.formTarget,
        name: props.name,
        value: props.value
    };
    else additionalProps = {
        role: 'button',
        href: elementType === 'a' && !isDisabled ? href : undefined,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $lhKAD.mergeProps)(focusableProps, pressProps, (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $lhKAD.mergeProps)(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            'aria-current': props['aria-current'],
            'aria-disabled': props['aria-disabled']
        })
    };
}

});
parcelRegister("bEes0", function(module, exports) {

$parcel$export(module.exports, "usePress", () => $211b14377fa9e590$export$45712eceda6fad21);

var $d8j5I = parcelRequire("d8j5I");

var $wjtfD = parcelRequire("wjtfD");

var $gvTw2 = parcelRequire("gvTw2");

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $k1844 = parcelRequire("k1844");

var $7ByPJ = parcelRequire("7ByPJ");

var $11FxZ = parcelRequire("11FxZ");

var $9J8wU = parcelRequire("9J8wU");

var $lhKAD = parcelRequire("lhKAD");

var $aGgVM = parcelRequire("aGgVM");

var $g0FJ3 = parcelRequire("g0FJ3");

var $4lMDe = parcelRequire("4lMDe");

var $ed0Y6 = parcelRequire("ed0Y6");

var $eLOK5 = parcelRequire("eLOK5");
parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $211b14377fa9e590$var$$d27d541f9569d26d$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $eF4cA.useContext)((0, $g0FJ3.PressResponderContext));
    if (context) {
        // Prevent mergeProps from merging ref.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let { register: register, ref: ref, ...contextProps } = context;
        props = (0, $lhKAD.mergeProps)(contextProps, props);
        register();
    }
    (0, $eLOK5.useSyncRef)(context, props.ref);
    return props;
}
class $211b14377fa9e590$var$$d27d541f9569d26d$var$PressEvent {
    #shouldStopPropagation;
    constructor(type, pointerType, originalEvent, state){
        this.#shouldStopPropagation = true;
        let currentTarget = state?.target ?? originalEvent.currentTarget;
        const rect = currentTarget?.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
        this.key = originalEvent.key;
    }
    continuePropagation() {
        this.#shouldStopPropagation = false;
    }
    get shouldStopPropagation() {
        return this.#shouldStopPropagation;
    }
}
const $211b14377fa9e590$var$$d27d541f9569d26d$var$LINK_CLICKED = Symbol('linkClicked');
const $211b14377fa9e590$var$$d27d541f9569d26d$var$STYLE_ID = 'react-aria-pressable-style';
const $211b14377fa9e590$var$$d27d541f9569d26d$var$PRESSABLE_ATTRIBUTE = 'data-react-aria-pressable';
function $211b14377fa9e590$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onClick: onClick, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: domRef, ...domProps } = $211b14377fa9e590$var$$d27d541f9569d26d$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $eF4cA.useState)(false);
    let ref = (0, $eF4cA.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null,
        disposables: []
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $ed0Y6.useGlobalListeners)();
    let triggerPressStart = (0, $eF4cA.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $211b14377fa9e590$var$$d27d541f9569d26d$var$PressEvent('pressstart', pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressStart,
        onPressChange
    ]);
    let triggerPressEnd = (0, $eF4cA.useCallback)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $211b14377fa9e590$var$$d27d541f9569d26d$var$PressEvent('pressend', pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $211b14377fa9e590$var$$d27d541f9569d26d$var$PressEvent('press', pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation &&= event.shouldStopPropagation;
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressEnd,
        onPressChange,
        onPress
    ]);
    let triggerPressEndEvent = (0, $4lMDe.useEffectEvent)(triggerPressEnd);
    let triggerPressUp = (0, $eF4cA.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $211b14377fa9e590$var$$d27d541f9569d26d$var$PressEvent('pressup', pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    }, [
        isDisabled,
        onPressUp
    ]);
    let triggerPressUpEvent = (0, $4lMDe.useEffectEvent)(triggerPressUp);
    let cancel = (0, $eF4cA.useCallback)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $gvTw2.restoreTextSelection)(state.target);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        }
    }, [
        allowTextSelectionOnPress,
        removeAllGlobalListeners,
        triggerPressEnd
    ]);
    let cancelEvent = (0, $4lMDe.useEffectEvent)(cancel);
    (0, $eF4cA.useEffect)(()=>{
        if (isDisabled && ref.current.isPressed) cancelEvent({
            currentTarget: ref.current.target,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false,
            altKey: false
        });
    }, [
        isDisabled
    ]);
    let cancelOnPointerExit = (0, $eF4cA.useCallback)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    }, [
        shouldCancelOnPointerExit,
        cancel
    ]);
    let triggerClick = (0, $eF4cA.useCallback)((e)=>{
        if (isDisabled) return;
        onClick?.(e);
    }, [
        isDisabled,
        onClick
    ]);
    let triggerSyntheticClick = (0, $eF4cA.useCallback)((e, target)=>{
        if (isDisabled) return;
        // Some third-party libraries pass in onClick instead of onPress.
        // Create a fake mouse event and trigger onClick as well.
        // This matches the browser's native activation behavior for certain elements (e.g. button).
        // https://html.spec.whatwg.org/#activation
        // https://html.spec.whatwg.org/#fire-a-synthetic-pointer-event
        if (onClick) {
            let event = new MouseEvent('click', e);
            (0, $wjtfD.setEventTarget)(event, target);
            onClick((0, $wjtfD.createSyntheticEvent)(event));
        }
    }, [
        isDisabled,
        onClick
    ]);
    let pressProps = (0, $eF4cA.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($211b14377fa9e590$var$$d27d541f9569d26d$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && (0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) {
                    if ($211b14377fa9e590$var$$d27d541f9569d26d$var$shouldPreventDefaultKeyboard((0, $fvyIQ.getEventTarget)(e), e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        state.pointerType = 'keyboard';
                        shouldStopPropagation = triggerPressStart(e, 'keyboard');
                    }
                    // Focus may move before the key up event, so register the event on the document
                    // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                    // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                    let originalTarget = e.currentTarget;
                    let pressUp = (e)=>{
                        if ($211b14377fa9e590$var$$d27d541f9569d26d$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && (0, $fvyIQ.nodeContains)(originalTarget, (0, $fvyIQ.getEventTarget)(e)) && state.target) triggerPressUpEvent($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(state.target, e), 'keyboard');
                    };
                    addGlobalListener((0, $7ByPJ.getOwnerDocument)(e.currentTarget), 'keyup', (0, $d8j5I.chain)(pressUp, onKeyUp), true);
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $11FxZ.isMac)()) state.metaKeyEvents?.set(e.key, e.nativeEvent);
                } else if (e.key === 'Meta') state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aGgVM.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === 'virtual' || (0, $9J8wU.isVirtualClick)(e.nativeEvent))) {
                        let stopPressStart = triggerPressStart(e, 'virtual');
                        let stopPressUp = triggerPressUpEvent(e, 'virtual');
                        let stopPressEnd = triggerPressEndEvent(e, 'virtual');
                        triggerClick(e);
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    } else if (state.isPressed && state.pointerType !== 'keyboard') {
                        let pointerType = state.pointerType || e.nativeEvent.pointerType || 'virtual';
                        let stopPressUp = triggerPressUpEvent($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(e.currentTarget, e), pointerType);
                        let stopPressEnd = triggerPressEndEvent($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(e.currentTarget, e), pointerType, true);
                        shouldStopPropagation = stopPressUp && stopPressEnd;
                        state.isOverTarget = false;
                        triggerClick(e);
                        // oxlint-disable-next-line react/react-compiler
                        cancelEvent(e);
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && state.target && $211b14377fa9e590$var$$d27d541f9569d26d$var$isValidKeyboardEvent(e, state.target)) {
                if ($211b14377fa9e590$var$$d27d541f9569d26d$var$shouldPreventDefaultKeyboard((0, $fvyIQ.getEventTarget)(e), e.key)) e.preventDefault();
                let target = (0, $fvyIQ.getEventTarget)(e);
                let wasPressed = (0, $fvyIQ.nodeContains)(state.target, target);
                triggerPressEndEvent($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(state.target, e), 'keyboard', wasPressed);
                if (wasPressed) triggerSyntheticClick(e, state.target);
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== 'Enter' && $211b14377fa9e590$var$$d27d541f9569d26d$var$isHTMLAnchorLink(state.target) && (0, $fvyIQ.nodeContains)(state.target, target) && !e[$211b14377fa9e590$var$$d27d541f9569d26d$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$211b14377fa9e590$var$$d27d541f9569d26d$var$LINK_CLICKED] = true;
                    (0, $aGgVM.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                state.metaKeyEvents?.delete(e.key);
            } else if (e.key === 'Meta' && state.metaKeyEvents?.size) {
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())state.target?.dispatchEvent(new KeyboardEvent('keyup', event));
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $9J8wU.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!allowTextSelectionOnPress) (0, $gvTw2.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    // Release pointer capture so that touch interactions can leave the original target.
                    // This enables onPointerLeave and onPointerEnter to fire.
                    let target = (0, $fvyIQ.getEventTarget)(e);
                    if ('releasePointerCapture' in target) {
                        if ('hasPointerCapture' in target) {
                            if (target.hasPointerCapture(e.pointerId)) target.releasePointerCapture(e.pointerId);
                        } else target.releasePointerCapture(e.pointerId);
                    }
                    addGlobalListener((0, $7ByPJ.getOwnerDocument)(e.currentTarget), 'pointerup', onPointerUp, false);
                    addGlobalListener((0, $7ByPJ.getOwnerDocument)(e.currentTarget), 'pointercancel', onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
                if (e.button === 0) {
                    if (preventFocusOnPress) {
                        let dispose = (0, $wjtfD.preventFocus)(e.target);
                        if (dispose) state.disposables.push(dispose);
                    }
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e)) || state.pointerType === 'virtual') return;
                // Only handle left clicks. If isPressed is true, delay until onClick.
                if (e.button === 0 && !state.isPressed) triggerPressUpEvent(e, state.pointerType || e.pointerType);
            };
            pressProps.onPointerEnter = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = true;
                    triggerPressStart($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(state.target, e), state.pointerType);
                }
            };
            pressProps.onPointerLeave = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEndEvent($211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ((0, $fvyIQ.nodeContains)(state.target, (0, $fvyIQ.getEventTarget)(e)) && state.pointerType != null) {
                        // Wait for onClick to fire onPress. This avoids browser issues when the DOM
                        // is mutated between onPointerUp and onClick, and is more compatible with third party libraries.
                        // https://github.com/adobe/react-spectrum/issues/1513
                        // https://issues.chromium.org/issues/40732224
                        // However, iOS and Android do not focus or fire onClick after a long press.
                        // We work around this by triggering a click ourselves after a timeout.
                        // This timeout is canceled during the click event in case the real one fires first.
                        // The timeout must be at least 32ms, because Safari on iOS delays the click event on
                        // non-form elements without certain ARIA roles (for hover emulation).
                        // https://github.com/WebKit/WebKit/blob/dccfae42bb29bd4bdef052e469f604a9387241c0/Source/WebKit/WebProcess/WebPage/ios/WebPageIOS.mm#L875-L892
                        let clicked = false;
                        let timeout = setTimeout(()=>{
                            if (state.isPressed && state.target instanceof HTMLElement) {
                                if (clicked) cancelEvent(e);
                                else {
                                    (0, $2jk5s.focusWithoutScrolling)(state.target);
                                    state.target.click();
                                }
                            }
                        }, 80);
                        // Use a capturing listener to track if a click occurred.
                        // If stopPropagation is called it may never reach our handler.
                        addGlobalListener(e.currentTarget, 'click', ()=>clicked = true, true);
                        state.disposables.push(()=>clearTimeout(timeout));
                    } else cancelEvent(e);
                    // Ignore subsequent onPointerLeave event before onClick on touch devices.
                    state.isOverTarget = false;
                }
            };
            let onPointerCancel = (e)=>{
                cancelEvent(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancelEvent(e);
            };
        } else var e, e1, e2, e3, e4, e5, e6, e7, e8;
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancelOnPointerExit,
        triggerPressStart,
        triggerClick,
        triggerSyntheticClick
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!domRef || false) return;
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(domRef.current);
        if (!ownerDocument || !ownerDocument.head || ownerDocument.getElementById($211b14377fa9e590$var$$d27d541f9569d26d$var$STYLE_ID)) return;
        const style = ownerDocument.createElement('style');
        style.id = $211b14377fa9e590$var$$d27d541f9569d26d$var$STYLE_ID;
        let nonce = (0, $k1844.getNonce)(ownerDocument);
        if (nonce) style.nonce = nonce;
        // touchAction: 'manipulation' is supposed to be equivalent, but in
        // Safari it causes onPointerCancel not to fire on scroll.
        // https://bugs.webkit.org/show_bug.cgi?id=240917
        style.textContent = `
@layer {
  [${$211b14377fa9e590$var$$d27d541f9569d26d$var$PRESSABLE_ATTRIBUTE}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim();
        ownerDocument.head.prepend(style);
    }, [
        domRef
    ]);
    (0, $eF4cA.useEffect)(()=>{
        let state = ref.current;
        return ()=>{
            if (!allowTextSelectionOnPress) (0, $gvTw2.restoreTextSelection)(state.target ?? undefined);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        // oxlint-disable-next-line react/react-compiler
        pressProps: (0, $lhKAD.mergeProps)(domProps, pressProps, {
            [$211b14377fa9e590$var$$d27d541f9569d26d$var$PRESSABLE_ATTRIBUTE]: true
        })
    };
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof (0, $7ByPJ.getOwnerWindow)(element).HTMLInputElement && !$211b14377fa9e590$var$$d27d541f9569d26d$var$isValidInputKey(element, key) || element instanceof (0, $7ByPJ.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === 'link' || !role && $211b14377fa9e590$var$$d27d541f9569d26d$var$isHTMLAnchorLink(element)) && key !== 'Enter');
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY,
        key: e.key
    };
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $211b14377fa9e590$var$$d27d541f9569d26d$var$getPointClientRect(point);
    return $211b14377fa9e590$var$$d27d541f9569d26d$var$areRectanglesOverlapping(rect, pointRect);
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$shouldPreventDefaultUp(target) {
    if (target instanceof HTMLInputElement) return false;
    if (target instanceof HTMLButtonElement) return target.type !== 'submit' && target.type !== 'reset';
    if ($211b14377fa9e590$var$$d27d541f9569d26d$var$isHTMLAnchorLink(target)) return false;
    return true;
}
function $211b14377fa9e590$var$$d27d541f9569d26d$var$shouldPreventDefaultKeyboard(target, key) {
    // Don't prevent the contextmenu shortcut on mac.
    if ((0, $11FxZ.isMac)() && key === 'Enter') return false;
    if (target instanceof HTMLInputElement) {
        if (key === 'Enter' && (target.type === 'checkbox' || target.type === 'radio')) return false;
        return !$211b14377fa9e590$var$$d27d541f9569d26d$var$isValidInputKey(target, key);
    }
    return $211b14377fa9e590$var$$d27d541f9569d26d$var$shouldPreventDefaultUp(target);
}
const $211b14377fa9e590$var$$d27d541f9569d26d$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $211b14377fa9e590$var$$d27d541f9569d26d$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $211b14377fa9e590$var$$d27d541f9569d26d$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("gvTw2", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", () => $2121f0080647131d$export$16a4697467175487);
$parcel$export(module.exports, "restoreTextSelection", () => $2121f0080647131d$export$b0d6fa1ab32e3295);

var $7ByPJ = parcelRequire("7ByPJ");

var $11FxZ = parcelRequire("11FxZ");

var $iUhPJ = parcelRequire("iUhPJ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $2121f0080647131d$var$$cbf007e418543821$var$state = 'default';
let $2121f0080647131d$var$$cbf007e418543821$var$savedUserSelect = '';
let $2121f0080647131d$var$$cbf007e418543821$var$modifiedElementMap = new WeakMap();
function $2121f0080647131d$export$16a4697467175487(target) {
    if ((0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)()) {
        if ($2121f0080647131d$var$$cbf007e418543821$var$state === 'default') {
            const documentObject = (0, $7ByPJ.getOwnerDocument)(target);
            $2121f0080647131d$var$$cbf007e418543821$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = 'none';
        }
        $2121f0080647131d$var$$cbf007e418543821$var$state = 'disabled';
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
        $2121f0080647131d$var$$cbf007e418543821$var$modifiedElementMap.set(target, target.style[property]);
        target.style[property] = 'none';
    }
}
function $2121f0080647131d$export$b0d6fa1ab32e3295(target) {
    if ((0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($2121f0080647131d$var$$cbf007e418543821$var$state !== 'disabled') return;
        $2121f0080647131d$var$$cbf007e418543821$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $iUhPJ.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($2121f0080647131d$var$$cbf007e418543821$var$state === 'restoring') {
                    const documentObject = (0, $7ByPJ.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === 'none') documentObject.documentElement.style.webkitUserSelect = $2121f0080647131d$var$$cbf007e418543821$var$savedUserSelect || '';
                    $2121f0080647131d$var$$cbf007e418543821$var$savedUserSelect = '';
                    $2121f0080647131d$var$$cbf007e418543821$var$state = 'default';
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $2121f0080647131d$var$$cbf007e418543821$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $2121f0080647131d$var$$cbf007e418543821$var$modifiedElementMap.get(target);
            let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
            if (target.style[property] === 'none') target.style[property] = targetOldUserSelect;
            if (target.getAttribute('style') === '') target.removeAttribute('style');
            $2121f0080647131d$var$$cbf007e418543821$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("k1844", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $fc30c53f9f9a07a3$export$2b85b721e524d74b);

var $aRGQy = parcelRequire("aRGQy");

var $7ByPJ = parcelRequire("7ByPJ");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $fc30c53f9f9a07a3$var$$2b2d34ff061957fb$var$nonceCache = new WeakMap();
function $fc30c53f9f9a07a3$export$88b319273f3705b4() {
    $fc30c53f9f9a07a3$var$$2b2d34ff061957fb$var$nonceCache = new WeakMap();
}
function $fc30c53f9f9a07a3$export$2b85b721e524d74b(doc) {
    let ownerDocument = (0, $7ByPJ.getOwnerDocument)(doc);
    let nonce = $fc30c53f9f9a07a3$var$$2b2d34ff061957fb$var$nonceCache.get(ownerDocument);
    nonce ??= (0, $aRGQy.getMetaValue)('csp-nonce', ownerDocument);
    if (nonce !== undefined) $fc30c53f9f9a07a3$var$$2b2d34ff061957fb$var$nonceCache.set(ownerDocument, nonce);
    return nonce;
}

});
parcelRegister("aRGQy", function(module, exports) {

$parcel$export(module.exports, "getMetaValue", () => $5ca55944a0c5e0ba$export$a929f3f93e2cc67e);

var $7ByPJ = parcelRequire("7ByPJ");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5ca55944a0c5e0ba$export$a929f3f93e2cc67e(key, doc) {
    let ownerWindow = (0, $7ByPJ.getOwnerWindow)(doc);
    let ownerDocument = (0, $7ByPJ.getOwnerDocument)(doc);
    if (ownerDocument == null || ownerWindow == null) return;
    let content = undefined;
    let selector = `meta[name="${CSS.escape(key)}"], meta[property="${CSS.escape(key)}"]`;
    let meta = ownerDocument.querySelector(selector);
    if (meta && meta instanceof ownerWindow.HTMLMetaElement) {
        if (key === 'csp-nonce' && meta.nonce) content ??= meta.nonce || undefined;
        if (meta.content) content ??= meta.content || undefined;
    }
    if (key === 'csp-nonce') content ??= ownerWindow.__webpack_nonce__ || globalThis.__webpack_nonce__ || undefined;
    return content;
}

});


parcelRegister("g0FJ3", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", () => $8261648f532e7643$export$5165eccb35aaadb5);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8261648f532e7643$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext({
    register: ()=>{}
});
$8261648f532e7643$export$5165eccb35aaadb5.displayName = 'PressResponderContext';

});

parcelRegister("4lMDe", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $e1fab00d052f0707$export$7f54fc3180508a52);

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Use the earliest effect type possible. useInsertionEffect runs during the mutation phase,
// before all layout effects, but is available only in React 18 and later.
const $e1fab00d052f0707$var$$fe16bffc7a557bf0$var$useEarlyEffect = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useInsertionEffect'] ?? (0, $4skXn.useLayoutEffect);
function $e1fab00d052f0707$export$7f54fc3180508a52(fn) {
    const ref = (0, $eF4cA.useRef)(null);
    $e1fab00d052f0707$var$$fe16bffc7a557bf0$var$useEarlyEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $eF4cA.useCallback)((...args)=>{
        const f = ref.current;
        return f?.(...args);
    }, []);
}

});

parcelRegister("ed0Y6", function(module, exports) {

$parcel$export(module.exports, "useGlobalListeners", () => $1ec439286f5a7ac2$export$4eaf04e54aa8eed6);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1ec439286f5a7ac2$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $eF4cA.useRef)(new Map());
    let addGlobalListener = (0, $eF4cA.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = options?.once ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    let removeGlobalListener = (0, $eF4cA.useCallback)((eventTarget, type, listener, options)=>{
        let fn = globalListeners.current.get(listener)?.fn || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $eF4cA.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}

});



parcelRegister("3h1XC", function(module, exports) {

$parcel$export(module.exports, "useFocusRing", () => $7d370817a99a3ed8$export$4e328f61c538687f);

var $YxOvP = parcelRequire("YxOvP");

var $4bE7h = parcelRequire("4bE7h");

var $i1DSg = parcelRequire("i1DSg");

var $eF4cA = parcelRequire("eF4cA");
function $7d370817a99a3ed8$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $eF4cA.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $YxOvP.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $eF4cA.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $eF4cA.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $eF4cA.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $eF4cA.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        state.current.isFocusVisible = (0, $YxOvP.isFocusVisible)();
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $YxOvP.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [
        isTextInput,
        isFocused
    ], {
        enabled: isFocused,
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $4bE7h.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

});
parcelRegister("i1DSg", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", () => $9044d5f2fb9237a1$export$420e68273165f4ec);

var $wjtfD = parcelRequire("wjtfD");

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $ed0Y6 = parcelRequire("ed0Y6");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $9044d5f2fb9237a1$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $eF4cA.useRef)({
        isFocusWithin: false
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $ed0Y6.useGlobalListeners)();
    let onBlur = (0, $eF4cA.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !(0, $fvyIQ.nodeContains)(e.currentTarget, e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    let onSyntheticFocus = (0, $wjtfD.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $eF4cA.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        let eventTarget = (0, $fvyIQ.getEventTarget)(e);
        const ownerDocument = (0, $7ByPJ.getOwnerDocument)(eventTarget);
        const activeElement = (0, $fvyIQ.getActiveElement)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === eventTarget) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            let currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', (e)=>{
                let eventTarget = (0, $fvyIQ.getEventTarget)(e);
                if (state.current.isFocusWithin && !(0, $fvyIQ.nodeContains)(currentTarget, eventTarget)) {
                    let nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: eventTarget
                    });
                    (0, $wjtfD.setEventTarget)(nativeEvent, currentTarget);
                    let event = (0, $wjtfD.createSyntheticEvent)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});


parcelRegister("j2JDe", function(module, exports) {

$parcel$export(module.exports, "useHover", () => $e7cfc423a1908f00$export$ae780daf29e6d456);

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $ed0Y6 = parcelRequire("ed0Y6");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents = false;
let $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$hoverCount = 0;
function $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$setGlobalIgnoreEmulatedMouseEvents() {
    $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents = false;
    }, 500);
}
function $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$setupGlobalTouchEvents() {
    let ownerDocument = (0, $7ByPJ.getOwnerDocument)(null);
    if (typeof ownerDocument === 'undefined') return;
    if ($e7cfc423a1908f00$var$$e969f22b6713ca4a$var$hoverCount === 0) {
        if (typeof PointerEvent !== 'undefined') ownerDocument.addEventListener('pointerup', $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$handleGlobalPointerEvent);
    }
    $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$hoverCount++;
    return ()=>{
        $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$hoverCount--;
        if ($e7cfc423a1908f00$var$$e969f22b6713ca4a$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') ownerDocument.removeEventListener('pointerup', $e7cfc423a1908f00$var$$e969f22b6713ca4a$var$handleGlobalPointerEvent);
    };
}
function $e7cfc423a1908f00$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $eF4cA.useState)(false);
    let state = (0, $eF4cA.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $eF4cA.useEffect)($e7cfc423a1908f00$var$$e969f22b6713ca4a$var$setupGlobalTouchEvents, []);
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $ed0Y6.useGlobalListeners)();
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $eF4cA.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !(0, $fvyIQ.nodeContains)(event.currentTarget, (0, $fvyIQ.getEventTarget)(event))) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            // When an element that is hovered over is removed, no pointerleave event is fired by the browser,
            // even though the originally hovered target may have shrunk in size so it is no longer hovered.
            // However, a pointerover event will be fired on the new target the mouse is over.
            // In Chrome this happens immediately. In Safari and Firefox, it happens upon moving the mouse one pixel.
            addGlobalListener((0, $7ByPJ.getOwnerDocument)((0, $fvyIQ.getEventTarget)(event)), 'pointerover', (e)=>{
                if (state.isHovered && state.target && !(0, $fvyIQ.nodeContains)(state.target, (0, $fvyIQ.getEventTarget)(e))) triggerHoverEnd(e, e.pointerType);
            }, {
                capture: true
            });
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            let target = state.target;
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered || !target) return;
            state.isHovered = false;
            removeAllGlobalListeners();
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($e7cfc423a1908f00$var$$e969f22b6713ca4a$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && (0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) triggerHoverEnd(e, e.pointerType);
            };
        } else var e, e1;
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state,
        addGlobalListener,
        removeAllGlobalListeners
    ]);
    (0, $eF4cA.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});


parcelRegister("k8kxd", function(module, exports) {

$parcel$export(module.exports, "LinkContext", () => $b6031d6f770a7e77$export$e2509388b49734e7);
$parcel$export(module.exports, "Link", () => $b6031d6f770a7e77$export$a6c7ac8248d6e38a);

var $fDYaM = parcelRequire("fDYaM");

var $lMcBU = parcelRequire("lMcBU");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b6031d6f770a7e77$export$e2509388b49734e7 = (0, $eF4cA.createContext)(null);
const $b6031d6f770a7e77$export$a6c7ac8248d6e38a = (0, $eF4cA.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $b6031d6f770a7e77$export$e2509388b49734e7);
    let elementType = props.href && !props.isDisabled ? 'a' : 'span';
    let { linkProps: linkProps, isPressed: isPressed } = (0, $lMcBU.useLink)({
        ...props,
        elementType: elementType
    }, ref);
    let ElementType = (0, $fDYaM.dom)[elementType];
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)(props);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Link',
        values: {
            isCurrent: !!props['aria-current'],
            isDisabled: props.isDisabled || false,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        ref: ref,
        slot: props.slot || undefined,
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, linkProps, hoverProps, focusProps),
        "data-focused": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-pressed": isPressed || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-current": !!props['aria-current'] || undefined,
        "data-disabled": props.isDisabled || undefined
    }, renderProps.children);
});

});
parcelRegister("lMcBU", function(module, exports) {

$parcel$export(module.exports, "useLink", () => $205468b78da1d52f$export$dcf14c9974fe2767);

var $fVfXf = parcelRequire("fVfXf");

var $aGgVM = parcelRequire("aGgVM");

var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $bEes0 = parcelRequire("bEes0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $205468b78da1d52f$export$dcf14c9974fe2767(props, ref) {
    let { elementType: elementType = 'a', onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onClick: onClick, isDisabled: isDisabled, ...otherProps } = props;
    let linkProps = {};
    if (elementType !== 'a') linkProps = {
        role: 'link',
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)(props, ref);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onClick: onClick,
        isDisabled: isDisabled,
        ref: ref
    });
    let domProps = (0, $fVfXf.filterDOMProps)(otherProps, {
        labelable: true
    });
    let interactionHandlers = (0, $lhKAD.mergeProps)(focusableProps, pressProps);
    let router = (0, $aGgVM.useRouter)();
    let routerLinkProps = (0, $aGgVM.useLinkProps)(props);
    return {
        isPressed: isPressed,
        linkProps: (0, $lhKAD.mergeProps)(domProps, routerLinkProps, {
            ...interactionHandlers,
            ...linkProps,
            'aria-disabled': isDisabled || undefined,
            'aria-current': props['aria-current'],
            onClick: (e)=>{
                pressProps.onClick?.(e);
                (0, $aGgVM.handleLinkClick)(e, router, props.href, props.routerOptions);
            }
        })
    };
}

});


parcelRegister("8gDpA", function(module, exports) {

$parcel$export(module.exports, "DialogContext", () => $a7950aca3e562825$export$8b93a07348a7730c);
$parcel$export(module.exports, "OverlayTriggerStateContext", () => $a7950aca3e562825$export$d2f961adcb0afbe);
$parcel$export(module.exports, "DialogTrigger", () => $a7950aca3e562825$export$2e1e1122cf0cba88);
$parcel$export(module.exports, "Dialog", () => $a7950aca3e562825$export$3ddf2d174ce01153);

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $1O9kP = parcelRequire("1O9kP");

var $f8UJ0 = parcelRequire("f8UJ0");

var $bVwb4 = parcelRequire("bVwb4");

var $c1ibQ = parcelRequire("c1ibQ");

var $lyU6I = parcelRequire("lyU6I");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $7aYcI = parcelRequire("7aYcI");

var $eF4cA = parcelRequire("eF4cA");

var $25dFS = parcelRequire("25dFS");

var $19ZgV = parcelRequire("19ZgV");

var $2esle = parcelRequire("2esle");

var $kzSDh = parcelRequire("kzSDh");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a7950aca3e562825$export$8b93a07348a7730c = (0, $eF4cA.createContext)(null);
const $a7950aca3e562825$export$d2f961adcb0afbe = (0, $eF4cA.createContext)(null);
function $a7950aca3e562825$export$2e1e1122cf0cba88(props) {
    // Use useMenuTriggerState instead of useOverlayTriggerState in case a menu is embedded in the dialog.
    // This is needed to handle submenus.
    let state = (0, $2esle.useMenuTriggerState)(props);
    let buttonRef = (0, $eF4cA.useRef)(null);
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $kzSDh.useOverlayTrigger)({
        type: 'dialog'
    }, state, buttonRef);
    // Label dialog by the trigger as a fallback if there is no title slot.
    // This is done in RAC instead of hooks because otherwise we cannot distinguish
    // between context and props. Normally aria-labelledby overrides the title
    // but when sent by context we want the title to win.
    // oxlint-disable-next-line react/react-compiler
    triggerProps.id = (0, $25dFS.useId)();
    // oxlint-disable-next-line react/react-compiler
    overlayProps['aria-labelledby'] = triggerProps.id;
    // If within a collection (e.g. Tabs), render nothing.
    // Not using createHideableComponent for this because that also creates a forwardRef.
    let isHidden = (0, $19ZgV.useIsHidden)();
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $a7950aca3e562825$export$d2f961adcb0afbe,
                state
            ],
            [
                (0, $bVwb4.RootMenuTriggerStateContext),
                state
            ],
            [
                $a7950aca3e562825$export$8b93a07348a7730c,
                overlayProps
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    trigger: 'DialogTrigger',
                    triggerRef: buttonRef,
                    id: overlayProps.id,
                    'aria-labelledby': overlayProps['aria-labelledby']
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $7aYcI.PressResponder), {
        ...triggerProps,
        ref: buttonRef,
        isPressed: state.isOpen
    }, props.children));
}
const $a7950aca3e562825$export$3ddf2d174ce01153 = (0, $eF4cA.forwardRef)(function Dialog(props, ref) {
    let originalAriaLabelledby = props['aria-labelledby'];
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $a7950aca3e562825$export$8b93a07348a7730c);
    let { dialogProps: dialogProps, titleProps: titleProps, contentProps: contentProps } = (0, $lyU6I.useDialog)({
        ...props,
        // Only pass aria-labelledby from props, not context.
        // Context is used as a fallback below.
        'aria-labelledby': originalAriaLabelledby
    }, ref);
    let state = (0, $eF4cA.useContext)($a7950aca3e562825$export$d2f961adcb0afbe);
    if (!dialogProps['aria-label'] && !dialogProps['aria-labelledby']) // If aria-labelledby exists on props, we know it came from context.
    // Use that as a fallback in case there is no title slot.
    {
        if (props['aria-labelledby']) dialogProps['aria-labelledby'] = props['aria-labelledby'];
    }
    let renderProps = (0, $fDYaM.useRenderProps)({
        defaultClassName: 'react-aria-Dialog',
        className: props.className,
        style: props.style,
        children: props.children,
        values: {
            close: state?.close || (()=>{})
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).section, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, dialogProps),
        render: props.render,
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $1O9kP.HeadingContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        title: {
                            ...titleProps,
                            level: 2
                        }
                    }
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        description: contentProps
                    }
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        close: {
                            onPress: ()=>state?.close()
                        }
                    }
                }
            ]
        ]
    }, renderProps.children));
});

});
parcelRegister("f8UJ0", function(module, exports) {

$parcel$export(module.exports, "PopoverContext", () => $7df40d250fa9a501$export$9b9a0cd73afb7ca4);
$parcel$export(module.exports, "Popover", () => $7df40d250fa9a501$export$5b6b19405a83ff9d);

var $fDYaM = parcelRequire("fDYaM");

var $eENmv = parcelRequire("eENmv");

var $8gDpA = parcelRequire("8gDpA");

var $6XFNb = parcelRequire("6XFNb");

var $br9QK = parcelRequire("br9QK");
var $k771r = parcelRequire("k771r");

var $fVfXf = parcelRequire("fVfXf");

var $eNuje = parcelRequire("eNuje");

var $YxOvP = parcelRequire("YxOvP");

var $fvyIQ = parcelRequire("fvyIQ");

var $lhKAD = parcelRequire("lhKAD");

var $lIr3v = parcelRequire("lIr3v");

var $eF4cA = parcelRequire("eF4cA");

var $gVozo = parcelRequire("gVozo");

var $6AczJ = parcelRequire("6AczJ");

var $19ZgV = parcelRequire("19ZgV");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $f9wnx = parcelRequire("f9wnx");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7df40d250fa9a501$export$9b9a0cd73afb7ca4 = (0, $eF4cA.createContext)(null);
// Stores a ref for the portal container for a group of popovers (e.g. submenus).
const $7df40d250fa9a501$var$$542a13ca2fa5b484$var$PopoverGroupContext = (0, $eF4cA.createContext)(null);
const $7df40d250fa9a501$export$5b6b19405a83ff9d = (0, $eF4cA.forwardRef)(function Popover(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $7df40d250fa9a501$export$9b9a0cd73afb7ca4);
    let contextState = (0, $eF4cA.useContext)((0, $8gDpA.OverlayTriggerStateContext));
    let localState = (0, $lIr3v.useOverlayTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    // Skip the automatic exit animation when closing instantly (e.g. swapping between previews
    // during warmup). An explicitly provided isExiting prop still takes precedence.
    let exitAnimation = (0, $6AczJ.useExitAnimation)(ref, state.isOpen);
    let isExiting = props.isExiting || !props.shouldSkipAnimation && exitAnimation || false;
    let isHidden = (0, $19ZgV.useIsHidden)();
    let { direction: direction } = (0, $1ntKq.useLocale)();
    // If we are in a hidden tree, we still need to preserve our children.
    if (isHidden) {
        let children = props.children;
        if (typeof children === 'function') children = children({
            trigger: props.trigger || null,
            placement: 'bottom',
            isEntering: false,
            isExiting: false,
            defaultChildren: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, children);
    }
    if (state && !state.isOpen && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7df40d250fa9a501$var$$542a13ca2fa5b484$var$PopoverInner, {
        ...props,
        triggerRef: props.triggerRef,
        state: state,
        popoverRef: ref,
        isExiting: isExiting,
        dir: direction
    });
});
function $7df40d250fa9a501$var$$542a13ca2fa5b484$var$PopoverInner({ state: state, isExiting: isExiting, UNSTABLE_portalContainer: UNSTABLE_portalContainer, clearContexts: clearContexts, ...props }) {
    // Calculate the arrow size internally (and remove props.arrowSize from PopoverProps)
    // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
    let arrowRef = (0, $eF4cA.useRef)(null);
    let containerRef = (0, $eF4cA.useRef)(null);
    let groupCtx = (0, $eF4cA.useContext)($7df40d250fa9a501$var$$542a13ca2fa5b484$var$PopoverGroupContext);
    let isSubPopover = groupCtx && props.trigger === 'SubmenuTrigger';
    let [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    let { popoverProps: popoverProps, underlayProps: underlayProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: triggerAnchorPoint } = (0, $6XFNb.usePopover)({
        ...props,
        offset: props.offset ?? 8,
        arrowRef: arrowRef,
        // If this is a submenu/subdialog, use the root popover's container
        // to detect outside interaction and add aria-hidden.
        groupRef: isSubPopover ? groupCtx : containerRef
    }, state);
    let ref = props.popoverRef;
    // Skip the automatic entry animation when opening instantly (e.g. swapping between previews
    // during warmup). An explicitly provided isEntering prop still takes precedence.
    let enterAnimation = (0, $6AczJ.useEnterAnimation)(ref, !!placement && isOpen);
    // oxlint-disable-next-line react/react-compiler
    let isEntering = props.isEntering || !props.shouldSkipAnimation && enterAnimation || false;
    // oxlint-disable-next-line react/react-compiler
    let renderProps = (0, $fDYaM.useRenderProps)({
        // oxlint-disable-next-line react/react-compiler
        ...props,
        defaultClassName: 'react-aria-Popover',
        // oxlint-disable-next-line react/react-compiler
        values: {
            // oxlint-disable-next-line react/react-compiler
            trigger: props.trigger || null,
            placement: placement,
            isEntering: isEntering,
            isExiting: isExiting
        }
    });
    // Automatically render Popover with role=dialog except when isNonModal is true,
    // or a dialog is already nested inside the popover.
    let shouldBeDialog = !props.isNonModal || props.trigger === 'SubmenuTrigger' || props.trigger === 'PreviewTrigger';
    // oxlint-disable-next-line react/react-compiler
    let [isDialog, setDialog] = (0, $eF4cA.useState)(props.trigger === 'PreviewTrigger');
    (0, $4skXn.useLayoutEffect)(()=>{
        if (ref.current) setDialog(shouldBeDialog && !ref.current.querySelector('[role=dialog]'));
    }, [
        ref,
        shouldBeDialog
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (isDialog && props.trigger !== 'PreviewTrigger' && (props.trigger !== 'SubmenuTrigger' || (0, $YxOvP.getInteractionModality)() !== 'pointer') && ref.current && !(0, $fvyIQ.isFocusWithin)(ref.current)) (0, $eNuje.focusSafely)(ref.current);
    }, [
        isDialog,
        ref,
        props.trigger
    ]);
    // oxlint-enable react/react-compiler
    let children = (0, $eF4cA.useMemo)(()=>{
        let children = renderProps.children;
        for (let Context of [
            $7df40d250fa9a501$export$9b9a0cd73afb7ca4,
            ...clearContexts ?? []
        ])children = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(Context.Provider, {
            value: null
        }, children);
        return children;
    }, [
        renderProps.children,
        clearContexts
    ]);
    let [triggerWidth, setTriggerWidth] = (0, $eF4cA.useState)(null);
    // oxlint-disable-next-line react/react-compiler
    let onResize = (0, $eF4cA.useCallback)(()=>{
        if (props.triggerRef.current) setTriggerWidth(props.triggerRef.current.getBoundingClientRect().width + 'px');
    }, [
        props.triggerRef
    ]);
    (0, $4skXn.useLayoutEffect)(onResize, [
        onResize
    ]);
    (0, $f9wnx.useResizeObserver)({
        // oxlint-disable-next-line react/react-compiler
        ref: renderProps.style?.['--trigger-width'] ? undefined : props.triggerRef,
        onResize: onResize
    });
    let style = {
        ...popoverProps.style,
        '--trigger-anchor-point': triggerAnchorPoint ? `${triggerAnchorPoint.x}px ${triggerAnchorPoint.y}px` : undefined,
        ...renderProps.style,
        '--trigger-width': renderProps.style?.['--trigger-width'] || triggerWidth
    };
    (0, $4skXn.useLayoutEffect)(()=>(0, $gVozo.runAfterKeyboard)(()=>setIsOpen(true)), []);
    // oxlint-disable react/react-compiler
    let overlay = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), popoverProps),
        ...renderProps,
        id: isDialog ? props.id : undefined,
        role: isDialog ? 'dialog' : undefined,
        tabIndex: isDialog ? -1 : undefined,
        "aria-label": props['aria-label'],
        "aria-labelledby": props['aria-labelledby'],
        ref: ref,
        slot: props.slot || undefined,
        style: style,
        dir: props.dir,
        "data-trigger": props.trigger,
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, !props.isNonModal && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $br9QK.DismissButton), {
        onDismiss: state.close
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $eENmv.OverlayArrowContext).Provider, {
        value: {
            ...arrowProps,
            placement: placement,
            ref: arrowRef
        }
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $br9QK.DismissButton), {
        onDismiss: state.close
    }));
    // oxlint-enable react/react-compiler
    // If this is a root popover, render an extra div to act as the portal container for submenus/subdialogs.
    if (!isSubPopover) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $k771r.Overlay), {
        ...props,
        shouldContainFocus: isDialog && props.trigger !== 'PreviewTrigger',
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, !props.isNonModal && state.isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "data-testid": "underlay",
        ...underlayProps,
        style: {
            position: 'fixed',
            inset: 0
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ref: containerRef,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($7df40d250fa9a501$var$$542a13ca2fa5b484$var$PopoverGroupContext.Provider, {
        value: containerRef
    }, overlay)));
    // Submenus/subdialogs are mounted into the root popover's container.
    // oxlint-disable react/react-compiler
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $k771r.Overlay), {
        ...props,
        shouldContainFocus: isDialog && props.trigger !== 'PreviewTrigger',
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer ?? groupCtx?.current ?? undefined
    }, overlay);
// oxlint-enable react/react-compiler
}

});
parcelRegister("eENmv", function(module, exports) {

$parcel$export(module.exports, "OverlayArrowContext", () => $bc807074c830f297$export$2de4954e8ae13b9f);
$parcel$export(module.exports, "OverlayArrow", () => $bc807074c830f297$export$746d02f47f4d381);

var $fDYaM = parcelRequire("fDYaM");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bc807074c830f297$export$2de4954e8ae13b9f = (0, $eF4cA.createContext)({
    placement: 'bottom'
});
const $bc807074c830f297$export$746d02f47f4d381 = (0, $eF4cA.forwardRef)(function OverlayArrow(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $bc807074c830f297$export$2de4954e8ae13b9f);
    let placement = props.placement;
    let style = {
        position: 'absolute',
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)'
    };
    if (placement != null) style[placement] = '100%';
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-OverlayArrow',
        values: {
            placement: placement
        }
    });
    // remove undefined values from renderProps.style object so that it can be
    // spread merged with the other style object
    if (renderProps.style) Object.keys(renderProps.style).forEach((key)=>renderProps.style[key] === undefined && delete renderProps.style[key]);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        style: {
            ...style,
            ...renderProps.style
        },
        ref: ref,
        "data-placement": placement
    });
});

});

parcelRegister("6XFNb", function(module, exports) {

$parcel$export(module.exports, "usePopover", () => $225a02902c45d9a6$export$542a6fd13ac93354);

var $7eFu7 = parcelRequire("7eFu7");

var $5ynwP = parcelRequire("5ynwP");

var $i1DSg = parcelRequire("i1DSg");

var $lhKAD = parcelRequire("lhKAD");

var $8CJSz = parcelRequire("8CJSz");

var $ey1E7 = parcelRequire("ey1E7");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $225a02902c45d9a6$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, groupRef: groupRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    let isSubmenu = otherProps['trigger'] === 'SubmenuTrigger';
    let { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $8CJSz.useOverlay)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal || isSubmenu,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, groupRef ?? popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: origin } = (0, $5ynwP.useOverlayPosition)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal && !isSubmenu ? state.close : null,
        getTargetRect: otherProps.getTargetRect ?? (state.point ? ()=>new DOMRect(state.point.x, state.point.y, 0, 0) : undefined)
    });
    (0, $ey1E7.usePreventScroll)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $eF4cA.useEffect)(()=>{
        if (state.isOpen && popoverRef.current) {
            if (isNonModal) return (0, $7eFu7.keepVisible)(groupRef?.current ?? popoverRef.current);
            else return (0, $7eFu7.ariaHideOutside)([
                groupRef?.current ?? popoverRef.current
            ], {
                shouldUseInert: true
            });
        }
    }, [
        isNonModal,
        state.isOpen,
        popoverRef,
        groupRef
    ]);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)(props);
    return {
        popoverProps: (0, $lhKAD.mergeProps)(overlayProps, positionProps, focusWithinProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement,
        triggerAnchorPoint: origin
    };
}

});
parcelRegister("7eFu7", function(module, exports) {

$parcel$export(module.exports, "ariaHideOutside", () => $88b2643ce9654a9b$export$1c3ebcada18427bf);
$parcel$export(module.exports, "keepVisible", () => $88b2643ce9654a9b$export$1020fa7f77e17884);

var $3xzD4 = parcelRequire("3xzD4");

var $7ByPJ = parcelRequire("7ByPJ");

var $fvyIQ = parcelRequire("fvyIQ");

var $6ReTa = parcelRequire("6ReTa");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$supportsInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$isAlwaysVisibleNode(node) {
    return node.dataset.liveAnnouncer === 'true' || node.dataset.reactAriaTopLayer !== undefined;
}
// Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$refCountMap = new WeakMap();
let $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack = [];
function $88b2643ce9654a9b$export$1c3ebcada18427bf(targets, options) {
    let windowObj = (0, $7ByPJ.getOwnerWindow)(targets?.[0]);
    let opts = options instanceof windowObj.Element ? {
        root: options
    } : options;
    let root = opts?.root ?? document.body;
    let shouldUseInert = opts?.shouldUseInert && $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$supportsInert;
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let getHidden = (element)=>{
        return shouldUseInert && element instanceof windowObj.HTMLElement ? element.inert : element.getAttribute('aria-hidden') === 'true';
    };
    let setHidden = (element, hidden)=>{
        if (shouldUseInert && element instanceof windowObj.HTMLElement) element.inert = hidden;
        else if (hidden) element.setAttribute('aria-hidden', 'true');
        else {
            element.removeAttribute('aria-hidden');
            if (element instanceof windowObj.HTMLElement) // we are trying to make the element visible to screen readers again, so remove inert as well
            element.inert = false;
        }
    };
    let shadowRootsToWatch = new Set();
    if ((0, $6ReTa.shadowDOM)()) {
        // Find all shadow roots that enclose the targets, walking up the host chain
        // until we reach the tree that `root` lives in. Each enclosing ShadowRoot
        // needs its own MutationObserver because it does not cross shadow
        // boundaries, so the observer on `root` cannot see mutations inside them.
        let boundary = root.getRootNode();
        for (let target of targets){
            let current = target.getRootNode();
            while((0, $7ByPJ.isShadowRoot)(current) && current !== boundary){
                shadowRootsToWatch.add(current);
                current = current.host.getRootNode();
            }
        }
    }
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]'))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (hiddenNodes.has(node) || visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if ((0, $fvyIQ.nodeContains)(node, target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = (0, $3xzD4.createShadowTreeWalker)((0, $7ByPJ.getOwnerDocument)(root), root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        let refCount = $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$refCountMap.get(node) ?? 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (getHidden(node) && refCount === 0) return;
        if (refCount === 0) setHidden(node, true);
        hiddenNodes.add(node);
        $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.length) $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack[$88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== 'childList') continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (change.target.isConnected && ![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>(0, $fvyIQ.nodeContains)(node, change.target))) for (let node of change.addedNodes){
                if ((node instanceof HTMLElement || node instanceof SVGElement) && $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$isAlwaysVisibleNode(node)) visibleNodes.add(node);
                else if (node instanceof Element) walk(node);
            }
            if ((0, $6ReTa.shadowDOM)()) {
                // if any of the observed shadow roots were removed, stop observing them
                for (let shadowRoot of shadowRootsToWatch)if (!shadowRoot.isConnected) {
                    observer.disconnect();
                    break;
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let shadowObservers = new Set();
    if ((0, $6ReTa.shadowDOM)()) for (let shadowRoot of shadowRootsToWatch){
        // Disconnect single target instead of all https://github.com/whatwg/dom/issues/126
        let shadowObserver = new MutationObserver((changes)=>{
            for (let change of changes){
                if (change.type !== 'childList') continue;
                // If the parent element of the added nodes is not within one of the targets,
                // and not already inside a hidden node, hide all of the new children.
                if (change.target.isConnected && ![
                    ...visibleNodes,
                    ...hiddenNodes
                ].some((node)=>(0, $fvyIQ.nodeContains)(node, change.target))) for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$isAlwaysVisibleNode(node)) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
                if ((0, $6ReTa.shadowDOM)()) {
                    // if any of the observed shadow roots were removed, stop observing them
                    for (let shadowRoot of shadowRootsToWatch)if (!shadowRoot.isConnected) {
                        observer.disconnect();
                        break;
                    }
                }
            }
        });
        shadowObserver.observe(shadowRoot, {
            childList: true,
            subtree: true
        });
        shadowObservers.add(shadowObserver);
    }
    let observerWrapper = {
        visibleNodes: visibleNodes,
        hiddenNodes: hiddenNodes,
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        if ((0, $6ReTa.shadowDOM)()) for (let shadowObserver of shadowObservers)shadowObserver.disconnect();
        for (let node of hiddenNodes){
            let count = $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                setHidden(node, false);
                $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$refCountMap.delete(node);
            } else $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack[$88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.length - 1]) {
            $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.pop();
            if ($88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.length) $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack[$88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.length - 1].observe();
        } else $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.splice($88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.indexOf(observerWrapper), 1);
    };
}
function $88b2643ce9654a9b$export$1020fa7f77e17884(element) {
    let observer = $88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack[$88b2643ce9654a9b$var$$58196c8d6a1f38fc$var$observerStack.length - 1];
    if (observer && !observer.visibleNodes.has(element)) {
        observer.visibleNodes.add(element);
        return ()=>{
            observer.visibleNodes.delete(element);
        };
    }
}

});

parcelRegister("5ynwP", function(module, exports) {

$parcel$export(module.exports, "useOverlayPosition", () => $dd13fa90600b26f0$export$d39e1813b3bdd0e1);

var $7ByPJ = parcelRequire("7ByPJ");

var $k90oe = parcelRequire("k90oe");

var $fvyIQ = parcelRequire("fvyIQ");

var $d8twi = parcelRequire("d8twi");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $f9wnx = parcelRequire("f9wnx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $dd13fa90600b26f0$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { arrowSize: arrowSize, targetRef: targetRef, overlayRef: overlayRef, arrowRef: arrowRef, scrollRef: scrollRef = overlayRef, placement: placement = 'bottom', containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== 'undefined' ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0, getTargetRect: getTargetRect } = props;
    let [position, setPosition] = (0, $eF4cA.useState)(null);
    let deps = [
        shouldUpdatePosition,
        placement,
        // oxlint-disable-next-line react/react-compiler
        overlayRef.current,
        // oxlint-disable-next-line react/react-compiler
        targetRef.current,
        // oxlint-disable-next-line react/react-compiler
        arrowRef?.current,
        // oxlint-disable-next-line react/react-compiler
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $eF4cA.useRef)($dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.scale);
    (0, $eF4cA.useEffect)(()=>{
        if (isOpen) lastScale.current = $dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $eF4cA.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !boundaryElement) return;
        if ($dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.scale !== lastScale.current) return;
        // Determine a scroll anchor based on the focused element.
        // This stores the offset of the anchor element from the scroll container
        // so it can be restored after repositioning. This way if the overlay height
        // changes, the focused element appears to stay in the same position.
        let anchor = null;
        if (scrollRef.current && (0, $fvyIQ.isFocusWithin)(scrollRef.current)) {
            let anchorRect = (0, $fvyIQ.getActiveElement)()?.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            // Anchor from the top if the offset is in the top half of the scrollable element,
            // otherwise anchor from the bottom.
            anchor = {
                type: 'top',
                offset: (anchorRect?.top ?? 0) - scrollRect.top
            };
            if (anchor.offset > scrollRect.height / 2) {
                anchor.type = 'bottom';
                anchor.offset = (anchorRect?.bottom ?? 0) - scrollRect.bottom;
            }
        }
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        let overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            overlay.style.top = '0px';
            overlay.style.bottom = '';
            overlay.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + 'px';
        }
        let position = (0, $k90oe.calculatePosition)({
            placement: $dd13fa90600b26f0$var$$b3526bc71400be8d$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current || overlayRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize ?? (arrowRef?.current ? (0, $k90oe.getRect)(arrowRef.current, true).width : 0),
            arrowBoundaryOffset: arrowBoundaryOffset,
            targetRect: getTargetRect?.(targetRef.current)
        });
        if (!position.position) return;
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = '';
        overlay.style.bottom = '';
        overlay.style.left = '';
        overlay.style.right = '';
        Object.keys(position.position).forEach((key)=>overlay.style[key] = position.position[key] + 'px');
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : '';
        // Restore scroll position relative to anchor element.
        let activeElement = (0, $fvyIQ.getActiveElement)();
        if (anchor && activeElement && scrollRef.current) {
            let anchorRect = activeElement.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            let newOffset = anchorRect[anchor.type] - scrollRect[anchor.type];
            scrollRef.current.scrollTop += newOffset - anchor.offset;
        }
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // oxlint-disable-next-line react/react-compiler, react-hooks/exhaustive-deps
    }, deps);
    (0, $4skXn.useLayoutEffect)(updatePosition, deps);
    // Update position on window resize
    $dd13fa90600b26f0$var$$b3526bc71400be8d$var$useResize(updatePosition);
    (0, $f9wnx.useResizeObserver)({
        ref: overlayRef,
        onResize: updatePosition
    });
    (0, $f9wnx.useResizeObserver)({
        ref: targetRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $eF4cA.useRef)(false);
    (0, $4skXn.useLayoutEffect)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.addEventListener('resize', onResize);
        $dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.addEventListener('scroll', onScroll);
        let cleanup = (0, $7ByPJ.addEvent)((0, $fvyIQ.getPropagationTargets)(window), 'scroll', onScroll);
        return ()=>{
            $dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.removeEventListener('resize', onResize);
            $dd13fa90600b26f0$var$$b3526bc71400be8d$var$visualViewport?.removeEventListener('scroll', onScroll);
            cleanup();
        };
    }, [
        updatePosition
    ]);
    let close = (0, $eF4cA.useCallback)(()=>{
        if (!isResizing.current) onClose?.();
    }, [
        onClose,
        isResizing
    ]);
    (0, $d8twi.useCloseOnScroll)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: position ? 'absolute' : 'fixed',
                top: !position ? 0 : undefined,
                left: !position ? 0 : undefined,
                zIndex: 100000,
                ...position?.position,
                maxHeight: position?.maxHeight ?? '100vh'
            }
        },
        placement: position?.placement ?? null,
        triggerAnchorPoint: position?.triggerAnchorPoint ?? null,
        arrowProps: {
            'aria-hidden': 'true',
            role: 'presentation',
            style: {
                left: position?.arrowOffsetLeft,
                top: position?.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $dd13fa90600b26f0$var$$b3526bc71400be8d$var$useResize(onResize) {
    (0, $4skXn.useLayoutEffect)(()=>{
        window.addEventListener('resize', onResize, false);
        return ()=>{
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $dd13fa90600b26f0$var$$b3526bc71400be8d$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}

});
parcelRegister("k90oe", function(module, exports) {

$parcel$export(module.exports, "calculatePosition", () => $2424766c7b7b2327$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "getRect", () => $2424766c7b7b2327$export$4b834cebd9e5cebe);

var $11FxZ = parcelRequire("11FxZ");

var $fvyIQ = parcelRequire("fvyIQ");

var $g8XbY = parcelRequire("g8XbY");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
const $2424766c7b7b2327$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $2424766c7b7b2327$var$$954926fb6168ae2a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
const $2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
const $2424766c7b7b2327$var$$954926fb6168ae2a$var$TOTAL_SIZE = {
    width: 'totalWidth',
    height: 'totalHeight'
};
const $2424766c7b7b2327$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE = {};
let $2424766c7b7b2327$var$$954926fb6168ae2a$var$getVisualViewport = ()=>typeof document !== 'undefined' ? window.visualViewport : null;
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getContainerDimensions(containerNode, visualViewport) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    let isPinchZoomedIn = (visualViewport?.scale ?? 1) > 1;
    // In the case where the container is `html` or `body` and the container doesn't have something like `position: relative`,
    // then position absolute will be positioned relative to the viewport, also known as the `initial containing block`.
    // That's why we use the visual viewport instead.
    if (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        width = visualViewport?.width ?? totalWidth;
        height = visualViewport?.height ?? totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        // Uses pageTop/pageLeft instead of offsetTop/offsetLeft because WebKit misreports those during pans.
        if (visualViewport) {
            top = Math.max(0, visualViewport.pageTop - (scroll.top ?? 0));
            left = Math.max(0, visualViewport.pageLeft - (scroll.left ?? 0));
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getOffset(containerNode, false));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $11FxZ.isWebKit)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = visualViewport?.pageTop ?? 0;
        left = visualViewport?.pageLeft ?? 0;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    let containerScroll = containerDimensions.scroll[axis] ?? 0;
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = containerOffsetWithBoundary[axis] + boundaryDimensions.scroll[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = containerOffsetWithBoundary[axis] + boundaryDimensions.scroll[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[axis]] + boundarySize - padding;
    // transformed value of the left edge of the overlay
    let startEdgeOffset = offset - containerScroll + boundaryDimensions.scroll[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[axis]] + containerOffsetWithBoundary[axis] - boundaryDimensions[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[axis]];
    // transformed value of the right edge of the overlay
    let endEdgeOffset = offset - containerScroll + size + boundaryDimensions.scroll[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[axis]] + containerOffsetWithBoundary[axis] - boundaryDimensions[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$parsePlacement(input) {
    if ($2424766c7b7b2327$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input]) return $2424766c7b7b2327$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(' ');
    let axis = $2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[placement] || 'right';
    let crossAxis = $2424766c7b7b2327$var$$954926fb6168ae2a$var$CROSS_AXIS[axis];
    if (!$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    let size = $2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS_SIZE[axis];
    let crossSize = $2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS_SIZE[crossAxis];
    $2424766c7b7b2327$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $2424766c7b7b2327$var$$954926fb6168ae2a$var$PARSED_PLACEMENT_CACHE[input];
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis] ?? 0;
    if (crossPlacement === 'center') // at this point the overlay center should match the button center
    position[crossAxis] += ((childOffset[crossSize] ?? 0) - (overlaySize[crossSize] ?? 0)) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += (childOffset[crossSize] ?? 0) - (overlaySize[crossSize] ?? 0);
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top or left overlapping arrow with button bottom or right
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom or right overlapping arrow with button top or left
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $g8XbY.clamp)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container.
        let containerHeight = isContainerPositioned ? containerDimensions[size] : containerDimensions[$2424766c7b7b2327$var$$954926fb6168ae2a$var$TOTAL_SIZE[size]];
        position[$2424766c7b7b2327$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection, containerDimensions, isContainerDescendentOfBoundary, visualViewport) {
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top
    // with respect to the container.
    let overlayTop = (position.top != null ? position.top : containerDimensions[$2424766c7b7b2327$var$$954926fb6168ae2a$var$TOTAL_SIZE.height] - (position.bottom ?? 0) - overlayHeight) - (containerDimensions.scroll.top ?? 0);
    // calculate the dimentions of the "boundingRect" which is most restrictive top/bottom of the boundaryRect and the visual view port
    let boundaryToContainerTransformOffset = isContainerDescendentOfBoundary ? containerOffsetWithBoundary.top : 0;
    let boundingRect = {
        // This should be boundary top in container coord system vs viewport top in container coord system
        // For the viewport top, there are several cases
        // 1. pinchzoom case where we want the viewports offset top as top here
        // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
        top: Math.max(boundaryDimensions.top + boundaryToContainerTransformOffset, (visualViewport?.offsetTop ?? boundaryDimensions.top) + boundaryToContainerTransformOffset),
        bottom: Math.min(boundaryDimensions.top + boundaryDimensions.height + boundaryToContainerTransformOffset, (visualViewport?.offsetTop ?? 0) + (visualViewport?.height ?? 0))
    };
    let maxHeight = heightGrowthDirection !== 'top' ? Math.max(0, boundingRect.bottom - // this is the bottom of the boundary
    overlayTop - // this is the top of the overlay
    ((margins.top ?? 0) + (margins.bottom ?? 0) + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight - // this is the bottom of the overlay
    boundingRect.top - // this is the top of the boundary
    ((margins.top ?? 0) + (margins.bottom ?? 0) + padding // save additional space for margin and padding
    ));
    return maxHeight;
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo, containerDimensions, isContainerDescendentOfBoundary) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - // trigger start
    (containerDimensions.scroll[axis] ?? 0) - // transform trigger position to be with respect to viewport 0,0
    (boundaryDimensions[axis] + (isContainerDescendentOfBoundary ? containerOffsetWithBoundary[axis] : 0)) - // boundary start
    (margins[axis] ?? 0) - // margins usually for arrows or other decorations
    margins[$2424766c7b7b2327$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[axis]] - padding); // padding between overlay and boundary
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + (isContainerDescendentOfBoundary ? containerOffsetWithBoundary[axis] : 0) - childOffset[axis] - childOffset[size] + (containerDimensions.scroll[axis] ?? 0) - (margins[axis] ?? 0) - margins[$2424766c7b7b2327$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $2424766c7b7b2327$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset, isContainerDescendentOfBoundary, visualViewport) {
    let placementInfo = $2424766c7b7b2327$var$$954926fb6168ae2a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $2424766c7b7b2327$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
    let normalizedOffset = offset;
    let space = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo, containerDimensions, isContainerDescendentOfBoundary);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && overlaySize[size] > space) {
        let flippedPlacementInfo = $2424766c7b7b2327$var$$954926fb6168ae2a$var$parsePlacement(`${$2424766c7b7b2327$var$$954926fb6168ae2a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $2424766c7b7b2327$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
        let flippedSpace = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo, containerDimensions, isContainerDescendentOfBoundary);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = 'bottom';
    if (placementInfo.axis === 'top') {
        if (placementInfo.placement === 'top') heightGrowthDirection = 'top';
        else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossAxis === 'top') {
        if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';
        else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
    }
    let delta = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection, containerDimensions, isContainerDescendentOfBoundary, visualViewport);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $2424766c7b7b2327$var$$954926fb6168ae2a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
    delta = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    // childOffset[crossAxis] + .5 * childOffset[crossSize] = absolute position with respect to the trigger's coordinate system that would place the arrow in the center of the trigger
    // position[crossAxis] - margins[AXIS[crossAxis]] = value use to transform the position to a value with respect to the overlay's coordinate system. A child element's (aka arrow) position absolute's "0"
    // is positioned after the margin of its parent (aka overlay) so we need to subtract it to get the proper coordinate transform
    let origin = childOffset[crossAxis] - position[crossAxis] - margins[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[crossAxis]];
    let preferredArrowPosition = origin + 0.5 * childOffset[crossSize];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    // overlaySize[crossSize] - margins = true size of the overlay
    const overlayMargin = $2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[crossAxis] === 'left' ? (margins.left ?? 0) + (margins.right ?? 0) : (margins.top ?? 0) + (margins.bottom ?? 0);
    const arrowMaxPosition = overlaySize[crossSize] - overlayMargin - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    // Same margin accomodation done here as well as for the preferredArrowPosition
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] + arrowSize / 2 - (position[crossAxis] + margins[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[crossAxis]]);
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - arrowSize / 2 - (position[crossAxis] + margins[$2424766c7b7b2327$var$$954926fb6168ae2a$var$AXIS[crossAxis]]);
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $g8XbY.clamp)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $g8XbY.clamp)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    // If there is an arrow, use that as the origin so that animations are smooth.
    // Otherwise use the target edge.
    ({ placement: placement, crossPlacement: crossPlacement } = placementInfo);
    if (arrowSize) origin = arrowPosition[crossAxis];
    else if (crossPlacement === 'right') origin += childOffset[crossSize];
    else if (crossPlacement === 'center') origin += childOffset[crossSize] / 2;
    let crossOrigin = placement === 'left' || placement === 'top' ? overlaySize[size] : 0;
    let triggerAnchorPoint = {
        x: placement === 'top' || placement === 'bottom' ? origin : crossOrigin,
        y: placement === 'left' || placement === 'right' ? origin : crossOrigin
    };
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placement,
        triggerAnchorPoint: triggerAnchorPoint
    };
}
function $2424766c7b7b2327$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0, targetRect: targetRect } = opts;
    let visualViewport = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getVisualViewport();
    let container = overlayNode instanceof HTMLElement ? $2424766c7b7b2327$var$$954926fb6168ae2a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    let childOffset = isViewportContainer ? $2424766c7b7b2327$var$$954926fb6168ae2a$var$getOffset(targetNode, false, targetRect) : $2424766c7b7b2327$var$$954926fb6168ae2a$var$getPosition(targetNode, container, false, targetRect);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getOffset(overlayNode, true);
    let margins = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getMargins(overlayNode);
    overlaySize.width += (margins.left ?? 0) + (margins.right ?? 0);
    overlaySize.height += (margins.top ?? 0) + (margins.bottom ?? 0);
    let scrollSize = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getScroll(scrollNode);
    // Note that due to logic inside getContainerDimensions, for cases where the boundary element is the body, we will return
    // a height/width that matches the visual viewport size rather than the body's height/width (aka for zoom it will be zoom adjusted size)
    // and a top/left that is adjusted as well (will return the top/left of the zoomed in viewport, or 0,0 for a non-zoomed body)
    // Otherwise this returns the height/width of a arbitrary boundary element, and its top/left with respect to the viewport (NOTE THIS MEANS IT DOESNT INCLUDE SCROLL)
    let boundaryDimensions = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getContainerDimensions(boundaryElement, visualViewport);
    let containerDimensions = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getContainerDimensions(container, visualViewport);
    // There are several difference cases of how to calculate the containerOffsetWithBoundary:
    // - boundaryElement is body or HTML and the container is an arbitrary element in the boundary (aka submenu with parent menu as container in v3)
    // - boundaryElement and container are both body or HTML element (aka standard popover case)
    // - boundaryElement is customized by the user. Container can also be arbitrary (either body/HTML or some other element)
    // containerOffsetWithBoundary should always return a value that is the boundary's coordinate offset with respect to the container coord system (container is 0, 0)
    let containerOffsetWithBoundary;
    if ((boundaryElement.tagName === 'BODY' || boundaryElement.tagName === 'HTML') && !isViewportContainer) {
        // Use getRect instead of getOffset because boundaryDimensions for BODY/HTML is in viewport coordinate space,
        // not document coordinate space
        let containerRect = $2424766c7b7b2327$export$4b834cebd9e5cebe(container, false);
        // the offset should be negative because if container is at viewport position x,y, then viewport top (aka 0)
        // is at position -x,y in container-relative coordinates
        containerOffsetWithBoundary = {
            top: -(containerRect.top - boundaryDimensions.top),
            left: -(containerRect.left - boundaryDimensions.left),
            width: 0,
            height: 0
        };
    } else if ((boundaryElement.tagName === 'BODY' || boundaryElement.tagName === 'HTML') && isViewportContainer) containerOffsetWithBoundary = {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    };
    else // like in ScrollingBoundaryContainerExample in Popover.stories.
    containerOffsetWithBoundary = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getPosition(boundaryElement, container, false);
    let isContainerDescendentOfBoundary = (0, $fvyIQ.nodeContains)(boundaryElement, container);
    return $2424766c7b7b2327$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset, isContainerDescendentOfBoundary, visualViewport);
}
function $2424766c7b7b2327$export$4b834cebd9e5cebe(node, ignoreScale) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    // Use offsetWidth and offsetHeight if this is an HTML element, so that
    // the size is not affected by scale transforms.
    if (ignoreScale && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        width = node.offsetWidth;
        height = node.offsetHeight;
    }
    return {
        top: top,
        left: left,
        width: width,
        height: height
    };
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getOffset(node, ignoreScale, overrideRect) {
    let { top: top, left: left, width: width, height: height } = overrideRect || $2424766c7b7b2327$export$4b834cebd9e5cebe(node, ignoreScale);
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getPosition(node, parent, ignoreScale, overrideRect) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === 'fixed') offset = overrideRect || $2424766c7b7b2327$export$4b834cebd9e5cebe(node, ignoreScale);
    else {
        offset = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getOffset(node, ignoreScale, overrideRect);
        let parentOffset = $2424766c7b7b2327$var$$954926fb6168ae2a$var$getOffset(parent, ignoreScale);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !$2424766c7b7b2327$var$$954926fb6168ae2a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$2424766c7b7b2327$var$$954926fb6168ae2a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $2424766c7b7b2327$var$$954926fb6168ae2a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' || 'backdropFilter' in style && style.backdropFilter !== 'none' || 'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}

});

parcelRegister("d8twi", function(module, exports) {

$parcel$export(module.exports, "onCloseMap", () => $0fa129f124bf18a1$export$f6211563215e3b37);
$parcel$export(module.exports, "useCloseOnScroll", () => $0fa129f124bf18a1$export$18fc8428861184da);

var $7ByPJ = parcelRequire("7ByPJ");

var $fvyIQ = parcelRequire("fvyIQ");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0fa129f124bf18a1$export$f6211563215e3b37 = new WeakMap();
function $0fa129f124bf18a1$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $eF4cA.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = (0, $fvyIQ.getEventTarget)(e);
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !(0, $fvyIQ.nodeContains)(target, triggerRef.current)) return;
            // Ignore scroll events on any input or textarea as the cursor position can cause it to scroll
            // such as in a combobox. Clicking the dropdown button places focus on the input, and if the
            // text inside the input extends beyond the 'end', then it will scroll so the cursor is visible at the end.
            if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) return;
            let onCloseHandler = onClose || $0fa129f124bf18a1$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        return (0, $7ByPJ.addEvent)((0, $fvyIQ.getPropagationTargets)(triggerRef.current), 'scroll', onScroll, true);
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}

});

parcelRegister("f9wnx", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $02e9e30bf6763316$export$683480f191c0e3ea);

var $4lMDe = parcelRequire("4lMDe");

var $eF4cA = parcelRequire("eF4cA");
function $02e9e30bf6763316$var$$970072cf4b13fde3$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== 'undefined';
}
function $02e9e30bf6763316$export$683480f191c0e3ea(options) {
    // Only call onResize from inside the effect, otherwise we'll void our assumption that
    // useEffectEvents are safe to pass in.
    const { ref: ref, box: box, onResize: onResize } = options;
    let onResizeEvent = (0, $4lMDe.useEffectEvent)(onResize);
    (0, $eF4cA.useEffect)(()=>{
        let element = ref?.current;
        if (!element) return;
        if (!$02e9e30bf6763316$var$$970072cf4b13fde3$var$hasResizeObserver()) {
            window.addEventListener('resize', onResizeEvent, false);
            return ()=>{
                window.removeEventListener('resize', onResizeEvent, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResizeEvent();
            });
            resizeObserverInstance.observe(element, {
                box: box
            });
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        ref,
        box
    ]);
}

});


parcelRegister("8CJSz", function(module, exports) {

$parcel$export(module.exports, "useOverlay", () => $47d46bf1726d168f$export$ea8f71083e90600f);

var $fvyIQ = parcelRequire("fvyIQ");

var $6pgkA = parcelRequire("6pgkA");

var $i1DSg = parcelRequire("i1DSg");

var $5DB0v = parcelRequire("5DB0v");

var $aGDvF = parcelRequire("aGDvF");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays = [];
function $47d46bf1726d168f$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    let lastVisibleOverlay = (0, $eF4cA.useRef)(undefined);
    (0, $eF4cA.useEffect)(()=>{
        if (isOpen && !$47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.includes(ref)) {
            $47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.push(ref);
            return ()=>{
                let index = $47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.indexOf(ref);
                if (index >= 0) $47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.splice(index, 1);
            };
        }
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays[$47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        const topMostOverlay = $47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays[$47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.length - 1];
        lastVisibleOverlay.current = topMostOverlay;
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside((0, $fvyIQ.getEventTarget)(e))) {
            if (topMostOverlay === ref) e.stopPropagation();
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside((0, $fvyIQ.getEventTarget)(e))) {
            if ($47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays[$47d46bf1726d168f$var$$77844860df94ba23$var$visibleOverlays.length - 1] === ref) e.stopPropagation();
            if (lastVisibleOverlay.current === ref) onHide();
        }
        lastVisibleOverlay.current = undefined;
    };
    // Handle the escape key
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            Escape: ()=>{
                if (!isKeyboardDismissDisabled) {
                    onHide();
                    return;
                }
                return false;
            }
        }
    });
    (0, $5DB0v.useInteractOutside)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : undefined,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $6pgkA.isElementInChildOfActiveScope)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose?.();
        }
    });
    return {
        overlayProps: {
            ...keyboardProps,
            ...focusWithinProps
        },
        underlayProps: {}
    };
}

});
parcelRegister("5DB0v", function(module, exports) {

$parcel$export(module.exports, "useInteractOutside", () => $7d58b6c3d0bfd91f$export$872b660ac5a1ff98);

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $4lMDe = parcelRequire("4lMDe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $7d58b6c3d0bfd91f$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $eF4cA.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $4lMDe.useEffectEvent)((e)=>{
        if (onInteractOutside && $7d58b6c3d0bfd91f$var$$e260d131964da0f9$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $4lMDe.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $eF4cA.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $7ByPJ.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== 'undefined') {
            let onClick = (e)=>{
                if (state.isPointerDown && $7d58b6c3d0bfd91f$var$$e260d131964da0f9$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            // Use click instead of pointerup to avoid Android Chrome issue
            // https://issues.chromium.org/issues/40732224
            documentObject.addEventListener('pointerdown', onPointerDown, true);
            documentObject.addEventListener('click', onClick, true);
            return ()=>{
                documentObject.removeEventListener('pointerdown', onPointerDown, true);
                documentObject.removeEventListener('click', onClick, true);
            };
        }
    }, [
        ref,
        isDisabled
    ]);
}
function $7d58b6c3d0bfd91f$var$$e260d131964da0f9$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    let target = (0, $fvyIQ.getEventTarget)(event);
    if (target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = target.ownerDocument;
        if (!ownerDocument || !(0, $fvyIQ.nodeContains)(ownerDocument.documentElement, target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (target.closest('[data-react-aria-top-layer]')) return false;
    }
    if (!ref.current) return false;
    // When the event source is inside a Shadow DOM, event.target is just the shadow root.
    // Using event.composedPath instead means we can get the actual element inside the shadow root.
    // This only works if the shadow root is open, there is no way to detect if it is closed.
    // If the event composed path contains the ref, interaction is inside.
    return !event.composedPath().includes(ref.current);
}

});


parcelRegister("ey1E7", function(module, exports) {

$parcel$export(module.exports, "usePreventScroll", () => $00f480a564b09ab8$export$ee0f7cc6afcd1c18);

var $7ByPJ = parcelRequire("7ByPJ");

var $d8j5I = parcelRequire("d8j5I");

var $fvyIQ = parcelRequire("fvyIQ");

var $k1844 = parcelRequire("k1844");

var $5AGOf = parcelRequire("5AGOf");

var $11FxZ = parcelRequire("11FxZ");

var $fSNAA = parcelRequire("fSNAA");

var $gVozo = parcelRequire("gVozo");

var $lDJIO = parcelRequire("lDJIO");

var $4skXn = parcelRequire("4skXn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $00f480a564b09ab8$var$$0644e3663365bfe5$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollCount = 0;
let $00f480a564b09ab8$var$$0644e3663365bfe5$var$restore;
function $00f480a564b09ab8$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled, UNSTABLE_overrideFocus: UNSTABLE_overrideFocus } = options;
    (0, $4skXn.useLayoutEffect)(()=>{
        if (isDisabled) return;
        $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollCount++;
        if ($00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollCount === 1) {
            if ((0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)()) $00f480a564b09ab8$var$$0644e3663365bfe5$var$restore = $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollMobileWebKit();
            else $00f480a564b09ab8$var$$0644e3663365bfe5$var$restore = $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollStandard(UNSTABLE_overrideFocus);
        }
        return ()=>{
            $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollCount--;
            if ($00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollCount === 0) $00f480a564b09ab8$var$$0644e3663365bfe5$var$restore();
        };
    }, [
        isDisabled,
        UNSTABLE_overrideFocus
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollStandard(UNSTABLE_overrideFocus) {
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return (0, $d8j5I.chain)(scrollbarWidth > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
    ('scrollbarGutter' in document.documentElement.style ? (0, $7ByPJ.setStyle)(document.documentElement, 'scrollbar-gutter', 'stable') : (0, $7ByPJ.setStyle)(document.documentElement, 'padding-right', `${scrollbarWidth}px`)), (0, $7ByPJ.setStyle)(document.documentElement, 'overflow', 'hidden'), UNSTABLE_overrideFocus && $00f480a564b09ab8$var$$0644e3663365bfe5$var$overrideFocus(), UNSTABLE_overrideFocus && (0, $lDJIO.supportsKeyboard)() && $00f480a564b09ab8$var$$0644e3663365bfe5$var$handleBlur());
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event. This is best effort: we can't prevent default when pinch
//    zooming or when an element contains text selection, which may allow scrolling in some cases.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
function $00f480a564b09ab8$var$$0644e3663365bfe5$var$preventScrollMobileWebKit() {
    // Set overflow hidden so scrollIntoViewport() (useSelectableCollection) sees isScrollPrevented and
    // scrolls only scroll parents instead of calling native scrollIntoView() which moves the window.
    let restoreOverflow = (0, $7ByPJ.setStyle)(document.documentElement, 'overflow', 'hidden');
    let scrollable;
    let allowTouchMove = false;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        let target = (0, $fvyIQ.getEventTarget)(e);
        scrollable = (0, $fSNAA.isScrollable)(target, true) ? target : (0, $5AGOf.getScrollParent)(target, true);
        allowTouchMove = false;
        // If the target is selected, don't preventDefault in touchmove to allow user to adjust selection.
        let selection = target.ownerDocument.defaultView.getSelection();
        if (selection && !selection.isCollapsed && selection.containsNode(target, true)) allowTouchMove = true;
        // If this is a range input, allow touch move to allow user to adjust the slider value
        if (e.composedPath().some((el)=>el instanceof HTMLInputElement && el.type === 'range')) allowTouchMove = true;
        // If this is a focused input element with a selected range, allow user to drag the selection handles.
        if ('selectionStart' in target && 'selectionEnd' in target && target.selectionStart < target.selectionEnd && target.ownerDocument.activeElement === target) allowTouchMove = true;
    };
    // Prevent scrolling up when at the top and scrolling down when at the bottom
    // of a nested scrollable area, otherwise mobile Safari will start scrolling
    // the window instead.
    // This must be applied before the touchstart event as of iOS 26, so inject it as a <style> element.
    let style = document.createElement('style');
    let nonce = (0, $k1844.getNonce)();
    if (nonce) style.nonce = nonce;
    style.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim();
    document.head.prepend(style);
    let onTouchMove = (e)=>{
        // Allow pinch-zooming.
        if (e.touches.length === 2 || allowTouchMove) return;
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let restoreFocus = $00f480a564b09ab8$var$$0644e3663365bfe5$var$overrideFocus();
    let removeEvents = (0, $d8j5I.chain)((0, $7ByPJ.addEvent)(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), (0, $7ByPJ.addEvent)(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $00f480a564b09ab8$var$$0644e3663365bfe5$var$handleBlur());
    return ()=>{
        restoreOverflow();
        removeEvents();
        style.remove();
        restoreFocus();
    };
}
function $00f480a564b09ab8$var$$0644e3663365bfe5$var$handleBlur() {
    let onBlur = (e)=>{
        let target = (0, $fvyIQ.getEventTarget)(e);
        let relatedTarget = e.relatedTarget;
        if (relatedTarget && (0, $lDJIO.willOpenKeyboard)(relatedTarget)) relatedTarget.focus();
        else if (!relatedTarget) {
            // When tapping the Done button on the keyboard, focus moves to the body.
            // FocusScope will then restore focus back to the input. Later when tapping
            // the same input again, it is already focused, so no blur event will fire,
            // resulting in the flow above never running and Safari's native scrolling occurring.
            // Instead, move focus to the parent focusable element (e.g. the dialog).
            let focusable = target.parentElement?.closest('[tabindex]');
            focusable?.focus({
                preventScroll: true
            });
        }
    };
    return (0, $7ByPJ.addEvent)(document, 'blur', onBlur, true);
}
function $00f480a564b09ab8$var$$0644e3663365bfe5$var$overrideFocus() {
    // Override programmatic focus to scroll into view without scrolling the whole page.
    let focus = HTMLElement.prototype.focus;
    Reflect.defineProperty(HTMLElement.prototype, 'focus', {
        configurable: true,
        writable: true,
        value: function(opts) {
            // Focus the element without scrolling the page.
            focus.call(this, {
                ...opts,
                preventScroll: true
            });
            if (!opts || !opts.preventScroll) {
                let scroll = ()=>{
                    let activeElement = (0, $fvyIQ.getActiveElement)();
                    if (activeElement === this) $00f480a564b09ab8$var$$0644e3663365bfe5$var$scrollIntoView(this);
                };
                (0, $gVozo.runAfterKeyboard)((isOpen)=>isOpen ? scroll() : (0, $gVozo.runAfterKeyboardTransition)(()=>scroll()));
            }
        }
    });
    return ()=>{
        Reflect.defineProperty(HTMLElement.prototype, 'focus', {
            configurable: true,
            writable: true,
            value: focus
        });
    };
}
function $00f480a564b09ab8$var$$0644e3663365bfe5$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    let nextTarget = target;
    while(nextTarget && nextTarget !== root && nextTarget.isConnected){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $5AGOf.getScrollParent)(nextTarget);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
            let scrollableRect = scrollable.getBoundingClientRect();
            let targetRect = nextTarget.getBoundingClientRect();
            if (targetRect.top < scrollableRect.top || targetRect.bottom > scrollableRect.top + nextTarget.clientHeight) {
                let bottom = scrollableRect.bottom;
                if ($00f480a564b09ab8$var$$0644e3663365bfe5$var$visualViewport) bottom = Math.min(bottom, $00f480a564b09ab8$var$$0644e3663365bfe5$var$visualViewport.offsetTop + $00f480a564b09ab8$var$$0644e3663365bfe5$var$visualViewport.height);
                // Center within the viewport.
                let adjustment = targetRect.top - scrollableRect.top - ((bottom - scrollableRect.top) / 2 - targetRect.height / 2);
                scrollable.scrollTo({
                    // Clamp to the valid range to prevent over-scrolling.
                    top: Math.max(0, Math.min(scrollable.scrollHeight - scrollable.clientHeight, scrollable.scrollTop + adjustment)),
                    behavior: 'smooth'
                });
            }
        }
        nextTarget = scrollable.parentElement;
    }
}

});
parcelRegister("5AGOf", function(module, exports) {

$parcel$export(module.exports, "getScrollParent", () => $988085d7e57f65e6$export$cfa2225e87938781);

var $fSNAA = parcelRequire("fSNAA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $988085d7e57f65e6$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $fSNAA.isScrollable)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $fSNAA.isScrollable)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}

});
parcelRegister("fSNAA", function(module, exports) {

$parcel$export(module.exports, "isScrollable", () => $dbe932ce1329cdd7$export$2bb74740c4e19def);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dbe932ce1329cdd7$export$2bb74740c4e19def(node, checkForOverflow) {
    if (!node) return false;
    let style = window.getComputedStyle(node);
    let root = document.scrollingElement || document.documentElement;
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    // Root element has `visible` overflow by default, but is scrollable nonetheless.
    if (node === root && style.overflow !== 'hidden') isScrollable = true;
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}

});


parcelRegister("gVozo", function(module, exports) {

$parcel$export(module.exports, "runAfterKeyboard", () => $6c720e662277c9a1$export$b80f73f72d03c10f);
$parcel$export(module.exports, "runAfterKeyboardTransition", () => $6c720e662277c9a1$export$c82b8fe1ad51fcd9);

var $fvyIQ = parcelRequire("fvyIQ");

var $lDJIO = parcelRequire("lDJIO");

var $11FxZ = parcelRequire("11FxZ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6c720e662277c9a1$var$$e0a0e4399f316b76$var$WEBKIT_OPEN_DELAY = 200;
const $6c720e662277c9a1$var$$e0a0e4399f316b76$var$TRANSITION_FRAMETIME = 50;
const $6c720e662277c9a1$var$$e0a0e4399f316b76$var$TRANSITION_TIMEOUT = 600;
const $6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow = new WeakMap();
const $6c720e662277c9a1$var$$e0a0e4399f316b76$var$transitionCallbacks = new Set();
const $6c720e662277c9a1$var$$e0a0e4399f316b76$var$resizeCallbacks = new Set();
function $6c720e662277c9a1$var$$e0a0e4399f316b76$var$onTransitionFrame(wasOpenKeyboard, signal) {
    let isOpenKeyboard = (0, $lDJIO.isKeyboardOpen)();
    // Flush resize callbacks when the keyboard has affected layout or we ran out of time.
    if (wasOpenKeyboard !== isOpenKeyboard || signal.aborted) for (let callback of $6c720e662277c9a1$var$$e0a0e4399f316b76$var$resizeCallbacks){
        callback(isOpenKeyboard);
        $6c720e662277c9a1$var$$e0a0e4399f316b76$var$resizeCallbacks.delete(callback);
    }
    // WebKit only fires a single resize event at the start of an opening transition.
    // The animation takes ~200ms, so restart the listener and flush when it runs out of time.
    if (!wasOpenKeyboard && isOpenKeyboard && (0, $11FxZ.isWebKit)() && !signal.aborted) {
        window.clearInterval($6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.get(window));
        $6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.set(window, $6c720e662277c9a1$var$$e0a0e4399f316b76$var$setupGlobalListeners($6c720e662277c9a1$var$$e0a0e4399f316b76$var$WEBKIT_OPEN_DELAY));
        return;
    }
    // Flush transition callbacks when the animation has completed or we ran out of time.
    if (wasOpenKeyboard !== isOpenKeyboard || signal.aborted) for (let callback of $6c720e662277c9a1$var$$e0a0e4399f316b76$var$transitionCallbacks){
        callback(isOpenKeyboard);
        $6c720e662277c9a1$var$$e0a0e4399f316b76$var$transitionCallbacks.delete(callback);
    }
    // Cancel the observer when no pending updates remain or we ran out of time.
    if ($6c720e662277c9a1$var$$e0a0e4399f316b76$var$resizeCallbacks.size + $6c720e662277c9a1$var$$e0a0e4399f316b76$var$transitionCallbacks.size <= 0 || signal.aborted) {
        window.clearInterval($6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.get(window));
        $6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.delete(window);
    }
}
function $6c720e662277c9a1$var$$e0a0e4399f316b76$var$setupGlobalListeners(timeout = $6c720e662277c9a1$var$$e0a0e4399f316b76$var$TRANSITION_TIMEOUT) {
    return window.setInterval($6c720e662277c9a1$var$$e0a0e4399f316b76$var$onTransitionFrame, $6c720e662277c9a1$var$$e0a0e4399f316b76$var$TRANSITION_FRAMETIME, (0, $lDJIO.isKeyboardOpen)(), AbortSignal.timeout(timeout));
}
function $6c720e662277c9a1$export$b80f73f72d03c10f(fn) {
    // Flush synchronously when keyboard is unsupported. This is default for non-touch devices
    // or devices which did not open their OSK within our opening timeout.
    if (!(0, $lDJIO.supportsKeyboard)()) return fn(false), ()=>{};
    // Wait two frames to see if focus lands on an input.
    let frame = window.requestAnimationFrame(()=>{
        frame = window.requestAnimationFrame(()=>{
            let activeElement = document.hasFocus() ? (0, $fvyIQ.getActiveElement)() : null;
            let willKeyboardOpen = (0, $lDJIO.willOpenKeyboard)(activeElement);
            // If keyboard won't change, call the function immediately.
            if ((0, $lDJIO.isKeyboardOpen)() === willKeyboardOpen) return fn(willKeyboardOpen);
            // On close, fire immediately since consumers may assert the ICB.
            if ((0, $lDJIO.isKeyboardOpen)() && !willKeyboardOpen) return fn(willKeyboardOpen);
            $6c720e662277c9a1$var$$e0a0e4399f316b76$var$resizeCallbacks.add(fn);
            if (!$6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.has(window)) $6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.set(window, $6c720e662277c9a1$var$$e0a0e4399f316b76$var$setupGlobalListeners());
        });
    });
    return ()=>{
        window.cancelAnimationFrame(frame);
        $6c720e662277c9a1$var$$e0a0e4399f316b76$var$resizeCallbacks.delete(fn);
    };
}
function $6c720e662277c9a1$export$c82b8fe1ad51fcd9(fn) {
    // Flush synchronously when keyboard is unsupported. This is default for non-touch devices
    // or devices which did not open their OSK within our opening timeout.
    if (!(0, $lDJIO.supportsKeyboard)()) return fn(false), ()=>{};
    // Wait two frames to see if focus lands on an input.
    let frame = window.requestAnimationFrame(()=>{
        frame = window.requestAnimationFrame(()=>{
            let activeElement = document.hasFocus() ? (0, $fvyIQ.getActiveElement)() : null;
            let willKeyboardOpen = (0, $lDJIO.willOpenKeyboard)(activeElement);
            // If keyboard won't transition, fire immediately.
            if ((0, $lDJIO.isKeyboardOpen)() === willKeyboardOpen) return fn(willKeyboardOpen);
            $6c720e662277c9a1$var$$e0a0e4399f316b76$var$transitionCallbacks.add(fn);
            if (!$6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.has(window)) $6c720e662277c9a1$var$$e0a0e4399f316b76$var$listenersByWindow.set(window, $6c720e662277c9a1$var$$e0a0e4399f316b76$var$setupGlobalListeners());
        });
    });
    return ()=>{
        window.cancelAnimationFrame(frame);
        $6c720e662277c9a1$var$$e0a0e4399f316b76$var$transitionCallbacks.delete(fn);
    };
}

});
parcelRegister("lDJIO", function(module, exports) {

$parcel$export(module.exports, "willOpenKeyboard", () => $aa8a50aa6d60aa2d$export$c57958e35f31ed73);
$parcel$export(module.exports, "supportsKeyboard", () => $aa8a50aa6d60aa2d$export$a986ed8aea890397);
$parcel$export(module.exports, "isCtrlKeyPressed", () => $aa8a50aa6d60aa2d$export$16792effe837dba3);
$parcel$export(module.exports, "isKeyboardOpen", () => $aa8a50aa6d60aa2d$export$b1f1c83775b8b5f7);

var $7ByPJ = parcelRequire("7ByPJ");

var $fvyIQ = parcelRequire("fvyIQ");

var $aRGQy = parcelRequire("aRGQy");

var $11FxZ = parcelRequire("11FxZ");

var $3OYqT = parcelRequire("3OYqT");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_HEIGHT = 100;
const $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_TIMEOUT = 600;
// Tracks layout state of the on-screen keyboard.
const $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state = {
    isOpen: false,
    screenWidth: 0,
    screenHeight: 0,
    screenAngle: 0,
    screenTimeout: 0,
    startTimeStamp: 0,
    endTimeStamp: 0,
    resizeTimeStamp: 0,
    resizeTimeout: 0
};
// HTML input types that do not cause the software keyboard to appear.
const $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$getTouchScreen() {
    // Normalize the screen by any scaling to get the layout coordinate space.
    let screenWidth = Number(window.visualViewport?.width ?? window.innerWidth);
    let screenHeight = Number(window.visualViewport?.height ?? window.innerHeight);
    let visualScale = Number(window.visualViewport?.scale ?? 1);
    return {
        width: screenWidth * visualScale,
        height: screenHeight * visualScale,
        angle: window.screen.orientation?.angle ?? 0
    };
}
function $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onResizeStart(e) {
    // So we don't constantly call clearTimeout and setTimeout, keep track of the
    // current timeout time and only reschedule the timer when it is getting close.
    if ($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.resizeTimeStamp <= e.timeStamp + 50) {
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.resizeTimeStamp = e.timeStamp + 150;
        window.clearTimeout($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.resizeTimeout);
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.resizeTimeout = window.setTimeout($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onResizeEnd, 150);
    }
}
function $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onResizeEnd() {
    let viewportMeta = (0, $aRGQy.getMetaValue)('viewport');
    // Overlaying keyboards do not impact geometry, so there is nothing to measure.
    // https://caniuse.com/mdn-html_elements_meta_name_viewport_interactive-widget
    if ((0, $11FxZ.isAndroid)() && viewportMeta?.includes('overlays-content')) return;
    let time = performance.now();
    let screen = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$getTouchScreen();
    let elapsed = time - $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.startTimeStamp;
    let delta = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight - screen.height;
    let rotation = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle - screen.angle;
    // Update the screen once an open keyboard that rotated along closes. The state swap was
    // deferred, so the old width predicts the height it should close towards.
    if (Math.abs(rotation) % 180 && $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth - screen.height < $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_HEIGHT) {
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth = screen.width;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight = screen.height;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle = screen.angle;
        delta = 0;
    }
    // Update the screen if a resize happens outside the capture timeframe. We debounce
    // because WebKit may fire its single opening resize before the focus event.
    if (elapsed > $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_TIMEOUT) {
        window.clearTimeout($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenTimeout);
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenTimeout = window.setTimeout(()=>{
            let activeElement = document.hasFocus() ? (0, $fvyIQ.getActiveElement)() : null;
            let willKeyboardOpen = $aa8a50aa6d60aa2d$export$c57958e35f31ed73(activeElement);
            let screen = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$getTouchScreen();
            if (Math.abs($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle - screen.angle) % 180) return;
            if ($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen && willKeyboardOpen) return;
            $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth = screen.width;
            $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight = screen.height;
            $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle = screen.angle;
            $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen = false;
        }, $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_TIMEOUT);
    }
    // Otherwise, record an opening if the height changed by more than our threshold.
    // This may fail if the layout viewport changes for other reasons during this timeframe.
    if (elapsed <= $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_TIMEOUT && delta >= $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_HEIGHT) $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.endTimeStamp = time;
    // Store the new open state since the viewport is stable when this is reached.
    $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen = delta >= $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_HEIGHT;
}
function $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onOrientationChange() {
    let screen = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$getTouchScreen();
    let rotation = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle - screen.angle;
    // Rotation may cause the resize buffer to be filled, but we need to make sure a screen
    // estimate is already available in case focus lands before it expires. This could fail
    // if a top bar exceeds the keyboard threshold, in which case we may need to revisit.
    if (Math.abs(rotation) % 180 && !$aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen) {
        let width = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth;
        let height = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth = height;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight = width;
    }
    if (!$aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen) $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle = screen.angle;
}
function $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onFocus(e) {
    let target = (0, $fvyIQ.getEventTarget)(e);
    let willKeyboardOpen = $aa8a50aa6d60aa2d$export$c57958e35f31ed73(target);
    let time = performance.now();
    let screen = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$getTouchScreen();
    let delta = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight - screen.height;
    // Update the screen and start the timer if we are about to open.
    if (delta < $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_HEIGHT && willKeyboardOpen) {
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth = screen.width;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight = screen.height;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle = screen.angle;
        $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.startTimeStamp = time;
    }
    // This focus will open a keyboard so reset the buffer.
    if (willKeyboardOpen) window.clearTimeout($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenTimeout);
    // Stop the timer if the keyboard is already open.
    if (delta >= $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_HEIGHT && willKeyboardOpen) $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.endTimeStamp = time;
}
function $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$setupGlobalEvents() {
    let screen = $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$getTouchScreen();
    (0, $7ByPJ.addEvent)(window.visualViewport, 'resize', (0, $11FxZ.isWebKit)() ? $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onResizeEnd : $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onResizeStart);
    (0, $7ByPJ.addEvent)(window.screen.orientation, 'change', $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onOrientationChange);
    (0, $7ByPJ.addEvent)(window, 'focus', $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$onFocus, {
        capture: true,
        passive: true
    });
    // Store the initial screen dimensions.
    $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenWidth = screen.width;
    $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenHeight = screen.height;
    $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.screenAngle = screen.angle;
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$setupGlobalEvents();
    else (0, $7ByPJ.addEvent)(document, 'DOMContentLoaded', $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$setupGlobalEvents);
}
function $aa8a50aa6d60aa2d$export$a986ed8aea890397() {
    let viewportMeta = (0, $aRGQy.getMetaValue)('viewport');
    // Overlaying keyboards do not impact geometry, so there is nothing to await.
    // https://caniuse.com/mdn-html_elements_meta_name_viewport_interactive-widget
    if ((0, $11FxZ.isAndroid)() && viewportMeta?.includes('overlays-content')) return false;
    // WebKit may resize before focus, but an open keyboard always means we have support.
    if ($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen) return true;
    // As long as no input has ever been focused, we return default support.
    if (!$aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.startTimeStamp) return window.navigator.maxTouchPoints > 0;
    // If keyboard geometry changed within the timeout period, we have support.
    if ($aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.endTimeStamp >= $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.startTimeStamp) return true;
    // If a geometry change is mid-flight we return the most recent support.
    // Supported platforms may have a hardware keyboard, which this won't catch, but thats
    // about as far as we can reasonably go to exclude non-touch devices.
    return performance.now() - $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.startTimeStamp <= $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$KEYBOARD_TIMEOUT ? $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.endTimeStamp > 0 || window.navigator.maxTouchPoints > 0 : false;
}
function $aa8a50aa6d60aa2d$export$c57958e35f31ed73(target) {
    if (!(target instanceof Element) || !(0, $3OYqT.isFocusable)(target)) return false;
    let isTextArea = target instanceof HTMLTextAreaElement;
    let isEditable = target instanceof HTMLElement && target.isContentEditable;
    let isTextInput = target instanceof HTMLInputElement && !$aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$nonTextInputTypes.has(target.type);
    return isTextArea || isEditable || isTextInput;
}
function $aa8a50aa6d60aa2d$export$16792effe837dba3(event) {
    return (0, $11FxZ.isMac)() ? event.metaKey : event.ctrlKey;
}
function $aa8a50aa6d60aa2d$export$b1f1c83775b8b5f7() {
    return $aa8a50aa6d60aa2d$var$$bb39c0fc1c19b34c$var$state.isOpen;
}

});




parcelRegister("br9QK", function(module, exports) {

$parcel$export(module.exports, "DismissButton", () => $f9e5dcb1ca3205e1$export$2317d149ed6f78c4);

var $cuiXY = parcelRequire("cuiXY");

var $dkaC0 = parcelRequire("dkaC0");

var $gI8Gw = parcelRequire("gI8Gw");

var $31fH3 = parcelRequire("31fH3");

var $eF4cA = parcelRequire("eF4cA");
function $f9e5dcb1ca3205e1$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f9e5dcb1ca3205e1$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($f9e5dcb1ca3205e1$var$$parcel$interopDefault((0, $cuiXY.default)), '@react-aria/overlays');
    let labels = (0, $dkaC0.useLabels)(otherProps, stringFormatter.format('dismiss'));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}

});
parcelRegister("cuiXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $719730a75281094c$export$2e2bcd8739ae039);

var $j1xyF = parcelRequire("j1xyF");

var $k3CJx = parcelRequire("k3CJx");

var $dZkbZ = parcelRequire("dZkbZ");

var $1vkXU = parcelRequire("1vkXU");

var $9KPsi = parcelRequire("9KPsi");

var $hSjQ6 = parcelRequire("hSjQ6");

var $hfmtN = parcelRequire("hfmtN");

var $kh9eb = parcelRequire("kh9eb");

var $g7PgS = parcelRequire("g7PgS");

var $gBP1y = parcelRequire("gBP1y");

var $1o0WX = parcelRequire("1o0WX");

var $b4UdD = parcelRequire("b4UdD");

var $29j6U = parcelRequire("29j6U");

var $hmdW5 = parcelRequire("hmdW5");

var $kpHIe = parcelRequire("kpHIe");

var $iDOlR = parcelRequire("iDOlR");

var $1Tl8x = parcelRequire("1Tl8x");

var $8kOUW = parcelRequire("8kOUW");

var $gCKJE = parcelRequire("gCKJE");

var $97orb = parcelRequire("97orb");

var $9nNSu = parcelRequire("9nNSu");

var $dER77 = parcelRequire("dER77");

var $1yUqR = parcelRequire("1yUqR");

var $kPAhj = parcelRequire("kPAhj");

var $2osbi = parcelRequire("2osbi");

var $1Liz2 = parcelRequire("1Liz2");

var $6DgjO = parcelRequire("6DgjO");

var $9WKao = parcelRequire("9WKao");

var $tIjxS = parcelRequire("tIjxS");

var $ajTmd = parcelRequire("ajTmd");

var $9DHKf = parcelRequire("9DHKf");

var $i5JVU = parcelRequire("i5JVU");

var $fq5wu = parcelRequire("fq5wu");

var $3HTDh = parcelRequire("3HTDh");
var $719730a75281094c$export$2e2bcd8739ae039 = {};
$719730a75281094c$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $j1xyF.default),
    "bg-BG": (0, $k3CJx.default),
    "cs-CZ": (0, $dZkbZ.default),
    "da-DK": (0, $1vkXU.default),
    "de-DE": (0, $9KPsi.default),
    "el-GR": (0, $hSjQ6.default),
    "en-US": (0, $hfmtN.default),
    "es-ES": (0, $kh9eb.default),
    "et-EE": (0, $g7PgS.default),
    "fi-FI": (0, $gBP1y.default),
    "fr-FR": (0, $1o0WX.default),
    "he-IL": (0, $b4UdD.default),
    "hr-HR": (0, $29j6U.default),
    "hu-HU": (0, $hmdW5.default),
    "it-IT": (0, $kpHIe.default),
    "ja-JP": (0, $iDOlR.default),
    "ko-KR": (0, $1Tl8x.default),
    "lt-LT": (0, $8kOUW.default),
    "lv-LV": (0, $gCKJE.default),
    "nb-NO": (0, $97orb.default),
    "nl-NL": (0, $9nNSu.default),
    "pl-PL": (0, $dER77.default),
    "pt-BR": (0, $1yUqR.default),
    "pt-PT": (0, $kPAhj.default),
    "ro-RO": (0, $2osbi.default),
    "ru-RU": (0, $1Liz2.default),
    "sk-SK": (0, $6DgjO.default),
    "sl-SI": (0, $9WKao.default),
    "sr-SP": (0, $tIjxS.default),
    "sv-SE": (0, $ajTmd.default),
    "tr-TR": (0, $9DHKf.default),
    "uk-UA": (0, $i5JVU.default),
    "zh-CN": (0, $fq5wu.default),
    "zh-TW": (0, $3HTDh.default)
};

});
parcelRegister("j1xyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e030c6cc3d780b2a$export$2e2bcd8739ae039);
var $e030c6cc3d780b2a$export$2e2bcd8739ae039 = {};
$e030c6cc3d780b2a$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

});

parcelRegister("k3CJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $813e00f1fab5acd1$export$2e2bcd8739ae039);
var $813e00f1fab5acd1$export$2e2bcd8739ae039 = {};
$813e00f1fab5acd1$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

});

parcelRegister("dZkbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee684c748c65561$export$2e2bcd8739ae039);
var $0ee684c748c65561$export$2e2bcd8739ae039 = {};
$0ee684c748c65561$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};

});

parcelRegister("1vkXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $971df4e02e7e19f0$export$2e2bcd8739ae039);
var $971df4e02e7e19f0$export$2e2bcd8739ae039 = {};
$971df4e02e7e19f0$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};

});

parcelRegister("9KPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $11827318765b52e0$export$2e2bcd8739ae039);
var $11827318765b52e0$export$2e2bcd8739ae039 = {};
$11827318765b52e0$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};

});

parcelRegister("hSjQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $75da72aee441a9a8$export$2e2bcd8739ae039);
var $75da72aee441a9a8$export$2e2bcd8739ae039 = {};
$75da72aee441a9a8$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

});

parcelRegister("hfmtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9880b7ba7504046d$export$2e2bcd8739ae039);
var $9880b7ba7504046d$export$2e2bcd8739ae039 = {};
$9880b7ba7504046d$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};

});

parcelRegister("kh9eb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd0954bf16549ad3$export$2e2bcd8739ae039);
var $bd0954bf16549ad3$export$2e2bcd8739ae039 = {};
$bd0954bf16549ad3$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("g7PgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $337cf2094efc6d0a$export$2e2bcd8739ae039);
var $337cf2094efc6d0a$export$2e2bcd8739ae039 = {};
$337cf2094efc6d0a$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};

});

parcelRegister("gBP1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f9baa7b254f098$export$2e2bcd8739ae039);
var $23f9baa7b254f098$export$2e2bcd8739ae039 = {};
$23f9baa7b254f098$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};

});

parcelRegister("1o0WX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e59568ce68adbb$export$2e2bcd8739ae039);
var $c4e59568ce68adbb$export$2e2bcd8739ae039 = {};
$c4e59568ce68adbb$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};

});

parcelRegister("b4UdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $efc229bb7d91a440$export$2e2bcd8739ae039);
var $efc229bb7d91a440$export$2e2bcd8739ae039 = {};
$efc229bb7d91a440$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

});

parcelRegister("29j6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71a9c68cac551b0$export$2e2bcd8739ae039);
var $a71a9c68cac551b0$export$2e2bcd8739ae039 = {};
$a71a9c68cac551b0$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("hmdW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $322e5215afa903e4$export$2e2bcd8739ae039);
var $322e5215afa903e4$export$2e2bcd8739ae039 = {};
$322e5215afa903e4$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};

});

parcelRegister("kpHIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2fc2712b198e4d$export$2e2bcd8739ae039);
var $5a2fc2712b198e4d$export$2e2bcd8739ae039 = {};
$5a2fc2712b198e4d$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};

});

parcelRegister("iDOlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7168802ec45ef76d$export$2e2bcd8739ae039);
var $7168802ec45ef76d$export$2e2bcd8739ae039 = {};
$7168802ec45ef76d$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};

});

parcelRegister("1Tl8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f7f0085238c506$export$2e2bcd8739ae039);
var $76f7f0085238c506$export$2e2bcd8739ae039 = {};
$76f7f0085238c506$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};

});

parcelRegister("8kOUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5e1bbf8d06a6f6$export$2e2bcd8739ae039);
var $7c5e1bbf8d06a6f6$export$2e2bcd8739ae039 = {};
$7c5e1bbf8d06a6f6$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};

});

parcelRegister("gCKJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4092318060033772$export$2e2bcd8739ae039);
var $4092318060033772$export$2e2bcd8739ae039 = {};
$4092318060033772$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};

});

parcelRegister("97orb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce3e70615980852d$export$2e2bcd8739ae039);
var $ce3e70615980852d$export$2e2bcd8739ae039 = {};
$ce3e70615980852d$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};

});

parcelRegister("9nNSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c21bd4e5897f2b5$export$2e2bcd8739ae039);
var $1c21bd4e5897f2b5$export$2e2bcd8739ae039 = {};
$1c21bd4e5897f2b5$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};

});

parcelRegister("dER77", function(module, exports) {

$parcel$export(module.exports, "default", () => $5371b2c5f4eea11c$export$2e2bcd8739ae039);
var $5371b2c5f4eea11c$export$2e2bcd8739ae039 = {};
$5371b2c5f4eea11c$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};

});

parcelRegister("1yUqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84f47e7b88e7f24$export$2e2bcd8739ae039);
var $a84f47e7b88e7f24$export$2e2bcd8739ae039 = {};
$a84f47e7b88e7f24$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("kPAhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae82f813ce5fdd6$export$2e2bcd8739ae039);
var $0ae82f813ce5fdd6$export$2e2bcd8739ae039 = {};
$0ae82f813ce5fdd6$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};

});

parcelRegister("2osbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6b2d067f3450659$export$2e2bcd8739ae039);
var $d6b2d067f3450659$export$2e2bcd8739ae039 = {};
$d6b2d067f3450659$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};

});

parcelRegister("1Liz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $50c45d8a9b91ba0a$export$2e2bcd8739ae039);
var $50c45d8a9b91ba0a$export$2e2bcd8739ae039 = {};
$50c45d8a9b91ba0a$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

});

parcelRegister("6DgjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b955f6c7c5508e$export$2e2bcd8739ae039);
var $d3b955f6c7c5508e$export$2e2bcd8739ae039 = {};
$d3b955f6c7c5508e$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};

});

parcelRegister("9WKao", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b38b7869a8c570b$export$2e2bcd8739ae039);
var $8b38b7869a8c570b$export$2e2bcd8739ae039 = {};
$8b38b7869a8c570b$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};

});

parcelRegister("tIjxS", function(module, exports) {

$parcel$export(module.exports, "default", () => $050b3a490959782b$export$2e2bcd8739ae039);
var $050b3a490959782b$export$2e2bcd8739ae039 = {};
$050b3a490959782b$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("ajTmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dfedcb20f018ae1$export$2e2bcd8739ae039);
var $3dfedcb20f018ae1$export$2e2bcd8739ae039 = {};
$3dfedcb20f018ae1$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};

});

parcelRegister("9DHKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa7ec94e5583675$export$2e2bcd8739ae039);
var $cfa7ec94e5583675$export$2e2bcd8739ae039 = {};
$cfa7ec94e5583675$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};

});

parcelRegister("i5JVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d1502159264ce6e$export$2e2bcd8739ae039);
var $5d1502159264ce6e$export$2e2bcd8739ae039 = {};
$5d1502159264ce6e$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

});

parcelRegister("fq5wu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e647735194b6bab4$export$2e2bcd8739ae039);
var $e647735194b6bab4$export$2e2bcd8739ae039 = {};
$e647735194b6bab4$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};

});

parcelRegister("3HTDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3955f7ec9620d1f8$export$2e2bcd8739ae039);
var $3955f7ec9620d1f8$export$2e2bcd8739ae039 = {};
$3955f7ec9620d1f8$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};

});


parcelRegister("31fH3", function(module, exports) {

$parcel$export(module.exports, "useVisuallyHidden", () => $a3a1dc4db7f8600b$export$a966af930f325cab);
$parcel$export(module.exports, "VisuallyHidden", () => $a3a1dc4db7f8600b$export$439d29a4e110a164);

var $lhKAD = parcelRequire("lhKAD");

var $i1DSg = parcelRequire("i1DSg");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a3a1dc4db7f8600b$var$$ea3928288112382f$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap'
};
function $a3a1dc4db7f8600b$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $eF4cA.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $eF4cA.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$a3a1dc4db7f8600b$var$$ea3928288112382f$var$styles,
            ...style
        };
        else return $a3a1dc4db7f8600b$var$$ea3928288112382f$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $a3a1dc4db7f8600b$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = 'div', isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $a3a1dc4db7f8600b$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(Element, (0, $lhKAD.mergeProps)(otherProps, visuallyHiddenProps), children);
}

});


parcelRegister("k771r", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $c2ed7d87ee988454$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "useOverlayFocusContain", () => $c2ed7d87ee988454$export$14c98a7594375490);

var $7aYcI = parcelRequire("7aYcI");

var $8M8Qw = parcelRequire("8M8Qw");

var $6pgkA = parcelRequire("6pgkA");

var $hWe38 = parcelRequire("hWe38");

var $4skXn = parcelRequire("4skXn");

var $euMIq = parcelRequire("euMIq");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c2ed7d87ee988454$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
function $c2ed7d87ee988454$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $hWe38.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $eF4cA.useState)(false);
    let contextValue = (0, $eF4cA.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $euMIq.useUNSAFE_PortalContext)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $6pgkA.FocusScope), {
        restoreFocus: true,
        contain: (props.shouldContainFocus || contain) && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($c2ed7d87ee988454$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $7aYcI.ClearPressResponder), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8M8Qw.FocusableContext).Provider, {
        value: null
    }, contents)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($l19Vn))).createPortal(contents, portalContainer);
}
function $c2ed7d87ee988454$export$14c98a7594375490() {
    let ctx = (0, $eF4cA.useContext)($c2ed7d87ee988454$export$a2200b96afd16271);
    let setContain = ctx?.setContain;
    (0, $4skXn.useLayoutEffect)(()=>{
        setContain?.(true);
    }, [
        setContain
    ]);
}

});
parcelRegister("7aYcI", function(module, exports) {

$parcel$export(module.exports, "PressResponder", () => $86c4ce18c50f93fe$export$3351871ee4b288b8);
$parcel$export(module.exports, "ClearPressResponder", () => $86c4ce18c50f93fe$export$cf75428e0b9ed1ea);

var $lhKAD = parcelRequire("lhKAD");

var $g0FJ3 = parcelRequire("g0FJ3");

var $26CkO = parcelRequire("26CkO");

var $eLOK5 = parcelRequire("eLOK5");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $86c4ce18c50f93fe$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $eF4cA.useRef)(false);
    let prevContext = (0, $eF4cA.useContext)((0, $g0FJ3.PressResponderContext));
    // oxlint-disable-next-line react/react-compiler
    let context = (0, $lhKAD.mergeProps)(prevContext || {}, {
        ...props,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    context.ref = (0, $26CkO.useObjectRef)(ref || prevContext?.ref);
    (0, $eLOK5.useSyncRef)(prevContext, context.ref);
    (0, $eF4cA.useEffect)(()=>{
        if (!isRegistered.current) isRegistered.current = true; // only warn once in strict mode.
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $g0FJ3.PressResponderContext).Provider, {
        value: context
    }, children);
});
function $86c4ce18c50f93fe$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $eF4cA.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $g0FJ3.PressResponderContext).Provider, {
        value: context
    }, children);
}

});

parcelRegister("euMIq", function(module, exports) {

$parcel$export(module.exports, "useUNSAFE_PortalContext", () => $b4d41e445e831daa$export$9fc1347d4195ccb3);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b4d41e445e831daa$export$60d741e20e0aa309 = (0, $eF4cA.createContext)({});
function $b4d41e445e831daa$export$78efe591171d7d45(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $b4d41e445e831daa$export$9fc1347d4195ccb3();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($b4d41e445e831daa$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? undefined : getContainer ?? ctxGetContainer
        }
    }, props.children);
}
function $b4d41e445e831daa$export$9fc1347d4195ccb3() {
    return (0, $eF4cA.useContext)($b4d41e445e831daa$export$60d741e20e0aa309) ?? {};
}

});


parcelRegister("lIr3v", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", () => $c3035b95b125bcfa$export$61c6a8c84e605fb6);

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c3035b95b125bcfa$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $iUErx.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    let [point, setPoint] = (0, $eF4cA.useState)(null);
    const open = (0, $eF4cA.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $eF4cA.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $eF4cA.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle,
        point: point,
        setPoint: setPoint
    };
}

});
parcelRegister("iUErx", function(module, exports) {

$parcel$export(module.exports, "useControlledState", () => $cb6f9b5dd564c10a$export$40bfa8c7b0832715);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Use the earliest effect possible to reset the ref below.
const $cb6f9b5dd564c10a$var$$3e6197669829fe11$var$useEarlyEffect = typeof document !== 'undefined' || parseInt((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).version, 10) >= 19 ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA)))['useInsertionEffect'] ?? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useLayoutEffect : ()=>{};
function $cb6f9b5dd564c10a$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    // Store the value in both state and a ref. The state value will only be used when uncontrolled.
    // The ref is used to track the most current value, which is passed to the function setState callback.
    let [stateValue, setStateValue] = (0, $eF4cA.useState)(value || defaultValue);
    let valueRef = (0, $eF4cA.useRef)(stateValue);
    let isControlledRef = (0, $eF4cA.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $eF4cA.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    // After each render, update the ref to the current value.
    // This ensures that the setState callback argument is reset.
    // Note: the effect should not have any dependencies so that controlled values always reset.
    let currentValue = isControlled ? value : stateValue;
    $cb6f9b5dd564c10a$var$$3e6197669829fe11$var$useEarlyEffect(()=>{
        valueRef.current = currentValue;
    });
    let [, forceUpdate] = (0, $eF4cA.useReducer)(()=>({}), {});
    let setValue = (0, $eF4cA.useCallback)((value, ...args)=>{
        // @ts-ignore - TS doesn't know that T cannot be a function.
        let newValue = typeof value === 'function' ? value(valueRef.current) : value;
        if (!Object.is(valueRef.current, newValue)) {
            // Update the ref so that the next setState callback has the most recent value.
            valueRef.current = newValue;
            setStateValue(newValue);
            // Always trigger a re-render, even when controlled, so that the layout effect above runs to reset the value.
            forceUpdate();
            // Trigger onChange. Note that if setState is called multiple times in a single event,
            // onChange will be called for each one instead of only once.
            onChange?.(newValue, ...args);
        }
    }, [
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}

});


parcelRegister("6AczJ", function(module, exports) {

$parcel$export(module.exports, "useEnterAnimation", () => $e4c56b720faf7037$export$6d3443f2c48bfc20);
$parcel$export(module.exports, "useExitAnimation", () => $e4c56b720faf7037$export$45fda7c47f93fd48);

var $d8j5I = parcelRequire("d8j5I");

var $7ByPJ = parcelRequire("7ByPJ");

var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e4c56b720faf7037$export$6d3443f2c48bfc20(ref, isReady = true, onEnter) {
    let [isEntering, setEntering] = (0, $eF4cA.useState)(true);
    let isAnimationReady = isEntering && isReady;
    (0, $4skXn.useLayoutEffect)(()=>{
        if (!isReady && ref.current) return (0, $d8j5I.chain)((0, $7ByPJ.setStyle)(ref.current, 'opacity', '0'), (0, $7ByPJ.setStyle)(ref.current, 'clip', 'rect(0 0 0 0)'), (0, $7ByPJ.setStyle)(ref.current, 'clip-path', 'inset(50%)'), (0, $7ByPJ.setStyle)(ref.current, 'mask-image', 'linear-gradient(#0000, #0000)'));
    }, [
        ref,
        isReady
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (isAnimationReady && ref.current && 'getAnimations' in ref.current) {
            for (let animation of ref.current.getAnimations())if (animation instanceof CSSTransition) animation.cancel();
        }
    }, [
        ref,
        isAnimationReady
    ]);
    $e4c56b720faf7037$var$$fcc7165e876206c6$var$useAnimation(ref, isAnimationReady, onEnter, (0, $eF4cA.useCallback)(()=>setEntering(false), []));
    return isAnimationReady;
}
function $e4c56b720faf7037$export$45fda7c47f93fd48(ref, isOpen, onExit) {
    let [exitState, setExitState] = (0, $eF4cA.useState)(isOpen ? 'open' : 'closed');
    switch(exitState){
        case 'open':
            // If isOpen becomes false, set the state to exiting.
            if (!isOpen) setExitState('exiting');
            break;
        case 'closed':
        case 'exiting':
            // If we are exiting and isOpen becomes true, the animation was interrupted.
            // Reset the state to open.
            if (isOpen) setExitState('open');
            break;
    }
    let isExiting = exitState === 'exiting';
    $e4c56b720faf7037$var$$fcc7165e876206c6$var$useAnimation(ref, isExiting, onExit, (0, $eF4cA.useCallback)(()=>{
        // Set the state to closed, which will cause the element to be unmounted.
        setExitState((state)=>state === 'exiting' ? 'closed' : state);
    }, []));
    return isExiting;
}
function $e4c56b720faf7037$var$$fcc7165e876206c6$var$useAnimation(ref, isActive, onStart, onEnd) {
    let isActiveRef = (0, $eF4cA.useRef)(null);
    let start = (0, $4lMDe.useEffectEvent)(onStart);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (isActive && ref.current && isActiveRef.current !== isActive) {
            isActiveRef.current = isActive;
            if (!('getAnimations' in ref.current)) {
                // JSDOM
                onEnd();
                return;
            }
            let startPromise = start?.(ref.current);
            let animations = ref.current.getAnimations().filter((a)=>(typeof DocumentTimeline === 'undefined' || a.timeline instanceof DocumentTimeline) && a.playState === 'running');
            if (animations.length === 0 && !startPromise) {
                onEnd();
                return;
            }
            Promise.all([
                startPromise,
                ...animations.map((a)=>a.finished)
            ]).then(()=>{
                (0, $l19Vn.flushSync)(()=>{
                    onEnd();
                });
            }).catch(()=>{});
        }
        isActiveRef.current = isActive;
    }, [
        ref,
        isActive,
        onEnd
    ]);
}

});


parcelRegister("bVwb4", function(module, exports) {

$parcel$export(module.exports, "MenuStateContext", () => $fd23024458c647e6$export$24aad8519b95b41b);
$parcel$export(module.exports, "RootMenuTriggerStateContext", () => $fd23024458c647e6$export$795aec4671cbae19);
$parcel$export(module.exports, "MenuTrigger", () => $fd23024458c647e6$export$27d2ad3c5815583e);
$parcel$export(module.exports, "SubmenuTrigger", () => $fd23024458c647e6$export$ecabc99eeffab7ca);
$parcel$export(module.exports, "Menu", () => $fd23024458c647e6$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "MenuSection", () => $fd23024458c647e6$export$4b1545b4f2016d26);
$parcel$export(module.exports, "MenuItem", () => $fd23024458c647e6$export$2ce376c2cc3355c8);
$parcel$export(module.exports, "MenuLoadMoreItem", () => $fd23024458c647e6$export$93aba29d3a678058);

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $9PmUB = parcelRequire("9PmUB");

var $1etmN = parcelRequire("1etmN");

var $2AolA = parcelRequire("2AolA");

var $8gDpA = parcelRequire("8gDpA");

var $f8UJ0 = parcelRequire("f8UJ0");

var $hUj7u = parcelRequire("hUj7u");

var $jbXau = parcelRequire("jbXau");

var $2FPWu = parcelRequire("2FPWu");

var $c1ibQ = parcelRequire("c1ibQ");

var $lRhry = parcelRequire("lRhry");
var $hUJml = parcelRequire("hUJml");
var $jcwJg = parcelRequire("jcwJg");
var $3nhvX = parcelRequire("3nhvX");
var $51tBd = parcelRequire("51tBd");

var $bWhaY = parcelRequire("bWhaY");

var $2esle = parcelRequire("2esle");
var $4zDYv = parcelRequire("4zDYv");

var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $fVfXf = parcelRequire("fVfXf");

var $6pgkA = parcelRequire("6pgkA");

var $gF3YT = parcelRequire("gF3YT");

var $lJdzA = parcelRequire("lJdzA");

var $lhKAD = parcelRequire("lhKAD");

var $7aYcI = parcelRequire("7aYcI");

var $eF4cA = parcelRequire("eF4cA");

var $dWVHy = parcelRequire("dWVHy");

var $8muBU = parcelRequire("8muBU");

var $j2JDe = parcelRequire("j2JDe");

var $19ZgV = parcelRequire("19ZgV");

var $fAqsC = parcelRequire("fAqsC");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fd23024458c647e6$export$c7e742effb1c51e2 = (0, $eF4cA.createContext)(null);
const $fd23024458c647e6$export$24aad8519b95b41b = (0, $eF4cA.createContext)(null);
const $fd23024458c647e6$export$795aec4671cbae19 = (0, $eF4cA.createContext)(null);
const $fd23024458c647e6$var$$49319ee1285aa241$var$SelectionManagerContext = (0, $eF4cA.createContext)(null);
function $fd23024458c647e6$export$27d2ad3c5815583e(props) {
    let state = (0, $2esle.useMenuTriggerState)(props);
    let ref = (0, $eF4cA.useRef)(null);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $3nhvX.useMenuTrigger)({
        ...props,
        type: 'menu'
    }, state, ref);
    let scrollRef = (0, $eF4cA.useRef)(null);
    // If within a collection (e.g. Tabs), render nothing.
    // Not using createHideableComponent for this because that also creates a forwardRef.
    let isHidden = (0, $19ZgV.useIsHidden)();
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $fd23024458c647e6$export$c7e742effb1c51e2,
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                state
            ],
            [
                $fd23024458c647e6$export$795aec4671cbae19,
                state
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    trigger: 'MenuTrigger',
                    triggerRef: ref,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    'aria-labelledby': menuProps['aria-labelledby'],
                    offset: props.trigger === 'contextMenu' ? 0 : undefined
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $7aYcI.PressResponder), {
        ...menuTriggerProps,
        ref: ref,
        isPressed: state.isOpen
    }, props.children));
}
const $fd23024458c647e6$var$$49319ee1285aa241$var$SubmenuTriggerContext = (0, $eF4cA.createContext)(null);
class $fd23024458c647e6$var$$49319ee1285aa241$var$SubmenuTriggerNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'submenutrigger';
    }
    filter(collection, newCollection, filterFn) {
        let triggerNode = collection.getItem(this.firstChildKey);
        if (triggerNode && filterFn(triggerNode.textValue, this)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
const $fd23024458c647e6$export$ecabc99eeffab7ca = (0, $3g2oV.createBranchComponent)($fd23024458c647e6$var$$49319ee1285aa241$var$SubmenuTriggerNode, (props, ref, item)=>{
    let { CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let state = (0, $eF4cA.useContext)($fd23024458c647e6$export$24aad8519b95b41b);
    let rootMenuTriggerState = (0, $eF4cA.useContext)($fd23024458c647e6$export$795aec4671cbae19);
    let submenuTriggerState = (0, $4zDYv.useSubmenuTriggerState)({
        triggerKey: item.key
    }, rootMenuTriggerState);
    let submenuRef = (0, $eF4cA.useRef)(null);
    let itemRef = (0, $26CkO.useObjectRef)(ref);
    let { parentMenuRef: parentMenuRef, shouldUseVirtualFocus: shouldUseVirtualFocus } = (0, $eF4cA.useContext)($fd23024458c647e6$var$$49319ee1285aa241$var$SubmenuTriggerContext);
    let { submenuTriggerProps: submenuTriggerProps, submenuProps: submenuProps, popoverProps: popoverProps } = (0, $51tBd.useSubmenuTrigger)({
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        delay: props.delay,
        shouldUseVirtualFocus: shouldUseVirtualFocus
    }, submenuTriggerState, itemRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext,
                {
                    ...submenuTriggerProps,
                    onAction: undefined,
                    ref: itemRef
                }
            ],
            [
                $fd23024458c647e6$export$c7e742effb1c51e2,
                {
                    ref: submenuRef,
                    ...submenuProps
                }
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                submenuTriggerState
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    trigger: 'SubmenuTrigger',
                    triggerRef: itemRef,
                    placement: 'end top',
                    'aria-labelledby': submenuProps['aria-labelledby'],
                    ...popoverProps
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }), props.children[1]);
}, (props)=>props.children[0]);
const $fd23024458c647e6$export$d9b273488cd8ce6f = (0, $eF4cA.forwardRef)(function Menu(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $fd23024458c647e6$export$c7e742effb1c51e2);
    // Delay rendering the actual menu until we have the collection so that auto focus works properly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($fd23024458c647e6$var$$49319ee1285aa241$var$MenuInner, {
            props: props,
            collection: collection,
            menuRef: ref
        }));
});
function $fd23024458c647e6$var$$49319ee1285aa241$var$MenuInner({ props: props, collection: collection, menuRef: ref }) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, (0, $9PmUB.SelectableCollectionContext));
    let { filter: filter, ...autocompleteMenuProps } = props;
    let filteredCollection = (0, $eF4cA.useMemo)(()=>filter ? collection.filter(filter) : collection, [
        collection,
        filter
    ]);
    let state = (0, $8muBU.useTreeState)({
        ...props,
        collection: filteredCollection,
        children: undefined
    });
    let triggerState = (0, $eF4cA.useContext)($fd23024458c647e6$export$795aec4671cbae19);
    let { isVirtualized: isVirtualized, CollectionRoot: CollectionRoot } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { menuProps: menuProps } = (0, $lRhry.useMenu)({
        ...props,
        isVirtualized: isVirtualized,
        onClose: props.onClose || triggerState?.close
    }, state, ref);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-Menu',
        values: {
            isEmpty: state.collection.size === 0
        }
    });
    let emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "menuitem",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState());
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $6pgkA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, menuProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        onScroll: props.onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $fd23024458c647e6$export$24aad8519b95b41b,
                state
            ],
            [
                (0, $jbXau.SeparatorContext),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $8dzVy.SectionContext),
                {
                    name: 'MenuSection',
                    render: $fd23024458c647e6$var$$49319ee1285aa241$var$MenuSectionInner
                }
            ],
            [
                $fd23024458c647e6$var$$49319ee1285aa241$var$SubmenuTriggerContext,
                {
                    parentMenuRef: ref,
                    shouldUseVirtualFocus: autocompleteMenuProps?.shouldUseVirtualFocus
                }
            ],
            [
                $fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext,
                {
                    shouldCloseOnSelect: props.shouldCloseOnSelect
                }
            ],
            [
                (0, $9PmUB.SelectableCollectionContext),
                null
            ],
            [
                (0, $9PmUB.FieldInputContext),
                null
            ],
            [
                $fd23024458c647e6$var$$49319ee1285aa241$var$SelectionManagerContext,
                state.selectionManager
            ],
            /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */ /* We assume the context can never change between defined and undefined. */ // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
            [
                $fd23024458c647e6$export$795aec4671cbae19,
                triggerState ?? (0, $2esle.useMenuTriggerState)({})
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, $8dzVy.usePersistedKeys)(state.selectionManager.focusedKey),
        scrollRef: ref
    }))), emptyState));
}
// A subclass of SelectionManager that forwards focus-related properties to the parent,
// but has its own local selection state.
class $fd23024458c647e6$var$$49319ee1285aa241$var$GroupSelectionManager extends (0, $dWVHy.SelectionManager) {
    constructor(parent, state){
        super(parent.collection, state);
        this.parent = parent;
    }
    get focusedKey() {
        return this.parent.focusedKey;
    }
    get isFocused() {
        return this.parent.isFocused;
    }
    setFocusedKey(key, childFocusStrategy) {
        return this.parent.setFocusedKey(key, childFocusStrategy);
    }
    setFocused(isFocused) {
        this.parent.setFocused(isFocused);
    }
    get childFocusStrategy() {
        return this.parent.childFocusStrategy;
    }
}
function $fd23024458c647e6$var$$49319ee1285aa241$var$MenuSectionInner(props, ref, section, className = 'react-aria-MenuSection') {
    let state = (0, $eF4cA.useContext)($fd23024458c647e6$export$24aad8519b95b41b);
    let { CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let [headingRef, heading] = (0, $fDYaM.useSlot)();
    let { headingProps: headingProps, groupProps: groupProps } = (0, $jcwJg.useMenuSection)({
        heading: heading,
        'aria-label': section.props['aria-label'] ?? undefined
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: className,
        className: section.props?.className,
        style: section.props?.style,
        values: undefined
    });
    let parent = (0, $eF4cA.useContext)($fd23024458c647e6$var$$49319ee1285aa241$var$SelectionManagerContext);
    let selectionState = (0, $fAqsC.useMultipleSelectionState)(props);
    let manager = props.selectionMode != null ? new $fd23024458c647e6$var$$49319ee1285aa241$var$GroupSelectionManager(parent, selectionState) : parent;
    let closeOnSelect = (0, $fDYaM.useSlottedContext)($fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext)?.shouldCloseOnSelect;
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).section, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $1etmN.HeaderContext),
                {
                    ...headingProps,
                    ref: headingRef
                }
            ],
            [
                $fd23024458c647e6$var$$49319ee1285aa241$var$SelectionManagerContext,
                manager
            ],
            [
                $fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext,
                {
                    shouldCloseOnSelect: props.shouldCloseOnSelect ?? closeOnSelect
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section
    })));
}
const $fd23024458c647e6$export$4b1545b4f2016d26 = (0, $3g2oV.createBranchComponent)((0, $bWhaY.SectionNode), $fd23024458c647e6$var$$49319ee1285aa241$var$MenuSectionInner);
const $fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext = (0, $eF4cA.createContext)(null);
const $fd23024458c647e6$export$2ce376c2cc3355c8 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.ItemNode), function MenuItem(props, forwardedRef, item) {
    [props, forwardedRef] = (0, $fDYaM.useContextProps)(props, forwardedRef, $fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext);
    let id = (0, $fDYaM.useSlottedContext)($fd23024458c647e6$var$$49319ee1285aa241$var$MenuItemContext)?.id;
    let state = (0, $eF4cA.useContext)($fd23024458c647e6$export$24aad8519b95b41b);
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let selectionManager = (0, $eF4cA.useContext)($fd23024458c647e6$var$$49319ee1285aa241$var$SelectionManagerContext);
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps, ...states } = (0, $hUJml.useMenuItem)({
        ...props,
        id: id,
        key: item.key,
        selectionManager: selectionManager,
        isVirtualized: isVirtualized
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        isDisabled: states.isDisabled
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-MenuItem',
        values: {
            ...states,
            isHovered: isHovered,
            isFocusVisible: states.isFocusVisible,
            selectionMode: selectionManager.selectionMode,
            selectionBehavior: selectionManager.selectionBehavior,
            hasSubmenu: !!props['aria-haspopup'],
            isOpen: props['aria-expanded'] === 'true'
        }
    });
    let ElementType = props.href ? (0, $fDYaM.dom).a : (0, $fDYaM.dom).div;
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, menuItemProps, hoverProps),
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": selectionManager.selectionMode === 'none' ? undefined : selectionManager.selectionMode,
        "data-has-submenu": !!props['aria-haspopup'] || undefined,
        "data-open": props['aria-expanded'] === 'true' || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $2AolA.KeyboardContext),
                keyboardShortcutProps
            ],
            [
                (0, $hUj7u.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});
const $fd23024458c647e6$export$93aba29d3a678058 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.LoaderNode), function MenuLoadingIndicator(props, ref, item) {
    let state = (0, $eF4cA.useContext)($fd23024458c647e6$export$24aad8519b95b41b);
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $eF4cA.useRef)(null);
    let memoedLoadMoreProps = (0, $eF4cA.useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, $lJdzA.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-MenuLoadingIndicator',
        values: undefined
    });
    let itemProps = {
        // For Android talkback
        tabIndex: -1
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $gF3YT.inertValue)(true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), itemProps),
        ...renderProps,
        role: "menuitem",
        ref: ref
    }, renderProps.children)));
});

});
parcelRegister("8dzVy", function(module, exports) {

$parcel$export(module.exports, "SectionContext", () => $cbfb56a10d903625$export$d40e14dec8b060a8);
$parcel$export(module.exports, "DefaultCollectionRenderer", () => $cbfb56a10d903625$export$a164736487e3f0ae);
$parcel$export(module.exports, "renderAfterDropIndicators", () => $cbfb56a10d903625$export$2dbbd341daed716d);
$parcel$export(module.exports, "CollectionRendererContext", () => $cbfb56a10d903625$export$4feb769f8ddf26c5);
$parcel$export(module.exports, "usePersistedKeys", () => $cbfb56a10d903625$export$90e00781bc59d8f9);

var $3g2oV = parcelRequire("3g2oV");

var $eF4cA = parcelRequire("eF4cA");

var $1kw8g = parcelRequire("1kw8g");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cbfb56a10d903625$export$d40e14dec8b060a8 = (0, $eF4cA.createContext)(null);
const $cbfb56a10d903625$export$6e2c8f0811a474ce = (0, $3g2oV.createBranchComponent)('section', (props, ref, section)=>{
    let { name: name, render: render } = (0, $eF4cA.useContext)($cbfb56a10d903625$export$d40e14dec8b060a8);
    return render(props, ref, section, 'react-aria-Section');
});
const $cbfb56a10d903625$export$a164736487e3f0ae = {
    CollectionRoot ({ collection: collection, renderDropIndicator: renderDropIndicator }) {
        return $cbfb56a10d903625$var$$263ab7fc0f95ccdb$var$useCollectionRender(collection, null, renderDropIndicator);
    },
    CollectionBranch ({ collection: collection, parent: parent, renderDropIndicator: renderDropIndicator }) {
        return $cbfb56a10d903625$var$$263ab7fc0f95ccdb$var$useCollectionRender(collection, parent, renderDropIndicator);
    }
};
function $cbfb56a10d903625$var$$263ab7fc0f95ccdb$var$useCollectionRender(collection, parent, renderDropIndicator) {
    return (0, $1kw8g.useCachedChildren)({
        items: parent ? collection.getChildren(parent.key) : collection,
        dependencies: [
            renderDropIndicator
        ],
        children (node) {
            // Return a empty fragment since we don't want to render the content twice
            // If we don't skip the content node here, we end up rendering them twice in a Tree since we also render the content node in TreeItem
            if (node.type === 'content') return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null);
            let rendered = node.render(node);
            if (!renderDropIndicator || node.type !== 'item') return rendered;
            return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, renderDropIndicator({
                type: 'item',
                key: node.key,
                dropPosition: 'before'
            }), rendered, $cbfb56a10d903625$export$2dbbd341daed716d(collection, node, renderDropIndicator));
        }
    });
}
function $cbfb56a10d903625$export$2dbbd341daed716d(collection, node, renderDropIndicator) {
    let key = node.key;
    let keyAfter = collection.getKeyAfter(key);
    let nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    while(nextItemInFlattenedCollection != null && nextItemInFlattenedCollection.type !== 'item'){
        keyAfter = collection.getKeyAfter(nextItemInFlattenedCollection.key);
        nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    }
    let nextItemInSameLevel = node.nextKey != null ? collection.getItem(node.nextKey) : null;
    while(nextItemInSameLevel != null && nextItemInSameLevel.type !== 'item')nextItemInSameLevel = nextItemInSameLevel.nextKey != null ? collection.getItem(nextItemInSameLevel.nextKey) : null;
    // Render one or more "after" drop indicators when the next item in the flattened collection
    // has a smaller level, is not an item, or there are no more items in the collection.
    // Otherwise, the "after" position is equivalent to the next item's "before" position.
    let afterIndicators = [];
    if (nextItemInSameLevel == null) {
        let current = node;
        while(current?.type === 'item' && (!nextItemInFlattenedCollection || current.parentKey !== nextItemInFlattenedCollection.parentKey && nextItemInFlattenedCollection.level < current.level)){
            let indicator = renderDropIndicator({
                type: 'item',
                key: current.key,
                dropPosition: 'after'
            });
            if ((0, $eF4cA.isValidElement)(indicator)) afterIndicators.push((0, $eF4cA.cloneElement)(indicator, {
                key: `${current.key}-after`
            }));
            current = current.parentKey != null ? collection.getItem(current.parentKey) : null;
        }
    }
    return afterIndicators;
}
const $cbfb56a10d903625$export$4feb769f8ddf26c5 = (0, $eF4cA.createContext)($cbfb56a10d903625$export$a164736487e3f0ae);
function $cbfb56a10d903625$export$90e00781bc59d8f9(focusedKey) {
    return (0, $eF4cA.useMemo)(()=>focusedKey != null ? new Set([
            focusedKey
        ]) : null, [
        focusedKey
    ]);
}

});

parcelRegister("9PmUB", function(module, exports) {

$parcel$export(module.exports, "SelectableCollectionContext", () => $bbf4520d9fa9022c$export$b0d3ecf7112093a7);
$parcel$export(module.exports, "FieldInputContext", () => $bbf4520d9fa9022c$export$698f465ec27e93df);

var $fDYaM = parcelRequire("fDYaM");

var $a8Vul = parcelRequire("a8Vul");

var $g3Enz = parcelRequire("g3Enz");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bbf4520d9fa9022c$export$36e687af51cd0967 = (0, $eF4cA.createContext)(null);
const $bbf4520d9fa9022c$export$68ee3368b6d68148 = (0, $eF4cA.createContext)(null);
const $bbf4520d9fa9022c$export$b0d3ecf7112093a7 = (0, $eF4cA.createContext)(null);
const $bbf4520d9fa9022c$export$698f465ec27e93df = (0, $eF4cA.createContext)(null);
function $bbf4520d9fa9022c$export$2f2b9559550c7bbc(props) {
    let ctx = (0, $fDYaM.useSlottedContext)($bbf4520d9fa9022c$export$36e687af51cd0967, props.slot);
    props = (0, $lhKAD.mergeProps)(ctx, props);
    let { filter: filter, disableAutoFocusFirst: disableAutoFocusFirst } = props;
    let state = (0, $g3Enz.useAutocompleteState)(props);
    let inputRef = (0, $eF4cA.useRef)(null);
    let collectionRef = (0, $eF4cA.useRef)(null);
    let { inputProps: inputProps, collectionProps: collectionProps, collectionRef: mergedCollectionRef, filter: filterFn } = (0, $a8Vul.useAutocomplete)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        filter: filter,
        disableAutoFocusFirst: disableAutoFocusFirst,
        inputRef: inputRef,
        collectionRef: collectionRef
    }, state);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $bbf4520d9fa9022c$export$68ee3368b6d68148,
                state
            ],
            [
                $bbf4520d9fa9022c$export$698f465ec27e93df,
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                $bbf4520d9fa9022c$export$b0d3ecf7112093a7,
                {
                    ...collectionProps,
                    filter: filterFn,
                    ref: mergedCollectionRef
                }
            ]
        ]
    }, props.children);
}

});
parcelRegister("a8Vul", function(module, exports) {

$parcel$export(module.exports, "useAutocomplete", () => $138a23d5bd4f788a$export$1e40b3ca02d92d21);

var $bT06y = parcelRequire("bT06y");

var $5sRge = parcelRequire("5sRge");

var $fvyIQ = parcelRequire("fvyIQ");

var $YxOvP = parcelRequire("YxOvP");

var $7ByPJ = parcelRequire("7ByPJ");

var $6au8X = parcelRequire("6au8X");

var $11FxZ = parcelRequire("11FxZ");

var $lDJIO = parcelRequire("lDJIO");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $4lMDe = parcelRequire("4lMDe");

var $58OnM = parcelRequire("58OnM");

var $25dFS = parcelRequire("25dFS");

var $dkaC0 = parcelRequire("dkaC0");

var $4skXn = parcelRequire("4skXn");

var $gI8Gw = parcelRequire("gI8Gw");

var $26CkO = parcelRequire("26CkO");

var $eF4cA = parcelRequire("eF4cA");
function $138a23d5bd4f788a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $138a23d5bd4f788a$export$1e40b3ca02d92d21(props, state) {
    let { inputRef: inputRef, collectionRef: collectionRef, filter: filter, disableAutoFocusFirst: disableAutoFocusFirst = false, disableVirtualFocus: disableVirtualFocus = false } = props;
    let collectionId = (0, $25dFS.useId)();
    let timeout = (0, $eF4cA.useRef)(undefined);
    let delayNextActiveDescendant = (0, $eF4cA.useRef)(false);
    let queuedActiveDescendant = (0, $eF4cA.useRef)(null);
    // For mobile screen readers, we don't want virtual focus, instead opting to disable FocusScope's restoreFocus and manually
    // moving focus back to the subtriggers
    let isMobileScreenReader = (0, $YxOvP.getInteractionModality)() === 'virtual' && ((0, $11FxZ.isIOS)() || (0, $11FxZ.isAndroid)());
    let [shouldUseVirtualFocus, setShouldUseVirtualFocus] = (0, $eF4cA.useState)(!isMobileScreenReader && !disableVirtualFocus);
    // Tracks if a collection has been connected to the autocomplete. If false, we don't want to add various attributes to the autocomplete input
    // since it isn't attached to a filterable collection (e.g. Tabs)
    let [hasCollection, setHasCollection] = (0, $eF4cA.useState)(false);
    let [autoFocusOnMount, setAutoFocusOnMount] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>clearTimeout(timeout.current);
    }, []);
    let updateActiveDescendantEvent = (0, $4lMDe.useEffectEvent)((e)=>{
        // Ensure input is focused if the user clicks on the collection directly.
        // don't trigger on touch so that mobile keyboard doesnt appear when tapping on options
        if (!e.isTrusted && shouldUseVirtualFocus && inputRef.current && (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(inputRef.current)) !== inputRef.current && (0, $YxOvP.getPointerType)() !== 'touch') inputRef.current.focus();
        let target = (0, $fvyIQ.getEventTarget)(e);
        if (e.isTrusted || !target || queuedActiveDescendant.current === target.id) return;
        clearTimeout(timeout.current);
        if (target !== collectionRef.current) {
            if (delayNextActiveDescendant.current) {
                queuedActiveDescendant.current = target.id;
                timeout.current = setTimeout(()=>{
                    state.setFocusedNodeId(target.id);
                }, 500);
            } else {
                queuedActiveDescendant.current = target.id;
                state.setFocusedNodeId(target.id);
            }
        } else if (queuedActiveDescendant.current && !document.getElementById(queuedActiveDescendant.current)) {
            // If we recieve a focus event refocusing the collection, either we have newly refocused the input and are waiting for the
            // wrapped collection to refocus the previously focused node if any OR
            // we are in a state where we've filtered to such a point that there aren't any matching items in the collection to focus.
            // In this case we want to clear tracked item if any and clear active descendant
            queuedActiveDescendant.current = null;
            state.setFocusedNodeId(null);
        }
        delayNextActiveDescendant.current = false;
    });
    let [collectionNode, setCollectionNode] = (0, $eF4cA.useState)(null);
    let callbackRef = (0, $eF4cA.useCallback)((node)=>{
        setCollectionNode(node);
        if (node != null) {
            // If useSelectableCollection isn't passed shouldUseVirtualFocus even when useAutocomplete provides it
            // that means the collection doesn't support it (e.g. Table). If that is the case, we need to disable it here regardless
            // of what the user's provided so that the input doesn't recieve the onKeyDown and autocomplete props.
            if (node.getAttribute('tabindex') != null) setShouldUseVirtualFocus(false);
            setHasCollection(true);
        } else setHasCollection(false);
    }, []);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (collectionNode != null) // of the letter you just typed. If we recieve another focus event then we clear the queued update
        collectionNode.addEventListener('focusin', updateActiveDescendantEvent);
        return ()=>{
            collectionNode?.removeEventListener('focusin', updateActiveDescendantEvent);
        };
    }, [
        collectionNode
    ]);
    // Make sure to memo so that React doesn't keep registering a new event listeners on every rerender of the wrapped collection
    let mergedCollectionRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(collectionRef, callbackRef), [
        collectionRef,
        callbackRef
    ]));
    let focusFirstItem = (0, $eF4cA.useCallback)(()=>{
        if (!collectionRef.current) {
            setAutoFocusOnMount(true);
            return;
        }
        delayNextActiveDescendant.current = true;
        collectionRef.current?.dispatchEvent(new CustomEvent((0, $bT06y.FOCUS_EVENT), {
            cancelable: true,
            bubbles: true,
            detail: {
                focusStrategy: 'first'
            }
        }));
    }, [
        collectionRef
    ]);
    let clearVirtualFocus = (0, $eF4cA.useCallback)((clearFocusKey)=>{
        setAutoFocusOnMount(false);
        (0, $5sRge.moveVirtualFocus)((0, $fvyIQ.getActiveElement)());
        queuedActiveDescendant.current = null;
        state.setFocusedNodeId(null);
        let clearFocusEvent = new CustomEvent((0, $bT06y.CLEAR_FOCUS_EVENT), {
            cancelable: true,
            bubbles: true,
            detail: {
                clearFocusKey: clearFocusKey
            }
        });
        clearTimeout(timeout.current);
        delayNextActiveDescendant.current = false;
        collectionRef.current?.dispatchEvent(clearFocusEvent);
    }, [
        collectionRef,
        state
    ]);
    let lastInputType = (0, $eF4cA.useRef)('');
    (0, $58OnM.useEvent)(inputRef, 'beforeinput', (e)=>{
        let { inputType: inputType } = e;
        lastInputType.current = inputType;
    });
    let onChange = (value)=>{
        // Tell wrapped collection to focus the first element in the list when typing forward and to clear focused key when modifying the text via
        // copy paste/backspacing/undo/redo for screen reader announcements
        if ((lastInputType.current === 'insertText' || // IME composition (e.g. CJK input) reports 'insertCompositionText'/'insertFromComposition'
        // instead of 'insertText'. Treat these as forward typing so the first item gets virtual focus.
        lastInputType.current === 'insertCompositionText' || lastInputType.current === 'insertFromComposition') && !disableAutoFocusFirst) focusFirstItem();
        else if (lastInputType.current && (lastInputType.current.includes('insert') || lastInputType.current.includes('delete') || lastInputType.current.includes('history'))) {
            clearVirtualFocus(true);
            // If onChange was triggered before the timeout actually updated the activedescendant, we need to fire
            // our own dispatchVirtualFocus so focusVisible gets reapplied on the input
            if ((0, $5sRge.getVirtuallyFocusedElement)(document) === inputRef.current) (0, $5sRge.dispatchVirtualFocus)(inputRef.current, null);
        }
        state.setInputValue(value);
    };
    let keyDownTarget = (0, $eF4cA.useRef)(null);
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        keyDownTarget.current = (0, $fvyIQ.getEventTarget)(e);
        if (e.nativeEvent.isComposing) return;
        let focusedNodeId = queuedActiveDescendant.current;
        if (focusedNodeId !== null && (0, $7ByPJ.getOwnerDocument)(inputRef.current).getElementById(focusedNodeId) == null) {
            // if the focused id doesn't exist in document, then we need to clear the tracked focused node, otherwise
            // we will be attempting to fire key events on a non-existing node instead of trying to focus the newly swapped wrapped collection.
            // This can happen if you are swapping out the Autocomplete wrapped collection component like in the docs search.
            queuedActiveDescendant.current = null;
            focusedNodeId = null;
        }
        switch(e.key){
            case 'a':
                if ((0, $lDJIO.isCtrlKeyPressed)(e)) return;
                break;
            case 'Escape':
                // Early return for Escape here so it doesn't leak the Escape event from the simulated collection event below and
                // close the dialog prematurely. Ideally that should be up to the discretion of the input element hence the check
                // for isPropagationStopped
                if (e.isDefaultPrevented()) return;
                break;
            case ' ':
                // Space shouldn't trigger onAction so early return.
                return;
            case 'Tab':
                // Don't propogate Tab down to the collection, otherwise we will try to focus the collection via useSelectableCollection's Tab handler (aka shift tab logic)
                // We want FocusScope to handle Tab if one exists (aka sub dialog), so special casepropogate
                if ('continuePropagation' in e) e.continuePropagation();
                return;
            case 'Home':
            case 'End':
            case 'PageDown':
            case 'PageUp':
            case 'ArrowUp':
            case 'ArrowDown':
            case 'ArrowRight':
            case 'ArrowLeft':
                {
                    if ((e.key === 'Home' || e.key === 'End') && focusedNodeId == null && e.shiftKey) return;
                    // If there is text within the input field, we'll want continue propagating events down
                    // to the wrapped collection if there is a focused node so that a user can continue moving the
                    // virtual focus. However, if the user doesn't have a focus in the collection, just move the text
                    // cursor instead. They can move focus down into the collection via down/up arrow if need be
                    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                        if (focusedNodeId == null) {
                            if (!e.isPropagationStopped()) e.stopPropagation();
                            return;
                        }
                        break;
                    }
                    // Prevent these keys from moving the text cursor in the input
                    e.preventDefault();
                    // Move virtual focus into the wrapped collection
                    let focusCollection = new CustomEvent((0, $bT06y.FOCUS_EVENT), {
                        cancelable: true,
                        bubbles: true
                    });
                    collectionRef.current?.dispatchEvent(focusCollection);
                    break;
                }
        }
        // Emulate the keyboard events that happen in the input field in the wrapped collection. This is for triggering things like onAction via Enter
        // or moving focus from one item to another. Stop propagation on the input event if it isn't already stopped so it doesn't leak out. For events
        // like ESC, the dispatched event below will bubble out of the collection and be stopped if handled by useSelectableCollection, otherwise will bubble
        // as expected
        if (!e.isPropagationStopped()) e.stopPropagation();
        let shouldPerformDefaultAction = true;
        if (collectionRef.current !== null) {
            if (focusedNodeId == null) shouldPerformDefaultAction = collectionRef.current?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            else {
                let item = document.getElementById(focusedNodeId);
                if (item) shouldPerformDefaultAction = item?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            }
        }
        if (shouldPerformDefaultAction) switch(e.key){
            case 'ArrowLeft':
            case 'ArrowRight':
                // Clear the activedescendant so NVDA announcements aren't interrupted but retain the focused key in the collection so the
                // user's keyboard navigation restarts from where they left off
                clearVirtualFocus();
                break;
            case 'Enter':
                // Trigger click action on item when Enter key was pressed.
                if (focusedNodeId != null) {
                    let item = document.getElementById(focusedNodeId);
                    item?.dispatchEvent(new PointerEvent('click', e.nativeEvent));
                }
                break;
        }
        else e.preventDefault();
    };
    let onKeyUpCapture = (0, $4lMDe.useEffectEvent)((e)=>{
        // Dispatch simulated key up events for things like triggering links in listbox
        // Make sure to stop the propagation of the input keyup event so that the simulated keyup/down pair
        // is detected by usePress instead of the original keyup originating from the input
        if ((0, $fvyIQ.getEventTarget)(e) === keyDownTarget.current) {
            e.stopImmediatePropagation();
            let focusedNodeId = queuedActiveDescendant.current;
            if (focusedNodeId == null) collectionRef.current?.dispatchEvent(new KeyboardEvent(e.type, e));
            else {
                let item = document.getElementById(focusedNodeId);
                item?.dispatchEvent(new KeyboardEvent(e.type, e));
            }
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        document.addEventListener('keyup', onKeyUpCapture, true);
        return ()=>{
            document.removeEventListener('keyup', onKeyUpCapture, true);
        };
    }, []);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($138a23d5bd4f788a$var$$parcel$interopDefault((0, $6au8X.default)), '@react-aria/autocomplete');
    let collectionProps = (0, $dkaC0.useLabels)({
        id: collectionId,
        'aria-label': stringFormatter.format('collectionLabel')
    });
    let filterFn = (0, $eF4cA.useCallback)((nodeTextValue, node)=>{
        if (filter) return filter(nodeTextValue, state.inputValue, node);
        return true;
    }, [
        state.inputValue,
        filter
    ]);
    // Be sure to clear/restore the virtual + collection focus when blurring/refocusing the field so we only show the
    // focus ring on the virtually focused collection when are actually interacting with the Autocomplete
    let onBlur = (e)=>{
        if (!e.isTrusted) return;
        let lastFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (lastFocusedNode) (0, $5sRge.dispatchVirtualBlur)(lastFocusedNode, e.relatedTarget);
    };
    let onFocus = (e)=>{
        if (!e.isTrusted) return;
        let curFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (curFocusedNode) {
            let target = (0, $fvyIQ.getEventTarget)(e);
            queueMicrotask(()=>{
                (0, $5sRge.dispatchVirtualBlur)(target, collectionRef.current);
                (0, $5sRge.dispatchVirtualFocus)(collectionRef.current, target);
            });
        }
    };
    // Clicking back into the input can happen after focus moved elsewhere in the dialog, while
    // virtual focus is still on an option. Clear virtual focus on pointer down so mouse
    // interactions restore the input state before the click's focus handling runs.
    // Touch is excluded because touch interactions should not move focus back to the input.
    let onPointerDown = (e)=>{
        if (e.button !== 0 || e.pointerType === 'touch' || queuedActiveDescendant.current == null || inputRef.current == null) return;
        if ((0, $fvyIQ.getEventTarget)(e) === inputRef.current) clearVirtualFocus();
    };
    // Only apply the autocomplete specific behaviors if the collection component wrapped by it is actually
    // being filtered/allows filtering by the Autocomplete.
    let inputProps = {
        value: state.inputValue,
        onChange: onChange
    };
    let virtualFocusProps = {
        onKeyDown: onKeyDown,
        'aria-activedescendant': state.focusedNodeId ?? undefined,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerDown: onPointerDown
    };
    inputProps = {
        ...inputProps,
        ...shouldUseVirtualFocus && hasCollection && virtualFocusProps,
        enterKeyHint: 'go',
        'aria-controls': hasCollection ? collectionId : undefined,
        // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
        'aria-autocomplete': 'list',
        // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
        autoCorrect: 'off',
        // This disable's the macOS Safari spell check auto corrections.
        spellCheck: 'false',
        autoComplete: 'off'
    };
    return {
        inputProps: inputProps,
        collectionProps: (0, $lhKAD.mergeProps)(collectionProps, {
            shouldUseVirtualFocus: shouldUseVirtualFocus,
            disallowTypeAhead: shouldUseVirtualFocus,
            autoFocus: autoFocusOnMount ? 'first' : false
        }),
        collectionRef: mergedCollectionRef,
        filter: filter != null ? filterFn : undefined
    };
}

});
parcelRegister("bT06y", function(module, exports) {

$parcel$export(module.exports, "CLEAR_FOCUS_EVENT", () => $acea24f60e7fd9c4$export$447a38995de2c711);
$parcel$export(module.exports, "FOCUS_EVENT", () => $acea24f60e7fd9c4$export$831c820ad60f9d12);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Custom event names for updating the autocomplete's aria-activedecendant.
const $acea24f60e7fd9c4$export$447a38995de2c711 = 'react-aria-clear-focus';
const $acea24f60e7fd9c4$export$831c820ad60f9d12 = 'react-aria-focus';

});

parcelRegister("5sRge", function(module, exports) {

$parcel$export(module.exports, "moveVirtualFocus", () => $1d6f425d719488af$export$76e4e37e5339496d);
$parcel$export(module.exports, "getVirtuallyFocusedElement", () => $1d6f425d719488af$export$759df0d867455a91);
$parcel$export(module.exports, "dispatchVirtualBlur", () => $1d6f425d719488af$export$6c5dc7e81d2cc29a);
$parcel$export(module.exports, "dispatchVirtualFocus", () => $1d6f425d719488af$export$2b35b76d2e30e129);

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");
function $1d6f425d719488af$export$76e4e37e5339496d(to) {
    let from = $1d6f425d719488af$export$759df0d867455a91((0, $7ByPJ.getOwnerDocument)(to));
    if (from !== to) {
        if (from) $1d6f425d719488af$export$6c5dc7e81d2cc29a(from, to);
        if (to) $1d6f425d719488af$export$2b35b76d2e30e129(to, from);
    }
}
function $1d6f425d719488af$export$6c5dc7e81d2cc29a(from, to) {
    from.dispatchEvent(new FocusEvent('blur', {
        relatedTarget: to
    }));
    from.dispatchEvent(new FocusEvent('focusout', {
        bubbles: true,
        relatedTarget: to
    }));
}
function $1d6f425d719488af$export$2b35b76d2e30e129(to, from) {
    to.dispatchEvent(new FocusEvent('focus', {
        relatedTarget: from
    }));
    to.dispatchEvent(new FocusEvent('focusin', {
        bubbles: true,
        relatedTarget: from
    }));
}
function $1d6f425d719488af$export$759df0d867455a91(document) {
    let activeElement = (0, $fvyIQ.getActiveElement)(document);
    let activeDescendant = activeElement?.getAttribute('aria-activedescendant');
    if (activeDescendant) return document.getElementById(activeDescendant) || activeElement;
    return activeElement;
}

});

parcelRegister("6au8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $4632a30e72f185ea$export$2e2bcd8739ae039);

var $lvTXL = parcelRequire("lvTXL");

var $272P3 = parcelRequire("272P3");

var $dskoT = parcelRequire("dskoT");

var $jtDf8 = parcelRequire("jtDf8");

var $fpuyp = parcelRequire("fpuyp");

var $l59r7 = parcelRequire("l59r7");

var $hf0xC = parcelRequire("hf0xC");

var $kbcqb = parcelRequire("kbcqb");

var $ZE10s = parcelRequire("ZE10s");

var $86QpE = parcelRequire("86QpE");

var $lHeIt = parcelRequire("lHeIt");

var $c9vv1 = parcelRequire("c9vv1");

var $giPm8 = parcelRequire("giPm8");

var $jA1Jv = parcelRequire("jA1Jv");

var $kU6tw = parcelRequire("kU6tw");

var $kCqh4 = parcelRequire("kCqh4");

var $73wcv = parcelRequire("73wcv");

var $oFvGF = parcelRequire("oFvGF");

var $1kw5Q = parcelRequire("1kw5Q");

var $jFlUT = parcelRequire("jFlUT");

var $7eAgL = parcelRequire("7eAgL");

var $hzLhP = parcelRequire("hzLhP");

var $5kyGM = parcelRequire("5kyGM");

var $acgcO = parcelRequire("acgcO");

var $9EkQU = parcelRequire("9EkQU");

var $1crid = parcelRequire("1crid");

var $dpSqk = parcelRequire("dpSqk");

var $iw5Id = parcelRequire("iw5Id");

var $Oevsc = parcelRequire("Oevsc");

var $1NlIW = parcelRequire("1NlIW");

var $7E7jm = parcelRequire("7E7jm");

var $46Zfd = parcelRequire("46Zfd");

var $5QKyD = parcelRequire("5QKyD");

var $dPTqM = parcelRequire("dPTqM");
var $4632a30e72f185ea$export$2e2bcd8739ae039 = {};
$4632a30e72f185ea$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $lvTXL.default),
    "bg-BG": (0, $272P3.default),
    "cs-CZ": (0, $dskoT.default),
    "da-DK": (0, $jtDf8.default),
    "de-DE": (0, $fpuyp.default),
    "el-GR": (0, $l59r7.default),
    "en-US": (0, $hf0xC.default),
    "es-ES": (0, $kbcqb.default),
    "et-EE": (0, $ZE10s.default),
    "fi-FI": (0, $86QpE.default),
    "fr-FR": (0, $lHeIt.default),
    "he-IL": (0, $c9vv1.default),
    "hr-HR": (0, $giPm8.default),
    "hu-HU": (0, $jA1Jv.default),
    "it-IT": (0, $kU6tw.default),
    "ja-JP": (0, $kCqh4.default),
    "ko-KR": (0, $73wcv.default),
    "lt-LT": (0, $oFvGF.default),
    "lv-LV": (0, $1kw5Q.default),
    "nb-NO": (0, $jFlUT.default),
    "nl-NL": (0, $7eAgL.default),
    "pl-PL": (0, $hzLhP.default),
    "pt-BR": (0, $5kyGM.default),
    "pt-PT": (0, $acgcO.default),
    "ro-RO": (0, $9EkQU.default),
    "ru-RU": (0, $1crid.default),
    "sk-SK": (0, $dpSqk.default),
    "sl-SI": (0, $iw5Id.default),
    "sr-SP": (0, $Oevsc.default),
    "sv-SE": (0, $1NlIW.default),
    "tr-TR": (0, $7E7jm.default),
    "uk-UA": (0, $46Zfd.default),
    "zh-CN": (0, $5QKyD.default),
    "zh-TW": (0, $dPTqM.default)
};

});
parcelRegister("lvTXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfac875e2c726970$export$2e2bcd8739ae039);
var $cfac875e2c726970$export$2e2bcd8739ae039 = {};
$cfac875e2c726970$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`
};

});

parcelRegister("272P3", function(module, exports) {

$parcel$export(module.exports, "default", () => $601ed6aa4432a0e2$export$2e2bcd8739ae039);
var $601ed6aa4432a0e2$export$2e2bcd8739ae039 = {};
$601ed6aa4432a0e2$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};

});

parcelRegister("dskoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $752d8fdb3021a1b0$export$2e2bcd8739ae039);
var $752d8fdb3021a1b0$export$2e2bcd8739ae039 = {};
$752d8fdb3021a1b0$export$2e2bcd8739ae039 = {
    "collectionLabel": `N\xe1vrhy`
};

});

parcelRegister("jtDf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $113068b23a282e31$export$2e2bcd8739ae039);
var $113068b23a282e31$export$2e2bcd8739ae039 = {};
$113068b23a282e31$export$2e2bcd8739ae039 = {
    "collectionLabel": `Forslag`
};

});

parcelRegister("fpuyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c1041a4b146f31$export$2e2bcd8739ae039);
var $94c1041a4b146f31$export$2e2bcd8739ae039 = {};
$94c1041a4b146f31$export$2e2bcd8739ae039 = {
    "collectionLabel": `Empfehlungen`
};

});

parcelRegister("l59r7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7c8c3d85b35c2a$export$2e2bcd8739ae039);
var $fe7c8c3d85b35c2a$export$2e2bcd8739ae039 = {};
$fe7c8c3d85b35c2a$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
};

});

parcelRegister("hf0xC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83fd186fbaa0942$export$2e2bcd8739ae039);
var $a83fd186fbaa0942$export$2e2bcd8739ae039 = {};
$a83fd186fbaa0942$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggestions`
};

});

parcelRegister("kbcqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79e8ee3e8f049f9a$export$2e2bcd8739ae039);
var $79e8ee3e8f049f9a$export$2e2bcd8739ae039 = {};
$79e8ee3e8f049f9a$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugerencias`
};

});

parcelRegister("ZE10s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7170d29057d9bf$export$2e2bcd8739ae039);
var $4b7170d29057d9bf$export$2e2bcd8739ae039 = {};
$4b7170d29057d9bf$export$2e2bcd8739ae039 = {
    "collectionLabel": `Soovitused`
};

});

parcelRegister("86QpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $46084f6523fbd8db$export$2e2bcd8739ae039);
var $46084f6523fbd8db$export$2e2bcd8739ae039 = {};
$46084f6523fbd8db$export$2e2bcd8739ae039 = {
    "collectionLabel": `Ehdotukset`
};

});

parcelRegister("lHeIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aa4ee433bb5a963$export$2e2bcd8739ae039);
var $7aa4ee433bb5a963$export$2e2bcd8739ae039 = {};
$7aa4ee433bb5a963$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggestions`
};

});

parcelRegister("c9vv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $556b82884a9ac80a$export$2e2bcd8739ae039);
var $556b82884a9ac80a$export$2e2bcd8739ae039 = {};
$556b82884a9ac80a$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`
};

});

parcelRegister("giPm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f81e360504e148d$export$2e2bcd8739ae039);
var $3f81e360504e148d$export$2e2bcd8739ae039 = {};
$3f81e360504e148d$export$2e2bcd8739ae039 = {
    "collectionLabel": `Prijedlozi`
};

});

parcelRegister("jA1Jv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c477657114e3ab11$export$2e2bcd8739ae039);
var $c477657114e3ab11$export$2e2bcd8739ae039 = {};
$c477657114e3ab11$export$2e2bcd8739ae039 = {
    "collectionLabel": `Javaslatok`
};

});

parcelRegister("kU6tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e337e25c7c68d3$export$2e2bcd8739ae039);
var $b0e337e25c7c68d3$export$2e2bcd8739ae039 = {};
$b0e337e25c7c68d3$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggerimenti`
};

});

parcelRegister("kCqh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c6df3457c6b139$export$2e2bcd8739ae039);
var $74c6df3457c6b139$export$2e2bcd8739ae039 = {};
$74c6df3457c6b139$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5019}\u{88DC}`
};

});

parcelRegister("73wcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58f36c52a975a8d$export$2e2bcd8739ae039);
var $b58f36c52a975a8d$export$2e2bcd8739ae039 = {};
$b58f36c52a975a8d$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{C81C}\u{C548}`
};

});

parcelRegister("oFvGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de8f5b03bde3f2c$export$2e2bcd8739ae039);
var $2de8f5b03bde3f2c$export$2e2bcd8739ae039 = {};
$2de8f5b03bde3f2c$export$2e2bcd8739ae039 = {
    "collectionLabel": `Pasi\u{16B}lymai`
};

});

parcelRegister("1kw5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afa17873090f94c$export$2e2bcd8739ae039);
var $3afa17873090f94c$export$2e2bcd8739ae039 = {};
$3afa17873090f94c$export$2e2bcd8739ae039 = {
    "collectionLabel": `Ieteikumi`
};

});

parcelRegister("jFlUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2be076a77da93cd0$export$2e2bcd8739ae039);
var $2be076a77da93cd0$export$2e2bcd8739ae039 = {};
$2be076a77da93cd0$export$2e2bcd8739ae039 = {
    "collectionLabel": `Forslag`
};

});

parcelRegister("7eAgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c3014b686302bb$export$2e2bcd8739ae039);
var $c7c3014b686302bb$export$2e2bcd8739ae039 = {};
$c7c3014b686302bb$export$2e2bcd8739ae039 = {
    "collectionLabel": `Suggesties`
};

});

parcelRegister("hzLhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $517f244b632e07f5$export$2e2bcd8739ae039);
var $517f244b632e07f5$export$2e2bcd8739ae039 = {};
$517f244b632e07f5$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugestie`
};

});

parcelRegister("5kyGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $864119c064e66c30$export$2e2bcd8739ae039);
var $864119c064e66c30$export$2e2bcd8739ae039 = {};
$864119c064e66c30$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugest\xf5es`
};

});

parcelRegister("acgcO", function(module, exports) {

$parcel$export(module.exports, "default", () => $988dde52cafdfe6a$export$2e2bcd8739ae039);
var $988dde52cafdfe6a$export$2e2bcd8739ae039 = {};
$988dde52cafdfe6a$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugest\xf5es`
};

});

parcelRegister("9EkQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e3ed317cdc3000$export$2e2bcd8739ae039);
var $c0e3ed317cdc3000$export$2e2bcd8739ae039 = {};
$c0e3ed317cdc3000$export$2e2bcd8739ae039 = {
    "collectionLabel": `Sugestii`
};

});

parcelRegister("1crid", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee6b6a7daf2f0f33$export$2e2bcd8739ae039);
var $ee6b6a7daf2f0f33$export$2e2bcd8739ae039 = {};
$ee6b6a7daf2f0f33$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};

});

parcelRegister("dpSqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6020ceea3da7fd5e$export$2e2bcd8739ae039);
var $6020ceea3da7fd5e$export$2e2bcd8739ae039 = {};
$6020ceea3da7fd5e$export$2e2bcd8739ae039 = {
    "collectionLabel": `N\xe1vrhy`
};

});

parcelRegister("iw5Id", function(module, exports) {

$parcel$export(module.exports, "default", () => $865b143eab4e58f0$export$2e2bcd8739ae039);
var $865b143eab4e58f0$export$2e2bcd8739ae039 = {};
$865b143eab4e58f0$export$2e2bcd8739ae039 = {
    "collectionLabel": `Predlogi`
};

});

parcelRegister("Oevsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b288ea37d30d3040$export$2e2bcd8739ae039);
var $b288ea37d30d3040$export$2e2bcd8739ae039 = {};
$b288ea37d30d3040$export$2e2bcd8739ae039 = {
    "collectionLabel": `Predlozi`
};

});

parcelRegister("1NlIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4262c714cdb1c8be$export$2e2bcd8739ae039);
var $4262c714cdb1c8be$export$2e2bcd8739ae039 = {};
$4262c714cdb1c8be$export$2e2bcd8739ae039 = {
    "collectionLabel": `F\xf6rslag`
};

});

parcelRegister("7E7jm", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ff2cb7e3490ef3$export$2e2bcd8739ae039);
var $58ff2cb7e3490ef3$export$2e2bcd8739ae039 = {};
$58ff2cb7e3490ef3$export$2e2bcd8739ae039 = {
    "collectionLabel": `\xd6neriler`
};

});

parcelRegister("46Zfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd71bf8c06aeb11d$export$2e2bcd8739ae039);
var $dd71bf8c06aeb11d$export$2e2bcd8739ae039 = {};
$dd71bf8c06aeb11d$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`
};

});

parcelRegister("5QKyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a0cf3e2d5731db$export$2e2bcd8739ae039);
var $89a0cf3e2d5731db$export$2e2bcd8739ae039 = {};
$89a0cf3e2d5731db$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5EFA}\u{8BAE}`
};

});

parcelRegister("dPTqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $13ec1d53244c3449$export$2e2bcd8739ae039);
var $13ec1d53244c3449$export$2e2bcd8739ae039 = {};
$13ec1d53244c3449$export$2e2bcd8739ae039 = {
    "collectionLabel": `\u{5EFA}\u{8B70}`
};

});


parcelRegister("58OnM", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $d3e54f94d6520810$export$90fc3a17d93f704c);

var $7ByPJ = parcelRequire("7ByPJ");

var $4lMDe = parcelRequire("4lMDe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d3e54f94d6520810$export$90fc3a17d93f704c(ref, event, listener, options) {
    let handleEvent = (0, $4lMDe.useEffectEvent)(listener);
    let isDisabled = listener == null;
    (0, $eF4cA.useEffect)(()=>{
        if (isDisabled || ref.current == null) return;
        return (0, $7ByPJ.addEvent)(ref.current, event, handleEvent, options);
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}

});


parcelRegister("g3Enz", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteState", () => $dbfc4e7ea0f713a8$export$ce1595f6e1a63433);

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dbfc4e7ea0f713a8$export$ce1595f6e1a63433(props) {
    let { onInputChange: propsOnInputChange, inputValue: propsInputValue, defaultInputValue: propsDefaultInputValue = '' } = props;
    let onInputChange = (value)=>{
        if (propsOnInputChange) propsOnInputChange(value);
    };
    let [focusedNodeId, setFocusedNodeId] = (0, $eF4cA.useState)(null);
    let [inputValue, setInputValue] = (0, $iUErx.useControlledState)(propsInputValue, propsDefaultInputValue, onInputChange);
    return {
        inputValue: inputValue,
        setInputValue: setInputValue,
        focusedNodeId: focusedNodeId,
        setFocusedNodeId: setFocusedNodeId
    };
}

});


parcelRegister("hUj7u", function(module, exports) {

$parcel$export(module.exports, "SelectionIndicatorContext", () => $bef38dbeda45fe99$export$c9549807523555e0);
$parcel$export(module.exports, "SelectionIndicator", () => $bef38dbeda45fe99$export$17f80983afe4e444);

var $fDYaM = parcelRequire("fDYaM");

var $2FPWu = parcelRequire("2FPWu");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bef38dbeda45fe99$export$c9549807523555e0 = (0, $eF4cA.createContext)({
    isSelected: false
});
const $bef38dbeda45fe99$export$17f80983afe4e444 = (0, $eF4cA.forwardRef)(function SelectionIndicator(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $bef38dbeda45fe99$export$c9549807523555e0);
    let { isSelected: isSelected, ...otherProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElement), {
        ...otherProps,
        ref: ref,
        className: props.className || 'react-aria-SelectionIndicator',
        name: "SelectionIndicator",
        isVisible: isSelected
    });
});

});
parcelRegister("2FPWu", function(module, exports) {

$parcel$export(module.exports, "SharedElementTransition", () => $e0cf96e444c2b6e5$export$758399f318e6385a);
$parcel$export(module.exports, "SharedElement", () => $e0cf96e444c2b6e5$export$c34620ff8881d89f);

var $fDYaM = parcelRequire("fDYaM");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");

var $4skXn = parcelRequire("4skXn");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e0cf96e444c2b6e5$var$$792f28e438b9ad5f$var$SharedElementContext = (0, $eF4cA.createContext)(null);
function $e0cf96e444c2b6e5$export$758399f318e6385a(props) {
    let ref = (0, $eF4cA.useRef)({});
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($e0cf96e444c2b6e5$var$$792f28e438b9ad5f$var$SharedElementContext.Provider, {
        value: ref
    }, props.children);
}
const $e0cf96e444c2b6e5$export$c34620ff8881d89f = (0, $eF4cA.forwardRef)(function SharedElement(props, ref) {
    let { name: name, isVisible: isVisible = true, children: children, className: className, style: style, render: render, ...divProps } = props;
    let [state, setState] = (0, $eF4cA.useState)(isVisible ? 'visible' : 'hidden');
    let scopeRef = (0, $eF4cA.useContext)($e0cf96e444c2b6e5$var$$792f28e438b9ad5f$var$SharedElementContext);
    if (!scopeRef) throw new Error('<SharedElement> must be rendered inside a <SharedElementTransition>');
    if (isVisible && state === 'hidden') setState('visible');
    ref = (0, $26CkO.useObjectRef)(ref);
    (0, $4skXn.useLayoutEffect)(()=>{
        let element = ref.current;
        let scope = scopeRef.current;
        let prevSnapshot = scope[name];
        let frame = null;
        if (element && isVisible && prevSnapshot) {
            // Element is transitioning from a previous instance.
            setState('visible');
            let animations = element.getAnimations();
            // Set properties to animate from.
            let values = prevSnapshot.style.map(([property, prevValue])=>{
                let value = element.style[property];
                if (property === 'translate') {
                    let prevRect = prevSnapshot.rect;
                    let currentItem = element.getBoundingClientRect();
                    let deltaX = prevRect.left - currentItem?.left;
                    let deltaY = prevRect.top - currentItem?.top;
                    element.style.translate = `${deltaX}px ${deltaY}px`;
                } else element.style[property] = prevValue;
                return [
                    property,
                    value
                ];
            });
            // Cancel any new animations triggered by these properties.
            for (let a of element.getAnimations())if (!animations.includes(a)) a.cancel();
            // Remove overrides after one frame to animate to the current values.
            frame = requestAnimationFrame(()=>{
                frame = null;
                for (let [property, value] of values)element.style[property] = value;
            });
            delete scope[name];
        } else if (element && isVisible && !prevSnapshot) {
            // No previous instance exists, apply the entering state.
            queueMicrotask(()=>(0, $l19Vn.flushSync)(()=>setState('entering')));
            frame = requestAnimationFrame(()=>{
                frame = null;
                setState('visible');
            });
        } else if (element && !isVisible) // If so, no new SharedElement consumed it, so enter the exiting state.
        queueMicrotask(()=>{
            if (scope[name]) {
                delete scope[name];
                (0, $l19Vn.flushSync)(()=>setState('exiting'));
                Promise.all(element.getAnimations().map((a)=>a.finished)).then(()=>setState('hidden')).catch(()=>{});
            } else setState('hidden');
        });
        return ()=>{
            if (frame != null) cancelAnimationFrame(frame);
            if (element && element.isConnected && !element.hasAttribute('data-exiting')) {
                // On unmount, store a snapshot of the rectangle and computed style for transitioning properties.
                let style = window.getComputedStyle(element);
                if (style.transitionProperty !== 'none') {
                    let transitionProperty = style.transitionProperty.split(/\s*,\s*/);
                    scope[name] = {
                        rect: element.getBoundingClientRect(),
                        style: transitionProperty.map((p)=>[
                                p,
                                style[p]
                            ])
                    };
                }
            }
        };
    }, [
        ref,
        scopeRef,
        name,
        isVisible
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        children: children,
        className: className,
        style: style,
        render: render,
        values: {
            isEntering: state === 'entering',
            isExiting: state === 'exiting'
        }
    });
    if (state === 'hidden') return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...divProps,
        ...renderProps,
        ref: ref,
        "data-entering": state === 'entering' || undefined,
        "data-exiting": state === 'exiting' || undefined
    });
});

});


parcelRegister("jbXau", function(module, exports) {

$parcel$export(module.exports, "SeparatorContext", () => $20c45d22b03dc9bc$export$6615d83f6de245ce);
$parcel$export(module.exports, "Separator", () => $20c45d22b03dc9bc$export$1ff3c3f08ae963c0);

var $fDYaM = parcelRequire("fDYaM");

var $5ItsF = parcelRequire("5ItsF");

var $bWhaY = parcelRequire("bWhaY");

var $3g2oV = parcelRequire("3g2oV");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $20c45d22b03dc9bc$export$6615d83f6de245ce = (0, $eF4cA.createContext)({});
class $20c45d22b03dc9bc$export$7750289ca694c0b5 extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'separator';
    }
    filter(collection, newCollection) {
        let prevItem = newCollection.getItem(this.prevKey);
        if (prevItem && prevItem.type !== 'separator') {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
const $20c45d22b03dc9bc$export$1ff3c3f08ae963c0 = (0, $3g2oV.createLeafComponent)($20c45d22b03dc9bc$export$7750289ca694c0b5, function Separator(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $20c45d22b03dc9bc$export$6615d83f6de245ce);
    let { elementType: elementType, orientation: orientation, style: style, className: className, slot: slot, ...otherProps } = props;
    let Element = elementType || 'hr';
    if (Element === 'hr' && orientation === 'vertical') Element = 'div';
    let ElementType = (0, $fDYaM.dom)[Element];
    let { separatorProps: separatorProps } = (0, $5ItsF.useSeparator)({
        ...otherProps,
        elementType: elementType,
        orientation: orientation
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        render: props.render,
        ...(0, $lhKAD.mergeProps)(DOMProps, separatorProps),
        style: style,
        className: className ?? 'react-aria-Separator',
        ref: ref,
        slot: slot || undefined
    });
});

});
parcelRegister("5ItsF", function(module, exports) {

$parcel$export(module.exports, "useSeparator", () => $f2ea52c845131465$export$52210f68a14655d0);

var $fVfXf = parcelRequire("fVfXf");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f2ea52c845131465$export$52210f68a14655d0(props) {
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === 'vertical') ariaOrientation = 'vertical';
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== 'hr') return {
        separatorProps: {
            ...domProps,
            role: 'separator',
            'aria-orientation': ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

});


parcelRegister("lRhry", function(module, exports) {

$parcel$export(module.exports, "useMenu", () => $d74f3620caff782d$export$38eaa17faae8f579);

var $fVfXf = parcelRequire("fVfXf");

var $hlZng = parcelRequire("hlZng");

var $lhKAD = parcelRequire("lhKAD");

var $jePNV = parcelRequire("jePNV");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d74f3620caff782d$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    !props['aria-label'] && props['aria-labelledby'];
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $jePNV.useSelectableList)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: 'override'
    });
    (0, $hlZng.menuData).set(state, {
        onClose: props.onClose,
        onAction: props.onAction,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus
    });
    return {
        menuProps: (0, $lhKAD.mergeProps)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: 'menu',
            ...listProps,
            onKeyDown: (e)=>{
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== 'Escape' || props.shouldUseVirtualFocus) listProps.onKeyDown?.(e);
            }
        })
    };
}

});
parcelRegister("hlZng", function(module, exports) {

$parcel$export(module.exports, "menuData", () => $6cec247c3eb51d26$export$6f49b4016bfc8d56);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6cec247c3eb51d26$export$6f49b4016bfc8d56 = new WeakMap();

});

parcelRegister("jePNV", function(module, exports) {

$parcel$export(module.exports, "useSelectableList", () => $080bda340679084b$export$b95089534ab7c1fd);

var $vvwBC = parcelRequire("vvwBC");

var $daM4n = parcelRequire("daM4n");

var $gm31e = parcelRequire("gm31e");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $080bda340679084b$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, orientation: orientation } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $eF4cA.useMemo)(()=>keyboardDelegate || new (0, $daM4n.ListKeyboardDelegate)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator,
            layoutDelegate: layoutDelegate,
            orientation: orientation
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior,
        orientation
    ]);
    let { collectionProps: collectionProps } = (0, $vvwBC.useSelectableCollection)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

});
parcelRegister("vvwBC", function(module, exports) {

$parcel$export(module.exports, "useSelectableCollection", () => $4c566b60fe1794e4$export$d6daf82dcd84e87c);

var $bT06y = parcelRequire("bT06y");

var $5sRge = parcelRequire("5sRge");

var $eNuje = parcelRequire("eNuje");

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $6pgkA = parcelRequire("6pgkA");

var $YxOvP = parcelRequire("YxOvP");

var $fHcNp = parcelRequire("fHcNp");

var $lDJIO = parcelRequire("lDJIO");

var $11FxZ = parcelRequire("11FxZ");

var $3OYqT = parcelRequire("3OYqT");

var $lhKAD = parcelRequire("lhKAD");

var $3lc2m = parcelRequire("3lc2m");

var $58OnM = parcelRequire("58OnM");

var $aGDvF = parcelRequire("aGDvF");

var $1ntKq = parcelRequire("1ntKq");

var $aGgVM = parcelRequire("aGgVM");

var $luVJm = parcelRequire("luVJm");

var $a5mYH = parcelRequire("a5mYH");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4c566b60fe1794e4$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, escapeKeyBehavior: escapeKeyBehavior = 'clearSelection', selectOnFocus: selectOnFocus = manager.selectionBehavior === 'replace', disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = 'action', UNSTABLE_focusOnEntry: UNSTABLE_focusOnEntry } = options;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let router = (0, $aGgVM.useRouter)();
    const navigateToKey = (e, key, childFocus)=>{
        if (key != null) {
            if (manager.isLink(key) && linkBehavior === 'selection' && selectOnFocus && !(0, $fHcNp.isNonContiguousSelectionModifier)(e)) {
                (0, $l19Vn.flushSync)(()=>{
                    manager.setFocusedKey(key, childFocus);
                });
                let item = (0, $fHcNp.getItemElement)(ref, key);
                let itemProps = manager.getItemProps(key);
                if (item) {
                    router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                return false;
            }
            manager.setFocusedKey(key, childFocus);
            if (manager.isLink(key) && linkBehavior === 'override') return false;
            if (e.shiftKey && manager.selectionMode === 'multiple') {
                manager.extendSelection(key);
                return;
            } else if (selectOnFocus && !(0, $fHcNp.isNonContiguousSelectionModifier)(e)) {
                manager.replaceSelection(key);
                return;
            }
        }
        return false;
    };
    let arrowDown = (e)=>{
        if (delegate.getKeyBelow) {
            let nextKey = manager.focusedKey != null ? delegate.getKeyBelow?.(manager.focusedKey) : delegate.getFirstKey?.();
            if (nextKey == null && shouldFocusWrap) nextKey = delegate.getFirstKey?.(manager.focusedKey);
            if (nextKey != null) {
                navigateToKey(e, nextKey);
                return;
            }
        }
        return false;
    };
    let arrowUp = (e)=>{
        if (delegate.getKeyAbove) {
            let nextKey = manager.focusedKey != null ? delegate.getKeyAbove?.(manager.focusedKey) : delegate.getLastKey?.();
            if (nextKey == null && shouldFocusWrap) nextKey = delegate.getLastKey?.(manager.focusedKey);
            if (nextKey != null) {
                navigateToKey(e, nextKey);
                return;
            }
        }
        return false;
    };
    let home = (e)=>{
        if (delegate.getFirstKey) {
            if (manager.focusedKey === null && e.shiftKey) return false;
            // TODO: should Home and End also be reversed in column reverse aka Home goes to top? Or should Home always to to the "first" (bottom)
            let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $lDJIO.isCtrlKeyPressed)(e));
            manager.setFocusedKey(firstKey);
            if (firstKey != null) {
                if ((0, $lDJIO.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === 'multiple') {
                    manager.extendSelection(firstKey);
                    return;
                } else if (selectOnFocus) {
                    manager.replaceSelection(firstKey);
                    return;
                }
            }
        }
        return false;
    };
    let arrowLeft = (e)=>{
        if (delegate.getKeyLeftOf) {
            let nextKey = manager.focusedKey != null ? delegate.getKeyLeftOf?.(manager.focusedKey) : delegate.getFirstKey?.();
            if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? delegate.getFirstKey?.(manager.focusedKey) : delegate.getLastKey?.(manager.focusedKey);
            if (nextKey != null) {
                navigateToKey(e, nextKey, direction === 'rtl' ? 'first' : 'last');
                return;
            }
        }
        return false;
    };
    let arrowRight = (e)=>{
        if (delegate.getKeyRightOf) {
            let nextKey = manager.focusedKey != null ? delegate.getKeyRightOf?.(manager.focusedKey) : delegate.getFirstKey?.();
            if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? delegate.getLastKey?.(manager.focusedKey) : delegate.getFirstKey?.(manager.focusedKey);
            if (nextKey != null) {
                navigateToKey(e, nextKey, direction === 'rtl' ? 'last' : 'first');
                return;
            }
        }
        return false;
    };
    let end = (e)=>{
        if (delegate.getLastKey) {
            if (manager.focusedKey === null && e.shiftKey) return false;
            let lastKey = delegate.getLastKey(manager.focusedKey, (0, $lDJIO.isCtrlKeyPressed)(e));
            manager.setFocusedKey(lastKey);
            if (lastKey != null) {
                if ((0, $lDJIO.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === 'multiple') {
                    manager.extendSelection(lastKey);
                    return;
                } else if (selectOnFocus) {
                    manager.replaceSelection(lastKey);
                    return;
                }
            }
        }
        return false;
    };
    let pageDown = (e)=>{
        if (delegate.getKeyPageBelow && manager.focusedKey != null) {
            let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
            if (nextKey != null) return navigateToKey(e, nextKey);
        }
        return false;
    };
    let pageUp = (e)=>{
        if (delegate.getKeyPageAbove && manager.focusedKey != null) {
            let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
            if (nextKey != null) return navigateToKey(e, nextKey);
        }
        return false;
    };
    let aHandler = ()=>{
        if (manager.selectionMode === 'multiple' && disallowSelectAll !== true) {
            manager.selectAll();
            return;
        }
        return false;
    };
    let escape = ()=>{
        if (escapeKeyBehavior === 'clearSelection' && !disallowEmptySelection && manager.selectedKeys.size !== 0) {
            manager.clearSelection();
            return;
        }
        return false;
    };
    let tab = ()=>{
        if (!allowsTabNavigation && ref.current) {
            // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
            // However, collections should be treated as a single tab stop, with arrow key navigation internally.
            // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
            // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
            // in the collection, so that the browser default behavior will apply starting from that element
            // rather than the currently focused one.
            let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current, {
                tabbable: true
            });
            let next = undefined;
            let last;
            do {
                last = walker.lastChild();
                if (last) next = last;
            }while (last);
            // If the active element is NOT tabbable but is contained by an element that IS tabbable (aka the cell), the browser will actually move focus to
            // the containing element. We need to special case this so that tab will move focus out of the grid instead of looping between
            // focusing the containing cell and back to the non-tabbable child element
            let activeElement = (0, $fvyIQ.getActiveElement)();
            if (next && (!(0, $fvyIQ.isFocusWithin)(next) || activeElement && !(0, $3OYqT.isTabbable)(activeElement))) (0, $2jk5s.focusWithoutScrolling)(next);
        }
        return {
            shouldContinuePropagation: true,
            shouldPreventDefault: false
        };
    };
    let shiftTab = ()=>{
        if (!allowsTabNavigation && ref.current) ref.current.focus();
        return {
            shouldContinuePropagation: true,
            shouldPreventDefault: false
        };
    };
    let withShiftSel = (key, callback)=>{
        return {
            [(0, $11FxZ.isMac)() ? key + '+Shift+Alt' : key + '+Shift+Control']: callback,
            [key + '+Shift']: callback,
            [(0, $11FxZ.isMac)() ? key + '+Alt' : key + '+Control']: callback,
            [key]: callback
        };
    };
    // oxlint-disable react/react-compiler
    let { keyboardProps: repeatKeyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ...withShiftSel('ArrowDown', arrowDown),
            ...withShiftSel('ArrowUp', arrowUp),
            ...withShiftSel('ArrowLeft', arrowLeft),
            ...withShiftSel('ArrowRight', arrowRight),
            ...withShiftSel('PageDown', pageDown),
            ...withShiftSel('PageUp', pageUp)
        },
        allowRepeats: true
    });
    // oxlint-disable react/react-compiler
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ...withShiftSel('Home', home),
            ...withShiftSel('End', end),
            'Mod+A': aHandler,
            Escape: escape,
            Tab: tab,
            'Tab+Shift': shiftTab
        }
    });
    // oxlint-enable react/react-compiler
    // Store the scroll position so we can restore it later.
    /// TODO: should this happen all the time??
    let scrollPos = (0, $eF4cA.useRef)({
        top: 0,
        left: 0
    });
    (0, $58OnM.useEvent)(scrollRef, 'scroll', ()=>{
        scrollPos.current = {
            top: scrollRef.current?.scrollTop ?? 0,
            left: scrollRef.current?.scrollLeft ?? 0
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
        let modality = (0, $YxOvP.getInteractionModality)();
        manager.setFocused(true);
        let navigateToKey = (key)=>{
            if (key != null) {
                manager.setFocusedKey(key);
                if (selectOnFocus && !manager.isSelected(key)) manager.replaceSelection(key);
            }
        };
        // we need the "virtual" modality case checks here because shift tabbing from the prompt field's attachment card back into the
        // thread is a virtual focus event (the tab handler in onKeyDown focuses the ref of the attachmentList aka TagGroup via a focus() call, hence the virtual modality)
        if (UNSTABLE_focusOnEntry && (modality === 'keyboard' || modality === 'virtual')) // since it is probably more important to the user to see the new prompt reply rather than go to the last focused key
        navigateToKey(UNSTABLE_focusOnEntry === 'first' ? delegate.getFirstKey?.() : delegate.getLastKey?.());
        else if (manager.focusedKey == null) {
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToKey(manager.lastSelectedKey ?? delegate.getLastKey?.());
            else navigateToKey(manager.firstSelectedKey ?? delegate.getFirstKey?.());
        } else if (scrollRef.current) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (manager.focusedKey != null && scrollRef.current) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = (0, $fHcNp.getItemElement)(ref, manager.focusedKey);
            if (element instanceof HTMLElement) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!(0, $fvyIQ.isFocusWithin)(element) && !shouldUseVirtualFocus) (0, $2jk5s.focusWithoutScrolling)(element);
                if (modality === 'keyboard' || UNSTABLE_focusOnEntry && modality === 'virtual') (0, $3lc2m.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, e.relatedTarget)) manager.setFocused(false);
    };
    // Ref to track whether the first item in the collection should be automatically focused. Specifically used for autocomplete when user types
    // to focus the first key AFTER the collection updates.
    // TODO: potentially expand the usage of this
    let shouldVirtualFocusFirst = (0, $eF4cA.useRef)(false);
    (0, $58OnM.useEvent)(ref, (0, $bT06y.FOCUS_EVENT), !shouldUseVirtualFocus ? undefined : (e)=>{
        let { detail: detail } = e;
        e.stopPropagation();
        manager.setFocused(true);
        // If the user is typing forwards, autofocus the first option in the list.
        if (detail?.focusStrategy === 'first') shouldVirtualFocusFirst.current = true;
    });
    // update active descendant
    let firstKey = delegate.getFirstKey?.() ?? null;
    (0, $a5mYH.useUpdateLayoutEffect)(()=>{
        if (shouldVirtualFocusFirst.current) {
            // If no focusable items exist in the list, make sure to clear any activedescendant that may still exist and move focus back to
            // the original active element (e.g. the autocomplete input)
            if (firstKey == null) {
                let previousActiveElement = (0, $fvyIQ.getActiveElement)();
                (0, $5sRge.moveVirtualFocus)(ref.current);
                (0, $5sRge.dispatchVirtualFocus)(previousActiveElement, null);
                // If there wasn't a focusable key but the collection had items, then that means we aren't in an intermediate load state and all keys are disabled.
                // Reset shouldVirtualFocusFirst so that we don't erronously autofocus an item when the collection is filtered again.
                if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
            } else {
                manager.setFocusedKey(firstKey);
                // Only set shouldVirtualFocusFirst to false if we've successfully set the first key as the focused key
                // If there wasn't a key to focus, we might be in a temporary loading state so we'll want to still focus the first key
                // after the collection updates after load
                shouldVirtualFocusFirst.current = false;
            }
        }
    }, [
        firstKey,
        manager.collection.size
    ]);
    (0, $a5mYH.useUpdateLayoutEffect)(()=>{
        // If user causes the focused key to change in any other way, clear shouldVirtualFocusFirst so we don't
        // accidentally move focus from under them. Skip this if the collection was empty because we might be in a load
        // state and will still want to focus the first item after load
        if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
    }, [
        manager.focusedKey
    ]);
    (0, $58OnM.useEvent)(ref, (0, $bT06y.CLEAR_FOCUS_EVENT), !shouldUseVirtualFocus ? undefined : (e)=>{
        e.stopPropagation();
        manager.setFocused(false);
        if (e.detail?.clearFocusKey) manager.setFocusedKey(null);
    });
    const autoFocusRef = (0, $eF4cA.useRef)(autoFocus);
    const didAutoFocusRef = (0, $eF4cA.useRef)(false);
    (0, $eF4cA.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === 'first') focusedKey = delegate.getFirstKey?.() ?? null;
            if (autoFocus === 'last') focusedKey = delegate.getLastKey?.() ?? null;
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            if (focusedKey != null && selectOnFocus && !selectedKeys.size && manager.canSelectItem(focusedKey)) manager.replaceSelection(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus && ref.current) (0, $eNuje.focusSafely)(ref.current);
            // Wait until the collection has items to autofocus.
            if (manager.collection.size > 0) {
                autoFocusRef.current = false;
                didAutoFocusRef.current = true;
            }
        }
    });
    // Scroll the focused element into view when the focusedKey changes.
    let lastFocusedKey = (0, $eF4cA.useRef)(manager.focusedKey);
    let raf = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (manager.isFocused && manager.focusedKey != null && (manager.focusedKey !== lastFocusedKey.current || didAutoFocusRef.current) && scrollRef.current && ref.current) {
            let modality = (0, $YxOvP.getInteractionModality)();
            let element = (0, $fHcNp.getItemElement)(ref, manager.focusedKey);
            if (!(element instanceof HTMLElement)) // The collection may initially be empty (e.g. virtualizer), so wait until the element exists.
            return;
            if (modality === 'keyboard' || didAutoFocusRef.current) {
                if (raf.current) cancelAnimationFrame(raf.current);
                raf.current = requestAnimationFrame(()=>{
                    if (scrollRef.current) {
                        (0, $3lc2m.scrollIntoView)(scrollRef.current, element);
                        // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                        if (modality !== 'virtual') (0, $3lc2m.scrollIntoViewport)(element, {
                            containingElement: ref.current
                        });
                    }
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (!shouldUseVirtualFocus && manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null && ref.current) (0, $eNuje.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        didAutoFocusRef.current = false;
    });
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    (0, $58OnM.useEvent)(ref, 'react-aria-focus-scope-restore', (e)=>{
        e.preventDefault();
        manager.setFocused(true);
    });
    let handlers = {
        ...(0, $lhKAD.mergeProps)(keyboardProps, repeatKeyboardProps),
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === (0, $fvyIQ.getEventTarget)(e)) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $luVJm.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $lhKAD.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    let tabIndex = undefined;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    let collectionId = (0, $fHcNp.useCollectionId)(manager.collection);
    return {
        // oxlint-disable-next-line react/react-compiler
        collectionProps: (0, $lhKAD.mergeProps)(handlers, {
            tabIndex: tabIndex,
            'data-collection': collectionId
        })
    };
}

});
parcelRegister("fHcNp", function(module, exports) {

$parcel$export(module.exports, "isNonContiguousSelectionModifier", () => $24eea0c8a64d13c1$export$d3e3bd3e26688c04);
$parcel$export(module.exports, "getItemElement", () => $24eea0c8a64d13c1$export$c3d8340acf92597f);
$parcel$export(module.exports, "useCollectionId", () => $24eea0c8a64d13c1$export$881eb0d9f3605d9d);
$parcel$export(module.exports, "getCollectionId", () => $24eea0c8a64d13c1$export$6aeb1680a0ae8741);

var $11FxZ = parcelRequire("11FxZ");

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $24eea0c8a64d13c1$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $11FxZ.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $24eea0c8a64d13c1$export$c3d8340acf92597f(collectionRef, key) {
    let selector = `[data-key="${CSS.escape(String(key))}"]`;
    let collection = collectionRef.current?.dataset.collection;
    if (collection) selector = `[data-collection="${CSS.escape(collection)}"]${selector}`;
    return collectionRef.current?.querySelector(selector);
}
const $24eea0c8a64d13c1$var$$22bbea12c2567021$var$collectionMap = new WeakMap();
function $24eea0c8a64d13c1$export$881eb0d9f3605d9d(collection) {
    let id = (0, $25dFS.useId)();
    $24eea0c8a64d13c1$var$$22bbea12c2567021$var$collectionMap.set(collection, id);
    return id;
}
function $24eea0c8a64d13c1$export$6aeb1680a0ae8741(collection) {
    return $24eea0c8a64d13c1$var$$22bbea12c2567021$var$collectionMap.get(collection);
}

});

parcelRegister("3lc2m", function(module, exports) {

$parcel$export(module.exports, "scrollIntoView", () => $c4256e327b0da04a$export$53a0910f038337bd);
$parcel$export(module.exports, "scrollIntoViewport", () => $c4256e327b0da04a$export$c826860796309d1b);

var $kqP2q = parcelRequire("kqP2q");

var $11FxZ = parcelRequire("11FxZ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c4256e327b0da04a$export$53a0910f038337bd(scrollView, element, opts = {}) {
    if (scrollView === element) return;
    let target = element.getBoundingClientRect();
    $c4256e327b0da04a$export$f064fd83a2c6e9ca(scrollView, element, target, opts);
}
function $c4256e327b0da04a$export$f064fd83a2c6e9ca(scrollView, element, target, opts = {}) {
    let { block: block = 'nearest', inline: inline = 'nearest' } = opts;
    let y = scrollView.scrollTop;
    let x = scrollView.scrollLeft;
    let view = scrollView.getBoundingClientRect();
    let itemStyle = window.getComputedStyle(element);
    let viewStyle = window.getComputedStyle(scrollView);
    let root = document.scrollingElement || document.documentElement;
    let isRoot = scrollView === root;
    let viewTop = scrollView === root ? 0 : view.top;
    let viewBottom = scrollView === root ? scrollView.clientHeight : view.bottom;
    let viewLeft = scrollView === root ? 0 : view.left;
    let viewRight = scrollView === root ? scrollView.clientWidth : view.right;
    let scrollMarginTop = parseFloat(itemStyle.scrollMarginTop) || 0;
    let scrollMarginBottom = parseFloat(itemStyle.scrollMarginBottom) || 0;
    let scrollMarginLeft = parseFloat(itemStyle.scrollMarginLeft) || 0;
    let scrollMarginRight = parseFloat(itemStyle.scrollMarginRight) || 0;
    let scrollPaddingTop = parseFloat(viewStyle.scrollPaddingTop) || 0;
    let scrollPaddingBottom = parseFloat(viewStyle.scrollPaddingBottom) || 0;
    let scrollPaddingLeft = parseFloat(viewStyle.scrollPaddingLeft) || 0;
    let scrollPaddingRight = parseFloat(viewStyle.scrollPaddingRight) || 0;
    let borderTopWidth = parseFloat(viewStyle.borderTopWidth) || 0;
    let borderBottomWidth = parseFloat(viewStyle.borderBottomWidth) || 0;
    let borderLeftWidth = parseFloat(viewStyle.borderLeftWidth) || 0;
    let borderRightWidth = parseFloat(viewStyle.borderRightWidth) || 0;
    let scrollAreaTop = target.top - scrollMarginTop;
    let scrollAreaBottom = target.bottom + scrollMarginBottom;
    let scrollAreaLeft = target.left - scrollMarginLeft;
    let scrollAreaRight = target.right + scrollMarginRight;
    let scrollBarOffsetX = scrollView === root ? 0 : borderLeftWidth + borderRightWidth;
    let scrollBarOffsetY = scrollView === root ? 0 : borderTopWidth + borderBottomWidth;
    let scrollBarWidth = scrollView === root ? 0 : scrollView.offsetWidth - scrollView.clientWidth - scrollBarOffsetX;
    let scrollBarHeight = scrollView === root ? 0 : scrollView.offsetHeight - scrollView.clientHeight - scrollBarOffsetY;
    let scrollPortTop = viewTop + (isRoot ? 0 : borderTopWidth) + scrollPaddingTop;
    let scrollPortBottom = viewBottom - (isRoot ? 0 : borderBottomWidth) - scrollPaddingBottom - scrollBarHeight;
    let scrollPortLeft = viewLeft + (isRoot ? 0 : borderLeftWidth) + scrollPaddingLeft;
    let scrollPortRight = viewRight - (isRoot ? 0 : borderRightWidth) - scrollPaddingRight;
    // WebKit on iOS always positions the scrollbar on the right ¯\_(ツ)_/¯
    if ((0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)() || viewStyle.direction === 'ltr') scrollPortRight -= scrollBarWidth;
    else if (viewStyle.direction === 'rtl') scrollPortLeft += scrollBarWidth;
    let shouldScrollBlock = scrollAreaTop < scrollPortTop || scrollAreaBottom > scrollPortBottom;
    let shouldScrollInline = scrollAreaLeft < scrollPortLeft || scrollAreaRight > scrollPortRight;
    if (shouldScrollBlock && block === 'start') y += scrollAreaTop - scrollPortTop;
    else if (shouldScrollBlock && block === 'center') y += (scrollAreaTop + scrollAreaBottom) / 2 - (scrollPortTop + scrollPortBottom) / 2;
    else if (shouldScrollBlock && block === 'end') y += scrollAreaBottom - scrollPortBottom;
    else if (shouldScrollBlock && block === 'nearest') {
        let start = scrollAreaTop - scrollPortTop;
        let end = scrollAreaBottom - scrollPortBottom;
        y += Math.abs(start) <= Math.abs(end) ? start : end;
    }
    if (shouldScrollInline && inline === 'start') x += scrollAreaLeft - scrollPortLeft;
    else if (shouldScrollInline && inline === 'center') x += (scrollAreaLeft + scrollAreaRight) / 2 - (scrollPortLeft + scrollPortRight) / 2;
    else if (shouldScrollInline && inline === 'end') x += scrollAreaRight - scrollPortRight;
    else if (shouldScrollInline && inline === 'nearest') {
        let start = scrollAreaLeft - scrollPortLeft;
        let end = scrollAreaRight - scrollPortRight;
        x += Math.abs(start) <= Math.abs(end) ? start : end;
    }
    scrollView.scrollTo({
        left: x,
        top: y
    });
}
function $c4256e327b0da04a$export$c826860796309d1b(targetElement, opts = {}) {
    let { containingElement: containingElement } = opts;
    if (targetElement && targetElement.isConnected) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === 'hidden';
        if (!isScrollPrevented) {
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            // use scrollIntoView({block: 'nearest'}) instead of .focus to check if the element is fully in view or not since .focus()
            // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            targetElement?.scrollIntoView?.({
                block: 'nearest'
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                containingElement?.scrollIntoView?.({
                    block: 'center',
                    inline: 'center'
                });
                targetElement.scrollIntoView?.({
                    block: 'nearest'
                });
            }
        } else {
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            let scrollParents = (0, $kqP2q.getScrollParents)(targetElement, true);
            for (let scrollParent of scrollParents)$c4256e327b0da04a$export$53a0910f038337bd(scrollParent, targetElement);
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                scrollParents = containingElement ? (0, $kqP2q.getScrollParents)(containingElement, true) : [];
                // scroll containing element into view first, then rescroll target element into view like the non chrome flow above
                for (let scrollParent of scrollParents)$c4256e327b0da04a$export$53a0910f038337bd(scrollParent, containingElement, {
                    block: 'center',
                    inline: 'center'
                });
                for (let scrollParent of (0, $kqP2q.getScrollParents)(targetElement, true))$c4256e327b0da04a$export$53a0910f038337bd(scrollParent, targetElement);
            }
        }
    }
}

});
parcelRegister("kqP2q", function(module, exports) {

$parcel$export(module.exports, "getScrollParents", () => $2b7495a25d5187f5$export$94ed1c92c7beeb22);

var $fSNAA = parcelRequire("fSNAA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b7495a25d5187f5$export$94ed1c92c7beeb22(node, checkForOverflow) {
    let parentElements = [];
    let root = document.scrollingElement || document.documentElement;
    while(node){
        if ((0, $fSNAA.isScrollable)(node, checkForOverflow)) parentElements.push(node);
        if (node === root) break;
        node = node.parentElement;
    }
    return parentElements;
}

});


parcelRegister("luVJm", function(module, exports) {

$parcel$export(module.exports, "useTypeSelect", () => $027d0e9be8e132de$export$e32c88dfddc6e1d8);

var $fvyIQ = parcelRequire("fvyIQ");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $027d0e9be8e132de$var$$f5a4a9a3486154da$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $027d0e9be8e132de$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $eF4cA.useRef)({
        search: '',
        timeout: undefined
    });
    let onKeyDownCapture = (e)=>{
        // if we're in the middle of a search, then a spacebar should be treated as a search and we should not propagate the event
        // since we handle this one in a capture phase, we should ignore it in the bubble phase
        if (state.current.search.length > 0 && e.key === ' ') {
            e.preventDefault();
            if (!('continuePropagation' in e) || 'continuePropagation' in e && !e.isPropagationStopped()) e.stopPropagation();
            state.current.search += ' ';
            if (keyboardDelegate.getKeyForSearch != null) {
                // Use the delegate to find a key to focus.
                // Prioritize items after the currently focused item, falling back to searching the whole list.
                let key = keyboardDelegate.getKeyForSearch(state.current.search, selectionManager.focusedKey);
                // If no key found, search from the top.
                if (key == null) key = keyboardDelegate.getKeyForSearch(state.current.search);
                if (key != null) {
                    selectionManager.setFocusedKey(key);
                    if (onTypeSelect) onTypeSelect(key);
                }
            }
            clearTimeout(state.current.timeout);
            state.current.timeout = setTimeout(()=>{
                state.current.search = '';
            }, $027d0e9be8e132de$var$$f5a4a9a3486154da$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
        }
    };
    let onKeyDown = (e)=>{
        let character = $027d0e9be8e132de$var$$f5a4a9a3486154da$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || e.altKey || !(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e)) || state.current.search.length === 0 && character === ' ') return;
        state.current.search += character;
        if (keyboardDelegate.getKeyForSearch != null) {
            // Use the delegate to find a key to focus.
            // Prioritize items after the currently focused item, falling back to searching the whole list.
            let key = keyboardDelegate.getKeyForSearch(state.current.search, selectionManager.focusedKey);
            if (key == null) key = keyboardDelegate.getKeyForSearch(state.current.search);
            if (key != null) {
                selectionManager.setFocusedKey(key);
                if (onTypeSelect) onTypeSelect(key);
                e.preventDefault();
                if (!('continuePropagation' in e)) e.stopPropagation();
            } else {
                // if still nothing then the type to select is done and everything is reset
                state.current.search = '';
                clearTimeout(state.current.timeout);
                state.current.timeout = undefined;
                return;
            }
        }
        clearTimeout(state.current.timeout);
        state.current.timeout = setTimeout(()=>{
            state.current.search = '';
        }, $027d0e9be8e132de$var$$f5a4a9a3486154da$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    (0, $eF4cA.useEffect)(()=>{
        let timeout = state.current.timeout;
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        state
    ]);
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDownCapture : undefined,
            onKeyDown: keyboardDelegate.getKeyForSearch ? onKeyDown : undefined
        }
    };
}
function $027d0e9be8e132de$var$$f5a4a9a3486154da$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return '';
}

});

parcelRegister("a5mYH", function(module, exports) {

$parcel$export(module.exports, "useUpdateLayoutEffect", () => $0430c9fb5b0b4ad9$export$72ef708ab07251f1);

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0430c9fb5b0b4ad9$export$72ef708ab07251f1(effect, dependencies) {
    const isInitialMount = (0, $eF4cA.useRef)(true);
    const lastDeps = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("daM4n", function(module, exports) {

$parcel$export(module.exports, "ListKeyboardDelegate", () => $8df7e87875140fe7$export$a05409b8bb224a5a);

var $aXSxC = parcelRequire("aXSxC");

var $fHcNp = parcelRequire("fHcNp");

var $fSNAA = parcelRequire("fSNAA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $8df7e87875140fe7$export$a05409b8bb224a5a {
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || 'all';
            this.orientation = opts.orientation || 'vertical';
            this.direction = opts.direction;
            this.layout = opts.layout || 'stack';
            this.layoutDelegate = opts.layoutDelegate || new (0, $aXSxC.DOMLayoutDelegate)(opts.ref);
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = 'stack';
            this.orientation = 'vertical';
            this.disabledBehavior = 'all';
            this.layoutDelegate = new (0, $aXSxC.DOMLayoutDelegate)(this.ref);
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === 'stack' && this.orientation === 'vertical') {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
    isDisabled(item) {
        return this.disabledBehavior === 'all' && (item.props?.isDisabled || this.disabledKeys.has(item.key)) && item.props?.disabledBehavior !== 'selection';
    }
    findNextNonDisabled(key, getNext, includeDisabled = false) {
        let nextKey = key;
        while(nextKey != null){
            let item = this.collection.getItem(nextKey);
            if (item?.type === 'item' && (includeDisabled || !this.isDisabled(item))) return nextKey;
            nextKey = getNext(nextKey);
        }
        return null;
    }
    getNextKey(key, options) {
        let nextKey = key;
        nextKey = this.collection.getKeyAfter(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyAfter(key), options?.includeDisabled);
    }
    getPreviousKey(key, options) {
        let nextKey = key;
        nextKey = this.collection.getKeyBefore(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyBefore(key), options?.includeDisabled);
    }
    findKey(key, nextKey, shouldSkip) {
        let tempKey = key;
        let itemRect = this.layoutDelegate.getItemRect(tempKey);
        if (!itemRect || tempKey == null) return null;
        // Find the item above or below in the same column.
        let prevRect = itemRect;
        do {
            tempKey = nextKey(tempKey);
            if (tempKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(tempKey);
        }while (itemRect && shouldSkip(prevRect, itemRect) && tempKey != null);
        return tempKey;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.y === itemRect.y || prevRect.x !== itemRect.x;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.x === itemRect.x || prevRect.y !== itemRect.y;
    }
    // checks to see if the next/prev key is spatially above/below the current key. If not, that means we are in
    // a reversed column layout and need to adjust appropriately
    // TODO: still need to see how this works with virtualizer once there is handling for the reverse layout
    // this felt like a simpler approach then changing getKeyAbove/Below to be purely spatial calculations
    isReversed(key) {
        let nextKey = this.getNextKey(key);
        let currentEl = (0, $fHcNp.getItemElement)(this.ref, key);
        if (nextKey != null) {
            let nextEl = (0, $fHcNp.getItemElement)(this.ref, nextKey);
            if (!currentEl || !nextEl) return false;
            return currentEl.getBoundingClientRect().top > nextEl.getBoundingClientRect().top;
        }
        let prevKey = this.getPreviousKey(key);
        if (prevKey != null) {
            let prevEl = (0, $fHcNp.getItemElement)(this.ref, prevKey);
            if (!currentEl || !prevEl) return false;
            return prevEl.getBoundingClientRect().top > currentEl.getBoundingClientRect().top;
        }
        return false;
    }
    getKeyBelow(key, options) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getNextKey(key, options), this.isSameRow);
        else if (this.orientation === 'vertical') return this.isReversed(key) ? this.getPreviousKey(key, options) : this.getNextKey(key, options);
        else return this.getNextKey(key, options);
    }
    getKeyAbove(key, options) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getPreviousKey(key, options), this.isSameRow);
        else if (this.orientation === 'vertical') return this.isReversed(key) ? this.getNextKey(key, options) : this.getPreviousKey(key, options);
        else return this.getPreviousKey(key, options);
    }
    getNextColumn(key, right, options) {
        return right ? this.getPreviousKey(key, options) : this.getNextKey(key, options);
    }
    getKeyRightOf(key, options) {
        // This is a temporary solution for CardView until we refactor useSelectableCollection.
        // https://github.com/orgs/adobe/projects/19/views/32?pane=issue&itemId=77825042
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyRightOf' : 'getKeyLeftOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key), options?.includeDisabled);
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'rtl', options);
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'rtl', options), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'rtl', options);
        return null;
    }
    getKeyLeftOf(key, options) {
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyLeftOf' : 'getKeyRightOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key), options?.includeDisabled);
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'ltr', options);
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'ltr', options), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'ltr', options);
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyAfter(key));
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyBefore(key));
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let reversed = this.isReversed(key);
        if (menu && !(0, $fSNAA.isScrollable)(menu)) return this.getFirstKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.max(0, itemRect.x + itemRect.width - this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x > pageX && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let visibleRect = this.layoutDelegate.getVisibleRect();
            // column reverse makes y negative for items so we need to instead do current pos - height instead
            let pageY = reversed ? itemRect.y - visibleRect.height : Math.max(0, itemRect.y + itemRect.height - visibleRect.height);
            while(itemRect && itemRect.y > pageY && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey ?? (reversed ? this.getLastKey() : this.getFirstKey());
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let reversed = this.isReversed(key);
        if (menu && !(0, $fSNAA.isScrollable)(menu)) return this.getLastKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.min(this.layoutDelegate.getContentSize().width, itemRect.x - itemRect.width + this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x < pageX && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y - itemRect.height + this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y < pageY && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey ?? (reversed ? this.getFirstKey() : this.getLastKey());
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getNextKey(key);
        }
        return null;
    }
}

});
parcelRegister("aXSxC", function(module, exports) {

$parcel$export(module.exports, "DOMLayoutDelegate", () => $78c31fae6644d302$export$8f5ed9ff9f511381);

var $fHcNp = parcelRequire("fHcNp");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $78c31fae6644d302$export$8f5ed9ff9f511381 {
    constructor(ref){
        this.ref = ref;
    }
    getItemRect(key) {
        let container = this.ref.current;
        if (!container) return null;
        let item = key != null ? (0, $fHcNp.getItemElement)(this.ref, key) : null;
        if (!item) return null;
        let containerRect = container.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        return {
            x: itemRect.left - containerRect.left - container.clientLeft + container.scrollLeft,
            y: itemRect.top - containerRect.top - container.clientTop + container.scrollTop,
            width: itemRect.width,
            height: itemRect.height
        };
    }
    getContentSize() {
        let container = this.ref.current;
        return {
            width: container?.scrollWidth ?? 0,
            height: container?.scrollHeight ?? 0
        };
    }
    getVisibleRect() {
        let container = this.ref.current;
        return {
            x: container?.scrollLeft ?? 0,
            y: container?.scrollTop ?? 0,
            width: container?.clientWidth ?? 0,
            height: container?.clientHeight ?? 0
        };
    }
}

});


parcelRegister("gm31e", function(module, exports) {

$parcel$export(module.exports, "useCollator", () => $7c54b929ae5e4a45$export$a16aca283550c30d);

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $7c54b929ae5e4a45$var$$673d46fce3e5717d$var$cache = new Map();
function $7c54b929ae5e4a45$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($7c54b929ae5e4a45$var$$673d46fce3e5717d$var$cache.has(cacheKey)) return $7c54b929ae5e4a45$var$$673d46fce3e5717d$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $7c54b929ae5e4a45$var$$673d46fce3e5717d$var$cache.set(cacheKey, formatter);
    return formatter;
}

});



parcelRegister("hUJml", function(module, exports) {

$parcel$export(module.exports, "useMenuItem", () => $5fbd7ace1afb48e0$export$9d32628fc2aea7da);

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $aGgVM = parcelRequire("aGgVM");

var $YxOvP = parcelRequire("YxOvP");

var $hlZng = parcelRequire("hlZng");

var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $j2JDe = parcelRequire("j2JDe");

var $aGDvF = parcelRequire("aGDvF");

var $bEes0 = parcelRequire("bEes0");

var $hNw9N = parcelRequire("hNw9N");

var $25dFS = parcelRequire("25dFS");

var $4vRK0 = parcelRequire("4vRK0");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5fbd7ace1afb48e0$export$9d32628fc2aea7da(props, state, ref) {
    let { id: id, key: key, closeOnSelect: closeOnSelect, shouldCloseOnSelect: shouldCloseOnSelect, isVirtualized: isVirtualized, 'aria-haspopup': hasPopup, onPressStart: onPressStart, onPressUp: pressUpProp, onPress: onPress, onPressChange: pressChangeProp, onPressEnd: onPressEnd, onClick: onClickProp, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur, selectionManager: selectionManager = state.selectionManager } = props;
    let isTrigger = !!hasPopup;
    let isTriggerExpanded = isTrigger && props['aria-expanded'] === 'true';
    let isDisabled = props.isDisabled ?? selectionManager.isDisabled(key);
    let isSelected = props.isSelected ?? selectionManager.isSelected(key);
    let data = (0, $hlZng.menuData).get(state);
    let item = state.collection.getItem(key);
    let onClose = props.onClose || data.onClose;
    let router = (0, $aGgVM.useRouter)();
    let performAction = ()=>{
        if (isTrigger) return;
        if (item?.props?.onAction) item.props.onAction();
        else if (props.onAction) props.onAction(key);
        if (data.onAction) {
            // Must reassign to variable otherwise `this` binding gets messed up. Something to do with WeakMap.
            let onAction = data.onAction;
            onAction(key, item?.value);
        }
    };
    let role = 'menuitem';
    if (!isTrigger) {
        if (selectionManager.selectionMode === 'single') role = 'menuitemradio';
        else if (selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    }
    let labelId = (0, $25dFS.useSlotId)();
    let descriptionId = (0, $25dFS.useSlotId)();
    let keyboardId = (0, $25dFS.useSlotId)();
    let ariaProps = {
        id: id,
        'aria-disabled': isDisabled || undefined,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            props['aria-describedby'],
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined,
        'aria-controls': props['aria-controls'],
        'aria-haspopup': hasPopup,
        'aria-expanded': props['aria-expanded']
    };
    if (selectionManager.selectionMode !== 'none' && !isTrigger) ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        let index = Number(item?.index);
        ariaProps['aria-posinset'] = Number.isNaN(index) ? undefined : index + 1;
        ariaProps['aria-setsize'] = (0, $4vRK0.getItemCount)(state.collection);
    }
    let isPressedRef = (0, $eF4cA.useRef)(false);
    let onPressChange = (isPressed)=>{
        pressChangeProp?.(isPressed);
        isPressedRef.current = isPressed;
    };
    let interaction = (0, $eF4cA.useRef)(null);
    let onPressUp = (e)=>{
        if (e.pointerType !== 'keyboard') interaction.current = {
            pointerType: e.pointerType
        };
        // If interacting with mouse, allow the user to mouse down on the trigger button,
        // drag, and release over an item (matching native behavior).
        if (e.pointerType === 'mouse') {
            if (!isPressedRef.current) e.target.click();
        }
        pressUpProp?.(e);
    };
    let onClick = (e)=>{
        onClickProp?.(e);
        performAction();
        (0, $aGgVM.handleLinkClick)(e, router, item.props.href, item?.props.routerOptions);
        let shouldClose = interaction.current?.pointerType === 'keyboard' ? interaction.current?.key === 'Enter' || selectionManager.selectionMode === 'none' || selectionManager.isLink(key) : selectionManager.selectionMode !== 'multiple' || selectionManager.isLink(key);
        shouldClose = shouldCloseOnSelect ?? closeOnSelect ?? shouldClose;
        if (onClose && !isTrigger && shouldClose) onClose();
        interaction.current = null;
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $hNw9N.useSelectableItem)({
        id: id,
        selectionManager: selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: 'none',
        shouldUseVirtualFocus: data.shouldUseVirtualFocus
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $j2JDe.useHover)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            // Hovering over an already expanded sub dialog trigger should keep focus in the dialog.
            if (!(0, $YxOvP.isFocusVisible)() && !(isTriggerExpanded && hasPopup)) {
                selectionManager.setFocused(true);
                selectionManager.setFocusedKey(key);
            }
            hoverStartProp?.(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ' ': (e)=>{
                interaction.current = {
                    pointerType: 'keyboard',
                    key: ' '
                };
                (0, $fvyIQ.getEventTarget)(e).click();
                (0, $YxOvP.setInteractionModality)('keyboard');
            },
            Enter: (e)=>{
                interaction.current = {
                    pointerType: 'keyboard',
                    key: 'Enter'
                };
                let target = (0, $fvyIQ.getEventTarget)(e);
                // Trigger click unless this is a link. Links with real DOM focus activate on Enter natively.
                // With virtual focus (e.g. Autocomplete) focus stays on the input and useAutocomplete dispatches
                // keydown here then follows with a synthetic click only if dispatchEvent was not canceled—so
                // links must not preventDefault on that keydown.
                if (target.tagName !== 'A') {
                    target.click();
                    (0, $YxOvP.setInteractionModality)('keyboard');
                    return;
                }
                (0, $YxOvP.setInteractionModality)('keyboard');
                return {
                    shouldPreventDefault: false,
                    shouldContinuePropagation: false
                };
            }
        },
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    });
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    }, ref);
    let domProps = (0, $fVfXf.filterDOMProps)(item?.props);
    delete domProps.id;
    let linkProps = (0, $aGgVM.useLinkProps)(item?.props);
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $lhKAD.mergeProps)(domProps, linkProps, isTrigger ? {
                onFocus: itemProps.onFocus,
                'data-collection': itemProps['data-collection'],
                'data-key': itemProps['data-key']
            } : itemProps, pressProps, hoverProps, keyboardProps, focusableProps, data.shouldUseVirtualFocus || isTrigger ? {
                onMouseDown: (e)=>e.preventDefault()
            } : undefined, isDisabled ? undefined : {
                onClick: onClick
            }),
            // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
            tabIndex: itemProps.tabIndex != null && isTriggerExpanded && !data.shouldUseVirtualFocus ? -1 : itemProps.tabIndex
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && selectionManager.isFocused && (0, $YxOvP.isFocusVisible)() && !isTriggerExpanded,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}

});
parcelRegister("hNw9N", function(module, exports) {

$parcel$export(module.exports, "useSelectableItem", () => $fadb777ac96b823a$export$ecf600387e221c37);

var $d8j5I = parcelRequire("d8j5I");

var $eNuje = parcelRequire("eNuje");

var $fvyIQ = parcelRequire("fvyIQ");

var $fHcNp = parcelRequire("fHcNp");

var $lDJIO = parcelRequire("lDJIO");

var $3OYqT = parcelRequire("3OYqT");

var $lhKAD = parcelRequire("lhKAD");

var $5sRge = parcelRequire("5sRge");

var $aGgVM = parcelRequire("aGgVM");

var $bEes0 = parcelRequire("bEes0");

var $25dFS = parcelRequire("25dFS");

var $fFU3w = parcelRequire("fFU3w");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fadb777ac96b823a$export$ecf600387e221c37(options) {
    let { id: id, selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = 'action' } = options;
    let router = (0, $aGgVM.useRouter)();
    id = (0, $25dFS.useId)(id);
    let onSelect = (e)=>{
        if (e.pointerType === 'keyboard' && (0, $fHcNp.isNonContiguousSelectionModifier)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === 'none') return;
            if (manager.isLink(key)) {
                if (linkBehavior === 'selection' && ref.current) {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === 'override' || linkBehavior === 'none') return;
            }
            if (manager.selectionMode === 'single') {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === 'toggle' || e && ((0, $lDJIO.isCtrlKeyPressed)(e) || e.pointerType === 'touch' || e.pointerType === 'virtual')) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $eF4cA.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused) {
            if (!shouldUseVirtualFocus) {
                if (focus) focus();
                else if ((0, $fvyIQ.getActiveElement)() !== ref.current && ref.current) (0, $eNuje.focusSafely)(ref.current);
            } else (0, $5sRge.moveVirtualFocus)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if ((0, $fvyIQ.getEventTarget)(e) === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    (0, $eF4cA.useEffect)(()=>{
        if (isDisabled && manager.focusedKey === key) manager.setFocusedKey(null);
    }, [
        manager,
        isDisabled,
        key
    ]);
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === 'override';
    let isActionOverride = onAction && options['UNSTABLE_itemBehavior'] === 'action';
    let hasLinkAction = manager.isLink(key) && linkBehavior !== 'selection' && linkBehavior !== 'none';
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride && !isActionOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === 'replace' ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === 'replace';
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $eF4cA.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $eF4cA.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $eF4cA.useRef)(false);
    let collectionItemProps = manager.getItemProps(key);
    let performAction = (e)=>{
        if (onAction) {
            onAction();
            ref.current?.dispatchEvent(new CustomEvent('react-aria-item-action', {
                bubbles: true
            }));
        }
        if (hasLinkAction && ref.current) router.open(ref.current, e, collectionItemProps.href, collectionItemProps.routerOptions);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {
        ref: ref
    };
    if (shouldSelectOnPressUp) {
        // oxlint-disable-next-line react/react-compiler
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === 'keyboard' && (!hasAction || $fadb777ac96b823a$var$$f6ba6936bfd098a0$var$isSelectionKey(e.key))) onSelect(e);
        };
        // If allowsDifferentPressOrigin and interacting with mouse, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== 'mouse') {
                if (e.pointerType === 'keyboard' && !$fadb777ac96b823a$var$$f6ba6936bfd098a0$var$isActionKey(e.key)) return;
                performAction(e);
            } else if (e.pointerType !== 'keyboard' && allowsSelection) onSelect(e);
        };
        else {
            // oxlint-disable-next-line react/react-compiler
            itemPressProps.onPressUp = hasPrimaryAction ? undefined : (e)=>{
                if (e.pointerType === 'mouse' && allowsSelection) onSelect(e);
            };
            // oxlint-disable-next-line react/react-compiler
            itemPressProps.onPress = hasPrimaryAction ? performAction : (e)=>{
                if (e.pointerType !== 'keyboard' && e.pointerType !== 'mouse' && allowsSelection) onSelect(e);
            };
        }
    } else {
        // oxlint-disable-next-line react/react-compiler
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === 'mouse' && !hasPrimaryAction || e.pointerType === 'keyboard' && (!allowsActions || $fadb777ac96b823a$var$$f6ba6936bfd098a0$var$isSelectionKey(e.key)))) onSelect(e);
        };
        // oxlint-disable-next-line react/react-compiler
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === 'touch' || e.pointerType === 'pen' || e.pointerType === 'virtual' || e.pointerType === 'keyboard' && hasAction && $fadb777ac96b823a$var$$f6ba6936bfd098a0$var$isActionKey(e.key) || e.pointerType === 'mouse' && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    let collectionId = (0, $fHcNp.getCollectionId)(manager.collection);
    itemProps['data-collection'] = collectionId;
    itemProps['data-key'] = key;
    // oxlint-disable-next-line react/react-compiler
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    // When using virtual focus, make sure the focused key gets updated on press.
    if (shouldUseVirtualFocus) itemPressProps = (0, $lhKAD.mergeProps)(itemPressProps, {
        onPressStart (e) {
            if (e.pointerType !== 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        },
        onPress (e) {
            if (e.pointerType === 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        }
    });
    if (collectionItemProps) {
        for (let key of [
            'onPressStart',
            'onPressEnd',
            'onPressChange',
            'onPress',
            'onPressUp',
            'onClick'
        ])if (collectionItemProps[key]) itemPressProps[key] = (0, $d8j5I.chain)(itemPressProps[key], collectionItemProps[key]);
    }
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === 'mouse') {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $fFU3w.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === 'touch') {
                onSelect(e);
                manager.setSelectionBehavior('toggle');
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === 'touch' && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = linkBehavior !== 'none' && manager.isLink(key) ? (e)=>{
        if (!(0, $aGgVM.openLink).isOpening) e.preventDefault();
    } : undefined;
    let mergedItemProps = (0, $lhKAD.mergeProps)(itemProps, allowsSelection || hasPrimaryAction || shouldUseVirtualFocus && !isDisabled ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
        onDoubleClick: onDoubleClick,
        onDragStartCapture: onDragStartCapture,
        onClick: onClick,
        id: id
    }, shouldUseVirtualFocus ? {
        onMouseDown: (e)=>e.preventDefault()
    } : undefined);
    // Guard against presses triggering selection when they happen on interactive children or collection items from different collections
    // will need to trigger selection if the target is itself a collection item belonging to the same collection parent (aka a cell in a row) but
    // not if the target is a child of a different collections aka taggroup in table cell.
    let isChildInteraction = (target)=>{
        let el = target;
        while(el && el !== ref.current){
            let elCollection = el.getAttribute('data-collection');
            if (elCollection != null) return elCollection !== collectionId;
            el = el.parentElement;
        }
        return (0, $3OYqT.isTabbable)(target);
    };
    let baseOnPointerDown = mergedItemProps.onPointerDown;
    mergedItemProps.onPointerDown = (e)=>{
        let target = (0, $fvyIQ.getEventTarget)(e);
        if (target && target !== ref.current && isChildInteraction(target)) {
            e.stopPropagation();
            return;
        }
        baseOnPointerDown?.(e);
    };
    let baseOnMouseDown = mergedItemProps.onMouseDown;
    mergedItemProps.onMouseDown = (e)=>{
        let target = (0, $fvyIQ.getEventTarget)(e);
        if (target && target !== ref.current && isChildInteraction(target)) {
            e.stopPropagation();
            return;
        }
        baseOnMouseDown?.(e);
    };
    return {
        itemProps: mergedItemProps,
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $fadb777ac96b823a$var$$f6ba6936bfd098a0$var$isActionKey(key) {
    return key === 'Enter';
}
function $fadb777ac96b823a$var$$f6ba6936bfd098a0$var$isSelectionKey(key) {
    return key === ' ';
}

});
parcelRegister("fFU3w", function(module, exports) {

$parcel$export(module.exports, "useLongPress", () => $f62b4c1d2c1ebd50$export$c24ed0104d07eab9);

var $2jk5s = parcelRequire("2jk5s");

var $7ByPJ = parcelRequire("7ByPJ");

var $lhKAD = parcelRequire("lhKAD");

var $lXRQr = parcelRequire("lXRQr");

var $ed0Y6 = parcelRequire("ed0Y6");

var $bEes0 = parcelRequire("bEes0");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f62b4c1d2c1ebd50$var$$7b01448eaad0fe7c$var$DEFAULT_THRESHOLD = 500;
function $f62b4c1d2c1ebd50$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, pointerType: pointerType, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $f62b4c1d2c1ebd50$var$$7b01448eaad0fe7c$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $eF4cA.useRef)(undefined);
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $ed0Y6.useGlobalListeners)();
    let isAcceptedPointerType = (e)=>pointerType ? e.pointerType === pointerType : e.pointerType === 'mouse' || e.pointerType === 'touch';
    let { pressProps: pressProps } = (0, $bEes0.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (isAcceptedPointerType(e)) {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: 'longpressstart'
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent('pointercancel', {
                        bubbles: true
                    }));
                    // Prevent default click action (e.g. opening a link) after a long press.
                    addGlobalListener(e.target, 'click', (e)=>e.preventDefault(), {
                        once: true
                    });
                    // Ensure target is focused. On touch devices, browsers typically focus on pointer up.
                    if ((0, $7ByPJ.getOwnerDocument)(e.target).activeElement !== e.target) (0, $2jk5s.focusWithoutScrolling)(e.target);
                    if (onLongPress) onLongPress({
                        ...e,
                        type: 'longpress'
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === 'touch') addGlobalListener(e.target, 'contextmenu', (e)=>e.preventDefault(), {
                    once: true
                });
                let ownerWindow = (0, $7ByPJ.getOwnerWindow)(e.target);
                addGlobalListener(ownerWindow, 'pointerup', ()=>{
                    // If no contextmenu/click event is fired quickly after pointerup, remove the handler
                    // so future events outside a long press are not prevented.
                    setTimeout(()=>{
                        removeAllGlobalListeners();
                    }, 100);
                }, {
                    once: true
                });
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && isAcceptedPointerType(e)) onLongPressEnd({
                ...e,
                type: 'longpressend'
            });
        }
    });
    let descriptionProps = (0, $lXRQr.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $lhKAD.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("lXRQr", function(module, exports) {

$parcel$export(module.exports, "useDescription", () => $5f0dc6b3df08800a$export$f8aeda7b10753fa1);

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $5f0dc6b3df08800a$var$$121970af65029459$var$descriptionId = 0;
const $5f0dc6b3df08800a$var$$121970af65029459$var$descriptionNodes = new Map();
function $5f0dc6b3df08800a$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $eF4cA.useState)();
    (0, $4skXn.useLayoutEffect)(()=>{
        if (!description) return;
        let desc = $5f0dc6b3df08800a$var$$121970af65029459$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$5f0dc6b3df08800a$var$$121970af65029459$var$descriptionId++}`;
            setId(id);
            let node = document.createElement('div');
            node.id = id;
            node.style.display = 'none';
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $5f0dc6b3df08800a$var$$121970af65029459$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $5f0dc6b3df08800a$var$$121970af65029459$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        'aria-describedby': description ? id : undefined
    };
}

});



parcelRegister("4vRK0", function(module, exports) {

$parcel$export(module.exports, "getItemCount", () => $756d05caca2e02be$export$77d5aafae4e095b2);

var $f7tr2 = parcelRequire("f7tr2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $756d05caca2e02be$var$$2efe10d3f1f9e31e$var$cache = new WeakMap();
function $756d05caca2e02be$export$77d5aafae4e095b2(collection) {
    let count = $756d05caca2e02be$var$$2efe10d3f1f9e31e$var$cache.get(collection);
    if (count != null) return count;
    // TS isn't smart enough to know we've ensured count is a number, so use a new variable
    let counter = 0;
    let countItems = (items)=>{
        for (let item of items){
            if (item.type === 'section') countItems((0, $f7tr2.getChildNodes)(item, collection));
            else if (item.type === 'item') counter++;
        }
    };
    countItems(collection);
    $756d05caca2e02be$var$$2efe10d3f1f9e31e$var$cache.set(collection, counter);
    return counter;
}

});
parcelRegister("f7tr2", function(module, exports) {

$parcel$export(module.exports, "getChildNodes", () => $40351d8000c0466b$export$1005530eda016c13);
$parcel$export(module.exports, "getFirstItem", () => $40351d8000c0466b$export$fbdeaa6a76694f71);
$parcel$export(module.exports, "getNthItem", () => $40351d8000c0466b$export$5f3398f8733f90e2);
$parcel$export(module.exports, "getLastItem", () => $40351d8000c0466b$export$7475b2c64539e4cf);
$parcel$export(module.exports, "compareNodeOrder", () => $40351d8000c0466b$export$8c434b3a7a4dad6);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $40351d8000c0466b$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === 'function') return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $40351d8000c0466b$export$fbdeaa6a76694f71(iterable) {
    return $40351d8000c0466b$export$5f3398f8733f90e2(iterable, 0);
}
function $40351d8000c0466b$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $40351d8000c0466b$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $40351d8000c0466b$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$40351d8000c0466b$var$$cd5ea4b915021f1d$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$40351d8000c0466b$var$$cd5ea4b915021f1d$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $40351d8000c0466b$var$$cd5ea4b915021f1d$var$getAncestors(collection, node) {
    let parents = [];
    let currNode = node;
    while(currNode?.parentKey != null){
        currNode = collection.getItem(currNode.parentKey);
        if (currNode) parents.unshift(currNode);
    }
    return parents;
}

});



parcelRegister("jcwJg", function(module, exports) {

$parcel$export(module.exports, "useMenuSection", () => $65a1899e12237afd$export$73f7a44322579622);

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $65a1899e12237afd$export$73f7a44322579622(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $25dFS.useId)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

});

parcelRegister("3nhvX", function(module, exports) {

$parcel$export(module.exports, "useMenuTrigger", () => $f2db076896f38042$export$dc9c12ed27dd1b49);

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $gWwpU = parcelRequire("gWwpU");

var $1RejD = parcelRequire("1RejD");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $gI8Gw = parcelRequire("gI8Gw");

var $fFU3w = parcelRequire("fFU3w");

var $kzSDh = parcelRequire("kzSDh");

var $eF4cA = parcelRequire("eF4cA");
function $f2db076896f38042$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f2db076896f38042$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = 'menu', isDisabled: isDisabled, trigger: trigger = 'press' } = props;
    let menuTriggerId = (0, $25dFS.useId)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $kzSDh.useOverlayTrigger)({
        type: type
    }, state, ref);
    let open = (shouldOpen, e, focusStrategy = 'first')=>{
        if (!shouldOpen || e.isDefaultPrevented()) return false;
        state.toggle(focusStrategy);
    };
    // React puts listeners on the same root, so even if propagation was stopped, immediate propagation is still possible.
    // useTypeSelect will handle the spacebar first if it's running, so we don't want to open if it's handled it already.
    // We use isDefaultPrevented() instead of isPropagationStopped() because createEventHandler stops propagation by default.
    // And default prevented means that the event was handled by something else (typeahead), so we don't want to open the menu.
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        isDisabled: isDisabled,
        shortcuts: {
            Enter: (e)=>{
                return open(trigger !== 'longPress', e, 'first');
            },
            ' ': (e)=>{
                return open(trigger !== 'longPress', e, 'first');
            },
            ArrowDown: (e)=>{
                return open(trigger !== 'longPress', e, 'first');
            },
            ArrowUp: (e)=>{
                return open(trigger !== 'longPress', e, 'last');
            },
            'Alt+Enter': (e)=>{
                return open(trigger === 'longPress', e, 'first');
            },
            'Alt+ ': (e)=>{
                return open(trigger === 'longPress', e, 'first');
            },
            // Alt+Arrow* must open for both trigger modes: for `press` it matches the same `e.key` cases as
            // plain Arrow*; for `longPress`, plain arrows are ignored elsewhere and Alt+Arrow is the opener
            // (see legacy `if (trigger === 'longPress' && !e.altKey) return` before the ArrowDown/Up switch).
            'Alt+ArrowDown': (e)=>{
                return open(true, e, 'first');
            },
            'Alt+ArrowUp': (e)=>{
                return open(true, e, 'last');
            }
        }
    });
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($f2db076896f38042$var$$parcel$interopDefault((0, $gWwpU.default)), '@react-aria/menu');
    let { longPressProps: longPressProps } = (0, $fFU3w.useLongPress)({
        isDisabled: isDisabled || trigger !== 'longPress',
        accessibilityDescription: stringFormatter.format('longPressMessage'),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open('first');
        }
    });
    let pressProps = {
        preventFocusOnPress: true,
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) {
                (0, $2jk5s.focusWithoutScrolling)(e.target);
                // If opened with a screen reader, auto focus the first item.
                // Otherwise, the menu itself will be focused.
                state.open(e.pointerType === 'virtual' ? 'first' : null);
            }
        },
        onPress (e) {
            if (e.pointerType === 'touch' && !isDisabled) {
                (0, $2jk5s.focusWithoutScrolling)(e.target);
                state.toggle();
            }
        }
    };
    // omit onPress from triggerProps since we override it above.
    // oxlint-disable-next-line react/react-compiler
    delete triggerProps.onPress;
    let { contextMenuProps: contextMenuProps } = (0, $1RejD.useContextMenu)({
        onContextMenu (e) {
            // This is not a DOM event, so the linter is incorrect.
            // eslint-disable-next-line rsp-rules/safe-event-target
            let rect = e.target.getBoundingClientRect();
            state.setPoint({
                x: rect.x + e.x,
                y: rect.y + e.y
            });
            state.open();
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        // Close context menus when right clicking outside. The browser's context menu will appear instead.
        if (state.isOpen && trigger === 'contextMenu') {
            let onContextMenu = (e)=>{
                // Checking if the target is the body works because everything outside the menu is inert.
                if ((e.button === 2 || e.button === 0 && e.ctrlKey === true) && (0, $fvyIQ.getEventTarget)(e) === document.body) state.close();
            };
            document.addEventListener('mousedown', onContextMenu);
            return ()=>document.removeEventListener('mousedown', onContextMenu);
        }
    }, [
        state,
        trigger
    ]);
    let interactionProps;
    if (trigger === 'press') interactionProps = {
        ...pressProps,
        ...keyboardProps
    };
    else if (trigger === 'longPress') interactionProps = {
        ...longPressProps,
        ...keyboardProps
    };
    else if (trigger === 'contextMenu') {
        interactionProps = contextMenuProps;
        // Remove aria-haspopup and associated attributes from context menu triggers.
        // aria-haspopup indicates that the trigger opens a menu on activation (i.e. click/Enter),
        // which is not the case for context menus, so this would lead to confusing announcements.
        // Context menus are equally discoverable (or not) by sighted and non-sighted users,
        // so we don't need a screen reader specific announcement.
        // See https://github.com/w3c/aria/issues/1971 for further discussion.
        let { 'aria-haspopup': _a, 'aria-expanded': _b, 'aria-controls': _c, ...rest } = triggerProps;
        triggerProps = rest;
    }
    return {
        // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
        menuTriggerProps: {
            ...triggerProps,
            ...interactionProps,
            id: menuTriggerId
        },
        menuProps: {
            ...overlayProps,
            'aria-labelledby': menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}

});
parcelRegister("gWwpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $60aa23d2a4d16cad$export$2e2bcd8739ae039);

var $csMzz = parcelRequire("csMzz");

var $csoRU = parcelRequire("csoRU");

var $2HOXG = parcelRequire("2HOXG");

var $h0Ra4 = parcelRequire("h0Ra4");

var $6Ubk3 = parcelRequire("6Ubk3");

var $4zzd0 = parcelRequire("4zzd0");

var $kKVGG = parcelRequire("kKVGG");

var $91VSb = parcelRequire("91VSb");

var $dfx8Y = parcelRequire("dfx8Y");

var $laXNL = parcelRequire("laXNL");

var $7e8dh = parcelRequire("7e8dh");

var $80Sx5 = parcelRequire("80Sx5");

var $gka6u = parcelRequire("gka6u");

var $7Qqn1 = parcelRequire("7Qqn1");

var $jyvc6 = parcelRequire("jyvc6");

var $lom5a = parcelRequire("lom5a");

var $2sxKK = parcelRequire("2sxKK");

var $kwn7M = parcelRequire("kwn7M");

var $fkrUn = parcelRequire("fkrUn");

var $17ZkT = parcelRequire("17ZkT");

var $jhUrN = parcelRequire("jhUrN");

var $2tLuy = parcelRequire("2tLuy");

var $a7a3z = parcelRequire("a7a3z");

var $1bPvd = parcelRequire("1bPvd");

var $7I1kh = parcelRequire("7I1kh");

var $8Fpsr = parcelRequire("8Fpsr");

var $kOAj0 = parcelRequire("kOAj0");

var $72f9o = parcelRequire("72f9o");

var $k6Kwj = parcelRequire("k6Kwj");

var $jFrHE = parcelRequire("jFrHE");

var $hDHMZ = parcelRequire("hDHMZ");

var $8uoIB = parcelRequire("8uoIB");

var $kBFNu = parcelRequire("kBFNu");

var $2qkrc = parcelRequire("2qkrc");
var $60aa23d2a4d16cad$export$2e2bcd8739ae039 = {};
$60aa23d2a4d16cad$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $csMzz.default),
    "bg-BG": (0, $csoRU.default),
    "cs-CZ": (0, $2HOXG.default),
    "da-DK": (0, $h0Ra4.default),
    "de-DE": (0, $6Ubk3.default),
    "el-GR": (0, $4zzd0.default),
    "en-US": (0, $kKVGG.default),
    "es-ES": (0, $91VSb.default),
    "et-EE": (0, $dfx8Y.default),
    "fi-FI": (0, $laXNL.default),
    "fr-FR": (0, $7e8dh.default),
    "he-IL": (0, $80Sx5.default),
    "hr-HR": (0, $gka6u.default),
    "hu-HU": (0, $7Qqn1.default),
    "it-IT": (0, $jyvc6.default),
    "ja-JP": (0, $lom5a.default),
    "ko-KR": (0, $2sxKK.default),
    "lt-LT": (0, $kwn7M.default),
    "lv-LV": (0, $fkrUn.default),
    "nb-NO": (0, $17ZkT.default),
    "nl-NL": (0, $jhUrN.default),
    "pl-PL": (0, $2tLuy.default),
    "pt-BR": (0, $a7a3z.default),
    "pt-PT": (0, $1bPvd.default),
    "ro-RO": (0, $7I1kh.default),
    "ru-RU": (0, $8Fpsr.default),
    "sk-SK": (0, $kOAj0.default),
    "sl-SI": (0, $72f9o.default),
    "sr-SP": (0, $k6Kwj.default),
    "sv-SE": (0, $jFrHE.default),
    "tr-TR": (0, $hDHMZ.default),
    "uk-UA": (0, $8uoIB.default),
    "zh-CN": (0, $kBFNu.default),
    "zh-TW": (0, $2qkrc.default)
};

});
parcelRegister("csMzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $331e123f8f601a5c$export$2e2bcd8739ae039);
var $331e123f8f601a5c$export$2e2bcd8739ae039 = {};
$331e123f8f601a5c$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};

});

parcelRegister("csoRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f6b88f26fe16cfd$export$2e2bcd8739ae039);
var $8f6b88f26fe16cfd$export$2e2bcd8739ae039 = {};
$8f6b88f26fe16cfd$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};

});

parcelRegister("2HOXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $342dabe883ef86bb$export$2e2bcd8739ae039);
var $342dabe883ef86bb$export$2e2bcd8739ae039 = {};
$342dabe883ef86bb$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};

});

parcelRegister("h0Ra4", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde956547e61ecc5$export$2e2bcd8739ae039);
var $dde956547e61ecc5$export$2e2bcd8739ae039 = {};
$dde956547e61ecc5$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};

});

parcelRegister("6Ubk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b141022a50eb83b$export$2e2bcd8739ae039);
var $3b141022a50eb83b$export$2e2bcd8739ae039 = {};
$3b141022a50eb83b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};

});

parcelRegister("4zzd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ff6e46c94d9d9ef$export$2e2bcd8739ae039);
var $7ff6e46c94d9d9ef$export$2e2bcd8739ae039 = {};
$7ff6e46c94d9d9ef$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};

});

parcelRegister("kKVGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c1a2c6415124cf$export$2e2bcd8739ae039);
var $93c1a2c6415124cf$export$2e2bcd8739ae039 = {};
$93c1a2c6415124cf$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};

});

parcelRegister("91VSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $83a8dc54d6908b0e$export$2e2bcd8739ae039);
var $83a8dc54d6908b0e$export$2e2bcd8739ae039 = {};
$83a8dc54d6908b0e$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};

});

parcelRegister("dfx8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1cd251b6fdd1d26$export$2e2bcd8739ae039);
var $a1cd251b6fdd1d26$export$2e2bcd8739ae039 = {};
$a1cd251b6fdd1d26$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};

});

parcelRegister("laXNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f15960fe93e0a4c$export$2e2bcd8739ae039);
var $8f15960fe93e0a4c$export$2e2bcd8739ae039 = {};
$8f15960fe93e0a4c$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};

});

parcelRegister("7e8dh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc53ccf9d583d85$export$2e2bcd8739ae039);
var $3dc53ccf9d583d85$export$2e2bcd8739ae039 = {};
$3dc53ccf9d583d85$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};

});

parcelRegister("80Sx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a2be39bb0741ed$export$2e2bcd8739ae039);
var $f8a2be39bb0741ed$export$2e2bcd8739ae039 = {};
$f8a2be39bb0741ed$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};

});

parcelRegister("gka6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d92cce5210156c2$export$2e2bcd8739ae039);
var $6d92cce5210156c2$export$2e2bcd8739ae039 = {};
$6d92cce5210156c2$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};

});

parcelRegister("7Qqn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $691a4dcab22cedcf$export$2e2bcd8739ae039);
var $691a4dcab22cedcf$export$2e2bcd8739ae039 = {};
$691a4dcab22cedcf$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};

});

parcelRegister("jyvc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddab9268ef9e03e6$export$2e2bcd8739ae039);
var $ddab9268ef9e03e6$export$2e2bcd8739ae039 = {};
$ddab9268ef9e03e6$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premi a lungo o premi Alt + Freccia gi\xf9 per aprire il menu`
};

});

parcelRegister("lom5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0953ef7b4096d97$export$2e2bcd8739ae039);
var $d0953ef7b4096d97$export$2e2bcd8739ae039 = {};
$d0953ef7b4096d97$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};

});

parcelRegister("2sxKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $da86a392c54592c4$export$2e2bcd8739ae039);
var $da86a392c54592c4$export$2e2bcd8739ae039 = {};
$da86a392c54592c4$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};

});

parcelRegister("kwn7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $8143d1c4d1054bf7$export$2e2bcd8739ae039);
var $8143d1c4d1054bf7$export$2e2bcd8739ae039 = {};
$8143d1c4d1054bf7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};

});

parcelRegister("fkrUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $486aa4737cc1efa3$export$2e2bcd8739ae039);
var $486aa4737cc1efa3$export$2e2bcd8739ae039 = {};
$486aa4737cc1efa3$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};

});

parcelRegister("17ZkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1b431ac43ae2045$export$2e2bcd8739ae039);
var $f1b431ac43ae2045$export$2e2bcd8739ae039 = {};
$f1b431ac43ae2045$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};

});

parcelRegister("jhUrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe6e065ddd4dddb$export$2e2bcd8739ae039);
var $dbe6e065ddd4dddb$export$2e2bcd8739ae039 = {};
$dbe6e065ddd4dddb$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};

});

parcelRegister("2tLuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdc0a104eae6b21$export$2e2bcd8739ae039);
var $dfdc0a104eae6b21$export$2e2bcd8739ae039 = {};
$dfdc0a104eae6b21$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};

});

parcelRegister("a7a3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc391f26e95acaca$export$2e2bcd8739ae039);
var $fc391f26e95acaca$export$2e2bcd8739ae039 = {};
$fc391f26e95acaca$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};

});

parcelRegister("1bPvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $68cf61baa95382ec$export$2e2bcd8739ae039);
var $68cf61baa95382ec$export$2e2bcd8739ae039 = {};
$68cf61baa95382ec$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};

});

parcelRegister("7I1kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b6dfec268d4d1b$export$2e2bcd8739ae039);
var $86b6dfec268d4d1b$export$2e2bcd8739ae039 = {};
$86b6dfec268d4d1b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};

});

parcelRegister("8Fpsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae08b085d900f46$export$2e2bcd8739ae039);
var $bae08b085d900f46$export$2e2bcd8739ae039 = {};
$bae08b085d900f46$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("kOAj0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f03823d35f0694e$export$2e2bcd8739ae039);
var $9f03823d35f0694e$export$2e2bcd8739ae039 = {};
$9f03823d35f0694e$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};

});

parcelRegister("72f9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c533ce5e8a3537$export$2e2bcd8739ae039);
var $20c533ce5e8a3537$export$2e2bcd8739ae039 = {};
$20c533ce5e8a3537$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};

});

parcelRegister("k6Kwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9442cdeac076f2b6$export$2e2bcd8739ae039);
var $9442cdeac076f2b6$export$2e2bcd8739ae039 = {};
$9442cdeac076f2b6$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};

});

parcelRegister("jFrHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b43973a68bf27f41$export$2e2bcd8739ae039);
var $b43973a68bf27f41$export$2e2bcd8739ae039 = {};
$b43973a68bf27f41$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};

});

parcelRegister("hDHMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8600d135b2ac1126$export$2e2bcd8739ae039);
var $8600d135b2ac1126$export$2e2bcd8739ae039 = {};
$8600d135b2ac1126$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};

});

parcelRegister("8uoIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47c6be271d5ec94$export$2e2bcd8739ae039);
var $f47c6be271d5ec94$export$2e2bcd8739ae039 = {};
$f47c6be271d5ec94$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("kBFNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b240bcf9df04340$export$2e2bcd8739ae039);
var $5b240bcf9df04340$export$2e2bcd8739ae039 = {};
$5b240bcf9df04340$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};

});

parcelRegister("2qkrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8d0df589aead1e$export$2e2bcd8739ae039);
var $4d8d0df589aead1e$export$2e2bcd8739ae039 = {};
$4d8d0df589aead1e$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};

});


parcelRegister("1RejD", function(module, exports) {

$parcel$export(module.exports, "useContextMenu", () => $309797b8a4d517a7$export$2464060fb1e12fa6);

var $11FxZ = parcelRequire("11FxZ");

var $lhKAD = parcelRequire("lhKAD");

var $fFU3w = parcelRequire("fFU3w");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $309797b8a4d517a7$export$2464060fb1e12fa6(props) {
    // How to trigger context menu events on various platforms:
    // - macOS
    //   - Mouse right click
    //   - Control + click
    //   - Control + Enter (does not fire the contextmenu event in certain WebKit / Chrome versions - https://bugs.webkit.org/show_bug.cgi?id=302049, https://issues.chromium.org/issues/369897039)
    //   - Control + Option + Shift + M with VoiceOver
    // - Windows / Linux
    //   - Mouse right click
    //   - Shift + F10
    //   - Long press on a touch screen
    // - iOS
    //   - Long press (does not fire contextmenu event - https://bugs.webkit.org/show_bug.cgi?id=213953)
    // - Android
    //   - Long press
    let { onContextMenu: onContextMenu } = props;
    let firedContextMenuEvent = (0, $eF4cA.useRef)(false);
    // iOS does not fire the contextmenu event, so use long press.
    let { longPressProps: longPressProps } = (0, $fFU3w.useLongPress)({
        onLongPressStart () {
            firedContextMenuEvent.current = false;
        },
        onLongPress (e) {
            if (!firedContextMenuEvent.current) onContextMenu?.({
                target: e.target,
                x: e.x,
                y: e.y
            });
            else firedContextMenuEvent.current = false;
        }
    });
    if (!onContextMenu) return {
        contextMenuProps: {}
    };
    return {
        // oxlint-disable-next-line react/react-compiler - it says we are reading a ref during render but that's not true...
        contextMenuProps: (0, $lhKAD.mergeProps)((0, $11FxZ.isIOS)() ? longPressProps : {}, {
            onContextMenu (e) {
                e.stopPropagation();
                e.preventDefault();
                firedContextMenuEvent.current = true;
                let rect = e.currentTarget.getBoundingClientRect();
                onContextMenu({
                    target: e.currentTarget,
                    x: e.clientX - rect.x,
                    y: e.clientY - rect.y
                });
            },
            onKeyDown (e) {
                // macOS has a default keyboard shortcut to show the contextmenu: Ctrl + Enter.
                // However, some versions of Safari and Chrome do not trigger the contextmenu event.
                // Fixed in https://github.com/WebKit/WebKit/pull/62278 (currently in WekKit nightly) and
                // https://github.com/chromium/chromium/commit/268c876c191cd4712c2d1043aab9760fb71d9be5 (Chrome 147).
                // Remove this workaround once those are broadly available.
                // An additional bug still occurs when the target has a border-radius: https://bugs.webkit.org/show_bug.cgi?id=317496
                if ((0, $11FxZ.isMac)()) {
                    if (e.ctrlKey && e.key === 'Enter') {
                        firedContextMenuEvent.current = false;
                        let target = e.currentTarget;
                        e.stopPropagation();
                        setTimeout(()=>{
                            if (!firedContextMenuEvent.current) {
                                let rect = target.getBoundingClientRect();
                                onContextMenu({
                                    target: target,
                                    x: rect.width / 2,
                                    y: rect.height / 2
                                });
                            } else firedContextMenuEvent.current = false;
                        }, 10);
                    }
                }
            }
        })
    };
}

});

parcelRegister("kzSDh", function(module, exports) {

$parcel$export(module.exports, "useOverlayTrigger", () => $e53398b48d859996$export$f9d5c8beee7d008d);

var $d8twi = parcelRequire("d8twi");

var $25dFS = parcelRequire("25dFS");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e53398b48d859996$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $eF4cA.useEffect)(()=>{
        if (ref && ref.current) (0, $d8twi.onCloseMap).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    let overlayId = (0, $25dFS.useId)();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : undefined,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}

});


parcelRegister("51tBd", function(module, exports) {

$parcel$export(module.exports, "useSubmenuTrigger", () => $8ed7ba6479739803$export$7138b0d059a6e743);

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $58OnM = parcelRequire("58OnM");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $diCpw = parcelRequire("diCpw");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8ed7ba6479739803$export$7138b0d059a6e743(props, state, ref) {
    let { parentMenuRef: parentMenuRef, submenuRef: submenuRef, type: type = 'menu', isDisabled: isDisabled, delay: delay = 200, shouldUseVirtualFocus: shouldUseVirtualFocus } = props;
    let submenuTriggerId = (0, $25dFS.useId)();
    let overlayId = (0, $25dFS.useId)();
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let openTimeout = (0, $eF4cA.useRef)(undefined);
    let cancelOpenTimeout = (0, $eF4cA.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, $eF4cA.useCallback)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    }, [
        state,
        cancelOpenTimeout
    ]);
    let onSubmenuClose = (0, $eF4cA.useCallback)(()=>{
        cancelOpenTimeout();
        state.close();
    }, [
        state,
        cancelOpenTimeout
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ArrowLeft: (e)=>{
                // If focus is not within the menu, assume virtual focus is being used.
                // This means some other input element is also within the popover, so we shouldn't close the menu.
                if (!(0, $fvyIQ.isFocusWithin)(e.currentTarget)) return false;
                if (direction === 'ltr' && (0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) {
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $2jk5s.focusWithoutScrolling)(ref.current);
                    return;
                }
                return false;
            },
            ArrowRight: (e)=>{
                if (!(0, $fvyIQ.isFocusWithin)(e.currentTarget)) return false;
                if (direction === 'rtl' && (0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) {
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $2jk5s.focusWithoutScrolling)(ref.current);
                    return;
                }
                return false;
            },
            Escape: (e)=>{
                if (!(0, $fvyIQ.isFocusWithin)(e.currentTarget)) return false;
                if ((0, $fvyIQ.nodeContains)(submenuRef.current, (0, $fvyIQ.getEventTarget)(e))) {
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $2jk5s.focusWithoutScrolling)(ref.current);
                    return;
                }
                return false;
            }
        }
    });
    let submenuProps = {
        id: overlayId,
        'aria-labelledby': submenuTriggerId,
        submenuLevel: state.submenuLevel,
        ...type === 'menu' && {
            onClose: state.closeAll,
            autoFocus: state.focusStrategy ?? undefined,
            ...keyboardProps
        }
    };
    let { keyboardProps: submenuTriggerKeyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ArrowRight: ()=>{
                if (!isDisabled) {
                    if (direction === 'ltr') {
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!submenuRef?.current && (0, $fvyIQ.getActiveElement)() === ref?.current) (0, $2jk5s.focusWithoutScrolling)(submenuRef.current);
                        return;
                    } else if (state.isOpen) {
                        onSubmenuClose();
                        return;
                    } else return false;
                }
                return false;
            },
            ArrowLeft: ()=>{
                if (!isDisabled) {
                    if (direction === 'rtl') {
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!submenuRef?.current && (0, $fvyIQ.getActiveElement)() === ref?.current) (0, $2jk5s.focusWithoutScrolling)(submenuRef.current);
                        return;
                    } else if (state.isOpen) {
                        onSubmenuClose();
                        return;
                    } else return false;
                }
                return false;
            }
        }
    });
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === 'virtual' || e.pointerType === 'keyboard')) onSubmenuOpen('first');
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === 'touch' || e.pointerType === 'mouse')) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    (0, $58OnM.useEvent)(parentMenuRef, 'focusin', (e)=>{
        // If we detect focus moved to a different item in the same menu that the currently open submenu trigger is in
        // then close the submenu. This is for a case where the user hovers a root menu item when multiple submenus are open
        if (state.isOpen && (0, $fvyIQ.nodeContains)(parentMenuRef.current, (0, $fvyIQ.getEventTarget)(e)) && (0, $fvyIQ.getEventTarget)(e) !== ref.current) onSubmenuClose();
    });
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    (0, $diCpw.useSafelyMouseToSubmenu)({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            onKeyDown: submenuTriggerKeyboardProps.onKeyDown,
            onKeyUp: submenuTriggerKeyboardProps.onKeyUp,
            id: submenuTriggerId,
            'aria-controls': state.isOpen ? overlayId : undefined,
            'aria-haspopup': !isDisabled ? type : undefined,
            'aria-expanded': state.isOpen ? 'true' : 'false',
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}

});
parcelRegister("diCpw", function(module, exports) {

$parcel$export(module.exports, "useSafelyMouseToSubmenu", () => $82a7b7202f6a6305$export$85ec83e04c95f50a);

var $fvyIQ = parcelRequire("fvyIQ");

var $4lMDe = parcelRequire("4lMDe");

var $YxOvP = parcelRequire("YxOvP");

var $4skXn = parcelRequire("4skXn");

var $f9wnx = parcelRequire("f9wnx");

var $eF4cA = parcelRequire("eF4cA");
const $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS = 2;
const $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$THROTTLE_TIME = 50;
const $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$TIMEOUT_TIME = 1000;
const $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $82a7b7202f6a6305$export$85ec83e04c95f50a(options) {
    let { menuRef: menuRef, submenuRef: submenuRef, isOpen: isOpen, isDisabled: isDisabled } = options;
    let prevPointerPos = (0, $eF4cA.useRef)(undefined);
    let submenuRect = (0, $eF4cA.useRef)(undefined);
    let lastProcessedTime = (0, $eF4cA.useRef)(0);
    let timeout = (0, $eF4cA.useRef)(undefined);
    let autoCloseTimeout = (0, $eF4cA.useRef)(undefined);
    let submenuSide = (0, $eF4cA.useRef)(undefined);
    let movementsTowardsSubmenuCount = (0, $eF4cA.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, $eF4cA.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $f9wnx.useResizeObserver)({
        ref: isOpen ? submenuRef : undefined,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS;
        prevPointerPos.current = undefined;
    };
    let modality = (0, $YxOvP.useInteractionModality)();
    // Prevent mouse down over safe triangle. Clicking while pointer-events: none is applied
    // will cause focus to move unexpectedly since it will go to an element behind the menu.
    let onPointerDown = (0, $4lMDe.useEffectEvent)((e)=>{
        if (preventPointerEvents) e.preventDefault();
    });
    (0, $eF4cA.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = 'none';
        else menuRef.current.style.pointerEvents = '';
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== 'pointer' || !menu) {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? 'left' : 'right';
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === 'right' ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === 'left' ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && (0, $fvyIQ.nodeContains)(menu, target)) target.dispatchEvent(new PointerEvent('pointerover', {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$TIMEOUT_TIME);
        };
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerdown', onPointerDown, true);
        return ()=>{
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerdown', onPointerDown, true);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $82a7b7202f6a6305$var$$eac5d44fa99b2e3b$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}

});


parcelRegister("2esle", function(module, exports) {

$parcel$export(module.exports, "useMenuTriggerState", () => $fa01d573694ce127$export$79fefeb1c2091ac3);

var $lIr3v = parcelRequire("lIr3v");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fa01d573694ce127$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $lIr3v.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, $eF4cA.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $eF4cA.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        expandedKeysStack: expandedKeysStack,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    };
}

});

parcelRegister("4zDYv", function(module, exports) {

$parcel$export(module.exports, "useSubmenuTriggerState", () => $87cdfa0a4743171c$export$cfc51cf86138bf98);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $87cdfa0a4743171c$export$cfc51cf86138bf98(props, state) {
    let { triggerKey: triggerKey } = props;
    let { expandedKeysStack: expandedKeysStack, openSubmenu: openSubmenu, closeSubmenu: closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, $eF4cA.useState)(expandedKeysStack?.length);
    let isOpen = (0, $eF4cA.useMemo)(()=>expandedKeysStack[submenuLevel] === triggerKey, [
        expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, $eF4cA.useState)(null);
    let open = (0, $eF4cA.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy ?? null);
        openSubmenu(triggerKey, submenuLevel);
    }, [
        openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, $eF4cA.useCallback)(()=>{
        setFocusStrategy(null);
        closeSubmenu(triggerKey, submenuLevel);
    }, [
        closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, $eF4cA.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy ?? null);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle: toggle,
            point: null,
            setPoint: ()=>{}
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}

});

parcelRegister("lJdzA", function(module, exports) {

$parcel$export(module.exports, "useLoadMoreSentinel", () => $b1410bf9173c5222$export$ccaea96c28e8b9e7);

var $5AGOf = parcelRequire("5AGOf");

var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b1410bf9173c5222$export$ccaea96c28e8b9e7(props, ref) {
    let { collection: collection, onLoadMore: onLoadMore, scrollOffset: scrollOffset = 1, direction: direction = 'end' } = props;
    let sentinelObserver = (0, $eF4cA.useRef)(null);
    let triggerLoadMore = (0, $4lMDe.useEffectEvent)((entries)=>{
        // Use "isIntersecting" over an equality check of 0 since it seems like there is cases where
        // a intersection ratio of 0 can be reported when isIntersecting is actually true
        for (let entry of entries)// Up to user discretion as to how to handle these multiple onLoadMore calls
        if (entry.isIntersecting && onLoadMore) onLoadMore();
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        if (ref.current) {
            // Tear down and set up a new IntersectionObserver when the collection changes so that we can properly trigger additional loadMores if there is room for more items
            // Need to do this tear down and set up since using a large rootMargin will mean the observer's callback isn't called even when scrolling the item into view beause its visibility hasn't actually changed
            // https://codesandbox.io/p/sandbox/magical-swanson-dhgp89?file=%2Fsrc%2FApp.js%3A21%2C21
            const margin = 100 * scrollOffset;
            // For direction='start', right/left margins have no affect for vertical scroll containers. We are not supporting reverse horizontal scroll containers for now.
            const rootMargin = direction === 'start' ? `${margin}% 0px 0px 0px` : `0px ${margin}% ${margin}% ${margin}%`;
            sentinelObserver.current = new IntersectionObserver(triggerLoadMore, {
                root: (0, $5AGOf.getScrollParent)(ref?.current),
                rootMargin: rootMargin
            });
            sentinelObserver.current.observe(ref.current);
        }
        return ()=>{
            if (sentinelObserver.current) sentinelObserver.current.disconnect();
        };
    }, [
        collection,
        ref,
        scrollOffset,
        direction
    ]);
}

});

parcelRegister("dWVHy", function(module, exports) {

$parcel$export(module.exports, "SelectionManager", () => $78b254d147433a91$export$6c8a5aaad13c9852);

var $f7tr2 = parcelRequire("f7tr2");

var $cZV1R = parcelRequire("cZV1R");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $78b254d147433a91$export$6c8a5aaad13c9852 {
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        this.allowsCellSelection = options?.allowsCellSelection ?? false;
        this._isSelectAll = null;
        this.layoutDelegate = options?.layoutDelegate || null;
        this.fullCollection = options?.fullCollection || null;
    }
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === 'none') return false;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return false;
        return this.state.selectedKeys === 'all' ? this.canSelectItem(mappedKey) : this.state.selectedKeys.has(mappedKey);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === 'all') return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $f7tr2.compareNodeOrder)(this.collection, item, first) < 0) first = item;
        }
        return first?.key ?? null;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $f7tr2.compareNodeOrder)(this.collection, item, last) > 0) last = item;
        }
        return last?.key ?? null;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            this.replaceSelection(toKey);
            return;
        }
        let mappedToKey = this.getKey(toKey);
        if (mappedToKey == null) return;
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === 'all') selection = new (0, $cZV1R.Selection)([
            mappedToKey
        ], mappedToKey, mappedToKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey ?? mappedToKey;
            selection = new (0, $cZV1R.Selection)(selectedKeys, anchorKey, mappedToKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey ?? mappedToKey))selection.delete(key);
            for (let key of this.getKeyRange(mappedToKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $f7tr2.compareNodeOrder)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(from, to);
        let keys = [];
        let key = from;
        while(key != null){
            let item = this.collection.getItem(key);
            if (item && (item.type === 'item' || item.type === 'cell' && this.allowsCellSelection)) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === 'cell' && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item && item.type !== 'item' && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== 'item') return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single' && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let keys = new (0, $cZV1R.Selection)(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(mappedKey)) keys.delete(mappedKey);
        else if (this.canSelectItem(mappedKey)) {
            keys.add(mappedKey);
            keys.anchorKey = mappedKey;
            keys.currentKey = mappedKey;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === 'none') return;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let selection = this.canSelectItem(mappedKey) ? new (0, $cZV1R.Selection)([
            mappedKey
        ], mappedKey, mappedKey) : new (0, $cZV1R.Selection)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === 'none') return;
        let selection = new (0, $cZV1R.Selection)();
        for (let key of keys){
            let mappedKey = this.getKey(key);
            if (mappedKey != null) {
                selection.add(mappedKey);
                if (this.selectionMode === 'single') break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        // Use the full (unfiltered) collection when available so that materializing
        // the 'all' selection includes items that are currently filtered out (e.g. by Autocomplete).
        let collection = this.fullCollection ?? this.collection;
        let keys = [];
        let addKeys = (key)=>{
            while(key != null){
                if (this.canSelectItemIn(key, collection)) {
                    let item = collection.getItem(key);
                    if (item?.type === 'item') keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item?.hasChildNodes && (this.allowsCellSelection || item.type !== 'item')) addKeys((0, $f7tr2.getFirstItem)((0, $f7tr2.getChildNodes)(item, collection))?.key ?? null);
                }
                key = collection.getKeyAfter(key);
            }
        };
        addKeys(collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $cZV1R.Selection)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual')) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        return this.canSelectItemIn(key, this.collection);
    }
    canSelectItemIn(key, collection) {
        if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
        let item = collection.getItem(key);
        if (!item || item?.props?.isDisabled || item.type === 'cell' && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        let item = this.collection.getItem(key);
        return this.state.disabledBehavior === 'all' && (this.state.disabledKeys.has(key) || !!item?.props?.isDisabled) && item?.props?.disabledBehavior !== 'selection';
    }
    isLink(key) {
        return !!this.collection.getItem(key)?.props?.href;
    }
    getItemProps(key) {
        return this.collection.getItem(key)?.props;
    }
    withCollection(collection) {
        return new $78b254d147433a91$export$6c8a5aaad13c9852(collection, this.state, {
            allowsCellSelection: this.allowsCellSelection,
            layoutDelegate: this.layoutDelegate || undefined,
            fullCollection: this.fullCollection ?? this.collection
        });
    }
}

});
parcelRegister("cZV1R", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $af5523bbd244a1bf$export$52baac22726c72bf);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $af5523bbd244a1bf$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $af5523bbd244a1bf$export$52baac22726c72bf) {
            this.anchorKey = anchorKey ?? keys.anchorKey;
            this.currentKey = currentKey ?? keys.currentKey;
        } else {
            this.anchorKey = anchorKey ?? null;
            this.currentKey = currentKey ?? null;
        }
    }
}

});


parcelRegister("8muBU", function(module, exports) {

$parcel$export(module.exports, "useTreeState", () => $d8510bb2ca045127$export$728d6ba534403756);

var $dWVHy = parcelRequire("dWVHy");

var $dekH2 = parcelRequire("dekH2");

var $94DDV = parcelRequire("94DDV");

var $iUErx = parcelRequire("iUErx");

var $fAqsC = parcelRequire("fAqsC");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d8510bb2ca045127$export$728d6ba534403756(props) {
    let { onExpandedChange: onExpandedChange } = props;
    let [expandedKeys, setExpandedKeys] = (0, $iUErx.useControlledState)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), onExpandedChange);
    let selectionState = (0, $fAqsC.useMultipleSelectionState)(props);
    let disabledKeys = (0, $eF4cA.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $94DDV.useCollection)(props, (0, $eF4cA.useCallback)((nodes)=>new (0, $dekH2.TreeCollection)(nodes, {
            expandedKeys: expandedKeys
        }), [
        expandedKeys
    ]), null);
    (0, $eF4cA.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($d8510bb2ca045127$var$$6b915bde6cd300dd$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $dWVHy.SelectionManager)(tree, selectionState)
    };
}
function $d8510bb2ca045127$var$$6b915bde6cd300dd$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}

});
parcelRegister("dekH2", function(module, exports) {

$parcel$export(module.exports, "TreeCollection", () => $d6dfc454336937cd$export$863faf230ee2118a);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $d6dfc454336937cd$export$863faf230ee2118a {
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === 'section' || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last?.key ?? null;
    }
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey ?? null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey ?? null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
}

});

parcelRegister("94DDV", function(module, exports) {

$parcel$export(module.exports, "useCollection", () => $29d4d0ea637a6031$export$6cd28814d92fa9c9);

var $2Bb6h = parcelRequire("2Bb6h");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $29d4d0ea637a6031$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $eF4cA.useMemo)(()=>new (0, $2Bb6h.CollectionBuilder)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $eF4cA.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}

});
parcelRegister("2Bb6h", function(module, exports) {

$parcel$export(module.exports, "CollectionBuilder", () => $94e011eaa4273865$export$bf788dd355e3a401);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $94e011eaa4273865$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $94e011eaa4273865$var$$bda7a7e55e1ff206$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).isValidElement(children) && children.type === (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment) yield* this.iterateCollection({
            children: children.props.children,
            items: items
        });
        else if (typeof children === 'function') {
            if (!items) throw new Error('props.children was a function but props.items is missing');
            let index = 0;
            for (let item of items){
                yield* this.getFullNode({
                    value: item,
                    index: index
                }, {
                    renderer: children
                });
                index++;
            }
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.forEach(children, (child)=>{
                if (child) items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === 'cell' && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            let key = v.key ?? v.id;
            if (key == null) throw new Error('No key found for item');
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).isValidElement(partialNode.element) && partialNode.element.type === (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment) {
            let children = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.forEach(partialNode.element.props.children, (child)=>{
                children.push(child);
            });
            let index = partialNode.index ?? 0;
            for (const child of children)yield* this.getFullNode({
                element: child,
                index: index++
            }, state, parentKey, parentNode);
            return;
        }
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== 'function' && typeof type.getCollectionNode !== 'function') {
                let name = element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index ?? 0;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key ?? null;
                if (nodeKey == null) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $94e011eaa4273865$var$$bda7a7e55e1ff206$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value ?? partialNode.value ?? null;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$94e011eaa4273865$var$$bda7a7e55e1ff206$var$capitalize(node.type)}> in <${$94e011eaa4273865$var$$bda7a7e55e1ff206$var$capitalize(parentNode?.type ?? 'unknown parent type')}>. Only <${$94e011eaa4273865$var$$bda7a7e55e1ff206$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null || partialNode.type == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value ?? null,
            level: (parentNode?.level ?? 0) + (parentNode?.type === 'item' ? 1 : 0),
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue ?? '',
            'aria-label': partialNode['aria-label'],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes || false,
            childNodes: $94e011eaa4273865$var$$bda7a7e55e1ff206$var$iterable(function*() {
                if (!partialNode.hasChildNodes || !partialNode.childNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    let nodes = builder.getFullNode({
                        ...child,
                        index: index
                    }, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $94e011eaa4273865$var$$bda7a7e55e1ff206$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $94e011eaa4273865$var$$bda7a7e55e1ff206$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $94e011eaa4273865$var$$bda7a7e55e1ff206$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}

});


parcelRegister("fAqsC", function(module, exports) {

$parcel$export(module.exports, "useMultipleSelectionState", () => $2d1a6932f51e90f4$export$253fe78d46329472);

var $cZV1R = parcelRequire("cZV1R");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2d1a6932f51e90f4$var$$60f19cefd567a3e4$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $2d1a6932f51e90f4$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = 'none', disallowEmptySelection: disallowEmptySelection = false, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = 'toggle', disabledBehavior: disabledBehavior = 'all' } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $eF4cA.useRef)(false);
    let [, setFocused] = (0, $eF4cA.useState)(false);
    let focusedKeyRef = (0, $eF4cA.useRef)(null);
    let childFocusStrategyRef = (0, $eF4cA.useRef)(null);
    let [, setFocusedKey] = (0, $eF4cA.useState)(null);
    let selectedKeysProp = (0, $eF4cA.useMemo)(()=>$2d1a6932f51e90f4$var$$60f19cefd567a3e4$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $eF4cA.useMemo)(()=>$2d1a6932f51e90f4$var$$60f19cefd567a3e4$var$convertSelection(props.defaultSelectedKeys, new (0, $cZV1R.Selection)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $iUErx.useControlledState)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $eF4cA.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $eF4cA.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === 'replace' && selectionBehavior === 'toggle' && typeof selectedKeys === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $eF4cA.useRef)(selectionBehaviorProp);
    (0, $eF4cA.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = 'first') {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$2d1a6932f51e90f4$var$$60f19cefd567a3e4$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $2d1a6932f51e90f4$var$$60f19cefd567a3e4$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === 'all' ? 'all' : new (0, $cZV1R.Selection)(selection);
}

});



parcelRegister("lyU6I", function(module, exports) {

$parcel$export(module.exports, "useDialog", () => $afdd7623c39ea914$export$d55e7ee900f34e93);

var $fVfXf = parcelRequire("fVfXf");

var $eNuje = parcelRequire("eNuje");

var $fvyIQ = parcelRequire("fvyIQ");

var $k771r = parcelRequire("k771r");

var $25dFS = parcelRequire("25dFS");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $afdd7623c39ea914$export$d55e7ee900f34e93(props, ref) {
    let { role: role = 'dialog', isEntering: isEntering } = props;
    let titleId = (0, $25dFS.useSlotId)();
    titleId = props['aria-label'] ? undefined : titleId;
    let contentId = (0, $25dFS.useSlotId)();
    contentId = role === 'alertdialog' && !props['aria-describedby'] ? contentId : undefined;
    let isRefocusing = (0, $eF4cA.useRef)(false);
    (0, $eF4cA.useEffect)(()=>{
        if (!isEntering && ref.current && !(0, $fvyIQ.isFocusWithin)(ref.current)) {
            (0, $eNuje.focusSafely)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                // Check that the dialog is still focused, or focused was lost to the body.
                if ((0, $fvyIQ.getActiveElement)() === ref.current || (0, $fvyIQ.getActiveElement)() === document.body) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $eNuje.focusSafely)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref,
        isEntering
    ]);
    (0, $k771r.useOverlayFocusContain)();
    // Warn in dev mode if the dialog has no accessible title.
    // This catches a common mistake where useDialog and useOverlayTriggerState
    // are used in the same component, causing the title element to not be
    // in the DOM when useSlotId queries for it.
    // Check the DOM element directly since aria-labelledby may be added by
    // wrapper components (e.g. RAC Dialog uses trigger ID as a fallback).
    let hasWarned = (0, $eF4cA.useRef)(false);
    (0, $eF4cA.useEffect)(()=>{});
    let ariaDescribedby = props['aria-describedby'] ?? contentId;
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $fVfXf.filterDOMProps)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            'aria-labelledby': props['aria-labelledby'] ?? titleId,
            'aria-describedby': ariaDescribedby,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        },
        contentProps: {
            id: contentId
        }
    };
}

});




parcelRegister("8Muzv", function(module, exports) {

$parcel$export(module.exports, "DividerContext", () => $b68af89b5bf5d18a$export$30fbfd376abdf190);
$parcel$export(module.exports, "divider", () => $b68af89b5bf5d18a$export$e8c9778bf415dd08);
$parcel$export(module.exports, "Divider", () => $b68af89b5bf5d18a$export$2e0a83ec2e27ecbb);


var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $jbXau = parcelRequire("jbXau");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b68af89b5bf5d18a$export$30fbfd376abdf190 = (0, $eF4cA.createContext)(null);
const $b68af89b5bf5d18a$export$e8c9778bf415dd08 = function anonymous(props, overrides) {
    let rules = " ";
    let alignSelf = false;
    let marginTop = false;
    let marginBottom = false;
    let marginInlineStart = false;
    let marginInlineEnd = false;
    let flexGrow = false;
    let flexShrink = false;
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_d") alignSelf = true;
        if (p[1] === "J") marginTop = true;
        if (p[1] === "G") marginBottom = true;
        if (p[1] === "I") marginInlineStart = true;
        if (p[1] === "H") marginInlineEnd = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    if (!alignSelf) rules += ' _df182';
    if (props.isStaticColor) {
        if (props.size === "L") rules += ' gi182';
        else rules += ' gg182';
    } else if (props.size === "L") rules += ' g0182';
    else rules += ' gF182';
    rules += ' gl_a182';
    rules += ' _je182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    if (!marginTop) rules += ' Jy182';
    if (!marginBottom) rules += ' Gy182';
    if (!marginInlineStart) rules += ' Iy182';
    if (!marginInlineEnd) rules += ' Hy182';
    if (!flexGrow) rules += ' _ua182';
    if (!flexShrink) rules += ' _va182';
    if (props.orientation === "horizontal") {
        if (props.size === "L") rules += ' FT4Nfn182';
        else if (props.size === "S") rules += ' FceNfn182';
        else rules += ' FLvNfn182';
    }
    if (props.orientation === "vertical") {
        if (props.size === "L") {
            if (!width) rules += ' ZT4Nfn182';
        } else if (props.size === "S") {
            if (!width) rules += ' ZceNfn182';
        } else if (!width) rules += ' ZLvNfn182';
    }
    return rules;
};
const $b68af89b5bf5d18a$export$2e0a83ec2e27ecbb = (0, $eF4cA.forwardRef)(function Divider(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $b68af89b5bf5d18a$export$30fbfd376abdf190);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $jbXau.Separator), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + $b68af89b5bf5d18a$export$e8c9778bf415dd08({
            size: props.size || 'M',
            orientation: props.orientation || 'horizontal',
            staticColor: props.staticColor,
            isStaticColor: !!props.staticColor
        }, props.styles)
    });
});

});

parcelRegister("3YPmU", function(module, exports) {

$parcel$export(module.exports, "Link", () => $e6c769eee2642a18$export$a6c7ac8248d6e38a);


var $91SAk = parcelRequire("91SAk");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $k8kxd = parcelRequire("k8kxd");

var $4skXn = parcelRequire("4skXn");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e6c769eee2642a18$export$e2509388b49734e7 = (0, $eF4cA.createContext)(null);
const $e6c769eee2642a18$var$$f50c78733c21bfe2$var$link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    if (props.isStaticColor) rules += ' Oe182';
    else rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    if (props.isStandalone) {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.isStandalone) {
        rules += ' xc182';
        rules += ' _xa182';
    }
    if (props.isStandalone) {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isStaticColor) rules += ' pl182';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps182';
        else if (props.isFocusVisible) rules += ' ps182';
        else if (props.isHovered) rules += ' ps182';
        else rules += ' pu182';
    }
    rules += ' plf182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb182';
                rules += ' __Va182';
            } else if (props.isHovered) {
                rules += ' _Xb182';
                rules += ' __Va182';
            } else rules += ' _Xa182';
        }
    } else {
        rules += ' _Xb182';
        rules += ' __Va182';
    }
    rules += ' __ca182';
    return rules;
};
const $e6c769eee2642a18$export$a6c7ac8248d6e38a = (0, $eF4cA.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $e6c769eee2642a18$export$e2509388b49734e7);
    let { variant: variant = 'primary', staticColor: staticColor, isQuiet: isQuiet, isStandalone: isStandalone, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', styles: styles, children: children } = props;
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let isSkeleton = (0, $eF4cA.useContext)((0, $91SAk.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, $91SAk.useSkeletonText)(children, UNSAFE_style);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (domRef.current) domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return (0, $dx4lB.jsx)((0, $k8kxd.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + $e6c769eee2642a18$var$$f50c78733c21bfe2$var$link({
                ...renderProps,
                variant: variant,
                staticColor: staticColor,
                isStaticColor: !!staticColor,
                isQuiet: isQuiet,
                isStandalone: isStandalone,
                isSkeleton: isSkeleton
            }, styles),
        children: children
    });
});

});

parcelRegister("15xG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd69a857604138c$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $bbd69a857604138c$var$$b10a7cd27fb1aca8$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M17.78 1.757C16.51.716 14.555.858 13.33 2.08L3.079 12.334c-.32.32-.559.717-.69 1.15l-1.384 4.584c-.08.265-.007.552.188.747.142.143.334.22.53.22q.11 0 .217-.032l4.582-1.384c.434-.13.832-.368 1.151-.688L18.028 6.575c.648-.647.993-1.545.948-2.46s-.482-1.775-1.195-2.358M2.846 17.163l.98-3.246q.042-.135.113-.257l2.41 2.409q-.123.07-.259.114zM16.966 5.516l-9.525 9.526-2.475-2.476 9.425-9.425c.386-.387.896-.586 1.39-.586.38 0 .752.119 1.05.362.392.321.621.772.646 1.272.025.494-.161.977-.51 1.327"
        })
    });
const $bbd69a857604138c$var$$b10a7cd27fb1aca8$var$ForwardRef = (0, $eF4cA.forwardRef)($bbd69a857604138c$var$$b10a7cd27fb1aca8$var$SvgComponent);
var $bbd69a857604138c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($bbd69a857604138c$var$$b10a7cd27fb1aca8$var$ForwardRef);

});

parcelRegister("fmJ8d", function(module, exports) {

$parcel$export(module.exports, "store", () => $b2fbeb497b5fe917$export$6f57813fe9f31bf9);

var $6ywA8 = parcelRequire("6ywA8");

var $kwoA1 = parcelRequire("kwoA1");

var $arybv = parcelRequire("arybv");

var $4CPg4 = parcelRequire("4CPg4");

var $1k12E = parcelRequire("1k12E");

var $kHUY0 = parcelRequire("kHUY0");

var $ODCYl = parcelRequire("ODCYl");

var $8nzd0 = parcelRequire("8nzd0");

var $9vM6B = parcelRequire("9vM6B");
const $b2fbeb497b5fe917$export$6f57813fe9f31bf9 = (0, $6ywA8.createStore)((0, $kwoA1.subscribeWithSelector)((0, $kwoA1.devtools)((0, $kwoA1.persist)((...args)=>({
        ...(0, $arybv.createAppSlice)(...args),
        ...(0, $4CPg4.createImsSlice)(...args),
        ...(0, $1k12E.createStorySlice)(...args),
        ...(0, $kHUY0.createWizardSlice)(...args),
        ...(0, $ODCYl.createPromptStorySlice)(...args),
        ...(0, $8nzd0.createPromptPersonasSlice)(...args),
        ...(0, $9vM6B.createPromptVisualsSlice)(...args)
    }), {
    name: "exd-storyteller-store",
    storage: (0, $kwoA1.createJSONStorage)(()=>localStorage),
    version: 2,
    partialize: ({ stories: stories, wizard: wizard, ims: ims, redirectPath: redirectPath, colorSchemePreference: colorSchemePreference, rolesDisabled: rolesDisabled, devModeOverride: devModeOverride, demoMode: demoMode })=>({
            stories: stories,
            wizard: wizard,
            colorSchemePreference: colorSchemePreference,
            rolesDisabled: rolesDisabled,
            devModeOverride: devModeOverride,
            demoMode: demoMode,
            ims: {
                profile: ims.profile,
                token: ims.token,
                org: ims.org,
                orgTokens: ims.orgTokens
            },
            redirectPath: redirectPath
        }),
    migrate: (persistedState, version)=>{
        if (version === 0) {
            // Migration logic for version 0 to 1
            persistedState.wizard.data = persistedState.data;
            persistedState.wizard.sampleData = persistedState.sampleData;
            persistedState.wizard.storyPrompt = persistedState.storyPrompt;
            persistedState.wizard.storyPromptTemplate = persistedState.storyPromptTemplate;
            delete persistedState.data;
            delete persistedState.sampleData;
            delete persistedState.storyPrompt;
            delete persistedState.storyPromptTemplate;
        }
        if (version === 1 || version === 2) // Migration logic for version 1 to 2
        persistedState.stories = persistedState.stories.map(({ id: id, uuid: uuid, ...story })=>({
                id: id ?? uuid,
                ...story
            }));
        return persistedState;
    }
}), {
    name: "exd-storyteller-store",
    enabled: false
})));
const $b2fbeb497b5fe917$var$storiesKeys = $b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().stories.map((story)=>story.id);
const $b2fbeb497b5fe917$var$uniqueStoriesKeys = new Set($b2fbeb497b5fe917$var$storiesKeys);
if ($b2fbeb497b5fe917$var$storiesKeys.length !== $b2fbeb497b5fe917$var$uniqueStoriesKeys.size) {
    // Remove duplicate stories
    const uniqueStories = new Map();
    $b2fbeb497b5fe917$var$uniqueStoriesKeys.forEach((storyId)=>{
        const story = $b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().stories.find((s)=>s.id === storyId);
        if (story) uniqueStories.set(story.id, story);
    });
    $b2fbeb497b5fe917$export$6f57813fe9f31bf9.setState(()=>({
            stories: Array.from(uniqueStories.values())
        }), false, "removeDuplicateStories");
}
const $b2fbeb497b5fe917$var$IS_DARK_MODE_MATCH = window.matchMedia("(prefers-color-scheme: dark)");
const $b2fbeb497b5fe917$var$IS_MOBILE_VIEWPORT_MATCH = window.matchMedia(`(max-width: 767px)`);
const $b2fbeb497b5fe917$var$IS_LARGE_VIEWPORT_MATCH = window.matchMedia(`(min-width: 1720px)`);
$b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().setColorSchemePreference($b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().colorSchemePreference);
$b2fbeb497b5fe917$var$IS_DARK_MODE_MATCH.addEventListener("change", (event)=>{
    if ($b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().colorSchemePreference !== "system") return;
    const theme = event.matches ? "dark" : "light";
    $b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().setColorScheme(theme);
});
$b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().setIsMobile($b2fbeb497b5fe917$var$IS_MOBILE_VIEWPORT_MATCH.matches);
$b2fbeb497b5fe917$var$IS_MOBILE_VIEWPORT_MATCH.addEventListener("change", (event)=>{
    $b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().setIsMobile(event.matches);
});
$b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().setIsLargeViewport($b2fbeb497b5fe917$var$IS_LARGE_VIEWPORT_MATCH.matches);
$b2fbeb497b5fe917$var$IS_LARGE_VIEWPORT_MATCH.addEventListener("change", (event)=>{
    $b2fbeb497b5fe917$export$6f57813fe9f31bf9.getState().setIsLargeViewport(event.matches);
});

});
parcelRegister("kwoA1", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $050809dc2eddaf7f$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $050809dc2eddaf7f$export$5c593627aef9f076);
$parcel$export(module.exports, "createJSONStorage", () => $050809dc2eddaf7f$export$95a3b7b12ab518f9);
$parcel$export(module.exports, "persist", () => $050809dc2eddaf7f$export$9a6132153fba2e0);
var $050809dc2eddaf7f$import_meta = Object.assign(Object.create(null), {
    url: "file:///../../node_modules/.pnpm/zustand@5.0.16_@types+react@19.3.0_immer@11.2.9_react@19.3.1_use-sync-external-store@1.7.0_react@19.3.1_/node_modules/zustand/esm/middleware.mjs"
});
const $050809dc2eddaf7f$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...args)=>api.dispatch(...args),
            ...initial
        };
    };
const $050809dc2eddaf7f$export$4feba8a1bc8e9afd = $050809dc2eddaf7f$var$reduxImpl;
const $050809dc2eddaf7f$var$shouldDispatchFromDevtools = (api)=>!!api.dispatchFromDevtools && typeof api.dispatch === "function";
const $050809dc2eddaf7f$var$trackedConnections = /* @__PURE__ */ new Map();
const $050809dc2eddaf7f$var$getTrackedConnectionState = (name)=>{
    const api = $050809dc2eddaf7f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $050809dc2eddaf7f$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $050809dc2eddaf7f$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $050809dc2eddaf7f$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $050809dc2eddaf7f$var$removeStoreFromTrackedConnections = (name, store, api)=>{
    if (store === void 0) return;
    const connectionInfo = $050809dc2eddaf7f$var$trackedConnections.get(name);
    if ((connectionInfo == null ? void 0 : connectionInfo.stores[store]) !== api) return;
    delete connectionInfo.stores[store];
    if (Object.keys(connectionInfo.stores).length === 0) $050809dc2eddaf7f$var$trackedConnections.delete(name);
};
const $050809dc2eddaf7f$var$v8StackLineRe = /^at (?:new |async )?(.+?) \(/;
const $050809dc2eddaf7f$var$geckoStackLineRe = /^([^@]+)@/;
function $050809dc2eddaf7f$var$findCallerName(stack) {
    var _a, _b, _c;
    if (!stack) return void 0;
    const traceLines = stack.split("\n");
    const apiSetStateLineIndex = traceLines.findIndex((traceLine)=>traceLine.includes("api.setState"));
    if (apiSetStateLineIndex < 0) return void 0;
    const callerLine = ((_a = traceLines[apiSetStateLineIndex + 1]) == null ? void 0 : _a.trim()) || "";
    return ((_b = $050809dc2eddaf7f$var$v8StackLineRe.exec(callerLine)) == null ? void 0 : _b[1]) || ((_c = $050809dc2eddaf7f$var$geckoStackLineRe.exec(callerLine)) == null ? void 0 : _c[1]);
}
const $050809dc2eddaf7f$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($050809dc2eddaf7f$import_meta.env ? $050809dc2eddaf7f$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $050809dc2eddaf7f$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || $050809dc2eddaf7f$var$findCallerName(new Error().stack) || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$050809dc2eddaf7f$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        let unsubscribeFromStore;
        api.devtools = {
            cleanup: ()=>{
                unsubscribeFromStore == null || unsubscribeFromStore();
                unsubscribeFromStore = void 0;
                $050809dc2eddaf7f$var$removeStoreFromTrackedConnections(options.name, store, api);
                if ((store === void 0 || !$050809dc2eddaf7f$var$trackedConnections.has(options.name)) && connection && typeof connection.unsubscribe === "function") connection.unsubscribe();
            }
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if ($050809dc2eddaf7f$var$shouldDispatchFromDevtools(api)) {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...args)=>{
                if (($050809dc2eddaf7f$import_meta.env ? $050809dc2eddaf7f$import_meta.env.MODE : void 0) !== "production" && args[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...args);
            };
        }
        unsubscribeFromStore = connection.subscribe((message)=>{
            var _a;
            const reviver = typeof options.serialize === "object" ? options.serialize.reviver : void 0;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $050809dc2eddaf7f$var$parseJsonThen(message.payload, reviver, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if ($050809dc2eddaf7f$var$shouldDispatchFromDevtools(api)) api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($050809dc2eddaf7f$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($050809dc2eddaf7f$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $050809dc2eddaf7f$var$parseJsonThen(message.state, reviver, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($050809dc2eddaf7f$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $050809dc2eddaf7f$var$parseJsonThen(message.state, reviver, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $050809dc2eddaf7f$export$6922d3b3a607469e = $050809dc2eddaf7f$var$devtoolsImpl;
const $050809dc2eddaf7f$var$parseJsonThen = (stringified, reviver, fn)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified, reviver);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) fn(parsed);
};
const $050809dc2eddaf7f$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $050809dc2eddaf7f$export$5c593627aef9f076 = $050809dc2eddaf7f$var$subscribeWithSelectorImpl;
function $050809dc2eddaf7f$export$1be1fc439b849fdf(initialState, create) {
    return (...args)=>Object.assign({}, initialState, create(...args));
}
function $050809dc2eddaf7f$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $050809dc2eddaf7f$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $050809dc2eddaf7f$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $050809dc2eddaf7f$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $050809dc2eddaf7f$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $050809dc2eddaf7f$export$95a3b7b12ab518f9(()=>window.localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        let hydrationVersion = 0;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (...args)=>{
            savedSetState(...args);
            return setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            return setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            const currentVersion = ++hydrationVersion;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $050809dc2eddaf7f$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                if (currentVersion !== hydrationVersion) return;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                if (currentVersion !== hydrationVersion) return;
                postRehydrationCallback == null || postRehydrationCallback(get(), void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                if (currentVersion !== hydrationVersion) return;
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                ++hydrationVersion;
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $050809dc2eddaf7f$export$9a6132153fba2e0 = $050809dc2eddaf7f$var$persistImpl;
function $050809dc2eddaf7f$export$6836f8135aedc40a(config, isSSR = typeof window === "undefined") {
    return (set, get, api)=>{
        if (!isSSR) return config(set, get, api);
        const ssrSet = ()=>{
            throw new Error("Cannot set state of Zustand store in SSR");
        };
        api.setState = ssrSet;
        return config(ssrSet, get, api);
    };
}

});

parcelRegister("arybv", function(module, exports) {

$parcel$export(module.exports, "createAppSlice", () => $79a6f15814a7255d$export$767f1dabdb13a717);

var $8u8Xx = parcelRequire("8u8Xx");
const $79a6f15814a7255d$var$COLOR_SCHEME_PREFERENCES = [
    "system",
    "light",
    "dark"
];
const $79a6f15814a7255d$export$767f1dabdb13a717 = (set, get)=>({
        isGenerating: false,
        /**
   * Sets the generating state.
   * @param {boolean} value - The new generating state.
   *
   * @returns {void}
   */ setGenerating: (value)=>set({
                isGenerating: value
            }, undefined, "app/setGenerating"),
        isPromptMinimized: true,
        /**
   * Sets the prompt minimized state.
   *
   * @param {boolean} value - The new prompt minimized state.
   *
   * @returns {void}
   */ setPromptMinimized: (value)=>set({
                isPromptMinimized: value
            }, undefined, "app/setPromptMinimized"),
        isExpressDialogOpen: false,
        /**
   * Sets the express dialog open state.
   *
   * @param {boolean} value - The new express dialog open state.
   *
   * @returns {void}
   */ setExpressDialogOpen: (value)=>set({
                isExpressDialogOpen: value
            }, undefined, "app/setExpressDialogOpen"),
        shouldGenerateImages: false,
        /**
   * Sets the should generate images state.
   *
   * @param {boolean} value - The new should generate images state.
   *
   * @returns {void}
   */ setShouldGenerateImages: (value)=>set({
                shouldGenerateImages: value
            }, undefined, "app/setShouldGenerateImages"),
        colorScheme: null,
        /**
   * Sets the resolved color scheme ("light" or "dark").
   *
   * @param {string} value - The new color scheme.
   *
   * @returns {void}
   */ setColorScheme: (value)=>set({
                colorScheme: value
            }, undefined, "app/setColorScheme"),
        colorSchemePreference: "system",
        /**
   * Sets the user's color scheme preference and resolves the effective color scheme.
   *
   * @param {"system"|"light"|"dark"} value - The preferred color scheme.
   *
   * @returns {void}
   */ setColorSchemePreference: (value)=>{
            const preference = $79a6f15814a7255d$var$COLOR_SCHEME_PREFERENCES.includes(value) ? value : "system";
            const colorScheme = preference === "system" ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : preference;
            set({
                colorSchemePreference: preference,
                colorScheme: colorScheme
            }, undefined, "app/setColorSchemePreference");
        },
        rolesDisabled: false,
        demoMode: false,
        setDemoMode: (value)=>set({
                demoMode: !!value
            }, undefined, "app/setDemoMode"),
        /**
   * Hides the signed-in user's roles in the UI to simulate a regular user.
   *
   * @param {boolean} value - Whether roles should be disabled.
   *
   * @returns {void}
   */ setRolesDisabled: (value)=>set({
                rolesDisabled: !!value
            }, undefined, "app/setRolesDisabled"),
        devModeOverride: null,
        /**
   * Overrides the dev mode flag returned by `useIsDevMode` (admins only).
   *
   * @param {boolean|null} value - Override value, or null to follow NODE_ENV.
   *
   * @returns {void}
   */ setDevModeOverride: (value)=>set({
                devModeOverride: typeof value === "boolean" ? value : null
            }, undefined, "app/setDevModeOverride"),
        isMobile: false,
        /**
   * Sets the mobile viewport state.
   *
   * @param {boolean} value - The new mobile viewport state.
   *
   * @returns {void}
   */ setIsMobile: (value)=>set({
                isMobile: value
            }, undefined, "app/setIsMobile"),
        isLargeViewport: false,
        /**
   * Sets the large viewport state.
   *
   * @param {boolean} value - The new large viewport state.
   *
   * @returns {void}
   */ setIsLargeViewport: (value)=>set({
                isLargeViewport: value
            }, undefined, "app/setIsLargeViewport"),
        clearToastRef: null,
        /**
   * Adds a toast message to the queue.
   *
   * @param {string} message - The message to display in the toast.
   * @param {object} options - Options for the toast, such as timeout.
   * @param {string} variant - The variant of the toast (e.g., "neutral", "positive", "negative", "info").
   *
   * @returns {void}
   */ addToast: (message, options, variant)=>{
            // variant can be "neutral", "positive", "negative", "info"
            // console.trace("adding toast:", message, options, variant);
            // Clear the previous toast if it exists
            get().clearToastRef?.();
            if (options?.timeout === -1) options.timeout = 60000; // 1 minute
            const clearToastRef = (0, $8u8Xx.ToastQueue)[variant ?? options?.variant ?? "neutral"]?.(message, options);
            set({
                clearToastRef: clearToastRef
            }, undefined, "app/addToast");
        },
        /**
   * Clears the current toast message.
   *
   * @returns {void}
   */ clearToast: ()=>{
            const clearToastRef = get().clearToastRef;
            if (clearToastRef) {
                clearToastRef();
                set({
                    clearToastRef: null
                }, undefined, "app/clearToast");
            }
        },
        isSideNavCollapsed: true,
        setSideNavCollapsed: (value)=>set({
                isSideNavCollapsed: value
            }, undefined, "app/setSideNavCollapsed"),
        imageVariationProgress: {},
        setImageVariationProgress: (variationKey, value)=>set((state)=>{
                if (typeof value === "function") value = value(state.imageVariationProgress[variationKey]);
                const ret = {
                    imageVariationProgress: {
                        ...state.imageVariationProgress,
                        [variationKey]: value
                    }
                };
                if (value === null) delete ret.imageVariationProgress[variationKey];
                return ret;
            }, undefined, "app/setImageVariationProgress"),
        promptHint: null,
        setPromptHint: (value)=>set({
                promptHint: value
            }, undefined, "app/setPromptHint")
    });

});
parcelRegister("8u8Xx", function(module, exports) {

$parcel$export(module.exports, "ToastQueue", () => $c5dc25c7108bd33f$export$f1f8569633bbbec4);
$parcel$export(module.exports, "ToastContainer", () => $c5dc25c7108bd33f$export$f2815235e76a62b9);


var $4W5AG = parcelRequire("4W5AG");

var $cnBj9 = parcelRequire("cnBj9");

var $34HUQ = parcelRequire("34HUQ");

var $8OJ2z = parcelRequire("8OJ2z");

var $cHCEM = parcelRequire("cHCEM");

var $iW1HQ = parcelRequire("iW1HQ");

var $4UbTp = parcelRequire("4UbTp");

var $gUjW8 = parcelRequire("gUjW8");

var $fL4LX = parcelRequire("fL4LX");

var $208Op = parcelRequire("208Op");


var $5sxG2 = parcelRequire("5sxG2");

var $5nuB1 = parcelRequire("5nuB1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $l19Vn = parcelRequire("l19Vn");

var $6pgkA = parcelRequire("6pgkA");

var $fvyIQ = parcelRequire("fvyIQ");

var $11FxZ = parcelRequire("11FxZ");

var $6yL0d = parcelRequire("6yL0d");

var $iPu7G = parcelRequire("iPu7G");

var $58OnM = parcelRequire("58OnM");

var $gI8Gw = parcelRequire("gI8Gw");

var $bTDob = parcelRequire("bTDob");

var $lIr3v = parcelRequire("lIr3v");
function $c5dc25c7108bd33f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalReduceMotion = false;
function $c5dc25c7108bd33f$var$$6e462db325878d1a$var$startViewTransition(fn, type) {
    if ('startViewTransition' in document) {
        // Safari doesn't support :active-view-transition-type() yet, so we fall back to a class on the html element.
        document.documentElement.classList.add($c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))[type]);
        if ($c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalReduceMotion) document.documentElement.classList.add($c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default)).reduceMotion);
        let viewTransition = document.startViewTransition(()=>(0, $l19Vn.flushSync)(fn));
        viewTransition.ready.catch(()=>{});
        viewTransition.finished.then(()=>{
            document.documentElement.classList.remove($c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))[type], $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default)).reduceMotion);
        });
    } else fn();
}
// There is a single global toast queue instance for the whole app, initialized lazily.
let $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalToastQueue = null;
function $c5dc25c7108bd33f$var$$6e462db325878d1a$var$getGlobalToastQueue() {
    if (!$c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalToastQueue) $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalToastQueue = new (0, $6yL0d.ToastQueue)({
        maxVisibleToasts: Infinity,
        wrapUpdate (fn, action) {
            $c5dc25c7108bd33f$var$$6e462db325878d1a$var$startViewTransition(fn, `toast-${action}`);
        }
    });
    return $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalToastQueue;
}
function $c5dc25c7108bd33f$var$$6e462db325878d1a$var$addToast(children, variant, options = {}) {
    let value = {
        children: children,
        variant: variant,
        actionLabel: options.actionLabel,
        onAction: options.onAction,
        shouldCloseOnAction: options.shouldCloseOnAction,
        ...(0, $fVfXf.filterDOMProps)(options)
    };
    // Minimum time of 5s from https://spectrum.adobe.com/web/rsp/components/toast#component-options
    // Actionable toasts cannot be auto dismissed. That would fail WCAG SC 2.2.1.
    // It is debatable whether non-actionable toasts would also fail.
    let timeout = options.timeout && !options.actionLabel ? Math.max(options.timeout, 5000) : undefined;
    let queue = $c5dc25c7108bd33f$var$$6e462db325878d1a$var$getGlobalToastQueue();
    let key = queue.add(value, {
        timeout: timeout,
        onClose: options.onClose
    });
    return ()=>queue.close(key);
}
const $c5dc25c7108bd33f$export$f1f8569633bbbec4 = {
    /** Queues a neutral toast. */ neutral (children, options = {}) {
        return $c5dc25c7108bd33f$var$$6e462db325878d1a$var$addToast(children, 'neutral', options);
    },
    /** Queues a positive toast. */ positive (children, options = {}) {
        return $c5dc25c7108bd33f$var$$6e462db325878d1a$var$addToast(children, 'positive', options);
    },
    /** Queues a negative toast. */ negative (children, options = {}) {
        return $c5dc25c7108bd33f$var$$6e462db325878d1a$var$addToast(children, 'negative', options);
    },
    /** Queues an informational toast. */ info (children, options = {}) {
        return $c5dc25c7108bd33f$var$$6e462db325878d1a$var$addToast(children, 'info', options);
    }
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastRegion = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' sd182';
    if (props.placement === "bottom") rules += ' _tb182';
    else if (props.placement === "top") rules += ' _ta182';
    rules += ' _Pb182';
    rules += ' _Ar182';
    rules += ' _zr182';
    rules += ' ZJ182';
    if (props.placement === "top") {
        if (props.isExpanded) rules += ' Wr182';
        else rules += ' Wu182';
    }
    if (props.placement === "bottom") {
        if (props.isExpanded) rules += ' _lr182';
        else rules += ' _lu182';
    }
    if (props.align === "end") rules += ' IM182';
    else if (props.align === "center") rules += ' IM182';
    else if (props.align === "start") rules += ' IC182';
    if (props.align === "end") rules += ' HC182';
    else if (props.align === "center") rules += ' HM182';
    else if (props.align === "start") rules += ' HM182';
    rules += ' _oa182';
    rules += ' Ka182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    return rules;
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastList = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc182';
    rules += ' _ub182';
    rules += ' sd182';
    rules += ' Ue182';
    rules += ' qe182';
    if (props.placement === "bottom") rules += ' _tb182';
    else if (props.placement === "top") rules += ' _ta182';
    rules += ' _oa182';
    rules += ' Jy182';
    rules += ' Gy182';
    if (props.isExpanded) {
        if (props.placement === "bottom") rules += ' Tt182';
        else if (props.placement === "top") rules += ' Tf182';
    }
    if (props.isExpanded) {
        if (props.placement === "bottom") rules += ' Qf182';
        else if (props.placement === "top") rules += ' Qt182';
    }
    if (props.isExpanded) rules += ' St182';
    else rules += ' Sd182';
    if (props.isExpanded) rules += ' Rt182';
    else rules += ' Rd182';
    if (props.isExpanded) rules += ' Ic182';
    else rules += ' Iy182';
    if (props.isExpanded) rules += ' Hc182';
    else rules += ' Hy182';
    if (props.isExpanded) rules += ' _Na182';
    if (props.isExpanded) rules += ' Pa182';
    return rules;
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastStyle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    if (props.isExpanded) rules += ' Ok182';
    else rules += ' Oh182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' sd182';
    rules += ' Ul182';
    rules += ' ql182';
    rules += ' Sf182';
    rules += ' Rt182';
    rules += ' Te182';
    rules += ' Qe182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    rules += ' Mj182';
    rules += ' -Zn3gsb-L0uB6Qb182';
    rules += ' LksArhc182';
    rules += ' _oa182';
    rules += ' _va182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' px182';
    if (props.variant === "negative") rules += ' gB182';
    else if (props.variant === "positive") rules += ' g1182';
    else if (props.variant === "info") rules += ' g2182';
    else if (props.variant === "neutral") rules += ' g6182';
    rules += ' -_8sjo0b-t5ZbAob182';
    if (props.isExpanded) rules += ' _nd182';
    else rules += ' _nLeasBb182';
    rules += ' _8d182';
    return rules;
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastBody = function anonymous(props) {
    let rules = " ";
    if (props.isSingle) rules += ' sd182';
    else rules += ' se182';
    rules += ' D4w1sLc182';
    rules += ' CWLL0Xb182';
    rules += ' _ub182';
    rules += ' _wb182';
    rules += ' eb182';
    rules += ' qj182';
    rules += ' Ue182';
    return rules;
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastContent = " sd182 Ue182 qe182 ea182 zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 ri182 ZJ182 -nTSCV-LTAEPe182 __ZLTAEPe182 Na182";
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$controls = function anonymous(props) {
    let rules = " ";
    rules += ' _pb182';
    if (props.isExpanded) rules += ' sd182';
    else rules += ' sk182';
    rules += ' _Cb182';
    rules += ' Ue182';
    rules += ' qe182';
    if (props.isExpanded) rules += ' _Ib182';
    else rules += ' _Ia182';
    return rules;
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$ICONS = {
    info: (0, $gUjW8.default),
    negative: (0, $cnBj9.default),
    positive: (0, $cHCEM.default)
};
const $c5dc25c7108bd33f$var$$6e462db325878d1a$var$ToastContainerContext = (0, $eF4cA.createContext)(null);
function $c5dc25c7108bd33f$export$f2815235e76a62b9(props) {
    let { placement: placement = 'bottom' } = props;
    let queue = $c5dc25c7108bd33f$var$$6e462db325878d1a$var$getGlobalToastQueue();
    let align = 'center';
    [placement, align = 'center'] = placement.split(' ');
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($c5dc25c7108bd33f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let regionRef = (0, $eF4cA.useRef)(null);
    let state = (0, $lIr3v.useOverlayTriggerState)({});
    let { isOpen: isExpanded, close: close, toggle: toggle } = state;
    let ctx = (0, $eF4cA.useMemo)(()=>({
            isExpanded: isExpanded,
            toggleExpanded () {
                if (!isExpanded && queue.visibleToasts.length <= 1) return;
                $c5dc25c7108bd33f$var$$6e462db325878d1a$var$startViewTransition(()=>toggle(), isExpanded ? 'toast-collapse' : 'toast-expand');
            }
        }), [
        isExpanded,
        toggle,
        queue
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return queue.subscribe(()=>{
            if (queue.visibleToasts.length === 0 && isExpanded) close();
        });
    }, [
        queue,
        isExpanded,
        close
    ]);
    let collapse = ()=>{
        regionRef.current?.focus();
        ctx.toggleExpanded();
    };
    (0, $bTDob.useModalOverlay)({}, state, regionRef);
    (0, $58OnM.useEvent)(regionRef, 'keydown', isExpanded ? (e)=>{
        if (e.key === 'Escape') collapse();
    } : undefined);
    let prefersReducedMotion = (0, $5nuB1.useMediaQuery)('(prefers-reduced-motion)');
    let reduceMotion = props['PRIVATE_forceReducedMotion'] ?? prefersReducedMotion;
    (0, $eF4cA.useEffect)(()=>{
        let oldGlobalReduceMotion = $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalReduceMotion;
        $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalReduceMotion = reduceMotion;
        return ()=>{
            $c5dc25c7108bd33f$var$$6e462db325878d1a$var$globalReduceMotion = oldGlobalReduceMotion;
        };
    }, [
        reduceMotion
    ]);
    return (0, $dx4lB.jsx)((0, $iPu7G.UNSTABLE_ToastRegion), {
        ...props,
        ref: regionRef,
        queue: queue,
        className: (renderProps)=>$c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastRegion({
                ...renderProps,
                placement: placement,
                align: align,
                isExpanded: isExpanded
            }),
        children: (0, $dx4lB.jsx)((0, $6pgkA.FocusScope), {
            contain: isExpanded,
            children: (0, $dx4lB.jsxs)($c5dc25c7108bd33f$var$$6e462db325878d1a$var$ToastContainerContext.Provider, {
                value: ctx,
                children: [
                    isExpanded && (0, $dx4lB.jsx)("div", {
                        className: $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['toast-background'] + " _Pb182 Wr182 _lr182 _Ar182 _zr182 g8182",
                        onClick: collapse
                    }),
                    (0, $dx4lB.jsx)($c5dc25c7108bd33f$var$$6e462db325878d1a$var$SpectrumToastList, {
                        placement: placement,
                        align: align,
                        reduceMotion: reduceMotion
                    }),
                    (0, $dx4lB.jsxs)("div", {
                        className: $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['toast-controls'] + $c5dc25c7108bd33f$var$$6e462db325878d1a$var$controls({
                            isExpanded: isExpanded
                        }),
                        children: [
                            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                size: "S",
                                onPress: ()=>queue.clear(),
                                // Default focus ring does not have enough contrast against gray background.
                                UNSAFE_style: {
                                    outlineColor: 'white'
                                },
                                children: stringFormatter.format('toast.clearAll')
                            }),
                            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                size: "S",
                                onPress: collapse,
                                UNSAFE_style: {
                                    outlineColor: 'white'
                                },
                                children: stringFormatter.format('toast.collapse')
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $c5dc25c7108bd33f$var$$6e462db325878d1a$var$SpectrumToastList({ placement: placement, align: align, reduceMotion: reduceMotion }) {
    let { isExpanded: isExpanded, toggleExpanded: toggleExpanded } = (0, $eF4cA.useContext)($c5dc25c7108bd33f$var$$6e462db325878d1a$var$ToastContainerContext);
    // Attach click handler to ref since ToastList doesn't pass through onClick/onPress.
    let toastListRef = (0, $eF4cA.useRef)(null);
    (0, $58OnM.useEvent)(toastListRef, 'click', (e)=>{
        // Have to check if this is a button because stopPropagation in react events doesn't affect native events.
        if (!isExpanded && !(0, $fvyIQ.getEventTarget)(e)?.closest('button')) toggleExpanded();
    });
    return (0, $dx4lB.jsx)((0, $iPu7G.UNSTABLE_ToastList), {
        ref: toastListRef,
        style: ({ isHovered: isHovered })=>{
            let origin = isHovered ? 95 : 55;
            return {
                perspective: 80,
                perspectiveOrigin: 'center ' + (placement === 'top' ? `calc(100% + ${origin}px)` : `${-origin}px`),
                transition: 'perspective-origin 400ms'
            };
        },
        className: $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))[isExpanded ? 'toast-list-expanded' : 'toast-list-collapsed'] + $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastList({
            placement: placement,
            align: align,
            isExpanded: isExpanded
        }),
        children: ({ toast: toast })=>(0, $dx4lB.jsx)($c5dc25c7108bd33f$export$f9b1e1c88454fa08, {
                toast: toast,
                placement: placement,
                align: align,
                reduceMotion: reduceMotion
            })
    });
}
function $c5dc25c7108bd33f$export$f9b1e1c88454fa08(props) {
    let { toast: toast, placement: placement = 'bottom', align: align = 'center' } = props;
    let variant = toast.content.variant || 'info';
    let Icon = $c5dc25c7108bd33f$var$$6e462db325878d1a$var$ICONS[variant];
    let state = (0, $eF4cA.useContext)((0, $iPu7G.UNSTABLE_ToastStateContext));
    let visibleToasts = state.visibleToasts;
    let index = visibleToasts.indexOf(toast);
    let isMain = index <= 0;
    let ctx = (0, $eF4cA.useContext)($c5dc25c7108bd33f$var$$6e462db325878d1a$var$ToastContainerContext);
    let isExpanded = ctx?.isExpanded || false;
    let toastRef = (0, $eF4cA.useRef)(null);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($c5dc25c7108bd33f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    // When not expanded, use a presentational div for the toasts behind the top one.
    // The content is invisible, all we show is the background color.
    if (!isMain && ctx && !ctx.isExpanded) return (0, $dx4lB.jsx)("div", {
        role: "presentation",
        style: {
            position: 'absolute',
            [placement === 'top' ? 'bottom' : 'top']: 0,
            left: 0,
            width: '100%',
            translate: `0 0 ${-12 * index / 16}rem`,
            // Only 3 toasts are visible in the stack at once, but all toasts are in the DOM.
            // This allows view transitions to smoothly animate them from where they would be
            // in the collapsed stack to their final position in the expanded list.
            opacity: index >= 3 ? 0 : 1,
            zIndex: visibleToasts.length - index - 1,
            // When reduced motion is enabled, use append index to view-transition-name
            // so that adding/removing a toast cross fades instead of transitioning the position.
            // This works because the toasts are seen as separate elements instead of the same one when their index changes.
            viewTransitionName: toast.key + (props.reduceMotion ? '-' + index : ''),
            viewTransitionClass: [
                $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default)).toast,
                $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['background-toast']
            ].map((c)=>CSS.escape(c)).join(' ')
        },
        className: $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default)).toast + $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastStyle({
            variant: toast.content.variant || 'info',
            index: index,
            isExpanded: isExpanded
        }),
        ref: $c5dc25c7108bd33f$var$$6e462db325878d1a$var$fixSafariTransform
    });
    return (0, $dx4lB.jsxs)((0, $iPu7G.UNSTABLE_Toast), {
        ref: toastRef,
        toast: toast,
        style: {
            zIndex: visibleToasts.length - index - 1,
            viewTransitionName: toast.key,
            viewTransitionClass: [
                $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default)).toast,
                !isMain ? $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['background-toast'] : '',
                $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))[placement],
                $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))[align]
            ].filter(Boolean).map((c)=>CSS.escape(c)).join(' ')
        },
        className: (renderProps)=>$c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default)).toast + $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastStyle({
                ...renderProps,
                variant: toast.content.variant || 'info',
                index: index,
                isExpanded: isExpanded
            }),
        ...(0, $fVfXf.filterDOMProps)(toast.content),
        children: [
            (0, $dx4lB.jsxs)("div", {
                role: "presentation",
                className: $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastBody({
                    isSingle: !isMain || visibleToasts.length <= 1 || isExpanded
                }),
                children: [
                    (0, $dx4lB.jsxs)((0, $iPu7G.UNSTABLE_ToastContent), {
                        className: $c5dc25c7108bd33f$var$$6e462db325878d1a$var$toastContent + (ctx && isMain ? ` ${$c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['toast-content']}` : null),
                        children: [
                            Icon && (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                                children: (0, $dx4lB.jsx)(Icon, {})
                            }),
                            (0, $dx4lB.jsx)((0, $208Op.Text), {
                                slot: "title",
                                children: toast.content.children
                            })
                        ]
                    }),
                    !isExpanded && visibleToasts.length > 1 && (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        isQuiet: true,
                        staticColor: "white",
                        styles: " zPgKvMe182 yPgKvMe182 BPgKvMe182 APgKvMe182",
                        // Make the chevron line up with the toast text, even though there is padding within the button.
                        UNSAFE_style: {
                            marginInlineStart: variant === 'neutral' ? -10 : 14
                        },
                        UNSAFE_className: ctx && isMain ? $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['toast-expand'] : undefined,
                        onPress: ()=>{
                            // This button disappears when clicked, so move focus to the toast.
                            toastRef.current?.focus();
                            ctx?.toggleExpanded();
                        },
                        children: [
                            (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: stringFormatter.format('toast.showAll')
                            }),
                            (0, $dx4lB.jsx)((0, $iW1HQ.default), {
                                UNSAFE_style: {
                                    rotate: placement === 'bottom' ? '180deg' : undefined
                                }
                            })
                        ]
                    }),
                    toast.content.actionLabel && (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        variant: "secondary",
                        fillStyle: "outline",
                        staticColor: "white",
                        onPress: ()=>{
                            toast.content.onAction?.();
                            if (toast.content.shouldCloseOnAction) state.close(toast.key);
                        },
                        UNSAFE_className: ctx && isMain ? $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['toast-action'] : undefined,
                        styles: " IM182 zzz3eAe182 yzz3eAe182 Bzz3eAe182 Azz3eAe182",
                        children: toast.content.actionLabel
                    })
                ]
            }),
            (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                staticColor: "white",
                UNSAFE_className: ctx && isMain ? $c5dc25c7108bd33f$var$$parcel$interopDefault((0, $5sxG2.default))['toast-close'] : undefined
            })
        ]
    });
}
function $c5dc25c7108bd33f$var$$6e462db325878d1a$var$fixSafariTransform(el) {
    // WebKit has a bug where the toasts display in the wrong position (CSS transform is not applied correctly).
    // Work around this by removing it, forcing a reflow, and re-applying.
    if (el && (0, $11FxZ.isWebKit)()) {
        let translate = el.style.translate;
        el.style.translate = '';
        el.offsetHeight;
        el.style.translate = translate;
    }
}

});
parcelRegister("cnBj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $693a2cdd4f45ef60$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $693a2cdd4f45ef60$var$$e17a4836f4b6cc28$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 15.123c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234M10 11.75c-.414 0-.75-.336-.75-.75V7c0-.414.336-.75.75-.75s.75.336.75.75v4c0 .414-.336.75-.75.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.733 18H3.267c-.8 0-1.523-.41-1.933-1.098s-.427-1.518-.046-2.222L8.02 2.232c.394-.727 1.152-1.18 1.979-1.18s1.585.453 1.979 1.18l6.733 12.448c.381.704.364 1.535-.046 2.222S17.534 18 16.733 18M10 2.553c-.134 0-.468.038-.66.392L2.607 15.393c-.183.338-.05.631.016.74.065.111.259.367.644.367h13.466c.385 0 .579-.256.644-.366s.2-.403.016-.741L10.66 2.945c-.192-.354-.526-.392-.66-.392"
            })
        ]
    });
const $693a2cdd4f45ef60$var$$e17a4836f4b6cc28$var$ForwardRef = (0, $eF4cA.forwardRef)($693a2cdd4f45ef60$var$$e17a4836f4b6cc28$var$SvgComponent);
var $693a2cdd4f45ef60$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($693a2cdd4f45ef60$var$$e17a4836f4b6cc28$var$ForwardRef);

});

parcelRegister("cHCEM", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b07313bb9b91af$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $31b07313bb9b91af$var$$22a7d72fc05e138d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M9.223 13.5c-.212 0-.415-.09-.558-.248l-2.51-2.792c-.278-.309-.253-.782.055-1.06s.781-.252 1.06.056l1.893 2.107 3.487-4.756c.244-.334.711-.41 1.048-.161.334.244.406.713.161 1.047l-4.032 5.5c-.133.183-.342.295-.567.306z"
            })
        ]
    });
const $31b07313bb9b91af$var$$22a7d72fc05e138d$var$ForwardRef = (0, $eF4cA.forwardRef)($31b07313bb9b91af$var$$22a7d72fc05e138d$var$SvgComponent);
var $31b07313bb9b91af$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($31b07313bb9b91af$var$$22a7d72fc05e138d$var$ForwardRef);

});

parcelRegister("iW1HQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5738ac5786bdf71$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $d5738ac5786bdf71$var$$e59ae2a33cca2ebf$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M3.755 7.243c.287-.299.762-.308 1.06-.02l5.183 4.986 5.197-4.999c.298-.288.773-.278 1.06.02.287.297.278.773-.02 1.06l-5.717 5.5c-.29.28-.75.28-1.04 0L3.776 8.303c-.153-.147-.23-.344-.23-.54 0-.188.07-.375.21-.52"
        })
    });
const $d5738ac5786bdf71$var$$e59ae2a33cca2ebf$var$ForwardRef = (0, $eF4cA.forwardRef)($d5738ac5786bdf71$var$$e59ae2a33cca2ebf$var$SvgComponent);
var $d5738ac5786bdf71$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($d5738ac5786bdf71$var$$e59ae2a33cca2ebf$var$ForwardRef);

});

parcelRegister("4UbTp", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $9cb6e8ce99b35717$export$de65de8213222d10);


var $bQJuU = parcelRequire("bQJuU");

var $fL4LX = parcelRequire("fL4LX");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $eF4cA = parcelRequire("eF4cA");

var $gI8Gw = parcelRequire("gI8Gw");
function $9cb6e8ce99b35717$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9cb6e8ce99b35717$var$$a9cda54c4f47ce52$var$hoverBackground = {
    default: 'gray-200',
    isStaticColor: 'transparent-overlay-200'
};
const $9cb6e8ce99b35717$var$$a9cda54c4f47ce52$var$styles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let flexShrink = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "_v") flexShrink = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    if (props.isStaticColor) rules += ' Oe182';
    else rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    if (props.size === "XL") {
        if (!width) rules += ' ZF182';
    } else if (props.size === "L") {
        if (!width) rules += ' Zw182';
    } else if (props.size === "S") {
        if (!width) rules += ' Zo182';
    } else if (props.size === "XS") {
        if (!width) rules += ' Zm182';
    } else if (!width) rules += ' ZC182';
    if (props.size === "XL") rules += ' Fz182';
    else if (props.size === "L") rules += ' Fv182';
    else if (props.size === "S") rules += ' Fp182';
    else if (props.size === "XS") rules += ' Fn182';
    else rules += ' Fx182';
    if (!flexShrink) rules += ' _va182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' _je182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isPressed) {
        if (props.isStaticColor) rules += ' gg182';
        else rules += ' gF182';
    } else if (props.isFocusVisible) {
        if (props.isStaticColor) rules += ' gg182';
        else rules += ' gF182';
    } else if (props.isHovered) {
        if (props.isStaticColor) rules += ' gg182';
        else rules += ' gF182';
    } else rules += ' g9182';
    if (props.isStaticColor) {
        if (props.isDisabled) rules += ' -_8sjo0b-pi182';
        else rules += ' -_8sjo0b-pl182';
    } else if (props.isDisabled) rules += ' -_8sjo0b-pp182';
    else {
        if (props.isPressed) rules += ' -_8sjo0b-po182';
        else if (props.isFocusVisible) rules += ' -_8sjo0b-po182';
        else if (props.isHovered) rules += ' -_8sjo0b-po182';
        else rules += ' -_8sjo0b-pt182';
    }
    if (props.isDisabled) rules += ' -_8sjo0b-lpc182';
    else rules += ' -_8sjo0b-lpb182';
    rules += ' __ca182';
    return rules;
};
const $9cb6e8ce99b35717$export$c796eec99a15b55d = (0, $eF4cA.createContext)(null);
const $9cb6e8ce99b35717$export$de65de8213222d10 = (0, $eF4cA.forwardRef)(function CloseButton(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $9cb6e8ce99b35717$export$c796eec99a15b55d);
    let { UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '' } = props;
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($9cb6e8ce99b35717$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        ...props,
        ref: domRef,
        slot: "close",
        "aria-label": props['aria-label'] || stringFormatter.format('dialog.dismiss'),
        style: (0, $i93Vd.pressScale)(domRef, UNSAFE_style),
        className: (renderProps)=>UNSAFE_className + $9cb6e8ce99b35717$var$$a9cda54c4f47ce52$var$styles({
                ...renderProps,
                size: props.size,
                staticColor: props.staticColor,
                isStaticColor: !!props.staticColor
            }, props.styles),
        children: (0, $dx4lB.jsx)((0, $bQJuU.default), {
            size: {
                S: 'L',
                M: 'XL',
                L: 'XXL',
                XL: 'XXXL'
            }[props.size || 'M']
        })
    });
// oxlint-enable react/react-compiler
});

});
parcelRegister("bQJuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef2205e59d2de9a$export$2e2bcd8739ae039);


var $Ci59b = parcelRequire("Ci59b");

var $2UMCp = parcelRequire("2UMCp");

var $iNLD4 = parcelRequire("iNLD4");

var $gsiPD = parcelRequire("gsiPD");

var $3XYpR = parcelRequire("3XYpR");

var $d3wdL = parcelRequire("d3wdL");

var $gzdjA = parcelRequire("gzdjA");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zh182';
    else if (props.size === "XXXXL") rules += ' Zu182';
    else if (props.size === "XXXL") rules += ' Zk182';
    else if (props.size === "XXL") rules += ' Zj182';
    else if (props.size === "XL") rules += ' Zj182';
    else if (props.size === "L") rules += ' Zi182';
    else if (props.size === "M") rules += ' Zh182';
    if (props.size === "S") rules += ' Fi182';
    else if (props.size === "XXXXL") rules += ' Ft182';
    else if (props.size === "XXXL") rules += ' Fl182';
    else if (props.size === "XXL") rules += ' Fk182';
    else if (props.size === "XL") rules += ' Fk182';
    else if (props.size === "L") rules += ' Fj182';
    else if (props.size === "M") rules += ' Fi182';
    return rules;
};
function $7ef2205e59d2de9a$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $2UMCp.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $Ci59b.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $gsiPD.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
        case 'XXL':
            return (0, $dx4lB.jsx)((0, $3XYpR.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
        case 'XXXL':
            return (0, $dx4lB.jsx)((0, $d3wdL.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
        case 'XXXXL':
            return (0, $dx4lB.jsx)((0, $gzdjA.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $iNLD4.default), {
                ...otherProps,
                className: (otherProps.className || '') + $7ef2205e59d2de9a$var$$bd983341bd35d639$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("Ci59b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb42715f136a5e8$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $ceb42715f136a5e8$var$$f9b0e4d204f0089d$var$SvgS2CrossSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m6.289 5 2.922-2.923A.912.912 0 0 0 7.922.788L5 3.711 2.078.788a.912.912 0 0 0-1.29 1.29L3.712 5 .789 7.923a.912.912 0 0 0 1.289 1.289L5 6.289l2.922 2.923a.91.91 0 0 0 1.29 0 .91.91 0 0 0 0-1.29z"
        })
    });
var $ceb42715f136a5e8$export$2e2bcd8739ae039 = $ceb42715f136a5e8$var$$f9b0e4d204f0089d$var$SvgS2CrossSize200;

});

parcelRegister("2UMCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c438b779c107f7$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $57c438b779c107f7$var$$7113f5fa84d2e14b$var$SvgS2CrossSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m5.238 4 2.456-2.456A.876.876 0 0 0 6.457.306L4 2.762 1.543.306A.875.875 0 1 0 .306 1.544L2.762 4 .306 6.456a.876.876 0 0 0 1.237 1.238L4 5.238l2.457 2.456a.871.871 0 0 0 1.237 0 .876.876 0 0 0 0-1.238z"
        })
    });
var $57c438b779c107f7$export$2e2bcd8739ae039 = $57c438b779c107f7$var$$7113f5fa84d2e14b$var$SvgS2CrossSize100;

});

parcelRegister("iNLD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bb9cdbe7af0e14$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $77bb9cdbe7af0e14$var$$a93ef97d8d8a352b$var$SvgS2CrossSize75 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m5.188 4 2.14-2.14A.84.84 0 0 0 6.14.671L4 2.812 1.86.672A.84.84 0 0 0 .672 1.859L2.812 4 .672 6.14A.84.84 0 0 0 1.86 7.329L4 5.188l2.14 2.14a.84.84 0 0 0 1.188 0 .84.84 0 0 0 0-1.187z"
        })
    });
var $77bb9cdbe7af0e14$export$2e2bcd8739ae039 = $77bb9cdbe7af0e14$var$$a93ef97d8d8a352b$var$SvgS2CrossSize75;

});

parcelRegister("gsiPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0a9bbaeb61e906$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $1a0a9bbaeb61e906$var$$4cc2fc1192001377$var$SvgS2CrossSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m7.342 6 3.396-3.396a.95.95 0 1 0-1.342-1.342L6 4.658 2.604 1.262a.95.95 0 1 0-1.343 1.342L4.659 6 1.262 9.396a.95.95 0 1 0 1.343 1.342L6 7.342l3.396 3.396a.946.946 0 0 0 1.342.001.95.95 0 0 0 0-1.343z"
        })
    });
var $1a0a9bbaeb61e906$export$2e2bcd8739ae039 = $1a0a9bbaeb61e906$var$$4cc2fc1192001377$var$SvgS2CrossSize300;

});

parcelRegister("3XYpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $458814848087fe0b$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $458814848087fe0b$var$$0385b854665937eb$var$SvgS2CrossSize400 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m7.398 6 3.932-3.932A.989.989 0 1 0 9.932.67L6 4.602 2.068.67A.988.988 0 1 0 .67 2.068L4.602 6 .67 9.932a.989.989 0 1 0 1.398 1.398L6 7.398l3.932 3.932a.985.985 0 0 0 1.398 0 .99.99 0 0 0 0-1.398z"
        })
    });
var $458814848087fe0b$export$2e2bcd8739ae039 = $458814848087fe0b$var$$0385b854665937eb$var$SvgS2CrossSize400;

});

parcelRegister("d3wdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc2a11e6c10428f1$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $dc2a11e6c10428f1$var$$0b87753fef448aa6$var$SvgS2CrossSize500 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m8.457 7 4.54-4.54a1.031 1.031 0 0 0-1.457-1.456L7 5.543l-4.54-4.54a1.03 1.03 0 0 0-1.457 1.458L5.543 7l-4.54 4.54a1.031 1.031 0 0 0 1.457 1.456L7 8.457l4.54 4.54a1.027 1.027 0 0 0 1.457 0 1.03 1.03 0 0 0 0-1.458z"
        })
    });
var $dc2a11e6c10428f1$export$2e2bcd8739ae039 = $dc2a11e6c10428f1$var$$0b87753fef448aa6$var$SvgS2CrossSize500;

});

parcelRegister("gzdjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $33f48768026d45e7$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $33f48768026d45e7$var$$316aaa4fa56e9cde$var$SvgS2CrossSize600 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m9.518 8 5.23-5.229a1.073 1.073 0 0 0-1.519-1.517L8 6.483l-5.229-5.23a1.073 1.073 0 0 0-1.518 1.518l5.23 5.23-5.23 5.228a1.073 1.073 0 0 0 1.518 1.518l5.23-5.229 5.228 5.23a1.073 1.073 0 1 0 1.518-1.519z"
        })
    });
var $33f48768026d45e7$export$2e2bcd8739ae039 = $33f48768026d45e7$var$$316aaa4fa56e9cde$var$SvgS2CrossSize600;

});



parcelRegister("gUjW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b71617a9cd13bc8c$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $b71617a9cd13bc8c$var$$4c8f17dac3ecefd9$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 5.26c.231-.008.456.074.627.229.33.365.33.921 0 1.286-.17.159-.395.243-.626.235-.237.01-.466-.08-.633-.248-.162-.168-.25-.394-.242-.627-.012-.235.07-.465.228-.64.174-.164.408-.25.647-.235M10 15.063c-.414 0-.75-.336-.75-.75V9.478c0-.415.336-.75.75-.75s.75.335.75.75v4.835c0 .414-.336.75-.75.75"
            })
        ]
    });
const $b71617a9cd13bc8c$var$$4c8f17dac3ecefd9$var$ForwardRef = (0, $eF4cA.forwardRef)($b71617a9cd13bc8c$var$$4c8f17dac3ecefd9$var$SvgComponent);
var $b71617a9cd13bc8c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($b71617a9cd13bc8c$var$$4c8f17dac3ecefd9$var$ForwardRef);

});

parcelRegister("5sxG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cc9bfbec1ed9cb$export$2e2bcd8739ae039);
function $03cc9bfbec1ed9cb$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $03cc9bfbec1ed9cb$export$2e2bcd8739ae039 = {};
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "background-toast", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$edbbb856c11a0d96, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$edbbb856c11a0d96 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "bottom", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$40e543e69a8b3fbb, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$40e543e69a8b3fbb = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "end", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$bd5df0f255a350f8, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$bd5df0f255a350f8 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "reduceMotion", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$4d326e2f78efc43c, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$4d326e2f78efc43c = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "slide-in", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1c220dee9e4dbe34, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1c220dee9e4dbe34 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "slide-out", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$ec7246eb5d3e2aa3, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$ec7246eb5d3e2aa3 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "start", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b3571188c770cc5a, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b3571188c770cc5a = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b410431fab84fa58, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b410431fab84fa58 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-action", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$3d00e48b8962d9f0, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$3d00e48b8962d9f0 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-add", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b684c8de946176be, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b684c8de946176be = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-background", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$9a03a30b325163ea, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$9a03a30b325163ea = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-clear", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$7cbc9cee106851da, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$7cbc9cee106851da = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-close", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$cf9b85a5ed109c94, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$cf9b85a5ed109c94 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-collapse", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$eb15d68452870263, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$eb15d68452870263 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-content", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$83df85987eadac53, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$83df85987eadac53 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-controls", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b5485e66c0963f26, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b5485e66c0963f26 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-expand", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b19c3e4c0d595545, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b19c3e4c0d595545 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-list-collapsed", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$a87160c50f0b3a26, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$a87160c50f0b3a26 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-list-expanded", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$c2bf6e0c0f84b201, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$c2bf6e0c0f84b201 = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "toast-remove", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$e6c629548fb56b1d, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$e6c629548fb56b1d = v);
$03cc9bfbec1ed9cb$var$$parcel$export($03cc9bfbec1ed9cb$export$2e2bcd8739ae039, "top", ()=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1e95b668f3b82d, (v)=>$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1e95b668f3b82d = v);
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$edbbb856c11a0d96;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$40e543e69a8b3fbb;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$bd5df0f255a350f8;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$4d326e2f78efc43c;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1c220dee9e4dbe34;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$ec7246eb5d3e2aa3;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b3571188c770cc5a;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b410431fab84fa58;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$3d00e48b8962d9f0;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b684c8de946176be;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$9a03a30b325163ea;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$7cbc9cee106851da;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$cf9b85a5ed109c94;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$eb15d68452870263;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$83df85987eadac53;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b5485e66c0963f26;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b19c3e4c0d595545;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$a87160c50f0b3a26;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$c2bf6e0c0f84b201;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$e6c629548fb56b1d;
var $03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1e95b668f3b82d;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$edbbb856c11a0d96 = `chyGla_background-toast`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$40e543e69a8b3fbb = `chyGla_bottom`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$bd5df0f255a350f8 = `chyGla_end`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$4d326e2f78efc43c = `chyGla_reduceMotion`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1c220dee9e4dbe34 = `chyGla_slide-in`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1c220dee9e4dbe34;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$ec7246eb5d3e2aa3 = `chyGla_slide-out`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$ec7246eb5d3e2aa3;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b3571188c770cc5a = `chyGla_start`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b410431fab84fa58 = `chyGla_toast`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$3d00e48b8962d9f0 = `chyGla_toast-action`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b684c8de946176be = `chyGla_toast-add`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$9a03a30b325163ea = `chyGla_toast-background`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$7cbc9cee106851da = `chyGla_toast-clear`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$cf9b85a5ed109c94 = `chyGla_toast-close`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$eb15d68452870263 = `chyGla_toast-collapse`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$83df85987eadac53 = `chyGla_toast-content`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b5485e66c0963f26 = `chyGla_toast-controls`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$b19c3e4c0d595545 = `chyGla_toast-expand`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$a87160c50f0b3a26 = `chyGla_toast-list-collapsed`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$c2bf6e0c0f84b201 = `chyGla_toast-list-expanded`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$e6c629548fb56b1d = `chyGla_toast-remove`;
$03cc9bfbec1ed9cb$var$$9cff1fc922af8248$export$1e95b668f3b82d = `chyGla_top`;

});

parcelRegister("6yL0d", function(module, exports) {

$parcel$export(module.exports, "ToastQueue", () => $5cca75c33d67898d$export$f1f8569633bbbec4);
$parcel$export(module.exports, "useToastQueue", () => $5cca75c33d67898d$export$84726ef35ca2129a);

var $eF4cA = parcelRequire("eF4cA");

var $5LhCr = parcelRequire("5LhCr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5cca75c33d67898d$export$c7b26b20d3ced9c5(props = {}) {
    let { maxVisibleToasts: maxVisibleToasts = 1, wrapUpdate: wrapUpdate } = props;
    let queue = (0, $eF4cA.useMemo)(()=>new $5cca75c33d67898d$export$f1f8569633bbbec4({
            maxVisibleToasts: maxVisibleToasts,
            wrapUpdate: wrapUpdate
        }), [
        maxVisibleToasts,
        wrapUpdate
    ]);
    return $5cca75c33d67898d$export$84726ef35ca2129a(queue);
}
function $5cca75c33d67898d$export$84726ef35ca2129a(queue) {
    let subscribe = (0, $eF4cA.useCallback)((fn)=>queue.subscribe(fn), [
        queue
    ]);
    let getSnapshot = (0, $eF4cA.useCallback)(()=>queue.visibleToasts, [
        queue
    ]);
    let visibleToasts = (0, $5LhCr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return {
        visibleToasts: visibleToasts,
        add: (content, options)=>queue.add(content, options),
        close: (key)=>queue.close(key),
        pauseAll: ()=>queue.pauseAll(),
        resumeAll: ()=>queue.resumeAll()
    };
}
class $5cca75c33d67898d$export$f1f8569633bbbec4 {
    constructor(options){
        this.queue = [];
        this.subscriptions = new Set();
        /** The currently visible toasts. */ this.visibleToasts = [];
        this.maxVisibleToasts = options?.maxVisibleToasts ?? Infinity;
        this.wrapUpdate = options?.wrapUpdate;
    }
    runWithWrapUpdate(fn, action) {
        if (this.wrapUpdate) this.wrapUpdate(fn, action);
        else fn();
    }
    /** Subscribes to updates to the visible toasts. */ subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    /** Adds a new toast to the queue. */ add(content, options = {}) {
        let toastKey = '_' + Math.random().toString(36).slice(2);
        let toast = {
            ...options,
            content: content,
            key: toastKey,
            timer: options.timeout ? new $5cca75c33d67898d$var$$ac6ee1e83ff78022$var$Timer(()=>this.close(toastKey), options.timeout) : undefined
        };
        this.queue.unshift(toast);
        this.updateVisibleToasts('add');
        return toastKey;
    }
    /**
   * Closes a toast.
   */ close(key) {
        let index = this.queue.findIndex((t)=>t.key === key);
        if (index >= 0) {
            this.queue[index].onClose?.();
            this.queue.splice(index, 1);
        }
        this.updateVisibleToasts('remove');
    }
    updateVisibleToasts(action) {
        this.visibleToasts = this.queue.slice(0, this.maxVisibleToasts);
        this.runWithWrapUpdate(()=>{
            for (let fn of this.subscriptions)fn();
        }, action);
    }
    /** Pauses the timers for all visible toasts. */ pauseAll() {
        for (let toast of this.visibleToasts)if (toast.timer) toast.timer.pause();
    }
    /** Resumes the timers for all visible toasts. */ resumeAll() {
        for (let toast of this.visibleToasts)if (toast.timer) toast.timer.resume();
    }
    clear() {
        this.queue = [];
        this.updateVisibleToasts('clear');
    }
}
class $5cca75c33d67898d$var$$ac6ee1e83ff78022$var$Timer {
    constructor(callback, delay){
        this.startTime = null;
        this.remaining = delay;
        this.callback = callback;
    }
    reset(delay) {
        this.remaining = delay;
        this.resume();
    }
    pause() {
        if (this.timerId == null) return;
        clearTimeout(this.timerId);
        this.timerId = null;
        this.remaining -= Date.now() - this.startTime;
    }
    resume() {
        if (this.remaining <= 0) return;
        this.startTime = Date.now();
        this.timerId = setTimeout(()=>{
            this.timerId = null;
            this.remaining = 0;
            this.callback();
        }, this.remaining);
    }
}

});

parcelRegister("iPu7G", function(module, exports) {

$parcel$export(module.exports, "UNSTABLE_ToastStateContext", () => $523bd5b347ec688b$export$17d647cb5858af3d);
$parcel$export(module.exports, "UNSTABLE_ToastRegion", () => $523bd5b347ec688b$export$133f5cbcf6f82aa1);
$parcel$export(module.exports, "UNSTABLE_ToastList", () => $523bd5b347ec688b$export$a40376c2ff45c041);
$parcel$export(module.exports, "UNSTABLE_Toast", () => $523bd5b347ec688b$export$200206268470a71);
$parcel$export(module.exports, "UNSTABLE_ToastContent", () => $523bd5b347ec688b$export$b134a6cc89b08851);

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $c1ibQ = parcelRequire("c1ibQ");

var $bbOdn = parcelRequire("bbOdn");
var $azbuM = parcelRequire("azbuM");

var $l19Vn = parcelRequire("l19Vn");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $6yL0d = parcelRequire("6yL0d");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $hWe38 = parcelRequire("hWe38");

var $1ntKq = parcelRequire("1ntKq");

var $26CkO = parcelRequire("26CkO");

var $euMIq = parcelRequire("euMIq");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $523bd5b347ec688b$export$17d647cb5858af3d = (0, $eF4cA.createContext)(null);
/**
 * A ToastRegion displays one or more toast notifications.
 */ const $523bd5b347ec688b$export$133f5cbcf6f82aa1 = (0, $eF4cA.forwardRef)(function ToastRegion(props, ref) {
    let isSSR = (0, $hWe38.useIsSSR)();
    let state = (0, $6yL0d.useToastQueue)(props.queue);
    let objectRef = (0, $26CkO.useObjectRef)(ref);
    let { regionProps: regionProps } = (0, $azbuM.useToastRegion)(props, state, objectRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ToastRegion',
        values: {
            visibleToasts: state.visibleToasts,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        }
    });
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let portalContainer;
    let { getContainer: getContainer } = (0, $euMIq.useUNSAFE_PortalContext)();
    if (!isSSR) {
        portalContainer = document.body;
        if (getContainer) portalContainer = getContainer();
    }
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    let region = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($523bd5b347ec688b$export$17d647cb5858af3d.Provider, {
        value: state
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, regionProps, focusProps, hoverProps),
        dir: direction,
        ref: objectRef,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, typeof props.children === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($523bd5b347ec688b$export$a40376c2ff45c041, {
        ...props,
        render: undefined,
        className: undefined,
        style: {
            display: 'contents'
        }
    }, props.children) : props.children));
    return state.visibleToasts.length > 0 && portalContainer ? (0, $l19Vn.createPortal)(region, portalContainer) : null;
});
const $523bd5b347ec688b$export$a40376c2ff45c041 = (0, $eF4cA.forwardRef)(function ToastList(props, ref) {
    let state = (0, $eF4cA.useContext)($523bd5b347ec688b$export$17d647cb5858af3d);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ToastList',
        values: {
            visibleToasts: state.visibleToasts,
            isFocused: false,
            isFocusVisible: false,
            isHovered: isHovered
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).ol, {
        ...hoverProps,
        ...renderProps,
        ref: ref
    }, state.visibleToasts.map((toast)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("li", {
            key: toast.key,
            style: {
                display: 'contents'
            }
        }, props.children({
            toast: toast
        }))));
});
/**
 * A Toast displays a brief, temporary notification of actions, errors, or other events in an
 * application.
 */ const $523bd5b347ec688b$export$200206268470a71 = (0, $eF4cA.forwardRef)(function Toast(props, ref) {
    let state = (0, $eF4cA.useContext)($523bd5b347ec688b$export$17d647cb5858af3d);
    let objectRef = (0, $26CkO.useObjectRef)(ref);
    let { toastProps: toastProps, contentProps: contentProps, titleProps: titleProps, descriptionProps: descriptionProps, closeButtonProps: closeButtonProps } = (0, $bbOdn.useToast)(props, state, objectRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Toast',
        values: {
            toast: props.toast,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, toastProps, focusProps),
        ref: objectRef,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $523bd5b347ec688b$export$3a0d85872d9f73f2,
                contentProps
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        title: titleProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        close: closeButtonProps
                    }
                }
            ]
        ]
    }, renderProps.children));
});
const $523bd5b347ec688b$export$3a0d85872d9f73f2 = (0, $eF4cA.createContext)({});
const $523bd5b347ec688b$export$b134a6cc89b08851 = (0, $eF4cA.forwardRef)(function ToastContent(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $523bd5b347ec688b$export$3a0d85872d9f73f2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        render: props.render,
        className: "react-aria-ToastContent",
        ...props,
        ref: ref
    }, props.children);
});

});
parcelRegister("bbOdn", function(module, exports) {

$parcel$export(module.exports, "useToast", () => $5fdc4bb81248d905$export$a407b657d3044108);

var $fVfXf = parcelRequire("fVfXf");

var $anI7e = parcelRequire("anI7e");

var $25dFS = parcelRequire("25dFS");

var $4skXn = parcelRequire("4skXn");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $5fdc4bb81248d905$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5fdc4bb81248d905$export$a407b657d3044108(props, state, ref) {
    let { key: key, timer: timer, timeout: timeout } = props.toast;
    (0, $eF4cA.useEffect)(()=>{
        if (timer == null || timeout == null) return;
        timer.reset(timeout);
        return ()=>{
            timer.pause();
        };
    }, [
        timer,
        timeout
    ]);
    let titleId = (0, $25dFS.useId)();
    let descriptionId = (0, $25dFS.useSlotId)();
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($5fdc4bb81248d905$var$$parcel$interopDefault((0, $anI7e.default)), '@react-aria/toast');
    // This is required for NVDA announcements, without it NVDA will NOT announce the toast when it appears.
    // Originally was tied to animationStart/End via https://github.com/adobe/react-spectrum/pull/6223/commits/e22e319df64958e822ab7cd9685e96818cae9ba5
    // but toasts don't always have animations.
    let [isVisible, setIsVisible] = (0, $eF4cA.useState)(false);
    (0, $4skXn.useLayoutEffect)(()=>{
        setIsVisible(true);
    }, []);
    let toastProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    return {
        toastProps: {
            ...toastProps,
            role: 'alertdialog',
            'aria-modal': 'false',
            'aria-labelledby': props['aria-labelledby'] || titleId,
            'aria-describedby': props['aria-describedby'] || descriptionId,
            tabIndex: 0
        },
        contentProps: {
            role: 'alert',
            'aria-atomic': 'true',
            'aria-hidden': isVisible ? undefined : 'true'
        },
        titleProps: {
            id: titleId
        },
        descriptionProps: {
            id: descriptionId
        },
        closeButtonProps: {
            'aria-label': stringFormatter.format('close'),
            onPress: ()=>state.close(key)
        }
    };
}

});
parcelRegister("anI7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $575bfba227507871$export$2e2bcd8739ae039);

var $ltK9O = parcelRequire("ltK9O");

var $gRcng = parcelRequire("gRcng");

var $d5J9Z = parcelRequire("d5J9Z");

var $k4CZ7 = parcelRequire("k4CZ7");

var $aPWct = parcelRequire("aPWct");

var $akejj = parcelRequire("akejj");

var $4NttE = parcelRequire("4NttE");

var $j6OaP = parcelRequire("j6OaP");

var $1JVop = parcelRequire("1JVop");

var $dzAG8 = parcelRequire("dzAG8");

var $11uQn = parcelRequire("11uQn");

var $iYMLh = parcelRequire("iYMLh");

var $10zlT = parcelRequire("10zlT");

var $l4A8h = parcelRequire("l4A8h");

var $iJej0 = parcelRequire("iJej0");

var $esCrA = parcelRequire("esCrA");

var $gYZiS = parcelRequire("gYZiS");

var $8js68 = parcelRequire("8js68");

var $aV4F2 = parcelRequire("aV4F2");

var $8IM83 = parcelRequire("8IM83");

var $5gKuo = parcelRequire("5gKuo");

var $7ENbm = parcelRequire("7ENbm");

var $3scKB = parcelRequire("3scKB");

var $kAQug = parcelRequire("kAQug");

var $6l8OX = parcelRequire("6l8OX");

var $lloOo = parcelRequire("lloOo");

var $j1Iip = parcelRequire("j1Iip");

var $gW72s = parcelRequire("gW72s");

var $1Oaq5 = parcelRequire("1Oaq5");

var $r6viY = parcelRequire("r6viY");

var $2WAYo = parcelRequire("2WAYo");

var $fsoGn = parcelRequire("fsoGn");

var $abWxA = parcelRequire("abWxA");

var $aZWfZ = parcelRequire("aZWfZ");
var $575bfba227507871$export$2e2bcd8739ae039 = {};
$575bfba227507871$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $ltK9O.default),
    "bg-BG": (0, $gRcng.default),
    "cs-CZ": (0, $d5J9Z.default),
    "da-DK": (0, $k4CZ7.default),
    "de-DE": (0, $aPWct.default),
    "el-GR": (0, $akejj.default),
    "en-US": (0, $4NttE.default),
    "es-ES": (0, $j6OaP.default),
    "et-EE": (0, $1JVop.default),
    "fi-FI": (0, $dzAG8.default),
    "fr-FR": (0, $11uQn.default),
    "he-IL": (0, $iYMLh.default),
    "hr-HR": (0, $10zlT.default),
    "hu-HU": (0, $l4A8h.default),
    "it-IT": (0, $iJej0.default),
    "ja-JP": (0, $esCrA.default),
    "ko-KR": (0, $gYZiS.default),
    "lt-LT": (0, $8js68.default),
    "lv-LV": (0, $aV4F2.default),
    "nb-NO": (0, $8IM83.default),
    "nl-NL": (0, $5gKuo.default),
    "pl-PL": (0, $7ENbm.default),
    "pt-BR": (0, $3scKB.default),
    "pt-PT": (0, $kAQug.default),
    "ro-RO": (0, $6l8OX.default),
    "ru-RU": (0, $lloOo.default),
    "sk-SK": (0, $j1Iip.default),
    "sl-SI": (0, $gW72s.default),
    "sr-SP": (0, $1Oaq5.default),
    "sv-SE": (0, $r6viY.default),
    "tr-TR": (0, $2WAYo.default),
    "uk-UA": (0, $fsoGn.default),
    "zh-CN": (0, $abWxA.default),
    "zh-TW": (0, $aZWfZ.default)
};

});
parcelRegister("ltK9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ba33d7ed2ed942$export$2e2bcd8739ae039);
var $d0ba33d7ed2ed942$export$2e2bcd8739ae039 = {};
$d0ba33d7ed2ed942$export$2e2bcd8739ae039 = {
    "close": `\u{625}\u{63A}\u{644}\u{627}\u{642}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{625}\u{634}\u{639}\u{627}\u{631}`,
            other: ()=>`${formatter.number(args.count)} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A}`
        })}.`
};

});

parcelRegister("gRcng", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bcffd50f89103aa$export$2e2bcd8739ae039);
var $1bcffd50f89103aa$export$2e2bcd8739ae039 = {};
$1bcffd50f89103aa$export$2e2bcd8739ae039 = {
    "close": `\u{417}\u{430}\u{442}\u{432}\u{43E}\u{440}\u{438}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{438}\u{435}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{438}\u{44F}`
        })}.`
};

});

parcelRegister("d5J9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf41dbdcec35861$export$2e2bcd8739ae039);
var $7bf41dbdcec35861$export$2e2bcd8739ae039 = {};
$7bf41dbdcec35861$export$2e2bcd8739ae039 = {
    "close": `Zav\u{159}\xedt`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`,
            other: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`
        })}.`
};

});

parcelRegister("k4CZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5106ef3428d24b$export$2e2bcd8739ae039);
var $ad5106ef3428d24b$export$2e2bcd8739ae039 = {};
$ad5106ef3428d24b$export$2e2bcd8739ae039 = {
    "close": `Luk`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} besked`,
            other: ()=>`${formatter.number(args.count)} beskeder`
        })}.`
};

});

parcelRegister("aPWct", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a22c9288dbfe530$export$2e2bcd8739ae039);
var $8a22c9288dbfe530$export$2e2bcd8739ae039 = {};
$8a22c9288dbfe530$export$2e2bcd8739ae039 = {
    "close": `Schlie\xdfen`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} Benachrichtigung`,
            other: ()=>`${formatter.number(args.count)} Benachrichtigungen`
        })}.`
};

});

parcelRegister("akejj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe6a14dc936e7f6$export$2e2bcd8739ae039);
var $dfe6a14dc936e7f6$export$2e2bcd8739ae039 = {};
$dfe6a14dc936e7f6$export$2e2bcd8739ae039 = {
    "close": `\u{39A}\u{3BB}\u{3B5}\u{3AF}\u{3C3}\u{3B9}\u{3BC}\u{3BF}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3B9}\u{3AE}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
        })}.`
};

});

parcelRegister("4NttE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c876eba596dfef92$export$2e2bcd8739ae039);
var $c876eba596dfef92$export$2e2bcd8739ae039 = {};
$c876eba596dfef92$export$2e2bcd8739ae039 = {
    "close": `Close`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notification`,
            other: ()=>`${formatter.number(args.count)} notifications`
        })}.`
};

});

parcelRegister("j6OaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e4f3dd91d527731$export$2e2bcd8739ae039);
var $0e4f3dd91d527731$export$2e2bcd8739ae039 = {};
$0e4f3dd91d527731$export$2e2bcd8739ae039 = {
    "close": `Cerrar`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notificaci\xf3n`,
            other: ()=>`${formatter.number(args.count)} notificaciones`
        })}.`
};

});

parcelRegister("1JVop", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee60c94af8d9e89$export$2e2bcd8739ae039);
var $8ee60c94af8d9e89$export$2e2bcd8739ae039 = {};
$8ee60c94af8d9e89$export$2e2bcd8739ae039 = {
    "close": `Sule`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} teatis`,
            other: ()=>`${formatter.number(args.count)} teatist`
        })}.`
};

});

parcelRegister("dzAG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a5855219e8bf7d$export$2e2bcd8739ae039);
var $69a5855219e8bf7d$export$2e2bcd8739ae039 = {};
$69a5855219e8bf7d$export$2e2bcd8739ae039 = {
    "close": `Sulje`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ilmoitus`,
            other: ()=>`${formatter.number(args.count)} ilmoitusta`
        })}.`
};

});

parcelRegister("11uQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b67624b9c9eea82$export$2e2bcd8739ae039);
var $9b67624b9c9eea82$export$2e2bcd8739ae039 = {};
$9b67624b9c9eea82$export$2e2bcd8739ae039 = {
    "close": `Fermer`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notification`,
            other: ()=>`${formatter.number(args.count)} notifications`
        })}.`
};

});

parcelRegister("iYMLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ab4d4ba32cdb64$export$2e2bcd8739ae039);
var $b5ab4d4ba32cdb64$export$2e2bcd8739ae039 = {};
$b5ab4d4ba32cdb64$export$2e2bcd8739ae039 = {
    "close": `\u{5E1}\u{5D2}\u{5D5}\u{5E8}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
            other: ()=>`${formatter.number(args.count)} \u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D5}\u{5EA}`
        })}.`
};

});

parcelRegister("10zlT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e62d9dac28c1f0d$export$2e2bcd8739ae039);
var $1e62d9dac28c1f0d$export$2e2bcd8739ae039 = {};
$1e62d9dac28c1f0d$export$2e2bcd8739ae039 = {
    "close": `Zatvori`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} obavijest`,
            other: ()=>`${formatter.number(args.count)} obavijesti`
        })}.`
};

});

parcelRegister("l4A8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b801c7f08c4677e8$export$2e2bcd8739ae039);
var $b801c7f08c4677e8$export$2e2bcd8739ae039 = {};
$b801c7f08c4677e8$export$2e2bcd8739ae039 = {
    "close": `Bez\xe1r\xe1s`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9rtes\xedt\xe9s`,
            other: ()=>`${formatter.number(args.count)} \xe9rtes\xedt\xe9s`
        })}.`
};

});

parcelRegister("iJej0", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c92712387a7b35$export$2e2bcd8739ae039);
var $40c92712387a7b35$export$2e2bcd8739ae039 = {};
$40c92712387a7b35$export$2e2bcd8739ae039 = {
    "close": `Chiudi`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notifica`,
            other: ()=>`${formatter.number(args.count)} notifiche`
        })}.`
};

});

parcelRegister("esCrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b63845cc6dbeeff$export$2e2bcd8739ae039);
var $4b63845cc6dbeeff$export$2e2bcd8739ae039 = {};
$4b63845cc6dbeeff$export$2e2bcd8739ae039 = {
    "close": `\u{9589}\u{3058}\u{308B}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{306E}\u{901A}\u{77E5}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{306E}\u{901A}\u{77E5}`
        })}\u{3002}`
};

});

parcelRegister("gYZiS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0adf8e19b739796c$export$2e2bcd8739ae039);
var $0adf8e19b739796c$export$2e2bcd8739ae039 = {};
$0adf8e19b739796c$export$2e2bcd8739ae039 = {
    "close": `\u{B2EB}\u{AE30}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C54C}\u{B9BC}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C54C}\u{B9BC}`
        })}.`
};

});

parcelRegister("8js68", function(module, exports) {

$parcel$export(module.exports, "default", () => $914bcffd622ce362$export$2e2bcd8739ae039);
var $914bcffd622ce362$export$2e2bcd8739ae039 = {};
$914bcffd622ce362$export$2e2bcd8739ae039 = {
    "close": `U\u{17E}daryti`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} prane\u{161}imas`,
            other: ()=>`${formatter.number(args.count)} prane\u{161}imai`
        })}.`
};

});

parcelRegister("aV4F2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1de7141595ba255e$export$2e2bcd8739ae039);
var $1de7141595ba255e$export$2e2bcd8739ae039 = {};
$1de7141595ba255e$export$2e2bcd8739ae039 = {
    "close": `Aizv\u{113}rt`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pazi\u{146}ojums`,
            other: ()=>`${formatter.number(args.count)} pazi\u{146}ojumi`
        })}.`
};

});

parcelRegister("8IM83", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d9d4fc0badbe6a2$export$2e2bcd8739ae039);
var $2d9d4fc0badbe6a2$export$2e2bcd8739ae039 = {};
$2d9d4fc0badbe6a2$export$2e2bcd8739ae039 = {
    "close": `Lukk`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} varsling`,
            other: ()=>`${formatter.number(args.count)} varsler`
        })}.`
};

});

parcelRegister("5gKuo", function(module, exports) {

$parcel$export(module.exports, "default", () => $61cca6d357fb1789$export$2e2bcd8739ae039);
var $61cca6d357fb1789$export$2e2bcd8739ae039 = {};
$61cca6d357fb1789$export$2e2bcd8739ae039 = {
    "close": `Sluiten`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} melding`,
            other: ()=>`${formatter.number(args.count)} meldingen`
        })}.`
};

});

parcelRegister("7ENbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec5aa6d4c5af08a$export$2e2bcd8739ae039);
var $dec5aa6d4c5af08a$export$2e2bcd8739ae039 = {};
$dec5aa6d4c5af08a$export$2e2bcd8739ae039 = {
    "close": `Zamknij`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} powiadomienie`,
            few: ()=>`${formatter.number(args.count)} powiadomienia`,
            many: ()=>`${formatter.number(args.count)} powiadomie\u{144}`,
            other: ()=>`${formatter.number(args.count)} powiadomienia`
        })}.`
};

});

parcelRegister("3scKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $41993400042fd2ea$export$2e2bcd8739ae039);
var $41993400042fd2ea$export$2e2bcd8739ae039 = {};
$41993400042fd2ea$export$2e2bcd8739ae039 = {
    "close": `Fechar`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notifica\xe7\xe3o`,
            other: ()=>`${formatter.number(args.count)} notifica\xe7\xf5es`
        })}.`
};

});

parcelRegister("kAQug", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6bd9b0eb4908d8$export$2e2bcd8739ae039);
var $eb6bd9b0eb4908d8$export$2e2bcd8739ae039 = {};
$eb6bd9b0eb4908d8$export$2e2bcd8739ae039 = {
    "close": `Fechar`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notifica\xe7\xe3o`,
            other: ()=>`${formatter.number(args.count)} notifica\xe7\xf5es`
        })}.`
};

});

parcelRegister("6l8OX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1240b45cdd190b5d$export$2e2bcd8739ae039);
var $1240b45cdd190b5d$export$2e2bcd8739ae039 = {};
$1240b45cdd190b5d$export$2e2bcd8739ae039 = {
    "close": `\xcenchide\u{163}i`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notificare`,
            other: ()=>`${formatter.number(args.count)} notific\u{103}ri`
        })}.`
};

});

parcelRegister("lloOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ecd9cfb1f579b3$export$2e2bcd8739ae039);
var $a9ecd9cfb1f579b3$export$2e2bcd8739ae039 = {};
$a9ecd9cfb1f579b3$export$2e2bcd8739ae039 = {
    "close": `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
            other: ()=>`${formatter.number(args.count)} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`
        })}.`
};

});

parcelRegister("j1Iip", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0a0ebc4fcb2119a$export$2e2bcd8739ae039);
var $d0a0ebc4fcb2119a$export$2e2bcd8739ae039 = {};
$d0a0ebc4fcb2119a$export$2e2bcd8739ae039 = {
    "close": `Zatvori\u{165}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ozn\xe1menie`,
            few: ()=>`${formatter.number(args.count)} ozn\xe1menia`,
            other: ()=>`${formatter.number(args.count)} ozn\xe1men\xed`
        })}.`
};

});

parcelRegister("gW72s", function(module, exports) {

$parcel$export(module.exports, "default", () => $47e669f32cc8d2b2$export$2e2bcd8739ae039);
var $47e669f32cc8d2b2$export$2e2bcd8739ae039 = {};
$47e669f32cc8d2b2$export$2e2bcd8739ae039 = {
    "close": `Zapri`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} obvestilo`,
            two: ()=>`${formatter.number(args.count)} obvestili`,
            few: ()=>`${formatter.number(args.count)} obvestila`,
            other: ()=>`${formatter.number(args.count)} obvestil`
        })}.`
};

});

parcelRegister("1Oaq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17cae02981f091a$export$2e2bcd8739ae039);
var $c17cae02981f091a$export$2e2bcd8739ae039 = {};
$c17cae02981f091a$export$2e2bcd8739ae039 = {
    "close": `Zatvori`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} obave\u{161}tenje`,
            other: ()=>`${formatter.number(args.count)} obave\u{161}tenja`
        })}.`
};

});

parcelRegister("r6viY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcae54ffe8be18bb$export$2e2bcd8739ae039);
var $fcae54ffe8be18bb$export$2e2bcd8739ae039 = {};
$fcae54ffe8be18bb$export$2e2bcd8739ae039 = {
    "close": `St\xe4ng`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} meddelande`,
            other: ()=>`${formatter.number(args.count)} meddelanden`
        })}.`
};

});

parcelRegister("2WAYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9400763ee488f367$export$2e2bcd8739ae039);
var $9400763ee488f367$export$2e2bcd8739ae039 = {};
$9400763ee488f367$export$2e2bcd8739ae039 = {
    "close": `Kapat`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} bildirim`,
            other: ()=>`${formatter.number(args.count)} bildirim`
        })}.`
};

});

parcelRegister("fsoGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b90b0f8ac7be99$export$2e2bcd8739ae039);
var $37b90b0f8ac7be99$export$2e2bcd8739ae039 = {};
$37b90b0f8ac7be99$export$2e2bcd8739ae039 = {
    "close": `\u{417}\u{430}\u{43A}\u{440}\u{438}\u{442}\u{438}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{441}\u{43F}\u{43E}\u{432}\u{456}\u{449}\u{435}\u{43D}\u{43D}\u{44F}`,
            other: ()=>`${formatter.number(args.count)} \u{441}\u{43F}\u{43E}\u{432}\u{456}\u{449}\u{435}\u{43D}\u{43D}\u{44F}`
        })}.`
};

});

parcelRegister("abWxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e657fd5b13f746$export$2e2bcd8739ae039);
var $a1e657fd5b13f746$export$2e2bcd8739ae039 = {};
$a1e657fd5b13f746$export$2e2bcd8739ae039 = {
    "close": `\u{5173}\u{95ED}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{901A}\u{77E5}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{901A}\u{77E5}`
        })}\u{3002}`
};

});

parcelRegister("aZWfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e61cc331d1395998$export$2e2bcd8739ae039);
var $e61cc331d1395998$export$2e2bcd8739ae039 = {};
$e61cc331d1395998$export$2e2bcd8739ae039 = {
    "close": `\u{95DC}\u{9589}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{901A}\u{77E5}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{901A}\u{77E5}`
        })}\u{3002}`
};

});



parcelRegister("azbuM", function(module, exports) {

$parcel$export(module.exports, "useToastRegion", () => $8230b11359352f26$export$b8cbbb20a51697de);

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $YxOvP = parcelRequire("YxOvP");

var $anI7e = parcelRequire("anI7e");

var $lhKAD = parcelRequire("lhKAD");

var $i1DSg = parcelRequire("i1DSg");

var $j2JDe = parcelRequire("j2JDe");

var $ctOxu = parcelRequire("ctOxu");

var $4skXn = parcelRequire("4skXn");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $8230b11359352f26$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8230b11359352f26$export$b8cbbb20a51697de(props, state, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($8230b11359352f26$var$$parcel$interopDefault((0, $anI7e.default)), '@react-aria/toast');
    let { landmarkProps: landmarkProps } = (0, $ctOxu.useLandmark)({
        role: 'region',
        'aria-label': props['aria-label'] || stringFormatter.format('notifications', {
            count: state.visibleToasts.length
        })
    }, ref);
    let isHovered = (0, $eF4cA.useRef)(false);
    let isFocused = (0, $eF4cA.useRef)(false);
    let updateTimers = (0, $eF4cA.useCallback)(()=>{
        if (isHovered.current || isFocused.current) state.pauseAll();
        else state.resumeAll();
    }, [
        state
    ]);
    let { hoverProps: hoverProps } = (0, $j2JDe.useHover)({
        onHoverStart: ()=>{
            isHovered.current = true;
            updateTimers();
        },
        onHoverEnd: ()=>{
            isHovered.current = false;
            updateTimers();
        }
    });
    // Manage focus within the toast region.
    // If a focused containing toast is removed, move focus to the next toast, or the previous toast if there is no next toast.
    let toasts = (0, $eF4cA.useRef)([]);
    let prevVisibleToasts = (0, $eF4cA.useRef)(state.visibleToasts);
    let focusedToast = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        // If no toast has focus, then don't do anything.
        if (focusedToast.current === -1 || state.visibleToasts.length === 0 || !ref.current) {
            toasts.current = [];
            prevVisibleToasts.current = state.visibleToasts;
            return;
        }
        toasts.current = [
            ...ref.current.querySelectorAll('[role="alertdialog"]')
        ];
        // If the visible toasts haven't changed, we don't need to do anything.
        if (prevVisibleToasts.current.length === state.visibleToasts.length && state.visibleToasts.every((t, i)=>t.key === prevVisibleToasts.current[i].key)) {
            prevVisibleToasts.current = state.visibleToasts;
            return;
        }
        // Get a list of all toasts by index and add info if they are removed.
        let allToasts = prevVisibleToasts.current.map((t, i)=>({
                ...t,
                i: i,
                isRemoved: !state.visibleToasts.some((t2)=>t.key === t2.key)
            }));
        let removedFocusedToastIndex = allToasts.findIndex((t)=>t.i === focusedToast.current && t.isRemoved);
        // If the focused toast was removed, focus the next or previous toast.
        if (removedFocusedToastIndex > -1) {
            // In pointer modality, move focus out of the toast region.
            // Otherwise auto-dismiss timers will appear "stuck".
            // oxlint-disable-next-line react/react-compiler
            if ((0, $YxOvP.getInteractionModality)() === 'pointer' && lastFocused.current?.isConnected) (0, $2jk5s.focusWithoutScrolling)(lastFocused.current);
            else {
                let i = 0;
                let nextToast;
                let prevToast;
                while(i <= removedFocusedToastIndex){
                    if (!allToasts[i].isRemoved) prevToast = Math.max(0, i - 1);
                    i++;
                }
                while(i < allToasts.length){
                    if (!allToasts[i].isRemoved) {
                        nextToast = i - 1;
                        break;
                    }
                    i++;
                }
                // in the case where it's one toast at a time, both will be undefined, but we know the index must be 0
                if (prevToast === undefined && nextToast === undefined) prevToast = 0;
                // prioritize going to newer toasts
                if (prevToast >= 0 && prevToast < toasts.current.length) (0, $2jk5s.focusWithoutScrolling)(toasts.current[prevToast]);
                else if (nextToast >= 0 && nextToast < toasts.current.length) (0, $2jk5s.focusWithoutScrolling)(toasts.current[nextToast]);
            }
        }
        prevVisibleToasts.current = state.visibleToasts;
    }, [
        state.visibleToasts,
        ref
    ]);
    let lastFocused = (0, $eF4cA.useRef)(null);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        onFocusWithin: (e)=>{
            isFocused.current = true;
            // oxlint-disable-next-line react/react-compiler
            lastFocused.current = e.relatedTarget;
            updateTimers();
        },
        onBlurWithin: ()=>{
            isFocused.current = false;
            // oxlint-disable-next-line react/react-compiler
            lastFocused.current = null;
            updateTimers();
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        if (state.visibleToasts.length === 0 && lastFocused.current?.isConnected) {
            if ((0, $YxOvP.getInteractionModality)() === 'pointer') (0, $2jk5s.focusWithoutScrolling)(lastFocused.current);
            else lastFocused.current.focus();
            // oxlint-disable-next-line react/react-compiler
            lastFocused.current = null;
        }
    }, [
        ref,
        state.visibleToasts.length
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (lastFocused.current?.isConnected) {
                if ((0, $YxOvP.getInteractionModality)() === 'pointer') (0, $2jk5s.focusWithoutScrolling)(lastFocused.current);
                else lastFocused.current.focus();
                lastFocused.current = null;
            }
        };
    }, [
        ref
    ]);
    return {
        // oxlint-disable-next-line react/react-compiler
        regionProps: (0, $lhKAD.mergeProps)(landmarkProps, hoverProps, focusWithinProps, {
            tabIndex: -1,
            // Mark the toast region as a "top layer", so that it:
            //   - is not aria-hidden when opening an overlay
            //   - allows focus even outside a containing focus scope
            //   - doesn’t dismiss overlays when clicking on it, even though it is outside
            // @ts-ignore
            'data-react-aria-top-layer': true,
            // listen to focus events separate from focuswithin because that will only fire once
            // and we need to follow all focus changes
            onFocus: (e)=>{
                let target = (0, $fvyIQ.getEventTarget)(e).closest('[role="alertdialog"]');
                focusedToast.current = toasts.current.findIndex((t)=>t === target);
            },
            onBlur: ()=>{
                focusedToast.current = -1;
            }
        })
    };
}

});
parcelRegister("ctOxu", function(module, exports) {

$parcel$export(module.exports, "useLandmark", () => $811475e7f8193bbe$export$4cc632584fd87fae);

var $fvyIQ = parcelRequire("fvyIQ");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");

var $5LhCr = parcelRequire("5LhCr");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Increment this version number whenever the
// LandmarkManagerApi or Landmark interfaces change.
const $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$LANDMARK_API_VERSION = 1;
// Symbol under which the singleton landmark manager instance is attached to the document.
const $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$landmarkSymbol = Symbol.for('react-aria-landmark-manager');
function $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$subscribe(fn) {
    document.addEventListener('react-aria-landmark-manager-change', fn);
    return ()=>document.removeEventListener('react-aria-landmark-manager-change', fn);
}
function $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$getLandmarkManager() {
    if (typeof document === 'undefined') return null;
    // Reuse an existing instance if it has the same or greater version.
    let instance = document[$811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$landmarkSymbol];
    if (instance && instance.version >= $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$LANDMARK_API_VERSION) return instance;
    // Otherwise, create a new instance and dispatch an event so anything using the existing
    // instance updates and re-registers their landmarks with the new one.
    document[$811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$landmarkSymbol] = new $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$LandmarkManager();
    document.dispatchEvent(new CustomEvent('react-aria-landmark-manager-change'));
    return document[$811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$landmarkSymbol];
}
// Subscribes a React component to the current landmark manager instance.
function $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$useLandmarkManager() {
    return (0, $5LhCr.useSyncExternalStore)($811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$subscribe, $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$getLandmarkManager, $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$getLandmarkManager);
}
class $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$LandmarkManager {
    constructor(){
        this.landmarks = [];
        this.isListening = false;
        this.refCount = 0;
        this.version = $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$LANDMARK_API_VERSION;
        this.f6Handler = this.f6Handler.bind(this);
        this.focusinHandler = this.focusinHandler.bind(this);
        this.focusoutHandler = this.focusoutHandler.bind(this);
    }
    setupIfNeeded() {
        if (this.isListening) return;
        document.addEventListener('keydown', this.f6Handler, {
            capture: true
        });
        document.addEventListener('focusin', this.focusinHandler, {
            capture: true
        });
        document.addEventListener('focusout', this.focusoutHandler, {
            capture: true
        });
        this.isListening = true;
    }
    teardownIfNeeded() {
        if (!this.isListening || this.landmarks.length > 0 || this.refCount > 0) return;
        document.removeEventListener('keydown', this.f6Handler, {
            capture: true
        });
        document.removeEventListener('focusin', this.focusinHandler, {
            capture: true
        });
        document.removeEventListener('focusout', this.focusoutHandler, {
            capture: true
        });
        this.isListening = false;
    }
    focusLandmark(landmark, direction) {
        this.landmarks.find((l)=>l.ref.current === landmark)?.focus?.(direction);
    }
    /**
   * Return set of landmarks with a specific role.
   */ getLandmarksByRole(role) {
        return new Set(this.landmarks.filter((l)=>l.role === role));
    }
    /**
   * Return first landmark with a specific role.
   */ getLandmarkByRole(role) {
        return this.landmarks.find((l)=>l.role === role);
    }
    addLandmark(newLandmark) {
        this.setupIfNeeded();
        if (this.landmarks.find((landmark)=>landmark.ref === newLandmark.ref) || !newLandmark.ref.current) return;
        this.landmarks.filter((landmark)=>landmark.role === 'main').length;
        if (this.landmarks.length === 0) {
            this.landmarks = [
                newLandmark
            ];
            this.checkLabels(newLandmark.role);
            return;
        }
        // Binary search to insert new landmark based on position in document relative to existing landmarks.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        let start = 0;
        let end = this.landmarks.length - 1;
        while(start <= end){
            let mid = Math.floor((start + end) / 2);
            let comparedPosition = newLandmark.ref.current.compareDocumentPosition(this.landmarks[mid].ref.current);
            let isNewAfterExisting = Boolean(comparedPosition & Node.DOCUMENT_POSITION_PRECEDING || comparedPosition & Node.DOCUMENT_POSITION_CONTAINS);
            if (isNewAfterExisting) start = mid + 1;
            else end = mid - 1;
        }
        this.landmarks.splice(start, 0, newLandmark);
        this.checkLabels(newLandmark.role);
    }
    updateLandmark(landmark) {
        let index = this.landmarks.findIndex((l)=>l.ref === landmark.ref);
        if (index >= 0) {
            this.landmarks[index] = {
                ...this.landmarks[index],
                ...landmark
            };
            this.checkLabels(this.landmarks[index].role);
        }
    }
    removeLandmark(ref) {
        this.landmarks = this.landmarks.filter((landmark)=>landmark.ref !== ref);
        this.teardownIfNeeded();
    }
    /**
   * Warn if there are 2+ landmarks with the same role but no label.
   * Labels for landmarks with the same role must also be unique.
   *
   * See https://www.w3.org/WAI/ARIA/apg/practices/landmark-regions/.
   */ checkLabels(role) {
        let landmarksWithRole = this.getLandmarksByRole(role);
        if (landmarksWithRole.size > 1) {
            let duplicatesWithoutLabel = [
                ...landmarksWithRole
            ].filter((landmark)=>!landmark.label);
            duplicatesWithoutLabel.length;
            var landmark;
            var label, landmark1, landmark2;
        }
    }
    /**
   * Get the landmark that is the closest parent in the DOM.
   * Returns undefined if no parent is a landmark.
   */ closestLandmark(element) {
        let landmarkMap = new Map(this.landmarks.map((l)=>[
                l.ref.current,
                l
            ]));
        let currentElement = element;
        while(currentElement && !landmarkMap.has(currentElement) && currentElement !== document.body && currentElement.parentElement)currentElement = currentElement.parentElement;
        return landmarkMap.get(currentElement);
    }
    /**
   * Gets the next landmark, in DOM focus order, or previous if backwards is specified.
   * If last landmark, next should be the first landmark.
   * If not inside a landmark, will return first landmark.
   * Returns undefined if there are no landmarks.
   */ getNextLandmark(element, { backward: backward }) {
        let currentLandmark = this.closestLandmark(element);
        let nextLandmarkIndex = backward ? this.landmarks.length - 1 : 0;
        if (currentLandmark) nextLandmarkIndex = this.landmarks.indexOf(currentLandmark) + (backward ? -1 : 1);
        let wrapIfNeeded = ()=>{
            // When we reach the end of the landmark sequence, fire a custom event that can be listened for by applications.
            // If this event is canceled, we return immediately. This can be used to implement landmark navigation across iframes.
            if (nextLandmarkIndex < 0) {
                if (!element.dispatchEvent(new CustomEvent('react-aria-landmark-navigation', {
                    detail: {
                        direction: 'backward'
                    },
                    bubbles: true,
                    cancelable: true
                }))) return true;
                nextLandmarkIndex = this.landmarks.length - 1;
            } else if (nextLandmarkIndex >= this.landmarks.length) {
                if (!element.dispatchEvent(new CustomEvent('react-aria-landmark-navigation', {
                    detail: {
                        direction: 'forward'
                    },
                    bubbles: true,
                    cancelable: true
                }))) return true;
                nextLandmarkIndex = 0;
            }
            if (nextLandmarkIndex < 0 || nextLandmarkIndex >= this.landmarks.length) return true;
            return false;
        };
        if (wrapIfNeeded()) return undefined;
        // Skip over hidden landmarks.
        let i = nextLandmarkIndex;
        while(this.landmarks[nextLandmarkIndex].ref.current?.closest('[aria-hidden=true]')){
            nextLandmarkIndex += backward ? -1 : 1;
            if (wrapIfNeeded()) return undefined;
            if (nextLandmarkIndex === i) break;
        }
        return this.landmarks[nextLandmarkIndex];
    }
    /**
   * Look at next landmark. If an element was previously focused inside, restore focus there.
   * If not, focus the landmark itself.
   * If no landmarks at all, or none with focusable elements, don't move focus.
   */ f6Handler(e) {
        if (e.key === 'F6') {
            // If alt key pressed, focus main landmark, otherwise navigate forward or backward based on shift key.
            let handled = e.altKey ? this.focusMain() : this.navigate((0, $fvyIQ.getEventTarget)(e), e.shiftKey);
            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
    focusMain() {
        let main = this.getLandmarkByRole('main');
        if (main && main.ref.current && main.ref.current.isConnected) {
            this.focusLandmark(main.ref.current, 'forward');
            return true;
        }
        return false;
    }
    navigate(from, backward) {
        let nextLandmark = this.getNextLandmark(from, {
            backward: backward
        });
        if (!nextLandmark) return false;
        // If something was previously focused in the next landmark, then return focus to it
        if (nextLandmark.lastFocused) {
            let lastFocused = nextLandmark.lastFocused;
            if ((0, $fvyIQ.nodeContains)(document.body, lastFocused)) {
                lastFocused.focus();
                return true;
            }
        }
        // Otherwise, focus the landmark itself
        if (nextLandmark.ref.current && nextLandmark.ref.current.isConnected) {
            this.focusLandmark(nextLandmark.ref.current, backward ? 'backward' : 'forward');
            return true;
        }
        return false;
    }
    /**
   * Sets lastFocused for a landmark, if focus is moved within that landmark.
   * Lets the last focused landmark know it was blurred if something else is focused.
   */ focusinHandler(e) {
        let currentLandmark = this.closestLandmark((0, $fvyIQ.getEventTarget)(e));
        if (currentLandmark && currentLandmark.ref.current !== (0, $fvyIQ.getEventTarget)(e)) this.updateLandmark({
            ref: currentLandmark.ref,
            lastFocused: (0, $fvyIQ.getEventTarget)(e)
        });
        let previousFocusedElement = e.relatedTarget;
        if (previousFocusedElement) {
            let closestPreviousLandmark = this.closestLandmark(previousFocusedElement);
            if (closestPreviousLandmark && closestPreviousLandmark.ref.current === previousFocusedElement) closestPreviousLandmark.blur();
        }
    }
    /**
   * Track if the focus is lost to the body. If it is, do cleanup on the landmark that last had
   * focus.
   */ focusoutHandler(e) {
        let previousFocusedElement = (0, $fvyIQ.getEventTarget)(e);
        let nextFocusedElement = e.relatedTarget;
        // the === document seems to be a jest thing for focus to go there on generic blur event such as landmark.blur();
        // browsers appear to send focus instead to document.body and the relatedTarget is null when that happens
        if (!nextFocusedElement || nextFocusedElement === document) {
            let closestPreviousLandmark = this.closestLandmark(previousFocusedElement);
            if (closestPreviousLandmark && closestPreviousLandmark.ref.current === previousFocusedElement) closestPreviousLandmark.blur();
        }
    }
    createLandmarkController() {
        let instance = this;
        instance.refCount++;
        instance.setupIfNeeded();
        return {
            navigate (direction, opts) {
                let element = opts?.from || document.activeElement;
                return instance.navigate(element, direction === 'backward');
            },
            focusNext (opts) {
                let element = opts?.from || document.activeElement;
                return instance.navigate(element, false);
            },
            focusPrevious (opts) {
                let element = opts?.from || document.activeElement;
                return instance.navigate(element, true);
            },
            focusMain () {
                return instance.focusMain();
            },
            dispose () {
                if (instance) {
                    instance.refCount--;
                    instance.teardownIfNeeded();
                    instance = null;
                }
            }
        };
    }
    registerLandmark(landmark) {
        if (this.landmarks.find((l)=>l.ref === landmark.ref)) this.updateLandmark(landmark);
        else this.addLandmark(landmark);
        return ()=>this.removeLandmark(landmark.ref);
    }
}
function $811475e7f8193bbe$export$a8e2debc6521490c() {
    // Get the current landmark manager and create a controller using it.
    let instance = $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$getLandmarkManager();
    let controller = instance?.createLandmarkController();
    let unsubscribe = $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$subscribe(()=>{
        // If the landmark manager changes, dispose the old
        // controller and create a new one.
        controller?.dispose();
        instance = $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$getLandmarkManager();
        controller = instance?.createLandmarkController();
    });
    // Return a wrapper that proxies requests to the current controller instance.
    return {
        navigate (direction, opts) {
            return controller.navigate(direction, opts);
        },
        focusNext (opts) {
            return controller.focusNext(opts);
        },
        focusPrevious (opts) {
            return controller.focusPrevious(opts);
        },
        focusMain () {
            return controller.focusMain();
        },
        dispose () {
            controller?.dispose();
            unsubscribe();
            controller = undefined;
            instance = null;
        }
    };
}
function $811475e7f8193bbe$export$4cc632584fd87fae(props, ref) {
    const { role: role, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, focus: focus } = props;
    let manager = $811475e7f8193bbe$var$$6b88d4883d4c7fe3$var$useLandmarkManager();
    let label = ariaLabel || ariaLabelledby;
    let [isLandmarkFocused, setIsLandmarkFocused] = (0, $eF4cA.useState)(false);
    let defaultFocus = (0, $eF4cA.useCallback)(()=>{
        setIsLandmarkFocused(true);
    }, [
        setIsLandmarkFocused
    ]);
    let blur = (0, $eF4cA.useCallback)(()=>{
        setIsLandmarkFocused(false);
    }, [
        setIsLandmarkFocused
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (manager) return manager.registerLandmark({
            ref: ref,
            label: label,
            role: role,
            focus: focus || defaultFocus,
            blur: blur
        });
    }, [
        manager,
        label,
        ref,
        role,
        focus,
        defaultFocus,
        blur
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (isLandmarkFocused) ref.current?.focus();
    }, [
        isLandmarkFocused,
        ref
    ]);
    return {
        landmarkProps: {
            role: role,
            tabIndex: isLandmarkFocused ? -1 : undefined,
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabelledby
        }
    };
}

});



parcelRegister("bTDob", function(module, exports) {

$parcel$export(module.exports, "useModalOverlay", () => $f02cdc93c60f7cde$export$dbc0f175b25fb0fb);

var $7eFu7 = parcelRequire("7eFu7");

var $8CJSz = parcelRequire("8CJSz");

var $lhKAD = parcelRequire("lhKAD");

var $k771r = parcelRequire("k771r");

var $ey1E7 = parcelRequire("ey1E7");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f02cdc93c60f7cde$export$dbc0f175b25fb0fb(props, state, ref) {
    let { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $8CJSz.useOverlay)({
        ...props,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    (0, $ey1E7.usePreventScroll)({
        isDisabled: !state.isOpen,
        UNSTABLE_overrideFocus: props.UNSTABLE_overrideFocus
    });
    (0, $k771r.useOverlayFocusContain)();
    let { isEntering: isEntering } = props;
    (0, $eF4cA.useEffect)(()=>{
        if (state.isOpen && ref.current) {
            if (isEntering) return (0, $7eFu7.keepVisible)(ref.current);
            return (0, $7eFu7.ariaHideOutside)([
                ref.current
            ], {
                shouldUseInert: true
            });
        }
    }, [
        state.isOpen,
        isEntering,
        ref
    ]);
    return {
        modalProps: (0, $lhKAD.mergeProps)(overlayProps),
        underlayProps: underlayProps
    };
}

});



parcelRegister("4CPg4", function(module, exports) {

$parcel$export(module.exports, "createImsSlice", () => $35e278d7565c4100$export$abb83416b22d2a37);

var $g0I9D = parcelRequire("g0I9D");
const $35e278d7565c4100$var$initialState = {
    ims: {
        profile: null,
        org: null,
        token: null,
        refreshToken: null,
        isLoggedIn: false,
        orgTokens: {}
    },
    locale: "en-US",
    redirectPath: null
};
const $35e278d7565c4100$export$abb83416b22d2a37 = (set)=>({
        ...$35e278d7565c4100$var$initialState,
        /**
   * Sets the IMS and locale state.
   *
   * @param {object} param0 - The new IMS and locale state.
   *
   * @returns {void}
   */ setIms: ({ ims: ims, locale: locale })=>set((state)=>({
                    ...state,
                    ims: ims,
                    locale: locale,
                    isLoggedIn: !!ims.token && !!ims?.profile?.email
                }), undefined, "ims/setIms"),
        /**
   * Sets the locale.
   *
   * @param {string} locale - The new locale.
   *
   * @returns {void}
   */ setLocale: (locale)=>set((0, $g0I9D.produce)((state)=>{
                state.locale = locale;
            }), undefined, "ims/setLocale"),
        /**
   * Sets the token.
   *
   * @param {string} token - The new token.
   *
   * @returns {void}
   */ setToken: (token)=>set((0, $g0I9D.produce)((state)=>{
                state.ims.token = token;
            }), undefined, "ims/setToken"),
        /**
   * Sets the refresh token.
   *
   * @param {string} refreshToken - The new refresh token.
   *
   * @returns {void}
   */ setRefreshToken: (refreshToken)=>set((0, $g0I9D.produce)((state)=>{
                state.ims.refreshToken = refreshToken;
            }), undefined, "ims/setRefreshToken"),
        /**
   * Sets the organization ID.
   *
   * @param {string} org - The new organization ID.
   *
   * @returns {void}
   */ setImsOrg: (org)=>set((0, $g0I9D.produce)((state)=>{
                state.ims.org = org;
            }), undefined, "ims/setImsOrg"),
        /**
   * Sets the redirect path.
   *
   * @param {string} path - The new redirect path.
   *
   * @returns {void}
   */ setRedirectPath: (path)=>set({
                redirectPath: path
            }, undefined, "ims/setRedirectPath"),
        /**
   * Sets an organization token.
   *
   * @param {string} orgId - The organization ID.
   * @param {string} token - The organization token.
   *
   * @returns {void}
   */ setOrgToken: (orgId, token)=>set((0, $g0I9D.produce)((state)=>{
                state.ims.orgTokens = {
                    ...state.ims.orgTokens ?? {},
                    [orgId]: token
                };
            }), undefined, "ims/setOrgToken"),
        /**
   * Gets an organization token.
   *
   * @param {string} orgId - The organization ID.
   *
   * @returns {string|null} The organization token or null if not found.
   */ getOrgToken: (orgId)=>(state)=>state.ims.orgTokens[orgId] || null,
        /**
   * Clears the IMS state.
   *
   * @returns {void}
   */ clearIms: ()=>set((state)=>({
                    ...state,
                    ...$35e278d7565c4100$var$initialState
                }), undefined, "ims/clearIms")
    });

});
parcelRegister("g0I9D", function(module, exports) {

$parcel$export(module.exports, "produce", () => $f2af581bc1df50a6$export$b46cabe22e78bc00);
// src/utils/env.ts
var $f2af581bc1df50a6$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $f2af581bc1df50a6$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $f2af581bc1df50a6$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $f2af581bc1df50a6$var$errors = [];
function $f2af581bc1df50a6$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $f2af581bc1df50a6$var$O = Object;
var $f2af581bc1df50a6$var$getPrototypeOf = $f2af581bc1df50a6$var$O.getPrototypeOf;
var $f2af581bc1df50a6$var$CONSTRUCTOR = "constructor";
var $f2af581bc1df50a6$var$PROTOTYPE = "prototype";
var $f2af581bc1df50a6$var$CONFIGURABLE = "configurable";
var $f2af581bc1df50a6$var$ENUMERABLE = "enumerable";
var $f2af581bc1df50a6$var$WRITABLE = "writable";
var $f2af581bc1df50a6$var$VALUE = "value";
var $f2af581bc1df50a6$export$541ac630993a4c84 = (value)=>!!value && !!value[$f2af581bc1df50a6$var$DRAFT_STATE];
function $f2af581bc1df50a6$export$f9ded33a1a6c97c7(value) {
    if (!$f2af581bc1df50a6$export$541ac630993a4c84(value)) return false;
    return value[$f2af581bc1df50a6$var$DRAFT_STATE].modified_;
}
function $f2af581bc1df50a6$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $f2af581bc1df50a6$var$isPlainObject(value) || $f2af581bc1df50a6$var$isArray(value) || !!value[$f2af581bc1df50a6$export$6ee2082928bcb0ee] || !!value[$f2af581bc1df50a6$var$CONSTRUCTOR]?.[$f2af581bc1df50a6$export$6ee2082928bcb0ee] || $f2af581bc1df50a6$var$isMap(value) || $f2af581bc1df50a6$var$isSet(value);
}
var $f2af581bc1df50a6$var$objectCtorString = $f2af581bc1df50a6$var$O[$f2af581bc1df50a6$var$PROTOTYPE][$f2af581bc1df50a6$var$CONSTRUCTOR].toString();
var $f2af581bc1df50a6$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $f2af581bc1df50a6$var$isPlainObject(value) {
    if (!value || !$f2af581bc1df50a6$var$isObjectish(value)) return false;
    const proto = $f2af581bc1df50a6$var$getPrototypeOf(value);
    if (proto === null || proto === $f2af581bc1df50a6$var$O[$f2af581bc1df50a6$var$PROTOTYPE]) return true;
    const Ctor = $f2af581bc1df50a6$var$O.hasOwnProperty.call(proto, $f2af581bc1df50a6$var$CONSTRUCTOR) && proto[$f2af581bc1df50a6$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$f2af581bc1df50a6$var$isFunction(Ctor)) return false;
    let ctorString = $f2af581bc1df50a6$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $f2af581bc1df50a6$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $f2af581bc1df50a6$var$objectCtorString;
}
function $f2af581bc1df50a6$export$22e8af3f75a010e3(value) {
    if (!$f2af581bc1df50a6$export$541ac630993a4c84(value)) $f2af581bc1df50a6$var$die(15, value);
    return value[$f2af581bc1df50a6$var$DRAFT_STATE].base_;
}
function $f2af581bc1df50a6$var$each(obj, iter, strict = true) {
    if ($f2af581bc1df50a6$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $f2af581bc1df50a6$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $f2af581bc1df50a6$var$getArchtype(thing) {
    const state = thing[$f2af581bc1df50a6$var$DRAFT_STATE];
    return state ? state.type_ : $f2af581bc1df50a6$var$isArray(thing) ? 1 /* Array */  : $f2af581bc1df50a6$var$isMap(thing) ? 2 /* Map */  : $f2af581bc1df50a6$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $f2af581bc1df50a6$var$has = (thing, prop, type = $f2af581bc1df50a6$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $f2af581bc1df50a6$var$O[$f2af581bc1df50a6$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $f2af581bc1df50a6$var$get = (thing, prop, type = $f2af581bc1df50a6$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $f2af581bc1df50a6$var$set = (thing, propOrOldValue, value, type = $f2af581bc1df50a6$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $f2af581bc1df50a6$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $f2af581bc1df50a6$var$isArray = Array.isArray;
var $f2af581bc1df50a6$var$isMap = (target)=>target instanceof Map;
var $f2af581bc1df50a6$var$isSet = (target)=>target instanceof Set;
var $f2af581bc1df50a6$var$isObjectish = (target)=>typeof target === "object";
var $f2af581bc1df50a6$var$isFunction = (target)=>typeof target === "function";
var $f2af581bc1df50a6$var$isBoolean = (target)=>typeof target === "boolean";
function $f2af581bc1df50a6$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $f2af581bc1df50a6$var$getProxyDraft = (value)=>{
    if (!$f2af581bc1df50a6$var$isObjectish(value)) return null;
    return value?.[$f2af581bc1df50a6$var$DRAFT_STATE];
};
var $f2af581bc1df50a6$var$latest = (state)=>state.copy_ || state.base_;
var $f2af581bc1df50a6$var$getValue = (value)=>{
    const proxyDraft = $f2af581bc1df50a6$var$getProxyDraft(value);
    return proxyDraft ? $f2af581bc1df50a6$var$getFinalValue(proxyDraft) : value;
};
var $f2af581bc1df50a6$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $f2af581bc1df50a6$var$shallowCopy(base, strict) {
    if ($f2af581bc1df50a6$var$isMap(base)) return new Map(base);
    if ($f2af581bc1df50a6$var$isSet(base)) return new Set(base);
    if ($f2af581bc1df50a6$var$isArray(base)) return Array[$f2af581bc1df50a6$var$PROTOTYPE].slice.call(base);
    const isPlain = $f2af581bc1df50a6$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $f2af581bc1df50a6$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$f2af581bc1df50a6$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$f2af581bc1df50a6$var$WRITABLE] === false) {
                desc[$f2af581bc1df50a6$var$WRITABLE] = true;
                desc[$f2af581bc1df50a6$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$f2af581bc1df50a6$var$CONFIGURABLE]: true,
                [$f2af581bc1df50a6$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$f2af581bc1df50a6$var$ENUMERABLE]: desc[$f2af581bc1df50a6$var$ENUMERABLE],
                [$f2af581bc1df50a6$var$VALUE]: base[key]
            };
        }
        return $f2af581bc1df50a6$var$O.create($f2af581bc1df50a6$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $f2af581bc1df50a6$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $f2af581bc1df50a6$var$O.create(proto);
        return $f2af581bc1df50a6$var$O.assign(obj, base);
    }
}
function $f2af581bc1df50a6$export$792f3d81ea979f55(obj, deep = false) {
    if ($f2af581bc1df50a6$var$isFrozen(obj) || $f2af581bc1df50a6$export$541ac630993a4c84(obj) || !$f2af581bc1df50a6$export$16e3aed3edb85946(obj)) return obj;
    if ($f2af581bc1df50a6$var$getArchtype(obj) > 1) $f2af581bc1df50a6$var$O.defineProperties(obj, {
        set: $f2af581bc1df50a6$var$dontMutateMethodOverride,
        add: $f2af581bc1df50a6$var$dontMutateMethodOverride,
        clear: $f2af581bc1df50a6$var$dontMutateMethodOverride,
        delete: $f2af581bc1df50a6$var$dontMutateMethodOverride
    });
    $f2af581bc1df50a6$var$O.freeze(obj);
    if (deep) $f2af581bc1df50a6$var$each(obj, (_key, value)=>{
        $f2af581bc1df50a6$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $f2af581bc1df50a6$var$dontMutateFrozenCollections() {
    $f2af581bc1df50a6$var$die(2);
}
var $f2af581bc1df50a6$var$dontMutateMethodOverride = {
    [$f2af581bc1df50a6$var$VALUE]: $f2af581bc1df50a6$var$dontMutateFrozenCollections
};
function $f2af581bc1df50a6$var$isFrozen(obj) {
    if (obj === null || !$f2af581bc1df50a6$var$isObjectish(obj)) return true;
    return $f2af581bc1df50a6$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $f2af581bc1df50a6$var$PluginMapSet = "MapSet";
var $f2af581bc1df50a6$var$PluginPatches = "Patches";
var $f2af581bc1df50a6$var$PluginArrayMethods = "ArrayMethods";
var $f2af581bc1df50a6$var$plugins = {};
function $f2af581bc1df50a6$var$getPlugin(pluginKey) {
    const plugin = $f2af581bc1df50a6$var$plugins[pluginKey];
    if (!plugin) $f2af581bc1df50a6$var$die(0, pluginKey);
    return plugin;
}
var $f2af581bc1df50a6$var$isPluginLoaded = (pluginKey)=>!!$f2af581bc1df50a6$var$plugins[pluginKey];
function $f2af581bc1df50a6$var$loadPlugin(pluginKey, implementation) {
    if (!$f2af581bc1df50a6$var$plugins[pluginKey]) $f2af581bc1df50a6$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $f2af581bc1df50a6$var$currentScope;
var $f2af581bc1df50a6$var$getCurrentScope = ()=>$f2af581bc1df50a6$var$currentScope;
var $f2af581bc1df50a6$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $f2af581bc1df50a6$var$isPluginLoaded($f2af581bc1df50a6$var$PluginMapSet) ? $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $f2af581bc1df50a6$var$isPluginLoaded($f2af581bc1df50a6$var$PluginArrayMethods) ? $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginArrayMethods) : void 0
    });
function $f2af581bc1df50a6$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $f2af581bc1df50a6$var$revokeScope(scope) {
    $f2af581bc1df50a6$var$leaveScope(scope);
    scope.drafts_.forEach($f2af581bc1df50a6$var$revokeDraft);
    scope.drafts_ = null;
}
function $f2af581bc1df50a6$var$leaveScope(scope) {
    if (scope === $f2af581bc1df50a6$var$currentScope) $f2af581bc1df50a6$var$currentScope = scope.parent_;
}
var $f2af581bc1df50a6$var$enterScope = (immer2)=>$f2af581bc1df50a6$var$currentScope = $f2af581bc1df50a6$var$createScope($f2af581bc1df50a6$var$currentScope, immer2);
function $f2af581bc1df50a6$var$revokeDraft(draft) {
    const state = draft[$f2af581bc1df50a6$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $f2af581bc1df50a6$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$f2af581bc1df50a6$var$DRAFT_STATE].modified_) {
            $f2af581bc1df50a6$var$revokeScope(scope);
            $f2af581bc1df50a6$var$die(4);
        }
        if ($f2af581bc1df50a6$export$16e3aed3edb85946(result)) result = $f2af581bc1df50a6$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$f2af581bc1df50a6$var$DRAFT_STATE].base_, result, scope);
    } else result = $f2af581bc1df50a6$var$finalize(scope, baseDraft);
    $f2af581bc1df50a6$var$maybeFreeze(scope, result, true);
    $f2af581bc1df50a6$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $f2af581bc1df50a6$export$45b790e32b2810ee ? result : void 0;
}
function $f2af581bc1df50a6$var$finalize(rootScope, value) {
    if ($f2af581bc1df50a6$var$isFrozen(value)) return value;
    const state = value[$f2af581bc1df50a6$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $f2af581bc1df50a6$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$f2af581bc1df50a6$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $f2af581bc1df50a6$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $f2af581bc1df50a6$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $f2af581bc1df50a6$export$792f3d81ea979f55(value, deep);
}
function $f2af581bc1df50a6$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $f2af581bc1df50a6$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $f2af581bc1df50a6$var$EMPTY_LOCATIONS_RESULT = [];
function $f2af581bc1df50a6$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $f2af581bc1df50a6$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $f2af581bc1df50a6$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $f2af581bc1df50a6$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $f2af581bc1df50a6$var$each(parentCopy, (key, value)=>{
            if ($f2af581bc1df50a6$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $f2af581bc1df50a6$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$f2af581bc1df50a6$var$set(parentCopy, location, finalizedValue, parentType);
}
function $f2af581bc1df50a6$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$f2af581bc1df50a6$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $f2af581bc1df50a6$var$getFinalValue(state);
        $f2af581bc1df50a6$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $f2af581bc1df50a6$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $f2af581bc1df50a6$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $f2af581bc1df50a6$var$markStateFinalized(state);
    }
}
function $f2af581bc1df50a6$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($f2af581bc1df50a6$export$541ac630993a4c84(value)) {
        const state = value[$f2af581bc1df50a6$var$DRAFT_STATE];
        if ($f2af581bc1df50a6$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $f2af581bc1df50a6$var$prepareCopy(target);
            const finalizedValue = $f2af581bc1df50a6$var$getFinalValue(state);
            $f2af581bc1df50a6$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($f2af581bc1df50a6$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $f2af581bc1df50a6$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $f2af581bc1df50a6$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($f2af581bc1df50a6$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $f2af581bc1df50a6$var$handleValue($f2af581bc1df50a6$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $f2af581bc1df50a6$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($f2af581bc1df50a6$export$541ac630993a4c84(target) || handledSet.has(target) || !$f2af581bc1df50a6$export$16e3aed3edb85946(target) || $f2af581bc1df50a6$var$isFrozen(target)) return target;
    handledSet.add(target);
    $f2af581bc1df50a6$var$each(target, (key, value)=>{
        if ($f2af581bc1df50a6$export$541ac630993a4c84(value)) {
            const state = value[$f2af581bc1df50a6$var$DRAFT_STATE];
            if ($f2af581bc1df50a6$var$isSameScope(state, rootScope)) {
                const updatedValue = $f2af581bc1df50a6$var$getFinalValue(state);
                $f2af581bc1df50a6$var$set(target, key, updatedValue, target.type_);
                $f2af581bc1df50a6$var$markStateFinalized(state);
            }
        } else if ($f2af581bc1df50a6$export$16e3aed3edb85946(value)) $f2af581bc1df50a6$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $f2af581bc1df50a6$var$createProxyProxy(base, parent) {
    const baseIsArray = $f2af581bc1df50a6$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $f2af581bc1df50a6$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $f2af581bc1df50a6$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $f2af581bc1df50a6$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $f2af581bc1df50a6$var$objectTraps = {
    get (state, prop) {
        if (prop === $f2af581bc1df50a6$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $f2af581bc1df50a6$var$latest(state);
        if (!$f2af581bc1df50a6$var$has(source, prop, state.type_)) return $f2af581bc1df50a6$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$f2af581bc1df50a6$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $f2af581bc1df50a6$var$isArrayIndex(prop)) return value;
        if (value === $f2af581bc1df50a6$var$peek(state.base_, prop) || $f2af581bc1df50a6$var$isRelocatedBaseRef(state, prop, value)) {
            $f2af581bc1df50a6$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $f2af581bc1df50a6$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $f2af581bc1df50a6$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($f2af581bc1df50a6$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $f2af581bc1df50a6$var$getDescriptorFromProto($f2af581bc1df50a6$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $f2af581bc1df50a6$var$peek($f2af581bc1df50a6$var$latest(state), prop);
            const currentState = current2?.[$f2af581bc1df50a6$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.delete(prop);
                return true;
            }
            if ($f2af581bc1df50a6$var$is(value, current2) && (value !== void 0 || $f2af581bc1df50a6$var$has(state.base_, prop, state.type_))) return true;
            $f2af581bc1df50a6$var$prepareCopy(state);
            $f2af581bc1df50a6$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $f2af581bc1df50a6$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $f2af581bc1df50a6$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $f2af581bc1df50a6$var$prepareCopy(state);
        if ($f2af581bc1df50a6$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $f2af581bc1df50a6$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $f2af581bc1df50a6$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$f2af581bc1df50a6$var$WRITABLE]: true,
            [$f2af581bc1df50a6$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$f2af581bc1df50a6$var$ENUMERABLE]: desc[$f2af581bc1df50a6$var$ENUMERABLE],
            [$f2af581bc1df50a6$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $f2af581bc1df50a6$var$die(11);
    },
    getPrototypeOf (state) {
        return $f2af581bc1df50a6$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $f2af581bc1df50a6$var$die(12);
    }
};
var $f2af581bc1df50a6$var$arrayTraps = {};
for(let key in $f2af581bc1df50a6$var$objectTraps){
    let fn = $f2af581bc1df50a6$var$objectTraps[key];
    $f2af581bc1df50a6$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$f2af581bc1df50a6$var$arrayTraps.deleteProperty = function(state, prop) {
    return $f2af581bc1df50a6$var$arrayTraps.set.call(this, state, prop, void 0);
};
$f2af581bc1df50a6$var$arrayTraps.set = function(state, prop, value) {
    return $f2af581bc1df50a6$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $f2af581bc1df50a6$var$peek(draft, prop) {
    const state = draft[$f2af581bc1df50a6$var$DRAFT_STATE];
    const source = state ? $f2af581bc1df50a6$var$latest(state) : draft;
    return source[prop];
}
function $f2af581bc1df50a6$var$isRelocatedBaseRef(state, prop, value) {
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || !$f2af581bc1df50a6$export$16e3aed3edb85946(value) || value[$f2af581bc1df50a6$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $f2af581bc1df50a6$var$readPropFromProto(state, source, prop) {
    const desc = $f2af581bc1df50a6$var$getDescriptorFromProto(source, prop);
    return desc ? $f2af581bc1df50a6$var$VALUE in desc ? desc[$f2af581bc1df50a6$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $f2af581bc1df50a6$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $f2af581bc1df50a6$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $f2af581bc1df50a6$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $f2af581bc1df50a6$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $f2af581bc1df50a6$var$markChanged(state.parent_);
    }
}
function $f2af581bc1df50a6$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $f2af581bc1df50a6$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $f2af581bc1df50a6$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($f2af581bc1df50a6$var$isFunction(base) && !$f2af581bc1df50a6$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$f2af581bc1df50a6$var$isFunction(recipe)) $f2af581bc1df50a6$var$die(6);
            if (patchListener !== void 0 && !$f2af581bc1df50a6$var$isFunction(patchListener)) $f2af581bc1df50a6$var$die(7);
            let result;
            if ($f2af581bc1df50a6$export$16e3aed3edb85946(base)) {
                const scope = $f2af581bc1df50a6$var$enterScope(this);
                const proxy = $f2af581bc1df50a6$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $f2af581bc1df50a6$var$revokeScope(scope);
                    else $f2af581bc1df50a6$var$leaveScope(scope);
                }
                $f2af581bc1df50a6$var$usePatchesInScope(scope, patchListener);
                return $f2af581bc1df50a6$var$processResult(result, scope);
            } else if (!base || !$f2af581bc1df50a6$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $f2af581bc1df50a6$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $f2af581bc1df50a6$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $f2af581bc1df50a6$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($f2af581bc1df50a6$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($f2af581bc1df50a6$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($f2af581bc1df50a6$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($f2af581bc1df50a6$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$f2af581bc1df50a6$export$16e3aed3edb85946(base)) $f2af581bc1df50a6$var$die(8);
        if ($f2af581bc1df50a6$export$541ac630993a4c84(base)) base = $f2af581bc1df50a6$export$97aac956da55dae9(base);
        const scope = $f2af581bc1df50a6$var$enterScope(this);
        const proxy = $f2af581bc1df50a6$var$createProxy(scope, base, void 0);
        proxy[$f2af581bc1df50a6$var$DRAFT_STATE].isManual_ = true;
        $f2af581bc1df50a6$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$f2af581bc1df50a6$var$DRAFT_STATE];
        if (!state || !state.isManual_) $f2af581bc1df50a6$var$die(9);
        const { scope_: scope } = state;
        $f2af581bc1df50a6$var$usePatchesInScope(scope, patchListener);
        return $f2af581bc1df50a6$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginPatches).applyPatches_;
        if ($f2af581bc1df50a6$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $f2af581bc1df50a6$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $f2af581bc1df50a6$var$isMap(value) ? $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginMapSet).proxyMap_(value, parent) : $f2af581bc1df50a6$var$isSet(value) ? $f2af581bc1df50a6$var$getPlugin($f2af581bc1df50a6$var$PluginMapSet).proxySet_(value, parent) : $f2af581bc1df50a6$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $f2af581bc1df50a6$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $f2af581bc1df50a6$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $f2af581bc1df50a6$export$97aac956da55dae9(value) {
    if (!$f2af581bc1df50a6$export$541ac630993a4c84(value)) $f2af581bc1df50a6$var$die(10, value);
    return $f2af581bc1df50a6$var$currentImpl(value);
}
function $f2af581bc1df50a6$var$currentImpl(value) {
    if (!$f2af581bc1df50a6$export$16e3aed3edb85946(value) || $f2af581bc1df50a6$var$isFrozen(value)) return value;
    const state = value[$f2af581bc1df50a6$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $f2af581bc1df50a6$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $f2af581bc1df50a6$var$shallowCopy(value, true);
    const source = copy;
    if ($f2af581bc1df50a6$var$isSet(copy)) copy = /* @__PURE__ */ new Set();
    $f2af581bc1df50a6$var$each(source, (key, childValue)=>{
        $f2af581bc1df50a6$var$set(copy, key, $f2af581bc1df50a6$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $f2af581bc1df50a6$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $f2af581bc1df50a6$var$getProxyDraft($f2af581bc1df50a6$var$get(parentCopy, state.key_));
            const valueAtKey = $f2af581bc1df50a6$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $f2af581bc1df50a6$var$has(parentCopy, key))) return null;
            if (state.parent_.type_ === 1 /* Array */  && state.parent_.allIndicesReassigned_) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $f2af581bc1df50a6$var$get(current2, key);
            if (!$f2af581bc1df50a6$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$f2af581bc1df50a6$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $f2af581bc1df50a6$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $f2af581bc1df50a6$var$get(base_, key, type_);
            const value = $f2af581bc1df50a6$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $f2af581bc1df50a6$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $f2af581bc1df50a6$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $f2af581bc1df50a6$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $f2af581bc1df50a6$var$CONSTRUCTOR)) $f2af581bc1df50a6$var$die(errorOffset + 3);
                if ($f2af581bc1df50a6$var$isFunction(base) && p === $f2af581bc1df50a6$var$PROTOTYPE) $f2af581bc1df50a6$var$die(errorOffset + 3);
                base = $f2af581bc1df50a6$var$get(base, p);
                if (base === null || !$f2af581bc1df50a6$var$isObjectish(base)) $f2af581bc1df50a6$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $f2af581bc1df50a6$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $f2af581bc1df50a6$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $f2af581bc1df50a6$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$f2af581bc1df50a6$export$16e3aed3edb85946(obj)) return obj;
        if ($f2af581bc1df50a6$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($f2af581bc1df50a6$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($f2af581bc1df50a6$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($f2af581bc1df50a6$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($f2af581bc1df50a6$var$has(obj, $f2af581bc1df50a6$export$6ee2082928bcb0ee)) cloned[$f2af581bc1df50a6$export$6ee2082928bcb0ee] = obj[$f2af581bc1df50a6$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($f2af581bc1df50a6$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $f2af581bc1df50a6$var$loadPlugin($f2af581bc1df50a6$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
var $f2af581bc1df50a6$var$_globalIterator = globalThis.Iterator;
var $f2af581bc1df50a6$var$hasIteratorFrom = typeof $f2af581bc1df50a6$var$_globalIterator?.from === "function";
function $f2af581bc1df50a6$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$f2af581bc1df50a6$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f2af581bc1df50a6$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $f2af581bc1df50a6$var$latest(state).size;
        }
        has(key) {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $f2af581bc1df50a6$var$latest(state).has(key);
        }
        set(key, value) {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$f2af581bc1df50a6$var$latest(state).has(key) || $f2af581bc1df50a6$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $f2af581bc1df50a6$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $f2af581bc1df50a6$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $f2af581bc1df50a6$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f2af581bc1df50a6$var$latest(state).size) {
                prepareMapCopy(state);
                $f2af581bc1df50a6$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $f2af581bc1df50a6$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $f2af581bc1df50a6$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $f2af581bc1df50a6$var$latest(state).get(key);
            if (state.finalized_ || !$f2af581bc1df50a6$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $f2af581bc1df50a6$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            return $f2af581bc1df50a6$var$latest(state).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($f2af581bc1df50a6$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if ($f2af581bc1df50a6$var$hasIteratorFrom) return $f2af581bc1df50a6$var$_globalIterator.from(iterable);
        const iterator = {
            ...iterable,
            [Symbol.iterator]: ()=>iterator
        };
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$f2af581bc1df50a6$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$f2af581bc1df50a6$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f2af581bc1df50a6$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $f2af581bc1df50a6$var$latest(state).size;
        }
        has(value) {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $f2af581bc1df50a6$var$markChanged(state);
                state.copy_.add(value);
                $f2af581bc1df50a6$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $f2af581bc1df50a6$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f2af581bc1df50a6$var$latest(state).size) {
                prepareSetCopy(state);
                $f2af581bc1df50a6$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$f2af581bc1df50a6$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($f2af581bc1df50a6$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$f2af581bc1df50a6$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($f2af581bc1df50a6$export$16e3aed3edb85946(value)) {
                    const draft = $f2af581bc1df50a6$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $f2af581bc1df50a6$var$die(3, JSON.stringify($f2af581bc1df50a6$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($f2af581bc1df50a6$var$getValue(value));
            });
        }
    }
    $f2af581bc1df50a6$var$loadPlugin($f2af581bc1df50a6$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $f2af581bc1df50a6$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $f2af581bc1df50a6$var$prepareCopy(state);
        const result = operation();
        markArrayChanged(state, markLength);
        return result;
    }
    function markArrayChanged(state, markLength = true) {
        $f2af581bc1df50a6$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $f2af581bc1df50a6$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        const isInsert = method === "push" || method === "unshift";
        if (isInsert ? args.length === 0 : $f2af581bc1df50a6$var$latest(state).length === 0) return isInsert ? $f2af581bc1df50a6$var$latest(state).length : void 0;
        $f2af581bc1df50a6$var$prepareCopy(state);
        const lengthBefore = state.copy_.length;
        const result = state.copy_[method](...args);
        markArrayChanged(state);
        if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
        if (method === "push") handleInsertedValues(state, lengthBefore, args);
        else if (method === "unshift") handleInsertedValues(state, 0, args);
        return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
    }
    function handleReorderingOperation(state, method, args) {
        if ($f2af581bc1df50a6$var$latest(state).length <= 1) return state.draft_;
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const insertCount = args.length > 2 ? args.length - 2 : 0;
                        if (insertCount === 0) {
                            const length = $f2af581bc1df50a6$var$latest(state).length;
                            if (args.length === 0 || normalizeSliceIndex(args[0] ?? 0, length) === length || args.length > 1 && !(args[1] >= 1)) return [];
                        }
                        $f2af581bc1df50a6$var$prepareCopy(state);
                        const lengthBefore = state.copy_.length;
                        const res = state.copy_.splice(...args);
                        if (res.length === 0 && insertCount === 0) return res;
                        markArrayChanged(state);
                        markAllIndicesReassigned(state);
                        if (insertCount > 0) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, lengthBefore);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $f2af581bc1df50a6$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const thisArg = args[1];
            const result = [];
            const length = source.length;
            for(let i = 0; i < length; i++)if (predicate.call(thisArg, source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const thisArg = args[1];
            const length = source.length;
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : length - 1;
            for(let i = start; i >= 0 && i < length; i += step){
                if (predicate.call(thisArg, source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $f2af581bc1df50a6$var$loadPlugin($f2af581bc1df50a6$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $f2af581bc1df50a6$var$immer = new $f2af581bc1df50a6$export$aaadc6ff0f822719();
var $f2af581bc1df50a6$export$b46cabe22e78bc00 = $f2af581bc1df50a6$var$immer.produce;
var $f2af581bc1df50a6$export$4da66d41c9492c78 = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.produceWithPatches.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$573f26f60825c493 = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.setAutoFreeze.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$333ce65961cbe047 = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.setUseStrictShallowCopy.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$1045b3be3904c489 = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.setUseStrictIteration.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.applyPatches.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$3c3214997190395f = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.createDraft.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$c60f5e69c521b528 = /* @__PURE__ */ $f2af581bc1df50a6$var$immer.finishDraft.bind($f2af581bc1df50a6$var$immer);
var $f2af581bc1df50a6$export$c05b21e3257751e5 = (value)=>value;
var $f2af581bc1df50a6$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("1k12E", function(module, exports) {

$parcel$export(module.exports, "createStorySlice", () => $0f687796e3e045ef$export$e8ef992788b838e);

var $g0I9D = parcelRequire("g0I9D");
parcelRequire("aKSBi");
parcelRequire("D7J7L");
parcelRequire("17n4p");

var $VXM1R = parcelRequire("VXM1R");

var $1B1zl = parcelRequire("1B1zl");
const $0f687796e3e045ef$export$e8ef992788b838e = (set, get)=>({
        stories: [],
        setStories: (stories)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.stories = stories.map((story)=>{
                    const stateStory = state.stories.find((s)=>s.id === story.id);
                    return stateStory ? {
                        ...stateStory,
                        ...story
                    } : story;
                });
            }), undefined, "story/setStories");
        },
        isFetchingStories: false,
        /**
   * Sets the fetching state for stories.
   *
   * @param {boolean} isFetching - Whether stories are being fetched.
   *
   * @returns {void}
   */ setFetchingStories: (isFetching)=>set({
                isFetchingStories: isFetching
            }, undefined, "story/setFetchingStories"),
        isFetchingStory: {},
        /**
   * Sets the fetching state for a specific story.
   *
   * @param {string} id - The ID of the story.
   * @param {boolean} isFetching - Whether the story is being fetched.
   *
   * @returns {void}
   */ setFetchingStory: (id1, isFetching)=>set((0, $g0I9D.produce)((state)=>{
                state.isFetchingStory[id1] = isFetching;
            }), undefined, "story/setFetchingStory"),
        /**
   * Retrieves a story from the state by its ID.
   *
   * @param {string} id - The ID of the story.
   *
   * @returns {Object|null} - The story object if found, or null.
   */ getStory: (id1)=>(0, $1B1zl.queryClient).getQueryData((0, $VXM1R.storyKey).detail(id1)) ?? null,
        /**
   * Updates a story in the state.
   *
   * @param {string} id - The ID of the story.
   * @param {Object} update - The update to apply to the story.
   *
   * @returns {void}
   */ updateStory: (id1, update)=>{
            set((0, $g0I9D.produce)((state)=>{
                const index = state.stories.findIndex((story)=>story.id === id1);
                if (index !== -1) state.stories[index] = {
                    ...state.stories[index],
                    ...update
                };
                else state.stories.push({
                    id: id1,
                    ...update
                });
            }), undefined, "story/updateStory");
        },
        /**
   * Generates images for the story with the given ID.
   *
   * @param {string} id - The ID of the story.
   * @param {boolean} [forceGenerate=false] - Whether to force image generation even if they already exist.
   *
   * @returns {Promise<void>}
   */ generateStoryImages: async (id1, forceGenerate = false)=>{
            const story = get().getStory(id1);
            if (!story) {
                console.error(`Story with id ${id1} not found`);
                return;
            }
            if (story.personas?.some((p)=>!p.avatarPrompt) || forceGenerate) await get().generatePersonas(id1);
            const personasPromises = [];
            const visualsPromises = [];
            // FIXME: don't generate personas images if they already exist
            // if (
            //   story.personas?.some(
            //     (p) => !p.libraryId && !p.avatarId || !p.avatarUrl,
            //   ) ||
            //   forceGenerate
            // ) {
            //   personasPromises.push(get().generatePersonasImages(id));
            // }
            if (story.script?.some((step)=>!step.visuals?.length) || forceGenerate) visualsPromises.push(get().fetchVisuals(id1));
            await Promise.all(personasPromises);
            await Promise.all(visualsPromises);
            // Invalidate and refetch the story to get the latest data from the server
            await (0, $1B1zl.queryClient).invalidateQueries({
                queryKey: (0, $VXM1R.storyKey).detail(id1)
            });
        },
        isCheckStoryVisualsPending: {},
        /**
   * Sets the loading state for checking story visuals.
   *
   * @param {string} id - The ID of the story.
   * @param {boolean} isPending - Whether the check is pending.
   *
   * @returns {void}
   */ setCheckStoryVisualsPending: (id1, isPending)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.isCheckStoryVisualsPending[id1] = isPending;
            }), undefined, "story/setCheckStoryVisualsPending");
        },
        lastVisualCheck: {},
        /**
   * Sets the last visual check timestamp for a story.
   *
   * @param {string} id - The ID of the story.
   * @param {number} timestamp - The timestamp of the last visual check.
   *
   * @returns {void}
   */ setLastVisualCheck: (id1, timestamp)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.lastVisualCheck[id1] = timestamp;
            }), undefined, "story/setLastVisualCheck");
        },
        /**
   * Checks the visual URLs for a story.
   *
   * @param {Object} story - The story object to check.
   *
   * @returns {Promise<void>}
   */ checkStoryVisualURLs: async (story)=>{
            if (!story) return;
            get().setCheckStoryVisualsPending(story.id, true);
            get().setLastVisualCheck(story.id, +new Date());
            try {
                const randomVisual = story.script?.find((step)=>step.visuals && step.visuals.length > 0)?.visuals[0]?.url;
                if (!randomVisual) return;
                const response = await fetch(randomVisual, {
                    method: "HEAD"
                });
                if (!response.ok) throw new Error(`Visual URL check failed for story ${id}: ${randomVisual}`);
                get().setCheckStoryVisualsPending(story.id, false);
            } catch (error) {
                get().updateStoryVisualURLs(story.id);
            }
        },
        /**
   * Updates the visual URLs for a story.
   *
   * @param {string} id - The ID of the story.
   *
   * @returns {Promise<void>}
   */ updateStoryVisualURLs: async (id1)=>{
            const story = get().getStory(id1);
            try {
                const personaVisuals = story?.personas?.map(({ avatarPath: avatarPath })=>avatarPath).filter(Boolean) || [];
                const scriptVisuals = story?.script?.reduce((acc, { visuals: visuals })=>{
                    if (visuals) acc.push(...visuals.map(({ path: path })=>path));
                    return acc;
                }, []) || [];
                // const visualURLs = await batchPresignURLs([
                //   ...personaVisuals,
                //   ...scriptVisuals,
                // ]);
                const visualURLs = [];
                console.log(`Presigned URLs for story ${id1}:`, visualURLs);
                // set(
                //   produce((state) => {
                //     const storyIndex = state.stories.findIndex(
                //       (story) => story.id === id,
                //     );
                //     if (storyIndex !== -1) {
                //       state.stories[storyIndex].personas.forEach((persona, idx) => {
                //         const url = visualURLs.find(
                //           (url) => url.filePath === persona.avatarPath,
                //         );
                //         if (url) {
                //           state.stories[storyIndex].personas[idx].avatarUrl =
                //             url.presignURL;
                //         }
                //       });
                //       state.stories[storyIndex].script.forEach((step, idx) => {
                //         state.stories[storyIndex].script[idx]?.visuals?.forEach(
                //           (visual, vIdx) => {
                //             const url = visualURLs.find(
                //               (url) => url.filePath === visual.path,
                //             );
                //             if (url) {
                //               state.stories[storyIndex].script[idx].visuals[vIdx].url =
                //                 url.presignURL;
                //             }
                //           },
                //         );
                //       });
                //     }
                //   }),
                //   undefined,
                //   "story/updateStoryVisualURLs",
                // );
                (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(id1), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                        state.personas.forEach((persona, idx)=>{
                            const url = visualURLs.find((url)=>url.filePath === persona.avatarPath);
                            if (url) state.personas[idx].avatarUrl = url.presignURL;
                        });
                        state.script.forEach((step, idx)=>{
                            state.script[idx]?.visuals?.forEach((visual, vIdx)=>{
                                const url = visualURLs.find((url)=>url.filePath === visual.path);
                                if (url) state.script[idx].visuals[vIdx].url = url.presignURL;
                            });
                        });
                    }));
                // get().saveStory(id);
                get().setCheckStoryVisualsPending(story.id, false);
            } catch (error) {
                console.error(`Error updating visual URLs for story ${id1}:`, error);
                get().setCheckStoryVisualsPending(story.id, false);
            }
        },
        /**
   * Updates a script item in a story.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} itemId - The ID of the script item to update.
   * @param {Object} update - The update to apply to the script item.
   *
   * @returns {void}
   */ updateStoryScriptItem: (storyId, itemId, update)=>{
            (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                    const itemIndex = state.script.findIndex((item)=>item.id === itemId);
                    if (itemIndex !== -1) state.script[itemIndex] = {
                        ...state.script[itemIndex],
                        ...update
                    };
                }));
        },
        updateStoryPersonaImage: (storyId, libraryId, update)=>{
            (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                    const itemIndex = state.personas.findIndex((item)=>item.libraryId === libraryId);
                    if (itemIndex !== -1) state.personas[itemIndex] = {
                        ...state.personas[itemIndex],
                        ...update
                    };
                }));
        },
        updateStoryVisualImage: (storyId, stepId, visualId, update)=>{
            (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                    const itemIndex = state.script.findIndex((item)=>item.id === stepId);
                    if (itemIndex !== -1) {
                        state.script[itemIndex].visuals[visualId] = {
                            ...state.script[itemIndex].visuals[visualId],
                            libraryId: update?.libraryId,
                            id: update?.id
                        };
                        if (update.visualPrompt) state.script[itemIndex].visualPrompt = update.visualPrompt;
                    }
                }));
        }
    });

});
parcelRegister("aKSBi", function(module, exports) {

$parcel$export(module.exports, "isZoltarGenerateOk", () => $7d488dc8e09116e6$export$d70b8ddae332d718);
$parcel$export(module.exports, "ZOLTAR_POLL_USER_INPUT", () => $7d488dc8e09116e6$export$7738a8b8f8404a7a);
$parcel$export(module.exports, "IMAGE_LABELING_PROMPT_IDS", () => $7d488dc8e09116e6$export$dbb008fb890b28f4);
$parcel$export(module.exports, "isZoltarResponseNotReadyError", () => $7d488dc8e09116e6$export$ad46eb542fa0ef3);
$parcel$export(module.exports, "parseZoltarGenerateJson", () => $7d488dc8e09116e6$export$99d152512cf319e3);
$parcel$export(module.exports, "readZoltarGenerateJsonWithFallback", () => $7d488dc8e09116e6$export$86e5d369ddd998e0);
$parcel$export(module.exports, "parseZoltarGenerateAssistantJson", () => $7d488dc8e09116e6$export$ede628696761f5bb);
$parcel$export(module.exports, "zoltarLangchainMessagesToPromptTemplate", () => $7d488dc8e09116e6$export$667f86d55aba782d);
$parcel$export(module.exports, "getSystemPrompt", () => $7d488dc8e09116e6$export$1bea999321660682);
$parcel$export(module.exports, "listSystemPrompts", () => $7d488dc8e09116e6$export$c15f1b18a514c5b6);
$parcel$export(module.exports, "getZoltarCurl", () => $7d488dc8e09116e6$export$2395b8510c282874);
$parcel$export(module.exports, "generateContent", () => $7d488dc8e09116e6$export$4edbeb3aa79c6b8a);
$parcel$export(module.exports, "imageLabeling", () => $7d488dc8e09116e6$export$57b5e95f43258657);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $7d488dc8e09116e6$export$407ca81eb46778dd = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/zoltar"], null, 1, (0, $fHV62.DEFAULT_API_CLIENT_HEADERS), 0);
const $7d488dc8e09116e6$export$d70b8ddae332d718 = (data)=>Boolean(data && typeof data === "object" && data.ok === true);
const $7d488dc8e09116e6$export$de708c478e5da122 = "ZOLTAR_RESPONSE_NOT_READY";
const $7d488dc8e09116e6$export$7738a8b8f8404a7a = "Return the data.";
const $7d488dc8e09116e6$export$dbb008fb890b28f4 = [
    "common-image-description",
    "Brand-Visibility-image-description",
    "Brand-Visibility-image-dna"
];
const $7d488dc8e09116e6$export$ad46eb542fa0ef3 = (error)=>{
    const { status: status, data: data } = error?.cause ?? {};
    return data?.code === $7d488dc8e09116e6$export$de708c478e5da122 || status === 504 && data?.error === "Response not yet ready.";
};
const $7d488dc8e09116e6$export$a1e982e63cdb588c = (data)=>data?.response ?? "";
const $7d488dc8e09116e6$export$6a935cb61fe0e713 = (data)=>data?.envelope;
const $7d488dc8e09116e6$var$unwrapAgentAnswerEnvelope = (obj)=>obj?.kind === "answer" ? JSON.parse($7d488dc8e09116e6$export$5926bfa7c9ec35bf(obj.text)) : obj;
const $7d488dc8e09116e6$var$sanitizeJsonWhitespace = (text)=>String(text).replace(/[\u00a0\u202f\u2007\u2060\ufeff]/g, " ");
const $7d488dc8e09116e6$export$5926bfa7c9ec35bf = (text)=>{
    let t = String(text ?? "").trim();
    if (!t.startsWith("```")) return $7d488dc8e09116e6$var$sanitizeJsonWhitespace(t);
    t = t.replace(/^```(?:json)?\s*/i, "");
    const closing = t.lastIndexOf("```");
    if (closing !== -1) t = t.slice(0, closing).trim();
    return $7d488dc8e09116e6$var$sanitizeJsonWhitespace(t.trim());
};
const $7d488dc8e09116e6$export$f0322d804e613294 = (data, errorMessage = "Zoltar generation failed")=>{
    if (!$7d488dc8e09116e6$export$d70b8ddae332d718(data)) throw new Error(errorMessage, {
        cause: data
    });
};
const $7d488dc8e09116e6$export$99d152512cf319e3 = (data, fallbackJsonText = "{}")=>{
    const envelope = $7d488dc8e09116e6$export$6a935cb61fe0e713(data);
    if (envelope) return $7d488dc8e09116e6$var$unwrapAgentAnswerEnvelope(envelope);
    const stripped = $7d488dc8e09116e6$export$5926bfa7c9ec35bf($7d488dc8e09116e6$export$a1e982e63cdb588c(data));
    const raw = stripped.length > 0 ? stripped : fallbackJsonText;
    return $7d488dc8e09116e6$var$unwrapAgentAnswerEnvelope(JSON.parse(raw));
};
const $7d488dc8e09116e6$export$86e5d369ddd998e0 = (data, fallbackJsonText, errorMessage = "Zoltar generation failed")=>{
    $7d488dc8e09116e6$export$f0322d804e613294(data, errorMessage);
    return $7d488dc8e09116e6$export$99d152512cf319e3(data, fallbackJsonText);
};
const $7d488dc8e09116e6$export$ede628696761f5bb = (data, errorMessage = "Zoltar generation failed")=>{
    $7d488dc8e09116e6$export$f0322d804e613294(data, errorMessage);
    const withThreadId = (result)=>result && typeof result === "object" && !Array.isArray(result) ? {
            ...result,
            thread_id: data?.thread_id
        } : result;
    const envelope = $7d488dc8e09116e6$export$6a935cb61fe0e713(data);
    if (envelope) return withThreadId($7d488dc8e09116e6$var$unwrapAgentAnswerEnvelope(envelope));
    const text = $7d488dc8e09116e6$export$5926bfa7c9ec35bf($7d488dc8e09116e6$export$a1e982e63cdb588c(data));
    if (!text.trim()) throw new Error(`${errorMessage}: empty response`, {
        cause: data
    });
    return withThreadId($7d488dc8e09116e6$var$unwrapAgentAnswerEnvelope(JSON.parse(text)));
};
const $7d488dc8e09116e6$export$667f86d55aba782d = (messages)=>{
    if (!Array.isArray(messages)) return [];
    return messages.filter((m)=>m && typeof m === "object" && m.kwargs != null && typeof m.kwargs.content === "string").map((m)=>{
        const id = m.id;
        const type = Array.isArray(id) ? id[id.length - 1] : "";
        const role = type === "HumanMessage" ? "user" : "system";
        return {
            role: role,
            prompt_template: m.kwargs.content
        };
    });
};
const $7d488dc8e09116e6$export$1bea999321660682 = async (systemPromptId, options = {})=>{
    const response = await $7d488dc8e09116e6$export$407ca81eb46778dd.get(`/prompts/${encodeURIComponent(systemPromptId)}`, {}, options);
    if (!response.ok) throw new Error("Failed to load the system prompt. Administrator access is required.", {
        cause: response
    });
    return response.data.data;
};
const $7d488dc8e09116e6$export$c15f1b18a514c5b6 = async (options = {})=>{
    const response = await $7d488dc8e09116e6$export$407ca81eb46778dd.get("/prompts", {}, options);
    if (!response.ok) throw new Error("Failed to load system prompts. Administrator access is required.", {
        cause: response
    });
    return response.data.data;
};
const $7d488dc8e09116e6$export$2395b8510c282874 = async (body, options = {})=>{
    const response = await $7d488dc8e09116e6$export$407ca81eb46778dd.post("/curl", body, options);
    if (!response.ok) throw new Error("Failed to build the cURL command. Administrator access is required.", {
        cause: response
    });
    return response.data.data;
};
const $7d488dc8e09116e6$export$4edbeb3aa79c6b8a = async (body, errorMessage, options = {})=>{
    const override = body.promptOverrideKey && localStorage.getItem(body.promptOverrideKey);
    if (override && body.systemPromptId) {
        const document = await $7d488dc8e09116e6$export$1bea999321660682(body.systemPromptId, options);
        body = {
            ...body,
            systemPromptId: undefined,
            prompt_template: [
                {
                    role: "system",
                    prompt_template: override
                },
                ...body.prompt_template ?? []
            ],
            schema: document.schema
        };
    }
    const response = await $7d488dc8e09116e6$export$407ca81eb46778dd.post("/generateContent", {
        useAgent: body.useAgent,
        user: body.user,
        data: body?.data || {},
        prompt_template: body.prompt_template,
        ...body.systemPromptId !== undefined ? {
            systemPromptId: body.systemPromptId
        } : {},
        model: body.model,
        schema: body.schema,
        skills: body.skills,
        thread_id: body.thread_id,
        user_input: body.user_input
    }, options);
    if (!response.ok) throw new Error(errorMessage, {
        cause: response
    });
    return response.data.data;
};
const $7d488dc8e09116e6$export$57b5e95f43258657 = async (body, options = {})=>{
    const response = await $7d488dc8e09116e6$export$407ca81eb46778dd.post("/imageLabeling", {
        imageUrl: body.imageUrl,
        prompt_template: body.prompt_template,
        ...body.systemPromptId !== undefined ? {
            systemPromptId: body.systemPromptId
        } : {},
        ...body.userInput !== undefined ? {
            user_input: body.userInput
        } : {}
    }, options);
    if (!response.ok) throw new Error("Failed to label image", {
        cause: response
    });
    return response.data;
};

});
parcelRegister("8Ogg5", function(module, exports) {

$parcel$export(module.exports, "actions", () => $669f9acf18fcbdf0$export$e324594224ef24da);
$parcel$export(module.exports, "getPresignedImageUrl", () => $669f9acf18fcbdf0$export$87758d9e7863cd3a);
$parcel$export(module.exports, "getPresignedImageUrlFromTemplatedLink", () => $669f9acf18fcbdf0$export$477ba89695d136ea);
$parcel$export(module.exports, "getAvatarUrl", () => $669f9acf18fcbdf0$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "getVisualUrl", () => $669f9acf18fcbdf0$export$2cda7c8a2c0f9d45);
$parcel$export(module.exports, "findPrimaryLogo", () => $669f9acf18fcbdf0$export$b133a610c6227d2c);
$parcel$export(module.exports, "importAllPersonas", () => $669f9acf18fcbdf0$export$83264418ecc9f53a);
$parcel$export(module.exports, "getExtensionFromFilePath", () => $669f9acf18fcbdf0$export$9cbace9af6411ea9);
$parcel$export(module.exports, "getQueryLoadingState", () => $669f9acf18fcbdf0$export$2afdd9819c12657a);
$parcel$export(module.exports, "getRelativeTime", () => $669f9acf18fcbdf0$export$493c11ff22f45a24);
$parcel$export(module.exports, "shouldAddMapUrl", () => $669f9acf18fcbdf0$export$19e6242dcfd35194);

var $fCCXt = parcelRequire("fCCXt");

var $8PkOq = parcelRequire("8PkOq");
// Get API base path from environment variable, default to localhost for development
const $669f9acf18fcbdf0$var$API_PATH = "https://oneadobe-exd-bestory-ai-deploy-ethos101-prod-va6-b7a3d1.cloud.adobe.io";
const $669f9acf18fcbdf0$export$e324594224ef24da = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($fCCXt)))).reduce((obj, key)=>{
    if (key.lastIndexOf("/") > -1) obj[key] = `${$669f9acf18fcbdf0$var$API_PATH}${(0, (/*@__PURE__*/$parcel$interopDefault($fCCXt)))[key]}`;
    return obj;
}, {});
async function $669f9acf18fcbdf0$export$87758d9e7863cd3a(libraryId, imageId) {
    // Check if user is authenticated first
    if (!(0, $8PkOq.IMS).isSignedIn) throw new Error("User not authenticated. Please log in to access images.");
    const accessToken = await (0, $8PkOq.IMS).getAccessToken();
    if (!accessToken) throw new Error("No access token available. Please log in to access images.");
    return `https://platform-cs-edge-va6c2.adobe.io/rendition/id/${libraryId};type=image%2Fjpeg;size=2048?resource=%7B%22reltype%22%3A%22http%3A%2F%2Fns.adobe.com%2Fadobecloud%2Frel%2Fcomponent%22%2C%22component_id%22%3A%22${imageId}%22%2C%22revision%22%3A%220%22%7D&api_key=projectx_webapp&user_token=${accessToken}`;
}
async function $669f9acf18fcbdf0$export$477ba89695d136ea(templatedLink, imageId, size = 2048, type = "jpeg") {
    // Check if user is authenticated first
    if (!(0, $8PkOq.IMS).isSignedIn) throw new Error("User not authenticated. Please log in to access images.");
    const accessToken = await (0, $8PkOq.IMS).getAccessToken();
    if (!accessToken) throw new Error("No access token available. Please log in to access images.");
    if (!templatedLink || typeof templatedLink !== "string") throw new Error("Invalid templated link provided.");
    // Extract the base URL and library ID from the templated link
    // Format: "https://platform-cs-edge-{region}.adobe.io/rendition/id/{libraryId}{;page,size,type}{?resource,component_id,fragment}"
    const match = templatedLink.match(/^(https:\/\/[^\/]+)\/rendition\/id\/([^{]+)/);
    if (!match) throw new Error("Invalid templated link format. Expected format: https://platform-cs-edge-{region}.adobe.io/rendition/id/{libraryId}...");
    const baseUrl = match[1];
    const libraryId = match[2];
    // Construct the presigned URL using the extracted base URL and library ID
    return `${baseUrl}/rendition/id/${libraryId};type=image%2F${type};size=${size}?resource=%7B%22reltype%22%3A%22http%3A%2F%2Fns.adobe.com%2Fadobecloud%2Frel%2Fcomponent%22%2C%22component_id%22%3A%22${imageId}%22%2C%22revision%22%3A%220%22%7D&api_key=projectx_webapp&user_token=${accessToken}`;
}
function $669f9acf18fcbdf0$export$b4f8f1f54acec99b(persona) {
    // If avatarUrl is already present, return it synchronously
    if (persona?.avatarUrl) return persona.avatarUrl;
    // Fall back to CC Libraries lookup (async) if we have library info but no avatarUrl
    if (persona?.avatarId && (persona?.libraryId || persona?.id)) return $669f9acf18fcbdf0$export$87758d9e7863cd3a(persona?.libraryId ?? persona?.id, persona?.avatarId);
    // Return fallback image
    return "https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png";
}
function $669f9acf18fcbdf0$export$2cda7c8a2c0f9d45(visual) {
    // If URL is already present (backend provides presigned URL), return it synchronously
    if (visual?.url) return visual.url;
    // Fall back to CC Libraries lookup (async) if we have library info but no URL
    if (visual?.id && visual?.libraryId) return $669f9acf18fcbdf0$export$87758d9e7863cd3a(visual?.libraryId, visual?.id);
    // Return fallback image
    return "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png";
}
async function $669f9acf18fcbdf0$export$b133a610c6227d2c(brand) {
    const logoToUse = brand?.["rendition_grid"]?.main ? brand?.["rendition_grid"]?.main : brand?.["thumbnail"];
    if (logoToUse?.type === "application/vnd.adobe.element.colortheme+dcx") return {
        type: "swatches",
        swatches: logoToUse?.rendition?.swatches
    };
    else if (logoToUse?.type === "href") return {
        type: "link",
        url: await $669f9acf18fcbdf0$export$477ba89695d136ea(logoToUse?.templatedLink, logoToUse?.componentId, 640, "png")
    };
    else return {
        type: "",
        url: ""
    };
}

async function $669f9acf18fcbdf0$export$83264418ecc9f53a() {
    const { personas: personas } = await (parcelRequire("jHhWe"));
    return personas || [];
}
const $669f9acf18fcbdf0$export$9cbace9af6411ea9 = (filePath, defaultType)=>{
    return filePath.split("/").pop().split("?")[0].split(".")?.[1] ?? defaultType;
};
const $669f9acf18fcbdf0$export$2afdd9819c12657a = (query, { loadMore: loadMore = true } = {})=>{
    if (!Array.isArray(query)) query = [
        query
    ];
    const activeQueries = query.filter((q)=>q.isEnabled);
    const isSomePending = activeQueries.some((q)=>q.isPending);
    const isSomeSuccess = activeQueries.some((q)=>q.isSuccess);
    if (activeQueries.some((q)=>q.isError)) return "error";
    else if (isSomeSuccess && isSomePending) return loadMore ? "loadingMore" : "loading";
    else if (isSomePending) return "loading";
    else return "idle";
};
const $669f9acf18fcbdf0$var$relativeTimeFormat = new Intl.RelativeTimeFormat("en", {
    style: "short"
});
const $669f9acf18fcbdf0$export$493c11ff22f45a24 = (date, relativeTo = new Date())=>{
    const now = new Date(relativeTo);
    const diffInSeconds = Math.floor((now - new Date(date)) / 1000);
    if (!isFinite(diffInSeconds)) return "";
    if (diffInSeconds < 60) return $669f9acf18fcbdf0$var$relativeTimeFormat.format(-diffInSeconds, "second");
    else if (diffInSeconds < 3600) {
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        return $669f9acf18fcbdf0$var$relativeTimeFormat.format(-diffInMinutes, "minute");
    } else if (diffInSeconds < 86400) {
        const diffInHours = Math.floor(diffInSeconds / 3600);
        return $669f9acf18fcbdf0$var$relativeTimeFormat.format(-diffInHours, "hour");
    } else if (diffInSeconds < 2592000) {
        const diffInDays = Math.floor(diffInSeconds / 86400);
        return $669f9acf18fcbdf0$var$relativeTimeFormat.format(-diffInDays, "day");
    } else if (diffInSeconds < 31536000) {
        const diffInMonths = Math.floor(diffInSeconds / 2592000);
        return $669f9acf18fcbdf0$var$relativeTimeFormat.format(-diffInMonths, "month");
    } else {
        const diffInYears = Math.floor(diffInSeconds / 31536000);
        return $669f9acf18fcbdf0$var$relativeTimeFormat.format(-diffInYears, "year");
    }
};
const $669f9acf18fcbdf0$export$19e6242dcfd35194 = (map, url)=>{
    if (!map || !url) return false;
    const stripProtocol = (_url)=>_url.replace(/^https?:\/\//, "");
    return !Array.from(map.keys()).some((key)=>stripProtocol(key) === stripProtocol(url));
};

});
parcelRegister("fCCXt", function(module, exports) {
module.exports = JSON.parse("{\"exd-storyteller-ai/firefly\":\"/firefly\",\"exd-storyteller-ai/photoshop\":\"/ps\",\"exd-storyteller-ai/ccLibrariesProxy\":\"/express\",\"exd-storyteller-ai/stories\":\"/stories\",\"exd-storyteller-ai/videos\":\"/videos\",\"exd-storyteller-ai/templates\":\"/templates\",\"exd-storyteller-ai/zoltar\":\"/zoltar\",\"exd-storyteller-ai/generatePresentation\":\"/express/generate\",\"exd-storyteller-ai/uploadFileToS3\":\"/s3\",\"exd-storyteller-ai/zoltarDemoPilot\":\"/zoltar-demo-pilot\",\"exd-storyteller-ai/fluffyjaws\":\"/fluffyjaws\",\"exd-storyteller-ai/linkChecker\":\"/linkchecker\",\"exd-storyteller-ai/downloads\":\"/downloads\",\"exd-storyteller-ai/ffmpeg\":\"/ffmpeg\",\"exd-storyteller-ai/jobs\":\"/jobs\",\"exd-storyteller-ai/mogrt\":\"/mogrt\",\"exd-storyteller-ai/ims\":\"/ims\",\"exd-storyteller-ai/admin\":\"/admin\",\"exd-storyteller-ai/aurora\":\"/aurora\",\"exd-storyteller-ai/footage\":\"/footage\",\"exd-storyteller-ai/feedback\":\"/feedback\",\"exd-storyteller-ai/alerts\":\"/alerts\"}");

});

parcelRegister("8PkOq", function(module, exports) {

$parcel$export(module.exports, "markNextImsSignInForceAccountPicker", () => $66d33b0506d67769$export$33cb1877fecff55a);
$parcel$export(module.exports, "IMS", () => $66d33b0506d67769$export$2f19d0ab93d19249);

var $ksSD2 = parcelRequire("ksSD2");

var $isdGM = parcelRequire("isdGM");

var $fmJ8d = parcelRequire("fmJ8d");
const $66d33b0506d67769$var$FORCE_IMS_ACCOUNT_PICKER_KEY = "bestory_force_sign_in";
function $66d33b0506d67769$export$33cb1877fecff55a() {
    if (typeof sessionStorage !== "undefined") sessionStorage.setItem($66d33b0506d67769$var$FORCE_IMS_ACCOUNT_PICKER_KEY, "true");
}
class $66d33b0506d67769$var$Deferred {
    constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    promise() {
        return this._promise;
    }
    resolve(value) {
        this._resolve(value);
    }
    reject(error) {
        this._reject(error);
    }
}
/** @typedef {{ clientId: string; scope: string; environment: 'stage' | 'prod' }} IMSConfig */ /** @typedef {{ id: string; email: string; fullName: string; firstName: string; lastName: string; ownerOrg?: string | null }} IMSUserProfile */ const $66d33b0506d67769$var$IMS_PROFILE_URL = "https://ims-na1.adobelogin.com/ims/profile/v1";
/**
 * @returns {string}
 */ function $66d33b0506d67769$var$getImsOAuthRedirectUri() {
    if (typeof window === "undefined") return "";
    return window.location.origin;
}
/**
 * Route to restore after IMS OAuth
 * @param {string | undefined} [explicit]
 * @returns {string}
 */ function $66d33b0506d67769$var$resolveReturnPathForSignIn(explicit) {
    if (typeof explicit === "string" && explicit.length > 0) return explicit;
    if (typeof window === "undefined") return "";
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
class $66d33b0506d67769$export$6238af23ae91359d {
    constructor(){
        /** @type {AdobeIMS | undefined} */ this._adobeIMS = undefined;
        /** @type {string | undefined} */ this._explicitIMSToken = undefined;
        /** @type {IMSUserProfile | undefined} */ this._userProfile = undefined;
        /** @type {Deferred<void> | undefined} */ this._signInDef = undefined;
    }
    /**
   * @param {IMSConfig} config
   */ async initialize(config) {
        if (this._adobeIMS) return;
        const imsConfig = {
            locale: "en_US",
            environment: config.environment === "prod" ? (0, $isdGM.IEnvironment).PROD : (0, $isdGM.IEnvironment).STAGE,
            scope: config.scope,
            client_id: config.clientId,
            useLocalStorage: true,
            autoValidateToken: true,
            onError: null,
            onAccessToken: null,
            onAccessTokenHasExpired: null,
            onReauthAccessToken: null,
            onReady: (context)=>{
                if (context && typeof context.returnPath === "string" && context.returnPath.length > 0) (0, $fmJ8d.store).getState().setRedirectPath(context.returnPath);
            },
            redirect_uri: $66d33b0506d67769$var$getImsOAuthRedirectUri()
        };
        if (typeof window !== "undefined") window.adobeid = imsConfig;
        this._adobeIMS = new (0, $ksSD2.AdobeIMS)(imsConfig);
        await this._adobeIMS.initialize();
    }
    _ensureReady() {
        if (!this._adobeIMS) throw new Error("IMS is not initialized, call initialize first");
    }
    _ensureSignIn() {
        this._ensureReady();
        if (!this._signInDef) {
            this._signInDef = new $66d33b0506d67769$var$Deferred();
            const returnPath = $66d33b0506d67769$var$resolveReturnPathForSignIn();
            this._adobeIMS.signIn({
                redirect_uri: $66d33b0506d67769$var$getImsOAuthRedirectUri()
            }, returnPath ? {
                returnPath: returnPath
            } : undefined).then(()=>{
                this._signInDef?.resolve();
            }).catch((error)=>{
                this._signInDef?.reject(error);
            });
        }
        return this._signInDef.promise();
    }
    get isSignedIn() {
        return this._adobeIMS?.isSignedInUser() ?? false;
    }
    /** Cached profile from last getUserProfile (example-style). */ get userProfile() {
        return this._userProfile;
    }
    /**
   * @param {string} token
   */ setExplicitIMSToken(token) {
        this._explicitIMSToken = token;
        this._userProfile = undefined;
    }
    async getAccessToken() {
        if (this._explicitIMSToken) return this._explicitIMSToken;
        this._ensureReady();
        if (!this._adobeIMS.isSignedInUser()) await this._ensureSignIn();
        return this._adobeIMS.getAccessToken()?.token ?? null;
    }
    /**
   * @returns {Promise<boolean>} true if imslib refreshed and a new access token is available
   */ async refreshAccessToken() {
        if (this._explicitIMSToken) return false;
        try {
            this._ensureReady();
        } catch  {
            return false;
        }
        if (!this._adobeIMS.isSignedInUser()) return false;
        try {
            await this._adobeIMS.refreshToken({});
            this._userProfile = undefined;
            const token = this._adobeIMS.getAccessToken()?.token ?? null;
            if (token) (0, $fmJ8d.store).getState().setToken(token);
            return !!token;
        } catch  {
            return false;
        }
    }
    /**
   * @returns {Promise<IMSUserProfile>}
   */ async getUserProfile() {
        if (this._userProfile) return this._userProfile;
        if (this._explicitIMSToken) {
            const res = await fetch($66d33b0506d67769$var$IMS_PROFILE_URL, {
                headers: {
                    Authorization: `Bearer ${this._explicitIMSToken}`
                }
            });
            if (!res.ok) throw new Error(`401: profile request failed (${res.status})`);
            const data = await res.json();
            this._userProfile = {
                id: data.userId,
                email: data.email,
                fullName: data.name,
                firstName: data.first_name,
                lastName: data.last_name,
                ownerOrg: data.ownerOrg ?? null,
                ldap: data.email?.split("@")?.[0] ?? null
            };
            return this._userProfile;
        }
        this._ensureReady();
        if (!this._adobeIMS.isSignedInUser()) await this._ensureSignIn();
        const imsProfile = await this._adobeIMS.getProfile();
        this._userProfile = {
            id: imsProfile.userId,
            email: imsProfile.email,
            fullName: imsProfile.name,
            firstName: imsProfile.first_name,
            lastName: imsProfile.last_name,
            ownerOrg: imsProfile.ownerOrg ?? null,
            ldap: imsProfile?.email?.split("@")?.[0] ?? null
        };
        return this._userProfile;
    }
    /**
   * @param {boolean} [forceSignIn]
   * @param {string} [returnPath] App route to restore (pathname+search+hash); forwarded in IMS OAuth state.context
   */ async signIn(forceSignIn = false, returnPath) {
        this._ensureReady();
        let force = !!forceSignIn;
        if (typeof sessionStorage !== "undefined") {
            if (sessionStorage.getItem($66d33b0506d67769$var$FORCE_IMS_ACCOUNT_PICKER_KEY) === "true") {
                sessionStorage.removeItem($66d33b0506d67769$var$FORCE_IMS_ACCOUNT_PICKER_KEY);
                force = true;
            }
        }
        if (!force && this._adobeIMS.isSignedInUser()) return;
        const options = {
            redirect_uri: $66d33b0506d67769$var$getImsOAuthRedirectUri()
        };
        if (force) options.force_sign_in = true;
        const path = $66d33b0506d67769$var$resolveReturnPathForSignIn(returnPath);
        await this._adobeIMS.signIn(options, path ? {
            returnPath: path
        } : undefined);
    }
    async signUp() {
        this._ensureReady();
        const returnPath = $66d33b0506d67769$var$resolveReturnPathForSignIn();
        await this._adobeIMS.signUp({
            redirect_uri: $66d33b0506d67769$var$getImsOAuthRedirectUri()
        }, returnPath ? {
            returnPath: returnPath
        } : undefined);
    }
    getSSORedirectHref() {
        const redirectURL = new URL(window.location.origin);
        return redirectURL.toString();
    }
    async signOut() {
        this._ensureReady();
        this._userProfile = undefined;
        this._explicitIMSToken = undefined;
        this._signInDef = undefined;
        (0, $fmJ8d.store).getState().clearIms();
        this._adobeIMS.signOut({
            redirect_uri: this.getSSORedirectHref()
        });
    }
}
const $66d33b0506d67769$export$2f19d0ab93d19249 = new $66d33b0506d67769$export$6238af23ae91359d();

});


parcelRegister("fHV62", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_API_CLIENT_HEADERS", () => $b6f7294c86f8fad2$export$2a0a9c64054048f);
$parcel$export(module.exports, "getAuthHeaders", () => $b6f7294c86f8fad2$export$3fa04bebf37c9013);
$parcel$export(module.exports, "createApiClient", () => $b6f7294c86f8fad2$export$8744222f7aa763e1);

var $pKQR8 = parcelRequire("pKQR8");

var $hWsLk = parcelRequire("hWsLk");

var $8PkOq = parcelRequire("8PkOq");

var $fmJ8d = parcelRequire("fmJ8d");

var $8OIwE = parcelRequire("8OIwE");
const $b6f7294c86f8fad2$export$2a0a9c64054048f = {
    "Content-Type": "application/json",
    Accept: "application/json"
};
const $b6f7294c86f8fad2$var$DEFAULT_TIMEOUT_MS = 60000;
/** apisauce methods that issue a request and therefore have to be queued. */ const $b6f7294c86f8fad2$var$HTTP_METHODS = [
    "get",
    "post",
    "put",
    "patch",
    "delete",
    "head",
    "link",
    "unlink"
];
const $b6f7294c86f8fad2$export$3fa04bebf37c9013 = async ()=>{
    const token = await (0, $8PkOq.IMS).getAccessToken();
    if (!token) return {};
    return {
        Authorization: `Bearer ${token}`
    };
};
const $b6f7294c86f8fad2$export$8ab11b80038d254 = (apiClient)=>async (request)=>{
        const authHeaders = await $b6f7294c86f8fad2$export$3fa04bebf37c9013();
        request.headers = {
            ...request.headers,
            ...authHeaders
        };
        if (!authHeaders.Authorization) {
            console.log("No Authorization header found, deleting");
            delete request.headers.Authorization;
            delete request.headers.authorization;
        }
        apiClient.setHeaders(request.headers);
    };
const $b6f7294c86f8fad2$export$f0036bc26ecb1df8 = (apiClient)=>async (response)=>{
        if (response.status !== 401) return;
        const refreshed = await (0, $8PkOq.IMS).refreshAccessToken();
        const authHeaders = refreshed ? await $b6f7294c86f8fad2$export$3fa04bebf37c9013() : {};
        apiClient.setHeaders({
            ...apiClient.headers || {},
            ...authHeaders
        });
        if (!authHeaders.Authorization) {
            const returnPath = typeof window !== "undefined" ? `${window.location.pathname}${window.location.search}${window.location.hash}` : null;
            (0, $fmJ8d.store).getState().clearIms();
            if (returnPath) (0, $fmJ8d.store).getState().setRedirectPath(returnPath);
            await (0, $8PkOq.IMS).signIn(true, returnPath ?? undefined);
        }
    };
/**
 * `429` responses are deliberately **not** retried by axios-retry: an
 * interceptor has no knowledge of the other in-flight requests, so retrying
 * there would defeat both the concurrency limit and the `Retry-After` window.
 * Rate limits are handled by the request queue installed below.
 */ const $b6f7294c86f8fad2$var$shouldRetryRequest = (error)=>error?.response?.status !== 429 && error?.code !== "ERR_CANCELED" && (0, $hWsLk.default).isNetworkOrIdempotentRequestError(error);
/** Endpoint key a cool-down is tracked under, e.g. `/generate-3p`. */ const $b6f7294c86f8fad2$var$getEndpointKey = (url)=>String(url ?? "").split("?")[0] || "/";
/**
 * All apisauce request methods take the axios config as their third argument
 * (`get(url, params, config)` / `post(url, data, config)`), which is where the
 * abort signal lives.
 */ const $b6f7294c86f8fad2$var$getSignal = (args)=>args?.[1]?.signal;
/**
 * Routes every request of `apiClient` through a FIFO queue.
 *
 * - No more than `maxConcurrent` requests are in flight; the rest wait instead
 *   of being fired (and instead of failing fast and being retried in a burst).
 * - A `429` closes the cool-down gate of that endpoint for the `Retry-After`
 *   window: queued requests to it stay queued (without holding a slot, so
 *   other endpoints keep flowing) and the request is retried afterwards,
 *   through the queue, so retries also respect `maxConcurrent`.
 *
 * @param {object} apiClient - The apisauce client to wrap.
 * @param {object} options - `name`, `maxConcurrent` and `maxRateLimitRetries`.
 * @returns {object} - The same client, with a `requestQueue` property.
 */ const $b6f7294c86f8fad2$var$withRequestQueue = (apiClient, { name: name, maxConcurrent: maxConcurrent, maxRateLimitRetries: maxRateLimitRetries })=>{
    const queue = new (0, $8OIwE.RequestQueue)({
        name: name,
        maxConcurrent: maxConcurrent
    });
    const gates = new Map();
    const getGate = (url)=>(0, $8OIwE.getOrCreate)(gates, $b6f7294c86f8fad2$var$getEndpointKey(url), (key)=>new (0, $8OIwE.RateLimitGate)({
                name: `${name}${key}`
            }));
    for (const method of $b6f7294c86f8fad2$var$HTTP_METHODS){
        const request = apiClient[method];
        if (typeof request !== "function") continue;
        apiClient[method] = (url, ...args)=>(0, $8OIwE.runRateLimited)(queue, getGate(url), ()=>request(url, ...args), {
                signal: $b6f7294c86f8fad2$var$getSignal(args),
                maxRetries: maxRateLimitRetries
            });
    }
    apiClient.requestQueue = queue;
    return apiClient;
};
const $b6f7294c86f8fad2$export$8744222f7aa763e1 = (baseURL, maxConcurrentRequests = null, retries = 1, headers = $b6f7294c86f8fad2$export$2a0a9c64054048f, timeout = $b6f7294c86f8fad2$var$DEFAULT_TIMEOUT_MS, { maxRateLimitRetries: maxRateLimitRetries } = {})=>{
    const apiClient = (0, (/*@__PURE__*/$parcel$interopDefault($pKQR8))).create({
        baseURL: baseURL,
        headers: headers,
        timeout: timeout
    });
    apiClient.addAsyncRequestTransform($b6f7294c86f8fad2$export$8ab11b80038d254(apiClient));
    apiClient.addAsyncResponseTransform($b6f7294c86f8fad2$export$f0036bc26ecb1df8(apiClient));
    if (retries > 0) (0, $hWsLk.default)(apiClient.axiosInstance, {
        retries: retries,
        retryCondition: $b6f7294c86f8fad2$var$shouldRetryRequest,
        // The default delay is `0`, which turns a hiccup into a burst.
        retryDelay: (0, $hWsLk.default).exponentialDelay
    });
    if (maxConcurrentRequests) $b6f7294c86f8fad2$var$withRequestQueue(apiClient, {
        name: baseURL,
        maxConcurrent: maxConcurrentRequests,
        maxRateLimitRetries: maxRateLimitRetries
    });
    return apiClient;
};

});
parcelRegister("pKQR8", function(module, exports) {
"use strict";
function $04d6ada63f4456e4$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $04d6ada63f4456e4$var$axios = $04d6ada63f4456e4$var$_interopDefault((parcelRequire("fYHD4"))), $04d6ada63f4456e4$var$__assign = function() {
    return ($04d6ada63f4456e4$var$__assign = Object.assign || function(e) {
        for(var n, t = 1, r = arguments.length; t < r; t++)for(var o in n = arguments[t])Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        return e;
    }).apply(this, arguments);
}, $04d6ada63f4456e4$var$__awaiter = function(e, n, t, r) {
    return new (t || (t = Promise))(function(o, s) {
        function a(e) {
            try {
                i(r.next(e));
            } catch (e) {
                s(e);
            }
        }
        function R(e) {
            try {
                i(r.throw(e));
            } catch (e) {
                s(e);
            }
        }
        function i(e) {
            var n;
            e.done ? o(e.value) : (n = e.value, n instanceof t ? n : new t(function(e) {
                e(n);
            })).then(a, R);
        }
        i((r = r.apply(e, n || [])).next());
    });
}, $04d6ada63f4456e4$var$__generator = function(e, n) {
    var t, r, o, s, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return s = {
        next: R(0),
        throw: R(1),
        return: R(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function() {
        return this;
    }), s;
    function R(R) {
        return function(i) {
            return function(R) {
                if (t) throw new TypeError("Generator is already executing.");
                for(; s && (s = 0, R[0] && (a = 0)), a;)try {
                    if (t = 1, r && (o = 2 & R[0] ? r.return : R[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, R[1])).done) return o;
                    switch(r = 0, o && (R = [
                        2 & R[0],
                        o.value
                    ]), R[0]){
                        case 0:
                        case 1:
                            o = R;
                            break;
                        case 4:
                            return a.label++, {
                                value: R[1],
                                done: !1
                            };
                        case 5:
                            a.label++, r = R[1], R = [
                                0
                            ];
                            continue;
                        case 7:
                            R = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === R[0] || 2 === R[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === R[0] && (!o || R[1] > o[0] && R[1] < o[3])) {
                                a.label = R[1];
                                break;
                            }
                            if (6 === R[0] && a.label < o[1]) {
                                a.label = o[1], o = R;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(R);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    R = n.call(e, a);
                } catch (e) {
                    R = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    t = o = 0;
                }
                if (5 & R[0]) throw R[1];
                return {
                    value: R[0] ? R[1] : void 0,
                    done: !0
                };
            }([
                R,
                i
            ]);
        };
    }
}, $04d6ada63f4456e4$var$toNumber = function(e) {
    return e instanceof Date ? e.getTime() : "number" == typeof e || null === e || void 0 === e ? e : Number(e);
}, $04d6ada63f4456e4$var$isWithin = function(e, n, t) {
    return t >= e && t <= n;
}, $04d6ada63f4456e4$var$isPromise = function(e) {
    return !!e && ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
}, $04d6ada63f4456e4$var$DEFAULT_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json"
}, $04d6ada63f4456e4$var$DEFAULT_CONFIG = {
    timeout: 0
}, $04d6ada63f4456e4$var$NONE = null, $04d6ada63f4456e4$var$CLIENT_ERROR = "CLIENT_ERROR", $04d6ada63f4456e4$var$SERVER_ERROR = "SERVER_ERROR", $04d6ada63f4456e4$var$TIMEOUT_ERROR = "TIMEOUT_ERROR", $04d6ada63f4456e4$var$CONNECTION_ERROR = "CONNECTION_ERROR", $04d6ada63f4456e4$var$NETWORK_ERROR = "NETWORK_ERROR", $04d6ada63f4456e4$var$UNKNOWN_ERROR = "UNKNOWN_ERROR", $04d6ada63f4456e4$var$CANCEL_ERROR = "CANCEL_ERROR", $04d6ada63f4456e4$var$TIMEOUT_ERROR_CODES = [
    "ECONNABORTED"
], $04d6ada63f4456e4$var$NODEJS_CONNECTION_ERROR_CODES = [
    "ENOTFOUND",
    "ECONNREFUSED",
    "ECONNRESET"
], $04d6ada63f4456e4$var$STATUS_ERROR_CODES = [
    "ERR_BAD_REQUEST",
    "ERR_BAD_RESPONSE"
], $04d6ada63f4456e4$var$in200s = function(e) {
    return $04d6ada63f4456e4$var$isWithin(200, 299, e);
}, $04d6ada63f4456e4$var$in400s = function(e) {
    return $04d6ada63f4456e4$var$isWithin(400, 499, e);
}, $04d6ada63f4456e4$var$in500s = function(e) {
    return $04d6ada63f4456e4$var$isWithin(500, 599, e);
}, $04d6ada63f4456e4$var$getProblemFromError = function(e) {
    return "Network Error" === e.message ? $04d6ada63f4456e4$var$NETWORK_ERROR : $04d6ada63f4456e4$var$axios.isCancel(e) ? $04d6ada63f4456e4$var$CANCEL_ERROR : e.code ? $04d6ada63f4456e4$var$STATUS_ERROR_CODES.includes(e.code) ? $04d6ada63f4456e4$var$getProblemFromStatus(e.response.status) : $04d6ada63f4456e4$var$TIMEOUT_ERROR_CODES.includes(e.code) ? $04d6ada63f4456e4$var$TIMEOUT_ERROR : $04d6ada63f4456e4$var$NODEJS_CONNECTION_ERROR_CODES.includes(e.code) ? $04d6ada63f4456e4$var$CONNECTION_ERROR : $04d6ada63f4456e4$var$UNKNOWN_ERROR : $04d6ada63f4456e4$var$getProblemFromStatus(e.response ? e.response.status : null);
}, $04d6ada63f4456e4$var$getProblemFromStatus = function(e) {
    return e ? $04d6ada63f4456e4$var$in200s(e) ? $04d6ada63f4456e4$var$NONE : $04d6ada63f4456e4$var$in400s(e) ? $04d6ada63f4456e4$var$CLIENT_ERROR : $04d6ada63f4456e4$var$in500s(e) ? $04d6ada63f4456e4$var$SERVER_ERROR : $04d6ada63f4456e4$var$UNKNOWN_ERROR : $04d6ada63f4456e4$var$UNKNOWN_ERROR;
}, $04d6ada63f4456e4$var$create = function(e) {
    var n, t = $04d6ada63f4456e4$var$__assign($04d6ada63f4456e4$var$__assign({}, $04d6ada63f4456e4$var$DEFAULT_HEADERS), e.headers || {});
    if (e.axiosInstance) n = e.axiosInstance;
    else {
        var r = $04d6ada63f4456e4$var$__assign($04d6ada63f4456e4$var$__assign({}, e), {
            headers: void 0
        }), o = $04d6ada63f4456e4$var$__assign($04d6ada63f4456e4$var$__assign({}, $04d6ada63f4456e4$var$DEFAULT_CONFIG), r);
        n = $04d6ada63f4456e4$var$axios.create(o);
    }
    var s = [], a = [], R = [], i = [], u = [], E = function(e, r) {
        return t[e] = r, n;
    }, c = function(e) {
        return function(n, t, r) {
            return void 0 === t && (t = {}), void 0 === r && (r = {}), O($04d6ada63f4456e4$var$__assign($04d6ada63f4456e4$var$__assign({}, r), {
                url: n,
                params: t,
                method: e
            }));
        };
    }, l = function(e) {
        return function(n, t, r) {
            return void 0 === r && (r = {}), O($04d6ada63f4456e4$var$__assign($04d6ada63f4456e4$var$__assign({}, r), {
                url: n,
                method: e,
                data: t
            }));
        };
    }, O = function(e) {
        return $04d6ada63f4456e4$var$__awaiter(void 0, void 0, void 0, function() {
            var r, o, s, i;
            return $04d6ada63f4456e4$var$__generator(this, function(u) {
                switch(u.label){
                    case 0:
                        if (e.headers = $04d6ada63f4456e4$var$__assign($04d6ada63f4456e4$var$__assign({}, t), e.headers), a.length > 0 && a.forEach(function(n) {
                            return n(e);
                        }), !(R.length > 0)) return [
                            3,
                            6
                        ];
                        r = 0, u.label = 1;
                    case 1:
                        return r < R.length ? (o = R[r](e), $04d6ada63f4456e4$var$isPromise(o) ? [
                            4,
                            o
                        ] : [
                            3,
                            3
                        ]) : [
                            3,
                            6
                        ];
                    case 2:
                        return u.sent(), [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            o(e)
                        ];
                    case 4:
                        u.sent(), u.label = 5;
                    case 5:
                        return r++, [
                            3,
                            1
                        ];
                    case 6:
                        return s = $04d6ada63f4456e4$var$toNumber(new Date), i = function(e) {
                            return $04d6ada63f4456e4$var$__awaiter(void 0, void 0, void 0, function() {
                                var n;
                                return $04d6ada63f4456e4$var$__generator(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return [
                                                4,
                                                N(s, e)
                                            ];
                                        case 1:
                                            return n = t.sent(), [
                                                2,
                                                _(n)
                                            ];
                                    }
                                });
                            });
                        }, [
                            2,
                            n.request(e).then(i).catch(i)
                        ];
                }
            });
        });
    }, _ = function(e) {
        return s.forEach(function(n) {
            try {
                n(e);
            } catch (e) {}
        }), e;
    }, N = function(e, n) {
        return $04d6ada63f4456e4$var$__awaiter(void 0, void 0, void 0, function() {
            var t, r, o, s, a, R, E, c, l, O, _, N, f, p, T, d, C;
            return $04d6ada63f4456e4$var$__generator(this, function(h) {
                switch(h.label){
                    case 0:
                        if (t = $04d6ada63f4456e4$var$toNumber(new Date), r = t - e, o = n instanceof Error || $04d6ada63f4456e4$var$axios.isCancel(n), s = n, a = n, R = o ? a.response : s, E = R && R.status || null, c = o ? $04d6ada63f4456e4$var$getProblemFromError(n) : $04d6ada63f4456e4$var$getProblemFromStatus(E), l = o ? a : null, O = $04d6ada63f4456e4$var$in200s(E), _ = n.config || null, N = R && R.headers || null, f = null !== (C = R && R.data) && void 0 !== C ? C : null, p = {
                            duration: r,
                            problem: c,
                            originalError: l,
                            ok: O,
                            status: E,
                            headers: N,
                            config: _,
                            data: f
                        }, i.length > 0 && i.forEach(function(e) {
                            return e(p);
                        }), !(u.length > 0)) return [
                            3,
                            6
                        ];
                        T = 0, h.label = 1;
                    case 1:
                        return T < u.length ? (d = u[T](p), $04d6ada63f4456e4$var$isPromise(d) ? [
                            4,
                            d
                        ] : [
                            3,
                            3
                        ]) : [
                            3,
                            6
                        ];
                    case 2:
                        return h.sent(), [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            d(p)
                        ];
                    case 4:
                        h.sent(), h.label = 5;
                    case 5:
                        return T++, [
                            3,
                            1
                        ];
                    case 6:
                        return [
                            2,
                            p
                        ];
                }
            });
        });
    };
    return {
        axiosInstance: n,
        monitors: s,
        addMonitor: function(e) {
            s.push(e);
        },
        requestTransforms: a,
        asyncRequestTransforms: R,
        responseTransforms: i,
        asyncResponseTransforms: u,
        addRequestTransform: function(e) {
            return a.push(e);
        },
        addAsyncRequestTransform: function(e) {
            return R.push(e);
        },
        addResponseTransform: function(e) {
            return i.push(e);
        },
        addAsyncResponseTransform: function(e) {
            return u.push(e);
        },
        setHeader: E,
        setHeaders: function(e) {
            return Object.keys(e).forEach(function(n) {
                return E(n, e[n]);
            }), n;
        },
        deleteHeader: function(e) {
            return delete t[e], n;
        },
        headers: t,
        setBaseURL: function(e) {
            return n.defaults.baseURL = e, n;
        },
        getBaseURL: function() {
            return n.defaults.baseURL;
        },
        any: O,
        get: c("get"),
        delete: c("delete"),
        head: c("head"),
        post: l("post"),
        put: l("put"),
        patch: l("patch"),
        link: c("link"),
        unlink: c("unlink")
    };
}, $04d6ada63f4456e4$var$isCancel = $04d6ada63f4456e4$var$axios.isCancel, $04d6ada63f4456e4$var$CancelToken = $04d6ada63f4456e4$var$axios.CancelToken, $04d6ada63f4456e4$var$apisauce = {
    DEFAULT_HEADERS: $04d6ada63f4456e4$var$DEFAULT_HEADERS,
    NONE: $04d6ada63f4456e4$var$NONE,
    CLIENT_ERROR: $04d6ada63f4456e4$var$CLIENT_ERROR,
    SERVER_ERROR: $04d6ada63f4456e4$var$SERVER_ERROR,
    TIMEOUT_ERROR: $04d6ada63f4456e4$var$TIMEOUT_ERROR,
    CONNECTION_ERROR: $04d6ada63f4456e4$var$CONNECTION_ERROR,
    NETWORK_ERROR: $04d6ada63f4456e4$var$NETWORK_ERROR,
    UNKNOWN_ERROR: $04d6ada63f4456e4$var$UNKNOWN_ERROR,
    create: $04d6ada63f4456e4$var$create,
    isCancel: $04d6ada63f4456e4$var$isCancel,
    CancelToken: $04d6ada63f4456e4$var$CancelToken
};
module.exports.DEFAULT_HEADERS = $04d6ada63f4456e4$var$DEFAULT_HEADERS, module.exports.NONE = $04d6ada63f4456e4$var$NONE, module.exports.CLIENT_ERROR = $04d6ada63f4456e4$var$CLIENT_ERROR, module.exports.SERVER_ERROR = $04d6ada63f4456e4$var$SERVER_ERROR, module.exports.TIMEOUT_ERROR = $04d6ada63f4456e4$var$TIMEOUT_ERROR, module.exports.CONNECTION_ERROR = $04d6ada63f4456e4$var$CONNECTION_ERROR, module.exports.NETWORK_ERROR = $04d6ada63f4456e4$var$NETWORK_ERROR, module.exports.UNKNOWN_ERROR = $04d6ada63f4456e4$var$UNKNOWN_ERROR, module.exports.CANCEL_ERROR = $04d6ada63f4456e4$var$CANCEL_ERROR, module.exports.getProblemFromError = $04d6ada63f4456e4$var$getProblemFromError, module.exports.getProblemFromStatus = $04d6ada63f4456e4$var$getProblemFromStatus, module.exports.create = $04d6ada63f4456e4$var$create, module.exports.isCancel = $04d6ada63f4456e4$var$isCancel, module.exports.CancelToken = $04d6ada63f4456e4$var$CancelToken, module.exports.default = $04d6ada63f4456e4$var$apisauce;

});

parcelRegister("hWsLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0fe2a0a0f7b6668$export$2e2bcd8739ae039);

var $a5ucQ = parcelRequire("a5ucQ");
const $d0fe2a0a0f7b6668$export$76a88f7de6507443 = 'axios-retry';
function $d0fe2a0a0f7b6668$export$476aa014e2fd89d5(error) {
    const CODE_EXCLUDE_LIST = [
        'ERR_CANCELED',
        'ECONNABORTED'
    ];
    if (error.response) return false;
    if (!error.code) return false;
    // Prevents retrying timed out & cancelled requests
    if (CODE_EXCLUDE_LIST.includes(error.code)) return false;
    // Prevents retrying unsafe errors
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5ucQ)))(error);
}
const $d0fe2a0a0f7b6668$var$SAFE_HTTP_METHODS = [
    'get',
    'head',
    'options'
];
const $d0fe2a0a0f7b6668$var$IDEMPOTENT_HTTP_METHODS = $d0fe2a0a0f7b6668$var$SAFE_HTTP_METHODS.concat([
    'put',
    'delete'
]);
function $d0fe2a0a0f7b6668$export$5f1dc21fa925930b(error) {
    return error.code !== 'ECONNABORTED' && (!error.response || error.response.status === 429 || error.response.status >= 500 && error.response.status <= 599);
}
function $d0fe2a0a0f7b6668$export$693cf906fd8817e5(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $d0fe2a0a0f7b6668$export$5f1dc21fa925930b(error) && $d0fe2a0a0f7b6668$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $d0fe2a0a0f7b6668$export$d26799ad4978234d(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $d0fe2a0a0f7b6668$export$5f1dc21fa925930b(error) && $d0fe2a0a0f7b6668$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $d0fe2a0a0f7b6668$export$606bf0a2b170eb2(error) {
    return $d0fe2a0a0f7b6668$export$476aa014e2fd89d5(error) || $d0fe2a0a0f7b6668$export$d26799ad4978234d(error);
}
function $d0fe2a0a0f7b6668$export$e981df388f003617(error) {
    const retryAfterHeader = error?.response?.headers['retry-after'];
    if (!retryAfterHeader) return 0;
    // if the retry after header is a number, convert it to milliseconds
    let retryAfterMs = (Number(retryAfterHeader) || 0) * 1000;
    // If the retry after header is a date, get the number of milliseconds until that date
    if (retryAfterMs === 0) retryAfterMs = (new Date(retryAfterHeader).valueOf() || 0) - Date.now();
    return Math.max(0, retryAfterMs);
}
function $d0fe2a0a0f7b6668$var$noDelay(_retryNumber = 0, error) {
    return Math.max(0, $d0fe2a0a0f7b6668$export$e981df388f003617(error));
}
function $d0fe2a0a0f7b6668$export$ce2bf54576c66713(retryNumber = 0, error, delayFactor = 100) {
    const calculatedDelay = 2 ** retryNumber * delayFactor;
    const delay = Math.max(calculatedDelay, $d0fe2a0a0f7b6668$export$e981df388f003617(error));
    const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
function $d0fe2a0a0f7b6668$export$384f50abe7b57bc7(delayFactor = 100) {
    return (retryNumber = 0, error)=>{
        const delay = retryNumber * delayFactor;
        return Math.max(delay, $d0fe2a0a0f7b6668$export$e981df388f003617(error));
    };
}
const $d0fe2a0a0f7b6668$export$93ca5d3f8675ae4c = {
    retries: 3,
    retryCondition: $d0fe2a0a0f7b6668$export$606bf0a2b170eb2,
    retryDelay: $d0fe2a0a0f7b6668$var$noDelay,
    shouldResetTimeout: false,
    onRetry: ()=>{},
    onMaxRetryTimesExceeded: ()=>{},
    validateResponse: null
};
function $d0fe2a0a0f7b6668$var$getRequestOptions(config, defaultOptions) {
    return {
        ...$d0fe2a0a0f7b6668$export$93ca5d3f8675ae4c,
        ...defaultOptions,
        ...config[$d0fe2a0a0f7b6668$export$76a88f7de6507443]
    };
}
function $d0fe2a0a0f7b6668$var$setCurrentState(config, defaultOptions, resetLastRequestTime = false) {
    const currentState = $d0fe2a0a0f7b6668$var$getRequestOptions(config, defaultOptions || {});
    currentState.retryCount = currentState.retryCount || 0;
    if (!currentState.lastRequestTime || resetLastRequestTime) currentState.lastRequestTime = Date.now();
    config[$d0fe2a0a0f7b6668$export$76a88f7de6507443] = currentState;
    return currentState;
}
function $d0fe2a0a0f7b6668$var$fixConfig(axiosInstance, config) {
    // @ts-ignore
    if (axiosInstance.defaults.agent === config.agent) // @ts-ignore
    delete config.agent;
    if (axiosInstance.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axiosInstance.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
async function $d0fe2a0a0f7b6668$var$shouldRetry(currentState, error) {
    const { retries: retries, retryCondition: retryCondition } = currentState;
    const shouldRetryOrPromise = (currentState.retryCount || 0) < retries && retryCondition(error);
    // This could be a promise
    if (typeof shouldRetryOrPromise === 'object') try {
        const shouldRetryPromiseResult = await shouldRetryOrPromise;
        // keep return true unless shouldRetryPromiseResult return false for compatibility
        return shouldRetryPromiseResult !== false;
    } catch (_err) {
        return false;
    }
    return shouldRetryOrPromise;
}
async function $d0fe2a0a0f7b6668$var$handleRetry(axiosInstance, currentState, error, config) {
    currentState.retryCount += 1;
    const { retryDelay: retryDelay, shouldResetTimeout: shouldResetTimeout, onRetry: onRetry } = currentState;
    const delay = retryDelay(currentState.retryCount, error);
    // Axios fails merging this configuration to the default configuration because it has an issue
    // with circular structures: https://github.com/mzabriskie/axios/issues/370
    $d0fe2a0a0f7b6668$var$fixConfig(axiosInstance, config);
    if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
        const lastRequestDuration = Date.now() - currentState.lastRequestTime;
        const timeout = config.timeout - lastRequestDuration - delay;
        if (timeout <= 0) return Promise.reject(error);
        config.timeout = timeout;
    }
    config.transformRequest = [
        (data)=>data
    ];
    await onRetry(currentState.retryCount, error, config);
    if (config.signal?.aborted) return Promise.resolve(axiosInstance(config));
    return new Promise((resolve)=>{
        const abortListener = ()=>{
            clearTimeout(timeout);
            resolve(axiosInstance(config));
        };
        const timeout = setTimeout(()=>{
            resolve(axiosInstance(config));
            if (config.signal?.removeEventListener) config.signal.removeEventListener('abort', abortListener);
        }, delay);
        if (config.signal?.addEventListener) config.signal.addEventListener('abort', abortListener, {
            once: true
        });
    });
}
async function $d0fe2a0a0f7b6668$var$handleMaxRetryTimesExceeded(currentState, error) {
    if (currentState.retryCount >= currentState.retries) await currentState.onMaxRetryTimesExceeded(error, currentState.retryCount);
}
const $d0fe2a0a0f7b6668$var$axiosRetry = (axiosInstance, defaultOptions)=>{
    const requestInterceptorId = axiosInstance.interceptors.request.use((config)=>{
        $d0fe2a0a0f7b6668$var$setCurrentState(config, defaultOptions, true);
        if (config[$d0fe2a0a0f7b6668$export$76a88f7de6507443]?.validateResponse) // by setting this, all HTTP responses will be go through the error interceptor first
        config.validateStatus = ()=>false;
        return config;
    });
    const responseInterceptorId = axiosInstance.interceptors.response.use(null, async (error)=>{
        const { config: config } = error;
        // If we have no information to retry the request
        if (!config) return Promise.reject(error);
        const currentState = $d0fe2a0a0f7b6668$var$setCurrentState(config, defaultOptions);
        if (error.response && currentState.validateResponse?.(error.response)) // no issue with response
        return error.response;
        if (await $d0fe2a0a0f7b6668$var$shouldRetry(currentState, error)) return $d0fe2a0a0f7b6668$var$handleRetry(axiosInstance, currentState, error, config);
        await $d0fe2a0a0f7b6668$var$handleMaxRetryTimesExceeded(currentState, error);
        return Promise.reject(error);
    });
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
};
// Compatibility with CommonJS
$d0fe2a0a0f7b6668$var$axiosRetry.isNetworkError = $d0fe2a0a0f7b6668$export$476aa014e2fd89d5;
$d0fe2a0a0f7b6668$var$axiosRetry.isSafeRequestError = $d0fe2a0a0f7b6668$export$693cf906fd8817e5;
$d0fe2a0a0f7b6668$var$axiosRetry.isIdempotentRequestError = $d0fe2a0a0f7b6668$export$d26799ad4978234d;
$d0fe2a0a0f7b6668$var$axiosRetry.isNetworkOrIdempotentRequestError = $d0fe2a0a0f7b6668$export$606bf0a2b170eb2;
$d0fe2a0a0f7b6668$var$axiosRetry.exponentialDelay = $d0fe2a0a0f7b6668$export$ce2bf54576c66713;
$d0fe2a0a0f7b6668$var$axiosRetry.linearDelay = $d0fe2a0a0f7b6668$export$384f50abe7b57bc7;
$d0fe2a0a0f7b6668$var$axiosRetry.isRetryableError = $d0fe2a0a0f7b6668$export$5f1dc21fa925930b;
var $d0fe2a0a0f7b6668$export$2e2bcd8739ae039 = $d0fe2a0a0f7b6668$var$axiosRetry;

});
parcelRegister("a5ucQ", function(module, exports) {
'use strict';
const $7581cd4ea2a7c28f$var$denyList = new Set([
    'ENOTFOUND',
    'ENETUNREACH',
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    'UNABLE_TO_GET_ISSUER_CERT',
    'UNABLE_TO_GET_CRL',
    'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
    'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
    'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
    'CERT_SIGNATURE_FAILURE',
    'CRL_SIGNATURE_FAILURE',
    'CERT_NOT_YET_VALID',
    'CERT_HAS_EXPIRED',
    'CRL_NOT_YET_VALID',
    'CRL_HAS_EXPIRED',
    'ERROR_IN_CERT_NOT_BEFORE_FIELD',
    'ERROR_IN_CERT_NOT_AFTER_FIELD',
    'ERROR_IN_CRL_LAST_UPDATE_FIELD',
    'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
    'OUT_OF_MEM',
    'DEPTH_ZERO_SELF_SIGNED_CERT',
    'SELF_SIGNED_CERT_IN_CHAIN',
    'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
    'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
    'CERT_CHAIN_TOO_LONG',
    'CERT_REVOKED',
    'INVALID_CA',
    'PATH_LENGTH_EXCEEDED',
    'INVALID_PURPOSE',
    'CERT_UNTRUSTED',
    'CERT_REJECTED',
    'HOSTNAME_MISMATCH'
]);
// TODO: Use `error?.code` when targeting Node.js 14
module.exports = (error)=>!$7581cd4ea2a7c28f$var$denyList.has(error && error.code);

});


parcelRegister("8OIwE", function(module, exports) {

$parcel$export(module.exports, "getRetryAfterMs", () => $66b5881f77424620$export$f5ed7a849600bd69);
$parcel$export(module.exports, "RateLimitGate", () => $66b5881f77424620$export$b863ec655f14c5ad);
$parcel$export(module.exports, "RequestQueue", () => $66b5881f77424620$export$d4014e229af8080d);
$parcel$export(module.exports, "runRateLimited", () => $66b5881f77424620$export$85d51750b0a18250);
$parcel$export(module.exports, "getOrCreate", () => $66b5881f77424620$export$275bb542c01287e3);
/**
 * Building blocks for client side rate limiting.
 *
 * - {@link RateLimitGate} remembers a `Retry-After` cool-down for one resource
 *   (typically an endpoint) and lets everyone wait for it.
 * - {@link RequestQueue} is a FIFO semaphore: at most `maxConcurrent` tasks run
 *   at the same time, and a task whose gate is closed never takes a slot.
 * - {@link runRateLimited} ties both together: it runs a request through the
 *   queue and, on `429`, closes the gate for the `Retry-After` window before
 *   retrying — so queued *and* retried requests always back off together and
 *   never exceed the concurrency limit.
 */ 
var $ubpkL = parcelRequire("ubpkL");
const $66b5881f77424620$export$8b6efeafa0980bdb = 5000;
const $66b5881f77424620$export$91f461e7776836cf = 60000;
const $66b5881f77424620$export$9d521c1ed2e59fa0 = 5;
const $66b5881f77424620$var$HTTP_TOO_MANY_REQUESTS = 429;
const $66b5881f77424620$var$createAbortError = ()=>{
    const error = new Error("Request aborted");
    error.name = "AbortError";
    // Matches the apisauce shape the query client checks to skip retries.
    error.cause = {
        problem: "CANCEL_ERROR"
    };
    return error;
};
const $66b5881f77424620$var$sleep = (ms, signal)=>(0, $ubpkL.backgroundDelay)(ms, {
        signal: signal
    }).catch(()=>{
        throw $66b5881f77424620$var$createAbortError();
    });
const $66b5881f77424620$var$readHeader = (headers, name)=>{
    if (!headers) return undefined;
    // Axios v1 exposes `AxiosHeaders`, other callers may pass a plain object.
    if (typeof headers.get === "function") return headers.get(name);
    const lowerName = name.toLowerCase();
    const key = Object.keys(headers).find((k)=>k.toLowerCase() === lowerName);
    return key ? headers[key] : undefined;
};
const $66b5881f77424620$export$559881f8bc09beb5 = (value)=>{
    if (value === null || value === undefined || value === "") return null;
    const seconds = Number(value);
    if (Number.isFinite(seconds)) return Math.max(0, seconds * 1000);
    const date = Date.parse(value);
    return Number.isNaN(date) ? null : Math.max(0, date - Date.now());
};
const $66b5881f77424620$export$f5ed7a849600bd69 = (response)=>{
    if (!response) return null;
    const candidates = [
        $66b5881f77424620$var$readHeader(response.headers, "Retry-After"),
        response.retryAfter,
        response.data?.retryAfter,
        response.data?.retry_after
    ];
    for (const candidate of candidates){
        const retryAfterMs = $66b5881f77424620$export$559881f8bc09beb5(candidate);
        if (retryAfterMs !== null) return retryAfterMs;
    }
    return null;
};
const $66b5881f77424620$export$6c91fec22056810a = (response)=>response?.status === $66b5881f77424620$var$HTTP_TOO_MANY_REQUESTS;
class $66b5881f77424620$export$b863ec655f14c5ad {
    #name;
    #maxRetryAfterMs;
    #resumeAt = 0;
    constructor({ name: name = "gate", maxRetryAfterMs: maxRetryAfterMs = $66b5881f77424620$export$91f461e7776836cf } = {}){
        this.#name = name;
        this.#maxRetryAfterMs = maxRetryAfterMs;
    }
    get name() {
        return this.#name;
    }
    /** Remaining cool-down in milliseconds (`0` when open). */ get pausedForMs() {
        return Math.max(0, this.#resumeAt - Date.now());
    }
    /**
   * Closes the gate for `ms`, never shortening an existing cool-down.
   *
   * @param {number} ms - Requested cool-down in milliseconds.
   * @returns {number} - The effective cool-down remaining after this call.
   */ pause(ms) {
        const delay = Math.min(Math.max(0, ms ?? 0), this.#maxRetryAfterMs);
        if (delay > 0) this.#resumeAt = Math.max(this.#resumeAt, Date.now() + delay);
        return this.pausedForMs;
    }
    /**
   * Waits until the gate is open again.
   *
   * @param {AbortSignal} [signal] - Aborts the wait.
   */ async waitForResume(signal) {
        let remaining = this.pausedForMs;
        while(remaining > 0){
            await $66b5881f77424620$var$sleep(remaining, signal);
            remaining = this.pausedForMs;
        }
    }
}
class $66b5881f77424620$export$d4014e229af8080d {
    #name;
    #maxConcurrent;
    #active = 0;
    #waiters = [];
    #wakeAbort = null;
    constructor({ name: name = "request-queue", maxConcurrent: maxConcurrent = 1 } = {}){
        this.#name = name;
        this.#maxConcurrent = Math.max(1, maxConcurrent);
    }
    get name() {
        return this.#name;
    }
    get maxConcurrent() {
        return this.#maxConcurrent;
    }
    /** Number of tasks currently holding a slot. */ get activeCount() {
        return this.#active;
    }
    /** Number of tasks waiting for a slot. */ get pendingCount() {
        return this.#waiters.length;
    }
    /**
   * Waits for a free slot. The slot is reserved synchronously when the queue
   * hands it out, so concurrency holds even before the caller resumes.
   *
   * A waiter with a closed `gate` is skipped until its cool-down elapses: it
   * neither takes a slot nor blocks requests to other endpoints behind it.
   *
   * @param {object} [options] - `signal` to abort, `gate` to rate limit.
   * @returns {Promise<void>}
   */ acquire({ signal: signal, gate: gate } = {}) {
        if (signal?.aborted) return Promise.reject($66b5881f77424620$var$createAbortError());
        return new Promise((resolve, reject)=>{
            const waiter = {
                gate: gate
            };
            const onAbort = ()=>{
                const index = this.#waiters.indexOf(waiter);
                if (index >= 0) this.#waiters.splice(index, 1);
                reject($66b5881f77424620$var$createAbortError());
            };
            waiter.start = ()=>{
                signal?.removeEventListener("abort", onAbort);
                resolve();
            };
            this.#waiters.push(waiter);
            signal?.addEventListener("abort", onAbort, {
                once: true
            });
            this.#dispatch();
        });
    }
    /** Releases a slot previously handed out by `acquire`. */ release() {
        if (this.#active > 0) this.#active -= 1;
        this.#dispatch();
    }
    /**
   * Runs `task` once a slot is free, releasing the slot afterwards.
   *
   * @param {Function} task - The work to run.
   * @param {object} [options] - `signal` to abort, `gate` to rate limit.
   * @returns {Promise<*>} - Whatever `task` resolves with.
   */ async run(task, options = {}) {
        await this.acquire(options);
        try {
            return await task();
        } finally{
            this.release();
        }
    }
    #dispatch() {
        if (this.#wakeAbort) {
            this.#wakeAbort.abort();
            this.#wakeAbort = null;
        }
        let nextWakeUp = Infinity;
        let index = 0;
        while(index < this.#waiters.length && this.#active < this.#maxConcurrent){
            const waiter = this.#waiters[index];
            const pausedForMs = waiter.gate?.pausedForMs ?? 0;
            if (pausedForMs > 0) {
                // Rate limited: leave it queued and look at the next waiter.
                nextWakeUp = Math.min(nextWakeUp, pausedForMs);
                index += 1;
                continue;
            }
            this.#waiters.splice(index, 1);
            this.#active += 1;
            waiter.start();
        }
        if (Number.isFinite(nextWakeUp)) {
            const controller = new AbortController();
            this.#wakeAbort = controller;
            (0, $ubpkL.backgroundDelay)(nextWakeUp, {
                signal: controller.signal
            }).then(()=>{
                this.#wakeAbort = null;
                this.#dispatch();
            }).catch(()=>{
            // Superseded by a newer dispatch that aborted this wake-up.
            });
        }
    }
}
const $66b5881f77424620$export$85d51750b0a18250 = async (queue, gate, request, options = {})=>{
    const { signal: signal, maxRetries: maxRetries = $66b5881f77424620$export$9d521c1ed2e59fa0, onRateLimited: onRateLimited } = options;
    for(let attempt = 0;; attempt += 1){
        const response = await queue.run(async ()=>{
            const result = await request(attempt);
            if ($66b5881f77424620$export$6c91fec22056810a(result)) {
                // Closing the gate before the slot is released guarantees that no
                // queued request slips through during the cool-down.
                const waitMs = gate.pause($66b5881f77424620$export$f5ed7a849600bd69(result) ?? $66b5881f77424620$export$8b6efeafa0980bdb);
                console.warn(`[${queue.name}] rate limited (429) on "${gate.name}", holding ` + `back ${queue.pendingCount} queued request(s) for ${waitMs}ms ` + `(attempt ${attempt + 1}/${maxRetries + 1})`);
                onRateLimited?.({
                    attempt: attempt,
                    waitMs: waitMs,
                    response: result
                });
            }
            return result;
        }, {
            signal: signal,
            gate: gate
        });
        if (!$66b5881f77424620$export$6c91fec22056810a(response) || attempt >= maxRetries) return response;
    }
};
const $66b5881f77424620$export$275bb542c01287e3 = (registry, key, factory)=>{
    let entry = registry.get(key);
    if (!entry) {
        entry = factory(key);
        registry.set(key, entry);
    }
    return entry;
};

});
parcelRegister("ubpkL", function(module, exports) {

$parcel$export(module.exports, "backgroundDelay", () => $05aba6c52e9fa18a$export$8b7dbc8fd8a53be2);
// A delay that keeps ticking while the tab is in the background.
//
// Browsers throttle a hidden tab's main-thread timers (~1/s, then ~1/min after
// five minutes), which stalls the Firefly / Photoshop generation poll loops
// when the user minimizes the window or switches tabs — the server-side job
// finishes, but the client stops picking up the result. A dedicated worker's
// timers are not throttled that way, and `fetch` and `message` events still run
// on a hidden page, so driving each loop's delay from a worker keeps generation
// progressing regardless of tab visibility.
//
// Degrades gracefully to a plain (throttleable) `setTimeout` when workers are
// unavailable, so callers never have to branch on support.
// `null` = not yet created, `false` = unavailable (construction failed), else
// the live Worker.
let $05aba6c52e9fa18a$var$worker = null;
let $05aba6c52e9fa18a$var$nextId = 1;
const $05aba6c52e9fa18a$var$pending = new Map();
const $05aba6c52e9fa18a$var$abortError = ()=>{
    try {
        return new DOMException("The operation was aborted.", "AbortError");
    } catch  {
        const error = new Error("The operation was aborted.");
        error.name = "AbortError";
        return error;
    }
};

const $05aba6c52e9fa18a$var$getWorker = ()=>{
    if ($05aba6c52e9fa18a$var$worker !== null) return $05aba6c52e9fa18a$var$worker;
    try {
        $05aba6c52e9fa18a$var$worker = new Worker((parcelRequire("kaNNn")), {
            type: "module"
        });
        $05aba6c52e9fa18a$var$worker.onmessage = (event)=>{
            const resolve = $05aba6c52e9fa18a$var$pending.get(event.data?.id);
            if (resolve) {
                $05aba6c52e9fa18a$var$pending.delete(event.data.id);
                resolve();
            }
        };
        $05aba6c52e9fa18a$var$worker.onerror = ()=>{
            // A broken worker must not wedge every pending delay: resolve them so the
            // callers fall through to their next poll rather than hanging forever, and
            // stop trying to reconstruct it on every call.
            $05aba6c52e9fa18a$var$pending.forEach((resolve)=>resolve());
            $05aba6c52e9fa18a$var$pending.clear();
            $05aba6c52e9fa18a$var$worker = false;
        };
    } catch  {
        $05aba6c52e9fa18a$var$worker = false;
    }
    return $05aba6c52e9fa18a$var$worker;
};
const $05aba6c52e9fa18a$export$8b7dbc8fd8a53be2 = (ms, { signal: signal } = {})=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject($05aba6c52e9fa18a$var$abortError());
            return;
        }
        const activeWorker = $05aba6c52e9fa18a$var$getWorker();
        // No worker available — degrade to a regular (throttleable) timer, but keep
        // the same abort semantics.
        if (!activeWorker) {
            const onAbort = ()=>{
                clearTimeout(handle);
                reject($05aba6c52e9fa18a$var$abortError());
            };
            const handle = setTimeout(()=>{
                signal?.removeEventListener("abort", onAbort);
                resolve();
            }, ms);
            signal?.addEventListener("abort", onAbort, {
                once: true
            });
            return;
        }
        const id = $05aba6c52e9fa18a$var$nextId++;
        const onAbort = ()=>{
            $05aba6c52e9fa18a$var$pending.delete(id);
            activeWorker.postMessage({
                type: "clear",
                id: id
            });
            reject($05aba6c52e9fa18a$var$abortError());
        };
        $05aba6c52e9fa18a$var$pending.set(id, ()=>{
            signal?.removeEventListener("abort", onAbort);
            resolve();
        });
        signal?.addEventListener("abort", onAbort, {
            once: true
        });
        activeWorker.postMessage({
            type: "start",
            id: id,
            delay: ms
        });
    });

});
parcelRegister("kaNNn", function(module, exports) {

var $6jdew = parcelRequire("6jdew");
let $eafb5e228143db70$var$url = new URL(import.meta.resolve("atHff"));
module.exports = $6jdew($eafb5e228143db70$var$url.toString(), $eafb5e228143db70$var$url.origin, true);

});
parcelRegister("6jdew", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

});






parcelRegister("D7J7L", function(module, exports) {

$parcel$export(module.exports, "uploadFileByURL", () => $0759a304347e31ab$export$f4fd5e00e88e59a2);
$parcel$export(module.exports, "uploadFileByBlob", () => $0759a304347e31ab$export$887bffb713a6dfa1);
$parcel$export(module.exports, "fetchPresignURL", () => $0759a304347e31ab$export$77e5d7b86a788139);
$parcel$export(module.exports, "batchPresignURLs", () => $0759a304347e31ab$export$4cdce75fdf6b323f);
$parcel$export(module.exports, "listFilesInDirectory", () => $0759a304347e31ab$export$f9930565fa71ccc6);
$parcel$export(module.exports, "listFoldersInDirectory", () => $0759a304347e31ab$export$b244dc3e3b162cdb);

var $pKQR8 = parcelRequire("pKQR8");

var $hWsLk = parcelRequire("hWsLk");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $0759a304347e31ab$var$S3_UPLOAD_TIMEOUT_MS = 300000; // 5 minutes - fetch from URL + upload to S3 can be slow
const $0759a304347e31ab$export$f5ab5b53c403a7c8 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/uploadFileToS3"], null, 3, undefined, $0759a304347e31ab$var$S3_UPLOAD_TIMEOUT_MS);
const $0759a304347e31ab$var$awsClient = (0, (/*@__PURE__*/$parcel$interopDefault($pKQR8))).create({});
/**
 * Retries failed requests up to 3 times with exponential backoff.
 * It retries on network errors or idempotent request errors.
 */ (0, $hWsLk.default)($0759a304347e31ab$var$awsClient.axiosInstance, {
    retries: 3,
    retryDelay: (0, $hWsLk.default).exponentialDelay
});
const $0759a304347e31ab$export$f4fd5e00e88e59a2 = async (filePath, fileURL, options = {})=>{
    const response = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: filePath,
        fileURL: fileURL
    }, options);
    // Treat as success if we have valid response data (backend may have succeeded but client got network/timeout)
    if (response.data?.presignURL != null || response.data?.filePath != null) return response.data;
    if (!response.ok) {
        const reason = response.problem ?? (response.status != null ? String(response.status) : "connection or timeout");
        throw new Error(`Upload failed: ${reason}`);
    }
    return response.data;
};
const $0759a304347e31ab$export$887bffb713a6dfa1 = async (filePath, fileBlob, options = {})=>{
    const writableURLresponse = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: filePath,
        contentType: fileBlob.type || "application/octet-stream",
        writable: true
    }, options);
    if (!writableURLresponse.ok) throw new Error(`Failed to get writable URL: ${writableURLresponse.status}`, {
        cause: writableURLresponse
    });
    const { presignURL: presignURL, readPresignURL: readPresignURL, filePath: resolvedFilePath } = writableURLresponse.data;
    // Upload the blob to the writable URL
    const uploadResponse = await $0759a304347e31ab$var$awsClient.put(presignURL, fileBlob, {
        headers: {
            Accept: "*/*",
            "Content-Type": fileBlob.type || "application/octet-stream"
        },
        ...options
    });
    if (!uploadResponse.ok) throw new Error(`Blob upload failed: ${uploadResponse.status}`, {
        cause: uploadResponse
    });
    // If the backend already provided the read presigned URL, return immediately
    // without making a 3rd HTTP round-trip.
    if (readPresignURL) return {
        filePath: resolvedFilePath ?? filePath,
        presignURL: readPresignURL
    };
    // Fallback: fetch read presigned URL
    const completeResponse = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: [
            filePath
        ]
    });
    // console.log("completeResponse", completeResponse);
    if (!completeResponse.ok) throw new Error(`Upload completion failed: ${completeResponse.status}`, {
        cause: completeResponse
    });
    return completeResponse.data?.urls?.[0];
};
const $0759a304347e31ab$export$77e5d7b86a788139 = async (filePath, options = {})=>{
    const response = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: filePath
    }, options);
    if (!response.ok) throw new Error(`Failed to get presigned URL: ${response.status}`, {
        cause: response
    });
    return response.data;
};
const $0759a304347e31ab$export$4cdce75fdf6b323f = async (filePaths)=>{
    const response = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: filePaths
    });
    if (!response.ok) throw new Error(`Failed to get batch presigned URLs: ${response.status}`, {
        cause: response
    });
    return response.data;
};
const $0759a304347e31ab$export$f9930565fa71ccc6 = async (directoryPath, options = {})=>{
    if (!directoryPath) throw new Error("directoryPath is required");
    const normalizedPath = directoryPath.endsWith("/") ? directoryPath : `${directoryPath}/`;
    const response = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: normalizedPath
    }, options);
    if (!response.ok) throw new Error(`Failed to list directory: ${response.status}`, {
        cause: response
    });
    return response.data;
};
const $0759a304347e31ab$export$b244dc3e3b162cdb = async (directoryPath, options = {})=>{
    if (!directoryPath) throw new Error("directoryPath is required");
    const normalizedPath = directoryPath.endsWith("/") ? directoryPath : `${directoryPath}/`;
    const response = await $0759a304347e31ab$export$f5ab5b53c403a7c8.post("", {
        filePath: normalizedPath,
        listFolders: true
    }, options);
    if (!response.ok) throw new Error(`Failed to list folders: ${response.status}`, {
        cause: response
    });
    return response.data;
};

});

parcelRegister("17n4p", function(module, exports) {

$parcel$export(module.exports, "getStories", () => $0d085720d1d7cdf9$export$60389bcd9e06b4bf);
$parcel$export(module.exports, "getStory", () => $0d085720d1d7cdf9$export$71e2f73ece07d188);
$parcel$export(module.exports, "createStory", () => $0d085720d1d7cdf9$export$338260f70f1e6c2a);
$parcel$export(module.exports, "updateStory", () => $0d085720d1d7cdf9$export$954c0903301a2307);
$parcel$export(module.exports, "deleteStory", () => $0d085720d1d7cdf9$export$1cab82932c9b3873);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $0d085720d1d7cdf9$export$907da8775e6d2a8c = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/stories"]);
function $0d085720d1d7cdf9$var$debounce(func, wait) {
    var timeout, value;
    return function() {
        if (!timeout) value = func.apply(this, arguments);
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            timeout = value = null;
        }, wait);
        return value;
    };
}
const $0d085720d1d7cdf9$export$60389bcd9e06b4bf = async (options = {})=>{
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.get("/", {}, options);
    if (!response.ok) throw new Error("Failed to fetch stories", {
        cause: response
    });
    return response.data?.stories ?? [];
};
const $0d085720d1d7cdf9$export$71e2f73ece07d188 = async (id, options = {})=>{
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.get(`/${id}`, {}, options);
    if (!response.ok) throw new Error(`Failed to fetch story ${id}`, {
        cause: response
    });
    return response.data?.story;
};
const $0d085720d1d7cdf9$export$338260f70f1e6c2a = async (story, options = {})=>{
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.post("/", {
        story: story
    }, options);
    if (!response.ok) throw new Error("Failed to create story", {
        cause: response
    });
    return response.data?.story;
};
const $0d085720d1d7cdf9$export$954c0903301a2307 = async (id, story, options = {})=>{
    // const { queryKey, signal } = context;
    // const [, , , id] = queryKey || [];
    if (!id) throw new Error("Story ID is required to update a story");
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.put(`/${id}`, story, options);
    if (!response.ok) throw new Error(`Failed to update story ${id}`, {
        cause: response
    });
    return response.data?.story;
};
const $0d085720d1d7cdf9$export$501dc8351a76b = $0d085720d1d7cdf9$var$debounce($0d085720d1d7cdf9$export$954c0903301a2307, 5000);
const $0d085720d1d7cdf9$export$1cab82932c9b3873 = async (id, options = {})=>{
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.delete(`/${id}`, {}, options);
    if (!response.ok) throw new Error(`Failed to delete story ${id}`, {
        cause: response
    });
    return response.data;
};
const $0d085720d1d7cdf9$export$b764b70cc9d9cb7e = async (id, email, options = {})=>{
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.put(`/${id}/share`, {
        shareWith: email
    }, options);
    if (!response.ok) throw new Error(`Failed to share story ${id}`, {
        cause: response
    });
    return response.data?.story;
};
const $0d085720d1d7cdf9$export$275270e83e83e26a = async (id, email, options = {})=>{
    const response = await $0d085720d1d7cdf9$export$907da8775e6d2a8c.put(`/${id}/unshare`, {
        shareWith: email
    }, options);
    if (!response.ok) throw new Error(`Failed to unshare story ${id}`, {
        cause: response
    });
    return response.data?.story;
};

});

parcelRegister("VXM1R", function(module, exports) {

$parcel$export(module.exports, "storyKey", () => $0ae3b0ca3987265c$export$aa528f747dbe3c57);
$parcel$export(module.exports, "getStoriesKey", () => $0ae3b0ca3987265c$export$dc36d6ddc31571ce);
$parcel$export(module.exports, "useStories", () => $0ae3b0ca3987265c$export$f2f99f29def19f2c);
$parcel$export(module.exports, "useStory", () => $0ae3b0ca3987265c$export$3ee30d5a4184e73f);
$parcel$export(module.exports, "useUpdateStory", () => $0ae3b0ca3987265c$export$c5e9b09cc1a05d56);
$parcel$export(module.exports, "useCreateStory", () => $0ae3b0ca3987265c$export$da196af5371a1ffd);
$parcel$export(module.exports, "useDeleteStory", () => $0ae3b0ca3987265c$export$359004347e4d2d9f);
$parcel$export(module.exports, "useShareStory", () => $0ae3b0ca3987265c$export$7f4142916c7c414b);
$parcel$export(module.exports, "useUnshareStory", () => $0ae3b0ca3987265c$export$1c7d5e042c5c9f1a);
$parcel$export(module.exports, "useGenerateImages", () => $0ae3b0ca3987265c$export$5bfab0e6b54ea2d8);

var $eF4cA = parcelRequire("eF4cA");

var $1WYFS = parcelRequire("1WYFS");
var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");
var $7ClmI = parcelRequire("7ClmI");

var $fmJ8d = parcelRequire("fmJ8d");

var $17n4p = parcelRequire("17n4p");

var $4SSyx = parcelRequire("4SSyx");
const $0ae3b0ca3987265c$export$aa528f747dbe3c57 = {
    all: [
        "stories"
    ],
    lists: ()=>[
            ...$0ae3b0ca3987265c$export$aa528f747dbe3c57.all,
            "list"
        ],
    list: (filters)=>[
            ...$0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(),
            {
                filters: filters
            }
        ],
    details: ()=>[
            ...$0ae3b0ca3987265c$export$aa528f747dbe3c57.all,
            "detail"
        ],
    detail: (id)=>[
            ...$0ae3b0ca3987265c$export$aa528f747dbe3c57.details(),
            id
        ]
};
const $0ae3b0ca3987265c$export$dc36d6ddc31571ce = (...keys)=>[
        "stories",
        ...keys
    ];
const $0ae3b0ca3987265c$var$storiesQueryOptions = ()=>(0, $1WYFS.queryOptions)({
        queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(),
        queryFn: ({ signal: signal })=>$17n4p.getStories({
                signal: signal
            }),
        staleTime: 300000,
        // onSuccess: (data) => {
        //   store.getState().setStories(data.stories);
        // },
        meta: {
            errorMessage: "Failed to load stories. Please try again."
        }
    });
const $0ae3b0ca3987265c$export$c4c29364fdf5d577 = (storyId)=>(0, $1WYFS.queryOptions)({
        queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId),
        queryFn: ({ signal: signal })=>$17n4p.getStory(storyId, {
                signal: signal
            }),
        meta: {
            errorMessage: "Failed to load the story. Please try again."
        },
        enabled: !!storyId
    });
const $0ae3b0ca3987265c$export$f2f99f29def19f2c = (options = {})=>{
    const query = (0, $4kcQz.useQuery)({
        ...$0ae3b0ca3987265c$var$storiesQueryOptions(),
        ...options
    });
    return query;
};
const $0ae3b0ca3987265c$export$d2f1cc5d1edf2f04 = (storyId)=>{
    const select = (0, $eF4cA.useCallback)((data)=>data?.find((s)=>s.id === storyId), [
        storyId
    ]);
    const query = $0ae3b0ca3987265c$export$f2f99f29def19f2c({
        select: select
    });
    return query;
};
const $0ae3b0ca3987265c$export$3ee30d5a4184e73f = (storyId, options = {})=>{
    const query = (0, $4kcQz.useQuery)({
        ...$0ae3b0ca3987265c$export$c4c29364fdf5d577(storyId),
        ...options
    });
    return query;
};
const $0ae3b0ca3987265c$export$c5e9b09cc1a05d56 = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const mutation = (0, $k6waQ.useMutation)({
        mutationKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId),
        mutationFn: (variables, { signal: signal })=>$17n4p.updateStory(storyId, variables, {
                signal: signal
            }),
        onMutate: async (variables)=>{
            await queryClient.cancelQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.all
            });
            const previousData = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId));
            const previousListData = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists());
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId), {
                ...previousData,
                ...variables
            });
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(), (old)=>old.map((story)=>story.id === storyId ? {
                        ...story,
                        ...variables
                    } : story));
            return {
                previousData: previousData,
                previousListData: previousListData
            };
        },
        onSuccess: (data)=>{
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId), data.story);
            queryClient.invalidateQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.lists()
            });
        },
        onError: (error, variables, context)=>{
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId), context.previousData);
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(), context.previousListData);
        // TODO: handle error
        },
        enabled: !!storyId
    });
    return mutation;
};
const $0ae3b0ca3987265c$export$da196af5371a1ffd = ()=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: (variables, { signal: signal })=>$17n4p.createStory(variables, {
                signal: signal
            }),
        onMutate: async (variables)=>{
            await queryClient.cancelQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.lists()
            });
            if (!variables.id) variables.id = self.crypto.randomUUID();
            const optimisticStory = {
                ...variables
            };
            const previousData = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists());
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(), [
                ...previousData,
                optimisticStory
            ]);
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.details(optimisticStory.id), optimisticStory);
            return {
                optimisticStory: optimisticStory,
                previousData: previousData
            };
        },
        onSuccess: (data)=>{
            queryClient.invalidateQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.lists()
            });
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.details(data.id), data);
        },
        onError: (error, variables, context)=>{
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(), context.previousData);
            queryClient.removeQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.details(context.optimisticStory.id)
            });
        // TODO: handle error
        }
    });
    return mutation;
};
const $0ae3b0ca3987265c$export$359004347e4d2d9f = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: (variables, { signal: signal })=>$17n4p.deleteStory(storyId, {
                signal: signal
            }),
        onMutate: async ()=>{
            await queryClient.cancelQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.lists()
            });
            const previousData = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.details(storyId));
            const oldStories = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists());
            const previousIndex = oldStories.findIndex((story)=>story.id === storyId);
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(), (old)=>old.filter((story)=>story.id !== storyId));
            queryClient.removeQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.details(storyId)
            });
            return {
                previousData: previousData,
                previousIndex: previousIndex
            };
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $0ae3b0ca3987265c$export$aa528f747dbe3c57.lists()
            });
        },
        onError: (error, variables, context)=>{
            queryClient.setQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.lists(), (state)=>state.toSpliced(context.previousIndex, 0, context.previousData));
        }
    });
    return mutation;
};
const $0ae3b0ca3987265c$export$7f4142916c7c414b = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const updateStory = $0ae3b0ca3987265c$export$c5e9b09cc1a05d56(storyId);
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: (variables)=>{
            const previousData = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId));
            const sharedWith = (previousData?.sharedWith || []).concat(variables.email);
            return updateStory.mutateAsync({
                sharedWith: sharedWith
            });
        },
        onSuccess: (data, variables)=>{
            (0, $fmJ8d.store).getState().addToast(`Shared with ${variables.email}`, {
                variant: "positive",
                timeout: 5000
            });
        },
        onError: (error, variables, context)=>{
            (0, $fmJ8d.store).getState().addToast(`Failed to share with ${variables.email}. Please try again`, {
                variant: "negative",
                timeout: 10000,
                actionLabel: "Retry",
                shouldCloseOnAction: true,
                onAction: ()=>{
                    mutation.mutate(variables);
                }
            });
        }
    });
    return mutation;
};
const $0ae3b0ca3987265c$export$1c7d5e042c5c9f1a = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const updateStory = $0ae3b0ca3987265c$export$c5e9b09cc1a05d56(storyId);
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: (variables)=>{
            const previousData = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId));
            const sharedWith = (previousData?.sharedWith || []).filter((email)=>email !== variables.email);
            return updateStory.mutateAsync({
                sharedWith: sharedWith
            });
        }
    });
    return mutation;
};
const $0ae3b0ca3987265c$export$5bfab0e6b54ea2d8 = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const generatePersonas = (0, $4SSyx.useGeneratePersonas)(storyId);
    const generateVisuals = (0, $4SSyx.useGenerateVisuals)(storyId);
    const updateStory = $0ae3b0ca3987265c$export$c5e9b09cc1a05d56(storyId);
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (variables = {})=>{
            const { forceGenerate: forceGenerate = false } = variables;
            const story = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId));
            if (!story) throw new Error(`Story with id ${storyId} not found`);
            const personasPromises = [];
            const visualsPromises = [];
            // Check if personas need to be generated
            if (story.personas?.some((p)=>!p.avatarPrompt) || forceGenerate) personasPromises.push(generatePersonas.mutateAsync());
            // Check if visuals need to be fetched
            if (story.script?.some((step)=>!step.visuals?.length) || forceGenerate) visualsPromises.push(generateVisuals.mutateAsync());
            // Wait for all generation to complete before saving
            await Promise.all([
                ...personasPromises,
                ...visualsPromises
            ]);
            // Get the updated story from cache (includes all generated images)
            const updatedStory = queryClient.getQueryData($0ae3b0ca3987265c$export$aa528f747dbe3c57.detail(storyId));
            // Save the complete story to the server only once at the end
            await updateStory.mutateAsync({
                personas: updatedStory.personas,
                script: updatedStory.script
            });
            return {
                success: true
            };
        },
        onSuccess: ()=>{
            (0, $fmJ8d.store).getState().addToast("Generation completed", {
                variant: "positive",
                timeout: 60000,
                actionLabel: "Create Presentation",
                onAction: ()=>{
                    console.log("Create Presentation"); // TODO: set({ isExpressDialogOpen: true });
                }
            });
        },
        onError: (error)=>{
            console.error(`Error generating images for story ${storyId}:`, error);
            (0, $fmJ8d.store).getState().addToast("Failed to generate images. Please try again.", {
                variant: "negative",
                timeout: 10000
            });
        }
    });
    return mutation;
};

});
parcelRegister("1WYFS", function(module, exports) {

$parcel$export(module.exports, "queryOptions", () => $16ba45eb44048853$export$9a8e3100474fe331);
//#region src/queryOptions.ts
function $16ba45eb44048853$export$9a8e3100474fe331(options) {
    return options;
}

});

parcelRegister("k6waQ", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $ea2d5347879c0474$export$609860bf8b0084c);

var $7ClmI = parcelRequire("7ClmI");

var $eF4cA = parcelRequire("eF4cA");

var $7gCI3 = parcelRequire("7gCI3");
var $3ur2P = parcelRequire("3ur2P");
var $hnhg4 = parcelRequire("hnhg4");
"use client";
//#region src/useMutation.ts
/**
* Unlike queries, mutations are typically used to create/update/delete data or perform server side-effects.
* `useMutation` is the hook for that.
* @param options - The {@link UseMutationOptions} to use — everything you can pass to `useMutation`.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns `mutate`/`mutateAsync` also accept per-call `onSuccess`/`onError`/`onSettled` callbacks as a second
* argument, useful for triggering call-site side effects (e.g. navigation) without coupling them to the shared
* mutation definition. Hook-level callbacks (passed to `options`) fire for every mutation; per-call callbacks
* fire only for the latest call you've made, and only while the component is still mounted — unmounting before
* the mutation settles removes the subscription and prevents them from firing.
* @throws {Error} The mutation error, when `throwOnError` is `true` or returns `true` for it, so that it is
* thrown to the nearest error boundary.
* @see {@link mutationOptions} to share these options across multiple `useMutation` call sites, or to look
* the mutation up elsewhere via its `mutationKey` (e.g. with `useMutationState`).
* @example
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   return (
*     <button
*       onClick={() =>
*         addMutation.mutate('Item', {
*           onError: (error) => console.error('Failed to add item:', error),
*         })
*       }
*     >
*       Add
*     </button>
*   )
* }
* ```
* @example
* Rendering the mutation's own state, rather than just firing it off:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   return (
*     <div>
*       {addMutation.isPending ? (
*         'Adding todo...'
*       ) : (
*         <>
*           {addMutation.isError ? (
*             <div>An error occurred: {addMutation.error.message}</div>
*           ) : null}
*           <button onClick={() => addMutation.mutate('Item')}>Add</button>
*         </>
*       )}
*     </div>
*   )
* }
* ```
* @example
* Optimistic update via `onMutate`, rolling back on `onError`:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onMutate: async (newTodo) => {
*       await queryClient.cancelQueries({ queryKey: ['todos'] })
*       const previousTodos = queryClient.getQueryData<Array<string>>(['todos'])
*
*       queryClient.setQueryData<Array<string>>(['todos'], (old) => [
*         ...(old ?? []),
*         newTodo,
*       ])
*
*       // Passed to `onError` as `onMutateResult` if the mutation fails.
*       return { previousTodos }
*     },
*     onError: (_err, _newTodo, onMutateResult) => {
*       queryClient.setQueryData(['todos'], onMutateResult?.previousTodos)
*     },
*     onSettled: () => {
*       queryClient.invalidateQueries({ queryKey: ['todos'] })
*     },
*   })
*
*   return (
*     <button onClick={() => addMutation.mutate('Item')}>Add</button>
*   )
* }
* ```
* @example
* Callbacks passed per call to `mutate` only fire for the last call — `mutateAsync` gives you a
* promise per call instead, so you can wait for all of them when they succeed:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodos() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   async function handleAddAll(todos: Array<string>) {
*     try {
*       await Promise.all(todos.map((todo) => addMutation.mutateAsync(todo)))
*     } catch (error) {
*       console.error('Failed to add todos:', error)
*     }
*   }
*
*   return (
*     <button onClick={() => handleAddAll(['Todo 1', 'Todo 2', 'Todo 3'])}>
*       Add all
*     </button>
*   )
* }
* ```
* @example
* If some of the mutations above can fail independently of the others, and you want to know which ones
* did — rather than losing that information the moment the first one rejects — swap `Promise.all` for
* `Promise.allSettled`:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodos() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   async function handleAddAll(todos: Array<string>) {
*     const addResults = await Promise.allSettled(
*       todos.map((todo) => addMutation.mutateAsync(todo)),
*     )
*
*     addResults.forEach((addResult, index) => {
*       if (addResult.status === 'rejected') {
*         console.error(`Failed to add "${todos[index]}":`, addResult.reason)
*       }
*     })
*   }
*
*   return (
*     <button onClick={() => handleAddAll(['Todo 1', 'Todo 2', 'Todo 3'])}>
*       Add all
*     </button>
*   )
* }
* ```
*/ function $ea2d5347879c0474$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $7ClmI.useQueryClient)(queryClient);
    const [observer] = $eF4cA.useState(()=>new (0, $7gCI3.MutationObserver)(client, options));
    $eF4cA.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $eF4cA.useSyncExternalStore($eF4cA.useCallback((onStoreChange)=>observer.subscribe((0, $hnhg4.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $eF4cA.useCallback((...args)=>{
        observer.mutate(args[0], args[1]).catch((0, $3ur2P.noop));
    }, [
        observer
    ]);
    if (result.error && (0, $3ur2P.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}

});
parcelRegister("7ClmI", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", () => $58bca7c203b22260$export$22e77b9572c4fded);
$parcel$export(module.exports, "QueryClientProvider", () => $58bca7c203b22260$export$45604f0cc8ae667b);

var $eF4cA = parcelRequire("eF4cA");

var $dx4lB = parcelRequire("dx4lB");
"use client";
//#region src/QueryClientProvider.tsx
/**
* The context that `useQueryClient` reads from. `QueryClientProvider` is the normal way to set it.
*/ const $58bca7c203b22260$export$da112d31b0149f31 = $eF4cA.createContext(void 0);
/**
* The `useQueryClient` hook returns the current `QueryClient` instance.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns The current `QueryClient` instance.
* @throws {Error} If no `queryClient` argument is passed and no `QueryClientProvider` is found in the
* component tree.
*/ const $58bca7c203b22260$export$22e77b9572c4fded = (queryClient)=>{
    const client = $eF4cA.useContext($58bca7c203b22260$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
/**
* Use the `QueryClientProvider` component to connect and provide a `QueryClient` to your application. Also
* calls `client.mount()`/`client.unmount()` as this component mounts/unmounts, which subscribes the client to
* focus/online events (resuming any paused mutations and refetching as needed when the app regains focus or
* comes back online).
* @param props - The `client` to provide, and the `children` that get access to it.
* @returns The provided `children`, wrapped so they can read the `QueryClient` via `useQueryClient`.
* @example
* ```tsx
* import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
*
* const queryClient = new QueryClient()
*
* function App() {
*   return <QueryClientProvider client={queryClient}>...</QueryClientProvider>
* }
* ```
*/ const $58bca7c203b22260$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $eF4cA.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $dx4lB.jsx)($58bca7c203b22260$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});

parcelRegister("7gCI3", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", () => $54a80dea689715fd$export$d3c1860ee66f291a);

var $3ur2P = parcelRequire("3ur2P");

var $jdy3Z = parcelRequire("jdy3Z");

var $hnhg4 = parcelRequire("hnhg4");

var $7iFRT = parcelRequire("7iFRT");
//#region src/mutationObserver.ts
/**
* Observes a single mutation and derives a `MutationObserverResult` from it.
* A framework hook like `useMutation` creates one `MutationObserver` per hook
* call, keeps it stable across re-renders, calls `setOptions` when the options
* passed to the hook change, subscribes to it to re-render on updates, and
* reads `getCurrentResult()` for the value to return. Calling `mutate()`
* builds a new underlying `Mutation` in the `MutationCache` and executes it.
* @example
* ```ts
* const observer = new MutationObserver(queryClient, {
*   mutationFn: (variables: { title: string }) => addPost(variables),
* })
* ```
*/ var $54a80dea689715fd$export$d3c1860ee66f291a = class extends (0, $jdy3Z.Subscribable) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    /**
	* Binds the methods of the result (`mutate` and `reset`) to the observer, so they keep working when
	* destructured from it.
	*/ bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    /**
	* Updates the observer's options.
	*
	* If the new `mutationKey` differs from the previous one (and both were
	* defined), the observer is reset, detaching it from the mutation it was
	* observing. Otherwise, if the currently observed mutation is still
	* `pending`, its options are updated in place as well.
	* @param options - The new mutation observer options. They are defaulted with {@link
	* QueryClient#defaultMutationOptions} before being applied.
	* @example
	* ```ts
	* observer.setOptions({
	*   mutationFn: (variables: { title: string }) => addPost(variables),
	*   onSuccess: (data) => console.log(data),
	* })
	* ```
	*/ setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $3ur2P.shallowEqualObjects)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $3ur2P.hashKey)(prevOptions.mutationKey) !== (0, $3ur2P.hashKey)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onSubscribe() {
        if (this.listeners.size === 1 && this.#currentMutation) {
            this.#currentMutation.addObserver(this);
            this.#updateResult();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    /**
	* Updates the observer's result when the observed mutation changes, and notifies its listeners.
	* @internal
	* @param action - The action that updated the observed mutation, passed on to the observer's
	* callbacks.
	*/ onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    /**
	* Returns the observer's current result, derived from the observed
	* mutation's state (or the default, `idle` state if no mutation has been
	* built yet, e.g. before the first `mutate()` call or after `reset()`).
	* @returns The observer's latest result.
	*/ getCurrentResult() {
        return this.#currentResult;
    }
    /**
	* Detaches the observer from the mutation it is currently observing (if
	* any) and resets the observed result back to its default, `idle` state.
	*
	* This does not cancel an in-flight mutation; the mutation itself keeps
	* running to completion and its own callbacks still fire, but this
	* observer stops reflecting its state and a subsequent `mutate()` call
	* will build a brand new mutation.
	* @see {@link MutationObserver#mutate}
	* @example
	* ```ts
	* observer.reset()
	* ```
	*/ reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    /**
	* Builds a new `Mutation` in the `MutationCache` using the observer's
	* current options, detaches this observer from any previously observed
	* mutation, attaches it to the new one, and executes it with the given
	* variables.
	*
	* The optional per-call `options` (`onSuccess`/`onError`/`onSettled`) are
	* invoked once the mutation settles, in addition to any callbacks defined
	* on the observer's own options.
	* @param variables - The variables passed to the `mutationFn`.
	* @param options - Per-call `onSuccess`, `onError`, and `onSettled` callbacks.
	* @returns A promise that resolves with the mutation's data, or rejects with its error.
	* @example
	* ```ts
	* await observer.mutate(
	*   { title: 'New post' },
	*   { onSuccess: (data) => console.log(data) },
	* )
	* ```
	*/ mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $7iFRT.getDefaultState)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $hnhg4.notifyManager).batch(()=>{
            const mutateOptions = this.#mutateOptions;
            if (mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const onMutateResult = this.#currentResult.context;
                const context = {
                    client: this.#client,
                    meta: this.options.meta,
                    mutationKey: this.options.mutationKey
                };
                if (action?.type === "success") {
                    try {
                        mutateOptions.onSuccess?.(action.data, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                    try {
                        mutateOptions.onSettled?.(action.data, null, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                } else if (action?.type === "error") {
                    try {
                        mutateOptions.onError?.(action.error, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                    try {
                        mutateOptions.onSettled?.(void 0, action.error, variables, onMutateResult, context);
                    } catch (e) {
                        Promise.reject(e);
                    }
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};

});
parcelRegister("3ur2P", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $28a926f18db84d7c$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $28a926f18db84d7c$export$8793edee2d425525);
$parcel$export(module.exports, "functionalUpdate", () => $28a926f18db84d7c$export$7f095f455ad5af3f);
$parcel$export(module.exports, "isValidTimeout", () => $28a926f18db84d7c$export$e539f754e934e270);
$parcel$export(module.exports, "timeUntilStale", () => $28a926f18db84d7c$export$811b83d62bcf47f0);
$parcel$export(module.exports, "resolveQueryValue", () => $28a926f18db84d7c$export$e36731f6aa6a4362);
$parcel$export(module.exports, "matchQuery", () => $28a926f18db84d7c$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $28a926f18db84d7c$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "partialMatchKey", () => $28a926f18db84d7c$export$2f07189bb9fa26a7);
$parcel$export(module.exports, "matchMutation", () => $28a926f18db84d7c$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "hashKey", () => $28a926f18db84d7c$export$1e87d19d4aab5805);
$parcel$export(module.exports, "replaceEqualDeep", () => $28a926f18db84d7c$export$77a71fc411098696);
$parcel$export(module.exports, "shallowEqualObjects", () => $28a926f18db84d7c$export$3e67810a3f0e9f1c);
$parcel$export(module.exports, "sleep", () => $28a926f18db84d7c$export$e772c8ff12451969);
$parcel$export(module.exports, "replaceData", () => $28a926f18db84d7c$export$17619bac5b909b23);
$parcel$export(module.exports, "addToEnd", () => $28a926f18db84d7c$export$ccce65a22a26f2bc);
$parcel$export(module.exports, "addToStart", () => $28a926f18db84d7c$export$8c6246b73dd61f4a);
$parcel$export(module.exports, "skipToken", () => $28a926f18db84d7c$export$1aa5a89531b7670d);
$parcel$export(module.exports, "ensureQueryFn", () => $28a926f18db84d7c$export$c71c44209368a3bc);
$parcel$export(module.exports, "shouldThrowError", () => $28a926f18db84d7c$export$2072f68e6c3507cf);
$parcel$export(module.exports, "addConsumeAwareSignal", () => $28a926f18db84d7c$export$83f813cd1f8a4973);

var $1OpUA = parcelRequire("1OpUA");
//#region src/utils.ts
/**
* @deprecated use `environmentManager.isServer()` instead.
*/ const $28a926f18db84d7c$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $28a926f18db84d7c$export$8793edee2d425525() {}
/**
* Resolves an {@link Updater}: calls it with `input` if it is a function, otherwise returns it as
* is.
* @param updater - The new value, or a function that receives `input` and returns the new value.
* @param input - The current value, passed to `updater` if it is a function.
* @returns The new value.
*/ function $28a926f18db84d7c$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
/**
* Checks whether a value can be used as a timeout: a non-negative, finite number.
* @param value - The value to check.
* @returns `true` if `value` is a number that is `>= 0` and not `Infinity`.
*/ function $28a926f18db84d7c$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
/**
* Calculates how long until data updated at `updatedAt` becomes stale.
* @param updatedAt - The timestamp, in milliseconds, at which the data was last updated.
* @param staleTime - The time, in milliseconds, after which data is considered stale. Defaults to
* `0`.
* @returns The remaining time in milliseconds, or `0` if the data is already stale.
*/ function $28a926f18db84d7c$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
/**
* Resolves an option that can be given either as a value or as a function of the query, such as
* `staleTime`.
* @param value - The option value, or a function that receives `query` and returns the value.
* @param query - The query passed to `value` if it is a function.
* @returns The resolved value, or `undefined` if `value` is `undefined`.
*/ function $28a926f18db84d7c$export$e36731f6aa6a4362(value, query) {
    return typeof value === "function" ? value(query) : value;
}
/**
* Checks whether a query matches the given {@link QueryFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* @param filters - The filters to check the query against.
* @param query - The query to check.
* @returns `true` if the query matches every specified filter.
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
*
* const matchingQueries = queryCache
*   .getAll()
*   .filter((query) => matchQuery({ queryKey: ['posts'] }, query))
* ```
*/ function $28a926f18db84d7c$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $28a926f18db84d7c$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$28a926f18db84d7c$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
/**
* Checks whether a mutation matches the given {@link MutationFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* If a `mutationKey` filter is provided but the mutation has no `mutationKey` of its own, it does not match.
* @param filters - The filters to check the mutation against.
* @param mutation - The mutation to check.
* @returns `true` if the mutation matches every specified filter.
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const matchingMutations = mutationCache
*   .getAll()
*   .filter((mutation) => matchMutation({ mutationKey: ['addPost'] }, mutation))
* ```
*/ function $28a926f18db84d7c$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($28a926f18db84d7c$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $28a926f18db84d7c$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$28a926f18db84d7c$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
/**
* Hashes a query key with the query's `queryKeyHashFn` option, falling back to {@link hashKey}.
* @param queryKey - The query key to hash.
* @param options - The query options that may provide a custom `queryKeyHashFn`.
* @returns The query hash, a string that identifies the query in the cache.
*/ function $28a926f18db84d7c$export$cc90ca97bc0d73fd(queryKey, options) {
    return (options?.queryKeyHashFn || $28a926f18db84d7c$export$1e87d19d4aab5805)(queryKey);
}
/**
* Default query & mutation keys hash function.
* Hashes the value into a stable hash.
* @param queryKey - The query or mutation key to hash.
* @returns The stable hash of the key, as a JSON string.
* @example
* ```ts
* // Object keys are sorted, so key order doesn't affect the hash:
* hashKey(['todos', { page: 1, filter: 'done' }]) // === '["todos",{"filter":"done","page":1}]'
* ```
*/ function $28a926f18db84d7c$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$28a926f18db84d7c$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $28a926f18db84d7c$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            if (b.length > a.length) return false;
            for(let i = 0; i < b.length; i++)if (!$28a926f18db84d7c$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys)if (!$28a926f18db84d7c$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        return true;
    }
    return false;
}
const $28a926f18db84d7c$var$hasOwn = Object.prototype.hasOwnProperty;
function $28a926f18db84d7c$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $28a926f18db84d7c$export$7a8558113332b71e(a) && $28a926f18db84d7c$export$7a8558113332b71e(b);
    if (!array && !($28a926f18db84d7c$export$53b83ca8eaab0383(a) && $28a926f18db84d7c$export$53b83ca8eaab0383(b))) return b;
    const aSize = (array ? a : Object.keys(a)).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $28a926f18db84d7c$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $28a926f18db84d7c$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
/**
* Shallow compare objects.
* @param a - The first object.
* @param b - The second object, or `undefined`.
* @returns `true` if both objects have the same keys, with strictly equal values for each key.
*/ function $28a926f18db84d7c$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a)if (a[key] !== b[key]) return false;
    return true;
}
/**
* Checks whether a value is an array with no holes and no extra properties.
* @param value - The value to check.
* @returns `true` if `value` is an array whose number of own keys equals its `length`.
*/ function $28a926f18db84d7c$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
/**
* Checks whether a value is a plain object, e.g. created with an object literal or
* `Object.create(null)`.
* @param o - The value to check.
* @returns `true` if `o` is a plain object.
*/ function $28a926f18db84d7c$export$53b83ca8eaab0383(o) {
    if (!$28a926f18db84d7c$var$hasObjectPrototype(o)) return false;
    const objectPrototype = Object.getPrototypeOf(o);
    const ctor = objectPrototype?.constructor;
    if (ctor === void 0) return true;
    if (typeof ctor !== "function") return false;
    const prot = ctor.prototype;
    if (!$28a926f18db84d7c$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (objectPrototype !== Object.prototype) return false;
    return true;
}
/**
* Checks whether a value's `Object.prototype.toString` tag is `[object Object]`.
* @param o - The value to check.
* @returns `true` if the tag is `[object Object]`.
*/ function $28a926f18db84d7c$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
/**
* Waits for the given time, using the configured {@link timeoutManager}.
* @param timeout - The time to wait, in milliseconds.
* @returns A promise that resolves after `timeout` milliseconds.
*/ function $28a926f18db84d7c$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $1OpUA.timeoutManager).setTimeout(resolve, timeout);
    });
}
/**
* Applies a query's `structuralSharing` option when writing new data.
* @param prevData - The previously cached data.
* @param data - The new data.
* @param options - The query options, whose `structuralSharing` decides how the data is merged.
* @returns The result of a custom `structuralSharing` function, `data` with its unchanged parts
* replaced by those of `prevData` by default, or `data` as is if `structuralSharing` is `false`.
* @throws {Error} The error from the default structural sharing, e.g. when the data is not JSON serializable.
* Outside production, it is also logged to the console.
*/ function $28a926f18db84d7c$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $28a926f18db84d7c$export$77a71fc411098696(prevData, data);
    }
    return data;
}
/**
* Intended to be passed as a query's `placeholderData` option, for example
* `placeholderData: keepPreviousData`. Instead of resetting the query's data to `undefined` while a new
* query key is fetching, it keeps displaying the previously fetched data until the new data arrives.
* @param previousData - The data of the previous query key, passed by the observer.
* @returns The previous data, unchanged.
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['posts', page],
*   queryFn: () => fetchPosts(page),
*   placeholderData: keepPreviousData,
* })
* ```
*/ function $28a926f18db84d7c$export$f537417e7e421eac(previousData) {
    return previousData;
}
/**
* Returns a new array with `item` added at the end. If that makes the array longer than `max`,
* the first item is dropped. Only one item is dropped, so the result can still exceed `max` if
* `items` already did.
* @param items - The current items.
* @param item - The value to append.
* @param max - The length above which an item is dropped. `0` (the default) means no limit.
* @returns A new array with `item` added.
*/ function $28a926f18db84d7c$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
/**
* Returns a new array with `item` added at the start. If that makes the array longer than `max`,
* the last item is dropped. Only one item is dropped, so the result can still exceed `max` if
* `items` already did.
* @param items - The current items.
* @param item - The value to prepend.
* @param max - The length above which an item is dropped. `0` (the default) means no limit.
* @returns A new array with `item` added.
*/ function $28a926f18db84d7c$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
/**
* Sentinel value that can be passed as a query's `queryFn` to conditionally disable the query (equivalent
* to `enabled: false`) while preserving full type inference for the query's data. Unlike `enabled: false`,
* a query disabled via `skipToken` cannot be triggered with `refetch`.
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['post', postId],
*   queryFn: postId != null ? () => fetchPost(postId) : skipToken,
* })
* ```
*/ const $28a926f18db84d7c$export$1aa5a89531b7670d = Symbol();
/**
* Returns the function to call for a fetch. If there is no `queryFn` but the fetch was started from
* an `initialPromise`, that promise is returned instead. If there is no usable `queryFn` (missing or
* {@link skipToken}), the returned function rejects with a `Missing queryFn` error.
* @param options - The query options with the `queryFn`, and the `queryHash` used in error messages.
* @param fetchOptions - The fetch options, which may carry an `initialPromise`.
* @returns The function to call for the fetch.
*/ function $28a926f18db84d7c$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $28a926f18db84d7c$export$1aa5a89531b7670d) return ()=>Promise.reject(/* @__PURE__ */ new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
/**
* Resolves a `throwOnError` option to a boolean.
* If `throwOnError` is a function, it is called with `params` (e.g. the error and, depending on the caller,
* additional context such as the query or mutation) and its result is returned, allowing the throwing
* behavior to be decided per error. Otherwise, `throwOnError` itself is coerced to a boolean (`undefined`
* resolves to `false`).
* @param throwOnError - The `throwOnError` option: a boolean, a function that decides per error, or
* `undefined`.
* @param params - The arguments passed to `throwOnError` if it is a function.
* @returns Whether the error should be thrown.
* @example
* ```ts
* const throwOnError =
*   query.state.error && typeof options.throwOnError === 'function'
*     ? shouldThrowError(options.throwOnError, [query.state.error, query])
*     : options.throwOnError
* ```
*/ function $28a926f18db84d7c$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
/**
* Adds a lazy `signal` getter to an object, such as a query function context. The first time
* `signal` is read, `onCancelled` is registered for the signal's `abort` event (or called right
* away if it is already aborted), so cancellation is only tracked when the signal is actually used.
* @param object - The object to add the `signal` property to.
* @param getSignal - Returns the `AbortSignal`. Called once, when `signal` is first read.
* @param onCancelled - Called when the signal is aborted, if `signal` was read.
* @returns The same object, with the `signal` property added.
*/ function $28a926f18db84d7c$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ??= getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}

});
parcelRegister("1OpUA", function(module, exports) {

$parcel$export(module.exports, "timeoutManager", () => $151e8f7d754b246f$export$94a2700736e69372);
$parcel$export(module.exports, "systemSetTimeoutZero", () => $151e8f7d754b246f$export$5086591e51e32a18);
//#region src/timeoutManager.ts
const $151e8f7d754b246f$export$d235812f9125bf47 = {
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
/**
* Allows customization of how timeouts are created.
*
* `@tanstack/query-core` makes liberal use of timeouts to implement `staleTime`
* and `gcTime`. The default TimeoutManager provider uses the platform's global
* `setTimeout` implementation, which is known to have scalability issues with
* thousands of timeouts on the event loop.
*
* If you hit this limitation, consider providing a custom TimeoutProvider that
* coalesces timeouts.
*/ var $151e8f7d754b246f$export$6336d90323f0ab52 = class {
    #provider = $151e8f7d754b246f$export$d235812f9125bf47;
    #providerCalled = false;
    /**
	* `setTimeoutProvider` can be used to set a custom implementation of the
	* `setTimeout`, `clearTimeout`, `setInterval`, `clearInterval` functions,
	* called a `TimeoutProvider`.
	*
	* This may be useful if you notice event loop performance issues with
	* thousands of queries. A custom TimeoutProvider could also support timer
	* delays longer than the global `setTimeout` maximum delay value of about
	* 24 days.
	*
	* It is important to call `setTimeoutProvider` before creating a
	* QueryClient or queries, so that the same provider is used consistently
	* for all timers in the application, since different TimeoutProviders
	* cannot cancel each others' timers.
	* @param provider - The `TimeoutProvider` to use for all timers from now on.
	* @example
	* ```ts
	* import { timeoutManager, QueryClient } from '@tanstack/query-core'
	* import { CustomTimeoutProvider } from './CustomTimeoutProvider'
	*
	* timeoutManager.setTimeoutProvider(new CustomTimeoutProvider())
	*
	* export const queryClient = new QueryClient()
	* ```
	*/ setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    /**
	* `setTimeout` schedules a callback to run after approximately `delay`
	* milliseconds, like the global `setTimeout` function. The callback can be
	* canceled with `clearTimeout`.
	*
	* It returns a timer ID, which may be a number or an object that can be
	* coerced to a number via `Symbol.toPrimitive`.
	* @param callback - The function to call when the timeout elapses.
	* @param delay - The time to wait before calling `callback`, in milliseconds.
	* @returns The timer ID, to pass to {@link TimeoutManager#clearTimeout}.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* const timeoutIdNumber: number = Number(timeoutId)
	* ```
	*/ setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    /**
	* `clearTimeout` cancels a timeout callback scheduled with `setTimeout`,
	* like the global `clearTimeout` function. It should be called with a
	* timer ID returned by `setTimeout`.
	* @param timeoutId - The timer ID returned by `setTimeout`, or `undefined`.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearTimeout(timeoutId)
	* ```
	*/ clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    /**
	* `setInterval` schedules a callback to be called approximately every
	* `delay` milliseconds, like the global `setInterval` function.
	*
	* Like `setTimeout`, it returns a timer ID, which may be a number or an
	* object that can be coerced to a number via `Symbol.toPrimitive`.
	* @param callback - The function to call on every interval.
	* @param delay - The time between calls, in milliseconds.
	* @returns The timer ID, to pass to {@link TimeoutManager#clearInterval}.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	* ```
	*/ setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    /**
	* `clearInterval` can be used to cancel an interval, like the global
	* `clearInterval` function. It should be called with an interval ID
	* returned by `setInterval`.
	* @param intervalId - The timer ID returned by `setInterval`, or `undefined`.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearInterval(intervalId)
	* ```
	*/ clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
/**
* Singleton instance of {@link TimeoutManager}, used throughout TanStack Query to schedule and cancel timers.
*/ const $151e8f7d754b246f$export$94a2700736e69372 = new $151e8f7d754b246f$export$6336d90323f0ab52();
/**
* In many cases code wants to delay to the next event loop tick; this is not
* mediated by {@link timeoutManager}.
*
* This function is provided to make auditing the `tanstack/query-core` for
* incorrect use of system `setTimeout` easier.
* @param callback - The function to call on the next event loop tick.
*/ function $151e8f7d754b246f$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}

});


parcelRegister("jdy3Z", function(module, exports) {

$parcel$export(module.exports, "Subscribable", () => $dfd9a7806e300d7d$export$d26086b469ecdbcc);
//#region src/subscribable.ts
/**
* The base class behind everything in Query that you can subscribe to: `QueryCache`, `MutationCache`,
* the observers, and the `FocusManager`/`OnlineManager` behind `focusManager` and `onlineManager`.
* Subclasses decide what a listener receives and when it is called.
*/ var $dfd9a7806e300d7d$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    /**
	* Registers a listener to be called on every update this object notifies about. Returns a function
	* that removes the listener again — call it to stop listening. The base class never drops a listener
	* on its own, though some subclasses clear all of theirs in `destroy()`.
	* @param listener - Called on each update, with whatever the subclass passes to its subscribers.
	* @returns A function that removes the listener.
	* @example
	* ```ts
	* const unsubscribe = subscribable.subscribe(() => {
	*   // react to the update
	* })
	*
	* unsubscribe()
	* ```
	*/ subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    /**
	* Returns `true` while at least one listener is registered, `false` once they have all unsubscribed.
	* @returns `true` if at least one listener is registered.
	*/ hasListeners() {
        return this.listeners.size > 0;
    }
    /**
	* Called after a listener is added. Does nothing here; subclasses override it, e.g. to start
	* tracking what they observe once the first listener subscribes.
	*/ onSubscribe() {}
    /**
	* Called after a listener is removed. Does nothing here; subclasses override it, e.g. to clean up
	* once the last listener unsubscribes.
	*/ onUnsubscribe() {}
};

});

parcelRegister("hnhg4", function(module, exports) {

$parcel$export(module.exports, "notifyManager", () => $ca61f8c263a6eef3$export$520687f44db6e1ab);

var $1OpUA = parcelRequire("1OpUA");
//#region src/notifyManager.ts
/**
* Default scheduling function used by the notify manager.
* Schedules the callback with the system's `setTimeout(callback, 0)`.
*/ const $ca61f8c263a6eef3$export$7c76da44185e6090 = (0, $1OpUA.systemSetTimeoutZero);
/**
* Creates a notify manager, which schedules and batches notifications to subscribers. Query uses a
* single instance of it, exported as {@link notifyManager}.
* @returns A new notify manager.
*/ function $ca61f8c263a6eef3$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $ca61f8c263a6eef3$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        /**
		* Batches all updates scheduled inside the passed callback.
		* This is mainly used internally to optimize query client updating.
		* Batches can be nested; the queue is only flushed once the outermost `batch` call finishes.
		* The return value of `callback` is passed through.
		* @param callback - The function to run in the batch.
		* @returns The return value of `callback`.
		*/ batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
		* All calls to the wrapped function will be batched.
		* @param callback - The function to wrap.
		* @returns A function that schedules a call to `callback` with the given arguments.
		*/ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: /**
		* Schedules a function to be run on the next batch.
		* By default, the batch is run with a `setTimeout`, but this can be configured via `setScheduler`.
		*/ schedule,
        /**
		* Use this method to set a custom notify function.
		* This can be used to for example wrap notifications with `React.act` while running tests.
		* @param fn - Receives each notification callback and must call it.
		*/ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
		* Use this method to set a custom function to batch notifications together into a single tick.
		* Framework adapters use this to plug in their own batching primitive, so that a single query
		* update only triggers one re-render instead of one per subscriber.
		* @param fn - Receives a function that runs a batch of notifications and must call it.
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		* import { batch } from 'solid-js'
		*
		* notifyManager.setBatchNotifyFunction(batch)
		* ```
		*/ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        /**
		* Configures a custom callback that schedules when the next batch runs.
		* The default behavior is `setTimeout(callback, 0)`.
		* @param fn - Receives a callback that runs the next batch, and schedules it.
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		*
		* // Schedule batches in the next microtask
		* notifyManager.setScheduler(queueMicrotask)
		*
		* // Schedule batches before the next frame is rendered
		* notifyManager.setScheduler(requestAnimationFrame)
		*
		* // Schedule batches some time in the future
		* notifyManager.setScheduler((cb) => setTimeout(cb, 10))
		* ```
		*/ setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
/**
* Handles scheduling and batching callbacks in TanStack Query.
*/ const $ca61f8c263a6eef3$export$520687f44db6e1ab = $ca61f8c263a6eef3$export$316a8efd03cd1458();

});

parcelRegister("7iFRT", function(module, exports) {

$parcel$export(module.exports, "Mutation", () => $550ab0ff6167ffa0$export$17b8b19c814bcf56);
$parcel$export(module.exports, "getDefaultState", () => $550ab0ff6167ffa0$export$a1659b54bac3252a);

var $hnhg4 = parcelRequire("hnhg4");

var $k7O9T = parcelRequire("k7O9T");

var $2Vzad = parcelRequire("2Vzad");
//#region src/mutation.ts
/**
* Represents a single mutation attempt. A `Mutation` holds the mutation's
* options, state (data/error/status), and the `MutationObserver`s currently
* subscribed to it.
*
* Instances are created and managed internally by `MutationCache`; application
* code typically interacts with mutations indirectly through `QueryClient` or
* a framework hook like `useMutation`. Direct access to a `Mutation` instance
* is possible via `mutationCache.find()`/`getAll()` for inspecting cache state.
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
* ```
*/ var $550ab0ff6167ffa0$export$17b8b19c814bcf56 = class extends (0, $2Vzad.Removable) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $550ab0ff6167ffa0$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    /**
	* Replaces the mutation's options and applies their `gcTime`.
	* @internal
	* @param options - The new mutation options.
	*/ setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    /**
	* The `meta` object passed in the mutation's options, if any.
	* @returns The mutation's `meta`, or `undefined` if none was set.
	*/ get meta() {
        return this.options.meta;
    }
    /**
	* Subscribes an observer to the mutation and stops its garbage collection.
	* @internal
	* @param observer - The observer to add. Adding an observer that is already subscribed does
	* nothing.
	*/ addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    /**
	* Unsubscribes an observer from the mutation.
	* @internal
	* @param observer - The observer to remove. Garbage collection is scheduled afterwards.
	*/ removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    /**
	* Resumes a mutation that is currently paused or was restored from a
	* dehydrated, still-`pending` state.
	*
	* - If this mutation has an active retryer (it paused mid-attempt, e.g. due
	*   to the network mode or scope-based queuing), its retryer is resumed.
	* - Otherwise, if the mutation's status is still `pending` (e.g. it was
	*   dehydrated while an attempt was in flight and never got a retryer in
	*   this instance), `execute` is called again with the last known variables.
	* - Otherwise the mutation has already settled and this resolves immediately
	*   without running anything again.
	* @returns A promise that settles with the resumed mutation: it rejects if the mutation fails.
	* It resolves immediately if the mutation has already settled.
	* @see {@link Mutation#execute}
	* @example
	* ```ts
	* // typically driven by reconnect handling, e.g. queryClient.resumePausedMutations()
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* await mutation?.continue()
	* ```
	*/ continue() {
        return this.#retryer?.continue() ?? (this.state.status === "pending" ? this.execute(this.state.variables) : Promise.resolve());
    }
    /**
	* Runs the mutation function for the given variables through a retryer, and
	* drives the mutation's state and lifecycle callbacks through to settlement.
	*
	* If this mutation's state is already `pending` when `execute` is called
	* (i.e. it was restored, still in-flight, from a dehydrated state), the
	* `onMutate` step is skipped and a `continue` action is dispatched to
	* unpause it; otherwise a `pending` action is dispatched first, then the
	* mutation cache's `onMutate` and the mutation's own `onMutate` option are
	* awaited in that order, and the resulting context is stored.
	*
	* The mutation function is then run (subject to `retry`/`retryDelay`/
	* `networkMode`, and to the mutation cache's scope-based serialization).
	* On success, the cache's `onSuccess`/`onSettled` callbacks run before the
	* mutation's own `onSuccess`/`onSettled` options, a `success` action is
	* dispatched, and the resolved data is returned. On failure, the same
	* cache-then-option ordering is used for `onError`/`onSettled`, but each of
	* those four callbacks is individually caught so that a throwing callback
	* cannot mask the original error; an `error` action is then dispatched and
	* the original error is re-thrown.
	* @param variables - The variables passed to the `mutationFn`.
	* @returns A promise that resolves with the mutation's data, or rejects with its error.
	* @see {@link Mutation#continue}
	* @example
	* ```ts
	* // Called internally by `MutationObserver.mutate` and `Mutation.continue` —
	* // applications normally trigger mutations through those, not this method.
	* const data = await mutation.execute(variables)
	* ```
	*/ async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        const retryer = this.#retryer = (0, $k7O9T.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(/* @__PURE__ */ new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if (this.#mutationCache.config.onMutate) await this.#mutationCache.config.onMutate(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            throw error;
        } finally{
            if (this.#retryer === retryer) this.#retryer = void 0;
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $hnhg4.notifyManager).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
/**
* Returns the initial state of a mutation: `'idle'`, with no data, error, or variables.
* @returns The initial mutation state.
*/ function $550ab0ff6167ffa0$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

});
parcelRegister("k7O9T", function(module, exports) {

$parcel$export(module.exports, "canFetch", () => $ea6b5e8a256f3e40$export$61b92f63f30245cf);
$parcel$export(module.exports, "CancelledError", () => $ea6b5e8a256f3e40$export$a8430ed4188f35a9);
$parcel$export(module.exports, "isCancelledError", () => $ea6b5e8a256f3e40$export$986cc6445c1d323);
$parcel$export(module.exports, "createRetryer", () => $ea6b5e8a256f3e40$export$2cbd00fe8a2c8d85);

var $3ur2P = parcelRequire("3ur2P");

var $lGmfb = parcelRequire("lGmfb");

var $h5e0l = parcelRequire("h5e0l");

var $dRDEH = parcelRequire("dRDEH");
//#region src/retryer.ts
/**
* The default `retryDelay`: doubles with every failure, starting at 1 second, up to 30 seconds.
* @param failureCount - The number of failures so far.
* @returns The delay before the next retry, in milliseconds.
*/ function $ea6b5e8a256f3e40$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
/**
* Checks whether a fetch can run for the given network mode.
* @param networkMode - The `networkMode` option. Defaults to `'online'`.
* @returns `true` if the network mode is not `'online'`, or if it is and the client is online.
*/ function $ea6b5e8a256f3e40$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $dRDEH.onlineManager).isOnline() : true;
}
/**
* The error thrown by a `Retryer` (and surfaced to `query.promise`/`mutation`) when a fetch is cancelled, e.g. via
* `query.cancel()`. `revert`, if `true`, tells the caller to restore the state the query was in before the fetch
* started instead of surfacing the error. `silent`, if `true`, tells the caller to suppress this error and instead
* resolve with the promise of the fetch that triggered the cancellation.
* @example
* ```ts
* query.cancel()
*
* try {
*   await query.promise
* } catch (error) {
*   if (error instanceof CancelledError) {
*     // the fetch was cancelled, e.g. via `query.cancel()`
*   }
* }
* ```
*/ var $ea6b5e8a256f3e40$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
/**
* Checks whether a value is a `CancelledError`.
* @param value - The value to check.
* @returns `true` if `value` is a `CancelledError`.
* @deprecated Use instanceof `CancelledError` instead.
*/ function $ea6b5e8a256f3e40$export$986cc6445c1d323(value) {
    return value instanceof $ea6b5e8a256f3e40$export$a8430ed4188f35a9;
}
/**
* Creates a retryer, which runs a function and retries it on failure according to the `retry` and
* `retryDelay` options. It pauses while the network mode doesn't allow fetching or `canRun` returns
* `false`, and can be cancelled. Queries and mutations use it to run their `queryFn` and
* `mutationFn`.
* @param config - The function to run, the retry options, and the callbacks for failures, pausing,
* continuing, and cancellation.
* @returns The retryer, whose `promise` settles with the result of the function.
*/ function $ea6b5e8a256f3e40$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    let status = "pending";
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((resolve, reject)=>{
        promiseResolve = resolve;
        promiseReject = reject;
    });
    promise.catch((0, $3ur2P.noop));
    const isResolved = ()=>status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new $ea6b5e8a256f3e40$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $h5e0l.focusManager).isFocused() && (config.networkMode === "always" || (0, $dRDEH.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$ea6b5e8a256f3e40$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            status = "resolved";
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            status = "rejected";
            promiseReject(value);
        }
    };
    const pause = (canResume)=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canResume()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $lGmfb.isServer)() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $ea6b5e8a256f3e40$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $3ur2P.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause(canContinue);
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        status: ()=>status,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause(canStart).then(run);
            return promise;
        }
    };
}

});
parcelRegister("lGmfb", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $fc8ec6636207476f$export$6acf61af03e62db);

var $3ur2P = parcelRequire("3ur2P");
//#region src/environmentManager.ts
let $fc8ec6636207476f$var$isServerFn = ()=>(0, $3ur2P.isServer);
/**
* Returns whether the current runtime should be treated as a server environment.
* @returns `true` if the runtime is treated as a server.
*/ const $fc8ec6636207476f$export$6acf61af03e62db = ()=>$fc8ec6636207476f$var$isServerFn();
/**
* Manages how TanStack Query detects whether the current runtime should be treated as
* server-side, which disables scheduling refetch timers and changes the default `retry` count
* and `gcTime`. By default, the detection treats a missing `window` (or the presence of a
* `Deno` global) as server.
*
* Override this for runtimes where that default detection would give the wrong answer — for
* example, a Service Worker, where `window` is undefined even though the environment should
* behave like a client.
* @example
* ```ts
* import { environmentManager } from '@tanstack/query-core'
*
* environmentManager.setIsServer(() => false)
* ```
*/ const $fc8ec6636207476f$export$2d935f1a9c9d3f3e = {
    isServer: $fc8ec6636207476f$export$6acf61af03e62db,
    /**
	* Overrides the server check globally.
	* @param isServerValue - A function that returns whether the runtime should be treated as a
	* server.
	*/ setIsServer (isServerValue) {
        $fc8ec6636207476f$var$isServerFn = isServerValue;
    }
};

});

parcelRegister("h5e0l", function(module, exports) {

$parcel$export(module.exports, "focusManager", () => $c6fdc449e69c77de$export$6bf54661be5b02cf);

var $jdy3Z = parcelRequire("jdy3Z");
//#region src/focusManager.ts
/**
* The `FocusManager` manages the focus state within TanStack Query.
*
* It can be used to change the default event listeners or to manually change the focus state.
*/ var $c6fdc449e69c77de$export$86f1af424b2ca4de = class extends (0, $jdy3Z.Subscribable) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the focus state. The provided `setup` function
	* receives a `setFocused` callback: call it with a `boolean` to manually
	* set the focus state, or with no arguments to re-evaluate the current
	* focus state and notify subscribers.
	* @param setup - Receives the `setFocused` callback, registers the event listener, and may return
	* a cleanup function that is called when the listener is replaced or no longer needed.
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* focusManager.setEventListener((handleFocus) => {
	*   const listener = () => handleFocus()
	*   // Listen to visibilitychange
	*   if (typeof window !== 'undefined' && window.addEventListener) {
	*     window.addEventListener('visibilitychange', listener, false)
	*   }
	*
	*   return () => {
	*     // Be sure to unsubscribe if a new handler is set
	*     window.removeEventListener('visibilitychange', listener)
	*   }
	* })
	* ```
	*/ setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    /**
	* `setFocused` can be used to manually set the focus state. Set `undefined`
	* to fall back to the default focus check.
	* @param focused - The focus state, or `undefined` to use the default focus check.
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* // Set focused
	* focusManager.setFocused(true)
	*
	* // Set unfocused
	* focusManager.setFocused(false)
	*
	* // Fallback to the default focus check
	* focusManager.setFocused(undefined)
	* ```
	*/ setFocused(focused) {
        if (this.#focused !== focused) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    /**
	* `onFocus` notifies all subscribed listeners with the current focus state.
	*/ onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    /**
	* `isFocused` can be used to get the current focus state.
	* @returns The focus state set with `setFocused`, or otherwise whether the document is visible.
	*/ isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
/**
* Singleton instance of {@link FocusManager}, used to manage and observe the focus state within TanStack Query.
*/ const $c6fdc449e69c77de$export$6bf54661be5b02cf = new $c6fdc449e69c77de$export$86f1af424b2ca4de();

});

parcelRegister("dRDEH", function(module, exports) {

$parcel$export(module.exports, "onlineManager", () => $029ad28577cc8c9c$export$b113e788b2dd3fdc);

var $jdy3Z = parcelRequire("jdy3Z");
//#region src/onlineManager.ts
/**
* The `OnlineManager` manages the online state within TanStack Query. It can
* be used to change the default event listeners or to manually change the
* online state.
*
* By default, the `onlineManager` assumes an active network connection, and
* listens to the `online` and `offline` events on the `window` object to
* detect changes.
*/ var $029ad28577cc8c9c$export$58774fb55d5ff7fc = class extends (0, $jdy3Z.Subscribable) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the online state. The provided `setup` function
	* receives a `setOnline` callback that should be called with a `boolean`
	* whenever the online state changes.
	* @param setup - Receives the `setOnline` callback, registers the event listener, and may return
	* a cleanup function that is called when the listener is replaced or no longer needed.
	* @example
	* ```ts
	* import NetInfo from '@react-native-community/netinfo'
	* import { onlineManager } from '@tanstack/query-core'
	*
	* onlineManager.setEventListener((setOnline) => {
	*   return NetInfo.addEventListener((state) => {
	*     setOnline(!!state.isConnected)
	*   })
	* })
	* ```
	*/ setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    /**
	* `setOnline` can be used to manually set the online state.
	* @param online - The online state.
	* @example
	* ```ts
	* import { onlineManager } from '@tanstack/query-core'
	*
	* // Set to online
	* onlineManager.setOnline(true)
	*
	* // Set to offline
	* onlineManager.setOnline(false)
	* ```
	*/ setOnline(online) {
        if (this.#online !== online) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    /**
	* `isOnline` can be used to get the current online state.
	* @returns `true` if online.
	*/ isOnline() {
        return this.#online;
    }
};
/**
* Singleton instance of {@link OnlineManager}, used to manage and observe the online state within TanStack Query.
*/ const $029ad28577cc8c9c$export$b113e788b2dd3fdc = new $029ad28577cc8c9c$export$58774fb55d5ff7fc();

});


parcelRegister("2Vzad", function(module, exports) {

$parcel$export(module.exports, "Removable", () => $221c2e68adbb396b$export$e09608847fcc8c59);

var $1OpUA = parcelRequire("1OpUA");

var $3ur2P = parcelRequire("3ur2P");

var $lGmfb = parcelRequire("lGmfb");
//#region src/removable.ts
/**
* The base class for cache entries that are garbage collected once nothing is using them —
* `Query` and `Mutation` both extend it. `gcTime` controls how long an unused entry is kept.
*/ var $221c2e68adbb396b$export$e09608847fcc8c59 = class {
    #gcTimeout;
    /**
	* Clears the pending garbage collection timeout, so the entry is no longer scheduled for removal.
	* A subclass may override this to release what it holds on to as well — `Query` also cancels any
	* in-flight fetch.
	*/ destroy() {
        this.clearGcTimeout();
    }
    /**
	* Schedules the entry to be removed from its cache after `gcTime`, replacing any timeout scheduled
	* before. Nothing is scheduled if `gcTime` is `Infinity`.
	*/ scheduleGc() {
        this.clearGcTimeout();
        if ((0, $3ur2P.isValidTimeout)(this.gcTime)) this.#gcTimeout = (0, $1OpUA.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    /**
	* Updates `gcTime`, keeping the longest one seen so far. Without a value, it defaults to 5 minutes
	* on the client and `Infinity` on the server.
	* @param newGcTime - The `gcTime` from the latest options, if any.
	*/ updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $lGmfb.isServer)() ? Infinity : 3e5));
    }
    /**
	* Cancels the scheduled removal, if there is one.
	*/ clearGcTimeout() {
        if (this.#gcTimeout !== void 0) {
            (0, $1OpUA.timeoutManager).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};

});




parcelRegister("4kcQz", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3262fecd5234c450$export$dd0a697e1782aedd);

var $hGrCf = parcelRequire("hGrCf");

var $hpFA5 = parcelRequire("hpFA5");
"use client";
//#region src/useQuery.ts
function $3262fecd5234c450$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $hGrCf.useBaseQuery)(options, (0, $hpFA5.QueryObserver), queryClient);
}

});
parcelRegister("hGrCf", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", () => $cdfbc7d8781924f1$export$fff0865807e996c5);

var $7ClmI = parcelRequire("7ClmI");

var $8UjFd = parcelRequire("8UjFd");

var $hzoc8 = parcelRequire("hzoc8");

var $4OZmE = parcelRequire("4OZmE");

var $1rcdI = parcelRequire("1rcdI");

var $eF4cA = parcelRequire("eF4cA");

var $3ur2P = parcelRequire("3ur2P");
var $hnhg4 = parcelRequire("hnhg4");
"use client";
//#region src/useBaseQuery.ts
/**
* Base implementation shared by `useQuery`, `useInfiniteQuery`, `useSuspenseQuery`, and
* `useSuspenseInfiniteQuery`.
* @param options - The options passed to the calling hook.
* @param Observer - The observer class from query-core (`QueryObserver` or
* `InfiniteQueryObserver`).
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest
* context will be used.
* @returns The query result, tracking which properties are read unless `notifyOnChangeProps` is
* set.
* @throws {Error} If `options` is not an object (outside production), or the query error when it should be
* thrown to the nearest error boundary (see `throwOnError`). While suspending, it throws a promise instead.
*/ function $cdfbc7d8781924f1$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $8UjFd.useIsRestoring)();
    const errorResetBoundary = (0, $hzoc8.useQueryErrorResetBoundary)();
    const client = (0, $7ClmI.useQueryClient)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $1rcdI.ensureSuspenseTimers)(defaultedOptions);
    (0, $4OZmE.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary, query);
    (0, $4OZmE.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $eF4cA.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $eF4cA.useSyncExternalStore($eF4cA.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $hnhg4.notifyManager).batchCalls(onStoreChange)) : (0, $3ur2P.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $eF4cA.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $1rcdI.shouldSuspend)(defaultedOptions, result)) throw (0, $1rcdI.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $4OZmE.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("8UjFd", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", () => $67c2ce82e7799ac8$export$4da0178d6b5f553);
$parcel$export(module.exports, "IsRestoringProvider", () => $67c2ce82e7799ac8$export$593807d4e94f9621);

var $eF4cA = parcelRequire("eF4cA");
"use client";
//#region src/IsRestoringProvider.ts
const $67c2ce82e7799ac8$var$IsRestoringContext = $eF4cA.createContext(false);
/**
* If you are using `PersistQueryClientProvider`, you can also use the `useIsRestoring` hook alongside it to
* check if a restore is currently in progress. `useQuery` and friends also check this internally to avoid
* race conditions between the restore and mounting queries.
* @returns `true` while a persisted client is being restored, `false` otherwise.
*/ const $67c2ce82e7799ac8$export$4da0178d6b5f553 = ()=>$eF4cA.useContext($67c2ce82e7799ac8$var$IsRestoringContext);
/**
* The Provider that `PersistQueryClientProvider` uses to signal whether a persisted client is currently
* being restored, read by `useIsRestoring`.
*/ const $67c2ce82e7799ac8$export$593807d4e94f9621 = $67c2ce82e7799ac8$var$IsRestoringContext.Provider;

});

parcelRegister("hzoc8", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", () => $cca87921f09012e1$export$50dfac555130cafd);

var $eF4cA = parcelRequire("eF4cA");

var $dx4lB = parcelRequire("dx4lB");
"use client";
//#region src/QueryErrorResetBoundary.tsx
/**
* Creates the value shared through the boundary's context, which tracks whether a reset was
* requested.
* @returns The `clearReset`, `isReset`, and `reset` functions of the boundary.
*/ function $cca87921f09012e1$var$createValue() {
    let isReset = false;
    return {
        /**
		* Clears the reset state, so queries know not to try again until the boundary is reset again.
		*/ clearReset: ()=>{
            isReset = false;
        },
        /**
		* Resets any query errors within the boundary, so queries know they can try again.
		*/ reset: ()=>{
            isReset = true;
        },
        /**
		* Returns whether the boundary has been reset and not yet cleared.
		* @returns `true` if the boundary has been reset and not yet cleared.
		*/ isReset: ()=>{
            return isReset;
        }
    };
}
const $cca87921f09012e1$var$QueryErrorResetBoundaryContext = $eF4cA.createContext($cca87921f09012e1$var$createValue());
/**
* This hook will reset any query errors within the closest `QueryErrorResetBoundary`. If there is no boundary
* defined it will reset them globally.
* @returns The boundary's {@link QueryErrorResetBoundaryValue}.
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { useQueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App({ children }: { children: React.ReactNode }) {
*   const { reset } = useQueryErrorResetBoundary()
*
*   return (
*     <ErrorBoundary
*       onReset={reset}
*       fallbackRender={({ resetErrorBoundary }) => (
*         <div>
*           There was an error!
*           <button onClick={() => resetErrorBoundary()}>Try again</button>
*         </div>
*       )}
*     >
*       {children}
*     </ErrorBoundary>
*   )
* }
* ```
*/ const $cca87921f09012e1$export$50dfac555130cafd = ()=>$eF4cA.useContext($cca87921f09012e1$var$QueryErrorResetBoundaryContext);
/**
* When using `suspense` or `throwOnError` in your queries, you need a way to let queries know that you want to
* try again when re-rendering after some error occurred. With the `QueryErrorResetBoundary` component you can
* reset any query errors within the boundaries of the component.
* @param props - The `children` to render.
* @returns The `children`, rendered as-is, or called with the boundary's {@link QueryErrorResetBoundaryValue}
* if `children` is a function.
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { QueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App() {
*   return (
*     <QueryErrorResetBoundary>
*       {({ reset }) => (
*         <ErrorBoundary
*           onReset={reset}
*           fallbackRender={({ resetErrorBoundary }) => (
*             <div>
*               There was an error!
*               <button onClick={() => resetErrorBoundary()}>Try again</button>
*             </div>
*           )}
*         >
*           <Page />
*         </ErrorBoundary>
*       )}
*     </QueryErrorResetBoundary>
*   )
* }
* ```
*/ const $cca87921f09012e1$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $eF4cA.useState(()=>$cca87921f09012e1$var$createValue());
    return /* @__PURE__ */ (0, $dx4lB.jsx)($cca87921f09012e1$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};

});

parcelRegister("4OZmE", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", () => $382b6e9caaca8331$export$ae8adb3de3d77633);
$parcel$export(module.exports, "useClearResetErrorBoundary", () => $382b6e9caaca8331$export$b2b17ca3a1fb0229);
$parcel$export(module.exports, "getHasError", () => $382b6e9caaca8331$export$1fbcf724762d607);

var $eF4cA = parcelRequire("eF4cA");

var $3ur2P = parcelRequire("3ur2P");
"use client";
//#region src/errorBoundaryUtils.ts
/**
* Turns off `retryOnMount` for a query that throws its errors (with `suspense` or `throwOnError`),
* unless the error boundary has been reset, so a remount doesn't retry the failed query before the
* user resets the boundary. Mutates the options.
* @param options - The defaulted query options to adjust.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
* @param query - The query, used to evaluate a `throwOnError` function against its error.
*/ const $382b6e9caaca8331$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = query?.state.status === "error" && typeof options.throwOnError === "function" ? (0, $3ur2P.shouldThrowError)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
/**
* Clears the reset state of the error boundary after the component mounts, so later errors are
* thrown to the boundary again.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
*/ const $382b6e9caaca8331$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $eF4cA.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
/**
* Checks whether the query error should be thrown to the nearest error boundary: the query errored
* and isn't fetching, the boundary hasn't been reset, and either `suspense` is enabled with no data
* or `throwOnError` says so.
* @param params - The observer `result`, the `errorResetBoundary`, the `throwOnError` option, the
* `query`, and the `suspense` option.
* @returns `true` if the error should be thrown.
*/ const $382b6e9caaca8331$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $3ur2P.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

});

parcelRegister("1rcdI", function(module, exports) {

$parcel$export(module.exports, "ensureSuspenseTimers", () => $10c1cab9f9ece44b$export$274d2a1db5a20c09);
$parcel$export(module.exports, "shouldSuspend", () => $10c1cab9f9ece44b$export$88d3586dfed64df9);
$parcel$export(module.exports, "fetchOptimistic", () => $10c1cab9f9ece44b$export$defdc11a9c9acfcf);
//#region src/suspense.ts
/**
* The default `throwOnError` of the suspense hooks: throws the error to the nearest error boundary
* only if the query has no data to show.
* @param _error - The error of the query. Unused.
* @param query - The query that errored.
* @returns `true` if the query has no data.
*/ const $10c1cab9f9ece44b$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
/**
* Raises `staleTime` and a numeric `gcTime` to at least 1000ms when `suspense` is enabled, so a
* component that remounts after suspending doesn't refetch right away or find the query garbage
* collected. A `'static'` `staleTime` is kept as is. Mutates the options.
* @param defaultedOptions - The defaulted query options to adjust.
*/ const $10c1cab9f9ece44b$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
/**
* Checks whether a query should suspend: `suspense` is enabled and the result is still `pending`.
* @param defaultedOptions - The defaulted query options, if any.
* @param result - The current result of the observer.
* @returns `true` if the component should suspend.
*/ const $10c1cab9f9ece44b$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
/**
* Fetches the query for a suspending component, without affecting the observer's own result. If
* the fetch fails, the reset state of the error boundary is cleared, so the error is thrown to it.
* @param defaultedOptions - The defaulted query options to fetch with.
* @param observer - The observer of the query.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
* @returns A promise that resolves once the fetch settles. It never rejects.
*/ const $10c1cab9f9ece44b$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

});


parcelRegister("hpFA5", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", () => $cad506962cbab14f$export$a06cf8c0066f0d4c);

var $1OpUA = parcelRequire("1OpUA");

var $3ur2P = parcelRequire("3ur2P");

var $lGmfb = parcelRequire("lGmfb");

var $jdy3Z = parcelRequire("jdy3Z");

var $h5e0l = parcelRequire("h5e0l");

var $hnhg4 = parcelRequire("hnhg4");

var $z9vcI = parcelRequire("z9vcI");
//#region src/queryObserver.ts
/**
* A `QueryObserver` watches a single query in the `QueryCache` and computes a
* `QueryObserverResult` from its state, recomputing and notifying subscribers
* whenever the underlying query (or the observer's options) changes. It is
* the primitive that framework adapters (e.g. `useQuery`) build their hooks
* on top of, but it can also be used directly to observe and switch between
* queries outside of any framework.
* @example
* ```ts
* const observer = new QueryObserver(queryClient, {
*   queryKey: ['posts'],
*   queryFn: fetchPosts,
* })
*
* const unsubscribe = observer.subscribe((result) => {
*   console.log(result.data)
* })
* ```
*/ var $cad506962cbab14f$export$a06cf8c0066f0d4c = class extends (0, $jdy3Z.Subscribable) {
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #selectError;
    #selectFn;
    #selectResult;
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    /**
	* Binds the methods of the result (`refetch`) to the observer, so they keep working when destructured
	* from it. Subclasses override it to bind their own result methods as well.
	*/ bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($cad506962cbab14f$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnReconnect` option) to refetch when the network
	* reconnects.
	* @returns `true` if the observer should refetch the query on reconnect.
	*/ shouldFetchOnReconnect() {
        return $cad506962cbab14f$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnWindowFocus` option) to refetch when the window
	* regains focus.
	* @returns `true` if the observer should refetch the query on window focus.
	*/ shouldFetchOnWindowFocus() {
        return $cad506962cbab14f$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    /**
	* Stops observing the current query: clears all listeners, cancels the
	* stale and refetch-interval timers, and removes this observer from the
	* query it was observing.
	*/ destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    /**
	* Updates the observer's options. This will re-resolve the query being
	* observed (switching to a different query if the `queryKey` changed),
	* trigger a fetch if the new options require one and the observer has
	* subscribers, recompute the current result, and reschedule the stale and
	* refetch-interval timers as needed.
	* @param options - The new observer options. They are defaulted with {@link
	* QueryClient#defaultQueryOptions} before being applied.
	* @throws {Error} If `enabled` is neither a boolean nor a function.
	* @example
	* ```ts
	* observer.setOptions({ queryKey: ['posts', 1], queryFn: () => fetchPost(1) })
	* // later: switch to a different query, reusing the same observer
	* observer.setOptions({ queryKey: ['posts', 2], queryFn: () => fetchPost(2) })
	* ```
	*/ setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $3ur2P.resolveQueryValue)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $3ur2P.shallowEqualObjects)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $cad506962cbab14f$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $3ur2P.resolveQueryValue)(this.options.enabled, this.#currentQuery) !== (0, $3ur2P.resolveQueryValue)(prevOptions.enabled, this.#currentQuery) || (0, $3ur2P.resolveQueryValue)(this.options.staleTime, this.#currentQuery) !== (0, $3ur2P.resolveQueryValue)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $3ur2P.resolveQueryValue)(this.options.enabled, this.#currentQuery) !== (0, $3ur2P.resolveQueryValue)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    /**
	* Computes the result the observer would produce for the given (already-defaulted) options
	* right now, building the underlying `Query` if it doesn't exist yet, without waiting for a
	* subscription callback. Called by framework adapters on every render (e.g. `useQuery`) so the
	* returned value is available synchronously, ahead of `setOptions` triggering an actual fetch.
	* @param options - The defaulted observer options to compute the result for.
	* @returns The result for the given options.
	*/ getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if (!(0, $3ur2P.shallowEqualObjects)(this.getCurrentResult(), result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    /**
	* Returns the most recently computed `QueryObserverResult` for the
	* observed query. This is a point-in-time read; to be notified of updates
	* as they happen, subscribe to the observer instead (its inherited
	* `subscribe` method).
	* @returns The observer's latest result.
	* @example
	* ```ts
	* const result = observer.getCurrentResult()
	* console.log(result.status, result.data)
	* ```
	*/ getCurrentResult() {
        return this.#currentResult;
    }
    /**
	* Wraps a `QueryObserverResult` in a `Proxy` that records which properties are read, via
	* {@link QueryObserver#trackProp} (and an optional `onPropTracked` callback). Used by framework
	* adapters when `notifyOnChangeProps` is not set, to implement its default "only re-render on
	* properties you actually read" behavior.
	* @param result - The result to wrap.
	* @param onPropTracked - Called with the name of each property that is read.
	* @returns A proxy of `result` that tracks property reads.
	*/ trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                return Reflect.get(target, key);
            }
        });
    }
    /**
	* Records that the given `QueryObserverResult` property was read, so a subsequent update only
	* notifies this observer if a tracked property actually changed. Normally called indirectly via
	* {@link QueryObserver#trackResult}'s proxy; exposed directly for adapters that track property
	* access themselves (e.g. through their own reactivity system) instead of via the proxy.
	* @param key - The name of the property that was read.
	*/ trackProp(key) {
        this.#trackedProps.add(key);
    }
    /**
	* Returns the `Query` instance this observer is currently observing.
	* @returns The observed query.
	*/ getCurrentQuery() {
        return this.#currentQuery;
    }
    /**
	* Refetches the observed query and returns a promise that resolves with
	* the resulting `QueryObserverResult`.
	* @param options - Set `cancelRefetch` to `false` to keep a running fetch instead of cancelling
	* it, and `throwOnError` to `true` to reject when the refetch fails.
	* @returns A promise that resolves with the result after the refetch.
	* @example
	* ```ts
	* const result = await observer.refetch({ cancelRefetch: false })
	* console.log(result.data)
	* ```
	*/ refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    /**
	* Fetches a query defined by the given options without affecting this
	* observer's own tracked query or result, and returns a promise that
	* resolves with the `QueryObserverResult` for that fetch. This is useful
	* for prefetching data that another observer (e.g. a query about to be
	* navigated to) will need, ahead of time.
	* @param options - The observer options of the query to fetch.
	* @returns A promise that resolves with the result for the fetched query.
	* @example
	* ```ts
	* const result = await observer.fetchOptimistic({
	*   queryKey: ['posts', 2],
	*   queryFn: () => fetchPost(2),
	* })
	* console.log(result.data)
	* ```
	*/ fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        let unsubscribe = ()=>{};
        let resolveEarly;
        const cachePromise = new Promise((resolve)=>{
            resolveEarly = resolve;
            unsubscribe = this.#client.getQueryCache().subscribe((event)=>{
                if (event.type === "updated" && event.query.queryHash === query.queryHash && query.state.data !== void 0) {
                    unsubscribe();
                    resolve(this.createResult(query, defaultedOptions));
                }
            });
        });
        return Promise.race([
            query.fetch(defaultedOptions).then(()=>{
                const result = this.createResult(query, defaultedOptions);
                resolveEarly?.(result);
                return result;
            }).finally(()=>{
                unsubscribe();
            }),
            cachePromise
        ]);
    }
    /**
	* Fetches the observed query and updates the result once the fetch settles. Used by `refetch` and,
	* in `InfiniteQueryObserver`, to fetch more pages.
	* @param fetchOptions - Options for this fetch. `cancelRefetch` defaults to `true`.
	* @returns A promise that resolves with the updated result.
	*/ fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $3ur2P.noop));
        return promise;
    }
    #shouldScheduleTimer(timeout) {
        return !(0, $lGmfb.isServer)() && (0, $3ur2P.resolveQueryValue)(this.options.enabled, this.#currentQuery) !== false && (0, $3ur2P.isValidTimeout)(timeout);
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $3ur2P.resolveQueryValue)(this.options.staleTime, this.#currentQuery);
        if (this.#currentResult.isStale || !this.#shouldScheduleTimer(staleTime)) return;
        const timeout = (0, $3ur2P.timeUntilStale)(this.#currentResult.dataUpdatedAt, staleTime) + 1;
        this.#staleTimeoutId = (0, $1OpUA.timeoutManager).setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (0, $3ur2P.resolveQueryValue)(this.options.refetchInterval, this.#currentQuery) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if (this.#currentRefetchInterval === 0 || !this.#shouldScheduleTimer(this.#currentRefetchInterval)) return;
        this.#refetchIntervalId = (0, $1OpUA.timeoutManager).setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $h5e0l.focusManager).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId !== void 0) {
            (0, $1OpUA.timeoutManager).clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId !== void 0) {
            (0, $1OpUA.timeoutManager).clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    /**
	* Computes the result for a query and options from the query's state, applying `select`,
	* `placeholderData`, and the derived flags. Subclasses override it to add their own fields.
	* @param query - The query to compute the result for.
	* @param options - The observer options to compute the result with.
	* @returns The computed result.
	*/ createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryInitialState = query !== prevQuery ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $cad506962cbab14f$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $cad506962cbab14f$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $z9vcI.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $3ur2P.replaceData)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, $3ur2P.replaceData)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        } else if (data === void 0) this.#selectError = null;
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
            isPlaceholderData = false;
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        return {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $cad506962cbab14f$var$isStale(query, options),
            refetch: this.refetch,
            isEnabled: (0, $3ur2P.resolveQueryValue)(options.enabled, query) !== false
        };
    }
    /**
	* Recomputes and stores the current result from the current query/options, notifying listeners
	* if it changed. Framework adapters call this right after subscribing to make sure no query
	* update was missed in the gap between creating the observer and subscribing to it.
	*/ updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $3ur2P.shallowEqualObjects)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                return this.#currentResult[typedKey] !== prevResult[typedKey] && includedProps.has(typedKey);
            });
        };
        const notifyListeners = shouldNotifyListeners();
        (0, $hnhg4.notifyManager).batch(()=>{
            if (notifyListeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    /**
	* Updates the observer's result when the observed query changes, and reschedules its timers if it
	* has listeners.
	* @internal
	*/ onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
};
/**
* Checks whether a query has no data yet and should do its initial load when an observer mounts.
* @param query - The query to check.
* @param options - The observer options.
* @returns `true` if the query is enabled, has no data, and isn't in an error state with
* `retryOnMount: false`.
*/ function $cad506962cbab14f$var$shouldLoadOnMount(query, options) {
    return (0, $3ur2P.resolveQueryValue)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $3ur2P.resolveQueryValue)(options.retryOnMount, query) === false);
}
/**
* Checks whether a query should fetch when an observer mounts: either for its initial load, or
* because it has data and `refetchOnMount` asks for a refetch.
* @param query - The query to check.
* @param options - The observer options.
* @returns `true` if the query should fetch on mount.
*/ function $cad506962cbab14f$var$shouldFetchOnMount(query, options) {
    return $cad506962cbab14f$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $cad506962cbab14f$var$shouldFetchOn(query, options, options.refetchOnMount);
}
/**
* Checks whether a query should fetch for a `refetchOnMount`, `refetchOnWindowFocus`, or
* `refetchOnReconnect` option.
* @param query - The query to check.
* @param options - The observer options.
* @param field - The value of the option to check.
* @returns `true` if the query is enabled, not static, and the option is `'always'`, or is not
* `false` and the query is stale.
*/ function $cad506962cbab14f$var$shouldFetchOn(query, options, field) {
    if ((0, $3ur2P.resolveQueryValue)(options.enabled, query) !== false && (0, $3ur2P.resolveQueryValue)(options.staleTime, query) !== "static") {
        const value = (0, $3ur2P.resolveQueryValue)(field, query);
        return value === "always" || value !== false && $cad506962cbab14f$var$isStale(query, options);
    }
    return false;
}
/**
* Checks whether a query should fetch after the observer's options change.
* @param query - The query observed with the new options.
* @param prevQuery - The query observed with the previous options.
* @param options - The new observer options.
* @param prevOptions - The previous observer options.
* @returns `true` if the query changed or was disabled before, it isn't a suspense query in an
* error state, and it is stale.
*/ function $cad506962cbab14f$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $3ur2P.resolveQueryValue)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $cad506962cbab14f$var$isStale(query, options);
}
/**
* Checks whether a query is stale for the given observer options.
* @param query - The query to check.
* @param options - The observer options, whose `enabled` and `staleTime` are used.
* @returns `true` if the query is enabled and its data is stale for `staleTime`.
*/ function $cad506962cbab14f$var$isStale(query, options) {
    return (0, $3ur2P.resolveQueryValue)(options.enabled, query) !== false && query.isStaleByTime((0, $3ur2P.resolveQueryValue)(options.staleTime, query));
}

});
parcelRegister("z9vcI", function(module, exports) {

$parcel$export(module.exports, "Query", () => $069aa3f4e5dcdbaf$export$62297b13309008b2);
$parcel$export(module.exports, "fetchState", () => $069aa3f4e5dcdbaf$export$f3df9013f2b58bce);

var $3ur2P = parcelRequire("3ur2P");

var $hnhg4 = parcelRequire("hnhg4");

var $k7O9T = parcelRequire("k7O9T");

var $2Vzad = parcelRequire("2Vzad");

var $edy1c = parcelRequire("edy1c");
//#region src/query.ts
/**
* Represents a single cached query. A `Query` holds the query's key, options,
* state (data/error/status), and the observers currently subscribed to it.
*
* Instances are created and managed internally by `QueryCache`; application
* code typically interacts with queries indirectly through `QueryClient` or
* a framework hook like `useQuery`. Direct access to a `Query` instance is
* possible via `queryCache.find()`/`findAll()` for inspecting cache state.
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
* const query = queryCache.find({ queryKey: ['posts'] })
*
* if (query) {
*   console.log(query.state.dataUpdatedAt)
* }
* ```
*/ var $069aa3f4e5dcdbaf$export$62297b13309008b2 = class extends (0, $2Vzad.Removable) {
    #queryType;
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $069aa3f4e5dcdbaf$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    /**
	* The `meta` object passed in the query's options, if any.
	* @returns The query's `meta`, or `undefined` if none was set.
	*/ get meta() {
        return this.options.meta;
    }
    /**
	* `'infinite'` for an infinite query, otherwise `undefined`.
	* @internal
	* @returns The type of the query, set from the `_type` option (e.g. `'infinite'`).
	*/ get queryType() {
        return this.#queryType;
    }
    /**
	* The promise for the currently in-flight fetch, if the query is fetching.
	* `undefined` when the query is not fetching.
	* @returns The promise of the in-flight fetch, or `undefined`.
	*/ get promise() {
        return this.#retryer?.promise;
    }
    /**
	* Replaces the query's options and applies their `gcTime`. If the query has no data yet, it gets
	* the `initialData` from the new options, if any.
	* @internal
	* @param options - The new query options, merged on top of the query's default options.
	*/ setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        if (options?._type) this.#queryType = options._type;
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $069aa3f4e5dcdbaf$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($069aa3f4e5dcdbaf$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    /**
	* Writes new data to the query and marks it as successfully fetched.
	* @internal
	* @param newData - The data to write. Structural sharing with the current data is applied.
	* @param options - Set `updatedAt` to override the timestamp, and `manual` to mark the write as
	* manual (e.g. from `queryClient.setQueryData`).
	* @returns The data that was written.
	*/ setData(newData, options) {
        const data = (0, $3ur2P.replaceData)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    /**
	* Merges the given partial state directly into this query's state, notifying observers. Used
	* by persistence and broadcast plugins to restore a state snapshot, and by devtools to let a
	* user manually trigger a loading/error state or edit the cached data.
	* @param state - The partial state to merge into the query's state.
	*/ setState(state) {
        this.#dispatch({
            type: "setState",
            state: state
        });
    }
    /**
	* Cancels the query's currently in-flight fetch, if any.
	* - Returns a promise that resolves once the cancellation has settled.
	* - If no fetch is in progress, resolves immediately.
	* @param options - Set `revert` to restore the state from before the fetch started, and `silent`
	* to suppress the cancellation error when a new fetch replaces the cancelled one.
	* @returns A promise that resolves once the cancellation has settled.
	* @example
	* ```ts
	* await query.cancel()
	* ```
	*/ cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $3ur2P.noop)).catch((0, $3ur2P.noop)) : Promise.resolve();
    }
    /**
	* Clears the query's garbage collection timeout and silently cancels any
	* in-flight fetch. Called by `QueryCache` when the query is removed from
	* the cache.
	* @see {@link Query#cancel}
	*/ destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    /**
	* The state the query was created with.
	* @internal
	* @returns The state the query had when it was first created, used by {@link Query#reset}.
	*/ get resetState() {
        return this.#initialState;
    }
    /**
	* Resets the query back to its initial state (the state it had when it was
	* first created, e.g. any `initialData`), destroying it first to cancel any
	* in-flight fetch.
	*/ reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    /**
	* Returns `true` if the query has at least one observer for which `enabled`
	* does not resolve to `false`.
	* @returns `true` if the query has an enabled observer.
	*/ isActive() {
        return this.observers.some((observer)=>(0, $3ur2P.resolveQueryValue)(observer.options.enabled, this) !== false);
    }
    /**
	* Returns `true` if the query is disabled, meaning it will not fetch
	* automatically.
	* - If the query has observers, it is disabled when none of them are active
	*   (see `isActive`).
	* - If the query has no observers, it is disabled when its `queryFn` is
	*   `skipToken` or it has never been fetched.
	* @returns `true` if the query is disabled.
	*/ isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $3ur2P.skipToken) || !this.isFetched();
    }
    /**
	* Returns `true` if the query has been fetched, i.e. it has resolved with
	* either data or an error at least once.
	* @returns `true` if the query has been fetched.
	*/ isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    /**
	* Returns `true` if the query has at least one observer configured with
	* `staleTime: 'static'`, meaning it is treated as never stale.
	* @returns `true` if the query is static.
	*/ isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $3ur2P.resolveQueryValue)(observer.options.staleTime, this) === "static");
        return false;
    }
    /**
	* Returns `true` if the query is stale.
	* - If the query has observers, defers to whether any observer's current
	*   result reports `isStale` (which accounts for each observer's own
	*   `staleTime` and `enabled` state).
	* - If the query has no observers, it is considered stale when it has no
	*   data or has been invalidated.
	* @returns `true` if the query is stale.
	* @see {@link Query#isStaleByTime}
	* @example
	* ```ts
	* if (query.isStale()) {
	*   // refetch or otherwise treat the cached data as outdated
	* }
	* ```
	*/ isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    /**
	* Returns `true` if the query's data is stale relative to the given
	* `staleTime` (defaults to `0`).
	* - A query with no data is always stale.
	* - `staleTime: 'static'` is never stale.
	* - An invalidated query is always stale.
	* - Otherwise, staleness is based on elapsed time since `dataUpdatedAt`.
	* @param staleTime - The time, in milliseconds, after which data is considered stale, or
	* `'static'` to never treat existing data as stale. A query without data is stale either way.
	* @returns `true` if the query's data is stale.
	* @see {@link Query#isStale}
	* @example
	* ```ts
	* const isStale = query.isStaleByTime(60 * 1000)
	* ```
	*/ isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $3ur2P.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    /**
	* Refetches the query when the window regains focus, if an observer wants that, and continues a
	* paused fetch.
	* @internal
	*/ onFocus() {
        this.observers.find((x)=>x.shouldFetchOnWindowFocus())?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    /**
	* Refetches the query when the app reconnects, if an observer wants that, and continues a paused
	* fetch.
	* @internal
	*/ onOnline() {
        this.observers.find((x)=>x.shouldFetchOnReconnect())?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    /**
	* Subscribes an observer to the query and stops its garbage collection.
	* @internal
	* @param observer - The observer to add. Adding an observer that is already subscribed does
	* nothing.
	*/ addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Unsubscribes an observer from the query.
	* @internal
	* @param observer - The observer to remove. When the last observer is removed, the in-flight
	* fetch is cancelled if its abort signal was consumed (otherwise only its retries are stopped),
	* and garbage collection is scheduled.
	*/ removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed || this.state.fetchStatus === "paused" && this.state.status === "pending") this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Returns the number of observers currently subscribed to this query.
	* @returns The number of observers.
	* @example
	* ```ts
	* if (query.getObserversCount() === 0) {
	*   // no component is currently watching this query
	* }
	* ```
	*/ getObserversCount() {
        return this.observers.length;
    }
    /**
	* Marks the query as invalidated, unless it is already invalidated. This
	* updates `state.isInvalidated` and notifies observers, but does not by
	* itself trigger a refetch.
	* @example
	* ```ts
	* query.invalidate()
	* ```
	*/ invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    /**
	* Fetches the query, i.e. runs its `queryFn` (through any configured
	* retryer/behavior) and updates the query's state with the result.
	* - If a fetch is already in flight, returns its promise instead of
	*   starting a new one, unless `fetchOptions.cancelRefetch` is set and the
	*   query already has data, in which case the current fetch is silently
	*   cancelled first.
	* - If `options` is passed, it replaces the query's current options
	*   before fetching.
	* @param options - Query options that replace the query's current options before fetching. They
	* are not applied when an in-flight fetch is reused.
	* @param fetchOptions - Set `cancelRefetch` to cancel an in-flight fetch first (only if the query
	* already has data), and `meta` to pass extra information to the query's behavior.
	* @returns A promise that resolves with the fetched data, or rejects with the fetch error. If the
	* fetch is cancelled with `revert` while the query has data, it resolves with the restored data
	* instead.
	*/ async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $3ur2P.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext);
                return queryFnContext;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context);
            return context;
        };
        const context = createFetchContext();
        (this.#queryType === "infinite" ? (0, $edy1c.infiniteQueryBehavior)(this.options.pages) : this.options.behavior)?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const retryer = this.#retryer = (0, $k7O9T.createRetryer)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $k7O9T.CancelledError) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $k7O9T.CancelledError)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            if (this.#retryer === retryer) this.#retryer = void 0;
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$069aa3f4e5dcdbaf$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        ...$069aa3f4e5dcdbaf$var$successState(action.data, action.dataUpdatedAt),
                        dataUpdateCount: state.dataUpdateCount + 1,
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error",
                        isInvalidated: true
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $hnhg4.notifyManager).batch(()=>{
            this.observers.slice().forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
/**
* Returns the state changes applied when a query starts fetching.
* @param data - The query's current data. If it is `undefined`, the query is also reset to
* `'pending'` with no error.
* @param options - The query options, whose `networkMode` decides whether the query is `'fetching'`
* or `'paused'`.
* @returns The partial query state for a starting fetch.
*/ function $069aa3f4e5dcdbaf$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $k7O9T.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
/**
* Returns the state changes applied when a query receives data.
* @param data - The new data.
* @param dataUpdatedAt - The timestamp the data is recorded with. Defaults to the current time.
* @returns The partial query state for a successful update.
*/ function $069aa3f4e5dcdbaf$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
/**
* Returns the initial state of a query, based on its `initialData` and `initialDataUpdatedAt`
* options.
* @param options - The query options.
* @returns The initial query state: `'success'` if `initialData` is set, otherwise `'pending'`.
*/ function $069aa3f4e5dcdbaf$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("edy1c", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", () => $a59caaea4ca3d017$export$84470d1367601e8d);
$parcel$export(module.exports, "hasNextPage", () => $a59caaea4ca3d017$export$b9c88add8b8b5e6a);
$parcel$export(module.exports, "hasPreviousPage", () => $a59caaea4ca3d017$export$db1663b730a8e6e4);

var $3ur2P = parcelRequire("3ur2P");
//#region src/infiniteQueryBehavior.ts
/**
* Creates the behavior that fetches the pages of an infinite query: the next or previous page for
* `fetchNextPage`/`fetchPreviousPage`, or all pages again from the start on a refetch.
* @param pages - The number of pages to fetch from the start when all pages are fetched again,
* e.g. from the `pages` option of `queryClient.infiniteQuery`. Defaults to the number of cached
* pages.
* @returns The query behavior to set on an infinite query.
*/ function $a59caaea4ca3d017$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $3ur2P.addConsumeAwareSignal)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $3ur2P.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext);
                        return queryFnContext;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $3ur2P.addToStart) : (0, $3ur2P.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $a59caaea4ca3d017$var$getPreviousPageParam : $a59caaea4ca3d017$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    result = await fetchPage(oldData, pageParamFn(options, oldData), previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] === void 0 ? options.initialPageParam : oldPageParams[0] : $a59caaea4ca3d017$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
/**
* Computes the page param of the page after the last one, with the `getNextPageParam` option.
* @param options - The infinite query options.
* @param data - The current pages and page params.
* @returns The next page param, or `undefined` if there are no pages yet.
*/ function $a59caaea4ca3d017$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
/**
* Computes the page param of the page before the first one, with the `getPreviousPageParam`
* option.
* @param options - The infinite query options.
* @param data - The current pages and page params.
* @returns The previous page param, or `undefined` if there are no pages yet or no
* `getPreviousPageParam` option.
*/ function $a59caaea4ca3d017$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
/**
* Checks if there is a next page.
* @param options - The infinite query options with `getNextPageParam`.
* @param data - The current pages and page params.
* @returns `true` if `getNextPageParam` returns a value other than `null` or `undefined`.
*/ function $a59caaea4ca3d017$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $a59caaea4ca3d017$var$getNextPageParam(options, data) != null;
}
/**
* Checks if there is a previous page.
* @param options - The infinite query options with `getPreviousPageParam`.
* @param data - The current pages and page params.
* @returns `true` if `getPreviousPageParam` is set and returns a value other than `null` or
* `undefined`.
*/ function $a59caaea4ca3d017$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $a59caaea4ca3d017$var$getPreviousPageParam(options, data) != null;
}

});




parcelRegister("4SSyx", function(module, exports) {

$parcel$export(module.exports, "useGeneratePersonas", () => $38e6864152917eb4$export$d75965bc9349b0c0);
$parcel$export(module.exports, "useGenerateVisuals", () => $38e6864152917eb4$export$cfa582f6a241bcca);
$parcel$export(module.exports, "getZoltarResponse", () => $38e6864152917eb4$export$9b56a64af673894a);
$parcel$export(module.exports, "useSystemPrompts", () => $38e6864152917eb4$export$2a096b870495543a);
$parcel$export(module.exports, "useZoltarMutation", () => $38e6864152917eb4$export$31aade23daa61a53);
$parcel$export(module.exports, "useImageLabeling", () => $38e6864152917eb4$export$7b027e2b8b975ae4);

var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");
var $7ClmI = parcelRequire("7ClmI");

var $g0I9D = parcelRequire("g0I9D");

var $dqZbZ = parcelRequire("dqZbZ");

var $aKSBi = parcelRequire("aKSBi");

var $AkKc4 = parcelRequire("AkKc4");

var $dYPl9 = parcelRequire("dYPl9");

var $fmJ8d = parcelRequire("fmJ8d");

var $8Ogg5 = parcelRequire("8Ogg5");

var $VXM1R = parcelRequire("VXM1R");
const $38e6864152917eb4$export$3edf33279328180a = {
    all: [
        "zoltar"
    ],
    queries: ()=>[
            ...$38e6864152917eb4$export$3edf33279328180a.all,
            "query"
        ],
    query: (key)=>[
            ...$38e6864152917eb4$export$3edf33279328180a.queries(),
            ...Array.isArray(key) ? key : [
                key
            ]
        ],
    images: ()=>[
            ...$38e6864152917eb4$export$3edf33279328180a.all,
            "images"
        ],
    image: (key)=>[
            ...$38e6864152917eb4$export$3edf33279328180a.images(),
            ...Array.isArray(key) ? key : [
                key
            ]
        ]
};
// How many times a pending agent response is re-requested before giving up.
const $38e6864152917eb4$var$ZOLTAR_MAX_POLL_ATTEMPTS = 30;
const $38e6864152917eb4$var$ZOLTAR_POLL_INTERVAL_MS = 2000;
// Poll state (thread id + poll input) of a running mutation, keyed by the
// variables object react-query hands to every retry of that same mutation.
const $38e6864152917eb4$var$zoltarPollState = new WeakMap();
const $38e6864152917eb4$export$fbf7848cbe0580f2 = (response, id)=>{
    const story = (0, $aKSBi.parseZoltarGenerateAssistantJson)(response, "Failed to generate story");
    story.id = id ?? self.crypto.randomUUID();
    // extend story script with dividers
    const sections = [
        ...new Set(story.script.slice(2, -1).map(({ section: section })=>section))
    ];
    console.log("parseStoryPromptResponse sections:", sections);
    sections.forEach((section)=>{
        const sectionIndex = story.script.findIndex((step)=>step.section === section);
        if (sectionIndex !== -1) story.script.splice(sectionIndex, 0, {
            section: section,
            title: section,
            text: "",
            personas: [],
            solutions: [],
            visual: "",
            visualMessaging: "",
            comments: "Section divider"
        });
    });
    story.personas = (0, $g0I9D.produce)(story.personas, (draft)=>{
        draft.forEach((persona, idx)=>{
            persona.id = idx;
        });
    });
    story.script = (0, $g0I9D.produce)(story.script, (draft)=>{
        draft.forEach((step, idx)=>{
            step.id = idx;
            if (step?.personas) step.personas = step.personas.map((name)=>story.personas.findIndex((persona)=>persona.name === name));
        });
    });
    console.log("parseStoryPromptResponse story:", story);
    return story;
};
const $38e6864152917eb4$export$6d3dfc08bc7630d2 = ()=>{
    // const queryClient = useQueryClient();
    const navigate = (0, $dqZbZ.useNavigate)();
    const createStory = (0, $VXM1R.useCreateStory)();
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async ()=>{
            const ims = (0, $fmJ8d.store).getState().ims;
            const { data: data, storyPrompt: prompt, storyPromptTemplate: promptTemplate } = (0, $fmJ8d.store).getState().wizard;
            if (!ims || !data || !promptTemplate) throw new Error("Missing required data to generate story");
            const promptStoryResponse = await (0, $aKSBi.generateContent)({
                user: ims.profile.email,
                data: data,
                prompt_template: [
                    {
                        prompt_template: "{{sources}}",
                        role: "system"
                    },
                    {
                        prompt_template: `You are the digital marketing expert specializing in ${data.industry} industry.`,
                        role: "system"
                    },
                    {
                        prompt_template: promptTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: "{{#if (isEqual response_format 'json_object')}}You are an assistant designed to output JSON.{{/if}}{{~#if metadata}}{{#unless metadata.formattingOptions.renderMarkdown}}The answer should be in plain text without markdown or formatting.{{/unless}}{{/if}}",
                        role: "system"
                    }
                ]
            }, "Failed to generate story");
            const story = $38e6864152917eb4$export$fbf7848cbe0580f2(promptStoryResponse);
            return {
                ...story,
                data: data,
                prompt: prompt,
                promptTemplate: promptTemplate
            };
        },
        onMutate: async (variables)=>{},
        onSuccess: async (data, variables)=>{
            // save the story in db
            await createStory.mutateAsync(data);
            (0, $fmJ8d.store).getState().resetWizard();
            navigate(`/stories/${data.id}`);
        },
        onError: (error, variables)=>{
            console.error("Error generating story:", error);
        }
    });
    return mutation;
};
const $38e6864152917eb4$export$d75965bc9349b0c0 = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async ()=>{
            const ims = (0, $fmJ8d.store).getState().ims;
            const story = queryClient.getQueryData((0, $VXM1R.storyKey).detail(storyId));
            if (!ims || !story?.industry) throw new Error("Missing required data to generate personas");
            (0, $fmJ8d.store).getState().addToast(`Generating personas details`, {
                variant: "info",
                timeout: -1
            });
            const personas = await (0, $8Ogg5.importAllPersonas)();
            const personasPromptTemplate = `Here are 2 documents: a customer journey story script in JSON format from ${story.industry} industry and a personas list in JSON format.

In the story script there's array "personas". For each persona write a prompt that will be used to describe the persona to generate their image \u{2013} "descriptionPrompt". Include details of a person's appearance, ethnicity, characteristics, and detailed description of clothing.

Next, write a prompt that will be used to generate a profile portrait for this persona \u{2013} "avatarPrompt". Portrait should be positioned in the center of the frame with a face in a front view. Include "descriptionPrompt" in this prompt. At the end of the prompt add "Neutral background. Professional photography style."

Next, for each persona in the story, match them with one of the existing personas from the personas list using the "descriptionPrompt" that you've just generated.

Consider the following matching criteria:
1. Gender compatibility (if story says it's female, find female persona, if story says it's male, find male persona)
2. Age range similarity (if story says it's 30-40 years old, find persona in the 30-40 age range)
3. Role/profession alignment (if story says it's a customer, find a persona with "Customer" role)
4. Description characteristics that match the descriptionPrompt (if story says it's a customer, find a persona with "Customer" role)

For each match, use the "id" from the personas list as "libraryId" and the "avatarId" from the personas list as "avatarId" for the story persona. Take the "id" and "avatarId" exactly as they are in the personas list, do not make them up nor change them.

Take into consideration context of all the data in the provided script. Adjust the prompts to represent specified "industry" as well as to be aligned with the whole story script.

Don't use personas names in the prompts, but rather use their gender.`;
            const promptPersonasResponse = await (0, $aKSBi.generateContent)({
                user: ims.profile.email,
                data: {},
                prompt_template: [
                    {
                        prompt_template: JSON.stringify(story),
                        role: "system"
                    },
                    {
                        prompt_template: JSON.stringify(personas),
                        role: "system"
                    },
                    {
                        prompt_template: "You are a prompt engineering expert specializing in image prompting.",
                        role: "system"
                    },
                    {
                        prompt_template: personasPromptTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: "You are an assistant designed to output JSON. Please make sure to output JSON only.",
                        role: "system"
                    }
                ]
            }, "Failed to fetch personas prompt");
            console.log("promptPersonasResponse:", promptPersonasResponse);
            // Parse the response
            const personasContext = (0, $aKSBi.readZoltarGenerateJsonWithFallback)(promptPersonasResponse, '{"personas": []}', "Failed to fetch personas prompt")?.personas || [];
            console.log({
                personasContext: personasContext
            });
            return {
                personasContext: personasContext
            };
        },
        onSuccess: ({ personasContext: personasContext })=>{
            // Update the story with the generated persona details immediately
            // This makes persona data visible in the UI right away
            // Note: The actual save to server happens later in useGenerateImages
            queryClient.setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                    personasContext.forEach((persona, idx)=>{
                        if (state.personas[persona?.id ?? idx]) {
                            state.personas[persona?.id ?? idx].avatarPrompt = persona.avatarPrompt;
                            state.personas[persona?.id ?? idx].descriptionPrompt = persona.descriptionPrompt;
                            state.personas[persona?.id ?? idx].libraryId = persona.libraryId;
                            state.personas[persona?.id ?? idx].avatarId = persona.avatarId;
                        }
                    });
                }));
            (0, $fmJ8d.store).getState().addToast("Personas details generated successfully", {
                variant: "positive",
                timeout: 5000
            });
        },
        onError: (error)=>{
            console.error("Error generating personas:", error);
            (0, $fmJ8d.store).getState().addToast("Failed to generate personas details", {
                variant: "negative",
                timeout: 10000,
                actionLabel: "Try again",
                shouldCloseOnAction: true,
                onAction: ()=>{
                    mutation.mutate();
                }
            });
        }
    });
    return mutation;
};
const $38e6864152917eb4$export$97923591eb7217c = (storyId)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async ()=>{
            const ims = (0, $fmJ8d.store).getState().ims;
            return Promise.allSettled(story?.personas?.map((persona)=>{
                (0, $AkKc4.fetchPersonaImages)(storyId, persona, ims);
            }));
        },
        onMutate: async ()=>{
            await queryClient.cancelQueries({
                queryKey: (0, $VXM1R.storyKey).details(storyId)
            });
        },
        onSuccess: (data)=>{
            data.forEach((personaImages, idx)=>{
                queryClient.setQueryData((0, $VXM1R.storyKey).details(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                        state.personas[idx].avatarUrl = personaImages[0]?.[0]?.url;
                        state.personas[idx].avatarSeed = personaImages[0]?.[0]?.seed;
                        state.personas[idx].avatarPath = personaImages[0]?.[0]?.path;
                    }));
            });
        },
        onError: (error)=>{
            console.error("Error generating personas images:", error);
            (0, $fmJ8d.store).getState().addToast(`Failed to generate personas images`, {
                variant: "negative",
                timeout: -1,
                actionLabel: "Try again",
                shouldCloseOnAction: true,
                onAction: ()=>{
                    mutation.mutate();
                }
            });
        }
    });
    return mutation;
};
const $38e6864152917eb4$export$cfa582f6a241bcca = (storyId, stepId = null)=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async ()=>{
            const ims = (0, $fmJ8d.store).getState().ims;
            const story = queryClient.getQueryData((0, $VXM1R.storyKey).detail(storyId));
            if (!ims || !ims.profile) throw new Error("IMS is not initialized. Please ensure you are authenticated.");
            if (!story?.industry) throw new Error("Missing required data to generate visuals");
            const { prompt_template: prompt_template, totalSteps: totalSteps, personas: personas, script: script } = await $38e6864152917eb4$var$preparePromptTemplate(story, stepId);
            const imageReferenceId = story.imageReference ? await $38e6864152917eb4$var$uploadImageReference(story.imageReference) : null;
            const parseResponsePromises = [];
            const currentGenerationRef = {
                current: 0
            };
            for await (const visualsContext of $38e6864152917eb4$var$generateVisualsRecursive(ims, prompt_template, totalSteps, {
                steps: []
            }, 10)){
                console.log("Visuals context:", visualsContext);
                parseResponsePromises.push($38e6864152917eb4$var$parseFetchVisualsResponse(queryClient, storyId, visualsContext, personas, imageReferenceId, totalSteps, currentGenerationRef));
            }
            await Promise.all(parseResponsePromises);
            return {
                success: true,
                totalSteps: totalSteps,
                currentGeneration: currentGenerationRef.current
            };
        },
        onSuccess: ({ totalSteps: totalSteps, currentGeneration: currentGeneration })=>{
            //const successCount = currentGeneration;
            // Full success - all images generated
            (0, $fmJ8d.store).getState().addToast("Image generation completed successfully", {
                variant: "positive",
                timeout: 60000,
                actionLabel: "Create Presentation",
                onAction: ()=>{
                    (0, $fmJ8d.store).setState({
                        isExpressDialogOpen: true
                    });
                }
            });
        },
        onError: (error)=>{
            console.error("Error generating visuals:", error);
            if (!stepId) (0, $fmJ8d.store).getState().addToast("Failed to generate story images", {
                variant: "negative",
                timeout: -1,
                actionLabel: "Try again",
                shouldCloseOnAction: true,
                onAction: ()=>{
                    mutation.mutate();
                }
            });
        }
    });
    return mutation;
};
const $38e6864152917eb4$export$9b56a64af673894a = async ({ promptTemplate: promptTemplate, systemPromptId: systemPromptId, promptOverrideKey: promptOverrideKey, useAgent: useAgent = true, model: model, schema: schema, skills: skills, threadId: threadId, userInput: userInput } = {}, { signal: signal } = {})=>{
    const ims = (0, $fmJ8d.store).getState().ims;
    if (!ims || !promptTemplate && !systemPromptId) throw new Error("Missing required data to generate data");
    const response = await (0, $aKSBi.generateContent)({
        useAgent: useAgent,
        user: ims.profile.email,
        prompt_template: promptTemplate,
        systemPromptId: systemPromptId,
        promptOverrideKey: promptOverrideKey,
        question: "",
        model: model,
        schema: schema,
        skills: skills,
        thread_id: threadId,
        user_input: userInput
    }, "Failed to generate content", {
        signal: signal
    });
    if (useAgent) {
        if (!response?.ok) throw new Error("Failed to generate content", {
            cause: response
        });
        return response;
    }
    const choice = response?.chat?.choices?.[0];
    const finishReason = choice?.finishReason;
    if (finishReason !== "stop") // TODO: handle LLM error response
    throw new Error("Failed to generate content", {
        cause: response
    });
    return {
        ok: true,
        response: choice?.message?.content ?? "",
        messages: (response?.message_history_window ?? []).map((m)=>({
                id: [
                    "langchain_core",
                    "messages",
                    m.role === "user" ? "HumanMessage" : "SystemMessage"
                ],
                kwargs: {
                    content: m.content
                }
            }))
    };
};
const $38e6864152917eb4$export$2a096b870495543a = (options = {})=>(0, $4kcQz.useQuery)({
        queryKey: [
            "zoltar",
            "prompts"
        ],
        queryFn: ({ signal: signal })=>(0, $aKSBi.listSystemPrompts)({
                signal: signal
            }),
        staleTime: 60000,
        ...options
    });
const $38e6864152917eb4$export$31aade23daa61a53 = (options = {}, parseDataFn)=>{
    const { retry: retry, retryDelay: retryDelay, onSettled: onSettled, ...restOptions } = options;
    return (0, $k6waQ.useMutation)({
        mutationFn: async (variables, context)=>{
            const { promptTemplate: promptTemplate, systemPromptId: systemPromptId, promptOverrideKey: promptOverrideKey, useAgent: useAgent = true, model: model, schema: schema, skills: skills, threadId: threadId, userInput: userInput } = variables;
            const { signal: signal } = context;
            let pollState = $38e6864152917eb4$var$zoltarPollState.get(variables);
            if (!pollState) {
                pollState = {
                    threadId: threadId ?? self.crypto.randomUUID()
                };
                $38e6864152917eb4$var$zoltarPollState.set(variables, pollState);
            }
            try {
                const response = await $38e6864152917eb4$export$9b56a64af673894a({
                    promptTemplate: promptTemplate,
                    systemPromptId: systemPromptId,
                    promptOverrideKey: promptOverrideKey,
                    useAgent: useAgent,
                    model: model,
                    schema: schema,
                    skills: skills,
                    threadId: pollState.threadId,
                    userInput: pollState.userInput ?? userInput
                }, {
                    signal: signal
                });
                console.log("useZoltarMutation response:", response);
                if (typeof parseDataFn === "function") return parseDataFn?.(response, context);
                return response;
            } catch (error) {
                if ((0, $aKSBi.isZoltarResponseNotReadyError)(error)) // The agent is still working on the same thread, so the retry below
                // only asks for the result instead of repeating the prompt.
                pollState.userInput = (0, $aKSBi.ZOLTAR_POLL_USER_INPUT);
                throw error;
            }
        },
        retry: retry ?? ((failureCount, error)=>(0, $aKSBi.isZoltarResponseNotReadyError)(error) && failureCount < $38e6864152917eb4$var$ZOLTAR_MAX_POLL_ATTEMPTS),
        retryDelay: retryDelay ?? $38e6864152917eb4$var$ZOLTAR_POLL_INTERVAL_MS,
        onSettled: (data, error, variables, onMutateResult, context)=>{
            $38e6864152917eb4$var$zoltarPollState.delete(variables);
            return onSettled?.(data, error, variables, onMutateResult, context);
        },
        ...restOptions
    });
};
const $38e6864152917eb4$export$af88d7ae4bade1c3 = async ({ promptTemplate: promptTemplate, systemPromptId: systemPromptId, imageUrl: imageUrl, userInput: userInput }, { signal: signal } = {})=>{
    const response = await (0, $aKSBi.imageLabeling)({
        imageUrl: imageUrl,
        prompt_template: promptTemplate,
        systemPromptId: systemPromptId,
        userInput: userInput
    }, {
        signal: signal
    });
    console.log("useLabelImage response data:", response);
    const raw = response?.data?.tags?.[0]?.replace(/^```json/, "").replace(/```$/, "").trim();
    // The service answers `tags: [""]` when the model reply was empty.
    if (!raw) throw new Error("Image labeling returned an empty response.", {
        cause: response
    });
    return JSON.parse(raw);
};
const $38e6864152917eb4$export$7b027e2b8b975ae4 = (options = {}, parseDataFn)=>{
    return (0, $k6waQ.useMutation)({
        // queryKey: zoltarKey.image(key),
        mutationFn: async (variables, { signal: signal })=>{
            const data = await $38e6864152917eb4$export$af88d7ae4bade1c3(variables, {
                signal: signal
            });
            return typeof parseDataFn === "function" ? parseDataFn(data, variables, {
                signal: signal
            }) : data;
        },
        // enabled: !!variables.imageUrl && !!variables.promptTemplate,
        // staleTime: 24 * 60 * 60 * 1000, // 24 hours
        // gcTime: 24 * 60 * 60 * 1000, // 24 hours
        meta: {
            errorMessage: "Failed to describe the image. Please try again."
        },
        ...options
    });
};
const $38e6864152917eb4$var$preparePromptTemplate = async (story, stepId)=>{
    const selectedStep = story.script?.find((s)=>s.id === stepId);
    if (stepId && !selectedStep) throw new Error(`No step found with id: ${stepId}`);
    // Only fetch for personas with libraryId and that are mentioned in the script
    const libraries = [];
    let personas = story.personas.filter((persona)=>persona.libraryId).filter((persona)=>story.script.some((step)=>step.personas?.includes(persona.id)));
    console.log("fetchPersonasLibraries:", personas.map((persona)=>persona.name));
    // Use Promise.all to properly handle async operations
    await Promise.all(personas.map(async (persona)=>{
        try {
            const images = await (0, $dYPl9.getElements)({
                libraryId: persona.libraryId,
                tags: []
            });
            libraries.push({
                name: persona.name,
                libraryId: persona.libraryId,
                images: images?.elements?.map((image)=>({
                        id: image.thumbnail?.componentId,
                        name: image.name,
                        description: image.details?.description
                    }))
            });
        } catch (error) {
            console.warn(`Failed to fetch elements for persona ${persona.name}:`, error);
        // Continue with other personas even if one fails
        }
    }));
    const extendedScript = (0, $g0I9D.produce)(story.script, (draft)=>{
        draft.forEach((step, sdx)=>{
            step?.personas?.forEach((persona, pdx)=>{
                const { name: name, descriptionPrompt: descriptionPrompt, libraryId: libraryId, avatarId: avatarId } = story.personas.find((p)=>p.id === persona) || {};
                if (!name || !descriptionPrompt) console.warn(`No persona details found for id: ${persona}`);
                else draft[sdx].personas[pdx] = {
                    name: name,
                    descriptionPrompt: descriptionPrompt,
                    libraryId: libraryId,
                    avatarId: avatarId
                };
            });
        });
    });
    const introductionTemplate = `Here are 2 documents: a customer journey story script as a JSON formatted array and a personas library as a JSON formatted array.

  The story is set in the ${story.industry} industry for the company called ${story.customer}.

  Title:
  ${story.title}

  Overview:
  ${story.storyOverview}

  Business goals:
  ${story.businessGoals}${!!story.campaignFocus ? `

  Campaign focus: ${story.campaignFocus}` : ""}`;
    const visualsPromptTemplate = `${selectedStep ? `For the step with an *id* ${selectedStep.id} and the *title* "${selectedStep.title}` : `For each item`} in the script write a prompt that will be used to generate a image visualizing this step \u{2013} "visualPrompt".
  Using context of a step, describe in details the location in which it takes place.
  Suggest a generic background photo that would fit the context of the step. In this case, use a generic description of the location or setting which will represent the ${story.industry} industry. Don't include any people, logos, icons, or text messages in the prompt. Don't mention any companies.
  At the end of the prompt add "Professional photography style."

  Next, write a prompt that will be used to generate a visual for the step including specified personas \u{2013} "personasPrompt". If there are specific personas mentioned in the "personas" field, include them in the scenario and use their "descriptionPrompt" to describe their appearance. Make sure to include all the details from "descriptionPrompt" field. Don't use personas names, but rather use their gender.
  At the end of the prompt add "Professional photography style."

  Take into consideration context of all the data in the provided script to with a cohesive narrative. Adjust prompts to represent specified "industry" as well as to be aligned with the whole story.
  If any prompt mentions a device, like a phone or a computer, describe it as "with the screen turned off" to avoid generating anything on the screen.

  Make sure to generate prompts for each item in the script.`;
    const personasPromptTemplate = `${selectedStep ? `For the step with an *id* ${selectedStep.id} and the *title* "${selectedStep.title}` : `For each item`} in the script find the best matching image from the provided personas library.

  1. For each persona mentioned in the step's "personas" field:
     - Find the matching persona in personas library by comparing the persona's "libraryId" field
     - Each persona item consists of "name", "libraryId", "images" fields.
     - Look through that persona's "images" array to find the best matching image.
     - Do not assume that the first image is the best match, but rather find the best match based on the scoring criteria.
     - Do not alter the original image's "id" or "name" fields. Take them exactly as they are in the library.

  2. When selecting the best image, consider:
     - The step's context and title
     - The persona's description and role in the step
     - The generated visualPrompt and personasPrompt
     - The image's "description" and "tags" fields
     - How well the image fits the step's setting and action (the image shouldn't be a generic setting, but rather a specific setting that matches the step's context)

  3. Scoring criteria for image selection:
     - Relevance to step context (highest priority)
     - Match with persona's role and description (if the persona is a customer, the image should be a customer setting)
     - Appropriate setting/environment (the image should be a specific setting that matches the step's context)
     - Professional appearance (the image should be a professional appearance)
     - Industry-appropriate attire and setting (the image should be an industry-appropriate attire and setting)

  4. For the selected image, save:
     - "libraryId": The persona's library ID
     - "visualId": The selected image's "id" field
     - "visualName": The selected image's "name" field

  IMPORTANT: Verify that the selected "visualId" exists in the same image object within the "images" array of the persona with the selected "libraryId".
  If they do not match the same image object, start over and find the correct matching image. If no personas are mentioned in the step, or if no suitable images are found, set both "libraryId" and "visualId" to null.
  `;
    const prompt_template = [
        {
            prompt_template: JSON.stringify(extendedScript),
            role: "system"
        },
        {
            prompt_template: JSON.stringify(libraries),
            role: "system"
        },
        {
            prompt_template: introductionTemplate,
            role: "user"
        },
        {
            prompt_template: "You are a prompt engineering expert specializing in image prompting.",
            role: "system"
        },
        {
            prompt_template: visualsPromptTemplate,
            role: "user"
        },
        {
            prompt_template: personasPromptTemplate,
            role: "user"
        },
        {
            prompt_template: `The output should contain a JSON formatted array of steps, where each step is an object with the following fields:
              steps:
                *idx* \u{2013} The 0-based index of the step in the story script
                *title* \u{2013} The title of the step
                *visualPrompt*
                *personasPrompt*
                *libraryId* \u{2013} The library ID of the selected image (or null if none selected)
                *visualId* \u{2013} The ID of the selected image (or null if none selected),
                *visualName* \u{2013} The name of the selected image (or null if none selected)`,
            role: "user"
        },
        {
            prompt_template: "You are an assistant designed to output JSON. Please make sure to output JSON only.",
            role: "system"
        }
    ];
    return {
        prompt_template: prompt_template,
        totalSteps: stepId ? 1 : extendedScript.length,
        personas: libraries,
        script: extendedScript
    };
};
const $38e6864152917eb4$var$parseFetchVisualsResponse = async (queryClient, storyId, visualsContext, personas, imageReferenceId, totalSteps, currentGenerationRef)=>{
    try {
        // Check IMS is initialized before making API calls
        const ims = (0, $fmJ8d.store).getState().ims;
        if (!ims || !ims.profile) {
            console.error("IMS is not initialized. Cannot generate visuals.");
            throw new Error("IMS is not initialized");
        }
        // Update story with visual prompts and library selections
        // This makes the data visible in the UI immediately as each batch is processed
        queryClient.setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                visualsContext.steps?.forEach((step, idx)=>{
                    if (!state.script[step.idx ?? idx]) return;
                    const visualPrompt = step?.personas?.length ? step?.personasPrompt ?? step.visualPrompt : step.visualPrompt;
                    if (step.visualId && step.libraryId) {
                        // Validate that the persona exists and has the specified image
                        const persona = personas.find((p)=>p.libraryId === step.libraryId);
                        const hasValidImage = persona?.images?.some((img)=>img.id === step.visualId);
                        if (!hasValidImage) {
                            console.warn(`Persona with libraryId ${step.libraryId} not found in personas array for step ${step.idx}`);
                            // Fall back to Firefly generation
                            state.script[step.idx].visuals = [
                                {
                                    prompt: visualPrompt,
                                    type: "firefly"
                                }
                            ];
                        } else // Validation passed - add library visual
                        state.script[step.idx].visuals = [
                            {
                                id: step.visualId,
                                libraryId: step.libraryId,
                                visualName: step.visualName,
                                prompt: visualPrompt,
                                type: "cc-library"
                            }
                        ];
                    } else state.script[step.idx].visuals = [
                        {
                            prompt: visualPrompt,
                            type: "firefly"
                        }
                    ];
                });
            }));
        (0, $fmJ8d.store).getState().addToast(`Generating story images`, {
            variant: "info",
            timeout: -1
        });
        // Generate Firefly images for steps without library visuals
        const visualsPromises = $38e6864152917eb4$var$createVisualsPromises(queryClient, storyId, visualsContext, personas, imageReferenceId, totalSteps, currentGenerationRef);
        const results = await Promise.allSettled(visualsPromises);
        // Analyze results to track successes and failures
        const succeeded = results.filter((r)=>r.status === "fulfilled" && r.value?.success).length;
        const failed = results.filter((r)=>r.status === "rejected" || r.status === "fulfilled" && !r.value?.success);
        if (failed.length > 0) {
            console.warn(`${failed.length} image(s) failed to generate:`, failed);
            const failedSteps = failed.map((r)=>r.status === "fulfilled" ? r.value?.title : "Unknown step").filter(Boolean);
            if (failedSteps.length > 0) (0, $fmJ8d.store).getState().addToast(`Warning: ${failedSteps.length} step(s) failed to generate images`, {
                variant: "negative",
                timeout: 10000
            });
        }
        console.log(`Batch complete: ${succeeded} succeeded, ${failed.length} failed`);
    } catch (error) {
        console.error("Error parsing visuals response:", error);
        throw error;
    }
    return null;
};
const $38e6864152917eb4$var$uploadImageReference = async (imageReference)=>{
    try {
        console.log("Uploading reference image for style consistency...");
        const imageReferenceResponse = await (0, $AkKc4.uploadFireflyImage)(imageReference.url);
        console.log("Reference image uploaded successfully");
        return imageReferenceResponse?.id;
    } catch (error) {
        // Reference image upload is optional - continue without it if it fails
        console.warn("Failed to upload reference image - continuing without style reference:", error);
        (0, $fmJ8d.store).getState().addToast("Note: Reference image upload failed, generating without style reference", {
            variant: "info",
            timeout: 5000
        });
        return null;
    }
    return null;
};
/**
 * Generator function that recursively generates visuals for a story in batches.
 */ async function* $38e6864152917eb4$var$generateVisualsRecursive(ims, prompt_template, length, result = {
    steps: []
}, batchSize = 10) {
    for(let page = 1; page <= Math.ceil(length / batchSize); page++){
        console.log(`Generating visuals for page ${page} of ${Math.ceil(length / batchSize)}`);
        const currentPrompt = [
            ...prompt_template
        ];
        if (length > batchSize) currentPrompt.splice(-1, 0, {
            prompt_template: JSON.stringify(result),
            role: "system"
        }, {
            prompt_template: `You have already generated ${result.steps.length} steps. Continue generating until you reach ${Math.min(length, result.steps.length + batchSize)} steps.`,
            role: "user"
        });
        const response = await (0, $aKSBi.generateContent)({
            user: ims.profile.email,
            prompt_template: currentPrompt
        }, "Failed to fetch visuals prompt");
        const content = (0, $aKSBi.readZoltarGenerateJsonWithFallback)(response, '{"steps": []}', "Failed to fetch visuals prompt");
        result.steps.push(...content.steps);
        console.log({
            content: content,
            result: result
        });
        yield content;
    }
    return result;
}
/**
 * Constructs the request body for the Firefly image generation API.
 */ const $38e6864152917eb4$var$getFireflyImageBody = ({ model: model = (0, $AkKc4.DEFAULT_FIREFLY_MODEL), prompt: prompt = "", contentClass: contentClass = "photo", detailLevel: detailLevel = "full", size: size = {
    width: 2688,
    height: 1536
}, seeds: seeds = [], imageReferenceUrl: imageReferenceUrl = null, uploadId: uploadId = null, presets: presets = [], styleStrength: styleStrength = 50, visualIntensity: visualIntensity = 8, upsamplerType: upsamplerType = "default" } = {})=>({
        model: model,
        prompt: prompt,
        contentClass: contentClass,
        detailLevel: detailLevel,
        size: size,
        ...seeds.length > 0 ? {
            seeds: seeds
        } : {},
        ...!!imageReferenceUrl || !!uploadId || presets.length > 0 ? {
            style: {
                imageReference: {
                    source: {
                        ...imageReferenceUrl ? {
                            url: imageReferenceUrl
                        } : {},
                        ...uploadId ? {
                            uploadId: uploadId
                        } : {}
                    }
                },
                presets: presets,
                strength: styleStrength
            }
        } : {},
        visualIntensity: visualIntensity,
        upsamplerType: upsamplerType
    });
const $38e6864152917eb4$var$createVisualsPromises = (queryClient, storyId, visualsContext, personas, imageReferenceId, totalSteps, currentGenerationRef)=>{
    // Check IMS is initialized before making API calls
    const ims = (0, $fmJ8d.store).getState().ims;
    if (!ims || !ims.profile) {
        console.error("IMS is not initialized. Cannot generate visuals.");
        return [];
    }
    const visualsPromises = (visualsContext.steps || []).map(async (step)=>{
        try {
            const currentStory = queryClient.getQueryData((0, $VXM1R.storyKey).detail(storyId));
            if (!currentStory) {
                console.warn(`No story found with id: ${storyId}`);
                return {
                    success: false,
                    step: step.idx,
                    error: "Story not found"
                };
            }
            const storyStep = currentStory.script[step.idx];
            if (!storyStep) {
                console.warn(`No story step found for index ${step.idx} in visuals context`);
                return {
                    success: false,
                    step: step.idx,
                    error: "Step not found"
                };
            }
            const visual = storyStep.visuals[storyStep.visuals.length - 1];
            console.log("visual for step", step.idx, "is", storyStep.visuals);
            // Only generate Firefly image if no library visual was selected
            if (visual.type === "firefly") {
                if (!visual.prompt || typeof step.idx !== "number") return {
                    success: false,
                    step: step.idx,
                    error: "No prompt"
                };
                console.log("visual prompt:", step.idx, visual.prompt);
                const visualImages = await (0, $AkKc4.fetchFireflyImage)(storyId, $38e6864152917eb4$var$getFireflyImageBody({
                    prompt: visual.prompt,
                    uploadId: imageReferenceId
                }));
                if (!visualImages?.length) {
                    console.warn(`No images found for step ${step.idx} with prompt: ${visual.prompt}`);
                    return {
                        success: false,
                        step: step.idx,
                        error: "No images returned"
                    };
                }
                currentGenerationRef.current += 1;
                (0, $fmJ8d.store).getState().addToast(`Generating story images: ${currentGenerationRef.current}/${totalSteps}`, {
                    variant: "info",
                    timeout: -1
                });
                console.log("visual images:", step.idx, visualImages);
                // Add generated image to cache immediately so it appears in UI
                queryClient.setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                        state.script[step.idx].visuals[state.script[step.idx].visuals.length - 1] = {
                            ...state.script[step.idx].visuals[state.script[step.idx].visuals.length - 1],
                            url: visualImages?.[0]?.url,
                            seed: visualImages?.[0]?.seed,
                            path: visualImages?.[0]?.path
                        };
                    }));
            }
            return {
                success: true,
                step: step.idx
            };
        } catch (error) {
            console.error(`Failed to fetch image for step ${step.title} (index ${step.idx}):`, error);
            // Don't throw - return error info so we can continue with other images
            return {
                success: false,
                step: step.idx,
                error: error.message,
                title: step.title
            };
        }
    });
    return visualsPromises;
};

});
parcelRegister("dqZbZ", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $1c4d5fd65ffe522a$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $1c4d5fd65ffe522a$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $1c4d5fd65ffe522a$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $1c4d5fd65ffe522a$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "Navigate", () => $1c4d5fd65ffe522a$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $1c4d5fd65ffe522a$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $1c4d5fd65ffe522a$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "BrowserRouter", () => $1c4d5fd65ffe522a$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "useSearchParams", () => $1c4d5fd65ffe522a$export$f1a78c17382fe22a);
/**
 * react-router v7.18.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eF4cA = parcelRequire("eF4cA");
var $1c4d5fd65ffe522a$import_meta = Object.assign(Object.create(null), {
    url: "file:///../../node_modules/.pnpm/react-router@7.18.5_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/react-router/dist/development/chunk-6KYCQHYJ.mjs"
});
var $1c4d5fd65ffe522a$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $1c4d5fd65ffe522a$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $1c4d5fd65ffe522a$var$__typeError("Cannot " + msg);
var $1c4d5fd65ffe522a$var$__privateGet = (obj, member, getter)=>($1c4d5fd65ffe522a$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $1c4d5fd65ffe522a$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $1c4d5fd65ffe522a$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $1c4d5fd65ffe522a$var$__privateSet = (obj, member, value, setter)=>($1c4d5fd65ffe522a$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $1c4d5fd65ffe522a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $1c4d5fd65ffe522a$export$825a82322d91916e = /^[\\/]{2}/;
function $1c4d5fd65ffe522a$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $1c4d5fd65ffe522a$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($1c4d5fd65ffe522a$export$e19cd5f9376f8cee || {});
var $1c4d5fd65ffe522a$var$PopStateEventType = "popstate";
function $1c4d5fd65ffe522a$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $1c4d5fd65ffe522a$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $1c4d5fd65ffe522a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $1c4d5fd65ffe522a$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $1c4d5fd65ffe522a$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $1c4d5fd65ffe522a$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $1c4d5fd65ffe522a$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $1c4d5fd65ffe522a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to);
    }
    return $1c4d5fd65ffe522a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $1c4d5fd65ffe522a$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1c4d5fd65ffe522a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1c4d5fd65ffe522a$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $1c4d5fd65ffe522a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1c4d5fd65ffe522a$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1c4d5fd65ffe522a$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $1c4d5fd65ffe522a$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $1c4d5fd65ffe522a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $1c4d5fd65ffe522a$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1c4d5fd65ffe522a$var$createKey(),
        mask: mask
    };
    return location;
}
function $1c4d5fd65ffe522a$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1c4d5fd65ffe522a$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $1c4d5fd65ffe522a$var$isLocation(to) ? to : $1c4d5fd65ffe522a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1c4d5fd65ffe522a$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $1c4d5fd65ffe522a$var$isLocation(to) ? to : $1c4d5fd65ffe522a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1c4d5fd65ffe522a$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $1c4d5fd65ffe522a$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($1c4d5fd65ffe522a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($1c4d5fd65ffe522a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $1c4d5fd65ffe522a$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $1c4d5fd65ffe522a$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $1c4d5fd65ffe522a$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $1c4d5fd65ffe522a$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $1c4d5fd65ffe522a$var$_map;
var $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $1c4d5fd65ffe522a$var$__privateAdd(this, $1c4d5fd65ffe522a$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_map).has(context)) return $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_map).set(context, value);
    }
};
$1c4d5fd65ffe522a$var$_map = new WeakMap();
var $1c4d5fd65ffe522a$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1c4d5fd65ffe522a$var$isUnsupportedLazyRouteObjectKey(key) {
    return $1c4d5fd65ffe522a$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $1c4d5fd65ffe522a$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $1c4d5fd65ffe522a$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $1c4d5fd65ffe522a$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $1c4d5fd65ffe522a$var$isIndexRoute(route) {
    return route.index === true;
}
function $1c4d5fd65ffe522a$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1c4d5fd65ffe522a$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $1c4d5fd65ffe522a$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($1c4d5fd65ffe522a$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $1c4d5fd65ffe522a$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $1c4d5fd65ffe522a$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $1c4d5fd65ffe522a$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $1c4d5fd65ffe522a$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $1c4d5fd65ffe522a$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $1c4d5fd65ffe522a$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $1c4d5fd65ffe522a$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $1c4d5fd65ffe522a$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $1c4d5fd65ffe522a$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1c4d5fd65ffe522a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1c4d5fd65ffe522a$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $1c4d5fd65ffe522a$var$flattenAndRankRoutes(routes) {
    let branches = $1c4d5fd65ffe522a$var$flattenRoutes(routes);
    $1c4d5fd65ffe522a$var$rankRouteBranches(branches);
    return branches;
}
function $1c4d5fd65ffe522a$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $1c4d5fd65ffe522a$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1c4d5fd65ffe522a$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $1c4d5fd65ffe522a$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $1c4d5fd65ffe522a$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1c4d5fd65ffe522a$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $1c4d5fd65ffe522a$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $1c4d5fd65ffe522a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $1c4d5fd65ffe522a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1c4d5fd65ffe522a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1c4d5fd65ffe522a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $1c4d5fd65ffe522a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $1c4d5fd65ffe522a$var$paramRe = /^:[\w-]+$/;
var $1c4d5fd65ffe522a$var$dynamicSegmentValue = 3;
var $1c4d5fd65ffe522a$var$indexRouteValue = 2;
var $1c4d5fd65ffe522a$var$emptySegmentValue = 1;
var $1c4d5fd65ffe522a$var$staticSegmentValue = 10;
var $1c4d5fd65ffe522a$var$splatPenalty = -2;
var $1c4d5fd65ffe522a$var$isSplat = (s)=>s === "*";
function $1c4d5fd65ffe522a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1c4d5fd65ffe522a$var$isSplat)) initialScore += $1c4d5fd65ffe522a$var$splatPenalty;
    if (index) initialScore += $1c4d5fd65ffe522a$var$indexRouteValue;
    return segments.filter((s)=>!$1c4d5fd65ffe522a$var$isSplat(s)).reduce((score, segment)=>score + ($1c4d5fd65ffe522a$var$paramRe.test(segment) ? $1c4d5fd65ffe522a$var$dynamicSegmentValue : segment === "" ? $1c4d5fd65ffe522a$var$emptySegmentValue : $1c4d5fd65ffe522a$var$staticSegmentValue), initialScore);
}
function $1c4d5fd65ffe522a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1c4d5fd65ffe522a$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $1c4d5fd65ffe522a$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $1c4d5fd65ffe522a$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1c4d5fd65ffe522a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1c4d5fd65ffe522a$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1c4d5fd65ffe522a$var$normalizePathname($1c4d5fd65ffe522a$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1c4d5fd65ffe522a$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $1c4d5fd65ffe522a$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1c4d5fd65ffe522a$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $1c4d5fd65ffe522a$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $1c4d5fd65ffe522a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1c4d5fd65ffe522a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $1c4d5fd65ffe522a$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $1c4d5fd65ffe522a$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $1c4d5fd65ffe522a$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $1c4d5fd65ffe522a$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1c4d5fd65ffe522a$var$compilePath(path, caseSensitive = false, end = true) {
    $1c4d5fd65ffe522a$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $1c4d5fd65ffe522a$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1c4d5fd65ffe522a$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $1c4d5fd65ffe522a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $1c4d5fd65ffe522a$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $1c4d5fd65ffe522a$var$joinPaths([
        basename,
        pathname
    ]);
}
var $1c4d5fd65ffe522a$var$isAbsoluteUrl = (url)=>$1c4d5fd65ffe522a$var$ABSOLUTE_URL_REGEX.test(url);
function $1c4d5fd65ffe522a$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1c4d5fd65ffe522a$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $1c4d5fd65ffe522a$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1c4d5fd65ffe522a$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1c4d5fd65ffe522a$var$normalizeSearch(search),
        hash: $1c4d5fd65ffe522a$var$normalizeHash(hash)
    };
}
function $1c4d5fd65ffe522a$var$resolvePathname(relativePath, fromPathname) {
    let segments = $1c4d5fd65ffe522a$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1c4d5fd65ffe522a$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $1c4d5fd65ffe522a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $1c4d5fd65ffe522a$var$getResolveToMatches(matches) {
    let pathMatches = $1c4d5fd65ffe522a$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $1c4d5fd65ffe522a$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $1c4d5fd65ffe522a$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $1c4d5fd65ffe522a$var$getInvalidPathError("?", "pathname", "search", to));
        $1c4d5fd65ffe522a$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $1c4d5fd65ffe522a$var$getInvalidPathError("#", "pathname", "hash", to));
        $1c4d5fd65ffe522a$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $1c4d5fd65ffe522a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1c4d5fd65ffe522a$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $1c4d5fd65ffe522a$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $1c4d5fd65ffe522a$var$joinPaths = (paths)=>$1c4d5fd65ffe522a$var$removeDoubleSlashes(paths.join("/"));
function $1c4d5fd65ffe522a$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $1c4d5fd65ffe522a$var$normalizePathname = (pathname)=>$1c4d5fd65ffe522a$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $1c4d5fd65ffe522a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $1c4d5fd65ffe522a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $1c4d5fd65ffe522a$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $1c4d5fd65ffe522a$export$4051a07651545597(data2, init) {
    return new $1c4d5fd65ffe522a$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $1c4d5fd65ffe522a$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $1c4d5fd65ffe522a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1c4d5fd65ffe522a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $1c4d5fd65ffe522a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1c4d5fd65ffe522a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $1c4d5fd65ffe522a$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $1c4d5fd65ffe522a$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $1c4d5fd65ffe522a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $1c4d5fd65ffe522a$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $1c4d5fd65ffe522a$var$joinPaths(parts) || "/";
}
var $1c4d5fd65ffe522a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $1c4d5fd65ffe522a$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$1c4d5fd65ffe522a$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($1c4d5fd65ffe522a$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $1c4d5fd65ffe522a$export$825a82322d91916e.test(to) ? new URL($1c4d5fd65ffe522a$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $1c4d5fd65ffe522a$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $1c4d5fd65ffe522a$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $1c4d5fd65ffe522a$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $1c4d5fd65ffe522a$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $1c4d5fd65ffe522a$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $1c4d5fd65ffe522a$var$wrapImpl(aggregated[key], original, (...args)=>$1c4d5fd65ffe522a$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $1c4d5fd65ffe522a$var$wrapImpl(aggregated.middleware, original, (...args)=>$1c4d5fd65ffe522a$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $1c4d5fd65ffe522a$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $1c4d5fd65ffe522a$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $1c4d5fd65ffe522a$export$fe53371bee54353d(to) : ".",
                ...$1c4d5fd65ffe522a$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $1c4d5fd65ffe522a$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$1c4d5fd65ffe522a$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$1c4d5fd65ffe522a$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $1c4d5fd65ffe522a$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $1c4d5fd65ffe522a$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $1c4d5fd65ffe522a$var$getReadonlyRequest(request),
            context: context != null ? $1c4d5fd65ffe522a$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $1c4d5fd65ffe522a$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $1c4d5fd65ffe522a$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $1c4d5fd65ffe522a$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $1c4d5fd65ffe522a$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $1c4d5fd65ffe522a$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $1c4d5fd65ffe522a$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $1c4d5fd65ffe522a$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $1c4d5fd65ffe522a$var$getReadonlyContext(context)
    };
}
function $1c4d5fd65ffe522a$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $1c4d5fd65ffe522a$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $1c4d5fd65ffe522a$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $1c4d5fd65ffe522a$var$getReadonlyContext(context) {
    if ($1c4d5fd65ffe522a$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $1c4d5fd65ffe522a$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $1c4d5fd65ffe522a$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $1c4d5fd65ffe522a$var$objectProtoNames;
}
// lib/router/navigation.ts
var $1c4d5fd65ffe522a$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $1c4d5fd65ffe522a$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $1c4d5fd65ffe522a$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $1c4d5fd65ffe522a$var$DEFAULT_NAVIGATION_URL;
    }
}
function $1c4d5fd65ffe522a$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $1c4d5fd65ffe522a$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$1c4d5fd65ffe522a$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$1c4d5fd65ffe522a$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$1c4d5fd65ffe522a$var$isExplicitUrl(original, originalUrl) || !$1c4d5fd65ffe522a$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $1c4d5fd65ffe522a$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $1c4d5fd65ffe522a$var$validMutationMethods = new Set($1c4d5fd65ffe522a$var$validMutationMethodsArr);
var $1c4d5fd65ffe522a$var$validRequestMethodsArr = [
    "GET",
    ...$1c4d5fd65ffe522a$var$validMutationMethodsArr
];
var $1c4d5fd65ffe522a$var$validRequestMethods = new Set($1c4d5fd65ffe522a$var$validRequestMethodsArr);
var $1c4d5fd65ffe522a$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $1c4d5fd65ffe522a$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $1c4d5fd65ffe522a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $1c4d5fd65ffe522a$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $1c4d5fd65ffe522a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $1c4d5fd65ffe522a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $1c4d5fd65ffe522a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $1c4d5fd65ffe522a$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $1c4d5fd65ffe522a$var$_routes, $1c4d5fd65ffe522a$var$_branches, $1c4d5fd65ffe522a$var$_hmrRoutes, $1c4d5fd65ffe522a$var$_hmrBranches;
var $1c4d5fd65ffe522a$var$DataRoutes = class {
    constructor(routes){
        $1c4d5fd65ffe522a$var$__privateAdd(this, $1c4d5fd65ffe522a$var$_routes);
        $1c4d5fd65ffe522a$var$__privateAdd(this, $1c4d5fd65ffe522a$var$_branches);
        $1c4d5fd65ffe522a$var$__privateAdd(this, $1c4d5fd65ffe522a$var$_hmrRoutes);
        $1c4d5fd65ffe522a$var$__privateAdd(this, $1c4d5fd65ffe522a$var$_hmrBranches);
        $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_routes, routes);
        $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_branches, $1c4d5fd65ffe522a$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_hmrRoutes) ?? $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_hmrBranches) ?? $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_branches);
    }
    get hasHMRRoutes() {
        return $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_routes, routes);
        $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_branches, $1c4d5fd65ffe522a$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_hmrRoutes, routes);
        $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_hmrBranches, $1c4d5fd65ffe522a$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_hmrRoutes)) {
            $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_routes, $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_hmrRoutes));
            $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_branches, $1c4d5fd65ffe522a$var$__privateGet(this, $1c4d5fd65ffe522a$var$_hmrBranches));
            $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_hmrRoutes, void 0);
            $1c4d5fd65ffe522a$var$__privateSet(this, $1c4d5fd65ffe522a$var$_hmrBranches, void 0);
        }
    }
};
$1c4d5fd65ffe522a$var$_routes = new WeakMap();
$1c4d5fd65ffe522a$var$_branches = new WeakMap();
$1c4d5fd65ffe522a$var$_hmrRoutes = new WeakMap();
$1c4d5fd65ffe522a$var$_hmrBranches = new WeakMap();
function $1c4d5fd65ffe522a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $1c4d5fd65ffe522a$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $1c4d5fd65ffe522a$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$1c4d5fd65ffe522a$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $1c4d5fd65ffe522a$var$DataRoutes($1c4d5fd65ffe522a$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $1c4d5fd65ffe522a$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1c4d5fd65ffe522a$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$1c4d5fd65ffe522a$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $1c4d5fd65ffe522a$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $1c4d5fd65ffe522a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $1c4d5fd65ffe522a$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1c4d5fd65ffe522a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $1c4d5fd65ffe522a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1c4d5fd65ffe522a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $1c4d5fd65ffe522a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1c4d5fd65ffe522a$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $1c4d5fd65ffe522a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $1c4d5fd65ffe522a$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $1c4d5fd65ffe522a$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $1c4d5fd65ffe522a$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($1c4d5fd65ffe522a$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $1c4d5fd65ffe522a$export$fe53371bee54353d(opts.mask), $1c4d5fd65ffe522a$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $1c4d5fd65ffe522a$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1c4d5fd65ffe522a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $1c4d5fd65ffe522a$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1c4d5fd65ffe522a$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $1c4d5fd65ffe522a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $1c4d5fd65ffe522a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $1c4d5fd65ffe522a$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1c4d5fd65ffe522a$var$isErrorResult(result) && $1c4d5fd65ffe522a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1c4d5fd65ffe522a$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $1c4d5fd65ffe522a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$1c4d5fd65ffe522a$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $1c4d5fd65ffe522a$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $1c4d5fd65ffe522a$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $1c4d5fd65ffe522a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $1c4d5fd65ffe522a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1c4d5fd65ffe522a$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $1c4d5fd65ffe522a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($1c4d5fd65ffe522a$var$isErrorResult(result)) {
            let boundaryMatch = $1c4d5fd65ffe522a$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $1c4d5fd65ffe522a$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $1c4d5fd65ffe522a$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $1c4d5fd65ffe522a$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $1c4d5fd65ffe522a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $1c4d5fd65ffe522a$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$1c4d5fd65ffe522a$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $1c4d5fd65ffe522a$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $1c4d5fd65ffe522a$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $1c4d5fd65ffe522a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $1c4d5fd65ffe522a$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $1c4d5fd65ffe522a$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1c4d5fd65ffe522a$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1c4d5fd65ffe522a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1c4d5fd65ffe522a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $1c4d5fd65ffe522a$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($1c4d5fd65ffe522a$var$isRedirectResult(actionResult) || $1c4d5fd65ffe522a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1c4d5fd65ffe522a$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($1c4d5fd65ffe522a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $1c4d5fd65ffe522a$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1c4d5fd65ffe522a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($1c4d5fd65ffe522a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1c4d5fd65ffe522a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $1c4d5fd65ffe522a$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $1c4d5fd65ffe522a$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $1c4d5fd65ffe522a$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $1c4d5fd65ffe522a$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $1c4d5fd65ffe522a$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $1c4d5fd65ffe522a$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $1c4d5fd65ffe522a$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $1c4d5fd65ffe522a$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $1c4d5fd65ffe522a$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $1c4d5fd65ffe522a$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1c4d5fd65ffe522a$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $1c4d5fd65ffe522a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1c4d5fd65ffe522a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1c4d5fd65ffe522a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $1c4d5fd65ffe522a$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $1c4d5fd65ffe522a$var$getDoneFetcher(void 0));
            return;
        }
        if ($1c4d5fd65ffe522a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $1c4d5fd65ffe522a$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($1c4d5fd65ffe522a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $1c4d5fd65ffe522a$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $1c4d5fd65ffe522a$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $1c4d5fd65ffe522a$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $1c4d5fd65ffe522a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($1c4d5fd65ffe522a$var$isAbsoluteUrl(location)) {
                const url = $1c4d5fd65ffe522a$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1c4d5fd65ffe522a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1c4d5fd65ffe522a$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($1c4d5fd65ffe522a$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $1c4d5fd65ffe522a$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1c4d5fd65ffe522a$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$1c4d5fd65ffe522a$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($1c4d5fd65ffe522a$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $1c4d5fd65ffe522a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $1c4d5fd65ffe522a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $1c4d5fd65ffe522a$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $1c4d5fd65ffe522a$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $1c4d5fd65ffe522a$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $1c4d5fd65ffe522a$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $1c4d5fd65ffe522a$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $1c4d5fd65ffe522a$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $1c4d5fd65ffe522a$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1c4d5fd65ffe522a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1c4d5fd65ffe522a$export$386d57f03f0b2883;
        $1c4d5fd65ffe522a$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $1c4d5fd65ffe522a$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $1c4d5fd65ffe522a$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $1c4d5fd65ffe522a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$1c4d5fd65ffe522a$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1c4d5fd65ffe522a$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($1c4d5fd65ffe522a$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $1c4d5fd65ffe522a$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $1c4d5fd65ffe522a$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $1c4d5fd65ffe522a$export$3336b097a6fbc59a(routes, opts) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $1c4d5fd65ffe522a$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$1c4d5fd65ffe522a$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $1c4d5fd65ffe522a$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $1c4d5fd65ffe522a$var$flattenAndRankRoutes(dataRoutes);
    let matchCost = routeBranches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $1c4d5fd65ffe522a$var$defaultNormalizePath;
        let method = request.method;
        let location = $1c4d5fd65ffe522a$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04();
        if (!$1c4d5fd65ffe522a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1c4d5fd65ffe522a$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1c4d5fd65ffe522a$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $1c4d5fd65ffe522a$export$f5708dca728d7177(requestContext instanceof $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $1c4d5fd65ffe522a$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $1c4d5fd65ffe522a$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $1c4d5fd65ffe522a$var$createDataFunctionUrl(request, location),
                    pattern: $1c4d5fd65ffe522a$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($1c4d5fd65ffe522a$export$6e80290866a84dd4(error)) return error;
                    if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $1c4d5fd65ffe522a$export$f2680fa305b734ca(error.status, error.statusText, await $1c4d5fd65ffe522a$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(error)) error = $1c4d5fd65ffe522a$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $1c4d5fd65ffe522a$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $1c4d5fd65ffe522a$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $1c4d5fd65ffe522a$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $1c4d5fd65ffe522a$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $1c4d5fd65ffe522a$var$defaultNormalizePath;
        let method = request.method;
        let location = $1c4d5fd65ffe522a$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04();
        if (!$1c4d5fd65ffe522a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1c4d5fd65ffe522a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1c4d5fd65ffe522a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $1c4d5fd65ffe522a$export$f5708dca728d7177(requestContext instanceof $1c4d5fd65ffe522a$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $1c4d5fd65ffe522a$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $1c4d5fd65ffe522a$var$runServerMiddlewarePipeline({
                request: request,
                url: $1c4d5fd65ffe522a$var$createDataFunctionUrl(request, location),
                pattern: $1c4d5fd65ffe522a$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($1c4d5fd65ffe522a$var$dataWithResponseInitToResponse(error));
                if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $1c4d5fd65ffe522a$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1c4d5fd65ffe522a$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $1c4d5fd65ffe522a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($1c4d5fd65ffe522a$var$isDataStrategyResult(e) && $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($1c4d5fd65ffe522a$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1c4d5fd65ffe522a$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($1c4d5fd65ffe522a$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($1c4d5fd65ffe522a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($1c4d5fd65ffe522a$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1c4d5fd65ffe522a$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $1c4d5fd65ffe522a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1c4d5fd65ffe522a$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1c4d5fd65ffe522a$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $1c4d5fd65ffe522a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $1c4d5fd65ffe522a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $1c4d5fd65ffe522a$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $1c4d5fd65ffe522a$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $1c4d5fd65ffe522a$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1c4d5fd65ffe522a$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $1c4d5fd65ffe522a$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1c4d5fd65ffe522a$var$callDataStrategyImpl(dataStrategy || $1c4d5fd65ffe522a$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1c4d5fd65ffe522a$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $1c4d5fd65ffe522a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(result.result)) throw $1c4d5fd65ffe522a$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $1c4d5fd65ffe522a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _matchCost: matchCost,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $1c4d5fd65ffe522a$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $1c4d5fd65ffe522a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $1c4d5fd65ffe522a$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $1c4d5fd65ffe522a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $1c4d5fd65ffe522a$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $1c4d5fd65ffe522a$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $1c4d5fd65ffe522a$var$resolveTo(to ? to : ".", $1c4d5fd65ffe522a$var$getResolveToMatches(contextualMatches), $1c4d5fd65ffe522a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1c4d5fd65ffe522a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $1c4d5fd65ffe522a$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $1c4d5fd65ffe522a$export$fe53371bee54353d(path);
}
function $1c4d5fd65ffe522a$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$1c4d5fd65ffe522a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1c4d5fd65ffe522a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1c4d5fd65ffe522a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $1c4d5fd65ffe522a$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$1c4d5fd65ffe522a$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$1c4d5fd65ffe522a$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1c4d5fd65ffe522a$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1c4d5fd65ffe522a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1c4d5fd65ffe522a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1c4d5fd65ffe522a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1c4d5fd65ffe522a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($1c4d5fd65ffe522a$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $1c4d5fd65ffe522a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $1c4d5fd65ffe522a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $1c4d5fd65ffe522a$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $1c4d5fd65ffe522a$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$1c4d5fd65ffe522a$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $1c4d5fd65ffe522a$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($1c4d5fd65ffe522a$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $1c4d5fd65ffe522a$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($1c4d5fd65ffe522a$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $1c4d5fd65ffe522a$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $1c4d5fd65ffe522a$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $1c4d5fd65ffe522a$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $1c4d5fd65ffe522a$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($1c4d5fd65ffe522a$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $1c4d5fd65ffe522a$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $1c4d5fd65ffe522a$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$1c4d5fd65ffe522a$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $1c4d5fd65ffe522a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $1c4d5fd65ffe522a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1c4d5fd65ffe522a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1c4d5fd65ffe522a$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1c4d5fd65ffe522a$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$1c4d5fd65ffe522a$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $1c4d5fd65ffe522a$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $1c4d5fd65ffe522a$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $1c4d5fd65ffe522a$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$1c4d5fd65ffe522a$var$isSameRoute(aChild, bChild))) ?? false;
}
var $1c4d5fd65ffe522a$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $1c4d5fd65ffe522a$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $1c4d5fd65ffe522a$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $1c4d5fd65ffe522a$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $1c4d5fd65ffe522a$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $1c4d5fd65ffe522a$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $1c4d5fd65ffe522a$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $1c4d5fd65ffe522a$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $1c4d5fd65ffe522a$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $1c4d5fd65ffe522a$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $1c4d5fd65ffe522a$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $1c4d5fd65ffe522a$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $1c4d5fd65ffe522a$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $1c4d5fd65ffe522a$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $1c4d5fd65ffe522a$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $1c4d5fd65ffe522a$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $1c4d5fd65ffe522a$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $1c4d5fd65ffe522a$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $1c4d5fd65ffe522a$var$isNonNullable(value) {
    return value !== void 0;
}
function $1c4d5fd65ffe522a$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $1c4d5fd65ffe522a$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($1c4d5fd65ffe522a$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $1c4d5fd65ffe522a$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $1c4d5fd65ffe522a$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $1c4d5fd65ffe522a$var$defaultDataStrategy(args);
    return $1c4d5fd65ffe522a$var$runClientMiddlewarePipeline(args, ()=>$1c4d5fd65ffe522a$var$defaultDataStrategy(args));
}
function $1c4d5fd65ffe522a$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $1c4d5fd65ffe522a$var$runMiddlewarePipeline(args, handler, processResult, $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(result) ? $1c4d5fd65ffe522a$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $1c4d5fd65ffe522a$var$runClientMiddlewarePipeline(args, handler) {
    return $1c4d5fd65ffe522a$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($1c4d5fd65ffe522a$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $1c4d5fd65ffe522a$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $1c4d5fd65ffe522a$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $1c4d5fd65ffe522a$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $1c4d5fd65ffe522a$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $1c4d5fd65ffe522a$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $1c4d5fd65ffe522a$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $1c4d5fd65ffe522a$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $1c4d5fd65ffe522a$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $1c4d5fd65ffe522a$var$loadLazyRoute(match.route, $1c4d5fd65ffe522a$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $1c4d5fd65ffe522a$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $1c4d5fd65ffe522a$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $1c4d5fd65ffe522a$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $1c4d5fd65ffe522a$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $1c4d5fd65ffe522a$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$1c4d5fd65ffe522a$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($1c4d5fd65ffe522a$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $1c4d5fd65ffe522a$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $1c4d5fd65ffe522a$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $1c4d5fd65ffe522a$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $1c4d5fd65ffe522a$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $1c4d5fd65ffe522a$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $1c4d5fd65ffe522a$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $1c4d5fd65ffe522a$var$createDataFunctionUrl(request, path),
        pattern: $1c4d5fd65ffe522a$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $1c4d5fd65ffe522a$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $1c4d5fd65ffe522a$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $1c4d5fd65ffe522a$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $1c4d5fd65ffe522a$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1c4d5fd65ffe522a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1c4d5fd65ffe522a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1c4d5fd65ffe522a$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $1c4d5fd65ffe522a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $1c4d5fd65ffe522a$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $1c4d5fd65ffe522a$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $1c4d5fd65ffe522a$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $1c4d5fd65ffe522a$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $1c4d5fd65ffe522a$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $1c4d5fd65ffe522a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $1c4d5fd65ffe522a$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1c4d5fd65ffe522a$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1c4d5fd65ffe522a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $1c4d5fd65ffe522a$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $1c4d5fd65ffe522a$export$961a3ef7a4da3a39(location) {
    try {
        return $1c4d5fd65ffe522a$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $1c4d5fd65ffe522a$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($1c4d5fd65ffe522a$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $1c4d5fd65ffe522a$export$825a82322d91916e.test(normalizedLocation) ? new URL($1c4d5fd65ffe522a$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($1c4d5fd65ffe522a$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1c4d5fd65ffe522a$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($1c4d5fd65ffe522a$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $1c4d5fd65ffe522a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1c4d5fd65ffe522a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1c4d5fd65ffe522a$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $1c4d5fd65ffe522a$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1c4d5fd65ffe522a$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $1c4d5fd65ffe522a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1c4d5fd65ffe522a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1c4d5fd65ffe522a$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1c4d5fd65ffe522a$export$f5708dca728d7177(!$1c4d5fd65ffe522a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1c4d5fd65ffe522a$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $1c4d5fd65ffe522a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $1c4d5fd65ffe522a$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $1c4d5fd65ffe522a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1c4d5fd65ffe522a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $1c4d5fd65ffe522a$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $1c4d5fd65ffe522a$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($1c4d5fd65ffe522a$var$isErrorResult(result)) {
            let boundaryMatch = $1c4d5fd65ffe522a$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($1c4d5fd65ffe522a$var$isRedirectResult(result)) $1c4d5fd65ffe522a$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $1c4d5fd65ffe522a$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1c4d5fd65ffe522a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $1c4d5fd65ffe522a$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1c4d5fd65ffe522a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1c4d5fd65ffe522a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $1c4d5fd65ffe522a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1c4d5fd65ffe522a$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1c4d5fd65ffe522a$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $1c4d5fd65ffe522a$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $1c4d5fd65ffe522a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1c4d5fd65ffe522a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1c4d5fd65ffe522a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(path) : path;
    return $1c4d5fd65ffe522a$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $1c4d5fd65ffe522a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $1c4d5fd65ffe522a$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $1c4d5fd65ffe522a$var$dataWithResponseInitToErrorResponse(data2) {
    return new $1c4d5fd65ffe522a$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $1c4d5fd65ffe522a$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $1c4d5fd65ffe522a$var$isDataStrategyResult(value));
}
function $1c4d5fd65ffe522a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $1c4d5fd65ffe522a$var$isRedirectDataStrategyResult(result) {
    return $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result.result) && $1c4d5fd65ffe522a$var$redirectStatusCodes.has(result.result.status);
}
function $1c4d5fd65ffe522a$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $1c4d5fd65ffe522a$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1c4d5fd65ffe522a$export$794b2760043cf8cd(statusCode) {
    return $1c4d5fd65ffe522a$var$redirectStatusCodes.has(statusCode);
}
function $1c4d5fd65ffe522a$export$6e80290866a84dd4(result) {
    return $1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result) && $1c4d5fd65ffe522a$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $1c4d5fd65ffe522a$var$isValidMethod(method) {
    return $1c4d5fd65ffe522a$var$validRequestMethods.has(method.toUpperCase());
}
function $1c4d5fd65ffe522a$export$cbae47800eb95bc3(method) {
    return $1c4d5fd65ffe522a$var$validMutationMethods.has(method.toUpperCase());
}
function $1c4d5fd65ffe522a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1c4d5fd65ffe522a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1c4d5fd65ffe522a$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $1c4d5fd65ffe522a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1c4d5fd65ffe522a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $1c4d5fd65ffe522a$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $1c4d5fd65ffe522a$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1c4d5fd65ffe522a$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $1c4d5fd65ffe522a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $1c4d5fd65ffe522a$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $1c4d5fd65ffe522a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1c4d5fd65ffe522a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $1c4d5fd65ffe522a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1c4d5fd65ffe522a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1c4d5fd65ffe522a$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $1c4d5fd65ffe522a$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $1c4d5fd65ffe522a$export$2eeee58951ff3c1c = $eF4cA.createContext(null);
$1c4d5fd65ffe522a$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $1c4d5fd65ffe522a$export$315e3ffb01f217 = $eF4cA.createContext(null);
$1c4d5fd65ffe522a$export$315e3ffb01f217.displayName = "DataRouterState";
var $1c4d5fd65ffe522a$export$717f757c655223f1 = $eF4cA.createContext(false);
function $1c4d5fd65ffe522a$var$useIsRSCRouterContext() {
    return $eF4cA.useContext($1c4d5fd65ffe522a$export$717f757c655223f1);
}
var $1c4d5fd65ffe522a$export$3681f408decb40d1 = $eF4cA.createContext({
    isTransitioning: false
});
$1c4d5fd65ffe522a$export$3681f408decb40d1.displayName = "ViewTransition";
var $1c4d5fd65ffe522a$export$cb3f1df1bef00a39 = $eF4cA.createContext(/* @__PURE__ */ new Map());
$1c4d5fd65ffe522a$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $1c4d5fd65ffe522a$var$AwaitContext = $eF4cA.createContext(null);
$1c4d5fd65ffe522a$var$AwaitContext.displayName = "Await";
var $1c4d5fd65ffe522a$export$2666c20e15407622 = (props)=>$eF4cA.createElement($1c4d5fd65ffe522a$var$AwaitContext.Provider, props);
var $1c4d5fd65ffe522a$export$3044ab7fdabeaee6 = $eF4cA.createContext(null);
$1c4d5fd65ffe522a$export$3044ab7fdabeaee6.displayName = "Navigation";
var $1c4d5fd65ffe522a$export$e6a44b110a0c44d3 = $eF4cA.createContext(null);
$1c4d5fd65ffe522a$export$e6a44b110a0c44d3.displayName = "Location";
var $1c4d5fd65ffe522a$export$aac280ed165a4397 = $eF4cA.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$1c4d5fd65ffe522a$export$aac280ed165a4397.displayName = "Route";
var $1c4d5fd65ffe522a$var$RouteErrorContext = $eF4cA.createContext(null);
$1c4d5fd65ffe522a$var$RouteErrorContext.displayName = "RouteError";
var $1c4d5fd65ffe522a$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $1c4d5fd65ffe522a$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $1c4d5fd65ffe522a$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $1c4d5fd65ffe522a$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $1c4d5fd65ffe522a$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$1c4d5fd65ffe522a$var$ERROR_DIGEST_BASE}:${$1c4d5fd65ffe522a$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $1c4d5fd65ffe522a$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$1c4d5fd65ffe522a$var$ERROR_DIGEST_BASE}:${$1c4d5fd65ffe522a$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $1c4d5fd65ffe522a$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $1c4d5fd65ffe522a$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $1c4d5fd65ffe522a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $1c4d5fd65ffe522a$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $1c4d5fd65ffe522a$export$9c954a9d03d32f4a() {
    return $eF4cA.useContext($1c4d5fd65ffe522a$export$e6a44b110a0c44d3) != null;
}
function $1c4d5fd65ffe522a$export$45d76561a5302f2b() {
    $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $eF4cA.useContext($1c4d5fd65ffe522a$export$e6a44b110a0c44d3).location;
}
function $1c4d5fd65ffe522a$export$1b3f31771c5d07c() {
    return $eF4cA.useContext($1c4d5fd65ffe522a$export$e6a44b110a0c44d3).navigationType;
}
function $1c4d5fd65ffe522a$export$6c330e8992e8a295(pattern) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    return $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$export$81336c211d5ff295(pattern, $1c4d5fd65ffe522a$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $1c4d5fd65ffe522a$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $1c4d5fd65ffe522a$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6).static;
    if (!isStatic) $eF4cA.useLayoutEffect(cb);
}
function $1c4d5fd65ffe522a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    return isDataRoute ? $1c4d5fd65ffe522a$var$useNavigateStable() : $1c4d5fd65ffe522a$var$useNavigateUnstable();
}
function $1c4d5fd65ffe522a$var$useNavigateUnstable() {
    $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let { matches: matches } = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    let { pathname: locationPathname } = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($1c4d5fd65ffe522a$var$getResolveToMatches(matches));
    let activeRef = $eF4cA.useRef(false);
    $1c4d5fd65ffe522a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eF4cA.useCallback((to, options = {})=>{
        $1c4d5fd65ffe522a$var$warning(activeRef.current, $1c4d5fd65ffe522a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $1c4d5fd65ffe522a$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1c4d5fd65ffe522a$var$joinPaths([
            basename,
            path.pathname
        ]);
        $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to), navigator.createHref(path), $1c4d5fd65ffe522a$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $1c4d5fd65ffe522a$var$OutletContext = $eF4cA.createContext(null);
function $1c4d5fd65ffe522a$export$4138103a3ae699cc() {
    return $eF4cA.useContext($1c4d5fd65ffe522a$var$OutletContext);
}
function $1c4d5fd65ffe522a$export$a3be3530d8e40d0b(context) {
    let outlet = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397).outlet;
    return $eF4cA.useMemo(()=>outlet && /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $1c4d5fd65ffe522a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $1c4d5fd65ffe522a$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    let { pathname: locationPathname } = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($1c4d5fd65ffe522a$var$getResolveToMatches(matches));
    return $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $1c4d5fd65ffe522a$export$5d3fca4a98652595(routes, locationArg) {
    return $1c4d5fd65ffe522a$var$useRoutesImpl(routes, locationArg);
}
function $1c4d5fd65ffe522a$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($1c4d5fd65ffe522a$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $1c4d5fd65ffe522a$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $1c4d5fd65ffe522a$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $1c4d5fd65ffe522a$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($1c4d5fd65ffe522a$export$945fecf35a8ef089) {
        $1c4d5fd65ffe522a$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $1c4d5fd65ffe522a$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $1c4d5fd65ffe522a$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $1c4d5fd65ffe522a$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $1c4d5fd65ffe522a$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $1c4d5fd65ffe522a$var$DefaultErrorComponent() {
    let error = $1c4d5fd65ffe522a$export$ed527bf60f6e05f2();
    let message = $1c4d5fd65ffe522a$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($1c4d5fd65ffe522a$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, /* @__PURE__ */ $eF4cA.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $eF4cA.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $eF4cA.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $eF4cA.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, /* @__PURE__ */ $eF4cA.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $eF4cA.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $eF4cA.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $1c4d5fd65ffe522a$var$defaultErrorElement = /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$DefaultErrorComponent, null);
var $1c4d5fd65ffe522a$var$RenderErrorBoundary = class extends $eF4cA.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $1c4d5fd65ffe522a$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$1c4d5fd65ffe522a$var$RenderErrorBoundary.contextType = $1c4d5fd65ffe522a$export$717f757c655223f1;
var $1c4d5fd65ffe522a$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $1c4d5fd65ffe522a$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $1c4d5fd65ffe522a$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $1c4d5fd65ffe522a$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $1c4d5fd65ffe522a$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(redirect2.location, target, $1c4d5fd65ffe522a$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($1c4d5fd65ffe522a$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($1c4d5fd65ffe522a$var$isBrowser && !$1c4d5fd65ffe522a$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $1c4d5fd65ffe522a$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $eF4cA.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $1c4d5fd65ffe522a$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $1c4d5fd65ffe522a$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $1c4d5fd65ffe522a$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $1c4d5fd65ffe522a$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $1c4d5fd65ffe522a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $1c4d5fd65ffe522a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $eF4cA.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $1c4d5fd65ffe522a$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $1c4d5fd65ffe522a$var$useDataRouterContext(hookName) {
    let ctx = $eF4cA.useContext($1c4d5fd65ffe522a$export$2eeee58951ff3c1c);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(ctx, $1c4d5fd65ffe522a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $1c4d5fd65ffe522a$var$useDataRouterState(hookName) {
    let state = $eF4cA.useContext($1c4d5fd65ffe522a$export$315e3ffb01f217);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(state, $1c4d5fd65ffe522a$var$getDataRouterConsoleError(hookName));
    return state;
}
function $1c4d5fd65ffe522a$var$useRouteContext(hookName) {
    let route = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(route, $1c4d5fd65ffe522a$var$getDataRouterConsoleError(hookName));
    return route;
}
function $1c4d5fd65ffe522a$var$useCurrentRouteId(hookName) {
    let route = $1c4d5fd65ffe522a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $1c4d5fd65ffe522a$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $1c4d5fd65ffe522a$var$useRouteId() {
    return $1c4d5fd65ffe522a$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $1c4d5fd65ffe522a$export$d0fd4b7106de2769() {
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $eF4cA.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $1c4d5fd65ffe522a$export$600dc272ed516c15() {
    let dataRouterContext = $1c4d5fd65ffe522a$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $eF4cA.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $eF4cA.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $1c4d5fd65ffe522a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $1c4d5fd65ffe522a$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $eF4cA.useMemo(()=>matches.map((m)=>$1c4d5fd65ffe522a$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $1c4d5fd65ffe522a$export$1448a5050d252c4d() {
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $1c4d5fd65ffe522a$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $1c4d5fd65ffe522a$export$fd5d37484eab868d(routeId) {
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $1c4d5fd65ffe522a$export$fdc00f3f26066d5e() {
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $1c4d5fd65ffe522a$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $1c4d5fd65ffe522a$export$ed527bf60f6e05f2() {
    let error = $eF4cA.useContext($1c4d5fd65ffe522a$var$RouteErrorContext);
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $1c4d5fd65ffe522a$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $1c4d5fd65ffe522a$export$78a72ddb39bdd145() {
    let value = $eF4cA.useContext($1c4d5fd65ffe522a$var$AwaitContext);
    return value?._data;
}
function $1c4d5fd65ffe522a$export$17f53340677d5831() {
    let value = $eF4cA.useContext($1c4d5fd65ffe522a$var$AwaitContext);
    return value?._error;
}
var $1c4d5fd65ffe522a$var$blockerId = 0;
function $1c4d5fd65ffe522a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $1c4d5fd65ffe522a$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $1c4d5fd65ffe522a$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $eF4cA.useState("");
    let blockerFunction = $eF4cA.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $1c4d5fd65ffe522a$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $1c4d5fd65ffe522a$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $eF4cA.useEffect(()=>{
        let key = String(++$1c4d5fd65ffe522a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $eF4cA.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $1c4d5fd65ffe522a$export$386d57f03f0b2883;
}
function $1c4d5fd65ffe522a$var$useNavigateStable() {
    let { router: router } = $1c4d5fd65ffe522a$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $1c4d5fd65ffe522a$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $eF4cA.useRef(false);
    $1c4d5fd65ffe522a$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eF4cA.useCallback(async (to, options = {})=>{
        $1c4d5fd65ffe522a$var$warning(activeRef.current, $1c4d5fd65ffe522a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $1c4d5fd65ffe522a$var$alreadyWarned = {};
function $1c4d5fd65ffe522a$var$warningOnce(key, cond, message) {
    if (!cond && !$1c4d5fd65ffe522a$var$alreadyWarned[key]) {
        $1c4d5fd65ffe522a$var$alreadyWarned[key] = true;
        $1c4d5fd65ffe522a$var$warning(false, message);
    }
}
function $1c4d5fd65ffe522a$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $1c4d5fd65ffe522a$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $1c4d5fd65ffe522a$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $1c4d5fd65ffe522a$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $1c4d5fd65ffe522a$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $1c4d5fd65ffe522a$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $eF4cA.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$1c4d5fd65ffe522a$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $eF4cA.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$1c4d5fd65ffe522a$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $eF4cA.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $1c4d5fd65ffe522a$var$alreadyWarned2 = {};
function $1c4d5fd65ffe522a$export$5b28268982f175ba(condition, message) {
    if (!condition && !$1c4d5fd65ffe522a$var$alreadyWarned2[message]) {
        $1c4d5fd65ffe522a$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $1c4d5fd65ffe522a$var$USE_OPTIMISTIC = "useOptimistic";
var $1c4d5fd65ffe522a$var$useOptimisticImpl = $eF4cA[$1c4d5fd65ffe522a$var$USE_OPTIMISTIC];
var $1c4d5fd65ffe522a$var$stableUseOptimisticSetter = ()=>void 0;
function $1c4d5fd65ffe522a$var$useOptimisticSafe(val) {
    if ($1c4d5fd65ffe522a$var$useOptimisticImpl) return $1c4d5fd65ffe522a$var$useOptimisticImpl(val);
    else return [
        val,
        $1c4d5fd65ffe522a$var$stableUseOptimisticSetter
    ];
}
function $1c4d5fd65ffe522a$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($1c4d5fd65ffe522a$export$945fecf35a8ef089) {
            if (route.element) $1c4d5fd65ffe522a$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $eF4cA.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($1c4d5fd65ffe522a$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $1c4d5fd65ffe522a$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $eF4cA.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($1c4d5fd65ffe522a$export$945fecf35a8ef089) {
            if (route.errorElement) $1c4d5fd65ffe522a$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $eF4cA.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $1c4d5fd65ffe522a$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $1c4d5fd65ffe522a$export$f30f7e456d254e83(routes, opts) {
    return $1c4d5fd65ffe522a$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $1c4d5fd65ffe522a$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $1c4d5fd65ffe522a$export$e2fd2c03906469db,
        mapRouteProperties: $1c4d5fd65ffe522a$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $1c4d5fd65ffe522a$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $1c4d5fd65ffe522a$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $1c4d5fd65ffe522a$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $eF4cA.useState(router.state);
    let [state, setOptimisticState] = $1c4d5fd65ffe522a$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $eF4cA.useState();
    let [vtContext, setVtContext] = $eF4cA.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eF4cA.useState();
    let [transition, setTransition] = $eF4cA.useState();
    let [interruption, setInterruption] = $eF4cA.useState();
    let fetcherData = $eF4cA.useRef(/* @__PURE__ */ new Map());
    let setState = $eF4cA.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $1c4d5fd65ffe522a$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $1c4d5fd65ffe522a$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $1c4d5fd65ffe522a$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $eF4cA.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$1c4d5fd65ffe522a$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $eF4cA.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eF4cA.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1c4d5fd65ffe522a$var$Deferred());
    }, [
        vtContext
    ]);
    $eF4cA.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $eF4cA.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$1c4d5fd65ffe522a$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $eF4cA.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $eF4cA.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $eF4cA.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eF4cA.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $1c4d5fd65ffe522a$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $1c4d5fd65ffe522a$var$MemoizedDataRoutes = $eF4cA.memo($1c4d5fd65ffe522a$var$DataRoutes2);
function $1c4d5fd65ffe522a$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $1c4d5fd65ffe522a$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $1c4d5fd65ffe522a$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $eF4cA.useRef();
    if (historyRef.current == null) historyRef.current = $1c4d5fd65ffe522a$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eF4cA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eF4cA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $eF4cA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $eF4cA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $1c4d5fd65ffe522a$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177($1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    $1c4d5fd65ffe522a$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    let { pathname: locationPathname } = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let navigate = $1c4d5fd65ffe522a$export$9770f232ac06a008();
    let path = $1c4d5fd65ffe522a$var$resolveTo(to, $1c4d5fd65ffe522a$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $1c4d5fd65ffe522a$export$6c8e41f66e7aa990(typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to), navigator.createHref(path), $1c4d5fd65ffe522a$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $eF4cA.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $1c4d5fd65ffe522a$export$910ae8079b2c2852(props) {
    return $1c4d5fd65ffe522a$export$a3be3530d8e40d0b(props.context);
}
function $1c4d5fd65ffe522a$export$e7b0ac011bb776c6(props) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $1c4d5fd65ffe522a$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177(!$1c4d5fd65ffe522a$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eF4cA.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $eF4cA.useMemo(()=>{
        let trailingPathname = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $1c4d5fd65ffe522a$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $1c4d5fd65ffe522a$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $1c4d5fd65ffe522a$export$5d3fca4a98652595($1c4d5fd65ffe522a$export$16da398f5434bdec(children), location);
}
function $1c4d5fd65ffe522a$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$315e3ffb01f217);
    let onError = $eF4cA.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $1c4d5fd65ffe522a$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$ResolveAwait, null, children));
}
var $1c4d5fd65ffe522a$var$AwaitErrorBoundary = class extends $eF4cA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $1c4d5fd65ffe522a$var$ResolveAwait({ children: children }) {
    let data2 = $1c4d5fd65ffe522a$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, toRender);
}
function $1c4d5fd65ffe522a$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $eF4cA.Children.forEach(children, (element, index)=>{
        if (!$eF4cA.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eF4cA.Fragment) {
            routes.push.apply(routes, $1c4d5fd65ffe522a$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $1c4d5fd65ffe522a$export$f5708dca728d7177(element.type === $1c4d5fd65ffe522a$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $1c4d5fd65ffe522a$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $1c4d5fd65ffe522a$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $1c4d5fd65ffe522a$export$9b5b6d122dea0c88 = $1c4d5fd65ffe522a$export$16da398f5434bdec;
function $1c4d5fd65ffe522a$export$daf73786167a7f72(matches) {
    return $1c4d5fd65ffe522a$var$_renderMatches(matches);
}
function $1c4d5fd65ffe522a$var$useRouteComponentProps() {
    return {
        params: $1c4d5fd65ffe522a$export$99eaa27ddbbb95ef(),
        loaderData: $1c4d5fd65ffe522a$export$1448a5050d252c4d(),
        actionData: $1c4d5fd65ffe522a$export$fdc00f3f26066d5e(),
        matches: $1c4d5fd65ffe522a$export$2378eb7f5ff86053()
    };
}
function $1c4d5fd65ffe522a$export$6c4f3826290c37af({ children: children }) {
    const props = $1c4d5fd65ffe522a$var$useRouteComponentProps();
    return $eF4cA.cloneElement(children, props);
}
function $1c4d5fd65ffe522a$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $1c4d5fd65ffe522a$var$useRouteComponentProps();
        return $eF4cA.createElement(Component4, props);
    };
}
function $1c4d5fd65ffe522a$var$useHydrateFallbackProps() {
    return {
        params: $1c4d5fd65ffe522a$export$99eaa27ddbbb95ef(),
        loaderData: $1c4d5fd65ffe522a$export$1448a5050d252c4d(),
        actionData: $1c4d5fd65ffe522a$export$fdc00f3f26066d5e()
    };
}
function $1c4d5fd65ffe522a$export$f8cff34f39c1932a({ children: children }) {
    const props = $1c4d5fd65ffe522a$var$useHydrateFallbackProps();
    return $eF4cA.cloneElement(children, props);
}
function $1c4d5fd65ffe522a$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $1c4d5fd65ffe522a$var$useHydrateFallbackProps();
        return $eF4cA.createElement(HydrateFallback, props);
    };
}
function $1c4d5fd65ffe522a$var$useErrorBoundaryProps() {
    return {
        params: $1c4d5fd65ffe522a$export$99eaa27ddbbb95ef(),
        loaderData: $1c4d5fd65ffe522a$export$1448a5050d252c4d(),
        actionData: $1c4d5fd65ffe522a$export$fdc00f3f26066d5e(),
        error: $1c4d5fd65ffe522a$export$ed527bf60f6e05f2()
    };
}
function $1c4d5fd65ffe522a$export$e5afde5c4b6d747b({ children: children }) {
    const props = $1c4d5fd65ffe522a$var$useErrorBoundaryProps();
    return $eF4cA.cloneElement(children, props);
}
function $1c4d5fd65ffe522a$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $1c4d5fd65ffe522a$var$useErrorBoundaryProps();
        return $eF4cA.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $1c4d5fd65ffe522a$var$defaultMethod = "get";
var $1c4d5fd65ffe522a$var$defaultEncType = "application/x-www-form-urlencoded";
function $1c4d5fd65ffe522a$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $1c4d5fd65ffe522a$var$isButtonElement(object) {
    return $1c4d5fd65ffe522a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $1c4d5fd65ffe522a$var$isFormElement(object) {
    return $1c4d5fd65ffe522a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $1c4d5fd65ffe522a$var$isInputElement(object) {
    return $1c4d5fd65ffe522a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $1c4d5fd65ffe522a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $1c4d5fd65ffe522a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$1c4d5fd65ffe522a$var$isModifiedEvent(event);
}
function $1c4d5fd65ffe522a$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $1c4d5fd65ffe522a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $1c4d5fd65ffe522a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $1c4d5fd65ffe522a$var$_formDataSupportsSubmitter = null;
function $1c4d5fd65ffe522a$var$isFormDataSubmitterSupported() {
    if ($1c4d5fd65ffe522a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $1c4d5fd65ffe522a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $1c4d5fd65ffe522a$var$_formDataSupportsSubmitter = true;
    }
    return $1c4d5fd65ffe522a$var$_formDataSupportsSubmitter;
}
var $1c4d5fd65ffe522a$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $1c4d5fd65ffe522a$var$getFormEncType(encType) {
    if (encType != null && !$1c4d5fd65ffe522a$var$supportedFormEncTypes.has(encType)) {
        $1c4d5fd65ffe522a$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$1c4d5fd65ffe522a$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $1c4d5fd65ffe522a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($1c4d5fd65ffe522a$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $1c4d5fd65ffe522a$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $1c4d5fd65ffe522a$var$defaultMethod;
        encType = $1c4d5fd65ffe522a$var$getFormEncType(target.getAttribute("enctype")) || $1c4d5fd65ffe522a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($1c4d5fd65ffe522a$var$isButtonElement(target) || $1c4d5fd65ffe522a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $1c4d5fd65ffe522a$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $1c4d5fd65ffe522a$var$defaultMethod;
        encType = $1c4d5fd65ffe522a$var$getFormEncType(target.getAttribute("formenctype")) || $1c4d5fd65ffe522a$var$getFormEncType(form.getAttribute("enctype")) || $1c4d5fd65ffe522a$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$1c4d5fd65ffe522a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($1c4d5fd65ffe522a$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $1c4d5fd65ffe522a$var$defaultMethod;
        action = null;
        encType = $1c4d5fd65ffe522a$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $1c4d5fd65ffe522a$var$HOLE = -1;
var $1c4d5fd65ffe522a$var$NAN = -2;
var $1c4d5fd65ffe522a$var$NEGATIVE_INFINITY = -3;
var $1c4d5fd65ffe522a$var$NEGATIVE_ZERO = -4;
var $1c4d5fd65ffe522a$var$NULL = -5;
var $1c4d5fd65ffe522a$var$POSITIVE_INFINITY = -6;
var $1c4d5fd65ffe522a$var$UNDEFINED = -7;
var $1c4d5fd65ffe522a$var$TYPE_BIGINT = "B";
var $1c4d5fd65ffe522a$var$TYPE_DATE = "D";
var $1c4d5fd65ffe522a$var$TYPE_ERROR = "E";
var $1c4d5fd65ffe522a$var$TYPE_MAP = "M";
var $1c4d5fd65ffe522a$var$TYPE_NULL_OBJECT = "N";
var $1c4d5fd65ffe522a$var$TYPE_PROMISE = "P";
var $1c4d5fd65ffe522a$var$TYPE_REGEXP = "R";
var $1c4d5fd65ffe522a$var$TYPE_SET = "S";
var $1c4d5fd65ffe522a$var$TYPE_SYMBOL = "Y";
var $1c4d5fd65ffe522a$var$TYPE_URL = "U";
var $1c4d5fd65ffe522a$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $1c4d5fd65ffe522a$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $1c4d5fd65ffe522a$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $1c4d5fd65ffe522a$var$TIME_LIMIT_MS = 1;
var $1c4d5fd65ffe522a$var$getNow = ()=>Date.now();
var $1c4d5fd65ffe522a$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $1c4d5fd65ffe522a$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $1c4d5fd65ffe522a$var$UNDEFINED;
    if (input === null) return $1c4d5fd65ffe522a$var$NULL;
    if (Number.isNaN(input)) return $1c4d5fd65ffe522a$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $1c4d5fd65ffe522a$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $1c4d5fd65ffe522a$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $1c4d5fd65ffe522a$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $1c4d5fd65ffe522a$var$stringify.call(this, stack);
    return index;
}
async function $1c4d5fd65ffe522a$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $1c4d5fd65ffe522a$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $1c4d5fd65ffe522a$var$UNDEFINED;
        if (value === null) return $1c4d5fd65ffe522a$var$NULL;
        if (Number.isNaN(value)) return $1c4d5fd65ffe522a$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $1c4d5fd65ffe522a$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $1c4d5fd65ffe522a$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $1c4d5fd65ffe522a$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $1c4d5fd65ffe522a$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $1c4d5fd65ffe522a$var$TIME_LIMIT_MS) {
            await $1c4d5fd65ffe522a$var$yieldToMain();
            lastYieldTime = $1c4d5fd65ffe522a$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$1c4d5fd65ffe522a$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $1c4d5fd65ffe522a$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$1c4d5fd65ffe522a$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($1c4d5fd65ffe522a$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $1c4d5fd65ffe522a$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $1c4d5fd65ffe522a$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $1c4d5fd65ffe522a$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $1c4d5fd65ffe522a$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $1c4d5fd65ffe522a$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $1c4d5fd65ffe522a$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $1c4d5fd65ffe522a$var$hydrate.call(this, startIndex);
}
function $1c4d5fd65ffe522a$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $1c4d5fd65ffe522a$var$UNDEFINED:
                set(void 0);
                continue;
            case $1c4d5fd65ffe522a$var$NULL:
                set(null);
                continue;
            case $1c4d5fd65ffe522a$var$NAN:
                set(NaN);
                continue;
            case $1c4d5fd65ffe522a$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $1c4d5fd65ffe522a$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $1c4d5fd65ffe522a$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        $1c4d5fd65ffe522a$var$validateIndex(index2, values.length);
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $1c4d5fd65ffe522a$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_PROMISE:
                        $1c4d5fd65ffe522a$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $1c4d5fd65ffe522a$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $1c4d5fd65ffe522a$var$globalObj && $1c4d5fd65ffe522a$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $1c4d5fd65ffe522a$var$globalObj && typeof $1c4d5fd65ffe522a$var$globalObj[errorType] === "function" ? new $1c4d5fd65ffe522a$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $1c4d5fd65ffe522a$var$TYPE_PREVIOUS_RESOLVED:
                        $1c4d5fd65ffe522a$var$validateIndex(b, values.length);
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $1c4d5fd65ffe522a$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $1c4d5fd65ffe522a$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $1c4d5fd65ffe522a$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $1c4d5fd65ffe522a$var$Deferred2();
    const reader = readable.pipeThrough($1c4d5fd65ffe522a$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $1c4d5fd65ffe522a$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $1c4d5fd65ffe522a$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $1c4d5fd65ffe522a$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $1c4d5fd65ffe522a$var$unflatten.call(this, line)
    };
}
async function $1c4d5fd65ffe522a$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $1c4d5fd65ffe522a$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $1c4d5fd65ffe522a$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $1c4d5fd65ffe522a$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $1c4d5fd65ffe522a$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $1c4d5fd65ffe522a$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $1c4d5fd65ffe522a$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $1c4d5fd65ffe522a$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$1c4d5fd65ffe522a$var$TYPE_PROMISE}${deferredId}:[["${$1c4d5fd65ffe522a$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$1c4d5fd65ffe522a$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$1c4d5fd65ffe522a$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $1c4d5fd65ffe522a$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$1c4d5fd65ffe522a$var$TYPE_ERROR}${deferredId}:[["${$1c4d5fd65ffe522a$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$1c4d5fd65ffe522a$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$1c4d5fd65ffe522a$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $1c4d5fd65ffe522a$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $1c4d5fd65ffe522a$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $1c4d5fd65ffe522a$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $1c4d5fd65ffe522a$export$4cf11838cdc2a8a8(html) {
    return html.replace($1c4d5fd65ffe522a$var$ESCAPE_REGEX, (match)=>$1c4d5fd65ffe522a$var$ESCAPE_LOOKUP[match]);
}
function $1c4d5fd65ffe522a$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $1c4d5fd65ffe522a$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $1c4d5fd65ffe522a$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $1c4d5fd65ffe522a$var$SingleFetchNoResultError = class extends Error {
};
var $1c4d5fd65ffe522a$export$ae9272e641ead836 = 202;
var $1c4d5fd65ffe522a$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $1c4d5fd65ffe522a$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $eF4cA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$1c4d5fd65ffe522a$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, scriptTag, /* @__PURE__ */ $eF4cA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, scriptTag, /* @__PURE__ */ $eF4cA.createElement($eF4cA.Suspense, null, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $1c4d5fd65ffe522a$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $1c4d5fd65ffe522a$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $1c4d5fd65ffe522a$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $1c4d5fd65ffe522a$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $1c4d5fd65ffe522a$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $1c4d5fd65ffe522a$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $1c4d5fd65ffe522a$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $1c4d5fd65ffe522a$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $1c4d5fd65ffe522a$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $1c4d5fd65ffe522a$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $1c4d5fd65ffe522a$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $1c4d5fd65ffe522a$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($1c4d5fd65ffe522a$export$3f1eb41d9a6a6a27(result.result) || $1c4d5fd65ffe522a$export$972111febbeef05b(result.result) || $1c4d5fd65ffe522a$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $1c4d5fd65ffe522a$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $1c4d5fd65ffe522a$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $1c4d5fd65ffe522a$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $1c4d5fd65ffe522a$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$1c4d5fd65ffe522a$var$createDeferred2());
    let singleFetchDfd = $1c4d5fd65ffe522a$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $1c4d5fd65ffe522a$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $1c4d5fd65ffe522a$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $1c4d5fd65ffe522a$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $1c4d5fd65ffe522a$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $1c4d5fd65ffe522a$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $1c4d5fd65ffe522a$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $1c4d5fd65ffe522a$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $1c4d5fd65ffe522a$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $1c4d5fd65ffe522a$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $1c4d5fd65ffe522a$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $1c4d5fd65ffe522a$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$1c4d5fd65ffe522a$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$1c4d5fd65ffe522a$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $1c4d5fd65ffe522a$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $1c4d5fd65ffe522a$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $1c4d5fd65ffe522a$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $1c4d5fd65ffe522a$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $1c4d5fd65ffe522a$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $1c4d5fd65ffe522a$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($1c4d5fd65ffe522a$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $1c4d5fd65ffe522a$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $1c4d5fd65ffe522a$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($1c4d5fd65ffe522a$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$1c4d5fd65ffe522a$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $1c4d5fd65ffe522a$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $1c4d5fd65ffe522a$export$4023ad4ecd4126a2(body, global) {
    return $1c4d5fd65ffe522a$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $1c4d5fd65ffe522a$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $1c4d5fd65ffe522a$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$1c4d5fd65ffe522a$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $1c4d5fd65ffe522a$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $1c4d5fd65ffe522a$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $1c4d5fd65ffe522a$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $1c4d5fd65ffe522a$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $1c4d5fd65ffe522a$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $1c4d5fd65ffe522a$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $1c4d5fd65ffe522a$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $1c4d5fd65ffe522a$var$getModuleLinkHrefs(matches, manifest);
    return $1c4d5fd65ffe522a$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $1c4d5fd65ffe522a$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $1c4d5fd65ffe522a$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $1c4d5fd65ffe522a$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($1c4d5fd65ffe522a$var$prefetchStyleLink));
}
async function $1c4d5fd65ffe522a$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$1c4d5fd65ffe522a$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$1c4d5fd65ffe522a$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$1c4d5fd65ffe522a$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($1c4d5fd65ffe522a$var$prefetchStyleLink));
}
async function $1c4d5fd65ffe522a$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $1c4d5fd65ffe522a$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $1c4d5fd65ffe522a$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $1c4d5fd65ffe522a$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $1c4d5fd65ffe522a$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $1c4d5fd65ffe522a$var$dedupeLinkDescriptors(links.flat(1).filter($1c4d5fd65ffe522a$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $1c4d5fd65ffe522a$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $1c4d5fd65ffe522a$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $1c4d5fd65ffe522a$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $1c4d5fd65ffe522a$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $1c4d5fd65ffe522a$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $1c4d5fd65ffe522a$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$1c4d5fd65ffe522a$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($1c4d5fd65ffe522a$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $1c4d5fd65ffe522a$var$_isPreloadSupported;
function $1c4d5fd65ffe522a$var$isPreloadSupported() {
    if ($1c4d5fd65ffe522a$var$_isPreloadSupported !== void 0) return $1c4d5fd65ffe522a$var$_isPreloadSupported;
    let el = document.createElement("link");
    $1c4d5fd65ffe522a$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $1c4d5fd65ffe522a$var$_isPreloadSupported;
}
function $1c4d5fd65ffe522a$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $1c4d5fd65ffe522a$export$945fecf35a8ef089 ? /* @__PURE__ */ $eF4cA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $1c4d5fd65ffe522a$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $1c4d5fd65ffe522a$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $1c4d5fd65ffe522a$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $1c4d5fd65ffe522a$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RemixRootDefaultErrorBoundary, {
            error: $1c4d5fd65ffe522a$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $eF4cA.createElement(routeModule.Layout, null, /* @__PURE__ */ $eF4cA.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $eF4cA.createElement(routeModule.Layout, null, /* @__PURE__ */ $eF4cA.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $eF4cA.createElement(routeModule.Layout, null, /* @__PURE__ */ $eF4cA.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $1c4d5fd65ffe522a$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $1c4d5fd65ffe522a$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $1c4d5fd65ffe522a$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$1c4d5fd65ffe522a$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $1c4d5fd65ffe522a$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $1c4d5fd65ffe522a$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $1c4d5fd65ffe522a$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $1c4d5fd65ffe522a$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $1c4d5fd65ffe522a$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $1c4d5fd65ffe522a$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $1c4d5fd65ffe522a$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $1c4d5fd65ffe522a$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $1c4d5fd65ffe522a$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $1c4d5fd65ffe522a$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $1c4d5fd65ffe522a$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $1c4d5fd65ffe522a$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $1c4d5fd65ffe522a$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$1c4d5fd65ffe522a$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $1c4d5fd65ffe522a$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $1c4d5fd65ffe522a$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $1c4d5fd65ffe522a$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $1c4d5fd65ffe522a$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $1c4d5fd65ffe522a$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $1c4d5fd65ffe522a$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $1c4d5fd65ffe522a$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $1c4d5fd65ffe522a$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $1c4d5fd65ffe522a$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $1c4d5fd65ffe522a$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $1c4d5fd65ffe522a$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $1c4d5fd65ffe522a$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $1c4d5fd65ffe522a$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $1c4d5fd65ffe522a$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $1c4d5fd65ffe522a$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $1c4d5fd65ffe522a$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $1c4d5fd65ffe522a$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $1c4d5fd65ffe522a$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $1c4d5fd65ffe522a$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $1c4d5fd65ffe522a$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $1c4d5fd65ffe522a$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $1c4d5fd65ffe522a$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $1c4d5fd65ffe522a$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $1c4d5fd65ffe522a$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $1c4d5fd65ffe522a$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $1c4d5fd65ffe522a$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $1c4d5fd65ffe522a$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $1c4d5fd65ffe522a$var$nextPaths = /* @__PURE__ */ new Set();
var $1c4d5fd65ffe522a$var$discoveredPathsMaxSize = 1e3;
var $1c4d5fd65ffe522a$var$discoveredPaths = /* @__PURE__ */ new Set();
var $1c4d5fd65ffe522a$export$b5915cf27fa06b9f = 7680;
function $1c4d5fd65ffe522a$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $1c4d5fd65ffe522a$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
var $1c4d5fd65ffe522a$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
var $1c4d5fd65ffe522a$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $1c4d5fd65ffe522a$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    let ancestorCount = Math.max(segmentCount - 1, 0);
    return ancestorCount * pathname.length + 1 > $1c4d5fd65ffe522a$export$b5915cf27fa06b9f || segmentCount > $1c4d5fd65ffe522a$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $1c4d5fd65ffe522a$var$MANIFEST_MATCH_COST_LIMIT;
}
function $1c4d5fd65ffe522a$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $1c4d5fd65ffe522a$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $1c4d5fd65ffe522a$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$1c4d5fd65ffe522a$export$741d98b28dbfd(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($1c4d5fd65ffe522a$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $1c4d5fd65ffe522a$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $1c4d5fd65ffe522a$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $1c4d5fd65ffe522a$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $eF4cA.useEffect(()=>{
        if (!$1c4d5fd65ffe522a$export$741d98b28dbfd(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$1c4d5fd65ffe522a$var$discoveredPaths.has(pathname)) $1c4d5fd65ffe522a$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($1c4d5fd65ffe522a$var$nextPaths.keys()).filter((path)=>{
                if ($1c4d5fd65ffe522a$var$discoveredPaths.has(path)) {
                    $1c4d5fd65ffe522a$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $1c4d5fd65ffe522a$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $1c4d5fd65ffe522a$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $1c4d5fd65ffe522a$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $1c4d5fd65ffe522a$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $1c4d5fd65ffe522a$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $1c4d5fd65ffe522a$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $1c4d5fd65ffe522a$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($1c4d5fd65ffe522a$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $1c4d5fd65ffe522a$export$b5915cf27fa06b9f) {
        $1c4d5fd65ffe522a$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($1c4d5fd65ffe522a$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($1c4d5fd65ffe522a$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($1c4d5fd65ffe522a$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$1c4d5fd65ffe522a$var$addToFifoQueue(p, $1c4d5fd65ffe522a$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $1c4d5fd65ffe522a$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $1c4d5fd65ffe522a$var$addToFifoQueue(path, queue) {
    if (queue.size >= $1c4d5fd65ffe522a$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $1c4d5fd65ffe522a$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $1c4d5fd65ffe522a$var$useDataRouterContext2() {
    let context = $eF4cA.useContext($1c4d5fd65ffe522a$export$2eeee58951ff3c1c);
    $1c4d5fd65ffe522a$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $1c4d5fd65ffe522a$var$useDataRouterStateContext() {
    let context = $eF4cA.useContext($1c4d5fd65ffe522a$export$315e3ffb01f217);
    $1c4d5fd65ffe522a$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $1c4d5fd65ffe522a$export$208d6a3bc3aa62bd = $eF4cA.createContext(void 0);
$1c4d5fd65ffe522a$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $1c4d5fd65ffe522a$var$useFrameworkContext() {
    let context = $eF4cA.useContext($1c4d5fd65ffe522a$export$208d6a3bc3aa62bd);
    $1c4d5fd65ffe522a$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $1c4d5fd65ffe522a$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $eF4cA.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $eF4cA.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $eF4cA.useRef(null);
    $eF4cA.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $eF4cA.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $1c4d5fd65ffe522a$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $1c4d5fd65ffe522a$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $1c4d5fd65ffe522a$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $1c4d5fd65ffe522a$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $1c4d5fd65ffe522a$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $1c4d5fd65ffe522a$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $1c4d5fd65ffe522a$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$1c4d5fd65ffe522a$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $1c4d5fd65ffe522a$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $1c4d5fd65ffe522a$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $1c4d5fd65ffe522a$var$useDataRouterStateContext();
    let matches = $1c4d5fd65ffe522a$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $eF4cA.createElement("style", {
        [$1c4d5fd65ffe522a$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $eF4cA.createElement("link", {
        [$1c4d5fd65ffe522a$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$1c4d5fd65ffe522a$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $eF4cA.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $1c4d5fd65ffe522a$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $1c4d5fd65ffe522a$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let { router: router } = $1c4d5fd65ffe522a$var$useDataRouterContext2();
    let matches = $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $1c4d5fd65ffe522a$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $eF4cA.useState([]);
    $eF4cA.useEffect(()=>{
        let interrupted = false;
        $1c4d5fd65ffe522a$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $1c4d5fd65ffe522a$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let { future: future } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let { basename: basename } = $1c4d5fd65ffe522a$var$useDataRouterContext2();
    let dataHrefs = $eF4cA.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $1c4d5fd65ffe522a$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $eF4cA.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $1c4d5fd65ffe522a$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let { basename: basename } = $1c4d5fd65ffe522a$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $1c4d5fd65ffe522a$var$useDataRouterStateContext();
    let newMatchesForData = $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $eF4cA.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $1c4d5fd65ffe522a$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $eF4cA.useMemo(()=>$1c4d5fd65ffe522a$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $1c4d5fd65ffe522a$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $eF4cA.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $eF4cA.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $eF4cA.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $1c4d5fd65ffe522a$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $1c4d5fd65ffe522a$var$useDataRouterStateContext();
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let _matches = $1c4d5fd65ffe522a$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$1c4d5fd65ffe522a$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $eF4cA.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $eF4cA.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $eF4cA.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $eF4cA.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $1c4d5fd65ffe522a$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $eF4cA.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $1c4d5fd65ffe522a$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $1c4d5fd65ffe522a$var$isHydrated = false;
function $1c4d5fd65ffe522a$export$3be068dde909e563() {
    $1c4d5fd65ffe522a$var$isHydrated = true;
}
function $1c4d5fd65ffe522a$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $1c4d5fd65ffe522a$var$useDataRouterContext2();
    let { matches: routerMatches } = $1c4d5fd65ffe522a$var$useDataRouterStateContext();
    let isRSCRouterContext = $1c4d5fd65ffe522a$var$useIsRSCRouterContext();
    let enableFogOfWar = $1c4d5fd65ffe522a$export$741d98b28dbfd(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $1c4d5fd65ffe522a$var$getActiveMatches(routerMatches, null, isSpaMode);
    $eF4cA.useEffect(()=>{
        $1c4d5fd65ffe522a$export$3be068dde909e563();
    }, []);
    let initialScripts = $eF4cA.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $1c4d5fd65ffe522a$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($1c4d5fd65ffe522a$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, /* @__PURE__ */ $eF4cA.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $eF4cA.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $1c4d5fd65ffe522a$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($1c4d5fd65ffe522a$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $1c4d5fd65ffe522a$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $1c4d5fd65ffe522a$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $eF4cA.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $eF4cA.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $eF4cA.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $eF4cA.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $1c4d5fd65ffe522a$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $1c4d5fd65ffe522a$export$32e57f52df4b6e34 = class extends $eF4cA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $1c4d5fd65ffe522a$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $eF4cA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($1c4d5fd65ffe522a$export$972111febbeef05b(error)) return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $eF4cA.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $1c4d5fd65ffe522a$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $eF4cA.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $eF4cA.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $1c4d5fd65ffe522a$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $1c4d5fd65ffe522a$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $eF4cA.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $eF4cA.createElement("head", null, /* @__PURE__ */ $eF4cA.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $eF4cA.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $eF4cA.createElement("title", null, title)), /* @__PURE__ */ $eF4cA.createElement("body", null, /* @__PURE__ */ $eF4cA.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$ff0bf87698939488, null) : null)));
}
var $1c4d5fd65ffe522a$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($1c4d5fd65ffe522a$var$isBrowser2) window.__reactRouterVersion = "7.18.5";
} catch (e) {}
function $1c4d5fd65ffe522a$export$1f3f55432a00e06d(routes, opts) {
    return $1c4d5fd65ffe522a$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $1c4d5fd65ffe522a$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $1c4d5fd65ffe522a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $1c4d5fd65ffe522a$export$9269a41d8c4635e,
        hydrationRouteProperties: $1c4d5fd65ffe522a$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $1c4d5fd65ffe522a$export$1ba7ed8a3a7b3765(routes, opts) {
    return $1c4d5fd65ffe522a$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $1c4d5fd65ffe522a$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $1c4d5fd65ffe522a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $1c4d5fd65ffe522a$export$9269a41d8c4635e,
        hydrationRouteProperties: $1c4d5fd65ffe522a$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $1c4d5fd65ffe522a$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $1c4d5fd65ffe522a$var$deserializeErrors(state.errors)
    };
    return state;
}
function $1c4d5fd65ffe522a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $1c4d5fd65ffe522a$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $1c4d5fd65ffe522a$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $1c4d5fd65ffe522a$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $eF4cA.useRef();
    if (historyRef.current == null) historyRef.current = $1c4d5fd65ffe522a$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eF4cA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eF4cA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $eF4cA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $eF4cA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $1c4d5fd65ffe522a$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $eF4cA.useRef();
    if (historyRef.current == null) historyRef.current = $1c4d5fd65ffe522a$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eF4cA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eF4cA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $eF4cA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $eF4cA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $1c4d5fd65ffe522a$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $eF4cA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eF4cA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $eF4cA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $eF4cA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$1c4d5fd65ffe522a$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $1c4d5fd65ffe522a$export$a6c7ac8248d6e38a = $eF4cA.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $1c4d5fd65ffe522a$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $1c4d5fd65ffe522a$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $1c4d5fd65ffe522a$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $1c4d5fd65ffe522a$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $1c4d5fd65ffe522a$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $1c4d5fd65ffe522a$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $1c4d5fd65ffe522a$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $eF4cA.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $1c4d5fd65ffe522a$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, link, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$1c4d5fd65ffe522a$export$a6c7ac8248d6e38a.displayName = "Link";
var $1c4d5fd65ffe522a$export$b0d92dbee9b5b60d = $eF4cA.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $1c4d5fd65ffe522a$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let routerState = $eF4cA.useContext($1c4d5fd65ffe522a$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1c4d5fd65ffe522a$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$1c4d5fd65ffe522a$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $1c4d5fd65ffe522a$export$a7fed597f4b8afd8 = $eF4cA.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $1c4d5fd65ffe522a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let submit = $1c4d5fd65ffe522a$export$47c85c6e3a081d3();
    let formAction = $1c4d5fd65ffe522a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $1c4d5fd65ffe522a$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $eF4cA.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $eF4cA.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$1c4d5fd65ffe522a$export$a7fed597f4b8afd8.displayName = "Form";
function $1c4d5fd65ffe522a$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$208d6a3bc3aa62bd);
    let { basename: basename } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let matches = $1c4d5fd65ffe522a$export$2378eb7f5ff86053();
    $1c4d5fd65ffe522a$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $eF4cA.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $1c4d5fd65ffe522a$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $eF4cA.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$1c4d5fd65ffe522a$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $1c4d5fd65ffe522a$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$1c4d5fd65ffe522a$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$1c4d5fd65ffe522a$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $1c4d5fd65ffe522a$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $1c4d5fd65ffe522a$var$useDataRouterContext3(hookName) {
    let ctx = $eF4cA.useContext($1c4d5fd65ffe522a$export$2eeee58951ff3c1c);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(ctx, $1c4d5fd65ffe522a$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $1c4d5fd65ffe522a$var$useDataRouterState2(hookName) {
    let state = $eF4cA.useContext($1c4d5fd65ffe522a$export$315e3ffb01f217);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(state, $1c4d5fd65ffe522a$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $1c4d5fd65ffe522a$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $1c4d5fd65ffe522a$export$9770f232ac06a008();
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let path = $1c4d5fd65ffe522a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $eF4cA.useCallback((event)=>{
        if ($1c4d5fd65ffe522a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $1c4d5fd65ffe522a$export$fe53371bee54353d(location) === $1c4d5fd65ffe522a$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $eF4cA.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $1c4d5fd65ffe522a$export$f1a78c17382fe22a(defaultInit) {
    $1c4d5fd65ffe522a$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $eF4cA.useRef($1c4d5fd65ffe522a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eF4cA.useRef(false);
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let searchParams = $eF4cA.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $1c4d5fd65ffe522a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $1c4d5fd65ffe522a$export$9770f232ac06a008();
    let setSearchParams = $eF4cA.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $1c4d5fd65ffe522a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $1c4d5fd65ffe522a$var$fetcherId = 0;
var $1c4d5fd65ffe522a$var$getUniqueFetcherId = ()=>`__${String(++$1c4d5fd65ffe522a$var$fetcherId)}__`;
function $1c4d5fd65ffe522a$export$47c85c6e3a081d3() {
    let { router: router } = $1c4d5fd65ffe522a$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let currentRouteId = $1c4d5fd65ffe522a$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $eF4cA.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $1c4d5fd65ffe522a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $1c4d5fd65ffe522a$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $1c4d5fd65ffe522a$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let routeContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$1c4d5fd65ffe522a$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $1c4d5fd65ffe522a$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $1c4d5fd65ffe522a$export$fe53371bee54353d(path);
}
function $1c4d5fd65ffe522a$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $1c4d5fd65ffe522a$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $1c4d5fd65ffe522a$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $eF4cA.useContext($1c4d5fd65ffe522a$export$cb3f1df1bef00a39);
    let route = $eF4cA.useContext($1c4d5fd65ffe522a$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $1c4d5fd65ffe522a$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $eF4cA.useId();
    let [fetcherKey, setFetcherKey] = $eF4cA.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $eF4cA.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $eF4cA.useCallback(async (href, opts)=>{
        $1c4d5fd65ffe522a$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $1c4d5fd65ffe522a$export$47c85c6e3a081d3();
    let submit = $eF4cA.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $eF4cA.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $eF4cA.useMemo(()=>{
        let FetcherForm2 = $eF4cA.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $1c4d5fd65ffe522a$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eF4cA.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $1c4d5fd65ffe522a$export$fa996778a3a31087() {
    let state = $1c4d5fd65ffe522a$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $eF4cA.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $1c4d5fd65ffe522a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $1c4d5fd65ffe522a$var$savedScrollPositions = {};
function $1c4d5fd65ffe522a$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $1c4d5fd65ffe522a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $1c4d5fd65ffe522a$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $1c4d5fd65ffe522a$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $1c4d5fd65ffe522a$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $eF4cA.useContext($1c4d5fd65ffe522a$export$3044ab7fdabeaee6);
    let location = $1c4d5fd65ffe522a$export$45d76561a5302f2b();
    let matches = $1c4d5fd65ffe522a$export$2378eb7f5ff86053();
    let navigation = $1c4d5fd65ffe522a$export$d0fd4b7106de2769();
    $eF4cA.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $1c4d5fd65ffe522a$var$usePageHide($eF4cA.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $1c4d5fd65ffe522a$var$getScrollRestorationKey(location, matches, basename, getKey);
            $1c4d5fd65ffe522a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $1c4d5fd65ffe522a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($1c4d5fd65ffe522a$var$savedScrollPositions));
        } catch (error) {
            $1c4d5fd65ffe522a$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $eF4cA.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $1c4d5fd65ffe522a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $1c4d5fd65ffe522a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $eF4cA.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($1c4d5fd65ffe522a$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$1c4d5fd65ffe522a$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $eF4cA.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $1c4d5fd65ffe522a$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $1c4d5fd65ffe522a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eF4cA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $1c4d5fd65ffe522a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eF4cA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $1c4d5fd65ffe522a$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $1c4d5fd65ffe522a$export$b273b3273281a049(when);
    $eF4cA.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eF4cA.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $1c4d5fd65ffe522a$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $eF4cA.useContext($1c4d5fd65ffe522a$export$3681f408decb40d1);
    $1c4d5fd65ffe522a$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $1c4d5fd65ffe522a$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $1c4d5fd65ffe522a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $1c4d5fd65ffe522a$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $1c4d5fd65ffe522a$export$81336c211d5ff295(path.pathname, nextPath) != null || $1c4d5fd65ffe522a$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $1c4d5fd65ffe522a$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $1c4d5fd65ffe522a$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $1c4d5fd65ffe522a$var$getStatelessNavigator();
    return /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $1c4d5fd65ffe522a$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $1c4d5fd65ffe522a$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $1c4d5fd65ffe522a$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $1c4d5fd65ffe522a$var$serializeErrors(context.errors)
        };
        let json = $1c4d5fd65ffe522a$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $eF4cA.createElement($eF4cA.Fragment, null, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $eF4cA.createElement($1c4d5fd65ffe522a$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $eF4cA.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $1c4d5fd65ffe522a$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($1c4d5fd65ffe522a$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $1c4d5fd65ffe522a$var$getStatelessNavigator() {
    return {
        createHref: $1c4d5fd65ffe522a$var$createHref,
        encodeLocation: $1c4d5fd65ffe522a$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $1c4d5fd65ffe522a$export$69163f0b72ec60d9(routes, opts) {
    return $1c4d5fd65ffe522a$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $1c4d5fd65ffe522a$export$9269a41d8c4635e
    });
}
function $1c4d5fd65ffe522a$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $1c4d5fd65ffe522a$export$87cb1a9238dc3fba(routes, $1c4d5fd65ffe522a$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $1c4d5fd65ffe522a$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $1c4d5fd65ffe522a$var$createHref,
        encodeLocation: $1c4d5fd65ffe522a$var$encodeLocation,
        getFetcher () {
            return $1c4d5fd65ffe522a$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $1c4d5fd65ffe522a$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $1c4d5fd65ffe522a$var$createHref(to) {
    return typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to);
}
function $1c4d5fd65ffe522a$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $1c4d5fd65ffe522a$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $1c4d5fd65ffe522a$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("AkKc4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FIREFLY_MODEL", () => $06d3743ef2c90f68$export$98ed6833bd4ce822);
$parcel$export(module.exports, "fetchFireflyImage", () => $06d3743ef2c90f68$export$cbdd9cd5b45958aa);
$parcel$export(module.exports, "generateImage", () => $06d3743ef2c90f68$export$cd2b50685893b99f);
$parcel$export(module.exports, "fetchPersonaImages", () => $06d3743ef2c90f68$export$339c278a3d27f13);
$parcel$export(module.exports, "uploadFireflyImage", () => $06d3743ef2c90f68$export$d4e593fcb21cbdb);
$parcel$export(module.exports, "pollStatus", () => $06d3743ef2c90f68$export$79a43e2fc4855cd5);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");

var $8OIwE = parcelRequire("8OIwE");

var $ubpkL = parcelRequire("ubpkL");

var $D7J7L = parcelRequire("D7J7L");

var $8PkOq = parcelRequire("8PkOq");
const $06d3743ef2c90f68$export$98ed6833bd4ce822 = "image4_ultra";
/**
 * Parallel HTTP requests allowed on the Firefly client. It has to cover the
 * generate requests *and* the status polling/upload traffic they produce.
 * `createApiClient` queues anything above this limit and backs every endpoint
 * off for the `Retry-After` window when the server answers `429`.
 */ const $06d3743ef2c90f68$var$FIREFLY_MAX_CONCURRENT_REQUESTS = 8;
const $06d3743ef2c90f68$export$289d3a940072e8b8 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/firefly"], $06d3743ef2c90f68$var$FIREFLY_MAX_CONCURRENT_REQUESTS, 5);
const $06d3743ef2c90f68$export$f0dfa2746669c3dd = {
    "/generate-3p": 2,
    "/generate-video": 2,
    default: 4
};
/** Upper bound for a `Retry-After` driven poll delay. */ const $06d3743ef2c90f68$var$MAX_POLL_DELAY_MS = 30000;
const $06d3743ef2c90f68$var$generateQueues = new Map();
const $06d3743ef2c90f68$export$602930127900147a = (generatePath)=>(0, $8OIwE.getOrCreate)($06d3743ef2c90f68$var$generateQueues, generatePath, (path)=>new (0, $8OIwE.RequestQueue)({
            name: `firefly${path}`,
            maxConcurrent: $06d3743ef2c90f68$export$f0dfa2746669c3dd[path] ?? $06d3743ef2c90f68$export$f0dfa2746669c3dd.default
        }));
const $06d3743ef2c90f68$export$2a5e65246dd10c96 = (modelVersion)=>{
    switch(modelVersion){
        case "image5":
            return "/generate-v5";
        case "nano-banana":
        case "nano-banana-2":
        case "nano-banana-3":
            return "/generate-3p";
        case "video1_standard":
        case "video1_8_standard":
            return "/generate-video";
        default:
            return "/generate";
    }
};
const $06d3743ef2c90f68$export$cbdd9cd5b45958aa = async (storyId, body)=>{
    const images = [];
    const email = (0, $8PkOq.IMS).userProfile?.email;
    const basePath = email ? `${email.split("@")[0]}/stories/${storyId}/firefly/` : null;
    const defaultS3FilePath = basePath ? `${basePath}${self.crypto.randomUUID()}.jpg` : undefined;
    // Step 1: Generate and extract images from Firefly API (persisting to S3 during poll when possible)
    const { outputs: outputs, images: legacyImages } = await $06d3743ef2c90f68$export$cd2b50685893b99f({
        ...body,
        ...defaultS3FilePath ? {
            s3FilePath: defaultS3FilePath
        } : {}
    });
    const fireflyImages = outputs ?? legacyImages;
    // Step 2: Use backend-persisted S3 data when available, or upload remaining images to S3
    if (fireflyImages?.length > 0) {
        const s3UploadPromises = fireflyImages.map((image)=>{
            if (image.filePath && image.presignURL) return Promise.resolve({
                filePath: image.filePath,
                presignURL: image.presignURL
            });
            const filePath = `${basePath}${self.crypto.randomUUID()}.jpg`;
            return (0, $D7J7L.uploadFileByURL)(filePath, image.url);
        });
        const s3Files = await Promise.all(s3UploadPromises);
        s3Files.forEach((file)=>{
            // Response structure: { success: true, data: { filePath, presignURL } }
            const fileData = file.data || file; // Support both wrapped and unwrapped responses
            images.push({
                url: fileData.presignURL,
                path: fileData.filePath
            });
        });
    }
    return images;
};
const $06d3743ef2c90f68$export$339c278a3d27f13 = async (storyId, persona, imageReference)=>{
    const { avatarPrompt: avatarPrompt } = persona;
    return Promise.all([
        $06d3743ef2c90f68$export$cbdd9cd5b45958aa(storyId, {
            model: $06d3743ef2c90f68$export$98ed6833bd4ce822,
            prompt: avatarPrompt,
            negativePrompt: "texts on the image, blurry, low quality, bad lighting, bad composition",
            contentClass: "photo",
            size: {
                width: 2048,
                height: 2048
            },
            visualIntensity: 8,
            detailLevel: "full",
            style: {
                presets: [
                    "closeup"
                ],
                strength: 50,
                ...imageReference ? {
                    imageReference: {
                        source: {
                            ...imageReference.url ? {
                                url: imageReference.url
                            } : {},
                            ...imageReference.uploadId ? {
                                uploadId: imageReference.uploadId
                            } : {}
                        }
                    }
                } : {}
            }
        })
    ]);
};
const $06d3743ef2c90f68$export$d4e593fcb21cbdb = async (filePath, options = {})=>{
    const response = await $06d3743ef2c90f68$export$289d3a940072e8b8.post("/upload", {
        filePath: filePath
    }, options);
    if (!response.ok) throw new Error("Failed to upload Firefly image", {
        cause: response
    });
    return response.data;
};
const $06d3743ef2c90f68$export$79a43e2fc4855cd5 = async ({ statusUrl: statusUrl, shouldSave: shouldSave, modelVersion: modelVersion, s3FilePath: s3FilePath } = {}, options = {})=>{
    const pollPath = modelVersion === "image5" ? "/poll-status-v5" : "/poll-status";
    const pollBody = {
        statusUrl: statusUrl,
        ...modelVersion === "image5" ? {
            shouldSave: shouldSave === true || shouldSave === "true"
        } : {},
        ...s3FilePath ? {
            s3FilePath: s3FilePath
        } : {}
    };
    return $06d3743ef2c90f68$export$289d3a940072e8b8.post(pollPath, pollBody, options);
};
const $06d3743ef2c90f68$export$cd2b50685893b99f = async (body, options = {}, statusCallback = null)=>{
    const generatePath = $06d3743ef2c90f68$export$2a5e65246dd10c96(body.modelVersion);
    return $06d3743ef2c90f68$export$602930127900147a(generatePath).run(()=>$06d3743ef2c90f68$var$runGenerateJob(generatePath, body, options, statusCallback), {
        signal: options.signal
    });
};
const $06d3743ef2c90f68$var$runGenerateJob = async (generatePath, body, options, statusCallback)=>{
    const { s3FilePath: s3FilePath, ...generateBody } = body ?? {};
    const generateResponse = await $06d3743ef2c90f68$export$289d3a940072e8b8.post(generatePath, generateBody, options);
    if (!generateResponse.ok) throw new Error("Failed to generate Firefly image", {
        cause: generateResponse
    });
    const statusUrl = generateResponse.data?.links?.result?.href ?? generateResponse.data?.statusUrl;
    if (!statusUrl) throw new Error("Missing statusUrl in generate response", {
        cause: generateResponse
    });
    // Step 2: Poll for job status using statusUrl in a loop until success
    let jobResult = null;
    let attempts = 0;
    const maxAttempts = 120;
    const initialPollDelay = 2000; // Wait 2s before first poll since generation never finishes in <2s
    const pollDelay = 1500; // 1.5s interval
    const shouldSave = body.shouldSave === true || body.shouldSave === "true";
    await (0, $ubpkL.backgroundDelay)(initialPollDelay, {
        signal: options.signal
    });
    while(attempts < maxAttempts){
        attempts++;
        const pollResponse = await $06d3743ef2c90f68$export$79a43e2fc4855cd5({
            statusUrl: statusUrl,
            shouldSave: shouldSave,
            modelVersion: body.modelVersion,
            s3FilePath: s3FilePath
        }, options);
        if (!pollResponse.ok && pollResponse.status !== 429) throw new Error("Failed to poll job status", {
            cause: pollResponse
        });
        jobResult = pollResponse.data;
        if (jobResult?.outputs?.length > 0 || jobResult?.result?.outputs?.length > 0) break;
        if (jobResult?.progress) console.log(`Job processing... progress: ${jobResult.progress}% (attempt ${attempts}/${maxAttempts})`);
        else if (jobResult?.status) console.log(`Job processing... status: ${jobResult.status} (attempt ${attempts}/${maxAttempts})`);
        statusCallback?.(jobResult);
        const delay = Math.max(pollDelay, Math.min((0, $8OIwE.getRetryAfterMs)(pollResponse) ?? 0, $06d3743ef2c90f68$var$MAX_POLL_DELAY_MS));
        // Wait before polling again (worker-backed)
        await (0, $ubpkL.backgroundDelay)(delay, {
            signal: options.signal
        });
    }
    if (attempts >= maxAttempts) throw new Error(`Job timed out after ${attempts} attempts`);
    // Step 3: Extract outputs from job result
    const outputs = [];
    for (const output of jobResult?.outputs ?? jobResult?.result?.outputs ?? []){
        const s3Data = output?.s3 ?? jobResult?.s3 ?? null;
        const imageUrl = output?.image?.presignedUrl ?? output?.image?.url;
        if (imageUrl) outputs.push({
            kind: "image",
            url: s3Data?.presignURL ?? imageUrl,
            filePath: s3Data?.filePath ?? null,
            presignURL: s3Data?.presignURL ?? null,
            seed: output?.seed ?? 0,
            fireflyId: output?.image?.id ?? null,
            creativeCloudFileId: output?.image?.creativeCloudFileId ?? null
        });
        const videoUrl = output?.video?.presignedUrl ?? output?.video?.url;
        if (videoUrl) outputs.push({
            kind: "video",
            url: s3Data?.presignURL ?? videoUrl,
            filePath: s3Data?.filePath ?? null,
            presignURL: s3Data?.presignURL ?? null,
            seed: output?.seed ?? 0,
            fireflyId: output?.video?.id ?? null,
            creativeCloudFileId: output?.video?.creativeCloudFileId ?? null
        });
    }
    // Check if we have at least one output
    if (outputs.length === 0) throw new Error("No valid outputs were found in the response");
    return {
        success: true,
        outputs: outputs
    };
};

});

parcelRegister("dYPl9", function(module, exports) {

$parcel$export(module.exports, "getElements", () => $a2d8b405034c7c7d$export$73eac51a39d6b0eb);
$parcel$export(module.exports, "getBrands", () => $a2d8b405034c7c7d$export$b4742ff7ccdcdcf0);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $a2d8b405034c7c7d$var$MAX_CONCURRENT_REQUESTS = 50;
const $a2d8b405034c7c7d$export$95203b2341932fd6 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/ccLibrariesProxy"], $a2d8b405034c7c7d$var$MAX_CONCURRENT_REQUESTS);
const $a2d8b405034c7c7d$export$73eac51a39d6b0eb = async (data = {}, options = {})=>{
    const response = await $a2d8b405034c7c7d$export$95203b2341932fd6.post("", {
        baseUrl: "https://platform-cs-edge.adobe.io",
        method: "GET",
        path: `/api/v1/libraries/${data.libraryId}/elements`,
        queryParams: {
            selector: data.selector ?? "details",
            limit: data.limit ?? 10,
            start: data.start ?? 0,
            orderBy: data.orderBy ?? "-modified_date"
        }
    }, options);
    if (!response.ok) {
        const errorMsg = `Failed to fetch brand libraries for libraryId: ${data.libraryId}. Status: ${response.status}`;
        console.error(errorMsg, response);
        throw new Error(errorMsg, {
            cause: response
        });
    }
    return response?.data?.data;
};
const $a2d8b405034c7c7d$export$b80d5513bcafc6b2 = async (data = {})=>{
    const response = await $a2d8b405034c7c7d$export$95203b2341932fd6.post("", {
        baseUrl: "https://platform-cs-edge.adobe.io",
        method: "GET",
        path: `/api/v1/libraries/${data.libraryId}`,
        queryParams: {
            selector: data.selector ?? "details",
            limit: data.limit ?? 10,
            start: data.start ?? 0,
            orderBy: data.orderBy ?? "-modified_date"
        }
    });
    if (!response.ok) throw new Error("Failed to fetch brand libraries", response);
    return response?.data?.data;
};
const $a2d8b405034c7c7d$export$b4742ff7ccdcdcf0 = async ()=>{
    const response = await $a2d8b405034c7c7d$export$95203b2341932fd6.post("", {
        baseUrl: "https://libraries.adobe.io",
        method: "POST",
        path: "/api/v1/search",
        data: {
            limit: 25,
            start: 0,
            orderBy: "-modified_date",
            owner: "private,incoming,outgoing",
            selector: "full",
            library_roles_type: [
                "brand"
            ],
            asset_type: [
                "library"
            ]
        }
    });
    if (!response.ok) throw new Error("Failed to fetch brand libraries", response);
    return response?.data?.data?.libraries ?? [];
};

});



parcelRegister("1B1zl", function(module, exports) {

$parcel$export(module.exports, "retry", () => $129a76c120002d4f$export$9369b12211e1fce4);
$parcel$export(module.exports, "queryClient", () => $129a76c120002d4f$export$7c07b633a151f9c5);
$parcel$export(module.exports, "asyncStoragePersister", () => $129a76c120002d4f$export$8b7e543dc151abd3);
// Workaround for Parcel scopeHoist: false - use namespace import

var $kVoiX = parcelRequire("kVoiX");

var $15l6m = parcelRequire("15l6m");
var $a8tBG = parcelRequire("a8tBG");

var $ekEvR = parcelRequire("ekEvR");

var $7f2AL = parcelRequire("7f2AL");

var $fmJ8d = parcelRequire("fmJ8d");

var $8OIwE = parcelRequire("8OIwE");
/**
 * How many times a rate limited (`429`) request is retried by react-query.
 * Each attempt waits for the server requested `Retry-After` window and is
 * queued by the service layer, so it never bursts against the endpoint.
 */ const $129a76c120002d4f$var$MAX_RATE_LIMIT_RETRIES = 5;
const $129a76c120002d4f$var$delayWithJitter = (baseDelay, jitter = 0.5)=>{
    const jitterValue = baseDelay * jitter * Math.random();
    const shouldAddJitter = Math.random() < 0.5;
    return Math.floor(shouldAddJitter ? baseDelay + jitterValue : Math.max(0, baseDelay - jitterValue));
};
// A server requested cool-down is a minimum: only ever wait longer than asked,
// otherwise the retry is guaranteed to be rate limited again.
const $129a76c120002d4f$var$delayWithUpwardJitter = (baseDelay, jitter = 0.5)=>Math.floor(baseDelay + baseDelay * jitter * Math.random());
// Extract QueryClient from namespace import (works better with Parcel scopeHoist: false)
const $129a76c120002d4f$var$QueryClient = $kVoiX.QueryClient;
if (!$129a76c120002d4f$var$QueryClient || typeof $129a76c120002d4f$var$QueryClient !== "function") throw new Error("QueryClient is not available from @tanstack/react-query. This may be a Parcel bundling issue. Try setting scopeHoist: true in package.json");
const $129a76c120002d4f$export$9369b12211e1fce4 = (number = 1)=>(failureCount, error)=>{
        if (error?.cause?.problem === "CANCEL_ERROR" || error?.cause?.status === 451 // firefly "failed"
        ) return false;
        if ((0, $8OIwE.getRetryAfterMs)(error?.cause) === null) console.warn(`Query retry attempt ${failureCount + 1} due to error:`, error);
        // Rate limited requests are retried beyond `number`: they are queued and
        // delayed by `Retry-After`, so they do not add pressure on the server.
        if (error?.cause?.status === 429 || error?.cause?.shouldRetry) return failureCount < $129a76c120002d4f$var$MAX_RATE_LIMIT_RETRIES;
        return failureCount < number;
    };
const $129a76c120002d4f$export$5a1c93015a826e4 = (number = 30000)=>(retryAttempt, error)=>{
        // Honour `Retry-After` (header, or the value carried on the error cause)
        // so a retried request does not hit the rate limit again.
        const retryAfterMs = (0, $8OIwE.getRetryAfterMs)(error?.cause);
        return retryAfterMs === null ? $129a76c120002d4f$var$delayWithJitter(Math.min(1000 * 2 ** retryAttempt, number)) : $129a76c120002d4f$var$delayWithUpwardJitter(retryAfterMs);
    };
const $129a76c120002d4f$var$getApiErrorMessage = (error)=>{
    const message = error?.cause?.message ?? error?.cause?.data?.error ?? "";
    return typeof message === "string" ? message.trim() : "";
};
const $129a76c120002d4f$var$formatErrorMessage = (baseMessage, error)=>{
    const apiMessage = $129a76c120002d4f$var$getApiErrorMessage(error);
    return apiMessage ? `${baseMessage} ${apiMessage}` : baseMessage;
};
const $129a76c120002d4f$export$7c07b633a151f9c5 = new $129a76c120002d4f$var$QueryClient({
    queryCache: new (0, $a8tBG.QueryCache)({
        onError: async (error, query)=>{
            console.warn("Query error:", query, error);
            if (query?.meta?.errorMessage) (0, $fmJ8d.store).getState().addToast($129a76c120002d4f$var$formatErrorMessage(query.meta.errorMessage, error), {
                variant: "negative",
                timeout: 60000
            });
        }
    }),
    mutationCache: new (0, $15l6m.MutationCache)({
        onError: async (error, variables, onMutateResult, mutation)=>{
            console.warn("Mutation error:", mutation, variables, error);
            if (mutation?.meta?.errorMessage) (0, $fmJ8d.store).getState().addToast($129a76c120002d4f$var$formatErrorMessage(mutation.meta.errorMessage, error), {
                variant: "negative",
                timeout: 60000
            });
        }
    }),
    defaultOptions: {
        queries: {
            gcTime: 86400000,
            retry: $129a76c120002d4f$export$9369b12211e1fce4(),
            retryDelay: $129a76c120002d4f$export$5a1c93015a826e4()
        },
        mutations: {
            retry: $129a76c120002d4f$export$9369b12211e1fce4(0),
            retryDelay: $129a76c120002d4f$export$5a1c93015a826e4()
        }
    }
});
window.__TANSTACK_QUERY_CLIENT__ = $129a76c120002d4f$export$7c07b633a151f9c5;
const $129a76c120002d4f$export$8b7e543dc151abd3 = (0, $ekEvR.createAsyncStoragePersister)({
    storage: {
        getItem: $7f2AL.get,
        setItem: $7f2AL.set,
        removeItem: $7f2AL.del,
        entries: $7f2AL.entries
    },
    serialize: (data)=>data,
    deserialize: (data)=>data
});

});
parcelRegister("kVoiX", function(module, exports) {

$parcel$export(module.exports, "QueryClient", () => $f3bbfbee745a85cb$export$405d0624ed55a03f);

var $3ur2P = parcelRequire("3ur2P");

var $h5e0l = parcelRequire("h5e0l");

var $hnhg4 = parcelRequire("hnhg4");

var $dRDEH = parcelRequire("dRDEH");

var $anR7S = parcelRequire("anR7S");

var $jd5LA = parcelRequire("jd5LA");
//#region src/queryClient.ts
/**
* `QueryClient` is used to interact with a cache of queries and mutations. It owns a
* `QueryCache` and a `MutationCache` (creating default ones if none are passed in) and holds
* the default options that are applied to queries and mutations created through it.
* @example
* ```ts
* const queryClient = new QueryClient({
*   defaultOptions: {
*     queries: {
*       staleTime: Infinity,
*     },
*   },
* })
*
* await queryClient.query({ queryKey: ['posts'], queryFn: fetchPosts })
* ```
*/ var $f3bbfbee745a85cb$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $jd5LA.QueryCache)();
        this.#mutationCache = config.mutationCache || new (0, $anR7S.MutationCache)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    /**
	* Called by a framework adapter's `QueryClientProvider`-equivalent when it mounts, to start
	* listening for focus/online events and resume paused mutations. Ref-counted via an internal
	* mount count, so nested or multiple providers sharing the same `QueryClient` don't tear down
	* the shared listeners until the last one unmounts.
	*/ mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $h5e0l.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $dRDEH.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    /**
	* The inverse of {@link QueryClient#mount} — called by a framework adapter's
	* `QueryClientProvider`-equivalent when it unmounts. Only tears down the focus/online
	* listeners once the mount count returns to `0`.
	*/ unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    /**
	* Returns the number of queries in the cache that are currently fetching, optionally
	* matching a set of filters. This includes background-fetching, loading new pages, and
	* loading more infinite query results.
	* @param filters - Narrows down which fetching queries are counted. Without filters, every
	* fetching query is counted.
	* @returns The number of matching queries whose `fetchStatus` is `'fetching'`.
	* @example
	* ```ts
	* if (queryClient.isFetching()) {
	*   console.log('At least one query is fetching!')
	* }
	* ```
	*/ isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    /**
	* Returns the number of mutations in the cache that are currently pending, optionally
	* matching a set of filters.
	* @param filters - Narrows down which pending mutations are counted. Without filters, every
	* pending mutation is counted.
	* @returns The number of matching mutations whose `status` is `'pending'`.
	* @example
	* ```ts
	* if (queryClient.isMutating()) {
	*   console.log('At least one mutation is pending!')
	* }
	* ```
	*/ isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
	* Imperative (non-reactive) way to retrieve data for a QueryKey.
	* Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
	*
	* Hint: Do not use this function inside a component, because it won't receive updates.
	* Use `useQuery` to create a `QueryObserver` that subscribes to changes.
	* @param queryKey - The query key of the query to read.
	* @returns The cached data for the query, or `undefined` if no query with this key has been observed yet.
	* @see {@link QueryClient#getQueriesData}
	*/ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    /**
	* Returns the cached data of a query, or fetches it if there is none. With `revalidateIfStale`,
	* stale cached data is also refetched in the background.
	* @param options - The query options. If the query has no cached data yet, it is fetched with
	* these options.
	* @returns A promise that resolves to the cached data, or to the fetched data if nothing was
	* cached yet.
	* @deprecated Use queryClient.query({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $3ur2P.resolveQueryValue)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    /**
	* Imperative (non-reactive) way to retrieve the cached data of multiple queries at once.
	* Only queries matching the given filters are returned; if none match, an empty array is
	* returned.
	*
	* Because the matched queries can hold data of different shapes (e.g. a broad filter can match
	* queries with unrelated data types), the `TQueryFnData` generic defaults to `unknown` rather
	* than being inferred. Passing a more specific type is a convenience for call sites that know
	* every matched query holds the same shape — it is not checked against the actual cache
	* contents.
	* @param filters - The filters that select which queries to read.
	* @returns An array of query key and data pairs. The data is `undefined` for a query with no cached data.
	* @see {@link QueryClient#getQueryData}
	* @example
	* ```ts
	* const data = queryClient.getQueriesData({ queryKey: ['posts'] })
	* ```
	*/ getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            return [
                queryKey,
                state.data
            ];
        });
    }
    /**
	* Synchronous way to immediately update a query's cached data. If the updater (or the value
	* passed) resolves to `undefined`, the cache is left untouched and no query is created;
	* otherwise, if the query does not exist yet, it will be created. To update multiple queries
	* at once by partially matching query keys, use {@link QueryClient#setQueriesData} instead.
	*
	* Updates must be performed immutably: do not mutate `oldData`, or data previously retrieved
	* via {@link QueryClient#getQueryData}, in place.
	* @param queryKey - The query key to set data for.
	* @param updater - Either the new data, or a function that receives the current data (which
	* may be `undefined`) and returns the new data.
	* @param options - Set `updatedAt` to override the timestamp the written data is recorded with.
	* @returns The data that was written, or `undefined` if the updater returned `undefined` — in that case
	* the write is skipped and the cache is left unchanged.
	* @example
	* ```ts
	* queryClient.setQueryData(['posts'], newPosts)
	*
	* // Or, using an updater function that receives the current data:
	* queryClient.setQueryData(['posts'], (oldPosts) => [...oldPosts, newPost])
	* ```
	*/ setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const prevData = this.#queryCache.get(defaultedOptions.queryHash)?.state.data;
        const data = (0, $3ur2P.functionalUpdate)(updater, prevData);
        if (data === void 0) return;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
	* Synchronous way to immediately update the cached data of multiple queries at once, using
	* filters or partial query key matching. Only queries that already exist and match the given
	* filters are updated; no new cache entries are created. Internally this calls
	* {@link QueryClient#setQueryData} for each matching query.
	* @param filters - The filters that select which existing queries to update.
	* @param updater - Either the new data, or a function that receives each matched query's current
	* data (which may be `undefined`) and returns the new data.
	* @param options - Set `updatedAt` to override the timestamp the written data is recorded with.
	* @returns One `[queryKey, data]` tuple per matched query, in the same shape and with the same
	* `undefined` case as {@link QueryClient#setQueryData}.
	* @example
	* ```ts
	* queryClient.setQueriesData({ queryKey: ['posts'] }, (oldPosts) =>
	*   oldPosts ? oldPosts.filter((post) => post.id !== deletedId) : oldPosts,
	* )
	* ```
	*/ setQueriesData(filters, updater, options) {
        return (0, $hnhg4.notifyManager).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    /**
	* Imperative (non-reactive) way to retrieve an existing query's state. If the query does not
	* exist, `undefined` is returned.
	* @param queryKey - The query key of the query to read.
	* @returns The query's state, or `undefined` if no query with this key exists.
	* @example
	* ```ts
	* const state = queryClient.getQueryState(['posts'])
	* console.log(state?.dataUpdatedAt)
	* ```
	*/ getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    /**
	* Removes queries from the cache that match the given filters. Unlike
	* {@link QueryClient#invalidateQueries} or {@link QueryClient#refetchQueries}, this removes
	* matching queries from the cache instead of refetching them. Without filters, every query in
	* the cache is removed.
	* @param filters - The filters that select which queries to remove. Without filters, every query
	* is removed.
	* @example
	* ```ts
	* queryClient.removeQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $hnhg4.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
	* Resets queries matching the given filters back to their initial state (e.g. any
	* `initialData`), notifying subscribers rather than removing them. Active queries among the
	* matched set are then refetched, and the returned promise resolves once that refetch settles.
	* @param filters - The filters that select which queries to reset. Without filters, every query
	* is reset.
	* @param options - Passed to the refetch of the active matched queries, e.g. `cancelRefetch` and
	* `throwOnError`.
	* @returns A promise that resolves once the refetch of the active matched queries settles.
	* @example
	* ```ts
	* await queryClient.resetQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $hnhg4.notifyManager).batch(()=>{
            const matched = queryCache.findAll(filters);
            const queriesToRefetch = new Set(matched);
            matched.forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                predicate: (query)=>queriesToRefetch.has(query)
            }, options);
        });
    }
    /**
	* Cancels outgoing fetches for queries matching the given filters. Most useful when performing
	* optimistic updates, since any outgoing refetch that resolves afterwards would otherwise
	* overwrite the optimistic update. By default (`revert: true`), a cancelled query's data is
	* reverted to its state before the outgoing fetch started.
	*
	* The returned promise never rejects, even if individual cancellations fail.
	* @param filters - The filters that select which queries to cancel. Without filters, every query
	* is cancelled.
	* @param cancelOptions - Passed to each matched query's cancellation. `revert` defaults to
	* `true`.
	* @returns A promise that resolves once every cancellation has settled.
	* @example
	* ```ts
	* await queryClient.cancelQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $hnhg4.notifyManager).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $3ur2P.noop)).catch((0, $3ur2P.noop));
    }
    /**
	* Marks queries matching the given filters as invalidated. Unlike
	* {@link QueryClient#removeQueries}, invalidated queries stay in the cache.
	*
	* Unless `filters.refetchType` is `'none'`, matching queries are then refetched via
	* {@link QueryClient#refetchQueries}, using `filters.refetchType` if set, otherwise
	* `filters.type`, otherwise `'active'`.
	* @param filters - The filters that select which queries to invalidate, plus `refetchType` to
	* control which of them to refetch afterwards. Without filters, every query is invalidated.
	* @param options - Passed to {@link QueryClient#refetchQueries}, e.g. `cancelRefetch` and
	* `throwOnError`.
	* @returns A promise that resolves once the refetch settles, or immediately if `refetchType` is
	* `'none'`.
	* @example
	* ```ts
	* await queryClient.invalidateQueries({ queryKey: ['posts'], refetchType: 'active' })
	* ```
	*/ invalidateQueries(filters, options = {}) {
        return (0, $hnhg4.notifyManager).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    /**
	* Refetches queries matching the given filters, regardless of whether they are stale. Without
	* filters, every query in the cache is refetched. Queries that are disabled, or static (only
	* have observers with a static `staleTime`), are never refetched.
	*
	* By default (`cancelRefetch: true`), a currently running fetch is cancelled before the new
	* one starts. The returned promise resolves once all matching queries have settled; it does
	* not reject on individual query failures unless `throwOnError` is set.
	* @param filters - The filters that select which queries to refetch. Without filters, every query
	* in the cache is included.
	* @param options - Set `cancelRefetch` to `false` to keep a running fetch instead of cancelling
	* it, and `throwOnError` to `true` to reject when a refetch fails.
	* @returns A promise that resolves once every matched query has settled.
	* @example
	* ```ts
	* // refetch all active queries partially matching a query key:
	* await queryClient.refetchQueries({ queryKey: ['posts'], type: 'active' })
	* ```
	*/ refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $hnhg4.notifyManager).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $3ur2P.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $3ur2P.noop));
    }
    /**
	* Asynchronous method to fetch and cache a query, resolving with the data or throwing with
	* the error.
	*
	* If the query already exists in the cache and its data is not stale (per the given
	* `staleTime`), the cached data is returned without fetching. Otherwise, the query is fetched
	* and the promise resolves once the fetch settles. If a `select` function is provided, it is
	* applied to the data in both cases (cached or freshly fetched) before it is returned.
	*
	* Unlike a reactive observer, retries are disabled by default here (`retry: false`) unless
	* explicitly configured, since there is no component to catch a thrown error and retry through
	* re-render.
	*
	* The accepted options are `QueryObserverOptions` minus the fields that only make sense for a
	* reactive observer — `enabled`, `refetchInterval`, `refetchIntervalInBackground`,
	* `refetchOnWindowFocus`, `refetchOnReconnect`, `refetchOnMount`, `retryOnMount`,
	* `notifyOnChangeProps`, `throwOnError`, `suspense`, and `placeholderData` are not part of this
	* method's options.
	*
	* This method replaces the deprecated `fetchQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureQueryData`.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves to the data, or to the result of `select` if provided. It
	* rejects with the error from the fetch or from `select`.
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.query({ queryKey, queryFn, staleTime: 10000 })
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ async query(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        const queryData = query.isStaleByTime((0, $3ur2P.resolveQueryValue)(defaultedOptions.staleTime, query)) ? await query.fetch(defaultedOptions) : query.state.data;
        const select = defaultedOptions.select;
        if (select) return select(queryData);
        return queryData;
    }
    /**
	* Fetches and caches a query, or returns its cached data if it isn't stale. Unlike in observers,
	* the fetch isn't retried unless `retry` is set.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves to the cached or fetched data, or rejects with the fetch
	* error.
	* @deprecated Use queryClient.query(options) instead. This method will be removed in the next major version.
	*/ fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $3ur2P.resolveQueryValue)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
	* Fetches and caches a query like {@link QueryClient#fetchQuery}, but ignores the result and any
	* error.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves once the fetch settles. It never rejects.
	* @deprecated Use queryClient.query(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $3ur2P.noop)).catch((0, $3ur2P.noop));
    }
    /**
	* Asynchronous method to fetch and cache an infinite query, resolving with an
	* {@link InfiniteData} object or throwing with the error.
	*
	* Behaves like {@link QueryClient#query}, accepting the same options (minus
	* `initialPageParam`), plus the required `initialPageParam`, and an optional `pages` /
	* `getNextPageParam` pair used to refetch a fixed number of pages from the start.
	*
	* This method replaces the deprecated `fetchInfiniteQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureInfiniteQueryData`.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves to the {@link InfiniteData}, or to the result of `select` if
	* provided. It rejects with the error from the fetch or from `select`.
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.infiniteQuery({ queryKey, queryFn, initialPageParam: 0 })
	*   console.log(data.pages)
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ infiniteQuery(options) {
        options._type = "infinite";
        return this.query(options);
    }
    /**
	* Fetches and caches an infinite query, or returns its cached data if it isn't stale.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves to the cached or fetched {@link InfiniteData}, or rejects with
	* the fetch error.
	* @deprecated Use queryClient.infiniteQuery(options) instead. This method will be removed in the next major version.
	*/ fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    /**
	* Fetches and caches an infinite query like {@link QueryClient#fetchInfiniteQuery}, but ignores
	* the result and any error.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves once the fetch settles. It never rejects.
	* @deprecated Use queryClient.infiniteQuery(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $3ur2P.noop)).catch((0, $3ur2P.noop));
    }
    /**
	* Returns the cached data of an infinite query, or fetches it if there is none. With
	* `revalidateIfStale`, stale cached data is also refetched in the background.
	* @param options - The infinite query options. If the query has no cached data yet, it is fetched
	* with these options.
	* @returns A promise that resolves to the cached {@link InfiniteData}, or to the fetched data if
	* nothing was cached yet.
	* @deprecated Use queryClient.infiniteQuery({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    /**
	* Resumes mutations that were paused because there was no network connection. Does nothing
	* (resolving immediately) if the client is currently offline.
	* @returns A promise that resolves once the resumed mutations have settled.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* await queryClient.resumePausedMutations()
	* ```
	*/ resumePausedMutations() {
        if ((0, $dRDEH.onlineManager).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    /**
	* Returns the query cache this client is connected to.
	* @returns The {@link QueryCache} instance.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const queryCache = queryClient.getQueryCache()
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ getQueryCache() {
        return this.#queryCache;
    }
    /**
	* Returns the mutation cache this client is connected to.
	* @returns The {@link MutationCache} instance.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const mutationCache = queryClient.getMutationCache()
	* const mutations = mutationCache.findAll({ status: 'pending' })
	* ```
	*/ getMutationCache() {
        return this.#mutationCache;
    }
    /**
	* Returns the default options that were set when creating the client, or via
	* {@link QueryClient#setDefaultOptions}.
	* @returns The client's current default options.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const defaultOptions = queryClient.getDefaultOptions()
	* ```
	*/ getDefaultOptions() {
        return this.#defaultOptions;
    }
    /**
	* Dynamically sets the default options for this client, overwriting any previously defined
	* default options.
	* @param options - The new default options for queries and mutations.
	* @see {@link QueryClient#getDefaultOptions}
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.setDefaultOptions({
	*   queries: {
	*     staleTime: Infinity,
	*   },
	* })
	* ```
	*/ setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    /**
	* Sets default options for queries whose query key partially matches the given `queryKey`.
	*
	* If several registered query defaults match a given query key, they are merged together in
	* registration order by {@link QueryClient#getQueryDefaults}, so register defaults from the
	* most generic key to the least generic one — more specific defaults should be registered
	* after more generic ones so they take precedence.
	* @param queryKey - The query key that query keys are partially matched against.
	* @param options - The default options applied to matching queries.
	* @example
	* ```ts
	* queryClient.setQueryDefaults(['posts'], { queryFn: fetchPosts })
	*
	* await queryClient.query({ queryKey: ['posts'] })
	* ```
	*/ setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $3ur2P.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for queries whose query key partially matches the
	* given `queryKey`, via {@link QueryClient#setQueryDefaults}. If multiple registered defaults
	* match, they are merged together in registration order.
	* @param queryKey - The query key to look up registered defaults for.
	* @returns The merged default options of every registration that matches, or an empty object if
	* none match.
	* @example
	* ```ts
	* const defaultOptions = queryClient.getQueryDefaults(['posts'])
	* ```
	*/ getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $3ur2P.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Sets default options for mutations whose mutation key partially matches the given
	* `mutationKey`. As with {@link QueryClient#setQueryDefaults}, the order of registration
	* matters when several registered defaults match the same mutation key.
	* @param mutationKey - The mutation key that mutation keys are partially matched against.
	* @param options - The default options applied to matching mutations.
	* @see {@link QueryClient#getMutationDefaults}
	* @example
	* ```ts
	* queryClient.setMutationDefaults(['addPost'], { mutationFn: addPost })
	* ```
	*/ setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $3ur2P.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for mutations whose mutation key partially matches
	* the given `mutationKey`, via {@link QueryClient#setMutationDefaults}. If multiple registered
	* defaults match, they are merged together in registration order.
	* @param mutationKey - The mutation key to look up registered defaults for.
	* @returns The merged default options of every registration that matches, or an empty object if
	* none match.
	* @example
	* ```ts
	* const defaultOptions = queryClient.getMutationDefaults(['addPost'])
	* ```
	*/ getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $3ur2P.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Called by framework adapters (e.g. inside `useQuery`) to resolve the options passed by the
	* caller into their final, defaulted form: merging the client's own `defaultOptions.queries`,
	* then `queryClient.setQueryDefaults` for the given `queryKey`, then the caller's options on
	* top. A no-op if the options are already defaulted (`_defaulted: true`).
	* @param options - The query options passed by the caller.
	* @returns The defaulted options, with `queryHash` and dependent defaults (e.g.
	* `refetchOnReconnect`) filled in.
	*/ defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $3ur2P.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $3ur2P.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    /**
	* The mutation counterpart of {@link QueryClient#defaultQueryOptions}. Called by framework
	* adapters (e.g. inside `useMutation`) to merge the client's `defaultOptions.mutations`, then
	* `queryClient.setMutationDefaults` for the given `mutationKey`, then the caller's options on
	* top. A no-op if the options are already defaulted (`_defaulted: true`).
	* @param options - The mutation options passed by the caller.
	* @returns The defaulted options.
	*/ defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    /**
	* Clears both the query cache and the mutation cache this client is connected to.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.clear()
	* ```
	*/ clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};

});
parcelRegister("anR7S", function(module, exports) {

$parcel$export(module.exports, "MutationCache", () => $78f54311643f6103$export$1fcfd9a244434844);

var $3ur2P = parcelRequire("3ur2P");

var $jdy3Z = parcelRequire("jdy3Z");

var $hnhg4 = parcelRequire("hnhg4");

var $7iFRT = parcelRequire("7iFRT");
//#region src/mutationCache.ts
/**
* The `MutationCache` is the storage for mutations.
*
* Normally, you will not interact with the `MutationCache` directly and instead use a
* `QueryClient`. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as mutations being added, removed, or updated.
* @example
* ```ts
* const unsubscribe = mutationCache.subscribe((event) => {
*   console.log(event.type, event.mutation)
* })
* ```
*/ var $78f54311643f6103$export$1fcfd9a244434844 = class extends (0, $jdy3Z.Subscribable) {
    #mutations;
    #scopes;
    #mutationId;
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    /**
	* Creates a mutation and adds it to the cache.
	* @internal
	* @param client - The client the mutation belongs to, used to default its options.
	* @param options - The mutation options. They are defaulted with {@link
	* QueryClient#defaultMutationOptions}.
	* @param state - The initial state of the mutation, e.g. when restoring a dehydrated mutation.
	* @returns The new mutation, already added to the cache.
	*/ build(client, options, state) {
        const mutation = new (0, $7iFRT.Mutation)({
            client: client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    /**
	* Adds a mutation to the cache.
	* @internal
	* @param mutation - The mutation to add. If it has a `scope`, it is queued in that scope.
	*/ add(mutation) {
        this.#mutations.add(mutation);
        const scope = $78f54311643f6103$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    /**
	* Removes a mutation from the cache.
	* @internal
	* @param mutation - The mutation to remove, also from its scope's queue.
	*/ remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $78f54311643f6103$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    /**
	* Checks whether a mutation can run now, given the other mutations in its `scope`.
	* @internal
	* @param mutation - The mutation to check.
	* @returns `true` if the mutation has no `scope`, or no other mutation in its scope is pending
	* ahead of it.
	*/ canRun(mutation) {
        const scope = $78f54311643f6103$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const firstPendingMutation = this.#scopes.get(scope)?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    /**
	* Continues the next paused mutation in the same `scope` after a mutation finishes.
	* @internal
	* @param mutation - The mutation that finished.
	* @returns A promise that resolves once the next paused mutation in the same scope has continued,
	* or immediately if there is none.
	*/ runNext(mutation) {
        const scope = $78f54311643f6103$var$scopeFor(mutation);
        if (typeof scope === "string") return this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused)?.continue() ?? Promise.resolve();
        else return Promise.resolve();
    }
    /**
	* Removes all mutations from the cache.
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* mutationCache.clear()
	* ```
	*/ clear() {
        (0, $hnhg4.notifyManager).batch(()=>{
            const mutations = this.getAll();
            this.#mutations.clear();
            this.#scopes.clear();
            mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
        });
    }
    /**
	* Returns all mutations within the cache.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	* @returns Every mutation in the cache.
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.getAll()
	* ```
	*/ getAll() {
        return Array.from(this.#mutations);
    }
    /**
	* A slightly more advanced method that can be used to get an existing mutation instance from
	* the cache. If the mutation does not exist, `undefined` is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	* @param filters - The filters to match. `exact` defaults to `true`.
	* @returns The first matching mutation, or `undefined`.
	* @see {@link MutationCache#findAll}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $3ur2P.matchMutation)(defaultedFilters, mutation));
    }
    /**
	* An even more advanced method that can be used to get existing mutation instances from the
	* cache that match the given filters. If no mutations match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about mutations in rare scenarios.
	* @param filters - The filters to match. Without filters, every mutation is returned.
	* @returns The matching mutations.
	* @see {@link MutationCache#find}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.findAll({ mutationKey: ['addPost'] })
	* ```
	*/ findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $3ur2P.matchMutation)(filters, mutation));
    }
    /**
	* Notifies every cache listener of an event, in one batch.
	* @internal
	* @param event - The event passed to every listener.
	*/ notify(event) {
        (0, $hnhg4.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /**
	* Continues every paused mutation, e.g. when the app comes back online.
	* @internal
	* @returns A promise that resolves once every paused mutation has continued and settled.
	*/ resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $hnhg4.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $3ur2P.noop)))));
    }
};
/**
* Returns the scope id of a mutation, used to run mutations with the same scope one after another.
* @param mutation - The mutation to read the scope of.
* @returns The mutation's `scope.id`, or `undefined` if it has no scope.
*/ function $78f54311643f6103$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}

});

parcelRegister("jd5LA", function(module, exports) {

$parcel$export(module.exports, "QueryCache", () => $dfc3b44efcc67e59$export$5dde0cd941da8468);

var $3ur2P = parcelRequire("3ur2P");

var $jdy3Z = parcelRequire("jdy3Z");

var $hnhg4 = parcelRequire("hnhg4");

var $z9vcI = parcelRequire("z9vcI");
//#region src/queryCache.ts
/**
* The `QueryCache` is the storage mechanism for TanStack Query. It stores all the data, meta
* information, and state of the queries it contains.
*
* Normally, you will not interact with the `QueryCache` directly and instead use a `QueryClient`
* for a specific cache. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as queries being added, removed, or updated — updates made
* outside of the cache's own tracked mechanisms (e.g. mutating a query's state object directly) do
* not notify subscribers.
* @example
* ```ts
* const unsubscribe = queryCache.subscribe((event) => {
*   console.log(event.type, event.query)
* })
* ```
*/ var $dfc3b44efcc67e59$export$5dde0cd941da8468 = class extends (0, $jdy3Z.Subscribable) {
    #queries;
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    /**
	* Returns the existing `Query` instance for the given options' `queryKey`/`queryHash`, or
	* builds and adds a new one to the cache if none exists yet. Used by framework adapters and
	* plugins (e.g. broadcast/persistence) that need to get-or-create a `Query` directly, bypassing
	* the reactive `QueryObserver` machinery.
	* @param client - The client the query belongs to, used to default its options.
	* @param options - The query options, including the `queryKey`. A new query is created with the
	* options defaulted by {@link QueryClient#defaultQueryOptions}.
	* @param state - The initial state of a newly created query, e.g. when hydrating. Ignored if the
	* query already exists.
	* @returns The existing or newly created query.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.build(queryClient, {
	*   queryKey: ['posts'],
	*   queryFn: fetchPosts,
	* })
	* ```
	*/ build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $3ur2P.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $z9vcI.Query)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    /**
	* Adds a query to the cache.
	* @internal
	* @param query - The query to add. If a query with the same hash is already cached, nothing
	* happens.
	*/ add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    /**
	* Destroys the given `Query` and removes it from the cache, notifying subscribers with a
	* `'removed'` event. A no-op if the query is no longer the one currently stored under its hash
	* (e.g. it was already replaced). Used by plugins (e.g. the broadcast client) that mirror
	* removals across `QueryCache` instances.
	* @param query - The query to remove.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const query = queryCache.find({ queryKey: ['posts'] })
	*
	* if (query) {
	*   queryCache.remove(query)
	* }
	* ```
	*/ remove(query) {
        if (this.#queries.get(query.queryHash) === query) {
            query.destroy();
            this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    /**
	* Removes all queries from the cache.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* queryCache.clear()
	* ```
	*/ clear() {
        (0, $hnhg4.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    /**
	* Returns the `Query` instance stored under the given `queryHash`, or `undefined` if none
	* exists. Unlike {@link QueryCache#find}, this looks up by the already-computed hash rather
	* than by `QueryFilters`. Used by plugins (e.g. broadcast/hydration) that already have a hash
	* to look up directly.
	* @param queryHash - The hash of the query to look up.
	* @returns The query stored under the hash, or `undefined`.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const queryHash = hashKey(['posts'])
	*
	* const query = queryCache.get(queryHash)
	* ```
	*/ get(queryHash) {
        return this.#queries.get(queryHash);
    }
    /**
	* Returns all queries within the cache.
	* @returns Every query in the cache.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.getAll()
	* ```
	*/ getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    /**
	* A slightly more advanced method that can be used to get an existing query instance from the
	* cache. This instance not only contains all the state for the query, but all of the instances,
	* and underlying guts of the query as well. If the query does not exist, `undefined` is
	* returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a query in rare scenarios (e.g. looking at `query.state.dataUpdatedAt` to
	* decide whether a query is fresh enough to be used as an initial value).
	* @param filters - The filters to match, including the required `queryKey`. `exact` defaults to
	* `true`.
	* @returns The first matching query, or `undefined`.
	* @see {@link QueryCache#findAll}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.find({ queryKey: ['posts'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $3ur2P.matchQuery)(defaultedFilters, query));
    }
    /**
	* An even more advanced method that can be used to get existing query instances from the cache
	* that partially match a query key. If no queries match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about queries in rare scenarios.
	* @param filters - The filters to match. Without filters, every query is returned.
	* @returns The matching queries.
	* @see {@link QueryCache#find}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $3ur2P.matchQuery)(filters, query)) : queries;
    }
    /**
	* Notifies every cache listener of an event, in one batch.
	* @internal
	* @param event - The event passed to every listener.
	*/ notify(event) {
        (0, $hnhg4.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /**
	* Calls {@link Query#onFocus} on every cached query, in one batch.
	* @internal
	*/ onFocus() {
        (0, $hnhg4.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    /**
	* Calls {@link Query#onOnline} on every cached query, in one batch.
	* @internal
	*/ onOnline() {
        (0, $hnhg4.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

});


parcelRegister("15l6m", function(module, exports) {

$parcel$export(module.exports, "MutationCache", () => $0ca6a06a8afabce3$export$1fcfd9a244434844);
// src/mutationCache.ts

var $igIGl = parcelRequire("igIGl");

var $hDZHY = parcelRequire("hDZHY");

var $Pjwk4 = parcelRequire("Pjwk4");

var $56eQ3 = parcelRequire("56eQ3");
var $0ca6a06a8afabce3$export$1fcfd9a244434844 = class extends (0, $56eQ3.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $hDZHY.Mutation)({
            client: client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $0ca6a06a8afabce3$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $0ca6a06a8afabce3$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $0ca6a06a8afabce3$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $0ca6a06a8afabce3$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $igIGl.notifyManager).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $Pjwk4.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $Pjwk4.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $igIGl.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $igIGl.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $Pjwk4.noop)))));
    }
};
function $0ca6a06a8afabce3$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}

});
parcelRegister("igIGl", function(module, exports) {

$parcel$export(module.exports, "notifyManager", () => $d4cc61808f528879$export$520687f44db6e1ab);
// src/notifyManager.ts

var $22HzX = parcelRequire("22HzX");
var $d4cc61808f528879$export$7c76da44185e6090 = (0, $22HzX.systemSetTimeoutZero);
function $d4cc61808f528879$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $d4cc61808f528879$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $d4cc61808f528879$export$520687f44db6e1ab = $d4cc61808f528879$export$316a8efd03cd1458();

});
parcelRegister("22HzX", function(module, exports) {

$parcel$export(module.exports, "timeoutManager", () => $17cd928b2f039c47$export$94a2700736e69372);
$parcel$export(module.exports, "systemSetTimeoutZero", () => $17cd928b2f039c47$export$5086591e51e32a18);
// src/timeoutManager.ts
var $17cd928b2f039c47$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $17cd928b2f039c47$export$6336d90323f0ab52 = class {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support the default provider's concrete timer ID, which is
    // infeasible across environments.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    #provider = $17cd928b2f039c47$export$d235812f9125bf47;
    #providerCalled = false;
    setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
var $17cd928b2f039c47$export$94a2700736e69372 = new $17cd928b2f039c47$export$6336d90323f0ab52();
function $17cd928b2f039c47$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}

});


parcelRegister("hDZHY", function(module, exports) {

$parcel$export(module.exports, "Mutation", () => $cd85f22d37ac94f9$export$17b8b19c814bcf56);
// src/mutation.ts

var $igIGl = parcelRequire("igIGl");

var $9V6Gg = parcelRequire("9V6Gg");

var $aNOuJ = parcelRequire("aNOuJ");
var $cd85f22d37ac94f9$export$17b8b19c814bcf56 = class extends (0, $9V6Gg.Removable) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $cd85f22d37ac94f9$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        this.#retryer = (0, $aNOuJ.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if (this.#mutationCache.config.onMutate) await this.#mutationCache.config.onMutate(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            throw error;
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $igIGl.notifyManager).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $cd85f22d37ac94f9$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

});
parcelRegister("9V6Gg", function(module, exports) {

$parcel$export(module.exports, "Removable", () => $738e9e9463131c64$export$e09608847fcc8c59);
// src/removable.ts

var $22HzX = parcelRequire("22HzX");

var $kCnTC = parcelRequire("kCnTC");

var $Pjwk4 = parcelRequire("Pjwk4");
var $738e9e9463131c64$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $Pjwk4.isValidTimeout)(this.gcTime)) this.#gcTimeout = (0, $22HzX.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $kCnTC.environmentManager).isServer() ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout !== void 0) {
            (0, $22HzX.timeoutManager).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};

});
parcelRegister("kCnTC", function(module, exports) {

$parcel$export(module.exports, "environmentManager", () => $f029e4810cb32583$export$2d935f1a9c9d3f3e);
// src/environmentManager.ts

var $Pjwk4 = parcelRequire("Pjwk4");
var $f029e4810cb32583$export$2d935f1a9c9d3f3e = /* @__PURE__ */ (()=>{
    let isServerFn = ()=>(0, $Pjwk4.isServer);
    return {
        /**
     * Returns whether the current runtime should be treated as a server environment.
     */ isServer () {
            return isServerFn();
        },
        /**
     * Overrides the server check globally.
     */ setIsServer (isServerValue) {
            isServerFn = isServerValue;
        }
    };
})();

});
parcelRegister("Pjwk4", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $09a3e7ddc3bad6e2$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $09a3e7ddc3bad6e2$export$8793edee2d425525);
$parcel$export(module.exports, "isValidTimeout", () => $09a3e7ddc3bad6e2$export$e539f754e934e270);
$parcel$export(module.exports, "timeUntilStale", () => $09a3e7ddc3bad6e2$export$811b83d62bcf47f0);
$parcel$export(module.exports, "resolveStaleTime", () => $09a3e7ddc3bad6e2$export$cb3145f011bda3ac);
$parcel$export(module.exports, "resolveQueryBoolean", () => $09a3e7ddc3bad6e2$export$d7ee3961208f79c1);
$parcel$export(module.exports, "matchQuery", () => $09a3e7ddc3bad6e2$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $09a3e7ddc3bad6e2$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "matchMutation", () => $09a3e7ddc3bad6e2$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "sleep", () => $09a3e7ddc3bad6e2$export$e772c8ff12451969);
$parcel$export(module.exports, "replaceData", () => $09a3e7ddc3bad6e2$export$17619bac5b909b23);
$parcel$export(module.exports, "addToEnd", () => $09a3e7ddc3bad6e2$export$ccce65a22a26f2bc);
$parcel$export(module.exports, "addToStart", () => $09a3e7ddc3bad6e2$export$8c6246b73dd61f4a);
$parcel$export(module.exports, "skipToken", () => $09a3e7ddc3bad6e2$export$1aa5a89531b7670d);
$parcel$export(module.exports, "ensureQueryFn", () => $09a3e7ddc3bad6e2$export$c71c44209368a3bc);
$parcel$export(module.exports, "addConsumeAwareSignal", () => $09a3e7ddc3bad6e2$export$83f813cd1f8a4973);
// src/utils.ts

var $22HzX = parcelRequire("22HzX");
var $09a3e7ddc3bad6e2$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $09a3e7ddc3bad6e2$export$8793edee2d425525() {}
function $09a3e7ddc3bad6e2$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $09a3e7ddc3bad6e2$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $09a3e7ddc3bad6e2$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $09a3e7ddc3bad6e2$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $09a3e7ddc3bad6e2$export$d7ee3961208f79c1(option, query) {
    return typeof option === "function" ? option(query) : option;
}
function $09a3e7ddc3bad6e2$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $09a3e7ddc3bad6e2$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$09a3e7ddc3bad6e2$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $09a3e7ddc3bad6e2$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($09a3e7ddc3bad6e2$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $09a3e7ddc3bad6e2$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$09a3e7ddc3bad6e2$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $09a3e7ddc3bad6e2$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $09a3e7ddc3bad6e2$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $09a3e7ddc3bad6e2$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$09a3e7ddc3bad6e2$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $09a3e7ddc3bad6e2$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$09a3e7ddc3bad6e2$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $09a3e7ddc3bad6e2$var$hasOwn = Object.prototype.hasOwnProperty;
function $09a3e7ddc3bad6e2$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $09a3e7ddc3bad6e2$export$7a8558113332b71e(a) && $09a3e7ddc3bad6e2$export$7a8558113332b71e(b);
    if (!array && !($09a3e7ddc3bad6e2$export$53b83ca8eaab0383(a) && $09a3e7ddc3bad6e2$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $09a3e7ddc3bad6e2$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $09a3e7ddc3bad6e2$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $09a3e7ddc3bad6e2$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $09a3e7ddc3bad6e2$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $09a3e7ddc3bad6e2$export$53b83ca8eaab0383(o) {
    if (!$09a3e7ddc3bad6e2$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$09a3e7ddc3bad6e2$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $09a3e7ddc3bad6e2$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $09a3e7ddc3bad6e2$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $22HzX.timeoutManager).setTimeout(resolve, timeout);
    });
}
function $09a3e7ddc3bad6e2$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $09a3e7ddc3bad6e2$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $09a3e7ddc3bad6e2$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $09a3e7ddc3bad6e2$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $09a3e7ddc3bad6e2$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $09a3e7ddc3bad6e2$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $09a3e7ddc3bad6e2$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $09a3e7ddc3bad6e2$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $09a3e7ddc3bad6e2$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $09a3e7ddc3bad6e2$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ??= getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}

});



parcelRegister("aNOuJ", function(module, exports) {

$parcel$export(module.exports, "canFetch", () => $7dd5a62a74d718ab$export$61b92f63f30245cf);
$parcel$export(module.exports, "CancelledError", () => $7dd5a62a74d718ab$export$a8430ed4188f35a9);
$parcel$export(module.exports, "createRetryer", () => $7dd5a62a74d718ab$export$2cbd00fe8a2c8d85);
// src/retryer.ts

var $hUkGb = parcelRequire("hUkGb");

var $8z3VH = parcelRequire("8z3VH");

var $8ifh9 = parcelRequire("8ifh9");

var $kCnTC = parcelRequire("kCnTC");

var $Pjwk4 = parcelRequire("Pjwk4");
function $7dd5a62a74d718ab$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $7dd5a62a74d718ab$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $8z3VH.onlineManager).isOnline() : true;
}
var $7dd5a62a74d718ab$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $7dd5a62a74d718ab$export$986cc6445c1d323(value) {
    return value instanceof $7dd5a62a74d718ab$export$a8430ed4188f35a9;
}
function $7dd5a62a74d718ab$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $8ifh9.pendingThenable)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new $7dd5a62a74d718ab$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $hUkGb.focusManager).isFocused() && (config.networkMode === "always" || (0, $8z3VH.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$7dd5a62a74d718ab$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $kCnTC.environmentManager).isServer() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $7dd5a62a74d718ab$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $Pjwk4.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

});
parcelRegister("hUkGb", function(module, exports) {

$parcel$export(module.exports, "focusManager", () => $d097b5226765b2bf$export$6bf54661be5b02cf);
// src/focusManager.ts

var $56eQ3 = parcelRequire("56eQ3");
var $d097b5226765b2bf$export$86f1af424b2ca4de = class extends (0, $56eQ3.Subscribable) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $d097b5226765b2bf$export$6bf54661be5b02cf = new $d097b5226765b2bf$export$86f1af424b2ca4de();

});
parcelRegister("56eQ3", function(module, exports) {

$parcel$export(module.exports, "Subscribable", () => $3b6905ecad82ea74$export$d26086b469ecdbcc);
// src/subscribable.ts
var $3b6905ecad82ea74$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

});


parcelRegister("8z3VH", function(module, exports) {

$parcel$export(module.exports, "onlineManager", () => $63c4a3f421e41df4$export$b113e788b2dd3fdc);
// src/onlineManager.ts

var $56eQ3 = parcelRequire("56eQ3");
var $63c4a3f421e41df4$export$58774fb55d5ff7fc = class extends (0, $56eQ3.Subscribable) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $63c4a3f421e41df4$export$b113e788b2dd3fdc = new $63c4a3f421e41df4$export$58774fb55d5ff7fc();

});

parcelRegister("8ifh9", function(module, exports) {

$parcel$export(module.exports, "pendingThenable", () => $609bda9c290840a8$export$d54630db02a12b72);
// src/thenable.ts

var $Pjwk4 = parcelRequire("Pjwk4");
function $609bda9c290840a8$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $609bda9c290840a8$export$216296c47a9d1275(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, $Pjwk4.noop))?.catch((0, $Pjwk4.noop));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}

});




parcelRegister("a8tBG", function(module, exports) {

$parcel$export(module.exports, "QueryCache", () => $76119e0c113306cc$export$5dde0cd941da8468);
// src/queryCache.ts

var $Pjwk4 = parcelRequire("Pjwk4");

var $73nGS = parcelRequire("73nGS");

var $igIGl = parcelRequire("igIGl");

var $56eQ3 = parcelRequire("56eQ3");
var $76119e0c113306cc$export$5dde0cd941da8468 = class extends (0, $56eQ3.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $Pjwk4.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $73nGS.Query)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $igIGl.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $Pjwk4.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $Pjwk4.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $igIGl.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $igIGl.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $igIGl.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

});
parcelRegister("73nGS", function(module, exports) {

$parcel$export(module.exports, "Query", () => $522b30acc564585d$export$62297b13309008b2);
// src/query.ts

var $Pjwk4 = parcelRequire("Pjwk4");

var $igIGl = parcelRequire("igIGl");

var $aNOuJ = parcelRequire("aNOuJ");

var $9V6Gg = parcelRequire("9V6Gg");

var $6E6gD = parcelRequire("6E6gD");
var $522b30acc564585d$export$62297b13309008b2 = class extends (0, $9V6Gg.Removable) {
    #queryType;
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $522b30acc564585d$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get queryType() {
        return this.#queryType;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        if (options?._type) this.#queryType = options._type;
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $522b30acc564585d$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($522b30acc564585d$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $Pjwk4.replaceData)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state) {
        this.#dispatch({
            type: "setState",
            state: state
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $Pjwk4.noop)).catch((0, $Pjwk4.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return this.#initialState;
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $Pjwk4.resolveQueryBoolean)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $Pjwk4.skipToken) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $Pjwk4.resolveStaleTime)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $Pjwk4.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed || this.#isInitialPausedFetch()) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    #isInitialPausedFetch() {
        return this.state.fetchStatus === "paused" && this.state.status === "pending";
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $Pjwk4.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        const behavior = this.#queryType === "infinite" ? (0, $6E6gD.infiniteQueryBehavior)(this.options.pages) : this.options.behavior;
        behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        this.#retryer = (0, $aNOuJ.createRetryer)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $aNOuJ.CancelledError) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await this.#retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $aNOuJ.CancelledError)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$522b30acc564585d$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        ...$522b30acc564585d$var$successState(action.data, action.dataUpdatedAt),
                        dataUpdateCount: state.dataUpdateCount + 1,
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error",
                        // flag existing data as invalidated if we get a background error
                        // note that "no data" always means stale so we can set unconditionally here
                        isInvalidated: true
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $igIGl.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $522b30acc564585d$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $aNOuJ.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $522b30acc564585d$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $522b30acc564585d$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("6E6gD", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", () => $4d6b5709513909d5$export$84470d1367601e8d);
// src/infiniteQueryBehavior.ts

var $Pjwk4 = parcelRequire("Pjwk4");
function $4d6b5709513909d5$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $Pjwk4.addConsumeAwareSignal)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $Pjwk4.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $Pjwk4.addToStart) : (0, $Pjwk4.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $4d6b5709513909d5$var$getPreviousPageParam : $4d6b5709513909d5$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $4d6b5709513909d5$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $4d6b5709513909d5$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $4d6b5709513909d5$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $4d6b5709513909d5$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $4d6b5709513909d5$var$getNextPageParam(options, data) != null;
}
function $4d6b5709513909d5$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $4d6b5709513909d5$var$getPreviousPageParam(options, data) != null;
}

});



parcelRegister("ekEvR", function(module, exports) {

$parcel$export(module.exports, "createAsyncStoragePersister", () => $a6f25bf94d3c70f1$export$5e03d65274f1beeb);

var $7nhT4 = parcelRequire("7nhT4");

var $cObEW = parcelRequire("cObEW");
//#region src/index.ts
/**
* Creates a persister that saves the client to an asynchronous storage such as `AsyncStorage`,
* throttled by `throttleTime`. If saving fails, `retry` can return a smaller client to try again.
* @param options - The `storage` to persist to, the `key`, `throttleTime`, `serialize`,
* `deserialize`, and `retry` options.
* @returns A persister that saves, restores, and removes the client in `storage`. Without
* `storage`, its methods do nothing.
*/ const $a6f25bf94d3c70f1$export$5e03d65274f1beeb = ({ storage: storage, key: key = `REACT_QUERY_OFFLINE_CACHE`, throttleTime: throttleTime = 1e3, serialize: serialize = JSON.stringify, deserialize: deserialize = JSON.parse, retry: retry })=>{
    if (storage) {
        const trySave = async (persistedClient)=>{
            try {
                const serialized = await serialize(persistedClient);
                await storage.setItem(key, serialized);
                return;
            } catch (error) {
                return error;
            }
        };
        return {
            persistClient: (0, $cObEW.asyncThrottle)(async (persistedClient)=>{
                let client = persistedClient;
                let error = await trySave(client);
                let errorCount = 0;
                while(error && client){
                    errorCount++;
                    client = await retry?.({
                        persistedClient: client,
                        error: error,
                        errorCount: errorCount
                    });
                    if (client) error = await trySave(client);
                }
            }, {
                interval: throttleTime
            }),
            restoreClient: async ()=>{
                const cacheString = await storage.getItem(key);
                if (!cacheString) return;
                return await deserialize(cacheString);
            },
            removeClient: ()=>storage.removeItem(key)
        };
    }
    return {
        persistClient: (0, $7nhT4.noop),
        restoreClient: ()=>Promise.resolve(void 0),
        removeClient: (0, $7nhT4.noop)
    };
};

});
parcelRegister("7nhT4", function(module, exports) {

$parcel$export(module.exports, "noop", () => $55e88e7179af2774$export$8793edee2d425525);
//#region src/utils.ts
function $55e88e7179af2774$export$8793edee2d425525() {}

});

parcelRegister("cObEW", function(module, exports) {

$parcel$export(module.exports, "asyncThrottle", () => $953332d499482318$export$62b8953b6e765ff1);

var $7nhT4 = parcelRequire("7nhT4");

var $1OpUA = parcelRequire("1OpUA");
//#region src/asyncThrottle.ts
/**
* Wraps an async function so it runs at most once per `interval`, never concurrently, and with the
* arguments of the latest call. Calls made while a run is scheduled only update those arguments.
* @param func - The async function to throttle.
* @param options - The `interval` between runs in milliseconds, and `onError`, called when `func`
* rejects.
* @returns The throttled function.
* @throws {Error} If `func` is not a function.
*/ function $953332d499482318$export$62b8953b6e765ff1(func, { interval: interval = 1e3, onError: onError = (0, $7nhT4.noop) } = {}) {
    if (typeof func !== "function") throw new Error("argument is not function.");
    let nextExecutionTime = 0;
    let lastArgs = null;
    let isExecuting = false;
    let isScheduled = false;
    return async (...args)=>{
        lastArgs = args;
        if (isScheduled) return;
        isScheduled = true;
        while(isExecuting)await new Promise((done)=>(0, $1OpUA.timeoutManager).setTimeout(done, interval));
        while(Date.now() < nextExecutionTime)await new Promise((done)=>(0, $1OpUA.timeoutManager).setTimeout(done, nextExecutionTime - Date.now()));
        isScheduled = false;
        isExecuting = true;
        try {
            await func(...lastArgs);
        } catch (error) {
            try {
                onError(error);
            } catch  {}
        }
        nextExecutionTime = Date.now() + interval;
        isExecuting = false;
    };
}

});


parcelRegister("7f2AL", function(module, exports) {

$parcel$export(module.exports, "get", () => $545bf1d9140e7fc6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $545bf1d9140e7fc6$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "del", () => $545bf1d9140e7fc6$export$1d2f21e549771e67);
$parcel$export(module.exports, "entries", () => $545bf1d9140e7fc6$export$3e9f948b41964866);
function $545bf1d9140e7fc6$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $545bf1d9140e7fc6$export$f51a9068ac82ea43(dbName, storeName) {
    let dbp;
    const getDB = ()=>{
        if (dbp) return dbp;
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        dbp = $545bf1d9140e7fc6$export$b327150396135fe7(request);
        dbp.then((db)=>{
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = ()=>dbp = undefined;
        }, ()=>{
            dbp = undefined;
        });
        return dbp;
    };
    return (txMode, callback)=>getDB().then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $545bf1d9140e7fc6$var$defaultGetStoreFunc;
function $545bf1d9140e7fc6$var$defaultGetStore() {
    if (!$545bf1d9140e7fc6$var$defaultGetStoreFunc) $545bf1d9140e7fc6$var$defaultGetStoreFunc = $545bf1d9140e7fc6$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $545bf1d9140e7fc6$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$3988ae62b71be9a3(key, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$545bf1d9140e7fc6$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$adaa4cf7ef1b65be(key, value, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $545bf1d9140e7fc6$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$daa0a5170277c7a8(entries, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $545bf1d9140e7fc6$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$5df405cccea42673(keys, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$545bf1d9140e7fc6$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$722fbec263ad908a(key, updater, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            const req = store.get(key);
            req.onsuccess = function() {
                try {
                    store.put(updater(req.result), key);
                    resolve($545bf1d9140e7fc6$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
            req.onerror = ()=>reject(req.error);
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$1d2f21e549771e67(key, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $545bf1d9140e7fc6$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$c8aa84257229cac8(keys, customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $545bf1d9140e7fc6$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$42ffd38884aecdac(customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $545bf1d9140e7fc6$export$b327150396135fe7(store.transaction);
    });
}
function $545bf1d9140e7fc6$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $545bf1d9140e7fc6$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$ed97f33186d4b816(customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $545bf1d9140e7fc6$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $545bf1d9140e7fc6$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$68c286be0e7e55b7(customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $545bf1d9140e7fc6$export$b327150396135fe7(store.getAll());
        const items = [];
        return $545bf1d9140e7fc6$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $545bf1d9140e7fc6$export$3e9f948b41964866(customStore = $545bf1d9140e7fc6$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $545bf1d9140e7fc6$export$b327150396135fe7(store.getAllKeys()),
            $545bf1d9140e7fc6$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return $545bf1d9140e7fc6$var$eachCursor(store, (cursor)=>items.push([
                cursor.key,
                cursor.value
            ])).then(()=>items);
    });
}

});



parcelRegister("kHUY0", function(module, exports) {

$parcel$export(module.exports, "createWizardSlice", () => $f134033de58365c9$export$a2d8638a1787a73);

var $g0I9D = parcelRequire("g0I9D");
const $f134033de58365c9$var$industries = [
    {
        id: "i-0",
        items: [
            {
                id: 0,
                label: "Automotive"
            }
        ]
    },
    {
        id: "i-1",
        items: [
            {
                id: 1,
                label: "Consumer Packaged Goods"
            }
        ]
    },
    {
        id: "i-2",
        label: "Education",
        items: [
            {
                id: 2,
                label: "Education general"
            },
            {
                id: 3,
                label: "Higher Ed"
            },
            {
                id: 4,
                label: "K - 12"
            }
        ]
    },
    {
        id: "i-3",
        label: "Financial Services",
        items: [
            {
                id: 5,
                label: "Financial Services general"
            },
            {
                id: 6,
                label: "Insurance"
            },
            {
                id: 7,
                label: "Retail Banking"
            },
            {
                id: 8,
                label: "Wealth Management"
            }
        ]
    },
    {
        id: "i-4",
        label: "Health and Life Sciences",
        items: [
            {
                id: 9,
                label: "Health and Life Sciences general"
            },
            {
                id: 10,
                label: "Payer"
            },
            {
                id: 11,
                label: "Pharmaceutical"
            },
            {
                id: 12,
                label: "Provider"
            },
            {
                id: 13,
                label: "Medical Devices"
            }
        ]
    },
    {
        id: "i-5",
        label: "High Tech",
        items: [
            {
                id: 14,
                label: "High Tech general"
            },
            {
                id: 15,
                label: "B2B"
            },
            {
                id: 16,
                label: "B2C"
            },
            {
                id: 17,
                label: "Manufacturing & Distribution general"
            }
        ]
    },
    {
        id: "i-6",
        label: "Media, Entertainment & Communications",
        items: [
            {
                id: 18,
                label: "Media, Entertainment & Communications general"
            },
            {
                id: 19,
                label: "Digital Publishing"
            },
            {
                id: 20,
                label: "Paid TV & D2C Video"
            },
            {
                id: 21,
                label: "Sports, Gaming, & Gambling"
            },
            {
                id: 22,
                label: "Telecommunications"
            },
            {
                id: 23,
                label: "Non-Profit general"
            }
        ]
    },
    {
        id: "i-7",
        label: "Public Sector",
        items: [
            {
                id: 24,
                label: "Public Sector general"
            },
            {
                id: 25,
                label: "Department of Defense"
            },
            {
                id: 26,
                label: "Federal and Civilian"
            },
            {
                id: 27,
                label: "Intel"
            },
            {
                id: 28,
                label: "State and Local"
            }
        ]
    },
    {
        id: "i-8",
        label: "Retail",
        items: [
            {
                id: 29,
                label: "Retail general"
            }
        ]
    },
    {
        id: "i-9",
        label: "Travel & Hospitality",
        items: [
            {
                id: 30,
                label: "Travel & Hospitality general"
            },
            {
                id: 31,
                label: "Fitness"
            },
            {
                id: 32,
                label: "Hospitality"
            },
            {
                id: 33,
                label: "Restaurant"
            },
            {
                id: 34,
                label: "Transportation"
            }
        ]
    }
];
const $f134033de58365c9$var$sampleData = {
    companyName: "CitiSignal",
    industry: "Telecommunications",
    companyDescription: "E.g. has a wide range of teleco offerings, including carrier plans, phone devices, 5G mobile network, streaming TV. It's focused mostly on young, tech-savvy audience.",
    personaName: "Alex",
    personaDescription: "E.g. 30 years old woman, with 2 kids, who lives in San Jose, and is looking to optimize costs of her mobile provider. She currently has a basic 'On Demand' plan with CitiSignal.",
    businessGoals: "E.g. increase the upsell and build loyalty",
    featuredOfferings: "E.g. Premium' plan, streaming TV plan with special Kids channels, discount for event tickets by Townsend Events for mobile app users",
    featuredPhases: "E.g. onboarding and loyalty",
    featuredUseCases: "E.g. retargeting of the abandoner, inbound and outbound marketing channels, in-store experiences",
    featuredEvents: "E.g. interacting with chat and call center and visiting a CitiSignal store"
};
const $f134033de58365c9$var$MAX_STEP = 3;
const $f134033de58365c9$var$initialState = {
    wizard: {
        step: 0,
        storyPrompt: "",
        storyPromptTemplate: "",
        data: {
            businessGoals: "",
            companyDescription: "",
            companyName: "",
            featuredEvents: "",
            featuredOfferings: "",
            featuredUseCases: "",
            industry: "",
            personas: []
        },
        selectedIndustryKey: null,
        industries: $f134033de58365c9$var$industries,
        sampleData: $f134033de58365c9$var$sampleData
    }
};
const $f134033de58365c9$export$a2d8638a1787a73 = (set, get)=>({
        ...$f134033de58365c9$var$initialState,
        /**
   * Sets a value in the wizard data.
   *
   * @param {string} key - The key of the data to set.
   * @param {*} value - The value to set.
   *
   * @returns {void}
   */ setData: (key, value)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.wizard.data[key] = value;
            }), undefined, "wizard/setData");
            get().setStoryPrompt();
        },
        /**
   * Adds a new persona to the wizard data.
   *
   * @returns {void}
   */ addDataPersona: ()=>set((0, $g0I9D.produce)((state)=>{
                state.wizard.data.personas.push({});
            }), undefined, "wizard/addDataPersona"),
        /**
   * Removes a persona from the wizard data.
   *
   * @param {number} index - The index of the persona to remove.
   *
   * @returns {void}
   */ removeDataPersona: (index)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.wizard.data.personas.splice(index, 1);
            }), undefined, "wizard/removeDataPersona");
            get().setStoryPrompt();
        },
        /**
   * Updates a persona in the wizard data.
   *
   * @param {number} index - The index of the persona to update.
   * @param {string} key - The key of the persona data to update.
   * @param {*} value - The new value for the persona data.
   *
   * @returns {void}
   */ changeDataPersona: (index, key, value)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.wizard.data.personas[index][key] = value;
            }), undefined, "wizard/changeDataPersona");
            get().setStoryPrompt();
        },
        /**
   * Changes the industry in the wizard data.
   *
   * @param {string} key - The key of the industry to change.
   *
   * @returns {void}
   */ changeDataIndustry: (key)=>{
            set((0, $g0I9D.produce)((state)=>{
                const industry = state.wizard.industries.flatMap((section)=>section.items).find((item)=>item.id === key);
                if (!industry) {
                    console.warn(`Industry with key ${key} not found`);
                    return;
                }
                state.wizard.data.industry = industry.label;
                state.wizard.selectedIndustryKey = key;
                if (state.wizard.step === 0) state.wizard.step = 1; // Move to the next step if on the first step
            }), undefined, "wizard/changeDataIndustry");
            get().setStoryPrompt();
        },
        /**
   * Sets the wizard step.
   *
   * @param {number} step - The step to set.
   *
   * @returns {void}
   */ setWizardStep: (step)=>set((0, $g0I9D.produce)((state)=>{
                state.wizard.step = step;
            }), undefined, "wizard/setWizardStep"),
        /**
   * Builds the story prompt based on the current wizard data.
   *
   * @returns {string} - The story prompt based on the current wizard data.
   */ buildStoryPrompt: ()=>{
            const { industry: industry, companyName: companyName, companyDescription: companyDescription, personas: _personas = [], businessGoals: businessGoals, featuredOfferings: featuredOfferings, featuredPhases: featuredPhases, featuredUseCases: featuredUseCases, featuredEvents: featuredEvents } = get().wizard.data;
            const personas = _personas.filter((persona)=>persona.name);
            if (!industry || !companyName) return "";
            const baseInstruction = `Write a story, that will help explain the CEO of the ${industry} company ${!!companyName && `called ${companyName}`} what the modern marketing technology can do to power the end-to-end customer journey and achieve their business goals${!!businessGoals ? ` (especially ${businessGoals}` : ""}, while optimizing costs and increasing revenue.`;
            const personasDescription = !personas.length ? "" : personas.length === 1 ? `\n\nThe story's hero, our *persona*, is ${personas[0].name} \u{2013} ${personas[0].description}.` : `\n\nThe story's heroes, our *personas*, are:
    ${personas.map((persona)=>`- ${persona.name}${!!persona.description ? ` \u{2013} ${persona.description}` : ""}`).join("\n")}.`;
            const personasNames = personas.length ? new Intl.ListFormat("en", {
                style: "long",
                type: "conjunction"
            }).format(personas.map((persona)=>persona.name)) : `our persona`;
            const task = `\n\nThe story should show the experience of ${personasNames}, encompassing the whole customer journey, from the acquisition to retention, that is powered by modern digital experience solutions.
    ${!!featuredPhases ? `\nSpecial focus should be put on the ${featuredPhases} phases of the customer journey.` : ""}
    Experiences should include the key industry use cases, and show personalized digital experiences, real-time customer profile use, orchestration of user journey across channels${!!featuredUseCases ? `\n as well as ${featuredUseCases}.` : "."} \
    ${!!featuredEvents ? `\nPart of the story should feature the following events: ${featuredEvents}.` : ""}`;
            const company = `${!!companyDescription ? `\n\n${companyName} \u{2013} ${companyDescription}` : ""} \
    ${!!featuredOfferings ? `\n${companyName}'s offerings that the story should show include ${featuredOfferings}` : ""}`;
            const prompt = `${baseInstruction} \
    ${personasDescription} \
    ${task} \
    ${company}`;
            return prompt;
        },
        /**
   * Builds the story prompt template based on the current wizard data.
   *
   * @returns {string} - The story prompt template based on the current wizard data.
   */ buildStoryPromptTemplate: ()=>{
            const storyPrompt = get().wizard.storyPrompt;
            const industry = get().wizard.data.industry;
            if (!storyPrompt || !industry) return "";
            return `${storyPrompt}
    
    Build the story narrative in a way that following steps are connected to each other, and the whole story is cohesive, logical, and engaging.
    Connect each step of the story with a realistic (real-world events) narrative, by creating additional, intermediate steps, and transitioning smoothly between them. Make sure that each step is connected to the previous one.
    The story should be written in a way that it can be presented as a script for a presentation, with each step being a separate slide.
    
    Include those steps at the beginning of the story script:
      - "Intro" step with only title "Adobe \xd7 *companyName*"
      - "Cover" step with the headline
      - general "Introduction" to the story (in 1-4 steps)
      - "Introduction" step for each persona
    
    Include those steps at the end of the story script:
      - "Summary" for used Adobe solutions. Summarize the solutions used in the story, and how they help to achieve the business goals.
      - "Summary" for business values. Summarize the business values achieved in the story.
      - "Outro" step with only the title "Adobe"
    
    
    The output should follow exactly the JSON format of provided examples, tell the story in similar way, and follow the overall idiolect and sociolinguistics style used in the example scripts.
    The output JSON should include the following fields:
      *title* \u{2013} A title is a name assigned to a work, typically selected by its creator. It serves to identify the work, provide context, offer a brief summary of its content, and capture the reader's interest.
      *customer* \u{2013} The company highlighted in this story is defined as a customer, which refers to a business or organization that buys goods or services from another business in return for payment.
      *industry* \u{2013} A collection of companies that engage in similar activities and provide related products or services.
      *storyOverview* \u{2013} A story overview provides a general summary of a story, highlighting the main events and plot points while omitting minor details. It's a concise way to understand the core narrative arc without getting bogged down in specific instances.
      *businessGoals* \u{2013} The goals or objectives a company seeks to accomplish within a designated time period.
      *campaignFocus* - The central theme, problem, or result that directs all campaign activities and communications.
      *personas*: \u{2013} A persona represents a fictional member of a target audience, utilized in fields such as marketing and design to enhance understanding and empathy towards users. It is developed through research and insights regarding users, including their goals, motivations, and behaviors, informing design choices and leading to the creation of more effective products and experiences.
        - *name* \u{2013} Name of the persona.
        - *role* \u{2013} Persona's role in the story.
        - *description* \u{2013} Short overview of the persona.
        - *location* \u{2013} City where the persona lives.
        - *age* \u{2013} Age of persona.
      *solutions* \u{2013} List of Adobe solutions used across the story.
      *script*: \u{2013} List of the steps in the story script.
        - *section* \u{2013} (Required) The title of the ongoing chapter in the narrative.
        - *title* \u{2013} (Required) A title or label that indicates the current phase.
        - *text* \u{2013} (Required) A brief message outlining the current step. It should be formatted suitably for a presentation slide.
        - *personas* \u{2013} List of persona names described or play a role in this step. Required if the step is related to or talk about a specific persona.
        - *solutions* \u{2013} The titles of the Adobe solutions utilized in this phase.
        - *visual* \u{2013} (Required) Prompt for generating a visual image related to the step.
        - *visualMessaging* \u{2013} Messaging that corresponds with the visual shown.
        - *comments* \u{2013} (Required) Explaining the rationale for this stage of the story script, discussing the values given, and concentrating on reaching business objectives.
    `;
        },
        /**
   * Sets the story prompt in the wizard state.
   *
   * @param {string} prompt - The story prompt to set.
   *
   * @returns {void}
   */ setStoryPrompt: (prompt)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.wizard.storyPrompt = prompt ?? get().buildStoryPrompt();
            }), undefined, "wizard/setStoryPrompt");
            get().setStoryPromptTemplate();
        },
        /**
   * Sets the story prompt template in the wizard state.
   *
   * @param {string} template - The story prompt template to set.
   *
   * @returns {void}
   */ setStoryPromptTemplate: (template)=>set((0, $g0I9D.produce)((state)=>{
                state.wizard.storyPromptTemplate = template ?? get().buildStoryPromptTemplate();
            }), undefined, "wizard/setStoryPromptTemplate"),
        /**
   * Loads the wizard data.
   *
   * @param {Object} data - The wizard data to load.
   * @param {string} prompt - The story prompt to set.
   * @param {string} template - The story prompt template to set.
   *
   * @returns {void}
   */ loadWizardData: (data, prompt, template)=>{
            set((0, $g0I9D.produce)((state)=>{
                state.wizard.data = data;
                state.wizard.storyPrompt = prompt;
                state.wizard.storyPromptTemplate = template;
                state.wizard.step = $f134033de58365c9$var$MAX_STEP;
                const industry = state.wizard.industries.flatMap((section)=>section.items).find((item)=>item.label === data.industry);
                if (industry) state.wizard.selectedIndustryKey = industry.id;
            }), undefined, "wizard/loadWizardData");
            get().changeDataIndustry(data.industry);
        },
        /**
   * Resets the wizard state to its initial values.
   *
   * @returns {void}
   */ resetWizard: ()=>set({
                ...$f134033de58365c9$var$initialState
            }, undefined, "wizard/resetWizard")
    });

});

parcelRegister("ODCYl", function(module, exports) {

$parcel$export(module.exports, "createPromptStorySlice", () => $098368d6e877cffd$export$82ecf0b9b270b738);

parcelRequire("aKSBi");
const $098368d6e877cffd$export$82ecf0b9b270b738 = (set, get)=>({
        story: {},
        promptStoryResponse: null,
        shouldSaveStory: false
    });

});

parcelRegister("8nzd0", function(module, exports) {

$parcel$export(module.exports, "createPromptPersonasSlice", () => $619bc874920ebeb1$export$6252319957862f1f);

var $g0I9D = parcelRequire("g0I9D");

var $aKSBi = parcelRequire("aKSBi");

var $AkKc4 = parcelRequire("AkKc4");

var $1B1zl = parcelRequire("1B1zl");

var $VXM1R = parcelRequire("VXM1R");

var $8Ogg5 = parcelRequire("8Ogg5");
const $619bc874920ebeb1$export$fc3b34886ab36d7c = async (storyId, get, set)=>{
    set({
        isPromptPersonasPending: true
    }, undefined, "promptPersonas/generatePersonas");
    get().addToast(`Generating personas details`, {
        variant: "info",
        timeout: -1
    });
    try {
        const ims = get().ims;
        const story = get().getStory(storyId);
        if (!ims || !story.industry) throw new Error("Missing required data to generate personas");
        const personas = await (0, $8Ogg5.importAllPersonas)();
        const personasPromptTemplate = `Here are 2 documents: a customer journey story script in JSON format from ${story.industry} industry and a personas list in JSON format.

In the story script there's array "personas". For each persona write a prompt that will be used to describe the persona to generate their image \u{2013} "descriptionPrompt". Include details of a person's appearance, ethnicity, characteristics, and detailed description of clothing.

Next, write a prompt that will be used to generate a profile portrait for this persona \u{2013} "avatarPrompt". Portrait should be positioned in the center of the frame with a face in a front view. Include "descriptionPrompt" in this prompt. At the end of the prompt add "Neutral background. Professional photography style."

Next, for each persona in the story, match them with one of the existing personas from the personas list using the "descriptionPrompt" that you've just generated.

Consider the following matching criteria:
1. Gender compatibility (if story says it's female, find female persona, if story says it's male, find male persona)
2. Age range similarity (if story says it's 30-40 years old, find persona in the 30-40 age range)
3. Role/profession alignment (if story says it's a customer, find a persona with "Customer" role)
4. Description characteristics that match the descriptionPrompt (if story says it's a customer, find a persona with "Customer" role)

For each match, use the "id" from the personas list as "libraryId" and the "avatarId" from the personas list as "avatarId" for the story persona. Take the "id" and "avatarId" exactly as they are in the personas list, do not make them up nor change them.

Take into consideration context of all the data in the provided script. Adjust the prompts to represent specified "industry" as well as to be aligned with the whole story script.

Don't use personas names in the prompts, but rather use their gender.`;
        const promptPersonasResponse = await (0, $aKSBi.generateContent)({
            user: ims.profile.email,
            data: {},
            prompt_template: [
                {
                    prompt_template: JSON.stringify(story),
                    role: "system"
                },
                {
                    prompt_template: JSON.stringify(personas),
                    role: "system"
                },
                {
                    prompt_template: "You are a prompt engineering expert specializing in image prompting.",
                    role: "system"
                },
                {
                    prompt_template: personasPromptTemplate,
                    role: "user"
                },
                {
                    prompt_template: "You are an assistant designed to output JSON. Please make sure to output JSON only.",
                    role: "system"
                }
            ]
        }, "Failed to fetch personas prompt");
        console.log("promptPersonasResponse:", promptPersonasResponse);
        set({
            promptPersonasResponse: promptPersonasResponse,
            isPromptPersonasPending: false
        }, undefined, "promptPersonas/generatePersonas");
        await get().parsePromptPersonasResponse(storyId, promptPersonasResponse);
    } catch (error) {
        console.error("Error generating personas:", error);
        set({
            isPromptPersonasPending: false,
            shouldGenerateImages: false
        }, undefined, "promptPersonas/generatePersonas");
        get().addToast(`Failed to generate personas details`, {
            variant: "negative",
            timeout: -1,
            actionLabel: "Retry",
            shouldCloseOnAction: true,
            onAction: ()=>{
                get().generatePersonas(storyId);
            }
        });
    }
};
const $619bc874920ebeb1$export$fc1b1facb7e1cc1e = async (storyId, promptPersonasResponse, get, set)=>{
    try {
        if (promptPersonasResponse?.chat?.choices?.[0]?.finishReason !== "stop") // TODO: handle LLM error response
        throw new Error("Failed to fetch personas prompt", promptPersonasResponse);
        const personasContext = JSON.parse(promptPersonasResponse?.chat?.choices?.[0]?.message?.content || '{"personas": []}')?.personas || [];
        console.log({
            personasContext: personasContext
        });
        // set(
        //   produce((state) => {
        //     personasContext.forEach((persona, idx) => {
        //       const storyIndex = state.stories.findIndex(
        //         (story) => story.id === storyId,
        //       );
        //       if (storyIndex === -1) {
        //         throw new Error("Story not found");
        //       }
        //       state.stories[storyIndex].personas[
        //         persona?.id ?? idx
        //       ].avatarPrompt = persona.avatarPrompt;
        //       state.stories[storyIndex].personas[
        //         persona?.id ?? idx
        //       ].descriptionPrompt = persona.descriptionPrompt;
        //       state.stories[storyIndex].personas[persona?.id ?? idx].libraryId =
        //         persona.libraryId;
        //       state.stories[storyIndex].personas[persona?.id ?? idx].avatarId =
        //         persona.avatarId;
        //     });
        //   }),
        //   undefined,
        //   "promptPersonas/parsePromptPersonasResponse",
        // );
        (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                personasContext.forEach((persona, idx)=>{
                    state.personas[persona?.id ?? idx].avatarPrompt = persona.avatarPrompt;
                    state.personas[persona?.id ?? idx].descriptionPrompt = persona.descriptionPrompt;
                    state.personas[persona?.id ?? idx].libraryId = persona.libraryId;
                    state.personas[persona?.id ?? idx].avatarId = persona.avatarId;
                });
            }));
    } catch (error) {
        console.error("Error parsing personas response:", error);
        get().addToast(`Failed to generate personas details`, {
            variant: "negative",
            timeout: -1,
            actionLabel: "Retry",
            shouldCloseOnAction: true,
            onAction: ()=>{
                get().generatePersonas(storyId);
            }
        });
    }
};
const $619bc874920ebeb1$export$6252319957862f1f = (set, get)=>({
        isPromptPersonasPending: false,
        promptPersonasResponse: null,
        generatePersonas: async (storyId)=>$619bc874920ebeb1$export$fc3b34886ab36d7c(storyId, get, set),
        parsePromptPersonasResponse: async (storyId, promptPersonasResponse)=>$619bc874920ebeb1$export$fc1b1facb7e1cc1e(storyId, promptPersonasResponse, get, set),
        /**
   * Generates images for the personas in the given story.
   *
   * @param {string} storyId - The ID of the story.
   *
   * @returns {Promise<void>} - A promise that resolves when the persona images are generated.
   * @throws {Error} If the generation fails or if the story or personas are not found.
   */ generatePersonasImages: async (storyId)=>{
            const story = get().getStory(storyId);
            const ims = get().ims;
            let counter = 0;
            // get().addToast(
            //   `Generating personas images: ${counter}/${story?.personas?.length}`,
            //   {
            //     variant: "info",
            //     timeout: -1,
            //   },
            // );
            try {
                await get().fetchImageReference(storyId);
                await Promise.allSettled(story?.personas?.map((persona, idx)=>(0, $AkKc4.fetchPersonaImages)(storyId, persona, {
                        uploadId: get().imageReferenceResponse?.id
                    }).then((personaImages)=>{
                        console.log("persona images:", idx, personaImages);
                        counter += 1;
                        // get().addToast(
                        //   `Generating personas images: ${counter}/${story?.personas?.length}`,
                        //   {
                        //     variant: "info",
                        //     timeout: -1,
                        //   },
                        // );
                        // set(
                        //   produce((state) => {
                        //     const storyIndex = state.stories.findIndex(
                        //       (story) => story.id === storyId,
                        //     );
                        //     if (storyIndex === -1) {
                        //       throw new Error("Story not found");
                        //     }
                        //     state.stories[storyIndex].personas[idx].avatarUrl =
                        //       personaImages[0]?.[0]?.url;
                        //     state.stories[storyIndex].personas[idx].avatarSeed =
                        //       personaImages[0]?.[0]?.seed;
                        //     state.stories[storyIndex].personas[idx].avatarPath =
                        //       personaImages[0]?.[0]?.path;
                        //   }),
                        //   undefined,
                        //   "promptPersonas/parsePromptPersonasResponse",
                        // );
                        (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                                state.personas[idx].avatarUrl = personaImages[0]?.[0]?.url;
                                state.personas[idx].avatarSeed = personaImages[0]?.[0]?.seed;
                                state.personas[idx].avatarPath = personaImages[0]?.[0]?.path;
                            }));
                    })));
            } catch (error) {
                console.error("Error generating personas images:", error);
                get().addToast(`Failed to generate personas images`, {
                    variant: "negative",
                    timeout: -1,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        get().generatePersonasImages(storyId);
                    }
                });
            }
        }
    });

});

parcelRegister("9vM6B", function(module, exports) {

$parcel$export(module.exports, "createPromptVisualsSlice", () => $6ecc5309f1519980$export$413069b6bb77d3ba);

var $g0I9D = parcelRequire("g0I9D");

var $aKSBi = parcelRequire("aKSBi");

var $AkKc4 = parcelRequire("AkKc4");

var $dYPl9 = parcelRequire("dYPl9");

var $1B1zl = parcelRequire("1B1zl");

var $VXM1R = parcelRequire("VXM1R");
const $6ecc5309f1519980$var$BATCH_SIZE = 10;
async function* $6ecc5309f1519980$var$generateVisualsRecursive(ims, prompt_template, length, result = {
    steps: []
}) {
    for(let page = 1; page <= Math.ceil(length / $6ecc5309f1519980$var$BATCH_SIZE); page++){
        console.log(`Generating visuals for page ${page} of ${Math.ceil(length / $6ecc5309f1519980$var$BATCH_SIZE)}`);
        const currentPrompt = [
            ...prompt_template
        ];
        if (length > $6ecc5309f1519980$var$BATCH_SIZE) currentPrompt.splice(-1, 0, {
            prompt_template: JSON.stringify(result),
            role: "system"
        }, {
            prompt_template: `You have already generated ${result.steps.length} steps. Continue generating until you reach ${Math.min(length, result.steps.length + $6ecc5309f1519980$var$BATCH_SIZE)} steps.`,
            role: "user"
        });
        const response = await (0, $aKSBi.generateContent)({
            user: ims.profile.email,
            prompt_template: currentPrompt
        }, "Failed to fetch visuals prompt");
        if (response?.chat?.choices?.[0]?.finishReason !== "stop") throw new Error("Failed to fetch visuals prompt", response);
        const content = JSON.parse(response.chat.choices[0].message.content || '{"steps": []}');
        result.steps.push(...content.steps);
        console.log({
            content: content,
            result: result
        });
        yield content;
    }
    return result;
}
/**
 * Constructs the request body for the Firefly image generation API.
 *
 * @param {Object} options - The options for the image generation request.
 * @param {string} options.model - The model to use for image generation.
 * @param {string} options.prompt - The prompt for the image generation.
 * @param {string} options.contentClass - The content class for the image.
 * @param {string} options.detailLevel - The detail level for the image.
 * @param {Object} options.size - The size of the image.
 * @param {number} options.size.width - The width of the image.
 * @param {number} options.size.height - The height of the image.
 * @param {Array<number>} options.seeds - The seeds for the image generation.
 * @param {string|null} options.uploadId - The upload ID for the image.
 * @param {Array<string>} options.presets - The presets for the image generation.
 * @param {number} options.styleStrength - The style strength for the image.
 * @param {number} options.visualIntensity - The visual intensity for the image.
 *
 * @returns {Object} - The request body for the Firefly API.
 */ const $6ecc5309f1519980$var$getFireflyImageBody = ({ model: model = (0, $AkKc4.DEFAULT_FIREFLY_MODEL), prompt: prompt = "", contentClass: contentClass = "photo", detailLevel: detailLevel = "full", size: size = {
    width: 2688,
    height: 1536
}, seeds: seeds = [], imageReferenceUrl: imageReferenceUrl = null, uploadId: uploadId = null, presets: presets = [], styleStrength: styleStrength = 50, visualIntensity: visualIntensity = 8, upsamplerType: upsamplerType = "default" } = options)=>({
        model: model,
        prompt: prompt,
        contentClass: contentClass,
        detailLevel: detailLevel,
        size: size,
        ...seeds.length > 0 ? {
            seeds: seeds
        } : {},
        ...!!imageReferenceUrl || !!uploadId || presets.length > 0 ? {
            style: {
                imageReference: {
                    source: {
                        ...imageReferenceUrl ? {
                            url: imageReferenceUrl
                        } : {},
                        ...uploadId ? {
                            uploadId: uploadId
                        } : {}
                    }
                },
                presets: presets,
                strength: styleStrength
            }
        } : {},
        visualIntensity: visualIntensity,
        upsamplerType: upsamplerType
    });
const $6ecc5309f1519980$export$413069b6bb77d3ba = (set, get)=>({
        isPromptVisualsPending: false,
        promptVisualsResponse: null,
        /**
   * Generates visuals for the given story and step.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} stepId - The ID of the step.
   *
   * @throws {Error} If the required data is missing or if the generation fails.
   * @returns {Promise<void>} - A promise that resolves when the visuals are generated.
   */ generateVisuals: async (storyId, stepId)=>{
            set({
                isPromptVisualsPending: true
            }, undefined, "promptVisuals/generateVisuals");
            get().addToast(`Generating story details`, {
                variant: "info",
                timeout: -1
            });
            try {
                const ims = get().ims;
                const story = get().getStory(storyId);
                if (!ims?.token || !ims?.profile?.email || !story.industry) throw new Error("Missing required data to generate visuals");
                const selectedStep = story.script?.find((s)=>s.id === stepId);
                if (typeof stepId !== "undefined" && !selectedStep) throw new Error(`No step found with id: ${stepId}`);
                console.log({
                    story: story
                });
                const extendedScript = (0, $g0I9D.produce)(story.script, (draft)=>{
                    draft.forEach((step, sdx)=>{
                        step?.personas?.forEach((persona, pdx)=>{
                            const { name: name, descriptionPrompt: descriptionPrompt } = story.personas.find((p)=>p.id === persona) || {};
                            if (!name || !descriptionPrompt) console.warn(`No persona details found for id: ${persona}`);
                            else draft[sdx].personas[pdx] = {
                                name: name,
                                descriptionPrompt: descriptionPrompt
                            };
                        });
                    });
                });
                console.log({
                    extendedScript: extendedScript
                });
                const introductionTemplate = `Here's a customer journey story script as a JSON formatted array.

The story is set in the ${story.industry} industry for the company called ${story.customer}.

Title:
${story.title}

Overview:
${story.storyOverview}

Business goals:
${story.businessGoals}${!!story.campaignFocus ? `

Campaign focus: ${story.campaignFocus}` : ""}`;
                const visualsPromptTemplate = `${selectedStep ? `For the step with an *id* ${selectedStep.id} and the *title* "${selectedStep.title}` : `For each item`} in the script write a prompt that will be used to generate a image visualizing this step \u{2013} "visualPrompt".
Using context of a step, describe in details the location in which it takes place.
Suggest a generic background photo that would fit the context of the step. In this case, use a generic description of the location or setting which will represent the ${story.industry} industry. Don't include any people, logos, icons, or text messages in the prompt. Don't mention any companies.
${false}
${false}
At the end of the prompt add "Professional photography style."

Next, write a prompt that will be used to generate a visual for the step including specified personas \u{2013} "personasPrompt". If there are specific personas mentioned in the "personas" field, include them in the scenario and use their "descriptionPrompt" to describe their appearance. Make sure to include all the details from "descriptionPrompt" field. Don't use personas names, but rather use their gender.
At the end of the prompt add "Professional photography style."

Take into consideration context of all the data in the provided script to with a cohesive narrative. Adjust prompts to represent specified "industry" as well as to be aligned with the whole story.
If any prompt mentions a device, like a phone or a computer, describe it as "with the screen turned off" to avoid generating anything on the screen.

Next, write a list of "tags" that will help to categorize the image. Generate short, single-word or brief phrase tags. Focus on key objects, people, actions, settings, and colors. Return only concise tags suitable for labeling, not full sentences. Make sure to include tags that represent the context of the step and the personas involved.

Make sure to generate prompts for each item in the script.

The output should contain a JSON formatted array of steps, where each step is an object with the following fields:
steps:
  *idx* \u{2013} The 0-based index of the step in the story script
  *title* \u{2013} The title of the step
  *visualPrompt*
  *personasPrompt*
  *tags*`;
                const prompt_template = [
                    {
                        prompt_template: JSON.stringify(extendedScript),
                        role: "system"
                    },
                    {
                        prompt_template: introductionTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: "You are a prompt engineering expert specializing in image prompting.",
                        role: "system"
                    },
                    {
                        prompt_template: visualsPromptTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: "You are an assistant designed to output JSON. Please make sure to output JSON only.",
                        role: "system"
                    }
                ];
                // if (selectedStep) {
                //   prompt_template.splice(0, prompt_template.length - 1, {
                //     prompt_template: `Generate output only for the step number ${selectedStep.id} with title "${selectedStep.title}"`,
                //     role: "user",
                //   });
                // }
                // const promptVisualsResponse = await generateContent(
                //   ims,
                //   {
                //     user: ims.profile.email,
                //     prompt_template,
                //   },
                //   "Failed to fetch visuals prompt",
                // );
                // console.log("promptVisualsResponse:", promptVisualsResponse);
                const parseResponsePromises = [];
                set({
                    toGenerate: stepId ? 1 : extendedScript.length,
                    currentGeneration: 0
                });
                for await (const visualsContext of $6ecc5309f1519980$var$generateVisualsRecursive(ims, prompt_template, typeof stepId !== "undefined" ? 1 : extendedScript.length)){
                    console.log("Visuals context:", visualsContext);
                    parseResponsePromises.push(get().parsePromptVisualsResponse(storyId, visualsContext?.steps ?? []));
                }
                await Promise.all(parseResponsePromises);
                set({
                    isPromptVisualsPending: false
                }, undefined, "promptVisuals/generateVisuals");
                if (typeof stepId === "undefined") get().addToast(`Generation completed`, {
                    variant: "positive",
                    timeout: 60000,
                    actionLabel: "Create Presentation",
                    onAction: ()=>{
                        set({
                            isExpressDialogOpen: true
                        });
                    }
                });
            } catch (error) {
                console.error("Error generating visuals:", error);
                set({
                    isPromptVisualsPending: false
                }, undefined, "promptVisuals/generateVisuals");
                get().addToast(`Failed to generate story images`, {
                    variant: "negative",
                    timeout: -1,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        get().generateVisuals(storyId, stepId);
                    }
                });
            }
        },
        /**
   * Fetches visuals for the given story and step using persona cc library..
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} stepId - The ID of the step.
   *
   * @throws {Error} If the required data is missing or if the generation fails.
   * @returns {Promise<void>} - A promise that resolves when the visuals are generated.
   */ fetchVisuals: async (storyId, stepId)=>{
            set({
                isPromptVisualsPending: true
            }, undefined, "promptVisuals/fetchVisuals");
            get().addToast(`Generating story details`, {
                variant: "info",
                timeout: -1
            });
            try {
                const ims = get().ims;
                const story = get().getStory(storyId);
                if (!ims || !story.industry) throw new Error("Missing required data to generate visuals");
                const selectedStep = story.script?.find((s)=>s.id === stepId);
                if (stepId && !selectedStep) throw new Error(`No step found with id: ${stepId}`);
                console.log({
                    story: story
                });
                const libraries = [];
                // Use Promise.all to properly handle async operations
                await Promise.all(story.personas.filter((persona)=>persona.libraryId) // Only fetch for personas with libraryId
                .map(async (persona)=>{
                    try {
                        const images = await (0, $dYPl9.getElements)({
                            libraryId: persona.libraryId,
                            tags: []
                        });
                        libraries.push({
                            name: persona.name,
                            libraryId: persona.libraryId,
                            images: images
                        });
                    } catch (error) {
                        console.warn(`Failed to fetch elements for persona ${persona.name}:`, error);
                    // Continue with other personas even if one fails
                    }
                }));
                const extendedScript = (0, $g0I9D.produce)(story.script, (draft)=>{
                    draft.forEach((step, sdx)=>{
                        step?.personas?.forEach((persona, pdx)=>{
                            const { name: name, descriptionPrompt: descriptionPrompt, libraryId: libraryId, avatarId: avatarId } = story.personas.find((p)=>p.id === persona) || {};
                            if (!name || !descriptionPrompt) console.warn(`No persona details found for id: ${persona}`);
                            else draft[sdx].personas[pdx] = {
                                name: name,
                                descriptionPrompt: descriptionPrompt,
                                libraryId: libraryId,
                                avatarId: avatarId
                            };
                        });
                    });
                });
                console.log({
                    extendedScript: extendedScript
                });
                const introductionTemplate = `Here are 2 documents: a customer journey story script as a JSON formatted array and a personas library as a JSON formatted array.

The story is set in the ${story.industry} industry for the company called ${story.customer}.

Title:
${story.title}

Overview:
${story.storyOverview}

Business goals:
${story.businessGoals}${!!story.campaignFocus ? `

Campaign focus: ${story.campaignFocus}` : ""}`;
                const visualsPromptTemplate = `${selectedStep ? `For the step with an *id* ${selectedStep.id} and the *title* "${selectedStep.title}` : `For each item`} in the script write a prompt that will be used to generate a image visualizing this step \u{2013} "visualPrompt".
Using context of a step, describe in details the location in which it takes place.
Suggest a generic background photo that would fit the context of the step. In this case, use a generic description of the location or setting which will represent the ${story.industry} industry. Don't include any people, logos, icons, or text messages in the prompt. Don't mention any companies.
${false}
${false}
At the end of the prompt add "Professional photography style."

Next, write a prompt that will be used to generate a visual for the step including specified personas \u{2013} "personasPrompt". If there are specific personas mentioned in the "personas" field, include them in the scenario and use their "descriptionPrompt" to describe their appearance. Make sure to include all the details from "descriptionPrompt" field. Don't use personas names, but rather use their gender.
At the end of the prompt add "Professional photography style."

Take into consideration context of all the data in the provided script to with a cohesive narrative. Adjust prompts to represent specified "industry" as well as to be aligned with the whole story.
If any prompt mentions a device, like a phone or a computer, describe it as "with the screen turned off" to avoid generating anything on the screen.

Make sure to generate prompts for each item in the script.`;
                const personasPromptTemplate = `${selectedStep ? `For the step with an *id* ${selectedStep.id} and the *title* "${selectedStep.title}` : `For each item`} in the script find the best matching image from the provided personas library.

1. For each persona mentioned in the step's "personas" field:
   - Find the matching persona in personas library by comparing the persona's "libraryId" field
   - Each persona item consists of "name", "libraryId", "images" fields.
   - Look through that persona's "images" array to find the best matching image.
   - Do not assume that the first image is the best match, but rather find the best match based on the scoring criteria.
   - Do not alter the original image's "id" or "name" fields. Take them exactly as they are in the library.

2. When selecting the best image, consider:
   - The step's context and title
   - The persona's description and role in the step
   - The generated visualPrompt and personasPrompt
   - The image's "description" and "tags" fields
   - How well the image fits the step's setting and action (the image shouldn't be a generic setting, but rather a specific setting that matches the step's context)

3. Scoring criteria for image selection:
   - Relevance to step context (highest priority)
   - Match with persona's role and description (if the persona is a customer, the image should be a customer setting)
   - Appropriate setting/environment (the image should be a specific setting that matches the step's context)
   - Professional appearance (the image should be a professional appearance)
   - Industry-appropriate attire and setting (the image should be an industry-appropriate attire and setting)

4. For the selected image, save:
   - "libraryId": The persona's library ID
   - "visualId": The selected image's "id" field
   - "visualName": The selected image's "name" field

If no personas are mentioned in the step, or if no suitable images are found, set both "libraryId" and "visualId" to null.

Next, check if the selected "visualId" is present in the "images" array of the persona with selected "libraryId". If it is not, start over and find the best matchin image.
`;
                const prompt_template = [
                    {
                        prompt_template: JSON.stringify(extendedScript),
                        role: "system"
                    },
                    {
                        prompt_template: JSON.stringify(libraries),
                        role: "system"
                    },
                    {
                        prompt_template: introductionTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: "You are a prompt engineering expert specializing in image prompting.",
                        role: "system"
                    },
                    {
                        prompt_template: visualsPromptTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: personasPromptTemplate,
                        role: "user"
                    },
                    {
                        prompt_template: `The output should contain a JSON formatted array of steps, where each step is an object with the following fields:
            steps:
              *idx* \u{2013} The 0-based index of the step in the story script
              *title* \u{2013} The title of the step
              *visualPrompt*
              *personasPrompt*
              *libraryId* \u{2013} The library ID of the selected image (or null if none selected)
              *visualId* \u{2013} The ID of the selected image (or null if none selected),
              *visualName* \u{2013} The name of the selected image (or null if none selected)`,
                        role: "user"
                    },
                    {
                        prompt_template: "You are an assistant designed to output JSON. Please make sure to output JSON only.",
                        role: "system"
                    }
                ];
                // if (selectedStep) {
                //   prompt_template.splice(0, prompt_template.length - 1, {
                //     prompt_template: `Generate output only for the step number ${selectedStep.id} with title "${selectedStep.title}"`,
                //     role: "user",
                //   });
                // }
                // const promptVisualsResponse = await generateContent(
                //   ims,
                //   {
                //     user: ims.profile.email,
                //     prompt_template,
                //   },
                //   "Failed to fetch visuals prompt",
                // );
                // console.log("promptVisualsResponse:", promptVisualsResponse);
                const parseResponsePromises = [];
                set({
                    toGenerate: stepId ? 1 : extendedScript.length,
                    currentGeneration: 0
                });
                for await (const visualsContext of $6ecc5309f1519980$var$generateVisualsRecursive(ims, prompt_template, stepId ? 1 : extendedScript.length)){
                    console.log("Visuals context:", visualsContext);
                    parseResponsePromises.push(get().parseFetchVisualsResponse(storyId, visualsContext?.steps ?? []));
                }
                await Promise.all(parseResponsePromises);
                set({
                    isPromptVisualsPending: false
                }, undefined, "promptVisuals/fetchVisuals");
                get().addToast(`Generation completed`, {
                    variant: "positive",
                    timeout: 60000,
                    actionLabel: "Create Presentation",
                    onAction: ()=>{
                        set({
                            isExpressDialogOpen: true
                        });
                    }
                });
            } catch (error) {
                console.error("Error generating visuals:", error);
                set({
                    isPromptVisualsPending: false
                }, undefined, "promptVisuals/fetchVisuals");
                if (!stepId) get().addToast(`Failed to generate story images`, {
                    variant: "negative",
                    timeout: -1,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        get().fetchVisuals(storyId);
                    }
                });
            }
        },
        /**
   *
   * @param {string} storyId
   * @param {*} visualsContext
   *
   * @returns {Promise<void>} - A promise that resolves when the visuals are parsed and updated in the story.
   * @throws {Error} If the response is invalid or if the parsing fails.
   */ parsePromptVisualsResponse: async (storyId, visualsContext)=>{
            try {
                // if (promptVisualsResponse?.chat?.choices?.[0]?.finishReason !== "stop") {
                //   // TODO: handle LLM error response
                //   throw new Error(
                //     "Failed to fetch visuals prompt",
                //     promptVisualsResponse,
                //   );
                // }
                // const visualsContext =
                //   JSON.parse(
                //     promptVisualsResponse?.chat?.choices?.[0]?.message?.content ||
                //       '{"steps": []}',
                //   )?.steps || [];
                console.log({
                    visualsContext: visualsContext
                });
                // set(
                //   produce((state) => {
                //     visualsContext.forEach((step, idx) => {
                //       const storyIndex = state.stories.findIndex(
                //         (story) => story.id === storyId,
                //       );
                //       if (storyIndex === -1) {
                //         throw new Error("Story not found");
                //       }
                //       state.stories[storyIndex].script[step.idx ?? idx].visualPrompt =
                //         state.stories[storyIndex].script[step.idx ?? idx]?.personas
                //           ?.length
                //           ? (step?.personasPrompt ?? step.visualPrompt)
                //           : step.visualPrompt;
                //       state.stories[storyIndex].script[step.idx ?? idx].visualTags =
                //         step.tags;
                //     });
                //   }),
                //   undefined,
                //   "promptVisuals/parsePromptVisualsResponse",
                // );
                // get().saveStory(storyId);
                (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                        visualsContext.forEach((step, idx)=>{
                            state.script[step.idx ?? idx].visualPrompt = state.script[step.idx ?? idx]?.personas?.length ? step?.personasPrompt ?? step.visualPrompt : step.visualPrompt;
                            state.script[step.idx ?? idx].visualTags = step.tags;
                        });
                    }));
                get().addToast(`Generating story images: ${get().currentGeneration}/${get().toGenerate}`, {
                    variant: "info",
                    timeout: -1
                });
                await get().fetchImageReference(storyId);
                const visualsPromises = visualsContext.map((step)=>{
                    try {
                        const story = get().getStory(storyId);
                        if (!story) {
                            console.warn(`No story found with id: ${storyId}`);
                            return;
                        }
                        const storyStep = story.script[step.idx];
                        if (!storyStep) {
                            console.warn(`No story step found for index ${step.idx} in visuals context`);
                            return;
                        }
                        const visualPrompt = storyStep?.personas?.length ? step?.personasPrompt ?? step.visualPrompt : step.visualPrompt;
                        if (!visualPrompt || typeof step.idx !== "number") return;
                        console.log("visual prompt:", step.idx, visualPrompt);
                        const personaAvatarSeed = story?.personas?.[storyStep?.personas?.[0]]?.avatarSeed;
                        return (0, $AkKc4.fetchFireflyImage)(storyId, $6ecc5309f1519980$var$getFireflyImageBody({
                            prompt: visualPrompt,
                            ...personaAvatarSeed ? {
                                seeds: [
                                    personaAvatarSeed
                                ]
                            } : {},
                            uploadId: get().imageReferenceResponse?.id
                        })).then((visualImages)=>{
                            if (!visualImages?.length) {
                                console.warn(`No images found for step ${step.idx} with prompt: ${visualPrompt}`);
                                return;
                            }
                            set((state)=>({
                                    currentGeneration: state.currentGeneration + 1
                                }));
                            get().addToast(`Generating story images: ${get().currentGeneration}/${get().toGenerate}`, {
                                variant: "info",
                                timeout: -1
                            });
                            //   generationToast(
                            //     `Generating visuals: ${counter}/${visualsContext.length}`,
                            //   );
                            console.log("visual images:", step.idx, visualImages);
                            // set(
                            //   produce((state) => {
                            //     const storyIndex = state.stories.findIndex(
                            //       (story) => story.id === storyId,
                            //     );
                            //     if (storyIndex === -1) {
                            //       throw new Error("Story not found");
                            //     }
                            //     state.stories[storyIndex].script[step.idx].visualUrl =
                            //       visualImages?.[0]?.url;
                            //     state.stories[storyIndex].script[step.idx].visualSeed =
                            //       visualImages?.[0]?.seed;
                            //     state.stories[storyIndex].script[step.idx].visuals =
                            //       state.stories[storyIndex].script[step.idx]?.visuals ?? [];
                            //     state.stories[storyIndex].script[step.idx].visuals.push({
                            //       url: visualImages?.[0]?.url,
                            //       seed: visualImages?.[0]?.seed,
                            //       path: visualImages?.[0]?.path,
                            //       prompt: visualPrompt,
                            //     });
                            //     state.stories[storyIndex].script[step.idx].visual =
                            //       state.stories[storyIndex].script[step.idx].visuals.length - 1;
                            //   }),
                            //   undefined,
                            //   "promptVisuals/parsePromptVisualsResponse",
                            // );
                            (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                                    state.script[step.idx].visuals = state.script[step.idx]?.visuals ?? [];
                                    state.script[step.idx].visuals.push({
                                        url: visualImages?.[0]?.url,
                                        seed: visualImages?.[0]?.seed,
                                        path: visualImages?.[0]?.path,
                                        prompt: visualPrompt,
                                        type: "firefly"
                                    });
                                    state.script[step.idx].visual = state.script[step.idx].visuals.length - 1;
                                }));
                        });
                    } catch (error) {
                        console.error(`Failed to fetch image for step ${step.title}:`, error);
                        return Promise.reject(error);
                    }
                });
                // Promise.race(visualsContext).then(() => {
                //   set(
                //     { promptVisualsResponse: promptVisualsResponse },
                //     undefined,
                //     "promptVisuals/parsePromptVisualsResponse",
                //   );
                // });
                await Promise.allSettled(visualsPromises);
            // get().saveStory(storyId);
            //   generationToast("Generation completed", {
            //     variant: "positive",
            //     actionLabel: "Create Presentation",
            //     onAction: () => {
            //       setState((state) => ({
            //         ...state,
            //         isExpressDialogOpen: true,
            //       }));
            //     },
            //   });
            // await new Promise(() => {
            //   setTimeout(() => {
            //     // generationToast("", { isGenerating: false })
            //     resolve();
            //   }, 10000);
            // });
            } catch (error) {
                console.error("Error parsing visuals response:", error);
                get().addToast(`Failed to generate story images`, {
                    variant: "negative",
                    timeout: -1,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        get().generateVisuals(storyId);
                    }
                });
            }
        },
        /**
   *
   * @param {string} storyId
   * @param {*} visualsContext
   *
   * @returns {Promise<void>} - A promise that resolves when the visuals are parsed and updated in the story.
   * @throws {Error} If the response is invalid or if the parsing fails.
   */ parseFetchVisualsResponse: async (storyId, visualsContext)=>{
            try {
                // if (promptVisualsResponse?.chat?.choices?.[0]?.finishReason !== "stop") {
                //   // TODO: handle LLM error response
                //   throw new Error(
                //     "Failed to fetch visuals prompt",
                //     promptVisualsResponse,
                //   );
                // }
                const ims = get().ims;
                // const visualsContext =
                //   JSON.parse(
                //     promptVisualsResponse?.chat?.choices?.[0]?.message?.content ||
                //       '{"steps": []}',
                //   )?.steps || [];
                console.log({
                    visualsContext: visualsContext
                });
                // set(
                //   produce((state) => {
                //     visualsContext.forEach((step, idx) => {
                //       const storyIndex = state.stories.findIndex(
                //         (story) => story.id === storyId,
                //       );
                //       if (storyIndex === -1) {
                //         throw new Error("Story not found");
                //       }
                //       state.stories[storyIndex].script[step.idx ?? idx].visualPrompt =
                //         state.stories[storyIndex].script[step.idx ?? idx]?.personas
                //           ?.length
                //           ? (step?.personasPrompt ?? step.visualPrompt)
                //           : step.visualPrompt;
                //       state.stories[storyIndex].script[step.idx ?? idx].visualId = state
                //         .stories[storyIndex].script[step.idx ?? idx]?.personas?.length
                //         ? step.visualId
                //         : null;
                //     });
                //   }),
                //   undefined,
                //   "promptVisuals/parseFetchVisualsResponse",
                // );
                // get().saveStory(storyId);
                (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                        visualsContext.forEach((step, idx)=>{
                            state.script[step.idx ?? idx].visualPrompt = state.script[step.idx ?? idx]?.personas?.length ? step?.personasPrompt ?? step.visualPrompt : step.visualPrompt;
                            const visualPrompt = state.script[step.idx ?? idx]?.personas?.length ? step?.personasPrompt ?? step.visualPrompt : step.visualPrompt;
                            state.script[step.idx ?? idx].visualPrompt = visualPrompt;
                            if (step.visualId && step.libraryId) {
                                state.script[step.idx].visuals = state.script[step.idx]?.visuals ?? [];
                                state.script[step.idx].visuals.push({
                                    id: step.visualId,
                                    libraryId: step.libraryId,
                                    visualName: step.visualName,
                                    prompt: visualPrompt,
                                    type: "cc-library"
                                });
                                state.script[step.idx].visual = state.script[step.idx].visuals.length - 1;
                            }
                        });
                    }));
                get().addToast(`Generating story images: ${get().currentGeneration}/${get().toGenerate}`, {
                    variant: "info",
                    timeout: -1
                });
                await get().fetchImageReference(storyId);
                const visualsPromises = visualsContext.map((step)=>{
                    try {
                        const story = get().getStory(storyId);
                        if (!story) {
                            console.warn(`No story found with id: ${storyId}`);
                            return;
                        }
                        const storyStep = story.script[step.idx];
                        if (!storyStep) {
                            console.warn(`No story step found for index ${step.idx} in visuals context`);
                            return;
                        }
                        const visualPrompt = storyStep?.personas?.length ? step?.personasPrompt ?? step.visualPrompt : step.visualPrompt;
                        if (!visualPrompt || typeof step.idx !== "number") return;
                        console.log("visual prompt:", step.idx, visualPrompt);
                        const personaAvatarSeed = null;
                        if (!step.visualId) return (0, $AkKc4.fetchFireflyImage)(storyId, $6ecc5309f1519980$var$getFireflyImageBody({
                            prompt: visualPrompt,
                            ...personaAvatarSeed ? {
                                seeds: [
                                    personaAvatarSeed
                                ]
                            } : {},
                            uploadId: get().imageReferenceResponse?.id
                        })).then((visualImages)=>{
                            if (!visualImages?.length) {
                                console.warn(`No images found for step ${step.idx} with prompt: ${visualPrompt}`);
                                return;
                            }
                            set((state)=>({
                                    currentGeneration: state.currentGeneration + 1
                                }));
                            get().addToast(`Generating story images: ${get().currentGeneration}/${get().toGenerate}`, {
                                variant: "info",
                                timeout: -1
                            });
                            //   generationToast(
                            //     `Generating visuals: ${counter}/${visualsContext.length}`,
                            //   );
                            console.log("visual images:", step.idx, visualImages);
                            // set(
                            //   produce((state) => {
                            //     const storyIndex = state.stories.findIndex(
                            //       (story) => story.id === storyId,
                            //     );
                            //     if (storyIndex === -1) {
                            //       throw new Error("Story not found");
                            //     }
                            //     state.stories[storyIndex].script[step.idx].visualUrl =
                            //       visualImages?.[0]?.url;
                            //     state.stories[storyIndex].script[step.idx].visualSeed =
                            //       visualImages?.[0]?.seed;
                            //     state.stories[storyIndex].script[step.idx].visuals =
                            //       state.stories[storyIndex].script[step.idx]?.visuals ?? [];
                            //     state.stories[storyIndex].script[step.idx].visuals.push({
                            //       url: visualImages?.[0]?.url,
                            //       seed: visualImages?.[0]?.seed,
                            //       path: visualImages?.[0]?.path,
                            //       prompt: visualPrompt,
                            //     });
                            //     state.stories[storyIndex].script[step.idx].visual =
                            //       state.stories[storyIndex].script[step.idx].visuals.length -
                            //       1;
                            //   }),
                            //   undefined,
                            //   "promptVisuals/parsePromptVisualsResponse",
                            // );
                            (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                                    state.script[step.idx].visuals = state.script[step.idx]?.visuals ?? [];
                                    state.script[step.idx].visuals.push({
                                        url: visualImages?.[0]?.url,
                                        seed: visualImages?.[0]?.seed,
                                        path: visualImages?.[0]?.path,
                                        prompt: visualPrompt,
                                        type: "firefly"
                                    });
                                    state.script[step.idx].visual = state.script[step.idx].visuals.length - 1;
                                }));
                        });
                        else // set(
                        //   produce((state) => {
                        //     const storyIndex = state.stories.findIndex(
                        //       (story) => story.id === storyId,
                        //     );
                        //     if (storyIndex === -1) {
                        //       throw new Error("Story not found");
                        //     }
                        //     state.stories[storyIndex].script[step.idx].visuals =
                        //       state.stories[storyIndex].script[step.idx]?.visuals ?? [];
                        //     state.stories[storyIndex].script[step.idx].visuals.push({
                        //       id: step.visualId,
                        //       libraryId: step.libraryId,
                        //       visualName: step.visualName,
                        //       prompt: visualPrompt,
                        //     });
                        //     state.stories[storyIndex].script[step.idx].visual =
                        //       state.stories[storyIndex].script[step.idx].visuals.length - 1;
                        //   }),
                        //   undefined,
                        //   "promptVisuals/parsePromptVisualsResponse",
                        // );
                        (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                                state.script[step.idx].visuals = state.script[step.idx]?.visuals ?? [];
                                state.script[step.idx].visuals.push({
                                    id: step.visualId,
                                    libraryId: step.libraryId,
                                    visualName: step.visualName,
                                    prompt: visualPrompt,
                                    type: "firefly"
                                });
                                state.script[step.idx].visual = state.script[step.idx].visuals.length - 1;
                            }));
                    } catch (error) {
                        console.error(`Failed to fetch image for step ${step.title}:`, error);
                        return Promise.reject(error);
                    }
                });
                // Promise.race(visualsContext).then(() => {
                //   set(
                //     { promptVisualsResponse: promptVisualsResponse },
                //     undefined,
                //     "promptVisuals/parsePromptVisualsResponse",
                //   );
                // });
                await Promise.allSettled(visualsPromises);
            // get().saveStory(storyId);
            //   generationToast("Generation completed", {
            //     variant: "positive",
            //     actionLabel: "Create Presentation",
            //     onAction: () => {
            //       setState((state) => ({
            //         ...state,
            //         isExpressDialogOpen: true,
            //       }));
            //     },
            //   });
            // await new Promise(() => {
            //   setTimeout(() => {
            //     // generationToast("", { isGenerating: false })
            //     resolve();
            //   }, 10000);
            // });
            } catch (error) {
                console.error("Error parsing visuals response:", error);
                get().addToast(`Failed to generate story images`, {
                    variant: "negative",
                    timeout: -1,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        get().fetchVisuals(storyId);
                    }
                });
            }
        },
        isRegenerateVisualPending: false,
        /**
   * Regenerates the visual for a specific step in the story.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} stepId - The ID of the step.
   * @param {string} prompt - The prompt to use for generating the visual.
   * @param {string} seed - The seed to use for generating the visual.
   *
   * @returns {Promise<void>} - A promise that resolves when the visual is regenerated.
   * @throws {Error} If the step is not found or if the visual generation fails
   */ regenerateVisual: async (storyId, stepId, prompt, seed)=>{
            set({
                isRegenerateVisualPending: true
            });
            const story = get().getStory(storyId);
            const step = story?.script[stepId];
            try {
                if (!step) throw new Error(`No step found for index ${stepId} to regenerate visual`);
                const visualPrompt = prompt ?? step?.visualPrompt;
                const visualSeed = seed ?? story?.personas?.[step?.personas?.[0]]?.avatarSeed;
                if (!visualPrompt) throw new Error(`No prompt found for step index ${stepId} to regenerate visual`);
                await get().fetchImageReference(storyId);
                const visualImages = await (0, $AkKc4.fetchFireflyImage)(storyId, $6ecc5309f1519980$var$getFireflyImageBody({
                    prompt: visualPrompt,
                    ...visualSeed ? {
                        seeds: [
                            visualSeed
                        ]
                    } : {},
                    uploadId: get().imageReferenceResponse?.id
                }));
                if (!visualImages?.length) throw new Error(`Failed to regenerate visual for step ${stepId} with prompt: ${visualPrompt}`);
                // set(
                //   produce((state) => {
                //     const storyIndex = state.stories.findIndex(
                //       (story) => story.id === storyId,
                //     );
                //     if (storyIndex === -1) {
                //       throw new Error("Story not found");
                //     }
                //     // TODO: remove visualUrl and visualSeed from step
                //     // and use visuals array instead
                //     state.stories[storyIndex].script[stepId].visualUrl =
                //       visualImages[0].url;
                //     state.stories[storyIndex].script[stepId].visualSeed =
                //       visualImages[0].seed;
                //     state.stories[storyIndex].script[stepId].visuals =
                //       state.stories[storyIndex].script[stepId].visuals || [];
                //     state.stories[storyIndex].script[stepId].visuals.push({
                //       url: visualImages[0]?.url,
                //       path: visualImages[0]?.path,
                //       seed: visualImages[0]?.seed,
                //       prompt: visualPrompt,
                //     });
                //     state.stories[storyIndex].script[stepId].visual =
                //       state.stories[storyIndex].script[stepId].visuals.length - 1;
                //     state.isRegenerateVisualPending = false;
                //   }),
                //   undefined,
                //   "promptVisuals/regenerateVisual",
                // );
                // get().saveStory(storyId);
                (0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (state)=>{
                        state.script[stepId].visuals = state.script[stepId].visuals || [];
                        state.script[stepId].visuals.push({
                            url: visualImages[0]?.url,
                            path: visualImages[0]?.path,
                            seed: visualImages[0]?.seed,
                            prompt: visualPrompt,
                            type: "firefly"
                        });
                        state.script[stepId].visual = state.script[stepId].visuals.length - 1;
                    }));
                get().addToast(`Visual regenerated successfully`, {
                    variant: "positive",
                    timeout: 5000
                });
            } catch (error) {
                console.error(`Failed to regenerate visual for step ${stepId}:`, error);
                set({
                    isRegenerateVisualPending: false
                });
                get().addToast(`Failed to regenerate visual`, {
                    variant: "negative",
                    timeout: -1,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        get().regenerateVisual(storyId, stepId, prompt, seed);
                    }
                });
            }
        },
        /**
   * Generates a similar visual for the given story and step.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} stepId - The ID of the step.
   * @param {string} prompt - The prompt to use for generating the visual.
   *
   * @returns {Promise<void>} - A promise that resolves when the similar visual is generated.
   * @throws {Error} If the step is not found or if the visual generation fails
   */ generateSimilarVisual: async (storyId, stepId, prompt)=>{
            get().regenerateVisual(storyId, stepId, prompt, get().getStory(storyId)?.script[stepId]?.visualSeed);
        },
        /**
   * Regenerates the visual context for a specific step in the story.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} stepId - The ID of the step.
   * @param {*} update - The update to apply to the visual context.
   *
   * @returns {Promise<void>} - A promise that resolves when the visual context is regenerated.
   * @throws {Error} If the story or step is not found, or if the
   */ regenerateVisualContext: async (storyId, stepId, update)=>{
            set({
                isRegenerateVisualPending: true
            });
            console.log("regenerateVisualContext", storyId, stepId, update);
            try {
                const story = get().getStory(storyId);
                if (!story) throw new Error(`No story found with id: ${storyId}`);
                if (!story.script.find((s)=>s.id === stepId)) throw new Error(`No step found with id: ${stepId}`);
                get().updateStoryScriptItem(storyId, stepId, update);
                await get().generateVisuals(storyId, stepId);
                set({
                    isRegenerateVisualPending: false
                });
            } catch (error) {
                console.error("Error regenerating visual context:", error);
                set({
                    isRegenerateVisualPending: false
                });
            }
        },
        browseVisuals: (story)=>{
            console.log("browseVisuals", story);
        },
        /**
   * Sets the image reference for the prompt visuals.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} imageReference - The image reference URL to set.
   *
   * @returns {void}
   */ setImageReference: (storyId, imageReference)=>(0, $1B1zl.queryClient).setQueryData((0, $VXM1R.storyKey).detail(storyId), (oldData)=>(0, $g0I9D.produce)(oldData, (draft)=>{
                    if (draft) draft.imageReference = imageReference;
                })),
        /**
   * Generates visuals for the given story and step.
   *
   * @param {string} storyId - The ID of the story.
   * @param {string} stepId - The ID of the step.
   *
   * @returns {Promise<void>} - A promise that resolves when the visuals are generated.
   * @throws {Error} If the required data is missing or if the generation fails.
   */ imageReferenceResponse: null,
        /**
   * Fetches the image reference and uploads it to Firefly storage.
   *
   * @param {string} storyId - The ID of the story.
   *
   * @returns {Promise<void>} - A promise that resolves when the image reference is fetched and uploaded.
   */ fetchImageReference: async (storyId)=>{
            const imageReference = get().getStory(storyId)?.imageReference;
            if (!imageReference) {
                console.warn("No image reference set, skipping fetch.");
                return;
            }
            if (get().imageReferenceResponse?.filePath === imageReference.filePath) {
                console.log("Image reference already fetched, skipping fetch.");
                return;
            }
            if (!get().imageReferenceResponse || get().imageReferenceResponse?.filePath !== imageReference.filePath) try {
                const imageReferenceResponse = await (0, $AkKc4.uploadFireflyImage)(imageReference.url);
                set({
                    imageReferenceResponse: imageReferenceResponse
                }, undefined, "promptVisuals/fetchImageReference");
            } catch (error) {
                console.error("Failed to upload image reference:", error);
            }
        }
    });

});


parcelRegister("3NGKk", function(module, exports) {

$parcel$export(module.exports, "PreviewPasswordPopover", () => $2c471b3ca6740719$export$934e91ec8f383eee);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $5nTep = parcelRequire("5nTep");
var $2ffAV = parcelRequire("2ffAV");
var $208Op = parcelRequire("208Op");
var $8u8Xx = parcelRequire("8u8Xx");

var $j2JDe = parcelRequire("j2JDe");

var $3h1XC = parcelRequire("3h1XC");

var $9f9st = parcelRequire("9f9st");
// How long the popover waits to close, so the pointer can cross the gap
// between the section and the popover.
const $2c471b3ca6740719$var$CLOSE_DELAY = 150;
const $2c471b3ca6740719$var$wrapperStyle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' ob182';
    rules += ' nb182';
    rules += ' kb182';
    rules += ' jb182';
    return rules;
};
// Presses and keys in the popover must not reach what the section lives in
// (a card, say) — the popover is its child in the React tree. Escape is left
// to close the popover.
const $2c471b3ca6740719$var$stopPropagation = (e)=>e.stopPropagation();
const $2c471b3ca6740719$var$stopKeyPropagation = (e)=>{
    if (e.key !== "Escape") e.stopPropagation();
};
const $2c471b3ca6740719$export$934e91ec8f383eee = ({ password: password, children: children, styles: styles, label: label = "Preview", onOpenChange: onOpenChange })=>{
    const [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    const triggerRef = (0, $eF4cA.useRef)(null);
    const closeTimer = (0, $eF4cA.useRef)(null);
    const setOpen = (value)=>{
        setIsOpen(value);
        onOpenChange?.(value);
    };
    const open = ()=>{
        clearTimeout(closeTimer.current);
        setOpen(true);
    };
    const scheduleClose = ()=>{
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>setOpen(false), $2c471b3ca6740719$var$CLOSE_DELAY);
    };
    (0, $eF4cA.useEffect)(()=>()=>clearTimeout(closeTimer.current), []);
    const { hoverProps: triggerHoverProps } = (0, $j2JDe.useHover)({
        onHoverStart: open,
        onHoverEnd: scheduleClose
    });
    const { hoverProps: popoverHoverProps } = (0, $j2JDe.useHover)({
        onHoverStart: open,
        onHoverEnd: scheduleClose
    });
    const { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)({
        within: false
    });
    const hasPassword = typeof password === "string" && !!password;
    const copyPassword = async ()=>{
        try {
            await navigator.clipboard.writeText(password);
            (0, $8u8Xx.ToastQueue).positive("Password copied", {
                timeout: 3000
            });
        } catch  {
            (0, $8u8Xx.ToastQueue).negative("Could not copy the password", {
                timeout: 5000
            });
        }
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                ref: triggerRef,
                ...hasPassword ? {
                    ...triggerHoverProps,
                    ...focusProps,
                    tabIndex: 0,
                    role: "group",
                    "aria-label": label,
                    onFocus: (e)=>{
                        focusProps.onFocus?.(e);
                        open();
                    },
                    onBlur: (e)=>{
                        focusProps.onBlur?.(e);
                        scheduleClose();
                    }
                } : {},
                className: (0, $5nTep.mergeStyles)($2c471b3ca6740719$var$wrapperStyle({
                    isFocusVisible: hasPassword && isFocusVisible
                }), styles),
                children: children
            }),
            hasPassword && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                triggerRef: triggerRef,
                isOpen: isOpen,
                onOpenChange: setOpen,
                placement: "top",
                hideArrow: true,
                isNonModal: true,
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    ...popoverHoverProps,
                    onFocus: open,
                    onBlur: scheduleClose,
                    onPointerDown: $2c471b3ca6740719$var$stopPropagation,
                    onMouseDown: $2c471b3ca6740719$var$stopPropagation,
                    onClick: $2c471b3ca6740719$var$stopPropagation,
                    onKeyDown: $2c471b3ca6740719$var$stopKeyPropagation,
                    onKeyUp: $2c471b3ca6740719$var$stopKeyPropagation,
                    className: " sd182 eb182 Ue182 qe182 Te182 Qe182 Se182 Re182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                            children: [
                                "Password:",
                                " ",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 Is182",
                                    children: password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            "aria-label": "Copy password",
                            isQuiet: true,
                            size: "S",
                            onPress: copyPassword,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {})
                        })
                    ]
                })
            })
        ]
    });
};
$2c471b3ca6740719$export$934e91ec8f383eee.propTypes = {
    password: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};

});
parcelRegister("2ffAV", function(module, exports) {

$parcel$export(module.exports, "PopoverContext", () => $80dcd4fb498958b2$export$9b9a0cd73afb7ca4);
$parcel$export(module.exports, "InPopoverContext", () => $80dcd4fb498958b2$export$60dfb2c3202ad27d);
$parcel$export(module.exports, "Popover", () => $80dcd4fb498958b2$export$5b6b19405a83ff9d);


var $arisx = parcelRequire("arisx");

var $5nTep = parcelRequire("5nTep");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eENmv = parcelRequire("eENmv");
var $f8UJ0 = parcelRequire("f8UJ0");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $8gDpA = parcelRequire("8gDpA");

var $bkjeZ = parcelRequire("bkjeZ");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $80dcd4fb498958b2$var$$88b746eba92c8d0d$var$popover = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.colorScheme === "dark") rules += ' -ICUGx-_pa182';
    else if (props.colorScheme === "light") rules += ' -ICUGx-_pb182';
    else if (props.colorScheme === "light dark") {
        rules += ' -ICUGx-_pb182';
        rules += ' -ICUGx-D1v0V_pa182';
    }
    rules += ' _pK8eoyd182';
    if (props.colorScheme === "dark") rules += ' -NvXmrd-_ZLmU182';
    else if (props.colorScheme === "light") rules += ' -NvXmrd-_ZN8Gi4c182';
    else if (props.colorScheme === "light dark") {
        rules += ' -NvXmrd-_ZN8Gi4c182';
        rules += ' -NvXmrd-D1v0V_ZLmU182';
    }
    if (props.colorScheme === "dark") rules += ' -j9blY-_ZN8Gi4c182';
    else if (props.colorScheme === "light") rules += ' -j9blY-_ZLmU182';
    else if (props.colorScheme === "light dark") {
        rules += ' -j9blY-_ZLmU182';
        rules += ' -j9blY-D1v0V_ZN8Gi4c182';
    }
    rules += ' -Ovbhqd-g_g182';
    rules += ' -Ovbhqd-lga182';
    rules += ' gEzkoQe182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    if (props.isArrowShown) rules += ' _rgr5H3d182';
    if (props.isArrowShown) rules += ' _nd182';
    else rules += ' _nLeasBb182';
    rules += ' _Lf182';
    rules += ' _Mb182';
    rules += ' Oye39g182';
    rules += ' Ola182';
    if (props.size === "L") {
        if (!width) rules += ' ZE182';
    } else if (props.size === "M") {
        if (!width) rules += ' ZB182';
    } else if (props.size === "S") {
        if (!width) rules += ' Zz182';
    }
    if (!maxWidth) rules += ' LEmL1Zb182';
    rules += ' _oa182';
    rules += ' sd182';
    if (props.isExiting) rules += ' _Ia182';
    else if (props.isEntering) rules += ' _Ia182';
    if (props.isSubmenu) {
        rules += ' -_8PloMd-s182';
        rules += ' __Ya182';
    } else if (props.placement === "bottom") {
        if (props.isExiting) {
            rules += ' -_8PloMd-l182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_8PloMd-l182';
            rules += ' __Ya182';
        }
    } else if (props.placement === "top") {
        if (props.isExiting) {
            rules += ' -_8PloMd-F182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_8PloMd-F182';
            rules += ' __Ya182';
        }
    }
    if (props.isSubmenu) {
        rules += ' -_7PloMd-s182';
        rules += ' __Ya182';
    } else if (props.placement === "right") {
        if (props.isExiting) {
            rules += ' -_7PloMd-m182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_7PloMd-m182';
            rules += ' __Ya182';
        }
    } else if (props.placement === "left") {
        if (props.isExiting) {
            rules += ' -_7PloMd-G182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_7PloMd-G182';
            rules += ' __Ya182';
        }
    }
    rules += ' YmenWad182';
    rules += ' Xc182';
    if (props.isExiting) rules += ' _2c182';
    rules += ' _Bb182';
    if (props.isExiting) rules += ' _Ob182';
    return rules;
};
// TODO: animations and real Popover Arrow
let $80dcd4fb498958b2$var$$88b746eba92c8d0d$var$arrow = function anonymous(props) {
    let rules = " ";
    rules += ' sb182';
    rules += ' tEzkoQe182';
    rules += ' Zl182';
    rules += ' Fh182';
    if (props.placement === "right") rules += ' _Sd182';
    else if (props.placement === "left") rules += ' _Sa182';
    else if (props.placement === "bottom") rules += ' _Sc182';
    else if (props.placement === "top") rules += ' _Sb182';
    else rules += ' _Sc182';
    if (props.placement === "right") {
        rules += ' -_7PloMd-y182';
        rules += ' __Ya182';
    } else if (props.placement === "left") {
        rules += ' -_7PloMd-e182';
        rules += ' __Ya182';
    }
    rules += ' _Vb182';
    rules += ' Vye39g182';
    rules += ' Vlb182';
    return rules;
};
const $80dcd4fb498958b2$export$9b9a0cd73afb7ca4 = (0, $eF4cA.createContext)(null);
const $80dcd4fb498958b2$export$60dfb2c3202ad27d = (0, $eF4cA.createContext)(false);
const $80dcd4fb498958b2$export$fde1b04c590741a3 = (0, $eF4cA.forwardRef)(function PopoverBase(props, ref) {
    let { hideArrow: hideArrow = false, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles, size: size } = props;
    let colorScheme = (0, $eF4cA.useContext)((0, $arisx.ColorSchemeContext));
    let { locale: locale, direction: direction } = (0, $1ntKq.useLocale)();
    // TODO: should we pass through lang and dir props in RAC?
    let popoverRef = (0, $eF4cA.useCallback)((el)=>{
        if (el) {
            el.lang = locale;
            el.dir = direction;
        }
    }, [
        locale,
        direction
    ]);
    // Memoed so it doesn't break ComboBox/Picker scrolling
    let mergedRef = (0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(popoverRef, ref), [
        ref,
        popoverRef
    ]);
    // On small devices, show a modal (or eventually a tray) instead of a popover.
    // TODO: reverted this until we have trays.
    // let isMobile = useIsMobileDevice();
    // if (isMobile && process.env.NODE_ENV !== 'test') {
    //   let mappedChildren = typeof children === 'function'
    //     ? (renderProps: ModalRenderProps) => children({...renderProps, defaultChildren: null, trigger, placement: 'bottom'})
    //     : children;
    //   return (
    //     <Modal size={size} isDismissable>
    //       {composeRenderProps(mappedChildren, (children, {state}) => (
    //         <>
    //           {children}
    //           {/* Add additional dismiss button at the end to match popovers. */}
    //           <DismissButton onDismiss={state.close} />
    //         </>
    //       ))}
    //     </Modal>
    //   );
    // }
    // TODO: this still isn't the final popover 'tip', copying various ones out of the designs files yields different results
    // containerPadding not working as expected
    return (0, $dx4lB.jsx)((0, $f8UJ0.Popover), {
        ...props,
        offset: (props.offset ?? 8) + (hideArrow ? 0 : 8),
        ref: mergedRef,
        style: {
            ...UNSAFE_style,
            // Override default z-index from useOverlayPosition. We use isolation: isolate instead.
            zIndex: undefined
        },
        className: (renderProps)=>UNSAFE_className + (0, $5nTep.mergeStyles)($80dcd4fb498958b2$var$$88b746eba92c8d0d$var$popover({
                ...renderProps,
                size: size,
                isArrowShown: !hideArrow,
                colorScheme: colorScheme,
                isSubmenu: renderProps.trigger === 'SubmenuTrigger'
            }), styles),
        children: (0, $fDYaM.composeRenderProps)(props.children, (children, renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    !hideArrow && (0, $dx4lB.jsx)((0, $eENmv.OverlayArrow), {
                        className: "",
                        children: (0, $dx4lB.jsx)("svg", {
                            viewBox: "0 0 18 10",
                            className: $80dcd4fb498958b2$var$$88b746eba92c8d0d$var$arrow(renderProps),
                            children: (0, $dx4lB.jsx)("path", {
                                transform: "translate(0 -1)",
                                d: "M1 1L7.93799 8.52588C8.07224 8.67448 8.23607 8.79362 8.41895 8.87524C8.60182 8.95687 8.79973 8.9993 9 9C9.19984 8.99882 9.39724 8.95606 9.57959 8.87427C9.76193 8.79248 9.9253 8.67336 10.0591 8.5249L17 1"
                            })
                        })
                    }),
                    (0, $dx4lB.jsx)($80dcd4fb498958b2$export$60dfb2c3202ad27d.Provider, {
                        value: true,
                        children: children
                    })
                ]
            }))
    });
});
const $80dcd4fb498958b2$var$$88b746eba92c8d0d$var$innerDivStyle = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let maxWidth = false;
    let maxHeight = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        if (p[1] === "K") maxHeight = true;
        rules += p[0];
    }
    if (props.padding === "none") rules += ' Td182';
    else if (props.padding === "default") rules += ' Tt182';
    if (props.padding === "none") rules += ' Qd182';
    else if (props.padding === "default") rules += ' Qt182';
    if (props.padding === "none") rules += ' Sd182';
    else if (props.padding === "default") rules += ' St182';
    if (props.padding === "none") rules += ' Rd182';
    else if (props.padding === "default") rules += ' Rt182';
    rules += ' _oa182';
    rules += ' _Le182';
    rules += ' oi182';
    rules += ' ni182';
    rules += ' ki182';
    rules += ' ji182';
    rules += ' _Na182';
    rules += ' Pa182';
    if (!position) rules += ' _Pc182';
    if (!width) rules += ' Za182';
    if (!maxWidth) rules += ' L40ub4c182';
    if (!maxHeight) rules += ' K40ub4c182';
    return rules;
};
const $80dcd4fb498958b2$export$5b6b19405a83ff9d = (0, $eF4cA.forwardRef)(function Popover(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $80dcd4fb498958b2$export$9b9a0cd73afb7ca4);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, styles: styles, padding: padding = 'default', ...otherProps } = props;
    return (0, $dx4lB.jsx)($80dcd4fb498958b2$export$fde1b04c590741a3, {
        ...otherProps,
        ref: domRef,
        children: (0, $fDYaM.composeRenderProps)(props.children, (children)=>(0, $dx4lB.jsx)("div", {
                style: UNSAFE_style,
                className: (UNSAFE_className || '') + $80dcd4fb498958b2$var$$88b746eba92c8d0d$var$innerDivStyle({
                    padding: padding
                }, styles),
                children: (0, $dx4lB.jsx)((0, $8gDpA.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: children
                })
            }))
    });
});

});

parcelRegister("9f9st", function(module, exports) {

$parcel$export(module.exports, "default", () => $751111fa733a2e68$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $751111fa733a2e68$var$$617faba3c82b5da5$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M11.75 18h-7.5C3.01 18 2 16.99 2 15.75v-7.5C2 7.01 3.01 6 4.25 6c.414 0 .75.336.75.75s-.336.75-.75.75c-.413 0-.75.337-.75.75v7.5c0 .413.337.75.75.75h7.5c.413 0 .75-.337.75-.75 0-.414.336-.75.75-.75s.75.336.75.75c0 1.24-1.01 2.25-2.25 2.25M6.75 5C6.336 5 6 4.664 6 4.25 6 3.01 7.01 2 8.25 2c.414 0 .75.336.75.75s-.336.75-.75.75c-.413 0-.75.337-.75.75 0 .414-.336.75-.75.75M13 3.5h-2c-.414 0-.75-.336-.75-.75S10.586 2 11 2h2c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13 14h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.414 0 .75.336.75.75s-.336.75-.75.75M15.75 14c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c.413 0 .75-.337.75-.75 0-.414.336-.75.75-.75s.75.336.75.75c0 1.24-1.01 2.25-2.25 2.25M17.25 5c-.414 0-.75-.336-.75-.75 0-.413-.337-.75-.75-.75-.414 0-.75-.336-.75-.75s.336-.75.75-.75C16.99 2 18 3.01 18 4.25c0 .414-.336.75-.75.75M17.25 9.75c-.414 0-.75-.336-.75-.75V7c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414-.336.75-.75.75M6.75 9.75C6.336 9.75 6 9.414 6 9V7c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414-.336.75-.75.75M8.25 14C7.01 14 6 12.99 6 11.75c0-.414.336-.75.75-.75s.75.336.75.75c0 .413.337.75.75.75.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const $751111fa733a2e68$var$$617faba3c82b5da5$var$ForwardRef = (0, $eF4cA.forwardRef)($751111fa733a2e68$var$$617faba3c82b5da5$var$SvgComponent);
var $751111fa733a2e68$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($751111fa733a2e68$var$$617faba3c82b5da5$var$ForwardRef);

});


parcelRegister("lb17q", function(module, exports) {

$parcel$export(module.exports, "SELECTION_TYPE", () => $f6ab7e353aa51a61$export$96527b3d022fe7df);
$parcel$export(module.exports, "WIZARD_STEP", () => $f6ab7e353aa51a61$export$c48ce6cf47b2efbc);
$parcel$export(module.exports, "STEP_TYPE", () => $f6ab7e353aa51a61$export$9ab16df0cc5e0600);
$parcel$export(module.exports, "getStepType", () => $f6ab7e353aa51a61$export$82e4946097b9b1d9);
$parcel$export(module.exports, "isCampaignVisualsStep", () => $f6ab7e353aa51a61$export$76883f8e3ec2e4d);
$parcel$export(module.exports, "isImagesStep", () => $f6ab7e353aa51a61$export$4f1caa9ba5c217ba);
$parcel$export(module.exports, "isBrandingVariationsStep", () => $f6ab7e353aa51a61$export$c48d916db595cecf);
$parcel$export(module.exports, "getStructureVariationKeys", () => $f6ab7e353aa51a61$export$880bc1c3ad8d85fa);
$parcel$export(module.exports, "GRID_TYPE", () => $f6ab7e353aa51a61$export$7dc987e8e40d47ae);
$parcel$export(module.exports, "isTextCell", () => $f6ab7e353aa51a61$export$8c009e8a74b386f4);
$parcel$export(module.exports, "getCellLink", () => $f6ab7e353aa51a61$export$ed11e069f4d2e9b6);
$parcel$export(module.exports, "isCellDropDisabled", () => $f6ab7e353aa51a61$export$853c9dd5c0d2b5a0);
$parcel$export(module.exports, "getGroupGrids", () => $f6ab7e353aa51a61$export$9b48716113fe4cce);
$parcel$export(module.exports, "getPreviewLinks", () => $f6ab7e353aa51a61$export$375440ab6bfa35af);
$parcel$export(module.exports, "getVariationReferenceKeys", () => $f6ab7e353aa51a61$export$391327a1f0134302);
$parcel$export(module.exports, "hasPendingStructureVariations", () => $f6ab7e353aa51a61$export$bba65fbc52020564);
$parcel$export(module.exports, "getStructureVariationProgress", () => $f6ab7e353aa51a61$export$fb5c94e9fec59259);
$parcel$export(module.exports, "getStructureAssetNames", () => $f6ab7e353aa51a61$export$f5de6b1bbb4bb278);
$parcel$export(module.exports, "hasPendingStructureAssets", () => $f6ab7e353aa51a61$export$dde8f8771e8fe2ac);
$parcel$export(module.exports, "getPrimaryReferenceKey", () => $f6ab7e353aa51a61$export$196121bbba54f68d);
$parcel$export(module.exports, "getReferenceGroupId", () => $f6ab7e353aa51a61$export$fb51b03245f8f4b8);
$parcel$export(module.exports, "getVariationReferenceGroupId", () => $f6ab7e353aa51a61$export$c4a07c65b2f122be);
$parcel$export(module.exports, "isVariationEnabled", () => $f6ab7e353aa51a61$export$1a54764a5dde8cda);
$parcel$export(module.exports, "filterActiveVariations", () => $f6ab7e353aa51a61$export$398e462bac9670bb);
$parcel$export(module.exports, "VARIATION_PROGRESS_STAGE", () => $f6ab7e353aa51a61$export$5326e63df75307c9);
$parcel$export(module.exports, "isStepAtOrAfter", () => $f6ab7e353aa51a61$export$d64f7746dd67ffff);
$parcel$export(module.exports, "isStepAfter", () => $f6ab7e353aa51a61$export$cecf2e9b2828edad);
$parcel$export(module.exports, "isStepAtOrBefore", () => $f6ab7e353aa51a61$export$756aee0af0faa6d0);
$parcel$export(module.exports, "hasAudioStep", () => $f6ab7e353aa51a61$export$add75c387748f6ea);
$parcel$export(module.exports, "hasImageVariationsStep", () => $f6ab7e353aa51a61$export$a8d39c1cd6c28f62);
$parcel$export(module.exports, "hasBannersStep", () => $f6ab7e353aa51a61$export$6f403febd898bc66);
$parcel$export(module.exports, "getTemplateSteps", () => $f6ab7e353aa51a61$export$eb24ba3912970d00);
$parcel$export(module.exports, "getStepName", () => $f6ab7e353aa51a61$export$accc136c77ec5dfa);
$parcel$export(module.exports, "resolveSteps", () => $f6ab7e353aa51a61$export$fb2bef0743048987);
$parcel$export(module.exports, "getImagesSteps", () => $f6ab7e353aa51a61$export$d3b23e6849c455d8);
$parcel$export(module.exports, "getResumeImagesStepId", () => $f6ab7e353aa51a61$export$775bc351d4caa5d2);
$parcel$export(module.exports, "getKeyVisualSyncState", () => $f6ab7e353aa51a61$export$8984bb22ad1eef66);
$parcel$export(module.exports, "getStepEnterAction", () => $f6ab7e353aa51a61$export$e2914ca37ff801a6);
$parcel$export(module.exports, "getStepLeaveAction", () => $f6ab7e353aa51a61$export$cfbf32607ee42fac);
$parcel$export(module.exports, "PRE_FLOW_STEPS", () => $f6ab7e353aa51a61$export$7fe4c9cb311a7dd2);
$parcel$export(module.exports, "getContinueLabel", () => $f6ab7e353aa51a61$export$f002cbf67963876);
const $f6ab7e353aa51a61$export$96527b3d022fe7df = {
    NONE: "none",
    SINGLE: "single",
    MULTIPLE: "multiple"
};
const $f6ab7e353aa51a61$export$c48ce6cf47b2efbc = {
    SELECT_TEMPLATE: "select-template",
    ACCOUNT_DETAILS: "account-details",
    CUSTOMER_DETAILS: "customer-details",
    CREATE_VIDEO: "create-video",
    CAMPAIGN: "campaign",
    STORY_FOUNDATION: "story-foundation",
    CAMPAIGN_VISUALS: "campaign-visuals",
    KEY_VISUALS: "key-visuals",
    IMAGES_AND_TEXT: "images-and-text",
    SCENES: "scenes",
    VOICEOVER: "voiceover",
    BRANDING: "branding",
    AUDIO: "audio",
    IMAGES: "images",
    IMAGES_PLANNING: "images-planning",
    BANNERS: "banners",
    GENERATE_VIDEO: "generate-video",
    FIGMA_HANDOFF: "figma-handoff"
};
const $f6ab7e353aa51a61$export$9ab16df0cc5e0600 = {
    CAMPAIGN_VISUALS: "campaign-visuals",
    IMAGES: "images"
};
// The type a step has implicitly, by its id, when it declares none.
const $f6ab7e353aa51a61$var$IMPLICIT_STEP_TYPES = {
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN_VISUALS]: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES]: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.IMAGES
};
// Step helpers take a configured step entry; a bare id stands for a step that
// declares nothing but its id.
const $f6ab7e353aa51a61$var$toStepEntry = (step)=>typeof step === "string" ? {
        id: step
    } : step ?? undefined;
const $f6ab7e353aa51a61$export$82e4946097b9b1d9 = (step)=>{
    const entry = $f6ab7e353aa51a61$var$toStepEntry(step);
    return entry?.type ?? $f6ab7e353aa51a61$var$IMPLICIT_STEP_TYPES[entry?.id];
};
const $f6ab7e353aa51a61$export$76883f8e3ec2e4d = (step)=>$f6ab7e353aa51a61$export$82e4946097b9b1d9(step) === $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS;
const $f6ab7e353aa51a61$export$4f1caa9ba5c217ba = (step)=>$f6ab7e353aa51a61$export$82e4946097b9b1d9(step) === $f6ab7e353aa51a61$export$9ab16df0cc5e0600.IMAGES;
const $f6ab7e353aa51a61$export$268d70360331d179 = (step)=>$f6ab7e353aa51a61$export$4f1caa9ba5c217ba(step) ? $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES : $f6ab7e353aa51a61$var$toStepEntry(step)?.id;
const $f6ab7e353aa51a61$export$c48d916db595cecf = (step)=>step?.id === $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING && $f6ab7e353aa51a61$export$880bc1c3ad8d85fa(step?.campaignStructure).length > 0;
const $f6ab7e353aa51a61$export$fe5882e1cacea70d = [
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.ACCOUNT_DETAILS,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CUSTOMER_DETAILS,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CREATE_VIDEO,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.STORY_FOUNDATION,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN_VISUALS,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.KEY_VISUALS,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES_AND_TEXT,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SCENES,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.VOICEOVER,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.AUDIO,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BANNERS,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.GENERATE_VIDEO,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.FIGMA_HANDOFF
];
const $f6ab7e353aa51a61$export$7dc987e8e40d47ae = {
    FIELDS: "fields",
    VARIATIONS: "variations"
};
const $f6ab7e353aa51a61$export$8c009e8a74b386f4 = (cell)=>Array.isArray(cell?.value) ? cell.value.length > 0 : typeof cell?.value === "string" && !!cell.value;
const $f6ab7e353aa51a61$var$LINK_TYPE = {
    LINK: "link",
    BUTTON: "button",
    EMBED: "embed"
};
const $f6ab7e353aa51a61$var$EMBED_ASPECT_RATIO = "4 / 3";
// What an embedded page may do. Scripts together with the same origin would
// let a same-origin page lift its own sandbox, so that one is left out then.
const $f6ab7e353aa51a61$var$EMBED_SANDBOX = [
    "allow-scripts",
    "allow-forms",
    "allow-popups",
    "allow-popups-to-escape-sandbox"
];
// Absolute http(s) and mailto URLs, and relative ones — nothing that runs code.
const $f6ab7e353aa51a61$var$SAFE_LINK = /^(https?:|mailto:|\/|\.{1,2}\/|#|\?)/i;
const $f6ab7e353aa51a61$var$HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
// Links open in a named window, so a click navigates the tab an earlier one
// opened instead of opening another. The browser only finds that tab when the
// link is not `noopener`/`noreferrer`.
const $f6ab7e353aa51a61$var$LINK_WINDOW_NAME = "bestory-links";
/** Whether a URL is on the origin of the app (relative ones always are). */ const $f6ab7e353aa51a61$var$isSameOrigin = (href)=>{
    try {
        return typeof window === "undefined" || new URL(href, window.location.href).origin === window.location.origin;
    } catch  {
        return true;
    }
};
/**
 * The window a link opens in: `linkTarget` when set — `"_blank"` always opens
 * a new tab, `"_self"` stays put, anything else names the window — else the
 * one shared by all links, or by those of the same `linkGroup`.
 */ const $f6ab7e353aa51a61$var$getLinkTarget = (cell)=>{
    if (typeof cell.linkTarget === "string" && cell.linkTarget) return cell.linkTarget;
    const group = typeof cell.linkGroup === "string" ? cell.linkGroup.toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "") : "";
    return group ? `${$f6ab7e353aa51a61$var$LINK_WINDOW_NAME}-${group}` : $f6ab7e353aa51a61$var$LINK_WINDOW_NAME;
};
const $f6ab7e353aa51a61$export$ed11e069f4d2e9b6 = (cell)=>{
    const href = typeof cell?.link === "string" ? cell.link.trim() : "";
    if (!href || !($f6ab7e353aa51a61$var$SAFE_LINK.test(href) || !$f6ab7e353aa51a61$var$HAS_SCHEME.test(href))) return null;
    const target = $f6ab7e353aa51a61$var$getLinkTarget(cell);
    const isEmbed = cell.linkType === $f6ab7e353aa51a61$var$LINK_TYPE.EMBED && !/^mailto:/i.test(href);
    const type = isEmbed ? $f6ab7e353aa51a61$var$LINK_TYPE.EMBED : cell.linkType === $f6ab7e353aa51a61$var$LINK_TYPE.BUTTON ? $f6ab7e353aa51a61$var$LINK_TYPE.BUTTON : $f6ab7e353aa51a61$var$LINK_TYPE.LINK;
    return {
        href: href,
        label: typeof cell.linkLabel === "string" && cell.linkLabel ? cell.linkLabel : href,
        type: type,
        target: target,
        rel: target === "_blank" ? "noopener noreferrer" : undefined,
        ...isEmbed ? {
            aspectRatio: typeof cell.linkAspectRatio === "string" && cell.linkAspectRatio ? cell.linkAspectRatio : $f6ab7e353aa51a61$var$EMBED_ASPECT_RATIO,
            sandbox: typeof cell.linkSandbox === "string" ? cell.linkSandbox : ($f6ab7e353aa51a61$var$isSameOrigin(href) ? $f6ab7e353aa51a61$var$EMBED_SANDBOX : [
                "allow-same-origin",
                ...$f6ab7e353aa51a61$var$EMBED_SANDBOX
            ]).join(" ")
        } : {}
    };
};
const $f6ab7e353aa51a61$export$853c9dd5c0d2b5a0 = (cell, grid)=>[
        cell?.disableDrop,
        grid?.disableDrop
    ].find((value)=>typeof value === "boolean") ?? false;
const $f6ab7e353aa51a61$export$9b48716113fe4cce = (group)=>{
    if (group?.grid) return (Array.isArray(group.grid) ? group.grid : [
        group.grid
    ]).filter(Boolean).map(({ type: type = $f6ab7e353aa51a61$export$7dc987e8e40d47ae.FIELDS, title: title, description: description, linkedColSpan: linkedColSpan, disableDrop: disableDrop, previewLinks: previewLinks, rows: rows })=>({
            type: type,
            title: title,
            description: description,
            linkedColSpan: linkedColSpan,
            disableDrop: disableDrop,
            previewLinks: previewLinks,
            rows: (rows ?? []).map((row)=>(Array.isArray(row) ? row : [
                    row
                ]).map((cell)=>cell ?? null)).filter((row)=>row.length > 0)
        }));
    return [
        {
            type: $f6ab7e353aa51a61$export$7dc987e8e40d47ae.FIELDS,
            rows: (group?.fields ?? []).filter(Boolean).map((field)=>[
                    field
                ])
        }
    ];
};
/**
 * The URL a preview link points to, from the template's general `previewUrl`
 * and the link's `href`:
 * - no `href`: the `previewUrl`;
 * - an `href` of just a hash and/or search (`"#slide-2"`, `"?lang=de"`,
 *   `"?lang=de#slide-2"`): the `previewUrl` with its hash replaced and the
 *   search params added or replaced — each only when the `href` has it;
 * - any other `href` (a full URL with a domain, or a path): used as it is.
 * `null` for a URL that is not http(s) or relative, or when there is no
 * `previewUrl` to base the link on.
 */ const $f6ab7e353aa51a61$var$resolvePreviewHref = (href, previewUrl)=>{
    const value = typeof href === "string" ? href.trim() : "";
    const base = typeof previewUrl === "string" ? previewUrl.trim() : "";
    if (value && !/^[#?]/.test(value)) return /^https?:/i.test(value) || !$f6ab7e353aa51a61$var$HAS_SCHEME.test(value) && $f6ab7e353aa51a61$var$SAFE_LINK.test(value) ? value : null;
    if (!base || !/^https?:/i.test(base)) return null;
    if (!value) return base;
    try {
        const url = new URL(base);
        const hashIdx = value.indexOf("#");
        const search = hashIdx === -1 ? value : value.slice(0, hashIdx);
        if (search.startsWith("?")) {
            const seen = new Set();
            // `set` replaces a param in place, keeping the order of the rest.
            for (const [key, val] of new URLSearchParams(search))if (seen.has(key)) url.searchParams.append(key, val);
            else {
                seen.add(key);
                url.searchParams.set(key, val);
            }
        }
        if (hashIdx !== -1) url.hash = value.slice(hashIdx);
        return url.toString();
    } catch  {
        return null;
    }
};
const $f6ab7e353aa51a61$export$375440ab6bfa35af = (previewLinks, previewUrl)=>(Array.isArray(previewLinks) ? previewLinks : [
        previewLinks
    ]).filter((link)=>link && typeof link === "object").map((link)=>{
        const href = $f6ab7e353aa51a61$var$resolvePreviewHref(link.href, previewUrl);
        if (!href) return null;
        const target = $f6ab7e353aa51a61$var$getLinkTarget(link);
        return {
            href: href,
            label: typeof link.label === "string" && link.label ? link.label : href,
            target: target,
            rel: target === "_blank" ? "noopener noreferrer" : undefined
        };
    }).filter(Boolean);
/**
 * The cells of a grid's rows that may show an image — every cell but the empty
 * ones and, in a `variations` grid, its text cells.
 */ const $f6ab7e353aa51a61$var$getImageCells = (type, rows)=>rows.flat().filter(Boolean).filter((cell)=>type !== $f6ab7e353aa51a61$export$7dc987e8e40d47ae.VARIATIONS || !$f6ab7e353aa51a61$export$8c009e8a74b386f4(cell));
const $f6ab7e353aa51a61$export$fd1b7f19f12267ac = (campaignStructure)=>{
    const keys = new Set();
    for (const group of campaignStructure ?? []){
        for (const { type: type, rows: rows } of $f6ab7e353aa51a61$export$9b48716113fe4cce(group))for (const cell of $f6ab7e353aa51a61$var$getImageCells(type, rows))$f6ab7e353aa51a61$export$391327a1f0134302(cell).forEach((key)=>keys.add(key));
    }
    return Array.from(keys);
};
const $f6ab7e353aa51a61$export$880bc1c3ad8d85fa = (campaignStructure)=>{
    const keys = new Set();
    for (const group of campaignStructure ?? []){
        for (const { type: type, rows: rows } of $f6ab7e353aa51a61$export$9b48716113fe4cce(group))for (const cell of $f6ab7e353aa51a61$var$getImageCells(type, rows)){
            for (const key of [
                "variationKey",
                "referenceKey"
            ])if (cell[key]) keys.add(cell[key]);
        }
    }
    return Array.from(keys);
};
const $f6ab7e353aa51a61$export$bba65fbc52020564 = (campaignStructure, variations, assets)=>{
    const linkedKeys = $f6ab7e353aa51a61$export$880bc1c3ad8d85fa(campaignStructure);
    return (variations ?? []).filter((variation)=>linkedKeys.includes(variation.key)).some((variation)=>!assets?.some((asset)=>asset.name === variation.key));
};
const $f6ab7e353aa51a61$export$fb5c94e9fec59259 = (campaignStructure, variations, assets, templateAssetNames = [])=>{
    const linkedKeys = $f6ab7e353aa51a61$export$880bc1c3ad8d85fa(campaignStructure);
    const shown = (variations ?? []).filter((variation)=>linkedKeys.includes(variation.key) && !templateAssetNames.includes(variation.key));
    return {
        total: shown.length,
        selected: shown.filter((variation)=>assets?.some((asset)=>asset.name === variation.key)).length
    };
};
const $f6ab7e353aa51a61$export$f5de6b1bbb4bb278 = (campaignStructure)=>{
    const names = new Set();
    for (const group of campaignStructure ?? [])for (const { type: type, rows: rows } of $f6ab7e353aa51a61$export$9b48716113fe4cce(group)){
        for (const cell of $f6ab7e353aa51a61$var$getImageCells(type, rows))if (cell.assetName) names.add(cell.assetName);
    }
    return Array.from(names);
};
const $f6ab7e353aa51a61$export$dde8f8771e8fe2ac = (campaignStructure, templateAssets, videoAssets)=>{
    const names = $f6ab7e353aa51a61$export$f5de6b1bbb4bb278(campaignStructure);
    return (templateAssets ?? []).filter((asset)=>names.includes(asset.name) && (asset.type === "image" || asset.type === "color") && !asset.isOptional).some((asset)=>!videoAssets?.some((a)=>a.name === asset.name && !a.isInvalid));
};
const $f6ab7e353aa51a61$export$f43a2b74226430d2 = "default";
const $f6ab7e353aa51a61$export$e066645276346dd4 = (variation)=>variation?.stage ?? $f6ab7e353aa51a61$export$f43a2b74226430d2;
const $f6ab7e353aa51a61$export$429476692680d12b = 6;
const $f6ab7e353aa51a61$export$391327a1f0134302 = (variation)=>{
    const raw = variation?.referenceKey;
    const keys = Array.from(new Set((Array.isArray(raw) ? raw : [
        raw
    ]).filter((key)=>typeof key === "string" && !!key)));
    if (keys.length > $f6ab7e353aa51a61$export$429476692680d12b) {
        console.warn(`Image variation "${variation?.key}" has ${keys.length} reference images, only the first ${$f6ab7e353aa51a61$export$429476692680d12b} are used.`);
        return keys.slice(0, $f6ab7e353aa51a61$export$429476692680d12b);
    }
    return keys;
};
const $f6ab7e353aa51a61$export$196121bbba54f68d = (variation)=>$f6ab7e353aa51a61$export$391327a1f0134302(variation)[0] ?? null;
const $f6ab7e353aa51a61$export$fb51b03245f8f4b8 = (referenceKeys)=>JSON.stringify(referenceKeys ?? []);
const $f6ab7e353aa51a61$export$c4a07c65b2f122be = (variation)=>$f6ab7e353aa51a61$export$fb51b03245f8f4b8($f6ab7e353aa51a61$export$391327a1f0134302(variation));
const $f6ab7e353aa51a61$export$a806ef70ea0f55f0 = (templateData)=>{
    const stages = [];
    for (const variation of templateData?.imageVariations ?? []){
        const stage = $f6ab7e353aa51a61$export$e066645276346dd4(variation);
        if (!stages.includes(stage)) stages.push(stage);
    }
    return stages.includes($f6ab7e353aa51a61$export$f43a2b74226430d2) ? [
        $f6ab7e353aa51a61$export$f43a2b74226430d2,
        ...stages.filter((stage)=>stage !== $f6ab7e353aa51a61$export$f43a2b74226430d2)
    ] : stages;
};
const $f6ab7e353aa51a61$export$5486a5bd759b9c04 = (variations, stages)=>{
    const list = variations ?? [];
    if (!stages) return list;
    const allowed = new Set(stages);
    return list.filter((variation)=>allowed.has($f6ab7e353aa51a61$export$e066645276346dd4(variation)));
};
const $f6ab7e353aa51a61$export$1a54764a5dde8cda = (variation, selectedCampaign = {})=>{
    const condition = variation?.condition;
    if (!condition) return true;
    try {
        return !!new Function("selectedCampaign", `return (${condition});`)(selectedCampaign);
    } catch (error) {
        console.warn("Failed to evaluate variation condition:", variation, error);
        return false;
    }
};
const $f6ab7e353aa51a61$export$398e462bac9670bb = (variations, stages, selectedCampaign)=>$f6ab7e353aa51a61$export$5486a5bd759b9c04(variations, stages).filter((variation)=>$f6ab7e353aa51a61$export$1a54764a5dde8cda(variation, selectedCampaign));
const $f6ab7e353aa51a61$export$5326e63df75307c9 = {
    // A reference image being described (reference images only).
    LABELING: "labeling",
    // Waiting for a prompt, a reference, or a free slot to start generating.
    WAITING: "waiting",
    GENERATING: "generating",
    SAVING: "saving"
};
const $f6ab7e353aa51a61$export$fca9210716dbb622 = (stage)=>!stage || stage === $f6ab7e353aa51a61$export$f43a2b74226430d2 ? $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES : `${$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES}-${stage}`;
const $f6ab7e353aa51a61$export$bd6f67ffe333eb52 = (stage)=>{
    const label = String(stage ?? "").replace(/[-_]+/g, " ").trim();
    return label && stage !== $f6ab7e353aa51a61$export$f43a2b74226430d2 ? `${label.charAt(0).toUpperCase()}${label.slice(1)} variations` : "Images variations";
};
const $f6ab7e353aa51a61$export$c826f14a77e71f1c = (step)=>$f6ab7e353aa51a61$export$fe5882e1cacea70d.indexOf($f6ab7e353aa51a61$export$268d70360331d179(step));
const $f6ab7e353aa51a61$export$d64f7746dd67ffff = (a, b)=>$f6ab7e353aa51a61$export$c826f14a77e71f1c(a) >= $f6ab7e353aa51a61$export$c826f14a77e71f1c(b);
const $f6ab7e353aa51a61$export$cecf2e9b2828edad = (a, b)=>$f6ab7e353aa51a61$export$c826f14a77e71f1c(a) > $f6ab7e353aa51a61$export$c826f14a77e71f1c(b);
const $f6ab7e353aa51a61$export$756aee0af0faa6d0 = (a, b)=>$f6ab7e353aa51a61$export$c826f14a77e71f1c(a) <= $f6ab7e353aa51a61$export$c826f14a77e71f1c(b);
const $f6ab7e353aa51a61$export$f813e211f5698233 = (a, b)=>$f6ab7e353aa51a61$export$c826f14a77e71f1c(a) < $f6ab7e353aa51a61$export$c826f14a77e71f1c(b);
const $f6ab7e353aa51a61$export$add75c387748f6ea = (templateData)=>!!templateData?.assets?.some((asset)=>asset.type === "audio");
const $f6ab7e353aa51a61$export$a8d39c1cd6c28f62 = (templateData)=>(templateData?.imageVariations?.length ?? 0) > 0;
const $f6ab7e353aa51a61$export$4994fcde389480ae = (stages)=>(templateData)=>$f6ab7e353aa51a61$export$5486a5bd759b9c04(templateData?.imageVariations, stages).length > 0;
const $f6ab7e353aa51a61$export$6f403febd898bc66 = (templateData)=>!!templateData?.assetsTemplateId;
/**
 * Default flow, modelled on the "ucx" template:
 * customer → campaign focus → (voiceover) → brands & visuals → (images) →
 * (banners) → video.
 */ const $f6ab7e353aa51a61$var$DEFAULT_STEPS = [
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE,
        name: "Template selection"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.ACCOUNT_DETAILS,
        name: "Account details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CUSTOMER_DETAILS,
        name: "Customer details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CREATE_VIDEO,
        name: "Creating project",
        viewless: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN,
        name: "Campaign focus",
        preview: "campaign",
        contentLabel: "campaign",
        canEditCampaign: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.VOICEOVER,
        name: "Voiceover",
        enabled: $f6ab7e353aa51a61$export$add75c387748f6ea
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING,
        name: "Brands & visuals"
    },
    // The "planning" stage renders first as its own step, so a template can
    // generate its key visuals / reference anchors (which the default-stage
    // variations reference) before the main fan-out. Opt in purely via data by
    // tagging variations with `stage: "planning"`; templates without any such
    // variation skip this step entirely.
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES_PLANNING,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.IMAGES,
        name: "Key visuals",
        stages: [
            "planning"
        ],
        enabled: $f6ab7e353aa51a61$export$4994fcde389480ae([
            "planning"
        ])
    },
    // Renders the default image stage. Stages beyond these two are appended
    // automatically by `resolveSteps`; add an explicit entry here (e.g.
    // `{ id: makeImagesStepId("video"), type: STEP_TYPE.IMAGES,
    //    name: "Video variations", stages: ["video"],
    //    enabled: hasImageVariationsStage(["video"]) }`)
    // to control a stage's name or position.
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.IMAGES,
        name: "Images variations",
        stages: [
            $f6ab7e353aa51a61$export$f43a2b74226430d2
        ],
        enabled: $f6ab7e353aa51a61$export$4994fcde389480ae([
            $f6ab7e353aa51a61$export$f43a2b74226430d2
        ])
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BANNERS,
        name: "Banners",
        enabled: $f6ab7e353aa51a61$export$6f403febd898bc66
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.GENERATE_VIDEO,
        name: "Video generation"
    }
];
/**
 * The "partnership-value" flow:
 * customer → script → scenes → (voiceover) → brand → audio → video.
 */ const $f6ab7e353aa51a61$var$PARTNERSHIP_VALUE_STEPS = [
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE,
        name: "Template selection"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.ACCOUNT_DETAILS,
        name: "Account details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CUSTOMER_DETAILS,
        name: "Customer details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CREATE_VIDEO,
        name: "Creating project",
        viewless: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING,
        name: "Brand"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN,
        name: "Script",
        preview: "partnership-value",
        contentLabel: "script",
        // Hide the per-field inline "Edit" buttons in the partnership-value
        // preview (the footer prompt itself stays available).
        canEditCampaign: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SCENES,
        name: "Scenes"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.AUDIO,
        name: "Audio"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.VOICEOVER,
        name: "Voiceover",
        enabled: $f6ab7e353aa51a61$export$add75c387748f6ea
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.GENERATE_VIDEO,
        name: "Video generation"
    }
];
const $f6ab7e353aa51a61$var$ONE_ADOBE_STEPS = [
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE,
        name: "Template selection"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.ACCOUNT_DETAILS,
        name: "Account details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CUSTOMER_DETAILS,
        name: "Customer details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CREATE_VIDEO,
        name: "Creating project",
        viewless: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.STORY_FOUNDATION,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
        name: "Story foundation",
        description: "Here is the beginning of your story - the product, trigger event, and the general campaign idea. All the remaining texts and images will be generated basing on this foundation.",
        preview: "one-adobe",
        contentLabel: "story foundation",
        canEditCampaign: true,
        promptHintsKey: "storyFoundationPromptHints",
        editScope: "story-foundation"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING,
        name: "Brand"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.KEY_VISUALS,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
        name: "Key visuals",
        description: "Let\u2019s lock some key visual assets for this campaign",
        contentLabel: "key visuals",
        canEditCampaign: false,
        promptHintsKey: "keyVisualsPromptHints",
        editScope: "key-visuals"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES_AND_TEXT,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
        name: "Images & text",
        description: "Here are all the assets needed for your vision demo:  make sure they\u2019re on-brand, realistic, and match the intent. Make edits as needed.",
        preview: "one-adobe",
        contentLabel: "images and text",
        editScope: "general",
        canEditCampaign: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BANNERS,
        name: "Banners",
        enabled: $f6ab7e353aa51a61$export$6f403febd898bc66
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.FIGMA_HANDOFF,
        name: "Handoff"
    }
];
const $f6ab7e353aa51a61$var$BRAND_VISIBILITY_STEPS = [
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE,
        name: "Template selection"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.ACCOUNT_DETAILS,
        name: "Account details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CUSTOMER_DETAILS,
        name: "Customer details"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CREATE_VIDEO,
        name: "Creating project",
        viewless: true
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.STORY_FOUNDATION,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
        preview: "one-adobe",
        contentLabel: "story foundation",
        canEditCampaign: true,
        promptHintsKey: "storyFoundationPromptHints",
        editScope: "story-foundation"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING,
        name: "Brand"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.KEY_VISUALS,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
        contentLabel: "key visuals",
        canEditCampaign: false,
        showPromptFooter: false,
        promptHintsKey: "keyVisualsPromptHints",
        editScope: "key-visuals"
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES_AND_TEXT,
        type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.CAMPAIGN_VISUALS,
        preview: "one-adobe",
        contentLabel: "campaign images",
        editScope: "general",
        canEditCampaign: false,
        showPromptFooter: false
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BANNERS,
        name: "Banners",
        enabled: $f6ab7e353aa51a61$export$6f403febd898bc66
    },
    {
        id: $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.GENERATE_VIDEO,
        name: "Video generation"
    }
];
const $f6ab7e353aa51a61$var$STEPS_CONFIG = {
    "partnership-value": $f6ab7e353aa51a61$var$PARTNERSHIP_VALUE_STEPS,
    "one-adobe": $f6ab7e353aa51a61$var$ONE_ADOBE_STEPS,
    "brand-visibility": $f6ab7e353aa51a61$var$BRAND_VISIBILITY_STEPS
};
const $f6ab7e353aa51a61$export$eb24ba3912970d00 = (templateId)=>$f6ab7e353aa51a61$var$STEPS_CONFIG[templateId] ?? $f6ab7e353aa51a61$var$DEFAULT_STEPS;
// What a template's `data.steps` entry may set on a step of its flow.
const $f6ab7e353aa51a61$var$TEMPLATE_STEP_FIELDS = {
    name: (value)=>typeof value === "string" && !!value,
    description: (value)=>typeof value === "string" && !!value,
    campaignStructure: Array.isArray
};
// A step is resolved against the same entry once, so what is derived from it
// (memos, effects) does not start over each time the steps are resolved.
const $f6ab7e353aa51a61$var$resolvedStepsCache = new WeakMap();
const $f6ab7e353aa51a61$export$8584d77b5ffe08cd = (step, templateData)=>{
    const entry = templateData?.steps?.[step?.id];
    if (!entry || typeof entry !== "object") return step;
    let byEntry = $f6ab7e353aa51a61$var$resolvedStepsCache.get(step);
    if (!byEntry) {
        byEntry = new WeakMap();
        $f6ab7e353aa51a61$var$resolvedStepsCache.set(step, byEntry);
    }
    if (!byEntry.has(entry)) {
        const overrides = Object.fromEntries(Object.entries($f6ab7e353aa51a61$var$TEMPLATE_STEP_FIELDS).filter(([field, isValid])=>isValid(entry[field])).map(([field])=>[
                field,
                entry[field]
            ]));
        byEntry.set(entry, Object.keys(overrides).length ? {
            ...step,
            ...overrides
        } : step);
    }
    return byEntry.get(entry);
};
const $f6ab7e353aa51a61$export$accc136c77ec5dfa = (templateId, stepId, templateData)=>{
    const configured = $f6ab7e353aa51a61$export$eb24ba3912970d00(templateId).find((step)=>step.id === stepId);
    if (configured) return $f6ab7e353aa51a61$export$8584d77b5ffe08cd(configured, templateData).name;
    return templateData ? $f6ab7e353aa51a61$export$fb2bef0743048987(templateId, templateData).find((step)=>step.id === stepId)?.name : undefined;
};
const $f6ab7e353aa51a61$export$fb2bef0743048987 = (templateId, templateData)=>{
    const configured = $f6ab7e353aa51a61$export$eb24ba3912970d00(templateId).map((step)=>$f6ab7e353aa51a61$export$8584d77b5ffe08cd(step, templateData));
    const steps = [];
    // Where auto-expanded stage steps belong: right after the last configured
    // images step — tracked even when that step itself is filtered out.
    let stageInsertIndex = -1;
    for (const step of configured){
        if (!step.enabled || step.enabled(templateData)) steps.push(step);
        if ($f6ab7e353aa51a61$export$4f1caa9ba5c217ba(step)) stageInsertIndex = steps.length;
    }
    if (stageInsertIndex === -1) return steps;
    const imagesSteps = configured.filter($f6ab7e353aa51a61$export$4f1caa9ba5c217ba);
    // An images step without `stages` renders every stage — nothing to expand.
    if (imagesSteps.some((step)=>!step.stages)) return steps;
    const coveredStages = new Set(imagesSteps.flatMap((step)=>step.stages ?? []));
    const extraSteps = $f6ab7e353aa51a61$export$a806ef70ea0f55f0(templateData).filter((stage)=>!coveredStages.has(stage)).map((stage)=>({
            id: $f6ab7e353aa51a61$export$fca9210716dbb622(stage),
            type: $f6ab7e353aa51a61$export$9ab16df0cc5e0600.IMAGES,
            name: $f6ab7e353aa51a61$export$bd6f67ffe333eb52(stage),
            stages: [
                stage
            ]
        }));
    steps.splice(stageInsertIndex, 0, ...extraSteps);
    return steps;
};
const $f6ab7e353aa51a61$export$d3b23e6849c455d8 = (templateId, templateData)=>$f6ab7e353aa51a61$export$fb2bef0743048987(templateId, templateData).filter($f6ab7e353aa51a61$export$4f1caa9ba5c217ba);
const $f6ab7e353aa51a61$export$775bc351d4caa5d2 = (templateId, templateData, videoData)=>{
    const steps = $f6ab7e353aa51a61$export$d3b23e6849c455d8(templateId, templateData);
    if (!steps.length) return null;
    const selectedCampaign = videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0]);
    const incomplete = steps.find((step)=>$f6ab7e353aa51a61$export$398e462bac9670bb(templateData?.imageVariations, step.stages, selectedCampaign).some((variation)=>!videoData?.assets?.some((asset)=>asset.name === variation.key)));
    return (incomplete ?? steps[steps.length - 1]).id;
};
/**
 * Default per-step navigation actions, run by `handleNextStep` — never by
 * `useEffect`. Apply to every template unless overridden per `template.id` in
 * `TEMPLATE_STEP_ACTIONS` below.
 *
 * `enter` runs when navigating INTO a step; `leave` runs when navigating OUT of
 * it. Each action is pure configuration that operates on a `ctx` object the view
 * assembles (queries, mutations, and `run*` triggers):
 *
 *   - `isReady(ctx)`   — the step already has the data this action would produce.
 *                        The action is only worth running when this is `false`.
 *   - `isPending(ctx)` — the backing mutation is currently running.
 *   - `run(ctx)`       — trigger the mutation. Must be idempotent/self-guarding
 *                        because `handleNextStep` calls it unconditionally.
 *   - `pending`        — optional copy for the loading state shown while
 *                        `isPending` is true. `{ title, subtitle, icon }` are
 *                        forwarded to `Step.Loading`. Only used for viewless
 *                        steps; non-viewless steps render their own component.
 *   - `placeholder`    — copy for the unified empty-state (`IllustratedMessage`)
 *                        shown when an `enter` step is displayed but
 *                        `!isReady && !isPending` — e.g. after a page refresh
 *                        interrupted the mutation, leaving the step with no data
 *                        and nothing generating it. Not used for `leave`.
 */ /**
 * Whether the campaign step has produced what the steps after it need — shared
 * by every step that renders the selected campaign.
 */ const $f6ab7e353aa51a61$var$isCampaignReady = (ctx)=>{
    if (!ctx.video.data?.id) return false;
    if (ctx.template.data?.campaignSelectionType === $f6ab7e353aa51a61$export$96527b3d022fe7df.NONE && !ctx.selectedCampaign?.id) return false;
    else if (!ctx.video.data?.campaigns?.length) return false;
    return true;
};
const $f6ab7e353aa51a61$export$877cd717333f7cd1 = "KV-primary";
const $f6ab7e353aa51a61$export$8984bb22ad1eef66 = (videoData, selectedCampaign)=>{
    const asset = videoData?.assets?.find((a)=>a?.name === $f6ab7e353aa51a61$export$877cd717333f7cd1);
    if (!asset?.filePath) return {
        asset: asset,
        effectiveDescription: "",
        needsLabeling: false,
        isOutOfSync: false
    };
    const effectiveDescription = asset.prompt || asset.labeling?.description || "";
    return {
        asset: asset,
        effectiveDescription: effectiveDescription,
        needsLabeling: !asset.labeling,
        isOutOfSync: !!effectiveDescription && effectiveDescription !== (selectedCampaign?.["KV-description"] ?? "")
    };
};
const $f6ab7e353aa51a61$export$11637e6199ae54e2 = {
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE]: {
        enter: {
            isReady: ()=>true,
            isPending: ()=>false,
            run: (ctx)=>{
                ctx.setSelectedTemplateKey(null);
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CREATE_VIDEO]: {
        enter: {
            isReady: (ctx)=>!!ctx.video.data?.id,
            isPending: (ctx)=>ctx.createVideo.isPending || ctx.video.isPending,
            run: (ctx)=>{
                const id = ctx.ensureProjectId();
                ctx.runCreateVideo(id, (videoData)=>{
                    ctx.runGenerateBranding(videoData);
                });
            },
            pending: {
                title: "Creating your project",
                subtitle: "This may take a moment\u2026"
            },
            placeholder: {
                title: "Oops, something went wrong",
                body: "But no worries. Let's give it another go.",
                action: "Try again"
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN]: {
        enter: {
            isReady: $f6ab7e353aa51a61$var$isCampaignReady,
            isPending: (ctx)=>!ctx.video.data?.campaigns?.length && ctx.customerBranding.isPending,
            run: (ctx)=>{
                ctx.runCreateCampaign(ctx.video?.data);
                ctx.resetPersonaCampaigns();
            },
            placeholder: {
                title: "Oops, something went wrong",
                body: "But no worries. Let's give it another go.",
                action: "Try again"
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN_VISUALS]: {
        enter: {
            // Needs the campaign the visuals are written for — generated here too
            // when missing (e.g. after a reload interrupted it). The linked image
            // variations are generated by the step itself, which renders their
            // progress, so only the campaign counts as pending.
            isReady: $f6ab7e353aa51a61$var$isCampaignReady,
            isPending: (ctx)=>!ctx.video.data?.campaigns?.length && ctx.customerBranding.isPending,
            run: (ctx)=>{
                if (!$f6ab7e353aa51a61$var$isCampaignReady(ctx)) ctx.runCreateCampaign(ctx.video?.data);
                ctx.imageVariations?.run();
            },
            placeholder: {
                title: "Oops, something went wrong",
                body: "But no worries. Let's give it another go.",
                action: "Try again"
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SCENES]: {
        enter: {
            // Ready once scenes exist.
            isReady: (ctx)=>!!ctx.selectedCampaign?.scenes?.length,
            isPending: (ctx)=>!ctx.selectedCampaign?.scenes?.length && ctx.generateScenes.isPending,
            run: (ctx)=>ctx.runGenerateScenes(),
            placeholder: {
                title: "Oops, something went wrong",
                body: "But no worries. Let's give it another go.",
                action: "Try again"
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BRANDING]: {
        enter: {
            isReady: (ctx)=>!!ctx.video.data?.id && !!ctx.video.data?.customer?.["Company-name"],
            isPending: (ctx)=>ctx.checkCustomer.isPending,
            run: (ctx)=>{
                ctx.runGenerateBranding();
            },
            placeholder: {
                title: "Oops, something went wrong",
                body: "But no worries. Let's give it another go.",
                action: "Try again"
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES]: {
        enter: {
            // The checks that used to gate the generation effect inside
            // `ImageVariations`: nothing left to generate for this step's stages,
            // every reference image resolved and uploaded, and no write of the video
            // still in flight.
            //
            // `ctx.imageVariations` is absent from the reduced readiness ctx the
            // wizard uses to resolve the step from the URL — there is no pipeline to
            // ask there, and images steps are reachable regardless, so it counts as
            // ready.
            isReady: (ctx)=>{
                const imageVariations = ctx.imageVariations;
                if (!imageVariations) return true;
                return imageVariations.isComplete && !imageVariations.isReferenceMissing && !imageVariations.references.isFetching && !imageVariations.references.isError && !imageVariations.isUploading && !imageVariations.isSaving;
            },
            // Generating the variations is an asynchronous, multi-step process —
            // describing the references, generating the prompts, uploading them,
            // generating each image — and the step renders its own per-variation
            // progress, so the action itself never reports as pending.
            isPending: ()=>false,
            run: (ctx)=>ctx.imageVariations?.run()
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BANNERS]: {
        enter: {
            // Ready when the template has no banners, the banner template is still
            // loading, or renditions already exist.
            isReady: (ctx)=>!ctx.template.data?.assetsTemplateId || !ctx.assetsTemplate.isSuccess || !!ctx.video.data?.templateAssetsRenditions?.length,
            isPending: (ctx)=>ctx.generateBanners.isPending || ctx.editCampaign.isPending,
            run: (ctx)=>ctx.runBannersTransition(),
            placeholder: {
                title: "Oops, something went wrong",
                body: "But no worries. Let's give it another go.",
                action: "Try again"
            }
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.VOICEOVER]: {
        // Fire-and-forget: after the user leaves the voiceover step, reconcile the
        // muxed audio track in the background — but only when the voiceover config
        // actually changed (detected via the muxed asset's `muxSourceKey`).
        leave: {
            isReady: (ctx)=>ctx.isVoiceoverMuxReady(),
            isPending: (ctx)=>ctx.audioMux.isPending || ctx.uploadAssets.isPending,
            run: (ctx)=>ctx.runVoiceoverMux()
        }
    },
    [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.GENERATE_VIDEO]: {
        enter: {
            // Always "ready" — GenerateVideoStep owns its own progress/empty states,
            // so no placeholder. The render kicks off on entry.
            isReady: ()=>true,
            isPending: ()=>false,
            run: (ctx)=>ctx.runGenerateVideo()
        }
    }
};
const $f6ab7e353aa51a61$export$6c854c2af99c81b2 = {
    "partnership-value": {},
    "one-adobe": {
        [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.KEY_VISUALS]: {
            // When the user regenerated or uploaded a different key visual, describe
            // it and have the LLM adjust the campaign to it — in the background, so
            // the next step can show its own loading state meanwhile.
            leave: {
                isReady: (ctx)=>{
                    const { needsLabeling: needsLabeling, isOutOfSync: isOutOfSync } = $f6ab7e353aa51a61$export$8984bb22ad1eef66(ctx.video.data, ctx.selectedCampaign);
                    return !needsLabeling && !isOutOfSync;
                },
                isPending: (ctx)=>!!ctx.syncKeyVisual?.isPending,
                run: (ctx)=>ctx.runSyncKeyVisual?.()
            }
        },
        [$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES_AND_TEXT]: {
            enter: {
                // The visuals are written for the campaign, so they wait for it to be
                // adjusted to the key visual chosen on the previous step.
                isPending: (ctx)=>$f6ab7e353aa51a61$export$11637e6199ae54e2[$f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN_VISUALS].enter.isPending(ctx) || !!ctx.syncKeyVisual?.isPending
            }
        }
    }
};
// Merge a template's per-action override onto the default action.
// `undefined` → inherit default; `null` → disable; object → field-level merge.
const $f6ab7e353aa51a61$var$mergeStepAction = (base, override)=>{
    if (override === null) return null;
    if (override === undefined) return base ?? null;
    return {
        ...base ?? {},
        ...override
    };
};
/**
 * The resolved `{ enter, leave }` actions for a configured step (a bare id
 * for a step that declares nothing else) under a given template.
 */ const $f6ab7e353aa51a61$var$resolveStepActions = (step, templateId)=>{
    const entry = $f6ab7e353aa51a61$var$toStepEntry(step);
    // Every images step shares the `images` step's actions, and a step of a
    // family without actions of its own shares the family's.
    const familyId = $f6ab7e353aa51a61$export$268d70360331d179(entry);
    const baseId = familyId in $f6ab7e353aa51a61$export$11637e6199ae54e2 || !$f6ab7e353aa51a61$export$76883f8e3ec2e4d(entry) ? familyId : $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.CAMPAIGN_VISUALS;
    const base = $f6ab7e353aa51a61$export$11637e6199ae54e2[baseId] ?? {};
    // A template may override a step on its own id, or its whole family.
    const templateActions = $f6ab7e353aa51a61$export$6c854c2af99c81b2[templateId];
    const override = templateActions?.[entry?.id] ?? templateActions?.[familyId] ?? templateActions?.[baseId] ?? {};
    return {
        enter: $f6ab7e353aa51a61$var$mergeStepAction(base.enter, override.enter),
        leave: $f6ab7e353aa51a61$var$mergeStepAction(base.leave, override.leave)
    };
};
const $f6ab7e353aa51a61$export$e2914ca37ff801a6 = (step, templateId)=>$f6ab7e353aa51a61$var$resolveStepActions(step, templateId).enter;
const $f6ab7e353aa51a61$export$cfbf32607ee42fac = (step, templateId)=>$f6ab7e353aa51a61$var$resolveStepActions(step, templateId).leave;
const $f6ab7e353aa51a61$export$7fe4c9cb311a7dd2 = [
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.SELECT_TEMPLATE,
    $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.ACCOUNT_DETAILS
];
const $f6ab7e353aa51a61$export$f002cbf67963876 = (nextStep)=>{
    const nextFamilyId = $f6ab7e353aa51a61$export$268d70360331d179(nextStep);
    if (nextFamilyId === $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.IMAGES) return "Confirm & proceed";
    if (nextFamilyId === $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.BANNERS) return "Generate banners";
    if (nextFamilyId === $f6ab7e353aa51a61$export$c48ce6cf47b2efbc.GENERATE_VIDEO) return "Generate video";
    return "Continue";
};

});

parcelRegister("ij7W2", function(module, exports) {

$parcel$export(module.exports, "layoutGridRows", () => $d54028180c2948c1$export$3e1e8281f9697ab6);
/**
 * The layout of a `campaignStructure` grid's rows as a single CSS grid, so a
 * cell can span several rows (`rowSpan`) as well as several columns
 * (`colSpan`).
 *
 * Every row keeps the equal-width columns it would have on its own — its
 * cells' spans add up to its column count, or `columns` fixes it — so the grid
 * is divided into the finest sub-columns all of the rows need, and each cell's
 * position and span are scaled to them.
 *
 * A cell spanning rows keeps the position and width it has in its first row.
 * The rows below count its columns as taken: their own cells share the rest of
 * the width, left to right around it. A row whose cells do not fit wraps onto
 * extra lines, which the spanning cells above extend through — `rowSpan` counts
 * rows, not lines.
 *
 * Pure (no React), so it can be checked on its own.
 */ /** A row has at most this many columns. */ const $d54028180c2948c1$export$efc09cf99005198 = 5;
const $d54028180c2948c1$var$gcd = (a, b)=>b === 0 ? Math.abs(a) : $d54028180c2948c1$var$gcd(b, a % b);
const $d54028180c2948c1$var$lcm = (a, b)=>a / $d54028180c2948c1$var$gcd(a, b) * b;
// Exact fractions of the grid's width, `[numerator, denominator]`.
const $d54028180c2948c1$var$frac = (n, d = 1)=>{
    const g = $d54028180c2948c1$var$gcd(n, d) || 1;
    return [
        n / g,
        d / g
    ];
};
const $d54028180c2948c1$var$add = ([an, ad], [bn, bd])=>$d54028180c2948c1$var$frac(an * bd + bn * ad, ad * bd);
const $d54028180c2948c1$var$sub = ([an, ad], [bn, bd])=>$d54028180c2948c1$var$frac(an * bd - bn * ad, ad * bd);
const $d54028180c2948c1$var$mul = ([an, ad], k)=>$d54028180c2948c1$var$frac(an * k, ad);
const $d54028180c2948c1$var$div = ([an, ad], k)=>$d54028180c2948c1$var$frac(an, ad * k);
const $d54028180c2948c1$var$cmp = ([an, ad], [bn, bd])=>an * bd - bn * ad;
const $d54028180c2948c1$var$ZERO = $d54028180c2948c1$var$frac(0);
const $d54028180c2948c1$var$ONE = $d54028180c2948c1$var$frac(1);
/** A cell's span from its `key` (`colSpan`, `rowSpan`): 1 by default. */ const $d54028180c2948c1$var$getSpan = (cell, key)=>Number.isInteger(cell?.[key]) && cell[key] > 1 ? cell[key] : 1;
const $d54028180c2948c1$export$4096f515713e70d = (cell)=>$d54028180c2948c1$var$getSpan(cell, "colSpan");
const $d54028180c2948c1$export$937926a5e0d5cc15 = (cell)=>$d54028180c2948c1$var$getSpan(cell, "rowSpan");
/** The free stretches of a line around the `taken` ones, left to right. */ const $d54028180c2948c1$var$getFreeSegments = (taken)=>{
    const segments = [];
    let cursor = $d54028180c2948c1$var$ZERO;
    [
        ...taken
    ].sort((a, b)=>$d54028180c2948c1$var$cmp(a.start, b.start)).forEach(({ start: start, width: width })=>{
        if ($d54028180c2948c1$var$cmp(start, cursor) > 0) segments.push({
            start: cursor,
            end: start
        });
        const end = $d54028180c2948c1$var$add(start, width);
        if ($d54028180c2948c1$var$cmp(end, cursor) > 0) cursor = end;
    });
    if ($d54028180c2948c1$var$cmp($d54028180c2948c1$var$ONE, cursor) > 0) segments.push({
        start: cursor,
        end: $d54028180c2948c1$var$ONE
    });
    return segments;
};
const $d54028180c2948c1$export$3e1e8281f9697ab6 = (rows = [], { columns: columns, fillLines: fillLines = false } = {})=>{
    const placed = [];
    // The cells of earlier rows still spanning down: the rows they have left.
    let spanning = [];
    let line = 1;
    rows.forEach((row, rowIdx)=>{
        const rowsLeft = rows.length - rowIdx;
        const spanningColumns = spanning.reduce((sum, s)=>sum + s.columns, 0);
        const ownColumns = row.reduce((sum, cell)=>sum + $d54028180c2948c1$export$4096f515713e70d(cell), 0);
        // The columns this row's own cells share — the rest are the spanning
        // cells'.
        const lineColumns = columns ? columns : Math.max(1, Math.min(ownColumns, $d54028180c2948c1$export$efc09cf99005198 - spanningColumns));
        const freeWidth = columns ? $d54028180c2948c1$var$ONE : spanning.reduce((free, s)=>$d54028180c2948c1$var$sub(free, s.width), $d54028180c2948c1$var$ONE);
        const unit = $d54028180c2948c1$var$div(freeWidth, lineColumns);
        // This row's own cells spanning down extend through its extra lines too.
        let rowSpanning = [];
        let segments = $d54028180c2948c1$var$getFreeSegments(spanning);
        let segmentIdx = 0;
        let cursor = segments[0]?.start ?? $d54028180c2948c1$var$ZERO;
        const rowStartLine = line;
        // The line's last cell and where its free stretch ends, for `fillLines`.
        let lineLast = null;
        const fillLine = ()=>{
            if (fillLines && lineLast?.entry.cell) lineLast.entry.width = $d54028180c2948c1$var$sub(lineLast.end, lineLast.entry.start);
            lineLast = null;
        };
        const newLine = ()=>{
            fillLine();
            line += 1;
            segments = $d54028180c2948c1$var$getFreeSegments([
                ...spanning,
                ...rowSpanning
            ]);
            segmentIdx = 0;
            cursor = segments[0]?.start ?? $d54028180c2948c1$var$ZERO;
        };
        row.forEach((cell, cellIdx)=>{
            const width = $d54028180c2948c1$var$mul(unit, Math.min($d54028180c2948c1$export$4096f515713e70d(cell), lineColumns));
            const fits = ()=>segmentIdx < segments.length && $d54028180c2948c1$var$cmp($d54028180c2948c1$var$add(cursor, width), segments[segmentIdx].end) <= 0;
            // Into the first free stretch it fits, else onto a new line.
            while(!fits() && segmentIdx < segments.length){
                segmentIdx += 1;
                cursor = segments[segmentIdx]?.start ?? $d54028180c2948c1$var$ZERO;
            }
            let cellWidth = width;
            if (!fits()) {
                newLine();
                // Too wide for any free stretch even on a line of its own: it takes
                // the widest one.
                if (!fits()) {
                    segmentIdx = segments.reduce((best, segment, idx)=>$d54028180c2948c1$var$cmp($d54028180c2948c1$var$sub(segment.end, segment.start), $d54028180c2948c1$var$sub(segments[best].end, segments[best].start)) > 0 ? idx : best, 0);
                    cursor = segments[segmentIdx]?.start ?? $d54028180c2948c1$var$ZERO;
                    cellWidth = segments[segmentIdx] ? $d54028180c2948c1$var$sub(segments[segmentIdx].end, segments[segmentIdx].start) : $d54028180c2948c1$var$ONE;
                }
            }
            const entry = {
                cell: cell,
                rowIdx: rowIdx,
                cellIdx: cellIdx,
                start: cursor,
                width: cellWidth,
                line: line,
                lines: 1
            };
            placed.push(entry);
            cursor = $d54028180c2948c1$var$add(cursor, cellWidth);
            lineLast = {
                entry: entry,
                end: segments[segmentIdx]?.end ?? $d54028180c2948c1$var$ONE
            };
            const rowSpan = Math.min($d54028180c2948c1$export$937926a5e0d5cc15(cell), rowsLeft);
            if (cell && rowSpan > 1) rowSpanning.push({
                entry: entry,
                // Read from the entry, which `fillLines` may still stretch.
                get start () {
                    return entry.start;
                },
                get width () {
                    return entry.width;
                },
                // Its share of the columns, as the rows below count them.
                columns: Math.min($d54028180c2948c1$export$4096f515713e70d(cell), lineColumns),
                rowsLeft: rowSpan - 1
            });
        });
        fillLine();
        // Whatever spans this row covers all of its lines.
        const rowEndLine = line;
        rowSpanning.forEach(({ entry: entry })=>{
            entry.lines = rowEndLine - entry.line + 1;
        });
        spanning.forEach((s)=>{
            s.entry.lines += rowEndLine - rowStartLine + 1;
            s.rowsLeft -= 1;
        });
        spanning = [
            ...spanning,
            ...rowSpanning
        ].filter((s)=>s.rowsLeft > 0);
        line = rowEndLine + 1;
    });
    // Fixed columns are tracks of their own (a subgrid's come from its parent),
    // so positions are always counted in them, or finer.
    const gridColumns = placed.reduce((result, { start: start, width: width })=>$d54028180c2948c1$var$lcm($d54028180c2948c1$var$lcm(result, start[1]), width[1]), columns ?? 1);
    return {
        columns: gridColumns,
        lines: line - 1,
        cells: placed.map(({ cell: cell, rowIdx: rowIdx, cellIdx: cellIdx, start: start, width: width, line: line, lines: lines })=>({
                cell: cell,
                rowIdx: rowIdx,
                cellIdx: cellIdx,
                column: start[0] * gridColumns / start[1] + 1,
                colSpan: width[0] * gridColumns / width[1],
                line: line,
                rowSpan: lines
            }))
    };
};

});


parcelRegister("l1gUk", function(module, exports) {

$parcel$export(module.exports, "getExtendedTemplateAssets", () => getExtendedTemplateAssets);
$parcel$export(module.exports, "TemplateImageAsset", () => TemplateImageAsset);
$parcel$export(module.exports, "TemplateColorAsset", () => TemplateColorAsset);

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $208Op = parcelRequire("208Op");
var $5mvex = parcelRequire("5mvex");
var $yuTTo = parcelRequire("yuTTo");
var $bTZtY = parcelRequire("bTZtY");

var $i8elj = parcelRequire("i8elj");

var $kekDO = parcelRequire("kekDO");

var $hjJiG = parcelRequire("hjJiG");

var $g42KE = parcelRequire("g42KE");
const getExtendedTemplateAssets = (templateAssets, videoAssets)=>(templateAssets ?? []).reduce((obj, asset)=>{
        const selectedAsset = videoAssets?.find((a)=>a.name === asset.name);
        obj[asset.name] = {
            ...asset,
            ...selectedAsset
        };
        return obj;
    }, {});
const getAssetLabel = (asset, label)=>`${label ?? asset?.label ?? asset?.name}${asset?.isOptional ? " (optional)" : ""}`;
const isUseCaseVisible = (useCase, scope = {})=>{
    const { video, template, selectedCampaign } = scope;
    if (typeof useCase === "string" || !useCase?.condition) return true;
    try {
        return !!eval(useCase.condition);
    } catch (error) {
        console.warn("Failed to evaluate use-case condition:", useCase, error);
        return false;
    }
};
const getVisibleUseCases = (asset, scope)=>(asset?.useCases ?? []).filter((useCase)=>isUseCaseVisible(useCase, scope));
const getUseCaseLabel = (useCase)=>typeof useCase === "string" ? useCase : useCase?.label;
const interpolateField = (value, selectedCampaign)=>typeof value === "string" ? value.replace(/\{\{\s*([\w.-]+)\s*\}\}/g, (_match, key)=>selectedCampaign?.[key] ?? "").trim() : value;
const scopePropType = (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
    video: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    template: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
});
const UseCases = ({ asset, scope })=>{
    const useCases = getVisibleUseCases(asset, scope);
    return useCases.length ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.TagGroup), {
        label: "Use-cases",
        size: "S",
        selectionMode: "none",
        children: useCases.map((useCase, uix)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.Tag), {
                children: getUseCaseLabel(useCase)
            }, uix))
    }) : null;
};
UseCases.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    scope: scopePropType
};
const Product = ({ asset, scope })=>!!asset?.product && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
        label: "Product",
        size: "S",
        value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
            children: interpolateField(asset.product, scope?.selectedCampaign)
        })
    });
Product.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    scope: scopePropType
};
const hasTemplateAssetHelp = (asset, scope)=>!!asset?.description || !!asset?.info || getVisibleUseCases(asset, scope).length > 0;
const TemplateAssetHelp = ({ asset, label, scope })=>hasTemplateAssetHelp(asset, scope) ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5mvex.ContextualHelp), {
        variant: "info",
        styles: " sh182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                children: label ?? asset?.label ?? asset?.name
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                styles: " sd182 _ta182 Ug182 qg182",
                children: [
                    !!asset?.info ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: asset.info
                    }) : !!asset?.description && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: asset.description
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)(Product, {
                        asset: asset,
                        scope: scope
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)(UseCases, {
                        asset: asset,
                        scope: scope
                    })
                ]
            })
        ]
    }) : null;
TemplateAssetHelp.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    scope: scopePropType
};
const TemplateAssetDetails = ({ asset, scope, children })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
        styles: " sd182 _ta182 Ug182 qg182",
        children: [
            children,
            /*#__PURE__*/ (0, $dx4lB.jsx)(Product, {
                asset: asset,
                scope: scope
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)(UseCases, {
                asset: asset,
                scope: scope
            })
        ]
    });
TemplateAssetDetails.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    scope: scopePropType,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const TemplateImageAsset = ({ asset, selectedAsset, label, description, scope, showDetails = true, onDrop, onDelete, children, ...layoutProps })=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $kekDO.ImageAsset), {
        name: asset.name,
        // Deleting an optional asset that was selected, as updating an image
        // variation is, beside the label.
        actions: showDetails && !!asset?.isOptional && !!selectedAsset?.filePath && !!onDelete ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
            size: "XS",
            "aria-label": `Delete ${getAssetLabel(asset, label)}`,
            isDisabled: !!selectedAsset?.isLoading,
            onPress: ()=>onDelete(selectedAsset),
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: "Delete"
                })
            ]
        }) : undefined,
        label: label === null ? null : getAssetLabel(asset, label),
        description: (0, $g42KE.resolveCaptionText)(description, showDetails ? asset.description : null),
        contextualHelp: hasTemplateAssetHelp(asset, scope) ? /*#__PURE__*/ (0, $dx4lB.jsx)(TemplateAssetHelp, {
            asset: asset,
            label: label,
            scope: scope
        }) : null,
        filePath: selectedAsset?.filePath,
        src: selectedAsset?.src,
        isFilled: !!selectedAsset?.filePath,
        isLoading: selectedAsset?.isLoading,
        onDrop: (items, name)=>onDrop(items, name),
        ...layoutProps,
        children: showDetails && /*#__PURE__*/ (0, $dx4lB.jsx)(TemplateAssetDetails, {
            asset: asset,
            scope: scope,
            children: children
        })
    });
TemplateImageAsset.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    selectedAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    scope: scopePropType,
    showDetails: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const TemplateColorAsset = ({ asset, selectedAsset, label, description, scope, colors = [], onChange, ...layoutProps })=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $hjJiG.ColorAsset), {
        name: asset.name,
        label: label === null ? null : getAssetLabel(asset, label),
        description: (0, $g42KE.resolveCaptionText)(description, asset.description),
        color: (selectedAsset?.color ?? selectedAsset?.value) || scope?.video?.data?.customer?.color || "",
        colors: colors,
        contextualHelp: hasTemplateAssetHelp(asset, scope) ? /*#__PURE__*/ (0, $dx4lB.jsx)(TemplateAssetHelp, {
            asset: asset,
            label: label,
            scope: scope
        }) : null,
        onChange: onChange,
        ...layoutProps
    });
TemplateColorAsset.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    selectedAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    scope: scopePropType,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};

});
parcelRegister("5mvex", function(module, exports) {

$parcel$export(module.exports, "ContextualHelpContext", () => $98bf879ca0b3e321$export$41b9afaaba473494);
$parcel$export(module.exports, "ContextualHelp", () => $98bf879ca0b3e321$export$7d3cdb256c2ba320);


var $4W5AG = parcelRequire("4W5AG");

var $208Op = parcelRequire("208Op");

var $7uz0i = parcelRequire("7uz0i");

var $aQTiM = parcelRequire("aQTiM");

var $lV9iF = parcelRequire("lV9iF");

var $gUjW8 = parcelRequire("gUjW8");

var $fL4LX = parcelRequire("fL4LX");

var $5nTep = parcelRequire("5nTep");

var $2ffAV = parcelRequire("2ffAV");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $c1ibQ = parcelRequire("c1ibQ");

var $25dFS = parcelRequire("25dFS");

var $dkaC0 = parcelRequire("dkaC0");

var $gI8Gw = parcelRequire("gI8Gw");
function $98bf879ca0b3e321$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
const $98bf879ca0b3e321$var$$8e176595bc49ca3f$var$wrappingDiv = " NOBje7c182 ZOBje7c182 Th182 Qh182 Sh182 Rh182 _oa182 Fb182";
const $98bf879ca0b3e321$var$$8e176595bc49ca3f$var$headingStyles = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gv182 Iy182 Hy182";
function $98bf879ca0b3e321$export$218201d297fb4e0d(props) {
    let { children: children, ...popoverProps } = props;
    let titleId = (0, $25dFS.useId)();
    return (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
        padding: "none",
        hideArrow: true,
        "aria-labelledby": titleId,
        ...popoverProps,
        children: (0, $dx4lB.jsx)("div", {
            className: $98bf879ca0b3e321$var$$8e176595bc49ca3f$var$wrappingDiv,
            children: (0, $dx4lB.jsx)("div", {
                className: (0, $5nTep.mergeStyles)((0, $7uz0i.dialogInner), " od182 nd182 kd182 jd182 Jnqb3Ob182 Gnqb3Ob182 Inqb3Ob182 Hnqb3Ob182 TjCFGYc182 Qh182 Sh182 Rh182 -T_-Th182"),
                children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $c1ibQ.TextContext),
                            {
                                slots: {
                                    [(0, $fDYaM.DEFAULT_SLOT)]: {}
                                }
                            }
                        ],
                        // Make sure to clear context from above Menu
                        [
                            (0, $208Op.TextContext),
                            null
                        ],
                        [
                            (0, $208Op.HeadingContext),
                            {
                                styles: $98bf879ca0b3e321$var$$8e176595bc49ca3f$var$headingStyles,
                                slots: {
                                    // needed so combobox/picker does not need to provide slot="title" to their provided
                                    // ContextualHelp (they get the aria-labelled by from the button)
                                    // otherwise, use the heading if available aka unavaiable menu item
                                    [(0, $fDYaM.DEFAULT_SLOT)]: {
                                        styles: $98bf879ca0b3e321$var$$8e176595bc49ca3f$var$headingStyles
                                    },
                                    title: {
                                        id: titleId,
                                        styles: $98bf879ca0b3e321$var$$8e176595bc49ca3f$var$headingStyles,
                                        level: 2
                                    }
                                }
                            }
                        ],
                        [
                            (0, $208Op.ContentContext),
                            {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182"
                            }
                        ],
                        [
                            (0, $208Op.FooterContext),
                            {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 JC182"
                            }
                        ]
                    ],
                    children: children
                })
            })
        })
    });
}
const $98bf879ca0b3e321$export$41b9afaaba473494 = (0, $eF4cA.createContext)(null);
const $98bf879ca0b3e321$export$7d3cdb256c2ba320 = (0, $eF4cA.forwardRef)(function ContextualHelp(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($98bf879ca0b3e321$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $98bf879ca0b3e321$export$41b9afaaba473494);
    let { children: children, defaultOpen: defaultOpen, containerPadding: containerPadding = 8, size: size = 'XS', crossOffset: crossOffset, isOpen: isOpen, onOpenChange: onOpenChange, placement: placement = 'bottom start', shouldFlip: shouldFlip, UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, styles: styles, variant: variant = 'help' } = props;
    // In a FieldLabel we're getting the context's aria-labeledby, so we need to
    // manually set the aria-label after useLabels() to keep the order of label
    // then ContextualHelp variant
    let labelProps = (0, $dkaC0.useLabels)(props);
    let label = stringFormatter.format(`contextualhelp.${variant}`);
    // oxlint-disable-next-line react/react-compiler
    labelProps['aria-label'] = labelProps['aria-label'] ? labelProps['aria-label'] + ' ' + label : label;
    let buttonProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    return (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        children: [
            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                slot: null,
                ref: ref,
                size: size,
                ...(0, $lhKAD.mergeProps)(buttonProps, labelProps),
                UNSAFE_style: UNSAFE_style,
                UNSAFE_className: UNSAFE_className,
                styles: styles,
                isQuiet: true,
                children: variant === 'info' ? (0, $dx4lB.jsx)((0, $gUjW8.default), {}) : (0, $dx4lB.jsx)((0, $lV9iF.default), {})
            }),
            (0, $dx4lB.jsx)($98bf879ca0b3e321$export$218201d297fb4e0d, {
                placement: placement,
                shouldFlip: shouldFlip,
                containerPadding: containerPadding,
                offset: 8,
                crossOffset: crossOffset,
                children: children
            })
        ]
    });
});

});
parcelRegister("7uz0i", function(module, exports) {

$parcel$export(module.exports, "dialogInner", () => $e62fb41b15725247$export$6af31f836f9aa6f2);
$parcel$export(module.exports, "Dialog", () => $e62fb41b15725247$export$3ddf2d174ce01153);


var $lK44Y = parcelRequire("lK44Y");

var $4UbTp = parcelRequire("4UbTp");

var $208Op = parcelRequire("208Op");

var $8g9SZ = parcelRequire("8g9SZ");

var $abeS0 = parcelRequire("abeS0");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $8gDpA = parcelRequire("8gDpA");

var $fDYaM = parcelRequire("fDYaM");

var $c1ibQ = parcelRequire("c1ibQ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e62fb41b15725247$var$$9bbc115952dac5a6$var$image = " Za182 FC182 _va182 _Hb182";
const $e62fb41b15725247$var$$9bbc115952dac5a6$var$heading = " _ub182 Jy182 Gy182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182";
const $e62fb41b15725247$var$$9bbc115952dac5a6$var$header = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182";
const $e62fb41b15725247$var$$9bbc115952dac5a6$var$content = " _ub182 _v7GYNyba182 Pa182 P7GYNybe182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 Sk182 Rk182";
const $e62fb41b15725247$var$$9bbc115952dac5a6$var$footer = " _ub182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182";
const $e62fb41b15725247$var$$9bbc115952dac5a6$var$buttonGroup = " IM182 La182";
const $e62fb41b15725247$export$6af31f836f9aa6f2 = " sd182 _ta182 _ub182 K40ub4c182 _oa182 _Le182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 oi182 ni182 ki182 ji182 _Na182 Pa182";
const $e62fb41b15725247$export$3ddf2d174ce01153 = (0, $eF4cA.forwardRef)(function Dialog(props, ref) {
    let { size: size = 'M', isDismissible: isDismissible, isKeyboardDismissDisabled: isKeyboardDismissDisabled } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $abeS0.Modal), {
        size: size,
        isDismissable: isDismissible,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        children: (0, $dx4lB.jsx)((0, $8gDpA.Dialog), {
            ...props,
            ref: domRef,
            style: props.UNSAFE_style,
            className: (props.UNSAFE_className || '') + $e62fb41b15725247$export$6af31f836f9aa6f2,
            children: (0, $fDYaM.composeRenderProps)(props.children, (children)=>(0, $dx4lB.jsxs)((0, $8gDpA.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: [
                        (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                            values: [
                                [
                                    (0, $8g9SZ.ImageContext),
                                    {
                                        styles: $e62fb41b15725247$var$$9bbc115952dac5a6$var$image
                                    }
                                ],
                                [
                                    (0, $208Op.HeadingContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, $208Op.HeaderContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, $208Op.ContentContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, $208Op.FooterContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, $lK44Y.ButtonGroupContext),
                                    {
                                        isHidden: true
                                    }
                                ]
                            ],
                            children: children
                        }),
                        (0, $dx4lB.jsxs)("div", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' sd182';
                                rules += ' ed182';
                                rules += ' qg182';
                                rules += ' Sk182';
                                if (props.isDismissible) rules += ' Re182';
                                else rules += ' Rk182';
                                rules += ' Te182';
                                return rules;
                            }({
                                isDismissible: props.isDismissible
                            }),
                            children: [
                                (0, $dx4lB.jsx)("div", {
                                    className: " sd182 _ub182 Jz182 Jay182 GC182 Gay182 qj182 Ue182 _ta182 _tnc182 ed182 enb182",
                                    children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                        values: [
                                            [
                                                (0, $8g9SZ.ImageContext),
                                                {
                                                    hidden: true
                                                }
                                            ],
                                            [
                                                (0, $208Op.HeadingContext),
                                                {
                                                    styles: $e62fb41b15725247$var$$9bbc115952dac5a6$var$heading
                                                }
                                            ],
                                            [
                                                (0, $208Op.HeaderContext),
                                                {
                                                    styles: $e62fb41b15725247$var$$9bbc115952dac5a6$var$header
                                                }
                                            ],
                                            [
                                                (0, $208Op.ContentContext),
                                                {
                                                    isHidden: true
                                                }
                                            ],
                                            [
                                                (0, $208Op.FooterContext),
                                                {
                                                    isHidden: true
                                                }
                                            ],
                                            [
                                                (0, $lK44Y.ButtonGroupContext),
                                                {
                                                    isHidden: true
                                                }
                                            ]
                                        ],
                                        children: children
                                    })
                                }),
                                props.isDismissible && (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                                    styles: " Gx182"
                                })
                            ]
                        }),
                        (0, $dx4lB.jsx)((0, $c1ibQ.TextContext).Consumer, {
                            children: (value)=>{
                                let contentValue = {};
                                if (value && 'slots' in value && value.slots?.description) contentValue = value.slots.description;
                                return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                    values: [
                                        [
                                            (0, $8g9SZ.ImageContext),
                                            {
                                                hidden: true
                                            }
                                        ],
                                        [
                                            (0, $208Op.HeadingContext),
                                            {
                                                isHidden: true
                                            }
                                        ],
                                        [
                                            (0, $208Op.HeaderContext),
                                            {
                                                isHidden: true
                                            }
                                        ],
                                        [
                                            (0, $208Op.ContentContext),
                                            {
                                                styles: $e62fb41b15725247$var$$9bbc115952dac5a6$var$content,
                                                ...contentValue
                                            }
                                        ],
                                        [
                                            (0, $208Op.FooterContext),
                                            {
                                                isHidden: true
                                            }
                                        ],
                                        [
                                            (0, $lK44Y.ButtonGroupContext),
                                            {
                                                isHidden: true
                                            }
                                        ]
                                    ],
                                    children: children
                                });
                            }
                        }),
                        (0, $dx4lB.jsx)("div", {
                            className: " sd182 Sk182 Rk182 Qk182 Tk182 Tad182 Uj182 qj182 eb182 _wb182",
                            children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                values: [
                                    [
                                        (0, $8g9SZ.ImageContext),
                                        {
                                            hidden: true
                                        }
                                    ],
                                    [
                                        (0, $208Op.HeadingContext),
                                        {
                                            isHidden: true
                                        }
                                    ],
                                    [
                                        (0, $208Op.HeaderContext),
                                        {
                                            isHidden: true
                                        }
                                    ],
                                    [
                                        (0, $208Op.ContentContext),
                                        {
                                            isHidden: true
                                        }
                                    ],
                                    [
                                        (0, $208Op.FooterContext),
                                        {
                                            styles: $e62fb41b15725247$var$$9bbc115952dac5a6$var$footer
                                        }
                                    ],
                                    [
                                        (0, $lK44Y.ButtonGroupContext),
                                        {
                                            isHidden: props.isDismissible,
                                            styles: $e62fb41b15725247$var$$9bbc115952dac5a6$var$buttonGroup,
                                            align: 'end'
                                        }
                                    ]
                                ],
                                children: children
                            })
                        })
                    ]
                }))
        })
    });
});

});
parcelRegister("lK44Y", function(module, exports) {

$parcel$export(module.exports, "ButtonGroupContext", () => $74d5912fd50a2a69$export$4c574c91bb0be0e2);
$parcel$export(module.exports, "ButtonGroup", () => $74d5912fd50a2a69$export$69b1032f2ecdf404);


var $34HUQ = parcelRequire("34HUQ");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $4skXn = parcelRequire("4skXn");

var $f9wnx = parcelRequire("f9wnx");

var $axOIF = parcelRequire("axOIF");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $74d5912fd50a2a69$export$4c574c91bb0be0e2 = (0, $eF4cA.createContext)({});
const $74d5912fd50a2a69$var$$472eaa9a9b344b9a$var$buttongroup = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' sh182';
    if (!position) rules += ' _Pc182';
    if (!maxWidth) rules += ' La182';
    if (props.size === "XL") rules += ' Ug182';
    else if (props.size === "L") rules += ' Ug182';
    else if (props.size === "M") rules += ' Ug182';
    else if (props.size === "S") rules += ' Ue182';
    if (props.size === "XL") rules += ' qg182';
    else if (props.size === "L") rules += ' qg182';
    else if (props.size === "M") rules += ' qg182';
    else if (props.size === "S") rules += ' qe182';
    if (props.orientation === "vertical") rules += ' _ta182';
    else rules += ' _tc182';
    if (props.orientation === "vertical") {
        if (props.align === "center") rules += ' eb182';
        else if (props.align === "end") rules += ' ec182';
        else rules += ' ed182';
    } else rules += ' eb182';
    if (props.orientation === "vertical") {
        if (props.align === "center") rules += ' _Ca182';
        else if (props.align === "end") rules += ' _Cb182';
        else rules += ' _Cg182';
    }
    return rules;
};
const $74d5912fd50a2a69$export$69b1032f2ecdf404 = (0, $eF4cA.forwardRef)(function ButtonGroup(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $74d5912fd50a2a69$export$4c574c91bb0be0e2);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { size: size = 'M', orientation: orientation = 'horizontal', align: align = 'start', children: children, isDisabled: isDisabled, ...otherProps } = props;
    let [hasOverflow, setHasOverflow] = (0, $axOIF.useValueEffect)(false);
    // oxlint-disable react/react-compiler, react-hooks/exhaustive-deps
    let checkForOverflow = (0, $eF4cA.useCallback)(()=>{
        let computeHasOverflow = ()=>{
            if (domRef.current && orientation === 'horizontal') {
                let buttonGroupChildren = Array.from(domRef.current.children);
                let maxX = domRef.current.offsetWidth + 1; // + 1 to account for rounding errors
                // If any buttons have negative X positions (align="end") or extend beyond
                // the width of the button group (align="start"), then switch to vertical.
                if (buttonGroupChildren.some((child)=>child.offsetLeft < 0 || child.offsetLeft + child.offsetWidth > maxX)) return true;
                return false;
            }
        };
        if (orientation === 'horizontal') setHasOverflow(function*() {
            // Force to horizontal for measurement.
            yield false;
            // Measure, and update if there is overflow.
            yield computeHasOverflow();
        });
    }, [
        domRef,
        orientation,
        setHasOverflow,
        children
    ]);
    (0, $4skXn.useLayoutEffect)(()=>{
        checkForOverflow();
    }, [
        checkForOverflow
    ]);
    // 2. External changes: buttongroup won't change size due to any parents changing size, so listen to its container for size changes to figure out if we should remeasure
    let parent = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (domRef.current) parent.current = domRef.current.parentElement;
    }, [
        domRef.current
    ]);
    (0, $f9wnx.useResizeObserver)({
        ref: parent,
        onResize: checkForOverflow
    });
    if (props.isHidden) return null;
    let context = {
        styles: " _va182",
        size: size,
        isDisabled: isDisabled
    };
    return (0, $dx4lB.jsx)("div", {
        ...(0, $fVfXf.filterDOMProps)(otherProps),
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + $74d5912fd50a2a69$var$$472eaa9a9b344b9a$var$buttongroup({
            align: align,
            orientation: orientation === 'vertical' || hasOverflow ? 'vertical' : 'horizontal',
            size: size
        }, props.styles),
        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
            values: [
                [
                    (0, $34HUQ.ButtonContext),
                    context
                ],
                [
                    (0, $34HUQ.LinkButtonContext),
                    context
                ]
            ],
            children: children
        })
    });
});

});

parcelRegister("abeS0", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $775c1d79c9429547$export$2b77a92f1a5ad772);


var $arisx = parcelRequire("arisx");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $1yYiX = parcelRequire("1yYiX");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $775c1d79c9429547$var$$c46d159bd615e407$var$modalOverlayStyles = function anonymous(props) {
    let rules = " ";
    if (props.colorScheme === "dark") rules += ' -ICUGx-_pa182';
    else if (props.colorScheme === "light") rules += ' -ICUGx-_pb182';
    else if (props.colorScheme === "light dark") {
        rules += ' -ICUGx-_pb182';
        rules += ' -ICUGx-D1v0V_pa182';
    }
    rules += ' _pK8eoyd182';
    if (props.colorScheme === "dark") rules += ' -NvXmrd-_ZLmU182';
    else if (props.colorScheme === "light") rules += ' -NvXmrd-_ZN8Gi4c182';
    else if (props.colorScheme === "light dark") {
        rules += ' -NvXmrd-_ZN8Gi4c182';
        rules += ' -NvXmrd-D1v0V_ZLmU182';
    }
    if (props.colorScheme === "dark") rules += ' -j9blY-_ZN8Gi4c182';
    else if (props.colorScheme === "light") rules += ' -j9blY-_ZLmU182';
    else if (props.colorScheme === "light dark") {
        rules += ' -j9blY-_ZLmU182';
        rules += ' -j9blY-D1v0V_ZN8Gi4c182';
    }
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _Er182';
    rules += ' Za182';
    rules += ' FKem6Ob182';
    rules += ' _Bb182';
    rules += ' g8182';
    if (props.isExiting) rules += ' _Ia182';
    else if (props.isEntering) rules += ' _Ia182';
    rules += ' Yf182';
    if (props.isExiting) rules += ' Xa182';
    else rules += ' Xd182';
    rules += ' _2b182';
    return rules;
};
const $775c1d79c9429547$var$$c46d159bd615e407$var$modalWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' _Pe182';
    rules += ' Wr182';
    rules += ' _Er182';
    rules += ' Za182';
    rules += ' FE9bXU182';
    rules += ' sd182';
    if (props.size === "fullscreenTakeover") rules += ' ed182';
    else rules += ' eb182';
    rules += ' _Ca182';
    return rules;
};
const $775c1d79c9429547$export$2b77a92f1a5ad772 = (0, $eF4cA.forwardRef)(function Modal(props1, ref) {
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let colorScheme = (0, $eF4cA.useContext)((0, $arisx.ColorSchemeContext));
    let { locale: locale, direction: direction } = (0, $1ntKq.useLocale)();
    // TODO: should we pass through lang and dir props in RAC?
    let modalRef = (0, $eF4cA.useCallback)((el)=>{
        // oxlint-disable-next-line react/react-compiler
        domRef.current = el;
        if (el) {
            el.lang = locale;
            el.dir = direction;
        }
    }, [
        locale,
        direction,
        domRef
    ]);
    return (0, $dx4lB.jsx)((0, $1yYiX.ModalOverlay), {
        ...props1,
        className: (renderProps)=>$775c1d79c9429547$var$$c46d159bd615e407$var$modalOverlayStyles({
                ...renderProps,
                colorScheme: colorScheme
            }),
        children: (0, $dx4lB.jsx)("div", {
            className: $775c1d79c9429547$var$$c46d159bd615e407$var$modalWrapper({
                size: props1.size
            }),
            style: {
                containerType: 'size'
            },
            children: (0, $dx4lB.jsx)((0, $1yYiX.Modal), {
                ...props1,
                ref: modalRef,
                className: (renderProps)=>(function anonymous(props) {
                        let rules = " ";
                        rules += ' sd182';
                        rules += ' _ta182';
                        if (props.size === "fullscreenTakeover") rules += ' od182';
                        else rules += ' oe182';
                        if (props.size === "fullscreenTakeover") rules += ' nd182';
                        else rules += ' ne182';
                        if (props.size === "fullscreenTakeover") rules += ' kd182';
                        else rules += ' ke182';
                        if (props.size === "fullscreenTakeover") rules += ' jd182';
                        else rules += ' je182';
                        if (props.size === "fullscreenTakeover") rules += ' Za182';
                        else if (props.size === "fullscreen") rules += ' ZGqsG7b182';
                        else if (props.size === "XL") rules += ' ZbRWaYd182';
                        else if (props.size === "L") rules += ' Zb4QY4182';
                        else if (props.size === "M") rules += ' ZILqIYb182';
                        else if (props.size === "S") rules += ' ZA182';
                        if (props.size === "fullscreenTakeover") rules += ' Fb182';
                        else if (props.size === "fullscreen") rules += ' FGqsG7b182';
                        if (props.size === "fullscreenTakeover") rules += ' Lp182';
                        else if (props.size === "fullscreen") rules += ' Lp182';
                        else rules += ' Lc182';
                        if (props.size === "fullscreenTakeover") rules += ' Ki182';
                        else if (props.size === "fullscreen") rules += ' Ki182';
                        else rules += ' KjVOfn182';
                        if (props.size === "fullscreenTakeover") rules += ' QILlin182';
                        rules += ' -Ovbhqd-g_g182';
                        rules += ' gEzkoQe182';
                        if (props.isExiting) rules += ' _Ia182';
                        else if (props.isEntering) rules += ' _Ia182';
                        if (props.isEntering) {
                            rules += ' -_8PloMd-w182';
                            rules += ' __Ya182';
                        }
                        rules += ' YmenWad182';
                        if (props.isExiting) rules += ' Xa182';
                        else rules += ' Xd182';
                        rules += ' _2b182';
                        if (props.isExiting) rules += ' _1a182';
                        else rules += ' _1b182';
                        rules += ' _Lf182';
                        rules += ' _Mb182';
                        rules += ' Oj182';
                        return rules;
                    })({
                        ...renderProps,
                        size: props1.size
                    })
            })
        })
    });
});

});
parcelRegister("1yYiX", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $82e1859f1c847495$export$ab57792b9b6974a6);
$parcel$export(module.exports, "Modal", () => $82e1859f1c847495$export$2b77a92f1a5ad772);
$parcel$export(module.exports, "ModalOverlay", () => $82e1859f1c847495$export$8948f78d83984c69);

var $fDYaM = parcelRequire("fDYaM");

var $8gDpA = parcelRequire("8gDpA");

var $bTDob = parcelRequire("bTDob");

var $br9QK = parcelRequire("br9QK");
var $k771r = parcelRequire("k771r");

var $fVfXf = parcelRequire("fVfXf");

var $fSNAA = parcelRequire("fSNAA");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $lIr3v = parcelRequire("lIr3v");

var $eF4cA = parcelRequire("eF4cA");

var $gVozo = parcelRequire("gVozo");

var $6AczJ = parcelRequire("6AczJ");

var $hWe38 = parcelRequire("hWe38");

var $4skXn = parcelRequire("4skXn");

var $26CkO = parcelRequire("26CkO");

var $4Oopw = parcelRequire("4Oopw");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $82e1859f1c847495$export$ab57792b9b6974a6 = (0, $eF4cA.createContext)(null);
const $82e1859f1c847495$export$6bc057cefccad9c8 = (0, $eF4cA.createContext)(null);
const $82e1859f1c847495$export$2b77a92f1a5ad772 = (0, $eF4cA.forwardRef)(function Modal(props, ref) {
    let ctx = (0, $eF4cA.useContext)($82e1859f1c847495$export$6bc057cefccad9c8);
    if (ctx) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalContent, {
        ...props,
        modalRef: ref
    }, props.children);
    let { isDismissable: isDismissable, isKeyboardDismissDisabled: isKeyboardDismissDisabled, isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange, children: children, isEntering: isEntering, isExiting: isExiting, UNSTABLE_portalContainer: UNSTABLE_portalContainer, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($82e1859f1c847495$export$8948f78d83984c69, {
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        isEntering: isEntering,
        isExiting: isExiting,
        UNSTABLE_portalContainer: UNSTABLE_portalContainer,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalContent, {
        ...otherProps,
        modalRef: ref
    }, children));
});
function $82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalOverlayWithForwardRef(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $82e1859f1c847495$export$ab57792b9b6974a6);
    let contextState = (0, $eF4cA.useContext)((0, $8gDpA.OverlayTriggerStateContext));
    let localState = (0, $lIr3v.useOverlayTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let objectRef = (0, $26CkO.useObjectRef)(ref);
    let modalRef = (0, $eF4cA.useRef)(null);
    let isOverlayExiting = (0, $6AczJ.useExitAnimation)(objectRef, state.isOpen, props.onExit);
    let onExitRef = (0, $eF4cA.useRef)(null);
    let isModalExiting = (0, $6AczJ.useExitAnimation)(modalRef, state.isOpen, (element)=>onExitRef.current?.(element));
    let isExiting = isOverlayExiting || isModalExiting || props.isExiting || false;
    let isSSR = (0, $hWe38.useIsSSR)();
    if (!state.isOpen && !isExiting || isSSR) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalOverlayInner, {
        ...props,
        state: state,
        isExiting: isExiting,
        overlayRef: objectRef,
        modalRef: modalRef,
        onExitRef: onExitRef
    });
}
const $82e1859f1c847495$export$8948f78d83984c69 = (0, $eF4cA.forwardRef)($82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalOverlayWithForwardRef);
function $82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalOverlayInner({ UNSTABLE_portalContainer: UNSTABLE_portalContainer, UNSTABLE_deferUntilEntered: UNSTABLE_deferUntilEntered, ...props }) {
    let modalRef = props.modalRef;
    let { state: state } = props;
    let [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    let entering = (0, $6AczJ.useEnterAnimation)(props.overlayRef, isOpen, props.onEnter) || props.isEntering || false;
    let isDeferred = !!UNSTABLE_deferUntilEntered && (!isOpen || entering);
    let { modalProps: modalProps, underlayProps: underlayProps } = (0, $bTDob.useModalOverlay)({
        ...props,
        isEntering: isDeferred
    }, state, modalRef);
    // Pass the entering state to the dialog so it waits to move focus until the modal has entered.
    let dialogContext = (0, $eF4cA.useContext)((0, $8gDpA.DialogContext));
    let mergedDialogContext = UNSTABLE_deferUntilEntered ? $82e1859f1c847495$var$$8b8d26808cb8cb53$var$mergeDialogContext(dialogContext, {
        isEntering: isDeferred
    }) : dialogContext;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ModalOverlay',
        values: {
            isEntering: entering,
            isExiting: props.isExiting,
            state: state
        }
    });
    let viewport = (0, $4Oopw.useViewportSize)();
    let pageWidth = undefined;
    let pageHeight = undefined;
    if (typeof document !== 'undefined') {
        let scrollingElement = (0, $fSNAA.isScrollable)(document.body) ? document.body : document.scrollingElement || document.documentElement;
        // Prevent Firefox from adding scrollbars when the page has a fractional width/height.
        let fractionalWidthDifference = scrollingElement.getBoundingClientRect().width % 1;
        let fractionalHeightDifference = scrollingElement.getBoundingClientRect().height % 1;
        pageWidth = scrollingElement.scrollWidth - fractionalWidthDifference;
        pageHeight = scrollingElement.scrollHeight - fractionalHeightDifference;
    }
    let style = {
        ...renderProps.style,
        '--visual-viewport-width': viewport.width + 'px',
        '--visual-viewport-height': viewport.height + 'px',
        '--page-width': pageWidth !== undefined ? pageWidth + 'px' : undefined,
        '--page-height': pageHeight !== undefined ? pageHeight + 'px' : undefined
    };
    (0, $4skXn.useLayoutEffect)(()=>(0, $gVozo.runAfterKeyboard)(()=>setIsOpen(true)), []);
    // oxlint-disable react/react-compiler
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $k771r.Overlay), {
        isExiting: props.isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), underlayProps),
        ...renderProps,
        style: style,
        ref: props.overlayRef,
        "data-entering": entering || undefined,
        "data-exiting": props.isExiting || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $82e1859f1c847495$export$6bc057cefccad9c8,
                {
                    modalProps: modalProps,
                    modalRef: modalRef,
                    isExiting: props.isExiting,
                    onExitRef: props.onExitRef,
                    isOpen: isOpen,
                    isDismissable: props.isDismissable
                }
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                state
            ],
            [
                (0, $8gDpA.DialogContext),
                mergedDialogContext
            ]
        ]
    }, renderProps.children)));
// oxlint-enable react/react-compiler
}
function $82e1859f1c847495$var$$8b8d26808cb8cb53$var$mergeDialogContext(context, props) {
    if (context && 'slots' in context && context.slots) {
        let slots = {};
        for(let key in context.slots)slots[key] = {
            ...context.slots[key],
            ...props
        };
        return {
            ...context,
            slots: slots
        };
    }
    return {
        ...context,
        ...props
    };
}
function $82e1859f1c847495$var$$8b8d26808cb8cb53$var$ModalContent(props) {
    let { modalProps: modalProps, modalRef: modalRef, isExiting: isExiting, onExitRef: onExitRef, isDismissable: isDismissable, isOpen: isOpen } = (0, $eF4cA.useContext)($82e1859f1c847495$export$6bc057cefccad9c8);
    let state = (0, $eF4cA.useContext)((0, $8gDpA.OverlayTriggerStateContext));
    let mergedRefs = (0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(props.modalRef, modalRef), [
        props.modalRef,
        modalRef
    ]);
    let ref = (0, $26CkO.useObjectRef)(mergedRefs);
    let entering = (0, $6AczJ.useEnterAnimation)(ref, isOpen, props.onEnter);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Modal',
        values: {
            isEntering: entering,
            isExiting: isExiting,
            state: state
        }
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        if (onExitRef) onExitRef.current = props.onExit;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), modalProps),
        ...renderProps,
        ref: ref,
        "data-entering": entering || undefined,
        "data-exiting": isExiting || undefined
    }, isDismissable && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $br9QK.DismissButton), {
        onDismiss: state.close
    }), renderProps.children);
}

});
parcelRegister("4Oopw", function(module, exports) {

$parcel$export(module.exports, "useViewportSize", () => $e75cd944d764bf21$export$d699905dd57c73ca);

var $fvyIQ = parcelRequire("fvyIQ");

var $11FxZ = parcelRequire("11FxZ");

var $gVozo = parcelRequire("gVozo");

var $hWe38 = parcelRequire("hWe38");

var $lDJIO = parcelRequire("lDJIO");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
function $e75cd944d764bf21$export$d699905dd57c73ca() {
    let isSSR = (0, $hWe38.useIsSSR)();
    let unmountRef = (0, $eF4cA.useRef)(null);
    let [size, setSize] = (0, $eF4cA.useState)(()=>isSSR ? {
            width: 0,
            height: 0
        } : $e75cd944d764bf21$var$$6066a2c586ade9e1$var$getViewportSize());
    (0, $eF4cA.useEffect)(()=>{
        let updateSize = (newSize)=>{
            setSize((size)=>{
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        let onResize = ()=>{
            // Ignore updates when zoomed.
            if ($e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport && $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.scale > 1) return;
            updateSize($e75cd944d764bf21$var$$6066a2c586ade9e1$var$getViewportSize());
        };
        // When closing the keyboard, WebKit on iOS does not fire the visual viewport resize event until the animation is complete.
        // We can anticipate this and resize early by handling the blur event and using the layout size.
        let onBlur = (e)=>{
            if ($e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport && $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.scale > 1) return;
            if (!(0, $lDJIO.willOpenKeyboard)((0, $fvyIQ.getEventTarget)(e))) return;
            unmountRef.current = (0, $gVozo.runAfterKeyboard)((isOpen)=>{
                if (isOpen) return;
                updateSize({
                    width: document.documentElement.clientWidth,
                    height: document.documentElement.clientHeight
                });
            });
        };
        updateSize($e75cd944d764bf21$var$$6066a2c586ade9e1$var$getViewportSize());
        if ((0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)()) window.addEventListener('blur', onBlur, true);
        if (!$e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport) window.addEventListener('resize', onResize);
        else $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.addEventListener('resize', onResize);
        return ()=>{
            unmountRef.current?.();
            if ((0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)()) window.removeEventListener('blur', onBlur, true);
            if (!$e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport) window.removeEventListener('resize', onResize);
            else $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.removeEventListener('resize', onResize);
        };
    }, []);
    return size;
}
/**
 * Get the viewport size without the scrollbar.
 */ function $e75cd944d764bf21$var$$6066a2c586ade9e1$var$getViewportSize() {
    return {
        // Multiply by the visualViewport scale to get the "natural" size, unaffected by pinch zooming.
        width: $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport ? // See: https://github.com/w3c/csswg-drafts/issues/8099
        Math.min($e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.width * $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.scale, document.documentElement.clientWidth) : document.documentElement.clientWidth,
        height: $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport ? $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.height * $e75cd944d764bf21$var$$6066a2c586ade9e1$var$visualViewport.scale : document.documentElement.clientHeight
    };
}

});




parcelRegister("aQTiM", function(module, exports) {

$parcel$export(module.exports, "DialogTrigger", () => $f87bb91c621702e9$export$2e1e1122cf0cba88);

var $dx4lB = parcelRequire("dx4lB");

var $8gDpA = parcelRequire("8gDpA");

var $7aYcI = parcelRequire("7aYcI");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f87bb91c621702e9$export$2e1e1122cf0cba88(props) {
    return (0, $dx4lB.jsx)((0, $8gDpA.DialogTrigger), {
        ...props,
        children: (0, $dx4lB.jsx)((0, $7aYcI.PressResponder), {
            isPressed: false,
            children: props.children
        })
    });
}

});

parcelRegister("lV9iF", function(module, exports) {

$parcel$export(module.exports, "default", () => $58fd92031613d85c$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $58fd92031613d85c$var$$410bd93c9b5189d7$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M9.988 15.527c-.23.008-.455-.074-.627-.229-.33-.365-.33-.92 0-1.286.17-.158.395-.243.627-.235.236-.01.466.08.633.248.162.168.25.394.242.627.012.235-.07.466-.228.64-.174.165-.408.25-.647.235"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M9.992 12.706c-.414 0-.75-.336-.75-.75 0-1.022.07-1.714 1.04-2.683.784-.786.917-1.101.917-1.65 0-.21-.066-1.259-1.374-1.259-1.365 0-1.51 1.156-1.526 1.388-.027.413-.393.72-.797.7-.414-.028-.727-.385-.7-.798.064-.965.777-2.79 3.023-2.79 1.887 0 2.874 1.388 2.874 2.758 0 1.144-.457 1.81-1.357 2.712-.576.576-.6.811-.6 1.622 0 .414-.336.75-.75.75"
            })
        ]
    });
const $58fd92031613d85c$var$$410bd93c9b5189d7$var$ForwardRef = (0, $eF4cA.forwardRef)($58fd92031613d85c$var$$410bd93c9b5189d7$var$SvgComponent);
var $58fd92031613d85c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($58fd92031613d85c$var$$410bd93c9b5189d7$var$ForwardRef);

});


parcelRegister("yuTTo", function(module, exports) {

$parcel$export(module.exports, "LabeledValue", () => $00afd48d800b1885$export$d1328f67a56fa517);


var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $1qrul = parcelRequire("1qrul");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $eZSya = parcelRequire("eZSya");

var $9hIi4 = parcelRequire("9hIi4");

var $e62p6 = parcelRequire("e62p6");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $00afd48d800b1885$export$8ba7143a95895992 = (0, $eF4cA.createContext)(null);
const $00afd48d800b1885$var$$bf071f0d57f421d9$var$fieldStyles = function anonymous(props, overrides) {
    let rules = " ";
    let gridColumnStart = false;
    let gridColumnEnd = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "z") gridColumnStart = true;
        if (p[1] === "y") gridColumnEnd = true;
        rules += p[0];
    }
    rules += ' se182';
    if (props.isInForm) {
        if (!gridColumnStart) rules += ' z2mU182';
    }
    if (props.isInForm) {
        if (props.labelPosition === "side") {
            if (!gridColumnEnd) rules += ' yvoofG182';
        }
    }
    if (props.isInForm) rules += ' DLwlgod182';
    else {
        if (props.labelPosition === "side") rules += ' DPlN5qb182';
        else if (props.labelPosition === "top") rules += ' DM8Mfn182';
    }
    if (props.labelPosition === "side") rules += ' EPlN5qb182';
    else if (props.labelPosition === "top") rules += ' E4w1sLc182';
    if (props.labelPosition === "side") rules += ' CbRM95c182';
    else if (props.labelPosition === "top") rules += ' Cxaocre182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' ea182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.size === "XL") rules += ' -BhX7R-Fz182';
    else if (props.size === "L") rules += ' -BhX7R-Fv182';
    else if (props.size === "S") rules += ' -BhX7R-Fp182';
    else if (props.size === "XS") rules += ' -BhX7R-Fn182';
    else rules += ' -BhX7R-Fx182';
    rules += ' -AJjOLd-UVkF0Db182';
    rules += ' qg182';
    rules += ' __ca182';
    return rules;
};
const $00afd48d800b1885$var$$bf071f0d57f421d9$var$valueStyles = function anonymous(props) {
    let rules = " ";
    rules += ' zXcEWr182';
    rules += ' yXcEWr182';
    rules += ' BXcEWr182';
    rules += ' AXcEWr182';
    if (props.size === "XL") rules += ' Nl182';
    else if (props.size === "L") rules += ' Nj182';
    else if (props.size === "S") rules += ' Nf182';
    else if (props.size === "XS") rules += ' Ne182';
    else rules += ' Nk182';
    if (props.isQuiet) rules += ' _qd182';
    else rules += ' _qtb182';
    if (props.size === "XL") rules += ' -Anxdcc-Zt182';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
    else if (props.size === "S") rules += ' -Anxdcc-Zr182';
    else rules += ' -Anxdcc-Z3fn9H182';
    rules += ' __v6TNLWb182';
    if (props.isInForm) {
        if (props.size === "XL") rules += ' Mk182';
        else if (props.size === "L") rules += ' Mh182';
        else if (props.size === "S") rules += ' Mg182';
        else if (props.size === "XS") rules += ' Mf182';
        else rules += ' Mi182';
    }
    rules += ' sd182';
    rules += ' eb182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    else if (props.size === "XS") rules += ' pt182';
    else rules += ' pt182';
    return rules;
};
const $00afd48d800b1885$export$d1328f67a56fa517 = (0, $eF4cA.forwardRef)(function LabeledValue(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $00afd48d800b1885$export$8ba7143a95895992);
    props = (0, $j3pTw.useFormProps)(props);
    let { label: label, value: value, formatOptions: formatOptions, size: size = 'M', labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', contextualHelp: contextualHelp, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles, ...otherProps } = props;
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    (0, $eF4cA.useEffect)(()=>{
        if (domRef?.current && domRef.current.querySelectorAll('input, [contenteditable], textarea').length > 0) throw new Error('LabeledValue cannot contain an editable value.');
    }, [
        domRef
    ]);
    let children;
    if (Array.isArray(value)) children = (0, $dx4lB.jsx)($00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedStringList, {
        value: value,
        formatOptions: formatOptions
    });
    else if (typeof value === 'number') children = (0, $dx4lB.jsx)($00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedNumber, {
        value: value,
        formatOptions: formatOptions
    });
    else if (typeof value === 'object' && value !== null && 'start' in value && typeof value.start === 'number') children = (0, $dx4lB.jsx)($00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedNumber, {
        value: value,
        formatOptions: formatOptions
    });
    else if (typeof value === 'object' && value !== null && 'start' in value) children = (0, $dx4lB.jsx)($00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedDate, {
        value: value,
        formatOptions: formatOptions
    });
    else if (value instanceof Date || typeof value === 'object' && value !== null && ('calendar' in value || 'hour' in value)) children = (0, $dx4lB.jsx)($00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedDate, {
        value: value,
        formatOptions: formatOptions
    });
    else if (typeof value === 'string') children = value;
    else if ((0, $eF4cA.isValidElement)(value)) children = value;
    return (0, $dx4lB.jsxs)("div", {
        ...(0, $fVfXf.filterDOMProps)(otherProps),
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + $00afd48d800b1885$var$$bf071f0d57f421d9$var$fieldStyles({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, styles),
        children: [
            (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                elementType: "span",
                size: size,
                labelPosition: labelPosition,
                labelAlign: labelAlign,
                contextualHelp: contextualHelp,
                children: label
            }),
            (0, $dx4lB.jsx)("span", {
                className: $00afd48d800b1885$var$$bf071f0d57f421d9$var$valueStyles({
                    isInForm: !!formContext,
                    size: size,
                    labelPosition: labelPosition
                }),
                children: children
            })
        ]
    });
});
function $00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedStringList({ value: value, formatOptions: formatOptions }) {
    let formatter = (0, $9hIi4.useListFormatter)(formatOptions ?? {});
    return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: formatter.format(value)
    });
}
function $00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedNumber({ value: value, formatOptions: formatOptions }) {
    let formatter = (0, $e62p6.useNumberFormatter)(formatOptions);
    if (typeof value === 'object') return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: formatter.formatRange(value.start, value.end)
    });
    return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: formatter.format(value)
    });
}
function $00afd48d800b1885$var$$bf071f0d57f421d9$var$FormattedDate({ value: value, formatOptions: formatOptions }) {
    if (!formatOptions) formatOptions = $00afd48d800b1885$var$$bf071f0d57f421d9$var$getDefaultFormatOptions('start' in value ? value.start : value);
    let dateFormatter = (0, $eZSya.useDateFormatter)(formatOptions);
    let timeZone = dateFormatter.resolvedOptions().timeZone || (0, $1qrul.getLocalTimeZone)();
    if ('start' in value && 'end' in value) {
        let start = $00afd48d800b1885$var$$bf071f0d57f421d9$var$convertDateTime(value.start, timeZone);
        let end = $00afd48d800b1885$var$$bf071f0d57f421d9$var$convertDateTime(value.end, timeZone);
        return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
            children: dateFormatter.formatRange(start, end)
        });
    }
    return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: dateFormatter.format($00afd48d800b1885$var$$bf071f0d57f421d9$var$convertDateTime(value, timeZone))
    });
}
function $00afd48d800b1885$var$$bf071f0d57f421d9$var$convertDateTime(value, timeZone) {
    if ('timeZone' in value) return value.toDate();
    else if ('calendar' in value) return value.toDate(timeZone);
    else if (!(value instanceof Date)) return (0, $8jDkV.toCalendarDateTime)((0, $1qrul.today)((0, $1qrul.getLocalTimeZone)()), value).toDate(timeZone);
    return value;
}
function $00afd48d800b1885$var$$bf071f0d57f421d9$var$getDefaultFormatOptions(value) {
    if (value instanceof Date) return {
        dateStyle: 'long',
        timeStyle: 'short'
    };
    else if ('timeZone' in value) return {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: value.timeZone,
        timeZoneName: 'short'
    };
    else if ('hour' in value && 'year' in value) return {
        dateStyle: 'long',
        timeStyle: 'short'
    };
    else if ('hour' in value) return {
        timeStyle: 'short'
    };
    else return {
        dateStyle: 'long'
    };
}

});
parcelRegister("8w4Nl", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $668ccde884a3272f$export$1acdcf5a973a8414);
$parcel$export(module.exports, "FieldGroup", () => $668ccde884a3272f$export$f0fe469072bc6950);
$parcel$export(module.exports, "Input", () => $668ccde884a3272f$export$f5b8910cec6cf069);
$parcel$export(module.exports, "helpTextStyles", () => $668ccde884a3272f$export$13b1fd5431595bf6);
$parcel$export(module.exports, "HelpText", () => $668ccde884a3272f$export$a67c0bc59081311a);
$parcel$export(module.exports, "FieldErrorIcon", () => $668ccde884a3272f$export$bda0d075e0e342c9);


var $cnBj9 = parcelRequire("cnBj9");

var $2VqIs = parcelRequire("2VqIs");

var $8OJ2z = parcelRequire("8OJ2z");

var $5mvex = parcelRequire("5mvex");

var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $5nTep = parcelRequire("5nTep");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $eF4cA = parcelRequire("eF4cA");

var $fvyIQ = parcelRequire("fvyIQ");

var $cTXxz = parcelRequire("cTXxz");

var $ecbit = parcelRequire("ecbit");

var $8UElq = parcelRequire("8UElq");

var $fDYaM = parcelRequire("fDYaM");

var $c1ibQ = parcelRequire("c1ibQ");

var $25dFS = parcelRequire("25dFS");

var $gI8Gw = parcelRequire("gI8Gw");
function $668ccde884a3272f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $668ccde884a3272f$export$1acdcf5a973a8414 = (0, $eF4cA.forwardRef)(function FieldLabel(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($668ccde884a3272f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { isDisabled: isDisabled, isRequired: isRequired, size: size = 'M', necessityIndicator: necessityIndicator = 'icon', includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName = false, labelAlign: labelAlign, labelPosition: labelPosition, staticColor: staticColor, contextualHelp: contextualHelp, isQuiet: isQuiet, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', ...labelProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let contextualHelpId = (0, $25dFS.useId)();
    let fallbackLabelPropsId = (0, $25dFS.useId)();
    if (contextualHelp && !labelProps.id) labelProps.id = fallbackLabelPropsId;
    if (!props.children) return null;
    return (0, $dx4lB.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' zv6x9r182';
            rules += ' yv6x9r182';
            rules += ' Bv6x9r182';
            rules += ' Av6x9r182';
            rules += ' sf182';
            if (props.labelAlign === "end") rules += ' _Wb182';
            else if (props.labelAlign === "start") rules += ' _Wd182';
            if (props.labelPosition === "top") rules += ' QgOnRt182';
            if (props.isQuiet) rules += ' _qd182';
            else if (props.labelPosition === "top") rules += ' _qb182';
            return rules;
        }({
            labelAlign: labelAlign,
            labelPosition: labelPosition,
            isQuiet: isQuiet
        }),
        children: [
            (0, $dx4lB.jsxs)((0, $8UElq.Label), {
                ...labelProps,
                ref: domRef,
                style: UNSAFE_style,
                className: UNSAFE_className + (0, $5nTep.mergeStyles)(function anonymous(props) {
                    let rules = " ";
                    if (props.size === "XL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "L") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "S") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XS") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.size === "XL") {
                        rules += ' -_6BNtrc-e182';
                        rules += ' vx182';
                    } else if (props.size === "L") {
                        rules += ' -_6BNtrc-d182';
                        rules += ' vx182';
                    } else if (props.size === "S") {
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    } else if (props.size === "XS") {
                        rules += ' -_6BNtrc-a182';
                        rules += ' vx182';
                    } else {
                        rules += ' -_6BNtrc-c182';
                        rules += ' vx182';
                    }
                    if (props.size === "XL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "L") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "S") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "XS") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else {
                        rules += ' xb182';
                        rules += ' _xa182';
                    }
                    if (props.size === "XL") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "L") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "S") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "XS") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    }
                    if (props.isStaticColor) rules += ' pl182';
                    else if (props.isDisabled) rules += ' pp182';
                    else rules += ' pv182';
                    rules += ' plb182';
                    rules += ' ri182';
                    return rules;
                }({
                    labelPosition: labelPosition,
                    isDisabled: isDisabled,
                    size: size,
                    isStaticColor: !!staticColor
                }), props.styles),
                children: [
                    props.children,
                    (isRequired || necessityIndicator === 'label') && (0, $dx4lB.jsxs)("span", {
                        className: " _7c182",
                        children: [
                            "\xa0",
                            necessityIndicator === 'icon' && (0, $dx4lB.jsx)((0, $2VqIs.default), {
                                size: size === 'S' ? 'M' : size,
                                className: " -_8sjo0b-t5ZbAob182",
                                "aria-label": includeNecessityIndicatorInAccessibilityName ? stringFormatter.format('label.(required)') : undefined,
                                "aria-hidden": !includeNecessityIndicatorInAccessibilityName
                            }),
                            necessityIndicator === 'label' && (0, $dx4lB.jsx)("span", {
                                "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined,
                                children: isRequired ? stringFormatter.format('label.(required)') : stringFormatter.format('label.(optional)')
                            })
                        ]
                    })
                ]
            }),
            contextualHelp && (0, $dx4lB.jsxs)("span", {
                className: " _7c182",
                children: [
                    "\xa0",
                    (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                        styles: " sh182 Fa182",
                        children: (0, $dx4lB.jsx)((0, $5mvex.ContextualHelpContext).Provider, {
                            value: {
                                id: contextualHelpId,
                                'aria-labelledby': labelProps?.id ? `${labelProps.id} ${contextualHelpId}` : undefined,
                                size: size === 'L' || size === 'XL' ? 'S' : 'XS'
                            },
                            children: contextualHelp
                        })
                    })
                ]
            })
        ]
    });
});
const $668ccde884a3272f$var$$9afd80978c252040$var$fieldGroupStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
        rules += ' plb182';
    }
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _oa182';
    rules += ' SMBFGYc182';
    rules += ' RfBFGYc182';
    if (props.size === "XL") rules += ' Nl182';
    else if (props.size === "L") rules += ' Nj182';
    else if (props.size === "S") rules += ' Nf182';
    else if (props.size === "XS") rules += ' Ne182';
    else rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' FRuFGYc182';
    rules += ' zXcEWr182';
    rules += ' yXcEWr182';
    rules += ' BXcEWr182';
    rules += ' AXcEWr182';
    if (props.isQuiet) rules += ' _qd182';
    else rules += ' _qtb182';
    if (props.size === "XL") rules += ' -Anxdcc-Zt182';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
    else if (props.size === "S") rules += ' -Anxdcc-Zr182';
    else rules += ' -Anxdcc-Z3fn9H182';
    rules += ' __v6TNLWb182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mCPFGYc182';
    rules += ' l5OFGYc182';
    rules += ' _jf182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isDisabled) {
        rules += ' iq182';
        rules += ' ilc182';
    } else if (props.isFocusWithin) {
        if (props.isInvalid) rules += ' im182';
        else rules += ' in182';
        rules += ' ild182';
    } else if (props.isInvalid) {
        if (props.isPressed) rules += ' im182';
        else if (props.isFocusVisible) rules += ' im182';
        else if (props.isHovered) rules += ' im182';
        else rules += ' ip182';
        rules += ' ile182';
    } else {
        if (props.isPressed) rules += ' io182';
        else if (props.isFocusVisible) rules += ' io182';
        else if (props.isHovered) rules += ' io182';
        else rules += ' iq182';
        rules += ' ila182';
    }
    rules += ' gX182';
    rules += ' gl1kG7o182';
    if (props.isDisabled) rules += ' ri182';
    else rules += ' rD182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    else if (props.size === "XS") rules += ' -F_-Fn182';
    else rules += ' -F_-Fx182';
    rules += ' -S_-Sv182';
    rules += ' -R_-Rv182';
    rules += ' -m_-mc182';
    rules += ' -l_-lc182';
    return rules;
};
const $668ccde884a3272f$export$f0fe469072bc6950 = (0, $eF4cA.forwardRef)(function FieldGroup(props, ref) {
    let { children: children, prefix: prefix, shouldTurnOffFocusRing: shouldTurnOffFocusRing, ...otherProps } = props;
    let ctx = (0, $eF4cA.useContext)((0, $ecbit.InputContext));
    let prefixId = (0, $25dFS.useId)();
    let newAriaLabelledby = ctx?.['aria-labelledby'];
    if (prefix) newAriaLabelledby = newAriaLabelledby ? `${newAriaLabelledby} ${prefixId}` : prefixId;
    return (0, $dx4lB.jsxs)((0, $cTXxz.Group), {
        ref: ref,
        ...otherProps,
        onPointerDown: (e)=>{
            // Forward focus to input element when clicking on a non-interactive child (e.g. icon or padding)
            if (e.pointerType === 'mouse' && !(0, $fvyIQ.getEventTarget)(e).closest('button,input,textarea,[role="button"]')) {
                e.preventDefault();
                e.currentTarget.querySelector('input, textarea')?.focus();
            }
        },
        onTouchEnd: (e)=>{
            let target = (0, $fvyIQ.getEventTarget)(e);
            if (!target.isContentEditable && !target.closest('button,input,textarea,[role="button"]')) {
                e.preventDefault();
                e.currentTarget.querySelector('input, textarea')?.focus();
            }
        },
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + ' ' + (0, $8OJ2z.centerBaselineBefore) + (0, $5nTep.mergeStyles)($668ccde884a3272f$var$$9afd80978c252040$var$fieldGroupStyles({
                ...renderProps,
                isFocusWithin: shouldTurnOffFocusRing ? false : renderProps.isFocusWithin,
                isFocusVisible: shouldTurnOffFocusRing ? false : renderProps.isFocusVisible,
                size: props.size || 'M'
            }), props.styles),
        children: [
            props.prefix ? (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $dm5H1.IconContext),
                        {
                            styles: " ZObNfn182 FObNfn182 -_8sjo0b-t5ZbAob182"
                        }
                    ]
                ],
                children: (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                    id: prefixId,
                    styles: " pn182 _va182 Ht182 Hsu182",
                    children: props.prefix
                })
            }) : null,
            (0, $dx4lB.jsx)((0, $ecbit.InputContext).Consumer, {
                children: (ctx)=>(0, $dx4lB.jsx)((0, $ecbit.InputContext).Provider, {
                        value: {
                            ...ctx,
                            'aria-labelledby': newAriaLabelledby
                        },
                        children: children
                    })
            })
        ]
    });
});
const $668ccde884a3272f$export$f5b8910cec6cf069 = (0, $eF4cA.forwardRef)(function Input(props, ref) {
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles, ...otherProps } = props;
    return (0, $dx4lB.jsx)((0, $ecbit.Input), {
        ...otherProps,
        ref: ref,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, $5nTep.mergeStyles)(" Td182 Qd182 Sd182 Rd182 g9182 p40ub4c182 pYFIK2bn182 pYFIK2blc182 u40ub4c182 v40ub4c182 x40ub4c182 _xa182 _ub182 _vb182 Na182 Za182 _Le182 _je182 _Nc182 Pc182 _Yb182 _7c182", styles)
    });
});
const $668ccde884a3272f$export$13b1fd5431595bf6 = function anonymous(props) {
    let rules = " ";
    rules += ' zzBWQ8d182';
    rules += ' yzBWQ8d182';
    rules += ' BzBWQ8d182';
    rules += ' AzBWQ8d182';
    rules += ' sd182';
    rules += ' ea182';
    rules += ' Uc182';
    rules += ' Usd182';
    rules += ' qc182';
    rules += ' qsd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else if (props.isInvalid) {
        rules += ' pq182';
        rules += ' plQBRyrc182';
    } else rules += ' pv182';
    rules += ' -_8sjo0b-t5ZbAob182';
    rules += ' _qb182';
    rules += ' TgOnRt182';
    if (props.isDisabled) rules += ' ri182';
    else rules += ' rD182';
    return rules;
};
function $668ccde884a3272f$export$a67c0bc59081311a(props1) {
    let domDescriptionRef = (0, $3PqDc.useDOMRef)(props1.descriptionRef || null);
    let domErrorRef = (0, $3PqDc.useDOMRef)(props1.errorRef || null);
    if (!props1.isInvalid && props1.description) return (0, $dx4lB.jsx)((0, $c1ibQ.Text), {
        slot: "description",
        ref: domDescriptionRef,
        className: (0, $5nTep.mergeStyles)($668ccde884a3272f$export$13b1fd5431595bf6({
            size: props1.size || 'M',
            isDisabled: props1.isDisabled
        }), props1.styles),
        children: props1.description
    });
    if (!props1.isInvalid) return null;
    return (0, $dx4lB.jsx)((0, $4kYL7.FieldError), {
        ...props1,
        ref: domErrorRef,
        className: (renderProps)=>(0, $5nTep.mergeStyles)($668ccde884a3272f$export$13b1fd5431595bf6({
                ...renderProps,
                size: props1.size || 'M',
                isDisabled: props1.isDisabled
            }), props1.styles),
        children: (0, $fDYaM.composeRenderProps)(props1.children, (children, { validationErrors: validationErrors })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    props1.showErrorIcon && (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                        children: (0, $dx4lB.jsx)((0, $cnBj9.default), {
                            // @ts-ignore - ts doesn't know that AlertIcon is an icon and not a raw SVG
                            styles: function anonymous(props) {
                                let rules = " ";
                                if (props.size === "XL") rules += ' Zp182';
                                else if (props.size === "L") rules += ' Zn182';
                                else if (props.size === "M") rules += ' Zm182';
                                else if (props.size === "S") rules += ' Zu182';
                                else if (props.size === "XS") rules += ' Zk182';
                                if (props.size === "XL") rules += ' Fq182';
                                else if (props.size === "L") rules += ' Fo182';
                                else if (props.size === "M") rules += ' Fn182';
                                else if (props.size === "S") rules += ' Ft182';
                                else if (props.size === "XS") rules += ' Fl182';
                                return rules;
                            }({
                                size: props1.size || 'M'
                            })
                        })
                    }),
                    (0, $dx4lB.jsx)("span", {
                        children: children || validationErrors.join(' ')
                    })
                ]
            }))
    });
}
function $668ccde884a3272f$export$bda0d075e0e342c9(props) {
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                (0, $dm5H1.IconContext),
                {
                    render: (0, $8OJ2z.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja182 _va182 -_8sjo0b-tq182 -_8sjo0b-ltQBRyrc182"
                    }),
                    styles: " ZObNfn182 FObNfn182 It182 Isu182 HAxCW0c182 _va182"
                }
            ]
        ],
        children: !props.isDisabled && (0, $dx4lB.jsx)((0, $cnBj9.default), {})
    });
}

});
parcelRegister("2VqIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06f38ec7f0badd3$export$2e2bcd8739ae039);


var $PEvv3 = parcelRequire("PEvv3");

var $8C4Z2 = parcelRequire("8C4Z2");

var $fcL2J = parcelRequire("fcL2J");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $c06f38ec7f0badd3$var$$8373af657584cab2$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' Zi182';
    else if (props.size === "L") rules += ' Zi182';
    else if (props.size === "M") rules += ' Zh182';
    if (props.size === "XL") rules += ' Fj182';
    else if (props.size === "L") rules += ' Fj182';
    else if (props.size === "M") rules += ' Fi182';
    return rules;
};
function $c06f38ec7f0badd3$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $8C4Z2.default), {
                ...otherProps,
                className: (otherProps.className || '') + $c06f38ec7f0badd3$var$$8373af657584cab2$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $PEvv3.default), {
                ...otherProps,
                className: (otherProps.className || '') + $c06f38ec7f0badd3$var$$8373af657584cab2$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $fcL2J.default), {
                ...otherProps,
                className: (otherProps.className || '') + $c06f38ec7f0badd3$var$$8373af657584cab2$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("PEvv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2d3c589d8b6387$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $2a2d3c589d8b6387$var$$62d01593dd48309a$var$SvgS2AsteriskSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.861 7.953c.062.063.1.146 0 .23l-1.293.834c-.1.063-.145.021-.187-.083l-1.6-2.793-2.105 2.314c-.021.04-.083.082-.145 0l-1-1.043c-.1-.062-.083-.125 0-.187l2.375-1.981-2.715-1.026c-.042 0-.1-.083-.063-.188l.707-1.412a.11.11 0 0 1 .136-.074q.03.01.052.034l2.378 1.54.146-3.043A.11.11 0 0 1 4.638.95h.034l1.73.23c.1 0 .125.042.1.146l-.814 2.979 2.751-.834c.062-.042.125-.042.167.083l.271 1.542c.02.1 0 .146-.083.146l-2.876.23z"
        })
    });
var $2a2d3c589d8b6387$export$2e2bcd8739ae039 = $2a2d3c589d8b6387$var$$62d01593dd48309a$var$SvgS2AsteriskSize200;

});

parcelRegister("8C4Z2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cec45b19100acdc3$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $cec45b19100acdc3$var$$b9479532c17a0eb6$var$SvgS2AsteriskSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.575 6.555c.055.056.092.13 0 .2l-1.149.741c-.092.056-.129.019-.166-.074L3.834 4.94 1.963 7c-.019.036-.074.073-.129 0l-.889-.927c-.093-.055-.074-.111 0-.166l2.111-1.76L.648 3.24c-.037 0-.092-.074-.056-.167l.63-1.259a.1.1 0 0 1 .121-.066.1.1 0 0 1 .046.03L3.5 3.148l.13-2.7a.1.1 0 0 1 .081-.11h.03l1.537.2c.093 0 .111.036.093.13l-.723 2.646 2.445-.741c.055-.037.111-.037.148.074l.241 1.37c.018.093 0 .13-.074.13l-2.556.2z"
        })
    });
var $cec45b19100acdc3$export$2e2bcd8739ae039 = $cec45b19100acdc3$var$$b9479532c17a0eb6$var$SvgS2AsteriskSize100;

});

parcelRegister("fcL2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc85ba8fe306a660$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $bc85ba8fe306a660$var$$424c8bf06ece899d$var$SvgS2AsteriskSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.266 8.324c.07.071.116.164 0 .258l-1.454.938c-.116.071-.163.024-.21-.094l-1.8-3.141-2.367 2.6c-.024.045-.094.092-.163 0l-1.13-1.167c-.118-.07-.094-.141 0-.21l2.671-2.227L.766 4.13c-.047 0-.116-.094-.071-.211l.8-1.593a.124.124 0 0 1 .153-.084.13.13 0 0 1 .058.038l2.669 1.738.164-3.422a.124.124 0 0 1 .1-.14h.038l1.945.258c.118 0 .14.047.118.164l-.915 3.349 3.094-.938c.07-.047.14-.047.187.094l.3 1.734c.023.118 0 .164-.094.164l-3.234.258z"
        })
    });
var $bc85ba8fe306a660$export$2e2bcd8739ae039 = $bc85ba8fe306a660$var$$424c8bf06ece899d$var$SvgS2AsteriskSize300;

});


parcelRegister("4kYL7", function(module, exports) {

$parcel$export(module.exports, "FieldErrorContext", () => $e1e323f106cb15d2$export$ff05c3ac10437e03);
$parcel$export(module.exports, "FieldError", () => $e1e323f106cb15d2$export$f551688fc98f2e09);

var $fDYaM = parcelRequire("fDYaM");

var $c1ibQ = parcelRequire("c1ibQ");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e1e323f106cb15d2$export$ff05c3ac10437e03 = (0, $eF4cA.createContext)(null);
const $e1e323f106cb15d2$export$f551688fc98f2e09 = (0, $eF4cA.forwardRef)(function FieldError(props, ref) {
    let validation = (0, $eF4cA.useContext)($e1e323f106cb15d2$export$ff05c3ac10437e03);
    if (!validation?.isInvalid) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($e1e323f106cb15d2$var$$1f3c3b1a70cec653$var$FieldErrorInner, {
        ...props,
        ref: ref
    });
});
const $e1e323f106cb15d2$var$$1f3c3b1a70cec653$var$FieldErrorInner = (0, $eF4cA.forwardRef)((props, ref)=>{
    let validation = (0, $eF4cA.useContext)($e1e323f106cb15d2$export$ff05c3ac10437e03);
    let { elementType: elementType, ...restProps } = props;
    let domProps = (0, $fVfXf.filterDOMProps)(restProps, {
        global: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...restProps,
        defaultClassName: 'react-aria-FieldError',
        defaultChildren: validation.validationErrors.length === 0 ? undefined : validation.validationErrors.join(' '),
        values: validation
    });
    if (renderProps.children == null) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $c1ibQ.Text), {
        slot: "errorMessage",
        elementType: elementType,
        ...domProps,
        ...renderProps,
        ref: ref
    });
});

});

parcelRegister("cTXxz", function(module, exports) {

$parcel$export(module.exports, "GroupContext", () => $cfab891105a7ce0e$export$f9c6924e160136d1);
$parcel$export(module.exports, "Group", () => $cfab891105a7ce0e$export$eb2fcfdbd7ba97d4);

var $fDYaM = parcelRequire("fDYaM");

var $j2JDe = parcelRequire("j2JDe");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cfab891105a7ce0e$export$f9c6924e160136d1 = (0, $eF4cA.createContext)({});
const $cfab891105a7ce0e$export$eb2fcfdbd7ba97d4 = (0, $eF4cA.forwardRef)(function Group(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $cfab891105a7ce0e$export$f9c6924e160136d1);
    let { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    isDisabled ??= !!props['aria-disabled'] && props['aria-disabled'] !== 'false';
    isInvalid ??= !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        onHoverStart: onHoverStart,
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd,
        isDisabled: isDisabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Group'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(otherProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        role: props.role ?? 'group',
        slot: props.slot ?? undefined,
        "data-focus-within": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-invalid": isInvalid || undefined,
        "data-readonly": isReadOnly || undefined
    }, renderProps.children);
});

});

parcelRegister("ecbit", function(module, exports) {

$parcel$export(module.exports, "InputContext", () => $cb2b7113e58aaf92$export$37fb8590cf2c088c);
$parcel$export(module.exports, "Input", () => $cb2b7113e58aaf92$export$f5b8910cec6cf069);

var $fDYaM = parcelRequire("fDYaM");

var $19ZgV = parcelRequire("19ZgV");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cb2b7113e58aaf92$export$37fb8590cf2c088c = (0, $eF4cA.createContext)({});
let $cb2b7113e58aaf92$var$$41fb335299a4a39e$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const $cb2b7113e58aaf92$export$f5b8910cec6cf069 = (0, $19ZgV.createHideableComponent)(function Input(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $cb2b7113e58aaf92$export$37fb8590cf2c088c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...props,
        isDisabled: props.disabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Input'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).input, {
        ...(0, $lhKAD.mergeProps)($cb2b7113e58aaf92$var$$41fb335299a4a39e$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});

});


parcelRegister("1qrul", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $e7442ce5feb1baf4$export$ea39ec197993aef0);
$parcel$export(module.exports, "isSameMonth", () => $e7442ce5feb1baf4$export$a18c89cbd24170ff);
$parcel$export(module.exports, "startOfMonth", () => $e7442ce5feb1baf4$export$a5a3b454ada2268e);
$parcel$export(module.exports, "isSameYear", () => $e7442ce5feb1baf4$export$5841f9eb9773f25f);
$parcel$export(module.exports, "startOfYear", () => $e7442ce5feb1baf4$export$f91e89d3d0406102);
$parcel$export(module.exports, "isEqualDay", () => $e7442ce5feb1baf4$export$91b62ebf2ba703ee);
$parcel$export(module.exports, "isEqualCalendar", () => $e7442ce5feb1baf4$export$dbc69fd56b53d5e);
$parcel$export(module.exports, "isToday", () => $e7442ce5feb1baf4$export$629b0a497aa65267);
$parcel$export(module.exports, "today", () => $e7442ce5feb1baf4$export$d0bdf45af03a6ea3);
$parcel$export(module.exports, "getDayOfWeek", () => $e7442ce5feb1baf4$export$2061056d06d7cdf7);
$parcel$export(module.exports, "now", () => $e7442ce5feb1baf4$export$461939dd4422153);
$parcel$export(module.exports, "compareDate", () => $e7442ce5feb1baf4$export$68781ddf31c0090f);
$parcel$export(module.exports, "compareTime", () => $e7442ce5feb1baf4$export$c19a80a9721b80f6);
$parcel$export(module.exports, "getLocalTimeZone", () => $e7442ce5feb1baf4$export$aa8b41735afcabd2);
$parcel$export(module.exports, "isLocalTimeZoneOverridden", () => $e7442ce5feb1baf4$export$6ab69b273755230b);
$parcel$export(module.exports, "endOfMonth", () => $e7442ce5feb1baf4$export$a2258d9c4118825c);
$parcel$export(module.exports, "startOfWeek", () => $e7442ce5feb1baf4$export$42c81a444fbfb5d4);
$parcel$export(module.exports, "endOfWeek", () => $e7442ce5feb1baf4$export$ef8b6d9133084f4e);
$parcel$export(module.exports, "getWeeksInMonth", () => $e7442ce5feb1baf4$export$ccc1b2479e7dd654);
$parcel$export(module.exports, "minDate", () => $e7442ce5feb1baf4$export$5c333a116e949cdd);
$parcel$export(module.exports, "maxDate", () => $e7442ce5feb1baf4$export$a75f2bff57811055);

var $8jDkV = parcelRequire("8jDkV");

var $238xf = parcelRequire("238xf");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e7442ce5feb1baf4$export$ea39ec197993aef0(a, b) {
    b = (0, $8jDkV.toCalendar)(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $e7442ce5feb1baf4$export$a18c89cbd24170ff(a, b) {
    b = (0, $8jDkV.toCalendar)(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $e7442ce5feb1baf4$export$a5a3b454ada2268e(a);
    b = $e7442ce5feb1baf4$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $e7442ce5feb1baf4$export$5841f9eb9773f25f(a, b) {
    b = (0, $8jDkV.toCalendar)(b, a.calendar);
    a = $e7442ce5feb1baf4$export$f91e89d3d0406102(a);
    b = $e7442ce5feb1baf4$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $e7442ce5feb1baf4$export$91b62ebf2ba703ee(a, b) {
    return $e7442ce5feb1baf4$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $e7442ce5feb1baf4$export$ea39ec197993aef0(a, b);
}
function $e7442ce5feb1baf4$export$5a8da0c44a3afdf2(a, b) {
    return $e7442ce5feb1baf4$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $e7442ce5feb1baf4$export$a18c89cbd24170ff(a, b);
}
function $e7442ce5feb1baf4$export$ea840f5a6dda8147(a, b) {
    return $e7442ce5feb1baf4$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $e7442ce5feb1baf4$export$5841f9eb9773f25f(a, b);
}
function $e7442ce5feb1baf4$export$dbc69fd56b53d5e(a, b) {
    return a.isEqual?.(b) ?? b.isEqual?.(a) ?? a.identifier === b.identifier;
}
function $e7442ce5feb1baf4$export$629b0a497aa65267(date, timeZone) {
    return $e7442ce5feb1baf4$export$ea39ec197993aef0(date, $e7442ce5feb1baf4$export$d0bdf45af03a6ea3(timeZone));
}
const $e7442ce5feb1baf4$var$$ad063034c8620db8$var$DAY_MAP = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
};
function $e7442ce5feb1baf4$export$2061056d06d7cdf7(date, locale, firstDayOfWeek) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let weekStart = firstDayOfWeek ? $e7442ce5feb1baf4$var$$ad063034c8620db8$var$DAY_MAP[firstDayOfWeek] : $e7442ce5feb1baf4$var$$ad063034c8620db8$var$getWeekStart(locale);
    let dayOfWeek = Math.ceil(julian + 1 - weekStart) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $e7442ce5feb1baf4$export$461939dd4422153(timeZone) {
    return (0, $8jDkV.fromAbsolute)(Date.now(), timeZone);
}
function $e7442ce5feb1baf4$export$d0bdf45af03a6ea3(timeZone) {
    return (0, $8jDkV.toCalendarDate)($e7442ce5feb1baf4$export$461939dd4422153(timeZone));
}
function $e7442ce5feb1baf4$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $e7442ce5feb1baf4$export$c19a80a9721b80f6(a, b) {
    return $e7442ce5feb1baf4$var$$ad063034c8620db8$var$timeToMs(a) - $e7442ce5feb1baf4$var$$ad063034c8620db8$var$timeToMs(b);
}
function $e7442ce5feb1baf4$var$$ad063034c8620db8$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $e7442ce5feb1baf4$export$126c91c941de7e(a, timeZone) {
    let ms = (0, $8jDkV.toAbsolute)(a, timeZone);
    let tomorrow = a.add({
        days: 1
    });
    let tomorrowMs = (0, $8jDkV.toAbsolute)(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
let $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZone = null;
let $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZoneOverride = false;
function $e7442ce5feb1baf4$export$aa8b41735afcabd2() {
    if ($e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZone == null) $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZone;
}
function $e7442ce5feb1baf4$export$61a9d83ceb59a3dd(timeZone) {
    $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZoneOverride = true;
    $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZone = timeZone;
}
function $e7442ce5feb1baf4$export$55753838ffe79333() {
    $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZoneOverride = false;
    $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZone = null;
}
function $e7442ce5feb1baf4$export$6ab69b273755230b() {
    return $e7442ce5feb1baf4$var$$ad063034c8620db8$var$localTimeZoneOverride;
}
function $e7442ce5feb1baf4$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $e7442ce5feb1baf4$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $e7442ce5feb1baf4$export$f91e89d3d0406102(date) {
    return $e7442ce5feb1baf4$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $e7442ce5feb1baf4$export$8b7aa55c66d5569e(date) {
    return $e7442ce5feb1baf4$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $e7442ce5feb1baf4$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $e7442ce5feb1baf4$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $e7442ce5feb1baf4$export$42c81a444fbfb5d4(date, locale, firstDayOfWeek) {
    let dayOfWeek = $e7442ce5feb1baf4$export$2061056d06d7cdf7(date, locale, firstDayOfWeek);
    return date.subtract({
        days: dayOfWeek
    });
}
function $e7442ce5feb1baf4$export$ef8b6d9133084f4e(date, locale, firstDayOfWeek) {
    return $e7442ce5feb1baf4$export$42c81a444fbfb5d4(date, locale, firstDayOfWeek).add({
        days: 6
    });
}
const $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedRegions = new Map();
const $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedWeekInfo = new Map();
function $e7442ce5feb1baf4$var$$ad063034c8620db8$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        let region = $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            if (region) $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    let part = locale.split('-')[1];
    return part === 'u' ? undefined : part;
}
function $e7442ce5feb1baf4$var$$ad063034c8620db8$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    let weekInfo = $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedWeekInfo.get(locale);
    if (!weekInfo) {
        if (Intl.Locale) {
            // @ts-ignore
            let localeInst = new Intl.Locale(locale);
            if ('getWeekInfo' in localeInst) {
                weekInfo = localeInst.getWeekInfo();
                if (weekInfo) {
                    $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedWeekInfo.set(locale, weekInfo);
                    return weekInfo.firstDay;
                }
            }
        }
        let region = $e7442ce5feb1baf4$var$$ad063034c8620db8$var$getRegion(locale);
        if (locale.includes('-fw-')) {
            // pull the value for the attribute fw from strings such as en-US-u-ca-iso8601-fw-tue or en-US-u-ca-iso8601-fw-mon-nu-thai
            // where the fw attribute could be followed by another unicode locale extension or not
            let day = locale.split('-fw-')[1].split('-')[0];
            if (day === 'mon') weekInfo = {
                firstDay: 1
            };
            else if (day === 'tue') weekInfo = {
                firstDay: 2
            };
            else if (day === 'wed') weekInfo = {
                firstDay: 3
            };
            else if (day === 'thu') weekInfo = {
                firstDay: 4
            };
            else if (day === 'fri') weekInfo = {
                firstDay: 5
            };
            else if (day === 'sat') weekInfo = {
                firstDay: 6
            };
            else weekInfo = {
                firstDay: 0
            };
        } else if (locale.includes('-ca-iso8601')) weekInfo = {
            firstDay: 1
        };
        else weekInfo = {
            firstDay: region ? (0, $238xf.weekStartData)[region] || 0 : 0
        };
        $e7442ce5feb1baf4$var$$ad063034c8620db8$var$cachedWeekInfo.set(locale, weekInfo);
    }
    return weekInfo.firstDay;
}
function $e7442ce5feb1baf4$export$ccc1b2479e7dd654(date, locale, firstDayOfWeek) {
    let days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($e7442ce5feb1baf4$export$2061056d06d7cdf7($e7442ce5feb1baf4$export$a5a3b454ada2268e(date), locale, firstDayOfWeek) + days) / 7);
}
function $e7442ce5feb1baf4$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $e7442ce5feb1baf4$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
const $e7442ce5feb1baf4$var$$ad063034c8620db8$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $e7442ce5feb1baf4$export$618d60ea299da42(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    let region = $e7442ce5feb1baf4$var$$ad063034c8620db8$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    let [start, end] = $e7442ce5feb1baf4$var$$ad063034c8620db8$var$WEEKEND_DATA[region] || [
        6,
        0
    ];
    return dayOfWeek === start || dayOfWeek === end;
}
function $e7442ce5feb1baf4$export$ee9d87258e1d19ed(date, locale) {
    return !$e7442ce5feb1baf4$export$618d60ea299da42(date, locale);
}

});
parcelRegister("8jDkV", function(module, exports) {

$parcel$export(module.exports, "epochFromDate", () => $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb);
$parcel$export(module.exports, "toCalendar", () => $fe0ec8e2a87a3c66$export$b4a036af3fc0b032);
$parcel$export(module.exports, "possibleAbsolutes", () => $fe0ec8e2a87a3c66$export$136f38efe7caf549);
$parcel$export(module.exports, "toAbsolute", () => $fe0ec8e2a87a3c66$export$5107c82f94518f5c);
$parcel$export(module.exports, "toCalendarDateTime", () => $fe0ec8e2a87a3c66$export$b21e0b124e224484);
$parcel$export(module.exports, "toDate", () => $fe0ec8e2a87a3c66$export$e67a095c620b86fe);
$parcel$export(module.exports, "fromAbsolute", () => $fe0ec8e2a87a3c66$export$1b96692a1ba042ac);
$parcel$export(module.exports, "toCalendarDate", () => $fe0ec8e2a87a3c66$export$93522d1a439f3617);
$parcel$export(module.exports, "toTime", () => $fe0ec8e2a87a3c66$export$d33f79e3ffc3dc83);
$parcel$export(module.exports, "toZoned", () => $fe0ec8e2a87a3c66$export$84c95a83c799e074);
$parcel$export(module.exports, "toTimeZone", () => $fe0ec8e2a87a3c66$export$538b00033cc11c75);
$parcel$export(module.exports, "zonedToDate", () => $fe0ec8e2a87a3c66$export$83aac07b4c37b25);
$parcel$export(module.exports, "toLocalTimeZone", () => $fe0ec8e2a87a3c66$export$d9b67bc93c097491);

var $tKwj1 = parcelRequire("tKwj1");

var $5zTJi = parcelRequire("5zTJi");

var $1k26k = parcelRequire("1k26k");

var $1qrul = parcelRequire("1qrul");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
function $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb(date) {
    date = $fe0ec8e2a87a3c66$export$b4a036af3fc0b032(date, new (0, $1k26k.GregorianCalendar)());
    let year = (0, $1k26k.getExtendedYear)(date.era, date.year);
    return $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    let date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $fe0ec8e2a87a3c66$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === 'UTC') return 0;
    // Fast path: for local timezone after 1970, use native Date.
    // Skip this fast path if the local timezone was explicitly overridden via setLocalTimeZone,
    // since native Date always uses the browser's timezone, not the overridden one.
    if (ms > 0 && timeZone === (0, $1qrul.getLocalTimeZone)() && !(0, $1qrul.isLocalTimeZoneOverridden)()) return new Date(ms).getTimezoneOffset() * -60000;
    let { year: year, month: month, day: day, hour: hour, minute: minute, second: second } = $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$getTimeZoneParts(ms, timeZone);
    let utc = $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
const $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$formattersByTimeZone = new Map();
function $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$getTimeZoneParts(ms, timeZone) {
    let formatter = $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            hour12: false,
            era: 'short',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        });
        $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$formattersByTimeZone.set(timeZone, formatter);
    }
    let parts = formatter.formatToParts(new Date(ms));
    let namedParts = {};
    for (let part of parts)if (part.type !== 'literal') namedParts[part.type] = part.value;
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === 'BC' || namedParts.era === 'B' ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === '24' ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
const $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$DAYMILLIS = 86400000;
function $fe0ec8e2a87a3c66$export$136f38efe7caf549(date, timeZone) {
    let ms = $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb(date);
    let earlier = ms - $fe0ec8e2a87a3c66$export$59c99f3515d3493f(ms - $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$DAYMILLIS, timeZone);
    let later = ms - $fe0ec8e2a87a3c66$export$59c99f3515d3493f(ms + $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$DAYMILLIS, timeZone);
    return $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$getValidWallTimes(date, timeZone, earlier, later) {
    let found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter((absolute)=>$fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$isValidWallTime(date, timeZone, absolute));
}
function $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$isValidWallTime(date, timeZone, absolute) {
    let parts = $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $fe0ec8e2a87a3c66$export$5107c82f94518f5c(date, timeZone, disambiguation = 'compatible') {
    let dateTime = $fe0ec8e2a87a3c66$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === 'UTC') return $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    // Skip this fast path if the local timezone was explicitly overridden via setLocalTimeZone,
    // since native Date always uses the browser's timezone, not the overridden one.
    if (timeZone === (0, $1qrul.getLocalTimeZone)() && disambiguation === 'compatible' && !(0, $1qrul.isLocalTimeZoneOverridden)()) {
        dateTime = $fe0ec8e2a87a3c66$export$b4a036af3fc0b032(dateTime, new (0, $1k26k.GregorianCalendar)());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        let date = new Date();
        let year = (0, $1k26k.getExtendedYear)(dateTime.era, dateTime.year);
        date.setFullYear(year, dateTime.month - 1, dateTime.day);
        date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return date.getTime();
    }
    let ms = $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb(dateTime);
    let offsetBefore = $fe0ec8e2a87a3c66$export$59c99f3515d3493f(ms - $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$DAYMILLIS, timeZone);
    let offsetAfter = $fe0ec8e2a87a3c66$export$59c99f3515d3493f(ms + $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$DAYMILLIS, timeZone);
    let valid = $fe0ec8e2a87a3c66$var$$d07e34cce18680fd$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case 'compatible':
        case 'earlier':
            return valid[0];
        case 'later':
            return valid[valid.length - 1];
        case 'reject':
            throw new RangeError('Multiple possible absolute times found');
    }
    switch(disambiguation){
        case 'earlier':
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case 'compatible':
        case 'later':
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case 'reject':
            throw new RangeError('No such absolute time found');
    }
}
function $fe0ec8e2a87a3c66$export$e67a095c620b86fe(dateTime, timeZone, disambiguation = 'compatible') {
    return new Date($fe0ec8e2a87a3c66$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $fe0ec8e2a87a3c66$export$1b96692a1ba042ac(ms, timeZone) {
    let offset = $fe0ec8e2a87a3c66$export$59c99f3515d3493f(ms, timeZone);
    let date = new Date(ms + offset);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    let millisecond = date.getUTCMilliseconds();
    return new (0, $tKwj1.ZonedDateTime)(year < 1 ? 'BC' : 'AD', year < 1 ? -year + 1 : year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $fe0ec8e2a87a3c66$export$e57ff100d91bd4b9(date, timeZone) {
    return $fe0ec8e2a87a3c66$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $fe0ec8e2a87a3c66$export$d7f92bcd3596b086(date) {
    return $fe0ec8e2a87a3c66$export$e57ff100d91bd4b9(date, (0, $1qrul.getLocalTimeZone)());
}
function $fe0ec8e2a87a3c66$export$93522d1a439f3617(dateTime) {
    return new (0, $tKwj1.CalendarDate)(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $fe0ec8e2a87a3c66$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $fe0ec8e2a87a3c66$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $fe0ec8e2a87a3c66$export$b21e0b124e224484(date, time) {
    let hour = 0, minute = 0, second = 0, millisecond = 0;
    if ('timeZone' in date) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = date);
    else if ('hour' in date && !time) return date;
    if (time) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = time);
    return new (0, $tKwj1.CalendarDateTime)(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $fe0ec8e2a87a3c66$export$d33f79e3ffc3dc83(dateTime) {
    return new (0, $tKwj1.Time)(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $fe0ec8e2a87a3c66$export$b4a036af3fc0b032(date, calendar) {
    if ((0, $1qrul.isEqualCalendar)(date.calendar, calendar)) return date;
    let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    let copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    (0, $5zTJi.constrain)(copy);
    return copy;
}
function $fe0ec8e2a87a3c66$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof (0, $tKwj1.ZonedDateTime)) {
        if (date.timeZone === timeZone) return date;
        return $fe0ec8e2a87a3c66$export$538b00033cc11c75(date, timeZone);
    }
    let ms = $fe0ec8e2a87a3c66$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $fe0ec8e2a87a3c66$export$1b96692a1ba042ac(ms, timeZone);
}
function $fe0ec8e2a87a3c66$export$83aac07b4c37b25(date) {
    let ms = $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $fe0ec8e2a87a3c66$export$538b00033cc11c75(date, timeZone) {
    let ms = $fe0ec8e2a87a3c66$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $fe0ec8e2a87a3c66$export$b4a036af3fc0b032($fe0ec8e2a87a3c66$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $fe0ec8e2a87a3c66$export$d9b67bc93c097491(date) {
    return $fe0ec8e2a87a3c66$export$538b00033cc11c75(date, (0, $1qrul.getLocalTimeZone)());
}

});
parcelRegister("tKwj1", function(module, exports) {

$parcel$export(module.exports, "CalendarDate", () => $7f9134dd50fafcfd$export$99faa760c7908e4f);
$parcel$export(module.exports, "Time", () => $7f9134dd50fafcfd$export$680ea196effce5f);
$parcel$export(module.exports, "CalendarDateTime", () => $7f9134dd50fafcfd$export$ca871e8dbb80966f);
$parcel$export(module.exports, "ZonedDateTime", () => $7f9134dd50fafcfd$export$d3b7288e7994edea);

var $5zTJi = parcelRequire("5zTJi");

var $1qrul = parcelRequire("1qrul");

var $gbmcw = parcelRequire("gbmcw");

var $1k26k = parcelRequire("1k26k");

var $8jDkV = parcelRequire("8jDkV");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7f9134dd50fafcfd$var$$2aaf608024c21ca1$var$shiftArgs(args) {
    let calendar = typeof args[0] === 'object' ? args.shift() : new (0, $1k26k.GregorianCalendar)();
    let era;
    if (typeof args[0] === 'string') era = args.shift();
    else {
        let eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    let year = args.shift();
    let month = args.shift();
    let day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
class $7f9134dd50fafcfd$export$99faa760c7908e4f {
    // This prevents TypeScript from allowing other types with the same fields to match.
    // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
    // If that behavior is desired, use the AnyCalendarDate interface instead.
    // @ts-ignore
    #type;
    constructor(...args){
        let [calendar, era, year, month, day] = $7f9134dd50fafcfd$var$$2aaf608024c21ca1$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        (0, $5zTJi.constrain)(this);
    }
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $7f9134dd50fafcfd$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
        else return new $7f9134dd50fafcfd$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
    }
    /** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
        return (0, $5zTJi.add)(this, duration);
    }
    /** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $5zTJi.subtract)(this, duration);
    }
    /**
   * Returns a new `CalendarDate` with the given fields set to the provided values. Other fields
   * will be constrained accordingly.
   */ set(fields) {
        return (0, $5zTJi.set)(this, fields);
    }
    /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, $5zTJi.cycleDate)(this, field, amount, options);
    }
    /**
   * Converts the date to a native JavaScript Date object, with the time set to midnight in the
   * given time zone.
   */ toDate(timeZone) {
        return (0, $8jDkV.toDate)(this, timeZone);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return (0, $gbmcw.dateToString)(this);
    }
    /**
   * Compares this date with another. A negative result indicates that this date is before the given
   * one, and a positive date indicates that it is after.
   */ compare(b) {
        return (0, $1qrul.compareDate)(this, b);
    }
}
class $7f9134dd50fafcfd$export$680ea196effce5f {
    // This prevents TypeScript from allowing other types with the same fields to match.
    // @ts-ignore
    #type;
    constructor(hour = 0, minute = 0, second = 0, millisecond = 0){
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        (0, $5zTJi.constrainTime)(this);
    }
    /** Returns a copy of this time. */ copy() {
        return new $7f9134dd50fafcfd$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `Time` with the given duration added to it. */ add(duration) {
        return (0, $5zTJi.addTime)(this, duration);
    }
    /** Returns a new `Time` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $5zTJi.subtractTime)(this, duration);
    }
    /**
   * Returns a new `Time` with the given fields set to the provided values. Other fields will be
   * constrained accordingly.
   */ set(fields) {
        return (0, $5zTJi.setTime)(this, fields);
    }
    /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, $5zTJi.cycleTime)(this, field, amount, options);
    }
    /** Converts the time to an ISO 8601 formatted string. */ toString() {
        return (0, $gbmcw.timeToString)(this);
    }
    /**
   * Compares this time with another. A negative result indicates that this time is before the given
   * one, and a positive time indicates that it is after.
   */ compare(b) {
        return (0, $1qrul.compareTime)(this, b);
    }
}
class $7f9134dd50fafcfd$export$ca871e8dbb80966f {
    // This prevents TypeScript from allowing other types with the same fields to match.
    // @ts-ignore
    #type;
    constructor(...args){
        let [calendar, era, year, month, day] = $7f9134dd50fafcfd$var$$2aaf608024c21ca1$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, $5zTJi.constrain)(this);
    }
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $7f9134dd50fafcfd$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
        else return new $7f9134dd50fafcfd$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
        return (0, $5zTJi.add)(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $5zTJi.subtract)(this, duration);
    }
    /**
   * Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields
   * will be constrained accordingly.
   */ set(fields) {
        return (0, $5zTJi.set)((0, $5zTJi.setTime)(this, fields), fields);
    }
    /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        switch(field){
            case 'era':
            case 'year':
            case 'month':
            case 'day':
                return (0, $5zTJi.cycleDate)(this, field, amount, options);
            default:
                return (0, $5zTJi.cycleTime)(this, field, amount, options);
        }
    }
    /** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
        return (0, $8jDkV.toDate)(this, timeZone, disambiguation);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return (0, $gbmcw.dateTimeToString)(this);
    }
    /**
   * Compares this date with another. A negative result indicates that this date is before the given
   * one, and a positive date indicates that it is after.
   */ compare(b) {
        let res = (0, $1qrul.compareDate)(this, b);
        if (res === 0) return (0, $1qrul.compareTime)(this, (0, $8jDkV.toCalendarDateTime)(b));
        return res;
    }
}
class $7f9134dd50fafcfd$export$d3b7288e7994edea {
    // This prevents TypeScript from allowing other types with the same fields to match.
    // @ts-ignore
    #type;
    constructor(...args){
        let [calendar, era, year, month, day] = $7f9134dd50fafcfd$var$$2aaf608024c21ca1$var$shiftArgs(args);
        let timeZone = args.shift();
        let offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, $5zTJi.constrain)(this);
    }
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $7f9134dd50fafcfd$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
        else return new $7f9134dd50fafcfd$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `ZonedDateTime` with the given duration added to it. */ add(duration) {
        return (0, $5zTJi.addZoned)(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $5zTJi.subtractZoned)(this, duration);
    }
    /**
   * Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields
   * will be constrained accordingly.
   */ set(fields, disambiguation) {
        return (0, $5zTJi.setZoned)(this, fields, disambiguation);
    }
    /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, $5zTJi.cycleZoned)(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object. */ toDate() {
        return (0, $8jDkV.zonedToDate)(this);
    }
    /**
   * Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone
   * identifier.
   */ toString() {
        return (0, $gbmcw.zonedDateTimeToString)(this);
    }
    /** Converts the date to an ISO 8601 formatted string in UTC. */ toAbsoluteString() {
        return this.toDate().toISOString();
    }
    /**
   * Compares this date with another. A negative result indicates that this date is before the given
   * one, and a positive date indicates that it is after.
   */ compare(b) {
        // TODO: Is this a bad idea??
        return this.toDate().getTime() - (0, $8jDkV.toZoned)(b, this.timeZone).toDate().getTime();
    }
}

});
parcelRegister("5zTJi", function(module, exports) {

$parcel$export(module.exports, "add", () => $003409c3d1b8e28b$export$e16d8520af44a096);
$parcel$export(module.exports, "constrain", () => $003409c3d1b8e28b$export$c4e2ecac49351ef2);
$parcel$export(module.exports, "subtract", () => $003409c3d1b8e28b$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "set", () => $003409c3d1b8e28b$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "setTime", () => $003409c3d1b8e28b$export$e5d5e1c1822b6e56);
$parcel$export(module.exports, "constrainTime", () => $003409c3d1b8e28b$export$7555de1e070510cb);
$parcel$export(module.exports, "addTime", () => $003409c3d1b8e28b$export$7ed87b6bc2506470);
$parcel$export(module.exports, "subtractTime", () => $003409c3d1b8e28b$export$fe34d3a381cd7501);
$parcel$export(module.exports, "cycleDate", () => $003409c3d1b8e28b$export$d52ced6badfb9a4c);
$parcel$export(module.exports, "cycleTime", () => $003409c3d1b8e28b$export$dd02b3e0007dfe28);
$parcel$export(module.exports, "addZoned", () => $003409c3d1b8e28b$export$96b1d28349274637);
$parcel$export(module.exports, "subtractZoned", () => $003409c3d1b8e28b$export$6814caac34ca03c7);
$parcel$export(module.exports, "cycleZoned", () => $003409c3d1b8e28b$export$9a297d111fc86b79);
$parcel$export(module.exports, "setZoned", () => $003409c3d1b8e28b$export$31b5430eb18be4f8);

var $8jDkV = parcelRequire("8jDkV");

var $1k26k = parcelRequire("1k26k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$ONE_HOUR = 3600000;
function $003409c3d1b8e28b$export$e16d8520af44a096(date, duration) {
    let mutableDate = date.copy();
    let days = 'hour' in mutableDate ? $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addTimeFields(mutableDate, duration) : 0;
    $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceYearMonth(mutableDate);
    $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        let isInverseEra = mutableDate.calendar.isInverseEra?.(mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addYears(date, years) {
    if (date.calendar.isInverseEra?.(date)) years = -years;
    date.year += years;
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceYearMonth(date) {
    while(date.month < 1){
        $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    let monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addYears(date, 1);
    }
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceYearMonth(date);
    }
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $003409c3d1b8e28b$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$constrainMonthDay(date);
}
function $003409c3d1b8e28b$export$3e2544e88a25bff8(duration) {
    let inverseDuration = {};
    for(let key in duration)if (typeof duration[key] === 'number') inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $003409c3d1b8e28b$export$4e2d2ead65e5f7e3(date, duration) {
    return $003409c3d1b8e28b$export$e16d8520af44a096(date, $003409c3d1b8e28b$export$3e2544e88a25bff8(duration));
}
function $003409c3d1b8e28b$export$adaa4cf7ef1b65be(date, fields) {
    let mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $003409c3d1b8e28b$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $003409c3d1b8e28b$export$e5d5e1c1822b6e56(value, fields) {
    let mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $003409c3d1b8e28b$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$nonNegativeMod(time.minute, 60);
    let days = Math.floor(time.hour / 24);
    time.hour = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $003409c3d1b8e28b$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 999));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$nonNegativeMod(a, b) {
    let result = a % b;
    if (result < 0) result += b;
    return result;
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$balanceTime(time);
}
function $003409c3d1b8e28b$export$7ed87b6bc2506470(time, duration) {
    let res = time.copy();
    $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$addTimeFields(res, duration);
    return res;
}
function $003409c3d1b8e28b$export$fe34d3a381cd7501(time, duration) {
    return $003409c3d1b8e28b$export$7ed87b6bc2506470(time, $003409c3d1b8e28b$export$3e2544e88a25bff8(duration));
}
function $003409c3d1b8e28b$export$d52ced6badfb9a4c(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case 'era':
            {
                let eras = value.calendar.getEras();
                let eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error('Invalid era: ' + value.era);
                eraIndex = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options?.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $003409c3d1b8e28b$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case 'year':
            if (mutable.calendar.isInverseEra?.(mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value.year, amount, -Infinity, 9999, options?.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case 'month':
            mutable.month = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options?.round);
            break;
        case 'day':
            mutable.day = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options?.round);
            break;
        default:
            throw new Error('Unsupported field ' + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $003409c3d1b8e28b$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $003409c3d1b8e28b$export$dd02b3e0007dfe28(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case 'hour':
            {
                let hours = value.hour;
                let min = 0;
                let max = 23;
                if (options?.hourCycle === 12) {
                    let isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(hours, amount, min, max, options?.round);
                break;
            }
        case 'minute':
            mutable.minute = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value.minute, amount, 0, 59, options?.round);
            break;
        case 'second':
            mutable.second = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value.second, amount, 0, 59, options?.round);
            break;
        case 'millisecond':
            mutable.millisecond = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value.millisecond, amount, 0, 999, options?.round);
            break;
        default:
            throw new Error('Unsupported field ' + field);
    }
    return mutable;
}
function $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $003409c3d1b8e28b$export$96b1d28349274637(dateTime, duration) {
    let ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        let res = $003409c3d1b8e28b$export$e16d8520af44a096((0, $8jDkV.toCalendarDateTime)(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = (0, $8jDkV.toAbsolute)(res, dateTime.timeZone);
    } else ms = (0, $8jDkV.epochFromDate)(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    let res = (0, $8jDkV.fromAbsolute)(ms, dateTime.timeZone);
    return (0, $8jDkV.toCalendar)(res, dateTime.calendar);
}
function $003409c3d1b8e28b$export$6814caac34ca03c7(dateTime, duration) {
    return $003409c3d1b8e28b$export$96b1d28349274637(dateTime, $003409c3d1b8e28b$export$3e2544e88a25bff8(duration));
}
function $003409c3d1b8e28b$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case 'hour':
            {
                let min = 0;
                let max = 23;
                if (options?.hourCycle === 12) {
                    let isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                let plainDateTime = (0, $8jDkV.toCalendarDateTime)(dateTime);
                let minDate = (0, $8jDkV.toCalendar)($003409c3d1b8e28b$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new (0, $1k26k.GregorianCalendar)());
                let minAbsolute = [
                    (0, $8jDkV.toAbsolute)(minDate, dateTime.timeZone, 'earlier'),
                    (0, $8jDkV.toAbsolute)(minDate, dateTime.timeZone, 'later')
                ].filter((ms)=>(0, $8jDkV.fromAbsolute)(ms, dateTime.timeZone).day === minDate.day)[0];
                let maxDate = (0, $8jDkV.toCalendar)($003409c3d1b8e28b$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new (0, $1k26k.GregorianCalendar)());
                let maxAbsolute = [
                    (0, $8jDkV.toAbsolute)(maxDate, dateTime.timeZone, 'earlier'),
                    (0, $8jDkV.toAbsolute)(maxDate, dateTime.timeZone, 'later')
                ].filter((ms)=>(0, $8jDkV.fromAbsolute)(ms, dateTime.timeZone).day === maxDate.day).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                let ms = (0, $8jDkV.epochFromDate)(dateTime) - dateTime.offset;
                let hours = Math.floor(ms / $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$ONE_HOUR);
                let remainder = ms % $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$ONE_HOUR;
                ms = $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$cycleValue(hours, amount, Math.floor(minAbsolute / $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$ONE_HOUR), Math.floor(maxAbsolute / $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$ONE_HOUR), options?.round) * $003409c3d1b8e28b$var$$435a2ceaa8778ed8$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return (0, $8jDkV.toCalendar)((0, $8jDkV.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
            }
        case 'minute':
        case 'second':
        case 'millisecond':
            // @ts-ignore
            return $003409c3d1b8e28b$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case 'era':
        case 'year':
        case 'month':
        case 'day':
            {
                let res = $003409c3d1b8e28b$export$d52ced6badfb9a4c((0, $8jDkV.toCalendarDateTime)(dateTime), field, amount, options);
                let ms = (0, $8jDkV.toAbsolute)(res, dateTime.timeZone);
                return (0, $8jDkV.toCalendar)((0, $8jDkV.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error('Unsupported field ' + field);
    }
}
function $003409c3d1b8e28b$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    let plainDateTime = (0, $8jDkV.toCalendarDateTime)(dateTime);
    let res = $003409c3d1b8e28b$export$e5d5e1c1822b6e56($003409c3d1b8e28b$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    let ms = (0, $8jDkV.toAbsolute)(res, dateTime.timeZone, disambiguation);
    return (0, $8jDkV.toCalendar)((0, $8jDkV.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
}

});
parcelRegister("1k26k", function(module, exports) {

$parcel$export(module.exports, "gregorianToJulianDay", () => $0c3d659024ba59aa$export$f297eb839006d339);
$parcel$export(module.exports, "getExtendedYear", () => $0c3d659024ba59aa$export$c36e0ecb2d4fa69d);
$parcel$export(module.exports, "isLeapYear", () => $0c3d659024ba59aa$export$553d7fa8e3805fc0);
$parcel$export(module.exports, "fromExtendedYear", () => $0c3d659024ba59aa$export$4475b7e617eb123c);
$parcel$export(module.exports, "GregorianCalendar", () => $0c3d659024ba59aa$export$80ee6245ec4f29ec);

var $tKwj1 = parcelRequire("tKwj1");

var $execq = parcelRequire("execq");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $0c3d659024ba59aa$var$$93635573935797de$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $0c3d659024ba59aa$export$f297eb839006d339(era, year, month, day) {
    year = $0c3d659024ba59aa$export$c36e0ecb2d4fa69d(era, year);
    let y1 = year - 1;
    let monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($0c3d659024ba59aa$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $0c3d659024ba59aa$var$$93635573935797de$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $0c3d659024ba59aa$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $0c3d659024ba59aa$export$c36e0ecb2d4fa69d(era, year) {
    return era === 'BC' ? 1 - year : year;
}
function $0c3d659024ba59aa$export$4475b7e617eb123c(year) {
    let era = 'AD';
    if (year <= 0) {
        era = 'BC';
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
const $0c3d659024ba59aa$var$$93635573935797de$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
class $0c3d659024ba59aa$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let jd0 = jd;
        let depoch = jd0 - $0c3d659024ba59aa$var$$93635573935797de$var$EPOCH;
        let quadricent = Math.floor(depoch / 146097);
        let dqc = (0, $execq.mod)(depoch, 146097);
        let cent = Math.floor(dqc / 36524);
        let dcent = (0, $execq.mod)(dqc, 36524);
        let quad = Math.floor(dcent / 1461);
        let dquad = (0, $execq.mod)(dcent, 1461);
        let yindex = Math.floor(dquad / 365);
        let extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
        let [era, year] = $0c3d659024ba59aa$export$4475b7e617eb123c(extendedYear);
        let yearDay = jd0 - $0c3d659024ba59aa$export$f297eb839006d339(era, year, 1, 1);
        let leapAdj = 2;
        if (jd0 < $0c3d659024ba59aa$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
        else if ($0c3d659024ba59aa$export$553d7fa8e3805fc0(year)) leapAdj = 1;
        let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
        let day = jd0 - $0c3d659024ba59aa$export$f297eb839006d339(era, year, month, 1) + 1;
        return new (0, $tKwj1.CalendarDate)(era, year, month, day);
    }
    toJulianDay(date) {
        return $0c3d659024ba59aa$export$f297eb839006d339(date.era, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $0c3d659024ba59aa$var$$93635573935797de$var$daysInMonth[$0c3d659024ba59aa$export$553d7fa8e3805fc0(date.year) ? 'leapyear' : 'standard'][date.month - 1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMonthsInYear(date) {
        return 12;
    }
    getDaysInYear(date) {
        return $0c3d659024ba59aa$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
    }
    getMaximumMonthsInYear() {
        return 12;
    }
    getMaximumDaysInMonth() {
        return 31;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getYearsInEra(date) {
        return 9999;
    }
    getEras() {
        return [
            'BC',
            'AD'
        ];
    }
    isInverseEra(date) {
        return date.era === 'BC';
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === 'BC' ? 'AD' : 'BC';
            date.year = 1 - date.year;
        }
    }
    constructor(){
        this.identifier = 'gregory';
    }
}

});
parcelRegister("execq", function(module, exports) {

$parcel$export(module.exports, "mod", () => $18425317d04adc10$export$842a2cf37af977e1);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $18425317d04adc10$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}

});



parcelRegister("gbmcw", function(module, exports) {

$parcel$export(module.exports, "parseDate", () => $cf6c675688ede86f$export$6b862160d295c8e);
$parcel$export(module.exports, "parseDateTime", () => $cf6c675688ede86f$export$588937bcd60ade55);
$parcel$export(module.exports, "dateTimeToString", () => $cf6c675688ede86f$export$4223de14708adc63);
$parcel$export(module.exports, "timeToString", () => $cf6c675688ede86f$export$f59dee82248f5ad4);
$parcel$export(module.exports, "dateToString", () => $cf6c675688ede86f$export$60dfd74aa96791bd);
$parcel$export(module.exports, "zonedDateTimeToString", () => $cf6c675688ede86f$export$bf79f1ebf4b18792);

var $tKwj1 = parcelRequire("tKwj1");

var $8jDkV = parcelRequire("8jDkV");

var $1qrul = parcelRequire("1qrul");

var $1k26k = parcelRequire("1k26k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cf6c675688ede86f$var$$58246871e4652552$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $cf6c675688ede86f$var$$58246871e4652552$var$DATE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
const $cf6c675688ede86f$var$$58246871e4652552$var$DATE_TIME_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $cf6c675688ede86f$var$$58246871e4652552$var$ZONED_DATE_TIME_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?(?::?(\d{2}))?)?\[(.*?)\]$/;
const $cf6c675688ede86f$var$$58246871e4652552$var$ABSOLUTE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
const $cf6c675688ede86f$var$$58246871e4652552$var$DATE_TIME_DURATION_RE = /^((?<negative>-)|\+)?P((?<years>\d*)Y)?((?<months>\d*)M)?((?<weeks>\d*)W)?((?<days>\d*)D)?((?<time>T)((?<hours>\d*[.,]?\d{1,9})H)?((?<minutes>\d*[.,]?\d{1,9})M)?((?<seconds>\d*[.,]?\d{1,9})S)?)?$/;
const $cf6c675688ede86f$var$$58246871e4652552$var$requiredDurationTimeGroups = [
    'hours',
    'minutes',
    'seconds'
];
const $cf6c675688ede86f$var$$58246871e4652552$var$requiredDurationGroups = [
    'years',
    'months',
    'weeks',
    'days',
    ...$cf6c675688ede86f$var$$58246871e4652552$var$requiredDurationTimeGroups
];
function $cf6c675688ede86f$export$c9698ec7f05a07e1(value) {
    let m = value.match($cf6c675688ede86f$var$$58246871e4652552$var$TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 time string: ' + value);
    return new (0, $tKwj1.Time)($cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[1], 0, 23), m[2] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $cf6c675688ede86f$export$6b862160d295c8e(value) {
    let m = value.match($cf6c675688ede86f$var$$58246871e4652552$var$DATE_RE);
    if (!m) {
        if ($cf6c675688ede86f$var$$58246871e4652552$var$ABSOLUTE_RE.test(value)) throw new Error(`Invalid ISO 8601 date string: ${value}. Use parseAbsolute() instead.`);
        throw new Error('Invalid ISO 8601 date string: ' + value);
    }
    let date = new (0, $tKwj1.CalendarDate)($cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[1], 0, 9999), $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[2], 1, 12), 1);
    date.day = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[3], 1, date.calendar.getDaysInMonth(date));
    return date;
}
function $cf6c675688ede86f$export$588937bcd60ade55(value) {
    let m = value.match($cf6c675688ede86f$var$$58246871e4652552$var$DATE_TIME_RE);
    if (!m) {
        if ($cf6c675688ede86f$var$$58246871e4652552$var$ABSOLUTE_RE.test(value)) throw new Error(`Invalid ISO 8601 date time string: ${value}. Use parseAbsolute() instead.`);
        throw new Error('Invalid ISO 8601 date time string: ' + value);
    }
    let year = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[1], -9999, 9999);
    let era = year < 1 ? 'BC' : 'AD';
    let date = new (0, $tKwj1.CalendarDateTime)(era, year < 1 ? -year + 1 : year, $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[2], 1, 12), 1, m[4] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $cf6c675688ede86f$export$fd7893f06e92a6a4(value, disambiguation) {
    let m = value.match($cf6c675688ede86f$var$$58246871e4652552$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    let year = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[1], -9999, 9999);
    let era = year < 1 ? 'BC' : 'AD';
    let date = new (0, $tKwj1.ZonedDateTime)(era, year < 1 ? -year + 1 : year, $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[2], 1, 12), 1, m[11], 0, m[4] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    let plainDateTime = (0, $8jDkV.toCalendarDateTime)(date);
    let ms;
    if (m[8]) {
        let hourOffset = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[8], -23, 23);
        date.offset = Math.sign(hourOffset) * (Math.abs(hourOffset) * 3600000 + $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[9] ?? '0', 0, 59) * 60000 + $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[10] ?? '0', 0, 59) * 1000);
        ms = (0, $8jDkV.epochFromDate)(date) - date.offset;
        // Validate offset against parsed date.
        let absolutes = (0, $8jDkV.possibleAbsolutes)(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error(`Offset ${$cf6c675688ede86f$var$$58246871e4652552$var$offsetToString(date.offset)} is invalid for ${$cf6c675688ede86f$export$4223de14708adc63(date)} in ${date.timeZone}`);
    } else ms = (0, $8jDkV.toAbsolute)((0, $8jDkV.toCalendarDateTime)(plainDateTime), date.timeZone, disambiguation);
    return (0, $8jDkV.fromAbsolute)(ms, date.timeZone);
}
function $cf6c675688ede86f$export$5adfdab05168c219(value, timeZone) {
    let m = value.match($cf6c675688ede86f$var$$58246871e4652552$var$ABSOLUTE_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    let year = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[1], -9999, 9999);
    let era = year < 1 ? 'BC' : 'AD';
    let date = new (0, $tKwj1.ZonedDateTime)(era, year < 1 ? -year + 1 : year, $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    if (m[8]) date.offset = $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[8], -23, 23) * 3600000 + $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(m[9] ?? '0', 0, 59) * 60000;
    return (0, $8jDkV.toTimeZone)(date, timeZone);
}
function $cf6c675688ede86f$export$8e384432362ed0f0(value) {
    return $cf6c675688ede86f$export$5adfdab05168c219(value, (0, $1qrul.getLocalTimeZone)());
}
function $cf6c675688ede86f$var$$58246871e4652552$var$parseNumber(value, min, max) {
    let val = Number(value);
    if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
    return val;
}
function $cf6c675688ede86f$export$f59dee82248f5ad4(time) {
    return `${String(time.hour).padStart(2, '0')}:${String(time.minute).padStart(2, '0')}:${String(time.second).padStart(2, '0')}${time.millisecond ? String(time.millisecond / 1000).slice(1) : ''}`;
}
function $cf6c675688ede86f$export$60dfd74aa96791bd(date) {
    let gregorianDate = (0, $8jDkV.toCalendar)(date, new (0, $1k26k.GregorianCalendar)());
    let year;
    if (gregorianDate.era === 'BC') year = gregorianDate.year === 1 ? '0000' : '-' + String(Math.abs(1 - gregorianDate.year)).padStart(6, '00');
    else year = String(gregorianDate.year).padStart(4, '0');
    return `${year}-${String(gregorianDate.month).padStart(2, '0')}-${String(gregorianDate.day).padStart(2, '0')}`;
}
function $cf6c675688ede86f$export$4223de14708adc63(date) {
    // @ts-ignore
    return `${$cf6c675688ede86f$export$60dfd74aa96791bd(date)}T${$cf6c675688ede86f$export$f59dee82248f5ad4(date)}`;
}
function $cf6c675688ede86f$var$$58246871e4652552$var$offsetToString(offset) {
    let sign = Math.sign(offset) < 0 ? '-' : '+';
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset / 3600000);
    let offsetMinutes = Math.floor(offset % 3600000 / 60000);
    let offsetSeconds = Math.floor(offset % 3600000 % 60000 / 1000);
    let stringOffset = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
    if (offsetSeconds !== 0) stringOffset += `:${String(offsetSeconds).padStart(2, '0')}`;
    return stringOffset;
}
function $cf6c675688ede86f$export$bf79f1ebf4b18792(date) {
    return `${$cf6c675688ede86f$export$4223de14708adc63(date)}${$cf6c675688ede86f$var$$58246871e4652552$var$offsetToString(date.offset)}[${date.timeZone}]`;
}
function $cf6c675688ede86f$export$ecae829bb3747ea6(value) {
    const match = value.match($cf6c675688ede86f$var$$58246871e4652552$var$DATE_TIME_DURATION_RE);
    if (!match) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const parseDurationGroup = (group, isNegative)=>{
        if (!group) return 0;
        try {
            const sign = isNegative ? -1 : 1;
            return sign * Number(group.replace(',', '.'));
        } catch  {
            throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
        }
    };
    const isNegative = !!match.groups?.negative;
    const hasRequiredGroups = $cf6c675688ede86f$var$$58246871e4652552$var$requiredDurationGroups.some((group)=>match.groups?.[group]);
    if (!hasRequiredGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const durationStringIncludesTime = match.groups?.time;
    if (durationStringIncludesTime) {
        const hasRequiredDurationTimeGroups = $cf6c675688ede86f$var$$58246871e4652552$var$requiredDurationTimeGroups.some((group)=>match.groups?.[group]);
        if (!hasRequiredDurationTimeGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    }
    const duration = {
        years: parseDurationGroup(match.groups?.years, isNegative),
        months: parseDurationGroup(match.groups?.months, isNegative),
        weeks: parseDurationGroup(match.groups?.weeks, isNegative),
        days: parseDurationGroup(match.groups?.days, isNegative),
        hours: parseDurationGroup(match.groups?.hours, isNegative),
        minutes: parseDurationGroup(match.groups?.minutes, isNegative),
        seconds: parseDurationGroup(match.groups?.seconds, isNegative)
    };
    if (duration.hours !== undefined && duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    if (duration.minutes !== undefined && duration.minutes % 1 !== 0 && duration.seconds) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    return duration;
}

});



parcelRegister("238xf", function(module, exports) {

$parcel$export(module.exports, "weekStartData", () => $2d0d269c880fb005$export$7a5acbd77d414bd9);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
const $2d0d269c880fb005$export$7a5acbd77d414bd9 = {
    '001': 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};

});


parcelRegister("eZSya", function(module, exports) {

$parcel$export(module.exports, "useDateFormatter", () => $c213a9e1670b6efa$export$85fd5fdf27bacc79);

var $gCYb4 = parcelRequire("gCYb4");

var $1ntKq = parcelRequire("1ntKq");

var $MHwAo = parcelRequire("MHwAo");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c213a9e1670b6efa$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $gCYb4.useDeepMemo)(options ?? {}, $c213a9e1670b6efa$var$$60f33508b4cd9d3b$var$isEqual);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    return (0, $eF4cA.useMemo)(()=>new (0, $MHwAo.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function $c213a9e1670b6efa$var$$60f33508b4cd9d3b$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}

});
parcelRegister("gCYb4", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $2bcaa14db68d4234$export$722debc0e56fea39);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rsp-rules/pure-render */ function $2bcaa14db68d4234$export$722debc0e56fea39(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, $eF4cA.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    // oxlint-disable-next-line react/react-compiler
    lastValue.current = value;
    return value;
}

});

parcelRegister("MHwAo", function(module, exports) {

$parcel$export(module.exports, "DateFormatter", () => $0c4dc64625c8fcf6$export$ad991b66133851cf);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$formatterCache = new Map();
class $0c4dc64625c8fcf6$export$ad991b66133851cf {
    constructor(locale, options = {}){
        this.formatter = $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
    /**
   * Formats a date as a string according to the locale and format options passed to the
   * constructor.
   */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {}
};
function $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref ?? defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$formatterCache.has(cacheKey)) return $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior = null;
function $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$hasBuggyHour12Behavior() {
    if ($0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior == null) $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyHour12Behavior;
}
let $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle = null;
function $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$hasBuggyResolvedHourCycle() {
    if ($0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle == null) $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$_hasBuggyResolvedHourCycle;
}
function $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = $0c4dc64625c8fcf6$var$$12a3c853105e5a70$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}

});


parcelRegister("9hIi4", function(module, exports) {

$parcel$export(module.exports, "useListFormatter", () => $09596f76779bf41c$export$a2f47a3d2973640);

var $1ntKq = parcelRequire("1ntKq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $09596f76779bf41c$export$a2f47a3d2973640(options = {}) {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    return (0, $eF4cA.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}

});


parcelRegister("bTZtY", function(module, exports) {

$parcel$export(module.exports, "TagGroup", () => $54d2c5e951245fa2$export$67ea30858aaf75e3);
$parcel$export(module.exports, "Tag", () => $54d2c5e951245fa2$export$3288d34c523a1192);


var $4W5AG = parcelRequire("4W5AG");

var $cnBj9 = parcelRequire("cnBj9");

var $f16Ml = parcelRequire("f16Ml");

var $8OJ2z = parcelRequire("8OJ2z");

var $eTg8W = parcelRequire("eTg8W");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $dm5H1 = parcelRequire("dm5H1");

var $8g9SZ = parcelRequire("8g9SZ");

var $fL4LX = parcelRequire("fL4LX");

var $i93Vd = parcelRequire("i93Vd");

var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $3g2oV = parcelRequire("3g2oV");
var $fE7cK = parcelRequire("fE7cK");

var $3g2oV = parcelRequire("3g2oV");

var $fDYaM = parcelRequire("fDYaM");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");

var $gF3YT = parcelRequire("gF3YT");

var $k5Pnh = parcelRequire("k5Pnh");

var $c1ibQ = parcelRequire("c1ibQ");

var $4lMDe = parcelRequire("4lMDe");

var $25dFS = parcelRequire("25dFS");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $f9wnx = parcelRequire("f9wnx");
function $54d2c5e951245fa2$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $54d2c5e951245fa2$export$5b07b5dd2cbd96e3 = (0, $eF4cA.createContext)(null);
const $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$InternalTagGroupContext = (0, $eF4cA.createContext)({});
const $54d2c5e951245fa2$export$67ea30858aaf75e3 = (0, $eF4cA.forwardRef)(function TagGroup(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $54d2c5e951245fa2$export$5b07b5dd2cbd96e3);
    props = (0, $j3pTw.useFormProps)(props);
    let { onRemove: onRemove } = props;
    return (0, $dx4lB.jsx)($54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$InternalTagGroupContext.Provider, {
        value: {
            onRemove: onRemove
        },
        children: (0, $dx4lB.jsx)((0, $3g2oV.CollectionBuilder), {
            content: (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                ...props
            }),
            children: (collection)=>(0, $dx4lB.jsx)($54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$TagGroupInner, {
                    props: props,
                    forwardedRef: ref,
                    collection: collection
                })
        })
    });
});
function $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$TagGroupInner({ props: { label: label, description: description, labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', isEmphasized: isEmphasized, isInvalid: isInvalid, errorMessage: errorMessage, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, size: size = 'M', ...props }, forwardedRef: ref, collection: collection }) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($54d2c5e951245fa2$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { maxRows: maxRows, groupActionLabel: groupActionLabel, onGroupAction: onGroupAction, renderEmptyState: renderEmptyState = ()=>stringFormatter.format('tag.noTags'), ...otherProps } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let containerRef = (0, $eF4cA.useRef)(null);
    let tagsRef = (0, $eF4cA.useRef)(null);
    let actionsRef = (0, $eF4cA.useRef)(null);
    let hiddenTagsRef = (0, $eF4cA.useRef)(null);
    let [tagState, setTagState] = (0, $eF4cA.useState)({
        visibleTagCount: collection.size,
        showCollapseButton: false
    });
    let [isCollapsed, setIsCollapsed] = (0, $eF4cA.useState)(maxRows != null);
    let { onRemove: onRemove } = (0, $eF4cA.useContext)($54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$InternalTagGroupContext);
    let isEmpty = collection.size === 0;
    let showCollapseToggleButton = tagState.showCollapseButton || tagState.visibleTagCount < collection.size;
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let allItems = (0, $eF4cA.useMemo)(()=>Array.from(collection), [
        collection
    ]);
    let items = (0, $eF4cA.useMemo)(()=>Array.from(collection).slice(0, !isCollapsed ? collection.size : tagState.visibleTagCount), [
        collection,
        tagState.visibleTagCount,
        isCollapsed
    ]);
    let updateVisibleTagCount = ()=>{
        if (maxRows == null) setTagState({
            visibleTagCount: collection.size,
            showCollapseButton: false
        });
        if (maxRows != null && maxRows > 0) {
            let computeVisibleTagCount = ()=>{
                let currContainerRef = hiddenTagsRef.current;
                let currTagsRef = hiddenTagsRef.current;
                let currActionsRef = actionsRef.current;
                if (!currContainerRef || !currTagsRef || collection.size === 0 || currContainerRef.parentElement == null) return {
                    visibleTagCount: 0,
                    showCollapseButton: false
                };
                // Count rows and show tags until we hit the maxRows.
                // I think this is still a safe assumption, and we don't need to queryAll for role=tag
                let tags = [
                    ...currTagsRef.children
                ];
                let currY = -Infinity;
                let rowCount = 0;
                let index = 0;
                let tagWidths = [];
                for (let tag of tags){
                    let { width: width, y: y } = tag.getBoundingClientRect();
                    if (y !== currY) {
                        currY = y;
                        rowCount++;
                    }
                    if (rowCount > maxRows) break;
                    tagWidths.push(width);
                    index++;
                }
                // Remove tags until there is space for the collapse button and action button (if present) on the last row.
                let buttons = currActionsRef ? [
                    ...currActionsRef.children
                ] : [];
                if (buttons.length > 0 && rowCount >= maxRows) {
                    let buttonsWidth = buttons.reduce((acc, curr)=>acc += curr.getBoundingClientRect().width, 0);
                    let margins = parseFloat(getComputedStyle(buttons[0]).marginInlineStart);
                    buttonsWidth += margins * 2;
                    let end = direction === 'ltr' ? 'right' : 'left';
                    let containerEnd = currContainerRef.parentElement?.getBoundingClientRect()[end] - margins;
                    let lastTagEnd = tags[index - 1]?.getBoundingClientRect()[end];
                    lastTagEnd += margins;
                    let availableWidth = containerEnd - lastTagEnd;
                    while(availableWidth <= buttonsWidth && index > 0){
                        let tagWidth = tagWidths.pop();
                        if (tagWidth != null) availableWidth += tagWidth;
                        index--;
                    }
                }
                return {
                    visibleTagCount: Math.max(index, 1),
                    showCollapseButton: index < collection.size
                };
            };
            let result = computeVisibleTagCount();
            (0, $l19Vn.flushSync)(()=>{
                setTagState(result);
            });
        }
    };
    let updateVisibleTagCountEffect = (0, $4lMDe.useEffectEvent)(updateVisibleTagCount);
    (0, $f9wnx.useResizeObserver)({
        ref: maxRows != null ? containerRef : undefined,
        onResize: updateVisibleTagCount
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        if (collection.size > 0 && maxRows != null && maxRows > 0) queueMicrotask(updateVisibleTagCountEffect);
    }, [
        collection.size,
        maxRows
    ]);
    (0, $eF4cA.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateVisibleTagCountEffect());
    }, []);
    let handlePressCollapse = ()=>{
        setIsCollapsed((prevCollapsed)=>!prevCollapsed);
    };
    let helpText = null;
    if (!isInvalid && description) helpText = (0, $dx4lB.jsx)((0, $208Op.Text), {
        slot: "description",
        styles: (0, $8w4Nl.helpTextStyles)({
            size: size
        }),
        children: description
    });
    else if (isInvalid) helpText = (0, $dx4lB.jsxs)("div", {
        className: (0, $8w4Nl.helpTextStyles)({
            size: size,
            isInvalid: isInvalid
        }),
        children: [
            (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                children: (0, $dx4lB.jsx)((0, $cnBj9.default), {})
            }),
            (0, $dx4lB.jsx)((0, $208Op.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
    return (0, $dx4lB.jsxs)((0, $fE7cK.TagGroup), {
        ...otherProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            size: size,
            labelPosition: labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: [
            (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                size: size,
                labelPosition: labelPosition,
                labelAlign: labelAlign,
                contextualHelp: props.contextualHelp,
                children: label
            }),
            (0, $dx4lB.jsx)("div", {
                ref: containerRef,
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' zXcEWr182';
                    rules += ' yXcEWr182';
                    rules += ' BXcEWr182';
                    rules += ' AXcEWr182';
                    rules += ' Nb182';
                    if (props.isEmpty) rules += ' Iy182';
                    else rules += ' Ib182';
                    if (props.isEmpty) rules += ' Hy182';
                    else rules += ' Hs182';
                    rules += ' _Pc182';
                    return rules;
                }({
                    isEmpty: isEmpty
                }),
                children: (0, $dx4lB.jsx)((0, $j3pTw.FormContext).Provider, {
                    value: {
                        ...formContext,
                        size: size
                    },
                    children: (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $c1ibQ.TextContext),
                                undefined
                            ],
                            [
                                (0, $k5Pnh.ButtonContext),
                                undefined
                            ],
                            [
                                $54d2c5e951245fa2$export$5b07b5dd2cbd96e3,
                                {
                                    size: size,
                                    isEmphasized: isEmphasized
                                }
                            ]
                        ],
                        children: [
                            maxRows != null && (0, $dx4lB.jsx)("div", {
                                // @ts-ignore
                                inert: (0, $gF3YT.inertValue)(true),
                                ref: hiddenTagsRef,
                                className: " sf182 _wb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 _Pa182 Wr182 _lr182 _6b182 _Nc182 Pc182 _Ia182",
                                children: allItems.map((item)=>{
                                    // pull off individual props as an allow list, don't want refs or other props getting through
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    let { ref: ref, ...itemProps } = item.props;
                                    return (0, $dx4lB.jsx)("div", {
                                        style: itemProps.UNSAFE_style,
                                        className: itemProps.className({
                                            size: size,
                                            allowsRemoving: Boolean(onRemove)
                                        }),
                                        children: (0, $dx4lB.jsx)($54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$TagWrapper, {
                                            id: item.key,
                                            textValue: item.textValue,
                                            isInRealDOM: true,
                                            size: size,
                                            allowsRemoving: !!onRemove,
                                            ...itemProps,
                                            children: itemProps.children({
                                                size: size,
                                                allowsRemoving: Boolean(onRemove),
                                                isInCtx: true
                                            })
                                        }, item.key)
                                    }, item.key);
                                })
                            }),
                            (0, $dx4lB.jsx)((0, $fE7cK.TagList), {
                                ref: tagsRef,
                                items: items,
                                renderEmptyState: renderEmptyState,
                                className: " sf182 Nb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                children: (item)=>(0, $dx4lB.jsx)($54d2c5e951245fa2$export$3288d34c523a1192, {
                                        ...item.props,
                                        id: item.key,
                                        textValue: item.textValue
                                    })
                            }),
                            !isEmpty && (showCollapseToggleButton || groupActionLabel) && (0, $dx4lB.jsx)($54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$ActionGroup, {
                                collection: collection,
                                "aria-label": props['aria-label'],
                                "aria-labelledby": props['aria-labelledby'],
                                actionsRef: actionsRef,
                                tagState: tagState,
                                size: size,
                                isCollapsed: isCollapsed,
                                handlePressCollapse: handlePressCollapse,
                                onGroupAction: onGroupAction,
                                groupActionLabel: groupActionLabel
                            })
                        ]
                    })
                })
            }),
            helpText
        ]
    });
}
function $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$ActionGroup(props) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($54d2c5e951245fa2$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { actionsRef: actionsRef, tagState: tagState, size: size, isCollapsed: isCollapsed, handlePressCollapse: handlePressCollapse, onGroupAction: onGroupAction, groupActionLabel: groupActionLabel, collection: collection, // and we can't supply an id to the TagList because it'll cause an issue where all the tag ids flip back
    // and forth with their prefix in an infinite loop
    'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy } = props;
    let actionsId = (0, $25dFS.useId)();
    // might need to localize the aria-label which concatenates with this label
    let actionGroupLabel = stringFormatter.format('tag.actions');
    return (0, $dx4lB.jsxs)("div", {
        role: "group",
        ref: actionsRef,
        id: actionsId,
        "aria-label": ariaLabel ? `${ariaLabel} ${actionGroupLabel}` : actionGroupLabel,
        "aria-labelledby": ariaLabelledBy ? ariaLabelledBy : undefined,
        className: " sf182",
        children: [
            tagState.showCollapseButton && (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                isQuiet: true,
                size: size,
                styles: " Js182 Gs182 Is182 Hs182",
                UNSAFE_style: {
                    display: 'inline-flex'
                },
                onPress: handlePressCollapse,
                children: isCollapsed ? stringFormatter.format('tag.showAllButtonLabel', {
                    tagCount: collection.size
                }) : stringFormatter.format('tag.hideButtonLabel')
            }),
            groupActionLabel && onGroupAction && (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                isQuiet: true,
                size: size,
                styles: " Js182 Gs182 Is182 Hs182",
                UNSAFE_style: {
                    display: 'inline-flex'
                },
                onPress: ()=>onGroupAction?.(),
                children: groupActionLabel
            })
        ]
    });
}
const $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$tagStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else if (props.isSelected) {
        if (props.isEmphasized) rules += ' px182';
        else rules += ' pr182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    if (props.isDisabled) rules += ' plc182';
    else if (props.isSelected) rules += ' ple182';
    else rules += ' plb182';
    rules += ' sh182';
    rules += ' eb182';
    rules += ' _oa182';
    rules += ' Sv182';
    rules += ' SgLWx3bd182';
    if (props.allowsRemoving) rules += ' Rd182';
    else rules += ' Rv182';
    if (props.size === "XL") rules += ' Nl182';
    else if (props.size === "L") rules += ' Nj182';
    else if (props.size === "S") rules += ' Nf182';
    else if (props.size === "XS") rules += ' Ne182';
    else rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' FRuFGYc182';
    rules += ' La182';
    rules += ' _5c182';
    rules += ' _Ca182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isDisabled) rules += ' gH182';
    else if (props.isSelected) {
        if (props.isEmphasized) {
            if (props.isFocusVisible) rules += ' gUgARdd182';
            else if (props.isPressed) rules += ' gUgARdd182';
            else if (props.isHovered) rules += ' gUgARdd182';
            else rules += ' g5qAiPc182';
        } else {
            if (props.isPressed) rules += ' gu182';
            else if (props.isFocusVisible) rules += ' gu182';
            else if (props.isHovered) rules += ' gu182';
            else rules += ' g0182';
        }
    } else if (props.isFocusVisible) rules += ' gF182';
    else if (props.isHovered) rules += ' gF182';
    else rules += ' gH182';
    if (props.isSelected) rules += ' gle182';
    else rules += ' glb182';
    rules += ' _je182';
    rules += ' Js182';
    rules += ' Gs182';
    rules += ' Is182';
    rules += ' Hs182';
    if (props.isLink) rules += ' ry182';
    else rules += ' ri182';
    rules += ' -_8sjo0b-t5ZbAob182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    else if (props.size === "XS") rules += ' -F_-Fn182';
    else rules += ' -F_-Fx182';
    return rules;
};
const $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$avatarSize = {
    S: 16,
    M: 20,
    L: 24
};
const $54d2c5e951245fa2$export$3288d34c523a1192 = (0, $eF4cA.forwardRef)(function Tag({ children: children, textValue: textValue, ...props }, ref) {
    textValue ||= typeof children === 'string' ? children : undefined;
    let ctx = (0, $fDYaM.useSlottedContext)($54d2c5e951245fa2$export$5b07b5dd2cbd96e3);
    let isInRealDOM = Boolean(ctx?.size);
    let { size: size, isEmphasized: isEmphasized } = ctx ?? {};
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let backupRef = (0, $eF4cA.useRef)(null);
    domRef = domRef || backupRef;
    let isLink = props.href != null;
    return (0, $dx4lB.jsx)((0, $fE7cK.Tag), {
        textValue: textValue,
        ...props,
        ref: domRef,
        style: (0, $i93Vd.pressScale)(domRef),
        className: (renderProps)=>$54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$tagStyles({
                size: size,
                isEmphasized: isEmphasized,
                isLink: isLink,
                ...renderProps
            }),
        children: (0, $fDYaM.composeRenderProps)(children, (children, renderProps)=>(0, $dx4lB.jsx)($54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$TagWrapper, {
                isInRealDOM: isInRealDOM,
                isEmphasized: isEmphasized,
                ...renderProps,
                children: typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: children
                }) : children
            }))
    });
});
function $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$TagWrapper({ children: children, isDisabled: isDisabled, allowsRemoving: allowsRemoving, isInRealDOM: isInRealDOM, isEmphasized: isEmphasized, isSelected: isSelected }) {
    let { size: size = 'M' } = (0, $fDYaM.useSlottedContext)($54d2c5e951245fa2$export$5b07b5dd2cbd96e3) ?? {};
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            isInRealDOM && (0, $dx4lB.jsx)("div", {
                className: " sd182 Na182 eb182 Uc182 Usd182 qc182 qsd182 _yb182 g9182",
                children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $208Op.TextContext),
                            {
                                styles: " _Jb182 _Nc182 Pc182 _Yb182 _7c182"
                            }
                        ],
                        [
                            (0, $dm5H1.IconContext),
                            {
                                render: (0, $8OJ2z.centerBaseline)({
                                    slot: 'icon',
                                    styles: " _Ja182"
                                }),
                                styles: " ZObNfn182 FObNfn182 I67logd182 _va182"
                            }
                        ],
                        [
                            (0, $f16Ml.AvatarContext),
                            {
                                size: $54d2c5e951245fa2$var$$1d63bfab43d9ffe1$var$avatarSize[size],
                                styles: " _Ja182"
                            }
                        ],
                        [
                            (0, $8g9SZ.ImageContext),
                            {
                                styles: " ZObNfn182 FObNfn182 _va182 _Ja182 fa182 _Ha182 oa182 na182 ka182 ja182"
                            }
                        ]
                    ],
                    children: children
                })
            }),
            !isInRealDOM && children,
            allowsRemoving && isInRealDOM && (0, $dx4lB.jsx)((0, $eTg8W.ClearButton), {
                slot: "remove",
                size: size,
                isStaticColor: isEmphasized && isSelected,
                isDisabled: isDisabled
            })
        ]
    });
}

});
parcelRegister("eTg8W", function(module, exports) {

$parcel$export(module.exports, "ClearButton", () => $1501dbd1cd840b0a$export$13ec83e50bf04290);


var $bQJuU = parcelRequire("bQJuU");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1501dbd1cd840b0a$var$$f6a62e6e68437458$var$focusRingStyles = {
    outlineStyle: {
        "default": "none",
        isFocusVisible: "solid"
    },
    outlineColor: {
        "default": "focus-ring",
        forcedColors: "Highlight"
    },
    outlineWidth: 2,
    outlineOffset: 2
};
const $1501dbd1cd840b0a$var$$f6a62e6e68437458$var$visibleClearButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    if (props.isStaticColor) rules += ' Ok182';
    else {
        rules += ' Oh182';
        rules += ' Olc182';
    }
    rules += ' _Mc182';
    rules += ' _Kc182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' Fb182';
    if (props.size === "XL") rules += ' ZF182';
    else if (props.size === "L") rules += ' Zw182';
    else if (props.size === "S") rules += ' Zo182';
    else if (props.size === "XS") rules += ' Zm182';
    else rules += ' ZC182';
    rules += ' _va182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' _je182';
    rules += ' g9182';
    rules += ' _oa182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' p40ub4c182';
    rules += ' -_8sjo0b-t5ZbAob182';
    return rules;
};
const $1501dbd1cd840b0a$export$13ec83e50bf04290 = (0, $eF4cA.forwardRef)(function ClearButton(props, ref) {
    let { size: size = 'M', isStaticColor: isStaticColor = false, ...rest } = props;
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        ...rest,
        ref: domRef,
        style: (0, $i93Vd.pressScale)(domRef),
        className: (renderProps)=>$1501dbd1cd840b0a$var$$f6a62e6e68437458$var$visibleClearButton({
                ...renderProps,
                size: size,
                isStaticColor: isStaticColor
            }),
        children: (0, $dx4lB.jsx)((0, $bQJuU.default), {
            size: props.size
        })
    });
// oxlint-enable react/react-compiler
});

});

parcelRegister("fE7cK", function(module, exports) {

$parcel$export(module.exports, "TagGroup", () => $d96f5a32472e6072$export$67ea30858aaf75e3);
$parcel$export(module.exports, "TagList", () => $d96f5a32472e6072$export$f9fef0f55402315b);
$parcel$export(module.exports, "Tag", () => $d96f5a32472e6072$export$3288d34c523a1192);

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $8UElq = parcelRequire("8UElq");

var $cg9Gh = parcelRequire("cg9Gh");

var $9PmUB = parcelRequire("9PmUB");

var $hUj7u = parcelRequire("hUj7u");

var $2FPWu = parcelRequire("2FPWu");

var $c1ibQ = parcelRequire("c1ibQ");

var $aOQtg = parcelRequire("aOQtg");
var $7Mkiz = parcelRequire("7Mkiz");

var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $fVfXf = parcelRequire("fVfXf");

var $bWhaY = parcelRequire("bWhaY");

var $fHi9W = parcelRequire("fHi9W");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d96f5a32472e6072$export$5b07b5dd2cbd96e3 = (0, $eF4cA.createContext)(null);
const $d96f5a32472e6072$export$e755ce3685dd0ca9 = (0, $eF4cA.createContext)(null);
const $d96f5a32472e6072$export$67ea30858aaf75e3 = (0, $eF4cA.forwardRef)(function TagGroup(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $d96f5a32472e6072$export$5b07b5dd2cbd96e3);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $cg9Gh.ListStateContext).Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: props.children
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d96f5a32472e6072$var$$3df3ddf5bafbc7b1$var$TagGroupInner, {
            props: props,
            forwardedRef: ref,
            collection: collection
        })));
});
function $d96f5a32472e6072$var$$3df3ddf5bafbc7b1$var$TagGroupInner({ props: props, forwardedRef: ref, collection: collection }) {
    let tagListRef = (0, $eF4cA.useRef)(null);
    // Extract the user provided id so it doesn't clash with the collection id provided by Autocomplete
    let { id: id, ...otherProps } = props;
    [otherProps, tagListRef] = (0, $fDYaM.useContextProps)(otherProps, tagListRef, (0, $9PmUB.SelectableCollectionContext));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { filter: filter, shouldUseVirtualFocus: shouldUseVirtualFocus, ...DOMCollectionProps } = otherProps;
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let tagGroupState = (0, $fHi9W.useListState)({
        ...DOMCollectionProps,
        children: undefined,
        collection: collection
    });
    // oxlint-disable-next-line react/react-compiler
    let filteredState = (0, $fHi9W.UNSTABLE_useFilteredListState)(tagGroupState, filter);
    // Prevent DOM props from going to two places.
    let domProps = (0, $fVfXf.filterDOMProps)(otherProps, {
        global: true
    });
    let domPropOverrides = Object.fromEntries(Object.entries(domProps).map(([k, val])=>[
            k,
            k === 'id' ? val : undefined
        ]));
    let { gridProps: gridProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $7Mkiz.useTagGroup)({
        ...DOMCollectionProps,
        ...domPropOverrides,
        label: label
    }, filteredState, tagListRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        render: props.render,
        ...domProps,
        id: id,
        ref: ref,
        slot: props.slot || undefined,
        className: props.className ?? 'react-aria-TagGroup',
        style: props.style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    elementType: 'span',
                    ref: labelRef
                }
            ],
            [
                $d96f5a32472e6072$export$e755ce3685dd0ca9,
                {
                    ...gridProps,
                    ref: tagListRef
                }
            ],
            [
                (0, $cg9Gh.ListStateContext),
                filteredState
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, props.children));
}
const $d96f5a32472e6072$export$f9fef0f55402315b = (0, $eF4cA.forwardRef)(function TagList(props, ref) {
    let state = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    return state ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($d96f5a32472e6072$var$$3df3ddf5bafbc7b1$var$TagListInner, {
        props: props,
        forwardedRef: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props);
});
function $d96f5a32472e6072$var$$3df3ddf5bafbc7b1$var$TagListInner({ props: props, forwardedRef: forwardedRef }) {
    let state = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    let { CollectionRoot: CollectionRoot } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let [gridProps, ref] = (0, $fDYaM.useContextProps)({}, forwardedRef, $d96f5a32472e6072$export$e755ce3685dd0ca9);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let renderValues = {
        isEmpty: state.collection.size === 0,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        state: state
    };
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-TagList',
        values: renderValues
    });
    let persistedKeys = (0, $8dzVy.usePersistedKeys)(state.selectionManager.focusedKey);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, gridProps, focusProps),
        ref: ref,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, state.collection.size === 0 && props.renderEmptyState ? props.renderEmptyState(renderValues) : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: persistedKeys
    })));
}
const $d96f5a32472e6072$export$3288d34c523a1192 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.ItemNode), (props, forwardedRef, item)=>{
    let state = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)({
        within: false
    });
    let { rowProps: rowProps, gridCellProps: gridCellProps, removeButtonProps: removeButtonProps, ...states } = (0, $aOQtg.useTag)({
        item: item
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-Tag',
        values: {
            ...states,
            isFocusVisible: isFocusVisible,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ref: ref,
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, rowProps, focusProps, hoverProps),
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-removing": states.allowsRemoving || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        remove: removeButtonProps
                    }
                }
            ],
            [
                (0, $8dzVy.CollectionRendererContext),
                (0, $8dzVy.DefaultCollectionRenderer)
            ],
            [
                (0, $hUj7u.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children)));
});

});
parcelRegister("cg9Gh", function(module, exports) {

$parcel$export(module.exports, "ListBoxContext", () => $f80e6972bb02c67c$export$7ff8f37d2d81a48d);
$parcel$export(module.exports, "ListStateContext", () => $f80e6972bb02c67c$export$7c5906fe4f1f2af2);
$parcel$export(module.exports, "ListBox", () => $f80e6972bb02c67c$export$41f133550aa26f48);
$parcel$export(module.exports, "ListBoxSection", () => $f80e6972bb02c67c$export$dca12b0bb56e4fc);
$parcel$export(module.exports, "ListBoxItem", () => $f80e6972bb02c67c$export$a11e76429ed99b4);
$parcel$export(module.exports, "ListBoxLoadMoreItem", () => $f80e6972bb02c67c$export$8e6d031a08cf56a1);

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $cLs8t = parcelRequire("cLs8t");

var $1etmN = parcelRequire("1etmN");

var $9PmUB = parcelRequire("9PmUB");

var $hUj7u = parcelRequire("hUj7u");

var $jbXau = parcelRequire("jbXau");

var $2FPWu = parcelRequire("2FPWu");

var $c1ibQ = parcelRequire("c1ibQ");

var $dkNZi = parcelRequire("dkNZi");
var $ht1Hx = parcelRequire("ht1Hx");
var $5bJVF = parcelRequire("5bJVF");

var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $fVfXf = parcelRequire("fVfXf");

var $6pgkA = parcelRequire("6pgkA");

var $gF3YT = parcelRequire("gF3YT");

var $bWhaY = parcelRequire("bWhaY");

var $daM4n = parcelRequire("daM4n");

var $fHi9W = parcelRequire("fHi9W");

var $lJdzA = parcelRequire("lJdzA");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $gm31e = parcelRequire("gm31e");

var $4bE7h = parcelRequire("4bE7h");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $aGDvF = parcelRequire("aGDvF");

var $1ntKq = parcelRequire("1ntKq");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f80e6972bb02c67c$export$7ff8f37d2d81a48d = (0, $eF4cA.createContext)(null);
const $f80e6972bb02c67c$export$7c5906fe4f1f2af2 = (0, $eF4cA.createContext)(null);
const $f80e6972bb02c67c$export$41f133550aa26f48 = (0, $eF4cA.forwardRef)(function ListBox(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $f80e6972bb02c67c$export$7ff8f37d2d81a48d);
    let state = (0, $eF4cA.useContext)($f80e6972bb02c67c$export$7c5906fe4f1f2af2);
    // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
    // Those components render two copies of their children so that the collection can be built even when the popover is closed.
    // The first copy sends a collection document via context which we render the collection portal into.
    // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
    // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.
    if (state) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($f80e6972bb02c67c$var$$928221da08ecbc62$var$StandaloneListBox, {
            props: props,
            listBoxRef: ref,
            collection: collection
        }));
});
function $f80e6972bb02c67c$var$$928221da08ecbc62$var$StandaloneListBox({ props: props, listBoxRef: listBoxRef, collection: collection }) {
    props = {
        ...props,
        collection: collection,
        children: null,
        items: null
    };
    let { layoutDelegate: layoutDelegate } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let state = (0, $fHi9W.useListState)({
        ...props,
        layoutDelegate: layoutDelegate
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: listBoxRef
    });
}
function $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxInner({ state: inputState, props: props, listBoxRef: listBoxRef }) {
    // oxlint-disable-next-line react/react-compiler
    [props, listBoxRef] = (0, $fDYaM.useContextProps)(props, listBoxRef, (0, $9PmUB.SelectableCollectionContext));
    let { dragAndDropHooks: dragAndDropHooks, layout: layout = 'stack', orientation: orientation = 'vertical', filter: filter } = props;
    // oxlint-disable-next-line react/react-compiler
    let state = (0, $fHi9W.UNSTABLE_useFilteredListState)(inputState, filter);
    let { collection: collection, selectionManager: selectionManager } = state;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = selectionManager;
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let keyboardDelegate = (0, $eF4cA.useMemo)(()=>props.keyboardDelegate || new (0, $daM4n.ListKeyboardDelegate)({
            collection: collection,
            collator: collator,
            ref: listBoxRef,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layout: layout,
            orientation: orientation,
            direction: direction,
            layoutDelegate: layoutDelegate
        }), [
        collection,
        collator,
        listBoxRef,
        disabledBehavior,
        disabledKeys,
        orientation,
        direction,
        props.keyboardDelegate,
        layout,
        layoutDelegate
    ]);
    let { listBoxProps: listBoxProps } = (0, $dkNZi.useListBox)({
        ...props,
        shouldSelectOnPressUp: isListDraggable || props.shouldSelectOnPressUp,
        keyboardDelegate: keyboardDelegate,
        isVirtualized: isVirtualized
    }, state, listBoxRef);
    let dragHooksProvided = (0, $eF4cA.useRef)(isListDraggable);
    let dropHooksProvided = (0, $eF4cA.useRef)(isListDroppable);
    (0, $eF4cA.useEffect)(()=>{
        return;
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $eF4cA.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        // oxlint-disable-next-line react/react-compiler
        dragAndDropHooks.useDraggableCollection({}, dragState, listBoxRef);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, listBoxRef, {
            orientation: orientation,
            layout: layout,
            direction: direction
        });
        // oxlint-disable-next-line react/react-compiler
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, listBoxRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let isEmpty = state.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: isEmpty,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: props.layout || 'stack',
        orientation: orientation,
        state: state
    };
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ListBox',
        values: renderValues
    });
    let emptyState = null;
    if (isEmpty && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        // eslint-disable-next-line
        role: "option",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState(renderValues));
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $6pgkA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, listBoxProps, focusProps, droppableCollection?.collectionProps),
        ref: listBoxRef,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": props.layout || 'stack',
        "data-orientation": orientation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $f80e6972bb02c67c$export$7ff8f37d2d81a48d,
                props
            ],
            [
                $f80e6972bb02c67c$export$7c5906fe4f1f2af2,
                state
            ],
            [
                (0, $cLs8t.DragAndDropContext),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $jbXau.SeparatorContext),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $cLs8t.DropIndicatorContext),
                {
                    render: $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxDropIndicatorWrapper
                }
            ],
            [
                (0, $8dzVy.SectionContext),
                {
                    name: 'ListBoxSection',
                    render: $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxSectionInner
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
        collection: collection,
        scrollRef: listBoxRef,
        persistedKeys: (0, $cLs8t.useDndPersistedKeys)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $cLs8t.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
function $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxSectionInner(props, ref, section, className = 'react-aria-ListBoxSection') {
    let state = (0, $eF4cA.useContext)($f80e6972bb02c67c$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let { CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let [headingRef, heading] = (0, $fDYaM.useSlot)();
    let { headingProps: headingProps, groupProps: groupProps } = (0, $ht1Hx.useListBoxSection)({
        heading: heading,
        'aria-label': props['aria-label'] ?? undefined
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: className,
        values: undefined
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).section, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $1etmN.HeaderContext).Provider, {
        value: {
            ...headingProps,
            ref: headingRef
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section,
        renderDropIndicator: (0, $cLs8t.useRenderDropIndicator)(dragAndDropHooks, dropState)
    })));
}
const $f80e6972bb02c67c$export$dca12b0bb56e4fc = (0, $3g2oV.createBranchComponent)((0, $bWhaY.SectionNode), $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxSectionInner);
const $f80e6972bb02c67c$export$a11e76429ed99b4 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.ItemNode), function ListBoxItem(props, forwardedRef, item) {
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let state = (0, $eF4cA.useContext)($f80e6972bb02c67c$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let isDraggable = dragState && !(dragState.isDisabled || dragState.selectionManager.isDisabled(item.key));
    let { optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps, ...states } = (0, $5bJVF.useOption)({
        key: item.key,
        'aria-label': props?.['aria-label']
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction && !isDraggable,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)(props);
    let { focusProps: focusProps } = (0, $4bE7h.useFocus)(props);
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasAction: states.hasAction
    }, dragState);
    let droppableItem = null;
    if (dropState && dragAndDropHooks) droppableItem = dragAndDropHooks.useDroppableItem({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, ref);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: props.children,
        defaultClassName: 'react-aria-ListBoxItem',
        values: {
            ...states,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: droppableItem?.isDropTarget
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let ElementType = props.href ? (0, $fDYaM.dom).a : (0, $fDYaM.dom).div;
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    if (props.href && optionProps.tabIndex == null) optionProps.tabIndex = -1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, optionProps, hoverProps, keyboardProps, focusProps, draggableItem?.dragProps, droppableItem?.dropProps),
        ref: ref,
        "data-allows-dragging": !!dragState || undefined,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": droppableItem?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $hUj7u.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});
function $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxDropIndicatorWrapper(props, ref) {
    ref = (0, $26CkO.useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref
    });
}
function $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, ...otherProps } = props;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...dropIndicatorProps,
        ...renderProps,
        role: "option",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }));
}
const $f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxDropIndicatorForwardRef = (0, $eF4cA.forwardRef)($f80e6972bb02c67c$var$$928221da08ecbc62$var$ListBoxDropIndicator);
const $f80e6972bb02c67c$export$8e6d031a08cf56a1 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.LoaderNode), function ListBoxLoadingIndicator(props, ref, item) {
    let state = (0, $eF4cA.useContext)($f80e6972bb02c67c$export$7c5906fe4f1f2af2);
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $eF4cA.useRef)(null);
    let memoedLoadMoreProps = (0, $eF4cA.useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, $lJdzA.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-ListBoxLoadingIndicator',
        values: undefined
    });
    let optionProps = {
        // For Android talkback
        tabIndex: -1
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $gF3YT.inertValue)(true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), optionProps),
        ...renderProps,
        // aria-selected isn't needed here since this option is not selectable.
        role: "option",
        ref: ref
    }, renderProps.children)));
});

});
parcelRegister("cLs8t", function(module, exports) {

$parcel$export(module.exports, "DragAndDropContext", () => $53d7a6967f2bb676$export$d188a835a7bc5783);
$parcel$export(module.exports, "DropIndicatorContext", () => $53d7a6967f2bb676$export$f55761759794cf55);
$parcel$export(module.exports, "DropIndicator", () => $53d7a6967f2bb676$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "useRenderDropIndicator", () => $53d7a6967f2bb676$export$971707d8a129a1f7);
$parcel$export(module.exports, "useDndPersistedKeys", () => $53d7a6967f2bb676$export$d1e8e3fbb7461f6);

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $53d7a6967f2bb676$export$d188a835a7bc5783 = (0, $eF4cA.createContext)({});
const $53d7a6967f2bb676$export$f55761759794cf55 = (0, $eF4cA.createContext)(null);
const $53d7a6967f2bb676$export$62ed72bc21f6b8a6 = (0, $eF4cA.forwardRef)(function DropIndicator(props, ref) {
    let { render: render } = (0, $eF4cA.useContext)($53d7a6967f2bb676$export$f55761759794cf55);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, render(props, ref));
});
function $53d7a6967f2bb676$export$971707d8a129a1f7(dragAndDropHooks, dropState) {
    let renderDropIndicator = dragAndDropHooks?.renderDropIndicator;
    let isVirtualDragging = dragAndDropHooks?.isVirtualDragging?.();
    let fn = (0, $eF4cA.useCallback)((target)=>{
        // Only show drop indicators when virtual dragging or this is the current drop target.
        // oxlint-disable-next-line react/react-compiler
        if (isVirtualDragging || dropState?.isDropTarget(target)) return renderDropIndicator ? renderDropIndicator(target) : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($53d7a6967f2bb676$export$62ed72bc21f6b8a6, {
            target: target
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dropState?.target,
        isVirtualDragging,
        renderDropIndicator
    ]);
    return dragAndDropHooks?.useDropIndicator ? fn : undefined;
}
function $53d7a6967f2bb676$export$d1e8e3fbb7461f6(selectionManager, dragAndDropHooks, dropState) {
    // Persist the focused key and the drop target key.
    let focusedKey = selectionManager.focusedKey;
    let dropTargetKey = null;
    if (dragAndDropHooks?.isVirtualDragging?.() && dropState?.target?.type === 'item') {
        dropTargetKey = dropState.target.key;
        if (dropState.target.dropPosition === 'after') {
            // Normalize to the "before" drop position since we only render those to the DOM.
            let nextKey = dropState.collection.getKeyAfter(dropTargetKey);
            let lastDescendantKey = null;
            if (nextKey != null) {
                let targetLevel = dropState.collection.getItem(dropTargetKey)?.level ?? 0;
                // Skip over any rows that are descendants of the target ("after" position should be after all children)
                while(nextKey != null){
                    let node = dropState.collection.getItem(nextKey);
                    // eslint-disable-next-line max-depth
                    if (!node) break;
                    // Skip over non-item nodes (e.g., loaders) since they can't be drop targets.
                    // eslint-disable-next-line max-depth
                    if (node.type !== 'item') {
                        nextKey = dropState.collection.getKeyAfter(nextKey);
                        continue;
                    }
                    // Stop once we find an item at the same level or higher
                    // eslint-disable-next-line max-depth
                    if ((node.level ?? 0) <= targetLevel) break;
                    lastDescendantKey = nextKey;
                    nextKey = dropState.collection.getKeyAfter(nextKey);
                }
            }
            // If nextKey is null (end of collection), use the last descendant
            dropTargetKey = nextKey ?? lastDescendantKey ?? dropTargetKey;
        }
    }
    return (0, $eF4cA.useMemo)(()=>{
        return new Set([
            focusedKey,
            dropTargetKey
        ].filter((k)=>k != null));
    }, [
        focusedKey,
        dropTargetKey
    ]);
}

});

parcelRegister("dkNZi", function(module, exports) {

$parcel$export(module.exports, "useListBox", () => $102858e62504db33$export$50eacbbf140a3141);

var $fVfXf = parcelRequire("fVfXf");

var $bmNeG = parcelRequire("bmNeG");

var $lhKAD = parcelRequire("lhKAD");

var $i1DSg = parcelRequire("i1DSg");

var $25dFS = parcelRequire("25dFS");

var $jrZXQ = parcelRequire("jrZXQ");

var $jePNV = parcelRequire("jePNV");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $102858e62504db33$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || 'toggle';
    let orientation = props.orientation || 'vertical';
    let linkBehavior = props.linkBehavior || (selectionBehavior === 'replace' ? 'action' : 'override');
    if (selectionBehavior === 'toggle' && linkBehavior === 'action') // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = 'override';
    let { listProps: listProps } = (0, $jePNV.useSelectableList)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $25dFS.useId)(props.id);
    (0, $bmNeG.listData).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior,
        // @ts-ignore
        UNSTABLE_itemBehavior: props['UNSTABLE_itemBehavior']
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $jrZXQ.useLabel)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $lhKAD.mergeProps)(domProps, focusWithinProps, state.selectionManager.selectionMode === 'multiple' ? {
            'aria-multiselectable': 'true'
        } : {}, {
            role: 'listbox',
            'aria-orientation': orientation,
            ...(0, $lhKAD.mergeProps)(fieldProps, listProps)
        })
    };
}

});
parcelRegister("bmNeG", function(module, exports) {

$parcel$export(module.exports, "listData", () => $4558858689061556$export$3585ede4d035bf14);
$parcel$export(module.exports, "getItemId", () => $4558858689061556$export$9145995848b05025);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4558858689061556$export$3585ede4d035bf14 = new WeakMap();
function $4558858689061556$var$$cd088b5c0d7b27b4$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $4558858689061556$export$9145995848b05025(state, itemKey) {
    let data = $4558858689061556$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error('Unknown list');
    return `${data.id}-option-${$4558858689061556$var$$cd088b5c0d7b27b4$var$normalizeKey(itemKey)}`;
}

});


parcelRegister("ht1Hx", function(module, exports) {

$parcel$export(module.exports, "useListBoxSection", () => $a2a37515756f17a9$export$c3f9f39876e4bc7);

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a2a37515756f17a9$export$c3f9f39876e4bc7(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $25dFS.useId)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Technically, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: 'presentation',
            onMouseDown: (e)=>{
                // Prevent DOM focus from moving on mouse down when using virtual focus
                e.preventDefault();
            }
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

});

parcelRegister("5bJVF", function(module, exports) {

$parcel$export(module.exports, "useOption", () => $d7bf5664df64a297$export$497855f14858aa34);

var $d8j5I = parcelRequire("d8j5I");

var $fVfXf = parcelRequire("fVfXf");

var $bmNeG = parcelRequire("bmNeG");

var $YxOvP = parcelRequire("YxOvP");

var $lhKAD = parcelRequire("lhKAD");

var $hNw9N = parcelRequire("hNw9N");

var $j2JDe = parcelRequire("j2JDe");

var $aGgVM = parcelRequire("aGgVM");

var $25dFS = parcelRequire("25dFS");

var $4vRK0 = parcelRequire("4vRK0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d7bf5664df64a297$export$497855f14858aa34(props, state, ref) {
    let { key: key } = props;
    let data = (0, $bmNeG.listData).get(state);
    let isDisabled = props.isDisabled ?? state.selectionManager.isDisabled(key);
    let isSelected = props.isSelected ?? state.selectionManager.isSelected(key);
    let shouldSelectOnPressUp = props.shouldSelectOnPressUp ?? data?.shouldSelectOnPressUp;
    let shouldFocusOnHover = props.shouldFocusOnHover ?? data?.shouldFocusOnHover;
    let shouldUseVirtualFocus = props.shouldUseVirtualFocus ?? data?.shouldUseVirtualFocus;
    let isVirtualized = props.isVirtualized ?? data?.isVirtualized;
    let labelId = (0, $25dFS.useSlotId)();
    let descriptionId = (0, $25dFS.useSlotId)();
    let optionProps = {
        role: 'option',
        'aria-disabled': isDisabled || undefined,
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': descriptionId
    };
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item?.index);
        optionProps['aria-posinset'] = Number.isNaN(index) ? undefined : index + 1;
        optionProps['aria-setsize'] = (0, $4vRK0.getItemCount)(state.collection);
    }
    let onAction = data?.onAction ? ()=>data?.onAction?.(key) : undefined;
    let id = (0, $bmNeG.getItemId)(state, key);
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $hNw9N.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: onAction || item?.props?.onAction ? (0, $d8j5I.chain)(item?.props?.onAction, onAction) : undefined,
        linkBehavior: data?.linkBehavior,
        // @ts-ignore
        UNSTABLE_itemBehavior: data?.['UNSTABLE_itemBehavior'],
        id: id
    });
    let { hoverProps: hoverProps } = (0, $j2JDe.useHover)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $YxOvP.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $fVfXf.filterDOMProps)(item?.props);
    delete domProps.id;
    let linkProps = (0, $aGgVM.useLinkProps)(item?.props);
    return {
        optionProps: {
            ...optionProps,
            ...(0, $lhKAD.mergeProps)(domProps, itemProps, hoverProps, linkProps),
            id: id
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && state.selectionManager.isFocused && (0, $YxOvP.isFocusVisible)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}

});

parcelRegister("fHi9W", function(module, exports) {

$parcel$export(module.exports, "useListState", () => $644d70da9c57131c$export$2f645645f7bca764);
$parcel$export(module.exports, "UNSTABLE_useFilteredListState", () => $644d70da9c57131c$export$ba9d38c0f1bf2b36);

var $hIeYt = parcelRequire("hIeYt");

var $fAqsC = parcelRequire("fAqsC");

var $dWVHy = parcelRequire("dWVHy");

var $94DDV = parcelRequire("94DDV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $644d70da9c57131c$export$2f645645f7bca764(props) {
    let { filter: filter, layoutDelegate: layoutDelegate } = props;
    let selectionState = (0, $fAqsC.useMultipleSelectionState)(props);
    let disabledKeys = (0, $eF4cA.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $eF4cA.useCallback)((nodes)=>filter ? new (0, $hIeYt.ListCollection)(filter(nodes)) : new (0, $hIeYt.ListCollection)(nodes), [
        filter
    ]);
    let context = (0, $eF4cA.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $94DDV.useCollection)(props, factory, context);
    let selectionManager = (0, $eF4cA.useMemo)(()=>new (0, $dWVHy.SelectionManager)(collection, selectionState, {
            layoutDelegate: layoutDelegate
        }), [
        collection,
        selectionState,
        layoutDelegate
    ]);
    $644d70da9c57131c$var$$b14b6f590b50af39$var$useFocusedKeyReset(collection, selectionManager);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
function $644d70da9c57131c$export$ba9d38c0f1bf2b36(state, filterFn) {
    let collection = (0, $eF4cA.useMemo)(()=>filterFn ? state.collection.filter(filterFn) : state.collection, [
        state.collection,
        filterFn
    ]);
    let selectionManager = state.selectionManager.withCollection(collection);
    $644d70da9c57131c$var$$b14b6f590b50af39$var$useFocusedKeyReset(collection, selectionManager);
    return {
        collection: collection,
        selectionManager: selectionManager,
        disabledKeys: state.disabledKeys
    };
}
function $644d70da9c57131c$var$$b14b6f590b50af39$var$useFocusedKeyReset(collection, selectionManager) {
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (selectionManager.focusedKey != null && !collection.getItem(selectionManager.focusedKey) && cachedCollection.current) {
            // Walk forward in the old collection to find the next key that still exists in the new collection.
            let key = cachedCollection.current.getKeyAfter(selectionManager.focusedKey);
            let nextFocusedKey = null;
            while(key != null){
                let node = collection.getItem(key);
                if (node && node.type === 'item' && !selectionManager.isDisabled(key)) {
                    nextFocusedKey = key;
                    break;
                }
                key = cachedCollection.current.getKeyAfter(key);
            }
            // If no such key exists, walk backward.
            if (nextFocusedKey == null) {
                key = cachedCollection.current.getKeyBefore(selectionManager.focusedKey);
                while(key != null){
                    let node = collection.getItem(key);
                    if (node && node.type === 'item' && !selectionManager.isDisabled(key)) {
                        nextFocusedKey = key;
                        break;
                    }
                    key = cachedCollection.current.getKeyBefore(key);
                }
            }
            selectionManager.setFocusedKey(nextFocusedKey);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager
    ]);
}

});
parcelRegister("hIeYt", function(module, exports) {

$parcel$export(module.exports, "ListCollection", () => $eaa35a4f4bb7e030$export$d085fb9e920b5ca7);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $eaa35a4f4bb7e030$export$d085fb9e920b5ca7 {
    constructor(nodes){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === 'section') for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        let size = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            // Only count sections and items when determining size so that
            // loaders and separators in RAC/S2 don't influence the emptyState determination
            if (node.type === 'section' || node.type === 'item') size++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this._size = size;
        this.lastKey = last?.key ?? null;
    }
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey ?? null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey ?? null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return node?.childNodes || [];
    }
}

});



parcelRegister("aOQtg", function(module, exports) {

$parcel$export(module.exports, "useTag", () => $b0faa6fc75e36082$export$3f568fff7dff2f03);

var $fVfXf = parcelRequire("fVfXf");

var $7Mkiz = parcelRequire("7Mkiz");

var $2Mr33 = parcelRequire("2Mr33");

var $lhKAD = parcelRequire("lhKAD");

var $lXRQr = parcelRequire("lXRQr");

var $8M8Qw = parcelRequire("8M8Qw");

var $8HLWT = parcelRequire("8HLWT");

var $25dFS = parcelRequire("25dFS");

var $YxOvP = parcelRequire("YxOvP");

var $aGDvF = parcelRequire("aGDvF");

var $gI8Gw = parcelRequire("gI8Gw");

var $aGgVM = parcelRequire("aGgVM");
function $b0faa6fc75e36082$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b0faa6fc75e36082$export$3f568fff7dff2f03(props, state, ref) {
    let { item: item } = props;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($b0faa6fc75e36082$var$$parcel$interopDefault((0, $2Mr33.default)), '@react-aria/tag');
    let buttonId = (0, $25dFS.useId)();
    let { onRemove: onRemove } = (0, $7Mkiz.hookData).get(state) || {};
    let { rowProps: rowProps, gridCellProps: gridCellProps, ...states } = (0, $8HLWT.useGridListItem)({
        node: item
    }, state, ref);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { descriptionProps: _, ...stateWithoutDescription } = states;
    let isDisabled = state.disabledKeys.has(item.key) || item.props.isDisabled;
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        isDisabled: isDisabled,
        shortcuts: {
            Delete: ()=>{
                if (state.selectionManager.isSelected(item.key)) onRemove?.(new Set(state.selectionManager.selectedKeys));
                else onRemove?.(new Set([
                    item.key
                ]));
            },
            Backspace: ()=>{
                if (state.selectionManager.isSelected(item.key)) onRemove?.(new Set(state.selectionManager.selectedKeys));
                else onRemove?.(new Set([
                    item.key
                ]));
            }
        },
        allowRepeats: true
    });
    let modality = (0, $YxOvP.useInteractionModality)();
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'pointer';
    let description = onRemove && (modality === 'keyboard' || modality === 'virtual') ? stringFormatter.format('removeDescription') : '';
    let descProps = (0, $lXRQr.useDescription)(description);
    let isItemFocused = item.key === state.selectionManager.focusedKey;
    let isFocused = state.selectionManager.focusedKey != null;
    let tabIndex = -1;
    if (!isDisabled && (isItemFocused || !isFocused)) tabIndex = 0;
    let domProps = (0, $fVfXf.filterDOMProps)(item.props);
    let linkProps = (0, $aGgVM.useSyntheticLinkProps)(item.props);
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)({
        ...item.props,
        isDisabled: isDisabled
    }, ref);
    return {
        removeButtonProps: {
            'aria-label': stringFormatter.format('removeButtonLabel'),
            'aria-labelledby': `${buttonId} ${rowProps.id}`,
            isDisabled: isDisabled,
            id: buttonId,
            onPress: ()=>onRemove ? onRemove(new Set([
                    item.key
                ])) : null
        },
        rowProps: (0, $lhKAD.mergeProps)(focusableProps, rowProps, domProps, linkProps, {
            tabIndex: tabIndex,
            ...onRemove ? keyboardProps : {},
            'aria-describedby': descProps['aria-describedby']
        }),
        gridCellProps: (0, $lhKAD.mergeProps)(gridCellProps, {
            'aria-errormessage': props['aria-errormessage'],
            'aria-label': props['aria-label']
        }),
        ...stateWithoutDescription,
        allowsRemoving: !!onRemove
    };
}

});
parcelRegister("7Mkiz", function(module, exports) {

$parcel$export(module.exports, "hookData", () => $d9766a505a11813a$export$653eddfc964b0f8a);
$parcel$export(module.exports, "useTagGroup", () => $d9766a505a11813a$export$4f8b5cda58b7e8ff);

var $fvrZl = parcelRequire("fvrZl");

var $fVfXf = parcelRequire("fVfXf");

var $daM4n = parcelRequire("daM4n");

var $lhKAD = parcelRequire("lhKAD");

var $cI1qR = parcelRequire("cI1qR");

var $i1DSg = parcelRequire("i1DSg");

var $1ntKq = parcelRequire("1ntKq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d9766a505a11813a$export$653eddfc964b0f8a = new WeakMap();
function $d9766a505a11813a$export$4f8b5cda58b7e8ff(props, state, ref) {
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let keyboardDelegate = props.keyboardDelegate || new (0, $daM4n.ListKeyboardDelegate)({
        collection: state.collection,
        ref: ref,
        orientation: 'horizontal',
        direction: direction,
        disabledKeys: state.disabledKeys,
        disabledBehavior: state.selectionManager.disabledBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        labelElementType: 'span'
    });
    let { gridProps: gridProps } = (0, $fvrZl.useGridList)({
        ...props,
        ...fieldProps,
        keyboardDelegate: keyboardDelegate,
        shouldFocusWrap: true,
        linkBehavior: 'override',
        keyboardNavigationBehavior: 'tab'
    }, state, ref);
    let [isFocusWithin, setFocusWithin] = (0, $eF4cA.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        onFocusWithinChange: setFocusWithin
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    // If the last tag is removed, focus the container.
    let prevCount = (0, $eF4cA.useRef)(state.collection.size);
    (0, $eF4cA.useEffect)(()=>{
        if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
        prevCount.current = state.collection.size;
    }, [
        state.collection.size,
        isFocusWithin,
        ref
    ]);
    $d9766a505a11813a$export$653eddfc964b0f8a.set(state, {
        onRemove: props.onRemove
    });
    return {
        gridProps: (0, $lhKAD.mergeProps)(gridProps, domProps, {
            role: state.collection.size ? 'grid' : 'group',
            'aria-atomic': false,
            'aria-relevant': 'additions',
            'aria-live': isFocusWithin ? 'polite' : 'off',
            ...focusWithinProps,
            ...fieldProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

});
parcelRegister("fvrZl", function(module, exports) {

$parcel$export(module.exports, "useGridList", () => $a7d969877216b039$export$664f9155035607eb);

var $fVfXf = parcelRequire("fVfXf");

var $7Ydqk = parcelRequire("7Ydqk");

var $lhKAD = parcelRequire("lhKAD");

var $3V5dF = parcelRequire("3V5dF");

var $flpop = parcelRequire("flpop");

var $9ehxp = parcelRequire("9ehxp");

var $25dFS = parcelRequire("25dFS");

var $jePNV = parcelRequire("jePNV");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a7d969877216b039$export$664f9155035607eb(props, state, ref) {
    let { isVirtualized: isVirtualized, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, onAction: onAction, disallowTypeAhead: disallowTypeAhead, linkBehavior: linkBehavior = 'action', keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow', escapeKeyBehavior: escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp: shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps: listProps } = (0, $jePNV.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref: ref,
        keyboardDelegate: keyboardDelegate,
        layoutDelegate: layoutDelegate,
        isVirtualized: isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior: linkBehavior,
        disallowTypeAhead: disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior: escapeKeyBehavior,
        UNSTABLE_focusOnEntry: props.UNSTABLE_focusOnEntry
    });
    let id = (0, $25dFS.useId)(props.id);
    (0, $7Ydqk.listMap).set(state, {
        id: id,
        onAction: onAction,
        linkBehavior: linkBehavior,
        keyboardNavigationBehavior: keyboardNavigationBehavior,
        shouldSelectOnPressUp: shouldSelectOnPressUp
    });
    let descriptionProps = (0, $9ehxp.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, $flpop.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, $lhKAD.mergeProps)(domProps, {
        role: 'grid',
        id: id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, $3V5dF.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps: gridProps
    };
}

});
parcelRegister("7Ydqk", function(module, exports) {

$parcel$export(module.exports, "listMap", () => $77b7783eac175226$export$5b9bb410392e3991);
$parcel$export(module.exports, "getRowId", () => $77b7783eac175226$export$f45c25170b9a99c2);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $77b7783eac175226$export$5b9bb410392e3991 = new WeakMap();
function $77b7783eac175226$export$f45c25170b9a99c2(state, key) {
    let { id: id } = $77b7783eac175226$export$5b9bb410392e3991.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${$77b7783eac175226$export$e0c709538cb8ae18(key)}`;
}
function $77b7783eac175226$export$e0c709538cb8ae18(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

});

parcelRegister("3V5dF", function(module, exports) {

$parcel$export(module.exports, "useGridSelectionAnnouncement", () => $f14ac335ea1f75ff$export$137e594ef3218a10);

var $4HiHF = parcelRequire("4HiHF");

var $bx0ZP = parcelRequire("bx0ZP");

var $gI8Gw = parcelRequire("gI8Gw");

var $lXemd = parcelRequire("lXemd");

var $eF4cA = parcelRequire("eF4cA");
function $f14ac335ea1f75ff$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f14ac335ea1f75ff$export$137e594ef3218a10(props, state) {
    let { getRowText: getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($f14ac335ea1f75ff$var$$parcel$interopDefault((0, $bx0ZP.default)), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, $eF4cA.useRef)(selection);
    let announceSelectionChange = (0, $eF4cA.useCallback)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = $f14ac335ea1f75ff$var$$2b2556a8276954c1$var$diffSelection(selection, lastSelection.current);
        let removedKeys = $f14ac335ea1f75ff$var$$2b2556a8276954c1$var$diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, $4HiHF.announce)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection,
        state.selectionManager.selectedKeys,
        state.selectionManager.isFocused,
        state.selectionManager.selectionBehavior,
        state.selectionManager.selectionMode,
        state.collection,
        getRowText,
        stringFormatter
    ]);
    (0, $lXemd.useUpdateEffect)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function $f14ac335ea1f75ff$var$$2b2556a8276954c1$var$diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

});
parcelRegister("bx0ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f3a29256cc0854$export$2e2bcd8739ae039);

var $etXoM = parcelRequire("etXoM");

var $fvYPB = parcelRequire("fvYPB");

var $8jznG = parcelRequire("8jznG");

var $a1mqm = parcelRequire("a1mqm");

var $geKzP = parcelRequire("geKzP");

var $39PwB = parcelRequire("39PwB");

var $1bjh6 = parcelRequire("1bjh6");

var $5NZ3a = parcelRequire("5NZ3a");

var $jb3QO = parcelRequire("jb3QO");

var $cB8T4 = parcelRequire("cB8T4");

var $caDow = parcelRequire("caDow");

var $j66L1 = parcelRequire("j66L1");

var $dM2I2 = parcelRequire("dM2I2");

var $knqxY = parcelRequire("knqxY");

var $g5XaP = parcelRequire("g5XaP");

var $j2Jq3 = parcelRequire("j2Jq3");

var $azxvr = parcelRequire("azxvr");

var $bMr0a = parcelRequire("bMr0a");

var $3uJiJ = parcelRequire("3uJiJ");

var $k0SiX = parcelRequire("k0SiX");

var $jcpJo = parcelRequire("jcpJo");

var $ddzoS = parcelRequire("ddzoS");

var $3kpgb = parcelRequire("3kpgb");

var $2JPRI = parcelRequire("2JPRI");

var $ahVjG = parcelRequire("ahVjG");

var $1Hdlv = parcelRequire("1Hdlv");

var $jYvCm = parcelRequire("jYvCm");

var $9XITm = parcelRequire("9XITm");

var $3pNWs = parcelRequire("3pNWs");

var $aE41a = parcelRequire("aE41a");

var $jPiEt = parcelRequire("jPiEt");

var $9l7FT = parcelRequire("9l7FT");

var $hBXzs = parcelRequire("hBXzs");

var $dNKZI = parcelRequire("dNKZI");
var $c1f3a29256cc0854$export$2e2bcd8739ae039 = {};
$c1f3a29256cc0854$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $etXoM.default),
    "bg-BG": (0, $fvYPB.default),
    "cs-CZ": (0, $8jznG.default),
    "da-DK": (0, $a1mqm.default),
    "de-DE": (0, $geKzP.default),
    "el-GR": (0, $39PwB.default),
    "en-US": (0, $1bjh6.default),
    "es-ES": (0, $5NZ3a.default),
    "et-EE": (0, $jb3QO.default),
    "fi-FI": (0, $cB8T4.default),
    "fr-FR": (0, $caDow.default),
    "he-IL": (0, $j66L1.default),
    "hr-HR": (0, $dM2I2.default),
    "hu-HU": (0, $knqxY.default),
    "it-IT": (0, $g5XaP.default),
    "ja-JP": (0, $j2Jq3.default),
    "ko-KR": (0, $azxvr.default),
    "lt-LT": (0, $bMr0a.default),
    "lv-LV": (0, $3uJiJ.default),
    "nb-NO": (0, $k0SiX.default),
    "nl-NL": (0, $jcpJo.default),
    "pl-PL": (0, $ddzoS.default),
    "pt-BR": (0, $3kpgb.default),
    "pt-PT": (0, $2JPRI.default),
    "ro-RO": (0, $ahVjG.default),
    "ru-RU": (0, $1Hdlv.default),
    "sk-SK": (0, $jYvCm.default),
    "sl-SI": (0, $9XITm.default),
    "sr-SP": (0, $3pNWs.default),
    "sv-SE": (0, $aE41a.default),
    "tr-TR": (0, $jPiEt.default),
    "uk-UA": (0, $9l7FT.default),
    "zh-CN": (0, $hBXzs.default),
    "zh-TW": (0, $dNKZI.default)
};

});
parcelRegister("etXoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7fb363290ecbdb1$export$2e2bcd8739ae039);
var $a7fb363290ecbdb1$export$2e2bcd8739ae039 = {};
$a7fb363290ecbdb1$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{63A}\u{64A}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "longPressToSelect": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{64B}\u{627} \u{644}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{648}\u{636}\u{639} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}.`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectedAll": `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{627}\u{635}\u{631}`,
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`
};

});

parcelRegister("fvYPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2d0a35211b7a73$export$2e2bcd8739ae039);
var $ef2d0a35211b7a73$export$2e2bcd8739ae039 = {};
$ef2d0a35211b7a73$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{435} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{438} \u{437}\u{430}\u{434}\u{440}\u{44A}\u{436}\u{442}\u{435} \u{437}\u{430} \u{434}\u{430} \u{432}\u{43B}\u{435}\u{437}\u{435}\u{442}\u{435} \u{432} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43D} \u{440}\u{435}\u{436}\u{438}\u{43C}.`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`
};

});

parcelRegister("8jznG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade0a184c71df009$export$2e2bcd8739ae039);
var $ade0a184c71df009$export$2e2bcd8739ae039 = {};
$ade0a184c71df009$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Polo\u{17E}ka ${args.item} nen\xed vybr\xe1na.`,
    "longPressToSelect": `Dlouh\xfdm stisknut\xedm p\u{159}ejdete do re\u{17E}imu v\xfdb\u{11B}ru.`,
    "select": `Vybrat`,
    "selectedAll": `Vybr\xe1ny v\u{161}echny polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nevybr\xe1ny \u{17E}\xe1dn\xe9 polo\u{17E}ky`,
            one: ()=>`Vybr\xe1na ${formatter.number(args.count)} polo\u{17E}ka`,
            other: ()=>`Vybr\xe1no ${formatter.number(args.count)} polo\u{17E}ek`
        })}.`,
    "selectedItem": (args)=>`Vybr\xe1na polo\u{17E}ka ${args.item}.`
};

});

parcelRegister("a1mqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca5d2a1322e07bb$export$2e2bcd8739ae039);
var $dca5d2a1322e07bb$export$2e2bcd8739ae039 = {};
$dca5d2a1322e07bb$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ikke valgt.`,
    "longPressToSelect": `Lav et langt tryk for at aktivere valgtilstand.`,
    "select": `V\xe6lg`,
    "selectedAll": `Alle elementer valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer valgt`,
            one: ()=>`${formatter.number(args.count)} element valgt`,
            other: ()=>`${formatter.number(args.count)} elementer valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} valgt.`
};

});

parcelRegister("geKzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2951bdf2ddad6e$export$2e2bcd8739ae039);
var $ef2951bdf2ddad6e$export$2e2bcd8739ae039 = {};
$ef2951bdf2ddad6e$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nicht ausgew\xe4hlt.`,
    "longPressToSelect": `Gedr\xfcckt halten, um Auswahlmodus zu \xf6ffnen.`,
    "select": `Ausw\xe4hlen`,
    "selectedAll": `Alle Elemente ausgew\xe4hlt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Keine Elemente ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} Element ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} Elemente ausgew\xe4hlt`
        })}.`,
    "selectedItem": (args)=>`${args.item} ausgew\xe4hlt.`
};

});

parcelRegister("39PwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a930b1ea6be790ea$export$2e2bcd8739ae039);
var $a930b1ea6be790ea$export$2e2bcd8739ae039 = {};
$a930b1ea6be790ea$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`,
    "longPressToSelect": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3C0}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3BB}\u{3B5}\u{3B9}\u{3C4}\u{3BF}\u{3C5}\u{3C1}\u{3B3}\u{3AF}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}.`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1} \u{3C4}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
            one: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "selectedItem": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`
};

});

parcelRegister("1bjh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f21bc6dc51ab4f3$export$2e2bcd8739ae039);
var $4f21bc6dc51ab4f3$export$2e2bcd8739ae039 = {};
$4f21bc6dc51ab4f3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

});

parcelRegister("5NZ3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $6774442b6967d236$export$2e2bcd8739ae039);
var $6774442b6967d236$export$2e2bcd8739ae039 = {};
$6774442b6967d236$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} no seleccionado.`,
    "longPressToSelect": `Mantenga pulsado para abrir el modo de selecci\xf3n.`,
    "select": `Seleccionar`,
    "selectedAll": `Todos los elementos seleccionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ning\xfan elemento seleccionado`,
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} seleccionado.`
};

});

parcelRegister("jb3QO", function(module, exports) {

$parcel$export(module.exports, "default", () => $468e75f511109d0f$export$2e2bcd8739ae039);
var $468e75f511109d0f$export$2e2bcd8739ae039 = {};
$468e75f511109d0f$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} pole valitud.`,
    "longPressToSelect": `Valikure\u{17E}iimi sisenemiseks vajutage pikalt.`,
    "select": `Vali`,
    "selectedAll": `K\xf5ik \xfcksused valitud.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\xdcksusi pole valitud`,
            one: ()=>`${formatter.number(args.count)} \xfcksus valitud`,
            other: ()=>`${formatter.number(args.count)} \xfcksust valitud`
        })}.`,
    "selectedItem": (args)=>`${args.item} valitud.`
};

});

parcelRegister("cB8T4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8233c23263a117f2$export$2e2bcd8739ae039);
var $8233c23263a117f2$export$2e2bcd8739ae039 = {};
$8233c23263a117f2$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Kohdetta ${args.item} ei valittu.`,
    "longPressToSelect": `Siirry valintatilaan painamalla pitk\xe4\xe4n.`,
    "select": `Valitse`,
    "selectedAll": `Kaikki kohteet valittu.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei yht\xe4\xe4n kohdetta valittu`,
            one: ()=>`${formatter.number(args.count)} kohde valittu`,
            other: ()=>`${formatter.number(args.count)} kohdetta valittu`
        })}.`,
    "selectedItem": (args)=>`${args.item} valittu.`
};

});

parcelRegister("caDow", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f776a595a33608d$export$2e2bcd8739ae039);
var $0f776a595a33608d$export$2e2bcd8739ae039 = {};
$0f776a595a33608d$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non s\xe9lectionn\xe9.`,
    "longPressToSelect": `Appuyez de mani\xe8re prolong\xe9e pour passer en mode de s\xe9lection.`,
    "select": `S\xe9lectionner`,
    "selectedAll": `Tous les \xe9l\xe9ments s\xe9lectionn\xe9s.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "selectedItem": (args)=>`${args.item} s\xe9lectionn\xe9.`
};

});

parcelRegister("j66L1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf4e8dbb6cf3a1a$export$2e2bcd8739ae039);
var $fcf4e8dbb6cf3a1a$export$2e2bcd8739ae039 = {};
$fcf4e8dbb6cf3a1a$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`,
    "longPressToSelect": `\u{5D4}\u{5E7}\u{5E9}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DC}\u{5DB}\u{5E0}\u{5D9}\u{5E1}\u{5D4} \u{5DC}\u{5DE}\u{5E6}\u{5D1} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}.`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD}`,
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} ${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`
};

});

parcelRegister("dM2I2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea78b379839340c$export$2e2bcd8739ae039);
var $fea78b379839340c$export$2e2bcd8739ae039 = {};
$fea78b379839340c$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Stavka ${args.item} nije odabrana.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u na\u{10D}in odabira.`,
    "select": `Odaberite`,
    "selectedAll": `Odabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije odabrana nijedna stavka`,
            one: ()=>`Odabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Odabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`Stavka ${args.item} je odabrana.`
};

});

parcelRegister("knqxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7160214deb617b$export$2e2bcd8739ae039);
var $bc7160214deb617b$export$2e2bcd8739ae039 = {};
$bc7160214deb617b$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nincs kijel\xf6lve.`,
    "longPressToSelect": `Nyomja hosszan a kijel\xf6l\xe9shez.`,
    "select": `Kijel\xf6l\xe9s`,
    "selectedAll": `Az \xf6sszes elem kijel\xf6lve.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy elem sincs kijel\xf6lve`,
            one: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`
        })}.`,
    "selectedItem": (args)=>`${args.item} kijel\xf6lve.`
};

});

parcelRegister("g5XaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $754d7c7390ce07e3$export$2e2bcd8739ae039);
var $754d7c7390ce07e3$export$2e2bcd8739ae039 = {};
$754d7c7390ce07e3$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non selezionato.`,
    "longPressToSelect": `Premi a lungo per passare alla modalit\xe0 di selezione.`,
    "select": `Seleziona`,
    "selectedAll": `Tutti gli elementi selezionati.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessun elemento selezionato`,
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "selectedItem": (args)=>`${args.item} selezionato.`
};

});

parcelRegister("j2Jq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $319c3d9355544182$export$2e2bcd8739ae039);
var $319c3d9355544182$export$2e2bcd8739ae039 = {};
$319c3d9355544182$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{9078}\u{629E}\u{30E2}\u{30FC}\u{30C9}\u{3092}\u{958B}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "select": `\u{9078}\u{629E}`,
    "selectedAll": `\u{3059}\u{3079}\u{3066}\u{306E}\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9805}\u{76EE}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            one: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`,
            other: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}\u{3002}`,
    "selectedItem": (args)=>`${args.item} \u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`
};

});

parcelRegister("azxvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $30129fa5b35230d8$export$2e2bcd8739ae039);
var $30129fa5b35230d8$export$2e2bcd8739ae039 = {};
$30129fa5b35230d8$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "longPressToSelect": `\u{C120}\u{D0DD} \u{BAA8}\u{B4DC}\u{B85C} \u{B4E4}\u{C5B4}\u{AC00}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectedAll": `\u{BAA8}\u{B4E0} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`
        })}.`,
    "selectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`
};

});

parcelRegister("bMr0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7cf907bb96482bd$export$2e2bcd8739ae039);
var $e7cf907bb96482bd$export$2e2bcd8739ae039 = {};
$e7cf907bb96482bd$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nepasirinkta.`,
    "longPressToSelect": `Nor\u{117}dami \u{12F}jungti pasirinkimo re\u{17E}im\u{105}, paspauskite ir palaikykite.`,
    "select": `Pasirinkti`,
    "selectedAll": `Pasirinkti visi elementai.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nepasirinktas n\u{117} vienas elementas`,
            one: ()=>`Pasirinktas ${formatter.number(args.count)} elementas`,
            other: ()=>`Pasirinkta element\u{173}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Pasirinkta: ${args.item}.`
};

});

parcelRegister("3uJiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2d5a6f2fbf6c90$export$2e2bcd8739ae039);
var $5a2d5a6f2fbf6c90$export$2e2bcd8739ae039 = {};
$5a2d5a6f2fbf6c90$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Vienums ${args.item} nav atlas\u{12B}ts.`,
    "longPressToSelect": `Ilgi turiet nospiestu. lai iesl\u{113}gtu atlases re\u{17E}\u{12B}mu.`,
    "select": `Atlas\u{12B}t`,
    "selectedAll": `Atlas\u{12B}ti visi vienumi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts neviens vienums`,
            one: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`,
            other: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Atlas\u{12B}ts vienums ${args.item}.`
};

});

parcelRegister("k0SiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $02306e33bdf114f6$export$2e2bcd8739ae039);
var $02306e33bdf114f6$export$2e2bcd8739ae039 = {};
$02306e33bdf114f6$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} er ikke valgt.`,
    "longPressToSelect": `Bruk et langt trykk for \xe5 g\xe5 inn i valgmodus.`,
    "select": `Velg`,
    "selectedAll": `Alle elementer er valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer er valgt`,
            one: ()=>`${formatter.number(args.count)} element er valgt`,
            other: ()=>`${formatter.number(args.count)} elementer er valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} er valgt.`
};

});

parcelRegister("jcpJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $43484eb23794f5a9$export$2e2bcd8739ae039);
var $43484eb23794f5a9$export$2e2bcd8739ae039 = {};
$43484eb23794f5a9$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} niet geselecteerd.`,
    "longPressToSelect": `Druk lang om de selectiemodus te openen.`,
    "select": `Selecteren`,
    "selectedAll": `Alle items geselecteerd.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Geen items geselecteerd`,
            one: ()=>`${formatter.number(args.count)} item geselecteerd`,
            other: ()=>`${formatter.number(args.count)} items geselecteerd`
        })}.`,
    "selectedItem": (args)=>`${args.item} geselecteerd.`
};

});

parcelRegister("ddzoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d21eebebb312667$export$2e2bcd8739ae039);
var $2d21eebebb312667$export$2e2bcd8739ae039 = {};
$2d21eebebb312667$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nie zaznaczono ${args.item}.`,
    "longPressToSelect": `Naci\u{15B}nij i przytrzymaj, aby wej\u{15B}\u{107} do trybu wyboru.`,
    "select": `Zaznacz`,
    "selectedAll": `Wszystkie zaznaczone elementy.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nie zaznaczono \u{17C}adnych element\xf3w`,
            one: ()=>`${formatter.number(args.count)} zaznaczony element`,
            other: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`
        })}.`,
    "selectedItem": (args)=>`Zaznaczono ${args.item}.`
};

});

parcelRegister("3kpgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5d9cbb51477e41$export$2e2bcd8739ae039);
var $1f5d9cbb51477e41$export$2e2bcd8739ae039 = {};
$1f5d9cbb51477e41$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Mantenha pressionado para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};

});

parcelRegister("2JPRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e5503ff3fc64ad$export$2e2bcd8739ae039);
var $21e5503ff3fc64ad$export$2e2bcd8739ae039 = {};
$21e5503ff3fc64ad$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Prima continuamente para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};

});

parcelRegister("ahVjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c56fe2f7a0a728d2$export$2e2bcd8739ae039);
var $c56fe2f7a0a728d2$export$2e2bcd8739ae039 = {};
$c56fe2f7a0a728d2$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} neselectat.`,
    "longPressToSelect": `Ap\u{103}sa\u{21B}i lung pentru a intra \xeen modul de selectare.`,
    "select": `Selectare`,
    "selectedAll": `Toate elementele selectate.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciun element selectat`,
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "selectedItem": (args)=>`${args.item} selectat.`
};

});

parcelRegister("1Hdlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $123f8bf3fde6571c$export$2e2bcd8739ae039);
var $123f8bf3fde6571c$export$2e2bcd8739ae039 = {};
$123f8bf3fde6571c$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}.`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{44B} \u{432}\u{441}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
            one: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};

});

parcelRegister("jYvCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $88dde5c0d166767b$export$2e2bcd8739ae039);
var $88dde5c0d166767b$export$2e2bcd8739ae039 = {};
$88dde5c0d166767b$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nevybrat\xe9 polo\u{17E}ky: ${args.item}.`,
    "longPressToSelect": `Dlh\u{161}\xedm stla\u{10D}en\xedm prejdite do re\u{17E}imu v\xfdberu.`,
    "select": `Vybra\u{165}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{17D}iadne vybrat\xe9 polo\u{17E}ky`,
            one: ()=>`${formatter.number(args.count)} vybrat\xe1 polo\u{17E}ka`,
            other: ()=>`Po\u{10D}et vybrat\xfdch polo\u{17E}iek:${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Vybrat\xe9 polo\u{17E}ky: ${args.item}.`
};

});

parcelRegister("9XITm", function(module, exports) {

$parcel$export(module.exports, "default", () => $033bde00759506cf$export$2e2bcd8739ae039);
var $033bde00759506cf$export$2e2bcd8739ae039 = {};
$033bde00759506cf$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Element ${args.item} ni izbran.`,
    "longPressToSelect": `Za izbirni na\u{10D}in pritisnite in dlje \u{10D}asa dr\u{17E}ite.`,
    "select": `Izberite`,
    "selectedAll": `Vsi elementi so izbrani.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Noben element ni izbran`,
            one: ()=>`${formatter.number(args.count)} element je izbran`,
            other: ()=>`${formatter.number(args.count)} elementov je izbranih`
        })}.`,
    "selectedItem": (args)=>`Element ${args.item} je izbran.`
};

});

parcelRegister("3pNWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $96621ac697a2f06e$export$2e2bcd8739ae039);
var $96621ac697a2f06e$export$2e2bcd8739ae039 = {};
$96621ac697a2f06e$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nije izabrano.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u re\u{17E}im biranja.`,
    "select": `Izaberite`,
    "selectedAll": `Izabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije izabrana nijedna stavka`,
            one: ()=>`Izabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Izabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`${args.item} je izabrano.`
};

});

parcelRegister("aE41a", function(module, exports) {

$parcel$export(module.exports, "default", () => $47c714b1474392de$export$2e2bcd8739ae039);
var $47c714b1474392de$export$2e2bcd8739ae039 = {};
$47c714b1474392de$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ej markerat.`,
    "longPressToSelect": `Tryck l\xe4nge n\xe4r du vill \xf6ppna v\xe4ljarl\xe4ge.`,
    "select": `Markera`,
    "selectedAll": `Alla markerade objekt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga markerade objekt`,
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "selectedItem": (args)=>`${args.item} markerat.`
};

});

parcelRegister("jPiEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5295dabb1dff5294$export$2e2bcd8739ae039);
var $5295dabb1dff5294$export$2e2bcd8739ae039 = {};
$5295dabb1dff5294$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} se\xe7ilmedi.`,
    "longPressToSelect": `Se\xe7im moduna girmek i\xe7in uzun bas\u{131}n.`,
    "select": `Se\xe7`,
    "selectedAll": `T\xfcm \xf6geler se\xe7ildi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7bir \xf6ge se\xe7ilmedi`,
            one: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`,
            other: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`
        })}.`,
    "selectedItem": (args)=>`${args.item} se\xe7ildi.`
};

});

parcelRegister("9l7FT", function(module, exports) {

$parcel$export(module.exports, "default", () => $41f4a9cf19d0fb58$export$2e2bcd8739ae039);
var $41f4a9cf19d0fb58$export$2e2bcd8739ae039 = {};
$41f4a9cf19d0fb58$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{412}\u{438}\u{43A}\u{43E}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43E}\u{432}\u{433}\u{435} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{43D}\u{43D}\u{44F}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{438}\u{431}\u{43E}\u{440}\u{443}.`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectedAll": `\u{423}\u{441}\u{456} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{416}\u{43E}\u{434}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            one: ()=>`${formatter.number(args.count)} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};

});

parcelRegister("hBXzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b67486967d50a99$export$2e2bcd8739ae039);
var $2b67486967d50a99$export$2e2bcd8739ae039 = {};
$2b67486967d50a99$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9009}\u{62E9} ${args.item}\u{3002}`,
    "longPressToSelect": `\u{957F}\u{6309}\u{4EE5}\u{8FDB}\u{5165}\u{9009}\u{62E9}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectedAll": `\u{5DF2}\u{9009}\u{62E9}\u{6240}\u{6709}\u{9879}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9009}\u{62E9}\u{9879}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.item}\u{3002}`
};

});

parcelRegister("dNKZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3be2becb9a3f7b0$export$2e2bcd8739ae039);
var $a3be2becb9a3f7b0$export$2e2bcd8739ae039 = {};
$a3be2becb9a3f7b0$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{6309}\u{4EE5}\u{9032}\u{5165}\u{9078}\u{64C7}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9078}\u{53D6}`,
    "selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`
};

});


parcelRegister("lXemd", function(module, exports) {

$parcel$export(module.exports, "useUpdateEffect", () => $1315dc767e7cb412$export$496315a1608d9602);

var $4lMDe = parcelRequire("4lMDe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1315dc767e7cb412$export$496315a1608d9602(cb, dependencies) {
    const isInitialMount = (0, $eF4cA.useRef)(true);
    const lastDeps = (0, $eF4cA.useRef)(null);
    let cbEvent = (0, $4lMDe.useEffectEvent)(cb);
    (0, $eF4cA.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $eF4cA.useEffect)(()=>{
        let prevDeps = lastDeps.current;
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!prevDeps || dependencies.some((dep, i)=>!Object.is(dep, prevDeps[i]))) cbEvent();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("flpop", function(module, exports) {

$parcel$export(module.exports, "useHasTabbableChild", () => $5924f642039d37a7$export$eac1895992b9f3d6);

var $6pgkA = parcelRequire("6pgkA");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5924f642039d37a7$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options?.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $eF4cA.useState)(false);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (ref?.current && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    'tabIndex',
                    'disabled'
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

});

parcelRegister("9ehxp", function(module, exports) {

$parcel$export(module.exports, "useHighlightSelectionDescription", () => $f744613363a42b3e$export$be42ebdab07ae4c2);

var $bx0ZP = parcelRequire("bx0ZP");

var $lXRQr = parcelRequire("lXRQr");

var $YxOvP = parcelRequire("YxOvP");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $f744613363a42b3e$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f744613363a42b3e$export$be42ebdab07ae4c2(props) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($f744613363a42b3e$var$$parcel$interopDefault((0, $bx0ZP.default)), '@react-aria/grid');
    let modality = (0, $YxOvP.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, $eF4cA.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, $lXRQr.useDescription)(interactionDescription);
    return descriptionProps;
}

});


parcelRegister("cI1qR", function(module, exports) {

$parcel$export(module.exports, "useField", () => $82af32c27f879653$export$294aa081a6c6f55d);

var $jrZXQ = parcelRequire("jrZXQ");

var $lhKAD = parcelRequire("lhKAD");

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $82af32c27f879653$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $jrZXQ.useLabel)(props);
    let descriptionId = (0, $25dFS.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $25dFS.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $lhKAD.mergeProps)(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

});


parcelRegister("2Mr33", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ab2f3c71f484ca$export$2e2bcd8739ae039);

var $iqV56 = parcelRequire("iqV56");

var $8djGq = parcelRequire("8djGq");

var $3o9r5 = parcelRequire("3o9r5");

var $hlFW7 = parcelRequire("hlFW7");

var $9sLmB = parcelRequire("9sLmB");

var $825Nn = parcelRequire("825Nn");

var $aHpoQ = parcelRequire("aHpoQ");

var $7GwJE = parcelRequire("7GwJE");

var $drqYp = parcelRequire("drqYp");

var $f5RS7 = parcelRequire("f5RS7");

var $1vQ8z = parcelRequire("1vQ8z");

var $frUYx = parcelRequire("frUYx");

var $hFKba = parcelRequire("hFKba");

var $bkqd4 = parcelRequire("bkqd4");

var $hZipF = parcelRequire("hZipF");

var $4i8DC = parcelRequire("4i8DC");

var $kru5A = parcelRequire("kru5A");

var $b0E0Z = parcelRequire("b0E0Z");

var $5wh1t = parcelRequire("5wh1t");

var $daGku = parcelRequire("daGku");

var $bMYpU = parcelRequire("bMYpU");

var $dIDAx = parcelRequire("dIDAx");

var $6Xsbd = parcelRequire("6Xsbd");

var $iAAAw = parcelRequire("iAAAw");

var $fhnCG = parcelRequire("fhnCG");

var $5GLQU = parcelRequire("5GLQU");

var $jTGw7 = parcelRequire("jTGw7");

var $5h5jc = parcelRequire("5h5jc");

var $c0lB6 = parcelRequire("c0lB6");

var $al1RU = parcelRequire("al1RU");

var $actEf = parcelRequire("actEf");

var $bR58E = parcelRequire("bR58E");

var $49mio = parcelRequire("49mio");

var $eKg2o = parcelRequire("eKg2o");
var $d2ab2f3c71f484ca$export$2e2bcd8739ae039 = {};
$d2ab2f3c71f484ca$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $iqV56.default),
    "bg-BG": (0, $8djGq.default),
    "cs-CZ": (0, $3o9r5.default),
    "da-DK": (0, $hlFW7.default),
    "de-DE": (0, $9sLmB.default),
    "el-GR": (0, $825Nn.default),
    "en-US": (0, $aHpoQ.default),
    "es-ES": (0, $7GwJE.default),
    "et-EE": (0, $drqYp.default),
    "fi-FI": (0, $f5RS7.default),
    "fr-FR": (0, $1vQ8z.default),
    "he-IL": (0, $frUYx.default),
    "hr-HR": (0, $hFKba.default),
    "hu-HU": (0, $bkqd4.default),
    "it-IT": (0, $hZipF.default),
    "ja-JP": (0, $4i8DC.default),
    "ko-KR": (0, $kru5A.default),
    "lt-LT": (0, $b0E0Z.default),
    "lv-LV": (0, $5wh1t.default),
    "nb-NO": (0, $daGku.default),
    "nl-NL": (0, $bMYpU.default),
    "pl-PL": (0, $dIDAx.default),
    "pt-BR": (0, $6Xsbd.default),
    "pt-PT": (0, $iAAAw.default),
    "ro-RO": (0, $fhnCG.default),
    "ru-RU": (0, $5GLQU.default),
    "sk-SK": (0, $jTGw7.default),
    "sl-SI": (0, $5h5jc.default),
    "sr-SP": (0, $c0lB6.default),
    "sv-SE": (0, $al1RU.default),
    "tr-TR": (0, $actEf.default),
    "uk-UA": (0, $bR58E.default),
    "zh-CN": (0, $49mio.default),
    "zh-TW": (0, $eKg2o.default)
};

});
parcelRegister("iqV56", function(module, exports) {

$parcel$export(module.exports, "default", () => $accdcc197700c571$export$2e2bcd8739ae039);
var $accdcc197700c571$export$2e2bcd8739ae039 = {};
$accdcc197700c571$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{625}\u{632}\u{627}\u{644}\u{629}`,
    "removeDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} DELETE \u{644}\u{625}\u{632}\u{627}\u{644}\u{629} \u{639}\u{644}\u{627}\u{645}\u{629}.`
};

});

parcelRegister("8djGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $25320591a75d9e2e$export$2e2bcd8739ae039);
var $25320591a75d9e2e$export$2e2bcd8739ae039 = {};
$25320591a75d9e2e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{41F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{432}\u{430}\u{43D}\u{435}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Delete, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{43D}\u{435}\u{442}\u{435} \u{43C}\u{430}\u{440}\u{43A}\u{435}\u{440}\u{430}.`
};

});

parcelRegister("3o9r5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ad3bf6b01949b3$export$2e2bcd8739ae039);
var $c8ad3bf6b01949b3$export$2e2bcd8739ae039 = {};
$c8ad3bf6b01949b3$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odebrat`,
    "removeDescription": `Stisknut\xedm kl\xe1vesy Delete odeberete zna\u{10D}ku.`
};

});

parcelRegister("hlFW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $11bc5c8fee6f897d$export$2e2bcd8739ae039);
var $11bc5c8fee6f897d$export$2e2bcd8739ae039 = {};
$11bc5c8fee6f897d$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Tryk p\xe5 Slet for at fjerne tag.`
};

});

parcelRegister("9sLmB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d750b153f1eee35a$export$2e2bcd8739ae039);
var $d750b153f1eee35a$export$2e2bcd8739ae039 = {};
$d750b153f1eee35a$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Entfernen`,
    "removeDescription": `Auf \u{201E}L\xf6schen\u{201C} dr\xfccken, um das Tag zu entfernen.`
};

});

parcelRegister("825Nn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b49c2a0f7ce16d$export$2e2bcd8739ae039);
var $e1b49c2a0f7ce16d$export$2e2bcd8739ae039 = {};
$e1b49c2a0f7ce16d$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{39A}\u{3B1}\u{3C4}\u{3AC}\u{3C1}\u{3B3}\u{3B7}\u{3C3}\u{3B7}`,
    "removeDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{394}\u{3B9}\u{3B1}\u{3B3}\u{3C1}\u{3B1}\u{3C6}\u{3AE} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BA}\u{3B1}\u{3C4}\u{3B1}\u{3C1}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3AD}\u{3C4}\u{3B1}.`
};

});

parcelRegister("aHpoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5229f5a1c9c70faa$export$2e2bcd8739ae039);
var $5229f5a1c9c70faa$export$2e2bcd8739ae039 = {};
$5229f5a1c9c70faa$export$2e2bcd8739ae039 = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};

});

parcelRegister("7GwJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $008b22f0e805ef34$export$2e2bcd8739ae039);
var $008b22f0e805ef34$export$2e2bcd8739ae039 = {};
$008b22f0e805ef34$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Quitar`,
    "removeDescription": `Pulse Eliminar para quitar la etiqueta.`
};

});

parcelRegister("drqYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $be6aea815b8aa319$export$2e2bcd8739ae039);
var $be6aea815b8aa319$export$2e2bcd8739ae039 = {};
$be6aea815b8aa319$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Eemalda`,
    "removeDescription": `Sildi eemaldamiseks vajutage kustutusklahvi Delete.`
};

});

parcelRegister("f5RS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a6cecfd617beb91$export$2e2bcd8739ae039);
var $2a6cecfd617beb91$export$2e2bcd8739ae039 = {};
$2a6cecfd617beb91$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Poista`,
    "removeDescription": `Poista tunniste painamalla Poista-painiketta.`
};

});

parcelRegister("1vQ8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdc50b7c106cc9a7$export$2e2bcd8739ae039);
var $fdc50b7c106cc9a7$export$2e2bcd8739ae039 = {};
$fdc50b7c106cc9a7$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Supprimer`,
    "removeDescription": `Appuyez sur Supprimer pour supprimer l\u{2019}\xe9tiquette.`
};

});

parcelRegister("frUYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f207b5b8aff366f7$export$2e2bcd8739ae039);
var $f207b5b8aff366f7$export$2e2bcd8739ae039 = {};
$f207b5b8aff366f7$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{5D4}\u{5E1}\u{5E8}`,
    "removeDescription": `\u{5DC}\u{5D7}\u{5E5} \u{5E2}\u{5DC} \u{5DE}\u{5D7}\u{5E7} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5EA}\u{5D2}.`
};

});

parcelRegister("hFKba", function(module, exports) {

$parcel$export(module.exports, "default", () => $660711d1090aa494$export$2e2bcd8739ae039);
var $660711d1090aa494$export$2e2bcd8739ae039 = {};
$660711d1090aa494$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Delete za uklanjanje oznake.`
};

});

parcelRegister("bkqd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b131c707cf1aab$export$2e2bcd8739ae039);
var $61b131c707cf1aab$export$2e2bcd8739ae039 = {};
$61b131c707cf1aab$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Elt\xe1vol\xedt\xe1s`,
    "removeDescription": `Nyomja meg a Delete billenty\u{171}t a c\xedmke elt\xe1vol\xedt\xe1s\xe1hoz.`
};

});

parcelRegister("hZipF", function(module, exports) {

$parcel$export(module.exports, "default", () => $628ad6f8728c6b69$export$2e2bcd8739ae039);
var $628ad6f8728c6b69$export$2e2bcd8739ae039 = {};
$628ad6f8728c6b69$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Rimuovi`,
    "removeDescription": `Premi Elimina per rimuovere il tag.`
};

});

parcelRegister("4i8DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae323bcf5bcebf45$export$2e2bcd8739ae039);
var $ae323bcf5bcebf45$export$2e2bcd8739ae039 = {};
$ae323bcf5bcebf45$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{524A}\u{9664}`,
    "removeDescription": `\u{30BF}\u{30B0}\u{3092}\u{524A}\u{9664}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}Delete \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{307E}\u{3059}\u{3002}`
};

});

parcelRegister("kru5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b6b178108e39a4$export$2e2bcd8739ae039);
var $44b6b178108e39a4$export$2e2bcd8739ae039 = {};
$44b6b178108e39a4$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{C81C}\u{AC70}`,
    "removeDescription": `\u{D0DC}\u{ADF8}\u{B97C} \u{C81C}\u{AC70}\u{D558}\u{B824}\u{BA74} Delete \u{D0A4}\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`
};

});

parcelRegister("b0E0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $354e8797ae147a95$export$2e2bcd8739ae039);
var $354e8797ae147a95$export$2e2bcd8739ae039 = {};
$354e8797ae147a95$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Pa\u{161}alinti`,
    "removeDescription": `Nor\u{117}dami pa\u{161}alinti \u{17E}ym\u{105}, paspauskite \u{201E}Delete\u{201C} klavi\u{161}\u{105}.`
};

});

parcelRegister("5wh1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac1b6a60fa808e3$export$2e2bcd8739ae039);
var $cac1b6a60fa808e3$export$2e2bcd8739ae039 = {};
$cac1b6a60fa808e3$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `No\u{146}emt`,
    "removeDescription": `Nospiediet Delete [Dz\u{113}st], lai no\u{146}emtu tagu.`
};

});

parcelRegister("daGku", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e2000223d8b436$export$2e2bcd8739ae039);
var $d8e2000223d8b436$export$2e2bcd8739ae039 = {};
$d8e2000223d8b436$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Trykk p\xe5 Slett for \xe5 fjerne taggen.`
};

});

parcelRegister("bMYpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $80d2fc65263bb502$export$2e2bcd8739ae039);
var $80d2fc65263bb502$export$2e2bcd8739ae039 = {};
$80d2fc65263bb502$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Verwijderen`,
    "removeDescription": `Druk op Verwijderen om de tag te verwijderen.`
};

});

parcelRegister("dIDAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4c93aeb258719f$export$2e2bcd8739ae039);
var $fd4c93aeb258719f$export$2e2bcd8739ae039 = {};
$fd4c93aeb258719f$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Usu\u{144}`,
    "removeDescription": `Naci\u{15B}nij Usu\u{144}, aby usun\u{105}\u{107} znacznik.`
};

});

parcelRegister("6Xsbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5e2cdc23ab47f3$export$2e2bcd8739ae039);
var $6f5e2cdc23ab47f3$export$2e2bcd8739ae039 = {};
$6f5e2cdc23ab47f3$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Remover`,
    "removeDescription": `Pressione Delete para remover a tag.`
};

});

parcelRegister("iAAAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75b9c7508b30aa0$export$2e2bcd8739ae039);
var $e75b9c7508b30aa0$export$2e2bcd8739ae039 = {};
$e75b9c7508b30aa0$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Eliminar`,
    "removeDescription": `Prima Delete para eliminar a tag.`
};

});

parcelRegister("fhnCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $47c5bc3439e397c7$export$2e2bcd8739ae039);
var $47c5bc3439e397c7$export$2e2bcd8739ae039 = {};
$47c5bc3439e397c7$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\xcendep\u{103}rta\u{163}i`,
    "removeDescription": `Ap\u{103}sa\u{21B}i pe Delete (\u{218}tergere) pentru a elimina eticheta.`
};

});

parcelRegister("5GLQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafd63f662b24c71$export$2e2bcd8739ae039);
var $eafd63f662b24c71$export$2e2bcd8739ae039 = {};
$eafd63f662b24c71$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    "removeDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} DELETE, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{433}.`
};

});

parcelRegister("jTGw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $28ccde82b3164985$export$2e2bcd8739ae039);
var $28ccde82b3164985$export$2e2bcd8739ae039 = {};
$28ccde82b3164985$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odstr\xe1ni\u{165}`,
    "removeDescription": `Ak chcete odstr\xe1ni\u{165} zna\u{10D}ku, stla\u{10D}te kl\xe1ves Delete.`
};

});

parcelRegister("5h5jc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73e2e764ece0386$export$2e2bcd8739ae039);
var $d73e2e764ece0386$export$2e2bcd8739ae039 = {};
$d73e2e764ece0386$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};

});

parcelRegister("c0lB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e25ee38809989c$export$2e2bcd8739ae039);
var $76e25ee38809989c$export$2e2bcd8739ae039 = {};
$76e25ee38809989c$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Obri\u{161}i da biste uklonili oznaku.`
};

});

parcelRegister("al1RU", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e2a1561b3abc96$export$2e2bcd8739ae039);
var $14e2a1561b3abc96$export$2e2bcd8739ae039 = {};
$14e2a1561b3abc96$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ta bort`,
    "removeDescription": `Tryck p\xe5 Radera f\xf6r att ta bort taggen.`
};

});

parcelRegister("actEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $12edb474ac206400$export$2e2bcd8739ae039);
var $12edb474ac206400$export$2e2bcd8739ae039 = {};
$12edb474ac206400$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Kald\u{131}r`,
    "removeDescription": `Etiketi kald\u{131}rmak i\xe7in Sil tu\u{15F}una bas\u{131}n.`
};

});

parcelRegister("bR58E", function(module, exports) {

$parcel$export(module.exports, "default", () => $3436ea74c6fed62a$export$2e2bcd8739ae039);
var $3436ea74c6fed62a$export$2e2bcd8739ae039 = {};
$3436ea74c6fed62a$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{412}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Delete, \u{449}\u{43E}\u{431} \u{432}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438} \u{442}\u{435}\u{433}.`
};

});

parcelRegister("49mio", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bdc510157fcb9d$export$2e2bcd8739ae039);
var $c0bdc510157fcb9d$export$2e2bcd8739ae039 = {};
$c0bdc510157fcb9d$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{5220}\u{9664}`,
    "removeDescription": `\u{6309}\u{4E0B}\u{201C}\u{5220}\u{9664}\u{201D}\u{4EE5}\u{5220}\u{9664}\u{6807}\u{8BB0}\u{3002}`
};

});

parcelRegister("eKg2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $752900b8b61db890$export$2e2bcd8739ae039);
var $752900b8b61db890$export$2e2bcd8739ae039 = {};
$752900b8b61db890$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{79FB}\u{9664}`,
    "removeDescription": `\u{6309} Delete \u{9375}\u{4EE5}\u{79FB}\u{9664}\u{6A19}\u{8A18}\u{3002}`
};

});


parcelRegister("8HLWT", function(module, exports) {

$parcel$export(module.exports, "useGridListItem", () => $4ab27b6a17085ec3$export$9610e69494fadfd2);

var $d8j5I = parcelRequire("d8j5I");

var $eNuje = parcelRequire("eNuje");

var $fvyIQ = parcelRequire("fvyIQ");

var $6pgkA = parcelRequire("6pgkA");

var $7ByPJ = parcelRequire("7ByPJ");

var $7Ydqk = parcelRequire("7Ydqk");

var $5AGOf = parcelRequire("5AGOf");

var $YxOvP = parcelRequire("YxOvP");

var $lhKAD = parcelRequire("lhKAD");

var $3lc2m = parcelRequire("3lc2m");

var $hNw9N = parcelRequire("hNw9N");

var $1ntKq = parcelRequire("1ntKq");

var $25dFS = parcelRequire("25dFS");

var $aGgVM = parcelRequire("aGgVM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$EXPANSION_KEYS = {
    expand: {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    collapse: {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function $4ab27b6a17085ec3$export$9610e69494fadfd2(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node: node, isVirtualized: isVirtualized, focusMode: focusMode = 'row', allowsArrowNavigation: allowsArrowNavigation } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { onAction: onAction, linkBehavior: linkBehavior, keyboardNavigationBehavior: keyboardNavigationBehavior, shouldSelectOnPressUp: shouldSelectOnPressUp } = (0, $7Ydqk.listMap).get(state);
    let descriptionId = (0, $25dFS.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, $eF4cA.useRef)(null);
    let focus = ()=>{
        if (ref.current === null) return;
        if (focusMode === 'child') {
            // If focus is already on a focusable child within the row, early return so we don't shift focus
            if ((0, $fvyIQ.isFocusWithin)(ref.current) && ref.current !== (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current))) return;
            let treeWalker = (0, $6pgkA.getFocusableTreeWalker)(ref.current, {
                tabbable: true
            });
            let focusable = treeWalker.firstChild();
            if (focusable) {
                (0, $eNuje.focusSafely)(focusable);
                (0, $3lc2m.scrollIntoViewport)(focusable, {
                    containingElement: (0, $5AGOf.getScrollParent)(focusable)
                });
                return;
            }
        }
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !(0, $fvyIQ.isFocusWithin)(ref.current)) (0, $eNuje.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        let index = node.index;
        if (node.level >= 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$getDirectChildren(parent, state.collection);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
                if (index > 0 && siblings[0].type !== 'item') index -= 1; // subtract one for the parent item's content node
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps: itemProps, ...itemStates } = (0, $hNw9N.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, $d8j5I.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus: focus,
        linkBehavior: linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        let activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current));
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e)) || !ref.current || !activeElement) return;
        let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current);
        walker.currentNode = activeElement;
        if ($4ab27b6a17085ec3$var$$be7bed9611dd7497$var$handleTreeExpansionKeys(e, state, node, hasChildRows, direction, activeElement, ref.current, allowsArrowNavigation)) return;
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, $eNuje.focusSafely)(focusable);
                        (0, $3lc2m.scrollIntoViewport)(focusable, {
                            containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, $eNuje.focusSafely)(ref.current);
                            (0, $3lc2m.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$last(walker);
                            // oxlint-disable-next-line max-depth
                            if (lastElement) {
                                (0, $eNuje.focusSafely)(lastElement);
                                (0, $3lc2m.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, $eNuje.focusSafely)(focusable);
                        (0, $3lc2m.scrollIntoViewport)(focusable, {
                            containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, $eNuje.focusSafely)(ref.current);
                            (0, $3lc2m.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$last(walker);
                            // oxlint-disable-next-line max-depth
                            if (lastElement) {
                                (0, $eNuje.focusSafely)(lastElement);
                                (0, $3lc2m.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && (0, $fvyIQ.nodeContains)(ref.current, (0, $fvyIQ.getEventTarget)(e))) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if ((0, $fvyIQ.getEventTarget)(e) !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, $YxOvP.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
        // if focus goes back to cell from child, make sure we don't refocus the cell if we are in focusMode=child
        // since that would be a focus trap
        if (focusMode === 'child' && e.relatedTarget && (0, $fvyIQ.nodeContains)(ref.current, e.relatedTarget)) return;
        // If the cell itself is focused, wait a frame so that focus finishes propagating
        // up to the tree, and move focus to a focusable child if possible.
        requestAnimationFrame(()=>{
            if (focusMode === 'child' && (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current)) === ref.current) focus();
        });
    };
    let onKeyDown = (e)=>{
        let activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current));
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e)) || !ref.current || !activeElement) return;
        if (keyboardNavigationBehavior === 'tab') {
            // Stop propagation for all events that originate from the children of the gridlist item since we don't want to trigger
            // grid level interactions (row navigation/typeselect/etc)
            // exception made for Tab since that needs to propagate to useSelectableCollection to tab out of the gridlist, might be others?
            if ((0, $fvyIQ.getEventTarget)(e) !== ref.current && e.key !== 'Tab') {
                e.stopPropagation();
                return;
            }
            if ($4ab27b6a17085ec3$var$$be7bed9611dd7497$var$handleTreeExpansionKeys(e, state, node, hasChildRows, direction, activeElement, ref.current, allowsArrowNavigation)) return;
        }
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, $aGgVM.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    // oxlint-disable-next-line react/react-compiler
    let rowProps = (0, $lhKAD.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture: keyboardNavigationBehavior === 'arrow' || allowsArrowNavigation ? onKeyDownCapture : undefined,
        onFocus: onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node['aria-label'] || node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && (node['aria-label'] || node.textValue) ? `${(0, $7Ydqk.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, $7Ydqk.getRowId)(state, node.key)
    });
    if (focusMode === 'child' && allowsArrowNavigation && keyboardNavigationBehavior === 'tab') rowProps.tabIndex = -1;
    // we need to guard against space/enter triggering selection/row link via usePress (from itemProps) so check if propagation
    // is stopped. this also fixes space not working in a textfield in a tree parent row
    let baseOnKeyDown = rowProps.onKeyDown;
    rowProps.onKeyDown = (e)=>{
        onKeyDown(e);
        if (!e.isPropagationStopped()) baseOnKeyDown?.(e);
    };
    if (isVirtualized) {
        let { collection: collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    // oxlint-disable react/react-compiler
    return {
        rowProps: {
            ...(0, $lhKAD.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps: gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
// oxlint-enable react/react-compiler
}
function $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$handleTreeExpansionKeys(e, state, node, hasChildRows, direction, activeElement, rowRef, allowsArrowNavigation) {
    if (!('expandedKeys' in state) || !allowsArrowNavigation && activeElement !== rowRef) return false;
    if (e.key === $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
        state.toggleKey(node.key);
        e.stopPropagation();
        return true;
    } else if (e.key === $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key) {
        // If item is collapsible, collapse it; else move to parent
        if (hasChildRows && state.expandedKeys.has(node.key)) {
            state.toggleKey(node.key);
            e.stopPropagation();
            return true;
        } else if (!state.expandedKeys.has(node.key) && node.parentKey && state.collection.getItem(node.parentKey)?.type === 'item') {
            // Item is a leaf or already collapsed, move focus to parent
            state.selectionManager.setFocusedKey(node.parentKey);
            e.stopPropagation();
            return true;
        }
    }
    return false;
}
function $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
function $4ab27b6a17085ec3$var$$be7bed9611dd7497$var$getDirectChildren(parent, collection) {
    // We can't assume that we can use firstChildKey because if a person builds a tree using hooks, they would not have access to that property (using type Node vs CollectionNode)
    // Instead, get all children and start at the first node (rather than just using firstChildKey) and only look at its siblings
    let children = collection.getChildren?.(parent.key);
    let childArray = children ? Array.from(children) : [];
    let node = childArray.length > 0 ? childArray[0] : null;
    let siblings = [];
    while(node){
        siblings.push(node);
        node = node.nextKey != null ? collection.getItem(node.nextKey) : null;
    }
    return siblings;
}

});




parcelRegister("i8elj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee945551201014ea$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ee945551201014ea$var$$3e3c3f5dddb8c730$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M8.249 15.021c-.4 0-.733-.317-.748-.72l-.25-6.5c-.017-.414.307-.763.72-.779H8c.4 0 .733.317.748.72l.25 6.5c.017.414-.307.763-.72.778zM11.751 15.021h-.03c-.413-.016-.737-.365-.72-.779l.25-6.5c.015-.403.348-.72.748-.72h.03c.413.016.737.365.72.779l-.25 6.5c-.015.403-.348.72-.748.72"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M17 4h-3.5v-.75C13.5 2.01 12.49 1 11.25 1h-2.5C7.51 1 6.5 2.01 6.5 3.25V4H3c-.414 0-.75.336-.75.75s.336.75.75.75h.52l.422 10.342C3.99 17.052 4.98 18 6.19 18h7.62c1.211 0 2.2-.948 2.248-2.158L16.48 5.5H17c.414 0 .75-.336.75-.75S17.414 4 17 4m-9-.75c0-.413.337-.75.75-.75h2.5c.413 0 .75.337.75.75V4H8zm6.56 12.531c-.017.404-.346.719-.75.719H6.19c-.404 0-.733-.315-.75-.719L5.02 5.5h9.96z"
            })
        ]
    });
const $ee945551201014ea$var$$3e3c3f5dddb8c730$var$ForwardRef = (0, $eF4cA.forwardRef)($ee945551201014ea$var$$3e3c3f5dddb8c730$var$SvgComponent);
var $ee945551201014ea$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($ee945551201014ea$var$$3e3c3f5dddb8c730$var$ForwardRef);

});

parcelRegister("kekDO", function(module, exports) {

$parcel$export(module.exports, "getImageDragOperation", () => $eba5205c06636b29$export$d029f811813e5fd5);
$parcel$export(module.exports, "IMAGE_DROP_ZONE_STYLE", () => $eba5205c06636b29$export$e354631a2b072374);
$parcel$export(module.exports, "IMAGE_DROP_ZONE_OUTSET", () => $eba5205c06636b29$export$c0f0c7bf21f7e500);
$parcel$export(module.exports, "UploadHoverOverlay", () => $eba5205c06636b29$export$52b303fad4ae5c04);
$parcel$export(module.exports, "UploadHoverBorder", () => $eba5205c06636b29$export$e6626193c1354509);
$parcel$export(module.exports, "ImageAsset", () => $eba5205c06636b29$export$7d9a50e36a0d626c);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $KXDAG = parcelRequire("KXDAG");
var $7Vvqh = parcelRequire("7Vvqh");
var $yuTTo = parcelRequire("yuTTo");
var $fZShI = parcelRequire("fZShI");

var $k5Pnh = parcelRequire("k5Pnh");

var $HZG6L = parcelRequire("HZG6L");

var $d51mJ = parcelRequire("d51mJ");

var $iLDMH = parcelRequire("iLDMH");

var $aK4qQ = parcelRequire("aK4qQ");

var $g42KE = parcelRequire("g42KE");
const $eba5205c06636b29$export$d029f811813e5fd5 = ({ types: types })=>Array.from(types)[0]?.startsWith("image/") ? "copy" : "cancel";
const $eba5205c06636b29$export$e354631a2b072374 = {
    padding: 4,
    borderRadius: "1rem"
};
const $eba5205c06636b29$export$c0f0c7bf21f7e500 = $eba5205c06636b29$export$e354631a2b072374.padding + 2;
const $eba5205c06636b29$export$52b303fad4ae5c04 = ({ isHovered: isHovered, compact: compact = false })=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $aK4qQ.HoverOverlay), {
        isHovered: isHovered,
        icon: (0, $HZG6L.default),
        compact: compact
    });
$eba5205c06636b29$export$52b303fad4ae5c04.propTypes = {
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
const $eba5205c06636b29$export$e6626193c1354509 = ({ isHovered: isHovered, borderRadius: borderRadius })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        "aria-hidden": true,
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _Pa182';
            rules += ' _Mc182';
            rules += ' _Lf182';
            if (props.isHovered) rules += ' OOIem5c182';
            else rules += ' Oj182';
            rules += ' _Kb182';
            rules += ' _Ob182';
            rules += ' Ya182';
            rules += ' XCIisn182';
            rules += ' _2b182';
            rules += ' _84alq6b182';
            return rules;
        }({
            isHovered: isHovered
        }),
        style: {
            inset: -2,
            borderRadius: borderRadius
        }
    });
$eba5205c06636b29$export$e6626193c1354509.propTypes = {
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    borderRadius: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const $eba5205c06636b29$export$7d9a50e36a0d626c = ({ label: label, description: description, name: name, isFilled: isFilled, contextualHelp: contextualHelp, filePath: filePath, src: src, isLoading: isLoading, isDisabled: isDisabled = false, onDrop: onDrop, getImageDragOperation: getDropOperation = $eba5205c06636b29$export$d029f811813e5fd5, aspectRatio: aspectRatio, isFluid: isFluid = false, isCaptioned: isCaptioned = false, actions: actions, children: children, styles: styles = "" })=>{
    const [isHovered, setHovered] = (0, $eF4cA.useState)(false);
    const dropZone = /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $KXDAG.DropZone), {
        isDisabled: isDisabled,
        isFilled: isFilled,
        getDropOperation: getDropOperation,
        onDrop: (event)=>onDrop(event.items, name),
        UNSAFE_style: $eba5205c06636b29$export$e354631a2b072374,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                isDisabled: isDisabled,
                acceptedFileTypes: "image/*",
                onSelect: (files)=>onDrop(files, name),
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
                    isDisabled: isDisabled,
                    className: " _oa182 _Pc182 Za182 Fb182 Td182 Qd182 Sd182 Rd182 _ka182 ha182 ma182 la182 g9182 _Nc182 Pc182",
                    onHoverChange: setHovered,
                    children: ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                isFilled ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                    variant: "quiet",
                                    styles: " Na182 Zd182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                                filePath: filePath,
                                                src: src || "",
                                                alt: name || "",
                                                styles: function anonymous(props) {
                                                    let rules = " ";
                                                    rules += ' _Ha182';
                                                    rules += ' fbUhsn182';
                                                    rules += ' Za182';
                                                    rules += ' Fb182';
                                                    if (props.isLoading) rules += ' _IStfurc182';
                                                    else rules += ' _Ib182';
                                                    return rules;
                                                }({
                                                    isLoading: isLoading
                                                }),
                                                UNSAFE_style: aspectRatio ? {
                                                    aspectRatio: aspectRatio
                                                } : undefined
                                            }),
                                            !!isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                "aria-label": "Loading",
                                                isIndeterminate: true,
                                                staticColor: "auto",
                                                styles: " _Pa182 WF182 _A3MNfn182",
                                                UNSAFE_className: " _Zc182"
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " Za182 Fb182 sd182 _ta182 eb182 _Ca182 Ua182 qa182 fcJcitc182",
                                    style: aspectRatio ? {
                                        aspectRatio: aspectRatio
                                    } : undefined,
                                    children: !isLoading ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d51mJ.default), {
                                                styles: " ZF182 ZoC182 ZrF182 Fz182 Fox182 Frz182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182 Jy182 Gy182 Iy182 Hy182",
                                                children: "Drag and drop an image"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                                children: "or select a file"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                        "aria-label": "Loading",
                                        isIndeterminate: true,
                                        staticColor: "auto",
                                        styles: " _Pa182 WF182 _A3MNfn182",
                                        UNSAFE_className: " _Zc182"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)($eba5205c06636b29$export$52b303fad4ae5c04, {
                                    isHovered: isHovered
                                })
                            ]
                        })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)($eba5205c06636b29$export$e6626193c1354509, {
                isHovered: isHovered,
                borderRadius: $eba5205c06636b29$export$e354631a2b072374.borderRadius
            })
        ]
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd182';
            rules += ' _ta182';
            if (props.isFluid) rules += ' Za182';
            else rules += ' Zt182';
            return rules;
        }({
            isFluid: isFluid
        }) + styles,
        children: [
            !!label && // Only a heading: a `LabeledValue` cannot contain the drop zone's
            // file input.
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: label,
                value: "",
                contextualHelp: isCaptioned ? undefined : contextualHelp
            }),
            dropZone,
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $g42KE.ThumbnailCaption), {
                description: description,
                contextualHelp: isCaptioned ? contextualHelp : undefined,
                actions: actions
            }),
            !!children && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " JC182",
                children: children
            })
        ]
    }, name);
};
$eba5205c06636b29$export$7d9a50e36a0d626c.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isFilled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    contextualHelp: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    getImageDragOperation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number
    ]),
    isFluid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isCaptioned: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};

});
parcelRegister("2RdeM", function(module, exports) {

$parcel$export(module.exports, "InternalCardViewContext", () => $39a13d9ee2d35a29$export$cb658fed5fefe1d);
$parcel$export(module.exports, "CardContext", () => $39a13d9ee2d35a29$export$d0b2ee33ebf7d64);
$parcel$export(module.exports, "Card", () => $39a13d9ee2d35a29$export$60332b2344f7fe41);
$parcel$export(module.exports, "CardPreview", () => $39a13d9ee2d35a29$export$115f017852a4bb7c);
$parcel$export(module.exports, "CollectionCardPreview", () => $39a13d9ee2d35a29$export$c368ea3e577b1b86);
$parcel$export(module.exports, "UserCard", () => $39a13d9ee2d35a29$export$78e8870b5d8ae469);


var $gc2oq = parcelRequire("gc2oq");

var $f16Ml = parcelRequire("f16Ml");

var $34HUQ = parcelRequire("34HUQ");

var $cxTG4 = parcelRequire("cxTG4");

var $208Op = parcelRequire("208Op");

var $8Muzv = parcelRequire("8Muzv");

var $dm5H1 = parcelRequire("dm5H1");

var $8g9SZ = parcelRequire("8g9SZ");

var $jTg9X = parcelRequire("jTg9X");

var $5nTep = parcelRequire("5nTep");

var $i93Vd = parcelRequire("i93Vd");

var $91SAk = parcelRequire("91SAk");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $gF3YT = parcelRequire("gF3YT");

var $k8kxd = parcelRequire("k8kxd");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$borderRadius = {
    default: 'lg',
    size: {
        XS: 'default',
        S: 'default'
    }
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$card = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd182';
    rules += ' _ta182';
    if (!position) rules += ' _Pc182';
    if (props.size === "S") rules += ' ob182';
    else if (props.size === "XS") rules += ' ob182';
    else rules += ' oc182';
    if (props.size === "S") rules += ' nb182';
    else if (props.size === "XS") rules += ' nb182';
    else rules += ' nc182';
    if (props.size === "S") rules += ' kb182';
    else if (props.size === "XS") rules += ' kb182';
    else rules += ' kc182';
    if (props.size === "S") rules += ' jb182';
    else if (props.size === "XS") rules += ' jb182';
    else rules += ' jc182';
    if (props.variant === "secondary") rules += ' -Ovbhqd-gqlRAZb182';
    else if (props.variant === "primary") rules += ' -Ovbhqd-g_g182';
    rules += ' -Ovbhqd-lgb182';
    if (props.variant === "quiet") rules += ' g9182';
    else if (props.variant === "tertiary") rules += ' g9182';
    else rules += ' gEzkoQe182';
    if (props.variant === "quiet") rules += ' _nd182';
    else if (props.variant === "tertiary") {
        if (props.isSelected) rules += ' _nd182';
        else if (props.isFocusVisible) rules += ' _nrC99Ne182';
        else if (props.isHovered) rules += ' _nrC99Ne182';
        else rules += ' _nnvmtGb182';
        rules += ' _nli6j2Ec182';
    } else {
        if (props.isSelected) rules += ' _nLeasBb182';
        else if (props.isFocusVisible) rules += ' _nLeasBb182';
        else if (props.isHovered) rules += ' _nLeasBb182';
        else rules += ' _n4zCLMe182';
        rules += ' _nlJWldjc182';
    }
    rules += ' _yb182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' _Xa182';
    if (props.variant === "quiet") rules += ' _Ne182';
    else rules += ' _Nb182';
    if (props.variant === "quiet") rules += ' Pe182';
    else rules += ' Pb182';
    rules += ' _qc182';
    rules += ' __ca182';
    if (props.isCardView) rules += ' _4c182';
    if (props.isLink) rules += ' ry182';
    if (props.isCardView) {
        if (!width) rules += ' Za182';
    } else if (props.size === "XL") {
        if (!width) rules += ' ZA182';
    } else if (props.size === "L") {
        if (!width) rules += ' Zy182';
    } else if (props.size === "M") {
        if (!width) rules += ' Zt182';
    } else if (props.size === "S") {
        if (!width) rules += ' Zr182';
    } else if (props.size === "XS") {
        if (!width) rules += ' ZI182';
    }
    rules += ' Fb182';
    if (props.density === "spacious") {
        if (props.size === "XL") rules += ' -dAV6Jb-Ti182';
        else if (props.size === "L") rules += ' -dAV6Jb-Th182';
        else if (props.size === "M") rules += ' -dAV6Jb-Tg182';
        else if (props.size === "S") rules += ' -dAV6Jb-Tf182';
        else if (props.size === "XS") rules += ' -dAV6Jb-Te182';
    } else if (props.density === "regular") {
        if (props.size === "XL") rules += ' -dAV6Jb-Th182';
        else if (props.size === "L") rules += ' -dAV6Jb-Tg182';
        else if (props.size === "M") rules += ' -dAV6Jb-Tf182';
        else if (props.size === "S") rules += ' -dAV6Jb-Te182';
        else if (props.size === "XS") rules += ' -dAV6Jb-Tt182';
    } else if (props.density === "compact") {
        if (props.size === "XL") rules += ' -dAV6Jb-Tg182';
        else if (props.size === "L") rules += ' -dAV6Jb-Tf182';
        else if (props.size === "M") rules += ' -dAV6Jb-Te182';
        else if (props.size === "S") rules += ' -dAV6Jb-Tt182';
        else if (props.size === "XS") rules += ' -dAV6Jb-T1DOfn182';
    }
    if (props.variant === "quiet") rules += ' -jXLvjd-Td182';
    else rules += ' -jXLvjd-T5gMYHd182';
    if (props.variant === "quiet") rules += ' -iXLvjd-Sd182';
    else rules += ' -iXLvjd-S5gMYHd182';
    rules += ' TxTaQHd182';
    rules += ' QxTaQHd182';
    rules += ' S0SaQHd182';
    rules += ' R0SaQHd182';
    rules += ' _oa182';
    if (props.variant === "quiet") rules += ' _Le182';
    else if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    return rules;
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$selectionIndicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _lr182';
    rules += ' _Ar182';
    rules += ' _zr182';
    rules += ' _9d182';
    if (props.size === "S") rules += ' ob182';
    else if (props.size === "XS") rules += ' ob182';
    else rules += ' oc182';
    if (props.size === "S") rules += ' nb182';
    else if (props.size === "XS") rules += ' nb182';
    else rules += ' nc182';
    if (props.size === "S") rules += ' kb182';
    else if (props.size === "XS") rules += ' kb182';
    else rules += ' kc182';
    if (props.size === "S") rules += ' jb182';
    else if (props.size === "XS") rules += ' jb182';
    else rules += ' jc182';
    rules += ' _Ob182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    rules += ' _jf182';
    rules += ' ik182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isSelected) rules += ' _Ib182';
    else rules += ' _Ia182';
    rules += ' OGcUfH182';
    rules += ' _Kc182';
    if (props.isStrokeInner) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' _Mc182';
    return rules;
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$preview = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _Nb182';
    rules += ' Pb182';
    rules += ' I8cyuNb182';
    rules += ' H8cyuNb182';
    rules += ' J39J4qb182';
    rules += ' Gk39J4qb182';
    if (props.isQuiet) {
        if (props.size === "S") rules += ' ob182';
        else if (props.size === "XS") rules += ' ob182';
        else rules += ' oc182';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' nb182';
        else if (props.size === "XS") rules += ' nb182';
        else rules += ' nc182';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' kb182';
        else if (props.size === "XS") rules += ' kb182';
        else rules += ' kc182';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' jb182';
        else if (props.size === "XS") rules += ' jb182';
        else rules += ' jc182';
    }
    if (props.isQuiet) {
        if (props.isSelected) rules += ' _nLeasBb182';
        else if (props.isFocusVisible) rules += ' _nLeasBb182';
        else if (props.isHovered) rules += ' _nLeasBb182';
    }
    if (props.isQuiet) {
        if (props.isFocusVisible) rules += ' _Lf182';
    } else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    return rules;
};
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$image = function anonymous(props) {
    let rules = " ";
    rules += ' Za182';
    if (props.layout === "grid") rules += ' fc182';
    rules += ' _Hb182';
    rules += ' _4c182';
    rules += ' _Ob182';
    return rules;
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$title = function anonymous(props) {
    let rules = " ";
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    rules += ' xfd182';
    rules += ' _xfa182';
    rules += ' xfX0cczbc182';
    rules += ' _xfX0cczba182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' po182';
    rules += ' __Ea182';
    rules += ' sa182';
    rules += ' __aa182';
    rules += ' __ba182';
    rules += ' zn9DOs182';
    rules += ' yn9DOs182';
    rules += ' Bn9DOs182';
    rules += ' An9DOs182';
    return rules;
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$description = function anonymous(props) {
    let rules = " ";
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    }
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fb182';
    rules += ' _FnuYUwec182';
    rules += ' pt182';
    rules += ' __Ea182';
    rules += ' sa182';
    rules += ' __aa182';
    rules += ' __ba182';
    rules += ' z9u7zPc182';
    rules += ' y9u7zPc182';
    rules += ' B9u7zPc182';
    rules += ' A9u7zPc182';
    return rules;
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$content = function anonymous(props) {
    let rules = " ";
    rules += ' se182';
    rules += ' DM8Mfn182';
    rules += ' DlsIuJI4ff4182';
    rules += ' CfLapxc182';
    rules += ' ClsIuJg9IhLd182';
    rules += ' qb182';
    rules += ' _ub182';
    rules += ' ea182';
    rules += ' _cf182';
    if (props.size === "XL") rules += ' Ue182';
    else if (props.size === "L") rules += ' UWJpoB182';
    else if (props.size === "M") rules += ' UWJpoB182';
    else if (props.size === "S") rules += ' Ub182';
    else if (props.size === "XS") rules += ' Ub182';
    rules += ' T5gMYHd182';
    rules += ' Tbd182';
    rules += ' Q69YG2b182';
    rules += ' Qkd182';
    return rules;
};
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$actionMenu = " zgSHDrc182 ygSHDrc182 BgSHDrc182 AgSHDrc182 JTnYEIe182 GTnYEIe182";
let $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$footer = " sd182 _tc182 ec182 _Ce182 Ue182 qe182 T69YG2b182";
const $39a13d9ee2d35a29$export$cb658fed5fefe1d = (0, $eF4cA.createContext)({
    ElementType: 'div',
    layout: 'grid'
});
const $39a13d9ee2d35a29$export$d0b2ee33ebf7d64 = (0, $eF4cA.createContext)(null);
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext = (0, $eF4cA.createContext)({
    isQuiet: false,
    size: 'M',
    isSelected: false,
    isHovered: false,
    isFocusVisible: false,
    isPressed: false,
    isCheckboxSelection: true
});
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$actionButtonSize = {
    XS: 'XS',
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const $39a13d9ee2d35a29$export$60332b2344f7fe41 = (0, $eF4cA.forwardRef)(function Card(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $39a13d9ee2d35a29$export$d0b2ee33ebf7d64);
    let { ElementType: ElementType, layout: layout } = (0, $eF4cA.useContext)($39a13d9ee2d35a29$export$cb658fed5fefe1d);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { density: density = 'regular', size: size = 'M', variant: variant = 'primary', UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles, id: id, ...otherProps } = props;
    let isQuiet = variant === 'quiet';
    let isSkeleton = (0, $91SAk.useIsSkeleton)();
    let children = (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                (0, $8g9SZ.ImageContext),
                {
                    alt: '',
                    styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$image({
                        layout: layout
                    })
                }
            ],
            [
                (0, $208Op.TextContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        title: {
                            styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$title({
                                size: size
                            })
                        },
                        description: {
                            styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$description({
                                size: size
                            })
                        }
                    }
                }
            ],
            [
                (0, $208Op.ContentContext),
                {
                    styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$content({
                        size: size
                    })
                }
            ],
            [
                (0, $8Muzv.DividerContext),
                {
                    size: 'S'
                }
            ],
            [
                (0, $208Op.FooterContext),
                {
                    styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$footer
                }
            ],
            [
                (0, $gc2oq.ActionMenuContext),
                {
                    isQuiet: true,
                    size: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$actionButtonSize[size],
                    isDisabled: isSkeleton,
                    // @ts-ignore
                    'data-slot': 'menu',
                    styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$actionMenu
                }
            ],
            [
                (0, $91SAk.SkeletonContext),
                isSkeleton
            ]
        ],
        children: (0, $dx4lB.jsx)((0, $jTg9X.ImageCoordinator), {
            children: typeof props.children === 'function' ? props.children({
                size: size
            }) : props.children
        })
    });
    // oxlint-disable-next-line react/react-compiler
    let press = (0, $i93Vd.pressScale)(domRef, UNSAFE_style);
    if (ElementType === 'div' && !isSkeleton && props.href) // NOTE: In this case, the card must not contain interactive elements.
    return (0, $dx4lB.jsx)((0, $k8kxd.Link), {
        ...(0, $fVfXf.filterDOMProps)(otherProps, {
            isLink: true
        }),
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$card({
                ...renderProps,
                size: size,
                density: density,
                variant: variant,
                isCardView: false,
                isLink: true
            }, styles),
        style: (renderProps)=>variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: (renderProps)=>(0, $dx4lB.jsx)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext.Provider, {
                value: {
                    size: size,
                    isQuiet: isQuiet,
                    isCheckboxSelection: false,
                    isSelected: false,
                    ...renderProps
                },
                children: children
            })
    });
    if (ElementType === 'div' || isSkeleton) return (0, $dx4lB.jsx)("div", {
        ...(0, $fVfXf.filterDOMProps)(otherProps),
        id: id != null ? String(id) : undefined,
        // @ts-ignore - React < 19 compat
        inert: (0, $gF3YT.inertValue)(isSkeleton),
        ref: domRef,
        className: UNSAFE_className + $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$card({
            size: size,
            density: density,
            variant: variant,
            isCardView: ElementType !== 'div'
        }, styles),
        style: UNSAFE_style,
        children: (0, $dx4lB.jsx)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext.Provider, {
            value: {
                size: size,
                isQuiet: isQuiet,
                isCheckboxSelection: false,
                isHovered: false,
                isFocusVisible: false,
                isSelected: false,
                isPressed: false
            },
            children: children
        })
    });
    return (0, $dx4lB.jsx)(ElementType, {
        ...props,
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$card({
                ...renderProps,
                isCardView: true,
                isLink: !!props.href,
                size: size,
                density: density,
                variant: variant
            }, styles),
        style: (renderProps)=>variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: ({ selectionMode: selectionMode, selectionBehavior: selectionBehavior, isHovered: isHovered, isFocusVisible: isFocusVisible, isSelected: isSelected, isPressed: isPressed })=>(0, $dx4lB.jsx)($39a13d9ee2d35a29$export$cb658fed5fefe1d.Provider, {
                value: {
                    ElementType: 'div',
                    layout: layout
                },
                children: (0, $dx4lB.jsxs)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext.Provider, {
                    value: {
                        size: size,
                        isQuiet: isQuiet,
                        isCheckboxSelection: selectionMode !== 'none' && selectionBehavior === 'toggle',
                        isHovered: isHovered,
                        isFocusVisible: isFocusVisible,
                        isSelected: isSelected,
                        isPressed: isPressed
                    },
                    children: [
                        !isQuiet && (0, $dx4lB.jsx)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$SelectionIndicator, {}),
                        !isQuiet && selectionMode !== 'none' && selectionBehavior === 'toggle' && (0, $dx4lB.jsx)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$CardCheckbox, {}),
                        (0, $dx4lB.jsx)("div", {
                            className: " sc182",
                            children: children
                        })
                    ]
                })
            })
    });
});
function $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$SelectionIndicator() {
    let { size: size, isSelected: isSelected, isQuiet: isQuiet, isCheckboxSelection: isCheckboxSelection } = (0, $eF4cA.useContext)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext);
    return (0, $dx4lB.jsx)("div", {
        className: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$selectionIndicator({
            size: size,
            isSelected: isSelected,
            // Add an inner stroke only for quiet cards with no checkbox to
            // help distinguish the selected state from the preview.
            isStrokeInner: isQuiet && !isCheckboxSelection
        })
    });
}
function $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$CardCheckbox() {
    let { size: size } = (0, $eF4cA.useContext)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext);
    return (0, $dx4lB.jsx)("div", {
        className: " _Pa182 W5gMYHd182 _A5gMYHd182 _9d182 Tp182 Qp182 Sp182 Rp182 gGcUfH182 ob182 nb182 kb182 jb182 _n4zCLMe182",
        children: (0, $dx4lB.jsx)((0, $cxTG4.Checkbox), {
            slot: "selection",
            excludeFromTabOrder: true,
            size: size === 'XS' ? 'S' : size
        })
    });
}
const $39a13d9ee2d35a29$export$115f017852a4bb7c = (0, $eF4cA.forwardRef)(function CardPreview(props, ref) {
    let { size: size, isQuiet: isQuiet, isHovered: isHovered, isFocusVisible: isFocusVisible, isSelected: isSelected, isPressed: isPressed, isCheckboxSelection: isCheckboxSelection } = (0, $eF4cA.useContext)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsxs)("div", {
        ...(0, $fVfXf.filterDOMProps)(props),
        slot: "preview",
        ref: domRef,
        className: UNSAFE_className + $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$preview({
            size: size,
            isQuiet: isQuiet,
            isHovered: isHovered,
            isFocusVisible: isFocusVisible,
            isSelected: isSelected
        }),
        style: isQuiet ? (0, $i93Vd.pressScale)(domRef)({
            isPressed: isPressed
        }) : UNSAFE_style,
        children: [
            isQuiet && (0, $dx4lB.jsx)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$SelectionIndicator, {}),
            isQuiet && isCheckboxSelection && (0, $dx4lB.jsx)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$CardCheckbox, {}),
            (0, $dx4lB.jsx)("div", {
                className: " oi182 ni182 ki182 ji182 _Nb182 Pb182",
                children: props.children
            })
        ]
    });
// oxlint-enable react/react-compiler
});
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$collection = function anonymous(props) {
    let rules = " ";
    rules += ' se182';
    rules += ' DvhgoHd182';
    if (props.size === "S") rules += ' Ua182';
    else if (props.size === "XS") rules += ' Ua182';
    else rules += ' Ub182';
    if (props.size === "S") rules += ' qa182';
    else if (props.size === "XS") rules += ' qa182';
    else rules += ' qb182';
    return rules;
};
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$collectionImage = " Za182 fa182 f5DbKFc182 y5DbKFwoofG182 _Hb182 _Ob182 _4c182";
const $39a13d9ee2d35a29$export$c368ea3e577b1b86 = (0, $eF4cA.forwardRef)(function CollectionCardPreview(props, ref) {
    let { size: size } = (0, $eF4cA.useContext)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$InternalCardContext);
    return (0, $dx4lB.jsx)($39a13d9ee2d35a29$export$115f017852a4bb7c, {
        ...props,
        ref: ref,
        children: (0, $dx4lB.jsx)("div", {
            className: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$collection({
                size: size
            }),
            children: (0, $dx4lB.jsx)((0, $8g9SZ.ImageContext).Provider, {
                value: {
                    styles: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$collectionImage
                },
                children: props.children
            })
        })
    });
});
const $39a13d9ee2d35a29$export$eff93e4e59ccc3b8 = (0, $eF4cA.forwardRef)(function AssetCard(props1, ref) {
    let { layout: layout } = (0, $eF4cA.useContext)($39a13d9ee2d35a29$export$cb658fed5fefe1d);
    return (0, $dx4lB.jsx)($39a13d9ee2d35a29$export$60332b2344f7fe41, {
        ...props1,
        ref: ref,
        density: "regular",
        children: (0, $fDYaM.composeRenderProps)(props1.children, (children)=>(0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $8g9SZ.ImageContext),
                        {
                            alt: '',
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' Za182';
                                if (props.layout === "grid") rules += ' fa182';
                                rules += ' _Ha182';
                                rules += ' _Ob182';
                                rules += ' _4c182';
                                return rules;
                            }({
                                layout: layout
                            })
                        }
                    ],
                    [
                        (0, $dm5H1.IllustrationContext),
                        {
                            render (icon) {
                                return (0, $dx4lB.jsx)((0, $91SAk.SkeletonWrapper), {
                                    children: (0, $dx4lB.jsx)("div", {
                                        className: " sd182 eb182 _Ca182 gH182 fa182",
                                        children: icon
                                    })
                                });
                            },
                            styles: " Fd182 Le182 Ke182 Zc182"
                        }
                    ]
                ],
                children: children
            }))
    });
});
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$avatarSize = {
    XS: 24,
    S: 48,
    M: 64,
    L: 64,
    XL: 80
};
const $39a13d9ee2d35a29$export$78e8870b5d8ae469 = (0, $eF4cA.forwardRef)(function UserCard(props, ref) {
    let { size: size = 'M' } = props;
    return (0, $dx4lB.jsx)($39a13d9ee2d35a29$export$60332b2344f7fe41, {
        ...props,
        ref: ref,
        density: "spacious",
        children: (0, $fDYaM.composeRenderProps)(props.children, (children)=>(0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $8g9SZ.ImageContext),
                        {
                            alt: '',
                            styles: " Za182 fb182 _Hb182 _Ob182 _4c182"
                        }
                    ],
                    [
                        (0, $f16Ml.AvatarContext),
                        {
                            size: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$avatarSize[size],
                            UNSAFE_style: {
                                '--size': $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$avatarSize[size] / 16 + 'rem'
                            },
                            styles: " _Pc182 Jy182 Jkymupd0fnV8d182",
                            isOverBackground: true
                        }
                    ]
                ],
                children: children
            }))
    });
});
const $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$buttonSize = {
    XS: 'S',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const $39a13d9ee2d35a29$export$e6cbe35324ccf844 = (0, $eF4cA.forwardRef)(function ProductCard(props1, ref) {
    let { size: size = 'M' } = props1;
    return (0, $dx4lB.jsx)($39a13d9ee2d35a29$export$60332b2344f7fe41, {
        ...props1,
        ref: ref,
        density: "spacious",
        children: (0, $fDYaM.composeRenderProps)(props1.children, (children)=>(0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $8g9SZ.ImageContext),
                        {
                            slots: {
                                preview: {
                                    alt: '',
                                    styles: " Za182 fd182 _Hb182 _Ob182 _4c182"
                                },
                                thumbnail: {
                                    alt: '',
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' _Pc182';
                                        rules += ' _Ob182';
                                        rules += ' _4c182';
                                        if (props.size === "XL") rules += ' ZD182';
                                        else if (props.size === "L") rules += ' Zx182';
                                        else if (props.size === "M") rules += ' Zw182';
                                        else if (props.size === "S") rules += ' Zv182';
                                        else if (props.size === "XS") rules += ' Zo182';
                                        rules += ' FRuFGYc182';
                                        if (props.size === "S") rules += ' oa182';
                                        else if (props.size === "XS") rules += ' oa182';
                                        else rules += ' ob182';
                                        if (props.size === "S") rules += ' na182';
                                        else if (props.size === "XS") rules += ' na182';
                                        else rules += ' nb182';
                                        if (props.size === "S") rules += ' ka182';
                                        else if (props.size === "XS") rules += ' ka182';
                                        else rules += ' kb182';
                                        if (props.size === "S") rules += ' ja182';
                                        else if (props.size === "XS") rules += ' ja182';
                                        else rules += ' jb182';
                                        rules += ' _Hb182';
                                        rules += ' Jy182';
                                        rules += ' JkymupdLu7Bcc182';
                                        rules += ' _Lf182';
                                        if (props.size === "XS") rules += ' _Mb182';
                                        else rules += ' _Mc182';
                                        rules += ' OEzkoQe182';
                                        if (props.size === "XL") rules += ' -F_-Fy182';
                                        else if (props.size === "L") rules += ' -F_-Fw182';
                                        else if (props.size === "M") rules += ' -F_-Fv182';
                                        else if (props.size === "S") rules += ' -F_-Fu182';
                                        else if (props.size === "XS") rules += ' -F_-Fp182';
                                        return rules;
                                    }({
                                        size: size
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, $208Op.FooterContext),
                        {
                            styles: (0, $5nTep.mergeStyles)($39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$footer, " _Cb182")
                        }
                    ],
                    [
                        (0, $34HUQ.ButtonContext),
                        {
                            size: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$buttonSize[size]
                        }
                    ],
                    [
                        (0, $34HUQ.LinkButtonContext),
                        {
                            size: $39a13d9ee2d35a29$var$$68e4e6fe083e22fd$var$buttonSize[size]
                        }
                    ]
                ],
                children: children
            }))
    });
});

});
parcelRegister("gc2oq", function(module, exports) {

$parcel$export(module.exports, "ActionMenuContext", () => $41c30a6da037165b$export$7f4b66acaca28bd5);
$parcel$export(module.exports, "ActionMenu", () => $41c30a6da037165b$export$ed57a210b9d13bb6);

var $4W5AG = parcelRequire("4W5AG");

var $fL4LX = parcelRequire("fL4LX");

var $8wD3p = parcelRequire("8wD3p");

var $2t0pV = parcelRequire("2t0pV");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $gI8Gw = parcelRequire("gI8Gw");
function $41c30a6da037165b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $41c30a6da037165b$export$7f4b66acaca28bd5 = (0, $eF4cA.createContext)(null);
const $41c30a6da037165b$export$ed57a210b9d13bb6 = (0, $eF4cA.forwardRef)(function ActionMenu(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($41c30a6da037165b$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $41c30a6da037165b$export$7f4b66acaca28bd5);
    let buttonProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    if (buttonProps['aria-label'] === undefined) buttonProps['aria-label'] = stringFormatter.format('menu.moreActions');
    return (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip,
        children: [
            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                ref: ref,
                size: props.size,
                isDisabled: props.isDisabled,
                autoFocus: props.autoFocus,
                isQuiet: props.isQuiet,
                styles: props.styles,
                ...buttonProps,
                children: (0, $dx4lB.jsx)((0, $2t0pV.default), {})
            }),
            (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                items: props.items,
                disabledKeys: props.disabledKeys,
                onAction: props.onAction,
                size: props.menuSize,
                shouldCloseOnSelect: props.shouldCloseOnSelect,
                children: props.children
            })
        ]
    });
});

});
parcelRegister("8wD3p", function(module, exports) {

$parcel$export(module.exports, "sectionHeader", () => $03ea609460f0c367$export$562e61a0817eb32e);
$parcel$export(module.exports, "sectionHeading", () => $03ea609460f0c367$export$300ac6f106ef584d);
$parcel$export(module.exports, "menuitem", () => $03ea609460f0c367$export$f68e44d881264486);
$parcel$export(module.exports, "checkmark", () => $03ea609460f0c367$export$292abbf31ed842a);
$parcel$export(module.exports, "checkbox", () => $03ea609460f0c367$export$b07e517d22efa1ca);
$parcel$export(module.exports, "icon", () => $03ea609460f0c367$export$1ca1ec8b29a4ce27);
$parcel$export(module.exports, "iconCenterWrapper", () => $03ea609460f0c367$export$31d1842a0fd736e6);
$parcel$export(module.exports, "label", () => $03ea609460f0c367$export$1237798dc640739a);
$parcel$export(module.exports, "description", () => $03ea609460f0c367$export$6d59db4903f20f7d);
$parcel$export(module.exports, "loadingWrapperStyles", () => $03ea609460f0c367$export$e152d023d7412712);
$parcel$export(module.exports, "progressCircleStyles", () => $03ea609460f0c367$export$8baf2a6025607324);
$parcel$export(module.exports, "Menu", () => $03ea609460f0c367$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "MenuSection", () => $03ea609460f0c367$export$4b1545b4f2016d26);
$parcel$export(module.exports, "MenuItem", () => $03ea609460f0c367$export$2ce376c2cc3355c8);
$parcel$export(module.exports, "MenuTrigger", () => $03ea609460f0c367$export$27d2ad3c5815583e);
$parcel$export(module.exports, "SubmenuTrigger", () => $03ea609460f0c367$export$ecabc99eeffab7ca);


var $4W5AG = parcelRequire("4W5AG");

var $cxTG4 = parcelRequire("cxTG4");

var $8OJ2z = parcelRequire("8OJ2z");

var $lTVIu = parcelRequire("lTVIu");

var $hxsf4 = parcelRequire("hxsf4");

var $8Muzv = parcelRequire("8Muzv");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $8g9SZ = parcelRequire("8g9SZ");

var $gUjW8 = parcelRequire("gUjW8");

var $2ffAV = parcelRequire("2ffAV");

var $fL4LX = parcelRequire("fL4LX");

var $iI3sv = parcelRequire("iI3sv");

var $gos6s = parcelRequire("gos6s");

var $5nTep = parcelRequire("5nTep");

var $i93Vd = parcelRequire("i93Vd");

var $fZShI = parcelRequire("fZShI");

var $kcpt6 = parcelRequire("kcpt6");

var $e0Enh = parcelRequire("e0Enh");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $bVwb4 = parcelRequire("bVwb4");

var $3g2oV = parcelRequire("3g2oV");

var $8dzVy = parcelRequire("8dzVy");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $3g2oV = parcelRequire("3g2oV");

var $n0XBd = parcelRequire("n0XBd");
var $eF2II = parcelRequire("eF2II");

var $7aYcI = parcelRequire("7aYcI");

var $jbXau = parcelRequire("jbXau");

var $ed0Y6 = parcelRequire("ed0Y6");

var $25dFS = parcelRequire("25dFS");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");
function $03ea609460f0c367$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $03ea609460f0c367$export$c7e742effb1c51e2 = (0, $eF4cA.createContext)(null);
const $03ea609460f0c367$var$$13afb0ea5f0ed767$var$menuItemGrid = {
    size: {
        S: [
            "calc(1.5rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(1.5rem * 3 / 8)"
        ],
        M: [
            "calc(2rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(2rem * 3 / 8)"
        ],
        L: [
            "calc(2.5rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(2.5rem * 3 / 8)"
        ],
        XL: [
            "calc(3rem * 3 / 8)",
            'auto',
            'auto',
            'minmax(0, 1fr)',
            'auto',
            'auto',
            'auto',
            "calc(3rem * 3 / 8)"
        ]
    }
};
let $03ea609460f0c367$export$b1e5508a851be14d = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' _Le182';
    rules += ' se182';
    if (props.size === "XL") rules += ' Dk92HIe182';
    else if (props.size === "L") rules += ' DyaX9Fb182';
    else if (props.size === "M") rules += ' Deb5jcb182';
    else if (props.size === "S") rules += ' DGTLJAe182';
    rules += ' _oa182';
    rules += ' K40ub4c182';
    if (!width) rules += ' Za182';
    if (props.isVirtualized) rules += ' _Na182';
    else if (props.isPopover) rules += ' _Na182';
    if (props.isVirtualized) rules += ' Pa182';
    else if (props.isPopover) rules += ' Pa182';
    if (props.isPopover) {
        if (!maxWidth) rules += ' Lh182';
    }
    if (props.isPopover) {
        if (props.isVirtualized) rules += ' Td182';
        else rules += ' Tt182';
    }
    if (props.isPopover) {
        if (props.isVirtualized) rules += ' Qd182';
        else rules += ' Qt182';
    }
    if (props.isPopover) {
        if (props.isVirtualized) rules += ' Sd182';
        else rules += ' St182';
    }
    if (props.isPopover) {
        if (props.isVirtualized) rules += ' Rd182';
        else rules += ' Rt182';
    }
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' __ya182';
    return rules;
};
const $03ea609460f0c367$var$$13afb0ea5f0ed767$var$virtualizedMenuWidth = function anonymous(props) {
    let rules = " ";
    if (props.isVirtualized) rules += ' ZNqBXK182';
    return rules;
};
let $03ea609460f0c367$export$fe2e36411d703b3d = function anonymous(props) {
    let rules = " ";
    rules += ' z2mU182';
    rules += ' yzZKy182';
    rules += ' eb182';
    rules += ' se182';
    rules += ' CcAc39c182';
    if (props.size === "XL") rules += ' Dk92HIe182';
    else if (props.size === "L") rules += ' DyaX9Fb182';
    else if (props.size === "M") rules += ' Deb5jcb182';
    else if (props.size === "S") rules += ' DGTLJAe182';
    return rules;
};
let $03ea609460f0c367$export$562e61a0817eb32e = function anonymous(props) {
    let rules = " ";
    rules += ' pt182';
    rules += ' z3mU182';
    rules += ' yAZKy182';
    if (props.isVirtualized) {
        if (props.size === "XL") rules += ' I2d3n182';
        else if (props.size === "L") rules += ' IaxPIqb182';
        else if (props.size === "M") rules += ' Ip2UVod182';
        else if (props.size === "S") rules += ' IH8XZ7c182';
    }
    if (props.isVirtualized) {
        if (props.size === "XL") rules += ' H2d3n182';
        else if (props.size === "L") rules += ' HaxPIqb182';
        else if (props.size === "M") rules += ' Hp2UVod182';
        else if (props.size === "S") rules += ' HH8XZ7c182';
    }
    rules += ' _oa182';
    rules += ' MAyFGYc182';
    rules += ' Tu7Fubd182';
    rules += ' Qu7Fubd182';
    if (props.size === "XL") rules += ' -M_-Mk182';
    else if (props.size === "L") rules += ' -M_-Mh182';
    else if (props.size === "S") rules += ' -M_-Mg182';
    else if (props.size === "XS") rules += ' -M_-Mf182';
    else rules += ' -M_-Mi182';
    return rules;
};
let $03ea609460f0c367$export$300ac6f106ef584d = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 _Fd182 _FnuYUweb182 pt182 Jy182 Gy182 Iy182 Hy182";
let $03ea609460f0c367$export$f68e44d881264486 = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let gridColumnStart = false;
    let gridColumnEnd = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "z") gridColumnStart = true;
        if (p[1] === "y") gridColumnEnd = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    if (props.isDisabled) rules += ' plc182';
    else if (props.isFocused) rules += ' ple182';
    else rules += ' plb182';
    rules += ' se182';
    rules += ' ea182';
    rules += ' egLWx3bb182';
    rules += ' _oa182';
    rules += ' Sd182';
    rules += ' Rd182';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl182';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj182';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf182';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne182';
    } else if (!minWidth) rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' qh182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' MAyFGYc182';
    rules += ' Td182';
    rules += ' QAzEcG182';
    rules += ' -aRvJDd-Tu7Fubd182';
    if (props.isFocused) {
        rules += ' gF182';
        rules += ' gle182';
    } else rules += ' g9182';
    if (!position) rules += ' _Pc182';
    if (!gridColumnStart) rules += ' z2mU182';
    if (!gridColumnEnd) rules += ' yzZKy182';
    rules += ' CcAc39c182';
    if (props.isVirtualized) {
        if (props.size === "XL") rules += ' Dk92HIe182';
        else if (props.size === "L") rules += ' DyaX9Fb182';
        else if (props.size === "M") rules += ' Deb5jcb182';
        else if (props.size === "S") rules += ' DGTLJAe182';
    } else rules += ' DLwlgod182';
    rules += ' EpvfBwb182';
    rules += ' EDNKd2dZQmDFe182';
    rules += ' UDNKd2dai5a0182';
    rules += ' FF182';
    rules += ' _Xa182';
    if (props.isLink) rules += ' ry182';
    else rules += ' ri182';
    rules += ' Yg182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _yb182';
    if (props.size === "XL") rules += ' -M_-Mk182';
    else if (props.size === "L") rules += ' -M_-Mh182';
    else if (props.size === "S") rules += ' -M_-Mg182';
    else if (props.size === "XS") rules += ' -M_-Mf182';
    else rules += ' -M_-Mi182';
    return rules;
};
let $03ea609460f0c367$export$292abbf31ed842a = function anonymous(props) {
    let rules = " ";
    if (props.isSelected) rules += ' _6c182';
    else rules += ' _6b182';
    rules += ' z2CW8rb182';
    rules += ' y2CW8rb182';
    rules += ' B2CW8rb182';
    rules += ' A2CW8rb182';
    if (props.isPressed) rules += ' ps182';
    else if (props.isFocusVisible) rules += ' ps182';
    else if (props.isHovered) rules += ' ps182';
    else rules += ' pu182';
    rules += ' -_8sjo0b-t5ZbAob182';
    if (props.isFocused) rules += ' -_8sjo0b-lt8pvGJ182';
    else rules += ' -_8sjo0b-lta182';
    rules += ' Hw182';
    rules += ' fa182';
    return rules;
};
let $03ea609460f0c367$export$b07e517d22efa1ca = " z2CW8rb182 y2CW8rb182 B2CW8rb182 A2CW8rb182 Hw182";
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$hiddenCheckbox = " _6b182";
let $03ea609460f0c367$export$1ca1ec8b29a4ce27 = " sb182 ZObNfn182 FObNfn182 Ht182 Hsu182 -_8sjo0b-t5ZbAob182";
let $03ea609460f0c367$export$31d1842a0fd736e6 = " sd182 z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182";
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$image = function anonymous(props) {
    let rules = " ";
    rules += ' z2U5Crc182';
    rules += ' y2U5Crc182';
    rules += ' B2U5Crc182';
    rules += ' AvoofG182';
    rules += ' Ht182';
    rules += ' Hsu182';
    rules += ' Jt182';
    rules += ' _dc182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    if (props.size === "XL") rules += ' ZF182';
    else if (props.size === "L") rules += ' Zx182';
    else if (props.size === "M") rules += ' Zw182';
    else if (props.size === "S") rules += ' ZC182';
    else rules += ' Zw182';
    if (props.size === "XL") rules += ' Fz182';
    else if (props.size === "L") rules += ' Fw182';
    else if (props.size === "M") rules += ' Fv182';
    else if (props.size === "S") rules += ' Fx182';
    else rules += ' Fv182';
    rules += ' fa182';
    rules += ' _Ha182';
    return rules;
};
let $03ea609460f0c367$export$1237798dc640739a = function anonymous(props) {
    let rules = " ";
    rules += ' zv6x9r182';
    rules += ' yv6x9r182';
    rules += ' Bv6x9r182';
    rules += ' Av6x9r182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' xc182';
    rules += ' _xa182';
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    rules += ' p40ub4c182';
    rules += ' JAzEcG182';
    return rules;
};
let $03ea609460f0c367$export$6d59db4903f20f7d = function anonymous(props) {
    let rules = " ";
    rules += ' z9u7zPc182';
    rules += ' y9u7zPc182';
    rules += ' B9u7zPc182';
    rules += ' A9u7zPc182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "M") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "M") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else if (props.isFocused) rules += ' pt182';
    else {
        if (props.isPressed) rules += ' pt182';
        else if (props.isFocusVisible) rules += ' pt182';
        else if (props.isHovered) rules += ' pt182';
        else rules += ' pv182';
    }
    rules += ' pl40ub4c182';
    return rules;
};
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$value = " z8bmXs182 y8bmXs182 B8bmXs182 A8bmXs182 Iv182";
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$keyboard = function anonymous(props) {
    let rules = " ";
    rules += ' z45MTAd182';
    rules += ' y45MTAd182';
    rules += ' B45MTAd182';
    rules += ' A45MTAd182';
    rules += ' Iv182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.isDisabled) rules += ' pp182';
    else rules += ' pn182';
    rules += ' pl40ub4c182';
    rules += ' _Wb182';
    rules += ' _3f182';
    return rules;
};
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptor = " z0cdLvd182 y0cdLvd182 B0cdLvd182 A0cdLvd182 _dd182 __Ac182 Iv182 -_8sjo0b-t5ZbAob182";
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptorIcon = function anonymous(props) {
    let rules = " ";
    rules += ' Hy182';
    rules += ' sb182';
    if (props.size === "XL") rules += ' Zp182';
    else if (props.size === "L") rules += ' Zo182';
    else if (props.size === "M") rules += ' Zm182';
    else if (props.size === "S") rules += ' Zu182';
    if (props.size === "XL") rules += ' Fq182';
    else if (props.size === "L") rules += ' Fp182';
    else if (props.size === "M") rules += ' Fn182';
    else if (props.size === "S") rules += ' Ft182';
    return rules;
};
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuContext = (0, $eF4cA.createContext)({
    size: 'M',
    isSubmenu: false,
    hideLinkOutIcon: false,
    isVirtualized: false
});
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuTriggerContext = (0, $eF4cA.createContext)(null);
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$UnavailableContext = (0, $eF4cA.createContext)(false);
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$wrappingDiv = " sd182 Za182 Fb182";
const $03ea609460f0c367$export$e152d023d7412712 = " z2mU182 yzZKy182 sd182 eb182 _Ca182 Jv182 Gv182";
const $03ea609460f0c367$export$8baf2a6025607324 = " ZObNfn182 FObNfn182";
const $03ea609460f0c367$var$$13afb0ea5f0ed767$var$emptyStateText = function anonymous(props) {
    let rules = " ";
    rules += ' FRuFGYc182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "M") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "M") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "M") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' Sv182';
    rules += ' Rv182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "M") rules += ' -F_-Fx182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    return rules;
};
const $03ea609460f0c367$var$$13afb0ea5f0ed767$var$ROW_HEIGHTS = {
    S: {
        medium: 24,
        large: 30
    },
    M: {
        medium: 32,
        large: 40
    },
    L: {
        medium: 40,
        large: 50
    },
    XL: {
        medium: 48,
        large: 60
    }
};
const $03ea609460f0c367$export$d9b273488cd8ce6f = (0, $eF4cA.forwardRef)(function Menu(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $03ea609460f0c367$export$c7e742effb1c51e2);
    let { isSubmenu: isSubmenu, size: ctxSize, isVirtualized: isParentVirtualized } = (0, $eF4cA.useContext)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuContext);
    let { children: children, size: size = ctxSize, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, hideLinkOutIcon: hideLinkOutIcon = false, items: items, loadingState: loadingState, onLoadMore: onLoadMore, isVirtualized: isVirtualized = isParentVirtualized } = props;
    let ctx = (0, $eF4cA.useContext)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuTriggerContext);
    let inPopover = (0, $eF4cA.useContext)((0, $2ffAV.InPopoverContext));
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($03ea609460f0c367$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let scale = (0, $e0Enh.useScale)();
    let menuLoadingCircle = (0, $dx4lB.jsx)((0, $bVwb4.MenuLoadMoreItem), {
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: $03ea609460f0c367$export$e152d023d7412712,
        children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
            isIndeterminate: true,
            size: "S",
            styles: $03ea609460f0c367$export$8baf2a6025607324,
            "aria-label": stringFormatter.format('menu.loadingMore')
        })
    });
    let renderer;
    if (typeof children === 'function' && items) renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: items,
                dependencies: props.dependencies,
                children: children
            }),
            menuLoadingCircle
        ]
    });
    else renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            children,
            menuLoadingCircle
        ]
    });
    let isPopover = (ctx || isSubmenu) && !inPopover;
    let menuContent = (0, $dx4lB.jsx)((0, $bVwb4.Menu), {
        ...props,
        className: $03ea609460f0c367$export$b1e5508a851be14d({
            size: size,
            isPopover: isPopover,
            isVirtualized: isVirtualized
        }, isPopover ? null : (0, $5nTep.mergeStyles)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$virtualizedMenuWidth({
            isVirtualized: isVirtualized && !inPopover
        }), styles)),
        renderEmptyState: ()=>loadingState === 'loading' ? (0, $dx4lB.jsx)("div", {
                className: $03ea609460f0c367$export$e152d023d7412712,
                children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                    isIndeterminate: true,
                    size: "S",
                    styles: $03ea609460f0c367$export$8baf2a6025607324,
                    "aria-label": stringFormatter.format('menu.loading')
                })
            }) : (0, $dx4lB.jsx)("span", {
                className: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$emptyStateText({
                    size: size
                }),
                children: stringFormatter.format('menu.noResults')
            }),
        children: renderer
    });
    let menuWithVirtualizer = isVirtualized ? (0, $dx4lB.jsx)((0, $eF2II.Virtualizer), {
        layout: (0, $n0XBd.ListLayout),
        layoutOptions: {
            estimatedRowSize: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$ROW_HEIGHTS[size][scale],
            estimatedHeadingSize: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$ROW_HEIGHTS[size][scale],
            padding: 8
        },
        children: menuContent
    }) : isParentVirtualized ? (0, $dx4lB.jsx)((0, $8dzVy.CollectionRendererContext).Provider, {
        value: (0, $8dzVy.DefaultCollectionRenderer),
        children: menuContent
    }) : menuContent;
    let content = (0, $dx4lB.jsx)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuContext.Provider, {
        value: {
            size: size,
            isSubmenu: true,
            hideLinkOutIcon: hideLinkOutIcon,
            isVirtualized: isVirtualized
        },
        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
            values: [
                [
                    (0, $208Op.HeaderContext),
                    {
                        styles: $03ea609460f0c367$export$562e61a0817eb32e({
                            size: size,
                            isVirtualized: isVirtualized
                        })
                    }
                ],
                [
                    (0, $208Op.HeadingContext),
                    {
                        // @ts-ignore
                        role: 'presentation',
                        styles: $03ea609460f0c367$export$300ac6f106ef584d
                    }
                ],
                [
                    (0, $208Op.TextContext),
                    {
                        slots: {
                            description: {
                                styles: $03ea609460f0c367$export$6d59db4903f20f7d({
                                    size: size,
                                    isFocused: false,
                                    isDisabled: false
                                })
                            }
                        }
                    }
                ],
                [
                    (0, $2ffAV.InPopoverContext),
                    false
                ]
            ],
            children: menuWithVirtualizer
        })
    });
    if (isPopover) return (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
        ref: ref,
        padding: "none",
        hideArrow: true,
        children: (0, $dx4lB.jsx)("div", {
            style: UNSAFE_style,
            className: (UNSAFE_className || '') + (0, $5nTep.mergeStyles)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$wrappingDiv, $03ea609460f0c367$var$$13afb0ea5f0ed767$var$virtualizedMenuWidth({
                isVirtualized: isVirtualized
            }), styles),
            children: content
        })
    });
    return content;
});
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$dividerPlacement = " se182 z3mU182 yAZKy182 JydxGIe182 GydxGIe182";
// same approach as combobox, need a wrapper with a fixed height so virtualizer measures it properly
let $03ea609460f0c367$var$$13afb0ea5f0ed767$var$virtualizedDividerWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' sd182';
    rules += ' _ta182';
    rules += ' _Ca182';
    rules += ' Fk182';
    if (props.size === "XL") rules += ' I2d3n182';
    else if (props.size === "L") rules += ' IaxPIqb182';
    else if (props.size === "M") rules += ' Ip2UVod182';
    else if (props.size === "S") rules += ' IH8XZ7c182';
    if (props.size === "XL") rules += ' H2d3n182';
    else if (props.size === "L") rules += ' HaxPIqb182';
    else if (props.size === "M") rules += ' Hp2UVod182';
    else if (props.size === "S") rules += ' HH8XZ7c182';
    return rules;
};
const $03ea609460f0c367$export$2e0a83ec2e27ecbb = (0, $3g2oV.createLeafComponent)((0, $iI3sv.SeparatorNode), function Divider(props, ref, node) {
    let state = (0, $eF4cA.useContext)((0, $bVwb4.MenuStateContext));
    let { size: ctxSize, isVirtualized: isVirtualized } = (0, $eF4cA.useContext)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuContext);
    if ((0, $iI3sv.isSeparatorHidden)(node, state.collection)) return null;
    let dividerStyles = (0, $8Muzv.divider)({
        size: 'M',
        orientation: 'horizontal',
        isStaticColor: false
    });
    if (isVirtualized) return (0, $dx4lB.jsx)("div", {
        className: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$virtualizedDividerWrapper({
            size: ctxSize
        }),
        children: (0, $dx4lB.jsx)((0, $jbXau.Separator), {
            ...props,
            ref: ref,
            className: dividerStyles
        })
    });
    return (0, $dx4lB.jsx)((0, $jbXau.Separator), {
        ...props,
        ref: ref,
        className: (0, $5nTep.mergeStyles)(dividerStyles, $03ea609460f0c367$var$$13afb0ea5f0ed767$var$dividerPlacement)
    });
});
function $03ea609460f0c367$export$4b1545b4f2016d26(props) {
    // remember, context doesn't work if it's around Section nor inside
    let { size: size } = (0, $eF4cA.useContext)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuContext);
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $bVwb4.MenuSection), {
                ...props,
                className: $03ea609460f0c367$export$fe2e36411d703b3d({
                    size: size
                }),
                children: props.children
            }),
            (0, $dx4lB.jsx)($03ea609460f0c367$export$2e0a83ec2e27ecbb, {})
        ]
    });
}
const $03ea609460f0c367$var$$13afb0ea5f0ed767$var$checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const $03ea609460f0c367$var$$13afb0ea5f0ed767$var$linkIconSize = {
    S: 'M',
    M: 'L',
    L: 'XL',
    XL: 'XL'
};
function $03ea609460f0c367$var$$13afb0ea5f0ed767$var$UnavailableIconWrapper(props1) {
    let { direction: direction, size: size, id: id } = props1;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($03ea609460f0c367$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    return (0, $dx4lB.jsx)("div", {
        slot: "descriptor",
        className: (0, $5nTep.mergeStyles)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptor, " Gy3v5sb182"),
        id: id,
        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
            values: [
                [
                    (0, $dm5H1.IconContext),
                    {
                        slots: {
                            icon: {
                                styles: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptorIcon({
                                    size: size
                                })
                            }
                        }
                    }
                ]
            ],
            children: (0, $dx4lB.jsx)((0, $gUjW8.default), {
                "aria-label": stringFormatter.format('menu.unavailable'),
                className: function anonymous(props) {
                    let rules = " ";
                    if (props.direction === "rtl") {
                        rules += ' -Z4Pn4c-a182';
                        rules += ' __Ha182';
                    }
                    return rules;
                }({
                    direction: direction
                })
            })
        })
    });
}
function $03ea609460f0c367$export$2ce376c2cc3355c8(props1) {
    let ref = (0, $eF4cA.useRef)(null);
    let isLink = props1.href != null;
    let isLinkOut = isLink && props1.target === '_blank';
    let { size: size, hideLinkOutIcon: hideLinkOutIcon, isVirtualized: isVirtualized } = (0, $eF4cA.useContext)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuContext);
    let textValue = props1.textValue || (typeof props1.children === 'string' ? props1.children : undefined);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let isUnavailable = (0, $eF4cA.useContext)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$UnavailableContext);
    let infoIconId = (0, $25dFS.useId)();
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $bVwb4.MenuItem), {
        ...props1,
        "aria-describedby": isUnavailable ? infoIconId : undefined,
        textValue: textValue,
        ref: ref,
        style: (0, $i93Vd.pressScale)(ref, props1.UNSAFE_style),
        className: (renderProps)=>(props1.UNSAFE_className || '') + $03ea609460f0c367$export$f68e44d881264486({
                ...renderProps,
                isFocused: renderProps.hasSubmenu && renderProps.isOpen || renderProps.isFocused,
                size: size,
                isLink: isLink,
                isVirtualized: isVirtualized
            }, props1.styles),
        children: (renderProps)=>{
            let { children: children } = props1;
            let checkboxRenderProps = {
                ...renderProps,
                size: size,
                isFocused: false,
                isFocusVisible: false,
                isIndeterminate: false,
                isReadOnly: false,
                isInvalid: false,
                isRequired: false
            };
            let isFocused = renderProps.hasSubmenu && renderProps.isOpen || renderProps.isFocused;
            // virtualized doesnt use subgrid so always render a hidden checkbox for submenu triggers so they stay indented
            let showSelectionIndicator = !renderProps.hasSubmenu || isVirtualized;
            return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $dm5H1.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, $8OJ2z.centerBaseline)({
                                            slot: 'icon',
                                            styles: $03ea609460f0c367$export$31d1842a0fd736e6
                                        }),
                                        styles: $03ea609460f0c367$export$1ca1ec8b29a4ce27
                                    },
                                    descriptor: {
                                        render: (0, $8OJ2z.centerBaseline)({
                                            slot: 'descriptor',
                                            styles: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptor
                                        })
                                    } // TODO: remove once we have default?
                                }
                            }
                        ],
                        [
                            (0, $208Op.TextContext),
                            {
                                slots: {
                                    [(0, $fDYaM.DEFAULT_SLOT)]: {
                                        styles: $03ea609460f0c367$export$1237798dc640739a({
                                            size: size
                                        })
                                    },
                                    label: {
                                        styles: $03ea609460f0c367$export$1237798dc640739a({
                                            size: size
                                        })
                                    },
                                    description: {
                                        styles: $03ea609460f0c367$export$6d59db4903f20f7d({
                                            ...renderProps,
                                            size: size,
                                            isFocused: isFocused
                                        })
                                    },
                                    value: {
                                        styles: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$value
                                    }
                                }
                            }
                        ],
                        [
                            (0, $208Op.KeyboardContext),
                            {
                                styles: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$keyboard({
                                    ...renderProps,
                                    size: size,
                                    isFocused: isFocused
                                })
                            }
                        ],
                        [
                            (0, $8g9SZ.ImageContext),
                            {
                                styles: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$image({
                                    size: size
                                })
                            }
                        ]
                    ],
                    children: [
                        renderProps.selectionMode === 'single' && showSelectionIndicator && (0, $dx4lB.jsx)((0, $lTVIu.default), {
                            size: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$checkmarkIconSize[size],
                            className: $03ea609460f0c367$export$292abbf31ed842a({
                                ...renderProps,
                                isSelected: renderProps.isSelected && !renderProps.hasSubmenu,
                                size: size
                            })
                        }),
                        renderProps.selectionMode === 'multiple' && showSelectionIndicator && (0, $dx4lB.jsx)("div", {
                            "aria-hidden": renderProps.hasSubmenu || undefined,
                            className: (0, $5nTep.mergeStyles)($03ea609460f0c367$export$b07e517d22efa1ca, (0, $cxTG4.box)(checkboxRenderProps), renderProps.hasSubmenu ? $03ea609460f0c367$var$$13afb0ea5f0ed767$var$hiddenCheckbox : null),
                            children: (0, $dx4lB.jsx)((0, $lTVIu.default), {
                                size: size,
                                className: (0, $cxTG4.iconStyles)
                            })
                        }),
                        typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "label",
                            children: children
                        }) : children,
                        isLinkOut && !hideLinkOutIcon && (0, $dx4lB.jsx)("div", {
                            slot: "descriptor",
                            className: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptor,
                            children: (0, $dx4lB.jsx)((0, $gos6s.default), {
                                size: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$linkIconSize[size],
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a182';
                                        rules += ' __Ha182';
                                    }
                                    return rules;
                                }({
                                    direction: direction
                                })
                            })
                        }),
                        renderProps.hasSubmenu && (isUnavailable ? (0, $dx4lB.jsx)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$UnavailableIconWrapper, {
                            direction: direction,
                            size: size,
                            id: infoIconId
                        }) : (0, $dx4lB.jsx)("div", {
                            slot: "descriptor",
                            className: $03ea609460f0c367$var$$13afb0ea5f0ed767$var$descriptor,
                            children: (0, $dx4lB.jsx)((0, $hxsf4.default), {
                                size: size,
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a182';
                                        rules += ' __Ha182';
                                    }
                                    return rules;
                                }({
                                    direction: direction
                                })
                            })
                        }))
                    ]
                })
            });
        }
    });
// oxlint-enable react/react-compiler
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */ function $03ea609460f0c367$export$27d2ad3c5815583e(props) {
    // RAC sets isPressed via PressResponder when the menu is open.
    // We don't want press scaling to appear to get "stuck", so override this.
    // For mouse interactions, menus open on press start. When the popover underlay appears
    // it covers the trigger button, causing onPressEnd to fire immediately and no press scaling
    // to occur. We override this by listening for pointerup on the document ourselves.
    let [isPressed, setPressed] = (0, $eF4cA.useState)(false);
    let { addGlobalListener: addGlobalListener } = (0, $ed0Y6.useGlobalListeners)();
    let onPressStart = (e)=>{
        if (e.pointerType !== 'mouse') return;
        setPressed(true);
        addGlobalListener(document, 'pointerup', ()=>{
            setPressed(false);
        }, {
            once: true,
            capture: true
        });
    };
    let { align: align = 'start', direction: direction = 'bottom', shouldFlip: shouldFlip, trigger: trigger = 'press' } = props;
    let placement;
    switch(direction){
        case 'left':
        case 'right':
        case 'start':
        case 'end':
            placement = `${direction} ${align === 'end' ? 'bottom' : 'top'}`;
            break;
        case 'bottom':
        case 'top':
        default:
            placement = `${direction} ${align}`;
    }
    let holdAffordance = trigger === 'longPress';
    let actionButtonContext = (0, $fDYaM.useSlottedContext)((0, $4W5AG.ActionButtonContext)) || {};
    let toggleButtonContext = (0, $fDYaM.useSlottedContext)((0, $kcpt6.ToggleButtonContext)) || {};
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                (0, $4W5AG.ActionButtonContext),
                {
                    ...actionButtonContext,
                    holdAffordance: holdAffordance
                }
            ],
            [
                (0, $kcpt6.ToggleButtonContext),
                {
                    ...toggleButtonContext,
                    holdAffordance: holdAffordance
                }
            ]
        ],
        children: (0, $dx4lB.jsx)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$InternalMenuTriggerContext.Provider, {
            value: {
                align: props.align,
                direction: props.direction,
                shouldFlip: props.shouldFlip
            },
            children: (0, $dx4lB.jsx)((0, $2ffAV.PopoverContext).Provider, {
                value: {
                    hideArrow: true,
                    offset: props.trigger === 'contextMenu' ? 0 : 8,
                    crossOffset: 0,
                    placement: placement,
                    shouldFlip: shouldFlip
                },
                children: (0, $dx4lB.jsx)((0, $2ffAV.InPopoverContext).Provider, {
                    value: false,
                    children: (0, $dx4lB.jsx)((0, $bVwb4.MenuTrigger), {
                        ...props,
                        children: (0, $dx4lB.jsx)((0, $7aYcI.PressResponder), {
                            onPressStart: onPressStart,
                            isPressed: isPressed,
                            children: props.children
                        })
                    })
                })
            })
        })
    });
}
function $03ea609460f0c367$export$ecabc99eeffab7ca(props) {
    // For submenus, the offset from the edge of the popover should be 10px.
    // Subtract 8px for the padding around the parent menu.
    // Offset by padding + border so that the first item in a submenu lines up with the parent menu item.
    return (0, $dx4lB.jsxs)((0, $bVwb4.SubmenuTrigger), {
        ...props,
        children: [
            props.children[0],
            (0, $dx4lB.jsx)((0, $2ffAV.PopoverContext).Provider, {
                value: {
                    hideArrow: true,
                    offset: -2,
                    crossOffset: -8,
                    placement: 'end top'
                },
                children: props.children[1]
            })
        ]
    });
}
function $03ea609460f0c367$export$7c4f7fdc3a164ef(props) {
    let { isUnavailable: isUnavailable = false, children: children } = props;
    if (isUnavailable) return (0, $dx4lB.jsx)($03ea609460f0c367$var$$13afb0ea5f0ed767$var$UnavailableContext.Provider, {
        value: isUnavailable,
        children: (0, $dx4lB.jsxs)((0, $bVwb4.SubmenuTrigger), {
            children: [
                children[0],
                (0, $dx4lB.jsx)((0, $2ffAV.PopoverContext).Provider, {
                    value: {
                        hideArrow: true,
                        offset: -2,
                        crossOffset: -8,
                        placement: 'end top'
                    },
                    children: children[1]
                })
            ]
        })
    });
    return children[0];
}
function $03ea609460f0c367$export$aebfca372ec4a7db(props) {
    return (0, $dx4lB.jsx)("div", {});
}

});
parcelRegister("cxTG4", function(module, exports) {

$parcel$export(module.exports, "box", () => $30aa74e0f29ae6f8$export$827f4ee28efc37);
$parcel$export(module.exports, "iconStyles", () => $30aa74e0f29ae6f8$export$2c99b98b77550cb4);
$parcel$export(module.exports, "Checkbox", () => $30aa74e0f29ae6f8$export$48513f6b9f8ce62d);


var $8OJ2z = parcelRequire("8OJ2z");

var $lTVIu = parcelRequire("lTVIu");

var $5zkzX = parcelRequire("5zkzX");

var $j3pTw = parcelRequire("j3pTw");

var $8w4Nl = parcelRequire("8w4Nl");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $ed1Og = parcelRequire("ed1Og");

var $ed1Og = parcelRequire("ed1Og");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $30aa74e0f29ae6f8$export$b085522c77523c51 = (0, $eF4cA.createContext)(null);
const $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$field = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let gridColumnStart = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "z") gridColumnStart = true;
        rules += p[0];
    }
    rules += ' se182';
    if (props.isNoVisibleLabel) rules += ' DtyCQZ182';
    else rules += ' DE5iebb182';
    rules += ' qf182';
    rules += ' _ch182';
    if (props.isInCheckboxGroup) {
        if (!width) rules += ' Zd182';
    } else if (!width) rules += ' ZJ182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    else if (props.size === "XS") rules += ' pt182';
    else rules += ' pt182';
    if (props.size === "XL") rules += ' -BhX7R-Fz182';
    else if (props.size === "L") rules += ' -BhX7R-Fv182';
    else if (props.size === "S") rules += ' -BhX7R-Fp182';
    else if (props.size === "XS") rules += ' -BhX7R-Fn182';
    else rules += ' -BhX7R-Fx182';
    if (props.isInCheckboxGroup) {
        if (props.size === "XL") rules += ' Ua182';
        else if (props.size === "L") rules += ' Ua182';
        else if (props.size === "M") rules += ' Uai5a0182';
        else if (props.size === "S") rules += ' Uai5a0182';
    } else rules += ' UVxyPec182';
    if (props.isInForm) {
        if (!gridColumnStart) rules += ' zhJUGr182';
    }
    return rules;
};
const $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$wrapper = function anonymous(props) {
    let rules = " ";
    rules += ' se182';
    rules += ' DLwlgod182';
    rules += ' z2mU182';
    rules += ' yzZKy182';
    rules += ' _Pc182';
    rules += ' ea182';
    rules += ' Yc182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' __ca182';
    return rules;
};
const $30aa74e0f29ae6f8$export$827f4ee28efc37 = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-oa182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    if (props.size === "XL") rules += ' Zm182';
    else if (props.size === "L") rules += ' Zl182';
    else if (props.size === "S") rules += ' Zk182';
    else rules += ' Zu182';
    if (props.size === "XL") rules += ' Fn182';
    else if (props.size === "L") rules += ' Fm182';
    else if (props.size === "S") rules += ' Fl182';
    else rules += ' Ft182';
    rules += ' _va182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' _k7m7Gv182';
    rules += ' h7m7Gv182';
    rules += ' m7m7Gv182';
    rules += ' l7m7Gv182';
    rules += ' _oa182';
    rules += ' _jf182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _yb182';
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' gw182';
            rules += ' gld182';
        } else if (props.isInvalid) {
            if (props.isPressed) rules += ' gt182';
            else if (props.isFocusVisible) rules += ' gt182';
            else if (props.isHovered) rules += ' gt182';
            else rules += ' g_d182';
            rules += ' gl_b182';
        } else {
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' gY182';
                else if (props.isFocusVisible) rules += ' gY182';
                else if (props.isHovered) rules += ' gY182';
                else rules += ' g3182';
            } else {
                if (props.isPressed) rules += ' gu182';
                else if (props.isFocusVisible) rules += ' gu182';
                else if (props.isHovered) rules += ' gu182';
                else rules += ' g0182';
            }
            rules += ' gle182';
        }
    } else {
        rules += ' gX182';
        rules += ' gla182';
    }
    if (props.isSelected) rules += ' iA182';
    else if (props.isDisabled) {
        rules += ' io182';
        rules += ' ilc182';
    } else if (props.isInvalid) {
        if (props.isPressed) rules += ' im182';
        else if (props.isFocusVisible) rules += ' im182';
        else if (props.isHovered) rules += ' im182';
        else rules += ' ip182';
        rules += ' ile182';
    } else {
        if (props.isPressed) rules += ' in182';
        else if (props.isFocusVisible) rules += ' in182';
        else if (props.isHovered) rules += ' in182';
        else rules += ' iv182';
        rules += ' ila182';
    }
    return rules;
};
const $30aa74e0f29ae6f8$export$2c99b98b77550cb4 = " _Ob182 -_8sjo0b-txpP0Sb182 -_8sjo0b-lt8pvGJ182";
const $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$smallerSize = {
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const $30aa74e0f29ae6f8$export$48513f6b9f8ce62d = (0, $eF4cA.forwardRef)(function Checkbox({ children: children, ...props1 }, ref) {
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $30aa74e0f29ae6f8$export$b085522c77523c51);
    let boxRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null);
    let domRef = (0, $3PqDc.useFocusableRef)(ref, inputRef);
    let isInForm = !!(0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props1 = (0, $j3pTw.useFormProps)(props1);
    let isInCheckboxGroup = !!(0, $eF4cA.useContext)((0, $ed1Og.CheckboxGroupStateContext));
    let ctx = (0, $fDYaM.useSlottedContext)($30aa74e0f29ae6f8$export$b085522c77523c51, props1.slot);
    return (0, $dx4lB.jsx)((0, $ed1Og.CheckboxField), {
        ...props1,
        ref: domRef,
        inputRef: inputRef,
        style: props1.UNSAFE_style,
        className: (props1.UNSAFE_className || '') + $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$field({
            size: props1.size || 'M',
            isInCheckboxGroup: isInCheckboxGroup,
            isNoVisibleLabel: !children
        }, props1.styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $ed1Og.CheckboxButton), {
                        className: (renderProps)=>$30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$wrapper({
                                ...renderProps,
                                isInForm: isInForm,
                                size: props1.size || 'M'
                            }),
                        children: (renderProps)=>{
                            let checkbox = (0, $dx4lB.jsxs)("div", {
                                ref: boxRef,
                                style: (0, $i93Vd.pressScale)(boxRef)(renderProps),
                                className: $30aa74e0f29ae6f8$export$827f4ee28efc37({
                                    ...renderProps,
                                    isSelected: renderProps.isSelected || renderProps.isIndeterminate,
                                    size: props1.size || 'M',
                                    isEmphasized: isInCheckboxGroup ? ctx?.isEmphasized : props1.isEmphasized
                                }),
                                children: [
                                    renderProps.isIndeterminate && (0, $dx4lB.jsx)((0, $5zkzX.default), {
                                        size: $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$smallerSize[props1.size || 'M'],
                                        className: $30aa74e0f29ae6f8$export$2c99b98b77550cb4
                                    }),
                                    renderProps.isSelected && !renderProps.isIndeterminate && (0, $dx4lB.jsx)((0, $lTVIu.default), {
                                        size: $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$smallerSize[props1.size || 'M'],
                                        className: $30aa74e0f29ae6f8$export$2c99b98b77550cb4
                                    })
                                ]
                            });
                            // Only render checkbox without center baseline if no label.
                            // This avoids expanding the checkbox height to the font's line height.
                            if (!children) return checkbox;
                            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                                        children: checkbox
                                    }),
                                    (0, $dx4lB.jsx)("span", {
                                        className: " z3mU182",
                                        children: children
                                    })
                                ]
                            });
                        }
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: isInCheckboxGroup ? $30aa74e0f29ae6f8$var$$9b405e0f8095dce0$var$smallerSize[props1.size || 'M'] : props1.size || 'M',
                        styles: function anonymous(props) {
                            let rules = " ";
                            if (props.isInCheckboxGroup) rules += ' z3mU182';
                            else rules += ' z2mU182';
                            rules += ' Td182';
                            return rules;
                        }({
                            isInCheckboxGroup: isInCheckboxGroup
                        }),
                        isDisabled: isDisabled,
                        isInvalid: isInCheckboxGroup ? false : isInvalid,
                        description: props1.description,
                        showErrorIcon: true,
                        children: props1.errorMessage
                    })
                ]
            })
    });
});

});
parcelRegister("lTVIu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7c8fa2b70b2df4$export$2e2bcd8739ae039);


var $2jeL4 = parcelRequire("2jeL4");

var $cf1yk = parcelRequire("cf1yk");

var $l4sgh = parcelRequire("l4sgh");

var $hFzw0 = parcelRequire("hFzw0");

var $7Cs5t = parcelRequire("7Cs5t");

var $8k4S2 = parcelRequire("8k4S2");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zi182';
    else if (props.size === "XS") rules += ' Zi182';
    else if (props.size === "XXL") rules += ' Zu182';
    else if (props.size === "XL") rules += ' Zk182';
    else if (props.size === "L") rules += ' Zj182';
    else if (props.size === "M") rules += ' Zi182';
    if (props.size === "S") rules += ' Fj182';
    else if (props.size === "XS") rules += ' Fj182';
    else if (props.size === "XXL") rules += ' Ft182';
    else if (props.size === "XL") rules += ' Fl182';
    else if (props.size === "L") rules += ' Fk182';
    else if (props.size === "M") rules += ' Fj182';
    return rules;
};
function $ac7c8fa2b70b2df4$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $cf1yk.default), {
                ...otherProps,
                className: (otherProps.className || '') + $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $2jeL4.default), {
                ...otherProps,
                className: (otherProps.className || '') + $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $hFzw0.default), {
                ...otherProps,
                className: (otherProps.className || '') + $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles({
                    size: size
                })
            });
        case 'XXL':
            return (0, $dx4lB.jsx)((0, $8k4S2.default), {
                ...otherProps,
                className: (otherProps.className || '') + $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles({
                    size: size
                })
            });
        case 'XS':
            return (0, $dx4lB.jsx)((0, $7Cs5t.default), {
                ...otherProps,
                className: (otherProps.className || '') + $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles({
                    size: size
                })
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $l4sgh.default), {
                ...otherProps,
                className: (otherProps.className || '') + $ac7c8fa2b70b2df4$var$$81cf3d4588736e7d$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("2jeL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe99fe9c2362c666$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $fe99fe9c2362c666$var$$2226697abda770d9$var$SvgS2CheckmarkSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M4.313 10.98c-.308 0-.602-.137-.8-.375L.648 7.165a1.042 1.042 0 0 1 1.6-1.334L4.29 8.283l5.442-6.93a1.043 1.043 0 0 1 1.64 1.288l-6.24 7.941a1.04 1.04 0 0 1-.804.397z"
        })
    });
var $fe99fe9c2362c666$export$2e2bcd8739ae039 = $fe99fe9c2362c666$var$$2226697abda770d9$var$SvgS2CheckmarkSize200;

});

parcelRegister("cf1yk", function(module, exports) {

$parcel$export(module.exports, "default", () => $803578584c66de09$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $803578584c66de09$var$$350b1bc6d608703f$var$SvgS2CheckmarkSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.5 9.503c-.3 0-.584-.135-.774-.367l-2.45-3A1 1 0 1 1 1.823 4.87L3.481 6.9 8.161.888A1 1 0 0 1 9.74 2.118l-5.45 7a1 1 0 0 1-.777.385z"
        })
    });
var $803578584c66de09$export$2e2bcd8739ae039 = $803578584c66de09$var$$350b1bc6d608703f$var$SvgS2CheckmarkSize100;

});

parcelRegister("l4sgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b45312869b76096$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $4b45312869b76096$var$$31137b4739adcf2e$var$SvgS2CheckmarkSize75 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.667 9.074a.96.96 0 0 1-.737-.345L.753 6.116a.96.96 0 1 1 1.474-1.228l1.418 1.7 4.112-5.233a.96.96 0 1 1 1.51 1.186L4.422 8.707a.96.96 0 0 1-.741.367z"
        })
    });
var $4b45312869b76096$export$2e2bcd8739ae039 = $4b45312869b76096$var$$31137b4739adcf2e$var$SvgS2CheckmarkSize75;

});

parcelRegister("hFzw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9bab704b8920cf$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $4b9bab704b8920cf$var$$3fce75c1c33635c3$var$SvgS2CheckmarkSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M5.102 12.517c-.322 0-.627-.143-.833-.391L.989 8.191a1.083 1.083 0 0 1 .139-1.527 1.08 1.08 0 0 1 1.527.139l2.422 2.904 6.243-7.946a1.086 1.086 0 0 1 1.707 1.34l-7.072 9c-.203.258-.51.41-.838.416z"
        })
    });
var $4b9bab704b8920cf$export$2e2bcd8739ae039 = $4b9bab704b8920cf$var$$3fce75c1c33635c3$var$SvgS2CheckmarkSize300;

});

parcelRegister("7Cs5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6d890613ebfebd$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $7a6d890613ebfebd$var$$d40ccf970611a77a$var$SvgS2CheckmarkSize50 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M3.815 8.69a.92.92 0 0 1-.708-.333L1.216 6.09a.922.922 0 0 1 1.416-1.18l1.162 1.394 3.56-4.532a.92.92 0 1 1 1.45 1.14L4.54 8.336a.92.92 0 0 1-.712.352z"
        })
    });
var $7a6d890613ebfebd$export$2e2bcd8739ae039 = $7a6d890613ebfebd$var$$d40ccf970611a77a$var$SvgS2CheckmarkSize50;

});

parcelRegister("8k4S2", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d5556d177ae624$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $55d5556d177ae624$var$$d9785d3b2bcf9fb0$var$SvgS2CheckmarkSize400 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M5.864 14.115c-.335 0-.653-.15-.868-.407L1.25 9.21a1.13 1.13 0 1 1 1.736-1.447l2.854 3.424 7.148-9.1a1.13 1.13 0 1 1 1.777 1.396l-8.011 10.2a1.13 1.13 0 0 1-.872.432z"
        })
    });
var $55d5556d177ae624$export$2e2bcd8739ae039 = $55d5556d177ae624$var$$d9785d3b2bcf9fb0$var$SvgS2CheckmarkSize400;

});


parcelRegister("5zkzX", function(module, exports) {

$parcel$export(module.exports, "default", () => $842608305ce96058$export$2e2bcd8739ae039);


var $fHdy6 = parcelRequire("fHdy6");

var $kLeBf = parcelRequire("kLeBf");

var $5Fm5s = parcelRequire("5Fm5s");

var $17pfS = parcelRequire("17pfS");

var $9al9B = parcelRequire("9al9B");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $842608305ce96058$var$$f17037051ff08dc2$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zh182';
    else if (props.size === "XS") rules += ' Zh182';
    else if (props.size === "XL") rules += ' Zj182';
    else if (props.size === "L") rules += ' Zj182';
    else if (props.size === "M") rules += ' Zi182';
    if (props.size === "S") rules += ' Fi182';
    else if (props.size === "XS") rules += ' Fi182';
    else if (props.size === "XL") rules += ' Fk182';
    else if (props.size === "L") rules += ' Fk182';
    else if (props.size === "M") rules += ' Fj182';
    return rules;
};
function $842608305ce96058$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $kLeBf.default), {
                ...otherProps,
                className: (otherProps.className || '') + $842608305ce96058$var$$f17037051ff08dc2$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $fHdy6.default), {
                ...otherProps,
                className: (otherProps.className || '') + $842608305ce96058$var$$f17037051ff08dc2$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $17pfS.default), {
                ...otherProps,
                className: (otherProps.className || '') + $842608305ce96058$var$$f17037051ff08dc2$var$styles({
                    size: size
                })
            });
        case 'XS':
            return (0, $dx4lB.jsx)((0, $9al9B.default), {
                ...otherProps,
                className: (otherProps.className || '') + $842608305ce96058$var$$f17037051ff08dc2$var$styles({
                    size: size
                })
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $5Fm5s.default), {
                ...otherProps,
                className: (otherProps.className || '') + $842608305ce96058$var$$f17037051ff08dc2$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("fHdy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb15c49d2f2d971f$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $cb15c49d2f2d971f$var$$9fd3031c2a375e46$var$SvgS2DashSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.021 7.041H1.98a1.04 1.04 0 1 1 0-2.082h8.042a1.04 1.04 0 1 1 0 2.082"
        })
    });
var $cb15c49d2f2d971f$export$2e2bcd8739ae039 = $cb15c49d2f2d971f$var$$9fd3031c2a375e46$var$SvgS2DashSize200;

});

parcelRegister("kLeBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0516d6cadf06554$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $f0516d6cadf06554$var$$d5753fd4179867a9$var$SvgS2DashSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.5 6h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2"
        })
    });
var $f0516d6cadf06554$export$2e2bcd8739ae039 = $f0516d6cadf06554$var$$d5753fd4179867a9$var$SvgS2DashSize100;

});

parcelRegister("5Fm5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e48b11a7994608$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $56e48b11a7994608$var$$a754b887682adb0c$var$SvgS2DashSize75 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.99 4.96H1.01a.96.96 0 1 1 0-1.92h5.98a.96.96 0 1 1 0 1.92"
        })
    });
var $56e48b11a7994608$export$2e2bcd8739ae039 = $56e48b11a7994608$var$$a754b887682adb0c$var$SvgS2DashSize75;

});

parcelRegister("17pfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc650d7f1b4c753f$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $cc650d7f1b4c753f$var$$05ef56ae100d2cfa$var$SvgS2DashSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.61 7.085H1.39a1.084 1.084 0 1 1 0-2.17h9.22a1.084 1.084 0 1 1 0 2.17"
        })
    });
var $cc650d7f1b4c753f$export$2e2bcd8739ae039 = $cc650d7f1b4c753f$var$$05ef56ae100d2cfa$var$SvgS2DashSize300;

});

parcelRegister("9al9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf87847bf3435a9$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $3bf87847bf3435a9$var$$b7a07c0db3879898$var$SvgS2DashSize50 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M6.634 4.922H1.366a.922.922 0 0 1 0-1.844h5.268a.922.922 0 0 1 0 1.844"
        })
    });
var $3bf87847bf3435a9$export$2e2bcd8739ae039 = $3bf87847bf3435a9$var$$b7a07c0db3879898$var$SvgS2DashSize50;

});


parcelRegister("ed1Og", function(module, exports) {

$parcel$export(module.exports, "CheckboxContext", () => $989a19bd545f9e2e$export$b085522c77523c51);
$parcel$export(module.exports, "CheckboxFieldContext", () => $989a19bd545f9e2e$export$c32003b803b6c22e);
$parcel$export(module.exports, "CheckboxGroupStateContext", () => $989a19bd545f9e2e$export$139c5b8563afc1fc);
$parcel$export(module.exports, "CheckboxField", () => $989a19bd545f9e2e$export$94195a47b94ed396);
$parcel$export(module.exports, "CheckboxButton", () => $989a19bd545f9e2e$export$6e7a18c0548f3129);

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $i0SpD = parcelRequire("i0SpD");

var $8UElq = parcelRequire("8UElq");

var $c1ibQ = parcelRequire("c1ibQ");

var $1vcav = parcelRequire("1vcav");
var $k7WTY = parcelRequire("k7WTY");

var $6AoKT = parcelRequire("6AoKT");

var $eS2lQ = parcelRequire("eS2lQ");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $26CkO = parcelRequire("26CkO");

var $9yazy = parcelRequire("9yazy");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $989a19bd545f9e2e$export$b085522c77523c51 = (0, $eF4cA.createContext)(null);
const $989a19bd545f9e2e$export$c32003b803b6c22e = (0, $eF4cA.createContext)(null);
const $989a19bd545f9e2e$export$baf37c4be89255b8 = (0, $eF4cA.createContext)(null);
const $989a19bd545f9e2e$export$139c5b8563afc1fc = (0, $eF4cA.createContext)(null);
const $989a19bd545f9e2e$export$4aa08d5625cb8ead = (0, $eF4cA.forwardRef)(function CheckboxGroup(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $989a19bd545f9e2e$export$baf37c4be89255b8);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $eS2lQ.useCheckboxGroupState)({
        ...props,
        validationBehavior: validationBehavior
    });
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps: groupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $1vcav.useCheckboxGroup)({
        ...props,
        label: label,
        validationBehavior: validationBehavior
    }, state);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false,
            isInvalid: state.isInvalid,
            state: state
        },
        defaultClassName: 'react-aria-CheckboxGroup'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": props.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $989a19bd545f9e2e$export$139c5b8563afc1fc,
                state
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});
const $989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$InternalCheckboxContext = (0, $eF4cA.createContext)(null);
const $989a19bd545f9e2e$export$94195a47b94ed396 = (0, $eF4cA.forwardRef)(function Checkbox(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $fDYaM.useContextProps)(otherProps, ref, $989a19bd545f9e2e$export$c32003b803b6c22e);
    let groupState = (0, $eF4cA.useContext)($989a19bd545f9e2e$export$139c5b8563afc1fc);
    let [aria, inputRef] = $989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$useCheckboxAria(props, userProvidedInputRef);
    let { descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isInvalid: isInvalid, validationDetails: validationDetails, validationErrors: validationErrors } = aria;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-CheckboxField',
        values: {
            isSelected: isSelected,
            isIndeterminate: props.isIndeterminate || false,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isInvalid: isInvalid,
            isRequired: props.isRequired || false
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-indeterminate": props.isIndeterminate || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$InternalCheckboxContext,
                {
                    ...aria,
                    inputRef: inputRef,
                    defaultClassName: 'react-aria-CheckboxButton',
                    isIndeterminate: props.isIndeterminate,
                    isRequired: props.isRequired
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            // In a CheckboxGroup, validation is handled at the group level instead of repeated on each checkbox.
            [
                (0, $4kYL7.FieldErrorContext),
                groupState ? null : {
                    isInvalid: isInvalid,
                    validationDetails: validationDetails,
                    validationErrors: validationErrors
                }
            ]
        ]
    }, renderProps.children));
});
function $989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$useCheckboxAria(props, userProvidedInputRef) {
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let groupState = (0, $eF4cA.useContext)($989a19bd545f9e2e$export$139c5b8563afc1fc);
    let inputRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let checkboxProps = {
        ...(0, $fDYaM.removeDataAttributes)(props),
        children: typeof props.children === 'function' ? true : props.children,
        value: props.value,
        validationBehavior: validationBehavior
    };
    let aria = groupState ? (0, $k7WTY.useCheckboxGroupItem)(checkboxProps, groupState, inputRef) : (0, $6AoKT.useCheckbox)(checkboxProps, (0, $9yazy.useToggleState)(props), inputRef);
    return [
        aria,
        inputRef
    ];
}
const $989a19bd545f9e2e$export$48513f6b9f8ce62d = (0, $eF4cA.forwardRef)(function Checkbox(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $fDYaM.useContextProps)(otherProps, ref, $989a19bd545f9e2e$export$b085522c77523c51);
    let [aria, inputRef] = $989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$useCheckboxAria(props, userProvidedInputRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$InternalCheckboxContext.Provider, {
        value: {
            ...aria,
            inputRef: inputRef,
            defaultClassName: 'react-aria-Checkbox',
            isIndeterminate: props.isIndeterminate,
            isRequired: props.isRequired
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($989a19bd545f9e2e$export$6e7a18c0548f3129, {
        ...props,
        ref: ref
    }));
});
const $989a19bd545f9e2e$export$6e7a18c0548f3129 = (0, $eF4cA.forwardRef)(function CheckboxButton(props, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isPressed: isPressed, isInvalid: isInvalid, inputRef: inputRef, defaultClassName: defaultClassName, isIndeterminate: isIndeterminate, isRequired: isRequired } = (0, $eF4cA.useContext)($989a19bd545f9e2e$var$$ed8ccb2e23e76301$var$InternalCheckboxContext);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let isInteractionDisabled = isDisabled || isReadOnly;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: defaultClassName,
        values: {
            isSelected: isSelected,
            isIndeterminate: isIndeterminate || false,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isInvalid: isInvalid,
            isRequired: isRequired || false
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).label, {
        ...(0, $lhKAD.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-indeterminate": isIndeterminate || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
        ...(0, $lhKAD.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
});

});
parcelRegister("1vcav", function(module, exports) {

$parcel$export(module.exports, "useCheckboxGroup", () => $acf4bf10ec29524b$export$49ff6f28c54f1cbe);

var $5Vclw = parcelRequire("5Vclw");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $cI1qR = parcelRequire("cI1qR");

var $i1DSg = parcelRequire("i1DSg");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $acf4bf10ec29524b$export$49ff6f28c54f1cbe(props, state) {
    let { isDisabled: isDisabled, name: name, form: form, validationBehavior: validationBehavior = 'aria' } = props;
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    (0, $5Vclw.checkboxGroupData).set(state, {
        name: name,
        form: form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    return {
        groupProps: (0, $lhKAD.mergeProps)(domProps, {
            role: 'group',
            'aria-disabled': isDisabled || undefined,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("5Vclw", function(module, exports) {

$parcel$export(module.exports, "checkboxGroupData", () => $069e7709509972bc$export$ec98120685d4f57d);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $069e7709509972bc$export$ec98120685d4f57d = new WeakMap();

});


parcelRegister("k7WTY", function(module, exports) {

$parcel$export(module.exports, "useCheckboxGroupItem", () => $cc3940890bbb00dd$export$353b32fc6898d37d);

var $6AoKT = parcelRequire("6AoKT");

var $5Vclw = parcelRequire("5Vclw");

var $iEwfj = parcelRequire("iEwfj");

var $eF4cA = parcelRequire("eF4cA");

var $9yazy = parcelRequire("9yazy");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cc3940890bbb00dd$export$353b32fc6898d37d(props, state, inputRef) {
    const toggleState = (0, $9yazy.useToggleState)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        defaultSelected: state.defaultValue.includes(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { name: name, form: form, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $5Vclw.checkboxGroupData).get(state);
    validationBehavior = props.validationBehavior ?? validationBehavior;
    // Local validation for this checkbox.
    let { realtimeValidation: realtimeValidation } = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: 'aria'
    });
    // Update the checkbox group state when realtime validation changes.
    let nativeValidation = (0, $eF4cA.useRef)((0, $iEwfj.DEFAULT_VALIDATION_RESULT));
    let updateValidation = ()=>{
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, $eF4cA.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    let displayValidation = validationBehavior === 'native' ? state.displayValidation : combinedRealtimeValidation;
    let res = (0, $6AoKT.useCheckbox)({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        form: props.form || form,
        isRequired: props.isRequired ?? state.isRequired,
        validationBehavior: validationBehavior,
        [(0, $iEwfj.privateValidationStateProp)]: {
            realtimeValidation: combinedRealtimeValidation,
            displayValidation: displayValidation,
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation,
            updateValidation (v) {
                nativeValidation.current = v;
                updateValidation();
            }
        }
    }, toggleState, inputRef);
    return {
        ...res,
        inputProps: {
            ...res.inputProps,
            'aria-describedby': [
                res.inputProps['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }
    };
}

});
parcelRegister("6AoKT", function(module, exports) {

$parcel$export(module.exports, "useCheckbox", () => $5fd97a45ffcdac09$export$e375f10ce42261c5);

var $gp6My = parcelRequire("gp6My");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5fd97a45ffcdac09$export$e375f10ce42261c5(props, state, inputRef) {
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly, isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $gp6My.useToggle)(props, state, inputRef);
    let { isIndeterminate: isIndeterminate } = props;
    (0, $eF4cA.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    return {
        labelProps: (0, $lhKAD.mergeProps)(labelProps, (0, $eF4cA.useMemo)(()=>({
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: inputProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("gp6My", function(module, exports) {

$parcel$export(module.exports, "useToggle", () => $005ec78684fb319f$export$cbe85ee05b554577);

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $3rgVl = parcelRequire("3rgVl");

var $56aMA = parcelRequire("56aMA");

var $bEes0 = parcelRequire("bEes0");

var $czVXo = parcelRequire("czVXo");

var $eF4cA = parcelRequire("eF4cA");

var $iEwfj = parcelRequire("iEwfj");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $005ec78684fb319f$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, form: form, children: children, isRequired: isRequired, validationBehavior: validationBehavior = 'aria', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    (0, $56aMA.useFormValidation)(props, validationState, ref);
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected((0, $fvyIQ.getEventTarget)(e).checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let [isLabelPressed, setLabelPressed] = (0, $eF4cA.useState)(false);
    let { pressProps: labelProps } = (0, $bEes0.usePress)({
        onPressStart (e) {
            // Keyboard interactions are handled directly on the input.
            if (e.pointerType === 'keyboard' || e.pointerType === 'virtual') {
                e.continuePropagation();
                return;
            }
            onPressStart?.(e);
            onPressChange?.(true);
            setLabelPressed(true);
        },
        onPressEnd (e) {
            // Keyboard interactions are handled directly on the input.
            if (e.pointerType === 'keyboard' || e.pointerType === 'virtual') {
                e.continuePropagation();
                return;
            }
            onPressEnd?.(e);
            onPressChange?.(false);
            setLabelPressed(false);
        },
        onPressUp (e) {
            if (e.pointerType === 'keyboard' || e.pointerType === 'virtual') {
                e.continuePropagation();
                return;
            }
            onPressUp?.(e);
        },
        onClick: onClick,
        onPress (e) {
            if (e.pointerType === 'keyboard' || e.pointerType === 'virtual') {
                e.continuePropagation();
                return;
            }
            onPress?.(e);
            state.toggle();
            ref.current?.focus();
            // @ts-expect-error
            let { [(0, $iEwfj.privateValidationStateProp)]: groupValidationState } = props;
            // oxlint-disable-next-line react/react-compiler
            let { commitValidation: commitValidation } = groupValidationState ? groupValidationState : validationState;
            commitValidation();
        },
        isDisabled: isDisabled || isReadOnly
    });
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)(props, ref);
    let interactions = (0, $lhKAD.mergeProps)(pressProps, focusableProps);
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    (0, $3rgVl.useFormReset)(ref, state.defaultSelected, state.setSelected);
    // Copied from useField because we don't want the label behavior that provides.
    let descriptionProps = (0, $czVXo.useSlotId2)();
    let errorMessageProps = (0, $czVXo.useSlotId2)();
    return {
        labelProps: (0, $lhKAD.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $lhKAD.mergeProps)(domProps, {
            checked: state.isSelected,
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            required: isRequired && validationBehavior === 'native',
            'aria-invalid': isInvalid || props.validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            'aria-describedby': [
                descriptionProps.id,
                errorMessageProps.id,
                ariaDescribedby
            ].filter(Boolean).join(' ') || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            form: form,
            type: 'checkbox',
            ...interactions
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || props.validationState === 'invalid',
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("3rgVl", function(module, exports) {

$parcel$export(module.exports, "useFormReset", () => $05df127ab1c1a1d7$export$5add1d006293d136);

var $4lMDe = parcelRequire("4lMDe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $05df127ab1c1a1d7$export$5add1d006293d136(ref, initialValue, onReset) {
    let handleReset = (0, $4lMDe.useEffectEvent)((e)=>{
        if (onReset && !e.defaultPrevented) onReset(initialValue);
    });
    (0, $eF4cA.useEffect)(()=>{
        let form = ref?.current?.form;
        // 'reset' does not compose across shadow DOM boundaries, but this listener is intentionally
        // scoped to this specific form element (not a global target), so shadow root propagation does
        // not apply here.
        // oxlint-disable-next-line rsp-rules/no-non-composing-event-listener
        form?.addEventListener('reset', handleReset);
        return ()=>{
            form?.removeEventListener('reset', handleReset);
        };
    }, [
        ref
    ]);
}

});

parcelRegister("56aMA", function(module, exports) {

$parcel$export(module.exports, "useFormValidation", () => $9d840ded81347080$export$b8473d3665f3a75a);

var $fvyIQ = parcelRequire("fvyIQ");

var $YxOvP = parcelRequire("YxOvP");

var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9d840ded81347080$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $4skXn.useLayoutEffect)(()=>{
        if (validationBehavior === 'native' && ref?.current && 'setCustomValidity' in ref.current && !ref.current.disabled) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(' ') || 'Invalid value.' : '';
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute('title')) ref.current.title = '';
            if (!state.realtimeValidation.isInvalid) state.updateValidation($9d840ded81347080$var$$860f7da480e22816$var$getNativeValidity(ref.current));
        }
    });
    let isIgnoredReset = (0, $eF4cA.useRef)(false);
    let onReset = (0, $4lMDe.useEffectEvent)(()=>{
        if (!isIgnoredReset.current) state.resetValidation();
    });
    let onInvalid = (0, $4lMDe.useEffectEvent)((e)=>{
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref?.current?.form;
        if (!e.defaultPrevented && ref && form && $9d840ded81347080$var$$860f7da480e22816$var$getFirstInvalidInput(form) === ref.current) {
            if (focus) focus();
            else ref.current?.focus();
            (0, $YxOvP.setInteractionModality)('keyboard');
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $4lMDe.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, $eF4cA.useEffect)(()=>{
        let input = ref?.current;
        if (!input) return;
        let form = input.form;
        let reset = form?.reset;
        if (form) // validation errors that are returned by server actions.
        // To do this, we ignore programmatic form resets that occur outside a user event.
        // This is best-effort. There may be false positives, e.g. setTimeout.
        // oxlint-disable-next-line react/react-compiler
        form.reset = ()=>{
            // React uses MessageChannel for scheduling, so ignore 'message' events.
            isIgnoredReset.current = !window.event || window.event.type === 'message' && (0, $fvyIQ.getEventTarget)(window.event) instanceof MessagePort;
            reset?.call(form);
            isIgnoredReset.current = false;
        };
        // 'change' and 'reset' do not compose across shadow DOM boundaries, but these listeners are
        // intentionally scoped to this specific input/form element (not a global target), so shadow
        // root propagation does not apply here.
        input.addEventListener('invalid', onInvalid);
        // oxlint-disable-next-line rsp-rules/no-non-composing-event-listener
        input.addEventListener('change', onChange);
        // oxlint-disable-next-line rsp-rules/no-non-composing-event-listener
        form?.addEventListener('reset', onReset);
        return ()=>{
            input.removeEventListener('invalid', onInvalid);
            input.removeEventListener('change', onChange);
            form?.removeEventListener('reset', onReset);
            if (form) form.reset = reset;
        };
    }, [
        ref,
        validationBehavior
    ]);
}
function $9d840ded81347080$var$$860f7da480e22816$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $9d840ded81347080$var$$860f7da480e22816$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $9d840ded81347080$var$$860f7da480e22816$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $9d840ded81347080$var$$860f7da480e22816$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (element.validity?.valid === false) return element;
    }
    return null;
}

});

parcelRegister("czVXo", function(module, exports) {

$parcel$export(module.exports, "useSlotId2", () => $562f762d5450256d$export$ed2feabec4a533f4);

var $25dFS = parcelRequire("25dFS");

var $4skXn = parcelRequire("4skXn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $562f762d5450256d$export$9d4c57ee4c6ffdd8(initialState = true) {
    // Initial state is typically based on the parent having an aria-label or aria-labelledby.
    // If it does, this value should be false so that we don't update the state and cause a rerender when we go through the layoutEffect
    let [hasSlot, setHasSlot] = (0, $eF4cA.useState)(initialState);
    let hasRun = (0, $eF4cA.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    let ref = (0, $eF4cA.useCallback)((el)=>{
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function $562f762d5450256d$export$ed2feabec4a533f4(initialState = true) {
    let id = (0, $25dFS.useId)();
    let [ref, hasSlot] = $562f762d5450256d$export$9d4c57ee4c6ffdd8(initialState);
    return {
        id: hasSlot ? id : undefined,
        ref: ref
    };
}

});



parcelRegister("9yazy", function(module, exports) {

$parcel$export(module.exports, "useToggleState", () => $ca861598de288ab1$export$8042c6c013fd5226);

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ca861598de288ab1$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $iUErx.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange);
    let [initialValue] = (0, $eF4cA.useState)(isSelected);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        defaultSelected: props.defaultSelected ?? initialValue,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

});


parcelRegister("eS2lQ", function(module, exports) {

$parcel$export(module.exports, "useCheckboxGroupState", () => $8632747ce11ecdbd$export$daff6da51032a415);

var $iEwfj = parcelRequire("iEwfj");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8632747ce11ecdbd$export$daff6da51032a415(props = {}) {
    let [selectedValues, setValue] = (0, $iUErx.useControlledState)(props.value, props.defaultValue || [], props.onChange);
    let [initialValues] = (0, $eF4cA.useState)(selectedValues);
    let isRequired = !!props.isRequired && selectedValues.length === 0;
    let invalidValues = (0, $eF4cA.useRef)(new Map());
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: selectedValues
    });
    let isInvalid = validation.displayValidation.isInvalid;
    const state = {
        ...validation,
        value: selectedValues,
        defaultValue: props.defaultValue ?? initialValues,
        setValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected (value) {
            return selectedValues.includes(value);
        },
        addValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue((selectedValues)=>{
                if (!selectedValues.includes(value)) return selectedValues.concat(value);
                return selectedValues;
            });
        },
        removeValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
        },
        toggleValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
            else setValue(selectedValues.concat(value));
        },
        setInvalid (value, v) {
            let s = new Map(invalidValues.current);
            if (v.isInvalid) s.set(value, v);
            else s.delete(value);
            invalidValues.current = s;
            validation.updateValidation((0, $iEwfj.mergeValidation)(...s.values()));
        },
        validationState: props.validationState ?? (isInvalid ? 'invalid' : null),
        isInvalid: isInvalid,
        isRequired: isRequired
    };
    return state;
}

});



parcelRegister("hxsf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d1c0880f1ac415$export$2e2bcd8739ae039);


var $2okeJ = parcelRequire("2okeJ");

var $ivZKj = parcelRequire("ivZKj");

var $1yGIB = parcelRequire("1yGIB");

var $9T040 = parcelRequire("9T040");

var $i7Mdw = parcelRequire("i7Mdw");

var $j7LNI = parcelRequire("j7LNI");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zi182';
    else if (props.size === "XS") rules += ' Zg182';
    else if (props.size === "XXL") rules += ' Zu182';
    else if (props.size === "XL") rules += ' Zk182';
    else if (props.size === "L") rules += ' Zj182';
    else if (props.size === "M") rules += ' Zi182';
    if (props.size === "S") rules += ' Fj182';
    else if (props.size === "XS") rules += ' Fg182';
    else if (props.size === "XXL") rules += ' Ft182';
    else if (props.size === "XL") rules += ' Fl182';
    else if (props.size === "L") rules += ' Fk182';
    else if (props.size === "M") rules += ' Fj182';
    return rules;
};
function $00d1c0880f1ac415$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $ivZKj.default), {
                ...otherProps,
                className: (otherProps.className || '') + $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $2okeJ.default), {
                ...otherProps,
                className: (otherProps.className || '') + $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $9T040.default), {
                ...otherProps,
                className: (otherProps.className || '') + $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles({
                    size: size
                })
            });
        case 'XXL':
            return (0, $dx4lB.jsx)((0, $j7LNI.default), {
                ...otherProps,
                className: (otherProps.className || '') + $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles({
                    size: size
                })
            });
        case 'XS':
            return (0, $dx4lB.jsx)((0, $i7Mdw.default), {
                ...otherProps,
                className: (otherProps.className || '') + $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles({
                    size: size
                })
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $1yGIB.default), {
                ...otherProps,
                className: (otherProps.className || '') + $00d1c0880f1ac415$var$$4b69f02ec06b9226$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("2okeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $95efec2473e7159d$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $95efec2473e7159d$var$$229b932983a6c939$var$SvgS2ChevronSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M9.301 6c0-.049-.02-.095-.028-.143-.01-.068-.013-.136-.039-.2a.9.9 0 0 0-.2-.302L4.343.663a.912.912 0 0 0-1.29 1.29L7.102 6l-4.047 4.048a.912.912 0 0 0 1.289 1.289l4.691-4.692a.9.9 0 0 0 .2-.302c.026-.064.028-.132.04-.2C9.28 6.095 9.3 6.05 9.3 6"
        })
    });
var $95efec2473e7159d$export$2e2bcd8739ae039 = $95efec2473e7159d$var$$229b932983a6c939$var$SvgS2ChevronSize200;

});

parcelRegister("ivZKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0904512413a9f190$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $0904512413a9f190$var$$9478429bc3f7b6ed$var$SvgS2ChevronSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.965 5.178C7.978 5.118 8 5.061 8 5s-.021-.118-.034-.178c-.01-.05-.01-.102-.03-.15-.023-.058-.068-.107-.104-.16-.03-.042-.047-.09-.084-.127l-.004-.003-.003-.004L3.615.303a.875.875 0 1 0-1.23 1.244L5.88 5 2.385 8.453a.875.875 0 1 0 1.23 1.244L7.74 5.622l.003-.004.004-.003c.037-.038.055-.085.084-.127.036-.053.08-.102.104-.16.02-.048.02-.1.03-.15"
        })
    });
var $0904512413a9f190$export$2e2bcd8739ae039 = $0904512413a9f190$var$$9478429bc3f7b6ed$var$SvgS2ChevronSize100;

});

parcelRegister("1yGIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0078886f79616a$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $7b0078886f79616a$var$$4db503230000328c$var$SvgS2ChevronSize75 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M7.483 4.406 3.86.783a.84.84 0 1 0-1.188 1.188L5.702 5l-3.03 3.03A.84.84 0 1 0 3.86 9.216l3.623-3.623a.84.84 0 0 0 0-1.188"
        })
    });
var $7b0078886f79616a$export$2e2bcd8739ae039 = $7b0078886f79616a$var$$4db503230000328c$var$SvgS2ChevronSize75;

});

parcelRegister("9T040", function(module, exports) {

$parcel$export(module.exports, "default", () => $403f2a093070c02e$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $403f2a093070c02e$var$$a590e5c7c9dae776$var$SvgS2ChevronSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.361 6.328 5.03.996a.954.954 0 0 0-1.343 0 .95.95 0 0 0 0 1.344L8.346 7l-4.66 4.66a.95.95 0 0 0 1.344 1.344l5.331-5.332a.95.95 0 0 0 0-1.344"
        })
    });
var $403f2a093070c02e$export$2e2bcd8739ae039 = $403f2a093070c02e$var$$a590e5c7c9dae776$var$SvgS2ChevronSize300;

});

parcelRegister("i7Mdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2375494943ec7633$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $2375494943ec7633$var$$9ffec407d8936863$var$SvgS2ChevronSize50 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 6,
        viewBox: "0 0 6 6",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M1.985 5.961a.695.695 0 0 1-.7-.704.7.7 0 0 1 .209-.493L3.279 3 1.51 1.251A.7.7 0 0 1 1.3.757.696.696 0 0 1 2.492.255l2.275 2.247a.7.7 0 0 1 0 .996L2.477 5.76a.7.7 0 0 1-.492.201"
        })
    });
var $2375494943ec7633$export$2e2bcd8739ae039 = $2375494943ec7633$var$$9ffec407d8936863$var$SvgS2ChevronSize50;

});

parcelRegister("j7LNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $84895bad4173c488$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $84895bad4173c488$var$$0c7cb9e52fc14b01$var$SvgS2ChevronSize400 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M11.726 7.3 5.67 1.247A.988.988 0 1 0 4.27 2.645L9.628 8 4.27 13.355a.988.988 0 1 0 1.399 1.399l6.056-6.055a.99.99 0 0 0 0-1.398"
        })
    });
var $84895bad4173c488$export$2e2bcd8739ae039 = $84895bad4173c488$var$$0c7cb9e52fc14b01$var$SvgS2ChevronSize400;

});


parcelRegister("iI3sv", function(module, exports) {

$parcel$export(module.exports, "SeparatorNode", () => $1f0102afa7d8eeb6$export$7750289ca694c0b5);
$parcel$export(module.exports, "isSeparatorHidden", () => $1f0102afa7d8eeb6$export$7c4d41271d5ff34b);

var $bWhaY = parcelRequire("bWhaY");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $1f0102afa7d8eeb6$export$7750289ca694c0b5 extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'separator';
    }
    filter(collection, newCollection) {
        let prevItem = newCollection.getItem(this.prevKey);
        if (prevItem && prevItem.type !== 'separator') {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
function $1f0102afa7d8eeb6$export$7c4d41271d5ff34b(node, collection) {
    let nextNode = node.nextKey != null && collection.getItem(node.nextKey);
    return node.prevKey == null || !nextNode || nextNode.type === 'separator' || nextNode.type === 'loader' && nextNode.nextKey == null;
}

});

parcelRegister("gos6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9c2f86849403e5$export$2e2bcd8739ae039);


var $ldlSf = parcelRequire("ldlSf");

var $fwniU = parcelRequire("fwniU");

var $NCSEW = parcelRequire("NCSEW");

var $2F0sb = parcelRequire("2F0sb");

var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $3e9c2f86849403e5$var$$d9f847a2895a93dc$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XXL") rules += ' Zu182';
    else if (props.size === "XL") rules += ' Zk182';
    else if (props.size === "L") rules += ' Zj182';
    else if (props.size === "M") rules += ' Zi182';
    if (props.size === "XXL") rules += ' Ft182';
    else if (props.size === "XL") rules += ' Fl182';
    else if (props.size === "L") rules += ' Fk182';
    else if (props.size === "M") rules += ' Fj182';
    return rules;
};
function $3e9c2f86849403e5$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $fwniU.default), {
                ...otherProps,
                className: (otherProps.className || '') + $3e9c2f86849403e5$var$$d9f847a2895a93dc$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $ldlSf.default), {
                ...otherProps,
                className: (otherProps.className || '') + $3e9c2f86849403e5$var$$d9f847a2895a93dc$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $NCSEW.default), {
                ...otherProps,
                className: (otherProps.className || '') + $3e9c2f86849403e5$var$$d9f847a2895a93dc$var$styles({
                    size: size
                })
            });
        case 'XXL':
            return (0, $dx4lB.jsx)((0, $2F0sb.default), {
                ...otherProps,
                className: (otherProps.className || '') + $3e9c2f86849403e5$var$$d9f847a2895a93dc$var$styles({
                    size: size
                })
            });
    }
}

});
parcelRegister("ldlSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f86975c983bd91$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $b7f86975c983bd91$var$$1e6ac76633d3918d$var$SvgS2LinkOutSize200 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M10.089 1h-5.51a.911.911 0 0 0 0 1.822h3.31L1.355 9.355a.91.91 0 1 0 1.29 1.29L9.178 4.11v3.31a.911.911 0 0 0 1.822 0v-5.51A.91.91 0 0 0 10.089 1"
        })
    });
var $b7f86975c983bd91$export$2e2bcd8739ae039 = $b7f86975c983bd91$var$$1e6ac76633d3918d$var$SvgS2LinkOutSize200;

});

parcelRegister("fwniU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd4a291aa69bfaf9$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $cd4a291aa69bfaf9$var$$3a6f6b5d395042df$var$SvgS2LinkOutSize100 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M8.125 1H3.741a.875.875 0 1 0 0 1.75h2.27l-4.88 4.88a.88.88 0 0 0 0 1.24.873.873 0 0 0 1.238 0L7.25 3.987v2.27a.875.875 0 1 0 1.75 0V1.876A.875.875 0 0 0 8.125 1"
        })
    });
var $cd4a291aa69bfaf9$export$2e2bcd8739ae039 = $cd4a291aa69bfaf9$var$$3a6f6b5d395042df$var$SvgS2LinkOutSize100;

});

parcelRegister("NCSEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e1bd1955ea0ab0$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $d0e1bd1955ea0ab0$var$$c1512f1df9c6d976$var$SvgS2LinkOutSize300 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M12.05 1H5.164a.949.949 0 1 0 0 1.898h4.595l-8.18 8.18a.95.95 0 0 0 1.344 1.344l8.18-8.18v4.595a.949.949 0 1 0 1.898 0V1.949A.95.95 0 0 0 12.05 1"
        })
    });
var $d0e1bd1955ea0ab0$export$2e2bcd8739ae039 = $d0e1bd1955ea0ab0$var$$c1512f1df9c6d976$var$SvgS2LinkOutSize300;

});

parcelRegister("2F0sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ac6765016095bb$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $91ac6765016095bb$var$$77729bea0e58bdda$var$SvgS2LinkOutSize400 = (props)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "M14.01 1h-8a.99.99 0 0 0 0 1.979h5.613L1.551 13.05a.988.988 0 1 0 1.398 1.398L13.021 4.377v5.612a.99.99 0 0 0 1.979 0v-8A.99.99 0 0 0 14.01 1"
        })
    });
var $91ac6765016095bb$export$2e2bcd8739ae039 = $91ac6765016095bb$var$$77729bea0e58bdda$var$SvgS2LinkOutSize400;

});


parcelRegister("kcpt6", function(module, exports) {

$parcel$export(module.exports, "ToggleButtonContext", () => $eef964243b6ed833$export$43506d75ebd2e218);


var $4W5AG = parcelRequire("4W5AG");

var $8OJ2z = parcelRequire("8OJ2z");

var $7PKMq = parcelRequire("7PKMq");

var $dm5H1 = parcelRequire("dm5H1");

var $i93Vd = parcelRequire("i93Vd");

var $91SAk = parcelRequire("91SAk");

var $208Op = parcelRequire("208Op");

var $3ILII = parcelRequire("3ILII");

var $3PqDc = parcelRequire("3PqDc");

var $j3pTw = parcelRequire("j3pTw");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $aeKbf = parcelRequire("aeKbf");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eef964243b6ed833$export$43506d75ebd2e218 = (0, $eF4cA.createContext)(null);
const $eef964243b6ed833$export$d2b052e7b4be1756 = (0, $eF4cA.forwardRef)(function ToggleButton(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $eef964243b6ed833$export$43506d75ebd2e218);
    props = (0, $j3pTw.useFormProps)(props);
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let ctx = (0, $fDYaM.useSlottedContext)((0, $3ILII.ToggleButtonGroupContext));
    let isInGroup = !!ctx;
    let { density: density = 'regular', isJustified: isJustified, orientation: orientation = 'horizontal', staticColor: staticColor = props.staticColor, isQuiet: isQuiet = props.isQuiet, isEmphasized: isEmphasized = props.isEmphasized, size: size = props.size || 'M', isDisabled: isDisabled = props.isDisabled } = ctx || {};
    let { holdAffordance: holdAffordance } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsxs)((0, $aeKbf.ToggleButton), {
        ...props,
        isDisabled: isDisabled,
        ref: domRef,
        style: (0, $i93Vd.pressScale)(domRef, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, $4W5AG.btnStyles)({
                ...renderProps,
                staticColor: staticColor,
                isStaticColor: !!staticColor,
                size: size,
                isQuiet: isQuiet,
                isEmphasized: isEmphasized,
                isPending: false,
                density: density,
                isJustified: isJustified,
                orientation: orientation,
                isInGroup: isInGroup
            }, props.styles),
        children: [
            (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $91SAk.SkeletonContext),
                        null
                    ],
                    [
                        (0, $208Op.TextContext),
                        {
                            styles: " TAzEcG182 QAzEcG182 _Jb182 _Nc182 Pc182 _Yb182 _7c182"
                        }
                    ],
                    [
                        (0, $dm5H1.IconContext),
                        {
                            render: (0, $8OJ2z.centerBaseline)({
                                slot: 'icon',
                                styles: " _Ja182"
                            }),
                            styles: " ZObNfn182 FObNfn182 I67logd182 _va182"
                        }
                    ]
                ],
                children: typeof props.children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: props.children
                }) : props.children
            }),
            holdAffordance && (0, $dx4lB.jsx)((0, $7PKMq.default), {
                size: size === 'XS' ? 'S' : size,
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' _Pa182';
                    if (props.size === "XL") rules += ' _zWJpoB182';
                    else if (props.size === "L") rules += ' _zC1otk182';
                    else if (props.size === "M") rules += ' _zE182';
                    else if (props.size === "S") rules += ' _zwtfhvc182';
                    else if (props.size === "XS") rules += ' _zwtfhvc182';
                    if (props.size === "XL") rules += ' _lWJpoB182';
                    else if (props.size === "L") rules += ' _lC1otk182';
                    else if (props.size === "M") rules += ' _lE182';
                    else if (props.size === "S") rules += ' _lwtfhvc182';
                    else if (props.size === "XS") rules += ' _lwtfhvc182';
                    if (props.direction === "rtl") {
                        rules += ' -Z4Pn4c-a182';
                        rules += ' __Ha182';
                    }
                    return rules;
                }({
                    direction: direction,
                    size: size
                })
            })
        ]
    });
// oxlint-enable react/react-compiler
});

});
parcelRegister("3ILII", function(module, exports) {

$parcel$export(module.exports, "ToggleButtonGroupContext", () => $e9b11b3c59738443$export$298258635ae0dd97);

var $waxwa = parcelRequire("waxwa");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4l6lZ = parcelRequire("4l6lZ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e9b11b3c59738443$export$298258635ae0dd97 = (0, $eF4cA.createContext)(null);
const $e9b11b3c59738443$export$40258cc1d95ff477 = (0, $eF4cA.forwardRef)(function ToggleButtonGroup(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $e9b11b3c59738443$export$298258635ae0dd97);
    let { density: density = 'regular', size: size = 'M', orientation: orientation = 'horizontal', isJustified: isJustified, children: children, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles } = props;
    return (0, $dx4lB.jsx)((0, $4l6lZ.ToggleButtonGroup), {
        ...props,
        ref: ref,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, $waxwa.actionGroupStyle)({
            size: size,
            density: density,
            orientation: orientation,
            isJustified: isJustified
        }, styles),
        children: (0, $dx4lB.jsx)($e9b11b3c59738443$export$298258635ae0dd97.Provider, {
            value: props,
            children: children
        })
    });
});

});
parcelRegister("4l6lZ", function(module, exports) {

$parcel$export(module.exports, "ToggleGroupStateContext", () => $963a8bb26b48568c$export$a8a71863db173133);
$parcel$export(module.exports, "ToggleButtonGroup", () => $963a8bb26b48568c$export$40258cc1d95ff477);

var $fDYaM = parcelRequire("fDYaM");

var $2FPWu = parcelRequire("2FPWu");

var $9aygw = parcelRequire("9aygw");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $f2MM7 = parcelRequire("f2MM7");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $963a8bb26b48568c$export$298258635ae0dd97 = (0, $eF4cA.createContext)({});
const $963a8bb26b48568c$export$a8a71863db173133 = (0, $eF4cA.createContext)(null);
const $963a8bb26b48568c$export$40258cc1d95ff477 = (0, $eF4cA.forwardRef)(function ToggleButtonGroup(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $963a8bb26b48568c$export$298258635ae0dd97);
    let state = (0, $f2MM7.useToggleGroupState)(props);
    let { groupProps: groupProps } = (0, $9aygw.useToggleButtonGroup)(props, state, ref);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            orientation: props.orientation || 'horizontal',
            isDisabled: state.isDisabled,
            state: state
        },
        defaultClassName: 'react-aria-ToggleButtonGroup'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'horizontal',
        "data-disabled": props.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($963a8bb26b48568c$export$a8a71863db173133.Provider, {
        value: state
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, renderProps.children)));
});

});
parcelRegister("9aygw", function(module, exports) {

$parcel$export(module.exports, "useToggleButtonGroup", () => $489d0a07499c74aa$export$dd5580ae642f110f);
$parcel$export(module.exports, "useToggleButtonGroupItem", () => $489d0a07499c74aa$export$bc53712daae3d6e6);

var $il6Ys = parcelRequire("il6Ys");

var $3usOD = parcelRequire("3usOD");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $489d0a07499c74aa$export$dd5580ae642f110f(props, state, ref) {
    let { isDisabled: isDisabled } = props;
    let { toolbarProps: toolbarProps } = (0, $3usOD.useToolbar)(props, ref);
    return {
        groupProps: {
            ...toolbarProps,
            role: state.selectionMode === 'single' ? 'radiogroup' : toolbarProps.role,
            'aria-disabled': isDisabled
        }
    };
}
function $489d0a07499c74aa$export$bc53712daae3d6e6(props, state, ref) {
    let toggleState = {
        isSelected: state.selectedKeys.has(props.id),
        defaultSelected: false,
        setSelected (isSelected) {
            state.setSelected(props.id, isSelected);
        },
        toggle () {
            state.toggleKey(props.id);
        }
    };
    let { isPressed: isPressed, isSelected: isSelected, isDisabled: isDisabled, buttonProps: buttonProps } = (0, $il6Ys.useToggleButton)({
        ...props,
        id: undefined,
        isDisabled: props.isDisabled || state.isDisabled
    }, toggleState, ref);
    if (state.selectionMode === 'single') {
        // oxlint-disable-next-line react/react-compiler
        buttonProps.role = 'radio';
        // oxlint-disable-next-line react/react-compiler
        buttonProps['aria-checked'] = toggleState.isSelected;
        // oxlint-disable-next-line react/react-compiler
        delete buttonProps['aria-pressed'];
    }
    return {
        isPressed: isPressed,
        isSelected: isSelected,
        isDisabled: isDisabled,
        buttonProps: buttonProps
    };
}

});
parcelRegister("il6Ys", function(module, exports) {

$parcel$export(module.exports, "useToggleButton", () => $f650e2b88a42769f$export$51e84d46ca0bc451);

var $fipJz = parcelRequire("fipJz");

var $d8j5I = parcelRequire("d8j5I");

var $lhKAD = parcelRequire("lhKAD");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f650e2b88a42769f$export$51e84d46ca0bc451(props, state, ref) {
    const { isSelected: isSelected } = state;
    const { isPressed: isPressed, buttonProps: buttonProps } = (0, $fipJz.useButton)({
        ...props,
        onPress: (0, $d8j5I.chain)(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        isSelected: isSelected,
        isDisabled: props.isDisabled || false,
        buttonProps: (0, $lhKAD.mergeProps)(buttonProps, {
            'aria-pressed': isSelected
        })
    };
}

});


parcelRegister("f2MM7", function(module, exports) {

$parcel$export(module.exports, "useToggleGroupState", () => $88bcfcbee37d3f3c$export$8deac67f4addf270);

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $88bcfcbee37d3f3c$export$8deac67f4addf270(props) {
    let { selectionMode: selectionMode = 'single', disallowEmptySelection: disallowEmptySelection, isDisabled: isDisabled = false } = props;
    let [selectedKeys, setSelectedKeys] = (0, $iUErx.useControlledState)((0, $eF4cA.useMemo)(()=>props.selectedKeys ? new Set(props.selectedKeys) : undefined, [
        props.selectedKeys
    ]), (0, $eF4cA.useMemo)(()=>props.defaultSelectedKeys ? new Set(props.defaultSelectedKeys) : new Set(), [
        props.defaultSelectedKeys
    ]), props.onSelectionChange);
    return {
        selectionMode: selectionMode,
        isDisabled: isDisabled,
        selectedKeys: selectedKeys,
        setSelectedKeys: setSelectedKeys,
        toggleKey (key) {
            let keys;
            if (selectionMode === 'multiple') {
                keys = new Set(selectedKeys);
                if (keys.has(key) && (!disallowEmptySelection || keys.size > 1)) keys.delete(key);
                else keys.add(key);
            } else keys = new Set(selectedKeys.has(key) && !disallowEmptySelection ? [] : [
                key
            ]);
            setSelectedKeys(keys);
        },
        setSelected (key, isSelected) {
            if (isSelected !== selectedKeys.has(key)) this.toggleKey(key);
        }
    };
}

});



parcelRegister("aeKbf", function(module, exports) {

$parcel$export(module.exports, "ToggleButton", () => $72eb6455827375c6$export$d2b052e7b4be1756);

var $fDYaM = parcelRequire("fDYaM");

var $hUj7u = parcelRequire("hUj7u");

var $4l6lZ = parcelRequire("4l6lZ");

var $il6Ys = parcelRequire("il6Ys");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $9yazy = parcelRequire("9yazy");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $9aygw = parcelRequire("9aygw");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $72eb6455827375c6$export$43506d75ebd2e218 = (0, $eF4cA.createContext)({});
const $72eb6455827375c6$export$d2b052e7b4be1756 = (0, $eF4cA.forwardRef)(function ToggleButton(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $72eb6455827375c6$export$43506d75ebd2e218);
    let groupState = (0, $eF4cA.useContext)((0, $4l6lZ.ToggleGroupStateContext));
    let state = (0, $9yazy.useToggleState)(groupState && props.id != null ? {
        isSelected: groupState.selectedKeys.has(props.id),
        onChange (isSelected) {
            groupState.setSelected(props.id, isSelected);
        }
    } : props);
    let { buttonProps: buttonProps, isPressed: isPressed, isSelected: isSelected, isDisabled: isDisabled } = groupState && props.id != null ? (0, $9aygw.useToggleButtonGroupItem)({
        ...props,
        id: props.id
    }, groupState, ref) : (0, $il6Ys.useToggleButton)({
        ...props,
        id: props.id != null ? String(props.id) : undefined
    }, state, ref);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...props,
        isDisabled: isDisabled
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        values: {
            isHovered: isHovered,
            isPressed: isPressed,
            isFocused: isFocused,
            isSelected: state.isSelected,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            state: state
        },
        defaultClassName: 'react-aria-ToggleButton'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).button, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, buttonProps, focusProps, hoverProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-disabled": isDisabled || undefined,
        "data-pressed": isPressed || undefined,
        "data-selected": isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $hUj7u.SelectionIndicatorContext).Provider, {
        value: {
            isSelected: isSelected
        }
    }, renderProps.children));
});

});


parcelRegister("e0Enh", function(module, exports) {

$parcel$export(module.exports, "useScale", () => $f2721cd10581cf35$export$a8d2043b2d807f4d);

var $5nuB1 = parcelRequire("5nuB1");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f2721cd10581cf35$export$736bf165441b18c7() {
    return (0, $5nuB1.useMediaQuery)('(max-width: 640px)');
}
function $f2721cd10581cf35$export$a8d2043b2d807f4d() {
    let matchesFine = (0, $5nuB1.useMediaQuery)('not ((hover: hover) and (pointer: fine))');
    if (matchesFine) return 'large';
    return 'medium';
}

});

parcelRegister("n0XBd", function(module, exports) {

$parcel$export(module.exports, "ListLayout", () => $93ed17fde4da6536$export$cacbb3924155d68e);

var $f7tr2 = parcelRequire("f7tr2");

var $fK9fi = parcelRequire("fK9fi");

var $dnqqa = parcelRequire("dnqqa");

var $8bBQM = parcelRequire("8bBQM");

var $bMKKe = parcelRequire("bMKKe");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT = 48;
class $93ed17fde4da6536$export$cacbb3924155d68e extends (0, $fK9fi.Layout) {
    /**
   * Creates a new ListLayout with options. See the list of properties below for a description
   * of the options that can be provided.
   */ constructor(options = {}){
        super();
        this.rowSize = options?.rowSize ?? options?.rowHeight ?? null;
        this.orientation = options.orientation ?? 'vertical';
        this.estimatedRowSize = options?.estimatedRowSize ?? options?.estimatedRowHeight ?? null;
        this.headingSize = options?.headingSize ?? options?.headingHeight ?? null;
        this.estimatedHeadingSize = options?.estimatedHeadingSize ?? options?.estimatedHeadingHeight ?? null;
        this.loaderSize = options?.loaderSize ?? options?.loaderHeight ?? null;
        this.dropIndicatorThickness = options.dropIndicatorThickness || 2;
        this.gap = options.gap || 0;
        this.padding = options.padding || 0;
        this.layoutNodes = new Map();
        this.rootNodes = [];
        this.lastCollection = null;
        this.invalidateEverything = false;
        this.validRect = new (0, $8bBQM.Rect)();
        this.requestedRect = new (0, $8bBQM.Rect)();
        this.contentSize = new (0, $bMKKe.Size)();
    }
    // Backward compatibility for subclassing.
    get collection() {
        return this.virtualizer.collection;
    }
    /** @deprecated Use `rowSize` instead. */ get rowHeight() {
        return this.rowSize;
    }
    /** @deprecated Use `estimatedRowSize` instead. */ get estimatedRowHeight() {
        return this.estimatedRowSize;
    }
    /** @deprecated Use `headingSize` instead. */ get headingHeight() {
        return this.headingSize;
    }
    /** @deprecated Use `estimatedHeadingSize` instead. */ get estimatedHeadingHeight() {
        return this.estimatedHeadingSize;
    }
    /** @deprecated Use `loaderSize` instead. */ get loaderHeight() {
        return this.loaderSize;
    }
    getLayoutInfo(key) {
        this.ensureLayoutInfo(key);
        return this.layoutNodes.get(key)?.layoutInfo || null;
    }
    getVisibleLayoutInfos(rect) {
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        // Adjust rect to keep number of visible rows consistent.
        // (only if height > 1 or width > 1 for getDropTargetFromPoint)
        if (rect[heightProperty] > 1) {
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT) + this.gap;
            // Clone only before mutating
            rect = rect.copy();
            let offset = Math.floor(rect[offsetProperty] / rowHeight) * rowHeight;
            let height = rect[heightProperty] + rect[offsetProperty] - offset;
            rect[offsetProperty] = offset;
            rect[heightProperty] = Math.ceil(height / rowHeight) * rowHeight;
        }
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        this.layoutIfNeeded(rect);
        let res = [];
        let addNodes = (nodes)=>{
            for (let node of nodes)if (this.isVisible(node, rect)) {
                res.push(node.layoutInfo);
                if (node.children) addNodes(node.children);
            }
        };
        addNodes(this.rootNodes);
        return res;
    }
    layoutIfNeeded(rect) {
        if (!this.lastCollection) return;
        if (!this.requestedRect.containsRect(rect)) {
            this.requestedRect = this.requestedRect.union(rect);
            this.rootNodes = this.buildCollection();
        }
        // Ensure all of the persisted keys are available.
        for (let key of this.virtualizer.persistedKeys){
            if (this.ensureLayoutInfo(key)) return;
        }
    }
    ensureLayoutInfo(key) {
        // If the layout info wasn't found, it might be outside the bounds of the area that we've
        // computed layout for so far. This can happen when accessing a random key, e.g pressing Home/End.
        // Compute the full layout and try again.
        if (!this.layoutNodes.has(key) && this.requestedRect.area < this.contentSize.area && this.lastCollection) {
            this.requestedRect = new (0, $8bBQM.Rect)(0, 0, Infinity, Infinity);
            this.rootNodes = this.buildCollection();
            this.requestedRect = new (0, $8bBQM.Rect)(0, 0, this.contentSize.width, this.contentSize.height);
            return true;
        }
        return false;
    }
    isVisible(node, rect) {
        return node.layoutInfo.rect.intersects(rect) || node.layoutInfo.isSticky || node.layoutInfo.type === 'header' || node.layoutInfo.type === 'loader' || this.virtualizer.isPersistedKey(node.layoutInfo.key);
    }
    shouldInvalidateEverything(invalidationContext) {
        let options = invalidationContext.layoutOptions;
        return invalidationContext.sizeChanged || this.rowSize !== (options?.rowSize ?? options?.rowHeight ?? this.rowSize) || this.orientation !== (options?.orientation ?? this.orientation) || this.headingSize !== (options?.headingSize ?? options?.headingHeight ?? this.headingSize) || this.loaderSize !== (options?.loaderSize ?? options?.loaderHeight ?? this.loaderSize) || this.gap !== (options?.gap ?? this.gap) || this.padding !== (options?.padding ?? this.padding);
    }
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return (newOptions?.rowSize ?? newOptions?.rowHeight) !== (oldOptions?.rowSize ?? oldOptions?.rowHeight) || newOptions.orientation !== oldOptions.orientation || (newOptions?.estimatedRowSize ?? newOptions?.estimatedRowHeight) !== (oldOptions?.estimatedRowSize ?? oldOptions?.estimatedRowHeight) || (newOptions?.headingSize ?? newOptions?.headingHeight) !== (oldOptions?.headingSize ?? oldOptions?.headingHeight) || (newOptions?.estimatedHeadingSize ?? newOptions?.estimatedHeadingHeight) !== (oldOptions?.estimatedHeadingSize ?? oldOptions?.estimatedHeadingHeight) || (newOptions?.loaderSize ?? newOptions?.loaderHeight) !== (oldOptions?.loaderSize ?? oldOptions?.loaderHeight) || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.gap !== oldOptions.gap || newOptions.padding !== oldOptions.padding;
    }
    update(invalidationContext) {
        let collection = this.virtualizer.collection;
        // Reset valid rect if we will have to invalidate everything.
        // Otherwise we can reuse cached layout infos outside the current visible rect.
        this.invalidateEverything = this.shouldInvalidateEverything(invalidationContext);
        if (this.invalidateEverything) {
            this.requestedRect = this.virtualizer.visibleRect.copy();
            this.layoutNodes.clear();
        }
        let options = invalidationContext.layoutOptions;
        this.rowSize = options?.rowSize ?? options?.rowHeight ?? this.rowSize;
        this.orientation = options?.orientation ?? this.orientation;
        this.estimatedRowSize = options?.estimatedRowSize ?? options?.estimatedRowHeight ?? this.estimatedRowSize;
        this.headingSize = options?.headingSize ?? options?.headingHeight ?? this.headingSize;
        this.estimatedHeadingSize = options?.estimatedHeadingSize ?? options?.estimatedHeadingHeight ?? this.estimatedHeadingSize;
        this.loaderSize = options?.loaderSize ?? options?.loaderHeight ?? this.loaderSize;
        this.dropIndicatorThickness = options?.dropIndicatorThickness ?? this.dropIndicatorThickness;
        this.gap = options?.gap ?? this.gap;
        this.padding = options?.padding ?? this.padding;
        this.rootNodes = this.buildCollection();
        // Remove deleted layout nodes
        if (this.lastCollection && collection !== this.lastCollection) {
            for (let key of this.lastCollection.getKeys())if (!collection.getItem(key)) {
                let layoutNode = this.layoutNodes.get(key);
                if (layoutNode) this.layoutNodes.delete(key);
            }
        }
        this.lastCollection = collection;
        this.invalidateEverything = false;
        this.validRect = this.requestedRect.copy();
    }
    buildCollection(offset = this.padding) {
        let collection = this.virtualizer.collection;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let maxOffsetProperty = this.orientation === 'horizontal' ? 'maxX' : 'maxY';
        // filter out content nodes since we don't want them to affect the height
        // Tree specific for now, if we add content nodes to other collection items, we might need to reconsider this
        let collectionNodes = $93ed17fde4da6536$var$$942f06a693c162e2$var$toArray(collection, (node)=>node.type !== 'content');
        let loaderNodes = collectionNodes.filter((node)=>node.type === 'loader');
        let nodes = [];
        let isEmptyOrLoading = collection?.size === 0;
        if (isEmptyOrLoading) offset = 0;
        for (let node of collectionNodes){
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (node.type === 'item' && offset + rowHeight < this.requestedRect[offsetProperty] && !this.isValid(node, offset)) {
                offset += rowHeight;
                continue;
            }
            let layoutNode = this.orientation === 'horizontal' ? this.buildChild(node, offset, this.padding, null) : this.buildChild(node, this.padding, offset, null);
            offset = layoutNode.layoutInfo.rect[maxOffsetProperty] + this.gap;
            nodes.push(layoutNode);
            if (node.type === 'loader') {
                let index = loaderNodes.indexOf(node);
                loaderNodes.splice(index, 1);
            }
            // Build each loader that exists in the collection that is outside the visible rect so that they are persisted
            // at the proper estimated location. If the node.type is "section" then we don't do this shortcut since we have to
            // build the sections to see how tall they are.
            if ((node.type === 'item' || node.type === 'loader') && offset > this.requestedRect[maxOffsetProperty]) {
                let lastProcessedIndex = collectionNodes.indexOf(node);
                for (let loaderNode of loaderNodes){
                    let loaderNodeIndex = collectionNodes.indexOf(loaderNode);
                    // Subtract by an additional 1 since we've already added the current item's height to y
                    offset += (loaderNodeIndex - lastProcessedIndex - 1) * rowHeight;
                    let loader = this.orientation === 'horizontal' ? this.buildChild(loaderNode, offset, this.padding, null) : this.buildChild(loaderNode, this.padding, offset, null);
                    nodes.push(loader);
                    offset = loader.layoutInfo.rect[maxOffsetProperty];
                    lastProcessedIndex = loaderNodeIndex;
                }
                // Account for the rest of the items after the last loader spinner, subtract by 1 since we've processed the current node's height already
                offset += (collectionNodes.length - lastProcessedIndex - 1) * rowHeight;
                break;
            }
        }
        offset = Math.max(offset - this.gap, 0);
        offset += isEmptyOrLoading ? 0 : this.padding;
        this.contentSize = this.orientation === 'horizontal' ? new (0, $bMKKe.Size)(offset, this.virtualizer.size.height) : new (0, $bMKKe.Size)(this.virtualizer.size.width, offset);
        return nodes;
    }
    isValid(node, offset) {
        let cached = this.layoutNodes.get(node.key);
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        return !this.invalidateEverything && !!cached && cached.node === node && offset === cached.layoutInfo.rect[offsetProperty] && cached.layoutInfo.rect.intersects(this.validRect) && cached.validRect.containsRect(cached.layoutInfo.rect.intersection(this.requestedRect));
    }
    buildChild(node, x, y, parentKey) {
        if (this.isValid(node, this.orientation === 'horizontal' ? x : y)) return this.layoutNodes.get(node.key);
        let layoutNode = this.buildNode(node, x, y);
        layoutNode.layoutInfo.parentKey = parentKey ?? null;
        layoutNode.layoutInfo.allowOverflow = true;
        this.layoutNodes.set(node.key, layoutNode);
        return layoutNode;
    }
    buildNode(node, x, y) {
        switch(node.type){
            case 'section':
                return this.buildSection(node, x, y);
            case 'item':
                return this.buildItem(node, x, y);
            case 'header':
                return this.buildSectionHeader(node, x, y);
            case 'loader':
                return this.buildLoader(node, x, y);
            case 'separator':
                return this.buildItem(node, x, y);
            // uses buildSection instead of buildItem cuz it has a child node (the trigger)
            // that need to be processed
            case 'submenutrigger':
                return this.buildSection(node, x, y);
            default:
                throw new Error('Unsupported node type: ' + node.type);
        }
    }
    buildLoader(node, x, y) {
        let rect = new (0, $8bBQM.Rect)(x, y, this.padding, 0);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)(node.type, node.key, rect);
        // Note that if the user provides isLoading to their sentinel during a case where they only want to render the emptyState, this will reserve
        // room for the loader alongside rendering the emptyState
        if (this.orientation === 'horizontal') {
            rect.height = this.virtualizer.contentSize.height - this.padding - y;
            rect.width = node.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT : 0;
        } else {
            rect.width = this.virtualizer.contentSize.width - this.padding - x;
            rect.height = node.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT : 0;
        }
        return {
            layoutInfo: layoutInfo,
            validRect: rect.intersection(this.requestedRect)
        };
    }
    buildSection(node, x, y) {
        let collection = this.virtualizer.collection;
        let width = this.virtualizer.size.width - this.padding - x;
        let height = this.virtualizer.size.height - this.padding - y;
        let rect = this.orientation === 'horizontal' ? new (0, $8bBQM.Rect)(x, y, 0, height) : new (0, $8bBQM.Rect)(x, y, width, 0);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)(node.type, node.key, rect);
        let offset = this.orientation === 'horizontal' ? x : y;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let maxOffsetProperty = this.orientation === 'horizontal' ? 'maxX' : 'maxY';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let skipped = 0;
        let children = [];
        for (let child of (0, $f7tr2.getChildNodes)(node, collection)){
            // skip if it is a content node, Tree specific for now, if we add content nodes to other collection items, we might need to reconsider this
            if (child.type === 'content') continue;
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (offset + rowHeight < this.requestedRect[offsetProperty] && !this.isValid(node, offset)) {
                offset += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.orientation === 'horizontal' ? this.buildChild(child, offset, y, layoutInfo.key) : this.buildChild(child, x, offset, layoutInfo.key);
            offset = layoutNode.layoutInfo.rect[maxOffsetProperty] + this.gap;
            children.push(layoutNode);
            if (offset > this.requestedRect[maxOffsetProperty]) {
                // Estimate the remaining height for rows that we don't need to layout right now.
                offset += ([
                    ...(0, $f7tr2.getChildNodes)(node, collection)
                ].length - (children.length + skipped)) * rowHeight;
                break;
            }
        }
        offset -= this.gap;
        rect[heightProperty] = offset - (this.orientation === 'horizontal' ? x : y);
        return {
            layoutInfo: layoutInfo,
            children: children,
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node: node
        };
    }
    buildSectionHeader(node, x, y) {
        let widthProperty = this.orientation === 'horizontal' ? 'height' : 'width';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let width = this.virtualizer.size[widthProperty] - this.padding - (this.orientation === 'horizontal' ? y : x);
        let rectHeight = this.headingSize;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            let previousLayoutInfo = previousLayoutNode?.layoutInfo;
            if (previousLayoutInfo) {
                let curNode = this.virtualizer.collection.getItem(node.key);
                let lastNode = this.lastCollection ? this.lastCollection.getItem(node.key) : null;
                rectHeight = previousLayoutNode.layoutInfo.rect[heightProperty];
                isEstimated = width !== previousLayoutInfo.rect[widthProperty] || curNode !== lastNode || previousLayoutInfo.estimatedSize;
            } else {
                rectHeight = node.rendered ? this.estimatedHeadingSize : 0;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT;
        let headerRect = this.orientation === 'horizontal' ? new (0, $8bBQM.Rect)(x, y, rectHeight, width - y) : new (0, $8bBQM.Rect)(x, y, width - x, rectHeight);
        let header = new (0, $dnqqa.LayoutInfo)('header', node.key, headerRect);
        header.estimatedSize = isEstimated;
        return {
            layoutInfo: header,
            children: [],
            validRect: header.rect.intersection(this.requestedRect),
            node: node
        };
    }
    buildItem(node, x, y) {
        let widthProperty = this.orientation === 'horizontal' ? 'height' : 'width';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let width = this.virtualizer.size[widthProperty] - this.padding - (this.orientation === 'horizontal' ? y : x);
        let rectHeight = this.rowSize;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                rectHeight = previousLayoutNode.layoutInfo.rect[heightProperty];
                isEstimated = width !== previousLayoutNode.layoutInfo.rect[widthProperty] || node !== previousLayoutNode.node || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                rectHeight = this.estimatedRowSize;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = $93ed17fde4da6536$var$$942f06a693c162e2$var$DEFAULT_HEIGHT;
        let rect = this.orientation === 'horizontal' ? new (0, $8bBQM.Rect)(x, y, rectHeight, width) : new (0, $8bBQM.Rect)(x, y, width, rectHeight);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo: layoutInfo,
            children: [],
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node: node
        };
    }
    updateItemSize(key, size) {
        let layoutNode = this.layoutNodes.get(key);
        // If no layoutInfo, item has been deleted/removed.
        if (!layoutNode) return false;
        let collection = this.virtualizer.collection;
        let layoutInfo = layoutNode.layoutInfo;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        layoutInfo.estimatedSize = false;
        if (layoutInfo.rect[heightProperty] !== size[heightProperty]) {
            // Copy layout info rather than mutating so that later caches are invalidated.
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect[heightProperty] = size[heightProperty];
            layoutNode.layoutInfo = newLayoutInfo;
            // Items after this layoutInfo will need to be repositioned to account for the new height.
            // Adjust the validRect so that only items above remain valid.
            this.validRect[heightProperty] = Math.min(this.validRect[heightProperty], layoutInfo.rect[offsetProperty] - this.validRect[offsetProperty]);
            // The requestedRect also needs to be adjusted to account for the height difference.
            if (layoutNode.node?.type === 'item') this.requestedRect[heightProperty] += newLayoutInfo.rect[heightProperty] - layoutInfo.rect[heightProperty];
            // Invalidate layout for this layout node and all parents
            this.updateLayoutNode(key, layoutInfo, newLayoutInfo);
            let node = layoutInfo.parentKey != null ? collection.getItem(layoutInfo.parentKey) : null;
            while(node){
                this.updateLayoutNode(node.key, layoutInfo, newLayoutInfo);
                node = node.parentKey != null ? collection.getItem(node.parentKey) : null;
            }
            return true;
        }
        return false;
    }
    updateLayoutNode(key, oldLayoutInfo, newLayoutInfo) {
        let n = this.layoutNodes.get(key);
        if (n) {
            // Invalidate by intersecting the validRect of this node with the overall validRect.
            n.validRect = n.validRect.intersection(this.validRect);
            // Replace layout info in LayoutNode
            if (n.layoutInfo === oldLayoutInfo) n.layoutInfo = newLayoutInfo;
        }
    }
    getContentSize() {
        return this.contentSize;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let searchRect = new (0, $8bBQM.Rect)(x, Math.max(0, y - this.gap), 1, Math.max(1, this.gap * 2));
        let candidates = this.getVisibleLayoutInfos(searchRect);
        let key = null;
        let minDistance = Infinity;
        for (let candidate of candidates){
            // Ignore items outside the search rect, e.g. persisted keys.
            if (!candidate.rect.intersects(searchRect)) continue;
            let yDist = Math.abs(candidate.rect.y - y);
            let maxYDist = Math.abs(candidate.rect.maxY - y);
            let dist = Math.min(yDist, maxYDist);
            if (dist < minDistance) {
                minDistance = dist;
                key = candidate.key;
            }
        }
        if (key == null || this.virtualizer.collection.size === 0) return {
            type: 'root'
        };
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = layoutInfo.rect;
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: 'before'
        })) target.dropPosition = 'before';
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: 'after'
        })) target.dropPosition = 'after';
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (target.dropPosition === 'before') rect = this.orientation === 'horizontal' ? new (0, $8bBQM.Rect)(Math.max(0, layoutInfo.rect.x - this.dropIndicatorThickness / 2), layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height) : new (0, $8bBQM.Rect)(layoutInfo.rect.x, Math.max(0, layoutInfo.rect.y - this.dropIndicatorThickness / 2), layoutInfo.rect.width, this.dropIndicatorThickness);
        else if (target.dropPosition === 'after') {
            // Render after last visible descendant of the drop target.
            let targetNode = this.collection.getItem(target.key);
            if (targetNode) {
                let targetLevel = targetNode.level ?? 0;
                let currentKey = this.collection.getKeyAfter(target.key);
                while(currentKey != null){
                    let node = this.collection.getItem(currentKey);
                    if (!node || node.level <= targetLevel) break;
                    layoutInfo = this.getLayoutInfo(currentKey) || layoutInfo;
                    currentKey = this.collection.getKeyAfter(currentKey);
                }
            }
            rect = this.orientation === 'horizontal' ? new (0, $8bBQM.Rect)(layoutInfo.rect.maxX - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height) : new (0, $8bBQM.Rect)(layoutInfo.rect.x, layoutInfo.rect.maxY - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        } else rect = layoutInfo.rect;
        return new (0, $dnqqa.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
}
function $93ed17fde4da6536$var$$942f06a693c162e2$var$toArray(collection, predicate) {
    const result = [];
    for (const node of collection)if (predicate(node)) result.push(node);
    return result;
}

});
parcelRegister("fK9fi", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $df41c404773c9561$export$c84671f46d6a1ca);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $df41c404773c9561$export$c84671f46d6a1ca {
    /**
   * Returns whether the layout should invalidate in response to
   * visible rectangle changes. By default, it only invalidates
   * when the virtualizer's size changes. Return true always
   * to make the layout invalidate while scrolling (e.g. sticky headers).
   */ shouldInvalidate(newRect, oldRect) {
        // By default, invalidate when the size changes
        return newRect.width !== oldRect.width || newRect.height !== oldRect.height;
    }
    /**
   * Returns whether the layout should invalidate when the layout options change.
   * By default it invalidates when the object identity changes. Override this
   * method to optimize layout updates based on specific option changes.
   */ shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions !== oldOptions;
    }
    /**
   * This method allows the layout to perform any pre-computation
   * it needs to in order to prepare LayoutInfos for retrieval.
   * Called by the virtualizer before `getVisibleLayoutInfos`
   * or `getLayoutInfo` are called.
   */ update(invalidationContext) {}
    /** @private */ getItemRect(key) {
        return this.getLayoutInfo(key)?.rect ?? null;
    }
    /** @private */ getVisibleRect() {
        return this.virtualizer.visibleRect;
    }
    constructor(){
        /** The Virtualizer the layout is currently attached to. */ this.virtualizer = null;
    }
}

});

parcelRegister("dnqqa", function(module, exports) {

$parcel$export(module.exports, "LayoutInfo", () => $14c12a3251c38eb8$export$7e0eeb9da702a085);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $14c12a3251c38eb8$export$7e0eeb9da702a085 {
    /**
   * @param type The type of element represented by this LayoutInfo. Should match the `type` of the
   *   corresponding collection node.
   * @param key A unique key for this LayoutInfo. Should match the `key` of the corresponding
   *   collection node.
   * @param rect The rectangle describing the size and position of this element.
   */ constructor(type, key, rect){
        this.type = type;
        this.key = key;
        this.parentKey = null;
        this.content = null;
        this.rect = rect;
        this.estimatedSize = false;
        this.isSticky = false;
        this.opacity = 1;
        this.transform = null;
        this.zIndex = 0;
        this.allowOverflow = false;
    }
    /**
   * Returns a copy of the LayoutInfo.
   */ copy() {
        let res = new $14c12a3251c38eb8$export$7e0eeb9da702a085(this.type, this.key, this.rect.copy());
        res.estimatedSize = this.estimatedSize;
        res.opacity = this.opacity;
        res.transform = this.transform;
        res.parentKey = this.parentKey;
        res.content = this.content;
        res.isSticky = this.isSticky;
        res.zIndex = this.zIndex;
        res.allowOverflow = this.allowOverflow;
        return res;
    }
}

});

parcelRegister("8bBQM", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $461b38cffa56f3d9$export$c79fc6492f3af13d);

var $919Au = parcelRequire("919Au");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $461b38cffa56f3d9$export$c79fc6492f3af13d {
    constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
   * The maximum x-coordinate in the rectangle.
   */ get maxX() {
        return this.x + this.width;
    }
    /**
   * The maximum y-coordinate in the rectangle.
   */ get maxY() {
        return this.y + this.height;
    }
    /**
   * The area of the rectangle.
   */ get area() {
        return this.width * this.height;
    }
    /**
   * The top left corner of the rectangle.
   */ get topLeft() {
        return new (0, $919Au.Point)(this.x, this.y);
    }
    /**
   * The top right corner of the rectangle.
   */ get topRight() {
        return new (0, $919Au.Point)(this.maxX, this.y);
    }
    /**
   * The bottom left corner of the rectangle.
   */ get bottomLeft() {
        return new (0, $919Au.Point)(this.x, this.maxY);
    }
    /**
   * The bottom right corner of the rectangle.
   */ get bottomRight() {
        return new (0, $919Au.Point)(this.maxX, this.maxY);
    }
    /**
   * Returns whether this rectangle intersects another rectangle.
   *
   * @param rect - The rectangle to check.
   */ intersects(rect) {
        let isTestEnv = false;
        return (isTestEnv || this.area > 0 && rect.area > 0) && this.x <= rect.x + rect.width && rect.x <= this.x + this.width && this.y <= rect.y + rect.height && rect.y <= this.y + this.height;
    }
    /**
   * Returns whether this rectangle fully contains another rectangle.
   *
   * @param rect - The rectangle to check.
   */ containsRect(rect) {
        return this.x <= rect.x && this.y <= rect.y && this.maxX >= rect.maxX && this.maxY >= rect.maxY;
    }
    /**
   * Returns whether the rectangle contains the given point.
   *
   * @param point - The point to check.
   */ containsPoint(point) {
        return this.x <= point.x && this.y <= point.y && this.maxX >= point.x && this.maxY >= point.y;
    }
    /**
   * Returns the first corner of this rectangle (from top to bottom, left to right)
   * that is contained in the given rectangle, or null of the rectangles do not intersect.
   *
   * @param rect - The rectangle to check.
   */ getCornerInRect(rect) {
        for (let key of [
            'topLeft',
            'topRight',
            'bottomLeft',
            'bottomRight'
        ]){
            if (rect.containsPoint(this[key])) return key;
        }
        return null;
    }
    equals(rect) {
        return rect.x === this.x && rect.y === this.y && rect.width === this.width && rect.height === this.height;
    }
    pointEquals(point) {
        return this.x === point.x && this.y === point.y;
    }
    sizeEquals(size) {
        return this.width === size.width && this.height === size.height;
    }
    /**
   * Returns the union of this Rect and another.
   */ union(other) {
        let x = Math.min(this.x, other.x);
        let y = Math.min(this.y, other.y);
        let width = Math.max(this.maxX, other.maxX) - x;
        let height = Math.max(this.maxY, other.maxY) - y;
        return new $461b38cffa56f3d9$export$c79fc6492f3af13d(x, y, width, height);
    }
    /**
   * Returns the intersection of this Rect with another.
   * If the rectangles do not intersect, an all zero Rect is returned.
   */ intersection(other) {
        if (!this.intersects(other)) return new $461b38cffa56f3d9$export$c79fc6492f3af13d(0, 0, 0, 0);
        let x = Math.max(this.x, other.x);
        let y = Math.max(this.y, other.y);
        return new $461b38cffa56f3d9$export$c79fc6492f3af13d(x, y, Math.min(this.maxX, other.maxX) - x, Math.min(this.maxY, other.maxY) - y);
    }
    /**
   * Returns a copy of this rectangle.
   */ copy() {
        return new $461b38cffa56f3d9$export$c79fc6492f3af13d(this.x, this.y, this.width, this.height);
    }
}

});
parcelRegister("919Au", function(module, exports) {

$parcel$export(module.exports, "Point", () => $60a6690487d31b4e$export$baf26146a414f24a);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $60a6690487d31b4e$export$baf26146a414f24a {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    /**
   * Returns a copy of this point.
   */ copy() {
        return new $60a6690487d31b4e$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Checks if two points are equal.
   */ equals(point) {
        return this.x === point.x && this.y === point.y;
    }
    /**
   * Returns true if this point is the origin.
   */ isOrigin() {
        return this.x === 0 && this.y === 0;
    }
}

});


parcelRegister("bMKKe", function(module, exports) {

$parcel$export(module.exports, "Size", () => $718fe8c1aa211d72$export$cb6da89c6af1a8ec);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $718fe8c1aa211d72$export$cb6da89c6af1a8ec {
    constructor(width = 0, height = 0){
        this.width = Math.max(width, 0);
        this.height = Math.max(height, 0);
    }
    /**
   * Returns a copy of this size.
   */ copy() {
        return new $718fe8c1aa211d72$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    /**
   * Returns whether this size is equal to another one.
   */ equals(other) {
        return this.width === other.width && this.height === other.height;
    }
    /**
   * The total area of the Size.
   */ get area() {
        return this.width * this.height;
    }
}

});


parcelRegister("eF2II", function(module, exports) {

$parcel$export(module.exports, "Virtualizer", () => $2a085b469e36ccf6$export$89be5a243e59c4b2);

var $8dzVy = parcelRequire("8dzVy");

var $1W66I = parcelRequire("1W66I");

var $eF4cA = parcelRequire("eF4cA");

var $ei9S8 = parcelRequire("ei9S8");

var $300io = parcelRequire("300io");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerContext = (0, $eF4cA.createContext)(null);
const $2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerOptionsContext = (0, $eF4cA.createContext)(null);
function $2a085b469e36ccf6$export$89be5a243e59c4b2(props) {
    let { children: children, layout: layoutProp, layoutOptions: layoutOptions, shouldObserveItemSize: shouldObserveItemSize } = props;
    let layout = (0, $eF4cA.useMemo)(()=>typeof layoutProp === 'function' ? new layoutProp() : layoutProp, [
        layoutProp
    ]);
    let renderer = (0, $eF4cA.useMemo)(()=>({
            isVirtualized: true,
            layoutDelegate: layout,
            dropTargetDelegate: layout.getDropTargetFromPoint ? layout : undefined,
            CollectionRoot: $2a085b469e36ccf6$var$$143fb904d86051ce$var$CollectionRoot,
            CollectionBranch: $2a085b469e36ccf6$var$$143fb904d86051ce$var$CollectionBranch
        }), [
        layout
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8dzVy.CollectionRendererContext).Provider, {
        value: renderer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerOptionsContext.Provider, {
        value: {
            layout: layout,
            layoutOptions: layoutOptions,
            shouldObserveItemSize: shouldObserveItemSize
        }
    }, children));
}
function $2a085b469e36ccf6$var$$143fb904d86051ce$var$CollectionRoot({ collection: collection, persistedKeys: persistedKeys, scrollRef: scrollRef, renderDropIndicator: renderDropIndicator }) {
    let { layout: layout, layoutOptions: layoutOptions, shouldObserveItemSize: shouldObserveItemSize } = (0, $eF4cA.useContext)($2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerOptionsContext);
    // oxlint-disable-next-line react/react-compiler
    let layoutOptions2 = layout.useLayoutOptions?.();
    let state = (0, $1W66I.useVirtualizerState)({
        allowsWindowScrolling: true,
        layout: layout,
        collection: collection,
        renderView: (type, item)=>{
            return item?.render?.(item);
        },
        onVisibleRectChange (rect) {
            let element = scrollRef?.current;
            if (element) {
                // oxlint-disable-next-line react/react-compiler
                element.scrollLeft = rect.x;
                element.scrollTop = rect.y;
            }
        },
        persistedKeys: persistedKeys,
        layoutOptions: (0, $eF4cA.useMemo)(()=>layoutOptions && layoutOptions2 ? {
                ...layoutOptions,
                ...layoutOptions2
            } : layoutOptions || layoutOptions2, [
            layoutOptions,
            layoutOptions2
        ])
    });
    let { contentProps: contentProps } = (0, $ei9S8.useScrollView)({
        onVisibleRectChange: state.setVisibleRect,
        onSizeChange: state.setSize,
        contentSize: state.contentSize,
        onScrollStart: state.startScrolling,
        onScrollEnd: state.endScrolling,
        allowsWindowScrolling: true
    }, scrollRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", contentProps, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerContext.Provider, {
        value: state
    }, $2a085b469e36ccf6$var$$143fb904d86051ce$var$renderChildren(null, state.visibleViews, renderDropIndicator, shouldObserveItemSize)));
}
function $2a085b469e36ccf6$var$$143fb904d86051ce$var$CollectionBranch({ parent: parent, renderDropIndicator: renderDropIndicator }) {
    let virtualizer = (0, $eF4cA.useContext)($2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerContext);
    let parentView = virtualizer.virtualizer.getVisibleView(parent.key);
    let { shouldObserveItemSize: shouldObserveItemSize } = (0, $eF4cA.useContext)($2a085b469e36ccf6$var$$143fb904d86051ce$var$VirtualizerOptionsContext);
    return $2a085b469e36ccf6$var$$143fb904d86051ce$var$renderChildren(parentView, Array.from(parentView.children), renderDropIndicator, shouldObserveItemSize);
}
function $2a085b469e36ccf6$var$$143fb904d86051ce$var$renderChildren(parent, children, renderDropIndicator, shouldObserveItemSize) {
    return children.map((view)=>$2a085b469e36ccf6$var$$143fb904d86051ce$var$renderWrapper(parent, view, renderDropIndicator, shouldObserveItemSize));
}
function $2a085b469e36ccf6$var$$143fb904d86051ce$var$renderWrapper(parent, reusableView, renderDropIndicator, shouldObserveItemSize) {
    let rendered = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $300io.VirtualizerItem), {
        key: reusableView.key,
        layoutInfo: reusableView.layoutInfo,
        virtualizer: reusableView.virtualizer,
        parent: parent?.layoutInfo,
        shouldObserveItemSize: shouldObserveItemSize
    }, reusableView.rendered);
    let { collection: collection, layout: layout } = reusableView.virtualizer;
    let node = reusableView.content;
    if (node?.type === 'item' && renderDropIndicator && layout.getDropTargetLayoutInfo) rendered = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, {
        key: reusableView.key
    }, $2a085b469e36ccf6$var$$143fb904d86051ce$var$renderDropIndicatorWrapper(parent, reusableView, {
        type: 'item',
        key: reusableView.content.key,
        dropPosition: 'before'
    }, renderDropIndicator), rendered, (0, $8dzVy.renderAfterDropIndicators)(collection, node, (target)=>$2a085b469e36ccf6$var$$143fb904d86051ce$var$renderDropIndicatorWrapper(parent, reusableView, target, renderDropIndicator)));
    return rendered;
}
function $2a085b469e36ccf6$var$$143fb904d86051ce$var$renderDropIndicatorWrapper(parent, reusableView, target, renderDropIndicator) {
    let indicator = renderDropIndicator(target);
    if (indicator) {
        let layoutInfo = reusableView.virtualizer.layout.getDropTargetLayoutInfo(target);
        indicator = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $300io.VirtualizerItem), {
            layoutInfo: layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent?.layoutInfo
        }, indicator);
    }
    return indicator;
}

});
parcelRegister("1W66I", function(module, exports) {

$parcel$export(module.exports, "useVirtualizerState", () => $993a16e52593f2d0$export$1505db82fe357e65);

var $8bBQM = parcelRequire("8bBQM");

var $bMKKe = parcelRequire("bMKKe");

var $2etG9 = parcelRequire("2etG9");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $993a16e52593f2d0$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useLayoutEffect : ()=>{};
function $993a16e52593f2d0$export$1505db82fe357e65(opts) {
    let [visibleRect, setVisibleRect] = (0, $eF4cA.useState)(new (0, $8bBQM.Rect)(0, 0, 0, 0));
    let [size, setSize] = (0, $eF4cA.useState)(new (0, $bMKKe.Size)());
    let [isScrolling, setScrolling] = (0, $eF4cA.useState)(false);
    let [invalidationContext, setInvalidationContext] = (0, $eF4cA.useState)({});
    let visibleRectChanged = (0, $eF4cA.useRef)(false);
    let [virtualizer] = (0, $eF4cA.useState)(()=>new (0, $2etG9.Virtualizer)({
            collection: opts.collection,
            layout: opts.layout,
            delegate: {
                setVisibleRect (rect) {
                    setVisibleRect(rect);
                    visibleRectChanged.current = true;
                },
                // TODO: should changing these invalidate the entire cache?
                renderView: opts.renderView,
                invalidate: setInvalidationContext
            }
        }));
    // onVisibleRectChange must be called from an effect, not during render.
    $993a16e52593f2d0$export$e5c5a5f917a5871c(()=>{
        if (visibleRectChanged.current) {
            visibleRectChanged.current = false;
            opts.onVisibleRectChange(visibleRect);
        }
    });
    let mergedInvalidationContext = (0, $eF4cA.useMemo)(()=>{
        if (opts.layoutOptions != null) return {
            ...invalidationContext,
            layoutOptions: opts.layoutOptions
        };
        return invalidationContext;
    }, [
        invalidationContext,
        opts.layoutOptions
    ]);
    let visibleViews = virtualizer.render({
        layout: opts.layout,
        collection: opts.collection,
        persistedKeys: opts.persistedKeys,
        layoutOptions: opts.layoutOptions,
        visibleRect: visibleRect,
        size: opts.allowsWindowScrolling ? size : visibleRect,
        invalidationContext: mergedInvalidationContext,
        isScrolling: isScrolling
    });
    let contentSize = virtualizer.contentSize;
    let startScrolling = (0, $eF4cA.useCallback)(()=>{
        setScrolling(true);
    }, []);
    let endScrolling = (0, $eF4cA.useCallback)(()=>{
        setScrolling(false);
    }, []);
    let state = (0, $eF4cA.useMemo)(()=>({
            virtualizer: virtualizer,
            visibleViews: visibleViews,
            setVisibleRect: setVisibleRect,
            size: size,
            setSize: setSize,
            contentSize: contentSize,
            isScrolling: isScrolling,
            startScrolling: startScrolling,
            endScrolling: endScrolling
        }), [
        virtualizer,
        visibleViews,
        setVisibleRect,
        size,
        setSize,
        contentSize,
        isScrolling,
        startScrolling,
        endScrolling
    ]);
    return state;
}

});
parcelRegister("2etG9", function(module, exports) {

$parcel$export(module.exports, "Virtualizer", () => $0cae90e7e3da7e4a$export$89be5a243e59c4b2);

var $kO1rZ = parcelRequire("kO1rZ");

var $4ZggR = parcelRequire("4ZggR");

var $4fSzh = parcelRequire("4fSzh");

var $8bBQM = parcelRequire("8bBQM");

var $hvkA2 = parcelRequire("hvkA2");

var $bMKKe = parcelRequire("bMKKe");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $0cae90e7e3da7e4a$export$89be5a243e59c4b2 {
    constructor(options){
        this.delegate = options.delegate;
        this.collection = options.collection;
        this.layout = options.layout;
        this.contentSize = new (0, $bMKKe.Size)();
        this.visibleRect = new (0, $8bBQM.Rect)();
        this.size = new (0, $bMKKe.Size)();
        this.persistedKeys = new Set();
        this._visibleViews = new Map();
        this._renderedContent = new WeakMap();
        this._rootView = new (0, $kO1rZ.RootView)(this);
        this._isScrolling = false;
        this._invalidationContext = {};
        this._overscanManager = new (0, $4fSzh.OverscanManager)();
        this._scrollAnchor = new (0, $hvkA2.ScrollAnchorTracker)();
    }
    /** Returns whether the given key, or an ancestor, is persisted. */ isPersistedKey(key) {
        // Quick check if the key is directly in the set of persisted keys.
        if (this.persistedKeys.has(key)) return true;
        // If not, check if the key is an ancestor of any of the persisted keys.
        for (let k of this.persistedKeys)while(k != null){
            let layoutInfo = this.layout.getLayoutInfo(k);
            if (!layoutInfo || layoutInfo.parentKey == null) break;
            k = layoutInfo.parentKey;
            if (k === key) return true;
        }
        return false;
    }
    getParentView(layoutInfo) {
        return layoutInfo.parentKey != null ? this._visibleViews.get(layoutInfo.parentKey) : this._rootView;
    }
    getReusableView(layoutInfo) {
        let parentView = this.getParentView(layoutInfo);
        let view = parentView.getReusableView(layoutInfo.type);
        view.layoutInfo = layoutInfo;
        this._renderView(view);
        return view;
    }
    _renderView(reusableView) {
        if (reusableView.layoutInfo) {
            let { type: type, key: key, content: content } = reusableView.layoutInfo;
            reusableView.content = content || this.collection.getItem(key);
            reusableView.rendered = this._renderContent(type, reusableView.content);
        }
    }
    _renderContent(type, content) {
        let cached = content != null ? this._renderedContent.get(content) : null;
        if (cached != null) return cached;
        let rendered = this.delegate.renderView(type, content);
        if (content) this._renderedContent.set(content, rendered);
        return rendered;
    }
    /**
   * Returns the key for the item view currently at the given point.
   */ keyAtPoint(point) {
        let rect = new (0, $8bBQM.Rect)(point.x, point.y, 1, 1);
        let layoutInfos = rect.area === 0 ? [] : this.layout.getVisibleLayoutInfos(rect);
        // Layout may return multiple layout infos in the case of
        // persisted keys, so find the first one that actually intersects.
        for (let layoutInfo of layoutInfos){
            if (layoutInfo.rect.intersects(rect)) return layoutInfo.key;
        }
        return null;
    }
    relayout(context = {}) {
        // @ts-ignore
        let anchorInfo = this.layout.UNSTABLE_getScrollAnchorInfo?.(context.layoutOptions) ?? null;
        // Capture scroll anchor from current (pre-layout) view positions.
        // On first render _visibleViews is empty so no anchor will be found.
        let anchor = null;
        if (anchorInfo) {
            let preLayoutInfos = [];
            for (let [key, view] of this._visibleViews){
                let layoutInfo = this.layout.getLayoutInfo(key) ?? view.layoutInfo;
                if (layoutInfo) preLayoutInfos.push([
                    key,
                    layoutInfo
                ]);
            }
            anchor = this._scrollAnchor.captureBeforeLayout(anchorInfo, preLayoutInfos, this.visibleRect);
        }
        let previousContentSize = this.contentSize;
        let previousVisibleRect = this.visibleRect;
        // Update the layout
        this.layout.update(context);
        let rawContentSize = this.layout.getContentSize();
        this.contentSize = new (0, $bMKKe.Size)(rawContentSize.width, rawContentSize.height);
        let target = this._scrollAnchor.resolveAfterLayout({
            anchorInfo: anchorInfo,
            anchor: anchor,
            postLayoutInfos: anchorInfo ? this.getVisibleLayoutInfos() : new Map(),
            previousVisibleRect: previousVisibleRect,
            previousContentSize: previousContentSize,
            contentSize: this.contentSize,
            itemSizeChanged: context.itemSizeChanged ?? false,
            isScrolling: this._isScrolling,
            getLayoutInfo: (key)=>this.layout.getLayoutInfo(key)
        });
        if (target) {
            // Queues a new render cycle. Return early to skip updateSubviews — running it now
            // would position views against the old visibleRect, causing a flash before the
            // incoming relayout corrects them.
            this.delegate.setVisibleRect(target);
            return;
        }
        // Constrain scroll position.
        // If the content changed, scroll to the top.
        let visibleRect = this.visibleRect;
        let contentOffsetX = context.contentChanged ? 0 : visibleRect.x;
        let contentOffsetY = context.contentChanged ? 0 : visibleRect.y;
        contentOffsetX = Math.max(0, Math.min(this.contentSize.width - visibleRect.width, contentOffsetX));
        contentOffsetY = Math.max(0, Math.min(this.contentSize.height - visibleRect.height, contentOffsetY));
        if (contentOffsetX !== visibleRect.x || contentOffsetY !== visibleRect.y) {
            // If the offset changed, trigger a new re-render.
            let rect = new (0, $8bBQM.Rect)(contentOffsetX, contentOffsetY, visibleRect.width, visibleRect.height);
            this.delegate.setVisibleRect(rect);
        } else this.updateSubviews();
    }
    getVisibleLayoutInfos() {
        let isTestEnv = false;
        let isClientWidthMocked = isTestEnv && typeof HTMLElement !== 'undefined' && Object.getOwnPropertyNames(HTMLElement.prototype).includes('clientWidth');
        let isClientHeightMocked = isTestEnv && typeof HTMLElement !== 'undefined' && Object.getOwnPropertyNames(HTMLElement.prototype).includes('clientHeight');
        let rect;
        if (isTestEnv && !(isClientWidthMocked && isClientHeightMocked)) rect = new (0, $8bBQM.Rect)(0, 0, this.contentSize.width, this.contentSize.height);
        else rect = this._overscanManager.getOverscannedRect();
        let layoutInfos = this.layout.getVisibleLayoutInfos(rect);
        let map = new Map();
        for (let layoutInfo of layoutInfos)map.set(layoutInfo.key, layoutInfo);
        return map;
    }
    updateSubviews() {
        let visibleLayoutInfos = this.getVisibleLayoutInfos();
        let removed = new Set();
        for (let [key, view] of this._visibleViews){
            let layoutInfo = visibleLayoutInfos.get(key);
            // If a view's parent changed, treat it as a delete and re-create in the new parent.
            if (!layoutInfo || view.parent !== this.getParentView(layoutInfo)) {
                this._visibleViews.delete(key);
                view.parent.reuseChild(view);
                removed.add(view); // Defer removing in case we reuse this view.
            }
        }
        for (let [key, layoutInfo] of visibleLayoutInfos){
            let view = this._visibleViews.get(key);
            if (!view) {
                view = this.getReusableView(layoutInfo);
                view.parent.children.add(view);
                this._visibleViews.set(key, view);
                removed.delete(view);
            } else {
                view.layoutInfo = layoutInfo;
                let item = this.collection.getItem(layoutInfo.key);
                if (view.content !== item) {
                    if (view.content != null) this._renderedContent.delete(view.content);
                    this._renderView(view);
                }
            }
        }
        // The remaining views in `removed` were not reused to render new items.
        // They should be removed from the DOM. We also clear the reusable view queue
        // here since there's no point holding onto views that have been removed.
        // Doing so hurts performance in the future when reusing elements due to FIFO order.
        for (let view of removed){
            view.parent.children.delete(view);
            view.parent.reusableViews.clear();
        }
        // Reordering DOM nodes is costly, so we defer this until scrolling stops.
        // DOM order does not affect visual order (due to absolute positioning),
        // but does matter for assistive technology users.
        if (!this._isScrolling) for (let key of visibleLayoutInfos.keys()){
            let view = this._visibleViews.get(key);
            view.parent.children.delete(view);
            view.parent.children.add(view);
        }
    }
    /** Performs layout and updates visible views as needed. */ render(opts) {
        let mutableThis = this;
        let needsLayout = false;
        let offsetChanged = false;
        let sizeChanged = false;
        let widthChanged = false;
        let heightChanged = false;
        let itemSizeChanged = false;
        let layoutOptionsChanged = false;
        let needsUpdate = false;
        if (opts.collection !== this.collection) {
            mutableThis.collection = opts.collection;
            needsLayout = true;
        }
        if (opts.layout !== this.layout || this.layout.virtualizer !== this) {
            if (this.layout) this.layout.virtualizer = null;
            opts.layout.virtualizer = this;
            mutableThis.layout = opts.layout;
            this._scrollAnchor.reset();
            needsLayout = true;
        }
        if (opts.persistedKeys && !(0, $4ZggR.isSetEqual)(opts.persistedKeys, this.persistedKeys)) {
            mutableThis.persistedKeys = opts.persistedKeys;
            needsUpdate = true;
        }
        if (!this.visibleRect.equals(opts.visibleRect) || !this.size.equals(opts.size)) {
            this._overscanManager.setVisibleRect(opts.visibleRect);
            // Create a rectangle using the scroll position and layout size of the scroll view. This is not the same
            // as the visibleRect, whose width and height may change during window scrolling.
            let oldRect = new (0, $8bBQM.Rect)(this.visibleRect.x, this.visibleRect.y, this.size.width, this.size.height);
            let newRect = new (0, $8bBQM.Rect)(opts.visibleRect.x, opts.visibleRect.y, opts.size.width, opts.size.height);
            let shouldInvalidate = this.layout.shouldInvalidate(newRect, oldRect);
            if (shouldInvalidate) {
                offsetChanged = !opts.visibleRect.pointEquals(this.visibleRect);
                sizeChanged = !this.size.equals(opts.size);
                widthChanged = this.size.width !== opts.size.width;
                heightChanged = this.size.height !== opts.size.height;
                needsLayout = true;
            } else needsUpdate = true;
            mutableThis.visibleRect = opts.visibleRect;
            mutableThis.size = opts.size;
        }
        if (opts.invalidationContext !== this._invalidationContext) {
            if (opts.invalidationContext) {
                sizeChanged ||= opts.invalidationContext.sizeChanged || false;
                widthChanged ||= opts.invalidationContext.widthChanged || false;
                heightChanged ||= opts.invalidationContext.heightChanged || false;
                offsetChanged ||= opts.invalidationContext.offsetChanged || false;
                itemSizeChanged ||= opts.invalidationContext.itemSizeChanged || false;
                layoutOptionsChanged ||= opts.invalidationContext.layoutOptions != null && this._invalidationContext.layoutOptions != null && opts.invalidationContext.layoutOptions !== this._invalidationContext.layoutOptions && this.layout.shouldInvalidateLayoutOptions(opts.invalidationContext.layoutOptions, this._invalidationContext.layoutOptions);
                needsLayout ||= itemSizeChanged || sizeChanged || offsetChanged || layoutOptionsChanged;
            }
            this._invalidationContext = opts.invalidationContext;
        }
        if (opts.isScrolling !== this._isScrolling) {
            this._isScrolling = opts.isScrolling;
            if (!opts.isScrolling) needsUpdate = true;
        }
        if (needsLayout) this.relayout({
            offsetChanged: offsetChanged,
            sizeChanged: sizeChanged,
            widthChanged: widthChanged,
            heightChanged: heightChanged,
            itemSizeChanged: itemSizeChanged,
            layoutOptionsChanged: layoutOptionsChanged,
            layoutOptions: this._invalidationContext.layoutOptions
        });
        else if (needsUpdate) this.updateSubviews();
        return Array.from(this._rootView.children);
    }
    getVisibleView(key) {
        return this._visibleViews.get(key);
    }
    invalidate(context) {
        this.delegate.invalidate(context);
    }
    updateItemSize(key, size) {
        if (!this.layout.updateItemSize) return;
        let changed = this.layout.updateItemSize(key, size);
        if (changed) this.invalidate({
            itemSizeChanged: true
        });
    }
}

});
parcelRegister("kO1rZ", function(module, exports) {

$parcel$export(module.exports, "RootView", () => $8a8a76773ce21d26$export$e21886a4eef6b29a);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $8a8a76773ce21d26$var$$6bbafa22c92cc056$var$KEY = 0;
class $8a8a76773ce21d26$export$1a5223887c560441 {
    constructor(virtualizer, viewType){
        this.virtualizer = virtualizer;
        this.key = ++$8a8a76773ce21d26$var$$6bbafa22c92cc056$var$KEY;
        this.viewType = viewType;
        this.children = new Set();
        this.reusableViews = new Map();
        this.layoutInfo = null;
        this.content = null;
        this.rendered = null;
    }
    /**
   * Prepares the view for reuse. Called just before the view is removed from the DOM.
   */ prepareForReuse() {
        this.content = null;
        this.rendered = null;
        this.layoutInfo = null;
    }
    getReusableView(reuseType) {
        // Reusable view queue should be FIFO so that DOM order remains consistent during scrolling.
        // For example, cells within a row should remain in the same order even if the row changes contents.
        // The cells within a row are removed from their parent in order. If the row is reused, the cells
        // should be reused in the new row in the same order they were before.
        let reusable = this.reusableViews.get(reuseType);
        let view = reusable && reusable.length > 0 ? reusable.shift() : new $8a8a76773ce21d26$export$7a41b6f219e61634(this.virtualizer, this, reuseType);
        return view;
    }
    reuseChild(child) {
        child.prepareForReuse();
        let reusable = this.reusableViews.get(child.viewType);
        if (!reusable) {
            reusable = [];
            this.reusableViews.set(child.viewType, reusable);
        }
        reusable.push(child);
    }
}
class $8a8a76773ce21d26$export$e21886a4eef6b29a extends $8a8a76773ce21d26$export$1a5223887c560441 {
    constructor(virtualizer){
        super(virtualizer, 'root');
    }
}
class $8a8a76773ce21d26$export$7a41b6f219e61634 extends $8a8a76773ce21d26$export$1a5223887c560441 {
    constructor(virtualizer, parent, viewType){
        super(virtualizer, viewType);
        this.parent = parent;
    }
}

});

parcelRegister("4ZggR", function(module, exports) {

$parcel$export(module.exports, "isSetEqual", () => $f9c5e6336c1528fb$export$a8d0d0c8d1c5df64);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /** Returns whether two sets are equal. */ function $f9c5e6336c1528fb$export$a8d0d0c8d1c5df64(a, b) {
    if (a === b) return true;
    if (a.size !== b.size) return false;
    for (let key of a){
        if (!b.has(key)) return false;
    }
    return true;
}

});

parcelRegister("4fSzh", function(module, exports) {

$parcel$export(module.exports, "OverscanManager", () => $fba35477a92ba21d$export$4455ee6afb38dcbb);

var $919Au = parcelRequire("919Au");

var $8bBQM = parcelRequire("8bBQM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $fba35477a92ba21d$export$4455ee6afb38dcbb {
    setVisibleRect(rect) {
        let time = performance.now() - this.startTime;
        if (time < 500) {
            if (rect.x !== this.visibleRect.x && time > 0) this.velocity.x = (rect.x - this.visibleRect.x) / time;
            if (rect.y !== this.visibleRect.y && time > 0) this.velocity.y = (rect.y - this.visibleRect.y) / time;
        }
        this.startTime = performance.now();
        this.visibleRect = rect;
    }
    getOverscannedRect() {
        let overscanned = this.visibleRect.copy();
        let overscanY = this.visibleRect.height / 3;
        overscanned.height += overscanY;
        if (this.velocity.y < 0) overscanned.y -= overscanY;
        let overscanX = this.visibleRect.width / 3;
        overscanned.width += overscanX;
        if (this.velocity.x < 0) overscanned.x -= overscanX;
        return overscanned;
    }
    constructor(){
        this.startTime = 0;
        this.velocity = new (0, $919Au.Point)(0, 0);
        this.visibleRect = new (0, $8bBQM.Rect)();
    }
}

});

parcelRegister("hvkA2", function(module, exports) {

$parcel$export(module.exports, "ScrollAnchorTracker", () => $14f70200ad1f4f0d$export$8ce0fdedc36cb6b);

var $8bBQM = parcelRequire("8bBQM");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Minimum overlap an item must have with the viewport, along the scroll axis,
 * to be eligible as a scroll anchor. Without this, an item that only overlaps the viewport
 * by a sliver (e.g. 1px, essentially scrolled out of view) can still "win" the anchor
 * tie-break over a substantially visible item.
 */ const $14f70200ad1f4f0d$var$$78014f4785404d8e$var$MIN_ANCHOR_OVERLAP = 4;
function $14f70200ad1f4f0d$var$$78014f4785404d8e$var$dimensionForAxis(axis) {
    return axis === 'x' ? 'width' : 'height';
}
function $14f70200ad1f4f0d$export$413719533c5919c9(anchor, axis, getLayoutInfo, visibleRect, contentSize) {
    let finalInfo = getLayoutInfo(anchor.key);
    if (!finalInfo) return null;
    let adjustment = finalInfo.rect[anchor.corner][axis] - visibleRect[axis] - anchor.offset;
    if (adjustment === 0) return null;
    let target = visibleRect[axis] + adjustment;
    let dimension = $14f70200ad1f4f0d$var$$78014f4785404d8e$var$dimensionForAxis(axis);
    let max = Math.max(0, contentSize[dimension] - visibleRect[dimension]);
    let clamped = Math.max(0, Math.min(max, target));
    return clamped !== visibleRect[axis] ? clamped : null;
}
function $14f70200ad1f4f0d$export$69fb4c6de5f339b7(edge, axis, visibleRect, visibleLayoutInfos, isAnchorable = ()=>true) {
    let dimension = $14f70200ad1f4f0d$var$$78014f4785404d8e$var$dimensionForAxis(axis);
    let best = null;
    for (let [key, layoutInfo] of visibleLayoutInfos){
        if (!layoutInfo || !isAnchorable(layoutInfo)) continue;
        let overlap = layoutInfo.rect.intersection(visibleRect)[dimension];
        if (layoutInfo.rect.area > 0 && overlap >= $14f70200ad1f4f0d$var$$78014f4785404d8e$var$MIN_ANCHOR_OVERLAP) {
            let corner = layoutInfo.rect.getCornerInRect(visibleRect) ?? 'topLeft';
            let offset = layoutInfo.rect[corner][axis] - visibleRect[axis];
            let isBetter = !best || (edge === 'end' ? offset < best.offset : offset > best.offset);
            if (isBetter) best = {
                key: key,
                corner: corner,
                offset: offset
            };
        }
    }
    return best;
}
function $14f70200ad1f4f0d$export$c74597e403428eac(edge, axis, contentSize, previousVisibleRect) {
    if (edge === 'start') return 0;
    let dimension = $14f70200ad1f4f0d$var$$78014f4785404d8e$var$dimensionForAxis(axis);
    return Math.max(0, contentSize[dimension] - previousVisibleRect[dimension]);
}
function $14f70200ad1f4f0d$export$f644bffd4937530e(visibleRect, contentSize, edge, axis, threshold) {
    if (edge === 'start') return visibleRect[axis] <= threshold;
    let dimension = $14f70200ad1f4f0d$var$$78014f4785404d8e$var$dimensionForAxis(axis);
    let distanceFromEnd = contentSize[dimension] - (visibleRect[axis] + visibleRect[dimension]);
    return distanceFromEnd <= threshold;
}
function $14f70200ad1f4f0d$export$dcb80b718ca193d7(edge, axis, anchor, wasNearAnchorEdge, isScrolling, itemSizeChanged, contentSizeDelta, getLayoutInfo, previousVisibleRect, contentSize) {
    let withTarget = (target)=>axis === 'x' ? new (0, $8bBQM.Rect)(target, previousVisibleRect.y, previousVisibleRect.width, previousVisibleRect.height) : new (0, $8bBQM.Rect)(previousVisibleRect.x, target, previousVisibleRect.width, previousVisibleRect.height);
    if (anchor) {
        let target = $14f70200ad1f4f0d$export$413719533c5919c9(anchor, axis, getLayoutInfo, previousVisibleRect, contentSize);
        if (target != null) return withTarget(target);
    }
    if (wasNearAnchorEdge && !isScrolling && (!itemSizeChanged || contentSizeDelta > 0)) {
        let target = withTarget($14f70200ad1f4f0d$export$c74597e403428eac(edge, axis, contentSize, previousVisibleRect));
        return target.equals(previousVisibleRect) ? null : target;
    }
    return null;
}
class $14f70200ad1f4f0d$export$8ce0fdedc36cb6b {
    /** Resets all tracked state, e.g. when the virtualizer's layout instance changes. */ reset() {
        this.hasSnappedToEdge = false;
        this.hadEstimatedVisibleItems = false;
        this.wasNearAnchorEdge = false;
    }
    /**
   * Captures the anchor from pre-layout view positions.
   */ captureBeforeLayout(anchorInfo, preLayoutInfos, visibleRect) {
        if (!anchorInfo) return null;
        return $14f70200ad1f4f0d$export$69fb4c6de5f339b7(anchorInfo.edge, anchorInfo.axis, visibleRect, preLayoutInfos, anchorInfo.isAnchorable);
    }
    /**
   * Runs the full post-layout decision: updates the tracked state for the next pass, and
   * returns the resolved scroll target, or null if nothing should change.
   */ resolveAfterLayout(options) {
        let { anchorInfo: anchorInfo, anchor: anchor, postLayoutInfos: postLayoutInfos, previousVisibleRect: previousVisibleRect, previousContentSize: previousContentSize, contentSize: contentSize, itemSizeChanged: itemSizeChanged, isScrolling: isScrolling, getLayoutInfo: getLayoutInfo } = options;
        if (!anchorInfo) return null;
        // Read the previous pass's state into locals before any writes below overwrite it.
        let wasSettlingLastPass = this.hadEstimatedVisibleItems;
        let wasNearAnchorEdgeLastPass = this.wasNearAnchorEdge;
        let hasEstimated = false;
        for (let layoutInfo of postLayoutInfos.values())if (layoutInfo.estimatedSize) {
            hasEstimated = true;
            break;
        }
        this.hadEstimatedVisibleItems = hasEstimated;
        // Don't recheck "near edge?" mid-resize because it could look like a scroll that never happened.
        // Reuse the answer from before the resizing started.
        if (!wasSettlingLastPass) this.wasNearAnchorEdge = $14f70200ad1f4f0d$export$f644bffd4937530e(previousVisibleRect, previousContentSize, anchorInfo.edge, anchorInfo.axis, anchorInfo.threshold);
        if (previousVisibleRect.area === 0) return null;
        let dimension = anchorInfo.axis === 'x' ? 'width' : 'height';
        let contentSizeDelta = contentSize[dimension] - previousContentSize[dimension];
        let isFirstAnchoredLayout = !this.hasSnappedToEdge;
        this.hasSnappedToEdge = true;
        // Only modify scroll when content actually changed (or this is the first layout, which always snaps)
        if (!(isFirstAnchoredLayout || contentSizeDelta !== 0 || itemSizeChanged)) return null;
        let wasNearAnchorEdge = isFirstAnchoredLayout || wasSettlingLastPass && wasNearAnchorEdgeLastPass || $14f70200ad1f4f0d$export$f644bffd4937530e(previousVisibleRect, previousContentSize, anchorInfo.edge, anchorInfo.axis, anchorInfo.threshold);
        // A first-ever layout always snaps to the edge, even if the raw distance check says
        // otherwise. Save that real decision here so later passes in this cascade reuse it.
        if (!wasSettlingLastPass) this.wasNearAnchorEdge = wasNearAnchorEdge;
        // Skip restoring to the captured anchor while still resizing because items above it are also still growing,
        // and following it would fall short of the edge.
        let effectiveAnchor = isFirstAnchoredLayout || wasSettlingLastPass && wasNearAnchorEdgeLastPass ? null : anchor;
        return $14f70200ad1f4f0d$export$dcb80b718ca193d7(anchorInfo.edge, anchorInfo.axis, effectiveAnchor, wasNearAnchorEdge, isScrolling, itemSizeChanged, contentSizeDelta, getLayoutInfo, previousVisibleRect, contentSize);
    }
    constructor(){
        this.hasSnappedToEdge = false;
        this.hadEstimatedVisibleItems = false;
        this.wasNearAnchorEdge = false;
    }
}

});



parcelRegister("ei9S8", function(module, exports) {

$parcel$export(module.exports, "useScrollView", () => $f5a84ea0f5f70cd7$export$2ea0c4974da4731b);

var $7ByPJ = parcelRequire("7ByPJ");

var $fvyIQ = parcelRequire("fvyIQ");

var $lfYk7 = parcelRequire("lfYk7");

var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $26CkO = parcelRequire("26CkO");

var $f9wnx = parcelRequire("f9wnx");

var $l19Vn = parcelRequire("l19Vn");

var $919Au = parcelRequire("919Au");
var $8bBQM = parcelRequire("8bBQM");
var $bMKKe = parcelRequire("bMKKe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f5a84ea0f5f70cd7$var$$d83ca946696b1300$var$ScrollView(props, ref) {
    ref = (0, $26CkO.useObjectRef)(ref);
    let { scrollViewProps: scrollViewProps, contentProps: contentProps } = $f5a84ea0f5f70cd7$export$2ea0c4974da4731b(props, ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "presentation",
        ...scrollViewProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", contentProps, props.children));
}
const $f5a84ea0f5f70cd7$export$5665e3d6be6adea = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef($f5a84ea0f5f70cd7$var$$d83ca946696b1300$var$ScrollView);
function $f5a84ea0f5f70cd7$export$2ea0c4974da4731b(props, ref) {
    let { contentSize: contentSize, onVisibleRectChange: onVisibleRectChange, onSizeChange: onSizeChange, innerStyle: innerStyle, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollDirection: scrollDirection = 'both', onScroll: onScrollProp, allowsWindowScrolling: allowsWindowScrolling, ...otherProps } = props;
    // oxlint-disable-next-line react/react-compiler
    let state = (0, $eF4cA.useRef)({
        // Internal scroll position of the scroll view.
        scrollPosition: new (0, $919Au.Point)(),
        // Size of the scroll view.
        size: new (0, $bMKKe.Size)(),
        // Offset of the scroll view relative to the window viewport.
        viewportOffset: new (0, $919Au.Point)(),
        // Size of the window viewport.
        viewportSize: new (0, $bMKKe.Size)(),
        scrollEndTime: 0,
        scrollTimeout: null,
        isScrolling: false,
        lastVisibleRect: new (0, $8bBQM.Rect)()
    }).current;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let updateVisibleRect = (0, $eF4cA.useCallback)(()=>{
        // Intersect the window viewport with the scroll view itself to find the actual visible rectangle.
        // This allows virtualized components to have unbounded height but still virtualize when scrolled with the page.
        // While there may be other scrollable elements between the <body> and the scroll view, we do not take
        // their sizes into account for performance reasons. Their scroll positions are accounted for in viewportOffset
        // though (due to getBoundingClientRect). This may result in more rows than absolutely necessary being rendered,
        // but no more than the entire height of the viewport which is good enough for virtualization use cases.
        let visibleRect = allowsWindowScrolling ? new (0, $8bBQM.Rect)(state.viewportOffset.x + state.scrollPosition.x, state.viewportOffset.y + state.scrollPosition.y, Math.max(0, Math.min(state.size.width - state.viewportOffset.x, state.viewportSize.width)), Math.max(0, Math.min(state.size.height - state.viewportOffset.y, state.viewportSize.height))) : new (0, $8bBQM.Rect)(state.scrollPosition.x, state.scrollPosition.y, state.size.width, state.size.height);
        // Don't emit updates if the visible area is zero and the last emitted area was also zero.
        if (visibleRect.area > 0 || state.lastVisibleRect.area > 0) {
            onVisibleRectChange(visibleRect);
            state.lastVisibleRect = visibleRect;
        }
    }, [
        state,
        allowsWindowScrolling,
        onVisibleRectChange
    ]);
    let [isScrolling, setScrolling] = (0, $eF4cA.useState)(false);
    let onScroll = (0, $eF4cA.useCallback)((e)=>{
        let target = (0, $fvyIQ.getEventTarget)(e);
        if (!(0, $fvyIQ.nodeContains)(target, ref.current)) return;
        if (onScrollProp && target === ref.current) onScrollProp(e);
        if (target !== ref.current) {
            // An ancestor element or the window was scrolled. Update the position of the scroll view relative to the viewport.
            let boundingRect = ref.current.getBoundingClientRect();
            let x = boundingRect.x < 0 ? -boundingRect.x : 0;
            let y = boundingRect.y < 0 ? -boundingRect.y : 0;
            if (x === state.viewportOffset.x && y === state.viewportOffset.y) return;
            state.viewportOffset = new (0, $919Au.Point)(x, y);
        } else {
            // The scroll view itself was scrolled. Update the local scroll position.
            // Prevent rubber band scrolling from shaking when scrolling out of bounds
            let scrollTop = target.scrollTop;
            let scrollLeft = (0, $lfYk7.getScrollLeft)(target, direction);
            state.scrollPosition = new (0, $919Au.Point)(Math.max(0, Math.min(scrollLeft, contentSize.width - state.size.width)), Math.max(0, Math.min(scrollTop, contentSize.height - state.size.height)));
        }
        (0, $l19Vn.flushSync)(()=>{
            updateVisibleRect();
            if (!state.isScrolling) {
                state.isScrolling = true;
                setScrolling(true);
                // Pause typekit MutationObserver during scrolling.
                window.dispatchEvent(new Event('tk.disconnect-observer'));
                if (onScrollStart) onScrollStart();
            }
            // So we don't constantly call clearTimeout and setTimeout,
            // keep track of the current timeout time and only reschedule
            // the timer when it is getting close.
            let now = Date.now();
            if (state.scrollEndTime <= now + 50) {
                state.scrollEndTime = now + 300;
                if (state.scrollTimeout != null) clearTimeout(state.scrollTimeout);
                state.scrollTimeout = setTimeout(()=>{
                    state.isScrolling = false;
                    setScrolling(false);
                    state.scrollTimeout = null;
                    window.dispatchEvent(new Event('tk.connect-observer'));
                    if (onScrollEnd) onScrollEnd();
                }, 300);
            }
        });
    }, [
        onScrollProp,
        ref,
        direction,
        state,
        contentSize,
        updateVisibleRect,
        onScrollStart,
        onScrollEnd
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return (0, $7ByPJ.addEvent)((0, $fvyIQ.getPropagationTargets)(ref.current, (0, $7ByPJ.getOwnerDocument)(ref.current)), 'scroll', onScroll, true);
    }, [
        onScroll,
        ref
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (state.scrollTimeout != null) clearTimeout(state.scrollTimeout);
            if (state.isScrolling) window.dispatchEvent(new Event('tk.connect-observer'));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let isUpdatingSize = (0, $eF4cA.useRef)(false);
    let updateSize = (0, $eF4cA.useCallback)((flush)=>{
        let dom = ref.current;
        if (!dom || isUpdatingSize.current) return;
        // Prevent reentrancy when resize observer fires, triggers re-layout that results in
        // content size update, causing below layout effect to fire. This avoids infinite loops.
        isUpdatingSize.current = true;
        let isTestEnv = false;
        let isClientWidthMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes('clientWidth');
        let isClientHeightMocked = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes('clientHeight');
        let clientWidth = dom.clientWidth;
        let clientHeight = dom.clientHeight;
        let w = isTestEnv && !isClientWidthMocked ? Infinity : clientWidth;
        let h = isTestEnv && !isClientHeightMocked ? Infinity : clientHeight;
        // Update the window viewport size.
        let viewportWidth = window.innerWidth;
        let viewportHeight = window.innerHeight;
        let viewportSizeChanged = state.viewportSize.width !== viewportWidth || state.viewportSize.height !== viewportHeight;
        if (viewportSizeChanged) state.viewportSize = new (0, $bMKKe.Size)(viewportWidth, viewportHeight);
        if (state.size.width !== w || state.size.height !== h || viewportSizeChanged) {
            state.size = new (0, $bMKKe.Size)(w, h);
            flush(()=>{
                updateVisibleRect();
                onSizeChange?.(state.size);
            });
            // If the clientWidth or clientHeight changed, scrollbars appeared or disappeared as
            // a result of the layout update. In this case, re-layout again to account for the
            // adjusted space. In very specific cases this might result in the scrollbars disappearing
            // again, resulting in extra padding. We stop after a maximum of two layout passes to avoid
            // an infinite loop. This matches how browsers behavior with native CSS grid layout.
            if (!isTestEnv && clientWidth !== dom.clientWidth || clientHeight !== dom.clientHeight) {
                state.size = new (0, $bMKKe.Size)(dom.clientWidth, dom.clientHeight);
                flush(()=>{
                    updateVisibleRect();
                    onSizeChange?.(state.size);
                });
            }
        }
        isUpdatingSize.current = false;
    }, [
        ref,
        state,
        updateVisibleRect,
        onSizeChange
    ]);
    let updateSizeEvent = (0, $4lMDe.useEffectEvent)(updateSize);
    (0, $4skXn.useLayoutEffect)(()=>{
        // Initialize viewportRect before updating size for the first time.
        state.viewportSize = new (0, $bMKKe.Size)(window.innerWidth, window.innerHeight);
        let onWindowResize = ()=>{
            updateSizeEvent((0, $l19Vn.flushSync));
        };
        window.addEventListener('resize', onWindowResize);
        return ()=>window.removeEventListener('resize', onWindowResize);
    }, [
        state
    ]);
    // Update visible rect when the content size changes, in case scrollbars need to appear or disappear.
    let lastContentSize = (0, $eF4cA.useRef)(null);
    let [update, setUpdate] = (0, $eF4cA.useState)({});
    (0, $4skXn.useLayoutEffect)(()=>{
        if (!isUpdatingSize.current && (lastContentSize.current == null || !contentSize.equals(lastContentSize.current))) {
            // React doesn't allow flushSync inside effects, so queue a microtask.
            // We also need to wait until all refs are set (e.g. when passing a ref down from a parent).
            // If we are in an `act` environment, update immediately without a microtask so you don't need
            // to mock timers in tests. In this case, the update is synchronous already.
            // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
            // https://github.com/reactwg/react-18/discussions/102
            if (typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined') {
                // This is so we update size in a separate render but within the same act. Needs to be setState instead of refs
                // due to strict mode.
                setUpdate({});
                lastContentSize.current = contentSize;
                return;
            } else queueMicrotask(()=>updateSizeEvent((0, $l19Vn.flushSync)));
        }
        lastContentSize.current = contentSize;
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        updateSizeEvent((fn)=>fn());
    }, [
        update
    ]);
    let onResize = (0, $eF4cA.useCallback)(()=>{
        updateSize((0, $l19Vn.flushSync));
    }, [
        updateSize
    ]);
    (0, $f9wnx.useResizeObserver)({
        ref: ref,
        box: 'border-box',
        onResize: onResize
    });
    let style = {
        // Reset padding so that relative positioning works correctly. Padding will be done in JS layout.
        padding: 0,
        ...otherProps.style
    };
    if (scrollDirection === 'horizontal') {
        style.overflowX = 'auto';
        style.overflowY = 'hidden';
    // oxlint-disable-next-line react/react-compiler
    } else if (scrollDirection === 'vertical' || contentSize.width === state.size.width) {
        // Set overflow-x: hidden if content size is equal to the width of the scroll view.
        // This prevents horizontal scrollbars from flickering during resizing due to resize observer
        // firing slower than the frame rate, which may cause an infinite re-render loop.
        style.overflowY = 'auto';
        style.overflowX = 'hidden';
    } else style.overflow = 'auto';
    innerStyle = {
        width: Number.isFinite(contentSize.width) ? contentSize.width : undefined,
        height: Number.isFinite(contentSize.height) ? contentSize.height : undefined,
        pointerEvents: isScrolling ? 'none' : 'auto',
        position: 'relative',
        ...innerStyle
    };
    return {
        isScrolling: isScrolling,
        scrollViewProps: {
            ...otherProps,
            style: style
        },
        contentProps: {
            role: 'presentation',
            style: innerStyle
        }
    };
}

});
parcelRegister("lfYk7", function(module, exports) {

$parcel$export(module.exports, "getScrollLeft", () => $2ad90d1baddfc47a$export$1389d168952b34b5);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult = null;
function $2ad90d1baddfc47a$export$faf7630257ad4304(recalculate = false) {
    if ($2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult === null || recalculate) {
        const outerDiv = document.createElement('div');
        const outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        const innerDiv = document.createElement('div');
        const innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult = 'negative';
            else $2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult;
    }
    return $2ad90d1baddfc47a$var$$3db4938a3baa5776$var$cachedRTLResult;
}
function $2ad90d1baddfc47a$export$1389d168952b34b5(node, direction) {
    let { scrollLeft: scrollLeft } = node;
    // scrollLeft in rtl locales differs across browsers, so normalize.
    // See comment by getRTLOffsetType below for details.
    if (direction === 'rtl') {
        let { scrollWidth: scrollWidth, clientWidth: clientWidth } = node;
        switch($2ad90d1baddfc47a$export$faf7630257ad4304()){
            case 'negative':
                scrollLeft = -scrollLeft;
                break;
            case 'positive-descending':
                scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
        }
    }
    return scrollLeft;
}
function $2ad90d1baddfc47a$export$ed5fd5ffe5ab0ac(node, direction, scrollLeft) {
    if (direction === 'rtl') switch($2ad90d1baddfc47a$export$faf7630257ad4304()){
        case 'negative':
            scrollLeft = -scrollLeft;
            break;
        case 'positive-ascending':
            break;
        default:
            {
                const { clientWidth: clientWidth, scrollWidth: scrollWidth } = node;
                scrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
    }
    node.scrollLeft = scrollLeft;
}

});


parcelRegister("300io", function(module, exports) {

$parcel$export(module.exports, "VirtualizerItem", () => $1715567fe05e776b$export$6796df8ba7398521);

var $1ntKq = parcelRequire("1ntKq");

var $8btCe = parcelRequire("8btCe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1715567fe05e776b$export$6796df8ba7398521(props) {
    let { style: style, className: className, layoutInfo: layoutInfo, virtualizer: virtualizer, parent: parent, children: children, shouldObserveItemSize: shouldObserveItemSize } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let ref = (0, $eF4cA.useRef)(null);
    (0, $8btCe.useVirtualizerItem)({
        layoutInfo: layoutInfo,
        virtualizer: virtualizer,
        ref: ref,
        shouldObserveItemSize: shouldObserveItemSize
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "presentation",
        ref: ref,
        className: className,
        style: {
            ...$1715567fe05e776b$export$1481e64fbe01b8b3(layoutInfo, direction, parent),
            ...style
        }
    }, children);
}
let $1715567fe05e776b$var$$6c92e9e346cd7b1c$var$cache = new WeakMap();
function $1715567fe05e776b$export$1481e64fbe01b8b3(layoutInfo, dir, parent) {
    let xProperty = dir === 'rtl' ? 'right' : 'left';
    let cached = $1715567fe05e776b$var$$6c92e9e346cd7b1c$var$cache.get(layoutInfo);
    if (cached && cached[xProperty] != null) {
        if (!parent) return cached;
        // Invalidate if the parent position changed.
        let top = layoutInfo.rect.y - parent.rect.y;
        let x = layoutInfo.rect.x - parent.rect.x;
        if (cached.top === top && cached[xProperty] === x) return cached;
    }
    let rectStyles = {
        // TODO: For layoutInfos that are sticky that have parents with overflow visible, their "top" will be relative to the to the nearest scrolling container
        // which WON'T be the parent since the parent has overflow visible. This means we shouldn't offset the height by the parent's position
        // Not 100% about this change here since it is quite ambigious what the scrolling container maybe and how its top is positioned with respect to the
        // calculated layoutInfo.y here
        top: layoutInfo.rect.y - (parent && !(parent.allowOverflow && layoutInfo.isSticky) ? parent.rect.y : 0),
        [xProperty]: layoutInfo.rect.x - (parent && !(parent.allowOverflow && layoutInfo.isSticky) ? parent.rect.x : 0),
        width: layoutInfo.rect.width,
        height: layoutInfo.rect.height
    };
    // Get rid of any non finite values since they aren't valid css values
    Object.entries(rectStyles).forEach(([key, value])=>{
        if (!Number.isFinite(value)) rectStyles[key] = undefined;
    });
    let style = {
        position: layoutInfo.isSticky ? 'sticky' : 'absolute',
        // Sticky elements are positioned in normal document flow. Display inline-block so that they don't push other sticky columns onto the following rows.
        display: layoutInfo.isSticky ? 'inline-block' : undefined,
        overflow: layoutInfo.allowOverflow ? 'visible' : 'hidden',
        opacity: layoutInfo.opacity,
        zIndex: layoutInfo.zIndex,
        transform: layoutInfo.transform ?? undefined,
        contain: 'size layout style',
        ...rectStyles
    };
    $1715567fe05e776b$var$$6c92e9e346cd7b1c$var$cache.set(layoutInfo, style);
    return style;
}

});
parcelRegister("8btCe", function(module, exports) {

$parcel$export(module.exports, "useVirtualizerItem", () => $1c7be5762116fb39$export$1da781778207e0a2);

var $030rU = parcelRequire("030rU");

var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $bMKKe = parcelRequire("bMKKe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1c7be5762116fb39$export$1da781778207e0a2(options) {
    let { layoutInfo: layoutInfo, virtualizer: virtualizer, ref: ref, shouldObserveItemSize: shouldObserveItemSize } = options;
    let key = layoutInfo?.key;
    let updateSize = (0, $eF4cA.useCallback)(()=>{
        if (key != null && ref.current) {
            // if the virtualized item is not visible (aka display none on virtualized collection),
            // we want to avoid reporting size 0 otherwise we get into a state where the virtualizer renders 0 items
            // when it is hidden and thus won't remeasure when it is is unhidden
            if (!(0, $030rU.isElementVisible)(ref.current)) return;
            let size = $1c7be5762116fb39$var$$cd3854145620ec6a$var$getSize(ref.current);
            virtualizer.updateItemSize(key, size);
        }
    }, [
        virtualizer,
        key,
        ref
    ]);
    let updateSizeEvent = (0, $4lMDe.useEffectEvent)(updateSize);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (layoutInfo?.estimatedSize) updateSizeEvent();
    });
    (0, $eF4cA.useEffect)(()=>{
        if (!shouldObserveItemSize) return;
        let el = ref.current;
        if (!el || typeof ResizeObserver === 'undefined') return;
        let resizeObserver = new ResizeObserver((entries)=>{
            if (!entries.length) return;
            updateSizeEvent();
        });
        for (let child of el.children)resizeObserver.observe(child);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        shouldObserveItemSize,
        ref,
        key
    ]);
    return {
        updateSize: updateSize
    };
}
function $1c7be5762116fb39$var$$cd3854145620ec6a$var$getSize(node) {
    // Reset height before measuring so we get the intrinsic size
    let height = node.style.height;
    node.style.height = '';
    let size = new (0, $bMKKe.Size)(node.scrollWidth, node.scrollHeight);
    node.style.height = height;
    return size;
}

});




parcelRegister("2t0pV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab450c0ef5faa3f$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $eab450c0ef5faa3f$var$$bd5e39574bf57a38$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 10,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 8.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 4,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 4,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 16,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 16,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            })
        ]
    });
const $eab450c0ef5faa3f$var$$bd5e39574bf57a38$var$ForwardRef = (0, $eF4cA.forwardRef)($eab450c0ef5faa3f$var$$bd5e39574bf57a38$var$SvgComponent);
var $eab450c0ef5faa3f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($eab450c0ef5faa3f$var$$bd5e39574bf57a38$var$ForwardRef);

});



parcelRegister("KXDAG", function(module, exports) {

$parcel$export(module.exports, "DropZone", () => $d3274581e3cfb06b$export$3c6489d84dc98b6);


var $c0XRK = parcelRequire("c0XRK");

var $fL4LX = parcelRequire("fL4LX");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $2wpnM = parcelRequire("2wpnM");

var $gI8Gw = parcelRequire("gI8Gw");
function $d3274581e3cfb06b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d3274581e3cfb06b$export$14a72053295ff9a6 = (0, $eF4cA.createContext)(null);
const $d3274581e3cfb06b$var$$fb6e45fba2483f65$var$dropzone = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    rules += ' sd182';
    rules += ' _Ca182';
    rules += ' eb182';
    if (!position) rules += ' _Pc182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' po182';
    if (props.isDropTarget) rules += ' _jf182';
    else rules += ' _ja182';
    if (props.isDropTarget) rules += ' g_e182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    if (props.isFocusVisible) rules += ' ix182';
    else if (props.isDropTarget) rules += ' ix182';
    else rules += ' iq182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    rules += ' Th182';
    rules += ' Qh182';
    rules += ' Sh182';
    rules += ' Rh182';
    rules += ' _oa182';
    return rules;
};
const $d3274581e3cfb06b$var$$fb6e45fba2483f65$var$banner = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' _Er182';
    rules += ' _Rr182';
    rules += ' IM182';
    rules += ' HM182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' MAyFGYc182';
    rules += ' ZJ182';
    if (props.size === "L") rules += ' Lg182';
    else if (props.size === "S") rules += ' Le182';
    else rules += ' Lf182';
    rules += ' g2182';
    rules += ' ob182';
    rules += ' nb182';
    rules += ' kb182';
    rules += ' jb182';
    rules += ' px182';
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    rules += ' T85xBjb182';
    rules += ' Q85xBjb182';
    rules += ' S85xBjb182';
    rules += ' R85xBjb182';
    rules += ' -M_-Mf182';
    return rules;
};
const $d3274581e3cfb06b$export$3c6489d84dc98b6 = (0, $eF4cA.forwardRef)(function DropZone(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($d3274581e3cfb06b$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $d3274581e3cfb06b$export$14a72053295ff9a6);
    let { size: size = 'M' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $2wpnM.DropZone), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + $d3274581e3cfb06b$var$$fb6e45fba2483f65$var$dropzone(renderProps, props.styles),
        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $c0XRK.IllustratedMessageContext).Provider, {
                        value: {
                            isInDropZone: true,
                            isDropTarget: renderProps.isDropTarget,
                            size: size
                        },
                        children: props.children
                    }),
                    renderProps.isDropTarget && props.isFilled && (0, $dx4lB.jsx)("div", {
                        className: $d3274581e3cfb06b$var$$fb6e45fba2483f65$var$banner({
                            size: size
                        }),
                        children: (0, $dx4lB.jsx)("span", {
                            children: props.replaceMessage ? props.replaceMessage : stringFormatter.format('dropzone.replaceMessage')
                        })
                    })
                ]
            })
    });
});

});
parcelRegister("c0XRK", function(module, exports) {

$parcel$export(module.exports, "IllustratedMessageContext", () => $5f511a5d7c6e541f$export$d661ef89ad42d682);
$parcel$export(module.exports, "IllustratedMessage", () => $5f511a5d7c6e541f$export$406dbc84c317ece0);


var $lK44Y = parcelRequire("lK44Y");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5f511a5d7c6e541f$var$$4950413ac998f607$var$illustratedMessage = function anonymous(props, overrides) {
    let rules = " ";
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' se182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    else if (props.size === "XS") rules += ' pt182';
    else rules += ' pt182';
    if (props.orientation === "horizontal") {
        if (!maxWidth) rules += ' Lj182';
    } else if (props.orientation === "vertical") {
        if (!maxWidth) rules += ' Li182';
    }
    if (props.orientation === "horizontal") rules += ' CLJajOe182';
    else if (props.orientation === "vertical") rules += ' CPmblS182';
    if (props.orientation === "horizontal") rules += ' E6zxP8c182';
    else if (props.orientation === "vertical") {
        if (props.size === "L") rules += ' EdL799182';
        else rules += ' E02fTrb182';
    }
    if (props.orientation === "horizontal") rules += ' DrSmbR182';
    if (props.orientation === "horizontal") rules += ' _Dc182';
    else if (props.orientation === "vertical") rules += ' _Da182';
    if (props.orientation === "vertical") rules += ' _Wa182';
    return rules;
};
const $5f511a5d7c6e541f$var$$4950413ac998f607$var$illustration = function anonymous(props) {
    let rules = " ";
    rules += ' zTZ8xtd182';
    rules += ' yTZ8xtd182';
    rules += ' BTZ8xtd182';
    rules += ' ATZ8xtd182';
    rules += ' _dc182';
    if (props.isDropTarget) rules += ' -_8sjo0b-pu182';
    else rules += ' -_8sjo0b-pt182';
    return rules;
};
const $5f511a5d7c6e541f$var$$4950413ac998f607$var$heading = function anonymous(props) {
    let rules = " ";
    rules += ' zPCJngb182';
    rules += ' yPCJngb182';
    rules += ' BPCJngb182';
    rules += ' APCJngb182';
    if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "L") {
        rules += ' -_6BNtrc-g182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-f182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    }
    if (props.size === "L") {
        rules += ' xd182';
        rules += ' _xa182';
        rules += ' xX0cczbc182';
        rules += ' _xX0cczba182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "M") {
        rules += ' xd182';
        rules += ' _xa182';
        rules += ' xX0cczbc182';
        rules += ' _xX0cczba182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "S") {
        rules += ' xd182';
        rules += ' _xa182';
        rules += ' xX0cczbc182';
        rules += ' _xX0cczba182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    }
    if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "M") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "L") rules += ' po182';
    else if (props.size === "M") rules += ' po182';
    else if (props.size === "S") rules += ' po182';
    rules += ' _dd182';
    rules += ' Jy182';
    rules += ' Gy182';
    rules += ' Iy182';
    rules += ' Hy182';
    return rules;
};
const $5f511a5d7c6e541f$var$$4950413ac998f607$var$content = function anonymous(props) {
    let rules = " ";
    if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "L") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "M") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "L") {
        rules += ' _Fb182';
        rules += ' _FnuYUwec182';
    } else if (props.size === "M") {
        rules += ' _Fb182';
        rules += ' _FnuYUwec182';
    } else if (props.size === "S") {
        rules += ' _Fb182';
        rules += ' _FnuYUwec182';
    }
    if (props.size === "L") rules += ' pt182';
    else if (props.size === "M") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    rules += ' zk52g2d182';
    rules += ' yk52g2d182';
    rules += ' Bk52g2d182';
    rules += ' Ak52g2d182';
    rules += ' _de182';
    return rules;
};
const $5f511a5d7c6e541f$var$$4950413ac998f607$var$buttonGroup = " zmlKpq182 ymlKpq182 BmlKpq182 AmlKpq182 JC182";
const $5f511a5d7c6e541f$export$d661ef89ad42d682 = (0, $eF4cA.createContext)(null);
const $5f511a5d7c6e541f$export$406dbc84c317ece0 = (0, $eF4cA.forwardRef)(function IllustratedMessage(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $5f511a5d7c6e541f$export$d661ef89ad42d682);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { children: children, orientation: orientation = 'horizontal', size: size = 'M', UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, isInDropZone: isInDropZone = false, isDropTarget: isDropTarget = false, ...otherProps } = props;
    return (0, $dx4lB.jsx)("div", {
        ...(0, $fVfXf.filterDOMProps)(otherProps),
        style: UNSAFE_style,
        className: UNSAFE_className + $5f511a5d7c6e541f$var$$4950413ac998f607$var$illustratedMessage({
            size: props.size || 'M',
            orientation: props.orientation || 'vertical'
        }, props.styles),
        ref: domRef,
        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
            values: [
                [
                    (0, $208Op.HeadingContext),
                    {
                        styles: $5f511a5d7c6e541f$var$$4950413ac998f607$var$heading({
                            orientation: orientation,
                            size: size
                        })
                    }
                ],
                [
                    (0, $208Op.ContentContext),
                    {
                        styles: $5f511a5d7c6e541f$var$$4950413ac998f607$var$content({
                            size: size
                        })
                    }
                ],
                [
                    (0, $dm5H1.IllustrationContext),
                    {
                        size: size === 'L' ? 'L' : 'M',
                        styles: $5f511a5d7c6e541f$var$$4950413ac998f607$var$illustration({
                            orientation: orientation,
                            size: size,
                            isInDropZone: isInDropZone,
                            isDropTarget: isDropTarget
                        })
                    }
                ],
                [
                    (0, $lK44Y.ButtonGroupContext),
                    {
                        styles: $5f511a5d7c6e541f$var$$4950413ac998f607$var$buttonGroup
                    }
                ]
            ],
            children: children
        })
    });
});

});

parcelRegister("2wpnM", function(module, exports) {

$parcel$export(module.exports, "DropZone", () => $9f265f20d6cb4e1b$export$3c6489d84dc98b6);

var $fDYaM = parcelRequire("fDYaM");

var $hJVXE = parcelRequire("hJVXE");

var $c1ibQ = parcelRequire("c1ibQ");

var $OwH9B = parcelRequire("OwH9B");

var $fVfXf = parcelRequire("fVfXf");

var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");

var $3OYqT = parcelRequire("3OYqT");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $fipJz = parcelRequire("fipJz");

var $8PVB5 = parcelRequire("8PVB5");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $dkaC0 = parcelRequire("dkaC0");

var $gI8Gw = parcelRequire("gI8Gw");

var $26CkO = parcelRequire("26CkO");

var $25dFS = parcelRequire("25dFS");

var $31fH3 = parcelRequire("31fH3");
function $9f265f20d6cb4e1b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9f265f20d6cb4e1b$export$14a72053295ff9a6 = (0, $eF4cA.createContext)(null);
const $9f265f20d6cb4e1b$export$3c6489d84dc98b6 = (0, $eF4cA.forwardRef)(function DropZone(props, ref) {
    let { isDisabled: isDisabled = false } = props;
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $9f265f20d6cb4e1b$export$14a72053295ff9a6);
    let dropzoneRef = (0, $26CkO.useObjectRef)(ref);
    let buttonRef = (0, $eF4cA.useRef)(null);
    let { dropProps: dropProps, dropButtonProps: dropButtonProps, isDropTarget: isDropTarget } = (0, $OwH9B.useDrop)({
        ...props,
        ref: buttonRef,
        hasDropButton: true
    });
    let { buttonProps: buttonProps } = (0, $fipJz.useButton)(dropButtonProps || {}, buttonRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)(props);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($9f265f20d6cb4e1b$var$$parcel$interopDefault((0, $hJVXE.default)), 'react-aria-components');
    let textId = (0, $25dFS.useSlotId)();
    let ariaLabel = props['aria-label'] || stringFormatter.format('dropzoneLabel');
    let messageId = props['aria-labelledby'];
    let ariaLabelledby = [
        textId,
        messageId
    ].filter(Boolean).join(' ');
    let labelProps = (0, $dkaC0.useLabels)({
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    let { clipboardProps: clipboardProps } = (0, $8PVB5.useClipboard)({
        isDisabled: isDisabled,
        onPaste: (items)=>props.onDrop?.({
                type: 'drop',
                items: items,
                x: 0,
                y: 0,
                dropOperation: 'copy'
            })
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDropTarget: isDropTarget,
            isDisabled: isDisabled
        },
        defaultClassName: 'react-aria-DropZone'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $c1ibQ.TextContext),
                {
                    id: textId,
                    slot: 'label'
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, dropProps, hoverProps),
        slot: props.slot || undefined,
        ref: dropzoneRef,
        onClick: (e)=>{
            let target = (0, $fvyIQ.getEventTarget)(e);
            while(target && (0, $fvyIQ.nodeContains)(dropzoneRef.current, target)){
                if ((0, $3OYqT.isFocusable)(target)) break;
                else if (target === dropzoneRef.current && buttonRef.current) {
                    (0, $2jk5s.focusWithoutScrolling)(buttonRef.current);
                    break;
                }
                target = target.parentElement;
            }
        },
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-drop-target": isDropTarget || undefined,
        "data-disabled": isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("button", {
        ...(0, $lhKAD.mergeProps)(buttonProps, focusProps, clipboardProps, labelProps),
        ref: buttonRef
    })), renderProps.children));
});

});
parcelRegister("hJVXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1abd521c9bf9427$export$2e2bcd8739ae039);

var $lHeLV = parcelRequire("lHeLV");

var $dg4eT = parcelRequire("dg4eT");

var $2CFvh = parcelRequire("2CFvh");

var $btKbY = parcelRequire("btKbY");

var $9DtLf = parcelRequire("9DtLf");

var $79gID = parcelRequire("79gID");

var $VJDd9 = parcelRequire("VJDd9");

var $iJSAb = parcelRequire("iJSAb");

var $f3A8b = parcelRequire("f3A8b");

var $24R7R = parcelRequire("24R7R");

var $hTIC8 = parcelRequire("hTIC8");

var $li8bz = parcelRequire("li8bz");

var $3n4NV = parcelRequire("3n4NV");

var $2cLLb = parcelRequire("2cLLb");

var $gS3Ih = parcelRequire("gS3Ih");

var $iSkNw = parcelRequire("iSkNw");

var $aHoc5 = parcelRequire("aHoc5");

var $40RAA = parcelRequire("40RAA");

var $7fmQ8 = parcelRequire("7fmQ8");

var $iCBwR = parcelRequire("iCBwR");

var $SfLZr = parcelRequire("SfLZr");

var $6ZBfC = parcelRequire("6ZBfC");

var $keL1J = parcelRequire("keL1J");

var $2ENAQ = parcelRequire("2ENAQ");

var $jQ1Al = parcelRequire("jQ1Al");

var $5DQMp = parcelRequire("5DQMp");

var $1K7Pb = parcelRequire("1K7Pb");

var $gXKuF = parcelRequire("gXKuF");

var $aF2Vk = parcelRequire("aF2Vk");

var $aK36Y = parcelRequire("aK36Y");

var $hfiKy = parcelRequire("hfiKy");

var $2yxr9 = parcelRequire("2yxr9");

var $eoSho = parcelRequire("eoSho");

var $764me = parcelRequire("764me");
var $d1abd521c9bf9427$export$2e2bcd8739ae039 = {};
$d1abd521c9bf9427$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $lHeLV.default),
    "bg-BG": (0, $dg4eT.default),
    "cs-CZ": (0, $2CFvh.default),
    "da-DK": (0, $btKbY.default),
    "de-DE": (0, $9DtLf.default),
    "el-GR": (0, $79gID.default),
    "en-US": (0, $VJDd9.default),
    "es-ES": (0, $iJSAb.default),
    "et-EE": (0, $f3A8b.default),
    "fi-FI": (0, $24R7R.default),
    "fr-FR": (0, $hTIC8.default),
    "he-IL": (0, $li8bz.default),
    "hr-HR": (0, $3n4NV.default),
    "hu-HU": (0, $2cLLb.default),
    "it-IT": (0, $gS3Ih.default),
    "ja-JP": (0, $iSkNw.default),
    "ko-KR": (0, $aHoc5.default),
    "lt-LT": (0, $40RAA.default),
    "lv-LV": (0, $7fmQ8.default),
    "nb-NO": (0, $iCBwR.default),
    "nl-NL": (0, $SfLZr.default),
    "pl-PL": (0, $6ZBfC.default),
    "pt-BR": (0, $keL1J.default),
    "pt-PT": (0, $2ENAQ.default),
    "ro-RO": (0, $jQ1Al.default),
    "ru-RU": (0, $5DQMp.default),
    "sk-SK": (0, $1K7Pb.default),
    "sl-SI": (0, $gXKuF.default),
    "sr-SP": (0, $aF2Vk.default),
    "sv-SE": (0, $aK36Y.default),
    "tr-TR": (0, $hfiKy.default),
    "uk-UA": (0, $2yxr9.default),
    "zh-CN": (0, $eoSho.default),
    "zh-TW": (0, $764me.default)
};

});
parcelRegister("lHeLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d30ee789164822$export$2e2bcd8739ae039);
var $24d30ee789164822$export$2e2bcd8739ae039 = {};
$24d30ee789164822$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{644}\u{648}\u{627}\u{646}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{62D}\u{62F}\u{62F} \u{639}\u{646}\u{635}\u{631}\u{64B}\u{627}`,
    "tableResizer": `\u{623}\u{62F}\u{627}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`
};

});

parcelRegister("dg4eT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bee87b4b525c0fb4$export$2e2bcd8739ae039);
var $bee87b4b525c0fb4$export$2e2bcd8739ae039 = {};
$bee87b4b525c0fb4$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{438} \u{43C}\u{43E}\u{441}\u{442}\u{440}\u{438}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}`,
    "tableResizer": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}`
};

});

parcelRegister("2CFvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9344f4a8a2bc37f4$export$2e2bcd8739ae039);
var $9344f4a8a2bc37f4$export$2e2bcd8739ae039 = {};
$9344f4a8a2bc37f4$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorky barev`,
    "dropzoneLabel": `M\xedsto pro p\u{159}eta\u{17E}en\xed`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `Zm\u{11B}na velikosti`
};

});

parcelRegister("btKbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2b41b514c136f4$export$2e2bcd8739ae039);
var $3e2b41b514c136f4$export$2e2bcd8739ae039 = {};
$3e2b41b514c136f4$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farvepr\xf8ver`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe6lg et element`,
    "tableResizer": `St\xf8rrelses\xe6ndring`
};

});

parcelRegister("9DtLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9481a12ff4de5c95$export$2e2bcd8739ae039);
var $9481a12ff4de5c95$export$2e2bcd8739ae039 = {};
$9481a12ff4de5c95$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farbfelder`,
    "dropzoneLabel": `Ablegebereich`,
    "selectPlaceholder": `Element w\xe4hlen`,
    "tableResizer": `Gr\xf6\xdfenanpassung`
};

});

parcelRegister("79gID", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a0ea8d3e16a1f8$export$2e2bcd8739ae039);
var $50a0ea8d3e16a1f8$export$2e2bcd8739ae039 = {};
$50a0ea8d3e16a1f8$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{3A7}\u{3C1}\u{3C9}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3AC} \u{3B4}\u{3B5}\u{3AF}\u{3B3}\u{3BC}\u{3B1}\u{3C4}\u{3B1}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3BE}\u{3C4}\u{3B5} \u{3AD}\u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B5}\u{3AF}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "tableResizer": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`
};

});

parcelRegister("VJDd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d0819abaa1093f$export$2e2bcd8739ae039);
var $84d0819abaa1093f$export$2e2bcd8739ae039 = {};
$84d0819abaa1093f$export$2e2bcd8739ae039 = {
    "selectPlaceholder": `Select an item`,
    "tableResizer": `Resizer`,
    "dropzoneLabel": `DropZone`,
    "colorSwatchPicker": `Color swatches`
};

});

parcelRegister("iJSAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $52df5274d90648e5$export$2e2bcd8739ae039);
var $52df5274d90648e5$export$2e2bcd8739ae039 = {};
$52df5274d90648e5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Muestras de colores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Seleccionar un art\xedculo`,
    "tableResizer": `Cambiador de tama\xf1o`
};

});

parcelRegister("f3A8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c95b3b4a0604c55$export$2e2bcd8739ae039);
var $5c95b3b4a0604c55$export$2e2bcd8739ae039 = {};
$5c95b3b4a0604c55$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rvin\xe4idised`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};

});

parcelRegister("24R7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $1afceb0a9967e921$export$2e2bcd8739ae039);
var $1afceb0a9967e921$export$2e2bcd8739ae039 = {};
$1afceb0a9967e921$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rimallit`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valitse kohde`,
    "tableResizer": `Koon muuttaja`
};

});

parcelRegister("hTIC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8110bcbce0dd23a$export$2e2bcd8739ae039);
var $e8110bcbce0dd23a$export$2e2bcd8739ae039 = {};
$e8110bcbce0dd23a$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\xc9chantillons de couleurs`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `S\xe9lectionner un \xe9l\xe9ment`,
    "tableResizer": `Redimensionneur`
};

});

parcelRegister("li8bz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e314bb8c4e91db8b$export$2e2bcd8739ae039);
var $e314bb8c4e91db8b$export$2e2bcd8739ae039 = {};
$e314bb8c4e91db8b$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{5D3}\u{5D5}\u{5D2}\u{5DE}\u{5D9}\u{5D5}\u{5EA} \u{5E6}\u{5D1}\u{5E2}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{5D1}\u{5D7}\u{5E8} \u{5E4}\u{5E8}\u{5D9}\u{5D8}`,
    "tableResizer": `\u{5E9}\u{5D9}\u{5E0}\u{5D5}\u{5D9} \u{5D2}\u{5D5}\u{5D3}\u{5DC}`
};

});

parcelRegister("3n4NV", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c622ad1fd7cfff$export$2e2bcd8739ae039);
var $49c622ad1fd7cfff$export$2e2bcd8739ae039 = {};
$49c622ad1fd7cfff$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boja`,
    "dropzoneLabel": `Zona spu\u{161}tanja`,
    "selectPlaceholder": `Odaberite stavku`,
    "tableResizer": `Promjena veli\u{10D}ine`
};

});

parcelRegister("2cLLb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6373754ed28a549$export$2e2bcd8739ae039);
var $b6373754ed28a549$export$2e2bcd8739ae039 = {};
$b6373754ed28a549$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Sz\xednt\xe1rak`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe1lasszon ki egy elemet`,
    "tableResizer": `\xc1tm\xe9retez\u{151}`
};

});

parcelRegister("gS3Ih", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c9b4086864efcc3$export$2e2bcd8739ae039);
var $3c9b4086864efcc3$export$2e2bcd8739ae039 = {};
$3c9b4086864efcc3$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Campioni di colore`,
    "dropzoneLabel": `Zona di rilascio`,
    "selectPlaceholder": `Seleziona un elemento`,
    "tableResizer": `Ridimensionamento`
};

});

parcelRegister("iSkNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3be92269e77fb2d$export$2e2bcd8739ae039);
var $a3be92269e77fb2d$export$2e2bcd8739ae039 = {};
$a3be92269e77fb2d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30B9}\u{30A6}\u{30A9}\u{30C3}\u{30C1}`,
    "dropzoneLabel": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BE}\u{30FC}\u{30F3}`,
    "selectPlaceholder": `\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}`,
    "tableResizer": `\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{30C4}\u{30FC}\u{30EB}`
};

});

parcelRegister("aHoc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e8d3f7cbe1238fa$export$2e2bcd8739ae039);
var $9e8d3f7cbe1238fa$export$2e2bcd8739ae039 = {};
$9e8d3f7cbe1238fa$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{C0C9}\u{C0C1} \u{ACAC}\u{BCF8}`,
    "dropzoneLabel": `\u{B4DC}\u{B86D} \u{C601}\u{C5ED}`,
    "selectPlaceholder": `\u{D56D}\u{BAA9} \u{C120}\u{D0DD}`,
    "tableResizer": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{AE30}`
};

});

parcelRegister("40RAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0722d8814c2b34d$export$2e2bcd8739ae039);
var $d0722d8814c2b34d$export$2e2bcd8739ae039 = {};
$d0722d8814c2b34d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Spalv\u{173} pavyzd\u{17E}iai`,
    "dropzoneLabel": `\u{201E}DropZone\u{201C}`,
    "selectPlaceholder": `Pasirinkite element\u{105}`,
    "tableResizer": `Dyd\u{17E}io keitiklis`
};

});

parcelRegister("7fmQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $211504db742946b6$export$2e2bcd8739ae039);
var $211504db742946b6$export$2e2bcd8739ae039 = {};
$211504db742946b6$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Kr\u{101}su paraugi`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izv\u{113}l\u{113}ties vienumu`,
    "tableResizer": `Izm\u{113}ra main\u{12B}t\u{101}js`
};

});

parcelRegister("iCBwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $df457ac3f5e84363$export$2e2bcd8739ae039);
var $df457ac3f5e84363$export$2e2bcd8739ae039 = {};
$df457ac3f5e84363$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Fargekart`,
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};

});

parcelRegister("SfLZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c97bc5e12cf7937e$export$2e2bcd8739ae039);
var $c97bc5e12cf7937e$export$2e2bcd8739ae039 = {};
$c97bc5e12cf7937e$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `kleurstalen`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`
};

});

parcelRegister("6ZBfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a95d0e066a1c3e7$export$2e2bcd8739ae039);
var $2a95d0e066a1c3e7$export$2e2bcd8739ae039 = {};
$2a95d0e066a1c3e7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Pr\xf3bki kolor\xf3w`,
    "dropzoneLabel": `Strefa upuszczania`,
    "selectPlaceholder": `Wybierz element`,
    "tableResizer": `Zmiana rozmiaru`
};

});

parcelRegister("keL1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b1e027170d69a6$export$2e2bcd8739ae039);
var $80b1e027170d69a6$export$2e2bcd8739ae039 = {};
$80b1e027170d69a6$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};

});

parcelRegister("2ENAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1cd321442bfc6b0$export$2e2bcd8739ae039);
var $b1cd321442bfc6b0$export$2e2bcd8739ae039 = {};
$b1cd321442bfc6b0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};

});

parcelRegister("jQ1Al", function(module, exports) {

$parcel$export(module.exports, "default", () => $6041e99412c20f78$export$2e2bcd8739ae039);
var $6041e99412c20f78$export$2e2bcd8739ae039 = {};
$6041e99412c20f78$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Specimene de culoare`,
    "dropzoneLabel": `Zon\u{103} de plasare`,
    "selectPlaceholder": `Selecta\u{21B}i un element`,
    "tableResizer": `Instrument de redimensionare`
};

});

parcelRegister("5DQMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6d430452343238$export$2e2bcd8739ae039);
var $1c6d430452343238$export$2e2bcd8739ae039 = {};
$1c6d430452343238$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{44B}\u{435} \u{43E}\u{431}\u{440}\u{430}\u{437}\u{446}\u{44B}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430}`
};

});

parcelRegister("1K7Pb", function(module, exports) {

$parcel$export(module.exports, "default", () => $335bc2b02cb70e46$export$2e2bcd8739ae039);
var $335bc2b02cb70e46$export$2e2bcd8739ae039 = {};
$335bc2b02cb70e46$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorkovn\xedky farieb`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `N\xe1stroj na zmenu ve\u{13E}kosti`
};

});

parcelRegister("gXKuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f09e31b1406965b0$export$2e2bcd8739ae039);
var $f09e31b1406965b0$export$2e2bcd8739ae039 = {};
$f09e31b1406965b0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Barvne palete`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izberite element`,
    "tableResizer": `Spreminjanje velikosti`
};

});

parcelRegister("aF2Vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5577581dc9ab1e0$export$2e2bcd8739ae039);
var $d5577581dc9ab1e0$export$2e2bcd8739ae039 = {};
$d5577581dc9ab1e0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boje`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`
};

});

parcelRegister("aK36Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e7d8ee61b932f8$export$2e2bcd8739ae039);
var $37e7d8ee61b932f8$export$2e2bcd8739ae039 = {};
$37e7d8ee61b932f8$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `F\xe4rgrutor`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};

});

parcelRegister("hfiKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4387b6285ca3cfb$export$2e2bcd8739ae039);
var $b4387b6285ca3cfb$export$2e2bcd8739ae039 = {};
$b4387b6285ca3cfb$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Renk \xf6rnekleri`,
    "dropzoneLabel": `B\u{131}rakma B\xf6lgesi`,
    "selectPlaceholder": `Bir \xf6\u{11F}e se\xe7in`,
    "tableResizer": `Yeniden boyutland\u{131}r\u{131}c\u{131}`
};

});

parcelRegister("2yxr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32162783e5a8342c$export$2e2bcd8739ae039);
var $32162783e5a8342c$export$2e2bcd8739ae039 = {};
$32162783e5a8342c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{417}\u{440}\u{430}\u{437}\u{43A}\u{438} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{417}\u{430}\u{441}\u{456}\u{431} \u{437}\u{43C}\u{456}\u{43D}\u{435}\u{43D}\u{43D}\u{44F} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`
};

});

parcelRegister("eoSho", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec9228e6f175c559$export$2e2bcd8739ae039);
var $ec9228e6f175c559$export$2e2bcd8739ae039 = {};
$ec9228e6f175c559$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{989C}\u{8272}\u{8272}\u{677F}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{533A}\u{57DF}`,
    "selectPlaceholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9879}\u{76EE}`,
    "tableResizer": `\u{5C3A}\u{5BF8}\u{8C03}\u{6574}\u{5668}`
};

});

parcelRegister("764me", function(module, exports) {

$parcel$export(module.exports, "default", () => $bada2640433bc58a$export$2e2bcd8739ae039);
var $bada2640433bc58a$export$2e2bcd8739ae039 = {};
$bada2640433bc58a$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{8272}\u{7968}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{5340}`,
    "selectPlaceholder": `\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "tableResizer": `\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`
};

});


parcelRegister("OwH9B", function(module, exports) {

$parcel$export(module.exports, "useDrop", () => $bac6c0dd5dda6400$export$ccdee5eaf73cf661);

var $grJ6Y = parcelRequire("grJ6Y");

var $kOxgB = parcelRequire("kOxgB");

var $gEvlw = parcelRequire("gEvlw");

var $fvyIQ = parcelRequire("fvyIQ");

var $11FxZ = parcelRequire("11FxZ");

var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $aOXCq = parcelRequire("aOXCq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$DROP_ACTIVATE_TIMEOUT = 800;
function $bac6c0dd5dda6400$export$ccdee5eaf73cf661(options) {
    let { hasDropButton: hasDropButton, isDisabled: isDisabled } = options;
    let [isDropTarget, setDropTarget] = (0, $eF4cA.useState)(false);
    let state = (0, $eF4cA.useRef)({
        x: 0,
        y: 0,
        dragOverElements: new Set(),
        dropEffect: 'none',
        allowedOperations: (0, $gEvlw.DROP_OPERATION).all,
        dropActivateTimer: undefined
    }).current;
    let fireDropEnter = (e)=>{
        setDropTarget(true);
        if (typeof options.onDropEnter === 'function') {
            let rect = e.currentTarget.getBoundingClientRect();
            options.onDropEnter({
                type: 'dropenter',
                x: e.clientX - rect.x,
                y: e.clientY - rect.y
            });
        }
    };
    let fireDropExit = (e)=>{
        setDropTarget(false);
        if (typeof options.onDropExit === 'function') {
            let rect = e.currentTarget.getBoundingClientRect();
            options.onDropExit({
                type: 'dropexit',
                x: e.clientX - rect.x,
                y: e.clientY - rect.y
            });
        }
    };
    let onDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        let allowedOperations = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getAllowedOperations(e);
        if (e.clientX === state.x && e.clientY === state.y && allowedOperations === state.allowedOperations) {
            e.dataTransfer.dropEffect = state.dropEffect;
            return;
        }
        state.x = e.clientX;
        state.y = e.clientY;
        let prevDropEffect = state.dropEffect;
        // Update drop effect if allowed drop operations changed (e.g. user pressed modifier key).
        if (allowedOperations !== state.allowedOperations) {
            let allowedOps = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$allowedOperationsToArray(allowedOperations);
            let dropOperation = allowedOps[0];
            if (typeof options.getDropOperation === 'function') {
                let types = new (0, $kOxgB.DragTypes)(e.dataTransfer);
                dropOperation = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getDropOperation(allowedOperations, options.getDropOperation(types, allowedOps));
            }
            state.dropEffect = (0, $gEvlw.DROP_OPERATION_TO_DROP_EFFECT)[dropOperation] || 'none';
        }
        if (typeof options.getDropOperationForPoint === 'function') {
            let types = new (0, $kOxgB.DragTypes)(e.dataTransfer);
            let rect = e.currentTarget.getBoundingClientRect();
            let dropOperation = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getDropOperation(allowedOperations, options.getDropOperationForPoint(types, $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$allowedOperationsToArray(allowedOperations), state.x - rect.x, state.y - rect.y));
            state.dropEffect = (0, $gEvlw.DROP_OPERATION_TO_DROP_EFFECT)[dropOperation] || 'none';
        }
        state.allowedOperations = allowedOperations;
        e.dataTransfer.dropEffect = state.dropEffect;
        // If the drop operation changes, update state and fire events appropriately.
        if (state.dropEffect === 'none' && prevDropEffect !== 'none') fireDropExit(e);
        else if (state.dropEffect !== 'none' && prevDropEffect === 'none') fireDropEnter(e);
        if (typeof options.onDropMove === 'function' && state.dropEffect !== 'none') {
            let rect = e.currentTarget.getBoundingClientRect();
            options.onDropMove({
                type: 'dropmove',
                x: state.x - rect.x,
                y: state.y - rect.y
            });
        }
        clearTimeout(state.dropActivateTimer);
        if (options.onDropActivate && typeof options.onDropActivate === 'function' && state.dropEffect !== 'none') {
            let onDropActivateOptions = options.onDropActivate;
            let rect = e.currentTarget.getBoundingClientRect();
            state.dropActivateTimer = setTimeout(()=>{
                onDropActivateOptions({
                    type: 'dropactivate',
                    x: state.x - rect.x,
                    y: state.y - rect.y
                });
            }, $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$DROP_ACTIVATE_TIMEOUT);
        }
    };
    let onDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        state.dragOverElements.add((0, $fvyIQ.getEventTarget)(e));
        if (state.dragOverElements.size > 1) return;
        let allowedOperationsBits = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getAllowedOperations(e);
        let allowedOperations = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$allowedOperationsToArray(allowedOperationsBits);
        let dropOperation = allowedOperations[0];
        if (typeof options.getDropOperation === 'function') {
            let types = new (0, $kOxgB.DragTypes)(e.dataTransfer);
            dropOperation = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getDropOperation(allowedOperationsBits, options.getDropOperation(types, allowedOperations));
        }
        if (typeof options.getDropOperationForPoint === 'function') {
            let types = new (0, $kOxgB.DragTypes)(e.dataTransfer);
            let rect = e.currentTarget.getBoundingClientRect();
            dropOperation = $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getDropOperation(allowedOperationsBits, options.getDropOperationForPoint(types, allowedOperations, e.clientX - rect.x, e.clientY - rect.y));
        }
        state.x = e.clientX;
        state.y = e.clientY;
        state.allowedOperations = allowedOperationsBits;
        state.dropEffect = (0, $gEvlw.DROP_OPERATION_TO_DROP_EFFECT)[dropOperation] || 'none';
        e.dataTransfer.dropEffect = state.dropEffect;
        if (dropOperation !== 'cancel') fireDropEnter(e);
    };
    let onDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        // We would use e.relatedTarget to detect if the drag is still inside the drop target,
        // but it is always null in WebKit. https://bugs.webkit.org/show_bug.cgi?id=66547
        // Instead, we track all of the targets of dragenter events in a set, and remove them
        // in dragleave. When the set becomes empty, we've left the drop target completely.
        // We must also remove any elements that are no longer in the DOM, because dragleave
        // events will never be fired for these. This can happen, for example, with drop
        // indicators between items, which disappear when the drop target changes.
        let target = (0, $fvyIQ.getEventTarget)(e);
        state.dragOverElements.delete(target);
        // Only remove stale elements when leaving the drop target itself.
        // Avoids issues with portal children bubbling dragleave events through the React tree.
        if (target === e.currentTarget) {
            for (let element of state.dragOverElements)if (!(0, $fvyIQ.nodeContains)(e.currentTarget, element)) state.dragOverElements.delete(element);
        }
        if (state.dragOverElements.size > 0) return;
        if (state.dropEffect !== 'none') fireDropExit(e);
        clearTimeout(state.dropActivateTimer);
    };
    let onDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        (0, $kOxgB.setGlobalDropEffect)(state.dropEffect);
        if (typeof options.onDrop === 'function') {
            let dropOperation = (0, $gEvlw.DROP_EFFECT_TO_DROP_OPERATION)[state.dropEffect];
            let items = (0, $kOxgB.readFromDataTransfer)(e.dataTransfer);
            let rect = e.currentTarget.getBoundingClientRect();
            let event = {
                type: 'drop',
                x: e.clientX - rect.x,
                y: e.clientY - rect.y,
                items: items,
                dropOperation: dropOperation
            };
            options.onDrop(event);
        }
        let dndStateSnapshot = {
            ...(0, $kOxgB.globalDndState)
        };
        state.dragOverElements.clear();
        fireDropExit(e);
        clearTimeout(state.dropActivateTimer);
        // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
        // RSP collection and thus we don't need to preserve the global drop effect
        if (dndStateSnapshot.draggingCollectionRef == null) (0, $kOxgB.setGlobalDropEffect)(undefined);
        else (0, $kOxgB.setGlobalDnDState)(dndStateSnapshot);
    };
    let onDropEnter = (0, $4lMDe.useEffectEvent)((e)=>{
        if (typeof options.onDropEnter === 'function') options.onDropEnter(e);
    });
    let onDropExit = (0, $4lMDe.useEffectEvent)((e)=>{
        if (typeof options.onDropExit === 'function') options.onDropExit(e);
    });
    let onDropActivate = (0, $4lMDe.useEffectEvent)((e)=>{
        if (typeof options.onDropActivate === 'function') options.onDropActivate(e);
    });
    let onKeyboardDrop = (0, $4lMDe.useEffectEvent)((e)=>{
        if (typeof options.onDrop === 'function') options.onDrop(e);
    });
    let getDropOperationKeyboard = (0, $4lMDe.useEffectEvent)((types, allowedOperations)=>{
        if (options.getDropOperation) return options.getDropOperation(types, allowedOperations);
        return allowedOperations[0];
    });
    let { ref: ref } = options;
    (0, $4skXn.useLayoutEffect)(()=>{
        if (isDisabled || !ref.current) return;
        return (0, $grJ6Y.registerDropTarget)({
            element: ref.current,
            getDropOperation: getDropOperationKeyboard,
            onDropEnter (e) {
                setDropTarget(true);
                onDropEnter(e);
            },
            onDropExit (e) {
                setDropTarget(false);
                onDropExit(e);
            },
            onDrop: onKeyboardDrop,
            onDropActivate: onDropActivate
        });
    }, [
        isDisabled,
        ref
    ]);
    let { dropProps: dropProps } = (0, $aOXCq.useVirtualDrop)();
    if (isDisabled) return {
        dropProps: {},
        dropButtonProps: {
            isDisabled: true
        },
        isDropTarget: false
    };
    return {
        dropProps: {
            ...!hasDropButton && dropProps,
            onDragEnter: onDragEnter,
            onDragOver: onDragOver,
            onDragLeave: onDragLeave,
            onDrop: onDrop
        },
        dropButtonProps: {
            ...hasDropButton && dropProps
        },
        isDropTarget: isDropTarget
    };
}
function $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getAllowedOperations(e) {
    let allowedOperations = (0, $gEvlw.DROP_OPERATION_ALLOWED)[e.dataTransfer.effectAllowed];
    // WebKit always sets effectAllowed to "copyMove" on macOS, and "all" on iOS, regardless of what was
    // set during the dragstart event: https://bugs.webkit.org/show_bug.cgi?id=178058
    //
    // Android Chrome also sets effectAllowed to "copyMove" in all cases: https://bugs.chromium.org/p/chromium/issues/detail?id=1359182
    //
    // If the drag started within the page, we can use a global variable to get the real allowed operations.
    // This needs to be intersected with the actual effectAllowed, which may have been filtered based on modifier keys.
    // Unfortunately, this means that link operations do not work at all in Safari.
    if (0, $kOxgB.globalAllowedDropOperations) allowedOperations &= (0, $kOxgB.globalAllowedDropOperations);
    // Chrome and Safari on macOS will automatically filter effectAllowed when pressing modifier keys,
    // allowing the user to switch between move, link, and copy operations. Firefox on macOS and all
    // Windows browsers do not do this, so do it ourselves instead. The exact keys are platform dependent.
    // https://ux.stackexchange.com/questions/83748/what-are-the-most-common-modifier-keys-for-dragging-objects-with-a-mouse
    //
    // Note that none of these modifiers are ever set in WebKit due to a bug: https://bugs.webkit.org/show_bug.cgi?id=77465
    // However, Safari does update effectAllowed correctly, so we can just rely on that.
    let allowedModifiers = (0, $gEvlw.DROP_OPERATION).none;
    if ((0, $11FxZ.isMac)()) {
        if (e.altKey) allowedModifiers |= (0, $gEvlw.DROP_OPERATION).copy;
        // Chrome and Safari both use the Control key for link, even though Finder uses Command + Option.
        // iPadOS doesn't support link operations and will not fire the drop event at all if dropEffect is set to link.
        // https://bugs.webkit.org/show_bug.cgi?id=244701
        if (e.ctrlKey && !(0, $11FxZ.isIPad)()) allowedModifiers |= (0, $gEvlw.DROP_OPERATION).link;
        if (e.metaKey) allowedModifiers |= (0, $gEvlw.DROP_OPERATION).move;
    } else {
        if (e.altKey) allowedModifiers |= (0, $gEvlw.DROP_OPERATION).link;
        if (e.shiftKey) allowedModifiers |= (0, $gEvlw.DROP_OPERATION).move;
        if (e.ctrlKey) allowedModifiers |= (0, $gEvlw.DROP_OPERATION).copy;
    }
    if (allowedModifiers) return allowedOperations & allowedModifiers;
    return allowedOperations;
}
function $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$allowedOperationsToArray(allowedOperationsBits) {
    let allowedOperations = [];
    if (allowedOperationsBits & (0, $gEvlw.DROP_OPERATION).move) allowedOperations.push('move');
    if (allowedOperationsBits & (0, $gEvlw.DROP_OPERATION).copy) allowedOperations.push('copy');
    if (allowedOperationsBits & (0, $gEvlw.DROP_OPERATION).link) allowedOperations.push('link');
    return allowedOperations;
}
function $bac6c0dd5dda6400$var$$f302ef02e940a6f8$var$getDropOperation(allowedOperations, operation) {
    let op = (0, $gEvlw.DROP_OPERATION)[operation];
    return allowedOperations & op ? operation : 'cancel';
}

});
parcelRegister("grJ6Y", function(module, exports) {

$parcel$export(module.exports, "registerDropTarget", () => $25caa20a0015005c$export$c28d9fb4a54e471a);
$parcel$export(module.exports, "registerDropItem", () => $25caa20a0015005c$export$aef80212ac99c003);
$parcel$export(module.exports, "beginDragging", () => $25caa20a0015005c$export$549dbcf8649bf3b2);
$parcel$export(module.exports, "useDragSession", () => $25caa20a0015005c$export$418e185dd3f1b968);
$parcel$export(module.exports, "isVirtualDragging", () => $25caa20a0015005c$export$403bc76cbf68cf60);

var $4HiHF = parcelRequire("4HiHF");

var $7eFu7 = parcelRequire("7eFu7");

var $fvyIQ = parcelRequire("fvyIQ");

var $kOxgB = parcelRequire("kOxgB");

var $9J8wU = parcelRequire("9J8wU");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropTargets = new Map();
let $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropItems = new Map();
let $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession = null;
let $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$subscriptions = new Set();
function $25caa20a0015005c$export$c28d9fb4a54e471a(target) {
    $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropTargets.set(target.element, target);
    $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession?.updateValidDropTargets();
    return ()=>{
        $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropTargets.delete(target.element);
        $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession?.updateValidDropTargets();
    };
}
function $25caa20a0015005c$export$aef80212ac99c003(item) {
    $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropItems.set(item.element, item);
    return ()=>{
        $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropItems.delete(item.element);
    };
}
function $25caa20a0015005c$export$549dbcf8649bf3b2(target, stringFormatter) {
    if ($25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession) throw new Error('Cannot begin dragging while already dragging');
    $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession = new $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$DragSession(target, stringFormatter);
    requestAnimationFrame(()=>{
        if ($25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession) {
            $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession.setup();
            if ((0, $kOxgB.getDragModality)() === 'keyboard') $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession.next();
        }
    });
    for (let cb of $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$subscriptions)cb();
}
function $25caa20a0015005c$export$418e185dd3f1b968() {
    let [session, setSession] = (0, $eF4cA.useState)($25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession);
    (0, $eF4cA.useEffect)(()=>{
        let cb = ()=>setSession($25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession);
        $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$subscriptions.add(cb);
        return ()=>{
            $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$subscriptions.delete(cb);
        };
    }, []);
    return session;
}
function $25caa20a0015005c$export$403bc76cbf68cf60() {
    return !!$25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession;
}
function $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$endDragging() {
    $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dragSession = null;
    for (let cb of $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$subscriptions)cb();
}
function $25caa20a0015005c$export$7454aff2e161f241(element) {
    for (let target of $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropTargets.keys()){
        if ((0, $fvyIQ.nodeContains)(target, element)) return true;
    }
    return false;
}
const $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$CANCELED_EVENTS = [
    'pointerdown',
    'pointermove',
    'pointerenter',
    'pointerleave',
    'pointerover',
    'pointerout',
    'pointerup',
    'mousedown',
    'mousemove',
    'mouseenter',
    'mouseleave',
    'mouseover',
    'mouseout',
    'mouseup',
    'touchstart',
    'touchmove',
    'touchend',
    'focusin',
    'focusout'
];
const $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$CLICK_EVENTS = [
    'pointerup',
    'mouseup',
    'touchend'
];
const $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$MESSAGES = {
    keyboard: 'dragStartedKeyboard',
    touch: 'dragStartedTouch',
    virtual: 'dragStartedVirtual'
};
class $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$DragSession {
    constructor(target, stringFormatter){
        this.validDropTargets = [];
        this.currentDropTarget = null;
        this.currentDropItem = null;
        this.dropOperation = null;
        this.mutationObserver = null;
        this.restoreAriaHidden = null;
        this.isVirtualClick = false;
        this.dragTarget = target;
        this.stringFormatter = stringFormatter;
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.cancelEvent = this.cancelEvent.bind(this);
        this.initialFocused = false;
    }
    setup() {
        document.addEventListener('keydown', this.onKeyDown, true);
        document.addEventListener('keyup', this.onKeyUp, true);
        window.addEventListener('focus', this.onFocus, true);
        window.addEventListener('blur', this.onBlur, true);
        document.addEventListener('click', this.onClick, true);
        document.addEventListener('pointerdown', this.onPointerDown, true);
        for (let event of $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$CANCELED_EVENTS)document.addEventListener(event, this.cancelEvent, true);
        this.mutationObserver = new MutationObserver(()=>this.updateValidDropTargets());
        this.updateValidDropTargets();
        (0, $4HiHF.announce)(this.stringFormatter.format($25caa20a0015005c$var$$99f1ee31a7e95d0e$var$MESSAGES[(0, $kOxgB.getDragModality)()]));
    }
    teardown() {
        document.removeEventListener('keydown', this.onKeyDown, true);
        document.removeEventListener('keyup', this.onKeyUp, true);
        window.removeEventListener('focus', this.onFocus, true);
        window.removeEventListener('blur', this.onBlur, true);
        document.removeEventListener('click', this.onClick, true);
        document.removeEventListener('pointerdown', this.onPointerDown, true);
        for (let event of $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$CANCELED_EVENTS)document.removeEventListener(event, this.cancelEvent, true);
        this.mutationObserver?.disconnect();
        this.restoreAriaHidden?.();
    }
    onKeyDown(e) {
        this.cancelEvent(e);
        if (e.key === 'Escape') {
            this.cancel();
            return;
        }
        if (e.key === 'Tab' && !(e.metaKey || e.altKey || e.ctrlKey)) {
            if (e.shiftKey) this.previous();
            else this.next();
        }
        if (typeof this.currentDropTarget?.onKeyDown === 'function') this.currentDropTarget.onKeyDown(e, this.dragTarget);
    }
    onKeyUp(e) {
        this.cancelEvent(e);
        if (e.key === 'Enter') {
            if (e.altKey || (0, $fvyIQ.nodeContains)(this.getCurrentActivateButton(), (0, $fvyIQ.getEventTarget)(e))) this.activate(this.currentDropTarget, this.currentDropItem);
            else this.drop();
        }
    }
    getCurrentActivateButton() {
        return this.currentDropItem?.activateButtonRef?.current ?? this.currentDropTarget?.activateButtonRef?.current ?? null;
    }
    onFocus(e) {
        let activateButton = this.getCurrentActivateButton();
        let eventTarget = (0, $fvyIQ.getEventTarget)(e);
        if (eventTarget === activateButton) {
            // TODO: canceling this breaks the focus ring. Revisit when we support tabbing.
            this.cancelEvent(e);
            return;
        }
        // Prevent focus events, except to the original drag target.
        if (eventTarget !== this.dragTarget.element) this.cancelEvent(e);
        // Ignore focus events on the window/document (JSDOM). Will be handled in onBlur, below.
        if (!(eventTarget instanceof HTMLElement) || eventTarget === this.dragTarget.element) return;
        let dropTarget = this.validDropTargets.find((target)=>target.element === eventTarget) || this.validDropTargets.find((target)=>(0, $fvyIQ.nodeContains)(target.element, eventTarget));
        if (!dropTarget) {
            // if (e.target === activateButton) {
            //   activateButton.focus();
            // }
            if (this.currentDropTarget) this.currentDropTarget.element.focus();
            else this.dragTarget.element.focus();
            return;
        }
        let item = $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropItems.get(eventTarget);
        if (dropTarget) this.setCurrentDropTarget(dropTarget, item);
    }
    onBlur(e) {
        let activateButton = this.getCurrentActivateButton();
        // Guard activateButton non-null so this doesn't trip on the case where
        // there's no activate button and the focused element loses focus to nothing
        // (browsers and jsdom 26+ both set relatedTarget to null in that case).
        if (activateButton && e.relatedTarget === activateButton) {
            this.cancelEvent(e);
            return;
        }
        if ((0, $fvyIQ.getEventTarget)(e) !== this.dragTarget.element) this.cancelEvent(e);
        // If nothing is gaining focus, or e.relatedTarget is the window/document (JSDOM),
        // restore focus back to the current drop target if any, or the original drag target.
        if (!e.relatedTarget || !(e.relatedTarget instanceof HTMLElement)) {
            if (this.currentDropTarget) this.currentDropTarget.element.focus();
            else this.dragTarget.element.focus();
        }
    }
    onClick(e) {
        this.cancelEvent(e);
        if ((0, $9J8wU.isVirtualClick)(e) || this.isVirtualClick) {
            let dropElements = $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropItems.values();
            let eventTarget = (0, $fvyIQ.getEventTarget)(e);
            let item = [
                ...dropElements
            ].find((item)=>item.element === eventTarget || (0, $fvyIQ.nodeContains)(item.activateButtonRef?.current, eventTarget));
            let dropTarget = this.validDropTargets.find((target)=>(0, $fvyIQ.nodeContains)(target.element, eventTarget));
            let activateButton = item?.activateButtonRef?.current ?? dropTarget?.activateButtonRef?.current;
            if ((0, $fvyIQ.nodeContains)(activateButton, eventTarget) && dropTarget) {
                this.activate(dropTarget, item);
                return;
            }
            if ((0, $fvyIQ.getEventTarget)(e) === this.dragTarget.element) {
                this.cancel();
                return;
            }
            if (dropTarget) {
                this.setCurrentDropTarget(dropTarget, item);
                this.drop(item);
            }
        }
    }
    onPointerDown(e) {
        // Android Talkback double tap has e.detail = 1 for onClick. Detect the virtual click in onPointerDown before onClick fires
        // so we can properly perform cancel and drop operations.
        this.cancelEvent(e);
        this.isVirtualClick = (0, $9J8wU.isVirtualPointerEvent)(e);
    }
    cancelEvent(e) {
        // Allow focusin and focusout on the drag target so focus ring works properly.
        let eventTarget = (0, $fvyIQ.getEventTarget)(e);
        if ((e.type === 'focusin' || e.type === 'focusout') && (eventTarget === this.dragTarget?.element || eventTarget === this.getCurrentActivateButton())) return;
        // Allow default for events that might cancel a click event
        if (!$25caa20a0015005c$var$$99f1ee31a7e95d0e$var$CLICK_EVENTS.includes(e.type)) e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
    updateValidDropTargets() {
        if (!this.mutationObserver) return;
        this.mutationObserver.disconnect();
        if (this.restoreAriaHidden) this.restoreAriaHidden();
        this.validDropTargets = $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$findValidDropTargets(this.dragTarget);
        // Shuffle drop target order based on starting drag target.
        if (this.validDropTargets.length > 0) {
            let nearestIndex = this.findNearestDropTarget();
            this.validDropTargets = [
                ...this.validDropTargets.slice(nearestIndex),
                ...this.validDropTargets.slice(0, nearestIndex)
            ];
        }
        if (this.currentDropTarget && !this.validDropTargets.includes(this.currentDropTarget)) this.setCurrentDropTarget(this.validDropTargets[0]);
        // Find valid drop items within collections
        let types = (0, $kOxgB.getTypes)(this.dragTarget.items);
        let validDropItems = [
            ...$25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropItems.values()
        ].filter((item)=>{
            if (typeof item.getDropOperation === 'function') return item.getDropOperation(types, this.dragTarget.allowedDropOperations) !== 'cancel';
            return true;
        });
        // Filter out drop targets that contain valid items. We don't want to stop hiding elements
        // other than the drop items that exist inside the collection.
        let visibleDropTargets = this.validDropTargets.filter((target)=>!validDropItems.some((item)=>(0, $fvyIQ.nodeContains)(target.element, item.element)));
        this.restoreAriaHidden = (0, $7eFu7.ariaHideOutside)([
            this.dragTarget.element,
            ...validDropItems.flatMap((item)=>item.activateButtonRef?.current ? [
                    item.element,
                    item.activateButtonRef?.current
                ] : [
                    item.element
                ]),
            ...visibleDropTargets.flatMap((target)=>target.activateButtonRef?.current ? [
                    target.element,
                    target.activateButtonRef?.current
                ] : [
                    target.element
                ])
        ], {
            shouldUseInert: true
        });
        this.mutationObserver.observe(document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: [
                'aria-hidden',
                'inert'
            ]
        });
    }
    next() {
        // TODO: Allow tabbing to the activate button. Revisit once we fix the focus ring.
        // For now, the activate button is reachable by screen readers and ArrowLeft/ArrowRight
        // is usable specifically by Tree. Will need tabbing for other components.
        // let activateButton = this.getCurrentActivateButton();
        // if (activateButton && document.activeElement !== activateButton) {
        //   activateButton.focus();
        //   return;
        // }
        if (!this.currentDropTarget) {
            this.setCurrentDropTarget(this.validDropTargets[0]);
            return;
        }
        let index = this.validDropTargets.indexOf(this.currentDropTarget);
        if (index < 0) {
            this.setCurrentDropTarget(this.validDropTargets[0]);
            return;
        }
        // If we've reached the end of the valid drop targets, cycle back to the original drag target.
        // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
        if (index === this.validDropTargets.length - 1) {
            if (!this.dragTarget.element.closest('[aria-hidden="true"], [inert]')) {
                this.setCurrentDropTarget(null);
                this.dragTarget.element.focus();
            } else this.setCurrentDropTarget(this.validDropTargets[0]);
        } else this.setCurrentDropTarget(this.validDropTargets[index + 1]);
    }
    previous() {
        // let activateButton = this.getCurrentActivateButton();
        // if (activateButton && document.activeElement === activateButton) {
        //   let target = this.currentDropItem ?? this.currentDropTarget;
        //   if (target) {
        //     target.element.focus();
        //     return;
        //   }
        // }
        if (!this.currentDropTarget) {
            this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
            return;
        }
        let index = this.validDropTargets.indexOf(this.currentDropTarget);
        if (index < 0) {
            this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
            return;
        }
        // If we've reached the start of the valid drop targets, cycle back to the original drag target.
        // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
        if (index === 0) {
            if (!this.dragTarget.element.closest('[aria-hidden="true"], [inert]')) {
                this.setCurrentDropTarget(null);
                this.dragTarget.element.focus();
            } else this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
        } else this.setCurrentDropTarget(this.validDropTargets[index - 1]);
    }
    findNearestDropTarget() {
        let dragTargetRect = this.dragTarget.element.getBoundingClientRect();
        let minDistance = Infinity;
        let nearest = -1;
        let ancestor = -1;
        for(let i = 0; i < this.validDropTargets.length; i++){
            let dropTarget = this.validDropTargets[i];
            if (ancestor < 0 && (0, $fvyIQ.nodeContains)(dropTarget.element, this.dragTarget.element)) ancestor = i;
            let rect = dropTarget.element.getBoundingClientRect();
            let dx = rect.left - dragTargetRect.left;
            let dy = rect.top - dragTargetRect.top;
            let dist = dx * dx + dy * dy;
            if (dist < minDistance) {
                minDistance = dist;
                nearest = i;
            }
        }
        return ancestor >= 0 ? ancestor : nearest;
    }
    setCurrentDropTarget(dropTarget, item) {
        if (dropTarget !== this.currentDropTarget) {
            if (this.currentDropTarget && typeof this.currentDropTarget.onDropExit === 'function') {
                let rect = this.currentDropTarget.element.getBoundingClientRect();
                this.currentDropTarget.onDropExit({
                    type: 'dropexit',
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2
                });
            }
            this.currentDropTarget = dropTarget;
            if (dropTarget) {
                if (typeof dropTarget.onDropEnter === 'function') {
                    let rect = dropTarget.element.getBoundingClientRect();
                    dropTarget.onDropEnter({
                        type: 'dropenter',
                        x: rect.left + rect.width / 2,
                        y: rect.top + rect.height / 2
                    }, this.dragTarget);
                }
                if (!item) dropTarget?.element.focus();
            }
        }
        if (item != null && item !== this.currentDropItem) {
            if (this.currentDropTarget && typeof this.currentDropTarget.onDropTargetEnter === 'function') this.currentDropTarget.onDropTargetEnter(item.target);
            item.element.focus();
            this.currentDropItem = item;
            // Announce first drop target after drag start announcement finishes.
            // Otherwise, it will never get announced because drag start announcement is assertive.
            if (!this.initialFocused) {
                let label = item?.element.getAttribute('aria-label');
                if (label) (0, $4HiHF.announce)(label, 'polite');
                this.initialFocused = true;
            }
        }
    }
    end() {
        this.teardown();
        $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$endDragging();
        if (typeof this.dragTarget.onDragEnd === 'function') {
            let target = this.currentDropTarget && this.dropOperation !== 'cancel' ? this.currentDropTarget : this.dragTarget;
            let rect = target.element.getBoundingClientRect();
            this.dragTarget.onDragEnd({
                type: 'dragend',
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2,
                dropOperation: this.dropOperation || 'cancel'
            });
        }
        if (this.currentDropTarget && !this.currentDropTarget.preventFocusOnDrop) (0, $fvyIQ.getActiveElement)()?.dispatchEvent(new FocusEvent('focusin', {
            bubbles: true
        }));
        this.setCurrentDropTarget(null);
    }
    cancel() {
        this.setCurrentDropTarget(null);
        this.end();
        if (!this.dragTarget.element.closest('[aria-hidden="true"], [inert]')) this.dragTarget.element.focus();
        (0, $fvyIQ.getActiveElement)()?.dispatchEvent(new FocusEvent('focusin', {
            bubbles: true
        }));
        (0, $4HiHF.announce)(this.stringFormatter.format('dropCanceled'));
    }
    drop(item) {
        if (!this.currentDropTarget) {
            this.cancel();
            return;
        }
        if (typeof item?.getDropOperation === 'function') {
            let types = (0, $kOxgB.getTypes)(this.dragTarget.items);
            this.dropOperation = item.getDropOperation(types, this.dragTarget.allowedDropOperations);
        } else if (typeof this.currentDropTarget.getDropOperation === 'function') {
            let types = (0, $kOxgB.getTypes)(this.dragTarget.items);
            this.dropOperation = this.currentDropTarget.getDropOperation(types, this.dragTarget.allowedDropOperations);
        } else this.dropOperation = this.dragTarget.allowedDropOperations[0];
        if (typeof this.currentDropTarget.onDrop === 'function') {
            let items = this.dragTarget.items.map((item)=>({
                    kind: 'text',
                    types: new Set(Object.keys(item)),
                    getText: (type)=>Promise.resolve(item[type])
                }));
            let rect = this.currentDropTarget.element.getBoundingClientRect();
            this.currentDropTarget.onDrop({
                type: 'drop',
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2,
                items: items,
                dropOperation: this.dropOperation
            }, item?.target ?? null);
        }
        this.end();
        (0, $4HiHF.announce)(this.stringFormatter.format('dropComplete'));
    }
    activate(dropTarget, dropItem) {
        if (dropTarget && typeof dropTarget.onDropActivate === 'function') {
            let target = dropItem?.target ?? null;
            let rect = dropTarget.element.getBoundingClientRect();
            dropTarget.onDropActivate({
                type: 'dropactivate',
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2
            }, target);
        }
    }
}
function $25caa20a0015005c$var$$99f1ee31a7e95d0e$var$findValidDropTargets(options) {
    let types = (0, $kOxgB.getTypes)(options.items);
    return [
        ...$25caa20a0015005c$var$$99f1ee31a7e95d0e$var$dropTargets.values()
    ].filter((target)=>{
        if (target.element.closest('[aria-hidden="true"], [inert]')) return false;
        if (typeof target.getDropOperation === 'function') return target.getDropOperation(types, options.allowedDropOperations) !== 'cancel';
        return true;
    });
}

});
parcelRegister("kOxgB", function(module, exports) {

$parcel$export(module.exports, "droppableCollectionMap", () => $fc9ae4c3a8473322$export$dfdf5deeaf27473f);
$parcel$export(module.exports, "DIRECTORY_DRAG_TYPE", () => $fc9ae4c3a8473322$export$990fced5dfac2637);
$parcel$export(module.exports, "getDroppableCollectionId", () => $fc9ae4c3a8473322$export$3093291712f09a77);
$parcel$export(module.exports, "getDroppableCollectionRef", () => $fc9ae4c3a8473322$export$7e397efd01d3db27);
$parcel$export(module.exports, "getTypes", () => $fc9ae4c3a8473322$export$e1d41611756c6326);
$parcel$export(module.exports, "useDragModality", () => $fc9ae4c3a8473322$export$49bac5d6d4b352ea);
$parcel$export(module.exports, "getDragModality", () => $fc9ae4c3a8473322$export$1fb2158d224b542c);
$parcel$export(module.exports, "writeToDataTransfer", () => $fc9ae4c3a8473322$export$f9c1490890ddd063);
$parcel$export(module.exports, "DragTypes", () => $fc9ae4c3a8473322$export$7f04ce188c91447c);
$parcel$export(module.exports, "readFromDataTransfer", () => $fc9ae4c3a8473322$export$d9e760437831f8b3);
$parcel$export(module.exports, "globalDndState", () => $fc9ae4c3a8473322$export$6ca6700462636d0b);
$parcel$export(module.exports, "setDraggingCollectionRef", () => $fc9ae4c3a8473322$export$f2be18a910c0caa6);
$parcel$export(module.exports, "setDraggingKeys", () => $fc9ae4c3a8473322$export$72cb63bdda528276);
$parcel$export(module.exports, "setDropCollectionRef", () => $fc9ae4c3a8473322$export$dac8db29d42db9a1);
$parcel$export(module.exports, "clearGlobalDnDState", () => $fc9ae4c3a8473322$export$70936501603e6c57);
$parcel$export(module.exports, "setGlobalDnDState", () => $fc9ae4c3a8473322$export$6c10d32b362bfa5f);
$parcel$export(module.exports, "isInternalDropOperation", () => $fc9ae4c3a8473322$export$78bf638634500fa5);
$parcel$export(module.exports, "globalDropEffect", () => $fc9ae4c3a8473322$export$8e6636520ac15722);
$parcel$export(module.exports, "setGlobalDropEffect", () => $fc9ae4c3a8473322$export$64f52ed7349ddb84);
$parcel$export(module.exports, "globalAllowedDropOperations", () => $fc9ae4c3a8473322$export$f0130eb70b6347b8);
$parcel$export(module.exports, "setGlobalAllowedDropOperations", () => $fc9ae4c3a8473322$export$6539bc8c3a0a2d67);

var $gEvlw = parcelRequire("gEvlw");

var $YxOvP = parcelRequire("YxOvP");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fc9ae4c3a8473322$export$dfdf5deeaf27473f = new WeakMap();
const $fc9ae4c3a8473322$export$990fced5dfac2637 = Symbol();
function $fc9ae4c3a8473322$export$3093291712f09a77(state) {
    let { id: id } = $fc9ae4c3a8473322$export$dfdf5deeaf27473f.get(state) || {};
    if (!id) throw new Error('Droppable item outside a droppable collection');
    return id;
}
function $fc9ae4c3a8473322$export$7e397efd01d3db27(state) {
    let { ref: ref } = $fc9ae4c3a8473322$export$dfdf5deeaf27473f.get(state) || {};
    if (!ref) throw new Error('Droppable item outside a droppable collection');
    return ref;
}
function $fc9ae4c3a8473322$export$e1d41611756c6326(items) {
    let types = new Set();
    for (let item of items)for (let type of Object.keys(item))types.add(type);
    return types;
}
function $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$mapModality(modality) {
    if (!modality) modality = 'virtual';
    if (modality === 'pointer') modality = 'virtual';
    if (modality === 'virtual' && typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches) modality = 'touch';
    return modality;
}
function $fc9ae4c3a8473322$export$49bac5d6d4b352ea() {
    return $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$mapModality((0, $YxOvP.useInteractionModality)());
}
function $fc9ae4c3a8473322$export$1fb2158d224b542c() {
    return $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$mapModality((0, $YxOvP.getInteractionModality)());
}
function $fc9ae4c3a8473322$export$f9c1490890ddd063(dataTransfer, items) {
    // The data transfer API doesn't support more than one item of a given type at once.
    // In addition, only a small set of types are supported natively for transfer between applications.
    // We allow for both multiple items, as well as multiple representations of a single item.
    // In order to make our API work with the native API, we serialize all items to JSON and
    // store as a single native item. We only need to do this if there is more than one item
    // of the same type, or if an item has more than one representation. Otherwise the native
    // API is sufficient.
    //
    // The DataTransferItemList API also theoretically supports adding files, which would enable
    // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
    // this does not currently work in any browser, so it is not currently supported by our API.
    // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
    let groupedByType = new Map();
    let needsCustomData = false;
    let customData = [];
    for (let item of items){
        let types = Object.keys(item);
        if (types.length > 1) needsCustomData = true;
        let dataByType = {};
        for (let type of types){
            let typeItems = groupedByType.get(type);
            if (!typeItems) {
                typeItems = [];
                groupedByType.set(type, typeItems);
            } else needsCustomData = true;
            let data = item[type];
            dataByType[type] = data;
            typeItems.push(data);
        }
        customData.push(dataByType);
    }
    for (let [type, items] of groupedByType)if ((0, $gEvlw.NATIVE_DRAG_TYPES).has(type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        let data = items.join('\n');
        dataTransfer.items.add(data, type);
    } else dataTransfer.items.add(items[0], type);
    if (needsCustomData) {
        let data = JSON.stringify(customData);
        dataTransfer.items.add(data, (0, $gEvlw.CUSTOM_DRAG_TYPE));
    }
}
class $fc9ae4c3a8473322$export$7f04ce188c91447c {
    constructor(dataTransfer){
        this.types = new Set();
        let hasFiles = false;
        for (let item of dataTransfer.items)if (item.type !== (0, $gEvlw.CUSTOM_DRAG_TYPE)) {
            if (item.kind === 'file') hasFiles = true;
            if (item.type) this.types.add(item.type);
            else // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, $gEvlw.GENERIC_TYPE));
        }
        // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
        // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
        // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
        this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes('Files');
    }
    has(type) {
        if (Array.isArray(type)) return type.some((t)=>this.has(t));
        if (this.includesUnknownTypes || type === $fc9ae4c3a8473322$export$990fced5dfac2637 && this.types.has((0, $gEvlw.GENERIC_TYPE)) || type === '*/*') return true;
        if (typeof type === 'string') {
            if (type.endsWith('/*')) {
                for (let key of this.types){
                    if (key.startsWith(type.slice(0, -2))) return true;
                }
                return false;
            }
            return this.types.has(type);
        }
        return false;
    }
}
function $fc9ae4c3a8473322$export$d9e760437831f8b3(dataTransfer) {
    let items = [];
    if (!dataTransfer) return items;
    // If our custom drag type is available, use that. This is a JSON serialized
    // representation of all items in the drag, set when there are multiple items
    // of the same type, or an individual item has multiple representations.
    let hasCustomType = false;
    if (dataTransfer.types.includes((0, $gEvlw.CUSTOM_DRAG_TYPE))) try {
        let data = dataTransfer.getData((0, $gEvlw.CUSTOM_DRAG_TYPE));
        let parsed = JSON.parse(data);
        for (let item of parsed)items.push({
            kind: 'text',
            types: new Set(Object.keys(item)),
            getText: (type)=>Promise.resolve(item[type])
        });
        hasCustomType = true;
    } catch  {
    // ignore
    }
    // Otherwise, map native drag items to items of a single representation.
    if (!hasCustomType) {
        let stringItems = new Map();
        for (let item of dataTransfer.items){
            if (item.kind === 'string') // cleared out after the event handler finishes. If the item has an empty string
            // as a type, the mime type is unknown. Map to a generic mime type instead.
            stringItems.set(item.type || (0, $gEvlw.GENERIC_TYPE), dataTransfer.getData(item.type));
            else if (item.kind === 'file') {
                // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
                // In the future, we may use getAsFileSystemHandle instead, but that's currently
                // only implemented in Chrome.
                if (typeof item.webkitGetAsEntry === 'function') {
                    let entry = item.webkitGetAsEntry();
                    // eslint-disable-next-line max-depth
                    if (!entry) continue;
                    // eslint-disable-next-line max-depth
                    if (entry.isFile) items.push($fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createFileItem(item.getAsFile()));
                    else if (entry.isDirectory) items.push($fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createDirectoryItem(entry));
                } else items.push($fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createFileItem(item.getAsFile()));
            }
        }
        // All string items are different representations of the same item. There's no way to have
        // multiple string items at once in the current DataTransfer API.
        if (stringItems.size > 0) items.push({
            kind: 'text',
            types: new Set(stringItems.keys()),
            getText: (type)=>Promise.resolve(stringItems.get(type))
        });
    }
    return items;
}
function $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$blobToString(blob) {
    if (typeof blob.text === 'function') return blob.text();
    // Safari doesn't have the Blob#text() method yet...
    return new Promise((resolve, reject)=>{
        let reader = new FileReader();
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}
function $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createFileItem(file) {
    if (!file) throw new Error('No file provided');
    return {
        kind: 'file',
        type: file.type || (0, $gEvlw.GENERIC_TYPE),
        name: file.name,
        getText: ()=>$fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$blobToString(file),
        getFile: ()=>Promise.resolve(file)
    };
}
function $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createDirectoryItem(entry) {
    return {
        kind: 'directory',
        name: entry.name,
        getEntries: ()=>$fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$getEntries(entry)
    };
}
async function* $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$getEntries(item) {
    let reader = item.createReader();
    // We must call readEntries repeatedly because there may be a limit to the
    // number of entries that are returned at once.
    let entries;
    do {
        entries = await new Promise((resolve, reject)=>{
            reader.readEntries(resolve, reject);
        });
        for (let entry of entries){
            if (entry.isFile) {
                let file = await $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$getEntryFile(entry);
                yield $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createFileItem(file);
            } else if (entry.isDirectory) yield $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$createDirectoryItem(entry);
        }
    }while (entries.length > 0);
}
function $fc9ae4c3a8473322$var$$d40e85a29b831dd6$var$getEntryFile(entry) {
    return new Promise((resolve, reject)=>entry.file(resolve, reject));
}
function $fc9ae4c3a8473322$export$97fd558bdc44bea1(dropItem) {
    return dropItem.kind === 'text';
}
function $fc9ae4c3a8473322$export$a144e1752ebe0aa(dropItem) {
    return dropItem.kind === 'file';
}
function $fc9ae4c3a8473322$export$2b40a62bdbe6b2b0(dropItem) {
    return dropItem.kind === 'directory';
}
let $fc9ae4c3a8473322$export$6ca6700462636d0b = {
    draggingKeys: new Set()
};
function $fc9ae4c3a8473322$export$f2be18a910c0caa6(ref) {
    $fc9ae4c3a8473322$export$6ca6700462636d0b.draggingCollectionRef = ref;
}
function $fc9ae4c3a8473322$export$72cb63bdda528276(keys) {
    $fc9ae4c3a8473322$export$6ca6700462636d0b.draggingKeys = keys;
}
function $fc9ae4c3a8473322$export$dac8db29d42db9a1(ref) {
    $fc9ae4c3a8473322$export$6ca6700462636d0b.dropCollectionRef = ref;
}
function $fc9ae4c3a8473322$export$70936501603e6c57() {
    $fc9ae4c3a8473322$export$6ca6700462636d0b = {
        draggingKeys: new Set()
    };
}
function $fc9ae4c3a8473322$export$6c10d32b362bfa5f(state) {
    $fc9ae4c3a8473322$export$6ca6700462636d0b = state;
}
function $fc9ae4c3a8473322$export$78bf638634500fa5(ref) {
    let { draggingCollectionRef: draggingCollectionRef, dropCollectionRef: dropCollectionRef } = $fc9ae4c3a8473322$export$6ca6700462636d0b;
    return draggingCollectionRef?.current != null && draggingCollectionRef.current === (ref?.current || dropCollectionRef?.current);
}
let $fc9ae4c3a8473322$export$8e6636520ac15722;
function $fc9ae4c3a8473322$export$64f52ed7349ddb84(dropEffect) {
    $fc9ae4c3a8473322$export$8e6636520ac15722 = dropEffect;
}
let $fc9ae4c3a8473322$export$f0130eb70b6347b8 = (0, $gEvlw.DROP_OPERATION).none;
function $fc9ae4c3a8473322$export$6539bc8c3a0a2d67(o) {
    $fc9ae4c3a8473322$export$f0130eb70b6347b8 = o;
}

});
parcelRegister("gEvlw", function(module, exports) {

$parcel$export(module.exports, "DROP_OPERATION", () => $627b1873c0a0dd51$export$60b7b4bcf3903d8e);
$parcel$export(module.exports, "DROP_OPERATION_ALLOWED", () => $627b1873c0a0dd51$export$9bbdfc78cf083e16);
$parcel$export(module.exports, "EFFECT_ALLOWED", () => $627b1873c0a0dd51$export$dd0165308d8bff45);
$parcel$export(module.exports, "DROP_EFFECT_TO_DROP_OPERATION", () => $627b1873c0a0dd51$export$608ecc6f1b23c35d);
$parcel$export(module.exports, "DROP_OPERATION_TO_DROP_EFFECT", () => $627b1873c0a0dd51$export$5eacb0769d26d3b2);
$parcel$export(module.exports, "NATIVE_DRAG_TYPES", () => $627b1873c0a0dd51$export$4a7729b856e9a690);
$parcel$export(module.exports, "CUSTOM_DRAG_TYPE", () => $627b1873c0a0dd51$export$fd9f9fc120c5402d);
$parcel$export(module.exports, "GENERIC_TYPE", () => $627b1873c0a0dd51$export$f8fc6581787339b3);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $627b1873c0a0dd51$export$60b7b4bcf3903d8e = /*#__PURE__*/ function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
    return DROP_OPERATION;
}({});
const $627b1873c0a0dd51$export$9bbdfc78cf083e16 = {
    ...$627b1873c0a0dd51$export$60b7b4bcf3903d8e,
    copyMove: 3,
    copyLink: 6,
    linkMove: 5,
    all: 7,
    uninitialized: 7
};
const $627b1873c0a0dd51$export$dd0165308d8bff45 = $627b1873c0a0dd51$var$$2991e2e71ca29774$var$invert($627b1873c0a0dd51$export$9bbdfc78cf083e16);
$627b1873c0a0dd51$export$dd0165308d8bff45[7] = 'all'; // ensure we don't map to 'uninitialized'.
const $627b1873c0a0dd51$export$608ecc6f1b23c35d = {
    none: 'cancel',
    link: 'link',
    copy: 'copy',
    move: 'move'
};
const $627b1873c0a0dd51$export$5eacb0769d26d3b2 = $627b1873c0a0dd51$var$$2991e2e71ca29774$var$invert($627b1873c0a0dd51$export$608ecc6f1b23c35d);
function $627b1873c0a0dd51$var$$2991e2e71ca29774$var$invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
const $627b1873c0a0dd51$export$4a7729b856e9a690 = new Set([
    'text/plain',
    'text/uri-list',
    'text/html'
]);
const $627b1873c0a0dd51$export$fd9f9fc120c5402d = 'application/vnd.react-aria.items+json';
const $627b1873c0a0dd51$export$f8fc6581787339b3 = 'application/octet-stream';

});



parcelRegister("aOXCq", function(module, exports) {

$parcel$export(module.exports, "useVirtualDrop", () => $6bcd9c353aea0179$export$62447ad3d2ec7da6);

var $grJ6Y = parcelRequire("grJ6Y");

var $4Dyny = parcelRequire("4Dyny");

var $lXRQr = parcelRequire("lXRQr");

var $kOxgB = parcelRequire("kOxgB");

var $gI8Gw = parcelRequire("gI8Gw");
function $6bcd9c353aea0179$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6bcd9c353aea0179$var$$8659ad8e5ae1862d$var$MESSAGES = {
    keyboard: 'dropDescriptionKeyboard',
    touch: 'dropDescriptionTouch',
    virtual: 'dropDescriptionVirtual'
};
function $6bcd9c353aea0179$export$62447ad3d2ec7da6() {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($6bcd9c353aea0179$var$$parcel$interopDefault((0, $4Dyny.default)), '@react-aria/dnd');
    let modality = (0, $kOxgB.useDragModality)();
    let dragSession = (0, $grJ6Y.useDragSession)();
    let descriptionProps = (0, $lXRQr.useDescription)(dragSession ? stringFormatter.format($6bcd9c353aea0179$var$$8659ad8e5ae1862d$var$MESSAGES[modality]) : '');
    return {
        dropProps: {
            ...descriptionProps,
            // Mobile Safari does not properly bubble click events on elements except links or inputs
            // unless there is an onclick handler bound directly to the element itself. By adding this
            // handler, React will take care of adding that for us, and we are able to handle document
            // level click events in the DragManager.
            // See https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
            onClick: ()=>{}
        }
    };
}

});
parcelRegister("4Dyny", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b25d8b79683937$export$2e2bcd8739ae039);

var $3kU8Q = parcelRequire("3kU8Q");

var $g3g5o = parcelRequire("g3g5o");

var $7ATyj = parcelRequire("7ATyj");

var $lKxoR = parcelRequire("lKxoR");

var $gMH8v = parcelRequire("gMH8v");

var $goszu = parcelRequire("goszu");

var $7bKd8 = parcelRequire("7bKd8");

var $jA2YH = parcelRequire("jA2YH");

var $6jm6e = parcelRequire("6jm6e");

var $lUYyv = parcelRequire("lUYyv");

var $cJNt6 = parcelRequire("cJNt6");

var $dsZIb = parcelRequire("dsZIb");

var $d5QT3 = parcelRequire("d5QT3");

var $2xJM8 = parcelRequire("2xJM8");

var $eNi6n = parcelRequire("eNi6n");

var $7d7QK = parcelRequire("7d7QK");

var $cbxAB = parcelRequire("cbxAB");

var $35B0h = parcelRequire("35B0h");

var $5rmQI = parcelRequire("5rmQI");

var $9a9xi = parcelRequire("9a9xi");

var $nohQW = parcelRequire("nohQW");

var $iroxh = parcelRequire("iroxh");

var $ipUFM = parcelRequire("ipUFM");

var $dMzUn = parcelRequire("dMzUn");

var $fhq8V = parcelRequire("fhq8V");

var $iEvQg = parcelRequire("iEvQg");

var $7g1Dd = parcelRequire("7g1Dd");

var $jOkrJ = parcelRequire("jOkrJ");

var $cgapE = parcelRequire("cgapE");

var $bhfJv = parcelRequire("bhfJv");

var $fEiwB = parcelRequire("fEiwB");

var $215fn = parcelRequire("215fn");

var $fp4xe = parcelRequire("fp4xe");

var $4qLTy = parcelRequire("4qLTy");
var $97b25d8b79683937$export$2e2bcd8739ae039 = {};
$97b25d8b79683937$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $3kU8Q.default),
    "bg-BG": (0, $g3g5o.default),
    "cs-CZ": (0, $7ATyj.default),
    "da-DK": (0, $lKxoR.default),
    "de-DE": (0, $gMH8v.default),
    "el-GR": (0, $goszu.default),
    "en-US": (0, $7bKd8.default),
    "es-ES": (0, $jA2YH.default),
    "et-EE": (0, $6jm6e.default),
    "fi-FI": (0, $lUYyv.default),
    "fr-FR": (0, $cJNt6.default),
    "he-IL": (0, $dsZIb.default),
    "hr-HR": (0, $d5QT3.default),
    "hu-HU": (0, $2xJM8.default),
    "it-IT": (0, $eNi6n.default),
    "ja-JP": (0, $7d7QK.default),
    "ko-KR": (0, $cbxAB.default),
    "lt-LT": (0, $35B0h.default),
    "lv-LV": (0, $5rmQI.default),
    "nb-NO": (0, $9a9xi.default),
    "nl-NL": (0, $nohQW.default),
    "pl-PL": (0, $iroxh.default),
    "pt-BR": (0, $ipUFM.default),
    "pt-PT": (0, $dMzUn.default),
    "ro-RO": (0, $fhq8V.default),
    "ru-RU": (0, $iEvQg.default),
    "sk-SK": (0, $7g1Dd.default),
    "sl-SI": (0, $jOkrJ.default),
    "sr-SP": (0, $cgapE.default),
    "sv-SE": (0, $bhfJv.default),
    "tr-TR": (0, $fEiwB.default),
    "uk-UA": (0, $215fn.default),
    "zh-CN": (0, $fp4xe.default),
    "zh-TW": (0, $4qLTy.default)
};

});
parcelRegister("3kU8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8efb701a3859882$export$2e2bcd8739ae039);
var $f8efb701a3859882$export$2e2bcd8739ae039 = {};
$f8efb701a3859882$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionKeyboardAlt": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + Enter \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionLongPress": `\u{627}\u{636}\u{63A}\u{637} \u{628}\u{627}\u{633}\u{62A}\u{645}\u{631}\u{627}\u{631} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionTouch": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragDescriptionVirtual": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dragItem": (args)=>`\u{627}\u{633}\u{62D}\u{628} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{627}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{627}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}\u{629}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Enter \u{644}\u{644}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
            other: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D}\u{64A} Alt + Enter \u{644}\u{644}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
            other: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{627}\u{636}\u{63A}\u{637} \u{628}\u{627}\u{633}\u{62A}\u{645}\u{631}\u{627}\u{631} \u{644}\u{644}\u{633}\u{62D}\u{628} ${formatter.plural(args.count, {
            one: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
            other: `\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`
        })}.`,
    "dragStartedKeyboard": `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{636}\u{63A}\u{637} Tab \u{644}\u{644}\u{627}\u{646}\u{62A}\u{642}\u{627}\u{644} \u{625}\u{644}\u{649} \u{645}\u{648}\u{636}\u{639} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{62B}\u{645} \u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} Escape \u{644}\u{644}\u{625}\u{644}\u{63A}\u{627}\u{621}.`,
    "dragStartedTouch": `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{645}\u{648}\u{636}\u{639} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{62B}\u{645} \u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dragStartedVirtual": `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{645}\u{643}\u{627}\u{646} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{62B}\u{645} \u{627}\u{646}\u{642}\u{631} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropCanceled": `\u{62A}\u{645} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropComplete": `\u{627}\u{643}\u{62A}\u{645}\u{644} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropDescriptionKeyboard": `\u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}. \u{627}\u{636}\u{63A}\u{637} Escape \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "dropDescriptionTouch": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropDescriptionVirtual": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}.`,
    "dropIndicator": `\u{645}\u{624}\u{634}\u{631} \u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}`,
    "dropOnItem": (args)=>`\u{625}\u{641}\u{644}\u{627}\u{62A} ${args.itemText}`,
    "dropOnRoot": `\u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}`,
    "endDragKeyboard": `\u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{636}\u{63A}\u{637} Enter \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "endDragTouch": `\u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{636}\u{63A}\u{637} \u{645}\u{631}\u{62A}\u{64A}\u{646} \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "endDragVirtual": `\u{627}\u{644}\u{633}\u{62D}\u{628}. \u{627}\u{646}\u{642}\u{631} \u{644}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{633}\u{62D}\u{628}.`,
    "insertAfter": (args)=>`\u{623}\u{62F}\u{62E}\u{644} \u{628}\u{639}\u{62F} ${args.itemText}`,
    "insertBefore": (args)=>`\u{623}\u{62F}\u{62E}\u{644} \u{642}\u{628}\u{644} ${args.itemText}`,
    "insertBetween": (args)=>`\u{623}\u{62F}\u{62E}\u{644} \u{628}\u{64A}\u{646} ${args.beforeItemText} \u{648} ${args.afterItemText}`
};

});

parcelRegister("g3g5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1915cc19fcb15ecd$export$2e2bcd8739ae039);
var $1915cc19fcb15ecd$export$2e2bcd8739ae039 = {};
$1915cc19fcb15ecd$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionKeyboardAlt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt + Enter, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionLongPress": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragDescriptionVirtual": `\u{429}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{442}\u{435}.`,
    "dragItem": (args)=>`\u{41F}\u{43B}\u{44A}\u{437}\u{43D}\u{438} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{41F}\u{43B}\u{44A}\u{437}\u{43D}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Enter, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt \u{438} Enter, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{43D}\u{435}\u{442}\u{435} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "dragStartedKeyboard": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Tab\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{441}\u{435} \u{43F}\u{440}\u{438}\u{434}\u{432}\u{438}\u{436}\u{438}\u{442}\u{435} \u{434}\u{43E} \u{446}\u{435}\u{43B}\u{442}\u{430}, \u{441}\u{43B}\u{435}\u{434} \u{43A}\u{43E}\u{435}\u{442}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Escape\u{201C} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430}.`,
    "dragStartedTouch": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41F}\u{440}\u{438}\u{434}\u{432}\u{438}\u{436}\u{435}\u{442}\u{435} \u{441}\u{435} \u{434}\u{43E} \u{446}\u{435}\u{43B}\u{442}\u{430}, \u{441}\u{43B}\u{435}\u{434} \u{43A}\u{43E}\u{435}\u{442}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{443}\u{441}\u{43D}\u{435}\u{442}\u{435}.`,
    "dragStartedVirtual": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41F}\u{440}\u{438}\u{434}\u{432}\u{438}\u{436}\u{435}\u{442}\u{435} \u{441}\u{435} \u{434}\u{43E} \u{446}\u{435}\u{43B}\u{442}\u{430}, \u{441}\u{43B}\u{435}\u{434} \u{43A}\u{43E}\u{435}\u{442}\u{43E} \u{449}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}.`,
    "dropCanceled": `\u{41F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}\u{442}\u{43E} \u{435} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43E}.`,
    "dropComplete": `\u{41F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}\u{442}\u{43E} \u{435} \u{437}\u{430}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    "dropDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Escape\u{201C} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430} \u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}\u{442}\u{43E}.`,
    "dropDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}.`,
    "dropDescriptionVirtual": `\u{429}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}.`,
    "dropIndicator": `\u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{437}\u{430} \u{43F}\u{443}\u{441}\u{43A}\u{430}\u{43D}\u{435}`,
    "dropOnItem": (args)=>`\u{41F}\u{443}\u{441}\u{43D}\u{438} \u{432}\u{44A}\u{440}\u{445}\u{443} ${args.itemText}`,
    "dropOnRoot": `\u{41F}\u{443}\u{441}\u{43D}\u{438} \u{432}\u{44A}\u{440}\u{445}\u{443}`,
    "endDragKeyboard": `\u{41F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430} \u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}\u{442}\u{43E}.`,
    "endDragTouch": `\u{41F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{432}\u{443}\u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430} \u{43D}\u{430} \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}\u{442}\u{43E}.`,
    "endDragVirtual": `\u{41F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{43D}\u{435}. \u{429}\u{440}\u{430}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43E}\u{442}\u{43C}\u{44F}\u{43D}\u{430}.`,
    "insertAfter": (args)=>`\u{412}\u{43C}\u{44A}\u{43A}\u{43D}\u{438} \u{441}\u{43B}\u{435}\u{434} ${args.itemText}`,
    "insertBefore": (args)=>`\u{412}\u{43C}\u{44A}\u{43A}\u{43D}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{438} ${args.itemText}`,
    "insertBetween": (args)=>`\u{412}\u{43C}\u{44A}\u{43A}\u{43D}\u{438} \u{43C}\u{435}\u{436}\u{434}\u{443} ${args.beforeItemText} \u{438} ${args.afterItemText}`
};

});

parcelRegister("7ATyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958e38f4a9657f8$export$2e2bcd8739ae039);
var $a958e38f4a9657f8$export$2e2bcd8739ae039 = {};
$a958e38f4a9657f8$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Stisknut\xedm kl\xe1vesy Enter za\u{10D}nete s p\u{159}etahov\xe1n\xedm.`,
    "dragDescriptionKeyboardAlt": `Stisknut\xedm Alt + Enter zah\xe1j\xedte p\u{159}etahov\xe1n\xed.`,
    "dragDescriptionLongPress": `Dlouh\xfdm stisknut\xedm zah\xe1j\xedte p\u{159}etahov\xe1n\xed.`,
    "dragDescriptionTouch": `Poklep\xe1n\xedm za\u{10D}nete s p\u{159}etahov\xe1n\xedm.`,
    "dragDescriptionVirtual": `Kliknut\xedm za\u{10D}nete s p\u{159}etahov\xe1n\xedm.`,
    "dragItem": (args)=>`P\u{159}et\xe1hnout ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`P\u{159}et\xe1hnout ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            few: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`,
            other: ()=>`${formatter.number(args.count)} vybran\xfdch polo\u{17E}ek`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Stisknut\xedm kl\xe1vesy Enter p\u{159}et\xe1hn\u{11B}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Stisknut\xedm Alt + Enter p\u{159}et\xe1hn\u{11B}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Dlouh\xfdm stisknut\xedm p\u{159}et\xe1hnete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybranou polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybran\xe9 polo\u{17E}ky`
        })}.`,
    "dragStartedKeyboard": `Za\u{10D}n\u{11B}te s p\u{159}etahov\xe1n\xedm. Po stisknut\xed kl\xe1vesy Tab najd\u{11B}te po\u{17E}adovan\xfd c\xedl a stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed dokon\u{10D}ete nebo stisknut\xedm kl\xe1vesy Esc akci zru\u{161}te.`,
    "dragStartedTouch": `Za\u{10D}n\u{11B}te s p\u{159}etahov\xe1n\xedm. Najd\u{11B}te po\u{17E}adovan\xfd c\xedl a poklep\xe1n\xedm p\u{159}eta\u{17E}en\xed dokon\u{10D}ete.`,
    "dragStartedVirtual": `Za\u{10D}n\u{11B}te s p\u{159}etahov\xe1n\xedm. Najd\u{11B}te po\u{17E}adovan\xfd c\xedl a kliknut\xedm nebo stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed dokon\u{10D}ete.`,
    "dropCanceled": `P\u{159}eta\u{17E}en\xed bylo zru\u{161}eno.`,
    "dropComplete": `P\u{159}eta\u{17E}en\xed bylo dokon\u{10D}eno.`,
    "dropDescriptionKeyboard": `Stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed dokon\u{10D}ete nebo stisknut\xedm kl\xe1vesy Esc akci zru\u{161}te.`,
    "dropDescriptionTouch": `Poklep\xe1n\xedm p\u{159}eta\u{17E}en\xed dokon\u{10D}ete.`,
    "dropDescriptionVirtual": `Kliknut\xedm objekt p\u{159}et\xe1hn\u{11B}te.`,
    "dropIndicator": `indik\xe1tor p\u{159}eta\u{17E}en\xed`,
    "dropOnItem": (args)=>`P\u{159}et\xe1hnout na ${args.itemText}`,
    "dropOnRoot": `P\u{159}et\xe1hnout na`,
    "endDragKeyboard": `Prob\xedh\xe1 p\u{159}etahov\xe1n\xed. Stisknut\xedm kl\xe1vesy Enter p\u{159}eta\u{17E}en\xed zru\u{161}\xedte.`,
    "endDragTouch": `Prob\xedh\xe1 p\u{159}etahov\xe1n\xed. Poklep\xe1n\xedm p\u{159}eta\u{17E}en\xed zru\u{161}\xedte.`,
    "endDragVirtual": `Prob\xedh\xe1 p\u{159}etahov\xe1n\xed. Kliknut\xedm p\u{159}eta\u{17E}en\xed zru\u{161}\xedte.`,
    "insertAfter": (args)=>`Vlo\u{17E}it za ${args.itemText}`,
    "insertBefore": (args)=>`Vlo\u{17E}it p\u{159}ed ${args.itemText}`,
    "insertBetween": (args)=>`Vlo\u{17E}it mezi ${args.beforeItemText} a ${args.afterItemText}`
};

});

parcelRegister("lKxoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcecb229f13c4ed4$export$2e2bcd8739ae039);
var $bcecb229f13c4ed4$export$2e2bcd8739ae039 = {};
$bcecb229f13c4ed4$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Tryk p\xe5 Enter for at starte med at tr\xe6kke.`,
    "dragDescriptionKeyboardAlt": `Tryk p\xe5 Alt + Enter for at starte med at tr\xe6kke.`,
    "dragDescriptionLongPress": `Tryk l\xe6nge for at starte med at tr\xe6kke.`,
    "dragDescriptionTouch": `Dobbelttryk for at starte med at tr\xe6kke.`,
    "dragDescriptionVirtual": `Klik for at starte med at tr\xe6kke.`,
    "dragItem": (args)=>`Tr\xe6k ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Tr\xe6k ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Tryk p\xe5 Enter for at tr\xe6kke ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgte element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Tryk p\xe5 Alt + Enter for at tr\xe6kke ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgte element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Tryk l\xe6nge for at tr\xe6kke ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgte element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragStartedKeyboard": `Startet med at tr\xe6kke. Tryk p\xe5 Tab for at g\xe5 til et slip-m\xe5l, tryk derefter p\xe5 Enter for at slippe, eller tryk p\xe5 Escape for at annullere.`,
    "dragStartedTouch": `Startet med at tr\xe6kke. G\xe5 til et slip-m\xe5l, og dobbelttryk derefter for at slippe.`,
    "dragStartedVirtual": `Startet med at tr\xe6kke. G\xe5 til et slip-m\xe5l, og klik eller tryk derefter p\xe5 enter for at slippe.`,
    "dropCanceled": `Slip annulleret.`,
    "dropComplete": `Slip fuldf\xf8rt.`,
    "dropDescriptionKeyboard": `Tryk p\xe5 Enter for at slippe. Tryk p\xe5 Escape for at annullere tr\xe6kning.`,
    "dropDescriptionTouch": `Dobbelttryk for at slippe.`,
    "dropDescriptionVirtual": `Klik for at slippe.`,
    "dropIndicator": `slip-indikator`,
    "dropOnItem": (args)=>`Slip p\xe5 ${args.itemText}`,
    "dropOnRoot": `Slip p\xe5`,
    "endDragKeyboard": `Tr\xe6kning. Tryk p\xe5 enter for at annullere tr\xe6k.`,
    "endDragTouch": `Tr\xe6kning. Dobbelttryk for at annullere tr\xe6k.`,
    "endDragVirtual": `Tr\xe6kning. Klik for at annullere tr\xe6kning.`,
    "insertAfter": (args)=>`Inds\xe6t efter ${args.itemText}`,
    "insertBefore": (args)=>`Inds\xe6t f\xf8r ${args.itemText}`,
    "insertBetween": (args)=>`Inds\xe6t mellem ${args.beforeItemText} og ${args.afterItemText}`
};

});

parcelRegister("gMH8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d6910348d475c1$export$2e2bcd8739ae039);
var $c8d6910348d475c1$export$2e2bcd8739ae039 = {};
$c8d6910348d475c1$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Dr\xfccken Sie die Eingabetaste, um den Ziehvorgang zu starten.`,
    "dragDescriptionKeyboardAlt": `Alt + Eingabe dr\xfccken, um den Ziehvorgang zu starten.`,
    "dragDescriptionLongPress": `Lang dr\xfccken, um mit dem Ziehen zu beginnen.`,
    "dragDescriptionTouch": `Tippen Sie doppelt, um den Ziehvorgang zu starten.`,
    "dragDescriptionVirtual": `Zum Starten des Ziehvorgangs klicken.`,
    "dragItem": (args)=>`${args.itemText} ziehen`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Objekt`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Objekte`
        })} ziehen`,
    "dragSelectedKeyboard": (args, formatter)=>`Eingabetaste dr\xfccken, um ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Element`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Elemente`
        })} zu ziehen.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Alt + Eingabetaste dr\xfccken, um ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Element`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Elemente`
        })} zu ziehen.`,
    "dragSelectedLongPress": (args, formatter)=>`Lang dr\xfccken, um ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} ausgew\xe4hltes Element`,
            other: ()=>`${formatter.number(args.count)} ausgew\xe4hlte Elemente`
        })} zu ziehen.`,
    "dragStartedKeyboard": `Ziehvorgang gestartet. Dr\xfccken Sie die Tabulatortaste, um zu einem Ablegeziel zu navigieren und dr\xfccken Sie dann die Eingabetaste, um das Objekt abzulegen, oder Escape, um den Vorgang abzubrechen.`,
    "dragStartedTouch": `Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und tippen Sie doppelt, um das Objekt abzulegen.`,
    "dragStartedVirtual": `Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und klicken Sie oder dr\xfccken Sie die Eingabetaste, um das Objekt abzulegen.`,
    "dropCanceled": `Ablegen abgebrochen.`,
    "dropComplete": `Ablegen abgeschlossen.`,
    "dropDescriptionKeyboard": `Dr\xfccken Sie die Eingabetaste, um das Objekt abzulegen. Dr\xfccken Sie Escape, um den Vorgang abzubrechen.`,
    "dropDescriptionTouch": `Tippen Sie doppelt, um das Objekt abzulegen.`,
    "dropDescriptionVirtual": `Zum Ablegen klicken.`,
    "dropIndicator": `Ablegeanzeiger`,
    "dropOnItem": (args)=>`Auf ${args.itemText} ablegen`,
    "dropOnRoot": `Ablegen auf`,
    "endDragKeyboard": `Ziehvorgang l\xe4uft. Dr\xfccken Sie die Eingabetaste, um den Vorgang abzubrechen.`,
    "endDragTouch": `Ziehvorgang l\xe4uft. Tippen Sie doppelt, um den Vorgang abzubrechen.`,
    "endDragVirtual": `Ziehvorgang l\xe4uft. Klicken Sie, um den Vorgang abzubrechen.`,
    "insertAfter": (args)=>`Nach ${args.itemText} einf\xfcgen`,
    "insertBefore": (args)=>`Vor ${args.itemText} einf\xfcgen`,
    "insertBetween": (args)=>`Zwischen ${args.beforeItemText} und ${args.afterItemText} einf\xfcgen`
};

});

parcelRegister("goszu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7060fbbf163b31$export$2e2bcd8739ae039);
var $7c7060fbbf163b31$export$2e2bcd8739ae039 = {};
$7c7060fbbf163b31$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dragDescriptionKeyboardAlt": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dragDescriptionLongPress": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}.`,
    "dragDescriptionTouch": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dragDescriptionVirtual": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}.`,
    "dragItem": (args)=>`\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3C1}\u{3B5}\u{3C4}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + Enter \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3C1}\u{3B5}\u{3C4}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3C1}\u{3B5}\u{3C4}\u{3B5} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`${formatter.number(args.count)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "dragStartedKeyboard": `\u{397} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3BE}\u{3B5}\u{3BA}\u{3AF}\u{3BD}\u{3B7}\u{3C3}\u{3B5}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3C0}\u{3BB}\u{3AE}\u{3BA}\u{3C4}\u{3C1}\u{3BF} Tab \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3B2}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3AD}\u{3BD}\u{3B1}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3BF}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9}, \u{3C3}\u{3C4}\u{3B7} \u{3C3}\u{3C5}\u{3BD}\u{3AD}\u{3C7}\u{3B5}\u{3B9}\u{3B1}, \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Escape \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7}.`,
    "dragStartedTouch": `\u{397} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3BE}\u{3B5}\u{3BA}\u{3AF}\u{3BD}\u{3B7}\u{3C3}\u{3B5}. \u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3B2}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3AD}\u{3BD}\u{3B1}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3BF}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9}, \u{3C3}\u{3C4}\u{3B7} \u{3C3}\u{3C5}\u{3BD}\u{3AD}\u{3C7}\u{3B5}\u{3B9}\u{3B1}, \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dragStartedVirtual": `\u{397} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3BE}\u{3B5}\u{3BA}\u{3AF}\u{3BD}\u{3B7}\u{3C3}\u{3B5}. \u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3B2}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3AD}\u{3BD}\u{3B1}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3BF}\u{3C1}\u{3B9}\u{3C3}\u{3BC}\u{3CC} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9}, \u{3C3}\u{3C4}\u{3B7} \u{3C3}\u{3C5}\u{3BD}\u{3AD}\u{3C7}\u{3B5}\u{3B9}\u{3B1}, \u{3BA}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dropCanceled": `\u{397} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3B1}\u{3BA}\u{3C5}\u{3C1}\u{3CE}\u{3B8}\u{3B7}\u{3BA}\u{3B5}.`,
    "dropComplete": `\u{397} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3BF}\u{3BB}\u{3BF}\u{3BA}\u{3BB}\u{3B7}\u{3C1}\u{3CE}\u{3B8}\u{3B7}\u{3BA}\u{3B5}.`,
    "dropDescriptionKeyboard": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Escape \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "dropDescriptionTouch": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dropDescriptionVirtual": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}.`,
    "dropIndicator": `\u{3B4}\u{3B5}\u{3AF}\u{3BA}\u{3C4}\u{3B7}\u{3C2} \u{3B1}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7}\u{3C2}`,
    "dropOnItem": (args)=>`\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3C3}\u{3B5} ${args.itemText}`,
    "dropOnRoot": `\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3C3}\u{3B5}`,
    "endDragKeyboard": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} \u{3B5}\u{3BE}\u{3AD}\u{3BB}\u{3B9}\u{3BE}\u{3B7}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "endDragTouch": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} \u{3B5}\u{3BE}\u{3AD}\u{3BB}\u{3B9}\u{3BE}\u{3B7}. \u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3B4}\u{3CD}\u{3BF} \u{3C6}\u{3BF}\u{3C1}\u{3AD}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "endDragVirtual": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC} \u{3C3}\u{3B5} \u{3B5}\u{3BE}\u{3AD}\u{3BB}\u{3B9}\u{3BE}\u{3B7}. \u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BA}\u{3CD}\u{3C1}\u{3C9}\u{3C3}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3BF}\u{3C1}\u{3AC}\u{3C2}.`,
    "insertAfter": (args)=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3C9}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3AC} \u{3B1}\u{3C0}\u{3CC} ${args.itemText}`,
    "insertBefore": (args)=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3C9}\u{3B3}\u{3AE} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3B1}\u{3C0}\u{3CC} ${args.itemText}`,
    "insertBetween": (args)=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3C9}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3BE}\u{3CD} ${args.beforeItemText} \u{3BA}\u{3B1}\u{3B9} ${args.afterItemText}`
};

});

parcelRegister("7bKd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3d06ca30b7034e$export$2e2bcd8739ae039);
var $fd3d06ca30b7034e$export$2e2bcd8739ae039 = {};
$fd3d06ca30b7034e$export$2e2bcd8739ae039 = {
    "dragItem": (args)=>`Drag ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}`,
    "dragDescriptionKeyboard": `Press Enter to start dragging.`,
    "dragDescriptionKeyboardAlt": `Press Alt + Enter to start dragging.`,
    "dragDescriptionTouch": `Double tap to start dragging.`,
    "dragDescriptionVirtual": `Click to start dragging.`,
    "dragDescriptionLongPress": `Long press to start dragging.`,
    "dragSelectedKeyboard": (args, formatter)=>`Press Enter to drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Press Alt + Enter to drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Long press to drag ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} selected item`,
            other: ()=>`${formatter.number(args.count)} selected items`
        })}.`,
    "dragStartedKeyboard": `Started dragging. Press Tab to navigate to a drop target, then press Enter to drop, or press Escape to cancel.`,
    "dragStartedTouch": `Started dragging. Navigate to a drop target, then double tap to drop.`,
    "dragStartedVirtual": `Started dragging. Navigate to a drop target, then click or press Enter to drop.`,
    "endDragKeyboard": `Dragging. Press Enter to cancel drag.`,
    "endDragTouch": `Dragging. Double tap to cancel drag.`,
    "endDragVirtual": `Dragging. Click to cancel drag.`,
    "dropDescriptionKeyboard": `Press Enter to drop. Press Escape to cancel drag.`,
    "dropDescriptionTouch": `Double tap to drop.`,
    "dropDescriptionVirtual": `Click to drop.`,
    "dropCanceled": `Drop canceled.`,
    "dropComplete": `Drop complete.`,
    "dropIndicator": `drop indicator`,
    "dropOnRoot": `Drop on`,
    "dropOnItem": (args)=>`Drop on ${args.itemText}`,
    "insertBefore": (args)=>`Insert before ${args.itemText}`,
    "insertBetween": (args)=>`Insert between ${args.beforeItemText} and ${args.afterItemText}`,
    "insertAfter": (args)=>`Insert after ${args.itemText}`
};

});

parcelRegister("jA2YH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aca38a2587e8739$export$2e2bcd8739ae039);
var $8aca38a2587e8739$export$2e2bcd8739ae039 = {};
$8aca38a2587e8739$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Pulse Intro para empezar a arrastrar.`,
    "dragDescriptionKeyboardAlt": `Pulse Intro para empezar a arrastrar.`,
    "dragDescriptionLongPress": `Mantenga pulsado para comenzar a arrastrar.`,
    "dragDescriptionTouch": `Pulse dos veces para iniciar el arrastre.`,
    "dragDescriptionVirtual": `Haga clic para iniciar el arrastre.`,
    "dragItem": (args)=>`Arrastrar ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pulse Intro para arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pulse Alt + Intro para arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Mantenga pulsado para arrastrar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "dragStartedKeyboard": `Se ha empezado a arrastrar. Pulse el tabulador para ir al destino donde se vaya a colocar y, a continuaci\xf3n, pulse Intro para soltar, o pulse Escape para cancelar.`,
    "dragStartedTouch": `Se ha empezado a arrastrar. Vaya al destino donde se vaya a colocar y, a continuaci\xf3n, pulse dos veces para soltar.`,
    "dragStartedVirtual": `Se ha empezado a arrastrar. Vaya al destino donde se vaya a colocar y, a continuaci\xf3n, haga clic o pulse Intro para soltar.`,
    "dropCanceled": `Se ha cancelado la colocaci\xf3n.`,
    "dropComplete": `Colocaci\xf3n finalizada.`,
    "dropDescriptionKeyboard": `Pulse Intro para soltar. Pulse Escape para cancelar el arrastre.`,
    "dropDescriptionTouch": `Pulse dos veces para soltar.`,
    "dropDescriptionVirtual": `Haga clic para soltar.`,
    "dropIndicator": `indicador de colocaci\xf3n`,
    "dropOnItem": (args)=>`Soltar en ${args.itemText}`,
    "dropOnRoot": `Soltar en`,
    "endDragKeyboard": `Arrastrando. Pulse Intro para cancelar el arrastre.`,
    "endDragTouch": `Arrastrando. Pulse dos veces para cancelar el arrastre.`,
    "endDragVirtual": `Arrastrando. Haga clic para cancelar el arrastre.`,
    "insertAfter": (args)=>`Insertar despu\xe9s de ${args.itemText}`,
    "insertBefore": (args)=>`Insertar antes de ${args.itemText}`,
    "insertBetween": (args)=>`Insertar entre ${args.beforeItemText} y ${args.afterItemText}`
};

});

parcelRegister("6jm6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $26abccf49d90d061$export$2e2bcd8739ae039);
var $26abccf49d90d061$export$2e2bcd8739ae039 = {};
$26abccf49d90d061$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Lohistamise alustamiseks vajutage klahvi Enter.`,
    "dragDescriptionKeyboardAlt": `Lohistamise alustamiseks vajutage klahvikombinatsiooni Alt + Enter.`,
    "dragDescriptionLongPress": `Vajutage pikalt lohistamise alustamiseks.`,
    "dragDescriptionTouch": `Topeltpuudutage lohistamise alustamiseks.`,
    "dragDescriptionVirtual": `Kl\xf5psake lohistamise alustamiseks.`,
    "dragItem": (args)=>`Lohista ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Lohista ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksust`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksust`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksuse`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksuse`
        })} lohistamiseks vajutage sisestusklahvi Enter.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Lohistamiseks vajutage klahvikombinatsiooni Alt + Enter ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksuse`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksuse`
        })} jaoks.`,
    "dragSelectedLongPress": (args, formatter)=>`Pikk vajutus ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valitud \xfcksuse`,
            other: ()=>`${formatter.number(args.count)} valitud \xfcksuse`
        })} lohistamiseks.`,
    "dragStartedKeyboard": `Alustati lohistamist. Kukutamise sihtm\xe4rgi juurde navigeerimiseks vajutage klahvi Tab, seej\xe4rel vajutage kukutamiseks klahvi Enter v\xf5i loobumiseks klahvi Escape.`,
    "dragStartedTouch": `Alustati lohistamist. Navigeerige kukutamise sihtm\xe4rgi juurde ja topeltpuudutage kukutamiseks.`,
    "dragStartedVirtual": `Alustati lohistamist. Navigeerige kukutamise sihtm\xe4rgi juurde ja kukutamiseks kl\xf5psake v\xf5i vajutage klahvi Enter.`,
    "dropCanceled": `Lohistamisest loobuti.`,
    "dropComplete": `Lohistamine on tehtud.`,
    "dropDescriptionKeyboard": `Kukutamiseks vajutage klahvi Enter. Lohistamisest loobumiseks vajutage klahvi Escape.`,
    "dropDescriptionTouch": `Kukutamiseks topeltpuudutage.`,
    "dropDescriptionVirtual": `Kukutamiseks kl\xf5psake.`,
    "dropIndicator": `lohistamise indikaator`,
    "dropOnItem": (args)=>`Kukuta asukohta ${args.itemText}`,
    "dropOnRoot": `Kukuta asukohta`,
    "endDragKeyboard": `Lohistamine. Lohistamisest loobumiseks vajutage klahvi Enter.`,
    "endDragTouch": `Lohistamine. Lohistamisest loobumiseks topeltpuudutage.`,
    "endDragVirtual": `Lohistamine. Lohistamisest loobumiseks kl\xf5psake.`,
    "insertAfter": (args)=>`Sisesta ${args.itemText} j\xe4rele`,
    "insertBefore": (args)=>`Sisesta ${args.itemText} ette`,
    "insertBetween": (args)=>`Sisesta ${args.beforeItemText} ja ${args.afterItemText} vahele`
};

});

parcelRegister("lUYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a92f1af48ad8524$export$2e2bcd8739ae039);
var $2a92f1af48ad8524$export$2e2bcd8739ae039 = {};
$2a92f1af48ad8524$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Aloita vet\xe4minen painamalla Enter-n\xe4pp\xe4int\xe4.`,
    "dragDescriptionKeyboardAlt": `Aloita vet\xe4minen painamalla Alt + Enter -n\xe4pp\xe4inyhdistelm\xe4\xe4.`,
    "dragDescriptionLongPress": `Aloita vet\xe4minen pit\xe4m\xe4ll\xe4 painettuna.`,
    "dragDescriptionTouch": `Aloita vet\xe4minen kaksoisnapauttamalla.`,
    "dragDescriptionVirtual": `Aloita vet\xe4minen napsauttamalla.`,
    "dragItem": (args)=>`Ved\xe4 kohdetta ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Ved\xe4 ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittua kohdetta`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Ved\xe4 painamalla Enter ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittu kohde`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Ved\xe4 painamalla Alt + Enter ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittu kohde`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Ved\xe4 pit\xe4m\xe4ll\xe4 painettuna ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valittu kohde`,
            other: ()=>`${formatter.number(args.count)} valittua kohdetta`
        })}.`,
    "dragStartedKeyboard": `Vet\xe4minen aloitettu. Siirry pudotuskohteeseen painamalla sarkainn\xe4pp\xe4int\xe4 ja sitten pudota painamalla Enter-n\xe4pp\xe4int\xe4 tai peruuta painamalla Escape-n\xe4pp\xe4int\xe4.`,
    "dragStartedTouch": `Vet\xe4minen aloitettu. Siirry pudotuskohteeseen ja pudota kaksoisnapauttamalla.`,
    "dragStartedVirtual": `Vet\xe4minen aloitettu. Siirry pudotuskohteeseen ja pudota napsauttamalla tai painamalla Enter-n\xe4pp\xe4int\xe4.`,
    "dropCanceled": `Pudotus peruutettu.`,
    "dropComplete": `Pudotus suoritettu.`,
    "dropDescriptionKeyboard": `Pudota painamalla Enter-n\xe4pp\xe4int\xe4. Peruuta vet\xe4minen painamalla Escape-n\xe4pp\xe4int\xe4.`,
    "dropDescriptionTouch": `Pudota kaksoisnapauttamalla.`,
    "dropDescriptionVirtual": `Pudota napsauttamalla.`,
    "dropIndicator": `pudotuksen ilmaisin`,
    "dropOnItem": (args)=>`Pudota kohteeseen ${args.itemText}`,
    "dropOnRoot": `Pudota kohteeseen`,
    "endDragKeyboard": `Vedet\xe4\xe4n. Peruuta vet\xe4minen painamalla Enter-n\xe4pp\xe4int\xe4.`,
    "endDragTouch": `Vedet\xe4\xe4n. Peruuta vet\xe4minen kaksoisnapauttamalla.`,
    "endDragVirtual": `Vedet\xe4\xe4n. Peruuta vet\xe4minen napsauttamalla.`,
    "insertAfter": (args)=>`Lis\xe4\xe4 kohteen ${args.itemText} j\xe4lkeen`,
    "insertBefore": (args)=>`Lis\xe4\xe4 ennen kohdetta ${args.itemText}`,
    "insertBetween": (args)=>`Lis\xe4\xe4 kohteiden ${args.beforeItemText} ja ${args.afterItemText} v\xe4liin`
};

});

parcelRegister("cJNt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e538e57df3c85353$export$2e2bcd8739ae039);
var $e538e57df3c85353$export$2e2bcd8739ae039 = {};
$e538e57df3c85353$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Appuyez sur Entr\xe9e pour commencer le d\xe9placement.`,
    "dragDescriptionKeyboardAlt": `Appuyez sur Alt\xa0+\xa0Entr\xe9e pour commencer \xe0 faire glisser.`,
    "dragDescriptionLongPress": `Appuyez de mani\xe8re prolong\xe9e pour commencer \xe0 faire glisser.`,
    "dragDescriptionTouch": `Touchez deux fois pour commencer le d\xe9placement.`,
    "dragDescriptionVirtual": `Cliquez pour commencer le d\xe9placement.`,
    "dragItem": (args)=>`D\xe9placer ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`D\xe9placer ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Appuyez sur Entr\xe9e pour faire glisser ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Appuyez sur Alt\xa0+\xa0Entr\xe9e pour faire glisser ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Appuyez de mani\xe8re prolong\xe9e pour faire glisser ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "dragStartedKeyboard": `D\xe9placement commenc\xe9. Appuyez sur Tabulation pour acc\xe9der \xe0 une cible de d\xe9p\xf4t, puis appuyez sur Entr\xe9e pour d\xe9poser, ou appuyez sur \xc9chap pour annuler.`,
    "dragStartedTouch": `D\xe9placement commenc\xe9. Acc\xe9dez \xe0 une cible de d\xe9p\xf4t, puis touchez deux fois pour d\xe9poser.`,
    "dragStartedVirtual": `D\xe9placement commenc\xe9. Acc\xe9dez \xe0 une cible de d\xe9p\xf4t, puis cliquez ou appuyez sur Entr\xe9e pour d\xe9poser.`,
    "dropCanceled": `D\xe9p\xf4t annul\xe9.`,
    "dropComplete": `D\xe9p\xf4t termin\xe9.`,
    "dropDescriptionKeyboard": `Appuyez sur Entr\xe9e pour d\xe9poser. Appuyez sur \xc9chap pour annuler le d\xe9placement.`,
    "dropDescriptionTouch": `Touchez deux fois pour d\xe9poser.`,
    "dropDescriptionVirtual": `Cliquez pour d\xe9poser.`,
    "dropIndicator": `indicateur de d\xe9p\xf4t`,
    "dropOnItem": (args)=>`D\xe9poser sur ${args.itemText}`,
    "dropOnRoot": `D\xe9poser sur`,
    "endDragKeyboard": `D\xe9placement. Appuyez sur Entr\xe9e pour annuler le d\xe9placement.`,
    "endDragTouch": `D\xe9placement. Touchez deux fois pour annuler le d\xe9placement.`,
    "endDragVirtual": `D\xe9placement. Cliquez pour annuler le d\xe9placement.`,
    "insertAfter": (args)=>`Ins\xe9rer apr\xe8s ${args.itemText}`,
    "insertBefore": (args)=>`Ins\xe9rer avant ${args.itemText}`,
    "insertBetween": (args)=>`Ins\xe9rer entre ${args.beforeItemText} et ${args.afterItemText}`
};

});

parcelRegister("dsZIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bffbac8dd3445125$export$2e2bcd8739ae039);
var $bffbac8dd3445125$export$2e2bcd8739ae039 = {};
$bffbac8dd3445125$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragDescriptionKeyboardAlt": `\u{5D4}\u{5E7}\u{5E9} Alt + Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragDescriptionLongPress": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragDescriptionTouch": `\u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "dragDescriptionVirtual": `\u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}.`,
    "dragItem": (args)=>`\u{5D2}\u{5E8}\u{5D5}\u{5E8} \u{5D0}\u{5EA} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E0}\u{5D1}\u{5D7}\u{5E8} ${formatter.number(args.count)}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{5D4}\u{5E7}\u{5E9} Alt + Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E9}\u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "dragStartedKeyboard": `\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5EA} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Tab \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E0}\u{5D5}\u{5D5}\u{5D8} \u{5DC}\u{5E0}\u{5E7}\u{5D5}\u{5D3}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4} \u{5D5}\u{5DC}\u{5D0}\u{5D7}\u{5E8} \u{5DE}\u{5DB}\u{5DF} \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5D0}\u{5D5} \u{5E2}\u{5DC} Escape \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC}.`,
    "dragStartedTouch": `\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5EA} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}. \u{5E0}\u{5D5}\u{5D5}\u{5D8} \u{5DC}\u{5E0}\u{5E7}\u{5D5}\u{5D3}\u{5EA} \u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D5}\u{5DC}\u{5D0}\u{5D7}\u{5E8} \u{5DE}\u{5DB}\u{5DF} \u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dragStartedVirtual": `\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5EA} \u{5DC}\u{5D2}\u{5E8}\u{5D5}\u{5E8}. \u{5E0}\u{5D5}\u{5D5}\u{5D8} \u{5DC}\u{5E0}\u{5E7}\u{5D5}\u{5D3}\u{5EA} \u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D5}\u{5DC}\u{5D0}\u{5D7}\u{5E8} \u{5DE}\u{5DB}\u{5DF} \u{5DC}\u{5D7}\u{5E5} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dropCanceled": `\u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D1}\u{5D5}\u{5D8}\u{5DC}.`,
    "dropComplete": `\u{5D4}\u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8} \u{5D4}\u{5D5}\u{5E9}\u{5DC}\u{5DD}.`,
    "dropDescriptionKeyboard": `\u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Escape \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "dropDescriptionTouch": `\u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dropDescriptionVirtual": `\u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5D7}\u{5E8}\u{5E8}.`,
    "dropIndicator": `\u{5DE}\u{5D7}\u{5D5}\u{5D5}\u{5DF} \u{5E9}\u{5D7}\u{5E8}\u{5D5}\u{5E8}`,
    "dropOnItem": (args)=>`\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5E2}\u{5DC} ${args.itemText}`,
    "dropOnRoot": `\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5E2}\u{5DC}`,
    "endDragKeyboard": `\u{5D2}\u{5D5}\u{5E8}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E2}\u{5DC} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "endDragTouch": `\u{5D2}\u{5D5}\u{5E8}\u{5E8}. \u{5D4}\u{5E7}\u{5E9} \u{5E4}\u{5E2}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "endDragVirtual": `\u{5D2}\u{5D5}\u{5E8}\u{5E8}. \u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D1}\u{5D8}\u{5DC} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5E8}\u{5D9}\u{5E8}\u{5D4}.`,
    "insertAfter": (args)=>`\u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5D0}\u{5D7}\u{5E8}\u{5D9} ${args.itemText}`,
    "insertBefore": (args)=>`\u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5DC}\u{5E4}\u{5E0}\u{5D9} ${args.itemText}`,
    "insertBetween": (args)=>`\u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5D1}\u{5D9}\u{5DF} ${args.beforeItemText} \u{5DC}\u{5D1}\u{5D9}\u{5DF} ${args.afterItemText}`
};

});

parcelRegister("d5QT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6aa60a380c4a7c3$export$2e2bcd8739ae039);
var $b6aa60a380c4a7c3$export$2e2bcd8739ae039 = {};
$b6aa60a380c4a7c3$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Pritisnite Enter da biste po\u{10D}eli povla\u{10D}iti.`,
    "dragDescriptionKeyboardAlt": `Pritisnite Alt + Enter za po\u{10D}etak povla\u{10D}enja.`,
    "dragDescriptionLongPress": `Dugo pritisnite za po\u{10D}etak povla\u{10D}enja.`,
    "dragDescriptionTouch": `Dvaput dodirnite da biste po\u{10D}eli povla\u{10D}iti.`,
    "dragDescriptionVirtual": `Kliknite da biste po\u{10D}eli povla\u{10D}iti.`,
    "dragItem": (args)=>`Povucite stavku ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Povucite ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabranu stavku`,
            other: ()=>`ovoliko odabranih stavki: ${formatter.number(args.count)}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pritisnite Enter za povla\u{10D}enje ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabrana stavka`,
            other: ()=>`${formatter.number(args.count)} odabrane stavke`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pritisnite Alt + Enter za povla\u{10D}enje ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabrana stavka`,
            other: ()=>`${formatter.number(args.count)} odabrane stavke`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Dugo pritisnite za povla\u{10D}enje ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} odabrana stavka`,
            other: ()=>`${formatter.number(args.count)} odabrane stavke`
        })}.`,
    "dragStartedKeyboard": `Po\u{10D}eli ste povla\u{10D}iti. Pritisnite tipku tabulatora da biste do\u{161}li do cilja ispu\u{161}tanja, a zatim Enter da biste ispustili stavku ili Escape da biste prekinuli povla\u{10D}enje.`,
    "dragStartedTouch": `Po\u{10D}eli ste povla\u{10D}iti. Do\u{111}ite do cilja ispu\u{161}tanja, a zatim dvaput dodirnite da biste ispustili stavku.`,
    "dragStartedVirtual": `Po\u{10D}eli ste povla\u{10D}iti. Do\u{111}ite do cilja ispu\u{161}tanja, a zatim kliknite ili pritisnite Enter da biste ispustili stavku.`,
    "dropCanceled": `Povla\u{10D}enje je prekinuto.`,
    "dropComplete": `Ispu\u{161}tanje je dovr\u{161}eno.`,
    "dropDescriptionKeyboard": `Pritisnite Enter da biste ispustili stavku. Pritisnite Escape da biste prekinuli povla\u{10D}enje.`,
    "dropDescriptionTouch": `Dvaput dodirnite da biste ispustili stavku.`,
    "dropDescriptionVirtual": `Kliknite da biste ispustili stavku.`,
    "dropIndicator": `pokazatelj ispu\u{161}tanja`,
    "dropOnItem": (args)=>`Ispustite na stavku ${args.itemText}`,
    "dropOnRoot": `Ispustite na`,
    "endDragKeyboard": `Povla\u{10D}enje. Pritisnite Enter da biste prekinuli povla\u{10D}enje.`,
    "endDragTouch": `Povla\u{10D}enje. Dvaput dodirnite da biste prekinuli povla\u{10D}enje.`,
    "endDragVirtual": `Povla\u{10D}enje. Kliknite da biste prekinuli povla\u{10D}enje.`,
    "insertAfter": (args)=>`Umetnite iza stavke ${args.itemText}`,
    "insertBefore": (args)=>`Ispustite ispred stavke ${args.itemText}`,
    "insertBetween": (args)=>`Umetnite izme\u{111}u stavki ${args.beforeItemText} i ${args.afterItemText}`
};

});

parcelRegister("2xJM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6cdd45c48d85ae$export$2e2bcd8739ae039);
var $de6cdd45c48d85ae$export$2e2bcd8739ae039 = {};
$de6cdd45c48d85ae$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Nyomja le az Enter billenty\u{171}t a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragDescriptionKeyboardAlt": `Nyomja le az Alt + Enter billenty\u{171}ket a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragDescriptionLongPress": `Hosszan nyomja meg a h\xfaz\xe1s elind\xedt\xe1s\xe1hoz.`,
    "dragDescriptionTouch": `Koppintson dupl\xe1n a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragDescriptionVirtual": `Kattintson a h\xfaz\xe1s megkezd\xe9s\xe9hez.`,
    "dragItem": (args)=>`${args.itemText} h\xfaz\xe1sa`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1sa`,
    "dragSelectedKeyboard": (args, formatter)=>`Nyomja meg az Entert ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1s\xe1hoz.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Nyomja meg az Alt + Enter billenty\u{171}ket ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1s\xe1hoz.`,
    "dragSelectedLongPress": (args, formatter)=>`Tartsa lenyomva hosszan ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`,
            other: ()=>`${formatter.number(args.count)} kijel\xf6lt elem`
        })} h\xfaz\xe1s\xe1hoz.`,
    "dragStartedKeyboard": `H\xfaz\xe1s megkezdve. Nyomja le a Tab billenty\u{171}t az elenged\xe9si c\xe9lhoz navig\xe1l\xe1s\xe1hoz, majd nyomja le az Enter billenty\u{171}t az elenged\xe9shez, vagy nyomja le az Escape billenty\u{171}t a megszak\xedt\xe1shoz.`,
    "dragStartedTouch": `H\xfaz\xe1s megkezdve. Navig\xe1ljon egy elenged\xe9si c\xe9lhoz, majd koppintson dupl\xe1n az elenged\xe9shez.`,
    "dragStartedVirtual": `H\xfaz\xe1s megkezdve. Navig\xe1ljon egy elenged\xe9si c\xe9lhoz, majd kattintson vagy nyomja le az Enter billenty\u{171}t az elenged\xe9shez.`,
    "dropCanceled": `Elenged\xe9s megszak\xedtva.`,
    "dropComplete": `Elenged\xe9s teljes\xedtve.`,
    "dropDescriptionKeyboard": `Nyomja le az Enter billenty\u{171}t az elenged\xe9shez. Nyomja le az Escape billenty\u{171}t a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "dropDescriptionTouch": `Koppintson dupl\xe1n az elenged\xe9shez.`,
    "dropDescriptionVirtual": `Kattintson az elenged\xe9shez.`,
    "dropIndicator": `elenged\xe9sjelz\u{151}`,
    "dropOnItem": (args)=>`Elenged\xe9s erre: ${args.itemText}`,
    "dropOnRoot": `Elenged\xe9s erre:`,
    "endDragKeyboard": `H\xfaz\xe1s folyamatban. Nyomja le az Enter billenty\u{171}t a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "endDragTouch": `H\xfaz\xe1s folyamatban. Koppintson dupl\xe1n a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "endDragVirtual": `H\xfaz\xe1s folyamatban. Kattintson a h\xfaz\xe1s megszak\xedt\xe1s\xe1hoz.`,
    "insertAfter": (args)=>`Besz\xfar\xe1s ${args.itemText} ut\xe1n`,
    "insertBefore": (args)=>`Besz\xfar\xe1s ${args.itemText} el\xe9`,
    "insertBetween": (args)=>`Besz\xfar\xe1s ${args.beforeItemText} \xe9s ${args.afterItemText} k\xf6z\xe9`
};

});

parcelRegister("eNi6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $a15538de2c0f87f9$export$2e2bcd8739ae039);
var $a15538de2c0f87f9$export$2e2bcd8739ae039 = {};
$a15538de2c0f87f9$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Premi Invio per iniziare a trascinare.`,
    "dragDescriptionKeyboardAlt": `Premi Alt + Invio per iniziare a trascinare.`,
    "dragDescriptionLongPress": `Premi a lungo per iniziare a trascinare.`,
    "dragDescriptionTouch": `Tocca due volte per iniziare a trascinare.`,
    "dragDescriptionVirtual": `Fai clic per iniziare a trascinare.`,
    "dragItem": (args)=>`Trascina ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Trascina ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} altro elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} altri elementi selezionati`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Premi Invio per trascinare ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Premi Alt + Invio per trascinare ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Premi a lungo per trascinare ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "dragStartedKeyboard": `Hai iniziato a trascinare. Premi Tab per arrivare sull\u{2019}area di destinazione, quindi premi Invio per rilasciare o Esc per annullare.`,
    "dragStartedTouch": `Hai iniziato a trascinare. Arriva sull\u{2019}area di destinazione, quindi tocca due volte per rilasciare.`,
    "dragStartedVirtual": `Hai iniziato a trascinare. Arriva sull\u{2019}area di destinazione, quindi fai clic o premi Invio per rilasciare.`,
    "dropCanceled": `Rilascio annullato.`,
    "dropComplete": `Rilascio completato.`,
    "dropDescriptionKeyboard": `Premi Invio per rilasciare. Premi Esc per annullare.`,
    "dropDescriptionTouch": `Tocca due volte per rilasciare.`,
    "dropDescriptionVirtual": `Fai clic per rilasciare.`,
    "dropIndicator": `indicatore di rilascio`,
    "dropOnItem": (args)=>`Rilascia su ${args.itemText}`,
    "dropOnRoot": `Rilascia su`,
    "endDragKeyboard": `Trascinamento. Premi Invio per annullare.`,
    "endDragTouch": `Trascinamento. Tocca due volte per annullare.`,
    "endDragVirtual": `Trascinamento. Fai clic per annullare.`,
    "insertAfter": (args)=>`Inserisci dopo ${args.itemText}`,
    "insertBefore": (args)=>`Inserisci prima di ${args.itemText}`,
    "insertBetween": (args)=>`Inserisci tra ${args.beforeItemText} e ${args.afterItemText}`
};

});

parcelRegister("7d7QK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0c4d13007e9576$export$2e2bcd8739ae039);
var $6d0c4d13007e9576$export$2e2bcd8739ae039 = {};
$6d0c4d13007e9576$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    "dragDescriptionKeyboardAlt": `Alt+Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragDescriptionLongPress": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragDescriptionTouch": `\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragDescriptionVirtual": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragItem": (args)=>`${args.itemText} \u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{306E}\u{9078}\u{629E}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{306E}\u{9078}\u{629E}\u{9805}\u{76EE}`
        })} \u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}`,
    "dragSelectedKeyboard": (args, formatter)=>`Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{3001}${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`
        })}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Alt+Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{3001}${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`
        })}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragSelectedLongPress": (args, formatter)=>`\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{3001}${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9078}\u{629E}\u{3057}\u{305F}\u{9805}\u{76EE}`
        })}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragStartedKeyboard": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3059}\u{3002}Tab \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{306B}\u{3044}\u{3069}\u{3046}\u{3057}\u{3001}Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3059}\u{308B}\u{304B}\u{3001}Esc \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragStartedTouch": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{306E}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dragStartedVirtual": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{958B}\u{59CB}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{306E}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{307E}\u{305F}\u{306F} Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropCanceled": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{304C}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "dropComplete": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{304C}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "dropDescriptionKeyboard": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}Esc \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropDescriptionTouch": `\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropDescriptionVirtual": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "dropIndicator": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30A4}\u{30F3}\u{30B8}\u{30B1}\u{30FC}\u{30BF}\u{30FC}`,
    "dropOnItem": (args)=>`${args.itemText} \u{306B}\u{30C9}\u{30ED}\u{30C3}\u{30D7}`,
    "dropOnRoot": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{5834}\u{6240}`,
    "endDragKeyboard": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "endDragTouch": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{30C0}\u{30D6}\u{30EB}\u{30BF}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "endDragVirtual": `\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{30C9}\u{30E9}\u{30C3}\u{30B0}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "insertAfter": (args)=>`${args.itemText} \u{306E}\u{5F8C}\u{306B}\u{633F}\u{5165}`,
    "insertBefore": (args)=>`${args.itemText} \u{306E}\u{524D}\u{306B}\u{633F}\u{5165}`,
    "insertBetween": (args)=>`${args.beforeItemText} \u{3068} ${args.afterItemText} \u{306E}\u{9593}\u{306B}\u{633F}\u{5165}`
};

});

parcelRegister("cbxAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7d1ad082559a41$export$2e2bcd8739ae039);
var $da7d1ad082559a41$export$2e2bcd8739ae039 = {};
$da7d1ad082559a41$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "dragDescriptionKeyboardAlt": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Alt + Enter\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragDescriptionLongPress": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragDescriptionTouch": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C138}\u{C694}.`,
    "dragDescriptionVirtual": `\u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C138}\u{C694}.`,
    "dragItem": (args)=>`${args.itemText} \u{B4DC}\u{B798}\u{ADF8}`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })} \u{B4DC}\u{B798}\u{ADF8}`,
    "dragSelectedKeyboard": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })}\u{C744} \u{B4DC}\u{B798}\u{ADF8}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })}\u{C744} \u{B4DC}\u{B798}\u{ADF8}\u{D558}\u{B824}\u{BA74} Alt + Enter\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragSelectedLongPress": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{C120}\u{D0DD} \u{D56D}\u{BAA9}`
        })}\u{C744} \u{B4DC}\u{B798}\u{ADF8}\u{D558}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "dragStartedKeyboard": `\u{B4DC}\u{B798}\u{ADF8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. Tab\u{C744} \u{B20C}\u{B7EC} \u{B4DC}\u{B86D} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D55C} \u{B2E4}\u{C74C} Enter\u{B97C} \u{B20C}\u{B7EC} \u{B4DC}\u{B86D}\u{D558}\u{AC70}\u{B098} Esc\u{B97C} \u{B20C}\u{B7EC} \u{CDE8}\u{C18C}\u{D558}\u{C138}\u{C694}.`,
    "dragStartedTouch": `\u{B4DC}\u{B798}\u{ADF8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B86D} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D55C} \u{B2E4}\u{C74C} \u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C5EC} \u{B4DC}\u{B86D}\u{D558}\u{C138}\u{C694}.`,
    "dragStartedVirtual": `\u{B4DC}\u{B798}\u{ADF8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B86D} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D55C} \u{B2E4}\u{C74C} \u{D074}\u{B9AD}\u{D558}\u{AC70}\u{B098} Enter\u{B97C} \u{B20C}\u{B7EC} \u{B4DC}\u{B86D}\u{D558}\u{C138}\u{C694}.`,
    "dropCanceled": `\u{B4DC}\u{B86D}\u{C774} \u{CDE8}\u{C18C}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "dropComplete": `\u{B4DC}\u{B86D}\u{C774} \u{C644}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "dropDescriptionKeyboard": `\u{B4DC}\u{B86D}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} Esc\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "dropDescriptionTouch": `\u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C5EC} \u{B4DC}\u{B86D}\u{D558}\u{C138}\u{C694}.`,
    "dropDescriptionVirtual": `\u{B4DC}\u{B86D}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C138}\u{C694}.`,
    "dropIndicator": `\u{B4DC}\u{B86D} \u{D45C}\u{C2DC}\u{AE30}`,
    "dropOnItem": (args)=>`${args.itemText}\u{C5D0} \u{B4DC}\u{B86D}`,
    "dropOnRoot": `\u{B4DC}\u{B86D} \u{B300}\u{C0C1}`,
    "endDragKeyboard": `\u{B4DC}\u{B798}\u{ADF8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "endDragTouch": `\u{B4DC}\u{B798}\u{ADF8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} \u{B354}\u{BE14} \u{D0ED}\u{D558}\u{C138}\u{C694}.`,
    "endDragVirtual": `\u{B4DC}\u{B798}\u{ADF8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{B4DC}\u{B798}\u{ADF8}\u{B97C} \u{CDE8}\u{C18C}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C138}\u{C694}.`,
    "insertAfter": (args)=>`${args.itemText} \u{C774}\u{D6C4}\u{C5D0} \u{C0BD}\u{C785}`,
    "insertBefore": (args)=>`${args.itemText} \u{C774}\u{C804}\u{C5D0} \u{C0BD}\u{C785}`,
    "insertBetween": (args)=>`${args.beforeItemText} \u{BC0F} ${args.afterItemText} \u{C0AC}\u{C774}\u{C5D0} \u{C0BD}\u{C785}`
};

});

parcelRegister("35B0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc13a57c83ff5895$export$2e2bcd8739ae039);
var $dc13a57c83ff5895$export$2e2bcd8739ae039 = {};
$dc13a57c83ff5895$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Paspauskite \u{201E}Enter\u{201C}, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionKeyboardAlt": `Paspauskite \u{201E}Alt + Enter\u{201C}, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionLongPress": `Palaikykite nuspaud\u{119}, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionTouch": `Palieskite dukart, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragDescriptionVirtual": `Spustel\u{117}kite, kad prad\u{117}tum\u{117}te vilkti.`,
    "dragItem": (args)=>`Vilkti ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Vilkti ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Paspauskite \u{201E}Enter\u{201C}, jei norite nuvilkti ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Paspauskite \u{201E}Alt + Enter\u{201C}, kad nuvilktum\u{117}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Nuspaud\u{119} palaikykite, kad nuvilktum\u{117}te ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pasirinkt\u{105} element\u{105}`,
            other: ()=>`${formatter.number(args.count)} pasirinktus elementus`
        })}.`,
    "dragStartedKeyboard": `Prad\u{117}ta vilkti. Paspauskite \u{201E}Tab\u{201C}, kad pereitum\u{117}te \u{12F} tiesiogin\u{119} paskirties viet\u{105}, tada paspauskite \u{201E}Enter\u{201C}, kad numestum\u{117}te, arba \u{201E}Escape\u{201C}, kad at\u{161}auktum\u{117}te.`,
    "dragStartedTouch": `Prad\u{117}ta vilkti. Eikite \u{12F} tiesiogin\u{119} paskirties viet\u{105}, tada palieskite dukart, kad numestum\u{117}te.`,
    "dragStartedVirtual": `Prad\u{117}ta vilkti. Eikite \u{12F} tiesiogin\u{119} paskirties viet\u{105} ir spustel\u{117}kite arba paspauskite \u{201E}Enter\u{201C}, kad numestum\u{117}te.`,
    "dropCanceled": `Numetimas at\u{161}auktas.`,
    "dropComplete": `Numesta.`,
    "dropDescriptionKeyboard": `Paspauskite \u{201E}Enter\u{201C}, kad numestum\u{117}te. Paspauskite \u{201E}Escape\u{201C}, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "dropDescriptionTouch": `Palieskite dukart, kad numestum\u{117}te.`,
    "dropDescriptionVirtual": `Spustel\u{117}kite, kad numestum\u{117}te.`,
    "dropIndicator": `numetimo indikatorius`,
    "dropOnItem": (args)=>`Numesti ant ${args.itemText}`,
    "dropOnRoot": `Numesti ant`,
    "endDragKeyboard": `Velkama. Paspauskite \u{201E}Enter\u{201C}, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "endDragTouch": `Velkama. Spustel\u{117}kite dukart, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "endDragVirtual": `Velkama. Spustel\u{117}kite, kad at\u{161}auktum\u{117}te vilkim\u{105}.`,
    "insertAfter": (args)=>`\u{12E}terpti po ${args.itemText}`,
    "insertBefore": (args)=>`\u{12E}terpti prie\u{161} ${args.itemText}`,
    "insertBetween": (args)=>`\u{12E}terpti tarp ${args.beforeItemText} ir ${args.afterItemText}`
};

});

parcelRegister("5rmQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ed05a5495fe835$export$2e2bcd8739ae039);
var $b5ed05a5495fe835$export$2e2bcd8739ae039 = {};
$b5ed05a5495fe835$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Nospiediet Enter, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionKeyboardAlt": `Nospiediet tausti\u{146}u kombin\u{101}ciju Alt+Enter, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionLongPress": `Turiet nospiestu, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionTouch": `Veiciet dubultsk\u{101}rienu, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragDescriptionVirtual": `Noklik\u{161}\u{137}iniet, lai s\u{101}ktu vilk\u{161}anu.`,
    "dragItem": (args)=>`Velciet ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Velciet ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Nospiediet tausti\u{146}u Enter, lai vilktu ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Nospiediet tausti\u{146}u kombin\u{101}ciju Alt+Enter, lai vilktu ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Turiet nospiestu, lai vilktu ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} atlas\u{12B}to vienumu`,
            other: ()=>`${formatter.number(args.count)} atlas\u{12B}tos vienumus`
        })}.`,
    "dragStartedKeyboard": `Uzs\u{101}kta vilk\u{161}ana. Nospiediet tausti\u{146}u Tab, lai p\u{101}rietu uz nome\u{161}anas m\u{113}r\u{137}i, p\u{113}c tam nospiediet Enter, lai nomestu, vai nospiediet Escape, lai atceltu.`,
    "dragStartedTouch": `Uzs\u{101}kta vilk\u{161}ana. P\u{101}rejiet uz nome\u{161}anas m\u{113}r\u{137}i, p\u{113}c tam veiciet dubultsk\u{101}rienu, lai nomestu.`,
    "dragStartedVirtual": `Uzs\u{101}kta vilk\u{161}ana. P\u{101}rejiet uz nome\u{161}anas m\u{113}r\u{137}i, p\u{113}c tam nospiediet Enter, lai nomestu.`,
    "dropCanceled": `Nome\u{161}ana atcelta.`,
    "dropComplete": `Nome\u{161}ana pabeigta.`,
    "dropDescriptionKeyboard": `Nospiediet Enter, lai nomestu. Nospiediet Escape, lai atceltu vilk\u{161}anu.`,
    "dropDescriptionTouch": `Veiciet dubultsk\u{101}rienu, lai nomestu.`,
    "dropDescriptionVirtual": `Noklik\u{161}\u{137}iniet, lai nomestu.`,
    "dropIndicator": `nome\u{161}anas indikators`,
    "dropOnItem": (args)=>`Nometiet uz ${args.itemText}`,
    "dropOnRoot": `Nometiet uz`,
    "endDragKeyboard": `Notiek vilk\u{161}ana. Nospiediet Enter, lai atceltu vilk\u{161}anu.`,
    "endDragTouch": `Notiek vilk\u{161}ana. Veiciet dubultsk\u{101}rienu, lai atceltu vilk\u{161}anu.`,
    "endDragVirtual": `Notiek vilk\u{161}ana. Noklik\u{161}\u{137}iniet, lai atceltu vilk\u{161}anu.`,
    "insertAfter": (args)=>`Ievietojiet p\u{113}c ${args.itemText}`,
    "insertBefore": (args)=>`Ievietojiet pirms ${args.itemText}`,
    "insertBetween": (args)=>`Ievietojiet starp ${args.beforeItemText} un ${args.afterItemText}`
};

});

parcelRegister("9a9xi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e00f2cf13ebc5f0$export$2e2bcd8739ae039);
var $2e00f2cf13ebc5f0$export$2e2bcd8739ae039 = {};
$2e00f2cf13ebc5f0$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Trykk p\xe5 Enter for \xe5 begynne \xe5 dra.`,
    "dragDescriptionKeyboardAlt": `Trykk p\xe5 Alt + Enter for \xe5 begynne \xe5 dra.`,
    "dragDescriptionLongPress": `Trykk lenge for \xe5 begynne \xe5 dra.`,
    "dragDescriptionTouch": `Dobbelttrykk for \xe5 begynne \xe5 dra.`,
    "dragDescriptionVirtual": `Klikk for \xe5 begynne \xe5 dra.`,
    "dragItem": (args)=>`Dra ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} merket element`,
            other: ()=>`${formatter.number(args.count)} merkede elementer`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Trykk Enter for \xe5 dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Trykk p\xe5 Alt + Enter for \xe5 dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Trykk lenge for \xe5 dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valgt element`,
            other: ()=>`${formatter.number(args.count)} valgte elementer`
        })}.`,
    "dragStartedKeyboard": `Begynte \xe5 dra. Trykk p\xe5 Tab for \xe5 navigere til et m\xe5l, og trykk deretter p\xe5 Enter for \xe5 slippe eller p\xe5 Esc for \xe5 avbryte.`,
    "dragStartedTouch": `Begynte \xe5 dra. Naviger til et m\xe5l, og dobbelttrykk for \xe5 slippe.`,
    "dragStartedVirtual": `Begynte \xe5 dra. Naviger til et m\xe5l, og klikk eller trykk p\xe5 Enter for \xe5 slippe.`,
    "dropCanceled": `Avbr\xf8t slipping.`,
    "dropComplete": `Slippingen er fullf\xf8rt.`,
    "dropDescriptionKeyboard": `Trykk p\xe5 Enter for \xe5 slippe. Trykk p\xe5 Esc hvis du vil avbryte draingen.`,
    "dropDescriptionTouch": `Dobbelttrykk for \xe5 slippe.`,
    "dropDescriptionVirtual": `Klikk for \xe5 slippe.`,
    "dropIndicator": `slippeindikator`,
    "dropOnItem": (args)=>`Slipp p\xe5 ${args.itemText}`,
    "dropOnRoot": `Slipp p\xe5`,
    "endDragKeyboard": `Drar. Trykk p\xe5 Enter hvis du vil avbryte.`,
    "endDragTouch": `Drar. Dobbelttrykk hvis du vil avbryte.`,
    "endDragVirtual": `Drar. Klikk hvis du vil avbryte.`,
    "insertAfter": (args)=>`Sett inn etter ${args.itemText}`,
    "insertBefore": (args)=>`Sett inn f\xf8r ${args.itemText}`,
    "insertBetween": (args)=>`Sett inn mellom ${args.beforeItemText} og ${args.afterItemText}`
};

});

parcelRegister("nohQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a5a3356efe992aa$export$2e2bcd8739ae039);
var $6a5a3356efe992aa$export$2e2bcd8739ae039 = {};
$6a5a3356efe992aa$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Druk op Enter om te slepen.`,
    "dragDescriptionKeyboardAlt": `Druk op Alt + Enter om te slepen.`,
    "dragDescriptionLongPress": `Houd lang ingedrukt om te slepen.`,
    "dragDescriptionTouch": `Dubbeltik om te slepen.`,
    "dragDescriptionVirtual": `Klik om met slepen te starten.`,
    "dragItem": (args)=>`${args.itemText} slepen`,
    "dragSelectedItems": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} slepen`,
    "dragSelectedKeyboard": (args, formatter)=>`Druk op Enter om ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} te slepen.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Druk op Alt + Enter om ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} te slepen.`,
    "dragSelectedLongPress": (args, formatter)=>`Houd lang ingedrukt om ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} geselecteerd item`,
            other: ()=>`${formatter.number(args.count)} geselecteerde items`
        })} te slepen.`,
    "dragStartedKeyboard": `Begonnen met slepen. Druk op Tab om naar een locatie te gaan. Druk dan op Enter om neer te zetten, of op Esc om te annuleren.`,
    "dragStartedTouch": `Begonnen met slepen. Ga naar de gewenste locatie en dubbeltik om neer te zetten.`,
    "dragStartedVirtual": `Begonnen met slepen. Ga naar de gewenste locatie en klik of druk op Enter om neer te zetten.`,
    "dropCanceled": `Neerzetten geannuleerd.`,
    "dropComplete": `Neerzetten voltooid.`,
    "dropDescriptionKeyboard": `Druk op Enter om neer te zetten. Druk op Esc om het slepen te annuleren.`,
    "dropDescriptionTouch": `Dubbeltik om neer te zetten.`,
    "dropDescriptionVirtual": `Klik om neer te zetten.`,
    "dropIndicator": `aanwijzer voor neerzetten`,
    "dropOnItem": (args)=>`Neerzetten op ${args.itemText}`,
    "dropOnRoot": `Neerzetten op`,
    "endDragKeyboard": `Bezig met slepen. Druk op Enter om te annuleren.`,
    "endDragTouch": `Bezig met slepen. Dubbeltik om te annuleren.`,
    "endDragVirtual": `Bezig met slepen. Klik om te annuleren.`,
    "insertAfter": (args)=>`Plaatsen na ${args.itemText}`,
    "insertBefore": (args)=>`Plaatsen v\xf3\xf3r ${args.itemText}`,
    "insertBetween": (args)=>`Plaatsen tussen ${args.beforeItemText} en ${args.afterItemText}`
};

});

parcelRegister("iroxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a23cf9a89bee23c$export$2e2bcd8739ae039);
var $4a23cf9a89bee23c$export$2e2bcd8739ae039 = {};
$4a23cf9a89bee23c$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Naci\u{15B}nij Enter, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionKeyboardAlt": `Naci\u{15B}nij Alt + Enter, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionLongPress": `Naci\u{15B}nij i przytrzymaj, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionTouch": `Dotknij dwukrotnie, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragDescriptionVirtual": `Kliknij, aby rozpocz\u{105}\u{107} przeci\u{105}ganie.`,
    "dragItem": (args)=>`Przeci\u{105}gnij ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Przeci\u{105}gnij ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybranych element\xf3w`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Naci\u{15B}nij Enter, aby przeci\u{105}gn\u{105}\u{107} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybrane(-ych) elementy(-\xf3w)`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Naci\u{15B}nij Alt + Enter, aby przeci\u{105}gn\u{105}\u{107} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybrane(-ych) elementy(-\xf3w)`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Naci\u{15B}nij i przytrzymaj, aby przeci\u{105}gn\u{105}\u{107} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} wybrany element`,
            other: ()=>`${formatter.number(args.count)} wybrane(-ych) elementy(-\xf3w)`
        })}.`,
    "dragStartedKeyboard": `Rozpocz\u{119}to przeci\u{105}ganie. Naci\u{15B}nij Tab, aby wybra\u{107} miejsce docelowe, a nast\u{119}pnie naci\u{15B}nij Enter, aby upu\u{15B}ci\u{107}, lub Escape, aby anulowa\u{107}.`,
    "dragStartedTouch": `Rozpocz\u{119}to przeci\u{105}ganie. Wybierz miejsce, w kt\xf3rym chcesz upu\u{15B}ci\u{107} element, a nast\u{119}pnie dotknij dwukrotnie, aby upu\u{15B}ci\u{107}.F`,
    "dragStartedVirtual": `Rozpocz\u{119}to przeci\u{105}ganie. Wybierz miejsce, w kt\xf3rym chcesz upu\u{15B}ci\u{107} element, a nast\u{119}pnie kliknij lub naci\u{15B}nij Enter, aby upu\u{15B}ci\u{107}.`,
    "dropCanceled": `Anulowano upuszczenie.`,
    "dropComplete": `Zako\u{144}czono upuszczanie.`,
    "dropDescriptionKeyboard": `Naci\u{15B}nij Enter, aby upu\u{15B}ci\u{107}. Naci\u{15B}nij Escape, aby anulowa\u{107} przeci\u{105}gni\u{119}cie.`,
    "dropDescriptionTouch": `Dotknij dwukrotnie, aby upu\u{15B}ci\u{107}.`,
    "dropDescriptionVirtual": `Kliknij, aby upu\u{15B}ci\u{107}.`,
    "dropIndicator": `wska\u{17A}nik upuszczenia`,
    "dropOnItem": (args)=>`Upu\u{15B}\u{107} na ${args.itemText}`,
    "dropOnRoot": `Upu\u{15B}\u{107}`,
    "endDragKeyboard": `Przeci\u{105}ganie. Naci\u{15B}nij Enter, aby anulowa\u{107} przeci\u{105}gni\u{119}cie.`,
    "endDragTouch": `Przeci\u{105}ganie. Kliknij dwukrotnie, aby anulowa\u{107} przeci\u{105}gni\u{119}cie.`,
    "endDragVirtual": `Przeci\u{105}ganie. Kliknij, aby anulowa\u{107} przeci\u{105}ganie.`,
    "insertAfter": (args)=>`Umie\u{15B}\u{107} za ${args.itemText}`,
    "insertBefore": (args)=>`Umie\u{15B}\u{107} przed ${args.itemText}`,
    "insertBetween": (args)=>`Umie\u{15B}\u{107} mi\u{119}dzy ${args.beforeItemText} i ${args.afterItemText}`
};

});

parcelRegister("ipUFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5ec57e06426b25d$export$2e2bcd8739ae039);
var $c5ec57e06426b25d$export$2e2bcd8739ae039 = {};
$c5ec57e06426b25d$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Pressione Enter para come\xe7ar a arrastar.`,
    "dragDescriptionKeyboardAlt": `Pressione Alt + Enter para come\xe7ar a arrastar.`,
    "dragDescriptionLongPress": `Pressione e segure para come\xe7ar a arrastar.`,
    "dragDescriptionTouch": `Toque duas vezes para come\xe7ar a arrastar.`,
    "dragDescriptionVirtual": `Clique para come\xe7ar a arrastar.`,
    "dragItem": (args)=>`Arrastar ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pressione Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pressione Alt + Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Pressione e segure para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragStartedKeyboard": `Comece a arrastar. Pressione Tab para navegar at\xe9 um alvo e, em seguida, pressione Enter para soltar ou pressione Escape para cancelar.`,
    "dragStartedTouch": `Comece a arrastar. Navegue at\xe9 um alvo e toque duas vezes para soltar.`,
    "dragStartedVirtual": `Comece a arrastar. Navegue at\xe9 um alvo e clique ou pressione Enter para soltar.`,
    "dropCanceled": `Libera\xe7\xe3o cancelada.`,
    "dropComplete": `Libera\xe7\xe3o conclu\xedda.`,
    "dropDescriptionKeyboard": `Pressione Enter para soltar. Pressione Escape para cancelar.`,
    "dropDescriptionTouch": `Toque duas vezes para soltar.`,
    "dropDescriptionVirtual": `Clique para soltar.`,
    "dropIndicator": `indicador de libera\xe7\xe3o`,
    "dropOnItem": (args)=>`Soltar em ${args.itemText}`,
    "dropOnRoot": `Soltar`,
    "endDragKeyboard": `Arrastando. Pressione Enter para cancelar.`,
    "endDragTouch": `Arrastando. Toque duas vezes para cancelar.`,
    "endDragVirtual": `Arrastando. Clique para cancelar.`,
    "insertAfter": (args)=>`Inserir ap\xf3s ${args.itemText}`,
    "insertBefore": (args)=>`Inserir antes de ${args.itemText}`,
    "insertBetween": (args)=>`Inserir entre ${args.beforeItemText} e ${args.afterItemText}`
};

});

parcelRegister("dMzUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $46fbdbe3f7d9fb92$export$2e2bcd8739ae039);
var $46fbdbe3f7d9fb92$export$2e2bcd8739ae039 = {};
$46fbdbe3f7d9fb92$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Prima Enter para iniciar o arrasto.`,
    "dragDescriptionKeyboardAlt": `Prima Alt + Enter para iniciar o arrasto.`,
    "dragDescriptionLongPress": `Prima longamente para come\xe7ar a arrastar.`,
    "dragDescriptionTouch": `Fa\xe7a duplo toque para come\xe7ar a arrastar.`,
    "dragDescriptionVirtual": `Clique para iniciar o arrasto.`,
    "dragItem": (args)=>`Arrastar ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Prima Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Prima Alt + Enter para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Prima longamente para arrastar ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} o item selecionado`,
            other: ()=>`${formatter.number(args.count)} os itens selecionados`
        })}.`,
    "dragStartedKeyboard": `Arrasto iniciado. Prima a tecla de tabula\xe7\xe3o para navegar para um destino para largar, e em seguida prima Enter para largar ou prima Escape para cancelar.`,
    "dragStartedTouch": `Arrasto iniciado. Navegue para um destino para largar, e em seguida fa\xe7a duplo toque para largar.`,
    "dragStartedVirtual": `Arrasto iniciado. Navegue para um destino para largar, e em seguida clique ou prima Enter para largar.`,
    "dropCanceled": `Largar cancelado.`,
    "dropComplete": `Largar completo.`,
    "dropDescriptionKeyboard": `Prima Enter para largar. Prima Escape para cancelar o arrasto.`,
    "dropDescriptionTouch": `Fa\xe7a duplo toque para largar.`,
    "dropDescriptionVirtual": `Clique para largar.`,
    "dropIndicator": `Indicador de largar`,
    "dropOnItem": (args)=>`Largar em ${args.itemText}`,
    "dropOnRoot": `Largar em`,
    "endDragKeyboard": `A arrastar. Prima Enter para cancelar o arrasto.`,
    "endDragTouch": `A arrastar. Fa\xe7a duplo toque para cancelar o arrasto.`,
    "endDragVirtual": `A arrastar. Clique para cancelar o arrasto.`,
    "insertAfter": (args)=>`Inserir depois de ${args.itemText}`,
    "insertBefore": (args)=>`Inserir antes de ${args.itemText}`,
    "insertBetween": (args)=>`Inserir entre ${args.beforeItemText} e ${args.afterItemText}`
};

});

parcelRegister("fhq8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8e89f607478588$export$2e2bcd8739ae039);
var $9b8e89f607478588$export$2e2bcd8739ae039 = {};
$9b8e89f607478588$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Ap\u{103}sa\u{21B}i pe Enter pentru a \xeencepe glisarea.`,
    "dragDescriptionKeyboardAlt": `Ap\u{103}sa\u{21B}i pe Alt + Enter pentru a \xeencepe glisarea.`,
    "dragDescriptionLongPress": `Ap\u{103}sa\u{21B}i lung pentru a \xeencepe glisarea.`,
    "dragDescriptionTouch": `Atinge\u{21B}i de dou\u{103} ori pentru a \xeencepe s\u{103} glisa\u{21B}i.`,
    "dragDescriptionVirtual": `Face\u{21B}i clic pentru a \xeencepe glisarea.`,
    "dragItem": (args)=>`Glisa\u{21B}i ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Glisa\u{21B}i ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Ap\u{103}sa\u{21B}i pe Enter pentru a glisa ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Ap\u{103}sa\u{21B}i pe Alt + Enter pentru a glisa ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Ap\u{103}sa\u{21B}i lung pentru a glisa ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "dragStartedKeyboard": `A \xeenceput glisarea. Ap\u{103}sa\u{21B}i pe Tab pentru a naviga la o \u{21B}int\u{103} de fixare, apoi ap\u{103}sa\u{21B}i pe Enter pentru a fixa sau ap\u{103}sa\u{21B}i pe Escape pentru a anula glisarea.`,
    "dragStartedTouch": `A \xeenceput glisarea. Naviga\u{21B}i la o \u{21B}int\u{103} de fixare, apoi atinge\u{21B}i de dou\u{103} ori pentru a fixa.`,
    "dragStartedVirtual": `A \xeenceput glisarea. Naviga\u{21B}i la o \u{21B}int\u{103} de fixare, apoi face\u{21B}i clic sau ap\u{103}sa\u{21B}i pe Enter pentru a fixa.`,
    "dropCanceled": `Fixare anulat\u{103}.`,
    "dropComplete": `Fixare finalizat\u{103}.`,
    "dropDescriptionKeyboard": `Ap\u{103}sa\u{21B}i pe Enter pentru a fixa. Ap\u{103}sa\u{21B}i pe Escape pentru a anula glisarea.`,
    "dropDescriptionTouch": `Atinge\u{21B}i de dou\u{103} ori pentru a fixa.`,
    "dropDescriptionVirtual": `Face\u{21B}i clic pentru a fixa.`,
    "dropIndicator": `indicator de fixare`,
    "dropOnItem": (args)=>`Fixa\u{21B}i pe ${args.itemText}`,
    "dropOnRoot": `Fixare pe`,
    "endDragKeyboard": `Se gliseaz\u{103}. Ap\u{103}sa\u{21B}i pe Enter pentru a anula glisarea.`,
    "endDragTouch": `Se gliseaz\u{103}. Atinge\u{21B}i de dou\u{103} ori pentru a anula glisarea.`,
    "endDragVirtual": `Se gliseaz\u{103}. Face\u{21B}i clic pentru a anula glisarea.`,
    "insertAfter": (args)=>`Insera\u{21B}i dup\u{103} ${args.itemText}`,
    "insertBefore": (args)=>`Insera\u{21B}i \xeenainte de ${args.itemText}`,
    "insertBetween": (args)=>`Insera\u{21B}i \xeentre ${args.beforeItemText} \u{219}i ${args.afterItemText}`
};

});

parcelRegister("iEvQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef80ba38206c1474$export$2e2bcd8739ae039);
var $ef80ba38206c1474$export$2e2bcd8739ae039 = {};
$ef80ba38206c1474$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}.`,
    "dragDescriptionKeyboardAlt": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{442}\u{44C}.`,
    "dragDescriptionLongPress": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{442}\u{44C}.`,
    "dragDescriptionTouch": `\u{414}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}.`,
    "dragDescriptionVirtual": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}.`,
    "dragItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Enter \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + Enter \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`
        })}.`,
    "dragStartedKeyboard": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Tab \u{434}\u{43B}\u{44F} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{446}\u{435}\u{43B}\u{438}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}, \u{438}\u{43B}\u{438} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Escape \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}.`,
    "dragStartedTouch": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{446}\u{435}\u{43B}\u{44C}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{434}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dragStartedVirtual": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Tab \u{434}\u{43B}\u{44F} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430} \u{446}\u{435}\u{43B}\u{438}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dropCanceled": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43E}.`,
    "dropComplete": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    "dropDescriptionKeyboard": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Escape \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "dropDescriptionTouch": `\u{414}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dropDescriptionVirtual": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}.`,
    "dropIndicator": `\u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    "dropOnItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} \u{43D}\u{430} ${args.itemText}`,
    "dropOnRoot": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{44C} \u{43D}\u{430}`,
    "endDragKeyboard": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "endDragTouch": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{414}\u{432}\u{430}\u{436}\u{434}\u{44B} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "endDragVirtual": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}. \u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    "insertAfter": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{441}\u{43B}\u{435} ${args.itemText}`,
    "insertBefore": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{434} ${args.itemText}`,
    "insertBetween": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43C}\u{435}\u{436}\u{434}\u{443} ${args.beforeItemText} \u{438} ${args.afterItemText}`
};

});

parcelRegister("7g1Dd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0efe1fde929fd572$export$2e2bcd8739ae039);
var $0efe1fde929fd572$export$2e2bcd8739ae039 = {};
$0efe1fde929fd572$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Stla\u{10D}en\xedm kl\xe1vesu Enter za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionKeyboardAlt": `Stla\u{10D}en\xedm kl\xe1vesov Alt + Enter za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionLongPress": `Dlh\xfdm stla\u{10D}en\xedm za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionTouch": `Dvojit\xfdm kliknut\xedm za\u{10D}nete pres\xfavanie.`,
    "dragDescriptionVirtual": `Kliknut\xedm za\u{10D}nete pres\xfavanie.`,
    "dragItem": (args)=>`Presun\xfa\u{165} polo\u{17E}ku ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Presun\xfa\u{165} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xe9 polo\u{17E}ky`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Stla\u{10D}en\xedm kl\xe1vesu Enter presuniete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xfdch polo\u{17E}iek`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Stla\u{10D}en\xedm kl\xe1vesov Alt + Enter presuniete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xfdch polo\u{17E}iek`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Dlh\xfdm stla\u{10D}en\xedm presuniete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} vybrat\xfa polo\u{17E}ku`,
            other: ()=>`${formatter.number(args.count)} vybrat\xfdch polo\u{17E}iek`
        })}.`,
    "dragStartedKeyboard": `Pres\xfavanie sa za\u{10D}alo. Do cie\u{13E}ov\xe9ho umiestnenia prejdete stla\u{10D}en\xedm kl\xe1vesu Tab. Ak chcete polo\u{17E}ku umiestni\u{165}, stla\u{10D}te kl\xe1ves Enter alebo stla\u{10D}te kl\xe1ves Esc, ak chcete pres\xfavanie zru\u{161}i\u{165}.`,
    "dragStartedTouch": `Pres\xfavanie sa za\u{10D}alo. Prejdite na cie\u{13E}ov\xe9 umiestnenie a dvojit\xfdm kliknut\xedm umiestnite polo\u{17E}ku.`,
    "dragStartedVirtual": `Pres\xfavanie sa za\u{10D}alo. Prejdite na cie\u{13E}ov\xe9 umiestnenie a kliknut\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Enter umiestnite polo\u{17E}ku.`,
    "dropCanceled": `Umiestnenie zru\u{161}en\xe9.`,
    "dropComplete": `Umiestnenie dokon\u{10D}en\xe9.`,
    "dropDescriptionKeyboard": `Stla\u{10D}en\xedm kl\xe1vesu Enter umiestnite polo\u{17E}ku. Stla\u{10D}en\xedm kl\xe1vesu Esc zru\u{161}\xedte pres\xfavanie.`,
    "dropDescriptionTouch": `Dvojit\xfdm kliknut\xedm umiestnite polo\u{17E}ku.`,
    "dropDescriptionVirtual": `Kliknut\xedm umiestnite polo\u{17E}ku.`,
    "dropIndicator": `indik\xe1tor umiestnenia`,
    "dropOnItem": (args)=>`Umiestni\u{165} na polo\u{17E}ku ${args.itemText}`,
    "dropOnRoot": `Umiestni\u{165} na`,
    "endDragKeyboard": `Prebieha pres\xfavanie. Ak ho chcete zru\u{161}i\u{165}, stla\u{10D}te kl\xe1ves Enter.`,
    "endDragTouch": `Prebieha pres\xfavanie. Dvojit\xfdm kliknut\xedm ho m\xf4\u{17E}ete zru\u{161}i\u{165}.`,
    "endDragVirtual": `Prebieha pres\xfavanie.`,
    "insertAfter": (args)=>`Vlo\u{17E}i\u{165} za polo\u{17E}ku ${args.itemText}`,
    "insertBefore": (args)=>`Vlo\u{17E}i\u{165} pred polo\u{17E}ku ${args.itemText}`,
    "insertBetween": (args)=>`Vlo\u{17E}i\u{165} medzi polo\u{17E}ky ${args.beforeItemText} a ${args.afterItemText}`
};

});

parcelRegister("jOkrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd93a5a64e78f064$export$2e2bcd8739ae039);
var $dd93a5a64e78f064$export$2e2bcd8739ae039 = {};
$dd93a5a64e78f064$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Pritisnite tipko Enter za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionKeyboardAlt": `Pritisnite tipki Alt + Enter za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionLongPress": `Pritisnite in zadr\u{17E}ite za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionTouch": `Dvotapnite za za\u{10D}etek vle\u{10D}enja.`,
    "dragDescriptionVirtual": `Kliknite za za\u{10D}etek vle\u{10D}enja.`,
    "dragItem": (args)=>`Povleci ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Povlecite ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbran element`,
            other: ()=>`izbrane elemente (${formatter.number(args.count)})`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pritisnite tipko Enter, da povle\u{10D}ete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbrani element`,
            other: ()=>`${formatter.number(args.count)} izbranih elementov`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pritisnite tipki Alt + Enter, da povle\u{10D}ete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbrani element`,
            other: ()=>`${formatter.number(args.count)} izbranih elementov`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Pritisnite in zadr\u{17E}ite, da povle\u{10D}ete ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izbrani element`,
            other: ()=>`${formatter.number(args.count)} izbranih elementov`
        })}.`,
    "dragStartedKeyboard": `Vle\u{10D}enje se je za\u{10D}elo. Pritisnite tipko Tab za pomik na mesto, kamor \u{17E}elite spustiti elemente, in pritisnite tipko Enter, da jih spustite, ali tipko Escape, da prekli\u{10D}ete postopek.`,
    "dragStartedTouch": `Vle\u{10D}enje se je za\u{10D}elo. Pomaknite se na mesto, kamor \u{17E}elite spustiti elemente, in dvotapnite, da jih spustite.`,
    "dragStartedVirtual": `Vle\u{10D}enje se je za\u{10D}elo. Pomaknite se na mesto, kamor \u{17E}elite spustiti elemente, in kliknite ali pritisnite tipko Enter, da jih spustite.`,
    "dropCanceled": `Spust je preklican.`,
    "dropComplete": `Spust je kon\u{10D}an.`,
    "dropDescriptionKeyboard": `Pritisnite tipko Enter, da spustite. Pritisnite tipko Escape, da prekli\u{10D}ete vle\u{10D}enje.`,
    "dropDescriptionTouch": `Dvotapnite, da spustite.`,
    "dropDescriptionVirtual": `Kliknite, da spustite.`,
    "dropIndicator": `indikator spusta`,
    "dropOnItem": (args)=>`Spusti na mesto ${args.itemText}`,
    "dropOnRoot": `Spusti na mesto`,
    "endDragKeyboard": `Vle\u{10D}enje. Pritisnite tipko Enter za preklic vle\u{10D}enja.`,
    "endDragTouch": `Vle\u{10D}enje. Dvotapnite za preklic vle\u{10D}enja.`,
    "endDragVirtual": `Vle\u{10D}enje. Kliknite, da prekli\u{10D}ete vle\u{10D}enje.`,
    "insertAfter": (args)=>`Vstavi za ${args.itemText}`,
    "insertBefore": (args)=>`Vstavi pred ${args.itemText}`,
    "insertBetween": (args)=>`Vstavi med ${args.beforeItemText} in ${args.afterItemText}`
};

});

parcelRegister("cgapE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec0dd94b13fbb3f1$export$2e2bcd8739ae039);
var $ec0dd94b13fbb3f1$export$2e2bcd8739ae039 = {};
$ec0dd94b13fbb3f1$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Pritisnite Enter da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionKeyboardAlt": `Pritisnite Alt + Enter da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionLongPress": `Pritisnite dugo da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionTouch": `Dvaput dodirnite da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragDescriptionVirtual": `Kliknite da biste zapo\u{10D}eli prevla\u{10D}enje.`,
    "dragItem": (args)=>`Prevucite ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Prevucite ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabrane stavke`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Pritisnite Enter da biste prevukli ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabranih stavki`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Pritisnite Alt + Enter da biste prevukli ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabranih stavki`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Pritisnite dugo da biste prevukli ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} izabranu stavku`,
            other: ()=>`${formatter.number(args.count)} izabranih stavki`
        })}.`,
    "dragStartedKeyboard": `Prevla\u{10D}enje je zapo\u{10D}eto. Pritisnite Tab da biste oti\u{161}li do cilja za otpu\u{161}tanje, zatim pritisnite Enter za ispu\u{161}tanje ili pritisnite Escape za otkazivanje.`,
    "dragStartedTouch": `Prevla\u{10D}enje je zapo\u{10D}eto. Idite do cilja za otpu\u{161}tanje, a zatim dvaput dodirnite za otpu\u{161}tanje.`,
    "dragStartedVirtual": `Prevla\u{10D}enje je zapo\u{10D}eto. Idite do cilja za otpu\u{161}tanje, a zatim kliknite ili pritinite Enter za otpu\u{161}tanje.`,
    "dropCanceled": `Otpu\u{161}tanje je otkazano.`,
    "dropComplete": `Prevla\u{10D}enje je zavr\u{161}eno.`,
    "dropDescriptionKeyboard": `Pritisnite Enter da biste otpustili. Pritisnite Escape da biste otkazali prevla\u{10D}enje.`,
    "dropDescriptionTouch": `Dvaput dodirnite za otpu\u{161}tanje.`,
    "dropDescriptionVirtual": `Kliknite za otpu\u{161}tanje.`,
    "dropIndicator": `Indikator otpu\u{161}tanja`,
    "dropOnItem": (args)=>`Otpusti na ${args.itemText}`,
    "dropOnRoot": `Otpusti na`,
    "endDragKeyboard": `Prevla\u{10D}enje u toku. Pritisnite Enter da biste otkazali prevla\u{10D}enje.`,
    "endDragTouch": `Prevla\u{10D}enje u toku. Dvaput dodirnite da biste otkazali prevla\u{10D}enje.`,
    "endDragVirtual": `Prevla\u{10D}enje u toku. Kliknite da biste otkazali prevla\u{10D}enje.`,
    "insertAfter": (args)=>`Umetnite posle ${args.itemText}`,
    "insertBefore": (args)=>`Umetnite ispred ${args.itemText}`,
    "insertBetween": (args)=>`Umetnite izme\u{111}u ${args.beforeItemText} i ${args.afterItemText}`
};

});

parcelRegister("bhfJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7e648e9c5e8456c$export$2e2bcd8739ae039);
var $f7e648e9c5e8456c$export$2e2bcd8739ae039 = {};
$f7e648e9c5e8456c$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `Tryck p\xe5 enter f\xf6r att b\xf6rja dra.`,
    "dragDescriptionKeyboardAlt": `Tryck p\xe5 Alt + Retur f\xf6r att b\xf6rja dra.`,
    "dragDescriptionLongPress": `Tryck l\xe4nge f\xf6r att b\xf6rja dra.`,
    "dragDescriptionTouch": `Dubbeltryck f\xf6r att b\xf6rja dra.`,
    "dragDescriptionVirtual": `Klicka f\xf6r att b\xf6rja dra.`,
    "dragItem": (args)=>`Dra ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`Dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} valt objekt`,
            other: ()=>`${formatter.number(args.count)} valda objekt`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`Tryck p\xe5 Retur f\xf6r att dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`Tryck p\xe5 Alt + Retur f\xf6r att dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`Tryck l\xe4nge f\xf6r att dra ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "dragStartedKeyboard": `B\xf6rja dra. Tryck p\xe5 tabb f\xf6r att navigera till m\xe5let, tryck p\xe5 enter f\xf6r att sl\xe4ppa eller p\xe5 escape f\xf6r att avbryta.`,
    "dragStartedTouch": `B\xf6rja dra. Navigera till ett m\xe5l och dubbeltryck f\xf6r att sl\xe4ppa.`,
    "dragStartedVirtual": `B\xf6rja dra. Navigera till ett m\xe5l och klicka eller tryck p\xe5 enter f\xf6r att sl\xe4ppa.`,
    "dropCanceled": `Sl\xe4pp\xe5tg\xe4rd avbr\xf6ts.`,
    "dropComplete": `Sl\xe4pp\xe5tg\xe4rd klar.`,
    "dropDescriptionKeyboard": `Tryck p\xe5 enter f\xf6r att sl\xe4ppa. Tryck p\xe5 escape f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "dropDescriptionTouch": `Dubbeltryck f\xf6r att sl\xe4ppa.`,
    "dropDescriptionVirtual": `Klicka f\xf6r att sl\xe4ppa.`,
    "dropIndicator": `sl\xe4ppindikator`,
    "dropOnItem": (args)=>`Sl\xe4pp p\xe5 ${args.itemText}`,
    "dropOnRoot": `Sl\xe4pp p\xe5`,
    "endDragKeyboard": `Drar. Tryck p\xe5 enter f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "endDragTouch": `Drar. Dubbeltryck f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "endDragVirtual": `Drar. Klicka f\xf6r att avbryta drag\xe5tg\xe4rd.`,
    "insertAfter": (args)=>`Infoga efter ${args.itemText}`,
    "insertBefore": (args)=>`Infoga f\xf6re ${args.itemText}`,
    "insertBetween": (args)=>`Infoga mellan ${args.beforeItemText} och ${args.afterItemText}`
};

});

parcelRegister("fEiwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2719ab1e22abab71$export$2e2bcd8739ae039);
var $2719ab1e22abab71$export$2e2bcd8739ae039 = {};
$2719ab1e22abab71$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in Enter'a bas\u{131}n.`,
    "dragDescriptionKeyboardAlt": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in Alt + Enter'a bas\u{131}n.`,
    "dragDescriptionLongPress": `S\xfcr\xfcklemeye ba\u{15F}lamak i\xe7in uzun bas\u{131}n.`,
    "dragDescriptionTouch": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "dragDescriptionVirtual": `S\xfcr\xfcklemeyi ba\u{15F}latmak i\xe7in t\u{131}klay\u{131}n.`,
    "dragItem": (args)=>`${args.itemText}\u{2019}i s\xfcr\xfckle`,
    "dragSelectedItems": (args, formatter)=>`S\xfcr\xfckle ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ili \xf6ge`,
            other: ()=>`${formatter.number(args.count)} se\xe7ili \xf6ge`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`,
            other: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`
        })} \xf6\u{11F}esini s\xfcr\xfcklemek i\xe7in Enter'a bas\u{131}n.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`,
            other: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`
        })} \xf6\u{11F}esini s\xfcr\xfcklemek i\xe7in Alt + Enter tu\u{15F}una bas\u{131}n.`,
    "dragSelectedLongPress": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`,
            other: ()=>`${formatter.number(args.count)} se\xe7ilmi\u{15F} \xf6\u{11F}e`
        })} \xf6\u{11F}esini s\xfcr\xfcklemek i\xe7in uzun bas\u{131}n.`,
    "dragStartedKeyboard": `S\xfcr\xfckleme ba\u{15F}lat\u{131}ld\u{131}. Bir b\u{131}rakma hedefine gitmek i\xe7in Tab\u{2019}a bas\u{131}n, ard\u{131}ndan b\u{131}rakmak i\xe7in Enter\u{2019}a bas\u{131}n veya iptal etmek i\xe7in Escape\u{2019}e bas\u{131}n.`,
    "dragStartedTouch": `S\xfcr\xfckleme ba\u{15F}lat\u{131}ld\u{131}. Bir b\u{131}rakma hedefine gidin, ard\u{131}ndan b\u{131}rakmak i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "dragStartedVirtual": `S\xfcr\xfckleme ba\u{15F}lat\u{131}ld\u{131}. Bir b\u{131}rakma hedefine gidin, ard\u{131}ndan b\u{131}rakmak i\xe7in Enter\u{2019}a t\u{131}klay\u{131}n veya bas\u{131}n.`,
    "dropCanceled": `B\u{131}rakma iptal edildi.`,
    "dropComplete": `B\u{131}rakma tamamland\u{131}.`,
    "dropDescriptionKeyboard": `B\u{131}rakmak i\xe7in Enter'a bas\u{131}n. S\xfcr\xfcklemeyi iptal etmek i\xe7in Escape'e bas\u{131}n.`,
    "dropDescriptionTouch": `B\u{131}rakmak i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "dropDescriptionVirtual": `B\u{131}rakmak i\xe7in t\u{131}klay\u{131}n.`,
    "dropIndicator": `b\u{131}rakma g\xf6stergesi`,
    "dropOnItem": (args)=>`${args.itemText} \xfczerine b\u{131}rak`,
    "dropOnRoot": `B\u{131}rak\u{131}n`,
    "endDragKeyboard": `S\xfcr\xfckleme. S\xfcr\xfcklemeyi iptal etmek i\xe7in Enter'a bas\u{131}n.`,
    "endDragTouch": `S\xfcr\xfckleme. S\xfcr\xfcklemeyi iptal etmek i\xe7in \xe7ift t\u{131}klay\u{131}n.`,
    "endDragVirtual": `S\xfcr\xfckleme. S\xfcr\xfcklemeyi iptal etmek i\xe7in t\u{131}klay\u{131}n.`,
    "insertAfter": (args)=>`${args.itemText}\u{2019}den sonra gir`,
    "insertBefore": (args)=>`${args.itemText}\u{2019}den \xf6nce gir`,
    "insertBetween": (args)=>`${args.beforeItemText} ve ${args.afterItemText} aras\u{131}na gir`
};

});

parcelRegister("215fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c692636e2961941b$export$2e2bcd8739ae039);
var $c692636e2961941b$export$2e2bcd8739ae039 = {};
$c692636e2961941b$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionKeyboardAlt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Alt + Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionLongPress": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{456} \u{443}\u{442}\u{440}\u{438}\u{43C}\u{443}\u{439}\u{442}\u{435}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragDescriptionVirtual": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dragItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{456}\u{442}\u{44C} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}(-\u{456}\u{432})`
        })}.`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Alt + Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}(-\u{456}\u{432})`
        })}.`,
    "dragSelectedLongPress": (args, formatter)=>`\u{423}\u{442}\u{440}\u{438}\u{43C}\u{443}\u{439}\u{442}\u{435}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}(-\u{456}\u{432})`
        })}.`,
    "dragStartedKeyboard": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{43F}\u{43E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Tab, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{434}\u{43E} \u{446}\u{456}\u{43B}\u{456} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{442}\u{456}\u{43C} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}, \u{430}\u{431}\u{43E} Escape, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}.`,
    "dragStartedTouch": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{43F}\u{43E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44F}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{456}\u{442}\u{44C} \u{434}\u{43E} \u{446}\u{456}\u{43B}\u{456} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{442}\u{456}\u{43C} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dragStartedVirtual": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{43F}\u{43E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44F}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{456}\u{442}\u{44C} \u{434}\u{43E} \u{446}\u{456}\u{43B}\u{456} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{442}\u{456}\u{43C} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dropCanceled": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{441}\u{43A}\u{430}\u{441}\u{43E}\u{432}\u{430}\u{43D}\u{43E}.`,
    "dropComplete": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    "dropDescriptionKeyboard": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Escape, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "dropDescriptionTouch": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dropDescriptionVirtual": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438}.`,
    "dropIndicator": `\u{456}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}`,
    "dropOnItem": (args)=>`\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} \u{43D}\u{430} ${args.itemText}`,
    "dropOnRoot": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{443}\u{442}\u{438} \u{43D}\u{430}`,
    "endDragKeyboard": `\u{422}\u{440}\u{438}\u{432}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "endDragTouch": `\u{422}\u{440}\u{438}\u{432}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{432}\u{456}\u{447}\u{456}, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "endDragVirtual": `\u{422}\u{440}\u{438}\u{432}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{441}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "insertAfter": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{438} \u{43F}\u{456}\u{441}\u{43B}\u{44F} ${args.itemText}`,
    "insertBefore": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{434} ${args.itemText}`,
    "insertBetween": (args)=>`\u{412}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{438} \u{43C}\u{456}\u{436} ${args.beforeItemText} \u{456} ${args.afterItemText}`
};

});

parcelRegister("fp4xe", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ffcbecf2a5e833$export$2e2bcd8739ae039);
var $10ffcbecf2a5e833$export$2e2bcd8739ae039 = {};
$10ffcbecf2a5e833$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{6309} Enter \u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionKeyboardAlt": `\u{6309} Alt + Enter \u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionLongPress": `\u{957F}\u{6309}\u{4EE5}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionTouch": `\u{53CC}\u{51FB}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragDescriptionVirtual": `\u{5355}\u{51FB}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}`,
    "dragItem": (args)=>`\u{62D6}\u{52A8} ${args.itemText}`,
    "dragSelectedItems": (args, formatter)=>`\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{9009}\u{4E2D}\u{9879}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{9009}\u{4E2D}\u{9879}\u{76EE}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{6309} Enter \u{4EE5}\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`
        })}\u{3002}`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{6309} Alt + Enter \u{4EE5}\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`
        })}\u{3002}`,
    "dragSelectedLongPress": (args, formatter)=>`\u{957F}\u{6309}\u{4EE5}\u{62D6}\u{52A8} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`,
            other: ()=>`${formatter.number(args.count)} \u{4E2A}\u{9009}\u{5B9A}\u{9879}`
        })}\u{3002}`,
    "dragStartedKeyboard": `\u{5DF2}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}\u{6309} Tab \u{5BFC}\u{822A}\u{5230}\u{653E}\u{7F6E}\u{76EE}\u{6807}\u{FF0C}\u{7136}\u{540E}\u{6309} Enter \u{653E}\u{7F6E}\u{6216}\u{6309} Escape \u{53D6}\u{6D88}\u{3002}`,
    "dragStartedTouch": `\u{5DF2}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}\u{5BFC}\u{822A}\u{5230}\u{653E}\u{7F6E}\u{76EE}\u{6807}\u{FF0C}\u{7136}\u{540E}\u{53CC}\u{51FB}\u{653E}\u{7F6E}\u{3002}`,
    "dragStartedVirtual": `\u{5DF2}\u{5F00}\u{59CB}\u{62D6}\u{52A8}\u{3002}\u{5BFC}\u{822A}\u{5230}\u{653E}\u{7F6E}\u{76EE}\u{6807}\u{FF0C}\u{7136}\u{540E}\u{5355}\u{51FB}\u{6216}\u{6309} Enter \u{653E}\u{7F6E}\u{3002}`,
    "dropCanceled": `\u{653E}\u{7F6E}\u{5DF2}\u{53D6}\u{6D88}\u{3002}`,
    "dropComplete": `\u{653E}\u{7F6E}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    "dropDescriptionKeyboard": `\u{6309} Enter \u{653E}\u{7F6E}\u{3002}\u{6309} Escape \u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "dropDescriptionTouch": `\u{53CC}\u{51FB}\u{653E}\u{7F6E}\u{3002}`,
    "dropDescriptionVirtual": `\u{5355}\u{51FB}\u{653E}\u{7F6E}\u{3002}`,
    "dropIndicator": `\u{653E}\u{7F6E}\u{6807}\u{8BB0}`,
    "dropOnItem": (args)=>`\u{653E}\u{7F6E}\u{4E8E} ${args.itemText}`,
    "dropOnRoot": `\u{653E}\u{7F6E}\u{4E8E}`,
    "endDragKeyboard": `\u{6B63}\u{5728}\u{62D6}\u{52A8}\u{3002}\u{6309} Enter \u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "endDragTouch": `\u{6B63}\u{5728}\u{62D6}\u{52A8}\u{3002}\u{53CC}\u{51FB}\u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "endDragVirtual": `\u{6B63}\u{5728}\u{62D6}\u{52A8}\u{3002}\u{5355}\u{51FB}\u{53D6}\u{6D88}\u{62D6}\u{52A8}\u{3002}`,
    "insertAfter": (args)=>`\u{63D2}\u{5165}\u{5230} ${args.itemText} \u{4E4B}\u{540E}`,
    "insertBefore": (args)=>`\u{63D2}\u{5165}\u{5230} ${args.itemText} \u{4E4B}\u{524D}`,
    "insertBetween": (args)=>`\u{63D2}\u{5165}\u{5230} ${args.beforeItemText} \u{548C} ${args.afterItemText} \u{4E4B}\u{95F4}`
};

});

parcelRegister("4qLTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $80e81f562616ba09$export$2e2bcd8739ae039);
var $80e81f562616ba09$export$2e2bcd8739ae039 = {};
$80e81f562616ba09$export$2e2bcd8739ae039 = {
    "dragDescriptionKeyboard": `\u{6309} Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionKeyboardAlt": `\u{6309} Alt+Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionLongPress": `\u{9577}\u{6309}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionTouch": `\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragDescriptionVirtual": `\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{4EE5}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}`,
    "dragItem": (args)=>`\u{62D6}\u{66F3}\u{300C}${args.itemText}\u{300D}`,
    "dragSelectedItems": (args, formatter)=>`\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}`,
    "dragSelectedKeyboard": (args, formatter)=>`\u{6309} Enter \u{9375}\u{4EE5}\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "dragSelectedKeyboardAlt": (args, formatter)=>`\u{6309} Alt+Enter \u{9375}\u{4EE5}\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "dragSelectedLongPress": (args, formatter)=>`\u{9577}\u{6309}\u{4EE5}\u{62D6}\u{66F3} ${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{9078}\u{5B9A}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "dragStartedKeyboard": `\u{5DF2}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}\u{6309} Tab \u{9375}\u{4EE5}\u{700F}\u{89BD}\u{81F3}\u{653E}\u{7F6E}\u{76EE}\u{6A19}\u{FF0C}\u{7136}\u{5F8C}\u{6309} Enter \u{9375}\u{4EE5}\u{653E}\u{7F6E}\u{FF0C}\u{6216}\u{6309} Escape \u{9375}\u{4EE5}\u{53D6}\u{6D88}\u{3002}`,
    "dragStartedTouch": `\u{5DF2}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}\u{700F}\u{89BD}\u{81F3}\u{653E}\u{7F6E}\u{76EE}\u{6A19}\u{FF0C}\u{7136}\u{5F8C}\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dragStartedVirtual": `\u{5DF2}\u{958B}\u{59CB}\u{62D6}\u{66F3}\u{3002}\u{700F}\u{89BD}\u{81F3}\u{653E}\u{7F6E}\u{76EE}\u{6A19}\u{FF0C}\u{7136}\u{5F8C}\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{6216}\u{6309} Enter \u{9375}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dropCanceled": `\u{653E}\u{7F6E}\u{5DF2}\u{53D6}\u{6D88}\u{3002}`,
    "dropComplete": `\u{653E}\u{7F6E}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    "dropDescriptionKeyboard": `\u{6309} Enter \u{9375}\u{4EE5}\u{653E}\u{7F6E}\u{3002}\u{6309} Escape \u{9375}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "dropDescriptionTouch": `\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dropDescriptionVirtual": `\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{4EE5}\u{653E}\u{7F6E}\u{3002}`,
    "dropIndicator": `\u{653E}\u{7F6E}\u{6307}\u{793A}\u{5668}`,
    "dropOnItem": (args)=>`\u{653E}\u{7F6E}\u{5728}\u{300C}${args.itemText}\u{300D}\u{4E0A}`,
    "dropOnRoot": `\u{653E}\u{7F6E}\u{5728}`,
    "endDragKeyboard": `\u{62D6}\u{66F3}\u{4E2D}\u{3002}\u{6309} Enter \u{9375}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "endDragTouch": `\u{62D6}\u{66F3}\u{4E2D}\u{3002}\u{8F15}\u{9EDE}\u{5169}\u{4E0B}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "endDragVirtual": `\u{62D6}\u{66F3}\u{4E2D}\u{3002}\u{6309}\u{4E00}\u{4E0B}\u{6ED1}\u{9F20}\u{4EE5}\u{53D6}\u{6D88}\u{62D6}\u{66F3}\u{3002}`,
    "insertAfter": (args)=>`\u{63D2}\u{5165}\u{81F3}\u{300C}${args.itemText}\u{300D}\u{4E4B}\u{5F8C}`,
    "insertBefore": (args)=>`\u{63D2}\u{5165}\u{81F3}\u{300C}${args.itemText}\u{300D}\u{4E4B}\u{524D}`,
    "insertBetween": (args)=>`\u{63D2}\u{5165}\u{81F3}\u{300C}${args.beforeItemText}\u{300D}\u{548C}\u{300C}${args.afterItemText}\u{300D}\u{4E4B}\u{9593}`
};

});




parcelRegister("8PVB5", function(module, exports) {

$parcel$export(module.exports, "useClipboard", () => $a4b5e804a80563ed$export$2314ca2a3e892862);

var $d8j5I = parcelRequire("d8j5I");

var $kOxgB = parcelRequire("kOxgB");

var $4lMDe = parcelRequire("4lMDe");

var $4bE7h = parcelRequire("4bE7h");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a4b5e804a80563ed$var$$692863997030a376$var$globalEvents = new Map();
function $a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener(event, fn) {
    let eventData = $a4b5e804a80563ed$var$$692863997030a376$var$globalEvents.get(event);
    if (!eventData) {
        let handlers = new Set();
        let listener = (e)=>{
            for (let handler of handlers)handler(e);
        };
        eventData = {
            listener: listener,
            handlers: handlers
        };
        $a4b5e804a80563ed$var$$692863997030a376$var$globalEvents.set(event, eventData);
        document.addEventListener(event, listener);
    }
    eventData.handlers.add(fn);
    return ()=>{
        eventData.handlers.delete(fn);
        if (eventData.handlers.size === 0) {
            document.removeEventListener(event, eventData.listener);
            $a4b5e804a80563ed$var$$692863997030a376$var$globalEvents.delete(event);
        }
    };
}
function $a4b5e804a80563ed$export$2314ca2a3e892862(options) {
    let { isDisabled: isDisabled } = options;
    let isFocusedRef = (0, $eF4cA.useRef)(false);
    let { focusProps: focusProps } = (0, $4bE7h.useFocus)({
        onFocusChange: (isFocused)=>{
            isFocusedRef.current = isFocused;
        }
    });
    let onBeforeCopy = (0, $4lMDe.useEffectEvent)((e)=>{
        // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
        if (isFocusedRef.current && options.getItems) e.preventDefault();
    });
    let onCopy = (0, $4lMDe.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, $kOxgB.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'copy'
            }));
            options.onCopy?.();
        }
    });
    let onBeforeCut = (0, $4lMDe.useEffectEvent)((e)=>{
        if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
    });
    let onCut = (0, $4lMDe.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, $kOxgB.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'cut'
            }));
            options.onCut();
        }
    });
    let onBeforePaste = (0, $4lMDe.useEffectEvent)((e)=>{
        // Unfortunately, e.clipboardData.types is not available in this event so we always
        // have to enable the Paste menu item even if the type of data is unsupported.
        if (isFocusedRef.current && options.onPaste) e.preventDefault();
    });
    let onPaste = (0, $4lMDe.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onPaste) return;
        e.preventDefault();
        if (e.clipboardData) {
            let items = (0, $kOxgB.readFromDataTransfer)(e.clipboardData);
            options.onPaste(items);
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        if (isDisabled) return;
        return (0, $d8j5I.chain)($a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener('beforecopy', onBeforeCopy), $a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener('copy', onCopy), $a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener('beforecut', onBeforeCut), $a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener('cut', onCut), $a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener('beforepaste', onBeforePaste), $a4b5e804a80563ed$var$$692863997030a376$var$addGlobalEventListener('paste', onPaste));
    }, [
        isDisabled
    ]);
    return {
        clipboardProps: focusProps
    };
}

});



parcelRegister("7Vvqh", function(module, exports) {

$parcel$export(module.exports, "FileTrigger", () => $8c83e9959e0bf737$export$6fb4a10d2c950550);

var $ecbit = parcelRequire("ecbit");

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $7aYcI = parcelRequire("7aYcI");

var $eF4cA = parcelRequire("eF4cA");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8c83e9959e0bf737$export$6fb4a10d2c950550 = (0, $eF4cA.forwardRef)(function FileTrigger(props, ref) {
    let { onSelect: onSelect, acceptedFileTypes: acceptedFileTypes, allowsMultiple: allowsMultiple, defaultCamera: defaultCamera, children: children, acceptDirectory: acceptDirectory, ...rest } = props;
    let inputRef = (0, $26CkO.useObjectRef)(ref);
    let domProps = (0, $fVfXf.filterDOMProps)(rest, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $7aYcI.PressResponder), {
        onPress: ()=>{
            if (inputRef.current?.value) inputRef.current.value = '';
            inputRef.current?.click();
        }
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $ecbit.Input), {
        ...domProps,
        className: "",
        type: "file",
        ref: inputRef,
        onClick: (e)=>e.stopPropagation(),
        style: {
            display: 'none'
        },
        accept: acceptedFileTypes?.toString(),
        onChange: (e)=>onSelect?.((0, $fvyIQ.getEventTarget)(e).files),
        capture: defaultCamera,
        multiple: allowsMultiple,
        // @ts-expect-error
        webkitdirectory: acceptDirectory ? '' : undefined
    }));
});

});

parcelRegister("HZG6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f91d54ca44c5c$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ff8f91d54ca44c5c$var$$27869bce9dc5ec88$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M19.739 11.668c0 1.158-.45 2.246-1.27 3.063S16.564 16 15.407 16h-.657c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.657c.757 0 1.468-.294 2.003-.83.535-.534.83-1.245.83-2.002 0-.728-.277-1.418-.78-1.942-.501-.524-1.176-.833-1.902-.872-.254-.014-.485-.156-.611-.377-.127-.222-.132-.492-.014-.718.126-.241.222-.49.287-.739q.103-.392.103-.791c0-.894-.347-1.734-.979-2.366-1.208-1.207-3.296-1.274-4.568-.14-.6.536-.99 1.272-1.094 2.072-.03.236-.172.444-.38.559-.207.116-.457.126-.675.027q-.253-.116-.516-.175c-.86-.196-1.742.069-2.349.662-.474.463-.736 1.076-.736 1.728q0 .252.054.498c.034.158.086.316.152.466.1.224.083.483-.043.693-.128.21-.35.344-.594.36-.496.032-.957.247-1.298.606-.341.36-.53.832-.53 1.33 0 .52.203 1.011.572 1.38.369.368.858.571 1.38.571h2.1c.413 0 .75.336.75.75s-.337.75-.75.75h-2.1c-.922 0-1.789-.359-2.44-1.01-.653-.653-1.012-1.52-1.012-2.442 0-.882.335-1.72.942-2.361.387-.408.86-.71 1.382-.89q-.065-.348-.065-.701c0-1.06.422-2.054 1.189-2.802.956-.934 2.333-1.35 3.676-1.063.264-.814.74-1.55 1.387-2.127.882-.787 2.018-1.22 3.202-1.22 1.293 0 2.51.504 3.425 1.419.914.915 1.418 2.132 1.418 3.426 0 .394-.051.789-.152 1.172q-.016.063-.035.125c.721.212 1.378.61 1.908 1.162.771.806 1.196 1.864 1.196 2.98"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.854 10.824 10.85 7.826c-.293-.292-.768-.292-1.06 0l-2.998 2.998c-.293.293-.293.768 0 1.06.147.147.339.22.53.22s.385-.073.531-.22l1.722-1.722v8.184c0 .414.336.75.75.75s.75-.336.75-.75V10.17l1.718 1.714c.292.292.767.292 1.06 0 .293-.294.293-.769 0-1.061"
            })
        ]
    });
const $ff8f91d54ca44c5c$var$$27869bce9dc5ec88$var$ForwardRef = (0, $eF4cA.forwardRef)($ff8f91d54ca44c5c$var$$27869bce9dc5ec88$var$SvgComponent);
var $ff8f91d54ca44c5c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($ff8f91d54ca44c5c$var$$27869bce9dc5ec88$var$ForwardRef);

});

parcelRegister("d51mJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5904ac8ef19cd8b$export$2e2bcd8739ae039);

var $5MajL = parcelRequire("5MajL");

var $9MRNB = parcelRequire("9MRNB");

var $qnL6D = parcelRequire("qnL6D");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d5904ac8ef19cd8b$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $5MajL.default), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $qnL6D.default), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $9MRNB.default), {
                ...otherProps
            });
    }
}

});
parcelRegister("5MajL", function(module, exports) {

$parcel$export(module.exports, "default", () => $06613a91346ccb89$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $06613a91346ccb89$var$$f72a6b841a21927d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M136 50c0-6.627-5.373-12-12-12H36c-6.627 0-12 5.373-12 12v60c0 .862.09 1.703.264 2.513l24.781-38.286c4.365-6.75 14.252-6.75 18.618-.002l.001.002 20.529 31.71 11.745-17.491.001-.002c4.393-6.534 14.019-6.548 18.41 0l.004.007 17.059 25.27c.382-1.172.588-2.422.588-3.721zM55.762 78.573l-26.686 41.229C31.032 121.186 33.42 122 36 122h41.407l5.934-8.837-22.393-34.59-.002-.002c-1.213-1.876-3.97-1.876-5.183 0zm74.428 41.71c-1.808 1.09-3.926 1.717-6.19 1.717H87.044l19.534-29.092.001-.002c1.232-1.83 3.914-1.817 5.127-.005l.008.013zM79.61 130H124c11.046 0 20-8.954 20-20V50c0-11.046-8.954-20-20-20H36c-11.046 0-20 8.954-20 20v60c0 11.046 8.954 20 20 20h43.609M108 58c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8"
        })
    });
const $06613a91346ccb89$var$$f72a6b841a21927d$var$ForwardRef = (0, $eF4cA.forwardRef)($06613a91346ccb89$var$$f72a6b841a21927d$var$SvgComponent);
var $06613a91346ccb89$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($06613a91346ccb89$var$$f72a6b841a21927d$var$ForwardRef);

});

parcelRegister("9MRNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c53bb67073be16$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $01c53bb67073be16$var$$cf716f21e24b0e26$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M82.2 28c0-3.314-2.687-6-6-6H19c-3.315 0-6 2.686-6 6v39.2c0 .678.112 1.33.32 1.939l16.042-24.785v-.001c2.462-3.806 8.038-3.806 10.5 0l12.702 19.62 7.322-11.07.009-.013c2.477-3.686 7.906-3.693 10.382 0l.002.003 11.364 16.834c.357-.768.556-1.624.556-2.527zM32.72 46.526 15.983 72.387c.886.517 1.917.813 3.017.813h27.463l3.694-5.585-13.653-21.088v-.001c-.886-1.37-2.896-1.37-3.782 0m46.051 26.096c-.78.37-1.651.578-2.572.578H51.257l11.96-18.084c.9-1.328 2.853-1.32 3.738.002l.004.007zM76.2 18c5.523 0 10 4.477 10 10v39.2c0 5.523-4.477 10-10 10H19c-5.523 0-10-4.477-10-10V28c0-5.523 4.477-10 10-10zM65.5 33c0 2.761 2.239 5 5 5s5-2.239 5-5-2.239-5-5-5-5 2.239-5 5"
        })
    });
const $01c53bb67073be16$var$$cf716f21e24b0e26$var$ForwardRef = (0, $eF4cA.forwardRef)($01c53bb67073be16$var$$cf716f21e24b0e26$var$SvgComponent);
var $01c53bb67073be16$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($01c53bb67073be16$var$$cf716f21e24b0e26$var$ForwardRef);

});

parcelRegister("qnL6D", function(module, exports) {

$parcel$export(module.exports, "default", () => $06028dbe4bb3774e$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $06028dbe4bb3774e$var$$3bbaca709d56ce84$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M40.75 14c0-1.519-1.231-2.75-2.75-2.75H10c-1.519 0-2.75 1.231-2.75 2.75v19.97l7.722-11.93c1.33-2.055 4.34-2.055 5.669 0l6.144 9.49 3.45-5.217.005-.008c1.338-1.99 4.27-1.994 5.606 0l.002.002 4.902 7.262zm-23.68 9.399-8.414 13c.397.224.856.351 1.344.351h13.354q.043-.097.104-.19l1.822-2.754-6.738-10.407c-.344-.533-1.127-.533-1.471 0m22.485 12.87c-.442.303-.978.481-1.555.481H26.33l5.987-9.053c.35-.517 1.11-.512 1.453.001l.003.004zM38 8.75c2.9 0 5.25 2.35 5.25 5.25v20c0 2.9-2.35 5.25-5.25 5.25H10c-2.9 0-5.25-2.35-5.25-5.25V14c0-2.9 2.35-5.25 5.25-5.25zm-6 8.75c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5"
        })
    });
const $06028dbe4bb3774e$var$$3bbaca709d56ce84$var$ForwardRef = (0, $eF4cA.forwardRef)($06028dbe4bb3774e$var$$3bbaca709d56ce84$var$SvgComponent);
var $06028dbe4bb3774e$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($06028dbe4bb3774e$var$$3bbaca709d56ce84$var$ForwardRef);

});


parcelRegister("iLDMH", function(module, exports) {

$parcel$export(module.exports, "S3Image", () => $da9b7a278077c774$export$6400234c4a9a250);

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");

var $a8sj2 = parcelRequire("a8sj2");
const $da9b7a278077c774$export$6400234c4a9a250 = ({ filePath: filePath, src: src, isLoading: isLoading, ...props })=>{
    const urlQuery = (0, $a8sj2.usePresignURL)(filePath, {
        enabled: !src && !!filePath
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
        isLoading: !!isLoading || urlQuery.isFetching,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
            src: urlQuery.data?.presignURL ?? src ?? null,
            ...props
        })
    });
};
$da9b7a278077c774$export$6400234c4a9a250.propTypes = {
    filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};

});
parcelRegister("a8sj2", function(module, exports) {

$parcel$export(module.exports, "s3Key", () => $76109bb762174ac4$export$2e16cdea0a4e93f);
$parcel$export(module.exports, "useUploadFile", () => $76109bb762174ac4$export$25a37a5353d087d9);
$parcel$export(module.exports, "presignURLQueryOptions", () => $76109bb762174ac4$export$7c732a54e7d52c46);
$parcel$export(module.exports, "usePresignURL", () => $76109bb762174ac4$export$74d914cd510e9332);
$parcel$export(module.exports, "useDownloadS3Image", () => $76109bb762174ac4$export$a0a26e964a10de4d);

var $b0Fq6 = parcelRequire("b0Fq6");
var $1WYFS = parcelRequire("1WYFS");
var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");

var $D7J7L = parcelRequire("D7J7L");

var $9lDhw = parcelRequire("9lDhw");
const $76109bb762174ac4$export$2e16cdea0a4e93f = {
    all: [
        "s3"
    ],
    presignURL: (filePath)=>[
            ...$76109bb762174ac4$export$2e16cdea0a4e93f.all,
            "presignURL",
            filePath
        ]
};
const $76109bb762174ac4$export$47c13fca17f52ecc = (options = {})=>(0, $b0Fq6.mutationOptions)({
        mutationFn: ({ filePath: filePath, fileURL: fileURL, fileBlob: fileBlob }, { signal: signal })=>{
            if (fileBlob) return (0, $D7J7L.uploadFileByBlob)(filePath, fileBlob, {
                signal: signal
            });
            if (fileURL) return (0, $D7J7L.uploadFileByURL)(filePath, fileURL, {
                signal: signal
            });
            throw new Error("fileURL or fileBlob is required for upload");
        },
        onSuccess: (data, variables, context, { client: client })=>{
            client.setQueryData($76109bb762174ac4$export$2e16cdea0a4e93f.presignURL(data.filePath), data);
        },
        meta: {
            errorMessage: "Failed to upload file. Please try again."
        },
        ...options
    });
const $76109bb762174ac4$export$25a37a5353d087d9 = (options = {})=>{
    return (0, $k6waQ.useMutation)($76109bb762174ac4$export$47c13fca17f52ecc(options));
};
const $76109bb762174ac4$export$7c732a54e7d52c46 = (filePath, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $76109bb762174ac4$export$2e16cdea0a4e93f.presignURL(filePath),
        queryFn: ({ signal: signal })=>(0, $D7J7L.fetchPresignURL)(filePath, {
                signal: signal
            }),
        enabled: !!filePath,
        staleTime: 1200000,
        gcTime: 3000000,
        ...options
    });
const $76109bb762174ac4$export$74d914cd510e9332 = (filePath, options = {})=>{
    return (0, $4kcQz.useQuery)($76109bb762174ac4$export$7c732a54e7d52c46(filePath, options));
};
const $76109bb762174ac4$export$a0a26e964a10de4d = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async ({ filePath: filePath, fileName: fileName }, { signal: signal, client: client })=>{
            const s3Data = await client.query($76109bb762174ac4$export$7c732a54e7d52c46(filePath));
            return (0, $9lDhw.downloadImage)({
                url: s3Data.presignURL
            }, fileName, {
                signal: signal
            });
        },
        meta: {
            errorMessage: "Failed to download image. Please try again."
        },
        ...options
    });
};

});
parcelRegister("b0Fq6", function(module, exports) {

$parcel$export(module.exports, "mutationOptions", () => $803fd2f4b0a50b2a$export$e56bf486680f3272);
//#region src/mutationOptions.ts
function $803fd2f4b0a50b2a$export$e56bf486680f3272(options) {
    return options;
}

});

parcelRegister("9lDhw", function(module, exports) {

$parcel$export(module.exports, "downloadFile", () => $6ce48bb9bd75930a$export$bb3b75778e3e272);
$parcel$export(module.exports, "getImageBlob", () => $6ce48bb9bd75930a$export$a3dbe8c0b0742d4e);
$parcel$export(module.exports, "downloadImage", () => $6ce48bb9bd75930a$export$ea18af249ae1fbd0);
$parcel$export(module.exports, "generateExportJson", () => $6ce48bb9bd75930a$export$1b69c8d05c70d90);
$parcel$export(module.exports, "downloadImages", () => $6ce48bb9bd75930a$export$537fb84b8adc78c7);

var $lCqUR = parcelRequire("lCqUR");

var $kQT4E = parcelRequire("kQT4E");

var $8Ogg5 = parcelRequire("8Ogg5");

var $6lZyT = parcelRequire("6lZyT");

var $fHV62 = parcelRequire("fHV62");
/**
 * @param {string} hexValue
 * @returns {{ R: number, G: number, B: number } | null}
 */ function $6ce48bb9bd75930a$var$hexCampaignColorToRgbSliders(hexValue) {
    if (hexValue == null || hexValue === "") return null;
    try {
        const rgb = (0, $kQT4E.parseColor)(hexValue).toFormat("rgb");
        return {
            R: Math.round(rgb.getChannelValue("red")),
            G: Math.round(rgb.getChannelValue("green")),
            B: Math.round(rgb.getChannelValue("blue"))
        };
    } catch  {
        return null;
    }
}
/**
 * Sets MOGRT export.json RGB effect sliders from a campaign hex color.
 * @param {Record<string, object>} items - export.json section under the template top key
 * @param {string} campaignColorKey - "Brand-color" | "Secondary-color"
 * @param {string} hexValue - The hex value of the campaign color.
 */ function $6ce48bb9bd75930a$var$applyHexColorToExportEffects(items, campaignColorKey, hexValue) {
    const channels = $6ce48bb9bd75930a$var$hexCampaignColorToRgbSliders(hexValue);
    if (!channels) return;
    for (const item of Object.values(items)){
        const effects = item?.Effects;
        if (!effects || typeof effects !== "object") continue;
        for (const [suffix, sliderValue] of Object.entries(channels)){
            const effectKey = `${campaignColorKey}--${suffix}`;
            if (effects[effectKey]?.Slider !== undefined) effects[effectKey].Slider = sliderValue;
        }
    }
}
const $6ce48bb9bd75930a$export$bb3b75778e3e272 = (content, fileName, fileType)=>{
    const blob = new Blob([
        content
    ], {
        type: fileType
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName.includes(".") ? fileName : `${fileName}.${fileType.split("/")[1]}`;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.parentElement.removeChild(a);
};
const $6ce48bb9bd75930a$export$a3dbe8c0b0742d4e = async (image)=>{
    const url = await (0, $8Ogg5.getVisualUrl)(image);
    const isDataUrl = typeof url === "string" && url.startsWith("data:");
    const hintedType = image?.contentType || image?.mimeType;
    let response;
    if (isDataUrl) // Base64/data URLs are already local content - decode them directly
    // instead of routing through the SSRF-protected download proxy, which
    // only accepts http(s) URLs.
    response = await fetch(url);
    else {
        const headerOverrides = image?.downloadHeaders || image?.headers || {};
        const proxyUrl = (0, $8Ogg5.actions)["exd-storyteller-ai/downloads"];
        const authHeaders = await (0, $fHV62.getAuthHeaders)();
        response = await fetch(proxyUrl, {
            method: "POST",
            headers: {
                ...authHeaders,
                "Content-Type": "application/json"
            },
            credentials: "include",
            mode: "cors",
            body: JSON.stringify({
                url: url,
                headers: headerOverrides
            })
        });
    }
    if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
    let contentType = response.headers.get("content-type") || hintedType || "image/jpg";
    contentType = contentType.split(";")[0].trim().toLowerCase();
    if (contentType === "application/octet-stream") {
        const hintBase = hintedType?.split(";")[0].trim().toLowerCase();
        contentType = hintBase && hintBase.startsWith("audio/") ? hintBase : "image/jpg";
    }
    let format;
    if (contentType === "audio/x-wav" || contentType === "audio/wav" || contentType === "audio/wave") format = "wav";
    else format = contentType.split("/")[1].replace(/\+.*$/, "");
    const blob = await response.blob();
    let bitmap;
    let size = {
        width: 0,
        height: 0
    };
    if (contentType === "image/svg+xml") {
        const convertedBlob = await (0, $6lZyT.convertImageBlobToType)(blob, "png");
        bitmap = await window.createImageBitmap(convertedBlob);
        size.width = bitmap.width;
        size.height = bitmap.height;
    } else if (contentType.startsWith("image/")) {
        bitmap = await window.createImageBitmap(blob);
        size.width = bitmap.width;
        size.height = bitmap.height;
    }
    let name = image?.name;
    if (name == null || name === "") {
        if (!isDataUrl) try {
            const urlObj = new URL(image.url);
            name = urlObj.pathname.split("/").pop().split(".")[0];
        } catch (e) {
            name = "" + crypto.randomUUID();
        }
        else name = "" + crypto.randomUUID();
    }
    return {
        image: {
            ...image,
            contentType: contentType,
            format: format,
            size: size,
            name: name
        },
        blob: blob
    };
};
const $6ce48bb9bd75930a$export$ea18af249ae1fbd0 = (image, fileName)=>{
    return new Promise((resolve, reject)=>{
        if (!image || !image.url) return reject("No image to download");
        $6ce48bb9bd75930a$export$a3dbe8c0b0742d4e(image).then(({ image: image, blob: blob })=>{
            $6ce48bb9bd75930a$export$bb3b75778e3e272(blob, fileName ?? "image.png", image.contentType);
            resolve("Image downloaded successfully");
        }).catch((error)=>{
            reject(`Error downloading image: ${error}`);
        });
    });
};
const $6ce48bb9bd75930a$export$1b69c8d05c70d90 = (template, campaign, exportFileName = "export.json")=>{
    if (!template || !campaign || typeof template !== "object") return template;
    const topKey = Object.keys(template)[0];
    if (!topKey) return template;
    const cloned = JSON.parse(JSON.stringify(template));
    const items = cloned[topKey];
    if (!items || typeof items !== "object") return cloned;
    if (exportFileName !== "export-grouped.json") {
        for (const [label, value] of Object.entries(campaign)){
            if (label.includes("color")) {
                $6ce48bb9bd75930a$var$applyHexColorToExportEffects(items, label, value);
                continue;
            }
            const item = items[label];
            if (item?.Text?.["Source Text"] !== undefined) item.Text["Source Text"] = value === null || value === undefined ? "" : String(value);
        }
        return cloned;
    }
    const fillGroupedFields = (group)=>{
        for (const [label, item] of Object.entries(group)){
            if (!item || typeof item !== "object") continue;
            if (item.Text?.["Source Text"] !== undefined) {
                if (!Object.hasOwn(campaign, label)) continue;
                const value = campaign[label];
                if (/color/i.test(label) && value != null && value !== "") try {
                    const color = String(value);
                    item.Text["Source Text"] = (0, $kQT4E.parseColor)(/^[0-9a-f]{6}$/i.test(color) ? `#${color}` : color).toString("hex").replace(/^#/, "").toUpperCase();
                } catch  {
                    continue;
                }
                else item.Text["Source Text"] = value == null ? "" : String(value);
            } else fillGroupedFields(item);
        }
    };
    fillGroupedFields(cloned);
    return cloned;
};
const $6ce48bb9bd75930a$export$537fb84b8adc78c7 = (images, fileName, texts)=>{
    return new Promise((resolve, reject)=>{
        if ((!images || images.length === 0) && (!texts || texts.length === 0)) return resolve("No data to download");
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($lCqUR)))();
        const validImages = (images ?? []).filter(Boolean);
        const imagePromises = validImages.map((image, index)=>{
            if (image.blob) {
                zip.file(`${image.name ?? `image_${index + 1}`}.png`, image.blob);
                return Promise.resolve();
            }
            return $6ce48bb9bd75930a$export$a3dbe8c0b0742d4e(image).then(({ image: img, blob: blob })=>{
                zip.file(`${img.name ?? `image_${index + 1}`}.${img.format}`, blob);
            }).catch((error)=>{
                console.error(`Error downloading image ${index + 1}:`, error);
                throw error;
            });
        });
        Promise.all(imagePromises).then(()=>{
            if (texts?.length) for (const { name: name, data: data } of texts)zip.file(`${name}.json`, JSON.stringify(data, null, 2));
            return zip.generateAsync({
                type: "blob"
            });
        }).then((content)=>{
            $6ce48bb9bd75930a$export$bb3b75778e3e272(content, `${fileName}.zip` ?? "images.zip", "application/zip");
            resolve("Images downloaded successfully");
        }).catch((error)=>{
            reject(`Error generating zip file: ${error}`);
        });
    });
};

});
parcelRegister("lCqUR", function(module, exports) {
/*!

JSZip v3.10.2 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $1S3Wg = parcelRequire("1S3Wg");
var $fbd20696278e0f7f$require$Buffer = $1S3Wg.Buffer;

var $236eG = parcelRequire("236eG");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.2", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $fbd20696278e0f7f$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($fbd20696278e0f7f$require$Buffer.from && $fbd20696278e0f7f$require$Buffer.from !== Uint8Array.from) return $fbd20696278e0f7f$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $fbd20696278e0f7f$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($fbd20696278e0f7f$require$Buffer.alloc) return $fbd20696278e0f7f$require$Buffer.alloc(e);
                        var t = new $fbd20696278e0f7f$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $fbd20696278e0f7f$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $fbd20696278e0f7f$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $fbd20696278e0f7f$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    if ("string" == typeof e) return "string";
                    var t = Object.prototype.toString.call(e);
                    return "[object Array]" === t ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && "[object Uint8Array]" === t ? "uint8array" : o.arraybuffer && "[object ArrayBuffer]" === t ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) ? void 0 !== Blob.prototype.arrayBuffer ? n.arrayBuffer() : "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : u.Promise.reject(new Error(r + " is a Blob, but we have no way of reading it.")) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $236eG.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("1S3Wg", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $15cde3bafeb140c6$export$a143d493d941bafc, (v) => $15cde3bafeb140c6$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $15cde3bafeb140c6$export$f99ded8fe4b79145, (v) => $15cde3bafeb140c6$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $15cde3bafeb140c6$export$a143d493d941bafc;
var $15cde3bafeb140c6$export$e4cf37d7f6fb9e0a;
var $15cde3bafeb140c6$export$f99ded8fe4b79145;
var $15cde3bafeb140c6$export$599f31c3813fae4d;
'use strict';

var $gbgLa = parcelRequire("gbgLa");

var $7nSqb = parcelRequire("7nSqb");
var $15cde3bafeb140c6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$15cde3bafeb140c6$export$a143d493d941bafc = $15cde3bafeb140c6$var$Buffer;
$15cde3bafeb140c6$export$e4cf37d7f6fb9e0a = $15cde3bafeb140c6$var$SlowBuffer;
$15cde3bafeb140c6$export$f99ded8fe4b79145 = 50;
var $15cde3bafeb140c6$var$K_MAX_LENGTH = 0x7fffffff;
$15cde3bafeb140c6$export$599f31c3813fae4d = $15cde3bafeb140c6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $15cde3bafeb140c6$var$Buffer.TYPED_ARRAY_SUPPORT = $15cde3bafeb140c6$var$typedArraySupport();
if (!$15cde3bafeb140c6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $15cde3bafeb140c6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($15cde3bafeb140c6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$15cde3bafeb140c6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($15cde3bafeb140c6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$15cde3bafeb140c6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $15cde3bafeb140c6$var$createBuffer(length) {
    if (length > $15cde3bafeb140c6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $15cde3bafeb140c6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $15cde3bafeb140c6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $15cde3bafeb140c6$var$allocUnsafe(arg);
    }
    return $15cde3bafeb140c6$var$from(arg, encodingOrOffset, length);
}
$15cde3bafeb140c6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $15cde3bafeb140c6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $15cde3bafeb140c6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $15cde3bafeb140c6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($15cde3bafeb140c6$var$isInstance(value, ArrayBuffer) || value && $15cde3bafeb140c6$var$isInstance(value.buffer, ArrayBuffer)) return $15cde3bafeb140c6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($15cde3bafeb140c6$var$isInstance(value, SharedArrayBuffer) || value && $15cde3bafeb140c6$var$isInstance(value.buffer, SharedArrayBuffer))) return $15cde3bafeb140c6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $15cde3bafeb140c6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $15cde3bafeb140c6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $15cde3bafeb140c6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $15cde3bafeb140c6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $15cde3bafeb140c6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($15cde3bafeb140c6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($15cde3bafeb140c6$var$Buffer, Uint8Array);
function $15cde3bafeb140c6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $15cde3bafeb140c6$var$alloc(size, fill, encoding) {
    $15cde3bafeb140c6$var$assertSize(size);
    if (size <= 0) return $15cde3bafeb140c6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $15cde3bafeb140c6$var$createBuffer(size).fill(fill, encoding) : $15cde3bafeb140c6$var$createBuffer(size).fill(fill);
    return $15cde3bafeb140c6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $15cde3bafeb140c6$var$Buffer.alloc = function(size, fill, encoding) {
    return $15cde3bafeb140c6$var$alloc(size, fill, encoding);
};
function $15cde3bafeb140c6$var$allocUnsafe(size) {
    $15cde3bafeb140c6$var$assertSize(size);
    return $15cde3bafeb140c6$var$createBuffer(size < 0 ? 0 : $15cde3bafeb140c6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $15cde3bafeb140c6$var$Buffer.allocUnsafe = function(size) {
    return $15cde3bafeb140c6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $15cde3bafeb140c6$var$Buffer.allocUnsafeSlow = function(size) {
    return $15cde3bafeb140c6$var$allocUnsafe(size);
};
function $15cde3bafeb140c6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$15cde3bafeb140c6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $15cde3bafeb140c6$var$byteLength(string, encoding) | 0;
    var buf = $15cde3bafeb140c6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $15cde3bafeb140c6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $15cde3bafeb140c6$var$checked(array.length) | 0;
    var buf = $15cde3bafeb140c6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $15cde3bafeb140c6$var$fromArrayView(arrayView) {
    if ($15cde3bafeb140c6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $15cde3bafeb140c6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $15cde3bafeb140c6$var$fromArrayLike(arrayView);
}
function $15cde3bafeb140c6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $15cde3bafeb140c6$var$Buffer.prototype);
    return buf;
}
function $15cde3bafeb140c6$var$fromObject(obj) {
    if ($15cde3bafeb140c6$var$Buffer.isBuffer(obj)) {
        var len = $15cde3bafeb140c6$var$checked(obj.length) | 0;
        var buf = $15cde3bafeb140c6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $15cde3bafeb140c6$var$numberIsNaN(obj.length)) return $15cde3bafeb140c6$var$createBuffer(0);
        return $15cde3bafeb140c6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $15cde3bafeb140c6$var$fromArrayLike(obj.data);
}
function $15cde3bafeb140c6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $15cde3bafeb140c6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $15cde3bafeb140c6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $15cde3bafeb140c6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $15cde3bafeb140c6$var$Buffer.alloc(+length);
}
$15cde3bafeb140c6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $15cde3bafeb140c6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$15cde3bafeb140c6$var$Buffer.compare = function compare(a, b) {
    if ($15cde3bafeb140c6$var$isInstance(a, Uint8Array)) a = $15cde3bafeb140c6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($15cde3bafeb140c6$var$isInstance(b, Uint8Array)) b = $15cde3bafeb140c6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$15cde3bafeb140c6$var$Buffer.isBuffer(a) || !$15cde3bafeb140c6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$15cde3bafeb140c6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$15cde3bafeb140c6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $15cde3bafeb140c6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $15cde3bafeb140c6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($15cde3bafeb140c6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $15cde3bafeb140c6$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$15cde3bafeb140c6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $15cde3bafeb140c6$var$byteLength(string, encoding) {
    if ($15cde3bafeb140c6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $15cde3bafeb140c6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $15cde3bafeb140c6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $15cde3bafeb140c6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $15cde3bafeb140c6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$15cde3bafeb140c6$var$Buffer.byteLength = $15cde3bafeb140c6$var$byteLength;
function $15cde3bafeb140c6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $15cde3bafeb140c6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $15cde3bafeb140c6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $15cde3bafeb140c6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $15cde3bafeb140c6$var$latin1Slice(this, start, end);
        case 'base64':
            return $15cde3bafeb140c6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $15cde3bafeb140c6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$15cde3bafeb140c6$var$Buffer.prototype._isBuffer = true;
function $15cde3bafeb140c6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$15cde3bafeb140c6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$15cde3bafeb140c6$var$swap(this, i, i + 1);
    return this;
};
$15cde3bafeb140c6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $15cde3bafeb140c6$var$swap(this, i, i + 3);
        $15cde3bafeb140c6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$15cde3bafeb140c6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $15cde3bafeb140c6$var$swap(this, i, i + 7);
        $15cde3bafeb140c6$var$swap(this, i + 1, i + 6);
        $15cde3bafeb140c6$var$swap(this, i + 2, i + 5);
        $15cde3bafeb140c6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$15cde3bafeb140c6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $15cde3bafeb140c6$var$utf8Slice(this, 0, length);
    return $15cde3bafeb140c6$var$slowToString.apply(this, arguments);
};
$15cde3bafeb140c6$var$Buffer.prototype.toLocaleString = $15cde3bafeb140c6$var$Buffer.prototype.toString;
$15cde3bafeb140c6$var$Buffer.prototype.equals = function equals(b) {
    if (!$15cde3bafeb140c6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $15cde3bafeb140c6$var$Buffer.compare(this, b) === 0;
};
$15cde3bafeb140c6$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $15cde3bafeb140c6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($15cde3bafeb140c6$var$customInspectSymbol) $15cde3bafeb140c6$var$Buffer.prototype[$15cde3bafeb140c6$var$customInspectSymbol] = $15cde3bafeb140c6$var$Buffer.prototype.inspect;
$15cde3bafeb140c6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($15cde3bafeb140c6$var$isInstance(target, Uint8Array)) target = $15cde3bafeb140c6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$15cde3bafeb140c6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $15cde3bafeb140c6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($15cde3bafeb140c6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $15cde3bafeb140c6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($15cde3bafeb140c6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $15cde3bafeb140c6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $15cde3bafeb140c6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $15cde3bafeb140c6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$15cde3bafeb140c6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$15cde3bafeb140c6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $15cde3bafeb140c6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$15cde3bafeb140c6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $15cde3bafeb140c6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $15cde3bafeb140c6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($15cde3bafeb140c6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $15cde3bafeb140c6$var$utf8Write(buf, string, offset, length) {
    return $15cde3bafeb140c6$var$blitBuffer($15cde3bafeb140c6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $15cde3bafeb140c6$var$asciiWrite(buf, string, offset, length) {
    return $15cde3bafeb140c6$var$blitBuffer($15cde3bafeb140c6$var$asciiToBytes(string), buf, offset, length);
}
function $15cde3bafeb140c6$var$base64Write(buf, string, offset, length) {
    return $15cde3bafeb140c6$var$blitBuffer($15cde3bafeb140c6$var$base64ToBytes(string), buf, offset, length);
}
function $15cde3bafeb140c6$var$ucs2Write(buf, string, offset, length) {
    return $15cde3bafeb140c6$var$blitBuffer($15cde3bafeb140c6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$15cde3bafeb140c6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $15cde3bafeb140c6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $15cde3bafeb140c6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $15cde3bafeb140c6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $15cde3bafeb140c6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $15cde3bafeb140c6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$15cde3bafeb140c6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $15cde3bafeb140c6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gbgLa.fromByteArray(buf);
    else return $gbgLa.fromByteArray(buf.slice(start, end));
}
function $15cde3bafeb140c6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $15cde3bafeb140c6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $15cde3bafeb140c6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $15cde3bafeb140c6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $15cde3bafeb140c6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $15cde3bafeb140c6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $15cde3bafeb140c6$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $15cde3bafeb140c6$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $15cde3bafeb140c6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $15cde3bafeb140c6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $15cde3bafeb140c6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$15cde3bafeb140c6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $15cde3bafeb140c6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $15cde3bafeb140c6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$15cde3bafeb140c6$var$Buffer.prototype.readUintLE = $15cde3bafeb140c6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$15cde3bafeb140c6$var$Buffer.prototype.readUintBE = $15cde3bafeb140c6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$15cde3bafeb140c6$var$Buffer.prototype.readUint8 = $15cde3bafeb140c6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$15cde3bafeb140c6$var$Buffer.prototype.readUint16LE = $15cde3bafeb140c6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$15cde3bafeb140c6$var$Buffer.prototype.readUint16BE = $15cde3bafeb140c6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$15cde3bafeb140c6$var$Buffer.prototype.readUint32LE = $15cde3bafeb140c6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$15cde3bafeb140c6$var$Buffer.prototype.readUint32BE = $15cde3bafeb140c6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$15cde3bafeb140c6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$15cde3bafeb140c6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$15cde3bafeb140c6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$15cde3bafeb140c6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$15cde3bafeb140c6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$15cde3bafeb140c6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$15cde3bafeb140c6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$15cde3bafeb140c6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 4, this.length);
    return $7nSqb.read(this, offset, true, 23, 4);
};
$15cde3bafeb140c6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 4, this.length);
    return $7nSqb.read(this, offset, false, 23, 4);
};
$15cde3bafeb140c6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 8, this.length);
    return $7nSqb.read(this, offset, true, 52, 8);
};
$15cde3bafeb140c6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkOffset(offset, 8, this.length);
    return $7nSqb.read(this, offset, false, 52, 8);
};
function $15cde3bafeb140c6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$15cde3bafeb140c6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$15cde3bafeb140c6$var$Buffer.prototype.writeUintLE = $15cde3bafeb140c6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $15cde3bafeb140c6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeUintBE = $15cde3bafeb140c6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $15cde3bafeb140c6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeUint8 = $15cde3bafeb140c6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeUint16LE = $15cde3bafeb140c6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeUint16BE = $15cde3bafeb140c6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeUint32LE = $15cde3bafeb140c6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeUint32BE = $15cde3bafeb140c6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $15cde3bafeb140c6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $15cde3bafeb140c6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$15cde3bafeb140c6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $15cde3bafeb140c6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $15cde3bafeb140c6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7nSqb.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$15cde3bafeb140c6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $15cde3bafeb140c6$var$writeFloat(this, value, offset, true, noAssert);
};
$15cde3bafeb140c6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $15cde3bafeb140c6$var$writeFloat(this, value, offset, false, noAssert);
};
function $15cde3bafeb140c6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $15cde3bafeb140c6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7nSqb.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$15cde3bafeb140c6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $15cde3bafeb140c6$var$writeDouble(this, value, offset, true, noAssert);
};
$15cde3bafeb140c6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $15cde3bafeb140c6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$15cde3bafeb140c6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$15cde3bafeb140c6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$15cde3bafeb140c6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$15cde3bafeb140c6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $15cde3bafeb140c6$var$Buffer.isBuffer(val) ? val : $15cde3bafeb140c6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $15cde3bafeb140c6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $15cde3bafeb140c6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($15cde3bafeb140c6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $15cde3bafeb140c6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $15cde3bafeb140c6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $15cde3bafeb140c6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $15cde3bafeb140c6$var$base64ToBytes(str) {
    return $gbgLa.toByteArray($15cde3bafeb140c6$var$base64clean(str));
}
function $15cde3bafeb140c6$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $15cde3bafeb140c6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $15cde3bafeb140c6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $15cde3bafeb140c6$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("gbgLa", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $bc7aac9306e012cb$export$d622b2ad8d90c771, (v) => $bc7aac9306e012cb$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $bc7aac9306e012cb$export$6100ba28696e12de, (v) => $bc7aac9306e012cb$export$6100ba28696e12de = v);
var $bc7aac9306e012cb$export$a48f0734ac7c2329;
var $bc7aac9306e012cb$export$d622b2ad8d90c771;
var $bc7aac9306e012cb$export$6100ba28696e12de;
'use strict';
$bc7aac9306e012cb$export$a48f0734ac7c2329 = $bc7aac9306e012cb$var$byteLength;
$bc7aac9306e012cb$export$d622b2ad8d90c771 = $bc7aac9306e012cb$var$toByteArray;
$bc7aac9306e012cb$export$6100ba28696e12de = $bc7aac9306e012cb$var$fromByteArray;
var $bc7aac9306e012cb$var$lookup = [];
var $bc7aac9306e012cb$var$revLookup = [];
var $bc7aac9306e012cb$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bc7aac9306e012cb$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bc7aac9306e012cb$var$i = 0, $bc7aac9306e012cb$var$len = $bc7aac9306e012cb$var$code.length; $bc7aac9306e012cb$var$i < $bc7aac9306e012cb$var$len; ++$bc7aac9306e012cb$var$i){
    $bc7aac9306e012cb$var$lookup[$bc7aac9306e012cb$var$i] = $bc7aac9306e012cb$var$code[$bc7aac9306e012cb$var$i];
    $bc7aac9306e012cb$var$revLookup[$bc7aac9306e012cb$var$code.charCodeAt($bc7aac9306e012cb$var$i)] = $bc7aac9306e012cb$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bc7aac9306e012cb$var$revLookup['-'.charCodeAt(0)] = 62;
$bc7aac9306e012cb$var$revLookup['_'.charCodeAt(0)] = 63;
function $bc7aac9306e012cb$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bc7aac9306e012cb$var$byteLength(b64) {
    var lens = $bc7aac9306e012cb$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bc7aac9306e012cb$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bc7aac9306e012cb$var$toByteArray(b64) {
    var tmp;
    var lens = $bc7aac9306e012cb$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bc7aac9306e012cb$var$Arr($bc7aac9306e012cb$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i)] << 18 | $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i)] << 2 | $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i)] << 10 | $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bc7aac9306e012cb$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bc7aac9306e012cb$var$tripletToBase64(num) {
    return $bc7aac9306e012cb$var$lookup[num >> 18 & 0x3F] + $bc7aac9306e012cb$var$lookup[num >> 12 & 0x3F] + $bc7aac9306e012cb$var$lookup[num >> 6 & 0x3F] + $bc7aac9306e012cb$var$lookup[num & 0x3F];
}
function $bc7aac9306e012cb$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bc7aac9306e012cb$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bc7aac9306e012cb$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bc7aac9306e012cb$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bc7aac9306e012cb$var$lookup[tmp >> 2] + $bc7aac9306e012cb$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bc7aac9306e012cb$var$lookup[tmp >> 10] + $bc7aac9306e012cb$var$lookup[tmp >> 4 & 0x3F] + $bc7aac9306e012cb$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7nSqb", function(module, exports) {

$parcel$export(module.exports, "read", () => $5604e555c2cd23cf$export$aafa59e2e03f2942, (v) => $5604e555c2cd23cf$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $5604e555c2cd23cf$export$68d8715fc104d294, (v) => $5604e555c2cd23cf$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5604e555c2cd23cf$export$aafa59e2e03f2942;
var $5604e555c2cd23cf$export$68d8715fc104d294;
$5604e555c2cd23cf$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5604e555c2cd23cf$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("236eG", function(module, exports) {
// shim for using process in browser
var $17e0b2e6f3aa52e6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $17e0b2e6f3aa52e6$var$cachedSetTimeout;
var $17e0b2e6f3aa52e6$var$cachedClearTimeout;
function $17e0b2e6f3aa52e6$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $17e0b2e6f3aa52e6$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $17e0b2e6f3aa52e6$var$cachedSetTimeout = setTimeout;
        else $17e0b2e6f3aa52e6$var$cachedSetTimeout = $17e0b2e6f3aa52e6$var$defaultSetTimout;
    } catch (e) {
        $17e0b2e6f3aa52e6$var$cachedSetTimeout = $17e0b2e6f3aa52e6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $17e0b2e6f3aa52e6$var$cachedClearTimeout = clearTimeout;
        else $17e0b2e6f3aa52e6$var$cachedClearTimeout = $17e0b2e6f3aa52e6$var$defaultClearTimeout;
    } catch (e) {
        $17e0b2e6f3aa52e6$var$cachedClearTimeout = $17e0b2e6f3aa52e6$var$defaultClearTimeout;
    }
})();
function $17e0b2e6f3aa52e6$var$runTimeout(fun) {
    if ($17e0b2e6f3aa52e6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($17e0b2e6f3aa52e6$var$cachedSetTimeout === $17e0b2e6f3aa52e6$var$defaultSetTimout || !$17e0b2e6f3aa52e6$var$cachedSetTimeout) && setTimeout) {
        $17e0b2e6f3aa52e6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $17e0b2e6f3aa52e6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $17e0b2e6f3aa52e6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $17e0b2e6f3aa52e6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $17e0b2e6f3aa52e6$var$runClearTimeout(marker) {
    if ($17e0b2e6f3aa52e6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($17e0b2e6f3aa52e6$var$cachedClearTimeout === $17e0b2e6f3aa52e6$var$defaultClearTimeout || !$17e0b2e6f3aa52e6$var$cachedClearTimeout) && clearTimeout) {
        $17e0b2e6f3aa52e6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $17e0b2e6f3aa52e6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $17e0b2e6f3aa52e6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $17e0b2e6f3aa52e6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $17e0b2e6f3aa52e6$var$queue = [];
var $17e0b2e6f3aa52e6$var$draining = false;
var $17e0b2e6f3aa52e6$var$currentQueue;
var $17e0b2e6f3aa52e6$var$queueIndex = -1;
function $17e0b2e6f3aa52e6$var$cleanUpNextTick() {
    if (!$17e0b2e6f3aa52e6$var$draining || !$17e0b2e6f3aa52e6$var$currentQueue) return;
    $17e0b2e6f3aa52e6$var$draining = false;
    if ($17e0b2e6f3aa52e6$var$currentQueue.length) $17e0b2e6f3aa52e6$var$queue = $17e0b2e6f3aa52e6$var$currentQueue.concat($17e0b2e6f3aa52e6$var$queue);
    else $17e0b2e6f3aa52e6$var$queueIndex = -1;
    if ($17e0b2e6f3aa52e6$var$queue.length) $17e0b2e6f3aa52e6$var$drainQueue();
}
function $17e0b2e6f3aa52e6$var$drainQueue() {
    if ($17e0b2e6f3aa52e6$var$draining) return;
    var timeout = $17e0b2e6f3aa52e6$var$runTimeout($17e0b2e6f3aa52e6$var$cleanUpNextTick);
    $17e0b2e6f3aa52e6$var$draining = true;
    var len = $17e0b2e6f3aa52e6$var$queue.length;
    while(len){
        $17e0b2e6f3aa52e6$var$currentQueue = $17e0b2e6f3aa52e6$var$queue;
        $17e0b2e6f3aa52e6$var$queue = [];
        while(++$17e0b2e6f3aa52e6$var$queueIndex < len)if ($17e0b2e6f3aa52e6$var$currentQueue) $17e0b2e6f3aa52e6$var$currentQueue[$17e0b2e6f3aa52e6$var$queueIndex].run();
        $17e0b2e6f3aa52e6$var$queueIndex = -1;
        len = $17e0b2e6f3aa52e6$var$queue.length;
    }
    $17e0b2e6f3aa52e6$var$currentQueue = null;
    $17e0b2e6f3aa52e6$var$draining = false;
    $17e0b2e6f3aa52e6$var$runClearTimeout(timeout);
}
$17e0b2e6f3aa52e6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $17e0b2e6f3aa52e6$var$queue.push(new $17e0b2e6f3aa52e6$var$Item(fun, args));
    if ($17e0b2e6f3aa52e6$var$queue.length === 1 && !$17e0b2e6f3aa52e6$var$draining) $17e0b2e6f3aa52e6$var$runTimeout($17e0b2e6f3aa52e6$var$drainQueue);
};
// v8 likes predictible objects
function $17e0b2e6f3aa52e6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$17e0b2e6f3aa52e6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$17e0b2e6f3aa52e6$var$process.title = 'browser';
$17e0b2e6f3aa52e6$var$process.browser = true;
$17e0b2e6f3aa52e6$var$process.env = {};
$17e0b2e6f3aa52e6$var$process.argv = [];
$17e0b2e6f3aa52e6$var$process.version = ''; // empty string to avoid regexp issues
$17e0b2e6f3aa52e6$var$process.versions = {};
function $17e0b2e6f3aa52e6$var$noop() {}
$17e0b2e6f3aa52e6$var$process.on = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.addListener = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.once = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.off = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.removeListener = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.removeAllListeners = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.emit = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.prependListener = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.prependOnceListener = $17e0b2e6f3aa52e6$var$noop;
$17e0b2e6f3aa52e6$var$process.listeners = function(name) {
    return [];
};
$17e0b2e6f3aa52e6$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$17e0b2e6f3aa52e6$var$process.cwd = function() {
    return '/';
};
$17e0b2e6f3aa52e6$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$17e0b2e6f3aa52e6$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kQT4E", function(module, exports) {

$parcel$export(module.exports, "parseColor", () => $d463f98fb787de37$export$6e865ea70d7724f);

var $g8XbY = parcelRequire("g8XbY");

var $l6qeh = parcelRequire("l6qeh");

var $4EK5Y = parcelRequire("4EK5Y");
var $aLZXd = parcelRequire("aLZXd");

var $l3v5Z = parcelRequire("l3v5Z");
function $d463f98fb787de37$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d463f98fb787de37$var$$890783418b00a858$var$dictionary = new (0, $4EK5Y.LocalizedStringDictionary)($d463f98fb787de37$var$$parcel$interopDefault((0, $l6qeh.default)));
function $d463f98fb787de37$export$6e865ea70d7724f(value) {
    let res = $d463f98fb787de37$var$$890783418b00a858$var$RGBColor.parse(value) || $d463f98fb787de37$var$$890783418b00a858$var$HSBColor.parse(value) || $d463f98fb787de37$var$$890783418b00a858$var$HSLColor.parse(value);
    if (res) return res;
    throw new Error('Invalid color value: ' + value);
}
function $d463f98fb787de37$export$4cde5df63f53f473(v) {
    if (typeof v === 'string') return $d463f98fb787de37$export$6e865ea70d7724f(v);
    else return v;
}
function $d463f98fb787de37$export$1c0c08912582810c(colorSpace) {
    switch(colorSpace){
        case 'rgb':
            return $d463f98fb787de37$var$$890783418b00a858$var$RGBColor.colorChannels;
        case 'hsl':
            return $d463f98fb787de37$var$$890783418b00a858$var$HSLColor.colorChannels;
        case 'hsb':
            return $d463f98fb787de37$var$$890783418b00a858$var$HSBColor.colorChannels;
    }
}
function $d463f98fb787de37$export$87f5012e10bb20b2(hue) {
    if (hue === 360) return hue;
    return (hue % 360 + 360) % 360;
}
// Lightness threshold between orange and brown.
const $d463f98fb787de37$var$$890783418b00a858$var$ORANGE_LIGHTNESS_THRESHOLD = 0.68;
// Lightness threshold between pure yellow and "yellow green".
const $d463f98fb787de37$var$$890783418b00a858$var$YELLOW_GREEN_LIGHTNESS_THRESHOLD = 0.85;
// The maximum lightness considered to be "dark".
const $d463f98fb787de37$var$$890783418b00a858$var$MAX_DARK_LIGHTNESS = 0.55;
// The chroma threshold between gray and color.
const $d463f98fb787de37$var$$890783418b00a858$var$GRAY_THRESHOLD = 0.001;
const $d463f98fb787de37$var$$890783418b00a858$var$OKLCH_HUES = [
    [
        0,
        'pink'
    ],
    [
        15,
        'red'
    ],
    [
        48,
        'orange'
    ],
    [
        94,
        'yellow'
    ],
    [
        135,
        'green'
    ],
    [
        175,
        'cyan'
    ],
    [
        264,
        'blue'
    ],
    [
        284,
        'purple'
    ],
    [
        320,
        'magenta'
    ],
    [
        349,
        'pink'
    ]
];
class $d463f98fb787de37$var$$890783418b00a858$var$Color {
    toHexInt() {
        return this.toFormat('rgb').toHexInt();
    }
    getChannelValue(channel) {
        if (channel in this) return this[channel];
        throw new Error('Unsupported color channel: ' + channel);
    }
    withChannelValue(channel, value) {
        if (channel in this) {
            let x = this.clone();
            x[channel] = value;
            return x;
        }
        throw new Error('Unsupported color channel: ' + channel);
    }
    getChannelName(channel, locale) {
        let strings = (0, $4EK5Y.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/color') || $d463f98fb787de37$var$$890783418b00a858$var$dictionary;
        return strings.getStringForLocale(channel, locale);
    }
    getColorSpaceAxes(xyChannels) {
        let { xChannel: xChannel, yChannel: yChannel } = xyChannels;
        let xCh = xChannel || this.getColorChannels().find((c)=>c !== yChannel);
        let yCh = yChannel || this.getColorChannels().find((c)=>c !== xCh);
        let zCh = this.getColorChannels().find((c)=>c !== xCh && c !== yCh);
        return {
            xChannel: xCh,
            yChannel: yCh,
            zChannel: zCh
        };
    }
    getColorName(locale) {
        // Convert to oklch color space, which has perceptually uniform lightness across all hues.
        let [l, c, h] = $d463f98fb787de37$var$$890783418b00a858$var$toOKLCH(this);
        let strings = (0, $4EK5Y.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/color') || $d463f98fb787de37$var$$890783418b00a858$var$dictionary;
        if (l > 0.999) return strings.getStringForLocale('white', locale);
        if (l < 0.001) return strings.getStringForLocale('black', locale);
        let hue;
        [hue, l] = this.getOklchHue(l, c, h, locale);
        let lightness = '';
        let chroma = '';
        if (c <= 0.1 && c >= $d463f98fb787de37$var$$890783418b00a858$var$GRAY_THRESHOLD) {
            if (l >= 0.7) chroma = 'pale';
            else chroma = 'grayish';
        } else if (c >= 0.15) chroma = 'vibrant';
        if (l < 0.3) lightness = 'very dark';
        else if (l < $d463f98fb787de37$var$$890783418b00a858$var$MAX_DARK_LIGHTNESS) lightness = 'dark';
        else if (l < 0.7) ;
        else if (l < 0.85) lightness = 'light';
        else lightness = 'very light';
        if (chroma) chroma = strings.getStringForLocale(chroma, locale);
        if (lightness) lightness = strings.getStringForLocale(lightness, locale);
        let alpha = this.getChannelValue('alpha');
        let formatter = new (0, $aLZXd.LocalizedStringFormatter)(locale, strings);
        if (alpha < 1) {
            let percentTransparent = new (0, $l3v5Z.NumberFormatter)(locale, {
                style: 'percent'
            }).format(1 - alpha);
            return formatter.format('transparentColorName', {
                lightness: lightness,
                chroma: chroma,
                hue: hue,
                percentTransparent: percentTransparent
            }).replace(/\s+/g, ' ').trim();
        } else return formatter.format('colorName', {
            lightness: lightness,
            chroma: chroma,
            hue: hue
        }).replace(/\s+/g, ' ').trim();
    }
    getOklchHue(l, c, h, locale) {
        let strings = (0, $4EK5Y.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/color') || $d463f98fb787de37$var$$890783418b00a858$var$dictionary;
        if (c < $d463f98fb787de37$var$$890783418b00a858$var$GRAY_THRESHOLD) return [
            strings.getStringForLocale('gray', locale),
            l
        ];
        for(let i = 0; i < $d463f98fb787de37$var$$890783418b00a858$var$OKLCH_HUES.length; i++){
            let [hue, hueName] = $d463f98fb787de37$var$$890783418b00a858$var$OKLCH_HUES[i];
            let [nextHue, nextHueName] = $d463f98fb787de37$var$$890783418b00a858$var$OKLCH_HUES[i + 1] || [
                360,
                'pink'
            ];
            if (h >= hue && h < nextHue) {
                // Split orange hue into brown/orange depending on lightness.
                if (hueName === 'orange') {
                    if (l < $d463f98fb787de37$var$$890783418b00a858$var$ORANGE_LIGHTNESS_THRESHOLD) hueName = 'brown';
                    else l = l - $d463f98fb787de37$var$$890783418b00a858$var$ORANGE_LIGHTNESS_THRESHOLD + $d463f98fb787de37$var$$890783418b00a858$var$MAX_DARK_LIGHTNESS;
                }
                // If the hue is at least halfway to the next hue, add the next hue name as well.
                if (h > hue + (nextHue - hue) / 2 && hueName !== nextHueName) hueName = `${hueName} ${nextHueName}`;
                else if (hueName === 'yellow' && l < $d463f98fb787de37$var$$890783418b00a858$var$YELLOW_GREEN_LIGHTNESS_THRESHOLD) hueName = 'yellow green';
                let name = strings.getStringForLocale(hueName, locale).toLocaleLowerCase(locale);
                return [
                    name,
                    l
                ];
            }
        }
        throw new Error('Unexpected hue');
    }
    getHueName(locale) {
        let [l, c, h] = $d463f98fb787de37$var$$890783418b00a858$var$toOKLCH(this);
        let [name] = this.getOklchHue(l, c, h, locale);
        return name;
    }
}
class $d463f98fb787de37$var$$890783418b00a858$var$RGBColor extends $d463f98fb787de37$var$$890783418b00a858$var$Color {
    constructor(red, green, blue, alpha){
        super(), this.red = red, this.green = green, this.blue = blue, this.alpha = alpha;
    }
    static parse(value) {
        let colors = [];
        // matching #rgb, #rgba, #rrggbb, #rrggbbaa
        if (/^#[\da-f]+$/i.test(value) && [
            4,
            5,
            7,
            9
        ].includes(value.length)) {
            const values = (value.length < 6 ? value.replace(/[^#]/gi, '$&$&') : value).slice(1).split('');
            while(values.length > 0)colors.push(parseInt(values.splice(0, 2).join(''), 16));
            colors[3] = colors[3] !== undefined ? colors[3] / 255 : undefined;
        }
        // matching rgb(rrr, ggg, bbb), rgba(rrr, ggg, bbb, 0.a)
        const match = value.match(/^rgba?\((.*)\)$/);
        if (match?.[1]) {
            const parts = match[1].split(',').map((value)=>value.trim());
            // Number('') is 0 rather than NaN, so empty components need their own check.
            if (parts.some((part)=>part === '' || !Number.isFinite(Number(part)))) return undefined;
            colors = parts.map((part, i)=>{
                return (0, $g8XbY.clamp)(Number(part), 0, i < 3 ? 255 : 1);
            });
        }
        if (colors[0] === undefined || colors[1] === undefined || colors[2] === undefined) return undefined;
        return colors.length < 3 ? undefined : new $d463f98fb787de37$var$$890783418b00a858$var$RGBColor(colors[0], colors[1], colors[2], colors[3] ?? 1);
    }
    toString(format = 'css') {
        switch(format){
            case 'hex':
                return '#' + (this.red.toString(16).padStart(2, '0') + this.green.toString(16).padStart(2, '0') + this.blue.toString(16).padStart(2, '0')).toUpperCase();
            case 'hexa':
                return '#' + (this.red.toString(16).padStart(2, '0') + this.green.toString(16).padStart(2, '0') + this.blue.toString(16).padStart(2, '0') + Math.round(this.alpha * 255).toString(16).padStart(2, '0')).toUpperCase();
            case 'rgb':
                return `rgb(${this.red}, ${this.green}, ${this.blue})`;
            case 'css':
            case 'rgba':
                return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case 'hex':
            case 'hexa':
            case 'rgb':
            case 'rgba':
                return this;
            case 'hsb':
            case 'hsba':
                return this.toHSB();
            case 'hsl':
            case 'hsla':
                return this.toHSL();
            default:
                throw new Error('Unsupported color conversion: rgb -> ' + format);
        }
    }
    toHexInt() {
        return this.red << 16 | this.green << 8 | this.blue;
    }
    /**
   * Converts an RGB color value to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   *
   * @returns An HSBColor object.
   */ toHSB() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const brightness = Math.max(red, green, blue);
        const chroma = brightness - min;
        const saturation = brightness === 0 ? 0 : chroma / brightness;
        let hue = 0; // achromatic
        if (chroma !== 0) {
            switch(brightness){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new $d463f98fb787de37$var$$890783418b00a858$var$HSBColor((0, $g8XbY.toFixedNumber)(hue * 360, 2), (0, $g8XbY.toFixedNumber)(saturation * 100, 2), (0, $g8XbY.toFixedNumber)(brightness * 100, 2), this.alpha);
    }
    /**
   * Converts an RGB color value to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   *
   * @returns An HSLColor object.
   */ toHSL() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const max = Math.max(red, green, blue);
        const lightness = (max + min) / 2;
        const chroma = max - min;
        let hue;
        let saturation;
        if (chroma === 0) hue = saturation = 0; // achromatic
        else {
            saturation = chroma / (lightness < 0.5 ? max + min : 2 - max - min);
            switch(max){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                default:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new $d463f98fb787de37$var$$890783418b00a858$var$HSLColor((0, $g8XbY.toFixedNumber)(hue * 360, 2), (0, $g8XbY.toFixedNumber)(saturation * 100, 2), (0, $g8XbY.toFixedNumber)(lightness * 100, 2), this.alpha);
    }
    clone() {
        return new $d463f98fb787de37$var$$890783418b00a858$var$RGBColor(this.red, this.green, this.blue, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case 'red':
            case 'green':
            case 'blue':
                return {
                    minValue: 0x0,
                    maxValue: 0xff,
                    step: 0x1,
                    pageSize: 0x11
                };
            case 'alpha':
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case 'red':
            case 'green':
            case 'blue':
                return {
                    style: 'decimal'
                };
            case 'alpha':
                return {
                    style: 'percent'
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        return new (0, $l3v5Z.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return 'rgb';
    }
    static{
        this.colorChannels = [
            'red',
            'green',
            'blue'
        ];
    }
    getColorChannels() {
        return $d463f98fb787de37$var$$890783418b00a858$var$RGBColor.colorChannels;
    }
}
// X = <negative/positive number with/without decimal places>
// before/after a comma, 0 or more whitespaces are allowed
// - hsb(X, X%, X%)
// - hsba(X, X%, X%, X)
const $d463f98fb787de37$var$$890783418b00a858$var$HSB_REGEX = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class $d463f98fb787de37$var$$890783418b00a858$var$HSBColor extends $d463f98fb787de37$var$$890783418b00a858$var$Color {
    constructor(hue, saturation, brightness, alpha){
        super(), this.hue = hue, this.saturation = saturation, this.brightness = brightness, this.alpha = alpha;
    }
    static parse(value) {
        let m;
        if (m = value.match($d463f98fb787de37$var$$890783418b00a858$var$HSB_REGEX)) {
            const [h, s, b, a] = (m[1] ?? m[2]).split(',').map((n)=>Number(n.trim().replace('%', '')));
            return new $d463f98fb787de37$var$$890783418b00a858$var$HSBColor($d463f98fb787de37$export$87f5012e10bb20b2(h), (0, $g8XbY.clamp)(s, 0, 100), (0, $g8XbY.clamp)(b, 0, 100), (0, $g8XbY.clamp)(a ?? 1, 0, 1));
        }
    }
    toString(format = 'css') {
        switch(format){
            case 'css':
                return this.toHSL().toString('css');
            case 'hex':
                return this.toRGB().toString('hex');
            case 'hexa':
                return this.toRGB().toString('hexa');
            case 'hsb':
                return `hsb(${this.hue}, ${(0, $g8XbY.toFixedNumber)(this.saturation, 2)}%, ${(0, $g8XbY.toFixedNumber)(this.brightness, 2)}%)`;
            case 'hsba':
                return `hsba(${this.hue}, ${(0, $g8XbY.toFixedNumber)(this.saturation, 2)}%, ${(0, $g8XbY.toFixedNumber)(this.brightness, 2)}%, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case 'hsb':
            case 'hsba':
                return this;
            case 'hsl':
            case 'hsla':
                return this.toHSL();
            case 'rgb':
            case 'rgba':
                return this.toRGB();
            default:
                throw new Error('Unsupported color conversion: hsb -> ' + format);
        }
    }
    /**
   * Converts a HSB color to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
   *
   * @returns An HSLColor object.
   */ toHSL() {
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let lightness = brightness * (1 - saturation / 2);
        saturation = lightness === 0 || lightness === 1 ? 0 : (brightness - lightness) / Math.min(lightness, 1 - lightness);
        return new $d463f98fb787de37$var$$890783418b00a858$var$HSLColor((0, $g8XbY.toFixedNumber)(this.hue, 2), (0, $g8XbY.toFixedNumber)(saturation * 100, 2), (0, $g8XbY.toFixedNumber)(lightness * 100, 2), this.alpha);
    }
    /**
   * Converts a HSV color value to RGB. Conversion formula adapted from
   * https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
   *
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let fn = (n, k = (n + hue / 60) % 6)=>brightness - saturation * brightness * Math.max(Math.min(k, 4 - k, 1), 0);
        return new $d463f98fb787de37$var$$890783418b00a858$var$RGBColor(Math.round(fn(5) * 255), Math.round(fn(3) * 255), Math.round(fn(1) * 255), this.alpha);
    }
    clone() {
        return new $d463f98fb787de37$var$$890783418b00a858$var$HSBColor(this.hue, this.saturation, this.brightness, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case 'hue':
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case 'saturation':
            case 'brightness':
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case 'alpha':
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case 'hue':
                return {
                    style: 'unit',
                    unit: 'degree',
                    unitDisplay: 'narrow'
                };
            case 'saturation':
            case 'brightness':
            case 'alpha':
                return {
                    style: 'percent'
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        if (channel === 'saturation' || channel === 'brightness') value /= 100;
        return new (0, $l3v5Z.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return 'hsb';
    }
    static{
        this.colorChannels = [
            'hue',
            'saturation',
            'brightness'
        ];
    }
    getColorChannels() {
        return $d463f98fb787de37$var$$890783418b00a858$var$HSBColor.colorChannels;
    }
}
// X = <negative/positive number with/without decimal places>
// before/after a comma, 0 or more whitespaces are allowed
// - hsl(X, X%, X%)
// - hsla(X, X%, X%, X)
const $d463f98fb787de37$var$$890783418b00a858$var$HSL_REGEX = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
class $d463f98fb787de37$var$$890783418b00a858$var$HSLColor extends $d463f98fb787de37$var$$890783418b00a858$var$Color {
    constructor(hue, saturation, lightness, alpha){
        super(), this.hue = hue, this.saturation = saturation, this.lightness = lightness, this.alpha = alpha;
    }
    static parse(value) {
        let m;
        if (m = value.match($d463f98fb787de37$var$$890783418b00a858$var$HSL_REGEX)) {
            const [h, s, l, a] = (m[1] ?? m[2]).split(',').map((n)=>Number(n.trim().replace('%', '')));
            return new $d463f98fb787de37$var$$890783418b00a858$var$HSLColor($d463f98fb787de37$export$87f5012e10bb20b2(h), (0, $g8XbY.clamp)(s, 0, 100), (0, $g8XbY.clamp)(l, 0, 100), (0, $g8XbY.clamp)(a ?? 1, 0, 1));
        }
    }
    toString(format = 'css') {
        switch(format){
            case 'hex':
                return this.toRGB().toString('hex');
            case 'hexa':
                return this.toRGB().toString('hexa');
            case 'hsl':
                return `hsl(${this.hue}, ${(0, $g8XbY.toFixedNumber)(this.saturation, 2)}%, ${(0, $g8XbY.toFixedNumber)(this.lightness, 2)}%)`;
            case 'css':
            case 'hsla':
                return `hsla(${this.hue}, ${(0, $g8XbY.toFixedNumber)(this.saturation, 2)}%, ${(0, $g8XbY.toFixedNumber)(this.lightness, 2)}%, ${this.alpha})`;
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case 'hsl':
            case 'hsla':
                return this;
            case 'hsb':
            case 'hsba':
                return this.toHSB();
            case 'rgb':
            case 'rgba':
                return this.toRGB();
            default:
                throw new Error('Unsupported color conversion: hsl -> ' + format);
        }
    }
    /**
   * Converts a HSL color to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
   *
   * @returns An HSBColor object.
   */ toHSB() {
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let brightness = lightness + saturation * Math.min(lightness, 1 - lightness);
        saturation = brightness === 0 ? 0 : 2 * (1 - lightness / brightness);
        return new $d463f98fb787de37$var$$890783418b00a858$var$HSBColor((0, $g8XbY.toFixedNumber)(this.hue, 2), (0, $g8XbY.toFixedNumber)(saturation * 100, 2), (0, $g8XbY.toFixedNumber)(brightness * 100, 2), this.alpha);
    }
    /**
   * Converts a HSL color to RGB. Conversion formula adapted from
   * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
   *
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let a = saturation * Math.min(lightness, 1 - lightness);
        let fn = (n, k = (n + hue / 30) % 12)=>lightness - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return new $d463f98fb787de37$var$$890783418b00a858$var$RGBColor(Math.round(fn(0) * 255), Math.round(fn(8) * 255), Math.round(fn(4) * 255), this.alpha);
    }
    clone() {
        return new $d463f98fb787de37$var$$890783418b00a858$var$HSLColor(this.hue, this.saturation, this.lightness, this.alpha);
    }
    getChannelRange(channel) {
        switch(channel){
            case 'hue':
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case 'saturation':
            case 'lightness':
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case 'alpha':
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case 'hue':
                return {
                    style: 'unit',
                    unit: 'degree',
                    unitDisplay: 'narrow'
                };
            case 'saturation':
            case 'lightness':
            case 'alpha':
                return {
                    style: 'percent'
                };
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        if (channel === 'saturation' || channel === 'lightness') value /= 100;
        return new (0, $l3v5Z.NumberFormatter)(locale, options).format(value);
    }
    getColorSpace() {
        return 'hsl';
    }
    static{
        this.colorChannels = [
            'hue',
            'saturation',
            'lightness'
        ];
    }
    getColorChannels() {
        return $d463f98fb787de37$var$$890783418b00a858$var$HSLColor.colorChannels;
    }
}
// https://www.w3.org/TR/css-color-4/#color-conversion-code
function $d463f98fb787de37$var$$890783418b00a858$var$toOKLCH(color) {
    let rgb = color.toFormat('rgb');
    let red = rgb.getChannelValue('red') / 255;
    let green = rgb.getChannelValue('green') / 255;
    let blue = rgb.getChannelValue('blue') / 255;
    [red, green, blue] = $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB(red, green, blue);
    let [x, y, z] = $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB_to_XYZ(red, green, blue);
    let [l, a, b] = $d463f98fb787de37$var$$890783418b00a858$var$XYZ_to_OKLab(x, y, z);
    return $d463f98fb787de37$var$$890783418b00a858$var$OKLab_to_OKLCH(l, a, b);
}
function $d463f98fb787de37$var$$890783418b00a858$var$OKLab_to_OKLCH(l, a, b) {
    var hue = Math.atan2(b, a) * 180 / Math.PI;
    return [
        l,
        Math.sqrt(a ** 2 + b ** 2),
        hue >= 0 ? hue : hue + 360 // Hue, in degrees [0 to 360)
    ];
}
function $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB(r, g, b) {
    // convert an array of sRGB values
    // where in-gamut values are in the range [0 - 1]
    // to linear light (un-companded) form.
    // https://en.wikipedia.org/wiki/SRGB
    // Extended transfer function:
    // for negative values,  linear portion is extended on reflection of axis,
    // then reflected power function is used.
    return [
        $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB_component(r),
        $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB_component(g),
        $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB_component(b)
    ];
}
function $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB_component(val) {
    let sign = val < 0 ? -1 : 1;
    let abs = Math.abs(val);
    if (abs <= 0.04045) return val / 12.92;
    return sign * Math.pow((abs + 0.055) / 1.055, 2.4);
}
function $d463f98fb787de37$var$$890783418b00a858$var$lin_sRGB_to_XYZ(r, g, b) {
    // convert an array of linear-light sRGB values to CIE XYZ
    // using sRGB's own white, D65 (no chromatic adaptation)
    const M = [
        506752 / 1228815,
        87881 / 245763,
        12673 / 70218,
        87098 / 409605,
        175762 / 245763,
        12673 / 175545,
        7918 / 409605,
        87881 / 737289,
        1001167 / 1053270
    ];
    return $d463f98fb787de37$var$$890783418b00a858$var$multiplyMatrix(M, r, g, b);
}
function $d463f98fb787de37$var$$890783418b00a858$var$XYZ_to_OKLab(x, y, z) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        0.819022437996703,
        0.3619062600528904,
        -0.1288737815209879,
        0.0329836539323885,
        0.9292868615863434,
        0.0361446663506424,
        0.0481771893596242,
        0.2642395317527308,
        0.6335478284694309
    ];
    const LMStoOKLab = [
        0.210454268309314,
        0.7936177747023054,
        -0.0040720430116193,
        1.9779985324311684,
        -2.42859224204858,
        0.450593709617411,
        0.0259040424655478,
        0.7827717124575296,
        -0.8086757549230774
    ];
    let [a, b, c] = $d463f98fb787de37$var$$890783418b00a858$var$multiplyMatrix(XYZtoLMS, x, y, z);
    return $d463f98fb787de37$var$$890783418b00a858$var$multiplyMatrix(LMStoOKLab, Math.cbrt(a), Math.cbrt(b), Math.cbrt(c));
}
function $d463f98fb787de37$var$$890783418b00a858$var$multiplyMatrix(m, x, y, z) {
    let a = m[0] * x + m[1] * y + m[2] * z;
    let b = m[3] * x + m[4] * y + m[5] * z;
    let c = m[6] * x + m[7] * y + m[8] * z;
    return [
        a,
        b,
        c
    ];
}

});
parcelRegister("l6qeh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f69763d64df540e$export$2e2bcd8739ae039);

var $k9Ixz = parcelRequire("k9Ixz");

var $3EEen = parcelRequire("3EEen");

var $fGz9f = parcelRequire("fGz9f");

var $6OnhH = parcelRequire("6OnhH");

var $5gq1F = parcelRequire("5gq1F");

var $f8yOO = parcelRequire("f8yOO");

var $kudWV = parcelRequire("kudWV");

var $2t2Kq = parcelRequire("2t2Kq");

var $bSn32 = parcelRequire("bSn32");

var $3iCSt = parcelRequire("3iCSt");

var $lPrCl = parcelRequire("lPrCl");

var $6P9Rg = parcelRequire("6P9Rg");

var $ahUH3 = parcelRequire("ahUH3");

var $iPO6C = parcelRequire("iPO6C");

var $3blNM = parcelRequire("3blNM");

var $4nYXE = parcelRequire("4nYXE");

var $h5EZU = parcelRequire("h5EZU");

var $holYk = parcelRequire("holYk");

var $ivoBH = parcelRequire("ivoBH");

var $4GgHK = parcelRequire("4GgHK");

var $b5APv = parcelRequire("b5APv");

var $8BQO5 = parcelRequire("8BQO5");

var $h76e2 = parcelRequire("h76e2");

var $jO1pK = parcelRequire("jO1pK");

var $bEvBQ = parcelRequire("bEvBQ");

var $lWe8c = parcelRequire("lWe8c");

var $11LV1 = parcelRequire("11LV1");

var $5JGqD = parcelRequire("5JGqD");

var $dh1G3 = parcelRequire("dh1G3");

var $5fPSa = parcelRequire("5fPSa");

var $dqBVU = parcelRequire("dqBVU");

var $421bv = parcelRequire("421bv");

var $9d0LU = parcelRequire("9d0LU");

var $8b6lW = parcelRequire("8b6lW");
var $1f69763d64df540e$export$2e2bcd8739ae039 = {};
$1f69763d64df540e$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $k9Ixz.default),
    "bg-BG": (0, $3EEen.default),
    "cs-CZ": (0, $fGz9f.default),
    "da-DK": (0, $6OnhH.default),
    "de-DE": (0, $5gq1F.default),
    "el-GR": (0, $f8yOO.default),
    "en-US": (0, $kudWV.default),
    "es-ES": (0, $2t2Kq.default),
    "et-EE": (0, $bSn32.default),
    "fi-FI": (0, $3iCSt.default),
    "fr-FR": (0, $lPrCl.default),
    "he-IL": (0, $6P9Rg.default),
    "hr-HR": (0, $ahUH3.default),
    "hu-HU": (0, $iPO6C.default),
    "it-IT": (0, $3blNM.default),
    "ja-JP": (0, $4nYXE.default),
    "ko-KR": (0, $h5EZU.default),
    "lt-LT": (0, $holYk.default),
    "lv-LV": (0, $ivoBH.default),
    "nb-NO": (0, $4GgHK.default),
    "nl-NL": (0, $b5APv.default),
    "pl-PL": (0, $8BQO5.default),
    "pt-BR": (0, $h76e2.default),
    "pt-PT": (0, $jO1pK.default),
    "ro-RO": (0, $bEvBQ.default),
    "ru-RU": (0, $lWe8c.default),
    "sk-SK": (0, $11LV1.default),
    "sl-SI": (0, $5JGqD.default),
    "sr-SP": (0, $dh1G3.default),
    "sv-SE": (0, $5fPSa.default),
    "tr-TR": (0, $dqBVU.default),
    "uk-UA": (0, $421bv.default),
    "zh-CN": (0, $9d0LU.default),
    "zh-TW": (0, $8b6lW.default)
};

});
parcelRegister("k9Ixz", function(module, exports) {

$parcel$export(module.exports, "default", () => $96cdf945c31d9065$export$2e2bcd8739ae039);
var $96cdf945c31d9065$export$2e2bcd8739ae039 = {};
$96cdf945c31d9065$export$2e2bcd8739ae039 = {
    "alpha": `\u{623}\u{644}\u{641}\u{627}`,
    "black": `\u{623}\u{633}\u{648}\u{62F}`,
    "blue": `\u{623}\u{632}\u{631}\u{642}`,
    "blue purple": `\u{623}\u{631}\u{62C}\u{648}\u{627}\u{646}\u{64A} \u{645}\u{632}\u{631}\u{642}`,
    "brightness": `\u{627}\u{644}\u{633}\u{637}\u{648}\u{639}`,
    "brown": `\u{628}\u{646}\u{64A}`,
    "brown yellow": `\u{623}\u{635}\u{641}\u{631} \u{628}\u{646}\u{64A}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{633}\u{645}\u{627}\u{648}\u{64A}`,
    "cyan blue": `\u{623}\u{632}\u{631}\u{642} \u{633}\u{645}\u{627}\u{648}\u{64A}`,
    "dark": `\u{62F}\u{627}\u{643}\u{646}`,
    "gray": `\u{631}\u{645}\u{627}\u{62F}\u{64A}`,
    "grayish": `\u{645}\u{627}\u{626}\u{644} \u{644}\u{644}\u{631}\u{645}\u{627}\u{62F}\u{64A}`,
    "green": `\u{623}\u{62E}\u{636}\u{631}`,
    "green cyan": `\u{633}\u{645}\u{627}\u{648}\u{64A} \u{645}\u{62E}\u{636}\u{631}`,
    "hue": `\u{62F}\u{631}\u{62C}\u{629} \u{627}\u{644}\u{644}\u{648}\u{646}`,
    "light": `\u{641}\u{627}\u{62A}\u{62D}`,
    "lightness": `\u{627}\u{644}\u{625}\u{636}\u{627}\u{621}\u{629}`,
    "magenta": `\u{623}\u{631}\u{62C}\u{648}\u{627}\u{646}\u{64A}`,
    "magenta pink": `\u{623}\u{631}\u{62C}\u{648}\u{627}\u{646}\u{64A} \u{648}\u{631}\u{62F}\u{64A}`,
    "orange": `\u{628}\u{631}\u{62A}\u{642}\u{627}\u{644}\u{64A}`,
    "orange yellow": `\u{623}\u{635}\u{641}\u{631} \u{628}\u{631}\u{62A}\u{642}\u{627}\u{644}\u{64A}`,
    "pale": `\u{628}\u{627}\u{647}\u{62A}`,
    "pink": `\u{648}\u{631}\u{62F}\u{64A}`,
    "pink red": `\u{623}\u{62D}\u{645}\u{631} \u{648}\u{631}\u{62F}\u{64A}`,
    "purple": `\u{623}\u{631}\u{62C}\u{648}\u{627}\u{646}\u{64A}`,
    "purple magenta": `\u{628}\u{646}\u{641}\u{633}\u{62C}\u{64A}`,
    "red": `\u{623}\u{62D}\u{645}\u{631}`,
    "red orange": `\u{628}\u{631}\u{62A}\u{642}\u{627}\u{644}\u{64A} \u{645}\u{62D}\u{645}\u{631}`,
    "saturation": `\u{627}\u{644}\u{62A}\u{634}\u{628}\u{639}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{634}\u{641}\u{627}\u{641}`,
    "very dark": `\u{62F}\u{627}\u{643}\u{646} \u{62C}\u{62F}\u{64B}\u{627}`,
    "very light": `\u{641}\u{627}\u{62A}\u{62D} \u{62C}\u{62F}\u{64B}\u{627}`,
    "vibrant": `\u{633}\u{627}\u{637}\u{639}`,
    "white": `\u{623}\u{628}\u{64A}\u{636}`,
    "yellow": `\u{623}\u{635}\u{641}\u{631}`,
    "yellow green": `\u{623}\u{62E}\u{636}\u{631} \u{645}\u{635}\u{641}\u{631}`
};

});

parcelRegister("3EEen", function(module, exports) {

$parcel$export(module.exports, "default", () => $c78a98b81b2081a6$export$2e2bcd8739ae039);
var $c78a98b81b2081a6$export$2e2bcd8739ae039 = {};
$c78a98b81b2081a6$export$2e2bcd8739ae039 = {
    "alpha": `\u{410}\u{43B}\u{444}\u{430}`,
    "black": `\u{447}\u{435}\u{440}\u{43D}\u{43E}`,
    "blue": `\u{421}\u{438}\u{43D}\u{44C}\u{43E}`,
    "blue purple": `\u{441}\u{438}\u{43D}\u{44C}\u{43E} \u{43B}\u{438}\u{43B}\u{430}\u{432}\u{43E}`,
    "brightness": `\u{42F}\u{440}\u{43A}\u{43E}\u{441}\u{442}`,
    "brown": `\u{43A}\u{430}\u{444}\u{44F}\u{432}\u{43E}`,
    "brown yellow": `\u{43A}\u{430}\u{444}\u{44F}\u{432}\u{43E} \u{436}\u{44A}\u{43B}\u{442}\u{43E}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{446}\u{438}\u{430}\u{43D}`,
    "cyan blue": `\u{446}\u{438}\u{430}\u{43D} \u{441}\u{438}\u{43D}\u{44C}\u{43E}`,
    "dark": `\u{442}\u{44A}\u{43C}\u{43D}\u{43E}`,
    "gray": `\u{441}\u{438}\u{432}\u{43E}`,
    "grayish": `\u{441}\u{438}\u{432}\u{43A}\u{430}\u{432}`,
    "green": `\u{417}\u{435}\u{43B}\u{435}\u{43D}\u{43E}`,
    "green cyan": `\u{437}\u{435}\u{43B}\u{435}\u{43D} \u{446}\u{438}\u{430}\u{43D}`,
    "hue": `\u{41E}\u{442}\u{442}\u{435}\u{43D}\u{44A}\u{43A}`,
    "light": `\u{441}\u{432}\u{435}\u{442}\u{43B}\u{43E}`,
    "lightness": `\u{41B}\u{435}\u{43A}\u{43E}\u{442}\u{430}`,
    "magenta": `\u{43C}\u{430}\u{433}\u{435}\u{43D}\u{442}\u{430}`,
    "magenta pink": `\u{43C}\u{430}\u{433}\u{435}\u{43D}\u{442}\u{430} \u{440}\u{43E}\u{437}\u{43E}\u{432}\u{43E}`,
    "orange": `\u{43E}\u{440}\u{430}\u{43D}\u{436}\u{435}\u{432}\u{43E}`,
    "orange yellow": `\u{43E}\u{440}\u{430}\u{43D}\u{436}\u{435}\u{432}\u{43E} \u{436}\u{44A}\u{43B}\u{442}\u{43E}`,
    "pale": `\u{431}\u{43B}\u{435}\u{434}\u{43E}`,
    "pink": `\u{440}\u{43E}\u{437}\u{43E}\u{432}\u{43E}`,
    "pink red": `\u{440}\u{43E}\u{437}\u{43E}\u{432}\u{43E} \u{447}\u{435}\u{440}\u{432}\u{435}\u{43D}\u{43E}`,
    "purple": `\u{43B}\u{438}\u{43B}\u{430}\u{432}\u{43E}`,
    "purple magenta": `\u{43B}\u{438}\u{43B}\u{430}\u{432}\u{43E} \u{43C}\u{430}\u{433}\u{435}\u{43D}\u{442}\u{430}`,
    "red": `\u{427}\u{435}\u{440}\u{432}\u{435}\u{43D}\u{43E}`,
    "red orange": `\u{447}\u{435}\u{440}\u{432}\u{435}\u{43D} \u{43F}\u{43E}\u{440}\u{442}\u{43E}\u{43A}\u{430}\u{43B}`,
    "saturation": `\u{41D}\u{430}\u{441}\u{438}\u{442}\u{435}\u{43D}\u{43E}\u{441}\u{442}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{435}\u{43D}`,
    "very dark": `\u{43C}\u{43D}\u{43E}\u{433}\u{43E} \u{442}\u{44A}\u{43C}\u{43D}\u{43E}`,
    "very light": `\u{43C}\u{43D}\u{43E}\u{433}\u{43E} \u{441}\u{432}\u{435}\u{442}\u{43B}\u{43E}`,
    "vibrant": ` \u{44F}\u{440}\u{43A}\u{43E}`,
    "white": `\u{431}\u{44F}\u{43B}\u{43E}`,
    "yellow": `\u{436}\u{44A}\u{43B}\u{442}\u{43E}`,
    "yellow green": `\u{436}\u{44A}\u{43B}\u{442}\u{43E} \u{437}\u{435}\u{43B}\u{435}\u{43D}`
};

});

parcelRegister("fGz9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95b4954753d9773$export$2e2bcd8739ae039);
var $e95b4954753d9773$export$2e2bcd8739ae039 = {};
$e95b4954753d9773$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `\u{10D}ern\xe1`,
    "blue": `Modr\xe1`,
    "blue purple": `modrofialov\xe1`,
    "brightness": `Jas`,
    "brown": `hn\u{11B}d\xe1`,
    "brown yellow": `hn\u{11B}do\u{17E}lut\xe1`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `tyrkysov\xe1`,
    "cyan blue": `tyrkysovomodr\xe1`,
    "dark": `tmav\xe1`,
    "gray": `\u{161}ed\xe1`,
    "grayish": `na\u{161}edl\xe1`,
    "green": `Zelen\xe1`,
    "green cyan": `zelenotyrkysov\xe1`,
    "hue": `Odst\xedn`,
    "light": `sv\u{11B}tl\xe1`,
    "lightness": `Sv\u{11B}tlost`,
    "magenta": `purpurov\xe1`,
    "magenta pink": `purpurov\u{11B} r\u{16F}\u{17E}ov\xe1`,
    "orange": `oran\u{17E}ov\xe1`,
    "orange yellow": `oran\u{17E}ovo\u{17E}lut\xe1`,
    "pale": `bled\xe1`,
    "pink": `r\u{16F}\u{17E}ov\xe1`,
    "pink red": `r\u{16F}\u{17E}ovo\u{10D}erven\xe1`,
    "purple": `fialov\xe1`,
    "purple magenta": `fialov\u{11B} purpurov\xe1`,
    "red": `\u{10C}erven\xe1`,
    "red orange": `\u{10D}ervenooran\u{17E}ov\xe1`,
    "saturation": `Sytost`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} pr\u{16F}hledn\xe9`,
    "very dark": `velmi tmav\xe1`,
    "very light": `velmi sv\u{11B}tl\xe1`,
    "vibrant": `z\xe1\u{159}iv\xe1`,
    "white": `b\xedl\xe1`,
    "yellow": `\u{17E}lut\xe1`,
    "yellow green": `\u{17E}lutozelen\xe1`
};

});

parcelRegister("6OnhH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a89a8c9a717617f6$export$2e2bcd8739ae039);
var $a89a8c9a717617f6$export$2e2bcd8739ae039 = {};
$a89a8c9a717617f6$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `sort`,
    "blue": `Bl\xe5`,
    "blue purple": `bl\xe5lilla`,
    "brightness": `Lysstyrke`,
    "brown": `brun`,
    "brown yellow": `brungul`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cyan`,
    "cyan blue": `cyan bl\xe5`,
    "dark": `m\xf8rk`,
    "gray": `gr\xe5`,
    "grayish": `gr\xe5lig`,
    "green": `Gr\xf8n`,
    "green cyan": `gr\xf8n cyan`,
    "hue": `Tone`,
    "light": `lys`,
    "lightness": `Lyshed`,
    "magenta": `magenta`,
    "magenta pink": `magenta pink`,
    "orange": `orange`,
    "orange yellow": `orangegul`,
    "pale": `bleg`,
    "pink": `lyser\xf8d`,
    "pink red": `lyser\xf8dlig r\xf8d`,
    "purple": `lilla`,
    "purple magenta": `lilla magenta`,
    "red": `R\xf8d`,
    "red orange": `r\xf8dorange`,
    "saturation": `Farvem\xe6tning`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} gennemsigtig`,
    "very dark": `meget m\xf8rk`,
    "very light": `meget lys`,
    "vibrant": `klar`,
    "white": `hvid`,
    "yellow": `gul`,
    "yellow green": `gulgr\xf8n`
};

});

parcelRegister("5gq1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb57452811a4f0f2$export$2e2bcd8739ae039);
var $fb57452811a4f0f2$export$2e2bcd8739ae039 = {};
$fb57452811a4f0f2$export$2e2bcd8739ae039 = {
    "alpha": `Alpha`,
    "black": `Schwarz`,
    "blue": `Blau`,
    "blue purple": `Blaulila`,
    "brightness": `Helligkeit`,
    "brown": `Braun`,
    "brown yellow": `Braungelb`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `Cyan`,
    "cyan blue": `Cyanblau`,
    "dark": `dunkles`,
    "gray": `Grau`,
    "grayish": `gr\xe4uliches`,
    "green": `Gr\xfcn`,
    "green cyan": `Gr\xfcncyan`,
    "hue": `Farbton`,
    "light": `helles`,
    "lightness": `Leuchtkraft`,
    "magenta": `Magenta`,
    "magenta pink": `Magentarosa`,
    "orange": `Orange`,
    "orange yellow": `Orangegelb`,
    "pale": `blasses`,
    "pink": `Rosa`,
    "pink red": `Rosarot`,
    "purple": `Lila`,
    "purple magenta": `Lilamagenta`,
    "red": `Rot`,
    "red orange": `Rotorange`,
    "saturation": `S\xe4ttigung`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, zu ${args.percentTransparent} transparent`,
    "very dark": `sehr dunkles`,
    "very light": `sehr helles`,
    "vibrant": `lebhaftes`,
    "white": `Wei\xdf`,
    "yellow": `Gelb`,
    "yellow green": `Gelbgr\xfcn`
};

});

parcelRegister("f8yOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf7b35bd5cad6c6$export$2e2bcd8739ae039);
var $dbf7b35bd5cad6c6$export$2e2bcd8739ae039 = {};
$dbf7b35bd5cad6c6$export$2e2bcd8739ae039 = {
    "alpha": `\u{386}\u{3BB}\u{3C6}\u{3B1}`,
    "black": `\u{3BC}\u{3B1}\u{3CD}\u{3C1}\u{3BF}`,
    "blue": `\u{39C}\u{3C0}\u{3BB}\u{3B5}`,
    "blue purple": `\u{3BC}\u{3C0}\u{3BB}\u{3B5} \u{3BC}\u{3C9}\u{3B2}`,
    "brightness": `\u{3A6}\u{3C9}\u{3C4}\u{3B5}\u{3B9}\u{3BD}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "brown": `\u{3BA}\u{3B1}\u{3C6}\u{3AD}`,
    "brown yellow": `\u{3BA}\u{3B1}\u{3C6}\u{3AD} \u{3BA}\u{3AF}\u{3C4}\u{3C1}\u{3B9}\u{3BD}\u{3BF}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{3BA}\u{3C5}\u{3B1}\u{3BD}\u{3CC}`,
    "cyan blue": `\u{3BA}\u{3C5}\u{3B1}\u{3BD}\u{3CC} \u{3BC}\u{3C0}\u{3BB}\u{3B5}`,
    "dark": `\u{3C3}\u{3BA}\u{3BF}\u{3CD}\u{3C1}\u{3BF}`,
    "gray": `\u{3B3}\u{3BA}\u{3C1}\u{3B9}`,
    "grayish": `\u{3B3}\u{3BA}\u{3C1}\u{3B9}\u{3B6}\u{3C9}\u{3C0}\u{3CC}`,
    "green": `\u{3A0}\u{3C1}\u{3AC}\u{3C3}\u{3B9}\u{3BD}\u{3BF}`,
    "green cyan": `\u{3C0}\u{3C1}\u{3AC}\u{3C3}\u{3B9}\u{3BD}\u{3BF} \u{3BA}\u{3C5}\u{3B1}\u{3BD}\u{3CC}`,
    "hue": `\u{3A4}\u{3CC}\u{3BD}\u{3BF}\u{3C2}`,
    "light": `\u{3B1}\u{3BD}\u{3BF}\u{3B9}\u{3C7}\u{3C4}\u{3CC}`,
    "lightness": `\u{3A6}\u{3C9}\u{3C4}\u{3B5}\u{3B9}\u{3BD}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "magenta": `\u{3BC}\u{3B1}\u{3C4}\u{3B6}\u{3AD}\u{3BD}\u{3C4}\u{3B1}`,
    "magenta pink": `\u{3BC}\u{3B1}\u{3C4}\u{3B6}\u{3AD}\u{3BD}\u{3C4}\u{3B1} \u{3C1}\u{3BF}\u{3B6}`,
    "orange": `\u{3C0}\u{3BF}\u{3C1}\u{3C4}\u{3BF}\u{3BA}\u{3B1}\u{3BB}\u{3AF}`,
    "orange yellow": `\u{3C0}\u{3BF}\u{3C1}\u{3C4}\u{3BF}\u{3BA}\u{3B1}\u{3BB}\u{3AF} \u{3BA}\u{3AF}\u{3C4}\u{3C1}\u{3B9}\u{3BD}\u{3BF}`,
    "pale": `\u{3B1}\u{3BD}\u{3BF}\u{3B9}\u{3C7}\u{3C4}\u{3CC}`,
    "pink": `\u{3C1}\u{3BF}\u{3B6}`,
    "pink red": `\u{3C1}\u{3BF}\u{3B6} \u{3BA}\u{3CC}\u{3BA}\u{3BA}\u{3B9}\u{3BD}\u{3BF}`,
    "purple": `\u{3BC}\u{3C9}\u{3B2}`,
    "purple magenta": `\u{3BC}\u{3C9}\u{3B2} \u{3BC}\u{3B1}\u{3C4}\u{3B6}\u{3AD}\u{3BD}\u{3C4}\u{3B1}`,
    "red": `\u{39A}\u{3CC}\u{3BA}\u{3BA}\u{3B9}\u{3BD}\u{3BF}`,
    "red orange": `\u{3BA}\u{3CC}\u{3BA}\u{3BA}\u{3B9}\u{3BD}\u{3BF} \u{3C0}\u{3BF}\u{3C1}\u{3C4}\u{3BF}\u{3BA}\u{3B1}\u{3BB}\u{3AF}`,
    "saturation": `\u{39A}\u{3BF}\u{3C1}\u{3B5}\u{3C3}\u{3BC}\u{3CC}\u{3C2}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{3B4}\u{3B9}\u{3B1}\u{3C6}\u{3B1}\u{3BD}\u{3AD}\u{3C2}`,
    "very dark": `\u{3C0}\u{3BF}\u{3BB}\u{3CD} \u{3C3}\u{3BA}\u{3BF}\u{3CD}\u{3C1}\u{3BF}`,
    "very light": `\u{3C0}\u{3BF}\u{3BB}\u{3CD} \u{3B1}\u{3BD}\u{3BF}\u{3B9}\u{3C7}\u{3C4}\u{3CC}`,
    "vibrant": `\u{3AD}\u{3BD}\u{3C4}\u{3BF}\u{3BD}\u{3BF}`,
    "white": `\u{3BB}\u{3B5}\u{3C5}\u{3BA}\u{3CC}`,
    "yellow": `\u{3BA}\u{3AF}\u{3C4}\u{3C1}\u{3B9}\u{3BD}\u{3BF}`,
    "yellow green": `\u{3BA}\u{3AF}\u{3C4}\u{3C1}\u{3B9}\u{3BD}\u{3BF} \u{3C0}\u{3C1}\u{3AC}\u{3C3}\u{3B9}\u{3BD}\u{3BF}`
};

});

parcelRegister("kudWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fad83a524bd4d7cd$export$2e2bcd8739ae039);
var $fad83a524bd4d7cd$export$2e2bcd8739ae039 = {};
$fad83a524bd4d7cd$export$2e2bcd8739ae039 = {
    "hue": `Hue`,
    "saturation": `Saturation`,
    "lightness": `Lightness`,
    "brightness": `Brightness`,
    "red": `Red`,
    "green": `Green`,
    "blue": `Blue`,
    "alpha": `Alpha`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparent`,
    "very dark": `very dark`,
    "dark": `dark`,
    "light": `light`,
    "very light": `very light`,
    "pale": `pale`,
    "grayish": `grayish`,
    "vibrant": `vibrant`,
    "black": `black`,
    "white": `white`,
    "gray": `gray`,
    "pink": `pink`,
    "pink red": `pink red`,
    "red orange": `red orange`,
    "brown": `brown`,
    "orange": `orange`,
    "orange yellow": `orange yellow`,
    "brown yellow": `brown yellow`,
    "yellow": `yellow`,
    "yellow green": `yellow green`,
    "green cyan": `green cyan`,
    "cyan": `cyan`,
    "cyan blue": `cyan blue`,
    "blue purple": `blue purple`,
    "purple": `purple`,
    "purple magenta": `purple magenta`,
    "magenta": `magenta`,
    "magenta pink": `magenta pink`
};

});

parcelRegister("2t2Kq", function(module, exports) {

$parcel$export(module.exports, "default", () => $97516a676db08127$export$2e2bcd8739ae039);
var $97516a676db08127$export$2e2bcd8739ae039 = {};
$97516a676db08127$export$2e2bcd8739ae039 = {
    "alpha": `Alpha`,
    "black": `negro`,
    "blue": `Azul`,
    "blue purple": `p\xfarpura azulado`,
    "brightness": `Brillo`,
    "brown": `marr\xf3n`,
    "brown yellow": `amarillo amarronado`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cian`,
    "cyan blue": `azul cian`,
    "dark": `oscuro`,
    "gray": `gris`,
    "grayish": `gris\xe1ceo`,
    "green": `Verde`,
    "green cyan": `cian verdoso`,
    "hue": `Tono`,
    "light": `claro`,
    "lightness": `Luminosidad`,
    "magenta": `magenta`,
    "magenta pink": `rosa magenta`,
    "orange": `naranja`,
    "orange yellow": `amarillo anaranjado`,
    "pale": `p\xe1lido`,
    "pink": `rosa`,
    "pink red": `rojo rosado`,
    "purple": `morado`,
    "purple magenta": `magenta viol\xe1ceo`,
    "red": `Rojo`,
    "red orange": `naranja rojizo`,
    "saturation": `Saturaci\xf3n`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparente`,
    "very dark": `muy oscuro`,
    "very light": `muy claro`,
    "vibrant": `intenso`,
    "white": `blanco`,
    "yellow": `amarillo`,
    "yellow green": `verde amarillento`
};

});

parcelRegister("bSn32", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ebecb780fc8731$export$2e2bcd8739ae039);
var $38ebecb780fc8731$export$2e2bcd8739ae039 = {};
$38ebecb780fc8731$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `must`,
    "blue": `Sinine`,
    "blue purple": `sinakaslilla`,
    "brightness": `Heledus`,
    "brown": `pruun`,
    "brown yellow": `pruunikaskollane`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `ts\xfcaan`,
    "cyan blue": `ts\xfcaansinine`,
    "dark": `tume`,
    "gray": `hall`,
    "grayish": `hallikas`,
    "green": `Roheline`,
    "green cyan": `ts\xfcaanroheline`,
    "hue": `V\xe4rv`,
    "light": `valgus`,
    "lightness": `Valgus`,
    "magenta": `magentapunane`,
    "magenta pink": `magentaroosa`,
    "orange": `oran\u{17E}`,
    "orange yellow": `oran\u{17E}ikaskollane`,
    "pale": `kahvatu`,
    "pink": `roosa`,
    "pink red": `vaarikapunane`,
    "purple": `lilla`,
    "purple magenta": `purpurne magenta`,
    "red": `Punane`,
    "red orange": `punakasoran\u{17E}`,
    "saturation": `K\xfcllastus`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} l\xe4bipaistev`,
    "very dark": `v\xe4ga tume`,
    "very light": `v\xe4ga hele`,
    "vibrant": `ere`,
    "white": `valge`,
    "yellow": `kollane`,
    "yellow green": `kollakasroheline`
};

});

parcelRegister("3iCSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7925a26494fdb059$export$2e2bcd8739ae039);
var $7925a26494fdb059$export$2e2bcd8739ae039 = {};
$7925a26494fdb059$export$2e2bcd8739ae039 = {
    "alpha": `Alpha`,
    "black": `musta`,
    "blue": `Sininen`,
    "blue purple": `sinivioletti`,
    "brightness": `Kirkkaus`,
    "brown": `ruskea`,
    "brown yellow": `ruskeankeltainen`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `syaani`,
    "cyan blue": `syaaninsininen`,
    "dark": `tumma`,
    "gray": `harmaa`,
    "grayish": `harmahtava`,
    "green": `Vihre\xe4`,
    "green cyan": `vihre\xe4nsyaani`,
    "hue": `S\xe4vy`,
    "light": `vaalea`,
    "lightness": `Valom\xe4\xe4r\xe4`,
    "magenta": `magenta`,
    "magenta pink": `magentapinkki`,
    "orange": `oranssi`,
    "orange yellow": `oranssinkeltainen`,
    "pale": `vaalea`,
    "pink": `pinkki`,
    "pink red": `vaaleanpunainen`,
    "purple": `violetti`,
    "purple magenta": `violettimagenta`,
    "red": `Punainen`,
    "red orange": `punaoranssi`,
    "saturation": `V\xe4rikyll\xe4isyys`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} l\xe4pin\xe4kyv\xe4`,
    "very dark": `hyvin tumma`,
    "very light": `eritt\xe4in vaalea`,
    "vibrant": `eloisa`,
    "white": `valkea`,
    "yellow": `keltainen`,
    "yellow green": `keltavihre\xe4`
};

});

parcelRegister("lPrCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4254a6d1cd604a8f$export$2e2bcd8739ae039);
var $4254a6d1cd604a8f$export$2e2bcd8739ae039 = {};
$4254a6d1cd604a8f$export$2e2bcd8739ae039 = {
    "alpha": `Alpha`,
    "black": `Noir`,
    "blue": `Bleu`,
    "blue purple": `Violet bleu`,
    "brightness": `Luminosit\xe9`,
    "brown": `Brun`,
    "brown yellow": `Jaune brun`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `Cyan`,
    "cyan blue": `Bleu cyan`,
    "dark": `Sombre`,
    "gray": `Gris`,
    "grayish": `Gris\xe2tre`,
    "green": `Vert`,
    "green cyan": `Cyan vert`,
    "hue": `Teinte`,
    "light": `Clair`,
    "lightness": `Luminosit\xe9`,
    "magenta": `Magenta`,
    "magenta pink": `Rose magenta`,
    "orange": `Orange`,
    "orange yellow": `Jaune orang\xe9`,
    "pale": `P\xe2le`,
    "pink": `Rose`,
    "pink red": `Rouge ros\xe9`,
    "purple": `Violet`,
    "purple magenta": `Magenta violet`,
    "red": `Rouge`,
    "red orange": `Orange rouge`,
    "saturation": `Saturation`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparent`,
    "very dark": `Tr\xe8s sombre`,
    "very light": `Tr\xe8s clair`,
    "vibrant": `Vif`,
    "white": `Blanc`,
    "yellow": `Jaune`,
    "yellow green": `Vert jaune`
};

});

parcelRegister("6P9Rg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabc56f1a13024e2$export$2e2bcd8739ae039);
var $fabc56f1a13024e2$export$2e2bcd8739ae039 = {};
$fabc56f1a13024e2$export$2e2bcd8739ae039 = {
    "alpha": `\u{5D0}\u{5DC}\u{5E4}\u{5D0}`,
    "black": `\u{5E9}\u{5D7}\u{5D5}\u{5E8}`,
    "blue": `\u{5DB}\u{5D7}\u{5D5}\u{5DC}`,
    "blue purple": `\u{5DB}\u{5D7}\u{5D5}\u{5DC} \u{5E1}\u{5D2}\u{5D5}\u{5DC}`,
    "brightness": `\u{5D1}\u{5D4}\u{5D9}\u{5E8}\u{5D5}\u{5EA}`,
    "brown": `\u{5D7}\u{5D5}\u{5DD}`,
    "brown yellow": `\u{5D7}\u{5D5}\u{5DD} \u{5E6}\u{5D4}\u{5D5}\u{5D1}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{5D8}\u{5D5}\u{5E8}\u{5E7}\u{5D9}\u{5D6}`,
    "cyan blue": `\u{5DB}\u{5D7}\u{5D5}\u{5DC} \u{5E6}\u{5D9}\u{5D0}\u{5DF}`,
    "dark": `\u{5DB}\u{5D4}\u{5D4}`,
    "gray": `\u{5D0}\u{5E4}\u{5D5}\u{5E8}`,
    "grayish": `\u{5D0}\u{5E4}\u{5E8}\u{5E4}\u{5E8}`,
    "green": `\u{5D9}\u{5E8}\u{5D5}\u{5E7}`,
    "green cyan": `\u{5E6}\u{5D9}\u{5D0}\u{5DF} \u{5D9}\u{5E8}\u{5D5}\u{5E7}`,
    "hue": `\u{5D2}\u{5D5}\u{5D5}\u{5DF}`,
    "light": `\u{5D0}\u{5D5}\u{5E8}`,
    "lightness": `\u{5DB}\u{5DE}\u{5D5}\u{5EA} \u{5D0}\u{5D5}\u{5E8}`,
    "magenta": `\u{5DE}\u{5D2}'\u{5E0}\u{5D8}\u{5D4}`,
    "magenta pink": `\u{5D5}\u{5E8}\u{5D5}\u{5D3} \u{5DE}\u{5D2}'\u{5E0}\u{5D8}\u{5D4}`,
    "orange": `\u{5DB}\u{5EA}\u{5D5}\u{5DD}`,
    "orange yellow": `\u{5DB}\u{5EA}\u{5D5}\u{5DD} \u{5E6}\u{5D4}\u{5D5}\u{5D1}`,
    "pale": `\u{5D7}\u{5D9}\u{5D5}\u{5D5}\u{5E8}`,
    "pink": `\u{5D5}\u{5E8}\u{5D5}\u{5D3}`,
    "pink red": `\u{5D5}\u{5E8}\u{5D5}\u{5D3} \u{5D0}\u{5D3}\u{5D5}\u{5DD}`,
    "purple": `\u{5E1}\u{5D2}\u{5D5}\u{5DC}`,
    "purple magenta": `\u{5DE}\u{5D2}'\u{5E0}\u{5D8}\u{5D4} \u{5E1}\u{5D2}\u{5D5}\u{5DC}`,
    "red": `\u{5D0}\u{5D3}\u{5D5}\u{5DD}`,
    "red orange": `\u{5DB}\u{5EA}\u{5D5}\u{5DD} \u{5D0}\u{5D3}\u{5D5}\u{5DD}`,
    "saturation": `\u{5E8}\u{5D5}\u{5D5}\u{5D9}\u{5D4}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{5E9}\u{5E7}\u{5D5}\u{5E3}`,
    "very dark": `\u{5DB}\u{5D4}\u{5D4} \u{5DE}\u{5D0}\u{5D5}\u{5D3}`,
    "very light": `\u{5D1}\u{5D4}\u{5D9}\u{5E8} \u{5DE}\u{5D0}\u{5D5}\u{5D3}`,
    "vibrant": `\u{5EA}\u{5D5}\u{5E1}\u{5E1}`,
    "white": `\u{5DC}\u{5D1}\u{5DF}`,
    "yellow": `\u{5E6}\u{5D4}\u{5D5}\u{5D1}`,
    "yellow green": `\u{5E6}\u{5D4}\u{5D5}\u{5D1} \u{5D9}\u{5E8}\u{5D5}\u{5E7}`
};

});

parcelRegister("ahUH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22adcc4ab84144a$export$2e2bcd8739ae039);
var $a22adcc4ab84144a$export$2e2bcd8739ae039 = {};
$a22adcc4ab84144a$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `crno`,
    "blue": `Plava`,
    "blue purple": `plavo ljubi\u{10D}asta`,
    "brightness": `Svjetlina`,
    "brown": `sme\u{111}a`,
    "brown yellow": `sme\u{111}e \u{17E}uta`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cijan`,
    "cyan blue": `cijan plava`,
    "dark": `tamno`,
    "gray": `siva`,
    "grayish": `sivkasto`,
    "green": `Zelena`,
    "green cyan": `zelena cijan`,
    "hue": `Nijansa`,
    "light": `svjetlo`,
    "lightness": `Osvijetljenost`,
    "magenta": `magenta`,
    "magenta pink": `magentno ru\u{17E}i\u{10D}asta`,
    "orange": `naran\u{10D}asta`,
    "orange yellow": `naran\u{10D}asto \u{17E}uta`,
    "pale": `blijeda`,
    "pink": `ru\u{17E}i\u{10D}asta`,
    "pink red": `ru\u{17E}i\u{10D}asto crvena`,
    "purple": `ljubi\u{10D}asta`,
    "purple magenta": `ljubi\u{10D}asta magenta`,
    "red": `Crvena`,
    "red orange": `crveno naran\u{10D}asta`,
    "saturation": `Zasi\u{107}enost`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} prozirnosti`,
    "very dark": `jako tamna`,
    "very light": `vrlo svijetlo`,
    "vibrant": `vibrantna`,
    "white": `bijela`,
    "yellow": `\u{17E}uto`,
    "yellow green": `\u{17E}uto zelena`
};

});

parcelRegister("iPO6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d88f3e6fa62574e$export$2e2bcd8739ae039);
var $5d88f3e6fa62574e$export$2e2bcd8739ae039 = {};
$5d88f3e6fa62574e$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `fekete`,
    "blue": `K\xe9k`,
    "blue purple": `k\xe9k lila`,
    "brightness": `F\xe9nyess\xe9g`,
    "brown": `barna`,
    "brown yellow": `barna s\xe1rga`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `ci\xe1nk\xe9k`,
    "cyan blue": `ci\xe1nk\xe9k`,
    "dark": `s\xf6t\xe9t`,
    "gray": `sz\xfcrke`,
    "grayish": `sz\xfcrk\xe9s`,
    "green": `Z\xf6ld`,
    "green cyan": `z\xf6ld ci\xe1nk\xe9k`,
    "hue": `Sz\xedn\xe1rnyalat`,
    "light": `vil\xe1gos`,
    "lightness": `Vil\xe1goss\xe1g`,
    "magenta": `b\xedbor`,
    "magenta pink": `b\xedbor r\xf3zsasz\xedn`,
    "orange": `narancs`,
    "orange yellow": `narancss\xe1rga`,
    "pale": `halv\xe1ny`,
    "pink": `r\xf3zsasz\xedn`,
    "pink red": `r\xf3zsasz\xedn piros`,
    "purple": `lila`,
    "purple magenta": `lila b\xedbor`,
    "red": `Piros`,
    "red orange": `piros narancs`,
    "saturation": `Tel\xedtetts\xe9g`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \xe1tl\xe1tsz\xf3`,
    "very dark": `nagyon s\xf6t\xe9t`,
    "very light": `nagyon vil\xe1gos`,
    "vibrant": `\xe9l\xe9nk`,
    "white": `feh\xe9r`,
    "yellow": `s\xe1rga`,
    "yellow green": `s\xe1rga z\xf6ld`
};

});

parcelRegister("3blNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b0748d5fd4676ef$export$2e2bcd8739ae039);
var $5b0748d5fd4676ef$export$2e2bcd8739ae039 = {};
$5b0748d5fd4676ef$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `nero`,
    "blue": `Blu`,
    "blue purple": `blu viola`,
    "brightness": `Luminosit\xe0`,
    "brown": `marrone`,
    "brown yellow": `giallo bruno`,
    "colorName": (args)=>`${args.hue} ${args.chroma} ${args.lightness}`,
    "cyan": `ciano`,
    "cyan blue": `blu ciano`,
    "dark": `scuro`,
    "gray": `grigio`,
    "grayish": `grigiastro`,
    "green": `Verde`,
    "green cyan": `verde ciano`,
    "hue": `Tonalit\xe0`,
    "light": `chiaro`,
    "lightness": `Luminosit\xe0`,
    "magenta": `magenta`,
    "magenta pink": `rosa magenta`,
    "orange": `arancio`,
    "orange yellow": `giallo arancio`,
    "pale": `tenue`,
    "pink": `rosa`,
    "pink red": `rosa rosso`,
    "purple": `viola`,
    "purple magenta": `viola magenta`,
    "red": `Rosso`,
    "red orange": `rosso arancio`,
    "saturation": `Saturazione`,
    "transparentColorName": (args)=>`${args.hue} ${args.chroma} ${args.lightness}, trasparenza ${args.percentTransparent}`,
    "very dark": `molto scuro`,
    "very light": `molto chiaro`,
    "vibrant": `vivace`,
    "white": `bianco`,
    "yellow": `giallo`,
    "yellow green": `giallo verde`
};

});

parcelRegister("4nYXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dce2974c3c808cb$export$2e2bcd8739ae039);
var $6dce2974c3c808cb$export$2e2bcd8739ae039 = {};
$6dce2974c3c808cb$export$2e2bcd8739ae039 = {
    "alpha": `\u{30A2}\u{30EB}\u{30D5}\u{30A1}`,
    "black": `\u{30D6}\u{30E9}\u{30C3}\u{30AF}`,
    "blue": `\u{9752}`,
    "blue purple": `\u{30D6}\u{30EB}\u{30FC}\u{30D1}\u{30FC}\u{30D7}\u{30EB}`,
    "brightness": `\u{660E}\u{308B}\u{3055}`,
    "brown": `\u{30D6}\u{30E9}\u{30A6}\u{30F3}`,
    "brown yellow": `\u{30D6}\u{30E9}\u{30A6}\u{30F3}\u{30A4}\u{30A8}\u{30ED}\u{30FC}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{30B7}\u{30A2}\u{30F3}`,
    "cyan blue": `\u{30B7}\u{30A2}\u{30F3}\u{30D6}\u{30EB}\u{30FC}`,
    "dark": `\u{30C0}\u{30FC}\u{30AF}`,
    "gray": `\u{30B0}\u{30EC}\u{30FC}`,
    "grayish": `\u{30B0}\u{30EC}\u{30A4}\u{30C3}\u{30B7}\u{30E5}`,
    "green": `\u{7DD1}`,
    "green cyan": `\u{30B0}\u{30EA}\u{30FC}\u{30F3}\u{30B7}\u{30A2}\u{30F3}`,
    "hue": `\u{8272}\u{76F8}`,
    "light": `\u{30E9}\u{30A4}\u{30C8}`,
    "lightness": `\u{660E}\u{5EA6}`,
    "magenta": `\u{30DE}\u{30BC}\u{30F3}\u{30BF}`,
    "magenta pink": `\u{30DE}\u{30BC}\u{30F3}\u{30BF}\u{30D4}\u{30F3}\u{30AF}`,
    "orange": `\u{30AA}\u{30EC}\u{30F3}\u{30B8}`,
    "orange yellow": `\u{30AA}\u{30EC}\u{30F3}\u{30B8}\u{30A4}\u{30A8}\u{30ED}\u{30FC}`,
    "pale": `\u{30DA}\u{30FC}\u{30EB}`,
    "pink": `\u{30D4}\u{30F3}\u{30AF}`,
    "pink red": `\u{30D4}\u{30F3}\u{30AF}\u{30EC}\u{30C3}\u{30C9}`,
    "purple": `\u{30D1}\u{30FC}\u{30D7}\u{30EB}`,
    "purple magenta": `\u{30D1}\u{30FC}\u{30D7}\u{30EB}\u{30DE}\u{30BC}\u{30F3}\u{30BF}`,
    "red": `\u{8D64}`,
    "red orange": `\u{30EC}\u{30C3}\u{30C9}\u{30AA}\u{30EC}\u{30F3}\u{30B8}`,
    "saturation": `\u{5F69}\u{5EA6}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{900F}\u{660E}`,
    "very dark": `\u{6700}\u{3082}\u{6697}\u{3044}`,
    "very light": `\u{30D9}\u{30EA}\u{30FC}\u{30E9}\u{30A4}\u{30C8}`,
    "vibrant": `\u{9BAE}\u{3084}\u{304B}`,
    "white": `\u{30DB}\u{30EF}\u{30A4}\u{30C8}`,
    "yellow": `\u{30A4}\u{30A8}\u{30ED}\u{30FC}`,
    "yellow green": `\u{30A4}\u{30A8}\u{30ED}\u{30FC}\u{30B0}\u{30EA}\u{30FC}\u{30F3}`
};

});

parcelRegister("h5EZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1047a21d122d9b4$export$2e2bcd8739ae039);
var $e1047a21d122d9b4$export$2e2bcd8739ae039 = {};
$e1047a21d122d9b4$export$2e2bcd8739ae039 = {
    "alpha": `\u{C54C}\u{D30C}`,
    "black": `\u{AC80}\u{C740}\u{C0C9}`,
    "blue": `\u{D30C}\u{B791}`,
    "blue purple": `\u{CCAD}\u{C790}\u{C0C9}`,
    "brightness": `\u{BA85}\u{B3C4}`,
    "brown": `\u{AC08}\u{C0C9}`,
    "brown yellow": `\u{D669}\u{AC08}\u{C0C9}`,
    "colorName": (args)=>`${args.lightness}, ${args.chroma}, ${args.hue}`,
    "cyan": `\u{CCAD}\u{B85D}\u{C0C9}`,
    "cyan blue": `\u{CCAD}\u{B85D}\u{C0C9}`,
    "dark": `\u{B2E4}\u{D06C}`,
    "gray": `\u{D68C}\u{C0C9}`,
    "grayish": `\u{D68C}\u{AC08}\u{C0C9}`,
    "green": `\u{CD08}\u{B85D}`,
    "green cyan": `\u{CCAD}\u{B85D}\u{C0C9}`,
    "hue": `\u{C0C9}\u{C870}`,
    "light": `\u{B77C}\u{C774}\u{D2B8}`,
    "lightness": `\u{BC1D}\u{AE30}`,
    "magenta": `\u{C790}\u{D64D}\u{C0C9}`,
    "magenta pink": `\u{B9C8}\u{C820}\u{D0C0} \u{D551}\u{D06C}`,
    "orange": `\u{C8FC}\u{D669}\u{C0C9}`,
    "orange yellow": `\u{BD88}\u{ADF8}\u{C2A4}\u{B984}\u{D55C} \u{B178}\u{B791}`,
    "pale": `\u{D759}\u{C0C9}`,
    "pink": `\u{BD84}\u{D64D}\u{C0C9}`,
    "pink red": `\u{D551}\u{D06C} \u{B808}\u{B4DC}`,
    "purple": `\u{C790}\u{C8FC}\u{C0C9}`,
    "purple magenta": `\u{BCF4}\u{B77C}\u{BE5B} \u{C790}\u{D64D}\u{C0C9}`,
    "red": `\u{BE68}\u{AC15}`,
    "red orange": `\u{BD89}\u{C740} \u{C8FC}\u{D669}\u{C0C9}`,
    "saturation": `\u{CC44}\u{B3C4}`,
    "transparentColorName": (args)=>`${args.lightness}, ${args.chroma}, ${args.hue}, ${args.percentTransparent} \u{D22C}\u{BA85}\u{B3C4}`,
    "very dark": `\u{B9E4}\u{C6B0} \u{C5B4}\u{B450}\u{C6B4}`,
    "very light": `\u{B9E4}\u{C6B0} \u{C5F0}\u{D568}`,
    "vibrant": `\u{AC15}\u{B82C}\u{D55C}`,
    "white": `\u{D770}\u{C0C9}`,
    "yellow": `\u{B178}\u{B780}\u{C0C9}`,
    "yellow green": `\u{C5F0}\u{B450}\u{C0C9}`
};

});

parcelRegister("holYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $19976359bc2ab0b9$export$2e2bcd8739ae039);
var $19976359bc2ab0b9$export$2e2bcd8739ae039 = {};
$19976359bc2ab0b9$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `juoda`,
    "blue": `M\u{117}lyna`,
    "blue purple": `melsvai violetin\u{117}`,
    "brightness": `Ry\u{161}kumas`,
    "brown": `ruda`,
    "brown yellow": `rusvai geltona`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{17E}alsvai m\u{117}lyna`,
    "cyan blue": `\u{17E}alsvai m\u{117}lyna`,
    "dark": `tamsi`,
    "gray": `pilka`,
    "grayish": `pilk\u{161}va`,
    "green": `\u{17D}alia`,
    "green cyan": `\u{17E}alsvai m\u{117}lyna`,
    "hue": `Atspalvis`,
    "light": `\u{161}viesi`,
    "lightness": `\u{160}viesumas`,
    "magenta": `rausvai raudona`,
    "magenta pink": `purpurin\u{117}`,
    "orange": `oran\u{17E}in\u{117}`,
    "orange yellow": `oran\u{17E}inio atspalvio geltona`,
    "pale": `bly\u{161}ki`,
    "pink": `ro\u{17E}in\u{117}`,
    "pink red": `ro\u{17E}in\u{117} raudona`,
    "purple": `violetin\u{117}`,
    "purple magenta": `purpurin\u{117} rausvai raudona`,
    "red": `Raudona`,
    "red orange": `rausvai oran\u{17E}in\u{117}`,
    "saturation": `\u{12E}sotinimas`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} skaidri`,
    "very dark": `labai tamsi`,
    "very light": `labai \u{161}viesi`,
    "vibrant": `ry\u{161}ki`,
    "white": `balta`,
    "yellow": `geltona`,
    "yellow green": `gelsvai \u{17E}alia`
};

});

parcelRegister("ivoBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec0431c25c8c5ae$export$2e2bcd8739ae039);
var $4ec0431c25c8c5ae$export$2e2bcd8739ae039 = {};
$4ec0431c25c8c5ae$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `melns`,
    "blue": `Zila`,
    "blue purple": `zili violets`,
    "brightness": `Spilgtums`,
    "brown": `br\u{16B}ns`,
    "brown yellow": `br\u{16B}ni dzeltens`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `ci\u{101}ns`,
    "cyan blue": `ci\u{101}na zils`,
    "dark": `tum\u{161}s`,
    "gray": `pel\u{113}ks`,
    "grayish": `pel\u{113}c\u{12B}gs`,
    "green": `Za\u{13C}a`,
    "green cyan": `za\u{13C}\u{161} ci\u{101}ns`,
    "hue": `Nokr\u{101}sa`,
    "light": `gai\u{161}s`,
    "lightness": `Gai\u{161}ums`,
    "magenta": `fuksiju`,
    "magenta pink": `fuksiju roz\u{101}`,
    "orange": `oran\u{17E}s`,
    "orange yellow": `oran\u{17E}i dzeltens`,
    "pale": `b\u{101}ls`,
    "pink": `roz\u{101}`,
    "pink red": `roz\u{12B}gi sarkans`,
    "purple": `violets`,
    "purple magenta": `violets fuksiju`,
    "red": `Sarkana`,
    "red orange": `sarkan\u{12B}gi oran\u{17E}s`,
    "saturation": `Pies\u{101}tin\u{101}jums`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} caursp\u{12B}d\u{12B}gs`,
    "very dark": `\u{13C}oti tum\u{161}s`,
    "very light": `\u{13C}oti gai\u{161}s`,
    "vibrant": `ko\u{161}s`,
    "white": `balts`,
    "yellow": `dzeltens`,
    "yellow green": `dzelteni za\u{13C}\u{161}`
};

});

parcelRegister("4GgHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bec4bf91b8d4d33e$export$2e2bcd8739ae039);
var $bec4bf91b8d4d33e$export$2e2bcd8739ae039 = {};
$bec4bf91b8d4d33e$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `svart`,
    "blue": `Bl\xe5`,
    "blue purple": `bl\xe5lilla`,
    "brightness": `Lysstyrke`,
    "brown": `brun`,
    "brown yellow": `brungul`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cyan`,
    "cyan blue": `cyanbl\xe5`,
    "dark": `m\xf8rk`,
    "gray": `gr\xe5`,
    "grayish": `gr\xe5aktig`,
    "green": `Gr\xf8nn`,
    "green cyan": `gr\xf8nncyan`,
    "hue": `Fargetone`,
    "light": `lys`,
    "lightness": `Lyshet`,
    "magenta": `magenta`,
    "magenta pink": `magentarosa`,
    "orange": `oransje`,
    "orange yellow": `oransjegul`,
    "pale": `blek`,
    "pink": `rosa`,
    "pink red": `rosar\xf8d`,
    "purple": `lilla`,
    "purple magenta": `lillamagenta`,
    "red": `R\xf8d`,
    "red orange": `r\xf8doransje`,
    "saturation": `Metning`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} gjennomsiktig`,
    "very dark": `sv\xe6rt m\xf8rk`,
    "very light": `sv\xe6rt lys`,
    "vibrant": `levende`,
    "white": `hvit`,
    "yellow": `gul`,
    "yellow green": `gulgr\xf8nn`
};

});

parcelRegister("b5APv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc17ff545ff6c05e$export$2e2bcd8739ae039);
var $cc17ff545ff6c05e$export$2e2bcd8739ae039 = {};
$cc17ff545ff6c05e$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `zwart`,
    "blue": `Blauw`,
    "blue purple": `paarsblauw`,
    "brightness": `Helderheid`,
    "brown": `bruin`,
    "brown yellow": `bruingeel`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cyaan`,
    "cyan blue": `cyaanblauw`,
    "dark": `donker`,
    "gray": `grijs`,
    "grayish": `grijsachtig`,
    "green": `Groen`,
    "green cyan": `cyaangroen`,
    "hue": `Kleurtoon`,
    "light": `licht`,
    "lightness": `Lichtsterkte`,
    "magenta": `magenta`,
    "magenta pink": `magentaroze`,
    "orange": `oranje`,
    "orange yellow": `oranjegeel`,
    "pale": `bleek`,
    "pink": `roze`,
    "pink red": `rozerood`,
    "purple": `paars`,
    "purple magenta": `magentapaars`,
    "red": `Rood`,
    "red orange": `roodoranje`,
    "saturation": `Verzadiging`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparant`,
    "very dark": `heel donker`,
    "very light": `heel licht`,
    "vibrant": `levendig`,
    "white": `wit`,
    "yellow": `geel`,
    "yellow green": `geelgroen`
};

});

parcelRegister("8BQO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $beeef860d16c3ebf$export$2e2bcd8739ae039);
var $beeef860d16c3ebf$export$2e2bcd8739ae039 = {};
$beeef860d16c3ebf$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `czarny`,
    "blue": `Niebieski`,
    "blue purple": `niebiesko-fioletowy`,
    "brightness": `Jasno\u{15B}\u{107}`,
    "brown": `br\u{105}zowy`,
    "brown yellow": `br\u{105}zowo-\u{17C}\xf3\u{142}ty`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cyjanowy`,
    "cyan blue": `cyjanowo-niebieski`,
    "dark": `ciemny`,
    "gray": `szary`,
    "grayish": `szarawy`,
    "green": `Zielony`,
    "green cyan": `zielono-cyjanowy`,
    "hue": `Odcie\u{144}`,
    "light": `jasny`,
    "lightness": `Jaskrawo\u{15B}\u{107}`,
    "magenta": `purpurowy`,
    "magenta pink": `purpurowo-r\xf3\u{17C}owy`,
    "orange": `pomara\u{144}czowy`,
    "orange yellow": `pomara\u{144}czowo-\u{17C}\xf3\u{142}ty`,
    "pale": `blady`,
    "pink": `r\xf3\u{17C}owy`,
    "pink red": `r\xf3\u{17C}owo-czerwony`,
    "purple": `fioletowy`,
    "purple magenta": `fioletowo-purpurowy`,
    "red": `Czerwony`,
    "red orange": `czerwono-pomara\u{144}czowy`,
    "saturation": `Nasycenie`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} przezroczysto\u{15B}ci`,
    "very dark": `bardzo ciemny`,
    "very light": `bardzo jasny`,
    "vibrant": `intensywny`,
    "white": `bia\u{142}y`,
    "yellow": `\u{17C}\xf3\u{142}ty`,
    "yellow green": `\u{17C}\xf3\u{142}to-zielony`
};

});

parcelRegister("h76e2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5176bced8894a92$export$2e2bcd8739ae039);
var $f5176bced8894a92$export$2e2bcd8739ae039 = {};
$f5176bced8894a92$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `preto`,
    "blue": `Azul`,
    "blue purple": `roxo azulado`,
    "brightness": `Brilho`,
    "brown": `marrom`,
    "brown yellow": `marrom amarelado`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `ciano`,
    "cyan blue": `azul-ciano`,
    "dark": `escuro`,
    "gray": `cinza`,
    "grayish": `acinzentado`,
    "green": `Verde`,
    "green cyan": `verde-ciano`,
    "hue": `Matiz`,
    "light": `claro`,
    "lightness": `Luminosidade`,
    "magenta": `magenta`,
    "magenta pink": `rosa-magenta`,
    "orange": `laranja`,
    "orange yellow": `amarelo alaranjado`,
    "pale": `p\xe1lido`,
    "pink": `rosa`,
    "pink red": `rosa avermelhado`,
    "purple": `roxo`,
    "purple magenta": `roxo-magenta`,
    "red": `Vermelho`,
    "red orange": `laranja avermelhado`,
    "saturation": `Satura\xe7\xe3o`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparente`,
    "very dark": `muito escuro`,
    "very light": `muito claro`,
    "vibrant": `vibrante`,
    "white": `branco`,
    "yellow": `amarelo`,
    "yellow green": `verde amarelado`
};

});

parcelRegister("jO1pK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b260f8ebd8991a$export$2e2bcd8739ae039);
var $f5b260f8ebd8991a$export$2e2bcd8739ae039 = {};
$f5b260f8ebd8991a$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `preto`,
    "blue": `Azul`,
    "blue purple": `azul-p\xfarpura`,
    "brightness": `Luminosidade`,
    "brown": `castanho`,
    "brown yellow": `amarelo-castanho`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `ciano`,
    "cyan blue": `azul-ciano`,
    "dark": `escuro`,
    "gray": `cinzento`,
    "grayish": `acinzentado`,
    "green": `Verde`,
    "green cyan": `verde-ciano`,
    "hue": `Tonalidade`,
    "light": `claro`,
    "lightness": `Claridade`,
    "magenta": `magenta`,
    "magenta pink": `rosa-magenta`,
    "orange": `laranja`,
    "orange yellow": `amarelo-laranja`,
    "pale": `p\xe1lido`,
    "pink": `cor-de-rosa`,
    "pink red": `vermelho-rosa`,
    "purple": `p\xfarpura`,
    "purple magenta": `p\xfarpura-magenta`,
    "red": `Vermelho`,
    "red orange": `laranja-vermelho`,
    "saturation": `Satura\xe7\xe3o`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparente`,
    "very dark": `muito escuro`,
    "very light": `muito claro`,
    "vibrant": `vibrante`,
    "white": `branco`,
    "yellow": `amarelo`,
    "yellow green": `verde-amarelo`
};

});

parcelRegister("bEvBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3463892783351e72$export$2e2bcd8739ae039);
var $3463892783351e72$export$2e2bcd8739ae039 = {};
$3463892783351e72$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `negru`,
    "blue": `Albastru`,
    "blue purple": `albastru-violet`,
    "brightness": `Luminozitate`,
    "brown": `maro`,
    "brown yellow": `galben maro`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `bleu`,
    "cyan blue": `albastru-bleu`,
    "dark": `\xeenchis`,
    "gray": `gri`,
    "grayish": `cenu\u{219}iu`,
    "green": `Verde`,
    "green cyan": `verde bleu`,
    "hue": `Nuan\u{21B}\u{103}`,
    "light": `deschis`,
    "lightness": `Luminozitate`,
    "magenta": `fucsia`,
    "magenta pink": `roz-fucsia`,
    "orange": `portocaliu`,
    "orange yellow": `galben-portocaliu`,
    "pale": `pal`,
    "pink": `roz`,
    "pink red": `roz-ro\u{219}u`,
    "purple": `violet`,
    "purple magenta": `violet-fucsia`,
    "red": `Ro\u{219}u`,
    "red orange": `portocaliu-ro\u{219}u`,
    "saturation": `Satura\u{21B}ie`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} transparent`,
    "very dark": `foarte \xeenchis`,
    "very light": `foarte deschis`,
    "vibrant": `plin de via\u{21B}\u{103}`,
    "white": `alb`,
    "yellow": `galben`,
    "yellow green": `galben-verde`
};

});

parcelRegister("lWe8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a512cbb29c44cf1$export$2e2bcd8739ae039);
var $8a512cbb29c44cf1$export$2e2bcd8739ae039 = {};
$8a512cbb29c44cf1$export$2e2bcd8739ae039 = {
    "alpha": `\u{410}\u{43B}\u{44C}\u{444}\u{430}`,
    "black": `\u{447}\u{435}\u{440}\u{43D}\u{44B}\u{439}`,
    "blue": `\u{421}\u{438}\u{43D}\u{438}\u{439}`,
    "blue purple": `\u{441}\u{438}\u{43D}\u{435}-\u{444}\u{438}\u{43E}\u{43B}\u{435}\u{442}\u{43E}\u{432}\u{44B}\u{439}`,
    "brightness": `\u{42F}\u{440}\u{43A}\u{43E}\u{441}\u{442}\u{44C}`,
    "brown": `\u{43A}\u{43E}\u{440}\u{438}\u{447}\u{43D}\u{435}\u{432}\u{44B}\u{439}`,
    "brown yellow": `\u{43A}\u{43E}\u{440}\u{438}\u{447}\u{43D}\u{435}\u{432}\u{43E}-\u{436}\u{435}\u{43B}\u{442}\u{44B}\u{439}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{433}\u{43E}\u{43B}\u{443}\u{431}\u{43E}\u{439}`,
    "cyan blue": `\u{446}\u{432}\u{435}\u{442} \u{43C}\u{43E}\u{440}\u{441}\u{43A}\u{43E}\u{439} \u{432}\u{43E}\u{43B}\u{43D}\u{44B}`,
    "dark": `\u{442}\u{435}\u{43C}\u{43D}\u{44B}\u{439}`,
    "gray": `\u{441}\u{435}\u{440}\u{44B}\u{439}`,
    "grayish": `\u{441}\u{435}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44B}\u{439}`,
    "green": `\u{417}\u{435}\u{43B}\u{435}\u{43D}\u{44B}\u{439}`,
    "green cyan": `\u{441}\u{438}\u{43D}\u{435}-\u{437}\u{435}\u{43B}\u{435}\u{43D}\u{44B}\u{439}`,
    "hue": `\u{41E}\u{442}\u{442}\u{435}\u{43D}\u{43E}\u{43A}`,
    "light": `\u{441}\u{432}\u{435}\u{442}\u{43B}\u{44B}\u{439}`,
    "lightness": `\u{41E}\u{441}\u{432}\u{435}\u{449}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    "magenta": `\u{43F}\u{443}\u{440}\u{43F}\u{443}\u{440}\u{43D}\u{44B}\u{439}`,
    "magenta pink": `\u{43F}\u{443}\u{440}\u{43F}\u{443}\u{440}\u{43D}\u{43E}-\u{440}\u{43E}\u{437}\u{43E}\u{432}\u{44B}\u{439}`,
    "orange": `\u{43E}\u{440}\u{430}\u{43D}\u{436}\u{435}\u{432}\u{44B}\u{439}`,
    "orange yellow": `\u{43E}\u{440}\u{430}\u{43D}\u{436}\u{435}\u{432}\u{43E}-\u{436}\u{435}\u{43B}\u{442}\u{44B}\u{439}`,
    "pale": `\u{431}\u{43B}\u{435}\u{434}\u{43D}\u{44B}\u{439}`,
    "pink": `\u{440}\u{43E}\u{437}\u{43E}\u{432}\u{44B}\u{439}`,
    "pink red": `\u{440}\u{43E}\u{437}\u{43E}\u{432}\u{43E}-\u{43A}\u{440}\u{430}\u{441}\u{43D}\u{44B}\u{439}`,
    "purple": `\u{444}\u{438}\u{43E}\u{43B}\u{435}\u{442}\u{43E}\u{432}\u{44B}\u{439}`,
    "purple magenta": `\u{444}\u{438}\u{43E}\u{43B}\u{435}\u{442}\u{43E}\u{432}\u{43E}-\u{43F}\u{443}\u{440}\u{43F}\u{443}\u{440}\u{43D}\u{44B}\u{439}`,
    "red": `\u{41A}\u{440}\u{430}\u{441}\u{43D}\u{44B}\u{439}`,
    "red orange": `\u{43A}\u{440}\u{430}\u{441}\u{43D}\u{43E}-\u{43E}\u{440}\u{430}\u{43D}\u{436}\u{435}\u{432}\u{44B}\u{439}`,
    "saturation": `\u{41D}\u{430}\u{441}\u{44B}\u{449}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, \u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{43D}\u{44B}\u{439} \u{43D}\u{430} ${args.percentTransparent}`,
    "very dark": `\u{43E}\u{447}\u{435}\u{43D}\u{44C} \u{442}\u{435}\u{43C}\u{43D}\u{44B}\u{439}`,
    "very light": `\u{43E}\u{447}\u{435}\u{43D}\u{44C} \u{441}\u{432}\u{435}\u{442}\u{43B}\u{44B}\u{439}`,
    "vibrant": `\u{44F}\u{440}\u{43A}\u{438}\u{439}`,
    "white": `\u{431}\u{435}\u{43B}\u{44B}\u{439}`,
    "yellow": `\u{436}\u{435}\u{43B}\u{442}\u{44B}\u{439}`,
    "yellow green": `\u{436}\u{435}\u{43B}\u{442}\u{43E}-\u{437}\u{435}\u{43B}\u{435}\u{43D}\u{44B}\u{439}`
};

});

parcelRegister("11LV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3f3eca631aafc5$export$2e2bcd8739ae039);
var $4f3f3eca631aafc5$export$2e2bcd8739ae039 = {};
$4f3f3eca631aafc5$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `\u{10D}ierna`,
    "blue": `Modr\xe1`,
    "blue purple": `modrofialov\xe1`,
    "brightness": `Jas`,
    "brown": `hned\xe1`,
    "brown yellow": `hnedo\u{17E}lt\xe1`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `az\xfarov\xe1`,
    "cyan blue": `az\xfarov\xe1 modr\xe1`,
    "dark": `tmav\xe1`,
    "gray": `siv\xe1`,
    "grayish": `sivast\xe1`,
    "green": `Zelen\xe1`,
    "green cyan": `zelen\xe1 az\xfarov\xe1`,
    "hue": `Odtie\u{148}`,
    "light": `svetl\xe1`,
    "lightness": `Svetlos\u{165}`,
    "magenta": `purpurov\xe1`,
    "magenta pink": `ru\u{17E}ov\xe1 purpurov\xe1`,
    "orange": `oran\u{17E}ov\xe1`,
    "orange yellow": `oran\u{17E}ovo\u{17E}lt\xe1`,
    "pale": `bled\xe1`,
    "pink": `ru\u{17E}ov\xe1`,
    "pink red": `ru\u{17E}ovo\u{10D}erven\xe1`,
    "purple": `fialov\xe1`,
    "purple magenta": `fialov\xe1 purpurov\xe1`,
    "red": `\u{10C}erven\xe1`,
    "red orange": `\u{10D}ervenooran\u{17E}ov\xe1`,
    "saturation": `S\xfdtos\u{165}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} prieh\u{13E}adn\xe1`,
    "very dark": `ve\u{13E}mi tmav\xe1`,
    "very light": `ve\u{13E}mi svetl\xe1`,
    "vibrant": `energick\xe1`,
    "white": `biela`,
    "yellow": `\u{17E}lt\xe1`,
    "yellow green": `\u{17E}ltozelen\xe1`
};

});

parcelRegister("5JGqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $323ccf66b7979f28$export$2e2bcd8739ae039);
var $323ccf66b7979f28$export$2e2bcd8739ae039 = {};
$323ccf66b7979f28$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `\u{10D}rna`,
    "blue": `Modra`,
    "blue purple": `modro vijoli\u{10D}na`,
    "brightness": `Svetlost`,
    "brown": `rjava`,
    "brown yellow": `rjavo rumena`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cian`,
    "cyan blue": `cian modra`,
    "dark": `temna`,
    "gray": `siva`,
    "grayish": `sivkasta`,
    "green": `Zelena`,
    "green cyan": `zelena cian`,
    "hue": `Barva`,
    "light": `svetla`,
    "lightness": `Lahkost`,
    "magenta": `\u{161}krlatna`,
    "magenta pink": `\u{161}krlatno roza`,
    "orange": `oran\u{17E}na`,
    "orange yellow": `oran\u{17E}no rumena`,
    "pale": `bleda`,
    "pink": `roza`,
    "pink red": `roza rde\u{10D}a`,
    "purple": `vijoli\u{10D}na`,
    "purple magenta": `vijoli\u{10D}no \u{161}krlatna`,
    "red": `Rde\u{10D}a`,
    "red orange": `rde\u{10D}e oran\u{17E}na`,
    "saturation": `Nasi\u{10D}enost`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} prozorna`,
    "very dark": `zelo temna`,
    "very light": `zelo svetla`,
    "vibrant": `\u{17E}ivahna`,
    "white": `bela`,
    "yellow": `rumena`,
    "yellow green": `rumeno zelena`
};

});

parcelRegister("dh1G3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5de7714a8f91fa$export$2e2bcd8739ae039);
var $fa5de7714a8f91fa$export$2e2bcd8739ae039 = {};
$fa5de7714a8f91fa$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `crno`,
    "blue": `Plava`,
    "blue purple": `plavoljubi\u{10D}asta`,
    "brightness": `Osvetljenost`,
    "brown": `sme\u{111}a`,
    "brown yellow": `sme\u{111}e\u{17E}uta`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cijan`,
    "cyan blue": `cijan plava`,
    "dark": `tamno`,
    "gray": `siva`,
    "grayish": `sivkasta`,
    "green": `Zelena`,
    "green cyan": `zeleno cijan`,
    "hue": `Nijansa`,
    "light": `svetla`,
    "lightness": `Osvetljenje`,
    "magenta": `purpurnocrvena`,
    "magenta pink": `magenta ru\u{17E}i\u{10D}asta`,
    "orange": `narand\u{17E}asta`,
    "orange yellow": `narand\u{17E}asto\u{17E}uta`,
    "pale": `bledo`,
    "pink": `ru\u{17E}i\u{10D}asta`,
    "pink red": `ru\u{17E}i\u{10D}astocrvena`,
    "purple": `ljubi\u{10D}asta`,
    "purple magenta": `ljubi\u{10D}asta magenta`,
    "red": `Crvena`,
    "red orange": `crvenonarand\u{17E}asta`,
    "saturation": `Zasi\u{107}enje`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} prozirna`,
    "very dark": `veoma tamno`,
    "very light": `vrlo svetlo`,
    "vibrant": `\u{17E}ivopisna`,
    "white": `bela`,
    "yellow": `\u{17E}uto`,
    "yellow green": `\u{17E}utozelena`
};

});

parcelRegister("5fPSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e628c9ef09a55c2$export$2e2bcd8739ae039);
var $9e628c9ef09a55c2$export$2e2bcd8739ae039 = {};
$9e628c9ef09a55c2$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `svart`,
    "blue": `Bl\xe5tt`,
    "blue purple": `bl\xe5lila`,
    "brightness": `Ljusstyrka`,
    "brown": `brun`,
    "brown yellow": `brungul`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `cyan`,
    "cyan blue": `cyanbl\xe5`,
    "dark": `m\xf6rk`,
    "gray": `gr\xe5`,
    "grayish": `gr\xe5aktig`,
    "green": `Gr\xf6nt`,
    "green cyan": `gr\xf6n cyan`,
    "hue": `Nyans`,
    "light": `ljus`,
    "lightness": `Ljushet`,
    "magenta": `magenta`,
    "magenta pink": `magentarosa`,
    "orange": `orange`,
    "orange yellow": `orangegul`,
    "pale": `blek`,
    "pink": `rosa`,
    "pink red": `rosar\xf6d`,
    "purple": `lila`,
    "purple magenta": `lila magenta`,
    "red": `R\xf6tt`,
    "red orange": `r\xf6dorange`,
    "saturation": `M\xe4ttnad`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} genomskinlig`,
    "very dark": `mycket m\xf6rk`,
    "very light": `mycket ljus`,
    "vibrant": `livfull`,
    "white": `vit`,
    "yellow": `gul`,
    "yellow green": `gulgr\xf6n`
};

});

parcelRegister("dqBVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $079e0084db1fd820$export$2e2bcd8739ae039);
var $079e0084db1fd820$export$2e2bcd8739ae039 = {};
$079e0084db1fd820$export$2e2bcd8739ae039 = {
    "alpha": `Alfa`,
    "black": `siyah`,
    "blue": `Mavi`,
    "blue purple": `mavi mor`,
    "brightness": `Parlakl\u{131}k`,
    "brown": `kahverengi`,
    "brown yellow": `kahverengi sar\u{131}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `camg\xf6be\u{11F}i`,
    "cyan blue": `camg\xf6be\u{11F}i mavi`,
    "dark": `koyu`,
    "gray": `gri`,
    "grayish": `grimsi`,
    "green": `Ye\u{15F}il`,
    "green cyan": `ye\u{15F}il camg\xf6be\u{11F}i`,
    "hue": `Ton`,
    "light": `a\xe7\u{131}k`,
    "lightness": `Canl\u{131}l\u{131}k`,
    "magenta": `eflatun`,
    "magenta pink": `eflatun pembe`,
    "orange": `turuncu`,
    "orange yellow": `turuncu sar\u{131}`,
    "pale": `solgun`,
    "pink": `pembe`,
    "pink red": `pembe k\u{131}rm\u{131}z\u{131}`,
    "purple": `mor`,
    "purple magenta": `mor eflatun`,
    "red": `K\u{131}rm\u{131}z\u{131}`,
    "red orange": `k\u{131}rm\u{131}z\u{131} portakal`,
    "saturation": `Doygunluk`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} saydam`,
    "very dark": `\xe7ok koyu`,
    "very light": `\xe7ok a\xe7\u{131}k`,
    "vibrant": `canl\u{131}`,
    "white": `beyaz`,
    "yellow": `sar\u{131}`,
    "yellow green": `sar\u{131} ye\u{15F}il`
};

});

parcelRegister("421bv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf0552a5c8dfe68$export$2e2bcd8739ae039);
var $7cf0552a5c8dfe68$export$2e2bcd8739ae039 = {};
$7cf0552a5c8dfe68$export$2e2bcd8739ae039 = {
    "alpha": `\u{410}\u{43B}\u{44C}\u{444}\u{430}`,
    "black": `\u{447}\u{43E}\u{440}\u{43D}\u{438}\u{439}`,
    "blue": `\u{421}\u{438}\u{43D}\u{456}\u{439}`,
    "blue purple": `\u{441}\u{438}\u{43D}\u{44C}\u{43E}-\u{444}\u{456}\u{43E}\u{43B}\u{435}\u{442}\u{43E}\u{432}\u{438}\u{439}`,
    "brightness": `\u{42F}\u{441}\u{43A}\u{440}\u{430}\u{432}\u{456}\u{441}\u{442}\u{44C}`,
    "brown": `\u{43A}\u{43E}\u{440}\u{438}\u{447}\u{43D}\u{435}\u{432}\u{438}\u{439}`,
    "brown yellow": `\u{43A}\u{43E}\u{440}\u{438}\u{447}\u{43D}\u{435}\u{432}\u{43E}-\u{436}\u{43E}\u{432}\u{442}\u{438}\u{439}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{431}\u{43B}\u{430}\u{43A}\u{438}\u{442}\u{43D}\u{438}\u{439}`,
    "cyan blue": `\u{441}\u{438}\u{43D}\u{44C}\u{43E}-\u{431}\u{43B}\u{430}\u{43A}\u{438}\u{442}\u{43D}\u{438}\u{439}`,
    "dark": `\u{442}\u{435}\u{43C}\u{43D}\u{438}\u{439}`,
    "gray": `\u{441}\u{456}\u{440}\u{438}\u{439}`,
    "grayish": `\u{441}\u{456}\u{440}\u{443}\u{432}\u{430}\u{442}\u{438}\u{439}`,
    "green": `\u{417}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{439}`,
    "green cyan": `\u{437}\u{435}\u{43B}\u{435}\u{43D}\u{43E}-\u{431}\u{43B}\u{430}\u{43A}\u{438}\u{442}\u{43D}\u{438}\u{439}`,
    "hue": `\u{422}\u{43E}\u{43D}`,
    "light": `\u{441}\u{432}\u{456}\u{442}\u{43B}\u{438}\u{439}`,
    "lightness": `\u{41E}\u{441}\u{432}\u{456}\u{442}\u{43B}\u{435}\u{43D}\u{456}\u{441}\u{442}\u{44C}`,
    "magenta": `\u{43F}\u{443}\u{440}\u{43F}\u{443}\u{440}\u{43E}\u{432}\u{438}\u{439}`,
    "magenta pink": `\u{43F}\u{443}\u{440}\u{43F}\u{443}\u{440}\u{43E}\u{432}\u{43E}-\u{440}\u{43E}\u{436}\u{435}\u{432}\u{438}\u{439}`,
    "orange": `\u{43F}\u{43E}\u{43C}\u{430}\u{440}\u{430}\u{43D}\u{447}\u{435}\u{432}\u{438}\u{439}`,
    "orange yellow": `\u{43F}\u{43E}\u{43C}\u{430}\u{440}\u{430}\u{43D}\u{447}\u{435}\u{432}\u{43E}-\u{436}\u{43E}\u{432}\u{442}\u{438}\u{439}`,
    "pale": `\u{431}\u{43B}\u{456}\u{434}\u{438}\u{439}`,
    "pink": `\u{440}\u{43E}\u{436}\u{435}\u{432}\u{438}\u{439}`,
    "pink red": `\u{440}\u{43E}\u{436}\u{435}\u{432}\u{43E}-\u{447}\u{435}\u{440}\u{432}\u{43E}\u{43D}\u{438}\u{439}`,
    "purple": `\u{444}\u{456}\u{43E}\u{43B}\u{435}\u{442}\u{43E}\u{432}\u{438}\u{439}`,
    "purple magenta": `\u{444}\u{456}\u{43E}\u{43B}\u{435}\u{442}\u{43E}\u{432}\u{43E}-\u{43F}\u{443}\u{440}\u{43F}\u{443}\u{440}\u{43E}\u{432}\u{438}\u{439}`,
    "red": `\u{427}\u{435}\u{440}\u{432}\u{43E}\u{43D}\u{438}\u{439}`,
    "red orange": `\u{447}\u{435}\u{440}\u{432}\u{43E}\u{43D}\u{43E}-\u{43F}\u{43E}\u{43C}\u{430}\u{440}\u{430}\u{43D}\u{447}\u{435}\u{432}\u{438}\u{439}`,
    "saturation": `\u{41D}\u{430}\u{441}\u{438}\u{447}\u{435}\u{43D}\u{456}\u{441}\u{442}\u{44C}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, \u{43F}\u{440}\u{43E}\u{437}\u{43E}\u{440}\u{438}\u{439} \u{43D}\u{430} ${args.percentTransparent}`,
    "very dark": `\u{434}\u{443}\u{436}\u{435} \u{442}\u{435}\u{43C}\u{43D}\u{438}\u{439}`,
    "very light": `\u{434}\u{443}\u{436}\u{435} \u{441}\u{432}\u{456}\u{442}\u{43B}\u{438}\u{439}`,
    "vibrant": `\u{44F}\u{441}\u{43A}\u{440}\u{430}\u{432}\u{438}\u{439}`,
    "white": `\u{431}\u{456}\u{43B}\u{438}\u{439}`,
    "yellow": `\u{436}\u{43E}\u{432}\u{442}\u{438}\u{439}`,
    "yellow green": `\u{436}\u{43E}\u{432}\u{442}\u{43E}-\u{437}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{439}`
};

});

parcelRegister("9d0LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $28af1883b4304b12$export$2e2bcd8739ae039);
var $28af1883b4304b12$export$2e2bcd8739ae039 = {};
$28af1883b4304b12$export$2e2bcd8739ae039 = {
    "alpha": `Alpha`,
    "black": `\u{9ED1}\u{8272}`,
    "blue": `\u{84DD}\u{8272}`,
    "blue purple": `\u{84DD}\u{7D2B}\u{8272}`,
    "brightness": `\u{4EAE}\u{5EA6}`,
    "brown": `\u{68D5}\u{8272}\u{7684}`,
    "brown yellow": `\u{68D5}\u{9EC4}\u{8272}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{84DD}\u{7EFF}\u{8272}`,
    "cyan blue": `\u{9752}\u{84DD}\u{8272}`,
    "dark": `\u{6DF1}\u{8272}`,
    "gray": `\u{7070}\u{8272}`,
    "grayish": `\u{6D45}\u{7070}\u{8272}\u{7684}`,
    "green": `\u{7EFF}\u{8272}`,
    "green cyan": `\u{7EFF}\u{9752}\u{8272}`,
    "hue": `\u{8272}\u{76F8}`,
    "light": `\u{6D45}\u{8272}`,
    "lightness": `\u{660E}\u{4EAE}\u{5EA6}`,
    "magenta": `\u{7D2B}\u{7EA2}\u{8272}`,
    "magenta pink": `\u{7D2B}\u{7C89}\u{8272}`,
    "orange": `\u{6A59}\u{8272}`,
    "orange yellow": `\u{6A59}\u{9EC4}\u{8272}`,
    "pale": `\u{82CD}\u{767D}\u{7684}`,
    "pink": `\u{7C89}\u{8272}`,
    "pink red": `\u{7C89}\u{7EA2}\u{8272}`,
    "purple": `\u{7D2B}\u{8272}`,
    "purple magenta": `\u{7D2B}\u{6D0B}\u{7EA2}\u{8272}`,
    "red": `\u{7EA2}\u{8272}`,
    "red orange": `\u{7EA2}\u{6A59}\u{8272}`,
    "saturation": `\u{9971}\u{548C}\u{5EA6}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{900F}\u{660E}`,
    "very dark": `\u{5F88}\u{6697}`,
    "very light": `\u{5F88}\u{6D45}`,
    "vibrant": `\u{751F}\u{673A}\u{52C3}\u{52C3}`,
    "white": `\u{767D}\u{8272}`,
    "yellow": `\u{9EC4}\u{8272}`,
    "yellow green": `\u{9EC4}\u{8272}/\u{7EFF}\u{8272}`
};

});

parcelRegister("8b6lW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd217e075be019e9$export$2e2bcd8739ae039);
var $dd217e075be019e9$export$2e2bcd8739ae039 = {};
$dd217e075be019e9$export$2e2bcd8739ae039 = {
    "alpha": `Alpha`,
    "black": `\u{9ED1}`,
    "blue": `\u{85CD}\u{8272}`,
    "blue purple": `\u{85CD}\u{7D2B}`,
    "brightness": `\u{4EAE}\u{5EA6}`,
    "brown": `\u{68D5}`,
    "brown yellow": `\u{68D5}\u{9EC3}`,
    "colorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}`,
    "cyan": `\u{9752}`,
    "cyan blue": `\u{9752}\u{85CD}`,
    "dark": `\u{6697}`,
    "gray": `\u{7070}`,
    "grayish": `\u{504F}\u{7070}`,
    "green": `\u{7DA0}\u{8272}`,
    "green cyan": `\u{9752}\u{7DA0}`,
    "hue": `\u{8272}\u{76F8}`,
    "light": `\u{6DFA}`,
    "lightness": `\u{660E}\u{4EAE}`,
    "magenta": `\u{6D0B}\u{7D05}`,
    "magenta pink": `\u{6DFA}\u{6D0B}\u{7D05}`,
    "orange": `\u{6A59}`,
    "orange yellow": `\u{6A59}\u{9EC3}`,
    "pale": `\u{6DE1}`,
    "pink": `\u{7C89}\u{7D05}`,
    "pink red": `\u{7C89}\u{7D05}`,
    "purple": `\u{7D2B}`,
    "purple magenta": `\u{7D2B}\u{6D0B}\u{7D05}`,
    "red": `\u{7D05}\u{8272}`,
    "red orange": `\u{6A59}\u{7D05}`,
    "saturation": `\u{98FD}\u{548C}\u{5EA6}`,
    "transparentColorName": (args)=>`${args.lightness} ${args.chroma} ${args.hue}, ${args.percentTransparent} \u{900F}\u{660E}`,
    "very dark": `\u{5F88}\u{6697}`,
    "very light": `\u{5F88}\u{6DFA}`,
    "vibrant": `\u{9BAE}\u{8C54}`,
    "white": `\u{767D}`,
    "yellow": `\u{9EC3}`,
    "yellow green": `\u{9EC3}\u{7DA0}`
};

});



parcelRegister("6lZyT", function(module, exports) {

$parcel$export(module.exports, "OBJECT_FIT", () => $4a04751b797e733f$export$b8794f3631979dac);
$parcel$export(module.exports, "OBJECT_POSITION", () => $4a04751b797e733f$export$bc152aea625f7e8d);
$parcel$export(module.exports, "imageBlobToDataUrl", () => $4a04751b797e733f$export$46306eb2e7d64c7a);
$parcel$export(module.exports, "getImageBlobDimensions", () => $4a04751b797e733f$export$2887e94ce3d9564e);
$parcel$export(module.exports, "resizeImageBlob", () => $4a04751b797e733f$export$255106b75cb4538e);
$parcel$export(module.exports, "convertImageBlobToType", () => $4a04751b797e733f$export$a6f50fcad385ea7a);
$parcel$export(module.exports, "cropImageBlob", () => $4a04751b797e733f$export$40b763a8ad657c4e);
$parcel$export(module.exports, "cropImageBlobToBbox", () => $4a04751b797e733f$export$3a37269357f89abb);
$parcel$export(module.exports, "createImageColorBlob", () => $4a04751b797e733f$export$bc1e14e6102aaeac);
const $4a04751b797e733f$export$2b856535b6d3fa77 = 4000000;
const $4a04751b797e733f$export$36e3680e58243075 = 2000000;
const $4a04751b797e733f$export$b8794f3631979dac = {
    COVER: "cover",
    CONTAIN: "contain"
};
const $4a04751b797e733f$export$bc152aea625f7e8d = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right",
    TOP: "top",
    BOTTOM: "bottom"
};
const $4a04751b797e733f$export$46306eb2e7d64c7a = (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
const $4a04751b797e733f$var$loadImageBlob = (imageBlob)=>new Promise((resolve, reject)=>{
        const img = new window.Image();
        const url = URL.createObjectURL(imageBlob);
        img.onload = ()=>{
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = ()=>{
            URL.revokeObjectURL(url);
            reject(new Error("Failed to decode image"));
        };
        try {
            img.src = url;
        } catch (error) {
            URL.revokeObjectURL(url);
            reject(error);
        }
    });
const $4a04751b797e733f$var$validateDimensions = (width, height)=>{
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) throw new Error("Image dimensions must be finite and positive");
};
const $4a04751b797e733f$var$limitDimensions = (width, height, maxPixels)=>{
    $4a04751b797e733f$var$validateDimensions(width, height);
    if (!Number.isFinite(maxPixels) || maxPixels < 1) throw new Error("Image pixel limit must be at least 1");
    const scale = Math.min(1, Math.sqrt(maxPixels / (width * height)));
    let targetWidth = Math.max(1, Math.floor(width * scale));
    let targetHeight = Math.max(1, Math.floor(height * scale));
    // Clamping a very narrow side to one pixel can put the area over the limit.
    if (targetWidth * targetHeight > maxPixels) {
        if (targetWidth >= targetHeight) targetWidth = Math.floor(maxPixels / targetHeight);
        else targetHeight = Math.floor(maxPixels / targetWidth);
    }
    return {
        width: targetWidth,
        height: targetHeight
    };
};
const $4a04751b797e733f$var$canvasToBlob = (canvas, type)=>new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) resolve(blob);
            else reject(new Error("Failed to encode image"));
        }, type);
    });
const $4a04751b797e733f$var$createCanvas = (width, height)=>{
    $4a04751b797e733f$var$validateDimensions(width, height);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Image canvas context is unavailable");
    return {
        canvas: canvas,
        ctx: ctx
    };
};
const $4a04751b797e733f$export$2887e94ce3d9564e = async (imageBlob)=>{
    const img = await $4a04751b797e733f$var$loadImageBlob(imageBlob);
    $4a04751b797e733f$var$validateDimensions(img.width, img.height);
    return {
        width: img.width,
        height: img.height
    };
};
const $4a04751b797e733f$export$255106b75cb4538e = async (imageBlob, dimensions, maxPixels = $4a04751b797e733f$export$2b856535b6d3fa77)=>{
    const { width: width, height: height } = $4a04751b797e733f$var$limitDimensions(dimensions.width, dimensions.height, maxPixels);
    if (width === dimensions.width && height === dimensions.height) return imageBlob;
    const img = await $4a04751b797e733f$var$loadImageBlob(imageBlob);
    const { canvas: canvas, ctx: ctx } = $4a04751b797e733f$var$createCanvas(width, height);
    ctx.drawImage(img, 0, 0, width, height);
    return $4a04751b797e733f$var$canvasToBlob(canvas, imageBlob.type);
};
const $4a04751b797e733f$export$a6f50fcad385ea7a = async (imageBlob, targetType = "jpeg", upscaleSvgFactor = 4)=>{
    const img = await $4a04751b797e733f$var$loadImageBlob(imageBlob);
    let width = img.width;
    let height = img.height;
    if (imageBlob.type === "image/svg+xml") {
        const factor = Math.max(1, upscaleSvgFactor);
        ({ width: width, height: height } = $4a04751b797e733f$var$limitDimensions(width * factor, height * factor, $4a04751b797e733f$export$36e3680e58243075));
    }
    const { canvas: canvas, ctx: ctx } = $4a04751b797e733f$var$createCanvas(width, height);
    ctx.drawImage(img, 0, 0, width, height);
    return $4a04751b797e733f$var$canvasToBlob(canvas, `image/${targetType}`);
};
const $4a04751b797e733f$export$40b763a8ad657c4e = async (imageBlob, containerSize, objectFit = $4a04751b797e733f$export$b8794f3631979dac.COVER, objectPosition = $4a04751b797e733f$export$bc152aea625f7e8d.CENTER)=>{
    const img = await $4a04751b797e733f$var$loadImageBlob(imageBlob);
    const { canvas: canvas, ctx: ctx } = $4a04751b797e733f$var$createCanvas(containerSize.width, containerSize.height);
    const containerRatio = containerSize.width / containerSize.height;
    const imgRatio = img.width / img.height;
    let drawWidth = containerSize.width;
    let drawHeight = containerSize.height;
    let offsetX = 0;
    let offsetY = 0;
    if (objectFit === $4a04751b797e733f$export$b8794f3631979dac.COVER) {
        if (containerRatio > imgRatio) {
            drawHeight = containerSize.width / imgRatio;
            offsetY = (containerSize.height - drawHeight) / 2;
        } else {
            drawWidth = containerSize.height * imgRatio;
            offsetX = (containerSize.width - drawWidth) / 2;
        }
    } else if (objectFit === $4a04751b797e733f$export$b8794f3631979dac.CONTAIN) {
        if (containerRatio > imgRatio) {
            drawWidth = containerSize.height * imgRatio;
            offsetX = (containerSize.width - drawWidth) / 2;
        } else {
            drawHeight = containerSize.width / imgRatio;
            offsetY = (containerSize.height - drawHeight) / 2;
        }
    }
    if (objectPosition === $4a04751b797e733f$export$bc152aea625f7e8d.LEFT) offsetX = 0;
    else if (objectPosition === $4a04751b797e733f$export$bc152aea625f7e8d.RIGHT) offsetX = containerSize.width - drawWidth;
    else if (objectPosition === $4a04751b797e733f$export$bc152aea625f7e8d.TOP) offsetY = 0;
    else if (objectPosition === $4a04751b797e733f$export$bc152aea625f7e8d.BOTTOM) offsetY = containerSize.height - drawHeight;
    ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
    return $4a04751b797e733f$var$canvasToBlob(canvas, imageBlob?.type ?? "image/jpeg");
};
const $4a04751b797e733f$export$3a37269357f89abb = async (imageBlob, { bbox: bbox } = {})=>{
    const img = await $4a04751b797e733f$var$loadImageBlob(imageBlob);
    const { canvas: canvas, ctx: ctx } = $4a04751b797e733f$var$createCanvas(bbox.w, bbox.h);
    ctx.drawImage(img, bbox.x, bbox.y, bbox.w, bbox.h, 0, 0, bbox.w, bbox.h);
    return $4a04751b797e733f$var$canvasToBlob(canvas, imageBlob?.type ?? "image/jpeg");
};
const $4a04751b797e733f$export$bc1e14e6102aaeac = async (color, width = 400, height = 400)=>{
    const { canvas: canvas, ctx: ctx } = $4a04751b797e733f$var$createCanvas(width, height);
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, width, height);
    return $4a04751b797e733f$var$canvasToBlob(canvas, "image/png");
};

});




parcelRegister("aK4qQ", function(module, exports) {

$parcel$export(module.exports, "HoverOverlay", () => $7d21a3599c0a8c0c$export$5b7e6a421a3df3e3);

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");
const $7d21a3599c0a8c0c$export$5b7e6a421a3df3e3 = ({ isHovered: isHovered, icon: Icon, compact: compact = false, radius: radius = "lg" })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        "aria-hidden": true,
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _oa182';
            rules += ' Za182';
            rules += ' Fb182';
            rules += ' sd182';
            rules += ' eb182';
            rules += ' _Ca182';
            rules += ' g7UFYnb182';
            if (props.isSmall) rules += ' ob182';
            else rules += ' oc182';
            if (props.isSmall) rules += ' nb182';
            else rules += ' nc182';
            if (props.isSmall) rules += ' kb182';
            else rules += ' kc182';
            if (props.isSmall) rules += ' jb182';
            else rules += ' jc182';
            rules += ' _Pa182';
            rules += ' Wr182';
            rules += ' _lr182';
            rules += ' _Ar182';
            rules += ' _zr182';
            rules += ' _Ob182';
            if (props.isHovered) rules += ' _Ib182';
            else rules += ' _Ia182';
            rules += ' Ya182';
            rules += ' XCIisn182';
            rules += ' _2b182';
            rules += ' _8sAsZdc182';
            return rules;
        }({
            isHovered: isHovered,
            isSmall: radius === "default"
        }),
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: function anonymous(props) {
                let rules = " ";
                rules += ' gf182';
                rules += ' sd182';
                rules += ' eb182';
                rules += ' _Ca182';
                if (props.isCompact) rules += ' Js182';
                else rules += ' JC182';
                if (props.isCompact) rules += ' Gs182';
                else rules += ' GC182';
                if (props.isCompact) rules += ' Is182';
                else rules += ' IC182';
                if (props.isCompact) rules += ' Hs182';
                else rules += ' HC182';
                if (props.isCompact) rules += ' Tp182';
                else rules += ' Tt182';
                if (props.isCompact) rules += ' Qp182';
                else rules += ' Qt182';
                if (props.isCompact) rules += ' Sp182';
                else rules += ' St182';
                if (props.isCompact) rules += ' Rp182';
                else rules += ' Rt182';
                rules += ' ob182';
                rules += ' nb182';
                rules += ' kb182';
                rules += ' jb182';
                return rules;
            }({
                isCompact: compact
            }),
            children: /*#__PURE__*/ (0, $dx4lB.jsx)(Icon, {})
        })
    });
$7d21a3599c0a8c0c$export$5b7e6a421a3df3e3.propTypes = {
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).elementType.isRequired,
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "lg",
        "default"
    ])
};

});

parcelRegister("g42KE", function(module, exports) {

$parcel$export(module.exports, "resolveCaptionText", () => $bb1f27718ebad5f2$export$8b0e5226eef9486d);
$parcel$export(module.exports, "ThumbnailCaption", () => $bb1f27718ebad5f2$export$de309396c633afc5);

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $208Op = parcelRequire("208Op");
const $bb1f27718ebad5f2$export$8b0e5226eef9486d = (value, fallback)=>value === null ? null : value ?? fallback;
const $bb1f27718ebad5f2$export$8e0b374f8650b6a4 = ({ description: description })=>!!description && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
        children: description
    });
$bb1f27718ebad5f2$export$8e0b374f8650b6a4.propTypes = {
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const $bb1f27718ebad5f2$export$de309396c633afc5 = ({ description: description, contextualHelp: contextualHelp, actions: actions })=>{
    if (!description && !contextualHelp && !actions) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 ed182 Ub182 qb182 Jv182 SssxDec182 RssxDec182",
        children: [
            contextualHelp,
            !!description && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " _ub182 Na182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)($bb1f27718ebad5f2$export$8e0b374f8650b6a4, {
                    description: description
                })
            }),
            !!actions && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " sd182 eb182 Ub182 qb182 IM182 _va182",
                children: actions
            })
        ]
    });
};
$bb1f27718ebad5f2$export$de309396c633afc5.propTypes = {
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    contextualHelp: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};

});


parcelRegister("hjJiG", function(module, exports) {

$parcel$export(module.exports, "ColorAsset", () => $c9b759bea8c44edc$export$51fc38806633062a);

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $eF4cA = parcelRequire("eF4cA");

var $2RdeM = parcelRequire("2RdeM");
var $1RxE8 = parcelRequire("1RxE8");
var $fWQx3 = parcelRequire("fWQx3");
var $fUh73 = parcelRequire("fUh73");
var $aQTiM = parcelRequire("aQTiM");
var $yuTTo = parcelRequire("yuTTo");
var $kQT4E = parcelRequire("kQT4E");
var $2ffAV = parcelRequire("2ffAV");
var $208Op = parcelRequire("208Op");

var $k5Pnh = parcelRequire("k5Pnh");

var $eF93E = parcelRequire("eF93E");

var $aK4qQ = parcelRequire("aK4qQ");

var $g42KE = parcelRequire("g42KE");
const $c9b759bea8c44edc$export$51fc38806633062a = ({ label: label, description: description, contextualHelp: contextualHelp, color: color, colors: colors, name: name, onChange: onChange, isCaptioned: isCaptioned = false, children: children })=>{
    const [isActive, setActive] = (0, $eF4cA.useState)(false);
    const picker = /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
        onOpenChange: setActive,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
                className: (state)=>(function anonymous(props) {
                        let rules = " ";
                        rules += ' _oa182';
                        rules += ' ZywElld182';
                        rules += ' Tp182';
                        rules += ' Qp182';
                        rules += ' Sp182';
                        rules += ' Rp182';
                        rules += ' _kc182';
                        rules += ' hc182';
                        rules += ' mc182';
                        rules += ' lc182';
                        rules += ' _jf182';
                        if (props.isActive) rules += ' ik182';
                        else if (props.isPressed) rules += ' ik182';
                        else if (props.isHovered) rules += ' iOIem5c182';
                        else rules += ' iq182';
                        rules += ' oe182';
                        rules += ' ne182';
                        rules += ' ke182';
                        rules += ' je182';
                        rules += ' _Pc182';
                        rules += ' g9182';
                        rules += ' _Nc182';
                        rules += ' Pc182';
                        rules += ' Yc182';
                        rules += ' Xb182';
                        rules += ' _2b182';
                        return rules;
                    })({
                        ...state,
                        isActive: isActive
                    }),
                children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                variant: "quiet",
                                styles: " Zd182 Na182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                    UNSAFE_className: " fa182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " fa182 -_8LZfRc-gEkQK7c182",
                                        style: {
                                            background: color || "linear-gradient(to bottom right, transparent calc(50% - 2px), var(--slash-color) calc(50% - 2px) calc(50% + 2px), transparent calc(50% + 2px)) no-repeat"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aK4qQ.HoverOverlay), {
                                isHovered: isHovered,
                                icon: (0, $eF93E.default),
                                radius: "default"
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                size: "S",
                placement: "end",
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 _ta182 Uj182 qj182 Te182 Qe182 Se182 Re182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: [
                                    "Select ",
                                    (label || name)?.toLowerCase()
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fUh73.ColorSwatchPicker), {
                            value: !!color ? (0, $kQT4E.parseColor)(color) : undefined,
                            onChange: (color)=>{
                                if (color) onChange?.({
                                    color: color,
                                    name: name
                                });
                            },
                            children: [
                                ...new Set([
                                    ...colors ?? [],
                                    color
                                ])
                            ].map((color)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $fWQx3.ColorSwatch), {
                                    color: color
                                }, color))
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1RxE8.ColorField), {
                            label: "Color",
                            labelPosition: "side",
                            colorSpace: "rgb",
                            value: color || "",
                            onChange: (color)=>onChange({
                                    color: color,
                                    name: name
                                }),
                            prefix: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fWQx3.ColorSwatch), {
                                size: "XS",
                                color: color ? color.toString("hex") : undefined
                            })
                        })
                    ]
                })
            })
        ]
    });
    // A caption below the 72px swatch spans the whole container.
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd182';
            rules += ' _ta182';
            if (props.isCaptioned) rules += ' Za182';
            else rules += ' ZywElld182';
            return rules;
        }({
            isCaptioned: isCaptioned
        }),
        children: [
            !!label && // Only a heading: a `LabeledValue` cannot contain editable values.
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: label,
                value: "",
                contextualHelp: isCaptioned ? undefined : contextualHelp
            }),
            picker,
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $g42KE.ThumbnailCaption), {
                description: description,
                contextualHelp: isCaptioned ? contextualHelp : undefined
            }),
            !!children && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " JC182",
                children: children
            })
        ]
    });
};
$c9b759bea8c44edc$export$51fc38806633062a.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isCaptioned: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    contextualHelp: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};

});
parcelRegister("1RxE8", function(module, exports) {

$parcel$export(module.exports, "ColorField", () => $d1cac75fbc0a14ea$export$b865d4358897bb17);


var $3PqDc = parcelRequire("3PqDc");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $hjld4 = parcelRequire("hjld4");

var $eF4cA = parcelRequire("eF4cA");

var $ecbit = parcelRequire("ecbit");

var $bkjeZ = parcelRequire("bkjeZ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d1cac75fbc0a14ea$export$44644b8a16031b5b = (0, $eF4cA.createContext)(null);
const $d1cac75fbc0a14ea$export$b865d4358897bb17 = (0, $eF4cA.forwardRef)(function ColorField(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $d1cac75fbc0a14ea$export$44644b8a16031b5b);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props = (0, $j3pTw.useFormProps)(props);
    let { label: label, description: description, errorMessage: errorMessage, necessityIndicator: necessityIndicator, labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', styles: styles, ...fieldProps } = props;
    // Expose imperative interface for ref
    let domRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>({
            ...(0, $3PqDc.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return (0, $dx4lB.jsx)((0, $hjld4.ColorField), {
        ...fieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            size: props.size,
            labelPosition: labelPosition,
            isInForm: !!formContext
        }, styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                        prefix: props.prefix,
                        size: props.size,
                        children: [
                            (0, $dx4lB.jsx)((0, $ecbit.InputContext).Consumer, {
                                children: (ctx)=>(0, $dx4lB.jsx)((0, $ecbit.InputContext).Provider, {
                                        value: {
                                            ...ctx,
                                            ref: (0, $bkjeZ.mergeRefs)(ctx?.ref, inputRef)
                                        },
                                        children: (0, $dx4lB.jsx)((0, $8w4Nl.Input), {})
                                    })
                            }),
                            isInvalid && (0, $dx4lB.jsx)((0, $8w4Nl.FieldErrorIcon), {
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});

});
parcelRegister("hjld4", function(module, exports) {

$parcel$export(module.exports, "ColorField", () => $66dfcf1e597d9408$export$b865d4358897bb17);

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $cTXxz = parcelRequire("cTXxz");

var $ecbit = parcelRequire("ecbit");

var $8UElq = parcelRequire("8UElq");

var $c1ibQ = parcelRequire("c1ibQ");

var $hgLJ9 = parcelRequire("hgLJ9");
var $jKA62 = parcelRequire("jKA62");

var $iwZvF = parcelRequire("iwZvF");
var $ifCwf = parcelRequire("ifCwf");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $66dfcf1e597d9408$export$44644b8a16031b5b = (0, $eF4cA.createContext)(null);
const $66dfcf1e597d9408$export$96b6d32b05a1a8ed = (0, $eF4cA.createContext)(null);
const $66dfcf1e597d9408$export$b865d4358897bb17 = (0, $eF4cA.forwardRef)(function ColorField(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $66dfcf1e597d9408$export$44644b8a16031b5b);
    if (props.channel) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$ColorChannelField, {
        ...props,
        channel: props.channel,
        forwardedRef: ref
    });
    else return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$HexColorField, {
        ...props,
        forwardedRef: ref
    });
});
function $66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$ColorChannelField(props) {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let state = (0, $iwZvF.useColorChannelFieldState)({
        ...props,
        locale: locale
    });
    let inputRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $hgLJ9.useColorChannelField)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        validationBehavior: props.validationBehavior ?? 'native'
    }, state, inputRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, $66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$useChildren(props, state, props.forwardedRef, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation), props.name && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
        type: "hidden",
        name: props.name,
        form: props.form,
        value: isNaN(state.numberValue) ? '' : state.numberValue
    }));
}
function $66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$HexColorField(props) {
    let state = (0, $ifCwf.useColorFieldState)({
        ...props,
        validationBehavior: props.validationBehavior ?? 'native'
    });
    let inputRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $jKA62.useColorField)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        validationBehavior: props.validationBehavior ?? 'native'
    }, state, inputRef);
    return $66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$useChildren(props, state, props.forwardedRef, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation);
}
function $66dfcf1e597d9408$var$$baf01eb6a6ce4d91$var$useChildren(props, state, ref, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation) {
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            state: state,
            channel: props.channel || 'hex',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-ColorField'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $66dfcf1e597d9408$export$96b6d32b05a1a8ed,
                state
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-channel": props.channel || 'hex',
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }));
}

});
parcelRegister("hgLJ9", function(module, exports) {

$parcel$export(module.exports, "useColorChannelField", () => $652f5da1b3dc96fa$export$e55dd820142d3131);

var $F7t5Q = parcelRequire("F7t5Q");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $652f5da1b3dc96fa$export$e55dd820142d3131(props, state, inputRef) {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    return (0, $F7t5Q.useNumberField)({
        ...props,
        value: undefined,
        defaultValue: undefined,
        onChange: undefined,
        validate: undefined,
        // Provide a default aria-label if no other label is provided.
        'aria-label': props['aria-label'] || (props.label || props['aria-labelledby'] ? undefined : state.colorValue.getChannelName(props.channel, locale))
    }, state, inputRef);
}

});
parcelRegister("F7t5Q", function(module, exports) {

$parcel$export(module.exports, "useNumberField", () => $569447b620135edf$export$23f548e970bdf099);

var $4HiHF = parcelRequire("4HiHF");

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $IK8A1 = parcelRequire("IK8A1");

var $11FxZ = parcelRequire("11FxZ");

var $lhKAD = parcelRequire("lhKAD");

var $4bE7h = parcelRequire("4bE7h");

var $i1DSg = parcelRequire("i1DSg");

var $dbHGI = parcelRequire("dbHGI");

var $3rgVl = parcelRequire("3rgVl");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $4skXn = parcelRequire("4skXn");

var $gI8Gw = parcelRequire("gI8Gw");

var $e62p6 = parcelRequire("e62p6");

var $3joGx = parcelRequire("3joGx");

var $eHcWW = parcelRequire("eHcWW");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");

var $iEwfj = parcelRequire("iEwfj");
function $569447b620135edf$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $569447b620135edf$export$23f548e970bdf099(props, state, inputRef) {
    let { id: id, decrementAriaLabel: decrementAriaLabel, incrementAriaLabel: incrementAriaLabel, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, minValue: minValue, maxValue: maxValue, autoFocus: autoFocus, label: label, formatOptions: formatOptions, onBlur: onBlur = ()=>{}, onFocus: onFocus, onFocusChange: onFocusChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, description: description, errorMessage: errorMessage, isWheelDisabled: isWheelDisabled, ...otherProps } = props;
    let { increment: increment, incrementToMax: incrementToMax, decrement: decrement, decrementToMin: decrementToMin, numberValue: numberValue, inputValue: inputValue, commit: commit, commitValidation: commitValidation } = state;
    const stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($569447b620135edf$var$$parcel$interopDefault((0, $IK8A1.default)), '@react-aria/numberfield');
    let commitAndAnnounce = (0, $eF4cA.useCallback)(()=>{
        let oldValue = inputRef.current?.value ?? '';
        (0, $l19Vn.flushSync)(()=>{
            commit();
        });
        if (inputRef.current?.value !== oldValue) (0, $4HiHF.announce)(inputRef.current?.value ?? '', 'assertive');
    }, [
        commit,
        inputRef
    ]);
    let inputId = (0, $25dFS.useId)(id);
    let { focusProps: focusProps } = (0, $4bE7h.useFocus)({
        onBlur () {
            commitAndAnnounce();
        }
    });
    let numberFormatter = (0, $e62p6.useNumberFormatter)(formatOptions);
    let intlOptions = (0, $eF4cA.useMemo)(()=>numberFormatter.resolvedOptions(), [
        numberFormatter
    ]);
    // Replace negative textValue formatted using currencySign: 'accounting'
    // with a textValue that can be announced using a minus sign.
    let textValueFormatter = (0, $e62p6.useNumberFormatter)({
        ...formatOptions,
        currencySign: undefined
    });
    let textValue = (0, $eF4cA.useMemo)(()=>isNaN(numberValue) ? '' : textValueFormatter.format(numberValue), [
        textValueFormatter,
        numberValue
    ]);
    let { spinButtonProps: spinButtonProps, incrementButtonProps: incButtonProps, decrementButtonProps: decButtonProps } = (0, $eHcWW.useSpinButton)({
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        maxValue: maxValue,
        minValue: minValue,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: numberValue,
        textValue: textValue
    });
    let [focusWithin, setFocusWithin] = (0, $eF4cA.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        isDisabled: isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, $eF4cA.useCallback)((e)=>{
        // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
        // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
        // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
        // especially if the user is scrolling near 45deg
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, $3joGx.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, inputRef);
    // The inputMode attribute influences the software keyboard that is shown on touch devices.
    // Browsers and operating systems are quite inconsistent about what keys are available, however.
    // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
    // and based on testing on various devices to determine what keys are available in each inputMode.
    let hasDecimals = (intlOptions.maximumFractionDigits ?? 0) > 0;
    let hasNegative = state.minValue === undefined || isNaN(state.minValue) || state.minValue < 0;
    let inputMode = 'numeric';
    if ((0, $11FxZ.isIPhone)()) {
        // iPhone doesn't have a minus sign in either numeric or decimal.
        // Note this is only for iPhone, not iPad, which always has both
        // minus and decimal in numeric.
        if (hasNegative) inputMode = 'text';
        else if (hasDecimals) inputMode = 'decimal';
    } else if ((0, $11FxZ.isAndroid)()) {
        // Android numeric has both a decimal point and minus key.
        // decimal does not have a minus key.
        if (hasNegative) inputMode = 'numeric';
        else if (hasDecimals) inputMode = 'decimal';
    }
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let onPaste = (e)=>{
        props.onPaste?.(e);
        let inputElement = (0, $fvyIQ.getEventTarget)(e);
        // we can only handle the case where the paste takes over the entire input, otherwise things get very complicated
        // trying to calculate the new string based on what the paste is replacing and where in the source string it is
        if (inputElement && (inputElement.selectionEnd ?? -1) - (inputElement.selectionStart ?? 0) === inputElement.value.length) {
            e.preventDefault();
            // commit so that the user gets to see what it formats to immediately
            // paste happens before inputRef's value is updated, so have to prevent the default and do it ourselves
            // spin button will then handle announcing the new value, this should work with controlled state as well
            // because the announcement is done as a result of the new rendered input value if there is one
            commit(e.clipboardData?.getData?.('text/plain')?.trim() ?? '');
        }
    };
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        isDisabled: isDisabled || isReadOnly,
        shortcuts: {
            Enter: ()=>{
                (0, $l19Vn.flushSync)(()=>{
                    commit();
                });
                commitValidation();
                return {
                    shouldPreventDefault: false
                };
            }
        },
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, inputProps: textFieldPropsFromHook, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $dbHGI.useFormattedTextField)({
        ...otherProps,
        ...domProps,
        // These props are added to a hidden input rather than the formatted textfield.
        name: undefined,
        form: undefined,
        label: label,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        validate: undefined,
        [(0, $iEwfj.privateValidationStateProp)]: state,
        value: inputValue,
        defaultValue: '!',
        autoComplete: 'off',
        'aria-label': props['aria-label'] || undefined,
        'aria-labelledby': props['aria-labelledby'] || undefined,
        id: inputId,
        type: 'text',
        inputMode: inputMode,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange,
        onPaste: onPaste,
        description: description,
        errorMessage: errorMessage
    }, state, inputRef);
    // Merge outside useFormattedTextField so useKeyboard's createEventHandler is not nested inside
    // useTextField/useFocusable's createEventHandler (avoids redundant stopPropagation on RS events).
    // Shortcuts run first (mergeProps chains the second argument after the first).
    let textFieldProps = (0, $lhKAD.mergeProps)(keyboardProps, textFieldPropsFromHook);
    (0, $3rgVl.useFormReset)(inputRef, state.defaultNumberValue, state.setNumberValue);
    $569447b620135edf$var$$cd2fa56213693c5e$var$useNativeValidation(state, props.validationBehavior, props.commitBehavior, inputRef, state.minValue, state.maxValue, props.step, state.numberValue);
    let inputProps = (0, $lhKAD.mergeProps)(spinButtonProps, focusProps, textFieldProps, {
        // override the spinbutton role, we can't focus a spin button with VO
        role: null,
        // ignore aria-roledescription on iOS so that required state will announce when it is present
        'aria-roledescription': !(0, $11FxZ.isIOS)() ? stringFormatter.format('numberField') : null,
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null,
        'aria-valuetext': null,
        autoCorrect: 'off',
        spellCheck: 'false'
    });
    if (props.validationBehavior === 'native') inputProps['aria-required'] = undefined;
    let onButtonPressStart = (e)=>{
        // If focus is already on the input, keep it there so we don't hide the
        // software keyboard when tapping the increment/decrement buttons.
        if ((0, $fvyIQ.getActiveElement)() === inputRef.current) return;
        // Otherwise, when using a mouse, move focus to the input.
        // On touch, or with a screen reader, focus the button so that the software
        // keyboard does not appear and the screen reader cursor is not moved off the button.
        if (e.pointerType === 'mouse') inputRef.current?.focus();
        else e.target.focus();
    };
    // Determine the label for the increment and decrement buttons. There are 4 cases:
    //
    // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
    // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
    // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
    // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
    //
    // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
    // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
    // the order or add additional words around the label if needed.
    let fieldLabel = props['aria-label'] || (typeof props.label === 'string' ? props.label : '');
    let ariaLabelledby;
    if (!fieldLabel) ariaLabelledby = props.label != null ? labelProps.id : props['aria-labelledby'];
    let incrementId = (0, $25dFS.useId)();
    let decrementId = (0, $25dFS.useId)();
    // oxlint-disable-next-line react/react-compiler
    let incrementButtonProps = (0, $lhKAD.mergeProps)(incButtonProps, {
        'aria-label': incrementAriaLabel || stringFormatter.format('increase', {
            fieldLabel: fieldLabel
        }).trim(),
        id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
        'aria-labelledby': ariaLabelledby && !incrementAriaLabel ? `${incrementId} ${ariaLabelledby}` : null,
        'aria-controls': inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canIncrement,
        onPressStart: onButtonPressStart
    });
    // oxlint-disable-next-line react/react-compiler
    let decrementButtonProps = (0, $lhKAD.mergeProps)(decButtonProps, {
        'aria-label': decrementAriaLabel || stringFormatter.format('decrease', {
            fieldLabel: fieldLabel
        }).trim(),
        id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
        'aria-labelledby': ariaLabelledby && !decrementAriaLabel ? `${decrementId} ${ariaLabelledby}` : null,
        'aria-controls': inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canDecrement,
        onPressStart: onButtonPressStart
    });
    return {
        groupProps: {
            ...focusWithinProps,
            role: 'group',
            'aria-disabled': isDisabled,
            'aria-invalid': isInvalid ? 'true' : undefined
        },
        labelProps: labelProps,
        inputProps: inputProps,
        incrementButtonProps: incrementButtonProps,
        decrementButtonProps: decrementButtonProps,
        errorMessageProps: errorMessageProps,
        descriptionProps: descriptionProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
let $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput = null;
function $569447b620135edf$var$$cd2fa56213693c5e$var$useNativeValidation(state, validationBehavior, commitBehavior, inputRef, min, max, step, value) {
    (0, $4skXn.useLayoutEffect)(()=>{
        let input = inputRef.current;
        if (commitBehavior !== 'validate' || state.realtimeValidation.isInvalid || !input || input.disabled) return;
        // Create a native number input and use it to implement validation of min/max/step.
        // This lets us get the native validation message provided by the browser instead of needing our own translations.
        if (!$569447b620135edf$var$$cd2fa56213693c5e$var$numberInput && typeof document !== 'undefined') {
            $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput = document.createElement('input');
            $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.type = 'number';
        }
        if (!$569447b620135edf$var$$cd2fa56213693c5e$var$numberInput) return;
        $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.min = min != null && !isNaN(min) ? String(min) : '';
        $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.max = max != null && !isNaN(max) ? String(max) : '';
        $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.step = step != null && !isNaN(step) ? String(step) : '';
        $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.value = value != null && !isNaN(value) ? String(value) : '';
        // Merge validity with the visible text input (for other validations like required).
        let valid = input.validity.valid && $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validity.valid;
        let validationMessage = input.validationMessage || $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validationMessage;
        let validity = {
            isInvalid: !valid,
            validationErrors: validationMessage ? [
                validationMessage
            ] : [],
            validationDetails: {
                badInput: input.validity.badInput,
                customError: input.validity.customError,
                patternMismatch: input.validity.patternMismatch,
                rangeOverflow: $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validity.rangeOverflow,
                rangeUnderflow: $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validity.rangeUnderflow,
                stepMismatch: $569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validity.stepMismatch,
                tooLong: input.validity.tooLong,
                tooShort: input.validity.tooShort,
                typeMismatch: input.validity.typeMismatch,
                valueMissing: input.validity.valueMissing,
                valid: valid
            }
        };
        state.updateValidation(validity);
        // Block form submission if validation behavior is native.
        // This won't overwrite any user-defined validation message because we checked realtimeValidation above.
        if (validationBehavior === 'native' && !$569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validity.valid) input.setCustomValidity($569447b620135edf$var$$cd2fa56213693c5e$var$numberInput.validationMessage);
    });
}

});
parcelRegister("IK8A1", function(module, exports) {

$parcel$export(module.exports, "default", () => $244b4acdc53c5956$export$2e2bcd8739ae039);

var $ciLqv = parcelRequire("ciLqv");

var $bXcgH = parcelRequire("bXcgH");

var $iMyuP = parcelRequire("iMyuP");

var $etmHX = parcelRequire("etmHX");

var $4TYjW = parcelRequire("4TYjW");

var $gfZaw = parcelRequire("gfZaw");

var $kbD4H = parcelRequire("kbD4H");

var $6Bl8i = parcelRequire("6Bl8i");

var $6BzBp = parcelRequire("6BzBp");

var $5zDeE = parcelRequire("5zDeE");

var $6XdEU = parcelRequire("6XdEU");

var $bOWRm = parcelRequire("bOWRm");

var $5oYLv = parcelRequire("5oYLv");

var $6q8XH = parcelRequire("6q8XH");

var $4WKnT = parcelRequire("4WKnT");

var $b6DCf = parcelRequire("b6DCf");

var $cXHvK = parcelRequire("cXHvK");

var $8Huzx = parcelRequire("8Huzx");

var $chxlx = parcelRequire("chxlx");

var $4EwrA = parcelRequire("4EwrA");

var $e6YmO = parcelRequire("e6YmO");

var $c8Pcm = parcelRequire("c8Pcm");

var $3wnvI = parcelRequire("3wnvI");

var $f7Myi = parcelRequire("f7Myi");

var $hdJVG = parcelRequire("hdJVG");

var $5GbAJ = parcelRequire("5GbAJ");

var $97cJT = parcelRequire("97cJT");

var $2zbxH = parcelRequire("2zbxH");

var $gXurm = parcelRequire("gXurm");

var $9Ev7I = parcelRequire("9Ev7I");

var $ft5dF = parcelRequire("ft5dF");

var $39xjr = parcelRequire("39xjr");

var $iBo0U = parcelRequire("iBo0U");

var $72Yge = parcelRequire("72Yge");
var $244b4acdc53c5956$export$2e2bcd8739ae039 = {};
$244b4acdc53c5956$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $ciLqv.default),
    "bg-BG": (0, $bXcgH.default),
    "cs-CZ": (0, $iMyuP.default),
    "da-DK": (0, $etmHX.default),
    "de-DE": (0, $4TYjW.default),
    "el-GR": (0, $gfZaw.default),
    "en-US": (0, $kbD4H.default),
    "es-ES": (0, $6Bl8i.default),
    "et-EE": (0, $6BzBp.default),
    "fi-FI": (0, $5zDeE.default),
    "fr-FR": (0, $6XdEU.default),
    "he-IL": (0, $bOWRm.default),
    "hr-HR": (0, $5oYLv.default),
    "hu-HU": (0, $6q8XH.default),
    "it-IT": (0, $4WKnT.default),
    "ja-JP": (0, $b6DCf.default),
    "ko-KR": (0, $cXHvK.default),
    "lt-LT": (0, $8Huzx.default),
    "lv-LV": (0, $chxlx.default),
    "nb-NO": (0, $4EwrA.default),
    "nl-NL": (0, $e6YmO.default),
    "pl-PL": (0, $c8Pcm.default),
    "pt-BR": (0, $3wnvI.default),
    "pt-PT": (0, $f7Myi.default),
    "ro-RO": (0, $hdJVG.default),
    "ru-RU": (0, $5GbAJ.default),
    "sk-SK": (0, $97cJT.default),
    "sl-SI": (0, $2zbxH.default),
    "sr-SP": (0, $gXurm.default),
    "sv-SE": (0, $9Ev7I.default),
    "tr-TR": (0, $ft5dF.default),
    "uk-UA": (0, $39xjr.default),
    "zh-CN": (0, $iBo0U.default),
    "zh-TW": (0, $72Yge.default)
};

});
parcelRegister("ciLqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $77db1620ccf0750a$export$2e2bcd8739ae039);
var $77db1620ccf0750a$export$2e2bcd8739ae039 = {};
$77db1620ccf0750a$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{62E}\u{641}\u{636} ${args.fieldLabel}`,
    "increase": (args)=>`\u{632}\u{64A}\u{627}\u{62F}\u{629} ${args.fieldLabel}`,
    "numberField": `\u{62D}\u{642}\u{644} \u{631}\u{642}\u{645}\u{64A}`
};

});

parcelRegister("bXcgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9106aaf55e1b6356$export$2e2bcd8739ae039);
var $9106aaf55e1b6356$export$2e2bcd8739ae039 = {};
$9106aaf55e1b6356$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{41D}\u{430}\u{43C}\u{430}\u{43B}\u{44F}\u{432}\u{430}\u{43D}\u{435} ${args.fieldLabel}`,
    "increase": (args)=>`\u{423}\u{441}\u{438}\u{43B}\u{432}\u{430}\u{43D}\u{435} ${args.fieldLabel}`,
    "numberField": `\u{41D}\u{43E}\u{43C}\u{435}\u{440} \u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{435}\u{442}\u{43E}`
};

});

parcelRegister("iMyuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $29bba7bbef72805d$export$2e2bcd8739ae039);
var $29bba7bbef72805d$export$2e2bcd8739ae039 = {};
$29bba7bbef72805d$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Sn\xed\u{17E}it ${args.fieldLabel}`,
    "increase": (args)=>`Zv\xfd\u{161}it ${args.fieldLabel}`,
    "numberField": `\u{10C}\xedseln\xe9 pole`
};

});

parcelRegister("etmHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57f18115aaa5dfa$export$2e2bcd8739ae039);
var $f57f18115aaa5dfa$export$2e2bcd8739ae039 = {};
$f57f18115aaa5dfa$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Reducer ${args.fieldLabel}`,
    "increase": (args)=>`\xd8g ${args.fieldLabel}`,
    "numberField": `Talfelt`
};

});

parcelRegister("4TYjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $173f5bac2492025a$export$2e2bcd8739ae039);
var $173f5bac2492025a$export$2e2bcd8739ae039 = {};
$173f5bac2492025a$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`${args.fieldLabel} verringern`,
    "increase": (args)=>`${args.fieldLabel} erh\xf6hen`,
    "numberField": `Nummernfeld`
};

});

parcelRegister("gfZaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be6c58c231796ed$export$2e2bcd8739ae039);
var $5be6c58c231796ed$export$2e2bcd8739ae039 = {};
$5be6c58c231796ed$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{39C}\u{3B5}\u{3AF}\u{3C9}\u{3C3}\u{3B7} ${args.fieldLabel}`,
    "increase": (args)=>`\u{391}\u{3CD}\u{3BE}\u{3B7}\u{3C3}\u{3B7} ${args.fieldLabel}`,
    "numberField": `\u{3A0}\u{3B5}\u{3B4}\u{3AF}\u{3BF} \u{3B1}\u{3C1}\u{3B9}\u{3B8}\u{3BC}\u{3BF}\u{3CD}`
};

});

parcelRegister("kbD4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bcd4bdda8355c28$export$2e2bcd8739ae039);
var $1bcd4bdda8355c28$export$2e2bcd8739ae039 = {};
$1bcd4bdda8355c28$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Decrease ${args.fieldLabel}`,
    "increase": (args)=>`Increase ${args.fieldLabel}`,
    "numberField": `Number field`
};

});

parcelRegister("6Bl8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $77116b1804e4724b$export$2e2bcd8739ae039);
var $77116b1804e4724b$export$2e2bcd8739ae039 = {};
$77116b1804e4724b$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Reducir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de n\xfamero`
};

});

parcelRegister("6BzBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $957b54210801dc67$export$2e2bcd8739ae039);
var $957b54210801dc67$export$2e2bcd8739ae039 = {};
$957b54210801dc67$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`V\xe4henda ${args.fieldLabel}`,
    "increase": (args)=>`Suurenda ${args.fieldLabel}`,
    "numberField": `Numbri v\xe4li`
};

});

parcelRegister("5zDeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7aaac7fc79a092$export$2e2bcd8739ae039);
var $1b7aaac7fc79a092$export$2e2bcd8739ae039 = {};
$1b7aaac7fc79a092$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`V\xe4henn\xe4 ${args.fieldLabel}`,
    "increase": (args)=>`Lis\xe4\xe4 ${args.fieldLabel}`,
    "numberField": `Numerokentt\xe4`
};

});

parcelRegister("6XdEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e4fe7c6acb9ebd$export$2e2bcd8739ae039);
var $f8e4fe7c6acb9ebd$export$2e2bcd8739ae039 = {};
$f8e4fe7c6acb9ebd$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Diminuer ${args.fieldLabel}`,
    "increase": (args)=>`Augmenter ${args.fieldLabel}`,
    "numberField": `Champ de nombre`
};

});

parcelRegister("bOWRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1fae46191d18fc6$export$2e2bcd8739ae039);
var $c1fae46191d18fc6$export$2e2bcd8739ae039 = {};
$c1fae46191d18fc6$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{5D4}\u{5E7}\u{5D8}\u{5DF} ${args.fieldLabel}`,
    "increase": (args)=>`\u{5D4}\u{5D2}\u{5D3}\u{5DC} ${args.fieldLabel}`,
    "numberField": `\u{5E9}\u{5D3}\u{5D4} \u{5DE}\u{5E1}\u{5E4}\u{5E8}`
};

});

parcelRegister("5oYLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d83828f3dfa7af$export$2e2bcd8739ae039);
var $03d83828f3dfa7af$export$2e2bcd8739ae039 = {};
$03d83828f3dfa7af$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{107}aj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};

});

parcelRegister("6q8XH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b69ee2fb53985b4$export$2e2bcd8739ae039);
var $2b69ee2fb53985b4$export$2e2bcd8739ae039 = {};
$2b69ee2fb53985b4$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`${args.fieldLabel} cs\xf6kkent\xe9se`,
    "increase": (args)=>`${args.fieldLabel} n\xf6vel\xe9se`,
    "numberField": `Sz\xe1mmez\u{151}`
};

});

parcelRegister("4WKnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $90be642bb0ffb1d1$export$2e2bcd8739ae039);
var $90be642bb0ffb1d1$export$2e2bcd8739ae039 = {};
$90be642bb0ffb1d1$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Riduci ${args.fieldLabel}`,
    "increase": (args)=>`Aumenta ${args.fieldLabel}`,
    "numberField": `Campo numero`
};

});

parcelRegister("b6DCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f634cbc377b9d396$export$2e2bcd8739ae039);
var $f634cbc377b9d396$export$2e2bcd8739ae039 = {};
$f634cbc377b9d396$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`${args.fieldLabel}\u{3092}\u{7E2E}\u{5C0F}`,
    "increase": (args)=>`${args.fieldLabel}\u{3092}\u{62E1}\u{5927}`,
    "numberField": `\u{6570}\u{5024}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}`
};

});

parcelRegister("cXHvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b7321b79aabf44$export$2e2bcd8739ae039);
var $92b7321b79aabf44$export$2e2bcd8739ae039 = {};
$92b7321b79aabf44$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`${args.fieldLabel} \u{AC10}\u{C18C}`,
    "increase": (args)=>`${args.fieldLabel} \u{C99D}\u{AC00}`,
    "numberField": `\u{BC88}\u{D638} \u{D544}\u{B4DC}`
};

});

parcelRegister("8Huzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e714a63eaf7163cb$export$2e2bcd8739ae039);
var $e714a63eaf7163cb$export$2e2bcd8739ae039 = {};
$e714a63eaf7163cb$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Suma\u{17E}inti ${args.fieldLabel}`,
    "increase": (args)=>`Padidinti ${args.fieldLabel}`,
    "numberField": `Numerio laukas`
};

});

parcelRegister("chxlx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b52745accc23cc1$export$2e2bcd8739ae039);
var $1b52745accc23cc1$export$2e2bcd8739ae039 = {};
$1b52745accc23cc1$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Samazin\u{101}\u{161}ana ${args.fieldLabel}`,
    "increase": (args)=>`Palielin\u{101}\u{161}ana ${args.fieldLabel}`,
    "numberField": `Skait\u{13C}u lauks`
};

});

parcelRegister("4EwrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb428687d1957338$export$2e2bcd8739ae039);
var $fb428687d1957338$export$2e2bcd8739ae039 = {};
$fb428687d1957338$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Reduser ${args.fieldLabel}`,
    "increase": (args)=>`\xd8k ${args.fieldLabel}`,
    "numberField": `Tallfelt`
};

});

parcelRegister("e6YmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e8d5a2cdd8b1bb$export$2e2bcd8739ae039);
var $51e8d5a2cdd8b1bb$export$2e2bcd8739ae039 = {};
$51e8d5a2cdd8b1bb$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`${args.fieldLabel} verlagen`,
    "increase": (args)=>`${args.fieldLabel} verhogen`,
    "numberField": `Getalveld`
};

});

parcelRegister("c8Pcm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57aec4237e33a87d$export$2e2bcd8739ae039);
var $57aec4237e33a87d$export$2e2bcd8739ae039 = {};
$57aec4237e33a87d$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Zmniejsz ${args.fieldLabel}`,
    "increase": (args)=>`Zwi\u{119}ksz ${args.fieldLabel}`,
    "numberField": `Pole numeru`
};

});

parcelRegister("3wnvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7323e0d65fd73042$export$2e2bcd8739ae039);
var $7323e0d65fd73042$export$2e2bcd8739ae039 = {};
$7323e0d65fd73042$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de n\xfamero`
};

});

parcelRegister("f7Myi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f20df71200612b89$export$2e2bcd8739ae039);
var $f20df71200612b89$export$2e2bcd8739ae039 = {};
$f20df71200612b89$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo num\xe9rico`
};

});

parcelRegister("hdJVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $204e555169a38c9b$export$2e2bcd8739ae039);
var $204e555169a38c9b$export$2e2bcd8739ae039 = {};
$204e555169a38c9b$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Sc\u{103}dere ${args.fieldLabel}`,
    "increase": (args)=>`Cre\u{219}tere ${args.fieldLabel}`,
    "numberField": `C\xe2mp numeric`
};

});

parcelRegister("5GbAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a753be3e7adcc23$export$2e2bcd8739ae039);
var $0a753be3e7adcc23$export$2e2bcd8739ae039 = {};
$0a753be3e7adcc23$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{423}\u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435}\u{43D}\u{438}\u{435} ${args.fieldLabel}`,
    "increase": (args)=>`\u{423}\u{432}\u{435}\u{43B}\u{438}\u{447}\u{435}\u{43D}\u{438}\u{435} ${args.fieldLabel}`,
    "numberField": `\u{427}\u{438}\u{441}\u{43B}\u{43E}\u{432}\u{43E}\u{435} \u{43F}\u{43E}\u{43B}\u{435}`
};

});

parcelRegister("97cJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b2c1379dcf3790$export$2e2bcd8739ae039);
var $26b2c1379dcf3790$export$2e2bcd8739ae039 = {};
$26b2c1379dcf3790$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Zn\xed\u{17E}i\u{165} ${args.fieldLabel}`,
    "increase": (args)=>`Zv\xfd\u{161}i\u{165} ${args.fieldLabel}`,
    "numberField": `\u{10C}\xedseln\xe9 pole`
};

});

parcelRegister("2zbxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a65b56e9283e631$export$2e2bcd8739ae039);
var $5a65b56e9283e631$export$2e2bcd8739ae039 = {};
$5a65b56e9283e631$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Upadati ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{10D}ajte ${args.fieldLabel}`,
    "numberField": `\u{160}tevil\u{10D}no polje`
};

});

parcelRegister("gXurm", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ac01e9d71c87c9$export$2e2bcd8739ae039);
var $37ac01e9d71c87c9$export$2e2bcd8739ae039 = {};
$37ac01e9d71c87c9$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{107}aj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};

});

parcelRegister("9Ev7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $75561b5d090d7fb7$export$2e2bcd8739ae039);
var $75561b5d090d7fb7$export$2e2bcd8739ae039 = {};
$75561b5d090d7fb7$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`Minska ${args.fieldLabel}`,
    "increase": (args)=>`\xd6ka ${args.fieldLabel}`,
    "numberField": `Nummerf\xe4lt`
};

});

parcelRegister("ft5dF", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ad05813bd576da$export$2e2bcd8739ae039);
var $50ad05813bd576da$export$2e2bcd8739ae039 = {};
$50ad05813bd576da$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`${args.fieldLabel} azalt`,
    "increase": (args)=>`${args.fieldLabel} artt\u{131}r`,
    "numberField": `Say\u{131} alan\u{131}`
};

});

parcelRegister("39xjr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4e81be4728c3a50$export$2e2bcd8739ae039);
var $b4e81be4728c3a50$export$2e2bcd8739ae039 = {};
$b4e81be4728c3a50$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{417}\u{43C}\u{435}\u{43D}\u{448}\u{438}\u{442}\u{438} ${args.fieldLabel}`,
    "increase": (args)=>`\u{417}\u{431}\u{456}\u{43B}\u{44C}\u{448}\u{438}\u{442}\u{438} ${args.fieldLabel}`,
    "numberField": `\u{41F}\u{43E}\u{43B}\u{435} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430}`
};

});

parcelRegister("iBo0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b09b09198a88abc$export$2e2bcd8739ae039);
var $8b09b09198a88abc$export$2e2bcd8739ae039 = {};
$8b09b09198a88abc$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{964D}\u{4F4E} ${args.fieldLabel}`,
    "increase": (args)=>`\u{63D0}\u{9AD8} ${args.fieldLabel}`,
    "numberField": `\u{6570}\u{5B57}\u{5B57}\u{6BB5}`
};

});

parcelRegister("72Yge", function(module, exports) {

$parcel$export(module.exports, "default", () => $f98ac577f8e3811e$export$2e2bcd8739ae039);
var $f98ac577f8e3811e$export$2e2bcd8739ae039 = {};
$f98ac577f8e3811e$export$2e2bcd8739ae039 = {
    "decrease": (args)=>`\u{7E2E}\u{5C0F} ${args.fieldLabel}`,
    "increase": (args)=>`\u{653E}\u{5927} ${args.fieldLabel}`,
    "numberField": `\u{6578}\u{5B57}\u{6B04}\u{4F4D}`
};

});


parcelRegister("dbHGI", function(module, exports) {

$parcel$export(module.exports, "useFormattedTextField", () => $a3c41ef73003c6f3$export$4f384c9210e583c3);

var $lKBFz = parcelRequire("lKBFz");

var $fvyIQ = parcelRequire("fvyIQ");

var $lhKAD = parcelRequire("lhKAD");

var $4lMDe = parcelRequire("4lMDe");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a3c41ef73003c6f3$var$$62888b2ec35be488$var$supportsNativeBeforeInputEvent() {
    return typeof window !== 'undefined' && window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function';
}
function $a3c41ef73003c6f3$export$4f384c9210e583c3(props, state, inputRef) {
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    let onBeforeInputFallback = (0, $4lMDe.useEffectEvent)((e)=>{
        let input = inputRef.current;
        if (!input) return;
        // Compute the next value of the input if the event is allowed to proceed.
        // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
        let nextValue = null;
        switch(e.inputType){
            case 'historyUndo':
            case 'historyRedo':
                // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                // because presumably the input would have already been validated previously.
                return;
            case 'insertLineBreak':
                // Explicitly allow "insertLineBreak" event, to allow onSubmit for "enter" key. e.data is null in this case.
                return;
            case 'deleteContent':
            case 'deleteByCut':
            case 'deleteByDrag':
                nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case 'deleteContentForward':
                // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                // If we support additional locales in the future, this may need to change.
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case 'deleteContentBackward':
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case 'deleteSoftLineBackward':
            case 'deleteHardLineBackward':
                nextValue = input.value.slice(input.selectionStart);
                break;
            default:
                if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                break;
        }
        // If we did not compute a value, or the new value is invalid, prevent the event
        // so that the browser does not update the input text, move the selection, or add to
        // the undo/redo stack.
        if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
    });
    (0, $eF4cA.useEffect)(()=>{
        if (!$a3c41ef73003c6f3$var$$62888b2ec35be488$var$supportsNativeBeforeInputEvent() || !inputRef.current) return;
        let input = inputRef.current;
        input.addEventListener('beforeinput', onBeforeInputFallback, false);
        return ()=>{
            input.removeEventListener('beforeinput', onBeforeInputFallback, false);
        };
    }, [
        inputRef
    ]);
    let onBeforeInput = !$a3c41ef73003c6f3$var$$62888b2ec35be488$var$supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = (0, $fvyIQ.getEventTarget)(e).value.slice(0, (0, $fvyIQ.getEventTarget)(e).selectionStart) + e.data + (0, $fvyIQ.getEventTarget)(e).value.slice((0, $fvyIQ.getEventTarget)(e).selectionEnd);
        if (!state.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps: labelProps, inputProps: textFieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $lKBFz.useTextField)(props, inputRef);
    let compositionStartState = (0, $eF4cA.useRef)(null);
    return {
        // oxlint-disable-next-line react/react-compiler
        inputProps: (0, $lhKAD.mergeProps)(textFieldProps, {
            onBeforeInput: onBeforeInput,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputRef.current;
                compositionStartState.current = {
                    value: value,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            },
            onCompositionEnd () {
                if (inputRef.current && !state.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state.setInputValue(value);
                }
            }
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        ...validation
    };
}

});
parcelRegister("lKBFz", function(module, exports) {

$parcel$export(module.exports, "useTextField", () => $04a1781dc47ee6dc$export$712718f7aec83d5);

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $lhKAD = parcelRequire("lhKAD");

var $cI1qR = parcelRequire("cI1qR");

var $8M8Qw = parcelRequire("8M8Qw");

var $3rgVl = parcelRequire("3rgVl");

var $56aMA = parcelRequire("56aMA");

var $eF4cA = parcelRequire("eF4cA");

var $iUErx = parcelRequire("iUErx");

var $iEwfj = parcelRequire("iEwfj");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $04a1781dc47ee6dc$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = 'input', isDisabled: isDisabled = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, type: type = 'text', validationBehavior: validationBehavior = 'aria' } = props;
    let [value, setValue] = (0, $iUErx.useControlledState)(props.value, props.defaultValue || '', props.onChange);
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)(props, ref);
    let validationState = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: value
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    let [initialValue] = (0, $eF4cA.useState)(value);
    (0, $3rgVl.useFormReset)(ref, props.defaultValue ?? initialValue, setValue);
    (0, $56aMA.useFormValidation)(props, validationState, ref);
    return {
        labelProps: labelProps,
        inputProps: (0, $lhKAD.mergeProps)(domProps, inputElementType === 'input' ? inputOnlyProps : undefined, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === 'native',
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            'aria-invalid': isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-activedescendant': props['aria-activedescendant'],
            'aria-autocomplete': props['aria-autocomplete'],
            'aria-haspopup': props['aria-haspopup'],
            'aria-controls': props['aria-controls'],
            value: value,
            onChange: (e)=>setValue((0, $fvyIQ.getEventTarget)(e).value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            form: props.form,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            autoCorrect: props.autoCorrect,
            spellCheck: props.spellCheck,
            [parseInt((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: props.enterKeyHint,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});


parcelRegister("3joGx", function(module, exports) {

$parcel$export(module.exports, "useScrollWheel", () => $80c9b7e7ee1c39ae$export$2123ff2b87c81ca);

var $58OnM = parcelRequire("58OnM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $80c9b7e7ee1c39ae$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll, isDisabled: isDisabled } = props;
    let onScrollHandler = (0, $eF4cA.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, $58OnM.useEvent)(ref, 'wheel', isDisabled ? undefined : onScrollHandler);
}

});

parcelRegister("eHcWW", function(module, exports) {

$parcel$export(module.exports, "useSpinButton", () => $2727295e95ffc69f$export$e908e06f4b8e3402);

var $4HiHF = parcelRequire("4HiHF");

var $4vnuj = parcelRequire("4vnuj");

var $4lMDe = parcelRequire("4lMDe");

var $ed0Y6 = parcelRequire("ed0Y6");

var $aGDvF = parcelRequire("aGDvF");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $2727295e95ffc69f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2727295e95ffc69f$var$$757ec6630f26125c$var$noop = ()=>{};
function $2727295e95ffc69f$export$e908e06f4b8e3402(props) {
    const _async = (0, $eF4cA.useRef)(undefined);
    let { value: value, textValue: textValue, minValue: minValue, maxValue: maxValue, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, onIncrement: onIncrement, onIncrementPage: onIncrementPage, onDecrement: onDecrement, onDecrementPage: onDecrementPage, onDecrementToMin: onDecrementToMin, onIncrementToMax: onIncrementToMax } = props;
    const stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($2727295e95ffc69f$var$$parcel$interopDefault((0, $4vnuj.default)), '@react-aria/spinbutton');
    let isSpinning = (0, $eF4cA.useRef)(false);
    const clearAsync = (0, $eF4cA.useCallback)(()=>{
        clearTimeout(_async.current);
        isSpinning.current = false;
    }, []);
    const clearAsyncEvent = (0, $4lMDe.useEffectEvent)(()=>{
        clearAsync();
    });
    (0, $eF4cA.useEffect)(()=>{
        return ()=>clearAsyncEvent();
    }, []);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        isDisabled: isDisabled || isReadOnly,
        shortcuts: {
            PageUp: ()=>{
                if (onIncrementPage) {
                    onIncrementPage();
                    return;
                }
                if (onIncrement) {
                    onIncrement();
                    return;
                }
                return false;
            },
            ArrowUp: ()=>{
                if (onIncrement) {
                    onIncrement();
                    return;
                }
                return false;
            },
            PageDown: ()=>{
                if (onDecrementPage) {
                    onDecrementPage();
                    return;
                }
                if (onDecrement) {
                    onDecrement();
                    return;
                }
                return false;
            },
            ArrowDown: ()=>{
                if (onDecrement) {
                    onDecrement();
                    return;
                }
                return false;
            },
            Home: ()=>{
                if (onDecrementToMin) {
                    onDecrementToMin();
                    return;
                }
                return false;
            },
            End: ()=>{
                if (onIncrementToMax) {
                    onIncrementToMax();
                    return;
                }
                return false;
            }
        },
        allowRepeats: true
    });
    let isFocused = (0, $eF4cA.useRef)(false);
    let onFocus = ()=>{
        isFocused.current = true;
    };
    let onBlur = ()=>{
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    let ariaTextValue = textValue === '' ? stringFormatter.format('Empty') : (textValue || `${value}`).replace('-', '\u2212');
    (0, $eF4cA.useEffect)(()=>{
        if (isFocused.current) {
            (0, $4HiHF.clearAnnouncer)('assertive');
            (0, $4HiHF.announce)(ariaTextValue, 'assertive');
        }
    }, [
        ariaTextValue
    ]);
    // For touch users, if they move their finger like they're scrolling, we don't want to trigger a spin.
    let onPointerCancel = (0, $eF4cA.useCallback)(()=>{
        clearAsync();
    }, [
        clearAsync
    ]);
    const onIncrementEvent = (0, $4lMDe.useEffectEvent)(onIncrement ?? $2727295e95ffc69f$var$$757ec6630f26125c$var$noop);
    const onDecrementEvent = (0, $4lMDe.useEffectEvent)(onDecrement ?? $2727295e95ffc69f$var$$757ec6630f26125c$var$noop);
    const stepUpEvent = (0, $4lMDe.useEffectEvent)(()=>{
        if (maxValue === undefined || isNaN(maxValue) || value === undefined || isNaN(value) || value < maxValue) {
            onIncrementEvent();
            // oxlint-disable-next-line react/react-compiler
            onIncrementPressStartEvent(60);
        }
    });
    const onIncrementPressStartEvent = (0, $4lMDe.useEffectEvent)((initialStepDelay)=>{
        clearAsyncEvent();
        isSpinning.current = true;
        // Start spinning after initial delay
        _async.current = window.setTimeout(stepUpEvent, initialStepDelay);
    });
    const stepDownEvent = (0, $4lMDe.useEffectEvent)(()=>{
        if (minValue === undefined || isNaN(minValue) || value === undefined || isNaN(value) || value > minValue) {
            onDecrementEvent();
            // oxlint-disable-next-line react/react-compiler
            onDecrementPressStartEvent(60);
        }
    });
    const onDecrementPressStartEvent = (0, $4lMDe.useEffectEvent)((initialStepDelay)=>{
        clearAsyncEvent();
        isSpinning.current = true;
        // Start spinning after initial delay
        _async.current = window.setTimeout(stepDownEvent, initialStepDelay);
    });
    let cancelContextMenu = (e)=>{
        e.preventDefault();
    };
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $ed0Y6.useGlobalListeners)();
    // Tracks in touch if the press end event was preceded by a press up.
    // If it wasn't, then we know the finger left the button while still in contact with the screen.
    // This means that the user is trying to scroll or interact in some way that shouldn't trigger
    // an increment or decrement.
    let isUp = (0, $eF4cA.useRef)(false);
    let [isIncrementPressed, setIsIncrementPressed] = (0, $eF4cA.useState)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (isIncrementPressed === 'touch') onIncrementPressStartEvent(600);
        else if (isIncrementPressed) onIncrementPressStartEvent(400);
        else if (!isIncrementPressed) clearAsyncEvent();
    }, [
        isIncrementPressed
    ]);
    let [isDecrementPressed, setIsDecrementPressed] = (0, $eF4cA.useState)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (isDecrementPressed === 'touch') onDecrementPressStartEvent(600);
        else if (isDecrementPressed) onDecrementPressStartEvent(400);
        else if (!isDecrementPressed) clearAsyncEvent();
    }, [
        isDecrementPressed
    ]);
    return {
        spinButtonProps: {
            role: 'spinbutton',
            'aria-valuenow': value !== undefined && !isNaN(value) ? value : undefined,
            'aria-valuetext': ariaTextValue,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-disabled': isDisabled || undefined,
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            ...keyboardProps,
            onFocus: onFocus,
            onBlur: onBlur
        },
        incrementButtonProps: {
            onPressStart: (e)=>{
                clearAsync();
                if (e.pointerType !== 'touch') {
                    onIncrement?.();
                    setIsIncrementPressed('mouse');
                } else {
                    addGlobalListener(window, 'pointercancel', onPointerCancel, {
                        capture: true
                    });
                    isUp.current = false;
                    // For touch users, don't trigger a decrement on press start, we'll wait for the press end to trigger it if
                    // the control isn't spinning.
                    setIsIncrementPressed('touch');
                }
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressUp: (e)=>{
                clearAsync();
                if (e.pointerType === 'touch') isUp.current = true;
                removeAllGlobalListeners();
                setIsIncrementPressed(null);
            },
            onPressEnd: (e)=>{
                clearAsync();
                if (e.pointerType === 'touch') {
                    if (!isSpinning.current && isUp.current) onIncrement?.();
                }
                isUp.current = false;
                setIsIncrementPressed(null);
            },
            onFocus: onFocus,
            onBlur: onBlur
        },
        decrementButtonProps: {
            onPressStart: (e)=>{
                clearAsync();
                if (e.pointerType !== 'touch') {
                    onDecrement?.();
                    setIsDecrementPressed('mouse');
                } else {
                    addGlobalListener(window, 'pointercancel', onPointerCancel, {
                        capture: true
                    });
                    isUp.current = false;
                    // For touch users, don't trigger a decrement on press start, we'll wait for the press end to trigger it if
                    // the control isn't spinning.
                    setIsDecrementPressed('touch');
                }
            },
            onPressUp: (e)=>{
                clearAsync();
                if (e.pointerType === 'touch') isUp.current = true;
                removeAllGlobalListeners();
                setIsDecrementPressed(null);
            },
            onPressEnd: (e)=>{
                clearAsync();
                if (e.pointerType === 'touch') {
                    if (!isSpinning.current && isUp.current) onDecrement?.();
                }
                isUp.current = false;
                setIsDecrementPressed(null);
            },
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("4vnuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5136430b2fa2e487$export$2e2bcd8739ae039);

var $3ktoj = parcelRequire("3ktoj");

var $6sCn2 = parcelRequire("6sCn2");

var $bLgtE = parcelRequire("bLgtE");

var $e3WPl = parcelRequire("e3WPl");

var $792na = parcelRequire("792na");

var $2FVmB = parcelRequire("2FVmB");

var $ks6aB = parcelRequire("ks6aB");

var $dhFo0 = parcelRequire("dhFo0");

var $arzGz = parcelRequire("arzGz");

var $59SdD = parcelRequire("59SdD");

var $5AMKx = parcelRequire("5AMKx");

var $8RaTM = parcelRequire("8RaTM");

var $8CJ0i = parcelRequire("8CJ0i");

var $joKzI = parcelRequire("joKzI");

var $9A0Ca = parcelRequire("9A0Ca");

var $65Qjk = parcelRequire("65Qjk");

var $87nWf = parcelRequire("87nWf");

var $bYOPb = parcelRequire("bYOPb");

var $9UshF = parcelRequire("9UshF");

var $4hmQF = parcelRequire("4hmQF");

var $5BI6n = parcelRequire("5BI6n");

var $3qZiw = parcelRequire("3qZiw");

var $gzYeq = parcelRequire("gzYeq");

var $5Dw7V = parcelRequire("5Dw7V");

var $bLlXE = parcelRequire("bLlXE");

var $1lkvu = parcelRequire("1lkvu");

var $8AbSa = parcelRequire("8AbSa");

var $jCl7a = parcelRequire("jCl7a");

var $5VDjR = parcelRequire("5VDjR");

var $8P1gD = parcelRequire("8P1gD");

var $kWJyl = parcelRequire("kWJyl");

var $buFWm = parcelRequire("buFWm");

var $4rU5Y = parcelRequire("4rU5Y");

var $ktoi6 = parcelRequire("ktoi6");
var $5136430b2fa2e487$export$2e2bcd8739ae039 = {};
$5136430b2fa2e487$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $3ktoj.default),
    "bg-BG": (0, $6sCn2.default),
    "cs-CZ": (0, $bLgtE.default),
    "da-DK": (0, $e3WPl.default),
    "de-DE": (0, $792na.default),
    "el-GR": (0, $2FVmB.default),
    "en-US": (0, $ks6aB.default),
    "es-ES": (0, $dhFo0.default),
    "et-EE": (0, $arzGz.default),
    "fi-FI": (0, $59SdD.default),
    "fr-FR": (0, $5AMKx.default),
    "he-IL": (0, $8RaTM.default),
    "hr-HR": (0, $8CJ0i.default),
    "hu-HU": (0, $joKzI.default),
    "it-IT": (0, $9A0Ca.default),
    "ja-JP": (0, $65Qjk.default),
    "ko-KR": (0, $87nWf.default),
    "lt-LT": (0, $bYOPb.default),
    "lv-LV": (0, $9UshF.default),
    "nb-NO": (0, $4hmQF.default),
    "nl-NL": (0, $5BI6n.default),
    "pl-PL": (0, $3qZiw.default),
    "pt-BR": (0, $gzYeq.default),
    "pt-PT": (0, $5Dw7V.default),
    "ro-RO": (0, $bLlXE.default),
    "ru-RU": (0, $1lkvu.default),
    "sk-SK": (0, $8AbSa.default),
    "sl-SI": (0, $jCl7a.default),
    "sr-SP": (0, $5VDjR.default),
    "sv-SE": (0, $8P1gD.default),
    "tr-TR": (0, $kWJyl.default),
    "uk-UA": (0, $buFWm.default),
    "zh-CN": (0, $4rU5Y.default),
    "zh-TW": (0, $ktoi6.default)
};

});
parcelRegister("3ktoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a35b9a9565a1992$export$2e2bcd8739ae039);
var $7a35b9a9565a1992$export$2e2bcd8739ae039 = {};
$7a35b9a9565a1992$export$2e2bcd8739ae039 = {
    "Empty": `\u{641}\u{627}\u{631}\u{63A}`
};

});

parcelRegister("6sCn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d0a373e793a989b$export$2e2bcd8739ae039);
var $2d0a373e793a989b$export$2e2bcd8739ae039 = {};
$2d0a373e793a989b$export$2e2bcd8739ae039 = {
    "Empty": `\u{418}\u{437}\u{43F}\u{440}\u{430}\u{437}\u{43D}\u{438}`
};

});

parcelRegister("bLgtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $56105d98480787db$export$2e2bcd8739ae039);
var $56105d98480787db$export$2e2bcd8739ae039 = {};
$56105d98480787db$export$2e2bcd8739ae039 = {
    "Empty": `Pr\xe1zdn\xe9`
};

});

parcelRegister("e3WPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5a579e3a4d76d5$export$2e2bcd8739ae039);
var $4a5a579e3a4d76d5$export$2e2bcd8739ae039 = {};
$4a5a579e3a4d76d5$export$2e2bcd8739ae039 = {
    "Empty": `Tom`
};

});

parcelRegister("792na", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd4dde54296d6e1$export$2e2bcd8739ae039);
var $4fd4dde54296d6e1$export$2e2bcd8739ae039 = {};
$4fd4dde54296d6e1$export$2e2bcd8739ae039 = {
    "Empty": `Leer`
};

});

parcelRegister("2FVmB", function(module, exports) {

$parcel$export(module.exports, "default", () => $df6e6dbf98fcf2cd$export$2e2bcd8739ae039);
var $df6e6dbf98fcf2cd$export$2e2bcd8739ae039 = {};
$df6e6dbf98fcf2cd$export$2e2bcd8739ae039 = {
    "Empty": `\u{386}\u{3B4}\u{3B5}\u{3B9}\u{3BF}`
};

});

parcelRegister("ks6aB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae80eabde8724fc$export$2e2bcd8739ae039);
var $fae80eabde8724fc$export$2e2bcd8739ae039 = {};
$fae80eabde8724fc$export$2e2bcd8739ae039 = {
    "Empty": `Empty`
};

});

parcelRegister("dhFo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d75d9f7089fba064$export$2e2bcd8739ae039);
var $d75d9f7089fba064$export$2e2bcd8739ae039 = {};
$d75d9f7089fba064$export$2e2bcd8739ae039 = {
    "Empty": `Vac\xedo`
};

});

parcelRegister("arzGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e955eb5a62a802$export$2e2bcd8739ae039);
var $07e955eb5a62a802$export$2e2bcd8739ae039 = {};
$07e955eb5a62a802$export$2e2bcd8739ae039 = {
    "Empty": `T\xfchjenda`
};

});

parcelRegister("59SdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c837cdd409c4a0a$export$2e2bcd8739ae039);
var $0c837cdd409c4a0a$export$2e2bcd8739ae039 = {};
$0c837cdd409c4a0a$export$2e2bcd8739ae039 = {
    "Empty": `Tyhj\xe4`
};

});

parcelRegister("5AMKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f422c557ecf366$export$2e2bcd8739ae039);
var $16f422c557ecf366$export$2e2bcd8739ae039 = {};
$16f422c557ecf366$export$2e2bcd8739ae039 = {
    "Empty": `Vide`
};

});

parcelRegister("8RaTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26f68e6d9acf2aa$export$2e2bcd8739ae039);
var $c26f68e6d9acf2aa$export$2e2bcd8739ae039 = {};
$c26f68e6d9acf2aa$export$2e2bcd8739ae039 = {
    "Empty": `\u{5E8}\u{5D9}\u{5E7}`
};

});

parcelRegister("8CJ0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $961bb868154cf890$export$2e2bcd8739ae039);
var $961bb868154cf890$export$2e2bcd8739ae039 = {};
$961bb868154cf890$export$2e2bcd8739ae039 = {
    "Empty": `Prazno`
};

});

parcelRegister("joKzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c143bc282dd3fe4$export$2e2bcd8739ae039);
var $1c143bc282dd3fe4$export$2e2bcd8739ae039 = {};
$1c143bc282dd3fe4$export$2e2bcd8739ae039 = {
    "Empty": `\xdcres`
};

});

parcelRegister("9A0Ca", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a1bc5729e680e1$export$2e2bcd8739ae039);
var $44a1bc5729e680e1$export$2e2bcd8739ae039 = {};
$44a1bc5729e680e1$export$2e2bcd8739ae039 = {
    "Empty": `Vuoto`
};

});

parcelRegister("65Qjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2805188dec1f7212$export$2e2bcd8739ae039);
var $2805188dec1f7212$export$2e2bcd8739ae039 = {};
$2805188dec1f7212$export$2e2bcd8739ae039 = {
    "Empty": `\u{7A7A}`
};

});

parcelRegister("87nWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d780bec012ea4f21$export$2e2bcd8739ae039);
var $d780bec012ea4f21$export$2e2bcd8739ae039 = {};
$d780bec012ea4f21$export$2e2bcd8739ae039 = {
    "Empty": `\u{BE44}\u{C5B4} \u{C788}\u{C74C}`
};

});

parcelRegister("bYOPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0da546edc378c45a$export$2e2bcd8739ae039);
var $0da546edc378c45a$export$2e2bcd8739ae039 = {};
$0da546edc378c45a$export$2e2bcd8739ae039 = {
    "Empty": `Tu\u{161}\u{10D}ias`
};

});

parcelRegister("9UshF", function(module, exports) {

$parcel$export(module.exports, "default", () => $937800604a22462f$export$2e2bcd8739ae039);
var $937800604a22462f$export$2e2bcd8739ae039 = {};
$937800604a22462f$export$2e2bcd8739ae039 = {
    "Empty": `Tuk\u{161}s`
};

});

parcelRegister("4hmQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $164f70334682d716$export$2e2bcd8739ae039);
var $164f70334682d716$export$2e2bcd8739ae039 = {};
$164f70334682d716$export$2e2bcd8739ae039 = {
    "Empty": `Tom`
};

});

parcelRegister("5BI6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee527cc1b861b745$export$2e2bcd8739ae039);
var $ee527cc1b861b745$export$2e2bcd8739ae039 = {};
$ee527cc1b861b745$export$2e2bcd8739ae039 = {
    "Empty": `Leeg`
};

});

parcelRegister("3qZiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $324617fbc28773a7$export$2e2bcd8739ae039);
var $324617fbc28773a7$export$2e2bcd8739ae039 = {};
$324617fbc28773a7$export$2e2bcd8739ae039 = {
    "Empty": `Pusty`
};

});

parcelRegister("gzYeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de1fbdb7cc7f51b$export$2e2bcd8739ae039);
var $4de1fbdb7cc7f51b$export$2e2bcd8739ae039 = {};
$4de1fbdb7cc7f51b$export$2e2bcd8739ae039 = {
    "Empty": `Vazio`
};

});

parcelRegister("5Dw7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c0f545574a7e42$export$2e2bcd8739ae039);
var $60c0f545574a7e42$export$2e2bcd8739ae039 = {};
$60c0f545574a7e42$export$2e2bcd8739ae039 = {
    "Empty": `Vazio`
};

});

parcelRegister("bLlXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $36214c69f79f38ff$export$2e2bcd8739ae039);
var $36214c69f79f38ff$export$2e2bcd8739ae039 = {};
$36214c69f79f38ff$export$2e2bcd8739ae039 = {
    "Empty": `Gol`
};

});

parcelRegister("1lkvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a23dbd3f7d15742d$export$2e2bcd8739ae039);
var $a23dbd3f7d15742d$export$2e2bcd8739ae039 = {};
$a23dbd3f7d15742d$export$2e2bcd8739ae039 = {
    "Empty": `\u{41D}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43E}`
};

});

parcelRegister("8AbSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ca27e956f81abb8$export$2e2bcd8739ae039);
var $7ca27e956f81abb8$export$2e2bcd8739ae039 = {};
$7ca27e956f81abb8$export$2e2bcd8739ae039 = {
    "Empty": `Pr\xe1zdne`
};

});

parcelRegister("jCl7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e2e072215adb3b$export$2e2bcd8739ae039);
var $e3e2e072215adb3b$export$2e2bcd8739ae039 = {};
$e3e2e072215adb3b$export$2e2bcd8739ae039 = {
    "Empty": `Prazen`
};

});

parcelRegister("5VDjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabdc5bde9a70056$export$2e2bcd8739ae039);
var $eabdc5bde9a70056$export$2e2bcd8739ae039 = {};
$eabdc5bde9a70056$export$2e2bcd8739ae039 = {
    "Empty": `Prazno`
};

});

parcelRegister("8P1gD", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f202cea13e3b08$export$2e2bcd8739ae039);
var $59f202cea13e3b08$export$2e2bcd8739ae039 = {};
$59f202cea13e3b08$export$2e2bcd8739ae039 = {
    "Empty": `Tomt`
};

});

parcelRegister("kWJyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c151b8759b9dc72a$export$2e2bcd8739ae039);
var $c151b8759b9dc72a$export$2e2bcd8739ae039 = {};
$c151b8759b9dc72a$export$2e2bcd8739ae039 = {
    "Empty": `Bo\u{15F}`
};

});

parcelRegister("buFWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7440d3ec366b1b1a$export$2e2bcd8739ae039);
var $7440d3ec366b1b1a$export$2e2bcd8739ae039 = {};
$7440d3ec366b1b1a$export$2e2bcd8739ae039 = {
    "Empty": `\u{41F}\u{443}\u{441}\u{442}\u{43E}`
};

});

parcelRegister("4rU5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ec2b52deeaa6196$export$2e2bcd8739ae039);
var $5ec2b52deeaa6196$export$2e2bcd8739ae039 = {};
$5ec2b52deeaa6196$export$2e2bcd8739ae039 = {
    "Empty": `\u{7A7A}`
};

});

parcelRegister("ktoi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $eef1a6194efbcb54$export$2e2bcd8739ae039);
var $eef1a6194efbcb54$export$2e2bcd8739ae039 = {};
$eef1a6194efbcb54$export$2e2bcd8739ae039 = {
    "Empty": `\u{7A7A}\u{767D}`
};

});





parcelRegister("jKA62", function(module, exports) {

$parcel$export(module.exports, "useColorField", () => $ec88ec5eaf560d04$export$77e32ca575a28fdf);

var $lhKAD = parcelRequire("lhKAD");

var $i1DSg = parcelRequire("i1DSg");

var $dbHGI = parcelRequire("dbHGI");

var $3rgVl = parcelRequire("3rgVl");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $3joGx = parcelRequire("3joGx");

var $eHcWW = parcelRequire("eHcWW");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");

var $iEwfj = parcelRequire("iEwfj");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ec88ec5eaf560d04$export$77e32ca575a28fdf(props, state, ref) {
    let { isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, isWheelDisabled: isWheelDisabled, validationBehavior: validationBehavior = 'aria', onKeyDown: onKeyDown, onKeyUp: onKeyUp } = props;
    let { colorValue: colorValue, inputValue: inputValue, increment: increment, decrement: decrement, incrementToMax: incrementToMax, decrementToMin: decrementToMin, commit: commit, commitValidation: commitValidation } = state;
    let inputId = (0, $25dFS.useId)();
    let { spinButtonProps: spinButtonProps } = (0, $eHcWW.useSpinButton)({
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        maxValue: 0xffffff,
        minValue: 0,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: colorValue ? colorValue.toHexInt() : undefined,
        textValue: colorValue ? colorValue.toString('hex') : undefined
    });
    let [focusWithin, setFocusWithin] = (0, $eF4cA.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        isDisabled: isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, $eF4cA.useCallback)((e)=>{
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, $3joGx.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, ref);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        isDisabled: isDisabled || isReadOnly,
        shortcuts: {
            Enter: ()=>{
                (0, $l19Vn.flushSync)(()=>{
                    commit();
                });
                commitValidation();
                return {
                    shouldPreventDefault: false
                };
            }
        },
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    });
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let { inputProps: inputProps, ...otherProps } = (0, $dbHGI.useFormattedTextField)({
        ...props,
        id: inputId,
        value: inputValue,
        // Intentionally invalid value that will be ignored by onChange during form reset
        // This is handled separately below.
        defaultValue: '!',
        validate: undefined,
        [(0, $iEwfj.privateValidationStateProp)]: state,
        type: 'text',
        autoComplete: 'off',
        onChange: onChange,
        onKeyDown: undefined,
        onKeyUp: undefined
    }, state, ref);
    (0, $3rgVl.useFormReset)(ref, state.defaultColorValue, state.setColorValue);
    inputProps = (0, $lhKAD.mergeProps)(keyboardProps, inputProps, spinButtonProps, focusWithinProps, {
        role: 'textbox',
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null,
        'aria-valuetext': null,
        autoCorrect: 'off',
        spellCheck: 'false',
        onBlur: commit
    });
    if (validationBehavior === 'native') inputProps['aria-required'] = undefined;
    return {
        inputProps: inputProps,
        ...otherProps
    };
}

});

parcelRegister("iwZvF", function(module, exports) {

$parcel$export(module.exports, "useColorChannelFieldState", () => $8b7b01b6fbcfc866$export$b9fc0d69c9190c4a);

var $kUz1y = parcelRequire("kUz1y");

var $fqsAA = parcelRequire("fqsAA");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
function $8b7b01b6fbcfc866$export$b9fc0d69c9190c4a(props) {
    let { channel: channel, colorSpace: colorSpace, locale: locale } = props;
    let initialValue = (0, $fqsAA.useColor)(props.value);
    let initialDefaultValue = (0, $fqsAA.useColor)(props.defaultValue);
    let [colorValue, setColor] = (0, $iUErx.useControlledState)(initialValue, initialDefaultValue ?? null, props.onChange);
    let color = $8b7b01b6fbcfc866$var$$378fa61546b28d38$var$useConvertColor(colorValue, colorSpace);
    let [initialColorValue] = (0, $eF4cA.useState)(colorValue);
    let defaultColorValue = initialDefaultValue ?? initialColorValue;
    let defaultColor = $8b7b01b6fbcfc866$var$$378fa61546b28d38$var$useConvertColor(defaultColorValue, colorSpace);
    let value = color.getChannelValue(channel);
    let range = color.getChannelRange(channel);
    let formatOptions = (0, $eF4cA.useMemo)(()=>color.getChannelFormatOptions(channel), [
        color,
        channel
    ]);
    let multiplier = formatOptions.style === 'percent' && range.maxValue === 100 ? 100 : 1;
    let numberFieldState = (0, $kUz1y.useNumberFieldState)({
        locale: locale,
        value: colorValue === null ? NaN : value / multiplier,
        defaultValue: defaultColorValue === null ? NaN : defaultColor.getChannelValue(channel) / multiplier,
        onChange: (v)=>{
            if (!Number.isNaN(v)) setColor(color.withChannelValue(channel, v * multiplier));
            else setColor(null);
        },
        minValue: range.minValue / multiplier,
        maxValue: range.maxValue / multiplier,
        step: range.step / multiplier,
        formatOptions: formatOptions
    });
    return {
        ...numberFieldState,
        colorValue: color,
        defaultColorValue: defaultColorValue,
        setColorValue: setColor
    };
}
function $8b7b01b6fbcfc866$var$$378fa61546b28d38$var$useConvertColor(colorValue, colorSpace) {
    let black = (0, $fqsAA.useColor)('#000');
    return (0, $eF4cA.useMemo)(()=>{
        let nonNullColorValue = colorValue || black;
        return colorSpace && nonNullColorValue ? nonNullColorValue.toFormat(colorSpace) : nonNullColorValue;
    }, [
        black,
        colorValue,
        colorSpace
    ]);
}

});
parcelRegister("kUz1y", function(module, exports) {

$parcel$export(module.exports, "useNumberFieldState", () => $a5f96a799f771f03$export$7f629e9dc1ecf37c);

var $g8XbY = parcelRequire("g8XbY");

var $iEwfj = parcelRequire("iEwfj");

var $iUErx = parcelRequire("iUErx");

var $l3v5Z = parcelRequire("l3v5Z");
var $9LpUQ = parcelRequire("9LpUQ");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a5f96a799f771f03$export$7f629e9dc1ecf37c(props) {
    let { minValue: minValue, maxValue: maxValue, step: step, formatOptions: formatOptions, value: value, defaultValue: defaultValue = NaN, onChange: onChange, locale: locale, isDisabled: isDisabled, isReadOnly: isReadOnly, commitBehavior: commitBehavior = 'snap' } = props;
    if (value === null) value = NaN;
    let snapValue = (0, $eF4cA.useCallback)((value)=>{
        return step === undefined || isNaN(step) ? (0, $g8XbY.clamp)(value, minValue, maxValue) : (0, $g8XbY.snapValueToStep)(value, minValue, maxValue, step);
    }, [
        step,
        minValue,
        maxValue
    ]);
    if (value !== undefined && !isNaN(value) && commitBehavior === 'snap') value = snapValue(value);
    if (!isNaN(defaultValue) && commitBehavior === 'snap') defaultValue = snapValue(defaultValue);
    let [numberValue, setNumberValue] = (0, $iUErx.useControlledState)(value, isNaN(defaultValue) ? NaN : defaultValue, onChange);
    let [initialValue] = (0, $eF4cA.useState)(numberValue);
    let [inputValue, setInputValue] = (0, $eF4cA.useState)(()=>isNaN(numberValue) ? '' : new (0, $l3v5Z.NumberFormatter)(locale, formatOptions).format(numberValue));
    let numberParser = (0, $eF4cA.useMemo)(()=>new (0, $9LpUQ.NumberParser)(locale, formatOptions), [
        locale,
        formatOptions
    ]);
    let numberingSystem = (0, $eF4cA.useMemo)(()=>numberParser.getNumberingSystem(inputValue), [
        numberParser,
        inputValue
    ]);
    let formatter = (0, $eF4cA.useMemo)(()=>new (0, $l3v5Z.NumberFormatter)(locale, {
            ...formatOptions,
            numberingSystem: numberingSystem
        }), [
        locale,
        formatOptions,
        numberingSystem
    ]);
    let intlOptions = (0, $eF4cA.useMemo)(()=>formatter.resolvedOptions(), [
        formatter
    ]);
    let format = (0, $eF4cA.useCallback)((value)=>isNaN(value) || value === null ? '' : formatter.format(value), [
        formatter
    ]);
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: numberValue
    });
    let clampStep = step !== undefined && !isNaN(step) ? step : 1;
    if (intlOptions.style === 'percent' && (step === undefined || isNaN(step))) clampStep = 0.01;
    // Update the input value when the number value or format options change. This is done
    // in a useEffect so that the controlled behavior is correct and we only update the
    // textfield after prop changes.
    let [prevValue, setPrevValue] = (0, $eF4cA.useState)(numberValue);
    let [prevLocale, setPrevLocale] = (0, $eF4cA.useState)(locale);
    let [prevFormatOptions, setPrevFormatOptions] = (0, $eF4cA.useState)(formatOptions);
    if (!Object.is(numberValue, prevValue) || locale !== prevLocale || !$a5f96a799f771f03$var$$3d0ee518c6f3d04f$var$isEqualFormatOptions(formatOptions, prevFormatOptions)) {
        setInputValue(format(numberValue));
        setPrevValue(numberValue);
        setPrevLocale(locale);
        setPrevFormatOptions(formatOptions);
    }
    let parsedValue = (0, $eF4cA.useMemo)(()=>numberParser.parse(inputValue), [
        numberParser,
        inputValue
    ]);
    let commit = (overrideValue)=>{
        let newInputValue = overrideValue === undefined ? inputValue : overrideValue;
        let newParsedValue = parsedValue;
        if (overrideValue !== undefined) newParsedValue = numberParser.parse(newInputValue);
        // Set to empty state if input value is empty
        if (!newInputValue.length) {
            setNumberValue(NaN);
            setInputValue(value === undefined ? '' : format(numberValue));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (isNaN(newParsedValue)) {
            setInputValue(format(numberValue));
            return;
        }
        // Clamp to min and max, round to the nearest step, and round to specified number of digits
        let clampedValue = commitBehavior === 'snap' ? snapValue(newParsedValue) : newParsedValue;
        clampedValue = numberParser.parse(format(clampedValue));
        let shouldValidate = clampedValue !== numberValue;
        setNumberValue(clampedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        setInputValue(format(value === undefined ? clampedValue : numberValue));
        if (shouldValidate) validation.commitValidation();
    };
    let safeNextStep = (operation, minMax = 0)=>{
        let prev = parsedValue;
        if (isNaN(prev)) {
            // if the input is empty, start from the min/max value when incrementing/decrementing,
            // or zero if there is no min/max value defined.
            let newValue = isNaN(minMax) ? 0 : minMax;
            return (0, $g8XbY.snapValueToStep)(newValue, minValue, maxValue, clampStep);
        } else {
            // otherwise, first snap the current value to the nearest step. if it moves in the direction
            // we're going, use that value, otherwise add the step and snap that value.
            let newValue = (0, $g8XbY.snapValueToStep)(prev, minValue, maxValue, clampStep);
            if (operation === '+' && newValue > prev || operation === '-' && newValue < prev) return newValue;
            return (0, $g8XbY.snapValueToStep)($a5f96a799f771f03$var$$3d0ee518c6f3d04f$var$handleDecimalOperation(operation, prev, clampStep), minValue, maxValue, clampStep);
        }
    };
    let increment = ()=>{
        let newValue = safeNextStep('+', minValue);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = safeNextStep('-', maxValue);
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>{
        if (maxValue != null) {
            setNumberValue((0, $g8XbY.snapValueToStep)(maxValue, minValue, maxValue, clampStep));
            validation.commitValidation();
        }
    };
    let decrementToMin = ()=>{
        if (minValue != null) {
            setNumberValue(minValue);
            validation.commitValidation();
        }
    };
    let canIncrement = (0, $eF4cA.useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || maxValue === undefined || isNaN(maxValue) || (0, $g8XbY.snapValueToStep)(parsedValue, minValue, maxValue, clampStep) > parsedValue || $a5f96a799f771f03$var$$3d0ee518c6f3d04f$var$handleDecimalOperation('+', parsedValue, clampStep) <= maxValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let canDecrement = (0, $eF4cA.useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || minValue === undefined || isNaN(minValue) || (0, $g8XbY.snapValueToStep)(parsedValue, minValue, maxValue, clampStep) < parsedValue || $a5f96a799f771f03$var$$3d0ee518c6f3d04f$var$handleDecimalOperation('-', parsedValue, clampStep) >= minValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let validate = (value)=>numberParser.isValidPartialNumber(value, minValue, maxValue);
    return {
        ...validation,
        validate: validate,
        increment: increment,
        incrementToMax: incrementToMax,
        decrement: decrement,
        decrementToMin: decrementToMin,
        canIncrement: canIncrement,
        canDecrement: canDecrement,
        minValue: minValue,
        maxValue: maxValue,
        numberValue: parsedValue,
        defaultNumberValue: isNaN(defaultValue) ? initialValue : defaultValue,
        setNumberValue: setNumberValue,
        setInputValue: setInputValue,
        inputValue: inputValue,
        commit: commit
    };
}
// Shallow equality is sufficient here because all values in Intl.NumberFormatOptions are primitives.
function $a5f96a799f771f03$var$$3d0ee518c6f3d04f$var$isEqualFormatOptions(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}
function $a5f96a799f771f03$var$$3d0ee518c6f3d04f$var$handleDecimalOperation(operator, value1, value2) {
    let result = operator === '+' ? value1 + value2 : value1 - value2;
    // Check if we have decimals
    if (value1 % 1 !== 0 || value2 % 1 !== 0) {
        const value1Decimal = value1.toString().split('.');
        const value2Decimal = value2.toString().split('.');
        const value1DecimalLength = value1Decimal[1] && value1Decimal[1].length || 0;
        const value2DecimalLength = value2Decimal[1] && value2Decimal[1].length || 0;
        const multiplier = Math.pow(10, Math.max(value1DecimalLength, value2DecimalLength));
        // Transform the decimals to integers based on the precision
        value1 = Math.round(value1 * multiplier);
        value2 = Math.round(value2 * multiplier);
        // Perform the operation on integers values to make sure we don't get a fancy decimal value
        result = operator === '+' ? value1 + value2 : value1 - value2;
        // Transform the integer result back to decimal
        result /= multiplier;
    }
    return result;
}

});
parcelRegister("9LpUQ", function(module, exports) {

$parcel$export(module.exports, "NumberParser", () => $11bdb6b24b3f728f$export$cd11ab140839f11d);

var $l3v5Z = parcelRequire("l3v5Z");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$CURRENCY_SIGN_REGEX = new RegExp('^.*\\(.*\\).*$');
const $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$NUMBERING_SYSTEMS = [
    'latn',
    'arab',
    'hanidec',
    'deva',
    'beng',
    'fullwide'
];
class $11bdb6b24b3f728f$export$cd11ab140839f11d {
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
}
const $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$numberParserCache = new Map();
function $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes('-nu-') && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getCachedNumberParser(locale + (locale.includes('-u-') ? '-nu-' : '-u-nu-') + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    let parser = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$NumberParserImpl(locale, options);
        $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$NumberParserImpl {
    constructor(locale, options = {}){
        this.locale = locale;
        // see https://tc39.es/ecma402/#sec-setnfdigitoptions, when using roundingIncrement, the maximumFractionDigits and minimumFractionDigits must be equal
        // by default, they are 0 and 3 respectively, so we set them to 0 if neither are set
        if (options.roundingIncrement !== 1 && options.roundingIncrement != null) {
            if (options.maximumFractionDigits == null && options.minimumFractionDigits == null) {
                options.maximumFractionDigits = 0;
                options.minimumFractionDigits = 0;
            } else if (options.maximumFractionDigits == null) options.maximumFractionDigits = options.minimumFractionDigits;
            else if (options.minimumFractionDigits == null) options.minimumFractionDigits = options.maximumFractionDigits;
        // if both are specified, let the normal Range Error be thrown
        }
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getSymbols(locale, this.formatter, this.options, options);
        if (this.options.style === 'percent' && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18)) console.warn('NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.');
    }
    parse(value) {
        let isGroupSymbolAllowed = this.formatter.resolvedOptions().useGrouping;
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        // Return NaN if there is a group symbol but useGrouping is false
        if (!isGroupSymbolAllowed && this.symbols.group && fullySanitizedValue.includes(this.symbols.group)) return NaN;
        else if (this.symbols.group) fullySanitizedValue = fullySanitizedValue.replaceAll(this.symbols.group, '');
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, '.');
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, '-');
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === 'percent') {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf('-');
            fullySanitizedValue = fullySanitizedValue.replace('-', '');
            fullySanitizedValue = fullySanitizedValue.replace('+', '');
            let index = fullySanitizedValue.indexOf('.');
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace('.', '');
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = '0.00';
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === 'percent') {
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: 'decimal',
                minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
                maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
            };
            return new $11bdb6b24b3f728f$export$cd11ab140839f11d(this.locale, options).parse(new (0, $l3v5Z.NumberFormatter)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === 'accounting' && $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        let isGroupSymbolAllowed = this.formatter.resolvedOptions().useGrouping;
        // If the value is only a unit and it matches one of the formatted numbers where the value is part of the unit and doesn't have any numerals, then
        // return the known value for that case.
        if (this.symbols.noNumeralUnits.length > 0 && this.symbols.noNumeralUnits.find((obj)=>obj.unit === value)) return this.symbols.noNumeralUnits.find((obj)=>obj.unit === value).value.toString();
        value = value.replace(this.symbols.literals, '');
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace('-', this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === 'arab') {
            if (this.symbols.decimal) {
                value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, ',', this.symbols.decimal);
                value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group && isGroupSymbolAllowed) value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, '.', this.symbols.group);
        }
        // In some locale styles, such as swiss currency, the group character can be a special single quote
        // that keyboards don't typically have. This expands the character to include the easier to type single quote.
        if (this.symbols.group === "\u2019" && value.includes("'") && isGroupSymbolAllowed) value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, "'", this.symbols.group);
        // On newer ICU versions, the special single quote has been normalized, so we need to backport.
        if (this.symbols.group === "'" && value.includes("\u2019") && isGroupSymbolAllowed) value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, "\u2019", this.symbols.group);
        // fr-FR group character is narrow non-breaking space, char code 8239 (U+202F), but that's not a key on the french keyboard,
        // so allow space and non-breaking space as a group char as well
        if (this.options.locale === 'fr-FR' && this.symbols.group && isGroupSymbolAllowed) {
            value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, ' ', this.symbols.group);
            value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, /\u00A0/g, this.symbols.group);
        }
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        let isGroupSymbolAllowed = this.formatter.resolvedOptions().useGrouping;
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group && isGroupSymbolAllowed) value = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(value, this.symbols.group, '');
        value = value.replace(this.symbols.numeral, '');
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, '');
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
}
const $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$nonLiteralParts = new Set([
    'decimal',
    'fraction',
    'integer',
    'minusSign',
    'plusSign',
    'group'
]);
// This list is derived from https://www.unicode.org/cldr/charts/49/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// Run scripts/generateAllPlurals.mjs to generate this list.
const $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        // Resets so we get the full range of symbols
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21,
        roundingIncrement: 1,
        roundingPriority: 'auto',
        roundingMode: 'halfExpand',
        useGrouping: true
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    // if the plural parts include a unit but no integer or fraction, then we need to add the unit to the special set
    let noNumeralUnits = pluralParts.map((p, i)=>{
        let unit = p.find((p)=>p.type === 'unit');
        if (unit && !p.some((p)=>p.type === 'integer' || p.type === 'fraction')) return {
            unit: unit.value,
            value: $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$pluralNumbers[i]
        };
        return null;
    }).filter((p)=>!!p);
    let minusSign = allParts.find((p)=>p.type === 'minusSign')?.value ?? '-';
    let plusSign = posAllParts.find((p)=>p.type === 'plusSign')?.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    if (!plusSign && (originalOptions?.signDisplay === 'exceptZero' || originalOptions?.signDisplay === 'always')) plusSign = '+';
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = decimalParts.find((p)=>p.type === 'decimal')?.value;
    let group = allParts.find((p)=>p.type === 'group')?.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!$11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$nonLiteralParts.has(p.type)).map((p)=>$11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!$11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$nonLiteralParts.has(p.type)).map((p)=>$11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    // Match both whitespace and formatting characters
    let literals = sortedLiterals.length === 0 ? new RegExp('\\p{White_Space}|\\p{Cf}', 'gu') : new RegExp(`${sortedLiterals.join('|')}|\\p{White_Space}|\\p{Cf}`, 'gu');
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join('')}]`, 'g');
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        numerals: numerals,
        index: index,
        noNumeralUnits: noNumeralUnits
    };
}
function $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$replaceAll(str, find, replace) {
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $11bdb6b24b3f728f$var$$eb76cf4feb040f77$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

});


parcelRegister("fqsAA", function(module, exports) {

$parcel$export(module.exports, "useColor", () => $f897c9f8bf3916b6$export$5aadd9c0606af5c2);

var $kQT4E = parcelRequire("kQT4E");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f897c9f8bf3916b6$export$5aadd9c0606af5c2(value) {
    return (0, $eF4cA.useMemo)(()=>{
        if (typeof value === 'string') try {
            return (0, $kQT4E.parseColor)(value);
        } catch  {
            return undefined;
        }
        return value;
    }, [
        value
    ]);
}

});


parcelRegister("ifCwf", function(module, exports) {

$parcel$export(module.exports, "useColorFieldState", () => $4b093fd3814634e5$export$d52a01683abdfcd6);

var $iEwfj = parcelRequire("iEwfj");

var $kQT4E = parcelRequire("kQT4E");

var $fqsAA = parcelRequire("fqsAA");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR = (0, $kQT4E.parseColor)('#000000');
const $4b093fd3814634e5$var$$83c2160a93ad557c$var$MAX_COLOR = (0, $kQT4E.parseColor)('#FFFFFF');
const $4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR_INT = $4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR.toHexInt();
const $4b093fd3814634e5$var$$83c2160a93ad557c$var$MAX_COLOR_INT = $4b093fd3814634e5$var$$83c2160a93ad557c$var$MAX_COLOR.toHexInt();
function $4b093fd3814634e5$export$d52a01683abdfcd6(props) {
    let { value: value, defaultValue: defaultValue, onChange: onChange } = props;
    let { step: step } = $4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR.getChannelRange('red');
    let initialDefaultValue = (0, $fqsAA.useColor)(defaultValue);
    let [colorValue, setColorValue] = (0, $iUErx.useControlledState)((0, $fqsAA.useColor)(value), initialDefaultValue, onChange);
    let [initialValue] = (0, $eF4cA.useState)(colorValue);
    let [inputValue, setInputValue] = (0, $eF4cA.useState)(()=>(value || defaultValue) && colorValue ? colorValue.toString('hex') : '');
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: colorValue
    });
    let safelySetColorValue = (newColor)=>{
        if (!colorValue || !newColor) {
            setColorValue(newColor);
            return;
        }
        if (newColor.toHexInt() !== colorValue.toHexInt()) {
            setColorValue(newColor);
            return;
        }
    };
    let [prevValue, setPrevValue] = (0, $eF4cA.useState)(colorValue);
    if (prevValue !== colorValue) {
        setInputValue(colorValue ? colorValue.toString('hex') : '');
        setPrevValue(colorValue);
    }
    let parsedValue = (0, $eF4cA.useMemo)(()=>{
        let color;
        try {
            color = (0, $kQT4E.parseColor)(inputValue.startsWith('#') ? inputValue : `#${inputValue}`);
        } catch  {
            color = null;
        }
        return color;
    }, [
        inputValue
    ]);
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            safelySetColorValue(null);
            if (value === undefined || colorValue === null) setInputValue('');
            else setInputValue(colorValue.toString('hex'));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (parsedValue == null) {
            setInputValue(colorValue ? colorValue.toString('hex') : '');
            return;
        }
        safelySetColorValue(parsedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        let newColorValue = '';
        if (colorValue) newColorValue = colorValue.toString('hex');
        setInputValue(newColorValue);
        validation.commitValidation();
    };
    let increment = ()=>{
        let newValue = $4b093fd3814634e5$var$$83c2160a93ad557c$var$addColorValue(parsedValue, step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString('hex'));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = $4b093fd3814634e5$var$$83c2160a93ad557c$var$addColorValue(parsedValue, -step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString('hex'));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>safelySetColorValue($4b093fd3814634e5$var$$83c2160a93ad557c$var$MAX_COLOR);
    let decrementToMin = ()=>safelySetColorValue($4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR);
    let validate = (value)=>value === '' || !!value.match(/^#?[0-9a-f]{0,6}$/i)?.[0];
    return {
        ...validation,
        validate: validate,
        colorValue: colorValue,
        defaultColorValue: initialDefaultValue ?? initialValue,
        setColorValue: setColorValue,
        inputValue: inputValue,
        setInputValue: setInputValue,
        commit: commit,
        increment: increment,
        incrementToMax: incrementToMax,
        decrement: decrement,
        decrementToMin: decrementToMin
    };
}
function $4b093fd3814634e5$var$$83c2160a93ad557c$var$addColorValue(color, step) {
    let newColor = color ? color : $4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR;
    let colorInt = newColor.toHexInt();
    let clampInt = Math.min(Math.max(colorInt + step, $4b093fd3814634e5$var$$83c2160a93ad557c$var$MIN_COLOR_INT), $4b093fd3814634e5$var$$83c2160a93ad557c$var$MAX_COLOR_INT);
    if (clampInt !== colorInt) {
        let newColorString = `#${clampInt.toString(16).padStart(6, '0').toUpperCase()}`;
        newColor = (0, $kQT4E.parseColor)(newColorString);
    }
    return newColor;
}

});



parcelRegister("fWQx3", function(module, exports) {

$parcel$export(module.exports, "InternalColorSwatchContext", () => $78a17f562b11bcd3$export$2d9e1fe7b5c0ceb6);
$parcel$export(module.exports, "ColorSwatch", () => $78a17f562b11bcd3$export$cae13e90592f246a);


var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $j81Pl = parcelRequire("j81Pl");
var $kQT4E = parcelRequire("kQT4E");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $78a17f562b11bcd3$export$83cc445538396800 = (0, $eF4cA.createContext)(null);
const $78a17f562b11bcd3$export$2d9e1fe7b5c0ceb6 = (0, $eF4cA.createContext)(null);
const $78a17f562b11bcd3$export$cae13e90592f246a = (0, $eF4cA.forwardRef)(function ColorSwatch(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $78a17f562b11bcd3$export$83cc445538396800);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let ctx = (0, $eF4cA.useContext)($78a17f562b11bcd3$export$2d9e1fe7b5c0ceb6);
    let { size: size = ctx?.size || 'M', rounding: rounding = ctx?.rounding || 'default', color: color } = props;
    let nonNullValue = color || '#fff0';
    color = (0, $eF4cA.useMemo)(()=>typeof nonNullValue === 'string' ? (0, $kQT4E.parseColor)(nonNullValue) : nonNullValue, [
        nonNullValue
    ]);
    let swatch = (0, $dx4lB.jsx)((0, $j81Pl.ColorSwatch), {
        ...props,
        color: color,
        ref: domRef,
        style: ({ color: color })=>({
                // TODO: should there be a distinction between transparent and no value (e.g. null)?
                background: color.getChannelValue('alpha') > 0 ? `linear-gradient(${color}, ${color}), repeating-conic-gradient(#e6e6e6 0% 25%, white 0% 50%) 0% 50% / 16px 16px` : 'linear-gradient(to bottom right, transparent calc(50% - 2px), var(--slash-color) calc(50% - 2px) calc(50% + 2px), transparent calc(50% + 2px)) no-repeat'
            }),
        className: function anonymous(props, overrides) {
            let rules = " ";
            let width = false;
            let height = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "Z") width = true;
                if (p[1] === "F") height = true;
                rules += p[0];
            }
            if (props.size === "L") {
                if (!width) rules += ' Zw182';
            } else if (props.size === "M") {
                if (!width) rules += ' ZC182';
            } else if (props.size === "S") {
                if (!width) rules += ' Zo182';
            } else if (props.size === "XS") {
                if (!width) rules += ' Zu182';
            }
            if (props.size === "L") {
                if (!height) rules += ' Fv182';
            } else if (props.size === "M") {
                if (!height) rules += ' Fx182';
            } else if (props.size === "S") {
                if (!height) rules += ' Fp182';
            } else if (props.size === "XS") {
                if (!height) rules += ' Ft182';
            }
            if (props.rounding === "full") rules += ' og182';
            else if (props.rounding === "none") rules += ' od182';
            else if (props.rounding === "default") rules += ' oa182';
            if (props.rounding === "full") rules += ' ng182';
            else if (props.rounding === "none") rules += ' nd182';
            else if (props.rounding === "default") rules += ' na182';
            if (props.rounding === "full") rules += ' kg182';
            else if (props.rounding === "none") rules += ' kd182';
            else if (props.rounding === "default") rules += ' ka182';
            if (props.rounding === "full") rules += ' jg182';
            else if (props.rounding === "none") rules += ' jd182';
            else if (props.rounding === "default") rules += ' ja182';
            rules += ' iz182';
            rules += ' _kb182';
            rules += ' hb182';
            rules += ' mb182';
            rules += ' lb182';
            rules += ' _jf182';
            rules += ' _oa182';
            rules += ' _yb182';
            rules += ' -_8LZfRc-pq182';
            return rules;
        }({
            size: size,
            rounding: rounding
        }, props.styles)
    });
    // ColorSwatchPicker needs to wrap the swatch in a ListBoxItem.
    if (ctx) return ctx.useWrapper(swatch, color, rounding);
    return swatch;
});

});
parcelRegister("j81Pl", function(module, exports) {

$parcel$export(module.exports, "ColorSwatchContext", () => $dd685f6f56a4b1b5$export$83cc445538396800);
$parcel$export(module.exports, "ColorSwatch", () => $dd685f6f56a4b1b5$export$cae13e90592f246a);

var $fDYaM = parcelRequire("fDYaM");

var $91Drq = parcelRequire("91Drq");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
const $dd685f6f56a4b1b5$export$83cc445538396800 = (0, $eF4cA.createContext)(null);
const $dd685f6f56a4b1b5$export$cae13e90592f246a = (0, $eF4cA.forwardRef)(function ColorSwatch(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $dd685f6f56a4b1b5$export$83cc445538396800);
    let { colorSwatchProps: colorSwatchProps, color: color } = (0, $91Drq.useColorSwatch)(props);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorSwatch',
        defaultStyle: colorSwatchProps.style,
        values: {
            color: color
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, colorSwatchProps, renderProps),
        slot: props.slot || undefined,
        ref: ref
    });
});

});
parcelRegister("91Drq", function(module, exports) {

$parcel$export(module.exports, "useColorSwatch", () => $7c0ad752ff77b3e4$export$9060ae606178d849);

var $fVfXf = parcelRequire("fVfXf");

var $b6jfX = parcelRequire("b6jfX");

var $25dFS = parcelRequire("25dFS");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");

var $kQT4E = parcelRequire("kQT4E");
function $7c0ad752ff77b3e4$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7c0ad752ff77b3e4$export$9060ae606178d849(props) {
    let { color: value, colorName: colorName } = props;
    let nonNullValue = value || '#fff0';
    let color = (0, $eF4cA.useMemo)(()=>typeof nonNullValue === 'string' ? (0, $kQT4E.parseColor)(nonNullValue) : nonNullValue, [
        nonNullValue
    ]);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($7c0ad752ff77b3e4$var$$parcel$interopDefault((0, $b6jfX.default)), '@react-aria/color');
    let id = (0, $25dFS.useId)(props.id);
    if (!colorName) colorName = color.getChannelValue('alpha') === 0 ? stringFormatter.format('transparent') : color.getColorName(locale);
    return {
        colorSwatchProps: {
            ...DOMProps,
            role: 'img',
            'aria-roledescription': stringFormatter.format('colorSwatch'),
            'aria-label': [
                colorName,
                props['aria-label'] || ''
            ].filter(Boolean).join(', '),
            'aria-labelledby': props['aria-labelledby'] ? `${id} ${props['aria-labelledby']}` : undefined,
            id: id,
            style: {
                backgroundColor: color.toString('css'),
                // @ts-ignore
                forcedColorAdjust: 'none'
            }
        },
        color: color || null
    };
}

});
parcelRegister("b6jfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd3493dc32bcb40$export$2e2bcd8739ae039);

var $7H6FO = parcelRequire("7H6FO");

var $5L4ni = parcelRequire("5L4ni");

var $bpguD = parcelRequire("bpguD");

var $fr55O = parcelRequire("fr55O");

var $H8ULd = parcelRequire("H8ULd");

var $bXgBu = parcelRequire("bXgBu");

var $c44L4 = parcelRequire("c44L4");

var $gyAI1 = parcelRequire("gyAI1");

var $g1XQQ = parcelRequire("g1XQQ");

var $ftIWk = parcelRequire("ftIWk");

var $fKkr1 = parcelRequire("fKkr1");

var $e0Oxo = parcelRequire("e0Oxo");

var $ik2gs = parcelRequire("ik2gs");

var $bl55e = parcelRequire("bl55e");

var $4M5kL = parcelRequire("4M5kL");

var $6lqc2 = parcelRequire("6lqc2");

var $jI7B4 = parcelRequire("jI7B4");

var $3uhAj = parcelRequire("3uhAj");

var $2DqEZ = parcelRequire("2DqEZ");

var $eYypJ = parcelRequire("eYypJ");

var $MHZFJ = parcelRequire("MHZFJ");

var $arW9l = parcelRequire("arW9l");

var $hsz5a = parcelRequire("hsz5a");

var $dZlsy = parcelRequire("dZlsy");

var $lQk8s = parcelRequire("lQk8s");

var $aChrR = parcelRequire("aChrR");

var $bRnir = parcelRequire("bRnir");

var $kb4Vl = parcelRequire("kb4Vl");

var $jyNCi = parcelRequire("jyNCi");

var $4IQMZ = parcelRequire("4IQMZ");

var $l2TjQ = parcelRequire("l2TjQ");

var $87XYX = parcelRequire("87XYX");

var $2KeeM = parcelRequire("2KeeM");

var $2tisk = parcelRequire("2tisk");
var $9dd3493dc32bcb40$export$2e2bcd8739ae039 = {};
$9dd3493dc32bcb40$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $7H6FO.default),
    "bg-BG": (0, $5L4ni.default),
    "cs-CZ": (0, $bpguD.default),
    "da-DK": (0, $fr55O.default),
    "de-DE": (0, $H8ULd.default),
    "el-GR": (0, $bXgBu.default),
    "en-US": (0, $c44L4.default),
    "es-ES": (0, $gyAI1.default),
    "et-EE": (0, $g1XQQ.default),
    "fi-FI": (0, $ftIWk.default),
    "fr-FR": (0, $fKkr1.default),
    "he-IL": (0, $e0Oxo.default),
    "hr-HR": (0, $ik2gs.default),
    "hu-HU": (0, $bl55e.default),
    "it-IT": (0, $4M5kL.default),
    "ja-JP": (0, $6lqc2.default),
    "ko-KR": (0, $jI7B4.default),
    "lt-LT": (0, $3uhAj.default),
    "lv-LV": (0, $2DqEZ.default),
    "nb-NO": (0, $eYypJ.default),
    "nl-NL": (0, $MHZFJ.default),
    "pl-PL": (0, $arW9l.default),
    "pt-BR": (0, $hsz5a.default),
    "pt-PT": (0, $dZlsy.default),
    "ro-RO": (0, $lQk8s.default),
    "ru-RU": (0, $aChrR.default),
    "sk-SK": (0, $bRnir.default),
    "sl-SI": (0, $kb4Vl.default),
    "sr-SP": (0, $jyNCi.default),
    "sv-SE": (0, $4IQMZ.default),
    "tr-TR": (0, $l2TjQ.default),
    "uk-UA": (0, $87XYX.default),
    "zh-CN": (0, $2KeeM.default),
    "zh-TW": (0, $2tisk.default)
};

});
parcelRegister("7H6FO", function(module, exports) {

$parcel$export(module.exports, "default", () => $61952cf5801b7cb4$export$2e2bcd8739ae039);
var $61952cf5801b7cb4$export$2e2bcd8739ae039 = {};
$61952cf5801b7cb4$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{623}\u{62F}\u{627}\u{629} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{621} \u{627}\u{644}\u{644}\u{648}\u{646}`,
    "colorSwatch": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{623}\u{644}\u{648}\u{627}\u{646}`,
    "transparent": `\u{634}\u{641}\u{627}\u{641}`,
    "twoDimensionalSlider": `\u{645}\u{64F}\u{646}\u{632}\u{644}\u{642} 2D`
};

});

parcelRegister("5L4ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ab7340533d4fd43$export$2e2bcd8739ae039);
var $8ab7340533d4fd43$export$2e2bcd8739ae039 = {};
$8ab7340533d4fd43$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{437}\u{430} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{446}\u{432}\u{44F}\u{442}`,
    "colorSwatch": `\u{446}\u{432}\u{435}\u{442}\u{43D}\u{430} \u{43C}\u{43E}\u{441}\u{442}\u{440}\u{430}`,
    "transparent": `\u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{435}\u{43D}`,
    "twoDimensionalSlider": `2D \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{447}`
};

});

parcelRegister("bpguD", function(module, exports) {

$parcel$export(module.exports, "default", () => $42786a4ca60e45df$export$2e2bcd8739ae039);
var $42786a4ca60e45df$export$2e2bcd8739ae039 = {};
$42786a4ca60e45df$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdb\u{11B}r barvy`,
    "colorSwatch": `barevn\xfd vzorek`,
    "transparent": `pr\u{16F}hledn\xfd`,
    "twoDimensionalSlider": `2D posuvn\xedk`
};

});

parcelRegister("fr55O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51f76111f3a814d$export$2e2bcd8739ae039);
var $f51f76111f3a814d$export$2e2bcd8739ae039 = {};
$f51f76111f3a814d$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farvev\xe6lger`,
    "colorSwatch": `farvepr\xf8ve`,
    "transparent": `gennemsigtig`,
    "twoDimensionalSlider": `2D-skyder`
};

});

parcelRegister("H8ULd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cb6db07eff4f6c6$export$2e2bcd8739ae039);
var $1cb6db07eff4f6c6$export$2e2bcd8739ae039 = {};
$1cb6db07eff4f6c6$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farbw\xe4hler`,
    "colorSwatch": `Farbfeld`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `2D-Schieberegler`
};

});

parcelRegister("bXgBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3ebdf011f72676$export$2e2bcd8739ae039);
var $5c3ebdf011f72676$export$2e2bcd8739ae039 = {};
$5c3ebdf011f72676$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3B1}\u{3C2} \u{3C7}\u{3C1}\u{3C9}\u{3BC}\u{3AC}\u{3C4}\u{3C9}\u{3BD}`,
    "colorSwatch": `\u{3C7}\u{3C1}\u{3C9}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3CC} \u{3B4}\u{3B5}\u{3AF}\u{3B3}\u{3BC}\u{3B1}`,
    "transparent": `\u{3B4}\u{3B9}\u{3B1}\u{3C6}\u{3B1}\u{3BD}\u{3AD}\u{3C2}`,
    "twoDimensionalSlider": `\u{3A1}\u{3C5}\u{3B8}\u{3BC}\u{3B9}\u{3C3}\u{3C4}\u{3B9}\u{3BA}\u{3CC} 2D`
};

});

parcelRegister("c44L4", function(module, exports) {

$parcel$export(module.exports, "default", () => $13186e78edbff962$export$2e2bcd8739ae039);
var $13186e78edbff962$export$2e2bcd8739ae039 = {};
$13186e78edbff962$export$2e2bcd8739ae039 = {
    "colorPicker": `Color picker`,
    "twoDimensionalSlider": `2D slider`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorSwatch": `color swatch`,
    "transparent": `transparent`
};

});

parcelRegister("gyAI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d294fa4567b1c7$export$2e2bcd8739ae039);
var $45d294fa4567b1c7$export$2e2bcd8739ae039 = {};
$45d294fa4567b1c7$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de color`,
    "colorSwatch": `muestra de color`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Regulador 2D`
};

});

parcelRegister("g1XQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $91b22e596332cc9c$export$2e2bcd8739ae039);
var $91b22e596332cc9c$export$2e2bcd8739ae039 = {};
$91b22e596332cc9c$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rvivalija`,
    "colorSwatch": `v\xe4rvin\xe4idis`,
    "transparent": `l\xe4bipaistev`,
    "twoDimensionalSlider": `2D-liugur`
};

});

parcelRegister("ftIWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62954a00316ef49$export$2e2bcd8739ae039);
var $e62954a00316ef49$export$2e2bcd8739ae039 = {};
$e62954a00316ef49$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rimuokkain`,
    "colorSwatch": `v\xe4rimalli`,
    "transparent": `l\xe4pin\xe4kyv\xe4`,
    "twoDimensionalSlider": `2D-liukus\xe4\xe4din`
};

});

parcelRegister("fKkr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $046dbb39699f778f$export$2e2bcd8739ae039);
var $046dbb39699f778f$export$2e2bcd8739ae039 = {};
$046dbb39699f778f$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\xa0: ${args.value}`,
    "colorPicker": `S\xe9lecteur de couleurs`,
    "colorSwatch": `\xc9chantillon de couleurs`,
    "transparent": `Transparent`,
    "twoDimensionalSlider": `Curseur\xa02D`
};

});

parcelRegister("e0Oxo", function(module, exports) {

$parcel$export(module.exports, "default", () => $50349749f1a44c18$export$2e2bcd8739ae039);
var $50349749f1a44c18$export$2e2bcd8739ae039 = {};
$50349749f1a44c18$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{5D1}\u{5D5}\u{5D7}\u{5E8} \u{5D4}\u{5E6}\u{5D1}\u{5E2}\u{5D9}\u{5DD}`,
    "colorSwatch": `\u{5D3}\u{5D5}\u{5D2}\u{5DE}\u{5D9}\u{5EA} \u{5E6}\u{5D1}\u{5E2}`,
    "transparent": `\u{5E9}\u{5E7}\u{5D5}\u{5E3}`,
    "twoDimensionalSlider": `\u{5DE}\u{5D7}\u{5D5}\u{5D5}\u{5DF} \u{5D3}\u{5D5} \u{5DE}\u{5D9}\u{5DE}\u{5D3}\u{5D9}`
};

});

parcelRegister("ik2gs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f2a3f8a522f8$export$2e2bcd8739ae039);
var $7b08f2a3f8a522f8$export$2e2bcd8739ae039 = {};
$7b08f2a3f8a522f8$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Odabir boje`,
    "colorSwatch": `uzorak boje`,
    "transparent": `transparentno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};

});

parcelRegister("bl55e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4011db9de7430026$export$2e2bcd8739ae039);
var $4011db9de7430026$export$2e2bcd8739ae039 = {};
$4011db9de7430026$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Sz\xednv\xe1laszt\xf3`,
    "colorSwatch": `sz\xednt\xe1r`,
    "transparent": `\xe1tl\xe1tsz\xf3`,
    "twoDimensionalSlider": `2D-cs\xfaszka`
};

});

parcelRegister("4M5kL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d07b4cfe68331d0e$export$2e2bcd8739ae039);
var $d07b4cfe68331d0e$export$2e2bcd8739ae039 = {};
$d07b4cfe68331d0e$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selettore colore`,
    "colorSwatch": `campione di colore`,
    "transparent": `trasparente`,
    "twoDimensionalSlider": `Cursore 2D`
};

});

parcelRegister("6lqc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d336941ea87f64c$export$2e2bcd8739ae039);
var $4d336941ea87f64c$export$2e2bcd8739ae039 = {};
$4d336941ea87f64c$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}\u{3001}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name} : ${args.value}`,
    "colorPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30D4}\u{30C3}\u{30AB}\u{30FC}`,
    "colorSwatch": `\u{30AB}\u{30E9}\u{30FC}\u{30B9}\u{30A6}\u{30A9}\u{30C3}\u{30C1}`,
    "transparent": `\u{900F}\u{660E}`,
    "twoDimensionalSlider": `2D \u{30B9}\u{30E9}\u{30A4}\u{30C0}\u{30FC}`
};

});

parcelRegister("jI7B4", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f988c1008d89f2$export$2e2bcd8739ae039);
var $80f988c1008d89f2$export$2e2bcd8739ae039 = {};
$80f988c1008d89f2$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{C0C9}\u{C0C1} \u{D53C}\u{CEE4}`,
    "colorSwatch": `\u{C0C9}\u{C0C1} \u{ACAC}\u{BCF8}`,
    "transparent": `\u{D22C}\u{BA85}\u{B3C4}`,
    "twoDimensionalSlider": `2D \u{C2AC}\u{B77C}\u{C774}\u{B354}`
};

});

parcelRegister("3uhAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e48c2e3d8a1972f$export$2e2bcd8739ae039);
var $6e48c2e3d8a1972f$export$2e2bcd8739ae039 = {};
$6e48c2e3d8a1972f$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Spalv\u{173} parinkiklis`,
    "colorSwatch": `spalv\u{173} pavyzdys`,
    "transparent": `skaidrus`,
    "twoDimensionalSlider": `2D slankiklis`
};

});

parcelRegister("2DqEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24426af9da19912$export$2e2bcd8739ae039);
var $a24426af9da19912$export$2e2bcd8739ae039 = {};
$a24426af9da19912$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kr\u{101}su atlas\u{12B}t\u{101}js`,
    "colorSwatch": `kr\u{101}su paraugs`,
    "transparent": `caursp\u{12B}d\u{12B}gs`,
    "twoDimensionalSlider": `2D sl\u{12B}dnis`
};

});

parcelRegister("eYypJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $778de1a72c52e67a$export$2e2bcd8739ae039);
var $778de1a72c52e67a$export$2e2bcd8739ae039 = {};
$778de1a72c52e67a$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Fargevelger`,
    "colorSwatch": `fargekart`,
    "transparent": `gjennomsiktig`,
    "twoDimensionalSlider": `2D-glidebryter`
};

});

parcelRegister("MHZFJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccb288d85c61417c$export$2e2bcd8739ae039);
var $ccb288d85c61417c$export$2e2bcd8739ae039 = {};
$ccb288d85c61417c$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kleurkiezer`,
    "colorSwatch": `kleurstaal`,
    "transparent": `transparant`,
    "twoDimensionalSlider": `2D-schuifregelaar`
};

});

parcelRegister("arW9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c6f82802cf237eb$export$2e2bcd8739ae039);
var $6c6f82802cf237eb$export$2e2bcd8739ae039 = {};
$6c6f82802cf237eb$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Pr\xf3bnik kolor\xf3w`,
    "colorSwatch": `pr\xf3bka koloru`,
    "transparent": `przezroczysty`,
    "twoDimensionalSlider": `Suwak 2D`
};

});

parcelRegister("hsz5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $26874114569ffb63$export$2e2bcd8739ae039);
var $26874114569ffb63$export$2e2bcd8739ae039 = {};
$26874114569ffb63$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cores`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};

});

parcelRegister("dZlsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $142c1d4c912493c6$export$2e2bcd8739ae039);
var $142c1d4c912493c6$export$2e2bcd8739ae039 = {};
$142c1d4c912493c6$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cor`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};

});

parcelRegister("lQk8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $c694527b481f182d$export$2e2bcd8739ae039);
var $c694527b481f182d$export$2e2bcd8739ae039 = {};
$c694527b481f182d$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de culori`,
    "colorSwatch": `specimen de culoare`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `Glisor 2D`
};

});

parcelRegister("aChrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b71d7622571ef943$export$2e2bcd8739ae039);
var $b71d7622571ef943$export$2e2bcd8739ae039 = {};
$b71d7622571ef943$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{41F}\u{430}\u{43B}\u{438}\u{442}\u{440}\u{430} \u{446}\u{432}\u{435}\u{442}\u{43E}\u{432}`,
    "colorSwatch": `\u{446}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{43E}\u{439} \u{43E}\u{431}\u{440}\u{430}\u{437}\u{435}\u{446}`,
    "transparent": `\u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{43D}\u{44B}\u{439}`,
    "twoDimensionalSlider": `\u{41F}\u{43E}\u{43B}\u{437}\u{443}\u{43D}\u{43E}\u{43A} 2D`
};

});

parcelRegister("bRnir", function(module, exports) {

$parcel$export(module.exports, "default", () => $537aa200ac07bab2$export$2e2bcd8739ae039);
var $537aa200ac07bab2$export$2e2bcd8739ae039 = {};
$537aa200ac07bab2$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdber farieb`,
    "colorSwatch": `vzorkovn\xedk farieb`,
    "transparent": `transparentn\xfd`,
    "twoDimensionalSlider": `2D jazdec`
};

});

parcelRegister("kb4Vl", function(module, exports) {

$parcel$export(module.exports, "default", () => $de8cfe7b6df0727b$export$2e2bcd8739ae039);
var $de8cfe7b6df0727b$export$2e2bcd8739ae039 = {};
$de8cfe7b6df0727b$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Izbirnik barv`,
    "colorSwatch": `barvna paleta`,
    "transparent": `prozorno`,
    "twoDimensionalSlider": `2D drsnik`
};

});

parcelRegister("jyNCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a34aef0d8c77437$export$2e2bcd8739ae039);
var $7a34aef0d8c77437$export$2e2bcd8739ae039 = {};
$7a34aef0d8c77437$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Bira\u{10D} boja`,
    "colorSwatch": `Uzorak boje`,
    "transparent": `providno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};

});

parcelRegister("4IQMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0305c274906108$export$2e2bcd8739ae039);
var $6e0305c274906108$export$2e2bcd8739ae039 = {};
$6e0305c274906108$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `F\xe4rgv\xe4ljaren`,
    "colorSwatch": `f\xe4rgruta`,
    "transparent": `genomskinlig`,
    "twoDimensionalSlider": `2D-reglage`
};

});

parcelRegister("l2TjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d9c2cae053e5d8$export$2e2bcd8739ae039);
var $45d9c2cae053e5d8$export$2e2bcd8739ae039 = {};
$45d9c2cae053e5d8$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Renk Se\xe7ici`,
    "colorSwatch": `renk \xf6rne\u{11F}i`,
    "transparent": `saydam`,
    "twoDimensionalSlider": `2D s\xfcrg\xfc`
};

});

parcelRegister("87XYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3c6853a63ec402$export$2e2bcd8739ae039);
var $4f3c6853a63ec402$export$2e2bcd8739ae039 = {};
$4f3c6853a63ec402$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{41F}\u{430}\u{43B}\u{456}\u{442}\u{440}\u{430} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "colorSwatch": `\u{437}\u{440}\u{430}\u{437}\u{43E}\u{43A} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{443}`,
    "transparent": `\u{43F}\u{440}\u{43E}\u{437}\u{43E}\u{440}\u{438}\u{439}`,
    "twoDimensionalSlider": `\u{41F}\u{43E}\u{432}\u{437}\u{443}\u{43D}\u{43E}\u{43A} 2D`
};

});

parcelRegister("2KeeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3fcc81021735c2a$export$2e2bcd8739ae039);
var $c3fcc81021735c2a$export$2e2bcd8739ae039 = {};
$c3fcc81021735c2a$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}\u{3001}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\u{FF1A}${args.value}`,
    "colorPicker": `\u{62FE}\u{8272}\u{5668}`,
    "colorSwatch": `\u{989C}\u{8272}\u{8272}\u{677F}`,
    "transparent": `\u{900F}\u{660E}`,
    "twoDimensionalSlider": `2D \u{6ED1}\u{5757}`
};

});

parcelRegister("2tisk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fbc0d68858cbfc0$export$2e2bcd8739ae039);
var $7fbc0d68858cbfc0$export$2e2bcd8739ae039 = {};
$7fbc0d68858cbfc0$export$2e2bcd8739ae039 = {
    "colorInputLabel": (args)=>`${args.label}\u{FF0C}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\u{FF1A}${args.value}`,
    "colorPicker": `\u{6AA2}\u{8272}\u{5668}`,
    "colorSwatch": `\u{8272}\u{7968}`,
    "transparent": `\u{900F}\u{660E}`,
    "twoDimensionalSlider": `2D \u{6ED1}\u{687F}`
};

});





parcelRegister("fUh73", function(module, exports) {

$parcel$export(module.exports, "ColorSwatchPicker", () => $74381e7752e04335$export$b46792416e3d8515);


var $fWQx3 = parcelRequire("fWQx3");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $f2nrS = parcelRequire("f2nrS");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $74381e7752e04335$export$7214f50881fc1eaf = (0, $eF4cA.createContext)(null);
const $74381e7752e04335$export$b46792416e3d8515 = (0, $eF4cA.forwardRef)(function ColorSwatchPicker(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $74381e7752e04335$export$7214f50881fc1eaf);
    let { density: density = 'regular', size: size = 'M', rounding: rounding = 'none', UNSAFE_className: UNSAFE_className = '', ...otherProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $f2nrS.ColorSwatchPicker), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
            rules += ' sd182';
            rules += ' _wb182';
            if (props.density === "spacious") rules += ' UWJpoB182';
            else if (props.density === "regular") rules += ' Ub182';
            else if (props.density === "compact") rules += ' Ua182';
            if (props.density === "spacious") rules += ' qWJpoB182';
            else if (props.density === "regular") rules += ' qb182';
            else if (props.density === "compact") rules += ' qa182';
            return rules;
        }({
            density: density
        }, props.styles),
        children: (0, $dx4lB.jsx)((0, $fWQx3.InternalColorSwatchContext).Provider, {
            value: {
                useWrapper: $74381e7752e04335$var$$ba9c901b6c815fb9$var$useWrapper,
                size: size,
                rounding: rounding
            },
            children: props.children
        })
    });
});
function $74381e7752e04335$var$$ba9c901b6c815fb9$var$useWrapper(swatch, color, rounding) {
    return (0, $dx4lB.jsx)((0, $f2nrS.ColorSwatchPickerItem), {
        color: color,
        className: (renderProps)=>(function anonymous(props) {
                let rules = " ";
                if (props.isFocusVisible) rules += ' _Lf182';
                else rules += ' _Le182';
                rules += ' Oh182';
                rules += ' Olc182';
                rules += ' _Mc182';
                rules += ' _Kd182';
                rules += ' _Pc182';
                if (props.rounding === "full") rules += ' og182';
                else if (props.rounding === "default") rules += ' oa182';
                else if (props.rounding === "none") rules += ' od182';
                if (props.rounding === "full") rules += ' ng182';
                else if (props.rounding === "default") rules += ' na182';
                else if (props.rounding === "none") rules += ' nd182';
                if (props.rounding === "full") rules += ' kg182';
                else if (props.rounding === "default") rules += ' ka182';
                else if (props.rounding === "none") rules += ' kd182';
                if (props.rounding === "full") rules += ' jg182';
                else if (props.rounding === "default") rules += ' ja182';
                else if (props.rounding === "none") rules += ' jd182';
                rules += ' __ca182';
                return rules;
            })({
                ...renderProps,
                rounding: rounding
            }),
        children: ({ isSelected: isSelected })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    swatch,
                    isSelected && (0, $dx4lB.jsx)("div", {
                        "aria-hidden": true,
                        className: " _Pa182 _Ob182 Wr182 _lr182 _Ar182 _zr182 _oa182 in182 _jf182 _kc182 hc182 mc182 lc182 Og182 _Lf182 _Mc182 _Kc182 _yb182 oi182 ni182 ki182 ji182"
                    })
                ]
            })
    });
}

});
parcelRegister("f2nrS", function(module, exports) {

$parcel$export(module.exports, "ColorSwatchPicker", () => $09eaae03625e5f51$export$b46792416e3d8515);
$parcel$export(module.exports, "ColorSwatchPickerItem", () => $09eaae03625e5f51$export$abcd89c27081c2ef);

var $fDYaM = parcelRequire("fDYaM");

var $j81Pl = parcelRequire("j81Pl");

var $hJVXE = parcelRequire("hJVXE");

var $cg9Gh = parcelRequire("cg9Gh");

var $fVfXf = parcelRequire("fVfXf");

var $kQT4E = parcelRequire("kQT4E");

var $eF4cA = parcelRequire("eF4cA");

var $drBqh = parcelRequire("drBqh");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");
function $09eaae03625e5f51$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
const $09eaae03625e5f51$export$7214f50881fc1eaf = (0, $eF4cA.createContext)(null);
const $09eaae03625e5f51$var$$a36727cf8b43b57f$var$ColorMapContext = (0, $eF4cA.createContext)(null);
const $09eaae03625e5f51$export$b46792416e3d8515 = (0, $eF4cA.forwardRef)(function ColorSwatchPicker(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $09eaae03625e5f51$export$7214f50881fc1eaf);
    let state = (0, $drBqh.useColorPickerState)(props);
    let colorMap = (0, $eF4cA.useMemo)(()=>new Map(), []);
    let formatter = (0, $gI8Gw.useLocalizedStringFormatter)($09eaae03625e5f51$var$$parcel$interopDefault((0, $hJVXE.default)), 'react-aria-components');
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $cg9Gh.ListBox), {
        ...(0, $fVfXf.filterDOMProps)(props, {
            labelable: true
        }),
        ref: ref,
        className: props.className || 'react-aria-ColorSwatchPicker',
        style: props.style,
        "aria-label": props['aria-label'] || (!props['aria-labelledby'] ? formatter.format('colorSwatchPicker') : undefined),
        layout: props.layout || 'grid',
        selectionMode: "single",
        selectedKeys: [
            state.color.toString('hexa')
        ],
        onSelectionChange: (keys)=>{
            // single select, 'all' cannot occur. appease typescript.
            if (keys !== 'all') state.setColor(colorMap.get([
                ...keys
            ][0]));
        },
        disallowEmptySelection: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($09eaae03625e5f51$var$$a36727cf8b43b57f$var$ColorMapContext.Provider, {
        value: colorMap
    }, props.children));
});
const $09eaae03625e5f51$export$abcd89c27081c2ef = (0, $eF4cA.forwardRef)(function ColorSwatchPickerItem(props, ref) {
    let propColor = props.color || '#0000';
    let color = (0, $eF4cA.useMemo)(()=>typeof propColor === 'string' ? (0, $kQT4E.parseColor)(propColor) : propColor, [
        propColor
    ]);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let map = (0, $eF4cA.useContext)($09eaae03625e5f51$var$$a36727cf8b43b57f$var$ColorMapContext);
    (0, $eF4cA.useEffect)(()=>{
        let key = color.toString('hexa');
        map.set(key, color);
        return ()=>{
            map.delete(key);
        };
    }, [
        color,
        map
    ]);
    let wrap = (v)=>{
        if (typeof v === 'function') return (renderProps)=>v({
                ...renderProps,
                color: color
            });
        return v;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $cg9Gh.ListBoxItem), {
        ...props,
        // ColorSwatchPickerItem is never a link.
        render: props.render,
        ref: ref,
        id: color.toString('hexa'),
        textValue: color.getColorName(locale),
        className: wrap(props.className || 'react-aria-ColorSwatchPickerItem'),
        style: wrap(props.style)
    }, (0, $fDYaM.composeRenderProps)(wrap(props.children), (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $j81Pl.ColorSwatchContext).Provider, {
            value: {
                color: color
            }
        }, children)));
});

});
parcelRegister("drBqh", function(module, exports) {

$parcel$export(module.exports, "useColorPickerState", () => $289305e6ee09929c$export$dc6b73b623f8645f);

var $kQT4E = parcelRequire("kQT4E");

var $fqsAA = parcelRequire("fqsAA");

var $iUErx = parcelRequire("iUErx");
function $289305e6ee09929c$export$dc6b73b623f8645f(props) {
    let value = (0, $fqsAA.useColor)(props.value);
    let defaultValue = (0, $fqsAA.useColor)(props.defaultValue || '#000000');
    let [color, setColor] = (0, $iUErx.useControlledState)(value || undefined, defaultValue, props.onChange);
    return {
        color: color,
        setColor (color) {
            if (color != null) setColor(color || (0, $kQT4E.parseColor)('#000000'));
        }
    };
}

});



parcelRegister("eF93E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b60aa2e6ca85e88$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $9b60aa2e6ca85e88$var$$33f3b0a3a61a9fc1$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m18.53 13.47-3-3c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l1.72 1.72H4c-.414 0-.75.336-.75.75s.336.75.75.75h12.19l-1.72 1.72c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22l3-3c.293-.293.293-.767 0-1.06M16 5.25H3.81l1.72-1.72c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0l-3 3c-.293.293-.293.767 0 1.06l3 3c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06L3.81 6.75H16c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const $9b60aa2e6ca85e88$var$$33f3b0a3a61a9fc1$var$ForwardRef = (0, $eF4cA.forwardRef)($9b60aa2e6ca85e88$var$$33f3b0a3a61a9fc1$var$SvgComponent);
var $9b60aa2e6ca85e88$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($9b60aa2e6ca85e88$var$$33f3b0a3a61a9fc1$var$ForwardRef);

});



parcelRegister("m1itB", function(module, exports) {

$parcel$export(module.exports, "PartnershipValuePreview", () => PartnershipValuePreview);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $f16Ml = parcelRequire("f16Ml");
var $aVEhH = parcelRequire("aVEhH");
var $8Muzv = parcelRequire("8Muzv");
var $208Op = parcelRequire("208Op");
var $3YPmU = parcelRequire("3YPmU");
var $j8RRT = parcelRequire("j8RRT");

var $15xG7 = parcelRequire("15xG7");

var $fmJ8d = parcelRequire("fmJ8d");

var $lb17q = parcelRequire("lb17q");

var $lHGo8 = parcelRequire("lHGo8");
const formatter = new Intl.ListFormat("en", {
    style: "long",
    type: "conjunction"
});
const EditButton = ({ value, onPress })=>{
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const setPromptHint = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setPromptHint);
    const handlePress = onPress ?? (()=>{
        setPromptHint(`Edit ${formatter.format((Array.isArray(value) ? value : [
            value
        ]).map((v)=>`"${v}"`))}: `);
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
        "aria-label": "Edit",
        isQuiet: true,
        size: "XS",
        styles: " Iv182",
        UNSAFE_style: {
            display: "inline-grid",
            verticalAlign: "text-bottom"
        },
        onPress: handlePress,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {
            UNSAFE_className: function anonymous(props) {
                let rules = " ";
                if (props.colorScheme === "light") rules += ' psvEhre182';
                else if (props.colorScheme === "dark") rules += ' pAnB4Le182';
                return rules;
            }({
                colorScheme: colorScheme
            })
        })
    });
};
EditButton.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    onPress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
const fieldWrapperStyle = function anonymous(props) {
    let rules = " ";
    if (props.size === "XXXL") rules += ' JC182';
    else if (props.size === "XXL") rules += ' JC182';
    else if (props.size === "XL") rules += ' JC182';
    else if (props.size === "L") rules += ' Jx182';
    else if (props.size === "M") rules += ' Js182';
    else if (props.size === "S") rules += ' Js182';
    if (props.size === "XXXL") rules += ' GC182';
    else if (props.size === "XXL") rules += ' GC182';
    else if (props.size === "XL") rules += ' GC182';
    else if (props.size === "L") rules += ' Gx182';
    else if (props.size === "M") rules += ' Gs182';
    else if (props.size === "S") rules += ' Gs182';
    return rules;
};
const labelStyle = function anonymous(props) {
    let rules = " ";
    if (props.size === "XXXL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XXL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XXXL") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "XXL") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "XL") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    if (props.size === "XXXL") {
        rules += ' xc182';
        rules += ' _xa182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "XXL") {
        rules += ' xc182';
        rules += ' _xa182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "XL") {
        rules += ' xc182';
        rules += ' _xa182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "L") {
        rules += ' xc182';
        rules += ' _xa182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "M") {
        rules += ' xc182';
        rules += ' _xa182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    } else if (props.size === "S") {
        rules += ' xc182';
        rules += ' _xa182';
        rules += ' xfd182';
        rules += ' _xfa182';
        rules += ' xfX0cczbc182';
        rules += ' _xfX0cczba182';
    }
    if (props.size === "XXXL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XXL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "M") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XXXL") rules += ' pn182';
    else if (props.size === "XXL") rules += ' pn182';
    else if (props.size === "XL") rules += ' pn182';
    else if (props.size === "L") rules += ' pn182';
    else if (props.size === "M") rules += ' pn182';
    else if (props.size === "S") rules += ' pn182';
    return rules;
};
const CampaignField = ({ selectedCampaign = {}, selectedPersona = {}, label, value, size = "L", isDisabled, canEditCampaign = true, type, values = [], onFieldChange })=>{
    const [isEditing, setIsEditing] = (0, $eF4cA.useState)(false);
    const fieldKey = Array.isArray(value) ? value[0] : value;
    const [_fieldValue, setFieldValue] = (0, $eF4cA.useState)(null);
    const fieldValue = _fieldValue ?? selectedCampaign?.[fieldKey] ?? "";
    const TextFieldComponent = selectedCampaign?.[value]?.includes("\n") ? (0, $j8RRT.TextArea) : (0, $j8RRT.TextField);
    const handleFieldChange = ()=>{
        onFieldChange?.(fieldKey, fieldValue);
        setIsEditing(false);
    };
    if (type === "dropdown") {
        const dropdownItems = values.map((option)=>({
                id: option,
                label: option
            }));
        return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: fieldWrapperStyle,
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBox), {
                label: label,
                "aria-label": label || fieldKey,
                items: dropdownItems,
                selectedKey: selectedCampaign?.[fieldKey] ?? null,
                onSelectionChange: (key)=>{
                    if (key != null && onFieldChange) onFieldChange(fieldKey, key);
                },
                isDisabled: isDisabled,
                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBoxItem), {
                        id: item.id,
                        textValue: item.label,
                        children: item.label
                    })
            })
        });
    }
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: fieldWrapperStyle({
            size: size
        }),
        children: [
            !!label && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: labelStyle({
                    size: size
                }),
                children: label
            }),
            !isEditing && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' sf182';
                    rules += ' eb182';
                    if (props.size === "XXXL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XXL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "XL") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "L") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "M") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "S") {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' -_6BNtrc-KaY1Ce182';
                        rules += ' vx182';
                    } else if (props.size === "XXL") {
                        rules += ' -_6BNtrc-g182';
                        rules += ' vx182';
                    } else if (props.size === "XL") {
                        rules += ' -_6BNtrc-f182';
                        rules += ' vx182';
                    } else if (props.size === "L") {
                        rules += ' -_6BNtrc-e182';
                        rules += ' vx182';
                    } else if (props.size === "M") {
                        rules += ' -_6BNtrc-d182';
                        rules += ' vx182';
                    } else if (props.size === "S") {
                        rules += ' -_6BNtrc-c182';
                        rules += ' vx182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "XXL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "XL") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "L") {
                        rules += ' xb182';
                        rules += ' _xa182';
                    } else if (props.size === "M") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "S") {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    }
                    if (props.size === "XXXL") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "XXL") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "XL") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "L") {
                        rules += ' _Fb182';
                        rules += ' _FnuYUwec182';
                    } else if (props.size === "M") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "S") {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    }
                    if (props.size === "XXXL") rules += ' pt182';
                    else if (props.size === "XXL") rules += ' pt182';
                    else if (props.size === "XL") rules += ' pt182';
                    else if (props.size === "L") rules += ' pt182';
                    else if (props.size === "M") rules += ' pn182';
                    else if (props.size === "S") rules += ' pn182';
                    return rules;
                }({
                    size: size
                }),
                children: [
                    (Array.isArray(value) ? value : [
                        value
                    ]).map((val, idx)=>{
                        if ((selectedCampaign?.[val] ?? "")?.startsWith("http")) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                            variant: "primary",
                            href: selectedCampaign?.[val] ?? "",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: eval(`selectedCampaign["${val}"] ?? ""`)
                        }, `${val}-${idx}`);
                        return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                            children: [
                                val === "Persona-1-name" && !!selectedPersona?.avatarUrl && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                                    src: selectedPersona?.avatarUrl,
                                    alt: "Persona avatar",
                                    size: 80,
                                    isOverBackground: true,
                                    styles: " Gx182"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: " _7a182",
                                    children: (selectedCampaign?.[val] ?? "") + " "
                                })
                            ]
                        }, `${val}-${idx}`);
                    }),
                    !isDisabled && canEditCampaign && /*#__PURE__*/ (0, $dx4lB.jsx)(EditButton, {
                        value: value,
                        onPress: ()=>setIsEditing(true)
                    })
                ]
            }),
            isEditing && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 Za182 Ue182 qe182 _Pc182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)(TextFieldComponent, {
                        value: fieldValue,
                        onChange: setFieldValue,
                        autoFocus: true,
                        size: size,
                        styles: " _ub182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                        size: "S",
                        isQuiet: true,
                        styles: " ZK182 _Pa182 _As182 Ix182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                onPress: ()=>handleFieldChange(),
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                onPress: ()=>setIsEditing(false),
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
CampaignField.propTypes = {
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    selectedPersona: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    ]).isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL"
    ]),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    canEditCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    values: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
    onFieldChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
const PartnershipValuePreview = ({ selectedCampaign = {}, selectedPersona = {}, campaignStructure = [], templateData, canEditCampaign = true, onFieldChange })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " Za182 Lb4QY4182 IM182 HM182 __Wc182",
        children: campaignStructure.map((group, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                        size: "S"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " _oa182 Za182 Sh182 Rh182 Jx182 GI182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 Ue182 qe182 ea182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        level: 2,
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 pp182",
                                        children: group.title
                                    }),
                                    !!group.description && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pp182",
                                        children: group.description
                                    })
                                ]
                            }),
                            (0, $lb17q.getGroupGrids)(group).filter((grid)=>grid.type !== (0, $lb17q.GRID_TYPE).VARIATIONS).map((grid, gridIdx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignGridHeader), {
                                            title: grid.title,
                                            description: grid.description,
                                            previewLinks: (0, $lb17q.getPreviewLinks)(grid.previewLinks, templateData?.previewUrl),
                                            previewPassword: templateData?.previewPassword
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignFieldRows), {
                                            rows: grid.rows,
                                            renderField: (cell)=>{
                                                const { label, value, size = "L", disabled = false, type, values = [] } = cell;
                                                // A link is shown by the visuals preview only.
                                                return !(0, $lb17q.isTextCell)(cell) && (0, $lb17q.getCellLink)(cell) ? null : /*#__PURE__*/ (0, $dx4lB.jsx)(CampaignField, {
                                                    selectedCampaign: selectedCampaign,
                                                    selectedPersona: selectedPersona,
                                                    label: label,
                                                    value: value,
                                                    size: size,
                                                    isDisabled: disabled,
                                                    canEditCampaign: canEditCampaign,
                                                    type: type,
                                                    values: values,
                                                    onFieldChange: onFieldChange
                                                });
                                            }
                                        })
                                    ]
                                }, gridIdx))
                        ]
                    })
                ]
            }, idx))
    });
};
PartnershipValuePreview.propTypes = {
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    selectedPersona: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    campaignStructure: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    canEditCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onFieldChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};

});
parcelRegister("aVEhH", function(module, exports) {

$parcel$export(module.exports, "listbox", () => $a075b77c1bbd5dfe$export$9901d82449b93cea);
$parcel$export(module.exports, "listboxItem", () => $a075b77c1bbd5dfe$export$68265fb354482bae);
$parcel$export(module.exports, "listboxHeader", () => $a075b77c1bbd5dfe$export$c040ba7a724e8da1);
$parcel$export(module.exports, "LOADER_ROW_HEIGHTS", () => $a075b77c1bbd5dfe$export$83379f5245567d78);
$parcel$export(module.exports, "ComboBox", () => $a075b77c1bbd5dfe$export$72b9695b8216309a);
$parcel$export(module.exports, "ComboBoxItem", () => $a075b77c1bbd5dfe$export$b674b8ff01584ab1);
$parcel$export(module.exports, "Divider", () => $a075b77c1bbd5dfe$export$2e0a83ec2e27ecbb);


var $f16Ml = parcelRequire("f16Ml");

var $8OJ2z = parcelRequire("8OJ2z");

var $8wD3p = parcelRequire("8wD3p");

var $lTVIu = parcelRequire("lTVIu");

var $hxsf4 = parcelRequire("hxsf4");

var $3PqDc = parcelRequire("3PqDc");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $iI3sv = parcelRequire("iI3sv");

var $2ffAV = parcelRequire("2ffAV");

var $i93Vd = parcelRequire("i93Vd");

var $fZShI = parcelRequire("fZShI");

var $e0Enh = parcelRequire("e0Enh");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $cbwDF = parcelRequire("cbwDF");

var $cg9Gh = parcelRequire("cg9Gh");

var $k5Pnh = parcelRequire("k5Pnh");

var $3g2oV = parcelRequire("3g2oV");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $3g2oV = parcelRequire("3g2oV");

var $ecbit = parcelRequire("ecbit");

var $n0XBd = parcelRequire("n0XBd");

var $bkjeZ = parcelRequire("bkjeZ");

var $gI8Gw = parcelRequire("gI8Gw");

var $25dFS = parcelRequire("25dFS");

var $eF2II = parcelRequire("eF2II");
function $a075b77c1bbd5dfe$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a075b77c1bbd5dfe$export$d414ccceff7063c3 = (0, $eF4cA.createContext)(null);
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$inputButton = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-oa182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' sd182';
    rules += ' _Le182';
    rules += ' _Wa182';
    rules += ' _je182';
    rules += ' eb182';
    rules += ' _Ca182';
    if (props.size === "XL") rules += ' ZC182';
    else if (props.size === "L") rules += ' Zo182';
    else if (props.size === "M") rules += ' Zm182';
    else if (props.size === "S") rules += ' Zu182';
    if (props.size === "XL") rules += ' Fx182';
    else if (props.size === "L") rules += ' Fp182';
    else if (props.size === "M") rules += ' Fn182';
    else if (props.size === "S") rules += ' Ft182';
    rules += ' Iw182';
    rules += ' fa182';
    rules += ' _va182';
    rules += ' Yd182';
    rules += ' Yle182';
    rules += ' Xb182';
    rules += ' Xlb182';
    rules += ' _2b182';
    rules += ' _2lb182';
    if (props.isDisabled) rules += ' gH182';
    else if (props.isOpen) rules += ' gF182';
    else {
        if (props.isPressed) rules += ' gF182';
        else if (props.isFocusVisible) rules += ' gF182';
        else if (props.isHovered) rules += ' gF182';
        else rules += ' gH182';
    }
    if (props.isDisabled) rules += ' gld182';
    else if (props.isOpen) rules += ' gle182';
    else if (props.isHovered) rules += ' gle182';
    else rules += ' glc182';
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' pla182';
    return rules;
};
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$iconStyles = " _va182 _Sd182 -_8sjo0b-t5ZbAob182";
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$progressCircleStyles = function anonymous(props) {
    let rules = " ";
    rules += ' ZObNfn182';
    rules += ' FObNfn182';
    if (props.isInput) {
        rules += ' It182';
        rules += ' Isu182';
    }
    return rules;
};
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$emptyStateText = function anonymous(props) {
    let rules = " ";
    rules += ' FRuFGYc182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "M") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "M") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "M") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' Sv182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "M") rules += ' -F_-Fx182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    return rules;
};
let $a075b77c1bbd5dfe$export$9901d82449b93cea = function anonymous(props) {
    let rules = " ";
    rules += ' Za182';
    rules += ' _oa182';
    rules += ' K40ub4c182';
    rules += ' Pa182';
    rules += ' _Nc182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' _Le182';
    return rules;
};
let $a075b77c1bbd5dfe$export$68265fb354482bae = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let gridColumnStart = false;
    let gridColumnEnd = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "z") gridColumnStart = true;
        if (p[1] === "y") gridColumnEnd = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' se182';
    rules += ' ea182';
    rules += ' _oa182';
    rules += ' Sd182';
    rules += ' Rd182';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl182';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj182';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf182';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne182';
    } else if (!minWidth) rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' qh182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' MAyFGYc182';
    rules += ' Td182';
    rules += ' QAzEcG182';
    rules += ' -aRvJDd-Tu7Fubd182';
    if (props.isFocused) rules += ' gF182';
    else rules += ' g9182';
    if (!position) rules += ' _Pc182';
    if (!gridColumnStart) rules += ' z2mU182';
    if (!gridColumnEnd) rules += ' yzZKy182';
    rules += ' CHV1uCd182';
    if (props.size === "XL") rules += ' DTw5ujc182';
    else if (props.size === "L") rules += ' DdpPw4182';
    else if (props.size === "M") rules += ' Dxy3qDe182';
    else if (props.size === "S") rules += ' DfLJE0182';
    rules += ' EpvfBwb182';
    rules += ' EDNKd2dZQmDFe182';
    rules += ' UDNKd2dai5a0182';
    rules += ' FF182';
    rules += ' _Xa182';
    if (props.isLink) rules += ' ry182';
    else rules += ' ri182';
    rules += ' Yg182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.size === "XL") rules += ' -M_-Mk182';
    else if (props.size === "L") rules += ' -M_-Mh182';
    else if (props.size === "S") rules += ' -M_-Mg182';
    else if (props.size === "XS") rules += ' -M_-Mf182';
    else rules += ' -M_-Mi182';
    return rules;
};
let $a075b77c1bbd5dfe$export$c040ba7a724e8da1 = function anonymous(props) {
    let rules = " ";
    rules += ' pt182';
    rules += ' _oa182';
    rules += ' MAyFGYc182';
    rules += ' Tu7Fubd182';
    rules += ' Qu7Fubd182';
    if (props.size === "XL") rules += ' I2d3n182';
    else if (props.size === "L") rules += ' IaxPIqb182';
    else if (props.size === "M") rules += ' Ip2UVod182';
    else if (props.size === "S") rules += ' IH8XZ7c182';
    if (props.size === "XL") rules += ' H2d3n182';
    else if (props.size === "L") rules += ' HaxPIqb182';
    else if (props.size === "M") rules += ' Hp2UVod182';
    else if (props.size === "S") rules += ' HH8XZ7c182';
    if (props.size === "XL") rules += ' -M_-Mk182';
    else if (props.size === "L") rules += ' -M_-Mh182';
    else if (props.size === "S") rules += ' -M_-Mg182';
    else if (props.size === "XS") rules += ' -M_-Mf182';
    else rules += ' -M_-Mi182';
    return rules;
};
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$separatorWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' sd182';
    if (props.size === "XL") rules += ' I2d3n182';
    else if (props.size === "L") rules += ' IaxPIqb182';
    else if (props.size === "M") rules += ' Ip2UVod182';
    else if (props.size === "S") rules += ' IH8XZ7c182';
    if (props.size === "XL") rules += ' H2d3n182';
    else if (props.size === "L") rules += ' HaxPIqb182';
    else if (props.size === "M") rules += ' Hp2UVod182';
    else if (props.size === "S") rules += ' HH8XZ7c182';
    rules += ' Fk182';
    rules += ' eb182';
    return rules;
};
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$dividerStyle = " gF182 gl_a182 og182 ng182 kg182 jg182 FLvNfn182 Za182";
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$avatar = " z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182 Ht182 Hsu182";
const $a075b77c1bbd5dfe$export$83379f5245567d78 = {
    S: {
        medium: 24,
        large: 30
    },
    M: {
        medium: 32,
        large: 40
    },
    L: {
        medium: 40,
        large: 50
    },
    XL: {
        medium: 48,
        large: 60
    }
};
let $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$InternalComboboxContext = (0, $eF4cA.createContext)({
    size: 'M'
});
const $a075b77c1bbd5dfe$export$72b9695b8216309a = (0, $eF4cA.forwardRef)(function ComboBox(props1, ref) {
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $a075b77c1bbd5dfe$export$d414ccceff7063c3);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props1 = (0, $j3pTw.useFormProps)(props1);
    let { size: size = 'M', labelPosition: labelPosition = 'top', UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, ...comboBoxProps } = props1;
    return (0, $dx4lB.jsx)((0, $cbwDF.ComboBox), {
        ...comboBoxProps,
        allowsEmptyCollection: true,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, props1.styles),
        children: ({ isDisabled: isDisabled, isOpen: isOpen, isRequired: isRequired, isInvalid: isInvalid })=>(0, $dx4lB.jsx)($a075b77c1bbd5dfe$var$$a2f262fac286a920$var$ComboboxInner, {
                ...props1,
                isDisabled: isDisabled,
                isOpen: isOpen,
                isRequired: isRequired,
                isInvalid: isInvalid,
                ref: ref
            })
    });
});
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
function $a075b77c1bbd5dfe$export$b674b8ff01584ab1(props) {
    let ref = (0, $eF4cA.useRef)(null);
    let isLink = props.href != null;
    let { size: size } = (0, $eF4cA.useContext)($a075b77c1bbd5dfe$var$$a2f262fac286a920$var$InternalComboboxContext);
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, $i93Vd.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + $a075b77c1bbd5dfe$export$68265fb354482bae({
                ...renderProps,
                size: size,
                isLink: isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children: children } = props;
            return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $dm5H1.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, $8OJ2z.centerBaseline)({
                                            slot: 'icon',
                                            styles: (0, $8wD3p.iconCenterWrapper)
                                        }),
                                        styles: (0, $8wD3p.icon)
                                    }
                                }
                            }
                        ],
                        [
                            (0, $f16Ml.AvatarContext),
                            {
                                slots: {
                                    avatar: {
                                        size: '1lh',
                                        styles: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$avatar
                                    }
                                }
                            }
                        ],
                        [
                            (0, $208Op.TextContext),
                            {
                                slots: {
                                    label: {
                                        styles: (0, $8wD3p.label)({
                                            size: size
                                        })
                                    },
                                    description: {
                                        styles: (0, $8wD3p.description)({
                                            ...renderProps,
                                            size: size
                                        })
                                    }
                                }
                            }
                        ]
                    ],
                    children: [
                        !isLink && !props.onAction && (0, $dx4lB.jsx)((0, $lTVIu.default), {
                            size: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$checkmarkIconSize[size],
                            className: (0, $8wD3p.checkmark)({
                                ...renderProps,
                                size: size
                            })
                        }),
                        typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "label",
                            children: children
                        }) : children
                    ]
                })
            });
        }
    });
// oxlint-enable react/react-compiler
}
function $a075b77c1bbd5dfe$export$5510125537491b61(props) {
    let { size: size } = (0, $eF4cA.useContext)($a075b77c1bbd5dfe$var$$a2f262fac286a920$var$InternalComboboxContext);
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxSection), {
                ...props,
                children: props.children
            }),
            (0, $dx4lB.jsx)($a075b77c1bbd5dfe$export$2e0a83ec2e27ecbb, {
                size: size
            })
        ]
    });
}
const $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$ComboboxInner = (0, $eF4cA.forwardRef)(function ComboboxInner(props1, ref) {
    let { direction: direction = 'bottom', align: align = 'start', shouldFlip: shouldFlip = true, menuWidth: menuWidth, label: label, description: descriptionMessage, errorMessage: errorMessage, children: children, defaultItems: defaultItems, items: items, size: size = 'M', labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', necessityIndicator: necessityIndicator, loadingState: loadingState, isDisabled: isDisabled, isOpen: isOpen, isRequired: isRequired, isInvalid: isInvalid, menuTrigger: menuTrigger, onLoadMore: onLoadMore } = props1;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($a075b77c1bbd5dfe$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let inputRef = (0, $eF4cA.useRef)(null);
    let domRef = (0, $eF4cA.useRef)(null);
    let buttonRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>({
            ...(0, $3PqDc.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    // Better way to encode this into a style? need to account for flipping
    let menuOffset;
    if (size === 'S') menuOffset = 6;
    else if (size === 'M') menuOffset = 6;
    else if (size === 'L') menuOffset = 7;
    else menuOffset = 8;
    let state = (0, $eF4cA.useContext)((0, $cbwDF.ComboBoxStateContext));
    let timeout = (0, $eF4cA.useRef)(null);
    let [showLoading, setShowLoading] = (0, $eF4cA.useState)(false);
    let isLoadingOrFiltering = loadingState === 'loading' || loadingState === 'filtering';
    let showFieldSpinner = (0, $eF4cA.useMemo)(()=>showLoading && (isOpen || menuTrigger === 'manual' || loadingState === 'loading'), [
        showLoading,
        isOpen,
        menuTrigger,
        loadingState
    ]);
    let spinnerId = (0, $25dFS.useSlotId)([
        showFieldSpinner
    ]);
    let inputValue = state?.inputValue;
    let lastInputValue = (0, $eF4cA.useRef)(inputValue);
    (0, $eF4cA.useEffect)(()=>{
        if (isLoadingOrFiltering && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (!isLoadingOrFiltering) {
            // If loading is no longer happening, clear any timers and hide the loading circle
            // oxlint-disable-next-line react/react-compiler
            setShowLoading(false);
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        }
        lastInputValue.current = inputValue;
    }, [
        isLoadingOrFiltering,
        showLoading,
        inputValue
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        };
    }, []);
    let renderer;
    let listBoxLoadingCircle = (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxLoadMoreItem), {
        // Only show the spinner in the list when loading more
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: (0, $8wD3p.loadingWrapperStyles),
        children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
            isIndeterminate: true,
            size: "S",
            styles: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$progressCircleStyles({}),
            "aria-label": stringFormatter.format('combobox.loadingMore')
        })
    });
    if (typeof children === 'function') renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: items ?? defaultItems,
                dependencies: props1.dependencies,
                children: children
            }),
            listBoxLoadingCircle
        ]
    });
    else // Same case for other components that have this logic (TableView/CardView/Picker)
    renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            children,
            listBoxLoadingCircle
        ]
    });
    let scale = (0, $e0Enh.useScale)();
    return (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: (0, $dx4lB.jsxs)($a075b77c1bbd5dfe$var$$a2f262fac286a920$var$InternalComboboxContext.Provider, {
            value: {
                size: size
            },
            children: [
                (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    size: size,
                    labelPosition: labelPosition,
                    labelAlign: labelAlign,
                    necessityIndicator: necessityIndicator,
                    contextualHelp: props1.contextualHelp,
                    children: label
                }),
                (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                    prefix: props1.prefix,
                    role: "presentation",
                    isDisabled: isDisabled,
                    isInvalid: isInvalid,
                    size: size,
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' zXcEWr182';
                        rules += ' yXcEWr182';
                        rules += ' BXcEWr182';
                        rules += ' AXcEWr182';
                        if (props.size === "XL") rules += ' Nl182';
                        else if (props.size === "L") rules += ' Nj182';
                        else if (props.size === "S") rules += ' Nf182';
                        else if (props.size === "XS") rules += ' Ne182';
                        else rules += ' Nk182';
                        if (props.isQuiet) rules += ' _qd182';
                        else rules += ' _qtb182';
                        if (props.size === "XL") rules += ' -Anxdcc-Zt182';
                        else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
                        else if (props.size === "S") rules += ' -Anxdcc-Zr182';
                        else rules += ' -Anxdcc-Z3fn9H182';
                        rules += ' __v6TNLWb182';
                        rules += ' SMBFGYc182';
                        rules += ' RfBFGYc182';
                        rules += ' -S_-Sv182';
                        rules += ' -R_-R6sYnSd182';
                        return rules;
                    }({
                        size: size
                    }),
                    children: [
                        (0, $dx4lB.jsx)((0, $ecbit.InputContext).Consumer, {
                            children: (ctx)=>(0, $dx4lB.jsx)((0, $ecbit.InputContext).Provider, {
                                    value: {
                                        ...ctx,
                                        ref: (0, $bkjeZ.mergeRefs)(ctx?.ref, inputRef)
                                    },
                                    children: (0, $dx4lB.jsx)((0, $8w4Nl.Input), {
                                        "aria-describedby": spinnerId
                                    })
                                })
                        }),
                        isInvalid && (0, $dx4lB.jsx)((0, $8w4Nl.FieldErrorIcon), {
                            isDisabled: isDisabled
                        }),
                        showFieldSpinner && (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                            id: spinnerId,
                            isIndeterminate: true,
                            size: "S",
                            styles: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$progressCircleStyles({
                                isInput: true
                            }),
                            "aria-label": stringFormatter.format('combobox.loading')
                        }),
                        (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
                            ref: buttonRef,
                            // Prevent press scale from sticking while ComboBox is open.
                            // @ts-ignore
                            isPressed: false,
                            style: (renderProps)=>(0, $i93Vd.pressScale)(buttonRef)(renderProps),
                            className: (renderProps)=>$a075b77c1bbd5dfe$var$$a2f262fac286a920$var$inputButton({
                                    ...renderProps,
                                    size: size,
                                    isOpen: isOpen
                                }),
                            children: (0, $dx4lB.jsx)((0, $hxsf4.default), {
                                size: size,
                                className: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$iconStyles
                            })
                        })
                    ]
                }),
                (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                    size: size,
                    isDisabled: isDisabled,
                    isInvalid: isInvalid,
                    description: descriptionMessage,
                    children: errorMessage
                }),
                (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                    hideArrow: true,
                    offset: menuOffset,
                    placement: `${direction} ${align}`,
                    shouldFlip: shouldFlip,
                    UNSAFE_style: {
                        '--trigger-width': menuWidth ? menuWidth + 'px' : undefined
                    },
                    padding: "none",
                    styles: " NuHSBze182 ZuHSBze182",
                    children: (0, $dx4lB.jsx)("div", {
                        className: " sd182 Za182 Fb182",
                        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                            values: [
                                [
                                    (0, $208Op.HeaderContext),
                                    {
                                        styles: $a075b77c1bbd5dfe$export$c040ba7a724e8da1({
                                            size: size
                                        })
                                    }
                                ],
                                [
                                    (0, $208Op.HeadingContext),
                                    {
                                        // @ts-ignore
                                        role: 'presentation',
                                        styles: (0, $8wD3p.sectionHeading)
                                    }
                                ],
                                [
                                    (0, $208Op.TextContext),
                                    {
                                        slots: {
                                            description: {
                                                styles: (0, $8wD3p.description)({
                                                    size: size,
                                                    isFocused: false,
                                                    isDisabled: false
                                                })
                                            }
                                        }
                                    }
                                ]
                            ],
                            children: (0, $dx4lB.jsx)((0, $eF2II.Virtualizer), {
                                layout: (0, $n0XBd.ListLayout),
                                layoutOptions: {
                                    estimatedRowHeight: 32,
                                    padding: 8,
                                    estimatedHeadingHeight: 50,
                                    loaderHeight: $a075b77c1bbd5dfe$export$83379f5245567d78[size][scale]
                                },
                                children: (0, $dx4lB.jsx)((0, $cg9Gh.ListBox), {
                                    dependencies: props1.dependencies,
                                    renderEmptyState: ()=>(0, $dx4lB.jsx)("span", {
                                            className: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$emptyStateText({
                                                size: size
                                            }),
                                            children: loadingState === 'loading' ? stringFormatter.format('combobox.loading') : stringFormatter.format('combobox.noResults')
                                        }),
                                    items: items,
                                    className: $a075b77c1bbd5dfe$export$9901d82449b93cea({
                                        size: size
                                    }),
                                    children: renderer
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
});
const $a075b77c1bbd5dfe$export$2e0a83ec2e27ecbb = (0, $3g2oV.createLeafComponent)((0, $iI3sv.SeparatorNode), function Divider({ size: size }, ref, node) {
    let listState = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    if ((0, $iI3sv.isSeparatorHidden)(node, listState.collection)) return null;
    return (0, $dx4lB.jsx)("div", {
        className: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$separatorWrapper({
            size: size
        }),
        children: (0, $dx4lB.jsx)("div", {
            ref: ref,
            className: $a075b77c1bbd5dfe$var$$a2f262fac286a920$var$dividerStyle
        })
    });
});

});
parcelRegister("cbwDF", function(module, exports) {

$parcel$export(module.exports, "ComboBoxStateContext", () => $0db4c9fce3a85033$export$c02625b26074192c);
$parcel$export(module.exports, "ComboBox", () => $0db4c9fce3a85033$export$72b9695b8216309a);

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $9PmUB = parcelRequire("9PmUB");

var $i0SpD = parcelRequire("i0SpD");

var $cTXxz = parcelRequire("cTXxz");

var $ecbit = parcelRequire("ecbit");

var $8UElq = parcelRequire("8UElq");

var $cg9Gh = parcelRequire("cg9Gh");

var $8gDpA = parcelRequire("8gDpA");

var $f8UJ0 = parcelRequire("f8UJ0");

var $c1ibQ = parcelRequire("c1ibQ");

var $fRdBv = parcelRequire("fRdBv");

var $3g2oV = parcelRequire("3g2oV");

var $lrS4A = parcelRequire("lrS4A");

var $19ZgV = parcelRequire("19ZgV");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");

var $5oIDw = parcelRequire("5oIDw");

var $9hIi4 = parcelRequire("9hIi4");

var $f9wnx = parcelRequire("f9wnx");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0db4c9fce3a85033$export$d414ccceff7063c3 = (0, $eF4cA.createContext)(null);
const $0db4c9fce3a85033$export$c02625b26074192c = (0, $eF4cA.createContext)(null);
const $0db4c9fce3a85033$export$72b9695b8216309a = (0, $19ZgV.createHideableComponent)(function ComboBox(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $0db4c9fce3a85033$export$d414ccceff7063c3);
    let { children: children, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false } = props;
    let content = (0, $eF4cA.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $cg9Gh.ListBoxContext).Provider, {
            value: {
                items: props.items ?? props.defaultItems
            }
        }, typeof children === 'function' ? children({
            isOpen: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isRequired: isRequired,
            defaultChildren: null,
            isReadOnly: isReadOnly
        }) : children), [
        children,
        isDisabled,
        isInvalid,
        isRequired,
        isReadOnly,
        props.items,
        props.defaultItems
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: content
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($0db4c9fce3a85033$var$$dbdc5e6e7ce01b4b$var$ComboBoxInner, {
            props: props,
            collection: collection,
            comboBoxRef: ref
        }));
});
// Contexts to clear inside the popover.
const $0db4c9fce3a85033$var$$dbdc5e6e7ce01b4b$var$CLEAR_CONTEXTS = [
    (0, $8UElq.LabelContext),
    (0, $k5Pnh.ButtonContext),
    (0, $ecbit.InputContext),
    (0, $9PmUB.FieldInputContext),
    (0, $cTXxz.GroupContext),
    (0, $c1ibQ.TextContext)
];
function $0db4c9fce3a85033$var$$dbdc5e6e7ce01b4b$var$ComboBoxInner({ props: props, collection: collection, comboBoxRef: ref }) {
    let { name: name, formValue: formValue = 'key', allowsCustomValue: allowsCustomValue } = props;
    if (allowsCustomValue) formValue = 'text';
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let { contains: contains } = (0, $5oIDw.useFilter)({
        sensitivity: 'base'
    });
    let state = (0, $lrS4A.useComboBoxState)({
        ...props,
        defaultFilter: props.defaultFilter || contains,
        // If props.items isn't provided, rely on collection filtering (aka listbox.items is provided or defaultItems provided to Combobox)
        items: props.items,
        children: undefined,
        collection: collection,
        validationBehavior: validationBehavior
    });
    let buttonRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null);
    let groupRef = (0, $eF4cA.useRef)(null);
    let listBoxRef = (0, $eF4cA.useRef)(null);
    let popoverRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let [labelElementType, setLabelElementType] = (0, $eF4cA.useState)('label');
    let { buttonProps: buttonProps, inputProps: inputProps, listBoxProps: listBoxProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, valueProps: valueProps, ...validation } = (0, $fRdBv.useComboBox)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        inputRef: inputRef,
        buttonRef: buttonRef,
        listBoxRef: listBoxRef,
        popoverRef: popoverRef,
        name: formValue === 'text' ? name : undefined,
        validationBehavior: validationBehavior,
        labelElementType: labelElementType
    }, state);
    // Make menu width match input + button
    // Left for backward compatibility in case a <Group> is not rendered.
    let [menuWidth, setMenuWidth] = (0, $eF4cA.useState)(null);
    let onResize = (0, $eF4cA.useCallback)(()=>{
        if (inputRef.current && !groupRef.current) {
            let buttonRect = buttonRef.current?.getBoundingClientRect();
            let inputRect = inputRef.current.getBoundingClientRect();
            let minX = buttonRect ? Math.min(buttonRect.left, inputRect.left) : inputRect.left;
            let maxX = buttonRect ? Math.max(buttonRect.right, inputRect.right) : inputRect.right;
            setMenuWidth(maxX - minX + 'px');
        }
    }, [
        buttonRef,
        inputRef,
        setMenuWidth
    ]);
    (0, $f9wnx.useResizeObserver)({
        ref: inputRef,
        onResize: onResize
    });
    // Position popover relative to group if available, otherwise input.
    let triggerRef = (0, $eF4cA.useMemo)(()=>({
            get current () {
                return groupRef.current || inputRef.current;
            }
        }), [
        groupRef,
        inputRef
    ]);
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, $eF4cA.useMemo)(()=>({
            isOpen: state.isOpen,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false,
            isReadOnly: props.isReadOnly || false
        }), [
        state.isOpen,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired,
        props.isReadOnly
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: renderPropsState,
        defaultClassName: 'react-aria-ComboBox'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    let inputs = [];
    if (name && formValue === 'key') {
        let values = Array.isArray(state.value) ? state.value : [
            state.value
        ];
        if (values.length === 0) values = [
            null
        ];
        inputs = values.map((value, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
                key: i,
                type: "hidden",
                name: name,
                form: props.form,
                value: value ?? ''
            }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $0db4c9fce3a85033$export$c02625b26074192c,
                state
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    elementType: labelElementType,
                    ref: labelRef
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    ...buttonProps,
                    ref: buttonRef,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $9PmUB.FieldInputContext),
                {
                    ...inputProps,
                    ref: (0, $eF4cA.useCallback)((el)=>{
                        inputRef.current = el; // TODO: figure out how to fix non-input element types in useComboBox/useTextField
                        if (el) setLabelElementType(el.tagName.toLowerCase() === 'input' ? 'label' : 'span');
                    }, []),
                    value: state.inputValue,
                    onChange: (v)=>state.setInputValue(v)
                }
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                state
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    ref: popoverRef,
                    triggerRef: triggerRef,
                    scrollRef: listBoxRef,
                    placement: 'bottom start',
                    isNonModal: true,
                    trigger: 'ComboBox',
                    style: {
                        '--trigger-width': menuWidth
                    },
                    clearContexts: $0db4c9fce3a85033$var$$dbdc5e6e7ce01b4b$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $cg9Gh.ListBoxContext),
                {
                    ...listBoxProps,
                    ref: listBoxRef
                }
            ],
            [
                (0, $cg9Gh.ListStateContext),
                state
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    ref: groupRef,
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ],
            [
                $0db4c9fce3a85033$export$5c804022b41722df,
                valueProps
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, renderProps.children, inputs));
}
const $0db4c9fce3a85033$export$5c804022b41722df = (0, $eF4cA.createContext)(null);
const $0db4c9fce3a85033$export$3527949051a2d3a = (0, $19ZgV.createHideableComponent)(function ComboBoxValue(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $0db4c9fce3a85033$export$5c804022b41722df);
    let state = (0, $eF4cA.useContext)($0db4c9fce3a85033$export$c02625b26074192c);
    let formatter = (0, $9hIi4.useListFormatter)();
    let selectedText = (0, $eF4cA.useMemo)(()=>formatter.format(state.selectedItems.map((item)=>item?.textValue || '').filter((v)=>v !== '')), [
        formatter,
        state.selectedItems
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultChildren: selectedText || props.placeholder,
        defaultClassName: 'react-aria-ComboBoxValue',
        values: {
            selectedItems: (0, $eF4cA.useMemo)(()=>state.selectedItems.map((item)=>item.value ?? null), [
                state.selectedItems
            ]),
            selectedText: selectedText,
            isPlaceholder: state.selectedItems.length === 0,
            state: state
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ref: ref,
        ...DOMProps,
        ...renderProps,
        "data-placeholder": state.selectedItems.length === 0 || undefined
    });
});

});
parcelRegister("fRdBv", function(module, exports) {

$parcel$export(module.exports, "useComboBox", () => $0f4f48fa7b000efd$export$8c18d1b4f7232bbf);

var $4HiHF = parcelRequire("4HiHF");

var $7eFu7 = parcelRequire("7eFu7");

var $d8j5I = parcelRequire("d8j5I");

var $5sRge = parcelRequire("5sRge");

var $fvyIQ = parcelRequire("fvyIQ");

var $bmNeG = parcelRequire("bmNeG");

var $7ByPJ = parcelRequire("7ByPJ");

var $1Y2j8 = parcelRequire("1Y2j8");

var $11FxZ = parcelRequire("11FxZ");

var $daM4n = parcelRequire("daM4n");

var $lhKAD = parcelRequire("lhKAD");

var $YxOvP = parcelRequire("YxOvP");

var $58OnM = parcelRequire("58OnM");

var $3rgVl = parcelRequire("3rgVl");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $dkaC0 = parcelRequire("dkaC0");

var $gI8Gw = parcelRequire("gI8Gw");

var $3nhvX = parcelRequire("3nhvX");

var $aGgVM = parcelRequire("aGgVM");

var $vvwBC = parcelRequire("vvwBC");

var $lKBFz = parcelRequire("lKBFz");

var $lXemd = parcelRequire("lXemd");

var $eF4cA = parcelRequire("eF4cA");

var $f7tr2 = parcelRequire("f7tr2");

var $4vRK0 = parcelRequire("4vRK0");

var $iEwfj = parcelRequire("iEwfj");
function $0f4f48fa7b000efd$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0f4f48fa7b000efd$export$8c18d1b4f7232bbf(props, state) {
    let { buttonRef: buttonRef, popoverRef: popoverRef, inputRef: inputRef, listBoxRef: listBoxRef, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, shouldFocusWrap: shouldFocusWrap, isReadOnly: isReadOnly, isDisabled: isDisabled } = props;
    let backupBtnRef = (0, $eF4cA.useRef)(null);
    buttonRef = buttonRef ?? backupBtnRef;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($0f4f48fa7b000efd$var$$parcel$interopDefault((0, $1Y2j8.default)), '@react-aria/combobox');
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $3nhvX.useMenuTrigger)({
        type: 'listbox',
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    (0, $bmNeG.listData).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let { collection: collection } = state;
    let { disabledKeys: disabledKeys } = state.selectionManager;
    let delegate = (0, $eF4cA.useMemo)(()=>keyboardDelegate || new (0, $daM4n.ListKeyboardDelegate)({
            collection: collection,
            disabledKeys: disabledKeys,
            ref: listBoxRef,
            layoutDelegate: layoutDelegate
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps: collectionProps } = (0, $vvwBC.useSelectableCollection)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap: shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    let router = (0, $aGgVM.useRouter)();
    // for textfield specific operations
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            Enter: (e)=>{
                // Prevent default form submission if menu is open since we may be selecting a option
                let shouldPreventDefault = state.isOpen;
                // If the focused item is a link, trigger opening it. Items that are links are not selectable.
                if (state.isOpen && listBoxRef.current && state.selectionManager.focusedKey != null) {
                    let collectionItem = state.collection.getItem(state.selectionManager.focusedKey);
                    if (collectionItem?.props.href) {
                        let item = listBoxRef.current.querySelector(`[data-key="${CSS.escape(state.selectionManager.focusedKey.toString())}"]`);
                        if (item instanceof HTMLAnchorElement) router.open(item, e, collectionItem.props.href, collectionItem.props.routerOptions);
                        state.close();
                        return {
                            shouldPreventDefault: shouldPreventDefault
                        };
                    } else if (collectionItem?.props.onAction) {
                        collectionItem.props.onAction();
                        state.close();
                        return {
                            shouldPreventDefault: shouldPreventDefault
                        };
                    }
                }
                state.commit();
                return {
                    shouldPreventDefault: shouldPreventDefault
                };
            },
            Tab: ()=>{
                // If the focused item is a link, trigger opening it. Items that are links are not selectable.
                if (state.isOpen && listBoxRef.current && state.selectionManager.focusedKey != null) {
                    let collectionItem = state.collection.getItem(state.selectionManager.focusedKey);
                    if (collectionItem?.props.href) {
                        state.close();
                        return {
                            shouldPreventDefault: false
                        };
                    } else if (collectionItem?.props.onAction) {
                        collectionItem.props.onAction();
                        state.close();
                        return {
                            shouldPreventDefault: false,
                            shouldContinuePropagation: true
                        };
                    }
                }
                if (state.isOpen) state.commit();
                return {
                    shouldPreventDefault: false,
                    shouldContinuePropagation: true
                };
            },
            Escape: ()=>{
                let shouldContinuePropagation = false;
                if (!state.selectionManager.isEmpty || state.inputValue === '' || props.allowsCustomValue) shouldContinuePropagation = true;
                state.revert();
                return {
                    shouldContinuePropagation: shouldContinuePropagation
                };
            }
        }
    });
    let { keyboardProps: repeatKeyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ArrowDown: ()=>{
                state.open('first', 'manual');
                return {
                    shouldPreventDefault: false
                };
            },
            ArrowUp: ()=>{
                state.open('last', 'manual');
                return {
                    shouldPreventDefault: false
                };
            },
            ArrowLeft: ()=>{
                state.selectionManager.setFocusedKey(null);
                return {
                    shouldPreventDefault: false
                };
            },
            ArrowRight: ()=>{
                state.selectionManager.setFocusedKey(null);
                return {
                    shouldPreventDefault: false
                };
            }
        },
        allowRepeats: true
    });
    let onBlur = (e)=>{
        let blurFromButton = (0, $fvyIQ.nodeContains)(buttonRef.current, e.relatedTarget);
        let blurIntoPopover = (0, $fvyIQ.nodeContains)(popoverRef.current, e.relatedTarget);
        // Ignore blur if focused moved to the button(if exists) or into the popover.
        if (blurFromButton || blurIntoPopover) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let valueId = $0f4f48fa7b000efd$var$$bf505c7417d9b616$var$useValueId([
        state.selectionManager.selectedKeys,
        state.selectionManager.selectionMode
    ]);
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $lKBFz.useTextField)({
        ...props,
        // In multi-select mode, only set required if the selection is empty.
        isRequired: props.selectionMode === 'multiple' ? props.isRequired && state.selectionManager.isEmpty : props.isRequired,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly ? (0, $d8j5I.chain)(state.isOpen && collectionProps.onKeyDown, keyboardProps.onKeyDown, repeatKeyboardProps.onKeyDown, props.onKeyDown) : props.onKeyDown,
        onBlur: onBlur,
        value: state.inputValue,
        defaultValue: state.defaultInputValue,
        onFocus: onFocus,
        autoComplete: 'off',
        validate: undefined,
        [(0, $iEwfj.privateValidationStateProp)]: state,
        'aria-describedby': [
            valueId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    }, inputRef);
    (0, $3rgVl.useFormReset)(inputRef, state.defaultValue, state.setValue);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === 'touch') {
            // Focus the input field in case it isn't focused yet
            inputRef.current?.focus();
            state.toggle(null, 'manual');
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== 'touch') {
            inputRef.current?.focus();
            state.toggle(e.pointerType === 'keyboard' || e.pointerType === 'virtual' ? 'first' : null, 'manual');
        }
    };
    let triggerLabelProps = (0, $dkaC0.useLabels)({
        id: menuTriggerProps.id,
        'aria-label': stringFormatter.format('buttonLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    let listBoxProps = (0, $dkaC0.useLabels)({
        id: menuProps.id,
        'aria-label': stringFormatter.format('listboxLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (0, $eF4cA.useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current?.focus();
            return;
        }
        let rect = (0, $fvyIQ.getEventTarget)(e).getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + 0.5 * rect.width);
        let centerY = Math.ceil(rect.top + 0.5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current?.focus();
            state.toggle(null, 'manual');
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    let sectionKey = focusedItem?.parentKey ?? null;
    let itemKey = state.selectionManager.focusedKey ?? null;
    let lastSection = (0, $eF4cA.useRef)(sectionKey);
    let lastItem = (0, $eF4cA.useRef)(itemKey);
    (0, $eF4cA.useEffect)(()=>{
        if ((0, $11FxZ.isAppleDevice)() && focusedItem != null && itemKey != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = section?.['aria-label'] || (typeof section?.rendered === 'string' ? section.rendered : '') || '';
            let announcement = stringFormatter.format('focusAnnouncement', {
                isGroupChange: (section && sectionKey !== lastSection.current) ?? false,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...(0, $f7tr2.getChildNodes)(section, state.collection)
                ].length : 0,
                optionText: focusedItem['aria-label'] || focusedItem.textValue || '',
                isSelected: isSelected
            });
            (0, $4HiHF.announce)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = (0, $4vRK0.getItemCount)(state.collection);
    let lastSize = (0, $eF4cA.useRef)(optionCount);
    let lastOpen = (0, $eF4cA.useRef)(state.isOpen);
    (0, $eF4cA.useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, $11FxZ.isAppleDevice)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format('countAnnouncement', {
                optionCount: optionCount
            });
            (0, $4HiHF.announce)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    // TODO: do we need to do this for multi-select?
    let lastSelectedKey = (0, $eF4cA.useRef)(state.selectedKey);
    (0, $eF4cA.useEffect)(()=>{
        if ((0, $11FxZ.isAppleDevice)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem['aria-label'] || state.selectedItem.textValue || '';
            let announcement = stringFormatter.format('selectedAnnouncement', {
                optionText: optionText
            });
            (0, $4HiHF.announce)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (0, $eF4cA.useEffect)(()=>{
        if (state.isOpen) return (0, $7eFu7.ariaHideOutside)([
            inputRef.current,
            popoverRef.current
        ].filter((element)=>element != null));
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    (0, $lXemd.useUpdateEffect)(()=>{
        // Re-show focus ring when there is no virtually focused item.
        if (!focusedItem && inputRef.current && (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(inputRef.current)) === inputRef.current) (0, $5sRge.dispatchVirtualFocus)(inputRef.current, null);
    }, [
        focusedItem
    ]);
    (0, $58OnM.useEvent)(listBoxRef, 'react-aria-item-action', state.isOpen ? ()=>{
        state.close();
    } : undefined);
    return {
        labelProps: {
            ...labelProps,
            // Focus the input in case the label is not a native <label> element.
            onClick: 'htmlFor' in labelProps && labelProps.htmlFor || props.isDisabled ? undefined : ()=>{
                inputRef.current?.focus();
                (0, $YxOvP.setInteractionModality)('keyboard');
            }
        },
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            onPress: onPress,
            onPressStart: onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        // oxlint-disable-next-line react/react-compiler
        inputProps: (0, $lhKAD.mergeProps)(inputProps, {
            role: 'combobox',
            'aria-expanded': menuTriggerProps['aria-expanded'],
            'aria-controls': state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            'aria-autocomplete': 'list',
            'aria-activedescendant': focusedItem ? (0, $bmNeG.getItemId)(state, focusedItem.key) : undefined,
            onTouchEnd: onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: 'off',
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: 'false'
        }),
        listBoxProps: (0, $lhKAD.mergeProps)(menuProps, listBoxProps, {
            onAction: undefined,
            autoFocus: state.focusStrategy || true,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            linkBehavior: 'selection',
            ['UNSTABLE_itemBehavior']: 'action'
        }),
        valueProps: {
            id: valueId
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
// This is a modified version of useSlotId that uses useEffect instead of useLayoutEffect.
// Triggering re-renders from useLayoutEffect breaks useComboBoxState's useEffect logic in React 18.
// These re-renders preempt async state updates in the useEffect, which ends up running multiple times
// prior to the state being updated. This results in onSelectionChange being called multiple times.
// TODO: refactor useComboBoxState to avoid this.
function $0f4f48fa7b000efd$var$$bf505c7417d9b616$var$useValueId(depArray = []) {
    let id = (0, $25dFS.useId)();
    let [exists, setExists] = (0, $eF4cA.useState)(true);
    let [lastDeps, setLastDeps] = (0, $eF4cA.useState)(depArray);
    // If the deps changed, set exists to true so we can test whether the element exists.
    if (lastDeps.some((v, i)=>!Object.is(v, depArray[i]))) {
        setExists(true);
        setLastDeps(depArray);
    }
    (0, $eF4cA.useEffect)(()=>{
        if (exists && !document.getElementById(id)) setExists(false);
    }, [
        id,
        exists,
        lastDeps
    ]);
    return exists ? id : undefined;
}

});
parcelRegister("1Y2j8", function(module, exports) {

$parcel$export(module.exports, "default", () => $68796fe3e87b1f8f$export$2e2bcd8739ae039);

var $jfT91 = parcelRequire("jfT91");

var $idhQg = parcelRequire("idhQg");

var $76r6w = parcelRequire("76r6w");

var $2y2hY = parcelRequire("2y2hY");

var $gFdKc = parcelRequire("gFdKc");

var $fmuX0 = parcelRequire("fmuX0");

var $czDEd = parcelRequire("czDEd");

var $9RiLX = parcelRequire("9RiLX");

var $VjjLo = parcelRequire("VjjLo");

var $kXISR = parcelRequire("kXISR");

var $dfUqa = parcelRequire("dfUqa");

var $c9GJH = parcelRequire("c9GJH");

var $cDe3n = parcelRequire("cDe3n");

var $dXu3p = parcelRequire("dXu3p");

var $c5d5Q = parcelRequire("c5d5Q");

var $4vzVA = parcelRequire("4vzVA");

var $3sXqG = parcelRequire("3sXqG");

var $cy0Cw = parcelRequire("cy0Cw");

var $dv6j7 = parcelRequire("dv6j7");

var $5ptJI = parcelRequire("5ptJI");

var $3NGdz = parcelRequire("3NGdz");

var $ePe0L = parcelRequire("ePe0L");

var $yjCRW = parcelRequire("yjCRW");

var $j2iXf = parcelRequire("j2iXf");

var $ai3tT = parcelRequire("ai3tT");

var $9nmTh = parcelRequire("9nmTh");

var $5tVlE = parcelRequire("5tVlE");

var $35zQ6 = parcelRequire("35zQ6");

var $2pD7r = parcelRequire("2pD7r");

var $3cvLa = parcelRequire("3cvLa");

var $lAFFU = parcelRequire("lAFFU");

var $cLTrO = parcelRequire("cLTrO");

var $hEN5s = parcelRequire("hEN5s");

var $eA11x = parcelRequire("eA11x");
var $68796fe3e87b1f8f$export$2e2bcd8739ae039 = {};
$68796fe3e87b1f8f$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $jfT91.default),
    "bg-BG": (0, $idhQg.default),
    "cs-CZ": (0, $76r6w.default),
    "da-DK": (0, $2y2hY.default),
    "de-DE": (0, $gFdKc.default),
    "el-GR": (0, $fmuX0.default),
    "en-US": (0, $czDEd.default),
    "es-ES": (0, $9RiLX.default),
    "et-EE": (0, $VjjLo.default),
    "fi-FI": (0, $kXISR.default),
    "fr-FR": (0, $dfUqa.default),
    "he-IL": (0, $c9GJH.default),
    "hr-HR": (0, $cDe3n.default),
    "hu-HU": (0, $dXu3p.default),
    "it-IT": (0, $c5d5Q.default),
    "ja-JP": (0, $4vzVA.default),
    "ko-KR": (0, $3sXqG.default),
    "lt-LT": (0, $cy0Cw.default),
    "lv-LV": (0, $dv6j7.default),
    "nb-NO": (0, $5ptJI.default),
    "nl-NL": (0, $3NGdz.default),
    "pl-PL": (0, $ePe0L.default),
    "pt-BR": (0, $yjCRW.default),
    "pt-PT": (0, $j2iXf.default),
    "ro-RO": (0, $ai3tT.default),
    "ru-RU": (0, $9nmTh.default),
    "sk-SK": (0, $5tVlE.default),
    "sl-SI": (0, $35zQ6.default),
    "sr-SP": (0, $2pD7r.default),
    "sv-SE": (0, $3cvLa.default),
    "tr-TR": (0, $lAFFU.default),
    "uk-UA": (0, $cLTrO.default),
    "zh-CN": (0, $hEN5s.default),
    "zh-TW": (0, $eA11x.default)
};

});
parcelRegister("jfT91", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef70d1a30ea17379$export$2e2bcd8739ae039);
var $ef70d1a30ea17379$export$2e2bcd8739ae039 = {};
$ef70d1a30ea17379$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
        })} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{627}\u{644}\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644}\u{629} ${args.groupTitle}, \u{645}\u{639} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{60C} \u{645}\u{62D}\u{62F}\u{62F}`
};

});

parcelRegister("idhQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c303aeabfe44579$export$2e2bcd8739ae039);
var $9c303aeabfe44579$export$2e2bcd8739ae039 = {};
$9c303aeabfe44579$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{436}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
        })} \u{43D}\u{430} \u{440}\u{430}\u{437}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{44A}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};

});

parcelRegister("76r6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dafb7703ca82544$export$2e2bcd8739ae039);
var $2dafb7703ca82544$export$2e2bcd8739ae039 = {};
$2dafb7703ca82544$export$2e2bcd8739ae039 = {
    "buttonLabel": `Zobrazit doporu\u{10D}en\xed`,
    "countAnnouncement": (args, formatter)=>`K dispozici ${formatter.plural(args.optionCount, {
            one: ()=>`je ${formatter.number(args.optionCount)} mo\u{17E}nost`,
            other: ()=>`jsou/je ${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina \u{201E}${args.groupTitle}\u{201C} ${formatter.plural(args.groupCount, {
                    one: ()=>`s ${formatter.number(args.groupCount)} mo\u{17E}nost\xed`,
                    other: ()=>`se ${formatter.number(args.groupCount)} mo\u{17E}nostmi`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: ` (vybr\xe1no)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybr\xe1no`
};

});

parcelRegister("2y2hY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7002584e2cb282a3$export$2e2bcd8739ae039);
var $7002584e2cb282a3$export$2e2bcd8739ae039 = {};
$7002584e2cb282a3$export$2e2bcd8739ae039 = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mulighed tilg\xe6ngelig`,
            other: ()=>`${formatter.number(args.optionCount)} muligheder tilg\xe6ngelige`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angivet gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mulighed`,
                    other: ()=>`${formatter.number(args.groupCount)} muligheder`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};

});

parcelRegister("gFdKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e29e6042f57c1f8$export$2e2bcd8739ae039);
var $2e29e6042f57c1f8$export$2e2bcd8739ae039 = {};
$2e29e6042f57c1f8$export$2e2bcd8739ae039 = {
    "buttonLabel": `Empfehlungen anzeigen`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} Option`,
            other: ()=>`${formatter.number(args.optionCount)} Optionen`
        })} verf\xfcgbar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Eingetretene Gruppe ${args.groupTitle}, mit ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} Option`,
                    other: ()=>`${formatter.number(args.groupCount)} Optionen`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, ausgew\xe4hlt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Empfehlungen`,
    "selectedAnnouncement": (args)=>`${args.optionText}, ausgew\xe4hlt`
};

});

parcelRegister("fmuX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2567d8b4cef13d$export$2e2bcd8739ae039);
var $ad2567d8b4cef13d$export$2e2bcd8739ae039 = {};
$ad2567d8b4cef13d$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3B2}\u{3BF}\u{3BB}\u{3AE} \u{3C0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3C9}\u{3BD}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2} `
        })} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3BF}\u{3BC}\u{3AC}\u{3B4}\u{3B1} ${args.groupTitle}, \u{3BC}\u{3B5} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5}`
};

});

parcelRegister("czDEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6774eef002bbf6a$export$2e2bcd8739ae039);
var $d6774eef002bbf6a$export$2e2bcd8739ae039 = {};
$d6774eef002bbf6a$export$2e2bcd8739ae039 = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};

});

parcelRegister("9RiLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea08ce16f0d63d9f$export$2e2bcd8739ae039);
var $ea08ce16f0d63d9f$export$2e2bcd8739ae039 = {};
$ea08ce16f0d63d9f$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostrar sugerencias`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opci\xf3n`,
            other: ()=>`${formatter.number(args.optionCount)} opciones`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Se ha unido al grupo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opci\xf3n`,
                    other: ()=>`${formatter.number(args.groupCount)} opciones`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seleccionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugerencias`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seleccionado`
};

});

parcelRegister("VjjLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d7d7f2b4b77be2$export$2e2bcd8739ae039);
var $e5d7d7f2b4b77be2$export$2e2bcd8739ae039 = {};
$e5d7d7f2b4b77be2$export$2e2bcd8739ae039 = {
    "buttonLabel": `Kuva soovitused`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} valik`,
            other: ()=>`${formatter.number(args.optionCount)} valikud`
        })} saadaval.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Sisestatud r\xfchm ${args.groupTitle}, valikuga ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} valik`,
                    other: ()=>`${formatter.number(args.groupCount)} valikud`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valitud`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Soovitused`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valitud`
};

});

parcelRegister("kXISR", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d7e4ab6cc5ae0f$export$2e2bcd8739ae039);
var $06d7e4ab6cc5ae0f$export$2e2bcd8739ae039 = {};
$06d7e4ab6cc5ae0f$export$2e2bcd8739ae039 = {
    "buttonLabel": `N\xe4yt\xe4 ehdotukset`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} vaihtoehto`,
            other: ()=>`${formatter.number(args.optionCount)} vaihtoehtoa`
        })} saatavilla.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Siirtyi ryhm\xe4\xe4n ${args.groupTitle}, jossa ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} vaihtoehto`,
                    other: ()=>`${formatter.number(args.groupCount)} vaihtoehtoa`
                })}.`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valittu`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ehdotukset`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valittu`
};

});

parcelRegister("dfUqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecb77aa9d43f92f$export$2e2bcd8739ae039);
var $5ecb77aa9d43f92f$export$2e2bcd8739ae039 = {};
$5ecb77aa9d43f92f$export$2e2bcd8739ae039 = {
    "buttonLabel": `Afficher les suggestions`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groupe ${args.groupTitle} rejoint, avec ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, s\xe9lectionn\xe9(s)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggestions`,
    "selectedAnnouncement": (args)=>`${args.optionText}, s\xe9lectionn\xe9`
};

});

parcelRegister("c9GJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $881fbef591506f2f$export$2e2bcd8739ae039);
var $881fbef591506f2f$export$2e2bcd8739ae039 = {};
$881fbef591506f2f$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.optionCount)}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
        })} \u{5D1}\u{5DE}\u{5E6}\u{5D1} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5E0}\u{5DB}\u{5E0}\u{5E1} \u{5DC}\u{5E7}\u{5D1}\u{5D5}\u{5E6}\u{5D4} ${args.groupTitle}, \u{5E2}\u{5DD} ${formatter.plural(args.groupCount, {
                    one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.groupCount)}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`
};

});

parcelRegister("cDe3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $023150a785c07a23$export$2e2bcd8739ae039);
var $023150a785c07a23$export$2e2bcd8739ae039 = {};
$023150a785c07a23$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i prijedloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, odabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Prijedlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, odabrano`
};

});

parcelRegister("dXu3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67446816aef1f23$export$2e2bcd8739ae039);
var $c67446816aef1f23$export$2e2bcd8739ae039 = {};
$c67446816aef1f23$export$2e2bcd8739ae039 = {
    "buttonLabel": `Javaslatok megjelen\xedt\xe9se`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`,
            other: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`
        })} \xe1ll rendelkez\xe9sre.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Bel\xe9pett a(z) ${args.groupTitle} csoportba, amely ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`,
                    other: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`
                })} tartalmaz. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, kijel\xf6lve`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Javaslatok`,
    "selectedAnnouncement": (args)=>`${args.optionText}, kijel\xf6lve`
};

});

parcelRegister("c5d5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $85dbf9e5e27095bb$export$2e2bcd8739ae039);
var $85dbf9e5e27095bb$export$2e2bcd8739ae039 = {};
$85dbf9e5e27095bb$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostra suggerimenti`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opzione disponibile`,
            other: ()=>`${formatter.number(args.optionCount)} opzioni disponibili`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingresso nel gruppo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opzione`,
                    other: ()=>`${formatter.number(args.groupCount)} opzioni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selezionato`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggerimenti`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selezionato`
};

});

parcelRegister("4vzVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $285bea475807ca72$export$2e2bcd8739ae039);
var $285bea475807ca72$export$2e2bcd8739ae039 = {};
$285bea475807ca72$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{5019}\u{88DC}\u{3092}\u{8868}\u{793A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
        })}\u{3092}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5165}\u{529B}\u{3055}\u{308C}\u{305F}\u{30B0}\u{30EB}\u{30FC}\u{30D7} ${args.groupTitle}\u{3001}${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
                })}\u{3092}\u{542B}\u{3080}\u{3002}`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5019}\u{88DC}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`
};

});

parcelRegister("3sXqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec0201f83ea0f47d$export$2e2bcd8739ae039);
var $ec0201f83ea0f47d$export$2e2bcd8739ae039 = {};
$ec0201f83ea0f47d$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{C81C}\u{C548} \u{C0AC}\u{D56D} \u{D45C}\u{C2DC}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`,
            other: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`
        })}\u{C744} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{C785}\u{B825}\u{D55C} \u{ADF8}\u{B8F9} ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`,
                    other: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{C120}\u{D0DD}\u{B428}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{C81C}\u{C548}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{C120}\u{D0DD}\u{B428}`
};

});

parcelRegister("cy0Cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f06a7d6ddfda8f$export$2e2bcd8739ae039);
var $f7f06a7d6ddfda8f$export$2e2bcd8739ae039 = {};
$f7f06a7d6ddfda8f$export$2e2bcd8739ae039 = {
    "buttonLabel": `Rodyti pasi\u{16B}lymus`,
    "countAnnouncement": (args, formatter)=>`Yra ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} parinktis`,
            other: ()=>`${formatter.number(args.optionCount)} parinktys (-i\u{173})`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{12E}vesta grup\u{117} ${args.groupTitle}, su ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} parinktimi`,
                    other: ()=>`${formatter.number(args.groupCount)} parinktimis (-i\u{173})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, pasirinkta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Pasi\u{16B}lymai`,
    "selectedAnnouncement": (args)=>`${args.optionText}, pasirinkta`
};

});

parcelRegister("dv6j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b831b32bd0d46f1$export$2e2bcd8739ae039);
var $9b831b32bd0d46f1$export$2e2bcd8739ae039 = {};
$9b831b32bd0d46f1$export$2e2bcd8739ae039 = {
    "buttonLabel": `R\u{101}d\u{12B}t ieteikumus`,
    "countAnnouncement": (args, formatter)=>`Pieejamo opciju skaits: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcijas`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ievad\u{12B}ta grupa ${args.groupTitle}, ar ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opciju`,
                    other: ()=>`${formatter.number(args.groupCount)} opcij\u{101}m`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, atlas\u{12B}ta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ieteikumi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, atlas\u{12B}ta`
};

});

parcelRegister("5ptJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $04647bdbc20a553b$export$2e2bcd8739ae039);
var $04647bdbc20a553b$export$2e2bcd8739ae039 = {};
$04647bdbc20a553b$export$2e2bcd8739ae039 = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativer`
        })} finnes.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angitt gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativer`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};

});

parcelRegister("3NGdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad3854bb14a7aab2$export$2e2bcd8739ae039);
var $ad3854bb14a7aab2$export$2e2bcd8739ae039 = {};
$ad3854bb14a7aab2$export$2e2bcd8739ae039 = {
    "buttonLabel": `Suggesties weergeven`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} optie`,
            other: ()=>`${formatter.number(args.optionCount)} opties`
        })} beschikbaar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groep ${args.groupTitle} ingevoerd met ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} optie`,
                    other: ()=>`${formatter.number(args.groupCount)} opties`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, geselecteerd`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggesties`,
    "selectedAnnouncement": (args)=>`${args.optionText}, geselecteerd`
};

});

parcelRegister("ePe0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd732394f6aa7b5$export$2e2bcd8739ae039);
var $6fd732394f6aa7b5$export$2e2bcd8739ae039 = {};
$6fd732394f6aa7b5$export$2e2bcd8739ae039 = {
    "buttonLabel": `Wy\u{15B}wietlaj sugestie`,
    "countAnnouncement": (args, formatter)=>`dost\u{119}pna/dost\u{119}pne(-nych) ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcja`,
            other: ()=>`${formatter.number(args.optionCount)} opcje(-i)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Do\u{142}\u{105}czono do grupy ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcj\u{105}`,
                    other: ()=>`${formatter.number(args.groupCount)} opcjami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, wybrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestie`,
    "selectedAnnouncement": (args)=>`${args.optionText}, wybrano`
};

});

parcelRegister("yjCRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $589e0d89ac2bfc71$export$2e2bcd8739ae039);
var $589e0d89ac2bfc71$export$2e2bcd8739ae039 = {};
$589e0d89ac2bfc71$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostrar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo inserido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};

});

parcelRegister("j2iXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $722a2dd0f1f2e79e$export$2e2bcd8739ae039);
var $722a2dd0f1f2e79e$export$2e2bcd8739ae039 = {};
$722a2dd0f1f2e79e$export$2e2bcd8739ae039 = {
    "buttonLabel": `Apresentar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo introduzido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};

});

parcelRegister("ai3tT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fb329f553a8626$export$2e2bcd8739ae039);
var $59fb329f553a8626$export$2e2bcd8739ae039 = {};
$59fb329f553a8626$export$2e2bcd8739ae039 = {
    "buttonLabel": `Afi\u{219}are sugestii`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\u{21B}iune`,
            other: ()=>`${formatter.number(args.optionCount)} op\u{21B}iuni`
        })} disponibile.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grup ${args.groupTitle} introdus, cu ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\u{21B}iune`,
                    other: ()=>`${formatter.number(args.groupCount)} op\u{21B}iuni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selectat`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestii`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selectat`
};

});

parcelRegister("9nmTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c081b3f9352d3e8$export$2e2bcd8739ae039);
var $3c081b3f9352d3e8$export$2e2bcd8739ae039 = {};
$3c081b3f9352d3e8$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{432}`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{43C}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{43C}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};

});

parcelRegister("5tVlE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7b11cd4bd89515$export$2e2bcd8739ae039);
var $3c7b11cd4bd89515$export$2e2bcd8739ae039 = {};
$3c7b11cd4bd89515$export$2e2bcd8739ae039 = {
    "buttonLabel": `Zobrazi\u{165} n\xe1vrhy`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nos\u{165}`,
            other: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })} k dispoz\xedcii.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ou`,
                    other: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, vybrat\xe9`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybrat\xe9`
};

});

parcelRegister("35zQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $13577a2cea625a4d$export$2e2bcd8739ae039);
var $13577a2cea625a4d$export$2e2bcd8739ae039 = {};
$13577a2cea625a4d$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Na voljo je ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Vnesena skupina ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcija`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izbrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlogi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izbrano`
};

});

parcelRegister("2pD7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6c40e7d9af00f59$export$2e2bcd8739ae039);
var $c6c40e7d9af00f59$export$2e2bcd8739ae039 = {};
$c6c40e7d9af00f59$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena grupa ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} optione/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izabrano`
};

});

parcelRegister("3cvLa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fcc05a1952fc961$export$2e2bcd8739ae039);
var $7fcc05a1952fc961$export$2e2bcd8739ae039 = {};
$7fcc05a1952fc961$export$2e2bcd8739ae039 = {
    "buttonLabel": `Visa f\xf6rslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativ`
        })} tillg\xe4ngliga.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingick i gruppen ${args.groupTitle} med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativ`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valda`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `F\xf6rslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valda`
};

});

parcelRegister("lAFFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $91a9fbfd0610affb$export$2e2bcd8739ae039);
var $91a9fbfd0610affb$export$2e2bcd8739ae039 = {};
$91a9fbfd0610affb$export$2e2bcd8739ae039 = {
    "buttonLabel": `\xd6nerileri g\xf6ster`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} se\xe7enek`,
            other: ()=>`${formatter.number(args.optionCount)} se\xe7enekler`
        })} kullan\u{131}labilir.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Girilen grup ${args.groupTitle}, ile ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} se\xe7enek`,
                    other: ()=>`${formatter.number(args.groupCount)} se\xe7enekler`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, se\xe7ildi`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\xd6neriler`,
    "selectedAnnouncement": (args)=>`${args.optionText}, se\xe7ildi`
};

});

parcelRegister("cLTrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $759971820d9cbb9d$export$2e2bcd8739ae039);
var $759971820d9cbb9d$export$2e2bcd8739ae039 = {};
$759971820d9cbb9d$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{43F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{437} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};

});

parcelRegister("hEN5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $8487c6c5c2d424d9$export$2e2bcd8739ae039);
var $8487c6c5c2d424d9$export$2e2bcd8739ae039 = {};
$8487c6c5c2d424d9$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{663E}\u{793A}\u{5EFA}\u{8BAE}`,
    "countAnnouncement": (args, formatter)=>`\u{6709} ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`
        })}\u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8FDB}\u{5165}\u{4E86} ${args.groupTitle} \u{7EC4}\u{FF0C}\u{5176}\u{4E2D}\u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9009}\u{62E9}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8BAE}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9009}\u{62E9}`
};

});

parcelRegister("eA11x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8e246a3e08d038$export$2e2bcd8739ae039);
var $ad8e246a3e08d038$export$2e2bcd8739ae039 = {};
$ad8e246a3e08d038$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{986F}\u{793A}\u{5EFA}\u{8B70}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`
        })} \u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8F38}\u{5165}\u{7684}\u{7FA4}\u{7D44} ${args.groupTitle}, \u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9078}\u{53D6}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8B70}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9078}\u{53D6}`
};

});



parcelRegister("lrS4A", function(module, exports) {

$parcel$export(module.exports, "useComboBoxState", () => $c18705c58ae9645c$export$b453a3bfd4a5fa9e);

var $iEwfj = parcelRequire("iEwfj");

var $f7tr2 = parcelRequire("f7tr2");

var $hIeYt = parcelRequire("hIeYt");

var $fHi9W = parcelRequire("fHi9W");

var $lIr3v = parcelRequire("lIr3v");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c18705c58ae9645c$export$b453a3bfd4a5fa9e(props) {
    let { defaultFilter: defaultFilter, menuTrigger: menuTrigger = 'input', allowsEmptyCollection: allowsEmptyCollection = false, allowsCustomValue: allowsCustomValue, shouldCloseOnBlur: shouldCloseOnBlur = true, selectionMode: selectionMode = 'single' } = props;
    let [showAllItems, setShowAllItems] = (0, $eF4cA.useState)(false);
    let [isFocused, setFocusedState] = (0, $eF4cA.useState)(false);
    let [focusStrategy, setFocusStrategy] = (0, $eF4cA.useState)(null);
    let closedDueToEmpty = (0, $eF4cA.useRef)(false);
    let defaultValue = (0, $eF4cA.useMemo)(()=>{
        return props.defaultValue !== undefined ? props.defaultValue : selectionMode === 'single' ? props.defaultSelectedKey ?? null : [];
    }, [
        props.defaultValue,
        props.defaultSelectedKey,
        selectionMode
    ]);
    let value = (0, $eF4cA.useMemo)(()=>{
        return props.value !== undefined ? props.value : selectionMode === 'single' ? props.selectedKey : undefined;
    }, [
        props.value,
        props.selectedKey,
        selectionMode
    ]);
    let [controlledValue, setControlledValue] = (0, $iUErx.useControlledState)(value, defaultValue, props.onChange);
    // Only display the first selected item if in single selection mode but the value is an array.
    let displayValue = selectionMode === 'single' && Array.isArray(controlledValue) ? controlledValue[0] : controlledValue;
    let setValue = (value)=>{
        if (selectionMode === 'single') {
            let key = Array.isArray(value) ? value[0] ?? null : value;
            setControlledValue(key);
            if (key !== displayValue) props.onSelectionChange?.(key);
        } else {
            let keys = [];
            if (Array.isArray(value)) keys = value;
            else if (value != null) keys = [
                value
            ];
            setControlledValue(keys);
        }
    };
    let { collection: collection, selectionManager: selectionManager, disabledKeys: disabledKeys } = (0, $fHi9W.useListState)({
        ...props,
        items: props.items ?? props.defaultItems,
        selectionMode: selectionMode,
        disallowEmptySelection: selectionMode === 'single',
        allowDuplicateSelectionEvents: true,
        selectedKeys: (0, $eF4cA.useMemo)(()=>$c18705c58ae9645c$var$$120eca7b9c40f820$var$convertValue(displayValue), [
            displayValue
        ]),
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            if (selectionMode === 'single') {
                let key = keys.values().next().value ?? null;
                if (key === displayValue) {
                    props.onSelectionChange?.(key);
                    // If key is the same, reset the inputValue and close the menu
                    // (scenario: user clicks on already selected option)
                    resetInputValue();
                    closeMenu();
                } else setValue(key);
            } else setValue([
                ...keys
            ]);
        }
    });
    let selectedKey = selectionMode === 'single' ? selectionManager.firstSelectedKey : null;
    let selectedItems = (0, $eF4cA.useMemo)(()=>{
        return [
            ...selectionManager.selectedKeys
        ].map((key)=>collection.getItem(key)).filter((item)=>item != null);
    }, [
        selectionManager.selectedKeys,
        collection
    ]);
    let [inputValue, setInputValue] = (0, $iUErx.useControlledState)(props.inputValue, $c18705c58ae9645c$var$$120eca7b9c40f820$var$getDefaultInputValue(props.defaultInputValue, selectedKey, collection) || '', props.onInputChange);
    let [initialValue] = (0, $eF4cA.useState)(displayValue);
    let [initialInputValue] = (0, $eF4cA.useState)(inputValue);
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (0, $eF4cA.useMemo)(()=>props.items != null || !defaultFilter ? collection : $c18705c58ae9645c$var$$120eca7b9c40f820$var$filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    let [lastCollection, setLastCollection] = (0, $eF4cA.useState)(filteredCollection);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (0, $eF4cA.useRef)('focus');
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
        selectionManager.setFocused(open);
        if (!open) selectionManager.setFocusedKey(null);
    };
    let triggerState = (0, $lIr3v.useOverlayTriggerState)({
        ...props,
        onOpenChange: onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            setFocusStrategy(focusStrategy);
            triggerState.open();
        }
    };
    let toggle = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        toggleMenu(focusStrategy);
    };
    let updateLastCollection = (0, $eF4cA.useCallback)(()=>{
        setLastCollection(showAllItems ? originalCollection : filteredCollection);
    }, [
        showAllItems,
        originalCollection,
        filteredCollection
    ]);
    // If menu is going to close, save the current collection so we can freeze the displayed collection when the
    // user clicks outside the popover to close the menu. Prevents the menu contents from updating as the menu closes.
    let toggleMenu = (0, $eF4cA.useCallback)((focusStrategy = null)=>{
        if (triggerState.isOpen) updateLastCollection();
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
    }, [
        triggerState,
        updateLastCollection
    ]);
    let closeMenu = (0, $eF4cA.useCallback)(()=>{
        if (triggerState.isOpen) {
            updateLastCollection();
            triggerState.close();
        }
    }, [
        triggerState,
        updateLastCollection
    ]);
    let [lastValue, setLastValue] = (0, $eF4cA.useState)(inputValue);
    let resetInputValue = ()=>{
        let itemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
        setLastValue(itemText);
        setInputValue(itemText);
    };
    let lastValueRef = (0, $eF4cA.useRef)(displayValue);
    let lastSelectedKeyText = (0, $eF4cA.useRef)(selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '');
    (0, $eF4cA.useEffect)(()=>{
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue && menuTrigger !== 'manual') open(null, 'input');
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) {
            closedDueToEmpty.current = true;
            closeMenu();
        }
        // Re-open the menu when items become non-empty after being auto-closed due to
        // an empty collection (e.g. async load completed with results after a previous empty response).
        // This works for both controlled items on ComboBox and Collection patterns
        // (where items are provided on the ListBox rather than the ComboBox).
        if (isFocused && closedDueToEmpty.current && filteredCollection.size > 0 && !triggerState.isOpen && menuTrigger !== 'manual') {
            closedDueToEmpty.current = false;
            open(null, 'input');
        }
        // Close when an item is selected.
        if (displayValue != null && displayValue !== lastValueRef.current && selectionMode === 'single') closeMenu();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set value to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (selectionMode === 'single' && inputValue === '' && (props.inputValue === undefined || value === undefined)) setValue(null);
        }
        // If the value changed, update the input value.
        // Do nothing if both inputValue and value are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (displayValue !== lastValueRef.current && (props.inputValue === undefined || value === undefined)) resetInputValue();
        else if (lastValue !== inputValue) setLastValue(inputValue);
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastValueRef.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                setLastValue(selectedItemText);
                setInputValue(selectedItemText);
            }
        }
        lastValueRef.current = displayValue;
        lastSelectedKeyText.current = selectedItemText;
    });
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: (0, $eF4cA.useMemo)(()=>Array.isArray(displayValue) && displayValue.length === 0 ? null : {
                inputValue: inputValue,
                value: displayValue,
                selectedKey: selectedKey
            }, [
            inputValue,
            selectedKey,
            displayValue
        ])
    });
    // Revert input value and close menu
    let revert = ()=>{
        closedDueToEmpty.current = false;
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        if (selectionMode === 'multiple') {
            // In multi-select mode, the input's custom text is independent from the selected items.
            // Closing or committing the field should not clear the existing selection.
            setLastValue(inputValue);
            closeMenu();
            return;
        }
        let value = null;
        lastValueRef.current = value;
        setValue(value);
        closeMenu();
    };
    let commitSelection = (shouldForceSelectionChange = false)=>{
        // If multiple things are controlled, call onSelectionChange only when selecting the focused item,
        // or when inputValue needs to be synced back to the selected item on commit/blur.
        if (value !== undefined && props.inputValue !== undefined) {
            let itemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
            if (shouldForceSelectionChange || selectionMode === 'multiple' || inputValue !== itemText) {
                props.onSelectionChange?.(selectedKey);
                props.onChange?.(displayValue);
            }
            // Stop menu from reopening from useEffect
            setLastValue(itemText);
            closeMenu();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            closeMenu();
        }
    };
    const commitValue = ()=>{
        closedDueToEmpty.current = false;
        if (allowsCustomValue) {
            const itemText = selectedKey != null ? collection.getItem(selectedKey)?.textValue ?? '' : '';
            inputValue === itemText ? commitSelection() : commitCustomValue();
        } else commitSelection();
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectionManager.isSelected(selectionManager.focusedKey) && selectionMode === 'single') commitSelection(true);
            else selectionManager.select(selectionManager.focusedKey);
        } else commitValue();
    };
    let valueOnFocus = (0, $eF4cA.useRef)([
        inputValue,
        displayValue
    ]);
    let setFocused = (isFocused)=>{
        if (isFocused) {
            valueOnFocus.current = [
                inputValue,
                displayValue
            ];
            if (menuTrigger === 'focus' && !props.isReadOnly) open(null, 'focus');
        } else {
            if (shouldCloseOnBlur) commitValue();
            // Commit validation if the input value or selected items changed.
            if (inputValue !== valueOnFocus.current[0] || displayValue !== valueOnFocus.current[1]) validation.commitValidation();
        }
        setFocusedState(isFocused);
    };
    let displayedCollection = (0, $eF4cA.useMemo)(()=>{
        if (triggerState.isOpen) {
            if (showAllItems) return originalCollection;
            else return filteredCollection;
        } else return lastCollection;
    }, [
        triggerState.isOpen,
        originalCollection,
        filteredCollection,
        showAllItems,
        lastCollection
    ]);
    let defaultSelectedKey = props.defaultSelectedKey ?? (selectionMode === 'single' ? initialValue : null);
    return {
        ...validation,
        ...triggerState,
        focusStrategy: focusStrategy,
        toggle: toggle,
        open: open,
        close: commitValue,
        selectionManager: selectionManager,
        value: displayValue,
        defaultValue: defaultValue ?? initialValue,
        setValue: setValue,
        selectedKey: selectedKey,
        selectedItems: selectedItems,
        defaultSelectedKey: defaultSelectedKey,
        setSelectedKey: setValue,
        disabledKeys: disabledKeys,
        isFocused: isFocused,
        setFocused: setFocused,
        selectedItem: selectedItems[0] ?? null,
        collection: displayedCollection,
        inputValue: inputValue,
        defaultInputValue: $c18705c58ae9645c$var$$120eca7b9c40f820$var$getDefaultInputValue(props.defaultInputValue, defaultSelectedKey, collection) ?? initialInputValue,
        setInputValue: setInputValue,
        commit: commit,
        revert: revert
    };
}
function $c18705c58ae9645c$var$$120eca7b9c40f820$var$filterCollection(collection, inputValue, filter) {
    return new (0, $hIeYt.ListCollection)($c18705c58ae9645c$var$$120eca7b9c40f820$var$filterNodes(collection, collection, inputValue, filter));
}
function $c18705c58ae9645c$var$$120eca7b9c40f820$var$filterNodes(collection, nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === 'section' && node.hasChildNodes) {
            let filtered = $c18705c58ae9645c$var$$120eca7b9c40f820$var$filterNodes(collection, (0, $f7tr2.getChildNodes)(node, collection), inputValue, filter);
            if ([
                ...filtered
            ].some((node)=>node.type === 'item')) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type === 'item' && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
        else if (node.type !== 'item') filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}
function $c18705c58ae9645c$var$$120eca7b9c40f820$var$getDefaultInputValue(defaultInputValue, selectedKey, collection) {
    if (defaultInputValue == null) {
        if (selectedKey != null) return collection.getItem(selectedKey)?.textValue ?? '';
    }
    return defaultInputValue;
}
function $c18705c58ae9645c$var$$120eca7b9c40f820$var$convertValue(value) {
    if (value === undefined) return undefined;
    if (value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}

});

parcelRegister("5oIDw", function(module, exports) {

$parcel$export(module.exports, "useFilter", () => $8a625e3eaf5c49f3$export$3274cf84b703fff);

var $gm31e = parcelRequire("gm31e");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8a625e3eaf5c49f3$export$3274cf84b703fff(options) {
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $eF4cA.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $eF4cA.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $eF4cA.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}

});



parcelRegister("j8RRT", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $b599f7ae4e636981$export$2c73285ae9390cec);
$parcel$export(module.exports, "TextArea", () => $b599f7ae4e636981$export$f5c9f3c2c4054eec);


var $3PqDc = parcelRequire("3PqDc");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $208Op = parcelRequire("208Op");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $4WsZ6 = parcelRequire("4WsZ6");

var $h83Hu = parcelRequire("h83Hu");

var $fDYaM = parcelRequire("fDYaM");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $ecbit = parcelRequire("ecbit");

var $11FxZ = parcelRequire("11FxZ");

var $bkjeZ = parcelRequire("bkjeZ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b599f7ae4e636981$export$2129e27b3ef0d483 = (0, $eF4cA.createContext)(null);
const $b599f7ae4e636981$export$2c73285ae9390cec = (0, $eF4cA.forwardRef)(function TextField(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $b599f7ae4e636981$export$2129e27b3ef0d483);
    return (0, $dx4lB.jsx)($b599f7ae4e636981$export$d22444a338b6e3c2, {
        ...props,
        ref: ref,
        children: (0, $dx4lB.jsx)((0, $8w4Nl.Input), {})
    });
});
const $b599f7ae4e636981$export$2dc6166a7e65358c = (0, $eF4cA.createContext)(null);
const $b599f7ae4e636981$export$f5c9f3c2c4054eec = (0, $eF4cA.forwardRef)(function TextArea(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $b599f7ae4e636981$export$2dc6166a7e65358c);
    return (0, $dx4lB.jsx)($b599f7ae4e636981$export$d22444a338b6e3c2, {
        ...props,
        ref: ref,
        fieldGroupCss: function anonymous(props) {
            let rules = " ";
            rules += ' ea182';
            rules += ' Fd182';
            if (props.isChrome) rules += ' TSO4kUbZsXLs182';
            return rules;
        }({
            isChrome: (0, $11FxZ.isChrome)()
        }),
        children: (0, $dx4lB.jsx)($b599f7ae4e636981$var$$d946f50010ba937f$var$TextAreaInput, {})
    });
});
const $b599f7ae4e636981$export$d22444a338b6e3c2 = (0, $eF4cA.forwardRef)(function TextFieldBase(props1, ref) {
    let inputRef = (0, $eF4cA.useRef)(null);
    let domRef = (0, $eF4cA.useRef)(null);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    // oxlint-disable-next-line react/react-compiler
    props1 = (0, $j3pTw.useFormProps)(props1);
    let { label: label, description: description, errorMessage: errorMessage, necessityIndicator: necessityIndicator, labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', fieldGroupCss: fieldGroupCss, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', ...textFieldProps } = props1;
    (0, $eF4cA.useImperativeHandle)(ref, ()=>({
            ...(0, $3PqDc.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return (0, $dx4lB.jsx)((0, $h83Hu.TextField), {
        ...textFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            size: props1.size,
            labelPosition: labelPosition,
            isInForm: !!formContext
        }, props1.styles),
        children: (0, $fDYaM.composeRenderProps)(props1.children, (children, { isDisabled: isDisabled, isInvalid: isInvalid })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props1.isRequired,
                        size: props1.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props1.contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldGroup), {
                        prefix: props1.prefix,
                        size: props1.size,
                        styles: fieldGroupCss,
                        children: (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                            values: [
                                [
                                    (0, $208Op.TextContext),
                                    {}
                                ]
                            ],
                            children: [
                                (0, $dx4lB.jsx)((0, $ecbit.InputContext).Consumer, {
                                    children: (ctx)=>(0, $dx4lB.jsx)((0, $ecbit.InputContext).Provider, {
                                            value: {
                                                ...ctx,
                                                ref: (0, $bkjeZ.mergeRefs)(ctx?.ref, inputRef)
                                            },
                                            children: children
                                        })
                                }),
                                isInvalid && (0, $dx4lB.jsx)((0, $8w4Nl.FieldErrorIcon), {
                                    isDisabled: isDisabled
                                })
                            ]
                        })
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: props1.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            }))
    });
});
function $b599f7ae4e636981$var$$d946f50010ba937f$var$TextAreaInput() {
    // Force re-render when value changes so we update the height.
    let { placeholder: placeholder } = (0, $fDYaM.useSlottedContext)((0, $4WsZ6.TextAreaContext)) ?? {};
    let onHeightChange = (input)=>{
        // TODO: only do this if an explicit height is not given?
        if (input) {
            let prevAlignment = input.style.alignSelf;
            let prevOverflow = input.style.overflow;
            // Firefox scroll position is lost when overflow: 'hidden' is applied so we skip applying it.
            // The measure/applied height is also incorrect/reset if we turn on and off
            // overflow: hidden in Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1787062
            let isFirefox = 'MozAppearance' in input.style;
            if (!isFirefox) input.style.overflow = 'hidden';
            input.style.alignSelf = 'start';
            input.style.height = 'auto';
            // offsetHeight - clientHeight accounts for the border/padding.
            input.style.height = `${input.scrollHeight + (input.offsetHeight - input.clientHeight)}px`;
            input.style.overflow = prevOverflow;
            input.style.alignSelf = prevAlignment;
        }
    };
    let { ref: ref } = (0, $fDYaM.useSlottedContext)((0, $ecbit.InputContext)) ?? {};
    return (0, $dx4lB.jsx)((0, $4WsZ6.TextArea), {
        ref: (0, $bkjeZ.mergeRefs)(onHeightChange, ref),
        // Workaround for baseline alignment bug in Safari.
        // https://bugs.webkit.org/show_bug.cgi?id=142968
        placeholder: placeholder ?? ' ',
        className: function anonymous(props) {
            let rules = " ";
            rules += ' Sd182';
            rules += ' Rd182';
            rules += ' Tu7Fubd182';
            rules += ' Qu7Fubd182';
            rules += ' MAyFGYc182';
            rules += ' _oa182';
            rules += ' g9182';
            rules += ' p40ub4c182';
            rules += ' pYFIK2bn182';
            rules += ' pYFIK2blc182';
            rules += ' u40ub4c182';
            rules += ' v40ub4c182';
            rules += ' x40ub4c182';
            rules += ' _xa182';
            rules += ' _F40ub4c182';
            if (props.isChrome) rules += ' _de182';
            rules += ' _ub182';
            rules += ' Na182';
            rules += ' _Le182';
            rules += ' _je182';
            rules += ' _Qc182';
            rules += ' _Nc182';
            if (props.size === "XL") rules += ' -M_-Mk182';
            else if (props.size === "L") rules += ' -M_-Mh182';
            else if (props.size === "S") rules += ' -M_-Mg182';
            else if (props.size === "XS") rules += ' -M_-Mf182';
            else rules += ' -M_-Mi182';
            return rules;
        }({
            isChrome: (0, $11FxZ.isChrome)()
        })
    });
}

});
parcelRegister("4WsZ6", function(module, exports) {

$parcel$export(module.exports, "TextAreaContext", () => $202db8920e287019$export$2dc6166a7e65358c);
$parcel$export(module.exports, "TextArea", () => $202db8920e287019$export$f5c9f3c2c4054eec);

var $fDYaM = parcelRequire("fDYaM");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");
const $202db8920e287019$export$2dc6166a7e65358c = (0, $eF4cA.createContext)({});
let $202db8920e287019$var$$bd263d78e9bf3c56$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const $202db8920e287019$export$f5c9f3c2c4054eec = (0, $eF4cA.forwardRef)(function TextArea(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $202db8920e287019$export$2dc6166a7e65358c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)(props);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-TextArea'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).textarea, {
        ...(0, $lhKAD.mergeProps)($202db8920e287019$var$$bd263d78e9bf3c56$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});

});

parcelRegister("h83Hu", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $4ea221e0e1e05bb2$export$2c73285ae9390cec);

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $9PmUB = parcelRequire("9PmUB");

var $i0SpD = parcelRequire("i0SpD");

var $cTXxz = parcelRequire("cTXxz");

var $ecbit = parcelRequire("ecbit");

var $8UElq = parcelRequire("8UElq");

var $4WsZ6 = parcelRequire("4WsZ6");

var $c1ibQ = parcelRequire("c1ibQ");

var $lKBFz = parcelRequire("lKBFz");

var $19ZgV = parcelRequire("19ZgV");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4ea221e0e1e05bb2$export$2129e27b3ef0d483 = (0, $eF4cA.createContext)(null);
const $4ea221e0e1e05bb2$export$2c73285ae9390cec = (0, $19ZgV.createHideableComponent)(function TextField(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $4ea221e0e1e05bb2$export$2129e27b3ef0d483);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, $eF4cA.useRef)(null);
    [props, inputRef] = (0, $fDYaM.useContextProps)(props, inputRef, (0, $9PmUB.FieldInputContext));
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let [inputElementType, setInputElementType] = (0, $eF4cA.useState)('input');
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $lKBFz.useTextField)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        inputElementType: inputElementType,
        label: label,
        validationBehavior: validationBehavior
    }, inputRef);
    // Intercept setting the input ref so we can determine what kind of element we have.
    // useTextField uses this to determine what props to include.
    let inputOrTextAreaRef = (0, $eF4cA.useCallback)((el)=>{
        inputRef.current = el;
        if (el) setInputElementType(el instanceof HTMLTextAreaElement ? 'textarea' : 'input');
    }, [
        inputRef
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-TextField'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, $4WsZ6.TextAreaContext),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});

});



parcelRegister("iXKEI", function(module, exports) {

$parcel$export(module.exports, "EditVariationDialog", () => EditVariationDialog);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $4UbTp = parcelRequire("4UbTp");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");
var $7Vvqh = parcelRequire("7Vvqh");
var $yuTTo = parcelRequire("yuTTo");
var $33cDE = parcelRequire("33cDE");
var $bTZtY = parcelRequire("bTZtY");
var $j8RRT = parcelRequire("j8RRT");
var $hSW0F = parcelRequire("hSW0F");

var $5KhQr = parcelRequire("5KhQr");

var $klXmP = parcelRequire("klXmP");

var $HZG6L = parcelRequire("HZG6L");

var $cnBj9 = parcelRequire("cnBj9");

var $edFAP = parcelRequire("edFAP");

var $g2Wqz = parcelRequire("g2Wqz");

var $k469E = parcelRequire("k469E");

var $erkCj = parcelRequire("erkCj");

var $fmJ8d = parcelRequire("fmJ8d");

var $iLDMH = parcelRequire("iLDMH");

var $jBZxV = parcelRequire("jBZxV");

var $8ZsKk = parcelRequire("8ZsKk");

var $lfyDg = parcelRequire("lfyDg");

var $7nuM2 = parcelRequire("7nuM2");

var $3aLXY = parcelRequire("3aLXY");

var $gCdzD = parcelRequire("gCdzD");

var $a8sj2 = parcelRequire("a8sj2");

var $lRNYL = parcelRequire("lRNYL");
parcelRequire("8Xrlw");
var $6AUdR = parcelRequire("6AUdR");
var $2VxAI = parcelRequire("2VxAI");
var $44uR2 = parcelRequire("44uR2");
// Wide enough for the "Reference" badge on the references' card.
const REFERENCE_WIDTH = 72;
const CollapsableText = ({ text })=>{
    const [isExpanded, setIsExpanded] = (0, $eF4cA.useState)(false);
    if (!text) return null;
    const isCollapsable = text.length > 200;
    const displayText = isExpanded || !isCollapsable ? text : `${text.slice(0, 200)}...`;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
        children: [
            displayText,
            isCollapsable && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                size: "XS",
                isQuiet: true,
                onPress: ()=>setIsExpanded(!isExpanded),
                styles: " Is182",
                UNSAFE_style: {
                    display: "inline-grid"
                },
                children: isExpanded ? "Show less" : "Show more"
            })
        ]
    });
};
CollapsableText.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const EditVariationDialog = ({ videoId, variationKey, referenceKey, isReferenceAsset, dependencies, onUpload })=>{
    const { video, template, variation: imageVariation, asset, fallbackAsset, referenceAssets, progress, isGenerating, isPromptPending, isPromptEdited, isStatic, staticPrompt, isBusy, isSkipped, setSkipped, regenerate, regeneratePrompt, resetPrompt, regenerateFromCampaign } = (0, $44uR2.useImageVariation)({
        projectId: videoId,
        variationKey: variationKey,
        referenceKey: referenceKey
    });
    const downloadS3Image = (0, $a8sj2.useDownloadS3Image)();
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const progressByKey = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.imageVariationProgress);
    // Do not remove, used in eval()
    const selectedCampaign = (0, $eF4cA.useMemo)(()=>{
        return video.data?.campaigns?.find((c)=>c.id === video.data?.selectedCampaignIds?.[0]) ?? null;
    }, [
        video.data?.campaigns,
        video.data?.selectedCampaignIds
    ]);
    // A static prompt is the type's default, shown to admins only: for anyone
    // else the field is blank unless it holds the user's own.
    const defaultPrompt = isStatic && isAdmin ? staticPrompt ?? "" : "";
    const shownPrompt = (variation)=>isStatic && !variation?.promptEdited ? defaultPrompt : variation?.visualPrompt ?? "";
    const [prompt, setPrompt] = (0, $eF4cA.useState)(()=>shownPrompt(imageVariation));
    // Text that is not just the default being shown.
    const hasOwnPrompt = !!prompt.trim() && prompt !== defaultPrompt;
    const wasPromptEdited = (0, $eF4cA.useRef)(!!imageVariation?.promptEdited);
    const lastDefaultPrompt = (0, $eF4cA.useRef)(defaultPrompt);
    (0, $eF4cA.useEffect)(()=>{
        const next = shownPrompt(imageVariation);
        // The user's own prompt was replaced by the default (e.g. by updating
        // from the campaign). Or the default was shown before the variation was
        // known to be static.
        if (isStatic && !imageVariation?.promptEdited && (wasPromptEdited.current || prompt === imageVariation?.visualPrompt || prompt === lastDefaultPrompt.current)) setPrompt(defaultPrompt);
        wasPromptEdited.current = !!imageVariation?.promptEdited;
        lastDefaultPrompt.current = defaultPrompt;
        // For a static one, a refreshed default is handled above — it must not
        // replace what is being typed.
        if ((!isStatic || imageVariation?.promptEdited) && next && next !== prompt) setPrompt(next);
    }, [
        imageVariation?.visualPrompt,
        imageVariation?.promptEdited,
        isStatic,
        defaultPrompt
    ]);
    const handleDownload = (0, $eF4cA.useCallback)(()=>{
        if (!asset?.filePath) return;
        downloadS3Image.mutate({
            filePath: asset.filePath,
            fileName: asset.name
        });
    }, [
        asset?.filePath,
        asset?.name,
        downloadS3Image.mutate
    ]);
    const handleGenerate = (0, $eF4cA.useCallback)(()=>{
        (0, $eF4cA.startTransition)(()=>{
            regenerate({
                prompt: prompt.trim()
            });
        });
    }, [
        regenerate,
        prompt
    ]);
    // A non-generative action (Photoshop) rather than a model: it has no prompt
    // to write or edit, so the prompt controls are hidden and the action's own
    // description is used as the confirm label. Which types those are is
    // configured with the type itself, in `VARIATION_TYPES`.
    const isPhotoshopAction = !!(0, $2VxAI.getVariationType)(imageVariation?.type)?.action;
    const hasEditedPrompt = isPromptEdited || (isStatic ? hasOwnPrompt : prompt.trim() !== (imageVariation?.visualPrompt ?? ""));
    const { isOutdated, action: outdatedAction, message: outdatedMessage } = (0, $3aLXY.getVariationOutdatedState)({
        variation: {
            ...imageVariation,
            key: variationKey,
            referenceKey: referenceKey ?? imageVariation?.referenceKey
        },
        dependencies: dependencies,
        assets: video.data?.assets,
        selectedCampaign: selectedCampaign,
        video: video,
        templateData: template,
        isPromptEdited: hasEditedPrompt,
        isBusy: isGenerating || isBusy || isPromptPending || !!asset?.isLoading
    });
    // What is wrong with the preview: a failed generation, else a campaign or
    // references that have changed since it was generated.
    const notice = imageVariation?.errorMessage || (isOutdated ? outdatedMessage : null);
    // Outdated by a campaign its prompt has to be rewritten for: the primary
    // action writes a new prompt and image, and the prompt as it is can still be
    // kept. A prompt edited here but not generated from yet is the user's own
    // too.
    const isUpdatingPrompt = isOutdated && !isPhotoshopAction && outdatedAction === (0, $7nuM2.OUTDATED_ACTION).PROMPT_AND_IMAGE;
    const { update, confirmDialog } = (0, $gCdzD.useOutdatedUpdate)({
        action: outdatedAction,
        isPromptEdited: hasEditedPrompt,
        regenerateFromCampaign: regenerateFromCampaign,
        onKeepPrompt: handleGenerate
    });
    // As on `ImageVariationCard`: with no real progress to report, a preview
    // that has nothing to show yet is still "generating" — unless it failed.
    const hasPreview = !!(isSkipped ? fallbackAsset : asset)?.filePath;
    const isShowingProgress = !!progress || !imageVariation?.errorCode && !imageVariation?.errorMessage && !hasPreview;
    const isGenerateDisabled = isShowingProgress || isGenerating || isReferenceAsset || isSkipped || isBusy || isPromptPending || !!asset?.isLoading;
    // A static variation generates from its default prompt when the field is blank.
    const isPromptMissing = !isStatic && !prompt.trim();
    // Clears what was typed, and the prompt the pipeline kept for it.
    const handleRegeneratePrompt = ()=>{
        if (isStatic) {
            setPrompt(defaultPrompt);
            resetPrompt();
        } else regeneratePrompt();
    };
    // Rendered beside the prompt input normally, and in the footer next to the
    // confirm button for prompt-less actions (which have no input to sit next to).
    // A reference being (re)generated has no image for a while, but it is still
    // there — shown loading; one that is only a template asset nobody selected is
    // not.
    const generatedReferences = referenceAssets.filter((reference)=>!!reference?.filePath || (0, $6AUdR.getMissingReferenceKind)(reference?.name, template) === (0, $6AUdR.REFERENCE_KIND).GENERATED);
    const hasReference = generatedReferences.length > 0;
    const referenceThumbnail = !hasReference ? null : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
        label: "Reference",
        // `contain: inline-size` would otherwise size it to a field's width.
        styles: " ZywElld182 _va182",
        value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8ZsKk.ReferenceImages), {
            assets: generatedReferences,
            templateData: template,
            showTooltips: true,
            progressByKey: progressByKey,
            // Describing the image is the images steps' concern, not this dialog's.
            skipImageLabeling: true,
            colorScheme: colorScheme,
            aspectRatio: "1 / 1",
            showBadge: false,
            // Too small for a label.
            showProgressLabel: false
        })
    });
    const model = (()=>{
        const model = fallbackAsset?.model ?? asset?.model;
        let ret = null;
        switch(model){
            case "nano-banana":
            case "nano-banana-2":
            case "nano-banana-3":
                ret = {
                    model: model,
                    icon: (0, $g2Wqz.default),
                    label: `Gemini_${model}`
                };
                break;
            case "image4_ultra":
            case "image5":
            case "video":
                ret = {
                    model: model,
                    icon: (0, $k469E.default),
                    label: `Firefly_${model}`
                };
                break;
            case "photoshop":
                ret = {
                    model: model,
                    icon: (0, $erkCj.default),
                    label: "Photoshop"
                };
                break;
            default:
                break;
        }
        if (ret?.label) ret.label = ret.label.split(/[_-]|(?<=\w)(?=\d)/).map((s)=>s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
        return ret;
    })();
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        padding: "none",
        styles: " Z6AC4Sb182 Lc182",
        children: ({ close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " se182 Za182 Fb182 Kpc182 Ka182 _Nc182 Pc182 Cpk94dIb182 CgnkhCb182 Dp2GN5J182 D0P7fi182 EplDVqge182 EliRrde182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " z3lWFN182 y3lWFN182 B3lWFN182 A3lWFN182 _Pc182 Za182 Fb182",
                        children: [
                            asset?.type === "video" && !isSkipped ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
                                filePath: asset?.filePath,
                                src: asset?.src,
                                isLoading: !asset?.filePath,
                                className: " sb182 _Hb182 Za182 fcJcitc182",
                                controls: true,
                                autoPlay: true,
                                loop: true
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                alt: asset?.name ?? "",
                                filePath: isSkipped ? fallbackAsset?.filePath : asset?.filePath,
                                isLoading: isSkipped ? !fallbackAsset?.filePath : !asset?.filePath,
                                styles: " Za182 Fb182 _Ha182",
                                UNSAFE_style: !asset?.filePath ? {
                                    aspectRatio: "1 / 1"
                                } : undefined
                            }),
                            isShowingProgress && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " sd182 _ta182 eb182 _Ca182 Ul182 ql182 Za182 Fb182 _Pa182 Wr182 _Ar182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lfyDg.VariationProgress), {
                                    progress: progress,
                                    size: 32
                                })
                            }),
                            !!notice && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                variant: "notice",
                                size: "M",
                                styles: " _Pa182 Wt182 _At182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cnBj9.default), {})
                            }),
                            !!model && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                placement: "start",
                                delay: 0,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5KhQr.Pressable), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            role: "button",
                                            className: " _Pa182 Wt182 _zt182",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)(model.icon, {
                                                styles: " Zo182 Fp182"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: model.label
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Uj182 qj182 Za182 Fb182 Pa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                                slot: "title",
                                styles: " zPCJngb182 yPCJngb182 BPCJngb182 APCJngb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182 Iy182 Hy182",
                                children: [
                                    imageVariation?.label ?? `${!!asset?.prompt ? "Edit variation: " : ""}${variationKey}`,
                                    !!imageVariation?.key && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                styles: " -_6BNtrc-c182 vx182 _F2mU182 pp182 _7c182",
                                                children: [
                                                    "(",
                                                    imageVariation?.key,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                styles: " sd182 _ta182 Ul182 ql182 _ub182 _vb182 _sa182",
                                children: [
                                    [
                                        [
                                            null,
                                            imageVariation?.description
                                        ],
                                        [
                                            "Tagline",
                                            imageVariation?.tagline
                                        ],
                                        [
                                            "Audience",
                                            imageVariation?.audience
                                        ],
                                        ...(imageVariation?.context ?? []).map((c)=>[
                                                c.label,
                                                eval(c.value)
                                            ]) ?? [],
                                        [
                                            "AI Summary",
                                            asset?.labeling?.description
                                        ]
                                    ].map(([label, value], idx)=>!!value ? /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            children: [
                                                !!label && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182 Gs182",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)(CollapsableText, {
                                                        text: value
                                                    })
                                                })
                                            ]
                                        }, label ?? idx) : null),
                                    [
                                        [
                                            "Main subject",
                                            !!asset?.labeling?.mainSubject && [
                                                asset?.labeling?.mainSubject
                                            ]
                                        ],
                                        [
                                            "Attributes",
                                            asset?.labeling?.attributes
                                        ],
                                        [
                                            "Key elements",
                                            asset?.labeling?.keyElements
                                        ]
                                    ].map(([label, value])=>!!value && Array.isArray(value) ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.TagGroup), {
                                            label: label,
                                            size: "XS",
                                            selectionMode: "none",
                                            maxRows: 1,
                                            children: value.map((el, i)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.Tag), {
                                                    children: el
                                                }, i))
                                        }, label) : null),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                                            orientation: "horizontal",
                                            styles: function anonymous(props) {
                                                let rules = " ";
                                                rules += ' __Ad182';
                                                if (props.isAlone) rules += ' JM182';
                                                else rules += ' JG182';
                                                return rules;
                                            }({
                                                isAlone: isReferenceAsset
                                            }),
                                            children: [
                                                !isReferenceAsset && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                                                    acceptedFileTypes: "image/*,video/*",
                                                    onSelect: (files)=>onUpload?.(files, asset?.name),
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                        isDisabled: !asset?.filePath || downloadS3Image.isPending,
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $HZG6L.default), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                children: [
                                                                    "Upload own",
                                                                    " ",
                                                                    asset?.type === "video" ? "video" : "image"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                    isDisabled: !asset?.filePath || downloadS3Image.isPending,
                                                    onPress: handleDownload,
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                            children: [
                                                                "Download ",
                                                                asset?.type === "video" ? "video" : "image"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    !isReferenceAsset && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 _ta182 JM182 Th182",
                                        children: [
                                            !isPhotoshopAction && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                onPress: handleRegeneratePrompt,
                                                isDisabled: isGenerateDisabled || isStatic && !hasOwnPrompt && !isPromptEdited,
                                                isPending: !isStatic && isPromptPending,
                                                size: "XS",
                                                styles: " IM182 Gh182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Regenerate prompt"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 Ug182 qg182 ec182",
                                                children: [
                                                    !isPhotoshopAction && !!referenceThumbnail && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                        className: " sd182 _ta182 Ue182 qe182",
                                                        children: referenceThumbnail
                                                    }),
                                                    !isPhotoshopAction && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                                        label: `Prompt`,
                                                        placeholder: isStatic ? "Enter your prompt or leave blank for default" : "",
                                                        value: prompt,
                                                        onChange: setPrompt,
                                                        isDisabled: isGenerateDisabled,
                                                        styles: " _ub182",
                                                        UNSAFE_className: "__PromptInput __PromptInput--narrow"
                                                    })
                                                ]
                                            }),
                                            notice ? /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: function anonymous(props) {
                                                    let rules = " ";
                                                    rules += ' sh182';
                                                    rules += ' Jv182';
                                                    if (props.isIntented) rules += ' IL182';
                                                    else rules += ' Iy182';
                                                    return rules;
                                                }({
                                                    isIntented: hasReference
                                                }),
                                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 p9d4kQe182",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cnBj9.default), {
                                                            styles: " Hs182 -_8sjo0b-t9d4kQe182 Zu182 Ft182",
                                                            UNSAFE_className: " _5f182"
                                                        }),
                                                        notice
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                children: [
                                    isPhotoshopAction && !!referenceThumbnail && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " sd182 _ta182 Ue182 qe182",
                                        children: referenceThumbnail
                                    }),
                                    !isReferenceAsset && !!imageVariation?.fallbackKey && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                                        "aria-label": "Use fallback asset",
                                        isSelected: isSkipped,
                                        isEmphasized: true,
                                        onChange: setSkipped,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            slot: "description",
                                            children: "Use fallback asset"
                                        })
                                    }),
                                    !isReferenceAsset && isUpdatingPrompt && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                        variant: "secondary",
                                        onPress: ()=>handleGenerate(),
                                        isDisabled: isGenerateDisabled || isPromptMissing,
                                        styles: " IM182 _dd182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Keep prompt"
                                        })
                                    }),
                                    !isReferenceAsset && isUpdatingPrompt && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                        variant: "primary",
                                        onPress: update,
                                        isEmphasized: true,
                                        isDisabled: isGenerateDisabled,
                                        styles: " _dd182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Update & generate"
                                            })
                                        ]
                                    }),
                                    !isReferenceAsset && !isUpdatingPrompt && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                        variant: "primary",
                                        onPress: ()=>handleGenerate(),
                                        isEmphasized: true,
                                        isDisabled: isGenerateDisabled || isPromptMissing,
                                        styles: " IM182 _dd182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: isPhotoshopAction ? prompt.trim() || "Apply" : hasEditedPrompt ? "Generate" : "Regenerate"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            confirmDialog
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};
EditVariationDialog.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    variationKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    referenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    ]).isRequired,
    isReferenceAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).Boolean,
    dependencies: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        keys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Map)
    }),
    onUpload: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};

});
parcelRegister("geNzB", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $1d40906c3e0ddc44$export$37acb3580601e69a);


var $8OJ2z = parcelRequire("8OJ2z");

var $dm5H1 = parcelRequire("dm5H1");

var $91SAk = parcelRequire("91SAk");

var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $fVfXf = parcelRequire("fVfXf");

var $c1ibQ = parcelRequire("c1ibQ");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1d40906c3e0ddc44$export$1d4627584e49159a = (0, $eF4cA.createContext)(null);
const $1d40906c3e0ddc44$var$$6357025487dea614$var$badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.fillStyle === "outline") rules += ' pm182';
    else if (props.fillStyle === "subtle") rules += ' pm182';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg182';
        else if (props.variant === "chartreuse") rules += ' pg182';
        else if (props.variant === "yellow") rules += ' pg182';
        else if (props.variant === "orange") rules += ' pg182';
        else if (props.variant === "notice") rules += ' pg182';
        else rules += ' px182';
    }
    rules += ' sd182';
    rules += ' ea182';
    rules += ' egLWx3bb182';
    rules += ' _oa182';
    rules += ' Sv182';
    rules += ' SgLWx3bd182';
    rules += ' Rv182';
    rules += ' RgLWx3bd182';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl182';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj182';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf182';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne182';
    } else if (!minWidth) rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' MAyFGYc182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' -aRvJDd-Tu7Fubd182';
    rules += ' _Ca182';
    if (props.fillStyle === "outline") rules += ' g_g182';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f182';
        else if (props.variant === "cinnamon") rules += ' gP182';
        else if (props.variant === "brown") rules += ' gO182';
        else if (props.variant === "turquoise") rules += ' gy182';
        else if (props.variant === "pink") rules += ' gT182';
        else if (props.variant === "magenta") rules += ' gS182';
        else if (props.variant === "fuchsia") rules += ' gR182';
        else if (props.variant === "purple") rules += ' gM182';
        else if (props.variant === "indigo") rules += ' gK182';
        else if (props.variant === "blue") rules += ' gG182';
        else if (props.variant === "cyan") rules += ' gC182';
        else if (props.variant === "seafoam") rules += ' gz182';
        else if (props.variant === "green") rules += ' gA182';
        else if (props.variant === "celery") rules += ' gv182';
        else if (props.variant === "chartreuse") rules += ' gJ182';
        else if (props.variant === "yellow") rules += ' gW182';
        else if (props.variant === "orange") rules += ' gV182';
        else if (props.variant === "red") rules += ' gU182';
        else if (props.variant === "gray") rules += ' gI182';
        else if (props.variant === "negative") rules += ' gU182';
        else if (props.variant === "notice") rules += ' gV182';
        else if (props.variant === "positive") rules += ' gA182';
        else if (props.variant === "neutral") rules += ' gI182';
        else if (props.variant === "informative") rules += ' gG182';
        else if (props.variant === "accent") rules += ' gG182';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm182';
        else if (props.variant === "cinnamon") rules += ' gq182';
        else if (props.variant === "brown") rules += ' gn182';
        else if (props.variant === "turquoise") rules += ' g5182';
        else if (props.variant === "pink") rules += ' gx182';
        else if (props.variant === "magenta") rules += ' gD182';
        else if (props.variant === "fuchsia") rules += ' gr182';
        else if (props.variant === "purple") rules += ' go182';
        else if (props.variant === "indigo") rules += ' gl182';
        else if (props.variant === "blue") rules += ' g2182';
        else if (props.variant === "cyan") rules += ' gk182';
        else if (props.variant === "seafoam") rules += ' g4182';
        else if (props.variant === "green") rules += ' g1182';
        else if (props.variant === "celery") rules += ' g7182';
        else if (props.variant === "chartreuse") rules += ' gp182';
        else if (props.variant === "yellow") rules += ' gN182';
        else if (props.variant === "orange") rules += ' gQ182';
        else if (props.variant === "red") rules += ' gB182';
        else if (props.variant === "gray") rules += ' g6182';
        else if (props.variant === "negative") rules += ' gB182';
        else if (props.variant === "notice") rules += ' gQ182';
        else if (props.variant === "positive") rules += ' g1182';
        else if (props.variant === "neutral") rules += ' g6182';
        else if (props.variant === "informative") rules += ' g2182';
        else if (props.variant === "accent") rules += ' g2182';
    }
    rules += ' _jf182';
    rules += ' _kJ8iPYd182';
    rules += ' hXMFGYc182';
    rules += ' mc182';
    rules += ' lc182';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS182';
        else if (props.variant === "notice") rules += ' i9VrKkd182';
        else if (props.variant === "positive") rules += ' ip17Jm182';
        else if (props.variant === "neutral") rules += ' i0ruhAb182';
        else if (props.variant === "informative") rules += ' iG1ze4d182';
        else if (props.variant === "accent") rules += ' iG1ze4d182';
        else rules += ' iA182';
    } else rules += ' iA182';
    rules += ' -_8sjo0b-t5ZbAob182';
    if (props.size === "XL") rules += ' -M_-Mk182';
    else if (props.size === "L") rules += ' -M_-Mh182';
    else if (props.size === "S") rules += ' -M_-Mg182';
    else if (props.size === "XS") rules += ' -M_-Mf182';
    else rules += ' -M_-Mi182';
    rules += ' -_k_-_kc182';
    rules += ' -h_-hc182';
    return rules;
};
const $1d40906c3e0ddc44$export$37acb3580601e69a = (0, $eF4cA.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $1d40906c3e0ddc44$export$1d4627584e49159a);
    let { children: children, variant: variant = 'neutral', size: size = 'S', fillStyle: fillStyle = 'bold', overflowMode: overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let isTextOnly = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.toArray(props1.children).every((c)=>!(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).isValidElement(c));
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                (0, $208Op.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG182';
                        rules += ' QAzEcG182';
                        rules += ' _Jb182';
                        rules += ' _Nc182';
                        rules += ' Pc182';
                        rules += ' _Yb182';
                        if (props.overflowMode === "wrap") rules += ' _7b182';
                        else if (props.overflowMode === "truncate") rules += ' _7c182';
                        return rules;
                    }({
                        overflowMode: overflowMode
                    })
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {}
            ],
            [
                (0, $dm5H1.IconContext),
                {
                    render: (0, $8OJ2z.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja182"
                    }),
                    styles: " ZObNfn182 FObNfn182 I67logd182 _va182"
                }
            ]
        ],
        children: (0, $dx4lB.jsx)((0, $91SAk.SkeletonWrapper), {
            children: (0, $dx4lB.jsx)("span", {
                ...(0, $fVfXf.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + $1d40906c3e0ddc44$var$$6357025487dea614$var$badge({
                    variant: variant,
                    size: size,
                    fillStyle: fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: children
                }) : children
            })
        })
    });
});

});

parcelRegister("88lL9", function(module, exports) {

$parcel$export(module.exports, "CustomDialog", () => $ccf25b5cef7f4cd5$export$82e1fa7406db6ec);


var $abeS0 = parcelRequire("abeS0");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $8gDpA = parcelRequire("8gDpA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ccf25b5cef7f4cd5$var$$6e8e8fdd66697ef1$var$dialogStyle = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let height = false;
    let maxWidth = false;
    let maxHeight = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "F") height = true;
        if (p[1] === "L") maxWidth = true;
        if (p[1] === "K") maxHeight = true;
        rules += p[0];
    }
    if (props.padding === "none") rules += ' Td182';
    else if (props.padding === "default") {
        rules += ' Th182';
        rules += ' Tnk182';
    }
    if (props.padding === "none") rules += ' Qd182';
    else if (props.padding === "default") {
        rules += ' Qh182';
        rules += ' Qnk182';
    }
    if (props.padding === "none") rules += ' Sd182';
    else if (props.padding === "default") {
        rules += ' Sh182';
        rules += ' Snk182';
    }
    if (props.padding === "none") rules += ' Rd182';
    else if (props.padding === "default") {
        rules += ' Rh182';
        rules += ' Rnk182';
    }
    rules += ' _oa182';
    rules += ' _Le182';
    rules += ' oi182';
    rules += ' ni182';
    rules += ' ki182';
    rules += ' ji182';
    rules += ' _Na182';
    rules += ' Pa182';
    if (!position) rules += ' _Pc182';
    if (!width) rules += ' Za182';
    if (!height) rules += ' Fb182';
    if (!maxWidth) rules += ' L40ub4c182';
    if (!maxHeight) rules += ' K40ub4c182';
    return rules;
};
const $ccf25b5cef7f4cd5$export$82e1fa7406db6ec = (0, $eF4cA.forwardRef)(function CustomDialog(props, ref) {
    let { size: size, isDismissible: isDismissible, isKeyboardDismissDisabled: isKeyboardDismissDisabled, padding: padding = 'default' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $abeS0.Modal), {
        size: size,
        isDismissable: isDismissible,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        children: (0, $dx4lB.jsx)((0, $8gDpA.Dialog), {
            ...props,
            ref: domRef,
            style: props.UNSAFE_style,
            className: (props.UNSAFE_className || '') + $ccf25b5cef7f4cd5$var$$6e8e8fdd66697ef1$var$dialogStyle({
                padding: padding
            }, props.styles),
            children: (0, $fDYaM.composeRenderProps)(props.children, (children)=>(0, $dx4lB.jsx)((0, $8gDpA.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: children
                }))
        })
    });
});

});

parcelRegister("33cDE", function(module, exports) {

$parcel$export(module.exports, "Switch", () => $6a8b9c2de7c91ecf$export$b5d5cf8927ab7262);


var $8OJ2z = parcelRequire("8OJ2z");

var $j3pTw = parcelRequire("j3pTw");

var $8w4Nl = parcelRequire("8w4Nl");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fBsEf = parcelRequire("fBsEf");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6a8b9c2de7c91ecf$export$8699e3b644d5a28a = (0, $eF4cA.createContext)(null);
const $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$field = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let gridColumnStart = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "z") gridColumnStart = true;
        rules += p[0];
    }
    rules += ' se182';
    if (!position) rules += ' _Pc182';
    if (props.isNoVisibleLabel) rules += ' DtyCQZ182';
    else rules += ' DE5iebb182';
    rules += ' qf182';
    if (!width) rules += ' ZJ182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    else if (props.size === "XS") rules += ' pt182';
    else rules += ' pt182';
    if (props.size === "XL") rules += ' -BhX7R-Fz182';
    else if (props.size === "L") rules += ' -BhX7R-Fv182';
    else if (props.size === "S") rules += ' -BhX7R-Fp182';
    else if (props.size === "XS") rules += ' -BhX7R-Fn182';
    else rules += ' -BhX7R-Fx182';
    rules += ' UVxyPec182';
    if (props.isInForm) {
        if (!gridColumnStart) rules += ' zhJUGr182';
    }
    return rules;
};
const $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$wrapper = function anonymous(props) {
    let rules = " ";
    rules += ' se182';
    rules += ' DLwlgod182';
    rules += ' z2mU182';
    rules += ' yzZKy182';
    rules += ' ea182';
    rules += ' Yc182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' __ca182';
    return rules;
};
const $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$track = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' -ERv7Xb-ZmDIzbc182';
    if (props.size === "XL") rules += ' -LsrJQc-Fn182';
    else if (props.size === "L") rules += ' -LsrJQc-Fm182';
    else if (props.size === "S") rules += ' -LsrJQc-Fl182';
    else rules += ' -LsrJQc-Ft182';
    rules += ' ZAkyXj182';
    rules += ' Fpk5ROc182';
    rules += ' _oa182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    rules += ' _jf182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _yb182';
    if (props.isSelected) rules += ' iA182';
    else if (props.isDisabled) {
        rules += ' io182';
        rules += ' ilc182';
    } else {
        if (props.isPressed) rules += ' in182';
        else if (props.isFocusVisible) rules += ' in182';
        else if (props.isHovered) rules += ' in182';
        else rules += ' iv182';
        rules += ' ila182';
    }
    if (props.isSelected) {
        if (props.isDisabled) {
            rules += ' gw182';
            rules += ' gld182';
        } else {
            if (props.isEmphasized) {
                if (props.isPressed) rules += ' gY182';
                else if (props.isFocusVisible) rules += ' gY182';
                else if (props.isHovered) rules += ' gY182';
                else rules += ' g3182';
            } else {
                if (props.isPressed) rules += ' gu182';
                else if (props.isFocusVisible) rules += ' gu182';
                else if (props.isHovered) rules += ' gu182';
                else rules += ' g0182';
            }
            rules += ' gle182';
        }
    } else rules += ' gX182';
    return rules;
};
const $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$handle = function anonymous(props) {
    let rules = " ";
    rules += ' Fb182';
    rules += ' fa182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    if (props.isSelected) rules += ' gX182';
    else if (props.isDisabled) {
        rules += ' gw182';
        rules += ' gld182';
    } else {
        if (props.isPressed) rules += ' gu182';
        else if (props.isFocusVisible) rules += ' gu182';
        else if (props.isHovered) rules += ' gu182';
        else rules += ' g0182';
    }
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    return rules;
};
// Use an inline style to calculate the transform so we can combine it with the press scale.
const $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$transformStyle = ({ isSelected: isSelected, direction: direction })=>{
    // In the default state, the handle is 8px smaller than the track. When selected it grows to 6px smaller than the track.
    // Normally this could be calculated as a scale transform with (trackHeight - 8px) / trackHeight, however,
    // CSS does not allow division with units. To solve this we use a 3d perspective transform. Perspective is the
    // distance from the Z=0 plane to the viewer. Since we want to scale the handle by a fixed amount and we cannot divide
    // by a value with units, we can set the Z translation to a fixed amount and change the perspective in order to achieve
    // the desired effect. Given the following formula:
    //
    //   scale = perspective / (perspective - translateZ)
    //
    // and desired scale factors (accounting for the 2px border on each side of the track):
    //
    //   defaultScale = (trackHeight - 8px) / (trackHeight - 4px)
    //   selectedScale = (trackHeight - 6px) / (trackHeight - 4px)
    //
    // we can solve for the perspective needed in each case where translateZ is hard coded to -4px:
    //
    //    defaultPerspective = trackHeight - 8px
    //    selectedPerspective = 2 * (trackHeight - 6px)
    const placement = direction === 'ltr' ? 'translateX(calc(var(--trackWidth) - 100% - 4px)) perspective(calc(2 * (var(--trackHeight) - 6px))) translateZ(-4px)' : 'translateX(calc(100% - var(--trackWidth) + 4px)) perspective(calc(2 * (var(--trackHeight) - 6px))) translateZ(-4px)';
    return {
        transform: isSelected ? placement : 'perspective(calc(var(--trackHeight) - 8px)) translateZ(-4px)'
    };
};
const $6a8b9c2de7c91ecf$export$b5d5cf8927ab7262 = (0, $eF4cA.forwardRef)(function Switch(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $6a8b9c2de7c91ecf$export$8699e3b644d5a28a);
    let { children: children, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style } = props;
    let inputRef = (0, $eF4cA.useRef)(null);
    let domRef = (0, $3PqDc.useFocusableRef)(ref, inputRef);
    let handleRef = (0, $eF4cA.useRef)(null);
    let isInForm = !!(0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    let { direction: direction } = (0, $1ntKq.useLocale)();
    props = (0, $j3pTw.useFormProps)(props);
    return (0, $dx4lB.jsx)((0, $fBsEf.SwitchField), {
        ...props,
        ref: domRef,
        inputRef: inputRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$field({
                ...renderProps,
                isInForm: isInForm,
                size: props.size || 'M',
                isNoVisibleLabel: !children
            }, props.styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $fBsEf.SwitchButton), {
                        className: (renderProps)=>$6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$wrapper({
                                ...renderProps,
                                isInForm: isInForm,
                                size: props.size || 'M'
                            }),
                        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                                        children: (0, $dx4lB.jsx)("div", {
                                            className: $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$track({
                                                ...renderProps,
                                                size: props.size || 'M',
                                                isEmphasized: props.isEmphasized
                                            }),
                                            children: (0, $dx4lB.jsx)("div", {
                                                ref: handleRef,
                                                style: (0, $i93Vd.pressScale)(handleRef, $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$transformStyle)({
                                                    ...renderProps,
                                                    direction: direction
                                                }),
                                                className: $6a8b9c2de7c91ecf$var$$8926b17b75ae985d$var$handle(renderProps)
                                            })
                                        })
                                    }),
                                    children
                                ]
                            })
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: props.size || 'M',
                        styles: " z2mU182 Td182",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: props.description,
                        showErrorIcon: true,
                        children: props.errorMessage
                    })
                ]
            })
    });
});

});
parcelRegister("fBsEf", function(module, exports) {

$parcel$export(module.exports, "SwitchButton", () => $231c950d04a06e61$export$72111f742dee7cb8);
$parcel$export(module.exports, "SwitchField", () => $231c950d04a06e61$export$208c2e617baf9fc3);

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $i0SpD = parcelRequire("i0SpD");

var $c1ibQ = parcelRequire("c1ibQ");

var $8q9h4 = parcelRequire("8q9h4");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $eF4cA = parcelRequire("eF4cA");

var $9yazy = parcelRequire("9yazy");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $26CkO = parcelRequire("26CkO");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $231c950d04a06e61$export$8699e3b644d5a28a = (0, $eF4cA.createContext)(null);
const $231c950d04a06e61$export$3e1405298f0cafda = (0, $eF4cA.createContext)(null);
const $231c950d04a06e61$export$5cc1518e1ec171c = (0, $eF4cA.createContext)(null);
const $231c950d04a06e61$export$b5d5cf8927ab7262 = (0, $eF4cA.forwardRef)(function Switch(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $fDYaM.useContextProps)(otherProps, ref, $231c950d04a06e61$export$8699e3b644d5a28a);
    let inputRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let state = (0, $9yazy.useToggleState)(props);
    let aria = (0, $8q9h4.useSwitch)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $231c950d04a06e61$export$5cc1518e1ec171c,
                state
            ],
            [
                $231c950d04a06e61$var$$24585aa46d6ffdff$var$InternalSwitchContext,
                {
                    ...aria,
                    inputRef: inputRef,
                    defaultClassName: 'react-aria-Switch'
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($231c950d04a06e61$export$72111f742dee7cb8, {
        ...props,
        ref: ref
    }));
});
const $231c950d04a06e61$var$$24585aa46d6ffdff$var$InternalSwitchContext = (0, $eF4cA.createContext)(null);
const $231c950d04a06e61$export$208c2e617baf9fc3 = (0, $eF4cA.forwardRef)(function Switch(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $fDYaM.useContextProps)(otherProps, ref, $231c950d04a06e61$export$3e1405298f0cafda);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let state = (0, $9yazy.useToggleState)(props);
    let aria = (0, $8q9h4.useSwitch)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children,
        validationBehavior: validationBehavior
    }, state, inputRef);
    let { descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isInvalid: isInvalid, validationDetails: validationDetails, validationErrors: validationErrors } = aria;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SwitchField',
        values: {
            isSelected: isSelected,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isInvalid: isInvalid,
            isRequired: props.isRequired || false,
            state: state
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $231c950d04a06e61$export$5cc1518e1ec171c,
                state
            ],
            [
                $231c950d04a06e61$var$$24585aa46d6ffdff$var$InternalSwitchContext,
                {
                    ...aria,
                    inputRef: inputRef,
                    defaultClassName: 'react-aria-SwitchButton',
                    isRequired: props.isRequired
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                {
                    isInvalid: isInvalid,
                    validationDetails: validationDetails,
                    validationErrors: validationErrors
                }
            ]
        ]
    }, renderProps.children));
});
const $231c950d04a06e61$export$72111f742dee7cb8 = (0, $eF4cA.forwardRef)(function SwitchButton(props, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isPressed: isPressed, isInvalid: isInvalid, inputRef: inputRef, defaultClassName: defaultClassName, isRequired: isRequired } = (0, $eF4cA.useContext)($231c950d04a06e61$var$$24585aa46d6ffdff$var$InternalSwitchContext);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let isInteractionDisabled = isDisabled || isReadOnly;
    let state = (0, $eF4cA.useContext)($231c950d04a06e61$export$5cc1518e1ec171c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: defaultClassName,
        values: {
            isSelected: isSelected,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isInvalid: isInvalid,
            isRequired: isRequired || false,
            state: state
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).label, {
        ...(0, $lhKAD.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
        ...(0, $lhKAD.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
});

});
parcelRegister("8q9h4", function(module, exports) {

$parcel$export(module.exports, "useSwitch", () => $62f9be599aaf5a59$export$d853f7095ae95f88);

var $gp6My = parcelRequire("gp6My");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $62f9be599aaf5a59$export$d853f7095ae95f88(props, state, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, ...states } = (0, $gp6My.useToggle)(props, state, ref);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            role: 'switch',
            checked: isSelected
        },
        isSelected: isSelected,
        ...states
    };
}

});



parcelRegister("hSW0F", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $11cbb79187eebc1e$export$28c660c63b792dea);
$parcel$export(module.exports, "TooltipTrigger", () => $11cbb79187eebc1e$export$8c610744efcf8a1d);


var $arisx = parcelRequire("arisx");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $eENmv = parcelRequire("eENmv");
var $fBwWk = parcelRequire("fBwWk");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$tooltip = function anonymous(props) {
    let rules = " ";
    if (props.colorScheme === "dark") rules += ' -ICUGx-_pa182';
    else if (props.colorScheme === "light") rules += ' -ICUGx-_pb182';
    else if (props.colorScheme === "light dark") {
        rules += ' -ICUGx-_pb182';
        rules += ' -ICUGx-D1v0V_pa182';
    }
    rules += ' _pK8eoyd182';
    if (props.colorScheme === "dark") rules += ' -NvXmrd-_ZLmU182';
    else if (props.colorScheme === "light") rules += ' -NvXmrd-_ZN8Gi4c182';
    else if (props.colorScheme === "light dark") {
        rules += ' -NvXmrd-_ZN8Gi4c182';
        rules += ' -NvXmrd-D1v0V_ZLmU182';
    }
    if (props.colorScheme === "dark") rules += ' -j9blY-_ZN8Gi4c182';
    else if (props.colorScheme === "light") rules += ' -j9blY-_ZLmU182';
    else if (props.colorScheme === "light dark") {
        rules += ' -j9blY-_ZLmU182';
        rules += ' -j9blY-D1v0V_ZN8Gi4c182';
    }
    rules += ' _Ca182';
    rules += ' eb182';
    rules += ' Le182';
    rules += ' MAyFGYc182';
    rules += ' _oa182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-b182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' pr182';
    rules += ' plb182';
    rules += ' _kJ8iPYd182';
    rules += ' hXMFGYc182';
    rules += ' mlb182';
    rules += ' llb182';
    rules += ' _jlf182';
    rules += ' ilA182';
    rules += ' g0182';
    rules += ' ob182';
    rules += ' nb182';
    rules += ' kb182';
    rules += ' jb182';
    rules += ' Sv182';
    rules += ' Rv182';
    rules += ' Tu7Fubd182';
    rules += ' Qu7Fubd182';
    rules += ' Yd182';
    rules += ' Xc182';
    if (props.isExiting) rules += ' _2c182';
    if (props.placement === "right") {
        if (props.isExiting) {
            rules += ' -_7PloMd-m182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_7PloMd-m182';
            rules += ' __Ya182';
        }
    } else if (props.placement === "left") {
        if (props.isExiting) {
            rules += ' -_7PloMd-G182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_7PloMd-G182';
            rules += ' __Ya182';
        }
    }
    if (props.placement === "bottom") {
        if (props.isExiting) {
            rules += ' -_8PloMd-l182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_8PloMd-l182';
            rules += ' __Ya182';
        }
    } else if (props.placement === "top") {
        if (props.isExiting) {
            rules += ' -_8PloMd-F182';
            rules += ' __Ya182';
        } else if (props.isEntering) {
            rules += ' -_8PloMd-F182';
            rules += ' __Ya182';
        }
    }
    if (props.isExiting) rules += ' _Ia182';
    else if (props.isEntering) rules += ' _Ia182';
    rules += ' -nTSCV-LTAEPe182';
    rules += ' -M_-Mg182';
    rules += ' -_k_-l_kb182';
    rules += ' -h_-lhb182';
    return rules;
};
const $11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$arrowStyles = function anonymous(props) {
    let rules = " ";
    rules += ' sb182';
    rules += ' tr182';
    rules += ' Zi182';
    rules += ' Ff182';
    if (props.placement === "right") rules += ' _Sd182';
    else if (props.placement === "left") rules += ' _Sa182';
    else if (props.placement === "bottom") rules += ' _Sc182';
    else if (props.placement === "top") rules += ' _Sb182';
    if (props.placement === "right") {
        rules += ' -_7PloMd-y182';
        rules += ' __Ya182';
    } else if (props.placement === "left") {
        rules += ' -_7PloMd-e182';
        rules += ' __Ya182';
    }
    return rules;
};
let $11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$InternalTooltipTriggerContext = (0, $eF4cA.createContext)({});
const $11cbb79187eebc1e$export$28c660c63b792dea = (0, $eF4cA.forwardRef)(function Tooltip(props, ref) {
    let { children: children, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { containerPadding: containerPadding, crossOffset: crossOffset, placement: placement = 'top', shouldFlip: shouldFlip } = (0, $eF4cA.useContext)($11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$InternalTooltipTriggerContext);
    let colorScheme = (0, $eF4cA.useContext)((0, $arisx.ColorSchemeContext));
    let { locale: locale, direction: direction } = (0, $1ntKq.useLocale)();
    let [borderRadius, setBorderRadius] = (0, $eF4cA.useState)(0);
    // TODO: should we pass through lang and dir props in RAC?
    let tooltipRef = (0, $eF4cA.useCallback)((el)=>{
        // oxlint-disable-next-line react/react-compiler
        domRef.current = el;
        if (el) {
            el.lang = locale;
            el.dir = direction;
            let spectrumBorderRadius = typeof window !== 'undefined' ? window.getComputedStyle(el).borderRadius : '';
            if (spectrumBorderRadius !== '') setBorderRadius(parseInt(spectrumBorderRadius, 10));
        }
    }, [
        locale,
        direction,
        domRef
    ]);
    return (0, $dx4lB.jsx)((0, $fBwWk.Tooltip), {
        ...props,
        arrowBoundaryOffset: borderRadius,
        containerPadding: containerPadding,
        crossOffset: crossOffset,
        offset: 9,
        placement: placement,
        shouldFlip: shouldFlip,
        ref: tooltipRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + $11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$tooltip({
                ...renderProps,
                colorScheme: colorScheme
            }),
        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $eENmv.OverlayArrow), {
                        className: "",
                        children: (0, $dx4lB.jsx)("svg", {
                            className: $11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$arrowStyles(renderProps),
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 10 5",
                            children: (0, $dx4lB.jsx)("path", {
                                d: "M4.29289 4.29289L0 0H10L5.70711 4.29289C5.31658 4.68342 4.68342 4.68342 4.29289 4.29289Z"
                            })
                        })
                    }),
                    children
                ]
            })
    });
});
function $11cbb79187eebc1e$export$8c610744efcf8a1d(props) {
    let { containerPadding: containerPadding, crossOffset: crossOffset, placement: placement, shouldFlip: shouldFlip, ...triggerProps } = props;
    return (0, $dx4lB.jsx)((0, $fBwWk.TooltipTrigger), {
        ...triggerProps,
        children: (0, $dx4lB.jsx)($11cbb79187eebc1e$var$$4c20647d6e5d8fdf$var$InternalTooltipTriggerContext.Provider, {
            value: {
                containerPadding: containerPadding,
                crossOffset: crossOffset,
                placement: placement,
                shouldFlip: shouldFlip
            },
            children: props.children
        })
    });
}
function $11cbb79187eebc1e$export$92ee03cda75aac2b(props) {
    return (0, $dx4lB.jsx)("div", {});
}

});
parcelRegister("fBwWk", function(module, exports) {

$parcel$export(module.exports, "TooltipTrigger", () => $19bd5d79a22db06d$export$8c610744efcf8a1d);
$parcel$export(module.exports, "Tooltip", () => $19bd5d79a22db06d$export$28c660c63b792dea);

var $fDYaM = parcelRequire("fDYaM");

var $eENmv = parcelRequire("eENmv");

var $5ynwP = parcelRequire("5ynwP");

var $fVfXf = parcelRequire("fVfXf");

var $8M8Qw = parcelRequire("8M8Qw");

var $lhKAD = parcelRequire("lhKAD");

var $uddx7 = parcelRequire("uddx7");

var $eF4cA = parcelRequire("eF4cA");

var $h9PPU = parcelRequire("h9PPU");

var $6AczJ = parcelRequire("6AczJ");

var $dkIqh = parcelRequire("dkIqh");
var $9Ku0W = parcelRequire("9Ku0W");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $19bd5d79a22db06d$export$7a7623236eec67fa = (0, $eF4cA.createContext)(null);
const $19bd5d79a22db06d$export$39ae08fa83328b12 = (0, $eF4cA.createContext)(null);
function $19bd5d79a22db06d$export$8c610744efcf8a1d(props) {
    let state = (0, $h9PPU.useTooltipTriggerState)(props);
    let ref = (0, $eF4cA.useRef)(null);
    let { triggerProps: triggerProps, tooltipProps: tooltipProps } = (0, $9Ku0W.useTooltipTrigger)(props, state, ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $19bd5d79a22db06d$export$7a7623236eec67fa,
                state
            ],
            [
                $19bd5d79a22db06d$export$39ae08fa83328b12,
                {
                    ...tooltipProps,
                    triggerRef: ref
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8M8Qw.FocusableProvider), {
        ...triggerProps,
        ref: ref
    }, props.children));
}
const $19bd5d79a22db06d$export$28c660c63b792dea = (0, $eF4cA.forwardRef)(function Tooltip({ UNSTABLE_portalContainer: UNSTABLE_portalContainer, ...props }, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $19bd5d79a22db06d$export$39ae08fa83328b12);
    let contextState = (0, $eF4cA.useContext)($19bd5d79a22db06d$export$7a7623236eec67fa);
    let localState = (0, $h9PPU.useTooltipTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    // Skip the automatic exit animation when closing instantly (e.g. swapping between tooltips
    // during warmup). An explicitly provided isExiting prop still takes precedence.
    let exitAnimation = (0, $6AczJ.useExitAnimation)(ref, state.isOpen);
    let isExiting = props.isExiting || !state.shouldSkipAnimation && exitAnimation || false;
    if (!state.isOpen && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $uddx7.OverlayContainer), {
        portalContainer: UNSTABLE_portalContainer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($19bd5d79a22db06d$var$$05a50f7d78b03ad9$var$TooltipInner, {
        ...props,
        tooltipRef: ref,
        isExiting: isExiting
    }));
});
function $19bd5d79a22db06d$var$$05a50f7d78b03ad9$var$TooltipInner(props) {
    let state = (0, $eF4cA.useContext)($19bd5d79a22db06d$export$7a7623236eec67fa);
    let arrowRef = (0, $eF4cA.useRef)(null);
    let { overlayProps: overlayProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: triggerAnchorPoint } = (0, $5ynwP.useOverlayPosition)({
        placement: props.placement || 'top',
        targetRef: props.triggerRef,
        overlayRef: props.tooltipRef,
        arrowRef: arrowRef,
        offset: props.offset,
        crossOffset: props.crossOffset,
        isOpen: state.isOpen,
        arrowBoundaryOffset: props.arrowBoundaryOffset,
        shouldFlip: props.shouldFlip,
        containerPadding: props.containerPadding,
        onClose: ()=>state.close(true)
    });
    // Skip the automatic entry animation when opening instantly (e.g. swapping between tooltips
    // during warmup). An explicitly provided isEntering prop still takes precedence.
    let enterAnimation = (0, $6AczJ.useEnterAnimation)(props.tooltipRef, !!placement);
    let isEntering = props.isEntering || !state.shouldSkipAnimation && enterAnimation || false;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Tooltip',
        values: {
            placement: placement,
            isEntering: isEntering,
            isExiting: props.isExiting,
            state: state
        }
    });
    props = (0, $lhKAD.mergeProps)(props, overlayProps);
    let { tooltipProps: tooltipProps } = (0, $dkIqh.useTooltip)(props, state);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    // oxlint-disable react/react-compiler
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, tooltipProps),
        ref: props.tooltipRef,
        style: {
            ...overlayProps.style,
            '--trigger-anchor-point': triggerAnchorPoint ? `${triggerAnchorPoint.x}px ${triggerAnchorPoint.y}px` : undefined,
            ...renderProps.style
        },
        "data-placement": placement ?? undefined,
        "data-entering": isEntering || undefined,
        "data-exiting": props.isExiting || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $eENmv.OverlayArrowContext).Provider, {
        value: {
            ...arrowProps,
            placement: placement,
            ref: arrowRef
        }
    }, renderProps.children));
// oxlint-enable react/react-compiler
}

});
parcelRegister("uddx7", function(module, exports) {

$parcel$export(module.exports, "ModalProvider", () => $b7180c8866f8d842$export$178405afcd8c5eb);
$parcel$export(module.exports, "useModalProvider", () => $b7180c8866f8d842$export$d9aaed4c3ece1bc0);
$parcel$export(module.exports, "OverlayContainer", () => $b7180c8866f8d842$export$b47c3594eab58386);

var $hWe38 = parcelRequire("hWe38");

var $euMIq = parcelRequire("euMIq");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b7180c8866f8d842$var$$c07df45195231803$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
function $b7180c8866f8d842$export$178405afcd8c5eb(props) {
    let { children: children } = props;
    let parent = (0, $eF4cA.useContext)($b7180c8866f8d842$var$$c07df45195231803$var$Context);
    let [modalCount, setModalCount] = (0, $eF4cA.useState)(0);
    let context = (0, $eF4cA.useMemo)(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($b7180c8866f8d842$var$$c07df45195231803$var$Context.Provider, {
        value: context
    }, children);
}
function $b7180c8866f8d842$export$d9aaed4c3ece1bc0() {
    let context = (0, $eF4cA.useContext)($b7180c8866f8d842$var$$c07df45195231803$var$Context);
    return {
        modalProviderProps: {
            'aria-hidden': context && context.modalCount > 0 ? true : undefined
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $b7180c8866f8d842$var$$c07df45195231803$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps } = $b7180c8866f8d842$export$d9aaed4c3ece1bc0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function $b7180c8866f8d842$export$bf688221f59024e5(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($b7180c8866f8d842$export$178405afcd8c5eb, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($b7180c8866f8d842$var$$c07df45195231803$var$OverlayContainerDOM, props));
}
function $b7180c8866f8d842$export$b47c3594eab58386(props) {
    let isSSR = (0, $hWe38.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, ...rest } = props;
    let { getContainer: getContainer } = (0, $euMIq.useUNSAFE_PortalContext)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useEffect(()=>{
        if (portalContainer?.closest('[data-overlay-container]')) throw new Error('An OverlayContainer must not be inside another container. Please change the portalContainer prop.');
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($b7180c8866f8d842$export$bf688221f59024e5, rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l19Vn))).createPortal(contents, portalContainer);
}
function $b7180c8866f8d842$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, $eF4cA.useContext)($b7180c8866f8d842$var$$c07df45195231803$var$Context);
    if (!context) throw new Error('Modal is not contained within a provider');
    (0, $eF4cA.useEffect)(()=>{
        if (options?.isDisabled || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options?.isDisabled
    ]);
    return {
        modalProps: {
            'data-ismodal': !options?.isDisabled
        }
    };
}

});

parcelRegister("h9PPU", function(module, exports) {

$parcel$export(module.exports, "useTooltipTriggerState", () => $5a7e5bcbd1616a60$export$4d40659c25ecb50b);

var $lIr3v = parcelRequire("lIr3v");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$TOOLTIP_DELAY = 1500; // this seems to be a 1.5 second delay, check with design
const $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$TOOLTIP_COOLDOWN = 500;
let $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips = {};
let $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltipId = 0;
let $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp = false;
let $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout = null;
let $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout = null;
function $5a7e5bcbd1616a60$export$4d40659c25ecb50b(props = {}) {
    let { delay: delay = $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$TOOLTIP_DELAY, closeDelay: closeDelay = $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$TOOLTIP_COOLDOWN } = props;
    let { isOpen: isOpen, open: open, close: close } = (0, $lIr3v.useOverlayTriggerState)(props);
    // Whether the current open/close transition should skip its animation. Set when swapping
    // between tooltips during the global warmup period.
    let [shouldSkipAnimation, setIsInstant] = (0, $eF4cA.useState)(false);
    let id = (0, $eF4cA.useMemo)(()=>`${++$5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltipId}`, []);
    let closeTimeout = (0, $eF4cA.useRef)(null);
    let closeCallback = (0, $eF4cA.useRef)(close);
    let ensureTooltipEntry = ()=>{
        $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips[id] = hideTooltip;
    };
    let closeOpenTooltips = ()=>{
        for(let hideTooltipId in $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips)if (hideTooltipId !== id) {
            // Close other open tooltips instantly (no exit animation), since they are being
            // replaced by this one during the warmup period.
            $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips[hideTooltipId](true, true);
            delete $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips[hideTooltipId];
        }
    };
    let showTooltip = (instant)=>{
        if (closeTimeout.current) clearTimeout(closeTimeout.current);
        closeTimeout.current = null;
        closeOpenTooltips();
        ensureTooltipEntry();
        setIsInstant(!!instant);
        $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp = true;
        open();
        if ($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout) {
            clearTimeout($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout);
            $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout = null;
        }
        if ($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout) {
            clearTimeout($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout);
            $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout = null;
        }
    };
    let hideTooltip = (immediate, instant)=>{
        setIsInstant(!!instant);
        if (immediate || closeDelay <= 0) {
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
            closeCallback.current();
        } else if (!closeTimeout.current) closeTimeout.current = setTimeout(()=>{
            closeTimeout.current = null;
            closeCallback.current();
        }, closeDelay);
        if ($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout) {
            clearTimeout($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout);
            $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout = null;
        }
        if ($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp) {
            if ($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout) clearTimeout($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout);
            $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout = setTimeout(()=>{
                delete $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips[id];
                $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalCooldownTimeout = null;
                $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp = false;
            }, Math.max($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$TOOLTIP_COOLDOWN, closeDelay));
        }
    };
    let warmupTooltip = ()=>{
        closeOpenTooltips();
        ensureTooltipEntry();
        if (!isOpen && !$5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp) {
            if ($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout) clearTimeout($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout);
            $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout = setTimeout(()=>{
                $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmUpTimeout = null;
                $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp = true;
                // First tooltip in a sequence: animate in.
                showTooltip(false);
            }, delay);
        } else if (!isOpen) showTooltip(true);
    };
    (0, $eF4cA.useEffect)(()=>{
        closeCallback.current = close;
    }, [
        close
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
            let tooltip = $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips[id];
            if (tooltip) delete $5a7e5bcbd1616a60$var$$3834487504f4fc00$var$tooltips[id];
        };
    }, [
        id
    ]);
    return {
        isOpen: isOpen,
        shouldSkipAnimation: shouldSkipAnimation,
        open: (immediate)=>{
            if (!immediate && delay > 0 && !closeTimeout.current) warmupTooltip();
            else // only if another tooltip is already warmed up.
            showTooltip($5a7e5bcbd1616a60$var$$3834487504f4fc00$var$globalWarmedUp);
        },
        close: hideTooltip
    };
}

});

parcelRegister("dkIqh", function(module, exports) {

$parcel$export(module.exports, "useTooltip", () => $252fd778ad62bf1b$export$1c4b08e0eca38426);

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $j2JDe = parcelRequire("j2JDe");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $252fd778ad62bf1b$export$1c4b08e0eca38426(props, state) {
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let { hoverProps: hoverProps } = (0, $j2JDe.useHover)({
        onHoverStart: ()=>state?.open(true),
        onHoverEnd: ()=>state?.close()
    });
    return {
        tooltipProps: (0, $lhKAD.mergeProps)(domProps, hoverProps, {
            role: 'tooltip'
        })
    };
}

});

parcelRegister("9Ku0W", function(module, exports) {

$parcel$export(module.exports, "useTooltipTrigger", () => $3b3cdc138d1e6b25$export$a6da6c504e4bba8b);

var $YxOvP = parcelRequire("YxOvP");

var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $j2JDe = parcelRequire("j2JDe");

var $25dFS = parcelRequire("25dFS");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3b3cdc138d1e6b25$export$a6da6c504e4bba8b(props, state, ref) {
    let { isDisabled: isDisabled, trigger: trigger, shouldCloseOnPress: shouldCloseOnPress = true } = props;
    let tooltipId = (0, $25dFS.useId)();
    let isHovered = (0, $eF4cA.useRef)(false);
    let isFocused = (0, $eF4cA.useRef)(false);
    let handleShow = ()=>{
        if (isHovered.current || isFocused.current) state.open(isFocused.current);
    };
    let handleHide = (immediate)=>{
        if (!isHovered.current && !isFocused.current) state.close(immediate);
    };
    (0, $eF4cA.useEffect)(()=>{
        let onKeyDown = (e)=>{
            if (ref && ref.current) {
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    state.close(true);
                }
            }
        };
        if (state.isOpen) {
            document.addEventListener('keydown', onKeyDown, true);
            return ()=>{
                document.removeEventListener('keydown', onKeyDown, true);
            };
        }
    }, [
        ref,
        state
    ]);
    let onHoverStart = ()=>{
        if (trigger === 'focus') return;
        // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
        // interactions for example, hover will end. When hover is restored after that element disappears,
        // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
        // is the result of moving the mouse.
        if ((0, $YxOvP.getInteractionModality)() === 'pointer') isHovered.current = true;
        else isHovered.current = false;
        handleShow();
    };
    let onHoverEnd = ()=>{
        if (trigger === 'focus') return;
        // no matter how the trigger is left, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide();
    };
    let onPressStart = ()=>{
        // if shouldCloseOnPress is false, we should not close the tooltip
        if (!shouldCloseOnPress) return;
        // no matter how the trigger is pressed, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let onFocus = ()=>{
        let isVisible = (0, $YxOvP.isFocusVisible)();
        if (isVisible) {
            isFocused.current = true;
            handleShow();
        }
    };
    let onBlur = ()=>{
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let { hoverProps: hoverProps } = (0, $j2JDe.useHover)({
        isDisabled: isDisabled,
        onHoverStart: onHoverStart,
        onHoverEnd: onHoverEnd
    });
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)({
        isDisabled: isDisabled,
        onFocus: onFocus,
        onBlur: onBlur
    }, ref);
    return {
        triggerProps: {
            'aria-describedby': state.isOpen ? tooltipId : undefined,
            // oxlint-disable-next-line react/react-compiler
            ...(0, $lhKAD.mergeProps)(focusableProps, hoverProps, {
                onPointerDown: onPressStart,
                onKeyDown: onPressStart
            }),
            tabIndex: undefined
        },
        tooltipProps: {
            id: tooltipId
        }
    };
}

});



parcelRegister("5KhQr", function(module, exports) {

$parcel$export(module.exports, "Pressable", () => $ac9a387cfb3d1352$export$27c701ed9e449e99);



var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $bEes0 = parcelRequire("bEes0");

var $8M8Qw = parcelRequire("8M8Qw");

var $26CkO = parcelRequire("26CkO");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ac9a387cfb3d1352$export$27c701ed9e449e99 = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef(({ children: children, ...props }, ref)=>{
    ref = (0, $26CkO.useObjectRef)(ref);
    let { pressProps: pressProps } = (0, $bEes0.usePress)({
        ...props,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)(props, ref);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.only(children);
    (0, $eF4cA.useEffect)(()=>{
        return;
    }, [
        ref,
        props.isDisabled
    ]);
    // @ts-ignore
    let childRef = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).version, 10) < 19 ? child.ref : child.props.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).cloneElement(child, {
        ...(0, $lhKAD.mergeProps)(pressProps, focusableProps, child.props),
        // @ts-ignore
        // oxlint-disable-next-line react/react-compiler
        ref: (0, $bkjeZ.mergeRefs)(childRef, ref)
    });
});

});

parcelRegister("klXmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $23de11474b59d61d$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $23de11474b59d61d$var$$9a7089d23452d320$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.53 9.427c-.292-.292-.766-.294-1.06 0l-1.717 1.714V2.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v8.4L7.53 9.426c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.998 2.998c.146.147.338.22.53.22.191 0 .384-.073.53-.22l3.002-2.998c.293-.292.293-.767 0-1.06"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75v-2.021c0-.415.336-.75.75-.75s.75.335.75.75v2.021c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75v-2.021c0-.415.336-.75.75-.75s.75.335.75.75v2.021c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const $23de11474b59d61d$var$$9a7089d23452d320$var$ForwardRef = (0, $eF4cA.forwardRef)($23de11474b59d61d$var$$9a7089d23452d320$var$SvgComponent);
var $23de11474b59d61d$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($23de11474b59d61d$var$$9a7089d23452d320$var$ForwardRef);

});

parcelRegister("edFAP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0eeffb8ca696191$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $d0eeffb8ca696191$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.25 18h-7.5C3.682 18 2 16.317 2 14.25v-7.5C2 4.683 3.682 3 5.75 3H8c.414 0 .75.336.75.75s-.336.75-.75.75H5.75C4.51 4.5 3.5 5.51 3.5 6.75v7.5c0 1.24 1.01 2.25 2.25 2.25h7.5c1.24 0 2.25-1.01 2.25-2.25v-3.752c0-.414.336-.75.75-.75s.75.336.75.75v3.752c0 2.067-1.682 3.75-3.75 3.75"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M12.94 9.583c-.194 0-.39-.05-.568-.153-.428-.247-.646-.738-.541-1.221l.512-2.375-1.631-1.8c-.332-.366-.39-.9-.142-1.329s.738-.645 1.223-.54l2.374.513 1.799-1.632c.367-.333.901-.39 1.33-.142.428.247.645.739.54 1.222L17.323 4.5l1.632 1.8c.332.366.39.9.142 1.328-.247.43-.736.647-1.223.542l-2.373-.514-1.8 1.632c-.215.194-.487.295-.761.295m.91-3.616-.313 1.445 1.095-.993c.272-.246.645-.349 1.003-.268l1.443.312-.992-1.095c-.245-.27-.345-.643-.27-1l.313-1.445-1.094.992c-.272.245-.643.349-1.003.268l-1.443-.312.992 1.095c.245.27.346.644.268 1M8.12 13.25c-.129 0-.258-.033-.375-.1-.282-.164-.427-.49-.358-.808l.203-.94-.646-.712c-.218-.242-.256-.596-.093-.878s.492-.422.808-.359l.939.204.712-.645c.241-.22.597-.257.878-.094.283.163.427.49.358.808l-.202.939.645.712c.219.242.257.597.094.879s-.491.42-.808.358l-.94-.204-.711.646c-.142.128-.322.194-.504.194"
            })
        ]
    });
const $d0eeffb8ca696191$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($d0eeffb8ca696191$var$SvgComponent);
var $d0eeffb8ca696191$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($d0eeffb8ca696191$var$ForwardRef);

});

parcelRegister("g2Wqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85e390be1812016b$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $85e390be1812016b$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 54,
        height: 54,
        fill: "none",
        viewBox: "0 0 54 54",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("g", {
                clipPath: "url(#30dc30__a)",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                        fill: "#F2F2F2",
                        d: "M44.26 0H9.74C4.36 0 0 4.36 0 9.74v34.52C0 49.64 4.36 54 9.74 54h34.52c5.38 0 9.74-4.36 9.74-9.74V9.74C54 4.36 49.64 0 44.26 0"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("g", {
                        clipPath: "url(#30dc30__b)",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                fill: "#00AC47",
                                d: "M36.945 27.5c.002 2.223-.781 4.375-2.21 6.077-1.43 1.702-3.415 2.845-5.604 3.227-2.19.383-4.444-.02-6.366-1.136-1.922-1.117-3.388-2.876-4.14-4.968l-5.403 4.322c1.68 3.194 4.382 5.732 7.673 7.21s6.983 1.81 10.486.945 6.615-2.88 8.838-5.722c2.224-2.842 3.431-6.347 3.43-9.955"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                fill: "#4285F4",
                                d: "M36.945 27.5c0 1.503-.361 2.983-1.05 4.319s-1.688 2.486-2.913 3.357l5.342 4.273c1.674-1.508 3.014-3.35 3.931-5.409s1.392-4.286 1.393-6.54"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                fill: "#FFBA00",
                                d: "M18.055 27.5c.002-1.092.195-2.175.57-3.2l-5.403-4.322c-1.228 2.317-1.87 4.9-1.87 7.522s.642 5.205 1.87 7.522l5.403-4.322c-.375-1.025-.568-2.108-.57-3.2"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                fill: "#EA4435",
                                d: "M27.5 18.055c1.999 0 3.945.639 5.555 1.823l4.948-4.619c-1.837-1.583-4.007-2.732-6.35-3.36s-4.797-.717-7.18-.263-4.631 1.44-6.58 2.884-3.545 3.31-4.67 5.458l5.402 4.322c.659-1.827 1.864-3.406 3.452-4.523 1.588-1.118 3.481-1.719 5.423-1.722"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                fill: "#4285F4",
                                d: "M43.648 26.281V27.5l-2.742 4.266H28.11v-6.703h14.32c.324 0 .634.128.862.357.229.228.357.538.357.861"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("clipPath", {
                        id: "30dc30__a",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h54v54H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("clipPath", {
                        id: "30dc30__b",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                            fill: "#fff",
                            d: "M8 8h39v39H8z"
                        })
                    })
                ]
            })
        ]
    });
const $85e390be1812016b$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($85e390be1812016b$var$SvgComponent);
var $85e390be1812016b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($85e390be1812016b$var$ForwardRef);

});

parcelRegister("k469E", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e7ccb11d05db918$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $7e7ccb11d05db918$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 54 54",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                    width: 54,
                    height: 54,
                    rx: 9.74,
                    ry: 9.74,
                    style: {
                        fill: "#eb1000"
                    }
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                        d: "M13.48 14.96h18.09v5.88H20.36v4.25h9.92v5.88h-9.92v8.77h-6.88zM34.46 20.43h6.48v19.32h-6.48zM38.81 16.86l2.31.52c.91.2 1.54-.88.9-1.56l-1.6-1.73c-.21-.23-.3-.54-.23-.85l.52-2.3c.2-.9-.88-1.53-1.57-.9l-1.74 1.6c-.23.21-.55.29-.85.23l-2.31-.52c-.91-.2-1.54.88-.9 1.56l1.6 1.73c.21.23.3.54.23.85l-.52 2.3c-.2.9.88 1.53 1.57.9l1.74-1.6c.23-.21.55-.29.85-.23",
                        style: {
                            fill: "#fff"
                        }
                    })
                })
            })
        ]
    });
const $7e7ccb11d05db918$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($7e7ccb11d05db918$var$SvgComponent);
var $7e7ccb11d05db918$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($7e7ccb11d05db918$var$ForwardRef);

});

parcelRegister("erkCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc990f21b4ba1d6$export$2e2bcd8739ae039);

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $7fc990f21b4ba1d6$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("g", {
                fill: "#6e6e6e",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                        width: 20,
                        height: 20,
                        rx: 3.607,
                        ry: 3.607
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                        d: "M7.226 5.54c2.604 0 4.07 1.22 4.07 3.264 0 2.385-1.989 3.344-3.852 3.344H6.185v2.578H3.637V5.54H7.23zM6.186 7.72v2.248h1.121c.782 0 1.33-.315 1.33-1.111 0-.726-.467-1.137-1.274-1.137zM11.926 14.27l.015-2.126c.726.482 1.74.782 2.44.782.478 0 .7-.137.7-.385 0-.274-.3-.385-.877-.563-1.111-.33-2.33-.782-2.33-2.234s1.219-2.303 2.989-2.303c.837 0 1.522.122 2.126.385l-.015 2.03c-.478-.29-1.426-.549-2.04-.549-.453 0-.63.137-.63.345 0 .248.218.315.877.522 1.275.385 2.345.796 2.345 2.289s-1.167 2.385-2.989 2.385c-.96 0-1.863-.163-2.604-.574z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                width: 20,
                height: 20,
                fill: "#001e36",
                rx: 3.607,
                ry: 3.607
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                fill: "#31a8ff",
                d: "M7.226 5.54c2.604 0 4.07 1.22 4.07 3.264 0 2.385-1.989 3.344-3.852 3.344H6.185v2.578H3.637V5.54H7.23zM6.186 7.72v2.248h1.121c.782 0 1.33-.315 1.33-1.111 0-.726-.467-1.137-1.274-1.137zM11.926 14.27l.015-2.126c.726.482 1.74.782 2.44.782.478 0 .7-.137.7-.385 0-.274-.3-.385-.877-.563-1.111-.33-2.33-.782-2.33-2.234s1.219-2.303 2.989-2.303c.837 0 1.522.122 2.126.385l-.015 2.03c-.478-.29-1.426-.549-2.04-.549-.453 0-.63.137-.63.345 0 .248.218.315.877.522 1.275.385 2.345.796 2.345 2.289s-1.167 2.385-2.989 2.385c-.96 0-1.863-.163-2.604-.574z"
            })
        ]
    });
const $7fc990f21b4ba1d6$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($7fc990f21b4ba1d6$var$SvgComponent);
var $7fc990f21b4ba1d6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($7fc990f21b4ba1d6$var$ForwardRef);

});

parcelRegister("jBZxV", function(module, exports) {

$parcel$export(module.exports, "S3Video", () => $e47136d5d10cd5e1$export$5f55565bb9b55001);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $91SAk = parcelRequire("91SAk");

var $a8sj2 = parcelRequire("a8sj2");
const $e47136d5d10cd5e1$export$5f55565bb9b55001 = /*#__PURE__*/ (0, $eF4cA.forwardRef)(({ filePath: filePath, src: src, isLoading: _isLoading, ...props }, ref)=>{
    const urlQuery = (0, $a8sj2.usePresignURL)(filePath, {
        enabled: !src && !!filePath
    });
    const videoSrc = urlQuery.data?.presignURL ?? src;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
        isLoading: !!_isLoading || !videoSrc && urlQuery.isFetching,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("video", {
            ref: ref,
            src: videoSrc ?? undefined,
            muted: true,
            autoPlay: true,
            playsInline: true,
            loop: true,
            ...props
        })
    });
});
$e47136d5d10cd5e1$export$5f55565bb9b55001.displayName = "S3Video";
$e47136d5d10cd5e1$export$5f55565bb9b55001.propTypes = {
    filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};

});

parcelRegister("8ZsKk", function(module, exports) {

$parcel$export(module.exports, "ImageVariationCard", () => $68ba51a8e48a97b8$export$7eb814a9cc90144);
$parcel$export(module.exports, "ReferenceImages", () => $68ba51a8e48a97b8$export$7a4d573f47324198);
$parcel$export(module.exports, "ImageVariations", () => $68ba51a8e48a97b8$export$63bdc604ca2a66bb);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $2RdeM = parcelRequire("2RdeM");
var $KXDAG = parcelRequire("KXDAG");
var $7Vvqh = parcelRequire("7Vvqh");
var $5nTep = parcelRequire("5nTep");
var $208Op = parcelRequire("208Op");
var $hSW0F = parcelRequire("hSW0F");

var $8M8Qw = parcelRequire("8M8Qw");
var $bEes0 = parcelRequire("bEes0");

var $k5Pnh = parcelRequire("k5Pnh");

var $15xG7 = parcelRequire("15xG7");

var $gUjW8 = parcelRequire("gUjW8");

var $cnBj9 = parcelRequire("cnBj9");

var $fyTQx = parcelRequire("fyTQx");

var $d51mJ = parcelRequire("d51mJ");

var $9iR3a = parcelRequire("9iR3a");

var $j7E4C = parcelRequire("j7E4C");

var $g2Wqz = parcelRequire("g2Wqz");

var $k469E = parcelRequire("k469E");

var $erkCj = parcelRequire("erkCj");

var $fmJ8d = parcelRequire("fmJ8d");

var $iLDMH = parcelRequire("iLDMH");

var $jBZxV = parcelRequire("jBZxV");

var $iKDEm = parcelRequire("iKDEm");

var $kekDO = parcelRequire("kekDO");

var $6AUdR = parcelRequire("6AUdR");

var $lRNYL = parcelRequire("lRNYL");

var $lfyDg = parcelRequire("lfyDg");

var $lb17q = parcelRequire("lb17q");
const $68ba51a8e48a97b8$export$7eb814a9cc90144 = ({ variation: variation, asset: _asset, assets: assets = [], isLoading: isLoading, progress: progress, aspectRatio: aspectRatio, isOutdated: isOutdated = false, isIdle: isIdle = false, isInDropZone: isInDropZone = false, showProgressLabel: showProgressLabel = true, onEdit: onEdit, styles: styles = "", children: children })=>{
    // Without `onEdit` there is nothing to press or hover for.
    const { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPress: ()=>onEdit?.(variation),
        isDisabled: !onEdit
    });
    const fallbackAsset = _asset?.isSkipped ? assets.find((a)=>a.name === variation?.fallbackKey) : null;
    const asset = fallbackAsset ?? _asset;
    // A failed generation, or one the campaign has moved on from.
    // Not while a new image is on its way, which supersedes the flagged one.
    const isFlagged = !isLoading && (!!variation?.data?.errorCode || isOutdated);
    const ModelIcon = asset?.model?.startsWith("nano-banana") ? (0, $g2Wqz.default) : asset?.model === "photoshop" ? (0, $erkCj.default) : asset?.model?.startsWith("image") || asset?.model === "video" ? (0, $k469E.default) : null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        ...pressProps,
        className: function anonymous(props) {
            let rules = " ";
            rules += ' Yg182';
            rules += ' Xb182';
            rules += ' _2b182';
            rules += ' _8d182';
            if (props.isPressed) rules += ' _ZKUVOde182';
            else rules += ' _Zh3TDrc182';
            return rules;
        }({
            isPressed: isPressed
        }),
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
            variant: "quiet",
            styles: (0, $5nTep.mergeStyles)(" _nLeasBb182 Za182", styles),
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                    children: [
                        asset?.type === "video" ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
                            filePath: fallbackAsset?.filePath ?? asset?.filePath,
                            src: fallbackAsset?.src ?? asset?.src,
                            isLoading: isLoading,
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' sb182';
                                if (props.isFixedAspectRatio) rules += ' _Ha182';
                                else rules += ' _Hb182';
                                rules += ' Za182';
                                rules += ' fcJcitc182';
                                return rules;
                            }({
                                isFixedAspectRatio: !!aspectRatio
                            }),
                            style: aspectRatio ? {
                                aspectRatio: aspectRatio
                            } : undefined
                        }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                            alt: asset?.name,
                            filePath: fallbackAsset?.filePath ?? asset?.filePath,
                            isLoading: isLoading,
                            styles: function anonymous(props) {
                                let rules = " ";
                                if (props.isFixedAspectRatio) rules += ' _Ha182';
                                else rules += ' _Hb182';
                                return rules;
                            }({
                                isFixedAspectRatio: !!aspectRatio
                            }),
                            UNSAFE_style: aspectRatio ? {
                                aspectRatio: aspectRatio
                            } : asset?.size ? {
                                aspectRatio: `${asset.size.width} / ${asset.size.height}`
                            } : {}
                        }),
                        !variation?.data?.errorCode && !isIdle && (isLoading || !asset?.filePath) && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " sd182 _ta182 eb182 _Ca182 Za182 Fb182 _Pa182 Wr182 _Ar182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lfyDg.VariationProgress), {
                                progress: progress,
                                showLabel: showProgressLabel
                            })
                        }),
                        isFlagged && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' _Pa182';
                                rules += ' Wy182';
                                rules += ' _ly182';
                                rules += ' _Ay182';
                                rules += ' _zy182';
                                rules += ' _Mc182';
                                if (props.isInDropZone) rules += ' _Le182';
                                else rules += ' _Lf182';
                                rules += ' OqgQrud182';
                                rules += ' ob182';
                                rules += ' nb182';
                                rules += ' kb182';
                                rules += ' jb182';
                                return rules;
                            }({
                                isInDropZone: isInDropZone
                            }),
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                variant: "notice",
                                styles: " _Pa182 WJ182 _AI182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cnBj9.default), {})
                            })
                        }),
                        !!asset?.filePath && _asset?.type === "video" && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " _Pa182 WF182 _A3MNfn182 -_7PloMd-CoPtrc182 __Ya182 -_8PloMd-m182 __Ya182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                "aria-label": "Video type",
                                size: "S",
                                staticColor: "auto",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9iR3a.default), {})
                            })
                        }),
                        children
                    ]
                }),
                !isLoading && !!asset?.filePath && !!onEdit && // In a drop zone, the hover outline is drawn over the zone's dashed
                // border, while what it shows stays within the card.
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " _Pa182 Wr182 _lr182 _Ar182 _zr182",
                    style: isInDropZone ? {
                        inset: -(0, $kekDO.IMAGE_DROP_ZONE_OUTSET)
                    } : undefined,
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iKDEm.HoverState), {
                        isTinted: true,
                        renderBehavior: "always",
                        size: isInDropZone ? "XL" : "L",
                        styles: " sd182 eb182 _Ca182 _Oa182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " _Pa182 Wr182 _lr182 _Ar182 _zr182 sd182 eb182 _Ca182",
                            style: isInDropZone ? {
                                inset: (0, $kekDO.IMAGE_DROP_ZONE_OUTSET)
                            } : undefined,
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    "aria-label": "Edit variation",
                                    staticColor: "auto",
                                    // onPress={() => onEdit?.(variation)}
                                    UNSAFE_className: " _Ob182",
                                    children: variation.data?.visualPrompt ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $gUjW8.default), {})
                                }),
                                !!ModelIcon && /*#__PURE__*/ (0, $dx4lB.jsx)(ModelIcon, {
                                    styles: " _Pa182 WJ182 _zI182 _9a182"
                                })
                            ]
                        })
                    })
                }),
                isFlagged && isInDropZone && // Drawn over the drop zone's dashed border, which the preview
                // (clipping its content) cannot reach.
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " _Pa182 oe182 ne182 ke182 je182 _Mc182 _Kb182 _Lf182 OqgQrud182 _Ob182",
                    style: {
                        inset: -(0, $kekDO.IMAGE_DROP_ZONE_OUTSET)
                    }
                })
            ]
        })
    });
};
$68ba51a8e48a97b8$export$7eb814a9cc90144.propTypes = {
    variation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    assets: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number
    ]),
    isOutdated: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isIdle: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isInDropZone: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    showProgressLabel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const $68ba51a8e48a97b8$export$926e13577aad7fcb = ({ asset: asset, src: src, isLoading: isLoading, progress: progress, colorScheme: colorScheme, onEdit: onEdit, children: children })=>{
    const { pressProps: pressProps } = (0, $bEes0.usePress)({
        onPress: ()=>onEdit?.(asset),
        isDisabled: !onEdit
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        ...pressProps,
        className: " _Pc182 oa182 na182 ka182 ja182 _Nc182 Pc182 gH182 fq9Ufn182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                alt: asset?.name,
                filePath: asset?.filePath,
                // Already presigned in one batched request by the parent.
                src: src,
                styles: " _Hb182 Za182 Fb182"
            }),
            isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' sd182';
                    rules += ' eb182';
                    rules += ' _Ca182';
                    rules += ' Za182';
                    rules += ' Fb182';
                    rules += ' _Pa182';
                    rules += ' Wr182';
                    rules += ' _Ar182';
                    if (props.colorScheme === "default") rules += ' g9182';
                    else if (props.colorScheme === "dark") rules += ' gYTfire182';
                    else if (props.colorScheme === "light") rules += ' g6Lc5Le182';
                    return rules;
                }({
                    colorScheme: colorScheme
                }),
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lfyDg.VariationProgress), {
                    progress: progress,
                    size: 16,
                    showLabel: false
                })
            }),
            children
        ]
    });
};
$68ba51a8e48a97b8$export$926e13577aad7fcb.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    colorScheme: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
/**
 * The title of a reference — what it is — in a tooltip over it: its label,
 * then its name (see `getReferenceTitleParts`). The
 * thumbnail itself does nothing, so it is made focusable for the tooltip to
 * reach keyboard users too, and named for assistive technology.
 */ const $68ba51a8e48a97b8$var$ReferenceTooltip = ({ asset: asset, templateData: templateData, children: children })=>{
    const { label: label, name: name } = (0, $6AUdR.getReferenceTitleParts)(asset, templateData);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
        delay: 0,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8M8Qw.Focusable), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    role: "img",
                    "aria-label": (0, $6AUdR.getReferenceTitle)(asset, templateData),
                    tabIndex: 0,
                    className: " sb182 Za182",
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                children: label ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                    children: [
                        label,
                        " ",
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " -_6BNtrc-a182 vx182 pp182 _7c182",
                            children: [
                                "(",
                                name,
                                ")"
                            ]
                        })
                    ]
                }) : name
            })
        ]
    });
};
$68ba51a8e48a97b8$var$ReferenceTooltip.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const $68ba51a8e48a97b8$var$ReferenceBadge = ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $geNzB.Badge), {
        size: "XS",
        variant: "informative",
        fillStyle: "bold",
        styles: " _Pa182 WJ182 _AI182",
        UNSAFE_className: " _I0vfurc182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fyTQx.default), {}),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "Reference"
            })
        ]
    });
const $68ba51a8e48a97b8$export$b734c53d98bc4c89 = ({ asset: asset, isRequired: isRequired = false, variant: variant = "card", aspectRatio: aspectRatio, onUpload: onUpload })=>{
    const [isHovered, setHovered] = (0, $eF4cA.useState)(false);
    const isTile = variant === "tile";
    const text = isRequired ? "Reference required" : "No reference selected";
    const borderRadius = isTile ? "0.5rem" : (0, $kekDO.IMAGE_DROP_ZONE_STYLE).borderRadius;
    const padding = isTile ? 2 : (0, $kekDO.IMAGE_DROP_ZONE_STYLE).padding;
    const content = /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " _oa182 Za182 Fb182 sd182 _ta182 eb182 _Ca182 Ua182 qa182 Tp182 Qp182 Sp182 Rp182 _Wa182",
        style: {
            aspectRatio: isTile ? "1 / 1" : aspectRatio ?? "16 / 9"
        },
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d51mJ.default), {
                styles: function anonymous(props) {
                    let rules = " ";
                    if (props.isTile) rules += ' Zo182';
                    else rules += ' ZF182';
                    if (props.isTile) rules += ' Fp182';
                    else rules += ' Fz182';
                    return rules;
                }({
                    isTile: isTile
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: function anonymous(props) {
                    let rules = " ";
                    if (props.isTile) {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else {
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.isTile) {
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    } else {
                        rules += ' -_6BNtrc-c182';
                        rules += ' vx182';
                    }
                    if (props.isTile) {
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else {
                        rules += ' xd182';
                        rules += ' _xa182';
                        rules += ' xX0cczbc182';
                        rules += ' _xX0cczba182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    }
                    if (props.isTile) {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else {
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    }
                    rules += ' pv182';
                    return rules;
                }({
                    isTile: isTile
                }),
                children: text
            }),
            !isTile && !!onUpload && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                children: "Drop or select an image"
            })
        ]
    });
    // The warning of a required reference: the outline over the dashed border,
    // as an outdated image has it, and the badge.
    const warning = isRequired && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " _Pa182 _Mc182 _Lf182 OqgQrud182 _Kb182 _Ob182",
        style: {
            inset: -2,
            borderRadius: borderRadius
        },
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
            variant: "notice",
            size: isTile ? "XS" : "M",
            styles: " _Pa182 WJ182 _AI182",
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cnBj9.default), {})
        })
    });
    if (!onUpload) return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " _oa182 _Pc182 Za182 _kc182 hc182 mc182 lc182 _ja182 iq182",
        style: {
            padding: padding,
            borderRadius: borderRadius
        },
        children: [
            content,
            warning
        ]
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $KXDAG.DropZone), {
        "aria-label": `${text}: drop an image for ${asset?.name}`,
        getDropOperation: (0, $kekDO.getImageDragOperation),
        onDrop: (event)=>onUpload(event.items, asset?.name),
        UNSAFE_style: {
            padding: padding,
            borderRadius: borderRadius
        },
        styles: " Za182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                acceptedFileTypes: "image/*",
                onSelect: (files)=>onUpload(files, asset?.name),
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $k5Pnh.Button), {
                    className: " _oa182 _Pc182 Za182 Fb182 Td182 Qd182 Sd182 Rd182 _ka182 ha182 ma182 la182 g9182 _Nc182 Pc182",
                    style: {
                        borderRadius: isTile ? "0.375rem" : "0.625rem"
                    },
                    onHoverChange: setHovered,
                    children: [
                        content,
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $kekDO.UploadHoverOverlay), {
                            isHovered: isHovered,
                            compact: isTile
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $kekDO.UploadHoverBorder), {
                isHovered: isHovered,
                borderRadius: borderRadius
            }),
            warning
        ]
    });
};
$68ba51a8e48a97b8$export$b734c53d98bc4c89.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    isRequired: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "card",
        "tile"
    ]),
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number
    ]),
    onUpload: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
const $68ba51a8e48a97b8$export$a980b12494fd64f4 = (asset, { progressByKey: progressByKey, isLoading: isLoading, skipImageLabeling: skipImageLabeling, isLabeled: isLabeled, templateData: templateData } = {})=>{
    const progress = progressByKey?.[asset?.name];
    if (progress) return {
        isLoading: true,
        progress: progress
    };
    if (!asset?.filePath) {
        const kind = templateData && asset?.name ? (0, $6AUdR.getMissingReferenceKind)(asset.name, templateData) : (0, $6AUdR.REFERENCE_KIND).GENERATED;
        if (kind !== (0, $6AUdR.REFERENCE_KIND).GENERATED) return isLoading ? {
            isLoading: true,
            progress: null
        } : {
            isLoading: false,
            progress: null,
            isMissing: true,
            isRequired: kind === (0, $6AUdR.REFERENCE_KIND).REQUIRED
        };
        return {
            isLoading: true,
            progress: {
                stage: (0, $lb17q.VARIATION_PROGRESS_STAGE).WAITING,
                label: "Generating reference"
            }
        };
    }
    if (isLoading) return {
        isLoading: true,
        progress: null
    };
    if (!skipImageLabeling && !(isLabeled ? isLabeled(asset) : !!asset?.labeling?.description)) return {
        isLoading: true,
        progress: {
            stage: (0, $lb17q.VARIATION_PROGRESS_STAGE).LABELING
        }
    };
    return {
        isLoading: false,
        progress: null
    };
};
const $68ba51a8e48a97b8$export$7a4d573f47324198 = ({ assets: assets = [], urlByPath: urlByPath, isLoading: isLoading, progressByKey: progressByKey, skipImageLabeling: skipImageLabeling, isLabeled: isLabeled, templateData: templateData, colorScheme: colorScheme, aspectRatio: aspectRatio, showBadge: showBadge = true, showProgressLabel: showProgressLabel = true, showTooltips: showTooltips = false, onEdit: onEdit, onUpload: onUpload })=>{
    const withTooltip = (asset, node)=>showTooltips ? /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$var$ReferenceTooltip, {
            asset: asset,
            templateData: templateData,
            children: node
        }, asset?.name) : node;
    const getState = (asset)=>$68ba51a8e48a97b8$export$a980b12494fd64f4(asset, {
            progressByKey: progressByKey,
            isLoading: isLoading,
            skipImageLabeling: skipImageLabeling,
            isLabeled: isLabeled,
            templateData: templateData
        });
    if (assets.length <= 1) {
        const asset = assets[0];
        const { isLoading: isAssetLoading, progress: progress, isMissing: isMissing, isRequired: isRequired } = getState(asset);
        if (isMissing) return /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$export$b734c53d98bc4c89, {
            asset: asset,
            isRequired: isRequired,
            aspectRatio: aspectRatio,
            onUpload: onUpload
        });
        return withTooltip(asset, /*#__PURE__*/ (0, $dx4lB.jsxs)($68ba51a8e48a97b8$export$7eb814a9cc90144, {
            variation: {
                key: asset?.name
            },
            asset: asset,
            isLoading: isLoading,
            progress: progress,
            aspectRatio: aspectRatio,
            showProgressLabel: showProgressLabel,
            onEdit: onEdit ? ()=>onEdit(asset) : undefined,
            styles: " Za182",
            children: [
                showBadge && /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$var$ReferenceBadge, {}),
                isAssetLoading && !isLoading && !!asset?.filePath && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: function anonymous(props) {
                        let rules = " ";
                        rules += ' sd182';
                        rules += ' _ta182';
                        rules += ' eb182';
                        rules += ' _Ca182';
                        rules += ' Za182';
                        rules += ' Fb182';
                        rules += ' _Pa182';
                        rules += ' Wr182';
                        rules += ' _Ar182';
                        if (props.colorScheme === "default") rules += ' g9182';
                        else if (props.colorScheme === "dark") rules += ' gYTfire182';
                        else if (props.colorScheme === "light") rules += ' g6Lc5Le182';
                        return rules;
                    }({
                        colorScheme: colorScheme
                    }),
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lfyDg.VariationProgress), {
                        progress: progress,
                        showLabel: showProgressLabel
                    })
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
        variant: "quiet",
        styles: " _nLeasBb182 Za182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: (0, $5nTep.mergeStyles)(" se182 DM8Mfn182 Ub182 qb182 Tp182 Qp182 Sp182 Rp182 Za182 _oa182", "GvfKZd"),
                    children: assets.map((asset)=>{
                        const { isLoading: isAssetLoading, progress: progress, isMissing: isMissing, isRequired: isRequired } = getState(asset);
                        if (isMissing) return /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$export$b734c53d98bc4c89, {
                            asset: asset,
                            isRequired: isRequired,
                            variant: "tile",
                            onUpload: onUpload
                        }, asset?.name);
                        return withTooltip(asset, /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$export$926e13577aad7fcb, {
                            asset: asset,
                            src: urlByPath?.get(asset?.filePath),
                            isLoading: isAssetLoading,
                            progress: progress,
                            colorScheme: colorScheme,
                            onEdit: onEdit
                        }, asset?.name));
                    })
                }),
                showBadge && /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$var$ReferenceBadge, {})
            ]
        })
    });
};
$68ba51a8e48a97b8$export$7a4d573f47324198.propTypes = {
    assets: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object),
    urlByPath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Map),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    progressByKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    skipImageLabeling: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isLabeled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    colorScheme: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number
    ]),
    showBadge: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    showProgressLabel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    showTooltips: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onUpload: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
const $68ba51a8e48a97b8$export$63bdc604ca2a66bb = ({ group: group, assets: assets, referenceUrlByPath: referenceUrlByPath, generatingKeys: generatingKeys, skipImageLabeling: skipImageLabeling, isLabeled: isLabeled, templateData: templateData, isLoading: isLoading, onEditVariation: onEditVariation, onRegenerate: onRegenerate, onUploadReference: onUploadReference })=>{
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    // Subscribed here rather than passed down: generation progress ticks often,
    // and only these cards render it.
    const progressByKey = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.imageVariationProgress);
    const variations = group?.variations ?? [];
    const referenceAssets = group?.referenceAssets ?? [];
    const hasReference = !!group?.hasReference;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " Na182 _ub182 _vb182 _sa182 sd182 _tpc182 _ta182 ed182 Ul182 ql182 _Pc182",
        children: [
            isDevMode && !!onRegenerate && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " _Pa182 Wg182 _zg182 _IqmMfn182",
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                    size: "XS",
                    staticColor: "auto",
                    onPress: ()=>onRegenerate(),
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j7E4C.default), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Regenerate"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " La182 si182 DT3R18c182 _Ca182 eb182 Ul182 ql182",
                style: {
                    width: `calc(240px * ${Math.min(variations.length + (hasReference ? 1 : 0), 4)} + ${2 * Math.min(variations.length + (hasReference ? 0 : -1), 3)}rem)`,
                    maxWidth: "100%"
                },
                children: [
                    hasReference && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " Zt182 La182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$export$7a4d573f47324198, {
                            assets: referenceAssets,
                            urlByPath: referenceUrlByPath,
                            isLoading: isLoading,
                            progressByKey: progressByKey,
                            skipImageLabeling: skipImageLabeling,
                            isLabeled: isLabeled,
                            templateData: templateData,
                            colorScheme: colorScheme,
                            onUpload: onUploadReference,
                            onEdit: (asset)=>onEditVariation?.({
                                    key: asset?.name,
                                    referenceKey: asset?.name,
                                    isReferenceAsset: true,
                                    type: "original",
                                    data: {
                                        ...asset?.labeling
                                    }
                                })
                        })
                    }),
                    variations.map((variation)=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " Zt182 La182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)($68ba51a8e48a97b8$export$7eb814a9cc90144, {
                                variation: variation,
                                asset: assets?.find((asset)=>asset.name === variation.key),
                                assets: assets,
                                isLoading: !!generatingKeys?.has(variation.key),
                                progress: progressByKey?.[variation.key],
                                isParentHovered: true,
                                onEdit: onEditVariation,
                                styles: " Za182"
                            })
                        }, variation.key))
                ]
            })
        ]
    });
};
$68ba51a8e48a97b8$export$63bdc604ca2a66bb.propTypes = {
    group: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        referenceKeys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
        referenceAssets: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object),
        variations: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object),
        hasReference: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
    }).isRequired,
    assets: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object),
    referenceUrlByPath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Map),
    generatingKeys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Set),
    skipImageLabeling: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isLabeled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onEditVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onRegenerate: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onUploadReference: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};

});
parcelRegister("fyTQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b64d1601ee4170f$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $4b64d1601ee4170f$var$$a08c59697b107c7a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M2 4h4v4H2zM10 12h-.693L6 9V8h4zM10 4h4v4h-4zM14 8h4v4h-4zM14 12.285l-4 1.175V12h4z",
                opacity: 0.35
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M14.5 7.521c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M3.25 4.5h13.5c.414 0 .75.337.75.75v8.21l-1.909-1.908c-.85-.85-2.333-.85-3.182 0l-1.232 1.231c-.097.098-.257.097-.354.001L7.591 9.552c-.85-.85-2.333-.85-3.182 0L2.5 11.46V5.25c0-.413.336-.75.75-.75m0 11c-.414 0-.75-.337-.75-.75v-1.168l2.97-2.97c.282-.283.777-.283 1.06 0l3.233 3.234c.682.68 1.792.682 2.474-.001l1.233-1.233c.282-.283.777-.283 1.06 0l2.701 2.701c-.131.112-.296.187-.481.187z"
            })
        ]
    });
const $4b64d1601ee4170f$var$$a08c59697b107c7a$var$ForwardRef = (0, $eF4cA.forwardRef)($4b64d1601ee4170f$var$$a08c59697b107c7a$var$SvgComponent);
var $4b64d1601ee4170f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($4b64d1601ee4170f$var$$a08c59697b107c7a$var$ForwardRef);

});

parcelRegister("9iR3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4e3e3beb28916e$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $2e4e3e3beb28916e$var$$9c47ca1864f32e19$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M4.749 18.004c-.398 0-.795-.108-1.153-.321C2.91 17.273 2.5 16.55 2.5 15.75V4.249c0-.799.41-1.521 1.096-1.932.685-.409 1.515-.43 2.219-.05L16.516 8.02C17.246 8.41 17.7 9.17 17.7 10s-.453 1.589-1.184 1.981L5.815 17.732c-.336.182-.702.272-1.066.272m.003-14.508c-.178 0-.318.068-.387.11-.11.065-.365.26-.365.643v11.502c0 .384.255.578.365.644s.402.198.74.017l10.7-5.75c.357-.193.395-.527.395-.662s-.038-.469-.394-.661L5.105 3.588c-.126-.067-.246-.092-.353-.092"
        })
    });
const $2e4e3e3beb28916e$var$$9c47ca1864f32e19$var$ForwardRef = (0, $eF4cA.forwardRef)($2e4e3e3beb28916e$var$$9c47ca1864f32e19$var$SvgComponent);
var $2e4e3e3beb28916e$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($2e4e3e3beb28916e$var$$9c47ca1864f32e19$var$ForwardRef);

});

parcelRegister("j7E4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a25916bc453058a9$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a25916bc453058a9$var$$adf9555bfc9c301b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M18.25 10h-1.5c0-1.327-.278-2.577-.763-3.68.644-.397 1.246-.853 1.784-1.375.298-.288.306-.762.018-1.06-.287-.298-.762-.306-1.06-.018-.444.43-.936.81-1.463 1.14C14.027 3.178 12.129 2 10 2S5.973 3.177 4.734 5.008c-.527-.331-1.02-.712-1.463-1.14-.297-.289-.772-.281-1.06.017s-.28.772.018 1.06c.538.522 1.14.978 1.784 1.375C3.528 7.423 3.25 8.673 3.25 10h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.623c.176 1.094.538 2.11 1.049 2.997-.955.643-1.751 1.443-2.312 2.362-.216.354-.104.815.25 1.03.121.076.256.111.389.111.253 0 .5-.128.64-.36.456-.744 1.111-1.395 1.901-1.92C6.508 17.128 8.17 18 10 18s3.492-.872 4.71-2.28c.79.525 1.445 1.176 1.9 1.92.141.232.388.36.641.36.133 0 .268-.035.39-.11.353-.216.465-.677.249-1.03-.56-.92-1.357-1.72-2.312-2.363.515-.894.878-1.918 1.052-3.021.04.007.078.024.12.024h1.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M10 3.5c1.562 0 2.962.853 3.925 2.198-1.217.516-2.555.802-3.925.802s-2.708-.286-3.925-.802C7.038 4.353 8.438 3.5 10 3.5M6.15 14.404c-.007-.014-.006-.03-.013-.043-.037-.067-.09-.118-.143-.169C5.22 13.06 4.75 11.597 4.75 10c0-1.078.216-2.093.593-2.989 1.218.538 2.543.865 3.907.954v8.46c-1.219-.217-2.302-.952-3.1-2.021m4.6 2.022V7.965c1.365-.089 2.689-.416 3.907-.954.377.896.593 1.911.593 2.989 0 1.598-.47 3.061-1.246 4.195-.052.05-.104.1-.14.166-.008.014-.007.029-.014.043-.798 1.07-1.881 1.804-3.1 2.022"
        })
    });
const $a25916bc453058a9$var$$adf9555bfc9c301b$var$ForwardRef = (0, $eF4cA.forwardRef)($a25916bc453058a9$var$$adf9555bfc9c301b$var$SvgComponent);
var $a25916bc453058a9$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($a25916bc453058a9$var$$adf9555bfc9c301b$var$ForwardRef);

});

parcelRegister("iKDEm", function(module, exports) {

$parcel$export(module.exports, "HoverState", () => $da6b4786b730fd56$export$9bffa5162b852fea);

var $dx4lB = parcelRequire("dx4lB");

var $j2JDe = parcelRequire("j2JDe");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $5nTep = parcelRequire("5nTep");

var $fmJ8d = parcelRequire("fmJ8d");
const $da6b4786b730fd56$var$hoverStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _lr182';
    rules += ' _Er182';
    rules += ' _Rr182';
    if (props.size === "default") rules += ' oc182';
    else if (props.size === "XL") rules += ' oe182';
    else if (props.size === "L") rules += ' oc182';
    else if (props.size === "M") rules += ' ob182';
    else if (props.size === "S") rules += ' oa182';
    if (props.size === "default") rules += ' nc182';
    else if (props.size === "XL") rules += ' ne182';
    else if (props.size === "L") rules += ' nc182';
    else if (props.size === "M") rules += ' nb182';
    else if (props.size === "S") rules += ' na182';
    if (props.size === "default") rules += ' kc182';
    else if (props.size === "XL") rules += ' ke182';
    else if (props.size === "L") rules += ' kc182';
    else if (props.size === "M") rules += ' kb182';
    else if (props.size === "S") rules += ' ka182';
    if (props.size === "default") rules += ' jc182';
    else if (props.size === "XL") rules += ' je182';
    else if (props.size === "L") rules += ' jc182';
    else if (props.size === "M") rules += ' jb182';
    else if (props.size === "S") rules += ' ja182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' _Mc182';
    rules += ' _Kb182';
    rules += ' _Lf182';
    if (props.allowsOutline) {
        if (props.isHovered) {
            if (props.isEmphasized) rules += ' Og30vFd182';
            else rules += ' OOIem5c182';
        } else rules += ' OSbZC3d182';
    } else rules += ' Oj182';
    if (props.isTinted) {
        if (props.colorScheme === "dark") rules += ' gYTfire182';
        else if (props.colorScheme === "light") rules += ' g6Lc5Le182';
    } else rules += ' g9182';
    if (props.isHovered) rules += ' _Ib182';
    else rules += ' _Ia182';
    rules += ' Ya182';
    rules += ' XCIisn182';
    rules += ' _2b182';
    rules += ' _89et5h182';
    return rules;
};
const $da6b4786b730fd56$export$9bffa5162b852fea = ({ children: children, showOutline: showOutline = true, isEmphasized: isEmphasized, isTinted: isTinted, renderBehavior: renderBehavior = "hover", size: size = "L", styles: styles })=>{
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        ...hoverProps,
        className: (0, $5nTep.mergeStyles)($da6b4786b730fd56$var$hoverStyles({
            isHovered: isHovered,
            size: size,
            allowsOutline: showOutline,
            isEmphasized: isEmphasized,
            isTinted: isTinted,
            renderBehavior: renderBehavior,
            colorScheme: colorScheme
        }), styles),
        children: typeof children === "function" ? children({
            isHovered: isHovered
        }) : renderBehavior === "always" || isHovered ? children : null
    });
};
$da6b4786b730fd56$export$9bffa5162b852fea.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    showOutline: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isEmphasized: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isTinted: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    renderBehavior: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "hover",
        "always"
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "S",
        "M",
        "L",
        "XL"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};

});

parcelRegister("6AUdR", function(module, exports) {

$parcel$export(module.exports, "resolveAsset", () => $4cd1b77d85a68a34$export$c60880f504524a89);
$parcel$export(module.exports, "resolveReferenceAssets", () => $4cd1b77d85a68a34$export$8fde8b6bacb51b75);
$parcel$export(module.exports, "getReferenceTitleParts", () => $4cd1b77d85a68a34$export$b150d91c6e031f3a);
$parcel$export(module.exports, "getReferenceTitle", () => $4cd1b77d85a68a34$export$4d9b04bb53ef0055);
$parcel$export(module.exports, "REFERENCE_KIND", () => $4cd1b77d85a68a34$export$7dd485210c685809);
$parcel$export(module.exports, "getMissingReferenceKind", () => $4cd1b77d85a68a34$export$578ff3e95adbd0e7);
$parcel$export(module.exports, "resolveVariation", () => $4cd1b77d85a68a34$export$337c1254227eed8b);
$parcel$export(module.exports, "resolveVariationAsset", () => $4cd1b77d85a68a34$export$39e8e7c2424087b7);
$parcel$export(module.exports, "resolveFallbackAsset", () => $4cd1b77d85a68a34$export$9bfd41fdf69e36f8);

var $lb17q = parcelRequire("lb17q");
const $4cd1b77d85a68a34$export$c60880f504524a89 = (assets, key)=>assets?.find((asset)=>asset.name === key) ?? {
        name: key
    };
const $4cd1b77d85a68a34$export$8fde8b6bacb51b75 = (assets, variation)=>(0, $lb17q.getVariationReferenceKeys)(variation).map((key)=>$4cd1b77d85a68a34$export$c60880f504524a89(assets, key));
const $4cd1b77d85a68a34$export$b150d91c6e031f3a = (asset, templateData)=>{
    const name = asset?.name;
    const label = templateData?.assets?.find((a)=>a.name === name)?.label ?? templateData?.imageVariations?.find((v)=>v.key === name)?.label;
    return {
        label: label && label !== name ? label : null,
        name: name
    };
};
const $4cd1b77d85a68a34$export$4d9b04bb53ef0055 = (asset, templateData)=>{
    const { label: label, name: name } = $4cd1b77d85a68a34$export$b150d91c6e031f3a(asset, templateData);
    return label ? `${label} (${name})` : name;
};
const $4cd1b77d85a68a34$export$7dd485210c685809 = {
    /** An image variation: it is generated, so it is only a matter of time. */ GENERATED: "generated",
    /** An optional template asset the user did not select. */ OPTIONAL: "optional",
    /** A required template asset the user has not selected. */ REQUIRED: "required"
};
const $4cd1b77d85a68a34$export$578ff3e95adbd0e7 = (key, templateData)=>{
    if (templateData?.imageVariations?.some((variation)=>variation.key === key)) return $4cd1b77d85a68a34$export$7dd485210c685809.GENERATED;
    const templateAsset = templateData?.assets?.find((asset)=>asset.name === key);
    return templateAsset && !templateAsset.isOptional ? $4cd1b77d85a68a34$export$7dd485210c685809.REQUIRED : $4cd1b77d85a68a34$export$7dd485210c685809.OPTIONAL;
};
const $4cd1b77d85a68a34$export$337c1254227eed8b = (templateData, videoData, key)=>({
        ...templateData?.assets?.find((asset)=>asset.name === key),
        ...templateData?.imageVariations?.find((variation)=>variation.key === key),
        ...videoData?.imageVariations?.find((variation)=>variation.key === key)
    });
const $4cd1b77d85a68a34$export$39e8e7c2424087b7 = (templateData, videoData, key)=>({
        ...videoData?.assets?.find((asset)=>asset.name === key),
        ...templateData?.assets?.find((asset)=>asset.name === key)
    });
const $4cd1b77d85a68a34$export$9bfd41fdf69e36f8 = (videoData, variation, asset)=>asset?.isSkipped ? videoData?.assets?.find((a)=>a.name === variation?.fallbackKey) ?? null : null;

});

parcelRegister("lRNYL", function(module, exports) {

$parcel$export(module.exports, "useUserRoles", () => $feb55102351c4b0a$export$ff989fa3ff87b5af);
$parcel$export(module.exports, "useHasRole", () => $feb55102351c4b0a$export$b0f27deeae9620c7);
$parcel$export(module.exports, "useIsAdmin", () => $feb55102351c4b0a$export$99a5e4bc80d231ca);
$parcel$export(module.exports, "useIsDevMode", () => $feb55102351c4b0a$export$4d0b7ef8917240a4);

var $5IZkx = parcelRequire("5IZkx");

var $fL0wx = parcelRequire("fL0wx");

var $fmJ8d = parcelRequire("fmJ8d");
const $feb55102351c4b0a$var$EMPTY_ROLES = [];
function $feb55102351c4b0a$export$ff989fa3ff87b5af({ ignoreOverride: ignoreOverride = false } = {}) {
    const user = (0, $fL0wx.useUserProfile)();
    const rolesDisabled = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.rolesDisabled);
    if (rolesDisabled && !ignoreOverride) return $feb55102351c4b0a$var$EMPTY_ROLES;
    return Array.isArray(user?.roles) ? user.roles : $feb55102351c4b0a$var$EMPTY_ROLES;
}
function $feb55102351c4b0a$export$b0f27deeae9620c7(roles, options) {
    const userRoles = $feb55102351c4b0a$export$ff989fa3ff87b5af(options);
    return userRoles.includes("admin") || [].concat(roles).some((role)=>userRoles.includes(role));
}
function $feb55102351c4b0a$export$99a5e4bc80d231ca(options) {
    return $feb55102351c4b0a$export$b0f27deeae9620c7("admin", options);
}
function $feb55102351c4b0a$export$4d0b7ef8917240a4() {
    const isAdmin = $feb55102351c4b0a$export$99a5e4bc80d231ca({
        ignoreOverride: true
    });
    const devModeOverride = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.devModeOverride);
    if (isAdmin && typeof devModeOverride === "boolean") return devModeOverride;
    return false;
}

});
parcelRegister("fL0wx", function(module, exports) {

$parcel$export(module.exports, "useIMS", () => $b78ba6ce034606f2$export$112c3f5c4d283ee6);
$parcel$export(module.exports, "useUserProfile", () => $b78ba6ce034606f2$export$c8308480b6dfe6db);
$parcel$export(module.exports, "getUserLdap", () => $b78ba6ce034606f2$export$8f07810b8f83f8cd);

var $eF4cA = parcelRequire("eF4cA");

var $4kcQz = parcelRequire("4kcQz");

var $5IZkx = parcelRequire("5IZkx");

var $iFEvA = parcelRequire("iFEvA");

var $8PkOq = parcelRequire("8PkOq");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");

var $fmJ8d = parcelRequire("fmJ8d");
const $b78ba6ce034606f2$var$imsClient = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/ims"]);
function $b78ba6ce034606f2$export$112c3f5c4d283ee6() {
    const [isSignedIn, setIsSignedIn] = (0, $eF4cA.useState)((0, $8PkOq.IMS).isSignedIn);
    const [userProfile, setUserProfile] = (0, $eF4cA.useState)((0, $8PkOq.IMS).userProfile);
    (0, $eF4cA.useEffect)(()=>{
        setIsSignedIn((0, $8PkOq.IMS).isSignedIn);
        setUserProfile((0, $8PkOq.IMS).userProfile);
        const interval = setInterval(()=>{
            const newIsSignedIn = (0, $8PkOq.IMS).isSignedIn;
            const newUserProfile = (0, $8PkOq.IMS).userProfile;
            if (newIsSignedIn !== isSignedIn) setIsSignedIn(newIsSignedIn);
            if (newUserProfile !== userProfile) setUserProfile(newUserProfile);
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        isSignedIn,
        userProfile
    ]);
    return {
        isSignedIn: isSignedIn,
        userProfile: userProfile,
        signIn: ()=>(0, $8PkOq.IMS).signIn(),
        signOut: ()=>(0, $8PkOq.IMS).signOut(),
        signUp: ()=>(0, $8PkOq.IMS).signUp(),
        getAccessToken: ()=>(0, $8PkOq.IMS).getAccessToken(),
        getUserProfile: ()=>(0, $8PkOq.IMS).getUserProfile()
    };
}
function $b78ba6ce034606f2$export$c8308480b6dfe6db() {
    const imsToken = (0, $5IZkx.useStore)((0, $fmJ8d.store), (s)=>s.ims?.token);
    const profileQuery = (0, $4kcQz.useQuery)({
        queryKey: [
            "user",
            "profile",
            imsToken
        ],
        enabled: !!imsToken,
        queryFn: async ()=>{
            const res = await $b78ba6ce034606f2$var$imsClient.get("/profile");
            if (!res.ok) throw new Error("Failed to load user profile");
            const backend = res.data?.profile ?? {};
            const roles = Array.isArray(backend.roles) ? backend.roles : [];
            return {
                ...backend,
                roles: roles,
                id: backend.userId ?? backend.id,
                fullName: backend.name ?? backend.fullName,
                firstName: backend.first_name ?? backend.firstName,
                lastName: backend.last_name ?? backend.lastName
            };
        }
    });
    const [profile, setProfile] = (0, $eF4cA.useState)(null);
    (0, $eF4cA.useEffect)(()=>{
        const imsState = (0, $fmJ8d.store).getState().ims;
        if (imsState?.profile) {
            const imsProfile = {
                ...imsState.profile
            };
            imsProfile.ldap = imsProfile.email.split("@")[0];
            setProfile(imsProfile);
            $iFEvA.setUser({
                username: imsProfile.fullName,
                email: imsProfile.email,
                ownerOrg: imsProfile.ownerOrg
            });
        }
        const unsubscribe = (0, $fmJ8d.store).subscribe((state)=>state.ims?.profile, (newProfile)=>{
            setProfile(newProfile);
        });
        return unsubscribe;
    }, []);
    return profile ? {
        ...profile,
        ...profileQuery.data
    } : null;
}
function $b78ba6ce034606f2$export$8f07810b8f83f8cd({ timeoutMs: timeoutMs = 10000 } = {}) {
    const ldapFromState = ()=>{
        const email = (0, $fmJ8d.store).getState().ims?.profile?.email;
        return email ? email.split("@")[0] : null;
    };
    const existing = ldapFromState();
    if (existing) return Promise.resolve(existing);
    return new Promise((resolve, reject)=>{
        const timer = setTimeout(()=>{
            unsubscribe();
            reject(new Error("Timed out waiting for user profile to load"));
        }, timeoutMs);
        const unsubscribe = (0, $fmJ8d.store).subscribe((state)=>state.ims?.profile?.email, (email)=>{
            if (email) {
                clearTimeout(timer);
                unsubscribe();
                resolve(email.split("@")[0]);
            }
        });
    });
}
function $b78ba6ce034606f2$export$3ccadd702407cbab() {
    const [token, setToken] = (0, $eF4cA.useState)(null);
    (0, $eF4cA.useEffect)(()=>{
        const imsState = (0, $fmJ8d.store).getState().ims;
        if (imsState?.token) setToken(imsState.token);
        const unsubscribe = (0, $fmJ8d.store).subscribe((state)=>state.ims?.token, (newToken)=>{
            setToken(newToken);
        });
        return unsubscribe;
    }, []);
    return token;
}
function $b78ba6ce034606f2$export$79c3258edc7d1573() {
    const [isLoggedIn, setIsLoggedIn] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(()=>{
        const imsState = (0, $fmJ8d.store).getState().ims;
        setIsLoggedIn(!!imsState?.token && !!imsState?.profile);
        const unsubscribe = (0, $fmJ8d.store).subscribe((state)=>state.isLoggedIn, (newIsLoggedIn)=>{
            setIsLoggedIn(newIsLoggedIn);
        });
        return unsubscribe;
    }, []);
    return isLoggedIn;
}

});
parcelRegister("iFEvA", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $d97b7a79a505747e$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $d97b7a79a505747e$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "setContext", () => $d97b7a79a505747e$export$2f04de43fe27971a);
$parcel$export(module.exports, "setUser", () => $d97b7a79a505747e$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "addEventProcessor", () => $d97b7a79a505747e$export$9aac0b9f77928fbf);
$parcel$export(module.exports, "startSession", () => $d97b7a79a505747e$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $d97b7a79a505747e$export$667e7b4d445d566b);

var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $2KiSw = parcelRequire("2KiSw");

var $cG2xs = parcelRequire("cG2xs");

var $9rdlm = parcelRequire("9rdlm");

var $ea5SN = parcelRequire("ea5SN");

var $59NSd = parcelRequire("59NSd");
function $d97b7a79a505747e$export$f5282963edea4a68(exception, hint) {
    return (0, $gqV7N.getCurrentScope)().captureException(exception, (0, $9rdlm.parseEventHintOrCaptureContext)(hint));
}
function $d97b7a79a505747e$export$45654777c133ae80(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $gqV7N.getCurrentScope)().captureMessage(message, level, hint);
}
function $d97b7a79a505747e$export$1462b974fdcf6ba2(event, hint) {
    return (0, $gqV7N.getCurrentScope)().captureEvent(event, hint);
}
function $d97b7a79a505747e$export$2f04de43fe27971a(name, context) {
    (0, $gqV7N.getIsolationScope)().setContext(name, context);
}
function $d97b7a79a505747e$export$bb4922da0dd51b92(extras) {
    (0, $gqV7N.getIsolationScope)().setExtras(extras);
}
function $d97b7a79a505747e$export$8e8e7789d42ed61d(key, extra) {
    (0, $gqV7N.getIsolationScope)().setExtra(key, extra);
}
function $d97b7a79a505747e$export$74a8fb34822092e6(tags) {
    (0, $gqV7N.getIsolationScope)().setTags(tags);
}
function $d97b7a79a505747e$export$a37d07ee78eb4569(key, value) {
    (0, $gqV7N.getIsolationScope)().setTag(key, value);
}
function $d97b7a79a505747e$export$74da2cba014bdc09(attributes) {
    (0, $gqV7N.getIsolationScope)().setAttributes(attributes);
}
function $d97b7a79a505747e$export$9fec4d97f1922e0b(key, value) {
    (0, $gqV7N.getIsolationScope)().setAttribute(key, value);
}
function $d97b7a79a505747e$export$8b6bb3dd62a01be2(user) {
    (0, $gqV7N.getIsolationScope)().setUser(user);
}
function $d97b7a79a505747e$export$58213391a19e392(conversationId) {
    (0, $gqV7N.getIsolationScope)().setConversationId(conversationId);
}
function $d97b7a79a505747e$export$5d4e9fd7fac8e617() {
    return (0, $gqV7N.getIsolationScope)().lastEventId();
}
async function $d97b7a79a505747e$export$4909b86c8034bf73(timeout) {
    const client = (0, $gqV7N.getClient)();
    if (client) return client.flush(timeout);
    (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $d97b7a79a505747e$export$8360e631d277ea4d(timeout) {
    const client = (0, $gqV7N.getClient)();
    if (client) return client.close(timeout);
    (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $d97b7a79a505747e$export$3f95c6f800b78024() {
    return !!(0, $gqV7N.getClient)();
}
function $d97b7a79a505747e$export$3b029eb57ac4d562() {
    const client = (0, $gqV7N.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $d97b7a79a505747e$export$9aac0b9f77928fbf(callback) {
    (0, $gqV7N.getIsolationScope)().addEventProcessor(callback);
}
function $d97b7a79a505747e$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $gqV7N.getIsolationScope)();
    const { user: user } = (0, $ea5SN.getCombinedScopeData)(isolationScope, (0, $gqV7N.getCurrentScope)());
    const { userAgent: userAgent } = (0, $59NSd.GLOBAL_OBJ).navigator || {};
    const session = (0, $2KiSw.makeSession)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $2KiSw.updateSession)(currentSession, {
        status: "exited"
    });
    $d97b7a79a505747e$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $d97b7a79a505747e$export$17a5be43989a0bc1() {
    const isolationScope = (0, $gqV7N.getIsolationScope)();
    const currentScope = (0, $gqV7N.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $2KiSw.closeSession)(session);
    $d97b7a79a505747e$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $d97b7a79a505747e$var$_sendSessionUpdate() {
    const isolationScope = (0, $gqV7N.getIsolationScope)();
    const client = (0, $gqV7N.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $d97b7a79a505747e$export$667e7b4d445d566b(end = false) {
    if (end) {
        $d97b7a79a505747e$export$17a5be43989a0bc1();
        return;
    }
    $d97b7a79a505747e$var$_sendSessionUpdate();
}

});
parcelRegister("gqV7N", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", () => $bf6b62d5ab580a20$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $bf6b62d5ab580a20$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $bf6b62d5ab580a20$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $bf6b62d5ab580a20$export$ec58d9285c204497);
$parcel$export(module.exports, "getClient", () => $bf6b62d5ab580a20$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $bf6b62d5ab580a20$export$1e83db7ee4876dc4);

var $1758c = parcelRequire("1758c");

var $4AWuw = parcelRequire("4AWuw");

var $8RAbX = parcelRequire("8RAbX");

var $61J4g = parcelRequire("61J4g");
let $bf6b62d5ab580a20$var$_externalPropagationContextProvider;
function $bf6b62d5ab580a20$export$b5defb3466e9689b(fn) {
    $bf6b62d5ab580a20$var$_externalPropagationContextProvider = fn;
}
function $bf6b62d5ab580a20$export$92547f779c920a71() {
    return $bf6b62d5ab580a20$var$_externalPropagationContextProvider?.();
}
function $bf6b62d5ab580a20$export$53f0ae651a1c4298() {
    return $bf6b62d5ab580a20$var$_externalPropagationContextProvider !== void 0;
}
function $bf6b62d5ab580a20$export$c7be4b0125a10cba() {
    const carrier = (0, $4AWuw.getMainCarrier)();
    const acs = (0, $1758c.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
function $bf6b62d5ab580a20$export$68f3af03034c9e90() {
    const carrier = (0, $4AWuw.getMainCarrier)();
    const acs = (0, $1758c.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
function $bf6b62d5ab580a20$export$aa55d5ab8e05984f() {
    return (0, $4AWuw.getGlobalSingleton)("globalScope", ()=>new (0, $8RAbX.Scope)());
}
function $bf6b62d5ab580a20$export$ec58d9285c204497(...rest) {
    const carrier = (0, $4AWuw.getMainCarrier)();
    const acs = (0, $1758c.getAsyncContextStrategy)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $bf6b62d5ab580a20$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $4AWuw.getMainCarrier)();
    const acs = (0, $1758c.getAsyncContextStrategy)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $bf6b62d5ab580a20$export$6bb76d6eba7e258c() {
    return $bf6b62d5ab580a20$export$c7be4b0125a10cba().getClient();
}
function $bf6b62d5ab580a20$export$1e83db7ee4876dc4(scope) {
    const externalContext = $bf6b62d5ab580a20$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $61J4g.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("1758c", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", () => $0cfa6cd823c1de85$export$f639b0c2752203be);

var $4AWuw = parcelRequire("4AWuw");

var $9RRBX = parcelRequire("9RRBX");
function $0cfa6cd823c1de85$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $4AWuw.getMainCarrier)();
    const sentry = (0, $4AWuw.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
function $0cfa6cd823c1de85$export$f639b0c2752203be(carrier) {
    const sentry = (0, $4AWuw.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $9RRBX.getStackAsyncContextStrategy)();
}

});
parcelRegister("4AWuw", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $3587e5612caf298d$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $3587e5612caf298d$export$c8bfa33e4e8ae492);
$parcel$export(module.exports, "getGlobalSingleton", () => $3587e5612caf298d$export$7e223ec222791509);

var $a6Xop = parcelRequire("a6Xop");

var $59NSd = parcelRequire("59NSd");
function $3587e5612caf298d$export$19eade501500c6c1() {
    $3587e5612caf298d$export$c8bfa33e4e8ae492((0, $59NSd.GLOBAL_OBJ));
    return 0, $59NSd.GLOBAL_OBJ;
}
function $3587e5612caf298d$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $a6Xop.SDK_VERSION);
    return __SENTRY__[0, $a6Xop.SDK_VERSION] = __SENTRY__[0, $a6Xop.SDK_VERSION] || {};
}
function $3587e5612caf298d$export$7e223ec222791509(name, creator, obj = (0, $59NSd.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $a6Xop.SDK_VERSION] = __SENTRY__[0, $a6Xop.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("a6Xop", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $75c889164213c1c1$export$31499a9cd224b78c);
const $75c889164213c1c1$export$31499a9cd224b78c = "10.77.1";

});

parcelRegister("59NSd", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $3c147ad48c2aa9a5$export$f1a6cdb1459e81d1);
const $3c147ad48c2aa9a5$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("9RRBX", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $72f2a663f3f27c1d$export$329d4d4d54e42710);

var $7jkdF = parcelRequire("7jkdF");

var $8RAbX = parcelRequire("8RAbX");

var $HF1Wb = parcelRequire("HF1Wb");

var $exje8 = parcelRequire("exje8");

var $4AWuw = parcelRequire("4AWuw");
class $72f2a663f3f27c1d$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $8RAbX.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $8RAbX.Scope)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $exje8.isThenable)(maybePromiseResult)) return (0, $HF1Wb.chainAndCopyPromiseLike)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $72f2a663f3f27c1d$var$getAsyncContextStack() {
    const registry = (0, $4AWuw.getMainCarrier)();
    const sentry = (0, $4AWuw.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $72f2a663f3f27c1d$export$d36ec451f120cfba((0, $7jkdF.getDefaultCurrentScope)(), (0, $7jkdF.getDefaultIsolationScope)());
}
function $72f2a663f3f27c1d$var$withScope(callback) {
    return $72f2a663f3f27c1d$var$getAsyncContextStack().withScope(callback);
}
function $72f2a663f3f27c1d$var$withSetScope(scope, callback) {
    const stack = $72f2a663f3f27c1d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $72f2a663f3f27c1d$var$withIsolationScope(callback) {
    return $72f2a663f3f27c1d$var$getAsyncContextStack().withScope(()=>{
        return callback($72f2a663f3f27c1d$var$getAsyncContextStack().getIsolationScope());
    });
}
function $72f2a663f3f27c1d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $72f2a663f3f27c1d$var$withIsolationScope,
        withScope: $72f2a663f3f27c1d$var$withScope,
        withSetScope: $72f2a663f3f27c1d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $72f2a663f3f27c1d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$72f2a663f3f27c1d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$72f2a663f3f27c1d$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("7jkdF", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", () => $5529fde5bf38bb83$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $5529fde5bf38bb83$export$de9862929b76bf57);

var $4AWuw = parcelRequire("4AWuw");

var $8RAbX = parcelRequire("8RAbX");
function $5529fde5bf38bb83$export$6f1b9191db9c4d5() {
    return (0, $4AWuw.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, $8RAbX.Scope)());
}
function $5529fde5bf38bb83$export$de9862929b76bf57() {
    return (0, $4AWuw.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, $8RAbX.Scope)());
}

});
parcelRegister("8RAbX", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $673f58e885e80c5f$export$775b6bb06e53a214);

var $dn9bA = parcelRequire("dn9bA");

var $2KiSw = parcelRequire("2KiSw");

var $cG2xs = parcelRequire("cG2xs");

var $exje8 = parcelRequire("exje8");

var $aje4A = parcelRequire("aje4A");

var $1nf4J = parcelRequire("1nf4J");

var $61J4g = parcelRequire("61J4g");

var $55uN4 = parcelRequire("55uN4");

var $1Wbj3 = parcelRequire("1Wbj3");

var $byQav = parcelRequire("byQav");

var $c5ls6 = parcelRequire("c5ls6");
const $673f58e885e80c5f$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $673f58e885e80c5f$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $61J4g.generateTraceId)(),
            sampleRand: (0, $55uN4.safeMathRandom)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $673f58e885e80c5f$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $1Wbj3._setSpanForScope)(newScope, (0, $1Wbj3._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $2KiSw.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $673f58e885e80c5f$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $exje8.isPlainObject)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $1Wbj3._setSpanForScope)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $61J4g.generateTraceId)(),
            sampleRand: (0, $55uN4.safeMathRandom)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $673f58e885e80c5f$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $c5ls6.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $byQav.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $1Wbj3._getSpanForScope)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $aje4A.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $1nf4J.uuid4)();
        if (!this._client) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $1nf4J.uuid4)();
        if (!this._client) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $1nf4J.uuid4)();
        if (!this._client) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("dn9bA", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $02832b8e3d237307$export$16a28057038b10ef);
const $02832b8e3d237307$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("2KiSw", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $1ffe85845d504ee0$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $1ffe85845d504ee0$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $1ffe85845d504ee0$export$56521d9ba90f62ee);

var $1nf4J = parcelRequire("1nf4J");

var $c5ls6 = parcelRequire("c5ls6");
function $1ffe85845d504ee0$export$14a186326edbb264(context) {
    const startingTime = (0, $c5ls6.timestampInSeconds)();
    const session = {
        sid: (0, $1nf4J.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$1ffe85845d504ee0$var$sessionToJSON(session)
    };
    if (context) $1ffe85845d504ee0$export$531818e825e774db(session, context);
    return session;
}
function $1ffe85845d504ee0$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $c5ls6.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $1nf4J.uuid4)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $1ffe85845d504ee0$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $1ffe85845d504ee0$export$531818e825e774db(session, context);
}
function $1ffe85845d504ee0$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("1nf4J", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $1003a211be6fede5$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $1003a211be6fede5$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $1003a211be6fede5$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $1003a211be6fede5$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $1003a211be6fede5$export$6de4ffac6a2f1098);

var $6i9K0 = parcelRequire("6i9K0");

var $55uN4 = parcelRequire("55uN4");

var $byQav = parcelRequire("byQav");

var $59NSd = parcelRequire("59NSd");
function $1003a211be6fede5$var$getCrypto() {
    const gbl = (0, $59NSd.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
let $1003a211be6fede5$var$emptyUuid;
function $1003a211be6fede5$var$getRandomByte() {
    return (0, $55uN4.safeMathRandom)() * 16;
}
function $1003a211be6fede5$export$19f53698e68b2496(crypto = $1003a211be6fede5$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $55uN4.withRandomSafeContext)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$1003a211be6fede5$var$emptyUuid) $1003a211be6fede5$var$emptyUuid = "10000000100040008000100000000000";
    return $1003a211be6fede5$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($1003a211be6fede5$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $1003a211be6fede5$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $1003a211be6fede5$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $1003a211be6fede5$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $1003a211be6fede5$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $1003a211be6fede5$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $1003a211be6fede5$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $1003a211be6fede5$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $1003a211be6fede5$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $1003a211be6fede5$export$d364f2020ab30578(input) {
    const match = input.match($1003a211be6fede5$var$SEMVER_REGEXP) || [];
    const major = $1003a211be6fede5$var$_parseInt(match[1]);
    const minor = $1003a211be6fede5$var$_parseInt(match[2]);
    const patch = $1003a211be6fede5$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $1003a211be6fede5$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $byQav.snipLine)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $byQav.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $byQav.snipLine)(line, 0));
}
function $1003a211be6fede5$export$6de4ffac6a2f1098(exception) {
    if ($1003a211be6fede5$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $6i9K0.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $1003a211be6fede5$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}

});
parcelRegister("6i9K0", function(module, exports) {

$parcel$export(module.exports, "fill", () => $494bfae64aae72e1$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $494bfae64aae72e1$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $494bfae64aae72e1$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $494bfae64aae72e1$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $494bfae64aae72e1$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $494bfae64aae72e1$export$b0244d5063c0b61b);

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $exje8 = parcelRequire("exje8");
function $494bfae64aae72e1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $494bfae64aae72e1$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $494bfae64aae72e1$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $494bfae64aae72e1$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $494bfae64aae72e1$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $494bfae64aae72e1$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($494bfae64aae72e1$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $494bfae64aae72e1$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $494bfae64aae72e1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $494bfae64aae72e1$export$62ff257738bf57f5(value) {
    if ((0, $exje8.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$494bfae64aae72e1$var$getOwnProperties(value)
    };
    if ((0, $exje8.isEvent)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$494bfae64aae72e1$var$getOwnProperties(value)
        };
    }
    return value;
}
function $494bfae64aae72e1$var$getOwnProperties(obj) {
    if ((0, $exje8.isObjectLike)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $494bfae64aae72e1$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($494bfae64aae72e1$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $494bfae64aae72e1$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $494bfae64aae72e1$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $494bfae64aae72e1$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($494bfae64aae72e1$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($494bfae64aae72e1$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $494bfae64aae72e1$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $494bfae64aae72e1$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $494bfae64aae72e1$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $exje8.isPrimitive)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("cG2xs", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $93ab60617757e8bc$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $93ab60617757e8bc$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $93ab60617757e8bc$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "debug", () => $93ab60617757e8bc$export$1c9f709888824e05);

var $4AWuw = parcelRequire("4AWuw");

var $dn9bA = parcelRequire("dn9bA");

var $59NSd = parcelRequire("59NSd");
const $93ab60617757e8bc$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $93ab60617757e8bc$var$PREFIX = "Sentry Logger ";
const $93ab60617757e8bc$export$77c4ce905194557b = {};
function $93ab60617757e8bc$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $59NSd.GLOBAL_OBJ))) return callback();
    const console = (0, $59NSd.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($93ab60617757e8bc$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $93ab60617757e8bc$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $93ab60617757e8bc$var$enable() {
    $93ab60617757e8bc$var$_getLoggerSettings().enabled = true;
}
function $93ab60617757e8bc$var$disable() {
    $93ab60617757e8bc$var$_getLoggerSettings().enabled = false;
}
function $93ab60617757e8bc$var$isEnabled() {
    return $93ab60617757e8bc$var$_getLoggerSettings().enabled;
}
function $93ab60617757e8bc$var$log(...args) {
    $93ab60617757e8bc$var$_maybeLog("log", ...args);
}
function $93ab60617757e8bc$var$warn(...args) {
    $93ab60617757e8bc$var$_maybeLog("warn", ...args);
}
function $93ab60617757e8bc$var$error(...args) {
    $93ab60617757e8bc$var$_maybeLog("error", ...args);
}
function $93ab60617757e8bc$var$_maybeLog(level, ...args) {
    if (!(0, $dn9bA.DEBUG_BUILD)) return;
    if ($93ab60617757e8bc$var$isEnabled()) $93ab60617757e8bc$export$cda52e2a8927a2ca(()=>{
        (0, $59NSd.GLOBAL_OBJ).console[level](`${$93ab60617757e8bc$var$PREFIX}[${level}]:`, ...args);
    });
}
function $93ab60617757e8bc$var$_getLoggerSettings() {
    if (!(0, $dn9bA.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $4AWuw.getGlobalSingleton)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $93ab60617757e8bc$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $93ab60617757e8bc$var$enable,
    disable: /** Disable logging. */ $93ab60617757e8bc$var$disable,
    isEnabled: /** Check if logging is enabled. */ $93ab60617757e8bc$var$isEnabled,
    log: /** Log a message. */ $93ab60617757e8bc$var$log,
    warn: /** Log a warning. */ $93ab60617757e8bc$var$warn,
    error: /** Log an error. */ $93ab60617757e8bc$var$error
};

});

parcelRegister("exje8", function(module, exports) {

$parcel$export(module.exports, "isError", () => $a9530fd3074b8cb4$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isErrorEvent", () => $a9530fd3074b8cb4$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $a9530fd3074b8cb4$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $a9530fd3074b8cb4$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $a9530fd3074b8cb4$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $a9530fd3074b8cb4$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $a9530fd3074b8cb4$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $a9530fd3074b8cb4$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isObjectLike", () => $a9530fd3074b8cb4$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isEvent", () => $a9530fd3074b8cb4$export$9671ea99bd126ace);
$parcel$export(module.exports, "isRegExp", () => $a9530fd3074b8cb4$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $a9530fd3074b8cb4$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isRequest", () => $a9530fd3074b8cb4$export$6d3d1f317d7cda57);
const $a9530fd3074b8cb4$var$objectToString = Object.prototype.toString;
function $a9530fd3074b8cb4$export$e6127cc7fe7395c3(wat) {
    switch($a9530fd3074b8cb4$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $a9530fd3074b8cb4$export$49034edbe6b62415(wat, Error);
    }
}
function $a9530fd3074b8cb4$var$isBuiltin(wat, className) {
    return $a9530fd3074b8cb4$var$objectToString.call(wat) === `[object ${className}]`;
}
function $a9530fd3074b8cb4$export$9f9636d330b71954(wat) {
    return $a9530fd3074b8cb4$var$isBuiltin(wat, "ErrorEvent");
}
function $a9530fd3074b8cb4$export$ef9e2056653f0c8e(wat) {
    return $a9530fd3074b8cb4$var$isBuiltin(wat, "DOMError");
}
function $a9530fd3074b8cb4$export$12e869b2a583f783(wat) {
    return $a9530fd3074b8cb4$var$isBuiltin(wat, "DOMException");
}
function $a9530fd3074b8cb4$export$844ec244b1367d54(wat) {
    return $a9530fd3074b8cb4$var$isBuiltin(wat, "String");
}
function $a9530fd3074b8cb4$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $a9530fd3074b8cb4$export$c3825b437cbdea5c(wat) {
    return wat === null || $a9530fd3074b8cb4$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $a9530fd3074b8cb4$export$53b83ca8eaab0383(wat) {
    return $a9530fd3074b8cb4$var$isBuiltin(wat, "Object");
}
function $a9530fd3074b8cb4$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $a9530fd3074b8cb4$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $a9530fd3074b8cb4$export$49034edbe6b62415(wat, Event);
}
function $a9530fd3074b8cb4$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $a9530fd3074b8cb4$export$49034edbe6b62415(wat, Element);
}
function $a9530fd3074b8cb4$export$49841c62b9eff15(wat) {
    return $a9530fd3074b8cb4$var$isBuiltin(wat, "RegExp");
}
function $a9530fd3074b8cb4$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $a9530fd3074b8cb4$export$bc2894c7158efbac(wat) {
    return $a9530fd3074b8cb4$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $a9530fd3074b8cb4$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $a9530fd3074b8cb4$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $a9530fd3074b8cb4$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $a9530fd3074b8cb4$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("55uN4", function(module, exports) {

$parcel$export(module.exports, "withRandomSafeContext", () => $3b454db71fb5b37b$export$ff239213cb80e2da);
$parcel$export(module.exports, "safeMathRandom", () => $3b454db71fb5b37b$export$9869d72de32a3917);
$parcel$export(module.exports, "safeDateNow", () => $3b454db71fb5b37b$export$65b1bada40c91b34);

var $59NSd = parcelRequire("59NSd");
let $3b454db71fb5b37b$var$RESOLVED_RUNNER;
function $3b454db71fb5b37b$export$ff239213cb80e2da(cb) {
    if ($3b454db71fb5b37b$var$RESOLVED_RUNNER !== void 0) return $3b454db71fb5b37b$var$RESOLVED_RUNNER ? $3b454db71fb5b37b$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $59NSd.GLOBAL_OBJ);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $3b454db71fb5b37b$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $3b454db71fb5b37b$var$RESOLVED_RUNNER(cb);
    }
    $3b454db71fb5b37b$var$RESOLVED_RUNNER = null;
    return cb();
}
function $3b454db71fb5b37b$export$9869d72de32a3917() {
    return $3b454db71fb5b37b$export$ff239213cb80e2da(()=>Math.random());
}
function $3b454db71fb5b37b$export$65b1bada40c91b34() {
    return $3b454db71fb5b37b$export$ff239213cb80e2da(()=>Date.now());
}

});

parcelRegister("byQav", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $86ab563a42a35bf2$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $86ab563a42a35bf2$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $86ab563a42a35bf2$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $86ab563a42a35bf2$export$cdded5b28a5f8c6d);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $86ab563a42a35bf2$export$a7a5ec66062ea5d);

var $exje8 = parcelRequire("exje8");

var $fuLLi = parcelRequire("fuLLi");
function $86ab563a42a35bf2$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $86ab563a42a35bf2$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $86ab563a42a35bf2$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $86ab563a42a35bf2$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $exje8.isPrimitive)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $fuLLi.stringifyValue)(void 0, value));
    }
    return output.join(delimiter);
}
function $86ab563a42a35bf2$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $exje8.isString)(value)) return false;
    if ((0, $exje8.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $exje8.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $86ab563a42a35bf2$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($86ab563a42a35bf2$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}

});
parcelRegister("fuLLi", function(module, exports) {

$parcel$export(module.exports, "setNormalizeStringifier", () => $b47eb4de8a516fed$export$575c40989754ba4d);
$parcel$export(module.exports, "normalize", () => $b47eb4de8a516fed$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $b47eb4de8a516fed$export$23fbbb20bed71033);
$parcel$export(module.exports, "stringifyValue", () => $b47eb4de8a516fed$export$a110e5bc79f44a84);

var $cYp1A = parcelRequire("cYp1A");

var $6i9K0 = parcelRequire("6i9K0");

var $eAGoL = parcelRequire("eAGoL");
let $b47eb4de8a516fed$var$stringifier;
function $b47eb4de8a516fed$export$575c40989754ba4d(newStringifier) {
    $b47eb4de8a516fed$var$stringifier = newStringifier;
}
function $b47eb4de8a516fed$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $b47eb4de8a516fed$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $b47eb4de8a516fed$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $b47eb4de8a516fed$export$a3295358bff77e(object, depth);
    if ($b47eb4de8a516fed$var$jsonSize(normalized) > maxSize) return $b47eb4de8a516fed$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $b47eb4de8a516fed$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $b47eb4de8a516fed$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $b47eb4de8a516fed$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $cYp1A.hasSkipNormalizationHint)(value)) return value;
    const overrideDepth = (0, $cYp1A.getNormalizationDepthOverrideHint)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $b47eb4de8a516fed$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $6i9K0.convertToPlainObject)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $b47eb4de8a516fed$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $b47eb4de8a516fed$export$a110e5bc79f44a84(key, value) {
    try {
        if ($b47eb4de8a516fed$var$stringifier) {
            const stringified = $b47eb4de8a516fed$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $eAGoL.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $b47eb4de8a516fed$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $b47eb4de8a516fed$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $b47eb4de8a516fed$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $b47eb4de8a516fed$var$jsonSize(value) {
    return $b47eb4de8a516fed$var$utf8Length(JSON.stringify(value));
}
function $b47eb4de8a516fed$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $b47eb4de8a516fed$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("cYp1A", function(module, exports) {

$parcel$export(module.exports, "hasSkipNormalizationHint", () => $971e80008219bd39$export$c8d26b7b28f926c7);
$parcel$export(module.exports, "getNormalizationDepthOverrideHint", () => $971e80008219bd39$export$fe95a19841c4b155);

var $6i9K0 = parcelRequire("6i9K0");
const $971e80008219bd39$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $971e80008219bd39$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $971e80008219bd39$export$280812de8e91ea53(obj) {
    (0, $6i9K0.addNonEnumerableProperty)(obj, $971e80008219bd39$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $971e80008219bd39$export$610d1422c4bdc4c1(obj, depth) {
    (0, $6i9K0.addNonEnumerableProperty)(obj, $971e80008219bd39$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $971e80008219bd39$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$971e80008219bd39$var$SENTRY_SKIP_NORMALIZATION]);
}
function $971e80008219bd39$export$fe95a19841c4b155(value) {
    const v = value[$971e80008219bd39$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}

});

parcelRegister("eAGoL", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $a9f550f1b3da1714$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $a9f550f1b3da1714$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $a9f550f1b3da1714$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $a9f550f1b3da1714$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $a9f550f1b3da1714$export$91d8ca51bd9f6a47);
$parcel$export(module.exports, "normalizeStackTracePath", () => $a9f550f1b3da1714$export$60c0d6c8e038267a);
const $a9f550f1b3da1714$var$STACKTRACE_FRAME_LIMIT = 50;
const $a9f550f1b3da1714$export$27c7e15d453fc0ac = "?";
const $a9f550f1b3da1714$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $a9f550f1b3da1714$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $a9f550f1b3da1714$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $a9f550f1b3da1714$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($a9f550f1b3da1714$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $a9f550f1b3da1714$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $a9f550f1b3da1714$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $a9f550f1b3da1714$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $a9f550f1b3da1714$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $a9f550f1b3da1714$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($a9f550f1b3da1714$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($a9f550f1b3da1714$var$STRIP_FRAME_REGEXP.test($a9f550f1b3da1714$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($a9f550f1b3da1714$var$STRIP_FRAME_REGEXP.test($a9f550f1b3da1714$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $a9f550f1b3da1714$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $a9f550f1b3da1714$var$getLastStackFrame(localStack).filename,
            function: frame.function || $a9f550f1b3da1714$export$27c7e15d453fc0ac
        }));
}
function $a9f550f1b3da1714$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $a9f550f1b3da1714$var$defaultFunctionName = "<anonymous>";
function $a9f550f1b3da1714$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $a9f550f1b3da1714$var$defaultFunctionName;
        return fn.name || $a9f550f1b3da1714$var$defaultFunctionName;
    } catch  {
        return $a9f550f1b3da1714$var$defaultFunctionName;
    }
}
function $a9f550f1b3da1714$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $a9f550f1b3da1714$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}

});




parcelRegister("c5ls6", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $8cc697a343ccc79b$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $8cc697a343ccc79b$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $8cc697a343ccc79b$export$baf075a948ffc0bf);

var $55uN4 = parcelRequire("55uN4");

var $59NSd = parcelRequire("59NSd");
const $8cc697a343ccc79b$var$ONE_SECOND_IN_MS = 1e3;
function $8cc697a343ccc79b$export$7740643b9eeaf0c4() {
    return (0, $55uN4.safeDateNow)() / $8cc697a343ccc79b$var$ONE_SECOND_IN_MS;
}
function $8cc697a343ccc79b$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $59NSd.GLOBAL_OBJ);
    if (!performance?.now || !performance.timeOrigin) return $8cc697a343ccc79b$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $55uN4.withRandomSafeContext)(()=>performance.now())) / $8cc697a343ccc79b$var$ONE_SECOND_IN_MS;
    };
}
let $8cc697a343ccc79b$var$_cachedTimestampInSeconds;
function $8cc697a343ccc79b$export$ee52dced521e3e18() {
    const func = $8cc697a343ccc79b$var$_cachedTimestampInSeconds ?? ($8cc697a343ccc79b$var$_cachedTimestampInSeconds = $8cc697a343ccc79b$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $8cc697a343ccc79b$var$cachedTimeOrigin = null;
function $8cc697a343ccc79b$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $59NSd.GLOBAL_OBJ);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $55uN4.withRandomSafeContext)(()=>performance.now());
    const dateNow = (0, $55uN4.safeDateNow)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $8cc697a343ccc79b$export$baf075a948ffc0bf() {
    if ($8cc697a343ccc79b$var$cachedTimeOrigin === null) $8cc697a343ccc79b$var$cachedTimeOrigin = $8cc697a343ccc79b$var$getBrowserTimeOrigin();
    return $8cc697a343ccc79b$var$cachedTimeOrigin;
}

});


parcelRegister("aje4A", function(module, exports) {

$parcel$export(module.exports, "merge", () => $78169859bcfa574c$export$4950aa0f605343fb);
function $78169859bcfa574c$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $78169859bcfa574c$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("61J4g", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", () => $4635cb96ac66e646$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $4635cb96ac66e646$export$295213bc4d0c54ad);

var $1nf4J = parcelRequire("1nf4J");
function $4635cb96ac66e646$export$dc6d7ea554bcce10() {
    return (0, $1nf4J.uuid4)();
}
function $4635cb96ac66e646$export$295213bc4d0c54ad() {
    return (0, $1nf4J.uuid4)().substring(16);
}

});

parcelRegister("1Wbj3", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", () => $1693fa6bf5dd068d$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $1693fa6bf5dd068d$export$91f063ebb8eff307);

var $6i9K0 = parcelRequire("6i9K0");

var $hxbjp = parcelRequire("hxbjp");
const $1693fa6bf5dd068d$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $1693fa6bf5dd068d$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $6i9K0.addNonEnumerableProperty)(scope, $1693fa6bf5dd068d$var$SCOPE_SPAN_FIELD, (0, $hxbjp.makeWeakRef)(span));
    else delete scope[$1693fa6bf5dd068d$var$SCOPE_SPAN_FIELD];
}
function $1693fa6bf5dd068d$export$91f063ebb8eff307(scope) {
    return (0, $hxbjp.derefWeakRef)(scope[$1693fa6bf5dd068d$var$SCOPE_SPAN_FIELD]);
}

});
parcelRegister("hxbjp", function(module, exports) {

$parcel$export(module.exports, "makeWeakRef", () => $cc3e4b1668934248$export$f0b98edec95fcb33);
$parcel$export(module.exports, "derefWeakRef", () => $cc3e4b1668934248$export$a0592ad8c3586cf);

var $59NSd = parcelRequire("59NSd");
function $cc3e4b1668934248$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $59NSd.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $cc3e4b1668934248$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}

});




parcelRegister("HF1Wb", function(module, exports) {

$parcel$export(module.exports, "chainAndCopyPromiseLike", () => $0833d805132886fa$export$64da0f40b0f924ba);
const $0833d805132886fa$var$isActualPromise = (p)=>p instanceof Promise && !p[$0833d805132886fa$var$kChainedCopy];
const $0833d805132886fa$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $0833d805132886fa$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $0833d805132886fa$var$isActualPromise(chained) && $0833d805132886fa$var$isActualPromise(original) ? chained : $0833d805132886fa$var$copyProps(original, chained);
};
const $0833d805132886fa$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$0833d805132886fa$var$kChainedCopy]: true
    });
    return chained;
};

});




parcelRegister("9rdlm", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $6df0fc65af694976$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $6df0fc65af694976$export$76b5f966996d1653);

var $7LgVW = parcelRequire("7LgVW");

var $9MjTE = parcelRequire("9MjTE");

var $8RAbX = parcelRequire("8RAbX");

var $jhUXm = parcelRequire("jhUXm");

var $auwZv = parcelRequire("auwZv");

var $1nf4J = parcelRequire("1nf4J");

var $fuLLi = parcelRequire("fuLLi");

var $ea5SN = parcelRequire("ea5SN");

var $byQav = parcelRequire("byQav");

var $j3ztq = parcelRequire("j3ztq");

var $c5ls6 = parcelRequire("c5ls6");
function $6df0fc65af694976$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $1nf4J.uuid4)(),
        timestamp: event.timestamp || (0, $c5ls6.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $6df0fc65af694976$export$d7e04067a6fbc882(prepared, options);
    $6df0fc65af694976$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $6df0fc65af694976$export$63042efc86f043e7(prepared, options.stackParser);
    const finalScope = $6df0fc65af694976$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $1nf4J.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = (0, $ea5SN.getCombinedScopeData)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $ea5SN.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $auwZv.isInternalException)(hint) ? (0, $j3ztq.resolvedSyncPromise)(prepared) : (0, $9MjTE.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) $6df0fc65af694976$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $6df0fc65af694976$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $6df0fc65af694976$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || (0, $7LgVW.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $byQav.truncate)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = (0, $byQav.truncate)(exception.value, maxValueLength);
    });
}
function $6df0fc65af694976$export$63042efc86f043e7(event, stackParser) {
    const filenameDebugIdMap = (0, $jhUXm.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $6df0fc65af694976$export$1be657ba8ef44ff0(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $6df0fc65af694976$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $6df0fc65af694976$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $fuLLi.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $fuLLi.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $fuLLi.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $fuLLi.normalize)(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $fuLLi.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $fuLLi.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $fuLLi.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $6df0fc65af694976$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $8RAbX.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
function $6df0fc65af694976$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($6df0fc65af694976$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($6df0fc65af694976$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $6df0fc65af694976$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $8RAbX.Scope) || typeof hint === "function";
}
const $6df0fc65af694976$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $6df0fc65af694976$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$6df0fc65af694976$var$captureContextKeys.includes(key));
}

});
parcelRegister("7LgVW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $5a6a0ed9444b5aad$export$849dbeeeda01ae98);
const $5a6a0ed9444b5aad$export$849dbeeeda01ae98 = "production";
const $5a6a0ed9444b5aad$export$6829f580e78306fa = "development";

});

parcelRegister("9MjTE", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", () => $71e807cde4b5741c$export$bf2a096c3e883e79);

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $exje8 = parcelRequire("exje8");

var $j3ztq = parcelRequire("j3ztq");
function $71e807cde4b5741c$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $71e807cde4b5741c$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $exje8.isThenable)(result) ? result : (0, $j3ztq.resolvedSyncPromise)(result);
    } catch (error) {
        return (0, $j3ztq.rejectedSyncPromise)(error);
    }
}
function $71e807cde4b5741c$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $dn9bA.DEBUG_BUILD) && result === null && (0, $cG2xs.debug).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, $exje8.isThenable)(result)) return result.then((final)=>$71e807cde4b5741c$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $71e807cde4b5741c$var$_notifyEventProcessors(result, hint, processors, index + 1);
}

});
parcelRegister("j3ztq", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $ddf9d070347b1443$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "rejectedSyncPromise", () => $ddf9d070347b1443$export$78e43115b553f358);

var $exje8 = parcelRequire("exje8");
const $ddf9d070347b1443$var$STATE_PENDING = 0;
const $ddf9d070347b1443$var$STATE_RESOLVED = 1;
const $ddf9d070347b1443$var$STATE_REJECTED = 2;
function $ddf9d070347b1443$export$1fda8aa4d135f8aa(value) {
    return new $ddf9d070347b1443$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
function $ddf9d070347b1443$export$78e43115b553f358(reason) {
    return new $ddf9d070347b1443$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
class $ddf9d070347b1443$export$6f292d4960313241 {
    constructor(executor){
        this._state = $ddf9d070347b1443$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $ddf9d070347b1443$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $ddf9d070347b1443$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $ddf9d070347b1443$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $ddf9d070347b1443$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $ddf9d070347b1443$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $ddf9d070347b1443$var$STATE_PENDING) return;
            if ((0, $exje8.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($ddf9d070347b1443$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($ddf9d070347b1443$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("jhUXm", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $e0abc93a49f76cc7$export$e069fee9c632ed00);

var $eAGoL = parcelRequire("eAGoL");

var $59NSd = parcelRequire("59NSd");
let $e0abc93a49f76cc7$var$parsedStackResults;
let $e0abc93a49f76cc7$var$lastSentryKeysCount;
let $e0abc93a49f76cc7$var$lastNativeKeysCount;
let $e0abc93a49f76cc7$var$cachedFilenameDebugIds;
function $e0abc93a49f76cc7$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $59NSd.GLOBAL_OBJ)._sentryDebugIds;
    const nativeDebugIdMap = (0, $59NSd.GLOBAL_OBJ)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($e0abc93a49f76cc7$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $e0abc93a49f76cc7$var$lastSentryKeysCount && nativeDebugIdKeys.length === $e0abc93a49f76cc7$var$lastNativeKeysCount) return $e0abc93a49f76cc7$var$cachedFilenameDebugIds;
    $e0abc93a49f76cc7$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $e0abc93a49f76cc7$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $e0abc93a49f76cc7$var$cachedFilenameDebugIds = {};
    if (!$e0abc93a49f76cc7$var$parsedStackResults) $e0abc93a49f76cc7$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $e0abc93a49f76cc7$var$parsedStackResults?.[key];
            if (result && $e0abc93a49f76cc7$var$cachedFilenameDebugIds && debugId) {
                $e0abc93a49f76cc7$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($e0abc93a49f76cc7$var$parsedStackResults) $e0abc93a49f76cc7$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $e0abc93a49f76cc7$var$cachedFilenameDebugIds && $e0abc93a49f76cc7$var$parsedStackResults) {
                        $e0abc93a49f76cc7$var$cachedFilenameDebugIds[filename] = debugId;
                        $e0abc93a49f76cc7$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $e0abc93a49f76cc7$var$cachedFilenameDebugIds;
}
function $e0abc93a49f76cc7$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $e0abc93a49f76cc7$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $eAGoL.normalizeStackTracePath)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}

});

parcelRegister("auwZv", function(module, exports) {

$parcel$export(module.exports, "isInternalException", () => $7a364c120631090e$export$8ca34793c8898e34);
$parcel$export(module.exports, "getPossibleEventMessages", () => $7a364c120631090e$export$d55a97c329cacfcc);
function $7a364c120631090e$export$8ca34793c8898e34(hint) {
    return hint.data?.__sentry__ === true;
}
function $7a364c120631090e$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}

});

parcelRegister("ea5SN", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $a4f6900d5d410829$export$43988bc651a80216);
$parcel$export(module.exports, "getCombinedScopeData", () => $a4f6900d5d410829$export$cc422922fcbb91c6);

var $gqV7N = parcelRequire("gqV7N");

var $cvdrG = parcelRequire("cvdrG");

var $aje4A = parcelRequire("aje4A");

var $kn25x = parcelRequire("kn25x");
function $a4f6900d5d410829$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $a4f6900d5d410829$var$applyDataToEvent(event, data);
    if (span) $a4f6900d5d410829$var$applySpanToEvent(event, span);
    $a4f6900d5d410829$var$applyFingerprintToEvent(event, fingerprint);
    $a4f6900d5d410829$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $a4f6900d5d410829$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $a4f6900d5d410829$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $a4f6900d5d410829$export$b1a120a2871faa46(data, "extra", extra);
    $a4f6900d5d410829$export$b1a120a2871faa46(data, "tags", tags);
    $a4f6900d5d410829$export$b1a120a2871faa46(data, "attributes", attributes);
    $a4f6900d5d410829$export$b1a120a2871faa46(data, "user", user);
    $a4f6900d5d410829$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $aje4A.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $a4f6900d5d410829$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $aje4A.merge)(data[prop], mergeVal, 1);
}
function $a4f6900d5d410829$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $gqV7N.getGlobalScope)().getScopeData();
    isolationScope && $a4f6900d5d410829$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $a4f6900d5d410829$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $a4f6900d5d410829$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $a4f6900d5d410829$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $a4f6900d5d410829$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $a4f6900d5d410829$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $kn25x.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $cvdrG.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $kn25x.getRootSpan)(span);
    const transactionName = (0, $kn25x.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $a4f6900d5d410829$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("cvdrG", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $91a2cf4c9310c1e7$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $91a2cf4c9310c1e7$export$a117f995597e25df);

var $7LgVW = parcelRequire("7LgVW");

var $gqV7N = parcelRequire("gqV7N");

var $2MLxn = parcelRequire("2MLxn");

var $8CgbT = parcelRequire("8CgbT");

var $8U4FY = parcelRequire("8U4FY");

var $iDcZ3 = parcelRequire("iDcZ3");

var $6i9K0 = parcelRequire("6i9K0");

var $kn25x = parcelRequire("kn25x");

var $dyVHZ = parcelRequire("dyVHZ");

var $7l7Os = parcelRequire("7l7Os");
const $91a2cf4c9310c1e7$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $91a2cf4c9310c1e7$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $6i9K0.addNonEnumerableProperty)(spanWithMaybeDsc, $91a2cf4c9310c1e7$var$FROZEN_DSC_FIELD, dsc);
}
function $91a2cf4c9310c1e7$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $7LgVW.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $8U4FY.extractOrgIdFromClient)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $91a2cf4c9310c1e7$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $91a2cf4c9310c1e7$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $91a2cf4c9310c1e7$export$a117f995597e25df(span) {
    const client = (0, $gqV7N.getClient)();
    if (!client) return {};
    const rootSpan = (0, $kn25x.getRootSpan)(span);
    const rootSpanJson = (0, $kn25x.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$91a2cf4c9310c1e7$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $dyVHZ.spanIsNonRecordingSpan)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $iDcZ3.hasSpansEnabled)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $7l7Os.getCapturedScopesOnSpan)(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$91a2cf4c9310c1e7$export$89ef1736f08c6b2b(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $8CgbT.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $91a2cf4c9310c1e7$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $iDcZ3.hasSpansEnabled)()) {
        dsc.sampled = String((0, $kn25x.spanIsSampled)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $7l7Os.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $91a2cf4c9310c1e7$export$95cf936fdacaff7b(span) {
    const dsc = $91a2cf4c9310c1e7$export$a117f995597e25df(span);
    return (0, $8CgbT.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("2MLxn", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $2074f06573cbe0db$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $2074f06573cbe0db$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", () => $2074f06573cbe0db$export$889fb736668e1ecc);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $2074f06573cbe0db$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $2074f06573cbe0db$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE", () => $2074f06573cbe0db$export$d9e02c0285078f88);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_RELEASE", () => $2074f06573cbe0db$export$f5cefb258679b29e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT", () => $2074f06573cbe0db$export$d1b1dbb47f5ba57c);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS", () => $2074f06573cbe0db$export$bd847b1cc92ae587);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_USER_ID", () => $2074f06573cbe0db$export$1f9cc1d34ea098a0);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_USER_EMAIL", () => $2074f06573cbe0db$export$b7466609ef46c07e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS", () => $2074f06573cbe0db$export$8d592bdaea63b930);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_USER_USERNAME", () => $2074f06573cbe0db$export$c05ee933d3f74b2b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $2074f06573cbe0db$export$165ce9a229f6f050);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $2074f06573cbe0db$export$1efec95406bbe327);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", () => $2074f06573cbe0db$export$fea48ba9f4550879);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", () => $2074f06573cbe0db$export$be7a251980e7e946);
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID_ATTRIBUTE", () => $2074f06573cbe0db$export$71a4a707257f2774);
const $2074f06573cbe0db$export$d7a7d984b0791405 = "sentry.source";
const $2074f06573cbe0db$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $2074f06573cbe0db$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $2074f06573cbe0db$export$1a413bd9a88fdb09 = "sentry.op";
const $2074f06573cbe0db$export$cca8dd30f57f805e = "sentry.origin";
const $2074f06573cbe0db$export$d9e02c0285078f88 = "sentry.status.message";
const $2074f06573cbe0db$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $2074f06573cbe0db$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $2074f06573cbe0db$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $2074f06573cbe0db$export$f5cefb258679b29e = "sentry.release";
const $2074f06573cbe0db$export$d1b1dbb47f5ba57c = "sentry.environment";
const $2074f06573cbe0db$export$4626f2be16112c1c = "sentry.segment.name";
const $2074f06573cbe0db$export$25fa4a1832d3736a = "sentry.segment.id";
const $2074f06573cbe0db$export$87a4807042e1f1bb = "sentry.sdk.name";
const $2074f06573cbe0db$export$301ebe936458e291 = "sentry.sdk.version";
const $2074f06573cbe0db$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $2074f06573cbe0db$export$1f9cc1d34ea098a0 = "user.id";
const $2074f06573cbe0db$export$b7466609ef46c07e = "user.email";
const $2074f06573cbe0db$export$8d592bdaea63b930 = "user.ip_address";
const $2074f06573cbe0db$export$c05ee933d3f74b2b = "user.name";
const $2074f06573cbe0db$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $2074f06573cbe0db$export$1efec95406bbe327 = "sentry.profile_id";
const $2074f06573cbe0db$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $2074f06573cbe0db$export$b016f89ac1066ec = "cache.hit";
const $2074f06573cbe0db$export$3110e4c3f4386399 = "cache.key";
const $2074f06573cbe0db$export$86be76deee227ff2 = "cache.item_size";
const $2074f06573cbe0db$export$be7a251980e7e946 = "http.request.method";
const $2074f06573cbe0db$export$25dfd73e0e32c6e1 = "url.full";
const $2074f06573cbe0db$export$ff77b5fd5b2d627b = "sentry.link.type";
const $2074f06573cbe0db$export$71a4a707257f2774 = "gen_ai.conversation.id";

});

parcelRegister("8CgbT", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $645e6e7bf3d8539f$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $645e6e7bf3d8539f$export$56766feef403f365);

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $exje8 = parcelRequire("exje8");
const $645e6e7bf3d8539f$export$6e69537d67fa20f = "sentry-";
const $645e6e7bf3d8539f$export$eb0401070c617ea5 = /^sentry-/;
const $645e6e7bf3d8539f$export$bdd844ddb2def819 = 8192;
function $645e6e7bf3d8539f$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $645e6e7bf3d8539f$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($645e6e7bf3d8539f$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($645e6e7bf3d8539f$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $645e6e7bf3d8539f$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$645e6e7bf3d8539f$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $645e6e7bf3d8539f$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $645e6e7bf3d8539f$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $exje8.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $645e6e7bf3d8539f$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $645e6e7bf3d8539f$var$baggageHeaderToObject(baggageHeader);
}
function $645e6e7bf3d8539f$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $645e6e7bf3d8539f$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $645e6e7bf3d8539f$export$bdd844ddb2def819) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $645e6e7bf3d8539f$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $645e6e7bf3d8539f$export$397de414d189db00(existing);
    const incomingEntries = $645e6e7bf3d8539f$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($645e6e7bf3d8539f$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($645e6e7bf3d8539f$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $645e6e7bf3d8539f$export$12a7349a29a6e3c2(merged);
}

});

parcelRegister("8U4FY", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $67b72e3f4d9dc82e$export$44d472fbb931a776);
$parcel$export(module.exports, "extractOrgIdFromClient", () => $67b72e3f4d9dc82e$export$b7ac9b8efa4bb595);
$parcel$export(module.exports, "makeDsn", () => $67b72e3f4d9dc82e$export$128827c3562ec0cb);

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");
const $67b72e3f4d9dc82e$var$ORG_ID_REGEX = /^o(\d+)\./;
const $67b72e3f4d9dc82e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $67b72e3f4d9dc82e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $67b72e3f4d9dc82e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $67b72e3f4d9dc82e$export$b892860177f70a30(str) {
    const match = $67b72e3f4d9dc82e$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $cG2xs.consoleSandbox)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $67b72e3f4d9dc82e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $67b72e3f4d9dc82e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $67b72e3f4d9dc82e$var$validateDsn(dsn) {
    if (!(0, $dn9bA.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $cG2xs.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $cG2xs.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$67b72e3f4d9dc82e$var$isValidProtocol(protocol)) {
        (0, $cG2xs.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $cG2xs.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $67b72e3f4d9dc82e$export$5914f4e7748c29c9(host) {
    const match = host.match($67b72e3f4d9dc82e$var$ORG_ID_REGEX);
    return match?.[1];
}
function $67b72e3f4d9dc82e$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $67b72e3f4d9dc82e$export$5914f4e7748c29c9(host);
    return org_id;
}
function $67b72e3f4d9dc82e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $67b72e3f4d9dc82e$export$b892860177f70a30(from) : $67b72e3f4d9dc82e$var$dsnFromComponents(from);
    if (!components || !$67b72e3f4d9dc82e$var$validateDsn(components)) return void 0;
    return components;
}

});

parcelRegister("iDcZ3", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", () => $d905f0d20f3695f9$export$1f70765132c3c225);

var $gqV7N = parcelRequire("gqV7N");
function $d905f0d20f3695f9$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $gqV7N.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

});

parcelRegister("kn25x", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $ed4793577f4744d0$export$208d5b368507fb8b);
$parcel$export(module.exports, "spanToJSON", () => $ed4793577f4744d0$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $ed4793577f4744d0$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanIsSampled", () => $ed4793577f4744d0$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanToStreamedSpanJSON", () => $ed4793577f4744d0$export$db0cad9e44f67af8);
$parcel$export(module.exports, "INTERNAL_getSegmentSpan", () => $ed4793577f4744d0$export$7a3106f345d83bb6);
$parcel$export(module.exports, "streamedSpanJsonToSerializedSpan", () => $ed4793577f4744d0$export$5402aa553bcf35f3);
$parcel$export(module.exports, "getRootSpan", () => $ed4793577f4744d0$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "getActiveSpan", () => $ed4793577f4744d0$export$1be426a8e585c83e);
$parcel$export(module.exports, "showSpanDropWarning", () => $ed4793577f4744d0$export$d11691ff45a3e535);

var $1758c = parcelRequire("1758c");

var $gJxqo = parcelRequire("gJxqo");

var $4AWuw = parcelRequire("4AWuw");

var $gqV7N = parcelRequire("gqV7N");

var $2MLxn = parcelRequire("2MLxn");

var $7m8dg = parcelRequire("7m8dg");

var $7l7Os = parcelRequire("7l7Os");

var $6i9K0 = parcelRequire("6i9K0");

var $61J4g = parcelRequire("61J4g");

var $c5ls6 = parcelRequire("c5ls6");

var $lQFE0 = parcelRequire("lQFE0");

var $cG2xs = parcelRequire("cG2xs");

var $1Wbj3 = parcelRequire("1Wbj3");
const $ed4793577f4744d0$export$208d5b368507fb8b = 0;
const $ed4793577f4744d0$export$eb571cd9b5d98de8 = 1;
let $ed4793577f4744d0$var$hasShownSpanDropWarning = false;
function $ed4793577f4744d0$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $ed4793577f4744d0$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $ed4793577f4744d0$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $ed4793577f4744d0$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $7l7Os.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $61J4g.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $ed4793577f4744d0$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ed4793577f4744d0$export$5caecac1caaf3a71(span);
    return (0, $lQFE0.generateSentryTraceHeader)(traceId, spanId, sampled);
}
function $ed4793577f4744d0$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ed4793577f4744d0$export$5caecac1caaf3a71(span);
    return (0, $lQFE0.generateTraceparentHeader)(traceId, spanId, sampled);
}
function $ed4793577f4744d0$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $ed4793577f4744d0$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $ed4793577f4744d0$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $ed4793577f4744d0$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $ed4793577f4744d0$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $ed4793577f4744d0$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $ed4793577f4744d0$var$ensureTimestampInSeconds(input.getTime());
    return (0, $c5ls6.timestampInSeconds)();
}
function $ed4793577f4744d0$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $ed4793577f4744d0$export$92d8c23565496537(span) {
    if ($ed4793577f4744d0$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($ed4793577f4744d0$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $ed4793577f4744d0$var$getOtelParentSpanId(span),
            start_timestamp: $ed4793577f4744d0$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $ed4793577f4744d0$export$3f7581298f56c6d7(endTime) || void 0,
            status: $ed4793577f4744d0$export$e238a77ea3a8cd66(status),
            op: attributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $ed4793577f4744d0$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $ed4793577f4744d0$export$db0cad9e44f67af8(span) {
    if ($ed4793577f4744d0$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($ed4793577f4744d0$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $ed4793577f4744d0$var$getOtelParentSpanId(span),
            start_timestamp: $ed4793577f4744d0$export$3f7581298f56c6d7(startTime),
            end_timestamp: $ed4793577f4744d0$export$3f7581298f56c6d7(endTime),
            is_segment: span === $ed4793577f4744d0$export$7a3106f345d83bb6(span),
            status: $ed4793577f4744d0$export$d3856a3187d34821(status),
            attributes: $ed4793577f4744d0$export$1464a9cb828ba99f(attributes, status),
            links: $ed4793577f4744d0$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $ed4793577f4744d0$export$7a3106f345d83bb6(span)
    };
}
function $ed4793577f4744d0$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $ed4793577f4744d0$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $gJxqo.serializeAttributes)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $gJxqo.serializeAttributes)(link.attributes)
            }))
    };
}
function $ed4793577f4744d0$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $ed4793577f4744d0$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $ed4793577f4744d0$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $ed4793577f4744d0$export$eb571cd9b5d98de8;
}
function $ed4793577f4744d0$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $7m8dg.SPAN_STATUS_UNSET)) return void 0;
    if (status.code === (0, $7m8dg.SPAN_STATUS_OK)) return "ok";
    return status.message || "internal_error";
}
function $ed4793577f4744d0$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $7m8dg.SPAN_STATUS_OK) || status.code === (0, $7m8dg.SPAN_STATUS_UNSET) || status.message === "cancelled" ? "ok" : "error";
}
function $ed4793577f4744d0$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $ed4793577f4744d0$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE)]: statusMessage
        },
        ...attributes
    };
}
const $ed4793577f4744d0$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $ed4793577f4744d0$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $ed4793577f4744d0$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$ed4793577f4744d0$var$ROOT_SPAN_FIELD] || span;
    (0, $6i9K0.addNonEnumerableProperty)(childSpan, $ed4793577f4744d0$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$ed4793577f4744d0$export$5caecac1caaf3a71(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$ed4793577f4744d0$var$CHILD_SPANS_FIELD]) span[$ed4793577f4744d0$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $6i9K0.addNonEnumerableProperty)(span, $ed4793577f4744d0$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $ed4793577f4744d0$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$ed4793577f4744d0$var$CHILD_SPANS_FIELD]) span[$ed4793577f4744d0$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $ed4793577f4744d0$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($ed4793577f4744d0$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$ed4793577f4744d0$var$CHILD_SPANS_FIELD] ? Array.from(span2[$ed4793577f4744d0$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $ed4793577f4744d0$export$c4c6a79b1260ca1b = $ed4793577f4744d0$export$7a3106f345d83bb6;
function $ed4793577f4744d0$export$7a3106f345d83bb6(span) {
    return span[$ed4793577f4744d0$var$ROOT_SPAN_FIELD] || span;
}
function $ed4793577f4744d0$export$1be426a8e585c83e() {
    const carrier = (0, $4AWuw.getMainCarrier)();
    const acs = (0, $1758c.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $1Wbj3._getSpanForScope)((0, $gqV7N.getCurrentScope)());
}
function $ed4793577f4744d0$export$d11691ff45a3e535() {
    if (!$ed4793577f4744d0$var$hasShownSpanDropWarning) {
        (0, $cG2xs.consoleSandbox)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $ed4793577f4744d0$var$hasShownSpanDropWarning = true;
    }
}
function $ed4793577f4744d0$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("gJxqo", function(module, exports) {

$parcel$export(module.exports, "serializeAttributes", () => $c2eac6c8cd9f85cb$export$4954cae66e755861);

var $exje8 = parcelRequire("exje8");
function $c2eac6c8cd9f85cb$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $c2eac6c8cd9f85cb$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $c2eac6c8cd9f85cb$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $c2eac6c8cd9f85cb$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $c2eac6c8cd9f85cb$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $c2eac6c8cd9f85cb$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $c2eac6c8cd9f85cb$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $c2eac6c8cd9f85cb$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $exje8.isPrimitive)(val)) weight += $c2eac6c8cd9f85cb$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $c2eac6c8cd9f85cb$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $c2eac6c8cd9f85cb$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}

});

parcelRegister("7m8dg", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $55b0f5634441f3aa$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $55b0f5634441f3aa$export$58f7963109c806fc);
const $55b0f5634441f3aa$export$136e25984ba4a383 = 0;
const $55b0f5634441f3aa$export$58f7963109c806fc = 1;
const $55b0f5634441f3aa$export$f966a0446ece71e = 2;
function $55b0f5634441f3aa$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $55b0f5634441f3aa$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $55b0f5634441f3aa$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $55b0f5634441f3aa$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $55b0f5634441f3aa$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $55b0f5634441f3aa$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}

});

parcelRegister("7l7Os", function(module, exports) {

$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $55808e0589c02ecd$export$c08fbc656a245d03);

var $6i9K0 = parcelRequire("6i9K0");

var $hxbjp = parcelRequire("hxbjp");
const $55808e0589c02ecd$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $55808e0589c02ecd$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $55808e0589c02ecd$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $55808e0589c02ecd$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $55808e0589c02ecd$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $55808e0589c02ecd$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $6i9K0.addNonEnumerableProperty)(span, $55808e0589c02ecd$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $hxbjp.makeWeakRef)(isolationScope));
        (0, $6i9K0.addNonEnumerableProperty)(span, $55808e0589c02ecd$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $55808e0589c02ecd$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$55808e0589c02ecd$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $hxbjp.derefWeakRef)(spanWithScopes[$55808e0589c02ecd$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $55808e0589c02ecd$export$d135494e80cbbcae(span) {
    (0, $6i9K0.addNonEnumerableProperty)(span, $55808e0589c02ecd$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $55808e0589c02ecd$export$2e69b79005fc86eb(span) {
    return span[$55808e0589c02ecd$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $55808e0589c02ecd$export$c45f16c039fb5033(span) {
    (0, $6i9K0.addNonEnumerableProperty)(span, $55808e0589c02ecd$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $55808e0589c02ecd$export$aceb4106f395d20e(span) {
    return span[$55808e0589c02ecd$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $55808e0589c02ecd$export$6ba79447c0a2d852(span) {
    (0, $6i9K0.addNonEnumerableProperty)(span, $55808e0589c02ecd$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $55808e0589c02ecd$export$a9ba2a501dbf6a56(span) {
    return span[$55808e0589c02ecd$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}

});

parcelRegister("lQFE0", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", () => $fe7ec1fddc606d6b$export$f35d907436da45cf);
$parcel$export(module.exports, "generateTraceparentHeader", () => $fe7ec1fddc606d6b$export$1aff3752542747dd);

var $cG2xs = parcelRequire("cG2xs");

var $8CgbT = parcelRequire("8CgbT");

var $8U4FY = parcelRequire("8U4FY");

var $1s5dy = parcelRequire("1s5dy");

var $61J4g = parcelRequire("61J4g");

var $55uN4 = parcelRequire("55uN4");
const $fe7ec1fddc606d6b$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $fe7ec1fddc606d6b$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($fe7ec1fddc606d6b$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $fe7ec1fddc606d6b$export$d6559160aa7f14fa(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $fe7ec1fddc606d6b$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $fe7ec1fddc606d6b$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8CgbT.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $61J4g.generateTraceId)(),
        sampleRand: (0, $55uN4.safeMathRandom)()
    };
    const sampleRand = $fe7ec1fddc606d6b$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $fe7ec1fddc606d6b$export$f35d907436da45cf(traceId = (0, $61J4g.generateTraceId)(), spanId = (0, $61J4g.generateSpanId)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $fe7ec1fddc606d6b$export$1aff3752542747dd(traceId = (0, $61J4g.generateTraceId)(), spanId = (0, $61J4g.generateSpanId)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $fe7ec1fddc606d6b$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $1s5dy.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $1s5dy.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $55uN4.safeMathRandom)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $55uN4.safeMathRandom)() * (1 - parsedSampleRate);
    else return (0, $55uN4.safeMathRandom)();
}
function $fe7ec1fddc606d6b$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $8U4FY.extractOrgIdFromClient)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $cG2xs.debug).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $cG2xs.debug).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}

});
parcelRegister("1s5dy", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", () => $10ec741a83a0163b$export$a5bd2d81656d9546);
function $10ec741a83a0163b$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}

});



parcelRegister("dyVHZ", function(module, exports) {

$parcel$export(module.exports, "spanIsNonRecordingSpan", () => $9dfb370e614084e9$export$61cc547d99783aa7);

var $6i9K0 = parcelRequire("6i9K0");

var $61J4g = parcelRequire("61J4g");

var $kn25x = parcelRequire("kn25x");
const $9dfb370e614084e9$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $9dfb370e614084e9$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $61J4g.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $61J4g.generateSpanId)();
        this.dropReason = spanContext.dropReason;
        (0, $6i9K0.addNonEnumerableProperty)(this, $9dfb370e614084e9$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $kn25x.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $9dfb370e614084e9$export$61cc547d99783aa7(span) {
    return !!span && span[$9dfb370e614084e9$var$NON_RECORDING_SPAN_FIELD] === true;
}

});







parcelRegister("lfyDg", function(module, exports) {

$parcel$export(module.exports, "STAGES", () => $f785dced3cde61be$export$47007d96f3617630);
$parcel$export(module.exports, "VariationProgress", () => $f785dced3cde61be$export$f9bee077c7db831d);
$parcel$export(module.exports, "VARIATION_PROGRESS_STAGE", () => (parcelRequire("lb17q")).VARIATION_PROGRESS_STAGE);

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $fZShI = parcelRequire("fZShI");

var $6wv4i = parcelRequire("6wv4i");
var $e9DCr = parcelRequire("e9DCr");

var $lb17q = parcelRequire("lb17q");
const $f785dced3cde61be$export$47007d96f3617630 = {
    [(0, $lb17q.VARIATION_PROGRESS_STAGE).LABELING]: {
        icon: [
            (0, $6wv4i.eye),
            (0, $6wv4i.image),
            (0, $6wv4i.mag),
            (0, $6wv4i.aiLogo)
        ],
        label: "Analyzing image"
    },
    [(0, $lb17q.VARIATION_PROGRESS_STAGE).WAITING]: {
        icon: [
            (0, $6wv4i.hourglass),
            (0, $6wv4i.image),
            (0, $6wv4i.aiLogo)
        ],
        label: "Generating variation"
    },
    [(0, $lb17q.VARIATION_PROGRESS_STAGE).GENERATING]: {
        icon: [
            (0, $6wv4i.wand),
            (0, $6wv4i.image),
            (0, $6wv4i.aiLogo)
        ],
        label: "Generating image"
    },
    [(0, $lb17q.VARIATION_PROGRESS_STAGE).SAVING]: {
        icon: [
            (0, $6wv4i.floppy),
            (0, $6wv4i.image),
            (0, $6wv4i.cloud)
        ],
        label: "Saving image"
    }
};
const $f785dced3cde61be$export$f9bee077c7db831d = ({ progress: progress, size: size = 21, showLabel: showLabel = true })=>{
    const stageId = $f785dced3cde61be$export$47007d96f3617630[progress?.stage] ? progress.stage : (0, $lb17q.VARIATION_PROGRESS_STAGE).WAITING;
    const stage = $f785dced3cde61be$export$47007d96f3617630[stageId];
    const label = progress?.label ?? stage.label;
    const isLarge = size >= 32;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        role: "status",
        "aria-label": showLabel ? undefined : label,
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd182';
            rules += ' _ta182';
            rules += ' eb182';
            rules += ' _Ca182';
            if (props.isLarge) rules += ' Ul182';
            else rules += ' Ue182';
            if (props.isLarge) rules += ' ql182';
            else rules += ' qe182';
            return rules;
        }({
            isLarge: isLarge
        }),
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e9DCr.PixelLoader), {
                icon: stage.icon,
                size: size
            }),
            showLabel && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ue182 qe182 _Pc182",
                children: [
                    stageId === (0, $lb17q.VARIATION_PROGRESS_STAGE).GENERATING && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                        size: "S",
                        staticColor: "auto",
                        "aria-label": label,
                        isIndeterminate: !progress?.value,
                        value: progress?.value,
                        UNSAFE_className: function anonymous(props) {
                            let rules = " ";
                            if (props.isLarge) {
                                rules += ' -Z4Pn4c-b182';
                                rules += ' __Ha182';
                            } else {
                                rules += ' -Z4Pn4c-tmMfn182';
                                rules += ' __Ha182';
                            }
                            if (props.isLarge) {
                                rules += ' -_04Pn4c-b182';
                                rules += ' __Ha182';
                            } else {
                                rules += ' -_04Pn4c-tmMfn182';
                                rules += ' __Ha182';
                            }
                            rules += ' _0f182';
                            rules += ' _Pa182';
                            rules += ' WF182';
                            rules += ' _Ad182';
                            rules += ' -_8PloMd-m182';
                            rules += ' __Ya182';
                            return rules;
                        }({
                            isLarge: isLarge
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                        className: function anonymous(props) {
                            let rules = " ";
                            if (props.isLarge) {
                                rules += ' uk182';
                                rules += ' ucJ9TBTb182';
                                rules += ' ud3Euai182';
                                rules += ' uea182';
                                rules += ' ugb182';
                                rules += ' uhd182';
                                rules += ' uje182';
                                rules += ' u2NhKxcl182';
                                rules += ' uic182';
                            } else {
                                rules += ' uk182';
                                rules += ' ucJ9TBTb182';
                                rules += ' ud3Euai182';
                                rules += ' uea182';
                                rules += ' ugb182';
                                rules += ' uhd182';
                                rules += ' uje182';
                                rules += ' u2NhKxcl182';
                                rules += ' uic182';
                            }
                            if (props.isLarge) {
                                rules += ' -_6BNtrc-c182';
                                rules += ' vx182';
                            } else {
                                rules += ' -_6BNtrc-a182';
                                rules += ' vx182';
                            }
                            if (props.isLarge) {
                                rules += ' xb182';
                                rules += ' _xa182';
                            } else {
                                rules += ' xb182';
                                rules += ' _xa182';
                            }
                            if (props.isLarge) {
                                rules += ' _Fd182';
                                rules += ' _FnuYUweb182';
                            } else {
                                rules += ' _Fd182';
                                rules += ' _FnuYUweb182';
                            }
                            if (props.isLarge) rules += ' pt182';
                            else rules += ' pt182';
                            return rules;
                        }({
                            isLarge: isLarge
                        }),
                        children: label
                    })
                ]
            })
        ]
    });
};
$f785dced3cde61be$export$f9bee077c7db831d.propTypes = {
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        stage: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf(Object.values((0, $lb17q.VARIATION_PROGRESS_STAGE))),
        value: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
    }),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
    showLabel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};

});
parcelRegister("6wv4i", function(module, exports) {

$parcel$export(module.exports, "aiLogo", () => $d47683b874925f09$export$5ca8b7335cc0c39a);
$parcel$export(module.exports, "eye", () => $d47683b874925f09$export$4e18cf730a59887e);
$parcel$export(module.exports, "hourglass", () => $d47683b874925f09$export$f9da73b08d6387bd);
$parcel$export(module.exports, "mag", () => $d47683b874925f09$export$1b9bab504faa9305);
$parcel$export(module.exports, "image", () => $d47683b874925f09$export$5c452ff88e35e47d);
$parcel$export(module.exports, "wand", () => $d47683b874925f09$export$b35b7bd2b478be05);
$parcel$export(module.exports, "cloud", () => $d47683b874925f09$export$310741c5b9ff060);
$parcel$export(module.exports, "floppy", () => $d47683b874925f09$export$969f9c183ead5332);
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d47683b874925f09$export$5ca8b7335cc0c39a = [
    {
        cx: 240,
        cy: 360,
        adjustY: -0.5,
        stagger: 0,
        outer: true
    },
    {
        cx: 160,
        cy: 320,
        stagger: 2,
        outer: true
    },
    {
        cx: 320,
        cy: 320,
        stagger: 4,
        outer: true
    },
    {
        cx: 200,
        cy: 280,
        stagger: 6
    },
    {
        cx: 280,
        cy: 280,
        stagger: 8
    },
    {
        cx: 120,
        cy: 240,
        adjustX: 0.5,
        stagger: 10,
        outer: true
    },
    {
        cx: 360,
        cy: 240,
        adjustX: -0.5,
        stagger: 14,
        outer: true
    },
    {
        cx: 200,
        cy: 200,
        stagger: 16
    },
    {
        cx: 280,
        cy: 200,
        stagger: 18
    },
    {
        cx: 160,
        cy: 160,
        stagger: 20,
        outer: true
    },
    {
        cx: 320,
        cy: 160,
        stagger: 22,
        outer: true
    },
    {
        cx: 240,
        cy: 120,
        adjustY: 0.5,
        stagger: 24,
        outer: true
    }
];
// ─────────────────────────────────────────────────────────────
// POSITIONS — [col, row] grid coords per icon, exported individually.
// ─────────────────────────────────────────────────────────────
const $d47683b874925f09$var$$898b869d557a51d3$var$brushPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        1,
        5
    ],
    [
        3,
        5
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$eyePositions = [
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        5,
        3
    ],
    [
        0,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$hourglassPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        2,
        3
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        1,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$magPositions = [
    [
        6,
        6
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        0,
        3
    ],
    [
        4,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        0,
        1
    ],
    [
        4,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$cropPositions = [
    [
        5,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        1,
        4
    ],
    [
        1,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        2
    ],
    [
        0,
        1
    ],
    [
        1,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        1,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$flowerPositions = [
    [
        3,
        6
    ],
    [
        3,
        5
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        2,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        2,
        1
    ],
    [
        5,
        1
    ],
    [
        1,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$imagePositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        2,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$lassoPositions = [
    [
        1,
        6
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        0,
        3
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        0,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        6,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$pagePositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        3,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$wandPositions = [
    [
        6,
        6
    ],
    [
        5,
        5
    ],
    [
        0,
        4
    ],
    [
        4,
        4
    ],
    [
        2,
        3
    ],
    [
        1,
        2
    ],
    [
        3,
        2
    ],
    [
        2,
        1
    ],
    [
        0,
        0
    ],
    [
        4,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$bargraphPositions = [
    [
        0,
        6
    ],
    [
        2,
        6
    ],
    [
        4,
        6
    ],
    [
        6,
        6
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        6,
        4
    ],
    [
        1,
        3
    ],
    [
        6,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$trefoilPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        3,
        2
    ],
    [
        3,
        1
    ],
    [
        3,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$dialPositions = [
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        3,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$folderPositions = [
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$arrowPositions = [
    [
        0,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$cloudPositions = [
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ],
    [
        5,
        1
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$commentPositions = [
    [
        1,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        6,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$filterPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        2
    ],
    [
        0,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$microphonePositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        1,
        4
    ],
    [
        4,
        4
    ],
    [
        0,
        3
    ],
    [
        1,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        4,
        2
    ],
    [
        1,
        1
    ],
    [
        4,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$pencilPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        3,
        5
    ],
    [
        0,
        4
    ],
    [
        4,
        4
    ],
    [
        1,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        3,
        1
    ],
    [
        6,
        1
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$potionPositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        2,
        4
    ],
    [
        6,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        2,
        1
    ],
    [
        4,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$sliderPositions = [
    [
        4,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        4,
        3
    ],
    [
        2,
        2
    ],
    [
        0,
        1
    ],
    [
        1,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        2,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$timelinePositions = [
    [
        3,
        6
    ],
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$eyedropPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        0,
        5
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        3,
        4
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        6,
        3
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        3,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$adobeAPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        2,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$adobeDPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$adobeOPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$adobeBPositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$adobeEPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$documentPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$graphPositions = [
    [
        0,
        6
    ],
    [
        2,
        6
    ],
    [
        4,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        6,
        5
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        6,
        4
    ],
    [
        2,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        2,
        0
    ],
    [
        6,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$cartPositions = [
    [
        1,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$shopPositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        5,
        3
    ],
    [
        0,
        2
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        2,
        1
    ],
    [
        4,
        1
    ],
    [
        6,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$journeyPositions = [
    [
        5,
        6
    ],
    [
        4,
        5
    ],
    [
        6,
        5
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        0,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        5,
        2
    ],
    [
        1,
        1
    ],
    [
        4,
        1
    ],
    [
        6,
        1
    ],
    [
        5,
        0
    ]
];
const $d47683b874925f09$var$$898b869d557a51d3$var$floppyPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        1,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        3,
        0
    ],
    [
        5,
        0
    ]
];
// ─────────────────────────────────────────────────────────────
// buildCells — turn a positions list ([col, row] coords on a 7×7 grid,
// bottom-up/left-to-right within a row → stagger order) into a cells
// array with a per-cell entrance stagger. All other timing (settle, hold,
// exit, group opacity) is derived from stagger at render time.
//
// stagger modes:
//   'individual' — brush style. Each cell gets i * interval.
//   'grouped' (default) — eye style. Cells stagger within a row,
//     with 1-cell overlap between consecutive rows (cleaner reads).
//   'by-row' — all cells in a row share one stagger value.
// ─────────────────────────────────────────────────────────────
function $d47683b874925f09$var$$898b869d557a51d3$var$buildCells(positions, options = {}) {
    const { staggerInterval: staggerInterval = 2, rowOffset: rowOffset = 0, stagger: staggerMode = 'grouped' } = options;
    let staggers;
    if (staggerMode === 'by-row') {
        const rowsBottomUp = [
            ...new Set(positions.map((p)=>p[1]))
        ].sort((a, b)=>b - a);
        const rowStagger = new Map();
        rowsBottomUp.forEach((r, i)=>rowStagger.set(r, i * staggerInterval));
        staggers = positions.map(([, row])=>rowStagger.get(row));
    } else if (staggerMode === 'grouped') {
        const rowGroups = new Map();
        positions.forEach(([, row], i)=>{
            if (!rowGroups.has(row)) rowGroups.set(row, []);
            rowGroups.get(row).push(i);
        });
        const rowsBottomUp = [
            ...rowGroups.keys()
        ].sort((a, b)=>b - a);
        staggers = new Array(positions.length);
        let rowStart = 0;
        for (const row of rowsBottomUp){
            const indices = rowGroups.get(row);
            indices.forEach((idx, j)=>{
                staggers[idx] = rowStart + j * staggerInterval;
            });
            rowStart += Math.max(0, indices.length - 1) * staggerInterval;
        }
    } else if (staggerMode === 'individual') staggers = positions.map((_, i)=>i * staggerInterval);
    else throw new Error(`Unknown stagger mode: ${staggerMode}. Use 'individual', 'grouped', or 'by-row'.`);
    return positions.map(([col, row], i)=>({
            cx: 120 + col * 40,
            cy: 120 + (row + rowOffset) * 40,
            outer: false,
            stagger: staggers[i]
        }));
}
const $d47683b874925f09$export$da5d6544e8c27bc1 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$brushPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$4e18cf730a59887e = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$eyePositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: 1
});
const $d47683b874925f09$export$f9da73b08d6387bd = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$hourglassPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$1b9bab504faa9305 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$magPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$cf0991633bf59696 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$cropPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$137aef609360d3cb = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$flowerPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$5c452ff88e35e47d = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$imagePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$a1995fbee0b0f4ab = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$lassoPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$523fb3936f49e028 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$pagePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$b35b7bd2b478be05 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$wandPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$172e64b469e10167 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$bargraphPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$56f784ab966a6d87 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$trefoilPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$65e66d587c664fab = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$dialPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: 1
});
const $d47683b874925f09$export$e00584a723d0ee75 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$folderPositions, {
    staggerInterval: 1,
    stagger: 'grouped',
    rowOffset: 1
});
const $d47683b874925f09$export$f2120bbfa5450bd2 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$arrowPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: 2
});
const $d47683b874925f09$export$310741c5b9ff060 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$cloudPositions, {
    staggerInterval: 1,
    stagger: 'grouped',
    rowOffset: 1
});
const $d47683b874925f09$export$4a34f930e789283c = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$commentPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$3dea766d36a8935f = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$filterPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$e852da8bac022cf9 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$microphonePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$627145a3c022f65e = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$pencilPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$a0f88577bef20637 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$potionPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$b38bf4f33e9e4c25 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$sliderPositions, {
    staggerInterval: 1,
    stagger: 'grouped',
    rowOffset: 1
});
const $d47683b874925f09$export$cddc5598d4bb8461 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$timelinePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$65641906b768c371 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$eyedropPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$dcf6f4de000c2fb6 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$adobeAPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$a8d6198cd8cb6d8a = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$adobeDPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$b084152d3c12a03a = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$adobeOPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: -1
});
const $d47683b874925f09$export$54f54f37db70177 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$adobeBPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$983c44598ef621b = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$adobeEPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: -1
});
const $d47683b874925f09$export$5a7bfc01df82fcd1 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$documentPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$3d344a3806285c2 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$graphPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$e79499a77ba07702 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$cartPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$72e9ea039e98af90 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$shopPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$65d7afb3d6442805 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$journeyPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const $d47683b874925f09$export$969f9c183ead5332 = /* @__PURE__ */ $d47683b874925f09$var$$898b869d557a51d3$var$buildCells($d47683b874925f09$var$$898b869d557a51d3$var$floppyPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const $d47683b874925f09$export$a1edd97dd51cd48d = [
    $d47683b874925f09$export$5ca8b7335cc0c39a,
    $d47683b874925f09$export$da5d6544e8c27bc1,
    $d47683b874925f09$export$b35b7bd2b478be05,
    $d47683b874925f09$export$cf0991633bf59696,
    $d47683b874925f09$export$4e18cf730a59887e,
    $d47683b874925f09$export$f9da73b08d6387bd,
    $d47683b874925f09$export$dcf6f4de000c2fb6,
    $d47683b874925f09$export$a8d6198cd8cb6d8a,
    $d47683b874925f09$export$b084152d3c12a03a,
    $d47683b874925f09$export$54f54f37db70177,
    $d47683b874925f09$export$983c44598ef621b,
    $d47683b874925f09$export$65641906b768c371
];
const $d47683b874925f09$export$72f39d47420ee910 = [
    $d47683b874925f09$export$5ca8b7335cc0c39a,
    $d47683b874925f09$export$523fb3936f49e028,
    $d47683b874925f09$export$56f784ab966a6d87,
    $d47683b874925f09$export$5c452ff88e35e47d,
    $d47683b874925f09$export$310741c5b9ff060,
    $d47683b874925f09$export$1b9bab504faa9305,
    $d47683b874925f09$export$dcf6f4de000c2fb6,
    $d47683b874925f09$export$a8d6198cd8cb6d8a,
    $d47683b874925f09$export$b084152d3c12a03a,
    $d47683b874925f09$export$54f54f37db70177,
    $d47683b874925f09$export$983c44598ef621b,
    $d47683b874925f09$export$627145a3c022f65e
];
const $d47683b874925f09$export$b310ec824aaee37f = [
    $d47683b874925f09$export$5ca8b7335cc0c39a,
    $d47683b874925f09$export$172e64b469e10167,
    $d47683b874925f09$export$65e66d587c664fab,
    $d47683b874925f09$export$3dea766d36a8935f,
    $d47683b874925f09$export$b38bf4f33e9e4c25,
    $d47683b874925f09$export$e00584a723d0ee75,
    $d47683b874925f09$export$dcf6f4de000c2fb6,
    $d47683b874925f09$export$a8d6198cd8cb6d8a,
    $d47683b874925f09$export$b084152d3c12a03a,
    $d47683b874925f09$export$54f54f37db70177,
    $d47683b874925f09$export$983c44598ef621b,
    $d47683b874925f09$export$f2120bbfa5450bd2
];
const $d47683b874925f09$export$7cbcccfbecde6416 = [
    $d47683b874925f09$export$137aef609360d3cb,
    $d47683b874925f09$export$5c452ff88e35e47d,
    $d47683b874925f09$export$da5d6544e8c27bc1,
    $d47683b874925f09$export$4e18cf730a59887e,
    $d47683b874925f09$export$65641906b768c371,
    $d47683b874925f09$export$b35b7bd2b478be05,
    $d47683b874925f09$export$a1995fbee0b0f4ab,
    $d47683b874925f09$export$cf0991633bf59696
];
const $d47683b874925f09$export$fa5a2755865431a5 = [
    $d47683b874925f09$export$5ca8b7335cc0c39a,
    $d47683b874925f09$export$5a7bfc01df82fcd1,
    $d47683b874925f09$export$3d344a3806285c2,
    $d47683b874925f09$export$e79499a77ba07702,
    $d47683b874925f09$export$72e9ea039e98af90,
    $d47683b874925f09$export$65e66d587c664fab,
    $d47683b874925f09$export$5c452ff88e35e47d,
    $d47683b874925f09$export$65d7afb3d6442805,
    $d47683b874925f09$export$e00584a723d0ee75,
    $d47683b874925f09$export$cddc5598d4bb8461,
    $d47683b874925f09$export$4a34f930e789283c,
    $d47683b874925f09$export$969f9c183ead5332,
    $d47683b874925f09$export$dcf6f4de000c2fb6,
    $d47683b874925f09$export$a8d6198cd8cb6d8a,
    $d47683b874925f09$export$b084152d3c12a03a,
    $d47683b874925f09$export$54f54f37db70177,
    $d47683b874925f09$export$983c44598ef621b
];
const $d47683b874925f09$export$580f1e8cf64f2815 = [
    $d47683b874925f09$export$5ca8b7335cc0c39a,
    $d47683b874925f09$export$da5d6544e8c27bc1,
    $d47683b874925f09$export$b35b7bd2b478be05,
    $d47683b874925f09$export$cf0991633bf59696,
    $d47683b874925f09$export$4e18cf730a59887e,
    $d47683b874925f09$export$f9da73b08d6387bd,
    $d47683b874925f09$export$523fb3936f49e028,
    $d47683b874925f09$export$56f784ab966a6d87,
    $d47683b874925f09$export$5c452ff88e35e47d,
    $d47683b874925f09$export$65641906b768c371,
    $d47683b874925f09$export$1b9bab504faa9305,
    $d47683b874925f09$export$172e64b469e10167,
    $d47683b874925f09$export$65e66d587c664fab,
    $d47683b874925f09$export$e00584a723d0ee75,
    $d47683b874925f09$export$137aef609360d3cb,
    $d47683b874925f09$export$a1995fbee0b0f4ab,
    $d47683b874925f09$export$dcf6f4de000c2fb6,
    $d47683b874925f09$export$a8d6198cd8cb6d8a,
    $d47683b874925f09$export$b084152d3c12a03a,
    $d47683b874925f09$export$54f54f37db70177,
    $d47683b874925f09$export$983c44598ef621b,
    $d47683b874925f09$export$f2120bbfa5450bd2,
    $d47683b874925f09$export$310741c5b9ff060,
    $d47683b874925f09$export$4a34f930e789283c,
    $d47683b874925f09$export$3dea766d36a8935f,
    $d47683b874925f09$export$e852da8bac022cf9,
    $d47683b874925f09$export$627145a3c022f65e,
    $d47683b874925f09$export$a0f88577bef20637,
    $d47683b874925f09$export$b38bf4f33e9e4c25,
    $d47683b874925f09$export$cddc5598d4bb8461
];

});

parcelRegister("e9DCr", function(module, exports) {

$parcel$export(module.exports, "PixelLoader", () => $cf79ec6eb7fa5fdc$export$72440099bd090545);

var $6wv4i = parcelRequire("6wv4i");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React pixel-fall loader. Renders plain HTML divs and lets the browser
// drive the animation natively via generated CSS @keyframes. Multi-icon
// sequences (presets) play one icon per 2.4s cycle and
// advance via a single timer — only the current icon's cells are in the
// DOM. A single-icon loader stays a pure infinite CSS loop with no JS.
// Easing control points, formatted into `cubic-bezier(...)` in the
// generated keyframes. `fade` is intentionally near-linear — its control
// points lie on y=x. `scaleIn`/`scaleOut` drive the per-cell pop.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE = {
    drop: [
        0.333,
        0,
        0.667,
        1
    ],
    recover: [
        0.333,
        0,
        0.833,
        1
    ],
    exit: [
        0.563,
        0,
        0.906,
        0.757
    ],
    fade: [
        0.167,
        0.167,
        0.833,
        0.833
    ],
    scaleIn: [
        0.505,
        0.015,
        0.42,
        0.938
    ],
    scaleOut: [
        0.538,
        0.017,
        0.851,
        0.357
    ]
};
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$FPS = 30;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f = (ms)=>ms * $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$FPS / 1000;
// Timing model: every cell exits a constant `hold` after it settles, and the
// loop grows to fit. A cell settles DROP_SETTLE frames after its stagger, holds
// for HOLD_FRAMES, then takes EXIT_FALL frames to fall out of frame.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$DROP_SETTLE = 13; // frames from a cell's launch to its settled rest
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_FALL = 12; // frames for a cell to fall out of frame
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$HOLD_FRAMES = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f(1400); // constant per-cell assembled hold (42 frames)
// Per-cell scale pop: entrance 10% → 100%, exit 100% → 30%. The entrance pop
// *completes* ENT_LEAD frames before the cell settles (so it finishes on-screen
// rather than while still clipped above the frame), and the exit shrink starts
// as the cell begins to fall away.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ENT_DUR = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f(150);
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ENT_LEAD = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f(150);
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ENT_FLOOR = 0.1;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_DUR = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f(230);
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_FLOOR = 0.3;
// Group opacity envelope, applied once to the cell-grid container (one
// compositing group, so overlapping cells never stack their alpha): fades
// 0 → peak → 0 across the loop.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$OP_FADE_IN = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f(400);
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$OP_FADE_OUT = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ms2f(400);
// Per-cell vertical offsets in the 24-unit space: start off
// the top, overshoot just past the settled position, exit off the bottom.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_START = -26;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_OVERSHOOT = 1;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_EXIT = 26;
// A cell begins its exit fall a constant hold after it settles.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$exitStartOf = (c)=>c.stagger + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$DROP_SETTLE + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$HOLD_FRAMES;
// Loop length grows with the icon's stagger spread so every cell gets the
// same settle → hold → exit cadence.
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$loopFramesFor(cells) {
    let maxStagger = 1;
    for (const c of cells)maxStagger = Math.max(maxStagger, c.stagger);
    return maxStagger + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$DROP_SETTLE + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$HOLD_FRAMES + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_FALL;
}
// The animation lives in a fixed VIEWBOX-sized coordinate space that is scaled down to the
// rendered `size`. Cells are absolutely positioned in this space, so all
// the translateY offsets below are in these units — identical to the old
// SVG viewBox math, just on HTML elements the compositor can accelerate.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$VIEWBOX = 480;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$CELL = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$VIEWBOX / 12;
// ─────────────────────────────────────────────────────────────
// CSS @keyframes generation. Each piecewise segment of the motion
// becomes one keyframe stop whose `animation-timing-function` is the
// matching cubic-bezier (from EASE), so the browser interpolates the
// drop/recover/exit/fade curves natively.
// ─────────────────────────────────────────────────────────────
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$pct(frame, total) {
    // Frame → keyframe offset percentage, trimmed of noise.
    return `${+(frame / total * 100).toFixed(4)}%`;
}
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cb(coeffs) {
    return `cubic-bezier(${coeffs.join(',')})`;
}
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$emitKeyframes(name, stops, total) {
    let body = '';
    let lastPct = null;
    for (const s of stops){
        const p = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$pct(s.f, total);
        if (p === lastPct) continue;
        lastPct = p;
        const ease = s.ease ? `animation-timing-function:${$cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cb(s.ease)};` : '';
        body += `${p}{${s.decl}${ease}}`;
    }
    return `@keyframes ${name}{${body}}`;
}
// Use the individual `translate`/`scale` transform properties so the drop and
// the pop can animate on the same element without clobbering one another.
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty = (v)=>`translate:0 ${v}px;`;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc = (v)=>`scale:${v};`;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op = (v)=>`opacity:${v};`;
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cellYKeyframes(name, c, total) {
    const s = c.stagger;
    const e = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$exitStartOf(c);
    const stops = [
        {
            f: 0,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_START),
            ease: s > 0 ? null : $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.drop
        }
    ];
    if (s > 0) stops.push({
        f: s,
        decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_START),
        ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.drop
    });
    stops.push({
        f: s + 10,
        decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_OVERSHOOT),
        ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.recover
    });
    stops.push({
        f: s + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$DROP_SETTLE,
        decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty(0)
    }); // settled — hold until exit
    stops.push({
        f: e,
        decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty(0),
        ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.exit
    });
    stops.push({
        f: e + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_FALL,
        decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_EXIT)
    });
    stops.push({
        f: total,
        decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ty($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$Y_EXIT)
    }); // hold offscreen until wrap
    return $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$emitKeyframes(name, stops, total);
}
// Per-cell scale pop, applied to the inner cell element (transform-origin
// center, so no layout shift). The entrance completes ENT_LEAD frames before
// the cell settles; the exit starts as the cell begins to fall away.
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cellScaleKeyframes(name, c, total) {
    const inEnd = c.stagger + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$DROP_SETTLE - $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ENT_LEAD;
    const inStart = inEnd - $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ENT_DUR;
    const outStart = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$exitStartOf(c);
    const outEnd = outStart + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_DUR;
    return $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$emitKeyframes(name, [
        {
            f: 0,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc(0)
        },
        {
            f: inStart,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$ENT_FLOOR),
            ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.scaleIn
        },
        {
            f: inEnd,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc(1)
        },
        {
            f: outStart,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc(1),
            ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.scaleOut
        },
        {
            f: outEnd,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc($cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_FLOOR)
        },
        {
            f: outStart + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EXIT_FALL,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc(0)
        },
        {
            f: total,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$sc(0)
        }
    ], total);
}
// Group opacity envelope for the whole loader, applied once to the cell-grid
// container so overlapping cells never stack their alpha.
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$groupOpacityKeyframes(name, total, isReducedMotion) {
    // In reduced motion mode, the entire icon fades in and out instead of individual cells.
    if (isReducedMotion) return $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$emitKeyframes(name, [
        {
            f: 0,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op(0)
        },
        {
            f: total / 2 - $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$OP_FADE_OUT / 2,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op('var(--loader-opacity, 1)')
        },
        {
            f: total / 2 + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$OP_FADE_OUT / 2,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op('var(--loader-opacity, 1)')
        },
        {
            f: total,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op(0)
        }
    ], total);
    return $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$emitKeyframes(name, [
        {
            f: 0,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op(0),
            ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.fade
        },
        {
            f: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$OP_FADE_IN,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op('var(--loader-opacity, 1)')
        },
        {
            f: total - $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$OP_FADE_OUT,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op('var(--loader-opacity, 1)'),
            ease: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$EASE.fade
        },
        {
            f: total,
            decl: $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$op(0)
        }
    ], total);
}
// Stable per-icon id, keyed by the cell-array reference (icons are
// module-level consts, so the reference is stable). Used to namespace
// each icon's @keyframes and to cache its generated CSS.
let $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$nextIconId = 0;
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$iconIds = new WeakMap();
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$iconId(cells) {
    let id = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$iconIds.get(cells);
    if (id === undefined) {
        id = `pl${$cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$nextIconId++}`;
        $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$iconIds.set(cells, id);
    }
    return id;
}
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cssCache = new WeakMap();
const $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$reducedMotionCssCache = new WeakMap();
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$keyframesFor(cells, isReducedMotion) {
    let cache = isReducedMotion ? $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$reducedMotionCssCache : $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cssCache;
    let css = cache.get(cells);
    if (css === undefined) {
        const id = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$iconId(cells);
        const total = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$loopFramesFor(cells);
        css = cells.map((c, i)=>$cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cellYKeyframes(`${id}-${i}-y`, c, total) + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$cellScaleKeyframes(`${id}-${i}-s`, c, total)).join('') + $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$groupOpacityKeyframes(`${id}-group-o`, total, isReducedMotion);
        cache.set(cells, css);
    }
    return css;
}
function $cf79ec6eb7fa5fdc$export$72440099bd090545(props) {
    const { size: size = 21, isPlaying: isPlaying = true, icon: icon = (0, $6wv4i.aiLogo), color: color = 'currentColor', className: className, ...rest } = props;
    let isReducedMotion = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$useReducedMotion();
    // Normalize to a sequence.
    const sequence = (0, $eF4cA.useMemo)(()=>Array.isArray(icon[0]) ? icon : [
            icon
        ], [
        icon
    ]);
    const isSequence = sequence.length > 1;
    // `tick` increments once per cycle; the current icon is `tick % len`.
    const [tick, setTick] = (0, $eF4cA.useState)(0);
    // Restart from the first icon whenever the sequence changes.
    let [lastSequence, setLastSequence] = (0, $eF4cA.useState)(sequence);
    if (lastSequence !== sequence) {
        setLastSequence(sequence);
        setTick(0);
    }
    const cells = sequence[isSequence ? tick % sequence.length : 0];
    // The loop length — and therefore the cycle duration — is dynamic: it grows
    // with the current icon's stagger spread so every cell shares one cadence.
    const duration = (0, $eF4cA.useMemo)(()=>$cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$loopFramesFor(cells) / $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$FPS * 1000, [
        cells
    ]);
    // Advance the sequence one icon per cycle while playing. Single-icon
    // loaders never start a timer — they're a pure infinite CSS loop.
    (0, $eF4cA.useEffect)(()=>{
        if (!isPlaying || !isSequence) return undefined;
        const id = setInterval(()=>setTick((t)=>t + 1), duration);
        return ()=>clearInterval(id);
    }, [
        isPlaying,
        isSequence,
        duration,
        sequence
    ]);
    const animId = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$iconId(cells);
    const css = $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$keyframesFor(cells, isReducedMotion);
    // Sequences play each icon once and hold its faded-out final frame
    // (`forwards`) until the next remount; a single icon loops forever.
    const iteration = isSequence ? '1 forwards' : 'infinite';
    const cellSize = size / 7;
    const offset = (size - cellSize * 7) / 2;
    const matrix = (0, $eF4cA.useMemo)(()=>{
        let matrix = Array.from({
            length: 7
        }, ()=>Array.from({
                length: 7
            }, ()=>false));
        for (let c of cells){
            let x = (c.cx - 120) / $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$CELL;
            let y = (c.cy - 120) / $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$CELL;
            matrix[y][x] = true;
        }
        return matrix;
    }, [
        cells
    ]);
    const isHighDPI = (typeof document !== 'undefined' && window.devicePixelRatio >= 2) ?? false;
    const isAIIcon = cells === (0, $6wv4i.aiLogo);
    return (0, $dx4lB.jsxs)("div", {
        "aria-hidden": "true",
        className: className,
        style: {
            display: 'inline-block',
            width: size,
            height: size,
            lineHeight: 0,
            position: 'relative',
            // @ts-ignore
            forcedColorAdjust: 'none',
            willChange: 'opacity',
            ...isPlaying && {
                animation: `${animId}-group-o ${duration}ms linear ${iteration}`
            }
        },
        ...rest,
        children: [
            isPlaying ? (0, $dx4lB.jsx)("style", {
                children: css
            }) : null,
            cells.map((c, i)=>{
                let x = (c.cx - 120) / $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$CELL;
                let y = (c.cy - 120) / $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$CELL;
                // Convex-corner rounding: round a corner only when both orthogonal neighbors toward it,
                // and the diagonal neighbor toward it, are all absent.
                let left = matrix[y][x - 1];
                let right = matrix[y][x + 1];
                let top = matrix[y - 1]?.[x];
                let bottom = matrix[y + 1]?.[x];
                let topLeft = matrix[y - 1]?.[x - 1];
                let topRight = matrix[y - 1]?.[x + 1];
                let bottomLeft = matrix[y + 1]?.[x - 1];
                let bottomRight = matrix[y + 1]?.[x + 1];
                let corner = (a, b, diag)=>!a && !b && !diag ? '1px' : '0px';
                // Adjust position for outer cells on high DPI displays.
                let xPx = x * cellSize + offset + (isHighDPI ? c.adjustX ?? 0 : 0);
                let yPx = y * cellSize + offset + (isHighDPI ? c.adjustY ?? 0 : 0);
                return (0, $dx4lB.jsx)("div", {
                    style: {
                        position: 'absolute',
                        left: xPx,
                        top: yPx,
                        width: cellSize,
                        height: cellSize,
                        transformOrigin: 'center',
                        borderRadius: `${corner(left, top, topLeft)} ${corner(right, top, topRight)} ${corner(right, bottom, bottomRight)} ${corner(left, bottom, bottomLeft)}`,
                        backgroundColor: color,
                        // Extra stroke only on the AI icon's cells to match the original SVG.
                        boxShadow: isAIIcon ? `0 0 0 ${c.outer ? '0.15px' : '0.1px'} ${color}` : undefined,
                        ...isPlaying && !isReducedMotion && {
                            animation: `${animId}-${i}-y ${duration}ms linear ${iteration}, ` + `${animId}-${i}-s ${duration}ms linear ${iteration}`,
                            willChange: 'transform'
                        }
                    }
                }, i);
            })
        ]
    });
}
function $cf79ec6eb7fa5fdc$var$$914549f7925bcf98$var$useReducedMotion() {
    const [isReducedMotion, setReducedMotion] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        let mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        let update = ()=>{
            setReducedMotion(mq.matches);
        };
        update();
        mq.addEventListener('change', update);
        return ()=>mq.removeEventListener('change', update);
    }, []);
    return isReducedMotion;
}

});



parcelRegister("7nuM2", function(module, exports) {

$parcel$export(module.exports, "getStructureDependencies", () => $55f28d69f38c9a9a$export$595adb8b324f431);
$parcel$export(module.exports, "getVariationDependencies", () => $55f28d69f38c9a9a$export$5d03169b7ac3f3f5);
$parcel$export(module.exports, "snapshotDependencies", () => $55f28d69f38c9a9a$export$630fc2adf14c9a7a);
$parcel$export(module.exports, "getChangedDependencies", () => $55f28d69f38c9a9a$export$4fa48022e35d511f);
$parcel$export(module.exports, "snapshotReferences", () => $55f28d69f38c9a9a$export$cad4e20ad0a81c26);
$parcel$export(module.exports, "getChangedReferences", () => $55f28d69f38c9a9a$export$cd8fc9ffdb998519);
$parcel$export(module.exports, "getCampaignChangedVariationKeys", () => $55f28d69f38c9a9a$export$9e2f2e882208f314);
$parcel$export(module.exports, "isUploadedImage", () => $55f28d69f38c9a9a$export$404e0d4efa9073ed);
$parcel$export(module.exports, "OUTDATED_ACTION", () => $55f28d69f38c9a9a$export$57e83f91b239c0cb);
$parcel$export(module.exports, "getOutdatedAction", () => $55f28d69f38c9a9a$export$757ce9ab687de9b9);
$parcel$export(module.exports, "formatOutdatedMessage", () => $55f28d69f38c9a9a$export$1ef046981a228e74);
/**
 * What an image variation depends on — the campaign keys whose values it is
 * generated for, and its reference images — and whether they have changed
 * since.
 *
 * A variation depends on its template entry's `campaignKey`, extended by the
 * step's `campaignStructure`: the `campaignKey` of every cell and field linked
 * to it (`variationKey`) and, in a `fields` grid, that field's `value`. When an
 * image is generated, the values of those keys are recorded on the generated
 * asset as its `sourceValue` (`{ [campaignKey]: value }`). A value there that
 * differs from the campaign's now makes the image outdated — until it is
 * generated again.
 *
 * Its reference images count too: the file of each one an image is generated
 * from is recorded on the generated asset (`sourceReferences`), and a file
 * that has changed since makes the image outdated as well.
 *
 * An image the user uploaded records neither, so it is never outdated.
 *
 * Pure (no React), so it can be checked on its own.
 */ 
var $lb17q = parcelRequire("lb17q");
const $55f28d69f38c9a9a$export$e313337bbf103b45 = (value)=>Array.from(new Set((Array.isArray(value) ? value : [
        value
    ]).filter((key)=>typeof key === "string" && !!key)));
const $55f28d69f38c9a9a$export$595adb8b324f431 = (campaignStructure)=>{
    const byKey = new Map();
    // Every campaign key the structure shows, labelled by the first field
    // showing it — shared by all of its variations.
    const labels = new Map();
    for (const group of campaignStructure ?? []){
        for (const { type: type, rows: rows } of (0, $lb17q.getGroupGrids)(group))for (const cell of rows.flat().filter(Boolean)){
            const isFieldsGrid = type !== (0, $lb17q.GRID_TYPE).VARIATIONS;
            const isText = !isFieldsGrid && (0, $lb17q.isTextCell)(cell);
            // A field (or text cell) names the keys it shows.
            if ((isFieldsGrid || isText) && cell.label) $55f28d69f38c9a9a$export$e313337bbf103b45(cell.value).forEach((key)=>{
                if (!labels.has(key)) labels.set(key, cell.label);
            });
            // A text cell shows no image, so it links no variation.
            if (isText || !cell.variationKey) continue;
            const keys = [
                ...$55f28d69f38c9a9a$export$e313337bbf103b45(cell.campaignKey),
                ...isFieldsGrid ? $55f28d69f38c9a9a$export$e313337bbf103b45(cell.value) : []
            ];
            const entry = byKey.get(cell.variationKey) ?? {
                keys: [],
                labels: labels
            };
            entry.keys = $55f28d69f38c9a9a$export$e313337bbf103b45([
                ...entry.keys,
                ...keys
            ]);
            byKey.set(cell.variationKey, entry);
        }
    }
    return byKey;
};
const $55f28d69f38c9a9a$export$5d03169b7ac3f3f5 = (templateVariation, structureDependencies)=>$55f28d69f38c9a9a$export$e313337bbf103b45([
        ...$55f28d69f38c9a9a$export$e313337bbf103b45(templateVariation?.campaignKey),
        ...structureDependencies?.keys ?? []
    ]);
const $55f28d69f38c9a9a$export$630fc2adf14c9a7a = (keys, campaign)=>keys?.length ? Object.fromEntries(keys.map((key)=>[
            key,
            String(campaign?.[key] ?? "")
        ])) : undefined;
const $55f28d69f38c9a9a$var$isSnapshot = (value)=>!!value && typeof value === "object" && !Array.isArray(value);
const $55f28d69f38c9a9a$export$4fa48022e35d511f = (sourceValue, keys, campaign)=>$55f28d69f38c9a9a$var$isSnapshot(sourceValue) ? (keys ?? []).filter((key)=>Object.hasOwn(sourceValue, key) && String(sourceValue[key] ?? "") !== String(campaign?.[key] ?? "")) : [];
const $55f28d69f38c9a9a$export$cad4e20ad0a81c26 = (referenceKeys, assets)=>referenceKeys?.length ? Object.fromEntries(referenceKeys.map((key)=>[
            key,
            assets?.find((asset)=>asset.name === key)?.filePath ?? null
        ])) : undefined;
const $55f28d69f38c9a9a$export$cd8fc9ffdb998519 = (sourceReferences, referenceKeys, assets)=>$55f28d69f38c9a9a$var$isSnapshot(sourceReferences) ? (referenceKeys ?? []).filter((key)=>Object.hasOwn(sourceReferences, key) && (sourceReferences[key] ?? null) !== (assets?.find((asset)=>asset.name === key)?.filePath ?? null)) : [];
const $55f28d69f38c9a9a$export$9e2f2e882208f314 = (variations, previousCampaign, nextCampaign, { structureDependencies: structureDependencies, getPromptTemplate: getPromptTemplate } = {})=>{
    if (!previousCampaign || !nextCampaign) return [];
    const next = {
        ...nextCampaign,
        id: previousCampaign.id,
        thread_id: previousCampaign.thread_id
    };
    return (variations ?? []).filter((variation)=>{
        const keys = $55f28d69f38c9a9a$export$5d03169b7ac3f3f5(variation, structureDependencies?.get(variation.key));
        if (keys.some((key)=>String(previousCampaign[key] ?? "") !== String(next[key] ?? ""))) return true;
        return !!getPromptTemplate && JSON.stringify(getPromptTemplate(variation, previousCampaign) ?? null) !== JSON.stringify(getPromptTemplate(variation, next) ?? null);
    }).map((variation)=>variation.key);
};
const $55f28d69f38c9a9a$export$404e0d4efa9073ed = (asset)=>!!asset?.filePath && !asset.prompt && !asset.fireflyId && !asset.sourceValue && !asset.sourceReferences;
const $55f28d69f38c9a9a$export$808f5eb64b236229 = (a, b)=>{
    if (a === b) return true;
    if (!$55f28d69f38c9a9a$var$isSnapshot(a) || !$55f28d69f38c9a9a$var$isSnapshot(b)) return false;
    const keys = Object.keys(a);
    return keys.length === Object.keys(b).length && keys.every((key)=>Object.hasOwn(b, key) && a[key] === b[key]);
};
const $55f28d69f38c9a9a$var$listFormat = new Intl.ListFormat("en", {
    style: "long",
    type: "conjunction"
});
const $55f28d69f38c9a9a$export$57e83f91b239c0cb = {
    PROMPT_AND_IMAGE: "prompt-and-image",
    IMAGE: "image"
};
const $55f28d69f38c9a9a$export$757ce9ab687de9b9 = ({ changedKeys: changedKeys = [], changedReferences: changedReferences = [], isStatic: isStatic = false, isPromptEdited: isPromptEdited = false } = {})=>{
    if (changedKeys.length && (!isStatic || isPromptEdited)) return $55f28d69f38c9a9a$export$57e83f91b239c0cb.PROMPT_AND_IMAGE;
    return changedKeys.length || changedReferences.length ? $55f28d69f38c9a9a$export$57e83f91b239c0cb.IMAGE : null;
};
const $55f28d69f38c9a9a$export$1ef046981a228e74 = (changedKeys, labels, { changedReferences: changedReferences = [], referenceLabels: referenceLabels, action: action = changedKeys?.length ? $55f28d69f38c9a9a$export$57e83f91b239c0cb.PROMPT_AND_IMAGE : $55f28d69f38c9a9a$export$57e83f91b239c0cb.IMAGE } = {})=>{
    const names = Array.from(new Set([
        ...(changedKeys ?? []).map((key)=>labels?.get(key) ?? key),
        ...changedReferences.map((key)=>referenceLabels?.get(key) ?? key)
    ]));
    if (!names.length) return undefined;
    return `${$55f28d69f38c9a9a$var$listFormat.format(names.map((name)=>`"${name}"`))} changed since this image was generated. Regenerate the ${action === $55f28d69f38c9a9a$export$57e83f91b239c0cb.PROMPT_AND_IMAGE ? "prompt and image" : "image"} to match.`;
};

});

parcelRegister("3aLXY", function(module, exports) {

$parcel$export(module.exports, "getVariationOutdatedState", () => $24f7835b217a2f51$export$a03b88412cd56a15);

var $6AUdR = parcelRequire("6AUdR");

var $gJFBV = parcelRequire("gJFBV");

var $lb17q = parcelRequire("lb17q");

var $7nuM2 = parcelRequire("7nuM2");
const $24f7835b217a2f51$export$a03b88412cd56a15 = ({ variation: variation, dependencies: dependencies, assets: assets, selectedCampaign: selectedCampaign, video: video, templateData: templateData, isPromptEdited: isPromptEdited = false, isBusy: isBusy = false })=>{
    const asset = assets?.find((a)=>a.name === variation.key);
    const changedKeys = (0, $7nuM2.getChangedDependencies)(asset?.sourceValue, (0, $7nuM2.getVariationDependencies)(variation, dependencies), selectedCampaign);
    const changedReferences = (0, $7nuM2.getChangedReferences)(asset?.sourceReferences, (0, $lb17q.getVariationReferenceKeys)(variation), assets);
    const isOutdated = !isBusy && (changedKeys.length > 0 || changedReferences.length > 0);
    if (!isOutdated) return {
        changedKeys: changedKeys,
        changedReferences: changedReferences,
        isOutdated: isOutdated,
        action: null
    };
    const referenceAssets = (0, $6AUdR.resolveReferenceAssets)(assets, variation);
    const isStatic = (0, $gJFBV.isStaticPrompt)(variation, {
        templateId: video.data?.templateId,
        campaign: selectedCampaign,
        customer: video.data?.customer,
        visual: referenceAssets[0],
        visuals: referenceAssets
    });
    const action = (0, $7nuM2.getOutdatedAction)({
        changedKeys: changedKeys,
        changedReferences: changedReferences,
        isStatic: isStatic,
        isPromptEdited: isPromptEdited
    });
    const referenceLabels = new Map(changedReferences.map((key)=>[
            key,
            templateData?.assets?.find((a)=>a.name === key)?.label ?? templateData?.imageVariations?.find((v)=>v.key === key)?.label ?? key
        ]));
    return {
        changedKeys: changedKeys,
        changedReferences: changedReferences,
        isOutdated: isOutdated,
        action: action,
        message: (0, $7nuM2.formatOutdatedMessage)(changedKeys, dependencies?.labels, {
            changedReferences: changedReferences,
            referenceLabels: referenceLabels,
            action: action
        })
    };
};

});
parcelRegister("gJFBV", function(module, exports) {

$parcel$export(module.exports, "compileUserPrompt", () => $c2f1205062f0f02e$export$a1fb14ed7bca0f8e);
$parcel$export(module.exports, "getVariationPromptTemplate", () => $c2f1205062f0f02e$export$f16d897e8e784efd);
$parcel$export(module.exports, "resolveStaticPrompt", () => $c2f1205062f0f02e$export$9e586be7f3691e3a);
$parcel$export(module.exports, "isStaticPrompt", () => $c2f1205062f0f02e$export$ec52d0fe9955d5e5);
$parcel$export(module.exports, "resolveVariationUploadIds", () => $c2f1205062f0f02e$export$9f6491a5ed6ebfa2);
$parcel$export(module.exports, "buildVariationPayload", () => $c2f1205062f0f02e$export$95a1d8f003c8d342);

var $afIEk = parcelRequire("afIEk");

var $lb17q = parcelRequire("lb17q");

var $3OMKs = parcelRequire("3OMKs");

var $2VxAI = parcelRequire("2VxAI");
/**
 * Turning a variation into a request.
 *
 * Both halves of "what does this variation ask for" are resolved here, from
 * the same `VARIATION_TYPES` entry: the prompt template that gets it a
 * `visualPrompt`, and the payload that generates it.
 */ /**
 * Template-variation fields that are not model options.
 *
 * `prompt` and `values` are consumed when building the `visualPrompt` — letting
 * them through would spread the raw, un-interpolated `{{Var}}` body over the
 * generated prompt. `referenceKey` is resolved into `uploadId`/`uploadIds`,
 * `skipReferenceSeed` only controls seed inheritance, and the rest is
 * authoring metadata.
 */ const $c2f1205062f0f02e$var$NON_MODEL_FIELDS = new Set([
    "name",
    "label",
    "type",
    "useCases",
    "description",
    "imageDescriptionPrompt",
    "prompt",
    "values",
    "referenceKey",
    "skipReferenceSeed"
]);
const $c2f1205062f0f02e$var$modelOptionsOf = (templateVariation)=>Object.fromEntries(Object.entries(templateVariation ?? {}).filter(([field])=>!$c2f1205062f0f02e$var$NON_MODEL_FIELDS.has(field)));
/**
 * The values `{{Var}}` placeholders are expanded from for a variation:
 *
 *   campaign → CAMPAIGN_OVERRIDES[templateId][key] → variation.values
 *
 * Also returns the variation's references, primary first — builders that only
 * know about a single reference keep reading `visual`.
 */ const $c2f1205062f0f02e$var$resolvePromptScope = (variation, { templateId: templateId, campaign: campaign, visual: visual, visuals: visuals } = {})=>{
    const references = visuals?.length ? visuals : [
        visual
    ].filter(Boolean);
    const primary = references[0] ?? visual;
    const buildOverrides = (0, $3OMKs.CAMPAIGN_OVERRIDES)[templateId]?.[variation?.key];
    const merged = {
        ...campaign,
        ...buildOverrides?.({
            campaign: campaign,
            visual: primary,
            visuals: references
        })
    };
    const scope = {
        ...merged,
        ...(0, $3OMKs.resolveValues)(variation?.values, merged)
    };
    return {
        scope: scope,
        references: references,
        primary: primary
    };
};
const $c2f1205062f0f02e$export$a1fb14ed7bca0f8e = (prompt, variation, context)=>(0, $3OMKs.interpolatePrompt)(prompt, $c2f1205062f0f02e$var$resolvePromptScope(variation, context).scope);
const $c2f1205062f0f02e$export$f16d897e8e784efd = (variation, { templateId: templateId, campaign: campaign, customer: customer, visual: visual, visuals: visuals } = {})=>{
    const buildPrompt = (0, $2VxAI.getVariationType)(variation?.type)?.prompt;
    if (!buildPrompt) return null;
    const { scope: scope, references: references, primary: primary } = $c2f1205062f0f02e$var$resolvePromptScope(variation, {
        templateId: templateId,
        campaign: campaign,
        visual: visual,
        visuals: visuals
    });
    return (0, $3OMKs.interpolatePrompt)(buildPrompt({
        prompt: variation?.prompt,
        campaign: scope,
        customer: customer,
        visual: primary,
        visuals: references
    }), scope);
};
const $c2f1205062f0f02e$export$9e586be7f3691e3a = (variation, context)=>{
    const template = $c2f1205062f0f02e$export$f16d897e8e784efd(variation, context);
    return typeof template === "string" ? template : null;
};
const $c2f1205062f0f02e$export$ec52d0fe9955d5e5 = (variation, context)=>{
    const template = $c2f1205062f0f02e$export$f16d897e8e784efd(variation, context);
    return typeof template === "string" || template == null;
};
const $c2f1205062f0f02e$export$9f6491a5ed6ebfa2 = (variation, { byKey: byKey = {}, isReferenceExpected: isReferenceExpected = ()=>false } = {})=>{
    const referenceKeys = (0, $lb17q.getVariationReferenceKeys)(variation);
    const orderedUploadIds = referenceKeys.map((key)=>byKey[key]);
    const isWaitingOnUpload = referenceKeys.some((key, index)=>isReferenceExpected(key) && !orderedUploadIds[index]);
    if (isWaitingOnUpload) return null;
    return orderedUploadIds.filter(Boolean);
};
const $c2f1205062f0f02e$export$95a1d8f003c8d342 = (variation, { templateVariation: templateVariation, references: references = [], uploadIds: uploadIds = [] } = {})=>{
    const definition = (0, $2VxAI.getVariationType)(variation?.type);
    if (!definition) {
        console.warn("Unknown variation type:", variation);
        return null;
    }
    const { model: model, defaultModel: defaultModel, reference: reference = "upload" } = definition;
    const modelOptions = $c2f1205062f0f02e$var$modelOptionsOf(templateVariation);
    const primary = references[0];
    // Inherit the reference image's seed when it has one — a variation derived
    // from an already-generated asset stays visually consistent with it. `0` is
    // the "model returned no seed" sentinel from the Firefly response
    // normalizer, so it doesn't count. An explicit seed on the template
    // variation still wins. A template variation with `skipReferenceSeed: true`
    // opts out of the inheritance.
    const referenceSeed = !templateVariation?.skipReferenceSeed && typeof primary?.seed === "number" && primary.seed > 0 ? primary.seed : null;
    const payload = {
        ...referenceSeed === null ? {} : {
            seed: referenceSeed
        },
        ...modelOptions,
        // A type either pins its model or only suggests one, leaving the template
        // variation free to pick another.
        model: model ?? modelOptions.model ?? defaultModel
    };
    if (!payload.model) {
        console.warn("Variation type has no model configured:", variation);
        return null;
    }
    if (definition.action) payload.action = definition.action;
    else payload.prompt = variation?.visualPrompt;
    if (definition.negativePrompt) payload.negativePrompt = definition.negativePrompt;
    if (definition.videoSettings && variation?.videoSettings) payload.videoSettings = variation.videoSettings;
    switch(reference){
        // Operates on the reference image itself, so it needs a source file rather
        // than a prompt or a Firefly upload id.
        case "file":
            if (!primary?.filePath) {
                console.warn("Missing reference image for variation:", variation);
                return null;
            }
            payload.filePath = primary.filePath;
            break;
        // Generated from the prompt alone.
        case "none":
            break;
        default:
            payload.uploadId = uploadIds[0];
            // Only the Google models accept more than one reference image — every
            // other model keeps generating from the primary one.
            if (!!payload.uploadId && uploadIds.length > 1) {
                if ((0, $afIEk.supportsMultipleReferences)(payload.model)) payload.uploadIds = uploadIds;
                else console.warn(`Model "${payload.model}" supports a single reference image \u{2014} generating "${variation?.key}" from "${(0, $lb17q.getVariationReferenceKeys)(templateVariation)[0]}" only.`);
            }
            break;
    }
    // The generated asset records the single image it is filed under.
    payload.referenceKey = (0, $lb17q.getVariationReferenceKeys)(templateVariation)[0];
    return payload;
};

});
parcelRegister("afIEk", function(module, exports) {

$parcel$export(module.exports, "useFireflyStatus", () => $776df086cbc0ac73$export$9ba8323b90dd0598);
$parcel$export(module.exports, "supportsMultipleReferences", () => $776df086cbc0ac73$export$3541055550cebc4a);
$parcel$export(module.exports, "generateImageFn", () => $776df086cbc0ac73$export$73b565d7f9b8e198);
$parcel$export(module.exports, "useImageReferences", () => $776df086cbc0ac73$export$6025cb1f023546bb);

var $1WYFS = parcelRequire("1WYFS");
var $k6waQ = parcelRequire("k6waQ");
var $ittHc = parcelRequire("ittHc");
var $4kcQz = parcelRequire("4kcQz");

var $eF4cA = parcelRequire("eF4cA");

var $AkKc4 = parcelRequire("AkKc4");
const $776df086cbc0ac73$var$getFireflyStatus = async (params, options = {})=>{
    const response = await (0, $AkKc4.pollStatus)(params, options);
    if (!response.ok && response.status !== 429) return {
        status: "failed",
        ...response.data
    };
    const data = response.data ?? {};
    const hasOutputs = data?.outputs?.length > 0 || data?.result?.outputs?.length > 0;
    return {
        status: hasOutputs ? "succeeded" : "in_progress",
        ...data
    };
};
const $776df086cbc0ac73$export$9ba8323b90dd0598 = (options = {}, { onStatus: onStatus, getStatusFn: getStatusFn = $776df086cbc0ac73$var$getFireflyStatus } = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { signal: signal })=>{
            const { statusUrl: statusUrl, shouldSave: shouldSave, modelVersion: modelVersion } = variables;
            const statusResponse = await getStatusFn({
                statusUrl: statusUrl,
                shouldSave: shouldSave,
                modelVersion: modelVersion
            }, {
                signal: variables.signal ?? signal
            });
            const status = statusResponse?.status;
            if (status === "succeeded") return statusResponse;
            else if (status === "failed") throw new Error("Render job failed", {
                cause: statusResponse
            });
            onStatus?.(statusResponse);
            throw new Error("Firefly image generation in progress", {
                cause: statusResponse
            });
        },
        retryDelay: 5000,
        retry: (failureCount, error)=>{
            if (error?.message?.toLowerCase()?.includes("failed")) return false;
            return true;
        },
        meta: {
            errorMessage: "Failed to fetch Firefly job status. Please try again."
        },
        ...options
    });
};
const $776df086cbc0ac73$export$5f0484a9983fe2c = 6;
const $776df086cbc0ac73$export$3541055550cebc4a = (model)=>typeof model === "string" && model.startsWith("nano-banana");
const $776df086cbc0ac73$var$buildModelParams = (model, options = {})=>{
    const { prompt: prompt, negativePrompt: negativePrompt } = options;
    // Callers can pin the seed — e.g. to keep a variation visually consistent
    // with the reference image it is derived from. Otherwise pick a random one.
    const seed = /* typeof options.seed === "number"
      ? options.seed
      : */ Math.floor(Math.random() * 900000) + 100000;
    switch(model){
        case "veo":
            const veoParams = {
                seeds: [
                    seed
                ],
                output: {
                    storeInputs: false
                },
                locale: "en-US",
                size: [
                    {
                        width: 1920,
                        height: 1080
                    }
                ],
                modelId: model,
                modelVersion: "3.1-generate",
                prompt: prompt,
                duration: 5,
                generateAudio: false,
                generationMetadata: {
                    module: "text2video"
                }
            };
            /**
       * "negativePrompt": "cartoon, vector art, & bad aesthetics & poor aesthetic"
       */ if (options.negativePrompt) videoParams.negativePrompt = options.negativePrompt;
            if (options.uploadId) ret.referenceBlobs = [
                {
                    id: options.uploadId,
                    usage: "general",
                    promptReference: 1
                }
            ];
            if (options.duration) veoParams.duration = options.duration;
            return veoParams;
        case "video":
            const videoParams1 = {
                n: 1,
                seeds: [
                    seed
                ],
                output: {
                    storeInputs: false
                },
                locale: "en-US",
                sizes: [
                    {
                        width: 1920,
                        height: 1080,
                        numFrames: 128
                    }
                ],
                modelVersion: "video1_8_standard",
                videoSettings: {
                    cameraMotion: "camera pan left",
                    shotAngle: "eye_level shot",
                    shotSize: "close-up shot"
                },
                prompt: prompt,
                caiClaimVersion: 2,
                modelSpecificPayload: {
                    caiClaimVersion: 2
                }
            };
            if (options.uploadId) videoParams1.image = {
                source: {
                    id: options.uploadId
                }
            };
            if (options.numFrames) videoParams1.sizes[0].numFrames = options.numFrames;
            /**
       * "conditions": [
            {
              "source": { "id": "2cdb8aa4-2217-4d65-845a-fb5d5219c98c" },  // first frame
              "placement": { "start": 0 }
            },
            {
              "source": { "id": "b3dd9b94-1b7b-41b4-8cb9-3d06785aff5b" },  // last frame
              "placement": { "start": 1 }
            }
          ]
       */ if (options.imageConditions) videoParams1.image = {
                conditions: options.imageConditions
            };
            /** Note: For image‑to‑video (I2V), only cameraMotion is honored; shotAngle and shotSize are inferred from the reference image.
       * cameraMotion
       * "camera pan left"
       * "camera pan right"
       * "camera zoom in"
       * "camera zoom out"
       * "camera tilt up"
       * "camera tilt down"
       * "camera locked down"
       * "camera handheld"
       * shotAngle
       * "aerial shot"
       * "eye_level shot"
       * "high angle shot"
       * "low angle shot"
       * "top-down shot"
       * "none of the above"
       * shotSize
       * "close-up shot"
       * "extreme close-up shot"
       * "medium shot"
       * "long shot"
       * "extreme long shot"
       * "none of the above"
       */ if (options.videoSettings) videoParams1.videoSettings = {
                ...videoParams1.videoSettings,
                ...options.videoSettings
            };
            return videoParams1;
        case "nano-banana":
        case "nano-banana-2":
        case "nano-banana-3":
            const nanoBananaParams = {
                n: 1,
                seeds: [
                    seed
                ],
                output: {
                    storeInputs: true,
                    cai: {
                        directive: "sign_for_policy_mandate"
                    }
                },
                prompt: prompt,
                modelId: "gemini-flash",
                modelVersion: model,
                generationMetadata: {
                    module: "text2image",
                    submodule: "ff-image-generate"
                },
                modelSpecificPayload: {
                    parameters: {
                        addWatermark: false
                    },
                    aspectRatio: options.aspectRatio
                },
                groundSearch: true,
                caiClaimVersion: 2
            };
            if (options.aspectRatio) {
                if ([
                    "1:1",
                    "4:3",
                    "3:4",
                    "16:9",
                    "9:16",
                    "21:9",
                    "auto"
                ].includes(options.aspectRatio)) nanoBananaParams.modelSpecificPayload.aspectRatio = options.aspectRatio;
                else console.warn(`Invalid aspect ratio "${options.aspectRatio}" provided. Skipping aspect ratio setting.`);
            }
            if (options.size) {
                if ([
                    512,
                    1024,
                    2048,
                    4096
                ].includes(options.size)) nanoBananaParams.size = {
                    width: options.size,
                    height: options.size
                };
                else if (options.size?.width && options.size?.height) nanoBananaParams.size = {
                    width: options.size.width,
                    height: options.size.height
                };
                else console.warn(`Invalid size "${options.size}" provided. Skipping size setting.`);
            }
            if (Array.isArray(options.uploadIds) && options.uploadIds.length) {
                const uploadIds = Array.from(new Set(options.uploadIds.filter(Boolean)));
                if (uploadIds.length > $776df086cbc0ac73$export$5f0484a9983fe2c) console.warn(`Received ${uploadIds.length} image references, only the first ${$776df086cbc0ac73$export$5f0484a9983fe2c} are sent to "${model}".`);
                nanoBananaParams.referenceBlobs = uploadIds.slice(0, $776df086cbc0ac73$export$5f0484a9983fe2c).map((id)=>({
                        id: id,
                        usage: "general"
                    }));
            } else if (options.uploadId) nanoBananaParams.referenceBlobs = [
                {
                    id: options.uploadId,
                    usage: "general"
                }
            ];
            if (options.groundSearch) nanoBananaParams.groundSearch = options.groundSearch;
            return nanoBananaParams;
        case "image5":
            const ret1 = {
                seeds: [
                    seed
                ],
                output: {
                    cai: {
                        directive: "sign_for_policy_mandate"
                    },
                    storeInputs: true
                },
                prompt: prompt,
                modelId: "firefly_image",
                modelVersion: "image5",
                generationMetadata: {
                    module: "text2image"
                },
                caiClaimVersion: 2,
                modelSpecificPayload: {
                    caiClaimVersion: 2
                }
            };
            if (options.uploadId) ret1.referenceBlobs = [
                {
                    id: options.uploadId,
                    usage: "general"
                }
            ];
            if (options.aspectRatio && !options.uploadId) {
                if ([
                    "1:1",
                    "4:3",
                    "3:4",
                    "16:9",
                    "9:16",
                    "auto"
                ].includes(options.aspectRatio)) ret1.aspectRatio = options.aspectRatio;
                else console.warn(`Invalid aspect ratio "${options.aspectRatio}" provided. Skipping aspect ratio setting.`);
            }
            if (options.resolutionLevel) {
                if ([
                    "1MP",
                    "2.4MP",
                    "4MP"
                ].includes(options.resolutionLevel)) ret1.resolutionLevel = options.resolutionLevel;
                else console.warn(`Invalid resolution level "${options.resolutionLevel}" provided. Skipping resolution level setting.`);
            }
            if (options.promptReasoner) {
                if ([
                    "speed",
                    "quality",
                    "budget"
                ].includes(options.promptReasoner)) ret1.modelSpecificPayload.promptReasoner = options.promptReasoner;
                else console.warn(`Invalid prompt reasoner "${options.promptReasoner}" provided. Skipping prompt reasoner setting.`);
            }
            if (options.size) {
                const { width: width, height: height } = options.size;
                if (typeof width === "number" && typeof height === "number" && width > 0 && height > 0) ret1.size = {
                    width: width,
                    height: height
                };
                else console.warn(`Invalid size provided. Width and height should be positive numbers. Skipping size setting.`);
            }
            if (negativePrompt) ret1.negativePrompt = negativePrompt;
            return ret1;
        case "image4_ultra":
        default:
            const ff4Params = {
                model: "image4_ultra",
                prompt: prompt,
                promptEnhance: "on",
                contentClass: "photo",
                detailLevel: "full",
                visualIntensity: 8,
                caiClaimVersion: 2
            };
            if (negativePrompt) ff4Params.negativePrompt = negativePrompt;
            if (options.aspectRatio) switch(options.aspectRatio){
                case "1:1":
                    ff4Params.size = {
                        width: 2048,
                        height: 2048
                    };
                    break;
                case "4:3":
                    ff4Params.size = {
                        width: 2304,
                        height: 1792
                    };
                    break;
                case "3:4":
                    ff4Params.size = {
                        width: 1792,
                        height: 2304
                    };
                    break;
                case "9:16":
                    ff4Params.size = {
                        width: 1536,
                        height: 2688
                    };
                    break;
                case "16:9":
                default:
                    ff4Params.size = {
                        width: 2688,
                        height: 1536
                    };
                    break;
            }
            else ff4Params.size = {
                width: 2688,
                height: 1536
            };
            if (options.uploadId) ff4Params.style = {
                strength: 50,
                imageReference: {
                    source: {
                        uploadId: options.uploadId
                    }
                }
            };
            return ff4Params;
    }
};
const $776df086cbc0ac73$export$221554c045fca429 = {
    all: [
        "firefly"
    ],
    imageReferences: ()=>[
            ...$776df086cbc0ac73$export$221554c045fca429.all,
            "imageReference"
        ],
    imageReference: (key)=>[
            ...$776df086cbc0ac73$export$221554c045fca429.imageReferences(),
            key
        ],
    images: ()=>[
            ...$776df086cbc0ac73$export$221554c045fca429.all,
            "image"
        ],
    image: (model, imageReferenceId, prompt)=>[
            ...$776df086cbc0ac73$export$221554c045fca429.images(),
            model,
            imageReferenceId,
            prompt
        ]
};
const $776df086cbc0ac73$export$13a1b55002f2299 = (sourceReference, sourceReferenceKey, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $776df086cbc0ac73$export$221554c045fca429.imageReference(sourceReferenceKey ?? sourceReference),
        queryFn: async ({ signal: signal })=>(0, $AkKc4.uploadFireflyImage)(sourceReference, {
                signal: signal
            }),
        enabled: !!sourceReference,
        staleTime: 86400000,
        ...options
    });
const $776df086cbc0ac73$export$73b565d7f9b8e198 = async (options = {}, signal, statusCallback = null)=>{
    const { model: model, s3FilePath: s3FilePath, ...modelOptions } = options;
    // Rate limiting/queueing is handled per Firefly endpoint inside
    // `generateImage`, so requests over the limit wait for a free slot (and for
    // any `Retry-After` window) instead of failing fast.
    return (0, $AkKc4.generateImage)({
        ...$776df086cbc0ac73$var$buildModelParams(model, modelOptions),
        ...s3FilePath ? {
            s3FilePath: s3FilePath
        } : {}
    }, {
        signal: signal
    }, statusCallback);
};
const $776df086cbc0ac73$export$4d45c07cb6c71148 = (model, imageReferenceId, prompt, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $776df086cbc0ac73$export$221554c045fca429.image(model, imageReferenceId, prompt),
        queryFn: ({ signal: signal })=>$776df086cbc0ac73$export$73b565d7f9b8e198({
                model: model,
                uploadId: imageReferenceId,
                prompt: prompt
            }, signal),
        enabled: !!imageReferenceId && !!prompt,
        staleTime: 3600000,
        ...options
    });
const $776df086cbc0ac73$export$59ac85164418794d = (sourceReference, sourceReferenceKey, options = {})=>{
    return (0, $4kcQz.useQuery)($776df086cbc0ac73$export$13a1b55002f2299(sourceReference, sourceReferenceKey, options));
};
const $776df086cbc0ac73$export$6025cb1f023546bb = (sources, options = {})=>{
    const list = (0, $eF4cA.useMemo)(()=>(sources ?? []).filter((source)=>!!source?.key && !!source?.url), [
        sources
    ]);
    return (0, $ittHc.useQueries)({
        queries: list.map((source)=>$776df086cbc0ac73$export$13a1b55002f2299(source.url, source.cacheKey ?? source.key, options)),
        combine: (results)=>({
                byKey: Object.fromEntries(results.map((result, idx)=>[
                        list[idx].key,
                        result.data?.id ?? null
                    ])),
                isFetching: results.some((result)=>result.isFetching),
                isError: results.some((result)=>result.isError),
                error: results.find((result)=>result.isError)?.error ?? null
            })
    });
};
const $776df086cbc0ac73$export$7b51a2dd413357dc = (model, imageReferenceId, prompt, options = {})=>{
    return (0, $4kcQz.useQuery)($776df086cbc0ac73$export$4d45c07cb6c71148(model, imageReferenceId, prompt, options));
};

});
parcelRegister("ittHc", function(module, exports) {

$parcel$export(module.exports, "useQueries", () => $d731f85f64d24bcd$export$408667c6c87da1e5);

var $7ClmI = parcelRequire("7ClmI");

var $8UjFd = parcelRequire("8UjFd");

var $hzoc8 = parcelRequire("hzoc8");

var $4OZmE = parcelRequire("4OZmE");

var $1rcdI = parcelRequire("1rcdI");

var $eF4cA = parcelRequire("eF4cA");

var $3ur2P = parcelRequire("3ur2P");
var $hnhg4 = parcelRequire("hnhg4");
var $eI6kU = parcelRequire("eI6kU");
var $hpFA5 = parcelRequire("hpFA5");
"use client";
//#region src/useQueries.ts
/**
* The `useQueries` hook can be used to fetch a variable number of queries.
*
* The `queries` key accepts an array with query option objects mostly identical to `useQuery` — the top-level
* `subscribed` option isn't accepted per query (see `placeholderData` below for another difference). A custom
* `QueryClient` is supplied once, as `useQueries`' own top-level second argument, rather than per query.
*
* Having the same query key more than once in the array of query objects may cause some data to be shared
* between queries. To avoid this, consider de-duplicating the queries and map the results back to the desired
* structure.
*
* The `combine` option can be used to combine the results of the queries into a single value. The result will
* be structurally shared to be as referentially stable as possible.
* @param options - The `queries` array to run, and the optional `combine` and `subscribed` options.
* @param queryClient - Use this to provide a custom `QueryClient`. Otherwise, the one from the nearest context
* will be used.
* @returns The combined result. Without `combine`, this is an array with all the query results, in the same
* order as the input. When `combine` is provided, this is the value returned by `combine` instead.
* @throws {Error} The error of the first query that should be thrown to the nearest error boundary (see
* `throwOnError`). While suspending, it throws a promise instead.
* @remarks The `combine` function only re-runs if it changed referentially, or if any of the query results
* changed. An inlined `combine` function, as shown in the example below, therefore runs on every render — wrap
* it in `useCallback`, or extract it to a stable function reference if it doesn't have any dependencies, to
* avoid that.
*
* Unlike `useQuery`, `useQueries` cannot infer the `data` argument of an _inline_ `select` from its sibling
* `queryFn`. Because `useQueries` infers the type of the whole `queries` array at once, the `select` parameter
* of a query object written inline cannot be contextually typed from that same object's `queryFn`, so it falls
* back to `unknown` — a [known TypeScript limitation](https://github.com/TanStack/query/issues/6556). Annotate
* the `select` parameter explicitly, or define the query with {@link queryOptions}, which resolves its types in
* a single object _before_ it reaches `useQueries`, to work around this — see the example below. The same
* limitation applies to {@link useSuspenseQueries}.
*
* `placeholderData` is supported here too, but unlike `useQuery`, it doesn't receive information from
* previously rendered queries, because the number of queries can differ between renders.
* @example
* ```tsx
* import { useQueries } from '@tanstack/react-query'
*
* function Posts({ ids }: { ids: Array<number> }) {
*   const postQueries = useQueries({
*     queries: ids.map((id) => ({
*       queryKey: ['post', id],
*       queryFn: () => fetchPost(id),
*       staleTime: Infinity,
*     })),
*   })
*
*   return (
*     <ul>
*       {postQueries.map((query, index) => {
*         if (query.isPending) return <li key={ids[index]}>Loading...</li>
*         if (query.isError) return <li key={ids[index]}>Error: {query.error.message}</li>
*         return <li key={ids[index]}>{query.data.title}</li>
*       })}
*     </ul>
*   )
* }
* ```
* @example
* Combining results into a single value:
* ```tsx
* import { useQueries } from '@tanstack/react-query'
*
* function Posts({ ids }: { ids: Array<number> }) {
*   const { data, isPending, isError } = useQueries({
*     queries: ids.map((id) => ({
*       queryKey: ['post', id],
*       queryFn: () => fetchPost(id),
*     })),
*     combine: (postQueries) => {
*       return {
*         data: postQueries.map((query) => query.data),
*         isPending: postQueries.some((query) => query.isPending),
*         isError: postQueries.some((query) => query.isError),
*       }
*     },
*   })
*
*   if (isPending) return 'Loading...'
*   if (isError) return 'Error loading posts'
*
*   return (
*     <ul>
*       {data.map((post) => (
*         <li key={post?.id}>{post?.title}</li>
*       ))}
*     </ul>
*   )
* }
* ```
* @example
* Typing `select` via {@link queryOptions}. Note that spreading a `queryOptions` result and overriding
* `select` inline still falls back to `unknown` — wrap the spread in `queryOptions` again so the override is
* resolved before it reaches `useQueries`:
* ```tsx
* import { queryOptions, useQueries } from '@tanstack/react-query'
*
* const postOptions = (id: number) =>
*   queryOptions({
*     queryKey: ['post', id],
*     queryFn: () => fetchPost(id),
*   })
*
* function PostTitle({ id }: { id: number }) {
*   const [{ data: broken }] = useQueries({
*     queries: [
*       {
*         ...postOptions(id),
*         // ❌ `data` is `unknown` here
*         select: (data) => data.title,
*       },
*     ],
*   })
*
*   const [{ data: fixed }] = useQueries({
*     queries: [
*       queryOptions({
*         ...postOptions(id),
*         // ✅ `data` is `Post`
*         select: (data) => data.title,
*       }),
*     ],
*   })
*
*   return <h1>{fixed}</h1>
* }
* ```
*/ function $d731f85f64d24bcd$export$408667c6c87da1e5({ queries: queries, ...options }, queryClient) {
    const client = (0, $7ClmI.useQueryClient)(queryClient);
    const isRestoring = (0, $8UjFd.useIsRestoring)();
    const errorResetBoundary = (0, $hzoc8.useQueryErrorResetBoundary)();
    const subscribed = options.subscribed !== false;
    const defaultedQueries = $eF4cA.useMemo(()=>queries.map((opts)=>{
            const defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
            return defaultedOptions;
        }), [
        queries,
        client,
        isRestoring,
        subscribed
    ]);
    defaultedQueries.forEach((queryOptions)=>{
        (0, $1rcdI.ensureSuspenseTimers)(queryOptions);
        const query = client.getQueryCache().get(queryOptions.queryHash);
        (0, $4OZmE.ensurePreventErrorBoundaryRetry)(queryOptions, errorResetBoundary, query);
    });
    (0, $4OZmE.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $eF4cA.useState(()=>new (0, $eI6kU.QueriesObserver)(client, defaultedQueries, options));
    const [optimisticResult, getCombinedResult, trackResult] = observer.getOptimisticResult(defaultedQueries, options.combine);
    const shouldSubscribe = !isRestoring && subscribed;
    $eF4cA.useSyncExternalStore($eF4cA.useCallback((onStoreChange)=>shouldSubscribe ? observer.subscribe((0, $hnhg4.notifyManager).batchCalls(onStoreChange)) : (0, $3ur2P.noop), [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $eF4cA.useEffect(()=>{
        observer.setQueries(defaultedQueries, options);
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    const suspensePromises = optimisticResult.some((result, index)=>(0, $1rcdI.shouldSuspend)(defaultedQueries[index], result)) ? optimisticResult.flatMap((result, index)=>{
        const opts = defaultedQueries[index];
        if (opts && (0, $1rcdI.shouldSuspend)(opts, result)) {
            const queryObserver = new (0, $hpFA5.QueryObserver)(client, opts);
            return (0, $1rcdI.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        const query = defaultedQueries[index];
        return query && (0, $4OZmE.getHasError)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            throwOnError: query.throwOnError,
            query: client.getQueryCache().get(query.queryHash),
            suspense: query.suspense
        });
    });
    if (firstSingleResultWhichShouldThrow) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}

});
parcelRegister("eI6kU", function(module, exports) {

$parcel$export(module.exports, "QueriesObserver", () => $ab5a16f97efe3eb2$export$15352e437905ad4c);

var $3ur2P = parcelRequire("3ur2P");

var $jdy3Z = parcelRequire("jdy3Z");

var $hnhg4 = parcelRequire("hnhg4");

var $hpFA5 = parcelRequire("hpFA5");
//#region src/queriesObserver.ts
/**
* Returns the items of `array1` that are not in `array2`.
* @param array1 - The items to filter.
* @param array2 - The items to exclude.
* @returns A new array with the items of `array1` that are not in `array2`.
*/ function $ab5a16f97efe3eb2$var$difference(array1, array2) {
    const excludeSet = new Set(array2);
    return array1.filter((x)=>!excludeSet.has(x));
}
/**
* A `QueriesObserver` watches an array of queries at once, exposing them as
* a single array of `QueryObserverResult`s (or, when a `combine` option is
* given, as a combined value derived from that array). It manages one
* internal `QueryObserver` per query, and is the primitive that framework
* adapters (e.g. `useQueries`) build their hooks on top of.
* @example
* ```ts
* const observer = new QueriesObserver(queryClient, [
*   { queryKey: ['post', 1], queryFn: fetchPost },
*   { queryKey: ['post', 2], queryFn: fetchPost },
* ])
*
* const unsubscribe = observer.subscribe((result) => {
*   console.log(result)
* })
* ```
*/ var $ab5a16f97efe3eb2$export$15352e437905ad4c = class extends (0, $jdy3Z.Subscribable) {
    #client;
    #result;
    #queries;
    #options;
    #observers;
    #combinedResult;
    #lastCombine;
    #lastResult;
    #lastQueryHashes;
    #observerMatches = [];
    constructor(client, queries, options){
        super();
        this.#client = client;
        this.#options = options;
        this.#queries = [];
        this.#observers = [];
        this.#result = [];
        this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.#observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.#onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    /**
	* Stops observing all queries: clears all listeners and destroys every
	* underlying `QueryObserver` this observer manages.
	*/ destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    /**
	* Replaces the set of queries being observed. Existing `QueryObserver`s
	* are reused for queries that match an already-observed query hash;
	* observers for queries that are no longer present are destroyed, and new
	* observers are created and subscribed to for newly added queries.
	* @param queries - The options of the queries to observe.
	* @param options - Replaces the observer's options, e.g. its `combine` function.
	* @example
	* ```ts
	* observer.setQueries([
	*   { queryKey: ['post', 1], queryFn: fetchPost },
	*   { queryKey: ['post', 3], queryFn: fetchPost },
	* ])
	* ```
	*/ setQueries(queries, options) {
        this.#queries = queries;
        this.#options = options;
        (0, $hnhg4.notifyManager).batch(()=>{
            const prevObservers = this.#observers;
            const newObserverMatches = this.#findMatchingObservers(this.#queries);
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasLengthChange = prevObservers.length !== newObservers.length;
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            const hasStructuralChange = hasLengthChange || hasIndexChange;
            const hasResultChange = hasStructuralChange ? true : newResult.some((result, index)=>{
                const prev = this.#result[index];
                return !prev || !(0, $3ur2P.shallowEqualObjects)(result, prev);
            });
            if (!hasStructuralChange && !hasResultChange) return;
            if (hasStructuralChange) {
                this.#observerMatches = newObserverMatches;
                this.#observers = newObservers;
            }
            this.#result = newResult;
            if (!this.hasListeners()) return;
            if (hasStructuralChange) {
                $ab5a16f97efe3eb2$var$difference(prevObservers, newObservers).forEach((observer)=>{
                    observer.destroy();
                });
                $ab5a16f97efe3eb2$var$difference(newObservers, prevObservers).forEach((observer)=>{
                    observer.subscribe((result)=>{
                        this.#onUpdate(observer, result);
                    });
                });
            }
            this.#notify();
        });
    }
    /**
	* Returns the most recently computed array of `QueryObserverResult`s, one
	* per observed query, in the same order as the queries passed to the
	* constructor or `setQueries`.
	* @returns The current results.
	* @example
	* ```ts
	* const results = observer.getCurrentResult()
	* const data = results.map((result) => result.data)
	* ```
	*/ getCurrentResult() {
        return this.#result;
    }
    /**
	* Returns the underlying `Query` instances currently being observed, in
	* the same order as the queries passed to the constructor or `setQueries`.
	* @returns The observed queries.
	*/ getQueries() {
        return this.#observers.map((observer)=>observer.getCurrentQuery());
    }
    /**
	* Returns the underlying `QueryObserver` instances this observer manages,
	* in the same order as the queries passed to the constructor or
	* `setQueries`.
	* @returns The managed query observers.
	*/ getObservers() {
        return this.#observers;
    }
    /**
	* The `QueriesObserver` counterpart of {@link QueryObserver#getOptimisticResult} — computes
	* the result for the given (already-defaulted) queries right now, synchronously. Called by
	* framework adapters (e.g. `useQueries`) ahead of subscribing, returning a tuple of the raw
	* per-query results, a function to compute the combined result from them, and a function to
	* wrap the results for property-access tracking.
	* @param queries - The defaulted options of the queries to compute the result for.
	* @param combine - The `combine` function used by the returned `combineResult`, if any.
	* @returns A tuple of the per-query results, a function that computes the combined result, and a
	* function that returns the results wrapped for property-access tracking.
	*/ getOptimisticResult(queries, combine) {
        const matches = this.#findMatchingObservers(queries);
        const result = matches.map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
        const queryHashes = matches.map((match)=>match.defaultedQueryOptions.queryHash);
        return [
            result,
            (r)=>{
                return this.#combineResult(r ?? result, combine, queryHashes);
            },
            ()=>{
                return this.#trackResult(result, matches);
            }
        ];
    }
    #trackResult(result, matches) {
        const trackedProps = /* @__PURE__ */ new Set();
        return matches.map((match, index)=>{
            const observerResult = result[index];
            return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, (accessedProp)=>{
                if (!trackedProps.has(accessedProp)) {
                    trackedProps.add(accessedProp);
                    matches.forEach((m)=>{
                        m.observer.trackProp(accessedProp);
                    });
                }
            }) : observerResult;
        });
    }
    #combineResult(input, combine, queryHashes) {
        if (combine) {
            const lastHashes = this.#lastQueryHashes;
            const queryHashesChanged = queryHashes !== void 0 && lastHashes !== void 0 && (lastHashes.length !== queryHashes.length || queryHashes.some((hash, i)=>hash !== lastHashes[i]));
            if (this.#result !== this.#lastResult || queryHashesChanged || combine !== this.#lastCombine) {
                this.#lastCombine = combine;
                this.#lastResult = this.#result;
                if (queryHashes !== void 0) this.#lastQueryHashes = queryHashes;
                this.#combinedResult = (0, $3ur2P.replaceEqualDeep)(this.#combinedResult, combine(input));
            }
            return this.#combinedResult;
        }
        return input;
    }
    #shouldSkipCombine() {
        return !this.#options?.combine || this.#observers.some((observer, index)=>{
            return observer.options.suspense && this.#result[index]?.data === void 0;
        });
    }
    #findMatchingObservers(queries) {
        const prevObserversMap = /* @__PURE__ */ new Map();
        this.#observers.forEach((observer)=>{
            const key = observer.options.queryHash;
            if (!key) return;
            const previousObservers = prevObserversMap.get(key);
            if (previousObservers) previousObservers.push(observer);
            else prevObserversMap.set(key, [
                observer
            ]);
        });
        const observers = [];
        queries.forEach((options)=>{
            const defaultedOptions = this.#client.defaultQueryOptions(options);
            const observer = prevObserversMap.get(defaultedOptions.queryHash)?.shift() ?? new (0, $hpFA5.QueryObserver)(this.#client, defaultedOptions);
            observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: observer
            });
        });
        return observers;
    }
    #onUpdate(observer, result) {
        const index = this.#observers.indexOf(observer);
        if (index !== -1) {
            this.#result = this.#result.slice();
            this.#result[index] = result;
            this.#notify();
        }
    }
    #notify() {
        if (this.hasListeners()) {
            const shouldSkipCombine = this.#shouldSkipCombine();
            const previousResult = this.#combinedResult;
            const newResult = shouldSkipCombine ? previousResult : this.#combineResult(this.#trackResult(this.#result, this.#observerMatches), this.#options?.combine);
            if (shouldSkipCombine || previousResult !== newResult) (0, $hnhg4.notifyManager).batch(()=>{
                this.listeners.forEach((listener)=>{
                    listener(this.#result);
                });
            });
        }
    }
};

});



parcelRegister("3OMKs", function(module, exports) {

$parcel$export(module.exports, "formatter", () => $2c7bdafbfd4179f1$export$4bedd3f7d169f13c);
$parcel$export(module.exports, "keyVisualsSection", () => $2c7bdafbfd4179f1$export$ba88a3f577066d6a);
$parcel$export(module.exports, "referenceKeyElements", () => $2c7bdafbfd4179f1$export$a3d76ebcc5549695);
$parcel$export(module.exports, "CAMPAIGN_OVERRIDES", () => $2c7bdafbfd4179f1$export$f7c030ffc40cf160);
$parcel$export(module.exports, "systemUser", () => $2c7bdafbfd4179f1$export$86d94f63174e7474);
$parcel$export(module.exports, "interpolatePrompt", () => $2c7bdafbfd4179f1$export$b63b452171bb74f8);
$parcel$export(module.exports, "resolveValues", () => $2c7bdafbfd4179f1$export$9418dc7ef614f74b);
$parcel$export(module.exports, "abstractTopicPrompt", () => $2c7bdafbfd4179f1$export$6fb526b792910e46);
$parcel$export(module.exports, "campaignTopicPrompt", () => $2c7bdafbfd4179f1$export$87924b6a9b7db7ad);
$parcel$export(module.exports, "keyframePrompt", () => $2c7bdafbfd4179f1$export$de16e8b993d4e7a2);
$parcel$export(module.exports, "safeKeyframePrompt", () => $2c7bdafbfd4179f1$export$8204c2e46c53ba5a);
$parcel$export(module.exports, "backgroundVariationPrompt", () => $2c7bdafbfd4179f1$export$f0ab5eba0ced1763);
$parcel$export(module.exports, "objectVariationPrompt", () => $2c7bdafbfd4179f1$export$f598bfedae2346b4);
$parcel$export(module.exports, "SKIP_IMAGE_LABELING_TEMPLATES", () => $2c7bdafbfd4179f1$export$5f6db90cb8eaca28);
/**
 * The building blocks every variation type's prompt is written with.
 *
 * This module is the prompt *machinery*: describing reference images,
 * expanding `{{Var}}` placeholders, and the campaign overrides that decide
 * which slot a variation fills. What each type actually says lives with that
 * type, in `variationTypes.js`.
 */ const $2c7bdafbfd4179f1$export$4bedd3f7d169f13c = new Intl.ListFormat("en", {
    style: "long",
    type: "conjunction"
});
// ---------------------------------------------------------------------------
// Reference image descriptions
//
// A variation references one image (`referenceKey: "IMG1"`) or several
// (`referenceKey: ["IMG1", "IMG2"]`). Prompt builders receive both `visual`
// (the primary reference, unchanged) and `visuals` (every reference, in
// order), and describe them through the helpers below so a single reference
// keeps producing exactly the prompt it did before.
// ---------------------------------------------------------------------------
/** Every reference image of a variation, in order, primary first. */ const $2c7bdafbfd4179f1$var$referenceVisuals = (data)=>(data?.visuals?.length ? data.visuals : [
        data?.visual
    ]).filter(Boolean);
const $2c7bdafbfd4179f1$export$1eb78ae10f4cfec1 = (data)=>$2c7bdafbfd4179f1$var$referenceVisuals(data).filter((visual)=>!!visual?.labeling?.description);
const $2c7bdafbfd4179f1$export$2973232ea6746667 = (data)=>{
    const visuals = $2c7bdafbfd4179f1$export$1eb78ae10f4cfec1(data);
    if (visuals.length <= 1) return visuals[0]?.labeling?.description ?? "";
    return visuals.map((visual, idx)=>`Reference image ${idx + 1} shows:\n${visual.labeling.description}`).join("\n\n");
};
const $2c7bdafbfd4179f1$export$ba88a3f577066d6a = (data)=>{
    const visuals = $2c7bdafbfd4179f1$export$1eb78ae10f4cfec1(data);
    if (!visuals.length) return "";
    return visuals.length === 1 ? `I already have one key visual, it shows:\n${$2c7bdafbfd4179f1$export$2973232ea6746667(data)}` : `I already have ${visuals.length} key visuals:\n\n${$2c7bdafbfd4179f1$export$2973232ea6746667(data)}`;
};
const $2c7bdafbfd4179f1$export$a3d76ebcc5549695 = (data)=>Array.from(new Set($2c7bdafbfd4179f1$var$referenceVisuals(data).flatMap((visual)=>visual?.labeling?.keyElements ?? [])));
// ---------------------------------------------------------------------------
// Image variation prompts
//
// `getVariationPromptTemplate` (at the end of this section) resolves a
// variation's prompt from the two lookup tables below:
//
//   1. `CAMPAIGN_OVERRIDES[templateId][variation.key]` — campaign fields that
//      depend on the slot a variation fills (which persona, banner or scene it
//      renders). Merged over the campaign before the prompt is built.
//   2. `VARIATION_TYPES[variation.type].prompt` — the Zoltar ID/user-message
//      request, or a plain prompt string, built from the merged data.
//
// Both are plain data, so supporting a new template key or variation type is a
// single entry rather than another branch across two nested switches.
// ---------------------------------------------------------------------------
/**
 * A `csc-overview` audience slot: the Nth generated audience — falling back to
 * the first three when fewer were generated — plus the campaign's Nth tagline.
 */ const $2c7bdafbfd4179f1$var$cscAudienceSlot = (audienceIndex, taglineIndex)=>({ campaign: campaign })=>({
            audience: campaign?.audiences?.[audienceIndex] ?? campaign?.audiences?.[audienceIndex % 3],
            tagline: campaign?.taglines?.[taglineIndex]?.en
        });
/** The Nth persona's audience / visited location. */ const $2c7bdafbfd4179f1$var$personaAudience = (n)=>({ campaign: campaign })=>({
            Audience: campaign?.[`Persona-${n}-audience`]
        });
const $2c7bdafbfd4179f1$var$personaLocation = (n)=>({ campaign: campaign })=>({
            "Location-visited": campaign?.[`Persona-${n}-location`]
        });
/** Feed a campaign field into the differently-named field the prompt reads. */ const $2c7bdafbfd4179f1$var$campaignField = (target, source)=>({ campaign: campaign })=>({
            [target]: campaign?.[source]
        });
/** An `ai` banner visual: that banner's headline/copy plus the reference. */ const $2c7bdafbfd4179f1$var$aiBannerContext = (n)=>({ campaign: campaign, visual: visual, visuals: visuals })=>({
            Context: `This image will be used as a banner visual for a campaign with the following details:
Headline: ${campaign?.[`Banner${n}-slogan`]}
Copy: ${campaign?.[`Banner${n}-copy`]}

${$2c7bdafbfd4179f1$export$1eb78ae10f4cfec1({
                visual: visual,
                visuals: visuals
            }).length > 1 ? "The original images show:" : "The original image shows:"}
${$2c7bdafbfd4179f1$export$2973232ea6746667({
                visual: visual,
                visuals: visuals
            })}`
        });
const $2c7bdafbfd4179f1$var$ucxPersona1AudienceCity = ({ campaign: campaign })=>({
        Audience: campaign?.["Persona-1-audience"],
        City: campaign?.["Persona-1-location"]
    });
const $2c7bdafbfd4179f1$var$UCX_CAMPAIGN_OVERRIDES = {
    // UCX-campaign-audience
    "IMG1-V1": $2c7bdafbfd4179f1$var$ucxPersona1AudienceCity,
    "IMG1-V3": $2c7bdafbfd4179f1$var$ucxPersona1AudienceCity,
    // UCX-topic-abstract
    "IMG1-V2": $2c7bdafbfd4179f1$var$campaignField("Campaign-topic", "Form-title"),
    "IMG1-V4": $2c7bdafbfd4179f1$var$campaignField("Campaign-topic", "Invitation-email-copy"),
    // UCX-location-thumbnail
    "Thumb-1-City": $2c7bdafbfd4179f1$var$personaLocation(1),
    "Thumb-2-City": $2c7bdafbfd4179f1$var$personaLocation(2),
    // UCX-audience-thumbnail
    "Thumb-1-Audience": $2c7bdafbfd4179f1$var$personaAudience(1),
    "Thumb-2-Audience": $2c7bdafbfd4179f1$var$personaAudience(2)
};
/** `ao-overview` / `cx-coworker` only reuse the first persona's thumbnail. */ const $2c7bdafbfd4179f1$var$AO_CAMPAIGN_OVERRIDES = {
    // UCX-audience-thumbnail
    "Thumb-1-Audience": $2c7bdafbfd4179f1$var$personaAudience(1)
};
const $2c7bdafbfd4179f1$export$f7c030ffc40cf160 = {
    "csc-overview": {
        "IMG1-A1": $2c7bdafbfd4179f1$var$cscAudienceSlot(0, 0),
        "IMG1-A2": $2c7bdafbfd4179f1$var$cscAudienceSlot(1, 0),
        "IMG1-A3": $2c7bdafbfd4179f1$var$cscAudienceSlot(2, 0),
        "IMG3-A1": $2c7bdafbfd4179f1$var$cscAudienceSlot(3, 2),
        "IMG3-A2": $2c7bdafbfd4179f1$var$cscAudienceSlot(4, 2),
        "IMG3-A3": $2c7bdafbfd4179f1$var$cscAudienceSlot(5, 2)
    },
    ucx: $2c7bdafbfd4179f1$var$UCX_CAMPAIGN_OVERRIDES,
    "ucx-vo": $2c7bdafbfd4179f1$var$UCX_CAMPAIGN_OVERRIDES,
    "ao-overview": $2c7bdafbfd4179f1$var$AO_CAMPAIGN_OVERRIDES,
    "ao-overview-vo": $2c7bdafbfd4179f1$var$AO_CAMPAIGN_OVERRIDES,
    "cx-coworker": $2c7bdafbfd4179f1$var$AO_CAMPAIGN_OVERRIDES,
    foundry: {
        // Each scene variation renders the same-named campaign field.
        "TV-commercial-scene-1": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "TV-commercial-scene-1"),
        "TV-commercial-scene-2": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "TV-commercial-scene-2"),
        "TV-commercial-scene-3": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "TV-commercial-scene-3")
    },
    ai: {
        "IMG1-V2": $2c7bdafbfd4179f1$var$aiBannerContext(1),
        "IMG2-V2": $2c7bdafbfd4179f1$var$aiBannerContext(2),
        "IMG3-V2": $2c7bdafbfd4179f1$var$aiBannerContext(3),
        "IMG-competition-A": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "Banner-competition-A-visual"),
        "IMG-competition-B": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "Banner-competition-B-visual"),
        "IMG-competition-C": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "Banner-competition-C-visual"),
        "IMG-competition-D": $2c7bdafbfd4179f1$var$campaignField("TV-commercial-scene", "Banner-competition-D-visual")
    }
};
const $2c7bdafbfd4179f1$export$86d94f63174e7474 = (systemPromptId, user)=>({
        systemPromptId: systemPromptId,
        promptTemplate: [
            {
                role: "user",
                prompt_template: user
            }
        ]
    });
/**
 * Placeholder syntax for `{{Var}}` expansion.
 *
 * Deliberately narrow — only simple identifiers match, so Handlebars control
 * syntax (`{{#if}}`, `{{/if}}`, `{{~#if}}`, `{{>…}}`, `{{!…}}`) is never
 * touched. Zoltar system prompts are Handlebars templates, so mangling those
 * would be a silent corruption.
 */ const $2c7bdafbfd4179f1$var$VARIABLE_PATTERN = /\{\{\s*([\w.-]+)\s*\}\}/g;
const $2c7bdafbfd4179f1$var$hasValue = (value)=>value !== undefined && value !== null && value !== "";
/**
 * Expands `{{Var}}` from `scope`, dropping any line that still contains an
 * unresolved placeholder — a dangling `Tone:` with nothing after it reads worse
 * to an image model than no line at all. Returns `null` when nothing is left.
 */ const $2c7bdafbfd4179f1$var$interpolate = (text, scope)=>{
    if (typeof text !== "string") return text;
    return text.split("\n").map((line)=>{
        let isResolved = true;
        const expanded = line.replace($2c7bdafbfd4179f1$var$VARIABLE_PATTERN, (match, name)=>{
            const value = scope?.[name];
            if (!$2c7bdafbfd4179f1$var$hasValue(value)) {
                isResolved = false;
                return match;
            }
            return value;
        });
        return isResolved ? expanded : null;
    }).filter((line)=>line !== null).join("\n").trim() || null;
};
const $2c7bdafbfd4179f1$export$b63b452171bb74f8 = (result, scope)=>{
    if (result && typeof result === "object" && !Array.isArray(result)) return {
        ...result,
        promptTemplate: $2c7bdafbfd4179f1$export$b63b452171bb74f8(result.promptTemplate, scope)
    };
    if (Array.isArray(result)) return result.map((part)=>({
            ...part,
            prompt_template: $2c7bdafbfd4179f1$var$interpolate(part?.prompt_template, scope)
        }));
    return $2c7bdafbfd4179f1$var$interpolate(result, scope);
};
const $2c7bdafbfd4179f1$export$9418dc7ef614f74b = (values, campaign)=>Object.fromEntries(Object.entries(values ?? {}).map(([name, raw])=>[
            name,
            typeof raw === "string" ? $2c7bdafbfd4179f1$var$interpolate(raw, campaign) : raw
        ]).filter(([, value])=>$2c7bdafbfd4179f1$var$hasValue(value)));
const $2c7bdafbfd4179f1$export$6fb526b792910e46 = ({ customer: customer, visual: visual, visuals: visuals }, topic)=>$2c7bdafbfd4179f1$export$86d94f63174e7474("common-image-abstract", `I have a client named: ${customer?.name}
I want to focus on the campaign about: ${topic}
Consider this brand\u{2019}s marketing communication style, brand voice, style, atmosphere.

${$2c7bdafbfd4179f1$export$ba88a3f577066d6a({
        visual: visual,
        visuals: visuals
    })}`);
const $2c7bdafbfd4179f1$export$87924b6a9b7db7ad = ({ customer: customer, campaign: campaign }, usageNote)=>$2c7bdafbfd4179f1$export$86d94f63174e7474("common-image-abstract", `[Company]: ${customer?.name}
[Campaign-topic]: ${campaign?.["Campaign-topic"]}

${usageNote}`);
const $2c7bdafbfd4179f1$export$de16e8b993d4e7a2 = (campaignCreativeRule, suffix = "")=>`Analyze the input image and classify what you received:

- PACKSHOT \u{2014} product isolated on white/neutral background:
  add an atmospheric environment and lighting that complements the product's colour palette

- POLISHED AD \u{2014} styled product scene, no people:
  keep the exact background, environment, mood, and lighting \u{2014} only change the camera angle

- CAMPAIGN CREATIVE \u{2014} contains real people, text, or slogans:
  ${campaignCreativeRule}
  preserve the product and its branding exactly

- CHARACTER/MASCOT CREATIVE \u{2014} contains illustrated or CGI brand characters:
  preserve the characters pixel-perfect in appearance, expression, and proportions.
  Place them in a clean, brand-consistent set or environment.
  Remove non-product text only.

- FASHION/APPAREL:
  preserve garments and styling exactly, only adjust composition

---

CRITICAL RULES:

- Treat logos, labels, and branding printed on the product as part of the product \u{2192} DO NOT remove or alter them
- Only remove external text elements such as headlines, captions, or overlays
- Preserve product details pixel-faithfully (including typography on packaging)
- Do not hallucinate or redesign branding

---

Generate a photorealistic marketing image.
No external text, no overlays, no captions.
Preserve the product and its branding exactly.
Change only the angle and composition.${suffix}`;
const $2c7bdafbfd4179f1$export$8f07a5b6f9c44f33 = `Leave generous negative space (copy space) around the main subject on every side \u{2014} center it, with the subject occupying only about one-quarter of the frame's shorter dimension, real environment filling the rest. For a tall or narrow subject (bottle, mug, tube, glass), leave extra empty space above and below it, even if smaller still. At most one edge may touch the frame border; other sides need clear open space. If a person is in frame, their full head and hands must stay visible. Keep the subject clear of one side where a text/CTA panel may later be added.

Always show a real, depicted environment with visible content \u{2014} never a flat color, plain gradient, or empty studio backdrop. No borders, vignettes, letterboxing, frames, or stripes at the edges.`;
const $2c7bdafbfd4179f1$export$8204c2e46c53ba5a = ()=>`${$2c7bdafbfd4179f1$export$8f07a5b6f9c44f33}

---

Classify the input image:

- PACKSHOT (product on white/neutral background): add an atmospheric environment and lighting matching the product's palette.
- POLISHED AD (styled scene, no people): keep the exact background, mood, and lighting \u{2014} only change the camera angle.
- CAMPAIGN CREATIVE (real people, text, or slogans): remove all non-product text, preserve the product and branding exactly.
- CHARACTER/MASCOT (illustrated/CGI characters): preserve characters pixel-perfect; place in a clean, brand-consistent set; remove non-product text only.
- FASHION/APPAREL: preserve garments and styling exactly, only adjust composition.

CRITICAL: logos, labels, and branding on the product are part of the product \u{2014} never remove or alter them. Only remove external text. Preserve product details pixel-faithfully. Never hallucinate or redesign branding.

Generate a photorealistic marketing image. No external text, overlays, or captions. Preserve the product and branding exactly. Change only angle and composition.`;
const $2c7bdafbfd4179f1$export$f0ab5eba0ced1763 = (environmentNote)=>`Generate a fresh environment variation for this subject \u{2014} one of several background options to choose from. Keep the same composition archetype as the reference: matching camera height/angle and the frame area left open for the subject.

First recognize the background type, then vary accordingly:
- Real location (street, interior, landscape): swap for a different, physically plausible real-world setting where this subject could actually exist \u{2014} vary place, season, or time of day. Never force an implausible setting (e.g. a vehicle inside a tiny domestic room).
- Stylized effect (particle burst, smoke/dust, splash, light burst): keep the same effect type and energy, vary only material, color, or light \u{2014} never replace with a literal photographed location.
- Plain studio backdrop/limbo: vary only tone, color, or gradient.

Preserve the reference's own emotional register \u{2014} if moody, dramatic, or high-energy (common in automotive/sports/action campaigns), keep that energy rather than forcing cheerfulness. Only avoid content that reads as genuinely disturbing or grim beyond the reference's own intent.

If people are present, keep identity unchanged; pose may adapt naturally. Brand elements (logos, liveries, uniforms, signage) must stay exactly unchanged. No text, logos, watermarks.

${environmentNote}`;
const $2c7bdafbfd4179f1$export$f598bfedae2346b4 = (angleNote)=>`This is a real product/object that will be shown to actual customers, so brand accuracy is critical: you must not invent, redesign, restyle, recolor, or add any feature, pattern, logo, or detail that isn't already visible in the reference. Treat this strictly as photographing the same physical object from a new angle, not as creative reinterpretation.
Render this exact subject from ${angleNote}, framed as a standard, natural product-photography hero shot (not a close-up, not a cropped fragment) \u{2014} the whole subject fully visible, at a scale and framing typical of professional catalog/ad photography.
Preserve, with zero deviation: exact shape, proportions, materials, textures, colors, branding, logos, and every visible design detail. Where the new angle reveals a surface not visible in the reference, extend it in a way that is fully consistent with the visible design language and materials \u{2014} never invent a new pattern, color, or feature there.
Isolate the subject on a soft, uniform studio gradient background using a gentle, low-saturation tint pulled from the subject's own dominant colors (not flat white, not a clashing hue), with a soft, physically plausible contact shadow from a single soft overhead-front light source.
Do not add extra objects, text, logos, or watermarks.`;
const $2c7bdafbfd4179f1$export$5f6db90cb8eaca28 = new Set([
    "one-adobe"
]);

});

parcelRegister("2VxAI", function(module, exports) {

$parcel$export(module.exports, "getVariationType", () => $221af626b9e7ee2b$export$7341e92e1c06c24e);

var $l3mmJ = parcelRequire("l3mmJ");

var $3OMKs = parcelRequire("3OMKs");
/** No words, signs, logos or people — the abstract key visuals' constant. */ const $221af626b9e7ee2b$var$NO_TEXT_NEGATIVE_PROMPT = "words, signs, logos, icons, people, faces";
const $221af626b9e7ee2b$var$COMBINE_PROMPT = `Combine two references into one seamless advertising photograph. Reference 1 is the subject, isolated on a temporary studio gradient backdrop, shown at a specific angle and rotation \u{2014} discard that backdrop, preserving the subject's exact shape, proportions, colors, materials, branding, and design with zero redesign, and its given rotation exactly as shown.

Reference 2 is a style reference only, not a background to copy \u{2014} take from it only the general mood, environment type, color palette, and light quality, not its literal composition, camera angle, or content. If it contains a real person, use their presence only as scene-type context \u{2014} do not regenerate that specific person.

Design a new environment genuinely perspective-consistent with the subject's own angle in Reference 1 \u{2014} ground plane, horizon, and structure must match its orientation, never looking inserted sideways. Make this environment a distinct, fresh take on Reference 2's mood, since this subject may be composited multiple times \u{2014} each result must read as a genuinely different environment, not a near-duplicate of Reference 2 or other variants.

Composition safety margin: regardless of how tightly Reference 1 is cropped, compose the final image with generous negative space around the subject \u{2014} no more than roughly 40-50% of the frame's shorter dimension (less for tall/narrow subjects, clear margin above/below). Keep clear of a margin zone on at least one side for a possible text/CTA overlay. Never crop a person's head or face.

Add a realistic contact shadow and reflections matching the environment's light. Blend edges seamlessly, no halo. Keep the mood positive. Do not add extra objects, text, logos, or watermarks. Style: professional advertising photography, realistic grounding.`;
const $221af626b9e7ee2b$export$b9b8dde08a196935 = {
    // ---------------------------------------------------------------------------
    // Campaign key visuals (CSC / UCX)
    // ---------------------------------------------------------------------------
    "CSC-audience": {
        prompt: ({ customer: customer, campaign: campaign, visual: visual, visuals: visuals })=>(0, $3OMKs.systemUser)("CSC-image-audience", `I have a client named: ${customer?.name}

I want to focus on the campaign about:
[Campaign]: ${campaign?.title}
[Audience]: ${campaign?.audience}${!!(0, $3OMKs.keyVisualsSection)({
                visual: visual,
                visuals: visuals
            }) ? `\n\n${(0, $3OMKs.keyVisualsSection)({
                visual: visual,
                visuals: visuals
            })}` : ""}${(0, $3OMKs.referenceKeyElements)({
                visual: visual,
                visuals: visuals
            }).length ? `\n\nKey elements:
${(0, $3OMKs.formatter).format((0, $3OMKs.referenceKeyElements)({
                visual: visual,
                visuals: visuals
            }))}` : ""}`),
        model: "image5",
        reference: "upload"
    },
    audience: {
        // Legacy alias of `CSC-audience` — kept generating, never prompted.
        model: "image5",
        reference: "upload"
    },
    "CSC-abstract": {
        prompt: (data)=>(0, $3OMKs.abstractTopicPrompt)(data, data.campaign?.title),
        model: "image4_ultra",
        reference: "upload",
        negativePrompt: $221af626b9e7ee2b$var$NO_TEXT_NEGATIVE_PROMPT
    },
    abstract: {
        // Legacy alias of `CSC-abstract` — kept generating, never prompted.
        model: "image4_ultra",
        reference: "upload",
        negativePrompt: $221af626b9e7ee2b$var$NO_TEXT_NEGATIVE_PROMPT
    },
    "UCX-topic-abstract": {
        prompt: (data)=>(0, $3OMKs.abstractTopicPrompt)(data, data.campaign?.["Campaign-topic"]),
        model: "image4_ultra",
        reference: "upload",
        negativePrompt: $221af626b9e7ee2b$var$NO_TEXT_NEGATIVE_PROMPT
    },
    "UCX-campaign-audience": {
        prompt: ({ customer: customer, campaign: campaign, visual: visual, visuals: visuals })=>(0, $3OMKs.systemUser)("common-image-audience", `[Context]:
[Customer]: ${customer?.name}
[Audience]: ${campaign?.["Audience"] ?? campaign?.["Campaign-audience-name"]}
[City]: ${campaign?.["City"] ?? campaign?.["Persona-1-location"]}

${(0, $3OMKs.keyVisualsSection)({
                visual: visual,
                visuals: visuals
            })}`),
        model: "image5",
        reference: "upload"
    },
    "UCX-audience-product": {
        // Legacy alias of `UCX-campaign-audience` — kept generating, never prompted.
        model: "image5",
        reference: "upload"
    },
    "UCX-location": {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.systemUser)("UCX-image-location-based", `[Location-visited]: ${campaign?.["Location-visited"]}${!!campaign?.["Location-based-text"] ? `\n[Message]: ${campaign?.["Location-based-text"]}` : ""}`),
        model: "image5",
        reference: "none"
    },
    "UCX-tv": {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.systemUser)("UCX-image-connected-tv", `[Audience]: ${campaign?.["Persona-1-audience"]}
[Connected-TV-program-topic]: ${campaign?.["Connected-TV-program-topic"]}`),
        model: "image5",
        reference: "none"
    },
    "UCX-location-thumbnail": {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.systemUser)("UCX-image-location-based", `[Location-visited]: ${campaign?.["Persona-1-location"]}

This image will be used as a thumbnail, so it should be more focused on the location and less on the product. The image should look good when cropped to a square format and when displayed at smaller sizes (e.g. 200x200).`),
        model: "image5",
        reference: "none"
    },
    "UCX-audience-thumbnail": {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.systemUser)("UCX-image-audience-thumbnail", `[Audience]: ${campaign?.["Audience"] ?? campaign?.["Campaign-audience-name"]}`),
        model: "image5",
        reference: "none"
    },
    "UCX-campaign-topic": {
        prompt: (data)=>(0, $3OMKs.campaignTopicPrompt)(data, "This image will be used as a hero image for the sign-up page of a campaign website, so it should be visually striking and clearly convey the campaign topic. The image should look good when displayed in a wide format (e.g. 1200x600)."),
        model: "image4_ultra",
        reference: "upload",
        negativePrompt: $221af626b9e7ee2b$var$NO_TEXT_NEGATIVE_PROMPT
    },
    "UCX-share": {
        prompt: (data)=>(0, $3OMKs.campaignTopicPrompt)(data, "This image will be used as a preview image when sharing campaign content on social media, so it should be eye-catching and clearly represent the campaign. The image should look good when displayed in a square format (e.g. 1200x1200)."),
        model: "image4_ultra",
        reference: "upload",
        negativePrompt: $221af626b9e7ee2b$var$NO_TEXT_NEGATIVE_PROMPT
    },
    // ---------------------------------------------------------------------------
    // Keyframes and camera variations
    // ---------------------------------------------------------------------------
    Keyframe: {
        prompt: ()=>(0, $3OMKs.keyframePrompt)("remove all people and non-product text (e.g., slogans, headlines, overlays),"),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Keyframe-people": {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.keyframePrompt)("remove all non-product text (e.g., slogans, headlines, overlays),", campaign?.["Campaign-audience-name"] ? `\n\nThe image should appeal to the following audience: ${campaign?.["Campaign-audience-name"]}` : ""),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Keyframe-people-safe": {
        prompt: ()=>(0, $3OMKs.safeKeyframePrompt)(),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Keyframe-brand-visibility": {
        // Filled here: generic interpolation drops lines with unresolved placeholders.
        prompt: ({ campaign: campaign })=>{
            const inputs = {
                "company-name": campaign?.["Company-name"] ?? "",
                product: campaign?.["Campaign-product"] ?? ""
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($l3mmJ))).replace(/\{\{(company-name|product)\}\}/g, (_, key)=>inputs[key]);
        },
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Keyframe-extend": {
        prompt: ()=>`preserve original composition and subject exactly, extend background naturally and seamlessly, no new foreground elements, consistent lighting and style`,
        model: "image5",
        reference: "upload"
    },
    Angle: {
        prompt: ()=>`Use the reference image as the source of truth. Keep every subject IDENTICAL (shape/geometry, proportions, materials, colors, textures, small details, and any original label text/branding on the subject). Do not redesign or reinterpret anything. Keep the same lighting style and background style.

Create a clearly different result by changing ONLY the camera angle and framing/composition (crop, distance, perspective, depth of field).
IF there is ONE main object: make the change obvious by using an extreme viewpoint (top-down, bottom-up, strong diagonal), a tighter or wider crop, and a stronger placement (off-centre, more negative space). The object may be repositioned or rotated in space only if it remains physically identical.
IF there are MULTIPLE objects: keep all objects identical and present, but improve composition by rearranging their spacing and relative placement (closer/farther, slight overlap, clearer hierarchy). Do not add or remove objects.
IF there is a PERSON: do not change the person\u{2019}s identity, face, hair, clothing, body shape, pose, or expression. Only change camera angle and crop to improve composition.
Photorealistic result. No new elements. No stylization.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    Zoom: {
        prompt: ()=>`Create an abstract variation by zooming into the object.
Focus on material texture, surface detail, and form.
Extreme close\u{2011}up composition.
Keep original lighting, color, and material characteristics.
The object must remain recognizable through texture and form, not shape alone.
No new colors, no stylistic effects.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    Mix: {
        prompt: ()=>`Create another variation of this image, keeping the same object type and style but changing the zoom, crop or mix.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    Composition: {
        prompt: ()=>`Create another variation of this image, keeping the same object type and style but changing the composition.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    Sketch: {
        prompt: ()=>`Keep the exact same camera angle, framing, proportions, and composition.
Transform the image into a black and white sketch.
Line-based drawing style, hand-drawn or pencil-like.
No color, no shading tones other than black and white.
Do not simplify or exaggerate shapes.
The sketch must align perfectly with the original structure.
White, paper-like background.`,
        model: "image5",
        reference: "upload"
    },
    Draft: {
        prompt: ()=>`Using only the photo as reference, generate a multi\u{2011}panel step\u{2011}by\u{2011}step digital sketch sequence of the object, arranged in a clean grid on a pure white background.
Early panels:
Show very loose geometric construction using simple boxes and cylinders with perspective guide lines. Lines are light, rough, and overlapping.
Middle panels:
Gradually add loose contour lines and basic structural details. Construction lines remain visible. The drawing stays sketchy and exploratory.
Final two panels:
Introduce limited color accents sampled from the original photo. Color should be subtle and incomplete, applied loosely like a light digital watercolor or color pencil wash. Lines remain dominant. No full fill, no realism, no polished rendering.
Style: digital sketch, industrial design drawing, thin grey or black lines, imperfect strokes, visible process.
Background: pure white only.
Constraints: no paper texture, no canvas grain, no scanning artefacts, no shading, no gradients, no photorealism.
No text of any kind: no numbers, no captions, no labels, no watermarks, no logos.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    // ---------------------------------------------------------------------------
    // Product and 3D renders
    // ---------------------------------------------------------------------------
    "3D": {
        prompt: ()=>`Recreate the object as a precise 3D model.
Render the object in white material on a pure white background.
No textures, no color, no branding.
Change the camera angle and/or composition compared to the reference image, while keeping correct proportions and scale.
Soft, neutral studio lighting.
Clean, professional 3D render as if from a 3D modelling or CAD visualization program.
No artistic or stylized effects.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "3D-simple": {
        prompt: ()=>`Create an image of this product, visualized as a simple 3D render.

Keep its exact shape, proportions, and details. Use a uniform light-grey matte material with no branding, colors, or textures.

Grey #707070 background, perspective grid lines on the floor, soft lighting, 3/4 view.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "3D-mesh": {
        prompt: ()=>`Create an image of the exact product from the reference, visualized as a 3D mesh render in the same view.

Keep its exact shape, proportions, and details. Use a uniform white matte material with no branding, colors, or textures, and with clearly visible blue mesh/wireframe lines following the product geometry.

Black background, soft lighting, 3/4 view.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    Object: {
        prompt: ()=>`This is the source "keyframe" in a marketing pipeline. It will split into an isolated subject and a standalone background, later recombined with other new backgrounds/subjects. Produce the isolated subject asset here.

Identify the true subject using this priority, not just raw depth in the frame:
1. If any manufactured object, vehicle, structure, or venue carries visible branding, a logo, or brand name (printed on its body, livery, or packaging), that branded item is the subject \u{2014} even if people or other elements are closer to camera.
2. Otherwise, if a person is clearly wearing, holding, or using a product as the evident focus (fashion, apparel, a held package), that is the subject.
3. Otherwise, fall back to the foreground hero element: closest to camera, sharpest focus, largest scale, at the frame's main focal point.

Anything not selected counts as removable environment, including people or props staged nearby without being the branded item itself.

Keep the subject completely untouched in its original position, scale, crop, angle, and pose, so it aligns pixel-for-pixel with the original composition for later recombination with the background.

Remove everything else and replace it with a soft, seamless studio gradient: a gentle, low-saturation tint pulled from the subject's own dominant colors, brighter near the subject, deeper at the edges. Avoid flat white or clashing color. Add a soft, physically plausible contact shadow matching one soft overhead-front light source.

Do not redesign, recolor, or reinterpret the subject, and do not add new objects, text, logos, or watermarks.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Object-variation": {
        prompt: ()=>(0, $3OMKs.objectVariationPrompt)(`a complementary three-quarter angle on the opposite side from a typical default view`),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Object-variation-side": {
        prompt: ()=>(0, $3OMKs.objectVariationPrompt)(`a direct side profile view`),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Object-variation-front": {
        prompt: ()=>(0, $3OMKs.objectVariationPrompt)(`a front-facing (or back-facing, whichever is more visually informative) view`),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Object-3D": {
        prompt: ()=>`Convert the reference image into a clean 3D digital-twin mesh preview render of the main object shown, whatever it is.
Preserve the exact silhouette, proportions, and geometric structure of the reference object with no reinterpretation of shape or design.
Remove all color, material texture, branding, logos, and surface graphics \u{2014} replace with a uniform matte light-grey clay material (studio CAD-preview look).
Overlay a visible, even quadrilateral wireframe grid across the entire surface of the object, following its true topology and curvature.
Fully isolate the object from its background; float it in empty space at a slight three-quarter angle, matching the object's natural resting orientation.
Add soft, neutral studio lighting from above-front with gentle ambient occlusion in the recesses, and a soft diffused contact shadow beneath the object.
Background: seamless neutral grey-to-dark-grey radial gradient, no props, no text, no reflections, no background objects.
Overall style: clean CAD/3D-scan visualization render, high detail, sharp wireframe lines, no motion blur, no depth of field, centered composition.`,
        model: "image5",
        reference: "upload"
    },
    "Object-3D-macro": {
        prompt: ()=>`Ignore the reference image's overall composition and camera angle entirely. Create an extreme close-up macro shot of a single small fragment of the object's surface, such as a corner, edge, seam, or panel intersection, filling most of the frame, with parts of it extending beyond the frame edges. Choose a fragment and camera angle clearly different from what a straightforward crop of the reference would show, as if the camera moved to a new position around the object before zooming in. Critically, do not distort, bend, round, warp, or invent any geometry: all edges, corners, and flat panels must stay exactly as straight, flat, or angled as in the reference object, with correct real-world perspective. Keep the same clay material and wireframe topology style, applied consistently to the visible fragment. Remove any residual printed text, labels, logos, or graphic artifacts, leaving pure clay and wireframe only. Soft neutral studio lighting, gentle ambient occlusion emphasizing surface detail and the wireframe grid. Background: seamless neutral grey-to-dark-grey gradient, softly out of focus behind the fragment, no props, no text. Style: clean CAD/3D-scan macro detail render, sharp wireframe lines, shallow depth of field isolating the close-up.`,
        model: "image5",
        reference: "upload"
    },
    Combine: {
        prompt: ()=>$221af626b9e7ee2b$var$COMBINE_PROMPT,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    // ---------------------------------------------------------------------------
    // Scenes, people and thumbnails
    // ---------------------------------------------------------------------------
    "TV-scene": {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.systemUser)("common-image-tv-commercial-scene", `[Campaign-product]: ${campaign?.["Campaign-product"] ?? ""}
[TV-commercial-scene]:
${campaign?.["TV-commercial-scene"]}`),
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "User-thumbnail": {
        // Legacy alias of `TV-scene` — kept generating, never prompted.
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    Audience: {
        prompt: ({ campaign: campaign })=>(0, $3OMKs.systemUser)("common-image-audience", `[Context]:
${campaign?.["Context"]}`),
        model: "image5",
        reference: "upload"
    },
    "OneAdobe-product-variation": {
        prompt: ()=>`Create a new product shot of the {{Product-name}} from a different angle.
Keep the product completely consistent with the provided reference image: same shape, proportions, colors, materials, details, branding, and design. Do not add, remove, or change any product features.
Place it on a clean grey #909090 background and use professional studio lighting.
No additional texts or icons.
Show the product from this angle: {{Angle}}`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "OneAdobe-photoshoot": {
        prompt: ()=>`Image 1 is the original key visual from a photoshoot. Image 2 is a reference showing {{KV-theme-short}}, which also appears in Image 1. Image 2 only identifies what must be excluded; do not use it as content, style, or inspiration for the output.

Create another photo from the same key visual photoshoot, at the same location and within the same overall scenario, but capture a distinctly different moment.

The image must clearly feel like it belongs to the same campaign and creative concept as the original key visual. Preserve the same visual energy, emotional tone, brand expression, styling, atmosphere, lighting mood, and overall creative intent. Keep the people's appearance, clothing, and styling consistent with Image 1.

Make the image clearly different from the original by changing multiple photographic attributes at once:
- camera angle
- camera height
- distance to subject
- lens choice and perspective
- framing and crop
- subject pose and body orientation
- direction of movement or gaze

Do not recreate the original composition. Avoid similar framing, similar crop, similar perspective, similar pose, or a near-duplicate viewpoint.

The following must not appear anywhere in the new image, including in the background, at the edges, or partially visible:
1. The element shown in Image 2 ({{KV-theme-short}}), in any form.
2. The product: {{Product-name}}, including its packaging, branding, or lookalikes.
Wherever these would naturally have appeared, show what would realistically be there instead, matching the surrounding textures, lighting, shadows, and perspective. No leftover traces, ghosting, or blur.

The result should feel like a different selected hero shot from the same premium key visual photoshoot, not a variation of the same frame and not a generic lifestyle photo. Keep the same level of visual impact, campaign quality, and key visual presence as the original. Keep the main subject as the visual focal point and positioned near the center area.

Photorealistic. No packshot, no visual motif, no additional CGI elements, no text, image only.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "OneAdobe-location": {
        prompt: ()=>`Image 1 is the original key visual from a photoshoot. Image 2 is a reference showing {{KV-theme-short}}, which also appears in Image 1. Image 2 only identifies what must be excluded; do not use it as content, style, or inspiration for the output.

Create another photo from the same photoshoot, at the same location, showing only the location itself: an empty, clean environment with no people, no subjects, and no props.

The image must clearly feel like it belongs to the same campaign. Preserve the same atmosphere, lighting mood, time of day, color grading, and photographic style, as well as the location's architecture, materials, textures, and colors.

Make the image clearly different from the original by changing multiple photographic attributes at once:
- camera angle
- camera height
- distance
- lens choice and perspective
- framing and crop

Do not recreate the original composition. Avoid similar framing, similar crop, similar perspective, or a near-duplicate viewpoint. Show a different part of the space or a different perspective on it.

Remove everything except the location. The following must not appear anywhere in the new image, including in the background, at the edges, or partially visible:
1. The element shown in Image 2 ({{KV-theme-short}}), in any form.
2. The product: {{Product-name}}, including its packaging, branding, or lookalikes.
3. People: no people, figures, silhouettes, reflections of people, shadows of people, or body parts.
4. Any other foreground subjects, props, signage, banners, or decorative objects that were added for the photoshoot. Keep only the permanent, built or natural elements of the location itself (structure, surfaces, furniture or fixtures that belong to the space, vegetation, sky).
Wherever removed elements would naturally have appeared, show what would realistically be there instead, matching the surrounding textures, lighting, shadows, and perspective. No leftover traces, ghosting, or blur.

The result should look like a professional, premium location photograph: a clean, empty, inviting space with a strong sense of place. No single subject is required as the focal point; compose the frame around the architecture and atmosphere of the location.

Photorealistic. No packshot, no visual motif, no additional CGI elements, no text, image only.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "OneAdobe-KV-variation": {
        prompt: ()=>`Create another photo from the same key visual photoshoot for {{Product-name}} campaign, at the same location and within the same overall scenario, but capture a distinctly different moment.

The image must clearly feel like it belongs to the same campaign and creative concept as the original key visual. Preserve the same visual energy, emotional tone, brand expression, styling, atmosphere, lighting mood, and overall creative intent. Keep the people's appearance, clothing, and styling consistent with Image 1.

Make the image clearly different from the original by changing multiple photographic attributes at once:
- camera angle
- camera height
- distance to subject
- lens choice and perspective
- framing and crop
- subject pose and body orientation
- direction of movement or gaze

Do not recreate the original composition. Avoid similar framing, similar crop, similar perspective, similar pose, or a near-duplicate viewpoint.

The result should feel like a different selected hero shot from the same premium key visual photoshoot, not a variation of the same frame and not a generic lifestyle photo. Keep the same level of visual impact, campaign quality, and key visual presence as the original. Keep the main subject as the visual focal point and positioned near the center area.

Photorealistic, no text, image only.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "OneAdobe-user-grid": {
        prompt: ()=>`NO TEXT. NO TYPOGRAPHY. NO LETTERS. NO WORDS. NO NUMBERS. TEXT-FREE IMAGE ONLY.

4x4 image grid of user thumbnails \u{2014} 16 square user photos, filling the whole area, no margins, no borders, no text, just images. Each face covers at least 50% of its square.

All 16 must be visibly different, unique people \u{2014} never repeat the same person or look. Make them a realistic, diverse cross-section of the target audience below, varying naturally in age, gender, ethnicity, style and setting in the proportions you'd actually see in that group.

Each photo must have a clearly different background \u{2014} vary the setting, location and lighting so no two share the same environment. Draw the settings from places this audience would realistically be.

Target audience is: {{Product-target-audience-demographics}}`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    // Alternative, prompt-driven orbit shot kept for reference:
    //   systemUser("common-video-time-freeze-orbit", data?.visual?.labeling)
    Video: {
        prompt: ()=>`Camera is almost static, like a fixed tripod with a tiny rotation.
No zoom, pan, tilt, or shake.`,
        model: "video",
        reference: "upload",
        videoSettings: true
    },
    // ---------------------------------------------------------------------------
    // Backgrounds
    // ---------------------------------------------------------------------------
    Background: {
        prompt: ()=>`Identify the true subject of this image using this priority, not just raw depth in the frame:
1. If any manufactured object, vehicle, structure, or venue carries visible branding, a logo, or brand name (printed on its body, livery, or packaging), that branded item is the subject \u{2014} even if people or other elements are closer to camera.
2. Otherwise, if a person is clearly wearing, holding, or using a product as the evident focus (fashion, apparel, a held package), that is the subject.
3. Otherwise, fall back to the foreground hero element: closest to camera, sharpest focus, largest scale, at the frame's main focal point.

Remove that identified subject from this image completely, including any shadows or reflections it casts. Reconstruct and fill in the area where it was removed so the background looks natural, seamless, and continuous \u{2014} as if it was never there. Preserve the original background's colors, lighting, textures, perspective, and depth of field exactly as they are. Do not add any new objects, patterns, or elements that weren't part of the original background. The output should be a clean, empty version of the same scene.`,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "Background-variation-subtle": {
        prompt: ()=>(0, $3OMKs.backgroundVariationPrompt)(`For this variant, make the change subtle and closely related to the reference.`),
        model: "image5",
        reference: "upload"
    },
    "Background-variation-distinct": {
        prompt: ()=>(0, $3OMKs.backgroundVariationPrompt)(`For this variant, make the change clearly distinct from the reference \u{2014} a different setting, palette, or material within the same general category.`),
        model: "image5",
        reference: "upload"
    },
    "Background-variation-dramatic": {
        prompt: ()=>(0, $3OMKs.backgroundVariationPrompt)(`For this variant, make the change as dramatic and far-reaching as plausible, while staying physically and stylistically sensible for this subject.`),
        model: "image5",
        reference: "upload"
    },
    // ---------------------------------------------------------------------------
    // Config-driven and non-generative types
    // ---------------------------------------------------------------------------
    // Generic, fully config-driven type: the variation supplies its own prompt
    // body, which — like every other entry here — is then expanded against
    // `campaign` + `variation.values`. Covers the static, campaign-backed and
    // mixed cases in one type.
    prompt: {
        prompt: ({ prompt: prompt })=>prompt ?? null,
        defaultModel: "nano-banana-3",
        reference: "upload"
    },
    "labeling-prompt": {
        prompt: ({ prompt: prompt, visual: visual })=>{
            const fields = Array.isArray(prompt) ? prompt : [
                prompt
            ];
            const parts = fields.map((field)=>visual?.labeling?.[field]);
            return parts.length > 0 && parts.every((part)=>typeof part === "string" && part.trim().length > 0) ? parts.join("\n\n") : null;
        },
        defaultModel: "nano-banana-3",
        reference: "none"
    },
    // Non-generative Photoshop action. It needs no prompt, but the pipeline only
    // generates a variation once it has a `visualPrompt`, so this doubles as the
    // marker that unblocks it and as the label shown in the edit dialog.
    "Action:RemoveBackground": {
        prompt: ()=>"Remove background",
        model: "photoshop",
        reference: "file",
        action: "removeBackground"
    }
};
const $221af626b9e7ee2b$export$7341e92e1c06c24e = (type)=>$221af626b9e7ee2b$export$b9b8dde08a196935[type];

});
parcelRegister("l3mmJ", function(module, exports) {
module.exports = "INPUTS\n- COMPANY NAME: {{company-name}}\n- PRODUCT: {{product}}\n  (Optional. If PRODUCT is empty, missing, or still shows an unfilled placeholder, ignore it completely and identify the product from the image alone.)\n  (If PRODUCT names something the reference image does not show, the product in the image is the product. Use PRODUCT only as context for the brand; never add, swap in, or redesign a product to match it.)\n\n---\n\nTASK\n\nTurn the reference image into one finished, professional advertising photograph for {{company-name}}: the same product, branding, people, and campaign idea, reframed only where needed and refined to the standard of the brand's own flagship campaigns.\n\nThe result is always a single photograph, taken in one place, at one moment, with one camera and one lighting setup. It is never a collage, photomontage, composite, picture-in-picture, framed picture placed in a room, poster, graphic layout, or 3D render. Everything in the frame is a real, physical object that a photographer could have put in front of the camera, except characters already present in a CHARACTER/MASCOT reference; no CGI element is ever added.\n\nPriority order when rules conflict:\n1. The product and its branding, exactly as in the reference (for SERVICE / PLACE / DIGITAL: the place's signature features, the service moment, or the device and its interface).\n2. People, characters, and garments, exactly as in the reference.\n3. Physical and photographic coherence: anatomy, perspective, light, contact, and scale.\n4. The reference's own background, lighting, and color grade.\n5. The brand's visual language.\n6. Composition.\n\n---\n\nSTEP 1 — CLASSIFY THE REFERENCE\n\n- PACKSHOT: product on a white, plain, or cut-out background, no people.\n- POLISHED AD: styled photographic scene without people.\n- CAMPAIGN CREATIVE: photograph with people, often with text, slogans, or logos laid over it.\n- CHARACTER/MASCOT: illustrated or CGI characters.\n- FASHION/APPAREL: garments or complete looks as the subject.\n- SERVICE / PLACE / DIGITAL: no standalone product object; the reference shows a place (resort, venue, store, destination), people delivering or using a service, or the screen or interface of a digital product on a device.\n\n---\n\nSTEP 2 — DECIDE WHETHER THE FRAME NEEDS TO BE EXTENDED\n\nExtending the frame is a correction, not a default. Advertising impact comes from a strong, confident subject; too much added space weakens it.\n\n- Keep the reference's framing when the subject is already clearly readable, nothing important is cut off, and the frame feels balanced. Only fit it to the output format.\n- Extend lightly when the subject is cramped against the edges, an essential element is cut awkwardly (the product, the top of a head, a hand holding the product), or the output format is wider or taller than the reference. Add only what the frame needs, only on the sides that need it, and as a guide no more than about a quarter of the reference's width or height on any side.\n- The subject stays dominant, at the scale of a campaign key visual for this category: a hero product fills a large share of the frame; a portrait keeps the face and the product large and readable.\n- A person cut by the frame edge is normal in advertising. For a portrait cropped at the chest, waist, or shoulders, keep that crop at the frame edge and extend the background sideways or upward instead of shrinking the person or inventing the rest of the body.\n- When in doubt, extend less.\n\n---\n\nSTEP 3 — EXTEND AS ONE CONTINUOUS PHOTOGRAPH\n\nEvery added area continues the reference seamlessly, as if the photographer had used a slightly wider lens or stepped back half a step: the same backdrop or location, the same perspective, horizon, and vanishing points, the same depth of field and focus fall-off, the same light direction, color temperature, and shadows, the same grain, texture, and color grade. Nowhere in the result is there a visible edge, seam, rectangle, border, or change of light where the original image ended.\n\n- Studio backdrop: when the reference was shot on a seamless, painted, or gradient studio backdrop, extend that same backdrop with its existing light falloff. Keep the studio; do not replace it with a location, a room, or a street.\n- Location or set: continue the same place with plausible, uncluttered detail consistent with what is already visible.\n- Packshot only: replace the plain or white background with one real, art-directed campaign photograph built around the product, following PACKSHOT: CREATE A REAL ADVERTISING PHOTOGRAPH below, and light it so the product's existing highlights and shadows match the new light.\n\nThe subject always stands in, rests on, or casts shadows into its environment with correct contact, scale, and perspective. It is lit by the same light as the scene around it.\n\n---\n\nPACKSHOT: CREATE A REAL ADVERTISING PHOTOGRAPH\n\nWhen the reference is a packshot, the goal is always a real advertising photograph: a product photographed by a professional photographer on a real set or in a real location, with real materials and real light. It must never look like a 3D render or a digitally built showcase.\n\nReal setting, not a render:\n- Place the product in a real, physically believable setting that fits its use and the brand: for example a stone or wooden surface in a real interior with window light, a bathroom or vanity counter, a kitchen or restaurant table, a real outdoor surface such as a rock or wooden deck, or in a person's hand when that suits the product.\n- Use real materials with natural imperfections, real texture, and true-to-life reflections. Avoid the render look: floating podiums, acrylic or chrome pedestals, abstract geometric display stands, endless gradient voids, perfectly smooth digital surfaces, and pastel showroom spaces.\n- Props are few, real, and photographable: real ingredients, real fabrics, real tools of use. Every prop has a reason to be there.\n\nNo CGI elements, ever:\n- Do not add molecules, 3D letters or numbers, ingredient symbols, sculpted claim icons, floating fruit or ingredients, levitating splashes, sparkles, glowing particles, light trails, holograms, or stylized 3D objects of any kind.\n- Claims and ingredients printed on the packaging stay on the packaging; never turn them into objects in the scene.\n\nClean, logical product placement:\n- The product always stands on a clean, stable surface suited to it, exactly as a professional stylist would place it.\n- Never stand the product in spilled product, puddles, smears, crumbs, or any mess. A texture swatch, drop, or smear of the formula is allowed only as a deliberate, clean styling element placed beside the product, never under it or touching its base.\n- Respect hygiene and use logic: food and drink are served on plates, boards, trays, or clean tables, never on soil, sand, grass, bare stone floors, or other organic or dirty ground; cosmetics and personal-care products rest on clean, dry surfaces. Contact with a natural ground is allowed only when it is the product's own use, such as a hiking boot on a trail.\n\n\n---\n\nSTEP 4 — PEOPLE AND ANATOMY\n\nKeep every person exactly as in the reference: face, expression, pose, hair, make-up, skin tone, wardrobe, and the way they hold the product. Do not change their pose or the camera angle on them, and do not add new people.\n\nWhere the extension reveals more of a body, continue it with correct anatomy that fits the visible pose: two arms, two legs, five fingers per hand, joints bending the natural way, proportions matching the visible body. Keep movement physically correct: in running, the arms swing opposite to the legs, the supporting foot lands under the body, the knee bends forward, both feet point in the direction of travel, and the left and right shoes form a matching pair. Shadows follow the limbs and the light.\n\nIf a correct continuation is not possible, keep the original crop on that side and extend elsewhere.\n\n---\n\nSTEP 5 — CAMERA ANGLE\n\nFor PACKSHOT and POLISHED AD, a modest change of camera angle is allowed when it improves the composition, with the product's geometry and branding kept exact. For SERVICE / PLACE / DIGITAL and for every image with people, characters, or garments, keep the original viewpoint.\n\n---\n\nSTEP 6 — RAISE THE PRODUCTION QUALITY\n\nThe reference may be low resolution, compressed, noisy, or modestly lit. Render the result at the quality of a high-end campaign photograph shot on a professional medium-format camera: crisp focus on the subject, clean noise-free detail, accurate color, smooth tonal transitions, skin and surface retouching at the brand's level of polish, and shaped lighting with a clear key direction, gentle fill, and subtle rim or specular accents on the product.\n\nImprove quality only. Do not change the product design, the branding, people's identity or pose, or the overall direction of the reference's color grade.\n\n---\n\nBRAND VISUAL LANGUAGE\n\nInfer from {{company-name}} (and {{product}}, if provided) the brand's industry, market segment, and the visual codes of its campaigns. If the brand is well known, follow its established campaign aesthetic; otherwise infer it from the product, the packaging, and the reference itself. When the reference shows a different kind of offering than {{product}}, take the category and segment from the reference.\n\nFor PACKSHOT, the brand language defines the set, materials, light, and grade. For all other types, the reference's own background, light, and grade lead; the brand language only guides the extended areas and the quality improvements in STEP 6.\n\nSegment orientation (adapt, never copy literally):\n- Luxury / premium: restrained composition, soft directional light, deep controlled shadows, rich muted tones, refined materials such as stone, marble, brushed metal, glass, or linen.\n- Mass market / FMCG: bold, vivid, energetic campaign look, bright shaped light, saturated brand colors, graphic and uncluttered sets.\n- Tech / electronics: precise, cool-neutral grade, minimal architectural spaces, crisp controlled reflections.\n- Natural / wellness: soft directional daylight, warm earthy tones, natural textures and botanicals used sparingly.\n- Sport / performance: dynamic angles, hard light, strong contrast, graphic architecture or minimal sport environments.\n- Food & beverage: appetizing sculpted light, stylist-perfect product, gloss, steam, or condensation where natural.\n\nEvery set and environment is real and looks art-directed and produced for a campaign: few, purposeful real props, a controlled background, no bystanders or crowds, no tourist landmarks, no render-like or CGI elements.\n\n---\n\nTEXT AND BRANDING\n\nLogos, labels, and branding printed on the product or its packaging are part of the product: keep them exactly, without redesign or new lettering.\n\nRemove all external text and graphics: headlines, slogans, captions, prices, calls to action, logos placed on top of the photograph, stickers, and graphic panels. Restore the photograph underneath as if they had never been there. Do not render {{company-name}} or {{product}} as new text anywhere.\n\nFor DIGITAL, the interface shown on a device screen is part of the product, not external text: keep it as in the reference, without new or redesigned lettering.\n\nCHARACTER/MASCOT: keep the characters exactly as drawn and place them in a clean set consistent with the brand. FASHION/APPAREL: keep garments and styling exactly. SERVICE / PLACE / DIGITAL: keep the place's signature features, the people and their interaction, and the device and its interface exactly; extend and refine the setting as for a POLISHED AD or CAMPAIGN CREATIVE.\n\n---\n\nCOMPOSITION\n\nCompose as a campaign key visual: one clear focal point, balanced margins, and subject placement following the reference, centered or offset. The image is a complete advertising photograph in its own right; do not reserve empty areas for text or layout elements. No borders, vignettes, letterboxing, frames, or stripes at the edges.\n\n---\n\nOUTPUT\n\nOne real, photorealistic advertising photograph of {{company-name}}'s product, service, or place, free of any CGI element or render look: coherent in anatomy, perspective, light, and scale, with the product and its branding exactly preserved, no external text, and the production quality of the brand's flagship campaigns.\n";

});




parcelRegister("gCdzD", function(module, exports) {

$parcel$export(module.exports, "useOutdatedUpdate", () => $c18ab9661d90fd77$export$b0d28a179a316354);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5NHyX = parcelRequire("5NHyX");
var $bsn7e = parcelRequire("bsn7e");

var $7nuM2 = parcelRequire("7nuM2");
const $c18ab9661d90fd77$export$b0d28a179a316354 = ({ action: action, isPromptEdited: isPromptEdited = false, editedCount: editedCount = 1, regenerateFromCampaign: regenerateFromCampaign, onKeepPrompt: onKeepPrompt })=>{
    const [isConfirming, setConfirming] = (0, $eF4cA.useState)(false);
    const update = ()=>{
        if (action === (0, $7nuM2.OUTDATED_ACTION).IMAGE) onKeepPrompt?.();
        else if (action === (0, $7nuM2.OUTDATED_ACTION).PROMPT_AND_IMAGE) {
            if (isPromptEdited) setConfirming(true);
            else regenerateFromCampaign?.();
        }
    };
    const confirmDialog = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
        onDismiss: ()=>setConfirming(false),
        children: isConfirming && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5NHyX.AlertDialog), {
            title: editedCount > 1 ? "Overwrite your prompts?" : "Overwrite your prompt?",
            variant: "warning",
            primaryActionLabel: "Overwrite",
            secondaryActionLabel: editedCount > 1 ? "Keep prompts" : "Keep prompt",
            cancelLabel: "Cancel",
            onPrimaryAction: ()=>{
                setConfirming(false);
                regenerateFromCampaign?.();
            },
            onSecondaryAction: ()=>{
                setConfirming(false);
                onKeepPrompt?.();
            },
            onCancel: ()=>setConfirming(false),
            children: editedCount > 1 ? `The prompts of ${editedCount} images were edited by hand. Updating writes new prompts from the campaign, replacing your edits. You can also keep your prompts and only generate new images.` : "The prompt of this image was edited by hand. Updating writes a new prompt from the campaign, replacing your edits. You can also keep your prompt and only generate a new image."
        })
    });
    return {
        update: update,
        confirmDialog: confirmDialog
    };
};

});
parcelRegister("5NHyX", function(module, exports) {

$parcel$export(module.exports, "AlertDialog", () => $c4d204c1496b2764$export$de466dd8317b0b75);


var $cnBj9 = parcelRequire("cnBj9");

var $34HUQ = parcelRequire("34HUQ");

var $lK44Y = parcelRequire("lK44Y");

var $8OJ2z = parcelRequire("8OJ2z");

var $208Op = parcelRequire("208Op");

var $7uz0i = parcelRequire("7uz0i");

var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $82YSg = parcelRequire("82YSg");

var $dx4lB = parcelRequire("dx4lB");

var $d8j5I = parcelRequire("d8j5I");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");

var $fDYaM = parcelRequire("fDYaM");

var $gI8Gw = parcelRequire("gI8Gw");
function $c4d204c1496b2764$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c4d204c1496b2764$var$$94a8ad475d9a330c$var$icon = function anonymous(props) {
    let rules = " ";
    rules += ' Hv182';
    if (props.variant === "warning") rules += ' -_8sjo0b-tm182';
    else if (props.variant === "error") rules += ' -_8sjo0b-tq182';
    return rules;
};
const $c4d204c1496b2764$export$de466dd8317b0b75 = (0, $eF4cA.forwardRef)(function AlertDialog(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($c4d204c1496b2764$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { autoFocusButton: autoFocusButton, cancelLabel: cancelLabel, secondaryActionLabel: secondaryActionLabel, primaryActionLabel: primaryActionLabel, isSecondaryActionDisabled: isSecondaryActionDisabled, isPrimaryActionDisabled: isPrimaryActionDisabled, onCancel: onCancel = ()=>{}, onPrimaryAction: onPrimaryAction = ()=>{}, onSecondaryAction: onSecondaryAction = ()=>{}, title: title, children: children, variant: variant = 'confirmation' } = props;
    let buttonVariant = 'primary';
    if (variant === 'confirmation') buttonVariant = 'accent';
    else if (variant === 'destructive') buttonVariant = 'negative';
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    return (0, $dx4lB.jsx)((0, $7uz0i.Dialog), {
        ...domProps,
        role: "alertdialog",
        ref: ref,
        size: props.size,
        UNSAFE_style: props.UNSAFE_style,
        UNSAFE_className: props.UNSAFE_className || '',
        children: ({ close: close })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $dm5H1.IconContext),
                                {
                                    styles: $c4d204c1496b2764$var$$94a8ad475d9a330c$var$icon({
                                        variant: variant
                                    })
                                }
                            ]
                        ],
                        children: (0, $dx4lB.jsx)((0, $208Op.Heading), {
                            slot: "title",
                            children: (0, $dx4lB.jsxs)((0, $8OJ2z.CenterBaseline), {
                                children: [
                                    variant === 'error' && (0, $dx4lB.jsx)((0, $cnBj9.default), {
                                        "aria-label": stringFormatter.format('dialog.alert')
                                    }),
                                    variant === 'warning' && (0, $dx4lB.jsx)((0, $82YSg.default), {
                                        "aria-label": stringFormatter.format('dialog.alert')
                                    }),
                                    title
                                ]
                            })
                        })
                    }),
                    (0, $dx4lB.jsx)((0, $208Op.Content), {
                        children: children
                    }),
                    (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        children: [
                            cancelLabel && (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                onPress: ()=>(0, $d8j5I.chain)(close(), onCancel()),
                                variant: "secondary",
                                fillStyle: "outline",
                                autoFocus: autoFocusButton === 'cancel',
                                "data-testid": "rsp-AlertDialog-cancelButton",
                                children: cancelLabel
                            }),
                            secondaryActionLabel && (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                onPress: ()=>(0, $d8j5I.chain)(close(), onSecondaryAction()),
                                variant: "secondary",
                                isDisabled: isSecondaryActionDisabled,
                                fillStyle: "outline",
                                autoFocus: autoFocusButton === 'secondary',
                                "data-testid": "rsp-AlertDialog-secondaryButton",
                                children: secondaryActionLabel
                            }),
                            (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: buttonVariant,
                                isDisabled: isPrimaryActionDisabled,
                                autoFocus: autoFocusButton === 'primary',
                                onPress: ()=>(0, $d8j5I.chain)(close(), onPrimaryAction()),
                                "data-testid": "rsp-AlertDialog-confirmButton",
                                children: primaryActionLabel
                            })
                        ]
                    })
                ]
            })
    });
});

});
parcelRegister("82YSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a5ac059d641ddd$export$2e2bcd8739ae039);

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $80a5ac059d641ddd$var$$a951460932d22d7b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.795c-.601 0-1.166-.234-1.591-.66l-6.545-6.544c-.876-.877-.876-2.305 0-3.182l6.545-6.545c.849-.85 2.333-.85 3.182 0l6.545 6.545c.876.877.876 2.305 0 3.182l-6.545 6.545c-.425.425-.99.659-1.591.659m0-16.09c-.2 0-.389.078-.53.22L2.925 9.47c-.292.292-.292.768 0 1.06l6.545 6.545c.283.283.778.283 1.06 0l6.545-6.545c.292-.292.292-.768 0-1.06L10.53 2.925c-.141-.142-.33-.22-.53-.22"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 14.998c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234M10 11.625c-.414 0-.75-.336-.75-.75v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75"
            })
        ]
    });
const $80a5ac059d641ddd$var$$a951460932d22d7b$var$ForwardRef = (0, $eF4cA.forwardRef)($80a5ac059d641ddd$var$$a951460932d22d7b$var$SvgComponent);
var $80a5ac059d641ddd$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($80a5ac059d641ddd$var$$a951460932d22d7b$var$ForwardRef);

});


parcelRegister("bsn7e", function(module, exports) {

$parcel$export(module.exports, "DialogContainer", () => $5c16b969857d203b$export$547754aada6e339f);

var $dx4lB = parcelRequire("dx4lB");

var $1yYiX = parcelRequire("1yYiX");

var $eF4cA = parcelRequire("eF4cA");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5c16b969857d203b$export$547754aada6e339f(props) {
    let { children: children, onDismiss: onDismiss } = props;
    let childArray = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.toArray(children);
    if (childArray.length > 1) throw new Error('Only a single child can be passed to DialogContainer.');
    let [lastChild, setLastChild] = (0, $eF4cA.useState)(null);
    // React.Children.toArray mutates the children, and we need them to be stable
    // between renders so that the lastChild comparison works.
    let child = undefined;
    if (Array.isArray(children)) child = children.find((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).isValidElement);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).isValidElement(children)) child = children;
    if (child && child !== lastChild) setLastChild(child);
    let onOpenChange = (isOpen)=>{
        if (!isOpen) onDismiss();
    };
    return (0, $dx4lB.jsx)((0, $1yYiX.ModalContext).Provider, {
        value: {
            isOpen: !!child,
            onOpenChange: onOpenChange
        },
        children: lastChild
    });
}
function $5c16b969857d203b$export$a2f2d8fa6720dab1() {
    let context = (0, $fDYaM.useSlottedContext)((0, $1yYiX.ModalContext));
    if (!context) throw new Error('Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.');
    return {
        dismiss () {
            context?.onOpenChange?.(false);
        }
    };
}

});


parcelRegister("8Xrlw", function(module, exports) {

$parcel$export(module.exports, "useImageVariations", () => (parcelRequire("bfC2s")).useImageVariations);
$parcel$export(module.exports, "useImageVariation", () => (parcelRequire("44uR2")).useImageVariation);
$parcel$export(module.exports, "REFERENCE_KIND", () => (parcelRequire("6AUdR")).REFERENCE_KIND);
$parcel$export(module.exports, "getMissingReferenceKind", () => (parcelRequire("6AUdR")).getMissingReferenceKind);
$parcel$export(module.exports, "resolveReferenceAssets", () => (parcelRequire("6AUdR")).resolveReferenceAssets);
$parcel$export(module.exports, "getVariationType", () => (parcelRequire("2VxAI")).getVariationType);
/**
 * Image variation generation.
 *
 * `useImageVariations` runs the whole pipeline for a set of template stages —
 * describing the reference images, generating the prompts, uploading the
 * references and generating the variations themselves — and is what a wizard
 * step's `enter.run()` arms.
 *
 * `useImageVariation` (singular) is the counterpart for a view that works on
 * one variation: it resolves that variation and edits the data the pipeline
 * reacts to, without running a pipeline of its own.
 *
 * Each middle step is also exported on its own, so a step that only needs one
 * of them (describing an uploaded image, generating a prompt, uploading a
 * reference) can use it without the rest.
 *
 * What each variation `type` means — its prompt and the request that generates
 * it — is configured in one place: `VARIATION_TYPES` in `variationTypes.js`.
 */ 
var $bfC2s = parcelRequire("bfC2s");

var $44uR2 = parcelRequire("44uR2");

var $d1b3l = parcelRequire("d1b3l");

var $gQVw6 = parcelRequire("gQVw6");

var $cvDKE = parcelRequire("cvDKE");

var $eOKVi = parcelRequire("eOKVi");

var $6AUdR = parcelRequire("6AUdR");

var $2VxAI = parcelRequire("2VxAI");

var $gJFBV = parcelRequire("gJFBV");

var $3OMKs = parcelRequire("3OMKs");

});
parcelRegister("bfC2s", function(module, exports) {

$parcel$export(module.exports, "useImageVariations", () => $830e9a162c876292$export$a96d6b891f2c05ce);

var $eF4cA = parcelRequire("eF4cA");

var $k6waQ = parcelRequire("k6waQ");
var $7ClmI = parcelRequire("7ClmI");

var $fmJ8d = parcelRequire("fmJ8d");

var $a8sj2 = parcelRequire("a8sj2");

var $ikOQe = parcelRequire("ikOQe");

var $5DPNF = parcelRequire("5DPNF");

var $CGZx1 = parcelRequire("CGZx1");

var $afIEk = parcelRequire("afIEk");

var $984R8 = parcelRequire("984R8");

var $lb17q = parcelRequire("lb17q");

var $7nuM2 = parcelRequire("7nuM2");

var $6AUdR = parcelRequire("6AUdR");

var $gJFBV = parcelRequire("gJFBV");

var $d1b3l = parcelRequire("d1b3l");

var $gQVw6 = parcelRequire("gQVw6");

var $cvDKE = parcelRequire("cvDKE");

var $eOKVi = parcelRequire("eOKVi");
const $830e9a162c876292$export$a96d6b891f2c05ce = ({ projectId: projectId, video: video, templateData: templateData, stages: stages, keys: keys, sourceDependencies: sourceDependencies, selectedCampaign: selectedCampaign, enabled: enabled = true, manual: manual = false })=>{
    // Armed per project: `run()` turns the pipeline on, switching projects turns
    // it back off — a step action of the previous project must not keep
    // generating into the next one.
    const [armedProjectId, setArmedProjectId] = (0, $eF4cA.useState)(null);
    // A forced run regenerates variations that already have an image — the
    // keys it was asked for, per project. Each key is consumed once its
    // generation has started; until then, it keeps the references it needs
    // uploading. `runToken` is what wakes the generation effect up for a run.
    const [forced, setForced] = (0, $eF4cA.useState)(()=>({
            projectId: null,
            keys: new Set()
        }));
    const [runToken, setRunToken] = (0, $eF4cA.useState)(0);
    const isArmed = !!projectId && armedProjectId === projectId;
    const isActive = !!enabled && isArmed;
    const hasTemplateData = !!templateData;
    const videoData = video?.data;
    // Only the variations belonging to this step's stages — and enabled for the
    // current campaign — are generated here. Later stages stay idle until their
    // own step is reached, and a variation gated by a `condition` never
    // generates when the flag is off.
    const stageVariations = (0, $eF4cA.useMemo)(()=>{
        if (keys) {
            const owned = new Set(keys);
            return (templateData?.imageVariations ?? []).filter((variation)=>owned.has(variation.key) && (0, $lb17q.isVariationEnabled)(variation, selectedCampaign));
        }
        return (0, $lb17q.filterActiveVariations)(templateData?.imageVariations, stages, selectedCampaign);
    }, [
        templateData?.imageVariations,
        stages,
        keys,
        selectedCampaign
    ]);
    const stageKeys = (0, $eF4cA.useMemo)(()=>new Set(stageVariations.map((variation)=>variation.key)), [
        stageVariations
    ]);
    // The keys a forced run still has to regenerate, for the current project.
    const forcedKeys = (0, $eF4cA.useMemo)(()=>forced.projectId === projectId ? forced.keys : new Set(), [
        forced,
        projectId
    ]);
    // The never-generated variations asked for with `generate()`, per project —
    // only consulted in `manual` mode.
    const [requested, setRequested] = (0, $eF4cA.useState)(()=>({
            projectId: null,
            keys: new Set()
        }));
    // The variations the pipeline works on: every one of the step's, unless it is
    // `manual`, where a variation without a persisted record — never generated,
    // or only uploaded — waits until it is asked for.
    const eligibleVariations = (0, $5DPNF.useStable)((0, $eF4cA.useMemo)(()=>{
        if (!manual) return stageVariations;
        const requestedKeys = requested.projectId === projectId ? requested.keys : null;
        return stageVariations.filter((variation)=>!!requestedKeys?.has(variation.key) || !!videoData?.imageVariations?.some?.((v)=>v.key === variation.key));
    }, [
        manual,
        stageVariations,
        requested,
        projectId,
        videoData?.imageVariations
    ]));
    const eligibleKeys = (0, $eF4cA.useMemo)(()=>new Set(eligibleVariations.map((variation)=>variation.key)), [
        eligibleVariations
    ]);
    /**
   * The step's variations still waiting to be asked for (`manual` only): not
   * in the pipeline, and without an image.
   */ const idleKeys = (0, $eF4cA.useMemo)(()=>new Set(stageVariations.filter((variation)=>!eligibleKeys.has(variation.key) && !videoData?.assets?.some((asset)=>asset.name === variation.key)).map((variation)=>variation.key)), [
        stageVariations,
        eligibleKeys,
        videoData?.assets
    ]);
    // Bound to the current assets, so the memos and effects below keep a stable
    // identity for as long as the assets themselves do.
    const getAsset = (0, $eF4cA.useCallback)((key)=>(0, $6AUdR.resolveAsset)(videoData?.assets, key), [
        videoData?.assets
    ]);
    /** A variation's reference images, in order, primary first. */ const getReferenceAssets = (0, $eF4cA.useCallback)((variation)=>(0, $6AUdR.resolveReferenceAssets)(videoData?.assets, variation), [
        videoData?.assets
    ]);
    /**
   * Whether a reference key points at an image that exists or is still going
   * to be generated — the ones worth waiting for before generating from them.
   */ const isReferenceExpected = (0, $eF4cA.useCallback)((key)=>!!key && (!!videoData?.assets?.some((asset)=>asset.name === key) || !!templateData?.imageVariations?.some((variation)=>variation.key === key)), [
        videoData?.assets,
        templateData?.imageVariations
    ]);
    // Variations are grouped by their whole `referenceKey`: every variation
    // built from exactly the same references, in the same order, shares a group,
    // and `["IMG1", "IMG2"]` is a group of its own rather than part of `"IMG1"`.
    const groups = (0, $5DPNF.useStable)((0, $eF4cA.useMemo)(()=>{
        const byId = new Map();
        stageVariations.forEach((variation)=>{
            const referenceKeys = (0, $lb17q.getVariationReferenceKeys)(variation);
            const id = (0, $lb17q.getReferenceGroupId)(referenceKeys);
            if (!byId.has(id)) byId.set(id, {
                id: id,
                referenceKeys: referenceKeys,
                referenceAssets: referenceKeys.map(getAsset),
                // Whether the group is generated from an image that exists or is
                // still going to be generated — i.e. whether there is a reference
                // worth rendering and waiting for.
                hasReference: referenceKeys.some(isReferenceExpected),
                keys: [],
                variations: []
            });
            const group = byId.get(id);
            group.keys.push(variation.key);
            group.variations.push({
                ...variation,
                // The whole group's references, so the edit dialog can resolve them
                // without re-reading the template.
                referenceKey: referenceKeys.length > 1 ? referenceKeys : referenceKeys[0],
                data: videoData?.imageVariations?.find?.((v)=>v.key === variation.key) ?? {}
            });
        });
        return Array.from(byId.values());
    }, [
        stageVariations,
        getAsset,
        isReferenceExpected,
        videoData?.imageVariations
    ]));
    // Every reference image of this step, de-duplicated — the set that is
    // presigned, described and uploaded once for all groups.
    const referenceAssets = (0, $5DPNF.useStable)((0, $eF4cA.useMemo)(()=>{
        const byName = new Map();
        groups.forEach((group)=>{
            group.referenceAssets.forEach((asset)=>{
                if (asset?.name && !byName.has(asset.name)) byName.set(asset.name, asset);
            });
        });
        return Array.from(byName.values());
    }, [
        groups
    ]));
    // The reference images the pipeline actually works on — those of the groups
    // with an eligible variation; every one of them unless `manual`.
    const eligibleReferenceAssets = (0, $5DPNF.useStable)((0, $eF4cA.useMemo)(()=>{
        const byName = new Map();
        groups.filter((group)=>group.keys.some((key)=>eligibleKeys.has(key))).forEach((group)=>{
            group.referenceAssets.forEach((asset)=>{
                if (asset?.name && !byName.has(asset.name)) byName.set(asset.name, asset);
            });
        });
        return Array.from(byName.values());
    }, [
        groups,
        eligibleKeys
    ]));
    // Wrapped so the empty fallback keeps a stable identity across renders —
    // `campaign` is an effect dependency further down.
    const campaign = (0, $eF4cA.useMemo)(()=>selectedCampaign ?? {}, [
        selectedCampaign
    ]);
    const writer = (0, $eOKVi.usePersistImageVariations)(projectId);
    const persistImageVariations = writer.persist;
    const updateAssets = (0, $CGZx1.useUpdateAssets)(projectId);
    const queryClient = (0, $7ClmI.useQueryClient)();
    // ---------------------------------------------------------------------------
    // Generation bookkeeping
    //
    // The keys being generated are rendered by the caller, so they are state —
    // mirrored into a ref because the generation effect reads them while
    // deciding what is still left to do.
    // ---------------------------------------------------------------------------
    const [generatingKeys, setGeneratingKeys] = (0, $eF4cA.useState)(()=>new Set());
    const generatingKeysRef = (0, $eF4cA.useRef)(generatingKeys);
    const startGenerating = (0, $eF4cA.useCallback)((key)=>{
        if (!key || generatingKeysRef.current.has(key)) return;
        const next = new Set(generatingKeysRef.current);
        next.add(key);
        generatingKeysRef.current = next;
        setGeneratingKeys(next);
    }, []);
    const stopGenerating = (0, $eF4cA.useCallback)((key)=>{
        if (!key || !generatingKeysRef.current.has(key)) return;
        const next = new Set(generatingKeysRef.current);
        next.delete(key);
        generatingKeysRef.current = next;
        setGeneratingKeys(next);
    }, []);
    const uploadAssets = (0, $CGZx1.useUploadAssets)(projectId, {
        onSettled: (data, error, variables)=>{
            if (variables.key) {
                (0, $fmJ8d.store).getState().setImageVariationProgress(variables.key, null);
                stopGenerating(variables.key);
            }
        }
    });
    // ---------------------------------------------------------------------------
    // Middle steps — each usable on its own
    // ---------------------------------------------------------------------------
    // Uploading a reference is only worth it for a variation that is about to be
    // generated — missing its image (and not failed, which only regenerates when
    // asked for) or forced. The references of the step's other variations are
    // displayed, but not uploaded.
    const uploadKeys = (0, $eF4cA.useMemo)(()=>{
        const needsGeneration = (variation)=>eligibleKeys.has(variation.key) && (forcedKeys.has(variation.key) || !videoData?.assets?.some((asset)=>asset.name === variation.key) && !videoData?.imageVariations?.some?.((v)=>v.key === variation.key && !!v.errorCode));
        const names = new Set();
        groups.filter((group)=>group.variations.some(needsGeneration)).forEach((group)=>{
            group.referenceAssets.forEach((asset)=>{
                if (asset?.name) names.add(asset.name);
            });
        });
        return names;
    }, [
        groups,
        eligibleKeys,
        forcedKeys,
        videoData?.assets,
        videoData?.imageVariations
    ]);
    // When a group's references cannot be uploaded there is nothing to generate
    // from, so its variations fall back to the group's primary reference image.
    const referenceFallbacks = (0, $5DPNF.useStable)((0, $eF4cA.useMemo)(()=>groups.flatMap((group)=>group.variations.filter((variation)=>eligibleKeys.has(variation.key) && !videoData?.assets?.some((asset)=>asset.name === variation.key)).map((variation)=>({
                    key: variation.key,
                    asset: group.referenceAssets[0]
                }))), [
        groups,
        eligibleKeys,
        videoData?.assets
    ]));
    const references = (0, $cvDKE.useImageReferenceUploads)({
        projectId: projectId,
        assets: eligibleReferenceAssets,
        fallbacks: referenceFallbacks,
        uploadKeys: uploadKeys,
        enabled: isActive && uploadKeys.size > 0
    });
    const needsImageLabeling = (0, $eF4cA.useMemo)(()=>eligibleVariations.some((variation)=>{
            const visuals = getReferenceAssets(variation);
            return variation?.imageDescriptionPrompt === "brand-visibility-library" || !(0, $gJFBV.isStaticPrompt)(variation, {
                templateId: videoData?.templateId,
                campaign: campaign,
                customer: videoData?.customer,
                visual: visuals[0],
                visuals: visuals
            });
        }), [
        eligibleVariations,
        getReferenceAssets,
        videoData?.templateId,
        campaign,
        videoData?.customer
    ]);
    const labeling = (0, $d1b3l.useImageLabeling)({
        projectId: projectId,
        assets: eligibleReferenceAssets,
        urlByPath: references.urlByPath,
        templateId: videoData?.templateId,
        imageVariations: templateData?.imageVariations,
        enabled: isActive && needsImageLabeling,
        companyName: selectedCampaign?.["Company-name"],
        product: selectedCampaign?.["Campaign-product"]
    });
    const { retry: retryLabeling } = labeling;
    const prompts = (0, $gQVw6.useImagePrompts)({
        projectId: projectId,
        variations: eligibleVariations,
        imageVariations: videoData?.imageVariations,
        templateId: videoData?.templateId,
        campaign: campaign,
        customer: videoData?.customer,
        getReferenceAssets: getReferenceAssets,
        isLabeled: labeling.isLabeled,
        persist: persistImageVariations,
        enabled: isActive && !!video?.isSuccess && hasTemplateData
    });
    // ---------------------------------------------------------------------------
    // Generation
    // ---------------------------------------------------------------------------
    const imageVariation = (0, $k6waQ.useMutation)({
        // The snapshots are only recorded on the result, never sent along.
        mutationFn: ({ key: key, action: action, sourceValue: sourceValue, sourceReferences: sourceReferences, ...modelOptions }, { signal: signal })=>{
            // Non-generative Photoshop actions take a different route, but return the
            // same `{ success, outputs }` shape so `onSuccess` below is shared.
            if (action === "removeBackground") {
                const assetName = `photoshop__${key}__${crypto.randomUUID()}`;
                const s3FilePath = videoData?.projectPath ? `${videoData.projectPath}/${assetName}` : undefined;
                return (0, $984R8.removeBackgroundFn)({
                    ...modelOptions,
                    s3FilePath: s3FilePath
                }, signal, ()=>{
                    (0, $fmJ8d.store).getState().setImageVariationProgress(key, (prev)=>({
                            stage: (0, $lb17q.VARIATION_PROGRESS_STAGE).GENERATING,
                            value: prev?.value ?? 0,
                            label: "Removing background"
                        }));
                }).then((result)=>({
                        ...result,
                        assetName: assetName
                    }));
            }
            const assetName = `firefly__${key}__${crypto.randomUUID()}`;
            const s3FilePath = videoData?.projectPath ? `${videoData.projectPath}/${assetName}` : undefined;
            return (0, $afIEk.generateImageFn)({
                ...modelOptions,
                s3FilePath: s3FilePath
            }, signal, (status)=>{
                if (status.progress) (0, $fmJ8d.store).getState().setImageVariationProgress(key, (prev)=>({
                        stage: (0, $lb17q.VARIATION_PROGRESS_STAGE).GENERATING,
                        value: status.progress,
                        label: `Generating ${modelOptions.model?.startsWith("video") ? "video" : "image"}`
                    }));
                else (0, $fmJ8d.store).getState().setImageVariationProgress(key, (prev)=>({
                        stage: (0, $lb17q.VARIATION_PROGRESS_STAGE).GENERATING,
                        value: prev?.value ?? 0,
                        label: `Generating ${modelOptions.model?.startsWith("video") ? "video" : "image"}`
                    }));
            }).then((result)=>({
                    ...result,
                    assetName: assetName
                }));
        },
        onMutate: (variables)=>{
            const { key: key } = variables;
            startGenerating(key);
        },
        onSuccess: (data, variables)=>{
            const { key: key, model: model, prompt: prompt, referenceKey: referenceKey, action: action, sourceValue: sourceValue, sourceReferences: sourceReferences } = variables;
            const isVideoModel = model?.startsWith("video");
            const outs = data?.outputs ?? [];
            const assetData = isVideoModel ? outs.find((o)=>o.kind === "video") ?? outs.find((o)=>typeof o.url === "string" && /\.(mp4|webm|mov)(\?|$)/i.test(o.url)) ?? outs.at(-1) ?? {} : outs.find((o)=>o.kind === "image") ?? outs[0] ?? {};
            let fireflyId = assetData.fireflyId;
            if (!fireflyId) {
                // Try to extract Firefly ID from the URL
                const match = assetData.url?.match(/\/(?:images|videos)\/([a-f0-9-]{36})(?:[\/\?])/);
                if (match) fireflyId = match[1];
            }
            (0, $fmJ8d.store).getState().setImageVariationProgress(key, {
                stage: (0, $lb17q.VARIATION_PROGRESS_STAGE).SAVING,
                value: 0,
                label: `Saving ${isVideoModel ? "video" : "image"}`
            });
            let assetName = data?.assetName;
            if (!assetName) switch(action){
                case "removeBackground":
                    assetName = `photoshop__${key}__${crypto.randomUUID()}`;
                    break;
                default:
                    assetName = `firefly__${key}__${crypto.randomUUID()}`;
                    break;
            }
            if (assetData.filePath && assetData.presignURL) queryClient.setQueryData((0, $a8sj2.s3Key).presignURL(assetData.filePath), {
                filePath: assetData.filePath,
                presignURL: assetData.presignURL
            });
            return uploadAssets.mutateAsync({
                assets: [
                    {
                        name: assetName,
                        type: isVideoModel ? "video" : "image",
                        src: assetData.url,
                        ...assetData.filePath ? {
                            filePath: assetData.filePath
                        } : {},
                        ...assetData.presignURL ? {
                            presignURL: assetData.presignURL
                        } : {},
                        skipClientPrepare: true,
                        referenceKey: referenceKey,
                        fireflyId: fireflyId,
                        seed: assetData.seed,
                        model: model,
                        prompt: prompt,
                        ...sourceValue ? {
                            sourceValue: sourceValue
                        } : {},
                        ...sourceReferences ? {
                            sourceReferences: sourceReferences
                        } : {}
                    }
                ],
                fileName: key,
                key: key
            });
        },
        onError: async (error, variables, onMutateResult, { meta: meta, client: client })=>{
            //TODO: Set default image for the variation in case of error
            console.warn("Error generating image variation:", error, variables);
            stopGenerating(variables.key);
            (0, $fmJ8d.store).getState().setImageVariationProgress(variables.key, null);
            if (!!error?.cause?.data?.error_code) {
                const template = client.getQueryData((0, $ikOQe.videoKey).template(videoData?.templateId));
                if (error?.cause?.data?.error_code === "prompt_unsafe") {
                    const _variation = template?.imageVariations?.find((v)=>v.key === variables.key);
                    meta.errorMessage = `${!!_variation && !!_variation.label ? `[${_variation.key}] ${_variation.label}` : variables.key}: The generated prompt was flagged as unsafe. Please try again. If the issue persists, please edit the prompt and try again.`;
                }
                const failed = videoData?.imageVariations?.find((v)=>v.key === variables.key);
                // Through the same queue as every other `imageVariations` write, so
                // flagging the failure cannot drop a prompt written in the meantime.
                if (failed) await persistImageVariations([
                    {
                        ...failed,
                        errorCode: error?.cause?.data?.error_code,
                        errorMessage: error?.cause?.data?.message
                    }
                ]);
            }
            if (error) {
                if (variables?.referenceKey) {
                    const defaultAsset = videoData?.assets?.find((asset)=>asset.name === variables.referenceKey);
                    if (defaultAsset) updateAssets.mutate({
                        assets: [
                            {
                                ...defaultAsset,
                                name: variables.key
                            }
                        ]
                    });
                }
            }
        },
        meta: {
            errorMessage: "Failed to generate image variation. Please try again."
        }
    });
    const { mutate: mutateImageVariation } = imageVariation;
    // Generate image variations
    (0, $eF4cA.useEffect)(()=>{
        if (!isActive) return;
        /** Regenerate this variation even though it already has an image. */ const isForced = (key)=>forcedKeys.has(key);
        // The forced keys this pass is done with: started, or impossible to.
        const consumed = new Set();
        // Static prompts refreshed for this pass, persisted once it is done.
        const refreshedPrompts = [];
        const hasPendingVariation = (v)=>eligibleKeys.has(v.key) && !!v.visualPrompt && (isForced(v.key) || !v.errorCode && !videoData?.assets?.some((asset)=>asset.name === v.key)) && !generatingKeysRef.current.has(v.key);
        if (// Every reference of the step is uploaded together, so generation waits
        // for all of them — starting a variation whose upload is still running
        // would generate it without its reference image.
        !references.isFetching && !references.isError && !uploadAssets.isPending && !writer.isPending && videoData?.imageVariations?.some?.(hasPendingVariation)) {
            // If there are image variations that haven't been uploaded yet, trigger
            // their generation.
            videoData?.imageVariations?.filter(hasPendingVariation)?.forEach((variation)=>{
                const templateVariation = templateData?.imageVariations?.find((tv)=>tv.key === variation.key) ?? {};
                // Every reference image of this variation, primary first.
                // Generation waits until all of them exist — starting with a
                // half-ready set would silently drop references from the result.
                const variationReferences = getReferenceAssets(templateVariation);
                if (variationReferences.some((asset)=>isReferenceExpected(asset.name) && !asset?.filePath)) return;
                const uploadIds = (0, $gJFBV.resolveVariationUploadIds)(templateVariation, {
                    byKey: references.byKey,
                    isReferenceExpected: isReferenceExpected
                });
                if (uploadIds === null) return;
                const promptContext = {
                    templateId: videoData?.templateId,
                    campaign: campaign,
                    customer: videoData?.customer,
                    visual: variationReferences[0],
                    visuals: variationReferences
                };
                // A static prompt is generated from the campaign as it is now —
                // unless it is the user's own, which is kept as written.
                const staticPrompt = variation.promptEdited ? null : (0, $gJFBV.resolveStaticPrompt)(templateVariation, promptContext);
                let promptVariation = staticPrompt !== null && staticPrompt !== variation.visualPrompt ? {
                    ...variation,
                    visualPrompt: staticPrompt
                } : variation;
                if (promptVariation !== variation) refreshedPrompts.push(promptVariation);
                // The user's own prompt is stored as typed, and has its `{{Var}}`
                // placeholders expanded from the campaign only for this request.
                if (variation.promptEdited) {
                    const compiledPrompt = (0, $gJFBV.compileUserPrompt)(variation.visualPrompt, templateVariation, promptContext);
                    if (compiledPrompt === null) {
                        console.warn(`The prompt of "${variation.key}" has no campaign values to fill it with.`);
                        consumed.add(variation.key);
                        return;
                    }
                    promptVariation = {
                        ...variation,
                        visualPrompt: compiledPrompt
                    };
                }
                // What the variation's type asks for — model, prompt, references,
                // action — all of it resolved from its entry in `VARIATION_TYPES`.
                const payload = (0, $gJFBV.buildVariationPayload)(promptVariation, {
                    templateVariation: templateVariation,
                    references: variationReferences,
                    uploadIds: uploadIds
                });
                consumed.add(variation.key);
                if (payload) mutateImageVariation({
                    ...payload,
                    // What the image is generated from, recorded on it so a view can
                    // tell when it has changed since: the campaign values it depends
                    // on — generating it is what catches up with them — and the
                    // files of its references.
                    sourceValue: (0, $7nuM2.snapshotDependencies)((0, $7nuM2.getVariationDependencies)(templateVariation, sourceDependencies?.get(variation.key)), campaign),
                    sourceReferences: (0, $7nuM2.snapshotReferences)((0, $lb17q.getVariationReferenceKeys)(templateVariation), videoData?.assets)
                });
            });
            // So the variation shows the prompt its image is generated from.
            if (refreshedPrompts.length) persistImageVariations(refreshedPrompts).catch((error)=>{
                console.warn("Failed to save the refreshed prompts:", error);
            });
            // A forced key still waiting — on its references, say — stays forced.
            if ([
                ...consumed
            ].some(isForced)) setForced((prev)=>{
                const keys = new Set(prev.keys);
                consumed.forEach((key)=>keys.delete(key));
                return {
                    ...prev,
                    keys: keys
                };
            });
        }
    }, [
        isActive,
        references.isFetching,
        references.isError,
        references.byKey,
        uploadAssets.isPending,
        writer.isPending,
        videoData?.imageVariations,
        videoData?.assets,
        templateData?.imageVariations,
        eligibleKeys,
        getReferenceAssets,
        isReferenceExpected,
        mutateImageVariation,
        forcedKeys,
        sourceDependencies,
        campaign,
        persistImageVariations,
        videoData?.templateId,
        videoData?.customer,
        runToken
    ]);
    // ---------------------------------------------------------------------------
    // Step-action surface
    // ---------------------------------------------------------------------------
    /**
   * The variations of this step that still have to be generated — a failed one
   * is not pending, because it only regenerates when explicitly asked for.
   */ const pendingVariations = (0, $5DPNF.useStable)((0, $eF4cA.useMemo)(()=>stageVariations.filter((variation)=>{
            const data = videoData?.imageVariations?.find((v)=>v.key === variation.key);
            return !videoData?.assets?.some((asset)=>asset.name === variation.key) && !data?.errorCode;
        }), [
        stageVariations,
        videoData?.imageVariations,
        videoData?.assets
    ]));
    /** A pending variation is still waiting for a reference image of its own. */ const isReferenceMissing = (0, $eF4cA.useMemo)(()=>pendingVariations.some((variation)=>getReferenceAssets(variation).some((asset)=>isReferenceExpected(asset.name) && !asset?.filePath)), [
        pendingVariations,
        getReferenceAssets,
        isReferenceExpected
    ]);
    /**
   * Arms the pipeline. Safe to call repeatedly — every stage of the pipeline
   * guards itself, so entering the step again never duplicates work.
   *
   * @param {object} [options]
   * @param {boolean} [options.force] - Regenerate variations that already have
   *   an image, not just the missing ones.
   * @param {Iterable<string>} [options.keys] - Limit `force` to these variation
   *   keys — a single reference group, say. Every variation of the step when
   *   omitted.
   */ const run = (0, $eF4cA.useCallback)(({ force: force = false, keys: keys } = {})=>{
        if (force) {
            const forcedKeys = Array.from(keys ?? stageKeys).filter((key)=>stageKeys.has(key));
            setForced((prev)=>{
                const next = new Set(prev.projectId === projectId ? prev.keys : undefined);
                forcedKeys.forEach((key)=>next.add(key));
                return {
                    projectId: projectId,
                    keys: next
                };
            });
        }
        retryLabeling();
        setArmedProjectId(projectId ?? null);
        setRunToken((token)=>token + 1);
    }, [
        projectId,
        stageKeys,
        retryLabeling
    ]);
    /**
   * Asks for never-generated variations — what a `manual` pipeline waits for —
   * and arms the pipeline. Without a `manual` pipeline, it is just `run()`.
   *
   * @param {Iterable<string>} [keys] - The variations to generate. Every
   *   variation of the step when omitted.
   */ const generate = (0, $eF4cA.useCallback)((keys)=>{
        const requestedKeys = Array.from(keys ?? stageKeys).filter((key)=>stageKeys.has(key));
        setRequested((prev)=>{
            const next = new Set(prev.projectId === projectId ? prev.keys : undefined);
            requestedKeys.forEach((key)=>next.add(key));
            return {
                projectId: projectId,
                keys: next
            };
        });
        run();
    }, [
        projectId,
        stageKeys,
        run
    ]);
    /**
   * Catches outdated variations up at once, each as its `action` asks (see
   * `getOutdatedAction`): `"prompt-and-image"` drops its prompt — the user's
   * own included — so a fresh one is written, `"image"` keeps it. Either way
   * its images go, so the armed pipeline generates them again; a previous
   * failure is cleared too. One write for all of them, as
   * `useImageVariation`'s `regenerate` / `regenerateFromCampaign` do for one.
   *
   * @param {Array<{ key: string, action: string }>} updates
   * @returns {Promise<string[]>} The keys being regenerated.
   */ const updateVariations = (0, $eF4cA.useCallback)(async (updates)=>{
        const latest = queryClient.getQueryData((0, $ikOQe.videoKey).detail(projectId));
        const targets = (updates ?? []).filter(({ key: key, action: action })=>stageKeys.has(key) && !!action && !generatingKeysRef.current.has(key)).map(({ key: key, action: action })=>({
                key: key,
                action: action,
                variation: stageVariations.find((v)=>v.key === key),
                record: latest?.imageVariations?.find((v)=>v.key === key),
                asset: latest?.assets?.find((a)=>a.name === key)
            }));
        if (!targets.length) return [];
        const prompts = targets.filter(({ action: action })=>action === "prompt-and-image").map(({ key: key, variation: variation, record: record })=>{
            const { errorCode: errorCode, errorMessage: errorMessage, promptEdited: promptEdited, ...rest } = record ?? {
                type: variation?.type,
                referenceKey: (0, $lb17q.getPrimaryReferenceKey)(variation)
            };
            return {
                ...rest,
                key: key,
                visualPrompt: null
            };
        });
        const images = targets.filter(({ action: action, record: record })=>action !== "prompt-and-image" && record).map(({ key: key, record: record })=>{
            const { errorCode: errorCode, errorMessage: errorMessage, ...rest } = record;
            return {
                ...rest,
                key: key
            };
        });
        try {
            await persistImageVariations([
                ...prompts,
                ...images
            ]);
        } catch (error) {
            // Keep the current images rather than dropping them for a generation
            // that would run with the old prompts.
            console.warn("Failed to update the variations:", error);
            return [];
        }
        const toRemove = targets.flatMap(({ asset: asset })=>[
                asset?.name,
                (0, $lb17q.getPrimaryReferenceKey)({
                    referenceKey: asset?.referenceKey
                })
            ]).filter(Boolean).map((name)=>({
                name: name
            }));
        if (toRemove.length) updateAssets.mutate({
            toRemove: toRemove
        });
        run();
        return targets.map(({ key: key })=>key);
    }, [
        queryClient,
        projectId,
        stageKeys,
        stageVariations,
        persistImageVariations,
        updateAssets.mutate,
        run
    ]);
    /**
   * Regenerates — prompt and image — the variations of the step whose source
   * an edit of the campaign changed (see `getCampaignChangedVariationKeys`).
   * Only ones that already have a prompt or an image are concerned — the rest
   * are written for the edited campaign anyway — and neither an image the user
   * uploaded nor one being generated is touched.
   *
   * One write for all of them, as `useImageVariation.regenerateFromCampaign`
   * does for one: their prompts are dropped so fresh ones are written, then
   * their images, so the armed pipeline generates them again.
   *
   * @returns {Promise<string[]>} The keys being regenerated.
   */ const regenerateFromCampaignChange = (0, $eF4cA.useCallback)(async (previousCampaign, nextCampaign)=>{
        const latest = queryClient.getQueryData((0, $ikOQe.videoKey).detail(projectId));
        const changedKeys = new Set((0, $7nuM2.getCampaignChangedVariationKeys)(stageVariations, previousCampaign, nextCampaign, {
            structureDependencies: sourceDependencies,
            getPromptTemplate: (variation, campaign)=>{
                const visuals = (0, $6AUdR.resolveReferenceAssets)(latest?.assets, variation);
                return (0, $gJFBV.getVariationPromptTemplate)(variation, {
                    templateId: latest?.templateId,
                    campaign: campaign,
                    customer: latest?.customer,
                    visual: visuals[0],
                    visuals: visuals
                });
            }
        }));
        const targets = stageVariations.filter((variation)=>changedKeys.has(variation.key) && !generatingKeysRef.current.has(variation.key)).map((variation)=>({
                variation: variation,
                record: latest?.imageVariations?.find((v)=>v.key === variation.key),
                asset: latest?.assets?.find((a)=>a.name === variation.key)
            })).filter(({ record: record, asset: asset })=>(!!record?.visualPrompt || !!asset?.filePath) && !(0, $7nuM2.isUploadedImage)(asset));
        if (!targets.length) return [];
        try {
            await persistImageVariations(targets.map(({ variation: variation, record: record })=>{
                const { errorCode: errorCode, errorMessage: errorMessage, ...rest } = record ?? {
                    type: variation.type,
                    referenceKey: (0, $lb17q.getPrimaryReferenceKey)(variation)
                };
                return {
                    ...rest,
                    key: variation.key,
                    visualPrompt: null
                };
            }));
        } catch (error) {
            // Keep the current images rather than dropping them for a generation
            // that would run with the old prompts.
            console.warn("Failed to request new prompts:", error);
            return [];
        }
        const toRemove = targets.flatMap(({ asset: asset })=>[
                asset?.name,
                (0, $lb17q.getPrimaryReferenceKey)({
                    referenceKey: asset?.referenceKey
                })
            ]).filter(Boolean).map((name)=>({
                name: name
            }));
        if (toRemove.length) updateAssets.mutate({
            toRemove: toRemove
        });
        run();
        return targets.map(({ variation: variation })=>variation.key);
    }, [
        queryClient,
        projectId,
        stageVariations,
        sourceDependencies,
        persistImageVariations,
        updateAssets.mutate,
        run
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            stages: stages,
            groups: groups,
            variations: stageVariations,
            pendingVariations: pendingVariations,
            referenceAssets: referenceAssets,
            referenceUrlByPath: references.urlByPath,
            generatingKeys: generatingKeys,
            idleKeys: idleKeys,
            skipImageLabeling: labeling.skipImageLabeling,
            isArmed: isArmed,
            isComplete: !pendingVariations.length,
            isReferenceMissing: isReferenceMissing,
            isUploading: uploadAssets.isPending,
            isSaving: writer.isPending,
            references: references,
            labeling: labeling,
            prompts: prompts,
            run: run,
            generate: generate,
            regenerateFromCampaignChange: regenerateFromCampaignChange,
            updateVariations: updateVariations
        }), [
        stages,
        groups,
        stageVariations,
        pendingVariations,
        referenceAssets,
        references,
        generatingKeys,
        idleKeys,
        labeling,
        prompts,
        isArmed,
        isReferenceMissing,
        uploadAssets.isPending,
        writer.isPending,
        run,
        generate,
        regenerateFromCampaignChange,
        updateVariations
    ]);
};

});
parcelRegister("ikOQe", function(module, exports) {

$parcel$export(module.exports, "videoKey", () => $d591884ca5cc206e$export$90e89cae5bffb368);
$parcel$export(module.exports, "getNewVideoPath", () => $d591884ca5cc206e$export$29948378ccf061c7);
$parcel$export(module.exports, "useVideos", () => $d591884ca5cc206e$export$92d221c2e4efa6fe);
$parcel$export(module.exports, "useVideo", () => $d591884ca5cc206e$export$5269023cd97c8c79);
$parcel$export(module.exports, "useCreateVideo", () => $d591884ca5cc206e$export$6026d926616a8c84);
$parcel$export(module.exports, "useDuplicateVideo", () => $d591884ca5cc206e$export$52e07fb50a2deca4);
$parcel$export(module.exports, "useUpdateVideo", () => $d591884ca5cc206e$export$a3cb6be856652545);
$parcel$export(module.exports, "useDeleteVideo", () => $d591884ca5cc206e$export$e36b6051e578f0b4);
$parcel$export(module.exports, "useVideoTemplates", () => $d591884ca5cc206e$export$7b2bccbde1d8e953);
$parcel$export(module.exports, "useVideoTemplate", () => $d591884ca5cc206e$export$f0928a4bedb96ae3);
$parcel$export(module.exports, "useDownloadAsset", () => $d591884ca5cc206e$export$970d76847a0f6577);
$parcel$export(module.exports, "useVideoAssets", () => $d591884ca5cc206e$export$e7242f9c3fa2d32c);
$parcel$export(module.exports, "useDownloadAllAssets", () => $d591884ca5cc206e$export$c2d87ad67c84aef);

var $eF4cA = parcelRequire("eF4cA");

var $iFK2s = parcelRequire("iFK2s");
var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");

var $8ZGjb = parcelRequire("8ZGjb");

var $hOI0D = parcelRequire("hOI0D");

var $9lDhw = parcelRequire("9lDhw");

var $6lZyT = parcelRequire("6lZyT");

var $6yR6I = parcelRequire("6yR6I");

var $a8sj2 = parcelRequire("a8sj2");

var $CGZx1 = parcelRequire("CGZx1");

var $fK5Xl = parcelRequire("fK5Xl");
const $d591884ca5cc206e$export$90e89cae5bffb368 = {
    all: [
        "videos"
    ],
    lists: ()=>[
            ...$d591884ca5cc206e$export$90e89cae5bffb368.all,
            "list"
        ],
    list: (filters)=>[
            ...$d591884ca5cc206e$export$90e89cae5bffb368.lists(),
            "infinite",
            {
                filters: filters
            }
        ],
    details: ()=>[
            ...$d591884ca5cc206e$export$90e89cae5bffb368.all,
            "detail"
        ],
    detail: (id)=>[
            ...$d591884ca5cc206e$export$90e89cae5bffb368.details(),
            id
        ],
    templates: ()=>[
            ...$d591884ca5cc206e$export$90e89cae5bffb368.all,
            "templates"
        ],
    template: (id)=>[
            ...$d591884ca5cc206e$export$90e89cae5bffb368.templates(),
            id
        ]
};
const $d591884ca5cc206e$export$29948378ccf061c7 = (videoId)=>videoId ? `/projects/new/${videoId}` : "/projects/new";
const $d591884ca5cc206e$var$selectVideos = (data)=>data.pages.flatMap((page)=>page.videos);
const $d591884ca5cc206e$var$updateVideoLists = (client, update, filters = {})=>client.setQueriesData({
        queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists(),
        ...filters
    }, (data)=>data?.pages ? {
            ...data,
            pages: data.pages.map((page, index)=>({
                    ...page,
                    videos: update(page.videos, index)
                }))
        } : data);
const $d591884ca5cc206e$var$restoreVideoLists = (client, previousLists = [], id)=>{
    previousLists.forEach(([key, previous])=>{
        client.setQueryData(key, (data)=>data?.pages ? {
                ...data,
                pages: data.pages.map((page, index)=>{
                    const previousPage = previous?.pages?.[index];
                    const previousIndex = previousPage?.videos.findIndex((video)=>video.id === id) ?? -1;
                    // Roll back only this item so concurrent mutations stay intact.
                    const videos = page.videos.filter((video)=>video.id !== id);
                    if (previousIndex >= 0) videos.splice(previousIndex, 0, previousPage.videos[previousIndex]);
                    return {
                        ...page,
                        videos: videos
                    };
                })
            } : data);
    });
};
const $d591884ca5cc206e$export$92d221c2e4efa6fe = (options = {})=>{
    const { user: user = "me", pageSize: pageSize = 25, ...queryOptions } = options;
    const query = (0, $iFK2s.useInfiniteQuery)({
        queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.list({
            user: user,
            pageSize: pageSize
        }),
        queryFn: ({ pageParam: pageParam, signal: signal })=>$8ZGjb.getVideos(user, {
                signal: signal
            }, {
                page: pageParam,
                pageSize: pageSize
            }),
        initialPageParam: 1,
        getNextPageParam: (lastPage)=>lastPage.pagination.page < lastPage.pagination.totalPages ? lastPage.pagination.page + 1 : undefined,
        select: $d591884ca5cc206e$var$selectVideos,
        staleTime: 60000,
        meta: {
            errorMessage: "Failed to load projects. Please try again."
        },
        ...queryOptions
    });
    return query;
};
const $d591884ca5cc206e$export$5269023cd97c8c79 = (id, options = {})=>{
    const query = (0, $4kcQz.useQuery)({
        queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail(id),
        queryFn: ({ signal: signal })=>$8ZGjb.getVideo(id, {
                signal: signal
            }),
        meta: {
            errorMessage: "Failed to load the project. Please try again."
        },
        enabled: !!id,
        ...options
    });
    return query;
};
const $d591884ca5cc206e$export$6026d926616a8c84 = ()=>{
    return (0, $k6waQ.useMutation)({
        mutationKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail("new"),
        mutationFn: (variables, { signal: signal })=>$8ZGjb.createVideo(variables, {
                signal: signal
            }),
        onMutate: async (variables, { client: client })=>{
            await client.cancelQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
            const previousLists = client.getQueriesData({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
            $d591884ca5cc206e$var$updateVideoLists(client, (videos, index)=>index === 0 ? [
                    variables,
                    ...videos
                ] : videos, {
                predicate: (query)=>query.queryKey[3]?.filters?.user === "me"
            });
            return {
                previousLists: previousLists
            };
        },
        onSuccess: (data, variables, onMutateResult, { client: client })=>{
            client.setQueryData($d591884ca5cc206e$export$90e89cae5bffb368.details(data.id), data);
        },
        onError: (error, variables, { previousLists: previousLists } = {}, { client: client })=>{
            $d591884ca5cc206e$var$restoreVideoLists(client, previousLists, variables.id);
            client.removeQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail(variables.id)
            });
        },
        onSettled: (data, error, variables, onMutateResult, { client: client })=>{
            client.invalidateQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
        }
    });
};
const $d591884ca5cc206e$export$52e07fb50a2deca4 = ()=>{
    return (0, $k6waQ.useMutation)({
        mutationKey: [
            ...$d591884ca5cc206e$export$90e89cae5bffb368.all,
            "duplicate"
        ],
        mutationFn: ({ id: id })=>$8ZGjb.duplicateVideo(id),
        onSuccess: (data, variables, onMutateResult, { client: client })=>{
            client.setQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(data.id), data);
            client.invalidateQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
        },
        meta: {
            errorMessage: "Failed to duplicate the project. Please try again."
        }
    });
};
const $d591884ca5cc206e$export$a3cb6be856652545 = (id)=>{
    return (0, $k6waQ.useMutation)({
        scope: {
            id: $d591884ca5cc206e$export$90e89cae5bffb368.detail(id).join("/")
        },
        mutationKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail(id),
        mutationFn: (variables, { signal: signal })=>$8ZGjb.updateVideo(id ?? variables?.id, variables, {
                signal: signal
            }),
        onMutate: async (variables, { client: client })=>{
            await client.cancelQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.all
            });
            const previousData = client.getQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(id ?? variables?.id));
            const previousLists = client.getQueriesData({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
            client.setQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(id ?? variables?.id), {
                ...previousData,
                ...variables
            });
            $d591884ca5cc206e$var$updateVideoLists(client, (videos)=>videos.map((v)=>v.id === (id ?? variables?.id) ? {
                        ...v,
                        ...variables
                    } : v));
            return {
                previousData: previousData,
                previousLists: previousLists
            };
        },
        onSuccess: (data, variables, onMutateResult, { client: client })=>{
            client.setQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(id ?? variables?.id), data);
        },
        onError: (error, variables, { previousData: previousData, previousLists: previousLists } = {}, { client: client })=>{
            console.warn("Error updating video:", error, variables);
            client.setQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(id ?? variables?.id), previousData);
            $d591884ca5cc206e$var$restoreVideoLists(client, previousLists, id ?? variables?.id);
        },
        onSettled: (data, error, variables, onMutateResult, { client: client })=>{
            client.invalidateQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
            if (client.isMutating({
                mutationKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail(id ?? variables?.id)
            }) === 1) client.invalidateQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail(id ?? variables?.id)
            });
        },
        meta: {
            errorMessage: "Failed to update the project."
        }
    });
};
const $d591884ca5cc206e$export$e36b6051e578f0b4 = ()=>{
    return (0, $k6waQ.useMutation)({
        mutationKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists(),
        mutationFn: (variables, { signal: signal })=>$8ZGjb.deleteVideo(variables.id, {
                signal: signal
            }),
        onMutate: async (variables, { client: client })=>{
            await client.cancelQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
            const previousData = client.getQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(variables.id));
            const previousLists = client.getQueriesData({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
            $d591884ca5cc206e$var$updateVideoLists(client, (videos)=>videos.filter((v)=>v.id !== variables.id));
            client.removeQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.detail(variables.id)
            });
            return {
                previousData: previousData,
                previousLists: previousLists
            };
        },
        onError: (error, variables, { previousLists: previousLists, previousData: previousData } = {}, { client: client })=>{
            $d591884ca5cc206e$var$restoreVideoLists(client, previousLists, variables.id);
            client.setQueryData($d591884ca5cc206e$export$90e89cae5bffb368.detail(variables.id), previousData);
        },
        onSettled: (data, error, variables, onMutateResult, { client: client })=>{
            client.invalidateQueries({
                queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.lists()
            });
        }
    });
};
const $d591884ca5cc206e$export$7b2bccbde1d8e953 = (filters = {}, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: [
            ...$d591884ca5cc206e$export$90e89cae5bffb368.templates(),
            {
                filters: filters
            }
        ],
        queryFn: ({ signal: signal })=>$hOI0D.getVideoTemplates(filters, {
                signal: signal
            }),
        staleTime: 300000,
        meta: {
            errorMessage: "Failed to load video templates. Please try again."
        },
        ...options
    });
};
const $d591884ca5cc206e$export$f0928a4bedb96ae3 = (id, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $d591884ca5cc206e$export$90e89cae5bffb368.template(id),
        queryFn: ({ signal: signal })=>$hOI0D.getVideoTemplate(id, {
                signal: signal
            }),
        staleTime: 300000,
        meta: {
            errorMessage: "Failed to load the video template. Please try again."
        },
        enabled: !!id,
        ...options
    });
};
const $d591884ca5cc206e$var$handleAssetDownload = async (asset, { client: client, signal: signal })=>{
    if (asset.type === "color") {
        const color = asset.color ?? asset.value;
        if (!color) throw new Error("No color to download");
        const blob = await (0, $6lZyT.createImageColorBlob)(color);
        return {
            blob: blob,
            name: asset.name,
            contentType: "image/png"
        };
    }
    let url = asset.src;
    if (asset.filePath) {
        const queryKey = (0, $a8sj2.s3Key).presignURL(asset.filePath);
        const cancelPresignQuery = ()=>client.cancelQueries({
                queryKey: queryKey
            });
        signal?.addEventListener("abort", cancelPresignQuery);
        try {
            const s3Data = await client.query((0, $a8sj2.presignURLQueryOptions)(asset.filePath));
            url = s3Data.presignURL;
        } finally{
            signal?.removeEventListener("abort", cancelPresignQuery);
        }
    }
    return {
        url: url,
        name: asset.name
    };
};
const $d591884ca5cc206e$export$970d76847a0f6577 = ()=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: $d591884ca5cc206e$var$handleAssetDownload,
        onSuccess: (data)=>{
            if (data.blob) return (0, $9lDhw.downloadFile)(data.blob, data.name, data.contentType);
            return (0, $9lDhw.downloadImage)(data, data.name);
        }
    });
};
const $d591884ca5cc206e$export$e7242f9c3fa2d32c = (videoId)=>{
    const video = $d591884ca5cc206e$export$5269023cd97c8c79(videoId);
    const template = $d591884ca5cc206e$export$f0928a4bedb96ae3(video.data?.templateId);
    const assetsTemplate = (0, $fK5Xl.useExpressTemplate)(video.data?.assetsTemplateId);
    const exportBanners = (0, $CGZx1.useExportBanners)(video.data?.id, {
        enabled: !!video.data?.templateAssetsRenditions?.filter((rendition)=>!!rendition?.id).length
    });
    const assets = (0, $eF4cA.useMemo)(()=>{
        const orderedKeys = [
            ...(template.data?.assets ?? []).map((asset)=>asset.name),
            ...(template.data?.verticals ?? []).flatMap((vertical)=>(vertical.assets ?? []).map((asset)=>asset.name)),
            ...(template.data?.imageVariations ?? []).filter((asset)=>!!asset.type).map((asset)=>asset.key)
        ];
        const uniqueOrderedKeys = [
            ...new Set(orderedKeys.filter(Boolean))
        ];
        const videoByName = new Map((video.data?.assets ?? []).filter((asset)=>asset?.name).map((asset)=>[
                asset.name,
                asset
            ]));
        const baseAssets = uniqueOrderedKeys.map((key)=>videoByName.get(key)).filter(Boolean);
        const renditionFileByPage = new Map((video.data?.templateAssetsRenditionFiles ?? []).filter((file)=>file?.filePath).map((file)=>[
                file.pageNumber,
                file.filePath
            ]));
        const templateAssets = assetsTemplate.data?.pages?.flatMap((page)=>page.documentPages.flatMap((docPage)=>docPage).map(({ pageTitle: pageTitle, pageNumber: pageNumber, size: size })=>({
                    name: `${pageTitle ?? "Page"} ${pageNumber}`,
                    pageNumber: pageNumber,
                    filePath: renditionFileByPage.get(pageNumber),
                    src: exportBanners.data?.find((rendition)=>rendition.pageNumber === pageNumber)?.renditionUrl,
                    size: size
                }))) ?? [];
        return [
            ...baseAssets,
            ...templateAssets
        ].map((asset)=>({
                ...asset,
                name: video.data?.customer?.name ? `${video.data?.customer?.name}_${asset.name}` : asset.name
            }));
    }, [
        template.data,
        video.data?.assets,
        video.data?.customer?.name,
        video.data?.templateAssetsRenditionFiles,
        assetsTemplate.data?.pages,
        exportBanners.data
    ]);
    return {
        assets: assets,
        isLoading: video.isLoading || assetsTemplate.isLoading || exportBanners.isLoading
    };
};
const $d591884ca5cc206e$export$c2d87ad67c84aef = (videoId)=>{
    const video = $d591884ca5cc206e$export$5269023cd97c8c79(videoId);
    const template = $d591884ca5cc206e$export$f0928a4bedb96ae3(video.data?.templateId);
    const { assets: assets } = $d591884ca5cc206e$export$e7242f9c3fa2d32c(videoId);
    const selectedCampaign = (0, $eF4cA.useMemo)(()=>video.data?.campaigns?.find((campaign)=>campaign.id === video.data?.selectedCampaignIds?.[0]), [
        video.data?.campaigns,
        video.data?.selectedCampaignIds
    ]);
    return (0, $k6waQ.useMutation)({
        mutationFn: async (_, { client: client, signal: signal })=>{
            const isModular = video.data?.templateType === "modular";
            let texts;
            if (video.data?.templateId === "one-adobe" && selectedCampaign) texts = [
                {
                    name: "selected-campaign",
                    data: {
                        ...selectedCampaign,
                        "Customer-color-primary": video.data?.customer?.["Brand-color"] ?? null,
                        "Customer-color-secondary": video.data?.customer?.["Secondary-color"] ?? null
                    }
                }
            ];
            else if (isModular) try {
                const exportData = await (0, $6yR6I.buildModularExportJson)({
                    videoData: video.data,
                    templateData: template.data,
                    queryClient: client
                });
                texts = [
                    {
                        name: "export",
                        data: exportData
                    }
                ];
            } catch (error) {
                console.debug("Failed to build modular export.json", error);
            }
            else if (video.data?.templateType === "mogrt" && selectedCampaign && video.data?.mogrtRootPath) for (const exportFileName of [
                "export-grouped.json",
                "export.json"
            ]){
                const exportPath = `${video.data.mogrtRootPath.replace(/\/$/, "")}/${exportFileName}`;
                const s3Data = await client.query((0, $a8sj2.presignURLQueryOptions)(exportPath));
                const res = await fetch(s3Data.presignURL);
                if (res.status === 404 && exportFileName === "export-grouped.json") continue;
                if (!res.ok) {
                    console.debug("Failed to fetch export template");
                    break;
                }
                const exportTemplate = await res.json();
                const merged = (0, $9lDhw.generateExportJson)(exportTemplate, selectedCampaign, exportFileName);
                texts = [
                    {
                        name: "export",
                        data: merged
                    }
                ];
                break;
            }
            const assetsToDownload = isModular ? video.data?.assets ?? [] : assets;
            const stripNamePrefix = (asset)=>{
                let s = String(asset.name ?? "");
                const prefix = video.data?.customer?.name;
                if (prefix && s.startsWith(prefix)) s = s.slice(prefix.length).replace(/^_/, "") || s;
                const pageNumber = asset.pageNumber;
                if (pageNumber != null) {
                    const suffix = ` ${pageNumber}`;
                    if (s.endsWith(suffix)) s = s.slice(0, s.length - suffix.length);
                }
                return (s || asset.name) ?? "";
            };
            const downloadName = (asset)=>{
                if (isModular && asset.filePath) {
                    const base = asset.filePath.split("/").pop() ?? asset.name;
                    return base.replace(/\.[^./]+$/, "");
                }
                return stripNamePrefix(asset);
            };
            const images = await Promise.all(assetsToDownload.map((asset)=>$d591884ca5cc206e$var$handleAssetDownload({
                    ...asset,
                    name: downloadName(asset)
                }, {
                    client: client,
                    signal: signal
                })));
            return {
                images: images,
                texts: texts
            };
        },
        onSuccess: (data)=>{
            return (0, $9lDhw.downloadImages)(data.images, `${video.data?.name}_assets`, data.texts);
        }
    });
};

});
parcelRegister("iFK2s", function(module, exports) {

$parcel$export(module.exports, "useInfiniteQuery", () => $d97fc4a22b1cee82$export$bdc59d3c1a6569aa);

var $hGrCf = parcelRequire("hGrCf");

var $jlCVH = parcelRequire("jlCVH");
"use client";
//#region src/useInfiniteQuery.ts
function $d97fc4a22b1cee82$export$bdc59d3c1a6569aa(options, queryClient) {
    return (0, $hGrCf.useBaseQuery)(options, (0, $jlCVH.InfiniteQueryObserver), queryClient);
}

});
parcelRegister("jlCVH", function(module, exports) {

$parcel$export(module.exports, "InfiniteQueryObserver", () => $e15e2d14fea2bb77$export$85d960eb3ab339c8);

var $edy1c = parcelRequire("edy1c");

var $hpFA5 = parcelRequire("hpFA5");
//#region src/infiniteQueryObserver.ts
/**
* An `InfiniteQueryObserver` extends `QueryObserver` to observe and switch
* between infinite queries. It augments the base `QueryObserverResult` with
* infinite-query-specific fields and methods, such as `hasNextPage` and
* `fetchNextPage`, and is the primitive that framework adapters (e.g.
* `useInfiniteQuery`) build their hooks on top of.
* @example
* ```ts
* const observer = new InfiniteQueryObserver(queryClient, {
*   queryKey: ['projects'],
*   queryFn: ({ pageParam }) => fetchProjects(pageParam),
*   initialPageParam: 0,
*   getNextPageParam: (lastPage) => lastPage.nextCursor,
* })
*
* const unsubscribe = observer.subscribe((result) => console.log(result))
* ```
*/ var $e15e2d14fea2bb77$export$85d960eb3ab339c8 = class extends (0, $hpFA5.QueryObserver) {
    constructor(client, options){
        super(client, options);
    }
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    /**
	* Updates the observer's options. Behaves the same as
	* `QueryObserver.setOptions`, additionally marking the options as
	* belonging to an infinite query before delegating to the base
	* implementation.
	* @param options - The new infinite query observer options.
	*/ setOptions(options) {
        options._type = "infinite";
        super.setOptions(options);
    }
    /**
	* The infinite-query counterpart of {@link QueryObserver#getOptimisticResult}, marking the
	* options as an infinite query before delegating to it. Called by framework adapters (e.g.
	* `useInfiniteQuery`) ahead of subscribing, to compute the current `InfiniteQueryObserverResult`
	* synchronously.
	* @param options - The defaulted infinite query observer options to compute the result for.
	* @returns The result for the given options.
	*/ getOptimisticResult(options) {
        options._type = "infinite";
        return super.getOptimisticResult(options);
    }
    /**
	* Fetches the next page of the infinite query and returns a promise that
	* resolves with the resulting `InfiniteQueryObserverResult`. The page
	* param used for the fetch is determined by `getNextPageParam`, which
	* receives the current pages/page params and whose result also determines
	* `hasNextPage`.
	* @param options - Set `cancelRefetch` to `false` to ignore the call while a fetch is running,
	* and `throwOnError` to `true` to reject when the fetch fails.
	* @returns A promise that resolves with the result after the next page is fetched. With
	* `cancelRefetch: false`, a running fetch is reused instead, so the next page may not be fetched.
	* @see {@link InfiniteQueryObserver#fetchPreviousPage}
	* @example
	* ```ts
	* const { hasNextPage } = observer.getCurrentResult()
	*
	* if (hasNextPage) {
	*   await observer.fetchNextPage()
	* }
	* ```
	*/ fetchNextPage(options) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "forward"
                }
            }
        });
    }
    /**
	* Fetches the previous page of the infinite query and returns a promise
	* that resolves with the resulting `InfiniteQueryObserverResult`. The page
	* param used for the fetch is determined by `getPreviousPageParam`, which
	* receives the current pages/page params and whose result also determines
	* `hasPreviousPage`.
	* @param options - Set `cancelRefetch` to `false` to ignore the call while a fetch is running,
	* and `throwOnError` to `true` to reject when the fetch fails.
	* @returns A promise that resolves with the result after the previous page is fetched. With
	* `cancelRefetch: false`, a running fetch is reused instead, so the previous page may not be fetched.
	* @see {@link InfiniteQueryObserver#fetchNextPage}
	* @example
	* ```ts
	* const { hasPreviousPage } = observer.getCurrentResult()
	*
	* if (hasPreviousPage) {
	*   await observer.fetchPreviousPage()
	* }
	* ```
	*/ fetchPreviousPage(options) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "backward"
                }
            }
        });
    }
    createResult(query, options) {
        const { state: state } = query;
        const parentResult = super.createResult(query, options);
        const { isFetching: isFetching, isRefetching: isRefetching, isError: isError, isRefetchError: isRefetchError } = parentResult;
        const fetchDirection = state.fetchMeta?.fetchMore?.direction;
        const isFetchNextPageError = isError && fetchDirection === "forward";
        const isFetchingNextPage = isFetching && fetchDirection === "forward";
        const isFetchPreviousPageError = isError && fetchDirection === "backward";
        const isFetchingPreviousPage = isFetching && fetchDirection === "backward";
        return {
            ...parentResult,
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $edy1c.hasNextPage)(options, state.data),
            hasPreviousPage: (0, $edy1c.hasPreviousPage)(options, state.data),
            isFetchNextPageError: isFetchNextPageError,
            isFetchingNextPage: isFetchingNextPage,
            isFetchPreviousPageError: isFetchPreviousPageError,
            isFetchingPreviousPage: isFetchingPreviousPage,
            isRefetchError: isRefetchError && !isFetchNextPageError && !isFetchPreviousPageError,
            isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
        };
    }
};

});


parcelRegister("8ZGjb", function(module, exports) {

$parcel$export(module.exports, "getVideos", () => $68c4d6d3573e6e17$export$cd7cdf6690c6f106);
$parcel$export(module.exports, "getVideo", () => $68c4d6d3573e6e17$export$8c6fe3bf4851df71);
$parcel$export(module.exports, "createVideo", () => $68c4d6d3573e6e17$export$5b2fc423a43528b);
$parcel$export(module.exports, "duplicateVideo", () => $68c4d6d3573e6e17$export$7445063bb6c4da9c);
$parcel$export(module.exports, "deleteVideo", () => $68c4d6d3573e6e17$export$67c39cca4e2f1c45);
$parcel$export(module.exports, "updateVideo", () => $68c4d6d3573e6e17$export$f3d1390c48a99b0e);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $68c4d6d3573e6e17$export$c2b1a108a90fb881 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/videos"]);
const $68c4d6d3573e6e17$export$cd7cdf6690c6f106 = async (user = "me", options = {}, filters = {})=>{
    const path = user === "me" ? "/" : `/user/${encodeURIComponent(user)}`;
    const response = await $68c4d6d3573e6e17$export$c2b1a108a90fb881.get(path, filters, options);
    if (!response.ok) throw new Error("Failed to fetch videos", {
        cause: response
    });
    return response.data;
};
const $68c4d6d3573e6e17$export$8c6fe3bf4851df71 = async (id, options = {})=>{
    if (!id) throw new Error("Video ID is required to fetch video");
    const response = await $68c4d6d3573e6e17$export$c2b1a108a90fb881.get(`/${id}`, {}, options);
    if (!response.ok) throw new Error("Failed to fetch video", {
        cause: response
    });
    if (response.data?.video?.urls) response.data.video.urls = Array.from(new Map(response.data.video.urls.filter(([url])=>!!url)));
    return response.data?.video;
};
const $68c4d6d3573e6e17$export$5b2fc423a43528b = async (videoData, options = {})=>{
    const response = await $68c4d6d3573e6e17$export$c2b1a108a90fb881.post("/", videoData, options);
    if (!response.ok) throw new Error("Failed to create video", {
        cause: response
    });
    return response.data?.video;
};
const $68c4d6d3573e6e17$export$7445063bb6c4da9c = async (id, options = {})=>{
    if (!id) throw new Error("Video ID is required to duplicate video");
    const response = await $68c4d6d3573e6e17$export$c2b1a108a90fb881.post(`/${id}/duplicate`, {}, {
        timeout: 600000,
        ...options
    });
    if (!response.ok) throw new Error("Failed to duplicate video", {
        cause: response
    });
    return response.data?.video;
};
const $68c4d6d3573e6e17$export$67c39cca4e2f1c45 = async (id, options = {})=>{
    if (!id) throw new Error("Video ID is required to delete video");
    const response = await $68c4d6d3573e6e17$export$c2b1a108a90fb881.delete(`/${id}`, {}, options);
    if (!response.ok) throw new Error("Failed to delete video", {
        cause: response
    });
    return response.data;
};
const $68c4d6d3573e6e17$export$f3d1390c48a99b0e = async (id, videoData, options = {})=>{
    if (!id) throw new Error("Video ID is required to update video");
    const response = await $68c4d6d3573e6e17$export$c2b1a108a90fb881.put(`/${id}`, videoData, options);
    if (!response.ok) throw new Error("Failed to update video", {
        cause: response
    });
    return response.data?.video;
};

});

parcelRegister("hOI0D", function(module, exports) {

$parcel$export(module.exports, "getVideoTemplates", () => $cf893e8423ddd1a1$export$7c95ce9c8533793a);
$parcel$export(module.exports, "getVideoTemplate", () => $cf893e8423ddd1a1$export$7018ab3c421e2802);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $cf893e8423ddd1a1$export$eb3ba404725c90eb = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/templates"]);
const $cf893e8423ddd1a1$export$7c95ce9c8533793a = async (filters = {}, options = {})=>{
    const response = await $cf893e8423ddd1a1$export$eb3ba404725c90eb.get("/", filters, options);
    if (!response.ok) throw new Error("Failed to fetch video templates", {
        cause: response
    });
    return response.data?.templates ?? [];
};
const $cf893e8423ddd1a1$export$7018ab3c421e2802 = async (id, options = {})=>{
    if (!id) throw new Error("Template ID is required to fetch video template");
    const response = await $cf893e8423ddd1a1$export$eb3ba404725c90eb.get(`/${id}`, {}, options);
    if (!response.ok) throw new Error("Failed to fetch video template", {
        cause: response
    });
    return response.data?.template;
};

});

parcelRegister("6yR6I", function(module, exports) {

$parcel$export(module.exports, "buildModulesFromScenes", () => $4c6f1d0f13211c93$export$2dbf6d334f16dacc);
$parcel$export(module.exports, "assignScenesToModules", () => $4c6f1d0f13211c93$export$afec1b2db3b4a04f);
$parcel$export(module.exports, "collectTemplateVideoAssets", () => $4c6f1d0f13211c93$export$b995d8bef60f7314);
$parcel$export(module.exports, "applyScenesToModuleControls", () => $4c6f1d0f13211c93$export$db6565bf95ba083a);
$parcel$export(module.exports, "getVideoScenes", () => $4c6f1d0f13211c93$export$b280b217df4b2b60);
$parcel$export(module.exports, "buildModularExportJson", () => $4c6f1d0f13211c93$export$8b30d75716570dde);

var $a8sj2 = parcelRequire("a8sj2");

var $iMKxE = parcelRequire("iMKxE");
const $4c6f1d0f13211c93$export$3846b9bc73cdebde = 4;
const $4c6f1d0f13211c93$export$1ea19c1342c5d85c = (hex)=>{
    if (hex == null || hex === "") return "";
    return String(hex).replace(/^#/, "").toUpperCase();
};
const $4c6f1d0f13211c93$export$89e52c096e659089 = (scenes)=>{
    if (!Array.isArray(scenes) || scenes.length < $4c6f1d0f13211c93$export$3846b9bc73cdebde) return 0;
    const baseSceneCount = scenes.length - $4c6f1d0f13211c93$export$3846b9bc73cdebde;
    return Math.floor(baseSceneCount / $4c6f1d0f13211c93$export$3846b9bc73cdebde);
};
const $4c6f1d0f13211c93$export$2dbf6d334f16dacc = (scenes = [], templateModules = [])=>{
    const byName = Object.fromEntries((Array.isArray(templateModules) ? templateModules : []).map((module)=>[
            module.name,
            module
        ]));
    const intro = byName.Intro;
    const baseUnit = byName.BaseUnit;
    const closingUnit = byName.ClosingUnit;
    const baseUnitCount = $4c6f1d0f13211c93$export$89e52c096e659089(scenes);
    return [
        intro,
        ...Array.from({
            length: baseUnitCount
        }, ()=>({
                ...baseUnit
            })),
        closingUnit
    ].map(({ name: name, description: description, rootPath: rootPath, duration: duration })=>({
            name: name,
            description: description,
            rootPath: rootPath,
            duration: duration
        }));
};
const $4c6f1d0f13211c93$export$afec1b2db3b4a04f = (scenes)=>{
    if (!Array.isArray(scenes) || scenes.length === 0) return [
        {
            name: "Intro",
            scenes: []
        },
        {
            name: "ClosingUnit",
            scenes: []
        }
    ];
    if (scenes.length < $4c6f1d0f13211c93$export$3846b9bc73cdebde) return [
        {
            name: "Intro",
            scenes: []
        },
        {
            name: "ClosingUnit",
            scenes: scenes
        }
    ];
    const assignments = [
        {
            name: "Intro",
            scenes: []
        }
    ];
    const closingScenes = scenes.slice(-$4c6f1d0f13211c93$export$3846b9bc73cdebde);
    const basePool = scenes.slice(0, -$4c6f1d0f13211c93$export$3846b9bc73cdebde);
    const baseUnitCount = Math.floor(basePool.length / $4c6f1d0f13211c93$export$3846b9bc73cdebde);
    for(let index = 0; index < baseUnitCount; index++)assignments.push({
        name: "BaseUnit",
        scenes: basePool.slice(index * $4c6f1d0f13211c93$export$3846b9bc73cdebde, index * $4c6f1d0f13211c93$export$3846b9bc73cdebde + $4c6f1d0f13211c93$export$3846b9bc73cdebde)
    });
    assignments.push({
        name: "ClosingUnit",
        scenes: closingScenes
    });
    return assignments;
};
const $4c6f1d0f13211c93$export$b995d8bef60f7314 = (templateData, videoData)=>{
    const verticals = templateData?.verticals ?? templateData?.["verticals-tmp"] ?? [];
    const verticalKey = videoData?.verticalKey;
    const vertical = verticals.find((item)=>item.key === verticalKey) ?? verticals.find((item)=>item.isDefault) ?? verticals[0];
    const verticalAssets = vertical?.assets ?? [];
    const uploadedVideoAssets = (videoData?.assets ?? []).filter((asset)=>asset?.type === "video" || asset?.filePath?.toLowerCase().endsWith(".mp4") || asset?.name?.startsWith("GENERIC-"));
    const byName = new Map();
    for (const asset of [
        ...verticalAssets,
        ...uploadedVideoAssets
    ]){
        if (asset?.name) byName.set(asset.name, asset);
        if (asset?.filePath) {
            byName.set(asset.filePath, asset);
            const baseName = asset.filePath.split("/").pop()?.replace(/\.mp4$/i, "");
            if (baseName) byName.set(baseName, asset);
        }
    }
    return Array.from(byName.values());
};
const $4c6f1d0f13211c93$var$resolveVideoAsset = async (videoRef, context)=>{
    if (!videoRef) return null;
    const ref = String(videoRef).trim();
    const { assets: assets = [], queryClient: queryClient, templateVideoAssets: templateVideoAssets = [] } = context;
    const matched = assets.find((asset)=>asset.name === ref || asset.filePath === ref || asset.filePath?.endsWith(`/${ref}.mp4`) || asset.filePath?.endsWith(`/${ref}`)) ?? templateVideoAssets.find((asset)=>asset.name === ref || asset.filePath === ref || asset.filePath?.endsWith(`/${ref}.mp4`) || asset.filePath?.endsWith(`/${ref}`));
    if (matched) {
        if (matched.url) return {
            url: matched.url
        };
        if (matched.filePath && queryClient) {
            const s3Asset = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(matched.filePath));
            return {
                url: s3Asset.presignURL
            };
        }
    }
    // No known asset: treat the ref as a direct S3 key and presign it the same
    // way image assets are (e.g. "mogrt/footage/generic/GENERIC-...mp4").
    if (queryClient && (/\.(mp4|mov|webm|m4v)$/i.test(ref) || ref.includes("/"))) {
        const s3Asset = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(ref));
        return {
            url: s3Asset.presignURL
        };
    }
    return null;
};
const $4c6f1d0f13211c93$export$5bb6945aa377f088 = (scene, sceneNumber)=>[
        {
            label: `Scene${sceneNumber}-Text`,
            kind: "text",
            value: scene.Text
        },
        {
            label: `Scene${sceneNumber}-Text-Motion`,
            kind: "text",
            value: scene.Motion
        },
        {
            label: `Scene${sceneNumber}-Color1`,
            kind: "text",
            value: $4c6f1d0f13211c93$export$1ea19c1342c5d85c(scene.Color?.[0])
        },
        {
            label: `Scene${sceneNumber}-Color2`,
            kind: "text",
            value: $4c6f1d0f13211c93$export$1ea19c1342c5d85c(scene.Color?.[1] ?? scene.Color?.[0])
        },
        {
            label: `Scene${sceneNumber}-Video1`,
            kind: "video",
            value: scene.Video?.[0]
        },
        {
            label: `Scene${sceneNumber}-Video2`,
            kind: "video",
            value: scene.Video?.[1]
        }
    ];
const $4c6f1d0f13211c93$export$db6565bf95ba083a = async (scenes, controls, context)=>{
    if (!Array.isArray(scenes) || !Array.isArray(controls) || !scenes.length) return {};
    const controlByLabel = new Map(controls.map((control)=>[
            control.label ?? "",
            control
        ]));
    const formValues = {};
    for(let index = 0; index < Math.min(scenes.length, $4c6f1d0f13211c93$export$3846b9bc73cdebde); index++){
        const scene = scenes[index] ?? {};
        const sceneNumber = index + 1;
        for (const { label: label, kind: kind, value: value } of $4c6f1d0f13211c93$export$5bb6945aa377f088(scene, sceneNumber)){
            const control = controlByLabel.get(label);
            if (!control) continue;
            if (kind === "video") {
                if (!value) continue;
                const media = await $4c6f1d0f13211c93$var$resolveVideoAsset(value, context);
                if (media) formValues[control.variableId] = media;
            } else if (label.endsWith("-Text")) {
                const text = value ?? control.defaultData?.text ?? "";
                if (text !== "") formValues[control.variableId] = text;
            } else if (label.endsWith("-Text-Motion")) formValues[control.variableId] = value ?? control.defaultData?.text ?? "Subtle";
            else // Color1 / Color2
            formValues[control.variableId] = value || control.defaultData?.text || "";
        }
    }
    return formValues;
};
/** Basename of a video reference (asset name, filePath, or S3 key). */ const $4c6f1d0f13211c93$var$videoFileName = (ref)=>{
    if (ref == null || ref === "") return "";
    return String(ref).split("/").pop() ?? "";
};
const $4c6f1d0f13211c93$export$b2218e924eb17e81 = (exportTemplate, scenes, { logoFileName: logoFileName } = {})=>{
    if (!exportTemplate || typeof exportTemplate !== "object") return exportTemplate;
    const topKey = Object.keys(exportTemplate)[0];
    if (!topKey) return exportTemplate;
    const cloned = JSON.parse(JSON.stringify(exportTemplate));
    const items = cloned[topKey];
    if (!items || typeof items !== "object") return cloned;
    const setSourceText = (label, value)=>{
        if (value == null || value === "") return;
        const item = items[label];
        if (item?.Text?.["Source Text"] !== undefined) item.Text["Source Text"] = String(value);
    };
    const setPathSource = (label, value)=>{
        if (value == null || value === "") return;
        const item = items[label];
        if (item?.Path?.["Source"] !== undefined) item.Path["Source"] = String(value);
    };
    // Base (non-scene) value — fills modules with a `Logo` control, incl. Intro.
    setPathSource("Logo", logoFileName);
    const list = Array.isArray(scenes) ? scenes : [];
    for(let index = 0; index < Math.min(list.length, $4c6f1d0f13211c93$export$3846b9bc73cdebde); index++){
        const scene = list[index] ?? {};
        const sceneNumber = index + 1;
        for (const { label: label, kind: kind, value: value } of $4c6f1d0f13211c93$export$5bb6945aa377f088(scene, sceneNumber))if (kind === "video") setPathSource(label, $4c6f1d0f13211c93$var$videoFileName(value));
        else setSourceText(label, value);
    }
    return cloned;
};
const $4c6f1d0f13211c93$export$b280b217df4b2b60 = (videoData)=>{
    if (Array.isArray(videoData?.scenes) && videoData.scenes.length) return videoData.scenes;
    const selectedCampaign = videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0]);
    const latestCampaign = videoData?.campaigns?.[videoData.campaigns.length - 1];
    return selectedCampaign?.scenes ?? latestCampaign?.scenes ?? videoData?.campaigns?.[0]?.scenes ?? [];
};
const $4c6f1d0f13211c93$export$8b30d75716570dde = async ({ videoData: videoData, templateData: templateData, queryClient: queryClient })=>{
    const scenes = $4c6f1d0f13211c93$export$b280b217df4b2b60(videoData);
    const resolvedModules = videoData?.modules?.length ? videoData.modules : $4c6f1d0f13211c93$export$2dbf6d334f16dacc(scenes, templateData?.modules);
    const sceneAssignments = $4c6f1d0f13211c93$export$afec1b2db3b4a04f(scenes);
    // Logo is resolved the way the modular render resolves it (mapTaggedValue):
    // prefer the cropped variant, fall back to the raw "Logo" asset.
    const logoAsset = videoData?.assets?.find((asset)=>asset.name === "Logo_cropped") ?? videoData?.assets?.find((asset)=>asset.name === "Logo");
    const logoFileName = logoAsset?.filePath?.split("/").pop() ?? "";
    // Same order as `resolvedModules`; gives us each module's `.mogrt` path.
    const modularData = await queryClient.query((0, $iMKxE.modularTemplateQueryOptions)(resolvedModules));
    return Promise.all(resolvedModules.map(async (moduleData, index)=>{
        const mogrtPath = modularData.modules?.[index]?.mogrtPath ?? "";
        const mogrt = mogrtPath.split("/").pop() ?? "";
        const rootPath = moduleData?.rootPath;
        let sceneData = {};
        if (rootPath) {
            const exportPath = `${rootPath.replace(/\/$/, "")}/export.json`;
            try {
                const s3Data = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(exportPath));
                const res = await fetch(s3Data.presignURL);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const exportTemplate = await res.json();
                const filled = $4c6f1d0f13211c93$export$b2218e924eb17e81(exportTemplate, sceneAssignments[index]?.scenes ?? [], {
                    logoFileName: logoFileName
                });
                const topKey = Object.keys(filled ?? {})[0];
                sceneData = topKey ? filled[topKey] : filled ?? {};
            } catch (error) {
                console.debug(`No export.json for module "${moduleData?.name}" (${exportPath})`, error);
            }
        }
        return {
            mogrt: mogrt,
            scenes: sceneData
        };
    }));
};

});
parcelRegister("iMKxE", function(module, exports) {

$parcel$export(module.exports, "modularTemplateQueryOptions", () => $dad0cfe59196c7fc$export$bb2a7187f0c72784);
$parcel$export(module.exports, "jobStatusQueryOptions", () => $dad0cfe59196c7fc$export$b235907f4932200);
$parcel$export(module.exports, "useDescribeMogrtTemplate", () => $dad0cfe59196c7fc$export$e7aaf9d3dac8e968);
$parcel$export(module.exports, "useDescribeModularTemplate", () => $dad0cfe59196c7fc$export$ea8a628c76d577da);
$parcel$export(module.exports, "useMogrtStatus", () => $dad0cfe59196c7fc$export$5e7b2a1e06de3220);
$parcel$export(module.exports, "useRenderMogrtTemplate", () => $dad0cfe59196c7fc$export$c8a9836b41e2fd7b);
$parcel$export(module.exports, "buildRenderPayload", () => $dad0cfe59196c7fc$export$74823c27e76259cf);

var $eF4cA = parcelRequire("eF4cA");

var $1WYFS = parcelRequire("1WYFS");
var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");

var $5nqV3 = parcelRequire("5nqV3");

var $D7J7L = parcelRequire("D7J7L");

var $8oFcj = parcelRequire("8oFcj");
parcelRequire("dFfaH");
var $5uQ6L = parcelRequire("5uQ6L");
const $dad0cfe59196c7fc$export$c547a9f31df8d21a = {
    all: [
        "mogrtTemplates"
    ],
    lists: ()=>[
            ...$dad0cfe59196c7fc$export$c547a9f31df8d21a.all,
            "list"
        ],
    describes: ()=>[
            ...$dad0cfe59196c7fc$export$c547a9f31df8d21a.all,
            "describes"
        ],
    describe: (id)=>[
            ...$dad0cfe59196c7fc$export$c547a9f31df8d21a.describes(),
            id
        ],
    voices: ()=>[
            ...$dad0cfe59196c7fc$export$c547a9f31df8d21a.all,
            "voices"
        ],
    statuses: ()=>[
            ...$dad0cfe59196c7fc$export$c547a9f31df8d21a.all,
            "statuses"
        ],
    status: (jobId)=>[
            ...$dad0cfe59196c7fc$export$c547a9f31df8d21a.statuses(),
            jobId
        ]
};
async function $dad0cfe59196c7fc$var$describeSingleMogrtPath(path, signal) {
    const directoryPath = `${path}/`;
    const mediaDirectoryPath = `${path}/media/`;
    const videoDirectoryPath = `${path}/videos/`;
    const eprDirectoryPath = `${path}/epr/`;
    const musicDirectoryPath = `${path}/music/`;
    const [mediaResponse, videoResponse, eprResponse, fileResponse, musicResponse] = await Promise.all([
        (0, $D7J7L.listFilesInDirectory)(mediaDirectoryPath, {
            signal: signal
        }),
        (0, $D7J7L.listFilesInDirectory)(videoDirectoryPath, {
            signal: signal
        }),
        (0, $D7J7L.listFilesInDirectory)(eprDirectoryPath, {
            signal: signal
        }),
        (0, $D7J7L.listFilesInDirectory)(directoryPath, {
            signal: signal
        }),
        (0, $D7J7L.listFilesInDirectory)(musicDirectoryPath, {
            signal: signal
        })
    ]);
    const mediaItems = [
        ...mediaResponse?.urls ?? [],
        ...videoResponse?.urls ?? []
    ];
    const mediaFiles = mediaItems.map((item)=>item.filePath).filter(Boolean).sort((a, b)=>a.localeCompare(b));
    const eprItems = eprResponse?.urls ?? [];
    const eprFiles = eprItems.map((item)=>item.filePath).filter((filePath)=>filePath.toLowerCase().endsWith(".epr"));
    const eprPath = eprFiles?.[0] ?? "";
    const musicItems = musicResponse?.urls ?? [];
    const musicFiles = musicItems.map((item)=>item.filePath).filter((filePath)=>filePath.toLowerCase().endsWith(".mp3") || filePath.toLowerCase().endsWith(".wav"));
    const isVoBed = (filePath)=>/_vo\.(mp3|wav)$/i.test(filePath);
    const isNoVo = (filePath)=>/_novo\.(mp3|wav)$/i.test(filePath);
    const musicPath = musicFiles.find(isVoBed) ?? musicFiles.find((filePath)=>!isNoVo(filePath)) ?? musicFiles?.[0] ?? "";
    const musicNoVoPath = musicFiles.find(isNoVo) ?? musicPath;
    const files = fileResponse?.urls ?? [];
    const mogrtFiles = files.map((item)=>item.filePath).filter((filePath)=>filePath.toLowerCase().endsWith(".mogrt"));
    const mogrtPath = mogrtFiles?.[0];
    if (!mogrtPath) throw new Error("No .mogrt file found in the selected folder");
    const describeFile = files.find((item)=>item?.filePath?.toLowerCase().endsWith("describe-ga.json"));
    if (!describeFile?.presignURL) throw new Error("No describe.json found in the selected folder");
    const describeResponse = await fetch(describeFile.presignURL, {
        signal: signal
    });
    const describePayload = await describeResponse.json();
    const normalizedDescribe = describePayload?.output ? describePayload : {
        output: describePayload
    };
    const elements = normalizedDescribe?.output?.elements ?? [];
    const fonts = normalizedDescribe?.output?.fonts ?? [];
    const controls = elements.flatMap((element)=>element?.controls ?? []);
    const formValues = controls.reduce((acc, control)=>{
        if (control?.type === "text") acc[control.id] = control?.defaultData?.text ?? "";
        else if (control?.type === "media") acc[control.id] = "";
        return acc;
    }, {});
    return {
        mediaFiles: mediaFiles,
        eprPath: eprPath,
        musicPath: musicPath,
        musicNoVoPath: musicNoVoPath,
        mogrtPath: mogrtPath,
        elements: elements,
        fonts: fonts,
        controls: controls,
        formValues: formValues
    };
}
const $dad0cfe59196c7fc$export$ee29dc59064bdb27 = (path, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $dad0cfe59196c7fc$export$c547a9f31df8d21a.describe(path),
        queryFn: ({ signal: signal })=>$dad0cfe59196c7fc$var$describeSingleMogrtPath(path, signal),
        enabled: !!path,
        meta: {
            errorMessage: "Failed to fetch template data. Please try again."
        },
        ...options
    });
const $dad0cfe59196c7fc$export$bb2a7187f0c72784 = (templateModules, options = {})=>{
    const moduleList = Array.isArray(templateModules) ? templateModules : [];
    return (0, $1WYFS.queryOptions)({
        queryKey: $dad0cfe59196c7fc$export$c547a9f31df8d21a.describe(`modular:${moduleList.map((m)=>m.rootPath).join("|")}`),
        queryFn: async ({ signal: signal })=>{
            if (!moduleList.length) throw new Error("No modules defined for the modular template");
            const describeByPath = new Map();
            const describePath = (rootPath)=>{
                if (!describeByPath.has(rootPath)) describeByPath.set(rootPath, $dad0cfe59196c7fc$var$describeSingleMogrtPath(rootPath, signal));
                return describeByPath.get(rootPath);
            };
            const modules = await Promise.all(moduleList.map(async (m)=>({
                    name: m.name,
                    ...await describePath(m.rootPath)
                })));
            return {
                modules: modules
            };
        },
        enabled: moduleList.length > 0,
        staleTime: 1200000,
        gcTime: 3000000,
        meta: {
            errorMessage: "Failed to fetch modular template data. Please try again."
        },
        ...options
    });
};
// Job statuses at which a render has produced its output and polling can stop.
const $dad0cfe59196c7fc$var$TERMINAL_JOB_STATUSES = [
    "generated",
    "completed",
    "succeeded",
    "failed"
];
const $dad0cfe59196c7fc$export$b235907f4932200 = (jobId, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $dad0cfe59196c7fc$export$c547a9f31df8d21a.status(jobId),
        queryFn: ({ signal: signal })=>(0, $8oFcj.getJobStatus)(jobId, {
                signal: signal
            }),
        enabled: !!jobId,
        refetchInterval: (query)=>$dad0cfe59196c7fc$var$TERMINAL_JOB_STATUSES.includes(query.state.data?.status) ? false : 10000,
        ...options
    });
const $dad0cfe59196c7fc$export$77c316ca0eb497c6 = (jobId, options = {})=>{
    return (0, $4kcQz.useQuery)($dad0cfe59196c7fc$export$b235907f4932200(jobId, options));
};
const $dad0cfe59196c7fc$export$e7aaf9d3dac8e968 = (path, options = {})=>{
    return (0, $4kcQz.useQuery)($dad0cfe59196c7fc$export$ee29dc59064bdb27(path, options));
};
const $dad0cfe59196c7fc$export$ea8a628c76d577da = (templateModules, options = {})=>{
    return (0, $4kcQz.useQuery)($dad0cfe59196c7fc$export$bb2a7187f0c72784(templateModules, options));
};
const $dad0cfe59196c7fc$export$449c4f0e29858e0b = (options = {}, { onStatus: onStatus, jobSuccessStatuses: jobSuccessStatuses = [
    "completed"
] } = {}, jobFailureStatuses = [
    "failed"
])=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { signal: signal })=>{
            const { jobId: jobId } = variables;
            const jobRecord = await (0, $8oFcj.getJobStatus)(jobId, {
                signal: variables.signal ?? signal
            });
            const status = jobRecord?.status;
            if (jobSuccessStatuses.includes(status)) return jobRecord;
            else if (status === "failed") throw new Error("Job failed", {
                cause: jobRecord
            });
            onStatus?.(jobRecord);
            throw new Error("Job in progress", {
                cause: jobRecord
            });
        },
        retryDelay: 10000,
        retry: (failureCount, error)=>{
            const status = error?.cause?.status;
            if (jobFailureStatuses.includes(status)) return false;
            return true;
        },
        meta: {
            errorMessage: "Render job failed. Please try again."
        },
        ...options
    });
};
const $dad0cfe59196c7fc$export$5e7b2a1e06de3220 = (options = {}, { onStatus: onStatus, getStatusFn: getStatusFn = (0, $5nqV3.getMogrtStatus) } = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { signal: signal })=>{
            const { jobId: jobId } = variables;
            const statusResponse = await getStatusFn(jobId, {
                signal: variables.signal ?? signal
            });
            const status = statusResponse?.status;
            if (status === "succeeded") return statusResponse;
            else if (status === "failed") throw new Error("Mogrt rendering failed");
            onStatus?.(statusResponse);
            throw new Error("Mogrt rendering in progress", {
                cause: statusResponse
            });
        },
        retryDelay: 5000,
        retry: (failureCount, error)=>{
            if (error?.message?.toLowerCase()?.includes("failed")) return false;
            return true;
        },
        meta: {
            errorMessage: "Failed to fetch job status. Please try again."
        },
        ...options
    });
};
const $dad0cfe59196c7fc$export$c8a9836b41e2fd7b = (options = {})=>{
    const { jobSuccessStatuses: jobSuccessStatuses, ...mutationOptions } = options ?? {};
    const [progress, setProgress] = (0, $eF4cA.useState)(null);
    const jobStatus = $dad0cfe59196c7fc$export$449c4f0e29858e0b({
        onSettled: ()=>{
            setProgress(null);
        }
    }, {
        onStatus: (result)=>{
            if (result?.percentCompleted) {
                const percentCompleted = parseInt(result.percentCompleted, 10);
                setProgress((prev)=>{
                    if (prev === null) return percentCompleted;
                    return Math.min(Math.max(prev, percentCompleted), 99);
                });
            }
        },
        ...jobSuccessStatuses != null ? {
            jobSuccessStatuses: jobSuccessStatuses
        } : {}
    });
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { signal: signal })=>{
            let jobId;
            let renderProgressInterval = null;
            if (variables?.existingJobId) jobId = variables.existingJobId;
            else {
                const payload = $dad0cfe59196c7fc$export$74823c27e76259cf(variables);
                const identity = await (0, $5uQ6L.getAlloy)()?.("getIdentity", {
                    namespaces: [
                        "ECID"
                    ]
                });
                const renderResponse = await (0, $5nqV3.renderMogrtTemplate)({
                    ...payload,
                    videoId: variables.videoId,
                    ecid: identity?.identity?.ECID
                }, {
                    signal: signal
                });
                jobId = renderResponse?.jobId;
                if (!jobId) throw new Error("Failed to render template. Please try again.", {
                    cause: renderResponse
                });
                renderProgressInterval = setInterval(()=>{
                    setProgress((prev)=>{
                        if (prev === null) return prev;
                        else return Math.min(prev + 1, 99);
                    });
                }, 15000); // 40 increments over 10 minutes
            }
            try {
                const jobRecord = await jobStatus.mutateAsync({
                    jobId: jobId,
                    signal: signal
                });
                const outputUrl = jobRecord?.outputs?.[0]?.destination?.url;
                if (!outputUrl) throw new Error("Render succeeded but no output URL returned", {
                    cause: {
                        ...jobRecord,
                        status: "failed"
                    }
                });
                return outputUrl;
            } finally{
                if (renderProgressInterval) clearInterval(renderProgressInterval);
            }
        },
        retry: false,
        meta: {
            errorMessage: "Failed to render template. Please try again."
        },
        ...mutationOptions
    });
    return {
        ...mutation,
        progress: progress
    };
};
// FIXME: temp limit
const $dad0cfe59196c7fc$var$MAX_MOGRT_MEDIA_ASSETS = 28;
const $dad0cfe59196c7fc$var$isBannerControl = (control)=>/banner/i.test(control?.label ?? "");
function $dad0cfe59196c7fc$export$74823c27e76259cf({ fonts: fonts, elements: elements, formValues: formValues, mogrtPath: mogrtPath, eprPath: eprPath, musicPath: musicPath, audioVariations: audioVariations }) {
    const isSingleAudioVariation = (audioVariations?.length ?? 0) <= 1;
    const audioPreference = isSingleAudioVariation ? "mix" : musicPath ? "replace" : "mix";
    const resolvedFonts = fonts.map((font)=>font?.name).filter(Boolean).map((name)=>{
        const fileName = name.toLowerCase().endsWith(".otf") ? name : `${name}.otf`;
        return {
            name: name,
            source: {
                path: `mogrt/fonts/${fileName}`
            }
        };
    });
    const renderElements = elements.map((element)=>{
        const controls = element.controls ?? [];
        const producesAsset = (control)=>(control?.type === "media" || control?.type === "audio") && Boolean(formValues[control.variableId]);
        const assetControls = controls.filter(producesAsset);
        const excess = assetControls.length - $dad0cfe59196c7fc$var$MAX_MOGRT_MEDIA_ASSETS;
        const bannerControls = assetControls.filter($dad0cfe59196c7fc$var$isBannerControl);
        const droppedBanners = new Set();
        // excess > 0
        //   ? new Set(bannerControls.slice(Math.max(0, bannerControls.length - excess)))
        //   : new Set();
        let assets = [];
        let variables = controls.filter((control)=>{
            if (control?.type === "audio") return Boolean(formValues[control.variableId]);
            if (control?.type === "media") {
                if (!Boolean(formValues[control.variableId])) return false;
                if (droppedBanners.has(control)) return false;
                return true;
            }
            return true;
        }).map((control)=>{
            if (control?.type === "text") {
                const text = formValues[control.variableId] ?? control?.defaultData?.text ?? "";
                return {
                    variableId: control.variableId,
                    text: text === "" ? " " : text
                };
            }
            if (control?.type === "media") {
                const assetIndex = assets.push({
                    source: formValues[control.variableId] ?? {}
                }) - 1;
                const label = control?.label?.toLowerCase() ?? "";
                return {
                    variableId: control.variableId,
                    assetIndex: assetIndex,
                    scale: label.includes("logo") || label.includes("icon") ? "fit_to_frame" : "fill_frame"
                };
            }
            if (control?.type === "dropdown") return {
                variableId: control.variableId,
                selectedDropdownValue: formValues[control.variableId] ?? control.defaultData?.selectedDropdownValue ?? "0"
            };
            if (control?.type === "slider") {
                const range = control?.range ?? {};
                return {
                    variableId: control.variableId,
                    selectedSliderValue: formValues[control.variableId] ?? control?.defaultData?.selectedSliderValue ?? range?.minimum ?? 0
                };
            }
            if (control?.type === "audio") {
                const assetIndex = assets.push({
                    source: formValues[control.variableId] ?? {}
                }) - 1;
                return {
                    variableId: control.variableId,
                    assetIndex: assetIndex,
                    audioPreference: audioPreference
                };
            }
            return {
                variableId: control.variableId
            };
        });
        return {
            variations: [
                {
                    variables: variables
                }
            ],
            assets: assets
        };
    });
    const renderElement = renderElements[0] ?? {
        variations: [
            {
                variables: []
            }
        ],
        assets: []
    };
    return {
        type: "mogrt",
        source: {
            path: mogrtPath
        },
        ...resolvedFonts.length > 0 ? {
            fonts: resolvedFonts
        } : {},
        ...eprPath ? {
            presets: [
                {
                    source: {
                        id: "custom_epr_ucx",
                        path: eprPath
                    }
                }
            ]
        } : {
            presets: [
                {
                    source: {
                        presetId: "ffs_video_api_land_1080p_hq"
                    }
                }
            ]
        },
        ...renderElement,
        outputs: [
            {
                variationIndex: 0,
                presetIndex: 0,
                fileName: "output_0_0"
            }
        ]
    };
}

});
parcelRegister("5nqV3", function(module, exports) {

$parcel$export(module.exports, "renderMogrtTemplate", () => $3ea3fb52a936f43c$export$5fd4c6a7aac0b865);
$parcel$export(module.exports, "renderModularTemplate", () => $3ea3fb52a936f43c$export$3641b814cf92914f);
$parcel$export(module.exports, "getVoices", () => $3ea3fb52a936f43c$export$d474912f4c21f069);
$parcel$export(module.exports, "getVoices3p", () => $3ea3fb52a936f43c$export$67fa776af6e27330);
$parcel$export(module.exports, "generateAudio3p", () => $3ea3fb52a936f43c$export$82380490e40bfc49);
$parcel$export(module.exports, "generateSpeech", () => $3ea3fb52a936f43c$export$473c98c5dc3ebb44);
$parcel$export(module.exports, "getMogrtStatus", () => $3ea3fb52a936f43c$export$300d69e0512c0b86);
$parcel$export(module.exports, "audioMux", () => $3ea3fb52a936f43c$export$d092efc3c6c80e1d);
$parcel$export(module.exports, "getAudioStatus", () => $3ea3fb52a936f43c$export$bbf5b9923049cd28);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $3ea3fb52a936f43c$export$ea37ec8360acfed2 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/mogrt"], 1, 1);
const $3ea3fb52a936f43c$export$6f6ff4d19a74520f = async (path, type = "mogrt", options = {})=>{
    if (!path) throw new Error("Template path is required");
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/describe", {
        path: path,
        type: type
    }, options);
    if (!response.ok) throw new Error("Failed to describe mogrt template", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$5fd4c6a7aac0b865 = async (payload = {}, options = {})=>{
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/render", payload, options);
    if (!response.ok) throw new Error("Failed to render mogrt template", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$3641b814cf92914f = async (payload = {}, options = {})=>{
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/render-modular", payload, options);
    if (!response.ok) throw new Error("Failed to render modular template", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$d474912f4c21f069 = async (options = {})=>{
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.get("/voices", {}, options);
    if (!response.ok) throw new Error("Failed to fetch voices", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$67fa776af6e27330 = async (options = {})=>{
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.get("/voices-3p", {}, options);
    if (!response.ok) throw new Error("Failed to fetch 3p voices", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$82380490e40bfc49 = async (payload = {}, options = {})=>{
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/generate-audio-3p", payload, options);
    if (!response.ok) throw new Error("Failed to generate 3p audio", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$473c98c5dc3ebb44 = async (payload = {}, options = {})=>{
    // const audioPayload = {
    //   audios: [
    //     {
    //       source: {
    //         type: "text",
    //         ...payload,
    //       },
    //     },
    //   ],
    // };
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/generate-speech", payload, options);
    if (!response.ok) throw new Error("Failed to generate speech", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$300d69e0512c0b86 = async (jobId, options = {})=>{
    if (!jobId) throw new Error("jobId is required");
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/poll-status", {
        jobId: jobId
    }, options);
    if (!response.ok) throw new Error("Failed to poll mogrt status", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$d092efc3c6c80e1d = async (audios = [], options = {})=>{
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/audio-mux", {
        audios: audios
    }, options);
    if (!response.ok) throw new Error("Failed to mux audio", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$bbf5b9923049cd28 = async (jobId, options = {})=>{
    if (!jobId) throw new Error("jobId is required");
    const response = await $3ea3fb52a936f43c$export$ea37ec8360acfed2.post("/poll-status-audio", {
        jobId: jobId
    }, options);
    if (!response.ok) throw new Error("Failed to poll audio status", {
        cause: response.data
    });
    return response.data;
};
const $3ea3fb52a936f43c$export$d5e5b6e2bddd6f67 = async (jobId, interval = 1000, options = {}, statusCallback = null)=>{
    return new Promise((resolve, reject)=>{
        const poll = setInterval(async ()=>{
            try {
                const statusResponse = await $3ea3fb52a936f43c$export$300d69e0512c0b86(jobId, options);
                const status = statusResponse?.status;
                statusCallback?.(statusResponse);
                if (statusResponse?.success && status === "succeeded") {
                    clearInterval(poll);
                    resolve(statusResponse);
                } else if (status === "failed") {
                    clearInterval(poll);
                    reject(new Error("Mogrt job failed"));
                }
            } catch (error) {
                clearInterval(poll);
                reject(error);
            }
        }, interval);
    });
};

});

parcelRegister("8oFcj", function(module, exports) {

$parcel$export(module.exports, "getJobStatus", () => $61d08596c838f6b6$export$29d2ad33fc8c3498);
$parcel$export(module.exports, "listJobs", () => $61d08596c838f6b6$export$182e6e22b1a3f4b2);
$parcel$export(module.exports, "jobsPollStatus", () => $61d08596c838f6b6$export$6b6288200c88a5bc);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $61d08596c838f6b6$export$a31c5a976244fdb2 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/jobs"]);
const $61d08596c838f6b6$export$29d2ad33fc8c3498 = async (jobId, options = {})=>{
    const response = await $61d08596c838f6b6$export$a31c5a976244fdb2.post("/poll-status", {
        jobId: jobId
    }, options);
    if (!response.ok) throw new Error("Failed to poll job status", {
        cause: response
    });
    return response.data;
};
const $61d08596c838f6b6$export$182e6e22b1a3f4b2 = async (params = {}, options = {})=>{
    const response = await $61d08596c838f6b6$export$a31c5a976244fdb2.post("/list", params ?? {}, options);
    if (!response.ok) throw new Error("Failed to list mogrt jobs", {
        cause: response.data
    });
    return response.data;
};
const $61d08596c838f6b6$export$6b6288200c88a5bc = async ({ jobId: jobId }, interval = 1000, options = {})=>{
    return new Promise((resolve, reject)=>{
        const poll = setInterval(async ()=>{
            try {
                const response = await $61d08596c838f6b6$export$a31c5a976244fdb2.post("/poll-status", {
                    jobId: jobId
                }, options);
                if (!response.ok) {
                    clearInterval(poll);
                    reject(new Error("Failed to poll job status", {
                        cause: response
                    }));
                    return;
                }
                const statusData = response.data;
                if (statusData.status === "completed") {
                    clearInterval(poll);
                    resolve(statusData);
                } else if (statusData.status === "failed") {
                    clearInterval(poll);
                    reject(new Error("Job failed", {
                        cause: statusData
                    }));
                }
            // Continue polling if status is still pending/processing
            } catch (error) {
                clearInterval(poll);
                reject(error);
            }
        }, interval);
    });
};

});

parcelRegister("dFfaH", function(module, exports) {

$parcel$export(module.exports, "initAnalytics", () => (parcelRequire("5uQ6L")).initAnalytics);
$parcel$export(module.exports, "isAlloyReady", () => (parcelRequire("5uQ6L")).isAlloyReady);
$parcel$export(module.exports, "getAlloy", () => (parcelRequire("5uQ6L")).getAlloy);
$parcel$export(module.exports, "trackEvent", () => (parcelRequire("lhjTh")).trackEvent);
$parcel$export(module.exports, "trackVoiceoverEvent", () => (parcelRequire("kvWIh")).trackVoiceoverEvent);
$parcel$export(module.exports, "AnalyticsEventNames", () => (parcelRequire("hpQib")).AnalyticsEventNames);
$parcel$export(module.exports, "AnalyticsVariableNames", () => (parcelRequire("hpQib")).AnalyticsVariableNames);
$parcel$export(module.exports, "eventMap", () => (parcelRequire("hpQib")).eventMap);
$parcel$export(module.exports, "variableMap", () => (parcelRequire("hpQib")).variableMap);

var $5uQ6L = parcelRequire("5uQ6L");

var $lhjTh = parcelRequire("lhjTh");

var $kvWIh = parcelRequire("kvWIh");

var $hpQib = parcelRequire("hpQib");

var $hPT36 = parcelRequire("hPT36");

var $b2ol6 = parcelRequire("b2ol6");

});
parcelRegister("5uQ6L", function(module, exports) {

$parcel$export(module.exports, "initAnalytics", () => $40082caaa2f7f4a7$export$f2a39aaa42ea357a);
$parcel$export(module.exports, "getAlloy", () => $40082caaa2f7f4a7$export$6a74987a1ef14857);
$parcel$export(module.exports, "isAlloyReady", () => $40082caaa2f7f4a7$export$fbcabb5a785bdc13);
/**
 * Adobe Web SDK (Alloy) Types and Initialization
 * 
 * This file handles the initialization of Adobe Alloy SDK
 * and provides the configuration interface.
 */ 
var $b2ol6 = parcelRequire("b2ol6");
async function $40082caaa2f7f4a7$export$f2a39aaa42ea357a(options = {}) {
    const config = {
        datastreamId: options.datastreamId || "394b5bb8-6b88-49ac-a115-5828934cb3ca",
        orgId: options.orgId || "89CC1E5D661E3E5B0A495E79@AdobeOrg",
        debugEnabled: options.debugEnabled ?? false
    };
    if (!config.datastreamId || !config.orgId) {
        console.warn('Analytics not fully configured. Please set REACT_APP_ANALYTICS_DATASTREAM_ID and REACT_APP_ANALYTICS_ORG_ID environment variables.');
        return;
    }
    await (0, $b2ol6.initializeAlloy)(config);
}
function $40082caaa2f7f4a7$export$6a74987a1ef14857() {
    if (typeof window !== 'undefined' && window.alloy) return window.alloy;
    return null;
}
function $40082caaa2f7f4a7$export$fbcabb5a785bdc13() {
    return (0, $b2ol6.isAlloyConfigured)();
}

});
parcelRegister("b2ol6", function(module, exports) {

$parcel$export(module.exports, "initializeAlloy", () => $8092c2ed935a0c43$export$4406624e9f0679fe);
$parcel$export(module.exports, "isAlloyConfigured", () => $8092c2ed935a0c43$export$f44d0c41073004b1);
$parcel$export(module.exports, "alloy", () => $8092c2ed935a0c43$export$1805282cfc13d90b);
/**
 * Alloy Loader
 * 
 * This file handles dynamically loading and initializing the Adobe Alloy SDK.
 * It follows the same pattern as zoltar-demo-pilot's implementation.
 */ const $8092c2ed935a0c43$var$ALLOY_CDN_URL = "https://cdn1.adoberesources.net/alloy/2.27.0/alloy.js";
let $8092c2ed935a0c43$var$isConfigured = false;
let $8092c2ed935a0c43$var$initializationPromise = null;
function $8092c2ed935a0c43$var$initializeAlloyNamespace() {
    const instanceNames = [
        'alloy'
    ];
    instanceNames.forEach((instanceName)=>{
        if (!window[instanceName]) {
            window.__alloyNS = window.__alloyNS || [];
            if (!window.__alloyNS.includes(instanceName)) window.__alloyNS.push(instanceName);
            const alloyFunction = function() {
                const args = arguments;
                return new Promise((resolve, reject)=>{
                    window.setTimeout(()=>{
                        const currentAlloyFn = window[instanceName];
                        if (currentAlloyFn && currentAlloyFn.q) currentAlloyFn.q.push([
                            resolve,
                            reject,
                            args
                        ]);
                    });
                });
            };
            alloyFunction.q = [];
            window[instanceName] = alloyFunction;
        }
    });
}
/**
 * @returns {Promise<void>}
 */ function $8092c2ed935a0c43$var$loadAlloyScript() {
    return new Promise((resolve, reject)=>{
        if (document.querySelector(`script[src*="alloy.js"]`)) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = $8092c2ed935a0c43$var$ALLOY_CDN_URL;
        script.async = true;
        script.onload = ()=>{
            console.log('Alloy script loaded successfully');
            resolve();
        };
        script.onerror = ()=>{
            reject(new Error('Failed to load Alloy library from CDN'));
        };
        document.head.appendChild(script);
    });
}
async function $8092c2ed935a0c43$export$4406624e9f0679fe(config) {
    if (typeof window === 'undefined') {
        console.warn('Alloy cannot be initialized in non-browser environment');
        return;
    }
    if ($8092c2ed935a0c43$var$isConfigured) {
        console.log('Alloy already configured, skipping');
        return;
    }
    if ($8092c2ed935a0c43$var$initializationPromise) {
        console.log('Alloy initialization in progress, waiting...');
        return $8092c2ed935a0c43$var$initializationPromise;
    }
    $8092c2ed935a0c43$var$initializationPromise = (async ()=>{
        try {
            $8092c2ed935a0c43$var$initializeAlloyNamespace();
            await $8092c2ed935a0c43$var$loadAlloyScript();
            if (config && window.alloy && !$8092c2ed935a0c43$var$isConfigured) {
                await window.alloy('configure', {
                    datastreamId: config.datastreamId,
                    orgId: config.orgId,
                    debugEnabled: config.debugEnabled || false
                });
                $8092c2ed935a0c43$var$isConfigured = true;
                console.log('Alloy configured successfully', {
                    datastreamId: config.datastreamId,
                    orgId: config.orgId,
                    debugEnabled: config.debugEnabled
                });
            }
        } catch (error) {
            $8092c2ed935a0c43$var$initializationPromise = null;
            console.error('Failed to initialize Alloy:', error);
            throw error;
        }
    })();
    return $8092c2ed935a0c43$var$initializationPromise;
}
function $8092c2ed935a0c43$export$f44d0c41073004b1() {
    return $8092c2ed935a0c43$var$isConfigured && typeof window !== 'undefined' && typeof window.alloy === 'function';
}
const $8092c2ed935a0c43$export$1805282cfc13d90b = ()=>{
    if (!window.alloy) throw new Error('Alloy not initialized. Call initializeAlloy() first.');
    return window.alloy;
};

});


parcelRegister("lhjTh", function(module, exports) {

$parcel$export(module.exports, "trackEvent", () => $f7da9d5888adb2ac$export$73d0a139caca1fee);

var $hPT36 = parcelRequire("hPT36");

var $5uQ6L = parcelRequire("5uQ6L");
async function $f7da9d5888adb2ac$export$73d0a139caca1fee(eventId, props = {}) {
    if (!(0, $5uQ6L.isAlloyReady)()) {
        console.warn('Analytics not ready. Event not tracked:', eventId);
        return;
    }
    try {
        await (0, $hPT36.hitEvent)(eventId, props);
    } catch (error) {
        console.error('Error tracking event:', eventId, error);
    }
}

});
parcelRegister("hPT36", function(module, exports) {

$parcel$export(module.exports, "hitEvent", () => $cfc1e6b131b7764f$export$45df4eb9e6425f8);

var $b2ol6 = parcelRequire("b2ol6");
async function $cfc1e6b131b7764f$export$45df4eb9e6425f8(eventId, props = {}) {
    try {
        const alloyInstance = (0, $b2ol6.alloy)();
        const xdmPayload = {
            xdm: {
                _experience: {
                    analytics: {
                        event1to100: {
                            [eventId]: {
                                id: eventId,
                                value: 1
                            }
                        },
                        customDimensions: {
                            props: props
                        }
                    }
                }
            }
        };
        await alloyInstance('sendEvent', xdmPayload);
    } catch (error) {
        console.error('Failed to send analytics event:', error);
    }
}

});


parcelRegister("kvWIh", function(module, exports) {

$parcel$export(module.exports, "trackVoiceoverEvent", () => $eef43f1a4eed67ea$export$fae39ad8c6c11448);

var $lhjTh = parcelRequire("lhjTh");

var $5uQ6L = parcelRequire("5uQ6L");

var $hpQib = parcelRequire("hpQib");
const $eef43f1a4eed67ea$var$toString = (value)=>String(value);
const $eef43f1a4eed67ea$export$fae39ad8c6c11448 = (eventName, data = {})=>{
    if (typeof window === 'undefined' || !data?.user?.email) return;
    try {
        if (!(0, $5uQ6L.isAlloyReady)()) return;
        const props = {
            [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).USER_EMAIL]]: $eef43f1a4eed67ea$var$toString(data.user.email),
            [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).TIMESTAMP]]: $eef43f1a4eed67ea$var$toString(new Date().toISOString())
        };
        if (data.videoId) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VIDEO_ID]] = $eef43f1a4eed67ea$var$toString(data.videoId);
        if (data.templateId) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).TEMPLATE_ID]] = $eef43f1a4eed67ea$var$toString(data.templateId);
        if (data.voiceoverTemplate) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VOICEOVER_TEMPLATE]] = $eef43f1a4eed67ea$var$toString(data.voiceoverTemplate);
        (0, $lhjTh.trackEvent)((0, $hpQib.eventMap)[eventName], props);
    } catch (error) {
        console.error('Failed to track voiceover event:', error);
    }
};

});
parcelRegister("hpQib", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventNames", () => $cadd559eb27a30d9$export$90a771d24232f51a);
$parcel$export(module.exports, "AnalyticsVariableNames", () => $cadd559eb27a30d9$export$fe3f251d3c0e47f8);
$parcel$export(module.exports, "eventMap", () => $cadd559eb27a30d9$export$ad0af8749a496627);
$parcel$export(module.exports, "variableMap", () => $cadd559eb27a30d9$export$ccb9f111b1c1aca5);
// Analytics event names
const $cadd559eb27a30d9$export$90a771d24232f51a = {
    // Page events
    PAGE_VIEW: 'page_view',
    HOMEPAGE_OPENED: 'homepage_opened',
    // Video wizard events
    VIDEO_WIZARD_STEP: 'video_wizard_step',
    VIDEO_WIZARD_CONVERSION: 'video_wizard_conversion',
    VIDEO_CREATED: 'video_created',
    VIDEO_OPENED: 'video_opened',
    VIDEO_DELETED: 'video_deleted',
    VIDEO_UPDATED: 'video_updated',
    // Story events
    STORY_CREATED: 'story_created',
    STORY_OPENED: 'story_opened',
    STORY_UPDATED: 'story_updated',
    STORY_DELETED: 'story_deleted',
    // Template events
    TEMPLATE_OPENED: 'template_opened',
    TEMPLATE_USED: 'template_used',
    // Feature usage
    AI_GENERATION: 'ai_generation',
    EXPRESS_SYNC: 'express_sync',
    //Voiceover related event
    VOICEOVER_CHOSEN: 'voiceover_chosen',
    VOICEOVER_FRAGMENT_REGENERATED: 'voiceover_fragment_regereated',
    ENTIRE_AUDIO_PREVIEWED: 'entire_audio_previewed',
    FRAGMENTED_AUDIO_PREVIEWED: 'fragmented_audio_previewed',
    VOICEOVER_PRONUNCIATION_FIXED: 'voiceover_pronunciation_fixed',
    VOICEOVER_RESET: 'voiceover_reset',
    VOICEOVER_FRAGMENT_EDIT: 'voiceover_fragment_edit'
};
const $cadd559eb27a30d9$export$fe3f251d3c0e47f8 = {
    USER_EMAIL: 'user_email',
    TIMESTAMP: 'timestamp',
    PAGE_NAME: 'page_name',
    PAGE_URL: 'page_url',
    REFERRER_URL: 'referrer_url',
    VIDEO_ID: 'video_id',
    VIDEO_NAME: 'video_name',
    VIDEO_PATH: 'video_path',
    VIDEO_STEP: 'video_step',
    EXPRESS_ID: 'express_id',
    CUSTOMER_NAME: 'customer_name',
    CUSTOMER_INDUSTRY: 'customer_industry',
    CUSTOMER_DR_NUMBER: 'customer_dr_number',
    ACCOUNT_NAME: 'account_name',
    STORY_ID: 'story_id',
    TEMPLATE_ID: 'template_id',
    VOICEOVER_TEMPLATE: 'voiceover_template'
};
const $cadd559eb27a30d9$export$ad0af8749a496627 = {
    [$cadd559eb27a30d9$export$90a771d24232f51a.PAGE_VIEW]: 'event4',
    [$cadd559eb27a30d9$export$90a771d24232f51a.HOMEPAGE_OPENED]: 'event9',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VIDEO_WIZARD_STEP]: 'event10',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VIDEO_WIZARD_CONVERSION]: 'event11',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VIDEO_CREATED]: 'event12',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VIDEO_OPENED]: 'event13',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VIDEO_DELETED]: 'event14',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VIDEO_UPDATED]: 'event15',
    [$cadd559eb27a30d9$export$90a771d24232f51a.STORY_CREATED]: 'event16',
    [$cadd559eb27a30d9$export$90a771d24232f51a.STORY_OPENED]: 'event17',
    [$cadd559eb27a30d9$export$90a771d24232f51a.STORY_UPDATED]: 'event18',
    [$cadd559eb27a30d9$export$90a771d24232f51a.STORY_DELETED]: 'event19',
    [$cadd559eb27a30d9$export$90a771d24232f51a.TEMPLATE_OPENED]: 'event20',
    [$cadd559eb27a30d9$export$90a771d24232f51a.TEMPLATE_USED]: 'event21',
    [$cadd559eb27a30d9$export$90a771d24232f51a.AI_GENERATION]: 'event22',
    [$cadd559eb27a30d9$export$90a771d24232f51a.EXPRESS_SYNC]: 'event23',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VOICEOVER_CHOSEN]: 'event24',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VOICEOVER_FRAGMENT_REGENERATED]: 'event25',
    [$cadd559eb27a30d9$export$90a771d24232f51a.ENTIRE_AUDIO_PREVIEWED]: 'event26',
    [$cadd559eb27a30d9$export$90a771d24232f51a.FRAGMENTED_AUDIO_PREVIEWED]: 'event27',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VOICEOVER_PRONUNCIATION_FIXED]: 'event28',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VOICEOVER_RESET]: 'event29',
    [$cadd559eb27a30d9$export$90a771d24232f51a.VOICEOVER_FRAGMENT_EDIT]: 'event30'
};
const $cadd559eb27a30d9$export$ccb9f111b1c1aca5 = {
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.USER_EMAIL]: 'prop6',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.TIMESTAMP]: 'prop7',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.PAGE_NAME]: 'prop8',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.PAGE_URL]: 'prop9',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.REFERRER_URL]: 'prop10',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.VIDEO_ID]: 'prop11',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.VIDEO_NAME]: 'prop12',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.VIDEO_PATH]: 'prop13',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.VIDEO_STEP]: 'prop14',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.EXPRESS_ID]: 'prop15',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.CUSTOMER_NAME]: 'prop16',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.CUSTOMER_INDUSTRY]: 'prop17',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.CUSTOMER_DR_NUMBER]: 'prop18',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.STORY_ID]: 'prop19',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.TEMPLATE_ID]: 'prop20',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.ACCOUNT_NAME]: 'prop21',
    [$cadd559eb27a30d9$export$fe3f251d3c0e47f8.VOICEOVER_TEMPLATE]: 'prop22'
};

});





parcelRegister("CGZx1", function(module, exports) {

$parcel$export(module.exports, "useUpdateAssets", () => $0744e5ee275e1594$export$b16943f833debe59);
$parcel$export(module.exports, "useUploadAssets", () => $0744e5ee275e1594$export$cef27ae2a898d12f);
$parcel$export(module.exports, "useCustomerCheck", () => $0744e5ee275e1594$export$eeac4d7b59d6407f);
$parcel$export(module.exports, "useExportBanners", () => $0744e5ee275e1594$export$69931686cbeda8f3);
$parcel$export(module.exports, "useVideoWizard", () => $0744e5ee275e1594$export$e9ca88b0ace7ecc6);
$parcel$export(module.exports, "hasImageVariationsStep", () => (parcelRequire("lb17q")).hasImageVariationsStep);
$parcel$export(module.exports, "SELECTION_TYPE", () => (parcelRequire("lb17q")).SELECTION_TYPE);

var $eF4cA = parcelRequire("eF4cA");

var $k7O9T = parcelRequire("k7O9T");
var $kQhl7 = parcelRequire("kQhl7");
var $k6waQ = parcelRequire("k6waQ");
var $ittHc = parcelRequire("ittHc");
var $4kcQz = parcelRequire("4kcQz");
var $7ClmI = parcelRequire("7ClmI");

var $kQT4E = parcelRequire("kQT4E");

var $6lZyT = parcelRequire("6lZyT");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fmJ8d = parcelRequire("fmJ8d");

var $9lDhw = parcelRequire("9lDhw");

var $dzLiJ = parcelRequire("dzLiJ");
parcelRequire("dFfaH");
var $5uQ6L = parcelRequire("5uQ6L");

var $dSkgb = parcelRequire("dSkgb");

var $ikOQe = parcelRequire("ikOQe");

var $fK5Xl = parcelRequire("fK5Xl");

var $iMKxE = parcelRequire("iMKxE");

var $5nqV3 = parcelRequire("5nqV3");

var $6yR6I = parcelRequire("6yR6I");

var $4MHdR = parcelRequire("4MHdR");

var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");

var $fL0wx = parcelRequire("fL0wx");

var $a8sj2 = parcelRequire("a8sj2");

var $dyJFE = parcelRequire("dyJFE");

var $HE3sn = parcelRequire("HE3sn");

var $dXYND = parcelRequire("dXYND");

var $lRNYL = parcelRequire("lRNYL");

var $awCmJ = parcelRequire("awCmJ");

var $lb17q = parcelRequire("lb17q");
const $0744e5ee275e1594$var$EXPRESS_TAG_BATCH_SIZE = 50;
const $0744e5ee275e1594$export$39027ab9e2e75266 = [
    "Integrating brand elements",
    "Embedding banners",
    "Placing text elements",
    "Applying smooth transitions",
    "Adjusting animations",
    // "Preparing editable Express file",
    "Cropping & balancing images"
];
const $0744e5ee275e1594$export$77d77635add139a8 = (campaignSelectionType)=>(data)=>{
        if (campaignSelectionType === (0, $lb17q.SELECTION_TYPE).SINGLE) {
            data.campaigns = (data?.campaigns ?? []).map((campaign)=>({
                    ...campaign,
                    id: crypto.randomUUID()
                }));
            return data;
        } else if (campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE) {
            const ret = {
                campaigns: [
                    {
                        id: crypto.randomUUID(),
                        ...data
                    }
                ]
            };
            if (data?.["Brand-color"]) ret.customer = {
                ...ret.customer ?? {},
                color: (0, $kQT4E.parseColor)(data["Brand-color"]).toString("hex")
            };
            if (data?.["Secondary-color"]) ret.customer = {
                ...ret.customer ?? {},
                secondaryColor: (0, $kQT4E.parseColor)(data["Secondary-color"]).toString("hex")
            };
            if (data?.["Company-website-URL"]) ret.customer = {
                ...ret.customer ?? {},
                websiteURL: data["Company-website-URL"]
            };
            return ret;
        }
        return data;
    };
const $0744e5ee275e1594$var$useUpdateCustomer = (videoId)=>{
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ customer: customer }, { client: client })=>{
            const oldData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            if (!!customer?.color?.alpha) customer.color = customer.color.toString("hex");
            return updateVideo.mutateAsync({
                customer: {
                    ...oldData?.customer ?? {},
                    ...customer
                }
            });
        }
    });
};
const $0744e5ee275e1594$var$_getAllAssets = (videoId, client, assets = [])=>{
    const oldData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
    const oldAssets = oldData?.assets ?? [];
    const byName = new Map();
    for (const asset of oldAssets)if (!asset.isLoading) byName.set(asset.name, asset);
    for (const incoming of assets){
        const { src: src, presignURL: presignURL, blob: blob, skipClientPrepare: skipClientPrepare, ...rest } = incoming;
        const existing = byName.get(rest.name);
        const merged = existing ? {
            ...existing,
            ...rest
        } : {
            ...rest
        };
        if (rest.parts != null) merged.parts = {
            ...rest.parts
        };
        byName.set(rest.name, merged);
    }
    return Array.from(byName.values());
};
const $0744e5ee275e1594$var$assetsWrites = new Map();
const $0744e5ee275e1594$var$queueAssetsWrite = (videoId, write)=>{
    if (!videoId) return Promise.resolve().then(write);
    const previous = $0744e5ee275e1594$var$assetsWrites.get(videoId) ?? Promise.resolve();
    const next = previous.then(write, write);
    const settled = next.catch(()=>{});
    $0744e5ee275e1594$var$assetsWrites.set(videoId, settled);
    settled.then(()=>{
        if ($0744e5ee275e1594$var$assetsWrites.get(videoId) === settled) $0744e5ee275e1594$var$assetsWrites.delete(videoId);
    });
    return next;
};
const $0744e5ee275e1594$export$b16943f833debe59 = (videoId)=>{
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ assets: assets = [], toRemove: toRemove = [] }, { client: client } = {})=>$0744e5ee275e1594$var$queueAssetsWrite(videoId, ()=>{
                const _allAssets = $0744e5ee275e1594$var$_getAllAssets(videoId, client, assets);
                const shouldFilterByName = toRemove.some((asset)=>!!asset.name);
                const shouldFilterByFilePath = toRemove.some((asset)=>!!asset.filePath);
                const filteredAssets = _allAssets.filter((asset)=>(!shouldFilterByName || !toRemove.some((a)=>!!a.name && a.name === asset.name)) && (!shouldFilterByFilePath || !toRemove.some((a)=>!!a.filePath && a.filePath === asset.filePath)));
                return updateVideo.mutateAsync({
                    assets: filteredAssets
                });
            })
    });
};
const $0744e5ee275e1594$export$cef27ae2a898d12f = (videoId, options = {})=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const updateAssets = $0744e5ee275e1594$export$b16943f833debe59(videoId);
    const uploadFile = (0, $a8sj2.useUploadFile)();
    const { onSuccess: userOnSuccess, ...restOptions } = options;
    return (0, $k6waQ.useMutation)({
        mutationFn: async ({ assets: assets = [], fileName: fileName }, { client: client } = {})=>{
            const skippedImages = [];
            const uploadPromises = assets.map(async (asset)=>{
                const preparedAsset = {
                    ...asset
                };
                if (!asset.filePath && !asset.skipClientPrepare && (asset.type === "image" || !asset.type)) try {
                    let blob = asset.blob;
                    if (!blob && asset.src) ({ blob: blob } = await (0, $9lDhw.getImageBlob)({
                        url: asset.src
                    }));
                    const isSvg = blob?.type === "image/svg+xml";
                    const needsJpegConversion = !isSvg && ![
                        "image/jpeg",
                        "image/png"
                    ].includes(blob?.type);
                    if (isSvg) blob = await (0, $6lZyT.convertImageBlobToType)(blob, "png");
                    const dimensions = await (0, $6lZyT.getImageBlobDimensions)(blob);
                    const resizedBlob = await (0, $6lZyT.resizeImageBlob)(blob, dimensions);
                    preparedAsset.blob = needsJpegConversion ? await (0, $6lZyT.convertImageBlobToType)(resizedBlob, "jpeg") : resizedBlob;
                    preparedAsset.size = preparedAsset.blob === blob ? dimensions : await (0, $6lZyT.getImageBlobDimensions)(preparedAsset.blob);
                } catch (error) {
                    console.warn(`Skipping image "${asset.name}": preparation failed`, error);
                    skippedImages.push(asset.name);
                    return null;
                }
                if (preparedAsset.filePath) {
                    if (preparedAsset.presignURL && client && (0, $a8sj2.s3Key)?.presignURL) client.setQueryData((0, $a8sj2.s3Key).presignURL(preparedAsset.filePath), {
                        filePath: preparedAsset.filePath,
                        presignURL: preparedAsset.presignURL
                    });
                    const { src: src, blob: blob, presignURL: presignURL, skipClientPrepare: skipClientPrepare, ...uploadedAsset } = preparedAsset;
                    return uploadedAsset;
                }
                let fileExtension;
                if (preparedAsset.blob) fileExtension = preparedAsset.blob.type.split("/")[1];
                else {
                    const defaultExtension = asset.type === "video" ? "mp4" : asset.type === "audio" ? "wav" : "jpg";
                    fileExtension = (0, $8Ogg5.getExtensionFromFilePath)(asset.src, defaultExtension);
                }
                const dotIndex = asset.name.lastIndexOf(".");
                const baseName = dotIndex === -1 ? asset.name : asset.name.slice(0, dotIndex);
                const { filePath: filePath } = await uploadFile.mutateAsync({
                    filePath: `${video.data.projectPath}/${baseName}.${fileExtension}`,
                    fileURL: preparedAsset.blob ? undefined : asset.src,
                    fileBlob: preparedAsset.blob
                });
                const { src: src, blob: blob, presignURL: presignURL, skipClientPrepare: skipClientPrepare, ...uploadedAsset } = preparedAsset;
                return {
                    ...uploadedAsset,
                    filePath: filePath
                };
            });
            const uploadedAssets = (await Promise.all(uploadPromises)).filter((asset)=>asset !== null);
            if (assets.length > 0 && uploadedAssets.length === 0) throw new Error(`No assets could be prepared: ${skippedImages.join(", ")}`);
            if (skippedImages.length > 0) (0, $fmJ8d.store).getState().addToast(`Skipped images that could not be prepared: ${skippedImages.join(", ")}`, {
                variant: "negative",
                timeout: 60000
            });
            const allAssets = [
                ...uploadedAssets
            ];
            // Reference the uploaded asset with a specific fileName
            if (typeof fileName === "string" && assets.length === 1 && uploadedAssets.length === 1) {
                const uploadedAsset = uploadedAssets[0];
                allAssets.push({
                    ...uploadedAsset,
                    name: fileName,
                    referenceKey: uploadedAsset.name
                });
            }
            return updateAssets.mutateAsync({
                assets: allAssets
            });
        },
        ...restOptions,
        onSuccess: (data, variables, onMutateResult, context)=>{
            const { client: client } = context;
            if (data) client.setQueryData((0, $ikOQe.videoKey).detail(videoId), data);
            userOnSuccess?.(data, variables, onMutateResult, context);
        },
        onMutate: (variables, context)=>{
            const { assets: assets = [], fileName: fileName } = variables;
            const { client: client } = context;
            const oldData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const newAssets = [
                ...assets
            ];
            if (typeof fileName === "string" && newAssets.length === 1) newAssets.push({
                ...newAssets[0],
                name: fileName
            });
            client.setQueryData((0, $ikOQe.videoKey).detail(videoId), {
                ...oldData,
                assets: $0744e5ee275e1594$var$_getAllAssets(videoId, client, newAssets.map((asset)=>({
                        ...asset,
                        ...!!asset?.blob ? {
                            src: URL.createObjectURL(asset.blob)
                        } : {},
                        isDisabled: true,
                        isLoading: true
                    })))
            });
            restOptions?.onMutate?.(variables, context);
            return {
                oldData: oldData
            };
        },
        onError: (err, variables, onMutateResult, context)=>{
            const { oldData: oldData } = onMutateResult;
            const { client: client } = context;
            client.setQueryData((0, $ikOQe.videoKey).detail(videoId), oldData);
            restOptions?.onError?.(err, variables, onMutateResult, context);
        },
        meta: {
            errorMessage: "Failed to upload assets. Please try again."
        }
    });
};
const $0744e5ee275e1594$export$eeac4d7b59d6407f = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async ({ customerName: customerName, hint: hint }, { signal: signal })=>{
            const response = await (0, $4SSyx.getZoltarResponse)({
                promptTemplate: [
                    {
                        role: "user",
                        prompt_template: `[Company]: ${customerName}${hint ? `\n[Hints]: ${hint}` : ""}`
                    }
                ],
                systemPromptId: "common-customer-check",
                skills: [
                    "vertex-ai"
                ]
            }, {
                signal: signal
            });
            const data = (0, $aKSBi.parseZoltarGenerateAssistantJson)(response, "Failed to validate customer");
            if (!data?.exists) throw new Error(`We couldn\u{2019}t find this company (${data?.["Company-name"]}) online. Please check the name and try again.`);
            return data;
        },
        onSuccess: async (data, variables, onMutateResult, context)=>{
            if (options?.onSuccess) await Promise.resolve(options.onSuccess(data, variables, onMutateResult, context));
        },
        ...options
    });
};
const $0744e5ee275e1594$var$useCustomerBranding = ({ customerName: customerName, hint: hint, product: product, personaType: personaType, include3DDigitalTwin: include3DDigitalTwin, videoId: videoId }, options = {})=>{
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    const video = (0, $ikOQe.useVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const updateAssets = $0744e5ee275e1594$export$b16943f833debe59(videoId);
    const isVideoUpdating = (0, $kQhl7.useIsMutating)({
        mutationKey: (0, $ikOQe.videoKey).detail(videoId)
    }) > 0;
    const templateId = video.data?.templateId;
    const { enabled: enabledOption, ...mutationOptions } = options;
    const isEnabled = (enabledOption ?? true) && !!customerName && !!video.isSuccess && !video.data?.campaigns?.length;
    const branding = (0, $4SSyx.useZoltarMutation)({
        ...mutationOptions,
        onSuccess: async (data, variables, onMutateResult, context)=>{
            if (mutationOptions?.onSuccess) await Promise.resolve(mutationOptions.onSuccess(data, variables, onMutateResult, context));
            const videoData = context.client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const existingData = {
                customer: videoData?.customer ?? {},
                campaigns: videoData?.campaigns ?? []
            };
            const fetchData = data?.campaigns ? data : {
                customer: {},
                campaigns: [
                    data
                ]
            };
            const update = {};
            if (videoData?.templateId === "firefly-enterprise") {
                const selectedInclude3DDigitalTwin = videoData?.include3DDigitalTwin ?? videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0])?.["Include-3D-Digital-Twin"] ?? include3DDigitalTwin;
                fetchData.campaigns = fetchData.campaigns.map((campaign)=>({
                        ...campaign,
                        "Include-3D-Digital-Twin": selectedInclude3DDigitalTwin
                    }));
            }
            const combinedCampaigns = Array.from(new Map([
                ...existingData.campaigns,
                ...fetchData?.campaigns ?? []
            ].map((campaign)=>[
                    campaign.id,
                    campaign
                ])).values()).slice(-10);
            if (combinedCampaigns.length > existingData.campaigns.length) {
                update.campaigns = combinedCampaigns;
                if (template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE) update.selectedCampaignIds = [
                    combinedCampaigns[combinedCampaigns.length - 1].id
                ];
            }
            if (Object.keys(fetchData?.customer ?? {}).length > Object.keys(existingData.customer ?? {}).length) update.customer = {
                ...fetchData.customer,
                name: customerName
            };
            const assetsUpdate = new Map();
            if (fetchData.customer?.color && !videoData?.assets?.some((asset)=>asset.name === "Brand-color")) assetsUpdate.set("Brand-color", {
                name: "Brand-color",
                type: "color",
                color: fetchData.customer?.color
            });
            if (fetchData.customer?.secondaryColor && !videoData?.assets?.some((asset)=>asset.name === "Secondary-color")) assetsUpdate.set("Secondary-color", {
                name: "Secondary-color",
                type: "color",
                color: fetchData.customer?.secondaryColor
            });
            if (template.data?.assets.some((templateAsset)=>templateAsset.type === "color" && !assetsUpdate.has(templateAsset.name) && !videoData?.assets?.some((asset)=>asset.name === templateAsset.name))) {
                const newColorAssets = template.data.assets.filter((templateAsset)=>templateAsset.type === "color" && !assetsUpdate.has(templateAsset.name) && !videoData?.assets?.some((asset)=>asset.name === templateAsset.name)).map((asset)=>({
                        name: asset.name,
                        type: asset.type,
                        color: fetchData.campaigns?.[0]?.[asset.name] ?? videoData?.customer?.[asset.name] ?? ""
                    })).filter((asset)=>!!asset.color);
                if (newColorAssets.length) newColorAssets.forEach((asset)=>{
                    assetsUpdate.set(asset.name, asset);
                });
            }
            const updatePromises = [];
            if (Object.keys(update).length) updatePromises.push(updateVideo.mutateAsync(update));
            if (assetsUpdate.size) updatePromises.push(updateAssets.mutateAsync({
                assets: Array.from(assetsUpdate.values())
            }));
            return await Promise.all(updatePromises);
        }
    }, (response, context)=>{
        const { client: client } = context;
        const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        let campaignSelectionType = template.data?.campaignSelectionType ?? (0, $lb17q.SELECTION_TYPE).NONE;
        // FIXME: template.data is still fetching, we need to pass `campaignSelectionType`
        // as a parameter to the `refetch` function instead of relying on `template.data`.
        if (videoData?.templateId === "csc-overview") campaignSelectionType = (0, $lb17q.SELECTION_TYPE).SINGLE;
        return $0744e5ee275e1594$export$77d77635add139a8(campaignSelectionType)((0, $aKSBi.parseZoltarGenerateAssistantJson)(response, "Failed to generate content"));
    });
    // // Trigger branding generation once the conditions are met.
    // // Replaces the auto-running `enabled` option of the previous infiniteQuery.
    // useEffect(() => {
    //   if (
    //     isEnabled &&
    //     branding.isIdle &&
    //     (template.isSuccess || !template.isEnabled)
    //   ) {
    //     branding.mutate(mutateOptions);
    //   }
    // }, [isEnabled, branding.isIdle, template.isSuccess, template.isEnabled]);
    // Preserve the query-like surface consumed by the wizard views:
    // `isEnabled`/`isPending` gate the loading UI and `refetch` retries on error.
    branding.isEnabled = isEnabled;
    // branding.isPending =
    //   branding.isPending ||
    //   (isEnabled && !branding.isSuccess && !branding.isError);
    branding.getPromptTemplate = (videoData)=>(0, $dXYND.getCustomerBrandingPromptTemplate)({
            customerName: videoData?.customer?.name ?? customerName,
            hint: videoData?.hint ?? hint,
            editScope: videoData?.editScope,
            product: videoData?.product ?? product,
            personaType: videoData?.personaType ?? personaType,
            templateId: videoData?.templateId ?? templateId
        });
    const getRefetchVariables = (videoData, getPromptTemplate)=>{
        const selectedCampaign = template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE ? videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0]) : videoData?.campaigns;
        const promptParams = {
            customerName: videoData?.customer?.name ?? customerName,
            hint: videoData?.hint ?? hint,
            editScope: videoData?.editScope,
            product: videoData?.product ?? product,
            personaType: videoData?.personaType ?? personaType,
            templateId: videoData?.templateId ?? templateId
        };
        const promptTemplate = (0, $dXYND.getCustomerBrandingPromptTemplate)(promptParams);
        if (selectedCampaign) promptTemplate.template = promptTemplate.template.toSpliced(0, 0, {
            role: "user",
            prompt_template: `[Current data]:
${JSON.stringify(selectedCampaign)}`
        });
        return {
            model: videoData?.templateId === "csc-overview" ? "gpt-5.6-luna" : "gpt-5.6-sol",
            promptTemplate: getPromptTemplate ? getPromptTemplate(videoData, promptTemplate.template) : promptTemplate.template,
            systemPromptId: promptTemplate.systemPromptId,
            promptOverrideKey: isAdmin ? `customTemplate__${promptParams.templateId}` : undefined,
            threadId: selectedCampaign?.thread_id,
            // FIXME: 400 An assistant message with 'tool_calls' must be followed by tool messages responding to each 'tool_call_id'
            skills: videoData?.templateId === "csc-overview" ? undefined : [
                "vertex-ai"
            ]
        };
    };
    branding.refetch = (videoData, getPromptTemplate, options = {})=>{
        branding.mutate(getRefetchVariables(videoData, getPromptTemplate), options);
    };
    // Same as `refetch`, but resolves once the generated campaign has been
    // persisted — and rejects on failure — so a caller can await it.
    branding.refetchAsync = (videoData, getPromptTemplate, options = {})=>branding.mutateAsync(getRefetchVariables(videoData, getPromptTemplate), options);
    return branding;
};
const $0744e5ee275e1594$var$useAddCampaign = (videoId, options = {})=>{
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    return (0, $k6waQ.useMutation)({
        mutationFn: (variables, { client: client })=>{
            const oldData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            updateVideo.mutate({
                campaigns: [
                    ...oldData.campaigns ?? [],
                    {
                        ...variables,
                        id: crypto.randomUUID()
                    }
                ]
            });
        },
        ...options
    });
};
const $0744e5ee275e1594$export$dd91b85198001c8a = (videoId, options = {})=>{
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    return (0, $k6waQ.useMutation)({
        mutationFn: (variables, { client: client })=>{
            const oldData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            return updateVideo.mutateAsync({
                campaigns: oldData.campaigns.map((item)=>item.id === variables.id ? {
                        ...item,
                        ...variables
                    } : item)
            });
        },
        ...options
    });
};
const $0744e5ee275e1594$export$69931686cbeda8f3 = (videoId, options = {})=>{
    const exportRendition = (0, $fK5Xl.useExportRendition)();
    return (0, $4kcQz.useQuery)({
        queryKey: (0, $fK5Xl.expressTemplateKey).export(videoId, "image/jpeg"),
        queryFn: async (context)=>{
            const { client: client } = context;
            const { templateAssetsRenditions: templateAssetsRenditions = [] } = client.getQueryData((0, $ikOQe.videoKey).detail(videoId)) ?? {};
            const data = await Promise.all(templateAssetsRenditions.map(({ documentId: documentId })=>exportRendition.mutateAsync({
                    id: documentId,
                    pages: "1-",
                    options: {
                        format: "image/jpeg"
                    }
                })));
            const ret = data.flatMap((rendition)=>rendition.pageRenditionsResult.map((page)=>({
                        id: rendition.id,
                        ...page
                    })));
            if (ret.some((item)=>item.error)) console.warn("Some renditions failed to export:", data);
            return ret;
        },
        enabled: !!videoId && (options?.enabled ?? true),
        ...options
    });
};
const $0744e5ee275e1594$export$b9c3fc48de1fbbd2 = (videoId, options = {})=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const exportRendition = (0, $fK5Xl.useExportRendition)();
    const uploadFile = (0, $a8sj2.useUploadFile)();
    const videoFile = (0, $a8sj2.usePresignURL)(video.data?.videoPath);
    return (0, $k6waQ.useMutation)({
        // queryKey: expressTemplateKey.export(video.data?.expressId, "video/mp4"),
        mutationFn: async (_, options = {})=>{
            if (video.data?.videoPath) {
                while(videoFile.isLoading)await new Promise((resolve)=>setTimeout(resolve, 100));
                return videoFile.data;
            }
            let exportData = exportRendition.data?.pageRenditionsResult?.[0]?.renditionUrl;
            if (!exportData) exportData = await exportRendition.mutateAsync({
                id: video.data?.expressId,
                pages: "1-",
                options: {
                    format: "video/mp4"
                }
            }, options);
            const ret = await uploadFile.mutateAsync({
                fileURL: exportData.pageRenditionsResult?.[0]?.renditionUrl,
                filePath: `${video.data.projectPath}/${video.data.name}.mp4`
            });
            updateVideo.mutate({
                videoPath: ret.filePath
            });
            return ret;
        },
        ...options,
        enabled: !!videoId && video.isSuccess && !!video.data?.expressId && (options?.enabled ?? true)
    });
};
const $0744e5ee275e1594$export$b931cca02b68e364 = ({ videoId: videoId, templateId: templateId }, options = {})=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId ?? templateId);
    const personaAvatars = (0, $a8sj2.usePresignURL)(template.data?.personas?.map((persona)=>persona.avatarPath), {
        enabled: !!template.data?.personas?.length
    });
    const personas = template.data?.personas?.map((persona, idx)=>({
            ...persona,
            avatarUrl: personaAvatars.data?.urls?.[idx]?.presignURL
        })) ?? [];
    const [_selectedPersonaKey, setSelectedPersonaKey] = (0, $eF4cA.useState)();
    const selectedPersonaKey = _selectedPersonaKey ?? (video.isEnabled ? video.data?.personaId : undefined) ?? personas?.[0]?.id;
    const selectedPersona = personas?.find((persona)=>persona.id === selectedPersonaKey);
    const setSelectedPersona = (personaKey)=>{
        setSelectedPersonaKey(personaKey);
        if (video.isEnabled) {
            const update = {
                personaId: personaKey
            };
            if (!!video.data?.personaId && personaKey !== video.data?.personaId) {
                // Trigger campaign regeneration
                // TODO: should we trigger confirmation modal if persona is changed after campaign focus step?
                update.customer = {
                    name: video.data?.customer?.name
                };
                // update.assets = [];
                update.campaigns = [];
                update.selectedCampaignIds = [];
            }
            updateVideo.mutate(update);
        }
    };
    return {
        personas: personas,
        selectedPersona: selectedPersona,
        setSelectedPersona: setSelectedPersona
    };
};
const $0744e5ee275e1594$export$5b048322ab5718f5 = ({ videoId: videoId, templateId: templateId }, options = {})=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const updateAssets = $0744e5ee275e1594$export$b16943f833debe59(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId ?? templateId);
    const verticals = template.data?.verticals ?? [];
    const [_selectedKey, setSelectedKey] = (0, $eF4cA.useState)();
    const selectedKey = _selectedKey ?? (video.isEnabled ? video.data?.verticalKey : undefined) ?? template.data?.verticals?.find((vertical)=>vertical.isDefault)?.key ?? "generic";
    const selectedVertical = verticals?.find((vertical)=>vertical.key === selectedKey);
    const setSelectedVertical = (verticalKey)=>{
        setSelectedKey(verticalKey);
        if (video.isEnabled && !!video.data?.verticalKey && verticalKey !== video.data?.verticalKey) updateVideo.mutate({
            verticalKey: verticalKey
        }, {
            onSuccess: (data)=>{
                const templateVerticalAssets = verticals?.find((vertical)=>vertical.key === data.verticalKey)?.assets;
                const verticalAssets = templateVerticalAssets?.length ? {
                    assets: templateVerticalAssets
                } : {
                    toRemove: [
                        {
                            name: "Footage-Industry--A"
                        },
                        {
                            name: "Footage-Industry--B"
                        }
                    ]
                };
                updateAssets.mutate(verticalAssets);
            }
        });
    };
    return {
        verticals: verticals,
        selectedVertical: selectedVertical,
        setSelectedVertical: setSelectedVertical
    };
};
const $0744e5ee275e1594$export$875839b71582f701 = (templateData, selectedCampaign = {})=>{
    const variant = (templateData?.mogrtVariants ?? []).find((entry)=>{
        if (!entry?.rootPath) return false;
        if (!entry?.condition) return true;
        try {
            return !!new Function("selectedCampaign", `return (${entry.condition});`)(selectedCampaign);
        } catch (error) {
            console.warn("Failed to evaluate mogrt condition:", entry, error);
            return false;
        }
    });
    return variant?.rootPath ?? templateData?.rootPath;
};
const $0744e5ee275e1594$export$e9ca88b0ace7ecc6 = ({ videoId: videoId, routeStep: routeStep, customerName: customerName, hint: hint, product: product, include3DDigitalTwin: initialInclude3DDigitalTwin, templateType: templateType, templateId: templateId, sfType: sfType, drNumbersFilter: drNumbersFilter, drNumber: drNumber, accountName: accountName, demoPilotProjectId: demoPilotProjectId, onCreateProject: onCreateProject, onSuccess: onSuccess })=>{
    const userProfile = (0, $fL0wx.useUserProfile)();
    const [isVideoCreated, setIsVideoCreated] = (0, $eF4cA.useState)(!!videoId);
    const createVideo = (0, $ikOQe.useCreateVideo)();
    const video = (0, $ikOQe.useVideo)(videoId, {
        enabled: !!videoId && isVideoCreated,
        refetchInterval: (query)=>{
            const data = query.state.data;
            return data?.templateType === "modular" && data?.modularJobs?.length && !data?.videoPath ? 10000 : false;
        }
    });
    const [_currentStep, _setCurrentStep] = (0, $eF4cA.useState)();
    // Only honour a persisted step if it's a string id (the new format). Legacy
    // numeric values are ignored so the bootstrap below recomputes a valid step.
    const persistedStep = typeof video.data?.currentStep === "string" ? video.data.currentStep : null;
    // When the URL carries a step (`/projects/new/:id/:step`), it drives the initial
    // step (validated in the bootstrap effect) and takes priority over the
    // persisted step; otherwise fall back to the persisted step.
    const currentStep = _currentStep ?? (routeStep ? null : persistedStep) ?? null;
    const setCurrentStep = (step)=>{
        _setCurrentStep(step);
        if (video.isEnabled && video.data?.currentStep !== step) updateVideo.mutate({
            currentStep: step
        });
    };
    const queryClient = (0, $7ClmI.useQueryClient)();
    (0, $eF4cA.useEffect)(()=>{
        // Clear query cache
        if (!videoId && Object.keys(video.data || {}).length > 0) queryClient.setQueryData((0, $ikOQe.videoKey).detail(videoId), null);
    }, [
        videoId,
        video.data
    ]);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const updateCustomer = $0744e5ee275e1594$var$useUpdateCustomer(videoId);
    const updateAssets = $0744e5ee275e1594$export$b16943f833debe59(videoId);
    const uploadAssets = $0744e5ee275e1594$export$cef27ae2a898d12f(videoId);
    const uploadFile = (0, $a8sj2.useUploadFile)();
    const [_include3DDigitalTwin, _setInclude3DDigitalTwin] = (0, $eF4cA.useState)();
    const include3DDigitalTwin = _include3DDigitalTwin ?? (video.isEnabled ? video.data?.include3DDigitalTwin : undefined) ?? video.data?.campaigns?.find((campaign)=>campaign.id === video.data?.selectedCampaignIds?.[0])?.["Include-3D-Digital-Twin"] ?? video.data?.campaigns?.[0]?.["Include-3D-Digital-Twin"] ?? initialInclude3DDigitalTwin ?? true;
    const setInclude3DDigitalTwin = (value)=>{
        const previousValue = _include3DDigitalTwin;
        _setInclude3DDigitalTwin(value);
        if (video.isEnabled && video.data?.id) updateVideo.mutate({
            include3DDigitalTwin: value,
            ...video.data?.campaigns?.length ? {
                campaigns: video.data.campaigns.map((campaign)=>({
                        ...campaign,
                        "Include-3D-Digital-Twin": value
                    }))
            } : {}
        }, {
            onError: ()=>_setInclude3DDigitalTwin(previousValue)
        });
    };
    const templates = (0, $ikOQe.useVideoTemplates)({
        type: templateType
    });
    const template = (0, $ikOQe.useVideoTemplate)(templateId ?? video.data?.templateId);
    // The current step's configuration — its `type`, not its id, tells e.g. an
    // images stage step apart, which the step-order gates below depend on.
    const currentStepEntry = (0, $eF4cA.useMemo)(()=>(0, $lb17q.resolveSteps)(templateId ?? template.data?.id, template.data).find((step)=>step.id === currentStep) ?? currentStep, [
        templateId,
        template.data,
        currentStep
    ]);
    // const hasAudioStep = template.data?.assets?.some(
    //   (asset) => asset.type === "audio",
    // );
    const { personas: personas, selectedPersona: selectedPersona, setSelectedPersona: setSelectedPersona } = $0744e5ee275e1594$export$b931cca02b68e364({
        videoId: videoId,
        templateId: templateId
    });
    const personaId = selectedPersona?.id;
    const personaType = selectedPersona?.type;
    const { verticals: verticals, selectedVertical: selectedVertical, setSelectedVertical: setSelectedVertical } = $0744e5ee275e1594$export$5b048322ab5718f5({
        videoId: videoId,
        templateId: templateId
    });
    const verticalKey = selectedVertical?.key;
    const expressTemplate = (0, $fK5Xl.useExpressTemplate)(video.data?.expressTemplateId ?? template.data?.expressId, {
        enabled: !!(video.data?.expressTemplateId ?? template.data?.expressId) && template.data?.type === "express"
    });
    const assetsTemplate = (0, $fK5Xl.useExpressTemplate)(video.data?.assetsTemplateId ?? template.data?.assetsTemplateId);
    // Migrate old templateId field to the new expressTemplateId
    (0, $eF4cA.useEffect)(()=>{
        // TODO: remove after full migration
        //
        if (video.isEnabled && video.isSuccess && template.isSuccess && !updateVideo.isPending && video.data?.templateId?.startsWith("urn:")) updateVideo.mutate({
            templateId: template.data?.id,
            templateType: template.data?.type,
            expressTemplateId: video.data?.templateId
        });
    }, [
        video.isEnabled,
        video.isSuccess,
        video.data?.templateId,
        template.isSuccess,
        template.data?.id,
        template.data?.type,
        updateVideo.isPending
    ]);
    // Migrate old image variations structure to the new one
    (0, $eF4cA.useEffect)(()=>{
        // TODO: remove after full migration
        if (video.isEnabled && video.isSuccess && !updateVideo.isPending) {
            if (!video.data?.imageVariations || !Array.isArray(video.data.imageVariations)) {
                const imageVariations = [];
                Object.entries(video.data?.abstractVariations || {}).forEach(([key, arr])=>{
                    arr.forEach((variation)=>{
                        imageVariations.push({
                            referenceKey: key,
                            type: "abstract",
                            ...variation
                        });
                    });
                });
                Object.entries(video.data?.audiencesVariations || {}).forEach(([key, arr])=>{
                    if (!Array.isArray(arr)) return;
                    arr.forEach((variation)=>{
                        imageVariations.push({
                            referenceKey: key,
                            type: "audience",
                            ...variation
                        });
                    });
                });
                updateVideo.mutate({
                    imageVariations: imageVariations,
                    abstractVariations: null,
                    audiencesVariations: null
                });
            }
        }
    }, [
        video.isEnabled,
        video.isSuccess,
        video.data,
        updateVideo.isPending
    ]);
    const drNumbers = (0, $4MHdR.useDrNumbers)(drNumbersFilter, {
        enabled: sfType === "drNumber" && !!drNumbersFilter && drNumbersFilter.length >= 3
    });
    const accounts = (0, $4MHdR.useAccounts)(accountName, {
        enabled: sfType === "accountName" && !!accountName && accountName.length >= 3
    });
    // Generate customer branding info
    const customerBranding = $0744e5ee275e1594$var$useCustomerBranding({
        customerName: video.data?.customer?.name ?? customerName,
        hint: hint,
        product: product,
        personaType: personaType,
        include3DDigitalTwin: include3DDigitalTwin,
        videoId: videoId
    });
    const addCampaign = $0744e5ee275e1594$var$useAddCampaign(videoId);
    const editCampaign = $0744e5ee275e1594$export$dd91b85198001c8a(videoId);
    // const demoPilotProjects = useDemoPilotProjects();
    // const demoPilotProject = useDemoPilotProject(demoPilotProjectId);
    // const createDemoPilotProject = useCreateDemoPilotProject();
    const selectedCampaign = (0, $eF4cA.useMemo)(()=>{
        return video.data?.campaigns?.find((c)=>c.id === video.data?.selectedCampaignIds?.[0]);
    }, [
        video.data?.campaigns,
        video.data?.selectedCampaignIds
    ]);
    // Set `data.urls[]`
    (0, $eF4cA.useEffect)(()=>{
        if (!video.data?.id) return;
        const urlsMap = new Map();
        video.data?.selectedCampaignIds?.map((id)=>video.data?.campaigns?.find((campaign)=>campaign.id === id))?.filter(Boolean)?.forEach((item)=>{
            // if (item.landingPageURL) {
            //   urlsMap.set(item.landingPageURL, `Campaign: ${item.title}`);
            // }
            if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, item["Campaign-product-URL"])) urlsMap.set(item["Campaign-product-URL"], `Primary offer: ${item["Campaign-product"]}`);
            if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, item["NBA-campaign-product-URL"])) urlsMap.set(item["NBA-campaign-product-URL"], `Next best offer: ${item["NBA-campaign-product"]}`);
            if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, item["Persona-2-campaign-product-URL"])) urlsMap.set(item["Persona-2-campaign-product-URL"], `Secondary persona offer: ${item["Persona-2-campaign-product"]}`);
            Object.entries(item).filter(([, value])=>value?.startsWith?.("http")).forEach(([key, value])=>{
                if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, value)) {
                    const prefixKey = key.replace(/-URL$/i, "").trim();
                    urlsMap.set(value, item[prefixKey] ?? prefixKey.replace("-", " "));
                }
            });
        });
        if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, video.data?.customer?.websiteURL)) urlsMap.set(video.data?.customer?.websiteURL, "Customer Website");
        if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, video.data?.customer?.brandCenterURL)) urlsMap.set(video.data?.customer?.brandCenterURL, "Brand Guidelines");
        video.data?.urls?.forEach((_url)=>{
            const [url, label = ""] = Array.isArray(_url) ? _url : [
                _url
            ];
            if ((0, $8Ogg5.shouldAddMapUrl)(urlsMap, url)) urlsMap.set(url, label);
        });
        const urls = Array.from(urlsMap);
        if (!updateVideo.isPending && urls.length > 0 && urls.length !== (video.data?.urls || []).length) updateVideo.mutate({
            urls: urls
        });
    }, [
        updateVideo.isPending,
        video.data?.urls,
        video.data?.selectedCampaignIds,
        video.data?.campaigns,
        video.data?.customer?.websiteURL,
        video.data?.customer?.brandCenterURL
    ]);
    const _mapAssets = (0, $eF4cA.useCallback)((data)=>{
        const images = data.images.map((asset)=>{
            // if (asset.type === "image") {
            if (!asset?.src?.startsWith?.("data:image/svg+xml") && asset?.width && asset?.height) {
                const area = asset.width * asset.height;
                return {
                    ...asset,
                    isDisabled: area < 76800
                };
            }
            return {
                origin: asset.origin,
                ...asset?.data ?? {},
                type: "image",
                isDisabled: false
            };
        }).sort((a, b)=>b.isDisabled ? -1 : 1) || [];
        const colorValues = new Set([
            ...data.brandColors.map((color)=>color?.data?.value),
            ...[
                "primaryButton",
                "secondaryButton",
                "body",
                "header",
                "footer"
            ].flatMap((key)=>[
                    "background",
                    "text"
                ].map((subKey)=>data?.colors?.[key]?.[subKey]?.data?.value))
        ].filter(Boolean));
        const colors = Array.from(colorValues).map((color)=>({
                type: "color",
                color: color
            }));
        const assets = [
            ...images,
            ...colors
        ];
        assets.isFiltered = images.some((image)=>image?.isDisabled === true);
        return assets;
    }, []);
    const [...scrapeQueries] = (0, $ittHc.useQueries)({
        queries: video.data?.urls?.map(([url])=>(0, $4MHdR.scrapeQueryOptions)(url, {}, {
                enabled: !!url && (0, $lb17q.isStepAfter)(currentStepEntry, (0, $lb17q.WIZARD_STEP).CAMPAIGN) && (0, $lb17q.isStepAtOrBefore)(currentStepEntry, (0, $lb17q.WIZARD_STEP).BRANDING)
            }, {
                shouldParseAssets: true,
                dataParser: _mapAssets
            })) ?? []
    });
    scrapeQueries.forEach((_query, idx)=>{
        const [url, label] = video.data?.urls?.[idx] ?? [];
        _query.label = label;
        _query.url = url;
        _query.isEditable = true;
    });
    const searchURLs = (0, $eF4cA.useMemo)(()=>{
        try {
            const videoUrls = new Map(video.data?.urls ?? []);
            const urls = new Map();
            const websiteUrl = new URL(video.data?.customer?.websiteURL);
            const baseDomain = websiteUrl.host.replace(/^www\./, "");
            const baseQuery = `site:${baseDomain}`;
            const selectedCampaign = video.data?.campaigns?.find((c)=>c.id === video.data?.selectedCampaignIds?.[0]) ?? {};
            const companyWebsiteKey = websiteUrl.host + websiteUrl.pathname;
            Object.entries(selectedCampaign).filter(([, value])=>value?.startsWith?.("http")).forEach(([key, val])=>{
                try {
                    const url = new URL(val);
                    const value = url.host + url.pathname;
                    if (!urls.has(value) && value !== companyWebsiteKey) {
                        const prefixKey = key.replace(/-URL$/i, "").trim();
                        const name = selectedCampaign[prefixKey];
                        const label = videoUrls.has(val) ? videoUrls.get(val) : name ?? prefixKey.replace("-", " ");
                        urls.set(value, {
                            label: `[Search] ${label}`,
                            url: val,
                            query: `site:${url.host.replace(/^www\./, "")} ${name ?? label}`,
                            isEditable: true
                        });
                    }
                } catch (e) {
                    console.warn(`Invalid URL skipped: ${val}`);
                }
            });
            // if (!urls.has(websiteUrl.host + websiteUrl.pathname)) {
            urls.set(companyWebsiteKey, {
                label: "[Search] Company website",
                url: websiteUrl.host,
                query: baseQuery
            });
            urls.set("logotype", {
                label: "[Search] Company logo",
                url: websiteUrl.host,
                query: `type:transparent ${video.data?.customer?.name ?? ""} Logo`
            });
            // }
            videoUrls.entries().forEach(([url, label])=>{
                try {
                    const parsedUrl = new URL(url);
                    const value = parsedUrl.host + parsedUrl.pathname;
                    if (!urls.has(value)) urls.set(value, {
                        label: `[Search] ${label || url}`,
                        url: url,
                        query: `site:${parsedUrl.host.replace(/^www\./, "")}${parsedUrl.pathname !== "/" ? ` ${parsedUrl.pathname}` : ""}`,
                        isEditable: true
                    });
                } catch (e) {
                    console.warn(`Invalid URL skipped: ${url}`);
                }
            });
            return Array.from(urls);
        } catch (e) {
            console.warn("Invalid customer website URL:", video.data?.customer?.websiteURL);
            return [];
        }
    }, [
        video.data?.customer?.websiteURL,
        video.data?.campaigns,
        video.data?.selectedCampaignIds,
        video.data?.urls
    ]);
    const _searchImagesQueries = searchURLs?.map(([, { query: query }])=>(0, $4MHdR.searchImagesQueryOptions)({
            q: query,
            iterations: 1,
            moderate: true,
            retries: 1
        }, {
            enabled: !!query && (0, $lb17q.isStepAfter)(currentStepEntry, (0, $lb17q.WIZARD_STEP).CAMPAIGN) && (0, $lb17q.isStepAtOrBefore)(currentStepEntry, (0, $lb17q.WIZARD_STEP).BRANDING)
        })) ?? [];
    const [...searchImagesQueries] = (0, $ittHc.useQueries)({
        queries: _searchImagesQueries
    });
    searchImagesQueries.forEach((_query, idx)=>{
        const { url: url, query: query, label: label, isEditable: isEditable } = searchURLs?.[idx]?.[1] ?? {};
        _query.label = label;
        _query.query = `https://www.bing.com/images/search?q=${encodeURIComponent(query)}`;
        _query.url = _query.query;
        _query.isEditable = false;
    });
    const appStoreQueryParams = {
        term: video.data?.customer?.name,
        limit: 15,
        country: "US",
        media: "software"
    };
    const _appStoreQuery = (0, $4kcQz.useQuery)({
        queryKey: [
            "appStore",
            "search",
            appStoreQueryParams
        ],
        queryFn: ({ signal: signal })=>(0, $dzLiJ.searchAppStore)(appStoreQueryParams, {
                signal: signal
            }),
        enabled: !!video.data?.projectPath && !!video.data?.customer?.name && (0, $lb17q.isStepAtOrBefore)(currentStepEntry, (0, $lb17q.WIZARD_STEP).BRANDING),
        select: (0, $eF4cA.useCallback)((data)=>data.results.filter((app)=>[
                    app.artistName,
                    app.sellerName,
                    app.trackName
                ].map((str)=>str.toLowerCase().replaceAll(/[^a-z0-9]/g, "")).some((str)=>str.includes(video.data?.customer?.name.toLowerCase().replaceAll(/[^a-z0-9]/g, "")))).flatMap((app, idx)=>{
                if (idx === 0) {
                    if (!!app.artworkUrl512 && !video.data?.assets?.some((a)=>a.name === "App-icon") && !uploadAssets.isPending) uploadAssets.mutate({
                        assets: [
                            {
                                name: "App-icon",
                                type: "image",
                                src: app.artworkUrl512,
                                size: {
                                    width: 512,
                                    height: 512
                                }
                            }
                        ]
                    });
                    if (!!app.sellerUrl) {
                        const urlsMap = new Map(video.data?.urls ?? []);
                        const stripProtocol = (url)=>url.replace(/^https?:\/\//, "");
                        const hasSellerUrl = Array.from(urlsMap.keys()).some((url)=>stripProtocol(url) === stripProtocol(app.sellerUrl));
                        if (!hasSellerUrl && !updateVideo.isPending) {
                            urlsMap.set(app.sellerUrl, "App Store: Website");
                            updateVideo.mutate({
                                urls: Array.from(urlsMap)
                            });
                        }
                    }
                }
                const images = [
                    {
                        id: `${app.trackId}-icon`,
                        type: "image",
                        src: app.artworkUrl512,
                        alt: app.trackName,
                        width: 512,
                        height: 512,
                        type: "image",
                        name: "App Store Image",
                        isDisabled: false
                    }
                ];
                if (app.screenshotUrls?.length) images.push(...app.screenshotUrls.map((url, index)=>{
                    const [width, height] = /\/(\d+)x(\d+)/.exec(url)?.slice(1, 3) || [
                        1080,
                        1920
                    ];
                    return {
                        id: `${app.trackId}-screenshot-${index}`,
                        type: "image",
                        src: url,
                        alt: `${app.trackName} Screenshot ${index + 1}`,
                        width: width,
                        height: height,
                        type: "image",
                        name: `App Store Screenshot ${index + 1}`,
                        isDisabled: false
                    };
                }));
                return images;
            }), [
            video.data?.customer?.name,
            video.data?.assets,
            video.data?.urls,
            uploadAssets.isPending,
            updateVideo.isPending
        ])
    });
    const appStoreQuery = Object.assign({
        label: "App Store",
        url: `https://apps.apple.com/iphone/search?term=${video.data?.customer?.name}`
    }, _appStoreQuery);
    const _productSearchQuery = (0, $4kcQz.useQuery)((0, $4MHdR.searchImagesQueryOptions)({
        q: `${video.data?.customer?.name} ${selectedCampaign?.["Product-name"] ?? ""}`,
        iterations: 1,
        moderate: true,
        retries: 1
    }, {
        enabled: !!video.data?.customer?.name && !!selectedCampaign?.["Product-name"]
    }));
    const productSearchQuery = Object.assign({
        label: `[Search] ${selectedCampaign?.["Product-name"]}`,
        url: `https://www.bing.com/images/search?q=${encodeURIComponent(`${video.data?.customer?.name} ${selectedCampaign?.["Product-name"] ?? ""}`)}`
    }, _productSearchQuery);
    (0, $eF4cA.useEffect)(()=>{
        if (!video.isSuccess || !videoId || updateVideo.isPending) return;
        const ids = video.data?.selectedCampaignIds ?? [];
        const campaigns = video.data?.campaigns ?? [];
        if (!ids.length) return;
        const invalid = ids.some((id)=>!campaigns.some((campaign)=>campaign.id === id));
        if (!invalid) return;
        updateVideo.mutate({
            selectedCampaignIds: campaigns.length > 0 ? [
                campaigns[campaigns.length - 1].id
            ] : []
        });
    }, [
        video.isSuccess,
        videoId,
        video.data?.selectedCampaignIds,
        video.data?.campaigns,
        updateVideo.isPending,
        updateVideo.mutate
    ]);
    const cropImage = (0, $dyJFE.useCropImage)();
    const generateVariation = (0, $fK5Xl.useGenerateVariation)();
    const [bannersStatus, setBannersStatus] = (0, $eF4cA.useState)(null);
    const exportBanners = $0744e5ee275e1594$export$69931686cbeda8f3(videoId, {
        enabled: !!template.data?.assetsTemplateId && currentStep === (0, $lb17q.WIZARD_STEP).BANNERS && !!video.data?.templateAssetsRenditions?.length
    });
    // Retry exporting banners if there were errors -> status="partially_succeeded"
    (0, $eF4cA.useEffect)(()=>{
        if (exportBanners.isSuccess && exportBanners.data.some((item)=>item.error)) exportBanners.refetch();
    }, [
        exportBanners.isSuccess,
        exportBanners.data
    ]);
    const generateBanners = (0, $k6waQ.useMutation)({
        mutationFn: async ({ videoId: videoId }, { client: client })=>{
            if (!videoId) throw new Error("videoId is required");
            setBannersStatus("Preparing assets");
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const renditionsDocumentId = videoData?.templateAssetsRenditions?.[0]?.documentId;
            const assetsTemplateId = // renditionsDocumentId ??
            videoData?.assetsTemplateId ?? template.data?.assetsTemplateId;
            const { campaigns: campaigns, selectedCampaignIds: selectedCampaignIds } = videoData;
            const assetsTemplateData = client.getQueryData((0, $fK5Xl.expressTemplateKey).detail(assetsTemplateId));
            const taggedAssets = assetsTemplateData?.pages?.flatMap((apiPage)=>apiPage.documentPages)?.flatMap((docPage)=>docPage.taggedElements.map((element)=>({
                        ...element,
                        size: {
                            width: Math.round(element.size.width),
                            height: Math.round(element.size.height)
                        }
                    }))) ?? [];
            const newAssets = [];
            const selectedLogo = videoData?.assets?.find((asset)=>asset.name === "Logo");
            if (!!selectedLogo && !videoData?.assets?.some((asset)=>asset.name === "Logo_cropped" && asset.filePath.endsWith(".png"))) {
                const taggedLogos = taggedAssets?.filter((el)=>el.type === "image" && el.name.startsWith("Logo #"));
                const biggestTaggedLogo = taggedLogos?.reduce((prev, current)=>{
                    const currentArea = current.size.width * current.size.height;
                    const prevArea = prev?.size?.width * prev?.size?.height;
                    return currentArea > (prevArea ?? 0) ? current : prev;
                }, null) ?? selectedLogo;
                const minLogoSize = {
                    width: 512,
                    height: 512
                };
                if (biggestTaggedLogo.size.width < minLogoSize.width || biggestTaggedLogo.size.height < minLogoSize.height) {
                    const aspectRatio = biggestTaggedLogo.size.width / biggestTaggedLogo.size.height;
                    if (biggestTaggedLogo.size.width < minLogoSize.width) {
                        biggestTaggedLogo.size.width = minLogoSize.width;
                        biggestTaggedLogo.size.height = Math.round(minLogoSize.width / aspectRatio);
                    } else if (biggestTaggedLogo.size.height < minLogoSize.height) {
                        biggestTaggedLogo.size.height = minLogoSize.height;
                        biggestTaggedLogo.size.width = Math.round(minLogoSize.height * aspectRatio);
                    }
                }
                const logoUrl = await client.query((0, $a8sj2.presignURLQueryOptions)(selectedLogo?.filePath));
                const logoBlob = await (0, $9lDhw.getImageBlob)({
                    url: logoUrl.presignURL
                });
                const pngLogoBlob = await (0, $6lZyT.convertImageBlobToType)(logoBlob.blob, "png", 1);
                const logoRendition = await (0, $6lZyT.cropImageBlob)(pngLogoBlob, {
                    width: biggestTaggedLogo.size.width,
                    height: biggestTaggedLogo.size.height
                }, (0, $6lZyT.OBJECT_FIT).CONTAIN, (0, $6lZyT.OBJECT_POSITION).LEFT);
                const croppedLogo = await uploadFile.mutateAsync({
                    fileBlob: logoRendition,
                    filePath: `${video.data?.projectPath}/Logo_cropped_${biggestTaggedLogo.size.width}x${biggestTaggedLogo.size.height}.png`
                });
                const croppedLogoAsset = {
                    name: "Logo_cropped",
                    filePath: croppedLogo.filePath,
                    size: biggestTaggedLogo.size
                };
                newAssets.push(croppedLogoAsset);
            }
            const brandColor = videoData?.assets?.find((asset)=>asset.name === "Brand-color")?.color || videoData?.customer?.color || "#FFFFFF";
            if (!videoData?.assets?.some((asset)=>asset.name === "Customer-color-img") || !videoData?.assets?.find((asset)=>asset.name === "Customer-color-img")?.color !== brandColor) {
                const colorImageBlob = await (0, $6lZyT.createImageColorBlob)(brandColor, 400, 400);
                const customerColorImage = await uploadFile.mutateAsync({
                    fileBlob: colorImageBlob,
                    filePath: `${video.data?.projectPath}/Customer-color-img.png`
                });
                const customerColorImageAsset = {
                    name: "Customer-color-img",
                    filePath: customerColorImage.filePath,
                    size: {
                        width: 400,
                        height: 400
                    },
                    color: brandColor
                };
                newAssets.push(customerColorImageAsset);
            }
            const taggedImages = taggedAssets.filter((el)=>el.type === "image" && !el.name.startsWith("Logo") && !el.name.startsWith("App-icon") && !videoData?.assets?.some((asset)=>asset.name === el.name)).map((taggedImage)=>{
                const assetName = taggedImage.name.split("#")[0].trim();
                const baseAssetName = assetName.split("-")[0].trim();
                const asset = newAssets?.find((a)=>a.name === assetName) ?? newAssets?.find((a)=>a.name === baseAssetName) ?? videoData?.assets?.find((a)=>a.name === assetName) ?? videoData?.assets?.find((a)=>a.name === baseAssetName);
                if (!asset?.filePath) {
                    console.warn("No filePath found for asset", asset, "taggedImage:", taggedImage);
                    return null;
                }
                const mainSubject = asset?.labeling?.mainSubject ?? videoData?.assets?.find((a)=>a.name === Object.keys(asset.sourceReferences ?? {})[0])?.labeling?.mainSubject;
                return {
                    name: taggedImage.name,
                    size: taggedImage.size,
                    originalPath: asset?.filePath,
                    mainSubject: mainSubject
                };
            }).filter(Boolean);
            setBannersStatus("Generating smart crops");
            const cropTargets = new Map();
            await Promise.all(taggedImages.filter((el)=>!el.name.startsWith("Customer-color-img")).map(async (asset)=>{
                if (!cropTargets.has(asset.originalPath)) {
                    const { presignURL: presignURL } = await client.query((0, $a8sj2.presignURLQueryOptions)(asset.originalPath));
                    cropTargets.set(asset.originalPath, [
                        presignURL,
                        new Set([
                            asset.size
                        ]),
                        new Map([
                            [
                                asset.name,
                                asset
                            ]
                        ])
                    ]);
                } else {
                    cropTargets.get(asset.originalPath)[1].add(asset.size);
                    cropTargets.get(asset.originalPath)[2].set(asset.name, asset);
                }
            }));
            const cropTargetEntries = Array.from(cropTargets.values());
            const batchSize = 2; // Adjust based on API limits and performance
            const batches = [];
            for(let i = 0; i < cropTargetEntries.length; i += batchSize)batches.push(cropTargetEntries.slice(i, i + batchSize));
            const smartCropResults = await Promise.allSettled(batches.map((batch)=>cropImage.mutateAsync({
                    items: batch.map(([presignURL, sizes, assetsMap])=>[
                            presignURL,
                            Array.from(sizes),
                            Array.from(assetsMap)?.[0]?.[1]?.mainSubject
                        ])
                })));
            const smartCropData = {
                crops: smartCropResults.flatMap((result, idx)=>result.status === "fulfilled" ? result.value.crops : new Array(batches[idx].length).fill({
                        bboxes: []
                    }))
            };
            setBannersStatus("Cropping visuals");
            const assetsToCrop = smartCropData?.crops.flatMap((item, itemIdx)=>{
                const [, , assetsMap] = cropTargetEntries[itemIdx];
                const _assets = Array.from(assetsMap.values()).map((asset, assetIdx)=>{
                    const bbox = item.bboxes[assetIdx];
                    if (!bbox) {
                        console.warn("No bbox found for asset", asset, "with size", asset.size);
                        return null;
                    }
                    return {
                        ...asset,
                        bbox: bbox
                    };
                }).filter(Boolean);
                return _assets;
            });
            const croppedPromises = await Promise.all(taggedImages.map(async (asset)=>{
                try {
                    let croppedBlob;
                    const smartCropItem = assetsToCrop?.find((a)=>a.name === asset.name);
                    const s3Asset = await client.query((0, $a8sj2.presignURLQueryOptions)(asset.originalPath));
                    const assetBlob = await (0, $9lDhw.getImageBlob)({
                        url: s3Asset.presignURL
                    });
                    if (smartCropItem?.bbox) croppedBlob = await (0, $6lZyT.cropImageBlobToBbox)(assetBlob.blob, smartCropItem);
                    else croppedBlob = await (0, $6lZyT.cropImageBlob)(assetBlob.blob, {
                        width: asset.size.width,
                        height: asset.size.height
                    }, (0, $6lZyT.OBJECT_FIT).COVER, (0, $6lZyT.OBJECT_POSITION).CENTER);
                    const croppedRendition = await uploadFile.mutateAsync({
                        fileBlob: croppedBlob,
                        filePath: `${video.data?.projectPath}/${asset.name}_cropped_${asset.size.width}x${asset.size.height}.${assetBlob.image.format}`
                    });
                    return {
                        name: asset.name,
                        size: asset.size,
                        filePath: croppedRendition.filePath
                    };
                } catch (error) {
                    console.warn("Error cropping/uploading asset", asset, error);
                    return {
                        name: asset.name,
                        size: asset.size,
                        filePath: asset.originalPath
                    };
                }
            }));
            newAssets.push(...croppedPromises);
            const filteredAssets = newAssets.filter(Boolean).filter((asset)=>!!asset.filePath);
            const toRemoveAssets = filteredAssets.some((asset)=>asset.name === "Customer-color-img") ? videoData?.assets?.filter((asset)=>asset.name.startsWith("Customer-color-img #")) : [];
            if (!!filteredAssets.length) await updateAssets.mutateAsync({
                assets: filteredAssets,
                toRemove: toRemoveAssets
            });
            const allAssets = client.getQueryData((0, $ikOQe.videoKey).detail(videoId)).assets;
            const selectedCampaign = campaigns.find((campaign)=>campaign.id === selectedCampaignIds?.[0]);
            let textMappings = {};
            if (videoData?.templateId === "csc-overview") textMappings = {
                "Campaign-tagline-1": selectedCampaign?.taglines?.[0]?.en || "",
                "Campaign-tagline-1-Spanish": selectedCampaign?.taglines?.[0]?.es || "",
                "Campaign-tagline-2": selectedCampaign?.taglines?.[1]?.en || "",
                "Campaign-tagline-3": selectedCampaign?.taglines?.[2]?.en || "",
                CTA: "DISCOVER",
                "CTA-Spanish": "DESCUBRIR"
            };
            else if (template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE) textMappings = videoData?.campaigns?.find((c)=>c.id === videoData?.selectedCampaignIds?.[0]) || {};
            // const assetTemplatePagesLength =
            //   assetsTemplateData?.pages
            //     ?.flatMap((apiPage) => apiPage.documentPages)
            //     .pop()?.pageNumber || 1;
            // const MAX_PAGES_PER_REQUEST = 60;
            // const _pages = new Array(
            //   Math.ceil(assetTemplatePagesLength / MAX_PAGES_PER_REQUEST),
            // )
            //   .fill(0)
            //   .map((_, idx) => {
            //     const startPage = idx * MAX_PAGES_PER_REQUEST + 1;
            //     const endPage = Math.min(
            //       startPage + MAX_PAGES_PER_REQUEST - 1,
            //       assetTemplatePagesLength,
            //     );
            //     return `${startPage}-${endPage}`;
            //   });
            setBannersStatus("Creating variations");
            const tagMappingsPromises = await Promise.all(assetsTemplate.data?.pages?.flatMap((page)=>page.documentPages.flatMap((docPage)=>docPage.taggedElements))?.map(async (element)=>{
                if (element.type === "text") return {
                    [element.name]: textMappings[element.name] || ""
                };
                let assetBaseName = element.name.split("#")[0].trim();
                if (element.name.startsWith("Logo")) assetBaseName = "Logo_cropped";
                 /* else if (element.name.startsWith("App-icon")) {
              assetBaseName = "App-icon-cropped";
            } */ 
                const matchedAsset = allAssets.find((a)=>a.name === element.name) || allAssets.find((a)=>a.name === assetBaseName);
                if (!matchedAsset) return null;
                const s3Asset = await client.query((0, $a8sj2.presignURLQueryOptions)(matchedAsset.filePath));
                return {
                    [element.name]: s3Asset.presignURL
                };
            }) ?? []);
            const tagMappings = tagMappingsPromises.filter(Boolean).reduce((acc, curr)=>({
                    ...acc,
                    ...curr
                }), {});
            if (assetsTemplateId) {
                setBannersStatus("Creating Express document");
                return generateVariation.mutateAsync({
                    id: assetsTemplateId,
                    batchSize: $0744e5ee275e1594$var$EXPRESS_TAG_BATCH_SIZE,
                    variationDetails: {
                        pages: "1-",
                        preferredDocumentName: `${videoData?.customer?.name} \u{2014} ${assetsTemplate?.data?.pages?.[0]?.name || "Assets Template"}`,
                        tagMappings: tagMappings
                    }
                });
            }
            return {
                document: {
                    id: null
                }
            };
        },
        onSuccess: async (data)=>{
            const templateAssetsRendition = {
                documentId: data.document.id,
                pages: "1-"
            };
            await updateVideo.mutateAsync({
                templateAssetsRenditions: [
                    templateAssetsRendition
                ],
                templateAssetsRenditionFiles: []
            });
        // exportBanners.refetch();
        // return exportBanners.mutateAsync(variables);
        },
        onError: (error)=>{
            console.error("Error generating banners:", error);
        }
    });
    // Update banners generation status
    (0, $eF4cA.useEffect)(()=>{
        if (exportBanners.isFetching) setBannersStatus(exportBanners.data?.length ? "Refreshing banners" : "Exporting banners");
        else if (exportBanners.isSuccess && !generateBanners.isPending) setBannersStatus(null);
    }, [
        exportBanners.isFetching,
        exportBanners.isSuccess,
        generateBanners.isPending
    ]);
    // Regenerate banners if assetsTemplate changed
    (0, $eF4cA.useEffect)(()=>{
        if (exportBanners.isEnabled && exportBanners.isSuccess && assetsTemplate.isSuccess) {
            const exportedPages = exportBanners.data.map((item)=>item.pageNumber).sort((a, b)=>a - b);
            const templatePages = assetsTemplate.data?.pages.flatMap((p)=>p.documentPages.map((dp)=>dp.pageNumber)).sort((a, b)=>a - b);
            if (// exportedPages.length !== templatePages.length ||
            !templatePages.every((value)=>exportedPages.includes(value))) {
                console.log("Regenerating banners due to changes in assets template");
                generateBanners.mutate({
                    videoId: videoId
                });
            }
        }
    }, [
        videoId,
        exportBanners.isEnabled,
        exportBanners.isSuccess,
        assetsTemplate.isSuccess
    ]);
    const exportExpressVideo = $0744e5ee275e1594$export$b9c3fc48de1fbbd2(videoId, {
        enabled: currentStep === (0, $lb17q.WIZARD_STEP).GENERATE_VIDEO && video.data?.templateType === "express"
    });
    const exportVideo = (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { client: client, signal: signal })=>{
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(variables.videoId));
            if (videoData?.templateType === "express") {
                if (videoData?.videoPath) {
                    const presignData = await client.query((0, $a8sj2.presignURLQueryOptions)(videoData.videoPath));
                    if (videoData?.externalSource === "aurora") await (0, $awCmJ.putAuroraVideo)(videoData.id, {
                        signal: signal
                    });
                    return presignData;
                }
                return exportExpressVideo.data;
            } else if (videoData?.templateType === "mogrt") {
                // For MOGRT templates, the video is already rendered and uploaded in S3 in the `renderMogrtTemplate` mutation
                if (videoData?.videoPath) return client.query((0, $a8sj2.presignURLQueryOptions)(videoData.videoPath));
                return variables;
            } else if (videoData?.templateType === "modular") // For modular templates, all renders were already completed — no additional export step needed
            return variables;
            else throw new Error("Unsupported template type");
        },
        onMutate: (variables, { client: client })=>{
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(variables.videoId));
            if (videoData?.templateType === "express" && !videoData?.videoPath) return exportExpressVideo.mutateAsync();
        }
    });
    const generateExpressVideo = (0, $k6waQ.useMutation)({
        mutationFn: async ({ videoId: videoId, selectedCampaign: selectedCampaign, banners: banners }, { client: client })=>{
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const { expressTemplateId: templateId } = videoData ?? {};
            const videoTemplateData = client.getQueryData((0, $fK5Xl.expressTemplateKey).detail(templateId));
            const taggedAssetsPromises = await Promise.allSettled(videoTemplateData?.pages.flatMap((apiPage)=>apiPage.documentPages).flatMap((docPage)=>docPage.taggedElements).map((element)=>$0744e5ee275e1594$var$mapTaggedValue("express", element, {
                    customerName: videoData?.customer?.name,
                    selectedCampaign: selectedCampaign,
                    banners: banners,
                    assets: videoData?.assets || [],
                    queryClient: client,
                    audioVariations: template.data?.audioVariations
                })));
            const tagMappings = taggedAssetsPromises.filter((promise)=>promise.status === "fulfilled" && promise.value).map((promise)=>promise.value);
            const sortedTagMappings = tagMappings.sort((a, b)=>{
                const keyA = Object.keys(a)[0];
                const keyB = Object.keys(b)[0];
                const indexA = template.data?.taggedElements.indexOf(keyA);
                const indexB = template.data?.taggedElements.indexOf(keyB);
                if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                if (indexA !== -1) return -1;
                if (indexB !== -1) return 1;
                return 0;
            });
            const generateData = await generateVariation.mutateAsync({
                id: templateId,
                batchSize: $0744e5ee275e1594$var$EXPRESS_TAG_BATCH_SIZE,
                variationDetails: {
                    pages: "1-",
                    preferredDocumentName: `${videoData?.customer?.name} \u{2014} ${videoTemplateData?.pages?.[0]?.name || ""}`,
                    tagMappings: sortedTagMappings.reduce((acc, curr)=>({
                            ...acc,
                            ...curr
                        }), {})
                }
            });
            (0, $dSkgb.trackVideoWizard)({
                isConversion: true,
                project: {
                    id: videoId,
                    name: videoData.name,
                    expressId: generateData.document.id,
                    videoPath: videoData.videoPath
                },
                customer: {
                    name: video.data?.customer?.name,
                    industry: video.data?.customer?.industry,
                    drNumber: video.data?.drNumber,
                    accountName: video.data?.accountName || accountName || undefined
                },
                user: {
                    email: userProfile?.email
                }
            });
            return updateVideo.mutateAsync({
                expressId: generateData.document.id
            });
        },
        onSuccess: async (data, variables)=>{
            return exportVideo.mutateAsync({
                videoId: variables.videoId
            });
        },
        onError: (error)=>{
            console.error("Error generating express video", error);
        }
    });
    (0, $eF4cA.useEffect)(()=>{
        if (!video.isSuccess || video.data?.templateType !== "mogrt" || updateVideo.isPending || !template.data) return;
        const resolved = $0744e5ee275e1594$export$875839b71582f701(template.data, selectedCampaign);
        if (resolved && resolved !== video.data?.mogrtRootPath) updateVideo.mutate({
            mogrtRootPath: resolved
        });
    }, [
        video.isSuccess,
        video.data?.templateType,
        video.data?.mogrtRootPath,
        template.data,
        selectedCampaign,
        updateVideo.isPending
    ]);
    const describeMogrtTemplate = (0, $iMKxE.useDescribeMogrtTemplate)(video.data?.mogrtRootPath, {
        enabled: !!video.data?.mogrtRootPath && video.data?.templateType === "mogrt" && currentStep != null && (0, $lb17q.isStepAtOrAfter)(currentStepEntry, (0, $lb17q.WIZARD_STEP).BRANDING)
    });
    const describeModularTemplate = (0, $iMKxE.useDescribeModularTemplate)(video.data?.modules, {
        enabled: !!video.data?.modules?.length && video.data?.templateType === "modular" && currentStep != null && (0, $lb17q.isStepAtOrAfter)(currentStepEntry, (0, $lb17q.WIZARD_STEP).BRANDING)
    });
    const renderMogrtTemplate = (0, $iMKxE.useRenderMogrtTemplate)({
        onSuccess: (outputUrl)=>{
            console.log("render success", outputUrl);
            video.refetch();
        }
    });
    const uploadRenditionFile = (0, $a8sj2.useUploadFile)();
    // Express rendition URLs expire after ~4h; render from our S3 copies so jobs stay replayable.
    const persistRenditionFiles = async (videoData, renditions)=>{
        const files = await Promise.all(renditions.filter((rendition)=>rendition?.renditionUrl).map(async (rendition)=>{
            const documentKey = String(rendition.id ?? videoData.templateAssetsRenditions?.[0]?.documentId ?? "document").replace(/[^\w-]/g, "_");
            try {
                const { filePath: filePath } = await uploadRenditionFile.mutateAsync({
                    fileURL: rendition.renditionUrl,
                    filePath: `${videoData.projectPath}/renditions/${documentKey}/page-${rendition.pageNumber}.jpg`
                });
                return {
                    pageNumber: rendition.pageNumber,
                    documentId: rendition.id ?? null,
                    filePath: filePath
                };
            } catch (error) {
                console.warn(`Failed to copy rendition page ${rendition.pageNumber} to S3; using the Express URL`, error);
                return null;
            }
        }));
        const savedFiles = files.filter(Boolean);
        if (savedFiles.length > 0) await updateVideo.mutateAsync({
            templateAssetsRenditionFiles: savedFiles
        });
        return savedFiles;
    };
    const generateVideo = (0, $k6waQ.useMutation)({
        mutationFn: async ({ videoId: videoId, templateAssetsRenditions: templateAssetsRenditions, resumeMogrtJob: resumeMogrtJob }, { client: client, signal: signal })=>{
            let videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const assetTemplateData = client.getQueryData((0, $fK5Xl.expressTemplateKey).detail(videoData?.assetsTemplateId));
            const assetsTemplatePages = assetTemplateData?.pages?.flatMap((apiPage)=>apiPage.documentPages);
            const renditionFiles = !resumeMogrtJob && videoData?.templateType !== "express" && videoData?.projectPath && templateAssetsRenditions?.length ? await persistRenditionFiles(videoData, templateAssetsRenditions) : [];
            const renditionFileByPage = new Map(renditionFiles.map((file)=>[
                    file.pageNumber,
                    file.filePath
                ]));
            const banners = templateAssetsRenditions?.map((rendition)=>{
                const filePath = renditionFileByPage.get(rendition.pageNumber);
                return {
                    ...filePath ? {
                        filePath: filePath
                    } : {
                        url: rendition.renditionUrl
                    },
                    pageNumber: rendition.pageNumber,
                    name: assetsTemplatePages?.find((page)=>page.pageNumber === rendition.pageNumber)?.pageTitle?.split(" - ")[0]
                };
            }) ?? [];
            const selectedCampaign = videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0]);
            if (videoData?.templateType === "express") return generateExpressVideo.mutateAsync({
                videoId: videoId,
                selectedCampaign: selectedCampaign,
                banners: banners
            });
            else if (videoData?.templateType === "mogrt") {
                if (resumeMogrtJob && videoData?.jobId && !videoData?.videoPath) return renderMogrtTemplate.mutateAsync({
                    videoId: videoId,
                    existingJobId: String(videoData.jobId)
                }, {
                    signal: signal
                });
                if (!describeMogrtTemplate.isSuccess) await new Promise((resolve)=>{
                    const interval = setInterval(()=>{
                        if (describeMogrtTemplate.isSuccess) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 100);
                });
                const formValues = await $0744e5ee275e1594$var$buildMogrtFormValues(describeMogrtTemplate.data.controls, {
                    customerName: videoData?.customer?.name,
                    selectedCampaign: {
                        "Persona Selection": personaId,
                        ...selectedCampaign
                    },
                    banners: banners,
                    assets: videoData?.assets || [],
                    queryClient: client,
                    audioVariations: template.data?.audioVariations,
                    customer: {
                        "Brand-color": videoData?.customer?.["Brand-color"] ?? videoData?.customer?.color,
                        "Secondary-color": videoData?.customer?.["Secondary-color"] ?? videoData?.customer?.secondaryColor
                    },
                    musicPath: videoData?.musicPath
                });
                console.log("Form values for MOGRT template:", formValues);
                return renderMogrtTemplate.mutateAsync({
                    ...describeMogrtTemplate.data,
                    formValues: formValues,
                    videoId: videoId,
                    audioVariations: template.data?.audioVariations
                }, {
                    signal: signal
                });
            } else if (videoData?.templateType === "modular") {
                const scenes = (0, $6yR6I.getVideoScenes)(videoData);
                const resolvedModules = videoData.modules?.length ? videoData.modules : (0, $6yR6I.buildModulesFromScenes)(scenes, template.data?.modules);
                const modularData = await client.query((0, $iMKxE.modularTemplateQueryOptions)(resolvedModules));
                const identity = await (0, $5uQ6L.getAlloy)()?.("getIdentity", {
                    namespaces: [
                        "ECID"
                    ]
                });
                const ecid = identity?.identity?.ECID;
                const formValuesContext = {
                    customerName: videoData?.customer?.name,
                    selectedCampaign: {
                        "Persona Selection": personaId,
                        ...selectedCampaign
                    },
                    banners: banners,
                    assets: videoData?.assets || [],
                    queryClient: client,
                    audioVariations: template.data?.audioVariations,
                    customer: {
                        "Brand-color": videoData?.customer?.["Brand-color"] ?? videoData?.customer?.color,
                        "Secondary-color": videoData?.customer?.["Secondary-color"] ?? videoData?.customer?.secondaryColor
                    },
                    musicPath: videoData?.musicPath,
                    templateVideoAssets: (0, $6yR6I.collectTemplateVideoAssets)(template.data, videoData)
                };
                const sceneAssignments = (0, $6yR6I.assignScenesToModules)(scenes);
                const modulePayloads = await Promise.all(modularData.modules.map(async (moduleData, index)=>{
                    const baseFormValues = await $0744e5ee275e1594$var$buildMogrtFormValues(moduleData.controls, formValuesContext);
                    const sceneFormValues = await (0, $6yR6I.applyScenesToModuleControls)(sceneAssignments[index]?.scenes ?? [], moduleData.controls, formValuesContext);
                    const formValues = {
                        ...baseFormValues,
                        ...sceneFormValues
                    };
                    console.log("Form values for modular module:", {
                        index: index,
                        name: moduleData.name,
                        scenes: sceneAssignments[index]?.scenes,
                        formValues: formValues
                    });
                    const payload = (0, $iMKxE.buildRenderPayload)({
                        ...moduleData,
                        formValues: formValues,
                        audioVariations: template.data?.audioVariations
                    });
                    return {
                        ...payload,
                        moduleName: moduleData.name
                    };
                }));
                const renderResponse = await (0, $5nqV3.renderModularTemplate)({
                    videoId: videoId,
                    ecid: ecid,
                    modules: modulePayloads
                }, {
                    signal: signal
                });
                const modularJobs = renderResponse?.modularJobs;
                if (!Array.isArray(modularJobs) || modularJobs.length === 0) throw new Error("Failed to start modular render. Please try again.", {
                    cause: renderResponse
                });
                await updateVideo.mutateAsync({
                    status: "processing",
                    modularJobs: modularJobs,
                    modularRenderJobId: renderResponse?.jobId
                });
                return modularJobs;
            } else throw new Error("Unsupported template type");
        },
        onMutate: async ({ videoId: videoId }, { client: client })=>{
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const previous = {
                jobId: videoData?.jobId ?? null,
                videoPath: videoData?.videoPath ?? null
            };
            if (videoData?.videoPath) await updateVideo.mutateAsync({
                videoPath: null,
                status: "processing"
            });
            return previous;
        },
        onSuccess: async (data, variables, onMutateResult, { client: client })=>{
            const { videoId: videoId } = variables;
            await client.refetchQueries({
                queryKey: (0, $ikOQe.videoKey).detail(videoId)
            });
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            return exportVideo.mutateAsync({
                videoId: videoId,
                videoPath: videoData?.videoPath
            });
        },
        onError: (error, variables, onMutateResult)=>{
            console.error("Error generating video", error);
            if ((0, $k7O9T.isCancelledError)(error) || error?.cause?.problem === "CANCEL_ERROR") return;
            const previous = onMutateResult;
            if (previous && (previous.jobId != null || previous.videoPath != null)) updateVideo.mutate({
                status: previous.videoPath != null ? "completed" : "processing",
                jobId: previous.jobId,
                videoPath: previous.videoPath
            });
        }
    });
    // Create the video for this wizard run. Self-guarding so it can be called
    // unconditionally as part of the CAMPAIGN step's entering action (see
    // `DEFAULT_STEP_ACTIONS` in wizardSteps.js) instead of firing from a
    // `useEffect`. Accepts an optional `overrideId` for the case where the caller
    // has just generated the project id in the same tick (React state for it
    // hasn't propagated to this hook's `videoId` yet).
    const createVideoIfNeeded = (0, $eF4cA.useCallback)(async (overrideId, onSuccess)=>{
        if (!!video.data?.id) {
            onSuccess?.(video.data, {
                videoId: video.data.id
            });
            return;
        }
        const id = overrideId ?? videoId;
        // Resolve the ldap from the live store instead of the closure-captured
        // `userProfile`, which would be stale for the duration of this callback.
        const ldap = await (0, $fL0wx.getUserLdap)();
        const projectPath = `${ldap}/videos/${id}`;
        const data = {
            id: id,
            templateId: template.data?.id,
            templateType: template.data?.type,
            assetsTemplateId: template.data?.assetsTemplateId,
            name: `${customerName} \u{2014} ${template.data?.name ?? "BeStory Video"}`,
            projectPath: projectPath,
            accountName: accountName,
            drNumber: drNumber,
            customer: {
                name: customerName
            },
            hint: hint,
            product: product,
            assets: []
        };
        if (template.data?.id === "firefly-enterprise") data.include3DDigitalTwin = include3DDigitalTwin;
        if (template.data?.type === "express") data.expressTemplateId = template.data?.expressId;
        else if (template.data?.type === "mogrt" || template.data?.type === "modular") data.mogrtRootPath = template.data?.rootPath;
        if (!!template.data?.personas?.length) data.personaId = personaId;
        if (!!template.data?.verticals?.length) {
            console.log("Selected vertical key:", verticalKey, selectedVertical);
            data.verticalKey = verticalKey ?? template.data?.verticals?.find((vertical)=>vertical.isDefault)?.key ?? "fashion";
            const verticalAssets = template.data?.verticals?.find((vertical)=>vertical.key === data.verticalKey)?.assets;
            if (verticalAssets) data.assets.push(...verticalAssets);
        }
        createVideo.mutate(data, {
            onSuccess: (data, variables)=>{
                setIsVideoCreated(true);
                onCreateProject?.(data, variables);
                if (onSuccess) return onSuccess(data, variables);
            }
        });
    }, [
        createVideo.isIdle,
        createVideo.mutate,
        video.data?.id,
        videoId,
        personaId,
        verticalKey,
        selectedVertical,
        template.data,
        customerName,
        hint,
        product,
        include3DDigitalTwin,
        accountName,
        drNumber,
        onCreateProject
    ]);
    // Setup current step
    (0, $eF4cA.useEffect)(()=>{
        if (currentStep === null && (video.isSuccess || !video.isEnabled) && (template.isSuccess || !template.isEnabled) && !createVideo.isSuccess) {
            // Prefer the step from the URL: render it if ready, otherwise walk back to
            // the first ready step (a step's `enter.isReady`, or `true` when it has no
            // entering action). Unknown/disabled steps fall through to the data-driven
            // resolution below.
            if (routeStep) {
                const resolvedTemplateId = templateId ?? template.data?.id;
                const steps = (0, $lb17q.resolveSteps)(resolvedTemplateId, template.data);
                const startIndex = steps.findIndex((step)=>step.id === routeStep);
                if (startIndex !== -1) {
                    const readinessCtx = {
                        video: video,
                        template: template,
                        assetsTemplate: assetsTemplate,
                        selectedCampaign: video.data?.campaigns?.find((campaign)=>campaign.id === video.data?.selectedCampaignIds?.[0])
                    };
                    const isStepReady = (step)=>{
                        // An images step is where its variations are generated, so being
                        // "not ready" is its normal state — it stays reachable, and the
                        // step arms the generation itself.
                        if ((0, $lb17q.isImagesStep)(step)) return true;
                        const action = (0, $lb17q.getStepEnterAction)(step, resolvedTemplateId);
                        return action?.isReady ? action.isReady(readinessCtx) : true;
                    };
                    for(let index = startIndex; index >= 0; index -= 1)if (isStepReady(steps[index])) {
                        setCurrentStep(steps[index].id);
                        return;
                    }
                    setCurrentStep(steps[0].id);
                    return;
                }
            }
            if (video.data?.videoPath && (video.data?.templateType === "express" ? !!video.data?.expressId : true)) {
                // onSuccess?.(video.data);
                exportVideo.mutate({
                    videoId: video.data.id,
                    videoPath: video.data.videoPath
                });
                setCurrentStep((0, $lb17q.WIZARD_STEP).GENERATE_VIDEO);
            } else if (video.data?.jobId || video.data?.modularJobs?.length) setCurrentStep((0, $lb17q.WIZARD_STEP).GENERATE_VIDEO);
            else if (video.data?.templateAssetsRenditions?.length && (0, $lb17q.hasBannersStep)(template.data)) setCurrentStep((0, $lb17q.WIZARD_STEP).BANNERS);
            else if ((0, $lb17q.hasImageVariationsStep)(template.data) && template.data?.imageVariations?.some((variation)=>video.data?.assets?.some((a)=>a.name === variation.key))) // Resume at the first stage that still has variations to generate.
            setCurrentStep((0, $lb17q.getResumeImagesStepId)(templateId ?? template.data?.id, template.data, video.data) ?? (0, $lb17q.WIZARD_STEP).IMAGES);
            else if (video.data?.selectedCampaignIds?.length) {
                if ((0, $lb17q.hasAudioStep)(template.data) && !template.data?.assets?.filter((asset)=>asset.type === "audio")?.every((asset)=>video.data?.assets?.find((a)=>a.name === asset.name))) setCurrentStep((0, $lb17q.WIZARD_STEP).VOICEOVER);
                else setCurrentStep((0, $lb17q.WIZARD_STEP).BRANDING);
            } else if (video.data?.customer?.name) setCurrentStep((0, $lb17q.WIZARD_STEP).CAMPAIGN);
            else if (video.data?.templateId) setCurrentStep((0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS);
            else if (templateId) {
                // A template was preselected before any video exists (e.g. picked on the
                // home page). Skip template selection — jump straight to customer details
                // when account details were already provided, otherwise collect them.
                const hasAccountDetails = sfType === "none" || !!accountName || !!drNumber;
                setCurrentStep(hasAccountDetails ? (0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS : (0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS);
            } else setCurrentStep((0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE);
        }
    }, [
        video.isSuccess,
        templates.isSuccess,
        template.isSuccess,
        createVideo.isSuccess,
        routeStep
    ]);
    // Track video wizard events
    (0, $eF4cA.useEffect)(()=>{
        (0, $dSkgb.trackVideoWizard)({
            isConversion: false,
            project: {
                id: video.data?.id,
                name: video.data?.name,
                expressId: video.data?.expressId,
                videoPath: video.data?.videoPath
            },
            step: (0, $lb17q.getStepName)(template.data?.id ?? templateId, currentStep, template.data),
            customer: {
                name: video.data?.customer?.name,
                industry: video.data?.customer?.industry,
                drNumber: video.data?.drNumber,
                accountName: video.data?.accountName || accountName || undefined
            },
            user: {
                email: userProfile?.email
            }
        });
    }, [
        currentStep
    ]);
    const handleCustomerNameChange = (0, $eF4cA.useCallback)((name)=>{
        updateVideo.mutate({
            name: `${name} \u{2014} ${expressTemplate.data?.pages?.[0]?.name ?? "BeStory Project"}`,
            // Trigger campaign regeneration
            customer: {
                name: name
            },
            assets: [],
            campaigns: [],
            selectedCampaignIds: []
        });
    }, [
        updateVideo.mutate,
        expressTemplate.data?.pages
    ]);
    const debouncedHandleCustomerNameChange = (0, $HE3sn.useDebounce)(handleCustomerNameChange, 1000);
    // Update customer name
    (0, $eF4cA.useEffect)(()=>{
        if (video.isEnabled && video.isSuccess && customerName && video.data?.customer?.name !== customerName) debouncedHandleCustomerNameChange(customerName);
    }, [
        video.isEnabled,
        video.isSuccess,
        customerName,
        updateCustomer.mutate,
        expressTemplate.data?.pages
    ]);
    // Update persona
    // useEffect(() => {
    //   if (
    //     video.isSuccess &&
    //     video.data?.templateId === "ucx" &&
    //     typeof personaId !== "undefined" &&
    //     video.data?.personaId !== personaId
    //   ) {
    //     updateVideo.mutate({
    //       personaId,
    //       // Trigger campaign regeneration
    //       customer: {
    //         name: video.data?.customer?.name,
    //       },
    //       assets: [],
    //       campaigns: [],
    //       selectedCampaignIds: [],
    //     });
    //   }
    // }, [
    //   video.isSuccess,
    //   video.data,
    //   personaId,
    //   customerBranding.isEnabled,
    //   updateVideo.mutate,
    // ]);
    // Set brand color asset if missing
    // useEffect(() => {
    //   if (
    //     video.isEnabled &&
    //     video.isSuccess &&
    //     !video.data?.assets?.some((a) => a.name === "Brand-color")
    //   ) {
    //     const color =
    //       video.data?.customer?.color ||
    //       customerBranding.data?.pages?.[0]?.customer?.color;
    //     if (color) {
    //       updateAssets.mutate({
    //         assets: [
    //           {
    //             name: "Brand-color",
    //             type: "color",
    //             color: color,
    //           },
    //         ],
    //       });
    //     }
    //   }
    // }, [
    //   video.isEnabled,
    //   video.isSuccess,
    //   video.data?.assets,
    //   customerBranding.data,
    //   updateAssets.mutate,
    // ]);
    const scrapedAssets = scrapeQueries.flatMap((query)=>query.data || []);
    // Update logo asset
    (0, $eF4cA.useEffect)(()=>{
        if (template.isSuccess && !!template.data?.assets?.some((asset)=>asset.name === "Logo") && video.isSuccess && !video.data?.assets?.some((asset)=>asset.name === "Logo") && !uploadAssets.isPending) {
            const scrapedLogo = scrapedAssets.find((asset)=>asset?.isLogo) ?? scrapedAssets.find((asset)=>{
                const { alt: alt, src: src } = asset || {};
                const fileName = (src?.split("/").pop().toLowerCase() || "").replaceAll(/[\W_]+/g, " ");
                const _customerName = video.data?.customer?.name?.toLowerCase().replaceAll(/[\W_]+/g, " ");
                return [
                    alt,
                    fileName
                ].some((str)=>[
                        /* _customerName,  */ "logo"
                    ].some((term)=>str?.includes(term)));
            });
            if (scrapedLogo) uploadAssets.mutate({
                assets: [
                    {
                        name: "Logo",
                        type: "image",
                        src: scrapedLogo.src,
                        size: {
                            width: scrapedLogo.width,
                            height: scrapedLogo.height
                        }
                    }
                ]
            });
        }
    }, [
        template.isSuccess,
        template.data?.assets,
        video.isSuccess,
        video.data?.assets,
        video.data?.customer?.name,
        scrapedAssets,
        uploadAssets.isMutating,
        uploadAssets.mutate
    ]);
    const [generateStatusText, setGenerateStatusText] = (0, $eF4cA.useState)($0744e5ee275e1594$export$39027ab9e2e75266);
    // Set additional status text for Express videos
    (0, $eF4cA.useEffect)(()=>{
        if (video.data?.templateType === "express") setGenerateStatusText((prev)=>[
                ...prev,
                "Preparing editable Express file"
            ]);
        else if (generateStatusText.includes("Preparing editable Express file")) setGenerateStatusText((prev)=>prev.filter((text)=>text !== "Preparing editable Express file"));
    }, [
        video.data?.templateType
    ]);
    return {
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        video: video,
        createVideo: createVideo,
        createVideoIfNeeded: createVideoIfNeeded,
        updateVideo: updateVideo,
        updateCustomer: updateCustomer,
        updateAssets: updateAssets,
        uploadAssets: uploadAssets,
        templates: templates,
        template: {
            ...template,
            hasAudioStep: $lb17q.hasAudioStep
        },
        assetsTemplate: assetsTemplate,
        drNumbers: drNumbers,
        accounts: accounts,
        personas: personas,
        selectedPersona: selectedPersona,
        setSelectedPersona: setSelectedPersona,
        verticals: verticals,
        selectedVertical: selectedVertical,
        setSelectedVertical: setSelectedVertical,
        include3DDigitalTwin: include3DDigitalTwin,
        setInclude3DDigitalTwin: setInclude3DDigitalTwin,
        customerBranding: customerBranding,
        addCampaign: addCampaign,
        editCampaign: editCampaign,
        scrapeQueries: scrapeQueries,
        searchImagesQueries: searchImagesQueries,
        appStoreQuery: appStoreQuery,
        productSearchQuery: productSearchQuery,
        bannersStatus: // taglines,
        bannersStatus,
        generateBanners: generateBanners,
        exportBanners: exportBanners,
        generateVideo: generateVideo,
        generateStatusText: generateStatusText,
        renderProgress: renderMogrtTemplate.progress,
        exportVideo: exportVideo,
        describeMogrtTemplate: describeMogrtTemplate,
        describeModularTemplate: describeModularTemplate
    };
};
async function $0744e5ee275e1594$var$buildMogrtFormValues(controls, context) {
    const promises = controls.map((control)=>{
        if (![
            "text",
            "media",
            "dropdown",
            "audio",
            "slider"
        ].includes(control.type)) return null;
        const [, mediaLabel] = /^GREEN-(.*)\.\w{3,4}$/i.exec(control.label) ?? [];
        let name, type = control.type;
        switch(control.type){
            case "text":
            case "dropdown":
            case "slider":
            case "audio":
                name = control.label;
                break;
            case "media":
                name = mediaLabel ?? control.label;
                type = "image";
                break;
            default:
                return null;
        }
        return {
            variableId: control.variableId,
            name: name,
            type: type
        };
    }).map(async (tag)=>{
        if (!tag) return null;
        const value = await $0744e5ee275e1594$var$mapTaggedValue("mogrt", tag, context);
        if (value == null) return null;
        return {
            [tag.variableId]: value
        };
    });
    return (await Promise.allSettled(promises)).map((r)=>r.status === "fulfilled" && r.value ? r.value : null).filter(Boolean).reduce((acc, curr)=>({
            ...acc,
            ...curr
        }), {});
}
async function $0744e5ee275e1594$var$mapTaggedValue(type, element, { customerName: customerName, selectedCampaign: selectedCampaign, banners: banners, assets: assets, queryClient: queryClient, audioVariations: audioVariations, customer: customer, musicPath: musicPath }) {
    let assetBaseName = element.name.split("#")[0].trim();
    if (assets.some((a)=>a.name === element.name && !!a?.isSkipped)) return null;
    if (element.type === "text") {
        let value = selectedCampaign?.[assetBaseName];
        if (!value) switch(assetBaseName){
            case "Customer-name":
                value = customerName;
                break;
            case "Campaign-name-1":
                // value =
                //   video.data?.audiencesVariations?.[0]?.campaignTitle || "";
                value = selectedCampaign?.taglines?.[0]?.name ?? `${customerName} Boost campaign`;
                break;
            case "Campaign-name-2":
                // value =
                //   video.data?.audiencesVariations?.[1]?.campaignTitle || "";
                value = selectedCampaign?.taglines?.[1]?.name ?? `${customerName} Winter campaign`;
                break;
            case "Campaign-name-3":
                // value =
                //   video.data?.audiencesVariations?.[2]?.campaignTitle || "";
                value = selectedCampaign?.taglines?.[2]?.name ?? `${customerName} Social campaign`;
                break;
            case "Campaign-tagline-1":
                value = selectedCampaign?.taglines?.[0]?.en || "";
                break;
            case "Campaign-tagline-1-Spanish":
                value = selectedCampaign?.taglines?.[0]?.es || "";
                break;
            case "Campaign-tagline-2":
                value = selectedCampaign?.taglines?.[1]?.en || "";
                break;
            case "Campaign-tagline-3":
                value = selectedCampaign?.taglines?.[2]?.en || "";
                break;
            case "CTA":
                value = "DISCOVER";
                break;
            case "CTA-Spanish":
                value = "DESCUBRIR";
                break;
            case "CTA-final":
                break;
        }
        // Brand/secondary colors live on the customer (as hex). Fill a text control
        // like "Brand-color" with that value, stripping a leading "#" to match the
        // mogrt default's no-"#" format (e.g. "584CCC").
        if (!value && customer?.[assetBaseName]) value = String(customer[assetBaseName]).replace(/^#/, "");
        // TODO: handle text tags
        return !!value ? type === "express" ? {
            [element.name]: value
        } : value : null;
    }
    if (element.type === "dropdown") return selectedCampaign?.[assetBaseName] ?? 0;
    if (element.type === "slider") {
        let altName = assetBaseName;
        let shouldConvertToRGB = false;
        if (element.name.startsWith("Brand-color")) {
            altName = "Brand-color";
            shouldConvertToRGB = true;
        }
        if (element.name.startsWith("Secondary-color")) {
            altName = "Secondary-color";
            shouldConvertToRGB = true;
        }
        let raw = assets?.find((a)=>a.name === altName)?.color ?? customer?.[altName] ?? selectedCampaign?.[altName];
        if (raw == null || raw === "") return null;
        if (shouldConvertToRGB) {
            const rgb = (0, $kQT4E.parseColor)(raw).toFormat("rgb");
            if (element.name.includes("--R")) raw = rgb.getChannelValue("red");
            else if (element.name.includes("--G")) raw = rgb.getChannelValue("green");
            else if (element.name.includes("--B")) raw = rgb.getChannelValue("blue");
        }
        let num;
        if (typeof raw === "number" && Number.isFinite(raw)) num = Math.round(raw);
        else {
            const s = String(raw).trim().replace(/,/g, "");
            const kMatch = s.match(/^([\d.]+)\s*k\s*$/i);
            const parsed = kMatch ? parseFloat(kMatch[1]) * 1000 : parseFloat(s);
            if (!Number.isFinite(parsed)) return null;
            num = Math.round(parsed);
        }
        return type === "express" ? {
            [element.name]: num
        } : num;
    }
    if (element.type === "image") {
        let altName;
        const isLogo = element.name.startsWith("Customer-logo") || element.name.startsWith("Company-logo") || element.name.toLowerCase().startsWith("logo");
        if (isLogo) assetBaseName = "Logo_cropped";
        else if (element.name.startsWith("App-icon")) altName = "App-icon-cropped";
        const elementName = element.name.replace(/\..*$/, "").trim();
        // A banner asset name may carry a trailing dot the control label does not
        // (or vice versa); ignore it when matching.
        const stripTrailingDot = (name)=>(name ?? "").replace(/\.$/, "");
        const matchedAsset = (!!altName ? banners?.find((banner)=>banner.name === altName) : undefined) ?? banners?.find((banner)=>stripTrailingDot(banner.name) === stripTrailingDot(assetBaseName)) ?? assets?.find((a)=>a.name === elementName) ?? assets?.find((a)=>a.name === assetBaseName) ?? (isLogo ? assets?.find((a)=>a.name?.toLowerCase() === "logo") : undefined);
        if (!matchedAsset) return null;
        if (matchedAsset.url) {
            if (type === "express") return {
                [element.name]: matchedAsset.url
            };
            return {
                url: matchedAsset.url
            };
        }
        const s3Asset = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(matchedAsset.filePath));
        return type === "express" ? {
            [element.name]: s3Asset.presignURL
        } : {
            url: s3Asset.presignURL
        };
    }
    if (element.type === "audio") {
        const variation = audioVariations?.find((v)=>v.label === element.name) ?? audioVariations?.[0];
        let matchedAsset;
        if (variation) matchedAsset = assets?.find((a)=>a.type === "audio" && a.name === variation.key);
        if (!matchedAsset) {
            if (musicPath) {
                const s3Music = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(musicPath));
                return type === "express" ? {
                    [element.name]: s3Music.presignURL
                } : {
                    url: s3Music.presignURL
                };
            }
            return null;
        }
        if (matchedAsset.url) return {
            url: matchedAsset.url
        };
        const s3Asset = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(matchedAsset.filePath));
        return type === "express" ? {
            [element.name]: s3Asset.presignURL
        } : {
            url: s3Asset.presignURL
        };
    }
}

});
parcelRegister("kQhl7", function(module, exports) {

$parcel$export(module.exports, "useIsMutating", () => $f2c61d49f20cad37$export$32cc39cf62abf4fc);
$parcel$export(module.exports, "useMutationState", () => $f2c61d49f20cad37$export$29ea95f3fea1dc1c);

var $7ClmI = parcelRequire("7ClmI");

var $eF4cA = parcelRequire("eF4cA");

var $hnhg4 = parcelRequire("hnhg4");
var $3ur2P = parcelRequire("3ur2P");
"use client";
//#region src/useMutationState.ts
/**
* The `useIsMutating` hook returns the `number` of mutations that your application currently has `pending`
* (useful for app-wide loading indicators).
* @param filters - The {@link MutationFilters} to narrow down the matched mutations.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns Will be the `number` of the mutations that your application currently has `pending`.
* @example
* ```tsx
* import { useIsMutating } from '@tanstack/react-query'
*
* function PostsMutatingIndicator() {
*   // How many mutations matching the posts prefix are in progress?
*   const isMutatingPosts = useIsMutating({ mutationKey: ['posts'] })
*
*   return isMutatingPosts ? <span>Saving posts...</span> : null
* }
* ```
*/ function $f2c61d49f20cad37$export$32cc39cf62abf4fc(filters, queryClient) {
    const client = (0, $7ClmI.useQueryClient)(queryClient);
    return $f2c61d49f20cad37$export$29ea95f3fea1dc1c({
        filters: {
            ...filters,
            status: "pending"
        }
    }, client).length;
}
/**
* Creates snapshot getters that share equal selected results across renders.
* A new getter is created on each render. Each getter caches its snapshot until the matching mutations
* or their states change.
* @returns A factory for snapshot getters with a shared result cache.
*/ function $f2c61d49f20cad37$var$createSnapshotFactory() {
    let previousResult;
    return (mutationCache, options)=>{
        let inputs = [];
        let snapshot;
        return ()=>{
            const mutations = mutationCache.findAll(options.filters);
            const nextInputs = mutations.flatMap((mutation)=>[
                    mutation,
                    mutation.state
                ]);
            if (!snapshot || nextInputs.length !== inputs.length || nextInputs.some((input, index)=>!Object.is(input, inputs[index]))) {
                inputs = nextInputs;
                snapshot = (0, $3ur2P.replaceEqualDeep)(previousResult, mutations.map((mutation)=>options.select ? options.select(mutation) : mutation.state));
                previousResult = snapshot;
            }
            return snapshot;
        };
    };
}
/**
* `useMutationState` is a hook that gives you access to all mutations in the `MutationCache`. You can pass
* `filters` ({@link MutationFilters}) to narrow down your mutations, and `select` to transform the mutation
* state.
* @param options - The `filters` to narrow down matched mutations, and an optional `select` to transform the
* mutation state.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns Will be an Array of whatever `select` returns for each matching mutation.
* @example
* Get all variables of all running mutations:
* ```tsx
* import { useMutationState } from '@tanstack/react-query'
*
* function PendingPosts() {
*   const pendingVariables = useMutationState({
*     filters: { status: 'pending' },
*     select: (mutation) => mutation.state.variables,
*   })
*
*   return <>{pendingVariables.length} posts saving...</>
* }
* ```
* @example
* Get all data for specific mutations via the `mutationKey`:
* ```tsx
* import { useMutation, useMutationState } from '@tanstack/react-query'
*
* const mutationKey = ['posts']
*
* function Posts() {
*   // Some mutation that we want to get the state for
*   const mutation = useMutation({
*     mutationKey,
*     mutationFn: createPosts,
*   })
*
*   const savedPosts = useMutationState({
*     // this mutation key needs to match the mutation key of the given mutation (see above)
*     filters: { mutationKey, status: 'success' },
*     select: (mutation) => mutation.state.data,
*   })
*
*   return (
*     <button onClick={() => mutation.mutate(['New Post'])}>
*       Create post ({savedPosts.length} saved so far)
*     </button>
*   )
* }
* ```
* @example
* Access the latest successful mutation data via the `mutationKey`. Each invocation of `mutate` adds a new
* entry to the mutation cache for `gcTime` milliseconds — with the `status: 'success'` filter below, check the
* last item that `useMutationState` returns to get the latest successful invocation:
* ```tsx
* import { useMutationState } from '@tanstack/react-query'
*
* function LatestPost() {
*   const savedPosts = useMutationState({
*     filters: { mutationKey: ['posts'], status: 'success' },
*     select: (mutation) => mutation.state.data,
*   })
*
*   const latestSavedPost = savedPosts[savedPosts.length - 1]
*
*   return <>{latestSavedPost ? 'Saved' : 'Nothing saved yet'}</>
* }
* ```
*/ function $f2c61d49f20cad37$export$29ea95f3fea1dc1c(options = {}, queryClient) {
    const mutationCache = (0, $7ClmI.useQueryClient)(queryClient).getMutationCache();
    const [createSnapshot] = $eF4cA.useState(()=>$f2c61d49f20cad37$var$createSnapshotFactory());
    const getSnapshot = createSnapshot(mutationCache, options);
    return $eF4cA.useSyncExternalStore($eF4cA.useCallback((onStoreChange)=>mutationCache.subscribe((0, $hnhg4.notifyManager).batchCalls(onStoreChange)), [
        mutationCache
    ]), getSnapshot, getSnapshot);
}

});

parcelRegister("dzLiJ", function(module, exports) {

$parcel$export(module.exports, "searchAppStore", () => $9e233c4144a8616f$export$e588c113f06a9f23);

var $fHV62 = parcelRequire("fHV62");
const $9e233c4144a8616f$export$5272fd100cd4ef15 = (0, $fHV62.createApiClient)("https://itunes.apple.com/");
const $9e233c4144a8616f$export$e588c113f06a9f23 = async ({ term: term, media: media = "software", country: country = "US", limit: limit = 5 } = {}, options = {})=>{
    const response = await $9e233c4144a8616f$export$5272fd100cd4ef15.get("search", {
        term: term,
        media: media,
        country: country,
        limit: limit
    }, options);
    if (!response.ok) throw new Error("Failed to search App Store", {
        cause: response.data
    });
    return response.data;
};

});

parcelRegister("dSkgb", function(module, exports) {

$parcel$export(module.exports, "usePageTracking", () => $a1a008c068054eed$export$e113eba4f47a8c1a);
$parcel$export(module.exports, "trackVideoWizard", () => $a1a008c068054eed$export$2bd7b3c3ecbbdaa0);

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $10EHz = parcelRequire("10EHz");
parcelRequire("dFfaH");
var $hpQib = parcelRequire("hpQib");
var $5uQ6L = parcelRequire("5uQ6L");
var $lhjTh = parcelRequire("lhjTh");
let $a1a008c068054eed$var$globalTrackingInitialized = false;
let $a1a008c068054eed$var$globalPreviousPath = null;
/**
 * Helper to convert value to string
 * @param {any} value - The value to convert
 * @returns {string} The string value
 */ const $a1a008c068054eed$var$toString = (value)=>String(value);
const $a1a008c068054eed$export$e113eba4f47a8c1a = ()=>{
    const location = (0, $dqZbZ.useLocation)();
    const alloyLoadedRef = (0, $eF4cA.useRef)(false);
    const ims = (0, $10EHz.useStore)((state)=>state.ims);
    const initializeAnalyticsAndTrack = async ()=>{
        if (typeof window !== "undefined" && !alloyLoadedRef.current) try {
            if (!(0, $5uQ6L.isAlloyReady)()) {
                await (0, $5uQ6L.initAnalytics)();
                console.log("Adobe Alloy SDK initialized successfully");
            }
            alloyLoadedRef.current = true;
            trackInitialPageView();
        } catch (error) {
            console.error("Failed to initialize Adobe Alloy SDK:", error);
        }
    };
    const trackInitialPageView = ()=>{
        const currentPath = location.pathname;
        if ($a1a008c068054eed$var$globalPreviousPath === currentPath) return;
        $a1a008c068054eed$var$globalPreviousPath = currentPath;
        let additionalData = {
            pageName: currentPath === "/" ? "Home" : currentPath,
            user: {
                email: ims.profile?.email
            }
        };
        if (currentPath.startsWith("/stories/")) {
            const storyId = currentPath.split("/")[2];
            additionalData.pageName = `Story View - ${storyId}`;
        } else if (currentPath === "/stories") additionalData.pageName = "Stories List";
        else if (currentPath === "/projects") additionalData.pageName = "Videos";
        else if (currentPath === "/projects/new") additionalData.pageName = "Create Video";
        else if (currentPath.startsWith("/projects/new/")) {
            const pathParts = currentPath.split("/");
            additionalData.pageName = `New Video`;
            additionalData.videoId = pathParts[3];
        } else if (currentPath.startsWith("/projects/")) {
            const pathParts = currentPath.split("/");
            additionalData.pageName = `Video`;
            additionalData.videoId = pathParts[2];
        } else if (currentPath.startsWith("/templates/")) {
            const pathParts = currentPath.split("/");
            const templateId = pathParts[2];
            additionalData.pageName = `Template - ${templateId}`;
        } else if (currentPath === "/templates") additionalData.pageName = "Templates";
        else if (currentPath === "/admin/mogrt") additionalData.pageName = "Generate Video";
        else if (currentPath === "/admin/crop-image") additionalData.pageName = "Crop Image";
        else if (currentPath === "/_copilot") additionalData.pageName = "Copilot";
        else if (currentPath === "/admin/smart-crop") additionalData.pageName = "Smart Crop";
        trackPageView(additionalData);
    };
    /**
   * Track page view using Adobe Alloy
   *
   * @param {Object} data
   */ const trackPageView = (data = {})=>{
        if (typeof window !== "undefined" && data?.user?.email) try {
            if ((0, $5uQ6L.isAlloyReady)()) {
                const props = {
                    [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).USER_EMAIL]]: $a1a008c068054eed$var$toString(data.user.email),
                    [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).TIMESTAMP]]: $a1a008c068054eed$var$toString(new Date().toISOString()),
                    [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).PAGE_NAME]]: $a1a008c068054eed$var$toString(data.pageName || "Unknown Page"),
                    [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).PAGE_URL]]: $a1a008c068054eed$var$toString(window.location.href),
                    [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).REFERRER_URL]]: $a1a008c068054eed$var$toString(document.referrer)
                };
                if (data.videoId) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VIDEO_ID]] = $a1a008c068054eed$var$toString(data.videoId);
                (0, $lhjTh.trackEvent)((0, $hpQib.eventMap)[(0, $hpQib.AnalyticsEventNames).PAGE_VIEW], props);
            }
        } catch (error) {
            console.error("Failed to track page view:", error);
        }
    };
    (0, $eF4cA.useEffect)(()=>{
        initializeAnalyticsAndTrack();
    }, []);
    (0, $eF4cA.useEffect)(()=>{
        if (!alloyLoadedRef.current || !(0, $5uQ6L.isAlloyReady)()) return;
        trackInitialPageView();
    }, [
        location.pathname,
        ims
    ]);
    return {
        trackPageView: trackPageView,
        trackVideoWizard: $a1a008c068054eed$export$2bd7b3c3ecbbdaa0,
        isTrackingReady: ()=>alloyLoadedRef.current && typeof window !== "undefined" && (0, $5uQ6L.isAlloyReady)()
    };
};
const $a1a008c068054eed$export$2bd7b3c3ecbbdaa0 = (videoData = {})=>{
    if (typeof window !== "undefined" && videoData?.user?.email) try {
        if ((0, $5uQ6L.isAlloyReady)()) {
            console.log("Tracking video wizard event", videoData);
            const props = {
                [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).USER_EMAIL]]: $a1a008c068054eed$var$toString(videoData.user.email),
                [(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).TIMESTAMP]]: $a1a008c068054eed$var$toString(new Date().toISOString())
            };
            if (videoData.step) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VIDEO_STEP]] = $a1a008c068054eed$var$toString(videoData.step);
            if (videoData.project?.id) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VIDEO_ID]] = $a1a008c068054eed$var$toString(videoData.project.id);
            if (videoData.project?.name) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VIDEO_NAME]] = $a1a008c068054eed$var$toString(videoData.project.name);
            if (videoData.project?.videoPath) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).VIDEO_PATH]] = $a1a008c068054eed$var$toString(videoData.project.videoPath);
            if (videoData.project?.expressId) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).EXPRESS_ID]] = $a1a008c068054eed$var$toString(videoData.project.expressId);
            if (videoData.customer?.name) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).CUSTOMER_NAME]] = $a1a008c068054eed$var$toString(videoData.customer.name);
            if (videoData.customer?.industry) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).CUSTOMER_INDUSTRY]] = $a1a008c068054eed$var$toString(videoData.customer.industry);
            if (videoData.customer?.drNumber) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).CUSTOMER_DR_NUMBER]] = $a1a008c068054eed$var$toString(videoData.customer.drNumber);
            if (videoData.customer?.accountName && videoData.customer.accountName.trim()) props[(0, $hpQib.variableMap)[(0, $hpQib.AnalyticsVariableNames).ACCOUNT_NAME]] = $a1a008c068054eed$var$toString(videoData.customer.accountName);
            const eventName = videoData.isConversion ? (0, $hpQib.AnalyticsEventNames).VIDEO_WIZARD_CONVERSION : (0, $hpQib.AnalyticsEventNames).VIDEO_WIZARD_STEP;
            (0, $lhjTh.trackEvent)((0, $hpQib.eventMap)[eventName], props);
        }
    } catch (error) {
        console.error("Failed to track video event:", error);
    }
};

});
parcelRegister("10EHz", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $0bc55d0e406df002$export$6ccbb43953eebf8);

var $5IZkx = parcelRequire("5IZkx");

var $fmJ8d = parcelRequire("fmJ8d");
function $0bc55d0e406df002$export$6ccbb43953eebf8(selector) {
    return (0, $5IZkx.useStore)((0, $fmJ8d.store), selector);
}

});


parcelRegister("fK5Xl", function(module, exports) {

$parcel$export(module.exports, "expressTemplateKey", () => $b75fc5a98b95baed$export$4850392fa73ccc2);
$parcel$export(module.exports, "useExpressTemplates", () => $b75fc5a98b95baed$export$230377524d2ee5a1);
$parcel$export(module.exports, "useExpressTemplate", () => $b75fc5a98b95baed$export$4a3b90781c7a4d29);
$parcel$export(module.exports, "useExpressPollStatus", () => $b75fc5a98b95baed$export$437f2aa15a362b37);
$parcel$export(module.exports, "useGenerateVariation", () => $b75fc5a98b95baed$export$79be5c8ce7f31714);
$parcel$export(module.exports, "useExportRendition", () => $b75fc5a98b95baed$export$629f306924f818fa);

var $eF4cA = parcelRequire("eF4cA");

var $iFK2s = parcelRequire("iFK2s");
var $k6waQ = parcelRequire("k6waQ");

var $6Njts = parcelRequire("6Njts");

var $cYxTU = parcelRequire("cYxTU");

var $8oFcj = parcelRequire("8oFcj");

var $ikOQe = parcelRequire("ikOQe");

var $D7J7L = parcelRequire("D7J7L");
const $b75fc5a98b95baed$export$4850392fa73ccc2 = {
    all: [
        "expressTemplates"
    ],
    lists: ()=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.all,
            "list"
        ],
    list: (filters)=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.lists(),
            {
                filters: filters
            }
        ],
    details: ()=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.all,
            "detail"
        ],
    detail: (id)=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.details(),
            id
        ],
    exports: ()=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.all,
            "export"
        ],
    export: (id, format = "any")=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.exports(),
            id,
            format
        ],
    statuses: ()=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.all,
            "status"
        ],
    status: (jobId)=>[
            ...$b75fc5a98b95baed$export$4850392fa73ccc2.statuses(),
            jobId
        ]
};
const $b75fc5a98b95baed$export$230377524d2ee5a1 = (options = {}, filters)=>{
    const query = (0, $iFK2s.useInfiniteQuery)({
        queryKey: $b75fc5a98b95baed$export$4850392fa73ccc2.list(filters),
        queryFn: ({ pageParam: pageParam, signal: signal })=>$6Njts.getTaggedDocuments({
                nextUrl: pageParam,
                filters: filters
            }, {
                signal: signal
            }),
        initialPageParam: `/beta/tagged-documents?${new URLSearchParams({
            start: 0,
            limit: 25
        })}`,
        getNextPageParam: (lastPage)=>{
            if (lastPage?.paging?.nextUrl) {
                const nextUrl = new URL(lastPage.paging.nextUrl);
                return nextUrl.pathname + nextUrl.search;
            }
            return null;
        },
        ...options,
        staleTime: 1800000,
        meta: {
            errorMessage: "Failed to load templates. Please try again."
        }
    });
    // Automatically fetch the next page when available
    (0, $eF4cA.useEffect)(()=>{
        if (!query.isFetching && query.hasNextPage) query.fetchNextPage();
    }, [
        query.isFetching,
        query.hasNextPage,
        query.fetchNextPage
    ]);
    return query;
};
const $b75fc5a98b95baed$export$4a3b90781c7a4d29 = (id, options = {})=>{
    const query = (0, $iFK2s.useInfiniteQuery)({
        queryKey: $b75fc5a98b95baed$export$4850392fa73ccc2.detail(id),
        queryFn: ({ pageParam: pageParam, signal: signal })=>$6Njts.getTaggedDocument({
                docId: id,
                nextUrl: pageParam
            }, {
                signal: signal
            }),
        initialPageParam: `/beta/tagged-documents/${id}?${new URLSearchParams({
            start: 1,
            limit: 10
        })}`,
        getNextPageParam: (lastPage)=>{
            if (lastPage?.paging?.nextUrl) {
                const nextUrl = new URL(lastPage.paging.nextUrl);
                return nextUrl.pathname + nextUrl.search;
            }
            return null;
        },
        staleTime: 1800000,
        enabled: !!id,
        meta: {
            errorMessage: "Failed to load template. Please try again."
        },
        ...options
    });
    // Automatically fetch the next page when available
    (0, $eF4cA.useEffect)(()=>{
        if (!query.isFetching && query.hasNextPage) query.fetchNextPage();
    }, [
        query.isFetching,
        query.hasNextPage,
        query.fetchNextPage
    ]);
    return query;
};
const $b75fc5a98b95baed$export$437f2aa15a362b37 = ()=>{
    return (0, $k6waQ.useMutation)({
        // queryKey: expressTemplateKey.status(jobId),
        mutationFn: ({ jobId: jobId, interval: interval = 2000 }, { signal: signal })=>$6Njts.pollStatus(jobId, interval, {
                signal: signal
            }),
        meta: {
            errorMessage: "Failed to get status. Please try again."
        }
    });
};
const $b75fc5a98b95baed$export$79be5c8ce7f31714 = ()=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async ({ batchSize: batchSize, ...payload }, { signal: signal })=>{
            const entries = Object.entries(payload.variationDetails?.tagMappings ?? {});
            if (!batchSize || entries.length <= batchSize) {
                const data = await $6Njts.generateVariation(payload, {
                    signal: signal
                });
                return $6Njts.pollStatus(data.jobId, 2000, {
                    signal: signal
                });
            }
            // Express times out on large tag sets; apply them in chunks, each on top of the previous result document.
            let id = payload.id;
            let result;
            for(let i = 0; i < entries.length; i += batchSize){
                const batchPayload = {
                    ...payload,
                    id: id,
                    variationDetails: {
                        ...payload.variationDetails,
                        tagMappings: Object.fromEntries(entries.slice(i, i + batchSize))
                    }
                };
                // A freshly generated document fails as input for ~4 minutes; wait that long, then retry every 2 minutes.
                for(let attempt = 0;; attempt++){
                    if (i > 0 || attempt > 0) {
                        await new Promise((resolve)=>setTimeout(resolve, attempt === 0 ? 240000 : 120000));
                        signal?.throwIfAborted();
                    }
                    try {
                        const data = await $6Njts.generateVariation(batchPayload, {
                            signal: signal
                        });
                        result = await $6Njts.pollStatus(data.jobId, 2000, {
                            signal: signal
                        });
                        break;
                    } catch (error) {
                        if (signal?.aborted || attempt >= 3) throw error;
                    }
                }
                id = result.document.id;
            }
            return result;
        },
        // retry: false,
        meta: {
            errorMessage: "Failed to generate variation. Please try again."
        }
    });
};
const $b75fc5a98b95baed$export$629f306924f818fa = ()=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async (payload, { signal: signal })=>{
            const data = await $6Njts.exportRendition(payload, {
                signal: signal
            });
            return $6Njts.pollStatus(data.jobId, 2000, {
                signal: signal
            });
        },
        // retry: false,
        meta: {
            errorMessage: "Failed to export rendition. Please try again."
        }
    });
};
const $b75fc5a98b95baed$export$38968534fd598b5 = ()=>{
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (payload)=>{
            // Step 1: Initiate merge
            const { jobId: jobId } = await (0, $cYxTU.mergeVideos)({
                videoUrls: payload.videoUrls,
                timestamps: payload.timestamps,
                s3Path: payload.s3Path
            });
            // Step 2: Poll for merge status
            const mergeStatus = await (0, $8oFcj.jobsPollStatus)({
                jobId: jobId
            });
            return mergeStatus;
        },
        meta: {
            errorMessage: "Failed to merge videos. Please try again."
        }
    });
    return mutation;
};
const $b75fc5a98b95baed$export$bb5a212cf9b373aa = ()=>{
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (filePath)=>{
            const presignData = await (0, $D7J7L.fetchPresignURL)(filePath);
            return presignData;
        },
        meta: {
            errorMessage: "Failed to fetch presigned URL. Please try again."
        }
    });
    return mutation;
};
const $b75fc5a98b95baed$export$29ac35f621e3103f = (id)=>{
    const updateVideo = (0, $ikOQe.useUpdateVideo)(id);
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (payload, { signal: signal })=>{
            const variationDetailsArray = Array.isArray(payload.variationDetails) ? payload.variationDetails : [
                payload.variationDetails
            ];
            // Generate variations for each item in parallel
            const variationResults = await Promise.all(variationDetailsArray.map((details)=>$6Njts.generateVariation({
                    id: payload.id,
                    variationDetails: details
                }, {
                    signal: signal
                })));
            // Process each variation in parallel
            const videoUrls = await Promise.all(variationResults.map(async (variationResult, index)=>{
                // Step 1: Poll for generation status
                const generateStatus = await $6Njts.pollStatus(variationResult.jobId, 2000, {
                    signal: signal
                });
                // Step 2: Update video with expressId (only for first variation)
                if (index === 0) await updateVideo.mutateAsync({
                    expressId: generateStatus.document.id
                });
                // Step 3: Export rendition
                const exportResult = await $6Njts.exportRendition({
                    id: generateStatus.document.id,
                    pages: "1",
                    options: {
                        format: "video/mp4"
                    }
                }, {
                    signal: signal
                });
                // Step 4: Poll for export status
                const exportStatus = await $6Njts.pollStatus(exportResult.jobId, 2000, {
                    signal: signal
                });
                // Return video URL
                return exportStatus.pageRenditionsResult?.[0]?.renditionUrl;
            }));
            // Step 5: Merge videos
            const { jobId: jobId } = await (0, $cYxTU.mergeVideos)({
                videoUrls: videoUrls,
                timestamps: [
                    {
                        start: 0,
                        duration: 54
                    },
                    {
                        start: 54,
                        duration: 47
                    }
                ],
                s3Path: payload.filePath
            });
            // Step 6: Poll for merge status
            const mergeStatus = await (0, $8oFcj.jobsPollStatus)({
                jobId: jobId
            });
            // Step 7: Update video with final path
            await updateVideo.mutateAsync({
                videoPath: mergeStatus?.result?.path
            });
            // Step 8: Fetch presigned URL for the merged video
            const presignData = await (0, $D7J7L.fetchPresignURL)(mergeStatus?.result?.path);
            return presignData;
        },
        meta: {
            errorMessage: "Failed to generate video. Please try again."
        }
    });
    return mutation;
};

});
parcelRegister("6Njts", function(module, exports) {

$parcel$export(module.exports, "getTaggedDocuments", () => $4f266ccf8f6ad264$export$3a8264f452f2c10b);
$parcel$export(module.exports, "getTaggedDocument", () => $4f266ccf8f6ad264$export$564c28ed3328c694);
$parcel$export(module.exports, "generateVariation", () => $4f266ccf8f6ad264$export$ff247ee8b57925cf);
$parcel$export(module.exports, "pollStatus", () => $4f266ccf8f6ad264$export$79a43e2fc4855cd5);
$parcel$export(module.exports, "exportRendition", () => $4f266ccf8f6ad264$export$564469de9fe1bca3);

var $fHV62 = parcelRequire("fHV62");
const $4f266ccf8f6ad264$export$f2f57f77ab1ce97c = (0, $fHV62.createApiClient)("https://express-api.adobe.io", null, 1, {
    "Content-Type": "application/json",
    "x-api-key": "09a93f07b97b4b14bcfae18666115e9e"
});
const $4f266ccf8f6ad264$export$3a8264f452f2c10b = async ({ nextUrl: nextUrl, filters: filters } = {}, options = {})=>{
    if (!nextUrl) throw new Error("nextUrl is required");
    const response = await $4f266ccf8f6ad264$export$f2f57f77ab1ce97c.get(nextUrl, {}, options);
    if (!response.ok) throw new Error("Failed to fetch tagged documents", {
        cause: response.data
    });
    if (Array.isArray(filters?.documents)) // Apply client-side filtering if filters are provided
    response.data.documents = response.data.documents.filter((item)=>filters.documents.includes(item.id));
    response.data.documents = response.data.documents.map((doc)=>({
            ...doc,
            name: doc.name.replace(/\.[^/.]+$/, "")
        }));
    return response.data;
};
const $4f266ccf8f6ad264$export$564c28ed3328c694 = async ({ nextUrl: nextUrl } = {}, options = {})=>{
    if (!nextUrl) throw new Error("nextUrl is required");
    const response = await $4f266ccf8f6ad264$export$f2f57f77ab1ce97c.get(nextUrl, {}, options);
    if (!response.ok) throw new Error("Failed to fetch tagged document", {
        cause: response.data
    });
    return response.data;
};
const $4f266ccf8f6ad264$export$ff247ee8b57925cf = async (payload, options = {})=>{
    const response = await $4f266ccf8f6ad264$export$f2f57f77ab1ce97c.post(`/beta/generate-variation`, payload, options);
    if (!response.ok) throw new Error("Failed to generate variation", {
        cause: response.data
    });
    return response.data;
};
const $4f266ccf8f6ad264$export$b70265791d2079d4 = async (jobId, options = {})=>{
    const response = await $4f266ccf8f6ad264$export$f2f57f77ab1ce97c.get(`/status/${jobId}`, {}, options);
    if (!response.ok) throw new Error("Failed to fetch status", {
        cause: response.data
    });
    return response.data;
};
const $4f266ccf8f6ad264$export$79a43e2fc4855cd5 = async (jobId, interval = 1000, options = {})=>{
    return new Promise((resolve, reject)=>{
        const poll = setInterval(async ()=>{
            try {
                const statusResponse = await $4f266ccf8f6ad264$export$b70265791d2079d4(jobId, options);
                if ([
                    "partially_succeeded",
                    "succeeded"
                ].includes(statusResponse.status)) {
                    clearInterval(poll);
                    resolve(statusResponse);
                } else if (statusResponse.status === "failed") {
                    console.log(statusResponse);
                    clearInterval(poll);
                    reject(new Error(statusResponse.message || "Job failed", {
                        cause: statusResponse
                    }));
                }
            } catch (error) {
                clearInterval(poll);
                reject(error);
            }
        }, interval);
    });
};
const $4f266ccf8f6ad264$export$564469de9fe1bca3 = async (payload = {}, options = {})=>{
    const response = await $4f266ccf8f6ad264$export$f2f57f77ab1ce97c.post(`/beta/export-rendition`, payload, options);
    if (!response.ok) throw new Error("Failed to export rendition", {
        cause: response.data
    });
    return response.data;
};

});

parcelRegister("cYxTU", function(module, exports) {

$parcel$export(module.exports, "mergeVideos", () => $9725629f46488b2f$export$9b1dccd0657efdb5);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $9725629f46488b2f$export$c2b1a108a90fb881 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/ffmpeg"]);
const $9725629f46488b2f$export$9b1dccd0657efdb5 = async ({ videoUrls: videoUrls, timestamps: timestamps, s3Path: s3Path }, options = {})=>{
    const response = await $9725629f46488b2f$export$c2b1a108a90fb881.post("/merge", {
        videoUrls: videoUrls,
        timestamps: timestamps,
        s3Path: s3Path
    }, options);
    if (!response.ok) throw new Error("Failed to merge videos", {
        cause: response
    });
    return response.data;
};

});


parcelRegister("4MHdR", function(module, exports) {

$parcel$export(module.exports, "useDrNumbers", () => $37bd2c3e6c39c773$export$3525915c16ad745e);
$parcel$export(module.exports, "useAccounts", () => $37bd2c3e6c39c773$export$c229550bd86eba85);
$parcel$export(module.exports, "scrapeQueryOptions", () => $37bd2c3e6c39c773$export$4ee361f0739efff5);
$parcel$export(module.exports, "searchImagesQueryOptions", () => $37bd2c3e6c39c773$export$41fb50f090fc6a27);

var $1WYFS = parcelRequire("1WYFS");
var $4kcQz = parcelRequire("4kcQz");

var $4BIhL = parcelRequire("4BIhL");
const $37bd2c3e6c39c773$export$efb5aa55574e3551 = {
    all: [
        "demoPilot"
    ],
    projects: ()=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.all,
            "projects"
        ],
    project: (id)=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.projects(),
            id
        ],
    drNumbers: (filter)=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.all,
            "drNumbers",
            {
                filter: filter
            }
        ],
    accounts: (filter)=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.all,
            "accounts",
            {
                filter: filter
            }
        ],
    scrapes: ()=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.all,
            "scrapes"
        ],
    scrape: (url, params)=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.scrapes(),
            {
                url: url,
                params: params
            }
        ],
    searches: ()=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.all,
            "searches"
        ],
    search: (params)=>[
            ...$37bd2c3e6c39c773$export$efb5aa55574e3551.searches(),
            {
                params: params
            }
        ]
};
const $37bd2c3e6c39c773$export$3525915c16ad745e = (filter, options = {})=>{
    const trimmedFilter = filter.trim();
    return (0, $4kcQz.useQuery)({
        queryKey: $37bd2c3e6c39c773$export$efb5aa55574e3551.drNumbers(trimmedFilter),
        queryFn: ({ signal: signal })=>(0, $4BIhL.getDrNumbers)(trimmedFilter, {
                signal: signal
            }),
        enabled: !!trimmedFilter && trimmedFilter.length >= 3,
        staleTime: 3600000,
        ...options
    });
};
const $37bd2c3e6c39c773$export$c229550bd86eba85 = (filter, options = {})=>{
    const trimmedFilter = filter.trim();
    return (0, $4kcQz.useQuery)({
        queryKey: $37bd2c3e6c39c773$export$efb5aa55574e3551.accounts(trimmedFilter),
        queryFn: ({ signal: signal })=>(0, $4BIhL.getAccounts)(trimmedFilter, {
                signal: signal
            }),
        enabled: !!trimmedFilter && trimmedFilter.length >= 3,
        staleTime: 3600000,
        ...options
    });
};
const $37bd2c3e6c39c773$export$4ee361f0739efff5 = (url, params = {}, options = {}, { shouldParseAssets: shouldParseAssets = false, dataParser: dataParser } = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $37bd2c3e6c39c773$export$efb5aa55574e3551.scrape(url, {
            ...params,
            shouldParseAssets: shouldParseAssets,
            dataParser: dataParser
        }),
        queryFn: async (queryContext)=>{
            const { signal: signal } = queryContext;
            if (!shouldParseAssets) return (0, $4BIhL.scrape)(url, params, {
                signal: signal
            });
            const scrapeData = await (0, $4BIhL.scrape)(url, params, {
                signal: signal
            });
            scrapeData.assets = (scrapeData.assets || []).map((asset, idx)=>{
                return {
                    id: `asset-${idx}`,
                    type: asset.data?.colors ? "color" : "image",
                    ...asset.data
                };
            });
            if (typeof dataParser === "function") return dataParser(scrapeData);
            return scrapeData;
        },
        enabled: !!url,
        staleTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        ...options
    });
const $37bd2c3e6c39c773$export$3d177833f682aa6f = (url = "", params = {}, options = {})=>{
    return (0, $4kcQz.useQuery)($37bd2c3e6c39c773$export$4ee361f0739efff5(url, params, options));
};
const $37bd2c3e6c39c773$export$41fb50f090fc6a27 = (params = {}, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $37bd2c3e6c39c773$export$efb5aa55574e3551.search(params),
        queryFn: async ({ signal: signal })=>{
            const result = await (0, $4BIhL.searchImages)(params, {
                signal: signal
            });
            return result?.results?.map((item, idx)=>({
                    id: `${item.url}-${idx}`,
                    type: "image",
                    src: item.image,
                    thumb: item.thumbnail,
                    alt: item.title,
                    width: item.width,
                    height: item.height,
                    // name: item.title,
                    sourceUrl: item.url,
                    isDisabled: false
                })) ?? [];
        },
        enabled: !!params.q && Object.keys(params).length > 0,
        staleTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        ...options
    });
const $37bd2c3e6c39c773$export$3997469237d385e = (params = {}, options = {})=>{
    return (0, $4kcQz.useQuery)($37bd2c3e6c39c773$export$41fb50f090fc6a27(params, options));
};

});
parcelRegister("4BIhL", function(module, exports) {

$parcel$export(module.exports, "scrape", () => $35acf84fe04b2243$export$6c0ecc2862ebf379);
$parcel$export(module.exports, "getAccounts", () => $35acf84fe04b2243$export$d5d451a14adbc067);
$parcel$export(module.exports, "getDrNumbers", () => $35acf84fe04b2243$export$f4ce8d15ff9b1ec0);
$parcel$export(module.exports, "searchImages", () => $35acf84fe04b2243$export$1b5f9b5fa5fe74e);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $35acf84fe04b2243$export$ea07a91e639bcc7b = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/zoltarDemoPilot"], 5, 0);
const $35acf84fe04b2243$export$6c0ecc2862ebf379 = async (url, { brandColors: brandColors = true, colorFormat: colorFormat = "hex", colors: colors = true, images: images = true, texts: texts = false, minPx: minPx = 64, maxPx: maxPx = 4096 } = {}, options = {})=>{
    const response = await $35acf84fe04b2243$export$ea07a91e639bcc7b.get("/api/assets", {
        url: url,
        brandColors: brandColors,
        colorFormat: colorFormat,
        colors: colors,
        images: images,
        texts: texts,
        minPx: minPx,
        maxPx: maxPx
    }, options);
    if (!response.ok) throw new Error("Failed to scrape URL", {
        cause: response
    });
    return response.data;
};
const $35acf84fe04b2243$export$d5d451a14adbc067 = async (accountName, options = {})=>{
    var name;
    // FIXME: Remove this temporary check once the upstream service is fixed.
    return [];
};
const $35acf84fe04b2243$export$f4ce8d15ff9b1ec0 = async (drNumber, options = {})=>{
    // FIXME: Remove this temporary check once the upstream service is fixed.
    return [];
};
const $35acf84fe04b2243$export$911b877d9fb1bbcc = async (options)=>{
    const response = await $35acf84fe04b2243$export$ea07a91e639bcc7b.post(`/api/uploads/init`, options);
    if (!response.ok) throw new Error(`Failed to init upload with options: ${JSON.stringify(options)}`, {
        cause: response
    });
    return response.data;
};
const $35acf84fe04b2243$export$43db64f5934888f1 = async (options)=>{
    const response = await $35acf84fe04b2243$export$ea07a91e639bcc7b.post(`/api/uploads/complete`, options);
    if (!response.ok) throw new Error(`Failed to complete upload with options: ${JSON.stringify(options)}`, {
        cause: response
    });
    return response.data;
};
const $35acf84fe04b2243$export$1e1c429290b0b9ab = async (projectId, url, params)=>{
    const response = await $35acf84fe04b2243$export$ea07a91e639bcc7b.post(`/api/brand-guidelines`, {
        url: url,
        params: params
    });
    if (!response.ok) throw new Error(`Failed to scrape brand guidelines for project ${projectId}`, {
        cause: response
    });
    return response.data;
};
const $35acf84fe04b2243$export$1b5f9b5fa5fe74e = async (params = {}, options)=>{
    const response = await $35acf84fe04b2243$export$ea07a91e639bcc7b.get(`/api/image-search-duck`, params, options);
    if (!response.ok) throw new Error(`Failed to search images`, {
        cause: response
    });
    return response.data;
};

});


parcelRegister("dyJFE", function(module, exports) {

$parcel$export(module.exports, "useCropImage", () => $9df1e09fe9582914$export$94249c3d90ca6a88);

var $b0Fq6 = parcelRequire("b0Fq6");
var $k6waQ = parcelRequire("k6waQ");

var $984R8 = parcelRequire("984R8");

var $1B1zl = parcelRequire("1B1zl");
const $9df1e09fe9582914$export$2e5af57a643938a = {
    all: [
        "photoshop"
    ],
    cropImages: ()=>[
            ...$9df1e09fe9582914$export$2e5af57a643938a.all,
            "cropImage"
        ],
    cropImage: (variables)=>[
            ...$9df1e09fe9582914$export$2e5af57a643938a.cropImages(),
            variables
        ],
    removeBackgrounds: ()=>[
            ...$9df1e09fe9582914$export$2e5af57a643938a.all,
            "removeBackground"
        ],
    removeBackground: (variables)=>[
            ...$9df1e09fe9582914$export$2e5af57a643938a.removeBackgrounds(),
            variables
        ]
};
const $9df1e09fe9582914$export$da321b0db45bceba = (options = {})=>(0, $b0Fq6.mutationOptions)({
        ...options,
        retry: (0, $1B1zl.retry)(1),
        mutationFn: (variables, { signal: signal })=>(0, $984R8.cropImage)(variables, {
                signal: signal
            }),
        onSuccess: (data, variables, onMutateResult, context)=>{
            const { client: client } = context;
            client.setQueryData($9df1e09fe9582914$export$2e5af57a643938a.cropImage(variables), data);
            options.onSuccess?.(data, variables, onMutateResult, context);
        }
    });
const $9df1e09fe9582914$export$94249c3d90ca6a88 = (options = {})=>{
    return (0, $k6waQ.useMutation)($9df1e09fe9582914$export$da321b0db45bceba(options));
};
const $9df1e09fe9582914$export$730236013be07905 = (options = {})=>(0, $b0Fq6.mutationOptions)({
        ...options,
        mutationFn: ({ statusCallback: statusCallback, ...variables }, { signal: signal })=>(0, $984R8.removeBackgroundFn)(variables, signal, statusCallback),
        onSuccess: (data, variables, onMutateResult, context)=>{
            const { client: client } = context;
            client.setQueryData($9df1e09fe9582914$export$2e5af57a643938a.removeBackground(variables), data);
            options.onSuccess?.(data, variables, onMutateResult, context);
        }
    });
const $9df1e09fe9582914$export$769a0574799842dd = (options = {})=>{
    return (0, $k6waQ.useMutation)($9df1e09fe9582914$export$730236013be07905(options));
};

});
parcelRegister("984R8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CROP_OBJECTS", () => $6a58a0b17a455baf$export$a010feaa5ad17dd3);
$parcel$export(module.exports, "cropImage", () => $6a58a0b17a455baf$export$ccc121838b14e831);
$parcel$export(module.exports, "removeBackgroundFn", () => $6a58a0b17a455baf$export$fda959cb49e582de);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");

var $ubpkL = parcelRequire("ubpkL");
const $6a58a0b17a455baf$export$63120f7056e3645 = 3;
const $6a58a0b17a455baf$export$561fbf3bc4c24b39 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/photoshop"], $6a58a0b17a455baf$export$63120f7056e3645);
const $6a58a0b17a455baf$export$a010feaa5ad17dd3 = "logo.person";
const $6a58a0b17a455baf$export$ccc121838b14e831 = async ({ items: items = [] }, options = {})=>{
    const inputs = [];
    const features = [];
    let index = 0;
    for (const [url, resolutions, objects] of items){
        // const presignedUrl = await fetchPresignURL(filePath);
        inputs.push({
            "dc:format": "image/jpeg",
            "repo:path": url,
            "sensei:repoType": "HTTP"
        });
        const feature = {
            feature_name: `image${index + 1}`,
            feature_value: {
                // aspect_ratios: [],
                // scales: [],
                // preserve_symmetry: true,
                auto: false,
                objects: objects ? [
                    "logo",
                    objects
                ].join(".") : $6a58a0b17a455baf$export$a010feaa5ad17dd3,
                target_resolution: []
            }
        };
        index++;
        for (const { width: width, height: height } of resolutions)feature.feature_value.target_resolution.push({
            w: width,
            h: height
        });
        features.push(feature);
    }
    const payload = {
        "sensei:invocation_batch": false,
        "sensei:engines": [
            {
                "sensei:execution_info": {
                    "sensei:engine": // "Feature:autocrop:Service-e28a51fdd1274c598a93bbc942ccf449", // V3
                    "Feature:autocrop:Service-bab6a9e1e21049bc9aff1cb76652f56d"
                },
                "sensei:inputs": {
                    image_input: inputs
                },
                "sensei:params": {
                    autocrop_params: {
                        features: features
                    }
                },
                "sensei:outputs": {
                    predict: {
                        "dc:format": "application/json",
                        "sensei:multipart_field_name": "outjson"
                    }
                }
            }
        ]
    };
    const formData = new FormData();
    formData.append("contentAnalyzerRequests", JSON.stringify(payload));
    const headers = await (0, $fHV62.getAuthHeaders)();
    // const response = await photoshopClient.post("/auto-crop", formData, {
    //   headers,
    //   ...options,
    // });
    const response = await fetch(`${(0, $8Ogg5.actions)["exd-storyteller-ai/photoshop"]}/auto-crop`, {
        method: "POST",
        body: formData,
        headers: headers
    });
    if (!response.ok) throw new Error(`Failed to crop image: ${response.status}`, {
        cause: response
    });
    return response.json();
};
const $6a58a0b17a455baf$export$bcbafd0c688e5b8d = async (body = {}, options = {})=>{
    const response = await $6a58a0b17a455baf$export$561fbf3bc4c24b39.post("/remove-background", body, options);
    if (!response.ok) throw new Error(`Failed to start background removal`, {
        cause: response
    });
    if (!response.data?.statusUrl) throw new Error(`Invalid response format from remove background`, {
        cause: response
    });
    return response.data;
};
const $6a58a0b17a455baf$export$268e3f1cb9b44f0f = async ({ statusUrl: statusUrl, s3FilePath: s3FilePath } = {}, options = {})=>$6a58a0b17a455baf$export$561fbf3bc4c24b39.post("/poll-status", {
        statusUrl: statusUrl,
        ...s3FilePath ? {
            s3FilePath: s3FilePath
        } : {}
    }, options);
const $6a58a0b17a455baf$export$fda959cb49e582de = async (options = {}, signal, statusCallback = null)=>{
    const { s3FilePath: s3FilePath, ...removeBgOptions } = options ?? {};
    const { statusUrl: statusUrl } = await $6a58a0b17a455baf$export$bcbafd0c688e5b8d(removeBgOptions, {
        signal: signal
    });
    const maxAttempts = 120; // 2 minutes
    const initialPollDelay = 1500;
    const pollDelay = 1500;
    let attempts = 0;
    await (0, $ubpkL.backgroundDelay)(initialPollDelay, {
        signal: signal
    });
    while(attempts < maxAttempts){
        attempts++;
        const pollResponse = await $6a58a0b17a455baf$export$268e3f1cb9b44f0f({
            statusUrl: statusUrl,
            s3FilePath: s3FilePath
        }, {
            signal: signal
        });
        if (!pollResponse.ok && pollResponse.status !== 429) throw new Error("Failed to poll background removal status", {
            cause: pollResponse
        });
        const jobResult = pollResponse.data;
        if (jobResult?.status === "succeeded") {
            const outputs = (jobResult?.result?.outputs ?? []).filter((output)=>!!output?.destination?.url).map((output)=>{
                const s3Data = output?.s3 ?? jobResult?.s3 ?? null;
                return {
                    kind: "image",
                    url: s3Data?.presignURL ?? output.destination.url,
                    filePath: s3Data?.filePath ?? null,
                    presignURL: s3Data?.presignURL ?? null,
                    mediaType: output.mediaType
                };
            });
            if (outputs.length === 0) throw new Error("No valid outputs were found in the response", {
                cause: pollResponse
            });
            return {
                success: true,
                outputs: outputs
            };
        }
        if (jobResult?.status === "failed") {
            const [firstError] = jobResult?.errorDetails ?? [];
            throw new Error(firstError?.message ?? "Background removal job failed", {
                cause: {
                    status: pollResponse.status,
                    data: {
                        status: "failed",
                        jobId: jobResult?.jobId,
                        error_code: firstError?.errorCode,
                        message: firstError?.message
                    }
                }
            });
        }
        statusCallback?.(jobResult ?? {});
        const delay = Math.max(pollDelay, pollResponse?.headers?.["retry-after"] ? parseInt(pollResponse.headers["retry-after"], 10) * 1000 : 0);
        // Wait before polling again (worker-backed)
        await (0, $ubpkL.backgroundDelay)(delay, {
            signal: signal
        });
    }
    throw new Error(`Job timed out after ${attempts} attempts`);
};

});


parcelRegister("HE3sn", function(module, exports) {

$parcel$export(module.exports, "useDebounce", () => $0833164e6d719cdd$export$21805fee57372823);

var $eF4cA = parcelRequire("eF4cA");

var $f3pgh = parcelRequire("f3pgh");
function $0833164e6d719cdd$export$21805fee57372823(callback, delay) {
    const callbackRef = (0, $eF4cA.useRef)(callback);
    (0, $eF4cA.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $eF4cA.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($f3pgh)))((...args)=>callbackRef.current(...args), delay), [
        delay
    ]);
}

});
parcelRegister("f3pgh", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $af5abb39f263b093$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $af5abb39f263b093$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $af5abb39f263b093$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $af5abb39f263b093$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $af5abb39f263b093$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $af5abb39f263b093$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $af5abb39f263b093$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $af5abb39f263b093$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $af5abb39f263b093$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $af5abb39f263b093$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $af5abb39f263b093$var$root = $af5abb39f263b093$var$freeGlobal || $af5abb39f263b093$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $af5abb39f263b093$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $af5abb39f263b093$var$objectToString = $af5abb39f263b093$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $af5abb39f263b093$var$nativeMax = Math.max, $af5abb39f263b093$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $af5abb39f263b093$var$now = function() {
    return $af5abb39f263b093$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $af5abb39f263b093$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($af5abb39f263b093$var$FUNC_ERROR_TEXT);
    wait = $af5abb39f263b093$var$toNumber(wait) || 0;
    if ($af5abb39f263b093$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $af5abb39f263b093$var$nativeMax($af5abb39f263b093$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $af5abb39f263b093$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $af5abb39f263b093$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($af5abb39f263b093$var$now());
    }
    function debounced() {
        var time = $af5abb39f263b093$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $af5abb39f263b093$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af5abb39f263b093$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $af5abb39f263b093$var$isSymbol(value) {
    return typeof value == 'symbol' || $af5abb39f263b093$var$isObjectLike(value) && $af5abb39f263b093$var$objectToString.call(value) == $af5abb39f263b093$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $af5abb39f263b093$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($af5abb39f263b093$var$isSymbol(value)) return $af5abb39f263b093$var$NAN;
    if ($af5abb39f263b093$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $af5abb39f263b093$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($af5abb39f263b093$var$reTrim, '');
    var isBinary = $af5abb39f263b093$var$reIsBinary.test(value);
    return isBinary || $af5abb39f263b093$var$reIsOctal.test(value) ? $af5abb39f263b093$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $af5abb39f263b093$var$reIsBadHex.test(value) ? $af5abb39f263b093$var$NAN : +value;
}
module.exports = $af5abb39f263b093$var$debounce;

});


parcelRegister("dXYND", function(module, exports) {

$parcel$export(module.exports, "getCustomerBrandingPromptTemplate", () => $a2aff297ae8e996e$export$97fd95c21b371f24);
$parcel$export(module.exports, "BRAND_LIBRARY_FIELDS", () => $a2aff297ae8e996e$export$23e51340dfa473bd);
const $a2aff297ae8e996e$export$25d11a7c55f89a4b = {
    "csc-overview": "CSC-branding",
    ucx: "UCX-texts",
    "ao-overview": "AO-texts",
    foundry: "Foundry-texts",
    "firefly-enterprise": "Firefly-Enterprise-texts",
    "brand-visibility": "Brand-Visibility-texts",
    "brand-intelligence": "Brand-Intelligence-texts",
    ai: "AI-at-Adobe-texts",
    "partnership-value": "PV-texts",
    "cx-coworker": "CXCoworker-texts",
    "one-adobe": "One-Adobe-texts"
};
const $a2aff297ae8e996e$export$97fd95c21b371f24 = ({ templateId: templateId, customerName: customerName, hint: hint, editScope: editScope, product: product, personaType: personaType })=>{
    const systemPromptId = Object.hasOwn($a2aff297ae8e996e$export$25d11a7c55f89a4b, templateId) ? $a2aff297ae8e996e$export$25d11a7c55f89a4b[templateId] : undefined;
    if (!systemPromptId) return {
        template: [],
        systemPromptId: systemPromptId
    };
    let userPrompt = "";
    if (templateId === "partnership-value") userPrompt += `Write a partnership film script for Adobe and ${customerName}.\n\n`;
    if (customerName) userPrompt += `[Company]: ${customerName}`;
    if (personaType) userPrompt += `\n[Persona-type]: ${personaType}`;
    if (product) userPrompt += `\n[Product]: ${product}`;
    if (hint) userPrompt += `\n\n[Hints]:\n${hint}`;
    if (editScope) userPrompt += `\n\n[Edit-scope]: ${editScope}`;
    return {
        systemPromptId: systemPromptId,
        template: [
            {
                role: "user",
                prompt_template: userPrompt
            }
        ]
    };
};
const $a2aff297ae8e996e$export$23e51340dfa473bd = [
    "Brand-visual-DNA",
    ...Array.from({
        length: 7
    }, (_, index)=>`Brand-library-prompt-${index + 1}`),
    "Competitor-brand-visual-DNA",
    "Competitor-library-prompt-1",
    "Competitor-library-prompt-2"
];

});

parcelRegister("awCmJ", function(module, exports) {

$parcel$export(module.exports, "putAuroraVideo", () => $7a9aa726450ce87a$export$25a5f9b8d488e333);

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $7a9aa726450ce87a$export$d05c3b237f572f63 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/aurora"]);
const $7a9aa726450ce87a$export$25a5f9b8d488e333 = async (id, options = {})=>{
    const response = await $7a9aa726450ce87a$export$d05c3b237f572f63.put(`/${encodeURIComponent(id)}`, {}, options);
    if (!response.ok) console.error("Failed to notify Aurora", response);
    return response.data;
};

});



parcelRegister("5DPNF", function(module, exports) {

$parcel$export(module.exports, "useStable", () => $368da52f31ab207d$export$b540f128867fb8a2);

var $eF4cA = parcelRequire("eF4cA");

var $3ur2P = parcelRequire("3ur2P");
function $368da52f31ab207d$export$b540f128867fb8a2(value) {
    const ref = (0, $eF4cA.useRef)(value);
    const stable = (0, $3ur2P.replaceEqualDeep)(ref.current, value);
    (0, $eF4cA.useEffect)(()=>{
        ref.current = stable;
    }, [
        stable
    ]);
    return stable;
}

});

parcelRegister("d1b3l", function(module, exports) {

$parcel$export(module.exports, "useImageLabeling", () => $97a3f13a8b0414b8$export$7b027e2b8b975ae4);

var $eF4cA = parcelRequire("eF4cA");

var $4SSyx = parcelRequire("4SSyx");

var $CGZx1 = parcelRequire("CGZx1");

var $aKSBi = parcelRequire("aKSBi");

var $dXYND = parcelRequire("dXYND");

var $3OMKs = parcelRequire("3OMKs");

var $34B61 = parcelRequire("34B61");
const $97a3f13a8b0414b8$var$BRAND_VISIBILITY_PROFILE = "brand-visibility-library";
const $97a3f13a8b0414b8$var$DNA_FIELDS = [
    "Brand-visual-DNA",
    "Competitor-brand-visual-DNA"
];
const $97a3f13a8b0414b8$var$IMAGE_LABELING_RETRIES = 2;
/** The asset with any labeling received for its current file merged back in. */ const $97a3f13a8b0414b8$var$withSavedLabeling = (projectId, asset)=>{
    const saved = (0, $34B61.imageLabelingResults).get((0, $34B61.labelingId)(projectId, asset?.name));
    return saved && saved.filePath === asset?.filePath ? {
        ...asset,
        labeling: {
            ...asset.labeling,
            ...saved.labeling
        }
    } : asset;
};
const $97a3f13a8b0414b8$export$7b027e2b8b975ae4 = ({ projectId: projectId, assets: assets, urlByPath: urlByPath, templateId: templateId, imageVariations: imageVariations, systemPromptId: systemPromptId = "common-image-description", enabled: enabled = true, companyName: companyName, product: product })=>{
    const updateAssets = (0, $CGZx1.useUpdateAssets)(projectId);
    // Failed assets are skipped until `retry()`, so one failure does not block the rest.
    const [failedIds, setFailedIds] = (0, $eF4cA.useState)(()=>new Set());
    /**
   * Templates whose variation prompts never read `visual.labeling` skip
   * describing their reference images entirely.
   */ const skipImageLabeling = (0, $3OMKs.SKIP_IMAGE_LABELING_TEMPLATES).has(templateId);
    const getDescriptionProfile = (0, $eF4cA.useCallback)((asset)=>imageVariations?.find((variation)=>variation.key === asset?.name)?.imageDescriptionPrompt === $97a3f13a8b0414b8$var$BRAND_VISIBILITY_PROFILE ? "Brand-Visibility-reference-description" : null, [
        imageVariations
    ]);
    const hasLabeling = (0, $eF4cA.useCallback)((asset)=>{
        const profile = getDescriptionProfile(asset);
        return (0, $34B61.hasLabelingFields)(asset?.labeling, profile ? (0, $dXYND.BRAND_LIBRARY_FIELDS) : [
            "description"
        ]);
    }, [
        getDescriptionProfile
    ]);
    const mutationOptions = {
        onMutate: (variables)=>{
            (0, $34B61.loadingImageLabeling).add((0, $34B61.labelingId)(projectId, variables.key));
        },
        onSuccess: (data, variables)=>{
            // React Query keeps the latest options, so this reads the assets as of
            // the moment the labeling settled.
            const asset = $97a3f13a8b0414b8$var$withSavedLabeling(projectId, assets?.find((a)=>a?.name === variables.key) ?? {
                name: variables.key
            });
            const labeling = {
                ...asset.labeling,
                ...data
            };
            if (asset.filePath) (0, $34B61.imageLabelingResults).set((0, $34B61.labelingId)(projectId, variables.key), {
                filePath: asset.filePath,
                labeling: labeling
            });
            return updateAssets.mutateAsync({
                assets: [
                    {
                        ...asset,
                        labeling: labeling
                    }
                ]
            }, {
                onSettled: ()=>{
                    (0, $34B61.loadingImageLabeling).delete((0, $34B61.labelingId)(projectId, variables.key));
                }
            });
        },
        onError: (error, variables)=>{
            setFailedIds((prev)=>new Set(prev).add((0, $34B61.labelingId)(projectId, variables.key)));
        },
        onSettled: (data, error, variables)=>{
            (0, $34B61.loadingImageLabeling).delete((0, $34B61.labelingId)(projectId, variables.key));
        }
    };
    const imageLabeling = (0, $4SSyx.useImageLabeling)({
        ...mutationOptions,
        // Empty or unparsable model replies are usually transient.
        retry: $97a3f13a8b0414b8$var$IMAGE_LABELING_RETRIES,
        retryDelay: (attempt)=>1000 * 2 ** attempt
    }, (data, variables)=>{
        if (variables.systemPromptId !== "Brand-Visibility-image-description") return data;
        if (!(0, $34B61.hasLabelingFields)(data, [
            "description"
        ])) throw new Error("Image labeling returned an invalid or empty reference description.");
        return {
            ...data,
            descriptionProfile: $97a3f13a8b0414b8$var$BRAND_VISIBILITY_PROFILE
        };
    });
    const imageDna = (0, $4SSyx.useImageLabeling)({
        ...mutationOptions,
        retry: $97a3f13a8b0414b8$var$IMAGE_LABELING_RETRIES,
        retryDelay: (attempt)=>1000 * 2 ** attempt
    }, (data)=>{
        if (!(0, $34B61.hasLabelingFields)(data, $97a3f13a8b0414b8$var$DNA_FIELDS)) throw new Error("Image labeling returned an invalid or empty visual DNA.");
        return Object.fromEntries($97a3f13a8b0414b8$var$DNA_FIELDS.map((field)=>[
                field,
                data[field]
            ]));
    });
    const imageLibrary = (0, $4SSyx.useZoltarMutation)({
        ...mutationOptions,
        meta: {
            errorMessage: "Failed to generate the brand image library. Please try again."
        }
    }, (response)=>{
        const data = (0, $aKSBi.readZoltarGenerateJsonWithFallback)(response, "{}", "Failed to generate the brand image library");
        const fields = (0, $dXYND.BRAND_LIBRARY_FIELDS);
        if (!(0, $34B61.hasLabelingFields)(data, fields) || Object.keys(data).length !== fields.length) throw new Error("Image analysis returned an incomplete or invalid library.");
        return data;
    });
    const { mutate: mutateImageLabeling, reset: resetImageLabeling } = imageLabeling;
    const { mutate: mutateImageDna, reset: resetImageDna } = imageDna;
    const { mutate: mutateImageLibrary, reset: resetImageLibrary } = imageLibrary;
    const { mutateAsync: writeAssets } = updateAssets;
    /** Clears previous failures so the failed assets are described again. */ const retry = (0, $eF4cA.useCallback)(()=>{
        resetImageLabeling();
        resetImageDna();
        resetImageLibrary();
        setFailedIds((prev)=>prev.size ? new Set() : prev);
    }, [
        resetImageLabeling,
        resetImageDna,
        resetImageLibrary
    ]);
    // Describe every reference image that still needs it.
    (0, $eF4cA.useEffect)(()=>{
        if (!enabled || skipImageLabeling) return;
        assets?.forEach((current)=>{
            const presignURL = urlByPath?.get(current?.filePath);
            const profile = getDescriptionProfile(current);
            const id = (0, $34B61.labelingId)(projectId, current?.name);
            const isDone = (a)=>profile ? hasLabeling(a) : !!a?.labeling;
            const asset = $97a3f13a8b0414b8$var$withSavedLabeling(projectId, current);
            if (!asset?.name || !asset?.filePath || !presignURL || isDone(current) || failedIds.has(id) || (0, $34B61.loadingImageLabeling).has(id)) return;
            if (isDone(asset)) {
                (0, $34B61.loadingImageLabeling).add(id);
                writeAssets({
                    assets: [
                        asset
                    ]
                }).catch(()=>{}).finally(()=>(0, $34B61.loadingImageLabeling).delete(id));
                return;
            }
            // Brand Visibility runs in three persisted steps, so each one resumes
            // after a failure: description and DNA (imageLabeling), then the library.
            // A description from another prompt (e.g. copied from the reference on a
            // failed generation) is replaced by step 1 rather than reused.
            if (profile && asset?.labeling?.descriptionProfile === $97a3f13a8b0414b8$var$BRAND_VISIBILITY_PROFILE && (0, $34B61.hasLabelingFields)(asset.labeling, [
                "description"
            ])) {
                const brandInput = [
                    `COMPANY_NAME: ${companyName ?? ""}`,
                    `PRODUCT: ${product ?? ""}`
                ];
                const description = {
                    description: asset.labeling.description,
                    mainSubject: asset.labeling.mainSubject,
                    keyElements: asset.labeling.keyElements,
                    attributes: asset.labeling.attributes,
                    productType: asset.labeling.productType,
                    productMatch: asset.labeling.productMatch,
                    visibleProduct: asset.labeling.visibleProduct
                };
                if (!(0, $34B61.hasLabelingFields)(asset.labeling, $97a3f13a8b0414b8$var$DNA_FIELDS)) {
                    mutateImageDna({
                        key: asset.name,
                        imageUrl: presignURL,
                        systemPromptId: "Brand-Visibility-image-dna",
                        userInput: [
                            ...brandInput,
                            `REFERENCE_DESCRIPTION: ${JSON.stringify(description)}`
                        ].join("\n")
                    });
                    return;
                }
                mutateImageLibrary({
                    key: asset.name,
                    promptTemplate: [],
                    systemPromptId: profile,
                    userInput: [
                        ...brandInput,
                        `REFERENCE_ANALYSIS: ${JSON.stringify({
                            ...description,
                            "Brand-visual-DNA": asset.labeling["Brand-visual-DNA"],
                            "Competitor-brand-visual-DNA": asset.labeling["Competitor-brand-visual-DNA"]
                        })}`
                    ].join("\n")
                });
                return;
            }
            mutateImageLabeling({
                key: asset.name,
                imageUrl: presignURL,
                systemPromptId: profile ? "Brand-Visibility-image-description" : systemPromptId,
                ...profile ? {
                    userInput: [
                        `COMPANY_NAME: ${companyName ?? ""}`,
                        `PRODUCT: ${product ?? ""}`
                    ].join("\n")
                } : {}
            });
        });
    }, [
        enabled,
        skipImageLabeling,
        assets,
        urlByPath,
        projectId,
        systemPromptId,
        companyName,
        product,
        getDescriptionProfile,
        hasLabeling,
        failedIds,
        writeAssets,
        imageLabeling.isPending,
        imageLabeling.isSuccess,
        mutateImageLabeling,
        imageDna.isPending,
        imageDna.isSuccess,
        mutateImageDna,
        imageLibrary.isPending,
        imageLibrary.isSuccess,
        mutateImageLibrary
    ]);
    /**
   * Whether an asset has everything a prompt needs from it — nothing to
   * describe, or a description already persisted.
   */ const isLabeled = (0, $eF4cA.useCallback)((asset)=>skipImageLabeling || !asset?.filePath || hasLabeling(asset), [
        skipImageLabeling,
        hasLabeling
    ]);
    const isPending = imageLabeling.isPending || imageDna.isPending || imageLibrary.isPending;
    const isError = imageLabeling.isError || imageDna.isError || imageLibrary.isError;
    const error = imageLibrary.error ?? imageDna.error ?? imageLabeling.error;
    return (0, $eF4cA.useMemo)(()=>({
            skipImageLabeling: skipImageLabeling,
            isLabeled: isLabeled,
            isPending: isPending,
            isError: isError,
            error: error,
            retry: retry
        }), [
        skipImageLabeling,
        isLabeled,
        isPending,
        isError,
        error,
        retry
    ]);
};

});
parcelRegister("34B61", function(module, exports) {

$parcel$export(module.exports, "loadingImageLabeling", () => $23ce85528ac7baad$export$c8c66f06e0e3d27b);
$parcel$export(module.exports, "labelingId", () => $23ce85528ac7baad$export$f15ebea469f57d64);
$parcel$export(module.exports, "imageLabelingResults", () => $23ce85528ac7baad$export$cd34186d2ec60fe8);
$parcel$export(module.exports, "hasLabelingFields", () => $23ce85528ac7baad$export$297d5070237e0ed5);
$parcel$export(module.exports, "loadingImagePrompts", () => $23ce85528ac7baad$export$beae68535079a7e4);
$parcel$export(module.exports, "promptId", () => $23ce85528ac7baad$export$f0f0161989b66dd3);
$parcel$export(module.exports, "queueImageVariationsWrite", () => $23ce85528ac7baad$export$3192fa81118533f9);
/**
 * Cross-instance bookkeeping for the image variation hooks.
 *
 * The hooks below may be mounted more than once — a different wizard step, a
 * preview, a second view of the same project — so the work already in flight
 * is tracked here, per project, rather than per hook instance.
 */ /**
 * Labeling requests in flight, shared by every `useImageLabeling`: the same
 * reference image can belong to more than one group, and it only has to be
 * described once.
 */ const $23ce85528ac7baad$export$c8c66f06e0e3d27b = new Set();
const $23ce85528ac7baad$export$f15ebea469f57d64 = (projectId, key)=>`${projectId}\u0000${key}`;
const $23ce85528ac7baad$export$cd34186d2ec60fe8 = new Map();
const $23ce85528ac7baad$export$297d5070237e0ed5 = (labeling, fields)=>!!labeling && typeof labeling === "object" && !Array.isArray(labeling) && fields.every((field)=>typeof labeling[field] === "string" && labeling[field].trim().length > 0);
const $23ce85528ac7baad$export$beae68535079a7e4 = new Set();
const $23ce85528ac7baad$export$f0f0161989b66dd3 = (projectId, key)=>`${projectId}\u0000${key}`;
/**
 * Persisting `imageVariations` rewrites the *whole* array, so two writes
 * started from the same snapshot drop each other's entries — and the prompt
 * effect would then ask for the lost prompts again, forever. Every write of a
 * project is chained here, across all hook instances, so each one reads the
 * cache only after the previous one has settled.
 */ const $23ce85528ac7baad$var$imageVariationsWrites = new Map();
const $23ce85528ac7baad$export$3192fa81118533f9 = (projectId, write)=>{
    const previous = $23ce85528ac7baad$var$imageVariationsWrites.get(projectId) ?? Promise.resolve();
    const next = previous.then(write, write);
    // A failed write must not break the queue for the ones behind it.
    const settled = next.catch(()=>{});
    $23ce85528ac7baad$var$imageVariationsWrites.set(projectId, settled);
    settled.then(()=>{
        // Nothing else queued up behind it — stop tracking the idle chain.
        if ($23ce85528ac7baad$var$imageVariationsWrites.get(projectId) === settled) $23ce85528ac7baad$var$imageVariationsWrites.delete(projectId);
    });
    return next;
};

});


parcelRegister("gQVw6", function(module, exports) {

$parcel$export(module.exports, "useImagePrompts", () => $c44e1e525add8493$export$58a2c9b4b98b61a7);

var $eF4cA = parcelRequire("eF4cA");

var $k6waQ = parcelRequire("k6waQ");

var $5DPNF = parcelRequire("5DPNF");

var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");

var $lb17q = parcelRequire("lb17q");

var $gJFBV = parcelRequire("gJFBV");

var $34B61 = parcelRequire("34B61");

var $eOKVi = parcelRequire("eOKVi");
const $c44e1e525add8493$export$58a2c9b4b98b61a7 = ({ projectId: projectId, variations: variations, imageVariations: imageVariations, templateId: templateId, campaign: campaign, customer: customer, getReferenceAssets: getReferenceAssets, isLabeled: isLabeled, persist: persist, enabled: enabled = true })=>{
    const ownWriter = (0, $eOKVi.usePersistImageVariations)(projectId);
    const persistImageVariations = persist ?? ownWriter.persist;
    const handleUpdateImageVariations = (0, $eF4cA.useCallback)((data, variables)=>{
        const { key: key, assetName: assetName, type: type } = variables;
        try {
            const zoltarData = (0, $aKSBi.parseZoltarGenerateAssistantJson)(data, "Failed to parse image variation response");
            const newVariations = [];
            newVariations.push({
                key: key,
                referenceKey: assetName,
                type: type,
                ...zoltarData ?? {}
            });
            return persistImageVariations(newVariations);
        } catch (error) {
            console.warn("Error parsing audiences variations response:", error, data, variables);
        }
    }, [
        persistImageVariations
    ]);
    const imagePromptBase = (0, $4SSyx.useZoltarMutation)();
    const imagePrompt = (0, $k6waQ.useMutation)({
        mutationFn: (variables)=>imagePromptBase.mutateAsync(variables),
        onSuccess: handleUpdateImageVariations,
        // The key stays reserved until the generated prompt has been persisted,
        // which is exactly when `onSettled` runs — `onSuccess` is awaited first.
        onSettled: (data, error, variables)=>{
            (0, $34B61.loadingImagePrompts).delete((0, $34B61.promptId)(projectId, variables.key));
        }
    });
    const { mutate: mutateImagePrompt } = imagePrompt;
    // The prompt requests still owed, fully resolved. Deriving them in a memo —
    // and stabilising the result by value — is what keeps the effect below from
    // re-running: every write to the video replaces the whole cache entry, so
    // `video.data` and everything derived from it changes identity on each
    // update, while the work that is actually left does not.
    const pendingPrompts = (0, $eF4cA.useMemo)(()=>(variations ?? []).filter((variation)=>!!variation.type && !imageVariations?.some((v)=>v.key === variation.key && !!v.visualPrompt))// Every reference image has to be described first for LLM-generated
        // prompts — static prompts do not read `visual.labeling` and can
        // proceed immediately without waiting for Zoltar image labeling.
        .filter((variation)=>{
            if (!isLabeled) return true;
            const visuals = getReferenceAssets(variation);
            if ((0, $gJFBV.isStaticPrompt)(variation, {
                templateId: templateId,
                campaign: campaign,
                customer: customer,
                visual: visuals[0],
                visuals: visuals
            })) return true;
            return visuals.every(isLabeled);
        }).map((variation)=>{
            const visuals = getReferenceAssets(variation);
            const prompt = (0, $gJFBV.getVariationPromptTemplate)(variation, {
                templateId: templateId,
                campaign: campaign,
                customer: customer,
                visual: visuals[0],
                visuals: visuals
            });
            return {
                ...typeof prompt === "string" || prompt == null ? {
                    promptTemplate: prompt
                } : prompt,
                assetName: (0, $lb17q.getPrimaryReferenceKey)(variation),
                key: variation.key,
                type: variation.type
            };
        })// e.g. a `labeling-prompt` whose reference has not been analysed yet.
        .filter((request)=>request.promptTemplate != null), [
        variations,
        imageVariations,
        getReferenceAssets,
        isLabeled,
        templateId,
        campaign,
        customer
    ]);
    const stablePendingPrompts = (0, $5DPNF.useStable)(pendingPrompts);
    // Generate image variation prompts
    (0, $eF4cA.useEffect)(()=>{
        if (!enabled) return;
        // Templates that resolve to a plain string are already the prompt: they
        // need no generation, only persisting — batched into a single write, so a
        // group of them cannot race each other.
        const staticVariations = [];
        stablePendingPrompts.forEach((request)=>{
            const id = (0, $34B61.promptId)(projectId, request.key);
            if ((0, $34B61.loadingImagePrompts).has(id)) return;
            (0, $34B61.loadingImagePrompts).add(id);
            if (typeof request.promptTemplate === "string") {
                staticVariations.push({
                    key: request.key,
                    referenceKey: request.assetName,
                    type: request.type,
                    visualPrompt: request.promptTemplate
                });
                return;
            }
            mutateImagePrompt(request);
        });
        if (staticVariations.length > 0) {
            const release = ()=>{
                staticVariations.forEach((variation)=>{
                    (0, $34B61.loadingImagePrompts).delete((0, $34B61.promptId)(projectId, variation.key));
                });
            };
            persistImageVariations(staticVariations).then(release, release);
        }
    }, [
        enabled,
        stablePendingPrompts,
        projectId,
        persistImageVariations,
        mutateImagePrompt
    ]);
    const { isPending: isPending, isError: isError, error: error } = imagePrompt;
    return (0, $eF4cA.useMemo)(()=>({
            pendingPrompts: stablePendingPrompts,
            isPending: isPending,
            isError: isError,
            error: error
        }), [
        stablePendingPrompts,
        isPending,
        isError,
        error
    ]);
};

});
parcelRegister("eOKVi", function(module, exports) {

$parcel$export(module.exports, "usePersistImageVariations", () => $ac9a222e34fc848b$export$5a5b2fe4296fedf2);

var $eF4cA = parcelRequire("eF4cA");

var $3ur2P = parcelRequire("3ur2P");
var $7ClmI = parcelRequire("7ClmI");

var $ikOQe = parcelRequire("ikOQe");

var $34B61 = parcelRequire("34B61");
const $ac9a222e34fc848b$export$5a5b2fe4296fedf2 = (projectId)=>{
    const client = (0, $7ClmI.useQueryClient)();
    const updateVideo = (0, $ikOQe.useUpdateVideo)(projectId);
    // `mutateAsync` is bound once per mutation observer, so it keeps the same
    // identity for the life of the hook — unlike the mutation object around it.
    const { mutateAsync: updateVideoAsync } = updateVideo;
    const persist = (0, $eF4cA.useCallback)((newVariations)=>{
        if (!newVariations?.length) return Promise.resolve();
        return (0, $34B61.queueImageVariationsWrite)(projectId, async ()=>{
            const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(projectId));
            const allVariations = new Map(videoData?.imageVariations?.map((v)=>[
                    v.key,
                    v
                ]) ?? []);
            newVariations.forEach((variation)=>{
                allVariations.set(variation.key, variation);
            });
            const imageVariations = (0, $3ur2P.replaceEqualDeep)(videoData?.imageVariations, Array.from(allVariations.values()));
            // Skip the update when the variations did not actually change
            if (imageVariations === videoData?.imageVariations) return;
            await updateVideoAsync({
                imageVariations: imageVariations
            });
        });
    }, [
        client,
        projectId,
        updateVideoAsync
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            persist: persist,
            isPending: updateVideo.isPending
        }), [
        persist,
        updateVideo.isPending
    ]);
};

});


parcelRegister("cvDKE", function(module, exports) {

$parcel$export(module.exports, "useImageReferenceUploads", () => $91b737141d6209b9$export$ae08cfd41d963fe1);

var $eF4cA = parcelRequire("eF4cA");

var $a8sj2 = parcelRequire("a8sj2");

var $afIEk = parcelRequire("afIEk");

var $CGZx1 = parcelRequire("CGZx1");
const $91b737141d6209b9$export$ae08cfd41d963fe1 = ({ projectId: projectId, assets: assets, fallbacks: fallbacks, uploadKeys: uploadKeys, enabled: enabled = true })=>{
    const updateAssets = (0, $CGZx1.useUpdateAssets)(projectId);
    const { mutate: mutateUpdateAssets } = updateAssets;
    // One batched presign for every reference image — an image referenced by
    // several variations is presigned once.
    const filePaths = (0, $eF4cA.useMemo)(()=>Array.from(new Set((assets ?? []).map((asset)=>asset?.filePath).filter(Boolean))), [
        assets
    ]);
    const presign = (0, $a8sj2.usePresignURL)(filePaths, {
        // An empty array is still truthy — do not presign "nothing".
        enabled: filePaths.length > 0
    });
    const urlByPath = (0, $eF4cA.useMemo)(()=>new Map((presign.data?.urls ?? []).map((entry)=>[
                entry?.filePath,
                entry?.presignURL
            ])), [
        presign.data?.urls
    ]);
    const references = (0, $afIEk.useImageReferences)((0, $eF4cA.useMemo)(()=>(assets ?? []).map((asset)=>({
                key: asset?.name,
                // Upload directly by S3 filePath (or presigned URL if already cached)
                // so reference uploads do not wait for the browser presign round-trip.
                url: !uploadKeys || uploadKeys.has(asset?.name) ? urlByPath.get(asset?.filePath) ?? asset?.filePath : undefined,
                // Keyed by file path so the upload is re-done when the asset changes
                cacheKey: asset?.filePath
            })), [
        assets,
        urlByPath,
        uploadKeys
    ]), {
        enabled: enabled
    });
    // Set default images for the variations if the image reference upload fails
    (0, $eF4cA.useEffect)(()=>{
        if (!references.isError || updateAssets.isPending || !fallbacks?.length) return;
        const missing = fallbacks.filter((fallback)=>!!fallback?.asset?.filePath);
        if (!missing.length) return;
        console.warn("Error uploading image reference:", references.error);
        console.info("Setting default images for all variations.");
        mutateUpdateAssets({
            assets: missing.map(({ key: key, asset: asset })=>({
                    ...asset,
                    name: key
                }))
        });
    }, [
        references.isError,
        references.error,
        fallbacks,
        updateAssets.isPending,
        mutateUpdateAssets
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            byKey: references.byKey,
            urlByPath: urlByPath,
            isFetching: references.isFetching,
            isError: references.isError,
            error: references.error,
            isPresigning: presign.isFetching
        }), [
        references.byKey,
        references.isFetching,
        references.isError,
        references.error,
        urlByPath,
        presign.isFetching
    ]);
};

});


parcelRegister("44uR2", function(module, exports) {

$parcel$export(module.exports, "useImageVariation", () => $2f6f782d3fe96112$export$fb317825012193f8);

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $fmJ8d = parcelRequire("fmJ8d");

var $ikOQe = parcelRequire("ikOQe");

var $CGZx1 = parcelRequire("CGZx1");

var $lb17q = parcelRequire("lb17q");

var $6AUdR = parcelRequire("6AUdR");

var $eOKVi = parcelRequire("eOKVi");

var $gJFBV = parcelRequire("gJFBV");

var $2VxAI = parcelRequire("2VxAI");
const $2f6f782d3fe96112$export$fb317825012193f8 = ({ projectId: projectId, variationKey: variationKey, referenceKey: referenceKey, video: video, templateData: templateData })=>{
    // Both queries are cached per project/template, so loading them here costs
    // nothing when the caller passes its own.
    const ownVideo = (0, $ikOQe.useVideo)(projectId);
    const videoQuery = video ?? ownVideo;
    const videoData = videoQuery?.data;
    const ownTemplate = (0, $ikOQe.useVideoTemplate)(videoData?.templateId);
    const template = templateData ?? ownTemplate.data;
    const updateAssets = (0, $CGZx1.useUpdateAssets)(projectId);
    const writer = (0, $eOKVi.usePersistImageVariations)(projectId);
    const { persist: persist } = writer;
    const variation = (0, $eF4cA.useMemo)(()=>(0, $6AUdR.resolveVariation)(template, videoData, variationKey), [
        template,
        videoData,
        variationKey
    ]);
    const asset = (0, $eF4cA.useMemo)(()=>(0, $6AUdR.resolveVariationAsset)(template, videoData, variationKey), [
        template,
        videoData,
        variationKey
    ]);
    const [skippedOverride, setSkippedOverride] = (0, $eF4cA.useState)(null);
    // The switch reacts before its write lands, and so does everything derived
    // from it — the dialog shows the fallback image as soon as it is flipped.
    const isSkipped = skippedOverride ?? !!asset?.isSkipped;
    const fallbackAsset = (0, $eF4cA.useMemo)(()=>(0, $6AUdR.resolveFallbackAsset)(videoData, variation, {
            ...asset,
            isSkipped: isSkipped
        }), [
        videoData,
        variation,
        asset,
        isSkipped
    ]);
    // The images this variation is generated from. `referenceKey` is passed in
    // rather than read from the asset: a generated asset's `referenceKey` points
    // at the record it aliases, not at the image it was made from.
    const referenceAssets = (0, $eF4cA.useMemo)(()=>(0, $6AUdR.resolveReferenceAssets)(videoData?.assets, {
            referenceKey: referenceKey
        }), [
        videoData?.assets,
        referenceKey
    ]);
    const primaryReference = referenceAssets[0] ?? null;
    // What a static prompt is written from; the same context the pipeline
    // resolves it with.
    const { isStatic: isStatic, staticPrompt: staticPrompt } = (0, $eF4cA.useMemo)(()=>{
        const templateVariation = template?.imageVariations?.find((v)=>v.key === variationKey);
        const context = {
            templateId: videoData?.templateId,
            campaign: videoData?.campaigns?.find((c)=>c.id === videoData?.selectedCampaignIds?.[0]) ?? {},
            customer: videoData?.customer,
            visual: referenceAssets[0],
            visuals: referenceAssets
        };
        const prompt = (0, $gJFBV.resolveStaticPrompt)(templateVariation, context);
        // An action's prompt is its label, and an unresolvable one is no default
        // to fall back on.
        return {
            isStatic: !!templateVariation && !(0, $2VxAI.getVariationType)(templateVariation.type)?.action && prompt !== null && (0, $gJFBV.isStaticPrompt)(templateVariation, context),
            staticPrompt: prompt
        };
    }, [
        template,
        videoData,
        variationKey,
        referenceAssets
    ]);
    // Subscribed for this key alone — generation progress ticks often, and a
    // dialog only ever shows one variation.
    const progress = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.imageVariationProgress[variationKey]);
    /** Switches the variation over to its `fallbackKey` asset, or back. */ const setSkipped = (0, $eF4cA.useCallback)((value)=>{
        setSkippedOverride(value);
        updateAssets.mutate({
            assets: [
                {
                    ...videoData?.assets?.find((a)=>a.name === variationKey) ?? {
                        name: variationKey
                    },
                    isSkipped: value
                }
            ]
        }, {
            onSettled: ()=>setSkippedOverride(null)
        });
    }, [
        updateAssets.mutate,
        videoData?.assets,
        variationKey
    ]);
    /**
   * The variation's persisted record, or — when it has none yet, because no
   * prompt was ever generated for it — a seed carrying the identity the
   * generation needs: without `type` the payload switch cannot route it.
   */ const persistedRecord = (0, $eF4cA.useCallback)(()=>videoData?.imageVariations?.find((v)=>v.key === variationKey) ?? {
            key: variationKey,
            type: variation?.type,
            referenceKey: (0, $lb17q.getPrimaryReferenceKey)({
                referenceKey: referenceKey
            }) ?? variation?.referenceKey
        }, [
        videoData?.imageVariations,
        variationKey,
        variation?.type,
        variation?.referenceKey,
        referenceKey
    ]);
    /**
   * Regenerates the variation from `prompt`: the prompt is persisted (and this
   * variation's previous failure cleared), then its images are dropped so the
   * wizard's pipeline generates it again.
   *
   * A `prompt` other than the stored one is the user's own: the record is
   * marked `promptEdited`, which keeps the pipeline from refreshing it (see
   * `useImageVariations`) until a prompt is written for it again. For a static
   * variation the default is the static prompt rather than the stored one, and
   * a blank `prompt` stands for it.
   *
   * Both of the variation's assets go: the one named after it, and the
   * generation record it aliases (`firefly__<key>__<uuid>` /
   * `photoshop__<key>__<uuid>`), which `asset.referenceKey` points at.
   */ const regenerate = (0, $eF4cA.useCallback)(async ({ prompt: prompt } = {})=>{
        const { errorCode: errorCode, errorMessage: errorMessage, ...record } = persistedRecord();
        // Without a `prompt` the stored one stands, edited or not. A static
        // variation's is edited unless the prompt is blank (or is the default).
        const hasPrompt = typeof prompt === "string";
        const isDefault = isStatic && hasPrompt && (!prompt.trim() || prompt.trim() === staticPrompt?.trim());
        const isEdited = hasPrompt ? isStatic ? !isDefault : prompt !== (record.visualPrompt ?? "") : false;
        if (isDefault) delete record.promptEdited;
        try {
            await persist([
                {
                    ...record,
                    key: variationKey,
                    ...hasPrompt ? {
                        visualPrompt: isDefault ? staticPrompt : prompt
                    } : {},
                    ...isEdited ? {
                        promptEdited: true
                    } : {}
                }
            ]);
        } catch (error) {
            // The prompt never landed, so keep the current image rather than
            // dropping it for a generation that would run with the old prompt.
            console.warn("Failed to save the edited prompt:", error);
            return;
        }
        updateAssets.mutate({
            toRemove: [
                {
                    name: asset?.name
                },
                {
                    name: (0, $lb17q.getPrimaryReferenceKey)({
                        referenceKey: asset?.referenceKey
                    })
                }
            ]
        });
    }, [
        persist,
        persistedRecord,
        updateAssets.mutate,
        variationKey,
        asset?.name,
        asset?.referenceKey,
        isStatic,
        staticPrompt
    ]);
    /**
   * Puts a static variation's default prompt back in place of the user's own:
   * `promptEdited` is cleared and the image is left as it is.
   */ const resetPrompt = (0, $eF4cA.useCallback)(()=>{
        const { promptEdited: promptEdited, ...record } = persistedRecord();
        return persist([
            {
                ...record,
                key: variationKey,
                visualPrompt: staticPrompt
            }
        ]).catch((error)=>{
            console.warn("Failed to reset the prompt:", error);
        });
    }, [
        persist,
        persistedRecord,
        variationKey,
        staticPrompt
    ]);
    /**
   * Drops the generated prompt, which is what makes `useImagePrompts` write a
   * fresh one for this variation.
   */ const regeneratePrompt = (0, $eF4cA.useCallback)(()=>{
        // A prompt written for it is no longer the user's own.
        const { promptEdited: promptEdited, ...record } = persistedRecord();
        return persist([
            {
                ...record,
                visualPrompt: null
            }
        ]).catch((error)=>{
            console.warn("Failed to request a new prompt:", error);
        });
    }, [
        persist,
        persistedRecord
    ]);
    /**
   * Regenerates both the prompt and the image — for when what the prompt was
   * written from (the campaign) has changed: the prompt is dropped (and a
   * previous failure cleared) so `useImagePrompts` writes a fresh one, then
   * the images are dropped so the pipeline generates from it.
   *
   * One write rather than `regeneratePrompt()` followed by `regenerate()`: the
   * latter reads the record from this render's video, so it would put the old
   * prompt back.
   */ const regenerateFromCampaign = (0, $eF4cA.useCallback)(async ()=>{
        // A prompt written for it is no longer the user's own.
        const { errorCode: errorCode, errorMessage: errorMessage, promptEdited: promptEdited, ...record } = persistedRecord();
        try {
            await persist([
                {
                    ...record,
                    key: variationKey,
                    visualPrompt: null
                }
            ]);
        } catch (error) {
            console.warn("Failed to request a new prompt:", error);
            return;
        }
        const toRemove = [
            asset?.name,
            (0, $lb17q.getPrimaryReferenceKey)({
                referenceKey: asset?.referenceKey
            })
        ].filter(Boolean).map((name)=>({
                name: name
            }));
        // Without an image there is nothing to drop — the fresh prompt alone makes
        // the pipeline generate it.
        if (toRemove.length) updateAssets.mutate({
            toRemove: toRemove
        });
    }, [
        persist,
        persistedRecord,
        updateAssets.mutate,
        variationKey,
        asset?.name,
        asset?.referenceKey
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            video: videoQuery,
            template: template,
            variation: variation,
            asset: asset,
            fallbackAsset: fallbackAsset,
            referenceAssets: referenceAssets,
            primaryReference: primaryReference,
            progress: progress,
            isGenerating: !!progress,
            // A `null` prompt is the "generate me a prompt" marker the prompts hook
            // picks up, so the variation is waiting for one.
            isPromptPending: variation?.visualPrompt === null,
            // The user's own prompt, which is kept rather than refreshed.
            isPromptEdited: !!variation?.promptEdited,
            isStatic: // Its prompt is the type's own, not written by an LLM — see `resetPrompt`.
            isStatic,
            staticPrompt: staticPrompt,
            isBusy: writer.isPending || updateAssets.isPending,
            isSkipped: isSkipped,
            setSkipped: setSkipped,
            regenerate: regenerate,
            regeneratePrompt: regeneratePrompt,
            resetPrompt: resetPrompt,
            regenerateFromCampaign: regenerateFromCampaign
        }), [
        videoQuery,
        template,
        variation,
        asset,
        fallbackAsset,
        referenceAssets,
        primaryReference,
        progress,
        writer.isPending,
        updateAssets.isPending,
        isSkipped,
        setSkipped,
        isStatic,
        staticPrompt,
        regenerate,
        regeneratePrompt,
        resetPrompt,
        regenerateFromCampaign
    ]);
};

});



parcelRegister("8jegM", function(module, exports) {

$parcel$export(module.exports, "TemplateAssets", () => TemplateAssets);

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $208Op = parcelRequire("208Op");
var $yuTTo = parcelRequire("yuTTo");

var $77tch = parcelRequire("77tch");

var $l1gUk = parcelRequire("l1gUk");
const NO_ASSET_NAMES = [];
const TemplateAssets = ({ excludedAssetNames = NO_ASSET_NAMES })=>{
    const { video, template, selectedCampaign, scrapedColors: colors = [], handleUploadAssets: onDrop, handleColorChange: onColorChange, handleAssetMenuAction } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    // What the use-case `condition`s are evaluated with.
    const scope = {
        video: video,
        template: template,
        selectedCampaign: selectedCampaign
    };
    const templateAssets = (0, $eF4cA.useMemo)(()=>template.data?.assets || [], [
        template.data?.assets
    ]);
    const shownAssets = (0, $eF4cA.useMemo)(()=>templateAssets.filter((asset)=>!excludedAssetNames.includes(asset.name)), [
        templateAssets,
        excludedAssetNames
    ]);
    const extendedAssets = (0, $eF4cA.useMemo)(()=>(0, $l1gUk.getExtendedTemplateAssets)(shownAssets, video.data?.assets), [
        shownAssets,
        video.data?.assets
    ]);
    const brandAssets = (0, $eF4cA.useMemo)(()=>Object.values(extendedAssets).filter((asset)=>[
                "Logo",
                "App-icon"
            ].includes(asset.name)) || [], [
        extendedAssets
    ]);
    const visualAssets = (0, $eF4cA.useMemo)(()=>Object.values(extendedAssets).filter((asset)=>asset.type === "image" && ![
                "Logo",
                "App-icon"
            ].includes(asset.name)) || [], [
        extendedAssets
    ]);
    const onDelete = (asset)=>handleAssetMenuAction("delete", asset);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: " sd182 _ta182",
            children: [
                !!brandAssets?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "Branding"
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 Up182 qp182",
                    children: [
                        shownAssets.filter((asset)=>asset.type === "color").map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateColorAsset), {
                                asset: asset,
                                selectedAsset: extendedAssets[asset.name],
                                // The swatches are too narrow for a description.
                                description: null,
                                scope: scope,
                                colors: colors,
                                onChange: onColorChange
                            }, asset.name)),
                        brandAssets.map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateImageAsset), {
                                asset: asset,
                                selectedAsset: asset,
                                scope: scope,
                                showDetails: false,
                                onDrop: onDrop,
                                styles: " _s93ojn182 _ua182 _vb182"
                            }, asset.name))
                    ]
                }),
                visualAssets?.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 JJ182 Gy182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "Campaign visuals"
                    })
                }),
                video.data?.templateId === "csc-overview" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 Ue182 qe182 Jc182 GA182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Campaign focus:"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            styles: " xd182 _xa182 xX0cczbc182 _xX0cczba182",
                            children: video.data?.campaigns?.find((c)=>c.id === video.data?.selectedCampaignIds?.[0])?.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " sd182 _wb182 Up182 qp182",
                    children: visualAssets.map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateImageAsset), {
                            asset: asset,
                            selectedAsset: asset,
                            scope: scope,
                            onDrop: onDrop,
                            onDelete: onDelete,
                            children: asset?.context?.map((contextItem, cix)=>!!eval(contextItem?.value) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                    label: contextItem.label,
                                    size: "S",
                                    value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                        children: eval(contextItem.value)
                                    })
                                }, cix))
                        }, asset.name))
                })
            ]
        })
    });
};
TemplateAssets.propTypes = {
    excludedAssetNames: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
};

});
parcelRegister("77tch", function(module, exports) {

$parcel$export(module.exports, "VideoWizardContext", () => $52efd5ca4518952d$export$eaae86b5e60fb8a);

var $eF4cA = parcelRequire("eF4cA");
const $52efd5ca4518952d$export$eaae86b5e60fb8a = /*#__PURE__*/ (0, $eF4cA.createContext)(null);

});



var $dx4lB = parcelRequire("dx4lB");

var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $6i9K0 = parcelRequire("6i9K0");

var $byQav = parcelRequire("byQav");

var $59NSd = parcelRequire("59NSd");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $eAGoL = parcelRequire("eAGoL");
const $aa72e96078455c59$var$handlers = {};
const $aa72e96078455c59$var$instrumented = {};
function $aa72e96078455c59$export$a4e09611e30da72e(type, handler) {
    $aa72e96078455c59$var$handlers[type] = $aa72e96078455c59$var$handlers[type] || [];
    $aa72e96078455c59$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $aa72e96078455c59$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $aa72e96078455c59$export$b17eab759a1cb5fe() {
    Object.keys($aa72e96078455c59$var$handlers).forEach((key)=>{
        $aa72e96078455c59$var$handlers[key] = void 0;
    });
}
function $aa72e96078455c59$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$aa72e96078455c59$var$instrumented[type]) {
        $aa72e96078455c59$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $aa72e96078455c59$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $aa72e96078455c59$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $eAGoL.getFunctionName)(handler)}
Error:`, e);
    }
}


const $04de36801c02842a$var$_filter = /* @__PURE__ */ new Set([]);
function $04de36801c02842a$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    const removeHandler = (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, $04de36801c02842a$export$b80c01837473f7bc);
    return removeHandler;
}
function $04de36801c02842a$export$7444162f8bcc9c91(filter) {
    for (const f of filter)$04de36801c02842a$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$04de36801c02842a$var$_filter.delete(f);
    };
}
const $04de36801c02842a$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $04de36801c02842a$export$b80c01837473f7bc() {
    if (!("console" in (0, $59NSd.GLOBAL_OBJ))) return;
    (0, $cG2xs.CONSOLE_LEVELS).forEach(function(level) {
        if ($04de36801c02842a$var$instrumentedLevels.has(level) || !(level in (0, $59NSd.GLOBAL_OBJ).console)) return;
        $04de36801c02842a$var$instrumentedLevels.add(level);
        (0, $6i9K0.fill)((0, $59NSd.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $cG2xs.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = (0, $cG2xs.originalConsoleMethods)[level];
                const isFiltered = $04de36801c02842a$var$_filter.size && typeof firstArg === "string" && (0, $byQav.stringMatchesSomePattern)(firstArg, $04de36801c02842a$var$_filter);
                if (!isFiltered) (0, $aa72e96078455c59$export$b18c893e424d3127)("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).isEnabled()) log?.apply((0, $59NSd.GLOBAL_OBJ).console, args);
            };
        });
    });
}



var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");
const $d016c01c54e4f9f6$export$b14a8888f80a0b3e = [];
function $d016c01c54e4f9f6$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $d016c01c54e4f9f6$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $d016c01c54e4f9f6$var$filterDuplicates(integrations);
}
function $d016c01c54e4f9f6$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $d016c01c54e4f9f6$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $d016c01c54e4f9f6$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $d016c01c54e4f9f6$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$d016c01c54e4f9f6$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $d016c01c54e4f9f6$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log(`Integration installed: ${integration.name}`);
}
function $d016c01c54e4f9f6$export$2d8f5188773bcddd(integration) {
    const client = (0, $gqV7N.getClient)();
    if (!client) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $d016c01c54e4f9f6$export$2323046b9414659f(fn) {
    return fn;
}
function $d016c01c54e4f9f6$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}



var $2MLxn = parcelRequire("2MLxn");

var $cG2xs = parcelRequire("cG2xs");

var $exje8 = parcelRequire("exje8");

var $fuLLi = parcelRequire("fuLLi");

var $gJxqo = parcelRequire("gJxqo");

var $4AWuw = parcelRequire("4AWuw");

var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $exje8 = parcelRequire("exje8");

var $ea5SN = parcelRequire("ea5SN");

var $1Wbj3 = parcelRequire("1Wbj3");

var $c5ls6 = parcelRequire("c5ls6");
const $0f459b6022082a02$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $0f459b6022082a02$var$_sequenceNumber = 0;
let $0f459b6022082a02$var$_previousTimestampMs;
function $0f459b6022082a02$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($0f459b6022082a02$var$_previousTimestampMs !== void 0 && nowMs !== $0f459b6022082a02$var$_previousTimestampMs) $0f459b6022082a02$var$_sequenceNumber = 0;
    const value = $0f459b6022082a02$var$_sequenceNumber;
    $0f459b6022082a02$var$_sequenceNumber++;
    $0f459b6022082a02$var$_previousTimestampMs = nowMs;
    return {
        key: $0f459b6022082a02$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}



var $gqV7N = parcelRequire("gqV7N");

var $cvdrG = parcelRequire("cvdrG");

var $kn25x = parcelRequire("kn25x");
function $27be9f68486c63a9$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return (0, $gqV7N.withScope)(scope, ()=>{
        const span = (0, $kn25x.getActiveSpan)();
        const traceContext = span ? (0, $kn25x.spanToTraceContext)(span) : (0, $gqV7N.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $cvdrG.getDynamicSamplingContextFromSpan)(span) : (0, $cvdrG.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


const $0512c94c4a6f85d7$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};



var $8U4FY = parcelRequire("8U4FY");

var $4AWuw = parcelRequire("4AWuw");

var $8U4FY = parcelRequire("8U4FY");

var $fuLLi = parcelRequire("fuLLi");

var $55uN4 = parcelRequire("55uN4");

var $59NSd = parcelRequire("59NSd");
function $f42278b5280d50b5$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $f42278b5280d50b5$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $f42278b5280d50b5$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $f42278b5280d50b5$export$604a45d95a155e2b(envelope, types) {
    return $f42278b5280d50b5$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $f42278b5280d50b5$var$encodeUTF8(input) {
    const carrier = (0, $4AWuw.getSentryCarrier)((0, $59NSd.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $f42278b5280d50b5$var$decodeUTF8(input) {
    const carrier = (0, $4AWuw.getSentryCarrier)((0, $59NSd.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $f42278b5280d50b5$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $f42278b5280d50b5$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $f42278b5280d50b5$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $fuLLi.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $f42278b5280d50b5$var$concatBuffers(parts);
}
function $f42278b5280d50b5$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $f42278b5280d50b5$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $f42278b5280d50b5$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($f42278b5280d50b5$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $f42278b5280d50b5$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $f42278b5280d50b5$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $f42278b5280d50b5$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $f42278b5280d50b5$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $f42278b5280d50b5$var$_isOverriddenType(type) {
    return type in $f42278b5280d50b5$var$DATA_CATEGORY_OVERRIDES;
}
function $f42278b5280d50b5$export$b11169581eeaf237(type) {
    return $f42278b5280d50b5$var$_isOverriddenType(type) ? $f42278b5280d50b5$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $f42278b5280d50b5$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $f42278b5280d50b5$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $55uN4.safeDateNow)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8U4FY.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}



var $iBv3y = parcelRequire("iBv3y");

var $59NSd = parcelRequire("59NSd");
function $aa9bd5b4b8a52a16$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $iBv3y.isNodeEnv)() || $aa9bd5b4b8a52a16$var$isElectronNodeRenderer());
}
function $aa9bd5b4b8a52a16$var$isElectronNodeRenderer() {
    const process = (0, $59NSd.GLOBAL_OBJ).process;
    return process?.type === "renderer";
}


function $5af1919f6e7b2fe8$export$efdf3b13edb1118e(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...(0, $aa9bd5b4b8a52a16$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $5af1919f6e7b2fe8$export$cdcd668e6516443f(logs, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $8U4FY.dsnToString)(dsn);
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)(headers, [
        $5af1919f6e7b2fe8$export$efdf3b13edb1118e(logs, inferUserData)
    ]);
}


const $622b2e5ee9ce710a$var$MAX_LOG_BUFFER_SIZE = 100;
function $622b2e5ee9ce710a$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $622b2e5ee9ce710a$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $622b2e5ee9ce710a$var$_getBufferMap();
    const logBuffer = $622b2e5ee9ce710a$export$5365c9902fb9e770(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $622b2e5ee9ce710a$var$MAX_LOG_BUFFER_SIZE) {
        $622b2e5ee9ce710a$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $622b2e5ee9ce710a$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $gqV7N.getCurrentScope)(), captureSerializedLog = $622b2e5ee9ce710a$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $gqV7N.getClient)();
    if (!client) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = true, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, $27be9f68486c63a9$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $ea5SN.getCombinedScopeData)((0, $gqV7N.getIsolationScope)(), currentScope);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $exje8.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $1Wbj3._getSpanForScope)(currentScope);
    $622b2e5ee9ce710a$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? (0, $cG2xs.consoleSandbox)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $c5ls6.timestampInSeconds)();
    const sequenceAttr = (0, $0f459b6022082a02$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $622b2e5ee9ce710a$export$b879a166f5ac57c8(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $0512c94c4a6f85d7$export$4fb50c0840d636d1)[level],
        attributes: $622b2e5ee9ce710a$var$sanitizeLogAttributes({
            ...(0, $gJxqo.serializeAttributes)(scopeAttributes),
            ...(0, $gJxqo.serializeAttributes)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $622b2e5ee9ce710a$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $622b2e5ee9ce710a$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $5af1919f6e7b2fe8$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $622b2e5ee9ce710a$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope);
}
function $622b2e5ee9ce710a$export$5365c9902fb9e770(client) {
    return $622b2e5ee9ce710a$var$_getBufferMap().get(client);
}
function $622b2e5ee9ce710a$var$_getBufferMap() {
    return (0, $4AWuw.getGlobalSingleton)("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $622b2e5ee9ce710a$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $622b2e5ee9ce710a$export$b879a166f5ac57c8(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $622b2e5ee9ce710a$export$b879a166f5ac57c8(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $622b2e5ee9ce710a$export$b879a166f5ac57c8(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}



var $exje8 = parcelRequire("exje8");

var $fuLLi = parcelRequire("fuLLi");

var $59NSd = parcelRequire("59NSd");
function $4eb8da4347e3c259$export$685fa2ac963d3401(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in (0, $59NSd.GLOBAL_OBJ) && typeof (0, $59NSd.GLOBAL_OBJ).util.format === "function" ? (0, $59NSd.GLOBAL_OBJ).util.format(...values) : $4eb8da4347e3c259$export$c0f6d13f2f9c0ad9(values, normalizeDepth, normalizeMaxBreadth);
}
function $4eb8da4347e3c259$export$c0f6d13f2f9c0ad9(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>(0, $exje8.isPrimitive)(value) ? String(value) : JSON.stringify((0, $fuLLi.normalize)(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $4eb8da4347e3c259$export$fd7d986bffc85771(str) {
    return /%[sdifocO]/.test(str);
}
function $4eb8da4347e3c259$export$a85dac26b5c120d1(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}


const $b79e1852664f0dff$var$INTEGRATION_NAME = "ConsoleLogs";
const $b79e1852664f0dff$var$DEFAULT_ATTRIBUTES = {
    [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.log.console"
};
const $b79e1852664f0dff$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || (0, $cG2xs.CONSOLE_LEVELS);
    return {
        name: $b79e1852664f0dff$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = (0, $04de36801c02842a$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $gqV7N.getClient)() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${(0, $4eb8da4347e3c259$export$685fa2ac963d3401)(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        (0, $622b2e5ee9ce710a$export$3ab3d16b9eebd986)({
                            level: "error",
                            message: assertionMessage,
                            attributes: $b79e1852664f0dff$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$b79e1852664f0dff$var$DEFAULT_ATTRIBUTES
                };
                if ((0, $exje8.isPlainObject)(firstArg)) {
                    Object.assign(attributes, (0, $fuLLi.normalize)(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = (0, $fuLLi.normalize)(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !(0, $4eb8da4347e3c259$export$fd7d986bffc85771)(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = (0, $4eb8da4347e3c259$export$a85dac26b5c120d1)(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? (0, $fuLLi.normalize)(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                (0, $622b2e5ee9ce710a$export$3ab3d16b9eebd986)({
                    level: isLevelLog ? "info" : level,
                    message: (0, $4eb8da4347e3c259$export$685fa2ac963d3401)(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $b79e1852664f0dff$export$63e034b6c5b5b12a = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($b79e1852664f0dff$var$_consoleLoggingIntegration);


var $gqV7N = parcelRequire("gqV7N");


var $2MLxn = parcelRequire("2MLxn");

var $kn25x = parcelRequire("kn25x");
const $b622512e585ae8f9$var$INTEGRATION_NAME = "ConversationId";
const $b622512e585ae8f9$var$_conversationIdIntegration = ()=>{
    return {
        name: $b622512e585ae8f9$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = (0, $gqV7N.getCurrentScope)().getScopeData();
                const isolationScopeData = (0, $gqV7N.getIsolationScope)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = (0, $kn25x.spanToJSON)(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute((0, $2MLxn.GEN_AI_CONVERSATION_ID_ATTRIBUTE), conversationId);
                }
            });
        }
    };
};
const $b622512e585ae8f9$export$97457a453081a5b3 = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($b622512e585ae8f9$var$_conversationIdIntegration);


var $dn9bA = parcelRequire("dn9bA");


var $cG2xs = parcelRequire("cG2xs");

var $eAGoL = parcelRequire("eAGoL");
const $6b62cc03ca60ffd4$var$INTEGRATION_NAME = "Dedupe";
const $6b62cc03ca60ffd4$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6b62cc03ca60ffd4$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($6b62cc03ca60ffd4$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $6b62cc03ca60ffd4$export$6d39aa44cd0c7567 = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($6b62cc03ca60ffd4$var$_dedupeIntegration);
function $6b62cc03ca60ffd4$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6b62cc03ca60ffd4$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6b62cc03ca60ffd4$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6b62cc03ca60ffd4$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6b62cc03ca60ffd4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6b62cc03ca60ffd4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6b62cc03ca60ffd4$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6b62cc03ca60ffd4$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6b62cc03ca60ffd4$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6b62cc03ca60ffd4$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6b62cc03ca60ffd4$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6b62cc03ca60ffd4$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $eAGoL.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $eAGoL.getFramesFromEvent)(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6b62cc03ca60ffd4$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $6b62cc03ca60ffd4$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}


var $gqV7N = parcelRequire("gqV7N");


var $6i9K0 = parcelRequire("6i9K0");
const $7d7fd81a1e80fb9a$var$INTEGRATION_NAME = "FunctionToString";
const $7d7fd81a1e80fb9a$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $7d7fd81a1e80fb9a$var$_functionToStringIntegration = ()=>{
    return {
        name: $7d7fd81a1e80fb9a$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $6i9K0.getOriginalFunction)(this);
                    let unwrappedFunction;
                    try {
                        if ($7d7fd81a1e80fb9a$var$SETUP_CLIENTS.has((0, $gqV7N.getClient)()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $7d7fd81a1e80fb9a$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $7d7fd81a1e80fb9a$export$7918117e9202e4fb = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($7d7fd81a1e80fb9a$var$_functionToStringIntegration);


var $dn9bA = parcelRequire("dn9bA");


var $cG2xs = parcelRequire("cG2xs");

var $auwZv = parcelRequire("auwZv");

var $1nf4J = parcelRequire("1nf4J");

var $byQav = parcelRequire("byQav");
const $afcf62d73cd7f8d3$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /Java exception was raised during method invocation$/,
    // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065, https://github.com/getsentry/sentry-javascript/issues/23733)
    /Java object is gone$/
];
const $afcf62d73cd7f8d3$var$INTEGRATION_NAME = "EventFilters";
const $afcf62d73cd7f8d3$export$9a84f518c163c552 = (0, $d016c01c54e4f9f6$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $afcf62d73cd7f8d3$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $afcf62d73cd7f8d3$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $afcf62d73cd7f8d3$var$_mergeOptions(options, clientOptions);
            }
            return $afcf62d73cd7f8d3$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $afcf62d73cd7f8d3$export$cb3c5c2ceb9818ba = (0, $d016c01c54e4f9f6$export$2323046b9414659f)((options = {})=>{
    return {
        ...$afcf62d73cd7f8d3$export$9a84f518c163c552(options),
        name: "InboundFilters"
    };
});
function $afcf62d73cd7f8d3$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $afcf62d73cd7f8d3$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $afcf62d73cd7f8d3$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($afcf62d73cd7f8d3$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${(0, $1nf4J.getEventDescription)(event)}`);
            return true;
        }
        if ($afcf62d73cd7f8d3$var$_isUselessError(event)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${(0, $1nf4J.getEventDescription)(event)}`);
            return true;
        }
        if ($afcf62d73cd7f8d3$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${(0, $1nf4J.getEventDescription)(event)}.
Url: ${$afcf62d73cd7f8d3$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$afcf62d73cd7f8d3$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${(0, $1nf4J.getEventDescription)(event)}.
Url: ${$afcf62d73cd7f8d3$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($afcf62d73cd7f8d3$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${(0, $1nf4J.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $afcf62d73cd7f8d3$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $auwZv.getPossibleEventMessages)(event).some((message)=>(0, $byQav.stringMatchesSomePattern)(message, ignoreErrors));
}
function $afcf62d73cd7f8d3$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $byQav.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $afcf62d73cd7f8d3$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $afcf62d73cd7f8d3$var$_getEventFilterUrl(event);
    return !url ? false : (0, $byQav.stringMatchesSomePattern)(url, denyUrls);
}
function $afcf62d73cd7f8d3$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $afcf62d73cd7f8d3$var$_getEventFilterUrl(event);
    return !url ? true : (0, $byQav.stringMatchesSomePattern)(url, allowUrls);
}
function $afcf62d73cd7f8d3$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $afcf62d73cd7f8d3$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $afcf62d73cd7f8d3$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error(`Cannot extract url for event ${(0, $1nf4J.getEventDescription)(event)}`);
        return null;
    }
}
function $afcf62d73cd7f8d3$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}


var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");
function $05e769100b279f33$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $dn9bA.DEBUG_BUILD) (0, $cG2xs.debug).enable();
        else (0, $cG2xs.consoleSandbox)(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $gqV7N.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $05e769100b279f33$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
function $05e769100b279f33$export$ecb76f41d43c0e43(client) {
    (0, $gqV7N.getCurrentScope)().setClient(client);
}


var $fuLLi = parcelRequire("fuLLi");
var $eAGoL = parcelRequire("eAGoL");
function $712e2bfc0fdf8780$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $712e2bfc0fdf8780$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}


var $a6Xop = parcelRequire("a6Xop");
function $ff86e8fd4d841bde$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: (0, $a6Xop.SDK_VERSION)
            }));
        sdk.version = (0, $a6Xop.SDK_VERSION);
    }
}


var $8U4FY = parcelRequire("8U4FY");
const $069bd6bc64549e6a$export$9207631ea4ce5c48 = "7";
function $069bd6bc64549e6a$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $069bd6bc64549e6a$var$_getIngestEndpoint(dsn) {
    return `${$069bd6bc64549e6a$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $069bd6bc64549e6a$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $069bd6bc64549e6a$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $069bd6bc64549e6a$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$069bd6bc64549e6a$var$_getIngestEndpoint(dsn)}?${$069bd6bc64549e6a$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $069bd6bc64549e6a$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $8U4FY.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$069bd6bc64549e6a$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $8U4FY.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}



var $7LgVW = parcelRequire("7LgVW");

var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $cvdrG = parcelRequire("cvdrG");

var $6i9K0 = parcelRequire("6i9K0");
function $d2ceb212c8cdae62$export$d3f49b33a1f44720(callback) {
    (0, $6i9K0.addNonEnumerableProperty)(callback, "_streamed", true);
    return callback;
}
function $d2ceb212c8cdae62$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}



var $8U4FY = parcelRequire("8U4FY");


var $55uN4 = parcelRequire("55uN4");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $byQav = parcelRequire("byQav");
function $89e1fde7b7661cf5$var$logIgnoredSpan(droppedSpan) {
    (0, $cG2xs.debug).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $89e1fde7b7661cf5$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($89e1fde7b7661cf5$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $byQav.isMatchingPattern)(span.description, pattern)) {
                (0, $dn9bA.DEBUG_BUILD) && $89e1fde7b7661cf5$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $byQav.isMatchingPattern)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $byQav.isMatchingPattern)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$89e1fde7b7661cf5$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $dn9bA.DEBUG_BUILD) && $89e1fde7b7661cf5$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $89e1fde7b7661cf5$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $byQav.isMatchingPattern)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $89e1fde7b7661cf5$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $89e1fde7b7661cf5$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}



var $kn25x = parcelRequire("kn25x");
function $4b2f06588bfb9025$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $4b2f06588bfb9025$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f42278b5280d50b5$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $55uN4.safeDateNow)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8U4FY.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $4b2f06588bfb9025$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f42278b5280d50b5$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $4b2f06588bfb9025$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $f42278b5280d50b5$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $4b2f06588bfb9025$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $cvdrG.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $55uN4.safeDateNow)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8U4FY.dsnToString)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $kn25x.spanToJSON)(span);
        return !(0, $89e1fde7b7661cf5$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $kn25x.spanToJSON)(span);
        const processedSpan = !(0, $d2ceb212c8cdae62$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $kn25x.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $kn25x.spanToJSON);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f42278b5280d50b5$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)(headers, items);
}





var $gJxqo = parcelRequire("gJxqo");

var $4AWuw = parcelRequire("4AWuw");

var $gqV7N = parcelRequire("gqV7N");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $ea5SN = parcelRequire("ea5SN");

var $1Wbj3 = parcelRequire("1Wbj3");

var $c5ls6 = parcelRequire("c5ls6");



var $8U4FY = parcelRequire("8U4FY");


function $5e30aa0561a9c662$export$58e45eb52ad1077d(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...(0, $aa9bd5b4b8a52a16$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $5e30aa0561a9c662$export$f23eb96e33154901(metrics, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $8U4FY.dsnToString)(dsn);
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)(headers, [
        $5e30aa0561a9c662$export$58e45eb52ad1077d(metrics, inferUserData)
    ]);
}


const $042c9f610a204ad5$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $042c9f610a204ad5$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $042c9f610a204ad5$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $042c9f610a204ad5$var$_getBufferMap();
    const metricBuffer = $042c9f610a204ad5$export$49385134251b08ff(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $042c9f610a204ad5$var$MAX_METRIC_BUFFER_SIZE) {
        $042c9f610a204ad5$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $042c9f610a204ad5$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $042c9f610a204ad5$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $042c9f610a204ad5$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = (0, $27be9f68486c63a9$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $1Wbj3._getSpanForScope)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = (0, $c5ls6.timestampInSeconds)();
    const sequenceAttr = (0, $0f459b6022082a02$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $gJxqo.serializeAttributes)(scopeAttributes),
            ...(0, $gJxqo.serializeAttributes)(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $042c9f610a204ad5$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $gqV7N.getCurrentScope)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $042c9f610a204ad5$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $gqV7N.getClient)();
    if (!client) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = (0, $ea5SN.getCombinedScopeData)((0, $gqV7N.getIsolationScope)(), currentScope);
    const enrichedMetric = $042c9f610a204ad5$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $042c9f610a204ad5$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $042c9f610a204ad5$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $042c9f610a204ad5$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $5e30aa0561a9c662$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $042c9f610a204ad5$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope);
}
function $042c9f610a204ad5$export$49385134251b08ff(client) {
    return $042c9f610a204ad5$var$_getBufferMap().get(client);
}
function $042c9f610a204ad5$var$_getBufferMap() {
    return (0, $4AWuw.getGlobalSingleton)("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}



var $2KiSw = parcelRequire("2KiSw");

var $cvdrG = parcelRequire("cvdrG");


function $69082917fa0c173c$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}



var $kn25x = parcelRequire("kn25x");
function $57b4d85b371b5cc6$export$f6f6d4b2a7942521(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return (0, $kn25x.streamedSpanJsonToSerializedSpan)(streamedSpan);
}


function $0404080cf9c818a7$export$9aeb9a2b899f8587(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || (0, $69082917fa0c173c$export$6ea47215d699c04a)(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push((0, $57b4d85b371b5cc6$export$f6f6d4b2a7942521)(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...(0, $aa9bd5b4b8a52a16$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}



var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");


var $j3ztq = parcelRequire("j3ztq");
function $752b2045d0b96517$export$630056cb83d87863(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}


const $3f9c76d04462ddf3$export$c8667f1887a128dc = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $3f9c76d04462ddf3$export$85a4f67f852183e6(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return (0, $j3ztq.rejectedSyncPromise)($3f9c76d04462ddf3$export$c8667f1887a128dc);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return (0, $j3ztq.resolvedSyncPromise)(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $752b2045d0b96517$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



var $55uN4 = parcelRequire("55uN4");
const $cc9ced9192f551f6$export$b09ce39faaeb1e7c = 60000;
function $cc9ced9192f551f6$export$615352e17ed7741(header, now = (0, $55uN4.safeDateNow)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $cc9ced9192f551f6$export$b09ce39faaeb1e7c;
}
function $cc9ced9192f551f6$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $cc9ced9192f551f6$export$6c91fec22056810a(limits, dataCategory, now = (0, $55uN4.safeDateNow)()) {
    return $cc9ced9192f551f6$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $cc9ced9192f551f6$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $55uN4.safeDateNow)()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $cc9ced9192f551f6$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $477dc03aa082bbce$export$e515cf6dfd2f98b8 = 64;
function $477dc03aa082bbce$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $3f9c76d04462ddf3$export$85a4f67f852183e6)(options.bufferSize || $477dc03aa082bbce$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        (0, $f42278b5280d50b5$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f42278b5280d50b5$export$b11169581eeaf237)(type);
            if ((0, $cc9ced9192f551f6$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $f42278b5280d50b5$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ((0, $f42278b5280d50b5$export$604a45d95a155e2b)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $f42278b5280d50b5$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $f42278b5280d50b5$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f42278b5280d50b5$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ((0, $dn9bA.DEBUG_BUILD) && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) (0, $cG2xs.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $cc9ced9192f551f6$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $3f9c76d04462ddf3$export$c8667f1887a128dc)) {
                (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




var $c5ls6 = parcelRequire("c5ls6");
function $85f690dfffd74086$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $c5ls6.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}



var $cG2xs = parcelRequire("cG2xs");

var $8U4FY = parcelRequire("8U4FY");


var $auwZv = parcelRequire("auwZv");

var $exje8 = parcelRequire("exje8");

var $aje4A = parcelRequire("aje4A");

var $1nf4J = parcelRequire("1nf4J");

var $1s5dy = parcelRequire("1s5dy");

var $9rdlm = parcelRequire("9rdlm");


var $55uN4 = parcelRequire("55uN4");


var $kn25x = parcelRequire("kn25x");


var $2MLxn = parcelRequire("2MLxn");
function $33b18298542aa71c$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $2MLxn.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $2MLxn.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $33b18298542aa71c$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


const $3edb0b56e607947b$export$59adc876c1ebd512 = "[Filtered]";
const $3edb0b56e607947b$export$8d9b1945e94c47d = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $3edb0b56e607947b$export$cdee6254fbd57505 = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $3edb0b56e607947b$export$6f34743829a9a6fb = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];


function $d3c9abbf1551263e$export$8d055982fdc6ee04(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: (0, $3edb0b56e607947b$export$8d9b1945e94c47d)
        },
        httpHeaders: {
            request: {
                deny: (0, $3edb0b56e607947b$export$8d9b1945e94c47d)
            },
            response: {
                deny: (0, $3edb0b56e607947b$export$8d9b1945e94c47d)
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: (0, $3edb0b56e607947b$export$8d9b1945e94c47d)
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}


const $f670a76cf227f537$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $f670a76cf227f537$var$isCollectBehavior(value) {
    return typeof value === "boolean" || "allow" in value || "deny" in value;
}
function $f670a76cf227f537$var$resolveHttpHeaders(httpHeaders, base) {
    if (httpHeaders === void 0) return {
        ...base.httpHeaders
    };
    if ($f670a76cf227f537$var$isCollectBehavior(httpHeaders)) return {
        request: httpHeaders,
        response: httpHeaders
    };
    return {
        request: httpHeaders.request ?? base.httpHeaders.request,
        response: httpHeaders.response ?? base.httpHeaders.response
    };
}
function $f670a76cf227f537$export$e0e409941f20a4c(options) {
    const base = options.dataCollection != null ? $f670a76cf227f537$var$DEFAULTS : (0, $d3c9abbf1551263e$export$8d055982fdc6ee04)(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: $f670a76cf227f537$var$resolveHttpHeaders(dc.httpHeaders, base),
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}


const $4c5acf3172b33521$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $4c5acf3172b33521$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $4c5acf3172b33521$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $4c5acf3172b33521$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $4c5acf3172b33521$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $4c5acf3172b33521$var$_makeInternalError(message) {
    return {
        message: message,
        [$4c5acf3172b33521$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $4c5acf3172b33521$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$4c5acf3172b33521$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $4c5acf3172b33521$var$_isInternalError(error) {
    return (0, $exje8.isObjectLike)(error) && $4c5acf3172b33521$var$INTERNAL_ERROR_SYMBOL in error;
}
function $4c5acf3172b33521$var$_isDoNotSendEventError(error) {
    return (0, $exje8.isObjectLike)(error) && $4c5acf3172b33521$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $4c5acf3172b33521$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $4c5acf3172b33521$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = (0, $752b2045d0b96517$export$630056cb83d87863)(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $4c5acf3172b33521$export$1f2bb630327ac4b6 {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $3f9c76d04462ddf3$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $477dc03aa082bbce$export$e515cf6dfd2f98b8));
        this._dataCollection = (0, $f670a76cf227f537$export$e0e409941f20a4c)(options);
        if (options.dsn) this._dsn = (0, $8U4FY.makeDsn)(options.dsn);
        else (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $069bd6bc64549e6a$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs ?? true;
        if (this._options.enableLogs) $4c5acf3172b33521$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $4c5acf3172b33521$var$estimateLogSizeInBytes, (0, $622b2e5ee9ce710a$export$f8ed83d3b6a0b504));
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $4c5acf3172b33521$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $4c5acf3172b33521$var$estimateMetricSizeInBytes, (0, $042c9f610a204ad5$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $1nf4J.uuid4)();
        if ((0, $1nf4J.checkOrSetAlreadyCaught)(exception)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log($4c5acf3172b33521$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $1nf4J.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $exje8.isParameterizedString)(message) ? message : String(message);
        const isMessage = (0, $exje8.isPrimitive)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $1nf4J.uuid4)();
        if (hint?.originalException && (0, $1nf4J.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log($4c5acf3172b33521$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $4c5acf3172b33521$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        (0, $2KiSw.updateSession)(session, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        (0, $d016c01c54e4f9f6$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        if (!isAlreadyInstalled) (0, $d016c01c54e4f9f6$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = (0, $0404080cf9c818a7$export$9aeb9a2b899f8587)(event, this);
        let env = (0, $4b2f06588bfb9025$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        if (!(0, $auwZv.isInternalException)(hint)) for (const attachment of hint.attachments || [])env = (0, $f42278b5280d50b5$export$d650323442802f6f)(env, (0, $f42278b5280d50b5$export$d8fc80952cc31fa4)(attachment));
        if (genAiSpanItem) env = (0, $f42278b5280d50b5$export$d650323442802f6f)(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $7LgVW.DEFAULT_ENVIRONMENT) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn($4c5acf3172b33521$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn($4c5acf3172b33521$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $4b2f06588bfb9025$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error("Error while sending envelope:", reason);
            return {};
        }
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $d016c01c54e4f9f6$export$51abed9797baa598)(this, integrations);
        (0, $d016c01c54e4f9f6$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $2KiSw.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $9rdlm.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $gqV7N.getTraceContextFromScope)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $cvdrG.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $gqV7N.getCurrentScope)(), isolationScope = (0, $gqV7N.getIsolationScope)()) {
        if ((0, $dn9bA.DEBUG_BUILD) && $4c5acf3172b33521$var$isErrorEvent(event)) (0, $cG2xs.debug).log(`Captured error event \`${(0, $auwZv.getPossibleEventMessages)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $dn9bA.DEBUG_BUILD) {
                if ($4c5acf3172b33521$var$_isDoNotSendEventError(reason)) (0, $cG2xs.debug).log(reason.message);
                else if ($4c5acf3172b33521$var$_isInternalError(reason)) (0, $cG2xs.debug).warn(reason.message);
                else (0, $cG2xs.debug).warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4c5acf3172b33521$var$isTransactionEvent(event);
        const isError = $4c5acf3172b33521$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : (0, $1s5dy.parseSampleRate)(sampleRate);
        const dataCategory = $4c5acf3172b33521$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $4c5acf3172b33521$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            if ((0, $auwZv.isInternalException)(hint)) return prepared;
            const result = $4c5acf3172b33521$var$processBeforeSend(this, options, prepared, hint);
            return $4c5acf3172b33521$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $4c5acf3172b33521$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && (0, $55uN4.safeMathRandom)() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $4c5acf3172b33521$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($4c5acf3172b33521$var$_isDoNotSendEventError(reason) || $4c5acf3172b33521$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $4c5acf3172b33521$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $3f9c76d04462ddf3$export$c8667f1887a128dc)) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).log("Sending outcomes:", outcomes);
        const envelope = (0, $85f690dfffd74086$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $8U4FY.dsnToString)(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $4c5acf3172b33521$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $4c5acf3172b33521$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $exje8.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $exje8.isPlainObject)(event) && event !== null) throw $4c5acf3172b33521$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $4c5acf3172b33521$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $exje8.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $4c5acf3172b33521$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $4c5acf3172b33521$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan = !(0, $d2ceb212c8cdae62$export$ca3e1ec3cdcc76ac)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($4c5acf3172b33521$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($4c5acf3172b33521$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan || ignoreSpans) {
            const rootSpanJson = (0, $33b18298542aa71c$export$d9c6b2464b0a687e)(processedEvent);
            if (ignoreSpans?.length && (0, $89e1fde7b7661cf5$export$5d569ac97c389400)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $kn25x.showSpanDropWarning)();
                else processedEvent = (0, $aje4A.merge)(event, (0, $33b18298542aa71c$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && (0, $89e1fde7b7661cf5$export$5d569ac97c389400)({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        (0, $89e1fde7b7661cf5$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $kn25x.showSpanDropWarning)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $4c5acf3172b33521$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $4c5acf3172b33521$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $4c5acf3172b33521$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $4c5acf3172b33521$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $4c5acf3172b33521$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $4c5acf3172b33521$var$estimateAttributesSizeInBytes(log.attributes);
}
function $4c5acf3172b33521$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $4c5acf3172b33521$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $exje8.isPrimitive)(value)) weight += $4c5acf3172b33521$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $4c5acf3172b33521$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}


var $jOxUT = parcelRequire("jOxUT");

var $exje8 = parcelRequire("exje8");

var $1nf4J = parcelRequire("1nf4J");

var $fuLLi = parcelRequire("fuLLi");

var $6i9K0 = parcelRequire("6i9K0");
function $7676bd6bdc0f9d8c$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $7676bd6bdc0f9d8c$var$hasSentryFetchUrlHost(error) {
    return (0, $exje8.isError)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $7676bd6bdc0f9d8c$export$35a730c8874c1024(error) {
    if ($7676bd6bdc0f9d8c$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $7676bd6bdc0f9d8c$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $7676bd6bdc0f9d8c$export$35a730c8874c1024(error)
    };
    const frames = $7676bd6bdc0f9d8c$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $7676bd6bdc0f9d8c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ((0, $exje8.isError)(value)) return value;
    }
    return void 0;
}
function $7676bd6bdc0f9d8c$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = (0, $6i9K0.extractExceptionKeysForMessage)(exception);
    if ((0, $exje8.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $7676bd6bdc0f9d8c$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $7676bd6bdc0f9d8c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $7676bd6bdc0f9d8c$var$getException(client, mechanism, exception, hint) {
    if ((0, $exje8.isError)(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ((0, $exje8.isPlainObject)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: (0, $fuLLi.normalizeToSize)(exception, normalizeDepth)
        };
        const errorFromProp = $7676bd6bdc0f9d8c$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $7676bd6bdc0f9d8c$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $7676bd6bdc0f9d8c$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $7676bd6bdc0f9d8c$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $7676bd6bdc0f9d8c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $1nf4J.addExceptionTypeValue)(event, void 0, void 0);
    (0, $1nf4J.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $7676bd6bdc0f9d8c$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $7676bd6bdc0f9d8c$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $1nf4J.addExceptionMechanism)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $exje8.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


var $1nf4J = parcelRequire("1nf4J");
var $6i9K0 = parcelRequire("6i9K0");
var $gqV7N = parcelRequire("gqV7N");
var $exje8 = parcelRequire("exje8");
var $fuLLi = parcelRequire("fuLLi");
var $j3ztq = parcelRequire("j3ztq");
function $3f36613d9ac7cfc2$export$a6c2d27607295951(stackParser, ex) {
    const frames = $3f36613d9ac7cfc2$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $3f36613d9ac7cfc2$export$2e9ae379995d99e3(ex),
        value: $3f36613d9ac7cfc2$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $3f36613d9ac7cfc2$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $gqV7N.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $3f36613d9ac7cfc2$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $fuLLi.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $3f36613d9ac7cfc2$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $exje8.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $3f36613d9ac7cfc2$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $3f36613d9ac7cfc2$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $3f36613d9ac7cfc2$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $3f36613d9ac7cfc2$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $3f36613d9ac7cfc2$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $3f36613d9ac7cfc2$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $3f36613d9ac7cfc2$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $3f36613d9ac7cfc2$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $3f36613d9ac7cfc2$var$getSkipFirstStackStringLines(ex) {
    if (ex && $3f36613d9ac7cfc2$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $3f36613d9ac7cfc2$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $3f36613d9ac7cfc2$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $3f36613d9ac7cfc2$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $3f36613d9ac7cfc2$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $3f36613d9ac7cfc2$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($3f36613d9ac7cfc2$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $7676bd6bdc0f9d8c$export$35a730c8874c1024)(message.error);
    return (0, $7676bd6bdc0f9d8c$export$35a730c8874c1024)(ex);
}
function $3f36613d9ac7cfc2$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $3f36613d9ac7cfc2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $1nf4J.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $j3ztq.resolvedSyncPromise)(event);
}
function $3f36613d9ac7cfc2$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $3f36613d9ac7cfc2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $j3ztq.resolvedSyncPromise)(event);
}
function $3f36613d9ac7cfc2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $exje8.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $3f36613d9ac7cfc2$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $exje8.isDOMError)(exception) || (0, $exje8.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $3f36613d9ac7cfc2$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $3f36613d9ac7cfc2$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $1nf4J.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $exje8.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $3f36613d9ac7cfc2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $1nf4J.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $exje8.isError)(exception)) return $3f36613d9ac7cfc2$var$eventFromError(stackParser, exception);
    if ((0, $exje8.isPlainObject)(exception) || (0, $exje8.isEvent)(exception)) {
        const objectException = exception;
        event = $3f36613d9ac7cfc2$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $1nf4J.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $3f36613d9ac7cfc2$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $1nf4J.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $1nf4J.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $3f36613d9ac7cfc2$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $3f36613d9ac7cfc2$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $1nf4J.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $exje8.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $3f36613d9ac7cfc2$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $6i9K0.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $exje8.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $exje8.isEvent)(exception)) {
        const className = $3f36613d9ac7cfc2$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $3f36613d9ac7cfc2$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $3f36613d9ac7cfc2$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $exje8.isError));
}



var $1nf4J = parcelRequire("1nf4J");
var $6i9K0 = parcelRequire("6i9K0");
var $iFEvA = parcelRequire("iFEvA");
var $gqV7N = parcelRequire("gqV7N");


function $6c8b8cdd88a13247$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $6c8b8cdd88a13247$export$1a2b255c1788eeeb(key, behavior, additionalDenyTerms) {
    if (behavior === false) return true;
    const lowerKey = key.toLowerCase();
    const denySnippets = additionalDenyTerms != null ? [
        ...(0, $3edb0b56e607947b$export$cdee6254fbd57505),
        ...additionalDenyTerms
    ] : (0, $3edb0b56e607947b$export$cdee6254fbd57505);
    if ($6c8b8cdd88a13247$var$isSensitiveKey(lowerKey, denySnippets)) return true;
    if (behavior === true) return false;
    const terms = "deny" in behavior ? behavior.deny : behavior.allow;
    const matchesConfiguredTerm = terms.some((term)=>lowerKey.includes(term.toLowerCase()));
    return "deny" in behavior ? matchesConfiguredTerm : !matchesConfiguredTerm;
}
function $6c8b8cdd88a13247$export$73acb6f35c15da01(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const result = {};
    for (const key of Object.keys(data))result[key] = $6c8b8cdd88a13247$export$1a2b255c1788eeeb(key, behavior, additionalDenyTerms) ? (0, $3edb0b56e607947b$export$59adc876c1ebd512) : data[key];
    return result;
}


function $de7a358f1e97b0f2$export$7e88e8c4177d6404(queryString, behavior) {
    if (!queryString || behavior === false) return void 0;
    return queryString.split("&").map((pair)=>{
        const separatorIndex = pair.indexOf("=");
        const encodedKey = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
        const key = new URLSearchParams(`${encodedKey}=`).keys().next().value;
        return key !== void 0 && (0, $6c8b8cdd88a13247$export$1a2b255c1788eeeb)(key, behavior) ? `${encodedKey}=${0, $3edb0b56e607947b$export$59adc876c1ebd512}` : pair;
    }).join("&");
}



function $d4a36980127d86a3$export$55957a65a66aa868(url, behavior) {
    const fragmentStart = url.indexOf("#");
    const queryEnd = fragmentStart === -1 ? url.length : fragmentStart;
    const queryStart = url.indexOf("?");
    if (queryStart === -1 || queryStart > queryEnd) return url;
    const prefix = url.slice(0, queryStart);
    const query = url.slice(queryStart + 1, queryEnd);
    const suffix = url.slice(queryEnd);
    const filtered = (0, $de7a358f1e97b0f2$export$7e88e8c4177d6404)(query, behavior);
    return filtered ? `${prefix}?${filtered}${suffix}` : `${prefix}${suffix}`;
}


function $8007a70b9b6b88a6$var$urlQueryParamsBehavior(client) {
    return (client ?? (0, $gqV7N.getClient)())?.getDataCollectionOptions().urlQueryParams ?? true;
}
function $8007a70b9b6b88a6$export$9dbd5b9f0d1db392(url, client) {
    return url === void 0 ? void 0 : (0, $d4a36980127d86a3$export$55957a65a66aa868)(url, $8007a70b9b6b88a6$var$urlQueryParamsBehavior(client));
}
function $8007a70b9b6b88a6$export$8cbd6331b69d8fe6(query, client) {
    if (!query) return query;
    const hasPrefix = query.startsWith("?");
    const filtered = (0, $de7a358f1e97b0f2$export$7e88e8c4177d6404)(hasPrefix ? query.slice(1) : query, $8007a70b9b6b88a6$var$urlQueryParamsBehavior(client));
    return filtered && hasPrefix ? `?${filtered}` : filtered;
}


var $exje8 = parcelRequire("exje8");

var $59NSd = parcelRequire("59NSd");
const $402417af1fc2ab33$var$WINDOW = (0, $59NSd.GLOBAL_OBJ);
const $402417af1fc2ab33$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $402417af1fc2ab33$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $402417af1fc2ab33$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $402417af1fc2ab33$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $402417af1fc2ab33$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($402417af1fc2ab33$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $exje8.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $402417af1fc2ab33$export$1cfafeee2987818b() {
    try {
        return $402417af1fc2ab33$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $402417af1fc2ab33$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$402417af1fc2ab33$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


var $59NSd = parcelRequire("59NSd");
var $gqV7N = parcelRequire("gqV7N");
const $139fd1dbcba49ef9$export$56d8a8a25bd48b81 = (0, $59NSd.GLOBAL_OBJ);
let $139fd1dbcba49ef9$var$ignoreOnError = 0;
function $139fd1dbcba49ef9$export$b79738ab10c590b2() {
    return $139fd1dbcba49ef9$var$ignoreOnError > 0;
}
function $139fd1dbcba49ef9$export$1265a142ff5ba165() {
    $139fd1dbcba49ef9$var$ignoreOnError++;
    setTimeout(()=>{
        $139fd1dbcba49ef9$var$ignoreOnError--;
    });
}
function $139fd1dbcba49ef9$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $6i9K0.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $59NSd.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $59NSd.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$139fd1dbcba49ef9$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $139fd1dbcba49ef9$export$1265a142ff5ba165();
            (0, $gqV7N.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $1nf4J.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $1nf4J.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $iFEvA.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $59NSd.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $59NSd.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $6i9K0.markFunctionWrapped)(sentryWrapped, fn);
    (0, $6i9K0.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $139fd1dbcba49ef9$export$a3c4a8453e8936f0(client) {
    const url = (0, $402417af1fc2ab33$export$1cfafeee2987818b)();
    const { referrer: referrer } = $139fd1dbcba49ef9$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $139fd1dbcba49ef9$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: (0, $8007a70b9b6b88a6$export$9dbd5b9f0d1db392)(referrer, client)
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $03706117b3d2ae35$export$1df9218a526d318d extends (0, $4c5acf3172b33521$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $03706117b3d2ae35$export$4e107b20a7f977(options);
        const sdkSource = (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $jOxUT.getSDKSource)();
        (0, $ff86e8fd4d841bde$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).document) (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $712e2bfc0fdf8780$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $3f36613d9ac7cfc2$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $3f36613d9ac7cfc2$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $03706117b3d2ae35$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



var $gqV7N = parcelRequire("gqV7N");

var $cG2xs = parcelRequire("cG2xs");

var $c5ls6 = parcelRequire("c5ls6");
const $afdaf3f0674c1f15$var$DEFAULT_BREADCRUMBS = 100;
function $afdaf3f0674c1f15$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $gqV7N.getClient)();
    const isolationScope = (0, $gqV7N.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $afdaf3f0674c1f15$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $c5ls6.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $cG2xs.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}


var $gqV7N = parcelRequire("gqV7N");

var $exje8 = parcelRequire("exje8");

var $6i9K0 = parcelRequire("6i9K0");

var $dn9bA = parcelRequire("dn9bA");

var $cG2xs = parcelRequire("cG2xs");

var $59NSd = parcelRequire("59NSd");
const $75f5e3731cc0c3a9$var$WINDOW = (0, $59NSd.GLOBAL_OBJ);
function $75f5e3731cc0c3a9$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $75f5e3731cc0c3a9$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $75f5e3731cc0c3a9$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $75f5e3731cc0c3a9$export$67fc34576016d6ec() {
    return "history" in $75f5e3731cc0c3a9$var$WINDOW && !!$75f5e3731cc0c3a9$var$WINDOW.history;
}
const $75f5e3731cc0c3a9$export$edf3cb81fd7d2a3e = $75f5e3731cc0c3a9$var$_isFetchSupported;
function $75f5e3731cc0c3a9$var$_isFetchSupported() {
    if (!("fetch" in $75f5e3731cc0c3a9$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $75f5e3731cc0c3a9$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $75f5e3731cc0c3a9$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$75f5e3731cc0c3a9$var$_isFetchSupported()) return false;
    if ($75f5e3731cc0c3a9$export$d5f608b368e73f38($75f5e3731cc0c3a9$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $75f5e3731cc0c3a9$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $75f5e3731cc0c3a9$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $dn9bA.DEBUG_BUILD) && (0, $cG2xs.debug).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $75f5e3731cc0c3a9$export$531055a6c684a70a() {
    return "ReportingObserver" in $75f5e3731cc0c3a9$var$WINDOW;
}
function $75f5e3731cc0c3a9$export$2d308b428295192f() {
    if (!$75f5e3731cc0c3a9$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



var $c5ls6 = parcelRequire("c5ls6");

var $59NSd = parcelRequire("59NSd");

function $ccd72d6281fbddaa$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, ()=>$ccd72d6281fbddaa$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $ccd72d6281fbddaa$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, ()=>$ccd72d6281fbddaa$var$instrumentFetch($ccd72d6281fbddaa$var$streamHandler));
    return removeHandler;
}
function $ccd72d6281fbddaa$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $75f5e3731cc0c3a9$export$c82d238e23c40b21)()) return;
    (0, $6i9K0.fill)((0, $59NSd.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $ccd72d6281fbddaa$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $c5ls6.timestampInSeconds)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $ccd72d6281fbddaa$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $aa72e96078455c59$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $59NSd.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $aa72e96078455c59$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $c5ls6.timestampInSeconds)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $aa72e96078455c59$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $c5ls6.timestampInSeconds)() * 1e3,
                    error: error
                });
                if ((0, $exje8.isError)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $6i9K0.addNonEnumerableProperty)(error, "framesToPop", 1);
                }
                const client = (0, $gqV7N.getClient)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && (0, $exje8.isError)(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $6i9K0.addNonEnumerableProperty)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $ccd72d6281fbddaa$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $ccd72d6281fbddaa$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $ccd72d6281fbddaa$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $aa72e96078455c59$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $c5ls6.timestampInSeconds)() * 1e3,
            response: response
        });
    });
}
function $ccd72d6281fbddaa$var$hasProp(obj, prop) {
    return (0, $exje8.isObjectLike)(obj) && !!obj[prop];
}
function $ccd72d6281fbddaa$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($ccd72d6281fbddaa$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $ccd72d6281fbddaa$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $ccd72d6281fbddaa$var$getUrlFromResource(resource),
            method: $ccd72d6281fbddaa$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $exje8.isRequest)(resource) && $ccd72d6281fbddaa$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $ccd72d6281fbddaa$var$getUrlFromResource(arg),
        method: $ccd72d6281fbddaa$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $ccd72d6281fbddaa$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $exje8.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}


var $cG2xs = parcelRequire("cG2xs");function $7ea8f0f0a9581a8e$export$b8cfcc4175694bcc(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}


var $gqV7N = parcelRequire("gqV7N");
var $1nf4J = parcelRequire("1nf4J");const $0f568bf657d00136$export$b60c5e9f9b7b58bd = "ai.citations", $0f568bf657d00136$export$cc06afd6de7f2c10 = "ai.completion_tokens.used", $0f568bf657d00136$export$ced6746028fe2cc = "ai.documents", $0f568bf657d00136$export$e6f4aa4f4fcb6da8 = "ai.finish_reason", $0f568bf657d00136$export$f02d892201cd8d36 = "ai.frequency_penalty", $0f568bf657d00136$export$f277a7ef9e273960 = "ai.function_call", $0f568bf657d00136$export$1a8c212c3becaa80 = "ai.generation_id", $0f568bf657d00136$export$721b137086c68a47 = "ai.input_messages", $0f568bf657d00136$export$6afde2bb69d9aa86 = "ai.is_search_required", $0f568bf657d00136$export$eadb4b562c974031 = "ai.metadata", $0f568bf657d00136$export$22a90f0ac1eee843 = "ai.model_id", $0f568bf657d00136$export$a727f215a0be1dad = "ai.model.provider", $0f568bf657d00136$export$536bc61b34d995e5 = "ai.pipeline.name", $0f568bf657d00136$export$c43ea6115b380e62 = "ai.preamble", $0f568bf657d00136$export$d2a16e26bada7cf1 = "ai.presence_penalty", $0f568bf657d00136$export$604eb1bd2278163b = "ai.prompt_tokens.used", $0f568bf657d00136$export$2f8568696c5aa352 = "ai.raw_prompting", $0f568bf657d00136$export$ccc8efd7dd31d3a9 = "ai.responses", $0f568bf657d00136$export$e176bf5dc45e40df = "ai.response_format", $0f568bf657d00136$export$c4ea01fd53f64e16 = "ai.search_queries", $0f568bf657d00136$export$bb5e6f2f31a15da9 = "ai.search_results", $0f568bf657d00136$export$1762c11b666b026a = "ai.seed", $0f568bf657d00136$export$14ddd4b729910100 = "ai.streaming", $0f568bf657d00136$export$5311d7c8e1f8eabb = "ai.tags", $0f568bf657d00136$export$2b748b9eca00828b = "ai.temperature", $0f568bf657d00136$export$5af25308c11addea = "ai.texts", $0f568bf657d00136$export$28f78b3b1663cb92 = "ai.tools", $0f568bf657d00136$export$a1d3f09f0f1f066f = "ai.tool_calls", $0f568bf657d00136$export$322bd4ea9f163663 = "ai.top_k", $0f568bf657d00136$export$95711b9e669edad8 = "ai.top_p", $0f568bf657d00136$export$5924d7d72384626a = "ai.total_cost", $0f568bf657d00136$export$db3b1b877a4ce4db = "ai.total_tokens.used", $0f568bf657d00136$export$a434a3e8afec2879 = "ai.warnings", $0f568bf657d00136$export$fe00bb20636d42af = "angular.version", $0f568bf657d00136$export$712aa698b7ee271e = "app.app_build", $0f568bf657d00136$export$1fac638b11ec16d9 = "app.app_identifier", $0f568bf657d00136$export$d132016ea64058e3 = "app.app_name", $0f568bf657d00136$export$53f2f47ec3b2f9ed = "app.app_start_time", $0f568bf657d00136$export$9f80c4b11053cef1 = "app.app_version", $0f568bf657d00136$export$5f7a08466d84e877 = "app.build", $0f568bf657d00136$export$2cea7f14750b8c19 = "app.identifier", $0f568bf657d00136$export$34c59270f032a6c6 = "app.in_foreground", $0f568bf657d00136$export$5b6c28c7dca07ad7 = "app.name", $0f568bf657d00136$export$1dc8ae58b58d6c50 = "app_start_cold", $0f568bf657d00136$export$ba267414e3c0d822 = "app.start_time", $0f568bf657d00136$export$71b176005902b99e = "app_start_type", $0f568bf657d00136$export$5c5b5a3c245a0079 = "app_start_warm", $0f568bf657d00136$export$8ee1df3c6367a60 = "app.version", $0f568bf657d00136$export$e8c7802ae95beccf = "app.vitals.frames.delay.value", $0f568bf657d00136$export$bb237734da4d464 = "app.vitals.frames.frozen.count", $0f568bf657d00136$export$cdaaf6d1fdcba0b6 = "app.vitals.frames.slow.count", $0f568bf657d00136$export$36223ebd4a30e9f5 = "app.vitals.frames.total.count", $0f568bf657d00136$export$8feaa177bb7941e2 = "app.vitals.start.cold.value", $0f568bf657d00136$export$e1ca25240db91d68 = "app.vitals.start.prewarmed", $0f568bf657d00136$export$404a223fd1ada08b = "app.vitals.start.reason", $0f568bf657d00136$export$53362079310c68 = "app.vitals.start.screen", $0f568bf657d00136$export$3efb5af0ac379f77 = "app.vitals.start.type", $0f568bf657d00136$export$2c10c1ca0612c46d = "app.vitals.start.warm.value", $0f568bf657d00136$export$bbb86ad4d6654da6 = "app.vitals.ttfd.value", $0f568bf657d00136$export$ad6896f00a2b1076 = "app.vitals.ttid.value", $0f568bf657d00136$export$300f39d8506a273d = "art.gc.blocking_count", $0f568bf657d00136$export$ecaa0e7f4773ddc7 = "art.gc.blocking_time", $0f568bf657d00136$export$74b78acb4c54c06b = "art.gc.pre_oome_count", $0f568bf657d00136$export$b15b2c133bc50e33 = "art.gc.total_count", $0f568bf657d00136$export$5f1381d9ae1b1c95 = "art.gc.total_time", $0f568bf657d00136$export$c170b7ff277132ea = "art.gc.waiting_time", $0f568bf657d00136$export$9459a5df93695e45 = "art.memory.free", $0f568bf657d00136$export$a7902bd57492ebe8 = "art.memory.free_until_gc", $0f568bf657d00136$export$d2ace0da59da09b7 = "art.memory.free_until_oome", $0f568bf657d00136$export$c15dd8d2461e0aeb = "art.memory.max", $0f568bf657d00136$export$5405b0a98e00e538 = "art.memory.total", $0f568bf657d00136$export$5d9f28f388f552d2 = "aws.cloudwatch.logs.log_group", $0f568bf657d00136$export$b3d2f68e0e769504 = "aws.cloudwatch.logs.log_stream", $0f568bf657d00136$export$2c98412ed43013e8 = "aws.cloudwatch.logs.url", $0f568bf657d00136$export$a7bd794d11c19f1b = "aws.dynamodb.attribute_definitions", $0f568bf657d00136$export$df4227832b83fdd0 = "aws.dynamodb.consistent_read", $0f568bf657d00136$export$f131a6d8fbc0534f = "aws.dynamodb.consumed_capacity", $0f568bf657d00136$export$9bdc66d4a70e7e3a = "aws.dynamodb.count", $0f568bf657d00136$export$bfbbc3cbcaa90e98 = "aws.dynamodb.exclusive_start_table", $0f568bf657d00136$export$3565fa72459aa4d6 = "aws.dynamodb.global_secondary_indexes", $0f568bf657d00136$export$bb67a834ae4bffdc = "aws.dynamodb.global_secondary_index_updates", $0f568bf657d00136$export$4a06c859a283f06 = "aws.dynamodb.index_name", $0f568bf657d00136$export$68324fac2038d0f2 = "aws.dynamodb.item_collection_metrics", $0f568bf657d00136$export$5e1bd62ffd2786fb = "aws.dynamodb.limit", $0f568bf657d00136$export$bfdf2261058f56b = "aws.dynamodb.local_secondary_indexes", $0f568bf657d00136$export$23bf57842d9d53df = "aws.dynamodb.projection", $0f568bf657d00136$export$bfbd7e060eeb4d35 = "aws.dynamodb.provisioned_read_capacity", $0f568bf657d00136$export$82eb6cccda27c3ff = "aws.dynamodb.provisioned_write_capacity", $0f568bf657d00136$export$8ea68734d455808f = "aws.dynamodb.scanned_count", $0f568bf657d00136$export$40050e29324d44ee = "aws.dynamodb.scan_forward", $0f568bf657d00136$export$5cd7541006d9f467 = "aws.dynamodb.segment", $0f568bf657d00136$export$81c017edd95d692e = "aws.dynamodb.select", $0f568bf657d00136$export$120b3897a58cf903 = "aws.dynamodb.table_count", $0f568bf657d00136$export$d4a9de43b4b1076c = "aws.dynamodb.table_names", $0f568bf657d00136$export$f37f4f9022f1ab17 = "aws.dynamodb.total_segments", $0f568bf657d00136$export$66ac18da14747cfb = "aws.extended_request_id", $0f568bf657d00136$export$9e49b833525ca49d = "aws.kinesis.stream_name", $0f568bf657d00136$export$247839c65766758 = "aws.kinesis.stream.name", $0f568bf657d00136$export$b084fea5b3097227 = "aws.lambda.aws_request_id", $0f568bf657d00136$export$e09cd8615652e8d0 = "aws.lambda.execution_duration_in_millis", $0f568bf657d00136$export$a43a60ec723a90ee = "aws.lambda.function_name", $0f568bf657d00136$export$34cc955357266287 = "aws.lambda.function_version", $0f568bf657d00136$export$d9dd218693ea9bba = "aws.lambda.invoked_arn", $0f568bf657d00136$export$c9649b7156282a2f = "aws.lambda.invoked_function_arn", $0f568bf657d00136$export$daa8ce1f8adc553e = "aws.lambda.remaining_time_in_millis", $0f568bf657d00136$export$cb93c7b05db202cf = "aws.log.group.names", $0f568bf657d00136$export$930f9bd3cc2e5b3d = "aws.log.stream.names", $0f568bf657d00136$export$48c6d4c44afdc0b = "aws.request.extended_id", $0f568bf657d00136$export$c78d41789fe4b1e4 = "aws.request_id", $0f568bf657d00136$export$f4d52b02df927d54 = "aws.request.id", $0f568bf657d00136$export$f462d9921f1f7332 = "aws.s3.bucket", $0f568bf657d00136$export$bc71f8df9a45e243 = "aws.secretsmanager.secret.arn", $0f568bf657d00136$export$ed840ec4a5f5d053 = "aws.sns.topic.arn", $0f568bf657d00136$export$c1a559a4f74a5e8e = "aws.step_functions.activity.arn", $0f568bf657d00136$export$d1c007424092e3f5 = "aws.step_functions.state_machine.arn", $0f568bf657d00136$export$9ebb466ce954c49c = "blocked_main_thread", $0f568bf657d00136$export$e9aafc7348984403 = "browser.name", $0f568bf657d00136$export$faaa46964f075237 = "browser.performance.navigation.activation_start", $0f568bf657d00136$export$d28c4b3cc4431a87 = "browser.performance.time_origin", $0f568bf657d00136$export$734b017b330c8fe6 = "browser.report.type", $0f568bf657d00136$export$683ebdc48ba3758d = "browser.script.invoker", $0f568bf657d00136$export$be0263971250ef44 = "browser.script.invoker_type", $0f568bf657d00136$export$36a0cbc35c405232 = "browser.script.source_char_position", $0f568bf657d00136$export$469f7765ba335497 = "browser.version", $0f568bf657d00136$export$fe6fe2b7af051610 = "browser.web_vital.cls.report_event", $0f568bf657d00136$export$8345821877c4dfad = "browser.web_vital.cls.source.<key>", $0f568bf657d00136$export$f6c188a7e02335cf = "browser.web_vital.cls.source", $0f568bf657d00136$export$aaf709a8971e825f = "browser.web_vital.cls.value", $0f568bf657d00136$export$def01b82f8c092f7 = "browser.web_vital.fcp.value", $0f568bf657d00136$export$23d4264c606a73a6 = "browser.web_vital.fp.value", $0f568bf657d00136$export$af9ece53bb92f66b = "browser.web_vital.inp.value", $0f568bf657d00136$export$25421625a565b69 = "browser.web_vital.lcp.element", $0f568bf657d00136$export$ab0c90d873e69ccb = "browser.web_vital.lcp.id", $0f568bf657d00136$export$538c05cc8cb2a2bb = "browser.web_vital.lcp.load_time", $0f568bf657d00136$export$f86df4de196e1a7c = "browser.web_vital.lcp.render_time", $0f568bf657d00136$export$51e8aa8c0d65e7b8 = "browser.web_vital.lcp.report_event", $0f568bf657d00136$export$99023486ecc470bd = "browser.web_vital.lcp.size", $0f568bf657d00136$export$2f6c85eaf382e81 = "browser.web_vital.lcp.url", $0f568bf657d00136$export$1158d57c0aed42be = "browser.web_vital.lcp.value", $0f568bf657d00136$export$d85c4f947ab776e3 = "browser.web_vital.ttfb.request_time", $0f568bf657d00136$export$813ef8386d874918 = "browser.web_vital.ttfb.value", $0f568bf657d00136$export$7c2f74ff9251f64 = "cache.hit", $0f568bf657d00136$export$993f84dab107b880 = "cache.item_size", $0f568bf657d00136$export$7b9c2315e94d8d2f = "cache.key", $0f568bf657d00136$export$f01e5cd42b9ec146 = "cache.operation", $0f568bf657d00136$export$987f6b4367434b55 = "cache.ttl", $0f568bf657d00136$export$d9d145585d5022bb = "cache.write", $0f568bf657d00136$export$44ffba16bd48dac6 = "channel", $0f568bf657d00136$export$3134892c5d2e251a = "client.address", $0f568bf657d00136$export$8495028d10296058 = "client.port", $0f568bf657d00136$export$d6d0e4fcf46d490c = "cloudflare.d1.duration", $0f568bf657d00136$export$658dced473c19301 = "cloudflare.d1.query_type", $0f568bf657d00136$export$97b0f9c3fbe64076 = "cloudflare.d1.rows_read", $0f568bf657d00136$export$cf2c95ed5efbe9eb = "cloudflare.d1.rows_written", $0f568bf657d00136$export$880007904f61a388 = "cloudflare.durable_object.query.bindings", $0f568bf657d00136$export$3e903b72d4d9e07d = "cloudflare.durable_object.response.rows_read", $0f568bf657d00136$export$34da07180e0e56af = "cloudflare.durable_object.response.rows_written", $0f568bf657d00136$export$c49aafdaeb061953 = "cloudflare.r2.bucket", $0f568bf657d00136$export$ceb762c61de2f17f = "cloudflare.r2.operation", $0f568bf657d00136$export$a5f54ccfb28c0caf = "cloudflare.r2.request.delimiter", $0f568bf657d00136$export$1c86a56857b024db = "cloudflare.r2.request.key", $0f568bf657d00136$export$7598f3464be47440 = "cloudflare.r2.request.part_number", $0f568bf657d00136$export$b673289c971fc0ae = "cloudflare.r2.request.prefix", $0f568bf657d00136$export$98b23f3e6f0c2a6f = "cloudflare.workflow.attempt", $0f568bf657d00136$export$6ddeaf0498614ebb = "cloudflare.workflow.retries.backoff", $0f568bf657d00136$export$97b78f78d64a7232 = "cloudflare.workflow.retries.delay", $0f568bf657d00136$export$5147715be870fff7 = "cloudflare.workflow.retries.limit", $0f568bf657d00136$export$5276bb46e6096fba = "cloudflare.workflow.timeout", $0f568bf657d00136$export$cbcbc1f67a937cf3 = "cloud.account.id", $0f568bf657d00136$export$226a2381b8f0cf78 = "cloud.availability_zone", $0f568bf657d00136$export$fd35512cae286064 = "cloud.platform", $0f568bf657d00136$export$de9bbf95ab1d81e = "cloud.provider", $0f568bf657d00136$export$47fb20e8d18d7d15 = "cloud.region", $0f568bf657d00136$export$9db7964e4b8cb849 = "cloud.resource_id", $0f568bf657d00136$export$7139adf9d3bace41 = "cls", $0f568bf657d00136$export$8ac3d09060e7f25d = "cls.source.<key>", $0f568bf657d00136$export$dad0e4778ea23971 = "cls.source", $0f568bf657d00136$export$c14d903ccf9385a8 = "code.filepath", $0f568bf657d00136$export$934cded0041affd7 = "code.file.path", $0f568bf657d00136$export$6386da1dcba88c9d = "code.function", $0f568bf657d00136$export$a3371797e606e2 = "code.function.name", $0f568bf657d00136$export$a5bbef0af83b23e5 = "code.lineno", $0f568bf657d00136$export$91ed1f55874222a6 = "code.line.number", $0f568bf657d00136$export$23de81068d2aed1b = "code.namespace", $0f568bf657d00136$export$d738320e1fba9e9d = "connectionType", $0f568bf657d00136$export$2eacdea75497e8a5 = "connection.rtt", $0f568bf657d00136$export$2bc3ea101f86c1d2 = "culture.calendar", $0f568bf657d00136$export$c54e27e8d90ee081 = "culture.display_name", $0f568bf657d00136$export$4943adcec371c2a6 = "culture.is_24_hour_format", $0f568bf657d00136$export$f000a5900d0480c2 = "culture.locale", $0f568bf657d00136$export$8f5234893868273b = "culture.timezone", $0f568bf657d00136$export$1a35518f6e81e8c7 = "db.collection.name", $0f568bf657d00136$export$a2d90911eaae60fc = "db.driver.name", $0f568bf657d00136$export$3c22ff8b64b8f565 = "db.name", $0f568bf657d00136$export$b8019c0e2a5b5f0f = "db.namespace", $0f568bf657d00136$export$8c11477e471467c8 = "db.operation", $0f568bf657d00136$export$92a96f6363488aee = "db.operation.batch.size", $0f568bf657d00136$export$f91beb6088f9ded9 = "db.operation.name", $0f568bf657d00136$export$78bc7224576bf289 = "db.query.parameter.<key>", $0f568bf657d00136$export$a8027e0ea0d93ca = "db.query.parameter", $0f568bf657d00136$export$5e59d3aea52e5037 = "db.query.summary", $0f568bf657d00136$export$47e408be0da7933f = "db.query.text", $0f568bf657d00136$export$d5772b934ca13e57 = "db.redis.connection", $0f568bf657d00136$export$36e47f6a5777561d = "db.redis.key", $0f568bf657d00136$export$e768cbc99cd68acf = "db.redis.parameters", $0f568bf657d00136$export$dfcc6c69df1343f2 = "db.response.status_code", $0f568bf657d00136$export$69b0a5d9226b5211 = "db.sql.bindings", $0f568bf657d00136$export$da010a4f4fc971ae = "db.statement", $0f568bf657d00136$export$5d515b35be0601a0 = "db.stored_procedure.name", $0f568bf657d00136$export$3e1b1037a315c5ca = "db.system", $0f568bf657d00136$export$847fdd494825f0fb = "db.system.name", $0f568bf657d00136$export$a9d76f26c6c730a9 = "db.user", $0f568bf657d00136$export$de03f86d1c9866ca = "deviceMemory", $0f568bf657d00136$export$65798ecab7eef8c = "device.archs", $0f568bf657d00136$export$22aa61f48b9c79a0 = "device.battery_level", $0f568bf657d00136$export$69f5fb98f5aed812 = "device.battery_temperature", $0f568bf657d00136$export$bdea5d1006fd280a = "device.boot_time", $0f568bf657d00136$export$f63a7230c5b1d609 = "device.brand", $0f568bf657d00136$export$6f25e59b05bb8e17 = "device.charging", $0f568bf657d00136$export$a56ad13c4afc7421 = "device.chipset", $0f568bf657d00136$export$d9ce89ce8912bf12 = "device.class", $0f568bf657d00136$export$17094e5f380e4162 = "device.connection_type", $0f568bf657d00136$export$28a0ffdf747973a0 = "device.cpu_description", $0f568bf657d00136$export$5480ae1ba5d50bb9 = "device.external_free_storage", $0f568bf657d00136$export$edc72ee4a17f5152 = "device.external_storage_size", $0f568bf657d00136$export$19e4df138d354f8b = "device.family", $0f568bf657d00136$export$92b0d20fa482b4b2 = "device.free_memory", $0f568bf657d00136$export$3f638a793d61933f = "device.free_storage", $0f568bf657d00136$export$3f511731cc3687d4 = "device.id", $0f568bf657d00136$export$692b08741d6b6265 = "device.locale", $0f568bf657d00136$export$cf67f8cb2324428e = "device.low_memory", $0f568bf657d00136$export$9d4197c1ffc5f359 = "device.low_power_mode", $0f568bf657d00136$export$509634fbff540e75 = "device.manufacturer", $0f568bf657d00136$export$ccbc4fdff4b5eff5 = "device.memory.estimated_capacity", $0f568bf657d00136$export$e0cb371ca548b1d6 = "device.memory_size", $0f568bf657d00136$export$3c39026d09026bc2 = "device.model", $0f568bf657d00136$export$bf9e8248cb72cf00 = "device.model_id", $0f568bf657d00136$export$1054f22a72121d0f = "device.name", $0f568bf657d00136$export$723b8a59dad2e467 = "device.online", $0f568bf657d00136$export$160081ff141bac8e = "device.orientation", $0f568bf657d00136$export$194f62c84d27310 = "device.processor_count", $0f568bf657d00136$export$7ed866d57b018d09 = "device.processor_frequency", $0f568bf657d00136$export$d50bae4562e03e5 = "device.screen_density", $0f568bf657d00136$export$649ea67a18fe8e8b = "device.screen_dpi", $0f568bf657d00136$export$136a5c1b43caaccd = "device.screen_height_pixels", $0f568bf657d00136$export$e33a28ea554b6ddc = "device.screen_width_pixels", $0f568bf657d00136$export$acbe2d25ac76ea64 = "device.simulator", $0f568bf657d00136$export$793c13e17d7e5e2b = "device.storage_size", $0f568bf657d00136$export$a5617e33b89fd956 = "device.thermal_state", $0f568bf657d00136$export$b51f82164fa31e07 = "device.timezone", $0f568bf657d00136$export$f2ef55183c04d202 = "device.usable_memory", $0f568bf657d00136$export$7c98fc0c48a16b1c = "dist", $0f568bf657d00136$export$f0511e328234ae83 = "effectiveConnectionType", $0f568bf657d00136$export$be46596bc6608f3b = "environment", $0f568bf657d00136$export$f215947b3d76a6b7 = "error.type", $0f568bf657d00136$export$89bbc91416db6670 = "event.id", $0f568bf657d00136$export$b4b5eff8a8712c89 = "event.name", $0f568bf657d00136$export$f455969a57ab8a03 = "exception.escaped", $0f568bf657d00136$export$13f2f8f42af49cec = "exception.message", $0f568bf657d00136$export$cd357afe2ffdd2c3 = "exception.stacktrace", $0f568bf657d00136$export$d9ca2a279a11be5e = "exception.type", $0f568bf657d00136$export$bbd59a8c7efad4c9 = "faas.coldstart", $0f568bf657d00136$export$8413282a17f1cda5 = "faas.cron", $0f568bf657d00136$export$30d19ddc7705e7e8 = "faas.duration_in_ms", $0f568bf657d00136$export$64a4f09e2444b3d = "faas.entry_point", $0f568bf657d00136$export$645b039fe163809e = "faas.execution", $0f568bf657d00136$export$b23ef8b8ffa607e1 = "faas.id", $0f568bf657d00136$export$8bf64516740c1369 = "faas.identity", $0f568bf657d00136$export$9a0dc8e612f3e10b = "faas.invocation_id", $0f568bf657d00136$export$abe90fedb3dddda2 = "faas.invoked_name", $0f568bf657d00136$export$4a19da9c85ed2ade = "faas.invoked_provider", $0f568bf657d00136$export$5e091479f094bdbc = "faas.invoked_region", $0f568bf657d00136$export$d70909b5aa96a79a = "faas.name", $0f568bf657d00136$export$651d142a8017d83d = "faas.time", $0f568bf657d00136$export$44382a010a9f7fcf = "faas.trigger", $0f568bf657d00136$export$807abfdc6b7b9338 = "faas.version", $0f568bf657d00136$export$31881d07f2569218 = "fcp", $0f568bf657d00136$export$e5bbf306deb709a6 = "flag.evaluation.<key>", $0f568bf657d00136$export$aa8721167c5c8d2d = "flag.evaluation", $0f568bf657d00136$export$757b93e5b3adc7cb = "fp", $0f568bf657d00136$export$f869eaa92db1dc9b = "frames.delay", $0f568bf657d00136$export$5d1d761e41c32d9e = "frames.frozen", $0f568bf657d00136$export$8aec72d9491f9399 = "frames_frozen_rate", $0f568bf657d00136$export$5562635d2be2ab25 = "frames.slow", $0f568bf657d00136$export$2dc31837ce6f7a3d = "frames_slow_rate", $0f568bf657d00136$export$b561df15f64d32e3 = "frames.total", $0f568bf657d00136$export$181f78b28f2ffa57 = "fs_error", $0f568bf657d00136$export$6c97c77b89571c75 = "gcp.function.context.event_id", $0f568bf657d00136$export$51e431eaf1f9bf58 = "gcp.function.context.event_type", $0f568bf657d00136$export$71429c7ef7cb7063 = "gcp.function.context.id", $0f568bf657d00136$export$99905d7583a6e8ac = "gcp.function.context.resource", $0f568bf657d00136$export$b6c4be74fd0c06bd = "gcp.function.context.source", $0f568bf657d00136$export$fd23e5b8d261a89 = "gcp.function.context.specversion", $0f568bf657d00136$export$25fabc9b3d1dd567 = "gcp.function.context.time", $0f568bf657d00136$export$41507f7b07dad151 = "gcp.function.context.timestamp", $0f568bf657d00136$export$1352f3699c35dd73 = "gcp.function.context.type", $0f568bf657d00136$export$fd6c9d5c74d943ac = "gcp.project.id", $0f568bf657d00136$export$c29634e3cf41e479 = "gen_ai.agent.name", $0f568bf657d00136$export$e6a60882cce7a085 = "gen_ai.context.utilization", $0f568bf657d00136$export$6773c9098ba5e194 = "gen_ai.context.window_size", $0f568bf657d00136$export$6ee6b62f50047686 = "gen_ai.conversation.id", $0f568bf657d00136$export$efac052bb3661242 = "gen_ai.cost.cache_creation.input_tokens", $0f568bf657d00136$export$7ccd63b9ca955862 = "gen_ai.cost.cache_read.input_tokens", $0f568bf657d00136$export$50921df5a58cb3ef = "gen_ai.cost.input_tokens", $0f568bf657d00136$export$8e48efc7acb57a97 = "gen_ai.cost.output_tokens", $0f568bf657d00136$export$cea9121727113f77 = "gen_ai.cost.reasoning.output_tokens", $0f568bf657d00136$export$bed35ff7f9af3aaa = "gen_ai.cost.total_tokens", $0f568bf657d00136$export$6b729e898b9067ce = "gen_ai.embeddings.input", $0f568bf657d00136$export$984fbab9b52f7e24 = "gen_ai.function_id", $0f568bf657d00136$export$9ea17906a87ada6f = "gen_ai.input.messages", $0f568bf657d00136$export$394b443aaff3ef92 = "gen_ai.operation.name", $0f568bf657d00136$export$6ddc374adbc06720 = "gen_ai.operation.type", $0f568bf657d00136$export$ab8c7ebc9add56b2 = "gen_ai.output.messages", $0f568bf657d00136$export$40ecc5bcd633d1ee = "gen_ai.pipeline.name", $0f568bf657d00136$export$86a8df7fff52fc69 = "gen_ai.prompt", $0f568bf657d00136$export$cf2115d46768f4c5 = "gen_ai.prompt.name", $0f568bf657d00136$export$3d7e036e195764db = "gen_ai.provider.name", $0f568bf657d00136$export$60c1d11221608cee = "gen_ai.request.available_tools", $0f568bf657d00136$export$bc3cef164abbc42c = "gen_ai.request.frequency_penalty", $0f568bf657d00136$export$43f9afb62cd79dec = "gen_ai.request.max_tokens", $0f568bf657d00136$export$a5ab4ffc4765f75f = "gen_ai.request.messages", $0f568bf657d00136$export$ccf46db9ab1743ec = "gen_ai.request.model", $0f568bf657d00136$export$76c1c247342d776 = "gen_ai.request.presence_penalty", $0f568bf657d00136$export$92f5944f0b02c9fb = "gen_ai.request.reasoning_effort", $0f568bf657d00136$export$867eeefcb1c95b27 = "gen_ai.request.seed", $0f568bf657d00136$export$5ada4697ae6aa17e = "gen_ai.request.stop_sequences", $0f568bf657d00136$export$427122300e8d54d0 = "gen_ai.request.temperature", $0f568bf657d00136$export$bcea8881375c352f = "gen_ai.request.top_k", $0f568bf657d00136$export$b867715f9a0c04e9 = "gen_ai.request.top_p", $0f568bf657d00136$export$69878a39cbdbe097 = "gen_ai.response.finish_reasons", $0f568bf657d00136$export$584c61a1b769552d = "gen_ai.response.id", $0f568bf657d00136$export$8169ebcb0b0331dd = "gen_ai.response.model", $0f568bf657d00136$export$2c9713b624877853 = "gen_ai.response.streaming", $0f568bf657d00136$export$45942692aeb454e0 = "gen_ai.response.text", $0f568bf657d00136$export$8e5efeaa031210cd = "gen_ai.response.time_to_first_chunk", $0f568bf657d00136$export$35a62769ee05a05a = "gen_ai.response.time_to_first_token", $0f568bf657d00136$export$8ea4f7e986ca4b06 = "gen_ai.response.tokens_per_second", $0f568bf657d00136$export$d2fd9ecaff0285a4 = "gen_ai.response.tool_calls", $0f568bf657d00136$export$a6c8e656a4f9bb67 = "gen_ai.system", $0f568bf657d00136$export$352a8075b163d53 = "gen_ai.system_instructions", $0f568bf657d00136$export$426d7b90ba5d79db = "gen_ai.system.message", $0f568bf657d00136$export$f5a1ee40934d19ce = "gen_ai.tool.call.arguments", $0f568bf657d00136$export$1ba812a9756622ce = "gen_ai.tool.call.result", $0f568bf657d00136$export$351120039c36e03 = "gen_ai.tool.definitions", $0f568bf657d00136$export$d42aa25ca09e17c4 = "gen_ai.tool.description", $0f568bf657d00136$export$d268db29b88a4286 = "gen_ai.tool.input", $0f568bf657d00136$export$c5deb6018f2d6251 = "gen_ai.tool.message", $0f568bf657d00136$export$e06baa3034409453 = "gen_ai.tool.name", $0f568bf657d00136$export$646fdb5910ce3931 = "gen_ai.tool.output", $0f568bf657d00136$export$662e3d2d4361e29b = "gen_ai.tool.type", $0f568bf657d00136$export$1de3962f221ba441 = "gen_ai.usage.cache_creation.input_tokens", $0f568bf657d00136$export$a4b3f0f5499c8738 = "gen_ai.usage.cache_read.input_tokens", $0f568bf657d00136$export$1aecdac6cecbdc5b = "gen_ai.usage.completion_tokens", $0f568bf657d00136$export$2eb2ab35b317a103 = "gen_ai.usage.input_tokens", $0f568bf657d00136$export$c7e14ea195ede241 = "gen_ai.usage.input_tokens.cached", $0f568bf657d00136$export$41ac034e7b9725a2 = "gen_ai.usage.input_tokens.cache_write", $0f568bf657d00136$export$9e521119d7751e37 = "gen_ai.usage.output_tokens", $0f568bf657d00136$export$cbac8f541a64a150 = "gen_ai.usage.output_tokens.reasoning", $0f568bf657d00136$export$93dd08efa94c9dd4 = "gen_ai.usage.prompt_tokens", $0f568bf657d00136$export$183e3523dac20bca = "gen_ai.usage.reasoning.output_tokens", $0f568bf657d00136$export$3867ca1d8381d4e3 = "gen_ai.usage.total_tokens", $0f568bf657d00136$export$11febcf9917c0057 = "graphql.document", $0f568bf657d00136$export$88ae1ee0c0a63398 = "graphql.operation.name", $0f568bf657d00136$export$d5bd986d1f283f29 = "graphql.operation.type", $0f568bf657d00136$export$fc4a2d238535d998 = "hardwareConcurrency", $0f568bf657d00136$export$57e53a60bf563f41 = "http.client_ip", $0f568bf657d00136$export$ffdb1464deb0eedb = "http.decoded_response_content_length", $0f568bf657d00136$export$b52670c950fd640 = "http.flavor", $0f568bf657d00136$export$c499fd8f1db3d18e = "http.fragment", $0f568bf657d00136$export$b2ee2242301eff05 = "http.host", $0f568bf657d00136$export$2ebf9f7586f16841 = "http.method", $0f568bf657d00136$export$6e9ffd608b3e828b = "http.query", $0f568bf657d00136$export$b960c5a73a722e6c = "http.request.body.data", $0f568bf657d00136$export$a7a850351369c77e = "http.request.connection_end", $0f568bf657d00136$export$b18bca78f4736a94 = "http.request.connect_start", $0f568bf657d00136$export$61a0059f562fb6c2 = "http.request.domain_lookup_end", $0f568bf657d00136$export$7dc0d5aefb816d91 = "http.request.domain_lookup_start", $0f568bf657d00136$export$58f6db56c841bef6 = "http.request.fetch_start", $0f568bf657d00136$export$97a3da679f509d5 = "http.request.header.<key>", $0f568bf657d00136$export$c387ec65fd1c2638 = "http.request.header", $0f568bf657d00136$export$4d9db82211f308a4 = "http.request.method", $0f568bf657d00136$export$df30ee8c5b5f1989 = "http.request_method", $0f568bf657d00136$export$ee4948a3be025123 = "http.request.redirect_end", $0f568bf657d00136$export$e0021eb2979cddaa = "http.request.redirect_start", $0f568bf657d00136$export$7c0ac0c19a45beac = "http.request.request_start", $0f568bf657d00136$export$6c32e9d84f534ee = "http.request.resend_count", $0f568bf657d00136$export$d1f9fbdb211dd29b = "http.request.response_end", $0f568bf657d00136$export$45e7eea99a17d6e4 = "http.request.response_start", $0f568bf657d00136$export$20ea34e16c0aa64f = "http.request.same_origin", $0f568bf657d00136$export$8365b0f03557fae9 = "http.request.secure_connection_start", $0f568bf657d00136$export$49ebbb9621675650 = "http.request.time_to_first_byte", $0f568bf657d00136$export$842be66a901f093 = "http.request.worker_start", $0f568bf657d00136$export$a9f5a6cb28adccb1 = "http.response.body.size", $0f568bf657d00136$export$57b055d4bc586d67 = "http.response_content_length", $0f568bf657d00136$export$3ddfd660caa7bf7a = "http.response.header.content-length", $0f568bf657d00136$export$fa7e1f5305153b3d = "http.response.header.<key>", $0f568bf657d00136$export$5674ce9d013eb7bd = "http.response.header", $0f568bf657d00136$export$6e8dc14cff6ccf72 = "http.response.size", $0f568bf657d00136$export$afd59480458e1b57 = "http.response.status_code", $0f568bf657d00136$export$48e61fb9bccccba9 = "http.response_transfer_size", $0f568bf657d00136$export$d3e674514dd3a3e1 = "http.route", $0f568bf657d00136$export$97ad02b50c60ef68 = "http.scheme", $0f568bf657d00136$export$61d053b1b63e82c4 = "http.server_name", $0f568bf657d00136$export$54256cce0d674dea = "http.server.request.time_in_queue", $0f568bf657d00136$export$8c01f0f407bcc5ca = "http.status_code", $0f568bf657d00136$export$be3f46982f6c7160 = "http.target", $0f568bf657d00136$export$778e4213e2788579 = "http.url", $0f568bf657d00136$export$8b48ca3594d2b172 = "http.user_agent", $0f568bf657d00136$export$8be180ec26319f9f = "id", $0f568bf657d00136$export$60eccaddefa8fc1c = "inp", $0f568bf657d00136$export$c99ce4fe37484d84 = "jsonrpc.protocol.version", $0f568bf657d00136$export$fdf432fcac7d8f37 = "jsonrpc.request.id", $0f568bf657d00136$export$4c21cc9cdf2f5dbd = "jvm.gc.action", $0f568bf657d00136$export$dcc1eab7f3f31816 = "jvm.gc.name", $0f568bf657d00136$export$dcb7f1379b2b8f86 = "jvm.memory.pool.name", $0f568bf657d00136$export$53416edeea4c2d74 = "jvm.memory.type", $0f568bf657d00136$export$69f7e5d2b74c5c9e = "jvm.thread.daemon", $0f568bf657d00136$export$8e104aed582a26bc = "jvm.thread.state", $0f568bf657d00136$export$577047501949be9 = "koa.name", $0f568bf657d00136$export$c4c45b599a2c15e = "koa.type", $0f568bf657d00136$export$361cb541700d648e = "lcp", $0f568bf657d00136$export$974f160e11f25731 = "lcp.element", $0f568bf657d00136$export$7162f5c702b95903 = "lcp.id", $0f568bf657d00136$export$a034d066a9090500 = "lcp.loadTime", $0f568bf657d00136$export$70938021e43e047c = "lcp.renderTime", $0f568bf657d00136$export$5f6ac460012a73bb = "lcp.size", $0f568bf657d00136$export$d8e498c1c670bcbf = "lcp.url", $0f568bf657d00136$export$cc1a78a24d947903 = "logger.name", $0f568bf657d00136$export$d29b927e0bb0ffea = "mcp.cancelled.reason", $0f568bf657d00136$export$b3999cacef245779 = "mcp.cancelled.request_id", $0f568bf657d00136$export$ff168b5f9cf9dcf6 = "mcp.client.name", $0f568bf657d00136$export$2ab876a45bd6e64 = "mcp.client.title", $0f568bf657d00136$export$cb8027e4395c6c0e = "mcp.client.version", $0f568bf657d00136$export$f5303d1bac3c2660 = "mcp.lifecycle.phase", $0f568bf657d00136$export$6c463c5f3b00f64 = "mcp.logging.data_type", $0f568bf657d00136$export$e25d553065457cab = "mcp.logging.level", $0f568bf657d00136$export$15d24c154ea8a56f = "mcp.logging.logger", $0f568bf657d00136$export$e5065789a6c415d0 = "mcp.logging.message", $0f568bf657d00136$export$62662c561d7c7835 = "mcp.method.name", $0f568bf657d00136$export$218f394557fb0a5a = "mcp.progress.current", $0f568bf657d00136$export$2a5ff6de5448ecdf = "mcp.progress.message", $0f568bf657d00136$export$9d23f3030ed2597e = "mcp.progress.percentage", $0f568bf657d00136$export$a26ff217a6124160 = "mcp.progress.token", $0f568bf657d00136$export$c8072f5fcfdb5b77 = "mcp.progress.total", $0f568bf657d00136$export$c4e4b74f1ccf3d96 = "mcp.prompt.name", $0f568bf657d00136$export$328519d02a26ac41 = "mcp.prompt.result.description", $0f568bf657d00136$export$d2061b291c43d045 = "mcp.prompt.result.message_content", $0f568bf657d00136$export$d1f04dfd3d695286 = "mcp.prompt.result.message_count", $0f568bf657d00136$export$234fbd86ea0f0bd8 = "mcp.prompt.result.message_role", $0f568bf657d00136$export$e795000978a75b12 = "mcp.protocol.ready", $0f568bf657d00136$export$9f4683b4d1018ace = "mcp.protocol.version", $0f568bf657d00136$export$e431b042fcdb1d63 = "mcp.request.argument.<key>", $0f568bf657d00136$export$a453239171ac9a23 = "mcp.request.argument", $0f568bf657d00136$export$3a7726a976c18d5f = "mcp.request.argument.name", $0f568bf657d00136$export$7eca7a6c06843b93 = "mcp.request.argument.uri", $0f568bf657d00136$export$f25c55f83e5b0672 = "mcp.request.id", $0f568bf657d00136$export$9562bfac4eb079cb = "mcp.resource.protocol", $0f568bf657d00136$export$c276d164ff91d2f7 = "mcp.resource.uri", $0f568bf657d00136$export$2f3e0574f1a99754 = "mcp.server.name", $0f568bf657d00136$export$15eecaab68167880 = "mcp.server.title", $0f568bf657d00136$export$513c47f6e194086a = "mcp.server.version", $0f568bf657d00136$export$a3f464c4d5cd9096 = "mcp.session.id", $0f568bf657d00136$export$ed366a03a2330b03 = "mcp.tool.name", $0f568bf657d00136$export$9b802c784f235e1d = "mcp.tool.result.content", $0f568bf657d00136$export$add0fc8b8c5726a4 = "mcp.tool.result.content_count", $0f568bf657d00136$export$e7f32463f5bfd554 = "mcp.tool.result.is_error", $0f568bf657d00136$export$f9346f394edf26a = "mcp.transport", $0f568bf657d00136$export$16b917774e73ef92 = "mdc.<key>", $0f568bf657d00136$export$15d2b60bf3b65454 = "mdc", $0f568bf657d00136$export$db55eca5af256142 = "messaging.batch.message_count", $0f568bf657d00136$export$967c74f8b1f3d35 = "messaging.destination", $0f568bf657d00136$export$7c33ae67962515d1 = "messaging.destination.connection", $0f568bf657d00136$export$9c69839b2d93489b = "messaging.destination.name", $0f568bf657d00136$export$be22d22d4b6cf5d8 = "messaging.message.body.size", $0f568bf657d00136$export$c529961b911626ac = "messaging.message.conversation_id", $0f568bf657d00136$export$e39c4b15d2881f5 = "messaging.message.envelope.size", $0f568bf657d00136$export$a8ca145161313e7 = "messaging.message.id", $0f568bf657d00136$export$3c1204d03918d076 = "messaging.message.receive.latency", $0f568bf657d00136$export$eaac3f141165e288 = "messaging.message.retry.count", $0f568bf657d00136$export$4c7e6934714150e6 = "messaging.operation.name", $0f568bf657d00136$export$6f71f9711d666eb4 = "messaging.operation.type", $0f568bf657d00136$export$2a3cd2bb71fb63a4 = "messaging.rabbitmq.destination.routing_key", $0f568bf657d00136$export$55478a0b7d2ae98f = "messaging.system", $0f568bf657d00136$export$bed10c4da9b8eb0a = "method", $0f568bf657d00136$export$a82607b6424c06c8 = "middleware.name", $0f568bf657d00136$export$6b081f3484c7f4e5 = "navigation.origin", $0f568bf657d00136$export$b7754d85fd39406c = "navigation.route.id", $0f568bf657d00136$export$492856c046eb4728 = "navigation.type", $0f568bf657d00136$export$c1678a2059fbe906 = "nel.elapsed_time", $0f568bf657d00136$export$6d384a0bc1011c34 = "nel.phase", $0f568bf657d00136$export$1499a7dbfc01e7d4 = "nel.referrer", $0f568bf657d00136$export$cfcbff40019f0ff1 = "nel.sampling_function", $0f568bf657d00136$export$27157b5f68e583af = "nel.type", $0f568bf657d00136$export$54bf5ed61532925d = "network.connection.effective_type", $0f568bf657d00136$export$60ed0786292ace08 = "network.connection.rtt", $0f568bf657d00136$export$d770bfb8345e146 = "network.connection.type", $0f568bf657d00136$export$bb73817f1290ad28 = "network.local.address", $0f568bf657d00136$export$f201c980f2b75802 = "network.local.port", $0f568bf657d00136$export$b40e970572afd0ee = "network.peer.address", $0f568bf657d00136$export$8850630a3d343488 = "network.peer.port", $0f568bf657d00136$export$fd0a39a918d6516f = "network.protocol.name", $0f568bf657d00136$export$e68ef41f8e0335bf = "network.protocol.version", $0f568bf657d00136$export$5bff09650e762829 = "network.transport", $0f568bf657d00136$export$21c1adce0e067f37 = "network.type", $0f568bf657d00136$export$fed6ce86f48c84bc = "net.host.ip", $0f568bf657d00136$export$500c2675137ac16e = "net.host.name", $0f568bf657d00136$export$402c7728623fd8df = "net.host.port", $0f568bf657d00136$export$15417259f4c0fe6b = "net.peer.ip", $0f568bf657d00136$export$2b3b7f579a727f45 = "net.peer.name", $0f568bf657d00136$export$514832a0b029734b = "net.peer.port", $0f568bf657d00136$export$b0522e6a14dec1a4 = "net.protocol.name", $0f568bf657d00136$export$659ea19f71a7ee0b = "net.protocol.version", $0f568bf657d00136$export$1b61d972db315e73 = "net.sock.family", $0f568bf657d00136$export$fb2970ee11a479ee = "net.sock.host.addr", $0f568bf657d00136$export$920aceb2a8fad77e = "net.sock.host.port", $0f568bf657d00136$export$48f8f6fbc999d187 = "net.sock.peer.addr", $0f568bf657d00136$export$eed590fa00a8223b = "net.sock.peer.name", $0f568bf657d00136$export$f2e5bb5cd4a130da = "net.sock.peer.port", $0f568bf657d00136$export$779ef03d633a9086 = "net.transport", $0f568bf657d00136$export$d98b87c8d53d0dbc = "os.build", $0f568bf657d00136$export$ca719aa57653a0a7 = "os.build_id", $0f568bf657d00136$export$74b19c5f48270c05 = "os.description", $0f568bf657d00136$export$c351affe7e8098cb = "os.kernel_version", $0f568bf657d00136$export$be7cd6b3ae3ae765 = "os.name", $0f568bf657d00136$export$ec182524c4c57275 = "os.raw_description", $0f568bf657d00136$export$9e45758246a85b07 = "os.rooted", $0f568bf657d00136$export$9fa5d5f0144954cb = "os.theme", $0f568bf657d00136$export$e66ba5bc4b978023 = "os.type", $0f568bf657d00136$export$2306e23cc611a36d = "os.version", $0f568bf657d00136$export$144f8c1fe01428db = "otel.kind", $0f568bf657d00136$export$f303b2744d52121c = "otel.scope.name", $0f568bf657d00136$export$866b2dbc7bf18ce6 = "otel.scope.version", $0f568bf657d00136$export$b4c85774878b4841 = "otel.status_code", $0f568bf657d00136$export$1c967a71bc9a3077 = "otel.status_description", $0f568bf657d00136$export$5e3884a35a19eb90 = "params.<key>", $0f568bf657d00136$export$6e7ff99bb3259573 = "params", $0f568bf657d00136$export$7c932cba2d9e7a7 = "performance.activationStart", $0f568bf657d00136$export$94091942edce0667 = "performance.timeOrigin", $0f568bf657d00136$export$3671a8a524706a9d = "previous_route", $0f568bf657d00136$export$c288888dc82d233f = "process.command_args", $0f568bf657d00136$export$8ff188536cebc35 = "process.executable.name", $0f568bf657d00136$export$6407d78968c0eabe = "process.pid", $0f568bf657d00136$export$43e9fb9ec28d9743 = "process.runtime.description", $0f568bf657d00136$export$26f31d5c5c201739 = "process.runtime.engine.name", $0f568bf657d00136$export$bff85124d2d35b93 = "process.runtime.engine.version", $0f568bf657d00136$export$495c671ed5a6408c = "process.runtime.name", $0f568bf657d00136$export$54b3d4d5548c35c3 = "process.runtime.version", $0f568bf657d00136$export$2954db6444fe1fa8 = "query.<key>", $0f568bf657d00136$export$15c1c974d16dd678 = "query", $0f568bf657d00136$export$9be2ae89a1eac217 = "react.version", $0f568bf657d00136$export$5c698591c0e586a2 = "release", $0f568bf657d00136$export$b711f2bb9c9a848a = "remix.action_form_data.<key>", $0f568bf657d00136$export$1d3a8501efd30213 = "remix.action_form_data", $0f568bf657d00136$export$cebaf684ced5a2c9 = "replay_id", $0f568bf657d00136$export$d4c658ecdcb7c78c = "resource.deployment.environment", $0f568bf657d00136$export$b1b162b01baeb044 = "resource.deployment.environment.name", $0f568bf657d00136$export$8be2d593d7f88ed8 = "resource.render_blocking_status", $0f568bf657d00136$export$dbd0a3528a97ccc0 = "route", $0f568bf657d00136$export$66581dc6d3d083d1 = "rpc.grpc.status_code", $0f568bf657d00136$export$e545f99e7abcc499 = "rpc.method", $0f568bf657d00136$export$7e1af5787f8c4aaa = "rpc.response.status_code", $0f568bf657d00136$export$186c94c351c54768 = "rpc.service", $0f568bf657d00136$export$2e3fd8dfcb16fe0c = "rpc.system", $0f568bf657d00136$export$7eeeceaa1dbd7cd5 = "rpc.system.name", $0f568bf657d00136$export$9d5bffdff936d554 = "runtime.build", $0f568bf657d00136$export$dc3a801c9a2c5b79 = "runtime.name", $0f568bf657d00136$export$27933a9557f87e98 = "runtime.raw_description", $0f568bf657d00136$export$eefa737b40a0d535 = "runtime.version", $0f568bf657d00136$export$92740ffbcb02553b = "score.<key>", $0f568bf657d00136$export$500e89753f9f1008 = "score", $0f568bf657d00136$export$d91a18e47fdddefd = "score.ratio.<key>", $0f568bf657d00136$export$eccbe6f20884ea7f = "score.ratio", $0f568bf657d00136$export$9e24f11d79141afb = "score.total", $0f568bf657d00136$export$f0b96ad9586f8887 = "score.weight.<key>", $0f568bf657d00136$export$8a92ed5d436a85c6 = "score.weight", $0f568bf657d00136$export$edd59acdf7e86a71 = "sentry.action", $0f568bf657d00136$export$ae81a1ae71952d50 = "sentry.browser.name", $0f568bf657d00136$export$6101470cd57eac1b = "sentry.browser.version", $0f568bf657d00136$export$452c0aee9673fe67 = "sentry.cancellation_reason", $0f568bf657d00136$export$773dddd1e8667756 = "sentry.category", $0f568bf657d00136$export$98815f8579a64a90 = "sentry.client_sample_rate", $0f568bf657d00136$export$7bc4e27428665019 = "sentry.description", $0f568bf657d00136$export$e7d7477fa9057ee2 = "sentry.dist", $0f568bf657d00136$export$1f4267a3fc018448 = "sentry.domain", $0f568bf657d00136$export$c171cae150389952 = "sentry.dsc.environment", $0f568bf657d00136$export$d9bb35e957b22c72 = "sentry.dsc.project_id", $0f568bf657d00136$export$b3508a2c95f74e3d = "sentry.dsc.public_key", $0f568bf657d00136$export$20bb272f4d21532d = "sentry.dsc.release", $0f568bf657d00136$export$d7e64fbd0102ce90 = "sentry.dsc.sampled", $0f568bf657d00136$export$c17eae7e86dbba3c = "sentry.dsc.sample_rate", $0f568bf657d00136$export$349603c0a9165744 = "sentry.dsc.trace_id", $0f568bf657d00136$export$4dadf693741f0283 = "sentry.dsc.transaction", $0f568bf657d00136$export$6377864d12f7eeb3 = "sentry.environment", $0f568bf657d00136$export$ba081af9585ed4 = "sentry.exclusive_time", $0f568bf657d00136$export$7841dacb241485d0 = "sentry.graphql.operation", $0f568bf657d00136$export$52c7044cf6301362 = "sentry.group", $0f568bf657d00136$export$56ea1c9e44590e20 = "sentry.http.prefetch", $0f568bf657d00136$export$7626e389d05f4c36 = "sentry.idle_span_finish_reason", $0f568bf657d00136$export$5e0a48187329b2e7 = "sentry.is_remote", $0f568bf657d00136$export$c322b150d7667841 = "sentry.kind", $0f568bf657d00136$export$4a4797d3c962f753 = "sentry.main_thread", $0f568bf657d00136$export$767524d5e72e2645 = "sentry.message.parameter.<key>", $0f568bf657d00136$export$497354ca7b0ee666 = "sentry.message.template", $0f568bf657d00136$export$cbdc4ad11118116a = "sentry.metric.source", $0f568bf657d00136$export$5b890de778c4c2fe = "sentry.mobile", $0f568bf657d00136$export$a78d9803b5e0a83e = "sentry.module.<key>", $0f568bf657d00136$export$df1b536467b3992a = "sentry.module", $0f568bf657d00136$export$73104a329e205998 = "sentry.nextjs.ssr.function.route", $0f568bf657d00136$export$5740e3da55330b0a = "sentry.nextjs.ssr.function.type", $0f568bf657d00136$export$8dcc2d92ff6d65da = "sentry.normalized_db_query", $0f568bf657d00136$export$e5f1321e53e24810 = "sentry.normalized_db_query.hash", $0f568bf657d00136$export$56dd3098cbca7c8a = "sentry.normalized_description", $0f568bf657d00136$export$aa7aff70e4380665 = "sentry.observed_timestamp_nanos", $0f568bf657d00136$export$dacb7d452aa6bcaf = "sentry.op", $0f568bf657d00136$export$15dfc6c5e8f9baf6 = "sentry.origin", $0f568bf657d00136$export$91ad03bba7909fb5 = "sentry.platform", $0f568bf657d00136$export$86128e6c0ab71d64 = "sentry.profiler_id", $0f568bf657d00136$export$745b60c4819aec1d = "sentry.profile_id", $0f568bf657d00136$export$d2c893bfac1da9a1 = "sentry.release", $0f568bf657d00136$export$1c14ad02f9534b19 = "sentry.replay_id", $0f568bf657d00136$export$db3cb63e0594d014 = "sentry.replay_is_buffering", $0f568bf657d00136$export$a65c9a0eba2c222d = "sentry.report_event", $0f568bf657d00136$export$68dbcca9c0e339ec = "sentry.sdk.integrations", $0f568bf657d00136$export$d59b669d4bb3f006 = "sentry.sdk.name", $0f568bf657d00136$export$4d88d347aa9667fc = "sentry.sdk.version", $0f568bf657d00136$export$9943ffdcaa4bc506 = "sentry.segment.id", $0f568bf657d00136$export$268a117c860fca6d = "sentry.segment_id", $0f568bf657d00136$export$d4f25b923533dbba = "sentry.segment.name", $0f568bf657d00136$export$35f3396a1cdeea45 = "sentry.server_sample_rate", $0f568bf657d00136$export$80e399da474bc98d = "sentry.source", $0f568bf657d00136$export$e01809e2dbceac35 = "sentry.span.source", $0f568bf657d00136$export$41900d5c4e8a9c68 = "sentry.status", $0f568bf657d00136$export$362bb1cb0bb5ca03 = "sentry.status_code", $0f568bf657d00136$export$6803ac54f919d9cc = "sentry.status.message", $0f568bf657d00136$export$72f5b47540331169 = "sentry.sveltekit.navigation.from", $0f568bf657d00136$export$6c61a8c9aa5305cb = "sentry.sveltekit.navigation.to", $0f568bf657d00136$export$6b5244c457b68e65 = "sentry.sveltekit.navigation.type", $0f568bf657d00136$export$b7bd0c9a886f3414 = "sentry.thread.id", $0f568bf657d00136$export$6b77f2bacac7c93d = "sentry.timestamp.sequence", $0f568bf657d00136$export$ddbc15c0e8e8a7ea = "sentry.trace_lifecycle", $0f568bf657d00136$export$feb4fe753df28a82 = "sentry.trace.parent_span_id", $0f568bf657d00136$export$d6267756132e2175 = "sentry.trace.status", $0f568bf657d00136$export$570ac5a3fd7e6cc6 = "sentry.transaction", $0f568bf657d00136$export$5b9a0015e1c530ed = "sentry.user.email", $0f568bf657d00136$export$8bbff71c84508218 = "sentry.user.geo.city", $0f568bf657d00136$export$b55aa07a514a2430 = "sentry.user.geo.country_code", $0f568bf657d00136$export$9927ad09f7c084dc = "sentry.user.geo.region", $0f568bf657d00136$export$52a07a35ff8ec6b6 = "sentry.user.geo.subdivision", $0f568bf657d00136$export$a10d277c42e6cae3 = "sentry.user.id", $0f568bf657d00136$export$cdc0ce5c66182801 = "sentry.user.ip", $0f568bf657d00136$export$2504d4bd698dd962 = "sentry.user.username", $0f568bf657d00136$export$9dc86f3b876e96ef = "server.address", $0f568bf657d00136$export$70ff7865f52549ae = "server_name", $0f568bf657d00136$export$f77b53a42be6e6fd = "server.port", $0f568bf657d00136$export$818eb7ab11414506 = "service.name", $0f568bf657d00136$export$829ef6b2e59d984d = "service.version", $0f568bf657d00136$export$b30f4cb52c088a26 = "session.id", $0f568bf657d00136$export$335eace0ff1771cd = "stall_percentage", $0f568bf657d00136$export$374d88a2025416ac = "stall_total_time", $0f568bf657d00136$export$bb7a91303551eb37 = "state.type", $0f568bf657d00136$export$f132ea291a7db56b = "thread.id", $0f568bf657d00136$export$f0abd4170bbd2468 = "thread.name", $0f568bf657d00136$export$50d00a157dc08581 = "timber.tag", $0f568bf657d00136$export$484576567a98833f = "time_to_full_display", $0f568bf657d00136$export$ec9e491e475d0c97 = "time_to_initial_display", $0f568bf657d00136$export$a86c59c10992220f = "transaction", $0f568bf657d00136$export$e12f06597e992fde = "trpc.procedure_path", $0f568bf657d00136$export$7ec54678ba28ea59 = "trpc.procedure_type", $0f568bf657d00136$export$433ba14c16717110 = "ttfb", $0f568bf657d00136$export$309ee349b8a537f = "ttfb.requestTime", $0f568bf657d00136$export$b87f371cbc396fcf = "type", $0f568bf657d00136$export$60050fc49fe0e7e2 = "ui.component_name", $0f568bf657d00136$export$348c8e2b37f276cd = "ui.contributes_to_ttfd", $0f568bf657d00136$export$7f47e8a8b2d97cb2 = "ui.contributes_to_ttid", $0f568bf657d00136$export$50d5adc4b543ce95 = "ui.element.height", $0f568bf657d00136$export$9221f1d2c934d9f = "ui.element.id", $0f568bf657d00136$export$3a56578b3ae09a02 = "ui.element.identifier", $0f568bf657d00136$export$e47b8dab9466c895 = "ui.element.load_time", $0f568bf657d00136$export$4ca52f75cf4889c5 = "ui.element.paint_type", $0f568bf657d00136$export$7343d7d72195067f = "ui.element.render_time", $0f568bf657d00136$export$f334f32f8d4d8063 = "ui.element.type", $0f568bf657d00136$export$c7bf2089e89a217c = "ui.element.url", $0f568bf657d00136$export$f514f97553a434b2 = "ui.element.width", $0f568bf657d00136$export$61abde59b50deb8e = "url", $0f568bf657d00136$export$5a5ce44f9fb51f93 = "url.domain", $0f568bf657d00136$export$7044ea8d89b6f59d = "url.fragment", $0f568bf657d00136$export$40eacf1a072c9dbd = "url.full", $0f568bf657d00136$export$4c1fa0ac0eff2ac = "url.path", $0f568bf657d00136$export$5bee9450fe31dde1 = "url.path.parameter.<key>", $0f568bf657d00136$export$d0b571fb4406d953 = "url.path.parameter", $0f568bf657d00136$export$258b370e6c2b85d5 = "url.port", $0f568bf657d00136$export$dc5e5523da291a4b = "url.query", $0f568bf657d00136$export$fd5a8904ab5abfe0 = "url.same_origin", $0f568bf657d00136$export$1350d8937b0f26fb = "url.scheme", $0f568bf657d00136$export$2a045f777fb349a8 = "url.template", $0f568bf657d00136$export$8bb874585539a88f = "user_agent.original", $0f568bf657d00136$export$17d3a50785727199 = "user.email", $0f568bf657d00136$export$2931c570009689e = "user.full_name", $0f568bf657d00136$export$199cbcedee735a43 = "user.geo.city", $0f568bf657d00136$export$4ba5bf9d4e3ed862 = "user.geo.country_code", $0f568bf657d00136$export$674c01ec2f0b89c3 = "user.geo.region", $0f568bf657d00136$export$bda1686739fd61c7 = "user.geo.subdivision", $0f568bf657d00136$export$8d804148f485d54c = "user.hash", $0f568bf657d00136$export$212a8f1ea37518bd = "user.id", $0f568bf657d00136$export$c9ac0fee28245883 = "user.ip_address", $0f568bf657d00136$export$77078610759fe5f6 = "user.name", $0f568bf657d00136$export$7c6317deeec7a6c1 = "user.roles", $0f568bf657d00136$export$877ebf2e4ad81f03 = "vercel.branch", $0f568bf657d00136$export$70b2343945496e1f = "vercel.build_id", $0f568bf657d00136$export$8415b56d2c6d2b1d = "vercel.deployment_id", $0f568bf657d00136$export$cc81114a03caab18 = "vercel.destination", $0f568bf657d00136$export$bc14eb892daceb23 = "vercel.edge_type", $0f568bf657d00136$export$3c973217450c3e9d = "vercel.entrypoint", $0f568bf657d00136$export$582c0b730ff1ddb9 = "vercel.execution_region", $0f568bf657d00136$export$b3edfb545b65f1c5 = "vercel.id", $0f568bf657d00136$export$2593317d8731841c = "vercel.ja3_digest", $0f568bf657d00136$export$8bb5bc1732aa41f = "vercel.ja4_digest", $0f568bf657d00136$export$74a79c98b110b5b9 = "vercel.log_type", $0f568bf657d00136$export$26461b03281b4db4 = "vercel.path", $0f568bf657d00136$export$eaea590d6d3dd93c = "vercel.project_id", $0f568bf657d00136$export$af45365f70099379 = "vercel.project_name", $0f568bf657d00136$export$a49e732d34d5ba9b = "vercel.proxy.cache_id", $0f568bf657d00136$export$7c147fe246bc8bd3 = "vercel.proxy.client_ip", $0f568bf657d00136$export$e5111b6070e1ee9e = "vercel.proxy.host", $0f568bf657d00136$export$591cbfd403f8c8d = "vercel.proxy.lambda_region", $0f568bf657d00136$export$b1388db955bbb885 = "vercel.proxy.method", $0f568bf657d00136$export$e898d0e9e211abd9 = "vercel.proxy.path", $0f568bf657d00136$export$ab6fee0e8a6ee069 = "vercel.proxy.path_type", $0f568bf657d00136$export$9786ad94c199ffbb = "vercel.proxy.path_type_variant", $0f568bf657d00136$export$269890524eed693b = "vercel.proxy.referer", $0f568bf657d00136$export$2ec623a8212d6b64 = "vercel.proxy.region", $0f568bf657d00136$export$30e7673b01ff994e = "vercel.proxy.response_byte_size", $0f568bf657d00136$export$9ea93477840812bf = "vercel.proxy.scheme", $0f568bf657d00136$export$a6da0c365670c430 = "vercel.proxy.status_code", $0f568bf657d00136$export$7986b22da43f2885 = "vercel.proxy.timestamp", $0f568bf657d00136$export$a9f943c7ceb3b42f = "vercel.proxy.user_agent", $0f568bf657d00136$export$dfe49501efcdffce = "vercel.proxy.vercel_cache", $0f568bf657d00136$export$be465f50c92eb01d = "vercel.proxy.vercel_id", $0f568bf657d00136$export$c138d1796bb34999 = "vercel.proxy.waf_action", $0f568bf657d00136$export$85a0016690a0ccf2 = "vercel.proxy.waf_rule_id", $0f568bf657d00136$export$883acab36ede4bfa = "vercel.request_id", $0f568bf657d00136$export$9cfc88d203f9cdf1 = "vercel.source", $0f568bf657d00136$export$b3c6c599110d7bab = "vercel.status_code", $0f568bf657d00136$export$96f586f8837b86ae = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $0f568bf657d00136$export$bd393bbb84b309d3 = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};



var $2MLxn = parcelRequire("2MLxn");

const $7de7b87bc3f0585b$var$DEFAULT_BASE_URL = "thismessage:/";
function $7de7b87bc3f0585b$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $7de7b87bc3f0585b$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $7de7b87bc3f0585b$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $7de7b87bc3f0585b$export$5339fcdc8e2a427c(url) {
    if ($7de7b87bc3f0585b$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $7de7b87bc3f0585b$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $7de7b87bc3f0585b$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $7de7b87bc3f0585b$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName, client) {
    const attributes = {
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = (0, $8007a70b9b6b88a6$export$8cbd6331b69d8fe6)(urlObject.search, client);
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$7de7b87bc3f0585b$export$e258e13805402ba7(urlObject)) {
            attributes[0, $0f568bf657d00136$export$40eacf1a072c9dbd] = (0, $8007a70b9b6b88a6$export$9dbd5b9f0d1db392)(urlObject.href, client);
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $7de7b87bc3f0585b$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $7de7b87bc3f0585b$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $7de7b87bc3f0585b$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $7de7b87bc3f0585b$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $7de7b87bc3f0585b$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}


var $byQav = parcelRequire("byQav");function $eabfd7106e0d0c43$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}



var $6i9K0 = parcelRequire("6i9K0");
var $1nf4J = parcelRequire("1nf4J");

var $59NSd = parcelRequire("59NSd");
const $09d3ee1c93b200e9$export$56d8a8a25bd48b81 = (0, $59NSd.GLOBAL_OBJ);


const $2f47c312dd50f63a$var$DEBOUNCE_DURATION = 1e3;
let $2f47c312dd50f63a$var$debounceTimerID;
let $2f47c312dd50f63a$var$lastCapturedEventType;
let $2f47c312dd50f63a$var$lastCapturedEventTargetId;
function $2f47c312dd50f63a$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, $2f47c312dd50f63a$export$3014bbf0af0e1d4a);
}
function $2f47c312dd50f63a$export$3014bbf0af0e1d4a() {
    if (!(0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $aa72e96078455c59$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $2f47c312dd50f63a$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $6i9K0.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $2f47c312dd50f63a$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $6i9K0.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $2f47c312dd50f63a$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $2f47c312dd50f63a$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $2f47c312dd50f63a$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $2f47c312dd50f63a$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $2f47c312dd50f63a$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $2f47c312dd50f63a$var$getEventTarget(event);
        if ($2f47c312dd50f63a$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $6i9K0.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $6i9K0.addNonEnumerableProperty)(target, "_sentryId", (0, $1nf4J.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$2f47c312dd50f63a$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $2f47c312dd50f63a$var$lastCapturedEventType = event.type;
            $2f47c312dd50f63a$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($2f47c312dd50f63a$var$debounceTimerID);
        $2f47c312dd50f63a$var$debounceTimerID = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).setTimeout(()=>{
            $2f47c312dd50f63a$var$lastCapturedEventTargetId = void 0;
            $2f47c312dd50f63a$var$lastCapturedEventType = void 0;
        }, $2f47c312dd50f63a$var$DEBOUNCE_DURATION);
    };
}
function $2f47c312dd50f63a$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}


var $6i9K0 = parcelRequire("6i9K0");

let $c7f70fe1d3ccb7d6$var$lastHref;
function $c7f70fe1d3ccb7d6$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, $c7f70fe1d3ccb7d6$export$d9b613a6254a184e);
}
function $c7f70fe1d3ccb7d6$export$d9b613a6254a184e() {
    (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).location.href;
        const from = $c7f70fe1d3ccb7d6$var$lastHref;
        $c7f70fe1d3ccb7d6$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $aa72e96078455c59$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $75f5e3731cc0c3a9$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $c7f70fe1d3ccb7d6$var$lastHref;
                const to = $c7f70fe1d3ccb7d6$var$getAbsoluteUrl(String(url));
                $c7f70fe1d3ccb7d6$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $aa72e96078455c59$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $6i9K0.fill)((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $6i9K0.fill)((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $c7f70fe1d3ccb7d6$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}


var $exje8 = parcelRequire("exje8");
var $c5ls6 = parcelRequire("c5ls6");

const $72d11f6c27b0f76b$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $72d11f6c27b0f76b$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, $72d11f6c27b0f76b$export$c67d533bf77cbf54);
}
function $72d11f6c27b0f76b$export$c67d533bf77cbf54() {
    if (!(0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            let virtualError = new Error();
            const startTimestamp = (0, $c5ls6.timestampInSeconds)() * 1e3;
            const method = (0, $exje8.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $72d11f6c27b0f76b$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$72d11f6c27b0f76b$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$72d11f6c27b0f76b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $c5ls6.timestampInSeconds)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $aa72e96078455c59$export$b18c893e424d3127)("xhr", handlerData);
                    virtualError = void 0;
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$72d11f6c27b0f76b$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $exje8.isString)(header) && (0, $exje8.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$72d11f6c27b0f76b$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $c5ls6.timestampInSeconds)() * 1e3,
                xhr: sendThisArg
            };
            (0, $aa72e96078455c59$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $72d11f6c27b0f76b$var$parseXhrUrlArg(url) {
    if ((0, $exje8.isString)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


var $exje8 = parcelRequire("exje8");
const $dcf13f5a97021253$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $dcf13f5a97021253$var$accessors = {};
try {
    if (typeof Node !== "undefined") $dcf13f5a97021253$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $dcf13f5a97021253$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $dcf13f5a97021253$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $dcf13f5a97021253$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $dcf13f5a97021253$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $dcf13f5a97021253$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $dcf13f5a97021253$var$_safeRead(el, prop, arg) {
    const fn = $dcf13f5a97021253$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $dcf13f5a97021253$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maskAttributeFn = Array.isArray(options) ? void 0 : options.maskAttributeFn;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $dcf13f5a97021253$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $dcf13f5a97021253$var$_htmlElementAsString(currentElem, keyAttrs, maskAttributeFn);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $dcf13f5a97021253$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $dcf13f5a97021253$var$_htmlElementAsString(el, keyAttrs, maskAttributeFn) {
    const out = [];
    const tagName = $dcf13f5a97021253$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $dcf13f5a97021253$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return maskAttributeFn ? maskAttributeFn("data-sentry-component", dataset["sentryComponent"], el) : dataset["sentryComponent"];
                if (dataset["sentryElement"]) return maskAttributeFn ? maskAttributeFn("data-sentry-element", dataset["sentryElement"], el) : dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$dcf13f5a97021253$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $dcf13f5a97021253$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach(([key, value])=>{
        out.push(`[${key}="${maskAttributeFn && value ? maskAttributeFn(key, value, el) : value}"]`);
    });
    else {
        const id = $dcf13f5a97021253$var$_safeRead(el, "id");
        if (id) out.push(`#${maskAttributeFn ? maskAttributeFn("id", id, el) : id}`);
        const className = $dcf13f5a97021253$var$_safeRead(el, "className");
        if (className && (0, $exje8.isString)(className)) {
            const classes = (maskAttributeFn ? maskAttributeFn("class", className, el) : className).split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $dcf13f5a97021253$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${maskAttributeFn ? maskAttributeFn(k, attr, el) : attr}"]`);
    }
    return out.join("");
}


const $70c82f0a555c967e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $7814f16d05813361$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $7814f16d05813361$var$INTEGRATION_NAME = "Breadcrumbs";
const $7814f16d05813361$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $7814f16d05813361$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $04de36801c02842a$export$1d6e0d073f9e6723)($7814f16d05813361$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $2f47c312dd50f63a$export$5aeffd3db2cf9df7)($7814f16d05813361$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $72d11f6c27b0f76b$export$26ace48dd54c9aea)($7814f16d05813361$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $ccd72d6281fbddaa$export$f75d3c772c923df0)($7814f16d05813361$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $c7f70fe1d3ccb7d6$export$3f18c56c58114e75)($7814f16d05813361$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $7814f16d05813361$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $7814f16d05813361$export$c079d904b326663a = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($7814f16d05813361$var$_breadcrumbsIntegration);
function $7814f16d05813361$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $gqV7N.getClient)() !== client) return;
        (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $1nf4J.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $7814f16d05813361$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $gqV7N.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $7814f16d05813361$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $70c82f0a555c967e$export$16a28057038b10ef) && (0, $cG2xs.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$7814f16d05813361$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$7814f16d05813361$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $7814f16d05813361$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $7814f16d05813361$var$_isEvent(event) ? event.target : event;
            target = (0, $dcf13f5a97021253$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $402417af1fc2ab33$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $7814f16d05813361$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $gqV7N.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $eabfd7106e0d0c43$export$d771ef054122c30a)(handlerData.level),
            message: (0, $byQav.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $byQav.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $7814f16d05813361$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $gqV7N.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $72d11f6c27b0f76b$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $7ea8f0f0a9581a8e$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
function $7814f16d05813361$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $gqV7N.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $7ea8f0f0a9581a8e$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
function $7814f16d05813361$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $gqV7N.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $7de7b87bc3f0585b$export$7a5253c0f62e0150)((0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $7de7b87bc3f0585b$export$7a5253c0f62e0150)(from) : void 0;
        const parsedTo = (0, $7de7b87bc3f0585b$export$7a5253c0f62e0150)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $7814f16d05813361$var$_isEvent(event) {
    return !!event && !!event.target;
}



var $6i9K0 = parcelRequire("6i9K0");
var $eAGoL = parcelRequire("eAGoL");

const $c3d7c658a866280f$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $c3d7c658a866280f$var$INTEGRATION_NAME = "BrowserApiErrors";
const $c3d7c658a866280f$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $c3d7c658a866280f$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $6i9K0.fill)((0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81), "setTimeout", $c3d7c658a866280f$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $6i9K0.fill)((0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81), "setInterval", $c3d7c658a866280f$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $6i9K0.fill)((0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81), "requestAnimationFrame", $c3d7c658a866280f$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81)) (0, $6i9K0.fill)(XMLHttpRequest.prototype, "send", $c3d7c658a866280f$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $c3d7c658a866280f$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$c3d7c658a866280f$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $c3d7c658a866280f$export$59bfe9f1c76150e = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($c3d7c658a866280f$var$_browserApiErrorsIntegration);
function $c3d7c658a866280f$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $139fd1dbcba49ef9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $eAGoL.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $c3d7c658a866280f$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $139fd1dbcba49ef9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $eAGoL.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $c3d7c658a866280f$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $6i9K0.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $eAGoL.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $6i9K0.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $eAGoL.getFunctionName)(originalFunction);
                return (0, $139fd1dbcba49ef9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $c3d7c658a866280f$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $6i9K0.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($c3d7c658a866280f$var$isEventListenerObject(fn)) fn.handleEvent = (0, $139fd1dbcba49ef9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $eAGoL.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $c3d7c658a866280f$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $139fd1dbcba49ef9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $eAGoL.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $6i9K0.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $c3d7c658a866280f$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $c3d7c658a866280f$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}



var $iFEvA = parcelRequire("iFEvA");
var $cG2xs = parcelRequire("cG2xs");
var $gqV7N = parcelRequire("gqV7N");


function $f4830b41bd3605aa$export$26d3d892edc56833(type, listener, options) {
    if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document) (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $f4830b41bd3605aa$export$324d7b4b46528191(type, listener, options) {
    if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document) (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


const $f04b452e7cb81916$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $7738b4ffbbdb1c6e$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).requestIdleCallback || (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $f04b452e7cb81916$export$b841d51e31c12bab)(cb);
        (0, $f4830b41bd3605aa$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $f4830b41bd3605aa$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $f4830b41bd3605aa$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $f4830b41bd3605aa$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};




const $dcb0e2730a11412e$export$1baa7880e357371c = (0, $d016c01c54e4f9f6$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $70c82f0a555c967e$export$16a28057038b10ef) && (0, $cG2xs.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $iFEvA.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $7738b4ffbbdb1c6e$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $iFEvA.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $gqV7N.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $iFEvA.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $c7f70fe1d3ccb7d6$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $iFEvA.startSession)({
                        ignoreDuration: true
                    });
                    (0, $iFEvA.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});



var $2MLxn = parcelRequire("2MLxn");

var $ea5SN = parcelRequire("ea5SN");

var $kn25x = parcelRequire("kn25x");

var $7l7Os = parcelRequire("7l7Os");

function $34cfdc3f9592d79a$export$3f58558cf4af9c09(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}



var $7LgVW = parcelRequire("7LgVW");

function $19021fd0a693b8fd$export$b1e72a433efdc918(span, client) {
    const spanJSON = (0, $kn25x.spanToStreamedSpanJSON)(span);
    const segmentSpan = (0, $kn25x.INTERNAL_getSegmentSpan)(span);
    const serializedSegmentSpan = (0, $kn25x.spanToStreamedSpanJSON)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $7l7Os.getCapturedScopesOnSpan)(span);
    const finalScopeData = (0, $ea5SN.getCombinedScopeData)(spanIsolationScope, spanScope);
    $19021fd0a693b8fd$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $19021fd0a693b8fd$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $19021fd0a693b8fd$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, $d2ceb212c8cdae62$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $19021fd0a693b8fd$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanJSON.is_segment && spanNameSource) $19021fd0a693b8fd$export$146fcadff0eefcf3(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...(0, $kn25x.streamedSpanJsonToSerializedSpan)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $19021fd0a693b8fd$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = (0, $34cfdc3f9592d79a$export$3f58558cf4af9c09)(scopeData.contexts);
    $19021fd0a693b8fd$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $19021fd0a693b8fd$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $19021fd0a693b8fd$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $19021fd0a693b8fd$export$146fcadff0eefcf3(segmentSpanJSON, {
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS)]: integrationNames
    });
}
function $19021fd0a693b8fd$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $19021fd0a693b8fd$export$146fcadff0eefcf3(spanJSON, {
        [(0, $0f568bf657d00136$export$ddbc15c0e8e8a7ea)]: "stream",
        [(0, $0f568bf657d00136$export$d4f25b923533dbba)]: serializedSegmentSpan.name,
        [(0, $0f568bf657d00136$export$9943ffdcaa4bc506)]: serializedSegmentSpan.span_id,
        [(0, $0f568bf657d00136$export$d59b669d4bb3f006)]: sdk?.sdk?.name,
        [(0, $0f568bf657d00136$export$4d88d347aa9667fc)]: sdk?.sdk?.version,
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE)]: release,
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT)]: environment || (0, $7LgVW.DEFAULT_ENVIRONMENT),
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_USER_ID)]: scopeData.user?.id,
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_USER_EMAIL)]: scopeData.user?.email,
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS)]: scopeData.user?.ip_address,
        [(0, $2MLxn.SEMANTIC_ATTRIBUTE_USER_USERNAME)]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $19021fd0a693b8fd$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $kn25x.showSpanDropWarning)();
        return span;
    }
    return modifedSpan;
}



const $f881a1c0b76d3d36$var$INTEGRATION_NAME = "CultureContext";
const $f881a1c0b76d3d36$var$_cultureContextIntegration = ()=>{
    return {
        name: $f881a1c0b76d3d36$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $f881a1c0b76d3d36$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $f881a1c0b76d3d36$var$getCultureContext();
            if (culture) (0, $19021fd0a693b8fd$export$146fcadff0eefcf3)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $f881a1c0b76d3d36$export$ec5976aacdc85985 = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($f881a1c0b76d3d36$var$_cultureContextIntegration);
function $f881a1c0b76d3d36$var$getCultureContext() {
    try {
        const intl = (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}



var $59NSd = parcelRequire("59NSd");

let $f9b6943067ff663b$var$_oldOnErrorHandler = null;
function $f9b6943067ff663b$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, $f9b6943067ff663b$var$instrumentError);
}
function $f9b6943067ff663b$var$instrumentError() {
    $f9b6943067ff663b$var$_oldOnErrorHandler = (0, $59NSd.GLOBAL_OBJ).onerror;
    (0, $59NSd.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $aa72e96078455c59$export$b18c893e424d3127)("error", handlerData);
        if ($f9b6943067ff663b$var$_oldOnErrorHandler) return $f9b6943067ff663b$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $59NSd.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}


var $59NSd = parcelRequire("59NSd");

let $814418f9c51bc655$var$_oldOnUnhandledRejectionHandler = null;
function $814418f9c51bc655$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $aa72e96078455c59$export$a4e09611e30da72e)(type, handler);
    (0, $aa72e96078455c59$export$e18d6c5462c01368)(type, $814418f9c51bc655$var$instrumentUnhandledRejection);
}
function $814418f9c51bc655$var$instrumentUnhandledRejection() {
    $814418f9c51bc655$var$_oldOnUnhandledRejectionHandler = (0, $59NSd.GLOBAL_OBJ).onunhandledrejection;
    (0, $59NSd.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $aa72e96078455c59$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($814418f9c51bc655$var$_oldOnUnhandledRejectionHandler) return $814418f9c51bc655$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $59NSd.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


var $iFEvA = parcelRequire("iFEvA");
var $cG2xs = parcelRequire("cG2xs");
var $gqV7N = parcelRequire("gqV7N");
var $exje8 = parcelRequire("exje8");
var $eAGoL = parcelRequire("eAGoL");



const $dc80c99b4c5d7b86$var$INTEGRATION_NAME = "GlobalHandlers";
const $dc80c99b4c5d7b86$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $dc80c99b4c5d7b86$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $dc80c99b4c5d7b86$var$_installGlobalOnErrorHandler(client);
                $dc80c99b4c5d7b86$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $dc80c99b4c5d7b86$var$_installGlobalOnUnhandledRejectionHandler(client);
                $dc80c99b4c5d7b86$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $dc80c99b4c5d7b86$export$66acc70e8cf2b71a = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($dc80c99b4c5d7b86$var$_globalHandlersIntegration);
function $dc80c99b4c5d7b86$var$_installGlobalOnErrorHandler(client) {
    (0, $f9b6943067ff663b$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $dc80c99b4c5d7b86$var$getOptions();
        if ((0, $gqV7N.getClient)() !== client || (0, $139fd1dbcba49ef9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $dc80c99b4c5d7b86$var$_enhanceEventWithInitialFrame((0, $3f36613d9ac7cfc2$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $iFEvA.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $dc80c99b4c5d7b86$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $814418f9c51bc655$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $dc80c99b4c5d7b86$var$getOptions();
        if ((0, $gqV7N.getClient)() !== client || (0, $139fd1dbcba49ef9$export$b79738ab10c590b2)()) return;
        const error = $dc80c99b4c5d7b86$export$b2cc40fa8241780(e);
        const event = (0, $exje8.isPrimitive)(error) ? $dc80c99b4c5d7b86$export$1353b5b36844a9ed(error) : (0, $3f36613d9ac7cfc2$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $iFEvA.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $dc80c99b4c5d7b86$export$b2cc40fa8241780(error) {
    if ((0, $exje8.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $dc80c99b4c5d7b86$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $dc80c99b4c5d7b86$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $dc80c99b4c5d7b86$var$getFilenameFromUrl(url) ?? (0, $402417af1fc2ab33$export$1cfafeee2987818b)(),
        function: (0, $eAGoL.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $dc80c99b4c5d7b86$var$globalHandlerLog(type) {
    (0, $70c82f0a555c967e$export$16a28057038b10ef) && (0, $cG2xs.debug).log(`Global Handler attached: ${type}`);
}
function $dc80c99b4c5d7b86$var$getOptions() {
    const client = (0, $gqV7N.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $dc80c99b4c5d7b86$var$getFilenameFromUrl(url) {
    if (!(0, $exje8.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $7de7b87bc3f0585b$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}





const $e7fe7f97be8c5bcf$export$1378794447170364 = (0, $d016c01c54e4f9f6$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event, _hint, client) {
            if (!(0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).navigator && !(0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).location && !(0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $139fd1dbcba49ef9$export$a3c4a8453e8936f0)(client);
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                url: (0, $8007a70b9b6b88a6$export$9dbd5b9f0d1db392)(reqData.url, client),
                ...event.request,
                headers: headers
            };
        },
        processSpan (span, client) {
            if (!(0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).navigator && !(0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).location && !(0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $139fd1dbcba49ef9$export$a3c4a8453e8936f0)(client);
            (0, $19021fd0a693b8fd$export$146fcadff0eefcf3)(span, {
                // This attribute is used by the "Filter out events from legacy browsers and crawlers" features on the Sentry backend.
                // Therefore, it's set on every span.
                [(0, $0f568bf657d00136$export$8bb874585539a88f)]: reqData.headers["User-Agent"],
                // These attributes, we only need on the segment span (analogous to the `request` context for events)
                ...span.is_segment && {
                    // Coerce empty string to undefined so the helper's nullish check drops it,
                    // rather than writing an empty `url.full` attribute onto the span.
                    [(0, $0f568bf657d00136$export$40eacf1a072c9dbd)]: span.attributes?.[0, $0f568bf657d00136$export$dacb7d452aa6bcaf] !== "http.client" ? (0, $8007a70b9b6b88a6$export$9dbd5b9f0d1db392)(reqData.url) : void 0,
                    [`${0, $0f568bf657d00136$export$c387ec65fd1c2638}.referer`]: reqData.headers["Referer"]
                }
            });
        }
    };
});



var $exje8 = parcelRequire("exje8");
function $5ef0b96c72cecadc$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $exje8.isError)(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $5ef0b96c72cecadc$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $5ef0b96c72cecadc$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $exje8.isError)(error[key])) {
        $5ef0b96c72cecadc$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $5ef0b96c72cecadc$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $5ef0b96c72cecadc$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($5ef0b96c72cecadc$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $exje8.isError)(childError)) {
            $5ef0b96c72cecadc$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $5ef0b96c72cecadc$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $5ef0b96c72cecadc$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $5ef0b96c72cecadc$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $5ef0b96c72cecadc$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$5ef0b96c72cecadc$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $5ef0b96c72cecadc$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $0ae7cf8281f8f210$var$DEFAULT_KEY = "cause";
const $0ae7cf8281f8f210$var$DEFAULT_LIMIT = 5;
const $0ae7cf8281f8f210$var$INTEGRATION_NAME = "LinkedErrors";
const $0ae7cf8281f8f210$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $0ae7cf8281f8f210$var$DEFAULT_LIMIT;
    const key = options.key || $0ae7cf8281f8f210$var$DEFAULT_KEY;
    return {
        name: $0ae7cf8281f8f210$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $5ef0b96c72cecadc$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $3f36613d9ac7cfc2$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $0ae7cf8281f8f210$export$ebabb00eb7f3a395 = (0, $d016c01c54e4f9f6$export$2323046b9414659f)($0ae7cf8281f8f210$var$_linkedErrorsIntegration);



var $eAGoL = parcelRequire("eAGoL");
const $e75b3ed8d8bd3802$var$OPERA10_PRIORITY = 10;
const $e75b3ed8d8bd3802$var$OPERA11_PRIORITY = 20;
const $e75b3ed8d8bd3802$var$CHROME_PRIORITY = 30;
const $e75b3ed8d8bd3802$var$WINJS_PRIORITY = 40;
const $e75b3ed8d8bd3802$var$GECKO_PRIORITY = 50;
function $e75b3ed8d8bd3802$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $eAGoL.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $e75b3ed8d8bd3802$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $e75b3ed8d8bd3802$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e75b3ed8d8bd3802$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $e75b3ed8d8bd3802$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $e75b3ed8d8bd3802$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($e75b3ed8d8bd3802$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $e75b3ed8d8bd3802$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $e75b3ed8d8bd3802$var$createFrame(filename, (0, $eAGoL.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $e75b3ed8d8bd3802$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $e75b3ed8d8bd3802$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $e75b3ed8d8bd3802$var$extractSafariExtensionDetails(parts[1] || (0, $eAGoL.UNKNOWN_FUNCTION), parts[2]);
        return $e75b3ed8d8bd3802$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $e75b3ed8d8bd3802$export$263a749fff749872 = [
    $e75b3ed8d8bd3802$var$CHROME_PRIORITY,
    $e75b3ed8d8bd3802$var$chromeStackParserFn
];
const $e75b3ed8d8bd3802$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e75b3ed8d8bd3802$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e75b3ed8d8bd3802$var$gecko = (line)=>{
    const parts = $e75b3ed8d8bd3802$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e75b3ed8d8bd3802$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $eAGoL.UNKNOWN_FUNCTION);
        [func, filename] = $e75b3ed8d8bd3802$var$extractSafariExtensionDetails(func, filename);
        return $e75b3ed8d8bd3802$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $e75b3ed8d8bd3802$export$cdba47a5dd2804d = [
    $e75b3ed8d8bd3802$var$GECKO_PRIORITY,
    $e75b3ed8d8bd3802$var$gecko
];
const $e75b3ed8d8bd3802$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e75b3ed8d8bd3802$var$winjs = (line)=>{
    const parts = $e75b3ed8d8bd3802$var$winjsRegex.exec(line);
    return parts ? $e75b3ed8d8bd3802$var$createFrame(parts[2], parts[1] || (0, $eAGoL.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $e75b3ed8d8bd3802$export$179460296da408e8 = [
    $e75b3ed8d8bd3802$var$WINJS_PRIORITY,
    $e75b3ed8d8bd3802$var$winjs
];
const $e75b3ed8d8bd3802$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e75b3ed8d8bd3802$var$opera10 = (line)=>{
    const parts = $e75b3ed8d8bd3802$var$opera10Regex.exec(line);
    return parts ? $e75b3ed8d8bd3802$var$createFrame(parts[2], parts[3] || (0, $eAGoL.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $e75b3ed8d8bd3802$export$f892b52c880ffc7a = [
    $e75b3ed8d8bd3802$var$OPERA10_PRIORITY,
    $e75b3ed8d8bd3802$var$opera10
];
const $e75b3ed8d8bd3802$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e75b3ed8d8bd3802$var$opera11 = (line)=>{
    const parts = $e75b3ed8d8bd3802$var$opera11Regex.exec(line);
    return parts ? $e75b3ed8d8bd3802$var$createFrame(parts[5], parts[3] || parts[4] || (0, $eAGoL.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $e75b3ed8d8bd3802$export$af11af13f09fb0dc = [
    $e75b3ed8d8bd3802$var$OPERA11_PRIORITY,
    $e75b3ed8d8bd3802$var$opera11
];
const $e75b3ed8d8bd3802$export$7197c0fe6554c079 = [
    $e75b3ed8d8bd3802$export$263a749fff749872,
    $e75b3ed8d8bd3802$export$cdba47a5dd2804d
];
const $e75b3ed8d8bd3802$export$2b2b997d81bf3907 = (0, $eAGoL.createStackParser)(...$e75b3ed8d8bd3802$export$7197c0fe6554c079);
const $e75b3ed8d8bd3802$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $eAGoL.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




var $cG2xs = parcelRequire("cG2xs");
const $8421e719ce98801e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $e2656f69bec1b12b$var$cachedImplementations = {};
function $e2656f69bec1b12b$export$e464f4a514ac28a8(name) {
    const cached = $e2656f69bec1b12b$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81)[name];
    if ((0, $75f5e3731cc0c3a9$export$d5f608b368e73f38)(impl)) return $e2656f69bec1b12b$var$cachedImplementations[name] = impl.bind((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81));
    const document = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $8421e719ce98801e$export$16a28057038b10ef) && (0, $cG2xs.debug).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $e2656f69bec1b12b$var$cachedImplementations[name] = impl.bind((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81));
}
function $e2656f69bec1b12b$export$8aa36702e8c8978(name) {
    $e2656f69bec1b12b$var$cachedImplementations[name] = void 0;
}
function $e2656f69bec1b12b$export$e7aa7bc5c1b3cfb3(...rest) {
    return $e2656f69bec1b12b$export$e464f4a514ac28a8("fetch")(...rest);
}
function $e2656f69bec1b12b$export$831dc9f2ab0a617b(...rest) {
    try {
        return $e2656f69bec1b12b$export$e464f4a514ac28a8("setTimeout")(...rest);
    } catch (e) {
        (0, $8421e719ce98801e$export$16a28057038b10ef) && (0, $cG2xs.debug).warn("Could not use native setTimeout implementation, falling back to window.setTimeout: ", e);
        const fallback = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).setTimeout.bind((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81));
        $e2656f69bec1b12b$var$cachedImplementations.setTimeout = fallback;
        return fallback(...rest);
    }
}


const $7c9e7dab26ffb7ac$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $7c9e7dab26ffb7ac$export$b2311068c46d7cc8(options, nativeFetch = (0, $e2656f69bec1b12b$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $e2656f69bec1b12b$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $477dc03aa082bbce$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $3f9c76d04462ddf3$export$85a4f67f852183e6)(options.bufferSize || $7c9e7dab26ffb7ac$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $e25f79f4c1043c58$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $dbe14aafc379ea93$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $dbe14aafc379ea93$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $e25f79f4c1043c58$export$45a5e7f76e0caa8d)(value)) {
        const objName = $dbe14aafc379ea93$var$getConstructorName(value);
        if ($dbe14aafc379ea93$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $dcf13f5a97021253$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $dbe14aafc379ea93$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}



var $cG2xs = parcelRequire("cG2xs");


function $afc887ea224a0765$export$dc236a86065879fc() {
    if ($afc887ea224a0765$var$_isEmbeddedBrowserExtension()) {
        if (0, $70c82f0a555c967e$export$16a28057038b10ef) (0, $cG2xs.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $afc887ea224a0765$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $402417af1fc2ab33$export$1cfafeee2987818b)();
    const isDedicatedExtensionPage = (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81) === (0, $139fd1dbcba49ef9$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $216561c6f04f7fab$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $afcf62d73cd7f8d3$export$cb3c5c2ceb9818ba)(),
        (0, $7d7fd81a1e80fb9a$export$7918117e9202e4fb)(),
        (0, $b622512e585ae8f9$export$97457a453081a5b3)(),
        (0, $c3d7c658a866280f$export$59bfe9f1c76150e)(),
        (0, $7814f16d05813361$export$c079d904b326663a)(),
        (0, $dc80c99b4c5d7b86$export$66acc70e8cf2b71a)(),
        (0, $0ae7cf8281f8f210$export$ebabb00eb7f3a395)(),
        (0, $6b62cc03ca60ffd4$export$6d39aa44cd0c7567)(),
        (0, $e7fe7f97be8c5bcf$export$1378794447170364)(),
        (0, $f881a1c0b76d3d36$export$ec5976aacdc85985)(),
        (0, $dcb0e2730a11412e$export$1baa7880e357371c)()
    ];
}
function $216561c6f04f7fab$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $afc887ea224a0765$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $216561c6f04f7fab$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $eAGoL.stackParserFromStackParserOptions)(options.stackParser || (0, $e75b3ed8d8bd3802$export$2b2b997d81bf3907)),
        integrations: (0, $d016c01c54e4f9f6$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $7c9e7dab26ffb7ac$export$b2311068c46d7cc8)
    };
    (0, $fuLLi.setNormalizeStringifier)((0, $dbe14aafc379ea93$export$4c88c355e6072df5));
    return (0, $05e769100b279f33$export$5333c3f1c58d9bc1)((0, $03706117b3d2ae35$export$1df9218a526d318d), clientOptions);
}
function $216561c6f04f7fab$export$a3f323d81eede727() {}
function $216561c6f04f7fab$export$4e4d8b287d028b6b(callback) {
    callback();
}


var $iFEvA = parcelRequire("iFEvA");

var $fuLLi = parcelRequire("fuLLi");

var $eF4cA = parcelRequire("eF4cA");

var $exje8 = parcelRequire("exje8");
function $3e86744098dc135f$export$bc2894c7158efbac(wat) {
    return (0, $exje8.isPlainObject)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


function $eb107a3c28f65464$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $ff86e8fd4d841bde$export$b9f95b027256052c)(opts, "react");
    (0, $iFEvA.setContext)("react", {
        version: $eF4cA.version
    });
    const client = (0, $216561c6f04f7fab$export$2cd8252107eb640b)(opts);
    (0, $fuLLi.setNormalizeStringifier)($eb107a3c28f65464$var$normalizeStringifyValue);
    return client;
}
function $eb107a3c28f65464$var$normalizeStringifyValue(value) {
    if ((0, $3e86744098dc135f$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
    return (0, $dbe14aafc379ea93$export$4c88c355e6072df5)(value);
}


var $iFEvA = parcelRequire("iFEvA");
var $c5ls6 = parcelRequire("c5ls6");
var $cG2xs = parcelRequire("cG2xs");function $3710eb481058c495$export$61fc7d43ac8f84b0(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}


var $6i9K0 = parcelRequire("6i9K0");
var $kn25x = parcelRequire("kn25x");
var $gqV7N = parcelRequire("gqV7N");
var $cvdrG = parcelRequire("cvdrG");
var $59NSd = parcelRequire("59NSd");
var $exje8 = parcelRequire("exje8");
function $fecc7855a46a23c6$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $fecc7855a46a23c6$var$checkDsn(url, dsn) || $fecc7855a46a23c6$var$checkTunnel(url, tunnel);
}
function $fecc7855a46a23c6$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $fecc7855a46a23c6$var$removeTrailingSlash(url) === $fecc7855a46a23c6$var$removeTrailingSlash(tunnel);
}
function $fecc7855a46a23c6$var$checkDsn(url, dsn) {
    const urlParts = (0, $7de7b87bc3f0585b$export$2004d912a9ead694)(url);
    if (!urlParts || (0, $7de7b87bc3f0585b$export$e258e13805402ba7)(urlParts)) return false;
    if (!dsn) return false;
    return $fecc7855a46a23c6$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $fecc7855a46a23c6$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $fecc7855a46a23c6$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}


var $fuLLi = parcelRequire("fuLLi");
var $1s5dy = parcelRequire("1s5dy");
var $9rdlm = parcelRequire("9rdlm");
var $2MLxn = parcelRequire("2MLxn");
var $byQav = parcelRequire("byQav");
var $1nf4J = parcelRequire("1nf4J");

var $cG2xs = parcelRequire("cG2xs");
var $eAGoL = parcelRequire("eAGoL");


const $735ca623bec72347$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $735ca623bec72347$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $735ca623bec72347$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $ff8d4c92004bc8b0$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $ff5346c047c9fb75$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $ff8d4c92004bc8b0$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



let $c7d0ba0c0cb7133b$var$firstHiddenTime = -1;
const $c7d0ba0c0cb7133b$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $c7d0ba0c0cb7133b$var$initHiddenTime = ()=>{
    return (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $c7d0ba0c0cb7133b$var$onVisibilityUpdate = (event)=>{
    if ($c7d0ba0c0cb7133b$var$isPageHidden(event) && $c7d0ba0c0cb7133b$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $c7d0ba0c0cb7133b$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($c7d0ba0c0cb7133b$var$firstHiddenTime)) {
            $c7d0ba0c0cb7133b$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $f4830b41bd3605aa$export$324d7b4b46528191)("prerenderingchange", $c7d0ba0c0cb7133b$var$onVisibilityUpdate, true);
        }
    }
};
const $c7d0ba0c0cb7133b$export$443f86b2c77012c4 = ()=>{
    if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document && $c7d0ba0c0cb7133b$var$firstHiddenTime < 0) {
        const activationStart = (0, $ff5346c047c9fb75$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $c7d0ba0c0cb7133b$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $c7d0ba0c0cb7133b$var$initHiddenTime();
        (0, $f4830b41bd3605aa$export$26d3d892edc56833)("visibilitychange", $c7d0ba0c0cb7133b$var$onVisibilityUpdate, true);
        (0, $f4830b41bd3605aa$export$26d3d892edc56833)("pagehide", $c7d0ba0c0cb7133b$var$onVisibilityUpdate, true);
        (0, $f4830b41bd3605aa$export$26d3d892edc56833)("prerenderingchange", $c7d0ba0c0cb7133b$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $c7d0ba0c0cb7133b$var$firstHiddenTime;
        },
        onHidden (cb) {
            $c7d0ba0c0cb7133b$var$onHiddenFunctions.add(cb);
        }
    };
};
function $c7d0ba0c0cb7133b$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $d1b6c5ca3de492b2$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $216ab9f427cdf3ff$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $ff8d4c92004bc8b0$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.prerendering || (0, $ff5346c047c9fb75$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $d1b6c5ca3de492b2$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $528b16106f2295b9$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $528b16106f2295b9$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$528b16106f2295b9$var$instanceMap.get(identityObj)) $528b16106f2295b9$var$instanceMap.set(identityObj, new ClassObj());
        return $528b16106f2295b9$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $19ad25db0eea3ac6$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $f578906f6f1aefd5$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};









const $71b55a8b60d098af$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $3a77048d46bf09ae$export$e610c735b5510cec = [
    1800,
    3e3
];
const $3a77048d46bf09ae$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $71b55a8b60d098af$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $c7d0ba0c0cb7133b$export$443f86b2c77012c4)();
        const metric = (0, $216ab9f427cdf3ff$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $ff5346c047c9fb75$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $f578906f6f1aefd5$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $735ca623bec72347$export$17679dccdd551979)(onReport, metric, $3a77048d46bf09ae$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $59593f155ed9cd72$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $59593f155ed9cd72$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $3a77048d46bf09ae$export$fe3c86b74e15d5de)((0, $f04b452e7cb81916$export$b841d51e31c12bab)(()=>{
        const metric = (0, $216ab9f427cdf3ff$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $c7d0ba0c0cb7133b$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $528b16106f2295b9$export$7c74c9b2462ddb3c)(opts, (0, $19ad25db0eea3ac6$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $f578906f6f1aefd5$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $735ca623bec72347$export$17679dccdd551979)(onReport, metric, $59593f155ed9cd72$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $cb4da6957564de8c$var$interactionCountEstimate = 0;
let $cb4da6957564de8c$var$minKnownInteractionId = Infinity;
let $cb4da6957564de8c$var$maxKnownInteractionId = 0;
const $cb4da6957564de8c$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cb4da6957564de8c$var$minKnownInteractionId = Math.min($cb4da6957564de8c$var$minKnownInteractionId, e.interactionId);
            $cb4da6957564de8c$var$maxKnownInteractionId = Math.max($cb4da6957564de8c$var$maxKnownInteractionId, e.interactionId);
            $cb4da6957564de8c$var$interactionCountEstimate = $cb4da6957564de8c$var$maxKnownInteractionId ? ($cb4da6957564de8c$var$maxKnownInteractionId - $cb4da6957564de8c$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cb4da6957564de8c$var$po;
const $cb4da6957564de8c$export$8a962f2683a476d1 = ()=>{
    return $cb4da6957564de8c$var$po ? $cb4da6957564de8c$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $cb4da6957564de8c$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $cb4da6957564de8c$var$po) return;
    $cb4da6957564de8c$var$po = (0, $f578906f6f1aefd5$export$d1203567a167490e)("event", $cb4da6957564de8c$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $22635304d416e2eb$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $22635304d416e2eb$var$prevInteractionCount = 0;
const $22635304d416e2eb$var$getInteractionCountForNavigation = ()=>{
    return (0, $cb4da6957564de8c$export$8a962f2683a476d1)() - $22635304d416e2eb$var$prevInteractionCount;
};
class $22635304d416e2eb$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $22635304d416e2eb$var$prevInteractionCount = (0, $cb4da6957564de8c$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($22635304d416e2eb$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $22635304d416e2eb$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $22635304d416e2eb$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($22635304d416e2eb$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}






const $3e88b75a2117c56f$export$7f4cb060ded9173c = [
    200,
    500
];
const $3e88b75a2117c56f$var$DEFAULT_DURATION_THRESHOLD = 40;
const $3e88b75a2117c56f$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $c7d0ba0c0cb7133b$export$443f86b2c77012c4)();
    (0, $71b55a8b60d098af$export$8bdb38a5671b594e)(()=>{
        (0, $cb4da6957564de8c$export$67d90cda6b78a2eb)();
        const metric = (0, $216ab9f427cdf3ff$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $528b16106f2295b9$export$7c74c9b2462ddb3c)(opts, (0, $22635304d416e2eb$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $7738b4ffbbdb1c6e$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $f578906f6f1aefd5$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $3e88b75a2117c56f$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $735ca623bec72347$export$17679dccdd551979)(onReport, metric, $3e88b75a2117c56f$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $9d2f046016694d3b$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $b7b0b1e825fa1047$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $b7b0b1e825fa1047$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $71b55a8b60d098af$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $c7d0ba0c0cb7133b$export$443f86b2c77012c4)();
        const metric = (0, $216ab9f427cdf3ff$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $528b16106f2295b9$export$7c74c9b2462ddb3c)(opts, (0, $9d2f046016694d3b$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                if (!entry) continue;
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $ff5346c047c9fb75$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $f578906f6f1aefd5$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $735ca623bec72347$export$17679dccdd551979)(onReport, metric, $b7b0b1e825fa1047$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $f04b452e7cb81916$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $7738b4ffbbdb1c6e$export$d3314d5863fc1fef)(stopListening);
                    (0, $f4830b41bd3605aa$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $f4830b41bd3605aa$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $dce51f24c877029b$export$65c59ea8064668fc = [
    800,
    1800
];
const $dce51f24c877029b$var$whenReady = (callback)=>{
    if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.prerendering) (0, $71b55a8b60d098af$export$8bdb38a5671b594e)(()=>$dce51f24c877029b$var$whenReady(callback));
    else if ((0, $09d3ee1c93b200e9$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$dce51f24c877029b$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $dce51f24c877029b$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $216ab9f427cdf3ff$export$3c29b44508a0612b)("TTFB");
    const report = (0, $735ca623bec72347$export$17679dccdd551979)(onReport, metric, $dce51f24c877029b$export$65c59ea8064668fc, opts.reportAllChanges);
    $dce51f24c877029b$var$whenReady(()=>{
        const navigationEntry = (0, $ff8d4c92004bc8b0$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $ff5346c047c9fb75$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $88bb8f0178a99731$var$handlers = {};
const $88bb8f0178a99731$var$instrumented = {};
let $88bb8f0178a99731$var$_previousCls;
let $88bb8f0178a99731$var$_previousLcp;
let $88bb8f0178a99731$var$_previousTtfb;
let $88bb8f0178a99731$var$_previousInp;
function $88bb8f0178a99731$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $88bb8f0178a99731$var$addMetricObserver("cls", callback, $88bb8f0178a99731$var$instrumentCls, $88bb8f0178a99731$var$_previousCls, stopOnCallback);
}
function $88bb8f0178a99731$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $88bb8f0178a99731$var$addMetricObserver("lcp", callback, $88bb8f0178a99731$var$instrumentLcp, $88bb8f0178a99731$var$_previousLcp, stopOnCallback);
}
function $88bb8f0178a99731$export$699d9529c099a797(callback) {
    return $88bb8f0178a99731$var$addMetricObserver("ttfb", callback, $88bb8f0178a99731$var$instrumentTtfb, $88bb8f0178a99731$var$_previousTtfb);
}
function $88bb8f0178a99731$export$da3b76aa2022cbd7(callback) {
    return $88bb8f0178a99731$var$addMetricObserver("inp", callback, $88bb8f0178a99731$var$instrumentInp, $88bb8f0178a99731$var$_previousInp);
}
function $88bb8f0178a99731$export$69816c1a049f8db6(type, callback) {
    $88bb8f0178a99731$var$addHandler(type, callback);
    if (!$88bb8f0178a99731$var$instrumented[type]) {
        $88bb8f0178a99731$var$instrumentPerformanceObserver(type);
        $88bb8f0178a99731$var$instrumented[type] = true;
    }
    return $88bb8f0178a99731$var$getCleanupCallback(type, callback);
}
function $88bb8f0178a99731$var$triggerHandlers(type, data) {
    const typeHandlers = $88bb8f0178a99731$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $8421e719ce98801e$export$16a28057038b10ef) && (0, $cG2xs.debug).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $eAGoL.getFunctionName)(handler)}
Error:`, e);
    }
}
function $88bb8f0178a99731$var$instrumentCls() {
    return (0, $59593f155ed9cd72$export$a7873055838e5ad8)((metric)=>{
        $88bb8f0178a99731$var$triggerHandlers("cls", {
            metric: metric
        });
        $88bb8f0178a99731$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $88bb8f0178a99731$var$instrumentLcp() {
    return (0, $b7b0b1e825fa1047$export$947b1626ab8d5632)((metric)=>{
        $88bb8f0178a99731$var$triggerHandlers("lcp", {
            metric: metric
        });
        $88bb8f0178a99731$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $88bb8f0178a99731$var$instrumentTtfb() {
    return (0, $dce51f24c877029b$export$33a01e6c5f2c7e33)((metric)=>{
        $88bb8f0178a99731$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $88bb8f0178a99731$var$_previousTtfb = metric;
    });
}
function $88bb8f0178a99731$var$instrumentInp() {
    return (0, $3e88b75a2117c56f$export$7df4b36ecaed99e1)((metric)=>{
        $88bb8f0178a99731$var$triggerHandlers("inp", {
            metric: metric
        });
        $88bb8f0178a99731$var$_previousInp = metric;
    });
}
function $88bb8f0178a99731$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $88bb8f0178a99731$var$addHandler(type, callback);
    let stopListening;
    if (!$88bb8f0178a99731$var$instrumented[type]) {
        stopListening = instrumentFn();
        $88bb8f0178a99731$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $88bb8f0178a99731$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $88bb8f0178a99731$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $f578906f6f1aefd5$export$d1203567a167490e)(type, (entries)=>{
        $88bb8f0178a99731$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $88bb8f0178a99731$var$addHandler(type, handler) {
    $88bb8f0178a99731$var$handlers[type] = $88bb8f0178a99731$var$handlers[type] || [];
    $88bb8f0178a99731$var$handlers[type].push(handler);
}
function $88bb8f0178a99731$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $88bb8f0178a99731$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $88bb8f0178a99731$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}


var $cG2xs = parcelRequire("cG2xs");

const $001198e209f856ba$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $001198e209f856ba$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $001198e209f856ba$export$945a2d5364608d5(body, _debug = (0, $cG2xs.debug)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $001198e209f856ba$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $8421e719ce98801e$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $8421e719ce98801e$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $001198e209f856ba$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$001198e209f856ba$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $001198e209f856ba$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $8421e719ce98801e$export$16a28057038b10ef) && (0, $cG2xs.debug).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}


const $2fb40ae0f5ba1db6$var$WINDOW = (0, $59NSd.GLOBAL_OBJ);
const $2fb40ae0f5ba1db6$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $2fb40ae0f5ba1db6$var$REPLAY_EVENT_NAME = "replay_event";
const $2fb40ae0f5ba1db6$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
const $2fb40ae0f5ba1db6$var$SESSION_IDLE_PAUSE_DURATION = 3e5;
const $2fb40ae0f5ba1db6$var$SESSION_IDLE_EXPIRE_DURATION = 9e5;
const $2fb40ae0f5ba1db6$var$DEFAULT_FLUSH_MIN_DELAY = 5e3;
const $2fb40ae0f5ba1db6$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
const $2fb40ae0f5ba1db6$var$BUFFER_CHECKOUT_TIME = 6e4;
const $2fb40ae0f5ba1db6$var$RETRY_BASE_INTERVAL = 5e3;
const $2fb40ae0f5ba1db6$var$RETRY_MAX_COUNT = 3;
const $2fb40ae0f5ba1db6$var$NETWORK_BODY_MAX_SIZE = 15e4;
const $2fb40ae0f5ba1db6$var$CONSOLE_ARG_MAX_SIZE = 5e3;
const $2fb40ae0f5ba1db6$var$SLOW_CLICK_THRESHOLD = 3e3;
const $2fb40ae0f5ba1db6$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
const $2fb40ae0f5ba1db6$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
const $2fb40ae0f5ba1db6$var$MIN_REPLAY_DURATION = 4999;
const $2fb40ae0f5ba1db6$var$MIN_REPLAY_DURATION_LIMIT = 5e4;
const $2fb40ae0f5ba1db6$var$MAX_REPLAY_DURATION = 36e5;
var $2fb40ae0f5ba1db6$var$__defProp = Object.defineProperty;
var $2fb40ae0f5ba1db6$var$__defNormalProp = (obj, key, value)=>key in obj ? $2fb40ae0f5ba1db6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2fb40ae0f5ba1db6$var$__publicField = (obj, key, value)=>$2fb40ae0f5ba1db6$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $2fb40ae0f5ba1db6$var$NodeType$1 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($2fb40ae0f5ba1db6$var$NodeType$1 || {});
function $2fb40ae0f5ba1db6$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $2fb40ae0f5ba1db6$var$isShadowRoot(n) {
    const host = n?.host;
    return Boolean(host?.shadowRoot === n);
}
function $2fb40ae0f5ba1db6$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $2fb40ae0f5ba1db6$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $2fb40ae0f5ba1db6$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $2fb40ae0f5ba1db6$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $2fb40ae0f5ba1db6$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $2fb40ae0f5ba1db6$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $2fb40ae0f5ba1db6$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i2 = 0; i2 < rule.style.length; i2++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i2];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $2fb40ae0f5ba1db6$var$stringifyRule(rule) {
    let importStringified;
    if ($2fb40ae0f5ba1db6$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $2fb40ae0f5ba1db6$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $2fb40ae0f5ba1db6$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($2fb40ae0f5ba1db6$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $2fb40ae0f5ba1db6$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $2fb40ae0f5ba1db6$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $2fb40ae0f5ba1db6$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $2fb40ae0f5ba1db6$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $2fb40ae0f5ba1db6$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $2fb40ae0f5ba1db6$var$Mirror {
    constructor(){
        $2fb40ae0f5ba1db6$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $2fb40ae0f5ba1db6$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n) {
        if (!n) return -1;
        const id = this.getMeta(n)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
        if ($2fb40ae0f5ba1db6$var$isElement$1(n) && n.shadowRoot) this.removeNodeFromMap(n.shadowRoot);
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $2fb40ae0f5ba1db6$var$createMirror() {
    return new $2fb40ae0f5ba1db6$var$Mirror();
}
function $2fb40ae0f5ba1db6$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $2fb40ae0f5ba1db6$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $2fb40ae0f5ba1db6$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $2fb40ae0f5ba1db6$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $2fb40ae0f5ba1db6$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $2fb40ae0f5ba1db6$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $2fb40ae0f5ba1db6$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$2fb40ae0f5ba1db6$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $2fb40ae0f5ba1db6$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $2fb40ae0f5ba1db6$var$toLowerCase(type) : null;
}
function $2fb40ae0f5ba1db6$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $2fb40ae0f5ba1db6$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $2fb40ae0f5ba1db6$var$cachedImplementations$1 = {};
function $2fb40ae0f5ba1db6$var$getImplementation$1(name) {
    const cached = $2fb40ae0f5ba1db6$var$cachedImplementations$1[name];
    if (cached) return cached;
    const windowImpl = window[name].bind(window);
    let impl = windowImpl;
    const document2 = window.document;
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) {
            const sandboxImpl = contentWindow[name].bind(window);
            impl = (...args)=>{
                try {
                    return sandboxImpl(...args);
                } catch  {
                    $2fb40ae0f5ba1db6$var$cachedImplementations$1[name] = windowImpl;
                    return windowImpl(...args);
                }
            };
        }
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $2fb40ae0f5ba1db6$var$cachedImplementations$1[name] = impl;
}
function $2fb40ae0f5ba1db6$var$setTimeout$1(...rest) {
    return $2fb40ae0f5ba1db6$var$getImplementation$1("setTimeout")(...rest);
}
function $2fb40ae0f5ba1db6$var$clearTimeout$1(...rest) {
    return $2fb40ae0f5ba1db6$var$getImplementation$1("clearTimeout")(...rest);
}
function $2fb40ae0f5ba1db6$var$getIFrameContentDocument$1(iframe) {
    try {
        return iframe.contentDocument;
    } catch  {}
}
function $2fb40ae0f5ba1db6$var$getIFrameContentWindow$1(iframe) {
    try {
        return iframe.contentWindow;
    } catch  {}
}
let $2fb40ae0f5ba1db6$var$_id = 1;
const $2fb40ae0f5ba1db6$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $2fb40ae0f5ba1db6$var$IGNORED_NODE = -2;
function $2fb40ae0f5ba1db6$var$genId() {
    return $2fb40ae0f5ba1db6$var$_id++;
}
function $2fb40ae0f5ba1db6$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $2fb40ae0f5ba1db6$var$toLowerCase(element.tagName);
    if ($2fb40ae0f5ba1db6$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $2fb40ae0f5ba1db6$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $2fb40ae0f5ba1db6$var$canvasService;
let $2fb40ae0f5ba1db6$var$canvasCtx;
const $2fb40ae0f5ba1db6$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $2fb40ae0f5ba1db6$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $2fb40ae0f5ba1db6$var$URL_WWW_MATCH = /^www\..*/i;
const $2fb40ae0f5ba1db6$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $2fb40ae0f5ba1db6$var$filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        const properties = cssText.split(";");
        const filteredProperties = [];
        for (let property of properties){
            property = property.trim();
            if (!property) continue;
            const colonIndex = property.indexOf(":");
            if (colonIndex === -1) {
                filteredProperties.push(property);
                continue;
            }
            const propertyName = property.slice(0, colonIndex).trim();
            if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function $2fb40ae0f5ba1db6$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($2fb40ae0f5ba1db6$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($2fb40ae0f5ba1db6$var$URL_PROTOCOL_MATCH.test(filePath) || $2fb40ae0f5ba1db6$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($2fb40ae0f5ba1db6$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$2fb40ae0f5ba1db6$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $2fb40ae0f5ba1db6$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $2fb40ae0f5ba1db6$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $2fb40ae0f5ba1db6$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($2fb40ae0f5ba1db6$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($2fb40ae0f5ba1db6$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $2fb40ae0f5ba1db6$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $2fb40ae0f5ba1db6$var$getHref(doc, attributeValue);
}
function $2fb40ae0f5ba1db6$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $2fb40ae0f5ba1db6$var$getHref(doc, customHref) {
    let a = $2fb40ae0f5ba1db6$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $2fb40ae0f5ba1db6$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $2fb40ae0f5ba1db6$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $2fb40ae0f5ba1db6$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        let processedStyle = $2fb40ae0f5ba1db6$var$absoluteToStylesheet(value, $2fb40ae0f5ba1db6$var$getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = $2fb40ae0f5ba1db6$var$filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return $2fb40ae0f5ba1db6$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $2fb40ae0f5ba1db6$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $2fb40ae0f5ba1db6$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $2fb40ae0f5ba1db6$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $2fb40ae0f5ba1db6$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if ($2fb40ae0f5ba1db6$var$isShadowRoot(node)) return $2fb40ae0f5ba1db6$var$distanceToMatch(node.host, matchPredicate, limit, distance + 1);
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $2fb40ae0f5ba1db6$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $2fb40ae0f5ba1db6$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($2fb40ae0f5ba1db6$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $2fb40ae0f5ba1db6$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $2fb40ae0f5ba1db6$var$distanceToMatch(el, $2fb40ae0f5ba1db6$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $2fb40ae0f5ba1db6$var$distanceToMatch(el, $2fb40ae0f5ba1db6$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $2fb40ae0f5ba1db6$var$distanceToMatch(el, $2fb40ae0f5ba1db6$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $2fb40ae0f5ba1db6$var$distanceToMatch(el, $2fb40ae0f5ba1db6$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $2fb40ae0f5ba1db6$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = $2fb40ae0f5ba1db6$var$getIFrameContentWindow$1(iframeEl);
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $2fb40ae0f5ba1db6$var$setTimeout$1(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $2fb40ae0f5ba1db6$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $2fb40ae0f5ba1db6$var$setTimeout$1(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $2fb40ae0f5ba1db6$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        styleSheetLoaded = null;
    }
    if (styleSheetLoaded) return;
    const timer = $2fb40ae0f5ba1db6$var$setTimeout$1(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $2fb40ae0f5ba1db6$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $2fb40ae0f5ba1db6$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const rootId = $2fb40ae0f5ba1db6$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $2fb40ae0f5ba1db6$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $2fb40ae0f5ba1db6$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $2fb40ae0f5ba1db6$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $2fb40ae0f5ba1db6$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n.TEXT_NODE:
            return $2fb40ae0f5ba1db6$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $2fb40ae0f5ba1db6$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $2fb40ae0f5ba1db6$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $2fb40ae0f5ba1db6$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    const docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $2fb40ae0f5ba1db6$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if (n.parentNode.sheet?.cssRules) textContent = $2fb40ae0f5ba1db6$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $2fb40ae0f5ba1db6$var$absoluteToStylesheet(textContent, $2fb40ae0f5ba1db6$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $2fb40ae0f5ba1db6$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $2fb40ae0f5ba1db6$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $2fb40ae0f5ba1db6$var$maskInputValue({
            isMasked: $2fb40ae0f5ba1db6$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $2fb40ae0f5ba1db6$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $2fb40ae0f5ba1db6$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const needBlock = $2fb40ae0f5ba1db6$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $2fb40ae0f5ba1db6$var$getValidTagName(n);
    let attributes2 = {};
    const len = n.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n.attributes[i2];
        if (attr.name && !$2fb40ae0f5ba1db6$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $2fb40ae0f5ba1db6$var$transformAttribute(doc, tagName, $2fb40ae0f5ba1db6$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $2fb40ae0f5ba1db6$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $2fb40ae0f5ba1db6$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $2fb40ae0f5ba1db6$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes2._cssText = $2fb40ae0f5ba1db6$var$absoluteToStylesheet(cssText, $2fb40ae0f5ba1db6$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $2fb40ae0f5ba1db6$var$getInputType(el);
        const value = $2fb40ae0f5ba1db6$var$getInputValue(el, $2fb40ae0f5ba1db6$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $2fb40ae0f5ba1db6$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $2fb40ae0f5ba1db6$var$shouldMaskInput({
                type: type,
                tagName: $2fb40ae0f5ba1db6$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $2fb40ae0f5ba1db6$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$2fb40ae0f5ba1db6$var$is2DCanvasBlank(n)) attributes2.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$2fb40ae0f5ba1db6$var$canvasService) {
            $2fb40ae0f5ba1db6$var$canvasService = doc.createElement("canvas");
            $2fb40ae0f5ba1db6$var$canvasCtx = $2fb40ae0f5ba1db6$var$canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $2fb40ae0f5ba1db6$var$canvasService.width = image.naturalWidth;
                $2fb40ae0f5ba1db6$var$canvasService.height = image.naturalHeight;
                $2fb40ae0f5ba1db6$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $2fb40ae0f5ba1db6$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes2.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes2.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$2fb40ae0f5ba1db6$var$getIFrameContentDocument$1(n)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $2fb40ae0f5ba1db6$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $2fb40ae0f5ba1db6$var$isSVGElement(n) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $2fb40ae0f5ba1db6$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $2fb40ae0f5ba1db6$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $2fb40ae0f5ba1db6$var$NodeType$1.Comment) return true;
    else if (sn.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $2fb40ae0f5ba1db6$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "application-name" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.rel) === "icon" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "robots" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "googlebot" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "author" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "generator" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "framework" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "publisher" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "progid" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "verification" || $2fb40ae0f5ba1db6$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $2fb40ae0f5ba1db6$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $2fb40ae0f5ba1db6$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($2fb40ae0f5ba1db6$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $2fb40ae0f5ba1db6$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) id = $2fb40ae0f5ba1db6$var$IGNORED_NODE;
    else id = $2fb40ae0f5ba1db6$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode2);
    if (id === $2fb40ae0f5ba1db6$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $2fb40ae0f5ba1db6$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Document || serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        const childNodes = n.childNodes ? Array.from(n.childNodes) : [];
        for (const childN of childNodes){
            const serializedChildNode = $2fb40ae0f5ba1db6$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($2fb40ae0f5ba1db6$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $2fb40ae0f5ba1db6$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $2fb40ae0f5ba1db6$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $2fb40ae0f5ba1db6$var$isShadowRoot(n.parentNode) && $2fb40ae0f5ba1db6$var$isNativeShadowDom(n.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) $2fb40ae0f5ba1db6$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = $2fb40ae0f5ba1db6$var$getIFrameContentDocument$1(n);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $2fb40ae0f5ba1db6$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element && serializedNode2.tagName === "img" && !n.complete && serializedNode2.needBlock) {
        const image = n;
        const updateImageDimensions = ()=>{
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                const rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $2fb40ae0f5ba1db6$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $2fb40ae0f5ba1db6$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $2fb40ae0f5ba1db6$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === $2fb40ae0f5ba1db6$var$NodeType$1.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function $2fb40ae0f5ba1db6$var$snapshot(n, options) {
    const { mirror: mirror = new $2fb40ae0f5ba1db6$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]) } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $2fb40ae0f5ba1db6$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function $2fb40ae0f5ba1db6$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $2fb40ae0f5ba1db6$var$_mirror = {
    map: {},
    getId () {
        console.error($2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $2fb40ae0f5ba1db6$var$_mirror = new Proxy($2fb40ae0f5ba1db6$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($2fb40ae0f5ba1db6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $2fb40ae0f5ba1db6$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $2fb40ae0f5ba1db6$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $2fb40ae0f5ba1db6$var$setTimeout$2(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $2fb40ae0f5ba1db6$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $2fb40ae0f5ba1db6$var$setTimeout$2(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$2fb40ae0f5ba1db6$var$hookSetter(target, key, original || {}, true);
}
function $2fb40ae0f5ba1db6$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $2fb40ae0f5ba1db6$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $2fb40ae0f5ba1db6$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $2fb40ae0f5ba1db6$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $2fb40ae0f5ba1db6$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $2fb40ae0f5ba1db6$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $2fb40ae0f5ba1db6$var$closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $2fb40ae0f5ba1db6$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $2fb40ae0f5ba1db6$var$closestElementOfNode$1(node);
    if (!el) return false;
    const blockedPredicate = $2fb40ae0f5ba1db6$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $2fb40ae0f5ba1db6$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $2fb40ae0f5ba1db6$var$distanceToMatch(el, $2fb40ae0f5ba1db6$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $2fb40ae0f5ba1db6$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $2fb40ae0f5ba1db6$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $2fb40ae0f5ba1db6$var$IGNORED_NODE;
}
function $2fb40ae0f5ba1db6$var$isAncestorRemoved(target, mirror) {
    if ($2fb40ae0f5ba1db6$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $2fb40ae0f5ba1db6$var$isAncestorRemoved(target.parentNode, mirror);
}
function $2fb40ae0f5ba1db6$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $2fb40ae0f5ba1db6$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $2fb40ae0f5ba1db6$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $2fb40ae0f5ba1db6$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $2fb40ae0f5ba1db6$var$hasShadowRoot(n) {
    return Boolean(n?.shadowRoot);
}
class $2fb40ae0f5ba1db6$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $2fb40ae0f5ba1db6$var$getShadowHost(n) {
    let shadowHost = null;
    if (n.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $2fb40ae0f5ba1db6$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $2fb40ae0f5ba1db6$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $2fb40ae0f5ba1db6$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $2fb40ae0f5ba1db6$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $2fb40ae0f5ba1db6$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $2fb40ae0f5ba1db6$var$shadowHostInDom(n);
}
const $2fb40ae0f5ba1db6$var$cachedImplementations = {};
function $2fb40ae0f5ba1db6$var$getImplementation(name) {
    const cached = $2fb40ae0f5ba1db6$var$cachedImplementations[name];
    if (cached) return cached;
    const windowImpl = window[name].bind(window);
    let impl = windowImpl;
    const document2 = window.document;
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) {
            const sandboxImpl = contentWindow[name].bind(window);
            impl = (...args)=>{
                try {
                    return sandboxImpl(...args);
                } catch  {
                    $2fb40ae0f5ba1db6$var$cachedImplementations[name] = windowImpl;
                    return windowImpl(...args);
                }
            };
        }
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $2fb40ae0f5ba1db6$var$cachedImplementations[name] = impl;
}
function $2fb40ae0f5ba1db6$var$onRequestAnimationFrame(...rest) {
    return $2fb40ae0f5ba1db6$var$getImplementation("requestAnimationFrame")(...rest);
}
function $2fb40ae0f5ba1db6$var$setTimeout$2(...rest) {
    return $2fb40ae0f5ba1db6$var$getImplementation("setTimeout")(...rest);
}
function $2fb40ae0f5ba1db6$var$clearTimeout$2(...rest) {
    return $2fb40ae0f5ba1db6$var$getImplementation("clearTimeout")(...rest);
}
var $2fb40ae0f5ba1db6$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($2fb40ae0f5ba1db6$var$EventType || {});
var $2fb40ae0f5ba1db6$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($2fb40ae0f5ba1db6$var$IncrementalSource || {});
var $2fb40ae0f5ba1db6$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($2fb40ae0f5ba1db6$var$MouseInteractions || {});
var $2fb40ae0f5ba1db6$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($2fb40ae0f5ba1db6$var$PointerTypes || {});
var $2fb40ae0f5ba1db6$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($2fb40ae0f5ba1db6$var$MediaInteractions || {});
let $2fb40ae0f5ba1db6$var$errorHandler;
function $2fb40ae0f5ba1db6$var$registerErrorHandler(handler) {
    $2fb40ae0f5ba1db6$var$errorHandler = handler;
}
function $2fb40ae0f5ba1db6$var$unregisterErrorHandler() {
    $2fb40ae0f5ba1db6$var$errorHandler = void 0;
}
const $2fb40ae0f5ba1db6$var$callbackWrapper = (cb)=>{
    if (!$2fb40ae0f5ba1db6$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($2fb40ae0f5ba1db6$var$errorHandler && $2fb40ae0f5ba1db6$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $2fb40ae0f5ba1db6$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $2fb40ae0f5ba1db6$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $2fb40ae0f5ba1db6$var$i = 0; $2fb40ae0f5ba1db6$var$i < $2fb40ae0f5ba1db6$var$chars.length; $2fb40ae0f5ba1db6$var$i++)$2fb40ae0f5ba1db6$var$lookup[$2fb40ae0f5ba1db6$var$chars.charCodeAt($2fb40ae0f5ba1db6$var$i)] = $2fb40ae0f5ba1db6$var$i;
class $2fb40ae0f5ba1db6$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
function $2fb40ae0f5ba1db6$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $2fb40ae0f5ba1db6$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
class $2fb40ae0f5ba1db6$var$StyleDeclarationParser {
    constructor(doc){
        this.doc = doc;
        this.unattachedDoc = null;
    }
    parse(styleText) {
        return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
    }
    parseWithConstructableStylesheet(styleText) {
        if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") return null;
        try {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(`x { ${styleText} }`);
            const rule = sheet.cssRules[0];
            if (!rule || rule.type !== CSSRule.STYLE_RULE) return null;
            return rule.style;
        } catch  {
            return null;
        }
    }
    parseWithDetachedElement(styleText) {
        const old = this.getUnattachedDoc().createElement("span");
        old.setAttribute("style", styleText);
        return old.style;
    }
    getUnattachedDoc() {
        if (!this.unattachedDoc) try {
            this.unattachedDoc = document.implementation.createHTMLDocument();
        } catch  {
            this.unattachedDoc = this.doc;
        }
        return this.unattachedDoc;
    }
}
function $2fb40ae0f5ba1db6$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $2fb40ae0f5ba1db6$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $2fb40ae0f5ba1db6$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $2fb40ae0f5ba1db6$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $2fb40ae0f5ba1db6$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $2fb40ae0f5ba1db6$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $2fb40ae0f5ba1db6$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $2fb40ae0f5ba1db6$var$IGNORED_NODE;
                while(nextId === $2fb40ae0f5ba1db6$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$2fb40ae0f5ba1db6$var$inDom(n2)) return;
                const parentId = $2fb40ae0f5ba1db6$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($2fb40ae0f5ba1db6$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $2fb40ae0f5ba1db6$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($2fb40ae0f5ba1db6$var$isSerializedIframe(currentN, this.mirror) && !$2fb40ae0f5ba1db6$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($2fb40ae0f5ba1db6$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($2fb40ae0f5ba1db6$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($2fb40ae0f5ba1db6$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        const contentWindow = $2fb40ae0f5ba1db6$var$getIFrameContentWindow(iframe);
                        if (contentWindow) this.canvasManager.addWindow(contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                        this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: `${width}px`,
                                            height: `${height}px`
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($2fb40ae0f5ba1db6$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$2fb40ae0f5ba1db6$var$isAncestorInSet(this.droppedSet, n2) && !$2fb40ae0f5ba1db6$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($2fb40ae0f5ba1db6$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($2fb40ae0f5ba1db6$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$2fb40ae0f5ba1db6$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $2fb40ae0f5ba1db6$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $2fb40ae0f5ba1db6$var$closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $2fb40ae0f5ba1db6$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $2fb40ae0f5ba1db6$var$getInputValue(target, tagName, type);
                            const isInputMasked = $2fb40ae0f5ba1db6$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $2fb40ae0f5ba1db6$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $2fb40ae0f5ba1db6$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($2fb40ae0f5ba1db6$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $2fb40ae0f5ba1db6$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$2fb40ae0f5ba1db6$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $2fb40ae0f5ba1db6$var$transformAttribute(this.doc, $2fb40ae0f5ba1db6$var$toLowerCase(target.tagName), $2fb40ae0f5ba1db6$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const oldStyle = m.oldValue ? this.styleDeclarationParser.parse(m.oldValue) : null;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== (oldStyle?.getPropertyValue(pname) || "") || newPriority !== (oldStyle?.getPropertyPriority(pname) || "")) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                if (oldStyle) {
                                    for (const pname of Array.from(oldStyle))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($2fb40ae0f5ba1db6$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $2fb40ae0f5ba1db6$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($2fb40ae0f5ba1db6$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $2fb40ae0f5ba1db6$var$isIgnored(n2, this.mirror) || !$2fb40ae0f5ba1db6$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $2fb40ae0f5ba1db6$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($2fb40ae0f5ba1db6$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$2fb40ae0f5ba1db6$var$moveKey(nodeId, parentId)]) $2fb40ae0f5ba1db6$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $2fb40ae0f5ba1db6$var$isShadowRoot(m.target) && $2fb40ae0f5ba1db6$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($2fb40ae0f5ba1db6$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$2fb40ae0f5ba1db6$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$2fb40ae0f5ba1db6$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($2fb40ae0f5ba1db6$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager",
            "ignoreCSSAttributes"
        ].forEach((key)=>{
            this[key] = options[key];
        });
        this.styleDeclarationParser = new $2fb40ae0f5ba1db6$var$StyleDeclarationParser(this.doc);
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $2fb40ae0f5ba1db6$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes?.forEach((childN)=>$2fb40ae0f5ba1db6$var$deepDelete(addsSet, childN));
}
function $2fb40ae0f5ba1db6$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $2fb40ae0f5ba1db6$var$_isParentRemoved(removes, n2, mirror2);
}
function $2fb40ae0f5ba1db6$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $2fb40ae0f5ba1db6$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $2fb40ae0f5ba1db6$var$_isAncestorInSet(set, n2);
}
function $2fb40ae0f5ba1db6$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $2fb40ae0f5ba1db6$var$_isAncestorInSet(set, parentNode);
}
const $2fb40ae0f5ba1db6$var$mutationBuffers = [];
function $2fb40ae0f5ba1db6$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $2fb40ae0f5ba1db6$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $2fb40ae0f5ba1db6$var$MutationBuffer();
    $2fb40ae0f5ba1db6$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($2fb40ae0f5ba1db6$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $2fb40ae0f5ba1db6$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $2fb40ae0f5ba1db6$var$throttle$1($2fb40ae0f5ba1db6$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $2fb40ae0f5ba1db6$var$callbackWrapper($2fb40ae0f5ba1db6$var$throttle$1($2fb40ae0f5ba1db6$var$callbackWrapper((evt)=>{
        const target = $2fb40ae0f5ba1db6$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $2fb40ae0f5ba1db6$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $2fb40ae0f5ba1db6$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $2fb40ae0f5ba1db6$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $2fb40ae0f5ba1db6$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $2fb40ae0f5ba1db6$var$IncrementalSource.MouseMove : $2fb40ae0f5ba1db6$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $2fb40ae0f5ba1db6$var$on("mousemove", updatePosition, doc),
        $2fb40ae0f5ba1db6$var$on("touchmove", updatePosition, doc),
        $2fb40ae0f5ba1db6$var$on("drag", updatePosition, doc)
    ];
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2fb40ae0f5ba1db6$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $2fb40ae0f5ba1db6$var$getEventTarget(event);
            if ($2fb40ae0f5ba1db6$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $2fb40ae0f5ba1db6$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $2fb40ae0f5ba1db6$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $2fb40ae0f5ba1db6$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $2fb40ae0f5ba1db6$var$PointerTypes.Touch) {
                    if ($2fb40ae0f5ba1db6$var$MouseInteractions[eventKey] === $2fb40ae0f5ba1db6$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($2fb40ae0f5ba1db6$var$MouseInteractions[eventKey] === $2fb40ae0f5ba1db6$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $2fb40ae0f5ba1db6$var$PointerTypes.Pen;
            } else if ($2fb40ae0f5ba1db6$var$legacy_isTouchEvent(event)) pointerType = $2fb40ae0f5ba1db6$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $2fb40ae0f5ba1db6$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $2fb40ae0f5ba1db6$var$PointerTypes.Mouse) pointerType = null;
            } else if ($2fb40ae0f5ba1db6$var$MouseInteractions[eventKey] === $2fb40ae0f5ba1db6$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $2fb40ae0f5ba1db6$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $2fb40ae0f5ba1db6$var$callbackWrapper(mouseInteractionCb)({
                type: $2fb40ae0f5ba1db6$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($2fb40ae0f5ba1db6$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $2fb40ae0f5ba1db6$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($2fb40ae0f5ba1db6$var$MouseInteractions[eventKey]){
            case $2fb40ae0f5ba1db6$var$MouseInteractions.MouseDown:
            case $2fb40ae0f5ba1db6$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $2fb40ae0f5ba1db6$var$MouseInteractions.TouchStart:
            case $2fb40ae0f5ba1db6$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($2fb40ae0f5ba1db6$var$on(eventName, handler, doc));
    });
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2fb40ae0f5ba1db6$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $2fb40ae0f5ba1db6$var$callbackWrapper($2fb40ae0f5ba1db6$var$throttle$1($2fb40ae0f5ba1db6$var$callbackWrapper((evt)=>{
        const target = $2fb40ae0f5ba1db6$var$getEventTarget(evt);
        if (!target || $2fb40ae0f5ba1db6$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $2fb40ae0f5ba1db6$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $2fb40ae0f5ba1db6$var$on("scroll", updatePosition, doc);
}
function $2fb40ae0f5ba1db6$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $2fb40ae0f5ba1db6$var$callbackWrapper($2fb40ae0f5ba1db6$var$throttle$1($2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        const height = $2fb40ae0f5ba1db6$var$getWindowHeight();
        const width = $2fb40ae0f5ba1db6$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $2fb40ae0f5ba1db6$var$on("resize", updateDimension, win);
}
const $2fb40ae0f5ba1db6$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $2fb40ae0f5ba1db6$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $2fb40ae0f5ba1db6$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $2fb40ae0f5ba1db6$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $2fb40ae0f5ba1db6$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $2fb40ae0f5ba1db6$var$INPUT_TAGS.indexOf(tagName) < 0 || $2fb40ae0f5ba1db6$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $2fb40ae0f5ba1db6$var$getInputType(target);
        let text = $2fb40ae0f5ba1db6$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $2fb40ae0f5ba1db6$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $2fb40ae0f5ba1db6$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $2fb40ae0f5ba1db6$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $2fb40ae0f5ba1db6$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $2fb40ae0f5ba1db6$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $2fb40ae0f5ba1db6$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $2fb40ae0f5ba1db6$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $2fb40ae0f5ba1db6$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$2fb40ae0f5ba1db6$var$on(eventName, $2fb40ae0f5ba1db6$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$2fb40ae0f5ba1db6$var$hookSetter(p[0], p[1], {
            set () {
                $2fb40ae0f5ba1db6$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2fb40ae0f5ba1db6$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($2fb40ae0f5ba1db6$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $2fb40ae0f5ba1db6$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $2fb40ae0f5ba1db6$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $2fb40ae0f5ba1db6$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $2fb40ae0f5ba1db6$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $2fb40ae0f5ba1db6$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($2fb40ae0f5ba1db6$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($2fb40ae0f5ba1db6$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($2fb40ae0f5ba1db6$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($2fb40ae0f5ba1db6$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$2fb40ae0f5ba1db6$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$2fb40ae0f5ba1db6$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $2fb40ae0f5ba1db6$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $2fb40ae0f5ba1db6$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $2fb40ae0f5ba1db6$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $2fb40ae0f5ba1db6$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $2fb40ae0f5ba1db6$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $2fb40ae0f5ba1db6$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $2fb40ae0f5ba1db6$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $2fb40ae0f5ba1db6$var$callbackWrapper((type)=>$2fb40ae0f5ba1db6$var$throttle$1($2fb40ae0f5ba1db6$var$callbackWrapper((event)=>{
            const target = $2fb40ae0f5ba1db6$var$getEventTarget(event);
            if (!target || $2fb40ae0f5ba1db6$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $2fb40ae0f5ba1db6$var$on("play", handler($2fb40ae0f5ba1db6$var$MediaInteractions.Play), doc),
        $2fb40ae0f5ba1db6$var$on("pause", handler($2fb40ae0f5ba1db6$var$MediaInteractions.Pause), doc),
        $2fb40ae0f5ba1db6$var$on("seeked", handler($2fb40ae0f5ba1db6$var$MediaInteractions.Seeked), doc),
        $2fb40ae0f5ba1db6$var$on("volumechange", handler($2fb40ae0f5ba1db6$var$MediaInteractions.VolumeChange), doc),
        $2fb40ae0f5ba1db6$var$on("ratechange", handler($2fb40ae0f5ba1db6$var$MediaInteractions.RateChange), doc)
    ];
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2fb40ae0f5ba1db6$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $2fb40ae0f5ba1db6$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $2fb40ae0f5ba1db6$var$setTimeout$2($2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2fb40ae0f5ba1db6$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $2fb40ae0f5ba1db6$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $2fb40ae0f5ba1db6$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $2fb40ae0f5ba1db6$var$on("selectionchange", updateSelection);
}
function $2fb40ae0f5ba1db6$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $2fb40ae0f5ba1db6$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $2fb40ae0f5ba1db6$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $2fb40ae0f5ba1db6$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $2fb40ae0f5ba1db6$var$initMoveObserver(o2);
    const mouseInteractionHandler = $2fb40ae0f5ba1db6$var$initMouseInteractionObserver(o2);
    const scrollHandler = $2fb40ae0f5ba1db6$var$initScrollObserver(o2);
    const viewportResizeHandler = $2fb40ae0f5ba1db6$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $2fb40ae0f5ba1db6$var$initInputObserver(o2);
    const mediaInteractionHandler = $2fb40ae0f5ba1db6$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $2fb40ae0f5ba1db6$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $2fb40ae0f5ba1db6$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $2fb40ae0f5ba1db6$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $2fb40ae0f5ba1db6$var$initFontObserver(o2);
    }
    const selectionObserver = $2fb40ae0f5ba1db6$var$initSelectionObserver(o2);
    const customElementObserver = $2fb40ae0f5ba1db6$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $2fb40ae0f5ba1db6$var$callbackWrapper(()=>{
        $2fb40ae0f5ba1db6$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $2fb40ae0f5ba1db6$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $2fb40ae0f5ba1db6$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $2fb40ae0f5ba1db6$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $2fb40ae0f5ba1db6$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $2fb40ae0f5ba1db6$var$CrossOriginIframeMirror($2fb40ae0f5ba1db6$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $2fb40ae0f5ba1db6$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $2fb40ae0f5ba1db6$var$CrossOriginIframeMirror($2fb40ae0f5ba1db6$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $2fb40ae0f5ba1db6$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        const contentWindow = $2fb40ae0f5ba1db6$var$getIFrameContentWindow(iframeEl);
        if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) $2fb40ae0f5ba1db6$var$getIFrameContentWindow(iframeEl)?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $2fb40ae0f5ba1db6$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $2fb40ae0f5ba1db6$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $2fb40ae0f5ba1db6$var$EventType.Meta:
            case $2fb40ae0f5ba1db6$var$EventType.Load:
            case $2fb40ae0f5ba1db6$var$EventType.DomContentLoaded:
                return false;
            case $2fb40ae0f5ba1db6$var$EventType.Plugin:
                return e2;
            case $2fb40ae0f5ba1db6$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.Drag:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.TouchMove:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.ViewportResize:
                        return false;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.MediaInteraction:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.MouseInteraction:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.Scroll:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.CanvasMutation:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.StyleSheetRule:
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.Font:
                        return e2;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $2fb40ae0f5ba1db6$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $2fb40ae0f5ba1db6$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $2fb40ae0f5ba1db6$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $2fb40ae0f5ba1db6$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$2fb40ae0f5ba1db6$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $2fb40ae0f5ba1db6$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($2fb40ae0f5ba1db6$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $2fb40ae0f5ba1db6$var$setTimeout$2(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($2fb40ae0f5ba1db6$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $2fb40ae0f5ba1db6$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $2fb40ae0f5ba1db6$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        let iframeElementConstructor;
        try {
            iframeElementConstructor = iframeWindow.Element;
        } catch (e2) {
            return;
        }
        if (!iframeElementConstructor) return;
        this.patchAttachShadow(iframeElementConstructor, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($2fb40ae0f5ba1db6$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $2fb40ae0f5ba1db6$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $2fb40ae0f5ba1db6$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $2fb40ae0f5ba1db6$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $2fb40ae0f5ba1db6$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $2fb40ae0f5ba1db6$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $2fb40ae0f5ba1db6$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $2fb40ae0f5ba1db6$var$wrappedEmit;
let $2fb40ae0f5ba1db6$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $2fb40ae0f5ba1db6$var$mirror = $2fb40ae0f5ba1db6$var$createMirror();
function $2fb40ae0f5ba1db6$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $2fb40ae0f5ba1db6$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $2fb40ae0f5ba1db6$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $2fb40ae0f5ba1db6$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $2fb40ae0f5ba1db6$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $2fb40ae0f5ba1db6$var$nowTimestamp();
        if ($2fb40ae0f5ba1db6$var$mutationBuffers[0]?.isFrozen() && e2.type !== $2fb40ae0f5ba1db6$var$EventType.FullSnapshot && !(e2.type === $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot && e2.data.source === $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation)) $2fb40ae0f5ba1db6$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $2fb40ae0f5ba1db6$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $2fb40ae0f5ba1db6$var$wrappedEmit({
            type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
            data: {
                source: $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
            type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
            data: {
                source: $2fb40ae0f5ba1db6$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
            type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
            data: {
                source: $2fb40ae0f5ba1db6$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
            type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
            data: {
                source: $2fb40ae0f5ba1db6$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $2fb40ae0f5ba1db6$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $2fb40ae0f5ba1db6$var$IframeManagerNoop() : new $2fb40ae0f5ba1db6$var$IframeManager({
        mirror: $2fb40ae0f5ba1db6$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $2fb40ae0f5ba1db6$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $2fb40ae0f5ba1db6$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $2fb40ae0f5ba1db6$var$ProcessedNodeManager();
    const canvasManager = $2fb40ae0f5ba1db6$var$_getCanvasManager(getCanvasManager, {
        mirror: $2fb40ae0f5ba1db6$var$mirror,
        win: window,
        mutationCb: (p)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                data: {
                    source: $2fb40ae0f5ba1db6$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $2fb40ae0f5ba1db6$var$ShadowDomManagerNoop() : new $2fb40ae0f5ba1db6$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: $2fb40ae0f5ba1db6$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $2fb40ae0f5ba1db6$var$wrappedEmit({
            type: $2fb40ae0f5ba1db6$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $2fb40ae0f5ba1db6$var$getWindowWidth(),
                height: $2fb40ae0f5ba1db6$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $2fb40ae0f5ba1db6$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $2fb40ae0f5ba1db6$var$snapshot(document, {
            mirror: $2fb40ae0f5ba1db6$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($2fb40ae0f5ba1db6$var$isSerializedIframe(n2, $2fb40ae0f5ba1db6$var$mirror)) iframeManager.addIframe(n2);
                if ($2fb40ae0f5ba1db6$var$isSerializedStylesheet(n2, $2fb40ae0f5ba1db6$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($2fb40ae0f5ba1db6$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                const contentWindow = $2fb40ae0f5ba1db6$var$getIFrameContentWindow(iframe);
                if (contentWindow) canvasManager.addWindow(contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: `${width}px`,
                                    height: `${height}px`
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $2fb40ae0f5ba1db6$var$wrappedEmit({
            type: $2fb40ae0f5ba1db6$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $2fb40ae0f5ba1db6$var$getWindowScroll(window)
            }
        });
        $2fb40ae0f5ba1db6$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $2fb40ae0f5ba1db6$var$mirror.getId(document));
    };
    $2fb40ae0f5ba1db6$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $2fb40ae0f5ba1db6$var$callbackWrapper($2fb40ae0f5ba1db6$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $2fb40ae0f5ba1db6$var$wrappedEmit({
                        type: $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2fb40ae0f5ba1db6$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $2fb40ae0f5ba1db6$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$2fb40ae0f5ba1db6$var$wrappedEmit({
                                type: $2fb40ae0f5ba1db6$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($2fb40ae0f5ba1db6$var$on("DOMContentLoaded", ()=>{
                $2fb40ae0f5ba1db6$var$wrappedEmit({
                    type: $2fb40ae0f5ba1db6$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($2fb40ae0f5ba1db6$var$on("load", ()=>{
                $2fb40ae0f5ba1db6$var$wrappedEmit({
                    type: $2fb40ae0f5ba1db6$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $2fb40ae0f5ba1db6$var$_takeFullSnapshot = void 0;
            $2fb40ae0f5ba1db6$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $2fb40ae0f5ba1db6$var$takeFullSnapshot(isCheckout) {
    if (!$2fb40ae0f5ba1db6$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $2fb40ae0f5ba1db6$var$_takeFullSnapshot(isCheckout);
}
$2fb40ae0f5ba1db6$var$record.mirror = $2fb40ae0f5ba1db6$var$mirror;
$2fb40ae0f5ba1db6$var$record.takeFullSnapshot = $2fb40ae0f5ba1db6$var$takeFullSnapshot;
function $2fb40ae0f5ba1db6$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $2fb40ae0f5ba1db6$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $2fb40ae0f5ba1db6$var$CanvasManagerNoop();
    }
}
var $2fb40ae0f5ba1db6$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($2fb40ae0f5ba1db6$var$n || ($2fb40ae0f5ba1db6$var$n = {}));
const $2fb40ae0f5ba1db6$var$ReplayEventTypeIncrementalSnapshot = 3;
const $2fb40ae0f5ba1db6$var$ReplayEventTypeCustom = 5;
function $2fb40ae0f5ba1db6$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1e3;
}
function $2fb40ae0f5ba1db6$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $2fb40ae0f5ba1db6$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $2fb40ae0f5ba1db6$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1e3,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $fuLLi.normalize)(breadcrumb, 10, 1e3)
            }
        });
        return breadcrumb.category === "console";
    });
}
const $2fb40ae0f5ba1db6$var$INTERACTIVE_SELECTOR = "button,a";
function $2fb40ae0f5ba1db6$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($2fb40ae0f5ba1db6$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
function $2fb40ae0f5ba1db6$var$getClickTargetNode(event) {
    const target = $2fb40ae0f5ba1db6$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $2fb40ae0f5ba1db6$var$getClosestInteractive(target);
}
function $2fb40ae0f5ba1db6$var$getTargetNode(event) {
    if ($2fb40ae0f5ba1db6$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $2fb40ae0f5ba1db6$var$isEventWithTarget(event) {
    return (0, $exje8.isObjectLike)(event) && "target" in event;
}
let $2fb40ae0f5ba1db6$var$handlers;
function $2fb40ae0f5ba1db6$var$onWindowOpen(cb) {
    if (!$2fb40ae0f5ba1db6$var$handlers) {
        $2fb40ae0f5ba1db6$var$handlers = [];
        $2fb40ae0f5ba1db6$var$monkeyPatchWindowOpen();
    }
    $2fb40ae0f5ba1db6$var$handlers.push(cb);
    return ()=>{
        const pos = $2fb40ae0f5ba1db6$var$handlers ? $2fb40ae0f5ba1db6$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $2fb40ae0f5ba1db6$var$handlers.splice(pos, 1);
    };
}
function $2fb40ae0f5ba1db6$var$monkeyPatchWindowOpen() {
    (0, $6i9K0.fill)($2fb40ae0f5ba1db6$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($2fb40ae0f5ba1db6$var$handlers) try {
                $2fb40ae0f5ba1db6$var$handlers.forEach((handler)=>handler());
            } catch  {}
            return originalWindowOpen.apply($2fb40ae0f5ba1db6$var$WINDOW, args);
        };
    });
}
const $2fb40ae0f5ba1db6$var$IncrementalMutationSources = /* @__PURE__ */ new Set([
    $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation,
    $2fb40ae0f5ba1db6$var$IncrementalSource.StyleSheetRule,
    $2fb40ae0f5ba1db6$var$IncrementalSource.StyleDeclaration,
    $2fb40ae0f5ba1db6$var$IncrementalSource.AdoptedStyleSheet,
    $2fb40ae0f5ba1db6$var$IncrementalSource.CanvasMutation,
    $2fb40ae0f5ba1db6$var$IncrementalSource.Selection,
    $2fb40ae0f5ba1db6$var$IncrementalSource.MediaInteraction
]);
function $2fb40ae0f5ba1db6$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
class $2fb40ae0f5ba1db6$var$ClickDetector {
    constructor(replay, slowClickConfig, _addBreadcrumbEvent = $2fb40ae0f5ba1db6$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        this._timeout = slowClickConfig.timeout / 1e3;
        this._threshold = slowClickConfig.threshold / 1e3;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $2fb40ae0f5ba1db6$var$onWindowOpen(()=>{
            this._lastMutation = $2fb40ae0f5ba1db6$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($2fb40ae0f5ba1db6$var$ignoreElement(node, this._ignoreSelector) || !$2fb40ae0f5ba1db6$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $2fb40ae0f5ba1db6$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $2fb40ae0f5ba1db6$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $2fb40ae0f5ba1db6$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $2fb40ae0f5ba1db6$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $2fb40ae0f5ba1db6$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : void 0;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : void 0;
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        if (isSlowClick) {
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
            const endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $2fb40ae0f5ba1db6$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $2fb40ae0f5ba1db6$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $e2656f69bec1b12b$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1e3);
    }
}
const $2fb40ae0f5ba1db6$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
function $2fb40ae0f5ba1db6$var$ignoreElement(node, ignoreSelector) {
    if (!$2fb40ae0f5ba1db6$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $2fb40ae0f5ba1db6$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
function $2fb40ae0f5ba1db6$var$nowInSeconds() {
    return Date.now() / 1e3;
}
function $2fb40ae0f5ba1db6$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        if (!$2fb40ae0f5ba1db6$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($2fb40ae0f5ba1db6$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $2fb40ae0f5ba1db6$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($2fb40ae0f5ba1db6$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $2fb40ae0f5ba1db6$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $2fb40ae0f5ba1db6$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {}
}
function $2fb40ae0f5ba1db6$var$isIncrementalEvent(event) {
    return event.type === $2fb40ae0f5ba1db6$var$ReplayEventTypeIncrementalSnapshot;
}
function $2fb40ae0f5ba1db6$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $2fb40ae0f5ba1db6$var$IncrementalSource.MouseInteraction;
}
function $2fb40ae0f5ba1db6$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1e3,
        type: "default",
        ...breadcrumb
    };
}
var $2fb40ae0f5ba1db6$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($2fb40ae0f5ba1db6$var$NodeType || {});
const $2fb40ae0f5ba1db6$var$ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
const $2fb40ae0f5ba1db6$var$BREADCRUMB_RELEVANT_ATTRIBUTES = /* @__PURE__ */ new Set([
    ...$2fb40ae0f5ba1db6$var$ATTRIBUTES_TO_RECORD,
    "data-sentry-element"
]);
function $2fb40ae0f5ba1db6$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($2fb40ae0f5ba1db6$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    if (!obj["data-sentry-component"] && attributes["data-sentry-element"]) obj["data-sentry-component"] = attributes["data-sentry-element"];
    return obj;
}
const $2fb40ae0f5ba1db6$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2fb40ae0f5ba1db6$var$handleDom(handlerData, replay.getMaskAttributeFn());
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : void 0;
        if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $2fb40ae0f5ba1db6$var$handleClick(replay.clickDetector, result, $2fb40ae0f5ba1db6$var$getClickTargetNode(handlerData.event));
        $2fb40ae0f5ba1db6$var$addBreadcrumbEvent(replay, result);
    };
};
function $2fb40ae0f5ba1db6$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $2fb40ae0f5ba1db6$var$record.mirror.getId(target);
    const node = nodeId && $2fb40ae0f5ba1db6$var$record.mirror.getNode(nodeId);
    const meta = node && $2fb40ae0f5ba1db6$var$record.mirror.getMeta(node);
    const element = meta && $2fb40ae0f5ba1db6$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node2)=>node2.type === $2fb40ae0f5ba1db6$var$NodeType.Text && node2.textContent).filter(Boolean).map((text)=>text.trim()).join(""),
                attributes: $2fb40ae0f5ba1db6$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
function $2fb40ae0f5ba1db6$var$handleDom(handlerData, maskAttributeFn) {
    const { target: target, message: message } = $2fb40ae0f5ba1db6$var$getDomTarget(handlerData, maskAttributeFn);
    return $2fb40ae0f5ba1db6$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$2fb40ae0f5ba1db6$var$getBaseDomBreadcrumb(target, message)
    });
}
function $2fb40ae0f5ba1db6$var$getDomTarget(handlerData, maskAttributeFn) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    try {
        target = isClick ? $2fb40ae0f5ba1db6$var$getClickTargetNode(handlerData.event) : $2fb40ae0f5ba1db6$var$getTargetNode(handlerData.event);
        message = (0, $dcf13f5a97021253$export$5647df6b7814ac86)(target, {
            maxStringLength: 200,
            maskAttributeFn: maskAttributeFn
        }) || "<unknown>";
    } catch  {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $2fb40ae0f5ba1db6$var$isElement(node) {
    return node.type === $2fb40ae0f5ba1db6$var$NodeType.Element;
}
function $2fb40ae0f5ba1db6$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.updateUserActivity();
    const breadcrumb = $2fb40ae0f5ba1db6$var$getKeyboardBreadcrumb(event, replay.getMaskAttributeFn());
    if (!breadcrumb) return;
    $2fb40ae0f5ba1db6$var$addBreadcrumbEvent(replay, breadcrumb);
}
function $2fb40ae0f5ba1db6$var$getKeyboardBreadcrumb(event, maskAttributeFn) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    if (!target || $2fb40ae0f5ba1db6$var$isInputElement(target) || !key) return null;
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1;
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $dcf13f5a97021253$export$5647df6b7814ac86)(target, {
        maxStringLength: 200,
        maskAttributeFn: maskAttributeFn
    }) || "<unknown>";
    const baseBreadcrumb = $2fb40ae0f5ba1db6$var$getBaseDomBreadcrumb(target, message);
    return $2fb40ae0f5ba1db6$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $2fb40ae0f5ba1db6$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const $2fb40ae0f5ba1db6$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $2fb40ae0f5ba1db6$var$createResourceEntry,
    paint: $2fb40ae0f5ba1db6$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $2fb40ae0f5ba1db6$var$createNavigationEntry
};
function $2fb40ae0f5ba1db6$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
function $2fb40ae0f5ba1db6$var$createPerformanceEntries(entries) {
    return entries.map($2fb40ae0f5ba1db6$var$createPerformanceEntry).filter(Boolean);
}
function $2fb40ae0f5ba1db6$var$createPerformanceEntry(entry) {
    const entryType = $2fb40ae0f5ba1db6$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $2fb40ae0f5ba1db6$var$getAbsoluteTime(time) {
    return (((0, $c5ls6.browserPerformanceTimeOrigin)() || $2fb40ae0f5ba1db6$var$WINDOW.performance.timeOrigin) + time) / 1e3;
}
function $2fb40ae0f5ba1db6$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $2fb40ae0f5ba1db6$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: void 0
    };
}
function $2fb40ae0f5ba1db6$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $2fb40ae0f5ba1db6$var$getAbsoluteTime(startTime),
        end: $2fb40ae0f5ba1db6$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $2fb40ae0f5ba1db6$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $2fb40ae0f5ba1db6$var$getAbsoluteTime(startTime),
        end: $2fb40ae0f5ba1db6$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $2fb40ae0f5ba1db6$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : void 0;
    return $2fb40ae0f5ba1db6$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $2fb40ae0f5ba1db6$var$isLayoutShift(entry) {
    return entry.sources !== void 0;
}
function $2fb40ae0f5ba1db6$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($2fb40ae0f5ba1db6$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $2fb40ae0f5ba1db6$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : void 0
        });
    }
    return $2fb40ae0f5ba1db6$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
function $2fb40ae0f5ba1db6$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : void 0;
    return $2fb40ae0f5ba1db6$var$getWebVital(metric, "interaction-to-next-paint", node);
}
function $2fb40ae0f5ba1db6$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $2fb40ae0f5ba1db6$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$2fb40ae0f5ba1db6$var$record.mirror.getId(node)) : void 0,
            attributions: attributions
        }
    };
}
function $2fb40ae0f5ba1db6$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $88bb8f0178a99731$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $88bb8f0178a99731$export$3fd4b53331200102)($2fb40ae0f5ba1db6$var$webVitalHandler($2fb40ae0f5ba1db6$var$getLargestContentfulPaint, replay)), (0, $88bb8f0178a99731$export$861b82818b37ba5b)($2fb40ae0f5ba1db6$var$webVitalHandler($2fb40ae0f5ba1db6$var$getCumulativeLayoutShift, replay)), (0, $88bb8f0178a99731$export$da3b76aa2022cbd7)($2fb40ae0f5ba1db6$var$webVitalHandler($2fb40ae0f5ba1db6$var$getInteractionToNextPaint, replay)));
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
const $2fb40ae0f5ba1db6$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $2fb40ae0f5ba1db6$var$t = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $2fb40ae0f5ba1db6$var$e() {
    const e2 = new Blob([
        $2fb40ae0f5ba1db6$var$t
    ], {
        type: "text/javascript"
    });
    return URL.createObjectURL(e2);
}
const $2fb40ae0f5ba1db6$var$CONSOLE_LEVELS = [
    "log",
    "warn",
    "error"
];
const $2fb40ae0f5ba1db6$var$PREFIX = "[Replay] ";
function $2fb40ae0f5ba1db6$var$_addBreadcrumb(message, level = "info") {
    (0, $afdaf3f0674c1f15$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$2fb40ae0f5ba1db6$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $2fb40ae0f5ba1db6$var$makeReplayDebugLogger() {
    let _capture = false;
    let _trace = false;
    const _debug = {
        exception: ()=>void 0,
        infoTick: ()=>void 0,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($2fb40ae0f5ba1db6$var$DEBUG_BUILD) {
        $2fb40ae0f5ba1db6$var$CONSOLE_LEVELS.forEach((name)=>{
            _debug[name] = (...args)=>{
                (0, $cG2xs.debug)[name]($2fb40ae0f5ba1db6$var$PREFIX, ...args);
                if (_trace) $2fb40ae0f5ba1db6$var$_addBreadcrumb(args.join(""), (0, $eabfd7106e0d0c43$export$d771ef054122c30a)(name));
            };
        });
        _debug.exception = (error, ...message)=>{
            if (message.length && _debug.error) _debug.error(...message);
            (0, $cG2xs.debug).error($2fb40ae0f5ba1db6$var$PREFIX, error);
            if (_capture) (0, $iFEvA.captureException)(error, {
                mechanism: {
                    handled: true,
                    type: "auto.function.replay.debug"
                }
            });
            else if (_trace) $2fb40ae0f5ba1db6$var$_addBreadcrumb(error, "error");
        };
        _debug.infoTick = (...args)=>{
            (0, $cG2xs.debug).log($2fb40ae0f5ba1db6$var$PREFIX, ...args);
            if (_trace) setTimeout(()=>$2fb40ae0f5ba1db6$var$_addBreadcrumb(args[0]), 0);
        };
    } else $2fb40ae0f5ba1db6$var$CONSOLE_LEVELS.forEach((name)=>{
        _debug[name] = ()=>void 0;
    });
    return _debug;
}
const $2fb40ae0f5ba1db6$var$debug = $2fb40ae0f5ba1db6$var$makeReplayDebugLogger();
class $2fb40ae0f5ba1db6$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$2fb40ae0f5ba1db6$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
class $2fb40ae0f5ba1db6$var$WorkerDestroyedError extends Error {
    constructor(){
        super("Worker destroyed");
    }
}
class $2fb40ae0f5ba1db6$var$EventBufferArray {
    constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $2fb40ae0f5ba1db6$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $2fb40ae0f5ba1db6$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        let ts = null;
        for (const { timestamp: timestamp } of this.events)if (ts === null || timestamp < ts) ts = timestamp;
        return ts === null ? ts : $2fb40ae0f5ba1db6$var$timestampToMs(ts);
    }
}
class $2fb40ae0f5ba1db6$var$WorkerHandler {
    constructor(worker){
        this._onMessage = ({ data: data })=>{
            const response = data;
            if (typeof response.id !== "number") return;
            const pending = this._pending.get(response.id);
            if (!pending || pending.method !== response.method) return;
            this._pending.delete(response.id);
            if (!response.success) {
                $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.error("Error in compression worker: ", response.response);
                pending.reject(new Error("Error in compression worker"));
                return;
            }
            pending.resolve(response.response);
        };
        this._worker = worker;
        this._id = 0;
        this._pending = /* @__PURE__ */ new Map();
        this._worker.addEventListener("message", this._onMessage);
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else {
                    $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.warn("Received worker message with unsuccessful status", data);
                    reject(new Error("Received worker message with unsuccessful status"));
                }
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.warn("Failed to load Replay compression worker", error);
                reject(new Error(`Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`));
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Destroying compression worker");
        this._worker.removeEventListener("message", this._onMessage);
        this._pending.forEach((pending)=>pending.reject(new $2fb40ae0f5ba1db6$var$WorkerDestroyedError()));
        this._pending.clear();
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            this._pending.set(id, {
                method: method,
                resolve: resolve,
                reject: reject
            });
            try {
                this._worker.postMessage({
                    id: id,
                    method: method,
                    arg: arg
                });
            } catch (error) {
                this._pending.delete(id);
                reject(error);
            }
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
class $2fb40ae0f5ba1db6$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $2fb40ae0f5ba1db6$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $2fb40ae0f5ba1db6$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $2fb40ae0f5ba1db6$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $2fb40ae0f5ba1db6$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this._worker.postMessage("clear").then(null, (e)=>{
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
class $2fb40ae0f5ba1db6$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $2fb40ae0f5ba1db6$var$EventBufferArray();
        this._compression = new $2fb40ae0f5ba1db6$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        this._used = this._compression;
        try {
            await Promise.all(addEventPromises);
            this._fallback.clear();
        } catch (error) {
            if (error instanceof $2fb40ae0f5ba1db6$var$WorkerDestroyedError) return;
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
function $2fb40ae0f5ba1db6$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $2fb40ae0f5ba1db6$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Using simple buffer");
    return new $2fb40ae0f5ba1db6$var$EventBufferArray();
}
function $2fb40ae0f5ba1db6$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $2fb40ae0f5ba1db6$var$_getWorkerUrl();
        if (!workerUrl) return;
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $2fb40ae0f5ba1db6$var$EventBufferProxy(worker);
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to create compression worker");
    }
}
function $2fb40ae0f5ba1db6$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $2fb40ae0f5ba1db6$var$e();
    return "";
}
function $2fb40ae0f5ba1db6$var$hasSessionStorage() {
    try {
        return "sessionStorage" in $2fb40ae0f5ba1db6$var$WINDOW && !!$2fb40ae0f5ba1db6$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
function $2fb40ae0f5ba1db6$var$clearSession(replay) {
    $2fb40ae0f5ba1db6$var$deleteSession();
    replay.session = void 0;
}
function $2fb40ae0f5ba1db6$var$deleteSession() {
    if (!$2fb40ae0f5ba1db6$var$hasSessionStorage()) return;
    try {
        $2fb40ae0f5ba1db6$var$WINDOW.sessionStorage.removeItem($2fb40ae0f5ba1db6$var$REPLAY_SESSION_KEY);
    } catch  {}
}
function $2fb40ae0f5ba1db6$var$isSampled(sampleRate) {
    if (sampleRate === void 0) return false;
    return Math.random() < sampleRate;
}
function $2fb40ae0f5ba1db6$var$saveSession(session) {
    if (!$2fb40ae0f5ba1db6$var$hasSessionStorage()) return;
    try {
        $2fb40ae0f5ba1db6$var$WINDOW.sessionStorage.setItem($2fb40ae0f5ba1db6$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {}
}
function $2fb40ae0f5ba1db6$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $1nf4J.uuid4)();
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    const dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
function $2fb40ae0f5ba1db6$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $2fb40ae0f5ba1db6$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
function $2fb40ae0f5ba1db6$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $2fb40ae0f5ba1db6$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $2fb40ae0f5ba1db6$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $2fb40ae0f5ba1db6$var$saveSession(session);
    return session;
}
function $2fb40ae0f5ba1db6$var$fetchSession() {
    if (!$2fb40ae0f5ba1db6$var$hasSessionStorage()) return null;
    try {
        const sessionStringFromStorage = $2fb40ae0f5ba1db6$var$WINDOW.sessionStorage.getItem($2fb40ae0f5ba1db6$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick("Loading existing session");
        return $2fb40ae0f5ba1db6$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
function $2fb40ae0f5ba1db6$var$isExpired(initialTime, expiry, targetTime = +/* @__PURE__ */ new Date()) {
    if (initialTime === null || expiry === void 0 || expiry < 0) return true;
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
function $2fb40ae0f5ba1db6$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $2fb40ae0f5ba1db6$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $2fb40ae0f5ba1db6$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
function $2fb40ae0f5ba1db6$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    if (!$2fb40ae0f5ba1db6$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
function $2fb40ae0f5ba1db6$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $2fb40ae0f5ba1db6$var$fetchSession();
    if (!existingSession) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick("Creating new session");
        return $2fb40ae0f5ba1db6$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$2fb40ae0f5ba1db6$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick("Session in sessionStorage is expired, creating new one...");
    return $2fb40ae0f5ba1db6$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $2fb40ae0f5ba1db6$var$isCustomEvent(event) {
    return event.type === $2fb40ae0f5ba1db6$var$EventType.Custom;
}
function $2fb40ae0f5ba1db6$var$addEventSync(replay, event, isCheckout) {
    if (!$2fb40ae0f5ba1db6$var$shouldAddEvent(replay, event)) return false;
    $2fb40ae0f5ba1db6$var$_addEvent(replay, event, isCheckout);
    return true;
}
function $2fb40ae0f5ba1db6$var$addEvent(replay, event, isCheckout) {
    if (!$2fb40ae0f5ba1db6$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $2fb40ae0f5ba1db6$var$_addEvent(replay, event, isCheckout);
}
async function $2fb40ae0f5ba1db6$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === "buffer";
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $2fb40ae0f5ba1db6$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        if (!replay.isEnabled()) {
            replay.handleException(error);
            return null;
        }
        const isExceeded = error && error instanceof $2fb40ae0f5ba1db6$var$EventBufferSizeExceededError;
        const reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
        const client = (0, $gqV7N.getClient)();
        if (client) {
            const dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
            client.recordDroppedEvent(dropReason, "replay");
        }
        if (isExceeded && isBufferMode) {
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
    }
}
function $2fb40ae0f5ba1db6$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $2fb40ae0f5ba1db6$var$timestampToMs(event.timestamp);
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $2fb40ae0f5ba1db6$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $2fb40ae0f5ba1db6$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
const $2fb40ae0f5ba1db6$var$MAX_CONTEXT_VALUES = 100;
function $2fb40ae0f5ba1db6$var$addSegmentDetailsToContext(replay, traceId, segmentName) {
    const replayContext = replay.getContext();
    if (traceId && replayContext.traceIds.size < $2fb40ae0f5ba1db6$var$MAX_CONTEXT_VALUES) replayContext.traceIds.add(traceId);
    if (segmentName && replayContext.segmentNames.size < $2fb40ae0f5ba1db6$var$MAX_CONTEXT_VALUES) replayContext.segmentNames.add(segmentName);
}
function $2fb40ae0f5ba1db6$var$handleProcessSegmentSpan(replay) {
    return (spanJSON)=>{
        if (!replay.isEnabled()) return;
        $2fb40ae0f5ba1db6$var$addSegmentDetailsToContext(replay, spanJSON.trace_id, spanJSON.name || void 0);
    };
}
function $2fb40ae0f5ba1db6$var$isErrorEvent(event) {
    return !event.type;
}
function $2fb40ae0f5ba1db6$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $2fb40ae0f5ba1db6$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
function $2fb40ae0f5ba1db6$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
function $2fb40ae0f5ba1db6$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$2fb40ae0f5ba1db6$var$isErrorEvent(event) && !$2fb40ae0f5ba1db6$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse.statusCode;
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($2fb40ae0f5ba1db6$var$isTransactionEvent(event)) {
            $2fb40ae0f5ba1db6$var$handleTransactionEvent(replay, event);
            return;
        }
        $2fb40ae0f5ba1db6$var$handleErrorEvent(replay, event);
    };
}
function $2fb40ae0f5ba1db6$var$handleTransactionEvent(replay, event) {
    $2fb40ae0f5ba1db6$var$addSegmentDetailsToContext(replay, event.contexts?.trace?.trace_id, event.transaction);
}
function $2fb40ae0f5ba1db6$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    if (replay.recordingMode !== "buffer" || !event.tags?.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $e2656f69bec1b12b$export$831dc9f2ab0a617b)(async ()=>{
        try {
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
function $2fb40ae0f5ba1db6$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$2fb40ae0f5ba1db6$var$isErrorEvent(event)) return;
        $2fb40ae0f5ba1db6$var$handleHydrationError(replay, event);
    };
}
function $2fb40ae0f5ba1db6$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $2fb40ae0f5ba1db6$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $402417af1fc2ab33$export$1cfafeee2987818b)()
            }
        });
        $2fb40ae0f5ba1db6$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
function $2fb40ae0f5ba1db6$var$handleBreadcrumbs(replay) {
    const client = (0, $gqV7N.getClient)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$2fb40ae0f5ba1db6$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $2fb40ae0f5ba1db6$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$2fb40ae0f5ba1db6$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $2fb40ae0f5ba1db6$var$normalizeBreadcrumb(breadcrumb);
    if (result) $2fb40ae0f5ba1db6$var$addBreadcrumbEvent(replay, result);
}
function $2fb40ae0f5ba1db6$var$normalizeBreadcrumb(breadcrumb) {
    if (!$2fb40ae0f5ba1db6$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $2fb40ae0f5ba1db6$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $2fb40ae0f5ba1db6$var$createBreadcrumb(breadcrumb);
}
function $2fb40ae0f5ba1db6$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $2fb40ae0f5ba1db6$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $2fb40ae0f5ba1db6$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $2fb40ae0f5ba1db6$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $fuLLi.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $2fb40ae0f5ba1db6$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $2fb40ae0f5ba1db6$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return normalizedArg;
        } catch  {}
        return arg;
    });
    return $2fb40ae0f5ba1db6$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $2fb40ae0f5ba1db6$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
function $2fb40ae0f5ba1db6$var$isRrwebError(event, hint) {
    if (event.type || !event.exception?.values?.length) return false;
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
function $2fb40ae0f5ba1db6$var$resetReplayIdOnDynamicSamplingContext() {
    const dsc = (0, $gqV7N.getCurrentScope)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    const activeSpan = (0, $kn25x.getActiveSpan)();
    if (activeSpan) {
        const dsc2 = (0, $cvdrG.getDynamicSamplingContextFromSpan)(activeSpan);
        delete dsc2.replay_id;
    }
}
function $2fb40ae0f5ba1db6$var$setReplayIdOnDynamicSamplingContext(replayId) {
    const dsc = (0, $gqV7N.getCurrentScope)().getPropagationContext().dsc;
    if (dsc) dsc.replay_id = replayId;
    const activeSpan = (0, $kn25x.getActiveSpan)();
    if (activeSpan) {
        const dsc2 = (0, $cvdrG.getDynamicSamplingContextFromSpan)(activeSpan);
        dsc2.replay_id = replayId;
    }
}
function $2fb40ae0f5ba1db6$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) return true;
        replay.throttledAddEvent({
            type: $2fb40ae0f5ba1db6$var$EventType.Custom,
            timestamp: event.timestamp * 1e3,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
function $2fb40ae0f5ba1db6$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    if (event.message === $2fb40ae0f5ba1db6$var$UNABLE_TO_SEND_REPLAY) return false;
    if (!event.exception || event.type) return false;
    return $2fb40ae0f5ba1db6$var$isSampled(replay.getOptions().errorSampleRate);
}
function $2fb40ae0f5ba1db6$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        if (replay.session && $2fb40ae0f5ba1db6$var$shouldRefreshSession(replay.session, {
            maxReplayDuration: replay.getOptions().maxReplayDuration,
            sessionIdleExpire: replay.timeouts.sessionIdleExpire
        })) $2fb40ae0f5ba1db6$var$resetReplayIdOnDynamicSamplingContext();
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($2fb40ae0f5ba1db6$var$isReplayEvent(event)) {
            delete event.breadcrumbs;
            return event;
        }
        if (!$2fb40ae0f5ba1db6$var$isErrorEvent(event) && !$2fb40ae0f5ba1db6$var$isTransactionEvent(event) && !$2fb40ae0f5ba1db6$var$isFeedbackEvent(event)) return event;
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $2fb40ae0f5ba1db6$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($2fb40ae0f5ba1db6$var$isFeedbackEvent(event)) {
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            $2fb40ae0f5ba1db6$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        if ($2fb40ae0f5ba1db6$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Ignoring error from rrweb internals", event);
            return null;
        }
        const isErrorEventSampled = $2fb40ae0f5ba1db6$var$shouldSampleForBufferEvent(replay, event);
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        if (isErrorEventSampled && replay.recordingMode === "buffer" && replay.session?.sampled === "buffer") {
            const session = replay.session;
            session.dirty = true;
            if (replay.getOptions().stickySession) $2fb40ae0f5ba1db6$var$saveSession(session);
        }
        return event;
    }, {
        id: "Replay"
    });
}
function $2fb40ae0f5ba1db6$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $2fb40ae0f5ba1db6$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $2fb40ae0f5ba1db6$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1e3;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
function $2fb40ae0f5ba1db6$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2fb40ae0f5ba1db6$var$handleHistory(handlerData);
        if (result === null) return;
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $2fb40ae0f5ba1db6$var$createPerformanceSpans(replay, [
                result
            ]);
            return false;
        });
    };
}
function $2fb40ae0f5ba1db6$var$shouldFilterRequest(replay, url) {
    if ($2fb40ae0f5ba1db6$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $fecc7855a46a23c6$export$d92e61f5600202af)(url, (0, $gqV7N.getClient)());
}
function $2fb40ae0f5ba1db6$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($2fb40ae0f5ba1db6$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $2fb40ae0f5ba1db6$var$createPerformanceSpans(replay, [
            result
        ]);
        return true;
    });
}
function $2fb40ae0f5ba1db6$var$getBodySize(body) {
    if (!body) return void 0;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $001198e209f856ba$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    } catch  {}
    return void 0;
}
function $2fb40ae0f5ba1db6$var$parseContentLengthHeader(header) {
    if (!header) return void 0;
    const size = parseInt(header, 10);
    return isNaN(size) ? void 0 : size;
}
function $2fb40ae0f5ba1db6$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: void 0,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
function $2fb40ae0f5ba1db6$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1e3,
        end: endTimestamp / 1e3,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
function $2fb40ae0f5ba1db6$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
function $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return void 0;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $2fb40ae0f5ba1db6$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
function $2fb40ae0f5ba1db6$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $2fb40ae0f5ba1db6$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $2fb40ae0f5ba1db6$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $2fb40ae0f5ba1db6$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $2fb40ae0f5ba1db6$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u2026`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {}
    return {
        body: body
    };
}
function $2fb40ae0f5ba1db6$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    return first === "[" && last === "]" || first === "{" && last === "}";
}
function $2fb40ae0f5ba1db6$var$urlMatches(url, urls) {
    const fullUrl = $2fb40ae0f5ba1db6$var$getFullUrl(url);
    return (0, $byQav.stringMatchesSomePattern)(fullUrl, urls);
}
function $2fb40ae0f5ba1db6$var$getFullUrl(url, baseURI = $2fb40ae0f5ba1db6$var$WINDOW.document.baseURI) {
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($2fb40ae0f5ba1db6$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
async function $2fb40ae0f5ba1db6$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $2fb40ae0f5ba1db6$var$_prepareFetchData(breadcrumb, hint, options);
        const result = $2fb40ae0f5ba1db6$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $2fb40ae0f5ba1db6$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to capture fetch breadcrumb");
    }
}
function $2fb40ae0f5ba1db6$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $001198e209f856ba$export$ad44edf8012ec314)(input) : void 0;
    const reqSize = $2fb40ae0f5ba1db6$var$getBodySize(body);
    const resSize = response ? $2fb40ae0f5ba1db6$var$parseContentLengthHeader(response.headers.get("content-length")) : void 0;
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
async function $2fb40ae0f5ba1db6$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $2fb40ae0f5ba1db6$var$urlMatches(url, options.networkDetailAllowUrls) && !$2fb40ae0f5ba1db6$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $2fb40ae0f5ba1db6$var$_getRequestInfo(options, hint.input, requestBodySize) : $2fb40ae0f5ba1db6$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $2fb40ae0f5ba1db6$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $2fb40ae0f5ba1db6$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $2fb40ae0f5ba1db6$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
    const requestBody = (0, $001198e209f856ba$export$ad44edf8012ec314)(input);
    const [bodyStr, warning] = (0, $001198e209f856ba$export$945a2d5364608d5)(requestBody, $2fb40ae0f5ba1db6$var$debug);
    const data = $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $2fb40ae0f5ba1db6$var$mergeWarning(data, warning);
    return data;
}
async function $2fb40ae0f5ba1db6$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== void 0) return $2fb40ae0f5ba1db6$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $2fb40ae0f5ba1db6$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== void 0) return $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    const [bodyText, warning] = await $2fb40ae0f5ba1db6$var$_parseFetchResponseBody(response);
    const result = $2fb40ae0f5ba1db6$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $2fb40ae0f5ba1db6$var$mergeWarning(result, warning);
    return result;
}
function $2fb40ae0f5ba1db6$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === void 0 ? $2fb40ae0f5ba1db6$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $2fb40ae0f5ba1db6$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, size, void 0);
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to serialize response body");
        return $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    }
}
async function $2fb40ae0f5ba1db6$var$_parseFetchResponseBody(response) {
    const res = $2fb40ae0f5ba1db6$var$_tryCloneResponse(response);
    if (!res) return [
        void 0,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $2fb40ae0f5ba1db6$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.warn("Parsing text body from response timed out");
            return [
                void 0,
                "BODY_PARSE_TIMEOUT"
            ];
        }
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to get text body from response");
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $2fb40ae0f5ba1db6$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $2fb40ae0f5ba1db6$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $2fb40ae0f5ba1db6$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $2fb40ae0f5ba1db6$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $2fb40ae0f5ba1db6$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $2fb40ae0f5ba1db6$var$getAllHeaders(headers, allowedHeaders);
    if (Array.isArray(headers)) return {};
    return $2fb40ae0f5ba1db6$var$getAllowedHeaders(headers, allowedHeaders);
}
function $2fb40ae0f5ba1db6$var$_tryCloneResponse(response) {
    try {
        return response.clone();
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to clone response body");
    }
}
function $2fb40ae0f5ba1db6$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $e2656f69bec1b12b$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $2fb40ae0f5ba1db6$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $2fb40ae0f5ba1db6$var$_getResponseText(response) {
    return await response.text();
}
async function $2fb40ae0f5ba1db6$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $2fb40ae0f5ba1db6$var$_prepareXhrData(breadcrumb, hint, options);
        const result = $2fb40ae0f5ba1db6$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $2fb40ae0f5ba1db6$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to capture xhr breadcrumb");
    }
}
function $2fb40ae0f5ba1db6$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $2fb40ae0f5ba1db6$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $2fb40ae0f5ba1db6$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $2fb40ae0f5ba1db6$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
function $2fb40ae0f5ba1db6$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$2fb40ae0f5ba1db6$var$urlMatches(url, options.networkDetailAllowUrls) || $2fb40ae0f5ba1db6$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request2 = $2fb40ae0f5ba1db6$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response2 = $2fb40ae0f5ba1db6$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request2,
            response: response2
        };
    }
    const xhrInfo = xhr[0, $72d11f6c27b0f76b$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $2fb40ae0f5ba1db6$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $2fb40ae0f5ba1db6$var$getAllowedHeaders((0, $001198e209f856ba$export$ce71c337afb62ea)(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $001198e209f856ba$export$945a2d5364608d5)(input, $2fb40ae0f5ba1db6$var$debug) : [
        void 0
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $2fb40ae0f5ba1db6$var$_getXhrResponseBody(xhr) : [
        void 0
    ];
    const request = $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $2fb40ae0f5ba1db6$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $2fb40ae0f5ba1db6$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $2fb40ae0f5ba1db6$var$mergeWarning(response, responseWarning) : response
    };
}
function $2fb40ae0f5ba1db6$var$_getXhrResponseBody(xhr) {
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    try {
        return $2fb40ae0f5ba1db6$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.warn("Failed to get xhr response body", ...errors);
    return [
        void 0
    ];
}
function $2fb40ae0f5ba1db6$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && (0, $exje8.isObjectLike)(body)) return [
            JSON.stringify(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $2fb40ae0f5ba1db6$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && (0, $exje8.isObjectLike)(body) ? JSON.stringify(body) : body;
        return $2fb40ae0f5ba1db6$var$getBodySize(bodyStr);
    } catch  {
        return void 0;
    }
}
function $2fb40ae0f5ba1db6$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $gqV7N.getClient)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$2fb40ae0f5ba1db6$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {}
}
function $2fb40ae0f5ba1db6$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($2fb40ae0f5ba1db6$var$_isXhrBreadcrumb(breadcrumb) && $2fb40ae0f5ba1db6$var$_isXhrHint(hint)) {
            $2fb40ae0f5ba1db6$var$enrichXhrBreadcrumb(breadcrumb, hint);
            $2fb40ae0f5ba1db6$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($2fb40ae0f5ba1db6$var$_isFetchBreadcrumb(breadcrumb) && $2fb40ae0f5ba1db6$var$_isFetchHint(hint)) {
            $2fb40ae0f5ba1db6$var$enrichFetchBreadcrumb(breadcrumb, hint);
            $2fb40ae0f5ba1db6$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(e, "Error when enriching network breadcrumb");
    }
}
function $2fb40ae0f5ba1db6$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $2fb40ae0f5ba1db6$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $2fb40ae0f5ba1db6$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $2fb40ae0f5ba1db6$var$_isFetchHint(hint) {
    return hint?.input !== void 0;
}
function $2fb40ae0f5ba1db6$var$addGlobalListeners(replay) {
    const client = (0, $gqV7N.getClient)();
    (0, $2f47c312dd50f63a$export$5aeffd3db2cf9df7)($2fb40ae0f5ba1db6$var$handleDomListener(replay));
    (0, $c7f70fe1d3ccb7d6$export$3f18c56c58114e75)($2fb40ae0f5ba1db6$var$handleHistorySpanListener(replay));
    $2fb40ae0f5ba1db6$var$handleBreadcrumbs(replay);
    $2fb40ae0f5ba1db6$var$handleNetworkBreadcrumbs(replay);
    const eventProcessor = $2fb40ae0f5ba1db6$var$handleGlobalEventListener(replay);
    (0, $iFEvA.addEventProcessor)(eventProcessor);
    if (client) {
        client.on("beforeSendEvent", $2fb40ae0f5ba1db6$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $2fb40ae0f5ba1db6$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("processSegmentSpan", $2fb40ae0f5ba1db6$var$handleProcessSegmentSpan(replay));
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("beforeSendFeedback", async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                if (feedbackEvent.contexts.feedback.source === "api") await replay.sendBufferedReplayOrFlush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        client.on("openFeedbackWidget", async ()=>{
            await replay.sendBufferedReplayOrFlush();
        });
    }
}
async function $2fb40ae0f5ba1db6$var$addMemoryEntry(replay) {
    try {
        return Promise.all($2fb40ae0f5ba1db6$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $2fb40ae0f5ba1db6$var$createMemoryEntry($2fb40ae0f5ba1db6$var$WINDOW.performance.memory)
        ]));
    } catch  {
        return [];
    }
}
function $2fb40ae0f5ba1db6$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    const time = Date.now() / 1e3;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
function $2fb40ae0f5ba1db6$var$debounce(func, wait, options) {
    return (0, $3710eb481058c495$export$61fc7d43ac8f84b0)(func, wait, {
        ...options,
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $e2656f69bec1b12b$export$831dc9f2ab0a617b)
    });
}
const $2fb40ae0f5ba1db6$var$NAVIGATOR = (0, $59NSd.GLOBAL_OBJ).navigator;
function $2fb40ae0f5ba1db6$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($2fb40ae0f5ba1db6$var$NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test($2fb40ae0f5ba1db6$var$NAVIGATOR?.userAgent ?? "") && $2fb40ae0f5ba1db6$var$NAVIGATOR?.maxTouchPoints && $2fb40ae0f5ba1db6$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
function $2fb40ae0f5ba1db6$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        try {
            if (!replay.checkAndHandleExpiredSession()) {
                $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.warn("Received replay event after session expired.");
                return;
            }
            const isCheckout = _isCheckout || !hadFirstEvent;
            hadFirstEvent = true;
            $2fb40ae0f5ba1db6$var$syncMirrorAttributesFromMutationEvent(event);
            if (replay.clickDetector) $2fb40ae0f5ba1db6$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
            replay.addUpdate(()=>{
                if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
                if (!$2fb40ae0f5ba1db6$var$addEventSync(replay, event, isCheckout)) return true;
                if (!isCheckout) return false;
                const session = replay.session;
                $2fb40ae0f5ba1db6$var$addSettingsEvent(replay, isCheckout);
                if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
                    const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                    if (earliestEvent) {
                        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                        session.started = earliestEvent;
                        if (replay.getOptions().stickySession) $2fb40ae0f5ba1db6$var$saveSession(session);
                    }
                }
                if (session?.previousSessionId) return true;
                if (replay.recordingMode === "session") replay.flush();
                return true;
            });
        } catch (error) {
            replay.handleException(error);
        }
    };
}
function $2fb40ae0f5ba1db6$var$syncMirrorAttributesFromMutationEvent(event) {
    const data = event.data;
    if (event.type !== $2fb40ae0f5ba1db6$var$EventType.IncrementalSnapshot || !data || typeof data !== "object" || !("source" in data) || data.source !== $2fb40ae0f5ba1db6$var$IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) return;
    for (const mutation of data.attributes){
        const node = $2fb40ae0f5ba1db6$var$record.mirror.getNode(mutation.id);
        const meta = node && $2fb40ae0f5ba1db6$var$record.mirror.getMeta(node);
        if (!node || meta?.type !== $2fb40ae0f5ba1db6$var$NodeType.Element) continue;
        const attributes = {
            ...meta.attributes
        };
        let changed = false;
        for (const [attributeName, value] of Object.entries(mutation.attributes)){
            if (!$2fb40ae0f5ba1db6$var$BREADCRUMB_RELEVANT_ATTRIBUTES.has(attributeName)) continue;
            if (value === null) delete attributes[attributeName];
            else attributes[attributeName] = value;
            changed = true;
        }
        if (changed) $2fb40ae0f5ba1db6$var$record.mirror.add(node, {
            ...meta,
            attributes: attributes
        });
    }
}
function $2fb40ae0f5ba1db6$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $2fb40ae0f5ba1db6$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
function $2fb40ae0f5ba1db6$var$addSettingsEvent(replay, isCheckout) {
    if (!isCheckout || replay.session?.segmentId !== 0) return;
    $2fb40ae0f5ba1db6$var$addEventSync(replay, $2fb40ae0f5ba1db6$var$createOptionsEvent(replay), false);
}
function $2fb40ae0f5ba1db6$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch  {
        return null;
    }
}
function $2fb40ae0f5ba1db6$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $f42278b5280d50b5$export$f93f7f385160c44e)((0, $f42278b5280d50b5$export$92b6093782fe661b)(replayEvent, (0, $f42278b5280d50b5$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
function $2fb40ae0f5ba1db6$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        const sequence = enc.encode(replayHeaders);
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
async function $2fb40ae0f5ba1db6$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $9rdlm.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $gqV7N.getIsolationScope)());
    if (!preparedEvent) return null;
    client.emit("postprocessEvent", preparedEvent, eventHint);
    preparedEvent.platform = preparedEvent.platform || "javascript";
    const metadata = client.getSdkMetadata();
    const { name: name, version: version, settings: settings } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0",
        settings: settings
    };
    return preparedEvent;
}
async function $2fb40ae0f5ba1db6$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $2fb40ae0f5ba1db6$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, segmentNames: segmentNames, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $gqV7N.getClient)();
    const scope = (0, $gqV7N.getCurrentScope)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return Promise.resolve({});
    const baseEvent = {
        type: $2fb40ae0f5ba1db6$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1e3,
        timestamp: timestamp / 1e3,
        error_ids: errorIds,
        trace_ids: traceIds,
        segment_names: segmentNames,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $2fb40ae0f5ba1db6$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        client.recordDroppedEvent("event_processor", "replay");
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("An event processor returned `null`, will not send event.");
        return Promise.resolve({});
    }
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $2fb40ae0f5ba1db6$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($2fb40ae0f5ba1db6$var$UNABLE_TO_SEND_REPLAY);
        try {
            error.cause = err;
        } catch  {}
        throw error;
    }
    const rateLimits = (0, $cc9ced9192f551f6$export$699aff705e0d49d4)({}, response);
    if ((0, $cc9ced9192f551f6$export$6c91fec22056810a)(rateLimits, "replay")) throw new $2fb40ae0f5ba1db6$var$RateLimitError(rateLimits);
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $2fb40ae0f5ba1db6$var$TransportStatusCodeError(response.statusCode);
    return response;
}
class $2fb40ae0f5ba1db6$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
class $2fb40ae0f5ba1db6$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
class $2fb40ae0f5ba1db6$var$ReplayDurationLimitError extends Error {
    constructor(){
        super("Session is too long, not sending replay");
    }
}
async function $2fb40ae0f5ba1db6$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $2fb40ae0f5ba1db6$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    if (!recordingData.length) return;
    try {
        await $2fb40ae0f5ba1db6$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $2fb40ae0f5ba1db6$var$TransportStatusCodeError || err instanceof $2fb40ae0f5ba1db6$var$RateLimitError) throw err;
        (0, $iFEvA.setContext)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        if (retryConfig.count >= $2fb40ae0f5ba1db6$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$2fb40ae0f5ba1db6$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                error.cause = err;
            } catch  {}
            throw error;
        }
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $e2656f69bec1b12b$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $2fb40ae0f5ba1db6$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err2) {
                    reject(err2);
                }
            }, retryConfig.interval);
        });
    }
}
const $2fb40ae0f5ba1db6$var$THROTTLED = "__THROTTLED";
const $2fb40ae0f5ba1db6$var$SKIPPED = "__SKIPPED";
function $2fb40ae0f5ba1db6$var$throttle(fn, maxCount, durationSeconds) {
    const counter = /* @__PURE__ */ new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        const now = Math.floor(Date.now() / 1e3);
        _cleanup(now);
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $2fb40ae0f5ba1db6$var$SKIPPED : $2fb40ae0f5ba1db6$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
class $2fb40ae0f5ba1db6$var$ReplayContainer {
    constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $2fb40ae0f5ba1db6$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $2fb40ae0f5ba1db6$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: /* @__PURE__ */ new Set(),
            traceIds: /* @__PURE__ */ new Set(),
            segmentNames: /* @__PURE__ */ new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $2fb40ae0f5ba1db6$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $2fb40ae0f5ba1db6$var$throttle((event, isCheckout)=>$2fb40ae0f5ba1db6$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($2fb40ae0f5ba1db6$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $2fb40ae0f5ba1db6$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : void 0;
        if (slowClickConfig) this.clickDetector = new $2fb40ae0f5ba1db6$var$ClickDetector(this, slowClickConfig);
        if ($2fb40ae0f5ba1db6$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $2fb40ae0f5ba1db6$var$debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        this._handleVisibilityChange = ()=>{
            if ($2fb40ae0f5ba1db6$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        this._handleWindowBlur = ()=>{
            const breadcrumb = $2fb40ae0f5ba1db6$var$createBreadcrumb({
                category: "ui.blur"
            });
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $2fb40ae0f5ba1db6$var$createBreadcrumb({
                category: "ui.focus"
            });
            this._doChangeToForegroundTasks(breadcrumb);
        };
        this._handleKeyboardEvent = (event)=>{
            $2fb40ae0f5ba1db6$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    getMaskAttributeFn() {
        return this._recordingOptions.maskAttributeFn;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) return;
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick("Starting replay in session mode");
        this._updateUserActivity();
        const session = $2fb40ae0f5ba1db6$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this.recordingMode = "session";
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.infoTick("Starting replay in buffer mode");
        const session = $2fb40ae0f5ba1db6$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $2fb40ae0f5ba1db6$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $2fb40ae0f5ba1db6$var$BUFFER_CHECKOUT_TIME
                } : // Otherwise, use experimental option w/ min checkout time of 6 minutes
                // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
                },
                emit: $2fb40ae0f5ba1db6$var$getHandleRecordingEmit(this),
                ...$2fb40ae0f5ba1db6$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = void 0;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        this._isEnabled = false;
        this.recordingMode = "buffer";
        const stopReason = reason ?? "manual";
        (0, $gqV7N.getClient)()?.emit("replayEnd", {
            sessionId: this.session?.id,
            reason: stopReason
        });
        try {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log(`Stopping Replay triggered by ${stopReason}`);
            $2fb40ae0f5ba1db6$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            if (forceFlush) await this._flush({
                force: true
            });
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            $2fb40ae0f5ba1db6$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Converting buffer to session");
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        if (this.recordingMode === "session") return;
        this.recordingMode = "session";
        if (this.session) {
            this.session.dirty = false;
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
            $2fb40ae0f5ba1db6$var$setReplayIdOnDynamicSamplingContext(this.session.id);
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        const cbResult = cb();
        if (this.recordingMode === "buffer" || !this._isEnabled) return;
        if (cbResult === true) return;
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        if (!this._stopRecording) {
            if (!this._checkSession()) return;
            this.resume();
            return;
        }
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ getSessionId(onlyIfSampled) {
        if (onlyIfSampled && this.session?.sampled === false) return void 0;
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        if (this._lastActivity && $2fb40ae0f5ba1db6$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === "session") {
            this.pause();
            return;
        }
        if (!this._checkSession()) return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$2fb40ae0f5ba1db6$var$WINDOW.location.pathname}${$2fb40ae0f5ba1db6$var$WINDOW.location.hash}${$2fb40ae0f5ba1db6$var$WINDOW.location.search}`;
        const url = `${$2fb40ae0f5ba1db6$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        if (res === $2fb40ae0f5ba1db6$var$THROTTLED) {
            const breadcrumb = $2fb40ae0f5ba1db6$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                return !$2fb40ae0f5ba1db6$var$addEventSync(this, {
                    type: $2fb40ae0f5ba1db6$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $kn25x.getActiveSpan)();
        const lastRootSpan = lastActiveSpan && (0, $kn25x.getRootSpan)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $kn25x.spanToJSON)(lastRootSpan).data || {};
        const source = attributes[0, $2MLxn.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return void 0;
        return (0, $kn25x.spanToJSON)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        this._updateSessionActivity();
        this.eventBuffer = $2fb40ae0f5ba1db6$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        this._isEnabled = true;
        this._isPaused = false;
        if (this.session) (0, $gqV7N.getClient)()?.emit("replayStart", {
            sessionId: this.session.id,
            recordingMode: this.recordingMode
        });
        this.startRecording();
        if (this.recordingMode === "session" && this.session) $2fb40ae0f5ba1db6$var$setReplayIdOnDynamicSamplingContext(this.session.id);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $2fb40ae0f5ba1db6$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        if (!this.session) return false;
        const currentSession = this.session;
        if ($2fb40ae0f5ba1db6$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "sessionExpired"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $2fb40ae0f5ba1db6$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $2fb40ae0f5ba1db6$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $2fb40ae0f5ba1db6$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $2fb40ae0f5ba1db6$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            if (!this._hasInitializedCoreListeners) {
                $2fb40ae0f5ba1db6$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $2fb40ae0f5ba1db6$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $2fb40ae0f5ba1db6$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $2fb40ae0f5ba1db6$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $2fb40ae0f5ba1db6$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $2fb40ae0f5ba1db6$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $2fb40ae0f5ba1db6$var$shouldRefreshSession(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) {
            $2fb40ae0f5ba1db6$var$resetReplayIdOnDynamicSamplingContext();
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $2fb40ae0f5ba1db6$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $2fb40ae0f5ba1db6$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($2fb40ae0f5ba1db6$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.segmentNames.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer || this._requiresManualStart) return;
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            segmentNames: Array.from(this._context.segmentNames),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        if (!this.eventBuffer?.hasEvents) return;
        await $2fb40ae0f5ba1db6$var$addMemoryEntry(this);
        if (!this.eventBuffer) return;
        if (replayId !== this.getSessionId()) return;
        try {
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) throw new $2fb40ae0f5ba1db6$var$ReplayDurationLimitError();
            const eventContext = this._popEventContext();
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            const recordingData = await this.eventBuffer.finish();
            await $2fb40ae0f5ba1db6$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            this.stop({
                reason: "sendError"
            });
            const client = (0, $gqV7N.getClient)();
            if (client) {
                let dropReason;
                if (err instanceof $2fb40ae0f5ba1db6$var$RateLimitError) dropReason = "ratelimit_backoff";
                else if (err instanceof $2fb40ae0f5ba1db6$var$ReplayDurationLimitError) dropReason = "invalid";
                else dropReason = "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) return;
        if (!this.checkAndHandleExpiredSession()) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.error("Attempting to finish replay event after session expired.");
            return;
        }
        if (!this.session) return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        this._debouncedFlush.cancel();
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5e3;
        if (tooShort || tooLong) {
            $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log(`Session duration (${Math.floor(duration / 1e3)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $2fb40ae0f5ba1db6$var$DEBUG_BUILD && $2fb40ae0f5ba1db6$var$debug.log("Flushing initial segment without checkout.");
        const _flushInProgress = !!this._flushLock;
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = void 0;
            if (_flushInProgress) this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $2fb40ae0f5ba1db6$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const { ignoreMutations: ignoreMutations } = this._options._experiments;
        if (ignoreMutations?.length) {
            if (mutations.some((mutation)=>{
                const el = $2fb40ae0f5ba1db6$var$closestElementOfNode(mutation.target);
                const selector = ignoreMutations.join(",");
                return el?.matches(selector);
            })) return false;
        }
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $2fb40ae0f5ba1db6$var$createBreadcrumb({
                category: "replay.mutations",
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        if (overMutationLimit) {
            this.stop({
                reason: "mutationLimit",
                forceFlush: this.recordingMode === "session"
            });
            return false;
        }
        return true;
    }
}
function $2fb40ae0f5ba1db6$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
function $2fb40ae0f5ba1db6$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        "base",
        "iframe[srcdoc]:not([src])"
    ];
    const maskSelector = $2fb40ae0f5ba1db6$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $2fb40ae0f5ba1db6$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $2fb40ae0f5ba1db6$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $2fb40ae0f5ba1db6$var$getOption(unblock, []),
        ignoreSelector: $2fb40ae0f5ba1db6$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
function $2fb40ae0f5ba1db6$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    const masksNamedAttribute = maskAttributes.includes(key);
    const masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "");
    if (masksNamedAttribute || masksSubmitButtonValue) return value.replace(/[\S]/g, "*");
    return value;
}
const $2fb40ae0f5ba1db6$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $2fb40ae0f5ba1db6$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
const $2fb40ae0f5ba1db6$var$ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
let $2fb40ae0f5ba1db6$var$_initialized = false;
let $2fb40ae0f5ba1db6$var$_isRequestInstrumented = false;
function $2fb40ae0f5ba1db6$var$_INTERNAL_instrumentRequestInterface() {
    if (typeof Request === "undefined" || $2fb40ae0f5ba1db6$var$_isRequestInstrumented) return;
    const OriginalRequest = Request;
    try {
        const SentryRequest = function(input, init) {
            const request = new OriginalRequest(input, init);
            if (init?.body != null) request[$2fb40ae0f5ba1db6$var$ORIGINAL_BODY] = init.body;
            return request;
        };
        SentryRequest.prototype = OriginalRequest.prototype;
        (0, $59NSd.GLOBAL_OBJ).Request = SentryRequest;
        $2fb40ae0f5ba1db6$var$_isRequestInstrumented = true;
    } catch  {}
}
const $2fb40ae0f5ba1db6$export$d7706faf7ab354bf = (options)=>{
    return new $2fb40ae0f5ba1db6$var$Replay(options);
};
class $2fb40ae0f5ba1db6$var$Replay {
    constructor({ flushMinDelay: flushMinDelay = $2fb40ae0f5ba1db6$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $2fb40ae0f5ba1db6$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $2fb40ae0f5ba1db6$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $2fb40ae0f5ba1db6$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 1e4, slowClickTimeout: slowClickTimeout = 7e3, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder",
        "aria-label"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError, attachRawBodyFromRequest: attachRawBodyFromRequest = false } = {}){
        this.name = "Replay";
        const privacyOptions = $2fb40ae0f5ba1db6$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$2fb40ae0f5ba1db6$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch  {}
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $2fb40ae0f5ba1db6$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $2fb40ae0f5ba1db6$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $2fb40ae0f5ba1db6$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $2fb40ae0f5ba1db6$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            attachRawBodyFromRequest: attachRawBodyFromRequest,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $2fb40ae0f5ba1db6$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$2fb40ae0f5ba1db6$var$MEDIA_SELECTORS}`;
            this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set([
                "background-image"
            ]);
        }
        if (this._isInitialized && (0, $aa9bd5b4b8a52a16$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $2fb40ae0f5ba1db6$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $2fb40ae0f5ba1db6$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $aa9bd5b4b8a52a16$export$4e09c449d6c407f7)() || this._replay) return;
        if (this._initialOptions.attachRawBodyFromRequest) $2fb40ae0f5ba1db6$var$_INTERNAL_instrumentRequestInterface();
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   *
   * @param options.flush - Whether to flush the pending replay segment when stopping.
   * When recording in `session` mode, `stop()` flushes the buffered-but-unsent segment by
   * default (`flush: true`), matching the previous behavior. Pass `flush: false` to stop
   * recording without sending that pending segment — useful when a user withdraws consent
   * and no further data should leave the browser.
   *
   * Note: `flush: false` only prevents the *pending* (final) segment from being sent. It does
   * **not** retract segments that were already sent earlier during `session` recording.
   */ stop(options) {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: options?.flush ?? this._replay.recordingMode === "session",
            reason: "manual"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ getReplayId(onlyIfSampled) {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId(onlyIfSampled);
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    processSpan(span) {
        const replayId = this.getReplayId(true);
        if (replayId) {
            (0, $19021fd0a693b8fd$export$146fcadff0eefcf3)(span, {
                "sentry.replay_id": replayId
            });
            if (this.getRecordingMode() === "buffer") (0, $19021fd0a693b8fd$export$146fcadff0eefcf3)(span, {
                "sentry._internal.replay_is_buffering": true
            });
        }
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        const finalOptions = $2fb40ae0f5ba1db6$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $2fb40ae0f5ba1db6$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch  {}
    }
}
function $2fb40ae0f5ba1db6$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $1s5dy.parseSampleRate)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $1s5dy.parseSampleRate)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $cG2xs.consoleSandbox)(()=>{
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $2fb40ae0f5ba1db6$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$2fb40ae0f5ba1db6$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
function $2fb40ae0f5ba1db6$export$b28310b2f161456b() {
    const client = (0, $gqV7N.getClient)();
    return client?.getIntegrationByName("Replay");
}


$eb107a3c28f65464$export$2cd8252107eb640b({
    dsn: "https://11dce24d08fba04366ff0f9527d5ac94@o307710.ingest.us.sentry.io/4510544236773376",
    environment: "production",
    debug: false,
    release: "@bestory/ui@0.13.0",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
        // send console.log, console.warn, and console.error calls as logs to Sentry
        $b79e1852664f0dff$export$63e034b6c5b5b12a({
            levels: [
                "log",
                "warn",
                "error"
            ]
        }),
        // Sentry.browserTracingIntegration(),
        $2fb40ae0f5ba1db6$export$d7706faf7ab354bf()
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/bestory\.adobedemo\.com/,
        /^https:\/\/bestory\.adobed\.com/
    ]
});



var $eF4cA = parcelRequire("eF4cA");
var $215fd4c42096d4b2$exports = {};
'use strict';
function $215fd4c42096d4b2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($215fd4c42096d4b2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$215fd4c42096d4b2$var$checkDCE();

$215fd4c42096d4b2$exports = (parcelRequire("5RTBg"));



var $dqZbZ = parcelRequire("dqZbZ");

var $iFEvA = parcelRequire("iFEvA");

var $exje8 = parcelRequire("exje8");

var $eF4cA = parcelRequire("eF4cA");
function $dcc25ca60a79753f$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
function $dcc25ca60a79753f$export$bc95048bc211a673(error, cause) {
    const seenErrors = /* @__PURE__ */ new WeakSet();
    function recurse(error2, cause2) {
        if (seenErrors.has(error2)) return;
        if (error2.cause) {
            if (!(0, $exje8.isError)(error2.cause)) return;
            seenErrors.add(error2);
            return recurse(error2.cause, cause2);
        }
        error2.cause = cause2;
    }
    recurse(error, cause);
}
function $dcc25ca60a79753f$export$270be4195468cda9(error, { componentStack: componentStack }, hint) {
    if ($dcc25ca60a79753f$export$a87138b73900f5b((0, $eF4cA.version)) && (0, $exje8.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        $dcc25ca60a79753f$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $iFEvA.captureException)(error, hint);
}
function $dcc25ca60a79753f$export$1e6f045b27b3cfb1(callback) {
    return (error, errorInfo)=>{
        const hasCallback = !!callback;
        const eventId = $dcc25ca60a79753f$export$270be4195468cda9(error, errorInfo, {
            mechanism: {
                handled: hasCallback,
                type: "auto.function.react.error_handler"
            }
        });
        if (hasCallback) callback(error, errorInfo, eventId);
    };
}



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $8b4a29f41b68dc46$export$b16d9fb1a22de840 = (0, $eF4cA.createContext)(null);
function $8b4a29f41b68dc46$var$m({ children: r, didCatch: e, error: t, resetErrorBoundary: o }) {
    const n = (0, $eF4cA.useMemo)(()=>({
            didCatch: e,
            error: t,
            resetErrorBoundary: o
        }), [
        e,
        t,
        o
    ]);
    return (0, $eF4cA.createElement)($8b4a29f41b68dc46$export$b16d9fb1a22de840.Provider, {
        value: n
    }, r);
}
const $8b4a29f41b68dc46$var$d = {
    didCatch: !1,
    error: null
};
class $8b4a29f41b68dc46$export$e926676385687eaf extends (0, $eF4cA.Component) {
    constructor(e){
        super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = $8b4a29f41b68dc46$var$d;
    }
    static getDerivedStateFromError(e) {
        return {
            didCatch: !0,
            error: e
        };
    }
    resetErrorBoundary(...e) {
        const { didCatch: t } = this.state;
        t && (this.props.onReset?.({
            args: e,
            reason: "imperative-api"
        }), this.setState($8b4a29f41b68dc46$var$d));
    }
    componentDidCatch(e, t) {
        this.props.onError?.(e, t);
    }
    componentDidUpdate(e, t) {
        const { didCatch: o } = this.state, { resetKeys: n } = this.props;
        o && t.didCatch && $8b4a29f41b68dc46$var$g(e.resetKeys, n) && (this.props.onReset?.({
            next: n,
            prev: e.resetKeys,
            reason: "keys"
        }), this.setState($8b4a29f41b68dc46$var$d));
    }
    render() {
        const { children: e, fallbackRender: t, FallbackComponent: o, fallback: n } = this.props, { didCatch: s, error: a } = this.state;
        let c = e;
        if (s) {
            const u = {
                error: a,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof t == "function") c = t(u);
            else if (o) c = (0, $eF4cA.createElement)(o, u);
            else if ("fallback" in this.props) c = n;
            else throw a;
        }
        return (0, $eF4cA.createElement)($8b4a29f41b68dc46$var$m, {
            didCatch: s,
            error: a,
            resetErrorBoundary: this.resetErrorBoundary
        }, c);
    }
}
function $8b4a29f41b68dc46$var$g(r = [], e = []) {
    return r.length !== e.length || r.some((t, o)=>!Object.is(t, e[o]));
}
function $8b4a29f41b68dc46$var$x(r) {
    return r !== null && typeof r == "object" && "didCatch" in r && typeof r.didCatch == "boolean" && "error" in r && "resetErrorBoundary" in r && typeof r.resetErrorBoundary == "function";
}
function $8b4a29f41b68dc46$var$b(r) {
    if (!$8b4a29f41b68dc46$var$x(r)) throw new Error("ErrorBoundaryContext not found");
}
function $8b4a29f41b68dc46$export$c052f6604b7d51fe() {
    const r = (0, $eF4cA.useContext)($8b4a29f41b68dc46$export$b16d9fb1a22de840);
    $8b4a29f41b68dc46$var$b(r);
    const { error: e, resetErrorBoundary: t } = r, [o, n] = (0, $eF4cA.useState)({
        error: null,
        hasError: !1
    }), s = (0, $eF4cA.useMemo)(()=>({
            error: e,
            resetBoundary: ()=>{
                t(), n({
                    error: null,
                    hasError: !1
                });
            },
            showBoundary: (a)=>n({
                    error: a,
                    hasError: !0
                })
        }), [
        e,
        t
    ]);
    if (o.hasError) throw o.error;
    return s;
}
function $8b4a29f41b68dc46$export$82f46aa4e6535a45(r) {
    switch(typeof r){
        case "object":
            if (r !== null && "message" in r && typeof r.message == "string") return r.message;
            break;
        case "string":
            return r;
    }
}
function $8b4a29f41b68dc46$export$f0c7a449e0cfaec7(r, e) {
    const t = (0, $eF4cA.forwardRef)((n, s)=>(0, $eF4cA.createElement)($8b4a29f41b68dc46$export$e926676385687eaf, e, (0, $eF4cA.createElement)(r, {
            ...n,
            ref: s
        }))), o = r.displayName || r.name || "Unknown";
    return t.displayName = `withErrorBoundary(${o})`, t;
}



var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $arisx = parcelRequire("arisx");

var $dqZbZ = parcelRequire("dqZbZ");

var $dm5H1 = parcelRequire("dm5H1");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a55d5c15221454c5$var$$b6ecef1351719e54$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "83211c__d",
                        x1: -19.921,
                        x2: 186.087,
                        y1: 133.557,
                        y2: 0.603,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "83211c__e",
                        x1: 150.995,
                        x2: 65.38,
                        y1: 45.947,
                        y2: 143.606,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "83211c__f",
                        x1: 39.959,
                        x2: 197.223,
                        y1: 151.344,
                        y2: 57.889,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "83211c__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "83211c__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 53.7253 -56.9923 0 56.992 53.725)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "83211c__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 13,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "83211c__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M107.022 87.22c-6.16 5.88-13.79 11.98-23.22 18.19h-.01c-.79.52-1.61.96-2.46 1.33-5.95 2.58-13 1.36-17.71-3.35l-3.54-3.54-3.54-3.54c-4.46-4.47-5.78-11.02-3.71-16.76.43-1.18.99-2.33 1.7-3.41 4.49-6.82 8.93-12.69 13.26-17.75 25.17-29.39 46.97-31.29 56.92-30.16 3.68.42 6.58 3.33 7 7 1.05 9.3-.53 28.94-24.69 51.99m1.7-35.99c-3.31-3.3-8.67-3.3-11.97 0-3.3 3.31-3.31 8.67 0 11.97s8.67 3.31 11.97 0 3.31-8.67 0-11.97m-64.61 30.71-10.48.18v.01c-6.81.12-10.67-7.8-6.35-13.06 12.21-14.85 28.66-20.14 39.39-21.35-6.47 6.82-12.76 14.84-18.82 24.04-2.06 3.13-3.29 6.63-3.74 10.18m-15.41 36.6c-.78.78-1.81 1.17-2.83 1.17-1.03 0-2.05-.39-2.83-1.17-1.56-1.57-1.56-4.1 0-5.66l10.5-10.5c1.57-1.56 4.1-1.56 5.66 0 1.56 1.57 1.56 4.1 0 5.66zm14-7c1.57-1.56 4.1-1.56 5.66 0 1.56 1.57 1.56 4.1 0 5.66l-20 20c-.78.78-1.8 1.17-2.83 1.17s-2.05-.39-2.83-1.17c-1.56-1.57-1.56-4.1 0-5.66zm9.22 9.21-11 11c-1.56 1.56-1.56 4.09 0 5.66.78.78 1.8 1.17 2.83 1.17s2.05-.39 2.83-1.17l11-11c1.56-1.56 1.56-4.09 0-5.66s-4.09-1.56-5.66 0m26.11-4.89-.18 10.44c-.12 6.85 7.85 10.65 13.13 6.29 14.761-12.18 20.041-28.55 21.271-39.27-6.48 6.12-14.39 12.41-24.05 18.77-3.08 2.03-6.55 3.3-10.17 3.77"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#83211c__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#83211c__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 131,
                            height: 123.491,
                            x: 13,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M13 23.2h131v123.491H13z"
                        }),
                        (0, $dx4lB.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#83211c__c)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 30 -25.66)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#83211c__d)",
                            d: "M63.002 1.387C52.94-4.482 40.194-4.518 30.096 1.294l-101 58.132c-9.891 5.693-9.907 19.132-.03 24.847L29.4 142.322c10.082 5.833 22.83 5.826 32.904-.021l100.125-58.104c9.826-5.702 9.844-19.066.03-24.79z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#83211c__e)",
                            d: "M31.878 81.831C34.118 35.728 75.58.066 124.485 2.177c48.907 2.11 86.738 41.195 84.499 87.298s-43.701 81.765-92.607 79.654c-48.906-2.11-86.738-41.195-84.499-87.298"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#83211c__f)",
                            d: "M-40.075 112.229c19.44-7.818 40.406-7.483 58.57-.645 36.349 13.718 57.498 5.237 72.167-28.95 7.307-17.153 21.572-31.681 41.035-39.508 38.911-15.624 83.833 1.33 100.384 37.902s-1.565 78.852-40.467 94.497c-19.506 7.845-40.512 7.477-58.705.577-36.288-13.644-57.398-5.131-72.048 29.096-7.325 17.113-21.588 31.592-41.028 39.41-38.88 15.636-83.803-1.318-100.344-37.87-16.542-36.552 1.555-78.873 40.436-94.509"
                        }),
                        (0, $dx4lB.jsx)("ellipse", {
                            cx: 56.992,
                            cy: 53.725,
                            fill: "url(#83211c__g)",
                            rx: 56.992,
                            ry: 53.725,
                            transform: "matrix(1 -.00132 .00148 1 79.293 -8.14)"
                        })
                    ]
                })
            })
        ]
    });
const $a55d5c15221454c5$var$$b6ecef1351719e54$var$ForwardRef = (0, $eF4cA.forwardRef)($a55d5c15221454c5$var$$b6ecef1351719e54$var$SvgComponent);
var $a55d5c15221454c5$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($a55d5c15221454c5$var$$b6ecef1351719e54$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $fb0e7be2fc031da8$var$$2b97049cf343cfc3$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "c7b3fa__d",
                        x1: -11.953,
                        x2: 111.651,
                        y1: 80.134,
                        y2: 0.361,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "c7b3fa__e",
                        x1: 90.597,
                        x2: 39.227,
                        y1: 27.568,
                        y2: 86.163,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "c7b3fa__f",
                        x1: 23.977,
                        x2: 118.335,
                        y1: 90.806,
                        y2: 34.734,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "c7b3fa__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "c7b3fa__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 32.2352 -34.1954 0 34.195 32.235)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "c7b3fa__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 7.801,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "c7b3fa__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M64.213 52.332c-3.696 3.528-8.274 7.188-13.932 10.914h-.006q-.71.466-1.477.798c-3.57 1.548-7.8.816-10.626-2.01L36.05 59.91l-2.124-2.124c-2.676-2.682-3.468-6.612-2.226-10.056.257-.708.593-1.398 1.02-2.046 2.694-4.092 5.358-7.614 7.956-10.65C55.777 17.4 68.857 16.26 74.827 16.938c2.207.252 3.948 1.998 4.2 4.2.63 5.58-.319 17.364-14.814 31.194m1.02-21.594c-1.987-1.98-5.203-1.98-7.183 0-1.98 1.986-1.985 5.202 0 7.182s5.203 1.986 7.183 0 1.986-5.202 0-7.182M26.466 49.164l-6.288.108v.006c-4.086.072-6.402-4.68-3.81-7.836 7.326-8.91 17.196-12.084 23.634-12.81-3.882 4.092-7.656 8.904-11.292 14.424-1.236 1.878-1.974 3.978-2.244 6.108m-9.246 21.96c-.468.468-1.086.702-1.698.702-.618 0-1.23-.234-1.698-.702-.936-.942-.936-2.46 0-3.396l6.3-6.3c.942-.936 2.46-.936 3.396 0 .936.942.936 2.46 0 3.396zm8.4-4.2c.942-.936 2.46-.936 3.396 0 .936.942.936 2.46 0 3.396l-12 12c-.468.468-1.08.702-1.698.702s-1.23-.234-1.698-.702c-.936-.942-.936-2.46 0-3.396zm5.532 5.526-6.6 6.6c-.936.936-.936 2.454 0 3.396.468.468 1.08.702 1.698.702s1.23-.234 1.698-.702l6.6-6.6c.936-.936.936-2.454 0-3.396s-2.454-.936-3.396 0m15.667-2.934-.108 6.264c-.072 4.11 4.71 6.39 7.878 3.774 8.856-7.308 12.024-17.13 12.762-23.562-3.888 3.672-8.634 7.446-14.43 11.262-1.848 1.218-3.93 1.98-6.102 2.262"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#c7b3fa__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#c7b3fa__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 78.6,
                            height: 74.094,
                            x: 7.801,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M7.8 13.92h78.6v74.094H7.8z"
                        }),
                        (0, $dx4lB.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#c7b3fa__c)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 18 -15.396)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#c7b3fa__d)",
                            d: "M37.8.832C31.764-2.69 24.116-2.711 18.057.776l-60.6 34.88c-5.935 3.415-5.945 11.478-.018 14.907l60.2 34.83c6.05 3.5 13.697 3.495 19.742-.013l60.075-34.862c5.895-3.421 5.906-11.44.018-14.874z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#c7b3fa__e)",
                            d: "M19.126 49.099C20.47 21.437 45.346.039 74.69 1.306c29.344 1.266 52.043 24.717 50.7 52.379-1.344 27.661-26.22 49.059-55.565 47.792-29.343-1.266-52.042-24.717-50.699-52.378"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#c7b3fa__f)",
                            d: "M-24.044 67.337c11.665-4.69 24.244-4.49 35.143-.386 21.809 8.23 34.498 3.142 43.3-17.37 4.384-10.292 12.943-19.01 24.62-23.705 23.348-9.375 50.301.797 60.231 22.74 9.931 21.945-.939 47.313-24.28 56.699-11.703 4.707-24.307 4.486-35.223.347-21.773-8.187-34.439-3.079-43.229 17.457-4.395 10.268-12.952 18.955-24.617 23.646-23.328 9.381-50.281-.791-60.206-22.722s.933-47.324 24.261-56.706"
                        }),
                        (0, $dx4lB.jsx)("ellipse", {
                            cx: 34.195,
                            cy: 32.235,
                            fill: "url(#c7b3fa__g)",
                            rx: 34.195,
                            ry: 32.235,
                            transform: "matrix(1 -.00132 .00148 1 47.578 -4.884)"
                        })
                    ]
                })
            })
        ]
    });
const $fb0e7be2fc031da8$var$$2b97049cf343cfc3$var$ForwardRef = (0, $eF4cA.forwardRef)($fb0e7be2fc031da8$var$$2b97049cf343cfc3$var$SvgComponent);
var $fb0e7be2fc031da8$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($fb0e7be2fc031da8$var$$2b97049cf343cfc3$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a24f2ba8d4661a81$var$$84497418bb316e8d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "76af74__d",
                        x1: -5.977,
                        x2: 55.826,
                        y1: 40.067,
                        y2: 0.181,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "76af74__e",
                        x1: 45.296,
                        x2: 19.612,
                        y1: 13.784,
                        y2: 43.081,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "76af74__f",
                        x1: 11.986,
                        x2: 59.166,
                        y1: 45.403,
                        y2: 17.367,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "76af74__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "76af74__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 16.1176 -17.0977 0 17.098 16.118)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "76af74__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 3.898,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "76af74__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M32.104 26.166c-1.848 1.764-4.137 3.594-6.966 5.457h-.003q-.355.233-.738.399c-1.785.774-3.9.408-5.313-1.005l-1.062-1.062-1.062-1.062c-1.338-1.341-1.734-3.306-1.113-5.028.13-.354.297-.7.51-1.023 1.347-2.046 2.68-3.807 3.978-5.325C27.886 8.7 34.426 8.13 37.411 8.469c1.104.126 1.974.999 2.1 2.1.315 2.79-.159 8.682-7.407 15.597m.51-10.797c-.993-.99-2.6-.99-3.59 0-.99.993-.994 2.6 0 3.59.992.99 2.6.994 3.59 0 .99-.992.993-2.6 0-3.59m-19.383 9.213-3.144.054v.003c-2.043.036-3.201-2.34-1.905-3.918 3.663-4.455 8.598-6.042 11.817-6.405-1.941 2.046-3.828 4.452-5.646 7.212-.618.939-.987 1.989-1.122 3.054m-4.623 10.98c-.234.234-.543.35-.849.35-.309 0-.615-.116-.849-.35-.468-.471-.468-1.23 0-1.698l3.15-3.15c.471-.468 1.23-.468 1.698 0 .468.47.468 1.23 0 1.698zm4.2-2.1c.471-.468 1.23-.468 1.698 0 .468.47.468 1.23 0 1.698l-6 6c-.234.234-.54.35-.849.35s-.615-.116-.849-.35c-.468-.471-.468-1.23 0-1.698zm2.766 2.763-3.3 3.3c-.468.468-.468 1.227 0 1.698.234.234.54.35.85.35.308 0 .614-.116.848-.35l3.3-3.3c.468-.468.468-1.227 0-1.698s-1.227-.468-1.698 0m7.833-1.467-.053 3.132c-.037 2.055 2.355 3.195 3.939 1.887 4.428-3.654 6.011-8.565 6.38-11.781-1.944 1.836-4.317 3.723-7.215 5.63-.923.61-1.964.99-3.05 1.132"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#76af74__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#76af74__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 39.3,
                            height: 37.047,
                            x: 3.898,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.898 6.96h39.3v37.047h-39.3z"
                        }),
                        (0, $dx4lB.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#76af74__c)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 9 -7.698)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#76af74__d)",
                            d: "M18.9.416c-3.018-1.76-6.842-1.771-9.872-.028l-30.3 17.44c-2.967 1.708-2.972 5.74-.008 7.454l30.1 17.415c3.024 1.75 6.848 1.747 9.87-.007l30.038-17.43c2.948-1.712 2.953-5.72.009-7.438z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#76af74__e)",
                            d: "M9.561 24.549C10.233 10.718 22.671.019 37.343.652s26.021 12.359 25.35 26.19c-.672 13.83-13.11 24.53-27.782 23.896-14.672-.633-26.022-12.358-25.35-26.19"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#76af74__f)",
                            d: "M-12.024 33.669c5.832-2.346 12.122-2.245 17.572-.194 10.904 4.116 17.249 1.571 21.65-8.684 2.192-5.147 6.471-9.505 12.31-11.853 11.673-4.687 25.15.399 30.115 11.37s-.47 23.656-12.14 28.35c-5.852 2.353-12.154 2.243-17.611.173-10.887-4.094-17.22-1.54-21.615 8.728-2.198 5.135-6.476 9.478-12.308 11.823-11.664 4.691-25.141-.395-30.104-11.36-4.962-10.966.467-23.662 12.131-28.353"
                        }),
                        (0, $dx4lB.jsx)("ellipse", {
                            cx: 17.098,
                            cy: 16.118,
                            fill: "url(#76af74__g)",
                            rx: 17.098,
                            ry: 16.118,
                            transform: "matrix(1 -.00132 .00148 1 23.785 -2.442)"
                        })
                    ]
                })
            })
        ]
    });
const $a24f2ba8d4661a81$var$$84497418bb316e8d$var$ForwardRef = (0, $eF4cA.forwardRef)($a24f2ba8d4661a81$var$$84497418bb316e8d$var$SvgComponent);
var $a24f2ba8d4661a81$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($a24f2ba8d4661a81$var$$84497418bb316e8d$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a7459e5f3808edd1$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $a55d5c15221454c5$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $a24f2ba8d4661a81$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $fb0e7be2fc031da8$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}



var $8PkOq = parcelRequire("8PkOq");

var $fmJ8d = parcelRequire("fmJ8d");
/*
 * <license header>
 */ 
var $dx4lB = parcelRequire("dx4lB");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $arisx = parcelRequire("arisx");

var $dm5H1 = parcelRequire("dm5H1");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ac17ca43e2805bbc$var$$b9f8236411ed542d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M43.5 32C34.94 32 28 38.94 28 47.5v1C28 57.06 34.94 64 43.5 64h73c8.56 0 15.5-6.94 15.5-15.5v-1c0-8.56-6.94-15.5-15.5-15.5zm73 40H84v16h32.5c12.979 0 23.5 10.521 23.5 23.5v1c0 12.979-10.521 23.5-23.5 23.5h-73C30.521 136 20 125.479 20 112.5v-1C20 98.521 30.521 88 43.5 88H76V72H43.5C30.521 72 20 61.479 20 48.5v-1C20 34.521 30.521 24 43.5 24h73c12.979 0 23.5 10.521 23.5 23.5v1c0 12.979-10.521 23.5-23.5 23.5M80 96H43.5c-8.56 0-15.5 6.94-15.5 15.5v1c0 8.56 6.94 15.5 15.5 15.5h73c8.56 0 15.5-6.94 15.5-15.5v-1c0-8.56-6.94-15.5-15.5-15.5zM57 44c-2.21 0-4 1.79-4 4s1.79 4 4 4h18c2.21 0 4-1.79 4-4s-1.79-4-4-4zm-12.5 8.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5S40 45.515 40 48s2.015 4.5 4.5 4.5M53 112c0-2.209 1.79-4 4-4h18c2.21 0 4 1.791 4 4s-1.79 4-4 4H57c-2.21 0-4-1.791-4-4m-4 0c0 2.485-2.015 4.5-4.5 4.5S40 114.485 40 112s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5"
        })
    });
const $ac17ca43e2805bbc$var$$b9f8236411ed542d$var$ForwardRef = (0, $eF4cA.forwardRef)($ac17ca43e2805bbc$var$$b9f8236411ed542d$var$SvgComponent);
var $ac17ca43e2805bbc$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($ac17ca43e2805bbc$var$$b9f8236411ed542d$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a22fc886b325db52$var$$20980ef1af485d32$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M18 29c0-4.97 4.03-9 9-9h42c4.97 0 9 4.03 9 9s-4.03 9-9 9H27c-4.97 0-9-4.03-9-9m32 13h19c7.18 0 13-5.82 13-13s-5.82-13-13-13H27c-7.18 0-13 5.82-13 13s5.82 13 13 13h19v11H27c-7.18 0-13 5.82-13 13s5.82 13 13 13h42c7.18 0 13-5.82 13-13s-5.82-13-13-13H50zM27 57c-4.97 0-9 4.03-9 9s4.03 9 9 9h42c4.97 0 9-4.03 9-9s-4.03-9-9-9zm3 9c0 1.38-1.12 2.5-2.5 2.5S25 67.38 25 66s1.12-2.5 2.5-2.5S30 64.62 30 66m2 0c0-1.105.895-2 2-2h10c1.105 0 2 .895 2 2s-.895 2-2 2H34c-1.105 0-2-.895-2-2m-4.5-34.5c1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5S25 27.62 25 29s1.12 2.5 2.5 2.5M34 27c-1.105 0-2 .895-2 2s.895 2 2 2h10c1.105 0 2-.895 2-2s-.895-2-2-2z"
        })
    });
const $a22fc886b325db52$var$$20980ef1af485d32$var$ForwardRef = (0, $eF4cA.forwardRef)($a22fc886b325db52$var$$20980ef1af485d32$var$SvgComponent);
var $a22fc886b325db52$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($a22fc886b325db52$var$$20980ef1af485d32$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $654ac17f5257a375$var$$6b4aa5f72ce3f94c$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M14 10.25c-2.623 0-4.75 2.127-4.75 4.75s2.127 4.75 4.75 4.75h20c2.623 0 4.75-2.127 4.75-4.75s-2.127-4.75-4.75-4.75zm20 12h-8.75v3.5H34c4.004 0 7.25 3.246 7.25 7.25s-3.246 7.25-7.25 7.25H14c-4.004 0-7.25-3.246-7.25-7.25s3.246-7.25 7.25-7.25h8.75v-3.5H14c-4.004 0-7.25-3.246-7.25-7.25S9.996 7.75 14 7.75h20c4.004 0 7.25 3.246 7.25 7.25s-3.246 7.25-7.25 7.25m-10 6H14c-2.623 0-4.75 2.127-4.75 4.75s2.127 4.75 4.75 4.75h20c2.623 0 4.75-2.127 4.75-4.75s-2.127-4.75-4.75-4.75zM15.5 15c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5 1.5.672 1.5 1.5M14 34.5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5m4-20.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25zM16.75 33c0-.69.56-1.25 1.25-1.25h5c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25h-5c-.69 0-1.25-.56-1.25-1.25"
        })
    });
const $654ac17f5257a375$var$$6b4aa5f72ce3f94c$var$ForwardRef = (0, $eF4cA.forwardRef)($654ac17f5257a375$var$$6b4aa5f72ce3f94c$var$SvgComponent);
var $654ac17f5257a375$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($654ac17f5257a375$var$$6b4aa5f72ce3f94c$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7ba0028f406a9726$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $ac17ca43e2805bbc$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $654ac17f5257a375$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $a22fc886b325db52$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}




var $5IZkx = parcelRequire("5IZkx");

var $dqZbZ = parcelRequire("dqZbZ");

var $eF4cA = parcelRequire("eF4cA");

var $3ur2P = parcelRequire("3ur2P");
//#region src/hydration.ts
/**
* Reads the value of a promise synchronously if it has already resolved, e.g. a thenable that
* resolves within its `then` call.
* @param promise - The promise to read.
* @returns An object with the resolved `data`, or `undefined` if the promise hasn't resolved
* synchronously (or resolved with `undefined`).
*/ function $16824955a607fa89$var$tryResolveSync(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, $3ur2P.noop))?.catch?.((0, $3ur2P.noop));
    if (data !== void 0) return {
        data: data
    };
}
/**
* Dehydrates a single `Mutation` into a serializable snapshot of its key, state, scope, and meta.
* @param mutation - The mutation to dehydrate.
* @returns The dehydrated mutation.
*/ function $16824955a607fa89$var$dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state,
        ...mutation.options.scope && {
            scope: mutation.options.scope
        },
        ...mutation.meta && {
            meta: mutation.meta
        }
    };
}
/**
* Prepares the in-flight promise of a pending query for dehydration: applies `serializeData` to its
* result, and redacts its rejection error unless `shouldRedactErrors` returns `false` for it.
* @param query - The pending query whose promise is dehydrated.
* @param serializeData - Optional transform applied to the resolved data.
* @param shouldRedactErrors - Optional predicate; if it returns `false` for the rejection error,
* that
* error is kept as-is instead of being redacted.
* @returns The transformed promise, or `undefined` if the query has no in-flight promise.
*/ function $16824955a607fa89$var$dehydratePromise(query, serializeData, shouldRedactErrors) {
    const promise = query.promise?.then(serializeData).catch((error)=>{
        if (shouldRedactErrors?.(error) === false) return Promise.reject(error);
        if ("production" !== "production") console.error(`A query that was dehydrated as pending ended up rejecting. [${query.queryHash}]: ${error}; The error will be redacted in production builds`);
        return Promise.reject(/* @__PURE__ */ new Error("redacted"));
    });
    promise?.catch((0, $3ur2P.noop));
    return promise;
}
/**
* Dehydrates a single `Query` into a serializable `DehydratedQuery` snapshot. Note that most query config (e.g.
* `queryFn`, `staleTime`) is not dehydrated but instead meant to be configured again when consuming the
* de/rehydrated data, typically with `useQuery` on the client. If the query is still `pending`, its in-flight
* promise is dehydrated too so it can be resumed on the other side instead of re-fetched.
* @param query - The query to dehydrate.
* @param serializeData - Optional transform applied to `query.state.data` before it is included in the snapshot.
* @param shouldRedactErrors - Optional predicate; if it returns `false` for the promise's rejection error, that
* error is kept as-is instead of being redacted.
* @returns The dehydrated query.
*/ function $16824955a607fa89$export$528abc11dd0866f3(query, serializeData, shouldRedactErrors) {
    return {
        dehydratedAt: Date.now(),
        state: {
            ...query.state,
            ...query.state.data !== void 0 && {
                data: serializeData ? serializeData(query.state.data) : query.state.data
            }
        },
        queryKey: query.queryKey,
        queryHash: query.queryHash,
        ...query.state.status === "pending" && {
            promise: $16824955a607fa89$var$dehydratePromise(query, serializeData, shouldRedactErrors)
        },
        ...query.meta && {
            meta: query.meta
        },
        ...query.queryType && {
            queryType: query.queryType
        }
    };
}
/**
* The default `shouldDehydrateMutation` predicate used by `dehydrate`. Only dehydrates mutations that are
* currently paused (e.g. paused by `networkMode` while offline).
* @param mutation - The mutation to check.
* @returns `true` if the mutation is paused.
*/ function $16824955a607fa89$export$3aa4c2840e01e53(mutation) {
    return mutation.state.isPaused;
}
/**
* The default `shouldDehydrateQuery` predicate used by `dehydrate`. Only dehydrates queries whose status is
* `'success'`.
* @param query - The query to check.
* @returns `true` if the query's status is `'success'`.
*/ function $16824955a607fa89$export$e71bc20295698fa1(query) {
    return query.state.status === "success";
}
/**
* Dehydrates a `QueryClient`'s cache (queries and mutations) into a plain, serializable `DehydratedState`,
* typically to embed in server-rendered markup and later restore into a client-side `QueryClient` via `hydrate`.
* Which queries/mutations are included, and how their data/errors are transformed, is controlled by `options`,
* falling back to the client's `dehydrate` default options, and finally to `defaultShouldDehydrateQuery` /
* `defaultShouldDehydrateMutation`.
* @param client - The client whose cache is dehydrated.
* @param options - Controls which queries and mutations are included and how their data and errors
* are transformed. Each option falls back to the client's `defaultOptions.dehydrate`.
* @returns The dehydrated state, with the included `queries` and `mutations`.
* @example
* ```ts
* const queryClient = new QueryClient()
*
* await queryClient.prefetchQuery({
*   queryKey: ['posts'],
*   queryFn: getPosts,
* })
*
* const dehydratedState = dehydrate(queryClient)
* ```
*/ function $16824955a607fa89$export$12aee8bb597e7dfe(client, options = {}) {
    const filterMutation = options.shouldDehydrateMutation ?? client.getDefaultOptions().dehydrate?.shouldDehydrateMutation ?? $16824955a607fa89$export$3aa4c2840e01e53;
    const mutations = client.getMutationCache().getAll().flatMap((mutation)=>filterMutation(mutation) ? [
            $16824955a607fa89$var$dehydrateMutation(mutation)
        ] : []);
    const filterQuery = options.shouldDehydrateQuery ?? client.getDefaultOptions().dehydrate?.shouldDehydrateQuery ?? $16824955a607fa89$export$e71bc20295698fa1;
    const shouldRedactErrors = options.shouldRedactErrors ?? client.getDefaultOptions().dehydrate?.shouldRedactErrors;
    const serializeData = options.serializeData ?? client.getDefaultOptions().dehydrate?.serializeData;
    return {
        mutations: mutations,
        queries: client.getQueryCache().getAll().flatMap((query)=>filterQuery(query) ? [
                $16824955a607fa89$export$528abc11dd0866f3(query, serializeData, shouldRedactErrors)
            ] : [])
    };
}
/**
* Restores a `DehydratedState` (as produced by `dehydrate`) into a `QueryClient`'s cache, typically to seed the
* client with data already fetched on the server. `mutations` and `queries` are each optional on `dehydratedState`.
* Queries not yet in the cache are built from the dehydrated snapshot; queries that already exist are only updated
* when the dehydrated data is newer than what's already cached. Newly built queries have their `fetchStatus` reset
* to `'idle'` so they don't hydrate stuck in a fetching state. If a dehydrated query still had an in-flight
* promise, it is resumed via `query.fetch()` (reusing that promise as `initialPromise`) rather than re-invoking
* `queryFn`.
* @param client - The client whose cache is restored into.
* @param dehydratedState - The dehydrated state, e.g. produced by `dehydrate` on the server.
* @param options - `defaultOptions` merged into every restored query and mutation (on top of the
* client's `defaultOptions.hydrate`), and `deserializeData` to reverse `serializeData`.
* @example
* ```ts
* // dehydratedState was produced by `dehydrate` on the server
* // and sent to the client, e.g. embedded in server-rendered markup.
* const queryClient = new QueryClient()
*
* hydrate(queryClient, dehydratedState)
* ```
*/ function $16824955a607fa89$export$fa8d919ba61d84db(client, dehydratedState, options) {
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache();
    const deserializeData = options?.defaultOptions?.deserializeData ?? client.getDefaultOptions().hydrate?.deserializeData;
    dehydratedState.mutations?.forEach(({ state: state, ...mutationOptions })=>{
        mutationCache.build(client, {
            ...client.getDefaultOptions().hydrate?.mutations,
            ...options?.defaultOptions?.mutations,
            ...mutationOptions
        }, state);
    });
    dehydratedState.queries?.forEach(({ queryKey: queryKey, state: state, queryHash: queryHash, meta: meta, promise: promise, dehydratedAt: dehydratedAt, queryType: queryType })=>{
        const syncData = promise ? $16824955a607fa89$var$tryResolveSync(promise) : void 0;
        const rawData = state.data === void 0 ? syncData?.data : state.data;
        const data = rawData === void 0 ? rawData : deserializeData ? deserializeData(rawData) : rawData;
        let query = queryCache.get(queryHash);
        const existingQueryIsPending = query?.state.status === "pending";
        const existingQueryIsFetching = query?.state.fetchStatus === "fetching";
        if (query) {
            const hasNewerSyncData = syncData && dehydratedAt > query.state.dataUpdatedAt;
            if (state.dataUpdatedAt > query.state.dataUpdatedAt || hasNewerSyncData) {
                const { fetchStatus: _ignored, ...serializedState } = state;
                query.setState({
                    ...serializedState,
                    data: data,
                    ...state.status === "pending" && data !== void 0 && {
                        status: "success",
                        dataUpdatedAt: dehydratedAt,
                        ...!existingQueryIsFetching && {
                            fetchStatus: "idle"
                        }
                    }
                });
            }
        } else query = queryCache.build(client, {
            ...client.getDefaultOptions().hydrate?.queries,
            ...options?.defaultOptions?.queries,
            queryKey: queryKey,
            queryHash: queryHash,
            meta: meta,
            _type: queryType
        }, {
            ...state,
            data: data,
            fetchStatus: "idle",
            status: state.status === "pending" && data !== void 0 ? "success" : state.status,
            ...state.status === "pending" && data !== void 0 && {
                dataUpdatedAt: dehydratedAt
            }
        });
        if (promise && !syncData && !existingQueryIsPending && !existingQueryIsFetching && dehydratedAt > query.state.dataUpdatedAt) query.fetch(void 0, {
            initialPromise: Promise.resolve(promise).then(deserializeData)
        }).catch((0, $3ur2P.noop));
    });
}


//#region src/persist.ts
const $208f27f84b910226$var$cacheEventTypes = [
    "added",
    "removed",
    "updated"
];
/**
* Checks if emitted event is about cache change and not about observers.
* Useful for persist, where we only want to trigger save when cache is changed.
* @param eventType - The type of the emitted event.
* @returns `true` if the event is `'added'`, `'removed'`, or `'updated'`.
*/ function $208f27f84b910226$var$isCacheEventType(eventType) {
    return $208f27f84b910226$var$cacheEventTypes.includes(eventType);
}
/**
* Restores persisted data to the QueryCache.
*  - data obtained from persister.restoreClient.
*  - data is hydrated using hydrateOptions.
* If data is expired, busted, empty, or throws, it runs persister.removeClient.
* @param options - The `queryClient` to restore into, the `persister`, and the `maxAge`, `buster`,
* and `hydrateOptions` that decide whether and how the persisted data is restored.
* @returns A promise that resolves once the data is restored or removed. If restoring throws, it
* attempts to remove the persisted data and then rejects with the restore error, or with the removal
* error if the removal fails too.
*/ async function $208f27f84b910226$export$781eb0ebad7272a1({ queryClient: queryClient, persister: persister, maxAge: maxAge = 864e5, buster: buster = "", hydrateOptions: hydrateOptions }) {
    try {
        const persistedClient = await persister.restoreClient();
        if (persistedClient) {
            if (persistedClient.timestamp) {
                const expired = Date.now() - persistedClient.timestamp > maxAge;
                const busted = persistedClient.buster !== buster;
                if (expired || busted) return persister.removeClient();
                else (0, $16824955a607fa89$export$fa8d919ba61d84db)(queryClient, persistedClient.clientState, hydrateOptions);
            } else return persister.removeClient();
        }
    } catch (err) {
        await persister.removeClient();
        throw err;
    }
}
/**
* Persists data from the QueryCache.
*  - data dehydrated using dehydrateOptions.
*  - data is persisted using persister.persistClient.
* @param options - The `queryClient` to persist, the `persister`, the `buster`, and the
* `dehydrateOptions`.
*/ async function $208f27f84b910226$export$8a3b4786a14f2528({ queryClient: queryClient, persister: persister, buster: buster = "", dehydrateOptions: dehydrateOptions }) {
    const persistClient = {
        buster: buster,
        timestamp: Date.now(),
        clientState: (0, $16824955a607fa89$export$12aee8bb597e7dfe)(queryClient, dehydrateOptions)
    };
    await persister.persistClient(persistClient);
}
/**
* Subscribe to QueryCache and MutationCache updates (for persisting).
* @param props - The `queryClient` to monitor, the `persister`, the `buster`, and the
* `dehydrateOptions` used for each save.
* @returns an unsubscribe function (to discontinue monitoring)
*/ function $208f27f84b910226$export$9fe01d80627be88c(props) {
    const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe((event)=>{
        if ($208f27f84b910226$var$isCacheEventType(event.type)) $208f27f84b910226$export$8a3b4786a14f2528(props);
    });
    const unsubscribeMutationCache = props.queryClient.getMutationCache().subscribe((event)=>{
        if ($208f27f84b910226$var$isCacheEventType(event.type)) $208f27f84b910226$export$8a3b4786a14f2528(props);
    });
    return ()=>{
        unsubscribeQueryCache();
        unsubscribeMutationCache();
    };
}
/**
* Restores persisted data to QueryCache and persists further changes.
* @param props - The options for both restoring and saving.
* @returns A tuple of a function that stops persisting, and a promise that resolves once the
* restore is done.
*/ function $208f27f84b910226$export$217ab42a80f50b3b(props) {
    let hasUnsubscribed = false;
    let persistQueryClientUnsubscribe;
    const unsubscribe = ()=>{
        hasUnsubscribed = true;
        persistQueryClientUnsubscribe?.();
    };
    return [
        unsubscribe,
        $208f27f84b910226$export$781eb0ebad7272a1(props).then(()=>{
            if (!hasUnsubscribed) persistQueryClientUnsubscribe = $208f27f84b910226$export$9fe01d80627be88c(props);
        })
    ];
}



var $8UjFd = parcelRequire("8UjFd");
var $7ClmI = parcelRequire("7ClmI");

var $dx4lB = parcelRequire("dx4lB");
"use client";
//#region src/PersistQueryClientProvider.tsx
/**
* Provides the `QueryClient` like `QueryClientProvider`, and restores the persisted client first:
* while restoring, `useIsRestoring` returns `true` and queries wait for the restore to finish
* before subscribing. Once restored, the client is saved with the persister whenever the cache
* changes.
* @param props - The `QueryClientProvider` props, the `persistOptions`, and the `onSuccess` and
* `onError` callbacks. `onSuccess` is called once restoring finishes, even if nothing was restored
* (e.g. because the persisted client expired), and `onError` if restoring or `onSuccess` throws.
* @returns The `QueryClientProvider` wrapping the children.
*/ const $70d036432997ba9c$export$9d736f54481e482f = ({ children: children, persistOptions: persistOptions, onSuccess: onSuccess, onError: onError, ...props })=>{
    const [isRestoring, setIsRestoring] = $eF4cA.useState(true);
    const optionsRef = $eF4cA.useRef({
        persistOptions: persistOptions,
        onSuccess: onSuccess,
        onError: onError
    });
    const didRestoreRef = $eF4cA.useRef(false);
    $eF4cA.useEffect(()=>{
        optionsRef.current = {
            persistOptions: persistOptions,
            onSuccess: onSuccess,
            onError: onError
        };
    });
    $eF4cA.useEffect(()=>{
        const options = {
            ...optionsRef.current.persistOptions,
            queryClient: props.client
        };
        if (!didRestoreRef.current) {
            didRestoreRef.current = true;
            (0, $208f27f84b910226$export$781eb0ebad7272a1)(options).then(()=>optionsRef.current.onSuccess?.()).catch(()=>optionsRef.current.onError?.()).finally(()=>{
                setIsRestoring(false);
            });
        }
        return isRestoring ? void 0 : (0, $208f27f84b910226$export$9fe01d80627be88c)(options);
    }, [
        props.client,
        isRestoring
    ]);
    return /* @__PURE__ */ (0, $dx4lB.jsx)((0, $7ClmI.QueryClientProvider), {
        ...props,
        children: /* @__PURE__ */ (0, $dx4lB.jsx)((0, $8UjFd.IsRestoringProvider), {
            value: isRestoring,
            children: children
        })
    });
};



var $fmJ8d = parcelRequire("fmJ8d");

var $1B1zl = parcelRequire("1B1zl");

var $dx4lB = parcelRequire("dx4lB");

var $8u8Xx = parcelRequire("8u8Xx");

var $dqZbZ = parcelRequire("dqZbZ");

var $5IZkx = parcelRequire("5IZkx");

var $fmJ8d = parcelRequire("fmJ8d");

var $dSkgb = parcelRequire("dSkgb");

var $4kcQz = parcelRequire("4kcQz");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $359f43c4fdc6cdef$export$d07d333e24835627 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/alerts"]);
const $359f43c4fdc6cdef$export$f7b1e2075b3da718 = async (options = {})=>{
    const response = await $359f43c4fdc6cdef$export$d07d333e24835627.get("", {}, options);
    if (!response.ok) throw new Error("Failed to fetch alerts", {
        cause: response
    });
    return response.data?.alerts ?? [];
};


const $1b214b7de04dc547$export$5190ebb7bea2fe30 = ()=>{
    return (0, $4kcQz.useQuery)({
        queryKey: [
            "alerts"
        ],
        queryFn: async ({ signal: signal })=>{
            try {
                return await (0, $359f43c4fdc6cdef$export$f7b1e2075b3da718)({
                    signal: signal
                });
            } catch (error) {
                return [];
            }
        },
        refetchInterval: 1800000,
        refetchOnWindowFocus: true,
        staleTime: 0,
        gcTime: 300000
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $l19Vn = parcelRequire("l19Vn");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $5nTep = parcelRequire("5nTep");
var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $8bb28521b6897537$var$$c235b1bd24a265f2$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.75 2h-8C7.507 2 6.5 3.007 6.5 4.25v.5c0 .414.336.75.75.75S8 5.164 8 4.75v-.5c0-.413.337-.75.75-.75h8c.413 0 .75.338.75.75v4.5c0 .413-.337.75-.75.75H16c-.414 0-.75.336-.75.75v1.651L13.5 10.36V9.25C13.5 8.007 12.493 7 11.25 7h-8C2.007 7 1 8.007 1 9.25v4.5C1 14.99 2.01 16 3.25 16v2.137c0 .383.228.723.58.869q.182.073.365.072c.239 0 .466-.089.618-.245L8.033 16h3.217c1.243 0 2.25-1.007 2.25-2.25v-1.393l1.64 1.444c.18.18.42.275.665.275.122 0 .246-.023.364-.072.352-.147.581-.486.581-.867V11C17.99 11 19 9.99 19 8.75v-4.5C19 3.007 17.993 2 16.75 2M12 13.75c0 .413-.337.75-.75.75H7.467L4.75 16.894V15.25c0-.414-.336-.75-.75-.75h-.75c-.412 0-.75-.337-.75-.75v-4.5c0-.412.338-.75.75-.75h8c.413 0 .75.338.75.75z"
        })
    });
const $8bb28521b6897537$var$$c235b1bd24a265f2$var$ForwardRef = (0, $eF4cA.forwardRef)($8bb28521b6897537$var$$c235b1bd24a265f2$var$SvgComponent);
var $8bb28521b6897537$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($8bb28521b6897537$var$$c235b1bd24a265f2$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $47731b42bd727f9a$var$$6e60e0f43c23b93f$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M6.179 18.822c-.193 0-.384-.073-.53-.22-.294-.292-.294-.768 0-1.06l.938-.938c.293-.293.768-.291 1.06 0 .293.293.293.769 0 1.061l-.938.938c-.146.146-.339.22-.53.22M1.918 14.603c-.192 0-.384-.074-.53-.22-.293-.293-.293-.769 0-1.06l.938-.938c.294-.294.769-.292 1.06 0 .294.293.294.768 0 1.06l-.938.938c-.146.146-.339.22-.53.22M2.498 18.252c-.191 0-.383-.072-.53-.218-.292-.293-.294-.767-.002-1.061l2.496-2.51c.294-.292.767-.295 1.061-.003.293.293.295.768.003 1.061l-2.496 2.51c-.147.147-.34.221-.532.221M18.18 1.662c-.637-.585-1.576-.788-2.782-.611-2.324.344-4.172 1.61-5.656 3.02C9.37 4.028 8.995 4 8.65 4c-2.987.03-5.756 1.648-7.409 4.333-.305.496-.32 1.118-.035 1.621.282.5.792.796 1.36.796h2.803c.087.512.329.997.712 1.38l1.79 1.79c.387.388.872.624 1.38.711v2.782c-.005.581.292 1.098.796 1.382.241.136.51.204.78.204.29 0 .583-.08.842-.24 2.684-1.652 4.303-4.421 4.332-7.408.003-.362-.026-.732-.072-1.102.071-.075.154-.15.222-.225 1.552-1.68 2.461-3.406 2.78-5.277.231-1.36-.029-2.426-.75-3.085M5.79 8.84c-.077.111-.14.225-.198.344l-.003.005c-.01.02-.015.041-.024.061H2.624c-.08 0-.13-.09-.09-.157 1.282-2.089 3.487-3.455 5.824-3.57-.106.122-.218.246-.32.366-.72.851-1.476 1.843-2.248 2.95m5.118 8.622c-.068.042-.158-.01-.158-.088v-2.936c.141-.064.28-.137.411-.229 1.286-.896 2.372-1.748 3.317-2.58-.117 2.342-1.465 4.53-3.57 5.833M17.45 4.495c-.268 1.576-1.054 3.052-2.402 4.512-1.16 1.255-2.711 2.554-4.745 3.972-.43.3-1.006.248-1.373-.12l-1.79-1.79c-.32-.32-.402-.811-.203-1.224q.036-.078.083-.149c.745-1.067 1.472-2.022 2.162-2.839 1.612-1.905 3.636-3.909 6.434-4.322.51-.076 1.192-.096 1.55.234.435.397.364 1.252.284 1.726"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M14.5 6.75c0 .69-.56 1.25-1.25 1.25S12 7.44 12 6.75s.56-1.25 1.25-1.25 1.25.56 1.25 1.25"
            })
        ]
    });
const $47731b42bd727f9a$var$$6e60e0f43c23b93f$var$ForwardRef = (0, $eF4cA.forwardRef)($47731b42bd727f9a$var$$6e60e0f43c23b93f$var$SvgComponent);
var $47731b42bd727f9a$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($47731b42bd727f9a$var$$6e60e0f43c23b93f$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");


var $4W5AG = parcelRequire("4W5AG");

var $hxsf4 = parcelRequire("hxsf4");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a7cefafcf198d8a2$var$$8b0a29919990739e$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.75 5h-5.964c-.218 0-.424-.094-.566-.259L8.516 2.777C8.089 2.283 7.47 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M3.25 3.5h3.565c.218 0 .424.094.567.259L8.459 5H2.5v-.75c0-.413.337-.75.75-.75M17.5 14.75c0 .413-.337.75-.75.75H3.25c-.413 0-.75-.337-.75-.75V6.5h14.25c.413 0 .75.337.75.75z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 13.65c-.192 0-.384-.073-.53-.22l-3-3c-.293-.292-.293-.767 0-1.06s.767-.293 1.06 0L10 11.84l2.47-2.47c.293-.293.767-.293 1.06 0s.293.768 0 1.06l-3 3c-.146.147-.338.22-.53.22"
            })
        ]
    });
const $a7cefafcf198d8a2$var$$8b0a29919990739e$var$ForwardRef = (0, $eF4cA.forwardRef)($a7cefafcf198d8a2$var$$8b0a29919990739e$var$SvgComponent);
var $a7cefafcf198d8a2$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($a7cefafcf198d8a2$var$$8b0a29919990739e$var$ForwardRef);



var $fL4LX = parcelRequire("fL4LX");

var $8wD3p = parcelRequire("8wD3p");

var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $k8kxd = parcelRequire("k8kxd");

var $fVfXf = parcelRequire("fVfXf");
var $9c105a28dc61564b$export$2e2bcd8739ae039 = {};
$9c105a28dc61564b$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{648}\u{627}\u{62C}\u{647}\u{629}`
};


var $d52dd15c8d9c9f50$export$2e2bcd8739ae039 = {};
$d52dd15c8d9c9f50$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{422}\u{440}\u{43E}\u{445}\u{438} \u{445}\u{43B}\u{44F}\u{431}`
};


var $ee0e09d3093b641a$export$2e2bcd8739ae039 = {};
$ee0e09d3093b641a$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Popis cesty`
};


var $786dc1d17c178c4e$export$2e2bcd8739ae039 = {};
$786dc1d17c178c4e$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Br\xf8dkrummer`
};


var $6858cc539077fbbf$export$2e2bcd8739ae039 = {};
$6858cc539077fbbf$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Breadcrumbs`
};


var $065f4141299301b6$export$2e2bcd8739ae039 = {};
$065f4141299301b6$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{3A0}\u{3BB}\u{3BF}\u{3B7}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3B9}\u{3C2} breadcrumb`
};


var $8cee251f49ebdfd1$export$2e2bcd8739ae039 = {};
$8cee251f49ebdfd1$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Breadcrumbs`
};


var $dec30b060ed34708$export$2e2bcd8739ae039 = {};
$dec30b060ed34708$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Migas de pan`
};


var $c9abfcb3b02e99e7$export$2e2bcd8739ae039 = {};
$c9abfcb3b02e99e7$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Lingiread`
};


var $8c42fceee635438e$export$2e2bcd8739ae039 = {};
$8c42fceee635438e$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Navigointilinkit`
};


var $5d3f2024b4f2b080$export$2e2bcd8739ae039 = {};
$5d3f2024b4f2b080$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Chemin de navigation`
};


var $3e3ee2cb38ea21b0$export$2e2bcd8739ae039 = {};
$3e3ee2cb38ea21b0$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{5E9}\u{5D1}\u{5D9}\u{5DC}\u{5D9} \u{5E0}\u{5D9}\u{5D5}\u{5D5}\u{5D8}`
};


var $72cdd87eeacdd29e$export$2e2bcd8739ae039 = {};
$72cdd87eeacdd29e$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Navigacijski putovi`
};


var $682debb9f955c681$export$2e2bcd8739ae039 = {};
$682debb9f955c681$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Morzsamen\xfc`
};


var $a9949a7414fa6155$export$2e2bcd8739ae039 = {};
$a9949a7414fa6155$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Breadcrumb`
};


var $263cadd32ac81d15$export$2e2bcd8739ae039 = {};
$263cadd32ac81d15$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{30D1}\u{30F3}\u{304F}\u{305A}\u{30EA}\u{30B9}\u{30C8}`
};


var $80fac96d7b67f5f7$export$2e2bcd8739ae039 = {};
$80fac96d7b67f5f7$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{D0D0}\u{C0C9} \u{D45C}\u{C2DC}`
};


var $36607c0a79affeec$export$2e2bcd8739ae039 = {};
$36607c0a79affeec$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Nar\u{161}ymo kelias`
};


var $b29bfba13d1e7298$export$2e2bcd8739ae039 = {};
$b29bfba13d1e7298$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Atpaka\u{13C}ce\u{13C}i`
};


var $937333291ded320f$export$2e2bcd8739ae039 = {};
$937333291ded320f$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Navigasjonsstier`
};


var $b2b82c26d422cd80$export$2e2bcd8739ae039 = {};
$b2b82c26d422cd80$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Broodkruimels`
};


var $1f7fa7bfbe3fcf1a$export$2e2bcd8739ae039 = {};
$1f7fa7bfbe3fcf1a$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Struktura nawigacyjna`
};


var $3394d236b7a9a3ab$export$2e2bcd8739ae039 = {};
$3394d236b7a9a3ab$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Caminho detalhado`
};


var $e2988d3833dccb44$export$2e2bcd8739ae039 = {};
$e2988d3833dccb44$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Categorias`
};


var $1eac30d6121ba3f7$export$2e2bcd8739ae039 = {};
$1eac30d6121ba3f7$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Miez de p\xe2ine`
};


var $d27601f00ac7bee0$export$2e2bcd8739ae039 = {};
$d27601f00ac7bee0$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{44F}`
};


var $b164f49e1bff1adc$export$2e2bcd8739ae039 = {};
$b164f49e1bff1adc$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Naviga\u{10D}n\xe9 prvky Breadcrumbs`
};


var $44047ab6bd1aaefe$export$2e2bcd8739ae039 = {};
$44047ab6bd1aaefe$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Drobtine`
};


var $7e6acef2cd09212a$export$2e2bcd8739ae039 = {};
$7e6acef2cd09212a$export$2e2bcd8739ae039 = {
    "breadcrumbs": `Putanje navigacije`
};


var $e8b8f9ff51845665$export$2e2bcd8739ae039 = {};
$e8b8f9ff51845665$export$2e2bcd8739ae039 = {
    "breadcrumbs": `S\xf6kv\xe4gar`
};


var $e6f4557565f35b85$export$2e2bcd8739ae039 = {};
$e6f4557565f35b85$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{130}\xe7erik haritalar\u{131}`
};


var $4366e054394f5230$export$2e2bcd8739ae039 = {};
$4366e054394f5230$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{456}\u{433}\u{430}\u{446}\u{456}\u{439}\u{43D}\u{430} \u{441}\u{442}\u{435}\u{436}\u{43A}\u{430}`
};


var $1c5187ff27dcebac$export$2e2bcd8739ae039 = {};
$1c5187ff27dcebac$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{5BFC}\u{822A}\u{680F}`
};


var $bbd383c9c965b142$export$2e2bcd8739ae039 = {};
$bbd383c9c965b142$export$2e2bcd8739ae039 = {
    "breadcrumbs": `\u{5C0E}\u{89BD}\u{5217}`
};


var $c43143323de63ffe$export$2e2bcd8739ae039 = {};
$c43143323de63ffe$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $9c105a28dc61564b$export$2e2bcd8739ae039),
    "bg-BG": (0, $d52dd15c8d9c9f50$export$2e2bcd8739ae039),
    "cs-CZ": (0, $ee0e09d3093b641a$export$2e2bcd8739ae039),
    "da-DK": (0, $786dc1d17c178c4e$export$2e2bcd8739ae039),
    "de-DE": (0, $6858cc539077fbbf$export$2e2bcd8739ae039),
    "el-GR": (0, $065f4141299301b6$export$2e2bcd8739ae039),
    "en-US": (0, $8cee251f49ebdfd1$export$2e2bcd8739ae039),
    "es-ES": (0, $dec30b060ed34708$export$2e2bcd8739ae039),
    "et-EE": (0, $c9abfcb3b02e99e7$export$2e2bcd8739ae039),
    "fi-FI": (0, $8c42fceee635438e$export$2e2bcd8739ae039),
    "fr-FR": (0, $5d3f2024b4f2b080$export$2e2bcd8739ae039),
    "he-IL": (0, $3e3ee2cb38ea21b0$export$2e2bcd8739ae039),
    "hr-HR": (0, $72cdd87eeacdd29e$export$2e2bcd8739ae039),
    "hu-HU": (0, $682debb9f955c681$export$2e2bcd8739ae039),
    "it-IT": (0, $a9949a7414fa6155$export$2e2bcd8739ae039),
    "ja-JP": (0, $263cadd32ac81d15$export$2e2bcd8739ae039),
    "ko-KR": (0, $80fac96d7b67f5f7$export$2e2bcd8739ae039),
    "lt-LT": (0, $36607c0a79affeec$export$2e2bcd8739ae039),
    "lv-LV": (0, $b29bfba13d1e7298$export$2e2bcd8739ae039),
    "nb-NO": (0, $937333291ded320f$export$2e2bcd8739ae039),
    "nl-NL": (0, $b2b82c26d422cd80$export$2e2bcd8739ae039),
    "pl-PL": (0, $1f7fa7bfbe3fcf1a$export$2e2bcd8739ae039),
    "pt-BR": (0, $3394d236b7a9a3ab$export$2e2bcd8739ae039),
    "pt-PT": (0, $e2988d3833dccb44$export$2e2bcd8739ae039),
    "ro-RO": (0, $1eac30d6121ba3f7$export$2e2bcd8739ae039),
    "ru-RU": (0, $d27601f00ac7bee0$export$2e2bcd8739ae039),
    "sk-SK": (0, $b164f49e1bff1adc$export$2e2bcd8739ae039),
    "sl-SI": (0, $44047ab6bd1aaefe$export$2e2bcd8739ae039),
    "sr-SP": (0, $7e6acef2cd09212a$export$2e2bcd8739ae039),
    "sv-SE": (0, $e8b8f9ff51845665$export$2e2bcd8739ae039),
    "tr-TR": (0, $e6f4557565f35b85$export$2e2bcd8739ae039),
    "uk-UA": (0, $4366e054394f5230$export$2e2bcd8739ae039),
    "zh-CN": (0, $1c5187ff27dcebac$export$2e2bcd8739ae039),
    "zh-TW": (0, $bbd383c9c965b142$export$2e2bcd8739ae039)
};



var $gI8Gw = parcelRequire("gI8Gw");
function $e1f9160de350db5b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e1f9160de350db5b$export$8cefe241bd876ca0(props) {
    let { 'aria-label': ariaLabel, ...otherProps } = props;
    let strings = (0, $gI8Gw.useLocalizedStringFormatter)($e1f9160de350db5b$var$$parcel$interopDefault((0, $c43143323de63ffe$export$2e2bcd8739ae039)), '@react-aria/breadcrumbs');
    return {
        navProps: {
            ...(0, $fVfXf.filterDOMProps)(otherProps, {
                labelable: true
            }),
            'aria-label': ariaLabel || strings.format('breadcrumbs')
        }
    };
}



var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $bWhaY = parcelRequire("bWhaY");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $52a4ce187ade7aed$export$65596d3621b0a4a0 = (0, $eF4cA.createContext)(null);
const $52a4ce187ade7aed$export$2dc68d50d56fbbd = (0, $eF4cA.forwardRef)(function Breadcrumbs(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $52a4ce187ade7aed$export$65596d3621b0a4a0);
    let { CollectionRoot: CollectionRoot } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { navProps: navProps } = (0, $e1f9160de350db5b$export$8cefe241bd876ca0)(props);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true,
        labelable: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).ol, {
            render: props.render,
            ref: ref,
            ...(0, $lhKAD.mergeProps)(DOMProps, navProps),
            slot: props.slot || undefined,
            style: props.style,
            className: props.className ?? 'react-aria-Breadcrumbs'
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($52a4ce187ade7aed$export$65596d3621b0a4a0.Provider, {
            value: props
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
            collection: collection
        }))));
});
class $52a4ce187ade7aed$var$$65dbe90f868fa5f4$var$BreadcrumbNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'item';
    }
}
const $52a4ce187ade7aed$export$dabcc1ec9dd9d1cc = (0, $3g2oV.createLeafComponent)($52a4ce187ade7aed$var$$65dbe90f868fa5f4$var$BreadcrumbNode, function Breadcrumb(props, ref, node) {
    // Recreating useBreadcrumbItem because we want to use composition instead of having the link builtin.
    let isCurrent = node.nextKey == null;
    let { isDisabled: isDisabled, onAction: onAction } = (0, $fDYaM.useSlottedContext)($52a4ce187ade7aed$export$65596d3621b0a4a0);
    let linkProps = {
        'aria-current': isCurrent ? 'page' : undefined,
        isDisabled: isDisabled || isCurrent,
        onPress: ()=>onAction?.(node.key)
    };
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...node.props,
        children: node.rendered,
        values: {
            isDisabled: isDisabled || isCurrent,
            isCurrent: isCurrent
        },
        defaultClassName: 'react-aria-Breadcrumb'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true,
        labelable: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).li, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        "data-disabled": isDisabled || isCurrent || undefined,
        "data-current": isCurrent || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $k8kxd.LinkContext).Provider, {
        value: linkProps
    }, renderProps.children));
});



var $8dzVy = parcelRequire("8dzVy");

var $fDYaM = parcelRequire("fDYaM");

var $1O9kP = parcelRequire("1O9kP");

var $gF3YT = parcelRequire("gF3YT");

var $k8kxd = parcelRequire("k8kxd");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $f9wnx = parcelRequire("f9wnx");
function $ddbbd506c05279f5$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$MIN_VISIBLE_ITEMS = 1;
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$MAX_VISIBLE_ITEMS = 4;
const $ddbbd506c05279f5$export$65596d3621b0a4a0 = (0, $eF4cA.createContext)(null);
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let flexGrow = false;
    let flexShrink = false;
    let flexBasis = false;
    let marginTop = false;
    let marginBottom = false;
    let marginInlineStart = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_s") flexBasis = true;
        if (p[1] === "J") marginTop = true;
        if (p[1] === "G") marginBottom = true;
        if (p[1] === "I") marginInlineStart = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc182';
    rules += ' sd182';
    rules += ' _Cg182';
    rules += ' _Gc182';
    rules += ' _wa182';
    if (!flexGrow) rules += ' _ub182';
    if (!flexShrink) rules += ' _va182';
    if (!flexBasis) rules += ' _sb182';
    if (props.size === "L") rules += ' Urun3rd182';
    else if (props.size === "M") rules += ' UssxDec182';
    if (props.size === "L") rules += ' qrun3rd182';
    else if (props.size === "M") rules += ' qssxDec182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (!marginTop) rules += ' Jy182';
    if (!marginBottom) rules += ' Gy182';
    if (props.size === "L") {
        if (!marginInlineStart) rules += ' Irun3rd182';
    } else if (props.size === "M") {
        if (!marginInlineStart) rules += ' IssxDec182';
    }
    return rules;
};
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$InternalBreadcrumbsContext = (0, $eF4cA.createContext)({});
const $ddbbd506c05279f5$export$2dc68d50d56fbbd = (0, $eF4cA.forwardRef)(function Breadcrumbs(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $ddbbd506c05279f5$export$65596d3621b0a4a0);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles, size: size = 'M', children: children, isDisabled: isDisabled, ...otherProps } = props;
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$InternalBreadcrumbsContext,
                {
                    size: size,
                    isDisabled: isDisabled
                }
            ]
        ],
        children: (0, $dx4lB.jsx)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapsingCollection, {
            containerRef: domRef,
            onAction: props.onAction,
            children: (0, $dx4lB.jsx)((0, $52a4ce187ade7aed$export$2dc68d50d56fbbd), {
                ...otherProps,
                isDisabled: isDisabled,
                ref: domRef,
                style: UNSAFE_style,
                className: UNSAFE_className + $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$wrapper({
                    size: size
                }, styles),
                children: children
            })
        })
    });
});
let $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$BreadcrumbMenu = (props)=>{
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($ddbbd506c05279f5$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { items: items, onAction: onAction } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { size: size, isDisabled: isDisabled } = (0, $eF4cA.useContext)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$InternalBreadcrumbsContext);
    let label = stringFormatter.format('breadcrumbs.more');
    return (0, $dx4lB.jsx)((0, $8dzVy.CollectionRendererContext).Provider, {
        value: (0, $8dzVy.DefaultCollectionRenderer),
        children: (0, $dx4lB.jsxs)("li", {
            className: $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$breadcrumbStyles({
                size: size,
                isDisabled: isDisabled,
                isMenu: true
            }),
            children: [
                (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                    children: [
                        (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            isDisabled: isDisabled,
                            isQuiet: true,
                            "aria-label": label,
                            children: (0, $dx4lB.jsx)((0, $a7cefafcf198d8a2$export$2e2bcd8739ae039), {})
                        }),
                        (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                            items: items,
                            onAction: onAction,
                            children: (item)=>(0, $eF4cA.createElement)((0, $8wD3p.MenuItem), {
                                    ...item.props.originalProps,
                                    key: item.key
                                }, (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    slot: "label",
                                    children: item.props.children({
                                        size: size,
                                        isCurrent: false,
                                        isMenu: true
                                    })
                                }))
                        })
                    ]
                }),
                (0, $dx4lB.jsx)((0, $hxsf4.default), {
                    size: size,
                    className: $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$chevronStyles({
                        direction: direction,
                        isMenu: true
                    })
                })
            ]
        })
    });
};
let $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$HiddenBreadcrumbs = function(props) {
    let { listRef: listRef, items: items, size: size } = props;
    return (0, $dx4lB.jsxs)("div", {
        // @ts-ignore
        inert: (0, $gF3YT.inertValue)(true),
        ref: listRef,
        className: " s40ub4c182 U40ub4c182 q40ub4c182 _w40ub4c182 _Pa182 Wr182 _lr182 _6b182 _Nc182 Pc182 _Ia182",
        children: [
            items.map((item, idx)=>{
                // pull off individual props as an allow list, don't want refs or other props getting through
                return (0, $dx4lB.jsx)("div", {
                    "data-hidden-breadcrumb": true,
                    style: item.props.UNSAFE_style,
                    className: item.props.className({
                        size: size,
                        isCurrent: idx === items.length - 1
                    }),
                    children: item.props.children({
                        size: size,
                        isCurrent: idx === items.length - 1
                    })
                }, item.key);
            }),
            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                "data-hidden-button": true,
                isQuiet: true,
                children: (0, $dx4lB.jsx)((0, $a7cefafcf198d8a2$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$breadcrumbStyles = function anonymous(props) {
    let rules = " ";
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Cg182';
    if (props.size === "XL") rules += ' Fz182';
    else if (props.size === "L") rules += ' Fv182';
    else if (props.size === "S") rules += ' Fp182';
    else if (props.size === "XS") rules += ' Fn182';
    else rules += ' Fx182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _Pc182';
    rules += ' _va182';
    if (props.isDisabled) rules += ' pp182';
    else rules += ' pt182';
    if (props.isDisabled) rules += ' plc182';
    else rules += ' plb182';
    rules += ' _je182';
    if (props.isMenu) rules += ' I34mdr182';
    return rules;
};
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.direction === "rtl") {
        rules += ' -Z4Pn4c-a182';
        rules += ' __Ha182';
    }
    if (props.direction === "rtl") {
        rules += ' -_04Pn4c-a182';
        rules += ' __Ha182';
    }
    if (props.isMenu) rules += ' Iy182';
    else {
        rules += ' It182';
        rules += ' Isu182';
    }
    rules += ' pt182';
    rules += ' plf182';
    rules += ' -_8sjo0b-t5ZbAob182';
    return rules;
};
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$linkStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isCurrent) {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    } else if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' pt182';
        else if (props.isFocusVisible) rules += ' pt182';
        else if (props.isHovered) rules += ' pt182';
        else rules += ' pv182';
    }
    if (props.isCurrent) rules += ' plc182';
    else if (props.isDisabled) rules += ' plc182';
    else rules += ' plf182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isDisabled) rules += ' _Xa182';
    else if (props.isFocusVisible) {
        rules += ' _Xb182';
        rules += ' __Va182';
    } else if (props.isHovered) {
        rules += ' _Xb182';
        rules += ' __Va182';
    } else rules += ' _Xa182';
    if (props.isDisabled) rules += ' ri182';
    else rules += ' ry182';
    rules += ' __ca182';
    return rules;
};
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$currentStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    rules += ' pt182';
    rules += ' plb182';
    return rules;
};
// TODO: support user heading size customization, for now just set it to large
const $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$heading = " Jy182 Gy182 Iy182 Hy182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 _Fd182 _FnuYUweb182 po182";
const $ddbbd506c05279f5$export$dabcc1ec9dd9d1cc = (0, $eF4cA.forwardRef)(function Breadcrumb({ children: children, ...props }, ref) {
    let { href: href, target: target, rel: rel, download: download, ping: ping, referrerPolicy: referrerPolicy } = props;
    let { size: size = 'M' } = (0, $eF4cA.useContext)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$InternalBreadcrumbsContext) ?? {};
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    return (0, $dx4lB.jsx)((0, $52a4ce187ade7aed$export$dabcc1ec9dd9d1cc), {
        ...props,
        ref: domRef,
        // @ts-ignore
        originalProps: props,
        className: ({ isCurrent: isCurrent, isDisabled: isDisabled })=>$ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$breadcrumbStyles({
                size: size,
                isCurrent: isCurrent,
                isDisabled: isDisabled
            }),
        children: ({ isCurrent: isCurrent, isDisabled: isDisabled, isMenu: isMenu })=>{
            if (isMenu) return children;
            return isCurrent ? (0, $dx4lB.jsx)("div", {
                className: $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$currentStyles({
                    size: size
                }),
                children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $1O9kP.HeadingContext),
                            {
                                className: $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$heading
                            }
                        ]
                    ],
                    children: children
                })
            }) : (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $k8kxd.Link), {
                        style: ({ isFocusVisible: isFocusVisible })=>({
                                clipPath: isFocusVisible ? 'none' : 'margin-box'
                            }),
                        href: href,
                        target: target,
                        rel: rel,
                        download: download,
                        ping: ping,
                        referrerPolicy: referrerPolicy,
                        isDisabled: isDisabled || isCurrent,
                        className: ({ isFocused: isFocused, isFocusVisible: isFocusVisible, isHovered: isHovered, isDisabled: isDisabled, isPressed: isPressed })=>$ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$linkStyles({
                                isFocused: isFocused,
                                isFocusVisible: isFocusVisible,
                                isHovered: isHovered,
                                isDisabled: isDisabled,
                                size: size,
                                isPressed: isPressed,
                                isCurrent: isCurrent
                            }),
                        children: children
                    }),
                    (0, $dx4lB.jsx)((0, $hxsf4.default), {
                        size: "M",
                        className: $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$chevronStyles({
                            direction: direction
                        })
                    })
                ]
            });
        }
    });
});
// Context for passing the count for the custom renderer
let $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapseContext = (0, $eF4cA.createContext)(null);
function $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapsingCollection({ children: children, containerRef: containerRef, onAction: onAction }) {
    return (0, $dx4lB.jsx)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapseContext.Provider, {
        value: {
            containerRef: containerRef,
            onAction: onAction
        },
        children: (0, $dx4lB.jsx)((0, $8dzVy.CollectionRendererContext).Provider, {
            value: $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapsingCollectionRenderer,
            children: children
        })
    });
}
let $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapsingCollectionRenderer = {
    CollectionRoot ({ collection: collection }) {
        return $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$useCollectionRender(collection);
    },
    CollectionBranch ({ collection: collection }) {
        return $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$useCollectionRender(collection);
    }
};
let $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$useCollectionRender = (collection)=>{
    let { containerRef: containerRef, onAction: onAction } = (0, $eF4cA.useContext)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$CollapseContext) ?? {};
    let [visibleItems, setVisibleItems] = (0, $eF4cA.useState)(collection.size);
    let { size: size = 'M' } = (0, $eF4cA.useContext)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$InternalBreadcrumbsContext);
    let children = (0, $eF4cA.useMemo)(()=>{
        let result = [];
        for (let key of collection.getKeys())result.push(collection.getItem(key));
        return result;
    }, [
        collection
    ]);
    let listRef = (0, $eF4cA.useRef)(null);
    let updateOverflow = (0, $eF4cA.useCallback)(()=>{
        let currListRef = listRef.current;
        if (!currListRef) {
            setVisibleItems(collection.size);
            return;
        }
        let container = currListRef.parentElement;
        if (!container) {
            setVisibleItems(collection.size);
            return;
        }
        let listItems = Array.from(currListRef.querySelectorAll('[data-hidden-breadcrumb]'));
        let folder = currListRef.querySelector('button');
        if (listItems.length <= 0) {
            setVisibleItems(collection.size);
            return;
        }
        let containerWidth = container.offsetWidth;
        let containerGap = parseInt(getComputedStyle(container).gap, 10);
        let folderGap = parseInt(getComputedStyle(folder).marginInlineStart, 10);
        let newVisibleItems = 0;
        let maxVisibleItems = $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$MAX_VISIBLE_ITEMS;
        let widths = [];
        let totalWidth = 0;
        for (let breadcrumb of listItems){
            let width = breadcrumb.offsetWidth + 1; // offsetWidth is rounded down
            widths.push(width);
            totalWidth += width;
        }
        // can we fit all the items without collapsing
        if (totalWidth <= containerWidth - collection.size * containerGap && collection.size <= $ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$MAX_VISIBLE_ITEMS) {
            setVisibleItems(collection.size);
            return;
        }
        // we know there is always at least one item because of the listItems.length check up above
        let widthOfFirst = widths.shift();
        let availableWidth = containerWidth - widthOfFirst - folderGap - folder.offsetWidth - containerGap;
        maxVisibleItems -= 2; // account for the first item and folder
        for (let width of widths.reverse()){
            availableWidth -= width;
            if (availableWidth <= 0) break;
            availableWidth -= containerGap;
            newVisibleItems++;
        }
        setVisibleItems(Math.max($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$MIN_VISIBLE_ITEMS, Math.min(maxVisibleItems, newVisibleItems)));
    }, [
        collection.size,
        setVisibleItems
    ]);
    (0, $f9wnx.useResizeObserver)({
        ref: containerRef,
        onResize: updateOverflow
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        if (collection.size > 0) queueMicrotask(updateOverflow);
    }, [
        collection.size,
        updateOverflow
    ]);
    (0, $eF4cA.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateOverflow());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let sliceIndex = collection.size - visibleItems;
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$HiddenBreadcrumbs, {
                items: children,
                size: size,
                listRef: listRef
            }),
            visibleItems < collection.size && collection.size > 2 ? (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    children[0].render?.(children[0]),
                    (0, $dx4lB.jsx)($ddbbd506c05279f5$var$$f329dd4f2aa58cd0$var$BreadcrumbMenu, {
                        items: children.slice(1, sliceIndex),
                        onAction: onAction
                    }),
                    children.slice(sliceIndex).map((node)=>(0, $dx4lB.jsx)((0, $eF4cA.Fragment), {
                            children: node.render?.(node)
                        }, node.key))
                ]
            }) : (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: children.map((node)=>(0, $dx4lB.jsx)((0, $eF4cA.Fragment), {
                        children: node.render?.(node)
                    }, node.key))
            })
        ]
    });
};


var $8Muzv = parcelRequire("8Muzv");
var $91SAk = parcelRequire("91SAk");
var $208Op = parcelRequire("208Op");
const $0de8615f62ba4b65$var$BreadcrumbsContext = /*#__PURE__*/ (0, $eF4cA.createContext)(null);
let $0de8615f62ba4b65$var$nextRegistrationId = 0;
const $0de8615f62ba4b65$export$5eb09e7a134d225e = ({ children: children })=>{
    const [registrations, setRegistrations] = (0, $eF4cA.useState)([]);
    const register = (0, $eF4cA.useCallback)((id, crumbs)=>{
        setRegistrations((prev)=>[
                ...prev.filter((entry)=>entry.id !== id),
                {
                    id: id,
                    crumbs: crumbs
                }
            ]);
    }, []);
    const unregister = (0, $eF4cA.useCallback)((id)=>{
        setRegistrations((prev)=>prev.filter((entry)=>entry.id !== id));
    }, []);
    const crumbs = registrations[registrations.length - 1]?.crumbs ?? [];
    return /*#__PURE__*/ (0, $dx4lB.jsx)($0de8615f62ba4b65$var$BreadcrumbsContext.Provider, {
        value: {
            crumbs: crumbs,
            register: register,
            unregister: unregister
        },
        children: children
    });
};
$0de8615f62ba4b65$export$5eb09e7a134d225e.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const $0de8615f62ba4b65$export$8cefe241bd876ca0 = (crumbs)=>{
    const context = (0, $eF4cA.useContext)($0de8615f62ba4b65$var$BreadcrumbsContext);
    const register = context?.register;
    const unregister = context?.unregister;
    const idRef = (0, $eF4cA.useRef)(null);
    if (idRef.current === null) idRef.current = `breadcrumbs-${$0de8615f62ba4b65$var$nextRegistrationId++}`;
    // Keep the latest crumbs available to the effect without making its identity
    // the dependency (the array is recreated every render). A serialized key of
    // the primitive fields drives re-registration instead.
    const crumbsRef = (0, $eF4cA.useRef)(crumbs);
    crumbsRef.current = crumbs;
    const key = JSON.stringify(crumbs ?? []);
    (0, $eF4cA.useEffect)(()=>{
        if (!register || !unregister) return;
        const id = idRef.current;
        register(id, crumbsRef.current ?? []);
        return ()=>unregister(id);
    }, [
        register,
        unregister,
        key
    ]);
};
const $0de8615f62ba4b65$export$2dc68d50d56fbbd = ()=>{
    const { crumbs: crumbs } = (0, $eF4cA.useContext)($0de8615f62ba4b65$var$BreadcrumbsContext) ?? {
        crumbs: []
    };
    if (!crumbs.length) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                orientation: "vertical",
                size: "M",
                styles: " zn9DOs182 yn9DOs182 Bn9DOs182 An9DOs182 Iv182 Hv182 Jv182 Gv182"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ddbbd506c05279f5$export$2dc68d50d56fbbd), {
                size: "M",
                styles: " zn9DOs182 yn9DOs182 Bn9DOs182 An9DOs182 _sd182 _ua182",
                children: crumbs.map((crumb)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $ddbbd506c05279f5$export$dabcc1ec9dd9d1cc), {
                        href: crumb.href,
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                            isLoading: !!crumb.isLoading,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: crumb.label
                            })
                        })
                    }, crumb.href ?? crumb.label))
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $f16Ml = parcelRequire("f16Ml");
var $aQTiM = parcelRequire("aQTiM");
var $8Muzv = parcelRequire("8Muzv");
var $8wD3p = parcelRequire("8wD3p");
var $2ffAV = parcelRequire("2ffAV");
var $208Op = parcelRequire("208Op");

var $5IZkx = parcelRequire("5IZkx");

var $fL0wx = parcelRequire("fL0wx");

var $lRNYL = parcelRequire("lRNYL");

var $fmJ8d = parcelRequire("fmJ8d");
const $344d9fa61b19950b$var$COLOR_SCHEME_LABELS = {
    system: "System",
    light: "Light",
    dark: "Dark"
};
const $344d9fa61b19950b$var$ADMIN_MENU_KEYS = {
    disableRoles: "disable-roles",
    devMode: "dev-mode",
    demoMode: "demo-mode"
};
const $344d9fa61b19950b$var$AvatarWithFallback = ({ profile: profile, size: size, ...props })=>{
    const [currentSrc, setCurrentSrc] = (0, $eF4cA.useState)(`https://ab.adobe-identity.com/api/avatars/100/${encodeURIComponent(profile?.id)}`);
    const ref = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (ref.current) {
            const domNode = ref.current?.UNSAFE_getDOMNode();
            if (domNode) domNode.querySelector("img").addEventListener("error", ()=>{
                setCurrentSrc(`https://s7d2.scene7.com/is/image/IMGDIR/${profile?.email?.replace("@adobe.com", "")}?$120x$`);
            }, {
                once: true
            });
        }
    }, [
        profile?.email
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
        ref: ref,
        src: currentSrc,
        size: size,
        ...props
    });
};
$344d9fa61b19950b$var$AvatarWithFallback.propTypes = {
    profile: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
    }),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number
};
const $344d9fa61b19950b$export$72d0b49a56703654 = ()=>{
    const profile = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state?.ims?.profile);
    const colorSchemePreference = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorSchemePreference);
    const setColorSchemePreference = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setColorSchemePreference);
    // Real (non-overridden) roles keep the Admin submenu visible so admins can
    // switch roles back on.
    const isAdmin = (0, $lRNYL.useIsAdmin)({
        ignoreOverride: true
    });
    const assignedRoles = (0, $lRNYL.useUserRoles)({
        ignoreOverride: true
    });
    const rolesDisabled = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.rolesDisabled);
    const setRolesDisabled = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setRolesDisabled);
    const setDevModeOverride = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setDevModeOverride);
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    const demoMode = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.demoMode);
    const setDemoMode = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setDemoMode);
    const adminSelectedKeys = [
        ...rolesDisabled ? [
            $344d9fa61b19950b$var$ADMIN_MENU_KEYS.disableRoles
        ] : [],
        ...isDevMode ? [
            $344d9fa61b19950b$var$ADMIN_MENU_KEYS.devMode
        ] : [],
        ...demoMode ? [
            $344d9fa61b19950b$var$ADMIN_MENU_KEYS.demoMode
        ] : []
    ];
    const handleAdminSelectionChange = (keys)=>{
        const nextRolesDisabled = keys.has($344d9fa61b19950b$var$ADMIN_MENU_KEYS.disableRoles);
        const nextDevMode = keys.has($344d9fa61b19950b$var$ADMIN_MENU_KEYS.devMode);
        const nextDemoMode = keys.has($344d9fa61b19950b$var$ADMIN_MENU_KEYS.demoMode);
        if (nextDemoMode !== demoMode) setDemoMode(nextDemoMode);
        if (nextRolesDisabled !== rolesDisabled) setRolesDisabled(nextRolesDisabled);
        if (nextDevMode !== isDevMode) setDevModeOverride(nextDevMode);
    };
    const { signOut: signOut } = (0, $fL0wx.useIMS)();
    if (!profile?.email) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                isQuiet: true,
                size: "L",
                "aria-label": "Account",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)($344d9fa61b19950b$var$AvatarWithFallback, {
                    profile: profile,
                    size: 28
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                hideArrow: true,
                placement: "bottom end",
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " Tp182 sd182 _ta182 Ug182 qg182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 Ug182 qg182 eb182 Ix182 Hx182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)($344d9fa61b19950b$var$AvatarWithFallback, {
                                    profile: profile,
                                    size: 56
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                            children: profile?.fullName ?? ""
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                            children: profile?.email ?? ""
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                            styles: " Ix182 Hx182"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.Menu), {
                            "aria-label": "Settings",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.SubmenuTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    slot: "label",
                                                    children: "Theme"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    slot: "value",
                                                    children: $344d9fa61b19950b$var$COLOR_SCHEME_LABELS[colorSchemePreference] ?? colorSchemePreference
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                                            selectionMode: "single",
                                            selectedKeys: [
                                                colorSchemePreference
                                            ],
                                            onSelectionChange: (keys)=>{
                                                const key = [
                                                    ...keys
                                                ][0];
                                                if (key) setColorSchemePreference(key);
                                            },
                                            children: Object.entries($344d9fa61b19950b$var$COLOR_SCHEME_LABELS).map(([id, label])=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                                    id: id,
                                                    children: label
                                                }, id))
                                        })
                                    ]
                                }),
                                isAdmin && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.SubmenuTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                slot: "label",
                                                children: "Admin"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.Menu), {
                                            "aria-label": "Admin",
                                            selectionMode: "multiple",
                                            selectedKeys: adminSelectedKeys,
                                            onSelectionChange: handleAdminSelectionChange,
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                    id: $344d9fa61b19950b$var$ADMIN_MENU_KEYS.disableRoles,
                                                    textValue: "Disable roles",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "label",
                                                            children: "Disable roles"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "description",
                                                            children: assignedRoles.join(", ") || "No roles"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                    id: $344d9fa61b19950b$var$ADMIN_MENU_KEYS.demoMode,
                                                    textValue: "Demo mode",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "label",
                                                            children: "Demo mode"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "description",
                                                            children: "Replay completed projects without changing them"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                                    id: $344d9fa61b19950b$var$ADMIN_MENU_KEYS.devMode,
                                                    textValue: "Dev mode",
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "label",
                                                        children: "Dev mode"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                    onClick: ()=>{
                                        signOut();
                                    },
                                    children: "Sign out"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


const $1f7d28ef023026e3$export$8b251419efc915eb = ({ styles: styles })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("header", {
        className: (0, $5nTep.mergeStyles)(" se182 CXbi7wd182 Duowq182", styles),
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " zn9DOs182 yn9DOs182 Bn9DOs182 An9DOs182 sd182 eb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                        isQuiet: true,
                        onPress: ()=>navigate("/"),
                        styles: " zn9DOs182 yn9DOs182 Bn9DOs182 An9DOs182",
                        UNSAFE_className: " Sd182 Spe182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sh182 _va182 eb182 Ue182 qe182 Hb182",
                            children: [
                                "BeStory",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                    size: "XS",
                                    variant: "magenta",
                                    UNSAFE_style: {
                                        paddingInline: 2
                                    },
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $47731b42bd727f9a$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0de8615f62ba4b65$export$2dc68d50d56fbbd), {}),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        id: "beStory-header-title",
                        className: (0, $5nTep.mergeStyles)("PBHkad", " sd182 eb182 _df182")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                id: "beStory-header-content",
                className: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ub182 Uj182 qj182"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " zkG38H182 ykG38H182 BkG38H182 AkG38H182 sd182 eb182 Ug182 qg182 IM182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        id: "beStory-header-actions",
                        className: " sd182 eb182 Ug182 qg182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                        href: "slack://channel?team=E23RE8G4F&id=C095CSV0N0Z",
                        target: "_blank",
                        variant: "secondary",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8bb28521b6897537$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Community"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $344d9fa61b19950b$export$72d0b49a56703654), {})
                ]
            })
        ]
    });
};
$1f7d28ef023026e3$export$8b251419efc915eb.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const $1f7d28ef023026e3$export$edb76fdb8665f52 = ({ children: children })=>{
    const headerTitleContainer = document.getElementById("beStory-header-title");
    if (!headerTitleContainer) {
        console.warn("HeaderTitle: Container element with id 'beStory-header-title' not found.");
        return null;
    }
    return /*#__PURE__*/ (0, $l19Vn.createPortal)(children, headerTitleContainer);
};
$1f7d28ef023026e3$export$edb76fdb8665f52.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node.isRequired
};
const $1f7d28ef023026e3$export$78a558edcc066ec2 = ({ children: children })=>{
    const headerContentContainer = document.getElementById("beStory-header-content");
    if (!headerContentContainer) {
        console.warn("HeaderContent: Container element with id 'beStory-header-content' not found.");
        return null;
    }
    return /*#__PURE__*/ (0, $l19Vn.createPortal)(children, headerContentContainer);
};
$1f7d28ef023026e3$export$78a558edcc066ec2.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node.isRequired
};
const $1f7d28ef023026e3$export$223875819fd7cf93 = ({ children: children })=>{
    const headerActionsContainer = document.getElementById("beStory-header-actions");
    if (!headerActionsContainer) {
        console.warn("HeaderActions: Container element with id 'beStory-header-actions' not found.");
        return null;
    }
    return /*#__PURE__*/ (0, $l19Vn.createPortal)(children, headerActionsContainer);
};
$1f7d28ef023026e3$export$223875819fd7cf93.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node.isRequired
};



// import {} from "@react-spectrum/s2";

var $dx4lB = parcelRequire("dx4lB");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $8wD3p = parcelRequire("8wD3p");
var $208Op = parcelRequire("208Op");


var $lRNYL = parcelRequire("lRNYL");



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $915163f661093130$var$$3501daccb5b4faaf$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const $915163f661093130$var$$3501daccb5b4faaf$var$ForwardRef = (0, $eF4cA.forwardRef)($915163f661093130$var$$3501daccb5b4faaf$var$SvgComponent);
var $915163f661093130$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($915163f661093130$var$$3501daccb5b4faaf$var$ForwardRef);


const $74d8869ffd4e0558$export$494cf78290fbe4c7 = ({ styles: styles })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("header", {
        className: styles + " sd182 spk182 eb182 Ue182 qe182 Tt182 Qt182 St182 Rt182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                isQuiet: true,
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $915163f661093130$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.Menu), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                        onPress: ()=>navigate("/"),
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                        onPress: ()=>navigate("/projects"),
                                        children: "Projects"
                                    }),
                                    isAdmin && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                        onPress: ()=>navigate("/admin"),
                                        children: "Admin"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                        onPress: ()=>navigate("/"),
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sh182 eb182 Ue182 qe182 Hb182",
                            children: [
                                "BeStory",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                    size: "XS",
                                    variant: "magenta",
                                    UNSAFE_style: {
                                        paddingInline: 2
                                    },
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $47731b42bd727f9a$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                id: "beStory-mobile-header-content",
                className: " _ub182 sd182 Uj182 qj182"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ug182 qg182 IM182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                        "aria-label": "Slack community",
                        href: "slack://channel?team=E23RE8G4F&id=C095CSV0N0Z",
                        target: "_blank",
                        variant: "secondary",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8bb28521b6897537$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $344d9fa61b19950b$export$72d0b49a56703654), {})
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $dm5H1 = parcelRequire("dm5H1");

var $8OJ2z = parcelRequire("8OJ2z");

var $dm5H1 = parcelRequire("dm5H1");


var $8OJ2z = parcelRequire("8OJ2z");

var $8wD3p = parcelRequire("8wD3p");

var $lTVIu = parcelRequire("lTVIu");

var $hxsf4 = parcelRequire("hxsf4");

var $8w4Nl = parcelRequire("8w4Nl");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $2ffAV = parcelRequire("2ffAV");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $j3pTw = parcelRequire("j3pTw");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $i0SpD = parcelRequire("i0SpD");

var $hJVXE = parcelRequire("hJVXE");

var $8UElq = parcelRequire("8UElq");

var $cg9Gh = parcelRequire("cg9Gh");

var $8gDpA = parcelRequire("8gDpA");

var $f8UJ0 = parcelRequire("f8UJ0");

var $c1ibQ = parcelRequire("c1ibQ");

var $fvyIQ = parcelRequire("fvyIQ");

var $d8j5I = parcelRequire("d8j5I");

var $fVfXf = parcelRequire("fVfXf");

var $daM4n = parcelRequire("daM4n");

var $lhKAD = parcelRequire("lhKAD");

var $fvyIQ = parcelRequire("fvyIQ");

var $YxOvP = parcelRequire("YxOvP");

var $gm31e = parcelRequire("gm31e");

var $cI1qR = parcelRequire("cI1qR");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $3nhvX = parcelRequire("3nhvX");

var $luVJm = parcelRequire("luVJm");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a35d2a5b1f91f874$export$703601b7e90536f8 = new WeakMap();
function $a35d2a5b1f91f874$export$e64b2f635402ca43(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate, isDisabled: isDisabled, isRequired: isRequired, name: name, form: form, validationBehavior: validationBehavior = 'aria' } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let delegate = (0, $eF4cA.useMemo)(()=>keyboardDelegate || new (0, $daM4n.ListKeyboardDelegate)(state.collection, state.disabledKeys, ref, collator), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator,
        ref
    ]);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $3nhvX.useMenuTrigger)({
        isDisabled: isDisabled,
        type: 'listbox'
    }, state, ref);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ArrowLeft: ()=>{
                if (state.selectionManager.selectionMode === 'multiple') return false;
                let key = state.selectedKey != null ? delegate.getKeyAbove?.(state.selectedKey) : delegate.getFirstKey?.();
                if (key != null) state.setSelectedKey(key);
            },
            ArrowRight: ()=>{
                if (state.selectionManager.selectionMode === 'multiple') return false;
                let key = state.selectedKey != null ? delegate.getKeyBelow?.(state.selectedKey) : delegate.getFirstKey?.();
                if (key != null) state.setSelectedKey(key);
            }
        },
        allowRepeats: true,
        onKeyDown: props.onKeyDown,
        onKeyUp: props.onKeyUp
    });
    let { typeSelectProps: typeSelectProps } = (0, $luVJm.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    if (state.selectionManager.selectionMode === 'multiple') typeSelectProps = {};
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let triggerProps = (0, $lhKAD.mergeProps)(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = (0, $25dFS.useId)();
    $a35d2a5b1f91f874$export$703601b7e90536f8.set(state, {
        isDisabled: isDisabled,
        isRequired: isRequired,
        name: name,
        form: form,
        validationBehavior: validationBehavior
    });
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current?.focus();
                    (0, $YxOvP.setInteractionModality)('keyboard');
                }
            }
        },
        triggerProps: (0, $lhKAD.mergeProps)(domProps, {
            ...triggerProps,
            isDisabled: isDisabled,
            onKeyDown: (0, $d8j5I.chain)(triggerProps.onKeyDown, keyboardProps.onKeyDown),
            onKeyUp: keyboardProps.onKeyUp,
            'aria-labelledby': [
                valueId,
                triggerProps['aria-labelledby'],
                triggerProps['aria-label'] && !triggerProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' '),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            onAction: undefined,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            linkBehavior: 'selection',
            onBlur: (e)=>{
                if ((0, $fvyIQ.nodeContains)(e.currentTarget, e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            'aria-labelledby': [
                fieldProps['aria-labelledby'],
                triggerProps['aria-label'] && !fieldProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' ')
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        hiddenSelectProps: {
            isDisabled: isDisabled,
            name: name,
            label: props.label,
            state: state,
            triggerRef: ref,
            form: form
        }
    };
}



var $3rgVl = parcelRequire("3rgVl");

var $56aMA = parcelRequire("56aMA");

var $31fH3 = parcelRequire("31fH3");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b5e64e760e4bdfe6$export$f809e80f58e251d1(props, state, triggerRef) {
    let data = (0, $a35d2a5b1f91f874$export$703601b7e90536f8).get(state) || {};
    let { autoComplete: autoComplete, name: name = data.name, form: form = data.form, isDisabled: isDisabled = data.isDisabled } = props;
    let { validationBehavior: validationBehavior, isRequired: isRequired } = data;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)({
        style: {
            // Prevent page scrolling.
            position: 'fixed',
            top: 0,
            left: 0
        }
    });
    (0, $3rgVl.useFormReset)(props.selectRef, state.defaultValue, state.setValue);
    (0, $56aMA.useFormValidation)({
        validationBehavior: validationBehavior,
        focus: ()=>triggerRef.current?.focus()
    }, state, props.selectRef);
    let setValue = state.setValue;
    // Used for both onChange and onInput, so accept the common supertype of both event types.
    let onChange = (0, $eF4cA.useCallback)((e)=>{
        let eventTarget = (0, $fvyIQ.getEventTarget)(e);
        if (eventTarget.multiple) setValue(Array.from(eventTarget.selectedOptions, (option)=>option.value));
        else setValue(e.currentTarget.value);
    }, [
        setValue
    ]);
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            'aria-hidden': true,
            // @ts-ignore
            ['data-react-aria-prevent-focus']: true,
            // @ts-ignore
            ['data-a11y-ignore']: 'aria-hidden-focus'
        },
        inputProps: {
            style: {
                display: 'none'
            }
        },
        selectProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            multiple: state.selectionManager.selectionMode === 'multiple',
            required: validationBehavior === 'native' && isRequired,
            name: name,
            form: form,
            value: state.value ?? '',
            onChange: onChange,
            onInput: onChange
        }
    };
}
function $b5e64e760e4bdfe6$export$cbd84cdb2e668835(props) {
    let { state: state, triggerRef: triggerRef, label: label, name: name, form: form, isDisabled: isDisabled } = props;
    let selectRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null);
    let { containerProps: containerProps, selectProps: selectProps } = $b5e64e760e4bdfe6$export$f809e80f58e251d1({
        ...props,
        selectRef: state.collection.size <= 300 ? selectRef : inputRef
    }, state, triggerRef);
    let values = Array.isArray(state.value) ? state.value : [
        state.value
    ];
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...containerProps,
        "data-testid": "hidden-select-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("label", null, label, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("select", {
        ...selectProps,
        ref: selectRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("option", {
        value: "",
        label: '\u00A0'
    }, '\u00A0'), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item && item.type === 'item') return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue);
    }), state.collection.size === 0 && name && values.map((value, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("option", {
            key: i,
            value: value ?? ''
        })))));
    else if (name) {
        let data = (0, $a35d2a5b1f91f874$export$703601b7e90536f8).get(state) || {};
        let { validationBehavior: validationBehavior } = data;
        // Always render at least one hidden input to ensure required form submission.
        if (values.length === 0) values = [
            null
        ];
        let res = values.map((value, i)=>{
            let inputProps = {
                type: 'hidden',
                autoComplete: selectProps.autoComplete,
                name: name,
                form: form,
                disabled: isDisabled,
                value: value ?? ''
            };
            if (validationBehavior === 'native') // so that an empty value blocks HTML form submission when the field is required.
            return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
                key: i,
                ...inputProps,
                ref: i === 0 ? inputRef : null,
                style: {
                    display: 'none'
                },
                type: "text",
                required: i === 0 ? selectProps.required : false,
                onChange: ()=>{
                /** Ignore react warning. */ }
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
                key: i,
                ...inputProps,
                ref: i === 0 ? inputRef : null
            });
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, res);
    }
    return null;
}



var $3g2oV = parcelRequire("3g2oV");

var $19ZgV = parcelRequire("19ZgV");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $iEwfj = parcelRequire("iEwfj");

var $fHi9W = parcelRequire("fHi9W");

var $lIr3v = parcelRequire("lIr3v");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $874b973904994039$export$5159ec8b34d4ec12(props) {
    let { selectionMode: selectionMode = 'single', shouldCloseOnSelect: shouldCloseOnSelect = selectionMode === 'single' } = props;
    let triggerState = (0, $lIr3v.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, $eF4cA.useState)(null);
    let defaultValue = (0, $eF4cA.useMemo)(()=>{
        return props.defaultValue !== undefined ? props.defaultValue : selectionMode === 'single' ? props.defaultSelectedKey ?? null : [];
    }, [
        props.defaultValue,
        props.defaultSelectedKey,
        selectionMode
    ]);
    let value = (0, $eF4cA.useMemo)(()=>{
        return props.value !== undefined ? props.value : selectionMode === 'single' ? props.selectedKey : undefined;
    }, [
        props.value,
        props.selectedKey,
        selectionMode
    ]);
    let [controlledValue, setControlledValue] = (0, $iUErx.useControlledState)(value, defaultValue, props.onChange);
    // Only display the first selected item if in single selection mode but the value is an array.
    let displayValue = selectionMode === 'single' && Array.isArray(controlledValue) ? controlledValue[0] : controlledValue;
    let setValue = (value)=>{
        if (selectionMode === 'single') {
            let key = Array.isArray(value) ? value[0] ?? null : value;
            setControlledValue(key);
            if (key !== displayValue) props.onSelectionChange?.(key);
        } else {
            let keys = [];
            if (Array.isArray(value)) keys = value;
            else if (value != null) keys = [
                value
            ];
            setControlledValue(keys);
        }
    };
    // oxlint-disable-next-line react/react-compiler
    let listState = (0, $fHi9W.useListState)({
        ...props,
        selectionMode: selectionMode,
        disallowEmptySelection: selectionMode === 'single',
        allowDuplicateSelectionEvents: true,
        selectedKeys: (0, $eF4cA.useMemo)(()=>$874b973904994039$var$$29256f53a2edafe9$var$convertValue(displayValue), [
            displayValue
        ]),
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            if (selectionMode === 'single') {
                let key = keys.values().next().value ?? null;
                setValue(key);
            } else setValue([
                ...keys
            ]);
            if (shouldCloseOnSelect) triggerState.close();
            validationState.commitValidation();
        }
    });
    let selectedKey = listState.selectionManager.firstSelectedKey;
    let selectedItems = (0, $eF4cA.useMemo)(()=>{
        return [
            ...listState.selectionManager.selectedKeys
        ].map((key)=>listState.collection.getItem(key)).filter((item)=>item != null);
    }, [
        listState.selectionManager.selectedKeys,
        listState.collection
    ]);
    let validationState = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: Array.isArray(displayValue) && displayValue.length === 0 ? null : displayValue
    });
    let [isFocused, setFocused] = (0, $eF4cA.useState)(false);
    let [initialValue] = (0, $eF4cA.useState)(displayValue);
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        value: displayValue,
        defaultValue: defaultValue ?? initialValue,
        setValue: setValue,
        selectedKey: selectedKey,
        setSelectedKey: setValue,
        selectedItem: selectedItems[0] ?? null,
        selectedItems: selectedItems,
        defaultSelectedKey: props.defaultSelectedKey ?? (props.selectionMode === 'single' ? initialValue : null),
        focusStrategy: focusStrategy,
        open (focusStrategy = null) {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0 || props.allowsEmptyCollection) {
                setFocusStrategy(focusStrategy);
                triggerState.open();
            }
        },
        toggle (focusStrategy = null) {
            if (listState.collection.size !== 0 || props.allowsEmptyCollection) {
                setFocusStrategy(focusStrategy);
                triggerState.toggle();
            }
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}
function $874b973904994039$var$$29256f53a2edafe9$var$convertValue(value) {
    if (value === undefined) return undefined;
    if (value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}



var $3h1XC = parcelRequire("3h1XC");

var $9hIi4 = parcelRequire("9hIi4");

var $gI8Gw = parcelRequire("gI8Gw");
function $115cb651e37427c9$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $115cb651e37427c9$export$7540cee5be7dc19b = (0, $eF4cA.createContext)(null);
const $115cb651e37427c9$export$ef445b55be0601bd = (0, $eF4cA.createContext)(null);
const $115cb651e37427c9$export$ef9b1a59e592288f = (0, $19ZgV.createHideableComponent)(function Select(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $115cb651e37427c9$export$7540cee5be7dc19b);
    let { children: children, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false } = props;
    let content = (0, $eF4cA.useMemo)(()=>typeof children === 'function' ? children({
            isOpen: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isRequired: isRequired,
            isFocused: false,
            isFocusVisible: false,
            defaultChildren: null
        }) : children, [
        children,
        isDisabled,
        isInvalid,
        isRequired
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: content
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($115cb651e37427c9$var$$c8bb816105474884$var$SelectInner, {
            props: props,
            collection: collection,
            selectRef: ref
        }));
});
// Contexts to clear inside the popover.
const $115cb651e37427c9$var$$c8bb816105474884$var$CLEAR_CONTEXTS = [
    (0, $8UElq.LabelContext),
    (0, $k5Pnh.ButtonContext),
    (0, $c1ibQ.TextContext)
];
function $115cb651e37427c9$var$$c8bb816105474884$var$SelectInner({ props: props, selectRef: ref, collection: collection }) {
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $874b973904994039$export$5159ec8b34d4ec12)({
        ...props,
        collection: collection,
        children: undefined,
        validationBehavior: validationBehavior
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    // Get props for child elements from useSelect
    let buttonRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, hiddenSelectProps: hiddenSelectProps, ...validation } = (0, $a35d2a5b1f91f874$export$e64b2f635402ca43)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, buttonRef);
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, $eF4cA.useMemo)(()=>({
            isOpen: state.isOpen,
            isFocused: state.isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        state.isFocused,
        isFocusVisible,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: renderPropsState,
        defaultClassName: 'react-aria-Select'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    let scrollRef = (0, $eF4cA.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $115cb651e37427c9$export$7540cee5be7dc19b,
                props
            ],
            [
                $115cb651e37427c9$export$ef445b55be0601bd,
                state
            ],
            [
                $115cb651e37427c9$export$f8f745c04421623f,
                valueProps
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    ...triggerProps,
                    ref: buttonRef,
                    isPressed: state.isOpen,
                    autoFocus: props.autoFocus
                }
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                state
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    trigger: 'Select',
                    triggerRef: buttonRef,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    'aria-labelledby': menuProps['aria-labelledby'],
                    clearContexts: $115cb651e37427c9$var$$c8bb816105474884$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $cg9Gh.ListBoxContext),
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $cg9Gh.ListStateContext),
                state
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $b5e64e760e4bdfe6$export$cbd84cdb2e668835), {
        ...hiddenSelectProps,
        autoComplete: props.autoComplete
    })));
}
const $115cb651e37427c9$export$f8f745c04421623f = (0, $eF4cA.createContext)(null);
const $115cb651e37427c9$export$e288731fd71264f0 = (0, $19ZgV.createHideableComponent)(function SelectValue(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $115cb651e37427c9$export$f8f745c04421623f);
    let state = (0, $eF4cA.useContext)($115cb651e37427c9$export$ef445b55be0601bd);
    let { placeholder: placeholder } = (0, $fDYaM.useSlottedContext)($115cb651e37427c9$export$7540cee5be7dc19b);
    let rendered = state.selectedItems.map((item)=>{
        let rendered = item.props?.children;
        // If the selected item has a function as a child, we need to call it to render to React.JSX.
        if (typeof rendered === 'function') {
            let fn = rendered;
            rendered = fn({
                isHovered: false,
                isPressed: false,
                isSelected: false,
                isFocused: false,
                isFocusVisible: false,
                isDisabled: false,
                selectionMode: 'single',
                selectionBehavior: 'toggle'
            });
        }
        return rendered;
    });
    let formatter = (0, $9hIi4.useListFormatter)();
    let textValue = (0, $eF4cA.useMemo)(()=>state.selectedItems.map((item)=>item?.textValue), [
        state.selectedItems
    ]);
    let selectionMode = state.selectionManager.selectionMode;
    let selectedText = (0, $eF4cA.useMemo)(()=>selectionMode === 'single' ? textValue[0] ?? '' : formatter.format(textValue), [
        selectionMode,
        formatter,
        textValue
    ]);
    let defaultChildren = (0, $eF4cA.useMemo)(()=>{
        if (selectionMode === 'single') return rendered[0];
        let parts = formatter.formatToParts(textValue);
        if (parts.length === 0) return null;
        let index = 0;
        return parts.map((part)=>{
            if (part.type === 'element') return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $eF4cA.Fragment), {
                key: index
            }, rendered[index++]);
            else return part.value;
        });
    }, [
        selectionMode,
        formatter,
        textValue,
        rendered
    ]);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($115cb651e37427c9$var$$parcel$interopDefault((0, $hJVXE.default)), 'react-aria-components');
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultChildren: defaultChildren ?? placeholder ?? stringFormatter.format('selectPlaceholder'),
        defaultClassName: 'react-aria-SelectValue',
        values: {
            selectedItem: state.selectedItems[0]?.value ?? null,
            selectedItems: (0, $eF4cA.useMemo)(()=>state.selectedItems.map((item)=>item.value ?? null), [
                state.selectedItems
            ]),
            selectedText: selectedText,
            isPlaceholder: state.selectedItems.length === 0,
            state: state
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).span, {
        ref: ref,
        ...DOMProps,
        ...renderProps,
        "data-placeholder": state.selectedItems.length === 0 || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $c1ibQ.TextContext).Provider, {
        value: undefined
    }, renderProps.children));
});



var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $cg9Gh = parcelRequire("cg9Gh");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6d8ae065df3d188d$export$b72b8dade9393cd5 = (0, $eF4cA.createContext)(null);
const $6d8ae065df3d188d$var$$0067ea932a992b6a$var$inputButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' zXcEWr182';
    rules += ' yXcEWr182';
    rules += ' BXcEWr182';
    rules += ' AXcEWr182';
    if (props.size === "XL") rules += ' Nl182';
    else if (props.size === "L") rules += ' Nj182';
    else if (props.size === "S") rules += ' Nf182';
    else if (props.size === "XS") rules += ' Ne182';
    else rules += ' Nk182';
    if (props.isQuiet) rules += ' _qd182';
    else rules += ' _qtb182';
    if (props.size === "XL") rules += ' -Anxdcc-Zt182';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
    else if (props.size === "S") rules += ' -Anxdcc-Zr182';
    else rules += ' -Anxdcc-Z3fn9H182';
    rules += ' __v6TNLWb182';
    rules += ' _Pc182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' sd182';
    rules += ' _Wd182';
    rules += ' _je182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    rules += ' eb182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' SMBFGYc182';
    rules += ' RfBFGYc182';
    rules += ' g9182';
    if (props.isQuiet) rules += ' Ln182';
    rules += ' __ca182';
    if (props.density === "compact") rules += ' Fx182';
    else rules += ' Fz182';
    rules += ' _oa182';
    rules += ' -S_-Sd182';
    rules += ' -R_-Rd182';
    return rules;
};
let $6d8ae065df3d188d$export$b1e5508a851be14d = function anonymous(props) {
    let rules = " ";
    rules += ' _Le182';
    rules += ' se182';
    rules += ' Deb5jcb182';
    rules += ' _oa182';
    rules += ' Za182';
    rules += ' K40ub4c182';
    rules += ' _Na182';
    rules += ' Pa182';
    rules += ' Tt182';
    rules += ' Qt182';
    rules += ' St182';
    rules += ' Rt182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    return rules;
};
const $6d8ae065df3d188d$var$$0067ea932a992b6a$var$valueStyles = " _ua182 _Nc182 Pc182 _Yb182 _7c182 sd182 eb182 Fb182";
const $6d8ae065df3d188d$var$$0067ea932a992b6a$var$iconStyles = " _va182 _Sd182 -_8sjo0b-t5ZbAob182";
const $6d8ae065df3d188d$var$$0067ea932a992b6a$var$iconCenterWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' sd182';
    rules += ' z2U5Crc182';
    rules += ' y2U5Crc182';
    rules += ' B2U5Crc182';
    rules += ' A2U5Crc182';
    if (props.labelBehavior === "hide") rules += ' SssxDec182';
    return rules;
};
let $6d8ae065df3d188d$var$$0067ea932a992b6a$var$InsideSelectValueContext = (0, $eF4cA.createContext)(false);
function $6d8ae065df3d188d$var$$0067ea932a992b6a$var$Picker(props1, ref) {
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $6d8ae065df3d188d$export$b72b8dade9393cd5);
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    props1 = (0, $j3pTw.useFormProps)(props1);
    let { direction: direction = 'bottom', align: align = 'start', shouldFlip: shouldFlip = true, children: children, items: items, density: density, labelBehavior: labelBehavior = 'show', valueId: valueId, ...pickerProps } = props1;
    let isQuiet = true;
    const menuOffset = 6;
    const size = 'M';
    let ariaLabelledby = props1['aria-labelledby'] ?? '';
    let { direction: dir } = (0, $1ntKq.useLocale)();
    let RTLFlipOffset = dir === 'rtl' ? -1 : 1;
    return (0, $dx4lB.jsxs)("div", {
        children: [
            (0, $dx4lB.jsx)((0, $115cb651e37427c9$export$ef9b1a59e592288f), {
                ...pickerProps,
                className: "",
                "aria-labelledby": `${labelBehavior === 'hide' ? valueId : ''} ${ariaLabelledby}`,
                children: ({ isOpen: isOpen })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                                isQuiet: isQuiet
                            }),
                            (0, $dx4lB.jsxs)((0, $k5Pnh.Button), {
                                ref: domRef,
                                style: (renderProps)=>(0, $i93Vd.pressScale)(domRef)(renderProps),
                                // Prevent press scale from sticking while Picker is open.
                                // @ts-ignore
                                isPressed: false,
                                className: (renderProps)=>$6d8ae065df3d188d$var$$0067ea932a992b6a$var$inputButton({
                                        ...renderProps,
                                        size: 'M',
                                        isOpen: isOpen,
                                        isQuiet: isQuiet,
                                        density: density
                                    }),
                                children: [
                                    (0, $dx4lB.jsx)((0, $115cb651e37427c9$export$e288731fd71264f0), {
                                        className: $6d8ae065df3d188d$var$$0067ea932a992b6a$var$valueStyles + ' ' + "WzII9b",
                                        children: ({ defaultChildren: defaultChildren })=>{
                                            return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                                values: [
                                                    [
                                                        (0, $dm5H1.IconContext),
                                                        {
                                                            slots: {
                                                                icon: {
                                                                    render: (0, $8OJ2z.centerBaseline)({
                                                                        slot: 'icon',
                                                                        styles: $6d8ae065df3d188d$var$$0067ea932a992b6a$var$iconCenterWrapper({
                                                                            labelBehavior: labelBehavior
                                                                        })
                                                                    }),
                                                                    styles: (0, $8wD3p.icon)
                                                                }
                                                            }
                                                        }
                                                    ],
                                                    [
                                                        (0, $208Op.TextContext),
                                                        {
                                                            slots: {
                                                                // Default slot is useful when converting other collections to PickerItems.
                                                                [(0, $fDYaM.DEFAULT_SLOT)]: {
                                                                    id: valueId,
                                                                    styles: function anonymous(props) {
                                                                        let rules = " ";
                                                                        if (props.labelBehavior === "hide") rules += ' sk182';
                                                                        else rules += ' sb182';
                                                                        rules += ' _ub182';
                                                                        rules += ' _Nc182';
                                                                        rules += ' Pc182';
                                                                        rules += ' _Yb182';
                                                                        rules += ' _7c182';
                                                                        return rules;
                                                                    }({
                                                                        labelBehavior: labelBehavior
                                                                    })
                                                                }
                                                            }
                                                        }
                                                    ],
                                                    [
                                                        $6d8ae065df3d188d$var$$0067ea932a992b6a$var$InsideSelectValueContext,
                                                        true
                                                    ]
                                                ],
                                                children: defaultChildren
                                            });
                                        }
                                    }),
                                    (0, $dx4lB.jsx)((0, $hxsf4.default), {
                                        size: size,
                                        className: $6d8ae065df3d188d$var$$0067ea932a992b6a$var$iconStyles
                                    })
                                ]
                            }),
                            (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                hideArrow: true,
                                offset: menuOffset,
                                crossOffset: RTLFlipOffset * -12,
                                placement: `${direction} ${align}`,
                                shouldFlip: shouldFlip,
                                styles: " Nh182 ZbWuche182",
                                children: (0, $dx4lB.jsx)("div", {
                                    className: " sd182 Za182 Fb182",
                                    children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                        values: [
                                            [
                                                (0, $208Op.HeaderContext),
                                                {
                                                    styles: (0, $8wD3p.sectionHeader)({
                                                        size: size
                                                    })
                                                }
                                            ],
                                            [
                                                (0, $208Op.HeadingContext),
                                                {
                                                    // @ts-ignore
                                                    role: 'presentation',
                                                    styles: (0, $8wD3p.sectionHeading)
                                                }
                                            ],
                                            [
                                                (0, $208Op.TextContext),
                                                {
                                                    slots: {
                                                        description: {
                                                            styles: (0, $8wD3p.description)({
                                                                size: size,
                                                                isFocused: false,
                                                                isDisabled: false
                                                            })
                                                        }
                                                    }
                                                }
                                            ]
                                        ],
                                        children: (0, $dx4lB.jsx)((0, $cg9Gh.ListBox), {
                                            items: items,
                                            className: $6d8ae065df3d188d$export$b1e5508a851be14d,
                                            children: children
                                        })
                                    })
                                })
                            })
                        ]
                    })
            }),
            (0, $dx4lB.jsx)($6d8ae065df3d188d$var$$0067ea932a992b6a$var$TabLine, {
                isDisabled: props1.isDisabled
            })
        ]
    });
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is
 * limited.
 */ let $6d8ae065df3d188d$export$ba25329847403e11 = (0, $eF4cA.forwardRef)($6d8ae065df3d188d$var$$0067ea932a992b6a$var$Picker);
const $6d8ae065df3d188d$var$$0067ea932a992b6a$var$selectedIndicator = function anonymous(props) {
    let rules = " ";
    if (props.isDisabled) rules += ' gH182';
    else rules += ' g0182';
    if (props.isDisabled) rules += ' gld182';
    else rules += ' gle182';
    rules += ' FLvNfn182';
    rules += ' _je182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' Jk7Otrc182';
    rules += ' Xa182';
    rules += ' _2b182';
    return rules;
};
function $6d8ae065df3d188d$var$$0067ea932a992b6a$var$TabLine(props) {
    return (0, $dx4lB.jsx)("div", {
        className: $6d8ae065df3d188d$var$$0067ea932a992b6a$var$selectedIndicator(props)
    });
}
function $6d8ae065df3d188d$export$d601881f38163e28(props) {
    let ref = (0, $eF4cA.useRef)(null);
    let isLink = props.href != null;
    const size = 'M';
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, $i93Vd.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, $8wD3p.menuitem)({
                ...renderProps,
                size: size,
                isLink: isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children: children } = props;
            return (0, $dx4lB.jsx)($6d8ae065df3d188d$var$$0067ea932a992b6a$var$DefaultProvider, {
                context: (0, $dm5H1.IconContext),
                value: {
                    slots: {
                        icon: {
                            render: (0, $8OJ2z.centerBaseline)({
                                slot: 'icon',
                                styles: $6d8ae065df3d188d$var$$0067ea932a992b6a$var$iconCenterWrapper({})
                            }),
                            styles: (0, $8wD3p.icon)
                        }
                    }
                },
                children: (0, $dx4lB.jsxs)($6d8ae065df3d188d$var$$0067ea932a992b6a$var$DefaultProvider, {
                    context: (0, $208Op.TextContext),
                    value: {
                        slots: {
                            [(0, $fDYaM.DEFAULT_SLOT)]: {
                                styles: (0, $8wD3p.label)({
                                    size: size
                                })
                            }
                        }
                    },
                    children: [
                        !isLink && (0, $dx4lB.jsx)((0, $lTVIu.default), {
                            size: size,
                            className: (0, $8wD3p.checkmark)({
                                ...renderProps,
                                size: size
                            })
                        }),
                        typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: children
                        }) : children
                    ]
                })
            });
        }
    });
// oxlint-enable react/react-compiler
}
// A Context.Provider that only sets a value if not inside SelectValue.
function $6d8ae065df3d188d$var$$0067ea932a992b6a$var$DefaultProvider({ context: context, value: value, children: children }) {
    let inSelectValue = (0, $eF4cA.useContext)($6d8ae065df3d188d$var$$0067ea932a992b6a$var$InsideSelectValueContext);
    if (inSelectValue) return children;
    return (0, $dx4lB.jsx)(context.Provider, {
        value: value,
        children: children
    });
}



var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $hUj7u = parcelRequire("hUj7u");

var $2FPWu = parcelRequire("2FPWu");

var $fVfXf = parcelRequire("fVfXf");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e5c64d45a8aaf561$export$c5f62239608282b6 = new WeakMap();
function $e5c64d45a8aaf561$export$567fc7097e064344(state, key, role) {
    if (!state) return '';
    if (typeof key === 'string') key = key.replace(/\s+/g, '');
    let baseId = $e5c64d45a8aaf561$export$c5f62239608282b6.get(state);
    return `${baseId}-${role}-${key}`;
}



var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $aGgVM = parcelRequire("aGgVM");

var $hNw9N = parcelRequire("hNw9N");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $111853fd0febb534$export$fdf4756d5b8ef90a(props, state, ref) {
    let { key: key, isDisabled: propsDisabled, shouldSelectOnPressUp: shouldSelectOnPressUp } = props;
    let { selectionManager: manager, selectedKey: selectedKey } = state;
    let isSelected = key === selectedKey;
    let isDisabled = propsDisabled || state.isDisabled || state.selectionManager.isDisabled(key);
    let item = state.collection.getItem(key);
    let { itemProps: itemProps, isPressed: isPressed } = (0, $hNw9N.useSelectableItem)({
        selectionManager: manager,
        key: key,
        ref: ref,
        isDisabled: isDisabled,
        // Link tabs should behave like native anchors (navigate on press up)
        // This avoids reopening beforeunload dialogs when browsers replay
        // queued pointer enter/leave events after cancellation.
        shouldSelectOnPressUp: shouldSelectOnPressUp ?? item?.props.href != null,
        linkBehavior: 'selection'
    });
    let tabId = (0, $e5c64d45a8aaf561$export$567fc7097e064344)(state, key, 'tab');
    let tabPanelId = (0, $e5c64d45a8aaf561$export$567fc7097e064344)(state, key, 'tabpanel');
    let { tabIndex: tabIndex } = itemProps;
    let domProps = (0, $fVfXf.filterDOMProps)(item?.props, {
        labelable: true
    });
    delete domProps.id;
    let linkProps = (0, $aGgVM.useLinkProps)(item?.props);
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)({
        ...item?.props,
        isDisabled: isDisabled
    }, ref);
    return {
        tabProps: (0, $lhKAD.mergeProps)(domProps, focusableProps, linkProps, itemProps, {
            id: tabId,
            'aria-selected': isSelected,
            'aria-disabled': isDisabled || undefined,
            'aria-controls': isSelected ? tabPanelId : undefined,
            tabIndex: isDisabled ? undefined : tabIndex,
            role: 'tab'
        }),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed
    };
}


var $lhKAD = parcelRequire("lhKAD");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $16a0a5f0e43075d9$export$15010ca3c1abe90b {
    constructor(collection, direction, orientation, disabledKeys = new Set()){
        this.collection = collection;
        // getKeyLeftOf/getKeyRightOf follow the locale's text direction regardless of orientation,
        // so ArrowLeft always moves to the next tab in RTL. getKeyAbove/getKeyBelow are never flipped.
        this.flipDirection = direction === 'rtl';
        this.disabledKeys = disabledKeys;
        this.tabDirection = orientation === 'horizontal';
    }
    getKeyLeftOf(key) {
        if (this.flipDirection) return this.getNextKey(key);
        return this.getPreviousKey(key);
    }
    getKeyRightOf(key) {
        if (this.flipDirection) return this.getPreviousKey(key);
        return this.getNextKey(key);
    }
    isDisabled(key) {
        return this.disabledKeys.has(key) || !!this.collection.getItem(key)?.props?.isDisabled;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        if (key != null && this.isDisabled(key)) key = this.getNextKey(key);
        return key;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        if (key != null && this.isDisabled(key)) key = this.getPreviousKey(key);
        return key;
    }
    getKeyAbove(key) {
        if (this.tabDirection) return null;
        return this.getPreviousKey(key);
    }
    getKeyBelow(key) {
        if (this.tabDirection) return null;
        return this.getNextKey(key);
    }
    getNextKey(startKey) {
        let key = startKey;
        do {
            key = this.collection.getKeyAfter(key);
            if (key == null) key = this.collection.getFirstKey();
        }while (key != null && this.isDisabled(key) && key !== startKey);
        return key;
    }
    getPreviousKey(startKey) {
        let key = startKey;
        do {
            key = this.collection.getKeyBefore(key);
            if (key == null) key = this.collection.getLastKey();
        }while (key != null && this.isDisabled(key) && key !== startKey);
        return key;
    }
}



var $25dFS = parcelRequire("25dFS");

var $dkaC0 = parcelRequire("dkaC0");

var $1ntKq = parcelRequire("1ntKq");

var $vvwBC = parcelRequire("vvwBC");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $061fec7c22d7bf28$export$773e389e644c5874(props, state, ref) {
    let { orientation: orientation = 'horizontal', keyboardActivation: keyboardActivation = 'automatic' } = props;
    let { collection: collection, selectionManager: manager, disabledKeys: disabledKeys } = state;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let delegate = (0, $eF4cA.useMemo)(()=>new (0, $16a0a5f0e43075d9$export$15010ca3c1abe90b)(collection, direction, orientation, disabledKeys), [
        collection,
        disabledKeys,
        orientation,
        direction
    ]);
    let { collectionProps: collectionProps } = (0, $vvwBC.useSelectableCollection)({
        ref: ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        selectOnFocus: keyboardActivation === 'automatic',
        disallowEmptySelection: true,
        scrollRef: ref,
        linkBehavior: 'selection'
    });
    // Compute base id for all tabs
    let tabsId = (0, $25dFS.useId)();
    (0, $e5c64d45a8aaf561$export$c5f62239608282b6).set(state, tabsId);
    let tabListLabelProps = (0, $dkaC0.useLabels)({
        ...props,
        id: tabsId
    });
    return {
        tabListProps: {
            ...(0, $lhKAD.mergeProps)(collectionProps, tabListLabelProps),
            role: 'tablist',
            'aria-orientation': orientation,
            tabIndex: undefined
        }
    };
}



var $lhKAD = parcelRequire("lhKAD");

var $flpop = parcelRequire("flpop");

var $dkaC0 = parcelRequire("dkaC0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cd4495f91e205538$export$fae0121b5afe572d(props, state, ref) {
    // The tabpanel should have tabIndex=0 when there are no tabbable elements within it.
    // Otherwise, tabbing from the focused tab should go directly to the first tabbable element
    // within the tabpanel.
    let tabIndex = (0, $flpop.useHasTabbableChild)(ref) ? undefined : 0;
    const id = (0, $e5c64d45a8aaf561$export$567fc7097e064344)(state, props.id ?? state?.selectedKey, 'tabpanel');
    const tabPanelProps = (0, $dkaC0.useLabels)({
        ...props,
        id: id,
        'aria-labelledby': (0, $e5c64d45a8aaf561$export$567fc7097e064344)(state, state?.selectedKey, 'tab')
    });
    return {
        tabPanelProps: (0, $lhKAD.mergeProps)(tabPanelProps, {
            tabIndex: tabIndex,
            role: 'tabpanel',
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details']
        })
    };
}



var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $bWhaY = parcelRequire("bWhaY");

var $19ZgV = parcelRequire("19ZgV");

var $fVfXf = parcelRequire("fVfXf");

var $gF3YT = parcelRequire("gF3YT");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $fHi9W = parcelRequire("fHi9W");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bf4d8ea2a35c63bd$export$e7f05e985daf4b5f(props) {
    let [selectedKey, setSelectedKey] = (0, $iUErx.useControlledState)(props.selectedKey, props.defaultSelectedKey ?? null, props.onSelectionChange);
    let selectedKeys = (0, $eF4cA.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = (0, $fHi9W.useListState)({
        ...props,
        selectionMode: 'single',
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            let key = keys.values().next().value ?? null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $90c6ba12683728d4$export$4ba071daf4e486(props) {
    let state = (0, $bf4d8ea2a35c63bd$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: props.onSelectionChange ? (key)=>{
            if (key != null) props.onSelectionChange?.(key);
        } : undefined,
        suppressTextValueWarning: true,
        defaultSelectedKey: props.defaultSelectedKey ?? $90c6ba12683728d4$var$$caeb030f09a278a1$var$findDefaultSelectedKey(props.collection, props.disabledKeys ? new Set(props.disabledKeys) : new Set()) ?? undefined
    });
    let { selectionManager: selectionManager, collection: collection, selectedKey: currentSelectedKey } = state;
    let lastSelectedKey = (0, $eF4cA.useRef)(currentSelectedKey);
    (0, $eF4cA.useEffect)(()=>{
        // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)
        let selectedKey = currentSelectedKey;
        if (props.selectedKey == null && (selectionManager.isEmpty || selectedKey == null || !collection.getItem(selectedKey))) {
            selectedKey = $90c6ba12683728d4$var$$caeb030f09a278a1$var$findDefaultSelectedKey(collection, state.disabledKeys);
            if (selectedKey != null) selectionManager.setSelectedKeys([
                selectedKey
            ]);
        }
        // If the tablist doesn't have focus and the selected key changes or if there isn't a focused key yet, change focused key to the selected key if it exists.
        if (selectedKey != null && selectionManager.focusedKey == null || !selectionManager.isFocused && selectedKey !== lastSelectedKey.current) selectionManager.setFocusedKey(selectedKey);
        lastSelectedKey.current = selectedKey;
    });
    return {
        ...state,
        isDisabled: props.isDisabled || false
    };
}
function $90c6ba12683728d4$var$$caeb030f09a278a1$var$findDefaultSelectedKey(collection, disabledKeys) {
    let selectedKey = null;
    if (collection) {
        selectedKey = collection.getFirstKey();
        // loop over tabs until we find one that isn't disabled and select that
        while(selectedKey != null && (disabledKeys.has(selectedKey) || collection.getItem(selectedKey)?.props?.isDisabled) && selectedKey !== collection.getLastKey())selectedKey = collection.getKeyAfter(selectedKey);
        // if this check is true, then every item is disabled, it makes more sense to default to the first key than the last
        if (selectedKey != null && (disabledKeys.has(selectedKey) || collection.getItem(selectedKey)?.props?.isDisabled) && selectedKey === collection.getLastKey()) selectedKey = collection.getFirstKey();
    }
    return selectedKey;
}



var $6AczJ = parcelRequire("6AczJ");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $4skXn = parcelRequire("4skXn");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $02862c4def27cb80$export$cfa7aa87c26e7d1f = (0, $eF4cA.createContext)(null);
const $02862c4def27cb80$export$364712098d2aa57c = (0, $eF4cA.createContext)(null);
const $02862c4def27cb80$export$b2539bed5023c21c = (0, $eF4cA.forwardRef)(function Tabs(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $02862c4def27cb80$export$cfa7aa87c26e7d1f);
    let { children: children, orientation: orientation = 'horizontal' } = props;
    children = (0, $eF4cA.useMemo)(()=>typeof children === 'function' ? children({
            orientation: orientation,
            defaultChildren: null
        }) : children, [
        children,
        orientation
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: children
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabsInner, {
            props: props,
            collection: collection,
            tabsRef: ref
        }));
});
function $02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabsInner({ props: props, tabsRef: ref, collection: collection }) {
    let { orientation: orientation = 'horizontal' } = props;
    let state = (0, $90c6ba12683728d4$export$4ba071daf4e486)({
        ...props,
        collection: collection,
        children: undefined
    });
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let values = (0, $eF4cA.useMemo)(()=>({
            orientation: orientation,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible
        }), [
        orientation,
        isFocused,
        isFocusVisible
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Tabs',
        values: values
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": isFocused || undefined,
        "data-orientation": orientation,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": state.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $02862c4def27cb80$export$cfa7aa87c26e7d1f,
                props
            ],
            [
                $02862c4def27cb80$export$364712098d2aa57c,
                state
            ]
        ]
    }, renderProps.children));
}
const $02862c4def27cb80$export$e51a686c67fdaa2d = (0, $eF4cA.forwardRef)(function TabList(props, ref) {
    let state = (0, $eF4cA.useContext)($02862c4def27cb80$export$364712098d2aa57c);
    return state ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabListInner, {
        props: props,
        forwardedRef: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props);
});
function $02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabListInner({ props: props, forwardedRef: ref }) {
    let state = (0, $eF4cA.useContext)($02862c4def27cb80$export$364712098d2aa57c);
    let { CollectionRoot: CollectionRoot } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { orientation: orientation = 'horizontal', keyboardActivation: keyboardActivation = 'automatic' } = (0, $fDYaM.useSlottedContext)($02862c4def27cb80$export$cfa7aa87c26e7d1f);
    let objectRef = (0, $26CkO.useObjectRef)(ref);
    let { tabListProps: tabListProps } = (0, $061fec7c22d7bf28$export$773e389e644c5874)({
        ...props,
        orientation: orientation,
        keyboardActivation: keyboardActivation
    }, state, objectRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: null,
        defaultClassName: 'react-aria-TabList',
        values: {
            orientation: orientation,
            state: state
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, tabListProps),
        ref: objectRef,
        "data-orientation": orientation || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, $8dzVy.usePersistedKeys)(state.selectionManager.focusedKey)
    })));
}
class $02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabItemNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'item';
    }
}
const $02862c4def27cb80$export$3e41faf802a29e71 = (0, $3g2oV.createLeafComponent)($02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabItemNode, (props, forwardedRef, item)=>{
    let state = (0, $eF4cA.useContext)($02862c4def27cb80$export$364712098d2aa57c);
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let { tabProps: tabProps, isSelected: isSelected, isDisabled: isDisabled, isPressed: isPressed } = (0, $111853fd0febb534$export$fdf4756d5b8ef90a)({
        key: item.key,
        ...props
    }, state, ref);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        isDisabled: isDisabled,
        onHoverStart: props.onHoverStart,
        onHoverEnd: props.onHoverEnd,
        onHoverChange: props.onHoverChange
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-Tab',
        values: {
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isPressed: isPressed,
            isHovered: isHovered
        }
    });
    let ElementType = item.props.href ? (0, $fDYaM.dom).a : (0, $fDYaM.dom).div;
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(ElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, tabProps, focusProps, hoverProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $hUj7u.SelectionIndicatorContext).Provider, {
        value: {
            isSelected: isSelected
        }
    }, renderProps.children));
});
const $02862c4def27cb80$export$5dae8d435677f210 = (0, $19ZgV.createHideableComponent)(function TabPanels(props, forwardedRef) {
    let state = (0, $eF4cA.useContext)($02862c4def27cb80$export$364712098d2aa57c);
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let selectedKeyRef = (0, $eF4cA.useRef)(state.selectedKey);
    let prevSize = (0, $eF4cA.useRef)(null);
    let hasTransition = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        let el = ref.current;
        if (!el) return;
        if (hasTransition.current == null) hasTransition.current = /width|height|block-size|inline-size|all/.test(window.getComputedStyle(el).transition);
        if (hasTransition.current && selectedKeyRef.current != null && selectedKeyRef.current !== state.selectedKey) {
            // Measure auto size.
            el.style.setProperty('--tab-panel-width', 'auto');
            el.style.setProperty('--tab-panel-height', 'auto');
            let { width: width, height: height } = el.getBoundingClientRect();
            if (prevSize.current && (prevSize.current.width !== width || prevSize.current.height !== height)) {
                // Revert to previous size.
                el.style.setProperty('--tab-panel-width', prevSize.current.width + 'px');
                el.style.setProperty('--tab-panel-height', prevSize.current.height + 'px');
                // Force style re-calculation to trigger animations.
                window.getComputedStyle(el).height;
                // Animate to current pixel size.
                el.style.setProperty('--tab-panel-width', width + 'px');
                el.style.setProperty('--tab-panel-height', height + 'px');
                // When animations complete, revert back to auto size.
                Promise.all(el.getAnimations().map((a)=>a.finished)).then(()=>{
                    el.style.setProperty('--tab-panel-width', 'auto');
                    el.style.setProperty('--tab-panel-height', 'auto');
                }).catch(()=>{});
            }
        }
        selectedKeyRef.current = state.selectedKey;
    }, [
        ref,
        state.selectedKey
    ]);
    // Store previous size before DOM updates occur.
    // This breaks the rules of hooks because there is no effect that runs _before_ DOM updates.
    if (state.selectedKey != null && // eslint-disable-next-line rsp-rules/pure-render
    state.selectedKey !== selectedKeyRef.current && ref.current && // eslint-disable-next-line rsp-rules/pure-render
    hasTransition.current) prevSize.current = ref.current.getBoundingClientRect();
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true,
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        render: props.render,
        ...DOMProps,
        ref: ref,
        style: props.style,
        className: props.className || 'react-aria-TabPanels'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props));
});
const $02862c4def27cb80$export$3d96ec278d3efce4 = (0, $19ZgV.createHideableComponent)(function TabPanel(props, forwardedRef) {
    const state = (0, $eF4cA.useContext)($02862c4def27cb80$export$364712098d2aa57c);
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    // Track if the tab panel was initially selected on mount (after extra render to populate the collection).
    // In this case, we don't want to trigger animations.
    let isSelected = state.selectedKey === props.id;
    let [isInitiallySelected, setInitiallySelected] = (0, $eF4cA.useState)(state.selectedKey != null ? isSelected : null);
    if (isInitiallySelected == null && state.selectedKey != null) setInitiallySelected(isSelected);
    else if (!isSelected && isInitiallySelected) setInitiallySelected(false);
    let isExiting = (0, $6AczJ.useExitAnimation)(ref, isSelected);
    if (!isSelected && !props.shouldForceMount && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabPanelInner, {
        ...props,
        tabPanelRef: ref,
        isInitiallySelected: isInitiallySelected || false,
        isExiting: isExiting
    });
});
function $02862c4def27cb80$var$$b4f18e3395fe64d7$var$TabPanelInner(props) {
    let state = (0, $eF4cA.useContext)($02862c4def27cb80$export$364712098d2aa57c);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { id: id, tabPanelRef: ref, isInitiallySelected: isInitiallySelected, isExiting: isExiting, ...otherProps } = props;
    let { tabPanelProps: tabPanelProps } = (0, $cd4495f91e205538$export$fae0121b5afe572d)(props, state, ref);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let isSelected = state.selectedKey === props.id;
    let isEntering = (0, $6AczJ.useEnterAnimation)(ref) && !isInitiallySelected;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-TabPanel',
        values: {
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            // @ts-ignore - compatibility with React < 19
            isInert: (0, $gF3YT.inertValue)(!isSelected),
            isEntering: isEntering,
            isExiting: isExiting,
            state: state
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(otherProps, {
        global: true
    });
    delete DOMProps.id;
    let domProps = isSelected ? (0, $lhKAD.mergeProps)(DOMProps, tabPanelProps, focusProps, renderProps) : (0, $lhKAD.mergeProps)(DOMProps, renderProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...domProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        // @ts-ignore
        inert: (0, $gF3YT.inertValue)(!isSelected || props.inert),
        "data-inert": !isSelected ? 'true' : undefined,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $02862c4def27cb80$export$cfa7aa87c26e7d1f,
                null
            ],
            [
                $02862c4def27cb80$export$364712098d2aa57c,
                null
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8dzVy.CollectionRendererContext).Provider, {
        value: (0, $8dzVy.DefaultCollectionRenderer)
    }, renderProps.children)));
}



var $3g2oV = parcelRequire("3g2oV");

var $fDYaM = parcelRequire("fDYaM");

var $cTXxz = parcelRequire("cTXxz");

var $gF3YT = parcelRequire("gF3YT");

var $hUj7u = parcelRequire("hUj7u");

var $iUErx = parcelRequire("iUErx");

var $4lMDe = parcelRequire("4lMDe");

var $flpop = parcelRequire("flpop");

var $25dFS = parcelRequire("25dFS");

var $dkaC0 = parcelRequire("dkaC0");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $f9wnx = parcelRequire("f9wnx");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2da3e6a4b40eb90e$export$cfa7aa87c26e7d1f = (0, $eF4cA.createContext)(null);
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext = (0, $eF4cA.createContext)({});
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext = (0, $eF4cA.createContext)({
    showTabs: true,
    menuId: '',
    valueId: '',
    tabs: []
});
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tabs = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let flexShrink = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "_v") flexShrink = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc182';
    rules += ' sd182';
    if (!flexShrink) rules += ' _va182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' pt182';
    if (props.orientation === "horizontal") rules += ' _ta182';
    return rules;
};
const $2da3e6a4b40eb90e$export$b2539bed5023c21c = (0, $eF4cA.forwardRef)(function Tabs(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $2da3e6a4b40eb90e$export$cfa7aa87c26e7d1f);
    let { density: density = 'regular', isDisabled: isDisabled, disabledKeys: disabledKeys, orientation: orientation = 'horizontal', labelBehavior: labelBehavior = 'show' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let [value, setValue] = (0, $iUErx.useControlledState)(props.selectedKey, props.defaultSelectedKey ?? null, props.onSelectionChange);
    if (!props['aria-label'] && !props['aria-labelledby']) throw new Error('An aria-label or aria-labelledby prop is required on Tabs for accessibility.');
    let tablistRef = (0, $eF4cA.useRef)(null);
    // Shared base id so child Tab/TabPanel components can derive stable ids.
    let baseId = (0, $25dFS.useId)();
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext,
                {
                    density: density,
                    isDisabled: isDisabled,
                    orientation: orientation,
                    disabledKeys: disabledKeys,
                    selectedKey: value,
                    tablistRef: tablistRef,
                    onSelectionChange: setValue,
                    labelBehavior: labelBehavior,
                    baseId: baseId,
                    'aria-label': props['aria-label'],
                    'aria-labelledby': props['aria-labelledby']
                }
            ]
        ],
        children: (0, $dx4lB.jsx)((0, $3g2oV.CollectionBuilder), {
            content: props.children,
            children: (collection)=>(0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapsingTabs, {
                    ...props,
                    selectedKey: value,
                    onSelectionChange: setValue,
                    collection: collection,
                    containerRef: domRef
                })
        })
    });
});
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablist = function anonymous(props) {
    let rules = " ";
    rules += ' sd182';
    if (props.orientation === "horizontal") {
        if (props.labelBehavior === "hide") {
            if (props.density === "regular") rules += ' Uj182';
            else if (props.density === "compact") rules += ' Ul182';
        } else if (props.density === "regular") rules += ' Up182';
        else if (props.density === "compact") rules += ' Uj182';
    }
    if (props.orientation === "horizontal") {
        if (props.labelBehavior === "hide") {
            if (props.density === "regular") rules += ' qj182';
            else if (props.density === "compact") rules += ' ql182';
        } else if (props.density === "regular") rules += ' qp182';
        else if (props.density === "compact") rules += ' qj182';
    }
    if (props.orientation === "vertical") rules += ' _ta182';
    if (props.orientation === "vertical") rules += ' Hz182';
    if (props.orientation === "vertical") rules += ' Ix182';
    rules += ' Nq182';
    return rules;
};
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablistWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let minWidth = false;
    let flexShrink = false;
    let flexGrow = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_u") flexGrow = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc182';
    if (!minWidth) rules += ' Na182';
    if (!flexShrink) rules += ' _va182';
    if (!flexGrow) rules += ' _ua182';
    return rules;
};
function $2da3e6a4b40eb90e$export$e51a686c67fdaa2d(props) {
    let { showTabs: showTabs, menuId: menuId, valueId: valueId, tabs: tabs, listRef: listRef, onSelectionChange: onSelectionChange, ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext) ?? {};
    let { density: density, orientation: orientation, labelBehavior: labelBehavior } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext);
    if (showTabs) return (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$TabListInner, {
        ...props
    });
    return (0, $dx4lB.jsxs)("div", {
        className: $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablistWrapper(null, props.styles),
        children: [
            listRef && (0, $dx4lB.jsx)("div", {
                className: $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablist({
                    orientation: orientation,
                    labelBehavior: labelBehavior,
                    density: density
                }),
                children: (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$HiddenTabs, {
                    items: tabs,
                    density: density,
                    listRef: listRef
                })
            }),
            (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$TabsMenu, {
                id: menuId,
                valueId: valueId,
                items: tabs,
                onSelectionChange: onSelectionChange,
                "aria-label": ariaLabel,
                "aria-describedby": ariaDescribedBy
            })
        ]
    });
}
function $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$TabListInner(props) {
    let { tablistRef: tablistRef, orientation: orientation, density: density, labelBehavior: labelBehavior, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext) ?? {};
    let { tabs: tabs, listRef: listRef } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext) ?? {};
    return (0, $dx4lB.jsxs)("div", {
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablistWrapper(null, props.styles),
        children: [
            listRef && (0, $dx4lB.jsx)("div", {
                className: $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablist({
                    orientation: orientation,
                    labelBehavior: labelBehavior,
                    density: density
                }),
                children: (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$HiddenTabs, {
                    items: tabs,
                    density: density,
                    listRef: listRef
                })
            }),
            (0, $dx4lB.jsx)((0, $02862c4def27cb80$export$e51a686c67fdaa2d), {
                ...props,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                ref: tablistRef,
                className: (renderProps)=>$2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tablist({
                        ...renderProps,
                        labelBehavior: labelBehavior,
                        density: density
                    })
            })
        ]
    });
}
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$selectedIndicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    if (props.isDisabled) rules += ' gH182';
    else rules += ' g0182';
    if (props.isDisabled) rules += ' gld182';
    else rules += ' gle182';
    if (props.orientation === "horizontal") rules += ' FLvNfn182';
    else rules += ' Fb182';
    if (props.orientation === "vertical") rules += ' ZLvNfn182';
    else rules += ' Za182';
    rules += ' _qg182';
    rules += ' YIRyJjb182';
    rules += ' Ydklsgce182';
    rules += ' Xc182';
    rules += ' _2a182';
    rules += ' _lr182';
    if (props.orientation === "vertical") rules += ' Wr182';
    if (props.orientation === "horizontal") rules += ' _Er182';
    if (props.orientation === "vertical") rules += ' _Aa182';
    rules += ' _je182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    return rules;
};
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tab = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let flexShrink = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "_v") flexShrink = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' sd182';
    if (props.isDisabled) rules += ' pp182';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    } else {
        if (props.isPressed) rules += ' pt182';
        else if (props.isFocusVisible) rules += ' pt182';
        else if (props.isHovered) rules += ' pt182';
        else rules += ' pv182';
    }
    if (props.isDisabled) rules += ' plc182';
    else if (props.isSelected) rules += ' pld182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    rules += ' Uc182';
    rules += ' Usd182';
    rules += ' qc182';
    rules += ' qsd182';
    if (props.orientation === "horizontal") {
        if (props.density === "regular") rules += ' Fz182';
        else if (props.density === "compact") rules += ' Fx182';
    }
    if (props.orientation === "vertical") {
        if (props.density === "regular") rules += ' Mk182';
        else if (props.density === "compact") rules += ' Mi182';
    }
    rules += ' eb182';
    if (!position) rules += ' _Pc182';
    rules += ' ri182';
    rules += ' _Xa182';
    if (!flexShrink) rules += ' _va182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.labelBehavior === "hide") rules += ' SssxDec182';
    if (props.labelBehavior === "hide") rules += ' RssxDec182';
    rules += ' __ca182';
    return rules;
};
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$icon = " sb182 _va182 -_8sjo0b-t5ZbAob182";
function $2da3e6a4b40eb90e$export$3e41faf802a29e71(props1) {
    let { density: density, orientation: orientation, labelBehavior: labelBehavior, baseId: baseId } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext) ?? {};
    // Derive a stable content id from the shared baseId on InternalTabsContext.
    // Prevents infinite loop when rendering across multiple CollectionBuilder portals.
    let fallbackId = (0, $25dFS.useId)();
    let contentId = `${baseId ?? fallbackId}-content-${props1.id ?? fallbackId}`;
    let ariaLabelledBy = props1['aria-labelledby'] || '';
    return (0, $dx4lB.jsx)((0, $02862c4def27cb80$export$3e41faf802a29e71), {
        ...props1,
        // @ts-ignore
        originalProps: props1,
        "aria-labelledby": `${labelBehavior === 'hide' ? contentId : ''} ${ariaLabelledBy}`,
        style: props1.UNSAFE_style,
        className: (renderProps)=>(props1.UNSAFE_className || '') + $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tab({
                ...renderProps,
                density: density,
                labelBehavior: labelBehavior,
                orientation: orientation
            }, props1.styles),
        children: ({ isMenu: isMenu, isDisabled: isDisabled })=>{
            if (isMenu) return props1.children;
            else return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $208Op.TextContext),
                        {
                            id: contentId,
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' _Jb182';
                                if (props.labelBehavior === "hide") rules += ' sk182';
                                return rules;
                            }({
                                labelBehavior: labelBehavior
                            })
                        }
                    ],
                    [
                        (0, $dm5H1.IconContext),
                        {
                            render: (0, $8OJ2z.centerBaseline)({
                                slot: 'icon',
                                styles: " _Ja182"
                            }),
                            styles: $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$icon
                        }
                    ]
                ],
                children: (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$TabInner, {
                    orientation: orientation,
                    isDisabled: isDisabled,
                    children: typeof props1.children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: props1.children
                    }) : props1.children
                })
            });
        }
    });
}
function $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$TabInner({ isDisabled: isDisabled, orientation: orientation, children: children }) {
    let ref = (0, $eF4cA.useRef)(null);
    let isHidden = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$HiddenTabsContext);
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            !isHidden && (0, $dx4lB.jsx)((0, $hUj7u.SelectionIndicator), {
                ref: ref,
                className: $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$selectedIndicator({
                    isDisabled: isDisabled,
                    orientation: orientation
                })
            }),
            children
        ]
    });
}
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tabPanel = function anonymous(props, overrides) {
    let rules = " ";
    let marginTop = false;
    let flexGrow = false;
    let minHeight = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "J") marginTop = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "M") minHeight = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (!marginTop) rules += ' Js182';
    rules += ' pt182';
    if (!flexGrow) rules += ' _ub182';
    if (!minHeight) rules += ' Ma182';
    if (props.isInert) rules += ' sk182';
    else rules += ' sb182';
    return rules;
};
function $2da3e6a4b40eb90e$export$3d96ec278d3efce4(props) {
    let { showTabs: showTabs } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext);
    let { selectedKey: selectedKey } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext);
    if (showTabs) return (0, $dx4lB.jsx)((0, $02862c4def27cb80$export$3d96ec278d3efce4), {
        ...props,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className ?? '') + $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tabPanel(renderProps, props.styles)
    });
    if (props.id !== selectedKey) return null;
    return (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapsedTabPanel, {
        ...props
    });
}
function $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapsedTabPanel(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', id: id, shouldForceMount: shouldForceMount, ...otherProps } = props;
    let { menuId: menuId, valueId: valueId } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext);
    let ref = (0, $eF4cA.useRef)(null);
    let tabIndex = (0, $flpop.useHasTabbableChild)(ref) ? undefined : 0;
    return (0, $dx4lB.jsx)((0, $cTXxz.Group), {
        ...otherProps,
        ref: ref,
        "aria-labelledby": menuId + ' ' + valueId,
        tabIndex: tabIndex,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tabPanel(renderProps, props.styles)
    });
}
function $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$isEveryTabDisabled(collection, disabledKeys) {
    let testKey = null;
    if (collection && collection.size > 0) {
        testKey = collection.getFirstKey();
        let index = 0;
        while(testKey && index < collection.size){
            // We have to check if the item in the collection has a key in disabledKeys or has the isDisabled prop set directly on it
            if (!disabledKeys.has(testKey) && !collection.getItem(testKey)?.props?.isDisabled) return false;
            testKey = collection.getKeyAfter(testKey);
            index++;
        }
        return true;
    }
    return false;
}
const $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$HiddenTabsContext = (0, $eF4cA.createContext)(false);
let $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$HiddenTabs = function(props) {
    let { listRef: listRef, items: items = [], size: size, density: density } = props;
    return (0, $dx4lB.jsx)("div", {
        // @ts-ignore
        inert: (0, $gF3YT.inertValue)(true),
        ref: listRef,
        className: " s40ub4c182 _t40ub4c182 U40ub4c182 q40ub4c182 _w40ub4c182 _Pa182 Wr182 _lr182 _Ar182 _zr182 _6b182 _Nc182 Pc182 _Ia182",
        children: (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$HiddenTabsContext.Provider, {
            value: true,
            children: items.map((item)=>{
                // pull off individual props as an allow list, don't want refs or other props getting through
                return (0, $dx4lB.jsx)("div", {
                    "data-hidden-tab": true,
                    style: item.props.UNSAFE_style,
                    className: item.props.className({
                        size: size,
                        density: density
                    }),
                    children: item.props.children({
                        size: size,
                        density: density
                    })
                }, item.key);
            })
        })
    });
};
let $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$TabsMenu = (props1)=>{
    let { id: id, items: items, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, valueId: valueId } = props1;
    let { density: density, onSelectionChange: _onSelectionChange, selectedKey: selectedKey, isDisabled: isDisabled, disabledKeys: disabledKeys, labelBehavior: labelBehavior } = (0, $eF4cA.useContext)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$InternalTabsContext);
    let onSelectionChange = (0, $eF4cA.useCallback)((key)=>{
        if (key != null) _onSelectionChange?.(key);
    }, [
        _onSelectionChange
    ]);
    let state = (0, $eF4cA.useContext)((0, $02862c4def27cb80$export$364712098d2aa57c));
    let allKeysDisabled = (0, $eF4cA.useMemo)(()=>{
        return $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$isEveryTabDisabled(state?.collection, disabledKeys ? new Set(disabledKeys) : new Set());
    }, [
        state?.collection,
        disabledKeys
    ]);
    let labelProps = (0, $dkaC0.useLabels)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledBy
    });
    return (0, $dx4lB.jsx)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd182';
            rules += ' _va182';
            rules += ' eb182';
            if (props.density === "regular") rules += ' Fz182';
            else if (props.density === "compact") rules += ' Fx182';
            return rules;
        }({
            density: density
        }),
        children: (0, $dx4lB.jsx)((0, $6d8ae065df3d188d$export$ba25329847403e11), {
            id: id,
            valueId: valueId,
            ...labelProps,
            "aria-describedby": props1['aria-describedby'],
            "aria-details": props1['aria-details'],
            isDisabled: isDisabled || allKeysDisabled,
            density: density,
            labelBehavior: labelBehavior,
            items: items,
            disabledKeys: disabledKeys,
            selectedKey: selectedKey,
            onSelectionChange: onSelectionChange,
            children: (item)=>{
                return (0, $eF4cA.createElement)((0, $6d8ae065df3d188d$export$d601881f38163e28), {
                    ...item.props.originalProps,
                    isDisabled: isDisabled || allKeysDisabled,
                    key: item.key
                }, item.props.children({
                    density: density,
                    isMenu: true
                }));
            }
        })
    });
};
let $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapsingTabs = ({ collection: collection, containerRef: containerRef, ...props })=>{
    let { orientation: orientation = 'horizontal', onSelectionChange: onSelectionChange } = props;
    let [showItems, _setShowItems] = (0, $eF4cA.useState)(true);
    showItems = orientation === 'vertical' ? true : showItems;
    let setShowItems = (0, $eF4cA.useCallback)((value)=>{
        if (orientation === 'vertical') _setShowItems(true);
        else _setShowItems(value);
    }, [
        orientation
    ]);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let children = (0, $eF4cA.useMemo)(()=>[
            ...collection
        ], [
        collection
    ]);
    let listRef = (0, $eF4cA.useRef)(null);
    let updateOverflow = ()=>{
        if (orientation === 'vertical' || !listRef.current || !containerRef?.current) return;
        let container = listRef.current;
        let containerRect = container.getBoundingClientRect();
        let tabs = container.querySelectorAll('[data-hidden-tab]');
        let lastTab = tabs[tabs.length - 1];
        let lastTabRect = lastTab.getBoundingClientRect();
        if (direction === 'ltr') setShowItems?.(lastTabRect.right <= containerRect.right);
        else setShowItems?.(lastTabRect.left >= containerRect.left);
    };
    let updateOverflowEffect = (0, $4lMDe.useEffectEvent)(updateOverflow);
    (0, $f9wnx.useResizeObserver)({
        ref: containerRef,
        onResize: updateOverflow
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        if (collection.size > 0) queueMicrotask(updateOverflowEffect);
    }, [
        collection.size
    ]);
    // start with null so that the first render won't have a flicker
    let prevOrientation = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        if (collection.size > 0 && prevOrientation.current !== orientation) updateOverflowEffect();
        prevOrientation.current = orientation;
    }, [
        collection.size,
        orientation
    ]);
    (0, $eF4cA.useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateOverflowEffect());
    }, []);
    let menuId = (0, $25dFS.useId)();
    let valueId = (0, $25dFS.useId)();
    let contents;
    if (showItems) contents = (0, $dx4lB.jsx)((0, $02862c4def27cb80$export$b2539bed5023c21c), {
        ...props,
        className: "",
        style: {
            display: 'contents'
        },
        children: props.children
    });
    else contents = (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext.Provider, {
            value: {
                showTabs: false,
                tabs: children,
                menuId: menuId,
                valueId: valueId,
                listRef: listRef,
                onSelectionChange: onSelectionChange,
                ariaLabel: props['aria-label'],
                ariaDescribedBy: props['aria-labelledby']
            },
            children: props.children
        })
    });
    return (0, $dx4lB.jsx)("div", {
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + $2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$tabs({
            orientation: orientation
        }, props.styles),
        ref: containerRef,
        children: (0, $dx4lB.jsx)($2da3e6a4b40eb90e$var$$79e2b4a1b34d1592$var$CollapseContext.Provider, {
            value: {
                showTabs: true,
                menuId: menuId,
                valueId: valueId,
                tabs: children,
                listRef: listRef
            },
            children: contents
        })
    });
};


var $208Op = parcelRequire("208Op");

var $dqZbZ = parcelRequire("dqZbZ");

var $9eyCh = parcelRequire("9eyCh");

var $5IZkx = parcelRequire("5IZkx");

var $fmJ8d = parcelRequire("fmJ8d");

var $lRNYL = parcelRequire("lRNYL");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $40d64a8bef637d73$var$$b3e9f60d11647129$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m17.13 5.734-5.75-4.472c-.812-.631-1.948-.632-2.76 0L2.87 5.735h-.002C2.324 6.157 2 6.821 2 7.511v8.239C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V7.51c0-.689-.324-1.353-.87-1.776M11.5 16.5h-3v-4.75c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75zm5-.75c0 .413-.337.75-.75.75H13v-4.75c0-1.24-1.01-2.25-2.25-2.25h-1.5C8.01 9.5 7 10.51 7 11.75v4.75H4.25c-.413 0-.75-.337-.75-.75V7.51c0-.229.108-.45.29-.592l5.75-4.47c.272-.213.65-.21.92-.002l5.75 4.472c.182.142.29.363.29.593z"
        })
    });
const $40d64a8bef637d73$var$$b3e9f60d11647129$var$ForwardRef = (0, $eF4cA.forwardRef)($40d64a8bef637d73$var$$b3e9f60d11647129$var$SvgComponent);
var $40d64a8bef637d73$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($40d64a8bef637d73$var$$b3e9f60d11647129$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $5b586339547de296$var$$f8ca0ce2580450e3$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.75 5h-5.964c-.218 0-.424-.095-.567-.259L8.516 2.776C8.088 2.283 7.468 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M3.25 3.5h3.565c.218 0 .424.095.567.259L8.458 5H2.5v-.75c0-.413.336-.75.75-.75M17.5 14.75c0 .413-.336.75-.75.75H3.25c-.414 0-.75-.337-.75-.75V6.5h14.25c.414 0 .75.337.75.75z"
        })
    });
const $5b586339547de296$var$$f8ca0ce2580450e3$var$ForwardRef = (0, $eF4cA.forwardRef)($5b586339547de296$var$$f8ca0ce2580450e3$var$SvgComponent);
var $5b586339547de296$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($5b586339547de296$var$$f8ca0ce2580450e3$var$ForwardRef);




var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $eb2ff098ae4f336c$var$$f80b027738a95a07$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const $eb2ff098ae4f336c$var$$f80b027738a95a07$var$ForwardRef = (0, $eF4cA.forwardRef)($eb2ff098ae4f336c$var$$f80b027738a95a07$var$SvgComponent);
var $eb2ff098ae4f336c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($eb2ff098ae4f336c$var$$f80b027738a95a07$var$ForwardRef);


const $8378bdc454a470ad$var$PanelIcon = (0, $dm5H1.createIcon)((props)=>{
    const { state: state, isHovered: isHovered, ...otherProps } = props;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "var(--iconPrimary)",
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                d: "M15.75 18H4.25C3.00977 18 2 16.9907 2 15.75V4.25C2 3.00928 3.00977 2 4.25 2H15.75C16.9902 2 18 3.00928 18 4.25V15.75C18 16.9907 16.9902 18 15.75 18ZM4.25 3.5C3.83691 3.5 3.5 3.83643 3.5 4.25V15.75C3.5 16.1636 3.83691 16.5 4.25 16.5H15.75C16.1631 16.5 16.5 16.1636 16.5 15.75V4.25C16.5 3.83643 16.1631 3.5 15.75 3.5H4.25Z",
                fill: "var(--iconPrimary)"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                x: 5,
                y: 5,
                rx: 0.5,
                height: 10,
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' YVdv3s182';
                    rules += ' XCIisn182';
                    rules += ' _2b182';
                    if (props.isHovered) {
                        if (props.state === "collapsed") rules += ' ZsmOfn182';
                        else if (props.state === "expanded") rules += ' Zlr4hn182';
                        else {
                            rules += ' ZsmOfn182';
                            rules += ' Zplr4hn182';
                        }
                    } else if (props.state === "collapsed") rules += ' Zlr4hn182';
                    else if (props.state === "expanded") rules += ' ZsmOfn182';
                    else {
                        rules += ' Zlr4hn182';
                        rules += ' ZpsmOfn182';
                    }
                    return rules;
                }({
                    state: state,
                    isHovered: isHovered
                })
            })
        ]
    });
});
$8378bdc454a470ad$var$PanelIcon.propTypes = {
    state: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "expanded",
        "collapsed"
    ]).isRequired,
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool.isRequired
};
const $8378bdc454a470ad$var$PanelToggleButton = ({ isCollapsed: isCollapsed, onPress: onPress })=>{
    const [isHovered, setIsHovered] = (0, $eF4cA.useState)(false);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
        isQuiet: true,
        // size="S"
        onPress: onPress,
        onHoverChange: setIsHovered,
        "aria-label": isCollapsed ? "Expand side navigation" : "Collapse side navigation",
        styles: function anonymous(props) {
            let rules = " ";
            rules += ' JM182';
            rules += ' IM182';
            if (props.isCollapsed) rules += ' HM182';
            else rules += ' Hy182';
            return rules;
        }({
            isCollapsed: isCollapsed
        }),
        children: /*#__PURE__*/ (0, $dx4lB.jsx)($8378bdc454a470ad$var$PanelIcon, {
            isHovered: isHovered,
            state: isCollapsed ? "collapsed" : "expanded"
        })
    });
};
$8378bdc454a470ad$var$PanelToggleButton.propTypes = {
    isCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool.isRequired,
    onPress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};
const $8378bdc454a470ad$export$1a35787d6353cf6a = ({ styles: styles })=>{
    const isHome = (0, $dqZbZ.useMatch)("/");
    const isStories = (0, $dqZbZ.useMatch)("/stories/*");
    const isProjects = (0, $dqZbZ.useMatch)("/projects/*");
    const isTemplates = (0, $dqZbZ.useMatch)("/templates/*");
    const isAdminRoute = (0, $dqZbZ.useMatch)("/admin/*");
    const isCopilot = (0, $dqZbZ.useMatch)("/_copilot/*");
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    const isSideNavCollapsed = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isSideNavCollapsed);
    const setSideNavCollapsed = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setSideNavCollapsed);
    const navigate = (0, $dqZbZ.useNavigate)();
    const [selectedKey, setSelectedKey] = (0, $eF4cA.useState)("home");
    (0, $eF4cA.useEffect)(()=>{
        if (isHome) setSelectedKey("home");
        else if (isStories) setSelectedKey("stories");
        else if (isProjects) setSelectedKey("projects");
        else if (isTemplates) setSelectedKey("templates");
        else if (isAdminRoute) setSelectedKey("admin");
        else if (isCopilot) setSelectedKey("copilot");
    }, [
        isHome,
        isStories,
        isProjects,
        isTemplates,
        isAdminRoute,
        isCopilot
    ]);
    const paths = (0, $eF4cA.useMemo)(()=>[
            {
                key: "home",
                path: "/",
                match: "/",
                name: "Home",
                icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $40d64a8bef637d73$export$2e2bcd8739ae039), {})
            },
            {
                key: "projects",
                path: "/projects",
                match: "/projects/*",
                name: "Projects",
                icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5b586339547de296$export$2e2bcd8739ae039), {})
            },
            // {
            //   key: "stories",
            //   path: "/stories",
            //   match: "/stories/*",
            //   name: "Stories",
            //   icon: <SlideshowIcon />,
            // },
            // {
            //   key: "stories",
            //   path: "/stories",
            //   match: "/stories/*",
            //   name: "Stories",
            //   icon: <ProjectIcon />,
            // },
            // {
            //   key: "templates",
            //   path: "/templates",
            //   match: "/templates/*",
            //   name: "Templates",
            //   icon: <TemplateIcon />,
            // },
            ...isAdmin ? [
                {
                    key: "admin",
                    path: "/admin",
                    match: "/admin/*",
                    name: "Admin",
                    icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $eb2ff098ae4f336c$export$2e2bcd8739ae039), {})
                }
            ] : []
        ], [
        isAdmin
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _ta182';
            rules += ' Fb182';
            if (props.state === "collapsed") rules += ' ZC182';
            else if (props.state === "expanded") rules += ' Zq182';
            else {
                rules += ' ZC182';
                rules += ' Zpq182';
            }
            rules += ' _Nb182';
            rules += ' Pb182';
            rules += ' YVdv3s182';
            rules += ' XCIisn182';
            rules += ' _2b182';
            return rules;
        }({
            state: isSideNavCollapsed ? "collapsed" : "expanded"
        }) + styles,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2da3e6a4b40eb90e$export$b2539bed5023c21c), {
                "aria-label": "Side Navigation",
                selectedKey: selectedKey,
                orientation: "vertical",
                density: "compact",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2da3e6a4b40eb90e$export$e51a686c67fdaa2d), {
                    UNSAFE_className: " Ib182 __SideNav",
                    children: paths.map(({ key: key, path: path, match: match, name: name, icon: icon })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2da3e6a4b40eb90e$export$3e41faf802a29e71), {
                            id: key,
                            onPress: ()=>navigate(path),
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        if (props.state === "collapsed") rules += ' _Ia182';
                                        else if (props.state === "expanded") rules += ' _Ib182';
                                        else {
                                            rules += ' _Ia182';
                                            rules += ' _Ipb182';
                                        }
                                        if (props.state === "collapsed") rules += ' ZDWMfn182';
                                        else if (props.state === "expanded") rules += ' ZJ182';
                                        else {
                                            rules += ' ZDWMfn182';
                                            rules += ' ZpJ182';
                                        }
                                        rules += ' YcqaRkb182';
                                        rules += ' XCIisn182';
                                        rules += ' _2b182';
                                        return rules;
                                    }({
                                        state: isSideNavCollapsed ? "collapsed" : "expanded"
                                    }),
                                    children: name
                                })
                            ]
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)($8378bdc454a470ad$var$PanelToggleButton, {
                isCollapsed: isSideNavCollapsed,
                onPress: ()=>setSideNavCollapsed(!isSideNavCollapsed)
            })
        ]
    });
};
$8378bdc454a470ad$export$1a35787d6353cf6a.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $5IZkx = parcelRequire("5IZkx");

var $34HUQ = parcelRequire("34HUQ");

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $fc96356a4e65e139$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 16 16",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                width: 2.4,
                height: 11.2,
                x: 4.5,
                y: 2.4,
                fill: "#000",
                rx: 1.2
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                width: 2.4,
                height: 11.2,
                x: 9.1,
                y: 2.4,
                fill: "#000",
                rx: 1.2
            })
        ]
    });
const $fc96356a4e65e139$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($fc96356a4e65e139$var$SvgComponent);
var $fc96356a4e65e139$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($fc96356a4e65e139$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $018662ae9d9c44c5$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 16,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 20 16",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "#000",
            d: "M6.5 2.4c0-.44.38-.68.76-.46l7.6 5.4c.32.18.32 1.14 0 1.32l-7.6 5.4c-.38.22-.76-.02-.76-.46z"
        })
    });
const $018662ae9d9c44c5$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($018662ae9d9c44c5$var$SvgComponent);
var $018662ae9d9c44c5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($018662ae9d9c44c5$var$ForwardRef);



var $fmJ8d = parcelRequire("fmJ8d");
const $0a53e8d7a144b92d$export$3c7591733da6b830 = ({ src: src, variant: variant = "default" })=>{
    const videoRef = (0, $eF4cA.useRef)(null);
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const [isPlaying, setIsPlaying] = (0, $eF4cA.useState)(localStorage.getItem("backgroundVideoPlaying") !== "false");
    const handleTogglePlay = (0, $eF4cA.useCallback)(()=>{
        if (!videoRef.current) return;
        if (isPlaying) {
            videoRef.current.pause();
            setIsPlaying(false);
        } else {
            videoRef.current.play();
            setIsPlaying(true);
        }
        localStorage.setItem("backgroundVideoPlaying", String(!isPlaying));
    }, [
        isPlaying
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sk182 spb182 _Pa182 Wr182 _Er182 fcJcitc182 Za182 _Nc182 Pc182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("video", {
                ref: videoRef,
                src: src,
                autoPlay: isPlaying,
                loop: true,
                muted: true,
                playsInline: true,
                className: " _9AZKy182 _Pa182 Wr182 _Er182 Za182 Fb182 _Hb182 __Di182 _Ob182"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' _9a182';
                    rules += ' _Pa182';
                    rules += ' Wr182';
                    rules += ' _Er182';
                    rules += ' Za182';
                    rules += ' Fb182';
                    if (props.variant === "faded") {
                        if (props.colorScheme === "light") {
                            rules += ' _iyDCVDc182';
                            rules += ' -yBNtrc-xpP0Sb182';
                            rules += ' -zBNtrc-AnB4Le182';
                            rules += ' -ACNtrc-Qbffyb182';
                        } else if (props.colorScheme === "dark") {
                            rules += ' _iyDCVDc182';
                            rules += ' -yBNtrc-xpP0Sb182';
                            rules += ' -zBNtrc-YTfire182';
                            rules += ' -ACNtrc-Qbffyb182';
                        }
                    } else if (props.variant === "default") {
                        rules += ' _iyDCVDc182';
                        rules += ' -yBNtrc-xpP0Sb182';
                        rules += ' -zBNtrc-RWHrbc182';
                        rules += ' -ACNtrc-Qbffyb182';
                    }
                    rules += ' _Ob182';
                    return rules;
                }({
                    variant: variant,
                    colorScheme: colorScheme
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                variant: "secondary",
                staticColor: "white",
                size: "L",
                onPress: handleTogglePlay,
                "aria-label": isPlaying ? "Pause video" : "Play video",
                styles: " _Pa182 Wu182 _zu182 _9d182",
                children: isPlaying ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fc96356a4e65e139$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $018662ae9d9c44c5$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
$0a53e8d7a144b92d$export$3c7591733da6b830.propTypes = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "default",
        "faded"
    ])
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $4UbTp = parcelRequire("4UbTp");
var $208Op = parcelRequire("208Op");
var $dbeadf8587015ddd$exports = {};
/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/ "use strict";
Object.defineProperty($dbeadf8587015ddd$exports, "__esModule", {
    value: true
});
$dbeadf8587015ddd$exports.A4uInfo = $dbeadf8587015ddd$var$A4uInfo;

var $dbeadf8587015ddd$var$_react = $dbeadf8587015ddd$var$_interopRequireDefault((parcelRequire("eF4cA")));
function $dbeadf8587015ddd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $dbeadf8587015ddd$var$_extends() {
    $dbeadf8587015ddd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dbeadf8587015ddd$var$_extends.apply(this, arguments);
}
function $dbeadf8587015ddd$var$A4uInfo(_ref) {
    var props = $dbeadf8587015ddd$var$_extends({}, _ref);
    return /*#__PURE__*/ $dbeadf8587015ddd$var$_react["default"].createElement("svg", $dbeadf8587015ddd$var$_extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ $dbeadf8587015ddd$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm-.3,4.3a2.718,2.718,0,0,1,2.864,2.824A2.664,2.664,0,0,1,17.7,11.987a2.705,2.705,0,0,1-2.864-2.864A2.717,2.717,0,0,1,17.7,6.3ZM22,27a1,1,0,0,1-1,1H15a1,1,0,0,1-1-1V25a1,1,0,0,1,1-1h1V18H15a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v9h1a1,1,0,0,1,1,1Z"
    }));
}



var $eF4cA = parcelRequire("eF4cA");

var $hWe38 = parcelRequire("hWe38");
const $55241d54ef9d57b7$var$$367536236d783ddf$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
$55241d54ef9d57b7$var$$367536236d783ddf$var$Context.displayName = 'BreakpointContext';
function $55241d54ef9d57b7$export$8214320346cf5104(props) {
    let { children: children, matchedBreakpoints: matchedBreakpoints } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($55241d54ef9d57b7$var$$367536236d783ddf$var$Context.Provider, {
        value: {
            matchedBreakpoints: matchedBreakpoints
        }
    }, children);
}
function $55241d54ef9d57b7$export$140ae7baa51cca23(breakpoints) {
    let entries = Object.entries(breakpoints).sort(([, valueA], [, valueB])=>valueB - valueA);
    let breakpointQueries = entries.map(([, value])=>`(min-width: ${value}px)`);
    let supportsMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    let getBreakpointHandler = ()=>{
        let matched = [];
        for(let i in breakpointQueries){
            let query = breakpointQueries[i];
            if (window.matchMedia(query).matches) matched.push(entries[i][0]);
        }
        matched.push('base');
        return matched;
    };
    let [breakpoint, setBreakpoint] = (0, $eF4cA.useState)(()=>supportsMatchMedia ? getBreakpointHandler() : [
            'base'
        ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let onResize = ()=>{
            const breakpointHandler = getBreakpointHandler();
            setBreakpoint((previousBreakpointHandler)=>{
                if (previousBreakpointHandler.length !== breakpointHandler.length || previousBreakpointHandler.some((breakpoint, idx)=>breakpoint !== breakpointHandler[idx])) return [
                    ...breakpointHandler
                ]; // Return a new array to force state change
                return previousBreakpointHandler;
            });
        };
        window.addEventListener('resize', onResize);
        return ()=>{
            window.removeEventListener('resize', onResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        supportsMatchMedia
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, $hWe38.useIsSSR)();
    return isSSR ? [
        'base'
    ] : breakpoint;
}
function $55241d54ef9d57b7$export$199d6754bdf4e1e3() {
    return (0, $eF4cA.useContext)($55241d54ef9d57b7$var$$367536236d783ddf$var$Context);
}



var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4e665a4f60367a7f$export$fe9c6e915565b4e8 = {
    margin: [
        'margin',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    marginStart: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('marginLeft', 'marginRight'),
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    marginEnd: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('marginRight', 'marginLeft'),
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    // marginLeft: ['marginLeft', dimensionValue],
    // marginRight: ['marginRight', dimensionValue],
    marginTop: [
        'marginTop',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    marginBottom: [
        'marginBottom',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    marginX: [
        [
            'marginLeft',
            'marginRight'
        ],
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    marginY: [
        [
            'marginTop',
            'marginBottom'
        ],
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    width: [
        'width',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    height: [
        'height',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    minWidth: [
        'minWidth',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    minHeight: [
        'minHeight',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    maxWidth: [
        'maxWidth',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    maxHeight: [
        'maxHeight',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    isHidden: [
        'display',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$hiddenValue
    ],
    alignSelf: [
        'alignSelf',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    justifySelf: [
        'justifySelf',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    position: [
        'position',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$anyValue
    ],
    zIndex: [
        'zIndex',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$anyValue
    ],
    top: [
        'top',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    bottom: [
        'bottom',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    start: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('left', 'right'),
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    end: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('right', 'left'),
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    left: [
        'left',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    right: [
        'right',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    order: [
        'order',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$anyValue
    ],
    flex: [
        'flex',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$flexValue
    ],
    flexGrow: [
        'flexGrow',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    flexShrink: [
        'flexShrink',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    flexBasis: [
        'flexBasis',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridArea: [
        'gridArea',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridColumn: [
        'gridColumn',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridColumnEnd: [
        'gridColumnEnd',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridColumnStart: [
        'gridColumnStart',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridRow: [
        'gridRow',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridRowEnd: [
        'gridRowEnd',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ],
    gridRowStart: [
        'gridRowStart',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ]
};
const $4e665a4f60367a7f$export$e0705d1a55f297c = {
    ...$4e665a4f60367a7f$export$fe9c6e915565b4e8,
    backgroundColor: [
        'backgroundColor',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$backgroundColorValue
    ],
    borderWidth: [
        'borderWidth',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderStartWidth: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderLeftWidth', 'borderRightWidth'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderEndWidth: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderRightWidth', 'borderLeftWidth'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderLeftWidth: [
        'borderLeftWidth',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderRightWidth: [
        'borderRightWidth',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderTopWidth: [
        'borderTopWidth',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderBottomWidth: [
        'borderBottomWidth',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderXWidth: [
        [
            'borderLeftWidth',
            'borderRightWidth'
        ],
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderYWidth: [
        [
            'borderTopWidth',
            'borderBottomWidth'
        ],
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue
    ],
    borderColor: [
        'borderColor',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderStartColor: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderLeftColor', 'borderRightColor'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderEndColor: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderRightColor', 'borderLeftColor'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderLeftColor: [
        'borderLeftColor',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderRightColor: [
        'borderRightColor',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderTopColor: [
        'borderTopColor',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderBottomColor: [
        'borderBottomColor',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderXColor: [
        [
            'borderLeftColor',
            'borderRightColor'
        ],
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderYColor: [
        [
            'borderTopColor',
            'borderBottomColor'
        ],
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue
    ],
    borderRadius: [
        'borderRadius',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopStartRadius: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderTopLeftRadius', 'borderTopRightRadius'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopEndRadius: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderTopRightRadius', 'borderTopLeftRadius'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomStartRadius: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderBottomLeftRadius', 'borderBottomRightRadius'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomEndRadius: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('borderBottomRightRadius', 'borderBottomLeftRadius'),
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopLeftRadius: [
        'borderTopLeftRadius',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderTopRightRadius: [
        'borderTopRightRadius',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomLeftRadius: [
        'borderBottomLeftRadius',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    borderBottomRightRadius: [
        'borderBottomRightRadius',
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue
    ],
    padding: [
        'padding',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingStart: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('paddingLeft', 'paddingRight'),
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingEnd: [
        $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl('paddingRight', 'paddingLeft'),
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingLeft: [
        'paddingLeft',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingRight: [
        'paddingRight',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingTop: [
        'paddingTop',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingBottom: [
        'paddingBottom',
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingX: [
        [
            'paddingLeft',
            'paddingRight'
        ],
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    paddingY: [
        [
            'paddingTop',
            'paddingBottom'
        ],
        $4e665a4f60367a7f$export$abc24f5b99744ea6
    ],
    overflow: [
        'overflow',
        $4e665a4f60367a7f$export$46b6c81d11d2c30a
    ]
};
const $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderStyleProps = {
    borderWidth: 'borderStyle',
    borderLeftWidth: 'borderLeftStyle',
    borderRightWidth: 'borderRightStyle',
    borderTopWidth: 'borderTopStyle',
    borderBottomWidth: 'borderBottomStyle'
};
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$rtl(ltr, rtl) {
    return (direction)=>direction === 'rtl' ? rtl : ltr;
}
const $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$UNIT_RE = /(%|px|em|rem|vw|vh|auto|cm|mm|in|pt|pc|ex|ch|rem|vmin|vmax|fr)$/;
const $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$FUNC_RE = /^\s*\w+\(/;
const $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$SPECTRUM_VARIABLE_RE = /(static-)?size-\d+|single-line-(height|width)/g;
function $4e665a4f60367a7f$export$abc24f5b99744ea6(value) {
    if (typeof value === 'number') return value + 'px';
    if (!value) return undefined;
    if ($4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$UNIT_RE.test(value)) return value;
    if ($4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$FUNC_RE.test(value)) return value.replace($4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$SPECTRUM_VARIABLE_RE, 'var(--spectrum-global-dimension-$&, var(--spectrum-alias-$&))');
    return `var(--spectrum-global-dimension-${value}, var(--spectrum-alias-${value}))`;
}
function $4e665a4f60367a7f$export$f348bec194f2e6b5(value, matchedBreakpoints) {
    let responsiveValue = $4e665a4f60367a7f$export$52dbfdbe1b2c3541(value, matchedBreakpoints);
    if (responsiveValue != null) return $4e665a4f60367a7f$export$abc24f5b99744ea6(responsiveValue);
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$colorValue(value, type = 'default', version = 5) {
    if (version > 5) return `var(--spectrum-${value}, var(--spectrum-semantic-${value}-color-${type}))`;
    return `var(--spectrum-legacy-color-${value}, var(--spectrum-global-color-${value}, var(--spectrum-semantic-${value}-color-${type})))`;
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$backgroundColorValue(value, version = 5) {
    if (!value) return undefined;
    return `var(--spectrum-alias-background-color-${value}, ${$4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$colorValue(value, 'background', version)})`;
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderColorValue(value, version = 5) {
    if (!value) return undefined;
    if (value === 'default') return 'var(--spectrum-alias-border-color)';
    return `var(--spectrum-alias-border-color-${value}, ${$4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$colorValue(value, 'border', version)})`;
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderSizeValue(value) {
    return value && value !== 'none' ? `var(--spectrum-alias-border-size-${value})` : '0';
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderRadiusValue(value) {
    if (!value) return undefined;
    return `var(--spectrum-alias-border-radius-${value})`;
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$hiddenValue(value) {
    return value ? 'none' : undefined;
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$anyValue(value) {
    return value;
}
function $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$flexValue(value) {
    if (typeof value === 'boolean') return value ? '1' : undefined;
    return '' + value;
}
function $4e665a4f60367a7f$export$f3c39bb9534218d0(props, handlers, direction, matchedBreakpoints) {
    let style = {};
    for(let key in props){
        let styleProp = handlers[key];
        if (!styleProp || props[key] == null) continue;
        let [name, convert] = styleProp;
        if (typeof name === 'function') name = name(direction);
        let prop = $4e665a4f60367a7f$export$52dbfdbe1b2c3541(props[key], matchedBreakpoints);
        let value = convert(prop, props.colorVersion);
        if (Array.isArray(name)) for (let k of name)style[k] = value;
        else style[name] = value;
    }
    for(let prop in $4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderStyleProps)if (style[prop]) {
        style[$4e665a4f60367a7f$var$$63d03c54ca5e4b88$var$borderStyleProps[prop]] = 'solid';
        style.boxSizing = 'border-box';
    }
    return style;
}
function $4e665a4f60367a7f$export$b8e6fb9d2dff3f41(props, handlers = $4e665a4f60367a7f$export$fe9c6e915565b4e8, options = {}) {
    let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, ...otherProps } = props;
    let breakpointProvider = (0, $55241d54ef9d57b7$export$199d6754bdf4e1e3)();
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { matchedBreakpoints: matchedBreakpoints = breakpointProvider?.matchedBreakpoints || [
        'base'
    ] } = options;
    let styles = $4e665a4f60367a7f$export$f3c39bb9534218d0(props, handlers, direction, matchedBreakpoints);
    let style = {
        ...UNSAFE_style,
        ...styles
    };
    // @ts-ignore
    otherProps.className;
    // @ts-ignore
    otherProps.style;
    let styleProps = {
        style: style,
        className: UNSAFE_className
    };
    if ($4e665a4f60367a7f$export$52dbfdbe1b2c3541(props.isHidden, matchedBreakpoints)) styleProps.hidden = true;
    return {
        styleProps: styleProps
    };
}
function $4e665a4f60367a7f$export$46b6c81d11d2c30a(value) {
    return value;
}
function $4e665a4f60367a7f$export$52dbfdbe1b2c3541(prop, matchedBreakpoints) {
    if (prop && typeof prop === 'object' && !Array.isArray(prop)) {
        for(let i = 0; i < matchedBreakpoints.length; i++){
            let breakpoint = matchedBreakpoints[i];
            if (prop[breakpoint] != null) return prop[breakpoint];
        }
        return prop.base;
    }
    return prop;
}



var $hkwY6 = parcelRequire("hkwY6");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d3f8b5a4676f60c9$export$46d604dce8bf8724 = false;
function $d3f8b5a4676f60c9$export$f9d3bfd10703eb31() {
    $d3f8b5a4676f60c9$export$46d604dce8bf8724 = true;
}
function $d3f8b5a4676f60c9$export$ce4ab0c55987d1ff(cssModule, ...values) {
    let classes = [];
    for (let value of values){
        if (typeof value === 'object' && value) {
            let mapped = {};
            for(let key in value){
                if (cssModule[key]) mapped[cssModule[key]] = value[key];
                if ($d3f8b5a4676f60c9$export$46d604dce8bf8724 || !cssModule[key]) mapped[key] = value[key];
            }
            classes.push(mapped);
        } else if (typeof value === 'string') {
            if (cssModule[value]) classes.push(cssModule[value]);
            if ($d3f8b5a4676f60c9$export$46d604dce8bf8724 || !cssModule[value]) classes.push(value);
        } else classes.push(value);
    }
    return (0, $hkwY6.default)(...classes);
}



function $114e12a5fd03a45a$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $114e12a5fd03a45a$export$2e2bcd8739ae039 = {};
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum--large", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$a88a8dbe29386d31;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$a88a8dbe29386d31 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum--medium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$4c0c83b3f4303ef8;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$4c0c83b3f4303ef8 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$d374b04f30360026;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$d374b04f30360026 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeL", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$8d23c37ef2a4f13e;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$8d23c37ef2a4f13e = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeM", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$8f1693ac47916bbf;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$8f1693ac47916bbf = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeS", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$34ce05647f0c65e;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$34ce05647f0c65e = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeXL", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c6e70a22e841bc1b;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c6e70a22e841bc1b = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeXS", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$557c0af6873b4222;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$557c0af6873b4222 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeXXL", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$b37777493a27e620;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$b37777493a27e620 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-Icon--sizeXXS", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$cab8448604b31f43;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$cab8448604b31f43 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c7db7fdc5aac13aa;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c7db7fdc5aac13aa = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon--large", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$2265a487ad399d8b;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$2265a487ad399d8b = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon--medium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$a6044013cf72ddc9;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$a6044013cf72ddc9 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-AlertMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$83be8302c01b6478;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$83be8302c01b6478 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-AlertSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$57b49d6ee2e9f187;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$57b49d6ee2e9f187 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ArrowDownSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$81968d05e3681b3f;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$81968d05e3681b3f = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ArrowLeftMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c0d655f335b5bc31;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c0d655f335b5bc31 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-Asterisk", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$cca4342eca45562;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$cca4342eca45562 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-CheckmarkMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$edc4a2e9af971b26;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$edc4a2e9af971b26 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-CheckmarkSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$9e665cb12e71e037;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$9e665cb12e71e037 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronDownMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$2f91b7a7627906d5;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$2f91b7a7627906d5 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronDownSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$56efb4ec9eb35c07;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$56efb4ec9eb35c07 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronLeftLarge", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$5861dfe1d581a528;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$5861dfe1d581a528 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronLeftMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$595a122b60890c78;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$595a122b60890c78 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronRightLarge", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$596373794435f8bc;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$596373794435f8bc = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronRightMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$32b379a02cafbfb3;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$32b379a02cafbfb3 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronRightSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$ee5de2c4d7c8faa4;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$ee5de2c4d7c8faa4 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ChevronUpSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c1cbae72fd236fd9;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c1cbae72fd236fd9 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-CornerTriangle", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$636d8cde4f6b7e6;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$636d8cde4f6b7e6 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-CrossLarge", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1f0ad4082256e3df;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1f0ad4082256e3df = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-CrossMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1e0848411e254295;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1e0848411e254295 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-CrossSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1c1bddac0ae5fbe5;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1c1bddac0ae5fbe5 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-DashSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$98de2b9917cd3b6a;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$98de2b9917cd3b6a = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-DoubleGripper", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$3c956876cb11c1e1;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$3c956876cb11c1e1 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-FolderBreadcrumb", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$55cf2795737352fc;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$55cf2795737352fc = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-HelpMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$d5d1e3e09ea6cd5;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$d5d1e3e09ea6cd5 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-HelpSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$f51b22382127207d;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$f51b22382127207d = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-InfoMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$825a6c2340d3b7e5;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$825a6c2340d3b7e5 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-InfoSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$4828f4a6bfd26c04;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$4828f4a6bfd26c04 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-ListGripper", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1254ece141a8dac6;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$1254ece141a8dac6 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-Magnifier", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$a33650c9f4cc191e;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$a33650c9f4cc191e = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-SkipLeft", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$9eb19533e4b8cc28;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$9eb19533e4b8cc28 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-SkipRight", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$67704939e41f705a;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$67704939e41f705a = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-Star", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c4d219c150b98c92;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$c4d219c150b98c92 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-StarOutline", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$bcda0a6a6d7202af;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$bcda0a6a6d7202af = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-SuccessMedium", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$d18d2d837989a797;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$d18d2d837989a797 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-SuccessSmall", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$506ac7a1a72a2c65;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$506ac7a1a72a2c65 = v;
});
$114e12a5fd03a45a$var$$parcel$export($114e12a5fd03a45a$export$2e2bcd8739ae039, "spectrum-UIIcon-TripleGripper", function() {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$12b8600bcd969018;
}, function(v) {
    return $114e12a5fd03a45a$var$$78388aa53846725a$export$12b8600bcd969018 = v;
});
var $114e12a5fd03a45a$var$$78388aa53846725a$export$a88a8dbe29386d31;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$4c0c83b3f4303ef8;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$d374b04f30360026;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$8d23c37ef2a4f13e;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$8f1693ac47916bbf;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$34ce05647f0c65e;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$c6e70a22e841bc1b;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$557c0af6873b4222;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$b37777493a27e620;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$cab8448604b31f43;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$c7db7fdc5aac13aa;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$2265a487ad399d8b;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$a6044013cf72ddc9;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$83be8302c01b6478;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$57b49d6ee2e9f187;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$81968d05e3681b3f;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$c0d655f335b5bc31;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$cca4342eca45562;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$edc4a2e9af971b26;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$9e665cb12e71e037;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$2f91b7a7627906d5;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$56efb4ec9eb35c07;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$5861dfe1d581a528;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$595a122b60890c78;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$596373794435f8bc;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$32b379a02cafbfb3;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$ee5de2c4d7c8faa4;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$c1cbae72fd236fd9;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$636d8cde4f6b7e6;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$1f0ad4082256e3df;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$1e0848411e254295;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$1c1bddac0ae5fbe5;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$98de2b9917cd3b6a;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$3c956876cb11c1e1;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$55cf2795737352fc;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$d5d1e3e09ea6cd5;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$f51b22382127207d;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$825a6c2340d3b7e5;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$4828f4a6bfd26c04;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$1254ece141a8dac6;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$a33650c9f4cc191e;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$9eb19533e4b8cc28;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$67704939e41f705a;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$c4d219c150b98c92;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$bcda0a6a6d7202af;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$d18d2d837989a797;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$506ac7a1a72a2c65;
var $114e12a5fd03a45a$var$$78388aa53846725a$export$12b8600bcd969018;
$114e12a5fd03a45a$var$$78388aa53846725a$export$a88a8dbe29386d31 = `wBx8DG_spectrum--large`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$4c0c83b3f4303ef8 = `wBx8DG_spectrum--medium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$d374b04f30360026 = `wBx8DG_spectrum-Icon`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$8d23c37ef2a4f13e = `wBx8DG_spectrum-Icon--sizeL`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$8f1693ac47916bbf = `wBx8DG_spectrum-Icon--sizeM`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$34ce05647f0c65e = `wBx8DG_spectrum-Icon--sizeS`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$c6e70a22e841bc1b = `wBx8DG_spectrum-Icon--sizeXL`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$557c0af6873b4222 = `wBx8DG_spectrum-Icon--sizeXS`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$b37777493a27e620 = `wBx8DG_spectrum-Icon--sizeXXL`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$cab8448604b31f43 = `wBx8DG_spectrum-Icon--sizeXXS`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$c7db7fdc5aac13aa = `wBx8DG_spectrum-UIIcon`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$2265a487ad399d8b = `wBx8DG_spectrum-UIIcon--large`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$a6044013cf72ddc9 = `wBx8DG_spectrum-UIIcon--medium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$83be8302c01b6478 = `wBx8DG_spectrum-UIIcon-AlertMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$57b49d6ee2e9f187 = `wBx8DG_spectrum-UIIcon-AlertSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$81968d05e3681b3f = `wBx8DG_spectrum-UIIcon-ArrowDownSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$c0d655f335b5bc31 = `wBx8DG_spectrum-UIIcon-ArrowLeftMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$cca4342eca45562 = `wBx8DG_spectrum-UIIcon-Asterisk`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$edc4a2e9af971b26 = `wBx8DG_spectrum-UIIcon-CheckmarkMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$9e665cb12e71e037 = `wBx8DG_spectrum-UIIcon-CheckmarkSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$2f91b7a7627906d5 = `wBx8DG_spectrum-UIIcon-ChevronDownMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$56efb4ec9eb35c07 = `wBx8DG_spectrum-UIIcon-ChevronDownSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$5861dfe1d581a528 = `wBx8DG_spectrum-UIIcon-ChevronLeftLarge`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$595a122b60890c78 = `wBx8DG_spectrum-UIIcon-ChevronLeftMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$596373794435f8bc = `wBx8DG_spectrum-UIIcon-ChevronRightLarge`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$32b379a02cafbfb3 = `wBx8DG_spectrum-UIIcon-ChevronRightMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$ee5de2c4d7c8faa4 = `wBx8DG_spectrum-UIIcon-ChevronRightSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$c1cbae72fd236fd9 = `wBx8DG_spectrum-UIIcon-ChevronUpSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$636d8cde4f6b7e6 = `wBx8DG_spectrum-UIIcon-CornerTriangle`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$1f0ad4082256e3df = `wBx8DG_spectrum-UIIcon-CrossLarge`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$1e0848411e254295 = `wBx8DG_spectrum-UIIcon-CrossMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$1c1bddac0ae5fbe5 = `wBx8DG_spectrum-UIIcon-CrossSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$98de2b9917cd3b6a = `wBx8DG_spectrum-UIIcon-DashSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$3c956876cb11c1e1 = `wBx8DG_spectrum-UIIcon-DoubleGripper`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$55cf2795737352fc = `wBx8DG_spectrum-UIIcon-FolderBreadcrumb`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$d5d1e3e09ea6cd5 = `wBx8DG_spectrum-UIIcon-HelpMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$f51b22382127207d = `wBx8DG_spectrum-UIIcon-HelpSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$825a6c2340d3b7e5 = `wBx8DG_spectrum-UIIcon-InfoMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$4828f4a6bfd26c04 = `wBx8DG_spectrum-UIIcon-InfoSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$1254ece141a8dac6 = `wBx8DG_spectrum-UIIcon-ListGripper`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$a33650c9f4cc191e = `wBx8DG_spectrum-UIIcon-Magnifier`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$9eb19533e4b8cc28 = `wBx8DG_spectrum-UIIcon-SkipLeft`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$67704939e41f705a = `wBx8DG_spectrum-UIIcon-SkipRight`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$c4d219c150b98c92 = `wBx8DG_spectrum-UIIcon-Star`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$bcda0a6a6d7202af = `wBx8DG_spectrum-UIIcon-StarOutline`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$d18d2d837989a797 = `wBx8DG_spectrum-UIIcon-SuccessMedium`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$506ac7a1a72a2c65 = `wBx8DG_spectrum-UIIcon-SuccessSmall`;
$114e12a5fd03a45a$var$$78388aa53846725a$export$12b8600bcd969018 = `wBx8DG_spectrum-UIIcon-TripleGripper`;




var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6d3f4cb1038022c4$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
$6d3f4cb1038022c4$export$841858b892ce1f4c.displayName = 'ProviderContext';




function $186616628c7c7a8a$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $186616628c7c7a8a$export$2e2bcd8739ae039 = {};
$186616628c7c7a8a$var$$parcel$export($186616628c7c7a8a$export$2e2bcd8739ae039, "focus-ring", function() {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$f39a09f249340e2a;
}, function(v) {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$f39a09f249340e2a = v;
});
$186616628c7c7a8a$var$$parcel$export($186616628c7c7a8a$export$2e2bcd8739ae039, "i18nFontFamily", function() {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$8c4ee2c50c22c514;
}, function(v) {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$8c4ee2c50c22c514 = v;
});
$186616628c7c7a8a$var$$parcel$export($186616628c7c7a8a$export$2e2bcd8739ae039, "spectrum", function() {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$3311ab3a441bc141;
}, function(v) {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$3311ab3a441bc141 = v;
});
$186616628c7c7a8a$var$$parcel$export($186616628c7c7a8a$export$2e2bcd8739ae039, "spectrum-FocusRing-ring", function() {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$4109102f950813a6;
}, function(v) {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$4109102f950813a6 = v;
});
$186616628c7c7a8a$var$$parcel$export($186616628c7c7a8a$export$2e2bcd8739ae039, "spectrum-FocusRing", function() {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$24c7f46a6e3605dd;
}, function(v) {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$24c7f46a6e3605dd = v;
});
$186616628c7c7a8a$var$$parcel$export($186616628c7c7a8a$export$2e2bcd8739ae039, "spectrum-FocusRing--quiet", function() {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$2927016961429360;
}, function(v) {
    return $186616628c7c7a8a$var$$44154f2294040c10$export$2927016961429360 = v;
});
var $186616628c7c7a8a$var$$44154f2294040c10$export$f39a09f249340e2a;
var $186616628c7c7a8a$var$$44154f2294040c10$export$8c4ee2c50c22c514;
var $186616628c7c7a8a$var$$44154f2294040c10$export$3311ab3a441bc141;
var $186616628c7c7a8a$var$$44154f2294040c10$export$4109102f950813a6;
var $186616628c7c7a8a$var$$44154f2294040c10$export$24c7f46a6e3605dd;
var $186616628c7c7a8a$var$$44154f2294040c10$export$2927016961429360;
$186616628c7c7a8a$var$$44154f2294040c10$export$f39a09f249340e2a = `XjpDJq_focus-ring`;
$186616628c7c7a8a$var$$44154f2294040c10$export$8c4ee2c50c22c514 = `XjpDJq_i18nFontFamily`;
$186616628c7c7a8a$var$$44154f2294040c10$export$3311ab3a441bc141 = `XjpDJq_spectrum`;
$186616628c7c7a8a$var$$44154f2294040c10$export$4109102f950813a6 = `XjpDJq_spectrum-FocusRing-ring`;
$186616628c7c7a8a$var$$44154f2294040c10$export$24c7f46a6e3605dd = `XjpDJq_spectrum-FocusRing ${$186616628c7c7a8a$var$$44154f2294040c10$export$4109102f950813a6}`;
$186616628c7c7a8a$var$$44154f2294040c10$export$2927016961429360 = `XjpDJq_spectrum-FocusRing--quiet`;



function $215e8c5f743e1757$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $215e8c5f743e1757$export$2e2bcd8739ae039 = {};
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "focus-ring", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$f39a09f249340e2a;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$f39a09f249340e2a = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "i18nFontFamily", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$8c4ee2c50c22c514;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$8c4ee2c50c22c514 = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "spectrum", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$3311ab3a441bc141;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$3311ab3a441bc141 = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "spectrum-Body", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$a30bf7810c8453d1;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$a30bf7810c8453d1 = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "spectrum-Body--italic", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$7b2dac1166f6ec4c;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$7b2dac1166f6ec4c = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "spectrum-FocusRing-ring", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$4109102f950813a6;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$4109102f950813a6 = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "spectrum-FocusRing", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$24c7f46a6e3605dd;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$24c7f46a6e3605dd = v;
});
$215e8c5f743e1757$var$$parcel$export($215e8c5f743e1757$export$2e2bcd8739ae039, "spectrum-FocusRing--quiet", function() {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$2927016961429360;
}, function(v) {
    return $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$2927016961429360 = v;
});
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$f39a09f249340e2a;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$8c4ee2c50c22c514;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$3311ab3a441bc141;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$a30bf7810c8453d1;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$7b2dac1166f6ec4c;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$4109102f950813a6;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$24c7f46a6e3605dd;
var $215e8c5f743e1757$var$$75983cb9bae5f5d5$export$2927016961429360;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$f39a09f249340e2a = `oAOseG_focus-ring`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$8c4ee2c50c22c514 = `oAOseG_i18nFontFamily`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$3311ab3a441bc141 = `oAOseG_spectrum ${$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$8c4ee2c50c22c514}`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$a30bf7810c8453d1 = `oAOseG_spectrum-Body`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$7b2dac1166f6ec4c = `oAOseG_spectrum-Body--italic`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$4109102f950813a6 = `oAOseG_spectrum-FocusRing-ring`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$24c7f46a6e3605dd = `oAOseG_spectrum-FocusRing ${$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$4109102f950813a6}`;
$215e8c5f743e1757$var$$75983cb9bae5f5d5$export$2927016961429360 = `oAOseG_spectrum-FocusRing--quiet`;



var $eF4cA = parcelRequire("eF4cA");

var $hWe38 = parcelRequire("hWe38");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c3c8be8f340258aa$export$32d5543ab307c01(query) {
    let supportsMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    let [matches, setMatches] = (0, $eF4cA.useState)(()=>supportsMatchMedia ? window.matchMedia(query).matches : false);
    (0, $eF4cA.useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let mq = window.matchMedia(query);
        let onChange = (evt)=>{
            setMatches(evt.matches);
        };
        mq.addListener(onChange);
        return ()=>{
            mq.removeListener(onChange);
        };
    }, [
        supportsMatchMedia,
        query
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, $hWe38.useIsSSR)();
    return isSSR ? false : matches;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $86a6de11a4eb5b2d$export$6343629ee1b29116(theme, defaultColorScheme) {
    let matchesDark = (0, $c3c8be8f340258aa$export$32d5543ab307c01)('(prefers-color-scheme: dark)');
    let matchesLight = (0, $c3c8be8f340258aa$export$32d5543ab307c01)('(prefers-color-scheme: light)');
    // importance OS > default > omitted
    if (theme.dark && matchesDark) return 'dark';
    if (theme.light && matchesLight) return 'light';
    if (theme.dark && defaultColorScheme === 'dark') return 'dark';
    if (theme.light && defaultColorScheme === 'light') return 'light';
    if (!theme.dark) return 'light';
    if (!theme.light) return 'dark';
    return 'light';
}
function $86a6de11a4eb5b2d$export$a8d2043b2d807f4d(theme) {
    let matchesFine = (0, $c3c8be8f340258aa$export$32d5543ab307c01)('(any-pointer: fine)');
    if (matchesFine && theme.medium) return 'medium';
    if (theme.large) return 'large';
    return 'medium';
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d089b7678fe5fe90$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $d089b7678fe5fe90$export$79d69eee6ae4b329(domRef, focusableRef = domRef) {
    return {
        ...$d089b7678fe5fe90$export$a5795cc979dfae80(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function $d089b7678fe5fe90$export$c2c55ef9111cafd8(ref) {
    let domRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>$d089b7678fe5fe90$export$a5795cc979dfae80(domRef));
    return domRef;
}
function $d089b7678fe5fe90$export$96a734597687c040(ref, focusableRef) {
    let domRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>$d089b7678fe5fe90$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $d089b7678fe5fe90$export$c7e28c72a4823176(ref) {
    return {
        get current () {
            return ref.current && ref.current.UNSAFE_getDOMNode();
        }
    };
}
function $d089b7678fe5fe90$export$1d5cc31d9d8df817(ref) {
    return (0, $eF4cA.useMemo)(()=>$d089b7678fe5fe90$export$c7e28c72a4823176(ref), [
        ref
    ]);
}




var $hkwY6 = parcelRequire("hkwY6");

var $fVfXf = parcelRequire("fVfXf");

var $1ntKq = parcelRequire("1ntKq");

var $uddx7 = parcelRequire("uddx7");

var $eF4cA = parcelRequire("eF4cA");

var $aGgVM = parcelRequire("aGgVM");
function $221bea965498e760$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // A macro ensures that we don't import the entire package.json.
const $221bea965498e760$var$$71dfb0e0358a12de$var$version = "3.47.7";
const $221bea965498e760$var$$71dfb0e0358a12de$var$DEFAULT_BREAKPOINTS = {
    S: 640,
    M: 768,
    L: 1024,
    XL: 1280,
    XXL: 1536
};
const $221bea965498e760$export$2881499e37b75b9a = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef(function Provider(props, ref) {
    let prevContext = (0, $eF4cA.useContext)((0, $6d3f4cb1038022c4$export$841858b892ce1f4c));
    let prevColorScheme = prevContext && prevContext.colorScheme;
    let prevBreakpoints = prevContext && prevContext.breakpoints;
    let { theme: theme = prevContext && prevContext.theme, defaultColorScheme: defaultColorScheme } = props;
    if (!theme) throw new Error('theme not found, the parent provider must have a theme provided');
    // Hooks must always be called.
    let autoColorScheme = (0, $86a6de11a4eb5b2d$export$6343629ee1b29116)(theme, defaultColorScheme || 'light');
    let autoScale = (0, $86a6de11a4eb5b2d$export$a8d2043b2d807f4d)(theme);
    let { locale: prevLocale } = (0, $1ntKq.useLocale)();
    // if the new theme doesn't support the prevColorScheme, we must resort to the auto
    let usePrevColorScheme = prevColorScheme ? !!theme[prevColorScheme] : false;
    // importance of color scheme props > parent > auto:(OS > default > omitted)
    let { colorScheme: colorScheme = usePrevColorScheme ? prevColorScheme : autoColorScheme, scale: scale = prevContext ? prevContext.scale : autoScale, locale: locale = prevContext ? prevLocale : undefined, breakpoints: breakpoints = prevContext ? prevBreakpoints : $221bea965498e760$var$$71dfb0e0358a12de$var$DEFAULT_BREAKPOINTS, children: children, isQuiet: isQuiet, isEmphasized: isEmphasized, isDisabled: isDisabled, isRequired: isRequired, isReadOnly: isReadOnly, validationState: validationState, router: router, ...otherProps } = props;
    // select only the props with values so undefined props don't overwrite prevContext values
    let currentProps = {
        version: $221bea965498e760$var$$71dfb0e0358a12de$var$version,
        theme: theme,
        breakpoints: breakpoints,
        colorScheme: colorScheme,
        scale: scale,
        isQuiet: isQuiet,
        isEmphasized: isEmphasized,
        isDisabled: isDisabled,
        isRequired: isRequired,
        isReadOnly: isReadOnly,
        validationState: validationState
    };
    let matchedBreakpoints = (0, $55241d54ef9d57b7$export$140ae7baa51cca23)(breakpoints);
    let filteredProps = {};
    Object.entries(currentProps).forEach(([key, value])=>value !== undefined && (filteredProps[key] = value));
    // Merge options with parent provider
    let context = Object.assign({}, prevContext, filteredProps);
    // Only wrap in a DOM node if the theme, colorScheme, or scale changed
    let contents = children;
    let domProps = (0, $fVfXf.filterDOMProps)(otherProps);
    let { styleProps: styleProps } = (0, $4e665a4f60367a7f$export$b8e6fb9d2dff3f41)(otherProps, undefined, {
        matchedBreakpoints: matchedBreakpoints
    });
    if (!prevContext || props.locale || theme !== prevContext.theme || colorScheme !== prevContext.colorScheme || scale !== prevContext.scale || Object.keys(domProps).length > 0 || otherProps.UNSAFE_className || styleProps.style && Object.keys(styleProps.style).length > 0) contents = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($221bea965498e760$var$$71dfb0e0358a12de$var$ProviderWrapper, {
        ...props,
        UNSAFE_style: {
            isolation: !prevContext ? 'isolate' : undefined,
            ...styleProps.style
        },
        ref: ref
    }, contents);
    if (router) contents = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $aGgVM.RouterProvider), router, contents);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $6d3f4cb1038022c4$export$841858b892ce1f4c).Provider, {
        value: context
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $1ntKq.I18nProvider), {
        locale: locale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $55241d54ef9d57b7$export$8214320346cf5104), {
        matchedBreakpoints: matchedBreakpoints
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $uddx7.ModalProvider), null, contents))));
});
const $221bea965498e760$var$$71dfb0e0358a12de$var$ProviderWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef(function ProviderWrapper(props, ref) {
    let { children: children, ...otherProps } = props;
    let { locale: locale, direction: direction } = (0, $1ntKq.useLocale)();
    let { theme: theme, colorScheme: colorScheme, scale: scale } = $221bea965498e760$export$693cdb10cec23617();
    let { modalProviderProps: modalProviderProps } = (0, $uddx7.useModalProvider)();
    let { styleProps: styleProps } = (0, $4e665a4f60367a7f$export$b8e6fb9d2dff3f41)(otherProps);
    let domRef = (0, $d089b7678fe5fe90$export$c2c55ef9111cafd8)(ref);
    let themeKey = Object.keys(theme[colorScheme])[0];
    let scaleKey = Object.keys(theme[scale])[0];
    let className = (0, $hkwY6.default)(styleProps.className, $221bea965498e760$var$$parcel$interopDefault((0, $186616628c7c7a8a$export$2e2bcd8739ae039))['spectrum'], $221bea965498e760$var$$parcel$interopDefault((0, $215e8c5f743e1757$export$2e2bcd8739ae039))['spectrum'], Object.values(theme[colorScheme]), Object.values(theme[scale]), theme.global ? Object.values(theme.global) : null, {
        'react-spectrum-provider': (0, $d3f8b5a4676f60c9$export$46d604dce8bf8724),
        spectrum: (0, $d3f8b5a4676f60c9$export$46d604dce8bf8724),
        [themeKey]: (0, $d3f8b5a4676f60c9$export$46d604dce8bf8724),
        [scaleKey]: (0, $d3f8b5a4676f60c9$export$46d604dce8bf8724)
    });
    let style = {
        ...styleProps.style,
        // This ensures that browser native UI like scrollbars are rendered in the right color scheme.
        // See https://web.dev/color-scheme/.
        colorScheme: props.colorScheme ?? colorScheme ?? Object.keys(theme).filter((k)=>k === 'light' || k === 'dark').join(' ')
    };
    let hasWarned = (0, $eF4cA.useRef)(false);
    (0, $eF4cA.useEffect)(()=>{
        if (direction && domRef.current) {
            let closestDir = domRef.current?.parentElement?.closest('[dir]');
            let dir = closestDir && closestDir.getAttribute('dir');
            dir && dir !== direction && hasWarned.current;
        }
    }, [
        direction,
        domRef,
        hasWarned
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...(0, $fVfXf.filterDOMProps)(otherProps),
        ...styleProps,
        ...modalProviderProps,
        className: className,
        style: style,
        lang: locale,
        dir: direction,
        ref: domRef
    }, children);
});
function $221bea965498e760$export$693cdb10cec23617() {
    let context = (0, $eF4cA.useContext)((0, $6d3f4cb1038022c4$export$841858b892ce1f4c));
    if (!context) throw new Error("No root provider found, please make sure your app is wrapped within a <Provider>. Alternatively, this issue may be caused by duplicate packages, see https://github.com/adobe/react-spectrum/wiki/Frequently-Asked-Questions-(FAQs)#why-are-there-errors-after-upgrading-a-react-spectrum-package for more information.");
    return context;
}
function $221bea965498e760$export$521c373ccc32c300(props) {
    let context = (0, $eF4cA.useContext)((0, $6d3f4cb1038022c4$export$841858b892ce1f4c));
    if (!context) return props;
    return Object.assign({}, {
        isQuiet: context.isQuiet,
        isEmphasized: context.isEmphasized,
        isDisabled: context.isDisabled,
        isRequired: context.isRequired,
        isReadOnly: context.isReadOnly,
        validationState: context.validationState
    }, props);
}



var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2940ed631615a46e$var$$62024859ff9f1f8a$var$SlotContext = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createContext(null);
function $2940ed631615a46e$export$1e5c9e6e4e15efe3(props, defaultSlot) {
    let slot = props.slot || defaultSlot;
    // @ts-ignore TODO why is slot an object and not just string or undefined?
    let { [slot]: slotProps = {} } = (0, $eF4cA.useContext)($2940ed631615a46e$var$$62024859ff9f1f8a$var$SlotContext) || {};
    // oxlint-disable-next-line react/react-compiler
    return (0, $lhKAD.mergeProps)(props, (0, $lhKAD.mergeProps)(slotProps, {
        id: props.id
    }));
}
function $2940ed631615a46e$export$365cf34cda9978e2(cssModule) {
    return Object.keys(cssModule).reduce((acc, slot)=>{
        acc[slot] = {
            UNSAFE_className: cssModule[slot]
        };
        return acc;
    }, {});
}
function $2940ed631615a46e$export$8107b24b91795686(props) {
    const emptyObj = (0, $eF4cA.useMemo)(()=>({}), []);
    let parentSlots = (0, $eF4cA.useContext)($2940ed631615a46e$var$$62024859ff9f1f8a$var$SlotContext) || emptyObj;
    let { slots: slots = emptyObj, children: children } = props;
    // Merge props for each slot from parent context and props
    let value = (0, $eF4cA.useMemo)(()=>Object.keys(parentSlots).concat(Object.keys(slots)).reduce((o, p)=>({
                ...o,
                [p]: (0, $lhKAD.mergeProps)(parentSlots[p] || {}, slots[p] || {})
            }), {}), [
        parentSlots,
        slots
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($2940ed631615a46e$var$$62024859ff9f1f8a$var$SlotContext.Provider, {
        value: value
    }, children);
}
function $2940ed631615a46e$export$ceb145244332b7a2(props) {
    let { children: children, ...otherProps } = props;
    const emptyObj = (0, $eF4cA.useMemo)(()=>({}), []);
    let content = children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.toArray(children).length <= 1) {
        if (typeof children === 'function') content = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Children.only(children), otherProps);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($2940ed631615a46e$var$$62024859ff9f1f8a$var$SlotContext.Provider, {
        value: emptyObj
    }, content);
}



var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");
function $08d1a20bf7ce52a0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $08d1a20bf7ce52a0$var$$20f96c95fdf7a1d8$var$iconColorValue(value) {
    return `var(--spectrum-semantic-${value}-color-icon)`;
}
const $08d1a20bf7ce52a0$var$$20f96c95fdf7a1d8$var$iconStyleProps = {
    ...(0, $4e665a4f60367a7f$export$fe9c6e915565b4e8),
    color: [
        'color',
        $08d1a20bf7ce52a0$var$$20f96c95fdf7a1d8$var$iconColorValue
    ]
};
function $08d1a20bf7ce52a0$export$f04a61298a47a40f(props) {
    props = (0, $2940ed631615a46e$export$1e5c9e6e4e15efe3)(props, 'icon');
    let { children: children, size: size, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $4e665a4f60367a7f$export$b8e6fb9d2dff3f41)(otherProps, $08d1a20bf7ce52a0$var$$20f96c95fdf7a1d8$var$iconStyleProps);
    let provider;
    try {
        // oxlint-disable-next-line react/react-compiler
        provider = (0, $221bea965498e760$export$693cdb10cec23617)();
    } catch  {
    // ignore
    }
    let scale = 'M';
    if (provider != null) scale = provider.scale === 'large' ? 'L' : 'M';
    if (!ariaHidden) ariaHidden = undefined;
    // Use user specified size, falling back to provider scale if size is undef
    let iconSize = size ? size : scale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).cloneElement(children, {
        ...(0, $fVfXf.filterDOMProps)(otherProps),
        ...styleProps,
        focusable: 'false',
        'aria-label': ariaLabel,
        'aria-hidden': ariaLabel ? ariaHidden || undefined : true,
        role: 'img',
        className: (0, $d3f8b5a4676f60c9$export$ce4ab0c55987d1ff)($08d1a20bf7ce52a0$var$$parcel$interopDefault((0, $114e12a5fd03a45a$export$2e2bcd8739ae039)), children.props.className, 'spectrum-Icon', `spectrum-Icon--size${iconSize}`, styleProps.className)
    });
}



var $eF4cA = parcelRequire("eF4cA");
function $4f2a835d1ef6e655$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $08d1a20bf7ce52a0$export$f04a61298a47a40f), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $dbeadf8587015ddd$exports.A4uInfo), null));
}


var $1a22730a73f85bec$exports = {};
/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/ "use strict";
Object.defineProperty($1a22730a73f85bec$exports, "__esModule", {
    value: true
});
$1a22730a73f85bec$exports.A4uAlert = $1a22730a73f85bec$var$A4uAlert;

var $1a22730a73f85bec$var$_react = $1a22730a73f85bec$var$_interopRequireDefault((parcelRequire("eF4cA")));
function $1a22730a73f85bec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1a22730a73f85bec$var$_extends() {
    $1a22730a73f85bec$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a22730a73f85bec$var$_extends.apply(this, arguments);
}
function $1a22730a73f85bec$var$A4uAlert(_ref) {
    var props = $1a22730a73f85bec$var$_extends({}, _ref);
    return /*#__PURE__*/ $1a22730a73f85bec$var$_react["default"].createElement("svg", $1a22730a73f85bec$var$_extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ $1a22730a73f85bec$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M17.127,2.579.4,32.512A1,1,0,0,0,1.272,34H34.728a1,1,0,0,0,.872-1.488L18.873,2.579A1,1,0,0,0,17.127,2.579ZM20,29.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Zm0-6a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z"
    }));
}




var $eF4cA = parcelRequire("eF4cA");
function $4f79764ee53d8ceb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $08d1a20bf7ce52a0$export$f04a61298a47a40f), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $1a22730a73f85bec$exports.A4uAlert), null));
}


var $3254958e2e8ae712$exports = {};
/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/ "use strict";
Object.defineProperty($3254958e2e8ae712$exports, "__esModule", {
    value: true
});
$3254958e2e8ae712$exports.A4uCheckmark = $3254958e2e8ae712$var$A4uCheckmark;

var $3254958e2e8ae712$var$_react = $3254958e2e8ae712$var$_interopRequireDefault((parcelRequire("eF4cA")));
function $3254958e2e8ae712$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3254958e2e8ae712$var$_extends() {
    $3254958e2e8ae712$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3254958e2e8ae712$var$_extends.apply(this, arguments);
}
function $3254958e2e8ae712$var$A4uCheckmark(_ref) {
    var props = $3254958e2e8ae712$var$_extends({}, _ref);
    return /*#__PURE__*/ $3254958e2e8ae712$var$_react["default"].createElement("svg", $3254958e2e8ae712$var$_extends({
        viewBox: "0 0 36 36"
    }, props, props), /*#__PURE__*/ $3254958e2e8ae712$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        d: "M31.312,7.725,29.857,6.592a1,1,0,0,0-1.4.175L14.822,24.283,8.175,17.671a1,1,0,0,0-1.414,0L5.436,19a1,1,0,0,0,0,1.414l8.926,8.9a1,1,0,0,0,1.5-.093L31.487,9.128A1,1,0,0,0,31.312,7.725Z"
    }));
}




var $eF4cA = parcelRequire("eF4cA");
function $51c7940db716f92a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $08d1a20bf7ce52a0$export$f04a61298a47a40f), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3254958e2e8ae712$exports.A4uCheckmark), null));
}



var $82YSg = parcelRequire("82YSg");
const $747531ddbc1c9a67$var$alertStyle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' sd182';
    rules += ' Ul182';
    rules += ' ql182';
    rules += ' Sf182';
    rules += ' Rt182';
    rules += ' Te182';
    rules += ' Qe182';
    rules += ' Mj182';
    rules += ' _oa182';
    rules += ' _va182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' po182';
    if (props.variant === "notice") rules += ' gV182';
    else if (props.variant === "negative") rules += ' gU182';
    else if (props.variant === "positive") rules += ' gA182';
    else if (props.variant === "info") rules += ' gG182';
    else if (props.variant === "neutral") rules += ' gI182';
    rules += ' -_8sjo0b-t5ZbAob182';
    rules += ' _nLeasBb182';
    rules += ' _8d182';
    return rules;
};
const $747531ddbc1c9a67$var$alertBody = " sd182 _ub182 _wb182 eb182 qj182 Ue182";
const $747531ddbc1c9a67$var$alertContent = " sd182 _ub182 Ue182 qe182 eb182 zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 ri182 ZJ182 -nTSCV-LTAEPe182 __ZLTAEPe182 Na182";
const $747531ddbc1c9a67$var$controls = function anonymous(props) {
    let rules = " ";
    rules += ' _pb182';
    if (props.isExpanded) rules += ' sd182';
    else rules += ' sk182';
    rules += ' _Cb182';
    rules += ' Ue182';
    rules += ' qe182';
    if (props.isExpanded) rules += ' _Ib182';
    else rules += ' _Ia182';
    return rules;
};
const $747531ddbc1c9a67$var$ICONS = {
    info: (0, $4f2a835d1ef6e655$export$2e2bcd8739ae039),
    negative: (0, $4f79764ee53d8ceb$export$2e2bcd8739ae039),
    positive: (0, $51c7940db716f92a$export$2e2bcd8739ae039),
    notice: (0, $82YSg.default)
};
const $747531ddbc1c9a67$export$40137d14c0f88992 = ({ variant: variant = "info", children: children, actionLabel: actionLabel, onAction: onAction, shouldCloseOnAction: shouldCloseOnAction, styles: styles = "" })=>{
    const [isClosed, setClosed] = (0, $eF4cA.useState)(false);
    const Icon = $747531ddbc1c9a67$var$ICONS[variant];
    if (isClosed) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: $747531ddbc1c9a67$var$alertStyle({
            variant: variant
        }) + styles,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: $747531ddbc1c9a67$var$alertBody,
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: $747531ddbc1c9a67$var$alertContent,
                        children: [
                            Icon && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " _sJ4e1lb182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)(Icon, {
                                    UNSAFE_className: " Zm182 Fn182"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                slot: "title",
                                children: children
                            })
                        ]
                    }),
                    actionLabel && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        variant: "secondary",
                        fillStyle: "outline",
                        staticColor: "white",
                        onPress: ()=>{
                            onAction?.();
                            shouldCloseOnAction;
                        },
                        // UNSAFE_className={ctx && isMain ? toastCss['toast-action'] : undefined}
                        styles: " IM182 zzz3eAe182 yzz3eAe182 Bzz3eAe182 Azz3eAe182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: actionLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                onPress: ()=>setClosed(true)
            })
        ]
    });
};
$747531ddbc1c9a67$export$40137d14c0f88992.propTypes = {
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "positive",
        "negative",
        "notice",
        "info",
        "neutral"
    ]).isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node.isRequired,
    actionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    shouldCloseOnAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $geNzB = parcelRequire("geNzB");
var $208Op = parcelRequire("208Op");
var $5mvex = parcelRequire("5mvex");
var $c0XRK = parcelRequire("c0XRK");
var $3YPmU = parcelRequire("3YPmU");

var $9eyCh = parcelRequire("9eyCh");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $20b96afb11026508$var$$192d4d12c2fcaf76$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "f2ac84__d",
                        x1: 115.768,
                        x2: 23.108,
                        y1: -5.145,
                        y2: 114.991,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FF4885"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF4885",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "f2ac84__e",
                        x1: 59.314,
                        x2: 77.188,
                        y1: -60.452,
                        y2: 53.946,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.156,
                                stopColor: "#7A6AFD"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A6AFD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "f2ac84__f",
                        x1: -146.934,
                        x2: 153.819,
                        y1: 169.541,
                        y2: 110.102,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#30A7FE",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#30A7FE",
                                stopOpacity: 0.995
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#30A7FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#30A7FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "f2ac84__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 18.716 123.904)scale(231.011)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.089,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "f2ac84__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#fff",
                            rx: 10
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "f2ac84__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M28.25 41.383c0-5.523 4.477-10 10-10h66.54c5.523 0 10 4.477 10 10v19.744H82.262c-5.367 0-10.186 2.35-13.484 6.076l-4.553-7.499-.011-.018c-3.581-5.828-12.02-5.921-15.728-.173l-.008.013-19.754 30.876c-.308-.962-.474-1.987-.474-3.051zm36.012 37.744V97.35H38.25c-1.404 0-2.741-.29-3.954-.813L55.209 63.85l.002-.004c.517-.794 1.683-.782 2.183.022l.004.006 7.188 11.838c-.213 1.106-.324 2.247-.324 3.415m29.906-21.97c3.314 0 6-2.687 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6m-21.906 21.97c0-5.523 4.477-10 10-10h39.488c5.523 0 10 4.477 10 10v39.488c0 5.523-4.477 10-10 10H82.262c-5.523 0-10-4.477-10-10zm42.583 17.766-19.507-11.19c-2.185-1.252-4.92.308-4.923 2.809l-.027 22.331c-.003 2.501 2.728 4.067 4.916 2.82l19.534-11.143c2.187-1.248 2.191-4.374.007-5.627"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#f2ac84__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#f2ac84__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 160,
                            height: 160,
                            fill: "#D9F4FD",
                            rx: 10
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 142.62,
                            cy: 105.187,
                            r: 231.011,
                            fill: "url(#f2ac84__c)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#f2ac84__d)",
                            d: "M-14.4 50.114C-16.968-5.19 25.782-52.103 81.085-54.671S183.302-14.489 185.87 40.814 145.688 143.031 90.385 145.6-11.832 105.417-14.4 50.114"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#f2ac84__e)",
                            d: "M40.418-110.716c-12.475-7.72-28.282-7.767-40.804-.122l-125.242 76.469c-12.266 7.49-12.286 25.167-.037 32.684L-1.25 74.676c12.503 7.673 28.31 7.664 40.802-.027L163.71-1.783c12.185-7.502 12.207-25.08.038-32.61z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#f2ac84__f)",
                            d: "M-79.763 76.529c25.814 0 49.197 10.448 66.127 27.302 33.86 33.768 61.931 33.797 95.79.087C99.084 86.977 122.497 76.5 148.34 76.5c51.657.029 93.504 41.762 93.504 93.279S199.997 263 148.34 263c-25.901 0-49.314-10.505-66.243-27.447-33.83-33.652-61.873-33.623-95.733.144C-30.566 252.581-53.949 263-79.763 263c-51.629 0-93.475-41.733-93.475-93.221s41.846-93.25 93.475-93.25"
                        })
                    ]
                })
            })
        ]
    });
const $20b96afb11026508$var$$192d4d12c2fcaf76$var$ForwardRef = (0, $eF4cA.forwardRef)($20b96afb11026508$var$$192d4d12c2fcaf76$var$SvgComponent);
var $20b96afb11026508$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($20b96afb11026508$var$$192d4d12c2fcaf76$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $0ca31fcd4205e5df$var$$a1a9f46cc0d96853$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "3c342e__d",
                        x1: 69.462,
                        x2: 13.866,
                        y1: -3.088,
                        y2: 68.993,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FF4885"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF4885",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "3c342e__e",
                        x1: 35.59,
                        x2: 46.315,
                        y1: -36.272,
                        y2: 32.367,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.156,
                                stopColor: "#7A6AFD"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A6AFD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "3c342e__f",
                        x1: -88.161,
                        x2: 92.291,
                        y1: 101.725,
                        y2: 66.061,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#30A7FE",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#30A7FE",
                                stopOpacity: 0.995
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#30A7FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#30A7FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "3c342e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 11.23 74.342)scale(138.607)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.089,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "3c342e__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#fff",
                            rx: 10
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "3c342e__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M18.25 26.05c0-3.313 2.686-6 6-6H62c3.314 0 6 2.687 6 6v11.7H49.552c-3.144 0-5.948 1.45-7.782 3.718l-3.1-4.99-.003-.006c-1.945-3.158-6.52-3.206-8.532-.089l-.001.003-11.459 17.811c-.274-.687-.425-1.437-.425-2.222zm17.017 12.53 4.477 7.207q-.19.954-.192 1.963v10.225H24.25c-1.012 0-1.966-.251-2.803-.694l12.05-18.73c.417-.644 1.363-.634 1.765.02zm23.878-7.162c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3M43.552 47.75c0-3.314 2.686-6 6-6H71.75c3.314 0 6 2.686 6 6v22.198c0 3.314-2.686 6-6 6H49.552c-3.314 0-6-2.686-6-6zm24.48 9.96-11.215-6.432c-1.256-.72-2.828.176-2.83 1.614l-.015 12.838c-.002 1.437 1.568 2.338 2.826 1.62l11.23-6.405c1.257-.718 1.26-2.515.003-3.235"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#3c342e__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#3c342e__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 96,
                            height: 96,
                            fill: "#D9F4FD",
                            rx: 10
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 85.571,
                            cy: 63.112,
                            r: 138.607,
                            fill: "url(#3c342e__c)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#3c342e__d)",
                            d: "M-8.64 30.067c-1.54-33.182 24.11-61.33 57.292-62.87 33.182-1.541 61.33 24.109 62.871 57.29 1.54 33.182-24.11 61.33-57.291 62.871-33.182 1.54-61.33-24.11-62.871-57.291"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#3c342e__e)",
                            d: "M24.253-66.43c-7.486-4.632-16.97-4.66-24.483-.073l-75.145 45.881c-7.36 4.494-7.372 15.1-.023 19.61l74.65 45.817c7.501 4.604 16.985 4.598 24.48-.016l74.496-45.86c7.31-4.5 7.324-15.048.022-19.566z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#3c342e__f)",
                            d: "M-47.859 45.918c15.489 0 29.519 6.268 39.677 16.381 20.315 20.26 37.158 20.278 57.474.052 10.158-10.165 24.205-16.45 39.711-16.45 30.994.017 56.102 25.056 56.102 55.967S119.997 157.8 89.003 157.8c-15.54 0-29.588-6.303-39.746-16.468-20.298-20.191-37.124-20.174-57.44.087C-18.34 151.549-32.37 157.8-47.858 157.8c-30.977 0-56.085-25.039-56.085-55.932s25.108-55.95 56.085-55.95"
                        })
                    ]
                })
            })
        ]
    });
const $0ca31fcd4205e5df$var$$a1a9f46cc0d96853$var$ForwardRef = (0, $eF4cA.forwardRef)($0ca31fcd4205e5df$var$$a1a9f46cc0d96853$var$SvgComponent);
var $0ca31fcd4205e5df$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($0ca31fcd4205e5df$var$$a1a9f46cc0d96853$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $0cdf160e1b9783f5$var$$5e2019b51bc3e710$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "d08810__d",
                        x1: 34.731,
                        x2: 6.933,
                        y1: -1.543,
                        y2: 34.498,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FF4885"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF4885",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "d08810__e",
                        x1: 17.793,
                        x2: 23.155,
                        y1: -18.135,
                        y2: 16.184,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.156,
                                stopColor: "#7A6AFD"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A6AFD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "d08810__f",
                        x1: -44.078,
                        x2: 46.147,
                        y1: 50.862,
                        y2: 33.03,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#30A7FE",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#30A7FE",
                                stopOpacity: 0.995
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#30A7FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#30A7FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "d08810__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 5.616 37.171)scale(69.3033)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.089,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "d08810__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#fff",
                            rx: 10
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "d08810__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M9.125 14.027c0-2.209 1.79-4 4-4H30c2.21 0 4 1.791 4 4v4.348h-8.224c-1.892 0-3.594.808-4.782 2.097l-1.445-2.36-.001-.002c-1.068-1.738-3.584-1.766-4.69-.052l-5.44 8.434c-.19-.464-.293-.972-.293-1.504zm10.15 10.848v4.113h-6.15c-.728 0-1.41-.194-1.998-.534l5.831-9.04c.109-.168.355-.166.46.004l2.152 3.518c-.191.612-.294 1.264-.294 1.939m8.798-7.664c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5c-.829 0-1.5.672-1.5 1.5s.671 1.5 1.5 1.5m-6.297 7.664c0-2.21 1.79-4 4-4h9.099c2.21 0 4 1.79 4 4v9.1c0 2.208-1.79 4-4 4h-9.1c-2.208 0-4-1.792-4-4zm12.24 3.982-5.607-3.216c-.628-.36-1.414.088-1.415.807l-.008 6.419c0 .719.784 1.169 1.413.81l5.615-3.203c.629-.358.63-1.257.002-1.617"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#d08810__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#d08810__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 48,
                            height: 48,
                            fill: "#D9F4FD",
                            rx: 10
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 42.788,
                            cy: 31.555,
                            r: 69.303,
                            fill: "url(#d08810__c)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#d08810__d)",
                            d: "M-4.32 15.035C-5.09-1.557 7.735-15.63 24.326-16.401c16.59-.77 30.665 12.055 31.435 28.646.77 16.59-12.054 30.665-28.645 31.435S-3.55 31.625-4.32 15.035"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#d08810__e)",
                            d: "M12.124-33.214c-3.742-2.316-8.484-2.33-12.24-.037L-37.69-10.31c-3.68 2.247-3.686 7.55-.01 9.805L-.377 22.404c3.75 2.301 8.493 2.299 12.24-.009L49.112-.535c3.655-2.25 3.662-7.523.011-9.782z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#d08810__f)",
                            d: "M-23.927 22.958c7.744 0 14.759 3.134 19.838 8.19 10.158 10.13 18.58 10.14 28.737.027 5.079-5.083 12.103-8.226 19.855-8.226 15.498.009 28.052 12.529 28.052 27.984S60 78.899 44.503 78.899c-7.77 0-14.794-3.151-19.872-8.234-10.15-10.095-18.562-10.087-28.72.043-5.08 5.066-12.094 8.191-19.838 8.191-15.489 0-28.043-12.52-28.043-27.966s12.554-27.975 28.043-27.975"
                        })
                    ]
                })
            })
        ]
    });
const $0cdf160e1b9783f5$var$$5e2019b51bc3e710$var$ForwardRef = (0, $eF4cA.forwardRef)($0cdf160e1b9783f5$var$$5e2019b51bc3e710$var$SvgComponent);
var $0cdf160e1b9783f5$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($0cdf160e1b9783f5$var$$5e2019b51bc3e710$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e76bf3a4cae7a571$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $20b96afb11026508$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $0cdf160e1b9783f5$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $0ca31fcd4205e5df$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $573e4a6c7d0fe92b$var$$18ea86fd25db8097$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M80 27.74c-28.719 0-52 23.281-52 52s23.281 52 52 52 52-23.281 52-52-23.281-52-52-52m-60 52c0-33.137 26.863-60 60-60s60 26.863 60 60-26.863 60-60 60-60-26.863-60-60m64-2.31V40.74c0-2.209-1.79-4-4-4s-4 1.791-4 4v38.924q-.004.239.02.476c.057.578.238 1.121.515 1.6s.656.908 1.128 1.247q.194.14.404.256l21.754 12.56c1.913 1.104 4.359.448 5.464-1.465 1.104-1.913.449-4.36-1.464-5.464z"
        })
    });
const $573e4a6c7d0fe92b$var$$18ea86fd25db8097$var$ForwardRef = (0, $eF4cA.forwardRef)($573e4a6c7d0fe92b$var$$18ea86fd25db8097$var$SvgComponent);
var $573e4a6c7d0fe92b$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($573e4a6c7d0fe92b$var$$18ea86fd25db8097$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $088d9afe65a5933e$var$$8a1986ae343e6319$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M48 16.74c-17.12 0-31 13.88-31 31 0 17.121 13.88 31 31 31s31-13.879 31-31c0-17.12-13.88-31-31-31m-35 31c0-19.33 15.67-35 35-35s35 15.67 35 35-15.67 35-35 35-35-15.67-35-35m37-1.154V24.74c0-1.104-.895-2-2-2s-2 .896-2 2v22.962q-.002.12.01.238c.029.29.119.56.258.8.138.24.328.455.565.624q.096.07.2.127l12.826 7.405c.956.553 2.18.225 2.732-.732.552-.956.224-2.18-.732-2.732z"
        })
    });
const $088d9afe65a5933e$var$$8a1986ae343e6319$var$ForwardRef = (0, $eF4cA.forwardRef)($088d9afe65a5933e$var$$8a1986ae343e6319$var$SvgComponent);
var $088d9afe65a5933e$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($088d9afe65a5933e$var$$8a1986ae343e6319$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $2241a3c724b3f8d9$var$$09f1665d7517b712$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M24 7.99c-8.698 0-15.75 7.052-15.75 15.75S15.302 39.49 24 39.49s15.75-7.051 15.75-15.75S32.699 7.99 24 7.99M5.75 23.74C5.75 13.661 13.92 5.49 24 5.49s18.25 8.171 18.25 18.25S34.08 41.99 24 41.99 5.75 33.82 5.75 23.74m19.5-.721V12.24c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v11.476q0 .075.006.149c.018.18.075.35.161.5s.205.284.353.39q.06.044.126.08l6.408 3.7c.598.345 1.363.14 1.708-.458s.14-1.362-.458-1.707z"
        })
    });
const $2241a3c724b3f8d9$var$$09f1665d7517b712$var$ForwardRef = (0, $eF4cA.forwardRef)($2241a3c724b3f8d9$var$$09f1665d7517b712$var$SvgComponent);
var $2241a3c724b3f8d9$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($2241a3c724b3f8d9$var$$09f1665d7517b712$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d1d49e40e1c5d96c$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $573e4a6c7d0fe92b$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $2241a3c724b3f8d9$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $088d9afe65a5933e$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


parcelRequire("edFAP");

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $ab0f66b034da7456$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M9.3 2.4H7.233c-1.14 0-2.066.926-2.066 2.067s.925 2.066 2.066 2.066H9.3zm0-1.4h3.467c1.914 0 3.466 1.552 3.466 3.467 0 1.13-.54 2.134-1.377 2.766.837.633 1.377 1.637 1.377 2.767 0 1.915-1.552 3.467-3.466 3.467-.775 0-1.49-.254-2.067-.683v2.75C10.7 17.447 9.148 19 7.233 19s-3.466-1.552-3.466-3.467c0-1.13.54-2.134 1.377-2.766-.837-.633-1.377-1.637-1.377-2.767s.54-2.134 1.377-2.767c-.837-.632-1.377-1.636-1.377-2.766C3.767 2.552 5.319 1 7.233 1zm1.4 1.4v4.133h2.067c1.14 0 2.066-.925 2.066-2.066S13.908 2.4 12.767 2.4zm-3.466 9.666H9.3V7.934H7.233c-1.14 0-2.066.925-2.066 2.066 0 1.138.921 2.062 2.058 2.066zm-2.067 3.467c0-1.138.921-2.062 2.058-2.066H9.3v2.066c0 1.141-.925 2.066-2.067 2.066s-2.066-.925-2.066-2.066M10.7 9.996c.003-1.14.927-2.062 2.067-2.062s2.066.925 2.066 2.066-.925 2.066-2.066 2.066-2.064-.923-2.067-2.062z"
        })
    });
const $ab0f66b034da7456$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($ab0f66b034da7456$var$SvgComponent);
var $ab0f66b034da7456$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($ab0f66b034da7456$var$ForwardRef);



var $ikOQe = parcelRequire("ikOQe");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $9eyCh = parcelRequire("9eyCh");


var $waxwa = parcelRequire("waxwa");

var $4UbTp = parcelRequire("4UbTp");

var $fL4LX = parcelRequire("fL4LX");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $4HiHF = parcelRequire("4HiHF");

var $eF4cA = parcelRequire("eF4cA");

var $6pgkA = parcelRequire("6pgkA");

var $iUErx = parcelRequire("iUErx");

var $6AczJ = parcelRequire("6AczJ");

var $aGDvF = parcelRequire("aGDvF");

var $gI8Gw = parcelRequire("gI8Gw");

var $26CkO = parcelRequire("26CkO");

var $f9wnx = parcelRequire("f9wnx");
function $df1664e6139b6656$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $df1664e6139b6656$var$$f21f2186348fbc5b$var$actionBarStyles = function anonymous(props) {
    let rules = " ";
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    if (props.isEmphasized) rules += ' -Ovbhqd-g0182';
    else rules += ' -Ovbhqd-g_g182';
    rules += ' gEzkoQe182';
    rules += ' _nLeasBb182';
    rules += ' _oa182';
    rules += ' _Lf182';
    rules += ' _Mb182';
    if (props.isEmphasized) rules += ' Oj182';
    else rules += ' Oye39g182';
    rules += ' Ola182';
    rules += ' St182';
    rules += ' Rt182';
    rules += ' Te182';
    rules += ' Qe182';
    rules += ' sd182';
    rules += ' Ul182';
    rules += ' ql182';
    rules += ' eb182';
    if (props.isInContainer) rules += ' _Pa182';
    rules += ' _lr182';
    rules += ' _AI182';
    rules += ' -F3Iohc-_zI182';
    if (props.isInContainer) rules += ' Zd182';
    else rules += ' Za182';
    rules += ' IM182';
    rules += ' HM182';
    rules += ' Ll182';
    rules += ' Yg182';
    rules += ' Xc182';
    rules += ' _2b182';
    if (props.isExiting) {
        rules += ' -_8PloMd-t182';
        rules += ' __Ya182';
    } else if (props.isEntering) {
        rules += ' -_8PloMd-t182';
        rules += ' __Ya182';
    } else {
        rules += ' -_8PloMd-q182';
        rules += ' __Ya182';
    }
    return rules;
};
const $df1664e6139b6656$export$9f306827c48feef4 = (0, $eF4cA.createContext)(null);
const $df1664e6139b6656$export$e213cebad6250b4a = (0, $eF4cA.forwardRef)(function ActionBar(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $df1664e6139b6656$export$9f306827c48feef4);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let isOpen = props.selectedItemCount !== 0;
    let isExiting = (0, $6AczJ.useExitAnimation)(domRef, isOpen && props.scrollRef != null);
    if (!isOpen && !isExiting) return null;
    return (0, $dx4lB.jsx)($df1664e6139b6656$var$$f21f2186348fbc5b$var$ActionBarInner, {
        ...props,
        ref: domRef,
        isExiting: isExiting
    });
});
const $df1664e6139b6656$var$$f21f2186348fbc5b$var$ActionBarInner = (0, $eF4cA.forwardRef)(function ActionBarInner(props1, ref) {
    let { isEmphasized: isEmphasized, selectedItemCount: selectedItemCount = 0, children: children, onClearSelection: onClearSelection, isExiting: isExiting, slot: slot, scrollRef: scrollRef, ...otherProps } = props1;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($df1664e6139b6656$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    // Store the last count greater than zero so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, $eF4cA.useState)(selectedItemCount);
    if ((selectedItemCount === 'all' || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    // Measure the width of the collection's scrollbar and offset the action bar by that amount.
    let [scrollbarWidth, setScrollbarWidth] = (0, $eF4cA.useState)(0);
    let updateScrollbarWidth = (0, $eF4cA.useCallback)(()=>{
        let el = scrollRef?.current;
        if (el) {
            let w = el.offsetWidth - el.clientWidth;
            setScrollbarWidth(w);
        }
    }, [
        scrollRef
    ]);
    (0, $f9wnx.useResizeObserver)({
        ref: scrollRef,
        onResize: updateScrollbarWidth
    });
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            Escape: ()=>{
                onClearSelection?.();
            }
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, $eF4cA.useRef)(true);
    (0, $eF4cA.useEffect)(()=>{
        if (isInitial.current && scrollRef) {
            isInitial.current = false;
            (0, $4HiHF.announce)(stringFormatter.format('actionbar.actionsAvailable'));
        }
    }, [
        stringFormatter,
        scrollRef
    ]);
    let objectRef = (0, $26CkO.useObjectRef)(ref);
    let isEntering = (0, $6AczJ.useEnterAnimation)(objectRef) && !!scrollRef;
    return (0, $dx4lB.jsx)((0, $6pgkA.FocusScope), {
        restoreFocus: true,
        children: (0, $dx4lB.jsxs)("div", {
            ref: objectRef,
            ...otherProps,
            ...keyboardProps,
            className: (props1.UNSAFE_className || '') + $df1664e6139b6656$var$$f21f2186348fbc5b$var$actionBarStyles({
                isEmphasized: isEmphasized,
                isInContainer: !!scrollRef,
                isEntering: isEntering,
                isExiting: isExiting
            }),
            style: {
                insetInlineEnd: `calc(var(--insetEnd) + ${scrollbarWidth}px)`,
                ...props1.UNSAFE_style
            },
            children: [
                (0, $dx4lB.jsx)("div", {
                    className: " _Jb182 IM182",
                    children: (0, $dx4lB.jsx)((0, $waxwa.ActionButtonGroup), {
                        staticColor: isEmphasized ? 'auto' : undefined,
                        isQuiet: true,
                        "aria-label": stringFormatter.format('actionbar.actions'),
                        children: children
                    })
                }),
                (0, $dx4lB.jsxs)("div", {
                    className: " _Ja182 sd182 eb182 Ub182 qb182",
                    children: [
                        (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                            staticColor: isEmphasized ? 'auto' : undefined,
                            "aria-label": stringFormatter.format('actionbar.clearSelection'),
                            onPress: ()=>onClearSelection?.()
                        }),
                        (0, $dx4lB.jsx)("span", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' uk182';
                                rules += ' ucJ9TBTb182';
                                rules += ' ud3Euai182';
                                rules += ' uea182';
                                rules += ' ugb182';
                                rules += ' uhd182';
                                rules += ' uje182';
                                rules += ' u2NhKxcl182';
                                rules += ' uic182';
                                rules += ' -_6BNtrc-c182';
                                rules += ' vx182';
                                rules += ' xb182';
                                rules += ' _xa182';
                                rules += ' _Fd182';
                                rules += ' _FnuYUweb182';
                                if (props.isEmphasized) rules += ' pr182';
                                else rules += ' pt182';
                                return rules;
                            }({
                                isEmphasized: isEmphasized
                            }),
                            children: lastCount === 'all' ? stringFormatter.format('actionbar.selectedAll') : stringFormatter.format('actionbar.selected', {
                                count: lastCount
                            })
                        })
                    ]
                })
            ]
        })
    });
});
function $df1664e6139b6656$export$13f32e21845e01d0(props) {
    let { renderActionBar: renderActionBar, scrollRef: scrollRef } = props;
    let [selectedKeys, setSelectedKeys] = (0, $iUErx.useControlledState)(props.selectedKeys, props.defaultSelectedKeys || new Set(), props.onSelectionChange);
    let selectedKeysSet = (0, $eF4cA.useMemo)(()=>selectedKeys === 'all' ? selectedKeys : new Set(selectedKeys), [
        selectedKeys
    ]);
    let actionBar = (0, $eF4cA.useMemo)(()=>renderActionBar?.(selectedKeysSet), [
        renderActionBar,
        selectedKeysSet
    ]);
    let selectedItemCount = selectedKeysSet === 'all' ? 'all' : selectedKeysSet.size;
    let [actionBarHeight, setActionBarHeight] = (0, $eF4cA.useState)(0);
    let actionBarRef = (0, $eF4cA.useCallback)((ref)=>{
        let actionBar = ref?.UNSAFE_getDOMNode();
        if (actionBar) setActionBarHeight(actionBar.offsetHeight + 8);
        else setActionBarHeight(0);
    }, []);
    let actionBarContext = (0, $eF4cA.useMemo)(()=>({
            ref: actionBarRef,
            scrollRef: scrollRef,
            selectedItemCount: selectedItemCount,
            onClearSelection: ()=>setSelectedKeys(new Set())
        }), [
        scrollRef,
        actionBarRef,
        selectedItemCount,
        setSelectedKeys
    ]);
    let wrappedActionBar = (0, $eF4cA.useMemo)(()=>(0, $dx4lB.jsx)($df1664e6139b6656$export$9f306827c48feef4.Provider, {
            value: actionBarContext,
            children: actionBar
        }), [
        actionBarContext,
        actionBar
    ]);
    return {
        selectedKeys: selectedKeys,
        onSelectionChange: setSelectedKeys,
        actionBar: wrappedActionBar,
        actionBarHeight: actionBarHeight
    };
}


var $4W5AG = parcelRequire("4W5AG");
var $5NHyX = parcelRequire("5NHyX");

var $2RdeM = parcelRequire("2RdeM");

var $jTg9X = parcelRequire("jTg9X");


var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $ed1Og = parcelRequire("ed1Og");

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $cLs8t = parcelRequire("cLs8t");

var $9PmUB = parcelRequire("9PmUB");

var $cg9Gh = parcelRequire("cg9Gh");

var $hUj7u = parcelRequire("hUj7u");

var $2FPWu = parcelRequire("2FPWu");

var $c1ibQ = parcelRequire("c1ibQ");

var $fvrZl = parcelRequire("fvrZl");
var $8HLWT = parcelRequire("8HLWT");
var $dkaC0 = parcelRequire("dkaC0");

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cb4a7571eedec626$export$8a024deed275af3f(props, state, ref) {
    let { 'aria-label': ariaLabel } = props;
    let headingId = (0, $25dFS.useSlotId)();
    let labelProps = (0, $dkaC0.useLabels)({
        'aria-label': ariaLabel,
        'aria-labelledby': headingId
    });
    return {
        rowProps: {
            role: 'row'
        },
        rowHeaderProps: {
            id: headingId,
            role: 'rowheader'
        },
        rowGroupProps: {
            role: 'rowgroup',
            ...labelProps
        }
    };
}


var $bx0ZP = parcelRequire("bx0ZP");

var $25dFS = parcelRequire("25dFS");

var $gI8Gw = parcelRequire("gI8Gw");
function $398321077e72958b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $398321077e72958b$export$70e2eed1a92976ad(props, state) {
    let { key: key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, $25dFS.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($398321077e72958b$var$$parcel$interopDefault((0, $bx0ZP.default)), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected: isSelected,
            isDisabled: isDisabled,
            onChange: onChange
        }
    };
}



var $7Ydqk = parcelRequire("7Ydqk");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $eba6e179724d2f2a$export$e29f2573fabbf7b9(props, state) {
    let { key: key } = props;
    const { checkboxProps: checkboxProps } = (0, $398321077e72958b$export$70e2eed1a92976ad)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, $7Ydqk.getRowId)(state, key)}`
        }
    };
}



var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $fVfXf = parcelRequire("fVfXf");

var $6pgkA = parcelRequire("6pgkA");

var $bWhaY = parcelRequire("bWhaY");

var $gF3YT = parcelRequire("gF3YT");

var $daM4n = parcelRequire("daM4n");

var $fHi9W = parcelRequire("fHi9W");

var $lJdzA = parcelRequire("lJdzA");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $gm31e = parcelRequire("gm31e");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $1ntKq = parcelRequire("1ntKq");

var $26CkO = parcelRequire("26CkO");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0c1b7b025fb75d97$export$54fe942636b6416d = (0, $eF4cA.createContext)(null);
const $0c1b7b025fb75d97$export$a7bfbda1311ca015 = (0, $eF4cA.forwardRef)(function GridList(props, ref) {
    // Render the portal first so that we have the collection by the time we render the DOM in SSR.
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $0c1b7b025fb75d97$export$54fe942636b6416d);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListInner, {
            props: props,
            collection: collection,
            gridListRef: ref
        }));
});
function $0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListInner({ props: props, collection: collection, gridListRef: ref }) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, (0, $9PmUB.SelectableCollectionContext));
    let { shouldUseVirtualFocus: shouldUseVirtualFocus, filter: filter, disallowTypeAhead: disallowTypeAhead, UNSTABLE_focusOnEntry: UNSTABLE_focusOnEntry, ...DOMCollectionProps } = props;
    let { dragAndDropHooks: dragAndDropHooks, keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow', layout: layout = 'stack', orientation: orientation = 'vertical' } = props;
    let { CollectionRoot: CollectionRoot, isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let gridlistState = (0, $fHi9W.useListState)({
        ...DOMCollectionProps,
        collection: collection,
        children: undefined,
        layoutDelegate: layoutDelegate
    });
    // oxlint-disable-next-line react/react-compiler
    let filteredState = (0, $fHi9W.UNSTABLE_useFilteredListState)(gridlistState, filter);
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = filteredState.selectionManager;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let keyboardDelegate = (0, $eF4cA.useMemo)(()=>new (0, $daM4n.ListKeyboardDelegate)({
            collection: filteredState.collection,
            collator: collator,
            ref: ref,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layoutDelegate: layoutDelegate,
            layout: layout,
            orientation: orientation,
            direction: direction
        }), [
        filteredState.collection,
        ref,
        layout,
        orientation,
        disabledKeys,
        disabledBehavior,
        layoutDelegate,
        collator,
        direction
    ]);
    let { gridProps: gridProps } = (0, $fvrZl.useGridList)({
        ...DOMCollectionProps,
        keyboardDelegate: keyboardDelegate,
        // Only tab navigation is supported in grid layout.
        keyboardNavigationBehavior: layout === 'grid' ? 'tab' : keyboardNavigationBehavior,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        disallowTypeAhead: disallowTypeAhead,
        UNSTABLE_focusOnEntry: UNSTABLE_focusOnEntry
    }, filteredState, ref);
    let selectionManager = filteredState.selectionManager;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, $eF4cA.useRef)(isListDraggable);
    let dropHooksProvided = (0, $eF4cA.useRef)(isListDroppable);
    (0, $eF4cA.useEffect)(()=>{
        return;
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $eF4cA.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: filteredState.collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        // oxlint-disable-next-line react/react-compiler
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: filteredState.collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, ref, {
            layout: layout,
            direction: direction,
            orientation: orientation
        });
        // oxlint-disable-next-line react/react-compiler
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let isEmpty = filteredState.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        orientation: orientation,
        isEmpty: isEmpty,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: layout,
        state: filteredState
    };
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-GridList',
        values: renderValues
    });
    let emptyState = null;
    let emptyStatePropOverrides = null;
    if (isEmpty && props.renderEmptyState) {
        let content = props.renderEmptyState(renderValues);
        emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
            role: "row",
            "aria-rowindex": 1,
            style: {
                display: 'contents'
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
            role: "gridcell",
            style: {
                display: 'contents'
            }
        }, content));
    }
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $6pgkA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, gridProps, focusProps, droppableCollection?.collectionProps, emptyStatePropOverrides),
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": layout,
        "data-orientation": orientation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $cg9Gh.ListStateContext),
                filteredState
            ],
            [
                (0, $cLs8t.DragAndDropContext),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $cLs8t.DropIndicatorContext),
                {
                    render: $0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListDropIndicatorWrapper
                }
            ]
        ]
    }, isListDroppable && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$RootDropIndicator, null), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
        collection: filteredState.collection,
        scrollRef: ref,
        persistedKeys: (0, $cLs8t.useDndPersistedKeys)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $cLs8t.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
const $0c1b7b025fb75d97$export$e96fc9a8407faa6b = (0, $3g2oV.createLeafComponent)((0, $bWhaY.ItemNode), function GridListItem(props, forwardedRef, item) {
    let state = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let isDraggable = dragState && !(dragState.isDisabled || dragState.selectionManager.isDisabled(item.key));
    let { rowProps: rowProps, gridCellProps: gridCellProps, descriptionProps: descriptionProps, ...states } = (0, $8HLWT.useGridListItem)({
        node: item,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized: isVirtualized,
        focusMode: props.focusMode,
        allowsArrowNavigation: props.allowsArrowNavigation
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        // because of https://bugs.webkit.org/show_bug.cgi?id=214609, supporting hover styles when a item is ONLY isDraggable
        // results in hover styles sticking around after a reorder/drop operation...
        isDisabled: !states.allowsSelection && !states.hasAction && !isDraggable,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let { checkboxProps: checkboxProps } = (0, $eba6e179724d2f2a$export$e29f2573fabbf7b9)({
        key: item.key
    }, state);
    let buttonProps = state.selectionManager.disabledBehavior === 'all' && states.isDisabled ? {
        isDisabled: true
    } : {};
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = null;
    let dropIndicatorRef = (0, $eF4cA.useRef)(null);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, dropIndicatorRef);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListItem',
        values: {
            ...states,
            isHovered: isHovered,
            isFocusVisible: isFocusVisible,
            isFocusVisibleWithin: isFocusVisibleWithin,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: dropIndicator?.isDropTarget,
            id: item.key,
            state: state
        }
    });
    let dragButtonRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (dragState && !dragButtonRef.current) console.warn('Draggable items in a GridList must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
    // eslint-disable-next-line
    }, []);
    (0, $eF4cA.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, dropIndicator && !dropIndicator.isHidden && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "row",
        style: {
            position: 'absolute'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "gridcell"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator?.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, rowProps, focusProps, focusWithinProps, hoverProps, draggableItem?.dragProps),
        ref: ref,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-focus-visible-within": isFocusVisibleWithin || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-dragging": !!dragState || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": dropIndicator?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $ed1Og.CheckboxContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $ed1Og.CheckboxFieldContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: buttonProps,
                        drag: {
                            ...draggableItem?.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: 'none'
                            }
                        }
                    }
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $8dzVy.CollectionRendererContext),
                (0, $8dzVy.DefaultCollectionRenderer)
            ],
            [
                (0, $cg9Gh.ListStateContext),
                null
            ],
            [
                (0, $9PmUB.SelectableCollectionContext),
                null
            ],
            [
                (0, $9PmUB.FieldInputContext),
                null
            ],
            [
                (0, $hUj7u.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children))));
});
function $0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListDropIndicatorWrapper(props, ref) {
    ref = (0, $26CkO.useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let buttonRef = (0, $eF4cA.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        buttonRef: buttonRef,
        ref: ref
    });
}
function $0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, buttonRef: buttonRef, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...renderProps,
        role: "row",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "gridcell"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const $0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListDropIndicatorForwardRef = (0, $eF4cA.forwardRef)($0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$GridListDropIndicator);
function $0c1b7b025fb75d97$var$$1f7649abe3ae3599$var$RootDropIndicator() {
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let ref = (0, $eF4cA.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden'],
        style: {
            position: 'absolute'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "gridcell"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}
const $0c1b7b025fb75d97$export$392b9a0bbc7c7e43 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.LoaderNode), function GridListLoadingIndicator(props, ref, item) {
    let state = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $eF4cA.useRef)(null);
    let memoedLoadMoreProps = (0, $eF4cA.useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        sentinelRef,
        state?.collection
    ]);
    (0, $lJdzA.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListLoadingIndicator',
        values: undefined
    });
    // For now don't include aria-posinset and aria-setsize on loader since they aren't keyboard focusable
    // Arguably shouldn't include them ever since it might be confusing to the user to include the loaders as part of the
    // item count
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $gF3YT.inertValue)(true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...renderProps,
        ...(0, $fVfXf.filterDOMProps)(props, {
            global: true
        }),
        role: "row",
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "aria-colindex": isVirtualized ? 1 : undefined,
        role: "gridcell"
    }, renderProps.children)));
});
const $0c1b7b025fb75d97$export$f696877219115b14 = (0, $3g2oV.createBranchComponent)((0, $bWhaY.SectionNode), (props, ref, item)=>{
    let state = (0, $eF4cA.useContext)((0, $cg9Gh.ListStateContext));
    let { CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let headingRef = (0, $eF4cA.useRef)(null);
    ref = (0, $26CkO.useObjectRef)(ref);
    let { rowHeaderProps: rowHeaderProps, rowProps: rowProps, rowGroupProps: rowGroupProps } = (0, $cb4a7571eedec626$export$8a024deed275af3f)({
        'aria-label': props['aria-label'] ?? undefined
    }, state, ref);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: 'react-aria-GridListSection',
        values: undefined
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, rowGroupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $0c1b7b025fb75d97$export$87f5843bfb30d205,
                {
                    ...rowProps,
                    ref: headingRef
                }
            ],
            [
                $0c1b7b025fb75d97$export$bc7e8a4031ec2a33,
                {
                    ...rowHeaderProps
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    })));
});
const $0c1b7b025fb75d97$export$87f5843bfb30d205 = (0, $eF4cA.createContext)({});
const $0c1b7b025fb75d97$export$bc7e8a4031ec2a33 = (0, $eF4cA.createContext)(null);
const $0c1b7b025fb75d97$export$1b574dbdb0075ff6 = (0, $3g2oV.createLeafComponent)((0, $bWhaY.HeaderNode), function Header(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $0c1b7b025fb75d97$export$87f5843bfb30d205);
    let rowHeaderProps = (0, $eF4cA.useContext)($0c1b7b025fb75d97$export$bc7e8a4031ec2a33);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        render: props.render,
        className: "react-aria-GridListHeader",
        ref: ref,
        ...props
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...rowHeaderProps,
        style: {
            display: 'contents'
        }
    }, props.children));
});



var $3g2oV = parcelRequire("3g2oV");

var $eF4cA = parcelRequire("eF4cA");

var $fK9fi = parcelRequire("fK9fi");

var $dnqqa = parcelRequire("dnqqa");

var $8bBQM = parcelRequire("8bBQM");

var $bMKKe = parcelRequire("bMKKe");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS = {
    minItemSize: new (0, $bMKKe.Size)(200, 200),
    maxItemSize: new (0, $bMKKe.Size)(Infinity, Infinity),
    preserveAspectRatio: false,
    minSpace: new (0, $bMKKe.Size)(18, 18),
    maxSpace: Infinity,
    maxColumns: Infinity,
    dropIndicatorThickness: 2,
    loaderHeight: 48
};
class $c308aee66d05bff9$export$7d2b12578154a735 extends (0, $fK9fi.Layout) {
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.maxColumns !== oldOptions.maxColumns || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.preserveAspectRatio !== oldOptions.preserveAspectRatio || !(newOptions.minItemSize || $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minItemSize).equals(oldOptions.minItemSize || $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minItemSize) || !(newOptions.maxItemSize || $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.maxItemSize).equals(oldOptions.maxItemSize || $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.maxItemSize) || !(newOptions.minSpace || $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minSpace).equals(oldOptions.minSpace || $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minSpace) || newOptions.maxHorizontalSpace !== oldOptions.maxHorizontalSpace || newOptions.loaderHeight !== oldOptions.loaderHeight || newOptions.direction !== oldOptions.direction;
    }
    update(invalidationContext) {
        let { minItemSize: minItemSize = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minItemSize, maxItemSize: maxItemSize = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.maxItemSize, preserveAspectRatio: preserveAspectRatio = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.preserveAspectRatio, minSpace: minSpace = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minSpace, maxHorizontalSpace: maxHorizontalSpace = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.maxSpace, maxColumns: maxColumns = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.maxColumns, dropIndicatorThickness: dropIndicatorThickness = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.dropIndicatorThickness, loaderHeight: loaderHeight = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.loaderHeight, direction: direction = 'ltr' } = invalidationContext.layoutOptions || {};
        this.dropIndicatorThickness = dropIndicatorThickness;
        this.direction = direction;
        let virtualizerWidth = this.virtualizer.size.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, virtualizerWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(virtualizerWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        this.numColumns = numColumns;
        // Compute the available width (minus the space between items)
        let width = virtualizerWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing, content height and horizontal margin
        let horizontalSpacing = Math.min(Math.max(maxHorizontalSpace, minSpace.width), Math.floor((virtualizerWidth - numColumns * itemWidth) / (numColumns + 1)));
        this.gap = new (0, $bMKKe.Size)(horizontalSpacing, minSpace.height);
        this.margin = Math.floor((virtualizerWidth - numColumns * itemWidth - horizontalSpacing * (numColumns + 1)) / 2);
        // If there is a skeleton loader within the last 2 items in the collection, increment the collection size
        // so that an additional row is added for the skeletons.
        let collection = this.virtualizer.collection;
        let collectionSize = collection.size;
        let lastKey = collection.getLastKey();
        for(let i = 0; i < 2 && lastKey != null; i++){
            let item = collection.getItem(lastKey);
            if (item?.type === 'skeleton') {
                collectionSize++;
                break;
            }
            lastKey = collection.getKeyBefore(lastKey);
        }
        let rows = Math.ceil(collectionSize / numColumns);
        let iterator = collection[Symbol.iterator]();
        let y = rows > 0 ? minSpace.height : 0;
        let newLayoutInfos = new Map();
        let skeleton = null;
        let skeletonCount = 0;
        for(let row = 0; row < rows; row++){
            let maxHeight = 0;
            let rowLayoutInfos = [];
            for(let col = 0; col < numColumns; col++){
                // Repeat skeleton until the end of the current row.
                let node = skeleton || iterator.next().value;
                if (!node) break;
                // We will add the loader after the skeletons so skip here
                if (node.type === 'loader') continue;
                if (node.type === 'skeleton') skeleton = node;
                let key = skeleton ? `${skeleton.key}-${skeletonCount++}` : node.key;
                let oldLayoutInfo = this.layoutInfos.get(key);
                let content = node;
                if (skeleton) content = oldLayoutInfo && oldLayoutInfo.content.key === key ? oldLayoutInfo.content : {
                    ...skeleton,
                    key: key
                };
                let x = horizontalSpacing + col * (itemWidth + horizontalSpacing) + this.margin;
                let height = itemHeight;
                let estimatedSize = !preserveAspectRatio;
                if (oldLayoutInfo && estimatedSize) {
                    height = oldLayoutInfo.rect.height;
                    estimatedSize = invalidationContext.layoutOptionsChanged || invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== content;
                }
                let rect = new (0, $8bBQM.Rect)(x, y, itemWidth, height);
                let layoutInfo = new (0, $dnqqa.LayoutInfo)(node.type, key, rect);
                layoutInfo.estimatedSize = estimatedSize;
                layoutInfo.allowOverflow = true;
                layoutInfo.content = content;
                newLayoutInfos.set(key, layoutInfo);
                rowLayoutInfos.push(layoutInfo);
                maxHeight = Math.max(maxHeight, layoutInfo.rect.height);
            }
            for (let layoutInfo of rowLayoutInfos)layoutInfo.rect.height = maxHeight;
            y += maxHeight + minSpace.height;
            // Keep adding skeleton rows until we fill the viewport
            if (skeleton && row === rows - 1 && y < this.virtualizer.size.height) rows++;
        }
        // Always add the loader sentinel if present in the collection so we can make sure it is never virtualized out.
        let lastNode = collection.getItem(collection.getLastKey());
        if (lastNode?.type === 'loader') {
            if (skeletonCount > 0 || !lastNode.props.isLoading) loaderHeight = 0;
            const loaderWidth = virtualizerWidth - horizontalSpacing * 2;
            // Note that if the user provides isLoading to their sentinel during a case where they only want to render the emptyState, this will reserve
            // room for the loader alongside rendering the emptyState
            let rect = new (0, $8bBQM.Rect)(horizontalSpacing, y, loaderWidth, loaderHeight);
            let layoutInfo = new (0, $dnqqa.LayoutInfo)('loader', lastNode.key, rect);
            newLayoutInfos.set(lastNode.key, layoutInfo);
            y = layoutInfo.rect.maxY;
        }
        this.layoutInfos = newLayoutInfos;
        this.contentSize = new (0, $bMKKe.Size)(this.virtualizer.size.width, y);
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key) || null;
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key) || layoutInfo.type === 'loader') layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.layoutInfos.size === 0) return {
            type: 'root'
        };
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // In RTL mode the virtualizer positions items using CSS `right` with the
        // layout rect's x value as the right-offset, but pointer coordinates are
        // in visual (left-origin) space. Flip x so it matches the layout coords.
        if (this.direction === 'rtl' && this.numColumns > 1) x = this.contentSize.width - x;
        // Find the closest item within on either side of the point using the gap width.
        let key = null;
        if (this.numColumns === 1) {
            let searchRect = new (0, $8bBQM.Rect)(x, Math.max(0, y - this.gap.height), 1, Math.max(1, this.gap.height * 2));
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let yDist = Math.abs(candidate.rect.y - y);
                let maxYDist = Math.abs(candidate.rect.maxY - y);
                let dist = Math.min(yDist, maxYDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        } else {
            let searchRect = new (0, $8bBQM.Rect)(Math.max(0, x - this.gap.width), y, this.gap.width * 2, 1);
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let xDist = Math.abs(candidate.rect.x - x);
                let maxXDist = Math.abs(candidate.rect.maxX - x);
                let dist = Math.min(xDist, maxXDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        }
        let layoutInfo = key != null ? this.getLayoutInfo(key) : null;
        if (!layoutInfo) return {
            type: 'root'
        };
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        let pos = this.numColumns === 1 ? y : x;
        let layoutInfoPos = this.numColumns === 1 ? layoutInfo.rect.y : layoutInfo.rect.x;
        let size = this.numColumns === 1 ? layoutInfo.rect.height : layoutInfo.rect.width;
        if (isValidDropTarget(target)) {
            // If dropping on the item is accepted, try the before/after positions
            // if within 5px of the start or end of the item.
            if (pos < layoutInfoPos + 5) target.dropPosition = 'before';
            else if (pos > layoutInfoPos + size - 5) target.dropPosition = 'after';
        } else {
            // If dropping on the item isn't accepted, try the target before or after depending on the position.
            let mid = layoutInfoPos + size / 2;
            if (pos <= mid && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (pos >= mid && isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        }
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (this.numColumns === 1) rect = new (0, $8bBQM.Rect)(layoutInfo.rect.x, target.dropPosition === 'before' ? layoutInfo.rect.y - this.gap.height / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxY + this.gap.height / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        else rect = new (0, $8bBQM.Rect)(target.dropPosition === 'before' ? layoutInfo.rect.x - this.gap.width / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxX + this.gap.width / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height);
        return new (0, $dnqqa.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
    constructor(...args){
        super(...args), this.gap = $c308aee66d05bff9$var$$fc34f5dff94ff74a$var$DEFAULT_OPTIONS.minSpace, this.dropIndicatorThickness = 2, this.numColumns = 0, this.direction = 'ltr', this.contentSize = new (0, $bMKKe.Size)(), this.layoutInfos = new Map(), this.margin = 0;
    }
}


var $bMKKe = parcelRequire("bMKKe");
var $eF2II = parcelRequire("eF2II");
var $fK9fi = parcelRequire("fK9fi");

var $dnqqa = parcelRequire("dnqqa");

var $919Au = parcelRequire("919Au");

var $8bBQM = parcelRequire("8bBQM");

var $bMKKe = parcelRequire("bMKKe");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $60c55cbb320c35b1$var$$71719b7c112ce40e$var$WaterfallLayoutInfo extends (0, $dnqqa.LayoutInfo) {
    copy() {
        let res = super.copy();
        res.column = this.column;
        res.index = this.index;
        return res;
    }
    constructor(...args){
        super(...args), this.column = 0, this.index = 0;
    }
}
const $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS = {
    minItemSize: new (0, $bMKKe.Size)(200, 200),
    maxItemSize: new (0, $bMKKe.Size)(Infinity, Infinity),
    minSpace: new (0, $bMKKe.Size)(18, 18),
    maxSpace: Infinity,
    maxColumns: Infinity,
    dropIndicatorThickness: 2,
    loaderHeight: 48
};
class $60c55cbb320c35b1$export$e9f7cda058ba8df8 extends (0, $fK9fi.Layout) {
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.maxColumns !== oldOptions.maxColumns || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || !(newOptions.minItemSize || $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.minItemSize).equals(oldOptions.minItemSize || $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.minItemSize) || !(newOptions.maxItemSize || $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.maxItemSize).equals(oldOptions.maxItemSize || $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.maxItemSize) || !(newOptions.minSpace || $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.minSpace).equals(oldOptions.minSpace || $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.minSpace) || newOptions.maxHorizontalSpace !== oldOptions.maxHorizontalSpace || newOptions.loaderHeight !== oldOptions.loaderHeight;
    }
    update(invalidationContext) {
        let { minItemSize: minItemSize = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.minItemSize, maxItemSize: maxItemSize = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.maxItemSize, minSpace: minSpace = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.minSpace, maxHorizontalSpace: maxHorizontalSpace = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.maxSpace, maxColumns: maxColumns = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.maxColumns, dropIndicatorThickness: dropIndicatorThickness = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.dropIndicatorThickness, loaderHeight: loaderHeight = $60c55cbb320c35b1$var$$71719b7c112ce40e$var$DEFAULT_OPTIONS.loaderHeight } = invalidationContext.layoutOptions || {};
        this.dropIndicatorThickness = dropIndicatorThickness;
        let virtualizerWidth = this.virtualizer.size.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, virtualizerWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(virtualizerWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        // Compute the available width (minus the space between items)
        let width = virtualizerWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing, content height and horizontal margin
        let horizontalSpacing = Math.min(Math.max(maxHorizontalSpace, minSpace.width), Math.floor((virtualizerWidth - numColumns * itemWidth) / (numColumns + 1)));
        this.margin = Math.floor((virtualizerWidth - numColumns * itemWidth - horizontalSpacing * (numColumns + 1)) / 2);
        // Setup an array of column heights
        let columnHeights = Array(numColumns).fill(minSpace.height);
        let newLayoutInfos = new Map();
        let index = 0;
        let addNode = (key, node)=>{
            let oldLayoutInfo = this.layoutInfos.get(key);
            let height = itemHeight;
            let estimatedSize = true;
            if (oldLayoutInfo) {
                height = oldLayoutInfo.rect.height / oldLayoutInfo.rect.width * itemWidth;
                estimatedSize = invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== node;
            }
            // Figure out which column to place the item in, and compute its position.
            // Preserve the previous column index so items don't jump around during resizing unless the number of columns changed.
            let prevColumn = numColumns === this.numColumns && oldLayoutInfo && oldLayoutInfo.index === index && oldLayoutInfo.rect.y < this.virtualizer.visibleRect.maxY ? oldLayoutInfo.column : undefined;
            let column = prevColumn ?? columnHeights.reduce((minIndex, h, i)=>h < columnHeights[minIndex] ? i : minIndex, 0);
            let x = horizontalSpacing + column * (itemWidth + horizontalSpacing) + this.margin;
            let y = columnHeights[column];
            let rect = new (0, $8bBQM.Rect)(x, y, itemWidth, height);
            let layoutInfo = new $60c55cbb320c35b1$var$$71719b7c112ce40e$var$WaterfallLayoutInfo(node.type, key, rect);
            layoutInfo.estimatedSize = estimatedSize;
            layoutInfo.allowOverflow = true;
            layoutInfo.content = node;
            layoutInfo.column = column;
            layoutInfo.index = index++;
            newLayoutInfos.set(key, layoutInfo);
            columnHeights[column] += layoutInfo.rect.height + minSpace.height;
        };
        let collection = this.virtualizer.collection;
        let skeletonCount = 0;
        for (let node of collection){
            if (node.type === 'skeleton') {
                // Add skeleton cards until every column has at least one, and we fill the viewport.
                let startingHeights = [
                    ...columnHeights
                ];
                while(!columnHeights.every((h, i)=>h !== startingHeights[i]) || Math.min(...columnHeights) < this.virtualizer.size.height){
                    let key = `${node.key}-${skeletonCount++}`;
                    let content = this.layoutInfos.get(key)?.content || {
                        ...node
                    };
                    addNode(key, content);
                }
                break;
            } else if (node.type !== 'loader') addNode(node.key, node);
        }
        // Reset all columns to the maximum for the next section. If loading, set to 0 so virtualizer doesn't render its body since there aren't items to render,
        // except if we are performing skeleton loading
        let isEmptyOrLoading = collection?.size === 0 && collection.getItem(collection.getFirstKey())?.type !== 'skeleton';
        let maxHeight = isEmptyOrLoading ? 0 : Math.max(...columnHeights);
        // Always add the loader sentinel if present in the collection so we can make sure it is never virtualized out.
        // Add it under the first column for simplicity
        let lastNode = collection.getItem(collection.getLastKey());
        if (lastNode?.type === 'loader') {
            if (skeletonCount > 0 || !lastNode.props.isLoading) loaderHeight = 0;
            const loaderWidth = virtualizerWidth - horizontalSpacing * 2;
            // Note that if the user provides isLoading to their sentinel during a case where they only want to render the emptyState, this will reserve
            // room for the loader alongside rendering the emptyState
            let rect = new (0, $8bBQM.Rect)(horizontalSpacing, maxHeight, loaderWidth, loaderHeight);
            let layoutInfo = new (0, $dnqqa.LayoutInfo)('loader', lastNode.key, rect);
            newLayoutInfos.set(lastNode.key, layoutInfo);
            maxHeight = layoutInfo.rect.maxY;
        }
        this.contentSize = new (0, $bMKKe.Size)(this.virtualizer.size.width, maxHeight);
        this.layoutInfos = newLayoutInfos;
        this.numColumns = numColumns;
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key);
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key) || layoutInfo.type === 'loader') layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    // Override keyboard navigation to work spatially.
    getKeyRightOf(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = new (0, $8bBQM.Rect)(layoutInfo.rect.maxX, layoutInfo.rect.y, this.virtualizer.visibleRect.maxX - layoutInfo.rect.maxX, layoutInfo.rect.height);
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let bestKey = null;
        let bestDistance = Infinity;
        for (let candidate of layoutInfos){
            if (candidate.key === key) continue;
            // Find the closest item in the x direction with the most overlap in the y direction.
            let deltaX = candidate.rect.x - rect.x;
            let overlapY = Math.min(candidate.rect.maxY, rect.maxY) - Math.max(candidate.rect.y, rect.y);
            let distance = deltaX - overlapY;
            if (distance < bestDistance) {
                bestDistance = distance;
                bestKey = candidate.key;
            }
        }
        return bestKey;
    }
    getKeyLeftOf(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = new (0, $8bBQM.Rect)(0, layoutInfo.rect.y, layoutInfo.rect.x, layoutInfo.rect.height);
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let bestKey = null;
        let bestDistance = Infinity;
        for (let candidate of layoutInfos){
            if (candidate.key === key) continue;
            // Find the closest item in the x direction with the most overlap in the y direction.
            let deltaX = rect.maxX - candidate.rect.maxX;
            let overlapY = Math.min(candidate.rect.maxY, rect.maxY) - Math.max(candidate.rect.y, rect.y);
            let distance = deltaX - overlapY;
            if (distance < bestDistance) {
                bestDistance = distance;
                bestKey = candidate.key;
            }
        }
        return bestKey;
    }
    // This overrides the default behavior of shift selection to work spatially
    // rather than following the order of the items in the collection (which may appear unpredictable).
    getKeyRange(from, to) {
        let fromLayoutInfo = this.getLayoutInfo(from);
        let toLayoutInfo = this.getLayoutInfo(to);
        if (!fromLayoutInfo || !toLayoutInfo) return [];
        // Find items where half of the area intersects the rectangle
        // formed from the first item to the last item in the range.
        let rect = fromLayoutInfo.rect.union(toLayoutInfo.rect);
        let keys = [];
        for (let layoutInfo of this.layoutInfos.values())if (rect.intersection(layoutInfo.rect).area > layoutInfo.rect.area / 2) keys.push(layoutInfo.key);
        return keys;
    }
    getDropTargetFromPoint(x, y) {
        if (this.layoutInfos.size === 0) return {
            type: 'root'
        };
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        let key = this.virtualizer.keyAtPoint(new (0, $919Au.Point)(x, y));
        if (key == null) return {
            type: 'root'
        };
        // Only support "on" drop position in waterfall layout.
        // Reordering doesn't make sense because the items don't have a deterministic order.
        return {
            type: 'item',
            key: key,
            dropPosition: 'on'
        };
    }
    constructor(...args){
        super(...args), this.contentSize = new (0, $bMKKe.Size)(), this.layoutInfos = new Map(), this.numColumns = 0, this.dropIndicatorThickness = 2, this.margin = 0;
    }
}



var $4lMDe = parcelRequire("4lMDe");

var $4skXn = parcelRequire("4skXn");

var $f9wnx = parcelRequire("f9wnx");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$layoutOptions = {
    XS: {
        compact: {
            minSpace: new (0, $bMKKe.Size)(6, 6),
            minItemSize: new (0, $bMKKe.Size)(100, 100),
            maxItemSize: new (0, $bMKKe.Size)(140, 140)
        },
        regular: {
            minSpace: new (0, $bMKKe.Size)(8, 8),
            minItemSize: new (0, $bMKKe.Size)(100, 100),
            maxItemSize: new (0, $bMKKe.Size)(140, 140)
        },
        spacious: {
            minSpace: new (0, $bMKKe.Size)(12, 12),
            minItemSize: new (0, $bMKKe.Size)(100, 100),
            maxItemSize: new (0, $bMKKe.Size)(140, 140)
        }
    },
    S: {
        compact: {
            minSpace: new (0, $bMKKe.Size)(8, 8),
            minItemSize: new (0, $bMKKe.Size)(150, 150),
            maxItemSize: new (0, $bMKKe.Size)(210, 210)
        },
        regular: {
            minSpace: new (0, $bMKKe.Size)(12, 12),
            minItemSize: new (0, $bMKKe.Size)(150, 150),
            maxItemSize: new (0, $bMKKe.Size)(210, 210)
        },
        spacious: {
            minSpace: new (0, $bMKKe.Size)(16, 16),
            minItemSize: new (0, $bMKKe.Size)(150, 150),
            maxItemSize: new (0, $bMKKe.Size)(210, 210)
        }
    },
    M: {
        compact: {
            minSpace: new (0, $bMKKe.Size)(12, 12),
            minItemSize: new (0, $bMKKe.Size)(200, 200),
            maxItemSize: new (0, $bMKKe.Size)(280, 280)
        },
        regular: {
            minSpace: new (0, $bMKKe.Size)(16, 16),
            minItemSize: new (0, $bMKKe.Size)(200, 200),
            maxItemSize: new (0, $bMKKe.Size)(280, 280)
        },
        spacious: {
            minSpace: new (0, $bMKKe.Size)(20, 20),
            minItemSize: new (0, $bMKKe.Size)(200, 200),
            maxItemSize: new (0, $bMKKe.Size)(280, 280)
        }
    },
    L: {
        compact: {
            minSpace: new (0, $bMKKe.Size)(16, 16),
            minItemSize: new (0, $bMKKe.Size)(270, 270),
            maxItemSize: new (0, $bMKKe.Size)(370, 370)
        },
        regular: {
            minSpace: new (0, $bMKKe.Size)(20, 20),
            minItemSize: new (0, $bMKKe.Size)(270, 270),
            maxItemSize: new (0, $bMKKe.Size)(370, 370)
        },
        spacious: {
            minSpace: new (0, $bMKKe.Size)(24, 24),
            minItemSize: new (0, $bMKKe.Size)(270, 270),
            maxItemSize: new (0, $bMKKe.Size)(370, 370)
        }
    },
    XL: {
        compact: {
            minSpace: new (0, $bMKKe.Size)(20, 20),
            minItemSize: new (0, $bMKKe.Size)(340, 340),
            maxItemSize: new (0, $bMKKe.Size)(460, 460)
        },
        regular: {
            minSpace: new (0, $bMKKe.Size)(24, 24),
            minItemSize: new (0, $bMKKe.Size)(340, 340),
            maxItemSize: new (0, $bMKKe.Size)(460, 460)
        },
        spacious: {
            minSpace: new (0, $bMKKe.Size)(28, 28),
            minItemSize: new (0, $bMKKe.Size)(340, 340),
            maxItemSize: new (0, $bMKKe.Size)(460, 460)
        }
    }
};
const $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$SIZES = [
    'XS',
    'S',
    'M',
    'L',
    'XL'
];
const $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$cardViewStyles = function anonymous(props, overrides) {
    let rules = " ";
    let height = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "F") height = true;
        rules += p[0];
    }
    if (props.isLoading) rules += ' Pc182';
    else rules += ' Pa182';
    if (props.isEmpty) rules += ' sd182';
    rules += ' _oa182';
    rules += ' _ta182';
    rules += ' eb182';
    rules += ' _Ca182';
    if (props.isEmpty) {
        if (props.isFocusVisible) rules += ' _Lf182';
    } else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kb182';
    if (props.isActionBar) {
        if (!height) rules += ' Fb182';
    }
    return rules;
};
const $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$wrapperStyles = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc182';
    rules += ' _Nb182';
    rules += ' Pb182';
    return rules;
};
const $e5c03cbecd05b517$export$64992ac69f286e5c = (0, $eF4cA.createContext)(null);
const $e5c03cbecd05b517$export$7e52c821f7b6f422 = (0, $eF4cA.forwardRef)(function CardView(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $e5c03cbecd05b517$export$64992ac69f286e5c);
    let { children: children, layout: layoutName = 'grid', size: sizeProp = 'M', density: density = 'regular', variant: variant = 'primary', selectionStyle: selectionStyle = 'checkbox', UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, styles: styles, loadingState: loadingState, onLoadMore: onLoadMore, items: items, renderEmptyState: renderEmptyStateProp, ...otherProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let innerRef = (0, $eF4cA.useRef)(null);
    let scrollRef = props.renderActionBar ? innerRef : domRef;
    // This calculates the maximum t-shirt size where at least two columns fit in the available width.
    let [maxSizeIndex, setMaxSizeIndex] = (0, $eF4cA.useState)($e5c03cbecd05b517$var$$bbcff092fe610ff3$var$SIZES.length - 1);
    let updateSize = (0, $eF4cA.useCallback)(()=>{
        let w = scrollRef.current?.clientWidth ?? 0;
        let i = $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$SIZES.length - 1;
        while(i > 0){
            let opts = $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$layoutOptions[$e5c03cbecd05b517$var$$bbcff092fe610ff3$var$SIZES[i]][density];
            if (w >= opts.minItemSize.width * 2 + opts.minSpace.width * 3) break;
            i--;
        }
        setMaxSizeIndex(i);
    }, [
        scrollRef,
        density
    ]);
    let updateSizeEvent = (0, $4lMDe.useEffectEvent)(updateSize);
    (0, $f9wnx.useResizeObserver)({
        ref: scrollRef,
        box: 'border-box',
        onResize: updateSize
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        updateSizeEvent();
    }, []);
    // The actual rendered t-shirt size is the minimum between the size prop and the maximum possible size.
    let size = $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$SIZES[Math.min(maxSizeIndex, $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$SIZES.indexOf(sizeProp))];
    let layout = layoutName === 'waterfall' ? (0, $60c55cbb320c35b1$export$e9f7cda058ba8df8) : (0, $c308aee66d05bff9$export$7d2b12578154a735);
    let options = $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$layoutOptions[size][density];
    let ctx = (0, $eF4cA.useMemo)(()=>({
            size: size,
            variant: variant
        }), [
        size,
        variant
    ]);
    let { selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, actionBar: actionBar, actionBarHeight: actionBarHeight } = (0, $df1664e6139b6656$export$13f32e21845e01d0)({
        ...props,
        scrollRef: scrollRef
    });
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let renderer;
    let cardLoadingSentinel = (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$392b9a0bbc7c7e43), {
        isLoading: isLoading,
        onLoadMore: onLoadMore
    });
    if (typeof children === 'function' && items) renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: items,
                dependencies: props.dependencies,
                children: children
            }),
            cardLoadingSentinel
        ]
    });
    else renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            children,
            cardLoadingSentinel
        ]
    });
    // Wrap the renderEmptyState function so that it is not called when there is a skeleton loader.
    let renderEmptyState = renderEmptyStateProp ? (renderProps)=>{
        let collection = renderProps.state.collection;
        let firstKey = collection.getFirstKey();
        if (firstKey == null || collection.getItem(firstKey)?.type !== 'skeleton') return renderEmptyStateProp(renderProps);
    } : undefined;
    let cardViewCtx = (0, $eF4cA.useMemo)(()=>({
            layout: layoutName,
            ElementType: (0, $0c1b7b025fb75d97$export$e96fc9a8407faa6b)
        }), [
        layoutName
    ]);
    let cardView = (0, $dx4lB.jsx)((0, $eF2II.Virtualizer), {
        layout: layout,
        layoutOptions: options,
        children: (0, $dx4lB.jsx)((0, $2RdeM.InternalCardViewContext).Provider, {
            value: cardViewCtx,
            children: (0, $dx4lB.jsx)((0, $2RdeM.CardContext).Provider, {
                value: ctx,
                children: (0, $dx4lB.jsx)((0, $jTg9X.ImageCoordinator), {
                    children: (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$a7bfbda1311ca015), {
                        ref: scrollRef,
                        ...otherProps,
                        renderEmptyState: renderEmptyState,
                        items: items,
                        layout: "grid",
                        selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                        selectedKeys: selectedKeys,
                        defaultSelectedKeys: undefined,
                        onSelectionChange: onSelectionChange,
                        style: {
                            ...!props.renderActionBar ? UNSAFE_style : {},
                            // Add padding at the bottom when the action bar is visible so users can scroll to the last items.
                            // Also add scroll padding so keyboard navigating preserves the padding.
                            paddingBottom: actionBarHeight > 0 ? actionBarHeight + options.minSpace.height : 0,
                            scrollPadding: options.minSpace.height,
                            scrollPaddingBottom: actionBarHeight + options.minSpace.height
                        },
                        className: (renderProps)=>(!props.renderActionBar ? UNSAFE_className : '') + $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$cardViewStyles({
                                ...renderProps,
                                isLoading: props.loadingState === 'loading',
                                isActionBar: !!props.renderActionBar
                            }, !props.renderActionBar ? styles : undefined),
                        children: renderer
                    })
                })
            })
        })
    });
    // Add extra wrapper if there is an action bar so we can position relative to it.
    // ActionBar cannot be inside the GridList due to ARIA and focus management requirements.
    if (props.renderActionBar) return (0, $dx4lB.jsxs)("div", {
        ref: domRef,
        className: UNSAFE_className + $e5c03cbecd05b517$var$$bbcff092fe610ff3$var$wrapperStyles(null, styles),
        style: UNSAFE_style,
        children: [
            cardView,
            actionBar
        ]
    });
    return cardView;
});


var $bsn7e = parcelRequire("bsn7e");
var $aQTiM = parcelRequire("aQTiM");
var $5nTep = parcelRequire("5nTep");
var $91SAk = parcelRequire("91SAk");

var $dx4lB = parcelRequire("dx4lB");

var $bWhaY = parcelRequire("bWhaY");

var $3g2oV = parcelRequire("3g2oV");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $bb964fde0a813fcf$var$$00cf18afd94ad18c$var$cache = new WeakMap();
class $bb964fde0a813fcf$var$$00cf18afd94ad18c$var$SkeletonNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'skeleton';
    }
}
const $bb964fde0a813fcf$export$4365333b6bb1c86b = (0, $3g2oV.createLeafComponent)($bb964fde0a813fcf$var$$00cf18afd94ad18c$var$SkeletonNode, (props, ref, node)=>{
    // Cache rendering based on node object identity. This allows the children function to randomize
    // its content (e.g. heights) and preserve on re-renders.
    // TODO: do we need a `dependencies` prop here?
    let cached = $bb964fde0a813fcf$var$$00cf18afd94ad18c$var$cache.get(node);
    if (!cached) {
        cached = (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
            isLoading: true,
            children: props.children()
        });
        $bb964fde0a813fcf$var$$00cf18afd94ad18c$var$cache.set(node, cached);
    }
    return cached;
});


var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");

var $3g2oV = parcelRequire("3g2oV");

var $i8elj = parcelRequire("i8elj");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a500bb283462013d$var$$bef30919fd1a9f72$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M13.783 15.708 8.737 3.78c-.235-.554-1.146-.554-1.382 0L2.31 15.708c-.161.38.017.821.399.982q.144.06.292.06c.292 0 .57-.172.69-.458L5.508 12h5.079l1.815 4.292c.162.38.602.562.983.398.382-.16.56-.601.4-.982M6.141 10.5l1.905-4.503L9.951 10.5zM16.25 18.75c-.414 0-.75-.336-.75-.75V2c0-.414.336-.75.75-.75s.75.336.75.75v16c0 .414-.336.75-.75.75"
        })
    });
const $a500bb283462013d$var$$bef30919fd1a9f72$var$ForwardRef = (0, $eF4cA.forwardRef)($a500bb283462013d$var$$bef30919fd1a9f72$var$SvgComponent);
var $a500bb283462013d$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($a500bb283462013d$var$$bef30919fd1a9f72$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $d17b0246a3955b22$var$$167bc2a09f863169$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m13.527 5.49-3.002-2.997c-.293-.292-.767-.293-1.06 0L6.467 5.491c-.293.293-.293.767 0 1.06.147.147.339.22.53.22s.384-.073.53-.22L9.25 4.83v8.181c0 .414.336.75.75.75s.75-.336.75-.75V4.837l1.718 1.715c.293.292.767.293 1.06-.001.293-.293.293-.768 0-1.06"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 18.021H4.25c-1.24 0-2.25-1.01-2.25-2.25v-5.75c0-.414.336-.75.75-.75s.75.336.75.75v5.75c0 .414.336.75.75.75h11.5c.414 0 .75-.336.75-.75v-5.75c0-.414.336-.75.75-.75s.75.336.75.75v5.75c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const $d17b0246a3955b22$var$$167bc2a09f863169$var$ForwardRef = (0, $eF4cA.forwardRef)($d17b0246a3955b22$var$$167bc2a09f863169$var$SvgComponent);
var $d17b0246a3955b22$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($d17b0246a3955b22$var$$167bc2a09f863169$var$ForwardRef);



var $9f9st = parcelRequire("9f9st");

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $gc2oq = parcelRequire("gc2oq");
var $geNzB = parcelRequire("geNzB");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $8wD3p = parcelRequire("8wD3p");

var $9f9st = parcelRequire("9f9st");


var $dx4lB = parcelRequire("dx4lB");

var $5nTep = parcelRequire("5nTep");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $b3c49aecb9e3a506$var$$79855e79d5c8c405$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.413 0-.75.337-.75.75v11.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75V4.25c0-.413-.337-.75-.75-.75z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m13.073 9.12-4.6-2.473C7.807 6.289 7 6.772 7 7.527v4.945c0 .756.807 1.239 1.473.881l4.6-2.472c.702-.378.702-1.384 0-1.762"
            })
        ]
    });
const $b3c49aecb9e3a506$var$$79855e79d5c8c405$var$ForwardRef = (0, $eF4cA.forwardRef)($b3c49aecb9e3a506$var$$79855e79d5c8c405$var$SvgComponent);
var $b3c49aecb9e3a506$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($b3c49aecb9e3a506$var$$79855e79d5c8c405$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $e2185caf356e8e80$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m6.766 8.228.9 2.775h-1.8zm7.64 1.06c-.605 0-.988.321-1.123.987h2.158c-.05-.58-.407-.987-1.036-.987m4.624-5.073v11.51c0 1.792-1.453 3.245-3.245 3.245H4.275c-1.792 0-3.245-1.453-3.245-3.245V4.215C1.03 2.423 2.483.97 4.275.97h11.51c1.792 0 3.245 1.453 3.245 3.245m-7.898 10.007-2.96-8.264h-2.64l-3.046 8.264h2.319l.407-1.258h3.096l.407 1.258zm6.32-3.404c0-1.937-1.184-3.145-3.06-3.145-1.825 0-3.206 1.32-3.206 3.305 0 2.171 1.443 3.367 3.601 3.367.876 0 1.554-.11 2.184-.431l-.025-1.715c-.58.272-1.16.395-1.826.395-.925 0-1.517-.296-1.763-.913h4.033c.037-.246.062-.567.062-.863"
        })
    });
const $e2185caf356e8e80$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($e2185caf356e8e80$var$SvgComponent);
var $e2185caf356e8e80$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($e2185caf356e8e80$var$ForwardRef);




var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $31a2e3c72a2a6980$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M15.785.97H4.275C2.483.97 1.03 2.423 1.03 4.215v11.51c0 1.792 1.453 3.245 3.245 3.245h11.51c1.792 0 3.245-1.453 3.245-3.245V4.215c0-1.792-1.453-3.245-3.245-3.245M13.43 14.692c-.444-.001-.947-.197-1.212-.799L10.291 9.39c-.103-.245-.438-.243-.541.001l-.944 2.25c-.084.198.061.417.276.417l.506-.004c.729 0 1.32.592 1.32 1.32s-.589 1.319-1.316 1.32H6.629c-.939 0-1.573-.957-1.209-1.823l2.66-6.335c.329-.78 1.098-1.288 1.944-1.288s1.608.506 1.938 1.284l2.677 6.336c.367.867-.268 1.825-1.209 1.825"
        })
    });
const $31a2e3c72a2a6980$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($31a2e3c72a2a6980$var$SvgComponent);
var $31a2e3c72a2a6980$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($31a2e3c72a2a6980$var$ForwardRef);


const $797f3d38d769d716$var$iconStyles = function anonymous(props) {
    let rules = " ";
    rules += ' -_8sjo0b-t5ZbAob182';
    rules += ' sb182';
    if (props.size === "XL") rules += ' Zo182';
    else if (props.size === "L") rules += ' Zm182';
    else if (props.size === "M") rules += ' Zl182';
    else if (props.size === "S") rules += ' Zk182';
    if (props.size === "XL") rules += ' Fp182';
    else if (props.size === "L") rules += ' Fn182';
    else if (props.size === "M") rules += ' Fm182';
    else if (props.size === "S") rules += ' Fl182';
    return rules;
};
const $797f3d38d769d716$export$17f8b5fdc0dde895 = ({ type: type, size: size = "M", styles: styles })=>{
    if ([
        "figma",
        "html"
    ].includes(type?.toLowerCase())) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ab0f66b034da7456$export$2e2bcd8739ae039), {
        styles: (0, $5nTep.mergeStyles)($797f3d38d769d716$var$iconStyles({
            size: size
        }), styles)
    });
    else return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $b3c49aecb9e3a506$export$2e2bcd8739ae039), {
        styles: (0, $5nTep.mergeStyles)($797f3d38d769d716$var$iconStyles({
            size: size
        }), styles)
    });
};



var $j2JDe = parcelRequire("j2JDe");

var $iLDMH = parcelRequire("iLDMH");

var $8Ogg5 = parcelRequire("8Ogg5");
const $ce29ef6db3284568$var$PROJECT_STATUS_CONFIG = [
    {
        condition: (item)=>typeof item.status === "undefined" && !item?.videoPath && !item?.jobId,
        variant: "yellow",
        label: "Draft"
    },
    {
        condition: (item)=>item.status === "processing" || !item?.videoPath && !!item?.jobId,
        variant: "informative",
        label: "Processing"
    },
    {
        condition: (item)=>(item.status === "completed" || !!item?.videoPath) && Date.now() - new Date(item.updatedAt) < 86400000,
        variant: "positive",
        label: "New"
    }
];
const $ce29ef6db3284568$var$ProjectStatusBadge = ({ item: item })=>{
    const status = $ce29ef6db3284568$var$PROJECT_STATUS_CONFIG.find(({ condition: condition })=>condition(item));
    if (!status) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
        variant: status.variant,
        size: "XS",
        styles: " _Pa182 _lI182 _zI182",
        children: status.label
    });
};
$ce29ef6db3284568$var$ProjectStatusBadge.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        videoPath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        jobId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        updatedAt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
    }).isRequired
};
const $ce29ef6db3284568$export$8d792ff3c0a85132 = ({ item: item, onPress: onPress, onMenuAction: onMenuAction, isDuplicating: isDuplicating = false })=>{
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    let template;
    if ([
        "mogrt",
        "modular"
    ].includes(item.templateType)) template = {
        label: "After Effects",
        type: "AE"
    };
    else if ([
        "figma",
        "html"
    ].includes(item.templateType)) template = {
        label: "Figma",
        type: "Figma"
    };
    else template = {
        label: "Adobe Express",
        type: "Express"
    };
    const templateLabel = template.label;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
        ...hoverProps,
        id: item.id,
        variant: "quiet",
        textValue: item.name,
        onPress: onPress,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " _Pc182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CollectionCardPreview), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                src: item?.rendition_grid?.main?.presignURL,
                                filePath: item?.rendition_grid?.main?.filePath,
                                alt: item?.rendition_grid?.main?.name ?? item.name ?? "",
                                styles: " _Ha182 Tt182 Qt182 St182 Rt182 _oa182"
                            }),
                            !!item?.rendition_grid?.tiles?.length && item?.rendition_grid?.tiles?.map((tile)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                    src: tile?.presignURL,
                                    filePath: tile?.filePath,
                                    alt: tile?.name ?? ""
                                }, tile.name)),
                            new Array(3 - (item?.rendition_grid?.tiles?.length || 0)).fill(null).map((_, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                    alt: ""
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)($ce29ef6db3284568$var$ProjectStatusBadge, {
                        item: item
                    }),
                    onMenuAction && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $gc2oq.ActionMenu), {
                        "aria-label": `Actions for ${item.name}`,
                        onAction: (action)=>onMenuAction(action, item),
                        isQuiet: false,
                        staticColor: "auto",
                        styles: " _Pa182 Wz182 _zI182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                id: "share",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d17b0246a3955b22$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Share"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                id: "duplicate",
                                isDisabled: isDuplicating,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: isDuplicating ? "Duplicating..." : "Duplicate"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                styles: " _ch182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        slot: "title",
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                        slot: "description",
                        styles: " sd182 ed182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $797f3d38d769d716$export$17f8b5fdc0dde895), {
                                type: template.type,
                                styles: function anonymous(props) {
                                    let rules = " ";
                                    rules += ' Zu182';
                                    rules += ' Ft182';
                                    if (props.isFigmaType) rules += ' Hr182';
                                    else rules += ' HydxGIe182';
                                    return rules;
                                }({
                                    isFigmaType: template.type === "Figma"
                                })
                            }),
                            template.label,
                            /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                className: " Is182 Hs182",
                                children: "\u2022"
                            }),
                            (0, $8Ogg5.getRelativeTime)(item.updatedAt)
                        ]
                    })
                ]
            })
        ]
    });
};
$ce29ef6db3284568$export$8d792ff3c0a85132.propTypes = {
    onMenuAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    isDuplicating: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        templateType: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
            "mogrt",
            "modular",
            "express",
            "figma",
            "html"
        ]).isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        updatedAt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
            filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
            presignURL: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
        }),
        rendition_grid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
            main: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
                name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
                filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
                presignURL: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
            }),
            tiles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
                name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
                filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
                presignURL: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
            }))
        }),
        expressId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        videoPath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        jobId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
    }).isRequired,
    onPress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $7uz0i = parcelRequire("7uz0i");
var $j3pTw = parcelRequire("j3pTw");
var $yuTTo = parcelRequire("yuTTo");

var $waxwa = parcelRequire("waxwa");

var $gc2oq = parcelRequire("gc2oq");

var $8OJ2z = parcelRequire("8OJ2z");

var $cxTG4 = parcelRequire("cxTG4");

var $hxsf4 = parcelRequire("hxsf4");


var $8OJ2z = parcelRequire("8OJ2z");

var $dm5H1 = parcelRequire("dm5H1");

var $208Op = parcelRequire("208Op");

var $e0Enh = parcelRequire("e0Enh");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2d603d22b712a1e0$export$1237798dc640739a = function anonymous(props) {
    let rules = " ";
    rules += ' zv6x9r182';
    rules += ' yv6x9r182';
    rules += ' Bv6x9r182';
    rules += ' Av6x9r182';
    rules += ' _dc182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    rules += ' p40ub4c182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' _Yb182';
    if (props.overflowMode === "wrap") rules += ' _7b182';
    else rules += ' _7c182';
    return rules;
};
let $2d603d22b712a1e0$export$6d59db4903f20f7d = function anonymous(props) {
    let rules = " ";
    rules += ' z9u7zPc182';
    rules += ' y9u7zPc182';
    rules += ' B9u7zPc182';
    rules += ' A9u7zPc182';
    rules += ' _dc182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' _Yb182';
    if (props.overflowMode === "wrap") rules += ' _7b182';
    else rules += ' _7c182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-b182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' pt182';
        else if (props.isFocusVisible) rules += ' pt182';
        else if (props.isHovered) rules += ' pt182';
        else rules += ' pv182';
    }
    rules += ' pl40ub4c182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    return rules;
};
let $2d603d22b712a1e0$export$31d1842a0fd736e6 = " sd182 z2U5Crc182 y2U5Crc182 B2U5Crc182 AvoofG182 _dc182 eb182";
let $2d603d22b712a1e0$export$1ca1ec8b29a4ce27 = " sb182 ZObNfn182 FObNfn182 Ht182 Hsu182 -_8sjo0b-t5ZbAob182";
let $2d603d22b712a1e0$export$6b6fc962de371ec4 = " _Pc182";
let $2d603d22b712a1e0$export$12d0dcd183478a04 = " _Pa182 _9a182 WE182 _EE182 Zd4Eyud182 Fb182 ob182 nb182 kb182 jb182 _kb182 hb182 mb182 lb182 _jf182 iw182 gX182";
let $2d603d22b712a1e0$export$4a61298387975868 = function anonymous(props) {
    let rules = " ";
    rules += ' _oa182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' Tt182';
    rules += ' Qt182';
    rules += ' gX182';
    if (props.isPressed) rules += ' po182';
    else if (props.isFocusVisible) rules += ' po182';
    else if (props.isHovered) rules += ' po182';
    else rules += ' pt182';
    rules += ' _Pc182';
    rules += ' se182';
    rules += ' CQyEEqe182';
    rules += ' DBqynpb182';
    rules += ' Exumf9b182';
    rules += ' ea182';
    if (props.scale === "large") rules += ' MODqQub182';
    else rules += ' Mh182';
    rules += ' Zd4Eyud182';
    rules += ' ob182';
    rules += ' nb182';
    rules += ' kb182';
    rules += ' jb182';
    rules += ' _kb182';
    rules += ' hb182';
    rules += ' mb182';
    rules += ' lb182';
    rules += ' _jf182';
    rules += ' iw182';
    return rules;
};
let $2d603d22b712a1e0$export$f28dddd30893324d = " z0yNlr182 y0yNlr182 B0yNlr182 A0yNlr182 _dc182 St182 Rt182 Tj182 Qj182 oa182 na182 ka182 ja182 g3182 gle182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 _Fd182 _FnuYUweb182 px182 ple182 _yb182";
function $2d603d22b712a1e0$export$905ab40ac2179daa(props) {
    let { items: items, overflowMode: overflowMode } = props;
    let isDraggingMultiple = items.length > 1;
    let itemLabel = items[0]?.['text/plain'] ?? '';
    let scale = (0, $e0Enh.useScale)();
    return (0, $dx4lB.jsxs)("div", {
        className: $2d603d22b712a1e0$export$6b6fc962de371ec4,
        children: [
            isDraggingMultiple && (0, $dx4lB.jsx)("div", {
                className: $2d603d22b712a1e0$export$12d0dcd183478a04
            }),
            (0, $dx4lB.jsx)("div", {
                className: $2d603d22b712a1e0$export$4a61298387975868({
                    scale: scale
                }),
                children: (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $208Op.TextContext),
                            {
                                slots: {
                                    [(0, $fDYaM.DEFAULT_SLOT)]: {
                                        styles: $2d603d22b712a1e0$export$1237798dc640739a({
                                            overflowMode: overflowMode
                                        })
                                    },
                                    label: {
                                        styles: $2d603d22b712a1e0$export$1237798dc640739a({
                                            overflowMode: overflowMode
                                        })
                                    },
                                    description: {
                                        styles: $2d603d22b712a1e0$export$6d59db4903f20f7d({
                                            overflowMode: overflowMode
                                        })
                                    }
                                }
                            }
                        ],
                        [
                            (0, $dm5H1.IconContext),
                            {
                                slots: {
                                    icon: {
                                        render: (0, $8OJ2z.centerBaseline)({
                                            slot: 'icon',
                                            styles: $2d603d22b712a1e0$export$31d1842a0fd736e6
                                        }),
                                        styles: $2d603d22b712a1e0$export$1ca1ec8b29a4ce27
                                    }
                                }
                            }
                        ]
                    ],
                    children: [
                        props.children ?? (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: itemLabel
                        }),
                        isDraggingMultiple && (0, $dx4lB.jsx)("div", {
                            className: $2d603d22b712a1e0$export$f28dddd30893324d,
                            children: items.length
                        })
                    ]
                })
            })
        ]
    });
}





var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $5dbaf0d74dd56a3d$var$$1792142a9047937d$var$SvgS2DragHandleSize200 = (props)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 3.8,
                cy: 10.4,
                r: 1.1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 3.8,
                cy: 6,
                r: 1.1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 3.8,
                cy: 1.6,
                r: 1.1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 8.2,
                cy: 10.4,
                r: 1.1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 8.2,
                cy: 6,
                r: 1.1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 8.2,
                cy: 1.6,
                r: 1.1,
                fill: "var(--iconPrimary, #222)"
            })
        ]
    });
var $5dbaf0d74dd56a3d$export$2e2bcd8739ae039 = $5dbaf0d74dd56a3d$var$$1792142a9047937d$var$SvgS2DragHandleSize200;



var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $7c8d47f17d7f7ed7$var$$0adf62121b55c8dc$var$SvgS2DragHandleSize100 = (props)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 3,
                cy: 9,
                r: 1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 3,
                cy: 5,
                r: 1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 3,
                cy: 1,
                r: 1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 7,
                cy: 9,
                r: 1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 7,
                cy: 5,
                r: 1,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 7,
                cy: 1,
                r: 1,
                fill: "var(--iconPrimary, #222)"
            })
        ]
    });
var $7c8d47f17d7f7ed7$export$2e2bcd8739ae039 = $7c8d47f17d7f7ed7$var$$0adf62121b55c8dc$var$SvgS2DragHandleSize100;



var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $32e123e2c05b1218$var$$c6fba7d3aa542a55$var$SvgS2DragHandleSize75 = (props)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 3.2,
                cy: 8.6,
                r: 0.9,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 3.2,
                cy: 5,
                r: 0.9,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 3.2,
                cy: 1.4,
                r: 0.9,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 6.8,
                cy: 8.6,
                r: 0.9,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 6.8,
                cy: 5,
                r: 0.9,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 6.8,
                cy: 1.4,
                r: 0.9,
                fill: "var(--iconPrimary, #222)"
            })
        ]
    });
var $32e123e2c05b1218$export$2e2bcd8739ae039 = $32e123e2c05b1218$var$$c6fba7d3aa542a55$var$SvgS2DragHandleSize75;



var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $27fa5526b3852cb1$var$$2328c0ed6835818a$var$SvgS2DragHandleSize300 = (props)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 4.6,
                cy: 11.8,
                r: 1.2,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 4.6,
                cy: 7,
                r: 1.2,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 4.6,
                cy: 2.2,
                r: 1.2,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 9.4,
                cy: 11.8,
                r: 1.2,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 9.4,
                cy: 7,
                r: 1.2,
                fill: "var(--iconPrimary, #222)"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 9.4,
                cy: 2.2,
                r: 1.2,
                fill: "var(--iconPrimary, #222)"
            })
        ]
    });
var $27fa5526b3852cb1$export$2e2bcd8739ae039 = $27fa5526b3852cb1$var$$2328c0ed6835818a$var$SvgS2DragHandleSize300;



var $dx4lB = parcelRequire("dx4lB");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $bd736e8b5feba36f$var$$8b63ac1a4fa1df22$var$styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Zi182';
    else if (props.size === "XL") rules += ' Zk182';
    else if (props.size === "L") rules += ' Zj182';
    else if (props.size === "M") rules += ' Zi182';
    if (props.size === "S") rules += ' Fj182';
    else if (props.size === "XL") rules += ' Fl182';
    else if (props.size === "L") rules += ' Fk182';
    else if (props.size === "M") rules += ' Fj182';
    return rules;
};
function $bd736e8b5feba36f$export$2e2bcd8739ae039(props) {
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return (0, $dx4lB.jsx)((0, $7c8d47f17d7f7ed7$export$2e2bcd8739ae039), {
                ...otherProps,
                className: (otherProps.className || '') + $bd736e8b5feba36f$var$$8b63ac1a4fa1df22$var$styles({
                    size: size
                })
            });
        case 'L':
            return (0, $dx4lB.jsx)((0, $5dbaf0d74dd56a3d$export$2e2bcd8739ae039), {
                ...otherProps,
                className: (otherProps.className || '') + $bd736e8b5feba36f$var$$8b63ac1a4fa1df22$var$styles({
                    size: size
                })
            });
        case 'XL':
            return (0, $dx4lB.jsx)((0, $27fa5526b3852cb1$export$2e2bcd8739ae039), {
                ...otherProps,
                className: (otherProps.className || '') + $bd736e8b5feba36f$var$$8b63ac1a4fa1df22$var$styles({
                    size: size
                })
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $32e123e2c05b1218$export$2e2bcd8739ae039), {
                ...otherProps,
                className: (otherProps.className || '') + $bd736e8b5feba36f$var$$8b63ac1a4fa1df22$var$styles({
                    size: size
                })
            });
    }
}



var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $cLs8t = parcelRequire("cLs8t");

var $eF4cA = parcelRequire("eF4cA");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $6750b0b6e12c44b5$var$$3c1ab1fd8f31a3e2$var$insertionIndicatorWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _lr182';
    rules += ' _Ar182';
    rules += ' _zr182';
    rules += ' sd182';
    rules += ' eb182';
    if (props.isRoot) rules += ' Iy182';
    else rules += ' IyEbn5c182';
    if (props.isDropTarget) rules += ' poPoFpe182';
    else rules += ' pw182';
    if (props.isDropTarget) rules += ' pld182';
    if (props.isDropTarget) rules += ' -_3xYcJd-gX182';
    else rules += ' -_3xYcJd-g9182';
    if (props.isDropTarget) rules += ' -_3xYcJd-lga182';
    rules += ' _yb182';
    return rules;
};
function $6750b0b6e12c44b5$export$2c0bab5914a9d088({ target: target }) {
    let { dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext)) ?? {};
    let level = 0;
    if (target.type === 'item' && dropState?.collection) level = dropState.collection.getItem(target.key)?.level ?? 0;
    return (0, $dx4lB.jsx)((0, $cLs8t.DropIndicator), {
        className: "",
        target: target,
        children: ({ isDropTarget: isDropTarget })=>(0, $dx4lB.jsx)("div", {
                className: $6750b0b6e12c44b5$var$$3c1ab1fd8f31a3e2$var$insertionIndicatorWrapper({
                    isDropTarget: isDropTarget,
                    isRoot: level === 0
                }),
                style: level > 0 ? {
                    '--drop-level': level
                } : undefined,
                children: (0, $dx4lB.jsxs)("svg", {
                    "aria-hidden": true,
                    width: "100%",
                    height: "12",
                    children: [
                        (0, $dx4lB.jsx)("line", {
                            x1: "0",
                            y1: "6",
                            x2: "100%",
                            y2: "6",
                            strokeWidth: "2",
                            stroke: "currentColor"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: "6",
                            cy: "6",
                            r: "5",
                            strokeWidth: "2",
                            stroke: "currentColor",
                            style: {
                                fill: 'var(--indicator-circle-bg)'
                            }
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: "100%",
                            cy: "6",
                            r: "5",
                            strokeWidth: "2",
                            stroke: "currentColor",
                            style: {
                                fill: 'var(--indicator-circle-bg)'
                            },
                            transform: "translate(-6, 0)"
                        })
                    ]
                })
            })
    });
}
let $6750b0b6e12c44b5$var$$3c1ab1fd8f31a3e2$var$dragButton = function anonymous(props) {
    let rules = " ";
    rules += ' p40ub4c182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' Fo182';
    rules += ' Zi182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' Jy182';
    rules += ' Gy182';
    rules += ' Iy182';
    rules += ' Hy182';
    rules += ' g9182';
    rules += ' _je182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' -_8sjo0b-t5ZbAob182';
    return rules;
};
function $6750b0b6e12c44b5$export$4c99a519d851f90c({ isFocusVisibleWithin: isFocusVisibleWithin }) {
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        slot: "drag",
        style: !isFocusVisibleWithin ? visuallyHiddenProps.style : {},
        className: $6750b0b6e12c44b5$var$$3c1ab1fd8f31a3e2$var$dragButton,
        children: (0, $dx4lB.jsx)((0, $bd736e8b5feba36f$export$2e2bcd8739ae039), {
            size: "M"
        })
    });
}



var $dm5H1 = parcelRequire("dm5H1");

var $8g9SZ = parcelRequire("8g9SZ");

var $fL4LX = parcelRequire("fL4LX");

var $gos6s = parcelRequire("gos6s");

var $fZShI = parcelRequire("fZShI");

var $208Op = parcelRequire("208Op");


var $3PqDc = parcelRequire("3PqDc");

var $e0Enh = parcelRequire("e0Enh");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $ed1Og = parcelRequire("ed1Og");

var $3g2oV = parcelRequire("3g2oV");

var $8dzVy = parcelRequire("8dzVy");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");


var $eF2II = parcelRequire("eF2II");

var $n0XBd = parcelRequire("n0XBd");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");
function $5f873f6fe070b647$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5f873f6fe070b647$export$870039b0abfe3de0 = (0, $eF4cA.createContext)(null);
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$InternalListViewContext = (0, $eF4cA.createContext)({});
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listViewWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let minHeight = false;
    let minWidth = false;
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!minHeight) rules += ' Ma182';
    if (!minWidth) rules += ' Ng182';
    rules += ' sd182';
    rules += ' _Bb182';
    rules += ' __ca182';
    if (!position) rules += ' _Pc182';
    rules += ' _Nb182';
    rules += ' Pb182';
    rules += ' -qVUQke-ob182';
    return rules;
};
// similar to tableview, use this approach so we can actually have a 2px outline when root dropping.
// cant do a external box shadow due to the clipping that is applied on the wrapper element...
// an inset box shadow runs into problems with the item background clipping the box shadow...
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rootDropOutline = "IJKxRb";
// When any row has a trailing icon, reserve space so actions align.
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$hasTrailingIconRows = ':has([data-has-trailing-icon]) [role="row"]';
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$dropTargetBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listView = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    if (props.isQuiet) rules += ' _Ka182';
    else rules += ' _Kb182';
    rules += ' _4c182';
    rules += ' Ma182';
    rules += ' Na182';
    rules += ' Za182';
    rules += ' Fb182';
    rules += ' _oa182';
    rules += ' _Na182';
    rules += ' Pa182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.isDropTarget) {
        rules += ' glzvDBe182';
        rules += ' gla182';
    } else if (props.isQuiet) rules += ' g9182';
    else rules += ' gX182';
    if (props.isQuiet) rules += ' od182';
    else rules += ' ob182';
    if (props.isQuiet) rules += ' nd182';
    else rules += ' nb182';
    if (props.isQuiet) rules += ' kd182';
    else rules += ' kb182';
    if (props.isQuiet) rules += ' jd182';
    else rules += ' jb182';
    rules += ' iq182';
    rules += ' ila182';
    if (props.isQuiet) rules += ' _ka182';
    else rules += ' _kb182';
    if (props.isQuiet) rules += ' ha182';
    else rules += ' hb182';
    if (props.isQuiet) rules += ' ma182';
    else rules += ' mb182';
    if (props.isQuiet) rules += ' la182';
    else rules += ' lb182';
    rules += ' _jf182';
    rules += ' _yb182';
    rules += ' -Ev4N4b-Zd182';
    rules += ' -Ev4N4b-1bNH0cZObNfn182';
    return rules;
};
class $5f873f6fe070b647$export$6f8e4757b55cd070 extends (0, $n0XBd.ListLayout) {
    getDropTargetLayoutInfo(target) {
        let layoutInfo = super.getDropTargetLayoutInfo(target);
        layoutInfo.zIndex = 1;
        layoutInfo.allowOverflow = true;
        return layoutInfo;
    }
}
const $5f873f6fe070b647$export$84d0dd190d551cd1 = (0, $eF4cA.forwardRef)(function ListView(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $5f873f6fe070b647$export$870039b0abfe3de0);
    let { children: children, isQuiet: isQuiet, selectionStyle: selectionStyle = 'checkbox', overflowMode: overflowMode = 'truncate', loadingState: loadingState, onLoadMore: onLoadMore, renderEmptyState: userRenderEmptyState, hideLinkOutIcon: hideLinkOutIcon = false, dragAndDropHooks: dragAndDropHooks, ...otherProps } = props;
    let scale = (0, $e0Enh.useScale)();
    if (dragAndDropHooks && dragAndDropHooks.renderDragPreview == null) dragAndDropHooks.renderDragPreview = (items)=>(0, $dx4lB.jsx)((0, $2d603d22b712a1e0$export$905ab40ac2179daa), {
            items: items,
            overflowMode: overflowMode
        });
    if (dragAndDropHooks) dragAndDropHooks.renderDropIndicator = (target)=>(0, $dx4lB.jsx)((0, $6750b0b6e12c44b5$export$2c0bab5914a9d088), {
            target: target
        });
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($5f873f6fe070b647$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let rowHeight = scale === 'large' ? 50 : 40;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let scrollRef = (0, $eF4cA.useRef)(null);
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let renderEmptyState;
    if (userRenderEmptyState != null && !isLoading) renderEmptyState = (renderProps)=>(0, $dx4lB.jsx)("div", {
            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$emptyStateWrapper,
            children: (0, $dx4lB.jsx)((0, $8dzVy.CollectionRendererContext).Provider, {
                value: (0, $8dzVy.DefaultCollectionRenderer),
                children: userRenderEmptyState(renderProps)
            })
        });
    else if (loadingState === 'loading') renderEmptyState = ()=>(0, $dx4lB.jsx)("div", {
            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$centeredWrapper,
            children: (0, $dx4lB.jsx)("div", {
                className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$loadingSpinnerWrapper,
                children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": stringFormatter.format('listview.loading')
                })
            })
        });
    let loadMoreSpinner = onLoadMore ? (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$392b9a0bbc7c7e43), {
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: " Fb182 Za182 Tt182 Qt182",
        children: (0, $dx4lB.jsx)("div", {
            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$centeredWrapper,
            children: (0, $dx4lB.jsx)("div", {
                className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$loadingSpinnerWrapper,
                children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": stringFormatter.format('listview.loadingMore')
                })
            })
        })
    }) : null;
    let wrappedChildren;
    let gridListProps = otherProps;
    if (typeof children === 'function' && otherProps.items) {
        let { items: items, dependencies: dependencies = [], ...rest } = otherProps;
        gridListProps = rest;
        wrappedChildren = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
            children: [
                (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                    items: items,
                    dependencies: dependencies,
                    children: children
                }),
                loadMoreSpinner
            ]
        });
    } else wrappedChildren = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            children,
            loadMoreSpinner
        ]
    });
    let { selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, actionBar: actionBar, actionBarHeight: actionBarHeight } = (0, $df1664e6139b6656$export$13f32e21845e01d0)({
        ...props,
        scrollRef: scrollRef
    });
    return (0, $dx4lB.jsxs)("div", {
        ref: domRef,
        className: (props.UNSAFE_className || '') + $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listViewWrapper(null, props.styles) + ' ' + $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rootDropOutline,
        style: props.UNSAFE_style,
        children: [
            (0, $dx4lB.jsx)((0, $eF2II.Virtualizer), {
                layout: $5f873f6fe070b647$export$6f8e4757b55cd070,
                layoutOptions: {
                    estimatedRowHeight: rowHeight,
                    loaderHeight: 60,
                    dropIndicatorThickness: 0
                },
                children: (0, $dx4lB.jsx)($5f873f6fe070b647$var$$6d4c8b365b6e9016$var$InternalListViewContext.Provider, {
                    value: {
                        isQuiet: isQuiet,
                        selectionStyle: selectionStyle,
                        overflowMode: overflowMode,
                        scale: scale,
                        hideLinkOutIcon: hideLinkOutIcon
                    },
                    children: (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$a7bfbda1311ca015), {
                        ref: scrollRef,
                        ...gridListProps,
                        dragAndDropHooks: dragAndDropHooks,
                        selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                        selectionMode: gridListProps.selectionMode,
                        renderEmptyState: renderEmptyState,
                        style: {
                            paddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0,
                            scrollPaddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0
                        },
                        className: (renderProps)=>$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listView({
                                ...renderProps,
                                isQuiet: isQuiet,
                                isDropTarget: renderProps.isDropTarget
                            }),
                        selectedKeys: selectedKeys,
                        defaultSelectedKeys: undefined,
                        onSelectionChange: onSelectionChange,
                        children: wrappedChildren
                    })
                })
            }),
            actionBar
        ]
    });
});
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$selectedBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$selectedActiveBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
// TODO: removed the background color in HCM for highlight selection since it made it hard to see the focus
// ring of the drag button, this matches v3 anyways. thoughts?
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listitem = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    } else {
        if (props.isPressed) rules += ' pt182';
        else if (props.isFocusVisible) rules += ' pt182';
        else if (props.isHovered) rules += ' pt182';
        else rules += ' pv182';
    }
    if (props.isDisabled) rules += ' plc182';
    else if (props.isSelected) {
        if (props.selectionStyle === "highlight") rules += ' ple182';
    } else rules += ' plb182';
    rules += ' _Le182';
    rules += ' _oa182';
    rules += ' qh182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' Tt182';
    rules += ' Qt182';
    rules += ' g9182';
    rules += ' _Pc182';
    rules += ' z2mU182';
    rules += ' yzZKy182';
    rules += ' se182';
    rules += ' CTJxasc182';
    rules += ' Ds5idie182';
    rules += ' Exumf9b182';
    rules += ' UDNKd2dai5a0182';
    rules += ' ea182';
    if (props.scale === "large") rules += ' MODqQub182';
    else rules += ' Mh182';
    rules += ' _Xa182';
    if (props.isLink) rules += ' ry182';
    else rules += ' ri182';
    if (props.isSelected) {
        if (props.selectionStyle === "checkbox") rules += ' -EH8uVb-iq182';
        else if (props.selectionStyle === "highlight") {
            rules += ' -EH8uVb-iw182';
            rules += ' -EH8uVb-lid182';
        }
    } else {
        rules += ' -EH8uVb-iq182';
        rules += ' -EH8uVb-lia182';
    }
    rules += ' _ka182';
    if (props.isLastItem) {
        if (props.isQuiet) rules += ' ha182';
        else rules += ' hb182';
    } else rules += ' hb182';
    rules += ' ma182';
    rules += ' la182';
    rules += ' _jf182';
    if (props.isSelected) rules += ' iA182';
    else if (props.isNextSelected) rules += ' iA182';
    else rules += ' i4pzfu182';
    rules += ' ila182';
    rules += ' -Bu7z1c-ob182';
    rules += ' _yb182';
    return rules;
};
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$insetBorderRadius = 'calc(var(--radius) - 1px)';
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rootDropSelectedRowBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 28%)]";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rowDropBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rootRowDropStyles = {
    // Unlike v3 tableview, v3 listview has the same background color for the listview itself and the rows when
    // dropping on root
    default: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$dropTargetBackground,
    isSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rootDropSelectedRowBackground,
    forcedColors: 'Background'
};
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rowDropStyles = {
    // Also unlike v3, dropping on a selected row vs a non selected row doesn't have any difference in background color
    default: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rowDropBackground,
    isSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rowDropBackground,
    forcedColors: 'Background'
};
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listRowBackground = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' _9a182';
    if (props.isFirstItem) rules += ' Wr182';
    else if (props.isPrevSelected) rules += ' Wr182';
    else if (props.isSelected) rules += ' WLPOtrc182';
    else rules += ' Wr182';
    rules += ' Wlr182';
    rules += ' _Er182';
    rules += ' _Rr182';
    if (props.isSelected) rules += ' _lLPOtrc182';
    else rules += ' _lr182';
    if (props.isDropTarget) {
        if (props.isSelected) rules += ' glzvDBe182';
        else rules += ' glzvDBe182';
        rules += ' gla182';
    } else {
        if (props.isSelected) {
            if (props.selectionStyle === "highlight") {
                if (props.isPressed) rules += ' gaZwDBe182';
                else if (props.isHovered) rules += ' gaZwDBe182';
                else rules += ' glzvDBe182';
            } else if (props.selectionStyle === "checkbox") {
                if (props.isFocusVisible) rules += ' gRfT7e182';
                else if (props.isPressed) rules += ' gRfT7e182';
                else if (props.isHovered) rules += ' gRfT7e182';
                else rules += ' gj1B7i182';
            }
        } else if (props.isPressed) {
            if (props.selectionStyle === "checkbox") rules += ' gRfT7e182';
            else rules += ' g7IonAe182';
        } else if (props.isHovered) {
            if (props.selectionStyle === "checkbox") rules += ' gj1B7i182';
            else rules += ' gVQkD8c182';
        } else rules += ' gs9yXOb182';
        if (props.selectionStyle === "highlight") {
            if (props.isSelected) rules += ' gle182';
            else rules += ' gl9182';
        } else rules += ' gl9182';
        if (props.isSelected) rules += ' gRQaNpdubHDBe182';
        else rules += ' gRQaNpdlzvDBe182';
        rules += ' gRQaNpdla182';
    }
    if (props.isDropTarget) rules += ' o7E7Gic182';
    else if (props.isPrevNotSelected) {
        if (props.isQuiet) rules += ' ob182';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' o7E7Gic182';
            else if (props.selectionStyle === "checkbox") rules += ' od182';
        }
    } else if (props.isSelected) rules += ' od182';
    else if (props.isQuiet) rules += ' ob182';
    if (props.isDropTarget) rules += ' n7E7Gic182';
    else if (props.isPrevNotSelected) {
        if (props.isQuiet) rules += ' nb182';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' n7E7Gic182';
            else if (props.selectionStyle === "checkbox") rules += ' nd182';
        }
    } else if (props.isSelected) rules += ' nd182';
    else if (props.isQuiet) rules += ' nb182';
    if (props.isDropTarget) rules += ' k7E7Gic182';
    else if (props.isNextNotSelected) {
        if (props.isQuiet) rules += ' kb182';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' k7E7Gic182';
            else if (props.selectionStyle === "checkbox") rules += ' kd182';
        }
    } else if (props.isSelected) rules += ' kd182';
    else if (props.isQuiet) rules += ' kb182';
    if (props.isDropTarget) rules += ' j7E7Gic182';
    else if (props.isNextNotSelected) {
        if (props.isQuiet) rules += ' jb182';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' j7E7Gic182';
            else if (props.selectionStyle === "checkbox") rules += ' jd182';
        }
    } else if (props.isSelected) rules += ' jd182';
    else if (props.isQuiet) rules += ' jb182';
    if (props.isDropTarget) rules += ' _kc182';
    else if (props.isPrevSelected) rules += ' _ka182';
    else {
        if (props.selectionStyle === "highlight") rules += ' _kb182';
        else if (props.selectionStyle === "checkbox") rules += ' _ka182';
    }
    if (props.isDropTarget) rules += ' hc182';
    else if (props.isNextSelected) rules += ' ha182';
    else {
        if (props.selectionStyle === "highlight") rules += ' hb182';
        else if (props.selectionStyle === "checkbox") rules += ' ha182';
    }
    if (props.isDropTarget) rules += ' mc182';
    else {
        if (props.selectionStyle === "highlight") rules += ' mb182';
        else if (props.selectionStyle === "checkbox") rules += ' ma182';
    }
    if (props.isDropTarget) rules += ' lc182';
    else {
        if (props.selectionStyle === "highlight") rules += ' lb182';
        else if (props.selectionStyle === "checkbox") rules += ' la182';
    }
    rules += ' _jf182';
    if (props.isDropTarget) rules += ' ix182';
    else if (props.isSelected) {
        if (props.selectionStyle === "highlight") rules += ' i4pzfu182';
        else if (props.selectionStyle === "checkbox") rules += ' iA182';
    } else rules += ' iA182';
    if (props.isDropTarget) rules += ' ild182';
    return rules;
};
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listRowFocusRing = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    if (props.selectionStyle === "highlight") rules += ' Ola182';
    else rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _MlkNNfn182';
    rules += ' _Kb182';
    rules += ' _KlToPtrc182';
    rules += ' _Pa182';
    if (props.isFirstItem) rules += ' Wr182';
    else rules += ' WLPOtrc182';
    if (props.selectionStyle === "highlight") rules += ' _lLPOtrc182';
    else if (props.selectionStyle === "checkbox") {
        if (props.isNextSelected) rules += ' _lr182';
        else rules += ' _lLPOtrc182';
    }
    rules += ' _Ar182';
    rules += ' _zr182';
    if (props.isQuiet) rules += ' ob182';
    else rules += ' o7E7Gic182';
    if (props.isQuiet) rules += ' nb182';
    else rules += ' n7E7Gic182';
    if (props.isQuiet) rules += ' kb182';
    else rules += ' k7E7Gic182';
    if (props.isQuiet) rules += ' jb182';
    else rules += ' j7E7Gic182';
    rules += ' _9c182';
    rules += ' _Ob182';
    return rules;
};
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rowWrapper = " sc182";
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$image = " z2U5Crc182 y2U5Crc182 B2U5Crc182 AvoofG182 Ht182 Hsu182 _dc182 oa182 na182 ka182 ja182 ZC182 fa182 _Hb182";
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$actionButtonGroup = " zkG38H182 ykG38H182 BkG38H182 AvoofG182 _dc182 __Ac182 It182 Isu182";
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listActionMenu = " z6Nrfjc182 y6Nrfjc182 B6Nrfjc182 AvoofG182 _dc182";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listCheckbox = function anonymous(props) {
    let rules = " ";
    rules += ' z2CW8rb182';
    rules += ' y2CW8rb182';
    rules += ' B2CW8rb182';
    rules += ' AvoofG182';
    rules += ' _dc182';
    rules += ' Hv182';
    if (props.isDisabled) rules += ' _6b182';
    else rules += ' _6c182';
    return rules;
};
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listTrailingIcon = " znWsohc182 ynWsohc182 BnWsohc182 AvoofG182 _dc182 sd182 eb182 It182 Isu182";
let $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$dragButtonContainer = " zdYeQw182 ydYeQw182 BdYeQw182 AvoofG182 _dc182 sd182 eb182 Zi182";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$centeredWrapper = " sd182 eb182 _Ca182 Za182 Fb182";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$loadingSpinnerWrapper = " TuNalie182 QuNalie182 SuNalie182 RuNalie182";
const $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$emptyStateWrapper = " sd182 eb182 _Ca182 Za182 Fb182 _oa182 Tf182 Qf182 Sf182 Rf182";
function $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$ListSelectionCheckbox({ isDisabled: isDisabled }) {
    let selectionContext = (0, $fDYaM.useSlottedContext)((0, $ed1Og.CheckboxContext), 'selection');
    let isSelectionDisabled = isDisabled || !!selectionContext?.isDisabled;
    return (0, $dx4lB.jsx)("div", {
        className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listCheckbox({
            isDisabled: isSelectionDisabled
        }),
        children: (0, $dx4lB.jsx)((0, $cxTG4.Checkbox), {
            slot: "selection"
        })
    });
}
function $5f873f6fe070b647$export$c6bde0c04b033c0e(props1) {
    let ref = (0, $eF4cA.useRef)(null);
    let { hasChildItems: hasChildItems, ...otherProps } = props1;
    let isLink = props1.href != null;
    let isLinkOut = isLink && props1.target === '_blank';
    let { isQuiet: isQuiet, selectionStyle: selectionStyle, overflowMode: overflowMode, scale: scale, hideLinkOutIcon: hideLinkOutIcon = false } = (0, $eF4cA.useContext)($5f873f6fe070b647$var$$6d4c8b365b6e9016$var$InternalListViewContext);
    let textValue = props1.textValue || (typeof props1.children === 'string' ? props1.children : undefined);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let hasTrailingIcon = hasChildItems || isLinkOut && !hideLinkOutIcon;
    return (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$e96fc9a8407faa6b), {
        ...otherProps,
        textValue: textValue,
        ref: ref,
        ...hasTrailingIcon ? {
            'data-has-trailing-icon': ''
        } : {},
        className: (renderProps)=>$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listitem({
                ...renderProps,
                isLink: isLink,
                isQuiet: isQuiet,
                scale: scale,
                selectionStyle: selectionStyle,
                isPrevNotSelected: !$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isPrevSelected(renderProps.id, renderProps.state),
                isNextSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(renderProps.id, renderProps.state),
                isNextNotSelected: !$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(renderProps.id, renderProps.state),
                isFirstItem: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isFirstItem(renderProps.id, renderProps.state),
                isLastItem: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isLastItem(renderProps.id, renderProps.state)
            }),
        children: (renderProps)=>{
            let { children: children } = props1;
            let { selectionMode: selectionMode, selectionBehavior: selectionBehavior, isDisabled: isDisabled, id: id, state: state, allowsDragging: allowsDragging, isFocusVisibleWithin: isFocusVisibleWithin } = renderProps;
            return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $208Op.TextContext),
                        {
                            slots: {
                                [(0, $fDYaM.DEFAULT_SLOT)]: {
                                    styles: (0, $2d603d22b712a1e0$export$1237798dc640739a)({
                                        ...renderProps,
                                        overflowMode: overflowMode
                                    })
                                },
                                label: {
                                    styles: (0, $2d603d22b712a1e0$export$1237798dc640739a)({
                                        ...renderProps,
                                        overflowMode: overflowMode
                                    })
                                },
                                description: {
                                    styles: (0, $2d603d22b712a1e0$export$6d59db4903f20f7d)({
                                        ...renderProps,
                                        overflowMode: overflowMode
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, $dm5H1.IconContext),
                        {
                            slots: {
                                icon: {
                                    render: (0, $8OJ2z.centerBaseline)({
                                        slot: 'icon',
                                        styles: (0, $2d603d22b712a1e0$export$31d1842a0fd736e6)
                                    }),
                                    styles: (0, $2d603d22b712a1e0$export$1ca1ec8b29a4ce27)
                                }
                            }
                        }
                    ],
                    [
                        (0, $8g9SZ.ImageContext),
                        {
                            styles: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$image
                        }
                    ],
                    [
                        (0, $waxwa.ActionButtonGroupContext),
                        {
                            styles: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$actionButtonGroup,
                            size: 'S',
                            isQuiet: true
                        }
                    ],
                    [
                        (0, $gc2oq.ActionMenuContext),
                        {
                            styles: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listActionMenu,
                            isQuiet: true,
                            size: 'S',
                            isDisabled: isDisabled
                        }
                    ]
                ],
                children: (0, $dx4lB.jsxs)("div", {
                    className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$rowWrapper,
                    children: [
                        (0, $dx4lB.jsx)("div", {
                            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listRowBackground({
                                ...renderProps,
                                selectionStyle: selectionStyle,
                                isQuiet: isQuiet,
                                isDropTarget: renderProps.isDropTarget,
                                isPrevSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isPrevSelected(id, state),
                                isNextSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(id, state),
                                isPrevNotSelected: !$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isPrevSelected(id, state),
                                isNextNotSelected: !$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(id, state),
                                isFirstItem: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isFirstItem(id, state),
                                isLastItem: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isLastItem(id, state)
                            })
                        }),
                        renderProps.isFocusVisible && (0, $dx4lB.jsx)("div", {
                            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listRowFocusRing({
                                ...renderProps,
                                selectionStyle: selectionStyle,
                                isQuiet: isQuiet,
                                isPrevSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isPrevSelected(id, state),
                                isNextSelected: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(id, state),
                                isPrevNotSelected: !$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isPrevSelected(id, state),
                                isNextNotSelected: !$5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(id, state),
                                isFirstItem: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isFirstItem(id, state),
                                isLastItem: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isLastItem(id, state)
                            })
                        }),
                        allowsDragging && (0, $dx4lB.jsx)("div", {
                            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$dragButtonContainer,
                            children: !isDisabled && (0, $dx4lB.jsx)((0, $6750b0b6e12c44b5$export$4c99a519d851f90c), {
                                isFocusVisibleWithin: isFocusVisibleWithin
                            })
                        }),
                        selectionMode !== 'none' && selectionBehavior === 'toggle' && (0, $dx4lB.jsx)($5f873f6fe070b647$var$$6d4c8b365b6e9016$var$ListSelectionCheckbox, {
                            isDisabled: isDisabled
                        }),
                        typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "label",
                            children: children
                        }) : children,
                        isLinkOut && !hideLinkOutIcon && (0, $dx4lB.jsx)("div", {
                            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listTrailingIcon,
                            children: (0, $dx4lB.jsx)((0, $gos6s.default), {
                                size: "M",
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a182';
                                        rules += ' __Ha182';
                                    }
                                    rules += ' -_8sjo0b-t5ZbAob182';
                                    return rules;
                                }({
                                    direction: direction
                                })
                            })
                        }),
                        hasChildItems && !isLinkOut && (0, $dx4lB.jsx)("div", {
                            className: $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$listTrailingIcon,
                            children: (0, $dx4lB.jsx)((0, $hxsf4.default), {
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a182';
                                        rules += ' __Ha182';
                                    } else if (props.direction === "ltr") {
                                        rules += ' -Z4Pn4c-b182';
                                        rules += ' __Ha182';
                                    }
                                    if (props.direction === "rtl") {
                                        rules += ' -_04Pn4c-a182';
                                        rules += ' __Ha182';
                                    } else if (props.direction === "ltr") {
                                        rules += ' -_04Pn4c-b182';
                                        rules += ' __Ha182';
                                    }
                                    rules += ' -_8sjo0b-t5ZbAob182';
                                    return rules;
                                }({
                                    direction: direction
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
}
function $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isNextSelected(id, state) {
    if (id == null || !state) return false;
    let keyAfter = state.collection.getKeyAfter(id);
    return keyAfter != null && state.selectionManager.isSelected(keyAfter);
}
function $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isPrevSelected(id, state) {
    if (id == null || !state) return false;
    let keyBefore = state.collection.getKeyBefore(id);
    return keyBefore != null && state.selectionManager.isSelected(keyBefore);
}
function $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isFirstItem(id, state) {
    if (id == null || !state) return false;
    return state.collection.getFirstKey() === id;
}
function $5f873f6fe070b647$var$$6d4c8b365b6e9016$var$isLastItem(id, state) {
    if (id == null || !state) return false;
    let key = state.collection.getLastKey();
    let node = key ? state.collection.getItem(key) : null;
    return node ? node.key === id : false;
}


var $j8RRT = parcelRequire("j8RRT");

var $8Ogg5 = parcelRequire("8Ogg5");

var $ikOQe = parcelRequire("ikOQe");
const $5a97d3ace48abbdb$var$ADOBE_EMAIL_REGEX = /^[a-z0-9._%+-]+@adobe\.com$/i;
const $5a97d3ace48abbdb$var$parseEmails = (value)=>[
        ...new Set(value.split(/[\s,;]+/).map((item)=>item.trim().toLowerCase()).filter(Boolean))
    ];
const $5a97d3ace48abbdb$export$26b082ba192e616 = ({ videoId: videoId, onAccept: onAccept })=>{
    const [value, setValue] = (0, $eF4cA.useState)("");
    const [isSaving, setIsSaving] = (0, $eF4cA.useState)(false);
    const video = (0, $ikOQe.useVideo)(videoId);
    const sharedWith = new Map([
        [
            video.data?.createdBy,
            {
                email: video.data?.createdBy,
                label: video.data?.createdBy,
                role: "Owner"
            }
        ],
        ...(video.data?.sharedWith ?? []).map((email)=>[
                email,
                {
                    email: email,
                    label: email
                }
            ])
    ]);
    console.log([
        ...sharedWith.values()
    ]);
    const sharedWithLoadingState = (0, $8Ogg5.getQueryLoadingState)(video);
    const emails = $5a97d3ace48abbdb$var$parseEmails(value);
    const invalidEmails = emails.filter((item)=>!$5a97d3ace48abbdb$var$ADOBE_EMAIL_REGEX.test(item));
    const isInvalid = invalidEmails.length > 0;
    const canSubmit = emails.length > 0 && !isInvalid && !isSaving;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7uz0i.Dialog), {
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        slot: "title",
                        children: "Share project"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                    label: "User emails",
                                    description: "Separate multiple emails with commas, spaces or new lines",
                                    placeholder: "name@adobe.com, other@adobe.com",
                                    value: value,
                                    onChange: setValue,
                                    isInvalid: isInvalid,
                                    errorMessage: `Invalid @adobe.com email: ${invalidEmails.join(", ")}`,
                                    isDisabled: isSaving,
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                    label: "Who has access",
                                    value: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " Za182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5f873f6fe070b647$export$84d0dd190d551cd1), {
                                            selectionMode: "none",
                                            isQuiet: true,
                                            loadingState: sharedWithLoadingState,
                                            children: [
                                                Array.from(sharedWith.values()).map((item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $5f873f6fe070b647$export$c6bde0c04b033c0e), {
                                                        id: item.email,
                                                        textValue: item.label,
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                            children: [
                                                                item.label,
                                                                !!item.role && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Is182",
                                                                    children: `(${item.role})`
                                                                })
                                                            ]
                                                        })
                                                    }, item.email)),
                                                video.isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                                                    children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $5f873f6fe070b647$export$c6bde0c04b033c0e), {
                                                            id: "skeleton",
                                                            children: "Loading\u2026"
                                                        })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "secondary",
                                isDisabled: isSaving,
                                onPress: close,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "primary",
                                isDisabled: !canSubmit,
                                isPending: isSaving,
                                onPress: async ()=>{
                                    setIsSaving(true);
                                    try {
                                        await onAccept(emails);
                                        close();
                                    } catch  {
                                    // Caller shows the error toast; keep the dialog open to retry.
                                    } finally{
                                        setIsSaving(false);
                                    }
                                },
                                children: "Share"
                            })
                        ]
                    })
                ]
            })
    });
};
$5a97d3ace48abbdb$export$26b082ba192e616.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};



var $ikOQe = parcelRequire("ikOQe");

var $fmJ8d = parcelRequire("fmJ8d");
const $08f113aefb328d35$export$99bffacbdbcb5195 = ({ limit: limit = -1, isQuiet: isQuiet = false, selectionMode: selectionMode = "multiple", renderEmptyState: renderEmptyState = ()=>null, onCardPress: onCardPress, styles: styles = "" })=>{
    const params = (0, $dqZbZ.useParams)();
    const [searchParams] = (0, $dqZbZ.useSearchParams)();
    const isEmptySearchParam = searchParams.get("empty");
    const isEmpty = [
        "",
        "true"
    ].includes(isEmptySearchParam) ?? isQuiet ?? false;
    const [selectedKeys, setSelectedKeys] = (0, $eF4cA.useState)(new Set());
    const [shareVideoId, setShareVideoId] = (0, $eF4cA.useState)(null);
    const videos = (0, $ikOQe.useVideos)({
        enabled: !isEmpty,
        user: params?.email ?? "me",
        pageSize: limit !== -1 && typeof limit === "number" ? limit : undefined
    });
    const updateVideo = (0, $ikOQe.useUpdateVideo)();
    const deleteVideo = (0, $ikOQe.useDeleteVideo)();
    const duplicateVideo = (0, $ikOQe.useDuplicateVideo)();
    const loadingState = videos.isError ? "error" : videos.isPending || videos.isLoading ? "loading" : videos.isFetchingNextPage ? "loadingMore" : "idle";
    const [currentLimit, setCurrentLimit] = (0, $eF4cA.useState)(typeof limit === "number" ? limit : -1);
    const listRef = (0, $eF4cA.useRef)(null);
    const handleLoadMore = (0, $eF4cA.useCallback)(()=>{
        if (!isEmpty && videos.hasNextPage && !videos.isFetching && (limit !== "row" || currentLimit > 0) && (currentLimit <= 0 || (videos.data?.length ?? 0) < currentLimit)) videos.fetchNextPage({
            cancelRefetch: false
        });
    }, [
        isEmpty,
        videos.hasNextPage,
        videos.isFetching,
        videos.data?.length,
        videos.fetchNextPage,
        currentLimit,
        limit
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (typeof limit === "number" && limit !== currentLimit) setCurrentLimit(limit);
    }, [
        limit,
        currentLimit
    ]);
    const handleResize = (0, $eF4cA.useCallback)(()=>{
        const listEl = listRef.current?.UNSAFE_getDOMNode();
        if (!listEl) return;
        const gridEl = listEl.querySelector("[role='grid']") ?? listEl;
        const itemEl = gridEl?.firstElementChild?.firstElementChild;
        const itemWidth = (itemEl?.offsetWidth ?? 165) + 6;
        const listWidth = listEl.offsetWidth;
        const possibleItems = Math.max(1, Math.floor(listWidth / itemWidth));
        if (possibleItems !== limit) setCurrentLimit(possibleItems);
    }, [
        limit
    ]);
    (0, $eF4cA.useLayoutEffect)(()=>{
        if (limit !== "row") return;
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        videos.data,
        handleResize,
        limit
    ]);
    const items = (0, $eF4cA.useMemo)(()=>{
        if (isEmpty) return [];
        return videos.data?.slice(0, currentLimit > 0 ? currentLimit : undefined)?.filter((item)=>!!item?.id) ?? [];
    }, [
        videos.data,
        currentLimit,
        isEmpty
    ]);
    const shouldShowSkeleton = (0, $eF4cA.useMemo)(()=>{
        return !isEmpty && (videos.isPending || videos.isFetchingNextPage) && (currentLimit <= 0 || items.length < currentLimit);
    }, [
        videos.isPending,
        videos.isFetchingNextPage,
        isEmpty,
        items.length,
        currentLimit
    ]);
    const handleVideosDelete = (0, $eF4cA.useCallback)((videoIds)=>{
        setSelectedKeys(new Set());
        [
            ...videoIds
        ].forEach((id)=>{
            deleteVideo.mutate({
                id: id
            }, {
                onSuccess: ()=>{
                    (0, $fmJ8d.store).getState().addToast(`Video${videoIds.size > 1 ? "s" : ""} deleted successfully`, {
                        variant: "positive",
                        timeout: 3000
                    });
                }
            });
        });
    }, [
        deleteVideo.mutate
    ]);
    const [tempName, setTempName] = (0, $eF4cA.useState)("");
    const handleVideoDuplicate = (id)=>{
        duplicateVideo.mutate({
            id: id
        }, {
            onSuccess: ()=>{
                setSelectedKeys(new Set());
                (0, $fmJ8d.store).getState().addToast("Project duplicated successfully", {
                    variant: "positive",
                    timeout: 3000
                });
            }
        });
    };
    const handleVideoRename = (0, $eF4cA.useCallback)((id, newName)=>{
        updateVideo.mutate({
            id: id,
            name: newName
        });
    }, [
        updateVideo.mutate
    ]);
    const handleVideoShare = async (id, emails)=>{
        try {
            const video = videos.data?.find((item)=>item.id === id);
            if (!video) throw new Error("Project not found");
            const current = video.sharedWith ?? [];
            const currentLower = new Set(current.map((item)=>item.toLowerCase()));
            const added = emails.filter((item)=>!currentLower.has(item));
            if (added.length === 0) {
                (0, $fmJ8d.store).getState().addToast("Project is already shared with these users", {
                    variant: "info",
                    timeout: 3000
                });
                return;
            }
            await updateVideo.mutateAsync({
                id: id,
                sharedWith: [
                    ...current,
                    ...added
                ]
            });
            (0, $fmJ8d.store).getState().addToast(`Project shared with ${added.join(", ")}`, {
                variant: "positive",
                timeout: 3000
            });
        } catch (error) {
            (0, $fmJ8d.store).getState().addToast("Unable to share project. Please try again.", {
                variant: "negative",
                timeout: 5000
            });
            throw error;
        }
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                ref: listRef,
                loadingState: loadingState,
                onLoadMore: handleLoadMore,
                selectionMode: selectionMode,
                selectionStyle: selectionMode === "multiple" ? "checkbox" : "highlight",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                renderEmptyState: renderEmptyState,
                renderActionBar: selectionMode === "multiple" ? (selectedKeys)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $df1664e6139b6656$export$e213cebad6250b4a), {
                        isEmphasized: true,
                        children: [
                            selectedKeys.size === 1 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d17b0246a3955b22$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Share"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5a97d3ace48abbdb$export$26b082ba192e616), {
                                        videoId: [
                                            ...selectedKeys
                                        ][0],
                                        onAccept: (email)=>handleVideoShare([
                                                ...selectedKeys
                                            ][0], email)
                                    })
                                ]
                            }),
                            selectedKeys.size === 1 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isDisabled: duplicateVideo.isPending,
                                onPress: ()=>handleVideoDuplicate([
                                        ...selectedKeys
                                    ][0]),
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: duplicateVideo.isPending ? "Duplicating..." : "Duplicate"
                                    })
                                ]
                            }),
                            selectedKeys.size === 1 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a500bb283462013d$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Rename"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5NHyX.AlertDialog), {
                                        title: "Rename Project",
                                        primaryActionLabel: "Rename",
                                        cancelLabel: "Cancel",
                                        onPrimaryAction: ()=>{
                                            handleVideoRename([
                                                ...selectedKeys
                                            ][0], tempName);
                                            setTempName("");
                                        },
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                            label: "Title",
                                            defaultValue: videos.data.find((video)=>video.id === [
                                                    ...selectedKeys
                                                ][0])?.name || "",
                                            onChange: setTempName
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                onPress: ()=>handleVideosDelete(selectedKeys),
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Delete"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                size: "S",
                "aria-label": "Projects list",
                styles: (0, $5nTep.mergeStyles)(" _ub182 _vb182 _sb182 Ma182 _oa182", styles),
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                        items: items,
                        dependencies: [],
                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $ce29ef6db3284568$export$8d792ff3c0a85132), {
                                item: item,
                                onPress: ()=>onCardPress(item),
                                isDuplicating: duplicateVideo.isPending,
                                onMenuAction: (action, video)=>{
                                    if (action === "share") setShareVideoId(video.id);
                                    else if (action === "duplicate") handleVideoDuplicate(video.id);
                                }
                            })
                    }),
                    shouldShowSkeleton && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                        children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $ce29ef6db3284568$export$8d792ff3c0a85132), {
                                item: {
                                    id: "",
                                    name: "Loading\u2026",
                                    rendition_grid: {
                                        main: {},
                                        tiles: [
                                            {
                                                name: 1
                                            },
                                            {
                                                name: 2
                                            },
                                            {
                                                name: 3
                                            }
                                        ]
                                    }
                                }
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
                onDismiss: ()=>setShareVideoId(null),
                children: shareVideoId && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5a97d3ace48abbdb$export$26b082ba192e616), {
                    videoId: shareVideoId,
                    onAccept: (emails)=>handleVideoShare(shareVideoId, emails)
                })
            })
        ]
    });
};
$08f113aefb328d35$export$99bffacbdbcb5195.propTypes = {
    ref: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    limit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
    isQuiet: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    selectionMode: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "none",
        "single",
        "multiple"
    ]),
    renderEmptyState: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onCardPress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $5IZkx = parcelRequire("5IZkx");


var $34HUQ = parcelRequire("34HUQ");
var $2RdeM = parcelRequire("2RdeM");
var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $8g9SZ = parcelRequire("8g9SZ");
var $5nTep = parcelRequire("5nTep");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $bc2606bda86da212$var$$995bbe8053bfef2e$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M23.923 24C16.792 24 11 29.774 11 36.91v81.726c0 8.732 6.45 15.95 14.84 17.179q1.082.184 2.225.185h98.059c5.342 0 10.208-3.211 12.173-8.192l15.798-38.303.028-.069C157.463 80.892 150.944 72 141.935 72H135v-8.364c0-9.595-7.789-17.363-17.385-17.363H72.69l-13.966-17.43C56.27 25.78 52.558 24 48.634 24zM127 72v-8.364c0-5.165-4.196-9.363-9.385-9.363H68.849l-1.201-1.5L52.48 33.846C51.547 32.68 50.132 32 48.635 32H23.923C21.198 32 19 34.204 19 36.91v74.08l12.703-30.797C33.668 75.212 38.533 72 43.877 72zm-98.615 56q-.693 0-1.358-.097c-3.036-.583-4.751-3.681-3.71-6.397l15.795-38.294.027-.07C39.861 81.298 41.72 80 43.876 80h98.059c3.667 0 5.903 3.482 4.748 6.494l-15.794 38.294-.026.063-.002.006c-.722 1.846-2.579 3.143-4.737 3.143h-97.74"
        })
    });
const $bc2606bda86da212$var$$995bbe8053bfef2e$var$ForwardRef = (0, $eF4cA.forwardRef)($bc2606bda86da212$var$$995bbe8053bfef2e$var$SvgComponent);
var $bc2606bda86da212$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($bc2606bda86da212$var$$995bbe8053bfef2e$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $7b9d3fc51bd2f911$var$$506444327def265d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M12.552 16C8.936 16 6 18.928 6 22.546v47.272c0 4.07 2.39 7.581 5.844 9.211 1.09.615 2.36.971 3.735.971h60.343c3.126 0 5.948-1.905 7.074-4.82l8.499-22C93.406 48.232 89.69 43 84.42 43H81v-2.272c0-6.128-4.974-11.092-11.104-11.092h-26.8l-8.957-11.18-1.56 1.25 1.56-1.25C32.895 16.903 31.013 16 29.024 16zM77 43v-2.272c0-3.914-3.178-7.092-7.104-7.092H41.175l-.601-.75-9.557-11.93C30.533 20.353 29.8 20 29.024 20H12.552C11.14 20 10 21.142 10 22.546v43.405l7.004-18.131c1.127-2.915 3.948-4.82 7.074-4.82zM16.185 76c-.894-.001-1.744-.191-2.511-.533-1.376-.851-2.062-2.588-1.438-4.206l8.5-22c.52-1.349 1.843-2.261 3.342-2.261H84.42c2.54 0 4.213 2.486 3.343 4.739l-8.5 22C78.744 75.088 77.421 76 75.922 76H16.185"
        })
    });
const $7b9d3fc51bd2f911$var$$506444327def265d$var$ForwardRef = (0, $eF4cA.forwardRef)($7b9d3fc51bd2f911$var$$506444327def265d$var$SvgComponent);
var $7b9d3fc51bd2f911$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($7b9d3fc51bd2f911$var$$506444327def265d$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $583083a7b102f667$var$$e1b470cf46639b4a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M6.692 7.75C4.5 7.75 2.75 9.546 2.75 11.727V34.91c0 2.074 1.175 3.885 2.902 4.768.596.361 1.302.573 2.068.573h29.417c1.632 0 3.112-.99 3.704-2.514l4.143-10.667c1.01-2.597-.956-5.319-3.704-5.319h-1.03v-1.84c0-2.935-2.353-5.342-5.288-5.342h-13.53l-4.2-5.32c-.746-.944-1.88-1.498-3.084-1.498zm31.058 14v-1.84c0-1.585-1.264-2.842-2.788-2.842H20.22l-.375-.475-4.576-5.795c-.276-.35-.69-.548-1.122-.548H6.692c-.781 0-1.442.646-1.442 1.477v20.026l2.909-7.489c.592-1.525 2.072-2.514 3.704-2.514zm-29.712 16c-.42 0-.822-.096-1.183-.268-.512-.363-.747-1.034-.51-1.646l4.144-10.667c.211-.542.751-.919 1.374-.919H41.28c1.06 0 1.721 1.02 1.374 1.914l-4.143 10.667c-.211.542-.751.919-1.374.919H8.038"
        })
    });
const $583083a7b102f667$var$$e1b470cf46639b4a$var$ForwardRef = (0, $eF4cA.forwardRef)($583083a7b102f667$var$$e1b470cf46639b4a$var$SvgComponent);
var $583083a7b102f667$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($583083a7b102f667$var$$e1b470cf46639b4a$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $87458d3f73b0e664$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $bc2606bda86da212$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $583083a7b102f667$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $7b9d3fc51bd2f911$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $eb8f55a238917802$var$$c34c4118f26b2a65$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.25 9.25h-2.5v-2.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.5h-2.5c-.414 0-.75.336-.75.75s.336.75.75.75h2.5v2.5c0 .414.336.75.75.75s.75-.336.75-.75v-2.5h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
            })
        ]
    });
const $eb8f55a238917802$var$$c34c4118f26b2a65$var$ForwardRef = (0, $eF4cA.forwardRef)($eb8f55a238917802$var$$c34c4118f26b2a65$var$SvgComponent);
var $eb8f55a238917802$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($eb8f55a238917802$var$$c34c4118f26b2a65$var$ForwardRef);



var $9iR3a = parcelRequire("9iR3a");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $8829c44c80cd9620$var$$5c3fed25abf344cc$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M12.237 16.455c-.196 0-.393-.077-.54-.23L6.21 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.288.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
        })
    });
const $8829c44c80cd9620$var$$5c3fed25abf344cc$var$ForwardRef = (0, $eF4cA.forwardRef)($8829c44c80cd9620$var$$5c3fed25abf344cc$var$SvgComponent);
var $8829c44c80cd9620$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($8829c44c80cd9620$var$$5c3fed25abf344cc$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $79846ac3e4f71e5a$var$$04f4b15c8c66bb2a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const $79846ac3e4f71e5a$var$$04f4b15c8c66bb2a$var$ForwardRef = (0, $eF4cA.forwardRef)($79846ac3e4f71e5a$var$$04f4b15c8c66bb2a$var$SvgComponent);
var $79846ac3e4f71e5a$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($79846ac3e4f71e5a$var$$04f4b15c8c66bb2a$var$ForwardRef);



var $8Ogg5 = parcelRequire("8Ogg5");

var $fmJ8d = parcelRequire("fmJ8d");

var $3NGKk = parcelRequire("3NGKk");
const $959bbd0e20257a0c$var$cardContentStyles = " _Ob182 se182 Za182 Fb182 _oa182 Tf182 Qf182 Sf182 Rf182 CGA1ZI182 ErNUpHe182 DKX6Yne182 qg182 Ub182 _Pa182 Wr182 _lr182 _Ar182 _zr182";
const $959bbd0e20257a0c$var$cardHeaderStyles = " _Oa182 z6Akec182 y6Akec182 B6Akec182 A6Akec182 IM182";
const $959bbd0e20257a0c$var$cardTitleStyles = " zn9DOs182 yn9DOs182 Bn9DOs182 An9DOs182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 px182 Jy182 Gy182 Iy182 Hy182";
const $959bbd0e20257a0c$var$cardIconStyles = " z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182 _db182 -_8sjo0b-tw182 Zl182 Fm182";
const $959bbd0e20257a0c$var$cardDescriptionStyle = " z9u7zPc182 y9u7zPc182 B9u7zPc182 A9u7zPc182 _vb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 p2FhUi182";
const $959bbd0e20257a0c$var$scrollArrowStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' _9c182';
    rules += ' WF182';
    rules += ' -_8PloMd-xo74Xb182';
    rules += ' __Ya182';
    if (props.isLeft) {
        if (props.isLargeViewport) rules += ' _Ek182';
        else rules += ' _Ei182';
    } else rules += ' _Ee4mUs182';
    if (props.isLeft) rules += ' _Re4mUs182';
    else if (props.isLargeViewport) rules += ' _Rk182';
    else rules += ' _Ri182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' _kb182';
    rules += ' hb182';
    rules += ' mb182';
    rules += ' lb182';
    rules += ' _jf182';
    rules += ' ir182';
    rules += ' _nLeasBb182';
    return rules;
};
const $959bbd0e20257a0c$var$renderEmptyState = (message = "No templates found", icon = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87458d3f73b0e664$export$2e2bcd8739ae039), {}))=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
        size: "M",
        styles: " fZaSpn182 JI182",
        children: [
            icon,
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                children: message
            })
        ]
    });
const $959bbd0e20257a0c$var$TemplateBadge = ({ children: children, styles: styles })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: (0, $5nTep.mergeStyles)(" z0yNlr182 y0yNlr182 B0yNlr182 A0yNlr182 __Ad182 St182 Rt182 Tj182 Qj182 _kb182 hb182 mb182 lb182 iroEKhb182 oa182 na182 ka182 ja182 gbcWFLe182 Gs182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pg182", styles),
        children: children
    });
};
/**
 * What a template card shows over its thumbnail: its name, and on hover its
 * description and actions — `Preview`, with the template's `previewPassword`
 * in a popover. The hover content stays up while that popover is open, as
 * the pointer leaves the card for it.
 */ const $959bbd0e20257a0c$var$TemplateCardOverlay = ({ item: item, isHovered: isHovered, isNew: isNew })=>{
    const [isPreviewOpen, setIsPreviewOpen] = (0, $eF4cA.useState)(false);
    const isShown = isHovered || isPreviewOpen;
    const previewLink = /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
        href: item.previewUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        size: "S",
        staticColor: "white",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9iR3a.default), {}),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "Preview"
            })
        ]
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " _iCSKHA182 _Pa182 Wr182 _lr182 _Ar182 _zr182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: (0, $5nTep.mergeStyles)($959bbd0e20257a0c$var$cardContentStyles, function anonymous(props) {
                    let rules = " ";
                    if (props.isShown) rules += ' _Ia182';
                    else rules += ' _Ib182';
                    if (props.isShown) {
                        rules += ' -_8PloMd-u182';
                        rules += ' __Ya182';
                    } else {
                        rules += ' -_8PloMd-s182';
                        rules += ' __Ya182';
                    }
                    rules += ' Ya182';
                    rules += ' Xb182';
                    rules += ' _2b182';
                    return rules;
                }({
                    isShown: isShown
                })),
                children: [
                    isNew && /*#__PURE__*/ (0, $dx4lB.jsx)($959bbd0e20257a0c$var$TemplateBadge, {
                        children: "New"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: $959bbd0e20257a0c$var$cardTitleStyles,
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $eb8f55a238917802$export$2e2bcd8739ae039), {
                        styles: $959bbd0e20257a0c$var$cardIconStyles
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: (0, $5nTep.mergeStyles)($959bbd0e20257a0c$var$cardContentStyles, function anonymous(props) {
                    let rules = " ";
                    if (props.isShown) rules += ' _Ib182';
                    else rules += ' _Ia182';
                    if (props.isShown) {
                        rules += ' -_8PloMd-s182';
                        rules += ' __Ya182';
                    } else {
                        rules += ' -_8PloMd-u182';
                        rules += ' __Ya182';
                    }
                    rules += ' Ya182';
                    rules += ' Xb182';
                    rules += ' _2b182';
                    return rules;
                }({
                    isShown: isShown
                })),
                children: [
                    !!item?.previewUrl && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: $959bbd0e20257a0c$var$cardHeaderStyles,
                        children: item.previewPassword ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3NGKk.PreviewPasswordPopover), {
                            password: item.previewPassword,
                            onOpenChange: setIsPreviewOpen,
                            children: previewLink
                        }) : previewLink
                    }),
                    isNew && /*#__PURE__*/ (0, $dx4lB.jsx)($959bbd0e20257a0c$var$TemplateBadge, {
                        children: "New"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: $959bbd0e20257a0c$var$cardTitleStyles,
                        children: item.name
                    }),
                    item.description && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: $959bbd0e20257a0c$var$cardDescriptionStyle,
                        children: item.description
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " _va182 zkG38H182 ykG38H182 BkG38H182 AkG38H182 _dd182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            staticColor: "white",
                            fillStyle: "outline",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Try it"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$959bbd0e20257a0c$var$TemplateCardOverlay.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    isHovered: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isNew: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
const $959bbd0e20257a0c$export$b768bbdb9877477 = ({ templates: templates, selectedTemplateKey: selectedTemplateKey, onSelectionChange: onSelectionChange, isDisabled: isDisabled = false, emptyStateMessage: emptyStateMessage = "Session expired - please sign in again", emptyStateIcon: emptyStateIcon = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87458d3f73b0e664$export$2e2bcd8739ae039), {}), placeholder: placeholder, orientation: orientation = "vertical", styles: styles = "", showScrollArrows: showScrollArrows = false })=>{
    const isLargeViewport = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isLargeViewport);
    const scrollRef = (0, $eF4cA.useRef)(null);
    const [canScrollLeft, setCanScrollLeft] = (0, $eF4cA.useState)(false);
    const [canScrollRight, setCanScrollRight] = (0, $eF4cA.useState)(false);
    const cardWidth = isLargeViewport ? "calc(18.75rem * var(--s2-scale))" : "calc(15rem * var(--s2-scale))";
    const updateScrollState = (0, $eF4cA.useCallback)(()=>{
        const el = scrollRef.current;
        if (!el) return;
        setCanScrollLeft(el.scrollLeft > 1);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }, []);
    (0, $eF4cA.useEffect)(()=>{
        const el = scrollRef.current;
        if (!showScrollArrows || !el) return undefined;
        updateScrollState();
        el.addEventListener("scroll", updateScrollState, {
            passive: true
        });
        // Observe the container and its content, as content width changes when templates load
        const observer = new ResizeObserver(updateScrollState);
        observer.observe(el);
        if (el.firstElementChild) observer.observe(el.firstElementChild);
        return ()=>{
            el.removeEventListener("scroll", updateScrollState);
            observer.disconnect();
        };
    }, [
        showScrollArrows,
        updateScrollState,
        templates.data?.length
    ]);
    const scrollByDirection = (direction)=>{
        const el = scrollRef.current;
        if (!el) return;
        el.scrollBy({
            left: direction * el.clientWidth * 0.8,
            behavior: "smooth"
        });
    };
    const renderScrollArrow = (direction)=>{
        const isLeft = direction < 0;
        return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: $959bbd0e20257a0c$var$scrollArrowStyles({
                isLeft: isLeft,
                isLargeViewport: isLargeViewport
            }),
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                "aria-label": isLeft ? "Scroll left" : "Scroll right",
                variant: "secondary",
                isDisabled: isLeft ? !canScrollLeft : !canScrollRight,
                onPress: ()=>scrollByDirection(direction),
                children: isLeft ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8829c44c80cd9620$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $79846ac3e4f71e5a$export$2e2bcd8739ae039), {})
            })
        });
    };
    const isNew = (item)=>+new Date() - new Date(item?.createdAt) < 1209600000;
    const content = /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        ref: scrollRef,
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _oa182';
            if (props.orientation === "horizontal") rules += ' Zd182';
            if (props.orientation === "vertical") rules += ' Zoa182';
            else if (props.orientation === "horizontal") rules += ' Zod182';
            rules += ' _Na182';
            if (props.orientation === "horizontal") rules += ' Qh182';
            if (props.orientation === "vertical") rules += ' IM182';
            else if (props.orientation === "horizontal") rules += ' In182';
            if (props.orientation === "vertical") rules += ' HM182';
            else if (props.orientation === "horizontal") rules += ' Hn182';
            if (props.orientation === "horizontal") rules += ' So182';
            if (props.orientation === "horizontal") rules += ' Ro182';
            return rules;
        }({
            orientation: orientation
        }),
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0c1b7b025fb75d97$export$a7bfbda1311ca015), {
            loadingState: (0, $8Ogg5.getQueryLoadingState)(templates),
            selectionMode: "single",
            selectionStyle: "checkbox",
            disallowEmptySelection: true,
            selectedKeys: [
                selectedTemplateKey
            ],
            onSelectionChange: onSelectionChange,
            disabledKeys: isDisabled ? new Set(templates.data?.map((item)=>item.id) ?? []) : new Set(),
            renderEmptyState: ()=>!templates.isFetching && $959bbd0e20257a0c$var$renderEmptyState(emptyStateMessage, emptyStateIcon),
            "aria-label": "Select a template",
            layout: "grid",
            className: (0, $5nTep.mergeStyles)(function anonymous(props) {
                let rules = " ";
                rules += ' se182';
                rules += ' _Ca182';
                rules += ' eb182';
                rules += ' Ug182';
                rules += ' qg182';
                if (props.orientation === "horizontal") rules += ' ZJ182';
                if (props.orientation === "horizontal") rules += ' __xa182';
                return rules;
            }({
                orientation: orientation
            }), styles),
            style: {
                gridTemplateColumns: orientation === "horizontal" ? `repeat(3, ${cardWidth})` : `repeat(auto-fit, ${cardWidth})`,
                gridAutoColumns: cardWidth
            },
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                    items: templates.data ?? [],
                    dependencies: [],
                    children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$e96fc9a8407faa6b), {
                            className: " _Pc182 Za182 Fb182 oc182 nc182 kc182 jc182 ry182",
                            children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                    id: item.id,
                                    textValue: item.name,
                                    styles: " Za182 Fb182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                src: item.thumbnailUrl,
                                                alt: item.name,
                                                styles: function anonymous(props) {
                                                    let rules = " ";
                                                    rules += ' Za182';
                                                    rules += ' Fb182';
                                                    rules += ' _Hb182';
                                                    rules += ' fZaSpn182';
                                                    if (props.isHovered) {
                                                        rules += ' -Z4Pn4c-VDMfn182';
                                                        rules += ' __Ha182';
                                                    } else {
                                                        rules += ' -Z4Pn4c-b182';
                                                        rules += ' __Ha182';
                                                    }
                                                    if (props.isHovered) {
                                                        rules += ' -_04Pn4c-VDMfn182';
                                                        rules += ' __Ha182';
                                                    } else {
                                                        rules += ' -_04Pn4c-b182';
                                                        rules += ' __Ha182';
                                                    }
                                                    if (props.isHovered) {
                                                        rules += ' -_8PloMd-b182';
                                                        rules += ' __Ya182';
                                                    } else {
                                                        rules += ' -_8PloMd-s182';
                                                        rules += ' __Ya182';
                                                    }
                                                    rules += ' Ya182';
                                                    if (props.isHovered) rules += ' XgOBrDc182';
                                                    else rules += ' XXUMfn182';
                                                    rules += ' _2b182';
                                                    return rules;
                                                }({
                                                    isHovered: isHovered
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)($959bbd0e20257a0c$var$TemplateCardOverlay, {
                                                item: item,
                                                isHovered: isHovered,
                                                isNew: isNew(item)
                                            })
                                        ]
                                    })
                                })
                        }, item.id)
                }),
                templates.isFetching && !templates.data?.length ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                    children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                            styles: " Za182 Fb182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                    alt: "",
                                    styles: " Za182 Fb182 _Hb182 fZaSpn182"
                                })
                            })
                        })
                }) : placeholder ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$e96fc9a8407faa6b), {
                    isDisabled: true,
                    className: " _Pc182 Za182 Fb182 oc182 nc182 kc182 jc182",
                    children: placeholder
                }) : null
            ]
        })
    });
    if (!showScrollArrows) return content;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " _Pc182",
        children: [
            content,
            renderScrollArrow(-1),
            renderScrollArrow(1)
        ]
    });
};
$959bbd0e20257a0c$export$b768bbdb9877477.propTypes = {
    templates: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    selectedTemplateKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onSelectionChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    emptyStateMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    emptyStateIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "vertical",
        "horizontal"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    showScrollArrows: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};



var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $aVEhH = parcelRequire("aVEhH");
var $208Op = parcelRequire("208Op");
var $7uz0i = parcelRequire("7uz0i");
var $bsn7e = parcelRequire("bsn7e");
var $j3pTw = parcelRequire("j3pTw");

var $8OJ2z = parcelRequire("8OJ2z");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $i0SpD = parcelRequire("i0SpD");

var $8UElq = parcelRequire("8UElq");

var $hUj7u = parcelRequire("hUj7u");

var $2FPWu = parcelRequire("2FPWu");

var $c1ibQ = parcelRequire("c1ibQ");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9032f1114e493871$export$37b65e5b5444d35c = new WeakMap();



var $8M8Qw = parcelRequire("8M8Qw");

var $3rgVl = parcelRequire("3rgVl");

var $56aMA = parcelRequire("56aMA");

var $bEes0 = parcelRequire("bEes0");

var $czVXo = parcelRequire("czVXo");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e5e6af279c3473c4$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $bEes0.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        onPress (e) {
            onPress?.(e);
            state.setSelectedValue(value);
            ref.current?.focus();
        }
    });
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)((0, $lhKAD.mergeProps)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, $lhKAD.mergeProps)(pressProps, focusableProps);
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name: name, form: form, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $9032f1114e493871$export$37b65e5b5444d35c).get(state);
    (0, $3rgVl.useFormReset)(ref, state.defaultSelectedValue, state.setSelectedValue);
    (0, $56aMA.useFormValidation)({
        validationBehavior: validationBehavior
    }, state, ref);
    let descriptionProps = (0, $czVXo.useSlotId2)();
    return {
        labelProps: (0, $lhKAD.mergeProps)(labelProps, (0, $eF4cA.useMemo)(()=>({
                onClick: (e)=>e.preventDefault(),
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: (0, $lhKAD.mergeProps)(domProps, {
            ...interactions,
            type: 'radio',
            name: name,
            form: form,
            tabIndex: tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === 'native',
            checked: checked,
            value: value,
            onChange: onChange,
            'aria-describedby': [
                props['aria-describedby'],
                descriptionProps.id,
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }),
        descriptionProps: descriptionProps,
        isDisabled: isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}


var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $6pgkA = parcelRequire("6pgkA");

var $7ByPJ = parcelRequire("7ByPJ");

var $lhKAD = parcelRequire("lhKAD");


var $cI1qR = parcelRequire("cI1qR");

var $i1DSg = parcelRequire("i1DSg");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5cd2be82a7a5c613$export$62b9571f283ff5c2(props, state) {
    let { name: name, form: form, isReadOnly: isReadOnly, isRequired: isRequired, isDisabled: isDisabled, orientation: orientation = 'vertical', validationBehavior: validationBehavior = 'aria' } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        onBlurWithin (e) {
            props.onBlur?.(e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    function getNextElement(nextDir, e) {
        let walker = (0, $6pgkA.getFocusableTreeWalker)(e.currentTarget, {
            from: (0, $fvyIQ.getEventTarget)(e),
            accept: (node)=>node instanceof (0, $7ByPJ.getOwnerWindow)(node).HTMLInputElement && node.type === 'radio'
        });
        let nextElem;
        if (nextDir === 'next') {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
            return true;
        }
        return false;
    }
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            ArrowRight: (e)=>{
                let nextDir = direction === 'rtl' && orientation !== 'vertical' ? 'prev' : 'next';
                return getNextElement(nextDir, e);
            },
            ArrowLeft: (e)=>{
                let nextDir = direction === 'rtl' && orientation !== 'vertical' ? 'next' : 'prev';
                return getNextElement(nextDir, e);
            },
            ArrowDown: (e)=>{
                return getNextElement('next', e);
            },
            ArrowUp: (e)=>{
                return getNextElement('prev', e);
            }
        },
        allowRepeats: true
    });
    let groupName = (0, $25dFS.useId)(name);
    (0, $9032f1114e493871$export$37b65e5b5444d35c).set(state, {
        name: groupName,
        form: form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    return {
        radioGroupProps: (0, $lhKAD.mergeProps)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: 'radiogroup',
            ...keyboardProps,
            'aria-invalid': state.isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            'aria-disabled': isDisabled || undefined,
            'aria-orientation': orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}



var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $iEwfj = parcelRequire("iEwfj");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d4ded92572cc0e44$var$$384704861d32dbed$var$instance = Math.round(Math.random() * 10000000000);
let $d4ded92572cc0e44$var$$384704861d32dbed$var$i = 0;
function $d4ded92572cc0e44$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, $eF4cA.useMemo)(()=>props.name || `radio-group-${$d4ded92572cc0e44$var$$384704861d32dbed$var$instance}-${++$d4ded92572cc0e44$var$$384704861d32dbed$var$i}`, [
        props.name
    ]);
    let [selectedValue, setSelected] = (0, $iUErx.useControlledState)(props.value, props.defaultValue ?? null, props.onChange);
    let [initialValue] = (0, $eF4cA.useState)(selectedValue);
    let [lastFocusedValue, setLastFocusedValue] = (0, $eF4cA.useState)(null);
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    return {
        ...validation,
        name: name,
        selectedValue: selectedValue,
        defaultSelectedValue: props.value !== undefined ? initialValue : props.defaultValue ?? null,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? 'invalid' : null),
        isInvalid: isInvalid
    };
}



var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $26CkO = parcelRequire("26CkO");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5698ee293d65c5b6$export$a79eda4ff50e30b6 = (0, $eF4cA.createContext)(null);
const $5698ee293d65c5b6$export$b118023277d4a5c3 = (0, $eF4cA.createContext)(null);
const $5698ee293d65c5b6$export$29c6814b341e632b = (0, $eF4cA.createContext)(null);
const $5698ee293d65c5b6$export$29d84393af70866c = (0, $eF4cA.createContext)(null);
const $5698ee293d65c5b6$export$a98f0dcb43a68a25 = (0, $eF4cA.forwardRef)(function RadioGroup(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $5698ee293d65c5b6$export$a79eda4ff50e30b6);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $d4ded92572cc0e44$export$bca9d026f8e704eb)({
        ...props,
        validationBehavior: validationBehavior
    });
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { radioGroupProps: radioGroupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $5cd2be82a7a5c613$export$62b9571f283ff5c2)({
        ...props,
        label: label,
        validationBehavior: validationBehavior
    }, state);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            orientation: props.orientation || 'vertical',
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: state.isRequired,
            isInvalid: state.isInvalid,
            state: state
        },
        defaultClassName: 'react-aria-RadioGroup'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, radioGroupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'vertical',
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $5698ee293d65c5b6$export$29d84393af70866c,
                state
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, renderProps.children)));
});
const $5698ee293d65c5b6$export$d7b12c4107be0d61 = (0, $eF4cA.forwardRef)(function Radio(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $fDYaM.useContextProps)(otherProps, ref, $5698ee293d65c5b6$export$b118023277d4a5c3);
    let state = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($5698ee293d65c5b6$export$29d84393af70866c);
    let inputRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let aria = (0, $e5e6af279c3473c4$export$37b0961d2f4751e2)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($5698ee293d65c5b6$var$$fe21c36db05242bb$var$InternalRadioContext.Provider, {
        value: {
            ...aria,
            inputRef: inputRef,
            defaultClassName: 'react-aria-Radio'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($5698ee293d65c5b6$export$f4422ae58352e179, {
        ...props,
        ref: ref
    }));
});
const $5698ee293d65c5b6$var$$fe21c36db05242bb$var$InternalRadioContext = (0, $eF4cA.createContext)(null);
const $5698ee293d65c5b6$export$4aaf0c609b3e241e = (0, $eF4cA.forwardRef)(function RadioField(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $fDYaM.useContextProps)(otherProps, ref, $5698ee293d65c5b6$export$29c6814b341e632b);
    let state = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($5698ee293d65c5b6$export$29d84393af70866c);
    let inputRef = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let aria = (0, $e5e6af279c3473c4$export$37b0961d2f4751e2)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    let { descriptionProps: descriptionProps, isSelected: isSelected, isDisabled: isDisabled } = aria;
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-RadioField',
        values: {
            isSelected: isSelected,
            isDisabled: isDisabled,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isRequired: state.isRequired
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $hUj7u.SelectionIndicatorContext),
                {
                    isSelected: isSelected
                }
            ],
            [
                $5698ee293d65c5b6$var$$fe21c36db05242bb$var$InternalRadioContext,
                {
                    ...aria,
                    inputRef: inputRef,
                    defaultClassName: 'react-aria-RadioButton'
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps
                    }
                }
            ]
        ]
    }, renderProps.children));
});
const $5698ee293d65c5b6$export$f4422ae58352e179 = (0, $eF4cA.forwardRef)(function RadioButton(props, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isPressed: isPressed, defaultClassName: defaultClassName, inputRef: inputRef } = (0, $eF4cA.useContext)($5698ee293d65c5b6$var$$fe21c36db05242bb$var$InternalRadioContext);
    let state = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($5698ee293d65c5b6$export$29d84393af70866c);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let interactionDisabled = isDisabled || state.isReadOnly;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...props,
        isDisabled: interactionDisabled
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: defaultClassName,
        values: {
            isSelected: isSelected,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isRequired: state.isRequired
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).label, {
        ...(0, $lhKAD.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
        ...(0, $lhKAD.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
});



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2193ca5c8653fd3e$export$a79eda4ff50e30b6 = (0, $eF4cA.createContext)(null);
const $2193ca5c8653fd3e$export$a98f0dcb43a68a25 = (0, $eF4cA.forwardRef)(function RadioGroup(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $2193ca5c8653fd3e$export$a79eda4ff50e30b6);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props = (0, $j3pTw.useFormProps)(props);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { label: label, description: description, errorMessage: errorMessage, children: children, isEmphasized: isEmphasized, labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', necessityIndicator: necessityIndicator = 'icon', size: size = 'M', orientation: orientation = 'vertical', UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, ...groupProps } = props;
    return (0, $dx4lB.jsx)((0, $5698ee293d65c5b6$export$a98f0dcb43a68a25), {
        ...groupProps,
        orientation: orientation,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVxyPec182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            size: size,
            labelPosition: labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        isQuiet: true,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr182';
                            rules += ' yXcEWr182';
                            rules += ' BXcEWr182';
                            rules += ' AXcEWr182';
                            rules += ' sd182';
                            if (props.orientation === "horizontal") rules += ' _tc182';
                            else if (props.orientation === "vertical") rules += ' _ta182';
                            if (props.orientation === "horizontal") rules += ' _wb182';
                            rules += ' ql182';
                            rules += ' UgOnRt182';
                            return rules;
                        }({
                            orientation: orientation
                        }),
                        children: (0, $dx4lB.jsx)((0, $j3pTw.FormContext).Provider, {
                            value: {
                                ...formContext,
                                size: size,
                                isEmphasized: isEmphasized
                            },
                            children: children
                        })
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        showErrorIcon: true,
                        children: errorMessage
                    })
                ]
            })
    });
});
const $2193ca5c8653fd3e$var$$9a2afae66771094f$var$radioField = function anonymous(props, overrides) {
    let rules = " ";
    let gridColumnStart = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "z") gridColumnStart = true;
        rules += p[0];
    }
    rules += ' se182';
    if (props.isNoVisibleLabel) rules += ' DtyCQZ182';
    else rules += ' DE5iebb182';
    rules += ' qf182';
    rules += ' _ch182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "XL") rules += ' pt182';
    else if (props.size === "L") rules += ' pt182';
    else if (props.size === "S") rules += ' pt182';
    else if (props.size === "XS") rules += ' pt182';
    else rules += ' pt182';
    if (props.size === "XL") rules += ' -BhX7R-Fz182';
    else if (props.size === "L") rules += ' -BhX7R-Fv182';
    else if (props.size === "S") rules += ' -BhX7R-Fp182';
    else if (props.size === "XS") rules += ' -BhX7R-Fn182';
    else rules += ' -BhX7R-Fx182';
    if (props.size === "XL") rules += ' Ua182';
    else if (props.size === "L") rules += ' Ua182';
    else if (props.size === "M") rules += ' Uai5a0182';
    else if (props.size === "S") rules += ' Uai5a0182';
    if (props.isInForm) {
        if (!gridColumnStart) rules += ' zhJUGr182';
    }
    return rules;
};
const $2193ca5c8653fd3e$var$$9a2afae66771094f$var$wrapper = function anonymous(props) {
    let rules = " ";
    rules += ' se182';
    rules += ' DLwlgod182';
    rules += ' z2mU182';
    rules += ' yzZKy182';
    rules += ' _Pc182';
    rules += ' ea182';
    rules += ' Yc182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' __ca182';
    return rules;
};
const $2193ca5c8653fd3e$var$$9a2afae66771094f$var$circle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") rules += ' Zm182';
    else if (props.size === "L") rules += ' Zl182';
    else if (props.size === "S") rules += ' Zk182';
    else rules += ' Zu182';
    rules += ' FRuFGYc182';
    rules += ' _va182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' _jf182';
    rules += ' _oa182';
    if (props.isSelected) rules += ' _kUXU7p182';
    else rules += ' _k7m7Gv182';
    if (props.isSelected) rules += ' hUXU7p182';
    else rules += ' h7m7Gv182';
    if (props.isSelected) rules += ' mUXU7p182';
    else rules += ' m7m7Gv182';
    if (props.isSelected) rules += ' lUXU7p182';
    else rules += ' l7m7Gv182';
    rules += ' _yb182';
    rules += ' gX182';
    if (props.isDisabled) {
        rules += ' io182';
        rules += ' ilc182';
    } else if (props.isInvalid) {
        if (props.isPressed) rules += ' im182';
        else if (props.isFocusVisible) rules += ' im182';
        else if (props.isHovered) rules += ' im182';
        else rules += ' ip182';
        rules += ' ile182';
    } else if (props.isSelected) {
        if (props.isEmphasized) {
            if (props.isPressed) rules += ' iu182';
            else if (props.isFocusVisible) rules += ' iu182';
            else if (props.isHovered) rules += ' iu182';
            else rules += ' iw182';
        }
        rules += ' ild182';
    } else {
        if (props.isPressed) rules += ' in182';
        else if (props.isFocusVisible) rules += ' in182';
        else if (props.isHovered) rules += ' in182';
        else rules += ' iv182';
        rules += ' ila182';
    }
    if (props.size === "XL") rules += ' -F_-Fn182';
    else if (props.size === "L") rules += ' -F_-Fm182';
    else if (props.size === "S") rules += ' -F_-Fl182';
    else rules += ' -F_-Ft182';
    return rules;
};
const $2193ca5c8653fd3e$var$$9a2afae66771094f$var$smallerSize = {
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const $2193ca5c8653fd3e$export$d7b12c4107be0d61 = (0, $eF4cA.forwardRef)(function Radio(props, ref) {
    let { children: children, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style } = props;
    let circleRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null);
    let domRef = (0, $3PqDc.useFocusableRef)(ref, inputRef);
    let isInForm = !!(0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    let { size: size = 'M', ...allProps } = (0, $j3pTw.useFormProps)(props);
    return (0, $dx4lB.jsx)((0, $5698ee293d65c5b6$export$4aaf0c609b3e241e), {
        ...allProps,
        ref: domRef,
        inputRef: inputRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + $2193ca5c8653fd3e$var$$9a2afae66771094f$var$radioField({
                ...renderProps,
                isInForm: isInForm,
                size: size,
                isNoVisibleLabel: !children
            }, allProps.styles),
        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $5698ee293d65c5b6$export$f4422ae58352e179), {
                        className: (renderProps)=>$2193ca5c8653fd3e$var$$9a2afae66771094f$var$wrapper({
                                ...renderProps,
                                isInForm: isInForm,
                                size: size
                            }),
                        children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                                        children: (0, $dx4lB.jsx)("div", {
                                            ref: circleRef,
                                            style: (0, $i93Vd.pressScale)(circleRef)(renderProps),
                                            className: $2193ca5c8653fd3e$var$$9a2afae66771094f$var$circle({
                                                ...renderProps,
                                                isEmphasized: allProps.isEmphasized,
                                                isSelected: renderProps.isSelected,
                                                size: size
                                            })
                                        })
                                    }),
                                    children
                                ]
                            })
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: $2193ca5c8653fd3e$var$$9a2afae66771094f$var$smallerSize[size],
                        styles: " z3mU182 Td182",
                        isDisabled: renderProps.isDisabled,
                        description: props.description
                    })
                ]
            })
    });
});


var $j8RRT = parcelRequire("j8RRT");

var $8Ogg5 = parcelRequire("8Ogg5");
const $651056028f5b77ca$export$93a2459aafaa6512 = ({ isOpen: isOpen, sfType: sfType, onSfTypeChange: onSfTypeChange, accountName: accountName, onAccountNameChange: onAccountNameChange, drNumbers: drNumbers, drNumbersFilter: drNumbersFilter, onDrNumbersFilterChange: onDrNumbersFilterChange, drNumber: drNumber, onDrNumbersSelectionChange: onDrNumbersSelectionChange, onCancel: onCancel, onContinue: onContinue })=>{
    const isContinueDisabled = sfType === "drNumber" && !drNumber || sfType === "accountName" && !accountName;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
        onDismiss: onCancel,
        children: isOpen && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $7uz0i.Dialog), {
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    slot: "title",
                    children: "Account details"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                            children: "Enter DR Number or Account Name to track the account details or select \u201CNone\u201D if not applicable."
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2193ca5c8653fd3e$export$a98f0dcb43a68a25), {
                                    "aria-label": "DR Number / Account Name",
                                    value: sfType,
                                    onChange: onSfTypeChange,
                                    orientation: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2193ca5c8653fd3e$export$d7b12c4107be0d61), {
                                            value: "accountName",
                                            children: "DR Number / Account"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2193ca5c8653fd3e$export$d7b12c4107be0d61), {
                                            value: "none",
                                            children: "None"
                                        })
                                    ]
                                }),
                                sfType === "drNumber" && drNumbers && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBox), {
                                    label: "DR Number",
                                    description: "Type at least 3 characters of a deal name or enter full DR number.",
                                    isRequired: true,
                                    items: drNumbers.data || [],
                                    loadingState: (0, $8Ogg5.getQueryLoadingState)(drNumbers),
                                    inputValue: drNumbersFilter,
                                    onInputChange: onDrNumbersFilterChange,
                                    selectedKey: drNumber,
                                    onSelectionChange: onDrNumbersSelectionChange,
                                    menuWidth: 540,
                                    children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBoxItem), {
                                            id: item.id,
                                            textValue: `${item.drNumber} \u{2014} ${item.name}`,
                                            children: `${item.drNumber} \u{2014} ${item.name}`
                                        })
                                }),
                                sfType === "accountName" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                    "aria-label": "Account Name",
                                    // description="Type the full account name."
                                    isRequired: true,
                                    value: accountName,
                                    onChange: onAccountNameChange
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "secondary",
                            onPress: onCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            isDisabled: isContinueDisabled,
                            onPress: onContinue,
                            children: "Continue"
                        })
                    ]
                })
            ]
        })
    });
};
$651056028f5b77ca$export$93a2459aafaa6512.propTypes = {
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    sfType: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onSfTypeChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    accountName: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onAccountNameChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    // Optional — only needed when the (currently disabled) DR Number option is used.
    drNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    drNumbersFilter: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onDrNumbersFilterChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    drNumber: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onDrNumbersSelectionChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onContinue: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};



var $dx4lB = parcelRequire("dx4lB");

var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $3YPmU = parcelRequire("3YPmU");
const $c82acbccad2c75af$export$595d810d6c5fe5a4 = ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
        textValue: "Placeholder",
        size: "L",
        variant: "quiet",
        styles: " Za182 Fb182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
            styles: " _cb182 _Da182 pv182 g2clXAd182 ob182 nb182 kb182 jb182 fZaSpn182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    slot: "title",
                    styles: " p40ub4c182",
                    children: "We're just getting started"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    slot: "description",
                    styles: " p40ub4c182",
                    children: "More experiences coming soon"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                    href: "https://adobe.enterprise.slack.com/docs/T025FJ55H/F0BMM363EBU",
                    target: "_blank",
                    variant: "secondary",
                    isStandalone: true,
                    UNSAFE_className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-a182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182 Jv182",
                    children: "Learn more"
                })
            ]
        })
    });


const $e1b5010755d49b5f$var$RECENT_VIDEOS_LIMIT = 6;
const $e1b5010755d49b5f$export$318ffe1a9c370f63 = ({ children: children })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const [searchParams, setSearchParams] = (0, $dqZbZ.useSearchParams)();
    const videos = (0, $ikOQe.useVideos)({
        pageSize: $e1b5010755d49b5f$var$RECENT_VIDEOS_LIMIT
    });
    const defaultTemplates = (0, $ikOQe.useVideoTemplates)({
        type: [
            "express",
            "mogrt"
        ]
    });
    const modularTemplates = (0, $ikOQe.useVideoTemplates)({
        type: "modular"
    });
    const htmlTemplates = (0, $ikOQe.useVideoTemplates)({
        type: "html"
    });
    // The account-details flow is entirely URL-driven so it survives refreshes and
    // can be deep-linked (e.g. `/?template=<id>&flow=video&sfType=accountName`).
    const selectedTemplateKey = searchParams.get("template");
    const flow = searchParams.get("flow");
    const sfType = searchParams.get("sfType") ?? "accountName";
    const accountName = searchParams.get("accountName") ?? "";
    const drNumber = searchParams.get("drNumber") ?? "";
    const isAccountDialogOpen = !!selectedTemplateKey;
    const patchParams = (0, $eF4cA.useCallback)((updates)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            for (const [key, value] of Object.entries(updates))if (value == null || value === "") next.delete(key);
            else next.set(key, value);
            return next;
        }, {
            replace: true
        });
    }, [
        setSearchParams
    ]);
    const handleCardPress = (0, $eF4cA.useCallback)(({ id: id, videoPath: videoPath, templateId: templateId })=>{
        if (!videoPath) {
            navigate((0, $ikOQe.getNewVideoPath)(id));
            return;
        }
        navigate(`/projects/${id}`);
    }, [
        navigate
    ]);
    // Selecting a template opens the account-details dialog in place (no redirect),
    // recording the choice in the URL. `flow` tracks which wizard to continue to.
    const handleTemplateSelect = (0, $eF4cA.useCallback)((flowType)=>(keys)=>{
            const [templateKey] = keys;
            if (!templateKey) return;
            patchParams({
                template: templateKey,
                flow: flowType,
                sfType: "accountName",
                accountName: null,
                drNumber: null
            });
        }, [
        patchParams
    ]);
    const handleAccountDialogCancel = (0, $eF4cA.useCallback)(()=>{
        patchParams({
            template: null,
            flow: null,
            sfType: null,
            accountName: null,
            drNumber: null
        });
    }, [
        patchParams
    ]);
    // Hand the collected template + account details off to the wizard as query
    // params so it can start past template selection (and account details).
    const handleAccountDialogContinue = (0, $eF4cA.useCallback)(()=>{
        let path;
        switch(flow){
            case "modular":
                path = "/projects/composer";
                break;
            case "story":
                path = "/stories/new";
                break;
            default:
                path = "/projects/new";
                break;
        }
        const params = new URLSearchParams();
        params.set("template", selectedTemplateKey);
        params.set("sfType", sfType);
        if (accountName) params.set("accountName", accountName);
        if (drNumber) params.set("drNumber", drNumber);
        navigate(`${path}?${params.toString()}`);
    }, [
        navigate,
        flow,
        selectedTemplateKey,
        sfType,
        accountName,
        drNumber
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 eb182 _Ce182 Ts182 Qs182 Sh182 Rh182 JM182 GM182 _oa182 Mb182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " sd182 _ta182 Ue182 qe182 IA182 HA182 eb182 _Wa182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    level: 1,
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 uok182 uocJ9TBTb182 uod3Euai182 uoea182 uogb182 uohd182 uoje182 uo2NhKxcl182 uoic182 -_6BNtrc-lcY1Ce182 vx182 -_6BNtrc-osnabcc182 vox182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 xoe182 _xoa182 xoX0cczbd182 _xoX0cczba182 xofe182 _xofa182 xofX0cczbd182 _xofX0cczba182 _F2mU182 po182 poo182 Jy182 GA182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: " sb182 eb182 Ue182 qe182",
                        children: "Create video sizzle reels for your customers \u2013 in minutes."
                    })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 eb182 Uu182 qu182 Za182 L6AC4Sb182 IM182 HM182 JK182 Qo182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 Na182 _vb182 La182 IM182 HM182 Ul182 ql182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jv182 Gv182",
                                children: [
                                    "Start from the template",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("wbr", {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 Ix182",
                                        children: "that best fits your message"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $959bbd0e20257a0c$export$b768bbdb9877477), {
                                templates: defaultTemplates,
                                emptyStateMessage: "No templates found",
                                selectedTemplateKey: flow === "modular" ? null : selectedTemplateKey,
                                onSelectionChange: handleTemplateSelect("video"),
                                orientation: "horizontal",
                                showScrollArrows: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _tb182 _tnc182 ed182 Na182 _vb182 La182 IM182 HM182 Ur182 qr182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 Na182 _vb182 La182 IM182 HM182 Ul182 ql182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 eb182 Ue182 qe182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5mvex.ContextualHelp), {
                                                variant: "info",
                                                size: "S",
                                                placement: "top start",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Video Composer"
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                                size: "XS",
                                                                variant: "yellow",
                                                                styles: " Iv182",
                                                                UNSAFE_className: " _5g182 oa182 na182 ka182 ja182",
                                                                UNSAFE_style: {
                                                                    paddingInlineStart: "calc(0.375rem * var(--s2-scale))",
                                                                    paddingInlineEnd: "calc(0.375rem * var(--s2-scale))",
                                                                    display: "inline-flex"
                                                                },
                                                                children: "Alpha"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            children: "Brand new script, unique video. Made for your Customer."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Footer), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "It's experimental \u2014 try it, break it, shape what's next."
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                                                                orientation: "vertical",
                                                                styles: " JC182",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                                        href: "https://f.io/0NSot_uj",
                                                                        target: "_blank",
                                                                        variant: "secondary",
                                                                        isStandalone: true,
                                                                        children: "Watch demo video"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                                        href: "https://f.io/TxN9A3Q4",
                                                                        target: "_blank",
                                                                        variant: "secondary",
                                                                        isStandalone: true,
                                                                        children: "See output examples"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                                        href: "slack://channel?team=E23RE8G4F&id=C095CSV0N0Z",
                                                                        target: "_blank",
                                                                        variant: "secondary",
                                                                        isStandalone: true,
                                                                        children: "Share your thoughts"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                                                styles: " sh182 _ta182 _tnc182 Uh182 qh182 ea182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jv182 Gv182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                        styles: " _7c182",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Video Composer"
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                                size: "XS",
                                                                variant: "yellow",
                                                                styles: " Iv182",
                                                                UNSAFE_className: " _5g182 oa182 na182 ka182 ja182",
                                                                UNSAFE_style: {
                                                                    paddingInlineStart: "calc(0.375rem * var(--s2-scale))",
                                                                    paddingInlineEnd: "calc(0.375rem * var(--s2-scale))",
                                                                    display: "inline-flex"
                                                                },
                                                                children: "Alpha"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 Ix182",
                                                        children: [
                                                            "try out what's coming next and",
                                                            " ",
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                                href: "slack://channel?team=E23RE8G4F&id=C095CSV0N0Z",
                                                                target: "_blank",
                                                                variant: "secondary",
                                                                children: "share your feedback"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " _oa182 _Nc182 Pc182 ZpJ182 Zd182 Lpa182 L2ongWb182 Th182 Sh182 Rh182 oe182 ne182 ke182 je182 g2clXAd182 _kb182 hb182 mb182 lb182 i0slXAd182 _jf182 Ipy182 Il182 Hpy182 Hl182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $959bbd0e20257a0c$export$b768bbdb9877477), {
                                            templates: modularTemplates,
                                            emptyStateMessage: "No templates found",
                                            selectedTemplateKey: flow === "modular" ? selectedTemplateKey : null,
                                            onSelectionChange: handleTemplateSelect("modular"),
                                            placeholder: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c82acbccad2c75af$export$595d810d6c5fe5a4), {}),
                                            orientation: "horizontal"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 _vb182 La182 IM182 HM182 Ul182 ql182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                                        styles: " sd182 _ta182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jv182 Gv182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                styles: " sh182 ed182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 Hx182",
                                                children: [
                                                    "Try out the new ",
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ab0f66b034da7456$export$2e2bcd8739ae039), {
                                                        styles: " Is182"
                                                    }),
                                                    " ",
                                                    "Figma"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("wbr", {}),
                                            "One Adobe template"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $959bbd0e20257a0c$export$b768bbdb9877477), {
                                        templates: htmlTemplates,
                                        emptyStateMessage: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: " sd182 _ta182 Ub182 qb182",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Coming soon!"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                                    children: [
                                                        "Join",
                                                        " ",
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                            href: "slack://channel?team=E23RE8G4F&id=C095CSV0N0Z",
                                                            target: "_blank",
                                                            variant: "secondary",
                                                            children: "#bestory-community"
                                                        }),
                                                        " ",
                                                        "to get notified!"
                                                    ]
                                                })
                                            ]
                                        }),
                                        emptyStateIcon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d1d49e40e1c5d96c$export$2e2bcd8739ae039), {}),
                                        emptyStateSize: "S",
                                        selectedTemplateKey: null,
                                        onSelectionChange: handleTemplateSelect("story"),
                                        orientation: "vertical"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 Ue182 qe182 Za182 Lq63t7c182 IM182 HM182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ug182 qg182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182",
                                        children: "Recent projects"
                                    }),
                                    !!videos.data?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                        textValue: "All projects",
                                        isQuiet: true,
                                        onPress: ()=>navigate("/projects"),
                                        children: "View all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " FpVWeVc182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $08f113aefb328d35$export$99bffacbdbcb5195), {
                                    limit: $e1b5010755d49b5f$var$RECENT_VIDEOS_LIMIT,
                                    selectionMode: "single",
                                    onCardPress: handleCardPress,
                                    renderEmptyState: ()=>videos.isSuccess ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                            size: "S",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e76bf3a4cae7a571$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                                    children: "Nothing Created So Far"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                                    children: "You haven't made any projects yet\u2014start your first one now!"
                                                })
                                            ]
                                        }) : null,
                                    styles: " _oa182 Id182 Hd182"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $651056028f5b77ca$export$93a2459aafaa6512), {
                isOpen: isAccountDialogOpen,
                sfType: sfType,
                onSfTypeChange: (value)=>patchParams({
                        sfType: value,
                        accountName: null,
                        drNumber: null
                    }),
                accountName: accountName,
                onAccountNameChange: (value)=>patchParams({
                        accountName: value
                    }),
                onCancel: handleAccountDialogCancel,
                onContinue: handleAccountDialogContinue
            }),
            children
        ]
    });
};
$e1b5010755d49b5f$export$318ffe1a9c370f63.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $91SAk = parcelRequire("91SAk");

var $VXM1R = parcelRequire("VXM1R");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");


var $f16Ml = parcelRequire("f16Ml");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fVfXf = parcelRequire("fVfXf");

var $jrZXQ = parcelRequire("jrZXQ");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $62173499bdf6ab25$export$4f18251748129091 = (0, $eF4cA.createContext)(null);
const $62173499bdf6ab25$var$$85e1de65a7290f4a$var$avatar = " I4gnV8d182 Iby182";
const $62173499bdf6ab25$var$$85e1de65a7290f4a$var$text = function anonymous(props) {
    let rules = " ";
    rules += ' Iv182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' _Yb182';
    rules += ' _7c182';
    if (props.size === "40") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "36") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "32") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "28") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "24") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "20") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "16") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "40") {
        rules += ' -_6BNtrc-g182';
        rules += ' vx182';
    } else if (props.size === "36") {
        rules += ' -_6BNtrc-f182';
        rules += ' vx182';
    } else if (props.size === "32") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "28") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "24") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "20") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "16") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    }
    if (props.size === "40") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "36") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "32") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "28") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "24") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "20") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "16") {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "40") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "36") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "32") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "28") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "24") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "20") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "16") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.size === "40") rules += ' pt182';
    else if (props.size === "36") rules += ' pt182';
    else if (props.size === "32") rules += ' pt182';
    else if (props.size === "28") rules += ' pt182';
    else if (props.size === "24") rules += ' pt182';
    else if (props.size === "20") rules += ' pt182';
    else if (props.size === "16") rules += ' pt182';
    return rules;
};
const $62173499bdf6ab25$var$$85e1de65a7290f4a$var$container = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6)[^\s]+/g) || []).join('');
    rules += ' sd182';
    rules += ' eb182';
    return rules;
};
const $62173499bdf6ab25$export$5b26ebaf2b105908 = (0, $eF4cA.forwardRef)(function AvatarGroup(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $62173499bdf6ab25$export$4f18251748129091);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { children: children, label: label, size: size = 24, styles: styles, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, ...otherProps } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $jrZXQ.useLabel)({
        ...props,
        labelElementType: 'span'
    });
    return (0, $dx4lB.jsx)((0, $f16Ml.AvatarContext).Provider, {
        value: {
            styles: $62173499bdf6ab25$var$$85e1de65a7290f4a$var$avatar,
            size: size,
            isOverBackground: true
        },
        children: (0, $dx4lB.jsxs)("div", {
            ref: domRef,
            ...(0, $fVfXf.filterDOMProps)(otherProps),
            ...fieldProps,
            role: "group",
            className: (UNSAFE_className ?? '') + $62173499bdf6ab25$var$$85e1de65a7290f4a$var$container(null, styles),
            style: {
                ...UNSAFE_style,
                '--size': size / 16 + 'rem'
            },
            children: [
                children,
                label && (0, $dx4lB.jsx)("span", {
                    ...labelProps,
                    className: $62173499bdf6ab25$var$$85e1de65a7290f4a$var$text({
                        size: String(size)
                    }),
                    children: label
                })
            ]
        })
    });
});


var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");

var $j2JDe = parcelRequire("j2JDe");
var $bEes0 = parcelRequire("bEes0");

var $lhKAD = parcelRequire("lhKAD");

var $dqZbZ = parcelRequire("dqZbZ");

var $dx4lB = parcelRequire("dx4lB");

var $f16Ml = parcelRequire("f16Ml");

var $eF4cA = parcelRequire("eF4cA");

var $8Ogg5 = parcelRequire("8Ogg5");
function $782edebb76e7c4bc$export$3130a221321c15ca(persona) {
    const fallbackUrl = "https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png";
    const [avatarUrl, setAvatarUrl] = (0, $eF4cA.useState)(fallbackUrl);
    (0, $eF4cA.useEffect)(()=>{
        let mounted = true;
        const loadAvatarUrl = async ()=>{
            try {
                const url = (0, $8Ogg5.getAvatarUrl)(persona);
                // Check if getAvatarUrl returned a Promise
                const resolvedUrl = url instanceof Promise ? await url : url;
                if (mounted) setAvatarUrl(resolvedUrl || fallbackUrl);
            } catch (error) {
                console.error("Error loading avatar URL:", error);
                if (mounted) setAvatarUrl(fallbackUrl);
            }
        };
        if (persona) loadAvatarUrl();
        else setAvatarUrl(fallbackUrl);
        return ()=>{
            mounted = false;
        };
    }, [
        persona,
        fallbackUrl
    ]);
    return avatarUrl;
}
function $782edebb76e7c4bc$export$2427d38ef09c0c42(visual) {
    const fallbackUrl = "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png";
    const [visualUrl, setVisualUrl] = (0, $eF4cA.useState)(fallbackUrl);
    (0, $eF4cA.useEffect)(()=>{
        let mounted = true;
        const loadVisualUrl = async ()=>{
            try {
                const url = (0, $8Ogg5.getVisualUrl)(visual);
                // Check if getVisualUrl returned a Promise
                const resolvedUrl = url instanceof Promise ? await url : url;
                if (mounted) setVisualUrl(resolvedUrl || fallbackUrl);
            } catch (error) {
                console.error("Error loading visual URL:", error);
                if (mounted) setVisualUrl(fallbackUrl);
            }
        };
        if (visual) loadVisualUrl();
        else setVisualUrl(fallbackUrl);
        return ()=>{
            mounted = false;
        };
    }, [
        visual,
        fallbackUrl
    ]);
    return visualUrl;
}



var $9eyCh = parcelRequire("9eyCh");
const $2bffda9db2261f28$export$3cf67ed17f3a3c34 = ({ persona: persona, alt: alt, ...rest })=>{
    const avatarUrl = (0, $782edebb76e7c4bc$export$3130a221321c15ca)(persona);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
        src: avatarUrl,
        alt: alt || persona?.name,
        ...rest
    });
};
$2bffda9db2261f28$export$3cf67ed17f3a3c34.propTypes = {
    persona: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    alt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



var $8Ogg5 = parcelRequire("8Ogg5");
const $6fc8a992395df526$export$c8bdea047183079f = ({ storyId: storyId, story: story, UNSAFE_style: UNSAFE_style })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPress: ()=>{
            navigate(`/stories/${storyId}`);
        }
    });
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    const [isThumbnailPending, startThumbnailTransition] = (0, $eF4cA.useTransition)();
    const [thumbnailUrl, setThumbnailUrl] = (0, $eF4cA.useState)();
    (0, $eF4cA.useEffect)(()=>{
        startThumbnailTransition(async ()=>{
            const url = await (0, $8Ogg5.getVisualUrl)(story?.thumbnail);
            setThumbnailUrl(url);
        });
    }, [
        story?.thumbnail
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " _ua182 _vb182 _sb182",
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
            textValue: story?.title ?? "title",
            variant: "quiet",
            styles: " Za182 NcTxjid182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                    UNSAFE_className: function anonymous(props) {
                        let rules = " ";
                        rules += ' _8d182';
                        if (props.isPressed) rules += ' _ZfOeo9d182';
                        else rules += ' _Zh3TDrc182';
                        return rules;
                    }({
                        isPressed: isPressed
                    }),
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                            isLoaded: !isThumbnailPending,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                src: thumbnailUrl,
                                alt: story?.title ?? "title",
                                styles: " Za182 Fb182 _Hb182 fu4qurc182"
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            ...(0, $lhKAD.mergeProps)(hoverProps, pressProps),
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' Za182';
                                rules += ' Fb182';
                                rules += ' _Pa182';
                                rules += ' Wr182';
                                rules += ' _Er182';
                                rules += ' oc182';
                                rules += ' nc182';
                                rules += ' kc182';
                                rules += ' jc182';
                                rules += ' _Mc182';
                                rules += ' _Kb182';
                                rules += ' _Lf182';
                                if (props.isHovered) rules += ' OOIem5c182';
                                else rules += ' Oj182';
                                rules += ' Ya182';
                                rules += ' Xb182';
                                rules += ' _2b182';
                                return rules;
                            }({
                                isHovered: isHovered
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                    styles: " _ch182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "title",
                            children: story?.title ?? "title"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "description",
                            children: story?.storyOverview ?? story?.industry
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $62173499bdf6ab25$export$5b26ebaf2b105908), {
                        "aria-label": "Story Personas",
                        children: story?.personas?.map((persona, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2bffda9db2261f28$export$3cf67ed17f3a3c34), {
                                persona: persona
                            }, index))
                    })
                })
            ]
        })
    });
};
$6fc8a992395df526$export$c8bdea047183079f.propTypes = {
    storyId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    story: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    UNSAFE_style: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};


const $5d122a3a98a3c1bc$export$2bd3254512ec27f = ({ limit: limit = -1 })=>{
    const stories = (0, $VXM1R.useStories)();
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Stories",
            href: "/stories"
        }
    ]);
    const storiesList = (0, $eF4cA.useMemo)(()=>[
            ...stories?.data ?? []
        ].reverse().filter((item)=>!!item.id).slice(0, limit !== -1 ? limit : stories?.data?.length ?? 0), [
        stories.data
    ]);
    // TODO: add empty states
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _tc182 _wb182 _Cg182 Ul182 ql182 _oa182 Za182 FD182",
        children: [
            stories.isPending && new Array(3).fill(0).map((_, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                    isLoading: true,
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $6fc8a992395df526$export$c8bdea047183079f), {
                        UNSAFE_style: limit !== -1 ? {
                            flexBasis: `calc(100% / ${limit} - 1rem)`
                        } : {
                            flexBasis: 240
                        }
                    })
                }, index)),
            stories.isSuccess && storiesList.map((story)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $6fc8a992395df526$export$c8bdea047183079f), {
                    storyId: story.id,
                    story: story,
                    UNSAFE_style: limit !== -1 ? {
                        flexBasis: `calc(100% / ${limit} - 1rem)`
                    } : {
                        flexBasis: 240
                    }
                }, story.id))
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $5IZkx = parcelRequire("5IZkx");

var $dqZbZ = parcelRequire("dqZbZ");

var $kQhl7 = parcelRequire("kQhl7");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $f16Ml = parcelRequire("f16Ml");

var $4W5AG = parcelRequire("4W5AG");

var $lK44Y = parcelRequire("lK44Y");

var $cxTG4 = parcelRequire("cxTG4");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $72df7913f6af7862$var$$4bb2fe02f5143bcc$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M7.864 15.734c-.222 0-.433-.098-.576-.27l-3.747-4.497c-.266-.319-.222-.792.096-1.057.317-.265.79-.223 1.056.096l3.154 3.786 7.44-9.469c.255-.326.728-.382 1.052-.127.326.256.383.728.127 1.053L8.454 15.447c-.14.179-.352.284-.579.287z"
        })
    });
const $72df7913f6af7862$var$$4bb2fe02f5143bcc$var$ForwardRef = (0, $eF4cA.forwardRef)($72df7913f6af7862$var$$4bb2fe02f5143bcc$var$SvgComponent);
var $72df7913f6af7862$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($72df7913f6af7862$var$$4bb2fe02f5143bcc$var$ForwardRef);



var $hxsf4 = parcelRequire("hxsf4");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $0ca39120f8ac8a03$var$$11111a8204dcac81$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m11.06 10 5.207-5.206c.293-.293.293-.768 0-1.06s-.767-.294-1.06 0L10 8.938 4.793 3.733c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06L8.939 10l-5.206 5.206c-.293.293-.293.768 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.062l5.207 5.206c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.06z"
        })
    });
const $0ca39120f8ac8a03$var$$11111a8204dcac81$var$ForwardRef = (0, $eF4cA.forwardRef)($0ca39120f8ac8a03$var$$11111a8204dcac81$var$SvgComponent);
var $0ca39120f8ac8a03$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($0ca39120f8ac8a03$var$$11111a8204dcac81$var$ForwardRef);



var $arisx = parcelRequire("arisx");

var $88lL9 = parcelRequire("88lL9");

var $bsn7e = parcelRequire("bsn7e");



var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $8wD3p = parcelRequire("8wD3p");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $c24960d0d4b13363$var$$467119b5442fc40b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 9.979,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 9.979,
                cy: 4,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 9.979,
                cy: 16,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            })
        ]
    });
const $c24960d0d4b13363$var$$467119b5442fc40b$var$ForwardRef = (0, $eF4cA.forwardRef)($c24960d0d4b13363$var$$467119b5442fc40b$var$SvgComponent);
var $c24960d0d4b13363$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($c24960d0d4b13363$var$$467119b5442fc40b$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");
const $79a6c2b248cdee5a$var$$1bdd184cd8a3d21d$var$SvgS2MoveHorizontalTableWidget = (props)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: [
            (0, $dx4lB.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, #fff)",
                d: "M10 11.75a.75.75 0 0 1-.53-1.28L11.94 8 9.47 5.53a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-.53.22M6 11.75a.75.75 0 0 1-.53-.22l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 1 1 1.06 1.06L4.06 8l2.47 2.47A.75.75 0 0 1 6 11.75"
            })
        ]
    });
var $79a6c2b248cdee5a$export$2e2bcd8739ae039 = $79a6c2b248cdee5a$var$$1bdd184cd8a3d21d$var$SvgS2MoveHorizontalTableWidget;



var $fZShI = parcelRequire("fZShI");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $0d716ea2abb3d15e$var$$5a632e895c21f138$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M18.28 13.22c-.293-.293-.767-.293-1.06 0L16 14.44V3.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v10.69l-1.22-1.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.5 2.5q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l2.5-2.5c.293-.293.293-.767 0-1.06M7.25 14.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 6.5h-8.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const $0d716ea2abb3d15e$var$$5a632e895c21f138$var$ForwardRef = (0, $eF4cA.forwardRef)($0d716ea2abb3d15e$var$$5a632e895c21f138$var$SvgComponent);
var $0d716ea2abb3d15e$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($0d716ea2abb3d15e$var$$5a632e895c21f138$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $981c4ca4a675355f$var$$415c33109ddcfc45$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m18.28 5.72-2.5-2.5q-.105-.105-.243-.162c-.184-.076-.39-.076-.574 0q-.138.058-.243.162l-2.5 2.5c-.293.293-.293.767 0 1.06s.767.293 1.06 0l1.22-1.22v10.69c0 .414.336.75.75.75s.75-.336.75-.75V5.56l1.22 1.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M7.25 6.5h-4.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 14.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const $981c4ca4a675355f$var$$415c33109ddcfc45$var$ForwardRef = (0, $eF4cA.forwardRef)($981c4ca4a675355f$var$$415c33109ddcfc45$var$SvgComponent);
var $981c4ca4a675355f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($981c4ca4a675355f$var$$415c33109ddcfc45$var$ForwardRef);



var $34HUQ = parcelRequire("34HUQ");


var $3PqDc = parcelRequire("3PqDc");

var $5nuB1 = parcelRequire("5nuB1");

var $e0Enh = parcelRequire("e0Enh");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $k5Pnh = parcelRequire("k5Pnh");

var $ed1Og = parcelRequire("ed1Og");

var $fDYaM = parcelRequire("fDYaM");

var $8dzVy = parcelRequire("8dzVy");

var $cLs8t = parcelRequire("cLs8t");

var $9PmUB = parcelRequire("9PmUB");

var $hJVXE = parcelRequire("hJVXE");

var $hUj7u = parcelRequire("hUj7u");

var $2FPWu = parcelRequire("2FPWu");
const $f0e8aa45449c9c67$var$$808d92ba0ee34db1$var$X_SWITCH_THRESHOLD = 10;
const $f0e8aa45449c9c67$var$$808d92ba0ee34db1$var$Y_SWITCH_THRESHOLD = 5;
class $f0e8aa45449c9c67$export$82c13862611c034e {
    setup(delegate, state, direction) {
        this.delegate = delegate;
        this.state = state;
        this.direction = direction;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        let baseTarget = this.delegate.getDropTargetFromPoint(x, y, isValidDropTarget);
        if (!baseTarget || baseTarget.type === 'root') return baseTarget;
        return this.resolveDropTarget(baseTarget, x, y, isValidDropTarget);
    }
    resolveDropTarget(target, x, y, isValidDropTarget) {
        let tracking = this.pointerTracking;
        // Calculate movement directions
        let deltaY = y - tracking.lastY;
        let deltaX = x - tracking.lastX;
        let currentYMovement = tracking.yDirection;
        let currentXMovement = tracking.xDirection;
        if (Math.abs(deltaY) > $f0e8aa45449c9c67$var$$808d92ba0ee34db1$var$Y_SWITCH_THRESHOLD) {
            currentYMovement = deltaY > 0 ? 'down' : 'up';
            tracking.yDirection = currentYMovement;
            tracking.lastY = y;
        }
        if (Math.abs(deltaX) > $f0e8aa45449c9c67$var$$808d92ba0ee34db1$var$X_SWITCH_THRESHOLD) {
            currentXMovement = deltaX > 0 ? 'right' : 'left';
            tracking.xDirection = currentXMovement;
            tracking.lastX = x;
        }
        // Normalize to 'after'
        if (target.dropPosition === 'before') {
            let keyBefore = this.state.collection.getKeyBefore(target.key);
            while(keyBefore != null){
                let node = this.state.collection.getItem(keyBefore);
                if (node?.type === 'item') break;
                keyBefore = node?.parentKey ?? null;
            }
            if (keyBefore != null) {
                let convertedTarget = {
                    type: 'item',
                    key: keyBefore,
                    dropPosition: 'after'
                };
                if (isValidDropTarget(convertedTarget)) target = convertedTarget;
            }
        }
        let potentialTargets = this.getPotentialTargets(target, isValidDropTarget);
        if (potentialTargets.length === 0) return {
            type: 'root'
        };
        let resolvedItemTarget;
        if (potentialTargets.length > 1) resolvedItemTarget = this.selectTarget(potentialTargets, target, x, y, currentYMovement, currentXMovement);
        else {
            resolvedItemTarget = potentialTargets[0];
            // Reset boundary context since we're not in a boundary case
            tracking.boundaryContext = null;
        }
        return resolvedItemTarget;
    }
    // Returns potential targets for an ambiguous drop position (e.g. after the last child of a parent, or after the parent itself)
    // Ordered by level, from innermost to outermost.
    getPotentialTargets(originalTarget, isValidDropTarget) {
        if (originalTarget.dropPosition === 'on') return [
            originalTarget
        ];
        let target = originalTarget;
        let collection = this.state.collection;
        let currentItem = collection.getItem(target.key);
        while(currentItem && currentItem?.type !== 'item' && currentItem.nextKey != null){
            target.key = currentItem.nextKey;
            currentItem = collection.getItem(currentItem.nextKey);
        }
        let potentialTargets = [
            target
        ];
        // If target has children and is expanded, use "before first child"
        if (currentItem && currentItem.hasChildNodes && this.state.expandedKeys.has(currentItem.key) && collection.getChildren && target.dropPosition === 'after') {
            // Find the first item child (traverse keys directly instead of using collection.getChildren, which may only include cells).
            let firstChildItemNode = currentItem.firstChildKey != null ? collection.getItem(currentItem.firstChildKey) : null;
            while(firstChildItemNode && firstChildItemNode.type !== 'item')firstChildItemNode = firstChildItemNode.nextKey != null ? collection.getItem(firstChildItemNode.nextKey) : null;
            if (firstChildItemNode?.type === 'item') {
                const beforeFirstChildTarget = {
                    type: 'item',
                    key: firstChildItemNode.key,
                    dropPosition: 'before'
                };
                if (isValidDropTarget(beforeFirstChildTarget)) return [
                    beforeFirstChildTarget
                ];
                else return [];
            }
        }
        if (currentItem?.nextKey != null) return [
            originalTarget
        ];
        // Walk up the parent chain to find ancestors that are the last child at their level
        let parentKey = currentItem?.parentKey;
        let ancestorTargets = [];
        while(parentKey != null){
            let parentItem = collection.getItem(parentKey);
            let nextItem = parentItem?.nextKey != null ? collection.getItem(parentItem.nextKey) : null;
            let isLastChildAtLevel = !nextItem || nextItem.parentKey !== parentKey;
            if (isLastChildAtLevel) {
                // Only items can be drop targets. Ancestors such as a Table's <TableBody> or a
                // <TreeSection> are part of the collection, but their keys are generated rather than
                // provided by the user, so dropping "after" them is not something the user can handle.
                if (parentItem?.type === 'item') {
                    let afterParentTarget = {
                        type: 'item',
                        key: parentKey,
                        dropPosition: 'after'
                    };
                    if (isValidDropTarget(afterParentTarget)) ancestorTargets.push(afterParentTarget);
                }
                if (nextItem) break;
            }
            parentKey = parentItem?.parentKey;
        }
        if (ancestorTargets.length > 0) potentialTargets.push(...ancestorTargets);
        // Handle converting "after" to "before next" for non-ambiguous cases
        if (potentialTargets.length === 1) {
            let nextKey = collection.getKeyAfter(target.key);
            let nextNode = nextKey != null ? collection.getItem(nextKey) : null;
            if (nextKey != null && nextNode && currentItem && nextNode.level != null && currentItem.level != null && nextNode.level > currentItem.level) {
                let beforeTarget = {
                    type: 'item',
                    key: nextKey,
                    dropPosition: 'before'
                };
                if (isValidDropTarget(beforeTarget)) return [
                    beforeTarget
                ];
            }
        }
        return potentialTargets.filter(isValidDropTarget);
    }
    selectTarget(potentialTargets, originalTarget, x, y, currentYMovement, currentXMovement) {
        if (potentialTargets.length < 2) return potentialTargets[0];
        let tracking = this.pointerTracking;
        let currentItem = this.state.collection.getItem(originalTarget.key);
        let parentKey = currentItem?.parentKey;
        if (parentKey == null) return potentialTargets[0];
        // More than 1 potential target - use Y for initial target, then X for switching levels
        // Initialize boundary context if needed
        if (!tracking.boundaryContext || tracking.boundaryContext.parentKey !== parentKey) {
            // If entering from below, start with outer-most
            let initialTargetIndex = tracking.yDirection === 'up' ? potentialTargets.length - 1 : 0;
            tracking.boundaryContext = {
                parentKey: parentKey,
                preferredTargetIndex: initialTargetIndex,
                lastSwitchY: y,
                lastSwitchX: x
            };
        }
        let boundaryContext = tracking.boundaryContext;
        let distanceFromLastXSwitch = Math.abs(x - boundaryContext.lastSwitchX);
        let distanceFromLastYSwitch = Math.abs(y - boundaryContext.lastSwitchY);
        // Switch between targets based on Y movement
        if (distanceFromLastYSwitch > $f0e8aa45449c9c67$var$$808d92ba0ee34db1$var$Y_SWITCH_THRESHOLD && currentYMovement) {
            let currentIndex = boundaryContext.preferredTargetIndex || 0;
            if (currentYMovement === 'down' && currentIndex === 0) boundaryContext.preferredTargetIndex = potentialTargets.length - 1;
            else if (currentYMovement === 'up' && currentIndex === potentialTargets.length - 1) boundaryContext.preferredTargetIndex = 0;
            // Reset x tracking so that moving diagonally doesn't cause flickering.
            tracking.xDirection = null;
        }
        // X movement controls level selection
        if (distanceFromLastXSwitch > $f0e8aa45449c9c67$var$$808d92ba0ee34db1$var$X_SWITCH_THRESHOLD && currentXMovement) {
            let currentTargetIndex = boundaryContext.preferredTargetIndex || 0;
            if (currentXMovement === 'left') {
                if (this.direction === 'ltr') {
                    if (currentTargetIndex < potentialTargets.length - 1) {
                        boundaryContext.preferredTargetIndex = currentTargetIndex + 1;
                        boundaryContext.lastSwitchX = x;
                    }
                } else if (currentTargetIndex > 0) {
                    boundaryContext.preferredTargetIndex = currentTargetIndex - 1;
                    boundaryContext.lastSwitchX = x;
                }
            } else if (currentXMovement === 'right') {
                if (this.direction === 'ltr') {
                    if (currentTargetIndex > 0) {
                        boundaryContext.preferredTargetIndex = currentTargetIndex - 1;
                        boundaryContext.lastSwitchX = x;
                    }
                } else if (currentTargetIndex < potentialTargets.length - 1) {
                    boundaryContext.preferredTargetIndex = currentTargetIndex + 1;
                    boundaryContext.lastSwitchX = x;
                }
            }
            // Reset y tracking so that moving diagonally doesn't cause flickering.
            tracking.yDirection = null;
        }
        let targetIndex = Math.max(0, Math.min(boundaryContext.preferredTargetIndex || 0, potentialTargets.length - 1));
        return potentialTargets[targetIndex];
    }
    constructor(){
        this.delegate = null;
        this.state = null;
        this.direction = 'ltr';
        this.pointerTracking = {
            lastY: 0,
            lastX: 0,
            yDirection: null,
            xDirection: null,
            boundaryContext: null
        };
    }
}



var $bWhaY = parcelRequire("bWhaY");

var $f7tr2 = parcelRequire("f7tr2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $77bf58589a3b30dd$export$de3fdf6493c353d {
    constructor(opts){
        this.keyMap = new Map();
        this.keyMap = new Map();
        this.columnCount = opts?.columnCount;
        this.rows = [];
        let visit = (node)=>{
            // If the node is the same object as the previous node for the same key,
            // we can skip this node and its children. We always visit columns though,
            // because we depend on order to build the columns array.
            let prevNode = this.keyMap.get(node.key);
            if (opts.visitNode) node = opts.visitNode(node);
            this.keyMap.set(node.key, node);
            let childKeys = new Set();
            let last = null;
            let rowHasCellWithColSpan = false;
            if (node.type === 'item') {
                for (let child of node.childNodes)if (child.props?.colSpan !== undefined) {
                    rowHasCellWithColSpan = true;
                    break;
                }
            }
            for (let child of node.childNodes){
                if (child.type === 'cell' && rowHasCellWithColSpan) {
                    child.colspan = child.props?.colSpan;
                    child.colSpan = child.props?.colSpan;
                    child.colIndex = !last ? child.index : (last.colIndex ?? last.index) + (last.colSpan ?? 1);
                }
                if (child.type === 'cell' && child.parentKey == null) child.parentKey = node.key;
                childKeys.add(child.key);
                if (last) {
                    last.nextKey = child.key;
                    child.prevKey = last.key;
                } else child.prevKey = null;
                visit(child);
                last = child;
            }
            if (last) last.nextKey = null;
            // Remove deleted nodes and their children from the key map
            if (prevNode) {
                for (let child of prevNode.childNodes)if (!childKeys.has(child.key)) remove(child);
            }
        };
        let remove = (node)=>{
            this.keyMap.delete(node.key);
            for (let child of node.childNodes)if (this.keyMap.get(child.key) === child) remove(child);
        };
        let last = null;
        for (let [i, node] of opts.items.entries()){
            let rowNode = {
                ...node,
                level: node.level ?? 0,
                key: node.key ?? 'row-' + i,
                type: node.type ?? 'row',
                value: node.value ?? null,
                hasChildNodes: true,
                childNodes: [
                    ...node.childNodes
                ],
                rendered: node.rendered,
                textValue: node.textValue ?? '',
                index: node.index ?? i
            };
            if (last) {
                last.nextKey = rowNode.key;
                rowNode.prevKey = last.key;
            } else rowNode.prevKey = null;
            this.rows.push(rowNode);
            visit(rowNode);
            last = rowNode;
        }
        if (last) last.nextKey = null;
    }
    *[Symbol.iterator]() {
        yield* [
            ...this.rows
        ];
    }
    get size() {
        return [
            ...this.rows
        ].length;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey ?? null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey ?? null : null;
    }
    getFirstKey() {
        return [
            ...this.rows
        ][0]?.key;
    }
    getLastKey() {
        let rows = [
            ...this.rows
        ];
        return rows[rows.length - 1]?.key;
    }
    getItem(key) {
        return this.keyMap.get(key) ?? null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return node?.childNodes || [];
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY = 'row-header-column-' + Math.random().toString(36).slice(2);
let $49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY_DRAG = 'row-header-column-' + Math.random().toString(36).slice(2);
while($49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY === $49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY_DRAG)$49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY_DRAG = 'row-header-column-' + Math.random().toString(36).slice(2);
function $49021bac7ed2e468$export$7c127db850d4e81e(keyMap, columnNodes) {
    if (columnNodes.length === 0) return [];
    let columns = [];
    let seen = new Map();
    for (let column of columnNodes){
        let parentKey = column.parentKey;
        let col = [
            column
        ];
        while(parentKey != null){
            let parent = keyMap.get(parentKey);
            if (!parent) break;
            // If we've already seen this parent, than it is shared
            // with a previous column. If the current column is taller
            // than the previous column, than we need to shift the parent
            // in the previous column so it's level with the current column.
            if (seen.has(parent)) {
                parent.colSpan ??= 0;
                parent.colSpan++;
                parent.colspan = parent.colSpan;
                let { column: column, index: index } = seen.get(parent);
                if (index > col.length) break;
                for(let i = index; i < col.length; i++)column.splice(i, 0, null);
                // Adjust shifted indices
                for(let i = col.length; i < column.length; i++)if (column[i] && seen.has(column[i])) seen.get(column[i]).index = i;
            } else {
                parent.colSpan = 1;
                parent.colspan = 1;
                col.push(parent);
                seen.set(parent, {
                    column: col,
                    index: col.length - 1
                });
            }
            parentKey = parent.parentKey;
        }
        columns.push(col);
        column.index = columns.length - 1;
    }
    let maxLength = Math.max(...columns.map((c)=>c.length));
    let headerRows = Array(maxLength).fill(0).map(()=>[]);
    // Convert columns into rows.
    let colIndex = 0;
    for (let column of columns){
        let i = maxLength - 1;
        for (let item of column){
            if (item) {
                // Fill the space up until the current column with a placeholder
                let row = headerRows[i];
                let rowLength = row.reduce((p, c)=>p + (c.colSpan ?? 1), 0);
                if (rowLength < colIndex) {
                    let placeholder = {
                        type: 'placeholder',
                        key: 'placeholder-' + item.key,
                        colspan: colIndex - rowLength,
                        colSpan: colIndex - rowLength,
                        index: rowLength,
                        value: null,
                        rendered: null,
                        level: i,
                        hasChildNodes: false,
                        childNodes: [],
                        textValue: ''
                    };
                    // eslint-disable-next-line max-depth
                    if (row.length > 0) {
                        row[row.length - 1].nextKey = placeholder.key;
                        placeholder.prevKey = row[row.length - 1].key;
                    }
                    row.push(placeholder);
                }
                if (row.length > 0) {
                    row[row.length - 1].nextKey = item.key;
                    item.prevKey = row[row.length - 1].key;
                }
                item.level = i;
                item.colIndex = colIndex;
                row.push(item);
            }
            i--;
        }
        colIndex++;
    }
    // Add placeholders at the end of each row that is shorter than the maximum
    let i = 0;
    for (let row of headerRows){
        let rowLength = row.reduce((p, c)=>p + (c.colSpan ?? 1), 0);
        if (rowLength < columnNodes.length) {
            let placeholder = {
                type: 'placeholder',
                key: 'placeholder-' + row[row.length - 1].key,
                colSpan: columnNodes.length - rowLength,
                colspan: columnNodes.length - rowLength,
                index: rowLength,
                value: null,
                rendered: null,
                level: i,
                hasChildNodes: false,
                childNodes: [],
                textValue: '',
                prevKey: row[row.length - 1].key
            };
            row.push(placeholder);
        }
        i++;
    }
    return headerRows.map((childNodes, index)=>{
        let row = {
            type: 'headerrow',
            key: 'headerrow-' + index,
            index: index,
            value: null,
            rendered: null,
            level: 0,
            hasChildNodes: true,
            childNodes: childNodes,
            textValue: ''
        };
        return row;
    });
}
class $49021bac7ed2e468$export$596e1b2e2cf93690 extends (0, $77bf58589a3b30dd$export$de3fdf6493c353d) {
    constructor(nodes, prev, opts){
        let rowHeaderColumnKeys = new Set();
        let body = null;
        let columns = [];
        // Add cell for selection checkboxes if needed.
        if (opts?.showSelectionCheckboxes) {
            let rowHeaderColumn = {
                type: 'column',
                key: $49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY,
                value: null,
                textValue: '',
                level: 0,
                index: opts?.showDragButtons ? 1 : 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isSelectionCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        // Add cell for drag buttons if needed.
        if (opts?.showDragButtons) {
            let rowHeaderColumn = {
                type: 'column',
                key: $49021bac7ed2e468$var$$3b14a8cc70843920$var$ROW_HEADER_COLUMN_KEY_DRAG,
                value: null,
                textValue: '',
                level: 0,
                index: 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isDragButtonCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        let rows = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case 'body':
                    body = node;
                    break;
                case 'column':
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        columns.push(node);
                        if (node.props.isRowHeader) rowHeaderColumnKeys.add(node.key);
                    }
                    break;
                case 'item':
                    rows.push(node);
                    return; // do not go into childNodes
            }
            for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let headerRows = $49021bac7ed2e468$export$7c127db850d4e81e(columnKeyMap, columns);
        headerRows.forEach((row, i)=>rows.splice(i, 0, row));
        super({
            columnCount: columns.length,
            items: rows,
            visitNode: (node)=>{
                node.column = columns[node.index];
                return node;
            }
        }), this._size = 0;
        this.columns = columns;
        this.rowHeaderColumnKeys = rowHeaderColumnKeys;
        this.body = body;
        this.headerRows = headerRows;
        this._size = [
            ...body.childNodes
        ].length;
        // Default row header column to the first one.
        if (this.rowHeaderColumnKeys.size === 0) {
            let col = this.columns.find((column)=>!column.props?.isDragButtonCell && !column.props?.isSelectionCell);
            if (col) this.rowHeaderColumnKeys.add(col.key);
        }
    }
    *[Symbol.iterator]() {
        yield* this.body.childNodes;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node?.prevKey ?? null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node?.nextKey ?? null;
    }
    getFirstKey() {
        return (0, $f7tr2.getFirstItem)(this.body.childNodes)?.key ?? null;
    }
    getLastKey() {
        return (0, $f7tr2.getLastItem)(this.body.childNodes)?.key ?? null;
    }
    getItem(key) {
        if (key === this.body.key) return this.body;
        return this.keyMap.get(key) ?? null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        if (key === this.body.key) return this.body.childNodes;
        let node = this.getItem(key);
        if (node?.type === 'item') return [
            ...node.childNodes
        ].filter((n)=>n.type === 'cell');
        return super.getChildren(key);
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return '';
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        if (rowHeaderColumnKeys) {
            let text = [];
            for (let cell of row.childNodes){
                let column = this.columns[cell.index];
                if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
                if (text.length === rowHeaderColumnKeys.size) break;
            }
            return text.join(' ');
        }
        return '';
    }
}



var $3g2oV = parcelRequire("3g2oV");

var $3g2oV = parcelRequire("3g2oV");

var $fVfXf = parcelRequire("fVfXf");

var $6pgkA = parcelRequire("6pgkA");

var $gF3YT = parcelRequire("gF3YT");

var $fSNAA = parcelRequire("fSNAA");

var $daM4n = parcelRequire("daM4n");

var $lJdzA = parcelRequire("lJdzA");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");

var $f7tr2 = parcelRequire("f7tr2");

var $fAqsC = parcelRequire("fAqsC");

var $dWVHy = parcelRequire("dWVHy");

var $eF4cA = parcelRequire("eF4cA");
function $7dbaf5e3d1a33cf1$export$4007ac09ff9c68ed(props) {
    let { collection: collection, focusMode: focusMode } = props;
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    let selectionState = props.UNSAFE_selectionState || (0, $fAqsC.useMultipleSelectionState)(props);
    let disabledKeys = (0, $eF4cA.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let setFocusedKey = selectionState.setFocusedKey;
    // oxlint-disable-next-line react/react-compiler
    selectionState.setFocusedKey = (key, child)=>{
        // If focusMode is cell and an item is focused, focus a child cell instead.
        if (focusMode === 'cell' && key != null) {
            let item = collection.getItem(key);
            if (item?.type === 'item') {
                let children = (0, $f7tr2.getChildNodes)(item, collection);
                if (child === 'last') key = (0, $f7tr2.getLastItem)(children)?.key ?? null;
                else key = (0, $f7tr2.getFirstItem)(children)?.key ?? null;
            }
        }
        setFocusedKey(key, child);
    };
    let selectionManager = (0, $eF4cA.useMemo)(()=>new (0, $dWVHy.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (selectionState.focusedKey != null && cachedCollection.current && !collection.getItem(selectionState.focusedKey)) {
            const node = cachedCollection.current.getItem(selectionState.focusedKey);
            const parentNode = node?.parentKey != null && (node.type === 'cell' || node.type === 'rowheader' || node.type === 'column') ? cachedCollection.current.getItem(node.parentKey) : node;
            if (!parentNode) {
                selectionState.setFocusedKey(null);
                return;
            }
            const cachedRows = cachedCollection.current.rows;
            const rows = collection.rows;
            const diff = cachedRows.length - rows.length;
            let index = Math.min(diff > 1 ? Math.max(parentNode.index - diff + 1, 0) : parentNode.index, rows.length - 1);
            let newRow = null;
            // Find the nearest focusable row at or after the deleted position...
            for(let i = Math.max(0, index); i < rows.length; i++)if (!selectionManager.isDisabled(rows[i].key) && rows[i].type !== 'headerrow') {
                newRow = rows[i];
                break;
            }
            // ...otherwise the nearest focusable row before it. (Mirrors useListState's
            // getKeyAfter/getKeyBefore walk.)
            if (newRow === null) {
                for(let i = index - 1; i >= 0; i--)if (!selectionManager.isDisabled(rows[i].key) && rows[i].type !== 'headerrow') {
                    newRow = rows[i];
                    break;
                }
            }
            if (newRow) {
                const childNodes = newRow.hasChildNodes ? [
                    ...(0, $f7tr2.getChildNodes)(newRow, collection)
                ] : [];
                const keyToFocus = newRow.hasChildNodes && parentNode !== node && node && node.index < childNodes.length ? childNodes[node.index].key : newRow.key;
                selectionState.setFocusedKey(keyToFocus);
            } else selectionState.setFocusedKey(null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        isKeyboardNavigationDisabled: false,
        selectionManager: selectionManager
    };
}




var $94DDV = parcelRequire("94DDV");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cc144e4ba0575d9a$var$$178a7f94e1b4b497$var$OPPOSITE_SORT_DIRECTION = {
    ascending: 'descending',
    descending: 'ascending'
};
function $cc144e4ba0575d9a$export$907bcc6c48325fd6(props) {
    let [isKeyboardNavigationDisabled, setKeyboardNavigationDisabled] = (0, $eF4cA.useState)(false);
    let { selectionMode: selectionMode = 'none', showSelectionCheckboxes: showSelectionCheckboxes, showDragButtons: showDragButtons, treeColumn: treeColumn = null } = props;
    let context = (0, $eF4cA.useMemo)(()=>({
            showSelectionCheckboxes: showSelectionCheckboxes && selectionMode !== 'none',
            showDragButtons: showDragButtons,
            selectionMode: selectionMode,
            columns: []
        }), // oxlint-disable-next-line react/react-compiler, react-hooks/exhaustive-deps
    [
        props.children,
        showSelectionCheckboxes,
        selectionMode,
        showDragButtons
    ]);
    let collection = (0, $94DDV.useCollection)(props, (0, $eF4cA.useCallback)((nodes)=>new (0, $49021bac7ed2e468$export$596e1b2e2cf93690)(nodes, null, context), [
        context
    ]), context);
    let { disabledKeys: disabledKeys, selectionManager: selectionManager } = (0, $7dbaf5e3d1a33cf1$export$4007ac09ff9c68ed)({
        ...props,
        collection: collection,
        disabledBehavior: props.disabledBehavior || 'selection'
    });
    let [expandedKeys, setExpandedKeys] = (0, $iUErx.useControlledState)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        showSelectionCheckboxes: props.showSelectionCheckboxes || false,
        sortDescriptor: props.sortDescriptor ?? null,
        isKeyboardNavigationDisabled: collection.size === 0 || isKeyboardNavigationDisabled,
        setKeyboardNavigationDisabled: setKeyboardNavigationDisabled,
        sort (columnKey, direction) {
            props.onSortChange?.({
                column: columnKey,
                direction: direction ?? (props.sortDescriptor?.column === columnKey ? $cc144e4ba0575d9a$var$$178a7f94e1b4b497$var$OPPOSITE_SORT_DIRECTION[props.sortDescriptor.direction] : 'ascending')
            });
        },
        expandedKeys: expandedKeys,
        toggleKey (key) {
            setExpandedKeys((keys)=>{
                let newKeys = new Set(keys);
                if (newKeys.has(key)) newKeys.delete(key);
                else newKeys.add(key);
                return newKeys;
            });
        },
        treeColumn: treeColumn
    };
}
function $cc144e4ba0575d9a$export$31447e17397b15c2(state, filterFn) {
    let collection = (0, $eF4cA.useMemo)(()=>filterFn ? state.collection.filter(filterFn) : state.collection, [
        state.collection,
        filterFn
    ]);
    let selectionManager = state.selectionManager.withCollection(collection);
    // TODO: handle focus key reset? That logic is in useGridState
    return {
        ...state,
        collection: collection,
        selectionManager: selectionManager
    };
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1002edb233e669c2$export$1994a077b98ee0d5(width) {
    return width != null && (!isNaN(width) || String(width).match(/^(\d+)(?=%$)/) !== null);
}
function $1002edb233e669c2$export$9078bad4c3934604(width) {
    if (!width || typeof width === 'number') return 1;
    let match = width.match(/^(.+)(?=fr$)/);
    // if width is the incorrect format, just default it to a 1fr
    if (!match) return 1;
    return parseFloat(match[0]);
}
function $1002edb233e669c2$export$7bbad27896f7ae9f(width, tableWidth) {
    if (typeof width === 'string') {
        let match = width.match(/^(\d+)(?=%$)/);
        if (!match) throw new Error('Only percentages or numbers are supported for static column widths');
        return tableWidth * (parseFloat(match[0]) / 100);
    }
    return width;
}
function $1002edb233e669c2$export$59185c62a7544aa0(maxWidth, tableWidth) {
    return maxWidth != null ? $1002edb233e669c2$export$7bbad27896f7ae9f(maxWidth, tableWidth) : Number.MAX_SAFE_INTEGER;
}
function $1002edb233e669c2$export$f556054ce4358701(minWidth, tableWidth) {
    return minWidth != null ? $1002edb233e669c2$export$7bbad27896f7ae9f(minWidth, tableWidth) : 0;
}
function $1002edb233e669c2$export$55d50dc687385491(availableWidth, columns, changedColumns, getDefaultWidth, getDefaultMinWidth) {
    let originalWidth = availableWidth;
    let flooredWidth = Math.floor(availableWidth);
    let hasFractionalWidth = availableWidth - flooredWidth > 0;
    availableWidth = flooredWidth;
    let hasNonFrozenItems = false;
    let flexItems = columns.map((column, index)=>{
        let width = changedColumns.get(column.key) != null ? changedColumns.get(column.key) ?? '1fr' : column.width ?? column.defaultWidth ?? getDefaultWidth?.(index) ?? '1fr';
        let frozen = false;
        let baseSize = 0;
        let flex = 0;
        let targetMainSize = 0;
        if ($1002edb233e669c2$export$1994a077b98ee0d5(width)) {
            baseSize = $1002edb233e669c2$export$7bbad27896f7ae9f(width, availableWidth);
            frozen = true;
        } else {
            flex = $1002edb233e669c2$export$9078bad4c3934604(width);
            if (flex <= 0) frozen = true;
        }
        let min = $1002edb233e669c2$export$f556054ce4358701(column.minWidth ?? getDefaultMinWidth?.(index) ?? 0, availableWidth);
        let max = $1002edb233e669c2$export$59185c62a7544aa0(column.maxWidth, availableWidth);
        let hypotheticalMainSize = Math.max(min, Math.min(baseSize, max));
        // 9.7.1
        // We don't make use of flex basis, it's always 0, so we are always in 'grow' mode.
        // 9.7.2
        if (frozen) targetMainSize = hypotheticalMainSize;
        else if (baseSize > hypotheticalMainSize) {
            frozen = true;
            targetMainSize = hypotheticalMainSize;
        }
        // 9.7.3
        if (!frozen) hasNonFrozenItems = true;
        return {
            frozen: frozen,
            baseSize: baseSize,
            hypotheticalMainSize: hypotheticalMainSize,
            min: min,
            max: max,
            flex: flex,
            targetMainSize: targetMainSize,
            violation: 0
        };
    });
    // 9.7.4
    // 9.7.4.a
    while(hasNonFrozenItems){
        // 9.7.4.b
        /**
     * Calculate the remaining free space as for initial free space,
     * above (9.7.3). If the sum of the unfrozen flex items’ flex factors is
     * less than one, multiply the initial free space by this sum (of flex factors).
     * If the magnitude of this value is less than the magnitude of
     * the remaining free space, use this as the remaining free space.
     */ let usedWidth = 0;
        let flexFactors = 0;
        flexItems.forEach((item)=>{
            if (item.frozen) usedWidth += item.targetMainSize;
            else {
                usedWidth += item.baseSize;
                flexFactors += item.flex;
            }
        });
        let remainingFreeSpace = availableWidth - usedWidth;
        // we only support integer FR's, and because of hasNonFrozenItems, we know that flexFactors > 0
        // so no need to check for flexFactors < 1
        // 9.7.4.c
        /**
     * If the remaining free space is zero
     * - Do nothing.
     * Else // remember, we're always in grow mode
     * - Find the ratio of the item’s flex grow factor to the
     * sum of the flex grow factors of all unfrozen items on
     * the line. Set the item’s target main size to its flex
     * base size plus a fraction of the remaining free space
     * proportional to the ratio.
     */ if (remainingFreeSpace > 0) flexItems.forEach((item)=>{
            if (!item.frozen) {
                let ratio = item.flex / flexFactors;
                item.targetMainSize = item.baseSize + ratio * remainingFreeSpace;
            }
        });
        // 9.7.4.d
        /**
     * Fix min/max violations. Clamp each non-frozen item’s
     * target main size by its used min and max main sizes
     * and floor its content-box size at zero. If the item’s
     * target main size was made smaller by this, it’s a max
     * violation. If the item’s target main size was made
     * larger by this, it’s a min violation.
     */ let totalViolation = 0;
        flexItems.forEach((item)=>{
            item.violation = 0;
            if (!item.frozen) {
                let { min: min, max: max, targetMainSize: targetMainSize } = item;
                item.targetMainSize = Math.max(min, Math.min(targetMainSize, max));
                item.violation = item.targetMainSize - targetMainSize;
                totalViolation += item.violation;
            }
        });
        // 9.7.4.e
        /**
     * Freeze over-flexed items. The total violation is the
     * sum of the adjustments from the previous step
     * ∑(clamped size - unclamped size). If the total violation is:
     * Zero
     * - Freeze all items.
     *
     * Positive
     * - Freeze all the items with min violations.
     *
     * Negative
     * - Freeze all the items with max violations.
     */ hasNonFrozenItems = false;
        flexItems.forEach((item)=>{
            if (totalViolation === 0 || Math.sign(totalViolation) === Math.sign(item.violation)) item.frozen = true;
            else if (!item.frozen) hasNonFrozenItems = true;
        });
    }
    let columnSizes = $1002edb233e669c2$var$$56195eeda89edca1$var$cascadeRounding(flexItems);
    // Give the leftover sub-pixel width to the last column so the columns sum
    // exactly to the (possibly fractional) available width.
    if (hasFractionalWidth && columnSizes.length > 0) {
        let tableFractionalWidth = originalWidth.toString().split('.')[1];
        let columnWidth = columnSizes[columnSizes.length - 1].toString();
        columnSizes[columnSizes.length - 1] = Number(columnWidth + '.' + tableFractionalWidth);
    }
    return columnSizes;
}
function $1002edb233e669c2$var$$56195eeda89edca1$var$cascadeRounding(flexItems) {
    /*
  Given an array of floats that sum to an integer, this rounds the floats
  and returns an array of integers with the same sum.
  */ let fpTotal = 0;
    let intTotal = 0;
    let roundedArray = [];
    flexItems.forEach(function(item) {
        let float = item.targetMainSize;
        let integer = Math.round(float + fpTotal) - intTotal;
        fpTotal += float;
        intTotal += integer;
        roundedArray.push(integer);
    });
    return roundedArray;
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $169b947a6ac01bfe$export$7ff77a162970b30e {
    constructor(options){
        this.columnWidths = new Map();
        this.columnMinWidths = new Map();
        this.columnMaxWidths = new Map();
        this.getDefaultWidth = options?.getDefaultWidth ?? (()=>'1fr');
        this.getDefaultMinWidth = options?.getDefaultMinWidth ?? (()=>75);
    }
    /**
   * Takes an array of columns and splits it into 2 maps of columns with controlled and columns with
   * uncontrolled widths.
   */ splitColumnsIntoControlledAndUncontrolled(columns) {
        return columns.reduce((acc, col)=>{
            if (col.props.width != null) acc[0].set(col.key, col);
            else acc[1].set(col.key, col);
            return acc;
        }, [
            new Map(),
            new Map()
        ]);
    }
    /** Takes uncontrolled and controlled widths and joins them into a single Map. */ recombineColumns(columns, uncontrolledWidths, uncontrolledColumns, controlledColumns) {
        return new Map(columns.map((col)=>{
            if (uncontrolledColumns.has(col.key)) return [
                col.key,
                uncontrolledWidths.get(col.key)
            ];
            else return [
                col.key,
                controlledColumns.get(col.key).props.width
            ];
        }));
    }
    /** Used to make an initial Map of the uncontrolled widths based on default widths. */ getInitialUncontrolledWidths(uncontrolledColumns) {
        return new Map(Array.from(uncontrolledColumns).map(([key, col])=>[
                key,
                col.props.defaultWidth ?? this.getDefaultWidth?.(col) ?? '1fr'
            ]));
    }
    getColumnWidth(key) {
        return this.columnWidths.get(key) ?? 0;
    }
    getColumnMinWidth(key) {
        return this.columnMinWidths.get(key) ?? 0;
    }
    getColumnMaxWidth(key) {
        return this.columnMaxWidths.get(key) ?? 0;
    }
    resizeColumnWidth(collection, uncontrolledWidths, col, width) {
        let prevColumnWidths = this.columnWidths;
        let freeze = true;
        let newWidths = new Map();
        width = Math.max(this.getColumnMinWidth(col), Math.min(this.getColumnMaxWidth(col), Math.floor(width)));
        collection.columns.forEach((column)=>{
            if (column.key === col) {
                newWidths.set(column.key, width);
                freeze = false;
            } else if (freeze) newWidths.set(column.key, prevColumnWidths.get(column.key) ?? 0);
            else newWidths.set(column.key, column.props.width ?? uncontrolledWidths.get(column.key));
        });
        return newWidths;
    }
    buildColumnWidths(tableWidth, collection, widths) {
        this.columnWidths = new Map();
        this.columnMinWidths = new Map();
        this.columnMaxWidths = new Map();
        // initial layout or table/window resizing
        let columnWidths = (0, $1002edb233e669c2$export$55d50dc687385491)(tableWidth, collection.columns.map((col)=>({
                ...col.props,
                key: col.key
            })), widths, (i)=>this.getDefaultWidth(collection.columns[i]), (i)=>this.getDefaultMinWidth(collection.columns[i]));
        // columns going in will be the same order as the columns coming out
        columnWidths.forEach((width, index)=>{
            let key = collection.columns[index].key;
            let column = collection.columns[index];
            this.columnWidths.set(key, width);
            this.columnMinWidths.set(key, (0, $1002edb233e669c2$export$f556054ce4358701)(column.props.minWidth ?? this.getDefaultMinWidth(column), tableWidth));
            this.columnMaxWidths.set(key, (0, $1002edb233e669c2$export$59185c62a7544aa0)(column.props.maxWidth, tableWidth));
        });
        return this.columnWidths;
    }
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $024d06f0fd0ec92f$export$cb895dcf85db1319(props, state) {
    let { getDefaultWidth: getDefaultWidth, getDefaultMinWidth: getDefaultMinWidth, tableWidth: tableWidth = 0 } = props;
    let [resizingColumn, setResizingColumn] = (0, $eF4cA.useState)(null);
    let columnLayout = (0, $eF4cA.useMemo)(()=>new (0, $169b947a6ac01bfe$export$7ff77a162970b30e)({
            getDefaultWidth: getDefaultWidth,
            getDefaultMinWidth: getDefaultMinWidth
        }), [
        getDefaultWidth,
        getDefaultMinWidth
    ]);
    let [controlledColumns, uncontrolledColumns] = (0, $eF4cA.useMemo)(()=>columnLayout.splitColumnsIntoControlledAndUncontrolled(state.collection.columns), [
        state.collection.columns,
        columnLayout
    ]);
    // uncontrolled column widths
    let [uncontrolledWidths, setUncontrolledWidths] = (0, $eF4cA.useState)(()=>columnLayout.getInitialUncontrolledWidths(uncontrolledColumns));
    // Update uncontrolled widths if the columns changed.
    let [lastColumns, setLastColumns] = (0, $eF4cA.useState)(state.collection.columns);
    if (state.collection.columns !== lastColumns) {
        if (state.collection.columns.length !== lastColumns.length || state.collection.columns.some((c, i)=>c.key !== lastColumns[i].key)) {
            let newUncontrolledWidths = columnLayout.getInitialUncontrolledWidths(uncontrolledColumns);
            setUncontrolledWidths(newUncontrolledWidths);
        }
        setLastColumns(state.collection.columns);
    }
    // combine columns back into one map that maintains same order as the columns
    let colWidths = (0, $eF4cA.useMemo)(()=>columnLayout.recombineColumns(state.collection.columns, uncontrolledWidths, uncontrolledColumns, controlledColumns), [
        state.collection.columns,
        uncontrolledWidths,
        uncontrolledColumns,
        controlledColumns,
        columnLayout
    ]);
    let startResize = (0, $eF4cA.useCallback)((key)=>{
        setResizingColumn(key);
    }, [
        setResizingColumn
    ]);
    let updateResizedColumns = (0, $eF4cA.useCallback)((key, width)=>{
        let newSizes = columnLayout.resizeColumnWidth(state.collection, uncontrolledWidths, key, width);
        let map = new Map(Array.from(uncontrolledColumns).map(([key])=>[
                key,
                newSizes.get(key)
            ]));
        map.set(key, width);
        setUncontrolledWidths(map);
        return newSizes;
    }, [
        uncontrolledColumns,
        setUncontrolledWidths,
        columnLayout,
        state.collection,
        uncontrolledWidths
    ]);
    let endResize = (0, $eF4cA.useCallback)(()=>{
        setResizingColumn(null);
    }, [
        setResizingColumn
    ]);
    let columnWidths = (0, $eF4cA.useMemo)(()=>columnLayout.buildColumnWidths(tableWidth, state.collection, colWidths), [
        tableWidth,
        state.collection,
        colWidths,
        columnLayout
    ]);
    return (0, $eF4cA.useMemo)(()=>({
            resizingColumn: resizingColumn,
            updateResizedColumns: updateResizedColumns,
            startResize: startResize,
            endResize: endResize,
            getColumnWidth: (key)=>columnLayout.getColumnWidth(key),
            getColumnMinWidth: (key)=>columnLayout.getColumnMinWidth(key),
            getColumnMaxWidth: (key)=>columnLayout.getColumnMaxWidth(key),
            tableState: state,
            columnWidths: columnWidths
        }), [
        columnLayout,
        columnWidths,
        resizingColumn,
        updateResizedColumns,
        startResize,
        endResize,
        state
    ]);
}



var $1kw8g = parcelRequire("1kw8g");

var $iUErx = parcelRequire("iUErx");

var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $fAqsC = parcelRequire("fAqsC");

var $26CkO = parcelRequire("26CkO");

var $f9wnx = parcelRequire("f9wnx");

var $4HiHF = parcelRequire("4HiHF");

var $fVfXf = parcelRequire("fVfXf");

var $fvyIQ = parcelRequire("fvyIQ");

var $aXSxC = parcelRequire("aXSxC");

var $f7tr2 = parcelRequire("f7tr2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $53dd6069743d4e55$export$de9feff04fda126e {
    constructor(options){
        this.collection = options.collection;
        this.disabledKeys = options.disabledKeys;
        this.disabledBehavior = options.disabledBehavior || 'all';
        this.direction = options.direction;
        this.collator = options.collator;
        if (!options.layout && !options.ref) throw new Error('Either a layout or a ref must be specified.');
        this.layoutDelegate = options.layoutDelegate || (options.layout ? new $53dd6069743d4e55$var$$c7bb87e55e1ab755$var$DeprecatedLayoutDelegate(options.layout) : new (0, $aXSxC.DOMLayoutDelegate)(options.ref));
        this.focusMode = options.focusMode ?? 'row';
    }
    isCell(node) {
        return node.type === 'cell';
    }
    isRow(node) {
        return node.type === 'row' || node.type === 'item';
    }
    isDisabled(item) {
        return this.disabledBehavior === 'all' && (item.props?.isDisabled || this.disabledKeys.has(item.key)) && item.props?.disabledBehavior !== 'selection';
    }
    findPreviousKey(fromKey, pred, includeDisabled = false) {
        let key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!item) return null;
            if ((includeDisabled || !this.isDisabled(item)) && (!pred || pred(item))) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findNextKey(fromKey, pred, includeDisabled = false) {
        let key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!item) return null;
            if ((includeDisabled || !this.isDisabled(item)) && (!pred || pred(item))) return key;
            key = this.collection.getKeyAfter(key);
            if (key == null) return null;
        }
        return null;
    }
    getKeyForItemInRowByIndex(key, index = 0) {
        if (index < 0) return null;
        let item = this.collection.getItem(key);
        if (!item) return null;
        let i = 0;
        for (let child of (0, $f7tr2.getChildNodes)(item, this.collection)){
            if (child.colSpan && child.colSpan + i > index) return child.key ?? null;
            if (child.colSpan) i = i + child.colSpan - 1;
            if (i === index) return child.key ?? null;
            i++;
        }
        return null;
    }
    getKeyBelow(fromKey, options) {
        let key = fromKey;
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        // If focus was on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey ?? null;
        if (key == null) return null;
        // Find the next item
        key = this.findNextKey(key, (item)=>item.type === 'item', options?.includeDisabled);
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the next row.
            if (this.isCell(startItem)) {
                let startIndex = startItem.colIndex ? startItem.colIndex : startItem.index;
                return this.getKeyForItemInRowByIndex(key, startIndex);
            }
            // Otherwise, focus the next row
            if (this.focusMode === 'row') return key;
        }
        return null;
    }
    getKeyAbove(fromKey, options) {
        let key = fromKey;
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        // If focus is on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey ?? null;
        if (key == null) return null;
        // Find the previous item
        key = this.findPreviousKey(key, (item)=>item.type === 'item', options?.includeDisabled);
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the previous row.
            if (this.isCell(startItem)) {
                let startIndex = startItem.colIndex ? startItem.colIndex : startItem.index;
                return this.getKeyForItemInRowByIndex(key, startIndex);
            }
            // Otherwise, focus the previous row
            if (this.focusMode === 'row') return key;
        }
        return null;
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus is on a row, focus the first child cell.
        if (this.isRow(item)) {
            let children = (0, $f7tr2.getChildNodes)(item, this.collection);
            return (this.direction === 'rtl' ? (0, $f7tr2.getLastItem)(children)?.key : (0, $f7tr2.getFirstItem)(children)?.key) ?? null;
        }
        // If focus is on a cell, focus the next cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item) && item.parentKey != null) {
            let parent = this.collection.getItem(item.parentKey);
            if (!parent) return null;
            let children = (0, $f7tr2.getChildNodes)(parent, this.collection);
            let next = (this.direction === 'rtl' ? (0, $f7tr2.getNthItem)(children, item.index - 1) : (0, $f7tr2.getNthItem)(children, item.index + 1)) ?? null;
            if (next) return next.key ?? null;
            // focus row only if focusMode is set to row
            if (this.focusMode === 'row') return item.parentKey ?? null;
            return (this.direction === 'rtl' ? this.getFirstKey(key) : this.getLastKey(key)) ?? null;
        }
        return null;
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus is on a row, focus the last child cell.
        if (this.isRow(item)) {
            let children = (0, $f7tr2.getChildNodes)(item, this.collection);
            return (this.direction === 'rtl' ? (0, $f7tr2.getFirstItem)(children)?.key : (0, $f7tr2.getLastItem)(children)?.key) ?? null;
        }
        // If focus is on a cell, focus the previous cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item) && item.parentKey != null) {
            let parent = this.collection.getItem(item.parentKey);
            if (!parent) return null;
            let children = (0, $f7tr2.getChildNodes)(parent, this.collection);
            let prev = (this.direction === 'rtl' ? (0, $f7tr2.getNthItem)(children, item.index + 1) : (0, $f7tr2.getNthItem)(children, item.index - 1)) ?? null;
            if (prev) return prev.key ?? null;
            // focus row only if focusMode is set to row
            if (this.focusMode === 'row') return item.parentKey ?? null;
            return (this.direction === 'rtl' ? this.getLastKey(key) : this.getFirstKey(key)) ?? null;
        }
        return null;
    }
    getFirstKey(fromKey, global) {
        let key = fromKey ?? null;
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return null;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the first cell in the parent row.
            if (this.isCell(item) && !global && item.parentKey != null) {
                let parent = this.collection.getItem(item.parentKey);
                if (!parent) return null;
                return (0, $f7tr2.getFirstItem)((0, $f7tr2.getChildNodes)(parent, this.collection))?.key ?? null;
            }
        }
        // Find the first row
        key = this.findNextKey(undefined, (item)=>item.type === 'item');
        // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
        if (key != null && (item && this.isCell(item) && global || this.focusMode === 'cell')) {
            let item = this.collection.getItem(key);
            if (!item) return null;
            key = (0, $f7tr2.getFirstItem)((0, $f7tr2.getChildNodes)(item, this.collection))?.key ?? null;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getLastKey(fromKey, global) {
        let key = fromKey ?? null;
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return null;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the last cell in the parent row.
            if (this.isCell(item) && !global && item.parentKey != null) {
                let parent = this.collection.getItem(item.parentKey);
                if (!parent) return null;
                let children = (0, $f7tr2.getChildNodes)(parent, this.collection);
                return (0, $f7tr2.getLastItem)(children)?.key ?? null;
            }
        }
        // Find the last row
        key = this.findPreviousKey(undefined, (item)=>item.type === 'item');
        // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
        if (key != null && (item && this.isCell(item) && global || this.focusMode === 'cell')) {
            let item = this.collection.getItem(key);
            if (!item) return null;
            let children = (0, $f7tr2.getChildNodes)(item, this.collection);
            key = (0, $f7tr2.getLastItem)(children)?.key ?? null;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getKeyPageAbove(fromKey) {
        let key = fromKey;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
        while(itemRect && itemRect.y > pageY && key != null){
            key = this.getKeyAbove(key) ?? null;
            if (key == null) break;
            itemRect = this.layoutDelegate.getItemRect(key);
        }
        return key;
    }
    getKeyPageBelow(fromKey) {
        let key = fromKey;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let pageHeight = this.layoutDelegate.getVisibleRect().height;
        let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y + pageHeight);
        while(itemRect && itemRect.y + itemRect.height < pageY){
            let nextKey = this.getKeyBelow(key);
            // If nextKey is undefined, we've reached the last row already
            if (nextKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(nextKey);
            key = nextKey;
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        let key = fromKey ?? null;
        if (!this.collator) return null;
        let collection = this.collection;
        key = fromKey ?? this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (!startItem) return null;
        if (startItem.type === 'cell') key = startItem.parentKey ?? null;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            // check row text value for match
            if (item.textValue) {
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) {
                    if (this.isRow(item) && this.focusMode === 'cell') return (0, $f7tr2.getFirstItem)((0, $f7tr2.getChildNodes)(item, this.collection))?.key ?? null;
                    return item.key;
                }
            }
            key = this.findNextKey(key, (item)=>item.type === 'item');
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
}
class $53dd6069743d4e55$var$$c7bb87e55e1ab755$var$DeprecatedLayoutDelegate {
    constructor(layout){
        this.layout = layout;
    }
    getContentSize() {
        return this.layout.getContentSize();
    }
    getItemRect(key) {
        return this.layout.getLayoutInfo(key)?.rect || null;
    }
    getVisibleRect() {
        return this.layout.virtualizer.visibleRect;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1fbe9494e8e847d1$export$e6235c0d09b995d0 = new WeakMap();



var $lhKAD = parcelRequire("lhKAD");

var $gm31e = parcelRequire("gm31e");

var $3V5dF = parcelRequire("3V5dF");

var $flpop = parcelRequire("flpop");

var $9ehxp = parcelRequire("9ehxp");

var $25dFS = parcelRequire("25dFS");

var $1ntKq = parcelRequire("1ntKq");

var $vvwBC = parcelRequire("vvwBC");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $96b970ef77c54f6f$export$f6b86a04e5d66d90(props, state, ref) {
    let { isVirtualized: isVirtualized, disallowTypeAhead: disallowTypeAhead, keyboardDelegate: keyboardDelegate, focusMode: focusMode, scrollRef: scrollRef, getRowText: getRowText, onRowAction: onRowAction, onCellAction: onCellAction, escapeKeyBehavior: escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp: shouldSelectOnPressUp, keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow' } = props;
    let { selectionManager: manager } = state;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, $eF4cA.useMemo)(()=>keyboardDelegate || new (0, $53dd6069743d4e55$export$de9feff04fda126e)({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            direction: direction,
            collator: collator,
            focusMode: focusMode
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        focusMode
    ]);
    let { collectionProps: collectionProps } = (0, $vvwBC.useSelectableCollection)({
        ref: ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        isVirtualized: isVirtualized,
        scrollRef: scrollRef,
        disallowTypeAhead: disallowTypeAhead,
        escapeKeyBehavior: escapeKeyBehavior
    });
    let id = (0, $25dFS.useId)(props.id);
    (0, $1fbe9494e8e847d1$export$e6235c0d09b995d0).set(state, {
        keyboardDelegate: delegate,
        actions: {
            onRowAction: onRowAction,
            onCellAction: onCellAction
        },
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        keyboardNavigationBehavior: keyboardNavigationBehavior
    });
    let descriptionProps = (0, $9ehxp.useHighlightSelectionDescription)({
        selectionManager: manager,
        hasItemActions: !!(onRowAction || onCellAction)
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        labelable: true
    });
    let onFocus = (0, $eF4cA.useCallback)((e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e))) return;
        manager.setFocused(true);
    }, [
        manager
    ]);
    // Continue to track collection focused state even if keyboard navigation is disabled
    let navDisabledHandlers = (0, $eF4cA.useMemo)(()=>({
            onBlur: collectionProps.onBlur,
            onFocus: onFocus
        }), [
        onFocus,
        collectionProps.onBlur
    ]);
    let hasTabbableChild = (0, $flpop.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let gridProps = (0, $lhKAD.mergeProps)(domProps, {
        role: 'grid',
        id: id,
        'aria-multiselectable': manager.selectionMode === 'multiple' ? 'true' : undefined
    }, state.isKeyboardNavigationDisabled ? navDisabledHandlers : collectionProps, state.collection.size === 0 && {
        tabIndex: hasTabbableChild ? -1 : 0
    } || undefined, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = state.collection.columnCount;
    }
    (0, $3V5dF.useGridSelectionAnnouncement)({
        getRowText: getRowText
    }, state);
    return {
        gridProps: gridProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $25e46ab2c7f47034$export$552312adfd451dab = new WeakMap();
function $25e46ab2c7f47034$var$$cf56c58f505db99a$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $25e46ab2c7f47034$export$37cd4213f2ad742e(state, columnKey) {
    let gridId = $25e46ab2c7f47034$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error('Unknown grid');
    return `${gridId}-${$25e46ab2c7f47034$var$$cf56c58f505db99a$var$normalizeKey(columnKey)}`;
}
function $25e46ab2c7f47034$export$19baff3266315d44(state, rowKey, columnKey) {
    let gridId = $25e46ab2c7f47034$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error('Unknown grid');
    return `${gridId}-${$25e46ab2c7f47034$var$$cf56c58f505db99a$var$normalizeKey(rowKey)}-${$25e46ab2c7f47034$var$$cf56c58f505db99a$var$normalizeKey(columnKey)}`;
}
function $25e46ab2c7f47034$export$85069b70317f543(state, rowKey) {
    // A row is labelled by it's row headers.
    return [
        ...state.collection.rowHeaderColumnKeys
    ].map((columnKey)=>$25e46ab2c7f47034$export$19baff3266315d44(state, rowKey, columnKey)).join(' ');
}


var $34ac0f3783f0ae4b$export$2e2bcd8739ae039 = {};
$34ac0f3783f0ae4b$export$2e2bcd8739ae039 = {
    "ascending": `\u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "ascendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "collapse": `\u{637}\u{64A}`,
    "columnSize": (args)=>`${args.value} \u{628}\u{627}\u{644}\u{628}\u{643}\u{633}\u{644}`,
    "descending": `\u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "descendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "expand": `\u{62A}\u{645}\u{62F}\u{64A}\u{62F}`,
    "resizerDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} Enter \u{644}\u{628}\u{62F}\u{621} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectAll": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{644}`,
    "sortable": `\u{639}\u{645}\u{648}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{62A}\u{631}\u{62A}\u{64A}\u{628}`
};


var $df0237fcbca3588e$export$2e2bcd8739ae039 = {};
$df0237fcbca3588e$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432}\u{44A}\u{432} \u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "collapse": `\u{421}\u{432}\u{438}\u{432}\u{430}\u{43D}\u{435}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}\u{435}\u{43B}\u{430}`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432} \u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "expand": `\u{420}\u{430}\u{437}\u{448}\u{438}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{442}\u{435}`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectAll": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{43E}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{449}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`
};


var $a798a7b5bb4008f4$export$2e2bcd8739ae039 = {};
$a798a7b5bb4008f4$export$2e2bcd8739ae039 = {
    "ascending": `vzestupn\u{11B}`,
    "ascendingSort": (args)=>`\u{159}azeno vzestupn\u{11B} podle sloupce ${args.columnName}`,
    "collapse": `Sbalit`,
    "columnSize": (args)=>`${args.value} pixel\u{16F}`,
    "descending": `sestupn\u{11B}`,
    "descendingSort": (args)=>`\u{159}azeno sestupn\u{11B} podle sloupce ${args.columnName}`,
    "expand": `Rozt\xe1hnout`,
    "resizerDescription": `Stisknut\xedm kl\xe1vesy Enter za\u{10D}nete m\u{11B}nit velikost`,
    "select": `Vybrat`,
    "selectAll": `Vybrat v\u{161}e`,
    "sortable": `sloupec s mo\u{17E}nost\xed \u{159}azen\xed`
};


var $90f254dc6e9f05a2$export$2e2bcd8739ae039 = {};
$90f254dc6e9f05a2$export$2e2bcd8739ae039 = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i stigende r\xe6kkef\xf8lge`,
    "collapse": `Skjul`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `faldende`,
    "descendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i faldende r\xe6kkef\xf8lge`,
    "expand": `Udvid`,
    "resizerDescription": `Tryk p\xe5 Enter for at \xe6ndre st\xf8rrelse`,
    "select": `V\xe6lg`,
    "selectAll": `V\xe6lg alle`,
    "sortable": `sorterbar kolonne`
};


var $2a837656cab525f2$export$2e2bcd8739ae039 = {};
$2a837656cab525f2$export$2e2bcd8739ae039 = {
    "ascending": `aufsteigend`,
    "ascendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in aufsteigender Reihenfolge`,
    "collapse": `Reduzieren`,
    "columnSize": (args)=>`${args.value} Pixel`,
    "descending": `absteigend`,
    "descendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in absteigender Reihenfolge`,
    "expand": `Erweitern`,
    "resizerDescription": `Eingabetaste zum Starten der Gr\xf6\xdfen\xe4nderung dr\xfccken`,
    "select": `Ausw\xe4hlen`,
    "selectAll": `Alles ausw\xe4hlen`,
    "sortable": `sortierbare Spalte`
};


var $cd89442be2bf132e$export$2e2bcd8739ae039 = {};
$cd89442be2bf132e$export$2e2bcd8739ae039 = {
    "ascending": `\u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "ascendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "collapse": `\u{3A3}\u{3CD}\u{3BC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `\u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "descendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "expand": `\u{391}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "resizerDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3B1}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE}\u{3C2} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3CC}\u{3BB}\u{3C9}\u{3BD}`,
    "sortable": `\u{3A3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}`
};


var $9c228ca1705b5611$export$2e2bcd8739ae039 = {};
$9c228ca1705b5611$export$2e2bcd8739ae039 = {
    "select": `Select`,
    "selectAll": `Select All`,
    "sortable": `sortable column`,
    "ascending": `ascending`,
    "descending": `descending`,
    "ascendingSort": (args)=>`sorted by column ${args.columnName} in ascending order`,
    "descendingSort": (args)=>`sorted by column ${args.columnName} in descending order`,
    "columnSize": (args)=>`${args.value} pixels`,
    "resizerDescription": `Press Enter to start resizing`,
    "expand": `Expand`,
    "collapse": `Collapse`
};


var $e3d07fa2df177b97$export$2e2bcd8739ae039 = {};
$e3d07fa2df177b97$export$2e2bcd8739ae039 = {
    "ascending": `ascendente`,
    "ascendingSort": (args)=>`ordenado por columna ${args.columnName} en sentido ascendente`,
    "collapse": `Contraer`,
    "columnSize": (args)=>`${args.value} p\xedxeles`,
    "descending": `descendente`,
    "descendingSort": (args)=>`ordenado por columna ${args.columnName} en orden descendente`,
    "expand": `Ampliar`,
    "resizerDescription": `Pulse Intro para empezar a redimensionar`,
    "select": `Seleccionar`,
    "selectAll": `Seleccionar todos`,
    "sortable": `columna ordenable`
};


var $e8173eb7b311e985$export$2e2bcd8739ae039 = {};
$e8173eb7b311e985$export$2e2bcd8739ae039 = {
    "ascending": `t\xf5usev j\xe4rjestus`,
    "ascendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} t\xf5usvas j\xe4rjestuses`,
    "collapse": `Ahenda`,
    "columnSize": (args)=>`${args.value} pikslit`,
    "descending": `laskuv j\xe4rjestus`,
    "descendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} laskuvas j\xe4rjestuses`,
    "expand": `Laienda`,
    "resizerDescription": `Suuruse muutmise alustamiseks vajutage klahvi Enter`,
    "select": `Vali`,
    "selectAll": `Vali k\xf5ik`,
    "sortable": `sorditav veerg`
};


var $aba04ed16517b081$export$2e2bcd8739ae039 = {};
$aba04ed16517b081$export$2e2bcd8739ae039 = {
    "ascending": `nouseva`,
    "ascendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan nousevassa j\xe4rjestyksess\xe4`,
    "collapse": `Pienenn\xe4`,
    "columnSize": (args)=>`${args.value} pikseli\xe4`,
    "descending": `laskeva`,
    "descendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan laskevassa j\xe4rjestyksess\xe4`,
    "expand": `Laajenna`,
    "resizerDescription": `Aloita koon muutos painamalla Enter-n\xe4pp\xe4int\xe4`,
    "select": `Valitse`,
    "selectAll": `Valitse kaikki`,
    "sortable": `lajiteltava sarake`
};


var $31f2306505c4d8c8$export$2e2bcd8739ae039 = {};
$31f2306505c4d8c8$export$2e2bcd8739ae039 = {
    "ascending": `croissant`,
    "ascendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre croissant`,
    "collapse": `R\xe9duire`,
    "columnSize": (args)=>`${args.value}\xa0pixels`,
    "descending": `d\xe9croissant`,
    "descendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre d\xe9croissant`,
    "expand": `D\xe9velopper`,
    "resizerDescription": `Appuyez sur Entr\xe9e pour commencer le redimensionnement.`,
    "select": `S\xe9lectionner`,
    "selectAll": `S\xe9lectionner tout`,
    "sortable": `colonne triable`
};


var $812163a9c012109c$export$2e2bcd8739ae039 = {};
$812163a9c012109c$export$2e2bcd8739ae039 = {
    "ascending": `\u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "ascendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5}`,
    "columnSize": (args)=>`${args.value} \u{5E4}\u{5D9}\u{5E7}\u{5E1}\u{5DC}\u{5D9}\u{5DD}`,
    "descending": `\u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "descendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "expand": `\u{5D4}\u{5E8}\u{5D7}\u{5D1}`,
    "resizerDescription": `\u{5D4}\u{5E7}\u{5E9} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5E0}\u{5D5}\u{5EA} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5D5}\u{5D3}\u{5DC}`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectAll": `\u{5D1}\u{5D7}\u{5E8} \u{5D4}\u{5DB}\u{5D5}\u{5DC}`,
    "sortable": `\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} \u{5E9}\u{5E0}\u{5D9}\u{5EA}\u{5DF} \u{5DC}\u{5DE}\u{5D9}\u{5D9}\u{5DF}`
};


var $a869453062b7d176$export$2e2bcd8739ae039 = {};
$a869453062b7d176$export$2e2bcd8739ae039 = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`razvrstano po stupcima ${args.columnName} rastu\u{107}em redoslijedom`,
    "collapse": `Sa\u{17E}mi`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`razvrstano po stupcima ${args.columnName} padaju\u{107}im redoslijedom`,
    "expand": `Pro\u{161}iri`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Odaberite`,
    "selectAll": `Odaberite sve`,
    "sortable": `stupac koji se mo\u{17E}e razvrstati`
};


var $cea3b0c81143014e$export$2e2bcd8739ae039 = {};
$cea3b0c81143014e$export$2e2bcd8739ae039 = {
    "ascending": `n\xf6vekv\u{151}`,
    "ascendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, n\xf6vekv\u{151} sorrendben`,
    "collapse": `\xd6sszecsuk\xe1s`,
    "columnSize": (args)=>`${args.value} k\xe9ppont`,
    "descending": `cs\xf6kken\u{151}`,
    "descendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, cs\xf6kken\u{151} sorrendben`,
    "expand": `Kibont\xe1s`,
    "resizerDescription": `Nyomja le az Enter billenty\u{171}t az \xe1tm\xe9retez\xe9s megkezd\xe9s\xe9hez`,
    "select": `Kijel\xf6l\xe9s`,
    "selectAll": `\xd6sszes kijel\xf6l\xe9se`,
    "sortable": `rendezend\u{151} oszlop`
};


var $d69dbbdec29b6738$export$2e2bcd8739ae039 = {};
$d69dbbdec29b6738$export$2e2bcd8739ae039 = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`in ordine crescente in base alla colonna ${args.columnName}`,
    "collapse": `Comprimi`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`in ordine decrescente in base alla colonna ${args.columnName}`,
    "expand": `Espandi`,
    "resizerDescription": `Premi Invio per iniziare a ridimensionare`,
    "select": `Seleziona`,
    "selectAll": `Seleziona tutto`,
    "sortable": `colonna ordinabile`
};


var $4b4db5dba2307e73$export$2e2bcd8739ae039 = {};
$4b4db5dba2307e73$export$2e2bcd8739ae039 = {
    "ascending": `\u{6607}\u{9806}`,
    "ascendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{6607}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "collapse": `\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "columnSize": (args)=>`${args.value} \u{30D4}\u{30AF}\u{30BB}\u{30EB}`,
    "descending": `\u{964D}\u{9806}`,
    "descendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{964D}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "expand": `\u{5C55}\u{958B}`,
    "resizerDescription": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{3092}\u{958B}\u{59CB}`,
    "select": `\u{9078}\u{629E}`,
    "selectAll": `\u{3059}\u{3079}\u{3066}\u{9078}\u{629E}`,
    "sortable": `\u{4E26}\u{3079}\u{66FF}\u{3048}\u{53EF}\u{80FD}\u{306A}\u{5217}`
};


var $42bc036c3ba841e1$export$2e2bcd8739ae039 = {};
$42bc036c3ba841e1$export$2e2bcd8739ae039 = {
    "ascending": `\u{C624}\u{B984}\u{CC28}\u{C21C}`,
    "ascendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{C624}\u{B984}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "collapse": `\u{C811}\u{AE30}`,
    "columnSize": (args)=>`${args.value} \u{D53D}\u{C140}`,
    "descending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C}`,
    "descendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{B0B4}\u{B9BC}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "expand": `\u{D3BC}\u{CE58}\u{AE30}`,
    "resizerDescription": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectAll": `\u{BAA8}\u{B450} \u{C120}\u{D0DD}`,
    "sortable": `\u{C815}\u{B82C} \u{AC00}\u{B2A5}\u{D55C} \u{C5F4}`
};


var $1dccd6a57bfd34e6$export$2e2bcd8739ae039 = {};
$1dccd6a57bfd34e6$export$2e2bcd8739ae039 = {
    "ascending": `did\u{117}jan\u{10D}ia tvarka`,
    "ascendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} did\u{117}jan\u{10D}ia tvarka`,
    "collapse": `Sutraukti`,
    "columnSize": (args)=>`${args.value} piks.`,
    "descending": `ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "descendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "expand": `I\u{161}skleisti`,
    "resizerDescription": `Paspauskite \u{201E}Enter\u{201C}, kad prad\u{117}tum\u{117}te keisti dyd\u{12F}`,
    "select": `Pasirinkti`,
    "selectAll": `Pasirinkti visk\u{105}`,
    "sortable": `rikiuojamas stulpelis`
};


var $06255ba4590c15ab$export$2e2bcd8739ae039 = {};
$06255ba4590c15ab$export$2e2bcd8739ae039 = {
    "ascending": `augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "ascendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "collapse": `Sak\u{13C}aut`,
    "columnSize": (args)=>`${args.value} pikse\u{13C}i`,
    "descending": `dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "descendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "expand": `Izv\u{113}rst`,
    "resizerDescription": `Nospiediet Enter, lai s\u{101}ktu izm\u{113}ru main\u{12B}\u{161}anu`,
    "select": `Atlas\u{12B}t`,
    "selectAll": `Atlas\u{12B}t visu`,
    "sortable": `k\u{101}rtojam\u{101} kolonna`
};


var $58455efb7aa32fbf$export$2e2bcd8739ae039 = {};
$58455efb7aa32fbf$export$2e2bcd8739ae039 = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sortert etter kolonne ${args.columnName} i stigende rekkef\xf8lge`,
    "collapse": `Skjul`,
    "columnSize": (args)=>`${args.value} piksler`,
    "descending": `synkende`,
    "descendingSort": (args)=>`sortert etter kolonne ${args.columnName} i synkende rekkef\xf8lge`,
    "expand": `Utvid`,
    "resizerDescription": `Trykk p\xe5 Enter for \xe5 starte st\xf8rrelsesendring`,
    "select": `Velg`,
    "selectAll": `Velg alle`,
    "sortable": `kolonne som kan sorteres`
};


var $172100d25168d03b$export$2e2bcd8739ae039 = {};
$172100d25168d03b$export$2e2bcd8739ae039 = {
    "ascending": `oplopend`,
    "ascendingSort": (args)=>`gesorteerd in oplopende volgorde in kolom ${args.columnName}`,
    "collapse": `Samenvouwen`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `aflopend`,
    "descendingSort": (args)=>`gesorteerd in aflopende volgorde in kolom ${args.columnName}`,
    "expand": `Uitvouwen`,
    "resizerDescription": `Druk op Enter om het formaat te wijzigen`,
    "select": `Selecteren`,
    "selectAll": `Alles selecteren`,
    "sortable": `sorteerbare kolom`
};


var $106d1d6b830f247b$export$2e2bcd8739ae039 = {};
$106d1d6b830f247b$export$2e2bcd8739ae039 = {
    "ascending": `rosn\u{105}co`,
    "ascendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku rosn\u{105}cym`,
    "collapse": `Zwi\u{144}`,
    "columnSize": (args)=>`Liczba pikseli: ${args.value}`,
    "descending": `malej\u{105}co`,
    "descendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku malej\u{105}cym`,
    "expand": `Rozwi\u{144}`,
    "resizerDescription": `Naci\u{15B}nij Enter, aby rozpocz\u{105}\u{107} zmienianie rozmiaru`,
    "select": `Zaznacz`,
    "selectAll": `Zaznacz wszystko`,
    "sortable": `kolumna z mo\u{17C}liwo\u{15B}ci\u{105} sortowania`
};


var $9f993bd759e542a8$export$2e2bcd8739ae039 = {};
$9f993bd759e542a8$export$2e2bcd8739ae039 = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem crescente`,
    "collapse": `Recolher`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem decrescente`,
    "expand": `Expandir`,
    "resizerDescription": `Pressione Enter para come\xe7ar a redimensionar`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `coluna classific\xe1vel`
};


var $7b77fc4cebe1d636$export$2e2bcd8739ae039 = {};
$7b77fc4cebe1d636$export$2e2bcd8739ae039 = {
    "ascending": `ascendente`,
    "ascendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem ascendente`,
    "collapse": `Colapsar`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `descendente`,
    "descendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem descendente`,
    "expand": `Expandir`,
    "resizerDescription": `Prima Enter para iniciar o redimensionamento`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `Coluna orden\xe1vel`
};


var $bd48316b01e81806$export$2e2bcd8739ae039 = {};
$bd48316b01e81806$export$2e2bcd8739ae039 = {
    "ascending": `cresc\u{103}toare`,
    "ascendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine cresc\u{103}toare`,
    "collapse": `Restr\xe2nge\u{21B}i`,
    "columnSize": (args)=>`${args.value} pixeli`,
    "descending": `descresc\u{103}toare`,
    "descendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine descresc\u{103}toare`,
    "expand": `Extinde\u{21B}i`,
    "resizerDescription": `Ap\u{103}sa\u{21B}i pe Enter pentru a \xeencepe redimensionarea`,
    "select": `Selectare`,
    "selectAll": `Selectare total\u{103}`,
    "sortable": `coloan\u{103} sortabil\u{103}`
};


var $074c1ae6a6313d04$export$2e2bcd8739ae039 = {};
$074c1ae6a6313d04$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{435}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44F}`,
    "collapse": `\u{421}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}.`,
    "descending": `\u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    "expand": `\u{420}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "resizerDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{43E}\u{432}`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{443}\u{435}\u{43C}\u{44B}\u{439} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446}`
};


var $ca7392ec7b55e895$export$2e2bcd8739ae039 = {};
$ca7392ec7b55e895$export$2e2bcd8739ae039 = {
    "ascending": `vzostupne`,
    "ascendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "collapse": `Zbali\u{165}`,
    "columnSize": (args)=>`Po\u{10D}et pixelov: ${args.value}`,
    "descending": `zostupne`,
    "descendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "expand": `Rozbali\u{165}`,
    "resizerDescription": `Stla\u{10D}en\xedm kl\xe1vesu Enter za\u{10D}nete zmenu ve\u{13E}kosti`,
    "select": `Vybra\u{165}`,
    "selectAll": `Vybra\u{165} v\u{161}etko`,
    "sortable": `zoradite\u{13E}n\xfd st\u{13A}pec`
};


var $177b7b18bbc01b7f$export$2e2bcd8739ae039 = {};
$177b7b18bbc01b7f$export$2e2bcd8739ae039 = {
    "ascending": `nara\u{161}\u{10D}ajo\u{10D}e`,
    "ascendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v nara\u{161}\u{10D}ajo\u{10D}em vrstnem redu`,
    "collapse": `Strni`,
    "columnSize": (args)=>`${args.value} slikovnih pik`,
    "descending": `padajo\u{10D}e`,
    "descendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v padajo\u{10D}em vrstnem redu`,
    "expand": `Raz\u{161}iri`,
    "resizerDescription": `Pritisnite tipko Enter da za\u{10D}nete spreminjati velikost`,
    "select": `Izberite`,
    "selectAll": `Izberite vse`,
    "sortable": `razvrstljivi stolpec`
};


var $e1227b1de8d83705$export$2e2bcd8739ae039 = {};
$e1227b1de8d83705$export$2e2bcd8739ae039 = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`sortirano po kolonama ${args.columnName} rastu\u{107}im redosledom`,
    "collapse": `Skupi`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`sortirano po kolonama ${args.columnName} padaju\u{107}im redosledom`,
    "expand": `Pro\u{161}iri`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Izaberite`,
    "selectAll": `Izaberite sve`,
    "sortable": `kolona koja se mo\u{17E}e sortirati`
};


var $19be2005752568bc$export$2e2bcd8739ae039 = {};
$19be2005752568bc$export$2e2bcd8739ae039 = {
    "ascending": `stigande`,
    "ascendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i stigande ordning`,
    "collapse": `D\xf6lj`,
    "columnSize": (args)=>`${args.value} pixlar`,
    "descending": `fallande`,
    "descendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i fallande ordning`,
    "expand": `Expandera`,
    "resizerDescription": `Tryck p\xe5 Retur f\xf6r att b\xf6rja \xe4ndra storlek`,
    "select": `Markera`,
    "selectAll": `Markera allt`,
    "sortable": `sorterbar kolumn`
};


var $3222833a6f3a2a97$export$2e2bcd8739ae039 = {};
$3222833a6f3a2a97$export$2e2bcd8739ae039 = {
    "ascending": `artan s\u{131}rada`,
    "ascendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re artan d\xfczende s\u{131}rala`,
    "collapse": `Daralt`,
    "columnSize": (args)=>`${args.value} piksel`,
    "descending": `azalan s\u{131}rada`,
    "descendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re azalan d\xfczende s\u{131}rala`,
    "expand": `Geni\u{15F}let`,
    "resizerDescription": `Yeniden boyutland\u{131}rmak i\xe7in Enter'a bas\u{131}n`,
    "select": `Se\xe7`,
    "selectAll": `T\xfcm\xfcn\xfc Se\xe7`,
    "sortable": `S\u{131}ralanabilir s\xfctun`
};


var $e8ec63dea6ae15e1$export$2e2bcd8739ae039 = {};
$e8ec63dea6ae15e1$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "ascendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{456}\u{43A}\u{441}.`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "descendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "expand": `\u{420}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{437}\u{43C}\u{456}\u{43D}\u{443} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectAll": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{435}\u{446}\u{44C}`
};


var $ff994a81094ab987$export$2e2bcd8739ae039 = {};
$ff994a81094ab987$export$2e2bcd8739ae039 = {
    "ascending": `\u{5347}\u{5E8F}`,
    "ascendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "collapse": `\u{6298}\u{53E0}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{964D}\u{5E8F}`,
    "descendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "expand": `\u{6269}\u{5C55}`,
    "resizerDescription": `\u{6309} Enter \u{5F00}\u{59CB}\u{8C03}\u{6574}\u{5927}\u{5C0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectAll": `\u{5168}\u{9009}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{5217}`
};


var $55087e278fb8c8ed$export$2e2bcd8739ae039 = {};
$55087e278fb8c8ed$export$2e2bcd8739ae039 = {
    "ascending": `\u{905E}\u{589E}`,
    "ascendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{589E}\u{6392}\u{5E8F}`,
    "collapse": `\u{6536}\u{5408}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{905E}\u{6E1B}`,
    "descendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{6E1B}\u{6392}\u{5E8F}`,
    "expand": `\u{5C55}\u{958B}`,
    "resizerDescription": `\u{6309} Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{8ABF}\u{6574}\u{5927}\u{5C0F}`,
    "select": `\u{9078}\u{53D6}`,
    "selectAll": `\u{5168}\u{9078}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{6B04}`
};


var $be149f643911f15a$export$2e2bcd8739ae039 = {};
$be149f643911f15a$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $34ac0f3783f0ae4b$export$2e2bcd8739ae039),
    "bg-BG": (0, $df0237fcbca3588e$export$2e2bcd8739ae039),
    "cs-CZ": (0, $a798a7b5bb4008f4$export$2e2bcd8739ae039),
    "da-DK": (0, $90f254dc6e9f05a2$export$2e2bcd8739ae039),
    "de-DE": (0, $2a837656cab525f2$export$2e2bcd8739ae039),
    "el-GR": (0, $cd89442be2bf132e$export$2e2bcd8739ae039),
    "en-US": (0, $9c228ca1705b5611$export$2e2bcd8739ae039),
    "es-ES": (0, $e3d07fa2df177b97$export$2e2bcd8739ae039),
    "et-EE": (0, $e8173eb7b311e985$export$2e2bcd8739ae039),
    "fi-FI": (0, $aba04ed16517b081$export$2e2bcd8739ae039),
    "fr-FR": (0, $31f2306505c4d8c8$export$2e2bcd8739ae039),
    "he-IL": (0, $812163a9c012109c$export$2e2bcd8739ae039),
    "hr-HR": (0, $a869453062b7d176$export$2e2bcd8739ae039),
    "hu-HU": (0, $cea3b0c81143014e$export$2e2bcd8739ae039),
    "it-IT": (0, $d69dbbdec29b6738$export$2e2bcd8739ae039),
    "ja-JP": (0, $4b4db5dba2307e73$export$2e2bcd8739ae039),
    "ko-KR": (0, $42bc036c3ba841e1$export$2e2bcd8739ae039),
    "lt-LT": (0, $1dccd6a57bfd34e6$export$2e2bcd8739ae039),
    "lv-LV": (0, $06255ba4590c15ab$export$2e2bcd8739ae039),
    "nb-NO": (0, $58455efb7aa32fbf$export$2e2bcd8739ae039),
    "nl-NL": (0, $172100d25168d03b$export$2e2bcd8739ae039),
    "pl-PL": (0, $106d1d6b830f247b$export$2e2bcd8739ae039),
    "pt-BR": (0, $9f993bd759e542a8$export$2e2bcd8739ae039),
    "pt-PT": (0, $7b77fc4cebe1d636$export$2e2bcd8739ae039),
    "ro-RO": (0, $bd48316b01e81806$export$2e2bcd8739ae039),
    "ru-RU": (0, $074c1ae6a6313d04$export$2e2bcd8739ae039),
    "sk-SK": (0, $ca7392ec7b55e895$export$2e2bcd8739ae039),
    "sl-SI": (0, $177b7b18bbc01b7f$export$2e2bcd8739ae039),
    "sr-SP": (0, $e1227b1de8d83705$export$2e2bcd8739ae039),
    "sv-SE": (0, $19be2005752568bc$export$2e2bcd8739ae039),
    "tr-TR": (0, $3222833a6f3a2a97$export$2e2bcd8739ae039),
    "uk-UA": (0, $e8ec63dea6ae15e1$export$2e2bcd8739ae039),
    "zh-CN": (0, $ff994a81094ab987$export$2e2bcd8739ae039),
    "zh-TW": (0, $55087e278fb8c8ed$export$2e2bcd8739ae039)
};



var $lhKAD = parcelRequire("lhKAD");


var $f7tr2 = parcelRequire("f7tr2");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $032dffb6afbd3ca1$export$da43f8f5cb04028d extends (0, $53dd6069743d4e55$export$de9feff04fda126e) {
    isCell(node) {
        return node.type === 'cell' || node.type === 'rowheader' || node.type === 'column';
    }
    getKeyBelow(key, options) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        // If focus was on a column, then focus the first child column if any,
        // or find the corresponding cell in the first row.
        if (startItem.type === 'column') {
            let child = (0, $f7tr2.getFirstItem)((0, $f7tr2.getChildNodes)(startItem, this.collection));
            if (child) return child.key;
            let firstKey = this.getFirstKey();
            if (firstKey == null) return null;
            let firstItem = this.collection.getItem(firstKey);
            if (!firstItem) return null;
            return super.getKeyForItemInRowByIndex(firstKey, startItem.index);
        }
        return super.getKeyBelow(key, options);
    }
    getKeyAbove(key, options) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        // If focus was on a column, focus the parent column if any
        if (startItem.type === 'column') {
            let parent = startItem.parentKey != null ? this.collection.getItem(startItem.parentKey) : null;
            if (parent && parent.type === 'column') return parent.key;
            return null;
        }
        // only return above row key if not header row
        let superKey = super.getKeyAbove(key, options);
        let superItem = superKey != null ? this.collection.getItem(superKey) : null;
        if (superItem && superItem.type !== 'headerrow') return superKey;
        // If no item was found, and focus was on a cell, then focus the
        // corresponding column header.
        if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
        // If focus was on a row, then focus the first column header.
        return this.collection.columns[0].key;
    }
    findNextColumnKey(column) {
        // Search following columns
        let key = this.findNextKey(column.key, (item)=>item.type === 'column');
        if (key != null) return key;
        // Wrap around to the first column
        let row = this.collection.headerRows[column.level];
        for (let item of (0, $f7tr2.getChildNodes)(row, this.collection)){
            if (item.type === 'column') return item.key;
        }
        return null;
    }
    findPreviousColumnKey(column) {
        // Search previous columns
        let key = this.findPreviousKey(column.key, (item)=>item.type === 'column');
        if (key != null) return key;
        // Wrap around to the last column
        let row = this.collection.headerRows[column.level];
        let childNodes = [
            ...(0, $f7tr2.getChildNodes)(row, this.collection)
        ];
        for(let i = childNodes.length - 1; i >= 0; i--){
            let item = childNodes[i];
            if (item.type === 'column') return item.key;
        }
        return null;
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus was on a column, then focus the next column
        if (item.type === 'column') return this.direction === 'rtl' ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
        return super.getKeyRightOf(key);
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus was on a column, then focus the previous column
        if (item.type === 'column') return this.direction === 'rtl' ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
        return super.getKeyLeftOf(key);
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey ?? this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem?.type === 'cell') key = startItem.parentKey ?? null;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            if (item.textValue) {
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) return item.key;
            }
            // Check each of the row header cells in this row for a match
            for (let cell of (0, $f7tr2.getChildNodes)(item, this.collection)){
                let column = collection.columns[cell.index];
                if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
                    let substring = cell.textValue.slice(0, search.length);
                    if (this.collator.compare(substring, search) === 0) {
                        // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                        let fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                        return fromItem?.type === 'cell' ? cell.key : item.key;
                    }
                }
            }
            key = this.getKeyBelow(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
}



var $gm31e = parcelRequire("gm31e");

var $lXRQr = parcelRequire("lXRQr");

var $25dFS = parcelRequire("25dFS");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $lXemd = parcelRequire("lXemd");

var $eF4cA = parcelRequire("eF4cA");
function $14b231632eb972d2$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $14b231632eb972d2$export$25bceaac3c7e4dc7(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate, isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, layout: layout } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $gm31e.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, $eF4cA.useMemo)(()=>keyboardDelegate || new (0, $032dffb6afbd3ca1$export$da43f8f5cb04028d)({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            direction: direction,
            collator: collator,
            layoutDelegate: layoutDelegate,
            layout: layout
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        layoutDelegate,
        layout
    ]);
    let id = (0, $25dFS.useId)(props.id);
    (0, $25e46ab2c7f47034$export$552312adfd451dab).set(state, id);
    let { gridProps: gridProps } = (0, $96b970ef77c54f6f$export$f6b86a04e5d66d90)({
        ...props,
        id: id,
        keyboardDelegate: delegate
    }, state, ref);
    // Override to include header rows
    if (isVirtualized) gridProps['aria-rowcount'] = state.collection.size + state.collection.headerRows.length;
    if (state.treeColumn != null) gridProps.role = 'treegrid';
    let { column: column, direction: sortDirection } = state.sortDescriptor || {};
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($14b231632eb972d2$var$$parcel$interopDefault((0, $be149f643911f15a$export$2e2bcd8739ae039)), '@react-aria/table');
    let sortDescription = (0, $eF4cA.useMemo)(()=>{
        let columnName = state.collection.columns.find((c)=>c.key === column)?.textValue ?? '';
        return sortDirection && column ? stringFormatter.format(`${sortDirection}Sort`, {
            columnName: columnName
        }) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortDirection,
        column,
        state.collection.columns
    ]);
    let descriptionProps = (0, $lXRQr.useDescription)(sortDescription);
    (0, $lXemd.useUpdateEffect)(()=>{
        if (sortDescription) (0, $4HiHF.announce)(sortDescription, 'assertive', 500);
    }, [
        sortDescription
    ]);
    return {
        gridProps: (0, $lhKAD.mergeProps)(gridProps, descriptionProps, {
            // merge sort description with long press information
            'aria-describedby': [
                descriptionProps['aria-describedby'],
                gridProps['aria-describedby']
            ].filter(Boolean).join(' ')
        })
    };
}



var $eNuje = parcelRequire("eNuje");

var $fvyIQ = parcelRequire("fvyIQ");

var $6pgkA = parcelRequire("6pgkA");

var $7ByPJ = parcelRequire("7ByPJ");

var $5AGOf = parcelRequire("5AGOf");


var $YxOvP = parcelRequire("YxOvP");

var $lhKAD = parcelRequire("lhKAD");

var $3lc2m = parcelRequire("3lc2m");

var $1ntKq = parcelRequire("1ntKq");

var $hNw9N = parcelRequire("hNw9N");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9bd83868def89e6f$export$c7e10bfc0c59f67c(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized, focusMode: focusModeProp, allowsArrowNavigation: allowsArrowNavigation, shouldSelectOnPressUp: shouldSelectOnPressUp, onAction: onAction } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { keyboardDelegate: keyboardDelegate, actions: { onCellAction: onCellAction }, keyboardNavigationBehavior: keyboardNavigationBehavior } = (0, $1fbe9494e8e847d1$export$e6235c0d09b995d0).get(state);
    let focusMode = focusModeProp ?? (keyboardNavigationBehavior === 'tab' ? 'cell' : 'child');
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, $eF4cA.useRef)(null);
    // Tracks the specific focusable child that was last focused within this cell.
    let lastFocusedChild = (0, $eF4cA.useRef)(null);
    // Handles focusing the cell. If there is a focusable child,
    // it is focused, otherwise the cell itself is focused.
    let focus = ()=>{
        if (ref.current) {
            let treeWalker = (0, $6pgkA.getFocusableTreeWalker)(ref.current);
            if (focusMode === 'child') {
                let activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current));
                // If focus is already on a focusable child within the cell, early return so we don't shift focus
                if ((0, $fvyIQ.isFocusWithin)(ref.current) && ref.current !== activeElement) return;
                let ownerDocument = (0, $7ByPJ.getOwnerDocument)(ref.current);
                let shouldRestoreToLastFocused = !activeElement || activeElement === ownerDocument.body || activeElement === ref.current;
                if (shouldRestoreToLastFocused) {
                    let lastChild = lastFocusedChild.current;
                    if (lastChild && keyWhenFocused.current === node.key && (0, $fvyIQ.nodeContains)(ref.current, lastChild)) {
                        (0, $eNuje.focusSafely)(lastChild);
                        return;
                    }
                }
                let focusable = state.selectionManager.childFocusStrategy === 'last' ? $9bd83868def89e6f$var$$a4d729ad50b8576a$var$last(treeWalker) : treeWalker.firstChild();
                if (focusable) {
                    (0, $eNuje.focusSafely)(focusable);
                    return;
                }
            }
            if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !(0, $fvyIQ.isFocusWithin)(ref.current)) (0, $eNuje.focusSafely)(ref.current);
        }
    };
    let { itemProps: itemProps, isPressed: isPressed } = (0, $hNw9N.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        focus: focus,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onCellAction ? ()=>onCellAction(node.key) : onAction,
        isDisabled: state.collection.size === 0
    });
    let onKeyDownCapture = (e)=>{
        let activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current));
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e)) || state.isKeyboardNavigationDisabled || !ref.current || !activeElement) return;
        let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current);
        walker.currentNode = activeElement;
        switch(e.key){
            case 'ArrowLeft':
                {
                    // Find the next focusable element within the cell.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    // Don't focus the cell itself if focusMode is "child"
                    if (focusMode === 'child' && focusable === ref.current) focusable = null;
                    e.preventDefault();
                    e.stopPropagation();
                    if (focusable) {
                        (0, $eNuje.focusSafely)(focusable);
                        (0, $3lc2m.scrollIntoViewport)(focusable, {
                            containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then move to the next cell to the left of this one.
                        // This will be handled by useSelectableCollection. However, if there is no cell to the left
                        // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
                        // same as this one. In that case we need to handle focusing either the cell or the first/last
                        // child, depending on the focus mode.
                        let prev = keyboardDelegate.getKeyLeftOf?.(node.key);
                        if (prev !== node.key) {
                            // We prevent the capturing event from reaching children of the cell, e.g. pickers.
                            // We want arrow keys to navigate to the next cell instead. We need to re-dispatch
                            // the event from a higher parent so it still bubbles and gets handled by useSelectableCollection.
                            ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                            break;
                        }
                        if (focusMode === 'cell' && direction === 'rtl') {
                            (0, $eNuje.focusSafely)(ref.current);
                            (0, $3lc2m.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === 'rtl' ? walker.firstChild() : $9bd83868def89e6f$var$$a4d729ad50b8576a$var$last(walker);
                            if (focusable) {
                                (0, $eNuje.focusSafely)(focusable);
                                (0, $3lc2m.scrollIntoViewport)(focusable, {
                                    containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case 'ArrowRight':
                {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusMode === 'child' && focusable === ref.current) focusable = null;
                    e.preventDefault();
                    e.stopPropagation();
                    if (focusable) {
                        (0, $eNuje.focusSafely)(focusable);
                        (0, $3lc2m.scrollIntoViewport)(focusable, {
                            containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                        });
                    } else {
                        let next = keyboardDelegate.getKeyRightOf?.(node.key);
                        if (next !== node.key) {
                            // We prevent the capturing event from reaching children of the cell, e.g. pickers.
                            // We want arrow keys to navigate to the next cell instead. We need to re-dispatch
                            // the event from a higher parent so it still bubbles and gets handled by useSelectableCollection.
                            ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                            break;
                        }
                        if (focusMode === 'cell' && direction === 'ltr') {
                            (0, $eNuje.focusSafely)(ref.current);
                            (0, $3lc2m.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === 'rtl' ? $9bd83868def89e6f$var$$a4d729ad50b8576a$var$last(walker) : walker.firstChild();
                            if (focusable) {
                                (0, $eNuje.focusSafely)(focusable);
                                (0, $3lc2m.scrollIntoViewport)(focusable, {
                                    containingElement: (0, $5AGOf.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
                // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && (0, $fvyIQ.nodeContains)(ref.current, (0, $fvyIQ.getEventTarget)(e))) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onKeyDown = (e)=>{
        let activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current));
        if (!(0, $fvyIQ.nodeContains)(e.currentTarget, (0, $fvyIQ.getEventTarget)(e)) || state.isKeyboardNavigationDisabled || !ref.current || !activeElement) return;
        if (keyboardNavigationBehavior === 'tab') {
            if ((0, $fvyIQ.getEventTarget)(e) !== ref.current && e.key !== 'Tab') {
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    // Grid cells can have focusable elements inside them. In this case, focus should
    // be marshalled to that element rather than focusing the cell itself.
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if ((0, $fvyIQ.getEventTarget)(e) !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the gridcell itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row/cell
            // in that case since the table should act like a single tab stop.
            let target = (0, $fvyIQ.getEventTarget)(e);
            if (ref.current && (0, $fvyIQ.nodeContains)(ref.current, target)) lastFocusedChild.current = target;
            if (!(0, $YxOvP.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
        // if focus goes back to cell from child, make sure we don't refocus the cell if we are in focusMode=child
        // since that would be a focus trap
        if (focusMode === 'child' && e.relatedTarget && (0, $fvyIQ.nodeContains)(ref.current, e.relatedTarget)) return;
        // If the cell itself is focused, wait a frame so that focus finishes propagating
        // up to the tree, and move focus to a focusable child if possible.
        requestAnimationFrame(()=>{
            if (focusMode === 'child' && (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(ref.current)) === ref.current) focus();
        });
    };
    // oxlint-disable-next-line react/react-compiler
    let gridCellProps = (0, $lhKAD.mergeProps)(itemProps, {
        role: 'gridcell',
        onKeyDownCapture: keyboardNavigationBehavior !== 'tab' || allowsArrowNavigation ? onKeyDownCapture : undefined,
        onKeyDown: keyboardNavigationBehavior === 'tab' ? onKeyDown : undefined,
        'aria-colspan': node.colSpan,
        'aria-colindex': node.colIndex != null ? node.colIndex + 1 : undefined,
        colSpan: isVirtualized ? undefined : node.colSpan,
        onFocus: onFocus,
        // make sure shift tabbing from a child of a cell doesnt move focus back to cell if focusMode="child" and in tab nav
        // consistent with arrow nav and focusMode="child" since you can't go back to the cell there either
        ...focusMode === 'child' && keyboardNavigationBehavior === 'tab' ? {
            tabIndex: -1
        } : {}
    });
    if (isVirtualized) gridCellProps['aria-colindex'] = (node.colIndex ?? node.index) + 1; // aria-colindex is 1-based
    // When pressing with a pointer and cell selection is not enabled, usePress will be applied to the
    // row rather than the cell. However, when the row is draggable, usePress cannot preventDefault
    // on pointer down, so the browser will try to focus the cell which has a tabIndex applied.
    // To avoid this, remove the tabIndex from the cell briefly on pointer down.
    if (shouldSelectOnPressUp && gridCellProps.tabIndex != null && gridCellProps.onPointerDown == null) gridCellProps.onPointerDown = (e)=>{
        let el = e.currentTarget;
        let tabindex = el.getAttribute('tabindex');
        el.removeAttribute('tabindex');
        requestAnimationFrame(()=>{
            if (tabindex != null) el.setAttribute('tabindex', tabindex);
        });
    };
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}
function $9bd83868def89e6f$var$$a4d729ad50b8576a$var$last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d2dc909a7cd2ecbd$export$49571c903d73624c(props, state, ref) {
    let { gridCellProps: gridCellProps, isPressed: isPressed } = (0, $9bd83868def89e6f$export$c7e10bfc0c59f67c)(props, state, ref);
    let columnKey = props.node.column?.key;
    if (columnKey != null && state.collection.rowHeaderColumnKeys.has(columnKey)) {
        // oxlint-disable-next-line react/react-compiler
        gridCellProps.role = 'rowheader';
        // oxlint-disable-next-line react/react-compiler
        gridCellProps.id = (0, $25e46ab2c7f47034$export$19baff3266315d44)(state, props.node.parentKey, columnKey);
    }
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}




var $11FxZ = parcelRequire("11FxZ");

var $lhKAD = parcelRequire("lhKAD");

var $lXRQr = parcelRequire("lXRQr");

var $8M8Qw = parcelRequire("8M8Qw");


var $gI8Gw = parcelRequire("gI8Gw");

var $bEes0 = parcelRequire("bEes0");

var $eF4cA = parcelRequire("eF4cA");
function $75281188f9e82bc0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $75281188f9e82bc0$export$9514819a8c81e960(props, state, ref) {
    let { node: node } = props;
    let allowsSorting = node.props.allowsSorting;
    let { gridCellProps: gridCellProps } = (0, $9bd83868def89e6f$export$c7e10bfc0c59f67c)({
        focusMode: 'child',
        ...props
    }, state, ref);
    let isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === 'single';
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        isDisabled: !allowsSorting || isSelectionCellDisabled,
        onPress () {
            state.sort(node.key);
        },
        ref: ref
    });
    // Needed to pick up the focusable context, enabling things like Tooltips for example
    let { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)({}, ref);
    let ariaSort = undefined;
    let isSortedColumn = state.sortDescriptor?.column === node.key;
    let sortDirection = state.sortDescriptor?.direction;
    // aria-sort not supported in Android Talkback
    if (node.props.allowsSorting && !(0, $11FxZ.isAndroid)()) ariaSort = isSortedColumn ? sortDirection : 'none';
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($75281188f9e82bc0$var$$parcel$interopDefault((0, $be149f643911f15a$export$2e2bcd8739ae039)), '@react-aria/table');
    let sortDescription;
    if (allowsSorting) {
        sortDescription = `${stringFormatter.format('sortable')}`;
        // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
        if (isSortedColumn && sortDirection && (0, $11FxZ.isAndroid)()) sortDescription = `${sortDescription}, ${stringFormatter.format(sortDirection)}`;
    }
    let descriptionProps = (0, $lXRQr.useDescription)(sortDescription);
    let shouldDisableFocus = state.collection.size === 0;
    (0, $eF4cA.useEffect)(()=>{
        if (shouldDisableFocus && state.selectionManager.focusedKey === node.key) state.selectionManager.setFocusedKey(null);
    }, [
        shouldDisableFocus,
        state.selectionManager,
        node.key
    ]);
    return {
        columnHeaderProps: {
            ...(0, $lhKAD.mergeProps)(focusableProps, gridCellProps, pressProps, descriptionProps, shouldDisableFocus ? {
                tabIndex: -1
            } : null),
            role: 'columnheader',
            id: (0, $25e46ab2c7f47034$export$37cd4213f2ad742e)(state, node.key),
            'aria-colspan': node.colSpan && node.colSpan > 1 ? node.colSpan : undefined,
            'aria-sort': ariaSort
        },
        isPressed: isPressed
    };
}


var $eNuje = parcelRequire("eNuje");

var $fvyIQ = parcelRequire("fvyIQ");



var $lhKAD = parcelRequire("lhKAD");

var $lXRQr = parcelRequire("lXRQr");

var $4lMDe = parcelRequire("4lMDe");

var $25dFS = parcelRequire("25dFS");

var $YxOvP = parcelRequire("YxOvP");

var $aGDvF = parcelRequire("aGDvF");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $gvTw2 = parcelRequire("gvTw2");

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $4lMDe = parcelRequire("4lMDe");

var $ed0Y6 = parcelRequire("ed0Y6");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $03126158ef85403f$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $eF4cA.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $ed0Y6.useGlobalListeners)();
    let move = (0, $eF4cA.useCallback)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart?.({
                type: 'movestart',
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove?.({
            type: 'move',
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    }, [
        onMoveStart,
        onMove,
        state
    ]);
    let moveEvent = (0, $4lMDe.useEffectEvent)(move);
    let end = (0, $eF4cA.useCallback)((originalEvent, pointerType)=>{
        (0, $gvTw2.restoreTextSelection)();
        if (state.current.didMove) onMoveEnd?.({
            type: 'moveend',
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    }, [
        onMoveEnd,
        state
    ]);
    let endEvent = (0, $4lMDe.useEffectEvent)(end);
    let moveProps = (0, $eF4cA.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            (0, $gvTw2.disableTextSelection)();
            state.current.didMove = false;
        };
        typeof PointerEvent;
        var e, e1;
        {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    moveEvent(e, pointerType, e.pageX - (state.current.lastPosition?.pageX ?? 0), e.pageY - (state.current.lastPosition?.pageY ?? 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    endEvent(e, pointerType);
                    state.current.id = null;
                    let ownerWindow = (0, $7ByPJ.getOwnerWindow)((0, $fvyIQ.getEventTarget)(e));
                    removeGlobalListener(ownerWindow, 'pointermove', onPointerMove, false);
                    removeGlobalListener(ownerWindow, 'pointerup', onPointerUp, false);
                    removeGlobalListener(ownerWindow, 'pointercancel', onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    let ownerWindow = (0, $7ByPJ.getOwnerWindow)((0, $fvyIQ.getEventTarget)(e));
                    addGlobalListener(ownerWindow, 'pointermove', onPointerMove, false);
                    addGlobalListener(ownerWindow, 'pointerup', onPointerUp, false);
                    addGlobalListener(ownerWindow, 'pointercancel', onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            moveEvent(e, 'keyboard', deltaX, deltaY);
            endEvent(e, 'keyboard');
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case 'Left':
                case 'ArrowLeft':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case 'Right':
                case 'ArrowRight':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case 'Up':
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case 'Down':
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        addGlobalListener,
        removeGlobalListener,
        state
    ]);
    return {
        moveProps: moveProps
    };
}



var $bEes0 = parcelRequire("bEes0");

var $31fH3 = parcelRequire("31fH3");

var $eF4cA = parcelRequire("eF4cA");
function $a600943036a15f41$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a600943036a15f41$export$52994e973806c219(props, state, ref) {
    let { column: item, triggerRef: triggerRef, isDisabled: isDisabled, onResizeStart: onResizeStart, onResize: onResize, onResizeEnd: onResizeEnd, 'aria-label': ariaLabel } = props;
    const stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($a600943036a15f41$var$$parcel$interopDefault((0, $be149f643911f15a$export$2e2bcd8739ae039)), '@react-aria/table');
    let id = (0, $25dFS.useId)();
    let isResizing = state.resizingColumn === item.key;
    let isResizingRef = (0, $eF4cA.useRef)(isResizing);
    let lastSize = (0, $eF4cA.useRef)(null);
    let wasFocusedOnResizeStart = (0, $eF4cA.useRef)(false);
    let editModeEnabled = state.tableState.isKeyboardNavigationDisabled;
    // Whether a mouse drag-resize is active. Set on the first move (not on press) so a cursor
    // overlay only mounts during an actual drag.
    let [isMouseResizing, setMouseResizing] = (0, $eF4cA.useState)(false);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let startResize = (0, $eF4cA.useCallback)((item)=>{
        if (!isResizingRef.current) {
            lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
            state.startResize(item.key);
            state.tableState.setKeyboardNavigationDisabled(true);
            onResizeStart?.(lastSize.current);
        }
        isResizingRef.current = true;
    }, [
        state,
        onResizeStart
    ]);
    let resize = (0, $eF4cA.useCallback)((item, newWidth)=>{
        let sizes = state.updateResizedColumns(item.key, newWidth);
        onResize?.(sizes);
        lastSize.current = sizes;
    }, [
        state,
        onResize
    ]);
    let endResize = (0, $eF4cA.useCallback)((item)=>{
        if (isResizingRef.current) {
            if (lastSize.current == null) lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
            state.endResize();
            state.tableState.setKeyboardNavigationDisabled(false);
            onResizeEnd?.(lastSize.current);
            isResizingRef.current = false;
            if (triggerRef?.current && !wasFocusedOnResizeStart.current) (0, $eNuje.focusSafely)(triggerRef.current);
        }
        lastSize.current = null;
    }, [
        state,
        triggerRef,
        onResizeEnd
    ]);
    let endResizeEvent = ()=>{
        if (editModeEnabled) {
            endResize(item);
            return;
        }
        return false;
    };
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            Escape: ()=>{
                return endResizeEvent();
            },
            Enter: ()=>{
                if (editModeEnabled) endResize(item);
                else startResize(item);
            },
            ' ': ()=>{
                return endResizeEvent();
            },
            Tab: ()=>{
                return endResizeEvent();
            }
        }
    });
    const columnResizeWidthRef = (0, $eF4cA.useRef)(0);
    const { moveProps: moveProps } = (0, $03126158ef85403f$export$36da96379f79f245)({
        onMoveStart (e) {
            columnResizeWidthRef.current = state.getColumnWidth(item.key);
            if (e.pointerType === 'mouse') setMouseResizing(true);
            startResize(item);
        },
        onMove (e) {
            let { deltaX: deltaX, deltaY: deltaY, pointerType: pointerType } = e;
            if (direction === 'rtl') deltaX *= -1;
            if (pointerType === 'keyboard') {
                if (deltaY !== 0 && deltaX === 0) deltaX = deltaY * -1;
                deltaX *= 10;
            }
            // if moving up/down only, no need to resize
            if (deltaX !== 0) {
                columnResizeWidthRef.current += deltaX;
                resize(item, columnResizeWidthRef.current);
            }
        },
        onMoveEnd (e) {
            let { pointerType: pointerType } = e;
            columnResizeWidthRef.current = 0;
            setMouseResizing(false);
            if (pointerType === 'mouse' || pointerType === 'touch' && wasFocusedOnResizeStart.current) endResize(item);
        }
    });
    let onKeyDown = (0, $eF4cA.useCallback)((e)=>{
        if (editModeEnabled) moveProps.onKeyDown?.(e);
    }, [
        editModeEnabled,
        moveProps
    ]);
    let min = Math.floor(state.getColumnMinWidth(item.key));
    let max = Math.floor(state.getColumnMaxWidth(item.key));
    if (max === Infinity) max = Number.MAX_SAFE_INTEGER;
    let value = Math.floor(state.getColumnWidth(item.key));
    let modality = (0, $YxOvP.useInteractionModality)();
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'touch';
    let description = triggerRef?.current == null && (modality === 'keyboard' || modality === 'virtual') && !isResizing ? stringFormatter.format('resizerDescription') : undefined;
    let descriptionProps = (0, $lXRQr.useDescription)(description);
    let ariaProps = {
        'aria-label': ariaLabel,
        'aria-orientation': 'horizontal',
        'aria-labelledby': `${id} ${(0, $25e46ab2c7f47034$export$37cd4213f2ad742e)(state.tableState, item.key)}`,
        'aria-valuetext': stringFormatter.format('columnSize', {
            value: value
        }),
        type: 'range',
        min: min,
        max: max,
        value: value,
        ...descriptionProps
    };
    const focusInput = (0, $eF4cA.useCallback)(()=>{
        if (ref.current) (0, $eNuje.focusSafely)(ref.current);
    }, [
        ref
    ]);
    let resizingColumn = state.resizingColumn;
    let prevResizingColumn = (0, $eF4cA.useRef)(null);
    let startResizeEvent = (0, $4lMDe.useEffectEvent)(startResize);
    (0, $eF4cA.useEffect)(()=>{
        if (prevResizingColumn.current !== resizingColumn && resizingColumn != null && resizingColumn === item.key) {
            wasFocusedOnResizeStart.current = (0, $fvyIQ.getActiveElement)() === ref.current;
            startResizeEvent(item);
            // Delay focusing input until Android Chrome's delayed click after touchend happens: https://bugs.chromium.org/p/chromium/issues/detail?id=1150073
            let timeout = setTimeout(()=>focusInput(), 0);
            // VoiceOver on iOS has problems focusing the input from a menu.
            let VOTimeout = setTimeout(focusInput, 400);
            return ()=>{
                clearTimeout(timeout);
                clearTimeout(VOTimeout);
            };
        }
        prevResizingColumn.current = resizingColumn;
    }, [
        resizingColumn,
        item,
        focusInput,
        ref
    ]);
    let onChange = (e)=>{
        let currentWidth = state.getColumnWidth(item.key);
        let nextValue = parseFloat((0, $fvyIQ.getEventTarget)(e).value);
        if (nextValue > currentWidth) nextValue = currentWidth + 10;
        else nextValue = currentWidth - 10;
        resize(item, nextValue);
    };
    let { pressProps: pressProps } = (0, $bEes0.usePress)({
        preventFocusOnPress: true,
        onPressStart: (e)=>{
            if (e.ctrlKey || e.altKey || e.metaKey || e.shiftKey || e.pointerType === 'keyboard') return;
            if (e.pointerType === 'virtual' && state.resizingColumn != null) {
                endResize(item);
                return;
            }
            // Sometimes onPress won't trigger for quick taps on mobile so we want to focus the input so blurring away
            // can cancel resize mode for us.
            focusInput();
            // If resizer is always visible, mobile screenreader user can access the visually hidden resizer directly and thus we don't need
            // to handle a virtual click to start the resizer.
            if (e.pointerType !== 'virtual') startResize(item);
        },
        onPress: (e)=>{
            if ((e.pointerType === 'touch' && wasFocusedOnResizeStart.current || e.pointerType === 'mouse') && state.resizingColumn != null) endResize(item);
        }
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    return {
        resizerProps: (0, $lhKAD.mergeProps)(keyboardProps, {
            ...moveProps,
            onKeyDown: onKeyDown
        }, pressProps, {
            style: {
                touchAction: 'none'
            }
        }),
        inputProps: (0, $lhKAD.mergeProps)(visuallyHiddenProps, {
            id: id,
            onBlur: ()=>{
                endResize(item);
            },
            onChange: onChange,
            disabled: isDisabled
        }, ariaProps),
        isResizing: isResizing,
        isMouseResizing: isMouseResizing
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7fdba76a9b1d6911$export$1b95a7d2d517b841(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized } = props;
    let rowProps = {
        role: 'row'
    };
    if (isVirtualized && state.treeColumn == null) rowProps['aria-rowindex'] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps
    };
}



var $d8j5I = parcelRequire("d8j5I");


var $hNw9N = parcelRequire("hNw9N");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2bd8b01e20801976$export$96357d5a73f686fa(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized, shouldSelectOnPressUp: shouldSelectOnPressUp, onAction: onAction } = props;
    let { actions: actions, shouldSelectOnPressUp: gridShouldSelectOnPressUp } = (0, $1fbe9494e8e847d1$export$e6235c0d09b995d0).get(state);
    let onRowAction = actions.onRowAction ? ()=>actions.onRowAction?.(node.key) : onAction;
    let { itemProps: itemProps, ...states } = (0, $hNw9N.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: gridShouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onRowAction || node?.props?.onAction ? (0, $d8j5I.chain)(node?.props?.onAction, onRowAction) : undefined,
        isDisabled: state.collection.size === 0
    });
    let isSelected = state.selectionManager.isSelected(node.key);
    let rowProps = {
        role: 'row',
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined,
        'aria-disabled': states.isDisabled || undefined,
        ...itemProps
    };
    if (isVirtualized) rowProps['aria-rowindex'] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps,
        ...states
    };
}




var $lhKAD = parcelRequire("lhKAD");

var $dkaC0 = parcelRequire("dkaC0");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $aGgVM = parcelRequire("aGgVM");
function $9a45af121db968c1$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9a45af121db968c1$var$$d5954d038bf91c37$var$EXPANSION_KEYS = {
    expand: {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    collapse: {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function $9a45af121db968c1$export$7f2f6ae19e707aa5(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized } = props;
    let { rowProps: rowProps, ...states } = (0, $2bd8b01e20801976$export$96357d5a73f686fa)(props, state, ref);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    if (isVirtualized && state.treeColumn == null) rowProps['aria-rowindex'] = node.index + 1 + state.collection.headerRows.length; // aria-rowindex is 1 based
    else delete rowProps['aria-rowindex'];
    let isExpanded = state.treeColumn != null && (state.expandedKeys === 'all' || state.expandedKeys.has(node.key));
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($9a45af121db968c1$var$$parcel$interopDefault((0, $be149f643911f15a$export$2e2bcd8739ae039)), '@react-aria/table');
    let labelProps = (0, $dkaC0.useLabels)({
        'aria-label': isExpanded ? stringFormatter.format('collapse') : stringFormatter.format('expand'),
        'aria-labelledby': (0, $25e46ab2c7f47034$export$85069b70317f543)(state, node.key)
    });
    let treeGridRowProps = {};
    let expandButtonProps = {};
    if (state.treeColumn != null) {
        let treeNode = state.collection.getItem(node.key);
        if (treeNode != null) {
            let lastChild = $9a45af121db968c1$var$$d5954d038bf91c37$var$getLastChild(state.collection, node);
            let hasChildRows = treeNode.props?.hasChildRows || treeNode.props?.UNSTABLE_childItems || lastChild?.type !== 'cell';
            let parent = state.collection.getItem(node.parentKey);
            let isParentBody = parent.type === 'tablebody' || parent.type === 'body';
            let lastSibling = $9a45af121db968c1$var$$d5954d038bf91c37$var$getLastChild(state.collection, parent);
            while(lastSibling && lastSibling.type !== 'item' && lastSibling.prevKey != null)lastSibling = state.collection.getItem(lastSibling.prevKey);
            treeGridRowProps = {
                onKeyDown: (e)=>{
                    if (e.key === $9a45af121db968c1$var$$d5954d038bf91c37$var$EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && state.expandedKeys !== 'all' && !state.expandedKeys.has(treeNode.key)) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    } else if (e.key === $9a45af121db968c1$var$$d5954d038bf91c37$var$EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === treeNode.key) {
                        if (state.expandedKeys !== 'all') {
                            if (hasChildRows && state.expandedKeys.has(treeNode.key)) {
                                state.toggleKey(treeNode.key);
                                e.stopPropagation();
                            } else if (!state.expandedKeys.has(treeNode.key) && treeNode.parentKey != null && treeNode.level > 0) {
                                // Item is a leaf or already collapsed, move focus to parent
                                state.selectionManager.setFocusedKey(treeNode.parentKey);
                                e.stopPropagation();
                            }
                        } else if (state.expandedKeys === 'all') {
                            state.toggleKey(treeNode.key);
                            e.stopPropagation();
                        }
                    }
                },
                'aria-expanded': hasChildRows ? state.expandedKeys === 'all' || state.expandedKeys.has(node.key) : undefined,
                'aria-level': treeNode.level + 1,
                'aria-posinset': treeNode.index - (isParentBody ? 0 : state.collection.columnCount) + 1,
                'aria-setsize': lastSibling.index - (isParentBody ? 0 : state.collection.columnCount) + 1
            };
            expandButtonProps = {
                isDisabled: states.isDisabled,
                onPress: ()=>{
                    if (!states.isDisabled) {
                        state.toggleKey(node.key);
                        state.selectionManager.setFocused(true);
                        state.selectionManager.setFocusedKey(node.key);
                    }
                },
                excludeFromTabOrder: true,
                preventFocusOnPress: true,
                // @ts-ignore
                'data-react-aria-prevent-focus': true,
                ...labelProps
            };
        }
    }
    let syntheticLinkProps = (0, $aGgVM.useSyntheticLinkProps)(node.props);
    let linkProps = states.hasAction ? syntheticLinkProps : {};
    return {
        rowProps: {
            ...(0, $lhKAD.mergeProps)(rowProps, treeGridRowProps, linkProps),
            'aria-labelledby': (0, $25e46ab2c7f47034$export$85069b70317f543)(state, node.key)
        },
        expandButtonProps: expandButtonProps,
        ...states
    };
}
function $9a45af121db968c1$var$$d5954d038bf91c37$var$getLastChild(collection, node) {
    if ('lastChildKey' in node) return node.lastChildKey != null ? collection.getItem(node.lastChildKey) : null;
    else return Array.from(node.childNodes).findLast((item)=>item.parentKey === node.key);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $478315c82ece9121$export$d3037f5d3f3e51bf() {
    return {
        rowGroupProps: {
            role: 'rowgroup'
        }
    };
}


/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $599063176fe1c245$export$6fb1613bd7b28198() {
    return (0, $478315c82ece9121$export$d3037f5d3f3e51bf)();
}





var $gI8Gw = parcelRequire("gI8Gw");
function $015ee9e13fd62e05$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $015ee9e13fd62e05$export$16ea7f650bd7c1bb(props, state) {
    let { key: key } = props;
    const { checkboxProps: checkboxProps } = (0, $398321077e72958b$export$70e2eed1a92976ad)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, $25e46ab2c7f47034$export$85069b70317f543)(state, key)}`
        }
    };
}
function $015ee9e13fd62e05$export$1003db6a7e384b99(state) {
    let { isEmpty: isEmpty, isSelectAll: isSelectAll, selectionMode: selectionMode } = state.selectionManager;
    const stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($015ee9e13fd62e05$var$$parcel$interopDefault((0, $be149f643911f15a$export$2e2bcd8739ae039)), '@react-aria/table');
    return {
        checkboxProps: {
            'aria-label': stringFormatter.format(selectionMode === 'single' ? 'select' : 'selectAll'),
            isSelected: isSelectAll,
            isDisabled: selectionMode !== 'multiple' || state.collection.size === 0 || state.collection.rows.length === 1 && state.collection.rows[0].type === 'loader',
            isIndeterminate: !isEmpty && !isSelectAll,
            onChange: ()=>state.selectionManager.toggleSelectAll()
        }
    };
}



var $31fH3 = parcelRequire("31fH3");
function $167a69a603174653$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableCollection extends (0, $bWhaY.BaseCollection) {
    withExpandedKeys(expandedKeys) {
        let collection = this.clone();
        collection.expandedKeys = expandedKeys;
        collection.frozen = this.frozen;
        collection.rows = Array.from(collection.getRows());
        return collection;
    }
    addNode(node) {
        super.addNode(node);
        this.columnsDirty ||= node.type === 'column';
        if (node.type === 'tableheader') this.head = node;
    }
    getRows() {
        let rows = [];
        for (let child of this)if (child.type === 'tablebody' || child.type === 'tablefooter') rows.push(...this.getChildren(child.key));
        return rows;
    }
    // backward compatibility
    get body() {
        for (let child of this){
            if (child.type === 'tablebody') return child;
        }
        return new $167a69a603174653$var$$76d00c5a4edb230a$var$TableBodyNode(-2);
    }
    commit(firstKey, lastKey, isSSR = false) {
        this.updateColumns(isSSR);
        this.firstKey = firstKey;
        this.lastKey = lastKey;
        this.rows = [];
        for (let row of this.getRows()){
            let lastChildKey = row.lastChildKey;
            if (lastChildKey != null) {
                let lastCell = this.getItem(lastChildKey);
                while(lastCell && lastCell.type !== 'cell')lastCell = lastCell.prevKey != null ? this.getItem(lastCell.prevKey) : null;
                if (lastCell) {
                    let numberOfCellsInRow = (lastCell.colIndex ?? lastCell.index) + (lastCell.colSpan ?? 1);
                    if (numberOfCellsInRow !== this.columns.length && !isSSR) throw new Error(`Cell count must match column count. Found ${numberOfCellsInRow} cells and ${this.columns.length} columns.`);
                }
            }
            this.rows.push(row);
        }
        super.commit(firstKey, lastKey, isSSR);
    }
    updateColumns(isSSR) {
        if (!this.columnsDirty) return;
        this.rowHeaderColumnKeys = new Set();
        this.columns = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case 'column':
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        node.index = this.columns.length;
                        this.columns.push(node);
                        if (node.props.isRowHeader) this.rowHeaderColumnKeys.add(node.key);
                    }
                    break;
            }
            for (let child of this.getChildren(node.key))visit(child);
        };
        for (let node of this.getChildren(this.head.key))visit(node);
        this.headerRows = (0, $49021bac7ed2e468$export$7c127db850d4e81e)(columnKeyMap, this.columns);
        this.columnsDirty = false;
        if (this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !isSSR) throw new Error('A table must have at least one Column with the isRowHeader prop set to true');
    }
    get columnCount() {
        return this.columns.length;
    }
    *[Symbol.iterator]() {
        let key = this.firstKey;
        while(key != null){
            let node = this.getItem(key);
            if (node) yield node;
            key = node?.nextKey ?? null;
        }
    }
    getFirstKey() {
        for (let child of this){
            if (child.type === 'tablebody') return child.firstChildKey ?? null;
        }
        return null;
    }
    getLastKey() {
        let key = this.lastKey;
        if (key == null) return null;
        let node = this.getItem(key);
        while(node?.lastChildKey != null && (node.type !== 'item' || this.expandedKeys.has(node.key)))node = this.getItem(node.lastChildKey);
        return node?.key;
    }
    getKeyAfter(key) {
        let node = this.getItem(key);
        if (node?.type === 'column') return node.nextKey ?? null;
        if (!node) return null;
        // If this is an expanded item, return the first child item if any.
        if (node.type === 'item' && node.firstChildKey != null && this.expandedKeys.has(node.key)) {
            let child = this.getItem(node.firstChildKey);
            while(child){
                if (child.type === 'item') return child.key;
                child = child.nextKey != null ? this.getItem(child.nextKey) : null;
            }
        }
        return super.getKeyAfter(key);
    }
    getKeyBefore(key) {
        let node = this.getItem(key);
        if (node?.type === 'column') return node.prevKey ?? null;
        if (!node) return null;
        let k = null;
        if (node.prevKey != null) {
            node = this.getItem(node.prevKey);
            // Traverse to the deepest expanded child.
            while(node && (node.type !== 'item' || this.expandedKeys.has(node.key)) && node.lastChildKey != null)node = this.getItem(node.lastChildKey);
            k = node?.key ?? null;
        }
        if (k == null) k = node.parentKey;
        if (k != null && this.getItem(k)?.type === 'tableheader') return null;
        return k;
    }
    getChildren(key) {
        let item = this.getItem(key);
        if (!item) for (let row of this.headerRows){
            if (row.key === key) return row.childNodes;
        }
        // Flatten all rows into the body.
        let self = this;
        if (item?.type === 'tablebody' || item?.type === 'tablefooter') return {
            *[Symbol.iterator] () {
                let firstKey = item.firstChildKey;
                let node = firstKey != null ? self.getItem(firstKey) : null;
                while(node){
                    yield node;
                    let key = self.getKeyAfter(node.key);
                    node = key != null ? self.getItem(key) : null;
                    if (node && node.parentKey === item.parentKey) break;
                }
            }
        };
        return {
            *[Symbol.iterator] () {
                let parent = self.getItem(key);
                let node = parent?.firstChildKey != null ? self.getItem(parent.firstChildKey) : null;
                while(node){
                    yield node;
                    node = node.nextKey != null ? self.getItem(node.nextKey) : null;
                    // Return only cells as children of rows (nested rows are flattened into the body).
                    if (parent?.type === 'item' && node?.type !== 'cell') break;
                }
            }
        };
    }
    clone() {
        let collection = super.clone();
        collection.headerRows = this.headerRows;
        collection.columns = this.columns;
        collection.rows = this.rows;
        collection.rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        collection.head = this.head;
        return collection;
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return '';
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        let text = [];
        for (let cell of this.getChildren(key)){
            let column = this.columns[cell.index];
            if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
            if (text.length === rowHeaderColumnKeys.size) break;
        }
        return text.join(' ');
    }
    constructor(...args){
        super(...args), this.headerRows = [], this.columns = [], this.rows = [], this.rowHeaderColumnKeys = new Set(), this.head = new $167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderNode(-1), this.columnsDirty = true, this.expandedKeys = new Set();
    }
}
const $167a69a603174653$var$$76d00c5a4edb230a$var$ResizableTableContainerContext = (0, $eF4cA.createContext)(null);
const $167a69a603174653$export$7063e69b8a954175 = (0, $eF4cA.forwardRef)(function ResizableTableContainer(props, ref) {
    let containerRef = (0, $26CkO.useObjectRef)(ref);
    let tableRef = (0, $eF4cA.useRef)(null);
    let scrollRef = (0, $eF4cA.useRef)(null);
    let [width, setWidth] = (0, $eF4cA.useState)(0);
    (0, $4skXn.useLayoutEffect)(()=>{
        // Walk up the DOM from the Table to the ResizableTableContainer and stop
        // when we reach the first scrollable element. This is what we'll measure
        // to determine column widths (important due to width of scrollbars).
        // This will usually be the ResizableTableContainer for native tables, and
        // the Table itself for virtualized tables.
        let table = tableRef.current;
        while(table && table !== containerRef.current && !(0, $fSNAA.isScrollable)(table))table = table.parentElement;
        scrollRef.current = table;
    }, [
        containerRef
    ]);
    (0, $f9wnx.useResizeObserver)({
        ref: scrollRef,
        box: 'border-box',
        onResize () {
            setWidth(scrollRef.current?.clientWidth ?? 0);
        }
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        setWidth(scrollRef.current?.clientWidth ?? 0);
    }, []);
    let ctx = (0, $eF4cA.useMemo)(()=>({
            tableRef: tableRef,
            scrollRef: scrollRef,
            tableWidth: width,
            useTableColumnResizeState: (0, $024d06f0fd0ec92f$export$cb895dcf85db1319),
            onResizeStart: props.onResizeStart,
            onResize: props.onResize,
            onResizeEnd: props.onResizeEnd
        }), [
        tableRef,
        width,
        props.onResizeStart,
        props.onResize,
        props.onResizeEnd
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        render: props.render,
        ...(0, $fVfXf.filterDOMProps)(props, {
            global: true
        }),
        ref: containerRef,
        className: props.className || 'react-aria-ResizableTableContainer',
        style: props.style,
        onScroll: props.onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$ResizableTableContainerContext.Provider, {
        value: ctx
    }, props.children));
});
const $167a69a603174653$export$93e4b0b2cc49b648 = (0, $eF4cA.createContext)(null);
const $167a69a603174653$export$38de1cb0526c21fb = (0, $eF4cA.createContext)(null);
const $167a69a603174653$export$a2680a798823803c = (0, $eF4cA.createContext)(null);
const $167a69a603174653$export$54ec01a60f47d33d = (0, $eF4cA.forwardRef)(function Table(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $167a69a603174653$export$93e4b0b2cc49b648);
    // Separate selection state so we have access to it from collection components via useTableOptions.
    let selectionState = (0, $fAqsC.useMultipleSelectionState)(props);
    let { selectionBehavior: selectionBehavior, selectionMode: selectionMode, disallowEmptySelection: disallowEmptySelection } = selectionState;
    let hasDragHooks = !!props.dragAndDropHooks?.useDraggableCollectionState;
    let ctx = (0, $eF4cA.useMemo)(()=>({
            selectionBehavior: selectionMode === 'none' ? null : selectionBehavior,
            selectionMode: selectionMode,
            disallowEmptySelection: disallowEmptySelection,
            allowsDragging: hasDragHooks
        }), [
        selectionBehavior,
        selectionMode,
        disallowEmptySelection,
        hasDragHooks
    ]);
    let content = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableOptionsContext.Provider, {
        value: ctx
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.CollectionBuilder), {
        content: content,
        createCollection: ()=>new $167a69a603174653$var$$76d00c5a4edb230a$var$TableCollection()
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableInner, {
            props: props,
            forwardedRef: ref,
            selectionState: selectionState,
            collection: collection
        }));
});
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableElementType = (0, $eF4cA.forwardRef)(function TableElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).table, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$var$$76d00c5a4edb230a$var$EXPANSION_KEYS = {
    expand: {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    collapse: {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function $167a69a603174653$var$$76d00c5a4edb230a$var$TableInner({ props: props, forwardedRef: ref, selectionState: selectionState, collection: collection }) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, (0, $9PmUB.SelectableCollectionContext));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { shouldUseVirtualFocus: shouldUseVirtualFocus, disallowTypeAhead: disallowTypeAhead, filter: filter, ...DOMCollectionProps } = props;
    let tableContainerContext = (0, $eF4cA.useContext)($167a69a603174653$var$$76d00c5a4edb230a$var$ResizableTableContainerContext);
    ref = (0, $26CkO.useObjectRef)((0, $eF4cA.useMemo)(()=>(0, $bkjeZ.mergeRefs)(ref, tableContainerContext?.tableRef), [
        ref,
        tableContainerContext?.tableRef
    ]));
    let [expandedKeys, setExpandedKeys] = (0, $iUErx.useControlledState)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    // oxlint-disable-next-line react/react-compiler
    collection = (0, $eF4cA.useMemo)(()=>collection.withExpandedKeys(expandedKeys), [
        collection,
        expandedKeys
    ]);
    let tableState = (0, $cc144e4ba0575d9a$export$907bcc6c48325fd6)({
        ...DOMCollectionProps,
        collection: collection,
        children: undefined,
        UNSAFE_selectionState: selectionState,
        expandedKeys: expandedKeys,
        onExpandedChange: setExpandedKeys
    });
    // oxlint-disable-next-line react/react-compiler
    let filteredState = (0, $cc144e4ba0575d9a$export$31447e17397b15c2)(tableState, filter);
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { dragAndDropHooks: dragAndDropHooks } = props;
    let { gridProps: gridProps } = (0, $14b231632eb972d2$export$25bceaac3c7e4dc7)({
        ...DOMCollectionProps,
        layoutDelegate: layoutDelegate,
        isVirtualized: isVirtualized
    }, filteredState, ref);
    let selectionManager = filteredState.selectionManager;
    let hasDragHooks = !!dragAndDropHooks?.useDraggableCollectionState;
    let hasDropHooks = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, $eF4cA.useRef)(hasDragHooks);
    let dropHooksProvided = (0, $eF4cA.useRef)(hasDropHooks);
    (0, $eF4cA.useEffect)(()=>{
        return;
    }, [
        hasDragHooks,
        hasDropHooks
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $eF4cA.useRef)(null);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let [treeDropTargetDelegate] = (0, $eF4cA.useState)(()=>new (0, $f0e8aa45449c9c67$export$82c13862611c034e)());
    if (hasDragHooks && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: filteredState.collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        // oxlint-disable-next-line react/react-compiler
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (hasDropHooks && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: filteredState.collection,
            selectionManager: selectionManager
        });
        let keyboardDelegate = new (0, $daM4n.ListKeyboardDelegate)({
            collection: filteredState.collection,
            disabledKeys: selectionManager.disabledKeys,
            disabledBehavior: selectionManager.disabledBehavior,
            ref: ref,
            layoutDelegate: layoutDelegate
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection.rows, ref);
        treeDropTargetDelegate.setup(dropTargetDelegate, tableState, direction);
        // oxlint-disable-next-line react/react-compiler
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: treeDropTargetDelegate,
            onDropActivate: (e)=>{
                // Expand collapsed item when dragging over. For keyboard, allow collapsing.
                if (e.target.type === 'item') {
                    let key = e.target.key;
                    let item = tableState.collection.getItem(key);
                    let isExpanded = expandedKeys.has(key);
                    if (item && item.hasChildNodes && (!isExpanded || dragAndDropHooks?.isVirtualDragging?.())) tableState.toggleKey(key);
                }
            },
            onKeyDown: (e)=>{
                let target = dropState?.target;
                if (target && target.type === 'item' && target.dropPosition === 'on') {
                    let item = tableState.collection.getItem(target.key);
                    if (e.key === $167a69a603174653$var$$76d00c5a4edb230a$var$EXPANSION_KEYS['expand'][direction] && item?.hasChildNodes && !tableState.expandedKeys.has(target.key)) tableState.toggleKey(target.key);
                    else if (e.key === $167a69a603174653$var$$76d00c5a4edb230a$var$EXPANSION_KEYS['collapse'][direction] && item?.hasChildNodes && tableState.expandedKeys.has(target.key)) tableState.toggleKey(target.key);
                }
            }
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-Table',
        values: {
            isDropTarget: isRootDropTarget,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            state: filteredState
        }
    });
    let isListDraggable = !!(hasDragHooks && !dragState?.isDisabled);
    let style = renderProps.style;
    let layoutState = null;
    if (tableContainerContext) {
        // oxlint-disable-next-line react/react-compiler
        layoutState = tableContainerContext.useTableColumnResizeState({
            tableWidth: tableContainerContext.tableWidth
        }, filteredState);
        if (!isVirtualized) style = {
            ...style,
            tableLayout: 'fixed',
            // due to https://bugzilla.mozilla.org/show_bug.cgi?id=1959353, we can't use "fit-content".
            // Causes the table columns to grow to fill the available space in Firefox, ignoring user set column widths
            width: 'min-content'
        };
    }
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $167a69a603174653$export$38de1cb0526c21fb,
                filteredState
            ],
            [
                $167a69a603174653$export$a2680a798823803c,
                layoutState
            ],
            [
                (0, $cLs8t.DragAndDropContext),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $cLs8t.DropIndicatorContext),
                {
                    render: $167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorWrapper
                }
            ],
            [
                (0, $9PmUB.SelectableCollectionContext),
                null
            ],
            [
                (0, $9PmUB.FieldInputContext),
                null
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $6pgkA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, gridProps, focusProps, droppableCollection?.collectionProps),
        style: style,
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-allows-dragging": isListDraggable || undefined,
        "data-drop-target": isRootDropTarget || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $2FPWu.SharedElementTransition), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionRoot, {
        collection: filteredState.collection,
        scrollRef: tableContainerContext?.scrollRef ?? ref,
        persistedKeys: (0, $cLs8t.useDndPersistedKeys)(selectionManager, dragAndDropHooks, dropState)
    })))), dragPreview);
}
const $167a69a603174653$var$$76d00c5a4edb230a$var$TableOptionsContext = (0, $eF4cA.createContext)(null);
function $167a69a603174653$export$fddc468cd8cb4db9() {
    return (0, $eF4cA.useContext)($167a69a603174653$var$$76d00c5a4edb230a$var$TableOptionsContext);
}
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'tableheader';
    }
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$THeadElementType = (0, $eF4cA.forwardRef)(function THeadElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).thead, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$export$f850895b287ef28e = (0, $3g2oV.createBranchComponent)($167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderNode, (props, ref)=>{
    let collection = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb).collection;
    let headerRows = (0, $1kw8g.useCachedChildren)({
        items: collection.headerRows,
        children: (0, $eF4cA.useCallback)((item)=>{
            switch(item.type){
                case 'headerrow':
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderRow, {
                        item: item
                    });
                default:
                    throw new Error('Unsupported node type in TableHeader: ' + item.type);
            }
        }, [])
    });
    let { rowGroupProps: rowGroupProps } = (0, $599063176fe1c245$export$6fb1613bd7b28198)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        onHoverStart: props.onHoverStart,
        onHoverChange: props.onHoverChange,
        onHoverEnd: props.onHoverEnd
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-TableHeader',
        values: {
            isHovered: isHovered
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$THeadElementType, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), rowGroupProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined
    }, headerRows);
}, (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), {
        dependencies: props.dependencies,
        items: props.columns
    }, props.children));
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderRowElementType = (0, $eF4cA.forwardRef)(function TableHeaderRowElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("tr", {
        ...props,
        ref: ref
    });
});
function $167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderRow({ item: item }) {
    let ref = (0, $eF4cA.useRef)(null);
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized, CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { rowProps: rowProps } = (0, $7fdba76a9b1d6911$export$1b95a7d2d517b841)({
        node: item,
        isVirtualized: isVirtualized
    }, state, ref);
    let { checkboxProps: checkboxProps } = (0, $015ee9e13fd62e05$export$1003db6a7e384b99)(state);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableHeaderRowElementType, {
        ...rowProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $ed1Og.CheckboxContext),
                {
                    slots: {
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $ed1Og.CheckboxFieldContext),
                {
                    slots: {
                        selection: checkboxProps
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    })));
}
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableColumnNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'column';
    }
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$ColumnElementType = (0, $eF4cA.forwardRef)(function ColumnElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).th, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$export$816b5d811295e6bc = (0, $3g2oV.createLeafComponent)($167a69a603174653$var$$76d00c5a4edb230a$var$TableColumnNode, (props, forwardedRef, column)=>{
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { columnHeaderProps: columnHeaderProps, isPressed: isPressed } = (0, $75281188f9e82bc0$export$9514819a8c81e960)({
        node: column,
        isVirtualized: isVirtualized,
        focusMode: props.focusMode,
        allowsArrowNavigation: props.allowsArrowNavigation
    }, state, ref);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let layoutState = (0, $eF4cA.useContext)($167a69a603174653$export$a2680a798823803c);
    let isResizing = false;
    if (layoutState) isResizing = layoutState.resizingColumn === column.key;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        isDisabled: !props.allowsSorting
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: column.rendered,
        defaultClassName: 'react-aria-Column',
        values: {
            isHovered: isHovered,
            isPressed: isPressed,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            allowsSorting: column.props.allowsSorting,
            sortDirection: state.sortDescriptor?.column === column.key ? state.sortDescriptor.direction : undefined,
            isResizing: isResizing,
            startResize: ()=>{
                if (layoutState) {
                    layoutState.startResize(column.key);
                    state.setKeyboardNavigationDisabled(true);
                } else throw new Error('Wrap your <Table> in a <ResizableTableContainer> to enable column resizing');
            },
            sort: (direction)=>{
                state.sort(column.key, direction);
            }
        }
    });
    let style = renderProps.style;
    if (layoutState) style = {
        ...style,
        width: layoutState.getColumnWidth(column.key)
    };
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$ColumnElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, columnHeaderProps, focusProps, hoverProps),
        ...renderProps,
        style: style,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-pressed": isPressed || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-resizing": isResizing || undefined,
        "data-allows-sorting": column.props.allowsSorting || undefined,
        "data-sort-direction": state.sortDescriptor?.column === column.key ? state.sortDescriptor.direction : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $167a69a603174653$var$$76d00c5a4edb230a$var$ColumnResizerContext,
                {
                    column: column,
                    triggerRef: ref
                }
            ],
            [
                (0, $8dzVy.CollectionRendererContext),
                (0, $8dzVy.DefaultCollectionRenderer)
            ]
        ]
    }, renderProps.children));
});
const $167a69a603174653$var$$76d00c5a4edb230a$var$ColumnResizerContext = (0, $eF4cA.createContext)(null);
const $167a69a603174653$export$ee689e97a7664bfd = (0, $eF4cA.forwardRef)(function ColumnResizer(props, ref) {
    let layoutState = (0, $eF4cA.useContext)($167a69a603174653$export$a2680a798823803c);
    if (!layoutState) throw new Error('Wrap your <Table> in a <ResizableTableContainer> to enable column resizing');
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($167a69a603174653$var$$parcel$interopDefault((0, $hJVXE.default)), 'react-aria-components');
    let { onResizeStart: onResizeStart, onResize: onResize, onResizeEnd: onResizeEnd } = (0, $eF4cA.useContext)($167a69a603174653$var$$76d00c5a4edb230a$var$ResizableTableContainerContext);
    let { column: column, triggerRef: triggerRef } = (0, $eF4cA.useContext)($167a69a603174653$var$$76d00c5a4edb230a$var$ColumnResizerContext);
    let inputRef = (0, $eF4cA.useRef)(null);
    let { resizerProps: resizerProps, inputProps: inputProps, isResizing: isResizing, isMouseResizing: isMouseResizing } = (0, $a600943036a15f41$export$52994e973806c219)({
        column: column,
        'aria-label': props['aria-label'] || stringFormatter.format('tableResizer'),
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeEnd: onResizeEnd,
        triggerRef: triggerRef
    }, layoutState, inputRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)(props);
    let isEResizable = layoutState.getColumnMinWidth(column.key) >= layoutState.getColumnWidth(column.key);
    let isWResizable = layoutState.getColumnMaxWidth(column.key) <= layoutState.getColumnWidth(column.key);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let resizableDirection = 'both';
    if (isEResizable) resizableDirection = direction === 'rtl' ? 'right' : 'left';
    else if (isWResizable) resizableDirection = direction === 'rtl' ? 'left' : 'right';
    else resizableDirection = 'both';
    let objectRef = (0, $26CkO.useObjectRef)(ref);
    let [cursor, setCursor] = (0, $eF4cA.useState)('');
    (0, $eF4cA.useEffect)(()=>{
        if (!objectRef.current) return;
        let style = window.getComputedStyle(objectRef.current);
        setCursor(style.cursor);
    }, [
        objectRef,
        resizableDirection
    ]);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColumnResizer',
        values: {
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isResizing: isResizing,
            isHovered: isHovered,
            resizableDirection: resizableDirection
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    // Cursor overlay is used to style the cursor against the entire screen.
    // Do not turn off pointer events or the cursor will no longer be styled.
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ref: objectRef,
        role: "presentation",
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, resizerProps, hoverProps),
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-resizing": isResizing || undefined,
        "data-resizable-direction": resizableDirection
    }, renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
        ref: inputRef,
        ...(0, $lhKAD.mergeProps)(inputProps, focusProps)
    }), isResizing && isMouseResizing && (0, (/*@__PURE__*/$parcel$interopDefault($l19Vn))).createPortal((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            cursor: cursor
        },
        "data-testid": "cursor-overlay"
    }), document.body));
});
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableBodyNode extends (0, $bWhaY.FilterableNode) {
    static{
        this.type = 'tablebody';
    }
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableBodyElementType = (0, $eF4cA.forwardRef)(function TableBodyElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).tbody, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$export$76ccd210b9029917 = (0, $3g2oV.createBranchComponent)($167a69a603174653$var$$76d00c5a4edb230a$var$TableBodyNode, (props, ref, node)=>{
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let collection = state.collection;
    let { CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let isDroppable = !!dragAndDropHooks?.useDroppableCollectionState && !dropState?.isDisabled;
    let isRootDropTarget = isDroppable && !!dropState && (dropState.isDropTarget({
        type: 'root'
    }) ?? false);
    let isEmpty = collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: isEmpty
    };
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: 'react-aria-TableBody',
        values: renderValues
    });
    let emptyState;
    let numColumns = collection.columnCount;
    if (isEmpty && props.renderEmptyState && state) {
        let rowProps = {};
        let rowHeaderProps = {};
        let style = {};
        if (isVirtualized) {
            rowHeaderProps['aria-colspan'] = numColumns;
            style = {
                display: 'contents'
            };
        } else rowHeaderProps['colSpan'] = numColumns;
        emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType, {
            role: "row",
            ...rowProps,
            style: style
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType, {
            role: "rowheader",
            ...rowHeaderProps,
            style: style
        }, props.renderEmptyState(renderValues)));
    }
    let { rowGroupProps: rowGroupProps } = (0, $599063176fe1c245$export$6fb1613bd7b28198)();
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    // TODO: TableBody doesn't support being the scrollable body of the table yet, to revisit if needed. Would need to
    // call useLoadMore here and walk up the DOM to the nearest scrollable element to set scrollRef
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableBodyElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, rowGroupProps),
        ref: ref,
        "data-empty": isEmpty || undefined
    }, isDroppable && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$RootDropIndicator, null), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: collection,
        parent: node,
        renderDropIndicator: (0, $cLs8t.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }), emptyState);
});
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableFooterNode extends (0, $bWhaY.FilterableNode) {
    static{
        this.type = 'tablefooter';
    }
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableFooterElementType = (0, $eF4cA.forwardRef)(function TableFooterElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).tfoot, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$export$1f116082bba1f9a8 = (0, $3g2oV.createBranchComponent)($167a69a603174653$var$$76d00c5a4edb230a$var$TableFooterNode, (props, ref, node)=>{
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let collection = state.collection;
    let { CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let { rowGroupProps: rowGroupProps } = (0, $599063176fe1c245$export$6fb1613bd7b28198)();
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        style: props.style,
        className: props.className,
        defaultClassName: 'react-aria-TableFooter',
        values: {}
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableFooterElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, rowGroupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: collection,
        parent: node,
        renderDropIndicator: (0, $cLs8t.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }));
});
const $167a69a603174653$export$1a75e308b53225a6 = (0, $eF4cA.createContext)({
    isFocusVisibleWithinRow: false
});
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableRowNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'item';
    }
    filter(collection, newCollection, filterFn) {
        let cells = collection.getChildren(this.key);
        for (let cell of cells)if (filterFn(cell.textValue, cell)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType = (0, $eF4cA.forwardRef)(function TableRowElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).tr, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$export$b59bdbef9ce70de2 = (0, $3g2oV.createBranchComponent)($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowNode, (props, forwardedRef, item)=>{
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let { isVirtualized: isVirtualized, CollectionBranch: CollectionBranch } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let isDraggable = dragState && !(dragState.isDisabled || dragState.selectionManager.isDisabled(item.key));
    let { rowProps: rowProps, expandButtonProps: expandButtonProps, ...states } = (0, $9a45af121db968c1$export$7f2f6ae19e707aa5)({
        node: item,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized: isVirtualized
    }, state, ref);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        // because of https://bugs.webkit.org/show_bug.cgi?id=214609, supporting hover styles when a item is ONLY isDraggable
        // results in hover styles sticking around after a reorder/drop operation...
        isDisabled: !states.allowsSelection && !states.hasAction && !isDraggable,
        onHoverStart: props.onHoverStart,
        onHoverChange: props.onHoverChange,
        onHoverEnd: props.onHoverEnd
    });
    let { checkboxProps: checkboxProps } = (0, $015ee9e13fd62e05$export$16ea7f650bd7c1bb)({
        key: item.key
    }, state);
    let draggableItem = undefined;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = undefined;
    let dropIndicatorRef = (0, $eF4cA.useRef)(null);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, dropIndicatorRef);
    let dragButtonRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        dragState && dragButtonRef.current;
    // eslint-disable-next-line
    }, []);
    let isDragging = dragState && dragState.isDragging(item.key);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: _, ...restProps } = props;
    let hasChildItems = props.hasChildItems || state.collection.getItem(item.lastChildKey)?.type !== 'cell';
    let isExpanded = hasChildItems && state.expandedKeys.has(item.key);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...restProps,
        id: undefined,
        defaultClassName: 'react-aria-Row',
        defaultStyle: {
            // @ts-ignore
            '--table-row-level': item.level + 1
        },
        values: {
            ...states,
            state: state,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            isDragging: isDragging,
            isDropTarget: dropIndicator?.isDropTarget,
            isFocusVisibleWithin: isFocusVisibleWithin,
            id: item.key,
            hasChildItems: hasChildItems,
            isExpanded: isExpanded,
            level: item.level + 1
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, dropIndicator && !dropIndicator.isHidden && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType, {
        role: "row",
        style: {
            height: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType, {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, rowProps, focusProps, hoverProps, draggableItem?.dragProps, focusWithinProps),
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-selected": states.isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": dropIndicator?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode,
        "data-focus-visible-within": isFocusVisibleWithin || undefined,
        "data-expanded": isExpanded || undefined,
        "data-has-child-items": hasChildItems || undefined,
        "data-level": item.level + 1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $ed1Og.CheckboxContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $ed1Og.CheckboxFieldContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        chevron: expandButtonProps,
                        drag: {
                            ...draggableItem?.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: 'none'
                            }
                        }
                    }
                }
            ],
            [
                (0, $hUj7u.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ],
            [
                $167a69a603174653$export$1a75e308b53225a6,
                {
                    isFocusVisibleWithinRow: isFocusVisibleWithin
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }))));
}, (props)=>{
    if (props.id == null && typeof props.children === 'function') throw new Error('No id detected for the Row element. The Row element requires a id to be provided to it when the cells are rendered dynamically.');
    let dependencies = [
        props.value
    ].concat(props.dependencies);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $3g2oV.Collection), {
        dependencies: dependencies,
        items: props.columns,
        idScope: props.id
    }, props.children);
});
class $167a69a603174653$var$$76d00c5a4edb230a$var$TableCellNode extends (0, $bWhaY.CollectionNode) {
    static{
        this.type = 'cell';
    }
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType = (0, $eF4cA.forwardRef)(function TableCellElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).td, {
        ...props,
        ref: ref
    });
});
const $167a69a603174653$export$f6f0c3fe4ec306ea = (0, $3g2oV.createLeafComponent)($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellNode, (props, forwardedRef, cell)=>{
    let ref = (0, $26CkO.useObjectRef)(forwardedRef);
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { dragState: dragState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    cell.column = state.collection.columns[cell.index];
    let { gridCellProps: gridCellProps, isPressed: isPressed } = (0, $d2dc909a7cd2ecbd$export$49571c903d73624c)({
        node: cell,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized: isVirtualized,
        focusMode: props.focusMode,
        allowsArrowNavigation: props.allowsArrowNavigation
    }, state, ref);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    let { isFocusVisibleWithinRow: isFocusVisibleWithinRow } = (0, $eF4cA.useContext)($167a69a603174653$export$1a75e308b53225a6);
    let isSelected = cell.parentKey != null ? state.selectionManager.isSelected(cell.parentKey) : false;
    // colIndex is null, when there is so span, falling back to using the index
    let columnIndex = cell.colIndex || cell.index;
    let row = state.collection.getItem(cell.parentKey);
    let hasChildItems = row.props.hasChildItems || state.collection.getItem(row.lastChildKey)?.type !== 'cell';
    let isExpanded = hasChildItems && state.expandedKeys.has(cell.parentKey);
    let isDisabled = state.selectionManager.isDisabled(cell.parentKey);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        defaultClassName: 'react-aria-Cell',
        values: {
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isFocusVisibleWithinRow: isFocusVisibleWithinRow,
            isPressed: isPressed,
            isHovered: isHovered,
            isSelected: isSelected,
            id: cell.key,
            columnIndex: columnIndex,
            hasChildItems: hasChildItems,
            isExpanded: isExpanded,
            isDisabled: isDisabled,
            level: row.level + 1,
            isTreeColumn: cell.column.key === state.treeColumn
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, gridCellProps, focusProps, hoverProps),
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-focus-visible-within-row": isFocusVisibleWithinRow || undefined,
        "data-pressed": isPressed || undefined,
        "data-selected": isSelected || undefined,
        "data-column-index": columnIndex,
        "data-expanded": isExpanded || undefined,
        "data-has-child-items": hasChildItems || undefined,
        "data-level": row.level + 1,
        "data-tree-column": cell.column.key === state.treeColumn || undefined,
        "data-disabled": isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $8dzVy.CollectionRendererContext).Provider, {
        value: (0, $8dzVy.DefaultCollectionRenderer)
    }, renderProps.children));
});
function $167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorWrapper(props, ref) {
    ref = (0, $26CkO.useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let buttonRef = (0, $eF4cA.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    let level = dropState && props.target.type === 'item' ? (dropState.collection.getItem(props.target.key)?.level || 0) + 1 : 1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        buttonRef: buttonRef,
        level: level,
        ref: ref
    });
}
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorRowElementType = (0, $eF4cA.forwardRef)(function TableDropIndicatorRowElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).tr, {
        ...props,
        ref: ref
    });
});
let $167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorTDElementType = (0, $eF4cA.forwardRef)(function TableDropIndicatorTDElementType(props, ref) {
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    if (isVirtualized) return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...props,
        ref: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).td, {
        ...props,
        ref: ref
    });
});
function $167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, buttonRef: buttonRef, level: level, ...otherProps } = props;
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        defaultStyle: {
            // @ts-ignore
            '--table-row-level': level + 1
        },
        values: {
            isDropTarget: isDropTarget
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorRowElementType, {
        ...(0, $fVfXf.filterDOMProps)(props, {
            global: true
        }),
        ...renderProps,
        role: "row",
        ref: ref,
        "data-drop-target": isDropTarget || undefined,
        "aria-level": level
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorTDElementType, {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const $167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicatorForwardRef = (0, $eF4cA.forwardRef)($167a69a603174653$var$$76d00c5a4edb230a$var$TableDropIndicator);
function $167a69a603174653$var$$76d00c5a4edb230a$var$RootDropIndicator() {
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $eF4cA.useContext)((0, $cLs8t.DragAndDropContext));
    let ref = (0, $eF4cA.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType, {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden'],
        style: {
            height: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType, {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}
const $167a69a603174653$export$8f5bea0338ed243c = (0, $3g2oV.createLeafComponent)((0, $bWhaY.LoaderNode), function TableLoadingIndicator(props, ref, item) {
    let state = (0, $eF4cA.useContext)($167a69a603174653$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized } = (0, $eF4cA.useContext)((0, $8dzVy.CollectionRendererContext));
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let numColumns = state.collection.columns.length;
    let sentinelRef = (0, $eF4cA.useRef)(null);
    let memoedLoadMoreProps = (0, $eF4cA.useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, $lJdzA.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-TableLoadingIndicator',
        defaultStyle: {
            // @ts-ignore
            '--table-row-level': item.level + 1
        },
        values: undefined
    });
    let rowProps = {};
    let rowHeaderProps = {};
    let style = {};
    if (isVirtualized) {
        // For now don't include aria-rowindex on loader since they aren't keyboard focusable
        // Arguably shouldn't include them ever since it might be confusing to the user to include the loaders as part of the
        // row count
        rowHeaderProps['aria-colspan'] = numColumns;
        style = {
            display: 'contents'
        };
    } else rowHeaderProps['colSpan'] = numColumns;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType, {
        style: {
            height: 0
        },
        inert: (0, $gF3YT.inertValue)(true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType, {
        style: {
            padding: 0,
            border: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'relative',
            height: 1,
            width: 1
        }
    }))), isLoading && renderProps.children && (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableRowElementType, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(props, {
            global: true
        }), rowProps),
        ...renderProps,
        role: "row",
        ref: ref,
        "aria-level": item.level + 1,
        "data-level": item.level + 1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($167a69a603174653$var$$76d00c5a4edb230a$var$TableCellElementType, {
        role: "rowheader",
        ...rowHeaderProps,
        style: style
    }, renderProps.children)));
});



var $3g2oV = parcelRequire("3g2oV");

var $8dzVy = parcelRequire("8dzVy");

var $fDYaM = parcelRequire("fDYaM");

var $i0SpD = parcelRequire("i0SpD");

var $fvyIQ = parcelRequire("fvyIQ");

var $7ByPJ = parcelRequire("7ByPJ");

var $8bBQM = parcelRequire("8bBQM");

var $f7tr2 = parcelRequire("f7tr2");

var $dnqqa = parcelRequire("dnqqa");

var $n0XBd = parcelRequire("n0XBd");

var $8bBQM = parcelRequire("8bBQM");

var $bMKKe = parcelRequire("bMKKe");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $64e2da81732cf657$var$$024b19c559603d56$var$DEFAULT_ROW_HEIGHT = 48;
class $64e2da81732cf657$export$62444c3c724b1b20 extends (0, $n0XBd.ListLayout) {
    constructor(options){
        super(options), this.lastCollection = null, this.columnWidths = new Map(), this.lastPersistedKeys = null, this.persistedIndices = new Map();
        this.stickyColumnIndices = [];
    }
    // Backward compatibility for subclassing.
    get collection() {
        return this.virtualizer.collection;
    }
    // Preserve the old rowHeight/other "height" properties since Table doesn't support a "horizontal" orientation
    get rowHeight() {
        return super.rowHeight;
    }
    get estimatedRowHeight() {
        return super.estimatedRowHeight;
    }
    get headingHeight() {
        return super.headingHeight;
    }
    get estimatedHeadingHeight() {
        return super.estimatedHeadingHeight;
    }
    get loaderHeight() {
        return super.loaderHeight;
    }
    columnsChanged(newCollection, oldCollection) {
        return !oldCollection || newCollection.columns !== oldCollection.columns && newCollection.columns.length !== oldCollection.columns.length || newCollection.columns.some((c, i)=>c.key !== oldCollection.columns[i].key || c.props.width !== oldCollection.columns[i].props.width || c.props.minWidth !== oldCollection.columns[i].props.minWidth || c.props.maxWidth !== oldCollection.columns[i].props.maxWidth);
    }
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.columnWidths !== oldOptions.columnWidths || super.shouldInvalidateLayoutOptions(newOptions, oldOptions);
    }
    update(invalidationContext) {
        let newCollection = this.virtualizer.collection;
        // If columnWidths were provided via layoutOptions, update those.
        // Otherwise, calculate column widths ourselves.
        if (invalidationContext.layoutOptions?.columnWidths) {
            for (const [key, val] of invalidationContext.layoutOptions.columnWidths)if (this.columnWidths.get(key) !== val) {
                this.columnWidths = invalidationContext.layoutOptions.columnWidths;
                invalidationContext.sizeChanged = true;
                break;
            }
        } else if (invalidationContext.sizeChanged || this.columnsChanged(newCollection, this.lastCollection)) {
            let columnLayout = new (0, $169b947a6ac01bfe$export$7ff77a162970b30e)({});
            this.columnWidths = columnLayout.buildColumnWidths(this.virtualizer.size.width - this.padding * 2, newCollection, new Map());
            invalidationContext.sizeChanged = true;
        }
        super.update(invalidationContext);
    }
    buildCollection() {
        this.stickyColumnIndices = [];
        let collection = this.virtualizer.collection;
        for (let column of collection.columns)// In addition, row headers need to be in the DOM for accessibility labeling.
        if (this.isStickyColumn(column) || collection.rowHeaderColumnKeys.has(column.key)) this.stickyColumnIndices.push(column.index);
        let layoutNodes = [];
        let y = 0;
        let width = 0;
        if (!collection.head) {
            let header = this.buildTableHeader();
            this.layoutNodes.set(header.layoutInfo.key, header);
            let body = this.buildBody(header.layoutInfo.rect.maxY + this.gap);
            body.layoutInfo.rect.width = Math.max(header.layoutInfo.rect.width, body.layoutInfo.rect.width);
            y = body.layoutInfo.rect.maxY;
            width = body.layoutInfo.rect.width;
            layoutNodes = [
                header,
                body
            ];
        } else {
            for (let node of collection)switch(node.type){
                case 'tableheader':
                    {
                        let header = this.buildTableHeader();
                        y = header.layoutInfo.rect.maxY + this.gap;
                        width = Math.max(width, header.layoutInfo.rect.width);
                        this.layoutNodes.set(header.layoutInfo.key, header);
                        layoutNodes.push(header);
                        break;
                    }
                case 'tablebody':
                case 'tablefooter':
                    {
                        let body = this.buildRowGroup(y, node);
                        y = body.layoutInfo.rect.maxY + this.gap;
                        width = Math.max(width, body.layoutInfo.rect.width);
                        this.layoutNodes.set(body.layoutInfo.key, body);
                        layoutNodes.push(body);
                        break;
                    }
            }
            if (y > 0) y -= this.gap;
            for (let layoutNode of layoutNodes)layoutNode.layoutInfo.rect.width = width;
        }
        this.lastPersistedKeys = null;
        this.contentSize = new (0, $bMKKe.Size)(width + this.padding * 2, y + this.padding);
        return layoutNodes;
    }
    buildTableHeader() {
        let collection = this.virtualizer.collection;
        let rect = new (0, $8bBQM.Rect)(this.padding, this.padding, 0, 0);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)('header', collection.head?.key ?? 'header', rect);
        layoutInfo.isSticky = true;
        layoutInfo.zIndex = 1;
        let y = this.padding;
        let width = 0;
        let children = [];
        for (let headerRow of collection.headerRows){
            let layoutNode = this.buildChild(headerRow, this.padding, y, layoutInfo.key);
            layoutNode.layoutInfo.parentKey = layoutInfo.key;
            y = layoutNode.layoutInfo.rect.maxY;
            width = Math.max(width, layoutNode.layoutInfo.rect.width);
            layoutNode.index = children.length;
            children.push(layoutNode);
        }
        rect.width = width;
        rect.height = y - this.padding;
        return {
            layoutInfo: layoutInfo,
            children: children,
            validRect: layoutInfo.rect,
            node: collection.head
        };
    }
    buildHeaderRow(headerRow, x, y) {
        let rect = new (0, $8bBQM.Rect)(x, y, 0, 0);
        let row = new (0, $dnqqa.LayoutInfo)('headerrow', headerRow.key, rect);
        let height = 0;
        let columns = [];
        for (let cell of (0, $f7tr2.getChildNodes)(headerRow, this.virtualizer.collection)){
            let layoutNode = this.buildChild(cell, x, y, row.key);
            layoutNode.layoutInfo.parentKey = row.key;
            x = layoutNode.layoutInfo.rect.maxX;
            height = Math.max(height, layoutNode.layoutInfo.rect.height);
            layoutNode.index = columns.length;
            columns.push(layoutNode);
        }
        for (let [i, layout] of columns.entries())layout.layoutInfo.zIndex = columns.length - i + 1;
        this.setChildHeights(columns, height);
        rect.height = height;
        rect.width = x - rect.x;
        return {
            layoutInfo: row,
            children: columns,
            validRect: rect,
            node: headerRow
        };
    }
    setChildHeights(children, height) {
        for (let child of children)if (child.layoutInfo.rect.height !== height) {
            // Need to copy the layout info before we mutate it.
            child.layoutInfo = child.layoutInfo.copy();
            child.layoutInfo.rect.height = height;
        }
    }
    // used to get the column widths when rendering to the DOM
    getRenderedColumnWidth(node) {
        let collection = this.virtualizer.collection;
        let colSpan = node.colSpan ?? 1;
        let colIndex = node.colIndex ?? node.index;
        let width = 0;
        for(let i = colIndex; i < colIndex + colSpan; i++){
            let column = collection.columns[i];
            if (column?.key != null) width += this.columnWidths.get(column.key) ?? 0;
        }
        return width;
    }
    getEstimatedHeight(node, width, height, estimatedHeight) {
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (height == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall collection view changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                height = previousLayoutNode.layoutInfo.rect.height;
                isEstimated = node !== previousLayoutNode.node || width !== previousLayoutNode.layoutInfo.rect.width || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                height = estimatedHeight ?? $64e2da81732cf657$var$$024b19c559603d56$var$DEFAULT_ROW_HEIGHT;
                isEstimated = true;
            }
        }
        return {
            height: height,
            isEstimated: isEstimated
        };
    }
    getEstimatedRowHeight() {
        return this.rowHeight ?? this.estimatedRowHeight ?? $64e2da81732cf657$var$$024b19c559603d56$var$DEFAULT_ROW_HEIGHT;
    }
    buildColumn(node, x, y) {
        let width = this.getRenderedColumnWidth(node);
        let { height: height, isEstimated: isEstimated } = this.getEstimatedHeight(node, width, this.headingHeight ?? this.rowHeight, this.estimatedHeadingHeight ?? this.estimatedRowHeight);
        let rect = new (0, $8bBQM.Rect)(x, y, width, height);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.isSticky = this.isStickyColumn(node);
        layoutInfo.zIndex = layoutInfo.isSticky ? 2 : 1;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo: layoutInfo,
            children: [],
            validRect: layoutInfo.rect,
            node: node
        };
    }
    // For subclasses.
    // eslint-disable-next-line
    isStickyColumn(node) {
        return false;
    }
    buildBody(y) {
        let collection = this.virtualizer.collection;
        return this.buildRowGroup(y, collection.body);
    }
    buildRowGroup(y, node) {
        let collection = this.virtualizer.collection;
        let rect = new (0, $8bBQM.Rect)(this.padding, y, 0, 0);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)('rowgroup', node.key, rect);
        let startY = y;
        let width = 0;
        let children = [];
        let rowHeight = this.getEstimatedRowHeight() + this.gap;
        let childNodes = (0, $f7tr2.getChildNodes)(node, collection);
        for (let node of childNodes){
            // Skip rows outside the valid rectangle unless they are already cached.
            if (y + rowHeight < this.requestedRect.y && !this.isValid(node, y) || y > this.requestedRect.maxY && node.type !== 'loader') {
                y += rowHeight;
                continue;
            }
            let layoutNode = this.buildChild(node, this.padding, y, layoutInfo.key);
            layoutNode.layoutInfo.parentKey = layoutInfo.key;
            layoutNode.index = children.length;
            y = layoutNode.layoutInfo.rect.maxY + this.gap;
            width = Math.max(width, layoutNode.layoutInfo.rect.width);
            children.push(layoutNode);
        }
        // Make sure that the table body gets a height if empty or performing initial load
        let isEmptyOrLoading = collection?.size === 0;
        if (isEmptyOrLoading) y = this.virtualizer.size.height;
        else y -= this.gap;
        rect.width = width;
        rect.height = y - startY;
        return {
            layoutInfo: layoutInfo,
            children: children,
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node: node
        };
    }
    buildLoader(node, x, y) {
        let layoutNode = super.buildLoader(node, x, y);
        let collection = this.virtualizer.collection;
        // use the same approach as buildRow to get the proper width of the loader, otherwise
        // we get a outdated loader width
        layoutNode.layoutInfo.rect.width = this.layoutNodes.get(collection.head?.key ?? 'header').layoutInfo.rect.width;
        layoutNode.validRect = layoutNode.layoutInfo.rect.intersection(this.requestedRect);
        return layoutNode;
    }
    buildNode(node, x, y) {
        switch(node.type){
            case 'headerrow':
                return this.buildHeaderRow(node, x, y);
            case 'item':
                return this.buildRow(node, x, y);
            case 'column':
            case 'placeholder':
                return this.buildColumn(node, x, y);
            case 'cell':
                return this.buildCell(node, x, y);
            case 'loader':
                return this.buildLoader(node, x, y);
            default:
                throw new Error('Unknown node type ' + node.type);
        }
    }
    buildRow(node, x, y) {
        let collection = this.virtualizer.collection;
        let rect = new (0, $8bBQM.Rect)(x, y, 0, 0);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)('row', node.key, rect);
        let children = [];
        let height = 0;
        for (let child of (0, $f7tr2.getChildNodes)(node, collection))if (child.type === 'cell') {
            if (x > this.requestedRect.maxX) {
                // Adjust existing cached layoutInfo to ensure that it is out of view.
                // This can happen due to column resizing.
                let layoutNode = this.layoutNodes.get(child.key);
                if (layoutNode) {
                    layoutNode.layoutInfo.rect.x = x;
                    x += layoutNode.layoutInfo.rect.width;
                } else break;
            } else {
                let layoutNode = this.buildChild(child, x, y, layoutInfo.key);
                x = layoutNode.layoutInfo.rect.maxX;
                height = Math.max(height, layoutNode.layoutInfo.rect.height);
                layoutNode.index = children.length;
                children.push(layoutNode);
            }
        }
        this.setChildHeights(children, height);
        rect.width = this.layoutNodes.get(collection.head?.key ?? 'header').layoutInfo.rect.width;
        rect.height = height;
        return {
            layoutInfo: layoutInfo,
            children: children,
            validRect: rect.intersection(this.requestedRect),
            node: node
        };
    }
    buildCell(node, x, y) {
        let width = this.getRenderedColumnWidth(node);
        let { height: height, isEstimated: isEstimated } = this.getEstimatedHeight(node, width, this.rowHeight, this.estimatedRowHeight);
        let rect = new (0, $8bBQM.Rect)(x, y, width, height);
        let layoutInfo = new (0, $dnqqa.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.isSticky = this.isStickyColumn(node);
        layoutInfo.zIndex = layoutInfo.isSticky ? 2 : 1;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo: layoutInfo,
            children: [],
            validRect: rect,
            node: node
        };
    }
    getVisibleLayoutInfos(rect) {
        // Adjust rect to keep number of visible rows consistent.
        // (only if height > 1 for getDropTargetFromPoint)
        if (rect.height > 1) {
            let rowHeight = this.getEstimatedRowHeight();
            rect.y = Math.floor(rect.y / rowHeight) * rowHeight;
            rect.height = Math.ceil(rect.height / rowHeight) * rowHeight;
        }
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        this.layoutIfNeeded(rect);
        let res = [];
        this.buildPersistedIndices();
        for (let node of this.rootNodes){
            res.push(node.layoutInfo);
            this.addVisibleLayoutInfos(res, node, rect);
        }
        return res;
    }
    addVisibleLayoutInfos(res, node, rect) {
        if (!node.children || node.children.length === 0) return;
        switch(node.layoutInfo.type){
            case 'header':
                for (let child of node.children){
                    res.push(child.layoutInfo);
                    this.addVisibleLayoutInfos(res, child, rect);
                }
                break;
            case 'rowgroup':
                {
                    let firstVisibleRow = this.binarySearch(node.children, rect.topLeft, 'y');
                    let lastVisibleRow = this.binarySearch(node.children, rect.bottomRight, 'y');
                    // Add persisted rows before the visible rows.
                    let persistedRowIndices = this.persistedIndices.get(node.layoutInfo.key);
                    let persistIndex = 0;
                    while(persistedRowIndices && persistIndex < persistedRowIndices.length && persistedRowIndices[persistIndex] < firstVisibleRow){
                        let idx = persistedRowIndices[persistIndex];
                        if (idx < node.children.length) {
                            res.push(node.children[idx].layoutInfo);
                            this.addVisibleLayoutInfos(res, node.children[idx], rect);
                        }
                        persistIndex++;
                    }
                    for(let i = firstVisibleRow; i <= lastVisibleRow; i++){
                        // Skip persisted rows that overlap with visible cells.
                        while(persistedRowIndices && persistIndex < persistedRowIndices.length && persistedRowIndices[persistIndex] < i)persistIndex++;
                        res.push(node.children[i].layoutInfo);
                        this.addVisibleLayoutInfos(res, node.children[i], rect);
                    }
                    // Add persisted rows after the visible rows.
                    while(persistedRowIndices && persistIndex < persistedRowIndices.length){
                        let idx = persistedRowIndices[persistIndex++];
                        if (idx < node.children.length) {
                            res.push(node.children[idx].layoutInfo);
                            this.addVisibleLayoutInfos(res, node.children[idx], rect);
                        }
                    }
                    // Always include loading sentinel even when virtualized, we assume it is always the last child for now
                    let lastRow = node.children.at(-1);
                    if (lastRow?.layoutInfo.type === 'loader') res.push(lastRow.layoutInfo);
                    break;
                }
            case 'headerrow':
            case 'row':
                {
                    let firstVisibleCell = this.binarySearch(node.children, rect.topLeft, 'x');
                    let lastVisibleCell = this.binarySearch(node.children, rect.topRight, 'x');
                    let stickyIndex = 0;
                    // Add persisted/sticky cells before the visible cells.
                    let persistedCellIndices = this.persistedIndices.get(node.layoutInfo.key) || this.stickyColumnIndices;
                    while(stickyIndex < persistedCellIndices.length && persistedCellIndices[stickyIndex] < firstVisibleCell){
                        let idx = persistedCellIndices[stickyIndex];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                        stickyIndex++;
                    }
                    for(let i = firstVisibleCell; i <= lastVisibleCell; i++){
                        // Skip sticky cells that overlap with visible cells.
                        while(stickyIndex < persistedCellIndices.length && persistedCellIndices[stickyIndex] < i)stickyIndex++;
                        res.push(node.children[i].layoutInfo);
                    }
                    // Add any remaining sticky cells after the visible cells.
                    while(stickyIndex < persistedCellIndices.length){
                        let idx = persistedCellIndices[stickyIndex++];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                    }
                    break;
                }
            default:
                throw new Error('Unknown node type ' + node.layoutInfo.type);
        }
    }
    binarySearch(items, point, axis) {
        let low = 0;
        let high = items.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            let item = items[mid];
            if (axis === 'x' && item.layoutInfo.rect.maxX <= point.x || axis === 'y' && item.layoutInfo.rect.maxY <= point.y) low = mid + 1;
            else if (axis === 'x' && item.layoutInfo.rect.x > point.x || axis === 'y' && item.layoutInfo.rect.y > point.y) high = mid - 1;
            else return mid;
        }
        return Math.max(0, Math.min(items.length - 1, low));
    }
    buildPersistedIndices() {
        if (this.virtualizer.persistedKeys === this.lastPersistedKeys) return;
        this.lastPersistedKeys = this.virtualizer.persistedKeys;
        this.persistedIndices.clear();
        // Build a map of parentKey => indices of children to persist.
        for (let key of this.virtualizer.persistedKeys){
            let layoutInfo = this.layoutNodes.get(key)?.layoutInfo;
            // Walk up ancestors so parents are also persisted if children are.
            while(layoutInfo && layoutInfo.parentKey){
                let collectionNode = this.virtualizer.collection.getItem(layoutInfo.key);
                let indices = this.persistedIndices.get(layoutInfo.parentKey);
                if (!indices) {
                    // stickyColumnIndices are always persisted along with any cells from persistedKeys.
                    indices = collectionNode?.type === 'cell' || collectionNode?.type === 'column' ? [
                        ...this.stickyColumnIndices
                    ] : [];
                    this.persistedIndices.set(layoutInfo.parentKey, indices);
                }
                let index = this.layoutNodes.get(layoutInfo.key)?.index;
                if (index != null && !indices.includes(index)) indices.push(index);
                layoutInfo = this.layoutNodes.get(layoutInfo.parentKey)?.layoutInfo;
            }
        }
        for (let indices of this.persistedIndices.values())indices.sort((a, b)=>a - b);
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let searchRect = new (0, $8bBQM.Rect)(x, Math.max(0, y - this.gap), 1, Math.max(1, this.gap * 2));
        let candidates = this.getVisibleLayoutInfos(searchRect);
        let key = null;
        let minDistance = Infinity;
        for (let candidate of candidates){
            // Ignore items outside the search rect, e.g. persisted keys.
            if (candidate.type !== 'row' || !candidate.rect.intersects(searchRect)) continue;
            let yDist = Math.abs(candidate.rect.y - y);
            let maxYDist = Math.abs(candidate.rect.maxY - y);
            let dist = Math.min(yDist, maxYDist);
            if (dist < minDistance) {
                minDistance = dist;
                key = candidate.key;
            }
        }
        if (key == null || this.virtualizer.collection.size === 0) return {
            type: 'root'
        };
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = layoutInfo.rect;
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: 'before'
        })) target.dropPosition = 'before';
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: 'after'
        })) target.dropPosition = 'after';
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = super.getDropTargetLayoutInfo(target);
        layoutInfo.parentKey = this.virtualizer.collection.getItem(target.key)?.parentKey ?? null;
        return layoutInfo;
    }
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $e595ef6eae0ac989$export$62444c3c724b1b20 extends (0, $64e2da81732cf657$export$62444c3c724b1b20) {
    // Invalidate the layout whenever the column widths change.
    useLayoutOptions() {
        // This is not a React class component, just a regular class.
        // oxlint-disable react/react-compiler, react-hooks/rules-of-hooks
        let colResizeState = (0, $eF4cA.useContext)((0, $167a69a603174653$export$a2680a798823803c));
        return (0, $eF4cA.useMemo)(()=>({
                columnWidths: colResizeState?.columnWidths
            }), [
            colResizeState?.columnWidths
        ]);
    // oxlint-enable react/react-compiler, react-hooks/rules-of-hooks
    }
}


var $eF2II = parcelRequire("eF2II");

var $8gDpA = parcelRequire("8gDpA");

var $ed1Og = parcelRequire("ed1Og");

var $f8UJ0 = parcelRequire("f8UJ0");

var $eF4cA = parcelRequire("eF4cA");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $26CkO = parcelRequire("26CkO");

var $31fH3 = parcelRequire("31fH3");
function $0a7fba920f0e9b9f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext = (0, $eF4cA.createContext)({});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$tableWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let minHeight = false;
    let minWidth = false;
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!minHeight) rules += ' Ma182';
    if (!minWidth) rules += ' Na182';
    rules += ' sd182';
    rules += ' _Bb182';
    rules += ' __ca182';
    if (!position) rules += ' _Pc182';
    rules += ' _Nb182';
    rules += ' Pb182';
    return rules;
};
// due to the overflow: clip for actionbar, render the outline via a pseudo element so it isn't
// clipped. 6px radius matches the table's border radius
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootDropOutline = "pUEtOc";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$dropTargetBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$table = function anonymous(props) {
    let rules = " ";
    rules += ' Za182';
    rules += ' Fb182';
    rules += ' _oa182';
    rules += ' _4c182';
    rules += ' Ma182';
    rules += ' Na182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Na182';
    rules += ' Pa182';
    if (props.isDropTarget) rules += ' glzvDBe182';
    else if (props.isQuiet) rules += ' g9182';
    else rules += ' gX182';
    rules += ' gla182';
    if (props.isDropTarget) rules += ' ix182';
    else rules += ' iq182';
    if (props.isDropTarget) rules += ' ild182';
    else rules += ' ila182';
    rules += ' _jf182';
    if (props.isQuiet) rules += ' _ka182';
    else rules += ' _kb182';
    if (props.isQuiet) rules += ' ha182';
    else rules += ' hb182';
    if (props.isQuiet) rules += ' ma182';
    else rules += ' mb182';
    if (props.isQuiet) rules += ' la182';
    else rules += ' lb182';
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.isQuiet) rules += ' od182';
    else rules += ' of182';
    if (props.isQuiet) rules += ' nd182';
    else rules += ' nf182';
    if (props.isQuiet) rules += ' kd182';
    else rules += ' kf182';
    if (props.isQuiet) rules += ' jd182';
    else rules += ' jf182';
    rules += ' _Um182';
    if (props.isDragAndDrop) {
        if (props.isCheckboxSelection) rules += ' _Tn182';
        else rules += ' _Ti182';
    } else if (props.isCheckboxSelection) rules += ' _Tk182';
    rules += ' _yb182';
    if (props.isCheckboxSelection) rules += ' -dBGRde-ZosIvTc182';
    else rules += ' -dBGRde-ZwbbKhe182';
    rules += ' -lPUMEc-Zu182';
    return rules;
};
// component-height-100
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$DEFAULT_HEADER_HEIGHT = {
    medium: 32,
    large: 40
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
class $0a7fba920f0e9b9f$export$4e03bdf0174fd602 extends (0, $e595ef6eae0ac989$export$62444c3c724b1b20) {
    isStickyColumn(node) {
        return node.props.isSticky;
    }
    buildCollection() {
        let rowGroups = super.buildCollection();
        if (rowGroups.length < 2) return [];
        let { layoutInfo: layoutInfo } = rowGroups[1];
        // TableLayout's buildCollection always sets the body width to the max width between the header width, but
        // we want the body to be sticky and only as wide as the table so it is always in view if loading/empty
        let isEmptyOrLoading = this.virtualizer?.collection.size === 0;
        if (isEmptyOrLoading) layoutInfo.rect.width = this.virtualizer.size.width - 80;
        return rowGroups;
    }
    buildLoader(node, x, y) {
        let layoutNode = super.buildLoader(node, x, y);
        let { layoutInfo: layoutInfo } = layoutNode;
        layoutInfo.allowOverflow = true;
        layoutInfo.rect.width = this.virtualizer.size.width;
        // If performing first load or empty, the body will be sticky so we don't want to apply sticky to the loader, otherwise it will
        // affect the positioning of the empty state renderer
        let collection = this.virtualizer.collection;
        let isEmptyOrLoading = collection?.size === 0;
        layoutInfo.isSticky = !isEmptyOrLoading;
        return layoutNode;
    }
    buildRowGroup(y, node) {
        let layoutNode = super.buildRowGroup(y, node);
        if (node.type !== 'tablebody') return layoutNode;
        let { layoutInfo: layoutInfo } = layoutNode;
        // Needs overflow for sticky loader
        layoutInfo.allowOverflow = true;
        // If loading or empty, we'll want the body to be sticky and centered
        let isEmptyOrLoading = this.virtualizer?.collection.size === 0;
        if (isEmptyOrLoading) {
            layoutInfo.rect = new (0, $8bBQM.Rect)(40, 40, this.virtualizer.size.width - 80, this.virtualizer.size.height - 80);
            layoutInfo.isSticky = true;
        }
        return {
            ...layoutNode,
            layoutInfo: layoutInfo
        };
    }
    buildRow(node, x, y) {
        let layoutNode = super.buildRow(node, x, y);
        layoutNode.layoutInfo.allowOverflow = true;
        // Needs overflow for sticky selection/drag cells
        return layoutNode;
    }
    buildTableHeader() {
        let layoutNode = super.buildTableHeader();
        // Needs overflow for sticky selection/drag column
        layoutNode.layoutInfo.allowOverflow = true;
        return layoutNode;
    }
    buildColumn(node, x, y) {
        let layoutNode = super.buildColumn(node, x, y);
        // Needs overflow for the resize handle
        layoutNode.layoutInfo.allowOverflow = true;
        return layoutNode;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = super.getDropTargetLayoutInfo(target);
        layoutInfo.zIndex = 1;
        layoutInfo.allowOverflow = true;
        return layoutInfo;
    }
}
const $0a7fba920f0e9b9f$export$93e4b0b2cc49b648 = (0, $eF4cA.createContext)(null);
const $0a7fba920f0e9b9f$export$b3c27e869d856b7 = (0, $eF4cA.forwardRef)(function TableView(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $0a7fba920f0e9b9f$export$93e4b0b2cc49b648);
    let { UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, isQuiet: isQuiet = false, density: density = 'regular', overflowMode: overflowMode = 'truncate', styles: styles, loadingState: loadingState, onResize: propsOnResize, onResizeStart: propsOnResizeStart, onResizeEnd: propsOnResizeEnd, onAction: onAction, onLoadMore: onLoadMore, selectionMode: selectionMode = 'none', selectionStyle: selectionStyle = 'checkbox', dragAndDropHooks: dragAndDropHooks, disabledBehavior: disabledBehavior = 'all', keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow', ...otherProps } = props;
    if (dragAndDropHooks && dragAndDropHooks.renderDragPreview == null) dragAndDropHooks.renderDragPreview = (items)=>(0, $dx4lB.jsx)((0, $2d603d22b712a1e0$export$905ab40ac2179daa), {
            items: items,
            overflowMode: overflowMode
        });
    if (dragAndDropHooks) dragAndDropHooks.renderDropIndicator = (target)=>(0, $dx4lB.jsx)((0, $6750b0b6e12c44b5$export$2c0bab5914a9d088), {
            target: target
        });
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let scale = (0, $e0Enh.useScale)();
    // Starts when the user selects resize from the menu, ends when resizing ends
    // used to control the visibility of the resizer Nubbin
    let [isInResizeMode, setIsInResizeMode] = (0, $eF4cA.useState)(false);
    let onResizeStart = (0, $eF4cA.useCallback)((widths)=>{
        propsOnResizeStart?.(widths);
    }, [
        propsOnResizeStart
    ]);
    let onResizeEnd = (0, $eF4cA.useCallback)((widths)=>{
        setIsInResizeMode(false);
        propsOnResizeEnd?.(widths);
    }, [
        propsOnResizeEnd,
        setIsInResizeMode
    ]);
    let context = (0, $eF4cA.useMemo)(()=>({
            isQuiet: isQuiet,
            density: density,
            overflowMode: overflowMode,
            loadingState: loadingState,
            onLoadMore: onLoadMore,
            isInResizeMode: isInResizeMode,
            setIsInResizeMode: setIsInResizeMode,
            selectionMode: selectionMode,
            selectionStyle: selectionStyle,
            disabledBehavior: disabledBehavior,
            keyboardNavigationBehavior: keyboardNavigationBehavior
        }), [
        isQuiet,
        density,
        overflowMode,
        loadingState,
        onLoadMore,
        isInResizeMode,
        setIsInResizeMode,
        selectionMode,
        selectionStyle,
        disabledBehavior,
        keyboardNavigationBehavior
    ]);
    let scrollRef = (0, $eF4cA.useRef)(null);
    let isCheckboxSelection = selectionMode === 'multiple' || selectionMode === 'single';
    let isDragAndDrop = !!dragAndDropHooks?.useDraggableCollectionState;
    let { selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, actionBar: actionBar, actionBarHeight: actionBarHeight } = (0, $df1664e6139b6656$export$13f32e21845e01d0)({
        ...props,
        scrollRef: scrollRef
    });
    return (0, $dx4lB.jsxs)((0, $167a69a603174653$export$7063e69b8a954175), {
        // TODO: perhaps this ref should be attached to the RACTable but it expects a table type ref which isn't true in the virtualized case
        ref: domRef,
        onResize: propsOnResize,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        className: (UNSAFE_className || '') + $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$tableWrapper(null, styles) + ' ' + $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootDropOutline,
        style: UNSAFE_style,
        children: [
            (0, $dx4lB.jsx)((0, $eF2II.Virtualizer), {
                layout: $0a7fba920f0e9b9f$export$4e03bdf0174fd602,
                layoutOptions: {
                    rowHeight: overflowMode === 'wrap' ? undefined : $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ROW_HEIGHTS[density][scale],
                    estimatedRowHeight: overflowMode === 'wrap' ? $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ROW_HEIGHTS[density][scale] : undefined,
                    // No need for estimated headingHeight since the headers aren't affected by overflow mode: wrap
                    headingHeight: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$DEFAULT_HEADER_HEIGHT[scale],
                    loaderHeight: 60,
                    dropIndicatorThickness: 0
                },
                children: (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext.Provider, {
                    value: context,
                    children: (0, $dx4lB.jsx)((0, $167a69a603174653$export$54ec01a60f47d33d), {
                        ref: scrollRef,
                        style: {
                            // Fix webkit bug where scrollbars appear above the checkboxes/other table elements
                            WebkitTransform: 'translateZ(0)',
                            // Add padding at the bottom when the action bar is visible so users can scroll to the last items.
                            // Also add scroll padding so navigating with the keyboard doesn't go behind the action bar.
                            paddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0,
                            scrollPaddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0
                        },
                        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$table({
                                ...renderProps,
                                isCheckboxSelection: isCheckboxSelection,
                                isDragAndDrop: isDragAndDrop,
                                isQuiet: isQuiet
                            }),
                        selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                        selectionMode: selectionMode,
                        onRowAction: onAction,
                        dragAndDropHooks: dragAndDropHooks,
                        disabledBehavior: disabledBehavior,
                        keyboardNavigationBehavior: keyboardNavigationBehavior,
                        ...otherProps,
                        selectedKeys: selectedKeys,
                        defaultSelectedKeys: undefined,
                        onSelectionChange: onSelectionChange
                    })
                })
            }),
            actionBar
        ]
    });
});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$centeredWrapper = " sd182 eb182 _Ca182 Za182 Fb182";
const $0a7fba920f0e9b9f$export$76ccd210b9029917 = (0, $eF4cA.forwardRef)(function TableBody(props, ref) {
    let { items: items, renderEmptyState: renderEmptyState, children: children, dependencies: dependencies = [] } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { loadingState: loadingState, onLoadMore: onLoadMore } = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let emptyRender;
    let renderer = children;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($0a7fba920f0e9b9f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    // TODO: still is offset strangely if loadingMore when there aren't any items in the table, see http://localhost:6006/?path=/story/tableview--empty-state&args=loadingState:loadingMore
    // This is because we don't distinguish between loadingMore and loading in the layout, resulting in a different rect being used to build the body. Perhaps can be considered as a user error
    // if they pass loadingMore without having any other items in the table. Alternatively, could update the layout so it knows the current loading state.
    let loadMoreSpinner = (0, $dx4lB.jsx)((0, $167a69a603174653$export$8f5bea0338ed243c), {
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: " Fb182 Za182",
        children: (0, $dx4lB.jsx)("div", {
            className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$centeredWrapper,
            children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": stringFormatter.format('table.loadingMore')
            })
        })
    });
    // If the user is rendering their rows in dynamic fashion, wrap their render function in Collection so we can inject
    // the loader. Otherwise it is a static renderer and thus we can simply add the table loader after
    // TODO: this assumes that the user isn't providing their children in some wrapper though and/or isn't doing a map of children
    // (though I guess they wouldn't provide items then so the check for this is still valid in the latter case)...
    if (typeof children === 'function' && items) renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: items,
                dependencies: dependencies,
                children: children
            }),
            loadMoreSpinner
        ]
    });
    else renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            children,
            loadMoreSpinner
        ]
    });
    if (renderEmptyState != null && !isLoading) emptyRender = (props)=>(0, $dx4lB.jsx)("div", {
            className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$centeredWrapper,
            children: (0, $dx4lB.jsx)((0, $8dzVy.CollectionRendererContext).Provider, {
                value: (0, $8dzVy.DefaultCollectionRenderer),
                children: renderEmptyState(props)
            })
        });
    else if (loadingState === 'loading') emptyRender = ()=>(0, $dx4lB.jsx)("div", {
            className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$centeredWrapper,
            children: (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": stringFormatter.format('table.loading')
            })
        });
    return (0, $dx4lB.jsx)((0, $167a69a603174653$export$76ccd210b9029917), {
        // @ts-ignore
        ref: domRef,
        className: " Fb182",
        ...props,
        renderEmptyState: emptyRender,
        dependencies: [
            loadingState
        ],
        children: renderer
    });
});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$cellFocus = {
    outlineStyle: {
        default: 'none',
        isFocusVisible: 'solid'
    },
    outlineOffset: -2,
    outlineWidth: 2,
    outlineColor: {
        default: 'focus-ring',
        forcedColors: {
            default: 'Highlight'
        }
    },
    borderRadius: '[5px]',
    // We need to render the cell focus ring on top of the cell divider if there is one. The divider has a z-index of 1.
    zIndex: 2
};
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$CellFocusRing() {
    return (0, $dx4lB.jsx)("div", {
        role: "presentation",
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf182';
            else rules += ' _Le182';
            rules += ' _Kb182';
            rules += ' _Mc182';
            rules += ' Oh182';
            rules += ' Olc182';
            rules += ' osmOfn182';
            rules += ' nsmOfn182';
            rules += ' ksmOfn182';
            rules += ' jsmOfn182';
            rules += ' _9d182';
            rules += ' _Pa182';
            rules += ' WEDXqxb182';
            rules += ' _lr182';
            rules += ' _Ar182';
            rules += ' _zr182';
            rules += ' _Ob182';
            return rules;
        }({
            isFocusVisible: true
        })
    });
}
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnStyles = function anonymous(props) {
    let rules = " ";
    rules += ' F40ub4c182';
    rules += ' _oa182';
    if (props.isPressed) rules += ' po182';
    else if (props.isFocusVisible) rules += ' po182';
    else if (props.isHovered) rules += ' po182';
    else rules += ' pt182';
    rules += ' plb182';
    if (props.isMenu) rules += ' Sd182';
    else rules += ' Sf182';
    if (props.isMenu) rules += ' Rd182';
    else rules += ' Rf182';
    if (props.align === "end") rules += ' _Wb182';
    else if (props.align === "center") rules += ' _Wa182';
    else if (props.align === "start") rules += ' _Wd182';
    rules += ' _Le182';
    rules += ' _Pc182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    rules += ' sd182';
    rules += ' iq182';
    rules += ' ila182';
    if (props.isQuiet) rules += ' _kb182';
    else rules += ' _ka182';
    rules += ' hb182';
    rules += ' ma182';
    if (props.isMenu) rules += ' lb182';
    else rules += ' la182';
    rules += ' _jf182';
    rules += ' _yb182';
    return rules;
};
const $0a7fba920f0e9b9f$export$816b5d811295e6bc = (0, $eF4cA.forwardRef)(function Column(props, ref) {
    let { isQuiet: isQuiet, keyboardNavigationBehavior: keyboardNavigationBehavior } = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let { allowsResizing: allowsResizing, children: children, align: align = 'start' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let isMenu = allowsResizing || !!props.menuItems;
    return (0, $dx4lB.jsx)((0, $167a69a603174653$export$816b5d811295e6bc), {
        // will need to make sure that focusMode and allowsArrowNavigation are only both set if said cell
        // doesn't have a textfield/interactive component that will need the arrow keys
        focusMode: keyboardNavigationBehavior === 'tab' ? 'child' : undefined,
        allowsArrowNavigation: keyboardNavigationBehavior === 'tab' || undefined,
        ...props,
        ref: domRef,
        style: {
            borderInlineEndColor: 'transparent'
        },
        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnStyles({
                ...renderProps,
                isMenu: isMenu,
                align: align,
                isQuiet: isQuiet
            }),
        children: ({ allowsSorting: allowsSorting, sortDirection: sortDirection, isFocusVisible: isFocusVisible, sort: sort, startResize: startResize })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    isFocusVisible && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$CellFocusRing, {}),
                    isMenu ? (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ColumnWithMenu, {
                        isColumnResizable: allowsResizing,
                        menuItems: props.menuItems,
                        allowsSorting: allowsSorting,
                        sortDirection: sortDirection,
                        sort: sort,
                        startResize: startResize,
                        align: align,
                        children: children
                    }) : (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ColumnContents, {
                        align: align,
                        allowsSorting: allowsSorting,
                        sortDirection: sortDirection,
                        children: children
                    })
                ]
            })
    });
});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnContentWrapper = function anonymous(props) {
    let rules = " ";
    rules += ' Na182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' Za182';
    if (props.align === "end") rules += ' _Cb182';
    else if (props.align === "center") rules += ' _Ca182';
    else if (props.align === "default") rules += ' _Cg182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$sortIcon = function anonymous(props) {
    let rules = " ";
    rules += ' ZXJkxGe182';
    rules += ' FXJkxGe182';
    rules += ' _va182';
    if (props.isButton) {
        rules += ' Ht182';
        rules += ' Hsu182';
    } else rules += ' Hv182';
    rules += ' _5b182';
    rules += ' -_8sjo0b-t5ZbAob182';
    return rules;
};
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ColumnContents(props) {
    let { align: align, allowsSorting: allowsSorting, sortDirection: sortDirection, children: children } = props;
    return (0, $dx4lB.jsxs)("div", {
        className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnContentWrapper({
            align: align
        }),
        children: [
            allowsSorting && (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $dm5H1.IconContext),
                        {
                            styles: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$sortIcon({})
                        }
                    ]
                ],
                children: sortDirection != null && (sortDirection === 'ascending' ? (0, $dx4lB.jsx)((0, $981c4ca4a675355f$export$2e2bcd8739ae039), {}) : (0, $dx4lB.jsx)((0, $0d716ea2abb3d15e$export$2e2bcd8739ae039), {}))
            }),
            (0, $dx4lB.jsx)("span", {
                className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnHeaderText,
                children: children
            })
        ]
    });
}
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$resizableMenuButtonWrapper = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' _Kb182';
    rules += ' _Mc182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' osmOfn182';
    rules += ' nsmOfn182';
    rules += ' ksmOfn182';
    rules += ' jsmOfn182';
    rules += ' _9d182';
    rules += ' po182';
    rules += ' Za182';
    rules += ' _Pc182';
    rules += ' sd182';
    rules += ' eb182';
    if (props.align === "end") rules += ' _Cb182';
    else if (props.align === "center") rules += ' _Ca182';
    else if (props.align === "default") rules += ' _Cg182';
    rules += ' Sf182';
    rules += ' Rf182';
    rules += ' g9182';
    rules += ' _je182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    rules += ' xfd182';
    rules += ' _xfa182';
    rules += ' xfX0cczbc182';
    rules += ' _xfX0cczba182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$resizerHandleContainer = function anonymous(props) {
    let rules = " ";
    if (props.isInResizeMode) rules += ' sb182';
    else if (props.isResizing) rules += ' sb182';
    else rules += ' sjBAxlb182';
    rules += ' Zj182';
    rules += ' Fb182';
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _zdYbyj182';
    if (props.resizableDirection === "both") rules += ' rk182';
    else if (props.resizableDirection === "right") rules += ' rF182';
    else if (props.resizableDirection === "left") rules += ' rj182';
    else rules += ' rt182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$resizerHandle = function anonymous(props) {
    let rules = " ";
    if (props.isResizing) rules += ' g5qAiPc182';
    else if (props.isFocusVisible) rules += ' g5qAiPc182';
    else rules += ' gE182';
    if (props.isResizing) rules += ' gle182';
    else if (props.isFocusVisible) rules += ' gle182';
    else rules += ' gla182';
    if (props.isResizing) rules += ' Fc182';
    else rules += ' Fb182';
    if (props.isResizing) rules += ' Zf182';
    else rules += ' Ze182';
    rules += ' _Pa182';
    rules += ' _AWJpoB182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnHeaderText = " _Nc182 Pc182 _Yb182 _7c182 NLb8KJ182 _ua182 _vb182 _sd182";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$moreVerticalIcon = function anonymous(props) {
    let rules = " ";
    rules += ' ZObNfn182';
    rules += ' FObNfn182';
    rules += ' It182';
    rules += ' Isu182';
    rules += ' NXJkxGe182';
    rules += ' _va182';
    if (props.isFocusVisible) rules += ' -_8sjo0b-tr182';
    else if (props.isHovered) rules += ' -_8sjo0b-tr182';
    else rules += ' -_8sjo0b-tOGGDSb182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$nubbin = " _Pa182 Wr182 _AlhfIS182 ZXJkxGe182 FXJkxGe182 t5qAiPc182 tla182 -_8sjo0b-tw182 -_8sjo0b-lt8pvGJ182";
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ColumnWithMenu(props) {
    let { allowsSorting: allowsSorting, sortDirection: sortDirection, sort: sort, startResize: startResize, children: children, align: align, isColumnResizable: isColumnResizable, menuItems: menuItems } = props;
    let { setIsInResizeMode: setIsInResizeMode, isInResizeMode: isInResizeMode } = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($0a7fba920f0e9b9f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    const onMenuSelect = (key)=>{
        switch(key){
            case 'sort-asc':
                sort('ascending');
                break;
            case 'sort-desc':
                sort('descending');
                break;
            case 'resize':
                setIsInResizeMode?.(true);
                startResize();
                break;
        }
    };
    let items = (0, $eF4cA.useMemo)(()=>{
        let options = [];
        if (isColumnResizable) options = [
            {
                // oxlint-disable-next-line react/react-compiler
                label: stringFormatter.format('table.resizeColumn'),
                id: 'resize'
            }
        ];
        if (allowsSorting) options = [
            {
                label: stringFormatter.format('table.sortAscending'),
                id: 'sort-asc'
            },
            {
                label: stringFormatter.format('table.sortDescending'),
                id: 'sort-desc'
            },
            ...options
        ];
        return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowsSorting,
        isColumnResizable
    ]);
    let buttonAlignment = 'start';
    let menuAlign = 'start';
    if (align === 'center') buttonAlignment = 'center';
    else if (align === 'end') {
        buttonAlignment = 'end';
        menuAlign = 'end';
    }
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                align: menuAlign,
                children: [
                    (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
                        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$resizableMenuButtonWrapper({
                                ...renderProps,
                                align: buttonAlignment
                            }),
                        children: ({ isHovered: isHovered, isFocusVisible: isFocusVisible })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    allowsSorting && (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                        values: [
                                            [
                                                (0, $dm5H1.IconContext),
                                                {
                                                    styles: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$sortIcon({
                                                        isButton: true
                                                    })
                                                }
                                            ]
                                        ],
                                        children: sortDirection != null && (sortDirection === 'ascending' ? (0, $dx4lB.jsx)((0, $981c4ca4a675355f$export$2e2bcd8739ae039), {}) : (0, $dx4lB.jsx)((0, $0d716ea2abb3d15e$export$2e2bcd8739ae039), {}))
                                    }),
                                    (0, $dx4lB.jsx)("div", {
                                        className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$columnHeaderText,
                                        children: children
                                    }),
                                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                        values: [
                                            [
                                                (0, $dm5H1.IconContext),
                                                {
                                                    styles: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$moreVerticalIcon({
                                                        isHovered: isHovered,
                                                        isFocusVisible: isFocusVisible
                                                    })
                                                }
                                            ]
                                        ],
                                        children: (0, $dx4lB.jsx)((0, $c24960d0d4b13363$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                    }),
                    (0, $dx4lB.jsxs)((0, $8wD3p.Menu), {
                        onAction: onMenuSelect,
                        styles: " Nn182",
                        children: [
                            items.length > 0 && (0, $dx4lB.jsx)((0, $8wD3p.MenuSection), {
                                children: (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                    items: items,
                                    children: (item)=>(0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                            children: item?.label
                                        })
                                })
                            }),
                            menuItems
                        ]
                    })
                ]
            }),
            isColumnResizable && (0, $dx4lB.jsx)("div", {
                "data-react-aria-prevent-focus": "true",
                children: (0, $dx4lB.jsx)((0, $167a69a603174653$export$ee689e97a7664bfd), {
                    "data-react-aria-prevent-focus": "true",
                    className: ({ resizableDirection: resizableDirection, isResizing: isResizing })=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$resizerHandleContainer({
                            resizableDirection: resizableDirection,
                            isResizing: isResizing,
                            isInResizeMode: isInResizeMode
                        }),
                    children: ({ isFocusVisible: isFocusVisible, isResizing: isResizing })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ResizerIndicator, {
                                    isFocusVisible: isFocusVisible,
                                    isResizing: isResizing
                                }),
                                (isFocusVisible || isInResizeMode) && isResizing && (0, $dx4lB.jsx)("div", {
                                    className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$nubbin,
                                    children: (0, $dx4lB.jsx)((0, $79a6c2b248cdee5a$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                })
            })
        ]
    });
}
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ResizerIndicator({ isFocusVisible: isFocusVisible, isResizing: isResizing }) {
    return (0, $dx4lB.jsx)("div", {
        className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$resizerHandle({
            isFocusVisible: isFocusVisible,
            isResizing: isResizing
        })
    });
}
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$tableHeader = function anonymous(props) {
    let rules = " ";
    rules += ' Fb182';
    rules += ' Za182';
    rules += ' gL182';
    rules += ' gl9182';
    rules += ' JLPOtrc182';
    if (props.isHovered) rules += ' -xLp2wc-sb182';
    else rules += ' -xLp2wc-sk182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectAllCheckbox = "";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectAllCheckboxColumn = function anonymous(props) {
    let rules = " ";
    rules += ' Sd182';
    rules += ' SZbReHcf182';
    rules += ' Rd182';
    rules += ' RZbReHct182';
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' Fb182';
    rules += ' _oa182';
    rules += ' _Le182';
    rules += ' _Pc182';
    rules += ' sd182';
    rules += ' _cb182';
    rules += ' eb182';
    rules += ' _Cg182';
    rules += ' iq182';
    rules += ' ila182';
    rules += ' ma182';
    rules += ' la182';
    if (props.isQuiet) rules += ' _kb182';
    else rules += ' _ka182';
    rules += ' hb182';
    rules += ' _jf182';
    rules += ' gL182';
    rules += ' gl9182';
    return rules;
};
const $0a7fba920f0e9b9f$export$f850895b287ef28e = (0, $eF4cA.forwardRef)(function TableHeader({ columns: columns, dependencies: dependencies, children: children }, ref) {
    let scale = (0, $e0Enh.useScale)();
    let { selectionBehavior: selectionBehavior, selectionMode: selectionMode, allowsDragging: allowsDragging } = (0, $167a69a603174653$export$fddc468cd8cb4db9)();
    let { isQuiet: isQuiet, selectionStyle: selectionStyle, keyboardNavigationBehavior: keyboardNavigationBehavior } = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($0a7fba920f0e9b9f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    return (0, $dx4lB.jsxs)((0, $167a69a603174653$export$f850895b287ef28e), {
        // @ts-ignore
        ref: domRef,
        className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$tableHeader,
        children: [
            allowsDragging && (0, $dx4lB.jsx)((0, $167a69a603174653$export$816b5d811295e6bc), {
                // @ts-ignore
                isSticky: true,
                width: scale === 'medium' ? 16 : 20,
                minWidth: scale === 'medium' ? 16 : 20,
                className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectAllCheckboxColumn({
                    isQuiet: isQuiet
                }),
                children: ({ isFocusVisible: isFocusVisible })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            isFocusVisible && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$CellFocusRing, {}),
                            (0, $dx4lB.jsx)((0, $31fH3.VisuallyHidden), {
                                children: stringFormatter.format('table.drag')
                            })
                        ]
                    })
            }),
            selectionBehavior === 'toggle' && selectionStyle === 'checkbox' && (0, $dx4lB.jsx)((0, $167a69a603174653$export$816b5d811295e6bc), {
                // Also isSticky prop is applied just for the layout, will decide what the RAC api should be later
                // @ts-ignore
                isSticky: true,
                width: scale === 'medium' ? 40 : 52,
                minWidth: scale === 'medium' ? 40 : 52,
                focusMode: keyboardNavigationBehavior === 'tab' ? 'child' : undefined,
                allowsArrowNavigation: keyboardNavigationBehavior === 'tab' || undefined,
                className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectAllCheckboxColumn({
                    isQuiet: isQuiet
                }),
                children: ({ isFocusVisible: isFocusVisible })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            isFocusVisible && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$CellFocusRing, {}),
                            selectionMode === 'single' && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$VisuallyHiddenSelectAllLabel, {}),
                            selectionMode === 'multiple' && (0, $dx4lB.jsx)((0, $cxTG4.Checkbox), {
                                styles: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectAllCheckbox,
                                slot: "selection"
                            })
                        ]
                    })
            }),
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: columns,
                dependencies: dependencies,
                children: children
            })
        ]
    });
});
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$VisuallyHiddenSelectAllLabel() {
    let checkboxProps = (0, $fDYaM.useSlottedContext)((0, $ed1Og.CheckboxContext), 'selection');
    return (0, $dx4lB.jsx)((0, $31fH3.VisuallyHidden), {
        children: checkboxProps?.['aria-label']
    });
}
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$commonCellStyles = {
    position: 'relative',
    color: '--rowTextColor',
    outlineStyle: 'none',
    paddingX: 16 // table-edge-to-content
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$treeColumnStyles = {
    '--treeColumnPadding': {
        type: 'width',
        value: {
            default: 16,
            isTreeColumnWithNoChildren: 36
        }
    },
    paddingStart: {
        default: 16,
        isTreeColumn: 'calc(var(--treeColumnPadding) + (var(--table-row-level, 1) - 1) * var(--indent))'
    }
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$cell = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc182';
    rules += ' pBvFblc182';
    rules += ' _Le182';
    if (props.isTreeColumn) rules += ' S7cyhDe182';
    else rules += ' Sf182';
    rules += ' Rf182';
    if (props.isTreeColumnWithNoChildren) rules += ' -WWxPD-Zv182';
    else rules += ' -WWxPD-Zu182';
    if (props.density === "spacious") rules += ' Mk182';
    else if (props.density === "compact") rules += ' Mi182';
    else rules += ' Mh182';
    rules += ' _oa182';
    rules += ' Fb182';
    rules += ' Za182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' eb182';
    rules += ' sd182';
    return rules;
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$divider = " sb182 _Pa182 ZceNfn182 Fb182 _zr182 gp95UEb182 _9c182";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$stickyCell = {
    backgroundColor: 'gray-25'
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$checkboxCellStyle = " _Pc182 pBvFblc182 _Le182 Sf182 Rt182 gs9yXOb182 sd182 _cb182 eb182 _Cg182 FBJsHLe182 ha182";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$dragCellStyle = " _Pc182 pBvFblc182 _Le182 Sp182 Rp182 gs9yXOb182 _cb182 FBJsHLe182 ha182";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$cellContent = function anonymous(props) {
    let rules = " ";
    if (props.isSticky) rules += ' _Ne182';
    else rules += ' _Nc182';
    if (props.isSticky) rules += ' Pe182';
    else rules += ' Pc182';
    if (props.isSticky) rules += ' _Ya182';
    else rules += ' _Yb182';
    if (props.overflowMode === "wrap") rules += ' _7b182';
    else rules += ' _7c182';
    if (props.align === "end") rules += ' _Wb182';
    else if (props.align === "center") rules += ' _Wa182';
    else if (props.align === "start") rules += ' _Wd182';
    rules += ' Za182';
    rules += ' ZZbReHce4mUs182';
    rules += ' _Bb182';
    if (props.isSticky) rules += ' Td182';
    else rules += ' Tp182';
    if (props.isSticky) rules += ' Qd182';
    else rules += ' Qp182';
    if (props.isSticky) rules += ' Sd182';
    else rules += ' Sp182';
    if (props.isSticky) rules += ' Rd182';
    else rules += ' Rp182';
    if (props.isSticky) rules += ' Jy182';
    else rules += ' Jb182';
    if (props.isSticky) rules += ' Gy182';
    else rules += ' Gb182';
    if (props.isSticky) rules += ' Iy182';
    else rules += ' Ib182';
    if (props.isSticky) rules += ' Hy182';
    else rules += ' Hb182';
    if (props.isSticky) rules += ' gs9yXOb182';
    else rules += ' g9182';
    return rules;
};
const $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea = (0, $eF4cA.forwardRef)(function Cell(props, ref) {
    let { children: children, isSticky: isSticky, showDivider: showDivider = false, align: align, textValue: textValue, ...otherProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let tableVisualOptions = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    textValue ||= typeof children === 'string' ? children : undefined;
    return (0, $dx4lB.jsx)((0, $167a69a603174653$export$f6f0c3fe4ec306ea), {
        ref: domRef,
        // Also isSticky prop is applied just for the layout, will decide what the RAC api should be later
        // @ts-ignore
        isSticky: isSticky,
        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$cell({
                ...renderProps,
                ...tableVisualOptions,
                isDivider: showDivider,
                isTreeColumnWithNoChildren: renderProps.isTreeColumn && !renderProps.hasChildItems
            }),
        textValue: textValue,
        ...otherProps,
        children: ({ id: id, isFocusVisible: isFocusVisible, hasChildItems: hasChildItems, isTreeColumn: isTreeColumn, isExpanded: isExpanded, isDisabled: isDisabled })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    showDivider && (0, $dx4lB.jsx)("div", {
                        className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$divider
                    }),
                    hasChildItems && isTreeColumn && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ExpandableRowChevron, {
                        isDisabled: isDisabled,
                        isExpanded: isExpanded
                    }, id),
                    (0, $dx4lB.jsx)("span", {
                        className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$cellContent({
                            ...tableVisualOptions,
                            isSticky: isSticky,
                            align: align || 'start'
                        }),
                        children: children
                    }),
                    isFocusVisible && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$CellFocusRing, {})
                ]
            })
    });
});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$expandButton = function anonymous(props) {
    let rules = " ";
    rules += ' z8dW5Qb182';
    rules += ' y8dW5Qb182';
    rules += ' B8dW5Qb182';
    rules += ' A8dW5Qb182';
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else rules += ' p40ub4c182';
    rules += ' Fb182';
    rules += ' Zw182';
    rules += ' Id182';
    rules += ' sd182';
    rules += ' _wb182';
    rules += ' _cb182';
    rules += ' _Ca182';
    rules += ' _Le182';
    rules += ' ri182';
    if (props.isExpanded) {
        if (props.isRTL) rules += ' _Za182';
        else rules += ' _Zb182';
    }
    rules += ' Td182';
    rules += ' Qd182';
    rules += ' Sd182';
    rules += ' Rd182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' g9182';
    rules += ' _je182';
    rules += ' __ca182';
    if (props.isHidden) rules += ' _6b182';
    return rules;
};
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ExpandableRowChevron(props1) {
    let ref = (0, $eF4cA.useRef)(null);
    let { isExpanded: isExpanded, isHidden: isHidden } = props1;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        ...props1,
        ref: ref,
        slot: "chevron",
        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$expandButton({
                ...renderProps,
                isExpanded: isExpanded,
                isRTL: direction === 'rtl',
                isHidden: isHidden
            }),
        children: (0, $dx4lB.jsx)((0, $hxsf4.default), {
            className: function anonymous(props) {
                let rules = " ";
                if (props.direction === "rtl") {
                    rules += ' -Z4Pn4c-a182';
                    rules += ' __Ha182';
                } else if (props.direction === "ltr") {
                    rules += ' -Z4Pn4c-b182';
                    rules += ' __Ha182';
                }
                if (props.direction === "rtl") {
                    rules += ' -_04Pn4c-a182';
                    rules += ' __Ha182';
                } else if (props.direction === "ltr") {
                    rules += ' -_04Pn4c-b182';
                    rules += ' __Ha182';
                }
                rules += ' -_8sjo0b-t5ZbAob182';
                return rules;
            }({
                direction: direction
            })
        })
    });
}
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$editableCell = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc182';
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isSaving) {
            if (props.isPressed) rules += ' pt182';
            else if (props.isFocusVisible) rules += ' pt182';
            else if (props.isHovered) rules += ' pt182';
            else rules += ' pv182';
        } else {
            if (props.isPressed) rules += ' po182';
            else if (props.isFocusVisible) rules += ' po182';
            else if (props.isHovered) rules += ' po182';
            else rules += ' pt182';
        }
        rules += ' plb182';
    }
    rules += ' _Le182';
    if (props.isTreeColumn) rules += ' S7cyhDe182';
    else rules += ' Sf182';
    rules += ' Rf182';
    if (props.isTreeColumnWithNoChildren) rules += ' -WWxPD-Zv182';
    else rules += ' -WWxPD-Zu182';
    rules += ' Tu7Fubd182';
    rules += ' Qu7Fubd182';
    rules += ' _oa182';
    rules += ' FBJsHLe182';
    rules += ' Za182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' eb182';
    rules += ' sd182';
    if (props.isDivider) rules += ' _jf182';
    else rules += ' _je182';
    if (props.isDivider) rules += ' lb182';
    else rules += ' la182';
    rules += ' iq182';
    rules += ' ila182';
    return rules;
};
let $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$editPopover = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.colorScheme === "dark") rules += ' -ICUGx-_pa182';
    else if (props.colorScheme === "light") rules += ' -ICUGx-_pb182';
    else if (props.colorScheme === "light dark") {
        rules += ' -ICUGx-_pb182';
        rules += ' -ICUGx-D1v0V_pa182';
    }
    rules += ' _pK8eoyd182';
    if (props.colorScheme === "dark") rules += ' -NvXmrd-_ZLmU182';
    else if (props.colorScheme === "light") rules += ' -NvXmrd-_ZN8Gi4c182';
    else if (props.colorScheme === "light dark") {
        rules += ' -NvXmrd-_ZN8Gi4c182';
        rules += ' -NvXmrd-D1v0V_ZLmU182';
    }
    if (props.colorScheme === "dark") rules += ' -j9blY-_ZN8Gi4c182';
    else if (props.colorScheme === "light") rules += ' -j9blY-_ZLmU182';
    else if (props.colorScheme === "light dark") {
        rules += ' -j9blY-_ZLmU182';
        rules += ' -j9blY-D1v0V_ZN8Gi4c182';
    }
    rules += ' -Ovbhqd-g_g182';
    rules += ' gEzkoQe182';
    rules += ' kb182';
    rules += ' jb182';
    rules += ' _nLeasBb182';
    rules += ' _jf182';
    rules += ' _kb182';
    rules += ' hb182';
    rules += ' mb182';
    rules += ' lb182';
    rules += ' ir182';
    rules += ' ila182';
    rules += ' _ob182';
    rules += ' _Bb182';
    if (props.isExiting) rules += ' _Ob182';
    rules += ' _Le182';
    if (!minWidth) rules += ' NuHSBze182';
    rules += ' Tt182';
    rules += ' Qt182';
    rules += ' St182';
    rules += ' Rt182';
    rules += ' sd182';
    rules += ' eb182';
    return rules;
};
const $0a7fba920f0e9b9f$export$d27c35c47f085992 = (0, $eF4cA.forwardRef)(function EditableCell(props, ref) {
    let { children: children, showDivider: showDivider = false, textValue: textValue, isSaving: isSaving, ...otherProps } = props;
    let tableVisualOptions = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let domRef = (0, $26CkO.useObjectRef)(ref);
    textValue ||= typeof children === 'string' ? children : undefined;
    return (0, $dx4lB.jsx)((0, $167a69a603174653$export$f6f0c3fe4ec306ea), {
        ref: domRef,
        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$editableCell({
                ...renderProps,
                ...tableVisualOptions,
                isDivider: showDivider,
                isSaving: isSaving,
                isTreeColumnWithNoChildren: renderProps.isTreeColumn && !renderProps.hasChildItems
            }),
        textValue: textValue,
        ...otherProps,
        children: ({ id: id, isFocusVisible: isFocusVisible, hasChildItems: hasChildItems, isTreeColumn: isTreeColumn, isExpanded: isExpanded, isDisabled: isDisabled })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    hasChildItems && isTreeColumn && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$ExpandableRowChevron, {
                        isDisabled: isDisabled,
                        isExpanded: isExpanded
                    }, id),
                    (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$EditableCellInner, {
                        ...props,
                        isFocusVisible: isFocusVisible,
                        cellRef: domRef
                    })
                ]
            })
    });
});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$EditableCellInner(props1) {
    let { children: children, align: align, renderEditing: renderEditing, isSaving: isSaving, onSubmit: onSubmit, isFocusVisible: isFocusVisible, cellRef: cellRef, action: action, onCancel: onCancel } = props1;
    let [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    let popoverRef = (0, $eF4cA.useRef)(null);
    let formRef = (0, $eF4cA.useRef)(null);
    let [triggerWidth, setTriggerWidth] = (0, $eF4cA.useState)(0);
    let [tableWidth, setTableWidth] = (0, $eF4cA.useState)(0);
    let [verticalOffset, setVerticalOffset] = (0, $eF4cA.useState)(0);
    let tableVisualOptions = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($0a7fba920f0e9b9f$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let dialogRef = (0, $eF4cA.useRef)(null);
    let { density: density, keyboardNavigationBehavior: keyboardNavigationBehavior } = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let colorScheme = (0, $eF4cA.useContext)((0, $arisx.ColorSchemeContext));
    let size = 'M';
    if (density === 'compact') size = 'S';
    else if (density === 'spacious') size = 'L';
    (0, $4skXn.useLayoutEffect)(()=>{
        if (!isOpen) return;
        let width = cellRef.current?.clientWidth || 0;
        let cell = cellRef.current;
        let boundingRect = cell?.parentElement?.getBoundingClientRect();
        let verticalOffset = (boundingRect?.top ?? 0) - (boundingRect?.bottom ?? 0);
        let tableWidth = cellRef.current?.closest('[role="grid"],[role="treegrid"]')?.clientWidth || 0;
        setTriggerWidth(width);
        setVerticalOffset(verticalOffset);
        setTableWidth(tableWidth);
    }, [
        cellRef,
        density,
        isOpen
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (isOpen) {
            let activeElement = (0, $fvyIQ.getActiveElement)((0, $7ByPJ.getOwnerDocument)(formRef.current));
            if (activeElement && (0, $fvyIQ.nodeContains)(formRef.current, activeElement) && // not going to handle contenteditable https://stackoverflow.com/questions/6139107/programmatically-select-text-in-a-contenteditable-html-element
            // seems like an edge case anyways
            (activeElement instanceof HTMLInputElement && !$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$nonTextInputTypes.has(activeElement.type) || activeElement instanceof HTMLTextAreaElement) && typeof activeElement.select === 'function') activeElement.select();
        }
    }, [
        isOpen
    ]);
    let cancel = (0, $eF4cA.useCallback)(()=>{
        setIsOpen(false);
        onCancel?.();
    }, [
        onCancel
    ]);
    let isMobile = !(0, $5nuB1.useMediaQuery)('(hover: hover) and (pointer: fine)');
    // Can't differentiate between Dialog click outside dismissal and Escape key dismissal
    let prevIsOpen = (0, $eF4cA.useRef)(isOpen);
    (0, $eF4cA.useEffect)(()=>{
        let dialog = dialogRef.current?.UNSAFE_getDOMNode();
        if (isOpen && dialog && !prevIsOpen.current) {
            let handler = (e)=>{
                if (e.key === 'Escape') {
                    cancel();
                    e.stopPropagation();
                    e.preventDefault();
                }
            };
            dialog.addEventListener('keydown', handler);
            prevIsOpen.current = isOpen;
            return ()=>{
                dialog.removeEventListener('keydown', handler);
            };
        }
        prevIsOpen.current = isOpen;
    }, [
        isOpen,
        cancel
    ]);
    return (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
        values: [
            [
                (0, $k5Pnh.ButtonContext),
                null
            ],
            [
                (0, $4W5AG.ActionButtonContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        edit: {
                            onPress: ()=>setIsOpen(true),
                            isPending: isSaving,
                            isQuiet: !isSaving,
                            size: size,
                            excludeFromTabOrder: keyboardNavigationBehavior === 'arrow',
                            styles: function anonymous(props) {
                                let rules = " ";
                                if (props.isForcedVisible) rules += ' _6c182';
                                else rules += ' _6b182';
                                rules += ' _6JGzCfcc182';
                                rules += ' _6hcIDbbc182';
                                rules += ' _6sc182';
                                return rules;
                            }({
                                isForcedVisible: isOpen || !!isSaving
                            })
                        }
                    }
                }
            ]
        ],
        children: [
            (0, $dx4lB.jsx)("span", {
                className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$cellContent({
                    ...tableVisualOptions,
                    align: align || 'start'
                }),
                children: children
            }),
            isFocusVisible && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$CellFocusRing, {}),
            (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
                values: [
                    [
                        (0, $4W5AG.ActionButtonContext),
                        null
                    ]
                ],
                children: [
                    !isMobile && (0, $dx4lB.jsx)((0, $f8UJ0.Popover), {
                        isOpen: isOpen,
                        onOpenChange: setIsOpen,
                        ref: popoverRef,
                        shouldCloseOnInteractOutside: ()=>{
                            if (!(0, $fvyIQ.isFocusWithin)(popoverRef.current)) return false;
                            formRef.current?.requestSubmit();
                            return false;
                        },
                        triggerRef: cellRef,
                        "aria-label": props1['aria-label'] ?? stringFormatter.format('table.editCell'),
                        offset: verticalOffset,
                        placement: "bottom start",
                        style: {
                            minWidth: `min(${triggerWidth}px, ${tableWidth}px)`,
                            maxWidth: `${tableWidth}px`,
                            // Override default z-index from useOverlayPosition. We use isolation: isolate instead.
                            zIndex: undefined
                        },
                        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$editPopover({
                                ...renderProps,
                                colorScheme: colorScheme
                            }),
                        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                            values: [
                                [
                                    (0, $8gDpA.OverlayTriggerStateContext),
                                    null
                                ]
                            ],
                            children: (0, $dx4lB.jsxs)((0, $i0SpD.Form), {
                                ref: formRef,
                                action: action,
                                onSubmit: (e)=>{
                                    onSubmit?.(e);
                                    setIsOpen(false);
                                },
                                className: " Za182 sd182 ed182 Ul182 ql182",
                                style: {
                                    '--input-width': `calc(${triggerWidth}px - 32px)`
                                },
                                children: [
                                    renderEditing(),
                                    (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 _tc182 ea182 _va182 _ua182",
                                        children: [
                                            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                isQuiet: true,
                                                onPress: cancel,
                                                "aria-label": stringFormatter.format('table.cancel'),
                                                children: (0, $dx4lB.jsx)((0, $0ca39120f8ac8a03$export$2e2bcd8739ae039), {})
                                            }),
                                            (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                isQuiet: true,
                                                type: "submit",
                                                "aria-label": stringFormatter.format('table.save'),
                                                children: (0, $dx4lB.jsx)((0, $72df7913f6af7862$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    isMobile && (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
                        onDismiss: ()=>formRef.current?.requestSubmit(),
                        children: isOpen && (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
                            ref: dialogRef,
                            isDismissible: true,
                            isKeyboardDismissDisabled: true,
                            "aria-label": props1['aria-label'] ?? stringFormatter.format('table.editCell'),
                            children: (0, $dx4lB.jsxs)((0, $i0SpD.Form), {
                                ref: formRef,
                                action: action,
                                onSubmit: (e)=>{
                                    onSubmit?.(e);
                                    setIsOpen(false);
                                },
                                className: " Za182 sd182 _ta182 ed182 Ul182 ql182",
                                children: [
                                    renderEditing(),
                                    (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                        align: "end",
                                        styles: " _dd182",
                                        children: [
                                            (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                onPress: cancel,
                                                variant: "secondary",
                                                fillStyle: "outline",
                                                children: "Cancel"
                                            }),
                                            (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                type: "submit",
                                                variant: "accent",
                                                children: "Save"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
// Use color-mix instead of transparency so sticky cells work correctly.
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectedBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectedActiveBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
// TODO: I made these up, not sure if there is a great way to go from v3 values to
// S2. Overall the root drop color should be lighter than the row color during a root drop
// which should be lighter than a selected row during root drop. Those root drop row colors should also be darker
// than if the row is the drop target itself
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootDropRowBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 17%)]";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootDropSelectedRowBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 28%)]";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowDropBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowDropSelectedBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%)]";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootRowDropStyles = {
    default: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootDropRowBackground,
    isSelected: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootDropSelectedRowBackground,
    forcedColors: 'Background'
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowDropStyles = {
    default: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowDropBackground,
    isSelected: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowDropSelectedBackground,
    forcedColors: 'Background'
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowBackgroundColor = {
    default: {
        default: 'gray-25',
        isQuiet: '--s2-container-bg'
    },
    forcedColors: {
        default: 'Background'
    },
    isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
    isSelected: {
        default: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectedBackground,
        isFocusVisibleWithin: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectedActiveBackground,
        isHovered: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectedActiveBackground,
        isPressed: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectedActiveBackground // table-selected-row-background-color, opacity /15
    },
    selectionStyle: {
        highlight: {
            default: 'gray-25',
            isQuiet: '--s2-container-bg',
            isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
            isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
            isSelected: {
                default: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]",
                isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%)]",
                isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%)]",
                forcedColors: 'Highlight'
            }
        }
    },
    isInFooter: 'gray-200',
    ':is([role="grid"][data-drop-target] *)': $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rootRowDropStyles,
    isDropTarget: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowDropStyles
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$rowTextColor = {
    default: {
        "default": "neutral-subdued",
        isHovered: "neutral-subdued:hovered",
        isFocusVisible: "neutral-subdued:focused",
        isPressed: "neutral-subdued:pressed"
    },
    isSelected: {
        "default": "neutral",
        isHovered: "neutral:hovered",
        isFocusVisible: "neutral:focused",
        isPressed: "neutral:pressed"
    },
    forcedColors: {
        default: 'ButtonText',
        isSelected: {
            selectionStyle: {
                highlight: 'HighlightText'
            }
        }
    },
    isDisabled: {
        default: 'disabled',
        forcedColors: 'GrayText'
    },
    isInFooter: 'neutral'
};
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$row = function anonymous(props) {
    let rules = " ";
    rules += ' Fb182';
    rules += ' _Pc182';
    rules += ' _oa182';
    rules += ' gs9yXOb182';
    if (props.isDropTarget) {
        if (props.isSelected) rules += ' -qH4xad-gaZwDBe182';
        else rules += ' -qH4xad-glzvDBe182';
        rules += ' -qH4xad-lga182';
    } else {
        if (props.isInFooter) rules += ' -qH4xad-gF182';
        else if (props.selectionStyle === "highlight") {
            if (props.isSelected) {
                if (props.isPressed) rules += ' -qH4xad-gaZwDBe182';
                else if (props.isHovered) rules += ' -qH4xad-gaZwDBe182';
                else rules += ' -qH4xad-glzvDBe182';
                rules += ' -qH4xad-lge182';
            } else if (props.isPressed) rules += ' -qH4xad-gRfT7e182';
            else if (props.isHovered) rules += ' -qH4xad-gj1B7i182';
            else if (props.isQuiet) rules += ' -qH4xad-gEzkoQe182';
            else rules += ' -qH4xad-gX182';
        } else if (props.isSelected) {
            if (props.isPressed) rules += ' -qH4xad-gRfT7e182';
            else if (props.isHovered) rules += ' -qH4xad-gRfT7e182';
            else if (props.isFocusVisibleWithin) rules += ' -qH4xad-gRfT7e182';
            else rules += ' -qH4xad-gj1B7i182';
        } else if (props.isPressed) rules += ' -qH4xad-gRfT7e182';
        else if (props.isHovered) rules += ' -qH4xad-gj1B7i182';
        else {
            if (props.isQuiet) rules += ' -qH4xad-gEzkoQe182';
            else rules += ' -qH4xad-gX182';
            rules += ' -qH4xad-lga182';
        }
        if (props.isSelected) rules += ' -qH4xad-RQaNpdgubHDBe182';
        else rules += ' -qH4xad-RQaNpdgiyxDBe182';
        rules += ' -qH4xad-RQaNpdlga182';
    }
    if (props.isInFooter) rules += ' -Fadoyc-pt182';
    else if (props.isDisabled) {
        rules += ' -Fadoyc-pp182';
        rules += ' -Fadoyc-lpc182';
    } else {
        if (props.isSelected) {
            if (props.isPressed) rules += ' -Fadoyc-po182';
            else if (props.isFocusVisible) rules += ' -Fadoyc-po182';
            else if (props.isHovered) rules += ' -Fadoyc-po182';
            else rules += ' -Fadoyc-pt182';
        } else {
            if (props.isPressed) rules += ' -Fadoyc-pt182';
            else if (props.isFocusVisible) rules += ' -Fadoyc-pt182';
            else if (props.isHovered) rules += ' -Fadoyc-pt182';
            else rules += ' -Fadoyc-pv182';
        }
        if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' -Fadoyc-lpe182';
        } else rules += ' -Fadoyc-lpb182';
    }
    rules += ' _Le182';
    if (props.selectionStyle === "highlight") {
        if (props.isNextSelected) rules += ' -mtnI9b-kd182';
        else if (props.isSelected) rules += ' -mtnI9b-ksmOfn182';
        else rules += ' -mtnI9b-kd182';
    } else rules += ' -mtnI9b-kd182';
    if (props.selectionStyle === "highlight") {
        if (props.isPrevSelected) rules += ' -GkFu3c-od182';
        else if (props.isSelected) rules += ' -GkFu3c-osmOfn182';
        else rules += ' -GkFu3c-od182';
    } else rules += ' -GkFu3c-od182';
    rules += ' kM1g6bb182';
    rules += ' jM1g6bb182';
    rules += ' ow2GT5b182';
    rules += ' nw2GT5b182';
    if (props.isPrevSelected) rules += ' -K0jSNe-ZDWMfn182';
    else {
        if (props.selectionStyle === "highlight") rules += ' -K0jSNe-Ze182';
        else if (props.selectionStyle === "checkbox") rules += ' -K0jSNe-ZDWMfn182';
    }
    if (props.isNextSelected) rules += ' -ACwbMe-ZDWMfn182';
    else {
        if (props.selectionStyle === "highlight") rules += ' -ACwbMe-Ze182';
        else if (props.selectionStyle === "checkbox") rules += ' -ACwbMe-ZDWMfn182';
    }
    if (props.selectionStyle === "highlight") rules += ' -YiueL-Ze182';
    else if (props.selectionStyle === "checkbox") rules += ' -YiueL-ZDWMfn182';
    rules += ' _ka182';
    rules += ' hb182';
    rules += ' ma182';
    rules += ' la182';
    rules += ' _jf182';
    if (props.selectionStyle === "checkbox") {
        rules += ' iq182';
        rules += ' ila182';
    } else if (props.selectionStyle === "highlight") {
        if (props.isNextSelected) rules += ' iA182';
        else if (props.isSelected) rules += ' iA182';
        else rules += ' iq182';
    }
    rules += ' -JW3yBe-iq182';
    if (props.isSelected) rules += ' -JW3yBe-lid182';
    else rules += ' -JW3yBe-lia182';
    rules += ' -wFhyBe-iw182';
    rules += ' -wFhyBe-lid182';
    if (props.isSelected) rules += ' -EH8uVb-iuZovEb182';
    else rules += ' -EH8uVb-iA182';
    rules += ' -Ov0MLc-Oh182';
    rules += ' -Ov0MLc-lOc182';
    if (props.isInFooter) {
        rules += ' xd182';
        rules += ' _xa182';
        rules += ' xX0cczbc182';
        rules += ' _xX0cczba182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    rules += ' _Bb182';
    rules += ' _yb182';
    if (props.isFirstItem) rules += ' -eTOhNb-Wr182';
    else rules += ' -eTOhNb-WLPOtrc182';
    if (props.isFirstItem) rules += ' -Wasu7d-Wr182';
    else if (props.isPrevSelected) rules += ' -Wasu7d-Wr182';
    else if (props.isSelected) rules += ' -Wasu7d-WLPOtrc182';
    else rules += ' -Wasu7d-Wr182';
    rules += ' -Wasu7d-lWr182';
    if (props.selectionStyle === "highlight") rules += ' -t5oMwe-_lLPOtrc182';
    else if (props.selectionStyle === "checkbox") {
        if (props.isNextSelected) rules += ' -t5oMwe-_lr182';
        else rules += ' -t5oMwe-_lLPOtrc182';
    }
    return rules;
};
// Sticky cells (the drag cell, and the checkbox cell when present) get an inline z-index=2 applied by the virtualizer's layout
// To ensure that the highlight selection border is painted above the sticky cells, set z-index to 3
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$highlightSelectionBorder = "AVAmN";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$focusIndicator = "yb5Ryc";
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectionCheckbox = " _6c182 _6Lcn87b182";
const $0a7fba920f0e9b9f$export$b59bdbef9ce70de2 = (0, $eF4cA.forwardRef)(function Row({ id: id, columns: columns, children: children, dependencies: dependencies = [], ...otherProps }, ref) {
    let { selectionBehavior: selectionBehavior, selectionMode: selectionMode, allowsDragging: allowsDragging } = (0, $167a69a603174653$export$fddc468cd8cb4db9)();
    let { selectionStyle: selectionStyle, keyboardNavigationBehavior: keyboardNavigationBehavior, ...tableVisualOptions } = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$InternalTableContext);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let isInFooter = (0, $eF4cA.useContext)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$FooterContext);
    return (0, $dx4lB.jsxs)((0, $167a69a603174653$export$b59bdbef9ce70de2), {
        // @ts-ignore
        ref: domRef,
        id: id,
        dependencies: [
            ...dependencies,
            columns
        ],
        isDisabled: isInFooter,
        disabledBehavior: isInFooter ? 'selection' : undefined,
        className: (renderProps)=>$0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$row({
                ...renderProps,
                ...tableVisualOptions,
                selectionStyle: selectionStyle,
                isInFooter: isInFooter,
                isFirstItem: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$isFirstItem(renderProps.id, renderProps.state),
                isNextSelected: $0a7fba920f0e9b9f$export$801a7cfaf3e363f5(renderProps.id, renderProps.state),
                isPrevSelected: $0a7fba920f0e9b9f$export$aebccab86af12e73(renderProps.id, renderProps.state)
            }) + (renderProps.isFocusVisible || renderProps.isDropTarget ? ' ' + $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$focusIndicator : '') + (selectionStyle === 'highlight' ? ' ' + $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$highlightSelectionBorder : ''),
        ...otherProps,
        children: [
            allowsDragging && (0, $dx4lB.jsx)((0, $167a69a603174653$export$f6f0c3fe4ec306ea), {
                // @ts-ignore
                isSticky: true,
                focusMode: keyboardNavigationBehavior === 'tab' ? 'child' : undefined,
                allowsArrowNavigation: keyboardNavigationBehavior === 'tab' || undefined,
                className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$dragCellStyle,
                children: ({ isFocusVisibleWithinRow: isFocusVisibleWithinRow })=>!(otherProps.isDisabled && tableVisualOptions.disabledBehavior === 'all') && (0, $dx4lB.jsx)((0, $6750b0b6e12c44b5$export$4c99a519d851f90c), {
                        isFocusVisibleWithin: isFocusVisibleWithinRow
                    })
            }),
            selectionMode !== 'none' && selectionBehavior === 'toggle' && selectionStyle === 'checkbox' && (0, $dx4lB.jsx)($0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea, {
                isSticky: true,
                // @ts-ignore
                className: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$checkboxCellStyle,
                focusMode: keyboardNavigationBehavior === 'tab' ? 'child' : undefined,
                allowsArrowNavigation: keyboardNavigationBehavior === 'tab' || undefined,
                children: (0, $dx4lB.jsx)((0, $cxTG4.Checkbox), {
                    slot: "selection",
                    styles: $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$selectionCheckbox
                })
            }),
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: columns,
                dependencies: [
                    ...dependencies,
                    columns
                ],
                children: children
            })
        ]
    });
});
const $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$FooterContext = (0, $eF4cA.createContext)(false);
const $0a7fba920f0e9b9f$export$1f116082bba1f9a8 = (0, $eF4cA.forwardRef)(function TableFooter(props, ref) {
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)($0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$FooterContext.Provider, {
        value: true,
        children: (0, $dx4lB.jsx)((0, $167a69a603174653$export$1f116082bba1f9a8), {
            ...props,
            ref: domRef
        })
    });
});
function $0a7fba920f0e9b9f$export$801a7cfaf3e363f5(id, state) {
    if (id == null || !state) return false;
    let keyAfter = state.collection.getKeyAfter(id);
    return keyAfter != null && state.selectionManager.isSelected(keyAfter);
}
function $0a7fba920f0e9b9f$export$aebccab86af12e73(id, state) {
    if (id == null || !state) return false;
    let keyBefore = state.collection.getKeyBefore(id);
    return keyBefore != null && state.selectionManager.isSelected(keyBefore);
}
function $0a7fba920f0e9b9f$var$$0fcd5fb617970a1d$var$isFirstItem(id, state) {
    if (id == null || !state) return false;
    return state.collection.getFirstKey() === id;
}


var $208Op = parcelRequire("208Op");
var $aQTiM = parcelRequire("aQTiM");

var $8OJ2z = parcelRequire("8OJ2z");

var $dm5H1 = parcelRequire("dm5H1");

var $i93Vd = parcelRequire("i93Vd");

var $208Op = parcelRequire("208Op");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $c1ibQ = parcelRequire("c1ibQ");

var $hUj7u = parcelRequire("hUj7u");

var $aeKbf = parcelRequire("aeKbf");

var $4l6lZ = parcelRequire("4l6lZ");

var $4skXn = parcelRequire("4skXn");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4836215752023500$export$c083c44d8a07dd35 = (0, $eF4cA.createContext)(null);
const $4836215752023500$var$$c679c2152e03f8bf$var$segmentedControl = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd182';
    rules += ' Ub182';
    rules += ' qb182';
    rules += ' gH182';
    rules += ' ob182';
    rules += ' nb182';
    rules += ' kb182';
    rules += ' jb182';
    if (!width) rules += ' ZJ182';
    return rules;
};
const $4836215752023500$var$$c679c2152e03f8bf$var$controlItem = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let position = false;
    let flexGrow = false;
    let flexBasis = false;
    let flexShrink = false;
    let zIndex = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "_s") flexBasis = true;
        if (p[1] === "_v") flexShrink = true;
        if (p[1] === "_9") zIndex = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    } else {
        if (props.isPressed) rules += ' pt182';
        else if (props.isFocusVisible) rules += ' pt182';
        else if (props.isHovered) rules += ' pt182';
        else rules += ' pv182';
    }
    if (props.isSelected) rules += ' ple182';
    else if (props.isDisabled) rules += ' plc182';
    else rules += ' plb182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _oa182';
    rules += ' Sv182';
    rules += ' SgLWx3bd182';
    rules += ' Rv182';
    rules += ' RgLWx3bd182';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl182';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj182';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf182';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne182';
    } else if (!minWidth) rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' FRuFGYc182';
    rules += ' _Ca182';
    if (!position) rules += ' _Pc182';
    rules += ' _yb182';
    if (props.isJustified) {
        if (!flexGrow) rules += ' _ub182';
    }
    if (props.isJustified) {
        if (!flexBasis) rules += ' _sb182';
    }
    if (!flexShrink) rules += ' _va182';
    rules += ' _7c182';
    rules += ' __ca182';
    rules += ' _4c182';
    rules += ' g9182';
    rules += ' _je182';
    rules += ' -_8sjo0b-t5ZbAob182';
    if (props.isSelected) {
        if (!zIndex) rules += ' _9b182';
    } else if (!zIndex) rules += ' _9c182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    else if (props.size === "XS") rules += ' -F_-Fn182';
    else rules += ' -F_-Fx182';
    return rules;
};
const $4836215752023500$var$$c679c2152e03f8bf$var$slider = function anonymous(props) {
    let rules = " ";
    rules += ' gX182';
    if (props.isDisabled) rules += ' gld182';
    else rules += ' gle182';
    rules += ' Wr182';
    rules += ' _Er182';
    rules += ' Za182';
    rules += ' Fb182';
    rules += ' _qg182';
    rules += ' Yx6BKnd182';
    rules += ' Ydklsgce182';
    rules += ' Xc182';
    rules += ' _2a182';
    rules += ' _Pa182';
    rules += ' _oa182';
    rules += ' _jf182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    if (props.isDisabled) rules += ' iq182';
    else rules += ' in182';
    if (props.isDisabled) rules += ' ilc182';
    else rules += ' ild182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    return rules;
};
const $4836215752023500$var$$c679c2152e03f8bf$var$InternalSegmentedControlContext = (0, $eF4cA.createContext)({});
const $4836215752023500$export$668709c620d0b8e2 = (0, $eF4cA.forwardRef)(function SegmentedControl(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $4836215752023500$export$c083c44d8a07dd35);
    let { defaultSelectedKey: defaultSelectedKey, selectedKey: selectedKey, onSelectionChange: onSelectionChange } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let onChange = (values)=>{
        if (onSelectionChange) {
            let firstKey = values.values().next().value;
            if (firstKey != null) onSelectionChange(firstKey);
        }
    };
    return (0, $dx4lB.jsx)((0, $4l6lZ.ToggleButtonGroup), {
        ...props,
        selectedKeys: selectedKey != null ? [
            selectedKey
        ] : undefined,
        defaultSelectedKeys: defaultSelectedKey != null ? [
            defaultSelectedKey
        ] : undefined,
        disallowEmptySelection: true,
        ref: domRef,
        orientation: "horizontal",
        style: props.UNSAFE_style,
        onSelectionChange: onChange,
        className: (props.UNSAFE_className || '') + $4836215752023500$var$$c679c2152e03f8bf$var$segmentedControl(null, props.styles),
        "aria-label": props['aria-label'],
        children: (0, $dx4lB.jsx)($4836215752023500$var$$c679c2152e03f8bf$var$DefaultSelectionTracker, {
            defaultValue: defaultSelectedKey,
            value: selectedKey,
            isJustified: props.isJustified,
            children: props.children
        })
    });
});
function $4836215752023500$var$$c679c2152e03f8bf$var$DefaultSelectionTracker(props) {
    let state = (0, $eF4cA.useContext)((0, $4l6lZ.ToggleGroupStateContext));
    let isRegistered = (0, $eF4cA.useRef)(!(props.defaultValue == null && props.value == null));
    // default select the first available item
    let register = (0, $eF4cA.useCallback)((value)=>{
        // oxlint-disable-next-line react/react-compiler
        if (state && !isRegistered.current) {
            isRegistered.current = true;
            state.toggleKey(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                $4836215752023500$var$$c679c2152e03f8bf$var$InternalSegmentedControlContext,
                {
                    register: register,
                    isJustified: props.isJustified
                }
            ]
        ],
        children: props.children
    });
}
const $4836215752023500$export$4fc12f2742e8cf3f = (0, $eF4cA.forwardRef)(function SegmentedControlItem(props, ref) {
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let divRef = (0, $eF4cA.useRef)(null);
    let { register: register, isJustified: isJustified } = (0, $eF4cA.useContext)($4836215752023500$var$$c679c2152e03f8bf$var$InternalSegmentedControlContext);
    (0, $4skXn.useLayoutEffect)(()=>{
        register?.(props.id);
    }, [
        register,
        props.id
    ]);
    return (0, $dx4lB.jsx)((0, $aeKbf.ToggleButton), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + $4836215752023500$var$$c679c2152e03f8bf$var$controlItem({
                ...renderProps,
                isJustified: isJustified
            }, props.styles),
        children: ({ isPressed: isPressed, isDisabled: isDisabled })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $hUj7u.SelectionIndicator), {
                        className: $4836215752023500$var$$c679c2152e03f8bf$var$slider({
                            isDisabled: isDisabled
                        })
                    }),
                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $dm5H1.IconContext),
                                {
                                    render: (0, $8OJ2z.centerBaseline)({
                                        slot: 'icon',
                                        styles: " _Ja182 _va182"
                                    })
                                }
                            ],
                            [
                                (0, $c1ibQ.TextContext),
                                {
                                    slots: {
                                        [(0, $fDYaM.DEFAULT_SLOT)]: {}
                                    }
                                }
                            ],
                            [
                                (0, $208Op.TextContext),
                                {
                                    styles: " _Jb182 _Nc182 Pc182 _Yb182 _7c182"
                                }
                            ]
                        ],
                        children: (0, $dx4lB.jsx)("div", {
                            ref: divRef,
                            style: (0, $i93Vd.pressScale)(divRef)({
                                isPressed: isPressed
                            }),
                            className: " sd182 Uc182 Usd182 qc182 qsd182 Yd182 Xb182 _2b182 eb182 Na182",
                            children: typeof props.children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: props.children
                            }) : props.children
                        })
                    })
                ]
            })
    });
});


var $91SAk = parcelRequire("91SAk");
var $j8RRT = parcelRequire("j8RRT");
var $2RdeM = parcelRequire("2RdeM");

var $fmJ8d = parcelRequire("fmJ8d");

var $VXM1R = parcelRequire("VXM1R");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $aQTiM = parcelRequire("aQTiM");

var $5IZkx = parcelRequire("5IZkx");

var $j2JDe = parcelRequire("j2JDe");

var $fmJ8d = parcelRequire("fmJ8d");

var $VXM1R = parcelRequire("VXM1R");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $g0I9D = parcelRequire("g0I9D");

var $5IZkx = parcelRequire("5IZkx");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $4UbTp = parcelRequire("4UbTp");
var $88lL9 = parcelRequire("88lL9");
var $bsn7e = parcelRequire("bsn7e");
var $7Vvqh = parcelRequire("7Vvqh");
var $8g9SZ = parcelRequire("8g9SZ");
var $208Op = parcelRequire("208Op");
var $8wD3p = parcelRequire("8wD3p");
var $fZShI = parcelRequire("fZShI");
var $91SAk = parcelRequire("91SAk");
var $j8RRT = parcelRequire("j8RRT");
var $hSW0F = parcelRequire("hSW0F");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $fa92467499c79969$var$$7c1e5177198cc89d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M13.125 9.513c-1.205 0-2.343-.512-3.524-1.287-2.167-1.423-4.273-1.278-6.088.42-.305.282-.778.266-1.06-.036-.284-.302-.267-.777.034-1.06 2.346-2.194 5.164-2.4 7.938-.578 2.082 1.368 3.592 1.626 6.054-.756.298-.287.773-.28 1.06.017s.28.773-.018 1.061c-1.646 1.592-3.062 2.219-4.396 2.219M13.125 14.262c-1.205 0-2.343-.512-3.524-1.287-2.164-1.423-4.27-1.28-6.09.42-.302.282-.776.267-1.059-.037-.283-.302-.266-.776.036-1.06 2.346-2.193 5.165-2.398 7.937-.577 2.082 1.367 3.592 1.627 6.054-.756.298-.287.773-.28 1.06.017s.28.773-.018 1.061c-1.646 1.592-3.062 2.219-4.396 2.219"
        })
    });
const $fa92467499c79969$var$$7c1e5177198cc89d$var$ForwardRef = (0, $eF4cA.forwardRef)($fa92467499c79969$var$$7c1e5177198cc89d$var$SvgComponent);
var $fa92467499c79969$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($fa92467499c79969$var$$7c1e5177198cc89d$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $950c2e77523108c3$var$$c3aeb71f8850a9b9$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m18.62 12.904-1.915-8.588c-.26-1.275-1.392-2.2-2.695-2.2-1.517 0-2.75 1.233-2.75 2.75v.51c-.377-.194-.798-.314-1.25-.314s-.874.12-1.25.314v-.51c0-1.517-1.234-2.75-2.75-2.75-1.303 0-2.437.925-2.693 2.186L1.4 12.904c-.082.309-.14.627-.14.961 0 2.068 1.682 3.75 3.75 3.75 2.066 0 3.749-1.681 3.75-3.748v-2.002c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25v2.002c0 1.001.39 1.942 1.097 2.65.708.709 1.65 1.098 2.652 1.098 2.067 0 3.75-1.681 3.75-3.75 0-.334-.057-.652-.14-.961m-4.61-9.289c.592 0 1.107.421 1.228 1.015l1.307 5.822c-.47-.212-.987-.337-1.535-.337-.848 0-1.622.293-2.25.77v-6.02c0-.69.56-1.25 1.25-1.25m-9.226 1c.117-.579.633-1 1.226-1 .69 0 1.25.56 1.25 1.25v6.02c-.629-.476-1.403-.77-2.25-.77-.549 0-1.066.125-1.536.338zm.226 11.5c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25 2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25m5-7c-.453 0-.874.12-1.25.315V7.812c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25V9.43c-.377-.195-.798-.315-1.25-.315m4.999 7c-.6 0-1.166-.234-1.591-.659s-.658-.99-.658-1.59c0-1.241 1.01-2.25 2.25-2.25s2.25 1.009 2.25 2.25c-.001 1.24-1.011 2.25-2.251 2.25"
        })
    });
const $950c2e77523108c3$var$$c3aeb71f8850a9b9$var$ForwardRef = (0, $eF4cA.forwardRef)($950c2e77523108c3$var$$c3aeb71f8850a9b9$var$SvgComponent);
var $950c2e77523108c3$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($950c2e77523108c3$var$$c3aeb71f8850a9b9$var$ForwardRef);



var $2t0pV = parcelRequire("2t0pV");

var $HZG6L = parcelRequire("HZG6L");

var $edFAP = parcelRequire("edFAP");

var $fmJ8d = parcelRequire("fmJ8d");

var $VXM1R = parcelRequire("VXM1R");

var $D7J7L = parcelRequire("D7J7L");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $j2JDe = parcelRequire("j2JDe");
var $bEes0 = parcelRequire("bEes0");

var $lhKAD = parcelRequire("lhKAD");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $geNzB = parcelRequire("geNzB");
var $8g9SZ = parcelRequire("8g9SZ");

var $i8elj = parcelRequire("i8elj");

var $klXmP = parcelRequire("klXmP");

var $fmJ8d = parcelRequire("fmJ8d");

var $9lDhw = parcelRequire("9lDhw");

const $c0230a5a4feb1ed2$export$e6394af6de0c911f = (props)=>{
    const ref = (0, $eF4cA.useRef)(null);
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    const { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        onPress: props?.onPress ?? (()=>{})
    });
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const isDark = colorScheme === "dark";
    const isSelected = props?.item?.visual === props?.idx;
    // Get the visual URL
    const visualUrl = (0, $782edebb76e7c4bc$export$2427d38ef09c0c42)(props?.visual);
    (0, $eF4cA.useEffect)(()=>{
        if (isSelected && ref.current) ref.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        ref: ref,
        ...(0, $lhKAD.mergeProps)(hoverProps, pressProps),
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _oa182';
            rules += ' _ua182';
            rules += ' _va182';
            rules += ' _sc182';
            rules += ' sd182';
            rules += ' __Pa182';
            rules += ' __Qa182';
            rules += ' Th182';
            rules += ' Qh182';
            rules += ' Sh182';
            rules += ' Rh182';
            rules += ' Yg182';
            rules += ' Xb182';
            rules += ' _2b182';
            rules += ' _8d182';
            if (props.isPressed) rules += ' _ZudDOde182';
            else rules += ' _Zh3TDrc182';
            return rules;
        }({
            isPressed: isPressed
        }),
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: function anonymous(props) {
                let rules = " ";
                rules += ' _Pc182';
                rules += ' Za182';
                rules += ' Fb182';
                rules += ' oc182';
                rules += ' nc182';
                rules += ' kc182';
                rules += ' jc182';
                rules += ' _Nc182';
                rules += ' Pc182';
                if (props.isSelected) rules += ' _nLeasBb182';
                else if (props.isHovered) rules += ' _n4zCLMe182';
                else rules += ' _nd182';
                if (props.isSelected) rules += ' O95Jo1182';
                else if (props.isHovered) rules += ' O7jYTrb182';
                else rules += ' Oj182';
                rules += ' _Kb182';
                rules += ' _Lf182';
                rules += ' _Mc182';
                rules += ' Ya182';
                rules += ' Xb182';
                rules += ' _2b182';
                return rules;
            }({
                isSelected: isSelected,
                isHovered: isHovered
            }),
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                    src: visualUrl,
                    alt: props?.visual?.prompt ?? props?.item?.title,
                    styles: " Za182 Fb182 _Hb182 _Pa182 Wy182 _ly182 _Ay182 _zy182 _9a182"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $geNzB.Badge), {
                    variant: "neutral",
                    fillStyle: "subtle",
                    size: "S",
                    styles: " _Pa182 _lI182 _AI182",
                    children: [
                        props.idx + 1,
                        "/",
                        props?.item?.visuals?.length
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                    styles: " _Pa182 WJ182 _zI182",
                    staticColor: isDark ? "black" : "white",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            "aria-label": "Delete visual",
                            onPress: props?.onDelete,
                            isQuiet: true,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {})
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            "aria-label": "Download visual",
                            onPress: ()=>(0, $9lDhw.downloadImage)(props.visual, props?.visual?.prompt?.trim()?.replace(/[^\w\d]+/g, "+")),
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {})
                        })
                    ]
                })
            ]
        })
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $4UbTp = parcelRequire("4UbTp");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");
var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");

var $cg9Gh = parcelRequire("cg9Gh");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a905dcfb69b51708$export$762f73dccccd255d(options) {
    let { initialItems: initialItems = [], initialSelectedKeys: initialSelectedKeys, getKey: getKey = (item)=>item.id ?? item.key, filter: filter, initialFilterText: initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, $eF4cA.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, $eF4cA.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...$a905dcfb69b51708$export$79c0c687a5963b0a({
            getKey: getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function $a905dcfb69b51708$export$79c0c687a5963b0a(opts, dispatch) {
    let { cursor: cursor, getKey: getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys: selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText: filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>$a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return $a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return $a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>$a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>$a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items: items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items: items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return $a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return $a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let updatedValue;
                if (typeof newValue === 'function') updatedValue = newValue(state.items[index]);
                else updatedValue = newValue;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        updatedValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function $a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function $a905dcfb69b51708$var$$232f8dea1b0a4f2f$var$move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from: from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5a57d6761ce6fb25$var$$c73d3f3d5ec90946$var$reducer(data, action) {
    let selectedKeys;
    switch(data.state){
        case 'idle':
        case 'error':
            switch(action.type){
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: action.abortController
                    };
                case 'update':
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                case 'success':
                case 'error':
                    return data;
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loading':
        case 'sorting':
        case 'filtering':
            switch(action.type){
                case 'success':
                    // Ignore if there is a newer abortcontroller in state.
                    // This means that multiple requests were going at once.
                    // We want to take only the latest result.
                    if (action.abortController !== data.abortController) return data;
                    selectedKeys = action.selectedKeys ?? data.selectedKeys;
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: 'idle',
                        items: [
                            ...action.items ?? []
                        ],
                        selectedKeys: selectedKeys === 'all' ? 'all' : new Set(selectedKeys),
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error,
                        abortController: undefined
                    };
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    // We're already loading, and another load was triggered at the same time.
                    // We need to abort the previous load and start a new one.
                    data.abortController?.abort('aborting current load and starting new one');
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loadingMore':
            switch(action.type){
                case 'success':
                    selectedKeys = data.selectedKeys === 'all' || action.selectedKeys === 'all' ? 'all' : new Set([
                        ...data.selectedKeys,
                        ...action.selectedKeys ?? []
                    ]);
                    // Append the new items
                    return {
                        ...data,
                        state: 'idle',
                        items: [
                            ...data.items,
                            ...action.items ?? []
                        ],
                        selectedKeys: selectedKeys,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error
                    };
                case 'loading':
                case 'sorting':
                case 'filtering':
                    // We're already loading more, and another load was triggered at the same time.
                    // We need to abort the previous load more and start a new one.
                    data.abortController?.abort();
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'loadingMore':
                    // If already loading more and another loading more is triggered, abort the new load more since
                    // it is a duplicate request since the cursor hasn't been updated.
                    // Do not overwrite the data.abortController
                    action.abortController?.abort();
                    return data;
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        default:
            throw new Error(`Invalid state "${data.state}"`);
    }
}
function $5a57d6761ce6fb25$export$bc3384a35de93d66(options) {
    const { load: load, sort: sort, initialSelectedKeys: initialSelectedKeys, initialSortDescriptor: initialSortDescriptor, getKey: getKey = (item)=>item.id || item.key, initialFilterText: initialFilterText = '' } = options;
    let [data, dispatch] = (0, $eF4cA.useReducer)($5a57d6761ce6fb25$var$$c73d3f3d5ec90946$var$reducer, {
        state: 'idle',
        error: undefined,
        items: [],
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys),
        sortDescriptor: initialSortDescriptor,
        filterText: initialFilterText
    });
    const dispatchFetch = async (action, fn)=>{
        let abortController = new AbortController();
        try {
            dispatch({
                ...action,
                abortController: abortController
            });
            let previousFilterText = action.filterText ?? data.filterText;
            let response = await fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === 'loadingMore' ? data.cursor : undefined,
                filterText: previousFilterText,
                loadingState: data.state
            });
            let filterText = response.filterText ?? previousFilterText;
            dispatch({
                type: 'success',
                ...response,
                abortController: abortController
            });
            // Fetch a new filtered list if filterText is updated via `load` response func rather than list.setFilterText
            // Only do this if not aborted (e.g. user triggers another filter action before load completes)
            if (filterText && filterText !== previousFilterText && !abortController.signal.aborted) dispatchFetch({
                type: 'filtering',
                filterText: filterText
            }, load);
        } catch (e) {
            dispatch({
                type: 'error',
                error: e,
                abortController: abortController
            });
        }
    };
    let didDispatchInitialFetch = (0, $eF4cA.useRef)(false);
    (0, $eF4cA.useEffect)(()=>{
        if (!didDispatchInitialFetch.current) {
            dispatchFetch({
                type: 'loading'
            }, load);
            didDispatchInitialFetch.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        items: data.items,
        selectedKeys: data.selectedKeys,
        sortDescriptor: data.sortDescriptor,
        isLoading: data.state === 'loading' || data.state === 'loadingMore' || data.state === 'sorting' || data.state === 'filtering',
        loadingState: data.state,
        error: data.error,
        filterText: data.filterText,
        getItem (key) {
            return data.items.find((item)=>getKey(item) === key);
        },
        reload () {
            dispatchFetch({
                type: 'loading'
            }, load);
        },
        loadMore () {
            // Ignore if already loading more or if performing server side filtering.
            if (data.state === 'loading' || data.state === 'loadingMore' || data.state === 'filtering' || data.cursor == null) return;
            dispatchFetch({
                type: 'loadingMore'
            }, load);
        },
        sort (sortDescriptor) {
            dispatchFetch({
                type: 'sorting',
                sortDescriptor: sortDescriptor
            }, sort || load);
        },
        ...(0, $a905dcfb69b51708$export$79c0c687a5963b0a)({
            ...options,
            getKey: getKey,
            cursor: data.cursor
        }, (fn)=>{
            dispatch({
                type: 'update',
                updater: fn
            });
        }),
        setFilterText (filterText) {
            dispatchFetch({
                type: 'filtering',
                filterText: filterText
            }, load);
        }
    };
}



var $dYPl9 = parcelRequire("dYPl9");

var $8Ogg5 = parcelRequire("8Ogg5");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $00e3c53c0a1afb38$var$$b4d39bb752c66970$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M43 36.74c0-7.18 5.82-13 13-13h23.272c3.448 0 6.754 1.37 9.192 3.808l24.728 24.728C115.63 54.714 117 58.02 117 61.468V96.74c0 7.18-5.82 13-13 13H56c-7.18 0-13-5.82-13-13zm13-5c-2.761 0-5 2.239-5 5v60c0 2.762 2.239 5 5 5h48c2.761 0 5-2.238 5-5V61.468c0-1.326-.527-2.598-1.464-3.535L82.808 33.205c-.938-.938-2.21-1.465-3.536-1.465zm5.704 41.827c1.375-1.729 3.891-2.016 5.62-.64l7.692 6.117.057-25.645c.005-2.21 1.8-3.996 4.009-3.992s3.996 1.8 3.99 4.01l-.057 25.693 7.64-6.165c1.719-1.388 4.237-1.12 5.625.6 1.387 1.719 1.118 4.237-.6 5.625L81.615 90.52c-1.457 1.176-3.536 1.184-5.002.018l-14.27-11.35c-1.729-1.376-2.016-3.892-.64-5.62M28 76.74c-2.21 0-4 1.791-4 4v3.375c0 2.21-1.79 4-4 4s-4-1.79-4-4V80.74c0-6.627 5.373-12 12-12h4.5c2.21 0 4 1.791 4 4s-1.79 4-4 4zm95.5-4c0-2.209 1.791-4 4-4h4.5c6.627 0 12 5.373 12 12v3.375c0 2.21-1.791 4-4 4s-4-1.79-4-4V80.74c0-2.209-1.791-4-4-4h-4.5c-2.209 0-4-1.79-4-4M20 93.865c2.21 0 4 1.791 4 4v8.75c0 2.209-1.79 4-4 4s-4-1.791-4-4v-8.75c0-2.209 1.79-4 4-4m120 0c2.209 0 4 1.791 4 4v8.75c0 2.209-1.791 4-4 4s-4-1.791-4-4v-8.75c0-2.209 1.791-4 4-4m-120 22.5c2.21 0 4 1.791 4 4v3.375c0 2.209 1.79 4 4 4h4.5c2.21 0 4 1.791 4 4s-1.79 4-4 4H28c-6.627 0-12-5.372-12-12v-3.375c0-2.209 1.79-4 4-4m120 0c2.209 0 4 1.791 4 4v3.375c0 6.628-5.373 12-12 12h-4.5c-2.209 0-4-1.791-4-4s1.791-4 4-4h4.5c2.209 0 4-1.791 4-4v-3.375c0-2.209 1.791-4 4-4m-37 11.375c-2.209 0-4 1.791-4 4s1.791 4 4 4h11c2.209 0 4-1.791 4-4s-1.791-4-4-4zm-32.5 4c0-2.209 1.79-4 4-4h11c2.21 0 4 1.791 4 4s-1.79 4-4 4h-11c-2.21 0-4-1.791-4-4m-24.5-4c-2.21 0-4 1.791-4 4s1.79 4 4 4h11c2.21 0 4-1.791 4-4s-1.79-4-4-4z"
        })
    });
const $00e3c53c0a1afb38$var$$b4d39bb752c66970$var$ForwardRef = (0, $eF4cA.forwardRef)($00e3c53c0a1afb38$var$$b4d39bb752c66970$var$SvgComponent);
var $00e3c53c0a1afb38$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($00e3c53c0a1afb38$var$$b4d39bb752c66970$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a1b45d6c83903923$var$$c5918639f2436231$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M33.455 15.74c-4.107 0-7.455 3.313-7.455 7.423v36.154c0 4.11 3.348 7.423 7.455 7.423h29.09c4.107 0 7.455-3.312 7.455-7.423V38.063c0-1.972-.788-3.861-2.187-5.253l-14.987-14.9c-1.399-1.39-3.294-2.17-5.267-2.17zM30 23.163c0-1.88 1.536-3.423 3.455-3.423h14.104c.92 0 1.8.364 2.447 1.007l14.986 14.9C65.64 36.29 66 37.16 66 38.063v21.254c0 1.88-1.536 3.423-3.455 3.423h-29.09c-1.92 0-3.455-1.543-3.455-3.423zm9.766 22.029c-.855-.7-2.115-.573-2.814.282-.7.856-.573 2.116.282 2.815l8.219 6.719c.366.446.92.73 1.543.732h.035c.464.007.93-.146 1.308-.46l8.438-7c.85-.706.968-1.967.262-2.817-.705-.85-1.966-.967-2.816-.262l-5.214 4.325.035-15.781c.002-1.105-.891-2.002-1.996-2.005-1.105-.002-2.002.891-2.004 1.996l-.035 15.743zM27 75.74c-1.105 0-2 .896-2 2s.895 2 2 2h7.5c1.105 0 2-.895 2-2s-.895-2-2-2zm-15-9.5c-1.105 0-2-.895-2-2v-7.5c0-1.104.895-2 2-2s2 .896 2 2v7.5c0 1.105-.895 2-2 2m70-1.5c0 1.105.895 2 2 2s2-.895 2-2v-7.5c0-1.104-.895-2-2-2s-2 .896-2 2zm-61-22c0-1.104-.895-2-2-2h-3.5c-3.038 0-5.5 2.463-5.5 5.5v3.5c0 1.105.895 2 2 2s2-.895 2-2v-3.5c0-.828.672-1.5 1.5-1.5H19c1.105 0 2-.895 2-2m56-2c-1.105 0-2 .896-2 2s.895 2 2 2h3.5c.828 0 1.5.672 1.5 1.5v3.5c0 1.105.895 2 2 2s2-.895 2-2v-3.5c0-3.037-2.462-5.5-5.5-5.5zm-65 28c-1.105 0-2 .896-2 2v3.5c0 3.038 2.462 5.5 5.5 5.5H19c1.105 0 2-.895 2-2s-.895-2-2-2h-3.5c-.828 0-1.5-.671-1.5-1.5v-3.5c0-1.104-.895-2-2-2m74 2c0-1.104-.895-2-2-2s-2 .896-2 2v3.5c0 .829-.672 1.5-1.5 1.5H77c-1.105 0-2 .896-2 2s.895 2 2 2h3.5c3.038 0 5.5-2.462 5.5-5.5zm-44 7c0-1.104.895-2 2-2h7.5c1.105 0 2 .896 2 2s-.895 2-2 2H44c-1.105 0-2-.895-2-2m19-2c-1.105 0-2 .896-2 2s.895 2 2 2h7.5c1.105 0 2-.895 2-2s-.895-2-2-2z"
        })
    });
const $a1b45d6c83903923$var$$c5918639f2436231$var$ForwardRef = (0, $eF4cA.forwardRef)($a1b45d6c83903923$var$$c5918639f2436231$var$SvgComponent);
var $a1b45d6c83903923$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($a1b45d6c83903923$var$$c5918639f2436231$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $65344d5c82295768$var$$cb1c1e42c7e7ba0b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 49,
        viewBox: "0 0 48 49",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M16.727 7.49c-2.19 0-3.977 1.767-3.977 3.962v18.077c0 2.194 1.787 3.961 3.977 3.961h14.546c2.19 0 3.977-1.767 3.977-3.961V18.902c0-1.053-.42-2.062-1.167-2.804l-7.494-7.45c-.746-.742-1.757-1.158-2.81-1.158zm-1.477 3.962c0-.8.655-1.462 1.477-1.462h7.052c.395 0 .771.156 1.048.43l7.493 7.45c.276.276.43.647.43 1.032v10.627c0 .8-.655 1.461-1.477 1.461H16.727c-.822 0-1.477-.66-1.477-1.461zm4.791 10.82c-.534-.436-1.322-.357-1.759.177s-.358 1.322.177 1.759l4.091 3.345c.229.267.568.436.947.437h.019c.288.004.578-.092.813-.288l4.22-3.5c.53-.44.604-1.229.163-1.76s-1.229-.605-1.76-.164L24.756 24.1l.016-7.357c.001-.69-.557-1.251-1.247-1.253-.69-.001-1.252.557-1.253 1.248l-.016 7.345zM13.5 37.49c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25zM6 32.99c-.69 0-1.25-.56-1.25-1.25v-3c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25m34.75-1.25c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25zm-30-10.5c0-.69-.56-1.25-1.25-1.25H7.75c-1.657 0-3 1.343-3 3v1.75c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-1.75c0-.276.224-.5.5-.5H9.5c.69 0 1.25-.56 1.25-1.25m27.75-1.25c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h1.75c.276 0 .5.224.5.5v1.75c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-1.75c0-1.657-1.343-3-3-3zM6 33.99c-.69 0-1.25.56-1.25 1.25v1.75c0 1.657 1.343 3 3 3H9.5c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25H7.75c-.276 0-.5-.224-.5-.5v-1.75c0-.69-.56-1.25-1.25-1.25m37.25 1.25c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v1.75c0 .276-.224.5-.5.5H38.5c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h1.75c1.657 0 3-1.343 3-3zm-22.5 3.5c0-.69.56-1.25 1.25-1.25h3.75c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25H22c-.69 0-1.25-.56-1.25-1.25m9.75-1.25c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25z"
        })
    });
const $65344d5c82295768$var$$cb1c1e42c7e7ba0b$var$ForwardRef = (0, $eF4cA.forwardRef)($65344d5c82295768$var$$cb1c1e42c7e7ba0b$var$SvgComponent);
var $65344d5c82295768$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($65344d5c82295768$var$$cb1c1e42c7e7ba0b$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c5c5c929122049b7$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $00e3c53c0a1afb38$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $65344d5c82295768$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $a1b45d6c83903923$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $c674c73a1c43d003$export$ee04c4cde48a5e2 = ({ libraryId: libraryId, images: images, onPrimaryAction: onPrimaryAction })=>{
    const [imageReference, setImageReference] = (0, $eF4cA.useState)(null);
    const [hasMoreData, setHasMoreData] = (0, $eF4cA.useState)(false);
    const listData = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        getKey: (item)=>item.id,
        async load ({ cursor: cursor, signal: signal }) {
            try {
                if (!libraryId && images) {
                    // Fetch all image URLs in parallel
                    const itemsWithUrls = await Promise.all(images.map(async (image)=>{
                        let url;
                        try {
                            url = await (0, $8Ogg5.getVisualUrl)({
                                id: image.avatarId,
                                libraryId: image.libraryId,
                                url: image.url
                            });
                        } catch (error) {
                            console.warn(`Failed to get image URL for ${image.id}:`, error);
                            url = "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png";
                        }
                        return {
                            name: image.id,
                            libraryId: image.libraryId,
                            id: image.avatarId,
                            url: url
                        };
                    }));
                    return {
                        items: itemsWithUrls,
                        selectedKeys: new Set(imageReference ? [
                            imageReference?.id
                        ] : [])
                    };
                }
                // Parse cursor to get start, default to 0 for initial load
                const start = cursor ? parseInt(cursor, 10) : 0;
                const limit = 10; // Smaller page size for better UX
                // { description, id, name, tags }
                const data = await (0, $dYPl9.getElements)({
                    libraryId: libraryId,
                    limit: limit,
                    start: start
                });
                // Check if request was aborted
                if (signal?.aborted) throw new Error("Request was aborted");
                // Fetch all element URLs in parallel
                const itemsWithUrls = await Promise.all((data?.elements || []).map(async (element)=>{
                    let url;
                    try {
                        url = await (0, $8Ogg5.getVisualUrl)({
                            id: element?.thumbnail?.componentId,
                            libraryId: libraryId,
                            url: element?.thumbnail?.url
                        });
                    } catch (error) {
                        console.warn(`Failed to get image URL for ${element.name}:`, error);
                        url = "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png";
                    }
                    return {
                        name: element.name,
                        description: element?.details?.description,
                        libraryId: libraryId,
                        id: element?.thumbnail?.componentId,
                        url: url
                    };
                }));
                // Calculate next cursor (offset for next page)
                const nextOffset = start + limit;
                const hasMoreData = data?._links?.next?.href;
                setHasMoreData(hasMoreData);
                return {
                    items: itemsWithUrls,
                    cursor: hasMoreData ? nextOffset.toString() : undefined,
                    selectedKeys: new Set(imageReference ? [
                        imageReference?.id
                    ] : [])
                };
            } catch (error) {
                console.error("Failed to load images:", error);
                if (error.message === "Request was aborted") throw error;
                return {
                    items: [],
                    selectedKeys: new Set()
                };
            }
        }
    });
    const handleSelectionChange = (selectedKeys)=>{
        listData.setSelectedKeys(selectedKeys);
        setImageReference(listData.getItem(selectedKeys.currentKey) ?? null);
    };
    const handleSave = (0, $eF4cA.useCallback)(()=>{
        onPrimaryAction(imageReference);
    }, [
        imageReference
    ]);
    const renderLoadMoreSkeleton = ()=>{
        if (listData.isLoading) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
            children: new Array(9).fill(null).map((_, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                    isLoading: true,
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        alt: "Loading more images",
                        className: " oc182 nc182 kc182 jc182 _Nc182 Pc182 Oj182 _Kb182 _Lf182 _Mc182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                            styles: " Za182 Fb182 fbvNfn182 _Hb182"
                        })
                    })
                }, `loadmore-${index}`))
        });
        return null;
    };
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        isDismissable: true,
        styles: " Lc182 Za182 ZnvuBnEc182",
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " Za182 Fb182 se182 CiIfZo182 E7ABCf182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Select image"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " Za182 Fb182 sd182 _ta182 Ul182 ql182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cg9Gh.ListBox), {
                                    "aria-label": "Select generated images visual style",
                                    items: listData.items,
                                    selectionMode: "single",
                                    selectedKeys: listData.selectedKeys,
                                    onSelectionChange: handleSelectionChange,
                                    layout: "grid",
                                    className: " ZJ182 Fb182 se182 DpwD1Pb182 Ul182 ql182 La182",
                                    children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxItem), {
                                            id: item.id,
                                            textValue: item.name,
                                            className: function anonymous(props) {
                                                let rules = " ";
                                                rules += ' oc182';
                                                rules += ' nc182';
                                                rules += ' kc182';
                                                rules += ' jc182';
                                                rules += ' _Nc182';
                                                rules += ' Pc182';
                                                if (props.isSelected) rules += ' O95Jo1182';
                                                else if (props.isFocused) rules += ' OaeNnJ182';
                                                else if (props.isHovered) rules += ' OcIrCFb182';
                                                else rules += ' Oj182';
                                                rules += ' _Kb182';
                                                rules += ' _Lf182';
                                                rules += ' _Mc182';
                                                rules += ' Yg182';
                                                rules += ' Xb182';
                                                rules += ' _2b182';
                                                rules += ' _8d182';
                                                if (props.isPressed) rules += ' _Z6Lx70c182';
                                                else rules += ' _Zh3TDrc182';
                                                return rules;
                                            },
                                            children: item.name !== "NEW" ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                src: item.url,
                                                alt: item.name,
                                                styles: " Za182 Fb182 fbvNfn182 _Hb182"
                                            }) : /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " Za182 Fb182 sd182 _ta182 eb182 _Ca182 Ug182 qg182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c5c5c929122049b7$export$2e2bcd8739ae039), {
                                                        styles: " ZF182 Fz182"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _Wa182",
                                                        children: "Drag and drop new image"
                                                    })
                                                ]
                                            })
                                        })
                                }),
                                listData.isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " se182 DpwD1Pb182 Ul182 ql182 ZJ182 La182",
                                    children: renderLoadMoreSkeleton()
                                }),
                                hasMoreData && !listData.isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " sd182 _Ca182 Tt182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                        variant: "secondary",
                                        onPress: ()=>{
                                            listData.loadMore();
                                        },
                                        isDisabled: listData.isLoading,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Load More Images"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                        styles: " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                        styles: " zmlKpq182 ymlKpq182 BmlKpq182 AmlKpq182 __Ac182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "genai",
                            isDisabled: listData.isLoading,
                            onPress: ()=>{
                                handleSave();
                                close();
                            },
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Save"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};


const $2e7a091bd5ddc46c$var$detailStyles = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182 Jy182";
const $2e7a091bd5ddc46c$export$a51ca80b6e1c45db = ({ storyId: storyId, item: item })=>{
    const [prompt, setPrompt] = (0, $eF4cA.useState)(item?.visualPrompt ?? "");
    const [selectedPersonaKeys, setSelectedPersonaKeys] = (0, $eF4cA.useState)(new Set(item?.personas ?? []));
    const [isBrowseDialogOpen, setIsBrowseDialogOpen] = (0, $eF4cA.useState)(false);
    const [title, setTitle] = (0, $eF4cA.useState)(item?.title ?? "");
    const [text, setText] = (0, $eF4cA.useState)(item?.text ?? "");
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const updateStory = (0, $VXM1R.useUpdateStory)(storyId);
    const selectedPersonas = (0, $eF4cA.useMemo)(()=>[
            ...selectedPersonaKeys
        ].map((key)=>story?.personas?.find((p)=>p.id === key)), [
        story?.personas,
        selectedPersonaKeys
    ]);
    (0, $eF4cA.useEffect)(()=>{
        setPrompt(item?.visualPrompt ?? prompt);
    }, [
        item?.visualPrompt
    ]);
    const isPromptPersonasPending = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isPromptPersonasPending);
    const isPromptVisualsPending = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isPromptVisualsPending);
    const isGenerating = isPromptPersonasPending || isPromptVisualsPending;
    const isRegenerateVisualPending = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isRegenerateVisualPending);
    const regenerateVisual = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.regenerateVisual);
    const generateSimilarVisual = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.generateSimilarVisual);
    const regenerateVisualContext = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.regenerateVisualContext);
    const updateStoryScriptItem = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.updateStoryScriptItem);
    const updateStoryVisualImage = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.updateStoryVisualImage);
    const email = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.ims?.profile?.email);
    const browseVisuals = (story)=>{
        console.log("browseVisuals", story);
        setIsBrowseDialogOpen(true);
    };
    const handleImageConfirm = (selectedImage)=>{
        updateStory.mutate({
            script: story.script.map((scriptItem)=>{
                return scriptItem.id === item.id ? {
                    ...scriptItem,
                    visualPrompt: selectedImage.description ?? "test",
                    visuals: scriptItem.visuals?.map((visual, idx)=>idx === 0 ? {
                            ...visual,
                            type: "cc-library",
                            libraryId: selectedImage.libraryId,
                            id: selectedImage.id,
                            visualPrompt: selectedImage.description ?? "test"
                        } : visual) || [
                        {
                            type: "cc-library",
                            libraryId: selectedImage.libraryId,
                            id: selectedImage.id,
                            visualPrompt: selectedImage.description ?? "test"
                        }
                    ]
                } : scriptItem;
            })
        });
        setIsBrowseDialogOpen(false);
    };
    //useStore(store, (state) => state.browseVisuals);
    const handleTextUpdate = (0, $eF4cA.useCallback)(()=>{
        (0, $fmJ8d.store).getState().updateStoryScriptItem(storyId, item.id, {
            title: title,
            text: text
        });
    }, [
        storyId,
        item.id,
        title,
        text
    ]);
    const visualsListRef = (0, $eF4cA.useRef)(null);
    const [isUploading, startUploading] = (0, $eF4cA.useTransition)();
    const handleImageSelect = (0, $eF4cA.useCallback)((files)=>{
        if (files.length > 0) startUploading(async ()=>{
            const [file] = files;
            const filePath = `${email.split("@")[0]}/stories/${storyId}/visuals/${file.name}`;
            const response = await (0, $D7J7L.uploadFileByBlob)(filePath, file);
            if (response?.presignURL) {
                (0, $fmJ8d.store).setState((0, $g0I9D.produce)((state)=>{
                    const storyIndex = state.stories.findIndex((story)=>story.id === storyId);
                    if (storyIndex === -1) throw new Error("Story not found");
                    state.stories[storyIndex].script[item.id].visualUrl = response.presignURL;
                    state.stories[storyIndex].script[item.id].visualSeed = null;
                    state.stories[storyIndex].script[item.id].visuals = state.stories[storyIndex].script[item.id]?.visuals ?? [];
                    state.stories[storyIndex].script[item.id].visuals.push({
                        url: response.presignURL,
                        seed: null,
                        path: filePath,
                        prompt: null
                    });
                    state.stories[storyIndex].script[item.id].visual = state.stories[storyIndex].script[item.id].visuals.length - 1;
                }));
                (0, $fmJ8d.store).getState().saveStory(storyId);
            }
        });
    }, [
        storyId,
        item.id
    ]);
    // useEffect(() => {
    //   if (visualsListRef.current) {
    //     visualsListRef.current.scrollLeft =
    //       visualsListRef.current.scrollWidth - visualsListRef.current.clientWidth;
    //     console.log(visualsListRef.current);
    //   }
    // }, [item?.visuals]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $88lL9.CustomDialog), {
        padding: "none",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 _tnc182 Za182 Fb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        ref: visualsListRef,
                        className: " _ub182 sd182 Ue182 qe182 Ma182 MnLt3Ric182 fIDBNkb182 _Na182 __Rd182 __Ib182",
                        children: [
                            item?.visuals?.map((visual, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $c0230a5a4feb1ed2$export$e6394af6de0c911f), {
                                    visual: visual,
                                    item: item,
                                    idx: idx,
                                    onPress: ()=>{
                                        updateStoryScriptItem(story.id, item.id, {
                                            visual: idx,
                                            visualUrl: visual.url,
                                            visualPrompt: visual.prompt
                                        });
                                    },
                                    onDelete: ()=>{
                                        (0, $fmJ8d.store).getState().updateStoryScriptItem(story.id, item.id, {
                                            visuals: item?.visuals?.toSpliced(idx, 1) ?? []
                                        });
                                    }
                                }, idx)),
                            !item?.visuals?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                                isLoading: true,
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                    src: "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png",
                                    className: " _ua182 _va182 _sc182 sd182"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " Th182 Tnk182 Qh182 Qnk182 Sh182 Snk182 Rh182 Rnk182 sd182 _ta182 _sd182 _snft0rSc182 _va182 Up182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ue182 qe182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        styles: $2e7a091bd5ddc46c$var$detailStyles,
                                        children: "Personas:"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $62173499bdf6ab25$export$5b26ebaf2b105908), {
                                        size: 24,
                                        "aria-label": "Personas",
                                        children: [
                                            ...selectedPersonas
                                        ].map((persona, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2bffda9db2261f28$export$3cf67ed17f3a3c34), {
                                                persona: persona,
                                                isOverBackground: true
                                            }, `${persona?.id}-${idx}`))
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                "aria-label": "Select personas",
                                                isQuiet: true,
                                                isDisabled: isGenerating || isRegenerateVisualPending,
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2t0pV.default), {})
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                                                selectionMode: "multiple",
                                                selectedKeys: selectedPersonaKeys,
                                                onSelectionChange: setSelectedPersonaKeys,
                                                "aria-label": "Select personas",
                                                children: story?.personas?.map?.((persona, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                        id: persona?.id ?? idx,
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2bffda9db2261f28$export$3cf67ed17f3a3c34), {
                                                                persona: persona,
                                                                size: 20,
                                                                isOverBackground: true
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: persona?.name
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Keyboard), {
                                                                children: persona?.role
                                                            })
                                                        ]
                                                    }, idx))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gs182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: item.section
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " Gv182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                            label: "Title",
                                            value: title,
                                            onChange: setTitle,
                                            isDisabled: isGenerating || isRegenerateVisualPending,
                                            size: "S",
                                            onBlur: handleTextUpdate
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 _7e182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                            label: "Text",
                                            value: text,
                                            onChange: setText,
                                            isDisabled: isGenerating || isRegenerateVisualPending,
                                            size: "S",
                                            onBlur: handleTextUpdate
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isQuiet: true,
                                isDisabled: isGenerating || isRegenerateVisualPending,
                                onPress: ()=>regenerateVisualContext(story.id, item.id, {
                                        personas: [
                                            ...selectedPersonaKeys
                                        ]
                                    }),
                                styles: " IM182 Gn182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Re-generate prompt"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                label: "Prompt",
                                value: prompt,
                                isDisabled: isGenerating || isRegenerateVisualPending,
                                onChange: setPrompt
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ue182 qe182",
                                children: [
                                    !!story?.imageReference?.url && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                isQuiet: true,
                                                UNSAFE_className: " Td182 Qd182 Sd182 Rd182",
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                    src: story?.imageReference?.url,
                                                    alt: "Generated visual",
                                                    styles: " ob182 nb182 kb182 jb182 iJWTFLe182 _kc182 hc182 mc182 lc182 _jf182 ZC182 Fx182"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.Tooltip), {
                                                children: [
                                                    "Reference style: ",
                                                    story?.imageReference?.name
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                        styles: " IM182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                                                acceptedFileTypes: "image/*",
                                                onSelect: handleImageSelect,
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                    isQuiet: true,
                                                    isDisabled: isUploading,
                                                    children: !isUploading ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $HZG6L.default), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                        isIndeterminate: true,
                                                        size: "S",
                                                        staticColor: "auto",
                                                        styles: " _dc182 Ib182"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                                        variant: "primary",
                                                        isDisabled: isGenerating || isRegenerateVisualPending || !prompt,
                                                        onPress: ()=>browseVisuals(story),
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $950c2e77523108c3$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Browse"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                                        children: "Pick different image from the library"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                                        variant: "primary",
                                                        isDisabled: isGenerating || isRegenerateVisualPending || !prompt || !item?.visualSeed,
                                                        onPress: ()=>generateSimilarVisual(story.id, item.id, prompt),
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fa92467499c79969$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Similar"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                                        children: "Generate similar image to the current one"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                                        variant: "accent",
                                                        isDisabled: isGenerating || isRegenerateVisualPending || !prompt,
                                                        onPress: ()=>regenerateVisual(story.id, item.id, prompt),
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Generate"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                                        children: "Generate new image based on provided prompt"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        // staticColor="black"
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
                onDismiss: ()=>setIsBrowseDialogOpen(false),
                styles: " _9d2Ky182",
                children: isBrowseDialogOpen && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c674c73a1c43d003$export$ee04c4cde48a5e2), {
                    libraryId: story?.personas[0]?.libraryId,
                    onPrimaryAction: handleImageConfirm
                })
            })
        ]
    });
};



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $8d36ed630f399b1b$var$$d7a647c410c8c086$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M9.03 10.97c-.293-.293-.767-.293-1.06 0L3.5 15.44v-2.433c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4.243c0 .414.336.75.75.75h4.243c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H4.56l4.47-4.47c.292-.293.292-.767 0-1.06M18 2.75v4.243c0 .414-.336.75-.75.75s-.75-.336-.75-.75V4.56l-4.47 4.47c-.146.146-.338.219-.53.219s-.384-.073-.53-.22c-.293-.293-.293-.767 0-1.06l4.47-4.47h-2.433c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.243c.414 0 .75.336.75.75"
        })
    });
const $8d36ed630f399b1b$var$$d7a647c410c8c086$var$ForwardRef = (0, $eF4cA.forwardRef)($8d36ed630f399b1b$var$$d7a647c410c8c086$var$SvgComponent);
var $8d36ed630f399b1b$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($8d36ed630f399b1b$var$$d7a647c410c8c086$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4kcQz = parcelRequire("4kcQz");

var $4W5AG = parcelRequire("4W5AG");
var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");

var $D7J7L = parcelRequire("D7J7L");

var $8Ogg5 = parcelRequire("8Ogg5");
const $960302d7ec1d1257$export$7245a73350102308 = ({ visuals: visuals, idx: idx = 0, styles: styles })=>{
    const currentVisual = (0, $eF4cA.useMemo)(()=>visuals?.[idx], [
        visuals,
        idx
    ]);
    const query = (0, $4kcQz.useQuery)({
        queryKey: [
            "storyImage",
            currentVisual ? currentVisual.path ?? currentVisual.id : "default",
            currentVisual?.prompt
        ],
        queryFn: async ({ signal: signal })=>{
            if (currentVisual?.path) {
                const response = await (0, $D7J7L.fetchPresignURL)(currentVisual.path);
                return response.presignURL;
            } else if (currentVisual?.id && currentVisual?.libraryId) return (0, $8Ogg5.getPresignedImageUrl)(currentVisual?.libraryId, currentVisual?.id);
            else return "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png";
        },
        retryDelay: (attemptIndex, error)=>{
            // console.error("FireflyImage5 generation error:", error);
            return Math.min(1000 * 2 ** attemptIndex, 30000);
        },
        enabled: !!currentVisual?.path || !!currentVisual?.id && !!currentVisual?.libraryId,
        staleTime: 3600000
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                isLoading: query.isFetching,
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                    src: query.data,
                    alt: currentVisual?.prompt,
                    styles: styles
                })
            }),
            query.status === "error" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                onPress: ()=>query.refetch(),
                children: "Retry"
            })
        ]
    });
};
$960302d7ec1d1257$export$7245a73350102308.propTypes = {
    sourceReference: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    prompt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};


const $1352983b8972423b$export$a4842f11451d38bd = ({ item: item = {}, storyId: storyId, variant: variant = "quiet", styles: styles })=>{
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const isDark = colorScheme === "dark";
    const cardPreviewRef = (0, $eF4cA.useRef)(null);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
            styles: styles,
            variant: variant,
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        ref: cardPreviewRef,
                        ...hoverProps,
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $960302d7ec1d1257$export$7245a73350102308), {
                                visuals: item?.visuals
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                variant: "neutral",
                                fillStyle: "subtle",
                                size: "S",
                                styles: " _Pa182 _lI182 _AI182",
                                children: item.index ?? item.id + 1
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $62173499bdf6ab25$export$5b26ebaf2b105908), {
                                size: 24,
                                styles: " _Pa182 _lI182 _zI182",
                                "aria-label": "Personas",
                                children: item?.personas?.map?.((personaIdx, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2bffda9db2261f28$export$3cf67ed17f3a3c34), {
                                        persona: story?.personas?.[personaIdx],
                                        isOverBackground: true
                                    }, `${personaIdx}-${idx}`))
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: function anonymous(props) {
                                    let rules = " ";
                                    rules += ' _Pa182';
                                    rules += ' WF182';
                                    rules += ' _z3MNfn182';
                                    rules += ' -_7PloMd-3MNfn182';
                                    rules += ' __Ya182';
                                    rules += ' -_8PloMd-m182';
                                    rules += ' __Ya182';
                                    if (props.isHovered) rules += ' _Ib182';
                                    else rules += ' _Ia182';
                                    return rules;
                                }({
                                    isHovered: isHovered
                                }),
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                            variant: "primary",
                                            staticColor: isDark ? "black" : "white",
                                            "aria-label": "Maximize card",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8d36ed630f399b1b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2e7a091bd5ddc46c$export$a51ca80b6e1c45db), {
                                            storyId: storyId,
                                            item: item
                                        }, item.id)
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                    styles: " _ch182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: item.section
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    slot: "title",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 _7e182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: item.text
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$1352983b8972423b$export$a4842f11451d38bd.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    storyId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $5IZkx = parcelRequire("5IZkx");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $5NHyX = parcelRequire("5NHyX");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $aQTiM = parcelRequire("aQTiM");
var $8Muzv = parcelRequire("8Muzv");
var $8wD3p = parcelRequire("8wD3p");
var $2ffAV = parcelRequire("2ffAV");
var $fZShI = parcelRequire("fZShI");
var $208Op = parcelRequire("208Op");

var $fmJ8d = parcelRequire("fmJ8d");

var $VXM1R = parcelRequire("VXM1R");

var $lRNYL = parcelRequire("lRNYL");
var $1877ffdb17d7d631$exports = {};
/*! ExcelJS 19-10-2023 */ !function(e) {
    $1877ffdb17d7d631$exports = e();
}(function() {
    return (function e(t, r, n) {
        function i(o, a) {
            if (!r[o]) {
                if (!t[o]) {
                    var l = undefined;
                    if (!a && l) return l(o, !0);
                    if (s) return s(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                t[o][0].call(u.exports, function(e) {
                    return i(t[o][1][e] || e);
                }, u, u.exports, e, t, r, n);
            }
            return r[o].exports;
        }
        for(var s = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                const n = e("fs"), i = e("fast-csv"), s = e("dayjs/plugin/customParseFormat"), o = e("dayjs/plugin/utc"), a = e("dayjs").extend(s).extend(o), l = e("../utils/stream-buf"), { fs: { exists: c } } = e("../utils/utils"), u = {
                    true: !0,
                    false: !1,
                    "#N/A": {
                        error: "#N/A"
                    },
                    "#REF!": {
                        error: "#REF!"
                    },
                    "#NAME?": {
                        error: "#NAME?"
                    },
                    "#DIV/0!": {
                        error: "#DIV/0!"
                    },
                    "#NULL!": {
                        error: "#NULL!"
                    },
                    "#VALUE!": {
                        error: "#VALUE!"
                    },
                    "#NUM!": {
                        error: "#NUM!"
                    }
                };
                t.exports = class {
                    constructor(e){
                        this.workbook = e, this.worksheet = null;
                    }
                    async readFile(e, t) {
                        if (t = t || {}, !await c(e)) throw new Error("File not found: " + e);
                        const r = n.createReadStream(e), i = await this.read(r, t);
                        return r.close(), i;
                    }
                    read(e, t) {
                        return t = t || {}, new Promise((r, n)=>{
                            const s = this.workbook.addWorksheet(t.sheetName), o = t.dateFormats || [
                                "YYYY-MM-DD[T]HH:mm:ssZ",
                                "YYYY-MM-DD[T]HH:mm:ss",
                                "MM-DD-YYYY",
                                "YYYY-MM-DD"
                            ], l = t.map || function(e) {
                                if ("" === e) return null;
                                const t = Number(e);
                                if (!Number.isNaN(t) && t !== 1 / 0) return t;
                                const r = o.reduce((t, r)=>{
                                    if (t) return t;
                                    const n = a(e, r, !0);
                                    return n.isValid() ? n : null;
                                }, null);
                                if (r) return new Date(r.valueOf());
                                const n = u[e];
                                return void 0 !== n ? n : e;
                            }, c = i.parse(t.parserOptions).on("data", (e)=>{
                                s.addRow(e.map(l));
                            }).on("end", ()=>{
                                c.emit("worksheet", s);
                            });
                            c.on("worksheet", r).on("error", n), e.pipe(c);
                        });
                    }
                    createInputStream() {
                        throw new Error("`CSV#createInputStream` is deprecated. You should use `CSV#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                    }
                    write(e, t) {
                        return new Promise((r, n)=>{
                            t = t || {};
                            const s = this.workbook.getWorksheet(t.sheetName || t.sheetId), o = i.format(t.formatterOptions);
                            e.on("finish", ()=>{
                                r();
                            }), o.on("error", n), o.pipe(e);
                            const { dateFormat: l, dateUTC: c } = t, u = t.map || ((e)=>{
                                if (e) {
                                    if (e.text || e.hyperlink) return e.hyperlink || e.text || "";
                                    if (e.formula || e.result) return e.result || "";
                                    if (e instanceof Date) return l ? c ? a.utc(e).format(l) : a(e).format(l) : c ? a.utc(e).format() : a(e).format();
                                    if (e.error) return e.error;
                                    if ("object" == typeof e) return JSON.stringify(e);
                                }
                                return e;
                            }), h = void 0 === t.includeEmptyRows || t.includeEmptyRows;
                            let f = 1;
                            s && s.eachRow((e, t)=>{
                                if (h) for(; f++ < t - 1;)o.write([]);
                                const { values: r } = e;
                                r.shift(), o.write(r.map(u)), f = t;
                            }), o.end();
                        });
                    }
                    writeFile(e, t) {
                        const r = {
                            encoding: (t = t || {}).encoding || "utf8"
                        }, i = n.createWriteStream(e, r);
                        return this.write(i, t);
                    }
                    async writeBuffer(e) {
                        const t = new l;
                        return await this.write(t, e), t.read();
                    }
                };
            },
            {
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                dayjs: 391,
                "dayjs/plugin/customParseFormat": 392,
                "dayjs/plugin/utc": 393,
                "fast-csv": 424,
                fs: 216
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t){
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (this.worksheet = e, t) {
                            if ("string" == typeof t) {
                                const e = n.decodeAddress(t);
                                this.nativeCol = e.col + r, this.nativeColOff = 0, this.nativeRow = e.row + r, this.nativeRowOff = 0;
                            } else void 0 !== t.nativeCol ? (this.nativeCol = t.nativeCol || 0, this.nativeColOff = t.nativeColOff || 0, this.nativeRow = t.nativeRow || 0, this.nativeRowOff = t.nativeRowOff || 0) : void 0 !== t.col ? (this.col = t.col + r, this.row = t.row + r) : (this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0);
                        } else this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0;
                    }
                    static asInstance(e) {
                        return e instanceof i || null == e ? e : new i(e);
                    }
                    get col() {
                        return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
                    }
                    set col(e) {
                        this.nativeCol = Math.floor(e), this.nativeColOff = Math.floor((e - this.nativeCol) * this.colWidth);
                    }
                    get row() {
                        return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
                    }
                    set row(e) {
                        this.nativeRow = Math.floor(e), this.nativeRowOff = Math.floor((e - this.nativeRow) * this.rowHeight);
                    }
                    get colWidth() {
                        return this.worksheet && this.worksheet.getColumn(this.nativeCol + 1) && this.worksheet.getColumn(this.nativeCol + 1).isCustomWidth ? Math.floor(1e4 * this.worksheet.getColumn(this.nativeCol + 1).width) : 64e4;
                    }
                    get rowHeight() {
                        return this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height ? Math.floor(1e4 * this.worksheet.getRow(this.nativeRow + 1).height) : 18e4;
                    }
                    get model() {
                        return {
                            nativeCol: this.nativeCol,
                            nativeColOff: this.nativeColOff,
                            nativeRow: this.nativeRow,
                            nativeRowOff: this.nativeRowOff
                        };
                    }
                    set model(e) {
                        this.nativeCol = e.nativeCol, this.nativeColOff = e.nativeColOff, this.nativeRow = e.nativeRow, this.nativeRowOff = e.nativeRowOff;
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("../utils/under-dash"), s = e("./enums"), { slideFormula: o } = e("../utils/shared-formula"), a = e("./note");
                class l {
                    constructor(e, t, r){
                        if (!e || !t) throw new Error("A Cell needs a Row");
                        this._row = e, this._column = t, n.validateAddress(r), this._address = r, this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(e.style, t.style, {}), this._mergeCount = 0;
                    }
                    get worksheet() {
                        return this._row.worksheet;
                    }
                    get workbook() {
                        return this._row.worksheet.workbook;
                    }
                    destroy() {
                        delete this.style, delete this._value, delete this._row, delete this._column, delete this._address;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this.style.numFmt = e;
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this.style.font = e;
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this.style.alignment = e;
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this.style.border = e;
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this.style.fill = e;
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this.style.protection = e;
                    }
                    _mergeStyle(e, t, r) {
                        const n = e && e.numFmt || t && t.numFmt;
                        n && (r.numFmt = n);
                        const i = e && e.font || t && t.font;
                        i && (r.font = i);
                        const s = e && e.alignment || t && t.alignment;
                        s && (r.alignment = s);
                        const o = e && e.border || t && t.border;
                        o && (r.border = o);
                        const a = e && e.fill || t && t.fill;
                        a && (r.fill = a);
                        const l = e && e.protection || t && t.protection;
                        return l && (r.protection = l), r;
                    }
                    get address() {
                        return this._address;
                    }
                    get row() {
                        return this._row.number;
                    }
                    get col() {
                        return this._column.number;
                    }
                    get $col$row() {
                        return `$${this._column.letter}$${this.row}`;
                    }
                    get type() {
                        return this._value.type;
                    }
                    get effectiveType() {
                        return this._value.effectiveType;
                    }
                    toCsvString() {
                        return this._value.toCsvString();
                    }
                    addMergeRef() {
                        this._mergeCount++;
                    }
                    releaseMergeRef() {
                        this._mergeCount--;
                    }
                    get isMerged() {
                        return this._mergeCount > 0 || this.type === l.Types.Merge;
                    }
                    merge(e, t) {
                        this._value.release(), this._value = c.create(l.Types.Merge, this, e), t || (this.style = e.style);
                    }
                    unmerge() {
                        this.type === l.Types.Merge && (this._value.release(), this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(this._row.style, this._column.style, {}));
                    }
                    isMergedTo(e) {
                        return this._value.type === l.Types.Merge && this._value.isMergedTo(e);
                    }
                    get master() {
                        return this.type === l.Types.Merge ? this._value.master : this;
                    }
                    get isHyperlink() {
                        return this._value.type === l.Types.Hyperlink;
                    }
                    get hyperlink() {
                        return this._value.hyperlink;
                    }
                    get value() {
                        return this._value.value;
                    }
                    set value(e) {
                        this.type !== l.Types.Merge ? (this._value.release(), this._value = c.create(c.getType(e), this, e)) : this._value.master.value = e;
                    }
                    get note() {
                        return this._comment && this._comment.note;
                    }
                    set note(e) {
                        this._comment = new a(e);
                    }
                    get text() {
                        return this._value.toString();
                    }
                    get html() {
                        return i.escapeHtml(this.text);
                    }
                    toString() {
                        return this.text;
                    }
                    _upgradeToHyperlink(e) {
                        this.type === l.Types.String && (this._value = c.create(l.Types.Hyperlink, this, {
                            text: this._value.value,
                            hyperlink: e
                        }));
                    }
                    get formula() {
                        return this._value.formula;
                    }
                    get result() {
                        return this._value.result;
                    }
                    get formulaType() {
                        return this._value.formulaType;
                    }
                    get fullAddress() {
                        const { worksheet: e } = this._row;
                        return {
                            sheetName: e.name,
                            address: this.address,
                            row: this.row,
                            col: this.col
                        };
                    }
                    get name() {
                        return this.names[0];
                    }
                    set name(e) {
                        this.names = [
                            e
                        ];
                    }
                    get names() {
                        return this.workbook.definedNames.getNamesEx(this.fullAddress);
                    }
                    set names(e) {
                        const { definedNames: t } = this.workbook;
                        t.removeAllNames(this.fullAddress), e.forEach((e)=>{
                            t.addEx(this.fullAddress, e);
                        });
                    }
                    addName(e) {
                        this.workbook.definedNames.addEx(this.fullAddress, e);
                    }
                    removeName(e) {
                        this.workbook.definedNames.removeEx(this.fullAddress, e);
                    }
                    removeAllNames() {
                        this.workbook.definedNames.removeAllNames(this.fullAddress);
                    }
                    get _dataValidations() {
                        return this.worksheet.dataValidations;
                    }
                    get dataValidation() {
                        return this._dataValidations.find(this.address);
                    }
                    set dataValidation(e) {
                        this._dataValidations.add(this.address, e);
                    }
                    get model() {
                        const { model: e } = this._value;
                        return e.style = this.style, this._comment && (e.comment = this._comment.model), e;
                    }
                    set model(e) {
                        if (this._value.release(), this._value = c.create(e.type, this), this._value.model = e, e.comment) switch(e.comment.type){
                            case "note":
                                this._comment = a.fromModel(e.comment);
                        }
                        e.style ? this.style = e.style : this.style = {};
                    }
                }
                l.Types = s.ValueType;
                const c = {
                    getType: (e)=>null == e ? l.Types.Null : e instanceof String || "string" == typeof e ? l.Types.String : "number" == typeof e ? l.Types.Number : "boolean" == typeof e ? l.Types.Boolean : e instanceof Date ? l.Types.Date : e.text && e.hyperlink ? l.Types.Hyperlink : e.formula || e.sharedFormula ? l.Types.Formula : e.richText ? l.Types.RichText : e.sharedString ? l.Types.SharedString : e.error ? l.Types.Error : l.Types.JSON,
                    types: [
                        {
                            t: l.Types.Null,
                            f: class {
                                constructor(e){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Null
                                    };
                                }
                                get value() {
                                    return null;
                                }
                                set value(e) {}
                                get type() {
                                    return l.Types.Null;
                                }
                                get effectiveType() {
                                    return l.Types.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {}
                                toString() {
                                    return "";
                                }
                            }
                        },
                        {
                            t: l.Types.Number,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Number,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Number;
                                }
                                get effectiveType() {
                                    return l.Types.Number;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.String,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.model.value.replace(/"/g, '""')}"`;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.Date,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Date,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Date;
                                }
                                get effectiveType() {
                                    return l.Types.Date;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toISOString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Hyperlink,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Hyperlink,
                                        text: t ? t.text : void 0,
                                        hyperlink: t ? t.hyperlink : void 0
                                    }, t && t.tooltip && (this.model.tooltip = t.tooltip);
                                }
                                get value() {
                                    const e = {
                                        text: this.model.text,
                                        hyperlink: this.model.hyperlink
                                    };
                                    return this.model.tooltip && (e.tooltip = this.model.tooltip), e;
                                }
                                set value(e) {
                                    this.model = {
                                        text: e.text,
                                        hyperlink: e.hyperlink
                                    }, e.tooltip && (this.model.tooltip = e.tooltip);
                                }
                                get text() {
                                    return this.model.text;
                                }
                                set text(e) {
                                    this.model.text = e;
                                }
                                get hyperlink() {
                                    return this.model.hyperlink;
                                }
                                set hyperlink(e) {
                                    this.model.hyperlink = e;
                                }
                                get type() {
                                    return l.Types.Hyperlink;
                                }
                                get effectiveType() {
                                    return l.Types.Hyperlink;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.hyperlink;
                                }
                                release() {}
                                toString() {
                                    return this.model.text;
                                }
                            }
                        },
                        {
                            t: l.Types.Formula,
                            f: class {
                                constructor(e, t){
                                    this.cell = e, this.model = {
                                        address: e.address,
                                        type: l.Types.Formula,
                                        shareType: t ? t.shareType : void 0,
                                        ref: t ? t.ref : void 0,
                                        formula: t ? t.formula : void 0,
                                        sharedFormula: t ? t.sharedFormula : void 0,
                                        result: t ? t.result : void 0
                                    };
                                }
                                _copyModel(e) {
                                    const t = {}, r = (r)=>{
                                        const n = e[r];
                                        n && (t[r] = n);
                                    };
                                    return r("formula"), r("result"), r("ref"), r("shareType"), r("sharedFormula"), t;
                                }
                                get value() {
                                    return this._copyModel(this.model);
                                }
                                set value(e) {
                                    this.model = this._copyModel(e);
                                }
                                validate(e) {
                                    switch(c.getType(e)){
                                        case l.Types.Null:
                                        case l.Types.String:
                                        case l.Types.Number:
                                        case l.Types.Date:
                                            break;
                                        case l.Types.Hyperlink:
                                        case l.Types.Formula:
                                        default:
                                            throw new Error("Cannot process that type of result value");
                                    }
                                }
                                get dependencies() {
                                    return {
                                        ranges: this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g),
                                        cells: this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g, "").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}/g)
                                    };
                                }
                                get formula() {
                                    return this.model.formula || this._getTranslatedFormula();
                                }
                                set formula(e) {
                                    this.model.formula = e;
                                }
                                get formulaType() {
                                    return this.model.formula ? s.FormulaType.Master : this.model.sharedFormula ? s.FormulaType.Shared : s.FormulaType.None;
                                }
                                get result() {
                                    return this.model.result;
                                }
                                set result(e) {
                                    this.model.result = e;
                                }
                                get type() {
                                    return l.Types.Formula;
                                }
                                get effectiveType() {
                                    const e = this.model.result;
                                    return null == e ? s.ValueType.Null : e instanceof String || "string" == typeof e ? s.ValueType.String : "number" == typeof e ? s.ValueType.Number : e instanceof Date ? s.ValueType.Date : e.text && e.hyperlink ? s.ValueType.Hyperlink : e.formula ? s.ValueType.Formula : s.ValueType.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                _getTranslatedFormula() {
                                    if (!this._translatedFormula && this.model.sharedFormula) {
                                        const { worksheet: e } = this.cell, t = e.findCell(this.model.sharedFormula);
                                        this._translatedFormula = t && o(t.formula, t.address, this.model.address);
                                    }
                                    return this._translatedFormula;
                                }
                                toCsvString() {
                                    return "" + (this.model.result || "");
                                }
                                release() {}
                                toString() {
                                    return this.model.result ? this.model.result.toString() : "";
                                }
                            }
                        },
                        {
                            t: l.Types.Merge,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Merge,
                                        master: t ? t.address : void 0
                                    }, this._master = t, t && t.addMergeRef();
                                }
                                get value() {
                                    return this._master.value;
                                }
                                set value(e) {
                                    e instanceof l ? (this._master && this._master.releaseMergeRef(), e.addMergeRef(), this._master = e) : this._master.value = e;
                                }
                                isMergedTo(e) {
                                    return e === this._master;
                                }
                                get master() {
                                    return this._master;
                                }
                                get type() {
                                    return l.Types.Merge;
                                }
                                get effectiveType() {
                                    return this._master.effectiveType;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {
                                    this._master.releaseMergeRef();
                                }
                                toString() {
                                    return this.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.JSON,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: JSON.stringify(t),
                                        rawValue: t
                                    };
                                }
                                get value() {
                                    return this.model.rawValue;
                                }
                                set value(e) {
                                    this.model.rawValue = e, this.model.value = JSON.stringify(e);
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.SharedString,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.SharedString,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.SharedString;
                                }
                                get effectiveType() {
                                    return l.Types.SharedString;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.RichText,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                toString() {
                                    return this.model.value.richText.map((e)=>e.text).join("");
                                }
                                get type() {
                                    return l.Types.RichText;
                                }
                                get effectiveType() {
                                    return l.Types.RichText;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.text.replace(/"/g, '""')}"`;
                                }
                                release() {}
                            }
                        },
                        {
                            t: l.Types.Boolean,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Boolean,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Boolean;
                                }
                                get effectiveType() {
                                    return l.Types.Boolean;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value ? 1 : 0;
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Error,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Error,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Error;
                                }
                                get effectiveType() {
                                    return l.Types.Error;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.error.toString();
                                }
                            }
                        }
                    ].reduce((e, t)=>(e[t.t] = t.f, e), []),
                    create (e, t, r) {
                        const n = this.types[e];
                        if (!n) throw new Error("Could not create Value of type " + e);
                        return new n(t, r);
                    }
                };
                t.exports = l;
            },
            {
                "../utils/col-cache": 19,
                "../utils/shared-formula": 23,
                "../utils/under-dash": 26,
                "./enums": 7,
                "./note": 9
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache");
                class o {
                    constructor(e, t, r){
                        this._worksheet = e, this._number = t, !1 !== r && (this.defn = r);
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    get letter() {
                        return s.n2l(this._number);
                    }
                    get isCustomWidth() {
                        return void 0 !== this.width && 9 !== this.width;
                    }
                    get defn() {
                        return {
                            header: this._header,
                            key: this.key,
                            width: this.width,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel
                        };
                    }
                    set defn(e) {
                        e ? (this.key = e.key, this.width = void 0 !== e.width ? e.width : 9, this.outlineLevel = e.outlineLevel, e.style ? this.style = e.style : this.style = {}, this.header = e.header, this._hidden = !!e.hidden) : (delete this._header, delete this._key, delete this.width, this.style = {}, this.outlineLevel = 0);
                    }
                    get headers() {
                        return this._header && this._header instanceof Array ? this._header : [
                            this._header
                        ];
                    }
                    get header() {
                        return this._header;
                    }
                    set header(e) {
                        void 0 !== e ? (this._header = e, this.headers.forEach((e, t)=>{
                            this._worksheet.getCell(t + 1, this.number).value = e;
                        })) : this._header = void 0;
                    }
                    get key() {
                        return this._key;
                    }
                    set key(e) {
                        (this._key && this._worksheet.getColumnKey(this._key)) === this && this._worksheet.deleteColumnKey(this._key), this._key = e, e && this._worksheet.setColumnKey(this._key, this);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelCol);
                    }
                    toString() {
                        return JSON.stringify({
                            key: this.key,
                            width: this.width,
                            headers: this.headers.length ? this.headers : void 0
                        });
                    }
                    equivalentTo(e) {
                        return this.width === e.width && this.hidden === e.hidden && this.outlineLevel === e.outlineLevel && n.isEqual(this.style, e.style);
                    }
                    get isDefault() {
                        if (this.isCustomWidth) return !1;
                        if (this.hidden) return !1;
                        if (this.outlineLevel) return !1;
                        const e = this.style;
                        return !e || !(e.font || e.numFmt || e.alignment || e.border || e.fill || e.protection);
                    }
                    get headerCount() {
                        return this.headers.length;
                    }
                    eachCell(e, t) {
                        const r = this.number;
                        t || (t = e, e = null), this._worksheet.eachRow(e, (e, n)=>{
                            t(e.getCell(r), n);
                        });
                    }
                    get values() {
                        const e = [];
                        return this.eachCell((t, r)=>{
                            t && t.type !== i.ValueType.Null && (e[r] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (!e) return;
                        const t = this.number;
                        let r = 0;
                        e.hasOwnProperty("0") && (r = 1), e.forEach((e, n)=>{
                            this._worksheet.getCell(n + r, t).value = e;
                        });
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this.eachCell((r)=>{
                            r[e] = t;
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    static toModel(e) {
                        const t = [];
                        let r = null;
                        return e && e.forEach((e, n)=>{
                            e.isDefault ? r && (r = null) : r && e.equivalentTo(r) ? r.max = n + 1 : (r = {
                                min: n + 1,
                                max: n + 1,
                                width: void 0 !== e.width ? e.width : 9,
                                style: e.style,
                                isCustomWidth: e.isCustomWidth,
                                hidden: e.hidden,
                                outlineLevel: e.outlineLevel,
                                collapsed: e.collapsed
                            }, t.push(r));
                        }), t.length ? t : void 0;
                    }
                    static fromModel(e, t) {
                        const r = [];
                        let n = 1, i = 0;
                        for(t = (t = t || []).sort(function(e, t) {
                            return e.min - t.min;
                        }); i < t.length;){
                            const s = t[i++];
                            for(; n < s.min;)r.push(new o(e, n++));
                            for(; n <= s.max;)r.push(new o(e, n++, s));
                        }
                        return r.length ? r : null;
                    }
                }
                t.exports = o;
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./enums": 7
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                t.exports = class {
                    constructor(e){
                        this.model = e || {};
                    }
                    add(e, t) {
                        return this.model[e] = t;
                    }
                    find(e) {
                        return this.model[e];
                    }
                    remove(e) {
                        this.model[e] = void 0;
                    }
                };
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("../utils/cell-matrix"), o = e("./range"), a = /[$](\w+)[$](\d+)(:[$](\w+)[$](\d+))?/;
                t.exports = class {
                    constructor(){
                        this.matrixMap = {};
                    }
                    getMatrix(e) {
                        return this.matrixMap[e] || (this.matrixMap[e] = new s);
                    }
                    add(e, t) {
                        const r = i.decodeEx(e);
                        this.addEx(r, t);
                    }
                    addEx(e, t) {
                        const r = this.getMatrix(t);
                        if (e.top) for(let t = e.left; t <= e.right; t++)for(let n = e.top; n <= e.bottom; n++){
                            const s = {
                                sheetName: e.sheetName,
                                address: i.n2l(t) + n,
                                row: n,
                                col: t
                            };
                            r.addCellEx(s);
                        }
                        else r.addCellEx(e);
                    }
                    remove(e, t) {
                        const r = i.decodeEx(e);
                        this.removeEx(r, t);
                    }
                    removeEx(e, t) {
                        this.getMatrix(t).removeCellEx(e);
                    }
                    removeAllNames(e) {
                        n.each(this.matrixMap, (t)=>{
                            t.removeCellEx(e);
                        });
                    }
                    forEach(e) {
                        n.each(this.matrixMap, (t, r)=>{
                            t.forEach((t)=>{
                                e(r, t);
                            });
                        });
                    }
                    getNames(e) {
                        return this.getNamesEx(i.decodeEx(e));
                    }
                    getNamesEx(e) {
                        return n.map(this.matrixMap, (t, r)=>t.findCellEx(e) && r).filter(Boolean);
                    }
                    _explore(e, t) {
                        t.mark = !1;
                        const { sheetName: r } = t, n = new o(t.row, t.col, t.row, t.col, r);
                        let i, s;
                        function a(i, s) {
                            const o = e.findCellAt(r, i, t.col);
                            return !(!o || !o.mark) && (n[s] = i, o.mark = !1, !0);
                        }
                        for(s = t.row - 1; a(s, "top"); s--);
                        for(s = t.row + 1; a(s, "bottom"); s++);
                        function l(t, i) {
                            const o = [];
                            for(s = n.top; s <= n.bottom; s++){
                                const n = e.findCellAt(r, s, t);
                                if (!n || !n.mark) return !1;
                                o.push(n);
                            }
                            n[i] = t;
                            for(let e = 0; e < o.length; e++)o[e].mark = !1;
                            return !0;
                        }
                        for(i = t.col - 1; l(i, "left"); i--);
                        for(i = t.col + 1; l(i, "right"); i++);
                        return n;
                    }
                    getRanges(e, t) {
                        if (!(t = t || this.matrixMap[e])) return {
                            name: e,
                            ranges: []
                        };
                        t.forEach((e)=>{
                            e.mark = !0;
                        });
                        return {
                            name: e,
                            ranges: t.map((e)=>e.mark && this._explore(t, e)).filter(Boolean).map((e)=>e.$shortRange)
                        };
                    }
                    normaliseMatrix(e, t) {
                        e.forEachInSheet(t, (e, t, r)=>{
                            e && (e.row === t && e.col === r || (e.row = t, e.col = r, e.address = i.n2l(r) + t));
                        });
                    }
                    spliceRows(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceRows(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    spliceColumns(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceColumns(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    get model() {
                        return n.map(this.matrixMap, (e, t)=>this.getRanges(t, e)).filter((e)=>e.ranges.length);
                    }
                    set model(e) {
                        const t = this.matrixMap = {};
                        e.forEach((e)=>{
                            const r = t[e.name] = new s;
                            e.ranges.forEach((e)=>{
                                a.test(e.split("!").pop() || "") && r.addCell(e);
                            });
                        });
                    }
                };
            },
            {
                "../utils/cell-matrix": 18,
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./range": 10
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    ValueType: {
                        Null: 0,
                        Merge: 1,
                        Number: 2,
                        String: 3,
                        Date: 4,
                        Hyperlink: 5,
                        Formula: 6,
                        SharedString: 7,
                        RichText: 8,
                        Boolean: 9,
                        Error: 10
                    },
                    FormulaType: {
                        None: 0,
                        Master: 1,
                        Shared: 2
                    },
                    RelationshipType: {
                        None: 0,
                        OfficeDocument: 1,
                        Worksheet: 2,
                        CalcChain: 3,
                        SharedStrings: 4,
                        Styles: 5,
                        Theme: 6,
                        Hyperlink: 7
                    },
                    DocumentType: {
                        Xlsx: 1
                    },
                    ReadingOrder: {
                        LeftToRight: 1,
                        RightToLeft: 2
                    },
                    ErrorValue: {
                        NotApplicable: "#N/A",
                        Ref: "#REF!",
                        Name: "#NAME?",
                        DivZero: "#DIV/0!",
                        Null: "#NULL!",
                        Value: "#VALUE!",
                        Num: "#NUM!"
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("./anchor");
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, this.model = t;
                    }
                    get model() {
                        switch(this.type){
                            case "background":
                                return {
                                    type: this.type,
                                    imageId: this.imageId
                                };
                            case "image":
                                return {
                                    type: this.type,
                                    imageId: this.imageId,
                                    hyperlinks: this.range.hyperlinks,
                                    range: {
                                        tl: this.range.tl.model,
                                        br: this.range.br && this.range.br.model,
                                        ext: this.range.ext,
                                        editAs: this.range.editAs
                                    }
                                };
                            default:
                                throw new Error("Invalid Image Type");
                        }
                    }
                    set model(e) {
                        let { type: t, imageId: r, range: s, hyperlinks: o } = e;
                        if (this.type = t, this.imageId = r, "image" === t) {
                            if ("string" == typeof s) {
                                const e = n.decode(s);
                                this.range = {
                                    tl: new i(this.worksheet, {
                                        col: e.left,
                                        row: e.top
                                    }, -1),
                                    br: new i(this.worksheet, {
                                        col: e.right,
                                        row: e.bottom
                                    }, 0),
                                    editAs: "oneCell"
                                };
                            } else this.range = {
                                tl: new i(this.worksheet, s.tl, 0),
                                br: s.br && new i(this.worksheet, s.br, 0),
                                ext: s.ext,
                                editAs: s.editAs,
                                hyperlinks: o || s.hyperlinks
                            };
                        }
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "./anchor": 2
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash");
                class i {
                    constructor(e){
                        this.note = e;
                    }
                    get model() {
                        let e = null;
                        switch(typeof this.note){
                            case "string":
                                e = {
                                    type: "note",
                                    note: {
                                        texts: [
                                            {
                                                text: this.note
                                            }
                                        ]
                                    }
                                };
                                break;
                            default:
                                e = {
                                    type: "note",
                                    note: this.note
                                };
                        }
                        return n.deepMerge({}, i.DEFAULT_CONFIGS, e);
                    }
                    set model(e) {
                        const { note: t } = e, { texts: r } = t;
                        1 === r.length && 1 === Object.keys(r[0]).length ? this.note = r[0].text : this.note = t;
                    }
                    static fromModel(e) {
                        const t = new i;
                        return t.model = e, t;
                    }
                }
                i.DEFAULT_CONFIGS = {
                    note: {
                        margins: {
                            insetmode: "auto",
                            inset: [
                                .13,
                                .13,
                                .25,
                                .25
                            ]
                        },
                        protection: {
                            locked: "True",
                            lockText: "True"
                        },
                        editAs: "absolute"
                    }
                }, t.exports = i;
            },
            {
                "../utils/under-dash": 26
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(){
                        this.decode(arguments);
                    }
                    setTLBR(e, t, r, i, s) {
                        if (arguments.length < 4) {
                            const i = n.decodeAddress(e), o = n.decodeAddress(t);
                            this.model = {
                                top: Math.min(i.row, o.row),
                                left: Math.min(i.col, o.col),
                                bottom: Math.max(i.row, o.row),
                                right: Math.max(i.col, o.col),
                                sheetName: r
                            }, this.setTLBR(i.row, i.col, o.row, o.col, s);
                        } else this.model = {
                            top: Math.min(e, r),
                            left: Math.min(t, i),
                            bottom: Math.max(e, r),
                            right: Math.max(t, i),
                            sheetName: s
                        };
                    }
                    decode(e) {
                        switch(e.length){
                            case 5:
                                this.setTLBR(e[0], e[1], e[2], e[3], e[4]);
                                break;
                            case 4:
                                this.setTLBR(e[0], e[1], e[2], e[3]);
                                break;
                            case 3:
                                this.setTLBR(e[0], e[1], e[2]);
                                break;
                            case 2:
                                this.setTLBR(e[0], e[1]);
                                break;
                            case 1:
                                {
                                    const t = e[0];
                                    if (t instanceof i) this.model = {
                                        top: t.model.top,
                                        left: t.model.left,
                                        bottom: t.model.bottom,
                                        right: t.model.right,
                                        sheetName: t.sheetName
                                    };
                                    else if (t instanceof Array) this.decode(t);
                                    else if (t.top && t.left && t.bottom && t.right) this.model = {
                                        top: t.top,
                                        left: t.left,
                                        bottom: t.bottom,
                                        right: t.right,
                                        sheetName: t.sheetName
                                    };
                                    else {
                                        const e = n.decodeEx(t);
                                        e.top ? this.model = {
                                            top: e.top,
                                            left: e.left,
                                            bottom: e.bottom,
                                            right: e.right,
                                            sheetName: e.sheetName
                                        } : this.model = {
                                            top: e.row,
                                            left: e.col,
                                            bottom: e.row,
                                            right: e.col,
                                            sheetName: e.sheetName
                                        };
                                    }
                                    break;
                                }
                            case 0:
                                this.model = {
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                };
                                break;
                            default:
                                throw new Error("Invalid number of arguments to _getDimensions() - " + e.length);
                        }
                    }
                    get top() {
                        return this.model.top || 1;
                    }
                    set top(e) {
                        this.model.top = e;
                    }
                    get left() {
                        return this.model.left || 1;
                    }
                    set left(e) {
                        this.model.left = e;
                    }
                    get bottom() {
                        return this.model.bottom || 1;
                    }
                    set bottom(e) {
                        this.model.bottom = e;
                    }
                    get right() {
                        return this.model.right || 1;
                    }
                    set right(e) {
                        this.model.right = e;
                    }
                    get sheetName() {
                        return this.model.sheetName;
                    }
                    set sheetName(e) {
                        this.model.sheetName = e;
                    }
                    get _serialisedSheetName() {
                        const { sheetName: e } = this.model;
                        return e ? /^[a-zA-Z0-9]*$/.test(e) ? e + "!" : `'${e}'!` : "";
                    }
                    expand(e, t, r, n) {
                        (!this.model.top || e < this.top) && (this.top = e), (!this.model.left || t < this.left) && (this.left = t), (!this.model.bottom || r > this.bottom) && (this.bottom = r), (!this.model.right || n > this.right) && (this.right = n);
                    }
                    expandRow(e) {
                        if (e) {
                            const { dimensions: t, number: r } = e;
                            t && this.expand(r, t.min, r, t.max);
                        }
                    }
                    expandToAddress(e) {
                        const t = n.decodeEx(e);
                        this.expand(t.row, t.col, t.row, t.col);
                    }
                    get tl() {
                        return n.n2l(this.left) + this.top;
                    }
                    get $t$l() {
                        return `$${n.n2l(this.left)}$${this.top}`;
                    }
                    get br() {
                        return n.n2l(this.right) + this.bottom;
                    }
                    get $b$r() {
                        return `$${n.n2l(this.right)}$${this.bottom}`;
                    }
                    get range() {
                        return `${this._serialisedSheetName + this.tl}:${this.br}`;
                    }
                    get $range() {
                        return `${this._serialisedSheetName + this.$t$l}:${this.$b$r}`;
                    }
                    get shortRange() {
                        return this.count > 1 ? this.range : this._serialisedSheetName + this.tl;
                    }
                    get $shortRange() {
                        return this.count > 1 ? this.$range : this._serialisedSheetName + this.$t$l;
                    }
                    get count() {
                        return (1 + this.bottom - this.top) * (1 + this.right - this.left);
                    }
                    toString() {
                        return this.range;
                    }
                    intersects(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && !(e.bottom < this.top) && !(e.top > this.bottom) && !(e.right < this.left) && !(e.left > this.right);
                    }
                    contains(e) {
                        const t = n.decodeEx(e);
                        return this.containsEx(t);
                    }
                    containsEx(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && e.row >= this.top && e.row <= this.bottom && e.col >= this.left && e.col <= this.right;
                    }
                    forEachAddress(e) {
                        for(let t = this.left; t <= this.right; t++)for(let r = this.top; r <= this.bottom; r++)e(n.encodeAddress(r, t), r, t);
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache"), o = e("./cell");
                t.exports = class {
                    constructor(e, t){
                        this._worksheet = e, this._number = t, this._cells = [], this.style = {}, this.outlineLevel = 0;
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    commit() {
                        this._worksheet._commitRow(this);
                    }
                    destroy() {
                        delete this._worksheet, delete this._cells, delete this.style;
                    }
                    findCell(e) {
                        return this._cells[e - 1];
                    }
                    getCellEx(e) {
                        let t = this._cells[e.col - 1];
                        if (!t) {
                            const r = this._worksheet.getColumn(e.col);
                            t = new o(this, r, e.address), this._cells[e.col - 1] = t;
                        }
                        return t;
                    }
                    getCell(e) {
                        if ("string" == typeof e) {
                            const t = this._worksheet.getColumnKey(e);
                            e = t ? t.number : s.l2n(e);
                        }
                        return this._cells[e - 1] || this.getCellEx({
                            address: s.encodeAddress(this._number, e),
                            row: this._number,
                            col: e
                        });
                    }
                    splice(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length - t, a = this._cells.length;
                        let l, c, u;
                        if (o < 0) for(l = e + i.length; l <= a; l++)u = this._cells[l - 1], c = this._cells[l - o - 1], c ? (u = this.getCell(l), u.value = c.value, u.style = c.style, u._comment = c._comment) : u && (u.value = null, u.style = {}, u._comment = void 0);
                        else if (o > 0) for(l = a; l >= r; l--)c = this._cells[l - 1], c ? (u = this.getCell(l + o), u.value = c.value, u.style = c.style, u._comment = c._comment) : this._cells[l + o - 1] = void 0;
                        for(l = 0; l < i.length; l++)u = this.getCell(e + l), u.value = i[l], u.style = {}, u._comment = void 0;
                    }
                    eachCell(e, t) {
                        if (t || (t = e, e = null), e && e.includeEmpty) {
                            const e = this._cells.length;
                            for(let r = 1; r <= e; r++)t(this.getCell(r), r);
                        } else this._cells.forEach((e, r)=>{
                            e && e.type !== i.ValueType.Null && t(e, r + 1);
                        });
                    }
                    addPageBreak(e, t) {
                        const r = this._worksheet, n = Math.max(0, e - 1) || 0, i = Math.max(0, t - 1) || 16838, s = {
                            id: this._number,
                            max: i,
                            man: 1
                        };
                        n && (s.min = n), r.rowBreaks.push(s);
                    }
                    get values() {
                        const e = [];
                        return this._cells.forEach((t)=>{
                            t && t.type !== i.ValueType.Null && (e[t.col] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (this._cells = [], e) {
                            if (e instanceof Array) {
                                let t = 0;
                                e.hasOwnProperty("0") && (t = 1), e.forEach((e, r)=>{
                                    void 0 !== e && (this.getCellEx({
                                        address: s.encodeAddress(this._number, r + t),
                                        row: this._number,
                                        col: r + t
                                    }).value = e);
                                });
                            } else this._worksheet.eachColumnKey((t, r)=>{
                                void 0 !== e[r] && (this.getCellEx({
                                    address: s.encodeAddress(this._number, t.number),
                                    row: this._number,
                                    col: t.number
                                }).value = e[r]);
                            });
                        } else ;
                    }
                    get hasValues() {
                        return n.some(this._cells, (e)=>e && e.type !== i.ValueType.Null);
                    }
                    get cellCount() {
                        return this._cells.length;
                    }
                    get actualCellCount() {
                        let e = 0;
                        return this.eachCell(()=>{
                            e++;
                        }), e;
                    }
                    get dimensions() {
                        let e = 0, t = 0;
                        return this._cells.forEach((r)=>{
                            r && r.type !== i.ValueType.Null && ((!e || e > r.col) && (e = r.col), t < r.col && (t = r.col));
                        }), e > 0 ? {
                            min: e,
                            max: t
                        } : null;
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this._cells.forEach((r)=>{
                            r && (r[e] = t);
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelRow);
                    }
                    get model() {
                        const e = [];
                        let t = 0, r = 0;
                        return this._cells.forEach((n)=>{
                            if (n) {
                                const i = n.model;
                                i && ((!t || t > n.col) && (t = n.col), r < n.col && (r = n.col), e.push(i));
                            }
                        }), this.height || e.length ? {
                            cells: e,
                            number: this.number,
                            min: t,
                            max: r,
                            height: this.height,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel,
                            collapsed: this.collapsed
                        } : null;
                    }
                    set model(e) {
                        if (e.number !== this._number) throw new Error("Invalid row number in model");
                        let t;
                        this._cells = [], e.cells.forEach((e)=>{
                            switch(e.type){
                                case o.Types.Merge:
                                    break;
                                default:
                                    {
                                        let r;
                                        if (e.address) r = s.decodeAddress(e.address);
                                        else if (t) {
                                            const { row: e } = t, n = t.col + 1;
                                            r = {
                                                row: e,
                                                col: n,
                                                address: s.encodeAddress(e, n),
                                                $col$row: `$${s.n2l(n)}$${e}`
                                            };
                                        }
                                        t = r;
                                        this.getCellEx(r).model = e;
                                        break;
                                    }
                            }
                        }), e.height ? this.height = e.height : delete this.height, this.hidden = e.hidden, this.outlineLevel = e.outlineLevel || 0, this.style = e.style && JSON.parse(JSON.stringify(e.style)) || {};
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./cell": 3,
                "./enums": 7
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t, r){
                        this.table = e, this.column = t, this.index = r;
                    }
                    _set(e, t) {
                        this.table.cacheState(), this.column[e] = t;
                    }
                    get name() {
                        return this.column.name;
                    }
                    set name(e) {
                        this._set("name", e);
                    }
                    get filterButton() {
                        return this.column.filterButton;
                    }
                    set filterButton(e) {
                        this.column.filterButton = e;
                    }
                    get style() {
                        return this.column.style;
                    }
                    set style(e) {
                        this.column.style = e;
                    }
                    get totalsRowLabel() {
                        return this.column.totalsRowLabel;
                    }
                    set totalsRowLabel(e) {
                        this._set("totalsRowLabel", e);
                    }
                    get totalsRowFunction() {
                        return this.column.totalsRowFunction;
                    }
                    set totalsRowFunction(e) {
                        this._set("totalsRowFunction", e);
                    }
                    get totalsRowResult() {
                        return this.column.totalsRowResult;
                    }
                    set totalsRowResult(e) {
                        this._set("totalsRowResult", e);
                    }
                    get totalsRowFormula() {
                        return this.column.totalsRowFormula;
                    }
                    set totalsRowFormula(e) {
                        this._set("totalsRowFormula", e);
                    }
                }
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, t && (this.table = t, this.validate(), this.store());
                    }
                    getFormula(e) {
                        switch(e.totalsRowFunction){
                            case "none":
                                return null;
                            case "average":
                                return `SUBTOTAL(101,${this.table.name}[${e.name}])`;
                            case "countNums":
                                return `SUBTOTAL(102,${this.table.name}[${e.name}])`;
                            case "count":
                                return `SUBTOTAL(103,${this.table.name}[${e.name}])`;
                            case "max":
                                return `SUBTOTAL(104,${this.table.name}[${e.name}])`;
                            case "min":
                                return `SUBTOTAL(105,${this.table.name}[${e.name}])`;
                            case "stdDev":
                                return `SUBTOTAL(106,${this.table.name}[${e.name}])`;
                            case "var":
                                return `SUBTOTAL(107,${this.table.name}[${e.name}])`;
                            case "sum":
                                return `SUBTOTAL(109,${this.table.name}[${e.name}])`;
                            case "custom":
                                return e.totalsRowFormula;
                            default:
                                throw new Error("Invalid Totals Row Function: " + e.totalsRowFunction);
                        }
                    }
                    get width() {
                        return this.table.columns.length;
                    }
                    get height() {
                        return this.table.rows.length;
                    }
                    get filterHeight() {
                        return this.height + (this.table.headerRow ? 1 : 0);
                    }
                    get tableHeight() {
                        return this.filterHeight + (this.table.totalsRow ? 1 : 0);
                    }
                    validate() {
                        const { table: e } = this, t = (e, t, r)=>{
                            void 0 === e[t] && (e[t] = r);
                        };
                        t(e, "headerRow", !0), t(e, "totalsRow", !1), t(e, "style", {}), t(e.style, "theme", "TableStyleMedium2"), t(e.style, "showFirstColumn", !1), t(e.style, "showLastColumn", !1), t(e.style, "showRowStripes", !1), t(e.style, "showColumnStripes", !1);
                        const r = (e, t)=>{
                            if (!e) throw new Error(t);
                        };
                        r(e.ref, "Table must have ref"), r(e.columns, "Table must have column definitions"), r(e.rows, "Table must have row definitions"), e.tl = n.decodeAddress(e.ref);
                        const { row: i, col: s } = e.tl;
                        r(i > 0, "Table must be on valid row"), r(s > 0, "Table must be on valid col");
                        const { width: o, filterHeight: a, tableHeight: l } = this;
                        e.autoFilterRef = n.encode(i, s, i + a - 1, s + o - 1), e.tableRef = n.encode(i, s, i + l - 1, s + o - 1), e.columns.forEach((e, n)=>{
                            r(e.name, `Column ${n} must have a name`), 0 === n ? t(e, "totalsRowLabel", "Total") : (t(e, "totalsRowFunction", "none"), e.totalsRowFormula = this.getFormula(e));
                        });
                    }
                    store() {
                        const e = (e, t)=>{
                            t && Object.keys(t).forEach((r)=>{
                                e[r] = t[r];
                            });
                        }, { worksheet: t, table: r } = this, { row: n, col: i } = r.tl;
                        let s = 0;
                        if (r.headerRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const { style: n, name: s } = t, a = o.getCell(i + r);
                                a.value = s, e(a, n);
                            });
                        }
                        if (r.rows.forEach((o)=>{
                            const a = t.getRow(n + s++);
                            o.forEach((t, n)=>{
                                const s = a.getCell(i + n);
                                s.value = t, e(s, r.columns[n].style);
                            });
                        }), r.totalsRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const n = o.getCell(i + r);
                                if (0 === r) n.value = t.totalsRowLabel;
                                else {
                                    const e = this.getFormula(t);
                                    n.value = e ? {
                                        formula: t.totalsRowFormula,
                                        result: t.totalsRowResult
                                    } : null;
                                }
                                e(n, t.style);
                            });
                        }
                    }
                    load(e) {
                        const { table: t } = this, { row: r, col: n } = t.tl;
                        let i = 0;
                        if (t.headerRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                s.getCell(n + t).value = e.name;
                            });
                        }
                        if (t.rows.forEach((t)=>{
                            const s = e.getRow(r + i++);
                            t.forEach((e, t)=>{
                                s.getCell(n + t).value = e;
                            });
                        }), t.totalsRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                const r = s.getCell(n + t);
                                if (0 === t) r.value = e.totalsRowLabel;
                                else this.getFormula(e) && (r.value = {
                                    formula: e.totalsRowFormula,
                                    result: e.totalsRowResult
                                });
                            });
                        }
                    }
                    get model() {
                        return this.table;
                    }
                    set model(e) {
                        this.table = e;
                    }
                    cacheState() {
                        this._cache || (this._cache = {
                            ref: this.ref,
                            width: this.width,
                            tableHeight: this.tableHeight
                        });
                    }
                    commit() {
                        if (!this._cache) return;
                        this.validate();
                        const e = n.decodeAddress(this._cache.ref);
                        if (this.ref !== this._cache.ref) for(let t = 0; t < this._cache.tableHeight; t++){
                            const r = this.worksheet.getRow(e.row + t);
                            for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                        }
                        else {
                            for(let t = this.tableHeight; t < this._cache.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                            for(let t = 0; t < this.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = this.width; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                        }
                        this.store();
                    }
                    addRow(e, t) {
                        this.cacheState(), void 0 === t ? this.table.rows.push(e) : this.table.rows.splice(t, 0, e);
                    }
                    removeRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.rows.splice(e, t);
                    }
                    getColumn(e) {
                        const t = this.table.columns[e];
                        return new i(this, t, e);
                    }
                    addColumn(e, t, r) {
                        this.cacheState(), void 0 === r ? (this.table.columns.push(e), this.table.rows.forEach((e, r)=>{
                            e.push(t[r]);
                        })) : (this.table.columns.splice(r, 0, e), this.table.rows.forEach((e, n)=>{
                            e.splice(r, 0, t[n]);
                        }));
                    }
                    removeColumns(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.columns.splice(e, t), this.table.rows.forEach((r)=>{
                            r.splice(e, t);
                        });
                    }
                    _assign(e, t, r) {
                        this.cacheState(), e[t] = r;
                    }
                    get ref() {
                        return this.table.ref;
                    }
                    set ref(e) {
                        this._assign(this.table, "ref", e);
                    }
                    get name() {
                        return this.table.name;
                    }
                    set name(e) {
                        this.table.name = e;
                    }
                    get displayName() {
                        return this.table.displyName || this.table.name;
                    }
                    set displayNamename(e) {
                        this.table.displayName = e;
                    }
                    get headerRow() {
                        return this.table.headerRow;
                    }
                    set headerRow(e) {
                        this._assign(this.table, "headerRow", e);
                    }
                    get totalsRow() {
                        return this.table.totalsRow;
                    }
                    set totalsRow(e) {
                        this._assign(this.table, "totalsRow", e);
                    }
                    get theme() {
                        return this.table.style.name;
                    }
                    set theme(e) {
                        this.table.style.name = e;
                    }
                    get showFirstColumn() {
                        return this.table.style.showFirstColumn;
                    }
                    set showFirstColumn(e) {
                        this.table.style.showFirstColumn = e;
                    }
                    get showLastColumn() {
                        return this.table.style.showLastColumn;
                    }
                    set showLastColumn(e) {
                        this.table.style.showLastColumn = e;
                    }
                    get showRowStripes() {
                        return this.table.style.showRowStripes;
                    }
                    set showRowStripes(e) {
                        this.table.style.showRowStripes = e;
                    }
                    get showColumnStripes() {
                        return this.table.style.showColumnStripes;
                    }
                    set showColumnStripes(e) {
                        this.table.style.showColumnStripes = e;
                    }
                };
            },
            {
                "../utils/col-cache": 19
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                const n = e("./worksheet"), i = e("./defined-names"), s = e("../xlsx/xlsx"), o = e("../csv/csv");
                t.exports = class {
                    constructor(){
                        this.category = "", this.company = "", this.created = new Date, this.description = "", this.keywords = "", this.manager = "", this.modified = this.created, this.properties = {}, this.calcProperties = {}, this._worksheets = [], this.subject = "", this.title = "", this.views = [], this.media = [], this._definedNames = new i;
                    }
                    get xlsx() {
                        return this._xlsx || (this._xlsx = new s(this)), this._xlsx;
                    }
                    get csv() {
                        return this._csv || (this._csv = new o(this)), this._csv;
                    }
                    get nextId() {
                        for(let e = 1; e < this._worksheets.length; e++)if (!this._worksheets[e]) return e;
                        return this._worksheets.length || 1;
                    }
                    addWorksheet(e, t) {
                        const r = this.nextId;
                        t && ("string" == typeof t ? (console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: "rbg value" } }'), t = {
                            properties: {
                                tabColor: {
                                    argb: t
                                }
                            }
                        }) : (t.argb || t.theme || t.indexed) && (console.trace("tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }"), t = {
                            properties: {
                                tabColor: t
                            }
                        }));
                        const i = this._worksheets.reduce((e, t)=>(t && t.orderNo) > e ? t.orderNo : e, 0), s = Object.assign({}, t, {
                            id: r,
                            name: e,
                            orderNo: i + 1,
                            workbook: this
                        }), o = new n(s);
                        return this._worksheets[r] = o, o;
                    }
                    removeWorksheetEx(e) {
                        delete this._worksheets[e.id];
                    }
                    removeWorksheet(e) {
                        const t = this.getWorksheet(e);
                        t && t.destroy();
                    }
                    getWorksheet(e) {
                        return void 0 === e ? this._worksheets.find(Boolean) : "number" == typeof e ? this._worksheets[e] : "string" == typeof e ? this._worksheets.find((t)=>t && t.name === e) : void 0;
                    }
                    get worksheets() {
                        return this._worksheets.slice(1).sort((e, t)=>e.orderNo - t.orderNo).filter(Boolean);
                    }
                    eachSheet(e) {
                        this.worksheets.forEach((t)=>{
                            e(t, t.id);
                        });
                    }
                    get definedNames() {
                        return this._definedNames;
                    }
                    clearThemes() {
                        this._themes = void 0;
                    }
                    addImage(e) {
                        const t = this.media.length;
                        return this.media.push(Object.assign({}, e, {
                            type: "image"
                        })), t;
                    }
                    getImage(e) {
                        return this.media[e];
                    }
                    get model() {
                        return {
                            creator: this.creator || "Unknown",
                            lastModifiedBy: this.lastModifiedBy || "Unknown",
                            lastPrinted: this.lastPrinted,
                            created: this.created,
                            modified: this.modified,
                            properties: this.properties,
                            worksheets: this.worksheets.map((e)=>e.model),
                            sheets: this.worksheets.map((e)=>e.model).filter(Boolean),
                            definedNames: this._definedNames.model,
                            views: this.views,
                            company: this.company,
                            manager: this.manager,
                            title: this.title,
                            subject: this.subject,
                            keywords: this.keywords,
                            category: this.category,
                            description: this.description,
                            language: this.language,
                            revision: this.revision,
                            contentStatus: this.contentStatus,
                            themes: this._themes,
                            media: this.media,
                            calcProperties: this.calcProperties
                        };
                    }
                    set model(e) {
                        this.creator = e.creator, this.lastModifiedBy = e.lastModifiedBy, this.lastPrinted = e.lastPrinted, this.created = e.created, this.modified = e.modified, this.company = e.company, this.manager = e.manager, this.title = e.title, this.subject = e.subject, this.keywords = e.keywords, this.category = e.category, this.description = e.description, this.language = e.language, this.revision = e.revision, this.contentStatus = e.contentStatus, this.properties = e.properties, this.calcProperties = e.calcProperties, this._worksheets = [], e.worksheets.forEach((t)=>{
                            const { id: r, name: i, state: s } = t, o = e.sheets && e.sheets.findIndex((e)=>e.id === r);
                            (this._worksheets[r] = new n({
                                id: r,
                                name: i,
                                orderNo: o,
                                state: s,
                                workbook: this
                            })).model = t;
                        }), this._definedNames.model = e.definedNames, this.views = e.views, this._themes = e.themes, this.media = e.media || [];
                    }
                };
            },
            {
                "../csv/csv": 1,
                "../xlsx/xlsx": 144,
                "./defined-names": 6,
                "./worksheet": 14
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("./range"), o = e("./row"), a = e("./column"), l = e("./enums"), c = e("./image"), u = e("./table"), h = e("./data-validations"), f = e("../utils/encryptor"), { copyStyle: d } = e("../utils/copy-style");
                t.exports = class {
                    constructor(e){
                        e = e || {}, this._workbook = e.workbook, this.id = e.id, this.orderNo = e.orderNo, this.name = e.name, this.state = e.state || "visible", this._rows = [], this._columns = null, this._keys = {}, this._merges = {}, this.rowBreaks = [], this.properties = Object.assign({}, {
                            defaultRowHeight: 15,
                            dyDescent: 55,
                            outlineLevelCol: 0,
                            outlineLevelRow: 0
                        }, e.properties), this.pageSetup = Object.assign({}, {
                            margins: {
                                left: .7,
                                right: .7,
                                top: .75,
                                bottom: .75,
                                header: .3,
                                footer: .3
                            },
                            orientation: "portrait",
                            horizontalDpi: 4294967295,
                            verticalDpi: 4294967295,
                            fitToPage: !(!e.pageSetup || !e.pageSetup.fitToWidth && !e.pageSetup.fitToHeight || e.pageSetup.scale),
                            pageOrder: "downThenOver",
                            blackAndWhite: !1,
                            draft: !1,
                            cellComments: "None",
                            errors: "displayed",
                            scale: 100,
                            fitToWidth: 1,
                            fitToHeight: 1,
                            paperSize: void 0,
                            showRowColHeaders: !1,
                            showGridLines: !1,
                            firstPageNumber: void 0,
                            horizontalCentered: !1,
                            verticalCentered: !1,
                            rowBreaks: null,
                            colBreaks: null
                        }, e.pageSetup), this.headerFooter = Object.assign({}, {
                            differentFirst: !1,
                            differentOddEven: !1,
                            oddHeader: null,
                            oddFooter: null,
                            evenHeader: null,
                            evenFooter: null,
                            firstHeader: null,
                            firstFooter: null
                        }, e.headerFooter), this.dataValidations = new h, this.views = e.views || [], this.autoFilter = e.autoFilter || null, this._media = [], this.sheetProtection = null, this.tables = {}, this.conditionalFormattings = [];
                    }
                    get name() {
                        return this._name;
                    }
                    set name(e) {
                        if (void 0 === e && (e = "sheet" + this.id), this._name !== e) {
                            if ("string" != typeof e) throw new Error("The name has to be a string.");
                            if ("" === e) throw new Error("The name can't be empty.");
                            if ("History" === e) throw new Error('The name "History" is protected. Please use a different name.');
                            if (/[*?:/\\[\]]/.test(e)) throw new Error(`Worksheet name ${e} cannot include any of the following characters: * ? : \\ / [ ]`);
                            if (/(^')|('$)/.test(e)) throw new Error("The first or last character of worksheet name cannot be a single quotation mark: " + e);
                            if (e && e.length > 31 && (console.warn(`Worksheet name ${e} exceeds 31 chars. This will be truncated`), e = e.substring(0, 31)), this._workbook._worksheets.find((t)=>t && t.name.toLowerCase() === e.toLowerCase())) throw new Error("Worksheet name already exists: " + e);
                            this._name = e;
                        }
                    }
                    get workbook() {
                        return this._workbook;
                    }
                    destroy() {
                        this._workbook.removeWorksheetEx(this);
                    }
                    get dimensions() {
                        const e = new s;
                        return this._rows.forEach((t)=>{
                            if (t) {
                                const r = t.dimensions;
                                r && e.expand(t.number, r.min, t.number, r.max);
                            }
                        }), e;
                    }
                    get columns() {
                        return this._columns;
                    }
                    set columns(e) {
                        this._headerRowCount = e.reduce((e, t)=>{
                            const r = (t.header ? 1 : t.headers && t.headers.length) || 0;
                            return Math.max(e, r);
                        }, 0);
                        let t = 1;
                        const r = this._columns = [];
                        e.forEach((e)=>{
                            const n = new a(this, t++, !1);
                            r.push(n), n.defn = e;
                        });
                    }
                    getColumnKey(e) {
                        return this._keys[e];
                    }
                    setColumnKey(e, t) {
                        this._keys[e] = t;
                    }
                    deleteColumnKey(e) {
                        delete this._keys[e];
                    }
                    eachColumnKey(e) {
                        n.each(this._keys, e);
                    }
                    getColumn(e) {
                        if ("string" == typeof e) {
                            const t = this._keys[e];
                            if (t) return t;
                            e = i.l2n(e);
                        }
                        if (this._columns || (this._columns = []), e > this._columns.length) {
                            let t = this._columns.length + 1;
                            for(; t <= e;)this._columns.push(new a(this, t++));
                        }
                        return this._columns[e - 1];
                    }
                    spliceColumns(e, t) {
                        const r = this._rows.length;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        if (i.length > 0) for(let n = 0; n < r; n++){
                            const r = [
                                e,
                                t
                            ];
                            i.forEach((e)=>{
                                r.push(e[n] || null);
                            });
                            const s = this.getRow(n + 1);
                            s.splice.apply(s, r);
                        }
                        else this._rows.forEach((r)=>{
                            r && r.splice(e, t);
                        });
                        const o = i.length - t, a = e + t, l = this._columns.length;
                        if (o < 0) for(let t = e + i.length; t <= l; t++)this.getColumn(t).defn = this.getColumn(t - o).defn;
                        else if (o > 0) for(let e = l; e >= a; e--)this.getColumn(e + o).defn = this.getColumn(e).defn;
                        for(let t = e; t < e + i.length; t++)this.getColumn(t).defn = null;
                        this.workbook.definedNames.spliceColumns(this.name, e, t, i.length);
                    }
                    get lastColumn() {
                        return this.getColumn(this.columnCount);
                    }
                    get columnCount() {
                        let e = 0;
                        return this.eachRow((t)=>{
                            e = Math.max(e, t.cellCount);
                        }), e;
                    }
                    get actualColumnCount() {
                        const e = [];
                        let t = 0;
                        return this.eachRow((r)=>{
                            r.eachCell((r)=>{
                                let { col: n } = r;
                                e[n] || (e[n] = !0, t++);
                            });
                        }), t;
                    }
                    _commitRow() {}
                    get _lastRowNumber() {
                        const e = this._rows;
                        let t = e.length;
                        for(; t > 0 && void 0 === e[t - 1];)t--;
                        return t;
                    }
                    get _nextRow() {
                        return this._lastRowNumber + 1;
                    }
                    get lastRow() {
                        if (this._rows.length) return this._rows[this._rows.length - 1];
                    }
                    findRow(e) {
                        return this._rows[e - 1];
                    }
                    findRows(e, t) {
                        return this._rows.slice(e - 1, e - 1 + t);
                    }
                    get rowCount() {
                        return this._lastRowNumber;
                    }
                    get actualRowCount() {
                        let e = 0;
                        return this.eachRow(()=>{
                            e++;
                        }), e;
                    }
                    getRow(e) {
                        let t = this._rows[e - 1];
                        return t || (t = this._rows[e - 1] = new o(this, e)), t;
                    }
                    getRows(e, t) {
                        if (t < 1) return;
                        const r = [];
                        for(let n = e; n < e + t; n++)r.push(this.getRow(n));
                        return r;
                    }
                    addRow(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = this._nextRow, n = this.getRow(r);
                        return n.values = e, this._setStyleOption(r, "i" === t[0] ? t : "n"), n;
                    }
                    addRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = [];
                        return e.forEach((e)=>{
                            r.push(this.addRow(e, t));
                        }), r;
                    }
                    insertRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        return this.spliceRows(e, 0, t), this._setStyleOption(e, r), this.getRow(e);
                    }
                    insertRows(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        if (this.spliceRows(e, 0, ...t), "n" !== r) for(let n = 0; n < t.length; n++)"o" === r[0] && void 0 !== this.findRow(t.length + e + n) ? this._copyStyle(t.length + e + n, e + n, "+" === r[1]) : "i" === r[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e + n, "+" === r[1]);
                        return this.getRows(e, t.length);
                    }
                    _setStyleOption(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        "o" === t[0] && void 0 !== this.findRow(e + 1) ? this._copyStyle(e + 1, e, "+" === t[1]) : "i" === t[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e, "+" === t[1]);
                    }
                    _copyStyle(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this.getRow(e), i = this.getRow(t);
                        i.style = d(n.style), n.eachCell({
                            includeEmpty: r
                        }, (e, t)=>{
                            i.getCell(t).style = d(e.style);
                        }), i.height = n.height;
                    }
                    duplicateRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this._rows[e - 1], i = new Array(t).fill(n.values);
                        this.spliceRows(e + 1, r ? 0 : t, ...i);
                        for(let r = 0; r < t; r++){
                            const t = this._rows[e + r];
                            t.style = n.style, t.height = n.height, n.eachCell({
                                includeEmpty: !0
                            }, (e, r)=>{
                                t.getCell(r).style = e.style;
                            });
                        }
                    }
                    spliceRows(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length, a = o - t, l = this._rows.length;
                        let c, u;
                        if (a < 0) for(e === l && (this._rows[l - 1] = void 0), c = r; c <= l; c++)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                e.getCell(r).style = t.style;
                            }), this._rows[c - 1] = void 0;
                        } else this._rows[c + a - 1] = void 0;
                        else if (a > 0) for(c = l; c >= r; c--)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                if (e.getCell(r).style = t.style, "MergeValue" === t._value.constructor.name) {
                                    const e = this.getRow(t._row._number + o).getCell(r), n = t._value._master, i = this.getRow(n._row._number + o).getCell(n._column._number);
                                    e.merge(i);
                                }
                            });
                        } else this._rows[c + a - 1] = void 0;
                        for(c = 0; c < o; c++){
                            const t = this.getRow(e + c);
                            t.style = {}, t.values = i[c];
                        }
                        this.workbook.definedNames.spliceRows(this.name, e, t, o);
                    }
                    eachRow(e, t) {
                        if (t || (t = e, e = void 0), e && e.includeEmpty) {
                            const e = this._rows.length;
                            for(let r = 1; r <= e; r++)t(this.getRow(r), r);
                        } else this._rows.forEach((e)=>{
                            e && e.hasValues && t(e, e.number);
                        });
                    }
                    getSheetValues() {
                        const e = [];
                        return this._rows.forEach((t)=>{
                            t && (e[t.number] = t.values);
                        }), e;
                    }
                    findCell(e, t) {
                        const r = i.getAddress(e, t), n = this._rows[r.row - 1];
                        return n ? n.findCell(r.col) : void 0;
                    }
                    getCell(e, t) {
                        const r = i.getAddress(e, t);
                        return this.getRow(r.row).getCellEx(r);
                    }
                    mergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n);
                    }
                    mergeCellsWithoutStyle() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n, !0);
                    }
                    _mergeCellsInternal(e, t) {
                        n.each(this._merges, (t)=>{
                            if (t.intersects(e)) throw new Error("Cannot merge already merged cells");
                        });
                        const r = this.getCell(e.top, e.left);
                        for(let n = e.top; n <= e.bottom; n++)for(let i = e.left; i <= e.right; i++)(n > e.top || i > e.left) && this.getCell(n, i).merge(r, t);
                        this._merges[r.address] = e;
                    }
                    _unMergeMaster(e) {
                        const t = this._merges[e.address];
                        if (t) {
                            for(let e = t.top; e <= t.bottom; e++)for(let r = t.left; r <= t.right; r++)this.getCell(e, r).unmerge();
                            delete this._merges[e.address];
                        }
                    }
                    get hasMerges() {
                        return n.some(this._merges, Boolean);
                    }
                    unMergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        for(let e = n.top; e <= n.bottom; e++)for(let t = n.left; t <= n.right; t++){
                            const r = this.findCell(e, t);
                            r && (r.type === l.ValueType.Merge ? this._unMergeMaster(r.master) : this._merges[r.address] && this._unMergeMaster(r));
                        }
                    }
                    fillFormula(e, t, r) {
                        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "shared";
                        const s = i.decode(e), { top: o, left: a, bottom: l, right: c } = s, u = c - a + 1, h = i.encodeAddress(o, a), f = "shared" === n;
                        let d;
                        d = "function" == typeof r ? r : Array.isArray(r) ? Array.isArray(r[0]) ? (e, t)=>r[e - o][t - a] : (e, t)=>r[(e - o) * u + (t - a)] : ()=>{};
                        let p = !0;
                        for(let r = o; r <= l; r++)for(let i = a; i <= c; i++)p ? (this.getCell(r, i).value = {
                            shareType: n,
                            formula: t,
                            ref: e,
                            result: d(r, i)
                        }, p = !1) : this.getCell(r, i).value = f ? {
                            sharedFormula: h,
                            result: d(r, i)
                        } : d(r, i);
                    }
                    addImage(e, t) {
                        const r = {
                            type: "image",
                            imageId: e,
                            range: t
                        };
                        this._media.push(new c(this, r));
                    }
                    getImages() {
                        return this._media.filter((e)=>"image" === e.type);
                    }
                    addBackgroundImage(e) {
                        const t = {
                            type: "background",
                            imageId: e
                        };
                        this._media.push(new c(this, t));
                    }
                    getBackgroundImageId() {
                        const e = this._media.find((e)=>"background" === e.type);
                        return e && e.imageId;
                    }
                    protect(e, t) {
                        return new Promise((r)=>{
                            this.sheetProtection = {
                                sheet: !0
                            }, t && "spinCount" in t && (t.spinCount = Number.isFinite(t.spinCount) ? Math.round(Math.max(0, t.spinCount)) : 1e5), e && (this.sheetProtection.algorithmName = "SHA-512", this.sheetProtection.saltValue = f.randomBytes(16).toString("base64"), this.sheetProtection.spinCount = t && "spinCount" in t ? t.spinCount : 1e5, this.sheetProtection.hashValue = f.convertPasswordToHash(e, "SHA512", this.sheetProtection.saltValue, this.sheetProtection.spinCount)), t && (this.sheetProtection = Object.assign(this.sheetProtection, t), !e && "spinCount" in t && delete this.sheetProtection.spinCount), r();
                        });
                    }
                    unprotect() {
                        this.sheetProtection = null;
                    }
                    addTable(e) {
                        const t = new u(this, e);
                        return this.tables[e.name] = t, t;
                    }
                    getTable(e) {
                        return this.tables[e];
                    }
                    removeTable(e) {
                        delete this.tables[e];
                    }
                    getTables() {
                        return Object.values(this.tables);
                    }
                    addConditionalFormatting(e) {
                        this.conditionalFormattings.push(e);
                    }
                    removeConditionalFormatting(e) {
                        "number" == typeof e ? this.conditionalFormattings.splice(e, 1) : this.conditionalFormattings = e instanceof Function ? this.conditionalFormattings.filter(e) : [];
                    }
                    get tabColor() {
                        return console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor;
                    }
                    set tabColor(e) {
                        console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor = e;
                    }
                    get model() {
                        const e = {
                            id: this.id,
                            name: this.name,
                            dataValidations: this.dataValidations.model,
                            properties: this.properties,
                            state: this.state,
                            pageSetup: this.pageSetup,
                            headerFooter: this.headerFooter,
                            rowBreaks: this.rowBreaks,
                            views: this.views,
                            autoFilter: this.autoFilter,
                            media: this._media.map((e)=>e.model),
                            sheetProtection: this.sheetProtection,
                            tables: Object.values(this.tables).map((e)=>e.model),
                            conditionalFormattings: this.conditionalFormattings
                        };
                        e.cols = a.toModel(this.columns);
                        const t = e.rows = [], r = e.dimensions = new s;
                        return this._rows.forEach((e)=>{
                            const n = e && e.model;
                            n && (r.expand(n.number, n.min, n.number, n.max), t.push(n));
                        }), e.merges = [], n.each(this._merges, (t)=>{
                            e.merges.push(t.range);
                        }), e;
                    }
                    _parseRows(e) {
                        this._rows = [], e.rows.forEach((e)=>{
                            const t = new o(this, e.number);
                            this._rows[t.number - 1] = t, t.model = e;
                        });
                    }
                    _parseMergeCells(e) {
                        n.each(e.mergeCells, (e)=>{
                            this.mergeCellsWithoutStyle(e);
                        });
                    }
                    set model(e) {
                        this.name = e.name, this._columns = a.fromModel(this, e.cols), this._parseRows(e), this._parseMergeCells(e), this.dataValidations = new h(e.dataValidations), this.properties = e.properties, this.pageSetup = e.pageSetup, this.headerFooter = e.headerFooter, this.views = e.views, this.autoFilter = e.autoFilter, this._media = e.media.map((e)=>new c(this, e)), this.sheetProtection = e.sheetProtection, this.tables = e.tables.reduce((e, t)=>{
                            const r = new u;
                            return r.model = t, e[t.name] = r, e;
                        }, {}), this.conditionalFormattings = e.conditionalFormattings;
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/copy-style": 20,
                "../utils/encryptor": 21,
                "../utils/under-dash": 26,
                "./column": 4,
                "./data-validations": 5,
                "./enums": 7,
                "./image": 8,
                "./range": 10,
                "./row": 11,
                "./table": 12
            }
        ],
        15: [
            function(e, t, r) {
                "use strict";
                e("core-js/modules/es.promise"), e("core-js/modules/es.promise.finally"), e("core-js/modules/es.object.assign"), e("core-js/modules/es.object.keys"), e("core-js/modules/es.object.values"), e("core-js/modules/es.symbol"), e("core-js/modules/es.symbol.async-iterator"), e("core-js/modules/es.array.iterator"), e("core-js/modules/es.array.includes"), e("core-js/modules/es.array.find-index"), e("core-js/modules/es.array.find"), e("core-js/modules/es.string.from-code-point"), e("core-js/modules/es.string.includes"), e("core-js/modules/es.number.is-nan"), e("regenerator-runtime/runtime");
                const n = {
                    Workbook: e("./doc/workbook")
                }, i = e("./doc/enums");
                Object.keys(i).forEach((e)=>{
                    n[e] = i[e];
                }), t.exports = n;
            },
            {
                "./doc/enums": 7,
                "./doc/workbook": 13,
                "core-js/modules/es.array.find": 359,
                "core-js/modules/es.array.find-index": 358,
                "core-js/modules/es.array.includes": 360,
                "core-js/modules/es.array.iterator": 361,
                "core-js/modules/es.number.is-nan": 363,
                "core-js/modules/es.object.assign": 364,
                "core-js/modules/es.object.keys": 366,
                "core-js/modules/es.object.values": 367,
                "core-js/modules/es.promise": 372,
                "core-js/modules/es.promise.finally": 371,
                "core-js/modules/es.string.from-code-point": 376,
                "core-js/modules/es.string.includes": 377,
                "core-js/modules/es.symbol": 381,
                "core-js/modules/es.symbol.async-iterator": 378,
                "regenerator-runtime/runtime": 492
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                r.bufferToString = function(e) {
                    return "string" == typeof e ? e : n ? n.decode(e) : e.toString();
                };
            },
            {}
        ],
        17: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextEncoder ? null : new TextEncoder("utf-8"), { Buffer: i } = e("buffer");
                r.stringToBuffer = function(e) {
                    return "string" != typeof e ? e : n ? i.from(n.encode(e).buffer) : i.from(e);
                };
            },
            {
                buffer: 220
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./col-cache");
                t.exports = class {
                    constructor(e){
                        this.template = e, this.sheets = {};
                    }
                    addCell(e) {
                        this.addCellEx(i.decodeEx(e));
                    }
                    getCell(e) {
                        return this.findCellEx(i.decodeEx(e), !0);
                    }
                    findCell(e) {
                        return this.findCellEx(i.decodeEx(e), !1);
                    }
                    findCellAt(e, t, r) {
                        const n = this.sheets[e], i = n && n[t];
                        return i && i[r];
                    }
                    addCellEx(e) {
                        if (e.top) for(let t = e.top; t <= e.bottom; t++)for(let r = e.left; r <= e.right; r++)this.getCellAt(e.sheetName, t, r);
                        else this.findCellEx(e, !0);
                    }
                    getCellEx(e) {
                        return this.findCellEx(e, !0);
                    }
                    findCellEx(e, t) {
                        const r = this.findSheet(e, t), n = this.findSheetRow(r, e, t);
                        return this.findRowCell(n, e, t);
                    }
                    getCellAt(e, t, r) {
                        const n = this.sheets[e] || (this.sheets[e] = []), s = n[t] || (n[t] = []);
                        return s[r] || (s[r] = {
                            sheetName: e,
                            address: i.n2l(r) + t,
                            row: t,
                            col: r
                        });
                    }
                    removeCellEx(e) {
                        const t = this.findSheet(e);
                        if (!t) return;
                        const r = this.findSheetRow(t, e);
                        r && delete r[e.col];
                    }
                    forEachInSheet(e, t) {
                        const r = this.sheets[e];
                        r && r.forEach((e, r)=>{
                            e && e.forEach((e, n)=>{
                                e && t(e, r, n);
                            });
                        });
                    }
                    forEach(e) {
                        n.each(this.sheets, (t, r)=>{
                            this.forEachInSheet(r, e);
                        });
                    }
                    map(e) {
                        const t = [];
                        return this.forEach((r)=>{
                            t.push(e(r));
                        }), t;
                    }
                    findSheet(e, t) {
                        const r = e.sheetName;
                        return this.sheets[r] ? this.sheets[r] : t ? this.sheets[r] = [] : void 0;
                    }
                    findSheetRow(e, t, r) {
                        const { row: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = [] : void 0;
                    }
                    findRowCell(e, t, r) {
                        const { col: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = this.template ? Object.assign(t, JSON.parse(JSON.stringify(this.template))) : t : void 0;
                    }
                    spliceRows(e, t, r, n) {
                        const i = this.sheets[e];
                        if (i) {
                            const e = [];
                            for(let t = 0; t < n; t++)e.push([]);
                            i.splice(t, r, ...e);
                        }
                    }
                    spliceColumns(e, t, r, i) {
                        const s = this.sheets[e];
                        if (s) {
                            const e = [];
                            for(let t = 0; t < i; t++)e.push(null);
                            n.each(s, (n)=>{
                                n.splice(t, r, ...e);
                            });
                        }
                    }
                };
            },
            {
                "./col-cache": 19,
                "./under-dash": 26
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                const n = /^[A-Z]+\d+$/, i = {
                    _dictionary: [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "L",
                        "M",
                        "N",
                        "O",
                        "P",
                        "Q",
                        "R",
                        "S",
                        "T",
                        "U",
                        "V",
                        "W",
                        "X",
                        "Y",
                        "Z"
                    ],
                    _l2nFill: 0,
                    _l2n: {},
                    _n2l: [],
                    _level: (e)=>e <= 26 ? 1 : e <= 676 ? 2 : 3,
                    _fill (e) {
                        let t, r, n, i, s, o = 1;
                        if (e >= 4) throw new Error("Out of bounds. Excel supports columns from 1 to 16384");
                        if (this._l2nFill < 1 && e >= 1) {
                            for(; o <= 26;)t = this._dictionary[o - 1], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 1;
                        }
                        if (this._l2nFill < 2 && e >= 2) {
                            for(o = 27; o <= 702;)r = o - 27, n = r % 26, i = Math.floor(r / 26), t = this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 2;
                        }
                        if (this._l2nFill < 3 && e >= 3) {
                            for(o = 703; o <= 16384;)r = o - 703, n = r % 26, i = Math.floor(r / 26) % 26, s = Math.floor(r / 676), t = this._dictionary[s] + this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 3;
                        }
                    },
                    l2n (e) {
                        if (this._l2n[e] || this._fill(e.length), !this._l2n[e]) throw new Error("Out of bounds. Invalid column letter: " + e);
                        return this._l2n[e];
                    },
                    n2l (e) {
                        if (e < 1 || e > 16384) throw new Error(e + " is out of bounds. Excel supports columns from 1 to 16384");
                        return this._n2l[e] || this._fill(this._level(e)), this._n2l[e];
                    },
                    _hash: {},
                    validateAddress (e) {
                        if (!n.test(e)) throw new Error("Invalid Address: " + e);
                        return !0;
                    },
                    decodeAddress (e) {
                        const t = e.length < 5 && this._hash[e];
                        if (t) return t;
                        let r = !1, n = "", i = 0, s = !1, o = "", a = 0;
                        for(let t, l = 0; l < e.length; l++)if (t = e.charCodeAt(l), !s && t >= 65 && t <= 90) r = !0, n += e[l], i = 26 * i + t - 64;
                        else if (t >= 48 && t <= 57) s = !0, o += e[l], a = 10 * a + t - 48;
                        else if (s && r && 36 !== t) break;
                        if (r) {
                            if (i > 16384) throw new Error("Out of bounds. Invalid column letter: " + n);
                        } else i = void 0;
                        s || (a = void 0);
                        const l = {
                            address: e = n + o,
                            col: i,
                            row: a,
                            $col$row: `$${n}$${o}`
                        };
                        return i <= 100 && a <= 100 && (this._hash[e] = l, this._hash[l.$col$row] = l), l;
                    },
                    getAddress (e, t) {
                        if (t) {
                            const r = this.n2l(t) + e;
                            return this.decodeAddress(r);
                        }
                        return this.decodeAddress(e);
                    },
                    decode (e) {
                        const t = e.split(":");
                        if (2 === t.length) {
                            const e = this.decodeAddress(t[0]), r = this.decodeAddress(t[1]), n = {
                                top: Math.min(e.row, r.row),
                                left: Math.min(e.col, r.col),
                                bottom: Math.max(e.row, r.row),
                                right: Math.max(e.col, r.col)
                            };
                            return n.tl = this.n2l(n.left) + n.top, n.br = this.n2l(n.right) + n.bottom, n.dimensions = `${n.tl}:${n.br}`, n;
                        }
                        return this.decodeAddress(e);
                    },
                    decodeEx (e) {
                        const t = e.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/), r = t[1] || t[2], n = t[3], i = n.split(":");
                        if (i.length > 1) {
                            let e = this.decodeAddress(i[0]), t = this.decodeAddress(i[1]);
                            const n = Math.min(e.row, t.row), s = Math.min(e.col, t.col), o = Math.max(e.row, t.row), a = Math.max(e.col, t.col);
                            return e = this.n2l(s) + n, t = this.n2l(a) + o, {
                                top: n,
                                left: s,
                                bottom: o,
                                right: a,
                                sheetName: r,
                                tl: {
                                    address: e,
                                    col: s,
                                    row: n,
                                    $col$row: `$${this.n2l(s)}$${n}`,
                                    sheetName: r
                                },
                                br: {
                                    address: t,
                                    col: a,
                                    row: o,
                                    $col$row: `$${this.n2l(a)}$${o}`,
                                    sheetName: r
                                },
                                dimensions: `${e}:${t}`
                            };
                        }
                        if (n.startsWith("#")) return r ? {
                            sheetName: r,
                            error: n
                        } : {
                            error: n
                        };
                        const s = this.decodeAddress(n);
                        return r ? {
                            sheetName: r,
                            ...s
                        } : s;
                    },
                    encodeAddress: (e, t)=>i.n2l(t) + e,
                    encode () {
                        switch(arguments.length){
                            case 2:
                                return i.encodeAddress(arguments[0], arguments[1]);
                            case 4:
                                return `${i.encodeAddress(arguments[0], arguments[1])}:${i.encodeAddress(arguments[2], arguments[3])}`;
                            default:
                                throw new Error("Can only encode with 2 or 4 arguments");
                        }
                    },
                    inRange (e, t) {
                        const [r, n, , i, s] = e, [o, a] = t;
                        return o >= r && o <= i && a >= n && a <= s;
                    }
                };
                t.exports = i;
            },
            {}
        ],
        20: [
            function(e, t, r) {
                "use strict";
                const n = (e, t)=>({
                        ...e,
                        ...t.reduce((t, r)=>(e[r] && (t[r] = {
                                ...e[r]
                            }), t), {})
                    }), i = function(e, t, r) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
                    e[r] && (t[r] = n(e[r], i));
                };
                r.copyStyle = (e)=>{
                    if (!e) return e;
                    if (t = e, 0 === Object.keys(t).length) return {};
                    var t;
                    const r = {
                        ...e
                    };
                    return i(e, r, "font", [
                        "color"
                    ]), i(e, r, "alignment"), i(e, r, "protection"), e.border && (i(e, r, "border"), i(e.border, r.border, "top", [
                        "color"
                    ]), i(e.border, r.border, "left", [
                        "color"
                    ]), i(e.border, r.border, "bottom", [
                        "color"
                    ]), i(e.border, r.border, "right", [
                        "color"
                    ]), i(e.border, r.border, "diagonal", [
                        "color"
                    ])), e.fill && (i(e, r, "fill", [
                        "fgColor",
                        "bgColor",
                        "center"
                    ]), e.fill.stops && (r.fill.stops = e.fill.stops.map((e)=>n(e, [
                            "color"
                        ])))), r;
                };
            },
            {}
        ],
        21: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("crypto"), i = {
                            hash (e) {
                                const t = n.createHash(e);
                                for(var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)s[o - 1] = arguments[o];
                                return t.update(r.concat(s)), t.digest();
                            },
                            convertPasswordToHash (e, t, i, s) {
                                t = t.toLowerCase();
                                if (n.getHashes().indexOf(t) < 0) throw new Error(`Hash algorithm '${t}' not supported!`);
                                const o = r.from(e, "utf16le");
                                let a = this.hash(t, r.from(i, "base64"), o);
                                for(let e = 0; e < s; e++){
                                    const n = r.alloc(4);
                                    n.writeUInt32LE(e, 0), a = this.hash(t, a, n);
                                }
                                return a.toString("base64");
                            },
                            randomBytes: (e)=>n.randomBytes(e)
                        };
                        t.exports = i;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                crypto: 390
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                const { SaxesParser: n } = e("saxes"), { PassThrough: i } = e("readable-stream"), { bufferToString: s } = e("./browser-buffer-decode");
                t.exports = async function*(e) {
                    e.pipe && !e[Symbol.asyncIterator] && (e = e.pipe(new i));
                    const t = new n;
                    let r;
                    t.on("error", (e)=>{
                        r = e;
                    });
                    let o = [];
                    t.on("opentag", (e)=>o.push({
                            eventType: "opentag",
                            value: e
                        })), t.on("text", (e)=>o.push({
                            eventType: "text",
                            value: e
                        })), t.on("closetag", (e)=>o.push({
                            eventType: "closetag",
                            value: e
                        }));
                    for await (const n of e){
                        if (t.write(s(n)), r) throw r;
                        yield o, o = [];
                    }
                };
            },
            {
                "./browser-buffer-decode": 16,
                "readable-stream": 491,
                saxes: 496
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                const n = e("./col-cache"), i = /(([a-z_\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi, s = /^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i;
                t.exports = {
                    slideFormula: function(e, t, r) {
                        const o = n.decode(t), a = n.decode(r);
                        return e.replace(i, (e, t, r, i, l)=>{
                            if (l) return e;
                            const c = s.exec(i);
                            if (c) {
                                const r = c[1], i = c[2].toUpperCase(), s = c[3], l = c[4];
                                if (i.length > 3 || 3 === i.length && i > "XFD") return e;
                                let u = n.l2n(i), h = parseInt(l, 10);
                                r || (u += a.col - o.col), s || (h += a.row - o.row);
                                return (t || "") + (r || "") + n.n2l(u) + (s || "") + h;
                            }
                            return e;
                        });
                    }
                };
            },
            {
                "./col-cache": 19
            }
        ],
        24: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("readable-stream"), s = e("./utils"), o = e("./string-buf");
                        class a {
                            constructor(e, t){
                                this._data = e, this._encoding = t;
                            }
                            get length() {
                                return this.toBuffer().length;
                            }
                            copy(e, t, r, n) {
                                return this.toBuffer().copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = n.from(this._data, this._encoding)), this._buffer;
                            }
                        }
                        class l {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                return this._data._buf.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data.toBuffer();
                            }
                        }
                        class c {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                this._data.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data;
                            }
                        }
                        class u {
                            constructor(e){
                                this.size = e, this.buffer = n.alloc(e), this.iRead = 0, this.iWrite = 0;
                            }
                            toBuffer() {
                                if (0 === this.iRead && this.iWrite === this.size) return this.buffer;
                                const e = n.alloc(this.iWrite - this.iRead);
                                return this.buffer.copy(e, 0, this.iRead, this.iWrite), e;
                            }
                            get length() {
                                return this.iWrite - this.iRead;
                            }
                            get eod() {
                                return this.iRead === this.iWrite;
                            }
                            get full() {
                                return this.iWrite === this.size;
                            }
                            read(e) {
                                let t;
                                return 0 === e ? null : void 0 === e || e >= this.length ? (t = this.toBuffer(), this.iRead = this.iWrite, t) : (t = n.alloc(e), this.buffer.copy(t, 0, this.iRead, e), this.iRead += e, t);
                            }
                            write(e, t, r) {
                                const n = Math.min(r, this.size - this.iWrite);
                                return e.copy(this.buffer, this.iWrite, t, t + n), this.iWrite += n, n;
                            }
                        }
                        const h = function(e) {
                            e = e || {}, this.bufSize = e.bufSize || 1048576, this.buffers = [], this.batch = e.batch || !1, this.corked = !1, this.inPos = 0, this.outPos = 0, this.pipes = [], this.paused = !1, this.encoding = null;
                        };
                        s.inherits(h, i.Duplex, {
                            toBuffer () {
                                switch(this.buffers.length){
                                    case 0:
                                        return null;
                                    case 1:
                                        return this.buffers[0].toBuffer();
                                    default:
                                        return n.concat(this.buffers.map((e)=>e.toBuffer()));
                                }
                            },
                            _getWritableBuffer () {
                                if (this.buffers.length) {
                                    const e = this.buffers[this.buffers.length - 1];
                                    if (!e.full) return e;
                                }
                                const e = new u(this.bufSize);
                                return this.buffers.push(e), e;
                            },
                            async _pipe (e) {
                                await Promise.all(this.pipes.map(function(t) {
                                    return new Promise((r)=>{
                                        t.write(e.toBuffer(), ()=>{
                                            r();
                                        });
                                    });
                                }));
                            },
                            _writeToBuffers (e) {
                                let t = 0;
                                const r = e.length;
                                for(; t < r;)t += this._getWritableBuffer().write(e, t, r - t);
                            },
                            async write (e, t, i) {
                                let u;
                                if (t instanceof Function && (i = t, t = "utf8"), i = i || s.nop, e instanceof o) u = new l(e);
                                else if (e instanceof n) u = new c(e);
                                else {
                                    if (!("string" == typeof e || e instanceof String || e instanceof ArrayBuffer)) throw new Error("Chunk must be one of type String, Buffer or StringBuf.");
                                    u = new a(e, t);
                                }
                                if (this.pipes.length) {
                                    if (this.batch) for(this._writeToBuffers(u); !this.corked && this.buffers.length > 1;)this._pipe(this.buffers.shift());
                                    else this.corked ? (this._writeToBuffers(u), r.nextTick(i)) : (await this._pipe(u), i());
                                } else this.paused || this.emit("data", u.toBuffer()), this._writeToBuffers(u), this.emit("readable");
                                return !0;
                            },
                            cork () {
                                this.corked = !0;
                            },
                            _flush () {
                                if (this.pipes.length) for(; this.buffers.length;)this._pipe(this.buffers.shift());
                            },
                            uncork () {
                                this.corked = !1, this._flush();
                            },
                            end (e, t, r) {
                                const n = (e)=>{
                                    e ? r(e) : (this._flush(), this.pipes.forEach((e)=>{
                                        e.end();
                                    }), this.emit("finish"));
                                };
                                e ? this.write(e, t, n) : n();
                            },
                            read (e) {
                                let t;
                                if (e) {
                                    for(t = []; e && this.buffers.length && !this.buffers[0].eod;){
                                        const r = this.buffers[0], n = r.read(e);
                                        e -= n.length, t.push(n), r.eod && r.full && this.buffers.shift();
                                    }
                                    return n.concat(t);
                                }
                                return t = this.buffers.map((e)=>e.toBuffer()).filter(Boolean), this.buffers = [], n.concat(t);
                            },
                            setEncoding (e) {
                                this.encoding = e;
                            },
                            pause () {
                                this.paused = !0;
                            },
                            resume () {
                                this.paused = !1;
                            },
                            isPaused () {
                                return !!this.paused;
                            },
                            pipe (e) {
                                this.pipes.push(e), !this.paused && this.buffers.length && this.end();
                            },
                            unpipe (e) {
                                this.pipes = this.pipes.filter((t)=>t !== e);
                            },
                            unshift () {
                                throw new Error("Not Implemented");
                            },
                            wrap () {
                                throw new Error("Not Implemented");
                            }
                        }), t.exports = h;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "./string-buf": 25,
                "./utils": 27,
                _process: 467,
                buffer: 220,
                "readable-stream": 491
            }
        ],
        25: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = class {
                            constructor(t){
                                this._buf = e.alloc(t && t.size || 16384), this._encoding = t && t.encoding || "utf8", this._inPos = 0, this._buffer = void 0;
                            }
                            get length() {
                                return this._inPos;
                            }
                            get capacity() {
                                return this._buf.length;
                            }
                            get buffer() {
                                return this._buf;
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = e.alloc(this.length), this._buf.copy(this._buffer, 0, 0, this.length)), this._buffer;
                            }
                            reset(e) {
                                e = e || 0, this._buffer = void 0, this._inPos = e;
                            }
                            _grow(t) {
                                let r = 2 * this._buf.length;
                                for(; r < t;)r *= 2;
                                const n = e.alloc(r);
                                this._buf.copy(n, 0), this._buf = n;
                            }
                            addText(e) {
                                this._buffer = void 0;
                                let t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                for(; t >= this._buf.length - 4;)this._grow(this._inPos + e.length), t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                this._inPos = t;
                            }
                            addStringBuf(e) {
                                e.length && (this._buffer = void 0, this.length + e.length > this.capacity && this._grow(this.length + e.length), e._buf.copy(this._buf, this._inPos, 0, e.length), this._inPos += e.length);
                            }
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                const { toString: n } = Object.prototype, i = /["&<>]/, s = {
                    each: function(e, t) {
                        e && (Array.isArray(e) ? e.forEach(t) : Object.keys(e).forEach((r)=>{
                            t(e[r], r);
                        }));
                    },
                    some: function(e, t) {
                        return !!e && (Array.isArray(e) ? e.some(t) : Object.keys(e).some((r)=>t(e[r], r)));
                    },
                    every: function(e, t) {
                        return !e || (Array.isArray(e) ? e.every(t) : Object.keys(e).every((r)=>t(e[r], r)));
                    },
                    map: function(e, t) {
                        return e ? Array.isArray(e) ? e.map(t) : Object.keys(e).map((r)=>t(e[r], r)) : [];
                    },
                    keyBy: (e, t)=>e.reduce((e, r)=>(e[r[t]] = r, e), {}),
                    isEqual: function(e, t) {
                        const r = typeof e, n = typeof t, i = Array.isArray(e), o = Array.isArray(t);
                        let a;
                        if (r !== n) return !1;
                        switch(typeof e){
                            case "object":
                                if (i || o) return !(!i || !o) && e.length === t.length && e.every((e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                                if (null === e || null === t) return e === t;
                                if (a = Object.keys(e), Object.keys(t).length !== a.length) return !1;
                                for (const e of a)if (!t.hasOwnProperty(e)) return !1;
                                return s.every(e, (e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                            default:
                                return e === t;
                        }
                    },
                    escapeHtml (e) {
                        const t = i.exec(e);
                        if (!t) return e;
                        let r = "", n = "", s = 0, o = t.index;
                        for(; o < e.length; o++){
                            switch(e.charAt(o)){
                                case '"':
                                    n = "&quot;";
                                    break;
                                case "&":
                                    n = "&amp;";
                                    break;
                                case "'":
                                    n = "&apos;";
                                    break;
                                case "<":
                                    n = "&lt;";
                                    break;
                                case ">":
                                    n = "&gt;";
                                    break;
                                default:
                                    continue;
                            }
                            s !== o && (r += e.substring(s, o)), s = o + 1, r += n;
                        }
                        return s !== o ? r + e.substring(s, o) : r;
                    },
                    strcmp: (e, t)=>e < t ? -1 : e > t ? 1 : 0,
                    isUndefined: (e)=>"[object Undefined]" === n.call(e),
                    isObject: (e)=>"[object Object]" === n.call(e),
                    deepMerge () {
                        const e = arguments[0] || {}, { length: t } = arguments;
                        let r, n, i;
                        function o(t, o) {
                            r = e[o], i = Array.isArray(t), s.isObject(t) || i ? (i ? (i = !1, n = r && Array.isArray(r) ? r : []) : n = r && s.isObject(r) ? r : {}, e[o] = s.deepMerge(n, t)) : s.isUndefined(t) || (e[o] = t);
                        }
                        for(let e = 0; e < t; e++)s.each(arguments[e], o);
                        return e;
                    }
                };
                t.exports = s;
            },
            {}
        ],
        27: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = /[<>&'"\x7F\x00-\x08\x0B-\x0C\x0E-\x1F]/, o = {
                            nop () {},
                            promiseImmediate: (e)=>new Promise((t)=>{
                                    r.setImmediate ? n(()=>{
                                        t(e);
                                    }) : setTimeout(()=>{
                                        t(e);
                                    }, 1);
                                }),
                            inherits: function(e, t, r, n) {
                                e.super_ = t, n || (n = r, r = null), r && Object.keys(r).forEach((t)=>{
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                                const i = {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }
                                };
                                n && Object.keys(n).forEach((e)=>{
                                    i[e] = Object.getOwnPropertyDescriptor(n, e);
                                }), e.prototype = Object.create(t.prototype, i);
                            },
                            dateToExcel: (e, t)=>25569 + e.getTime() / 864e5 - (t ? 1462 : 0),
                            excelToDate (e, t) {
                                const r = Math.round(24 * (e - 25569 + (t ? 1462 : 0)) * 3600000);
                                return new Date(r);
                            },
                            parsePath (e) {
                                const t = e.lastIndexOf("/");
                                return {
                                    path: e.substring(0, t),
                                    name: e.substring(t + 1)
                                };
                            },
                            getRelsPath (e) {
                                const t = o.parsePath(e);
                                return `${t.path}/_rels/${t.name}.rels`;
                            },
                            xmlEncode (e) {
                                const t = s.exec(e);
                                if (!t) return e;
                                let r = "", n = "", i = 0, o = t.index;
                                for(; o < e.length; o++){
                                    const t = e.charCodeAt(o);
                                    switch(t){
                                        case 34:
                                            n = "&quot;";
                                            break;
                                        case 38:
                                            n = "&amp;";
                                            break;
                                        case 39:
                                            n = "&apos;";
                                            break;
                                        case 60:
                                            n = "&lt;";
                                            break;
                                        case 62:
                                            n = "&gt;";
                                            break;
                                        case 127:
                                            n = "";
                                            break;
                                        default:
                                            if (t <= 31 && (t <= 8 || t >= 11 && 13 !== t)) {
                                                n = "";
                                                break;
                                            }
                                            continue;
                                    }
                                    i !== o && (r += e.substring(i, o)), i = o + 1, n && (r += n);
                                }
                                return i !== o ? r + e.substring(i, o) : r;
                            },
                            xmlDecode: (e)=>e.replace(/&([a-z]*);/g, (e)=>{
                                    switch(e){
                                        case "&lt;":
                                            return "<";
                                        case "&gt;":
                                            return ">";
                                        case "&amp;":
                                            return "&";
                                        case "&apos;":
                                            return "'";
                                        case "&quot;":
                                            return '"';
                                        default:
                                            return e;
                                    }
                                }),
                            validInt (e) {
                                const t = parseInt(e, 10);
                                return Number.isNaN(t) ? 0 : t;
                            },
                            isDateFmt (e) {
                                if (!e) return !1;
                                return null !== (e = (e = e.replace(/\[[^\]]*]/g, "")).replace(/"[^"]*"/g, "")).match(/[ymdhMsb]+/);
                            },
                            fs: {
                                exists: (e)=>new Promise((t)=>{
                                        i.access(e, i.constants.F_OK, (e)=>{
                                            t(!e);
                                        });
                                    })
                            },
                            toIsoDateString: (e)=>e.toIsoString().subsstr(0, 10),
                            parseBoolean: (e)=>!0 === e || "true" === e || 1 === e || "1" === e
                        };
                        t.exports = o;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                fs: 216,
                timers: 523
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./utils");
                function s(e, t, r) {
                    e.push(` ${t}="${i.xmlEncode(r.toString())}"`);
                }
                function o(e, t) {
                    if (t) {
                        const r = [];
                        n.each(t, (e, t)=>{
                            void 0 !== e && s(r, t, e);
                        }), e.push(r.join(""));
                    }
                }
                class a {
                    constructor(){
                        this._xml = [], this._stack = [], this._rollbacks = [];
                    }
                    get tos() {
                        return this._stack.length ? this._stack[this._stack.length - 1] : void 0;
                    }
                    get cursor() {
                        return this._xml.length;
                    }
                    openXml(e) {
                        const t = this._xml;
                        t.push("<?xml"), o(t, e), t.push("?>\n");
                    }
                    openNode(e, t) {
                        const r = this.tos, n = this._xml;
                        r && this.open && n.push(">"), this._stack.push(e), n.push("<"), n.push(e), o(n, t), this.leaf = !0, this.open = !0;
                    }
                    addAttribute(e, t) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        void 0 !== t && s(this._xml, e, t);
                    }
                    addAttributes(e) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        o(this._xml, e);
                    }
                    writeText(e) {
                        const t = this._xml;
                        this.open && (t.push(">"), this.open = !1), this.leaf = !1, t.push(i.xmlEncode(e.toString()));
                    }
                    writeXml(e) {
                        this.open && (this._xml.push(">"), this.open = !1), this.leaf = !1, this._xml.push(e);
                    }
                    closeNode() {
                        const e = this._stack.pop(), t = this._xml;
                        this.leaf ? t.push("/>") : (t.push("</"), t.push(e), t.push(">")), this.open = !1, this.leaf = !1;
                    }
                    leafNode(e, t, r) {
                        this.openNode(e, t), void 0 !== r && this.writeText(r), this.closeNode();
                    }
                    closeAll() {
                        for(; this._stack.length;)this.closeNode();
                    }
                    addRollback() {
                        return this._rollbacks.push({
                            xml: this._xml.length,
                            stack: this._stack.length,
                            leaf: this.leaf,
                            open: this.open
                        }), this.cursor;
                    }
                    commit() {
                        this._rollbacks.pop();
                    }
                    rollback() {
                        const e = this._rollbacks.pop();
                        this._xml.length > e.xml && this._xml.splice(e.xml, this._xml.length - e.xml), this._stack.length > e.stack && this._stack.splice(e.stack, this._stack.length - e.stack), this.leaf = e.leaf, this.open = e.open;
                    }
                    get xml() {
                        return this.closeAll(), this._xml.join("");
                    }
                }
                a.StdDocAttributes = {
                    version: "1.0",
                    encoding: "UTF-8",
                    standalone: "yes"
                }, t.exports = a;
            },
            {
                "./under-dash": 26,
                "./utils": 27
            }
        ],
        29: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("events"), i = e("jszip"), s = e("./stream-buf"), { stringToBuffer: o } = e("./browser-buffer-encode");
                        class a extends n.EventEmitter {
                            constructor(e){
                                super(), this.options = Object.assign({
                                    type: "nodebuffer",
                                    compression: "DEFLATE"
                                }, e), this.zip = new i, this.stream = new s;
                            }
                            append(e, t) {
                                t.hasOwnProperty("base64") && t.base64 ? this.zip.file(t.name, e, {
                                    base64: !0
                                }) : (r.browser && "string" == typeof e && (e = o(e)), this.zip.file(t.name, e));
                            }
                            async finalize() {
                                const e = await this.zip.generateAsync(this.options);
                                this.stream.end(e), this.emit("finish");
                            }
                            read(e) {
                                return this.stream.read(e);
                            }
                            setEncoding(e) {
                                return this.stream.setEncoding(e);
                            }
                            pause() {
                                return this.stream.pause();
                            }
                            resume() {
                                return this.stream.resume();
                            }
                            isPaused() {
                                return this.stream.isPaused();
                            }
                            pipe(e, t) {
                                return this.stream.pipe(e, t);
                            }
                            unpipe(e) {
                                return this.stream.unpipe(e);
                            }
                            unshift(e) {
                                return this.stream.unshift(e);
                            }
                            wrap(e) {
                                return this.stream.wrap(e);
                            }
                        }
                        t.exports = {
                            ZipWriter: a
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./browser-buffer-encode": 17,
                "./stream-buf": 24,
                _process: 467,
                events: 422,
                jszip: 441
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    0: {
                        f: "General"
                    },
                    1: {
                        f: "0"
                    },
                    2: {
                        f: "0.00"
                    },
                    3: {
                        f: "#,##0"
                    },
                    4: {
                        f: "#,##0.00"
                    },
                    9: {
                        f: "0%"
                    },
                    10: {
                        f: "0.00%"
                    },
                    11: {
                        f: "0.00E+00"
                    },
                    12: {
                        f: "# ?/?"
                    },
                    13: {
                        f: "# ??/??"
                    },
                    14: {
                        f: "mm-dd-yy"
                    },
                    15: {
                        f: "d-mmm-yy"
                    },
                    16: {
                        f: "d-mmm"
                    },
                    17: {
                        f: "mmm-yy"
                    },
                    18: {
                        f: "h:mm AM/PM"
                    },
                    19: {
                        f: "h:mm:ss AM/PM"
                    },
                    20: {
                        f: "h:mm"
                    },
                    21: {
                        f: "h:mm:ss"
                    },
                    22: {
                        f: 'm/d/yy "h":mm'
                    },
                    27: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    28: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    29: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    30: {
                        "zh-tw": "m/d/yy ",
                        "zh-cn": "m-d-yy",
                        "ja-jp": "m/d/yy",
                        "ko-kr": "mm-dd-yy"
                    },
                    31: {
                        "zh-tw": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": 'yyyy"\ub144" mm"\uc6d4" dd"\uc77c"'
                    },
                    32: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"',
                        "ja-jp": 'h"\u6642"mm"\u5206"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84"'
                    },
                    33: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'h"\u6642"mm"\u5206"ss"\u79d2"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84" ss"\ucd08"'
                    },
                    34: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    35: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    36: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    37: {
                        f: "#,##0 ;(#,##0)"
                    },
                    38: {
                        f: "#,##0 ;[Red](#,##0)"
                    },
                    39: {
                        f: "#,##0.00 ;(#,##0.00)"
                    },
                    40: {
                        f: "#,##0.00 ;[Red](#,##0.00)"
                    },
                    45: {
                        f: "mm:ss"
                    },
                    46: {
                        f: "[h]:mm:ss"
                    },
                    47: {
                        f: "mmss.0"
                    },
                    48: {
                        f: "##0.0E+0"
                    },
                    49: {
                        f: "@"
                    },
                    50: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    51: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    52: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    53: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    54: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    55: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    56: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    57: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    58: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    59: {
                        "th-th": "t0"
                    },
                    60: {
                        "th-th": "t0.00"
                    },
                    61: {
                        "th-th": "t#,##0"
                    },
                    62: {
                        "th-th": "t#,##0.00"
                    },
                    67: {
                        "th-th": "t0%"
                    },
                    68: {
                        "th-th": "t0.00%"
                    },
                    69: {
                        "th-th": "t# ?/?"
                    },
                    70: {
                        "th-th": "t# ??/??"
                    },
                    81: {
                        "th-th": "d/m/bb"
                    }
                };
            },
            {}
        ],
        31: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    OfficeDocument: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                    Worksheet: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                    CalcChain: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain",
                    SharedStrings: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                    Styles: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                    Theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                    Hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                    Image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                    CoreProperties: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                    ExtenderProperties: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
                    Comments: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
                    VmlDrawing: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                    Table: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table"
                };
            },
            {}
        ],
        32: [
            function(e, t, r) {
                "use strict";
                const n = e("../../utils/parse-sax"), i = e("../../utils/xml-stream");
                class s {
                    prepare() {}
                    render() {}
                    parseOpen(e) {}
                    parseText(e) {}
                    parseClose(e) {}
                    reconcile(e, t) {}
                    reset() {
                        this.model = null, this.map && Object.values(this.map).forEach((e)=>{
                            e instanceof s ? e.reset() : e.xform && e.xform.reset();
                        });
                    }
                    mergeModel(e) {
                        this.model = Object.assign(this.model || {}, e);
                    }
                    async parse(e) {
                        for await (const t of e)for (const { eventType: e, value: r } of t)if ("opentag" === e) this.parseOpen(r);
                        else if ("text" === e) this.parseText(r);
                        else if ("closetag" === e && !this.parseClose(r.name)) return this.model;
                        return this.model;
                    }
                    async parseStream(e) {
                        return this.parse(n(e));
                    }
                    get xml() {
                        return this.toXml(this.model);
                    }
                    toXml(e) {
                        const t = new i;
                        return this.render(t, e), t.xml;
                    }
                    static toAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e.toString();
                    }
                    static toStringAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toStringValue(e, t) {
                        return void 0 === e ? t : e;
                    }
                    static toBoolAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e ? "1" : "0";
                    }
                    static toBoolValue(e, t) {
                        return void 0 === e ? t : "1" === e;
                    }
                    static toIntAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toIntValue(e, t) {
                        return void 0 === e ? t : parseInt(e, 10);
                    }
                    static toFloatAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toFloatValue(e, t) {
                        return void 0 === e ? t : parseFloat(e);
                    }
                }
                t.exports = s;
            },
            {
                "../../utils/parse-sax": 22,
                "../../utils/xml-stream": 28
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/col-cache");
                function s(e) {
                    try {
                        return i.decodeEx(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function o(e) {
                    const t = [];
                    let r = !1, n = "";
                    return e.split(",").forEach((e)=>{
                        if (!e) return;
                        const i = (e.match(/'/g) || []).length;
                        if (!i) return void (r ? n += e + "," : s(e) && t.push(e));
                        const o = i % 2 == 0;
                        !r && o && s(e) ? t.push(e) : r && !o ? (r = !1, s(n + e) && t.push(n + e), n = "") : (r = !0, n += e + ",");
                    }), t;
                }
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("definedName", {
                            name: t.name,
                            localSheetId: t.localSheetId
                        }), e.writeText(t.ranges.join(",")), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "definedName":
                                return this._parsedName = e.attributes.name, this._parsedLocalSheetId = e.attributes.localSheetId, this._parsedText = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._parsedText.push(e);
                    }
                    parseClose() {
                        return this.model = {
                            name: this._parsedName,
                            ranges: o(this._parsedText.join(""))
                        }, void 0 !== this._parsedLocalSheetId && (this.model.localSheetId = parseInt(this._parsedLocalSheetId, 10)), !1;
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    render(e, t) {
                        e.leafNode("sheet", {
                            sheetId: t.id,
                            name: t.name,
                            state: t.state,
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        return "sheet" === e.name && (this.model = {
                            name: n.xmlDecode(e.attributes.name),
                            id: parseInt(e.attributes.sheetId, 10),
                            state: e.attributes.state,
                            rId: e.attributes["r:id"]
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("calcPr", {
                            calcId: 171027,
                            fullCalcOnLoad: t.fullCalcOnLoad ? 1 : void 0
                        });
                    }
                    parseOpen(e) {
                        return "calcPr" === e.name && (this.model = {}, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        36: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("workbookPr", {
                            date1904: t.date1904 ? 1 : void 0,
                            defaultThemeVersion: 164011,
                            filterPrivacy: 1
                        });
                    }
                    parseOpen(e) {
                        return "workbookPr" === e.name && (this.model = {
                            date1904: "1" === e.attributes.date1904
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        37: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        const r = {
                            xWindow: t.x || 0,
                            yWindow: t.y || 0,
                            windowWidth: t.width || 12e3,
                            windowHeight: t.height || 24e3,
                            firstSheet: t.firstSheet,
                            activeTab: t.activeTab
                        };
                        t.visibility && "visible" !== t.visibility && (r.visibility = t.visibility), e.leafNode("workbookView", r);
                    }
                    parseOpen(e) {
                        if ("workbookView" === e.name) {
                            const t = this.model = {}, r = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = r : n;
                                void 0 !== i && (t[e] = i);
                            }, n = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = parseInt(r, 10) : n;
                                void 0 !== i && (t[e] = i);
                            };
                            return n("x", e.attributes.xWindow, 0), n("y", e.attributes.yWindow, 0), n("width", e.attributes.windowWidth, 25e3), n("height", e.attributes.windowHeight, 1e4), r("visibility", e.attributes.visibility, "visible"), n("activeTab", e.attributes.activeTab, void 0), n("firstSheet", e.attributes.firstSheet, void 0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../base-xform"), a = e("../static-xform"), l = e("../list-xform"), c = e("./defined-name-xform"), u = e("./sheet-xform"), h = e("./workbook-view-xform"), f = e("./workbook-properties-xform"), d = e("./workbook-calc-properties-xform");
                class p extends o {
                    constructor(){
                        super(), this.map = {
                            fileVersion: p.STATIC_XFORMS.fileVersion,
                            workbookPr: new f,
                            bookViews: new l({
                                tag: "bookViews",
                                count: !1,
                                childXform: new h
                            }),
                            sheets: new l({
                                tag: "sheets",
                                count: !1,
                                childXform: new u
                            }),
                            definedNames: new l({
                                tag: "definedNames",
                                count: !1,
                                childXform: new c
                            }),
                            calcPr: new d
                        };
                    }
                    prepare(e) {
                        e.sheets = e.worksheets;
                        const t = [];
                        let r = 0;
                        e.sheets.forEach((e)=>{
                            if (e.pageSetup && e.pageSetup.printArea && e.pageSetup.printArea.split("&&").forEach((n)=>{
                                const i = n.split(":"), s = {
                                    name: "_xlnm.Print_Area",
                                    ranges: [
                                        `'${e.name}'!$${i[0]}:$${i[1]}`
                                    ],
                                    localSheetId: r
                                };
                                t.push(s);
                            }), e.pageSetup && (e.pageSetup.printTitlesRow || e.pageSetup.printTitlesColumn)) {
                                const n = [];
                                if (e.pageSetup.printTitlesColumn) {
                                    const t = e.pageSetup.printTitlesColumn.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                if (e.pageSetup.printTitlesRow) {
                                    const t = e.pageSetup.printTitlesRow.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                const i = {
                                    name: "_xlnm.Print_Titles",
                                    ranges: n,
                                    localSheetId: r
                                };
                                t.push(i);
                            }
                            r++;
                        }), t.length && (e.definedNames = e.definedNames.concat(t)), (e.media || []).forEach((e, t)=>{
                            e.name = e.type + (t + 1);
                        });
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("workbook", p.WORKBOOK_ATTRIBUTES), this.map.fileVersion.render(e), this.map.workbookPr.render(e, t.properties), this.map.bookViews.render(e, t.views), this.map.sheets.render(e, t.sheets), this.map.definedNames.render(e, t.definedNames), this.map.calcPr.render(e, t.calcProperties), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "workbook":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "workbook":
                                return this.model = {
                                    sheets: this.map.sheets.model,
                                    properties: this.map.workbookPr.model || {},
                                    views: this.map.bookViews.model,
                                    calcProperties: {}
                                }, this.map.definedNames.model && (this.model.definedNames = this.map.definedNames.model), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e) {
                        const t = (e.workbookRels || []).reduce((e, t)=>(e[t.Id] = t, e), {}), r = [];
                        let s, o = 0;
                        (e.sheets || []).forEach((n)=>{
                            const i = t[n.rId];
                            i && (s = e.worksheetHash["xl/" + i.Target.replace(/^(\s|\/xl\/)+/, "")], s && (s.name = n.name, s.id = n.id, s.state = n.state, r[o++] = s));
                        });
                        const a = [];
                        n.each(e.definedNames, (e)=>{
                            if ("_xlnm.Print_Area" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = i.decodeEx(e.ranges[0]);
                                    s.pageSetup.printArea = s.pageSetup.printArea ? `${s.pageSetup.printArea}&&${t.dimensions}` : t.dimensions;
                                }
                            } else if ("_xlnm.Print_Titles" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = e.ranges.join(","), r = /\$/g, n = /\$\d+:\$\d+/, i = t.match(n);
                                    if (i && i.length) {
                                        const e = i[0];
                                        s.pageSetup.printTitlesRow = e.replace(r, "");
                                    }
                                    const o = /\$[A-Z]+:\$[A-Z]+/, a = t.match(o);
                                    if (a && a.length) {
                                        const e = a[0];
                                        s.pageSetup.printTitlesColumn = e.replace(r, "");
                                    }
                                }
                            } else a.push(e);
                        }), e.definedNames = a, e.media.forEach((e, t)=>{
                            e.index = t;
                        });
                    }
                }
                p.WORKBOOK_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x15",
                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                }, p.STATIC_XFORMS = {
                    fileVersion: new a({
                        tag: "fileVersion",
                        $: {
                            appName: "xl",
                            lastEdited: 5,
                            lowestEdited: 5,
                            rupBuild: 9303
                        }
                    })
                }, t.exports = p;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./defined-name-xform": 33,
                "./sheet-xform": 34,
                "./workbook-calc-properties-xform": 35,
                "./workbook-properties-xform": 36,
                "./workbook-view-xform": 37
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                const n = e("../strings/rich-text-xform"), i = e("../../../utils/utils"), s = e("../base-xform"), o = t.exports = function(e) {
                    this.model = e;
                };
                i.inherits(o, s, {
                    get tag () {
                        return "r";
                    },
                    get richTextXform () {
                        return this._richTextXform || (this._richTextXform = new n), this._richTextXform;
                    },
                    render (e, t) {
                        t = t || this.model, e.openNode("comment", {
                            ref: t.ref,
                            authorId: 0
                        }), e.openNode("text"), t && t.note && t.note.texts && t.note.texts.forEach((t)=>{
                            this.richTextXform.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "comment":
                                return this.model = {
                                    type: "note",
                                    note: {
                                        texts: []
                                    },
                                    ...e.attributes
                                }, !0;
                            case "r":
                                return this.parser = this.richTextXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "comment":
                                return !1;
                            case "r":
                                return this.model.note.texts.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../../../utils/utils"), s = e("../base-xform"), o = e("./comment-xform"), a = t.exports = function() {
                    this.map = {
                        comment: new o
                    };
                };
                i.inherits(a, s, {
                    COMMENTS_ATTRIBUTES: {
                        xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                    }
                }, {
                    render (e, t) {
                        t = t || this.model, e.openXml(n.StdDocAttributes), e.openNode("comments", a.COMMENTS_ATTRIBUTES), e.openNode("authors"), e.leafNode("author", null, "Author"), e.closeNode(), e.openNode("commentList"), t.comments.forEach((t)=>{
                            this.map.comment.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "commentList":
                                return this.model = {
                                    comments: []
                                }, !0;
                            case "comment":
                                return this.parser = this.map.comment, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "commentList":
                                return !1;
                            case "comment":
                                return this.model.comments.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./comment-xform": 39
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t, r) {
                        (t === r[2] || "x:SizeWithCells" === this.tag && t === r[1]) && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {}, this.model[this.tag] = !0, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        42: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x:Anchor";
                    }
                    getAnchorRect(e) {
                        const t = Math.floor(e.left), r = Math.floor(68 * (e.left - t)), n = Math.floor(e.top), i = Math.floor(18 * (e.top - n)), s = Math.floor(e.right), o = Math.floor(68 * (e.right - s)), a = Math.floor(e.bottom);
                        return [
                            t,
                            r,
                            n,
                            i,
                            s,
                            o,
                            a,
                            Math.floor(18 * (e.bottom - a))
                        ];
                    }
                    getDefaultRect(e) {
                        const t = e.col, r = Math.max(e.row - 2, 0);
                        return [
                            t,
                            6,
                            r,
                            14,
                            t + 2,
                            2,
                            r + 4,
                            16
                        ];
                    }
                    render(e, t) {
                        const r = t.anchor ? this.getAnchorRect(t.anchor) : this.getDefaultRect(t.refAddress);
                        e.leafNode("x:Anchor", null, r.join(", "));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        44: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-anchor-xform"), s = e("./style/vml-protection-xform"), o = e("./style/vml-position-xform"), a = [
                    "twoCells",
                    "oneCells",
                    "absolute"
                ];
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x:Anchor": new i,
                            "x:Locked": new s({
                                tag: "x:Locked"
                            }),
                            "x:LockText": new s({
                                tag: "x:LockText"
                            }),
                            "x:SizeWithCells": new o({
                                tag: "x:SizeWithCells"
                            }),
                            "x:MoveWithCells": new o({
                                tag: "x:MoveWithCells"
                            })
                        };
                    }
                    get tag() {
                        return "x:ClientData";
                    }
                    render(e, t) {
                        const { protection: r, editAs: n } = t.note;
                        e.openNode(this.tag, {
                            ObjectType: "Note"
                        }), this.map["x:MoveWithCells"].render(e, n, a), this.map["x:SizeWithCells"].render(e, n, a), this.map["x:Anchor"].render(e, t), this.map["x:Locked"].render(e, r.locked), e.leafNode("x:AutoFill", null, "False"), this.map["x:LockText"].render(e, r.lockText), e.leafNode("x:Row", null, t.refAddress.row - 1), e.leafNode("x:Column", null, t.refAddress.col - 1), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchor: [],
                                    protection: {},
                                    editAs: ""
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.normalizeModel(), !1;
                            default:
                                return !0;
                        }
                    }
                    normalizeModel() {
                        const e = Object.assign({}, this.map["x:MoveWithCells"].model, this.map["x:SizeWithCells"].model), t = Object.keys(e).length;
                        this.model.editAs = a[t], this.model.anchor = this.map["x:Anchor"].text, this.model.protection.locked = this.map["x:Locked"].text, this.model.protection.lockText = this.map["x:LockText"].text;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./style/vml-position-xform": 41,
                "./style/vml-protection-xform": 42,
                "./vml-anchor-xform": 43
            }
        ],
        45: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./vml-shape-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "v:shape": new s
                        };
                    }
                    get tag() {
                        return "xml";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, o.DRAWING_ATTRIBUTES), e.openNode("o:shapelayout", {
                            "v:ext": "edit"
                        }), e.leafNode("o:idmap", {
                            "v:ext": "edit",
                            data: 1
                        }), e.closeNode(), e.openNode("v:shapetype", {
                            id: "_x0000_t202",
                            coordsize: "21600,21600",
                            "o:spt": 202,
                            path: "m,l,21600r21600,l21600,xe"
                        }), e.leafNode("v:stroke", {
                            joinstyle: "miter"
                        }), e.leafNode("v:path", {
                            gradientshapeok: "t",
                            "o:connecttype": "rect"
                        }), e.closeNode(), t.comments.forEach((t, r)=>{
                            this.map["v:shape"].render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    comments: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.comments.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                o.DRAWING_ATTRIBUTES = {
                    "xmlns:v": "urn:schemas-microsoft-com:vml",
                    "xmlns:o": "urn:schemas-microsoft-com:office:office",
                    "xmlns:x": "urn:schemas-microsoft-com:office:excel"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./vml-shape-xform": 46
            }
        ],
        46: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-textbox-xform"), s = e("./vml-client-data-xform");
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            "v:textbox": new i,
                            "x:ClientData": new s
                        };
                    }
                    get tag() {
                        return "v:shape";
                    }
                    render(e, t, r) {
                        e.openNode("v:shape", o.V_SHAPE_ATTRIBUTES(t, r)), e.leafNode("v:fill", {
                            color2: "infoBackground [80]"
                        }), e.leafNode("v:shadow", {
                            color: "none [81]",
                            obscured: "t"
                        }), e.leafNode("v:path", {
                            "o:connecttype": "none"
                        }), this.map["v:textbox"].render(e, t), this.map["x:ClientData"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    margins: {
                                        insetmode: e.attributes["o:insetmode"]
                                    },
                                    anchor: "",
                                    editAs: "",
                                    protection: {}
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.margins.inset = this.map["v:textbox"].model && this.map["v:textbox"].model.inset, this.model.protection = this.map["x:ClientData"].model && this.map["x:ClientData"].model.protection, this.model.anchor = this.map["x:ClientData"].model && this.map["x:ClientData"].model.anchor, this.model.editAs = this.map["x:ClientData"].model && this.map["x:ClientData"].model.editAs, !1;
                            default:
                                return !0;
                        }
                    }
                }
                o.V_SHAPE_ATTRIBUTES = (e, t)=>({
                        id: "_x0000_s" + (1025 + t),
                        type: "#_x0000_t202",
                        style: "position:absolute; margin-left:105.3pt;margin-top:10.5pt;width:97.8pt;height:59.1pt;z-index:1;visibility:hidden",
                        fillcolor: "infoBackground [80]",
                        strokecolor: "none [81]",
                        "o:insetmode": e.note.margins && e.note.margins.insetmode
                    }), t.exports = o;
            },
            {
                "../base-xform": 32,
                "./vml-client-data-xform": 44,
                "./vml-textbox-xform": 47
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "v:textbox";
                    }
                    conversionUnit(e, t, r) {
                        return `${parseFloat(e) * t.toFixed(2)}${r}`;
                    }
                    reverseConversionUnit(e) {
                        return (e || "").split(",").map((e)=>Number(parseFloat(this.conversionUnit(parseFloat(e), .1, "")).toFixed(2)));
                    }
                    render(e, t) {
                        const r = {
                            style: "mso-direction-alt:auto"
                        };
                        if (t && t.note) {
                            let { inset: e } = t.note && t.note.margins;
                            Array.isArray(e) && (e = e.map((e)=>this.conversionUnit(e, 10, "mm")).join(",")), e && (r.inset = e);
                        }
                        e.openNode("v:textbox", r), e.leafNode("div", {
                            style: "text-align:left"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    inset: this.reverseConversionUnit(e.attributes.inset)
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        48: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    createNewModel(e) {
                        return {};
                    }
                    parseOpen(e) {
                        return this.parser = this.parser || this.map[e.name], this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag && (this.model = this.createNewModel(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.onParserClose(e, this.parser), this.parser = void 0), !0) : e !== this.tag;
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        49: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("HeadingPairs"), e.openNode("vt:vector", {
                            size: 2,
                            baseType: "variant"
                        }), e.openNode("vt:variant"), e.leafNode("vt:lpstr", void 0, "Worksheets"), e.closeNode(), e.openNode("vt:variant"), e.leafNode("vt:i4", void 0, t.length), e.closeNode(), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "HeadingPairs" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "HeadingPairs" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("TitlesOfParts"), e.openNode("vt:vector", {
                            size: t.length,
                            baseType: "lpstr"
                        }), t.forEach((t)=>{
                            e.leafNode("vt:lpstr", void 0, t.name);
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "TitlesOfParts" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "TitlesOfParts" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/string-xform"), o = e("./app-heading-pairs-xform"), a = e("./app-titles-of-parts-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            Company: new s({
                                tag: "Company"
                            }),
                            Manager: new s({
                                tag: "Manager"
                            }),
                            HeadingPairs: new o,
                            TitleOfParts: new a
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Properties", l.PROPERTY_ATTRIBUTES), e.leafNode("Application", void 0, "Microsoft Excel"), e.leafNode("DocSecurity", void 0, "0"), e.leafNode("ScaleCrop", void 0, "false"), this.map.HeadingPairs.render(e, t.worksheets), this.map.TitleOfParts.render(e, t.worksheets), this.map.Company.render(e, t.company || ""), this.map.Manager.render(e, t.manager), e.leafNode("LinksUpToDate", void 0, "false"), e.leafNode("SharedDoc", void 0, "false"), e.leafNode("HyperlinksChanged", void 0, "false"), e.leafNode("AppVersion", void 0, "16.0300"), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Properties":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "Properties":
                                return this.model = {
                                    worksheets: this.map.TitleOfParts.model,
                                    company: this.map.Company.model,
                                    manager: this.map.Manager.model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3,6}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
                    "xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/string-xform": 119,
                "./app-heading-pairs-xform": 49,
                "./app-titles-of-parts-xform": 50
            }
        ],
        52: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform");
                class s extends i {
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Types", s.PROPERTY_ATTRIBUTES);
                        const r = {};
                        (t.media || []).forEach((t)=>{
                            if ("image" === t.type) {
                                const n = t.extension;
                                r[n] || (r[n] = !0, e.leafNode("Default", {
                                    Extension: n,
                                    ContentType: "image/" + n
                                }));
                            }
                        }), e.leafNode("Default", {
                            Extension: "rels",
                            ContentType: "application/vnd.openxmlformats-package.relationships+xml"
                        }), e.leafNode("Default", {
                            Extension: "xml",
                            ContentType: "application/xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/workbook.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                        }), t.worksheets.forEach((t)=>{
                            const r = `/xl/worksheets/sheet${t.id}.xml`;
                            e.leafNode("Override", {
                                PartName: r,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                            });
                        }), e.leafNode("Override", {
                            PartName: "/xl/theme/theme1.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.theme+xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/styles.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                        });
                        t.sharedStrings && t.sharedStrings.count && e.leafNode("Override", {
                            PartName: "/xl/sharedStrings.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                        }), t.tables && t.tables.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: "/xl/tables/" + t.target,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"
                            });
                        }), t.drawings && t.drawings.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: `/xl/drawings/${t.name}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml"
                            });
                        }), t.commentRefs && (e.leafNode("Default", {
                            Extension: "vml",
                            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
                        }), t.commentRefs.forEach((t)=>{
                            let { commentName: r } = t;
                            e.leafNode("Override", {
                                PartName: `/xl/${r}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                            });
                        })), e.leafNode("Override", {
                            PartName: "/docProps/core.xml",
                            ContentType: "application/vnd.openxmlformats-package.core-properties+xml"
                        }), e.leafNode("Override", {
                            PartName: "/docProps/app.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
                        }), e.closeNode();
                    }
                    parseOpen() {
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                s.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }, t.exports = s;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/date-xform"), o = e("../simple/string-xform"), a = e("../simple/integer-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            "dc:creator": new o({
                                tag: "dc:creator"
                            }),
                            "dc:title": new o({
                                tag: "dc:title"
                            }),
                            "dc:subject": new o({
                                tag: "dc:subject"
                            }),
                            "dc:description": new o({
                                tag: "dc:description"
                            }),
                            "dc:identifier": new o({
                                tag: "dc:identifier"
                            }),
                            "dc:language": new o({
                                tag: "dc:language"
                            }),
                            "cp:keywords": new o({
                                tag: "cp:keywords"
                            }),
                            "cp:category": new o({
                                tag: "cp:category"
                            }),
                            "cp:lastModifiedBy": new o({
                                tag: "cp:lastModifiedBy"
                            }),
                            "cp:lastPrinted": new s({
                                tag: "cp:lastPrinted",
                                format: l.DateFormat
                            }),
                            "cp:revision": new a({
                                tag: "cp:revision"
                            }),
                            "cp:version": new o({
                                tag: "cp:version"
                            }),
                            "cp:contentStatus": new o({
                                tag: "cp:contentStatus"
                            }),
                            "cp:contentType": new o({
                                tag: "cp:contentType"
                            }),
                            "dcterms:created": new s({
                                tag: "dcterms:created",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            }),
                            "dcterms:modified": new s({
                                tag: "dcterms:modified",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            })
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("cp:coreProperties", l.CORE_PROPERTY_ATTRIBUTES), this.map["dc:creator"].render(e, t.creator), this.map["dc:title"].render(e, t.title), this.map["dc:subject"].render(e, t.subject), this.map["dc:description"].render(e, t.description), this.map["dc:identifier"].render(e, t.identifier), this.map["dc:language"].render(e, t.language), this.map["cp:keywords"].render(e, t.keywords), this.map["cp:category"].render(e, t.category), this.map["cp:lastModifiedBy"].render(e, t.lastModifiedBy), this.map["cp:lastPrinted"].render(e, t.lastPrinted), this.map["cp:revision"].render(e, t.revision), this.map["cp:version"].render(e, t.version), this.map["cp:contentStatus"].render(e, t.contentStatus), this.map["cp:contentType"].render(e, t.contentType), this.map["dcterms:created"].render(e, t.created), this.map["dcterms:modified"].render(e, t.modified), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return this.model = {
                                    creator: this.map["dc:creator"].model,
                                    title: this.map["dc:title"].model,
                                    subject: this.map["dc:subject"].model,
                                    description: this.map["dc:description"].model,
                                    identifier: this.map["dc:identifier"].model,
                                    language: this.map["dc:language"].model,
                                    keywords: this.map["cp:keywords"].model,
                                    category: this.map["cp:category"].model,
                                    lastModifiedBy: this.map["cp:lastModifiedBy"].model,
                                    lastPrinted: this.map["cp:lastPrinted"].model,
                                    revision: this.map["cp:revision"].model,
                                    contentStatus: this.map["cp:contentStatus"].model,
                                    contentType: this.map["cp:contentType"].model,
                                    created: this.map["dcterms:created"].model,
                                    modified: this.map["dcterms:modified"].model
                                }, !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.CORE_PROPERTY_ATTRIBUTES = {
                    "xmlns:cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                    "xmlns:dcterms": "http://purl.org/dc/terms/",
                    "xmlns:dcmitype": "http://purl.org/dc/dcmitype/",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/date-xform": 117,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119
            }
        ],
        54: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("Relationship", t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "Relationship":
                                return this.model = e.attributes, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        55: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./relationship-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            Relationship: new s
                        };
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("Relationships", o.RELATIONSHIPS_ATTRIBUTES), t.forEach((t)=>{
                            this.map.Relationship.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Relationships":
                                return this.model = [], !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case "Relationships":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                o.RELATIONSHIPS_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./relationship-xform": 54
            }
        ],
        56: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    range: {
                                        editAs: e.attributes.editAs || "oneCell"
                                    }
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    reconcilePicture(e, t) {
                        if (e && e.rId) {
                            const r = t.rels[e.rId].Target.match(/.*\/media\/(.+[.][a-zA-Z]{3,4})/);
                            if (r) {
                                const e = r[1], n = t.mediaIndex[e];
                                return t.media[n];
                            }
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        57: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./blip-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:blip": new i
                        };
                    }
                    get tag() {
                        return "xdr:blipFill";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["a:blip"].render(e, t), e.openNode("a:stretch"), e.leafNode("a:fillRect"), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:blip"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./blip-xform": 58
            }
        ],
        58: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:blip";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:embed": t.rId,
                            cstate: "print"
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:embed"]
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        59: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xdr:cNvPicPr";
                    }
                    render(e) {
                        e.openNode(this.tag), e.leafNode("a:picLocks", {
                            noChangeAspect: "1"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        60: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./hlink-click-xform"), s = e("./ext-lst-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:hlinkClick": new i,
                            "a:extLst": new s
                        };
                    }
                    get tag() {
                        return "xdr:cNvPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            id: t.index,
                            name: "Picture " + t.index
                        }), this.map["a:hlinkClick"].render(e, t), this.map["a:extLst"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:hlinkClick"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./ext-lst-xform": 63,
                "./hlink-click-xform": 65
            }
        ],
        61: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../simple/integer-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {
                            "xdr:col": new i({
                                tag: "xdr:col",
                                zero: !0
                            }),
                            "xdr:colOff": new i({
                                tag: "xdr:colOff",
                                zero: !0
                            }),
                            "xdr:row": new i({
                                tag: "xdr:row",
                                zero: !0
                            }),
                            "xdr:rowOff": new i({
                                tag: "xdr:rowOff",
                                zero: !0
                            })
                        };
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:col"].render(e, t.nativeCol), this.map["xdr:colOff"].render(e, t.nativeColOff), this.map["xdr:row"].render(e, t.nativeRow), this.map["xdr:rowOff"].render(e, t.nativeRowOff), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = {
                                    nativeCol: this.map["xdr:col"].model,
                                    nativeColOff: this.map["xdr:colOff"].model,
                                    nativeRow: this.map["xdr:row"].model,
                                    nativeRowOff: this.map["xdr:rowOff"].model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../simple/integer-xform": 118
            }
        ],
        62: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("./two-cell-anchor-xform"), a = e("./one-cell-anchor-xform");
                class l extends s {
                    constructor(){
                        super(), this.map = {
                            "xdr:twoCellAnchor": new o,
                            "xdr:oneCellAnchor": new a
                        };
                    }
                    prepare(e) {
                        e.anchors.forEach((e, t)=>{
                            e.anchorType = function(e) {
                                return ("string" == typeof e.range ? n.decode(e.range) : e.range).br ? "xdr:twoCellAnchor" : "xdr:oneCellAnchor";
                            }(e);
                            this.map[e.anchorType].prepare(e, {
                                index: t
                            });
                        });
                    }
                    get tag() {
                        return "xdr:wsDr";
                    }
                    render(e, t) {
                        e.openXml(i.StdDocAttributes), e.openNode(this.tag, l.DRAWING_ATTRIBUTES), t.anchors.forEach((t)=>{
                            this.map[t.anchorType].render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchors: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.anchors.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                l.DRAWING_ATTRIBUTES = {
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing",
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main"
                }, t.exports = l;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./one-cell-anchor-xform": 67,
                "./two-cell-anchor-xform": 70
            }
        ],
        63: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:extLst";
                    }
                    render(e) {
                        e.openNode(this.tag), e.openNode("a:ext", {
                            uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                        }), e.leafNode("a16:creationId", {
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main",
                            id: "{00000000-0008-0000-0000-000002000000}"
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        64: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {};
                    }
                    render(e, t) {
                        e.openNode(this.tag);
                        const r = Math.floor(9525 * t.width), n = Math.floor(9525 * t.height);
                        e.addAttribute("cx", r), e.addAttribute("cy", n), e.closeNode();
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            width: parseInt(e.attributes.cx || "0", 10) / 9525,
                            height: parseInt(e.attributes.cy || "0", 10) / 9525
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        65: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:hlinkClick";
                    }
                    render(e, t) {
                        t.hyperlinks && t.hyperlinks.rId && e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:id": t.hyperlinks.rId,
                            tooltip: t.hyperlinks.tooltip
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    hyperlinks: {
                                        rId: e.attributes["r:id"],
                                        tooltip: e.attributes.tooltip
                                    }
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        66: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./c-nv-pr-xform"), s = e("./c-nv-pic-pr-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:cNvPr": new i,
                            "xdr:cNvPicPr": new s
                        };
                    }
                    get tag() {
                        return "xdr:nvPicPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:cNvPr"].render(e, t), this.map["xdr:cNvPicPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["xdr:cNvPr"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./c-nv-pic-pr-xform": 59,
                "./c-nv-pr-xform": 60
            }
        ],
        67: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./ext-xform"), a = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:ext": new o({
                                tag: "xdr:ext"
                            }),
                            "xdr:pic": new a,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:oneCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:ext"].render(e, t.range.ext), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.ext = this.map["xdr:ext"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./ext-xform": 64,
                "./pic-xform": 68
            }
        ],
        68: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../static-xform"), s = e("./blip-fill-xform"), o = e("./nv-pic-pr-xform"), a = e("./sp-pr");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:nvPicPr": new o,
                            "xdr:blipFill": new s,
                            "xdr:spPr": new i(a)
                        };
                    }
                    get tag() {
                        return "xdr:pic";
                    }
                    prepare(e, t) {
                        e.index = t.index + 1;
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:nvPicPr"].render(e, t), this.map["xdr:blipFill"].render(e, t), this.map["xdr:spPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.mergeModel(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../static-xform": 120,
                "./blip-fill-xform": 57,
                "./nv-pic-pr-xform": 66,
                "./sp-pr": 69
            }
        ],
        69: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    tag: "xdr:spPr",
                    c: [
                        {
                            tag: "a:xfrm",
                            c: [
                                {
                                    tag: "a:off",
                                    $: {
                                        x: "0",
                                        y: "0"
                                    }
                                },
                                {
                                    tag: "a:ext",
                                    $: {
                                        cx: "0",
                                        cy: "0"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "a:prstGeom",
                            $: {
                                prst: "rect"
                            },
                            c: [
                                {
                                    tag: "a:avLst"
                                }
                            ]
                        }
                    ]
                };
            },
            {}
        ],
        70: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:to": new s({
                                tag: "xdr:to"
                            }),
                            "xdr:pic": new o,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:twoCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:to"].render(e, t.range.br), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.br = this.map["xdr:to"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./pic-xform": 68
            }
        ],
        71: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.always = !!e.always, this.count = e.count, this.empty = e.empty, this.$count = e.$count || "count", this.$ = e.$, this.childXform = e.childXform, this.maxItems = e.maxItems;
                    }
                    prepare(e, t) {
                        const { childXform: r } = this;
                        e && e.forEach((e, n)=>{
                            t.index = n, r.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        if (this.always || t && t.length) {
                            e.openNode(this.tag, this.$), this.count && e.addAttribute(this.$count, t && t.length || 0);
                            const { childXform: r } = this;
                            (t || []).forEach((t, n)=>{
                                r.render(e, t, n);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = [], !0;
                            default:
                                return !!this.childXform.parseOpen(e) && (this.parser = this.childXform, !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e) && (this.model.push(this.parser.model), this.parser = void 0, this.maxItems && this.model.length > this.maxItems)) throw new Error(`Max ${this.childXform.tag} count (${this.maxItems}) exceeded`);
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        if (e) {
                            const { childXform: r } = this;
                            e.forEach((e)=>{
                                r.reconcile(e, t);
                            });
                        }
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        72: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "autoFilter";
                    }
                    render(e, t) {
                        if (t) {
                            if ("string" == typeof t) e.leafNode("autoFilter", {
                                ref: t
                            });
                            else {
                                const r = function(e) {
                                    return "string" == typeof e ? e : n.getAddress(e.row, e.column).address;
                                }, i = r(t.from), s = r(t.to);
                                i && s && e.leafNode("autoFilter", {
                                    ref: `${i}:${s}`
                                });
                            }
                        }
                    }
                    parseOpen(e) {
                        "autoFilter" === e.name && (this.model = e.attributes.ref);
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        73: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform"), s = e("../../../doc/range"), o = e("../../../doc/enums"), a = e("../strings/rich-text-xform");
                function l(e) {
                    if (null == e) return o.ValueType.Null;
                    if (e instanceof String || "string" == typeof e) return o.ValueType.String;
                    if ("number" == typeof e) return o.ValueType.Number;
                    if ("boolean" == typeof e) return o.ValueType.Boolean;
                    if (e instanceof Date) return o.ValueType.Date;
                    if (e.text && e.hyperlink) return o.ValueType.Hyperlink;
                    if (e.formula) return o.ValueType.Formula;
                    if (e.error) return o.ValueType.Error;
                    throw new Error("I could not understand type of value");
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.richTextXForm = new a;
                    }
                    get tag() {
                        return "c";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {}, function(e) {
                            switch(e.type){
                                case o.ValueType.Formula:
                                    return l(e.result);
                                default:
                                    return e.type;
                            }
                        }(e));
                        switch(r && (e.styleId = r), e.comment && t.comments.push({
                            ...e.comment,
                            ref: e.address
                        }), e.type){
                            case o.ValueType.String:
                            case o.ValueType.RichText:
                                t.sharedStrings && (e.ssId = t.sharedStrings.add(e.value));
                                break;
                            case o.ValueType.Date:
                                t.date1904 && (e.date1904 = !0);
                                break;
                            case o.ValueType.Hyperlink:
                                t.sharedStrings && void 0 !== e.text && null !== e.text && (e.ssId = t.sharedStrings.add(e.text)), t.hyperlinks.push({
                                    address: e.address,
                                    target: e.hyperlink,
                                    tooltip: e.tooltip
                                });
                                break;
                            case o.ValueType.Merge:
                                t.merges.add(e);
                                break;
                            case o.ValueType.Formula:
                                if (t.date1904 && (e.date1904 = !0), "shared" === e.shareType && (e.si = t.siFormulae++), e.formula) t.formulae[e.address] = e;
                                else if (e.sharedFormula) {
                                    const r = t.formulae[e.sharedFormula];
                                    if (!r) throw new Error("Shared Formula master must exist above and or left of clone for cell " + e.address);
                                    void 0 === r.si ? (r.shareType = "shared", r.si = t.siFormulae++, r.range = new s(r.address, e.address)) : r.range && r.range.expandToAddress(e.address), e.si = r.si;
                                }
                        }
                    }
                    renderFormula(e, t) {
                        let r = null;
                        switch(t.shareType){
                            case "shared":
                                r = {
                                    t: "shared",
                                    ref: t.ref || t.range.range,
                                    si: t.si
                                };
                                break;
                            case "array":
                                r = {
                                    t: "array",
                                    ref: t.ref
                                };
                                break;
                            default:
                                void 0 !== t.si && (r = {
                                    t: "shared",
                                    si: t.si
                                });
                        }
                        switch(l(t.result)){
                            case o.ValueType.Null:
                                e.leafNode("f", r, t.formula);
                                break;
                            case o.ValueType.String:
                                e.addAttribute("t", "str"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Number:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Boolean:
                                e.addAttribute("t", "b"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result ? 1 : 0);
                                break;
                            case o.ValueType.Error:
                                e.addAttribute("t", "e"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result.error);
                                break;
                            case o.ValueType.Date:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, n.dateToExcel(t.result, t.date1904));
                                break;
                            default:
                                throw new Error("I could not understand type of value");
                        }
                    }
                    render(e, t) {
                        if (t.type !== o.ValueType.Null || t.styleId) {
                            switch(e.openNode("c"), e.addAttribute("r", t.address), t.styleId && e.addAttribute("s", t.styleId), t.type){
                                case o.ValueType.Null:
                                    break;
                                case o.ValueType.Number:
                                    e.leafNode("v", null, t.value);
                                    break;
                                case o.ValueType.Boolean:
                                    e.addAttribute("t", "b"), e.leafNode("v", null, t.value ? "1" : "0");
                                    break;
                                case o.ValueType.Error:
                                    e.addAttribute("t", "e"), e.leafNode("v", null, t.value.error);
                                    break;
                                case o.ValueType.String:
                                case o.ValueType.RichText:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : t.value && t.value.richText ? (e.addAttribute("t", "inlineStr"), e.openNode("is"), t.value.richText.forEach((t)=>{
                                        this.richTextXForm.render(e, t);
                                    }), e.closeNode("is")) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.value));
                                    break;
                                case o.ValueType.Date:
                                    e.leafNode("v", null, n.dateToExcel(t.value, t.date1904));
                                    break;
                                case o.ValueType.Hyperlink:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.text));
                                    break;
                                case o.ValueType.Formula:
                                    this.renderFormula(e, t);
                                    break;
                                case o.ValueType.Merge:
                            }
                            e.closeNode();
                        }
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "c":
                                return this.model = {
                                    address: e.attributes.r
                                }, this.t = e.attributes.t, e.attributes.s && (this.model.styleId = parseInt(e.attributes.s, 10)), !0;
                            case "f":
                                return this.currentNode = "f", this.model.si = e.attributes.si, this.model.shareType = e.attributes.t, this.model.ref = e.attributes.ref, !0;
                            case "v":
                                return this.currentNode = "v", !0;
                            case "t":
                                return this.currentNode = "t", !0;
                            case "r":
                                return this.parser = this.richTextXForm, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        if (this.parser) this.parser.parseText(e);
                        else switch(this.currentNode){
                            case "f":
                                this.model.formula = this.model.formula ? this.model.formula + e : e;
                                break;
                            case "v":
                            case "t":
                                this.model.value && this.model.value.richText ? this.model.value.richText.text = this.model.value.richText.text ? this.model.value.richText.text + e : e : this.model.value = this.model.value ? this.model.value + e : e;
                        }
                    }
                    parseClose(e) {
                        switch(e){
                            case "c":
                                {
                                    const { model: e } = this;
                                    if (e.formula || e.shareType) e.type = o.ValueType.Formula, e.value && ("str" === this.t ? e.result = n.xmlDecode(e.value) : "b" === this.t ? e.result = 0 !== parseInt(e.value, 10) : "e" === this.t ? e.result = {
                                        error: e.value
                                    } : e.result = parseFloat(e.value), e.value = void 0);
                                    else if (void 0 !== e.value) switch(this.t){
                                        case "s":
                                            e.type = o.ValueType.String, e.value = parseInt(e.value, 10);
                                            break;
                                        case "str":
                                            e.type = o.ValueType.String, e.value = n.xmlDecode(e.value);
                                            break;
                                        case "inlineStr":
                                            e.type = o.ValueType.String;
                                            break;
                                        case "b":
                                            e.type = o.ValueType.Boolean, e.value = 0 !== parseInt(e.value, 10);
                                            break;
                                        case "e":
                                            e.type = o.ValueType.Error, e.value = {
                                                error: e.value
                                            };
                                            break;
                                        default:
                                            e.type = o.ValueType.Number, e.value = parseFloat(e.value);
                                    }
                                    else e.styleId ? e.type = o.ValueType.Null : e.type = o.ValueType.Merge;
                                    return !1;
                                }
                            case "f":
                            case "v":
                            case "is":
                                return this.currentNode = void 0, !0;
                            case "t":
                                return this.parser ? (this.parser.parseClose(e), !0) : (this.currentNode = void 0, !0);
                            case "r":
                                return this.model.value = this.model.value || {}, this.model.value.richText = this.model.value.richText || [], this.model.value.richText.push(this.parser.model), this.parser = void 0, this.currentNode = void 0, !0;
                            default:
                                return !!this.parser && (this.parser.parseClose(e), !0);
                        }
                    }
                    reconcile(e, t) {
                        const r = e.styleId && t.styles && t.styles.getStyleModel(e.styleId);
                        switch(r && (e.style = r), void 0 !== e.styleId && (e.styleId = void 0), e.type){
                            case o.ValueType.String:
                                "number" == typeof e.value && t.sharedStrings && (e.value = t.sharedStrings.getString(e.value)), e.value.richText && (e.type = o.ValueType.RichText);
                                break;
                            case o.ValueType.Number:
                                r && n.isDateFmt(r.numFmt) && (e.type = o.ValueType.Date, e.value = n.excelToDate(e.value, t.date1904));
                                break;
                            case o.ValueType.Formula:
                                void 0 !== e.result && r && n.isDateFmt(r.numFmt) && (e.result = n.excelToDate(e.result, t.date1904)), "shared" === e.shareType && (e.ref ? t.formulae[e.si] = e.address : (e.sharedFormula = t.formulae[e.si], delete e.shareType), delete e.si);
                        }
                        const i = t.hyperlinkMap[e.address];
                        i && (e.type === o.ValueType.Formula ? (e.text = e.result, e.result = void 0) : (e.text = e.value, e.value = void 0), e.type = o.ValueType.Hyperlink, e.hyperlink = i);
                        const s = t.commentsMap && t.commentsMap[e.address];
                        s && (e.comment = s);
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        74: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x14:cfIcon";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            iconSet: t.iconSet,
                            iconId: t.iconId
                        });
                    }
                    parseOpen(e) {
                        let { attributes: t } = e;
                        this.model = {
                            iconSet: t.iconSet,
                            iconId: n.toIntValue(t.iconId)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        75: [
            function(e, t, r) {
                "use strict";
                const { v4: n } = e("uuid"), i = e("../../base-xform"), s = e("../../composite-xform"), o = e("./databar-ext-xform"), a = e("./icon-set-ext-xform"), l = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                };
                class c extends s {
                    constructor(){
                        super(), this.map = {
                            "x14:dataBar": this.databarXform = new o,
                            "x14:iconSet": this.iconSetXform = new a
                        };
                    }
                    get tag() {
                        return "x14:cfRule";
                    }
                    static isExt(e) {
                        return "dataBar" === e.type ? o.isExt(e) : !("iconSet" !== e.type || !e.custom && !l[e.iconSet]);
                    }
                    prepare(e) {
                        c.isExt(e) && (e.x14Id = `{${n()}}`.toUpperCase());
                    }
                    render(e, t) {
                        if (c.isExt(t)) switch(t.type){
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                        }
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            id: t.x14Id
                        }), this.databarXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority,
                            id: t.x14Id || `{${n()}}`
                        }), this.iconSetXform.render(e, t), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            type: t.type,
                            x14Id: t.id,
                            priority: i.toIntValue(t.priority)
                        };
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                }
                t.exports = c;
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./databar-ext-xform": 79,
                "./icon-set-ext-xform": 81,
                uuid: 528
            }
        ],
        76: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./f-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:f": this.fExtXform = new i
                        };
                    }
                    get tag() {
                        return "x14:cfvo";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            type: t.type
                        }), void 0 !== t.value && this.fExtXform.render(e, t.value), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            type: e.attributes.type
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:f":
                                this.model.value = t.model ? parseFloat(t.model) : 0;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./f-ext-xform": 80
            }
        ],
        77: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./sqref-ext-xform"), s = e("./cf-rule-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:sqref": this.sqRef = new i,
                            "x14:cfRule": this.cfRule = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormatting";
                    }
                    prepare(e, t) {
                        e.rules.forEach((e)=>{
                            this.cfRule.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        t.rules.some(s.isExt) && (e.openNode(this.tag, {
                            "xmlns:xm": "http://schemas.microsoft.com/office/excel/2006/main"
                        }), t.rules.filter(s.isExt).forEach((t)=>this.cfRule.render(e, t)), this.sqRef.render(e, t.ref), e.closeNode());
                    }
                    createNewModel() {
                        return {
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:sqref":
                                this.model.ref = t.model;
                                break;
                            case "x14:cfRule":
                                this.model.rules.push(t.model);
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./sqref-ext-xform": 82
            }
        ],
        78: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-ext-xform"), s = e("./conditional-formatting-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormatting": this.cfXform = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormattings";
                    }
                    hasContent(e) {
                        return void 0 === e.hasExtContent && (e.hasExtContent = e.some((e)=>e.rules.some(i.isExt))), e.hasExtContent;
                    }
                    prepare(e, t) {
                        e.forEach((e)=>{
                            this.cfXform.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode(this.tag), t.forEach((t)=>this.cfXform.render(e, t)), e.closeNode());
                    }
                    createNewModel() {
                        return [];
                    }
                    onParserClose(e, t) {
                        this.model.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./conditional-formatting-ext-xform": 77
            }
        ],
        79: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../style/color-xform"), o = e("./cfvo-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new o,
                            "x14:borderColor": this.borderColorXform = new s("x14:borderColor"),
                            "x14:negativeBorderColor": this.negativeBorderColorXform = new s("x14:negativeBorderColor"),
                            "x14:negativeFillColor": this.negativeFillColorXform = new s("x14:negativeFillColor"),
                            "x14:axisColor": this.axisColorXform = new s("x14:axisColor")
                        };
                    }
                    static isExt(e) {
                        return !e.gradient;
                    }
                    get tag() {
                        return "x14:dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            minLength: n.toIntAttribute(t.minLength, 0, !0),
                            maxLength: n.toIntAttribute(t.maxLength, 100, !0),
                            border: n.toBoolAttribute(t.border, !1),
                            gradient: n.toBoolAttribute(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolAttribute(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolAttribute(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toAttribute(t.axisPosition, "auto"),
                            direction: n.toAttribute(t.direction, "leftToRight")
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.borderColorXform.render(e, t.borderColor), this.negativeBorderColorXform.render(e, t.negativeBorderColor), this.negativeFillColorXform.render(e, t.negativeFillColor), this.axisColorXform.render(e, t.axisColor), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            minLength: n.toIntValue(t.minLength, 0),
                            maxLength: n.toIntValue(t.maxLength, 100),
                            border: n.toBoolValue(t.border, !1),
                            gradient: n.toBoolValue(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolValue(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolValue(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toStringValue(t.axisPosition, "auto"),
                            direction: n.toStringValue(t.direction, "leftToRight")
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-ext-xform": 76
            }
        ],
        80: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:f";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        81: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-ext-xform"), o = e("./cf-icon-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new s,
                            "x14:cfIcon": this.cfIconXform = new o
                        };
                    }
                    get tag() {
                        return "x14:iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0),
                            custom: n.toBoolAttribute(t.icons, !1)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.icons && t.icons.forEach((t, r)=>{
                            t.iconId = r, this.cfIconXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse, !1),
                            showValue: n.toBoolValue(t.showValue, !0)
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "cfIcon":
                                this.model.icons || (this.model.icons = []), this.model.icons.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cf-icon-ext-xform": 74,
                "./cfvo-ext-xform": 76
            }
        ],
        82: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:sqref";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        83: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../../../doc/range"), o = e("./databar-xform"), a = e("./ext-lst-ref-xform"), l = e("./formula-xform"), c = e("./color-scale-xform"), u = e("./icon-set-xform"), h = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                }, f = (e)=>{
                    const { type: t, operator: r } = e;
                    switch(t){
                        case "containsText":
                        case "containsBlanks":
                        case "notContainsBlanks":
                        case "containsErrors":
                        case "notContainsErrors":
                            return {
                                type: "containsText",
                                operator: t
                            };
                        default:
                            return {
                                type: t,
                                operator: r
                            };
                    }
                };
                class d extends i {
                    constructor(){
                        super(), this.map = {
                            dataBar: this.databarXform = new o,
                            extLst: this.extLstRefXform = new a,
                            formula: this.formulaXform = new l,
                            colorScale: this.colorScaleXform = new c,
                            iconSet: this.iconSetXform = new u
                        };
                    }
                    get tag() {
                        return "cfRule";
                    }
                    static isPrimitive(e) {
                        return "iconSet" !== e.type || !e.custom && !h[e.iconSet];
                    }
                    render(e, t) {
                        switch(t.type){
                            case "expression":
                                this.renderExpression(e, t);
                                break;
                            case "cellIs":
                                this.renderCellIs(e, t);
                                break;
                            case "top10":
                                this.renderTop10(e, t);
                                break;
                            case "aboveAverage":
                                this.renderAboveAverage(e, t);
                                break;
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "colorScale":
                                this.renderColorScale(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                                break;
                            case "containsText":
                                this.renderText(e, t);
                                break;
                            case "timePeriod":
                                this.renderTimePeriod(e, t);
                        }
                    }
                    renderExpression(e, t) {
                        e.openNode(this.tag, {
                            type: "expression",
                            dxfId: t.dxfId,
                            priority: t.priority
                        }), this.formulaXform.render(e, t.formulae[0]), e.closeNode();
                    }
                    renderCellIs(e, t) {
                        e.openNode(this.tag, {
                            type: "cellIs",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: t.operator
                        }), t.formulae.forEach((t)=>{
                            this.formulaXform.render(e, t);
                        }), e.closeNode();
                    }
                    renderTop10(e, t) {
                        e.leafNode(this.tag, {
                            type: "top10",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            percent: n.toBoolAttribute(t.percent, !1),
                            bottom: n.toBoolAttribute(t.bottom, !1),
                            rank: n.toIntValue(t.rank, 10, !0)
                        });
                    }
                    renderAboveAverage(e, t) {
                        e.leafNode(this.tag, {
                            type: "aboveAverage",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            aboveAverage: n.toBoolAttribute(t.aboveAverage, !0)
                        });
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            priority: t.priority
                        }), this.databarXform.render(e, t), this.extLstRefXform.render(e, t), e.closeNode();
                    }
                    renderColorScale(e, t) {
                        e.openNode(this.tag, {
                            type: "colorScale",
                            priority: t.priority
                        }), this.colorScaleXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        d.isPrimitive(t) && (e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority
                        }), this.iconSetXform.render(e, t), e.closeNode());
                    }
                    renderText(e, t) {
                        e.openNode(this.tag, {
                            type: t.operator,
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: n.toStringAttribute(t.operator, "containsText")
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.operator){
                                case "containsText":
                                    return `NOT(ISERROR(SEARCH("${e.text}",${r})))`;
                                case "containsBlanks":
                                    return `LEN(TRIM(${r}))=0`;
                                case "notContainsBlanks":
                                    return `LEN(TRIM(${r}))>0`;
                                case "containsErrors":
                                    return `ISERROR(${r})`;
                                case "notContainsErrors":
                                    return `NOT(ISERROR(${r}))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    renderTimePeriod(e, t) {
                        e.openNode(this.tag, {
                            type: "timePeriod",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            timePeriod: t.timePeriod
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.timePeriod){
                                case "thisWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)<=WEEKDAY(TODAY())-1,ROUNDDOWN(${r},0)-TODAY()<=7-WEEKDAY(TODAY()))`;
                                case "lastWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)>=(WEEKDAY(TODAY())),TODAY()-ROUNDDOWN(${r},0)<(WEEKDAY(TODAY())+7))`;
                                case "nextWeek":
                                    return `AND(ROUNDDOWN(${r},0)-TODAY()>(7-WEEKDAY(TODAY())),ROUNDDOWN(${r},0)-TODAY()<(15-WEEKDAY(TODAY())))`;
                                case "yesterday":
                                    return `FLOOR(${r},1)=TODAY()-1`;
                                case "today":
                                    return `FLOOR(${r},1)=TODAY()`;
                                case "tomorrow":
                                    return `FLOOR(${r},1)=TODAY()+1`;
                                case "last7Days":
                                    return `AND(TODAY()-FLOOR(${r},1)<=6,FLOOR(${r},1)<=TODAY())`;
                                case "lastMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0-1)),YEAR(${r})=YEAR(EDATE(TODAY(),0-1)))`;
                                case "thisMonth":
                                    return `AND(MONTH(${r})=MONTH(TODAY()),YEAR(${r})=YEAR(TODAY()))`;
                                case "nextMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0+1)),YEAR(${r})=YEAR(EDATE(TODAY(),0+1)))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ...f(t),
                            dxfId: n.toIntValue(t.dxfId),
                            priority: n.toIntValue(t.priority),
                            timePeriod: t.timePeriod,
                            percent: n.toBoolValue(t.percent),
                            bottom: n.toBoolValue(t.bottom),
                            rank: n.toIntValue(t.rank),
                            aboveAverage: n.toBoolValue(t.aboveAverage)
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "dataBar":
                            case "extLst":
                            case "colorScale":
                            case "iconSet":
                                Object.assign(this.model, t.model);
                                break;
                            case "formula":
                                this.model.formulae = this.model.formulae || [], this.model.formulae.push(t.model);
                        }
                    }
                }
                t.exports = d;
            },
            {
                "../../../../doc/range": 10,
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./color-scale-xform": 85,
                "./databar-xform": 88,
                "./ext-lst-ref-xform": 89,
                "./formula-xform": 90,
                "./icon-set-xform": 91
            }
        ],
        84: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "cfvo";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            type: t.type,
                            val: t.value
                        });
                    }
                    parseOpen(e) {
                        this.model = {
                            type: e.attributes.type,
                            value: n.toFloatValue(e.attributes.val)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        85: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "colorScale";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.color.forEach((t)=>{
                            this.colorXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            cfvo: [],
                            color: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        86: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfRule: new i
                        };
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    render(e, t) {
                        t.rules.some(i.isPrimitive) && (e.openNode(this.tag, {
                            sqref: t.ref
                        }), t.rules.forEach((r)=>{
                            i.isPrimitive(r) && (r.ref = t.ref, this.map.cfRule.render(e, r));
                        }), e.closeNode());
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ref: t.sqref,
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model.rules.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-xform": 83
            }
        ],
        87: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("./conditional-formatting-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.cfXform = new i;
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    reset() {
                        this.model = [];
                    }
                    prepare(e, t) {
                        let r = e.reduce((e, t)=>Math.max(e, ...t.rules.map((e)=>e.priority || 0)), 1);
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                e.priority || (e.priority = r++), e.style && (e.dxfId = t.styles.addDxfStyle(e.style));
                            });
                        });
                    }
                    render(e, t) {
                        t.forEach((t)=>{
                            this.cfXform.render(e, t);
                        });
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "conditionalFormatting":
                                return this.parser = this.cfXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (!!this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0, !1));
                    }
                    reconcile(e, t) {
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId), delete e.dxfId);
                            });
                        });
                    }
                };
            },
            {
                "../../base-xform": 32,
                "./conditional-formatting-xform": 86
            }
        ],
        88: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.colorXform.render(e, t.color), e.closeNode();
                    }
                    createNewModel() {
                        return {
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "color":
                                this.model.color = t.model;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        89: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform");
                class s extends n {
                    get tag() {
                        return "x14:id";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                }
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:id": this.idXform = new s
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            uri: "{B025F937-C7B1-47D3-B67F-A62EFF666E3E}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.idXform.render(e, t.x14Id), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model.x14Id = t.model;
                    }
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            ext: new o
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map.ext.render(e, t), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48
            }
        ],
        90: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "formula";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        91: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s
                        };
                    }
                    get tag() {
                        return "iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse),
                            showValue: n.toBoolValue(t.showValue),
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cfvo-xform": 84
            }
        ],
        92: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "col";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {});
                        r && (e.styleId = r);
                    }
                    render(e, t) {
                        e.openNode("col"), e.addAttribute("min", t.min), e.addAttribute("max", t.max), t.width && e.addAttribute("width", t.width), t.styleId && e.addAttribute("style", t.styleId), t.hidden && e.addAttribute("hidden", "1"), t.bestFit && e.addAttribute("bestFit", "1"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1"), e.addAttribute("customWidth", "1"), e.closeNode();
                    }
                    parseOpen(e) {
                        if ("col" === e.name) {
                            const t = this.model = {
                                min: parseInt(e.attributes.min || "0", 10),
                                max: parseInt(e.attributes.max || "0", 10),
                                width: void 0 === e.attributes.width ? void 0 : parseFloat(e.attributes.width || "0")
                            };
                            return e.attributes.style && (t.styleId = parseInt(e.attributes.style, 10)), n.parseBoolean(e.attributes.hidden) && (t.hidden = !0), n.parseBoolean(e.attributes.bestFit) && (t.bestFit = !0), e.attributes.outlineLevel && (t.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), n.parseBoolean(e.attributes.collapsed) && (t.collapsed = !0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    reconcile(e, t) {
                        e.styleId && (e.style = t.styles.getStyleModel(e.styleId));
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        93: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/utils"), s = e("../../../utils/col-cache"), o = e("../base-xform"), a = e("../../../doc/range");
                function l(e, t, r, n) {
                    const i = t[r];
                    void 0 !== i ? e[r] = i : void 0 !== n && (e[r] = n);
                }
                function c(e, t, r, n) {
                    const s = t[r];
                    void 0 !== s ? e[r] = i.parseBoolean(s) : void 0 !== n && (e[r] = n);
                }
                t.exports = class extends o {
                    get tag() {
                        return "dataValidations";
                    }
                    render(e, t) {
                        const r = function(e) {
                            const t = n.map(e, (e, t)=>({
                                    address: t,
                                    dataValidation: e,
                                    marked: !1
                                })).sort((e, t)=>n.strcmp(e.address, t.address)), r = n.keyBy(t, "address"), i = (t, r, i)=>{
                                for(let o = 0; o < r; o++){
                                    const r = s.encodeAddress(t.row + o, i);
                                    if (!e[r] || !n.isEqual(e[t.address], e[r])) return !1;
                                }
                                return !0;
                            };
                            return t.map((t)=>{
                                if (!t.marked) {
                                    const o = s.decodeEx(t.address);
                                    if (o.dimensions) return r[o.dimensions].marked = !0, {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                    let a = 1, l = s.encodeAddress(o.row + a, o.col);
                                    for(; e[l] && n.isEqual(t.dataValidation, e[l]);)a++, l = s.encodeAddress(o.row + a, o.col);
                                    let c = 1;
                                    for(; i(o, a, o.col + c);)c++;
                                    for(let e = 0; e < a; e++)for(let t = 0; t < c; t++)l = s.encodeAddress(o.row + e, o.col + t), r[l].marked = !0;
                                    if (a > 1 || c > 1) {
                                        const e = o.row + (a - 1), r = o.col + (c - 1);
                                        return {
                                            ...t.dataValidation,
                                            sqref: `${t.address}:${s.encodeAddress(e, r)}`
                                        };
                                    }
                                    return {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                }
                                return null;
                            }).filter(Boolean);
                        }(t);
                        r.length && (e.openNode("dataValidations", {
                            count: r.length
                        }), r.forEach((t)=>{
                            e.openNode("dataValidation"), "any" !== t.type && (e.addAttribute("type", t.type), t.operator && "list" !== t.type && "between" !== t.operator && e.addAttribute("operator", t.operator), t.allowBlank && e.addAttribute("allowBlank", "1")), t.showInputMessage && e.addAttribute("showInputMessage", "1"), t.promptTitle && e.addAttribute("promptTitle", t.promptTitle), t.prompt && e.addAttribute("prompt", t.prompt), t.showErrorMessage && e.addAttribute("showErrorMessage", "1"), t.errorStyle && e.addAttribute("errorStyle", t.errorStyle), t.errorTitle && e.addAttribute("errorTitle", t.errorTitle), t.error && e.addAttribute("error", t.error), e.addAttribute("sqref", t.sqref), (t.formulae || []).forEach((r, n)=>{
                                e.openNode("formula" + (n + 1)), "date" === t.type ? e.writeText(i.dateToExcel(new Date(r))) : e.writeText(r), e.closeNode();
                            }), e.closeNode();
                        }), e.closeNode());
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "dataValidations":
                                return this.model = {}, !0;
                            case "dataValidation":
                                {
                                    this._address = e.attributes.sqref;
                                    const t = {
                                        type: e.attributes.type || "any",
                                        formulae: []
                                    };
                                    switch(e.attributes.type && c(t, e.attributes, "allowBlank"), c(t, e.attributes, "showInputMessage"), c(t, e.attributes, "showErrorMessage"), t.type){
                                        case "any":
                                        case "list":
                                        case "custom":
                                            break;
                                        default:
                                            l(t, e.attributes, "operator", "between");
                                    }
                                    return l(t, e.attributes, "promptTitle"), l(t, e.attributes, "prompt"), l(t, e.attributes, "errorStyle"), l(t, e.attributes, "errorTitle"), l(t, e.attributes, "error"), this._dataValidation = t, !0;
                                }
                            case "formula1":
                            case "formula2":
                                return this._formula = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._formula && this._formula.push(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "dataValidations":
                                return !1;
                            case "dataValidation":
                                this._dataValidation.formulae && this._dataValidation.formulae.length || (delete this._dataValidation.formulae, delete this._dataValidation.operator);
                                return (this._address.split(/\s+/g) || []).forEach((e)=>{
                                    if (e.includes(":")) new a(e).forEachAddress((e)=>{
                                        this.model[e] = this._dataValidation;
                                    });
                                    else this.model[e] = this._dataValidation;
                                }), !0;
                            case "formula1":
                            case "formula2":
                                {
                                    let e = this._formula.join("");
                                    switch(this._dataValidation.type){
                                        case "whole":
                                        case "textLength":
                                            e = parseInt(e, 10);
                                            break;
                                        case "decimal":
                                            e = parseFloat(e);
                                            break;
                                        case "date":
                                            e = i.excelToDate(parseFloat(e));
                                    }
                                    return this._dataValidation.formulae.push(e), this._formula = void 0, !0;
                                }
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        94: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "dimension";
                    }
                    render(e, t) {
                        t && e.leafNode("dimension", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "dimension" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        95: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "drawing";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        96: [
            function(e, t, r) {
                "use strict";
                const n = e("../composite-xform"), i = e("./cf-ext/conditional-formattings-ext-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormattings": this.conditionalFormattings = new i
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    hasContent(e) {
                        return this.conditionalFormattings.hasContent(e.conditionalFormattings);
                    }
                    prepare(e, t) {
                        this.conditionalFormattings.prepare(e.conditionalFormattings, t);
                    }
                    render(e, t) {
                        e.openNode("ext", {
                            uri: "{78C0D931-6437-407d-A8EE-F0AAD7539E65}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.conditionalFormattings.render(e, t.conditionalFormattings), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                }
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            ext: this.ext = new s
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    prepare(e, t) {
                        this.ext.prepare(e, t);
                    }
                    hasContent(e) {
                        return this.ext.hasContent(e);
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode("extLst"), this.ext.render(e, t), e.closeNode());
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../composite-xform": 48,
                "./cf-ext/conditional-formattings-ext-xform": 78
            }
        ],
        97: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "headerFooter";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback();
                            let r = !1;
                            e.openNode("headerFooter"), t.differentFirst && (e.addAttribute("differentFirst", "1"), r = !0), t.differentOddEven && (e.addAttribute("differentOddEven", "1"), r = !0), t.oddHeader && "string" == typeof t.oddHeader && (e.leafNode("oddHeader", null, t.oddHeader), r = !0), t.oddFooter && "string" == typeof t.oddFooter && (e.leafNode("oddFooter", null, t.oddFooter), r = !0), t.evenHeader && "string" == typeof t.evenHeader && (e.leafNode("evenHeader", null, t.evenHeader), r = !0), t.evenFooter && "string" == typeof t.evenFooter && (e.leafNode("evenFooter", null, t.evenFooter), r = !0), t.firstHeader && "string" == typeof t.firstHeader && (e.leafNode("firstHeader", null, t.firstHeader), r = !0), t.firstFooter && "string" == typeof t.firstFooter && (e.leafNode("firstFooter", null, t.firstFooter), r = !0), r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "headerFooter":
                                return this.model = {}, e.attributes.differentFirst && (this.model.differentFirst = 1 === parseInt(e.attributes.differentFirst, 0)), e.attributes.differentOddEven && (this.model.differentOddEven = 1 === parseInt(e.attributes.differentOddEven, 0)), !0;
                            case "oddHeader":
                                return this.currentNode = "oddHeader", !0;
                            case "oddFooter":
                                return this.currentNode = "oddFooter", !0;
                            case "evenHeader":
                                return this.currentNode = "evenHeader", !0;
                            case "evenFooter":
                                return this.currentNode = "evenFooter", !0;
                            case "firstHeader":
                                return this.currentNode = "firstHeader", !0;
                            case "firstFooter":
                                return this.currentNode = "firstFooter", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        switch(this.currentNode){
                            case "oddHeader":
                                this.model.oddHeader = e;
                                break;
                            case "oddFooter":
                                this.model.oddFooter = e;
                                break;
                            case "evenHeader":
                                this.model.evenHeader = e;
                                break;
                            case "evenFooter":
                                this.model.evenFooter = e;
                                break;
                            case "firstHeader":
                                this.model.firstHeader = e;
                                break;
                            case "firstFooter":
                                this.model.firstFooter = e;
                        }
                    }
                    parseClose() {
                        switch(this.currentNode){
                            case "oddHeader":
                            case "oddFooter":
                            case "evenHeader":
                            case "evenFooter":
                            case "firstHeader":
                            case "firstFooter":
                                return this.currentNode = void 0, !0;
                            default:
                                return !1;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        98: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "hyperlink";
                    }
                    render(e, t) {
                        this.isInternalLink(t) ? e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip,
                            location: t.target
                        }) : e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip
                        });
                    }
                    parseOpen(e) {
                        return "hyperlink" === e.name && (this.model = {
                            address: e.attributes.ref,
                            rId: e.attributes["r:id"],
                            tooltip: e.attributes.tooltip
                        }, e.attributes.location && (this.model.target = e.attributes.location), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    isInternalLink(e) {
                        return e.target && /^[^!]+![a-zA-Z]+[\d]+$/.test(e.target);
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        99: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "mergeCell";
                    }
                    render(e, t) {
                        e.leafNode("mergeCell", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "mergeCell" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        100: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../doc/range"), s = e("../../../utils/col-cache"), o = e("../../../doc/enums");
                t.exports = class {
                    constructor(){
                        this.merges = {};
                    }
                    add(e) {
                        if (this.merges[e.master]) this.merges[e.master].expandToAddress(e.address);
                        else {
                            const t = `${e.master}:${e.address}`;
                            this.merges[e.master] = new i(t);
                        }
                    }
                    get mergeCells() {
                        return n.map(this.merges, (e)=>e.range);
                    }
                    reconcile(e, t) {
                        n.each(e, (e)=>{
                            const r = s.decode(e);
                            for(let e = r.top; e <= r.bottom; e++){
                                const n = t[e - 1];
                                for(let t = r.left; t <= r.right; t++){
                                    const i = n.cells[t - 1];
                                    i ? i.type === o.ValueType.Merge && (i.master = r.tl) : n.cells[t] = {
                                        type: o.ValueType.Null,
                                        address: s.encodeAddress(e, t)
                                    };
                                }
                            }
                        });
                    }
                    getMasterAddress(e) {
                        const t = this.hash[e];
                        return t && t.tl;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26
            }
        ],
        101: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = (e)=>void 0 !== e;
                t.exports = class extends n {
                    get tag() {
                        return "outlinePr";
                    }
                    render(e, t) {
                        return !(!t || !i(t.summaryBelow) && !i(t.summaryRight)) && (e.leafNode(this.tag, {
                            summaryBelow: i(t.summaryBelow) ? Number(t.summaryBelow) : void 0,
                            summaryRight: i(t.summaryRight) ? Number(t.summaryRight) : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            summaryBelow: i(e.attributes.summaryBelow) ? Boolean(Number(e.attributes.summaryBelow)) : void 0,
                            summaryRight: i(e.attributes.summaryRight) ? Boolean(Number(e.attributes.summaryRight)) : void 0
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        102: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "brk";
                    }
                    render(e, t) {
                        e.leafNode("brk", t);
                    }
                    parseOpen(e) {
                        return "brk" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        103: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "pageMargins";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                left: t.left,
                                right: t.right,
                                top: t.top,
                                bottom: t.bottom,
                                header: t.header,
                                footer: t.footer
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    left: parseFloat(e.attributes.left || .7),
                                    right: parseFloat(e.attributes.right || .7),
                                    top: parseFloat(e.attributes.top || .75),
                                    bottom: parseFloat(e.attributes.bottom || .75),
                                    header: parseFloat(e.attributes.header || .3),
                                    footer: parseFloat(e.attributes.footer || .3)
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        104: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "pageSetUpPr";
                    }
                    render(e, t) {
                        return !(!t || !t.fitToPage) && (e.leafNode(this.tag, {
                            fitToPage: t.fitToPage ? "1" : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            fitToPage: "1" === e.attributes.fitToPage
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        105: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                function o(e) {
                    switch(e){
                        case "overThenDown":
                            return e;
                        default:
                            return;
                    }
                }
                function a(e) {
                    switch(e){
                        case "atEnd":
                        case "asDisplyed":
                            return e;
                        default:
                            return;
                    }
                }
                function l(e) {
                    switch(e){
                        case "dash":
                        case "blank":
                        case "NA":
                            return e;
                        default:
                            return;
                    }
                }
                t.exports = class extends i {
                    get tag() {
                        return "pageSetup";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                paperSize: t.paperSize,
                                orientation: t.orientation,
                                horizontalDpi: t.horizontalDpi,
                                verticalDpi: t.verticalDpi,
                                pageOrder: o(t.pageOrder),
                                blackAndWhite: s(t.blackAndWhite),
                                draft: s(t.draft),
                                cellComments: a(t.cellComments),
                                errors: l(t.errors),
                                scale: t.scale,
                                fitToWidth: t.fitToWidth,
                                fitToHeight: t.fitToHeight,
                                firstPageNumber: t.firstPageNumber,
                                useFirstPageNumber: s(t.firstPageNumber),
                                usePrinterDefaults: s(t.usePrinterDefaults),
                                copies: t.copies
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    paperSize: (t = e.attributes.paperSize, void 0 !== t ? parseInt(t, 10) : void 0),
                                    orientation: e.attributes.orientation || "portrait",
                                    horizontalDpi: parseInt(e.attributes.horizontalDpi || "4294967295", 10),
                                    verticalDpi: parseInt(e.attributes.verticalDpi || "4294967295", 10),
                                    pageOrder: e.attributes.pageOrder || "downThenOver",
                                    blackAndWhite: "1" === e.attributes.blackAndWhite,
                                    draft: "1" === e.attributes.draft,
                                    cellComments: e.attributes.cellComments || "None",
                                    errors: e.attributes.errors || "displayed",
                                    scale: parseInt(e.attributes.scale || "100", 10),
                                    fitToWidth: parseInt(e.attributes.fitToWidth || "1", 10),
                                    fitToHeight: parseInt(e.attributes.fitToHeight || "1", 10),
                                    firstPageNumber: parseInt(e.attributes.firstPageNumber || "1", 10),
                                    useFirstPageNumber: "1" === e.attributes.useFirstPageNumber,
                                    usePrinterDefaults: "1" === e.attributes.usePrinterDefaults,
                                    copies: parseInt(e.attributes.copies || "1", 10)
                                }, !0;
                            default:
                                return !1;
                        }
                        var t;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        106: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "picture";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        107: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "printOptions";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                headings: s(t.showRowColHeaders),
                                gridLines: s(t.showGridLines),
                                horizontalCentered: s(t.horizontalCentered),
                                verticalCentered: s(t.verticalCentered)
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    showRowColHeaders: "1" === e.attributes.headings,
                                    showGridLines: "1" === e.attributes.gridLines,
                                    horizontalCentered: "1" === e.attributes.horizontalCentered,
                                    verticalCentered: "1" === e.attributes.verticalCentered
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        108: [
            function(e, t, r) {
                "use strict";
                const n = e("./page-breaks-xform"), i = e("../list-xform");
                t.exports = class extends i {
                    constructor(){
                        super({
                            tag: "rowBreaks",
                            count: !0,
                            childXform: new n
                        });
                    }
                    render(e, t) {
                        if (t && t.length) {
                            e.openNode(this.tag, this.$), this.count && (e.addAttribute(this.$count, t.length), e.addAttribute("manualBreakCount", t.length));
                            const { childXform: r } = this;
                            t.forEach((t)=>{
                                r.render(e, t);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                };
            },
            {
                "../list-xform": 71,
                "./page-breaks-xform": 102
            }
        ],
        109: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./cell-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.maxItems = e && e.maxItems, this.map = {
                            c: new s
                        };
                    }
                    get tag() {
                        return "row";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style);
                        r && (e.styleId = r);
                        const n = this.map.c;
                        e.cells.forEach((e)=>{
                            n.prepare(e, t);
                        });
                    }
                    render(e, t, r) {
                        e.openNode("row"), e.addAttribute("r", t.number), t.height && (e.addAttribute("ht", t.height), e.addAttribute("customHeight", "1")), t.hidden && e.addAttribute("hidden", "1"), t.min > 0 && t.max > 0 && t.min <= t.max && e.addAttribute("spans", `${t.min}:${t.max}`), t.styleId && (e.addAttribute("s", t.styleId), e.addAttribute("customFormat", "1")), e.addAttribute("x14ac:dyDescent", "0.25"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1");
                        const n = this.map.c;
                        t.cells.forEach((t)=>{
                            n.render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if ("row" === e.name) {
                            this.numRowsSeen += 1;
                            const t = e.attributes.spans ? e.attributes.spans.split(":").map((e)=>parseInt(e, 10)) : [
                                void 0,
                                void 0
                            ], r = this.model = {
                                number: parseInt(e.attributes.r, 10),
                                min: t[0],
                                max: t[1],
                                cells: []
                            };
                            return e.attributes.s && (r.styleId = parseInt(e.attributes.s, 10)), i.parseBoolean(e.attributes.hidden) && (r.hidden = !0), i.parseBoolean(e.attributes.bestFit) && (r.bestFit = !0), e.attributes.ht && (r.height = parseFloat(e.attributes.ht)), e.attributes.outlineLevel && (r.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), i.parseBoolean(e.attributes.collapsed) && (r.collapsed = !0), !0;
                        }
                        return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                if (this.model.cells.push(this.parser.model), this.maxItems && this.model.cells.length > this.maxItems) throw new Error(`Max column count (${this.maxItems}) exceeded`);
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        e.style = e.styleId ? t.styles.getStyleModel(e.styleId) : {}, void 0 !== e.styleId && (e.styleId = void 0);
                        const r = this.map.c;
                        e.cells.forEach((e)=>{
                            r.reconcile(e, t);
                        });
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./cell-xform": 73
            }
        ],
        110: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "sheetFormatPr";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                defaultRowHeight: t.defaultRowHeight,
                                outlineLevelRow: t.outlineLevelRow,
                                outlineLevelCol: t.outlineLevelCol,
                                "x14ac:dyDescent": t.dyDescent
                            };
                            t.defaultColWidth && (r.defaultColWidth = t.defaultColWidth), t.defaultRowHeight && 15 === t.defaultRowHeight || (r.customHeight = "1"), n.some(r, (e)=>void 0 !== e) && e.leafNode("sheetFormatPr", r);
                        }
                    }
                    parseOpen(e) {
                        return "sheetFormatPr" === e.name && (this.model = {
                            defaultRowHeight: parseFloat(e.attributes.defaultRowHeight || "0"),
                            dyDescent: parseFloat(e.attributes["x14ac:dyDescent"] || "0"),
                            outlineLevelRow: parseInt(e.attributes.outlineLevelRow || "0", 10),
                            outlineLevelCol: parseInt(e.attributes.outlineLevelCol || "0", 10)
                        }, e.attributes.defaultColWidth && (this.model.defaultColWidth = parseFloat(e.attributes.defaultColWidth)), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        111: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../style/color-xform"), s = e("./page-setup-properties-xform"), o = e("./outline-properties-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            tabColor: new i("tabColor"),
                            pageSetUpPr: new s,
                            outlinePr: new o
                        };
                    }
                    get tag() {
                        return "sheetPr";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback(), e.openNode("sheetPr");
                            let r = !1;
                            r = this.map.tabColor.render(e, t.tabColor) || r, r = this.map.pageSetUpPr.render(e, t.pageSetup) || r, r = this.map.outlinePr.render(e, t.outlineProperties) || r, r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag ? (this.reset(), !0) : !!this.map[e.name] && (this.parser = this.map[e.name], this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        return !!this.parser && (this.parser.parseText(e), !0);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (this.map.tabColor.model || this.map.pageSetUpPr.model || this.map.outlinePr.model ? (this.model = {}, this.map.tabColor.model && (this.model.tabColor = this.map.tabColor.model), this.map.pageSetUpPr.model && (this.model.pageSetup = this.map.pageSetUpPr.model), this.map.outlinePr.model && (this.model.outlineProperties = this.map.outlinePr.model)) : this.model = null, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "../style/color-xform": 128,
                "./outline-properties-xform": 101,
                "./page-setup-properties-xform": 104
            }
        ],
        112: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e, t) {
                    return e ? t : void 0;
                }
                function o(e, t) {
                    return e === t || void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "sheetProtection";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                sheet: s(t.sheet, "1"),
                                selectLockedCells: !1 === t.selectLockedCells ? "1" : void 0,
                                selectUnlockedCells: !1 === t.selectUnlockedCells ? "1" : void 0,
                                formatCells: s(t.formatCells, "0"),
                                formatColumns: s(t.formatColumns, "0"),
                                formatRows: s(t.formatRows, "0"),
                                insertColumns: s(t.insertColumns, "0"),
                                insertRows: s(t.insertRows, "0"),
                                insertHyperlinks: s(t.insertHyperlinks, "0"),
                                deleteColumns: s(t.deleteColumns, "0"),
                                deleteRows: s(t.deleteRows, "0"),
                                sort: s(t.sort, "0"),
                                autoFilter: s(t.autoFilter, "0"),
                                pivotTables: s(t.pivotTables, "0")
                            };
                            t.sheet && (r.algorithmName = t.algorithmName, r.hashValue = t.hashValue, r.saltValue = t.saltValue, r.spinCount = t.spinCount, r.objects = s(!1 === t.objects, "1"), r.scenarios = s(!1 === t.scenarios, "1")), n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    sheet: o(e.attributes.sheet, "1"),
                                    objects: "1" !== e.attributes.objects && void 0,
                                    scenarios: "1" !== e.attributes.scenarios && void 0,
                                    selectLockedCells: "1" !== e.attributes.selectLockedCells && void 0,
                                    selectUnlockedCells: "1" !== e.attributes.selectUnlockedCells && void 0,
                                    formatCells: o(e.attributes.formatCells, "0"),
                                    formatColumns: o(e.attributes.formatColumns, "0"),
                                    formatRows: o(e.attributes.formatRows, "0"),
                                    insertColumns: o(e.attributes.insertColumns, "0"),
                                    insertRows: o(e.attributes.insertRows, "0"),
                                    insertHyperlinks: o(e.attributes.insertHyperlinks, "0"),
                                    deleteColumns: o(e.attributes.deleteColumns, "0"),
                                    deleteRows: o(e.attributes.deleteRows, "0"),
                                    sort: o(e.attributes.sort, "0"),
                                    autoFilter: o(e.attributes.autoFilter, "0"),
                                    pivotTables: o(e.attributes.pivotTables, "0")
                                }, e.attributes.algorithmName && (this.model.algorithmName = e.attributes.algorithmName, this.model.hashValue = e.attributes.hashValue, this.model.saltValue = e.attributes.saltValue, this.model.spinCount = parseInt(e.attributes.spinCount, 10)), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        113: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform"), s = {
                    frozen: "frozen",
                    frozenSplit: "frozen",
                    split: "split"
                };
                t.exports = class extends i {
                    get tag() {
                        return "sheetView";
                    }
                    prepare(e) {
                        switch(e.state){
                            case "frozen":
                            case "split":
                                break;
                            default:
                                e.state = "normal";
                        }
                    }
                    render(e, t) {
                        e.openNode("sheetView", {
                            workbookViewId: t.workbookViewId || 0
                        });
                        const r = function(t, r, n) {
                            n && e.addAttribute(t, r);
                        };
                        let i, s, o, a;
                        switch(r("rightToLeft", "1", !0 === t.rightToLeft), r("tabSelected", "1", t.tabSelected), r("showRuler", "0", !1 === t.showRuler), r("showRowColHeaders", "0", !1 === t.showRowColHeaders), r("showGridLines", "0", !1 === t.showGridLines), r("zoomScale", t.zoomScale, t.zoomScale), r("zoomScaleNormal", t.zoomScaleNormal, t.zoomScaleNormal), r("view", t.style, t.style), t.state){
                            case "frozen":
                                s = t.xSplit || 0, o = t.ySplit || 0, i = t.topLeftCell || n.getAddress(o + 1, s + 1).address, a = (t.xSplit && t.ySplit ? "bottomRight" : t.xSplit && "topRight") || "bottomLeft", e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: i,
                                    activePane: a,
                                    state: "frozen"
                                }), e.leafNode("selection", {
                                    pane: a,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "split":
                                "topLeft" === t.activePane && (t.activePane = void 0), e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: t.topLeftCell,
                                    activePane: t.activePane
                                }), e.leafNode("selection", {
                                    pane: t.activePane,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "normal":
                                t.activeCell && e.leafNode("selection", {
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                        }
                        e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "sheetView":
                                return this.sheetView = {
                                    workbookViewId: parseInt(e.attributes.workbookViewId, 10),
                                    rightToLeft: "1" === e.attributes.rightToLeft,
                                    tabSelected: "1" === e.attributes.tabSelected,
                                    showRuler: !("0" === e.attributes.showRuler),
                                    showRowColHeaders: !("0" === e.attributes.showRowColHeaders),
                                    showGridLines: !("0" === e.attributes.showGridLines),
                                    zoomScale: parseInt(e.attributes.zoomScale || "100", 10),
                                    zoomScaleNormal: parseInt(e.attributes.zoomScaleNormal || "100", 10),
                                    style: e.attributes.view
                                }, this.pane = void 0, this.selections = {}, !0;
                            case "pane":
                                return this.pane = {
                                    xSplit: parseInt(e.attributes.xSplit || "0", 10),
                                    ySplit: parseInt(e.attributes.ySplit || "0", 10),
                                    topLeftCell: e.attributes.topLeftCell,
                                    activePane: e.attributes.activePane || "topLeft",
                                    state: e.attributes.state
                                }, !0;
                            case "selection":
                                {
                                    const t = e.attributes.pane || "topLeft";
                                    return this.selections[t] = {
                                        pane: t,
                                        activeCell: e.attributes.activeCell
                                    }, !0;
                                }
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        let t, r;
                        switch(e){
                            case "sheetView":
                                return this.sheetView && this.pane ? (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: s[this.pane.state] || "split",
                                    xSplit: this.pane.xSplit,
                                    ySplit: this.pane.ySplit,
                                    topLeftCell: this.pane.topLeftCell,
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, "split" === this.model.state && (t.activePane = this.pane.activePane), r = this.selections[this.pane.activePane], r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)) : (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: "normal",
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, r = this.selections.topLeft, r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile() {}
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        114: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tablePart";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        115: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../../rel-type"), a = e("./merges"), l = e("../base-xform"), c = e("../list-xform"), u = e("./row-xform"), h = e("./col-xform"), f = e("./dimension-xform"), d = e("./hyperlink-xform"), p = e("./merge-cell-xform"), m = e("./data-validations-xform"), b = e("./sheet-properties-xform"), g = e("./sheet-format-properties-xform"), y = e("./sheet-view-xform"), v = e("./sheet-protection-xform"), w = e("./page-margins-xform"), _ = e("./page-setup-xform"), x = e("./print-options-xform"), k = e("./auto-filter-xform"), S = e("./picture-xform"), M = e("./drawing-xform"), C = e("./table-part-xform"), T = e("./row-breaks-xform"), E = e("./header-footer-xform"), A = e("./cf/conditional-formattings-xform"), R = e("./ext-lst-xform"), O = (e, t)=>{
                    if (!t || !t.length) return e;
                    if (!e || !e.length) return t;
                    const r = {}, n = {};
                    return e.forEach((e)=>{
                        r[e.ref] = e, e.rules.forEach((e)=>{
                            const { x14Id: t } = e;
                            t && (n[t] = e);
                        });
                    }), t.forEach((t)=>{
                        t.rules.forEach((i)=>{
                            const s = n[i.x14Id];
                            s ? ((e, t)=>{
                                Object.keys(t).forEach((r)=>{
                                    const n = e[r], i = t[r];
                                    void 0 === n && void 0 !== i && (e[r] = i);
                                });
                            })(s, i) : r[t.ref] ? r[t.ref].rules.push(i) : e.push({
                                ref: t.ref,
                                rules: [
                                    i
                                ]
                            });
                        });
                    }), e;
                };
                class j extends l {
                    constructor(e){
                        super();
                        const { maxRows: t, maxCols: r, ignoreNodes: n } = e || {};
                        this.ignoreNodes = n || [], this.map = {
                            sheetPr: new b,
                            dimension: new f,
                            sheetViews: new c({
                                tag: "sheetViews",
                                count: !1,
                                childXform: new y
                            }),
                            sheetFormatPr: new g,
                            cols: new c({
                                tag: "cols",
                                count: !1,
                                childXform: new h
                            }),
                            sheetData: new c({
                                tag: "sheetData",
                                count: !1,
                                empty: !0,
                                childXform: new u({
                                    maxItems: r
                                }),
                                maxItems: t
                            }),
                            autoFilter: new k,
                            mergeCells: new c({
                                tag: "mergeCells",
                                count: !0,
                                childXform: new p
                            }),
                            rowBreaks: new T,
                            hyperlinks: new c({
                                tag: "hyperlinks",
                                count: !1,
                                childXform: new d
                            }),
                            pageMargins: new w,
                            dataValidations: new m,
                            pageSetup: new _,
                            headerFooter: new E,
                            printOptions: new x,
                            picture: new S,
                            drawing: new M,
                            sheetProtection: new v,
                            tableParts: new c({
                                tag: "tableParts",
                                count: !0,
                                childXform: new C
                            }),
                            conditionalFormatting: new A,
                            extLst: new R
                        };
                    }
                    prepare(e, t) {
                        t.merges = new a, e.hyperlinks = t.hyperlinks = [], e.comments = t.comments = [], t.formulae = {}, t.siFormulae = 0, this.map.cols.prepare(e.cols, t), this.map.sheetData.prepare(e.rows, t), this.map.conditionalFormatting.prepare(e.conditionalFormattings, t), e.mergeCells = t.merges.mergeCells;
                        const r = e.rels = [];
                        function n(e) {
                            return "rId" + (e.length + 1);
                        }
                        if (e.hyperlinks.forEach((e)=>{
                            const t = n(r);
                            e.rId = t, r.push({
                                Id: t,
                                Type: o.Hyperlink,
                                Target: e.target,
                                TargetMode: "External"
                            });
                        }), e.comments.length > 0) {
                            const s = {
                                Id: n(r),
                                Type: o.Comments,
                                Target: `../comments${e.id}.xml`
                            };
                            r.push(s);
                            const a = {
                                Id: n(r),
                                Type: o.VmlDrawing,
                                Target: `../drawings/vmlDrawing${e.id}.vml`
                            };
                            r.push(a), e.comments.forEach((e)=>{
                                e.refAddress = i.decodeAddress(e.ref);
                            }), t.commentRefs.push({
                                commentName: "comments" + e.id,
                                vmlDrawing: "vmlDrawing" + e.id
                            });
                        }
                        const s = [];
                        let l;
                        e.media.forEach((i)=>{
                            if ("background" === i.type) {
                                const s = n(r);
                                l = t.media[i.imageId], r.push({
                                    Id: s,
                                    Type: o.Image,
                                    Target: `../media/${l.name}.${l.extension}`
                                }), e.background = {
                                    rId: s
                                }, e.image = t.media[i.imageId];
                            } else if ("image" === i.type) {
                                let { drawing: a } = e;
                                l = t.media[i.imageId], a || (a = e.drawing = {
                                    rId: n(r),
                                    name: "drawing" + ++t.drawingsCount,
                                    anchors: [],
                                    rels: []
                                }, t.drawings.push(a), r.push({
                                    Id: a.rId,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
                                    Target: `../drawings/${a.name}.xml`
                                }));
                                let c = this.preImageId === i.imageId ? s[i.imageId] : s[a.rels.length];
                                c || (c = n(a.rels), s[a.rels.length] = c, a.rels.push({
                                    Id: c,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                                    Target: `../media/${l.name}.${l.extension}`
                                }));
                                const u = {
                                    picture: {
                                        rId: c
                                    },
                                    range: i.range
                                };
                                if (i.hyperlinks && i.hyperlinks.hyperlink) {
                                    const e = n(a.rels);
                                    s[a.rels.length] = e, u.picture.hyperlinks = {
                                        tooltip: i.hyperlinks.tooltip,
                                        rId: e
                                    }, a.rels.push({
                                        Id: e,
                                        Type: o.Hyperlink,
                                        Target: i.hyperlinks.hyperlink,
                                        TargetMode: "External"
                                    });
                                }
                                this.preImageId = i.imageId, a.anchors.push(u);
                            }
                        }), e.tables.forEach((e)=>{
                            const i = n(r);
                            e.rId = i, r.push({
                                Id: i,
                                Type: o.Table,
                                Target: "../tables/" + e.target
                            }), e.columns.forEach((e)=>{
                                const { style: r } = e;
                                r && (e.dxfId = t.styles.addDxfStyle(r));
                            });
                        }), this.map.extLst.prepare(e, t);
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("worksheet", j.WORKSHEET_ATTRIBUTES);
                        const r = t.properties ? {
                            defaultRowHeight: t.properties.defaultRowHeight,
                            dyDescent: t.properties.dyDescent,
                            outlineLevelCol: t.properties.outlineLevelCol,
                            outlineLevelRow: t.properties.outlineLevelRow
                        } : void 0;
                        t.properties && t.properties.defaultColWidth && (r.defaultColWidth = t.properties.defaultColWidth);
                        const n = {
                            outlineProperties: t.properties && t.properties.outlineProperties,
                            tabColor: t.properties && t.properties.tabColor,
                            pageSetup: t.pageSetup && t.pageSetup.fitToPage ? {
                                fitToPage: t.pageSetup.fitToPage
                            } : void 0
                        }, i = t.pageSetup && t.pageSetup.margins, a = {
                            showRowColHeaders: t.pageSetup && t.pageSetup.showRowColHeaders,
                            showGridLines: t.pageSetup && t.pageSetup.showGridLines,
                            horizontalCentered: t.pageSetup && t.pageSetup.horizontalCentered,
                            verticalCentered: t.pageSetup && t.pageSetup.verticalCentered
                        }, l = t.sheetProtection;
                        this.map.sheetPr.render(e, n), this.map.dimension.render(e, t.dimensions), this.map.sheetViews.render(e, t.views), this.map.sheetFormatPr.render(e, r), this.map.cols.render(e, t.cols), this.map.sheetData.render(e, t.rows), this.map.sheetProtection.render(e, l), this.map.autoFilter.render(e, t.autoFilter), this.map.mergeCells.render(e, t.mergeCells), this.map.conditionalFormatting.render(e, t.conditionalFormattings), this.map.dataValidations.render(e, t.dataValidations), this.map.hyperlinks.render(e, t.hyperlinks), this.map.printOptions.render(e, a), this.map.pageMargins.render(e, i), this.map.pageSetup.render(e, t.pageSetup), this.map.headerFooter.render(e, t.headerFooter), this.map.rowBreaks.render(e, t.rowBreaks), this.map.drawing.render(e, t.drawing), this.map.picture.render(e, t.background), this.map.tableParts.render(e, t.tables), this.map.extLst.render(e, t), t.rels && t.rels.forEach((t)=>{
                            t.Type === o.VmlDrawing && e.leafNode("legacyDrawing", {
                                "r:id": t.Id
                            });
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : "worksheet" === e.name ? (n.each(this.map, (e)=>{
                            e.reset();
                        }), !0) : (this.map[e.name] && !this.ignoreNodes.includes(e.name) && (this.parser = this.map[e.name], this.parser.parseOpen(e)), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "worksheet":
                                {
                                    const e = this.map.sheetFormatPr.model || {};
                                    this.map.sheetPr.model && this.map.sheetPr.model.tabColor && (e.tabColor = this.map.sheetPr.model.tabColor), this.map.sheetPr.model && this.map.sheetPr.model.outlineProperties && (e.outlineProperties = this.map.sheetPr.model.outlineProperties);
                                    const t = {
                                        fitToPage: this.map.sheetPr.model && this.map.sheetPr.model.pageSetup && this.map.sheetPr.model.pageSetup.fitToPage || !1,
                                        margins: this.map.pageMargins.model
                                    }, r = Object.assign(t, this.map.pageSetup.model, this.map.printOptions.model), n = O(this.map.conditionalFormatting.model, this.map.extLst.model && this.map.extLst.model["x14:conditionalFormattings"]);
                                    return this.model = {
                                        dimensions: this.map.dimension.model,
                                        cols: this.map.cols.model,
                                        rows: this.map.sheetData.model,
                                        mergeCells: this.map.mergeCells.model,
                                        hyperlinks: this.map.hyperlinks.model,
                                        dataValidations: this.map.dataValidations.model,
                                        properties: e,
                                        views: this.map.sheetViews.model,
                                        pageSetup: r,
                                        headerFooter: this.map.headerFooter.model,
                                        background: this.map.picture.model,
                                        drawing: this.map.drawing.model,
                                        tables: this.map.tableParts.model,
                                        conditionalFormattings: n
                                    }, this.map.autoFilter.model && (this.model.autoFilter = this.map.autoFilter.model), this.map.sheetProtection.model && (this.model.sheetProtection = this.map.sheetProtection.model), !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        const r = (e.relationships || []).reduce((r, n)=>{
                            if (r[n.Id] = n, n.Type === o.Comments && (e.comments = t.comments[n.Target].comments), n.Type === o.VmlDrawing && e.comments && e.comments.length) {
                                const r = t.vmlDrawings[n.Target].comments;
                                e.comments.forEach((e, t)=>{
                                    e.note = Object.assign({}, e.note, r[t]);
                                });
                            }
                            return r;
                        }, {});
                        if (t.commentsMap = (e.comments || []).reduce((e, t)=>(t.ref && (e[t.ref] = t), e), {}), t.hyperlinkMap = (e.hyperlinks || []).reduce((e, t)=>(t.rId && (e[t.address] = r[t.rId].Target), e), {}), t.formulae = {}, e.rows = e.rows && e.rows.filter(Boolean) || [], e.rows.forEach((e)=>{
                            e.cells = e.cells && e.cells.filter(Boolean) || [];
                        }), this.map.cols.reconcile(e.cols, t), this.map.sheetData.reconcile(e.rows, t), this.map.conditionalFormatting.reconcile(e.conditionalFormattings, t), e.media = [], e.drawing) {
                            const n = r[e.drawing.rId].Target.match(/\/drawings\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);
                            if (n) {
                                const r = n[1];
                                t.drawings[r].anchors.forEach((t)=>{
                                    if (t.medium) {
                                        const r = {
                                            type: "image",
                                            imageId: t.medium.index,
                                            range: t.range,
                                            hyperlinks: t.picture.hyperlinks
                                        };
                                        e.media.push(r);
                                    }
                                });
                            }
                        }
                        const n = e.background && r[e.background.rId];
                        if (n) {
                            const r = n.Target.split("/media/")[1], i = t.mediaIndex && t.mediaIndex[r];
                            void 0 !== i && e.media.push({
                                type: "background",
                                imageId: i
                            });
                        }
                        e.tables = (e.tables || []).map((e)=>{
                            const n = r[e.rId];
                            return t.tables[n.Target];
                        }), delete e.relationships, delete e.hyperlinks, delete e.comments;
                    }
                }
                j.WORKSHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
                }, t.exports = j;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../../rel-type": 31,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 72,
                "./cf/conditional-formattings-xform": 87,
                "./col-xform": 92,
                "./data-validations-xform": 93,
                "./dimension-xform": 94,
                "./drawing-xform": 95,
                "./ext-lst-xform": 96,
                "./header-footer-xform": 97,
                "./hyperlink-xform": 98,
                "./merge-cell-xform": 99,
                "./merges": 100,
                "./page-margins-xform": 103,
                "./page-setup-xform": 105,
                "./picture-xform": 106,
                "./print-options-xform": 107,
                "./row-breaks-xform": 108,
                "./row-xform": 109,
                "./sheet-format-properties-xform": 110,
                "./sheet-properties-xform": 111,
                "./sheet-protection-xform": 112,
                "./sheet-view-xform": 113,
                "./table-part-xform": 114
            }
        ],
        116: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr;
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.model = !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        117: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this._format = e.format || function(e) {
                            try {
                                return Number.isNaN(e.getTime()) ? "" : e.toISOString();
                            } catch (e) {
                                return "";
                            }
                        }, this._parse = e.parse || function(e) {
                            return new Date(e);
                        };
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, this._format(t)) : e.writeText(this._format(t)), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = this._parse(e.attributes[this.attr]) : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this._parse(this.text.join(""))), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        118: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this.zero = e.zero;
                    }
                    render(e, t) {
                        (t || this.zero) && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.attr ? this.model = parseInt(e.attributes[this.attr], 10) : this.text = [], !0);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = parseInt(this.text.join("") || 0, 10)), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        119: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs;
                    }
                    render(e, t) {
                        void 0 !== t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = e.attributes[this.attr] : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this.text.join("")), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        120: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform"), i = e("../../utils/xml-stream");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    render(e) {
                        if (!this._xml) {
                            const e = new i;
                            !function e(t, r) {
                                t.openNode(r.tag, r.$), r.c && r.c.forEach((r)=>{
                                    e(t, r);
                                }), r.t && t.writeText(r.t), t.closeNode();
                            }(e, this._model), this._xml = e.xml;
                        }
                        e.writeXml(this._xml);
                    }
                    parseOpen() {
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this._model.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../utils/xml-stream": 28,
                "./base-xform": 32
            }
        ],
        121: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("../base-xform");
                t.exports = class extends s {
                    constructor(){
                        super(), this.map = {
                            r: new i,
                            t: new n
                        };
                    }
                    get tag() {
                        return "rPh";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag, {
                            sb: t.sb || 0,
                            eb: t.eb || 0
                        }), t && t.hasOwnProperty("richText") && t.richText) {
                            const { r: r } = this.map;
                            t.richText.forEach((t)=>{
                                r.render(e, t);
                            });
                        } else t && this.map.t.render(e, t.text);
                        e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {
                            sb: parseInt(e.attributes.sb, 10),
                            eb: parseInt(e.attributes.eb, 10)
                        }, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model.text = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        122: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("../style/font-xform"), s = e("../base-xform");
                class o extends s {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "r";
                    }
                    get textXform() {
                        return this._textXform || (this._textXform = new n);
                    }
                    get fontXform() {
                        return this._fontXform || (this._fontXform = new i(o.FONT_OPTIONS));
                    }
                    render(e, t) {
                        t = t || this.model, e.openNode("r"), t.font && this.fontXform.render(e, t.font), this.textXform.render(e, t.text), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "r":
                                return this.model = {}, !0;
                            case "t":
                                return this.parser = this.textXform, this.parser.parseOpen(e), !0;
                            case "rPr":
                                return this.parser = this.fontXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "r":
                                return !1;
                            case "t":
                                return this.model.text = this.parser.model, this.parser = void 0, !0;
                            case "rPr":
                                return this.model.font = this.parser.model, this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                }
                o.FONT_OPTIONS = {
                    tagName: "rPr",
                    fontNameTag: "rFont"
                }, t.exports = o;
            },
            {
                "../base-xform": 32,
                "../style/font-xform": 131,
                "./text-xform": 125
            }
        ],
        123: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("./phonetic-text-xform"), o = e("../base-xform");
                t.exports = class extends o {
                    constructor(e){
                        super(), this.model = e, this.map = {
                            r: new i,
                            t: new n,
                            rPh: new s
                        };
                    }
                    get tag() {
                        return "si";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t && t.hasOwnProperty("richText") && t.richText ? t.richText.length ? t.richText.forEach((t)=>{
                            this.map.r.render(e, t);
                        }) : this.map.t.render(e, "") : null != t && this.map.t.render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {}, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./phonetic-text-xform": 121,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        124: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./shared-string-xform");
                t.exports = class extends i {
                    constructor(e){
                        super(), this.model = e || {
                            values: [],
                            count: 0
                        }, this.hash = Object.create(null), this.rich = Object.create(null);
                    }
                    get sharedStringXform() {
                        return this._sharedStringXform || (this._sharedStringXform = new s);
                    }
                    get values() {
                        return this.model.values;
                    }
                    get uniqueCount() {
                        return this.model.values.length;
                    }
                    get count() {
                        return this.model.count;
                    }
                    getString(e) {
                        return this.model.values[e];
                    }
                    add(e) {
                        return e.richText ? this.addRichText(e) : this.addText(e);
                    }
                    addText(e) {
                        let t = this.hash[e];
                        return void 0 === t && (t = this.hash[e] = this.model.values.length, this.model.values.push(e)), this.model.count++, t;
                    }
                    addRichText(e) {
                        const t = this.sharedStringXform.toXml(e);
                        let r = this.rich[t];
                        return void 0 === r && (r = this.rich[t] = this.model.values.length, this.model.values.push(e)), this.model.count++, r;
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("sst", {
                            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                            count: t.count,
                            uniqueCount: t.values.length
                        });
                        const r = this.sharedStringXform;
                        t.values.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "sst":
                                return !0;
                            case "si":
                                return this.parser = this.sharedStringXform, this.parser.parseOpen(e), !0;
                            default:
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.values.push(this.parser.model), this.model.count++, this.parser = void 0), !0;
                        switch(e){
                            case "sst":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./shared-string-xform": 123
            }
        ],
        125: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "t";
                    }
                    render(e, t) {
                        e.openNode("t"), /^\s|\n|\s$/.test(t) && e.addAttribute("xml:space", "preserve"), e.writeText(t), e.closeNode();
                    }
                    get model() {
                        return this._text.join("").replace(/_x([0-9A-F]{4})_/g, (e, t)=>String.fromCharCode(parseInt(t, 16)));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "t":
                                return this._text = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._text.push(e);
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        126: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/utils"), s = e("../base-xform"), o = {
                    horizontalValues: [
                        "left",
                        "center",
                        "right",
                        "fill",
                        "centerContinuous",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    horizontal (e) {
                        return this.horizontalValues[e] ? e : void 0;
                    },
                    verticalValues: [
                        "top",
                        "middle",
                        "bottom",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    vertical (e) {
                        return "middle" === e ? "center" : this.verticalValues[e] ? e : void 0;
                    },
                    wrapText: (e)=>!!e || void 0,
                    shrinkToFit: (e)=>!!e || void 0,
                    textRotation (e) {
                        switch(e){
                            case "vertical":
                                return e;
                            default:
                                return (e = i.validInt(e)) >= -90 && e <= 90 ? e : void 0;
                        }
                    },
                    indent: (e)=>(e = i.validInt(e), Math.max(0, e)),
                    readingOrder (e) {
                        switch(e){
                            case "ltr":
                                return n.ReadingOrder.LeftToRight;
                            case "rtl":
                                return n.ReadingOrder.RightToLeft;
                            default:
                                return;
                        }
                    }
                }, a = {
                    toXml (e) {
                        if (e = o.textRotation(e)) {
                            if ("vertical" === e) return 255;
                            const t = Math.round(e);
                            if (t >= 0 && t <= 90) return t;
                            if (t < 0 && t >= -90) return 90 - t;
                        }
                    },
                    toModel (e) {
                        const t = i.validInt(e);
                        if (void 0 !== t) {
                            if (255 === t) return "vertical";
                            if (t >= 0 && t <= 90) return t;
                            if (t > 90 && t <= 180) return 90 - t;
                        }
                    }
                };
                t.exports = class extends s {
                    get tag() {
                        return "alignment";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("alignment");
                        let r = !1;
                        function n(t, n) {
                            n && (e.addAttribute(t, n), r = !0);
                        }
                        n("horizontal", o.horizontal(t.horizontal)), n("vertical", o.vertical(t.vertical)), n("wrapText", !!o.wrapText(t.wrapText) && "1"), n("shrinkToFit", !!o.shrinkToFit(t.shrinkToFit) && "1"), n("indent", o.indent(t.indent)), n("textRotation", a.toXml(t.textRotation)), n("readingOrder", o.readingOrder(t.readingOrder)), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {};
                        let r = !1;
                        function n(e, n, i) {
                            e && (t[n] = i, r = !0);
                        }
                        n(e.attributes.horizontal, "horizontal", e.attributes.horizontal), n(e.attributes.vertical, "vertical", "center" === e.attributes.vertical ? "middle" : e.attributes.vertical), n(e.attributes.wrapText, "wrapText", i.parseBoolean(e.attributes.wrapText)), n(e.attributes.shrinkToFit, "shrinkToFit", i.parseBoolean(e.attributes.shrinkToFit)), n(e.attributes.indent, "indent", parseInt(e.attributes.indent, 10)), n(e.attributes.textRotation, "textRotation", a.toModel(e.attributes.textRotation)), n(e.attributes.readingOrder, "readingOrder", "2" === e.attributes.readingOrder ? "rtl" : "ltr"), this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        127: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./color-xform");
                class o extends n {
                    constructor(e){
                        super(), this.name = e, this.map = {
                            color: new s
                        };
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t, r) {
                        const n = t && t.color || r || this.defaultColor;
                        e.openNode(this.name), t && t.style && (e.addAttribute("style", t.style), n && this.map.color.render(e, n)), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.name:
                                {
                                    const { style: t } = e.attributes;
                                    return this.model = t ? {
                                        style: t
                                    } : void 0, !0;
                                }
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (e === this.name && this.map.color.model && (this.model || (this.model = {}), this.model.color = this.map.color.model), !1);
                    }
                    validStyle(e) {
                        return o.validStyleValues[e];
                    }
                }
                o.validStyleValues = [
                    "thin",
                    "dashed",
                    "dotted",
                    "dashDot",
                    "hair",
                    "dashDotDot",
                    "slantDashDot",
                    "mediumDashed",
                    "mediumDashDotDot",
                    "mediumDashDot",
                    "medium",
                    "double",
                    "thick"
                ].reduce((e, t)=>(e[t] = !0, e), {});
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            top: new o("top"),
                            left: new o("left"),
                            bottom: new o("bottom"),
                            right: new o("right"),
                            diagonal: new o("diagonal")
                        };
                    }
                    render(e, t) {
                        const { color: r } = t;
                        function n(n, i) {
                            n && !n.color && t.color && (n = {
                                ...n,
                                color: t.color
                            }), i.render(e, n, r);
                        }
                        e.openNode("border"), t.diagonal && t.diagonal.style && (t.diagonal.up && e.addAttribute("diagonalUp", "1"), t.diagonal.down && e.addAttribute("diagonalDown", "1")), n(t.left, this.map.left), n(t.right, this.map.right), n(t.top, this.map.top), n(t.bottom, this.map.bottom), n(t.diagonal, this.map.diagonal), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "border":
                                return this.reset(), this.diagonalUp = i.parseBoolean(e.attributes.diagonalUp), this.diagonalDown = i.parseBoolean(e.attributes.diagonalDown), !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        if ("border" === e) {
                            const e = this.model = {}, t = function(t, r, n) {
                                r && (n && Object.assign(r, n), e[t] = r);
                            };
                            t("left", this.map.left.model), t("right", this.map.right.model), t("top", this.map.top.model), t("bottom", this.map.bottom.model), t("diagonal", this.map.diagonal.model, {
                                up: this.diagonalUp,
                                down: this.diagonalDown
                            });
                        }
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        128: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.name = e || "color";
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t) {
                        return !!t && (e.openNode(this.name), t.argb ? e.addAttribute("rgb", t.argb) : void 0 !== t.theme ? (e.addAttribute("theme", t.theme), void 0 !== t.tint && e.addAttribute("tint", t.tint)) : void 0 !== t.indexed ? e.addAttribute("indexed", t.indexed) : e.addAttribute("auto", "1"), e.closeNode(), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.name && (e.attributes.rgb ? this.model = {
                            argb: e.attributes.rgb
                        } : e.attributes.theme ? (this.model = {
                            theme: parseInt(e.attributes.theme, 10)
                        }, e.attributes.tint && (this.model.tint = parseFloat(e.attributes.tint))) : e.attributes.indexed ? this.model = {
                            indexed: parseInt(e.attributes.indexed, 10)
                        } : this.model = void 0, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        129: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./border-xform"), o = e("./fill-xform"), a = e("./font-xform"), l = e("./numfmt-xform"), c = e("./protection-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            alignment: new i,
                            border: new s,
                            fill: new o,
                            font: new a,
                            numFmt: new l,
                            protection: new c
                        };
                    }
                    get tag() {
                        return "dxf";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag), t.font && this.map.font.render(e, t.font), t.numFmt && t.numFmtId) {
                            const r = {
                                id: t.numFmtId,
                                formatCode: t.numFmt
                            };
                            this.map.numFmt.render(e, r);
                        }
                        t.fill && this.map.fill.render(e, t.fill), t.alignment && this.map.alignment.render(e, t.alignment), t.border && this.map.border.render(e, t.border), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.reset(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : e !== this.tag || (this.model = {
                            alignment: this.map.alignment.model,
                            border: this.map.border.model,
                            fill: this.map.fill.model,
                            font: this.map.font.model,
                            numFmt: this.map.numFmt.model,
                            protection: this.map.protection.model
                        }, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./border-xform": 127,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./protection-xform": 133
            }
        ],
        130: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./color-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            color: new i
                        };
                    }
                    get tag() {
                        return "stop";
                    }
                    render(e, t) {
                        e.openNode("stop"), e.addAttribute("position", t.position), this.map.color.render(e, t.color), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "stop":
                                return this.model = {
                                    position: parseFloat(e.attributes.position)
                                }, !0;
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.color = this.parser.model, this.parser = void 0), !0);
                    }
                }
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            fgColor: new i("fgColor"),
                            bgColor: new i("bgColor")
                        };
                    }
                    get name() {
                        return "pattern";
                    }
                    get tag() {
                        return "patternFill";
                    }
                    render(e, t) {
                        e.openNode("patternFill"), e.addAttribute("patternType", t.pattern), t.fgColor && this.map.fgColor.render(e, t.fgColor), t.bgColor && this.map.bgColor.render(e, t.bgColor), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "patternFill":
                                return this.model = {
                                    type: "pattern",
                                    pattern: e.attributes.patternType
                                }, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.parser.model && (this.model[e] = this.parser.model), this.parser = void 0), !0);
                    }
                }
                class a extends n {
                    constructor(){
                        super(), this.map = {
                            stop: new s
                        };
                    }
                    get name() {
                        return "gradient";
                    }
                    get tag() {
                        return "gradientFill";
                    }
                    render(e, t) {
                        switch(e.openNode("gradientFill"), t.gradient){
                            case "angle":
                                e.addAttribute("degree", t.degree);
                                break;
                            case "path":
                                e.addAttribute("type", "path"), t.center.left && (e.addAttribute("left", t.center.left), void 0 === t.center.right && e.addAttribute("right", t.center.left)), t.center.right && e.addAttribute("right", t.center.right), t.center.top && (e.addAttribute("top", t.center.top), void 0 === t.center.bottom && e.addAttribute("bottom", t.center.top)), t.center.bottom && e.addAttribute("bottom", t.center.bottom);
                        }
                        const r = this.map.stop;
                        t.stops.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "gradientFill":
                                {
                                    const t = this.model = {
                                        stops: []
                                    };
                                    return e.attributes.degree ? (t.gradient = "angle", t.degree = parseInt(e.attributes.degree, 10)) : "path" === e.attributes.type && (t.gradient = "path", t.center = {
                                        left: e.attributes.left ? parseFloat(e.attributes.left) : 0,
                                        top: e.attributes.top ? parseFloat(e.attributes.top) : 0
                                    }, e.attributes.right !== e.attributes.left && (t.center.right = e.attributes.right ? parseFloat(e.attributes.right) : 0), e.attributes.bottom !== e.attributes.top && (t.center.bottom = e.attributes.bottom ? parseFloat(e.attributes.bottom) : 0)), !0;
                                }
                            case "stop":
                                return this.parser = this.map.stop, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.stops.push(this.parser.model), this.parser = void 0), !0);
                    }
                }
                class l extends n {
                    constructor(){
                        super(), this.map = {
                            patternFill: new o,
                            gradientFill: new a
                        };
                    }
                    get tag() {
                        return "fill";
                    }
                    render(e, t) {
                        switch(e.addRollback(), e.openNode("fill"), t.type){
                            case "pattern":
                                this.map.patternFill.render(e, t);
                                break;
                            case "gradient":
                                this.map.gradientFill.render(e, t);
                                break;
                            default:
                                return void e.rollback();
                        }
                        e.closeNode(), e.commit();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "fill":
                                return this.model = {}, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model = this.parser.model, this.model.type = this.parser.name, this.parser = void 0), !0);
                    }
                    validStyle(e) {
                        return l.validPatternValues[e];
                    }
                }
                l.validPatternValues = [
                    "none",
                    "solid",
                    "darkVertical",
                    "darkGray",
                    "mediumGray",
                    "lightGray",
                    "gray125",
                    "gray0625",
                    "darkHorizontal",
                    "darkVertical",
                    "darkDown",
                    "darkUp",
                    "darkGrid",
                    "darkTrellis",
                    "lightHorizontal",
                    "lightVertical",
                    "lightDown",
                    "lightUp",
                    "lightGrid",
                    "lightTrellis",
                    "lightGrid"
                ].reduce((e, t)=>(e[t] = !0, e), {}), l.StopXform = s, l.PatternFillXform = o, l.GradientFillXform = a, t.exports = l;
            },
            {
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        131: [
            function(e, t, r) {
                "use strict";
                const n = e("./color-xform"), i = e("../simple/boolean-xform"), s = e("../simple/integer-xform"), o = e("../simple/string-xform"), a = e("./underline-xform"), l = e("../../../utils/under-dash"), c = e("../base-xform");
                class u extends c {
                    constructor(e){
                        super(), this.options = e || u.OPTIONS, this.map = {
                            b: {
                                prop: "bold",
                                xform: new i({
                                    tag: "b",
                                    attr: "val"
                                })
                            },
                            i: {
                                prop: "italic",
                                xform: new i({
                                    tag: "i",
                                    attr: "val"
                                })
                            },
                            u: {
                                prop: "underline",
                                xform: new a
                            },
                            charset: {
                                prop: "charset",
                                xform: new s({
                                    tag: "charset",
                                    attr: "val"
                                })
                            },
                            color: {
                                prop: "color",
                                xform: new n
                            },
                            condense: {
                                prop: "condense",
                                xform: new i({
                                    tag: "condense",
                                    attr: "val"
                                })
                            },
                            extend: {
                                prop: "extend",
                                xform: new i({
                                    tag: "extend",
                                    attr: "val"
                                })
                            },
                            family: {
                                prop: "family",
                                xform: new s({
                                    tag: "family",
                                    attr: "val"
                                })
                            },
                            outline: {
                                prop: "outline",
                                xform: new i({
                                    tag: "outline",
                                    attr: "val"
                                })
                            },
                            vertAlign: {
                                prop: "vertAlign",
                                xform: new o({
                                    tag: "vertAlign",
                                    attr: "val"
                                })
                            },
                            scheme: {
                                prop: "scheme",
                                xform: new o({
                                    tag: "scheme",
                                    attr: "val"
                                })
                            },
                            shadow: {
                                prop: "shadow",
                                xform: new i({
                                    tag: "shadow",
                                    attr: "val"
                                })
                            },
                            strike: {
                                prop: "strike",
                                xform: new i({
                                    tag: "strike",
                                    attr: "val"
                                })
                            },
                            sz: {
                                prop: "size",
                                xform: new s({
                                    tag: "sz",
                                    attr: "val"
                                })
                            }
                        }, this.map[this.options.fontNameTag] = {
                            prop: "name",
                            xform: new o({
                                tag: this.options.fontNameTag,
                                attr: "val"
                            })
                        };
                    }
                    get tag() {
                        return this.options.tagName;
                    }
                    render(e, t) {
                        const { map: r } = this;
                        e.openNode(this.options.tagName), l.each(this.map, (n, i)=>{
                            r[i].xform.render(e, t[n.prop]);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if (this.map[e.name]) return this.parser = this.map[e.name].xform, this.parser.parseOpen(e);
                        switch(e.name){
                            case this.options.tagName:
                                return this.model = {}, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser && !this.parser.parseClose(e)) {
                            const t = this.map[e];
                            return this.parser.model && (this.model[t.prop] = this.parser.model), this.parser = void 0, !0;
                        }
                        switch(e){
                            case this.options.tagName:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                }
                u.OPTIONS = {
                    tagName: "font",
                    fontNameTag: "name"
                }, t.exports = u;
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32,
                "../simple/boolean-xform": 116,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119,
                "./color-xform": 128,
                "./underline-xform": 136
            }
        ],
        132: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../defaultnumformats"), s = e("../base-xform");
                const o = function() {
                    const e = {};
                    return n.each(i, (t, r)=>{
                        t.f && (e[t.f] = parseInt(r, 10));
                    }), e;
                }();
                class a extends s {
                    constructor(e, t){
                        super(), this.id = e, this.formatCode = t;
                    }
                    get tag() {
                        return "numFmt";
                    }
                    render(e, t) {
                        e.leafNode("numFmt", {
                            numFmtId: t.id,
                            formatCode: t.formatCode
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "numFmt":
                                return this.model = {
                                    id: parseInt(e.attributes.numFmtId, 10),
                                    formatCode: e.attributes.formatCode.replace(/[\\](.)/g, "$1")
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                a.getDefaultFmtId = function(e) {
                    return o[e];
                }, a.getDefaultFmtCode = function(e) {
                    return i[e] && i[e].f;
                }, t.exports = a;
            },
            {
                "../../../utils/under-dash": 26,
                "../../defaultnumformats": 30,
                "../base-xform": 32
            }
        ],
        133: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = {
                    boolean: (e, t)=>void 0 === e ? t : e
                };
                t.exports = class extends n {
                    get tag() {
                        return "protection";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("protection");
                        let r = !1;
                        function n(t, n) {
                            void 0 !== n && (e.addAttribute(t, n), r = !0);
                        }
                        n("locked", i.boolean(t.locked, !0) ? void 0 : "0"), n("hidden", i.boolean(t.hidden, !1) ? "1" : void 0), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {
                            locked: !("0" === e.attributes.locked),
                            hidden: "1" === e.attributes.hidden
                        }, r = !t.locked || t.hidden;
                        this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        134: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./protection-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.xfId = !(!e || !e.xfId), this.map = {
                            alignment: new i,
                            protection: new s
                        };
                    }
                    get tag() {
                        return "xf";
                    }
                    render(e, t) {
                        e.openNode("xf", {
                            numFmtId: t.numFmtId || 0,
                            fontId: t.fontId || 0,
                            fillId: t.fillId || 0,
                            borderId: t.borderId || 0
                        }), this.xfId && e.addAttribute("xfId", t.xfId || 0), t.numFmtId && e.addAttribute("applyNumberFormat", "1"), t.fontId && e.addAttribute("applyFont", "1"), t.fillId && e.addAttribute("applyFill", "1"), t.borderId && e.addAttribute("applyBorder", "1"), t.alignment && e.addAttribute("applyAlignment", "1"), t.protection && e.addAttribute("applyProtection", "1"), t.alignment && this.map.alignment.render(e, t.alignment), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "xf":
                                return this.model = {
                                    numFmtId: parseInt(e.attributes.numFmtId, 10),
                                    fontId: parseInt(e.attributes.fontId, 10),
                                    fillId: parseInt(e.attributes.fillId, 10),
                                    borderId: parseInt(e.attributes.borderId, 10)
                                }, this.xfId && (this.model.xfId = parseInt(e.attributes.xfId, 10)), !0;
                            case "alignment":
                                return this.parser = this.map.alignment, this.parser.parseOpen(e), !0;
                            case "protection":
                                return this.parser = this.map.protection, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.map.protection === this.parser ? this.model.protection = this.parser.model : this.model.alignment = this.parser.model, this.parser = void 0), !0) : "xf" !== e;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./protection-xform": 133
            }
        ],
        135: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("../static-xform"), a = e("../list-xform"), l = e("./font-xform"), c = e("./fill-xform"), u = e("./border-xform"), h = e("./numfmt-xform"), f = e("./style-xform"), d = e("./dxf-xform");
                class p extends s {
                    constructor(e){
                        super(), this.map = {
                            numFmts: new a({
                                tag: "numFmts",
                                count: !0,
                                childXform: new h
                            }),
                            fonts: new a({
                                tag: "fonts",
                                count: !0,
                                childXform: new l,
                                $: {
                                    "x14ac:knownFonts": 1
                                }
                            }),
                            fills: new a({
                                tag: "fills",
                                count: !0,
                                childXform: new c
                            }),
                            borders: new a({
                                tag: "borders",
                                count: !0,
                                childXform: new u
                            }),
                            cellStyleXfs: new a({
                                tag: "cellStyleXfs",
                                count: !0,
                                childXform: new f
                            }),
                            cellXfs: new a({
                                tag: "cellXfs",
                                count: !0,
                                childXform: new f({
                                    xfId: !0
                                })
                            }),
                            dxfs: new a({
                                tag: "dxfs",
                                always: !0,
                                count: !0,
                                childXform: new d
                            }),
                            numFmt: new h,
                            font: new l,
                            fill: new c,
                            border: new u,
                            style: new f({
                                xfId: !0
                            }),
                            cellStyles: p.STATIC_XFORMS.cellStyles,
                            tableStyles: p.STATIC_XFORMS.tableStyles,
                            extLst: p.STATIC_XFORMS.extLst
                        }, e && this.init();
                    }
                    initIndex() {
                        this.index = {
                            style: {},
                            numFmt: {},
                            numFmtNextId: 164,
                            font: {},
                            border: {},
                            fill: {}
                        };
                    }
                    init() {
                        this.model = {
                            styles: [],
                            numFmts: [],
                            fonts: [],
                            borders: [],
                            fills: [],
                            dxfs: []
                        }, this.initIndex(), this._addBorder({}), this._addStyle({
                            numFmtId: 0,
                            fontId: 0,
                            fillId: 0,
                            borderId: 0,
                            xfId: 0
                        }), this._addFill({
                            type: "pattern",
                            pattern: "none"
                        }), this._addFill({
                            type: "pattern",
                            pattern: "gray125"
                        }), this.weakMap = new WeakMap;
                    }
                    render(e, t) {
                        t = t || this.model, e.openXml(i.StdDocAttributes), e.openNode("styleSheet", p.STYLESHEET_ATTRIBUTES), this.index ? (t.numFmts && t.numFmts.length && (e.openNode("numFmts", {
                            count: t.numFmts.length
                        }), t.numFmts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()), t.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), e.openNode("fonts", {
                            count: t.fonts.length,
                            "x14ac:knownFonts": 1
                        }), t.fonts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("fills", {
                            count: t.fills.length
                        }), t.fills.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("borders", {
                            count: t.borders.length
                        }), t.borders.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), e.openNode("cellXfs", {
                            count: t.styles.length
                        }), t.styles.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()) : (this.map.numFmts.render(e, t.numFmts), this.map.fonts.render(e, t.fonts), this.map.fills.render(e, t.fills), this.map.borders.render(e, t.borders), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), this.map.cellXfs.render(e, t.styles)), p.STATIC_XFORMS.cellStyles.render(e), this.map.dxfs.render(e, t.dxfs), p.STATIC_XFORMS.tableStyles.render(e), p.STATIC_XFORMS.extLst.render(e), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "styleSheet":
                                return this.initIndex(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "styleSheet":
                                {
                                    this.model = {};
                                    const e = (e, t)=>{
                                        t.model && t.model.length && (this.model[e] = t.model);
                                    };
                                    if (e("numFmts", this.map.numFmts), e("fonts", this.map.fonts), e("fills", this.map.fills), e("borders", this.map.borders), e("styles", this.map.cellXfs), e("dxfs", this.map.dxfs), this.index = {
                                        model: [],
                                        numFmt: []
                                    }, this.model.numFmts) {
                                        const e = this.index.numFmt;
                                        this.model.numFmts.forEach((t)=>{
                                            e[t.id] = t.formatCode;
                                        });
                                    }
                                    return !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    addStyleModel(e, t) {
                        if (!e) return 0;
                        if (this.model.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), this.weakMap && this.weakMap.has(e)) return this.weakMap.get(e);
                        const r = {};
                        if (t = t || n.ValueType.Number, e.numFmt) r.numFmtId = this._addNumFmtStr(e.numFmt);
                        else switch(t){
                            case n.ValueType.Number:
                                r.numFmtId = this._addNumFmtStr("General");
                                break;
                            case n.ValueType.Date:
                                r.numFmtId = this._addNumFmtStr("mm-dd-yy");
                        }
                        e.font && (r.fontId = this._addFont(e.font)), e.border && (r.borderId = this._addBorder(e.border)), e.fill && (r.fillId = this._addFill(e.fill)), e.alignment && (r.alignment = e.alignment), e.protection && (r.protection = e.protection);
                        const i = this._addStyle(r);
                        return this.weakMap && this.weakMap.set(e, i), i;
                    }
                    getStyleModel(e) {
                        const t = this.model.styles[e];
                        if (!t) return null;
                        let r = this.index.model[e];
                        if (r) return r;
                        if (r = this.index.model[e] = {}, t.numFmtId) {
                            const e = this.index.numFmt[t.numFmtId] || h.getDefaultFmtCode(t.numFmtId);
                            e && (r.numFmt = e);
                        }
                        function n(e, t, n) {
                            if (n || 0 === n) {
                                const i = t[n];
                                i && (r[e] = i);
                            }
                        }
                        return n("font", this.model.fonts, t.fontId), n("border", this.model.borders, t.borderId), n("fill", this.model.fills, t.fillId), t.alignment && (r.alignment = t.alignment), t.protection && (r.protection = t.protection), r;
                    }
                    addDxfStyle(e) {
                        return e.numFmt && (e.numFmtId = this._addNumFmtStr(e.numFmt)), this.model.dxfs.push(e), this.model.dxfs.length - 1;
                    }
                    getDxfStyle(e) {
                        return this.model.dxfs[e];
                    }
                    _addStyle(e) {
                        const t = this.map.style.toXml(e);
                        let r = this.index.style[t];
                        return void 0 === r && (r = this.index.style[t] = this.model.styles.length, this.model.styles.push(t)), r;
                    }
                    _addNumFmtStr(e) {
                        let t = h.getDefaultFmtId(e);
                        if (void 0 !== t) return t;
                        if (t = this.index.numFmt[e], void 0 !== t) return t;
                        t = this.index.numFmt[e] = 164 + this.model.numFmts.length;
                        const r = this.map.numFmt.toXml({
                            id: t,
                            formatCode: e
                        });
                        return this.model.numFmts.push(r), t;
                    }
                    _addFont(e) {
                        const t = this.map.font.toXml(e);
                        let r = this.index.font[t];
                        return void 0 === r && (r = this.index.font[t] = this.model.fonts.length, this.model.fonts.push(t)), r;
                    }
                    _addBorder(e) {
                        const t = this.map.border.toXml(e);
                        let r = this.index.border[t];
                        return void 0 === r && (r = this.index.border[t] = this.model.borders.length, this.model.borders.push(t)), r;
                    }
                    _addFill(e) {
                        const t = this.map.fill.toXml(e);
                        let r = this.index.fill[t];
                        return void 0 === r && (r = this.index.fill[t] = this.model.fills.length, this.model.fills.push(t)), r;
                    }
                }
                p.STYLESHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac x16r2",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"
                }, p.STATIC_XFORMS = {
                    cellStyles: new o({
                        tag: "cellStyles",
                        $: {
                            count: 1
                        },
                        c: [
                            {
                                tag: "cellStyle",
                                $: {
                                    name: "Normal",
                                    xfId: 0,
                                    builtinId: 0
                                }
                            }
                        ]
                    }),
                    dxfs: new o({
                        tag: "dxfs",
                        $: {
                            count: 0
                        }
                    }),
                    tableStyles: new o({
                        tag: "tableStyles",
                        $: {
                            count: 0,
                            defaultTableStyle: "TableStyleMedium2",
                            defaultPivotStyle: "PivotStyleLight16"
                        }
                    }),
                    extLst: new o({
                        tag: "extLst",
                        c: [
                            {
                                tag: "ext",
                                $: {
                                    uri: "{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}",
                                    "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                                },
                                c: [
                                    {
                                        tag: "x14:slicerStyles",
                                        $: {
                                            defaultSlicerStyle: "SlicerStyleLight1"
                                        }
                                    }
                                ]
                            },
                            {
                                tag: "ext",
                                $: {
                                    uri: "{9260A510-F301-46a8-8635-F512D64BE5F5}",
                                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                                },
                                c: [
                                    {
                                        tag: "x15:timelineStyles",
                                        $: {
                                            defaultTimelineStyle: "TimeSlicerStyleLight1"
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                };
                p.Mock = class extends p {
                    constructor(){
                        super(), this.model = {
                            styles: [
                                {
                                    numFmtId: 0,
                                    fontId: 0,
                                    fillId: 0,
                                    borderId: 0,
                                    xfId: 0
                                }
                            ],
                            numFmts: [],
                            fonts: [
                                {
                                    size: 11,
                                    color: {
                                        theme: 1
                                    },
                                    name: "Calibri",
                                    family: 2,
                                    scheme: "minor"
                                }
                            ],
                            borders: [
                                {}
                            ],
                            fills: [
                                {
                                    type: "pattern",
                                    pattern: "none"
                                },
                                {
                                    type: "pattern",
                                    pattern: "gray125"
                                }
                            ]
                        };
                    }
                    parseStream(e) {
                        return e.autodrain(), Promise.resolve();
                    }
                    addStyleModel(e, t) {
                        switch(t){
                            case n.ValueType.Date:
                                return this.dateStyleId;
                            default:
                                return 0;
                        }
                    }
                    get dateStyleId() {
                        if (!this._dateStyleId) {
                            const e = {
                                numFmtId: h.getDefaultFmtId("mm-dd-yy")
                            };
                            this._dateStyleId = this.model.styles.length, this.model.styles.push(e);
                        }
                        return this._dateStyleId;
                    }
                    getStyleModel() {
                        return {};
                    }
                }, t.exports = p;
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./border-xform": 127,
                "./dxf-xform": 129,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./style-xform": 134
            }
        ],
        136: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                class i extends n {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "u";
                    }
                    render(e, t) {
                        if (!0 === (t = t || this.model)) e.leafNode("u");
                        else {
                            const r = i.Attributes[t];
                            r && e.leafNode("u", r);
                        }
                    }
                    parseOpen(e) {
                        "u" === e.name && (this.model = e.attributes.val || !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                i.Attributes = {
                    single: {},
                    double: {
                        val: "double"
                    },
                    singleAccounting: {
                        val: "singleAccounting"
                    },
                    doubleAccounting: {
                        val: "doubleAccounting"
                    }
                }, t.exports = i;
            },
            {
                "../base-xform": 32
            }
        ],
        137: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./filter-column-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            filterColumn: new i
                        };
                    }
                    get tag() {
                        return "autoFilter";
                    }
                    prepare(e) {
                        e.columns.forEach((e, t)=>{
                            this.map.filterColumn.prepare(e, {
                                index: t
                            });
                        });
                    }
                    render(e, t) {
                        return e.openNode(this.tag, {
                            ref: t.autoFilterRef
                        }), t.columns.forEach((t)=>{
                            this.map.filterColumn.render(e, t);
                        }), e.closeNode(), !0;
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    autoFilterRef: e.attributes.ref,
                                    columns: []
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.columns.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./filter-column-xform": 139
            }
        ],
        138: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "customFilter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val,
                            operator: t.operator
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val,
                            operator: e.attributes.operator
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        139: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../list-xform"), s = e("./custom-filter-xform"), o = e("./filter-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            customFilters: new i({
                                tag: "customFilters",
                                count: !1,
                                empty: !0,
                                childXform: new s
                            }),
                            filters: new i({
                                tag: "filters",
                                count: !1,
                                empty: !0,
                                childXform: new o
                            })
                        };
                    }
                    get tag() {
                        return "filterColumn";
                    }
                    prepare(e, t) {
                        e.colId = t.index.toString();
                    }
                    render(e, t) {
                        return t.customFilters ? (e.openNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), this.map.customFilters.render(e, t.customFilters), e.closeNode(), !0) : (e.leafNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), !0);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { attributes: t } = e;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    filterButton: "0" === t.hiddenButton
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.customFilters = this.map.customFilters.model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../list-xform": 71,
                "./custom-filter-xform": 138,
                "./filter-xform": 140
            }
        ],
        140: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "filter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        141: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableColumn";
                    }
                    prepare(e, t) {
                        e.id = t.index + 1;
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            id: t.id.toString(),
                            name: t.name,
                            totalsRowLabel: t.totalsRowLabel,
                            totalsRowFunction: t.totalsRowFunction,
                            dxfId: t.dxfId
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                name: t.name,
                                totalsRowLabel: t.totalsRowLabel,
                                totalsRowFunction: t.totalsRowFunction,
                                dxfId: t.dxfId
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        142: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableStyleInfo";
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            name: t.theme ? t.theme : void 0,
                            showFirstColumn: t.showFirstColumn ? "1" : "0",
                            showLastColumn: t.showLastColumn ? "1" : "0",
                            showRowStripes: t.showRowStripes ? "1" : "0",
                            showColumnStripes: t.showColumnStripes ? "1" : "0"
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                theme: t.name ? t.name : null,
                                showFirstColumn: "1" === t.showFirstColumn,
                                showLastColumn: "1" === t.showLastColumn,
                                showRowStripes: "1" === t.showRowStripes,
                                showColumnStripes: "1" === t.showColumnStripes
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        143: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../list-xform"), o = e("./auto-filter-xform"), a = e("./table-column-xform"), l = e("./table-style-info-xform");
                class c extends i {
                    constructor(){
                        super(), this.map = {
                            autoFilter: new o,
                            tableColumns: new s({
                                tag: "tableColumns",
                                count: !0,
                                empty: !0,
                                childXform: new a
                            }),
                            tableStyleInfo: new l
                        };
                    }
                    prepare(e, t) {
                        this.map.autoFilter.prepare(e), this.map.tableColumns.prepare(e.columns, t);
                    }
                    get tag() {
                        return "table";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, {
                            ...c.TABLE_ATTRIBUTES,
                            id: t.id,
                            name: t.name,
                            displayName: t.displayName || t.name,
                            ref: t.tableRef,
                            totalsRowCount: t.totalsRow ? "1" : void 0,
                            totalsRowShown: t.totalsRow ? void 0 : "1",
                            headerRowCount: t.headerRow ? "1" : "0"
                        }), this.map.autoFilter.render(e, t), this.map.tableColumns.render(e, t.columns), this.map.tableStyleInfo.render(e, t.style), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { name: t, attributes: r } = e;
                        switch(t){
                            case this.tag:
                                this.reset(), this.model = {
                                    name: r.name,
                                    displayName: r.displayName || r.name,
                                    tableRef: r.ref,
                                    totalsRow: "1" === r.totalsRowCount,
                                    headerRow: "1" === r.headerRowCount
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.columns = this.map.tableColumns.model, this.map.autoFilter.model && (this.model.autoFilterRef = this.map.autoFilter.model.autoFilterRef, this.map.autoFilter.model.columns.forEach((e, t)=>{
                                    this.model.columns[t].filterButton = e.filterButton;
                                })), this.model.style = this.map.tableStyleInfo.model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.columns.forEach((e)=>{
                            void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId));
                        });
                    }
                }
                c.TABLE_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3"
                }, t.exports = c;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 137,
                "./table-column-xform": 141,
                "./table-style-info-xform": 142
            }
        ],
        144: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = e("jszip"), { PassThrough: o } = e("readable-stream"), a = e("../utils/zip-stream"), l = e("../utils/stream-buf"), c = e("../utils/utils"), u = e("../utils/xml-stream"), { bufferToString: h } = e("../utils/browser-buffer-decode"), f = e("./xform/style/styles-xform"), d = e("./xform/core/core-xform"), p = e("./xform/strings/shared-strings-xform"), m = e("./xform/core/relationships-xform"), b = e("./xform/core/content-types-xform"), g = e("./xform/core/app-xform"), y = e("./xform/book/workbook-xform"), v = e("./xform/sheet/worksheet-xform"), w = e("./xform/drawing/drawing-xform"), _ = e("./xform/table/table-xform"), x = e("./xform/comment/comments-xform"), k = e("./xform/comment/vml-notes-xform"), S = e("./xml/theme1");
                        class M {
                            constructor(e){
                                this.workbook = e;
                            }
                            async readFile(e, t) {
                                if (!await c.fs.exists(e)) throw new Error("File not found: " + e);
                                const r = i.createReadStream(e);
                                try {
                                    const e = await this.read(r, t);
                                    return r.close(), e;
                                } catch (e) {
                                    throw r.close(), e;
                                }
                            }
                            parseRels(e) {
                                return (new m).parseStream(e);
                            }
                            parseWorkbook(e) {
                                return (new y).parseStream(e);
                            }
                            parseSharedStrings(e) {
                                return (new p).parseStream(e);
                            }
                            reconcile(e, t) {
                                const r = new y, n = new v(t), i = new w, s = new _;
                                r.reconcile(e);
                                const o = {
                                    media: e.media,
                                    mediaIndex: e.mediaIndex
                                };
                                Object.keys(e.drawings).forEach((t)=>{
                                    const r = e.drawings[t], n = e.drawingRels[t];
                                    n && (o.rels = n.reduce((e, t)=>(e[t.Id] = t, e), {}), (r.anchors || []).forEach((e)=>{
                                        const t = e.picture && e.picture.hyperlinks;
                                        t && o.rels[t.rId] && (t.hyperlink = o.rels[t.rId].Target, delete t.rId);
                                    }), i.reconcile(r, o));
                                });
                                const a = {
                                    styles: e.styles
                                };
                                Object.values(e.tables).forEach((e)=>{
                                    s.reconcile(e, a);
                                });
                                const l = {
                                    styles: e.styles,
                                    sharedStrings: e.sharedStrings,
                                    media: e.media,
                                    mediaIndex: e.mediaIndex,
                                    date1904: e.properties && e.properties.date1904,
                                    drawings: e.drawings,
                                    comments: e.comments,
                                    tables: e.tables,
                                    vmlDrawings: e.vmlDrawings
                                };
                                e.worksheets.forEach((t)=>{
                                    t.relationships = e.worksheetRels[t.sheetNo], n.reconcile(t, l);
                                }), delete e.worksheetHash, delete e.worksheetRels, delete e.globalRels, delete e.sharedStrings, delete e.workbookRels, delete e.sheetDefs, delete e.styles, delete e.mediaIndex, delete e.drawings, delete e.drawingRels, delete e.vmlDrawings;
                            }
                            async _processWorksheetEntry(e, t, r, n, i) {
                                const s = new v(n), o = await s.parseStream(e);
                                o.sheetNo = r, t.worksheetHash[i] = o, t.worksheets.push(o);
                            }
                            async _processCommentEntry(e, t, r) {
                                const n = new x, i = await n.parseStream(e);
                                t.comments[`../${r}.xml`] = i;
                            }
                            async _processTableEntry(e, t, r) {
                                const n = new _, i = await n.parseStream(e);
                                t.tables[`../tables/${r}.xml`] = i;
                            }
                            async _processWorksheetRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.worksheetRels[r] = i;
                            }
                            async _processMediaEntry(e, t, r) {
                                const n = r.lastIndexOf(".");
                                if (n >= 1) {
                                    const i = r.substr(n + 1), s = r.substr(0, n);
                                    await new Promise((n, o)=>{
                                        const a = new l;
                                        a.on("finish", ()=>{
                                            t.mediaIndex[r] = t.media.length, t.mediaIndex[s] = t.media.length;
                                            const e = {
                                                type: "image",
                                                name: s,
                                                extension: i,
                                                buffer: a.toBuffer()
                                            };
                                            t.media.push(e), n();
                                        }), e.on("error", (e)=>{
                                            o(e);
                                        }), e.pipe(a);
                                    });
                                }
                            }
                            async _processDrawingEntry(e, t, r) {
                                const n = new w, i = await n.parseStream(e);
                                t.drawings[r] = i;
                            }
                            async _processDrawingRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.drawingRels[r] = i;
                            }
                            async _processVmlDrawingEntry(e, t, r) {
                                const n = new k, i = await n.parseStream(e);
                                t.vmlDrawings[`../drawings/${r}.vml`] = i;
                            }
                            async _processThemeEntry(e, t, r) {
                                await new Promise((n, i)=>{
                                    const s = new l;
                                    e.on("error", i), s.on("error", i), s.on("finish", ()=>{
                                        t.themes[r] = s.read().toString(), n();
                                    }), e.pipe(s);
                                });
                            }
                            createInputStream() {
                                throw new Error("`XLSX#createInputStream` is deprecated. You should use `XLSX#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                            }
                            async read(e, t) {
                                !e[Symbol.asyncIterator] && e.pipe && (e = e.pipe(new o));
                                const r = [];
                                for await (const t of e)r.push(t);
                                return this.load(n.concat(r), t);
                            }
                            async load(e, t) {
                                let i;
                                i = t && t.base64 ? n.from(e.toString(), "base64") : e;
                                const a = {
                                    worksheets: [],
                                    worksheetHash: {},
                                    worksheetRels: [],
                                    themes: {},
                                    media: [],
                                    mediaIndex: {},
                                    drawings: {},
                                    drawingRels: {},
                                    comments: {},
                                    tables: {},
                                    vmlDrawings: {}
                                }, l = await s.loadAsync(i);
                                for (const e of Object.values(l.files))if (!e.dir) {
                                    let n, i = e.name;
                                    if ("/" === i[0] && (i = i.substr(1)), i.match(/xl\/media\//) || i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/)) n = new o, n.write(await e.async("nodebuffer"));
                                    else {
                                        let t;
                                        n = new o({
                                            writableObjectMode: !0,
                                            readableObjectMode: !0
                                        }), t = r.browser ? h(await e.async("nodebuffer")) : await e.async("string");
                                        const i = 16384;
                                        for(let e = 0; e < t.length; e += i)n.write(t.substring(e, e + i));
                                    }
                                    switch(n.end(), i){
                                        case "_rels/.rels":
                                            a.globalRels = await this.parseRels(n);
                                            break;
                                        case "xl/workbook.xml":
                                            {
                                                const e = await this.parseWorkbook(n);
                                                a.sheets = e.sheets, a.definedNames = e.definedNames, a.views = e.views, a.properties = e.properties, a.calcProperties = e.calcProperties;
                                                break;
                                            }
                                        case "xl/_rels/workbook.xml.rels":
                                            a.workbookRels = await this.parseRels(n);
                                            break;
                                        case "xl/sharedStrings.xml":
                                            a.sharedStrings = new p, await a.sharedStrings.parseStream(n);
                                            break;
                                        case "xl/styles.xml":
                                            a.styles = new f, await a.styles.parseStream(n);
                                            break;
                                        case "docProps/app.xml":
                                            {
                                                const e = new g, t = await e.parseStream(n);
                                                a.company = t.company, a.manager = t.manager;
                                                break;
                                            }
                                        case "docProps/core.xml":
                                            {
                                                const e = new d, t = await e.parseStream(n);
                                                Object.assign(a, t);
                                                break;
                                            }
                                        default:
                                            {
                                                let e = i.match(/xl\/worksheets\/sheet(\d+)[.]xml/);
                                                if (e) {
                                                    await this._processWorksheetEntry(n, a, e[1], t, i);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/worksheets\/_rels\/sheet(\d+)[.]xml.rels/), e) {
                                                    await this._processWorksheetRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processThemeEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/), e) {
                                                    await this._processMediaEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/(comments\d+)[.]xml/), e) {
                                                    await this._processCommentEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/tables\/(table\d+)[.]xml/), e) {
                                                    await this._processTableEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/_rels\/([a-zA-Z0-9]+)[.]xml[.]rels/), e) {
                                                    await this._processDrawingRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/(vmlDrawing\d+)[.]vml/), e) {
                                                    await this._processVmlDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                            }
                                    }
                                }
                                return this.reconcile(a, t), this.workbook.model = a, this.workbook;
                            }
                            async addMedia(e, t) {
                                await Promise.all(t.media.map(async (t)=>{
                                    if ("image" === t.type) {
                                        const r = `xl/media/${t.name}.${t.extension}`;
                                        if (t.filename) {
                                            const n = await function(e, t) {
                                                return new Promise((r, n)=>{
                                                    i.readFile(e, t, (e, t)=>{
                                                        e ? n(e) : r(t);
                                                    });
                                                });
                                            }(t.filename);
                                            return e.append(n, {
                                                name: r
                                            });
                                        }
                                        if (t.buffer) return e.append(t.buffer, {
                                            name: r
                                        });
                                        if (t.base64) {
                                            const n = t.base64, i = n.substring(n.indexOf(",") + 1);
                                            return e.append(i, {
                                                name: r,
                                                base64: !0
                                            });
                                        }
                                    }
                                    throw new Error("Unsupported media");
                                }));
                            }
                            addDrawings(e, t) {
                                const r = new w, n = new m;
                                t.worksheets.forEach((t)=>{
                                    const { drawing: i } = t;
                                    if (i) {
                                        r.prepare(i, {});
                                        let t = r.toXml(i);
                                        e.append(t, {
                                            name: `xl/drawings/${i.name}.xml`
                                        }), t = n.toXml(i.rels), e.append(t, {
                                            name: `xl/drawings/_rels/${i.name}.xml.rels`
                                        });
                                    }
                                });
                            }
                            addTables(e, t) {
                                const r = new _;
                                t.worksheets.forEach((t)=>{
                                    const { tables: n } = t;
                                    n.forEach((t)=>{
                                        r.prepare(t, {});
                                        const n = r.toXml(t);
                                        e.append(n, {
                                            name: "xl/tables/" + t.target
                                        });
                                    });
                                });
                            }
                            async addContentTypes(e, t) {
                                const r = (new b).toXml(t);
                                e.append(r, {
                                    name: "[Content_Types].xml"
                                });
                            }
                            async addApp(e, t) {
                                const r = (new g).toXml(t);
                                e.append(r, {
                                    name: "docProps/app.xml"
                                });
                            }
                            async addCore(e, t) {
                                const r = new d;
                                e.append(r.toXml(t), {
                                    name: "docProps/core.xml"
                                });
                            }
                            async addThemes(e, t) {
                                const r = t.themes || {
                                    theme1: S
                                };
                                Object.keys(r).forEach((t)=>{
                                    const n = r[t], i = `xl/theme/${t}.xml`;
                                    e.append(n, {
                                        name: i
                                    });
                                });
                            }
                            async addOfficeRels(e) {
                                const t = (new m).toXml([
                                    {
                                        Id: "rId1",
                                        Type: M.RelType.OfficeDocument,
                                        Target: "xl/workbook.xml"
                                    },
                                    {
                                        Id: "rId2",
                                        Type: M.RelType.CoreProperties,
                                        Target: "docProps/core.xml"
                                    },
                                    {
                                        Id: "rId3",
                                        Type: M.RelType.ExtenderProperties,
                                        Target: "docProps/app.xml"
                                    }
                                ]);
                                e.append(t, {
                                    name: "_rels/.rels"
                                });
                            }
                            async addWorkbookRels(e, t) {
                                let r = 1;
                                const n = [
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Styles,
                                        Target: "styles.xml"
                                    },
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Theme,
                                        Target: "theme/theme1.xml"
                                    }
                                ];
                                t.sharedStrings.count && n.push({
                                    Id: "rId" + r++,
                                    Type: M.RelType.SharedStrings,
                                    Target: "sharedStrings.xml"
                                }), t.worksheets.forEach((e)=>{
                                    e.rId = "rId" + r++, n.push({
                                        Id: e.rId,
                                        Type: M.RelType.Worksheet,
                                        Target: `worksheets/sheet${e.id}.xml`
                                    });
                                });
                                const i = (new m).toXml(n);
                                e.append(i, {
                                    name: "xl/_rels/workbook.xml.rels"
                                });
                            }
                            async addSharedStrings(e, t) {
                                t.sharedStrings && t.sharedStrings.count && e.append(t.sharedStrings.xml, {
                                    name: "xl/sharedStrings.xml"
                                });
                            }
                            async addStyles(e, t) {
                                const { xml: r } = t.styles;
                                r && e.append(r, {
                                    name: "xl/styles.xml"
                                });
                            }
                            async addWorkbook(e, t) {
                                const r = new y;
                                e.append(r.toXml(t), {
                                    name: "xl/workbook.xml"
                                });
                            }
                            async addWorksheets(e, t) {
                                const r = new v, n = new m, i = new x, s = new k;
                                t.worksheets.forEach((t)=>{
                                    let o = new u;
                                    r.render(o, t), e.append(o.xml, {
                                        name: `xl/worksheets/sheet${t.id}.xml`
                                    }), t.rels && t.rels.length && (o = new u, n.render(o, t.rels), e.append(o.xml, {
                                        name: `xl/worksheets/_rels/sheet${t.id}.xml.rels`
                                    })), t.comments.length > 0 && (o = new u, i.render(o, t), e.append(o.xml, {
                                        name: `xl/comments${t.id}.xml`
                                    }), o = new u, s.render(o, t), e.append(o.xml, {
                                        name: `xl/drawings/vmlDrawing${t.id}.vml`
                                    }));
                                });
                            }
                            _finalize(e) {
                                return new Promise((t, r)=>{
                                    e.on("finish", ()=>{
                                        t(this);
                                    }), e.on("error", r), e.finalize();
                                });
                            }
                            prepareModel(e, t) {
                                e.creator = e.creator || "ExcelJS", e.lastModifiedBy = e.lastModifiedBy || "ExcelJS", e.created = e.created || new Date, e.modified = e.modified || new Date, e.useSharedStrings = void 0 === t.useSharedStrings || t.useSharedStrings, e.useStyles = void 0 === t.useStyles || t.useStyles, e.sharedStrings = new p, e.styles = e.useStyles ? new f(!0) : new f.Mock;
                                const r = new y, n = new v;
                                r.prepare(e);
                                const i = {
                                    sharedStrings: e.sharedStrings,
                                    styles: e.styles,
                                    date1904: e.properties.date1904,
                                    drawingsCount: 0,
                                    media: e.media
                                };
                                i.drawings = e.drawings = [], i.commentRefs = e.commentRefs = [];
                                let s = 0;
                                e.tables = [], e.worksheets.forEach((t)=>{
                                    t.tables.forEach((t)=>{
                                        s++, t.target = `table${s}.xml`, t.id = s, e.tables.push(t);
                                    }), n.prepare(t, i);
                                });
                            }
                            async write(e, t) {
                                t = t || {};
                                const { model: r } = this.workbook, n = new a.ZipWriter(t.zip);
                                return n.pipe(e), this.prepareModel(r, t), await this.addContentTypes(n, r), await this.addOfficeRels(n, r), await this.addWorkbookRels(n, r), await this.addWorksheets(n, r), await this.addSharedStrings(n, r), await this.addDrawings(n, r), await this.addTables(n, r), await Promise.all([
                                    this.addThemes(n, r),
                                    this.addStyles(n, r)
                                ]), await this.addMedia(n, r), await Promise.all([
                                    this.addApp(n, r),
                                    this.addCore(n, r)
                                ]), await this.addWorkbook(n, r), this._finalize(n);
                            }
                            writeFile(e, t) {
                                const r = i.createWriteStream(e);
                                return new Promise((e, n)=>{
                                    r.on("finish", ()=>{
                                        e();
                                    }), r.on("error", (e)=>{
                                        n(e);
                                    }), this.write(r, t).then(()=>{
                                        r.end();
                                    }).catch((e)=>{
                                        n(e);
                                    });
                                });
                            }
                            async writeBuffer(e) {
                                const t = new l;
                                return await this.write(t, e), t.read();
                            }
                        }
                        M.RelType = e("./rel-type"), t.exports = M;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "../utils/browser-buffer-decode": 16,
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                "../utils/xml-stream": 28,
                "../utils/zip-stream": 29,
                "./rel-type": 31,
                "./xform/book/workbook-xform": 38,
                "./xform/comment/comments-xform": 40,
                "./xform/comment/vml-notes-xform": 45,
                "./xform/core/app-xform": 51,
                "./xform/core/content-types-xform": 52,
                "./xform/core/core-xform": 53,
                "./xform/core/relationships-xform": 55,
                "./xform/drawing/drawing-xform": 62,
                "./xform/sheet/worksheet-xform": 115,
                "./xform/strings/shared-strings-xform": 124,
                "./xform/style/styles-xform": 135,
                "./xform/table/table-xform": 143,
                "./xml/theme1": 145,
                _process: 467,
                buffer: 220,
                fs: 216,
                jszip: 441,
                "readable-stream": 491
            }
        ],
        145: [
            function(e, t, r) {
                "use strict";
                t.exports = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"> <a:themeElements> <a:clrScheme name="Office"> <a:dk1> <a:sysClr val="windowText" lastClr="000000"/> </a:dk1> <a:lt1> <a:sysClr val="window" lastClr="FFFFFF"/> </a:lt1> <a:dk2> <a:srgbClr val="1F497D"/> </a:dk2> <a:lt2> <a:srgbClr val="EEECE1"/> </a:lt2> <a:accent1> <a:srgbClr val="4F81BD"/> </a:accent1> <a:accent2> <a:srgbClr val="C0504D"/> </a:accent2> <a:accent3> <a:srgbClr val="9BBB59"/> </a:accent3> <a:accent4> <a:srgbClr val="8064A2"/> </a:accent4> <a:accent5> <a:srgbClr val="4BACC6"/> </a:accent5> <a:accent6> <a:srgbClr val="F79646"/> </a:accent6> <a:hlink> <a:srgbClr val="0000FF"/> </a:hlink> <a:folHlink> <a:srgbClr val="800080"/> </a:folHlink> </a:clrScheme> <a:fontScheme name="Office"> <a:majorFont> <a:latin typeface="Cambria"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Times New Roman"/> <a:font script="Hebr" typeface="Times New Roman"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="MoolBoran"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Times New Roman"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:majorFont> <a:minorFont> <a:latin typeface="Calibri"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Arial"/> <a:font script="Hebr" typeface="Arial"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="DaunPenh"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Arial"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name="Office"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="35000"> <a:schemeClr val="phClr"> <a:tint val="37000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="15000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="1"/> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="100000"/> <a:shade val="100000"/> <a:satMod val="130000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:shade val="100000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="0"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"> <a:shade val="95000"/> <a:satMod val="105000"/> </a:schemeClr> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="38000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst="orthographicFront"> <a:rot lat="0" lon="0" rev="0"/> </a:camera> <a:lightRig rig="threePt" dir="t"> <a:rot lat="0" lon="0" rev="1200000"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w="63500" h="25400"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="40000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="40000"> <a:schemeClr val="phClr"> <a:tint val="45000"/> <a:shade val="99000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="20000"/> <a:satMod val="255000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="-80000" r="50000" b="180000"/> </a:path> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="80000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="30000"/> <a:satMod val="200000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="50000" r="50000" b="50000"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="1"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="3"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="2"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="lt1"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="2"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="0"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="1"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="tx1"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';
            },
            {}
        ],
        146: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvFormatterStream = void 0;
                        const n = e("stream"), i = e("./formatter");
                        class s extends n.Transform {
                            constructor(e){
                                super({
                                    writableObjectMode: e.objectMode
                                }), this.hasWrittenBOM = !1, this.formatterOptions = e, this.rowFormatter = new i.RowFormatter(e), this.hasWrittenBOM = !e.writeBOM;
                            }
                            transform(e) {
                                return this.rowFormatter.rowTransform = e, this;
                            }
                            _transform(e, r, n) {
                                let i = !1;
                                try {
                                    this.hasWrittenBOM || (this.push(this.formatterOptions.BOM), this.hasWrittenBOM = !0), this.rowFormatter.format(e, (e, r)=>e ? (i = !0, n(e)) : (r && r.forEach((e)=>{
                                            this.push(t.from(e, "utf8"));
                                        }), i = !0, n()));
                                } catch (e) {
                                    if (i) throw e;
                                    n(e);
                                }
                            }
                            _flush(e) {
                                this.rowFormatter.finish((r, n)=>r ? e(r) : (n && n.forEach((e)=>{
                                        this.push(t.from(e, "utf8"));
                                    }), e()));
                            }
                        }
                        r.CsvFormatterStream = s;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./formatter": 150,
                buffer: 220,
                stream: 505
            }
        ],
        147: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FormatterOptions = void 0;
                r.FormatterOptions = class {
                    constructor(){
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        var t;
                        this.objectMode = !0, this.delimiter = ",", this.rowDelimiter = "\n", this.quote = '"', this.escape = this.quote, this.quoteColumns = !1, this.quoteHeaders = this.quoteColumns, this.headers = null, this.includeEndRowDelimiter = !1, this.writeBOM = !1, this.BOM = "\ufeff", this.alwaysWriteHeaders = !1, Object.assign(this, e || {}), void 0 === (null == e ? void 0 : e.quoteHeaders) && (this.quoteHeaders = this.quoteColumns), !0 === (null == e ? void 0 : e.quote) ? this.quote = '"' : !1 === (null == e ? void 0 : e.quote) && (this.quote = ""), "string" != typeof (null == e ? void 0 : e.escape) && (this.escape = this.quote), this.shouldWriteHeaders = !!this.headers && (null === (t = e.writeHeaders) || void 0 === t || t), this.headers = Array.isArray(this.headers) ? this.headers : null, this.escapedQuote = `${this.escape}${this.quote}`;
                    }
                };
            },
            {}
        ],
        148: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = void 0;
                const i = n(e("lodash.isboolean")), s = n(e("lodash.isnil")), o = n(e("lodash.escaperegexp"));
                r.FieldFormatter = class {
                    constructor(e){
                        this._headers = null, this.formatterOptions = e, null !== e.headers && (this.headers = e.headers), this.REPLACE_REGEXP = new RegExp(e.quote, "g");
                        const t = `[${e.delimiter}${o.default(e.rowDelimiter)}|\r|\n]`;
                        this.ESCAPE_REGEXP = new RegExp(t);
                    }
                    set headers(e) {
                        this._headers = e;
                    }
                    shouldQuote(e, t) {
                        const r = t ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;
                        return i.default(r) ? r : Array.isArray(r) ? r[e] : null !== this._headers && r[this._headers[e]];
                    }
                    format(e, t, r) {
                        const n = ("" + (s.default(e) ? "" : e)).replace(/\0/g, ""), { formatterOptions: i } = this;
                        if ("" !== i.quote) {
                            if (-1 !== n.indexOf(i.quote)) return this.quoteField(n.replace(this.REPLACE_REGEXP, i.escapedQuote));
                        }
                        return -1 !== n.search(this.ESCAPE_REGEXP) || this.shouldQuote(t, r) ? this.quoteField(n) : n;
                    }
                    quoteField(e) {
                        const { quote: t } = this.formatterOptions;
                        return `${t}${e}${t}`;
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isboolean": 444,
                "lodash.isnil": 447
            }
        ],
        149: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowFormatter = void 0;
                const i = n(e("lodash.isfunction")), s = n(e("lodash.isequal")), o = e("./FieldFormatter"), a = e("../types");
                class l {
                    constructor(e){
                        this.rowCount = 0, this.formatterOptions = e, this.fieldFormatter = new o.FieldFormatter(e), this.headers = e.headers, this.shouldWriteHeaders = e.shouldWriteHeaders, this.hasWrittenHeaders = !1, null !== this.headers && (this.fieldFormatter.headers = this.headers), e.transform && (this.rowTransform = e.transform);
                    }
                    static isRowHashArray(e) {
                        return !!Array.isArray(e) && Array.isArray(e[0]) && 2 === e[0].length;
                    }
                    static isRowArray(e) {
                        return Array.isArray(e) && !this.isRowHashArray(e);
                    }
                    static gatherHeaders(e) {
                        return l.isRowHashArray(e) ? e.map((e)=>e[0]) : Array.isArray(e) ? e : Object.keys(e);
                    }
                    static createTransform(e) {
                        return a.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : (t, r)=>{
                            e(t, r);
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = l.createTransform(e);
                    }
                    format(e, t) {
                        this.callTransformer(e, (r, n)=>{
                            if (r) return t(r);
                            if (!e) return t(null);
                            const i = [];
                            if (n) {
                                const { shouldFormatColumns: e, headers: t } = this.checkHeaders(n);
                                if (this.shouldWriteHeaders && t && !this.hasWrittenHeaders && (i.push(this.formatColumns(t, !0)), this.hasWrittenHeaders = !0), e) {
                                    const e = this.gatherColumns(n);
                                    i.push(this.formatColumns(e, !1));
                                }
                            }
                            return t(null, i);
                        });
                    }
                    finish(e) {
                        const t = [];
                        if (this.formatterOptions.alwaysWriteHeaders && 0 === this.rowCount) {
                            if (!this.headers) return e(new Error("`alwaysWriteHeaders` option is set to true but `headers` option not provided."));
                            t.push(this.formatColumns(this.headers, !0));
                        }
                        return this.formatterOptions.includeEndRowDelimiter && t.push(this.formatterOptions.rowDelimiter), e(null, t);
                    }
                    checkHeaders(e) {
                        if (this.headers) return {
                            shouldFormatColumns: !0,
                            headers: this.headers
                        };
                        const t = l.gatherHeaders(e);
                        return this.headers = t, this.fieldFormatter.headers = t, this.shouldWriteHeaders ? {
                            shouldFormatColumns: !s.default(t, e),
                            headers: t
                        } : {
                            shouldFormatColumns: !0,
                            headers: null
                        };
                    }
                    gatherColumns(e) {
                        if (null === this.headers) throw new Error("Headers is currently null");
                        return Array.isArray(e) ? l.isRowHashArray(e) ? this.headers.map((t, r)=>{
                            const n = e[r];
                            return n ? n[1] : "";
                        }) : l.isRowArray(e) && !this.shouldWriteHeaders ? e : this.headers.map((t, r)=>e[r]) : this.headers.map((t)=>e[t]);
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    formatColumns(e, t) {
                        const r = e.map((e, r)=>this.fieldFormatter.format(e, r, t)).join(this.formatterOptions.delimiter), { rowCount: n } = this;
                        return this.rowCount += 1, n ? [
                            this.formatterOptions.rowDelimiter,
                            r
                        ].join("") : r;
                    }
                }
                r.RowFormatter = l;
            },
            {
                "../types": 152,
                "./FieldFormatter": 148,
                "lodash.isequal": 445,
                "lodash.isfunction": 446
            }
        ],
        150: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = r.RowFormatter = void 0;
                var n = e("./RowFormatter");
                Object.defineProperty(r, "RowFormatter", {
                    enumerable: !0,
                    get: function() {
                        return n.RowFormatter;
                    }
                });
                var i = e("./FieldFormatter");
                Object.defineProperty(r, "FieldFormatter", {
                    enumerable: !0,
                    get: function() {
                        return i.FieldFormatter;
                    }
                });
            },
            {
                "./FieldFormatter": 148,
                "./RowFormatter": 149
            }
        ],
        151: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = Object.create ? function(e, t, r, n) {
                            void 0 === n && (n = r), Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: function() {
                                    return t[r];
                                }
                            });
                        } : function(e, t, r, n) {
                            void 0 === n && (n = r), e[n] = t[r];
                        }, i = Object.create ? function(e, t) {
                            Object.defineProperty(e, "default", {
                                enumerable: !0,
                                value: t
                            });
                        } : function(e, t) {
                            e.default = t;
                        }, s = function(e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                            return i(t, e), t;
                        }, o = function(e, t) {
                            for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                        };
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = r.FormatterOptions = r.CsvFormatterStream = void 0;
                        const a = e("util"), l = e("stream"), c = s(e("fs")), u = e("./FormatterOptions"), h = e("./CsvFormatterStream");
                        o(e("./types"), r);
                        var f = e("./CsvFormatterStream");
                        Object.defineProperty(r, "CsvFormatterStream", {
                            enumerable: !0,
                            get: function() {
                                return f.CsvFormatterStream;
                            }
                        });
                        var d = e("./FormatterOptions");
                        Object.defineProperty(r, "FormatterOptions", {
                            enumerable: !0,
                            get: function() {
                                return d.FormatterOptions;
                            }
                        }), r.format = (e)=>new h.CsvFormatterStream(new u.FormatterOptions(e)), r.write = (e, t)=>{
                            const n = r.format(t), i = a.promisify((e, t)=>{
                                n.write(e, void 0, t);
                            });
                            return e.reduce((e, t)=>e.then(()=>i(t)), Promise.resolve()).then(()=>n.end()).catch((e)=>{
                                n.emit("error", e);
                            }), n;
                        }, r.writeToStream = (e, t, n)=>r.write(t, n).pipe(e), r.writeToBuffer = function(e) {
                            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            const i = [], s = new l.Writable({
                                write (e, t, r) {
                                    i.push(e), r();
                                }
                            });
                            return new Promise((o, a)=>{
                                s.on("error", a).on("finish", ()=>o(t.concat(i))), r.write(e, n).pipe(s);
                            });
                        }, r.writeToString = (e, t)=>r.writeToBuffer(e, t).then((e)=>e.toString()), r.writeToPath = (e, t, n)=>{
                            const i = c.createWriteStream(e, {
                                encoding: "utf8"
                            });
                            return r.write(t, n).pipe(i);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./CsvFormatterStream": 146,
                "./FormatterOptions": 147,
                "./types": 152,
                buffer: 220,
                fs: 216,
                stream: 505,
                util: 527
            }
        ],
        152: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length;
            },
            {}
        ],
        153: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvParserStream = void 0;
                        const n = e("string_decoder"), i = e("stream"), s = e("./transforms"), o = e("./parser");
                        class a extends i.Transform {
                            constructor(e){
                                super({
                                    objectMode: e.objectMode
                                }), this.lines = "", this.rowCount = 0, this.parsedRowCount = 0, this.parsedLineCount = 0, this.endEmitted = !1, this.headersEmitted = !1, this.parserOptions = e, this.parser = new o.Parser(e), this.headerTransformer = new s.HeaderTransformer(e), this.decoder = new n.StringDecoder(e.encoding), this.rowTransformerValidator = new s.RowTransformerValidator;
                            }
                            get hasHitRowLimit() {
                                return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
                            }
                            get shouldEmitRows() {
                                return this.parsedRowCount > this.parserOptions.skipRows;
                            }
                            get shouldSkipLine() {
                                return this.parsedLineCount <= this.parserOptions.skipLines;
                            }
                            transform(e) {
                                return this.rowTransformerValidator.rowTransform = e, this;
                            }
                            validate(e) {
                                return this.rowTransformerValidator.rowValidator = e, this;
                            }
                            emit(e) {
                                if ("end" === e) return this.endEmitted || (this.endEmitted = !0, super.emit("end", this.rowCount)), !1;
                                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                return super.emit(e, ...r);
                            }
                            _transform(e, t, r) {
                                if (this.hasHitRowLimit) return r();
                                const n = a.wrapDoneCallback(r);
                                try {
                                    const { lines: t } = this, r = t + this.decoder.write(e), i = this.parse(r, !0);
                                    return this.processRows(i, n);
                                } catch (e) {
                                    return n(e);
                                }
                            }
                            _flush(e) {
                                const t = a.wrapDoneCallback(e);
                                if (this.hasHitRowLimit) return t();
                                try {
                                    const e = this.lines + this.decoder.end(), r = this.parse(e, !1);
                                    return this.processRows(r, t);
                                } catch (e) {
                                    return t(e);
                                }
                            }
                            parse(e, t) {
                                if (!e) return [];
                                const { line: r, rows: n } = this.parser.parse(e, t);
                                return this.lines = r, n;
                            }
                            processRows(e, r) {
                                const n = e.length, i = (s)=>{
                                    const o = (e)=>e ? r(e) : s % 100 != 0 ? i(s + 1) : void t(()=>i(s + 1));
                                    if (this.checkAndEmitHeaders(), s >= n || this.hasHitRowLimit) return r();
                                    if (this.parsedLineCount += 1, this.shouldSkipLine) return o();
                                    const a = e[s];
                                    this.rowCount += 1, this.parsedRowCount += 1;
                                    const l = this.rowCount;
                                    return this.transformRow(a, (e, t)=>{
                                        if (e) return this.rowCount -= 1, o(e);
                                        if (!t) return o(new Error("expected transform result"));
                                        if (t.isValid) {
                                            if (t.row) return this.pushRow(t.row, o);
                                        } else this.emit("data-invalid", t.row, l, t.reason);
                                        return o();
                                    });
                                };
                                i(0);
                            }
                            transformRow(e, t) {
                                try {
                                    this.headerTransformer.transform(e, (r, n)=>r ? t(r) : n ? n.isValid ? n.row ? this.shouldEmitRows ? this.rowTransformerValidator.transformAndValidate(n.row, t) : this.skipRow(t) : (this.rowCount -= 1, this.parsedRowCount -= 1, t(null, {
                                            row: null,
                                            isValid: !0
                                        })) : this.shouldEmitRows ? t(null, {
                                            isValid: !1,
                                            row: e
                                        }) : this.skipRow(t) : t(new Error("Expected result from header transform")));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            checkAndEmitHeaders() {
                                !this.headersEmitted && this.headerTransformer.headers && (this.headersEmitted = !0, this.emit("headers", this.headerTransformer.headers));
                            }
                            skipRow(e) {
                                return this.rowCount -= 1, e(null, {
                                    row: null,
                                    isValid: !0
                                });
                            }
                            pushRow(e, t) {
                                try {
                                    this.parserOptions.objectMode ? this.push(e) : this.push(JSON.stringify(e)), t();
                                } catch (e) {
                                    t(e);
                                }
                            }
                            static wrapDoneCallback(e) {
                                let t = !1;
                                return function(r) {
                                    if (r) {
                                        if (t) throw r;
                                        return t = !0, void e(r);
                                    }
                                    for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                                    e(...i);
                                };
                            }
                        }
                        r.CsvParserStream = a;
                    }).call(this);
                }).call(this, e("timers").setImmediate);
            },
            {
                "./parser": 165,
                "./transforms": 168,
                stream: 505,
                string_decoder: 218,
                timers: 523
            }
        ],
        154: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ParserOptions = void 0;
                const i = n(e("lodash.escaperegexp")), s = n(e("lodash.isnil"));
                r.ParserOptions = class {
                    constructor(e){
                        var t;
                        if (this.objectMode = !0, this.delimiter = ",", this.ignoreEmpty = !1, this.quote = '"', this.escape = null, this.escapeChar = this.quote, this.comment = null, this.supportsComments = !1, this.ltrim = !1, this.rtrim = !1, this.trim = !1, this.headers = null, this.renameHeaders = !1, this.strictColumnHandling = !1, this.discardUnmappedColumns = !1, this.carriageReturn = "\r", this.encoding = "utf8", this.limitRows = !1, this.maxRows = 0, this.skipLines = 0, this.skipRows = 0, Object.assign(this, e || {}), this.delimiter.length > 1) throw new Error("delimiter option must be one character long");
                        this.escapedDelimiter = i.default(this.delimiter), this.escapeChar = null !== (t = this.escape) && void 0 !== t ? t : this.quote, this.supportsComments = !s.default(this.comment), this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`), this.maxRows > 0 && (this.limitRows = !0);
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isnil": 447
            }
        ],
        155: [
            function(e, t, r) {
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, o = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.parseString = r.parseFile = r.parseStream = r.parse = r.ParserOptions = r.CsvParserStream = void 0;
                const a = s(e("fs")), l = e("stream"), c = e("./ParserOptions"), u = e("./CsvParserStream");
                o(e("./types"), r);
                var h = e("./CsvParserStream");
                Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return h.CsvParserStream;
                    }
                });
                var f = e("./ParserOptions");
                Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return f.ParserOptions;
                    }
                }), r.parse = (e)=>new u.CsvParserStream(new c.ParserOptions(e)), r.parseStream = (e, t)=>e.pipe(new u.CsvParserStream(new c.ParserOptions(t))), r.parseFile = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a.createReadStream(e).pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                }, r.parseString = (e, t)=>{
                    const r = new l.Readable;
                    return r.push(e), r.push(null), r.pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                };
            },
            {
                "./CsvParserStream": 153,
                "./ParserOptions": 154,
                "./types": 169,
                fs: 216,
                stream: 505
            }
        ],
        156: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Parser = void 0;
                const n = e("./Scanner"), i = e("./RowParser"), s = e("./Token");
                class o {
                    constructor(e){
                        this.parserOptions = e, this.rowParser = new i.RowParser(this.parserOptions);
                    }
                    static removeBOM(e) {
                        return e && 65279 === e.charCodeAt(0) ? e.slice(1) : e;
                    }
                    parse(e, t) {
                        const r = new n.Scanner({
                            line: o.removeBOM(e),
                            parserOptions: this.parserOptions,
                            hasMoreData: t
                        });
                        return this.parserOptions.supportsComments ? this.parseWithComments(r) : this.parseWithoutComments(r);
                    }
                    parseWithoutComments(e) {
                        const t = [];
                        let r = !0;
                        for(; r;)r = this.parseRow(e, t);
                        return {
                            line: e.line,
                            rows: t
                        };
                    }
                    parseWithComments(e) {
                        const { parserOptions: t } = this, r = [];
                        for(let n = e.nextCharacterToken; null !== n; n = e.nextCharacterToken)if (s.Token.isTokenComment(n, t)) {
                            if (null === e.advancePastLine()) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            if (!e.hasMoreCharacters) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            e.truncateToCursor();
                        } else if (!this.parseRow(e, r)) break;
                        return {
                            line: e.line,
                            rows: r
                        };
                    }
                    parseRow(e, t) {
                        if (!e.nextNonSpaceToken) return !1;
                        const r = this.rowParser.parse(e);
                        return null !== r && (this.parserOptions.ignoreEmpty && i.RowParser.isEmptyRow(r) || t.push(r), !0);
                    }
                }
                r.Parser = o;
            },
            {
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159
            }
        ],
        157: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowParser = void 0;
                const n = e("./column"), i = e("./Token");
                r.RowParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnParser = new n.ColumnParser(e);
                    }
                    static isEmptyRow(e) {
                        return "" === e.join("").replace(/\s+/g, "");
                    }
                    parse(e) {
                        const { parserOptions: t } = this, { hasMoreData: r } = e, n = e, s = [];
                        let o = this.getStartToken(n, s);
                        for(; o;){
                            if (i.Token.isTokenRowDelimiter(o)) return n.advancePastToken(o), !n.hasMoreCharacters && i.Token.isTokenCarriageReturn(o, t) && r ? null : (n.truncateToCursor(), s);
                            if (!this.shouldSkipColumnParse(n, o, s)) {
                                const e = this.columnParser.parse(n);
                                if (null === e) return null;
                                s.push(e);
                            }
                            o = n.nextNonSpaceToken;
                        }
                        return r ? null : (n.truncateToCursor(), s);
                    }
                    getStartToken(e, t) {
                        const r = e.nextNonSpaceToken;
                        return null !== r && i.Token.isTokenDelimiter(r, this.parserOptions) ? (t.push(""), e.nextNonSpaceToken) : r;
                    }
                    shouldSkipColumnParse(e, t, r) {
                        const { parserOptions: n } = this;
                        if (i.Token.isTokenDelimiter(t, n)) {
                            e.advancePastToken(t);
                            const s = e.nextCharacterToken;
                            if (!e.hasMoreCharacters || null !== s && i.Token.isTokenRowDelimiter(s)) return r.push(""), !0;
                            if (null !== s && i.Token.isTokenDelimiter(s, n)) return r.push(""), !0;
                        }
                        return !1;
                    }
                };
            },
            {
                "./Token": 159,
                "./column": 164
            }
        ],
        158: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Scanner = void 0;
                const n = e("./Token"), i = /((?:\r\n)|\n|\r)/;
                r.Scanner = class {
                    constructor(e){
                        this.cursor = 0, this.line = e.line, this.lineLength = this.line.length, this.parserOptions = e.parserOptions, this.hasMoreData = e.hasMoreData, this.cursor = e.cursor || 0;
                    }
                    get hasMoreCharacters() {
                        return this.lineLength > this.cursor;
                    }
                    get nextNonSpaceToken() {
                        const { lineFromCursor: e } = this, t = this.parserOptions.NEXT_TOKEN_REGEXP;
                        if (-1 === e.search(t)) return null;
                        const r = t.exec(e);
                        if (null == r) return null;
                        const i = r[1], s = this.cursor + (r.index || 0);
                        return new n.Token({
                            token: i,
                            startCursor: s,
                            endCursor: s + i.length - 1
                        });
                    }
                    get nextCharacterToken() {
                        const { cursor: e, lineLength: t } = this;
                        return t <= e ? null : new n.Token({
                            token: this.line[e],
                            startCursor: e,
                            endCursor: e
                        });
                    }
                    get lineFromCursor() {
                        return this.line.substr(this.cursor);
                    }
                    advancePastLine() {
                        const e = i.exec(this.lineFromCursor);
                        return e ? (this.cursor += (e.index || 0) + e[0].length, this) : this.hasMoreData ? null : (this.cursor = this.lineLength, this);
                    }
                    advanceTo(e) {
                        return this.cursor = e, this;
                    }
                    advanceToToken(e) {
                        return this.cursor = e.startCursor, this;
                    }
                    advancePastToken(e) {
                        return this.cursor = e.endCursor + 1, this;
                    }
                    truncateToCursor() {
                        return this.line = this.lineFromCursor, this.lineLength = this.line.length, this.cursor = 0, this;
                    }
                };
            },
            {
                "./Token": 159
            }
        ],
        159: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Token = void 0;
                r.Token = class {
                    constructor(e){
                        this.token = e.token, this.startCursor = e.startCursor, this.endCursor = e.endCursor;
                    }
                    static isTokenRowDelimiter(e) {
                        const t = e.token;
                        return "\r" === t || "\n" === t || "\r\n" === t;
                    }
                    static isTokenCarriageReturn(e, t) {
                        return e.token === t.carriageReturn;
                    }
                    static isTokenComment(e, t) {
                        return t.supportsComments && !!e && e.token === t.comment;
                    }
                    static isTokenEscapeCharacter(e, t) {
                        return e.token === t.escapeChar;
                    }
                    static isTokenQuote(e, t) {
                        return e.token === t.quote;
                    }
                    static isTokenDelimiter(e, t) {
                        return e.token === t.delimiter;
                    }
                };
            },
            {}
        ],
        160: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = void 0;
                r.ColumnFormatter = class {
                    constructor(e){
                        e.trim ? this.format = (e)=>e.trim() : e.ltrim ? this.format = (e)=>e.trimLeft() : e.rtrim ? this.format = (e)=>e.trimRight() : this.format = (e)=>e;
                    }
                };
            },
            {}
        ],
        161: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnParser = void 0;
                const n = e("./NonQuotedColumnParser"), i = e("./QuotedColumnParser"), s = e("../Token");
                r.ColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.quotedColumnParser = new i.QuotedColumnParser(e), this.nonQuotedColumnParser = new n.NonQuotedColumnParser(e);
                    }
                    parse(e) {
                        const { nextNonSpaceToken: t } = e;
                        return null !== t && s.Token.isTokenQuote(t, this.parserOptions) ? (e.advanceToToken(t), this.quotedColumnParser.parse(e)) : this.nonQuotedColumnParser.parse(e);
                    }
                };
            },
            {
                "../Token": 159,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        162: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NonQuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.NonQuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const { parserOptions: t } = this, r = [];
                        let n = e.nextCharacterToken;
                        for(; n && !i.Token.isTokenDelimiter(n, t) && !i.Token.isTokenRowDelimiter(n); n = e.nextCharacterToken)r.push(n.token), e.advancePastToken(n);
                        return this.columnFormatter.format(r.join(""));
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        163: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.QuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const t = e.cursor, { foundClosingQuote: r, col: n } = this.gatherDataBetweenQuotes(e);
                        if (!r) {
                            if (e.advanceTo(t), !e.hasMoreData) throw new Error(`Parse Error: missing closing: '${this.parserOptions.quote || ""}' in line: at '${e.lineFromCursor.replace(/[\r\n]/g, "\\n'")}'`);
                            return null;
                        }
                        return this.checkForMalformedColumn(e), n;
                    }
                    gatherDataBetweenQuotes(e) {
                        const { parserOptions: t } = this;
                        let r = !1, n = !1;
                        const s = [];
                        let o = e.nextCharacterToken;
                        for(; !n && null !== o; o = e.nextCharacterToken){
                            const a = i.Token.isTokenQuote(o, t);
                            if (!r && a) r = !0;
                            else if (r) {
                                if (i.Token.isTokenEscapeCharacter(o, t)) {
                                    e.advancePastToken(o);
                                    const r = e.nextCharacterToken;
                                    null !== r && (i.Token.isTokenQuote(r, t) || i.Token.isTokenEscapeCharacter(r, t)) ? (s.push(r.token), o = r) : a ? n = !0 : s.push(o.token);
                                } else a ? n = !0 : s.push(o.token);
                            }
                            e.advancePastToken(o);
                        }
                        return {
                            col: this.columnFormatter.format(s.join("")),
                            foundClosingQuote: n
                        };
                    }
                    checkForMalformedColumn(e) {
                        const { parserOptions: t } = this, { nextNonSpaceToken: r } = e;
                        if (r) {
                            const n = i.Token.isTokenDelimiter(r, t), s = i.Token.isTokenRowDelimiter(r);
                            if (!n && !s) {
                                const n = e.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
                                throw new Error(`Parse Error: expected: '${t.escapedDelimiter}' OR new line got: '${r.token}'. at '${n}`);
                            }
                            e.advanceToToken(r);
                        } else e.hasMoreData || e.advancePastLine();
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        164: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = void 0;
                var n = e("./ColumnParser");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return n.ColumnParser;
                    }
                });
                var i = e("./NonQuotedColumnParser");
                Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return i.NonQuotedColumnParser;
                    }
                });
                var s = e("./QuotedColumnParser");
                Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return s.QuotedColumnParser;
                    }
                });
                var o = e("./ColumnFormatter");
                Object.defineProperty(r, "ColumnFormatter", {
                    enumerable: !0,
                    get: function() {
                        return o.ColumnFormatter;
                    }
                });
            },
            {
                "./ColumnFormatter": 160,
                "./ColumnParser": 161,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        165: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = r.Token = r.Scanner = r.RowParser = r.Parser = void 0;
                var n = e("./Parser");
                Object.defineProperty(r, "Parser", {
                    enumerable: !0,
                    get: function() {
                        return n.Parser;
                    }
                });
                var i = e("./RowParser");
                Object.defineProperty(r, "RowParser", {
                    enumerable: !0,
                    get: function() {
                        return i.RowParser;
                    }
                });
                var s = e("./Scanner");
                Object.defineProperty(r, "Scanner", {
                    enumerable: !0,
                    get: function() {
                        return s.Scanner;
                    }
                });
                var o = e("./Token");
                Object.defineProperty(r, "Token", {
                    enumerable: !0,
                    get: function() {
                        return o.Token;
                    }
                });
                var a = e("./column");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.ColumnParser;
                    }
                }), Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.NonQuotedColumnParser;
                    }
                }), Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.QuotedColumnParser;
                    }
                });
            },
            {
                "./Parser": 156,
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159,
                "./column": 164
            }
        ],
        166: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = void 0;
                const i = n(e("lodash.isundefined")), s = n(e("lodash.isfunction")), o = n(e("lodash.uniq")), a = n(e("lodash.groupby"));
                r.HeaderTransformer = class {
                    constructor(e){
                        this.headers = null, this.receivedHeaders = !1, this.shouldUseFirstRow = !1, this.processedFirstRow = !1, this.headersLength = 0, this.parserOptions = e, !0 === e.headers ? this.shouldUseFirstRow = !0 : Array.isArray(e.headers) ? this.setHeaders(e.headers) : s.default(e.headers) && (this.headersTransform = e.headers);
                    }
                    transform(e, t) {
                        return this.shouldMapRow(e) ? t(null, this.processRow(e)) : t(null, {
                            row: null,
                            isValid: !0
                        });
                    }
                    shouldMapRow(e) {
                        const { parserOptions: t } = this;
                        if (!this.headersTransform && t.renameHeaders && !this.processedFirstRow) {
                            if (!this.receivedHeaders) throw new Error("Error renaming headers: new headers must be provided in an array");
                            return this.processedFirstRow = !0, !1;
                        }
                        if (!this.receivedHeaders && Array.isArray(e)) {
                            if (this.headersTransform) this.setHeaders(this.headersTransform(e));
                            else {
                                if (!this.shouldUseFirstRow) return !0;
                                this.setHeaders(e);
                            }
                            return !1;
                        }
                        return !0;
                    }
                    processRow(e) {
                        if (!this.headers) return {
                            row: e,
                            isValid: !0
                        };
                        const { parserOptions: t } = this;
                        if (!t.discardUnmappedColumns && e.length > this.headersLength) {
                            if (!t.strictColumnHandling) throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${e.length}`);
                            return {
                                row: e,
                                isValid: !1,
                                reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                            };
                        }
                        return t.strictColumnHandling && e.length < this.headersLength ? {
                            row: e,
                            isValid: !1,
                            reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                        } : {
                            row: this.mapHeaders(e),
                            isValid: !0
                        };
                    }
                    mapHeaders(e) {
                        const t = {}, { headers: r, headersLength: n } = this;
                        for(let s = 0; s < n; s += 1){
                            const n = r[s];
                            if (!i.default(n)) {
                                const r = e[s];
                                i.default(r) ? t[n] = "" : t[n] = r;
                            }
                        }
                        return t;
                    }
                    setHeaders(e) {
                        var t;
                        const r = e.filter((e)=>!!e);
                        if (o.default(r).length !== r.length) {
                            const e = a.default(r), t = Object.keys(e).filter((t)=>e[t].length > 1);
                            throw new Error("Duplicate headers found " + JSON.stringify(t));
                        }
                        this.headers = e, this.receivedHeaders = !0, this.headersLength = (null === (t = this.headers) || void 0 === t ? void 0 : t.length) || 0;
                    }
                };
            },
            {
                "lodash.groupby": 443,
                "lodash.isfunction": 446,
                "lodash.isundefined": 448,
                "lodash.uniq": 449
            }
        ],
        167: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowTransformerValidator = void 0;
                const i = n(e("lodash.isfunction")), s = e("../types");
                class o {
                    constructor(){
                        this._rowTransform = null, this._rowValidator = null;
                    }
                    static createTransform(e) {
                        return s.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : e;
                    }
                    static createValidator(e) {
                        return s.isSyncValidate(e) ? (t, r)=>{
                            r(null, {
                                row: t,
                                isValid: e(t)
                            });
                        } : (t, r)=>{
                            e(t, (e, n, i)=>e ? r(e) : r(null, n ? {
                                    row: t,
                                    isValid: n,
                                    reason: i
                                } : {
                                    row: t,
                                    isValid: !1,
                                    reason: i
                                }));
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = o.createTransform(e);
                    }
                    set rowValidator(e) {
                        if (!i.default(e)) throw new TypeError("The validate should be a function");
                        this._rowValidator = o.createValidator(e);
                    }
                    transformAndValidate(e, t) {
                        return this.callTransformer(e, (e, r)=>e ? t(e) : r ? this.callValidator(r, (e, n)=>e ? t(e) : n && !n.isValid ? t(null, {
                                    row: r,
                                    isValid: !1,
                                    reason: n.reason
                                }) : t(null, {
                                    row: r,
                                    isValid: !0
                                })) : t(null, {
                                row: null,
                                isValid: !0
                            }));
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    callValidator(e, t) {
                        return this._rowValidator ? this._rowValidator(e, t) : t(null, {
                            row: e,
                            isValid: !0
                        });
                    }
                }
                r.RowTransformerValidator = o;
            },
            {
                "../types": 169,
                "lodash.isfunction": 446
            }
        ],
        168: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = r.RowTransformerValidator = void 0;
                var n = e("./RowTransformerValidator");
                Object.defineProperty(r, "RowTransformerValidator", {
                    enumerable: !0,
                    get: function() {
                        return n.RowTransformerValidator;
                    }
                });
                var i = e("./HeaderTransformer");
                Object.defineProperty(r, "HeaderTransformer", {
                    enumerable: !0,
                    get: function() {
                        return i.HeaderTransformer;
                    }
                });
            },
            {
                "./HeaderTransformer": 166,
                "./RowTransformerValidator": 167
            }
        ],
        169: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncValidate = r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length, r.isSyncValidate = (e)=>1 === e.length;
            },
            {}
        ],
        170: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.bignum = e("bn.js"), n.define = e("./asn1/api").define, n.base = e("./asn1/base"), n.constants = e("./asn1/constants"), n.decoders = e("./asn1/decoders"), n.encoders = e("./asn1/encoders");
            },
            {
                "./asn1/api": 171,
                "./asn1/base": 173,
                "./asn1/constants": 177,
                "./asn1/decoders": 179,
                "./asn1/encoders": 182,
                "bn.js": 184
            }
        ],
        171: [
            function(e, t, r) {
                "use strict";
                const n = e("./encoders"), i = e("./decoders"), s = e("inherits");
                function o(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                r.define = function(e, t) {
                    return new o(e, t);
                }, o.prototype._createNamed = function(e) {
                    const t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return s(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, o.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, o.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, o.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, o.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            {
                "./decoders": 179,
                "./encoders": 182,
                inherits: 440
            }
        ],
        172: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("../base/reporter").Reporter, s = e("safer-buffer").Buffer;
                function o(e, t) {
                    i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function a(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return a.isEncoderBuffer(e) || (e = new a(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);
                    else {
                        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
                        this.value = e, this.length = e.length;
                    }
                }
                n(o, i), r.DecoderBuffer = o, o.isDecoderBuffer = function(e) {
                    if (e instanceof o) return !0;
                    return "object" == typeof e && s.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, o.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: i.prototype.save.call(this)
                    };
                }, o.prototype.restore = function(e) {
                    const t = new o(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
                }, o.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, o.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, o.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    const r = new o(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, o.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, r.EncoderBuffer = a, a.isEncoderBuffer = function(e) {
                    if (e instanceof a) return !0;
                    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, a.prototype.join = function(e, t) {
                    return e || (e = s.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            {
                "../base/reporter": 175,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        173: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.Reporter = e("./reporter").Reporter, n.DecoderBuffer = e("./buffer").DecoderBuffer, n.EncoderBuffer = e("./buffer").EncoderBuffer, n.Node = e("./node");
            },
            {
                "./buffer": 172,
                "./node": 174,
                "./reporter": 175
            }
        ],
        174: [
            function(e, t, r) {
                "use strict";
                const n = e("../base/reporter").Reporter, i = e("../base/buffer").EncoderBuffer, s = e("../base/buffer").DecoderBuffer, o = e("minimalistic-assert"), a = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], l = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(a);
                function c(e, t, r) {
                    const n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                t.exports = c;
                const u = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                c.prototype.clone = function() {
                    const e = this._baseState, t = {};
                    u.forEach(function(r) {
                        t[r] = e[r];
                    });
                    const r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, c.prototype._wrap = function() {
                    const e = this._baseState;
                    l.forEach(function(t) {
                        this[t] = function() {
                            const r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, c.prototype._init = function(e) {
                    const t = this._baseState;
                    o(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
                }, c.prototype._useArgs = function(e) {
                    const t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" != typeof e || e.constructor !== Object) return e;
                        const t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            const n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), a.forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), c.prototype.use = function(e) {
                    o(e);
                    const t = this._baseState;
                    return o(null === t.use), t.use = e, this;
                }, c.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, c.prototype.def = function(e) {
                    const t = this._baseState;
                    return o(null === t.default), t.default = e, t.optional = !0, this;
                }, c.prototype.explicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, c.prototype.implicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, c.prototype.obj = function() {
                    const e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, c.prototype.key = function(e) {
                    const t = this._baseState;
                    return o(null === t.key), t.key = e, this;
                }, c.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, c.prototype.choice = function(e) {
                    const t = this._baseState;
                    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, c.prototype.contains = function(e) {
                    const t = this._baseState;
                    return o(null === t.use), t.contains = e, this;
                }, c.prototype._decode = function(e, t) {
                    const r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    let n, i = r.default, o = !0, a = null;
                    if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
                        let n = null;
                        if (null !== r.explicit ? n = r.explicit : null !== r.implicit ? n = r.implicit : null !== r.tag && (n = r.tag), null !== n || r.any) {
                            if (o = this._peekTag(e, n, r.any), e.isError(o)) return o;
                        } else {
                            const n = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(n);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            const t = this._decodeTag(e, r.explicit);
                            if (e.isError(t)) return t;
                            e = t;
                        }
                        const n = e.offset;
                        if (null === r.use && null === r.choice) {
                            let t;
                            r.any && (t = e.save());
                            const n = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(n)) return n;
                            r.any ? i = e.raw(t) : e = n;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), n, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            const n = new s(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(n, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
                }, c.prototype._decodeGeneric = function(e, t, r) {
                    const n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, c.prototype._getUse = function(e, t) {
                    const r = this._baseState;
                    return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, c.prototype._decodeChoice = function(e, t) {
                    const r = this._baseState;
                    let n = null, i = !1;
                    return Object.keys(r.choice).some(function(s) {
                        const o = e.save(), a = r.choice[s];
                        try {
                            const r = a._decode(e, t);
                            if (e.isError(r)) return !1;
                            n = {
                                type: s,
                                value: r
                            }, i = !0;
                        } catch (t) {
                            return e.restore(o), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, c.prototype._createEncoderBuffer = function(e) {
                    return new i(e, this.reporter);
                }, c.prototype._encode = function(e, t, r) {
                    const n = this._baseState;
                    if (null !== n.default && n.default === e) return;
                    const i = this._encodeValue(e, t, r);
                    return void 0 === i || this._skipDefault(i, t, r) ? void 0 : i;
                }, c.prototype._encodeValue = function(e, t, r) {
                    const i = this._baseState;
                    if (null === i.parent) return i.children[0]._encode(e, t || new n);
                    let s = null;
                    if (this.reporter = t, i.optional && void 0 === e) {
                        if (null === i.default) return;
                        e = i.default;
                    }
                    let o = null, a = !1;
                    if (i.any) s = this._createEncoderBuffer(e);
                    else if (i.choice) s = this._encodeChoice(e, t);
                    else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;
                    else if (i.children) o = i.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        const n = t.enterKey(r._baseState.key);
                        if ("object" != typeof e) return t.error("Child expected, but input is not object");
                        const i = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(n), i;
                    }, this).filter(function(e) {
                        return e;
                    }), o = this._createEncoderBuffer(o);
                    else if ("seqof" === i.tag || "setof" === i.tag) {
                        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        const r = this.clone();
                        r._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function(r) {
                            const n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, r));
                    } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);
                    if (!i.any && null === i.choice) {
                        const e = null !== i.implicit ? i.implicit : i.tag, r = null === i.implicit ? "universal" : "context";
                        null === e ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(e, a, r, o));
                    }
                    return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
                }, c.prototype._encodeChoice = function(e, t) {
                    const r = this._baseState, n = r.choice[e.type];
                    return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, c.prototype._encodePrimitive = function(e, t) {
                    const r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, c.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, c.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            {
                "../base/buffer": 172,
                "../base/reporter": 175,
                "minimalistic-assert": 453
            }
        ],
        175: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits");
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function s(e, t) {
                    this.path = e, this.rethrow(t);
                }
                r.Reporter = i, i.prototype.isError = function(e) {
                    return e instanceof s;
                }, i.prototype.save = function() {
                    const e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    const t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    const t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    const n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    const e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    const t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    let t;
                    const r = this._reporterState, n = e instanceof s;
                    if (t = n ? e : new s(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    const t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(s, Error), s.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            {
                inherits: 440
            }
        ],
        176: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }
                r.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, r.tagClassByName = n(r.tagClass), r.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, r.tagByName = n(r.tag);
            },
            {}
        ],
        177: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n._reverse = function(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = e("./der");
            },
            {
                "./der": 176
            }
        ],
        178: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("bn.js"), s = e("../base/buffer").DecoderBuffer, o = e("../base/node"), a = e("../constants/der");
                function l(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    o.call(this, "der", e);
                }
                function u(e, t) {
                    let r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    const n = a.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        let n = r;
                        for(r = 0; 128 == (128 & n);){
                            if (n = e.readUInt8(t), e.isError(n)) return n;
                            r <<= 7, r |= 127 & n;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: a.tag[r]
                    };
                }
                function h(e, t, r) {
                    let n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    const i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(let t = 0; t < i; t++){
                        n <<= 8;
                        const t = e.readUInt8(r);
                        if (e.isError(t)) return t;
                        n |= t;
                    }
                    return n;
                }
                t.exports = l, l.prototype.decode = function(e, t) {
                    return s.isDecoderBuffer(e) || (e = new s(e, t)), this.tree._decode(e, t);
                }, n(c, o), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    const n = e.save(), i = u(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    const n = u(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    let i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    const s = e.save(), o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        const r = u(e, t);
                        if (e.isError(r)) return r;
                        const n = h(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        let i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    const i = [];
                    for(; !e.isEmpty();){
                        const t = this._peekTag(e, "end");
                        if (e.isError(t)) return t;
                        const s = r.decode(e, "der", n);
                        if (e.isError(s) && t) break;
                        i.push(s);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        const t = e.readUInt8();
                        return e.isError(t) ? t : {
                            unused: t,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        const t = e.raw();
                        if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        let r = "";
                        for(let e = 0; e < t.length / 2; e++)r += String.fromCharCode(t.readUInt16BE(2 * e));
                        return r;
                    }
                    if ("numstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    let n;
                    const i = [];
                    let s = 0, o = 0;
                    for(; !e.isEmpty();)o = e.readUInt8(), s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
                    128 & o && i.push(s);
                    const a = i[0] / 40 | 0, l = i[0] % 40;
                    if (n = r ? i : [
                        a,
                        l
                    ].concat(i.slice(1)), t) {
                        let e = t[n.join(" ")];
                        void 0 === e && (e = t[n.join(".")]), void 0 !== e && (n = e);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    const r = e.raw().toString();
                    let n, i, s, o, a, l;
                    if ("gentime" === t) n = 0 | r.slice(0, 4), i = 0 | r.slice(4, 6), s = 0 | r.slice(6, 8), o = 0 | r.slice(8, 10), a = 0 | r.slice(10, 12), l = 0 | r.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), l = 0 | r.slice(10, 12), n = n < 70 ? 2e3 + n : 1900 + n;
                    }
                    return Date.UTC(n, i - 1, s, o, a, l, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    const t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    const r = e.raw();
                    let n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            {
                "../base/buffer": 172,
                "../base/node": 174,
                "../constants/der": 176,
                "bn.js": 184,
                inherits: 440
            }
        ],
        179: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 178,
                "./pem": 180
            }
        ],
        180: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("./der");
                function o(e) {
                    s.call(this, e), this.enc = "pem";
                }
                n(o, s), t.exports = o, o.prototype.decode = function(e, t) {
                    const r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/;
                    let a = -1, l = -1;
                    for(let e = 0; e < r.length; e++){
                        const t = r[e].match(o);
                        if (null !== t && t[2] === n) {
                            if (-1 !== a) {
                                if ("END" !== t[1]) break;
                                l = e;
                                break;
                            }
                            if ("BEGIN" !== t[1]) break;
                            a = e;
                        }
                    }
                    if (-1 === a || -1 === l) throw new Error("PEM section not found for: " + n);
                    const c = r.slice(a + 1, l).join("");
                    c.replace(/[^a-z0-9+/=]+/gi, "");
                    const u = i.from(c, "base64");
                    return s.prototype.decode.call(this, u, t);
                };
            },
            {
                "./der": 178,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        181: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("../base/node"), o = e("../constants/der");
                function a(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new l, this.tree._init(e.body);
                }
                function l(e) {
                    s.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                t.exports = a, a.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(l, s), l.prototype._encodeComposite = function(e, t, r, n) {
                    const s = function(e, t, r, n) {
                        let i;
                        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
                        if (o.tagByName.hasOwnProperty(e)) i = o.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
                        t || (i |= 32);
                        return i |= o.tagClassByName[r || "universal"] << 6, i;
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        const e = i.alloc(2);
                        return e[0] = s, e[1] = n.length, this._createEncoderBuffer([
                            e,
                            n
                        ]);
                    }
                    let a = 1;
                    for(let e = n.length; e >= 256; e >>= 8)a++;
                    const l = i.alloc(2 + a);
                    l[0] = s, l[1] = 128 | a;
                    for(let e = 1 + a, t = n.length; t > 0; e--, t >>= 8)l[e] = 255 & t;
                    return this._createEncoderBuffer([
                        l,
                        n
                    ]);
                }, l.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        const t = i.alloc(2 * e.length);
                        for(let r = 0; r < e.length; r++)t.writeUInt16BE(e.charCodeAt(r), 2 * r);
                        return this._createEncoderBuffer(t);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, l.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    let n = 0;
                    for(let t = 0; t < e.length; t++){
                        let r = e[t];
                        for(n++; r >= 128; r >>= 7)n++;
                    }
                    const s = i.alloc(n);
                    let o = s.length - 1;
                    for(let t = e.length - 1; t >= 0; t--){
                        let r = e[t];
                        for(s[o--] = 127 & r; (r >>= 7) > 0;)s[o--] = 128 | 127 & r;
                    }
                    return this._createEncoderBuffer(s);
                }, l.prototype._encodeTime = function(e, t) {
                    let r;
                    const n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, l.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, l.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        const t = e.toArray();
                        !e.sign && 128 & t[0] && t.unshift(0), e = i.from(t);
                    }
                    if (i.isBuffer(e)) {
                        let t = e.length;
                        0 === e.length && t++;
                        const r = i.alloc(t);
                        return e.copy(r), 0 === e.length && (r[0] = 0), this._createEncoderBuffer(r);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    let r = 1;
                    for(let t = e; t >= 256; t >>= 8)r++;
                    const n = new Array(r);
                    for(let t = n.length - 1; t >= 0; t--)n[t] = 255 & e, e >>= 8;
                    return 128 & n[0] && n.unshift(0), this._createEncoderBuffer(i.from(n));
                }, l.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, l.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, l.prototype._skipDefault = function(e, t, r) {
                    const n = this._baseState;
                    let i;
                    if (null === n.default) return !1;
                    const s = e.join();
                    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, r).join()), s.length !== n.defaultBuffer.length) return !1;
                    for(i = 0; i < s.length; i++)if (s[i] !== n.defaultBuffer[i]) return !1;
                    return !0;
                };
            },
            {
                "../base/node": 174,
                "../constants/der": 176,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        182: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 181,
                "./pem": 183
            }
        ],
        183: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("./der");
                function s(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(s, i), t.exports = s, s.prototype.encode = function(e, t) {
                    const r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ];
                    for(let e = 0; e < r.length; e += 64)n.push(r.slice(e, e + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            {
                "./der": 181,
                inherits: 440
            }
        ],
        184: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, n) {
                        for(var i = 0, s = Math.min(e.length, r), o = t; o < s; o++){
                            var a = e.charCodeAt(o) - 48;
                            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                        }
                        return i;
                    }
                    s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this.strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this.strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this.strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype.strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, s.prototype.inspect = function() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    var u = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], h = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], f = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function d(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                    }
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = h[e], d = f[e];
                            r = "";
                            var p = this.clone();
                            for(p.negative = 0; !p.isZero();){
                                var m = p.modn(d).toString(e);
                                r = (p = p.idivn(d)).isZero() ? m + r : u[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16);
                    }, s.prototype.toBuffer = function(e, t) {
                        return n(void 0 !== o), this.toArrayLike(o, e, t);
                    }, s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, s.prototype.toArrayLike = function(e, t, r) {
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
                        var o, a, l = "le" === t, c = new e(s), u = this.clone();
                        if (l) {
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[a] = o;
                            for(; a < s; a++)c[a] = 0;
                        } else {
                            for(a = 0; a < s - i; a++)c[a] = 0;
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
                        }
                        return c;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this.strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this.strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this.strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var p = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        return (new b).mulp(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (p = d), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? p(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function(e, t, r) {
                            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                            for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                                var o = i;
                                i = 0;
                                for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                    var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                    a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                }
                                r.words[s] = a, n = o, o = i;
                            }
                            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
                        }(this, e, t) : m(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, b.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), m(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        n("number" == typeof e), n(e < 67108864);
                        for(var t = 0, r = 0; r < this.length; r++){
                            var i = (0 | this.words[r]) * e, s = (67108863 & i) + (67108863 & t);
                            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
                        }
                        return 0 !== t && (this.words[r] = t, this.length++), this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = (e.words[n] & 1 << i) >>> i;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this.strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this.strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this.strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this.strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this.strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modn = function(e) {
                        n(e <= 67108863);
                        for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
                        return r;
                    }, s.prototype.idivn = function(e) {
                        n(e <= 67108863);
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var i = (0 | this.words[r]) + 67108864 * t;
                            this.words[r] = i / e | 0, t = i % e;
                        }
                        return this.strip();
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this.strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new k(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var g = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function y(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function v() {
                        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function _() {
                        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function k(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    y.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, y.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, y.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, y.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(v, y), v.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, v.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, y), i(_, y), i(x, y), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (g[e]) return g[e];
                        var t;
                        if ("k256" === e) t = new v;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new _;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return g[e] = t, t;
                    }, k.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, k.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, k.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
                    }, k.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, k.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, k.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, k.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, k.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, k.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, k.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, k.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, k.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, k.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, k.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, k.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, k.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, k.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, k.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new S(e);
                    }, i(S, k), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        185: [
            function(e, t, r) {
                "use strict";
                r.byteLength = function(e) {
                    var t = c(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(e) {
                    var t, r, n = c(e), o = n[0], a = n[1], l = new s(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, o, a)), u = 0, h = a > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], l[u++] = t >> 16 & 255, l[u++] = t >> 8 & 255, l[u++] = 255 & t;
                    2 === a && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, l[u++] = 255 & t);
                    1 === a && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, l[u++] = t >> 8 & 255, l[u++] = 255 & t);
                    return l;
                }, r.fromByteArray = function(e) {
                    for(var t, r = e.length, i = r % 3, s = [], o = 0, a = r - i; o < a; o += 16383)s.push(u(e, o, o + 16383 > a ? a : o + 16383));
                    1 === i ? (t = e[r - 1], s.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
                    return s.join("");
                };
                for(var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, l = o.length; a < l; ++a)n[a] = o[a], i[o.charCodeAt(a)] = a;
                function c(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e, t, r) {
                    for(var i, s, o = [], a = t; a < r; a += 3)i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        186: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var s = 0, o = 0, a = Math.min(e.length, r), l = t; l < a; l++){
                            var c = e.charCodeAt(l) - 48;
                            s *= i, o = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && o < i, "Invalid character"), s += o;
                        }
                        return s;
                    }
                    function u(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this._strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this._strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this._strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype._move = function(e) {
                        u(e, this);
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
                    } catch (e) {
                        s.prototype.inspect = h;
                    }
                    else s.prototype.inspect = h;
                    function h() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var f = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], d = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                s = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, o--), r = 0 !== s || o !== this.length - 1 ? f[6 - l.length] + l + r : l + r;
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = d[e], u = p[e];
                            r = "";
                            var h = this.clone();
                            for(h.negative = 0; !h.isZero();){
                                var m = h.modrn(u).toString(e);
                                r = (h = h.idivn(u)).isZero() ? m + r : f[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, o && (s.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(o, e, t);
                    }), s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r._strip();
                    }
                    s.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0");
                        var o = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, s);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](o, i), o;
                    }, s.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r++] = 255 & o, r < e.length && (e[r++] = o >> 8 & 255), r < e.length && (e[r++] = o >> 16 & 255), 6 === s ? (r < e.length && (e[r++] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, s.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r--] = 255 & o, r >= 0 && (e[r--] = o >> 8 & 255), r >= 0 && (e[r--] = o >> 16 & 255), 6 === s ? (r >= 0 && (e[r--] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this._strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var b = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function g(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                            var o = i;
                            i = 0;
                            for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                            }
                            r.words[s] = a, n = o, o = i;
                        }
                        return 0 !== n ? r.words[s] = n : r.length--, r._strip();
                    }
                    function y(e, t, r) {
                        return g(e, t, r);
                    }
                    function v(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (b = m), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : y(this, e, t);
                    }, v.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, v.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, v.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, v.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, v.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, v.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, v.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, v.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, v.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, v.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), y(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var s = (0 | this.words[i]) * e, o = (67108863 & s) + (67108863 & r);
                            r >>= 26, r += s / 67108864 | 0, r += o >>> 26, this.words[i] = 67108863 & o;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this._strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, s = this.length - 1; s >= 0; s--)i = (r * i + (0 | this.words[s])) % e;
                        return t ? -i : i;
                    }, s.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, s.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var s = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = s / e | 0, r = s % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new C(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var w = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function x() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function k() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function M() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function C(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function T(e) {
                        C.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(x, _), x.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, x.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(k, _), i(S, _), i(M, _), M.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (w[e]) return w[e];
                        var t;
                        if ("k256" === e) t = new x;
                        else if ("p224" === e) t = new k;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new M;
                        }
                        return w[e] = t, t;
                    }, C.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, C.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, C.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (u(e, e.umod(this.m)._forceRed(this)), e);
                    }, C.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, C.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, C.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, C.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, C.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, C.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, C.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, C.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, C.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, C.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, C.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, C.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, C.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, C.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, C.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new T(e);
                    }, i(T, C), T.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, T.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, T.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, T.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, T.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        187: [
            function(e, t, r) {
                "use strict";
                var n;
                function i(e) {
                    this.rand = e;
                }
                if (t.exports = function(e) {
                    return n || (n = new i(null)), n.generate(e);
                }, t.exports.Rand = i, i.prototype.generate = function(e) {
                    return this._rand(e);
                }, i.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" == typeof window && (i.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var s = e("crypto");
                    if ("function" != typeof s.randomBytes) throw new Error("Not supported");
                    i.prototype._rand = function(e) {
                        return s.randomBytes(e);
                    };
                } catch (e) {}
            },
            {
                crypto: 188
            }
        ],
        188: [
            function(e, t, r) {},
            {}
        ],
        189: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function s(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function o(e, t, r, n, i) {
                    for(var s, o, a, l, c = r[0], u = r[1], h = r[2], f = r[3], d = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], b = e[3] ^ t[3], g = 4, y = 1; y < i; y++)s = c[d >>> 24] ^ u[p >>> 16 & 255] ^ h[m >>> 8 & 255] ^ f[255 & b] ^ t[g++], o = c[p >>> 24] ^ u[m >>> 16 & 255] ^ h[b >>> 8 & 255] ^ f[255 & d] ^ t[g++], a = c[m >>> 24] ^ u[b >>> 16 & 255] ^ h[d >>> 8 & 255] ^ f[255 & p] ^ t[g++], l = c[b >>> 24] ^ u[d >>> 16 & 255] ^ h[p >>> 8 & 255] ^ f[255 & m] ^ t[g++], d = s, p = o, m = a, b = l;
                    return s = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], o = (n[p >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & d]) ^ t[g++], a = (n[m >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], l = (n[b >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & m]) ^ t[g++], [
                        s >>>= 0,
                        o >>>= 0,
                        a >>>= 0,
                        l >>>= 0
                    ];
                }
                var a = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], l = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], s = [
                        [],
                        [],
                        [],
                        []
                    ], o = 0, a = 0, l = 0; l < 256; ++l){
                        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
                        var u = e[o], h = e[u], f = e[h], d = 257 * e[c] ^ 16843008 * c;
                        i[0][o] = d << 24 | d >>> 8, i[1][o] = d << 16 | d >>> 16, i[2][o] = d << 8 | d >>> 24, i[3][o] = d, d = 16843009 * f ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = d << 24 | d >>> 8, s[1][c] = d << 16 | d >>> 16, s[2][c] = d << 8 | d >>> 24, s[3][c] = d, 0 === o ? o = a = 1 : (o = u ^ e[e[e[f ^ u]]], a ^= e[e[a]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: s
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++)i[s] = e[s];
                    for(s = t; s < n; s++){
                        var o = i[s - 1];
                        s % t == 0 ? (o = o << 8 | o >>> 24, o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o]), i[s] = i[s - t] ^ o;
                    }
                    for(var c = [], u = 0; u < n; u++){
                        var h = n - u, f = i[h - (u % 4 ? 0 : 4)];
                        c[u] = u < 4 || h <= 4 ? f : l.INV_SUB_MIX[0][l.SBOX[f >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[f >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[f >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & f]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return o(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = o(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), s = n.allocUnsafe(16);
                    return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
                }, c.prototype.scrub = function() {
                    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
                }, t.exports.AES = c;
            },
            {
                "safe-buffer": 494
            }
        ],
        190: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = e("inherits"), a = e("./ghash"), l = e("buffer-xor"), c = e("./incr32");
                function u(e, t, r, o) {
                    s.call(this);
                    var l = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var u = this._cipher.encryptBlock(l);
                    this._ghash = new a(u), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new a(r), s = t.length, o = s % 16;
                        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
                        var l = 8 * s, u = i.alloc(8);
                        u.writeUIntBE(l, 0, 8), n.update(u), e._finID = n.state;
                        var h = i.from(e._finID);
                        return c(h), h;
                    }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                o(u, s), u.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, u.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, u.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, u.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, u.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, t.exports = u;
            },
            {
                "./aes": 189,
                "./ghash": 194,
                "./incr32": 195,
                "buffer-xor": 219,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        191: [
            function(e, t, r) {
                "use strict";
                var n = e("./encrypter"), i = e("./decrypter"), s = e("./modes/list.json");
                r.createCipher = r.Cipher = n.createCipher, r.createCipheriv = r.Cipheriv = n.createCipheriv, r.createDecipher = r.Decipher = i.createDecipher, r.createDecipheriv = r.Decipheriv = i.createDecipheriv, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(s);
                };
            },
            {
                "./decrypter": 192,
                "./encrypter": 193,
                "./modes/list.json": 203
            }
        ],
        192: [
            function(e, t, r) {
                "use strict";
                var n = e("./authCipher"), i = e("safe-buffer").Buffer, s = e("./modes"), o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new h, this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function h() {
                    this.cache = i.allocUnsafe(0);
                }
                function f(e, t, r) {
                    var a = s[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        var r = -1;
                        for(; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 === t) return;
                        return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, h.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, h.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, h.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, r.createDecipher = function(e, t) {
                    var r = s[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return f(e, n.key, n.iv);
                }, r.createDecipheriv = f;
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        193: [
            function(e, t, r) {
                "use strict";
                var n = e("./modes"), i = e("./authCipher"), s = e("safe-buffer").Buffer, o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new f, this._cipher = new l.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return s.concat(n);
                };
                var h = s.alloc(16, 16);
                function f() {
                    this.cache = s.allocUnsafe(0);
                }
                function d(e, t, r) {
                    var a = n[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
                }
                u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, f.prototype.add = function(e) {
                    this.cache = s.concat([
                        this.cache,
                        e
                    ]);
                }, f.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, f.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return s.concat([
                        this.cache,
                        t
                    ]);
                }, r.createCipheriv = d, r.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return d(e, i.key, i.iv);
                };
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        194: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.alloc(16, 0);
                function s(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function o(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                o.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, o.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], o = -1; ++o < 128;){
                        for(0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = s(i);
                }, o.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, o.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(s([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, t.exports = o;
            },
            {
                "safe-buffer": 494
            }
        ],
        195: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            {}
        ],
        196: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor");
                r.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, r.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            {
                "buffer-xor": 219
            }
        ],
        197: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("buffer-xor");
                function s(e, t, r) {
                    var s = t.length, o = i(t, e._cache);
                    return e._cache = e._cache.slice(s), e._prev = n.concat([
                        e._prev,
                        r ? t : o
                    ]), o;
                }
                r.encrypt = function(e, t, r) {
                    for(var i, o = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            o = n.concat([
                                o,
                                s(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, o = n.concat([
                            o,
                            s(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return o;
                };
            },
            {
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        198: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    for(var n, i, o = -1, a = 0; ++o < 8;)n = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8, e._prev = s(e._prev, r ? n : i);
                    return a;
                }
                function s(e, t) {
                    var r = e.length, i = -1, s = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)s[i] = e[i] << 1 | e[i + 1] >> 7;
                    return s;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        199: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        200: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor"), i = e("safe-buffer").Buffer, s = e("../incr32");
                function o(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return s(e._prev), t;
                }
                r.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), s = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var a = 0; a < r; a++){
                        var l = o(e), c = s + 16 * a;
                        e._cache.writeUInt32BE(l[0], c + 0), e._cache.writeUInt32BE(l[1], c + 4), e._cache.writeUInt32BE(l[2], c + 8), e._cache.writeUInt32BE(l[3], c + 12);
                    }
                    var u = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, u);
                };
            },
            {
                "../incr32": 195,
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        201: [
            function(e, t, r) {
                "use strict";
                r.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, r.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            {}
        ],
        202: [
            function(e, t, r) {
                "use strict";
                var n = {
                    ECB: e("./ecb"),
                    CBC: e("./cbc"),
                    CFB: e("./cfb"),
                    CFB8: e("./cfb8"),
                    CFB1: e("./cfb1"),
                    OFB: e("./ofb"),
                    CTR: e("./ctr"),
                    GCM: e("./ctr")
                }, i = e("./list.json");
                for(var s in i)i[s].module = n[i[s].mode];
                t.exports = i;
            },
            {
                "./cbc": 196,
                "./cfb": 197,
                "./cfb1": 198,
                "./cfb8": 199,
                "./ctr": 200,
                "./ecb": 201,
                "./list.json": 203,
                "./ofb": 204
            }
        ],
        203: [
            function(e, t, r) {
                t.exports = {
                    "aes-128-ecb": {
                        cipher: "AES",
                        key: 128,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-192-ecb": {
                        cipher: "AES",
                        key: 192,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-256-ecb": {
                        cipher: "AES",
                        key: 256,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-128-cbc": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-192-cbc": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-256-cbc": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes128: {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes192: {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes256: {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-128-cfb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-192-cfb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-256-cfb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-128-cfb8": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-192-cfb8": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-256-cfb8": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-128-cfb1": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-192-cfb1": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-256-cfb1": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-128-ofb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-192-ofb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-256-ofb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-128-ctr": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-192-ctr": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-256-ctr": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-128-gcm": {
                        cipher: "AES",
                        key: 128,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-192-gcm": {
                        cipher: "AES",
                        key: 192,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-256-gcm": {
                        cipher: "AES",
                        key: 256,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    }
                };
            },
            {}
        ],
        204: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("buffer-xor");
                        function i(e) {
                            return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                        }
                        r.encrypt = function(e, r) {
                            for(; e._cache.length < r.length;)e._cache = t.concat([
                                e._cache,
                                i(e)
                            ]);
                            var s = e._cache.slice(0, r.length);
                            return e._cache = e._cache.slice(r.length), n(r, s);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                "buffer-xor": 219
            }
        ],
        205: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base");
                function o(e, t, r, o) {
                    s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
                }
                e("inherits")(o, s), o.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, o.prototype._final = function() {
                    this._cipher.scrub();
                }, t.exports = o;
            },
            {
                "./aes": 189,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        206: [
            function(e, t, r) {
                "use strict";
                var n = e("browserify-des"), i = e("browserify-aes/browser"), s = e("browserify-aes/modes"), o = e("browserify-des/modes"), a = e("evp_bytestokey");
                function l(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createCipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createDecipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                r.createCipher = r.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return l(e, i.key, i.iv);
                }, r.createCipheriv = r.Cipheriv = l, r.createDecipher = r.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, r.createDecipheriv = r.Decipheriv = c, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(o).concat(i.getCiphers());
                };
            },
            {
                "browserify-aes/browser": 191,
                "browserify-aes/modes": 202,
                "browserify-des": 207,
                "browserify-des/modes": 208,
                evp_bytestokey: 423
            }
        ],
        207: [
            function(e, t, r) {
                "use strict";
                var n = e("cipher-base"), i = e("des.js"), s = e("inherits"), o = e("safe-buffer").Buffer, a = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function l(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = a[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var s = e.key;
                    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== r && "des-ede-cbc" !== r || (s = o.concat([
                        s,
                        s.slice(0, 8)
                    ]));
                    var l = e.iv;
                    o.isBuffer(l) || (l = o.from(l)), this._des = i.create({
                        key: s,
                        iv: l,
                        type: t
                    });
                }
                a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], t.exports = l, s(l, n), l.prototype._update = function(e) {
                    return o.from(this._des.update(e));
                }, l.prototype._final = function() {
                    return o.from(this._des.final());
                };
            },
            {
                "cipher-base": 221,
                "des.js": 394,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        208: [
            function(e, t, r) {
                "use strict";
                r["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, r["des-cbc"] = r.des = {
                    key: 8,
                    iv: 8
                }, r["des-ede3-cbc"] = r.des3 = {
                    key: 24,
                    iv: 8
                }, r["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, r["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, r["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            {}
        ],
        209: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = e("randombytes");
                        function s(e) {
                            var t, r = e.modulus.byteLength();
                            do t = new n(i(r));
                            while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                            return t;
                        }
                        function o(e, t) {
                            var i = function(e) {
                                var t = s(e);
                                return {
                                    blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
                                    unblinder: t.invm(e.modulus)
                                };
                            }(t), o = t.modulus.byteLength(), a = new n(e).mul(i.blinder).umod(t.modulus), l = a.toRed(n.mont(t.prime1)), c = a.toRed(n.mont(t.prime2)), u = t.coefficient, h = t.prime1, f = t.prime2, d = l.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), m = d.isub(p).imul(u).umod(h).imul(f);
                            return p.iadd(m).imul(i.unblinder).umod(t.modulus).toArrayLike(r, "be", o);
                        }
                        o.getr = s, t.exports = o;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 186,
                buffer: 220,
                randombytes: 475
            }
        ],
        210: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./browser/algorithms.json");
            },
            {
                "./browser/algorithms.json": 211
            }
        ],
        211: [
            function(e, t, r) {
                t.exports = {
                    sha224WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    "RSA-SHA224": {
                        sign: "ecdsa/rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    sha256WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    "RSA-SHA256": {
                        sign: "ecdsa/rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    sha384WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    "RSA-SHA384": {
                        sign: "ecdsa/rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    sha512WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA512": {
                        sign: "ecdsa/rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA1": {
                        sign: "rsa",
                        hash: "sha1",
                        id: "3021300906052b0e03021a05000414"
                    },
                    "ecdsa-with-SHA1": {
                        sign: "ecdsa",
                        hash: "sha1",
                        id: ""
                    },
                    sha256: {
                        sign: "ecdsa",
                        hash: "sha256",
                        id: ""
                    },
                    sha224: {
                        sign: "ecdsa",
                        hash: "sha224",
                        id: ""
                    },
                    sha384: {
                        sign: "ecdsa",
                        hash: "sha384",
                        id: ""
                    },
                    sha512: {
                        sign: "ecdsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-SHA1": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    DSA: {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-WITH-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-WITH-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-WITH-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-WITH-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-RIPEMD160": {
                        sign: "dsa",
                        hash: "rmd160",
                        id: ""
                    },
                    ripemd160WithRSA: {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    "RSA-RIPEMD160": {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    md5WithRSAEncryption: {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    },
                    "RSA-MD5": {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    }
                };
            },
            {}
        ],
        212: [
            function(e, t, r) {
                t.exports = {
                    "1.3.132.0.10": "secp256k1",
                    "1.3.132.0.33": "p224",
                    "1.2.840.10045.3.1.1": "p192",
                    "1.2.840.10045.3.1.7": "p256",
                    "1.3.132.0.34": "p384",
                    "1.3.132.0.35": "p521"
                };
            },
            {}
        ],
        213: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hash"), s = e("readable-stream"), o = e("inherits"), a = e("./sign"), l = e("./verify"), c = e("./algorithms.json");
                function u(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function h(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function f(e) {
                    return new u(e);
                }
                function d(e) {
                    return new h(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), o(u, s.Writable), u.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, u.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, u.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = a(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, o(h, s.Writable), h.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, h.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, h.prototype.verify = function(e, t, r) {
                    "string" == typeof t && (t = n.from(t, r)), this.end();
                    var i = this._hash.digest();
                    return l(t, i, e, this._signType, this._tag);
                }, t.exports = {
                    Sign: f,
                    Verify: d,
                    createSign: f,
                    createVerify: d
                };
            },
            {
                "./algorithms.json": 211,
                "./sign": 214,
                "./verify": 215,
                "create-hash": 386,
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        214: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hmac"), s = e("browserify-rsa"), o = e("elliptic").ec, a = e("bn.js"), l = e("parse-asn1"), c = e("./curves.json");
                function u(e, t, r, s) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var o = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            o,
                            e
                        ]);
                    }
                    var a = r.length, l = function(e, t) {
                        e = (e = h(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(a);
                    c.fill(1);
                    var u = n.alloc(a);
                    return u = i(s, u).update(c).update(n.from([
                        0
                    ])).update(e).update(l).digest(), c = i(s, u).update(c).digest(), {
                        k: u = i(s, u).update(c).update(n.from([
                            1
                        ])).update(e).update(l).digest(),
                        v: c = i(s, u).update(c).digest()
                    };
                }
                function h(e, t) {
                    var r = new a(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function f(e, t, r) {
                    var s, o;
                    do {
                        for(s = n.alloc(0); 8 * s.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), s = n.concat([
                            s,
                            t.v
                        ]);
                        o = h(s, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== o.cmp(e));
                    return o;
                }
                function d(e, t, r, n) {
                    return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
                }
                t.exports = function(e, t, r, i, p) {
                    var m = l(t);
                    if (m.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new o(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, m);
                    }
                    if ("dsa" === m.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            var i, s = t.params.priv_key, o = t.params.p, l = t.params.q, c = t.params.g, p = new a(0), m = h(e, l).mod(l), b = !1, g = u(s, l, e, r);
                            for(; !1 === b;)i = f(l, g, r), p = d(c, i, o, l), 0 === (b = i.invm(l).imul(m.add(s.mul(p))).mod(l)).cmpn(0) && (b = !1, p = new a(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e));
                                128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, b);
                        }(e, m, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var b = m.modulus.byteLength(), g = [
                        0,
                        1
                    ]; e.length + g.length + 1 < b;)g.push(255);
                    g.push(0);
                    for(var y = -1; ++y < e.length;)g.push(e[y]);
                    return s(g, m);
                }, t.exports.getKey = u, t.exports.makeKey = f;
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                "browserify-rsa": 209,
                "create-hmac": 388,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        215: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("bn.js"), s = e("elliptic").ec, o = e("parse-asn1"), a = e("./curves.json");
                function l(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= t) throw new Error("invalid sig");
                }
                t.exports = function(e, t, r, c, u) {
                    var h = o(r);
                    if ("ec" === h.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = a[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new s(n), o = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, o);
                        }(e, t, h);
                    }
                    if ("dsa" === h.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, s = r.data.q, a = r.data.g, c = r.data.pub_key, u = o.signature.decode(e, "der"), h = u.s, f = u.r;
                            l(h, s), l(f, s);
                            var d = i.mont(n), p = h.invm(s);
                            return 0 === a.toRed(d).redPow(new i(t).mul(p).mod(s)).fromRed().mul(c.toRed(d).redPow(f.mul(p).mod(s)).fromRed()).mod(n).mod(s).cmp(f);
                        }(e, t, h);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        u,
                        t
                    ]);
                    for(var f = h.modulus.byteLength(), d = [
                        1
                    ], p = 0; t.length + d.length + 2 < f;)d.push(255), p++;
                    d.push(0);
                    for(var m = -1; ++m < t.length;)d.push(t[m]);
                    d = n.from(d);
                    var b = i.mont(h.modulus);
                    e = (e = new i(e).toRed(b)).redPow(new i(h.publicExponent)), e = n.from(e.fromRed().toArray());
                    var g = p < 8 ? 1 : 0;
                    for(f = Math.min(e.length, d.length), e.length !== d.length && (g = 1), m = -1; ++m < f;)g |= e[m] ^ d[m];
                    return 0 === g;
                };
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        216: [
            function(e, t, r) {},
            {}
        ],
        217: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        218: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function s(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = a, t = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, t = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function o(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function a(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function l(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function u(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function h(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function f(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                r.StringDecoder = s, s.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, s.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, s.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = o(t[n]);
                        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, s.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            {
                "safe-buffer": 217
            }
        ],
        219: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = function(t, r) {
                            for(var n = Math.min(t.length, r.length), i = new e(n), s = 0; s < n; ++s)i[s] = t[s] ^ r[s];
                            return i;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        220: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var t = e("base64-js"), n = e("ieee754");
                        r.Buffer = s, r.SlowBuffer = function(e) {
                            +e != e && (e = 0);
                            return s.alloc(+e);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(e) {
                            if (e > 2147483647) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, r) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(e);
                            }
                            return o(e, t, r);
                        }
                        function o(e, t, r) {
                            if ("string" == typeof e) return function(e, t) {
                                "string" == typeof t && "" !== t || (t = "utf8");
                                if (!s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                var r = 0 | h(e, t), n = i(r), o = n.write(e, t);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(e, t);
                            if (ArrayBuffer.isView(e)) return c(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (F(e, ArrayBuffer) || e && F(e.buffer, ArrayBuffer)) return function(e, t, r) {
                                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r);
                                return n.__proto__ = s.prototype, n;
                            }(e, t, r);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = e.valueOf && e.valueOf();
                            if (null != n && n !== e) return s.from(n, t, r);
                            var o = function(e) {
                                if (s.isBuffer(e)) {
                                    var t = 0 | u(e.length), r = i(t);
                                    return 0 === r.length || e.copy(r, 0, 0, t), r;
                                }
                                if (void 0 !== e.length) return "number" != typeof e.length || L(e.length) ? i(0) : c(e);
                                if ("Buffer" === e.type && Array.isArray(e.data)) return c(e.data);
                            }(e);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function a(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function l(e) {
                            return a(e), i(e < 0 ? 0 : 0 | u(e));
                        }
                        function c(e) {
                            for(var t = e.length < 0 ? 0 : 0 | u(e.length), r = i(t), n = 0; n < t; n += 1)r[n] = 255 & e[n];
                            return r;
                        }
                        function u(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function h(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || F(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return P(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return B(e).length;
                                default:
                                    if (i) return n ? -1 : P(e).length;
                                    t = ("" + t).toLowerCase(), i = !0;
                            }
                        }
                        function f(e, t, r) {
                            var n = !1;
                            if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (t >>>= 0)) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return C(this, t, r);
                                case "utf8":
                                case "utf-8":
                                    return k(this, t, r);
                                case "ascii":
                                    return S(this, t, r);
                                case "latin1":
                                case "binary":
                                    return M(this, t, r);
                                case "base64":
                                    return x(this, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return T(this, t, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), n = !0;
                            }
                        }
                        function d(e, t, r) {
                            var n = e[t];
                            e[t] = e[r], e[r] = n;
                        }
                        function p(e, t, r, n, i) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), L(r = +r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                if (i) return -1;
                                r = e.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof t && (t = s.from(t, n)), s.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                                t
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(e, t, r, n, i) {
                            var s, o = 1, a = e.length, l = t.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (e.length < 2 || t.length < 2) return -1;
                                o = 2, a /= 2, l /= 2, r /= 2;
                            }
                            function c(e, t) {
                                return 1 === o ? e[t] : e.readUInt16BE(t * o);
                            }
                            if (i) {
                                var u = -1;
                                for(s = r; s < a; s++)if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
                                    if (-1 === u && (u = s), s - u + 1 === l) return u * o;
                                } else -1 !== u && (s -= s - u), u = -1;
                            } else for(r + l > a && (r = a - l), s = r; s >= 0; s--){
                                for(var h = !0, f = 0; f < l; f++)if (c(e, s + f) !== c(t, f)) {
                                    h = !1;
                                    break;
                                }
                                if (h) return s;
                            }
                            return -1;
                        }
                        function b(e, t, r, n) {
                            r = Number(r) || 0;
                            var i = e.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var s = t.length;
                            n > s / 2 && (n = s / 2);
                            for(var o = 0; o < n; ++o){
                                var a = parseInt(t.substr(2 * o, 2), 16);
                                if (L(a)) return o;
                                e[r + o] = a;
                            }
                            return o;
                        }
                        function g(e, t, r, n) {
                            return D(P(t, e.length - r), e, r, n);
                        }
                        function y(e, t, r, n) {
                            return D(function(e) {
                                for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                return t;
                            }(t), e, r, n);
                        }
                        function v(e, t, r, n) {
                            return y(e, t, r, n);
                        }
                        function w(e, t, r, n) {
                            return D(B(t), e, r, n);
                        }
                        function _(e, t, r, n) {
                            return D(function(e, t) {
                                for(var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
                                return s;
                            }(t, e.length - r), e, r, n);
                        }
                        function x(e, r, n) {
                            return 0 === r && n === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(r, n));
                        }
                        function k(e, t, r) {
                            r = Math.min(e.length, r);
                            for(var n = [], i = t; i < r;){
                                var s, o, a, l, c = e[i], u = null, h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + h <= r) switch(h){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (s = e[i + 1])) && (l = (31 & c) << 6 | 63 & s) > 127 && (u = l);
                                        break;
                                    case 3:
                                        s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
                            }
                            return function(e) {
                                var t = e.length;
                                if (t <= 4096) return String.fromCharCode.apply(String, e);
                                var r = "", n = 0;
                                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (e) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, r) {
                            return o(e, t, r);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, r) {
                            return function(e, t, r) {
                                return a(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof r ? i(e).fill(t, r) : i(e).fill(t) : i(e);
                            }(e, t, r);
                        }, s.allocUnsafe = function(e) {
                            return l(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return l(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), F(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                                r = e[i], n = t[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch(String(e).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var r;
                            if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                            var n = s.allocUnsafe(t), i = 0;
                            for(r = 0; r < e.length; ++r){
                                var o = e[r];
                                if (F(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)d(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)d(this, t, t + 3), d(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)d(this, t, t + 7), d(this, t + 1, t + 6), d(this, t + 2, t + 5), d(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = r.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, r, n, i) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && t >= r) return 0;
                            if (n >= i) return -1;
                            if (t >= r) return 1;
                            if (this === e) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), l = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h)if (c[h] !== u[h]) {
                                o = c[h], a = u[h];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, s.prototype.includes = function(e, t, r) {
                            return -1 !== this.indexOf(e, t, r);
                        }, s.prototype.indexOf = function(e, t, r) {
                            return p(this, e, t, r, !0);
                        }, s.prototype.lastIndexOf = function(e, t, r) {
                            return p(this, e, t, r, !1);
                        }, s.prototype.write = function(e, t, r, n) {
                            if (void 0 === t) n = "utf8", r = this.length, t = 0;
                            else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                            else {
                                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - t;
                            if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var s = !1;;)switch(n){
                                case "hex":
                                    return b(this, e, t, r);
                                case "utf8":
                                case "utf-8":
                                    return g(this, e, t, r);
                                case "ascii":
                                    return y(this, e, t, r);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, r);
                                case "base64":
                                    return w(this, e, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, e, t, r);
                                default:
                                    if (s) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), s = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function S(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                            return n;
                        }
                        function M(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                            return n;
                        }
                        function C(e, t, r) {
                            var n = e.length;
                            (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", s = t; s < r; ++s)i += N(e[s]);
                            return i;
                        }
                        function T(e, t, r) {
                            for(var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2)i += String.fromCharCode(n[s] + 256 * n[s + 1]);
                            return i;
                        }
                        function E(e, t, r) {
                            if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                            if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function A(e, t, r, n, i, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > e.length) throw new RangeError("Index out of range");
                        }
                        function R(e, t, r, n, i, s) {
                            if (r + n > e.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function O(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4;
                        }
                        function j(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8;
                        }
                        s.prototype.slice = function(e, t) {
                            var r = this.length;
                            (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                            var n = this.subarray(e, t);
                            return n.__proto__ = s.prototype, n;
                        }, s.prototype.readUIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n;
                        }, s.prototype.readUIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                            return n;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                        }, s.prototype.readIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);)s += this[e + --n] * i;
                            return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e] | this[e + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e + 1] | this[e] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, s = 0;
                            for(this[t] = 255 & e; ++s < r && (i *= 256);)this[t + s] = e / i & 255;
                            return t + r;
                        }, s.prototype.writeUIntBE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, s = 1;
                            for(this[t + i] = 255 & e; --i >= 0 && (s *= 256);)this[t + i] = e / s & 255;
                            return t + r;
                        }, s.prototype.writeUInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = 0, o = 1, a = 0;
                            for(this[t] = 255 & e; ++s < r && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeIntBE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = r - 1, o = 1, a = 0;
                            for(this[t + s] = 255 & e; --s >= 0 && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, r) {
                            return O(this, e, t, !0, r);
                        }, s.prototype.writeFloatBE = function(e, t, r) {
                            return O(this, e, t, !1, r);
                        }, s.prototype.writeDoubleLE = function(e, t, r) {
                            return j(this, e, t, !0, r);
                        }, s.prototype.writeDoubleBE = function(e, t, r) {
                            return j(this, e, t, !1, r);
                        }, s.prototype.copy = function(e, t, r, n) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (t < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                            var i = n - r;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, n);
                            else if (this === e && r < t && t < n) for(var o = i - 1; o >= 0; --o)e[o + t] = this[o + r];
                            else Uint8Array.prototype.set.call(e, this.subarray(r, n), t);
                            return i;
                        }, s.prototype.fill = function(e, t, r, n) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === e.length) {
                                    var i = e.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (e = i);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                            if (r <= t) return this;
                            var o;
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                            else {
                                var a = s.isBuffer(e) ? e : s.from(e, n), l = a.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < r - t; ++o)this[o + t] = a[o % l];
                            }
                            return this;
                        };
                        var I = /[^+/0-9A-Za-z-_]/g;
                        function N(e) {
                            return e < 16 ? "0" + e.toString(16) : e.toString(16);
                        }
                        function P(e, t) {
                            var r;
                            t = t || 1 / 0;
                            for(var n = e.length, i = null, s = [], o = 0; o < n; ++o){
                                if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (t -= 3) > -1 && s.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (t -= 3) > -1 && s.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((t -= 1) < 0) break;
                                    s.push(r);
                                } else if (r < 2048) {
                                    if ((t -= 2) < 0) break;
                                    s.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((t -= 3) < 0) break;
                                    s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((t -= 4) < 0) break;
                                    s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return s;
                        }
                        function B(e) {
                            return t.toByteArray(function(e) {
                                if ((e = (e = e.split("=")[0]).trim().replace(I, "")).length < 2) return "";
                                for(; e.length % 4 != 0;)e += "=";
                                return e;
                            }(e));
                        }
                        function D(e, t, r, n) {
                            for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                            return i;
                        }
                        function F(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function L(e) {
                            return e != e;
                        }
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 185,
                buffer: 220,
                ieee754: 439
            }
        ],
        221: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("stream").Transform, s = e("string_decoder").StringDecoder;
                function o(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                e("inherits")(o, i), o.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, o.prototype.setAutoPadding = function() {}, o.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, o.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, o.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, o.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, o.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, o.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, t.exports = o;
            },
            {
                inherits: 440,
                "safe-buffer": 494,
                stream: 505,
                string_decoder: 218
            }
        ],
        222: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a function");
                };
            },
            {
                "../internals/is-callable": 285,
                "../internals/try-to-string": 349
            }
        ],
        223: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-constructor"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a constructor");
                };
            },
            {
                "../internals/is-constructor": 286,
                "../internals/try-to-string": 349
            }
        ],
        224: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = String, s = TypeError;
                t.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw new s("Can't set " + i(e) + " as a prototype");
                };
            },
            {
                "../internals/is-callable": 285
            }
        ],
        225: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/object-create"), s = e("../internals/object-define-property").f, o = n("unscopables"), a = Array.prototype;
                void 0 === a[o] && s(a, o, {
                    configurable: !0,
                    value: i(null)
                }), t.exports = function(e) {
                    a[o][e] = !0;
                };
            },
            {
                "../internals/object-create": 306,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        226: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-is-prototype-of"), i = TypeError;
                t.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            {
                "../internals/object-is-prototype-of": 314
            }
        ],
        227: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = String, s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not an object");
                };
            },
            {
                "../internals/is-object": 289
            }
        ],
        228: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/to-absolute-index"), s = e("../internals/length-of-array-like"), o = function(e) {
                    return function(t, r, o) {
                        var a, l = n(t), c = s(l), u = i(o, c);
                        if (e && r != r) {
                            for(; c > u;)if ((a = l[u++]) != a) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === r) return e || u || 0;
                        return !e && -1;
                    };
                };
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340,
                "../internals/to-indexed-object": 341
            }
        ],
        229: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-uncurry-this"), s = e("../internals/indexed-object"), o = e("../internals/to-object"), a = e("../internals/length-of-array-like"), l = e("../internals/array-species-create"), c = i([].push), u = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, u = 4 === e, h = 6 === e, f = 7 === e, d = 5 === e || h;
                    return function(p, m, b, g) {
                        for(var y, v, w = o(p), _ = s(w), x = n(m, b), k = a(_), S = 0, M = g || l, C = t ? M(p, k) : r || f ? M(p, 0) : void 0; k > S; S++)if ((d || S in _) && (v = x(y = _[S], S, w), e)) {
                            if (t) C[S] = v;
                            else if (v) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return S;
                                case 2:
                                    c(C, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(C, y);
                            }
                        }
                        return h ? -1 : i || u ? u : C;
                    };
                };
                t.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            {
                "../internals/array-species-create": 233,
                "../internals/function-bind-context": 262,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/length-of-array-like": 299,
                "../internals/to-object": 344
            }
        ],
        230: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-absolute-index"), i = e("../internals/length-of-array-like"), s = e("../internals/create-property"), o = Array, a = Math.max;
                t.exports = function(e, t, r) {
                    for(var l = i(e), c = n(t, l), u = n(void 0 === r ? l : r, l), h = o(a(u - c, 0)), f = 0; c < u; c++, f++)s(h, f, e[c]);
                    return h.length = f, h;
                };
            },
            {
                "../internals/create-property": 243,
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340
            }
        ],
        231: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n([].slice);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        232: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-array"), i = e("../internals/is-constructor"), s = e("../internals/is-object"), o = e("../internals/well-known-symbol")("species"), a = Array;
                t.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === a || n(t.prototype)) || s(t) && null === (t = t[o])) && (t = void 0)), void 0 === t ? a : t;
                };
            },
            {
                "../internals/is-array": 284,
                "../internals/is-constructor": 286,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        233: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/array-species-constructor");
                t.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            {
                "../internals/array-species-constructor": 232
            }
        ],
        234: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("iterator"), i = !1;
                try {
                    var s = 0, o = {
                        next: function() {
                            return {
                                done: !!s++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    o[n] = function() {
                        return this;
                    }, Array.from(o, function() {
                        throw 2;
                    });
                } catch (e) {}
                t.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var s = {};
                        s[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(s);
                    } catch (e) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        235: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = n({}.toString), s = n("".slice);
                t.exports = function(e) {
                    return s(i(e), 8, -1);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        236: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-string-tag-support"), i = e("../internals/is-callable"), s = e("../internals/classof-raw"), o = e("../internals/well-known-symbol")("toStringTag"), a = Object, l = "Arguments" === s(function() {
                    return arguments;
                }());
                t.exports = n ? s : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = a(e), o)) ? r : l ? s(t) : "Object" === (n = s(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-callable": 285,
                "../internals/to-string-tag-support": 347,
                "../internals/well-known-symbol": 357
            }
        ],
        237: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/own-keys"), s = e("../internals/object-get-own-property-descriptor"), o = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    for(var a = i(t), l = o.f, c = s.f, u = 0; u < a.length; u++){
                        var h = a[u];
                        n(e, h) || r && n(r, h) || l(e, h, c(t, h));
                    }
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/own-keys": 321
            }
        ],
        238: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        239: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        240: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            {}
        ],
        241: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = n ? function(e, t, r) {
                    return i.f(e, t, s(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308
            }
        ],
        242: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            {}
        ],
        243: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-property-key"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = function(e, t, r) {
                    var o = n(t);
                    o in e ? i.f(e, o, s(0, r)) : e[o] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/object-define-property": 308,
                "../internals/to-property-key": 346
            }
        ],
        244: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/make-built-in"), i = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            {
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        245: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/object-define-property"), s = e("../internals/make-built-in"), o = e("../internals/define-global-property");
                t.exports = function(e, t, r, a) {
                    a || (a = {});
                    var l = a.enumerable, c = void 0 !== a.name ? a.name : t;
                    if (n(r) && s(r, c, a), a.global) l ? e[t] = r : o(t, r);
                    else {
                        try {
                            a.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !a.nonConfigurable,
                            writable: !a.nonWritable
                        });
                    }
                    return e;
                };
            },
            {
                "../internals/define-global-property": 246,
                "../internals/is-callable": 285,
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        246: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = Object.defineProperty;
                t.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            {
                "../internals/global": 274
            }
        ],
        247: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        248: [
            function(e, t, r) {
                "use strict";
                var n = "object" == typeof document && document.all, i = void 0 === n && void 0 !== n;
                t.exports = {
                    all: n,
                    IS_HTMLDDA: i
                };
            },
            {}
        ],
        249: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-object"), s = n.document, o = i(s) && i(s.createElement);
                t.exports = function(e) {
                    return o ? s.createElement(e) : {};
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-object": 289
            }
        ],
        250: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-is-deno"), i = e("../internals/engine-is-node");
                t.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            {
                "../internals/engine-is-deno": 251,
                "../internals/engine-is-node": 254
            }
        ],
        251: [
            function(e, t, r) {
                "use strict";
                t.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            {}
        ],
        252: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        253: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        254: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/classof-raw");
                t.exports = "process" === i(n.process);
            },
            {
                "../internals/classof-raw": 235,
                "../internals/global": 274
            }
        ],
        255: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /web0s(?!.*chrome)/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        256: [
            function(e, t, r) {
                "use strict";
                t.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            {}
        ],
        257: [
            function(e, t, r) {
                "use strict";
                var n, i, s = e("../internals/global"), o = e("../internals/engine-user-agent"), a = s.process, l = s.Deno, c = a && a.versions || l && l.version, u = c && c.v8;
                u && (i = (n = u.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && o && (!(n = o.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = o.match(/Chrome\/(\d+)/)) && (i = +n[1]), t.exports = i;
            },
            {
                "../internals/engine-user-agent": 256,
                "../internals/global": 274
            }
        ],
        258: [
            function(e, t, r) {
                "use strict";
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        259: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/object-get-own-property-descriptor").f, s = e("../internals/create-non-enumerable-property"), o = e("../internals/define-built-in"), a = e("../internals/define-global-property"), l = e("../internals/copy-constructor-properties"), c = e("../internals/is-forced");
                t.exports = function(e, t) {
                    var r, u, h, f, d, p = e.target, m = e.global, b = e.stat;
                    if (r = m ? n : b ? n[p] || a(p, {}) : (n[p] || {}).prototype) for(u in t){
                        if (f = t[u], h = e.dontCallGetSet ? (d = i(r, u)) && d.value : r[u], !c(m ? u : p + (b ? "." : "#") + u, e.forced) && void 0 !== h) {
                            if (typeof f == typeof h) continue;
                            l(f, h);
                        }
                        (e.sham || h && h.sham) && s(f, "sham", !0), o(r, u, f, e);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 237,
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/define-global-property": 246,
                "../internals/global": 274,
                "../internals/is-forced": 287,
                "../internals/object-get-own-property-descriptor": 309
            }
        ],
        260: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            {}
        ],
        261: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.apply, o = i.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (n ? o.bind(s) : function() {
                    return o.apply(s, arguments);
                });
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        262: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-clause"), i = e("../internals/a-callable"), s = e("../internals/function-bind-native"), o = n(n.bind);
                t.exports = function(e, t) {
                    return i(e), void 0 === t ? e : s ? o(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-bind-native": 263,
                "../internals/function-uncurry-this-clause": 267
            }
        ],
        263: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        264: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype.call;
                t.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        265: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/has-own-property"), s = Function.prototype, o = n && Object.getOwnPropertyDescriptor, a = i(s, "name"), l = a && "something" === (function() {}).name, c = a && (!n || n && o(s, "name").configurable);
                t.exports = {
                    EXISTS: a,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/has-own-property": 275
            }
        ],
        266: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/a-callable");
                t.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-uncurry-this": 268
            }
        ],
        267: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/function-uncurry-this");
                t.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268
            }
        ],
        268: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.call, o = n && i.bind.bind(s, s);
                t.exports = n ? o : function(e) {
                    return function() {
                        return s.apply(e, arguments);
                    };
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        269: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = function(e) {
                    return i(e) ? e : void 0;
                };
                t.exports = function(e, t) {
                    return arguments.length < 2 ? s(n[e]) : n[e] && n[e][t];
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        270: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = e("../internals/get-method"), s = e("../internals/is-null-or-undefined"), o = e("../internals/iterators"), a = e("../internals/well-known-symbol")("iterator");
                t.exports = function(e) {
                    if (!s(e)) return i(e, a) || i(e, "@@iterator") || o[n(e)];
                };
            },
            {
                "../internals/classof": 236,
                "../internals/get-method": 273,
                "../internals/is-null-or-undefined": 288,
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        271: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/a-callable"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/get-iterator-method"), l = TypeError;
                t.exports = function(e, t) {
                    var r = arguments.length < 2 ? a(e) : t;
                    if (i(r)) return s(n(r, e));
                    throw new l(o(e) + " is not iterable");
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-iterator-method": 270,
                "../internals/try-to-string": 349
            }
        ],
        272: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-array"), s = e("../internals/is-callable"), o = e("../internals/classof-raw"), a = e("../internals/to-string"), l = n([].push);
                t.exports = function(e) {
                    if (s(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var c = e[n];
                            "string" == typeof c ? l(r, c) : "number" != typeof c && "Number" !== o(c) && "String" !== o(c) || l(r, a(c));
                        }
                        var u = r.length, h = !0;
                        return function(e, t) {
                            if (h) return h = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < u; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268,
                "../internals/is-array": 284,
                "../internals/is-callable": 285,
                "../internals/to-string": 348
            }
        ],
        273: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = e("../internals/is-null-or-undefined");
                t.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/is-null-or-undefined": 288
            }
        ],
        274: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = function(e) {
                            return e && e.Math === Math && e;
                        };
                        t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function() {
                            return this;
                        }() || this || Function("return this")();
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        275: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/to-object"), s = n({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(e, t) {
                    return s(i(e), t);
                };
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/to-object": 344
            }
        ],
        276: [
            function(e, t, r) {
                "use strict";
                t.exports = {};
            },
            {}
        ],
        277: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            {}
        ],
        278: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in");
                t.exports = n("document", "documentElement");
            },
            {
                "../internals/get-built-in": 269
            }
        ],
        279: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/document-create-element");
                t.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/document-create-element": 249,
                "../internals/fails": 260
            }
        ],
        280: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/classof-raw"), o = Object, a = n("".split);
                t.exports = i(function() {
                    return !o("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === s(e) ? a(e, "") : o(e);
                } : o;
            },
            {
                "../internals/classof-raw": 235,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268
            }
        ],
        281: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-callable"), s = e("../internals/shared-store"), o = n(Function.toString);
                i(s.inspectSource) || (s.inspectSource = function(e) {
                    return o(e);
                }), t.exports = s.inspectSource;
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/is-callable": 285,
                "../internals/shared-store": 333
            }
        ],
        282: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/weak-map-basic-detection"), a = e("../internals/global"), l = e("../internals/is-object"), c = e("../internals/create-non-enumerable-property"), u = e("../internals/has-own-property"), h = e("../internals/shared-store"), f = e("../internals/shared-key"), d = e("../internals/hidden-keys"), p = a.TypeError, m = a.WeakMap;
                if (o || h.state) {
                    var b = h.state || (h.state = new m);
                    b.get = b.get, b.has = b.has, b.set = b.set, n = function(e, t) {
                        if (b.has(e)) throw new p("Object already initialized");
                        return t.facade = e, b.set(e, t), t;
                    }, i = function(e) {
                        return b.get(e) || {};
                    }, s = function(e) {
                        return b.has(e);
                    };
                } else {
                    var g = f("state");
                    d[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw new p("Object already initialized");
                        return t.facade = e, c(e, g, t), t;
                    }, i = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, s = function(e) {
                        return u(e, g);
                    };
                }
                t.exports = {
                    set: n,
                    get: i,
                    has: s,
                    enforce: function(e) {
                        return s(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!l(t) || (r = i(t)).type !== e) throw new p("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/is-object": 289,
                "../internals/shared-key": 332,
                "../internals/shared-store": 333,
                "../internals/weak-map-basic-detection": 354
            }
        ],
        283: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/iterators"), s = n("iterator"), o = Array.prototype;
                t.exports = function(e) {
                    return void 0 !== e && (i.Array === e || o[s] === e);
                };
            },
            {
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        284: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw");
                t.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            {
                "../internals/classof-raw": 235
            }
        ],
        285: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/document-all"), i = n.all;
                t.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === i;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            {
                "../internals/document-all": 248
            }
        ],
        286: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/classof"), a = e("../internals/get-built-in"), l = e("../internals/inspect-source"), c = function() {}, u = [], h = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = n(f.exec), p = !f.test(c), m = function(e) {
                    if (!s(e)) return !1;
                    try {
                        return h(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, b = function(e) {
                    if (!s(e)) return !1;
                    switch(o(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                b.sham = !0, t.exports = !h || i(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? b : m;
            },
            {
                "../internals/classof": 236,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285
            }
        ],
        287: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails"), i = e("../internals/is-callable"), s = /#|\.prototype\./, o = function(e, t) {
                    var r = l[a(e)];
                    return r === u || r !== c && (i(t) ? n(t) : !!t);
                }, a = o.normalize = function(e) {
                    return String(e).replace(s, ".").toLowerCase();
                }, l = o.data = {}, c = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 260,
                "../internals/is-callable": 285
            }
        ],
        288: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        289: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/document-all"), s = i.all;
                t.exports = i.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === s;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            {
                "../internals/document-all": 248,
                "../internals/is-callable": 285
            }
        ],
        290: [
            function(e, t, r) {
                "use strict";
                t.exports = !1;
            },
            {}
        ],
        291: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = e("../internals/classof-raw"), s = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" === i(e));
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        292: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/is-callable"), s = e("../internals/object-is-prototype-of"), o = e("../internals/use-symbol-as-uid"), a = Object;
                t.exports = o ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && s(t.prototype, a(e));
                };
            },
            {
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/object-is-prototype-of": 314,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        293: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-call"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/is-array-iterator-method"), l = e("../internals/length-of-array-like"), c = e("../internals/object-is-prototype-of"), u = e("../internals/get-iterator"), h = e("../internals/get-iterator-method"), f = e("../internals/iterator-close"), d = TypeError, p = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = p.prototype;
                t.exports = function(e, t, r) {
                    var b, g, y, v, w, _, x, k = r && r.that, S = !(!r || !r.AS_ENTRIES), M = !(!r || !r.IS_RECORD), C = !(!r || !r.IS_ITERATOR), T = !(!r || !r.INTERRUPTED), E = n(t, k), A = function(e) {
                        return b && f(b, "normal", e), new p(!0, e);
                    }, R = function(e) {
                        return S ? (s(e), T ? E(e[0], e[1], A) : E(e[0], e[1])) : T ? E(e, A) : E(e);
                    };
                    if (M) b = e.iterator;
                    else if (C) b = e;
                    else {
                        if (!(g = h(e))) throw new d(o(e) + " is not iterable");
                        if (a(g)) {
                            for(y = 0, v = l(e); v > y; y++)if ((w = R(e[y])) && c(m, w)) return w;
                            return new p(!1);
                        }
                        b = u(e, g);
                    }
                    for(_ = M ? e.next : b.next; !(x = i(_, b)).done;){
                        try {
                            w = R(x.value);
                        } catch (e) {
                            f(b, "throw", e);
                        }
                        if ("object" == typeof w && w && c(m, w)) return w;
                    }
                    return new p(!1);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-bind-context": 262,
                "../internals/function-call": 264,
                "../internals/get-iterator": 271,
                "../internals/get-iterator-method": 270,
                "../internals/is-array-iterator-method": 283,
                "../internals/iterator-close": 294,
                "../internals/length-of-array-like": 299,
                "../internals/object-is-prototype-of": 314,
                "../internals/try-to-string": 349
            }
        ],
        294: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/an-object"), s = e("../internals/get-method");
                t.exports = function(e, t, r) {
                    var o, a;
                    i(e);
                    try {
                        if (!(o = s(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        o = n(o, e);
                    } catch (e) {
                        a = !0, o = e;
                    }
                    if ("throw" === t) throw r;
                    if (a) throw o;
                    return i(o), r;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-method": 273
            }
        ],
        295: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/iterators-core").IteratorPrototype, i = e("../internals/object-create"), s = e("../internals/create-property-descriptor"), o = e("../internals/set-to-string-tag"), a = e("../internals/iterators"), l = function() {
                    return this;
                };
                t.exports = function(e, t, r, c) {
                    var u = t + " Iterator";
                    return e.prototype = i(n, {
                        next: s(+!c, r)
                    }), o(e, u, !1, !0), a[u] = l, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-create": 306,
                "../internals/set-to-string-tag": 331
            }
        ],
        296: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/is-pure"), o = e("../internals/function-name"), a = e("../internals/is-callable"), l = e("../internals/iterator-create-constructor"), c = e("../internals/object-get-prototype-of"), u = e("../internals/object-set-prototype-of"), h = e("../internals/set-to-string-tag"), f = e("../internals/create-non-enumerable-property"), d = e("../internals/define-built-in"), p = e("../internals/well-known-symbol"), m = e("../internals/iterators"), b = e("../internals/iterators-core"), g = o.PROPER, y = o.CONFIGURABLE, v = b.IteratorPrototype, w = b.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), x = function() {
                    return this;
                };
                t.exports = function(e, t, r, o, p, b, k) {
                    l(r, t, o);
                    var S, M, C, T = function(e) {
                        if (e === p && j) return j;
                        if (!w && e && e in R) return R[e];
                        switch(e){
                            case "keys":
                            case "values":
                            case "entries":
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, E = t + " Iterator", A = !1, R = e.prototype, O = R[_] || R["@@iterator"] || p && R[p], j = !w && O || T(p), I = "Array" === t && R.entries || O;
                    if (I && (S = c(I.call(new e))) !== Object.prototype && S.next && (s || c(S) === v || (u ? u(S, v) : a(S[_]) || d(S, _, x)), h(S, E, !0, !0), s && (m[E] = x)), g && "values" === p && O && "values" !== O.name && (!s && y ? f(R, "name", "values") : (A = !0, j = function() {
                        return i(O, this);
                    })), p) {
                        if (M = {
                            values: T("values"),
                            keys: b ? j : T("keys"),
                            entries: T("entries")
                        }, k) for(C in M)(w || A || !(C in R)) && d(R, C, M[C]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: w || A
                        }, M);
                    }
                    return s && !k || R[_] === j || d(R, _, j, {
                        name: p
                    }), m[t] = j, M;
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/function-name": 265,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/iterator-create-constructor": 295,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-set-prototype-of": 318,
                "../internals/set-to-string-tag": 331,
                "../internals/well-known-symbol": 357
            }
        ],
        297: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/fails"), a = e("../internals/is-callable"), l = e("../internals/is-object"), c = e("../internals/object-create"), u = e("../internals/object-get-prototype-of"), h = e("../internals/define-built-in"), f = e("../internals/well-known-symbol"), d = e("../internals/is-pure"), p = f("iterator"), m = !1;
                [].keys && ("next" in (s = [].keys()) ? (i = u(u(s))) !== Object.prototype && (n = i) : m = !0), !l(n) || o(function() {
                    var e = {};
                    return n[p].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), a(n[p]) || h(n, p, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/fails": 260,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-get-prototype-of": 313,
                "../internals/well-known-symbol": 357
            }
        ],
        298: [
            function(e, t, r) {
                arguments[4][276][0].apply(r, arguments);
            },
            {
                dup: 276
            }
        ],
        299: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-length");
                t.exports = function(e) {
                    return n(e.length);
                };
            },
            {
                "../internals/to-length": 343
            }
        ],
        300: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/has-own-property"), a = e("../internals/descriptors"), l = e("../internals/function-name").CONFIGURABLE, c = e("../internals/inspect-source"), u = e("../internals/internal-state"), h = u.enforce, f = u.get, d = String, p = Object.defineProperty, m = n("".slice), b = n("".replace), g = n([].join), y = a && !i(function() {
                    return 8 !== p(function() {}, "length", {
                        value: 8
                    }).length;
                }), v = String(String).split("String"), w = t.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + b(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!o(e, "name") || l && e.name !== t) && (a ? p(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && r && o(r, "arity") && e.length !== r.arity && p(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && o(r, "constructor") && r.constructor ? a && p(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = h(e);
                    return o(n, "source") || (n.source = g(v, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = w(function() {
                    return s(this) && f(this).source || c(this);
                }, "toString");
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-name": 265,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/inspect-source": 281,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285
            }
        ],
        301: [
            function(e, t, r) {
                "use strict";
                var n = Math.ceil, i = Math.floor;
                t.exports = Math.trunc || function(e) {
                    var t = +e;
                    return (t > 0 ? i : n)(t);
                };
            },
            {}
        ],
        302: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a, l = e("../internals/global"), c = e("../internals/function-bind-context"), u = e("../internals/object-get-own-property-descriptor").f, h = e("../internals/task").set, f = e("../internals/queue"), d = e("../internals/engine-is-ios"), p = e("../internals/engine-is-ios-pebble"), m = e("../internals/engine-is-webos-webkit"), b = e("../internals/engine-is-node"), g = l.MutationObserver || l.WebKitMutationObserver, y = l.document, v = l.process, w = l.Promise, _ = u(l, "queueMicrotask"), x = _ && _.value;
                if (!x) {
                    var k = new f, S = function() {
                        var e, t;
                        for(b && (e = v.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || b || m || !g || !y ? !p && w && w.resolve ? ((o = w.resolve(void 0)).constructor = w, a = c(o.then, o), n = function() {
                        a(S);
                    }) : b ? n = function() {
                        v.nextTick(S);
                    } : (h = c(h, l), n = function() {
                        h(S);
                    }) : (i = !0, s = y.createTextNode(""), new g(S).observe(s, {
                        characterData: !0
                    }), n = function() {
                        s.data = i = !i;
                    }), x = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                t.exports = x;
            },
            {
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-ios-pebble": 252,
                "../internals/engine-is-node": 254,
                "../internals/engine-is-webos-webkit": 255,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/queue": 328,
                "../internals/task": 339
            }
        ],
        303: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = TypeError, s = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                t.exports.f = function(e) {
                    return new s(e);
                };
            },
            {
                "../internals/a-callable": 222
            }
        ],
        304: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-regexp"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            {
                "../internals/is-regexp": 291
            }
        ],
        305: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-uncurry-this"), s = e("../internals/function-call"), o = e("../internals/fails"), a = e("../internals/object-keys"), l = e("../internals/object-get-own-property-symbols"), c = e("../internals/object-property-is-enumerable"), u = e("../internals/to-object"), h = e("../internals/indexed-object"), f = Object.assign, d = Object.defineProperty, p = i([].concat);
                t.exports = !f || o(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection");
                    return e[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || "abcdefghijklmnopqrst" !== a(f({}, t)).join("");
                }) ? function(e, t) {
                    for(var r = u(e), i = arguments.length, o = 1, f = l.f, d = c.f; i > o;)for(var m, b = h(arguments[o++]), g = f ? p(a(b), f(b)) : a(b), y = g.length, v = 0; y > v;)m = g[v++], n && !s(d, b, m) || (r[m] = b[m]);
                    return r;
                } : f;
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-object": 344
            }
        ],
        306: [
            function(e, t, r) {
                "use strict";
                var n, i = e("../internals/an-object"), s = e("../internals/object-define-properties"), o = e("../internals/enum-bug-keys"), a = e("../internals/hidden-keys"), l = e("../internals/html"), c = e("../internals/document-create-element"), u = e("../internals/shared-key"), h = u("IE_PROTO"), f = function() {}, d = function(e) {
                    return "<script>" + e + "<\/script>";
                }, p = function(e) {
                    e.write(d("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, m = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    m = "undefined" != typeof document ? document.domain && n ? p(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(d("document.F=Object")), e.close(), e.F) : p(n);
                    for(var r = o.length; r--;)delete m.prototype[o[r]];
                    return m();
                };
                a[h] = !0, t.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (f.prototype = i(e), r = new f, f.prototype = null, r[h] = e) : r = m(), void 0 === t ? r : s.f(r, t);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/document-create-element": 249,
                "../internals/enum-bug-keys": 258,
                "../internals/hidden-keys": 276,
                "../internals/html": 278,
                "../internals/object-define-properties": 307,
                "../internals/shared-key": 332
            }
        ],
        307: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/v8-prototype-define-bug"), s = e("../internals/object-define-property"), o = e("../internals/an-object"), a = e("../internals/to-indexed-object"), l = e("../internals/object-keys");
                r.f = n && !i ? Object.defineProperties : function(e, t) {
                    o(e);
                    for(var r, n = a(t), i = l(t), c = i.length, u = 0; c > u;)s.f(e, r = i[u++], n[r]);
                    return e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308,
                "../internals/object-keys": 316,
                "../internals/to-indexed-object": 341,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        308: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/ie8-dom-define"), s = e("../internals/v8-prototype-define-bug"), o = e("../internals/an-object"), a = e("../internals/to-property-key"), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                r.f = n ? s ? function(e, t, r) {
                    if (o(e), t = a(t), o(r), "function" == typeof e && "prototype" === t && "value" in r && "writable" in r && !r.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = r.value, r = {
                            configurable: "configurable" in r ? r.configurable : n.configurable,
                            enumerable: "enumerable" in r ? r.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (o(e), t = a(t), o(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new l("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/ie8-dom-define": 279,
                "../internals/to-property-key": 346,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        309: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-call"), s = e("../internals/object-property-is-enumerable"), o = e("../internals/create-property-descriptor"), a = e("../internals/to-indexed-object"), l = e("../internals/to-property-key"), c = e("../internals/has-own-property"), u = e("../internals/ie8-dom-define"), h = Object.getOwnPropertyDescriptor;
                r.f = n ? h : function(e, t) {
                    if (e = a(e), t = l(t), u) try {
                        return h(e, t);
                    } catch (e) {}
                    if (c(e, t)) return o(!i(s.f, e, t), e[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/function-call": 264,
                "../internals/has-own-property": 275,
                "../internals/ie8-dom-define": 279,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346
            }
        ],
        310: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/to-indexed-object"), s = e("../internals/object-get-own-property-names").f, o = e("../internals/array-slice-simple"), a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e) {
                    return a && "Window" === n(e) ? function(e) {
                        try {
                            return s(e);
                        } catch (e) {
                            return o(a);
                        }
                    }(e) : s(i(e));
                };
            },
            {
                "../internals/array-slice-simple": 230,
                "../internals/classof-raw": 235,
                "../internals/object-get-own-property-names": 311,
                "../internals/to-indexed-object": 341
            }
        ],
        311: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        312: [
            function(e, t, r) {
                "use strict";
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        313: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/is-callable"), s = e("../internals/to-object"), o = e("../internals/shared-key"), a = e("../internals/correct-prototype-getter"), l = o("IE_PROTO"), c = Object, u = c.prototype;
                t.exports = a ? c.getPrototypeOf : function(e) {
                    var t = s(e);
                    if (n(t, l)) return t[l];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? u : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 239,
                "../internals/has-own-property": 275,
                "../internals/is-callable": 285,
                "../internals/shared-key": 332,
                "../internals/to-object": 344
            }
        ],
        314: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n({}.isPrototypeOf);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        315: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/has-own-property"), s = e("../internals/to-indexed-object"), o = e("../internals/array-includes").indexOf, a = e("../internals/hidden-keys"), l = n([].push);
                t.exports = function(e, t) {
                    var r, n = s(e), c = 0, u = [];
                    for(r in n)!i(a, r) && i(n, r) && l(u, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~o(u, r) || l(u, r));
                    return u;
                };
            },
            {
                "../internals/array-includes": 228,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/to-indexed-object": 341
            }
        ],
        316: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        317: [
            function(e, t, r) {
                "use strict";
                var n = {}.propertyIsEnumerable, i = Object.getOwnPropertyDescriptor, s = i && !n.call({
                    1: 2
                }, 1);
                r.f = s ? function(e) {
                    var t = i(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            {}
        ],
        318: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-accessor"), i = e("../internals/an-object"), s = e("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), s(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 224,
                "../internals/an-object": 227,
                "../internals/function-uncurry-this-accessor": 266
            }
        ],
        319: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/function-uncurry-this"), o = e("../internals/object-get-prototype-of"), a = e("../internals/object-keys"), l = e("../internals/to-indexed-object"), c = s(e("../internals/object-property-is-enumerable").f), u = s([].push), h = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !c(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = l(t), s = a(i), f = h && null === o(i), d = s.length, p = 0, m = []; d > p;)r = s[p++], n && !(f ? r in i : c(i, r)) || u(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                t.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341
            }
        ],
        320: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-callable"), s = e("../internals/is-object"), o = TypeError;
                t.exports = function(e, t) {
                    var r, a;
                    if ("string" === t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    if (i(r = e.valueOf) && !s(a = n(r, e))) return a;
                    if ("string" !== t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    throw new o("Can't convert object to primitive value");
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/is-callable": 285,
                "../internals/is-object": 289
            }
        ],
        321: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/function-uncurry-this"), s = e("../internals/object-get-own-property-names"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/an-object"), l = i([].concat);
                t.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = s.f(a(e)), r = o.f;
                    return r ? l(t, r(e)) : t;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-symbols": 312
            }
        ],
        322: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n;
            },
            {
                "../internals/global": 274
            }
        ],
        323: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            {}
        ],
        324: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/promise-native-constructor"), s = e("../internals/is-callable"), o = e("../internals/is-forced"), a = e("../internals/inspect-source"), l = e("../internals/well-known-symbol"), c = e("../internals/engine-is-browser"), u = e("../internals/engine-is-deno"), h = e("../internals/is-pure"), f = e("../internals/engine-v8-version"), d = i && i.prototype, p = l("species"), m = !1, b = s(n.PromiseRejectionEvent), g = o("Promise", function() {
                    var e = a(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (h && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[p] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || u) && !b;
                });
                t.exports = {
                    CONSTRUCTOR: g,
                    REJECTION_EVENT: b,
                    SUBCLASSING: m
                };
            },
            {
                "../internals/engine-is-browser": 250,
                "../internals/engine-is-deno": 251,
                "../internals/engine-v8-version": 257,
                "../internals/global": 274,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285,
                "../internals/is-forced": 287,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/well-known-symbol": 357
            }
        ],
        325: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n.Promise;
            },
            {
                "../internals/global": 274
            }
        ],
        326: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/is-object"), s = e("../internals/new-promise-capability");
                t.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = s.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/is-object": 289,
                "../internals/new-promise-capability": 303
            }
        ],
        327: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/promise-native-constructor"), i = e("../internals/check-correctness-of-iteration"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR;
                t.exports = s || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            {
                "../internals/check-correctness-of-iteration": 234,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        328: [
            function(e, t, r) {
                "use strict";
                var n = function() {
                    this.head = null, this.tail = null;
                };
                n.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, t.exports = n;
            },
            {}
        ],
        329: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-null-or-undefined"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            {
                "../internals/is-null-or-undefined": 288
            }
        ],
        330: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/define-built-in-accessor"), s = e("../internals/well-known-symbol"), o = e("../internals/descriptors"), a = s("species");
                t.exports = function(e) {
                    var t = n(e);
                    o && t && !t[a] && i(t, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        331: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-define-property").f, i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, s) && n(e, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        332: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/shared"), i = e("../internals/uid"), s = n("keys");
                t.exports = function(e) {
                    return s[e] || (s[e] = i(e));
                };
            },
            {
                "../internals/shared": 334,
                "../internals/uid": 350
            }
        ],
        333: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/define-global-property"), s = n["__core-js_shared__"] || i("__core-js_shared__", {});
                t.exports = s;
            },
            {
                "../internals/define-global-property": 246,
                "../internals/global": 274
            }
        ],
        334: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-pure"), i = e("../internals/shared-store");
                (t.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.33.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            {
                "../internals/is-pure": 290,
                "../internals/shared-store": 333
            }
        ],
        335: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/a-constructor"), s = e("../internals/is-null-or-undefined"), o = e("../internals/well-known-symbol")("species");
                t.exports = function(e, t) {
                    var r, a = n(e).constructor;
                    return void 0 === a || s(r = n(a)[o]) ? t : i(r);
                };
            },
            {
                "../internals/a-constructor": 223,
                "../internals/an-object": 227,
                "../internals/is-null-or-undefined": 288,
                "../internals/well-known-symbol": 357
            }
        ],
        336: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-v8-version"), i = e("../internals/fails"), s = e("../internals/global").String;
                t.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !s(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            {
                "../internals/engine-v8-version": 257,
                "../internals/fails": 260,
                "../internals/global": 274
            }
        ],
        337: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/get-built-in"), s = e("../internals/well-known-symbol"), o = e("../internals/define-built-in");
                t.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = s("toPrimitive");
                    t && !t[a] && o(t, a, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/function-call": 264,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        338: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        339: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a = e("../internals/global"), l = e("../internals/function-apply"), c = e("../internals/function-bind-context"), u = e("../internals/is-callable"), h = e("../internals/has-own-property"), f = e("../internals/fails"), d = e("../internals/html"), p = e("../internals/array-slice"), m = e("../internals/document-create-element"), b = e("../internals/validate-arguments-length"), g = e("../internals/engine-is-ios"), y = e("../internals/engine-is-node"), v = a.setImmediate, w = a.clearImmediate, _ = a.process, x = a.Dispatch, k = a.Function, S = a.MessageChannel, M = a.String, C = 0, T = {};
                f(function() {
                    n = a.location;
                });
                var E = function(e) {
                    if (h(T, e)) {
                        var t = T[e];
                        delete T[e], t();
                    }
                }, A = function(e) {
                    return function() {
                        E(e);
                    };
                }, R = function(e) {
                    E(e.data);
                }, O = function(e) {
                    a.postMessage(M(e), n.protocol + "//" + n.host);
                };
                v && w || (v = function(e) {
                    b(arguments.length, 1);
                    var t = u(e) ? e : k(e), r = p(arguments, 1);
                    return T[++C] = function() {
                        l(t, void 0, r);
                    }, i(C), C;
                }, w = function(e) {
                    delete T[e];
                }, y ? i = function(e) {
                    _.nextTick(A(e));
                } : x && x.now ? i = function(e) {
                    x.now(A(e));
                } : S && !g ? (o = (s = new S).port2, s.port1.onmessage = R, i = c(o.postMessage, o)) : a.addEventListener && u(a.postMessage) && !a.importScripts && n && "file:" !== n.protocol && !f(O) ? (i = O, a.addEventListener("message", R, !1)) : i = "onreadystatechange" in m("script") ? function(e) {
                    d.appendChild(m("script")).onreadystatechange = function() {
                        d.removeChild(this), E(e);
                    };
                } : function(e) {
                    setTimeout(A(e), 0);
                }), t.exports = {
                    set: v,
                    clear: w
                };
            },
            {
                "../internals/array-slice": 231,
                "../internals/document-create-element": 249,
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-node": 254,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/html": 278,
                "../internals/is-callable": 285,
                "../internals/validate-arguments-length": 353
            }
        ],
        340: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.max, s = Math.min;
                t.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : s(r, t);
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        341: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/indexed-object"), i = e("../internals/require-object-coercible");
                t.exports = function(e) {
                    return n(i(e));
                };
            },
            {
                "../internals/indexed-object": 280,
                "../internals/require-object-coercible": 329
            }
        ],
        342: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/math-trunc");
                t.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            {
                "../internals/math-trunc": 301
            }
        ],
        343: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.min;
                t.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        344: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/require-object-coercible"), i = Object;
                t.exports = function(e) {
                    return i(n(e));
                };
            },
            {
                "../internals/require-object-coercible": 329
            }
        ],
        345: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-object"), s = e("../internals/is-symbol"), o = e("../internals/get-method"), a = e("../internals/ordinary-to-primitive"), l = e("../internals/well-known-symbol"), c = TypeError, u = l("toPrimitive");
                t.exports = function(e, t) {
                    if (!i(e) || s(e)) return e;
                    var r, l = o(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), r = n(l, e, t), !i(r) || s(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), a(e, t);
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/get-method": 273,
                "../internals/is-object": 289,
                "../internals/is-symbol": 292,
                "../internals/ordinary-to-primitive": 320,
                "../internals/well-known-symbol": 357
            }
        ],
        346: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-primitive"), i = e("../internals/is-symbol");
                t.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            {
                "../internals/is-symbol": 292,
                "../internals/to-primitive": 345
            }
        ],
        347: [
            function(e, t, r) {
                "use strict";
                var n = {};
                n[e("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(n);
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        348: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = String;
                t.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            {
                "../internals/classof": 236
            }
        ],
        349: [
            function(e, t, r) {
                "use strict";
                var n = String;
                t.exports = function(e) {
                    try {
                        return n(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            {}
        ],
        350: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = 0, s = Math.random(), o = n(1..toString);
                t.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + o(++i + s, 36);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        351: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        352: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails");
                t.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260
            }
        ],
        353: [
            function(e, t, r) {
                "use strict";
                var n = TypeError;
                t.exports = function(e, t) {
                    if (e < t) throw new n("Not enough arguments");
                    return e;
                };
            },
            {}
        ],
        354: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = n.WeakMap;
                t.exports = i(s) && /native code/.test(String(s));
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        355: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/path"), i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol-wrapped"), o = e("../internals/object-define-property").f;
                t.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || o(t, e, {
                        value: s.f(e)
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/path": 322,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        356: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol");
                r.f = n;
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        357: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/shared"), s = e("../internals/has-own-property"), o = e("../internals/uid"), a = e("../internals/symbol-constructor-detection"), l = e("../internals/use-symbol-as-uid"), c = n.Symbol, u = i("wks"), h = l ? c.for || c : c && c.withoutSetter || o;
                t.exports = function(e) {
                    return s(u, e) || (u[e] = a && s(c, e) ? c[e] : h("Symbol." + e)), u[e];
                };
            },
            {
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-constructor-detection": 336,
                "../internals/uid": 350,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        358: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").findIndex, s = e("../internals/add-to-unscopables"), o = !0;
                "findIndex" in [] && Array(1).findIndex(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    findIndex: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("findIndex");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        359: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").find, s = e("../internals/add-to-unscopables"), o = !0;
                "find" in [] && Array(1).find(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("find");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        360: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-includes").includes, s = e("../internals/fails"), o = e("../internals/add-to-unscopables");
                n({
                    target: "Array",
                    proto: !0,
                    forced: s(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o("includes");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-includes": 228,
                "../internals/export": 259,
                "../internals/fails": 260
            }
        ],
        361: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/add-to-unscopables"), s = e("../internals/iterators"), o = e("../internals/internal-state"), a = e("../internals/object-define-property").f, l = e("../internals/iterator-define"), c = e("../internals/create-iter-result-object"), u = e("../internals/is-pure"), h = e("../internals/descriptors"), f = o.set, d = o.getterFor("Array Iterator");
                t.exports = l(Array, "Array", function(e, t) {
                    f(this, {
                        type: "Array Iterator",
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = d(this), t = e.target, r = e.kind, n = e.index++;
                    if (!t || n >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(r){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(t[n], !1);
                    }
                    return c([
                        n,
                        t[n]
                    ], !1);
                }, "values");
                var p = s.Arguments = s.Array;
                if (i("keys"), i("values"), i("entries"), !u && h && "values" !== p.name) try {
                    a(p, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/create-iter-result-object": 240,
                "../internals/descriptors": 247,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/iterator-define": 296,
                "../internals/iterators": 298,
                "../internals/object-define-property": 308,
                "../internals/to-indexed-object": 341
            }
        ],
        362: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/function-apply"), o = e("../internals/function-call"), a = e("../internals/function-uncurry-this"), l = e("../internals/fails"), c = e("../internals/is-callable"), u = e("../internals/is-symbol"), h = e("../internals/array-slice"), f = e("../internals/get-json-replacer-function"), d = e("../internals/symbol-constructor-detection"), p = String, m = i("JSON", "stringify"), b = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), v = a("".replace), w = a(1..toString), _ = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, k = /^[\uDC00-\uDFFF]$/, S = !d || l(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), M = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), C = function(e, t) {
                    var r = h(arguments), n = f(t);
                    if (c(n) || void 0 !== e && !u(e)) return r[1] = function(e, t) {
                        if (c(n) && (t = o(n, this, p(e), t)), !u(t)) return t;
                    }, s(m, null, r);
                }, T = function(e, t, r) {
                    var n = g(r, t - 1), i = g(r, t + 1);
                    return b(x, e) && !b(k, i) || b(k, e) && !b(x, n) ? "\\u" + w(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: S || M
                }, {
                    stringify: function(e, t, r) {
                        var n = h(arguments), i = s(S ? C : m, null, n);
                        return M && "string" == typeof i ? v(i, _, T) : i;
                    }
                });
            },
            {
                "../internals/array-slice": 231,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/get-json-replacer-function": 272,
                "../internals/is-callable": 285,
                "../internals/is-symbol": 292,
                "../internals/symbol-constructor-detection": 336
            }
        ],
        363: [
            function(e, t, r) {
                "use strict";
                e("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isNaN: function(e) {
                        return e != e;
                    }
                });
            },
            {
                "../internals/export": 259
            }
        ],
        364: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-assign");
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-assign": 305
            }
        ],
        365: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/symbol-constructor-detection"), s = e("../internals/fails"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/to-object");
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || s(function() {
                        o.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = o.f;
                        return t ? t(a(e)) : [];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/symbol-constructor-detection": 336,
                "../internals/to-object": 344
            }
        ],
        366: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/to-object"), s = e("../internals/object-keys");
                n({
                    target: "Object",
                    stat: !0,
                    forced: e("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e) {
                        return s(i(e));
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-keys": 316,
                "../internals/to-object": 344
            }
        ],
        367: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-to-array").values;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    values: function(e) {
                        return i(e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-to-array": 319
            }
        ],
        368: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    all: function(e) {
                        var t = this, r = o.f(t), n = r.resolve, c = r.reject, u = a(function() {
                            var r = s(t.resolve), o = [], a = 0, u = 1;
                            l(e, function(e) {
                                var s = a++, l = !1;
                                u++, i(r, t, e).then(function(e) {
                                    l || (l = !0, o[s] = e, --u || n(o));
                                }, c);
                            }), --u || n(o);
                        });
                        return u.error && c(u.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        369: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR, o = e("../internals/promise-native-constructor"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/define-built-in"), u = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: s,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && l(o)) {
                    var h = a("Promise").prototype.catch;
                    u.catch !== h && c(u, "catch", h, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        370: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/export"), a = e("../internals/is-pure"), l = e("../internals/engine-is-node"), c = e("../internals/global"), u = e("../internals/function-call"), h = e("../internals/define-built-in"), f = e("../internals/object-set-prototype-of"), d = e("../internals/set-to-string-tag"), p = e("../internals/set-species"), m = e("../internals/a-callable"), b = e("../internals/is-callable"), g = e("../internals/is-object"), y = e("../internals/an-instance"), v = e("../internals/species-constructor"), w = e("../internals/task").set, _ = e("../internals/microtask"), x = e("../internals/host-report-errors"), k = e("../internals/perform"), S = e("../internals/queue"), M = e("../internals/internal-state"), C = e("../internals/promise-native-constructor"), T = e("../internals/promise-constructor-detection"), E = e("../internals/new-promise-capability"), A = T.CONSTRUCTOR, R = T.REJECTION_EVENT, O = T.SUBCLASSING, j = M.getterFor("Promise"), I = M.set, N = C && C.prototype, P = C, B = N, D = c.TypeError, F = c.document, L = c.process, z = E.f, U = z, $ = !!(F && F.createEvent && c.dispatchEvent), H = function(e) {
                    var t;
                    return !(!g(e) || !b(t = e.then)) && t;
                }, V = function(e, t) {
                    var r, n, i, s = t.value, o = 1 === t.state, a = o ? e.ok : e.fail, l = e.resolve, c = e.reject, h = e.domain;
                    try {
                        a ? (o || (2 === t.rejection && Y(t), t.rejection = 1), !0 === a ? r = s : (h && h.enter(), r = a(s), h && (h.exit(), i = !0)), r === e.promise ? c(new D("Promise-chain cycle")) : (n = H(r)) ? u(n, r, l, c) : l(r)) : c(s);
                    } catch (e) {
                        h && !i && h.exit(), c(e);
                    }
                }, q = function(e, t) {
                    e.notified || (e.notified = !0, _(function() {
                        for(var r, n = e.reactions; r = n.get();)V(r, e);
                        e.notified = !1, t && !e.rejection && X(e);
                    }));
                }, W = function(e, t, r) {
                    var n, i;
                    $ ? ((n = F.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !R && (i = c["on" + e]) ? i(n) : "unhandledrejection" === e && x("Unhandled promise rejection", r);
                }, X = function(e) {
                    u(w, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (K(e) && (t = k(function() {
                            l ? L.emit("unhandledRejection", n, r) : W("unhandledrejection", r, n);
                        }), e.rejection = l || K(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, K = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, Y = function(e) {
                    u(w, c, function() {
                        var t = e.facade;
                        l ? L.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                    });
                }, Z = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, G = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, q(e, !0));
                }, J = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new D("Promise can't be resolved itself");
                            var n = H(t);
                            n ? _(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    u(n, t, Z(J, r, e), Z(G, r, e));
                                } catch (t) {
                                    G(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, q(e, !1));
                        } catch (t) {
                            G({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (A && (B = (P = function(e) {
                    y(this, B), m(e), u(n, this);
                    var t = j(this);
                    try {
                        e(Z(J, t), Z(G, t));
                    } catch (e) {
                        G(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: "Promise",
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new S,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(B, "then", function(e, t) {
                    var r = j(this), n = z(v(this, P));
                    return r.parent = !0, n.ok = !b(e) || e, n.fail = b(t) && t, n.domain = l ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : _(function() {
                        V(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = j(e);
                    this.promise = e, this.resolve = Z(J, t), this.reject = Z(G, t);
                }, E.f = z = function(e) {
                    return e === P || void 0 === e ? new i(e) : U(e);
                }, !a && b(C) && N !== Object.prototype)) {
                    s = N.then, O || h(N, "then", function(e, t) {
                        var r = this;
                        return new P(function(e, t) {
                            u(s, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete N.constructor;
                    } catch (e) {}
                    f && f(N, B);
                }
                o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Promise: P
                }), d(P, "Promise", !1, !0), p("Promise");
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-instance": 226,
                "../internals/define-built-in": 245,
                "../internals/engine-is-node": 254,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/global": 274,
                "../internals/host-report-errors": 277,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/microtask": 302,
                "../internals/new-promise-capability": 303,
                "../internals/object-set-prototype-of": 318,
                "../internals/perform": 323,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/queue": 328,
                "../internals/set-species": 330,
                "../internals/set-to-string-tag": 331,
                "../internals/species-constructor": 335,
                "../internals/task": 339
            }
        ],
        371: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-native-constructor"), o = e("../internals/fails"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/species-constructor"), u = e("../internals/promise-resolve"), h = e("../internals/define-built-in"), f = s && s.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!s && o(function() {
                        f.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, a("Promise")), r = l(e);
                        return this.then(r ? function(r) {
                            return u(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return u(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && l(s)) {
                    var d = a("Promise").prototype.finally;
                    f.finally !== d && h(f, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326,
                "../internals/species-constructor": 335
            }
        ],
        372: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.promise.constructor"), e("../modules/es.promise.all"), e("../modules/es.promise.catch"), e("../modules/es.promise.race"), e("../modules/es.promise.reject"), e("../modules/es.promise.resolve");
            },
            {
                "../modules/es.promise.all": 368,
                "../modules/es.promise.catch": 369,
                "../modules/es.promise.constructor": 370,
                "../modules/es.promise.race": 373,
                "../modules/es.promise.reject": 374,
                "../modules/es.promise.resolve": 375
            }
        ],
        373: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    race: function(e) {
                        var t = this, r = o.f(t), n = r.reject, c = a(function() {
                            var o = s(t.resolve);
                            l(e, function(e) {
                                i(o, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        374: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/new-promise-capability");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-constructor-detection").CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = s.f(this);
                        return i(t.reject, void 0, e), t.promise;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/new-promise-capability": 303,
                "../internals/promise-constructor-detection": 324
            }
        ],
        375: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/is-pure"), o = e("../internals/promise-native-constructor"), a = e("../internals/promise-constructor-detection").CONSTRUCTOR, l = e("../internals/promise-resolve"), c = i("Promise"), u = s && !a;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: s || a
                }, {
                    resolve: function(e) {
                        return l(u && this === c ? o : this, e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326
            }
        ],
        376: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/to-absolute-index"), o = RangeError, a = String.fromCharCode, l = String.fromCodePoint, c = i([].join);
                n({
                    target: "String",
                    stat: !0,
                    arity: 1,
                    forced: !!l && 1 !== l.length
                }, {
                    fromCodePoint: function(e) {
                        for(var t, r = [], n = arguments.length, i = 0; n > i;){
                            if (t = +arguments[i++], s(t, 1114111) !== t) throw new o(t + " is not a valid code point");
                            r[i] = t < 65536 ? a(t) : a(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
                        }
                        return c(r, "");
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/to-absolute-index": 340
            }
        ],
        377: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/not-a-regexp"), o = e("../internals/require-object-coercible"), a = e("../internals/to-string"), l = e("../internals/correct-is-regexp-logic"), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !l("includes")
                }, {
                    includes: function(e) {
                        return !!~c(a(o(this)), a(s(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 238,
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/not-a-regexp": 304,
                "../internals/require-object-coercible": 329,
                "../internals/to-string": 348
            }
        ],
        378: [
            function(e, t, r) {
                "use strict";
                e("../internals/well-known-symbol-define")("asyncIterator");
            },
            {
                "../internals/well-known-symbol-define": 355
            }
        ],
        379: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/global"), s = e("../internals/function-call"), o = e("../internals/function-uncurry-this"), a = e("../internals/is-pure"), l = e("../internals/descriptors"), c = e("../internals/symbol-constructor-detection"), u = e("../internals/fails"), h = e("../internals/has-own-property"), f = e("../internals/object-is-prototype-of"), d = e("../internals/an-object"), p = e("../internals/to-indexed-object"), m = e("../internals/to-property-key"), b = e("../internals/to-string"), g = e("../internals/create-property-descriptor"), y = e("../internals/object-create"), v = e("../internals/object-keys"), w = e("../internals/object-get-own-property-names"), _ = e("../internals/object-get-own-property-names-external"), x = e("../internals/object-get-own-property-symbols"), k = e("../internals/object-get-own-property-descriptor"), S = e("../internals/object-define-property"), M = e("../internals/object-define-properties"), C = e("../internals/object-property-is-enumerable"), T = e("../internals/define-built-in"), E = e("../internals/define-built-in-accessor"), A = e("../internals/shared"), R = e("../internals/shared-key"), O = e("../internals/hidden-keys"), j = e("../internals/uid"), I = e("../internals/well-known-symbol"), N = e("../internals/well-known-symbol-wrapped"), P = e("../internals/well-known-symbol-define"), B = e("../internals/symbol-define-to-primitive"), D = e("../internals/set-to-string-tag"), F = e("../internals/internal-state"), L = e("../internals/array-iteration").forEach, z = R("hidden"), U = F.set, $ = F.getterFor("Symbol"), H = Object.prototype, V = i.Symbol, q = V && V.prototype, W = i.RangeError, X = i.TypeError, K = i.QObject, Y = k.f, Z = S.f, G = _.f, J = C.f, Q = o([].push), ee = A("symbols"), te = A("op-symbols"), re = A("wks"), ne = !K || !K.prototype || !K.prototype.findChild, ie = function(e, t, r) {
                    var n = Y(H, t);
                    n && delete H[t], Z(e, t, r), n && e !== H && Z(H, t, n);
                }, se = l && u(function() {
                    return 7 !== y(Z({}, "a", {
                        get: function() {
                            return Z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ie : Z, oe = function(e, t) {
                    var r = ee[e] = y(q);
                    return U(r, {
                        type: "Symbol",
                        tag: e,
                        description: t
                    }), l || (r.description = t), r;
                }, ae = function(e, t, r) {
                    e === H && ae(te, t, r), d(e);
                    var n = m(t);
                    return d(r), h(ee, n) ? (r.enumerable ? (h(e, z) && e[z][n] && (e[z][n] = !1), r = y(r, {
                        enumerable: g(0, !1)
                    })) : (h(e, z) || Z(e, z, g(1, {})), e[z][n] = !0), se(e, n, r)) : Z(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = p(t), n = v(r).concat(fe(r));
                    return L(n, function(t) {
                        l && !s(ce, r, t) || ae(e, t, r[t]);
                    }), e;
                }, ce = function(e) {
                    var t = m(e), r = s(J, this, t);
                    return !(this === H && h(ee, t) && !h(te, t)) && (!(r || !h(this, t) || !h(ee, t) || h(this, z) && this[z][t]) || r);
                }, ue = function(e, t) {
                    var r = p(e), n = m(t);
                    if (r !== H || !h(ee, n) || h(te, n)) {
                        var i = Y(r, n);
                        return !i || !h(ee, n) || h(r, z) && r[z][n] || (i.enumerable = !0), i;
                    }
                }, he = function(e) {
                    var t = G(p(e)), r = [];
                    return L(t, function(e) {
                        h(ee, e) || h(O, e) || Q(r, e);
                    }), r;
                }, fe = function(e) {
                    var t = e === H, r = G(t ? te : p(e)), n = [];
                    return L(r, function(e) {
                        !h(ee, e) || t && !h(H, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (T(q = (V = function() {
                    if (f(q, this)) throw new X("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? b(arguments[0]) : void 0, t = j(e), r = function(e) {
                        this === H && s(r, te, e), h(this, z) && h(this[z], t) && (this[z][t] = !1);
                        var n = g(1, e);
                        try {
                            se(this, t, n);
                        } catch (e) {
                            if (!(e instanceof W)) throw e;
                            ie(this, t, n);
                        }
                    };
                    return l && ne && se(H, t, {
                        configurable: !0,
                        set: r
                    }), oe(t, e);
                }).prototype, "toString", function() {
                    return $(this).tag;
                }), T(V, "withoutSetter", function(e) {
                    return oe(j(e), e);
                }), C.f = ce, S.f = ae, M.f = le, k.f = ue, w.f = _.f = he, x.f = fe, N.f = function(e) {
                    return oe(I(e), e);
                }, l && (E(q, "description", {
                    configurable: !0,
                    get: function() {
                        return $(this).description;
                    }
                }), a || T(H, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: V
                }), L(v(re), function(e) {
                    P(e);
                }), n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : le(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: le,
                    getOwnPropertyDescriptor: ue
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: he
                }), B(), D(V, "Symbol"), O[z] = !0;
            },
            {
                "../internals/an-object": 227,
                "../internals/array-iteration": 229,
                "../internals/create-property-descriptor": 242,
                "../internals/define-built-in": 245,
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-define-properties": 307,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-names-external": 310,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-is-prototype-of": 314,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/set-to-string-tag": 331,
                "../internals/shared": 334,
                "../internals/shared-key": 332,
                "../internals/symbol-constructor-detection": 336,
                "../internals/symbol-define-to-primitive": 337,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346,
                "../internals/to-string": 348,
                "../internals/uid": 350,
                "../internals/well-known-symbol": 357,
                "../internals/well-known-symbol-define": 355,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        380: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/has-own-property"), o = e("../internals/to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("string-to-symbol-registry"), u = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = o(e);
                        if (s(c, t)) return c[t];
                        var r = i("Symbol")(t);
                        return c[t] = r, u[r] = t, r;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/to-string": 348
            }
        ],
        381: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.symbol.constructor"), e("../modules/es.symbol.for"), e("../modules/es.symbol.key-for"), e("../modules/es.json.stringify"), e("../modules/es.object.get-own-property-symbols");
            },
            {
                "../modules/es.json.stringify": 362,
                "../modules/es.object.get-own-property-symbols": 365,
                "../modules/es.symbol.constructor": 379,
                "../modules/es.symbol.for": 380,
                "../modules/es.symbol.key-for": 382
            }
        ],
        382: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/has-own-property"), s = e("../internals/is-symbol"), o = e("../internals/try-to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!s(e)) throw new TypeError(o(e) + " is not a symbol");
                        if (i(c, e)) return c[e];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/has-own-property": 275,
                "../internals/is-symbol": 292,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/try-to-string": 349
            }
        ],
        383: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return Object.prototype.toString.call(e);
                }
                r.isArray = function(e) {
                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                }, r.isBoolean = function(e) {
                    return "boolean" == typeof e;
                }, r.isNull = function(e) {
                    return null === e;
                }, r.isNullOrUndefined = function(e) {
                    return null == e;
                }, r.isNumber = function(e) {
                    return "number" == typeof e;
                }, r.isString = function(e) {
                    return "string" == typeof e;
                }, r.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, r.isUndefined = function(e) {
                    return void 0 === e;
                }, r.isRegExp = function(e) {
                    return "[object RegExp]" === n(e);
                }, r.isObject = function(e) {
                    return "object" == typeof e && null !== e;
                }, r.isDate = function(e) {
                    return "[object Date]" === n(e);
                }, r.isError = function(e) {
                    return "[object Error]" === n(e) || e instanceof Error;
                }, r.isFunction = function(e) {
                    return "function" == typeof e;
                }, r.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, r.isBuffer = e("buffer").Buffer.isBuffer;
            },
            {
                buffer: 220
            }
        ],
        384: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("elliptic"), i = e("bn.js");
                        t.exports = function(e) {
                            return new o(e);
                        };
                        var s = {
                            secp256k1: {
                                name: "secp256k1",
                                byteLength: 32
                            },
                            secp224r1: {
                                name: "p224",
                                byteLength: 28
                            },
                            prime256v1: {
                                name: "p256",
                                byteLength: 32
                            },
                            prime192v1: {
                                name: "p192",
                                byteLength: 24
                            },
                            ed25519: {
                                name: "ed25519",
                                byteLength: 32
                            },
                            secp384r1: {
                                name: "p384",
                                byteLength: 48
                            },
                            secp521r1: {
                                name: "p521",
                                byteLength: 66
                            }
                        };
                        function o(e) {
                            this.curveType = s[e], this.curveType || (this.curveType = {
                                name: e
                            }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
                        }
                        function a(e, t, n) {
                            Array.isArray(e) || (e = e.toArray());
                            var i = new r(e);
                            if (n && i.length < n) {
                                var s = new r(n - i.length);
                                s.fill(0), i = r.concat([
                                    s,
                                    i
                                ]);
                            }
                            return t ? i.toString(t) : i;
                        }
                        s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function(e, t) {
                            return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                        }, o.prototype.computeSecret = function(e, t, n) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
                        }, o.prototype.getPublicKey = function(e, t) {
                            var r = this.keys.getPublic("compressed" === t, !0);
                            return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
                        }, o.prototype.getPrivateKey = function(e) {
                            return a(this.keys.getPrivate(), e);
                        }, o.prototype.setPublicKey = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.keys._importPublic(e), this;
                        }, o.prototype.setPrivateKey = function(e, t) {
                            t = t || "utf8", r.isBuffer(e) || (e = new r(e, t));
                            var n = new i(e);
                            return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 385,
                buffer: 220,
                elliptic: 405
            }
        ],
        385: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        386: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("md5.js"), s = e("ripemd160"), o = e("sha.js"), a = e("cipher-base");
                function l(e) {
                    a.call(this, "digest"), this._hash = e;
                }
                n(l, a), l.prototype._update = function(e) {
                    this._hash.update(e);
                }, l.prototype._final = function() {
                    return this._hash.digest();
                }, t.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new s : new l(o(e));
                };
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "md5.js": 450,
                ripemd160: 493,
                "sha.js": 498
            }
        ],
        387: [
            function(e, t, r) {
                "use strict";
                var n = e("md5.js");
                t.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            {
                "md5.js": 450
            }
        ],
        388: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./legacy"), s = e("cipher-base"), o = e("safe-buffer").Buffer, a = e("create-hash/md5"), l = e("ripemd160"), c = e("sha.js"), u = o.alloc(128);
                function h(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new l : c(e)).update(t).digest() : t.length < r && (t = o.concat([
                        t,
                        u
                    ], r));
                    for(var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++)n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
                    this._hash = "rmd160" === e ? new l : c(e), this._hash.update(n);
                }
                n(h, s), h.prototype._update = function(e) {
                    this._hash.update(e);
                }, h.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new l : c(this._alg)).update(this._opad).update(e).digest();
                }, t.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
                };
            },
            {
                "./legacy": 389,
                "cipher-base": 221,
                "create-hash/md5": 387,
                inherits: 440,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        389: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = i.alloc(128);
                function a(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([
                        t,
                        o
                    ], 64));
                    for(var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), a = 0; a < 64; a++)r[a] = 54 ^ t[a], n[a] = 92 ^ t[a];
                    this._hash = [
                        r
                    ];
                }
                n(a, s), a.prototype._update = function(e) {
                    this._hash.push(e);
                }, a.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, t.exports = a;
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        390: [
            function(e, t, r) {
                "use strict";
                r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = e("randombytes"), r.createHash = r.Hash = e("create-hash"), r.createHmac = r.Hmac = e("create-hmac");
                var n = e("browserify-sign/algos"), i = Object.keys(n), s = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                r.getHashes = function() {
                    return s;
                };
                var o = e("pbkdf2");
                r.pbkdf2 = o.pbkdf2, r.pbkdf2Sync = o.pbkdf2Sync;
                var a = e("browserify-cipher");
                r.Cipher = a.Cipher, r.createCipher = a.createCipher, r.Cipheriv = a.Cipheriv, r.createCipheriv = a.createCipheriv, r.Decipher = a.Decipher, r.createDecipher = a.createDecipher, r.Decipheriv = a.Decipheriv, r.createDecipheriv = a.createDecipheriv, r.getCiphers = a.getCiphers, r.listCiphers = a.listCiphers;
                var l = e("diffie-hellman");
                r.DiffieHellmanGroup = l.DiffieHellmanGroup, r.createDiffieHellmanGroup = l.createDiffieHellmanGroup, r.getDiffieHellman = l.getDiffieHellman, r.createDiffieHellman = l.createDiffieHellman, r.DiffieHellman = l.DiffieHellman;
                var c = e("browserify-sign");
                r.createSign = c.createSign, r.Sign = c.Sign, r.createVerify = c.createVerify, r.Verify = c.Verify, r.createECDH = e("create-ecdh");
                var u = e("public-encrypt");
                r.publicEncrypt = u.publicEncrypt, r.privateEncrypt = u.privateEncrypt, r.publicDecrypt = u.publicDecrypt, r.privateDecrypt = u.privateDecrypt;
                var h = e("randomfill");
                r.randomFill = h.randomFill, r.randomFillSync = h.randomFillSync, r.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, r.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            {
                "browserify-cipher": 206,
                "browserify-sign": 213,
                "browserify-sign/algos": 210,
                "create-ecdh": 384,
                "create-hash": 386,
                "create-hmac": 388,
                "diffie-hellman": 400,
                pbkdf2: 460,
                "public-encrypt": 468,
                randombytes: 475,
                randomfill: 476
            }
        ],
        391: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs = n();
                }(void 0, function() {
                    var e = 6e4, t = 36e5, r = "millisecond", n = "second", i = "minute", s = "hour", o = "day", a = "week", l = "month", c = "quarter", u = "year", h = "date", f = "Invalid Date", d = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = {
                        name: "en",
                        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                        ordinal: function(e) {
                            var t = [
                                "th",
                                "st",
                                "nd",
                                "rd"
                            ], r = e % 100;
                            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
                        }
                    }, b = function(e, t, r) {
                        var n = String(e);
                        return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
                    }, g = {
                        s: b,
                        z: function(e) {
                            var t = -e.utcOffset(), r = Math.abs(t), n = Math.floor(r / 60), i = r % 60;
                            return (t <= 0 ? "+" : "-") + b(n, 2, "0") + ":" + b(i, 2, "0");
                        },
                        m: function e(t, r) {
                            if (t.date() < r.date()) return -e(r, t);
                            var n = 12 * (r.year() - t.year()) + (r.month() - t.month()), i = t.clone().add(n, l), s = r - i < 0, o = t.clone().add(n + (s ? -1 : 1), l);
                            return +(-(n + (r - i) / (s ? i - o : o - i)) || 0);
                        },
                        a: function(e) {
                            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                        },
                        p: function(e) {
                            return ({
                                M: l,
                                y: u,
                                w: a,
                                d: o,
                                D: h,
                                h: s,
                                m: i,
                                s: n,
                                ms: r,
                                Q: c
                            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
                        },
                        u: function(e) {
                            return void 0 === e;
                        }
                    }, y = "en", v = {};
                    v[y] = m;
                    var w = "$isDayjsObject", _ = function(e) {
                        return e instanceof M || !(!e || !e[w]);
                    }, x = function e(t, r, n) {
                        var i;
                        if (!t) return y;
                        if ("string" == typeof t) {
                            var s = t.toLowerCase();
                            v[s] && (i = s), r && (v[s] = r, i = s);
                            var o = t.split("-");
                            if (!i && o.length > 1) return e(o[0]);
                        } else {
                            var a = t.name;
                            v[a] = t, i = a;
                        }
                        return !n && i && (y = i), i || !n && y;
                    }, k = function(e, t) {
                        if (_(e)) return e.clone();
                        var r = "object" == typeof t ? t : {};
                        return r.date = e, r.args = arguments, new M(r);
                    }, S = g;
                    S.l = x, S.i = _, S.w = function(e, t) {
                        return k(e, {
                            locale: t.$L,
                            utc: t.$u,
                            x: t.$x,
                            $offset: t.$offset
                        });
                    };
                    var M = function() {
                        function m(e) {
                            this.$L = x(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[w] = !0;
                        }
                        var b = m.prototype;
                        return b.parse = function(e) {
                            this.$d = function(e) {
                                var t = e.date, r = e.utc;
                                if (null === t) return new Date(NaN);
                                if (S.u(t)) return new Date;
                                if (t instanceof Date) return new Date(t);
                                if ("string" == typeof t && !/Z$/i.test(t)) {
                                    var n = t.match(d);
                                    if (n) {
                                        var i = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
                                        return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
                                    }
                                }
                                return new Date(t);
                            }(e), this.init();
                        }, b.init = function() {
                            var e = this.$d;
                            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
                        }, b.$utils = function() {
                            return S;
                        }, b.isValid = function() {
                            return !(this.$d.toString() === f);
                        }, b.isSame = function(e, t) {
                            var r = k(e);
                            return this.startOf(t) <= r && r <= this.endOf(t);
                        }, b.isAfter = function(e, t) {
                            return k(e) < this.startOf(t);
                        }, b.isBefore = function(e, t) {
                            return this.endOf(t) < k(e);
                        }, b.$g = function(e, t, r) {
                            return S.u(e) ? this[t] : this.set(r, e);
                        }, b.unix = function() {
                            return Math.floor(this.valueOf() / 1e3);
                        }, b.valueOf = function() {
                            return this.$d.getTime();
                        }, b.startOf = function(e, t) {
                            var r = this, c = !!S.u(t) || t, f = S.p(e), d = function(e, t) {
                                var n = S.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
                                return c ? n : n.endOf(o);
                            }, p = function(e, t) {
                                return S.w(r.toDate()[e].apply(r.toDate("s"), (c ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    23,
                                    59,
                                    59,
                                    999
                                ]).slice(t)), r);
                            }, m = this.$W, b = this.$M, g = this.$D, y = "set" + (this.$u ? "UTC" : "");
                            switch(f){
                                case u:
                                    return c ? d(1, 0) : d(31, 11);
                                case l:
                                    return c ? d(1, b) : d(0, b + 1);
                                case a:
                                    var v = this.$locale().weekStart || 0, w = (m < v ? m + 7 : m) - v;
                                    return d(c ? g - w : g + (6 - w), b);
                                case o:
                                case h:
                                    return p(y + "Hours", 0);
                                case s:
                                    return p(y + "Minutes", 1);
                                case i:
                                    return p(y + "Seconds", 2);
                                case n:
                                    return p(y + "Milliseconds", 3);
                                default:
                                    return this.clone();
                            }
                        }, b.endOf = function(e) {
                            return this.startOf(e, !1);
                        }, b.$set = function(e, t) {
                            var a, c = S.p(e), f = "set" + (this.$u ? "UTC" : ""), d = (a = {}, a[o] = f + "Date", a[h] = f + "Date", a[l] = f + "Month", a[u] = f + "FullYear", a[s] = f + "Hours", a[i] = f + "Minutes", a[n] = f + "Seconds", a[r] = f + "Milliseconds", a)[c], p = c === o ? this.$D + (t - this.$W) : t;
                            if (c === l || c === u) {
                                var m = this.clone().set(h, 1);
                                m.$d[d](p), m.init(), this.$d = m.set(h, Math.min(this.$D, m.daysInMonth())).$d;
                            } else d && this.$d[d](p);
                            return this.init(), this;
                        }, b.set = function(e, t) {
                            return this.clone().$set(e, t);
                        }, b.get = function(e) {
                            return this[S.p(e)]();
                        }, b.add = function(r, c) {
                            var h, f = this;
                            r = Number(r);
                            var d = S.p(c), p = function(e) {
                                var t = k(f);
                                return S.w(t.date(t.date() + Math.round(e * r)), f);
                            };
                            if (d === l) return this.set(l, this.$M + r);
                            if (d === u) return this.set(u, this.$y + r);
                            if (d === o) return p(1);
                            if (d === a) return p(7);
                            var m = (h = {}, h[i] = e, h[s] = t, h[n] = 1e3, h)[d] || 1, b = this.$d.getTime() + r * m;
                            return S.w(b, this);
                        }, b.subtract = function(e, t) {
                            return this.add(-1 * e, t);
                        }, b.format = function(e) {
                            var t = this, r = this.$locale();
                            if (!this.isValid()) return r.invalidDate || f;
                            var n = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), s = this.$H, o = this.$m, a = this.$M, l = r.weekdays, c = r.months, u = r.meridiem, h = function(e, r, i, s) {
                                return e && (e[r] || e(t, n)) || i[r].slice(0, s);
                            }, d = function(e) {
                                return S.s(s % 12 || 12, e, "0");
                            }, m = u || function(e, t, r) {
                                var n = e < 12 ? "AM" : "PM";
                                return r ? n.toLowerCase() : n;
                            };
                            return n.replace(p, function(e, n) {
                                return n || function(e) {
                                    switch(e){
                                        case "YY":
                                            return String(t.$y).slice(-2);
                                        case "YYYY":
                                            return S.s(t.$y, 4, "0");
                                        case "M":
                                            return a + 1;
                                        case "MM":
                                            return S.s(a + 1, 2, "0");
                                        case "MMM":
                                            return h(r.monthsShort, a, c, 3);
                                        case "MMMM":
                                            return h(c, a);
                                        case "D":
                                            return t.$D;
                                        case "DD":
                                            return S.s(t.$D, 2, "0");
                                        case "d":
                                            return String(t.$W);
                                        case "dd":
                                            return h(r.weekdaysMin, t.$W, l, 2);
                                        case "ddd":
                                            return h(r.weekdaysShort, t.$W, l, 3);
                                        case "dddd":
                                            return l[t.$W];
                                        case "H":
                                            return String(s);
                                        case "HH":
                                            return S.s(s, 2, "0");
                                        case "h":
                                            return d(1);
                                        case "hh":
                                            return d(2);
                                        case "a":
                                            return m(s, o, !0);
                                        case "A":
                                            return m(s, o, !1);
                                        case "m":
                                            return String(o);
                                        case "mm":
                                            return S.s(o, 2, "0");
                                        case "s":
                                            return String(t.$s);
                                        case "ss":
                                            return S.s(t.$s, 2, "0");
                                        case "SSS":
                                            return S.s(t.$ms, 3, "0");
                                        case "Z":
                                            return i;
                                    }
                                    return null;
                                }(e) || i.replace(":", "");
                            });
                        }, b.utcOffset = function() {
                            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                        }, b.diff = function(r, h, f) {
                            var d, p = this, m = S.p(h), b = k(r), g = (b.utcOffset() - this.utcOffset()) * e, y = this - b, v = function() {
                                return S.m(p, b);
                            };
                            switch(m){
                                case u:
                                    d = v() / 12;
                                    break;
                                case l:
                                    d = v();
                                    break;
                                case c:
                                    d = v() / 3;
                                    break;
                                case a:
                                    d = (y - g) / 6048e5;
                                    break;
                                case o:
                                    d = (y - g) / 864e5;
                                    break;
                                case s:
                                    d = y / t;
                                    break;
                                case i:
                                    d = y / e;
                                    break;
                                case n:
                                    d = y / 1e3;
                                    break;
                                default:
                                    d = y;
                            }
                            return f ? d : S.a(d);
                        }, b.daysInMonth = function() {
                            return this.endOf(l).$D;
                        }, b.$locale = function() {
                            return v[this.$L];
                        }, b.locale = function(e, t) {
                            if (!e) return this.$L;
                            var r = this.clone(), n = x(e, t, !0);
                            return n && (r.$L = n), r;
                        }, b.clone = function() {
                            return S.w(this.$d, this);
                        }, b.toDate = function() {
                            return new Date(this.valueOf());
                        }, b.toJSON = function() {
                            return this.isValid() ? this.toISOString() : null;
                        }, b.toISOString = function() {
                            return this.$d.toISOString();
                        }, b.toString = function() {
                            return this.$d.toUTCString();
                        }, m;
                    }(), C = M.prototype;
                    return k.prototype = C, [
                        [
                            "$ms",
                            r
                        ],
                        [
                            "$s",
                            n
                        ],
                        [
                            "$m",
                            i
                        ],
                        [
                            "$H",
                            s
                        ],
                        [
                            "$W",
                            o
                        ],
                        [
                            "$M",
                            l
                        ],
                        [
                            "$y",
                            u
                        ],
                        [
                            "$D",
                            h
                        ]
                    ].forEach(function(e) {
                        C[e[1]] = function(t) {
                            return this.$g(t, e[0], e[1]);
                        };
                    }), k.extend = function(e, t) {
                        return e.$i || (e(t, M, k), e.$i = !0), k;
                    }, k.locale = x, k.isDayjs = _, k.unix = function(e) {
                        return k(1e3 * e);
                    }, k.en = v[y], k.Ls = v, k.p = {}, k;
                });
            },
            {}
        ],
        392: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = n();
                }(void 0, function() {
                    var e = {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, n = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, o = function(e) {
                        return (e = +e) + (e > 68 ? 1900 : 2e3);
                    }, a = function(e) {
                        return function(t) {
                            this[e] = +t;
                        };
                    }, l = [
                        /[+-]\d\d:?(\d\d)?|Z/,
                        function(e) {
                            (this.zone || (this.zone = {})).offset = function(e) {
                                if (!e) return 0;
                                if ("Z" === e) return 0;
                                var t = e.match(/([+-]|\d\d)/g), r = 60 * t[1] + (+t[2] || 0);
                                return 0 === r ? 0 : "+" === t[0] ? -r : r;
                            }(e);
                        }
                    ], c = function(e) {
                        var t = s[e];
                        return t && (t.indexOf ? t : t.s.concat(t.f));
                    }, u = function(e, t) {
                        var r, n = s.meridiem;
                        if (n) {
                            for(var i = 1; i <= 24; i += 1)if (e.indexOf(n(i, 0, t)) > -1) {
                                r = i > 12;
                                break;
                            }
                        } else r = e === (t ? "pm" : "PM");
                        return r;
                    }, h = {
                        A: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !1);
                            }
                        ],
                        a: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !0);
                            }
                        ],
                        S: [
                            /\d/,
                            function(e) {
                                this.milliseconds = 100 * +e;
                            }
                        ],
                        SS: [
                            r,
                            function(e) {
                                this.milliseconds = 10 * +e;
                            }
                        ],
                        SSS: [
                            /\d{3}/,
                            function(e) {
                                this.milliseconds = +e;
                            }
                        ],
                        s: [
                            n,
                            a("seconds")
                        ],
                        ss: [
                            n,
                            a("seconds")
                        ],
                        m: [
                            n,
                            a("minutes")
                        ],
                        mm: [
                            n,
                            a("minutes")
                        ],
                        H: [
                            n,
                            a("hours")
                        ],
                        h: [
                            n,
                            a("hours")
                        ],
                        HH: [
                            n,
                            a("hours")
                        ],
                        hh: [
                            n,
                            a("hours")
                        ],
                        D: [
                            n,
                            a("day")
                        ],
                        DD: [
                            r,
                            a("day")
                        ],
                        Do: [
                            i,
                            function(e) {
                                var t = s.ordinal, r = e.match(/\d+/);
                                if (this.day = r[0], t) for(var n = 1; n <= 31; n += 1)t(n).replace(/\[|\]/g, "") === e && (this.day = n);
                            }
                        ],
                        M: [
                            n,
                            a("month")
                        ],
                        MM: [
                            r,
                            a("month")
                        ],
                        MMM: [
                            i,
                            function(e) {
                                var t = c("months"), r = (c("monthsShort") || t.map(function(e) {
                                    return e.slice(0, 3);
                                })).indexOf(e) + 1;
                                if (r < 1) throw new Error;
                                this.month = r % 12 || r;
                            }
                        ],
                        MMMM: [
                            i,
                            function(e) {
                                var t = c("months").indexOf(e) + 1;
                                if (t < 1) throw new Error;
                                this.month = t % 12 || t;
                            }
                        ],
                        Y: [
                            /[+-]?\d+/,
                            a("year")
                        ],
                        YY: [
                            r,
                            function(e) {
                                this.year = o(e);
                            }
                        ],
                        YYYY: [
                            /\d{4}/,
                            a("year")
                        ],
                        Z: l,
                        ZZ: l
                    };
                    function f(r) {
                        var n, i;
                        n = r, i = s && s.formats;
                        for(var o = (r = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, r, n) {
                            var s = n && n.toUpperCase();
                            return r || i[n] || e[n] || i[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, r) {
                                return t || r.slice(1);
                            });
                        })).match(t), a = o.length, l = 0; l < a; l += 1){
                            var c = o[l], u = h[c], f = u && u[0], d = u && u[1];
                            o[l] = d ? {
                                regex: f,
                                parser: d
                            } : c.replace(/^\[|\]$/g, "");
                        }
                        return function(e) {
                            for(var t = {}, r = 0, n = 0; r < a; r += 1){
                                var i = o[r];
                                if ("string" == typeof i) n += i.length;
                                else {
                                    var s = i.regex, l = i.parser, c = e.slice(n), u = s.exec(c)[0];
                                    l.call(t, u), e = e.replace(u, "");
                                }
                            }
                            return function(e) {
                                var t = e.afternoon;
                                if (void 0 !== t) {
                                    var r = e.hours;
                                    t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                                }
                            }(t), t;
                        };
                    }
                    return function(e, t, r) {
                        r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
                        var n = t.prototype, i = n.parse;
                        n.parse = function(e) {
                            var t = e.date, n = e.utc, o = e.args;
                            this.$u = n;
                            var a = o[1];
                            if ("string" == typeof a) {
                                var l = !0 === o[2], c = !0 === o[3], u = l || c, h = o[2];
                                c && (h = o[2]), s = this.$locale(), !l && h && (s = r.Ls[h]), this.$d = function(e, t, r) {
                                    try {
                                        if ([
                                            "x",
                                            "X"
                                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                        var n = f(t)(e), i = n.year, s = n.month, o = n.day, a = n.hours, l = n.minutes, c = n.seconds, u = n.milliseconds, h = n.zone, d = new Date, p = o || (i || s ? 1 : d.getDate()), m = i || d.getFullYear(), b = 0;
                                        i && !s || (b = s > 0 ? s - 1 : d.getMonth());
                                        var g = a || 0, y = l || 0, v = c || 0, w = u || 0;
                                        return h ? new Date(Date.UTC(m, b, p, g, y, v, w + 60 * h.offset * 1e3)) : r ? new Date(Date.UTC(m, b, p, g, y, v, w)) : new Date(m, b, p, g, y, v, w);
                                    } catch (e) {
                                        return new Date("");
                                    }
                                }(t, a, n), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
                            } else if (a instanceof Array) for(var d = a.length, p = 1; p <= d; p += 1){
                                o[1] = a[p - 1];
                                var m = r.apply(this, o);
                                if (m.isValid()) {
                                    this.$d = m.$d, this.$L = m.$L, this.init();
                                    break;
                                }
                                p === d && (this.$d = new Date(""));
                            }
                            else i.call(this, e);
                        };
                    };
                });
            },
            {}
        ],
        393: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_utc = n();
                }(void 0, function() {
                    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
                    return function(n, i, s) {
                        var o = i.prototype;
                        s.utc = function(e) {
                            var t = {
                                date: e,
                                utc: !0,
                                args: arguments
                            };
                            return new i(t);
                        }, o.utc = function(t) {
                            var r = s(this.toDate(), {
                                locale: this.$L,
                                utc: !0
                            });
                            return t ? r.add(this.utcOffset(), e) : r;
                        }, o.local = function() {
                            return s(this.toDate(), {
                                locale: this.$L,
                                utc: !1
                            });
                        };
                        var a = o.parse;
                        o.parse = function(e) {
                            e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), a.call(this, e);
                        };
                        var l = o.init;
                        o.init = function() {
                            if (this.$u) {
                                var e = this.$d;
                                this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
                            } else l.call(this);
                        };
                        var c = o.utcOffset;
                        o.utcOffset = function(n, i) {
                            var s = this.$utils().u;
                            if (s(n)) return this.$u ? 0 : s(this.$offset) ? c.call(this) : this.$offset;
                            if ("string" == typeof n && null === (n = function(e) {
                                void 0 === e && (e = "");
                                var n = e.match(t);
                                if (!n) return null;
                                var i = ("" + n[0]).match(r) || [
                                    "-",
                                    0,
                                    0
                                ], s = i[0], o = 60 * +i[1] + +i[2];
                                return 0 === o ? 0 : "+" === s ? o : -o;
                            }(n))) return this;
                            var o = Math.abs(n) <= 16 ? 60 * n : n, a = this;
                            if (i) return a.$offset = o, a.$u = 0 === n, a;
                            if (0 !== n) {
                                var l = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                                (a = this.local().add(o + l, e)).$offset = o, a.$x.$localOffset = l;
                            } else a = this.utc();
                            return a;
                        };
                        var u = o.format;
                        o.format = function(e) {
                            var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                            return u.call(this, t);
                        }, o.valueOf = function() {
                            var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                            return this.$d.valueOf() - 6e4 * e;
                        }, o.isUTC = function() {
                            return !!this.$u;
                        }, o.toISOString = function() {
                            return this.toDate().toISOString();
                        }, o.toString = function() {
                            return this.toDate().toUTCString();
                        };
                        var h = o.toDate;
                        o.toDate = function(e) {
                            return "s" === e && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
                        };
                        var f = o.diff;
                        o.diff = function(e, t, r) {
                            if (e && this.$u === e.$u) return f.call(this, e, t, r);
                            var n = this.local(), i = s(e).local();
                            return f.call(n, i, t, r);
                        };
                    };
                });
            },
            {}
        ],
        394: [
            function(e, t, r) {
                "use strict";
                r.utils = e("./des/utils"), r.Cipher = e("./des/cipher"), r.DES = e("./des/des"), r.CBC = e("./des/cbc"), r.EDE = e("./des/ede");
            },
            {
                "./des/cbc": 395,
                "./des/cipher": 396,
                "./des/des": 397,
                "./des/ede": 398,
                "./des/utils": 399
            }
        ],
        395: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = {};
                function o(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                r.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(s), n = 0; n < r.length; n++){
                        var o = r[n];
                        t.prototype[o] = s[o];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, s._cbcInit = function() {
                    var e = new o(this.options.iv);
                    this._cbcState = e;
                }, s._update = function(e, t, r, n) {
                    var i = this._cbcState, s = this.constructor.super_.prototype, o = i.iv;
                    if ("encrypt" === this.type) {
                        for(var a = 0; a < this.blockSize; a++)o[a] ^= e[t + a];
                        s._update.call(this, o, 0, r, n);
                        for(a = 0; a < this.blockSize; a++)o[a] = r[n + a];
                    } else {
                        s._update.call(this, e, t, r, n);
                        for(a = 0; a < this.blockSize; a++)r[n + a] ^= o[a];
                        for(a = 0; a < this.blockSize; a++)o[a] = e[t + a];
                    }
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        396: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert");
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
                }
                t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            {
                "minimalistic-assert": 453
            }
        ],
        397: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./utils"), o = e("./cipher");
                function a() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function l(e) {
                    o.call(this, e);
                    var t = new a;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(l, o), t.exports = l, l.create = function(e) {
                    return new l(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                l.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = s.readUInt32BE(t, 0), i = s.readUInt32BE(t, 4);
                    s.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var o = 0; o < e.keys.length; o += 2){
                        var a = c[o >>> 1];
                        r = s.r28shl(r, a), i = s.r28shl(i, a), s.pc2(r, i, e.keys, o);
                    }
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._desState, o = s.readUInt32BE(e, t), a = s.readUInt32BE(e, t + 4);
                    s.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], s.writeUInt32BE(r, o, n), s.writeUInt32BE(r, a, n + 4);
                }, l.prototype._pad = function(e, t) {
                    if (!1 === this.padding) return !1;
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, l.prototype._unpad = function(e) {
                    if (!1 === this.padding) return e;
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, l.prototype._encrypt = function(e, t, r, n, i) {
                    for(var o = t, a = r, l = 0; l < e.keys.length; l += 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = a;
                        a = (o ^ s.permute(h)) >>> 0, o = f;
                    }
                    s.rip(a, o, n, i);
                }, l.prototype._decrypt = function(e, t, r, n, i) {
                    for(var o = r, a = t, l = e.keys.length - 2; l >= 0; l -= 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(o, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = o;
                        o = (a ^ s.permute(h)) >>> 0, a = f;
                    }
                    s.rip(o, a, n, i);
                };
            },
            {
                "./cipher": 396,
                "./utils": 399,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        398: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./cipher"), o = e("./des");
                function a(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), s = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        o.create({
                            type: "encrypt",
                            key: r
                        }),
                        o.create({
                            type: "decrypt",
                            key: i
                        }),
                        o.create({
                            type: "encrypt",
                            key: s
                        })
                    ] : [
                        o.create({
                            type: "decrypt",
                            key: s
                        }),
                        o.create({
                            type: "encrypt",
                            key: i
                        }),
                        o.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function l(e) {
                    s.call(this, e);
                    var t = new a(this.type, this.options.key);
                    this._edeState = t;
                }
                i(l, s), t.exports = l, l.create = function(e) {
                    return new l(e);
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad;
            },
            {
                "./cipher": 396,
                "./des": 397,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        399: [
            function(e, t, r) {
                "use strict";
                r.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, r.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, r.ip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 6; o >= 0; o -= 2){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >>> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >>> a + o & 1;
                    }
                    for(o = 6; o >= 0; o -= 2){
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= t >>> a + o & 1;
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= e >>> a + o & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.rip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 0; o < 4; o++)for(var a = 24; a >= 0; a -= 8)i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
                    for(o = 4; o < 8; o++)for(a = 24; a >= 0; a -= 8)s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.pc1 = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 7; o >= 5; o--){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                    for(o = 1; o <= 3; o++){
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var n = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                r.pc2 = function(e, t, r, i) {
                    for(var s = 0, o = 0, a = n.length >>> 1, l = 0; l < a; l++)s <<= 1, s |= e >>> n[l] & 1;
                    for(l = a; l < n.length; l++)o <<= 1, o |= t >>> n[l] & 1;
                    r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
                }, r.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var s = 23; s >= 15; s -= 4)n <<= 6, n |= e >>> s & 63;
                    for(s = 11; s >= 3; s -= 4)i |= e >>> s & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var i = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                r.substitute = function(e, t) {
                    for(var r = 0, n = 0; n < 4; n++)r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
                    for(n = 0; n < 4; n++)r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
                    return r >>> 0;
                };
                var s = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                r.permute = function(e) {
                    for(var t = 0, r = 0; r < s.length; r++)t <<= 1, t |= e >>> s[r] & 1;
                    return t >>> 0;
                }, r.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], s = 0; s < t; s += r)i.push(n.slice(s, s + r));
                    return i.join(" ");
                };
            },
            {}
        ],
        400: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("./lib/generatePrime"), i = e("./lib/primes.json"), s = e("./lib/dh");
                        var o = {
                            binary: !0,
                            hex: !0,
                            base64: !0
                        };
                        r.DiffieHellmanGroup = r.createDiffieHellmanGroup = r.getDiffieHellman = function(e) {
                            var r = new t(i[e].prime, "hex"), n = new t(i[e].gen, "hex");
                            return new s(r, n);
                        }, r.createDiffieHellman = r.DiffieHellman = function e(r, i, a, l) {
                            return t.isBuffer(i) || void 0 === o[i] ? e(r, "binary", i, a) : (i = i || "binary", l = l || "binary", a = a || new t([
                                2
                            ]), t.isBuffer(a) || (a = new t(a, l)), "number" == typeof r ? new s(n(r, a), a, !0) : (t.isBuffer(r) || (r = new t(r, i)), new s(r, a, !0)));
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./lib/dh": 401,
                "./lib/generatePrime": 402,
                "./lib/primes.json": 403,
                buffer: 220
            }
        ],
        401: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = new (e("miller-rabin")), s = new n(24), o = new n(11), a = new n(10), l = new n(3), c = new n(7), u = e("./generatePrime"), h = e("randombytes");
                        function f(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._pub = new n(e), this;
                        }
                        function d(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._priv = new n(e), this;
                        }
                        t.exports = m;
                        var p = {};
                        function m(e, t, r) {
                            this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = f, this.setPrivateKey = d) : this._primeCode = 8;
                        }
                        function b(e, t) {
                            var n = new r(e.toArray());
                            return t ? n.toString(t) : n;
                        }
                        Object.defineProperty(m.prototype, "verifyError", {
                            enumerable: !0,
                            get: function() {
                                return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                                    var r = t.toString("hex"), n = [
                                        r,
                                        e.toString(16)
                                    ].join("_");
                                    if (n in p) return p[n];
                                    var h, f = 0;
                                    if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return f += 1, f += "02" === r || "05" === r ? 8 : 4, p[n] = f, f;
                                    switch(i.test(e.shrn(1)) || (f += 2), r){
                                        case "02":
                                            e.mod(s).cmp(o) && (f += 8);
                                            break;
                                        case "05":
                                            (h = e.mod(a)).cmp(l) && h.cmp(c) && (f += 8);
                                            break;
                                        default:
                                            f += 4;
                                    }
                                    return p[n] = f, f;
                                }(this.__prime, this.__gen)), this._primeCode;
                            }
                        }), m.prototype.generateKeys = function() {
                            return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                        }, m.prototype.computeSecret = function(e) {
                            var t = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(), i = new r(t.toArray()), s = this.getPrime();
                            if (i.length < s.length) {
                                var o = new r(s.length - i.length);
                                o.fill(0), i = r.concat([
                                    o,
                                    i
                                ]);
                            }
                            return i;
                        }, m.prototype.getPublicKey = function(e) {
                            return b(this._pub, e);
                        }, m.prototype.getPrivateKey = function(e) {
                            return b(this._priv, e);
                        }, m.prototype.getPrime = function(e) {
                            return b(this.__prime, e);
                        }, m.prototype.getGenerator = function(e) {
                            return b(this._gen, e);
                        }, m.prototype.setGenerator = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.__gen = e, this._gen = new n(e), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./generatePrime": 402,
                "bn.js": 404,
                buffer: 220,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        402: [
            function(e, t, r) {
                "use strict";
                var n = e("randombytes");
                t.exports = y, y.simpleSieve = b, y.fermatTest = g;
                var i = e("bn.js"), s = new i(24), o = new (e("miller-rabin")), a = new i(1), l = new i(2), c = new i(5), u = (new i(16), new i(8), new i(10)), h = new i(3), f = (new i(7), new i(11)), d = new i(4), p = (new i(12), null);
                function m() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function b(e) {
                    for(var t = m(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function g(e) {
                    var t = i.mont(e);
                    return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function y(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(l), t.cmp(l)) {
                            if (!t.cmp(c)) for(; r.mod(u).cmp(h);)r.iadd(d);
                        } else for(; r.mod(s).cmp(f);)r.iadd(d);
                        if (b(p = r.shrn(1)) && b(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
                    }
                }
            },
            {
                "bn.js": 404,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        403: [
            function(e, t, r) {
                t.exports = {
                    modp1: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
                    },
                    modp2: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
                    },
                    modp5: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
                    },
                    modp14: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
                    },
                    modp15: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
                    },
                    modp16: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
                    },
                    modp17: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
                    },
                    modp18: {
                        gen: "02",
                        prime: "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"
                    }
                };
            },
            {}
        ],
        404: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        405: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.version = e("../package.json").version, n.utils = e("./elliptic/utils"), n.rand = e("brorand"), n.curve = e("./elliptic/curve"), n.curves = e("./elliptic/curves"), n.ec = e("./elliptic/ec"), n.eddsa = e("./elliptic/eddsa");
            },
            {
                "../package.json": 421,
                "./elliptic/curve": 408,
                "./elliptic/curves": 411,
                "./elliptic/ec": 412,
                "./elliptic/eddsa": 415,
                "./elliptic/utils": 419,
                brorand: 187
            }
        ],
        406: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.getNAF, o = i.getJSF, a = i.assert;
                function l(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                t.exports = l, l.prototype.point = function() {
                    throw new Error("Not implemented");
                }, l.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, l.prototype._fixedNafMul = function(e, t) {
                    a(e.precomputed);
                    var r = e._getDoubles(), n = s(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, l, c = [];
                    for(o = 0; o < n.length; o += r.step){
                        l = 0;
                        for(var u = o + r.step - 1; u >= o; u--)l = (l << 1) + n[u];
                        c.push(l);
                    }
                    for(var h = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < c.length; o++)(l = c[o]) === d ? f = f.mixedAdd(r.points[o]) : l === -d && (f = f.mixedAdd(r.points[o].neg()));
                        h = h.add(f);
                    }
                    return h.toP();
                }, l.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = s(t, r, this._bitLength), l = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--){
                        for(var u = 0; c >= 0 && 0 === o[c]; c--)u++;
                        if (c >= 0 && u++, l = l.dblp(u), c < 0) break;
                        var h = o[c];
                        a(0 !== h), l = "affine" === e.type ? h > 0 ? l.mixedAdd(i[h - 1 >> 1]) : l.mixedAdd(i[-h - 1 >> 1].neg()) : h > 0 ? l.add(i[h - 1 >> 1]) : l.add(i[-h - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? l.toP() : l;
                }, l.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var a, l, c, u = this._wnafT1, h = this._wnafT2, f = this._wnafT3, d = 0;
                    for(a = 0; a < n; a++){
                        var p = (c = t[a])._getNAFPoints(e);
                        u[a] = p.wnd, h[a] = p.points;
                    }
                    for(a = n - 1; a >= 1; a -= 2){
                        var m = a - 1, b = a;
                        if (1 === u[m] && 1 === u[b]) {
                            var g = [
                                t[m],
                                null,
                                null,
                                t[b]
                            ];
                            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
                            var y = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], v = o(r[m], r[b]);
                            for(d = Math.max(v[0].length, d), f[m] = new Array(d), f[b] = new Array(d), l = 0; l < d; l++){
                                var w = 0 | v[0][l], _ = 0 | v[1][l];
                                f[m][l] = y[3 * (w + 1) + (_ + 1)], f[b][l] = 0, h[m] = g;
                            }
                        } else f[m] = s(r[m], u[m], this._bitLength), f[b] = s(r[b], u[b], this._bitLength), d = Math.max(f[m].length, d), d = Math.max(f[b].length, d);
                    }
                    var x = this.jpoint(null, null, null), k = this._wnafT4;
                    for(a = d; a >= 0; a--){
                        for(var S = 0; a >= 0;){
                            var M = !0;
                            for(l = 0; l < n; l++)k[l] = 0 | f[l][a], 0 !== k[l] && (M = !1);
                            if (!M) break;
                            S++, a--;
                        }
                        if (a >= 0 && S++, x = x.dblp(S), a < 0) break;
                        for(l = 0; l < n; l++){
                            var C = k[l];
                            0 !== C && (C > 0 ? c = h[l][C - 1 >> 1] : C < 0 && (c = h[l][-C - 1 >> 1].neg()), x = "affine" === c.type ? x.mixedAdd(c) : x.add(c));
                        }
                    }
                    for(a = 0; a < n; a++)h[a] = null;
                    return i ? x : x.toP();
                }, l.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, l.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var s = 0; s < e; s++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        407: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, s) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = s && new i(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                s(l, o), t.exports = l, l.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, l.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, l.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), s = this.one.redSub(this.c2.redMul(this.d).redMul(r)), o = n.redMul(s.redInvm()), a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    var l = a.fromRed().isOdd();
                    return (t && !l || !t && l) && (a = a.redNeg()), this.point(e, a);
                }, l.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), s = r.redMul(this.d).redMul(this.c2).redSub(this.a), o = n.redMul(s.redInvm());
                    if (0 === o.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
                }, l.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, s(c, o.BasePoint), l.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, l.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), s = n.redAdd(t), o = s.redSub(r), a = n.redSub(t), l = i.redMul(o), c = s.redMul(a), u = i.redMul(a), h = o.redMul(s);
                    return this.curve.point(l, c, h, u);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, s, o = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), l = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(a)).redAdd(l);
                        this.zOne ? (e = o.redSub(a).redSub(l).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(l)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), s = c.redSub(i).redISub(i), e = o.redSub(a).redISub(l).redMul(s), t = c.redMul(n.redSub(l)), r = c.redMul(s));
                    } else n = a.redAdd(l), i = this.curve._mulC(this.z).redSqr(), s = n.redSub(i).redSub(i), e = this.curve._mulC(o.redISub(n)).redMul(s), t = this.curve._mulC(n).redMul(a.redISub(l)), r = n.redMul(s);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), s = r.redSub(t), o = i.redSub(n), a = i.redAdd(n), l = r.redAdd(t), c = s.redMul(o), u = a.redMul(l), h = s.redMul(l), f = o.redMul(a);
                    return this.curve.point(c, u, f, h);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), s = this.x.redMul(e.x), o = this.y.redMul(e.y), a = this.curve.d.redMul(s).redMul(o), l = i.redSub(a), c = i.redAdd(a), u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o), h = n.redMul(l).redMul(u);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = l.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(l).redMul(c)), this.curve.point(h, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        408: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.base = e("./base"), n.short = e("./short"), n.mont = e("./mont"), n.edwards = e("./edwards");
            },
            {
                "./base": 406,
                "./edwards": 407,
                "./mont": 409,
                "./short": 410
            }
        ],
        409: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("inherits"), s = e("./base"), o = e("../utils");
                function a(e) {
                    s.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function l(e, t, r) {
                    s.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(a, s), t.exports = a, a.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(l, s.BasePoint), a.prototype.decodePoint = function(e, t) {
                    return this.point(o.toArray(e, t), 1);
                }, a.prototype.point = function(e, t) {
                    return new l(this, e, t);
                }, a.prototype.pointFromJSON = function(e) {
                    return l.fromJSON(this, e);
                }, l.prototype.precompute = function() {}, l.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, l.fromJSON = function(e, t) {
                    return new l(e, t[0], t[1] || e.one);
                }, l.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, l.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, l.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, l.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), s = e.x.redSub(e.z).redMul(r), o = i.redMul(n), a = t.z.redMul(s.redAdd(o).redSqr()), l = t.x.redMul(s.redISub(o).redSqr());
                    return this.curve.point(a, l);
                }, l.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var s = i.length - 1; s >= 0; s--)0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, l.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, l.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, l.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        410: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    o.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    o.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function u(e, t, r, n) {
                    o.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                s(l, o), t.exports = l, l.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var s = this._getEndoRoots(this.n);
                            0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? r = s[0] : (r = s[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, l.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), s = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(s).fromRed(),
                        n.redSub(s).fromRed()
                    ];
                }, l.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, s, o, a, l, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, d = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), y = 0; 0 !== f.cmpn(0);){
                        var v = d.div(f);
                        c = d.sub(v.mul(f)), u = b.sub(v.mul(p));
                        var w = g.sub(v.mul(m));
                        if (!n && c.cmp(h) < 0) t = l.neg(), r = p, n = c.neg(), s = u;
                        else if (n && 2 == ++y) break;
                        l = c, d = f, f = c, b = p, p = u, g = m, m = w;
                    }
                    o = c.neg(), a = u;
                    var _ = n.sqr().add(s.sqr());
                    return o.sqr().add(a.sqr()).cmp(_) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), s = s.neg()), o.negative && (o = o.neg(), a = a.neg()), [
                        {
                            a: n,
                            b: s
                        },
                        {
                            a: o,
                            b: a
                        }
                    ];
                }, l.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), s = r.b.neg().mul(e).divRound(this.n), o = i.mul(r.a), a = s.mul(n.a), l = i.mul(r.b), c = s.mul(n.b);
                    return {
                        k1: e.sub(o).sub(a),
                        k2: l.add(c).neg()
                    };
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var s = n.fromRed().isOdd();
                    return (t && !s || !t && s) && (n = n.redNeg()), this.point(e, n);
                }, l.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, l.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++){
                        var o = this._endoSplit(t[s]), a = e[s], l = a._getBeta();
                        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), l = l.neg(!0)), n[2 * s] = a, n[2 * s + 1] = l, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++)n[u] = null, i[u] = null;
                    return c;
                }, s(c, o.BasePoint), l.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, l.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var s = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: s.doubles && {
                            step: s.doubles.step,
                            points: [
                                n
                            ].concat(s.doubles.points.map(i))
                        },
                        naf: s.naf && {
                            wnd: s.naf.wnd,
                            points: [
                                n
                            ].concat(s.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), s = i.redSqr().redISub(this.x.redAdd(this.x)), o = i.redMul(this.x.redSub(s)).redISub(this.y);
                    return this.curve.point(s, o);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, s(u, o.BasePoint), l.prototype.jpoint = function(e, t, r) {
                    return new u(this, e, t, r);
                }, u.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, u.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, u.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), s = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(r.redMul(this.z)), a = n.redSub(i), l = s.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = a.redSqr(), u = c.redMul(a), h = n.redMul(c), f = l.redSqr().redIAdd(u).redISub(h).redISub(h), d = l.redMul(h.redISub(f)).redISub(s.redMul(u)), p = this.z.redMul(e.z).redMul(a);
                    return this.curve.jpoint(f, d, p);
                }, u.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, s = e.y.redMul(t).redMul(this.z), o = r.redSub(n), a = i.redSub(s);
                    if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var l = o.redSqr(), c = l.redMul(o), u = r.redMul(l), h = a.redSqr().redIAdd(c).redISub(u).redISub(u), f = a.redMul(u.redISub(h)).redISub(i.redMul(c)), d = this.z.redMul(o);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, s = this.x, o = this.y, a = this.z, l = a.redSqr().redSqr(), c = o.redAdd(o);
                    for(t = 0; t < e; t++){
                        var u = s.redSqr(), h = c.redSqr(), f = h.redSqr(), d = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(l)), p = s.redMul(h), m = d.redSqr().redISub(p.redAdd(p)), b = p.redISub(m), g = d.redMul(b);
                        g = g.redIAdd(g).redISub(f);
                        var y = c.redMul(a);
                        t + 1 < e && (l = l.redMul(f)), s = m, a = y, c = g;
                    }
                    return this.curve.jpoint(s, c.redMul(i), a);
                }, u.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, u.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n), l = a.redSqr().redISub(o).redISub(o), c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = l, t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.x.redSqr(), h = this.y.redSqr(), f = h.redSqr(), d = this.x.redAdd(h).redSqr().redISub(u).redISub(f);
                        d = d.redIAdd(d);
                        var p = u.redAdd(u).redIAdd(u), m = p.redSqr(), b = f.redIAdd(f);
                        b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(d).redISub(d), t = p.redMul(d.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), l = a.redSqr().redISub(o).redISub(o);
                        e = l;
                        var c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.z.redSqr(), h = this.y.redSqr(), f = this.x.redMul(h), d = this.x.redSub(u).redMul(this.x.redAdd(u));
                        d = d.redAdd(d).redIAdd(d);
                        var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                        e = d.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);
                        var b = h.redSqr();
                        b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = d.redMul(p.redISub(e)).redISub(b);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), s = t.redSqr(), o = r.redSqr(), a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)), l = t.redAdd(t), c = (l = l.redIAdd(l)).redMul(o), u = a.redSqr().redISub(c.redAdd(c)), h = c.redISub(u), f = o.redSqr();
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = a.redMul(h).redISub(f), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(u, d, p);
                }, u.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), s = i.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(n), a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(), l = n.redIAdd(n);
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(l), u = t.redMul(c);
                    u = (u = u.redIAdd(u)).redIAdd(u);
                    var h = this.x.redMul(a).redISub(u);
                    h = (h = h.redIAdd(h)).redIAdd(h);
                    var f = this.y.redMul(c.redMul(l.redISub(c)).redISub(o.redMul(a)));
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, u.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, u.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        411: [
            function(e, t, r) {
                "use strict";
                var n, i = r, s = e("hash.js"), o = e("./curve"), a = e("./utils").assert;
                function l(e) {
                    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new l(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = l, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: s.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: s.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = e("./precomputed/secp256k1");
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: s.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            {
                "./curve": 408,
                "./precomputed/secp256k1": 418,
                "./utils": 419,
                "hash.js": 426
            }
        ],
        412: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("hmac-drbg"), s = e("../utils"), o = e("../curves"), a = e("brorand"), l = s.assert, c = e("./key"), u = e("./signature");
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    "string" == typeof e && (l(Object.prototype.hasOwnProperty.call(o, e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                t.exports = h, h.prototype.keyPair = function(e) {
                    return new c(this, e);
                }, h.prototype.keyFromPrivate = function(e, t) {
                    return c.fromPrivate(this, e, t);
                }, h.prototype.keyFromPublic = function(e, t) {
                    return c.fromPublic(this, e, t);
                }, h.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new i({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || a(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), s = this.n.sub(new n(2));;){
                        var o = new n(t.generate(r));
                        if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
                    }
                }, h.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, h.prototype.sign = function(e, t, r, s) {
                    "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));
                    for(var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), l = e.toArray("be", o), c = new i({
                        hash: this.hash,
                        entropy: a,
                        nonce: l,
                        pers: s.pers,
                        persEnc: s.persEnc || "utf8"
                    }), h = this.n.sub(new n(1)), f = 0;; f++){
                        var d = s.k ? s.k(f) : new n(c.generate(this.n.byteLength()));
                        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
                            var p = this.g.mul(d);
                            if (!p.isInfinity()) {
                                var m = p.getX(), b = m.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var g = d.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                                        var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                                        return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), y ^= 1), new u({
                                            r: b,
                                            s: g,
                                            recoveryParam: y
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, h.prototype.verify = function(e, t, r, i) {
                    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
                    var s = (t = new u(t, "hex")).r, o = t.s;
                    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    var a, l = o.invm(this.n), c = l.mul(e).umod(this.n), h = l.mul(s).umod(this.n);
                    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
                }, h.prototype.recoverPubKey = function(e, t, r, i) {
                    l((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
                    var s = this.n, o = new n(e), a = t.r, c = t.s, h = 1 & r, f = r >> 1;
                    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    a = f ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
                    var d = t.r.invm(s), p = s.sub(o).mul(d).umod(s), m = c.mul(d).umod(s);
                    return this.g.mulAdd(p, a, m);
                }, h.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var s;
                        try {
                            s = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (s.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 413,
                "./signature": 414,
                "bn.js": 420,
                brorand: 187,
                "hmac-drbg": 438
            }
        ],
        413: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils").assert;
                function s(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                t.exports = s, s.fromPublic = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, s.fromPrivate = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        priv: t,
                        privEnc: r
                    });
                }, s.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, s.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, s.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, s.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, s.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, s.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, s.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, s.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, s.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        414: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert;
                function o(e, t) {
                    if (e instanceof o) return e;
                    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function a() {
                    this.place = 0;
                }
                function l(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, s = 0, o = t.place; s < n; s++, o++)i <<= 8, i |= e[o], i >>>= 0;
                    return !(i <= 127) && (t.place = o, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function u(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                t.exports = o, o.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new a;
                    if (48 !== e[r.place++]) return !1;
                    var s = l(e, r);
                    if (!1 === s) return !1;
                    if (s + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var o = l(e, r);
                    if (!1 === o) return !1;
                    var c = e.slice(r.place, o + r.place);
                    if (r.place += o, 2 !== e[r.place++]) return !1;
                    var u = l(e, r);
                    if (!1 === u) return !1;
                    if (e.length !== u + r.place) return !1;
                    var h = e.slice(r.place, u + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === h[0]) {
                        if (!(128 & h[1])) return !1;
                        h = h.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(h), this.recoveryParam = null, !0;
                }, o.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
                    var s = n.concat(r), o = [
                        48
                    ];
                    return u(o, s.length), o = o.concat(s), i.encode(o, e);
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        415: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("../curves"), s = e("../utils"), o = s.assert, a = s.parseBytes, l = e("./key"), c = e("./signature");
                function u(e) {
                    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                t.exports = u, u.prototype.sign = function(e, t) {
                    e = a(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), s = this.encodePoint(i), o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()), l = n.add(o).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: l,
                        Rencoded: s
                    });
                }, u.prototype.verify = function(e, t, r) {
                    e = a(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), s = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(s);
                }, u.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return s.intFromLE(e.digest()).umod(this.curve.n);
                }, u.prototype.keyFromPublic = function(e) {
                    return l.fromPublic(this, e);
                }, u.prototype.keyFromSecret = function(e) {
                    return l.fromSecret(this, e);
                }, u.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, u.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, u.prototype.decodePoint = function(e) {
                    var t = (e = s.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = s.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, u.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, u.prototype.decodeInt = function(e) {
                    return s.intFromLE(e);
                }, u.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 416,
                "./signature": 417,
                "hash.js": 426
            }
        ],
        416: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = n.assert, s = n.parseBytes, o = n.cachedProperty;
                function a(e, t) {
                    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
                }
                a.fromPublic = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        pub: t
                    });
                }, a.fromSecret = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        secret: t
                    });
                }, a.prototype.secret = function() {
                    return this._secret;
                }, o(a, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), o(a, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), o(a, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), o(a, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), o(a, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), o(a, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), a.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, a.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, a.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, a.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, t.exports = a;
            },
            {
                "../utils": 419
            }
        ],
        417: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert, o = i.cachedProperty, a = i.parseBytes;
                function l(e, t) {
                    this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                o(l, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), o(l, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), o(l, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), o(l, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), l.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, l.prototype.toHex = function() {
                    return i.encode(this.toBytes(), "hex").toUpperCase();
                }, t.exports = l;
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        418: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            {}
        ],
        419: [
            function(e, t, r) {
                "use strict";
                var n = r, i = e("bn.js"), s = e("minimalistic-assert"), o = e("minimalistic-crypto-utils");
                n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, s = e.clone(), o = 0; o < n.length; o++){
                        var a, l = s.andln(i - 1);
                        s.isOdd() ? (a = l > (i >> 1) - 1 ? (i >> 1) - l : l, s.isubn(a)) : a = 0, n[o] = a, s.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, s = 0; e.cmpn(-i) > 0 || t.cmpn(-s) > 0;){
                        var o, a, l = e.andln(3) + i & 3, c = t.andln(3) + s & 3;
                        3 === l && (l = -1), 3 === c && (c = -1), o = 0 == (1 & l) ? 0 : 3 !== (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? l : -l, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 !== (n = t.andln(7) + s & 7) && 5 !== n || 2 !== l ? c : -c, r[1].push(a), 2 * i === o + 1 && (i = 1 - i), 2 * s === a + 1 && (s = 1 - s), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            {
                "bn.js": 420,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        420: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        421: [
            function(e, t, r) {
                t.exports = {
                    name: "elliptic",
                    version: "6.5.4",
                    description: "EC cryptography",
                    main: "lib/elliptic.js",
                    files: [
                        "lib"
                    ],
                    scripts: {
                        lint: "eslint lib test",
                        "lint:fix": "npm run lint -- --fix",
                        unit: "istanbul test _mocha --reporter=spec test/index.js",
                        test: "npm run lint && npm run unit",
                        version: "grunt dist && git add dist/"
                    },
                    repository: {
                        type: "git",
                        url: "git@github.com:indutny/elliptic"
                    },
                    keywords: [
                        "EC",
                        "Elliptic",
                        "curve",
                        "Cryptography"
                    ],
                    author: "Fedor Indutny <fedor@indutny.com>",
                    license: "MIT",
                    bugs: {
                        url: "https://github.com/indutny/elliptic/issues"
                    },
                    homepage: "https://github.com/indutny/elliptic",
                    devDependencies: {
                        brfs: "^2.0.2",
                        coveralls: "^3.1.0",
                        eslint: "^7.6.0",
                        grunt: "^1.2.1",
                        "grunt-browserify": "^5.3.0",
                        "grunt-cli": "^1.3.2",
                        "grunt-contrib-connect": "^3.0.0",
                        "grunt-contrib-copy": "^1.0.0",
                        "grunt-contrib-uglify": "^5.0.0",
                        "grunt-mocha-istanbul": "^5.0.2",
                        "grunt-saucelabs": "^9.0.1",
                        istanbul: "^0.4.5",
                        mocha: "^8.0.1"
                    },
                    dependencies: {
                        "bn.js": "^4.11.9",
                        brorand: "^1.1.0",
                        "hash.js": "^1.0.0",
                        "hmac-drbg": "^1.0.1",
                        inherits: "^2.0.4",
                        "minimalistic-assert": "^1.0.1",
                        "minimalistic-crypto-utils": "^1.0.1"
                    }
                };
            },
            {}
        ],
        422: [
            function(e, t, r) {
                "use strict";
                var n = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, s = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function o() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = n(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0;
                var a, l = 10;
                try {
                    var c = {};
                    Object.defineProperty && Object.defineProperty(c, "x", {
                        value: 0
                    }), a = 0 === c.x;
                } catch (e) {
                    a = !1;
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function h(e, t, r) {
                    if (t) e.call(r);
                    else for(var n = e.length, i = _(e, n), s = 0; s < n; ++s)i[s].call(r);
                }
                function f(e, t, r, n) {
                    if (t) e.call(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].call(r, n);
                }
                function d(e, t, r, n, i) {
                    if (t) e.call(r, n, i);
                    else for(var s = e.length, o = _(e, s), a = 0; a < s; ++a)o[a].call(r, n, i);
                }
                function p(e, t, r, n, i, s) {
                    if (t) e.call(r, n, i, s);
                    else for(var o = e.length, a = _(e, o), l = 0; l < o; ++l)a[l].call(r, n, i, s);
                }
                function m(e, t, r, n) {
                    if (t) e.apply(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].apply(r, n);
                }
                function b(e, t, r, i) {
                    var s, o, a;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]) : (o = e._events = n(null), e._eventsCount = 0), a) {
                        if ("function" == typeof a ? a = o[t] = i ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : i ? a.unshift(r) : a.push(r), !a.warned && (s = u(e)) && s > 0 && a.length > s) {
                            a.warned = !0;
                            var l = new Error("Possible EventEmitter memory leak detected. " + a.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                        }
                    } else a = o[t] = r, ++e._eventsCount;
                    return e;
                }
                function g() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function y(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = s.call(g, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function v(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : _(i, i.length) : [];
                }
                function w(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function _(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                a ? Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        l = e;
                    }
                }) : o.defaultMaxListeners = l, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    var t, r, n, i, s, o, a = "error" === e;
                    if (o = this._events) a = a && null == o.error;
                    else if (!a) return !1;
                    if (a) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var l = new Error('Unhandled "error" event. (' + t + ")");
                        throw l.context = t, l;
                    }
                    if (!(r = o[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            h(r, c, this);
                            break;
                        case 2:
                            f(r, c, this, arguments[1]);
                            break;
                        case 3:
                            d(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            p(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), s = 1; s < n; s++)i[s - 1] = arguments[s];
                            m(r, c, this, i);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return b(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return b(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, y(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, y(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, i, s, o, a;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(i = this._events)) return this;
                    if (!(r = i[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = n(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(s = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            a = r[o].listener, s = o;
                            break;
                        }
                        if (s < 0) return this;
                        0 === s ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, s), 1 === r.length && (i[e] = r[0]), i.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, o.prototype.removeAllListeners = function(e) {
                    var t, r, s;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = n(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = n(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, a = i(r);
                        for(s = 0; s < a.length; ++s)"removeListener" !== (o = a[s]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = n(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(s = t.length - 1; s >= 0; s--)this.removeListener(e, t[s]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return v(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return v(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : w.call(e, t);
                }, o.prototype.listenerCount = w, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            {}
        ],
        423: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("md5.js");
                t.exports = function(e, t, r, s) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var o = r / 8, a = n.alloc(o), l = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;){
                        var u = new i;
                        u.update(c), u.update(e), t && u.update(t), c = u.digest();
                        var h = 0;
                        if (o > 0) {
                            var f = a.length - o;
                            h = Math.min(o, c.length), c.copy(a, f, 0, h), o -= h;
                        }
                        if (h < c.length && s > 0) {
                            var d = l.length - s, p = Math.min(s, c.length - h);
                            c.copy(l, d, h, h + p), s -= p;
                        }
                    }
                    return c.fill(0), {
                        key: a,
                        iv: l
                    };
                };
            },
            {
                "md5.js": 450,
                "safe-buffer": 494
            }
        ],
        424: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CsvParserStream = r.ParserOptions = r.parseFile = r.parseStream = r.parseString = r.parse = r.FormatterOptions = r.CsvFormatterStream = r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = void 0;
                var n = e("@fast-csv/format");
                Object.defineProperty(r, "format", {
                    enumerable: !0,
                    get: function() {
                        return n.format;
                    }
                }), Object.defineProperty(r, "write", {
                    enumerable: !0,
                    get: function() {
                        return n.write;
                    }
                }), Object.defineProperty(r, "writeToStream", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToStream;
                    }
                }), Object.defineProperty(r, "writeToBuffer", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToBuffer;
                    }
                }), Object.defineProperty(r, "writeToString", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToString;
                    }
                }), Object.defineProperty(r, "writeToPath", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToPath;
                    }
                }), Object.defineProperty(r, "CsvFormatterStream", {
                    enumerable: !0,
                    get: function() {
                        return n.CsvFormatterStream;
                    }
                }), Object.defineProperty(r, "FormatterOptions", {
                    enumerable: !0,
                    get: function() {
                        return n.FormatterOptions;
                    }
                });
                var i = e("@fast-csv/parse");
                Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return i.parse;
                    }
                }), Object.defineProperty(r, "parseString", {
                    enumerable: !0,
                    get: function() {
                        return i.parseString;
                    }
                }), Object.defineProperty(r, "parseStream", {
                    enumerable: !0,
                    get: function() {
                        return i.parseStream;
                    }
                }), Object.defineProperty(r, "parseFile", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFile;
                    }
                }), Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return i.ParserOptions;
                    }
                }), Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return i.CsvParserStream;
                    }
                });
            },
            {
                "@fast-csv/format": 151,
                "@fast-csv/parse": 155
            }
        ],
        425: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("readable-stream").Transform;
                function s(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                e("inherits")(s, i), s.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, s.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, s.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
                    }(e, "Data"), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var s = this._blockOffset; s < this._blockSize;)r[s++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var o = 0, a = 8 * e.length; a > 0; ++o)this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
                    return this;
                }, s.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, s.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, s.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, t.exports = s;
            },
            {
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        426: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.utils = e("./hash/utils"), n.common = e("./hash/common"), n.sha = e("./hash/sha"), n.ripemd = e("./hash/ripemd"), n.hmac = e("./hash/hmac"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            {
                "./hash/common": 427,
                "./hash/hmac": 428,
                "./hash/ripemd": 429,
                "./hash/sha": 430,
                "./hash/utils": 437
            }
        ],
        427: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                r.BlockHash = s, s.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, s.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, s.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var s = 8; s < this.padLength; s++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++)n[i++] = 0;
                    return n;
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        428: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                t.exports = s, s.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, s.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, s.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        429: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("./common"), s = n.rotl32, o = n.sum32, a = n.sum32_3, l = n.sum32_4, c = i.BlockHash;
                function u() {
                    if (!(this instanceof u)) return new u;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function h(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function f(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function d(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(u, c), r.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, v = n, w = i, _ = c, x = u, k = 0; k < 80; k++){
                        var S = o(s(l(r, h(k, n, i, c), e[p[k] + t], f(k)), b[k]), u);
                        r = u, u = c, c = s(i, 10), i = n, n = S, S = o(s(l(y, h(79 - k, v, w, _), e[m[k] + t], d(k)), g[k]), x), y = x, x = _, _ = s(w, 10), w = v, v = S;
                    }
                    S = a(this.h[1], i, _), this.h[1] = a(this.h[2], c, x), this.h[2] = a(this.h[3], u, y), this.h[3] = a(this.h[4], r, v), this.h[4] = a(this.h[0], n, w), this.h[0] = S;
                }, u.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], m = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], b = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], g = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            {
                "./common": 427,
                "./utils": 437
            }
        ],
        430: [
            function(e, t, r) {
                "use strict";
                r.sha1 = e("./sha/1"), r.sha224 = e("./sha/224"), r.sha256 = e("./sha/256"), r.sha384 = e("./sha/384"), r.sha512 = e("./sha/512");
            },
            {
                "./sha/1": 431,
                "./sha/224": 432,
                "./sha/256": 433,
                "./sha/384": 434,
                "./sha/512": 435
            }
        ],
        431: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = n.rotl32, a = n.sum32, l = n.sum32_5, c = s.ft_1, u = i.BlockHash, h = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function f() {
                    if (!(this instanceof f)) return new f;
                    u.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(f, u), t.exports = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], s = this.h[1], u = this.h[2], f = this.h[3], d = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), m = l(o(i, 5), c(p, s, u, f), d, r[n], h[p]);
                        d = f, f = u, u = o(s, 30), s = i, i = m;
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], f), this.h[4] = a(this.h[4], d);
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436
            }
        ],
        432: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./256");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            {
                "../utils": 437,
                "./256": 433
            }
        ],
        433: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = e("minimalistic-assert"), a = n.sum32, l = n.sum32_4, c = n.sum32_5, u = s.ch32, h = s.maj32, f = s.s0_256, d = s.s1_256, p = s.g0_256, m = s.g1_256, b = i.BlockHash, g = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function y() {
                    if (!(this instanceof y)) return new y;
                    b.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = g, this.W = new Array(64);
                }
                n.inherits(y, b), t.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = l(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], s = this.h[1], b = this.h[2], g = this.h[3], y = this.h[4], v = this.h[5], w = this.h[6], _ = this.h[7];
                    for(o(this.k.length === r.length), n = 0; n < r.length; n++){
                        var x = c(_, d(y), u(y, v, w), this.k[n], r[n]), k = a(f(i), h(i, s, b));
                        _ = w, w = v, v = y, y = a(g, x), g = b, b = s, s = i, i = a(x, k);
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], b), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], y), this.h[5] = a(this.h[5], v), this.h[6] = a(this.h[6], w), this.h[7] = a(this.h[7], _);
                }, y.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436,
                "minimalistic-assert": 453
            }
        ],
        434: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./512");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            {
                "../utils": 437,
                "./512": 435
            }
        ],
        435: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("minimalistic-assert"), o = n.rotr64_hi, a = n.rotr64_lo, l = n.shr64_hi, c = n.shr64_lo, u = n.sum64, h = n.sum64_hi, f = n.sum64_lo, d = n.sum64_4_hi, p = n.sum64_4_lo, m = n.sum64_5_hi, b = n.sum64_5_lo, g = i.BlockHash, y = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function v() {
                    if (!(this instanceof v)) return new v;
                    g.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = y, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var s = e & r ^ ~e & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function _(e, t, r, n, i, s) {
                    var o = t & n ^ ~t & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function x(e, t, r, n, i) {
                    var s = e & r ^ e & i ^ r & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function k(e, t, r, n, i, s) {
                    var o = t & n ^ t & s ^ n & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function S(e, t) {
                    var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function M(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function C(e, t) {
                    var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function T(e, t) {
                    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function E(e, t) {
                    var r = o(e, t, 1) ^ o(e, t, 8) ^ l(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function A(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function R(e, t) {
                    var r = o(e, t, 19) ^ o(t, e, 29) ^ l(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(v, g), t.exports = v, v.blockSize = 1024, v.outSize = 512, v.hmacStrength = 192, v.padLength = 128, v.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = R(r[n - 4], r[n - 3]), s = O(r[n - 4], r[n - 3]), o = r[n - 14], a = r[n - 13], l = E(r[n - 30], r[n - 29]), c = A(r[n - 30], r[n - 29]), u = r[n - 32], h = r[n - 31];
                        r[n] = d(i, s, o, a, l, c, u, h), r[n + 1] = p(i, s, o, a, l, c, u, h);
                    }
                }, v.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r = this.W, n = this.h[0], i = this.h[1], o = this.h[2], a = this.h[3], l = this.h[4], c = this.h[5], d = this.h[6], p = this.h[7], g = this.h[8], y = this.h[9], v = this.h[10], E = this.h[11], A = this.h[12], R = this.h[13], O = this.h[14], j = this.h[15];
                    s(this.k.length === r.length);
                    for(var I = 0; I < r.length; I += 2){
                        var N = O, P = j, B = C(g, y), D = T(g, y), F = w(g, y, v, E, A), L = _(g, y, v, E, A, R), z = this.k[I], U = this.k[I + 1], $ = r[I], H = r[I + 1], V = m(N, P, B, D, F, L, z, U, $, H), q = b(N, P, B, D, F, L, z, U, $, H);
                        N = S(n, i), P = M(n, i), B = x(n, i, o, a, l), D = k(n, i, o, a, l, c);
                        var W = h(N, P, B, D), X = f(N, P, B, D);
                        O = A, j = R, A = v, R = E, v = g, E = y, g = h(d, p, V, q), y = f(p, p, V, q), d = l, p = c, l = o, c = a, o = n, a = i, n = h(V, q, W, X), i = f(V, q, W, X);
                    }
                    u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, l, c), u(this.h, 6, d, p), u(this.h, 8, g, y), u(this.h, 10, v, E), u(this.h, 12, A, R), u(this.h, 14, O, j);
                }, v.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "minimalistic-assert": 453
            }
        ],
        436: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils").rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function s(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function o(e, t, r) {
                    return e ^ t ^ r;
                }
                r.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
                }, r.ch32 = i, r.maj32 = s, r.p32 = o, r.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, r.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, r.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, r.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            {
                "../utils": 437
            }
        ],
        437: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits");
                function s(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function o(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function a(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function l(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                r.inherits = i, r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var o = e.charCodeAt(i);
                            o < 128 ? r[n++] = o : o < 2048 ? (r[n++] = o >> 6 | 192, r[n++] = 63 & o | 128) : s(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = o >> 18 | 240, r[n++] = o >> 12 & 63 | 128, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128) : (r[n++] = o >> 12 | 224, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, r.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += a(e[r].toString(16));
                    return t;
                }, r.htonl = o, r.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = o(i)), r += l(i.toString(16));
                    }
                    return r;
                }, r.zero2 = a, r.zero8 = l, r.join32 = function(e, t, r, i) {
                    var s = r - t;
                    n(s % 4 == 0);
                    for(var o = new Array(s / 4), a = 0, l = t; a < o.length; a++, l += 4){
                        var c;
                        c = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], o[a] = c >>> 0;
                    }
                    return o;
                }, r.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var s = e[n];
                        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
                    }
                    return r;
                }, r.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, r.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, r.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, r.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, r.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, r.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, r.sum64 = function(e, t, r, n) {
                    var i = e[t], s = n + e[t + 1] >>> 0, o = (s < n ? 1 : 0) + r + i;
                    e[t] = o >>> 0, e[t + 1] = s;
                }, r.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, r.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, r.sum64_4_hi = function(e, t, r, n, i, s, o, a) {
                    var l = 0, c = t;
                    return l += (c = c + n >>> 0) < t ? 1 : 0, l += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (l += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
                }, r.sum64_4_lo = function(e, t, r, n, i, s, o, a) {
                    return t + n + s + a >>> 0;
                }, r.sum64_5_hi = function(e, t, r, n, i, s, o, a, l, c) {
                    var u = 0, h = t;
                    return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + l + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
                }, r.sum64_5_lo = function(e, t, r, n, i, s, o, a, l, c) {
                    return t + n + s + a + c >>> 0;
                }, r.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, r.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, r.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, r.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        438: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("minimalistic-crypto-utils"), s = e("minimalistic-assert");
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                t.exports = o, o.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, o.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, o.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, o.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, o.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var s = []; s.length < e;)this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
                    var o = s.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(o, t);
                };
            },
            {
                "hash.js": 426,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        439: [
            function(e, t, r) {
                "use strict";
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ r.read = function(e, t, r, n, i) {
                    var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, d = e[t + h];
                    for(h += f, s = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += f, u -= 8);
                    for(o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
                    if (0 === s) s = 1 - c;
                    else {
                        if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                        o += Math.pow(2, n), s -= c;
                    }
                    return (d ? -1 : 1) * o * Math.pow(2, s - n);
                }, r.write = function(e, t, r, n, i, s) {
                    var o, a, l, c = 8 * s - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : s - 1, p = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & a, d += p, a /= 256, i -= 8);
                    for(o = o << i | a, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
                    e[r + d - p] |= 128 * m;
                };
            },
            {}
        ],
        440: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        441: [
            function(e, t, r) {
                (function(n, i, s, o, a, l, c, u) {
                    (function() {
                        "use strict";
                        /*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ !function(e) {
                            "object" == typeof r && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                        }(function() {
                            return (function t(r, n, i) {
                                function s(a, l) {
                                    if (!n[a]) {
                                        if (!r[a]) {
                                            var c = "function" == typeof e && e;
                                            if (!l && c) return c(a, !0);
                                            if (o) return o(a, !0);
                                            var u = new Error("Cannot find module '" + a + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var h = n[a] = {
                                            exports: {}
                                        };
                                        r[a][0].call(h.exports, function(e) {
                                            return s(r[a][1][e] || e);
                                        }, h, h.exports, t, r, n, i);
                                    }
                                    return n[a].exports;
                                }
                                for(var o = "function" == typeof e && e, a = 0; a < i.length; a++)s(i[a]);
                                return s;
                            })({
                                1: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./support"), s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                        r.encode = function(e) {
                                            for(var t, r, i, o, a, l, c, u = [], h = 0, f = e.length, d = f, p = "string" !== n.getTypeOf(e); h < e.length;)d = f - h, i = p ? (t = e[h++], r = h < f ? e[h++] : 0, h < f ? e[h++] : 0) : (t = e.charCodeAt(h++), r = h < f ? e.charCodeAt(h++) : 0, h < f ? e.charCodeAt(h++) : 0), o = t >> 2, a = (3 & t) << 4 | r >> 4, l = 1 < d ? (15 & r) << 2 | i >> 6 : 64, c = 2 < d ? 63 & i : 64, u.push(s.charAt(o) + s.charAt(a) + s.charAt(l) + s.charAt(c));
                                            return u.join("");
                                        }, r.decode = function(e) {
                                            var t, r, n, o, a, l, c = 0, u = 0, h = "data:";
                                            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
                                            var f, d = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                            if (e.charAt(e.length - 1) === s.charAt(64) && d--, e.charAt(e.length - 2) === s.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                            for(f = i.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < e.length;)t = s.indexOf(e.charAt(c++)) << 2 | (o = s.indexOf(e.charAt(c++))) >> 4, r = (15 & o) << 4 | (a = s.indexOf(e.charAt(c++))) >> 2, n = (3 & a) << 6 | (l = s.indexOf(e.charAt(c++))), f[u++] = t, 64 !== a && (f[u++] = r), 64 !== l && (f[u++] = n);
                                            return f;
                                        };
                                    },
                                    {
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                2: [
                                    function(e, t, r) {
                                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), o = e("./stream/DataLengthProbe");
                                        function a(e, t, r, n, i) {
                                            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                                        }
                                        a.prototype = {
                                            getContentWorker: function() {
                                                var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), t = this;
                                                return e.on("end", function() {
                                                    if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                }), e;
                                            },
                                            getCompressedWorker: function() {
                                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                            }
                                        }, a.createWorkerFrom = function(e, t, r) {
                                            return e.pipe(new s).pipe(new o("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
                                        }, t.exports = a;
                                    },
                                    {
                                        "./external": 6,
                                        "./stream/Crc32Probe": 25,
                                        "./stream/DataLengthProbe": 26,
                                        "./stream/DataWorker": 27
                                    }
                                ],
                                3: [
                                    function(e, t, r) {
                                        var n = e("./stream/GenericWorker");
                                        r.STORE = {
                                            magic: "\0\0",
                                            compressWorker: function() {
                                                return new n("STORE compression");
                                            },
                                            uncompressWorker: function() {
                                                return new n("STORE decompression");
                                            }
                                        }, r.DEFLATE = e("./flate");
                                    },
                                    {
                                        "./flate": 7,
                                        "./stream/GenericWorker": 28
                                    }
                                ],
                                4: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t) {
                                            return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t.charCodeAt(a))];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : 0;
                                        };
                                    },
                                    {
                                        "./utils": 32
                                    }
                                ],
                                5: [
                                    function(e, t, r) {
                                        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                                    },
                                    {}
                                ],
                                6: [
                                    function(e, t, r) {
                                        var n;
                                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                            Promise: n
                                        };
                                    },
                                    {
                                        lie: 37
                                    }
                                ],
                                7: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), o = e("./stream/GenericWorker"), a = n ? "uint8array" : "array";
                                        function l(e, t) {
                                            o.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                        }
                                        r.magic = "\b\0", s.inherits(l, o), l.prototype.processChunk = function(e) {
                                            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(a, e.data), !1);
                                        }, l.prototype.flush = function() {
                                            o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                        }, l.prototype.cleanUp = function() {
                                            o.prototype.cleanUp.call(this), this._pako = null;
                                        }, l.prototype._createPako = function() {
                                            this._pako = new i[this._pakoAction]({
                                                raw: !0,
                                                level: this._pakoOptions.level || -1
                                            });
                                            var e = this;
                                            this._pako.onData = function(t) {
                                                e.push({
                                                    data: t,
                                                    meta: e.meta
                                                });
                                            };
                                        }, r.compressWorker = function(e) {
                                            return new l("Deflate", e);
                                        }, r.uncompressWorker = function() {
                                            return new l("Inflate", {});
                                        };
                                    },
                                    {
                                        "./stream/GenericWorker": 28,
                                        "./utils": 32,
                                        pako: 38
                                    }
                                ],
                                8: [
                                    function(e, t, r) {
                                        function n(e, t) {
                                            var r, n = "";
                                            for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                                            return n;
                                        }
                                        function i(e, t, r, i, o, u) {
                                            var h, f, d = e.file, p = e.compression, m = u !== a.utf8encode, b = s.transformTo("string", u(d.name)), g = s.transformTo("string", a.utf8encode(d.name)), y = d.comment, v = s.transformTo("string", u(y)), w = s.transformTo("string", a.utf8encode(y)), _ = g.length !== d.name.length, x = w.length !== y.length, k = "", S = "", M = "", C = d.dir, T = d.date, E = {
                                                crc32: 0,
                                                compressedSize: 0,
                                                uncompressedSize: 0
                                            };
                                            t && !r || (E.crc32 = e.crc32, E.compressedSize = e.compressedSize, E.uncompressedSize = e.uncompressedSize);
                                            var A = 0;
                                            t && (A |= 8), m || !_ && !x || (A |= 2048);
                                            var R = 0, O = 0;
                                            C && (R |= 16), "UNIX" === o ? (O = 798, R |= function(e, t) {
                                                var r = e;
                                                return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                                            }(d.unixPermissions, C)) : (O = 20, R |= function(e) {
                                                return 63 & (e || 0);
                                            }(d.dosPermissions)), h = T.getUTCHours(), h <<= 6, h |= T.getUTCMinutes(), h <<= 5, h |= T.getUTCSeconds() / 2, f = T.getUTCFullYear() - 1980, f <<= 4, f |= T.getUTCMonth() + 1, f <<= 5, f |= T.getUTCDate(), _ && (S = n(1, 1) + n(l(b), 4) + g, k += "up" + n(S.length, 2) + S), x && (M = n(1, 1) + n(l(v), 4) + w, k += "uc" + n(M.length, 2) + M);
                                            var j = "";
                                            return j += "\n\0", j += n(A, 2), j += p.magic, j += n(h, 2), j += n(f, 2), j += n(E.crc32, 4), j += n(E.compressedSize, 4), j += n(E.uncompressedSize, 4), j += n(b.length, 2), j += n(k.length, 2), {
                                                fileRecord: c.LOCAL_FILE_HEADER + j + b + k,
                                                dirRecord: c.CENTRAL_FILE_HEADER + n(O, 2) + j + n(v.length, 2) + "\0\0\0\0" + n(R, 4) + n(i, 4) + b + k + v
                                            };
                                        }
                                        var s = e("../utils"), o = e("../stream/GenericWorker"), a = e("../utf8"), l = e("../crc32"), c = e("../signature");
                                        function u(e, t, r, n) {
                                            o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                        }
                                        s.inherits(u, o), u.prototype.push = function(e) {
                                            var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                                            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
                                                data: e.data,
                                                meta: {
                                                    currentFile: this.currentFile,
                                                    percent: r ? (t + 100 * (r - n - 1)) / r : 100
                                                }
                                            }));
                                        }, u.prototype.openedSource = function(e) {
                                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                            var t = this.streamFiles && !e.file.dir;
                                            if (t) {
                                                var r = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                this.push({
                                                    data: r.fileRecord,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            } else this.accumulate = !0;
                                        }, u.prototype.closedSource = function(e) {
                                            this.accumulate = !1;
                                            var t = this.streamFiles && !e.file.dir, r = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                            if (this.dirRecords.push(r.dirRecord), t) this.push({
                                                data: function(e) {
                                                    return c.DATA_DESCRIPTOR + n(e.crc32, 4) + n(e.compressedSize, 4) + n(e.uncompressedSize, 4);
                                                }(e),
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            else for(this.push({
                                                data: r.fileRecord,
                                                meta: {
                                                    percent: 0
                                                }
                                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                            this.currentFile = null;
                                        }, u.prototype.flush = function() {
                                            for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                                                data: this.dirRecords[t],
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            var r = this.bytesWritten - e, i = function(e, t, r, i, o) {
                                                var a = s.transformTo("string", o(i));
                                                return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(e, 2) + n(e, 2) + n(t, 4) + n(r, 4) + n(a.length, 2) + a;
                                            }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                                            this.push({
                                                data: i,
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                        }, u.prototype.prepareNextSource = function() {
                                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                        }, u.prototype.registerPrevious = function(e) {
                                            this._sources.push(e);
                                            var t = this;
                                            return e.on("data", function(e) {
                                                t.processChunk(e);
                                            }), e.on("end", function() {
                                                t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                            }), e.on("error", function(e) {
                                                t.error(e);
                                            }), this;
                                        }, u.prototype.resume = function() {
                                            return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                        }, u.prototype.error = function(e) {
                                            var t = this._sources;
                                            if (!o.prototype.error.call(this, e)) return !1;
                                            for(var r = 0; r < t.length; r++)try {
                                                t[r].error(e);
                                            } catch (e) {}
                                            return !0;
                                        }, u.prototype.lock = function() {
                                            o.prototype.lock.call(this);
                                            for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                                        }, t.exports = u;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../signature": 23,
                                        "../stream/GenericWorker": 28,
                                        "../utf8": 31,
                                        "../utils": 32
                                    }
                                ],
                                9: [
                                    function(e, t, r) {
                                        var n = e("../compressions"), i = e("./ZipFileWorker");
                                        r.generateWorker = function(e, t, r) {
                                            var s = new i(t.streamFiles, r, t.platform, t.encodeFileName), o = 0;
                                            try {
                                                e.forEach(function(e, r) {
                                                    o++;
                                                    var i = function(e, t) {
                                                        var r = e || t, i = n[r];
                                                        if (!i) throw new Error(r + " is not a valid compression method !");
                                                        return i;
                                                    }(r.options.compression, t.compression), a = r.options.compressionOptions || t.compressionOptions || {}, l = r.dir, c = r.date;
                                                    r._compressWorker(i, a).withStreamInfo("file", {
                                                        name: e,
                                                        dir: l,
                                                        date: c,
                                                        comment: r.comment || "",
                                                        unixPermissions: r.unixPermissions,
                                                        dosPermissions: r.dosPermissions
                                                    }).pipe(s);
                                                }), s.entriesCount = o;
                                            } catch (e) {
                                                s.error(e);
                                            }
                                            return s;
                                        };
                                    },
                                    {
                                        "../compressions": 3,
                                        "./ZipFileWorker": 8
                                    }
                                ],
                                10: [
                                    function(e, t, r) {
                                        function n() {
                                            if (!(this instanceof n)) return new n;
                                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                                var e = new n;
                                                for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                                                return e;
                                            };
                                        }
                                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                                            return (new n).loadAsync(e, t);
                                        }, n.external = e("./external"), t.exports = n;
                                    },
                                    {
                                        "./defaults": 5,
                                        "./external": 6,
                                        "./load": 11,
                                        "./object": 15,
                                        "./support": 30
                                    }
                                ],
                                11: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./external"), s = e("./utf8"), o = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                                        function c(e) {
                                            return new i.Promise(function(t, r) {
                                                var n = e.decompressed.getContentWorker().pipe(new a);
                                                n.on("error", function(e) {
                                                    r(e);
                                                }).on("end", function() {
                                                    n.streamInfo.crc32 !== e.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                }).resume();
                                            });
                                        }
                                        t.exports = function(e, t) {
                                            var r = this;
                                            return t = n.extend(t || {}, {
                                                base64: !1,
                                                checkCRC32: !1,
                                                optimizedBinaryString: !1,
                                                createFolders: !1,
                                                decodeFileName: s.utf8decode
                                            }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(e) {
                                                var r = new o(t);
                                                return r.load(e), r;
                                            }).then(function(e) {
                                                var r = [
                                                    i.Promise.resolve(e)
                                                ], n = e.files;
                                                if (t.checkCRC32) for(var s = 0; s < n.length; s++)r.push(c(n[s]));
                                                return i.Promise.all(r);
                                            }).then(function(e) {
                                                for(var i = e.shift(), s = i.files, o = 0; o < s.length; o++){
                                                    var a = s[o], l = a.fileNameStr, c = n.resolve(a.fileNameStr);
                                                    r.file(c, a.decompressed, {
                                                        binary: !0,
                                                        optimizedBinaryString: !0,
                                                        date: a.date,
                                                        dir: a.dir,
                                                        comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                        unixPermissions: a.unixPermissions,
                                                        dosPermissions: a.dosPermissions,
                                                        createFolders: t.createFolders
                                                    }), a.dir || (r.file(c).unsafeOriginalName = l);
                                                }
                                                return i.zipComment.length && (r.comment = i.zipComment), r;
                                            });
                                        };
                                    },
                                    {
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./stream/Crc32Probe": 25,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipEntries": 33
                                    }
                                ],
                                12: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../stream/GenericWorker");
                                        function s(e, t) {
                                            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                        }
                                        n.inherits(s, i), s.prototype._bindStream = function(e) {
                                            var t = this;
                                            (this._stream = e).pause(), e.on("data", function(e) {
                                                t.push({
                                                    data: e,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            }).on("error", function(e) {
                                                t.isPaused ? this.generatedError = e : t.error(e);
                                            }).on("end", function() {
                                                t.isPaused ? t._upstreamEnded = !0 : t.end();
                                            });
                                        }, s.prototype.pause = function() {
                                            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../stream/GenericWorker": 28,
                                        "../utils": 32
                                    }
                                ],
                                13: [
                                    function(e, t, r) {
                                        var n = e("readable-stream").Readable;
                                        function i(e, t, r) {
                                            n.call(this, t), this._helper = e;
                                            var i = this;
                                            e.on("data", function(e, t) {
                                                i.push(e) || i._helper.pause(), r && r(t);
                                            }).on("error", function(e) {
                                                i.emit("error", e);
                                            }).on("end", function() {
                                                i.push(null);
                                            });
                                        }
                                        e("../utils").inherits(i, n), i.prototype._read = function() {
                                            this._helper.resume();
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "readable-stream": 16
                                    }
                                ],
                                14: [
                                    function(e, t, r) {
                                        t.exports = {
                                            isNode: void 0 !== s,
                                            newBufferFrom: function(e, t) {
                                                if (s.from && s.from !== Uint8Array.from) return s.from(e, t);
                                                if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                return new s(e, t);
                                            },
                                            allocBuffer: function(e) {
                                                if (s.alloc) return s.alloc(e);
                                                var t = new s(e);
                                                return t.fill(0), t;
                                            },
                                            isBuffer: function(e) {
                                                return s.isBuffer(e);
                                            },
                                            isStream: function(e) {
                                                return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                15: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            var n, i = s.getTypeOf(t), a = s.extend(r || {}, l);
                                            a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (e = m(e)), a.createFolders && (n = p(e)) && b.call(this, n, !0);
                                            var h = "string" === i && !1 === a.binary && !1 === a.base64;
                                            r && void 0 !== r.binary || (a.binary = !h), (t instanceof c && 0 === t.uncompressedSize || a.dir || !t || 0 === t.length) && (a.base64 = !1, a.binary = !0, t = "", a.compression = "STORE", i = "string");
                                            var g;
                                            g = t instanceof c || t instanceof o ? t : f.isNode && f.isStream(t) ? new d(e, t) : s.prepareContent(e, t, a.binary, a.optimizedBinaryString, a.base64);
                                            var y = new u(e, g, a);
                                            this.files[e] = y;
                                        }
                                        var i = e("./utf8"), s = e("./utils"), o = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), l = e("./defaults"), c = e("./compressedObject"), u = e("./zipObject"), h = e("./generate"), f = e("./nodejsUtils"), d = e("./nodejs/NodejsStreamInputAdapter"), p = function(e) {
                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                            var t = e.lastIndexOf("/");
                                            return 0 < t ? e.substring(0, t) : "";
                                        }, m = function(e) {
                                            return "/" !== e.slice(-1) && (e += "/"), e;
                                        }, b = function(e, t) {
                                            return t = void 0 !== t ? t : l.createFolders, e = m(e), this.files[e] || n.call(this, e, null, {
                                                dir: !0,
                                                createFolders: t
                                            }), this.files[e];
                                        };
                                        function g(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }
                                        var y = {
                                            load: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            forEach: function(e) {
                                                var t, r, n;
                                                for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                                            },
                                            filter: function(e) {
                                                var t = [];
                                                return this.forEach(function(r, n) {
                                                    e(r, n) && t.push(n);
                                                }), t;
                                            },
                                            file: function(e, t, r) {
                                                if (1 !== arguments.length) return e = this.root + e, n.call(this, e, t, r), this;
                                                if (g(e)) {
                                                    var i = e;
                                                    return this.filter(function(e, t) {
                                                        return !t.dir && i.test(e);
                                                    });
                                                }
                                                var s = this.files[this.root + e];
                                                return s && !s.dir ? s : null;
                                            },
                                            folder: function(e) {
                                                if (!e) return this;
                                                if (g(e)) return this.filter(function(t, r) {
                                                    return r.dir && e.test(t);
                                                });
                                                var t = this.root + e, r = b.call(this, t), n = this.clone();
                                                return n.root = r.name, n;
                                            },
                                            remove: function(e) {
                                                e = this.root + e;
                                                var t = this.files[e];
                                                if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];
                                                else for(var r = this.filter(function(t, r) {
                                                    return r.name.slice(0, e.length) === e;
                                                }), n = 0; n < r.length; n++)delete this.files[r[n].name];
                                                return this;
                                            },
                                            generate: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            generateInternalStream: function(e) {
                                                var t, r = {};
                                                try {
                                                    if ((r = s.extend(e || {}, {
                                                        streamFiles: !1,
                                                        compression: "STORE",
                                                        compressionOptions: null,
                                                        type: "",
                                                        platform: "DOS",
                                                        comment: null,
                                                        mimeType: "application/zip",
                                                        encodeFileName: i.utf8encode
                                                    })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                                                    s.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                                                    var n = r.comment || this.comment || "";
                                                    t = h.generateWorker(this, r, n);
                                                } catch (e) {
                                                    (t = new o("error")).error(e);
                                                }
                                                return new a(t, r.type || "string", r.mimeType);
                                            },
                                            generateAsync: function(e, t) {
                                                return this.generateInternalStream(e).accumulate(t);
                                            },
                                            generateNodeStream: function(e, t) {
                                                return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                            }
                                        };
                                        t.exports = y;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./defaults": 5,
                                        "./generate": 9,
                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipObject": 35
                                    }
                                ],
                                16: [
                                    function(e, t, r) {
                                        t.exports = e("stream");
                                    },
                                    {
                                        stream: void 0
                                    }
                                ],
                                17: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                            for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data[this.zero + e];
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                                            return -1;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                                            return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                                        }, i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return [];
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                18: [
                                    function(e, t, r) {
                                        var n = e("../utils");
                                        function i(e) {
                                            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                        }
                                        i.prototype = {
                                            checkOffset: function(e) {
                                                this.checkIndex(this.index + e);
                                            },
                                            checkIndex: function(e) {
                                                if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                            },
                                            setIndex: function(e) {
                                                this.checkIndex(e), this.index = e;
                                            },
                                            skip: function(e) {
                                                this.setIndex(this.index + e);
                                            },
                                            byteAt: function() {},
                                            readInt: function(e) {
                                                var t, r = 0;
                                                for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                                                return this.index += e, r;
                                            },
                                            readString: function(e) {
                                                return n.transformTo("string", this.readData(e));
                                            },
                                            readData: function() {},
                                            lastIndexOfSignature: function() {},
                                            readAndCheckSignature: function() {},
                                            readDate: function() {
                                                var e = this.readInt(4);
                                                return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                            }
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32
                                    }
                                ],
                                19: [
                                    function(e, t, r) {
                                        var n = e("./Uint8ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                20: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data.charCodeAt(this.zero + e);
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            return this.data.lastIndexOf(e) - this.zero;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            return e === this.readData(4);
                                        }, i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                21: [
                                    function(e, t, r) {
                                        var n = e("./ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./ArrayReader": 17
                                    }
                                ],
                                22: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), o = e("./StringReader"), a = e("./NodeBufferReader"), l = e("./Uint8ArrayReader");
                                        t.exports = function(e) {
                                            var t = n.getTypeOf(e);
                                            return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new a(e) : i.uint8array ? new l(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new o(e);
                                        };
                                    },
                                    {
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ArrayReader": 17,
                                        "./NodeBufferReader": 19,
                                        "./StringReader": 20,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                23: [
                                    function(e, t, r) {
                                        r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
                                    },
                                    {}
                                ],
                                24: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../utils");
                                        function s(e) {
                                            n.call(this, "ConvertWorker to " + e), this.destType = e;
                                        }
                                        i.inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.push({
                                                data: i.transformTo(this.destType, e.data),
                                                meta: e.meta
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                25: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../crc32");
                                        function s() {
                                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                        }
                                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                26: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                        }
                                        n.inherits(s, i), s.prototype.processChunk = function(e) {
                                            if (e) {
                                                var t = this.streamInfo[this.propName] || 0;
                                                this.streamInfo[this.propName] = t + e.data.length;
                                            }
                                            i.prototype.processChunk.call(this, e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                27: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataWorker");
                                            var t = this;
                                            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                                                t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                            }, function(e) {
                                                t.error(e);
                                            });
                                        }
                                        n.inherits(s, i), s.prototype.cleanUp = function() {
                                            i.prototype.cleanUp.call(this), this.data = null;
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                                        }, s.prototype._tickAndRepeat = function() {
                                            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                        }, s.prototype._tick = function() {
                                            if (this.isPaused || this.isFinished) return !1;
                                            var e = null, t = Math.min(this.max, this.index + 16384);
                                            if (this.index >= this.max) return this.end();
                                            switch(this.type){
                                                case "string":
                                                    e = this.data.substring(this.index, t);
                                                    break;
                                                case "uint8array":
                                                    e = this.data.subarray(this.index, t);
                                                    break;
                                                case "array":
                                                case "nodebuffer":
                                                    e = this.data.slice(this.index, t);
                                            }
                                            return this.index = t, this.push({
                                                data: e,
                                                meta: {
                                                    percent: this.max ? this.index / this.max * 100 : 0
                                                }
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                28: [
                                    function(e, t, r) {
                                        function n(e) {
                                            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                data: [],
                                                end: [],
                                                error: []
                                            }, this.previous = null;
                                        }
                                        n.prototype = {
                                            push: function(e) {
                                                this.emit("data", e);
                                            },
                                            end: function() {
                                                if (this.isFinished) return !1;
                                                this.flush();
                                                try {
                                                    this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                } catch (e) {
                                                    this.emit("error", e);
                                                }
                                                return !0;
                                            },
                                            error: function(e) {
                                                return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                            },
                                            on: function(e, t) {
                                                return this._listeners[e].push(t), this;
                                            },
                                            cleanUp: function() {
                                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                            },
                                            emit: function(e, t) {
                                                if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                                            },
                                            pipe: function(e) {
                                                return e.registerPrevious(this);
                                            },
                                            registerPrevious: function(e) {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                var t = this;
                                                return e.on("data", function(e) {
                                                    t.processChunk(e);
                                                }), e.on("end", function() {
                                                    t.end();
                                                }), e.on("error", function(e) {
                                                    t.error(e);
                                                }), this;
                                            },
                                            pause: function() {
                                                return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                            },
                                            resume: function() {
                                                if (!this.isPaused || this.isFinished) return !1;
                                                var e = this.isPaused = !1;
                                                return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                            },
                                            flush: function() {},
                                            processChunk: function(e) {
                                                this.push(e);
                                            },
                                            withStreamInfo: function(e, t) {
                                                return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                            },
                                            mergeStreamInfo: function() {
                                                for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                            },
                                            lock: function() {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.isLocked = !0, this.previous && this.previous.lock();
                                            },
                                            toString: function() {
                                                var e = "Worker " + this.name;
                                                return this.previous ? this.previous + " -> " + e : e;
                                            }
                                        }, t.exports = n;
                                    },
                                    {}
                                ],
                                29: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./ConvertWorker"), o = e("./GenericWorker"), a = e("../base64"), l = e("../support"), c = e("../external"), u = null;
                                        if (l.nodestream) try {
                                            u = e("../nodejs/NodejsStreamOutputAdapter");
                                        } catch (e) {}
                                        function h(e, t, r) {
                                            var s = t;
                                            switch(t){
                                                case "blob":
                                                case "arraybuffer":
                                                    s = "uint8array";
                                                    break;
                                                case "base64":
                                                    s = "string";
                                            }
                                            try {
                                                this._internalType = s, this._outputType = t, this._mimeType = r, n.checkSupport(s), this._worker = e.pipe(new i(s)), e.lock();
                                            } catch (e) {
                                                this._worker = new o("error"), this._worker.error(e);
                                            }
                                        }
                                        h.prototype = {
                                            accumulate: function(e) {
                                                return function(e, t) {
                                                    return new c.Promise(function(r, i) {
                                                        var o = [], l = e._internalType, c = e._outputType, u = e._mimeType;
                                                        e.on("data", function(e, r) {
                                                            o.push(e), t && t(r);
                                                        }).on("error", function(e) {
                                                            o = [], i(e);
                                                        }).on("end", function() {
                                                            try {
                                                                var e = function(e, t, r) {
                                                                    switch(e){
                                                                        case "blob":
                                                                            return n.newBlob(n.transformTo("arraybuffer", t), r);
                                                                        case "base64":
                                                                            return a.encode(t);
                                                                        default:
                                                                            return n.transformTo(e, t);
                                                                    }
                                                                }(c, function(e, t) {
                                                                    var r, n = 0, i = null, o = 0;
                                                                    for(r = 0; r < t.length; r++)o += t[r].length;
                                                                    switch(e){
                                                                        case "string":
                                                                            return t.join("");
                                                                        case "array":
                                                                            return Array.prototype.concat.apply([], t);
                                                                        case "uint8array":
                                                                            for(i = new Uint8Array(o), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                                                            return i;
                                                                        case "nodebuffer":
                                                                            return s.concat(t);
                                                                        default:
                                                                            throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                }(l, o), u);
                                                                r(e);
                                                            } catch (e) {
                                                                i(e);
                                                            }
                                                            o = [];
                                                        }).resume();
                                                    });
                                                }(this, e);
                                            },
                                            on: function(e, t) {
                                                var r = this;
                                                return "data" === e ? this._worker.on(e, function(e) {
                                                    t.call(r, e.data, e.meta);
                                                }) : this._worker.on(e, function() {
                                                    n.delay(t, arguments, r);
                                                }), this;
                                            },
                                            resume: function() {
                                                return n.delay(this._worker.resume, [], this._worker), this;
                                            },
                                            pause: function() {
                                                return this._worker.pause(), this;
                                            },
                                            toNodejsStream: function(e) {
                                                if (n.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                return new u(this, {
                                                    objectMode: "nodebuffer" !== this._outputType
                                                }, e);
                                            }
                                        }, t.exports = h;
                                    },
                                    {
                                        "../base64": 1,
                                        "../external": 6,
                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ConvertWorker": 24,
                                        "./GenericWorker": 28
                                    }
                                ],
                                30: [
                                    function(e, t, r) {
                                        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== s, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                                        else {
                                            var n = new ArrayBuffer(0);
                                            try {
                                                r.blob = 0 === new Blob([
                                                    n
                                                ], {
                                                    type: "application/zip"
                                                }).size;
                                            } catch (e) {
                                                try {
                                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                                } catch (e) {
                                                    r.blob = !1;
                                                }
                                            }
                                        }
                                        try {
                                            r.nodestream = !!e("readable-stream").Readable;
                                        } catch (e) {
                                            r.nodestream = !1;
                                        }
                                    },
                                    {
                                        "readable-stream": 16
                                    }
                                ],
                                31: [
                                    function(e, t, r) {
                                        for(var n = e("./utils"), i = e("./support"), s = e("./nodejsUtils"), o = e("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                                        function c() {
                                            o.call(this, "utf-8 decode"), this.leftOver = null;
                                        }
                                        function u() {
                                            o.call(this, "utf-8 encode");
                                        }
                                        a[254] = a[254] = 1, r.utf8encode = function(e) {
                                            return i.nodebuffer ? s.newBufferFrom(e, "utf-8") : function(e) {
                                                var t, r, n, s, o, a = e.length, l = 0;
                                                for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                                for(t = i.uint8array ? new Uint8Array(l) : new Array(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                                return t;
                                            }(e);
                                        }, r.utf8decode = function(e) {
                                            return i.nodebuffer ? n.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                                                var t, r, i, s, o = e.length, l = new Array(2 * o);
                                                for(t = r = 0; t < o;)if ((i = e[t++]) < 128) l[r++] = i;
                                                else if (4 < (s = a[i])) l[r++] = 65533, t += s - 1;
                                                else {
                                                    for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && t < o;)i = i << 6 | 63 & e[t++], s--;
                                                    1 < s ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                }
                                                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
                                            }(e = n.transformTo(i.uint8array ? "uint8array" : "array", e));
                                        }, n.inherits(c, o), c.prototype.processChunk = function(e) {
                                            var t = n.transformTo(i.uint8array ? "uint8array" : "array", e.data);
                                            if (this.leftOver && this.leftOver.length) {
                                                if (i.uint8array) {
                                                    var s = t;
                                                    (t = new Uint8Array(s.length + this.leftOver.length)).set(this.leftOver, 0), t.set(s, this.leftOver.length);
                                                } else t = this.leftOver.concat(t);
                                                this.leftOver = null;
                                            }
                                            var o = function(e, t) {
                                                var r;
                                                for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                                return r < 0 || 0 === r ? t : r + a[e[r]] > t ? r : t;
                                            }(t), l = t;
                                            o !== t.length && (i.uint8array ? (l = t.subarray(0, o), this.leftOver = t.subarray(o, t.length)) : (l = t.slice(0, o), this.leftOver = t.slice(o, t.length))), this.push({
                                                data: r.utf8decode(l),
                                                meta: e.meta
                                            });
                                        }, c.prototype.flush = function() {
                                            this.leftOver && this.leftOver.length && (this.push({
                                                data: r.utf8decode(this.leftOver),
                                                meta: {}
                                            }), this.leftOver = null);
                                        }, r.Utf8DecodeWorker = c, n.inherits(u, o), u.prototype.processChunk = function(e) {
                                            this.push({
                                                data: r.utf8encode(e.data),
                                                meta: e.meta
                                            });
                                        }, r.Utf8EncodeWorker = u;
                                    },
                                    {
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                32: [
                                    function(e, t, r) {
                                        var n = e("./support"), i = e("./base64"), s = e("./nodejsUtils"), o = e("./external");
                                        function a(e) {
                                            return e;
                                        }
                                        function l(e, t) {
                                            for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                                            return t;
                                        }
                                        e("setimmediate"), r.newBlob = function(e, t) {
                                            r.checkSupport("blob");
                                            try {
                                                return new Blob([
                                                    e
                                                ], {
                                                    type: t
                                                });
                                            } catch (r) {
                                                try {
                                                    var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    return n.append(e), n.getBlob(t);
                                                } catch (e) {
                                                    throw new Error("Bug : can't construct the Blob.");
                                                }
                                            }
                                        };
                                        var c = {
                                            stringifyByChunk: function(e, t, r) {
                                                var n = [], i = 0, s = e.length;
                                                if (s <= r) return String.fromCharCode.apply(null, e);
                                                for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                                                return n.join("");
                                            },
                                            stringifyByChar: function(e) {
                                                for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                                                return t;
                                            },
                                            applyCanBeUsed: {
                                                uint8array: function() {
                                                    try {
                                                        return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(),
                                                nodebuffer: function() {
                                                    try {
                                                        return n.nodebuffer && 1 === String.fromCharCode.apply(null, s.allocBuffer(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }()
                                            }
                                        };
                                        function h(e) {
                                            var t = 65536, n = r.getTypeOf(e), i = !0;
                                            if ("uint8array" === n ? i = c.applyCanBeUsed.uint8array : "nodebuffer" === n && (i = c.applyCanBeUsed.nodebuffer), i) for(; 1 < t;)try {
                                                return c.stringifyByChunk(e, n, t);
                                            } catch (e) {
                                                t = Math.floor(t / 2);
                                            }
                                            return c.stringifyByChar(e);
                                        }
                                        function f(e, t) {
                                            for(var r = 0; r < e.length; r++)t[r] = e[r];
                                            return t;
                                        }
                                        r.applyFromCharCode = h;
                                        var d = {};
                                        d.string = {
                                            string: a,
                                            array: function(e) {
                                                return l(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.string.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return l(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: function(e) {
                                                return l(e, s.allocBuffer(e.length));
                                            }
                                        }, d.array = {
                                            string: h,
                                            array: a,
                                            arraybuffer: function(e) {
                                                return new Uint8Array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.arraybuffer = {
                                            string: function(e) {
                                                return h(new Uint8Array(e));
                                            },
                                            array: function(e) {
                                                return f(new Uint8Array(e), new Array(e.byteLength));
                                            },
                                            arraybuffer: a,
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(new Uint8Array(e));
                                            }
                                        }, d.uint8array = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return e.buffer;
                                            },
                                            uint8array: a,
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.nodebuffer = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.nodebuffer.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return f(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: a
                                        }, r.transformTo = function(e, t) {
                                            if (t = t || "", !e) return t;
                                            r.checkSupport(e);
                                            var n = r.getTypeOf(t);
                                            return d[n][e](t);
                                        }, r.resolve = function(e) {
                                            for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                                                var i = t[n];
                                                "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                                            }
                                            return r.join("/");
                                        }, r.getTypeOf = function(e) {
                                            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : n.nodebuffer && s.isBuffer(e) ? "nodebuffer" : n.uint8array && e instanceof Uint8Array ? "uint8array" : n.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                        }, r.checkSupport = function(e) {
                                            if (!n[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(e) {
                                            var t, r, n = "";
                                            for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                            return n;
                                        }, r.delay = function(e, t, r) {
                                            u(function() {
                                                e.apply(r || null, t || []);
                                            });
                                        }, r.inherits = function(e, t) {
                                            function r() {}
                                            r.prototype = t.prototype, e.prototype = new r;
                                        }, r.extend = function() {
                                            var e, t, r = {};
                                            for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                                            return r;
                                        }, r.prepareContent = function(e, t, s, a, c) {
                                            return o.Promise.resolve(t).then(function(e) {
                                                return n.blob && (e instanceof Blob || -1 !== [
                                                    "[object File]",
                                                    "[object Blob]"
                                                ].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new o.Promise(function(t, r) {
                                                    var n = new FileReader;
                                                    n.onload = function(e) {
                                                        t(e.target.result);
                                                    }, n.onerror = function(e) {
                                                        r(e.target.error);
                                                    }, n.readAsArrayBuffer(e);
                                                }) : e;
                                            }).then(function(t) {
                                                var u = r.getTypeOf(t);
                                                return u ? ("arraybuffer" === u ? t = r.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : s && !0 !== a && (t = function(e) {
                                                    return l(e, n.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                                                }(t))), t) : o.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                            });
                                        };
                                    },
                                    {
                                        "./base64": 1,
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./support": 30,
                                        setimmediate: 54
                                    }
                                ],
                                33: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), o = e("./zipEntry"), a = e("./support");
                                        function l(e) {
                                            this.files = [], this.loadOptions = e;
                                        }
                                        l.prototype = {
                                            checkSignature: function(e) {
                                                if (!this.reader.readAndCheckSignature(e)) {
                                                    this.reader.index -= 4;
                                                    var t = this.reader.readString(4);
                                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                }
                                            },
                                            isSignature: function(e, t) {
                                                var r = this.reader.index;
                                                this.reader.setIndex(e);
                                                var n = this.reader.readString(4) === t;
                                                return this.reader.setIndex(r), n;
                                            },
                                            readBlockEndOfCentral: function() {
                                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                var e = this.reader.readData(this.zipCommentLength), t = a.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                                                this.zipComment = this.loadOptions.decodeFileName(r);
                                            },
                                            readBlockZip64EndOfCentral: function() {
                                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                                for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                    id: e,
                                                    length: t,
                                                    value: r
                                                };
                                            },
                                            readBlockZip64EndOfCentralLocator: function() {
                                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                            },
                                            readLocalFiles: function() {
                                                var e, t;
                                                for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                            },
                                            readCentralDir: function() {
                                                var e;
                                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new o({
                                                    zip64: this.zip64
                                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                            },
                                            readEndOfCentral: function() {
                                                var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                                if (e < 0) throw this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                this.reader.setIndex(e);
                                                var t = e;
                                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                    if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                    if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                }
                                                var r = this.centralDirOffset + this.centralDirSize;
                                                this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                                                var n = t - r;
                                                if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                                                else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                                            },
                                            prepareReader: function(e) {
                                                this.reader = n(e);
                                            },
                                            load: function(e) {
                                                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                            }
                                        }, t.exports = l;
                                    },
                                    {
                                        "./reader/readerFor": 22,
                                        "./signature": 23,
                                        "./support": 30,
                                        "./utils": 32,
                                        "./zipEntry": 34
                                    }
                                ],
                                34: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./compressedObject"), o = e("./crc32"), a = e("./utf8"), l = e("./compressions"), c = e("./support");
                                        function u(e, t) {
                                            this.options = e, this.loadOptions = t;
                                        }
                                        u.prototype = {
                                            isEncrypted: function() {
                                                return 1 == (1 & this.bitFlag);
                                            },
                                            useUTF8: function() {
                                                return 2048 == (2048 & this.bitFlag);
                                            },
                                            readLocalPart: function(e) {
                                                var t, r;
                                                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                if (null === (t = function(e) {
                                                    for(var t in l)if (Object.prototype.hasOwnProperty.call(l, t) && l[t].magic === e) return l[t];
                                                    return null;
                                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                this.decompressed = new s(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                            },
                                            readCentralPart: function(e) {
                                                this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                var t = e.readInt(2);
                                                if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                            },
                                            processAttributes: function() {
                                                this.unixPermissions = null, this.dosPermissions = null;
                                                var e = this.versionMadeBy >> 8;
                                                this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                            },
                                            parseZIP64ExtraField: function() {
                                                if (this.extraFields[1]) {
                                                    var e = n(this.extraFields[1].value);
                                                    this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                                                }
                                            },
                                            readExtraFields: function(e) {
                                                var t, r, n, i = e.index + this.extraFieldsLength;
                                                for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                                                    id: t,
                                                    length: r,
                                                    value: n
                                                };
                                                e.setIndex(i);
                                            },
                                            handleUTF8: function() {
                                                var e = c.uint8array ? "uint8array" : "array";
                                                if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                                else {
                                                    var t = this.findExtraFieldUnicodePath();
                                                    if (null !== t) this.fileNameStr = t;
                                                    else {
                                                        var r = i.transformTo(e, this.fileName);
                                                        this.fileNameStr = this.loadOptions.decodeFileName(r);
                                                    }
                                                    var n = this.findExtraFieldUnicodeComment();
                                                    if (null !== n) this.fileCommentStr = n;
                                                    else {
                                                        var s = i.transformTo(e, this.fileComment);
                                                        this.fileCommentStr = this.loadOptions.decodeFileName(s);
                                                    }
                                                }
                                            },
                                            findExtraFieldUnicodePath: function() {
                                                var e = this.extraFields[28789];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileName) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            },
                                            findExtraFieldUnicodeComment: function() {
                                                var e = this.extraFields[25461];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileComment) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            }
                                        }, t.exports = u;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./compressions": 3,
                                        "./crc32": 4,
                                        "./reader/readerFor": 22,
                                        "./support": 30,
                                        "./utf8": 31,
                                        "./utils": 32
                                    }
                                ],
                                35: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                                                compression: r.compression,
                                                compressionOptions: r.compressionOptions
                                            };
                                        }
                                        var i = e("./stream/StreamHelper"), s = e("./stream/DataWorker"), o = e("./utf8"), a = e("./compressedObject"), l = e("./stream/GenericWorker");
                                        n.prototype = {
                                            internalStream: function(e) {
                                                var t = null, r = "string";
                                                try {
                                                    if (!e) throw new Error("No output type specified.");
                                                    var n = "string" === (r = e.toLowerCase()) || "text" === r;
                                                    "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                                                    var s = !this._dataBinary;
                                                    s && !n && (t = t.pipe(new o.Utf8EncodeWorker)), !s && n && (t = t.pipe(new o.Utf8DecodeWorker));
                                                } catch (e) {
                                                    (t = new l("error")).error(e);
                                                }
                                                return new i(t, r, "");
                                            },
                                            async: function(e, t) {
                                                return this.internalStream(e).accumulate(t);
                                            },
                                            nodeStream: function(e, t) {
                                                return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                            },
                                            _compressWorker: function(e, t) {
                                                if (this._data instanceof a && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                                                var r = this._decompressWorker();
                                                return this._dataBinary || (r = r.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(r, e, t);
                                            },
                                            _decompressWorker: function() {
                                                return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new s(this._data);
                                            }
                                        };
                                        for(var c = [
                                            "asText",
                                            "asBinary",
                                            "asNodeBuffer",
                                            "asUint8Array",
                                            "asArrayBuffer"
                                        ], u = function() {
                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                        }, h = 0; h < c.length; h++)n.prototype[c[h]] = u;
                                        t.exports = n;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./stream/DataWorker": 27,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31
                                    }
                                ],
                                36: [
                                    function(e, t, r) {
                                        (function(e) {
                                            var r, n, i = e.MutationObserver || e.WebKitMutationObserver;
                                            if (i) {
                                                var s = 0, o = new i(u), a = e.document.createTextNode("");
                                                o.observe(a, {
                                                    characterData: !0
                                                }), r = function() {
                                                    a.data = s = ++s % 2;
                                                };
                                            } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function() {
                                                var t = e.document.createElement("script");
                                                t.onreadystatechange = function() {
                                                    u(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                }, e.document.documentElement.appendChild(t);
                                            } : function() {
                                                setTimeout(u, 0);
                                            };
                                            else {
                                                var l = new e.MessageChannel;
                                                l.port1.onmessage = u, r = function() {
                                                    l.port2.postMessage(0);
                                                };
                                            }
                                            var c = [];
                                            function u() {
                                                var e, t;
                                                n = !0;
                                                for(var r = c.length; r;){
                                                    for(t = c, c = [], e = -1; ++e < r;)t[e]();
                                                    r = c.length;
                                                }
                                                n = !1;
                                            }
                                            t.exports = function(e) {
                                                1 !== c.push(e) || n || r();
                                            };
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                37: [
                                    function(e, t, r) {
                                        var n = e("immediate");
                                        function i() {}
                                        var s = {}, o = [
                                            "REJECTED"
                                        ], a = [
                                            "FULFILLED"
                                        ], l = [
                                            "PENDING"
                                        ];
                                        function c(e) {
                                            if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                            this.state = l, this.queue = [], this.outcome = void 0, e !== i && d(this, e);
                                        }
                                        function u(e, t, r) {
                                            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                                        }
                                        function h(e, t, r) {
                                            n(function() {
                                                var n;
                                                try {
                                                    n = t(r);
                                                } catch (n) {
                                                    return s.reject(e, n);
                                                }
                                                n === e ? s.reject(e, new TypeError("Cannot resolve promise with itself")) : s.resolve(e, n);
                                            });
                                        }
                                        function f(e) {
                                            var t = e && e.then;
                                            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                                                t.apply(e, arguments);
                                            };
                                        }
                                        function d(e, t) {
                                            var r = !1;
                                            function n(t) {
                                                r || (r = !0, s.reject(e, t));
                                            }
                                            function i(t) {
                                                r || (r = !0, s.resolve(e, t));
                                            }
                                            var o = p(function() {
                                                t(i, n);
                                            });
                                            "error" === o.status && n(o.value);
                                        }
                                        function p(e, t) {
                                            var r = {};
                                            try {
                                                r.value = e(t), r.status = "success";
                                            } catch (e) {
                                                r.status = "error", r.value = e;
                                            }
                                            return r;
                                        }
                                        (t.exports = c).prototype.finally = function(e) {
                                            if ("function" != typeof e) return this;
                                            var t = this.constructor;
                                            return this.then(function(r) {
                                                return t.resolve(e()).then(function() {
                                                    return r;
                                                });
                                            }, function(r) {
                                                return t.resolve(e()).then(function() {
                                                    throw r;
                                                });
                                            });
                                        }, c.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, c.prototype.then = function(e, t) {
                                            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === o) return this;
                                            var r = new this.constructor(i);
                                            return this.state !== l ? h(r, this.state === a ? e : t, this.outcome) : this.queue.push(new u(r, e, t)), r;
                                        }, u.prototype.callFulfilled = function(e) {
                                            s.resolve(this.promise, e);
                                        }, u.prototype.otherCallFulfilled = function(e) {
                                            h(this.promise, this.onFulfilled, e);
                                        }, u.prototype.callRejected = function(e) {
                                            s.reject(this.promise, e);
                                        }, u.prototype.otherCallRejected = function(e) {
                                            h(this.promise, this.onRejected, e);
                                        }, s.resolve = function(e, t) {
                                            var r = p(f, t);
                                            if ("error" === r.status) return s.reject(e, r.value);
                                            var n = r.value;
                                            if (n) d(e, n);
                                            else {
                                                e.state = a, e.outcome = t;
                                                for(var i = -1, o = e.queue.length; ++i < o;)e.queue[i].callFulfilled(t);
                                            }
                                            return e;
                                        }, s.reject = function(e, t) {
                                            e.state = o, e.outcome = t;
                                            for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                                            return e;
                                        }, c.resolve = function(e) {
                                            return e instanceof this ? e : s.resolve(new this(i), e);
                                        }, c.reject = function(e) {
                                            var t = new this(i);
                                            return s.reject(t, e);
                                        }, c.all = function(e) {
                                            var t = this;
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var r = e.length, n = !1;
                                            if (!r) return this.resolve([]);
                                            for(var o = new Array(r), a = 0, l = -1, c = new this(i); ++l < r;)u(e[l], l);
                                            return c;
                                            function u(e, i) {
                                                t.resolve(e).then(function(e) {
                                                    o[i] = e, ++a !== r || n || (n = !0, s.resolve(c, o));
                                                }, function(e) {
                                                    n || (n = !0, s.reject(c, e));
                                                });
                                            }
                                        }, c.race = function(e) {
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var t = e.length, r = !1;
                                            if (!t) return this.resolve([]);
                                            for(var n, o = -1, a = new this(i); ++o < t;)n = e[o], this.resolve(n).then(function(e) {
                                                r || (r = !0, s.resolve(a, e));
                                            }, function(e) {
                                                r || (r = !0, s.reject(a, e));
                                            });
                                            return a;
                                        };
                                    },
                                    {
                                        immediate: 36
                                    }
                                ],
                                38: [
                                    function(e, t, r) {
                                        var n = {};
                                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                                    },
                                    {
                                        "./lib/deflate": 39,
                                        "./lib/inflate": 40,
                                        "./lib/utils/common": 41,
                                        "./lib/zlib/constants": 44
                                    }
                                ],
                                39: [
                                    function(e, t, r) {
                                        var n = e("./zlib/deflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/messages"), a = e("./zlib/zstream"), l = Object.prototype.toString;
                                        function c(e) {
                                            if (!(this instanceof c)) return new c(e);
                                            this.options = i.assign({
                                                level: -1,
                                                method: 8,
                                                chunkSize: 16384,
                                                windowBits: 15,
                                                memLevel: 8,
                                                strategy: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                            var r = n.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                            if (0 !== r) throw new Error(o[r]);
                                            if (t.header && n.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                var u;
                                                if (u = "string" == typeof t.dictionary ? s.string2buf(t.dictionary) : "[object ArrayBuffer]" === l.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, u))) throw new Error(o[r]);
                                                this._dict_set = !0;
                                            }
                                        }
                                        function u(e, t) {
                                            var r = new c(t);
                                            if (r.push(e, !0), r.err) throw r.msg || o[r.err];
                                            return r.result;
                                        }
                                        c.prototype.push = function(e, t) {
                                            var r, o, a = this.strm, c = this.options.chunkSize;
                                            if (this.ended) return !1;
                                            o = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? a.input = s.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? a.input = new Uint8Array(e) : a.input = e, a.next_in = 0, a.avail_in = a.input.length;
                                            do {
                                                if (0 === a.avail_out && (a.output = new i.Buf8(c), a.next_out = 0, a.avail_out = c), 1 !== (r = n.deflate(a, o)) && 0 !== r) return this.onEnd(r), this.ended = !0, false;
                                                0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(s.buf2binstring(i.shrinkBuf(a.output, a.next_out))) : this.onData(i.shrinkBuf(a.output, a.next_out)));
                                            }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== r);
                                            return 4 === o ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                                        }, c.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, c.prototype.onEnd = function(e) {
                                            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Deflate = c, r.deflate = u, r.deflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, u(e, t);
                                        }, r.gzip = function(e, t) {
                                            return (t = t || {}).gzip = !0, u(e, t);
                                        };
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/deflate": 46,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                40: [
                                    function(e, t, r) {
                                        var n = e("./zlib/inflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/constants"), a = e("./zlib/messages"), l = e("./zlib/zstream"), c = e("./zlib/gzheader"), u = Object.prototype.toString;
                                        function h(e) {
                                            if (!(this instanceof h)) return new h(e);
                                            this.options = i.assign({
                                                chunkSize: 16384,
                                                windowBits: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                            var r = n.inflateInit2(this.strm, t.windowBits);
                                            if (r !== o.Z_OK) throw new Error(a[r]);
                                            this.header = new c, n.inflateGetHeader(this.strm, this.header);
                                        }
                                        function f(e, t) {
                                            var r = new h(t);
                                            if (r.push(e, !0), r.err) throw r.msg || a[r.err];
                                            return r.result;
                                        }
                                        h.prototype.push = function(e, t) {
                                            var r, a, l, c, h, f, d = this.strm, p = this.options.chunkSize, m = this.options.dictionary, b = !1;
                                            if (this.ended) return !1;
                                            a = t === ~~t ? t : !0 === t ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof e ? d.input = s.binstring2buf(e) : "[object ArrayBuffer]" === u.call(e) ? d.input = new Uint8Array(e) : d.input = e, d.next_in = 0, d.avail_in = d.input.length;
                                            do {
                                                if (0 === d.avail_out && (d.output = new i.Buf8(p), d.next_out = 0, d.avail_out = p), (r = n.inflate(d, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && m && (f = "string" == typeof m ? s.string2buf(m) : "[object ArrayBuffer]" === u.call(m) ? new Uint8Array(m) : m, r = n.inflateSetDictionary(this.strm, f)), r === o.Z_BUF_ERROR && !0 === b && (r = o.Z_OK, b = !1), r !== o.Z_STREAM_END && r !== o.Z_OK) return this.onEnd(r), this.ended = !0, false;
                                                d.next_out && (0 !== d.avail_out && r !== o.Z_STREAM_END && (0 !== d.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = s.utf8border(d.output, d.next_out), c = d.next_out - l, h = s.buf2string(d.output, l), d.next_out = c, d.avail_out = p - c, c && i.arraySet(d.output, d.output, l, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (b = !0);
                                            }while ((0 < d.avail_in || 0 === d.avail_out) && r !== o.Z_STREAM_END);
                                            return r === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), d.avail_out = 0, true);
                                        }, h.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, h.prototype.onEnd = function(e) {
                                            e === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Inflate = h, r.inflate = f, r.inflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, f(e, t);
                                        }, r.ungzip = f;
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/constants": 44,
                                        "./zlib/gzheader": 47,
                                        "./zlib/inflate": 49,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                41: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                        r.assign = function(e) {
                                            for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                                                var r = t.shift();
                                                if (r) {
                                                    if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                                    for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                                                }
                                            }
                                            return e;
                                        }, r.shrinkBuf = function(e, t) {
                                            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                        };
                                        var i = {
                                            arraySet: function(e, t, r, n, i) {
                                                if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                                                else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                var t, r, n, i, s, o;
                                                for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                                                for(o = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], o.set(s, i), i += s.length;
                                                return o;
                                            }
                                        }, s = {
                                            arraySet: function(e, t, r, n, i) {
                                                for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                return [].concat.apply([], e);
                                            }
                                        };
                                        r.setTyped = function(e) {
                                            e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                                        }, r.setTyped(n);
                                    },
                                    {}
                                ],
                                42: [
                                    function(e, t, r) {
                                        var n = e("./common"), i = !0, s = !0;
                                        try {
                                            String.fromCharCode.apply(null, [
                                                0
                                            ]);
                                        } catch (e) {
                                            i = !1;
                                        }
                                        try {
                                            String.fromCharCode.apply(null, new Uint8Array(1));
                                        } catch (e) {
                                            s = !1;
                                        }
                                        for(var o = new n.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                                        function l(e, t) {
                                            if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));
                                            for(var r = "", o = 0; o < t; o++)r += String.fromCharCode(e[o]);
                                            return r;
                                        }
                                        o[254] = o[254] = 1, r.string2buf = function(e) {
                                            var t, r, i, s, o, a = e.length, l = 0;
                                            for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                            for(t = new n.Buf8(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                            return t;
                                        }, r.buf2binstring = function(e) {
                                            return l(e, e.length);
                                        }, r.binstring2buf = function(e) {
                                            for(var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++)t[r] = e.charCodeAt(r);
                                            return t;
                                        }, r.buf2string = function(e, t) {
                                            var r, n, i, s, a = t || e.length, c = new Array(2 * a);
                                            for(r = n = 0; r < a;)if ((i = e[r++]) < 128) c[n++] = i;
                                            else if (4 < (s = o[i])) c[n++] = 65533, r += s - 1;
                                            else {
                                                for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                                                1 < s ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                            }
                                            return l(c, n);
                                        }, r.utf8border = function(e, t) {
                                            var r;
                                            for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                            return r < 0 || 0 === r ? t : r + o[e[r]] > t ? r : t;
                                        };
                                    },
                                    {
                                        "./common": 41
                                    }
                                ],
                                43: [
                                    function(e, t, r) {
                                        t.exports = function(e, t, r, n) {
                                            for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;){
                                                for(r -= o = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --o;);
                                                i %= 65521, s %= 65521;
                                            }
                                            return i | s << 16 | 0;
                                        };
                                    },
                                    {}
                                ],
                                44: [
                                    function(e, t, r) {
                                        t.exports = {
                                            Z_NO_FLUSH: 0,
                                            Z_PARTIAL_FLUSH: 1,
                                            Z_SYNC_FLUSH: 2,
                                            Z_FULL_FLUSH: 3,
                                            Z_FINISH: 4,
                                            Z_BLOCK: 5,
                                            Z_TREES: 6,
                                            Z_OK: 0,
                                            Z_STREAM_END: 1,
                                            Z_NEED_DICT: 2,
                                            Z_ERRNO: -1,
                                            Z_STREAM_ERROR: -2,
                                            Z_DATA_ERROR: -3,
                                            Z_BUF_ERROR: -5,
                                            Z_NO_COMPRESSION: 0,
                                            Z_BEST_SPEED: 1,
                                            Z_BEST_COMPRESSION: 9,
                                            Z_DEFAULT_COMPRESSION: -1,
                                            Z_FILTERED: 1,
                                            Z_HUFFMAN_ONLY: 2,
                                            Z_RLE: 3,
                                            Z_FIXED: 4,
                                            Z_DEFAULT_STRATEGY: 0,
                                            Z_BINARY: 0,
                                            Z_TEXT: 1,
                                            Z_UNKNOWN: 2,
                                            Z_DEFLATED: 8
                                        };
                                    },
                                    {}
                                ],
                                45: [
                                    function(e, t, r) {
                                        var n = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t, r, i) {
                                            var s = n, o = i + r;
                                            e ^= -1;
                                            for(var a = i; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                            return -1 ^ e;
                                        };
                                    },
                                    {}
                                ],
                                46: [
                                    function(e, t, r) {
                                        var n, i = e("../utils/common"), s = e("./trees"), o = e("./adler32"), a = e("./crc32"), l = e("./messages"), c = -2, u = 258, h = 262, f = 113;
                                        function d(e, t) {
                                            return e.msg = l[t], t;
                                        }
                                        function p(e) {
                                            return (e << 1) - (4 < e ? 9 : 0);
                                        }
                                        function m(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        function b(e) {
                                            var t = e.state, r = t.pending;
                                            r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                                        }
                                        function g(e, t) {
                                            s._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, b(e.strm);
                                        }
                                        function y(e, t) {
                                            e.pending_buf[e.pending++] = t;
                                        }
                                        function v(e, t) {
                                            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                        }
                                        function w(e, t) {
                                            var r, n, i = e.max_chain_length, s = e.strstart, o = e.prev_length, a = e.nice_match, l = e.strstart > e.w_size - h ? e.strstart - (e.w_size - h) : 0, c = e.window, f = e.w_mask, d = e.prev, p = e.strstart + u, m = c[s + o - 1], b = c[s + o];
                                            e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
                                            do if (c[(r = t) + o] === b && c[r + o - 1] === m && c[r] === c[s] && c[++r] === c[s + 1]) {
                                                s += 2, r++;
                                                do ;
                                                while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < p);
                                                if (n = u - (p - s), s = p - u, o < n) {
                                                    if (e.match_start = t, a <= (o = n)) break;
                                                    m = c[s + o - 1], b = c[s + o];
                                                }
                                            }
                                            while ((t = d[t & f]) > l && 0 != --i);
                                            return o <= e.lookahead ? o : e.lookahead;
                                        }
                                        function _(e) {
                                            var t, r, n, s, l, c, u, f, d, p, m = e.w_size;
                                            do {
                                                if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= m + (m - h)) {
                                                    for(i.arraySet(e.window, e.window, m, m, 0), e.match_start -= m, e.strstart -= m, e.block_start -= m, t = r = e.hash_size; n = e.head[--t], e.head[t] = m <= n ? n - m : 0, --r;);
                                                    for(t = r = m; n = e.prev[--t], e.prev[t] = m <= n ? n - m : 0, --r;);
                                                    s += m;
                                                }
                                                if (0 === e.strm.avail_in) break;
                                                if (c = e.strm, u = e.window, f = e.strstart + e.lookahead, p = void 0, (d = s) < (p = c.avail_in) && (p = d), r = 0 === p ? 0 : (c.avail_in -= p, i.arraySet(u, c.input, c.next_in, p, f), 1 === c.state.wrap ? c.adler = o(c.adler, u, p, f) : 2 === c.state.wrap && (c.adler = a(c.adler, u, p, f)), c.next_in += p, c.total_in += p, p), e.lookahead += r, e.lookahead + e.insert >= 3) for(l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 3 - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < 3)););
                                            }while (e.lookahead < h && 0 !== e.strm.avail_in);
                                        }
                                        function x(e, t) {
                                            for(var r, n;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r)), e.match_length >= 3) {
                                                    if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                                                        for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                                        e.strstart++;
                                                    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                if (n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                            }
                                            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function k(e, t) {
                                            for(var r, n, i;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && 4096 < e.strstart - e.match_start) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                                                    for(i = e.strstart + e.lookahead - 3, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                                                    if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                } else if (e.match_available) {
                                                    if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && g(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                } else e.match_available = 1, e.strstart++, e.lookahead--;
                                            }
                                            return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function S(e, t, r, n, i) {
                                            this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                                        }
                                        function M() {
                                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                        }
                                        function C(e) {
                                            var t;
                                            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : f, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, s._tr_init(t), 0) : d(e, c);
                                        }
                                        function T(e) {
                                            var t = C(e);
                                            return 0 === t && function(e) {
                                                e.window_size = 2 * e.w_size, m(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
                                            }(e.state), t;
                                        }
                                        function E(e, t, r, n, s, o) {
                                            if (!e) return c;
                                            var a = 1;
                                            if (-1 === t && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), s < 1 || 9 < s || 8 !== r || n < 8 || 15 < n || t < 0 || 9 < t || o < 0 || 4 < o) return d(e, c);
                                            8 === n && (n = 9);
                                            var l = new M;
                                            return (e.state = l).strm = e, l.wrap = a, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new i.Buf8(2 * l.w_size), l.head = new i.Buf16(l.hash_size), l.prev = new i.Buf16(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new i.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, T(e);
                                        }
                                        n = [
                                            new S(0, 0, 0, 0, function(e, t) {
                                                var r = 65535;
                                                for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                                                    if (e.lookahead <= 1) {
                                                        if (_(e), 0 === e.lookahead && 0 === t) return 1;
                                                        if (0 === e.lookahead) break;
                                                    }
                                                    e.strstart += e.lookahead, e.lookahead = 0;
                                                    var n = e.block_start + r;
                                                    if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    if (e.strstart - e.block_start >= e.w_size - h && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                }
                                                return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (g(e, !1), e.strm.avail_out), 1);
                                            }),
                                            new S(4, 4, 8, 4, x),
                                            new S(4, 5, 16, 8, x),
                                            new S(4, 6, 32, 32, x),
                                            new S(4, 4, 16, 16, k),
                                            new S(8, 16, 32, 32, k),
                                            new S(8, 16, 128, 128, k),
                                            new S(8, 32, 128, 256, k),
                                            new S(32, 128, 258, 1024, k),
                                            new S(32, 258, 258, 4096, k)
                                        ], r.deflateInit = function(e, t) {
                                            return E(e, t, 8, 15, 8, 0);
                                        }, r.deflateInit2 = E, r.deflateReset = T, r.deflateResetKeep = C, r.deflateSetHeader = function(e, t) {
                                            return e && e.state ? 2 !== e.state.wrap ? c : (e.state.gzhead = t, 0) : c;
                                        }, r.deflate = function(e, t) {
                                            var r, i, o, l;
                                            if (!e || !e.state || 5 < t || t < 0) return e ? d(e, c) : c;
                                            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return d(e, 0 === e.avail_out ? -5 : c);
                                            if (i.strm = e, r = i.last_flush, i.last_flush = t, 42 === i.status) {
                                                if (2 === i.wrap) e.adler = 0, y(i, 31), y(i, 139), y(i, 8), i.gzhead ? (y(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), y(i, 255 & i.gzhead.time), y(i, i.gzhead.time >> 8 & 255), y(i, i.gzhead.time >> 16 & 255), y(i, i.gzhead.time >> 24 & 255), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (y(i, 255 & i.gzhead.extra.length), y(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 3), i.status = f);
                                                else {
                                                    var h = 8 + (i.w_bits - 8 << 4) << 8;
                                                    h |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = f, v(i, h), 0 !== i.strstart && (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), e.adler = 1;
                                                }
                                            }
                                            if (69 === i.status) {
                                                if (i.gzhead.extra) {
                                                    for(o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending !== i.pending_buf_size));)y(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                } else i.status = 73;
                                            }
                                            if (73 === i.status) {
                                                if (i.gzhead.name) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.gzindex = 0, i.status = 91);
                                                } else i.status = 91;
                                            }
                                            if (91 === i.status) {
                                                if (i.gzhead.comment) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.status = 103);
                                                } else i.status = 103;
                                            }
                                            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && b(e), i.pending + 2 <= i.pending_buf_size && (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), e.adler = 0, i.status = f)) : i.status = f), 0 !== i.pending) {
                                                if (b(e), 0 === e.avail_out) return i.last_flush = -1, 0;
                                            } else if (0 === e.avail_in && p(t) <= p(r) && 4 !== t) return d(e, -5);
                                            if (666 === i.status && 0 !== e.avail_in) return d(e, -5);
                                            if (0 !== e.avail_in || 0 !== i.lookahead || 0 !== t && 666 !== i.status) {
                                                var w = 2 === i.strategy ? function(e, t) {
                                                    for(var r;;){
                                                        if (0 === e.lookahead && (_(e), 0 === e.lookahead)) {
                                                            if (0 === t) return 1;
                                                            break;
                                                        }
                                                        if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : 3 === i.strategy ? function(e, t) {
                                                    for(var r, n, i, o, a = e.window;;){
                                                        if (e.lookahead <= u) {
                                                            if (_(e), e.lookahead <= u && 0 === t) return 1;
                                                            if (0 === e.lookahead) break;
                                                        }
                                                        if (e.match_length = 0, e.lookahead >= 3 && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                                            o = e.strstart + u;
                                                            do ;
                                                            while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);
                                                            e.match_length = u - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                        }
                                                        if (e.match_length >= 3 ? (r = s._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : n[i.level].func(i, t);
                                                if (3 !== w && 4 !== w || (i.status = 666), 1 === w || 3 === w) return 0 === e.avail_out && (i.last_flush = -1), 0;
                                                if (2 === w && (1 === t ? s._tr_align(i) : 5 !== t && (s._tr_stored_block(i, 0, 0, !1), 3 === t && (m(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), b(e), 0 === e.avail_out)) return i.last_flush = -1, 0;
                                            }
                                            return 4 !== t ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), y(i, e.adler >> 16 & 255), y(i, e.adler >> 24 & 255), y(i, 255 & e.total_in), y(i, e.total_in >> 8 & 255), y(i, e.total_in >> 16 & 255), y(i, e.total_in >> 24 & 255)) : (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), b(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
                                        }, r.deflateEnd = function(e) {
                                            var t;
                                            return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== f && 666 !== t ? d(e, c) : (e.state = null, t === f ? d(e, -3) : 0) : c;
                                        }, r.deflateSetDictionary = function(e, t) {
                                            var r, n, s, a, l, u, h, f, d = t.length;
                                            if (!e || !e.state) return c;
                                            if (2 === (a = (r = e.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return c;
                                            for(1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (m(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), f = new i.Buf8(r.w_size), i.arraySet(f, t, d - r.w_size, r.w_size, 0), t = f, d = r.w_size), l = e.avail_in, u = e.next_in, h = e.input, e.avail_in = d, e.next_in = 0, e.input = t, _(r); r.lookahead >= 3;){
                                                for(n = r.strstart, s = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --s;);
                                                r.strstart = n, r.lookahead = 2, _(r);
                                            }
                                            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = u, e.input = h, e.avail_in = l, r.wrap = a, 0;
                                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./messages": 51,
                                        "./trees": 52
                                    }
                                ],
                                47: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(e, t, r) {
                                        t.exports = function(e, t) {
                                            var r, n, i, s, o, a, l, c, u, h, f, d, p, m, b, g, y, v, w, _, x, k, S, M, C;
                                            r = e.state, n = e.next_in, M = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, b = r.distcode, g = (1 << r.lenbits) - 1, y = (1 << r.distbits) - 1;
                                            e: do {
                                                p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = m[d & g];
                                                t: for(;;){
                                                    if (d >>>= w = v >>> 24, p -= w, 0 == (w = v >>> 16 & 255)) C[s++] = 65535 & v;
                                                    else {
                                                        if (!(16 & w)) {
                                                            if (0 == (64 & w)) {
                                                                v = m[(65535 & v) + (d & (1 << w) - 1)];
                                                                continue t;
                                                            }
                                                            if (32 & w) {
                                                                r.mode = 12;
                                                                break e;
                                                            }
                                                            e.msg = "invalid literal/length code", r.mode = 30;
                                                            break e;
                                                        }
                                                        _ = 65535 & v, (w &= 15) && (p < w && (d += M[n++] << p, p += 8), _ += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = b[d & y];
                                                        r: for(;;){
                                                            if (d >>>= w = v >>> 24, p -= w, !(16 & (w = v >>> 16 & 255))) {
                                                                if (0 == (64 & w)) {
                                                                    v = b[(65535 & v) + (d & (1 << w) - 1)];
                                                                    continue r;
                                                                }
                                                                e.msg = "invalid distance code", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (x = 65535 & v, p < (w &= 15) && (d += M[n++] << p, (p += 8) < w && (d += M[n++] << p, p += 8)), l < (x += d & (1 << w) - 1)) {
                                                                e.msg = "invalid distance too far back", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (d >>>= w, p -= w, (w = s - o) < x) {
                                                                if (u < (w = x - w) && r.sane) {
                                                                    e.msg = "invalid distance too far back", r.mode = 30;
                                                                    break e;
                                                                }
                                                                if (S = f, (k = 0) === h) {
                                                                    if (k += c - w, w < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        k = s - x, S = C;
                                                                    }
                                                                } else if (h < w) {
                                                                    if (k += c + h - w, (w -= h) < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        if (k = 0, h < _) {
                                                                            for(_ -= w = h; C[s++] = f[k++], --w;);
                                                                            k = s - x, S = C;
                                                                        }
                                                                    }
                                                                } else if (k += h - w, w < _) {
                                                                    for(_ -= w; C[s++] = f[k++], --w;);
                                                                    k = s - x, S = C;
                                                                }
                                                                for(; 2 < _;)C[s++] = S[k++], C[s++] = S[k++], C[s++] = S[k++], _ -= 3;
                                                                _ && (C[s++] = S[k++], 1 < _ && (C[s++] = S[k++]));
                                                            } else {
                                                                for(k = s - x; C[s++] = C[k++], C[s++] = C[k++], C[s++] = C[k++], 2 < (_ -= 3););
                                                                _ && (C[s++] = C[k++], 1 < _ && (C[s++] = C[k++]));
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }while (n < i && s < a);
                                            n -= _ = p >> 3, d &= (1 << (p -= _ << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = d, r.bits = p;
                                        };
                                    },
                                    {}
                                ],
                                49: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = e("./adler32"), s = e("./crc32"), o = e("./inffast"), a = e("./inftrees"), l = -2;
                                        function c(e) {
                                            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                        }
                                        function u() {
                                            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                        }
                                        function h(e) {
                                            var t;
                                            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(852), t.distcode = t.distdyn = new n.Buf32(592), t.sane = 1, t.back = -1, 0) : l;
                                        }
                                        function f(e) {
                                            var t;
                                            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, h(e)) : l;
                                        }
                                        function d(e, t) {
                                            var r, n;
                                            return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? l : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, f(e))) : l;
                                        }
                                        function p(e, t) {
                                            var r, n;
                                            return e ? (n = new u, (e.state = n).window = null, 0 !== (r = d(e, t)) && (e.state = null), r) : l;
                                        }
                                        var m, b, g = !0;
                                        function y(e) {
                                            if (g) {
                                                var t;
                                                for(m = new n.Buf32(512), b = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                                                for(; t < 256;)e.lens[t++] = 9;
                                                for(; t < 280;)e.lens[t++] = 7;
                                                for(; t < 288;)e.lens[t++] = 8;
                                                for(a(1, e.lens, 0, 288, m, 0, e.work, {
                                                    bits: 9
                                                }), t = 0; t < 32;)e.lens[t++] = 5;
                                                a(2, e.lens, 0, 32, b, 0, e.work, {
                                                    bits: 5
                                                }), g = !1;
                                            }
                                            e.lencode = m, e.lenbits = 9, e.distcode = b, e.distbits = 5;
                                        }
                                        function v(e, t, r, i) {
                                            var s, o = e.state;
                                            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (i < (s = o.wsize - o.wnext) && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
                                        }
                                        r.inflateReset = f, r.inflateReset2 = d, r.inflateResetKeep = h, r.inflateInit = function(e) {
                                            return p(e, 15);
                                        }, r.inflateInit2 = p, r.inflate = function(e, t) {
                                            var r, u, h, f, d, p, m, b, g, w, _, x, k, S, M, C, T, E, A, R, O, j, I, N, P = 0, B = new n.Buf8(4), D = [
                                                16,
                                                17,
                                                18,
                                                0,
                                                8,
                                                7,
                                                9,
                                                6,
                                                10,
                                                5,
                                                11,
                                                4,
                                                12,
                                                3,
                                                13,
                                                2,
                                                14,
                                                1,
                                                15
                                            ];
                                            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return l;
                                            12 === (r = e.state).mode && (r.mode = 13), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, w = p, _ = m, j = 0;
                                            e: for(;;)switch(r.mode){
                                                case 1:
                                                    if (0 === r.wrap) {
                                                        r.mode = 13;
                                                        break;
                                                    }
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (2 & r.wrap && 35615 === b) {
                                                        B[r.check = 0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0), g = b = 0, r.mode = 2;
                                                        break;
                                                    }
                                                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                                                        e.msg = "incorrect header check", r.mode = 30;
                                                        break;
                                                    }
                                                    if (8 != (15 & b)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (g -= 4, O = 8 + (15 & (b >>>= 4)), 0 === r.wbits) r.wbits = O;
                                                    else if (O > r.wbits) {
                                                        e.msg = "invalid window size", r.mode = 30;
                                                        break;
                                                    }
                                                    r.dmax = 1 << O, e.adler = r.check = 1, r.mode = 512 & b ? 10 : 12, g = b = 0;
                                                    break;
                                                case 2:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.flags = b, 8 != (255 & r.flags)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (57344 & r.flags) {
                                                        e.msg = "unknown header flags set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.head && (r.head.text = b >> 8 & 1), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 3;
                                                case 3:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.time = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, B[2] = b >>> 16 & 255, B[3] = b >>> 24 & 255, r.check = s(r.check, B, 4, 0)), g = b = 0, r.mode = 4;
                                                case 4:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.xflags = 255 & b, r.head.os = b >> 8), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 5;
                                                case 5:
                                                    if (1024 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length = b, r.head && (r.head.extra_len = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0;
                                                    } else r.head && (r.head.extra = null);
                                                    r.mode = 6;
                                                case 6:
                                                    if (1024 & r.flags && (p < (x = r.length) && (x = p), x && (r.head && (O = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, u, f, x, O)), 512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, r.length -= x), r.length)) break e;
                                                    r.length = 0, r.mode = 7;
                                                case 7:
                                                    if (2048 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.name += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.name = null);
                                                    r.length = 0, r.mode = 8;
                                                case 8:
                                                    if (4096 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.comment += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.comment = null);
                                                    r.mode = 9;
                                                case 9:
                                                    if (512 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (65535 & r.check)) {
                                                            e.msg = "header crc mismatch", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                                                    break;
                                                case 10:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    e.adler = r.check = c(b), g = b = 0, r.mode = 11;
                                                case 11:
                                                    if (0 === r.havedict) return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, 2;
                                                    e.adler = r.check = 1, r.mode = 12;
                                                case 12:
                                                    if (5 === t || 6 === t) break e;
                                                case 13:
                                                    if (r.last) {
                                                        b >>>= 7 & g, g -= 7 & g, r.mode = 27;
                                                        break;
                                                    }
                                                    for(; g < 3;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    switch(r.last = 1 & b, g -= 1, 3 & (b >>>= 1)){
                                                        case 0:
                                                            r.mode = 14;
                                                            break;
                                                        case 1:
                                                            if (y(r), r.mode = 20, 6 !== t) break;
                                                            b >>>= 2, g -= 2;
                                                            break e;
                                                        case 2:
                                                            r.mode = 17;
                                                            break;
                                                        case 3:
                                                            e.msg = "invalid block type", r.mode = 30;
                                                    }
                                                    b >>>= 2, g -= 2;
                                                    break;
                                                case 14:
                                                    for(b >>>= 7 & g, g -= 7 & g; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if ((65535 & b) != (b >>> 16 ^ 65535)) {
                                                        e.msg = "invalid stored block lengths", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.length = 65535 & b, g = b = 0, r.mode = 15, 6 === t) break e;
                                                case 15:
                                                    r.mode = 16;
                                                case 16:
                                                    if (x = r.length) {
                                                        if (p < x && (x = p), m < x && (x = m), 0 === x) break e;
                                                        n.arraySet(h, u, f, x, d), p -= x, f += x, m -= x, d += x, r.length -= x;
                                                        break;
                                                    }
                                                    r.mode = 12;
                                                    break;
                                                case 17:
                                                    for(; g < 14;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.nlen = 257 + (31 & b), b >>>= 5, g -= 5, r.ndist = 1 + (31 & b), b >>>= 5, g -= 5, r.ncode = 4 + (15 & b), b >>>= 4, g -= 4, 286 < r.nlen || 30 < r.ndist) {
                                                        e.msg = "too many length or distance symbols", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 18;
                                                case 18:
                                                    for(; r.have < r.ncode;){
                                                        for(; g < 3;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.lens[D[r.have++]] = 7 & b, b >>>= 3, g -= 3;
                                                    }
                                                    for(; r.have < 19;)r.lens[D[r.have++]] = 0;
                                                    if (r.lencode = r.lendyn, r.lenbits = 7, I = {
                                                        bits: r.lenbits
                                                    }, j = a(0, r.lens, 0, 19, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid code lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 19;
                                                case 19:
                                                    for(; r.have < r.nlen + r.ndist;){
                                                        for(; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (T < 16) b >>>= M, g -= M, r.lens[r.have++] = T;
                                                        else {
                                                            if (16 === T) {
                                                                for(N = M + 2; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                if (b >>>= M, g -= M, 0 === r.have) {
                                                                    e.msg = "invalid bit length repeat", r.mode = 30;
                                                                    break;
                                                                }
                                                                O = r.lens[r.have - 1], x = 3 + (3 & b), b >>>= 2, g -= 2;
                                                            } else if (17 === T) {
                                                                for(N = M + 3; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 3 + (7 & (b >>>= M)), b >>>= 3, g -= 3;
                                                            } else {
                                                                for(N = M + 7; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 11 + (127 & (b >>>= M)), b >>>= 7, g -= 7;
                                                            }
                                                            if (r.have + x > r.nlen + r.ndist) {
                                                                e.msg = "invalid bit length repeat", r.mode = 30;
                                                                break;
                                                            }
                                                            for(; x--;)r.lens[r.have++] = O;
                                                        }
                                                    }
                                                    if (30 === r.mode) break;
                                                    if (0 === r.lens[256]) {
                                                        e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.lenbits = 9, I = {
                                                        bits: r.lenbits
                                                    }, j = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid literal/lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.distbits = 6, r.distcode = r.distdyn, I = {
                                                        bits: r.distbits
                                                    }, j = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, I), r.distbits = I.bits, j) {
                                                        e.msg = "invalid distances set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.mode = 20, 6 === t) break e;
                                                case 20:
                                                    r.mode = 21;
                                                case 21:
                                                    if (6 <= p && 258 <= m) {
                                                        e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, o(e, _), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, 12 === r.mode && (r.back = -1);
                                                        break;
                                                    }
                                                    for(r.back = 0; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (C && 0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.lencode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, r.length = T, 0 === C) {
                                                        r.mode = 26;
                                                        break;
                                                    }
                                                    if (32 & C) {
                                                        r.back = -1, r.mode = 12;
                                                        break;
                                                    }
                                                    if (64 & C) {
                                                        e.msg = "invalid literal/length code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.extra = 15 & C, r.mode = 22;
                                                case 22:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    r.was = r.length, r.mode = 23;
                                                case 23:
                                                    for(; C = (P = r.distcode[b & (1 << r.distbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.distcode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, 64 & C) {
                                                        e.msg = "invalid distance code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.offset = T, r.extra = 15 & C, r.mode = 24;
                                                case 24:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.offset += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    if (r.offset > r.dmax) {
                                                        e.msg = "invalid distance too far back", r.mode = 30;
                                                        break;
                                                    }
                                                    r.mode = 25;
                                                case 25:
                                                    if (0 === m) break e;
                                                    if (x = _ - m, r.offset > x) {
                                                        if ((x = r.offset - x) > r.whave && r.sane) {
                                                            e.msg = "invalid distance too far back", r.mode = 30;
                                                            break;
                                                        }
                                                        k = x > r.wnext ? (x -= r.wnext, r.wsize - x) : r.wnext - x, x > r.length && (x = r.length), S = r.window;
                                                    } else S = h, k = d - r.offset, x = r.length;
                                                    for(m < x && (x = m), m -= x, r.length -= x; h[d++] = S[k++], --x;);
                                                    0 === r.length && (r.mode = 21);
                                                    break;
                                                case 26:
                                                    if (0 === m) break e;
                                                    h[d++] = r.length, m--, r.mode = 21;
                                                    break;
                                                case 27:
                                                    if (r.wrap) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b |= u[f++] << g, g += 8;
                                                        }
                                                        if (_ -= m, e.total_out += _, r.total += _, _ && (e.adler = r.check = r.flags ? s(r.check, h, _, d - _) : i(r.check, h, _, d - _)), _ = m, (r.flags ? b : c(b)) !== r.check) {
                                                            e.msg = "incorrect data check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 28;
                                                case 28:
                                                    if (r.wrap && r.flags) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (4294967295 & r.total)) {
                                                            e.msg = "incorrect length check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 29;
                                                case 29:
                                                    j = 1;
                                                    break e;
                                                case 30:
                                                    j = -3;
                                                    break e;
                                                case 31:
                                                    return -4;
                                                case 32:
                                                default:
                                                    return l;
                                            }
                                            return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, (r.wsize || _ !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && v(e, e.output, e.next_out, _ - e.avail_out) ? (r.mode = 31, -4) : (w -= e.avail_in, _ -= e.avail_out, e.total_in += w, e.total_out += _, r.total += _, r.wrap && _ && (e.adler = r.check = r.flags ? s(r.check, h, _, e.next_out - _) : i(r.check, h, _, e.next_out - _)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === _ || 4 === t) && 0 === j && (j = -5), j);
                                        }, r.inflateEnd = function(e) {
                                            if (!e || !e.state) return l;
                                            var t = e.state;
                                            return t.window && (t.window = null), e.state = null, 0;
                                        }, r.inflateGetHeader = function(e, t) {
                                            var r;
                                            return e && e.state ? 0 == (2 & (r = e.state).wrap) ? l : ((r.head = t).done = !1, 0) : l;
                                        }, r.inflateSetDictionary = function(e, t) {
                                            var r, n = t.length;
                                            return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? l : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : v(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : l;
                                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./inffast": 48,
                                        "./inftrees": 50
                                    }
                                ],
                                50: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = [
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9,
                                            10,
                                            11,
                                            13,
                                            15,
                                            17,
                                            19,
                                            23,
                                            27,
                                            31,
                                            35,
                                            43,
                                            51,
                                            59,
                                            67,
                                            83,
                                            99,
                                            115,
                                            131,
                                            163,
                                            195,
                                            227,
                                            258,
                                            0,
                                            0
                                        ], s = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            17,
                                            17,
                                            18,
                                            18,
                                            18,
                                            18,
                                            19,
                                            19,
                                            19,
                                            19,
                                            20,
                                            20,
                                            20,
                                            20,
                                            21,
                                            21,
                                            21,
                                            21,
                                            16,
                                            72,
                                            78
                                        ], o = [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            7,
                                            9,
                                            13,
                                            17,
                                            25,
                                            33,
                                            49,
                                            65,
                                            97,
                                            129,
                                            193,
                                            257,
                                            385,
                                            513,
                                            769,
                                            1025,
                                            1537,
                                            2049,
                                            3073,
                                            4097,
                                            6145,
                                            8193,
                                            12289,
                                            16385,
                                            24577,
                                            0,
                                            0
                                        ], a = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            18,
                                            18,
                                            19,
                                            19,
                                            20,
                                            20,
                                            21,
                                            21,
                                            22,
                                            22,
                                            23,
                                            23,
                                            24,
                                            24,
                                            25,
                                            25,
                                            26,
                                            26,
                                            27,
                                            27,
                                            28,
                                            28,
                                            29,
                                            29,
                                            64,
                                            64
                                        ];
                                        t.exports = function(e, t, r, l, c, u, h, f) {
                                            var d, p, m, b, g, y, v, w, _, x = f.bits, k = 0, S = 0, M = 0, C = 0, T = 0, E = 0, A = 0, R = 0, O = 0, j = 0, I = null, N = 0, P = new n.Buf16(16), B = new n.Buf16(16), D = null, F = 0;
                                            for(k = 0; k <= 15; k++)P[k] = 0;
                                            for(S = 0; S < l; S++)P[t[r + S]]++;
                                            for(T = x, C = 15; 1 <= C && 0 === P[C]; C--);
                                            if (C < T && (T = C), 0 === C) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
                                            for(M = 1; M < C && 0 === P[M]; M++);
                                            for(T < M && (T = M), k = R = 1; k <= 15; k++)if (R <<= 1, (R -= P[k]) < 0) return -1;
                                            if (0 < R && (0 === e || 1 !== C)) return -1;
                                            for(B[1] = 0, k = 1; k < 15; k++)B[k + 1] = B[k] + P[k];
                                            for(S = 0; S < l; S++)0 !== t[r + S] && (h[B[t[r + S]]++] = S);
                                            if (y = 0 === e ? (I = D = h, 19) : 1 === e ? (I = i, N -= 257, D = s, F -= 257, 256) : (I = o, D = a, -1), k = M, g = u, A = S = j = 0, m = -1, b = (O = 1 << (E = T)) - 1, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                            for(;;){
                                                for(v = k - A, _ = h[S] < y ? (w = 0, h[S]) : h[S] > y ? (w = D[F + h[S]], I[N + h[S]]) : (w = 96, 0), d = 1 << k - A, M = p = 1 << E; c[g + (j >> A) + (p -= d)] = v << 24 | w << 16 | _ | 0, 0 !== p;);
                                                for(d = 1 << k - 1; j & d;)d >>= 1;
                                                if (0 !== d ? (j &= d - 1, j += d) : j = 0, S++, 0 == --P[k]) {
                                                    if (k === C) break;
                                                    k = t[r + h[S]];
                                                }
                                                if (T < k && (j & b) !== m) {
                                                    for(0 === A && (A = T), g += M, R = 1 << (E = k - A); E + A < C && !((R -= P[E + A]) <= 0);)E++, R <<= 1;
                                                    if (O += 1 << E, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                                    c[m = j & b] = T << 24 | E << 16 | g - u | 0;
                                                }
                                            }
                                            return 0 !== j && (c[g + j] = k - A << 24 | 4194304), f.bits = T, 0;
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                51: [
                                    function(e, t, r) {
                                        t.exports = {
                                            2: "need dictionary",
                                            1: "stream end",
                                            0: "",
                                            "-1": "file error",
                                            "-2": "stream error",
                                            "-3": "data error",
                                            "-4": "insufficient memory",
                                            "-5": "buffer error",
                                            "-6": "incompatible version"
                                        };
                                    },
                                    {}
                                ],
                                52: [
                                    function(e, t, r) {
                                        var n = e("../utils/common");
                                        function i(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        var s = 256, o = 286, a = 30, l = 15, c = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            1,
                                            1,
                                            2,
                                            2,
                                            2,
                                            2,
                                            3,
                                            3,
                                            3,
                                            3,
                                            4,
                                            4,
                                            4,
                                            4,
                                            5,
                                            5,
                                            5,
                                            5,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            2,
                                            2,
                                            3,
                                            3,
                                            4,
                                            4,
                                            5,
                                            5,
                                            6,
                                            6,
                                            7,
                                            7,
                                            8,
                                            8,
                                            9,
                                            9,
                                            10,
                                            10,
                                            11,
                                            11,
                                            12,
                                            12,
                                            13,
                                            13
                                        ], h = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            3,
                                            7
                                        ], f = [
                                            16,
                                            17,
                                            18,
                                            0,
                                            8,
                                            7,
                                            9,
                                            6,
                                            10,
                                            5,
                                            11,
                                            4,
                                            12,
                                            3,
                                            13,
                                            2,
                                            14,
                                            1,
                                            15
                                        ], d = new Array(576);
                                        i(d);
                                        var p = new Array(60);
                                        i(p);
                                        var m = new Array(512);
                                        i(m);
                                        var b = new Array(256);
                                        i(b);
                                        var g = new Array(29);
                                        i(g);
                                        var y, v, w, _ = new Array(a);
                                        function x(e, t, r, n, i) {
                                            this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                                        }
                                        function k(e, t) {
                                            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                        }
                                        function S(e) {
                                            return e < 256 ? m[e] : m[256 + (e >>> 7)];
                                        }
                                        function M(e, t) {
                                            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                        }
                                        function C(e, t, r) {
                                            e.bi_valid > 16 - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += r - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                                        }
                                        function T(e, t, r) {
                                            C(e, r[2 * t], r[2 * t + 1]);
                                        }
                                        function E(e, t) {
                                            for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                                            return r >>> 1;
                                        }
                                        function A(e, t, r) {
                                            var n, i, s = new Array(16), o = 0;
                                            for(n = 1; n <= l; n++)s[n] = o = o + r[n - 1] << 1;
                                            for(i = 0; i <= t; i++){
                                                var a = e[2 * i + 1];
                                                0 !== a && (e[2 * i] = E(s[a]++, a));
                                            }
                                        }
                                        function R(e) {
                                            var t;
                                            for(t = 0; t < o; t++)e.dyn_ltree[2 * t] = 0;
                                            for(t = 0; t < a; t++)e.dyn_dtree[2 * t] = 0;
                                            for(t = 0; t < 19; t++)e.bl_tree[2 * t] = 0;
                                            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                        }
                                        function O(e) {
                                            8 < e.bi_valid ? M(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                        }
                                        function j(e, t, r, n) {
                                            var i = 2 * t, s = 2 * r;
                                            return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                                        }
                                        function I(e, t, r) {
                                            for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && j(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !j(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                                            e.heap[r] = n;
                                        }
                                        function N(e, t, r) {
                                            var n, i, o, a, l = 0;
                                            if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === n ? T(e, i, t) : (T(e, (o = b[i]) + s + 1, t), 0 !== (a = c[o]) && C(e, i -= g[o], a), T(e, o = S(--n), r), 0 !== (a = u[o]) && C(e, n -= _[o], a)), l < e.last_lit;);
                                            T(e, 256, t);
                                        }
                                        function P(e, t) {
                                            var r, n, i, s = t.dyn_tree, o = t.stat_desc.static_tree, a = t.stat_desc.has_stree, c = t.stat_desc.elems, u = -1;
                                            for(e.heap_len = 0, e.heap_max = 573, r = 0; r < c; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                                            for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
                                            for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)I(e, s, r);
                                            for(i = c; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], I(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, I(e, s, 1), 2 <= e.heap_len;);
                                            e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                                                var r, n, i, s, o, a, c = t.dyn_tree, u = t.max_code, h = t.stat_desc.static_tree, f = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, p = t.stat_desc.extra_base, m = t.stat_desc.max_length, b = 0;
                                                for(s = 0; s <= l; s++)e.bl_count[s] = 0;
                                                for(c[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < 573; r++)m < (s = c[2 * c[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = m, b++), c[2 * n + 1] = s, u < n || (e.bl_count[s]++, o = 0, p <= n && (o = d[n - p]), a = c[2 * n], e.opt_len += a * (s + o), f && (e.static_len += a * (h[2 * n + 1] + o)));
                                                if (0 !== b) {
                                                    do {
                                                        for(s = m - 1; 0 === e.bl_count[s];)s--;
                                                        e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[m]--, b -= 2;
                                                    }while (0 < b);
                                                    for(s = m; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (c[2 * i + 1] !== s && (e.opt_len += (s - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = s), n--);
                                                }
                                            }(e, t), A(s, u, e.bl_count);
                                        }
                                        function B(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = o, o = t[2 * (n + 1) + 1], ++a < l && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4));
                                        }
                                        function D(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), n = 0; n <= r; n++)if (i = o, o = t[2 * (n + 1) + 1], !(++a < l && i === o)) {
                                                if (a < c) for(; T(e, i, e.bl_tree), 0 != --a;);
                                                else 0 !== i ? (i !== s && (T(e, i, e.bl_tree), a--), T(e, 16, e.bl_tree), C(e, a - 3, 2)) : a <= 10 ? (T(e, 17, e.bl_tree), C(e, a - 3, 3)) : (T(e, 18, e.bl_tree), C(e, a - 11, 7));
                                                s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4);
                                            }
                                        }
                                        i(_);
                                        var F = !1;
                                        function L(e, t, r, i) {
                                            C(e, 0 + (i ? 1 : 0), 3), function(e, t, r, i) {
                                                O(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                                            }(e, t, r);
                                        }
                                        r._tr_init = function(e) {
                                            F || (function() {
                                                var e, t, r, n, i, s = new Array(16);
                                                for(n = r = 0; n < 28; n++)for(g[n] = r, e = 0; e < 1 << c[n]; e++)b[r++] = n;
                                                for(b[r - 1] = n, n = i = 0; n < 16; n++)for(_[n] = i, e = 0; e < 1 << u[n]; e++)m[i++] = n;
                                                for(i >>= 7; n < a; n++)for(_[n] = i << 7, e = 0; e < 1 << u[n] - 7; e++)m[256 + i++] = n;
                                                for(t = 0; t <= l; t++)s[t] = 0;
                                                for(e = 0; e <= 143;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(; e <= 255;)d[2 * e + 1] = 9, e++, s[9]++;
                                                for(; e <= 279;)d[2 * e + 1] = 7, e++, s[7]++;
                                                for(; e <= 287;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(A(d, 287, s), e = 0; e < a; e++)p[2 * e + 1] = 5, p[2 * e] = E(e, 5);
                                                y = new x(d, c, 257, o, l), v = new x(p, u, 0, a, l), w = new x(new Array(0), h, 0, 19, 7);
                                            }(), F = !0), e.l_desc = new k(e.dyn_ltree, y), e.d_desc = new k(e.dyn_dtree, v), e.bl_desc = new k(e.bl_tree, w), e.bi_buf = 0, e.bi_valid = 0, R(e);
                                        }, r._tr_stored_block = L, r._tr_flush_block = function(e, t, r, n) {
                                            var i, o, a = 0;
                                            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                                                var t, r = 4093624447;
                                                for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                                                for(t = 32; t < s; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                return 0;
                                            }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function(e) {
                                                var t;
                                                for(B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * f[t] + 1]; t--);
                                                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? L(e, t, r, n) : 4 === e.strategy || o === i ? (C(e, 2 + (n ? 1 : 0), 3), N(e, d, p)) : (C(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                                                var i;
                                                for(C(e, t - 257, 5), C(e, r - 1, 5), C(e, n - 4, 4), i = 0; i < n; i++)C(e, e.bl_tree[2 * f[i] + 1], 3);
                                                D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, r - 1);
                                            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), R(e), n && O(e);
                                        }, r._tr_tally = function(e, t, r) {
                                            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (b[r] + s + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                        }, r._tr_align = function(e) {
                                            C(e, 2, 3), T(e, 256, d), function(e) {
                                                16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                                            }(e);
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                53: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                        };
                                    },
                                    {}
                                ],
                                54: [
                                    function(e, t, r) {
                                        (function(e) {
                                            !function(e, t) {
                                                if (!e.setImmediate) {
                                                    var r, i, s, o, a = 1, l = {}, c = !1, u = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                                    h = h && h.setTimeout ? h : e, r = "[object process]" === ({}).toString.call(e.process) ? function(e) {
                                                        n.nextTick(function() {
                                                            d(e);
                                                        });
                                                    } : function() {
                                                        if (e.postMessage && !e.importScripts) {
                                                            var t = !0, r = e.onmessage;
                                                            return e.onmessage = function() {
                                                                t = !1;
                                                            }, e.postMessage("", "*"), e.onmessage = r, t;
                                                        }
                                                    }() ? (o = "setImmediate$" + Math.random() + "$", e.addEventListener ? e.addEventListener("message", p, !1) : e.attachEvent("onmessage", p), function(t) {
                                                        e.postMessage(o + t, "*");
                                                    }) : e.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(e) {
                                                        d(e.data);
                                                    }, function(e) {
                                                        s.port2.postMessage(e);
                                                    }) : u && "onreadystatechange" in u.createElement("script") ? (i = u.documentElement, function(e) {
                                                        var t = u.createElement("script");
                                                        t.onreadystatechange = function() {
                                                            d(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                                        }, i.appendChild(t);
                                                    }) : function(e) {
                                                        setTimeout(d, 0, e);
                                                    }, h.setImmediate = function(e) {
                                                        "function" != typeof e && (e = new Function("" + e));
                                                        for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                                        var i = {
                                                            callback: e,
                                                            args: t
                                                        };
                                                        return l[a] = i, r(a), a++;
                                                    }, h.clearImmediate = f;
                                                }
                                                function f(e) {
                                                    delete l[e];
                                                }
                                                function d(e) {
                                                    if (c) setTimeout(d, 0, e);
                                                    else {
                                                        var t = l[e];
                                                        if (t) {
                                                            c = !0;
                                                            try {
                                                                !function(e) {
                                                                    var t = e.callback, r = e.args;
                                                                    switch(r.length){
                                                                        case 0:
                                                                            t();
                                                                            break;
                                                                        case 1:
                                                                            t(r[0]);
                                                                            break;
                                                                        case 2:
                                                                            t(r[0], r[1]);
                                                                            break;
                                                                        case 3:
                                                                            t(r[0], r[1], r[2]);
                                                                            break;
                                                                        default:
                                                                            t.apply(void 0, r);
                                                                    }
                                                                }(t);
                                                            } finally{
                                                                f(e), c = !1;
                                                            }
                                                        }
                                                    }
                                                }
                                                function p(t) {
                                                    t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && d(+t.data.slice(o.length));
                                                }
                                            }("undefined" == typeof self ? void 0 === e ? this : e : self);
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ]
                            }, {}, [
                                10
                            ])(10);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], e("timers").setImmediate);
            },
            {
                _process: 467,
                buffer: 220,
                timers: 523
            }
        ],
        442: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /[\\^$.*+?()[\]{}|]/g, n = RegExp(r.source), i = "object" == typeof e && e && e.Object === Object && e, s = "object" == typeof self && self && self.Object === Object && self, o = i || s || Function("return this")(), a = Object.prototype.toString, l = o.Symbol, c = l ? l.prototype : void 0, u = c ? c.toString : void 0;
                        function h(e) {
                            if ("string" == typeof e) return e;
                            if (function(e) {
                                return "symbol" == typeof e || function(e) {
                                    return !!e && "object" == typeof e;
                                }(e) && "[object Symbol]" == a.call(e);
                            }(e)) return u ? u.call(e) : "";
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        t.exports = function(e) {
                            var t;
                            return (e = null == (t = e) ? "" : h(t)) && n.test(e) ? e.replace(r, "\\$&") : e;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        443: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, c = /^\./, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, h = /\\(\\)?/g, f = /^\[object .+?Constructor\]$/, d = /^(?:0|[1-9]\d*)$/, p = {};
                        p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[s] = p["[object RegExp]"] = p[o] = p["[object String]"] = p["[object WeakMap]"] = !1;
                        var m = "object" == typeof e && e && e.Object === Object && e, b = "object" == typeof self && self && self.Object === Object && self, g = m || b || Function("return this")(), y = "object" == typeof r && r && !r.nodeType && r, v = y && "object" == typeof t && t && !t.nodeType && t, w = v && v.exports === y && m.process, _ = function() {
                            try {
                                return w && w.binding("util");
                            } catch (e) {}
                        }(), x = _ && _.isTypedArray;
                        function k(e, t, r, n) {
                            for(var i = -1, s = e ? e.length : 0; ++i < s;){
                                var o = e[i];
                                t(n, o, r(o), e);
                            }
                            return n;
                        }
                        function S(e, t) {
                            for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function M(e) {
                            var t = !1;
                            if (null != e && "function" != typeof e.toString) try {
                                t = !!(e + "");
                            } catch (e) {}
                            return t;
                        }
                        function C(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function T(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var E, A, R, O = Array.prototype, j = Function.prototype, I = Object.prototype, N = g["__core-js_shared__"], P = (E = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", B = j.toString, D = I.hasOwnProperty, F = I.toString, L = RegExp("^" + B.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = g.Symbol, U = g.Uint8Array, $ = I.propertyIsEnumerable, H = O.splice, V = (A = Object.keys, R = Object, function(e) {
                            return A(R(e));
                        }), q = Ce(g, "DataView"), W = Ce(g, "Map"), X = Ce(g, "Promise"), K = Ce(g, "Set"), Y = Ce(g, "WeakMap"), Z = Ce(Object, "create"), G = Ne(q), J = Ne(W), Q = Ne(X), ee = Ne(K), te = Ne(Y), re = z ? z.prototype : void 0, ne = re ? re.valueOf : void 0, ie = re ? re.toString : void 0;
                        function se(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function oe(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ae(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function le(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new ae; ++t < r;)this.add(e[t]);
                        }
                        function ce(e) {
                            this.__data__ = new oe(e);
                        }
                        function ue(e, t) {
                            var r = Ue(e) || ze(e) ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], n = r.length, i = !!n;
                            for(var s in e)!t && !D.call(e, s) || i && ("length" == s || Ee(s, n)) || r.push(s);
                            return r;
                        }
                        function he(e, t) {
                            for(var r = e.length; r--;)if (Le(e[r][0], t)) return r;
                            return -1;
                        }
                        function fe(e, t, r, n) {
                            return me(e, function(e, i, s) {
                                t(n, e, r(e), s);
                            }), n;
                        }
                        se.prototype.clear = function() {
                            this.__data__ = Z ? Z(null) : {};
                        }, se.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, se.prototype.get = function(e) {
                            var t = this.__data__;
                            if (Z) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return D.call(t, e) ? t[e] : void 0;
                        }, se.prototype.has = function(e) {
                            var t = this.__data__;
                            return Z ? void 0 !== t[e] : D.call(t, e);
                        }, se.prototype.set = function(e, t) {
                            return this.__data__[e] = Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, oe.prototype.clear = function() {
                            this.__data__ = [];
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : H.call(t, r, 1), !0);
                        }, oe.prototype.get = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, oe.prototype.has = function(e) {
                            return he(this.__data__, e) > -1;
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__, n = he(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, ae.prototype.clear = function() {
                            this.__data__ = {
                                hash: new se,
                                map: new (W || oe),
                                string: new se
                            };
                        }, ae.prototype.delete = function(e) {
                            return Me(this, e).delete(e);
                        }, ae.prototype.get = function(e) {
                            return Me(this, e).get(e);
                        }, ae.prototype.has = function(e) {
                            return Me(this, e).has(e);
                        }, ae.prototype.set = function(e, t) {
                            return Me(this, e).set(e, t), this;
                        }, le.prototype.add = le.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, le.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.clear = function() {
                            this.__data__ = new oe;
                        }, ce.prototype.delete = function(e) {
                            return this.__data__.delete(e);
                        }, ce.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, ce.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof oe) {
                                var n = r.__data__;
                                if (!W || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this;
                                r = this.__data__ = new ae(n);
                            }
                            return r.set(e, t), this;
                        };
                        var de, pe, me = (de = function(e, t) {
                            return e && be(e, t, Ye);
                        }, function(e, t) {
                            if (null == e) return e;
                            if (!$e(e)) return de(e, t);
                            for(var r = e.length, n = pe ? r : -1, i = Object(e); (pe ? n-- : ++n < r) && !1 !== t(i[n], n, i););
                            return e;
                        }), be = function(e) {
                            return function(t, r, n) {
                                for(var i = -1, s = Object(t), o = n(t), a = o.length; a--;){
                                    var l = o[e ? a : ++i];
                                    if (!1 === r(s[l], l, s)) break;
                                }
                                return t;
                            };
                        }();
                        function ge(e, t) {
                            for(var r = 0, n = (t = Ae(t, e) ? [
                                t
                            ] : ke(t)).length; null != e && r < n;)e = e[Ie(t[r++])];
                            return r && r == n ? e : void 0;
                        }
                        function ye(e, t) {
                            return null != e && t in Object(e);
                        }
                        function ve(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !qe(e) && !We(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Ue(e), h = Ue(t), f = "[object Array]", d = "[object Array]";
                                u || (f = (f = Te(e)) == n ? s : f);
                                h || (d = (d = Te(t)) == n ? s : d);
                                var p = f == s && !M(e), m = d == s && !M(t), b = f == d;
                                if (b && !p) return c || (c = new ce), u || Ke(e) ? Se(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !n(new U(e), new U(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return Le(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = C;
                                        case o:
                                            var u = 2 & a;
                                            if (c || (c = T), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            a |= 1, l.set(e, t);
                                            var f = Se(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (ne) return ne.call(e) == ne.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(2 & l)) {
                                    var g = p && D.call(e, "__wrapped__"), y = m && D.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, w = y ? t.value() : t;
                                        return c || (c = new ce), r(v, w, a, l, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new ce), function(e, t, r, n, i, s) {
                                    var o = 2 & i, a = Ye(e), l = a.length, c = Ye(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : D.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || r(m, b, n, i, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, ve, r, a, l));
                        }
                        function we(e) {
                            return !(!qe(e) || function(e) {
                                return !!P && P in e;
                            }(e)) && (He(e) || M(e) ? L : f).test(Ne(e));
                        }
                        function _e(e) {
                            var t, r;
                            return "function" == typeof e ? e : null == e ? Ze : "object" == typeof e ? Ue(e) ? function(e, t) {
                                if (Ae(e) && Re(t)) return Oe(Ie(e), t);
                                return function(r) {
                                    var n = function(e, t, r) {
                                        var n = null == e ? void 0 : ge(e, t);
                                        return void 0 === n ? r : n;
                                    }(r, e);
                                    return void 0 === n && n === t ? function(e, t) {
                                        return null != e && function(e, t, r) {
                                            t = Ae(t, e) ? [
                                                t
                                            ] : ke(t);
                                            var n, i = -1, s = t.length;
                                            for(; ++i < s;){
                                                var o = Ie(t[i]);
                                                if (!(n = null != e && r(e, o))) break;
                                                e = e[o];
                                            }
                                            if (n) return n;
                                            return !!(s = e ? e.length : 0) && Ve(s) && Ee(o, s) && (Ue(e) || ze(e));
                                        }(e, t, ye);
                                    }(r, e) : ve(t, n, void 0, 3);
                                };
                            }(e[0], e[1]) : function(e) {
                                var t = function(e) {
                                    var t = Ye(e), r = t.length;
                                    for(; r--;){
                                        var n = t[r], i = e[n];
                                        t[r] = [
                                            n,
                                            i,
                                            Re(i)
                                        ];
                                    }
                                    return t;
                                }(e);
                                if (1 == t.length && t[0][2]) return Oe(t[0][0], t[0][1]);
                                return function(r) {
                                    return r === e || function(e, t, r, n) {
                                        var i = r.length, s = i, o = !n;
                                        if (null == e) return !s;
                                        for(e = Object(e); i--;){
                                            var a = r[i];
                                            if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                                        }
                                        for(; ++i < s;){
                                            var l = (a = r[i])[0], c = e[l], u = a[1];
                                            if (o && a[2]) {
                                                if (void 0 === c && !(l in e)) return !1;
                                            } else {
                                                var h = new ce;
                                                if (n) var f = n(c, u, l, e, t, h);
                                                if (!(void 0 === f ? ve(u, c, n, 3, h) : f)) return !1;
                                            }
                                        }
                                        return !0;
                                    }(r, e, t);
                                };
                            }(e) : Ae(t = e) ? (r = Ie(t), function(e) {
                                return null == e ? void 0 : e[r];
                            }) : function(e) {
                                return function(t) {
                                    return ge(t, e);
                                };
                            }(t);
                        }
                        function xe(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || I, t !== n) return V(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))D.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function ke(e) {
                            return Ue(e) ? e : je(e);
                        }
                        function Se(e, t, r, n, i, s) {
                            var o = 2 & i, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 1 & i ? new le : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!S(t, function(e, t) {
                                        if (!f.has(t) && (d === e || r(d, e, n, i, s))) return f.add(t);
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !r(d, p, n, i, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function Me(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function Ce(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return we(r) ? r : void 0;
                        }
                        var Te = function(e) {
                            return F.call(e);
                        };
                        function Ee(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || d.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function Ae(e, t) {
                            if (Ue(e)) return !1;
                            var r = typeof e;
                            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Xe(e)) || l.test(e) || !a.test(e) || null != t && e in Object(t);
                        }
                        function Re(e) {
                            return e == e && !qe(e);
                        }
                        function Oe(e, t) {
                            return function(r) {
                                return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                            };
                        }
                        (q && "[object DataView]" != Te(new q(new ArrayBuffer(1))) || W && Te(new W) != i || X && "[object Promise]" != Te(X.resolve()) || K && Te(new K) != o || Y && "[object WeakMap]" != Te(new Y)) && (Te = function(e) {
                            var t = F.call(e), r = t == s ? e.constructor : void 0, n = r ? Ne(r) : void 0;
                            if (n) switch(n){
                                case G:
                                    return "[object DataView]";
                                case J:
                                    return i;
                                case Q:
                                    return "[object Promise]";
                                case ee:
                                    return o;
                                case te:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var je = Fe(function(e) {
                            var t;
                            e = null == (t = e) ? "" : function(e) {
                                if ("string" == typeof e) return e;
                                if (Xe(e)) return ie ? ie.call(e) : "";
                                var t = e + "";
                                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                            }(t);
                            var r = [];
                            return c.test(e) && r.push(""), e.replace(u, function(e, t, n, i) {
                                r.push(n ? i.replace(h, "$1") : t || e);
                            }), r;
                        });
                        function Ie(e) {
                            if ("string" == typeof e || Xe(e)) return e;
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        function Ne(e) {
                            if (null != e) {
                                try {
                                    return B.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        var Pe, Be, De = (Pe = function(e, t, r) {
                            D.call(e, r) ? e[r].push(t) : e[r] = [
                                t
                            ];
                        }, function(e, t) {
                            var r = Ue(e) ? k : fe, n = Be ? Be() : {};
                            return r(e, Pe, _e(t), n);
                        });
                        function Fe(e, t) {
                            if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                            var r = function() {
                                var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                                if (s.has(i)) return s.get(i);
                                var o = e.apply(this, n);
                                return r.cache = s.set(i, o), o;
                            };
                            return r.cache = new (Fe.Cache || ae), r;
                        }
                        function Le(e, t) {
                            return e === t || e != e && t != t;
                        }
                        function ze(e) {
                            return function(e) {
                                return We(e) && $e(e);
                            }(e) && D.call(e, "callee") && (!$.call(e, "callee") || F.call(e) == n);
                        }
                        Fe.Cache = ae;
                        var Ue = Array.isArray;
                        function $e(e) {
                            return null != e && Ve(e.length) && !He(e);
                        }
                        function He(e) {
                            var t = qe(e) ? F.call(e) : "";
                            return "[object Function]" == t || "[object GeneratorFunction]" == t;
                        }
                        function Ve(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function qe(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        function We(e) {
                            return !!e && "object" == typeof e;
                        }
                        function Xe(e) {
                            return "symbol" == typeof e || We(e) && "[object Symbol]" == F.call(e);
                        }
                        var Ke = x ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(x) : function(e) {
                            return We(e) && Ve(e.length) && !!p[F.call(e)];
                        };
                        function Ye(e) {
                            return $e(e) ? ue(e) : xe(e);
                        }
                        function Ze(e) {
                            return e;
                        }
                        t.exports = De;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        444: [
            function(e, t, r) {
                "use strict";
                var n = Object.prototype.toString;
                t.exports = function(e) {
                    return !0 === e || !1 === e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Boolean]" == n.call(e);
                };
            },
            {}
        ],
        445: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /^\[object .+?Constructor\]$/, l = /^(?:0|[1-9]\d*)$/, c = {};
                        c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[n] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c[i] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c[o] = c["[object String]"] = c["[object WeakMap]"] = !1;
                        var u = "object" == typeof e && e && e.Object === Object && e, h = "object" == typeof self && self && self.Object === Object && self, f = u || h || Function("return this")(), d = "object" == typeof r && r && !r.nodeType && r, p = d && "object" == typeof t && t && !t.nodeType && t, m = p && p.exports === d, b = m && u.process, g = function() {
                            try {
                                return b && b.binding && b.binding("util");
                            } catch (e) {}
                        }(), y = g && g.isTypedArray;
                        function v(e, t) {
                            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function w(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function _(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var x, k, S, M = Array.prototype, C = Function.prototype, T = Object.prototype, E = f["__core-js_shared__"], A = C.toString, R = T.hasOwnProperty, O = (x = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", j = T.toString, I = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = m ? f.Buffer : void 0, P = f.Symbol, B = f.Uint8Array, D = T.propertyIsEnumerable, F = M.splice, L = P ? P.toStringTag : void 0, z = Object.getOwnPropertySymbols, U = N ? N.isBuffer : void 0, $ = (k = Object.keys, S = Object, function(e) {
                            return k(S(e));
                        }), H = ge(f, "DataView"), V = ge(f, "Map"), q = ge(f, "Promise"), W = ge(f, "Set"), X = ge(f, "WeakMap"), K = ge(Object, "create"), Y = _e(H), Z = _e(V), G = _e(q), J = _e(W), Q = _e(X), ee = P ? P.prototype : void 0, te = ee ? ee.valueOf : void 0;
                        function re(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ne(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ie(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function se(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.__data__ = new ie; ++t < r;)this.add(e[t]);
                        }
                        function oe(e) {
                            var t = this.__data__ = new ne(e);
                            this.size = t.size;
                        }
                        function ae(e, t) {
                            var r = Se(e), n = !r && ke(e), i = !r && !n && Me(e), s = !r && !n && !i && Re(e), o = r || n || i || s, a = o ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], l = a.length;
                            for(var c in e)!t && !R.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || we(c, l)) || a.push(c);
                            return a;
                        }
                        function le(e, t) {
                            for(var r = e.length; r--;)if (xe(e[r][0], t)) return r;
                            return -1;
                        }
                        function ce(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : L && L in Object(e) ? function(e) {
                                var t = R.call(e, L), r = e[L];
                                try {
                                    e[L] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = j.call(e);
                                n && (t ? e[L] = r : delete e[L]);
                                return i;
                            }(e) : function(e) {
                                return j.call(e);
                            }(e);
                        }
                        function ue(e) {
                            return Ae(e) && ce(e) == n;
                        }
                        function he(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !Ae(e) && !Ae(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Se(e), h = Se(t), f = u ? "[object Array]" : ve(e), d = h ? "[object Array]" : ve(t), p = (f = f == n ? s : f) == s, m = (d = d == n ? s : d) == s, b = f == d;
                                if (b && Me(e)) {
                                    if (!Me(t)) return !1;
                                    u = !0, p = !1;
                                }
                                if (b && !p) return c || (c = new oe), u || Re(e) ? pe(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !a(new B(e), new B(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return xe(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = w;
                                        case o:
                                            var u = 1 & n;
                                            if (c || (c = _), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            n |= 2, l.set(e, t);
                                            var f = pe(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (te) return te.call(e) == te.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(1 & r)) {
                                    var g = p && R.call(e, "__wrapped__"), y = m && R.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, x = y ? t.value() : t;
                                        return c || (c = new oe), l(v, x, r, a, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new oe), function(e, t, r, n, i, s) {
                                    var o = 1 & r, a = me(e), l = a.length, c = me(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : R.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || i(m, b, r, n, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, r, a, he, l));
                        }
                        function fe(e) {
                            return !(!Ee(e) || function(e) {
                                return !!O && O in e;
                            }(e)) && (Ce(e) ? I : a).test(_e(e));
                        }
                        function de(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || T, t !== n) return $(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))R.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function pe(e, t, r, n, i, s) {
                            var o = 1 & r, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 2 & r ? new se : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!v(t, function(e, t) {
                                        if (o = t, !f.has(o) && (d === e || i(d, e, r, n, s))) return f.push(t);
                                        var o;
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !i(d, p, r, n, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function me(e) {
                            return function(e, t, r) {
                                var n = t(e);
                                return Se(e) ? n : function(e, t) {
                                    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                                    return e;
                                }(n, r(e));
                            }(e, Oe, ye);
                        }
                        function be(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function ge(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return fe(r) ? r : void 0;
                        }
                        re.prototype.clear = function() {
                            this.__data__ = K ? K(null) : {}, this.size = 0;
                        }, re.prototype.delete = function(e) {
                            var t = this.has(e) && delete this.__data__[e];
                            return this.size -= t ? 1 : 0, t;
                        }, re.prototype.get = function(e) {
                            var t = this.__data__;
                            if (K) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return R.call(t, e) ? t[e] : void 0;
                        }, re.prototype.has = function(e) {
                            var t = this.__data__;
                            return K ? void 0 !== t[e] : R.call(t, e);
                        }, re.prototype.set = function(e, t) {
                            var r = this.__data__;
                            return this.size += this.has(e) ? 0 : 1, r[e] = K && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, ne.prototype.clear = function() {
                            this.__data__ = [], this.size = 0;
                        }, ne.prototype.delete = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : F.call(t, r, 1), --this.size, !0);
                        }, ne.prototype.get = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, ne.prototype.has = function(e) {
                            return le(this.__data__, e) > -1;
                        }, ne.prototype.set = function(e, t) {
                            var r = this.__data__, n = le(r, e);
                            return n < 0 ? (++this.size, r.push([
                                e,
                                t
                            ])) : r[n][1] = t, this;
                        }, ie.prototype.clear = function() {
                            this.size = 0, this.__data__ = {
                                hash: new re,
                                map: new (V || ne),
                                string: new re
                            };
                        }, ie.prototype.delete = function(e) {
                            var t = be(this, e).delete(e);
                            return this.size -= t ? 1 : 0, t;
                        }, ie.prototype.get = function(e) {
                            return be(this, e).get(e);
                        }, ie.prototype.has = function(e) {
                            return be(this, e).has(e);
                        }, ie.prototype.set = function(e, t) {
                            var r = be(this, e), n = r.size;
                            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
                        }, se.prototype.add = se.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, se.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.clear = function() {
                            this.__data__ = new ne, this.size = 0;
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = t.delete(e);
                            return this.size = t.size, r;
                        }, oe.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, oe.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof ne) {
                                var n = r.__data__;
                                if (!V || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this.size = ++r.size, this;
                                r = this.__data__ = new ie(n);
                            }
                            return r.set(e, t), this.size = r.size, this;
                        };
                        var ye = z ? function(e) {
                            return null == e ? [] : (e = Object(e), function(e, t) {
                                for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                                    var o = e[r];
                                    t(o, r, e) && (s[i++] = o);
                                }
                                return s;
                            }(z(e), function(t) {
                                return D.call(e, t);
                            }));
                        } : function() {
                            return [];
                        }, ve = ce;
                        function we(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || l.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function _e(e) {
                            if (null != e) {
                                try {
                                    return A.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        function xe(e, t) {
                            return e === t || e != e && t != t;
                        }
                        (H && "[object DataView]" != ve(new H(new ArrayBuffer(1))) || V && ve(new V) != i || q && "[object Promise]" != ve(q.resolve()) || W && ve(new W) != o || X && "[object WeakMap]" != ve(new X)) && (ve = function(e) {
                            var t = ce(e), r = t == s ? e.constructor : void 0, n = r ? _e(r) : "";
                            if (n) switch(n){
                                case Y:
                                    return "[object DataView]";
                                case Z:
                                    return i;
                                case G:
                                    return "[object Promise]";
                                case J:
                                    return o;
                                case Q:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var ke = ue(function() {
                            return arguments;
                        }()) ? ue : function(e) {
                            return Ae(e) && R.call(e, "callee") && !D.call(e, "callee");
                        }, Se = Array.isArray;
                        var Me = U || function() {
                            return !1;
                        };
                        function Ce(e) {
                            if (!Ee(e)) return !1;
                            var t = ce(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        }
                        function Te(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function Ee(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function Ae(e) {
                            return null != e && "object" == typeof e;
                        }
                        var Re = y ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(y) : function(e) {
                            return Ae(e) && Te(e.length) && !!c[ce(e)];
                        };
                        function Oe(e) {
                            var t;
                            return null != (t = e) && Te(t.length) && !Ce(t) ? ae(e) : de(e);
                        }
                        t.exports = function(e, t) {
                            return he(e, t);
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        446: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = "object" == typeof e && e && e.Object === Object && e, n = "object" == typeof self && self && self.Object === Object && self, i = r || n || Function("return this")(), s = Object.prototype, o = s.hasOwnProperty, a = s.toString, l = i.Symbol, c = l ? l.toStringTag : void 0;
                        function u(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(e) {
                                var t = o.call(e, c), r = e[c];
                                try {
                                    e[c] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = a.call(e);
                                n && (t ? e[c] = r : delete e[c]);
                                return i;
                            }(e) : function(e) {
                                return a.call(e);
                            }(e);
                        }
                        t.exports = function(e) {
                            if (!function(e) {
                                var t = typeof e;
                                return null != e && ("object" == t || "function" == t);
                            }(e)) return !1;
                            var t = u(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        447: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        448: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return void 0 === e;
                };
            },
            {}
        ],
        449: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /^\[object .+?Constructor\]$/, n = "object" == typeof e && e && e.Object === Object && e, i = "object" == typeof self && self && self.Object === Object && self, s = n || i || Function("return this")();
                        function o(e, t) {
                            return !!(e ? e.length : 0) && function(e, t, r) {
                                if (t != t) return function(e, t, r, n) {
                                    var i = e.length, s = r + (n ? 1 : -1);
                                    for(; n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
                                    return -1;
                                }(e, l, r);
                                var n = r - 1, i = e.length;
                                for(; ++n < i;)if (e[n] === t) return n;
                                return -1;
                            }(e, t, 0) > -1;
                        }
                        function a(e, t, r) {
                            for(var n = -1, i = e ? e.length : 0; ++n < i;)if (r(t, e[n])) return !0;
                            return !1;
                        }
                        function l(e) {
                            return e != e;
                        }
                        function c(e, t) {
                            return e.has(t);
                        }
                        function u(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var h, f = Array.prototype, d = Function.prototype, p = Object.prototype, m = s["__core-js_shared__"], b = (h = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "")) ? "Symbol(src)_1." + h : "", g = d.toString, y = p.hasOwnProperty, v = p.toString, w = RegExp("^" + g.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _ = f.splice, x = I(s, "Map"), k = I(s, "Set"), S = I(Object, "create");
                        function M(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function C(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function T(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function E(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new T; ++t < r;)this.add(e[t]);
                        }
                        function A(e, t) {
                            for(var r, n, i = e.length; i--;)if ((r = e[i][0]) === (n = t) || r != r && n != n) return i;
                            return -1;
                        }
                        function R(e) {
                            var t;
                            return !(!N(e) || (t = e, b && b in t)) && ((function(e) {
                                var t = N(e) ? v.call(e) : "";
                                return "[object Function]" == t || "[object GeneratorFunction]" == t;
                            })(e) || function(e) {
                                var t = !1;
                                if (null != e && "function" != typeof e.toString) try {
                                    t = !!(e + "");
                                } catch (e) {}
                                return t;
                            }(e) ? w : r).test(function(e) {
                                if (null != e) {
                                    try {
                                        return g.call(e);
                                    } catch (e) {}
                                    try {
                                        return e + "";
                                    } catch (e) {}
                                }
                                return "";
                            }(e));
                        }
                        M.prototype.clear = function() {
                            this.__data__ = S ? S(null) : {};
                        }, M.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, M.prototype.get = function(e) {
                            var t = this.__data__;
                            if (S) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return y.call(t, e) ? t[e] : void 0;
                        }, M.prototype.has = function(e) {
                            var t = this.__data__;
                            return S ? void 0 !== t[e] : y.call(t, e);
                        }, M.prototype.set = function(e, t) {
                            return this.__data__[e] = S && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, C.prototype.clear = function() {
                            this.__data__ = [];
                        }, C.prototype.delete = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : _.call(t, r, 1), !0);
                        }, C.prototype.get = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, C.prototype.has = function(e) {
                            return A(this.__data__, e) > -1;
                        }, C.prototype.set = function(e, t) {
                            var r = this.__data__, n = A(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, T.prototype.clear = function() {
                            this.__data__ = {
                                hash: new M,
                                map: new (x || C),
                                string: new M
                            };
                        }, T.prototype.delete = function(e) {
                            return j(this, e).delete(e);
                        }, T.prototype.get = function(e) {
                            return j(this, e).get(e);
                        }, T.prototype.has = function(e) {
                            return j(this, e).has(e);
                        }, T.prototype.set = function(e, t) {
                            return j(this, e).set(e, t), this;
                        }, E.prototype.add = E.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, E.prototype.has = function(e) {
                            return this.__data__.has(e);
                        };
                        var O = k && 1 / u(new k([
                            ,
                            -0
                        ]))[1] == 1 / 0 ? function(e) {
                            return new k(e);
                        } : function() {};
                        function j(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function I(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return R(r) ? r : void 0;
                        }
                        function N(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        t.exports = function(e) {
                            return e && e.length ? function(e, t, r) {
                                var n = -1, i = o, s = e.length, l = !0, h = [], f = h;
                                if (r) l = !1, i = a;
                                else if (s >= 200) {
                                    var d = t ? null : O(e);
                                    if (d) return u(d);
                                    l = !1, i = c, f = new E;
                                } else f = t ? [] : h;
                                e: for(; ++n < s;){
                                    var p = e[n], m = t ? t(p) : p;
                                    if (p = r || 0 !== p ? p : 0, l && m == m) {
                                        for(var b = f.length; b--;)if (f[b] === m) continue e;
                                        t && f.push(m), h.push(p);
                                    } else i(f, m, r) || (f !== h && f.push(m), h.push(p));
                                }
                                return h;
                            }(e) : [];
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        450: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("hash-base"), s = e("safe-buffer").Buffer, o = new Array(16);
                function a() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function l(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, s, o) {
                    return l(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
                }
                function u(e, t, r, n, i, s, o) {
                    return l(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
                }
                function h(e, t, r, n, i, s, o) {
                    return l(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
                }
                function f(e, t, r, n, i, s, o) {
                    return l(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
                }
                n(a, i), a.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, s = this._d;
                    r = c(r, n, i, s, e[0], 3614090360, 7), s = c(s, r, n, i, e[1], 3905402710, 12), i = c(i, s, r, n, e[2], 606105819, 17), n = c(n, i, s, r, e[3], 3250441966, 22), r = c(r, n, i, s, e[4], 4118548399, 7), s = c(s, r, n, i, e[5], 1200080426, 12), i = c(i, s, r, n, e[6], 2821735955, 17), n = c(n, i, s, r, e[7], 4249261313, 22), r = c(r, n, i, s, e[8], 1770035416, 7), s = c(s, r, n, i, e[9], 2336552879, 12), i = c(i, s, r, n, e[10], 4294925233, 17), n = c(n, i, s, r, e[11], 2304563134, 22), r = c(r, n, i, s, e[12], 1804603682, 7), s = c(s, r, n, i, e[13], 4254626195, 12), i = c(i, s, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, s, r, e[15], 1236535329, 22), i, s, e[1], 4129170786, 5), s = u(s, r, n, i, e[6], 3225465664, 9), i = u(i, s, r, n, e[11], 643717713, 14), n = u(n, i, s, r, e[0], 3921069994, 20), r = u(r, n, i, s, e[5], 3593408605, 5), s = u(s, r, n, i, e[10], 38016083, 9), i = u(i, s, r, n, e[15], 3634488961, 14), n = u(n, i, s, r, e[4], 3889429448, 20), r = u(r, n, i, s, e[9], 568446438, 5), s = u(s, r, n, i, e[14], 3275163606, 9), i = u(i, s, r, n, e[3], 4107603335, 14), n = u(n, i, s, r, e[8], 1163531501, 20), r = u(r, n, i, s, e[13], 2850285829, 5), s = u(s, r, n, i, e[2], 4243563512, 9), i = u(i, s, r, n, e[7], 1735328473, 14), r = h(r, n = u(n, i, s, r, e[12], 2368359562, 20), i, s, e[5], 4294588738, 4), s = h(s, r, n, i, e[8], 2272392833, 11), i = h(i, s, r, n, e[11], 1839030562, 16), n = h(n, i, s, r, e[14], 4259657740, 23), r = h(r, n, i, s, e[1], 2763975236, 4), s = h(s, r, n, i, e[4], 1272893353, 11), i = h(i, s, r, n, e[7], 4139469664, 16), n = h(n, i, s, r, e[10], 3200236656, 23), r = h(r, n, i, s, e[13], 681279174, 4), s = h(s, r, n, i, e[0], 3936430074, 11), i = h(i, s, r, n, e[3], 3572445317, 16), n = h(n, i, s, r, e[6], 76029189, 23), r = h(r, n, i, s, e[9], 3654602809, 4), s = h(s, r, n, i, e[12], 3873151461, 11), i = h(i, s, r, n, e[15], 530742520, 16), r = f(r, n = h(n, i, s, r, e[2], 3299628645, 23), i, s, e[0], 4096336452, 6), s = f(s, r, n, i, e[7], 1126891415, 10), i = f(i, s, r, n, e[14], 2878612391, 15), n = f(n, i, s, r, e[5], 4237533241, 21), r = f(r, n, i, s, e[12], 1700485571, 6), s = f(s, r, n, i, e[3], 2399980690, 10), i = f(i, s, r, n, e[10], 4293915773, 15), n = f(n, i, s, r, e[1], 2240044497, 21), r = f(r, n, i, s, e[8], 1873313359, 6), s = f(s, r, n, i, e[15], 4264355552, 10), i = f(i, s, r, n, e[6], 2734768916, 15), n = f(n, i, s, r, e[13], 1309151649, 21), r = f(r, n, i, s, e[4], 4149444226, 6), s = f(s, r, n, i, e[11], 3174756917, 10), i = f(i, s, r, n, e[2], 718787259, 15), n = f(n, i, s, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
                }, a.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = s.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, t.exports = a;
            },
            {
                "hash-base": 425,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        451: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("brorand");
                function s(e) {
                    this.rand = e || new i.Rand;
                }
                t.exports = s, s.create = function(e) {
                    return new s(e);
                }, s.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, s.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, s.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), s = n.mont(e), o = new n(1).toRed(s);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var a = e.subn(1), l = 0; !a.testn(l); l++);
                    for(var c = e.shrn(l), u = a.toRed(s); t > 0; t--){
                        var h = this._randrange(new n(2), a);
                        r && r(h);
                        var f = h.toRed(s).redPow(c);
                        if (0 !== f.cmp(o) && 0 !== f.cmp(u)) {
                            for(var d = 1; d < l; d++){
                                if (0 === (f = f.redSqr()).cmp(o)) return !1;
                                if (0 === f.cmp(u)) break;
                            }
                            if (d === l) return !1;
                        }
                    }
                    return !0;
                }, s.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), s = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var o = e.subn(1), a = 0; !o.testn(a); a++);
                    for(var l = e.shrn(a), c = o.toRed(i); t > 0; t--){
                        var u = this._randrange(new n(2), o), h = e.gcd(u);
                        if (0 !== h.cmpn(1)) return h;
                        var f = u.toRed(i).redPow(l);
                        if (0 !== f.cmp(s) && 0 !== f.cmp(c)) {
                            for(var d = 1; d < a; d++){
                                if (0 === (f = f.redSqr()).cmp(s)) return f.fromRed().subn(1).gcd(e);
                                if (0 === f.cmp(c)) break;
                            }
                            if (d === a) return (f = f.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            {
                "bn.js": 452,
                brorand: 187
            }
        ],
        452: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        453: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                t.exports = n, n.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            {}
        ],
        454: [
            function(e, t, r) {
                "use strict";
                var n = r;
                function i(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function s(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += i(e[r].toString(16));
                    return t;
                }
                n.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) {
                        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                        for(n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    } else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), s = i >> 8, o = 255 & i;
                        s ? r.push(s, o) : r.push(o);
                    }
                    return r;
                }, n.zero2 = i, n.toHex = s, n.encode = function(e, t) {
                    return "hex" === t ? s(e) : e;
                };
            },
            {}
        ],
        455: [
            function(e, t, r) {
                t.exports = {
                    "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
                    "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
                    "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
                    "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
                    "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
                    "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
                    "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
                    "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
                    "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
                    "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
                    "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
                    "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
                };
            },
            {}
        ],
        456: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js");
                r.certificate = e("./certificate");
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                r.RSAPrivateKey = i;
                var s = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                r.RSAPublicKey = s;
                var o = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                });
                r.PublicKey = o;
                var a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), l = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
                });
                r.PrivateKey = l;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                r.EncryptedPrivateKey = c;
                var u = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                r.DSAPrivateKey = u, r.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var h = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(f), this.key("publicKey").optional().explicit(1).bitstr());
                });
                r.ECPrivateKey = h;
                var f = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                r.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            {
                "./certificate": 457,
                "asn1.js": 170
            }
        ],
        457: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js"), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), s = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), o = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
                }), l = n.define("RelativeDistinguishedName", function() {
                    this.setof(s);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(l);
                }), u = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), h = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), f = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), d = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(f).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(d), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
                });
                t.exports = p;
            },
            {
                "asn1.js": 170
            }
        ],
        458: [
            function(e, t, r) {
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = e("evp_bytestokey"), a = e("browserify-aes"), l = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    var r, c = e.toString(), u = c.match(n);
                    if (u) {
                        var h = "aes" + u[1], f = l.from(u[2], "hex"), d = l.from(u[3].replace(/[\r\n]/g, ""), "base64"), p = o(t, f.slice(0, 8), parseInt(u[1], 10)).key, m = [], b = a.createDecipheriv(h, p, f);
                        m.push(b.update(d)), m.push(b.final()), r = l.concat(m);
                    } else {
                        var g = c.match(s);
                        r = l.from(g[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            {
                "browserify-aes": 191,
                evp_bytestokey: 423,
                "safe-buffer": 494
            }
        ],
        459: [
            function(e, t, r) {
                "use strict";
                var n = e("./asn1"), i = e("./aesid.json"), s = e("./fixProc"), o = e("browserify-aes"), a = e("pbkdf2"), l = e("safe-buffer").Buffer;
                function c(e) {
                    var t;
                    "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
                    var r, c, u = s(e, t), h = u.tag, f = u.data;
                    switch(h){
                        case "CERTIFICATE":
                            c = n.certificate.decode(f, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(c || (c = n.PublicKey.decode(f, "der")), r = c.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return c.subjectPrivateKey = c.subjectPublicKey, {
                                        type: "ec",
                                        data: c
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            f = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), s = i[e.algorithm.decrypt.cipher.algo.join(".")], c = e.algorithm.decrypt.cipher.iv, u = e.subjectPrivateKey, h = parseInt(s.split("-")[1], 10) / 8, f = a.pbkdf2Sync(t, r, n, h, "sha1"), d = o.createDecipheriv(s, f, c), p = [];
                                return p.push(d.update(u)), p.push(d.final()), l.concat(p);
                            }(f = n.EncryptedPrivateKey.decode(f, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (c = n.PrivateKey.decode(f, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: c.algorithm.curve,
                                        privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return n.RSAPublicKey.decode(f, "der");
                        case "RSA PRIVATE KEY":
                            return n.RSAPrivateKey.decode(f, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: n.DSAPrivateKey.decode(f, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (f = n.ECPrivateKey.decode(f, "der")).parameters.value,
                                privateKey: f.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + h);
                    }
                }
                t.exports = c, c.signature = n.signature;
            },
            {
                "./aesid.json": 455,
                "./asn1": 456,
                "./fixProc": 458,
                "browserify-aes": 191,
                pbkdf2: 460,
                "safe-buffer": 494
            }
        ],
        460: [
            function(e, t, r) {
                "use strict";
                r.pbkdf2 = e("./lib/async"), r.pbkdf2Sync = e("./lib/sync");
            },
            {
                "./lib/async": 461,
                "./lib/sync": 464
            }
        ],
        461: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i, s = e("safe-buffer").Buffer, o = e("./precondition"), a = e("./default-encoding"), l = e("./sync"), c = e("./to-buffer"), u = r.crypto && r.crypto.subtle, h = {
                            sha: "SHA-1",
                            "sha-1": "SHA-1",
                            sha1: "SHA-1",
                            sha256: "SHA-256",
                            "sha-256": "SHA-256",
                            sha384: "SHA-384",
                            "sha-384": "SHA-384",
                            "sha-512": "SHA-512",
                            sha512: "SHA-512"
                        }, f = [];
                        function d() {
                            return i || (i = r.process && r.process.nextTick ? r.process.nextTick : r.queueMicrotask ? r.queueMicrotask : r.setImmediate ? r.setImmediate : r.setTimeout);
                        }
                        function p(e, t, r, n, i) {
                            return u.importKey("raw", e, {
                                name: "PBKDF2"
                            }, !1, [
                                "deriveBits"
                            ]).then(function(e) {
                                return u.deriveBits({
                                    name: "PBKDF2",
                                    salt: t,
                                    iterations: r,
                                    hash: {
                                        name: i
                                    }
                                }, e, n << 3);
                            }).then(function(e) {
                                return s.from(e);
                            });
                        }
                        t.exports = function(e, t, i, m, b, g) {
                            "function" == typeof b && (g = b, b = void 0);
                            var y = h[(b = b || "sha1").toLowerCase()];
                            if (y && "function" == typeof r.Promise) {
                                if (o(i, m), e = c(e, a, "Password"), t = c(t, a, "Salt"), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
                                !function(e, t) {
                                    e.then(function(e) {
                                        d()(function() {
                                            t(null, e);
                                        });
                                    }, function(e) {
                                        d()(function() {
                                            t(e);
                                        });
                                    });
                                }((function(e) {
                                    if (r.process && !r.process.browser) return Promise.resolve(!1);
                                    if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
                                    if (void 0 !== f[e]) return f[e];
                                    var t = p(n = n || s.alloc(8), n, 10, 128, e).then(function() {
                                        return !0;
                                    }).catch(function() {
                                        return !1;
                                    });
                                    return f[e] = t, t;
                                })(y).then(function(r) {
                                    return r ? p(e, t, i, m, y) : l(e, t, i, m, b);
                                }), g);
                            } else d()(function() {
                                var r;
                                try {
                                    r = l(e, t, i, m, b);
                                } catch (e) {
                                    return g(e);
                                }
                                g(null, r);
                            });
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./sync": 464,
                "./to-buffer": 465,
                "safe-buffer": 494
            }
        ],
        462: [
            function(e, t, r) {
                (function(e, r) {
                    (function() {
                        "use strict";
                        var n;
                        if (r.process && r.process.browser) n = "utf-8";
                        else if (r.process && r.process.version) n = parseInt(e.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
                        else n = "utf-8";
                        t.exports = n;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467
            }
        ],
        463: [
            function(e, t, r) {
                "use strict";
                var n = Math.pow(2, 30) - 1;
                t.exports = function(e, t) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof t) throw new TypeError("Key length not a number");
                    if (t < 0 || t > n || t != t) throw new TypeError("Bad key length");
                };
            },
            {}
        ],
        464: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash/md5"), i = e("ripemd160"), s = e("sha.js"), o = e("safe-buffer").Buffer, a = e("./precondition"), l = e("./default-encoding"), c = e("./to-buffer"), u = o.alloc(128), h = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function f(e, t, r) {
                    var a = function(e) {
                        function t(t) {
                            return s(e).update(t).digest();
                        }
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : t;
                    }(e), l = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > l ? t = a(t) : t.length < l && (t = o.concat([
                        t,
                        u
                    ], l));
                    for(var c = o.allocUnsafe(l + h[e]), f = o.allocUnsafe(l + h[e]), d = 0; d < l; d++)c[d] = 54 ^ t[d], f[d] = 92 ^ t[d];
                    var p = o.allocUnsafe(l + r + 4);
                    c.copy(p, 0, 0, l), this.ipad1 = p, this.ipad2 = c, this.opad = f, this.alg = e, this.blocksize = l, this.hash = a, this.size = h[e];
                }
                f.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, t.exports = function(e, t, r, n, i) {
                    a(r, n);
                    var s = new f(i = i || "sha1", e = c(e, l, "Password"), (t = c(t, l, "Salt")).length), u = o.allocUnsafe(n), d = o.allocUnsafe(t.length + 4);
                    t.copy(d, 0, 0, t.length);
                    for(var p = 0, m = h[i], b = Math.ceil(n / m), g = 1; g <= b; g++){
                        d.writeUInt32BE(g, t.length);
                        for(var y = s.run(d, s.ipad1), v = y, w = 1; w < r; w++){
                            v = s.run(v, s.ipad2);
                            for(var _ = 0; _ < m; _++)y[_] ^= v[_];
                        }
                        y.copy(u, p), p += m;
                    }
                    return u;
                };
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./to-buffer": 465,
                "create-hash/md5": 387,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        465: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        466: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var s, o, a = arguments.length;
                                switch(a){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(s = new Array(a - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                                        return e.nextTick(function() {
                                            t.apply(null, s);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        467: [
            function(e, t, r) {
                "use strict";
                var n, i, s = t.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(e) {
                    if (n === setTimeout) return setTimeout(e, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                    try {
                        return n(e, 0);
                    } catch (t) {
                        try {
                            return n.call(null, e, 0);
                        } catch (t) {
                            return n.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        i = a;
                    }
                }();
                var c, u = [], h = !1, f = -1;
                function d() {
                    h && c && (h = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
                }
                function p() {
                    if (!h) {
                        var e = l(d);
                        h = !0;
                        for(var t = u.length; t;){
                            for(c = u, u = []; ++f < t;)c && c[f].run();
                            f = -1, t = u.length;
                        }
                        c = null, h = !1, function(e) {
                            if (i === clearTimeout) return clearTimeout(e);
                            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                            try {
                                i(e);
                            } catch (t) {
                                try {
                                    return i.call(null, e);
                                } catch (t) {
                                    return i.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function m(e, t) {
                    this.fun = e, this.array = t;
                }
                function b() {}
                s.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new m(e, t)), 1 !== u.length || h || l(p);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = b, s.addListener = b, s.once = b, s.off = b, s.removeListener = b, s.removeAllListeners = b, s.emit = b, s.prependListener = b, s.prependOnceListener = b, s.listeners = function(e) {
                    return [];
                }, s.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, s.cwd = function() {
                    return "/";
                }, s.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, s.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        468: [
            function(e, t, r) {
                "use strict";
                r.publicEncrypt = e("./publicEncrypt"), r.privateDecrypt = e("./privateDecrypt"), r.privateEncrypt = function(e, t) {
                    return r.publicEncrypt(e, t, !0);
                }, r.publicDecrypt = function(e, t) {
                    return r.privateDecrypt(e, t, !0);
                };
            },
            {
                "./privateDecrypt": 471,
                "./publicEncrypt": 472
            }
        ],
        469: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash"), i = e("safe-buffer").Buffer;
                function s(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                t.exports = function(e, t) {
                    for(var r, o = i.alloc(0), a = 0; o.length < t;)r = s(a++), o = i.concat([
                        o,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return o.slice(0, t);
                };
            },
            {
                "create-hash": 386,
                "safe-buffer": 494
            }
        ],
        470: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        471: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("./mgf"), s = e("./xor"), o = e("bn.js"), a = e("browserify-rsa"), l = e("create-hash"), c = e("./withPublic"), u = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var h;
                    h = e.padding ? e.padding : r ? 1 : 4;
                    var f, d = n(e), p = d.modulus.byteLength();
                    if (t.length > p || new o(t).cmp(d.modulus) >= 0) throw new Error("decryption error");
                    f = r ? c(new o(t), d) : a(t, d);
                    var m = u.alloc(p - f.length);
                    if (f = u.concat([
                        m,
                        f
                    ], p), 4 === h) return function(e, t) {
                        var r = e.modulus.byteLength(), n = l("sha1").update(u.alloc(0)).digest(), o = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var a = t.slice(1, o + 1), c = t.slice(o + 1), h = s(a, i(c, o)), f = s(c, i(h, r - o - 1));
                        if (function(e, t) {
                            e = u.from(e), t = u.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            var i = -1;
                            for(; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, f.slice(0, o))) throw new Error("decryption error");
                        var d = o;
                        for(; 0 === f[d];)d++;
                        if (1 !== f[d++]) throw new Error("decryption error");
                        return f.slice(d);
                    }(d, f);
                    if (1 === h) return function(e, t, r) {
                        var n = t.slice(0, 2), i = 2, s = 0;
                        for(; 0 !== t[i++];)if (i >= t.length) {
                            s++;
                            break;
                        }
                        var o = t.slice(2, i - 1);
                        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
                        o.length < 8 && s++;
                        if (s) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, f, r);
                    if (3 === h) return f;
                    throw new Error("unknown padding");
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        472: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("randombytes"), s = e("create-hash"), o = e("./mgf"), a = e("./xor"), l = e("bn.js"), c = e("./withPublic"), u = e("browserify-rsa"), h = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var f;
                    f = e.padding ? e.padding : r ? 1 : 4;
                    var d, p = n(e);
                    if (4 === f) d = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = s("sha1").update(h.alloc(0)).digest(), u = c.length, f = 2 * u;
                        if (n > r - f - 2) throw new Error("message too long");
                        var d = h.alloc(r - n - f - 2), p = r - u - 1, m = i(u), b = a(h.concat([
                            c,
                            d,
                            h.alloc(1, 1),
                            t
                        ], p), o(m, p)), g = a(m, o(b, u));
                        return new l(h.concat([
                            h.alloc(1),
                            g,
                            b
                        ], r));
                    }(p, t);
                    else if (1 === f) d = function(e, t, r) {
                        var n, s = t.length, o = e.modulus.byteLength();
                        if (s > o - 11) throw new Error("message too long");
                        n = r ? h.alloc(o - s - 3, 255) : function(e) {
                            var t, r = h.allocUnsafe(e), n = 0, s = i(2 * e), o = 0;
                            for(; n < e;)o === s.length && (s = i(2 * e), o = 0), (t = s[o++]) && (r[n++] = t);
                            return r;
                        }(o - s - 3);
                        return new l(h.concat([
                            h.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            h.alloc(1),
                            t
                        ], o));
                    }(p, t, r);
                    else {
                        if (3 !== f) throw new Error("unknown padding");
                        if ((d = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? u(d, p) : c(d, p);
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        473: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            {
                "bn.js": 470,
                "safe-buffer": 494
            }
        ],
        474: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            {}
        ],
        475: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("safe-buffer").Buffer, s = n.crypto || n.msCrypto;
                        s && s.getRandomValues ? t.exports = function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var n = i.allocUnsafe(e);
                            if (e > 0) {
                                if (e > 65536) for(var o = 0; o < e; o += 65536)s.getRandomValues(n.slice(o, o + 65536));
                                else s.getRandomValues(n);
                            }
                            if ("function" == typeof t) return r.nextTick(function() {
                                t(null, n);
                            });
                            return n;
                        } : t.exports = function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                "safe-buffer": 494
            }
        ],
        476: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        function i() {
                            throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                        }
                        var s = e("safe-buffer"), o = e("randombytes"), a = s.Buffer, l = s.kMaxLength, c = n.crypto || n.msCrypto, u = Math.pow(2, 32) - 1;
                        function h(e, t) {
                            if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                            if (e > u || e < 0) throw new TypeError("offset must be a uint32");
                            if (e > l || e > t) throw new RangeError("offset out of range");
                        }
                        function f(e, t, r) {
                            if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                            if (e > u || e < 0) throw new TypeError("size must be a uint32");
                            if (e + t > r || e > l) throw new RangeError("buffer too small");
                        }
                        function d(e, r, n, i) {
                            if (t.browser) {
                                var s = e.buffer, a = new Uint8Array(s, r, n);
                                return c.getRandomValues(a), i ? void t.nextTick(function() {
                                    i(null, e);
                                }) : e;
                            }
                            if (!i) return o(n).copy(e, r), e;
                            o(n, function(t, n) {
                                if (t) return i(t);
                                n.copy(e, r), i(null, e);
                            });
                        }
                        c && c.getRandomValues || !t.browser ? (r.randomFill = function(e, t, r, i) {
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            if ("function" == typeof t) i = t, t = 0, r = e.length;
                            else if ("function" == typeof r) i = r, r = e.length - t;
                            else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                            return h(t, e.length), f(r, t, e.length), d(e, t, r, i);
                        }, r.randomFillSync = function(e, t, r) {
                            void 0 === t && (t = 0);
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            h(t, e.length), void 0 === r && (r = e.length - t);
                            return f(r, t, e.length), d(e, t, r);
                        }) : (r.randomFill = i, r.randomFillSync = i);
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        477: [
            function(e, t, r) {
                "use strict";
                var n = {};
                function i(e, t, r) {
                    r || (r = Error);
                    var i = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = e, n[e] = i;
                }
                function s(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                i("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var n, i, o, a;
                    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) a = "The ".concat(e, " ").concat(n, " ").concat(s(t, "type"));
                    else {
                        var l = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        a = 'The "'.concat(e, '" ').concat(l, " ").concat(n, " ").concat(s(t, "type"));
                    }
                    return a += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = n;
            },
            {}
        ],
        478: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(e) {
                            var t = [];
                            for(var r in e)t.push(r);
                            return t;
                        };
                        t.exports = c;
                        var i = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(c, i);
                        for(var o = n(s.prototype), a = 0; a < o.length; a++){
                            var l = o[a];
                            c.prototype[l] || (c.prototype[l] = s.prototype[l]);
                        }
                        function c(e) {
                            if (!(this instanceof c)) return new c(e);
                            i.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(h, this);
                        }
                        function h(e) {
                            e.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 480,
                "./_stream_writable": 482,
                _process: 467,
                inherits: 440
            }
        ],
        479: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("./_stream_transform");
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                e("inherits")(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 481,
                inherits: 440
            }
        ],
        480: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        t.exports = M, M.ReadableState = S;
                        e("events").EventEmitter;
                        var s = function(e, t) {
                            return e.listeners(t).length;
                        }, o = e("./internal/streams/stream"), a = e("buffer").Buffer, l = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var c, u = e("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var h, f, d, p = e("./internal/streams/buffer_list"), m = e("./internal/streams/destroy"), b = e("./internal/streams/state").getHighWaterMark, g = e("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, v = g.ERR_STREAM_PUSH_AFTER_EOF, w = g.ERR_METHOD_NOT_IMPLEMENTED, _ = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(M, o);
                        var x = m.errorOrDestroy, k = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function S(t, r, n) {
                            i = i || e("./_stream_duplex"), t = t || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = b(this, t, "readableHighWaterMark", n), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (h || (h = e("string_decoder/").StringDecoder), this.decoder = new h(t.encoding), this.encoding = t.encoding);
                        }
                        function M(t) {
                            if (i = i || e("./_stream_duplex"), !(this instanceof M)) return new M(t);
                            var r = this instanceof i;
                            this._readableState = new S(t, this, r), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), o.call(this);
                        }
                        function C(e, t, r, n, i) {
                            c("readableAddChunk", t);
                            var s, o = e._readableState;
                            if (null === t) o.reading = !1, function(e, t) {
                                if (c("onEofChunk"), t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, t.sync ? A(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                            }(e, o);
                            else if (i || (s = function(e, t) {
                                var r;
                                n = t, a.isBuffer(n) || n instanceof l || "string" == typeof t || void 0 === t || e.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], t));
                                var n;
                                return r;
                            }(o, t)), s) x(e, s);
                            else if (o.objectMode || t && t.length > 0) {
                                if ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                                    return a.from(e);
                                }(t)), n) o.endEmitted ? x(e, new _) : T(e, o, t, !0);
                                else if (o.ended) x(e, new v);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? T(e, o, t, !1) : O(e, o)) : T(e, o, t, !1);
                                }
                            } else n || (o.reading = !1, O(e, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function T(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && A(e)), O(e, t);
                        }
                        Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        }, M.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), C(this, e, t, !1, r);
                        }, M.prototype.unshift = function(e) {
                            return C(this, e, null, !0, !1);
                        }, M.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, M.prototype.setEncoding = function(t) {
                            h || (h = e("string_decoder/").StringDecoder);
                            var r = new h(t);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 1073741824 ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function A(e) {
                            var t = e._readableState;
                            c("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (c("emitReadable", t.flowing), t.emittedReadable = !0, r.nextTick(R, e));
                        }
                        function R(e) {
                            var t = e._readableState;
                            c("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, B(e);
                        }
                        function O(e, t) {
                            t.readingMore || (t.readingMore = !0, r.nextTick(j, e, t));
                        }
                        function j(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var r = t.length;
                                if (c("maybeReadMore read 0"), e.read(0), r === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function I(e) {
                            var t = e._readableState;
                            t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                        }
                        function N(e) {
                            c("readable nexttick read 0"), e.read(0);
                        }
                        function P(e, t) {
                            c("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), B(e), t.flowing && !t.reading && e.read(0);
                        }
                        function B(e) {
                            var t = e._readableState;
                            for(c("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function D(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                        }
                        function F(e) {
                            var t = e._readableState;
                            c("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, r.nextTick(L, t, e));
                        }
                        function L(e, t) {
                            if (c("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var r = t._writableState;
                                (!r || r.autoDestroy && r.finished) && t.destroy();
                            }
                        }
                        function z(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        M.prototype.read = function(e) {
                            c("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return c("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : A(this), null;
                            if (0 === (e = E(e, t)) && t.ended) return 0 === t.length && F(this), null;
                            var n, i = t.needReadable;
                            return c("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && c("length less than watermark", i = !0), t.ended || t.reading ? c("reading or ended", i = !1) : i && (c("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = E(r, t))), null === (n = e > 0 ? D(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                        }, M.prototype._read = function(e) {
                            x(this, new w("_read()"));
                        }, M.prototype.pipe = function(e, t) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = e;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    i.pipes.push(e);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, t);
                            var o = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? l : b;
                            function a(t, r) {
                                c("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", u), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", l), n.removeListener("end", b), n.removeListener("data", f), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), e.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), e.on("unpipe", a);
                            var u = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    c("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, B(e));
                                };
                            }(n);
                            e.on("drain", u);
                            var h = !1;
                            function f(t) {
                                c("ondata");
                                var r = e.write(t);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== z(i.pipes, e)) && !h && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function d(t) {
                                c("onerror", t), b(), e.removeListener("error", d), 0 === s(e, "error") && x(e, t);
                            }
                            function p() {
                                e.removeListener("finish", m), b();
                            }
                            function m() {
                                c("onfinish"), e.removeListener("close", p), b();
                            }
                            function b() {
                                c("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", f), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", d), e.once("close", p), e.once("finish", m), e.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), e;
                        }, M.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = z(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, M.prototype.on = function(e, t) {
                            var n = o.prototype.on.call(this, e, t), i = this._readableState;
                            return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? A(this) : i.reading || r.nextTick(N, this))), n;
                        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(e, t) {
                            var n = o.prototype.removeListener.call(this, e, t);
                            return "readable" === e && r.nextTick(I, this), n;
                        }, M.prototype.removeAllListeners = function(e) {
                            var t = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== e && void 0 !== e || r.nextTick(I, this), t;
                        }, M.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (c("resume"), e.flowing = !e.readableListening, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, r.nextTick(P, e, t));
                            }(this, e)), e.paused = !1, this;
                        }, M.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, M.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < k.length; s++)e.on(k[s], this.emit.bind(this, k[s]));
                            return this._read = function(t) {
                                c("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === f && (f = e("./internal/streams/async_iterator")), f(this);
                        }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(M.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(M.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), M._fromList = D, Object.defineProperty(M.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (M.from = function(t, r) {
                            return void 0 === d && (d = e("./internal/streams/from")), d(M, t, r);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/async_iterator": 483,
                "./internal/streams/buffer_list": 484,
                "./internal/streams/destroy": 485,
                "./internal/streams/from": 487,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                events: 422,
                inherits: 440,
                "string_decoder/": 522,
                util: 188
            }
        ],
        481: [
            function(e, t, r) {
                "use strict";
                t.exports = u;
                var n = e("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, s = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = n.ERR_TRANSFORM_WITH_LENGTH_0, l = e("./_stream_duplex");
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new s);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(e) {
                    if (!(this instanceof u)) return new u(e);
                    l.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", h);
                }
                function h() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(t, r) {
                        f(e, t, r);
                    });
                }
                function f(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new a;
                    if (e._transformState.transforming) throw new o;
                    return e.push(null);
                }
                e("inherits")(u, l), u.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, e, t);
                }, u.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, u.prototype._destroy = function(e, t) {
                    l.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                inherits: 440
            }
        ],
        482: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        var s;
                        t.exports = M, M.WritableState = S;
                        var o = {
                            deprecate: e("util-deprecate")
                        }, a = e("./internal/streams/stream"), l = e("buffer").Buffer, c = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var u, h = e("./internal/streams/destroy"), f = e("./internal/streams/state").getHighWaterMark, d = e("../errors").codes, p = d.ERR_INVALID_ARG_TYPE, m = d.ERR_METHOD_NOT_IMPLEMENTED, b = d.ERR_MULTIPLE_CALLBACK, g = d.ERR_STREAM_CANNOT_PIPE, y = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, w = d.ERR_STREAM_WRITE_AFTER_END, _ = d.ERR_UNKNOWN_ENCODING, x = h.errorOrDestroy;
                        function k() {}
                        function S(t, n, o) {
                            s = s || e("./_stream_duplex"), t = t || {}, "boolean" != typeof o && (o = n instanceof s), this.objectMode = !!t.objectMode, o && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = f(this, t, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var a = !1 === t.decodeStrings;
                            this.decodeStrings = !a, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var n = e._writableState, i = n.sync, s = n.writecb;
                                    if ("function" != typeof s) throw new b;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(n), t) !function(e, t, n, i, s) {
                                        --t.pendingcb, n ? (r.nextTick(s, i), r.nextTick(O, e, t), e._writableState.errorEmitted = !0, x(e, i)) : (s(i), e._writableState.errorEmitted = !0, x(e, i), O(e, t));
                                    }(e, n, i, t, s);
                                    else {
                                        var o = A(n) || e.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(e, n), i ? r.nextTick(T, e, n, o, s) : T(e, n, o, s);
                                    }
                                }(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function M(t) {
                            var r = this instanceof (s = s || e("./_stream_duplex"));
                            if (!r && !u.call(M, this)) return new M(t);
                            this._writableState = new S(t, this, r), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), a.call(this);
                        }
                        function C(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new y("write")) : r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function T(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), O(e, t);
                        }
                        function E(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, s = new Array(n), o = t.corkedRequestsFree;
                                o.entry = r;
                                for(var a = 0, l = !0; r;)s[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                s.allBuffers = l, C(e, t, !0, t.length, s, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new i(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (C(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function A(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function R(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && x(e, r), t.prefinished = !0, e.emit("prefinish"), O(e, t);
                            });
                        }
                        function O(e, t) {
                            var n = A(t);
                            if (n && (function(e, t) {
                                t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, r.nextTick(R, e, t)));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var i = e._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        e("inherits")(M, a), S.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(S.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
                            value: function(e) {
                                return !!u.call(this, e) || this === M && e && e._writableState instanceof S;
                            }
                        })) : u = function(e) {
                            return e instanceof this;
                        }, M.prototype.pipe = function() {
                            x(this, new g);
                        }, M.prototype.write = function(e, t, n) {
                            var i, s = this._writableState, o = !1, a = !s.objectMode && (i = e, l.isBuffer(i) || i instanceof c);
                            return a && !l.isBuffer(e) && (e = function(e) {
                                return l.from(e);
                            }(e)), "function" == typeof t && (n = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof n && (n = k), s.ending ? function(e, t) {
                                var n = new w;
                                x(e, n), r.nextTick(t, n);
                            }(this, n) : (a || function(e, t, n, i) {
                                var s;
                                return null === n ? s = new v : "string" == typeof n || t.objectMode || (s = new p("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !s || (x(e, s), r.nextTick(i, s), !1);
                            }(this, s, e, n)) && (s.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var c = t.length < t.highWaterMark;
                                c || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var u = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else C(e, t, !1, a, n, i, s);
                                return c;
                            }(this, s, a, e, t, n)), o;
                        }, M.prototype.cork = function() {
                            this._writableState.corked++;
                        }, M.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || E(this, e));
                        }, M.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new _(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(M.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), M.prototype._write = function(e, t, r) {
                            r(new m("_write()"));
                        }, M.prototype._writev = null, M.prototype.end = function(e, t, n) {
                            var i = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), i.corked && (i.corked = 1, this.uncork()), i.ending || function(e, t, n) {
                                t.ending = !0, O(e, t), n && (t.finished ? r.nextTick(n) : e.once("finish", n));
                                t.ended = !0, e.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(M.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), M.prototype.destroy = h.destroy, M.prototype._undestroy = h.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/destroy": 485,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                inherits: 440,
                "util-deprecate": 524
            }
        ],
        483: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(e, t, r) {
                            return (t = function(e) {
                                var t = function(e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var r = e[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e, t || "default");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return ("string" === t ? String : Number)(e);
                                }(e, "string");
                                return "symbol" == typeof t ? t : String(t);
                            }(t)) in e ? Object.defineProperty(e, t, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = r, e;
                        }
                        var s = e("./end-of-stream"), o = Symbol("lastResolve"), a = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), f = Symbol("stream");
                        function d(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function p(e) {
                            var t = e[o];
                            if (null !== t) {
                                var r = e[f].read();
                                null !== r && (e[u] = null, e[o] = null, e[a] = null, t(d(r, !1)));
                            }
                        }
                        function m(e) {
                            r.nextTick(p, e);
                        }
                        var b = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[f];
                            },
                            next: function() {
                                var e = this, t = this[l];
                                if (null !== t) return Promise.reject(t);
                                if (this[c]) return Promise.resolve(d(void 0, !0));
                                if (this[f].destroyed) return new Promise(function(t, n) {
                                    r.nextTick(function() {
                                        e[l] ? n(e[l]) : t(d(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(e, t) {
                                    return function(r, n) {
                                        e.then(function() {
                                            t[c] ? r(d(void 0, !0)) : t[h](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var s = this[f].read();
                                    if (null !== s) return Promise.resolve(d(s, !1));
                                    n = new Promise(this[h]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var e = this;
                            return new Promise(function(t, r) {
                                e[f].destroy(null, function(e) {
                                    e ? r(e) : t(d(void 0, !0));
                                });
                            });
                        }), n), b);
                        t.exports = function(e) {
                            var t, r = Object.create(g, (i(t = {}, f, {
                                value: e,
                                writable: !0
                            }), i(t, o, {
                                value: null,
                                writable: !0
                            }), i(t, a, {
                                value: null,
                                writable: !0
                            }), i(t, l, {
                                value: null,
                                writable: !0
                            }), i(t, c, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), i(t, h, {
                                value: function(e, t) {
                                    var n = r[f].read();
                                    n ? (r[u] = null, r[o] = null, r[a] = null, e(d(n, !1))) : (r[o] = e, r[a] = t);
                                },
                                writable: !0
                            }), t));
                            return r[u] = null, s(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = r[a];
                                    return null !== t && (r[u] = null, r[o] = null, r[a] = null, t(e)), void (r[l] = e);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[a] = null, n(d(void 0, !0))), r[c] = !0;
                            }), e.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 486,
                _process: 467
            }
        ],
        484: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var l = e("buffer").Buffer, c = e("util").inspect, u = c && c.custom || "inspect";
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return l.alloc(0);
                                for(var t, r, n, i = l.allocUnsafe(e >>> 0), s = this.head, o = 0; s;)t = s.data, r = i, n = o, l.prototype.copy.call(t, r, n), o += s.data.length, s = s.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, s = e > i.length ? i.length : e;
                                    if (s === i.length ? n += i : n += i.slice(0, e), 0 == (e -= s)) {
                                        s === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(s));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = l.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, s = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, s), 0 == (e -= s)) {
                                        s === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(s));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: u,
                            value: function(e, t) {
                                return c(this, i(i({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], o(t.prototype, r), n && o(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            {
                buffer: 220,
                util: 188
            }
        ],
        485: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(e, t) {
                            i(e, t), n(e);
                        }
                        function n(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function i(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, s) {
                                var o = this, a = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return a || l ? (s ? s(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, t)) : e.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !s && t ? o._writableState ? o._writableState.errorEmitted ? e.nextTick(n, o) : (o._writableState.errorEmitted = !0, e.nextTick(r, o, t)) : e.nextTick(r, o, t) : s ? (e.nextTick(n, o), s(t)) : e.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var r = e._readableState, n = e._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        486: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t.exports = function e(t, r, s) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), s = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(s || i);
                    var o = r.readable || !1 !== r.readable && t.readable, a = r.writable || !1 !== r.writable && t.writable, l = function() {
                        t.writable || u();
                    }, c = t._writableState && t._writableState.finished, u = function() {
                        a = !1, c = !0, o || s.call(t);
                    }, h = t._readableState && t._readableState.endEmitted, f = function() {
                        o = !1, h = !0, a || s.call(t);
                    }, d = function(e) {
                        s.call(t, e);
                    }, p = function() {
                        var e;
                        return o && !h ? (t._readableState && t._readableState.ended || (e = new n), s.call(t, e)) : a && !c ? (t._writableState && t._writableState.ended || (e = new n), s.call(t, e)) : void 0;
                    }, m = function() {
                        t.req.on("finish", u);
                    };
                    return !function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? a && !t._writableState && (t.on("end", l), t.on("close", l)) : (t.on("complete", u), t.on("abort", p), t.req ? m() : t.on("request", m)), t.on("end", f), t.on("finish", u), !1 !== r.error && t.on("error", d), t.on("close", p), function() {
                        t.removeListener("complete", u), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", u), t.removeListener("end", l), t.removeListener("close", l), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", d), t.removeListener("close", p);
                    };
                };
            },
            {
                "../../../errors": 477
            }
        ],
        487: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        488: [
            function(e, t, r) {
                "use strict";
                var n;
                var i = e("../../../errors").codes, s = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function a(e) {
                    if (e) throw e;
                }
                function l(t, r, i, s) {
                    s = function(e) {
                        var t = !1;
                        return function() {
                            t || (t = !0, e.apply(void 0, arguments));
                        };
                    }(s);
                    var a = !1;
                    t.on("close", function() {
                        a = !0;
                    }), void 0 === n && (n = e("./end-of-stream")), n(t, {
                        readable: r,
                        writable: i
                    }, function(e) {
                        if (e) return s(e);
                        a = !0, s();
                    });
                    var l = !1;
                    return function(e) {
                        if (!a && !l) return l = !0, function(e) {
                            return e.setHeader && "function" == typeof e.abort;
                        }(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void s(e || new o("pipe"));
                    };
                }
                function c(e) {
                    e();
                }
                function u(e, t) {
                    return e.pipe(t);
                }
                function h(e) {
                    return e.length ? "function" != typeof e[e.length - 1] ? a : e.pop() : a;
                }
                t.exports = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n, i = h(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new s("streams");
                    var o = t.map(function(e, r) {
                        var s = r < t.length - 1;
                        return l(e, s, r > 0, function(e) {
                            n || (n = e), e && o.forEach(c), s || (o.forEach(c), i(n));
                        });
                    });
                    return t.reduce(u);
                };
            },
            {
                "../../../errors": 477,
                "./end-of-stream": 486
            }
        ],
        489: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                t.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var s = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != s) {
                            if (!isFinite(s) || Math.floor(s) !== s || s < 0) throw new n(i ? r : "highWaterMark", s);
                            return Math.floor(s);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 477
            }
        ],
        490: [
            function(e, t, r) {
                "use strict";
                t.exports = e("events").EventEmitter;
            },
            {
                events: 422
            }
        ],
        491: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js"), r.finished = e("./lib/internal/streams/end-of-stream.js"), r.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 478,
                "./lib/_stream_passthrough.js": 479,
                "./lib/_stream_readable.js": 480,
                "./lib/_stream_transform.js": 481,
                "./lib/_stream_writable.js": 482,
                "./lib/internal/streams/end-of-stream.js": 486,
                "./lib/internal/streams/pipeline.js": 488
            }
        ],
        492: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    var t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
                    function l(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        l({}, "");
                    } catch (e) {
                        l = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function c(e, t, r, i) {
                        var s = t && t.prototype instanceof f ? t : f, o = Object.create(s.prototype), a = new M(i || []);
                        return n(o, "_invoke", {
                            value: _(e, r, a)
                        }), o;
                    }
                    function u(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var h = {};
                    function f() {}
                    function d() {}
                    function p() {}
                    var m = {};
                    l(m, s, function() {
                        return this;
                    });
                    var b = Object.getPrototypeOf, g = b && b(b(C([])));
                    g && g !== t && r.call(g, s) && (m = g);
                    var y = p.prototype = f.prototype = Object.create(m);
                    function v(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function w(e, t) {
                        var i;
                        n(this, "_invoke", {
                            value: function(n, s) {
                                function o() {
                                    return new t(function(i, o) {
                                        !function n(i, s, o, a) {
                                            var l = u(e[i], e, s);
                                            if ("throw" !== l.type) {
                                                var c = l.arg, h = c.value;
                                                return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function(e) {
                                                    n("next", e, o, a);
                                                }, function(e) {
                                                    n("throw", e, o, a);
                                                }) : t.resolve(h).then(function(e) {
                                                    c.value = e, o(c);
                                                }, function(e) {
                                                    return n("throw", e, o, a);
                                                });
                                            }
                                            a(l.arg);
                                        }(n, s, i, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function _(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, s) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw s;
                                return T();
                            }
                            for(r.method = i, r.arg = s;;){
                                var o = r.delegate;
                                if (o) {
                                    var a = x(o, r);
                                    if (a) {
                                        if (a === h) continue;
                                        return a;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(e, t, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }
                    function x(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
                        var i = u(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
                        var s = i.arg;
                        return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function k(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function S(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function M(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(k, this), this.reset(!0);
                    }
                    function C(e) {
                        if (e) {
                            var t = e[s];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var n = -1, i = function t() {
                                    for(; ++n < e.length;)if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: T
                        };
                    }
                    function T() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return d.prototype = p, n(y, "constructor", {
                        value: p,
                        configurable: !0
                    }), n(p, "constructor", {
                        value: d,
                        configurable: !0
                    }), d.displayName = l(p, a, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, l(e, a, "GeneratorFunction")), e.prototype = Object.create(y), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, v(w.prototype), l(w.prototype, o, function() {
                        return this;
                    }), e.AsyncIterator = w, e.async = function(t, r, n, i, s) {
                        void 0 === s && (s = Promise);
                        var o = new w(c(t, r, n, i), s);
                        return e.isGeneratorFunction(r) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, v(y), l(y, a, "Generator"), l(y, s, function() {
                        return this;
                    }), l(y, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, e.values = C, M.prototype = {
                        constructor: M,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for(var t in this)"t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function n(r, n) {
                                return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var s = this.tryEntries[i], o = s.completion;
                                if ("root" === s.tryLoc) return n("end");
                                if (s.tryLoc <= this.prev) {
                                    var a = r.call(s, "catchLoc"), l = r.call(s, "finallyLoc");
                                    if (a && l) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    } else if (a) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var s = i;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        S(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: C(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            },
            {}
        ],
        493: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer").Buffer, i = e("inherits"), s = e("hash-base"), o = new Array(16), a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], l = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], u = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], h = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], f = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function d() {
                    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function m(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ r ^ n) + s + o | 0, a) + i | 0;
                }
                function b(e, t, r, n, i, s, o, a) {
                    return p(e + (t & r | ~t & n) + s + o | 0, a) + i | 0;
                }
                function g(e, t, r, n, i, s, o, a) {
                    return p(e + ((t | ~r) ^ n) + s + o | 0, a) + i | 0;
                }
                function y(e, t, r, n, i, s, o, a) {
                    return p(e + (t & n | r & ~n) + s + o | 0, a) + i | 0;
                }
                function v(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ (r | ~n)) + s + o | 0, a) + i | 0;
                }
                i(d, s), d.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, s = 0 | this._d, d = 0 | this._e, w = 0 | this._a, _ = 0 | this._b, x = 0 | this._c, k = 0 | this._d, S = 0 | this._e, M = 0; M < 80; M += 1){
                        var C, T;
                        M < 16 ? (C = m(r, n, i, s, d, e[a[M]], h[0], c[M]), T = v(w, _, x, k, S, e[l[M]], f[0], u[M])) : M < 32 ? (C = b(r, n, i, s, d, e[a[M]], h[1], c[M]), T = y(w, _, x, k, S, e[l[M]], f[1], u[M])) : M < 48 ? (C = g(r, n, i, s, d, e[a[M]], h[2], c[M]), T = g(w, _, x, k, S, e[l[M]], f[2], u[M])) : M < 64 ? (C = y(r, n, i, s, d, e[a[M]], h[3], c[M]), T = b(w, _, x, k, S, e[l[M]], f[3], u[M])) : (C = v(r, n, i, s, d, e[a[M]], h[4], c[M]), T = m(w, _, x, k, S, e[l[M]], f[4], u[M])), r = d, d = s, s = p(i, 10), i = n, n = C, w = S, S = k, k = p(x, 10), x = _, _ = T;
                    }
                    var E = this._b + i + k | 0;
                    this._b = this._c + s + S | 0, this._c = this._d + d + w | 0, this._d = this._e + r + _ | 0, this._e = this._a + n + x | 0, this._a = E;
                }, d.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, t.exports = d;
            },
            {
                buffer: 220,
                "hash-base": 425,
                inherits: 440
            }
        ],
        494: [
            function(e, t, r) {
                "use strict";
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        495: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = e("buffer"), s = i.Buffer, o = {};
                        for(n in i)i.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (o[n] = i[n]);
                        var a = o.Buffer = {};
                        for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (a[n] = s[n]);
                        if (o.Buffer.prototype = s.prototype, a.from && a.from !== Uint8Array.from || (a.from = function(e, t, r) {
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
                            if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            return s(e, t, r);
                        }), a.alloc || (a.alloc = function(e, t, r) {
                            if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
                            if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var n = s(e);
                            return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                        }), !o.kStringMaxLength) try {
                            o.kStringMaxLength = r.binding("buffer").kStringMaxLength;
                        } catch (e) {}
                        o.constants || (o.constants = {
                            MAX_LENGTH: o.kMaxLength
                        }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), t.exports = o;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467,
                buffer: 220
            }
        ],
        496: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                const n = e("xmlchars/xml/1.0/ed5"), i = e("xmlchars/xml/1.1/ed2"), s = e("xmlchars/xmlns/1.0/ed3");
                var o = n.isS, a = n.isChar, l = n.isNameStartChar, c = n.isNameChar, u = n.S_LIST, h = n.NAME_RE, f = i.isChar, d = s.isNCNameStartChar, p = s.isNCNameChar, m = s.NC_NAME_RE;
                const b = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", y = {
                    __proto__: null,
                    xml: b,
                    xmlns: g
                }, v = {
                    __proto__: null,
                    amp: "&",
                    gt: ">",
                    lt: "<",
                    quot: '"',
                    apos: "'"
                }, w = (e)=>34 === e || 39 === e, _ = [
                    34,
                    39
                ], x = [
                    ..._,
                    91,
                    62
                ], k = [
                    ..._,
                    60,
                    93
                ], S = [
                    61,
                    63,
                    ...u
                ], M = [
                    ...u,
                    62,
                    38,
                    60
                ];
                function C(e, t, r) {
                    switch(t){
                        case "xml":
                            r !== b && e.fail(`xml prefix must be bound to ${b}.`);
                            break;
                        case "xmlns":
                            r !== g && e.fail(`xmlns prefix must be bound to ${g}.`);
                    }
                    switch(r){
                        case g:
                            e.fail("" === t ? `the default namespace may not be set to ${r}.` : `may not assign a prefix (even "xmlns") to the URI ${g}.`);
                            break;
                        case b:
                            switch(t){
                                case "xml":
                                    break;
                                case "":
                                    e.fail(`the default namespace may not be set to ${r}.`);
                                    break;
                                default:
                                    e.fail("may not assign the xml namespace to another prefix.");
                            }
                    }
                }
                const T = (e)=>m.test(e), E = (e)=>h.test(e);
                r.EVENTS = [
                    "xmldecl",
                    "text",
                    "processinginstruction",
                    "doctype",
                    "comment",
                    "opentagstart",
                    "attribute",
                    "opentag",
                    "closetag",
                    "cdata",
                    "error",
                    "end",
                    "ready"
                ];
                const A = {
                    xmldecl: "xmldeclHandler",
                    text: "textHandler",
                    processinginstruction: "piHandler",
                    doctype: "doctypeHandler",
                    comment: "commentHandler",
                    opentagstart: "openTagStartHandler",
                    attribute: "attributeHandler",
                    opentag: "openTagHandler",
                    closetag: "closeTagHandler",
                    cdata: "cdataHandler",
                    error: "errorHandler",
                    end: "endHandler",
                    ready: "readyHandler"
                };
                r.SaxesParser = class {
                    constructor(e){
                        this.opt = null != e ? e : {}, this.fragmentOpt = !!this.opt.fragment;
                        const t = this.xmlnsOpt = !!this.opt.xmlns;
                        if (this.trackPosition = !1 !== this.opt.position, this.fileName = this.opt.fileName, t) {
                            this.nameStartCheck = d, this.nameCheck = p, this.isName = T, this.processAttribs = this.processAttribsNS, this.pushAttrib = this.pushAttribNS, this.ns = Object.assign({
                                __proto__: null
                            }, y);
                            const e = this.opt.additionalNamespaces;
                            null != e && (!function(e, t) {
                                for (const r of Object.keys(t))C(e, r, t[r]);
                            }(this, e), Object.assign(this.ns, e));
                        } else this.nameStartCheck = l, this.nameCheck = c, this.isName = E, this.processAttribs = this.processAttribsPlain, this.pushAttrib = this.pushAttribPlain;
                        this.stateTable = [
                            this.sBegin,
                            this.sBeginWhitespace,
                            this.sDoctype,
                            this.sDoctypeQuote,
                            this.sDTD,
                            this.sDTDQuoted,
                            this.sDTDOpenWaka,
                            this.sDTDOpenWakaBang,
                            this.sDTDComment,
                            this.sDTDCommentEnding,
                            this.sDTDCommentEnded,
                            this.sDTDPI,
                            this.sDTDPIEnding,
                            this.sText,
                            this.sEntity,
                            this.sOpenWaka,
                            this.sOpenWakaBang,
                            this.sComment,
                            this.sCommentEnding,
                            this.sCommentEnded,
                            this.sCData,
                            this.sCDataEnding,
                            this.sCDataEnding2,
                            this.sPIFirstChar,
                            this.sPIRest,
                            this.sPIBody,
                            this.sPIEnding,
                            this.sXMLDeclNameStart,
                            this.sXMLDeclName,
                            this.sXMLDeclEq,
                            this.sXMLDeclValueStart,
                            this.sXMLDeclValue,
                            this.sXMLDeclSeparator,
                            this.sXMLDeclEnding,
                            this.sOpenTag,
                            this.sOpenTagSlash,
                            this.sAttrib,
                            this.sAttribName,
                            this.sAttribNameSawWhite,
                            this.sAttribValue,
                            this.sAttribValueQuoted,
                            this.sAttribValueClosed,
                            this.sAttribValueUnquoted,
                            this.sCloseTag,
                            this.sCloseTagSawWhite
                        ], this._init();
                    }
                    get closed() {
                        return this._closed;
                    }
                    _init() {
                        var e;
                        this.openWakaBang = "", this.text = "", this.name = "", this.piTarget = "", this.entity = "", this.q = null, this.tags = [], this.tag = null, this.topNS = null, this.chunk = "", this.chunkPosition = 0, this.i = 0, this.prevI = 0, this.carriedFromPrevious = void 0, this.forbiddenState = 0, this.attribList = [];
                        const { fragmentOpt: t } = this;
                        this.state = t ? 13 : 0, this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = t, this.xmlDeclPossible = !t, this.xmlDeclExpects = [
                            "version"
                        ], this.entityReturnState = void 0;
                        let { defaultXMLVersion: r } = this.opt;
                        if (void 0 === r) {
                            if (!0 === this.opt.forceXMLVersion) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                            r = "1.0";
                        }
                        this.setXMLVersion(r), this.positionAtNewLine = 0, this.doctype = !1, this._closed = !1, this.xmlDecl = {
                            version: void 0,
                            encoding: void 0,
                            standalone: void 0
                        }, this.line = 1, this.column = 0, this.ENTITIES = Object.create(v), null === (e = this.readyHandler) || void 0 === e || e.call(this);
                    }
                    get position() {
                        return this.chunkPosition + this.i;
                    }
                    get columnIndex() {
                        return this.position - this.positionAtNewLine;
                    }
                    on(e, t) {
                        this[A[e]] = t;
                    }
                    off(e) {
                        this[A[e]] = void 0;
                    }
                    makeError(e) {
                        var t;
                        let r = null !== (t = this.fileName) && void 0 !== t ? t : "";
                        return this.trackPosition && (r.length > 0 && (r += ":"), r += `${this.line}:${this.column}`), r.length > 0 && (r += ": "), new Error(r + e);
                    }
                    fail(e) {
                        const t = this.makeError(e), r = this.errorHandler;
                        if (void 0 === r) throw t;
                        return r(t), this;
                    }
                    write(e) {
                        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                        let t = !1;
                        null === e ? (t = !0, e = "") : "object" == typeof e && (e = e.toString()), void 0 !== this.carriedFromPrevious && (e = `${this.carriedFromPrevious}${e}`, this.carriedFromPrevious = void 0);
                        let r = e.length;
                        const n = e.charCodeAt(r - 1);
                        !t && (13 === n || n >= 55296 && n <= 56319) && (this.carriedFromPrevious = e[r - 1], r--, e = e.slice(0, r));
                        const { stateTable: i } = this;
                        for(this.chunk = e, this.i = 0; this.i < r;)i[this.state].call(this);
                        return this.chunkPosition += r, t ? this.end() : this;
                    }
                    close() {
                        return this.write(null);
                    }
                    getCode10() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r >= 32 || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    return 10 === e.charCodeAt(t + 1) && (this.i = t + 2), this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCode11() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r > 31 && r < 127 || r > 159 && 8232 !== r || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    {
                                        const r = e.charCodeAt(t + 1);
                                        10 !== r && 133 !== r || (this.i = t + 2);
                                    }
                                case 133:
                                case 8232:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCodeNorm() {
                        const e = this.getCode();
                        return -2 === e ? 10 : e;
                    }
                    unget() {
                        this.i = this.prevI, this.column--;
                    }
                    captureTo(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            const n = this.getCode(), i = -2 === n, s = i ? 10 : n;
                            if (-1 === s || e.includes(s)) return this.text += r.slice(t, this.prevI), s;
                            i && (this.text += r.slice(t, this.prevI) + "\n", t = this.i);
                        }
                    }
                    captureToChar(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            let n = this.getCode();
                            switch(n){
                                case -2:
                                    this.text += r.slice(t, this.prevI) + "\n", t = this.i, n = 10;
                                    break;
                                case -1:
                                    return this.text += r.slice(t), !1;
                            }
                            if (n === e) return this.text += r.slice(t, this.prevI), !0;
                        }
                    }
                    captureNameChars() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCode();
                            if (-1 === r) return this.name += e.slice(t), -1;
                            if (!c(r)) return this.name += e.slice(t, this.prevI), -2 === r ? 10 : r;
                        }
                    }
                    skipSpaces() {
                        for(;;){
                            const e = this.getCodeNorm();
                            if (-1 === e || !o(e)) return e;
                        }
                    }
                    setXMLVersion(e) {
                        this.currentXMLVersion = e, "1.0" === e ? (this.isChar = a, this.getCode = this.getCode10) : (this.isChar = f, this.getCode = this.getCode11);
                    }
                    sBegin() {
                        65279 === this.chunk.charCodeAt(0) && (this.i++, this.column++), this.state = 1;
                    }
                    sBeginWhitespace() {
                        const e = this.i, t = this.skipSpaces();
                        switch(this.prevI !== e && (this.xmlDeclPossible = !1), t){
                            case 60:
                                if (this.state = 15, 0 !== this.text.length) throw new Error("no-empty text at start");
                                break;
                            case -1:
                                break;
                            default:
                                this.unget(), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sDoctype() {
                        var e;
                        const t = this.captureTo(x);
                        switch(t){
                            case 62:
                                null === (e = this.doctypeHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13, this.doctype = !0;
                                break;
                            case -1:
                                break;
                            default:
                                this.text += String.fromCodePoint(t), 91 === t ? this.state = 4 : w(t) && (this.state = 3, this.q = t);
                        }
                    }
                    sDoctypeQuote() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.q = null, this.state = 2);
                    }
                    sDTD() {
                        const e = this.captureTo(k);
                        -1 !== e && (this.text += String.fromCodePoint(e), 93 === e ? this.state = 2 : 60 === e ? this.state = 6 : w(e) && (this.state = 5, this.q = e));
                    }
                    sDTDQuoted() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.state = 4, this.q = null);
                    }
                    sDTDOpenWaka() {
                        const e = this.getCodeNorm();
                        switch(this.text += String.fromCodePoint(e), e){
                            case 33:
                                this.state = 7, this.openWakaBang = "";
                                break;
                            case 63:
                                this.state = 11;
                                break;
                            default:
                                this.state = 4;
                        }
                    }
                    sDTDOpenWakaBang() {
                        const e = String.fromCodePoint(this.getCodeNorm()), t = this.openWakaBang += e;
                        this.text += e, "-" !== t && (this.state = "--" === t ? 8 : 4, this.openWakaBang = "");
                    }
                    sDTDComment() {
                        this.captureToChar(45) && (this.text += "-", this.state = 9);
                    }
                    sDTDCommentEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), this.state = 45 === e ? 10 : 8;
                    }
                    sDTDCommentEnded() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e ? this.state = 4 : (this.fail("malformed comment."), this.state = 8);
                    }
                    sDTDPI() {
                        this.captureToChar(63) && (this.text += "?", this.state = 12);
                    }
                    sDTDPIEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e && (this.state = 4);
                    }
                    sText() {
                        0 !== this.tags.length ? this.handleTextInRoot() : this.handleTextOutsideRoot();
                    }
                    sEntity() {
                        let { i: e } = this;
                        const { chunk: t } = this;
                        e: for(;;)switch(this.getCode()){
                            case -2:
                                this.entity += t.slice(e, this.prevI) + "\n", e = this.i;
                                break;
                            case 59:
                                {
                                    const { entityReturnState: r } = this, n = this.entity + t.slice(e, this.prevI);
                                    let i;
                                    this.state = r, "" === n ? (this.fail("empty entity name."), i = "&;") : (i = this.parseEntity(n), this.entity = ""), 13 === r && void 0 === this.textHandler || (this.text += i);
                                    break e;
                                }
                            case -1:
                                this.entity += t.slice(e);
                                break e;
                        }
                    }
                    sOpenWaka() {
                        const e = this.getCode();
                        if (l(e)) this.state = 34, this.unget(), this.xmlDeclPossible = !1;
                        else switch(e){
                            case 47:
                                this.state = 43, this.xmlDeclPossible = !1;
                                break;
                            case 33:
                                this.state = 16, this.openWakaBang = "", this.xmlDeclPossible = !1;
                                break;
                            case 63:
                                this.state = 23;
                                break;
                            default:
                                this.fail("disallowed character in tag name"), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sOpenWakaBang() {
                        switch(this.openWakaBang += String.fromCodePoint(this.getCodeNorm()), this.openWakaBang){
                            case "[CDATA[":
                                this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0), this.state = 20, this.openWakaBang = "";
                                break;
                            case "--":
                                this.state = 17, this.openWakaBang = "";
                                break;
                            case "DOCTYPE":
                                this.state = 2, (this.doctype || this.sawRoot) && this.fail("inappropriately located doctype declaration."), this.openWakaBang = "";
                                break;
                            default:
                                this.openWakaBang.length >= 7 && this.fail("incorrect syntax.");
                        }
                    }
                    sComment() {
                        this.captureToChar(45) && (this.state = 18);
                    }
                    sCommentEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        45 === t ? (this.state = 19, null === (e = this.commentHandler) || void 0 === e || e.call(this, this.text), this.text = "") : (this.text += "-" + String.fromCodePoint(t), this.state = 17);
                    }
                    sCommentEnded() {
                        const e = this.getCodeNorm();
                        62 !== e ? (this.fail("malformed comment."), this.text += "--" + String.fromCodePoint(e), this.state = 17) : this.state = 13;
                    }
                    sCData() {
                        this.captureToChar(93) && (this.state = 21);
                    }
                    sCDataEnding() {
                        const e = this.getCodeNorm();
                        93 === e ? this.state = 22 : (this.text += "]" + String.fromCodePoint(e), this.state = 20);
                    }
                    sCDataEnding2() {
                        var e;
                        const t = this.getCodeNorm();
                        switch(t){
                            case 62:
                                null === (e = this.cdataHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13;
                                break;
                            case 93:
                                this.text += "]";
                                break;
                            default:
                                this.text += "]]" + String.fromCodePoint(t), this.state = 20;
                        }
                    }
                    sPIFirstChar() {
                        const e = this.getCodeNorm();
                        this.nameStartCheck(e) ? (this.piTarget += String.fromCodePoint(e), this.state = 24) : 63 === e || o(e) ? (this.fail("processing instruction without a target."), this.state = 63 === e ? 26 : 25) : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(e), this.state = 24);
                    }
                    sPIRest() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCodeNorm();
                            if (-1 === r) return void (this.piTarget += e.slice(t));
                            if (!this.nameCheck(r)) {
                                this.piTarget += e.slice(t, this.prevI);
                                const n = 63 === r;
                                n || o(r) ? "xml" === this.piTarget ? (this.xmlDeclPossible || this.fail("an XML declaration must be at the start of the document."), this.state = n ? 33 : 27) : this.state = n ? 26 : 25 : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(r));
                                break;
                            }
                        }
                    }
                    sPIBody() {
                        if (0 === this.text.length) {
                            const e = this.getCodeNorm();
                            63 === e ? this.state = 26 : o(e) || (this.text = String.fromCodePoint(e));
                        } else this.captureToChar(63) && (this.state = 26);
                    }
                    sPIEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        if (62 === t) {
                            const { piTarget: t } = this;
                            "xml" === t.toLowerCase() && this.fail("the XML declaration must appear at the start of the document."), null === (e = this.piHandler) || void 0 === e || e.call(this, {
                                target: t,
                                body: this.text
                            }), this.piTarget = this.text = "", this.state = 13;
                        } else 63 === t ? this.text += "?" : (this.text += "?" + String.fromCodePoint(t), this.state = 25);
                        this.xmlDeclPossible = !1;
                    }
                    sXMLDeclNameStart() {
                        const e = this.skipSpaces();
                        63 !== e ? -1 !== e && (this.state = 28, this.name = String.fromCodePoint(e)) : this.state = 33;
                    }
                    sXMLDeclName() {
                        const e = this.captureTo(S);
                        if (63 === e) return this.state = 33, this.name += this.text, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (o(e) || 61 === e) {
                            if (this.name += this.text, this.text = "", !this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                                case 0:
                                    this.fail("did not expect any more name/value pairs.");
                                    break;
                                case 1:
                                    this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                                    break;
                                default:
                                    this.fail("expected one of " + this.xmlDeclExpects.join(", "));
                            }
                            this.state = 61 === e ? 30 : 29;
                        }
                    }
                    sXMLDeclEq() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (61 !== e && this.fail("value required."), this.state = 30);
                    }
                    sXMLDeclValueStart() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (w(e) ? this.q = e : (this.fail("value must be quoted."), this.q = 32), this.state = 31);
                    }
                    sXMLDeclValue() {
                        const e = this.captureTo([
                            this.q,
                            63
                        ]);
                        if (63 === e) return this.state = 33, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (-1 === e) return;
                        const t = this.text;
                        switch(this.text = "", this.name){
                            case "version":
                                {
                                    this.xmlDeclExpects = [
                                        "encoding",
                                        "standalone"
                                    ];
                                    const e = t;
                                    this.xmlDecl.version = e, /^1\.[0-9]+$/.test(e) ? this.opt.forceXMLVersion || this.setXMLVersion(e) : this.fail("version number must match /^1\\.[0-9]+$/.");
                                    break;
                                }
                            case "encoding":
                                /^[A-Za-z][A-Za-z0-9._-]*$/.test(t) || this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/."), this.xmlDeclExpects = [
                                    "standalone"
                                ], this.xmlDecl.encoding = t;
                                break;
                            case "standalone":
                                "yes" !== t && "no" !== t && this.fail('standalone value must match "yes" or "no".'), this.xmlDeclExpects = [], this.xmlDecl.standalone = t;
                        }
                        this.name = "", this.state = 32;
                    }
                    sXMLDeclSeparator() {
                        const e = this.getCodeNorm();
                        63 !== e ? (o(e) || (this.fail("whitespace required."), this.unget()), this.state = 27) : this.state = 33;
                    }
                    sXMLDeclEnding() {
                        var e;
                        62 === this.getCodeNorm() ? ("xml" !== this.piTarget ? this.fail("processing instructions are not allowed before root.") : "version" !== this.name && this.xmlDeclExpects.includes("version") && this.fail("XML declaration must contain a version."), null === (e = this.xmldeclHandler) || void 0 === e || e.call(this, this.xmlDecl), this.name = "", this.piTarget = this.text = "", this.state = 13) : this.fail("The character ? is disallowed anywhere in XML declarations."), this.xmlDeclPossible = !1;
                    }
                    sOpenTag() {
                        var e;
                        const t = this.captureNameChars();
                        if (-1 === t) return;
                        const r = this.tag = {
                            name: this.name,
                            attributes: Object.create(null)
                        };
                        switch(this.name = "", this.xmlnsOpt && (this.topNS = r.ns = Object.create(null)), null === (e = this.openTagStartHandler) || void 0 === e || e.call(this, r), this.sawRoot = !0, !this.fragmentOpt && this.closedRoot && this.fail("documents may contain only one root."), t){
                            case 62:
                                this.openTag();
                                break;
                            case 47:
                                this.state = 35;
                                break;
                            default:
                                o(t) || this.fail("disallowed character in tag name."), this.state = 36;
                        }
                    }
                    sOpenTagSlash() {
                        62 === this.getCode() ? this.openSelfClosingTag() : (this.fail("forward-slash in opening tag not followed by >."), this.state = 36);
                    }
                    sAttrib() {
                        const e = this.skipSpaces();
                        -1 !== e && (l(e) ? (this.unget(), this.state = 37) : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : this.fail("disallowed character in attribute name."));
                    }
                    sAttribName() {
                        const e = this.captureNameChars();
                        61 === e ? this.state = 39 : o(e) ? this.state = 38 : 62 === e ? (this.fail("attribute without value."), this.pushAttrib(this.name, this.name), this.name = this.text = "", this.openTag()) : -1 !== e && this.fail("disallowed character in attribute name.");
                    }
                    sAttribNameSawWhite() {
                        const e = this.skipSpaces();
                        switch(e){
                            case -1:
                                return;
                            case 61:
                                this.state = 39;
                                break;
                            default:
                                this.fail("attribute without value."), this.text = "", this.name = "", 62 === e ? this.openTag() : l(e) ? (this.unget(), this.state = 37) : (this.fail("disallowed character in attribute name."), this.state = 36);
                        }
                    }
                    sAttribValue() {
                        const e = this.getCodeNorm();
                        w(e) ? (this.q = e, this.state = 40) : o(e) || (this.fail("unquoted attribute value."), this.state = 42, this.unget());
                    }
                    sAttribValueQuoted() {
                        const { q: e, chunk: t } = this;
                        let { i: r } = this;
                        for(;;)switch(this.getCode()){
                            case e:
                                return this.pushAttrib(this.name, this.text + t.slice(r, this.prevI)), this.name = this.text = "", this.q = null, void (this.state = 41);
                            case 38:
                                return this.text += t.slice(r, this.prevI), this.state = 14, void (this.entityReturnState = 40);
                            case 10:
                            case -2:
                            case 9:
                                this.text += t.slice(r, this.prevI) + " ", r = this.i;
                                break;
                            case 60:
                                return this.text += t.slice(r, this.prevI), void this.fail("disallowed character.");
                            case -1:
                                return void (this.text += t.slice(r));
                        }
                    }
                    sAttribValueClosed() {
                        const e = this.getCodeNorm();
                        o(e) ? this.state = 36 : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : l(e) ? (this.fail("no whitespace between attributes."), this.unget(), this.state = 37) : this.fail("disallowed character in attribute name.");
                    }
                    sAttribValueUnquoted() {
                        const e = this.captureTo(M);
                        switch(e){
                            case 38:
                                this.state = 14, this.entityReturnState = 42;
                                break;
                            case 60:
                                this.fail("disallowed character.");
                                break;
                            case -1:
                                break;
                            default:
                                this.text.includes("]]>") && this.fail('the string "]]>" is disallowed in char data.'), this.pushAttrib(this.name, this.text), this.name = this.text = "", 62 === e ? this.openTag() : this.state = 36;
                        }
                    }
                    sCloseTag() {
                        const e = this.captureNameChars();
                        62 === e ? this.closeTag() : o(e) ? this.state = 44 : -1 !== e && this.fail("disallowed character in closing tag.");
                    }
                    sCloseTagSawWhite() {
                        switch(this.skipSpaces()){
                            case 62:
                                this.closeTag();
                                break;
                            case -1:
                                break;
                            default:
                                this.fail("disallowed character in closing tag.");
                        }
                    }
                    handleTextInRoot() {
                        let { i: e, forbiddenState: t } = this;
                        const { chunk: r, textHandler: n } = this;
                        e: for(;;)switch(this.getCode()){
                            case 60:
                                if (this.state = 15, void 0 !== n) {
                                    const { text: t } = this, i = r.slice(e, this.prevI);
                                    0 !== t.length ? (n(t + i), this.text = "") : 0 !== i.length && n(i);
                                }
                                t = 0;
                                break e;
                            case 38:
                                this.state = 14, this.entityReturnState = 13, void 0 !== n && (this.text += r.slice(e, this.prevI)), t = 0;
                                break e;
                            case 93:
                                switch(t){
                                    case 0:
                                        t = 1;
                                        break;
                                    case 1:
                                        t = 2;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new Error("impossible state");
                                }
                                break;
                            case 62:
                                2 === t && this.fail('the string "]]>" is disallowed in char data.'), t = 0;
                                break;
                            case -2:
                                void 0 !== n && (this.text += r.slice(e, this.prevI) + "\n"), e = this.i, t = 0;
                                break;
                            case -1:
                                void 0 !== n && (this.text += r.slice(e));
                                break e;
                            default:
                                t = 0;
                        }
                        this.forbiddenState = t;
                    }
                    handleTextOutsideRoot() {
                        let { i: e } = this;
                        const { chunk: t, textHandler: r } = this;
                        let n = !1;
                        e: for(;;){
                            const i = this.getCode();
                            switch(i){
                                case 60:
                                    if (this.state = 15, void 0 !== r) {
                                        const { text: n } = this, i = t.slice(e, this.prevI);
                                        0 !== n.length ? (r(n + i), this.text = "") : 0 !== i.length && r(i);
                                    }
                                    break e;
                                case 38:
                                    this.state = 14, this.entityReturnState = 13, void 0 !== r && (this.text += t.slice(e, this.prevI)), n = !0;
                                    break e;
                                case -2:
                                    void 0 !== r && (this.text += t.slice(e, this.prevI) + "\n"), e = this.i;
                                    break;
                                case -1:
                                    void 0 !== r && (this.text += t.slice(e));
                                    break e;
                                default:
                                    o(i) || (n = !0);
                            }
                        }
                        n && (this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0));
                    }
                    pushAttribNS(e, t) {
                        var r;
                        const { prefix: n, local: i } = this.qname(e), s = {
                            name: e,
                            prefix: n,
                            local: i,
                            value: t
                        };
                        if (this.attribList.push(s), null === (r = this.attributeHandler) || void 0 === r || r.call(this, s), "xmlns" === n) {
                            const e = t.trim();
                            "1.0" === this.currentXMLVersion && "" === e && this.fail("invalid attempt to undefine prefix in XML 1.0"), this.topNS[i] = e, C(this, i, e);
                        } else if ("xmlns" === e) {
                            const e = t.trim();
                            this.topNS[""] = e, C(this, "", e);
                        }
                    }
                    pushAttribPlain(e, t) {
                        var r;
                        const n = {
                            name: e,
                            value: t
                        };
                        this.attribList.push(n), null === (r = this.attributeHandler) || void 0 === r || r.call(this, n);
                    }
                    end() {
                        var e, t;
                        this.sawRoot || this.fail("document must contain a root element.");
                        const { tags: r } = this;
                        for(; r.length > 0;){
                            const e = r.pop();
                            this.fail("unclosed tag: " + e.name);
                        }
                        0 !== this.state && 13 !== this.state && this.fail("unexpected end.");
                        const { text: n } = this;
                        return 0 !== n.length && (null === (e = this.textHandler) || void 0 === e || e.call(this, n), this.text = ""), this._closed = !0, null === (t = this.endHandler) || void 0 === t || t.call(this), this._init(), this;
                    }
                    resolve(e) {
                        var t, r;
                        let n = this.topNS[e];
                        if (void 0 !== n) return n;
                        const { tags: i } = this;
                        for(let t = i.length - 1; t >= 0; t--)if (n = i[t].ns[e], void 0 !== n) return n;
                        return n = this.ns[e], void 0 !== n ? n : null === (r = (t = this.opt).resolvePrefix) || void 0 === r ? void 0 : r.call(t, e);
                    }
                    qname(e) {
                        const t = e.indexOf(":");
                        if (-1 === t) return {
                            prefix: "",
                            local: e
                        };
                        const r = e.slice(t + 1), n = e.slice(0, t);
                        return ("" === n || "" === r || r.includes(":")) && this.fail(`malformed name: ${e}.`), {
                            prefix: n,
                            local: r
                        };
                    }
                    processAttribsNS() {
                        var e;
                        const { attribList: t } = this, r = this.tag;
                        {
                            const { prefix: t, local: n } = this.qname(r.name);
                            r.prefix = t, r.local = n;
                            const i = r.uri = null !== (e = this.resolve(t)) && void 0 !== e ? e : "";
                            "" !== t && ("xmlns" === t && this.fail('tags may not have "xmlns" as prefix.'), "" === i && (this.fail(`unbound namespace prefix: ${JSON.stringify(t)}.`), r.uri = t));
                        }
                        if (0 === t.length) return;
                        const { attributes: n } = r, i = new Set;
                        for (const e of t){
                            const { name: t, prefix: r, local: s } = e;
                            let o, a;
                            "" === r ? (o = "xmlns" === t ? g : "", a = t) : (o = this.resolve(r), void 0 === o && (this.fail(`unbound namespace prefix: ${JSON.stringify(r)}.`), o = r), a = `{${o}}${s}`), i.has(a) && this.fail(`duplicate attribute: ${a}.`), i.add(a), e.uri = o, n[t] = e;
                        }
                        this.attribList = [];
                    }
                    processAttribsPlain() {
                        const { attribList: e } = this, t = this.tag.attributes;
                        for (const { name: r, value: n } of e)void 0 !== t[r] && this.fail(`duplicate attribute: ${r}.`), t[r] = n;
                        this.attribList = [];
                    }
                    openTag() {
                        var e;
                        this.processAttribs();
                        const { tags: t } = this, r = this.tag;
                        r.isSelfClosing = !1, null === (e = this.openTagHandler) || void 0 === e || e.call(this, r), t.push(r), this.state = 13, this.name = "";
                    }
                    openSelfClosingTag() {
                        var e, t, r;
                        this.processAttribs();
                        const { tags: n } = this, i = this.tag;
                        i.isSelfClosing = !0, null === (e = this.openTagHandler) || void 0 === e || e.call(this, i), null === (t = this.closeTagHandler) || void 0 === t || t.call(this, i);
                        null === (this.tag = null !== (r = n[n.length - 1]) && void 0 !== r ? r : null) && (this.closedRoot = !0), this.state = 13, this.name = "";
                    }
                    closeTag() {
                        const { tags: e, name: t } = this;
                        if (this.state = 13, this.name = "", "" === t) return this.fail("weird empty close tag."), void (this.text += "</>");
                        const r = this.closeTagHandler;
                        let n = e.length;
                        for(; n-- > 0;){
                            const n = this.tag = e.pop();
                            if (this.topNS = n.ns, null == r || r(n), n.name === t) break;
                            this.fail("unexpected close tag.");
                        }
                        0 === n ? this.closedRoot = !0 : n < 0 && (this.fail(`unmatched closing tag: ${t}.`), this.text += `</${t}>`);
                    }
                    parseEntity(e) {
                        if ("#" !== e[0]) {
                            const t = this.ENTITIES[e];
                            return void 0 !== t ? t : (this.fail(this.isName(e) ? "undefined entity." : "disallowed character in entity name."), `&${e};`);
                        }
                        let t = NaN;
                        return "x" === e[1] && /^#x[0-9a-f]+$/i.test(e) ? t = parseInt(e.slice(2), 16) : /^#[0-9]+$/.test(e) && (t = parseInt(e.slice(1), 10)), this.isChar(t) ? String.fromCodePoint(t) : (this.fail("malformed character entity."), `&${e};`);
                    }
                };
            },
            {
                "xmlchars/xml/1.0/ed5": 543,
                "xmlchars/xml/1.1/ed2": 544,
                "xmlchars/xmlns/1.0/ed3": 545
            }
        ],
        497: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;){
                        for(var l = o % i, c = Math.min(s - a, i - l), u = 0; u < c; u++)r[l + u] = e[a + u];
                        a += c, (o += c) % i == 0 && this._update(r);
                    }
                    return this._len += s, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var s = this._hash();
                    return e ? s.toString(e) : s;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, t.exports = i;
            },
            {
                "safe-buffer": 494
            }
        ],
        498: [
            function(e, t, r) {
                "use strict";
                var n = t.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = e("./sha"), n.sha1 = e("./sha1"), n.sha224 = e("./sha224"), n.sha256 = e("./sha256"), n.sha384 = e("./sha384"), n.sha512 = e("./sha512");
            },
            {
                "./sha": 499,
                "./sha1": 500,
                "./sha224": 501,
                "./sha256": 502,
                "./sha384": 503,
                "./sha512": 504
            }
        ],
        499: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function u(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h)r[h] = e.readInt32BE(4 * h);
                    for(; h < 80; ++h)r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
                    for(var f = 0; f < 80; ++f){
                        var d = ~~(f / 20), p = 0 | ((t = n) << 5 | t >>> 27) + u(d, i, s, a) + l + r[f] + o[d];
                        l = a, a = s, s = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        500: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function u(e) {
                    return e << 30 | e >>> 2;
                }
                function h(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, f = 0; f < 16; ++f)r[f] = e.readInt32BE(4 * f);
                    for(; f < 80; ++f)r[f] = (t = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1 | t >>> 31;
                    for(var d = 0; d < 80; ++d){
                        var p = ~~(d / 20), m = c(n) + h(p, i, s, a) + l + r[d] + o[p] | 0;
                        l = a, a = s, s = u(i), i = n, n = m;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        501: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha256"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(64);
                function l() {
                    this.init(), this._w = a, s.call(this, 64, 56);
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha256": 502,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        502: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], a = new Array(64);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function f(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function d(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, b = 0 | this._h, g = 0; g < 16; ++g)r[g] = e.readInt32BE(4 * g);
                    for(; g < 64; ++g)r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + d(r[g - 15]) + r[g - 16];
                    for(var y = 0; y < 64; ++y){
                        var v = b + f(l) + c(l, p, m) + o[y] + r[y] | 0, w = h(n) + u(n, i, s) | 0;
                        b = m, m = p, p = l, l = a + v | 0, a = s, s = i, i = n, n = v + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = b + this._h | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        503: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha512"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(160);
                function l() {
                    this.init(), this._w = a, s.call(this, 128, 112);
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha512": 504,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        504: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], a = new Array(160);
                function l() {
                    this.init(), this._w = a, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function f(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function d(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function m(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function g(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, l.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, v = 0 | this._hh, w = 0 | this._al, _ = 0 | this._bl, x = 0 | this._cl, k = 0 | this._dl, S = 0 | this._el, M = 0 | this._fl, C = 0 | this._gl, T = 0 | this._hl, E = 0; E < 32; E += 2)t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
                    for(; E < 160; E += 2){
                        var A = t[E - 30], R = t[E - 30 + 1], O = d(A, R), j = p(R, A), I = m(A = t[E - 4], R = t[E - 4 + 1]), N = b(R, A), P = t[E - 14], B = t[E - 14 + 1], D = t[E - 32], F = t[E - 32 + 1], L = j + B | 0, z = O + P + g(L, j) | 0;
                        z = (z = z + I + g(L = L + N | 0, N) | 0) + D + g(L = L + F | 0, F) | 0, t[E] = z, t[E + 1] = L;
                    }
                    for(var U = 0; U < 160; U += 2){
                        z = t[U], L = t[U + 1];
                        var $ = u(r, n, i), H = u(w, _, x), V = h(r, w), q = h(w, r), W = f(a, S), X = f(S, a), K = o[U], Y = o[U + 1], Z = c(a, l, y), G = c(S, M, C), J = T + X | 0, Q = v + W + g(J, T) | 0;
                        Q = (Q = (Q = Q + Z + g(J = J + G | 0, G) | 0) + K + g(J = J + Y | 0, Y) | 0) + z + g(J = J + L | 0, L) | 0;
                        var ee = q + H | 0, te = V + $ + g(ee, q) | 0;
                        v = y, T = C, y = l, C = M, l = a, M = S, a = s + Q + g(S = k + J | 0, k) | 0, s = i, k = x, i = n, x = _, n = r, _ = w, r = Q + te + g(w = J + ee | 0, J) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + _ | 0, this._cl = this._cl + x | 0, this._dl = this._dl + k | 0, this._el = this._el + S | 0, this._fl = this._fl + M | 0, this._gl = this._gl + C | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, _) | 0, this._ch = this._ch + i + g(this._cl, x) | 0, this._dh = this._dh + s + g(this._dl, k) | 0, this._eh = this._eh + a + g(this._el, S) | 0, this._fh = this._fh + l + g(this._fl, M) | 0, this._gh = this._gh + y + g(this._gl, C) | 0, this._hh = this._hh + v + g(this._hl, T) | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        505: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                e("inherits")(i, n), i.Readable = e("readable-stream/readable.js"), i.Writable = e("readable-stream/writable.js"), i.Duplex = e("readable-stream/duplex.js"), i.Transform = e("readable-stream/transform.js"), i.PassThrough = e("readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function s() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", l));
                    var o = !1;
                    function a() {
                        o || (o = !0, e.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function u() {
                        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", l), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
                };
            },
            {
                events: 422,
                inherits: 440,
                "readable-stream/duplex.js": 507,
                "readable-stream/passthrough.js": 516,
                "readable-stream/readable.js": 517,
                "readable-stream/transform.js": 518,
                "readable-stream/writable.js": 519
            }
        ],
        506: [
            function(e, t, r) {
                "use strict";
                var n = {}.toString;
                t.exports = Array.isArray || function(e) {
                    return "[object Array]" == n.call(e);
                };
            },
            {}
        ],
        507: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_duplex.js");
            },
            {
                "./lib/_stream_duplex.js": 508
            }
        ],
        508: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args"), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                t.exports = h;
                var s = Object.create(e("core-util-is"));
                s.inherits = e("inherits");
                var o = e("./_stream_readable"), a = e("./_stream_writable");
                s.inherits(h, o);
                for(var l = i(a.prototype), c = 0; c < l.length; c++){
                    var u = l[c];
                    h.prototype[u] || (h.prototype[u] = a.prototype[u]);
                }
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                }
                function f() {
                    this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
                }
                function d(e) {
                    e.end();
                }
                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(h.prototype, "destroyed", {
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                }), h.prototype._destroy = function(e, t) {
                    this.push(null), this.end(), n.nextTick(t, e);
                };
            },
            {
                "./_stream_readable": 510,
                "./_stream_writable": 512,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466
            }
        ],
        509: [
            function(e, t, r) {
                "use strict";
                t.exports = s;
                var n = e("./_stream_transform"), i = Object.create(e("core-util-is"));
                function s(e) {
                    if (!(this instanceof s)) return new s(e);
                    n.call(this, e);
                }
                i.inherits = e("inherits"), i.inherits(s, n), s.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 511,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        510: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("process-nextick-args");
                        t.exports = v;
                        var s, o = e("isarray");
                        v.ReadableState = y;
                        e("events").EventEmitter;
                        var a = function(e, t) {
                            return e.listeners(t).length;
                        }, l = e("./internal/streams/stream"), c = e("safe-buffer").Buffer, u = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var h = Object.create(e("core-util-is"));
                        h.inherits = e("inherits");
                        var f = e("util"), d = void 0;
                        d = f && f.debuglog ? f.debuglog("stream") : function() {};
                        var p, m = e("./internal/streams/BufferList"), b = e("./internal/streams/destroy");
                        h.inherits(v, l);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function y(t, r) {
                            t = t || {};
                            var n = r instanceof (s = s || e("./_stream_duplex"));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, o = t.readableHighWaterMark, a = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = e("string_decoder/").StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
                        }
                        function v(t) {
                            if (s = s || e("./_stream_duplex"), !(this instanceof v)) return new v(t);
                            this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), l.call(this);
                        }
                        function w(e, t, r, n, i) {
                            var s, o = e._readableState;
                            null === t ? (o.reading = !1, function(e, t) {
                                if (t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, k(e);
                            }(e, o)) : (i || (s = function(e, t) {
                                var r;
                                n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                                var n;
                                return r;
                            }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function(e) {
                                return c.from(e);
                            }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : _(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? _(e, o, t, !1) : M(e, o)) : _(e, o, t, !1))) : n || (o.reading = !1));
                            return function(e) {
                                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                            }(o);
                        }
                        function _(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && k(e)), M(e, t);
                        }
                        Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function(e, t) {
                            this.push(null), t(e);
                        }, v.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), w(this, e, t, !1, r);
                        }, v.prototype.unshift = function(e) {
                            return w(this, e, null, !0, !1);
                        }, v.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, v.prototype.setEncoding = function(t) {
                            return p || (p = e("string_decoder/").StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
                        };
                        function x(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function k(e) {
                            var t = e._readableState;
                            t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(S, e) : S(e));
                        }
                        function S(e) {
                            d("emit readable"), e.emit("readable"), A(e);
                        }
                        function M(e, t) {
                            t.readingMore || (t.readingMore = !0, i.nextTick(C, e, t));
                        }
                        function C(e, t) {
                            for(var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);)r = t.length;
                            t.readingMore = !1;
                        }
                        function T(e) {
                            d("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), A(e), t.flowing && !t.reading && e.read(0);
                        }
                        function A(e) {
                            var t = e._readableState;
                            for(d("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function R(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function(e, t, r) {
                                var n;
                                e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function(e, t) {
                                    var r = t.head, n = 1, i = r.data;
                                    e -= i.length;
                                    for(; r = r.next;){
                                        var s = r.data, o = e > s.length ? s.length : e;
                                        if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                                            o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return t.length -= n, i;
                                }(e, t) : function(e, t) {
                                    var r = c.allocUnsafe(e), n = t.head, i = 1;
                                    n.data.copy(r), e -= n.data.length;
                                    for(; n = n.next;){
                                        var s = n.data, o = e > s.length ? s.length : e;
                                        if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                                            o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return t.length -= i, r;
                                }(e, t);
                                return n;
                            }(e, t.buffer, t.decoder), r);
                        }
                        function O(e) {
                            var t = e._readableState;
                            if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            t.endEmitted || (t.ended = !0, i.nextTick(j, t, e));
                        }
                        function j(e, t) {
                            e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                        }
                        function I(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        v.prototype.read = function(e) {
                            d("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : k(this), null;
                            if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && O(this), null;
                            var n, i = t.needReadable;
                            return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, v.prototype._read = function(e) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, v.prototype.pipe = function(e, t) {
                            var n = this, s = this._readableState;
                            switch(s.pipesCount){
                                case 0:
                                    s.pipes = e;
                                    break;
                                case 1:
                                    s.pipes = [
                                        s.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    s.pipes.push(e);
                            }
                            s.pipesCount += 1, d("pipe count=%d opts=%j", s.pipesCount, t);
                            var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? u : v;
                            function c(t, r) {
                                d("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), e.removeListener("close", g), e.removeListener("finish", y), e.removeListener("drain", h), e.removeListener("error", b), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", v), n.removeListener("data", m), f = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || h());
                            }
                            function u() {
                                d("onend"), e.end();
                            }
                            s.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", c);
                            var h = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, A(e));
                                };
                            }(n);
                            e.on("drain", h);
                            var f = !1;
                            var p = !1;
                            function m(t) {
                                d("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== I(s.pipes, e)) && !f && (d("false write response, pause", s.awaitDrain), s.awaitDrain++, p = !0), n.pause());
                            }
                            function b(t) {
                                d("onerror", t), v(), e.removeListener("error", b), 0 === a(e, "error") && e.emit("error", t);
                            }
                            function g() {
                                e.removeListener("finish", y), v();
                            }
                            function y() {
                                d("onfinish"), e.removeListener("close", g), v();
                            }
                            function v() {
                                d("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", m), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", b), e.once("close", g), e.once("finish", y), e.emit("pipe", n), s.flowing || (d("pipe resume"), n.resume()), e;
                        }, v.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = I(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, v.prototype.on = function(e, t) {
                            var r = l.prototype.on.call(this, e, t);
                            if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === e) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(T, this));
                            }
                            return r;
                        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (d("resume"), e.flowing = !0, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(E, e, t));
                            }(this, e)), this;
                        }, v.prototype.pause = function() {
                            return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, v.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (d("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < g.length; s++)e.on(g[s], this.emit.bind(this, g[s]));
                            return this._read = function(t) {
                                d("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), v._fromList = R;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/BufferList": 513,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                events: 422,
                inherits: 440,
                isarray: 506,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                "string_decoder/": 521,
                util: 188
            }
        ],
        511: [
            function(e, t, r) {
                "use strict";
                t.exports = o;
                var n = e("./_stream_duplex"), i = Object.create(e("core-util-is"));
                function s(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (!n) return this.emit("error", new Error("write callback called multiple times"));
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e), this._transformState = {
                        afterTransform: s.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
                }
                function a() {
                    var e = this;
                    "function" == typeof this._flush ? this._flush(function(t, r) {
                        l(e, t, r);
                    }) : l(this, null, null);
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                    return e.push(null);
                }
                i.inherits = e("inherits"), i.inherits(o, n), o.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
                }, o.prototype._transform = function(e, t, r) {
                    throw new Error("_transform() is not implemented");
                }, o.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, o.prototype._read = function(e) {
                    var t = this._transformState;
                    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                }, o.prototype._destroy = function(e, t) {
                    var r = this;
                    n.prototype._destroy.call(this, e, function(e) {
                        t(e), r.emit("close");
                    });
                };
            },
            {
                "./_stream_duplex": 508,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        512: [
            function(e, t, r) {
                (function(r, n, i) {
                    (function() {
                        "use strict";
                        var s = e("process-nextick-args");
                        function o(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        t.exports = y;
                        var a, l = !r.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(r.version.slice(0, 5)) > -1 ? i : s.nextTick;
                        y.WritableState = g;
                        var c = Object.create(e("core-util-is"));
                        c.inherits = e("inherits");
                        var u = {
                            deprecate: e("util-deprecate")
                        }, h = e("./internal/streams/stream"), f = e("safe-buffer").Buffer, d = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var p, m = e("./internal/streams/destroy");
                        function b() {}
                        function g(t, r) {
                            a = a || e("./_stream_duplex"), t = t || {};
                            var n = r instanceof a;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, c = t.writableHighWaterMark, u = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var h = !1 === t.decodeStrings;
                            this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var r = e._writableState, n = r.sync, i = r.writecb;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(r), t) !function(e, t, r, n, i) {
                                        --t.pendingcb, r ? (s.nextTick(i, n), s.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
                                    }(e, r, n, t, i);
                                    else {
                                        var o = x(r);
                                        o || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? l(w, e, r, o, i) : w(e, r, o, i);
                                    }
                                }(r, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                        }
                        function y(t) {
                            if (a = a || e("./_stream_duplex"), !(p.call(y, this) || this instanceof a)) return new y(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function v(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function w(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), S(e, t);
                        }
                        function _(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, i = new Array(n), s = t.corkedRequestsFree;
                                s.entry = r;
                                for(var a = 0, l = !0; r;)i[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                i.allBuffers = l, v(e, t, !0, t.length, i, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function x(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function k(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function S(e, t) {
                            var r = x(t);
                            return r && (!function(e, t) {
                                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
                        }
                        c.inherits(y, h), g.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: u.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                            value: function(e) {
                                return !!p.call(this, e) || this === y && e && e._writableState instanceof g;
                            }
                        })) : p = function(e) {
                            return e instanceof this;
                        }, y.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, y.prototype.write = function(e, t, r) {
                            var n, i = this._writableState, o = !1, a = !i.objectMode && (n = e, f.isBuffer(n) || n instanceof d);
                            return a && !f.isBuffer(e) && (e = function(e) {
                                return f.from(e);
                            }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = b), i.ended ? function(e, t) {
                                var r = new Error("write after end");
                                e.emit("error", r), s.nextTick(t, r);
                            }(this, r) : (a || function(e, t, r, n) {
                                var i = !0, o = !1;
                                return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(n, o), i = !1), i;
                            }(this, i, e, r)) && (i.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = f.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var l = t.length < t.highWaterMark;
                                l || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var c = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else v(e, t, !1, a, n, i, s);
                                return l;
                            }(this, i, a, e, t, r)), o;
                        }, y.prototype.cork = function() {
                            this._writableState.corked++;
                        }, y.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                        }, y.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), y.prototype._write = function(e, t, r) {
                            r(new Error("_write() is not implemented"));
                        }, y.prototype._writev = null, y.prototype.end = function(e, t, r) {
                            var n = this._writableState;
                            "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                                t.ending = !0, S(e, t), r && (t.finished ? s.nextTick(r) : e.once("finish", r));
                                t.ended = !0, e.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(y.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function(e, t) {
                            this.end(), t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                timers: 523,
                "util-deprecate": 524
            }
        ],
        513: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("util");
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return e.prototype.push = function(e) {
                        var t = {
                            data: e,
                            next: null
                        };
                        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                    }, e.prototype.unshift = function(e) {
                        var t = {
                            data: e,
                            next: this.head
                        };
                        0 === this.length && (this.tail = t), this.head = t, ++this.length;
                    }, e.prototype.shift = function() {
                        if (0 !== this.length) {
                            var e = this.head.data;
                            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                        }
                    }, e.prototype.clear = function() {
                        this.head = this.tail = null, this.length = 0;
                    }, e.prototype.join = function(e) {
                        if (0 === this.length) return "";
                        for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                        return r;
                    }, e.prototype.concat = function(e) {
                        if (0 === this.length) return n.alloc(0);
                        for(var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
                        return s;
                    }, e;
                }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                    var e = i.inspect({
                        length: this.length
                    });
                    return this.constructor.name + " " + e;
                });
            },
            {
                "safe-buffer": 520,
                util: 188
            }
        ],
        514: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args");
                function i(e, t) {
                    e.emit("error", t);
                }
                t.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                        return s || o ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, e)) : n.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t && t(e);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    }
                };
            },
            {
                "process-nextick-args": 466
            }
        ],
        515: [
            function(e, t, r) {
                arguments[4][490][0].apply(r, arguments);
            },
            {
                dup: 490,
                events: 422
            }
        ],
        516: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").PassThrough;
            },
            {
                "./readable": 517
            }
        ],
        517: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js");
            },
            {
                "./lib/_stream_duplex.js": 508,
                "./lib/_stream_passthrough.js": 509,
                "./lib/_stream_readable.js": 510,
                "./lib/_stream_transform.js": 511,
                "./lib/_stream_writable.js": 512
            }
        ],
        518: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").Transform;
            },
            {
                "./readable": 517
            }
        ],
        519: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_writable.js");
            },
            {
                "./lib/_stream_writable.js": 512
            }
        ],
        520: [
            function(e, t, r) {
                arguments[4][217][0].apply(r, arguments);
            },
            {
                buffer: 220,
                dup: 217
            }
        ],
        521: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 520
            }
        ],
        522: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 494
            }
        ],
        523: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = e("process/browser.js").nextTick, s = Function.prototype.apply, o = Array.prototype.slice, a = {}, l = 0;
                        function c(e, t) {
                            this._id = e, this._clearFn = t;
                        }
                        r.setTimeout = function() {
                            return new c(s.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(s.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(e) {
                            e.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(e, t) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                        }, r.unenroll = function(e) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(e) {
                            clearTimeout(e._idleTimeoutId);
                            var t = e._idleTimeout;
                            t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                e._onTimeout && e._onTimeout();
                            }, t));
                        }, r.setImmediate = "function" == typeof t ? t : function(e) {
                            var t = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return a[t] = !0, i(function() {
                                a[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
                            }), t;
                        }, r.clearImmediate = "function" == typeof n ? n : function(e) {
                            delete a[e];
                        };
                    }).call(this);
                }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
            },
            {
                "process/browser.js": 467,
                timers: 523
            }
        ],
        524: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(e, t) {
                            if (r("noDeprecation")) return e;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(t);
                                    r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        525: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : t.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            {}
        ],
        526: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            {}
        ],
        527: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = /%[sdj%]/g;
                        r.format = function(e) {
                            if (!g(e)) {
                                for(var t = [], r = 0; r < arguments.length; r++)t.push(a(arguments[r]));
                                return t.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, s = n.length, o = String(e).replace(i, function(e) {
                                if ("%%" === e) return "%";
                                if (r >= s) return e;
                                switch(e){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (e) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return e;
                                }
                            }), l = n[r]; r < s; l = n[++r])m(l) || !w(l) ? o += " " + l : o += " " + a(l);
                            return o;
                        }, r.deprecate = function(e, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(e, i).apply(this, arguments);
                            };
                            if (!0 === t.noDeprecation) return e;
                            var s = !1;
                            return function() {
                                if (!s) {
                                    if (t.throwDeprecation) throw new Error(i);
                                    t.traceDeprecation ? console.trace(i) : console.error(i), s = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                        var s, o = {};
                        function a(e, t) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(t) ? n.showHidden = t : t && r._extend(n, t), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, e, n.depth);
                        }
                        function l(e, t) {
                            var r = a.styles[t];
                            return r ? "\x1b[" + a.colors[r][0] + "m" + e + "\x1b[" + a.colors[r][1] + "m" : e;
                        }
                        function c(e, t) {
                            return e;
                        }
                        function u(e, t, n) {
                            if (e.customInspect && t && k(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                                var i = t.inspect(n, e);
                                return g(i) || (i = u(e, i, n)), i;
                            }
                            var s = function(e, t) {
                                if (y(t)) return e.stylize("undefined", "undefined");
                                if (g(t)) {
                                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return e.stylize(r, "string");
                                }
                                if (b(t)) return e.stylize("" + t, "number");
                                if (p(t)) return e.stylize("" + t, "boolean");
                                if (m(t)) return e.stylize("null", "null");
                            }(e, t);
                            if (s) return s;
                            var o = Object.keys(t), a = function(e) {
                                var t = {};
                                return e.forEach(function(e, r) {
                                    t[e] = !0;
                                }), t;
                            }(o);
                            if (e.showHidden && (o = Object.getOwnPropertyNames(t)), x(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return h(t);
                            if (0 === o.length) {
                                if (k(t)) {
                                    var l = t.name ? ": " + t.name : "";
                                    return e.stylize("[Function" + l + "]", "special");
                                }
                                if (v(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                                if (_(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                                if (x(t)) return h(t);
                            }
                            var c, w = "", S = !1, M = [
                                "{",
                                "}"
                            ];
                            (d(t) && (S = !0, M = [
                                "[",
                                "]"
                            ]), k(t)) && (w = " [Function" + (t.name ? ": " + t.name : "") + "]");
                            return v(t) && (w = " " + RegExp.prototype.toString.call(t)), _(t) && (w = " " + Date.prototype.toUTCString.call(t)), x(t) && (w = " " + h(t)), 0 !== o.length || S && 0 != t.length ? n < 0 ? v(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = S ? function(e, t, r, n, i) {
                                for(var s = [], o = 0, a = t.length; o < a; ++o)E(t, String(o)) ? s.push(f(e, t, r, n, String(o), !0)) : s.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || s.push(f(e, t, r, n, i, !0));
                                }), s;
                            }(e, t, n, a, o) : o.map(function(r) {
                                return f(e, t, n, a, r, S);
                            }), e.seen.pop(), function(e, t, r) {
                                if (e.reduce(function(e, t) {
                                    return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                                return r[0] + t + " " + e.join(", ") + " " + r[1];
                            }(c, w, M)) : M[0] + w + M[1];
                        }
                        function h(e) {
                            return "[" + Error.prototype.toString.call(e) + "]";
                        }
                        function f(e, t, r, n, i, s) {
                            var o, a, l;
                            if ((l = Object.getOwnPropertyDescriptor(t, i) || {
                                value: t[i]
                            }).get ? a = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (a = e.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(l.value) < 0 ? (a = m(r) ? u(e, l.value, null) : u(e, l.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function(e) {
                                return "  " + e;
                            }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                                return "   " + e;
                            }).join("\n")) : a = e.stylize("[Circular]", "special")), y(o)) {
                                if (s && i.match(/^\d+$/)) return a;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                            }
                            return o + ": " + a;
                        }
                        function d(e) {
                            return Array.isArray(e);
                        }
                        function p(e) {
                            return "boolean" == typeof e;
                        }
                        function m(e) {
                            return null === e;
                        }
                        function b(e) {
                            return "number" == typeof e;
                        }
                        function g(e) {
                            return "string" == typeof e;
                        }
                        function y(e) {
                            return void 0 === e;
                        }
                        function v(e) {
                            return w(e) && "[object RegExp]" === S(e);
                        }
                        function w(e) {
                            return "object" == typeof e && null !== e;
                        }
                        function _(e) {
                            return w(e) && "[object Date]" === S(e);
                        }
                        function x(e) {
                            return w(e) && ("[object Error]" === S(e) || e instanceof Error);
                        }
                        function k(e) {
                            return "function" == typeof e;
                        }
                        function S(e) {
                            return Object.prototype.toString.call(e);
                        }
                        function M(e) {
                            return e < 10 ? "0" + e.toString(10) : e.toString(10);
                        }
                        r.debuglog = function(e) {
                            if (y(s) && (s = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !o[e]) {
                                if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
                                    var n = t.pid;
                                    o[e] = function() {
                                        var t = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", e, n, t);
                                    };
                                } else o[e] = function() {};
                            }
                            return o[e];
                        }, r.inspect = a, a.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, a.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = d, r.isBoolean = p, r.isNull = m, r.isNullOrUndefined = function(e) {
                            return null == e;
                        }, r.isNumber = b, r.isString = g, r.isSymbol = function(e) {
                            return "symbol" == typeof e;
                        }, r.isUndefined = y, r.isRegExp = v, r.isObject = w, r.isDate = _, r.isError = x, r.isFunction = k, r.isPrimitive = function(e) {
                            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                        }, r.isBuffer = e("./support/isBuffer");
                        var C = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function T() {
                            var e = new Date, t = [
                                M(e.getHours()),
                                M(e.getMinutes()),
                                M(e.getSeconds())
                            ].join(":");
                            return [
                                e.getDate(),
                                C[e.getMonth()],
                                t
                            ].join(" ");
                        }
                        function E(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        r.log = function() {
                            console.log("%s - %s", T(), r.format.apply(r, arguments));
                        }, r.inherits = e("inherits"), r._extend = function(e, t) {
                            if (!t || !w(t)) return e;
                            for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                            return e;
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 526,
                _process: 467,
                inherits: 525
            }
        ],
        528: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), Object.defineProperty(r, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(r, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(r, "v4", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(r, "v5", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(r, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(r, "version", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(r, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(r, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return h.default;
                    }
                });
                var n = f(e("./v1.js")), i = f(e("./v3.js")), s = f(e("./v4.js")), o = f(e("./v5.js")), a = f(e("./nil.js")), l = f(e("./version.js")), c = f(e("./validate.js")), u = f(e("./stringify.js")), h = f(e("./parse.js"));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            {
                "./nil.js": 530,
                "./parse.js": 531,
                "./stringify.js": 535,
                "./v1.js": 536,
                "./v3.js": 537,
                "./v4.js": 539,
                "./v5.js": 540,
                "./validate.js": 541,
                "./version.js": 542
            }
        ],
        529: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function i(e, t) {
                    const r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function s(e, t, r, n, s, o) {
                    var a, l;
                    return i((a = i(i(t, e), i(n, o))) << (l = s) | a >>> 32 - l, r);
                }
                function o(e, t, r, n, i, o, a) {
                    return s(t & r | ~t & n, e, t, i, o, a);
                }
                function a(e, t, r, n, i, o, a) {
                    return s(t & n | r & ~n, e, t, i, o, a);
                }
                function l(e, t, r, n, i, o, a) {
                    return s(t ^ r ^ n, e, t, i, o, a);
                }
                function c(e, t, r, n, i, o, a) {
                    return s(r ^ (t | ~n), e, t, i, o, a);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = function(e) {
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(let r = 0; r < t.length; ++r)e[r] = t.charCodeAt(r);
                    }
                    return function(e) {
                        const t = [], r = 32 * e.length;
                        for(let n = 0; n < r; n += 8){
                            const r = e[n >> 5] >>> n % 32 & 255, i = parseInt("0123456789abcdef".charAt(r >>> 4 & 15) + "0123456789abcdef".charAt(15 & r), 16);
                            t.push(i);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[n(t) - 1] = t;
                        let r = 1732584193, s = -271733879, u = -1732584194, h = 271733878;
                        for(let t = 0; t < e.length; t += 16){
                            const n = r, f = s, d = u, p = h;
                            r = o(r, s, u, h, e[t], 7, -680876936), h = o(h, r, s, u, e[t + 1], 12, -389564586), u = o(u, h, r, s, e[t + 2], 17, 606105819), s = o(s, u, h, r, e[t + 3], 22, -1044525330), r = o(r, s, u, h, e[t + 4], 7, -176418897), h = o(h, r, s, u, e[t + 5], 12, 1200080426), u = o(u, h, r, s, e[t + 6], 17, -1473231341), s = o(s, u, h, r, e[t + 7], 22, -45705983), r = o(r, s, u, h, e[t + 8], 7, 1770035416), h = o(h, r, s, u, e[t + 9], 12, -1958414417), u = o(u, h, r, s, e[t + 10], 17, -42063), s = o(s, u, h, r, e[t + 11], 22, -1990404162), r = o(r, s, u, h, e[t + 12], 7, 1804603682), h = o(h, r, s, u, e[t + 13], 12, -40341101), u = o(u, h, r, s, e[t + 14], 17, -1502002290), s = o(s, u, h, r, e[t + 15], 22, 1236535329), r = a(r, s, u, h, e[t + 1], 5, -165796510), h = a(h, r, s, u, e[t + 6], 9, -1069501632), u = a(u, h, r, s, e[t + 11], 14, 643717713), s = a(s, u, h, r, e[t], 20, -373897302), r = a(r, s, u, h, e[t + 5], 5, -701558691), h = a(h, r, s, u, e[t + 10], 9, 38016083), u = a(u, h, r, s, e[t + 15], 14, -660478335), s = a(s, u, h, r, e[t + 4], 20, -405537848), r = a(r, s, u, h, e[t + 9], 5, 568446438), h = a(h, r, s, u, e[t + 14], 9, -1019803690), u = a(u, h, r, s, e[t + 3], 14, -187363961), s = a(s, u, h, r, e[t + 8], 20, 1163531501), r = a(r, s, u, h, e[t + 13], 5, -1444681467), h = a(h, r, s, u, e[t + 2], 9, -51403784), u = a(u, h, r, s, e[t + 7], 14, 1735328473), s = a(s, u, h, r, e[t + 12], 20, -1926607734), r = l(r, s, u, h, e[t + 5], 4, -378558), h = l(h, r, s, u, e[t + 8], 11, -2022574463), u = l(u, h, r, s, e[t + 11], 16, 1839030562), s = l(s, u, h, r, e[t + 14], 23, -35309556), r = l(r, s, u, h, e[t + 1], 4, -1530992060), h = l(h, r, s, u, e[t + 4], 11, 1272893353), u = l(u, h, r, s, e[t + 7], 16, -155497632), s = l(s, u, h, r, e[t + 10], 23, -1094730640), r = l(r, s, u, h, e[t + 13], 4, 681279174), h = l(h, r, s, u, e[t], 11, -358537222), u = l(u, h, r, s, e[t + 3], 16, -722521979), s = l(s, u, h, r, e[t + 6], 23, 76029189), r = l(r, s, u, h, e[t + 9], 4, -640364487), h = l(h, r, s, u, e[t + 12], 11, -421815835), u = l(u, h, r, s, e[t + 15], 16, 530742520), s = l(s, u, h, r, e[t + 2], 23, -995338651), r = c(r, s, u, h, e[t], 6, -198630844), h = c(h, r, s, u, e[t + 7], 10, 1126891415), u = c(u, h, r, s, e[t + 14], 15, -1416354905), s = c(s, u, h, r, e[t + 5], 21, -57434055), r = c(r, s, u, h, e[t + 12], 6, 1700485571), h = c(h, r, s, u, e[t + 3], 10, -1894986606), u = c(u, h, r, s, e[t + 10], 15, -1051523), s = c(s, u, h, r, e[t + 1], 21, -2054922799), r = c(r, s, u, h, e[t + 8], 6, 1873313359), h = c(h, r, s, u, e[t + 15], 10, -30611744), u = c(u, h, r, s, e[t + 6], 15, -1560198380), s = c(s, u, h, r, e[t + 13], 21, 1309151649), r = c(r, s, u, h, e[t + 4], 6, -145523070), h = c(h, r, s, u, e[t + 11], 10, -1120210379), u = c(u, h, r, s, e[t + 2], 15, 718787259), s = c(s, u, h, r, e[t + 9], 21, -343485551), r = i(r, n), s = i(s, f), u = i(u, d), h = i(h, p);
                        }
                        return [
                            r,
                            s,
                            u,
                            h
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        const t = 8 * e.length, r = new Uint32Array(n(t));
                        for(let n = 0; n < t; n += 8)r[n >> 5] |= (255 & e[n / 8]) << n % 32;
                        return r;
                    }(e), 8 * e.length));
                };
                r.default = u;
            },
            {}
        ],
        530: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = "00000000-0000-0000-0000-000000000000";
            },
            {}
        ],
        531: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    let t;
                    const r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        532: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            {}
        ],
        533: [
            function(e, t, r) {
                "use strict";
                let n;
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function() {
                    if (!n && (n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto), !n)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return n(i);
                };
                const i = new Uint8Array(16);
            },
            {}
        ],
        534: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                        case 3:
                            return t ^ r ^ n;
                    }
                }
                function i(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e) {
                    const t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], r = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = [];
                        for(let r = 0; r < t.length; ++r)e.push(t.charCodeAt(r));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    const s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o);
                    for(let t = 0; t < o; ++t){
                        const r = new Uint32Array(16);
                        for(let n = 0; n < 16; ++n)r[n] = e[64 * t + 4 * n] << 24 | e[64 * t + 4 * n + 1] << 16 | e[64 * t + 4 * n + 2] << 8 | e[64 * t + 4 * n + 3];
                        a[t] = r;
                    }
                    a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(let e = 0; e < o; ++e){
                        const s = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)s[t] = a[e][t];
                        for(let e = 16; e < 80; ++e)s[e] = i(s[e - 3] ^ s[e - 8] ^ s[e - 14] ^ s[e - 16], 1);
                        let o = r[0], l = r[1], c = r[2], u = r[3], h = r[4];
                        for(let e = 0; e < 80; ++e){
                            const r = Math.floor(e / 20), a = i(o, 5) + n(r, l, c, u) + h + t[r] + s[e] >>> 0;
                            h = u, u = c, c = i(l, 30) >>> 0, l = o, o = a;
                        }
                        r[0] = r[0] + o >>> 0, r[1] = r[1] + l >>> 0, r[2] = r[2] + c >>> 0, r[3] = r[3] + u >>> 0, r[4] = r[4] + h >>> 0;
                    }
                    return [
                        r[0] >> 24 & 255,
                        r[0] >> 16 & 255,
                        r[0] >> 8 & 255,
                        255 & r[0],
                        r[1] >> 24 & 255,
                        r[1] >> 16 & 255,
                        r[1] >> 8 & 255,
                        255 & r[1],
                        r[2] >> 24 & 255,
                        r[2] >> 16 & 255,
                        r[2] >> 8 & 255,
                        255 & r[2],
                        r[3] >> 24 & 255,
                        r[3] >> 16 & 255,
                        r[3] >> 8 & 255,
                        255 & r[3],
                        r[4] >> 24 & 255,
                        r[4] >> 16 & 255,
                        r[4] >> 8 & 255,
                        255 & r[4]
                    ];
                };
                r.default = s;
            },
            {}
        ],
        535: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                const s = [];
                for(let e = 0; e < 256; ++e)s.push((e + 256).toString(16).substr(1));
                var o = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const r = (s[e[t + 0]] + s[e[t + 1]] + s[e[t + 2]] + s[e[t + 3]] + "-" + s[e[t + 4]] + s[e[t + 5]] + "-" + s[e[t + 6]] + s[e[t + 7]] + "-" + s[e[t + 8]] + s[e[t + 9]] + "-" + s[e[t + 10]] + s[e[t + 11]] + s[e[t + 12]] + s[e[t + 13]] + s[e[t + 14]] + s[e[t + 15]]).toLowerCase();
                    if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
                    return r;
                };
                r.default = o;
            },
            {
                "./validate.js": 541
            }
        ],
        536: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                let o, a, l = 0, c = 0;
                var u = function(e, t, r) {
                    let s = t && r || 0;
                    const u = t || new Array(16);
                    let h = (e = e || {}).node || o, f = void 0 !== e.clockseq ? e.clockseq : a;
                    if (null == h || null == f) {
                        const t = e.random || (e.rng || n.default)();
                        null == h && (h = o = [
                            1 | t[0],
                            t[1],
                            t[2],
                            t[3],
                            t[4],
                            t[5]
                        ]), null == f && (f = a = 16383 & (t[6] << 8 | t[7]));
                    }
                    let d = void 0 !== e.msecs ? e.msecs : Date.now(), p = void 0 !== e.nsecs ? e.nsecs : c + 1;
                    const m = d - l + (p - c) / 1e4;
                    if (m < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (m < 0 || d > l) && void 0 === e.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    l = d, c = p, a = f, d += 122192928e5;
                    const b = (1e4 * (268435455 & d) + p) % 4294967296;
                    u[s++] = b >>> 24 & 255, u[s++] = b >>> 16 & 255, u[s++] = b >>> 8 & 255, u[s++] = 255 & b;
                    const g = d / 4294967296 * 1e4 & 268435455;
                    u[s++] = g >>> 8 & 255, u[s++] = 255 & g, u[s++] = g >>> 24 & 15 | 16, u[s++] = g >>> 16 & 255, u[s++] = f >>> 8 | 128, u[s++] = 255 & f;
                    for(let e = 0; e < 6; ++e)u[s + e] = h[e];
                    return t || (0, i.default)(u);
                };
                r.default = u;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        537: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./md5.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v3", 48, i.default);
                r.default = o;
            },
            {
                "./md5.js": 529,
                "./v35.js": 538
            }
        ],
        538: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function(e, t, r) {
                    function s(e, s, o, a) {
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof s && (s = (0, i.default)(s)), 16 !== s.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        let l = new Uint8Array(16 + e.length);
                        if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
                            a = a || 0;
                            for(let e = 0; e < 16; ++e)o[a + e] = l[e];
                            return o;
                        }
                        return (0, n.default)(l);
                    }
                    try {
                        s.name = e;
                    } catch (e) {}
                    return s.DNS = o, s.URL = a, s;
                }, r.URL = r.DNS = void 0;
                var n = s(e("./stringify.js")), i = s(e("./parse.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                r.DNS = o;
                const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                r.URL = a;
            },
            {
                "./parse.js": 531,
                "./stringify.js": 535
            }
        ],
        539: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = function(e, t, r) {
                    const s = (e = e || {}).random || (e.rng || n.default)();
                    if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) {
                        r = r || 0;
                        for(let e = 0; e < 16; ++e)t[r + e] = s[e];
                        return t;
                    }
                    return (0, i.default)(s);
                };
                r.default = o;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        540: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./sha1.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v5", 80, i.default);
                r.default = o;
            },
            {
                "./sha1.js": 534,
                "./v35.js": 538
            }
        ],
        541: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./regex.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
                r.default = s;
            },
            {
                "./regex.js": 532
            }
        ],
        542: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.substr(14, 1), 16);
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        543: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\t\n\r -\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 32 && e <= 55295 || 10 === e || 13 === e || 9 === e || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        544: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\x01-\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.RESTRICTED_CHAR_RE = new RegExp("^[" + r.RESTRICTED_CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 1 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isRestrictedChar = function(e) {
                    return e >= 1 && e <= 8 || 11 === e || 12 === e || e >= 14 && e <= 31 || e >= 127 && e <= 132 || e >= 134 && e <= 159;
                }, r.isCharAndNotRestricted = function(e) {
                    return 9 === e || 10 === e || 13 === e || e > 31 && e < 127 || 133 === e || e > 159 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        545: [
            function(e, t, r) {
                "use strict";
                /**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ function n(e) {
                    return e >= 65 && e <= 90 || 95 === e || e >= 97 && e <= 122 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c-\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NC_NAME_CHAR = "-" + r.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.NC_NAME_START_CHAR_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "]$", "u"), r.NC_NAME_CHAR_RE = new RegExp("^[" + r.NC_NAME_CHAR + "]$", "u"), r.NC_NAME_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "][" + r.NC_NAME_CHAR + "]*$", "u"), r.isNCNameStartChar = n, r.isNCNameChar = function(e) {
                    return n(e) || 45 === e || 46 === e || e >= 48 && e <= 57 || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});



var $9lDhw = parcelRequire("9lDhw");
/**
 * Sets options for a cell in the Excel worksheet.
 *
 * @param {object} cell - The cell object from the ExcelJS worksheet.
 * @param {object} options - An object containing the options to set on the cell.
 *
 * @returns {void}
 */ const $3ea562484f813133$var$setOptions = (cell, options)=>{
    Object.keys(options).forEach((key)=>{
        cell[key] = options[key];
    });
};
/**
 * Sets the value and options for a cell in the Excel worksheet.
 *
 * @param {Workbook} wb - The ExcelJS workbook object.
 * @param {string} id - The ID of the cell to set.
 * @param {*} value - The value to set for the cell.
 * @param {object} options - An object containing the options to set on the cell.
 * @param {object} logger - A logger object for logging errors.
 *
 * @returns {void}
 */ const $3ea562484f813133$var$setCell = (wb, id, value, options = {}, logger = console)=>{
    if (!value) {
        logger.error("No value provided for cell", wb, id);
        return;
    }
    if (id.indexOf(":") > -1) {
        wb.mergeCells(id);
        id = id.split(":")[0];
    }
    const cell = wb.getCell(id);
    cell.value = value;
    $3ea562484f813133$var$setOptions(cell, options);
};
/**
 * Gets the column key based on the column name.
 *
 * @param {string} columnName - The name of the column.
 *
 * @returns {string} - The key corresponding to the column name.
 */ const $3ea562484f813133$var$getColumnKey = (columnName)=>{
    switch(columnName){
        // Script
        case "No":
            return "id";
        case "Paragraph Text":
            return "text";
        case "Messaging":
            return "visualMessaging";
        // Personas
        // Notes
        case "Customer Name":
            return "customer";
        default:
            // transform to camelCase
            return columnName.replace(/[^a-zA-Z0-9 ]/g, "") // remove non-alphanumeric except space
            .split(" ").map((word, idx)=>idx === 0 ? word.charAt(0).toLowerCase() + word.slice(1) : word.charAt(0).toUpperCase() + word.slice(1)).join("");
    }
};
/**
 * Adds images to the specified worksheet in the Excel workbook.
 *
 * @param {Workbook} workbook - The ExcelJS workbook object.
 * @param {Worksheet} worksheet - The ExcelJS worksheet object where images will be added.
 * @param {Array} columnsIds - An array of column IDs to determine where to place the images.
 * @param {Array} items - An array of image URLs to be added to the worksheet.
 * @param {number} width - The width of the images to be added.
 * @param {number} height - The height of the images to be added.
 *
 * @returns {Promise<void>} - A promise that resolves when all images have been added.
 */ const $3ea562484f813133$var$addImagesToSheet = async (workbook, worksheet, columnsIds, items, width, height)=>{
    const imageIdIndex = columnsIds.findIndex(({ id: id })=>id === "image");
    if (imageIdIndex > -1) {
        const imagePromises = await Promise.allSettled(items.map((url, index)=>new Promise(async (resolve, reject)=>{
                if (url) try {
                    const { image: image, blob: blob } = await (0, $9lDhw.getImageBlob)({
                        url: url
                    });
                    const buffer = await blob.arrayBuffer();
                    const imageRef = workbook.addImage({
                        buffer: buffer,
                        extension: image.format
                    });
                    return resolve({
                        imageRef: imageRef,
                        index: index
                    });
                } catch (error) {
                    console.error("Error downloading image for script item:", error);
                    return reject(null);
                }
                reject(null);
            })));
        imagePromises.filter(({ status: status })=>status === "fulfilled").forEach(({ value: { imageRef: imageRef, index: index } })=>{
            worksheet.addImage(imageRef, {
                tl: {
                    col: imageIdIndex,
                    row: index + 1
                },
                ext: {
                    width: width,
                    height: height
                }
            });
        });
    }
};
/**
 * Generates an Excel file from the provided parameters.
 * @param {object} params - The parameters for generating the Excel file.
 *
 * @returns {Promise<Buffer>} - A promise that resolves to the Excel file buffer.
 */ const $3ea562484f813133$var$getExcel = async (params)=>{
    const workbook = new (0, (/*@__PURE__*/$parcel$interopDefault($1877ffdb17d7d631$exports))).Workbook();
    workbook.creator = params.user.name;
    workbook.created = new Date();
    workbook.views = [
        {
            x: 0,
            y: 0,
            width: 1000,
            height: 1000,
            firstSheet: 0,
            activeTab: 1,
            visibility: "visible"
        }
    ];
    const scriptSheet = workbook.addWorksheet("Script");
    const personasSheet = workbook.addWorksheet("Personas");
    const notesSheet = workbook.addWorksheet("Notes");
    const scriptColumnsIds = params.story.script.columns.map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
    const personasColumnsIds = params.story.personas.columns.map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
    if (params.story.script.items.some((item)=>!!item.visualUrl)) scriptColumnsIds.push({
        id: "visualPrompt",
        name: "Visual Prompt"
    }, {
        id: "image",
        name: "Image"
    });
    if (params.story.personas.items.some((item)=>!!item.avatarUrl)) personasColumnsIds.push({
        id: "descriptionPrompt",
        name: "Description Prompt"
    }, {
        id: "avatarPrompt",
        name: "Avatar Prompt"
    }, {
        id: "image",
        name: "Image"
    });
    scriptSheet.addTable({
        name: "Script",
        ref: "A1",
        headerRow: true,
        totalsRow: false,
        style: {
            theme: "TableStyleMedium2",
            showRowStripes: true
        },
        columns: scriptColumnsIds.map(({ name: name })=>({
                name: name,
                filterButton: true
            })),
        rows: params.story.script.items.map((item)=>{
            const ret = {
                ...item
            };
            Object.keys(item).forEach((key)=>{
                if (key === "image") ret[key] = "";
                else if (key === "personas") ret[key] = item[key].map((idx)=>params.story.personas.items[idx]?.name ?? idx).join("\n");
                else if (Array.isArray(item[key])) ret[key] = item[key].join("\n");
            });
            return scriptColumnsIds.map(({ id: id })=>ret[id]);
        })
    });
    [
        8,
        30,
        65,
        50,
        50,
        25,
        28,
        28,
        34,
        34,
        50,
        30
    ].map((width, index)=>{
        if (width) $3ea562484f813133$var$setOptions(scriptSheet.getColumn(index + 1), {
            width: width,
            alignment: {
                wrapText: true
            }
        });
    });
    await $3ea562484f813133$var$addImagesToSheet(workbook, scriptSheet, scriptColumnsIds, params.story.script.items.map(({ visualUrl: visualUrl })=>visualUrl), 180, 101);
    personasSheet.addTable({
        name: "Personas",
        ref: "A1",
        headerRow: true,
        totalsRow: false,
        style: {
            theme: "TableStyleMedium2",
            showRowStripes: true
        },
        columns: personasColumnsIds.map(({ name: name })=>({
                name: name,
                filterButton: true
            })),
        rows: params.story.personas.items.map((item)=>{
            const ret = {
                ...item
            };
            Object.keys(item).forEach((key)=>{
                if (key === "image") ret[key] = "";
                else if (Array.isArray(item[key])) ret[key] = item[key].join("\n");
            });
            return personasColumnsIds.map(({ id: id })=>ret[id]);
        })
    });
    [
        20,
        30,
        30,
        60,
        20,
        8,
        50,
        50,
        30
    ].map((width, index)=>{
        if (width) $3ea562484f813133$var$setOptions(personasSheet.getColumn(index + 1), {
            width: width,
            alignment: {
                wrapText: true
            }
        });
    });
    await $3ea562484f813133$var$addImagesToSheet(workbook, personasSheet, personasColumnsIds, params.story.personas.items.map(({ avatarUrl: avatarUrl })=>avatarUrl), 101, 101);
    const storySections = [
        ...new Set(params.story.script.items.map(({ section: section })=>section))
    ];
    notesSheet.addTable({
        name: "Notes",
        ref: "A1",
        // headerRow: false,
        style: {
            theme: "TableStyleMedium2",
            showFirstColumn: true,
            showColumnStripes: true
        },
        columns: [
            {
                name: "Key"
            },
            {
                name: "Value"
            }
        ],
        rows: [
            [
                "Title",
                params.story.title || ""
            ],
            [
                "Customer Name",
                params.story.customer || ""
            ],
            [
                "Industry",
                params.story.industry || ""
            ],
            [
                "Campaign Focus",
                params.story.campaignFocus || ""
            ],
            [
                "Story Overview",
                `${params.story.storyOverview || ""}${!!storySections.length ? `\n\n${storySections.join("\n")}` : ""}` || ""
            ],
            [
                "Business Goals",
                params.story.businessGoals || ""
            ],
            [
                "Products",
                params.story?.products?.join("\n") || ""
            ]
        ]
    });
    $3ea562484f813133$var$setOptions(notesSheet.getColumn(1), {
        width: 30,
        alignment: {
            wrapText: true
        }
    });
    $3ea562484f813133$var$setOptions(notesSheet.getColumn(2), {
        width: 80,
        alignment: {
            wrapText: true
        }
    });
    return workbook;
};
/**
 * Downloads the story data as an Excel file.
 *
 * @param {object} params - The parameters for downloading the Excel file.
 *
 * @returns {Promise<void>} - A promise that resolves when the file is downloaded.
 * @throws {Error} If the parameters are invalid or if an error occurs during file generation
 */ const $3ea562484f813133$export$614788f8f473dbf7 = async (params)=>{
    if (!params || !params.story) throw new Error("Invalid parameters provided for downloading Excel file.");
    try {
        const workbook = await $3ea562484f813133$var$getExcel(params);
        const buffer = await workbook.xlsx.writeBuffer();
        (0, $9lDhw.downloadFile)(buffer, `storyteller-ai-${params.story.customer}-${params.story.industry}-${Date.now()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    } catch (error) {
        console.error("Error generating Excel file:", error);
        throw error;
    }
};
/**
 * Parses an Excel file and extracts story data.
 *
 * @param {File} file - The Excel file to parse.
 *
 * @returns {Promise<object>} - A promise that resolves to an object containing the parsed story data.
 * @throws {Error} If the file is not provided or if an error occurs during parsing
 */ const $3ea562484f813133$export$e8acf0517c6f13f5 = async (file)=>{
    if (!file) throw new Error("No file provided for parsing.");
    const story = {
        title: "",
        storyOverview: "",
        customer: "",
        industry: "",
        businessGoals: "",
        campaignFocus: "",
        personas: [],
        products: [],
        script: []
    };
    try {
        const workbook = new (0, (/*@__PURE__*/$parcel$interopDefault($1877ffdb17d7d631$exports))).Workbook();
        await workbook.xlsx.load(file.arrayBuffer());
        const sheets = workbook.worksheets.filter((ws)=>[
                "script",
                "personas"
            ].includes(ws.name.toLowerCase())).filter(Boolean);
        sheets.forEach((sheet, idx)=>{
            sheet.eachRow((row, rowNumber)=>{
                if (rowNumber === 1) return;
                const rowData = {};
                row.eachCell((cell, colNumber)=>{
                    if (!cell.value) return;
                    const key = $3ea562484f813133$var$getColumnKey(sheet.getRow(1).getCell(colNumber).value);
                    if ([
                        "script",
                        "personas"
                    ].includes(key)) rowData[key] = cell.value.split(/[,\n]/).map((item)=>item.trim());
                    else rowData[key] = cell.value;
                });
                rowData.id = rowNumber - 2; // Adjusting index to start from 0
                if (idx === 0) story.script.push(rowData);
                else story.personas.push(rowData);
            });
        });
        workbook.worksheets.find((ws)=>ws.name.toLowerCase() === "notes")?.eachRow((row, rowNumber)=>{
            const key = $3ea562484f813133$var$getColumnKey(row.getCell(1).value);
            const value = row.getCell(2).value;
            if (key && value) {
                if (key === "products") story[key] = value.split(/[,\n]/).map((item)=>item.trim());
                else story[key] = value;
            }
        });
        story.script.forEach((step)=>{
            if (step.personas?.length) step.personas = step.personas.map((name)=>story.personas.findIndex((persona)=>persona.name.includes(name)));
        });
        return story;
    // logger.debug("Parsed Excel file", JSON.stringify(story, null, 2));
    // return json;
    } catch (error) {
        console.error("Error parsing Excel file:", error);
        throw new Error("Error parsing Excel file: " + error.message);
    }
};


/**
 * Writes the provided rich and plain text to the clipboard.
 * @param {{ rich: string, plain: string }} param0 - The text to copy.
 *
 * @returns {Promise<ClipboardItem>} - A promise that resolves with the ClipboardItem.
 */ const $4a26ab9efb3777da$export$e84ab21a5791681d = async ({ rich: rich, plain: plain })=>new Promise(async (resolve, reject)=>{
        try {
            const clipboardData = {};
            if (rich) {
                const html = new Blob([
                    rich
                ], {
                    type: "text/html"
                });
                clipboardData["text/html"] = html;
            }
            if (plain) {
                const textBlob = new Blob([
                    plain
                ], {
                    type: "text/plain"
                });
                clipboardData["text/plain"] = textBlob;
            }
            const data = new ClipboardItem(clipboardData);
            await navigator.clipboard.write([
                data
            ]);
            resolve(data);
            console.log("Text copied to clipboard");
        } catch (error) {
            console.error("Failed to copy text to clipboard", error);
            reject(error);
        }
    });


/**
 * Generates a story outline from the provided story object.
 * @param {*} story - The story object containing the script and metadata.
 *
 * @returns {Object} - An object containing the rich and plain text representations of the outline.
 */ const $eac26b4c0577e2d0$var$getOutline = (story)=>{
    const fragment = document.createDocumentFragment();
    const title = document.createElement("h1");
    title.textContent = story.title;
    fragment.append(title);
    const outline = `${story.title}\n`;
    const express = {
        title: story.title,
        sections: []
    };
    story.script.forEach(({ title: title, text: text, personas: personas, solutions: solutions, comments: comments, visual: visual, visualMessaging: visualMessaging })=>{
        const sectionTitle = document.createElement("h2");
        sectionTitle.textContent = title;
        const ul = document.createElement("ul");
        const section = {
            title: title,
            topics: [
                {
                    content: text
                }
            ]
        };
        outline += `\n${title}\n`;
        if (text) text.split("\n").forEach((line)=>{
            const li = document.createElement("li");
            li.textContent = line;
            ul.appendChild(li);
            outline += `\u{2022}	${line}\n`;
        });
        //   if (personas && personas.length) {
        //     const personasLine = document.createElement("li");
        //     personasLine.textContent = `[[Personas: ${personas.join(", ")}]]`;
        //     ul.appendChild(personasLine);
        //     outline += `•	${personasLine.textContent}\n`;
        //   }
        //   if (solutions && solutions.length) {
        //     const solutionsLine = document.createElement("li");
        //     solutionsLine.textContent = `[[Solutions: ${solutions.join(", ")}]]`;
        //     ul.appendChild(solutionsLine);
        //     outline += `•	${solutionsLine.textContent}\n`;
        //   }
        // if (visual || visualMessaging) {
        //   const visualLine = document.createElement("li");
        //   visualLine.textContent = `[[Visual: ${visual || visualMessaging}]]`;
        //   ul.appendChild(visualLine);
        //   outline += `•	${visualLine.textContent}\n`;
        // }
        //   if (comments && comments.length) {
        //     const commentsLine = document.createElement("li");
        //     commentsLine.textContent = `[[Comments: ${comments}]]`;
        //     ul.appendChild(commentsLine);
        //     outline += `•	${commentsLine.textContent}\n`;
        //   }
        fragment.append(sectionTitle, ul);
        express.sections.push(section);
    });
    const fragmentContainer = document.createElement("div");
    fragmentContainer.appendChild(fragment);
    return {
        rich: fragmentContainer.innerHTML,
        plain: outline,
        express: express
    };
};
const $eac26b4c0577e2d0$export$244fcd8734d6281c = (story)=>new Promise((resolve, reject)=>{
        try {
            const outline = $eac26b4c0577e2d0$var$getOutline(story);
            (0, $4a26ab9efb3777da$export$e84ab21a5791681d)(outline).then(()=>{
                resolve(outline);
            }).catch((error)=>{
                console.error("Failed to copy outline to clipboard:", error);
                reject(error);
            });
        } catch (error) {
            console.error("Error generating story outline:", error);
            reject(error);
        }
    });



var $8Ogg5 = parcelRequire("8Ogg5");

var $6lZyT = parcelRequire("6lZyT");

var $D7J7L = parcelRequire("D7J7L");
const $1e082e4b7b205f21$var$getSlideVisual = (slide)=>{
    let visual = {
        ...slide.visuals?.[slide.visual]
    };
    if (!visual) return null;
    if (visual.type === "firefly" && visual.libraryId) // FIXME: fix duplicated visuals from CC library
    visual = {
        ...slide.visuals?.[slide.visual - 1]
    };
    return visual;
};
const $1e082e4b7b205f21$var$getMediaImage = async (visual, objectFit = (0, $6lZyT.OBJECT_FIT).COVER, objectPosition = (0, $6lZyT.OBJECT_POSITION).CENTER, containerSize = {})=>{
    if (!visual) return {};
    if (visual.type === "cc-library") visual.url = await (0, $8Ogg5.getPresignedImageUrl)(visual.libraryId, visual.id);
    const imageId = Math.floor(Math.random() * 9000000000) + 1000000000;
    /*
   source: "firefly",
        id: `${imageId}`,
        url: slide.visuals?.[0]?.url,
        width: 1920,
        height: 1080,
        prompt: slide.visuals?.[0]?.prompt,
        seed: slide.visuals?.[0]?.seed,
        style: "",*/ // Validate URL before including in manifest
    if (!visual.url) {
        console.warn("Visual has no URL, skipping media inclusion");
        return {};
    }
    // Log the URL for debugging
    console.log("Including visual with URL:", visual.url);
    const ret = {
        media: {
            type: "image",
            data: {
                source: "plain",
                id: `${imageId}`,
                url: visual.url,
                width: 2688,
                height: 1536
            }
        }
    };
    if (objectFit === (0, $6lZyT.OBJECT_FIT).CONTAIN) {
        const blob = await fetch(visual.url).then((res)=>res.blob());
        const croppedBlob = await (0, $6lZyT.cropImageBlob)(blob, containerSize, (0, $6lZyT.OBJECT_FIT).CONTAIN, objectPosition);
        const croppedUrl = await (0, $D7J7L.uploadFileByBlob)();
    // ret.media.data.saliency = fourCornerSaliency(48, 48, {
    //   // sigma: 0.0001,
    //   // normalize: "minmax",
    // });
    // TODO: crop image to fit within container
    }
    return ret;
};
const $1e082e4b7b205f21$var$getSlides = async (story)=>{
    const slides = story.script.slice(2, -1).map((slide)=>({
            ...slide,
            personas: slide?.personas?.map((idx)=>story.personas[idx]) ?? []
        }));
    const presentation = {
        version: "1.0.0",
        slides: []
    };
    const [coverVisual, introVisual] = await Promise.all([
        $1e082e4b7b205f21$var$getMediaImage($1e082e4b7b205f21$var$getSlideVisual(story.script[0])),
        $1e082e4b7b205f21$var$getMediaImage($1e082e4b7b205f21$var$getSlideVisual(story.script[1]))
    ]);
    const coverSlide = {
        archetype: "cover",
        index: 0,
        title: story.script[0].title,
        subtitle: "Customer Journey",
        ...coverVisual
    };
    const introSlide = {
        archetype: "small_title",
        index: 1,
        title: story.script[1].title,
        chapter: story.script[0].title,
        ...introVisual
    };
    const agendaSlide = {
        archetype: "agenda",
        index: 2,
        chapter: story.script[0].title,
        agenda: Object.entries(slides.reduce((acc, slide)=>{
            if (slide.section !== slide.title) {
                acc[slide.section] = acc[slide.section] || [];
                if (slide.title) acc[slide.section].push(slide.title);
            } else acc[slide.title] = [];
            return acc;
        }, {})).map(([chapter, topics])=>({
                chapter: chapter,
                topics: topics
            }))
    };
    // Only add customContent if introVisual has media
    if (introVisual?.media) agendaSlide.customContent = [
        {
            role: "custom:visual",
            type: "media",
            data: introVisual.media
        }
    ];
    presentation.slides.push(coverSlide, introSlide, agendaSlide);
    // TODO: check selected brand and fetch logo
    // const logo = getMediaImage(logoAsset, OBJECT_FIT.CONTAIN, OBJECT_POSITION.LEFT, { width: 421, height: 112 });
    const logo = {};
    let section_id;
    for(let idx = 0; idx < slides.length; idx++){
        const { section: section, title: title, text: text, personas: personas = [], visuals: visuals } = slides[idx];
        let archetype;
        const visualUrl = visuals?.[0]?.url;
        const visualSeed = visuals?.[0]?.seed;
        const visualPrompt = visuals?.[0]?.prompt;
        const index = idx + 3;
        if (section !== slides?.[idx - 1]?.section) {
            archetype = "chapter";
            section_id = crypto.randomUUID();
        } else archetype = "content";
        if (personas.some((persona)=>title.includes(persona.name))) archetype = "custom:personaIntroduction";
        const slide = {
            archetype: archetype,
            index: index,
            chapter: `${story.script[0].title}   |   ${section}`,
            section_id: section_id,
            title: title
        };
        // TODO: add support for icons
        const [slideVisual, slideIcon] = await Promise.all([
            $1e082e4b7b205f21$var$getMediaImage($1e082e4b7b205f21$var$getSlideVisual(slides[idx])),
            Promise.resolve({})
        ]);
        switch(archetype){
            case "chapter":
                slide.subtitle = text;
                if (slideVisual.media) slide.media = slideVisual.media;
                break;
            case "custom:personaIntroduction":
                slide.customContent = [
                    {
                        role: "custom:chapter",
                        type: "text",
                        data: {
                            // heading: slide.chapter,
                            // points: [{ point: "" }],
                            points: [
                                {
                                    point: slide.chapter
                                }
                            ]
                        }
                    },
                    {
                        role: "custom:title",
                        type: "text",
                        data: {
                            // heading: title,
                            // points: [{ point: "" }],
                            points: [
                                {
                                    point: title
                                }
                            ]
                        }
                    },
                    {
                        role: "custom:subtitle",
                        type: "text",
                        data: {
                            // heading: personas[0]?.role || "",
                            points: [
                                {
                                    point: personas[0]?.role || ""
                                }
                            ]
                        }
                    },
                    {
                        role: "custom:content",
                        type: "text",
                        data: {
                            // heading: personas[0]?.role || "",
                            points: !!text ? text?.split("\n").map((point)=>({
                                    point: point
                                })) : []
                        }
                    }
                ];
                [
                    [
                        slideVisual,
                        "visual"
                    ],
                    [
                        slideIcon,
                        "icon"
                    ],
                    [
                        logo,
                        "logo"
                    ]
                ].forEach(([visualItem, role])=>{
                    if (visualItem.media) slide.customContent.push({
                        role: `custom:${role}`,
                        type: "media",
                        data: visualItem.media
                    });
                });
                break;
            case "content":
            default:
                slide.content = [
                    {
                        //   text: { heading: text },
                        text: {
                            // heading: text,
                            // points: !!text
                            //   ? text?.split("\n").map((point) => ({ point }))
                            //   : [],
                            // points: !!text
                            //   ? `${text}\n${text}`?.split("\n").map((point) => ({ point }))
                            //   : [],
                            points: !!text ? [
                                {
                                    point: text
                                }
                            ] : []
                        },
                        ...slideVisual
                    }
                ];
                slide.layout_preference = "column";
                if (personas.length > 0) {
                    slide.customContent = [
                        {
                            role: "custom:personaName",
                            type: "text",
                            data: {
                                points: [
                                    {
                                        point: personas[0]?.name || ""
                                    }
                                ]
                            }
                        },
                        {
                            role: "custom:personaRole",
                            type: "text",
                            data: {
                                points: [
                                    {
                                        point: personas[0]?.role || ""
                                    }
                                ]
                            }
                        }
                    ];
                    const personaAvatar = await $1e082e4b7b205f21$var$getMediaImage($1e082e4b7b205f21$var$getSlideVisual(slides[idx]));
                    if (personaAvatar.media) slide.customContent.push({
                        role: "custom:personaAvatar",
                        type: "media",
                        data: personaAvatar.media
                    });
                }
                break;
        }
        if (section.toLowerCase().includes("introduction")) personas.forEach((personaIdx)=>{
            const persona = story.personas[personaIdx];
            if (slide.title.toLowerCase().includes(persona?.name?.toLowerCase())) slide.subtitle = persona?.role;
        });
        presentation.slides.push(slide);
    }
    const outroSlide = {
        archetype: "small_title",
        index: presentation.slides.length,
        title: ""
    };
    // const outroMedia = getMediaImage(
    //   ({ visualUrl, visualSeed, visualPrompt } =
    //     story.script[story.script.length - 1]),
    // );
    // if (outroMedia.media) {
    //   outroSlide.media = outroMedia.media;
    // }
    presentation.slides.push(outroSlide);
    presentation.state = "DONE";
    // Validate all image URLs in the presentation
    const allUrls = [];
    presentation.slides.forEach((slide, idx)=>{
        // Check direct media
        if (slide.media?.data?.url) allUrls.push({
            slide: idx,
            type: "media",
            url: slide.media.data.url
        });
        // Check customContent
        if (slide.customContent) slide.customContent.forEach((content, contentIdx)=>{
            if (content.type === "media" && content.data?.data?.url) allUrls.push({
                slide: idx,
                type: `customContent[${contentIdx}]`,
                url: content.data.data.url
            });
        });
        // Check content
        if (slide.content) slide.content.forEach((item, itemIdx)=>{
            if (item.media?.data?.url) allUrls.push({
                slide: idx,
                type: `content[${itemIdx}]`,
                url: item.media.data.url
            });
        });
    });
    console.log("=== Presentation Validation ===");
    console.log(`Total slides: ${presentation.slides.length}`);
    console.log(`Total image URLs: ${allUrls.length}`);
    allUrls.forEach(({ slide: slide, type: type, url: url })=>{
        console.log(`  Slide ${slide} (${type}): ${url.substring(0, 100)}...`);
    });
    console.log("=== End Validation ===");
    return presentation;
};
const $1e082e4b7b205f21$export$20192bcc5d40f1c3 = async (story)=>await $1e082e4b7b205f21$var$getSlides(story);



var $9lDhw = parcelRequire("9lDhw");

var $fmJ8d = parcelRequire("fmJ8d");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
var $7fc3a3cce38e3646$exports = {};
$7fc3a3cce38e3646$exports = JSON.parse("{\"03d15d0c-e7ae-4383-b942-bef5af32b9d2\":{\"has_axis\":[\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_bottom\",\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_left\",\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_right\",\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_top\"],\"is_a\":[\"shape\"]},\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"03d15d0c-e7ae-4383-b942-bef5af32b9d2_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"061bbcd0-e9c1-4988-a030-5f21b0570f76\":{\"has_axis\":[\"061bbcd0-e9c1-4988-a030-5f21b0570f76_bottom\",\"061bbcd0-e9c1-4988-a030-5f21b0570f76_left\",\"061bbcd0-e9c1-4988-a030-5f21b0570f76_right\",\"061bbcd0-e9c1-4988-a030-5f21b0570f76_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"061bbcd0-e9c1-4988-a030-5f21b0570f76_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom\"]},\"061bbcd0-e9c1-4988-a030-5f21b0570f76_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"061bbcd0-e9c1-4988-a030-5f21b0570f76_right\":{\"is_limited_by\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_right\"]},\"061bbcd0-e9c1-4988-a030-5f21b0570f76_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"062e6859-d511-484c-bac3-388fccb01635\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"062e6859-d511-484c-bac3-388fccb01635_bottom\",\"062e6859-d511-484c-bac3-388fccb01635_left\",\"062e6859-d511-484c-bac3-388fccb01635_right\",\"062e6859-d511-484c-bac3-388fccb01635_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"062e6859-d511-484c-bac3-388fccb01635_bottom\":{\"is_limited_by\":[\"731d57c9-7588-4ca3-a019-5618a436794a_bottom\"]},\"062e6859-d511-484c-bac3-388fccb01635_left\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_left\"]},\"062e6859-d511-484c-bac3-388fccb01635_right\":{\"is_limited_by\":[\"731d57c9-7588-4ca3-a019-5618a436794a_right\"]},\"062e6859-d511-484c-bac3-388fccb01635_top\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_top\"]},\"083c6f6a-5f37-419d-947f-5f1aa0daae01\":{\"has_axis\":[\"083c6f6a-5f37-419d-947f-5f1aa0daae01_bottom\",\"083c6f6a-5f37-419d-947f-5f1aa0daae01_left\",\"083c6f6a-5f37-419d-947f-5f1aa0daae01_right\",\"083c6f6a-5f37-419d-947f-5f1aa0daae01_top\",\"083c6f6a-5f37-419d-947f-5f1aa0daae01_top_offset_-32\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"083c6f6a-5f37-419d-947f-5f1aa0daae01_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"083c6f6a-5f37-419d-947f-5f1aa0daae01_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"083c6f6a-5f37-419d-947f-5f1aa0daae01_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"083c6f6a-5f37-419d-947f-5f1aa0daae01_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"0892589a-e09d-4d9b-bb9e-f48a76b0553d\":{\"has_axis\":[\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_bottom\",\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_left\",\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_right\",\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_top\"],\"is_a\":[\"image\"]},\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"0892589a-e09d-4d9b-bb9e-f48a76b0553d_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"08dc04fb-9b47-4756-a556-d64d3d807823\":{\"has_axis\":[\"08dc04fb-9b47-4756-a556-d64d3d807823_bottom\",\"08dc04fb-9b47-4756-a556-d64d3d807823_left\",\"08dc04fb-9b47-4756-a556-d64d3d807823_right\",\"08dc04fb-9b47-4756-a556-d64d3d807823_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"08dc04fb-9b47-4756-a556-d64d3d807823_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"08dc04fb-9b47-4756-a556-d64d3d807823_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"08dc04fb-9b47-4756-a556-d64d3d807823_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"08dc04fb-9b47-4756-a556-d64d3d807823_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"0a74fb54-1b31-46d6-a8b8-e13c292e8069\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_bottom\",\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_left\",\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_right\",\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_bottom\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom\"]},\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_left\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_right\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"0a74fb54-1b31-46d6-a8b8-e13c292e8069_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"0e3cc635-21ea-42f2-b03c-81d94dea1202\":{\"has_axis\":[\"0e3cc635-21ea-42f2-b03c-81d94dea1202_bottom\",\"0e3cc635-21ea-42f2-b03c-81d94dea1202_left\",\"0e3cc635-21ea-42f2-b03c-81d94dea1202_right\",\"0e3cc635-21ea-42f2-b03c-81d94dea1202_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"0e3cc635-21ea-42f2-b03c-81d94dea1202_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"0e3cc635-21ea-42f2-b03c-81d94dea1202_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"0e3cc635-21ea-42f2-b03c-81d94dea1202_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"0e3cc635-21ea-42f2-b03c-81d94dea1202_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"0e4730ae-e29b-4e31-9cde-682868356ae9\":{\"has_axis\":[\"0e4730ae-e29b-4e31-9cde-682868356ae9_bottom\",\"0e4730ae-e29b-4e31-9cde-682868356ae9_left\",\"0e4730ae-e29b-4e31-9cde-682868356ae9_right\",\"0e4730ae-e29b-4e31-9cde-682868356ae9_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"0e4730ae-e29b-4e31-9cde-682868356ae9_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"0e4730ae-e29b-4e31-9cde-682868356ae9_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"0e4730ae-e29b-4e31-9cde-682868356ae9_right\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"0e4730ae-e29b-4e31-9cde-682868356ae9_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db\":{\"has_axis\":[\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_bottom\",\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_left\",\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_right\",\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_top\"],\"has_role\":[\"custom:icon\"],\"is_a\":[\"image\"]},\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"10110498-84dd-4eac-a05f-1d6a6786cc39\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"10110498-84dd-4eac-a05f-1d6a6786cc39_bottom\",\"10110498-84dd-4eac-a05f-1d6a6786cc39_left\",\"10110498-84dd-4eac-a05f-1d6a6786cc39_right\",\"10110498-84dd-4eac-a05f-1d6a6786cc39_top\"],\"is_a\":[\"text\"]},\"10110498-84dd-4eac-a05f-1d6a6786cc39_bottom\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom\"]},\"10110498-84dd-4eac-a05f-1d6a6786cc39_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"10110498-84dd-4eac-a05f-1d6a6786cc39_right\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_right\"]},\"10110498-84dd-4eac-a05f-1d6a6786cc39_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"105a38cf-643c-4c9e-9eb7-9a266559c7b5\":{\"has_attribute\":[\"text_auto_height\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"1358493b-5dcd-4cce-8fa0-ff202683852d\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"1358493b-5dcd-4cce-8fa0-ff202683852d_bottom\",\"1358493b-5dcd-4cce-8fa0-ff202683852d_left\",\"1358493b-5dcd-4cce-8fa0-ff202683852d_right\",\"1358493b-5dcd-4cce-8fa0-ff202683852d_top\"],\"has_role\":[\"subtitle\"],\"is_a\":[\"text\"]},\"1358493b-5dcd-4cce-8fa0-ff202683852d_bottom\":{\"is_limited_by\":[\"9319ba0d-afcf-4507-84ad-0028651706d4_bottom_offset_-32\"]},\"1358493b-5dcd-4cce-8fa0-ff202683852d_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"1358493b-5dcd-4cce-8fa0-ff202683852d_right\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_right\"]},\"1358493b-5dcd-4cce-8fa0-ff202683852d_top\":{\"is_pinned_to\":[\"c403034c-0a73-49a8-9539-7e5352f740c5_bottom\"]},\"14ee8467-275d-47eb-8252-74dde64e8179\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"14ee8467-275d-47eb-8252-74dde64e8179_bottom\",\"14ee8467-275d-47eb-8252-74dde64e8179_left\",\"14ee8467-275d-47eb-8252-74dde64e8179_right\",\"14ee8467-275d-47eb-8252-74dde64e8179_top\"],\"has_role\":[\"subtitle\"],\"is_a\":[\"text\"]},\"14ee8467-275d-47eb-8252-74dde64e8179_bottom\":{\"is_limited_by\":[\"999ff148-dd0a-4654-96fb-ec416264c291_bottom_offset_-32\"]},\"14ee8467-275d-47eb-8252-74dde64e8179_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"14ee8467-275d-47eb-8252-74dde64e8179_right\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_right\"]},\"14ee8467-275d-47eb-8252-74dde64e8179_top\":{\"is_pinned_to\":[\"29c6b33a-e04d-444b-a462-d25e577832ff_bottom\"]},\"152bfeb9-aa0c-42cf-b639-d3f63556df80\":{\"has_axis\":[\"152bfeb9-aa0c-42cf-b639-d3f63556df80_bottom\",\"152bfeb9-aa0c-42cf-b639-d3f63556df80_left\",\"152bfeb9-aa0c-42cf-b639-d3f63556df80_right\",\"152bfeb9-aa0c-42cf-b639-d3f63556df80_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"152bfeb9-aa0c-42cf-b639-d3f63556df80_bottom\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"152bfeb9-aa0c-42cf-b639-d3f63556df80_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"152bfeb9-aa0c-42cf-b639-d3f63556df80_right\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"152bfeb9-aa0c-42cf-b639-d3f63556df80_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"16f01b56-5e50-4aba-8a4d-04202d4aa796\":{\"has_attribute\":[\"text_auto_width\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"18099207-fd29-41eb-b50c-266787682802\":{\"has_axis\":[\"18099207-fd29-41eb-b50c-266787682802_bottom\",\"18099207-fd29-41eb-b50c-266787682802_left\",\"18099207-fd29-41eb-b50c-266787682802_right\",\"18099207-fd29-41eb-b50c-266787682802_top\"],\"is_a\":[\"shape\"]},\"18099207-fd29-41eb-b50c-266787682802_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"18099207-fd29-41eb-b50c-266787682802_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"18099207-fd29-41eb-b50c-266787682802_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"18099207-fd29-41eb-b50c-266787682802_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"1b8e67c5-8972-4f37-bc8e-2431e93e627d\":{\"has_role\":[\"content\"],\"is_a\":[\"image\"]},\"1dc8a7d1-059f-4740-8ad8-5268f85ed647\":{\"has_axis\":[\"1dc8a7d1-059f-4740-8ad8-5268f85ed647_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"1f501127-fe01-4a44-afa6-4b53f5a40be4\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"1f501127-fe01-4a44-afa6-4b53f5a40be4_bottom\",\"1f501127-fe01-4a44-afa6-4b53f5a40be4_left\",\"1f501127-fe01-4a44-afa6-4b53f5a40be4_right\",\"1f501127-fe01-4a44-afa6-4b53f5a40be4_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"1f501127-fe01-4a44-afa6-4b53f5a40be4_bottom\":{\"is_limited_by\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom\"]},\"1f501127-fe01-4a44-afa6-4b53f5a40be4_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"1f501127-fe01-4a44-afa6-4b53f5a40be4_right\":{\"is_limited_by\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_right\"]},\"1f501127-fe01-4a44-afa6-4b53f5a40be4_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"2342c752-7b06-4b38-84a8-6adc01291aed\":{\"has_axis\":[\"2342c752-7b06-4b38-84a8-6adc01291aed_bottom\",\"2342c752-7b06-4b38-84a8-6adc01291aed_left\",\"2342c752-7b06-4b38-84a8-6adc01291aed_left_offset_-32\",\"2342c752-7b06-4b38-84a8-6adc01291aed_right\",\"2342c752-7b06-4b38-84a8-6adc01291aed_top\",\"2342c752-7b06-4b38-84a8-6adc01291aed_top_offset_-32\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"2342c752-7b06-4b38-84a8-6adc01291aed_bottom\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"2342c752-7b06-4b38-84a8-6adc01291aed_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"2342c752-7b06-4b38-84a8-6adc01291aed_right\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"2342c752-7b06-4b38-84a8-6adc01291aed_top\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"26c813bc-f7c7-46e4-9ad2-e002d07208d4\":{\"has_axis\":[\"26c813bc-f7c7-46e4-9ad2-e002d07208d4_left\",\"26c813bc-f7c7-46e4-9ad2-e002d07208d4_left_offset_-32\"],\"has_role\":[\"custom:personaAvatar\"],\"is_a\":[\"image\"]},\"29242deb-3150-4dad-b090-d928893bfd04\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"29242deb-3150-4dad-b090-d928893bfd04_bottom\",\"29242deb-3150-4dad-b090-d928893bfd04_left\",\"29242deb-3150-4dad-b090-d928893bfd04_right\",\"29242deb-3150-4dad-b090-d928893bfd04_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"29242deb-3150-4dad-b090-d928893bfd04_bottom\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom\"]},\"29242deb-3150-4dad-b090-d928893bfd04_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"29242deb-3150-4dad-b090-d928893bfd04_right\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_right\"]},\"29242deb-3150-4dad-b090-d928893bfd04_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"2931e5d2-ce81-42e9-a4ad-66ddf0f449e6\":{\"is_a\":[\"image\"]},\"29c6b33a-e04d-444b-a462-d25e577832ff\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"29c6b33a-e04d-444b-a462-d25e577832ff_bottom\",\"29c6b33a-e04d-444b-a462-d25e577832ff_left\",\"29c6b33a-e04d-444b-a462-d25e577832ff_right\",\"29c6b33a-e04d-444b-a462-d25e577832ff_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"29c6b33a-e04d-444b-a462-d25e577832ff_bottom\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom\"]},\"29c6b33a-e04d-444b-a462-d25e577832ff_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"29c6b33a-e04d-444b-a462-d25e577832ff_right\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_right\"]},\"29c6b33a-e04d-444b-a462-d25e577832ff_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"2c989e52-7716-43e9-85d9-d08dcd08cb43\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"2c989e52-7716-43e9-85d9-d08dcd08cb43_bottom\",\"2c989e52-7716-43e9-85d9-d08dcd08cb43_left\",\"2c989e52-7716-43e9-85d9-d08dcd08cb43_right\",\"2c989e52-7716-43e9-85d9-d08dcd08cb43_top\"],\"has_role\":[\"custom:chapter\"],\"is_a\":[\"text\"]},\"2c989e52-7716-43e9-85d9-d08dcd08cb43_bottom\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom\"]},\"2c989e52-7716-43e9-85d9-d08dcd08cb43_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"2c989e52-7716-43e9-85d9-d08dcd08cb43_right\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_right\"]},\"2c989e52-7716-43e9-85d9-d08dcd08cb43_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"315f7ad5-00c2-4fbb-8239-836b86a53ecc\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_bottom\",\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_left\",\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_right\",\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_bottom\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom\"]},\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_right\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_right\"]},\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"32fd34ec-3db9-4c63-98c8-f6edeb97505b\":{\"contains\":[\"9b0f28ba-748a-4112-84e4-65335022c8de\"],\"has_axis\":[\"32fd34ec-3db9-4c63-98c8-f6edeb97505b_left\",\"32fd34ec-3db9-4c63-98c8-f6edeb97505b_top\"],\"has_role\":[\"small_title\"],\"is_a\":[\"slide\"]},\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa\":{\"has_axis\":[\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_bottom\",\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_left\",\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_right\",\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_bottom\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_right\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_top\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"3373f59d-272e-4d2d-b6b4-b86b27f6d449\":{\"has_axis\":[\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_bottom\",\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_left\",\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_right\",\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_bottom\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_right\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"3373f59d-272e-4d2d-b6b4-b86b27f6d449_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"33c28ef4-17fa-401b-ade1-a998647c587c\":{\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"3a6eb667-0bd1-462a-a3ff-63fadc096926\":{\"has_axis\":[\"3a6eb667-0bd1-462a-a3ff-63fadc096926_bottom\",\"3a6eb667-0bd1-462a-a3ff-63fadc096926_left\",\"3a6eb667-0bd1-462a-a3ff-63fadc096926_right\",\"3a6eb667-0bd1-462a-a3ff-63fadc096926_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"3a6eb667-0bd1-462a-a3ff-63fadc096926_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"3a6eb667-0bd1-462a-a3ff-63fadc096926_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"3a6eb667-0bd1-462a-a3ff-63fadc096926_right\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"3a6eb667-0bd1-462a-a3ff-63fadc096926_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"3c566718-4899-439f-bac4-3c58a81f1aa7\":{\"contains\":[\"1358493b-5dcd-4cce-8fa0-ff202683852d\",\"3373f59d-272e-4d2d-b6b4-b86b27f6d449\",\"3e4fbb51-a64a-41dd-b901-73178209d106\",\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac\",\"655813bf-5c37-4f16-a058-11e76e0ce701\",\"66253b03-f652-4093-bef9-8cdf7eb130fd\",\"9319ba0d-afcf-4507-84ad-0028651706d4\",\"c403034c-0a73-49a8-9539-7e5352f740c5\"],\"has_axis\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_bottom\",\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\",\"3c566718-4899-439f-bac4-3c58a81f1aa7_right\",\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"],\"has_role\":[\"small_title\"],\"is_a\":[\"slide\"]},\"3c81a404-ffbb-40ff-8a55-2d1a6a7de35d\":{\"has_attribute\":[\"text_auto_height\"],\"has_role\":[\"custom:personaRole\"],\"is_a\":[\"text\"]},\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4\":{\"has_axis\":[\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_bottom\",\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_left\",\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_right\",\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_bottom\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_right\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"3e4fbb51-a64a-41dd-b901-73178209d106\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"3e4fbb51-a64a-41dd-b901-73178209d106_bottom\",\"3e4fbb51-a64a-41dd-b901-73178209d106_left\",\"3e4fbb51-a64a-41dd-b901-73178209d106_right\",\"3e4fbb51-a64a-41dd-b901-73178209d106_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"3e4fbb51-a64a-41dd-b901-73178209d106_bottom\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_bottom\"]},\"3e4fbb51-a64a-41dd-b901-73178209d106_left\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"3e4fbb51-a64a-41dd-b901-73178209d106_right\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"3e4fbb51-a64a-41dd-b901-73178209d106_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"3eeacefe-1c84-4637-b4a5-d988c4411b34\":{\"has_axis\":[\"3eeacefe-1c84-4637-b4a5-d988c4411b34_bottom\",\"3eeacefe-1c84-4637-b4a5-d988c4411b34_left\",\"3eeacefe-1c84-4637-b4a5-d988c4411b34_right\",\"3eeacefe-1c84-4637-b4a5-d988c4411b34_top\"],\"is_a\":[\"image\"]},\"3eeacefe-1c84-4637-b4a5-d988c4411b34_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"3eeacefe-1c84-4637-b4a5-d988c4411b34_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"3eeacefe-1c84-4637-b4a5-d988c4411b34_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"3eeacefe-1c84-4637-b4a5-d988c4411b34_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"40802aad-299d-45e9-8c97-099453c995f8\":{\"has_axis\":[\"40802aad-299d-45e9-8c97-099453c995f8_bottom\",\"40802aad-299d-45e9-8c97-099453c995f8_left\",\"40802aad-299d-45e9-8c97-099453c995f8_right\",\"40802aad-299d-45e9-8c97-099453c995f8_top\"],\"is_a\":[\"shape\"]},\"40802aad-299d-45e9-8c97-099453c995f8_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"40802aad-299d-45e9-8c97-099453c995f8_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"40802aad-299d-45e9-8c97-099453c995f8_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"40802aad-299d-45e9-8c97-099453c995f8_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"419fda32-2472-49ec-80a7-8bdd6b504d70\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"419fda32-2472-49ec-80a7-8bdd6b504d70_bottom\",\"419fda32-2472-49ec-80a7-8bdd6b504d70_left\",\"419fda32-2472-49ec-80a7-8bdd6b504d70_right\",\"419fda32-2472-49ec-80a7-8bdd6b504d70_top\"],\"is_a\":[\"text\"]},\"419fda32-2472-49ec-80a7-8bdd6b504d70_bottom\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_bottom\"]},\"419fda32-2472-49ec-80a7-8bdd6b504d70_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"419fda32-2472-49ec-80a7-8bdd6b504d70_right\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_right\"]},\"419fda32-2472-49ec-80a7-8bdd6b504d70_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"41ab1c7e-f28c-4e16-9962-c5cad2635096\":{\"has_axis\":[\"41ab1c7e-f28c-4e16-9962-c5cad2635096_bottom\",\"41ab1c7e-f28c-4e16-9962-c5cad2635096_left\",\"41ab1c7e-f28c-4e16-9962-c5cad2635096_right\",\"41ab1c7e-f28c-4e16-9962-c5cad2635096_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"41ab1c7e-f28c-4e16-9962-c5cad2635096_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"41ab1c7e-f28c-4e16-9962-c5cad2635096_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"41ab1c7e-f28c-4e16-9962-c5cad2635096_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"41ab1c7e-f28c-4e16-9962-c5cad2635096_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0\":{\"has_axis\":[\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_bottom\",\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_left\",\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_right\",\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0\":{\"has_axis\":[\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_bottom\",\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_left\",\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_right\",\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_top\"],\"has_role\":[\"custom:visual\"],\"is_a\":[\"image\"]},\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_bottom\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_right\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"47560dac-0bcf-45bc-8470-d46d2faa5df7\":{\"has_axis\":[\"47560dac-0bcf-45bc-8470-d46d2faa5df7_bottom\",\"47560dac-0bcf-45bc-8470-d46d2faa5df7_left\",\"47560dac-0bcf-45bc-8470-d46d2faa5df7_right\",\"47560dac-0bcf-45bc-8470-d46d2faa5df7_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"47560dac-0bcf-45bc-8470-d46d2faa5df7_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"47560dac-0bcf-45bc-8470-d46d2faa5df7_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"47560dac-0bcf-45bc-8470-d46d2faa5df7_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"47560dac-0bcf-45bc-8470-d46d2faa5df7_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"48f59b8a-ad78-4fbc-add6-9cb6a922c231\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"4b7caf30-116b-4384-9028-d352fefc571d\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"4f18efff-7c4e-4636-8d01-032d5e4c7a73\":{\"has_axis\":[\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_bottom\",\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_left\",\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_right\",\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_bottom\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_right\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"4f18efff-7c4e-4636-8d01-032d5e4c7a73_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"506097e9-1862-4658-95e7-a9ce78273fca\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"510134a1-8d81-4e98-8d68-0f5290eea590\":{\"is_a\":[\"image\"]},\"53a5017d-0be5-4de5-a423-60e89dd51e14\":{\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"56239588-5483-4761-87b9-ded11fcdaa64\":{\"has_axis\":[\"56239588-5483-4761-87b9-ded11fcdaa64_bottom\",\"56239588-5483-4761-87b9-ded11fcdaa64_left\",\"56239588-5483-4761-87b9-ded11fcdaa64_right\",\"56239588-5483-4761-87b9-ded11fcdaa64_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"56239588-5483-4761-87b9-ded11fcdaa64_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"56239588-5483-4761-87b9-ded11fcdaa64_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"56239588-5483-4761-87b9-ded11fcdaa64_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"56239588-5483-4761-87b9-ded11fcdaa64_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"58d1cbba-5637-48a1-b003-c6c585a07cfe\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"58d1cbba-5637-48a1-b003-c6c585a07cfe_bottom\",\"58d1cbba-5637-48a1-b003-c6c585a07cfe_left\",\"58d1cbba-5637-48a1-b003-c6c585a07cfe_right\",\"58d1cbba-5637-48a1-b003-c6c585a07cfe_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"58d1cbba-5637-48a1-b003-c6c585a07cfe_bottom\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom\"]},\"58d1cbba-5637-48a1-b003-c6c585a07cfe_left\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"58d1cbba-5637-48a1-b003-c6c585a07cfe_right\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"58d1cbba-5637-48a1-b003-c6c585a07cfe_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"5c1877e5-848b-427d-8bea-ebb92fd92b6a\":{\"has_axis\":[\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_bottom\",\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_left\",\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_right\",\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"5c1877e5-848b-427d-8bea-ebb92fd92b6a_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac\":{\"has_axis\":[\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_bottom\",\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_left\",\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_right\",\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_bottom\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_right\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"5d8ee7c5-a782-45fc-bd27-6deb01c3adac_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_bottom\",\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_left\",\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_right\",\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_bottom\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom\"]},\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_left\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"5f52d182-db39-48d5-9ea0-24d231fad72b\":{\"has_axis\":[\"5f52d182-db39-48d5-9ea0-24d231fad72b_bottom\",\"5f52d182-db39-48d5-9ea0-24d231fad72b_left\",\"5f52d182-db39-48d5-9ea0-24d231fad72b_right\",\"5f52d182-db39-48d5-9ea0-24d231fad72b_top\"],\"has_role\":[\"custom:visual\"],\"is_a\":[\"image\"]},\"5f52d182-db39-48d5-9ea0-24d231fad72b_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"5f52d182-db39-48d5-9ea0-24d231fad72b_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"5f52d182-db39-48d5-9ea0-24d231fad72b_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"5f52d182-db39-48d5-9ea0-24d231fad72b_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"5feed6ff-1382-46bc-ae1f-713609ac0045\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"5feed6ff-1382-46bc-ae1f-713609ac0045_bottom\",\"5feed6ff-1382-46bc-ae1f-713609ac0045_left\",\"5feed6ff-1382-46bc-ae1f-713609ac0045_right\",\"5feed6ff-1382-46bc-ae1f-713609ac0045_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"5feed6ff-1382-46bc-ae1f-713609ac0045_bottom\":{\"is_limited_by\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_bottom\"]},\"5feed6ff-1382-46bc-ae1f-713609ac0045_left\":{\"is_limited_by\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"5feed6ff-1382-46bc-ae1f-713609ac0045_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"5feed6ff-1382-46bc-ae1f-713609ac0045_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"60389d63-842f-48e8-9536-ce2404aaf2bf\":{\"has_axis\":[\"60389d63-842f-48e8-9536-ce2404aaf2bf_bottom\",\"60389d63-842f-48e8-9536-ce2404aaf2bf_left\",\"60389d63-842f-48e8-9536-ce2404aaf2bf_left_offset_-32\",\"60389d63-842f-48e8-9536-ce2404aaf2bf_right\",\"60389d63-842f-48e8-9536-ce2404aaf2bf_top\"],\"has_role\":[\"content\"],\"is_a\":[\"image\"]},\"60389d63-842f-48e8-9536-ce2404aaf2bf_bottom\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_bottom\"]},\"60389d63-842f-48e8-9536-ce2404aaf2bf_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"60389d63-842f-48e8-9536-ce2404aaf2bf_right\":{\"is_limited_by\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_right\"]},\"60389d63-842f-48e8-9536-ce2404aaf2bf_top\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"62b07357-43e1-4fbc-968c-6f6b6eead503\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"62b07357-43e1-4fbc-968c-6f6b6eead503_bottom\",\"62b07357-43e1-4fbc-968c-6f6b6eead503_left\",\"62b07357-43e1-4fbc-968c-6f6b6eead503_right\",\"62b07357-43e1-4fbc-968c-6f6b6eead503_top\"],\"has_role\":[\"subtitle\"],\"is_a\":[\"text\"]},\"62b07357-43e1-4fbc-968c-6f6b6eead503_bottom\":{\"is_limited_by\":[\"cbf21645-b078-4812-b755-d8ecae9ef204_top\"]},\"62b07357-43e1-4fbc-968c-6f6b6eead503_left\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_left\"]},\"62b07357-43e1-4fbc-968c-6f6b6eead503_right\":{\"is_limited_by\":[\"731d57c9-7588-4ca3-a019-5618a436794a_right\"]},\"62b07357-43e1-4fbc-968c-6f6b6eead503_top\":{\"is_pinned_to\":[\"062e6859-d511-484c-bac3-388fccb01635_bottom\"]},\"640f3598-52e6-4d5d-929e-1357754b5b2a\":{\"has_attribute\":[\"text_auto_width\"],\"has_axis\":[\"640f3598-52e6-4d5d-929e-1357754b5b2a_bottom\",\"640f3598-52e6-4d5d-929e-1357754b5b2a_left\",\"640f3598-52e6-4d5d-929e-1357754b5b2a_right\",\"640f3598-52e6-4d5d-929e-1357754b5b2a_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"640f3598-52e6-4d5d-929e-1357754b5b2a_bottom\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_bottom\"]},\"640f3598-52e6-4d5d-929e-1357754b5b2a_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"640f3598-52e6-4d5d-929e-1357754b5b2a_right\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_right\"]},\"640f3598-52e6-4d5d-929e-1357754b5b2a_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"6413dc3d-e450-4649-9bc9-5b590d6ddd06\":{\"has_axis\":[\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_bottom\",\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_left\",\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_right\",\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_right\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"6413dc3d-e450-4649-9bc9-5b590d6ddd06_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"64358dd5-ae6a-4b59-9d2d-1b051def1d82\":{\"contains\":[\"083c6f6a-5f37-419d-947f-5f1aa0daae01\",\"08dc04fb-9b47-4756-a556-d64d3d807823\",\"29242deb-3150-4dad-b090-d928893bfd04\",\"315f7ad5-00c2-4fbb-8239-836b86a53ecc\",\"41ab1c7e-f28c-4e16-9962-c5cad2635096\",\"47560dac-0bcf-45bc-8470-d46d2faa5df7\",\"56239588-5483-4761-87b9-ded11fcdaa64\",\"5c1877e5-848b-427d-8bea-ebb92fd92b6a\",\"5e3c15a9-7c6a-4eec-b894-d095d1e9dd11\",\"6a235815-2168-4ec8-8fba-3110962fdd16\",\"79ec29c4-a287-49aa-8ac4-eae4d134da1d\",\"ba4fd689-f519-411d-9f85-e7f440e22ec4\",\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb\",\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9\",\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321\"],\"has_axis\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom\",\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\",\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_right\",\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"],\"has_role\":[\"content\"],\"is_a\":[\"slide\"]},\"655813bf-5c37-4f16-a058-11e76e0ce701\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"655813bf-5c37-4f16-a058-11e76e0ce701_bottom\",\"655813bf-5c37-4f16-a058-11e76e0ce701_left\",\"655813bf-5c37-4f16-a058-11e76e0ce701_right\",\"655813bf-5c37-4f16-a058-11e76e0ce701_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"655813bf-5c37-4f16-a058-11e76e0ce701_bottom\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_bottom\"]},\"655813bf-5c37-4f16-a058-11e76e0ce701_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"655813bf-5c37-4f16-a058-11e76e0ce701_right\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_right\"]},\"655813bf-5c37-4f16-a058-11e76e0ce701_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"65712f61-cfc5-4c4e-9563-b6ab2eab5902\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_bottom\",\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_left\",\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_right\",\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_top\"],\"is_a\":[\"text\"]},\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_bottom\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom\"]},\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_right\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_right\"]},\"65712f61-cfc5-4c4e-9563-b6ab2eab5902_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"66253b03-f652-4093-bef9-8cdf7eb130fd\":{\"has_axis\":[\"66253b03-f652-4093-bef9-8cdf7eb130fd_bottom\",\"66253b03-f652-4093-bef9-8cdf7eb130fd_left\",\"66253b03-f652-4093-bef9-8cdf7eb130fd_right\",\"66253b03-f652-4093-bef9-8cdf7eb130fd_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"66253b03-f652-4093-bef9-8cdf7eb130fd_bottom\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"66253b03-f652-4093-bef9-8cdf7eb130fd_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"66253b03-f652-4093-bef9-8cdf7eb130fd_right\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"66253b03-f652-4093-bef9-8cdf7eb130fd_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"676d177d-0f68-4da3-9fff-575c0ca96cef\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"676d177d-0f68-4da3-9fff-575c0ca96cef_bottom\",\"676d177d-0f68-4da3-9fff-575c0ca96cef_left\",\"676d177d-0f68-4da3-9fff-575c0ca96cef_right\",\"676d177d-0f68-4da3-9fff-575c0ca96cef_top\"],\"has_role\":[\"content\"],\"is_a\":[\"text\"]},\"676d177d-0f68-4da3-9fff-575c0ca96cef_bottom\":{\"is_limited_by\":[\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_top\"]},\"676d177d-0f68-4da3-9fff-575c0ca96cef_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"676d177d-0f68-4da3-9fff-575c0ca96cef_right\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_right\"]},\"676d177d-0f68-4da3-9fff-575c0ca96cef_top\":{\"is_pinned_to\":[\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_bottom\"]},\"6929c343-70aa-4324-b590-5bfafd176df0\":{\"has_axis\":[\"6929c343-70aa-4324-b590-5bfafd176df0_bottom\",\"6929c343-70aa-4324-b590-5bfafd176df0_left\",\"6929c343-70aa-4324-b590-5bfafd176df0_right\",\"6929c343-70aa-4324-b590-5bfafd176df0_top\"],\"is_a\":[\"shape\"]},\"6929c343-70aa-4324-b590-5bfafd176df0_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"6929c343-70aa-4324-b590-5bfafd176df0_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"6929c343-70aa-4324-b590-5bfafd176df0_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"6929c343-70aa-4324-b590-5bfafd176df0_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"69b7a4e4-a179-46e0-8576-8a861a67e156\":{\"has_axis\":[\"69b7a4e4-a179-46e0-8576-8a861a67e156_bottom\",\"69b7a4e4-a179-46e0-8576-8a861a67e156_left\",\"69b7a4e4-a179-46e0-8576-8a861a67e156_right\",\"69b7a4e4-a179-46e0-8576-8a861a67e156_top\"],\"is_a\":[\"shape\"]},\"69b7a4e4-a179-46e0-8576-8a861a67e156_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"69b7a4e4-a179-46e0-8576-8a861a67e156_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"69b7a4e4-a179-46e0-8576-8a861a67e156_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"69b7a4e4-a179-46e0-8576-8a861a67e156_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"6a235815-2168-4ec8-8fba-3110962fdd16\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"6a235815-2168-4ec8-8fba-3110962fdd16_bottom\",\"6a235815-2168-4ec8-8fba-3110962fdd16_left\",\"6a235815-2168-4ec8-8fba-3110962fdd16_right\",\"6a235815-2168-4ec8-8fba-3110962fdd16_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"6a235815-2168-4ec8-8fba-3110962fdd16_bottom\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom\"]},\"6a235815-2168-4ec8-8fba-3110962fdd16_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"6a235815-2168-4ec8-8fba-3110962fdd16_right\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_right\"]},\"6a235815-2168-4ec8-8fba-3110962fdd16_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"6a2513b9-c09b-484e-896f-398b1a5e8a36\":{\"is_a\":[\"image\"]},\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e\":{\"contains\":[\"2342c752-7b06-4b38-84a8-6adc01291aed\",\"331aa7bd-4787-4ca1-9e7d-3e6eff3100fa\",\"33c28ef4-17fa-401b-ade1-a998647c587c\",\"53a5017d-0be5-4de5-a423-60e89dd51e14\",\"60389d63-842f-48e8-9536-ce2404aaf2bf\",\"8c253f46-2c3c-4db4-8860-8a02f9ccfde7\",\"98743a8c-2f78-488b-b954-f09081e57d2a\",\"a2d3b917-7f07-46f1-991c-97273ee3275c\",\"ab0eb597-2dcd-4869-b761-f22f2e514dd4\",\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469\",\"fccda08f-b71b-4661-bdbd-157f12aca817\"],\"has_axis\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_bottom\",\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\",\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_right\",\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"],\"has_role\":[\"content\"],\"is_a\":[\"slide\"]},\"6d8d7dd5-b88c-4f34-ab46-b28fc765d86d\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"6ddf3890-7cba-4470-bb02-2321ac7f7a77\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_bottom\",\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_left\",\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_right\",\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_bottom\":{\"is_limited_by\":[\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_top_offset_-32\"]},\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_right\":{\"is_limited_by\":[\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_left_offset_-32\"]},\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"716445cb-1a99-4546-a262-990ce93f5b14\":{\"is_a\":[\"image\"]},\"731d57c9-7588-4ca3-a019-5618a436794a\":{\"contains\":[\"062e6859-d511-484c-bac3-388fccb01635\",\"62b07357-43e1-4fbc-968c-6f6b6eead503\",\"8c715784-9caa-4cac-9273-9260ed88a96f\",\"cbf21645-b078-4812-b755-d8ecae9ef204\"],\"has_axis\":[\"731d57c9-7588-4ca3-a019-5618a436794a_bottom\",\"731d57c9-7588-4ca3-a019-5618a436794a_left\",\"731d57c9-7588-4ca3-a019-5618a436794a_right\",\"731d57c9-7588-4ca3-a019-5618a436794a_top\"],\"has_role\":[\"cover\"],\"has_theme\":[\"e216c9a2-fb09-4e7e-9e84-c2b37c715cdf\"],\"is_a\":[\"slide\"]},\"7525a5d2-c947-401d-a8e1-48c943f17cfc\":{\"has_axis\":[\"7525a5d2-c947-401d-a8e1-48c943f17cfc_bottom\",\"7525a5d2-c947-401d-a8e1-48c943f17cfc_left\",\"7525a5d2-c947-401d-a8e1-48c943f17cfc_right\",\"7525a5d2-c947-401d-a8e1-48c943f17cfc_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"7525a5d2-c947-401d-a8e1-48c943f17cfc_bottom\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"7525a5d2-c947-401d-a8e1-48c943f17cfc_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"7525a5d2-c947-401d-a8e1-48c943f17cfc_right\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"7525a5d2-c947-401d-a8e1-48c943f17cfc_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"7681e420-6306-46ca-beb7-01e412b24005\":{\"has_axis\":[\"7681e420-6306-46ca-beb7-01e412b24005_bottom\",\"7681e420-6306-46ca-beb7-01e412b24005_left\",\"7681e420-6306-46ca-beb7-01e412b24005_right\",\"7681e420-6306-46ca-beb7-01e412b24005_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"7681e420-6306-46ca-beb7-01e412b24005_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"7681e420-6306-46ca-beb7-01e412b24005_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"7681e420-6306-46ca-beb7-01e412b24005_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"7681e420-6306-46ca-beb7-01e412b24005_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"78d0caee-a319-44ee-8e7c-c15bac97cfac\":{\"has_axis\":[\"78d0caee-a319-44ee-8e7c-c15bac97cfac_bottom\",\"78d0caee-a319-44ee-8e7c-c15bac97cfac_left\",\"78d0caee-a319-44ee-8e7c-c15bac97cfac_right\",\"78d0caee-a319-44ee-8e7c-c15bac97cfac_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"78d0caee-a319-44ee-8e7c-c15bac97cfac_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom\"]},\"78d0caee-a319-44ee-8e7c-c15bac97cfac_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"78d0caee-a319-44ee-8e7c-c15bac97cfac_right\":{\"is_limited_by\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_right\"]},\"78d0caee-a319-44ee-8e7c-c15bac97cfac_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"797017cb-2846-4bb7-b45a-ad16dc72fe4e\":{\"has_axis\":[\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_bottom\",\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_left\",\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_right\",\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_top\"],\"is_a\":[\"shape\"]},\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_bottom\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"]},\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_left\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\"]},\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_right\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\"]},\"797017cb-2846-4bb7-b45a-ad16dc72fe4e_top\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"]},\"79ec29c4-a287-49aa-8ac4-eae4d134da1d\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_bottom\",\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_left\",\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_right\",\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_bottom\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom\"]},\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_right\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_right\"]},\"79ec29c4-a287-49aa-8ac4-eae4d134da1d_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"7b210f71-5928-466e-aa4d-02ae284e2989\":{\"has_axis\":[\"7b210f71-5928-466e-aa4d-02ae284e2989_bottom\",\"7b210f71-5928-466e-aa4d-02ae284e2989_left\",\"7b210f71-5928-466e-aa4d-02ae284e2989_right\",\"7b210f71-5928-466e-aa4d-02ae284e2989_top\"],\"is_a\":[\"shape\"]},\"7b210f71-5928-466e-aa4d-02ae284e2989_bottom\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"]},\"7b210f71-5928-466e-aa4d-02ae284e2989_left\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\"]},\"7b210f71-5928-466e-aa4d-02ae284e2989_right\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\"]},\"7b210f71-5928-466e-aa4d-02ae284e2989_top\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"]},\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_bottom\",\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_left\",\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_right\",\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_bottom\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_bottom\"]},\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_right\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_right\"]},\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"7c4b5d08-8553-45f3-9c92-ac37aa897690\":{\"has_axis\":[\"7c4b5d08-8553-45f3-9c92-ac37aa897690_bottom\",\"7c4b5d08-8553-45f3-9c92-ac37aa897690_left\",\"7c4b5d08-8553-45f3-9c92-ac37aa897690_right\",\"7c4b5d08-8553-45f3-9c92-ac37aa897690_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"7c4b5d08-8553-45f3-9c92-ac37aa897690_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"7c4b5d08-8553-45f3-9c92-ac37aa897690_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"7c4b5d08-8553-45f3-9c92-ac37aa897690_right\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"7c4b5d08-8553-45f3-9c92-ac37aa897690_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"7e257dc0-6bf2-425b-9156-290223f6981f\":{\"has_axis\":[\"7e257dc0-6bf2-425b-9156-290223f6981f_bottom\",\"7e257dc0-6bf2-425b-9156-290223f6981f_left\",\"7e257dc0-6bf2-425b-9156-290223f6981f_right\",\"7e257dc0-6bf2-425b-9156-290223f6981f_top\"],\"has_role\":[\"custom:logo\"],\"is_a\":[\"image\"]},\"7e257dc0-6bf2-425b-9156-290223f6981f_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"7e257dc0-6bf2-425b-9156-290223f6981f_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"7e257dc0-6bf2-425b-9156-290223f6981f_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"7e257dc0-6bf2-425b-9156-290223f6981f_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"825eca02-f797-4734-8db9-23a087f2ed2e\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"85f25280-8989-4be3-b16c-6e9d22d9b6c1\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_bottom\",\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_left\",\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_right\",\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_top\"],\"is_a\":[\"text\"]},\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_bottom\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_bottom\"]},\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_right\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_right\"]},\"85f25280-8989-4be3-b16c-6e9d22d9b6c1_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"8a56399c-4fc2-4e72-a798-bd90aeb417c9\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_bottom\",\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_left\",\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_right\",\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_top\"],\"is_a\":[\"text\"]},\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_bottom\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom\"]},\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_right\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_right\"]},\"8a56399c-4fc2-4e72-a798-bd90aeb417c9_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"8b29d36e-1120-43cc-9781-0354be720c2b\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"8b77414d-a542-4222-acb0-a1b90d184d69\":{\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"8c253f46-2c3c-4db4-8860-8a02f9ccfde7\":{\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"8c715784-9caa-4cac-9273-9260ed88a96f\":{\"has_axis\":[\"8c715784-9caa-4cac-9273-9260ed88a96f_bottom\",\"8c715784-9caa-4cac-9273-9260ed88a96f_left\",\"8c715784-9caa-4cac-9273-9260ed88a96f_right\",\"8c715784-9caa-4cac-9273-9260ed88a96f_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"8c715784-9caa-4cac-9273-9260ed88a96f_bottom\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_top\"]},\"8c715784-9caa-4cac-9273-9260ed88a96f_left\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_left\"]},\"8c715784-9caa-4cac-9273-9260ed88a96f_right\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_left\"]},\"8c715784-9caa-4cac-9273-9260ed88a96f_top\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_top\"]},\"8ca27b0f-d10e-4d35-912b-969e99e37aec\":{\"contains\":[\"0a74fb54-1b31-46d6-a8b8-e13c292e8069\",\"14ee8467-275d-47eb-8252-74dde64e8179\",\"29c6b33a-e04d-444b-a462-d25e577832ff\",\"999ff148-dd0a-4654-96fb-ec416264c291\",\"9fcc2418-7096-4121-afdc-9200591e4b47\",\"b2721d84-2f2f-4d25-b8fa-92d013ef113a\",\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2\",\"deddf272-f102-4a15-851b-57b446f88245\",\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08\"],\"has_axis\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom\",\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\",\"8ca27b0f-d10e-4d35-912b-969e99e37aec_right\",\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"],\"has_role\":[\"small_title\"],\"is_a\":[\"slide\"]},\"8ee09d28-eea9-4088-a564-03a5a46f2f20\":{\"has_axis\":[\"8ee09d28-eea9-4088-a564-03a5a46f2f20_bottom\",\"8ee09d28-eea9-4088-a564-03a5a46f2f20_left\",\"8ee09d28-eea9-4088-a564-03a5a46f2f20_right\",\"8ee09d28-eea9-4088-a564-03a5a46f2f20_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"8ee09d28-eea9-4088-a564-03a5a46f2f20_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"8ee09d28-eea9-4088-a564-03a5a46f2f20_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"8ee09d28-eea9-4088-a564-03a5a46f2f20_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"8ee09d28-eea9-4088-a564-03a5a46f2f20_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"9319ba0d-afcf-4507-84ad-0028651706d4\":{\"has_axis\":[\"9319ba0d-afcf-4507-84ad-0028651706d4_bottom\",\"9319ba0d-afcf-4507-84ad-0028651706d4_bottom_offset_-32\",\"9319ba0d-afcf-4507-84ad-0028651706d4_left\",\"9319ba0d-afcf-4507-84ad-0028651706d4_right\",\"9319ba0d-afcf-4507-84ad-0028651706d4_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"9319ba0d-afcf-4507-84ad-0028651706d4_bottom\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"9319ba0d-afcf-4507-84ad-0028651706d4_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"9319ba0d-afcf-4507-84ad-0028651706d4_right\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"9319ba0d-afcf-4507-84ad-0028651706d4_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"965ef0ae-a185-4971-9193-c5ee4046085f\":{\"is_a\":[\"image\"]},\"98743a8c-2f78-488b-b954-f09081e57d2a\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"98743a8c-2f78-488b-b954-f09081e57d2a_bottom\",\"98743a8c-2f78-488b-b954-f09081e57d2a_left\",\"98743a8c-2f78-488b-b954-f09081e57d2a_right\",\"98743a8c-2f78-488b-b954-f09081e57d2a_top\"],\"has_role\":[\"content\"],\"is_a\":[\"text\"]},\"98743a8c-2f78-488b-b954-f09081e57d2a_bottom\":{\"is_limited_by\":[\"2342c752-7b06-4b38-84a8-6adc01291aed_top\"]},\"98743a8c-2f78-488b-b954-f09081e57d2a_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"98743a8c-2f78-488b-b954-f09081e57d2a_right\":{\"is_limited_by\":[\"2342c752-7b06-4b38-84a8-6adc01291aed_left_offset_-32\"]},\"98743a8c-2f78-488b-b954-f09081e57d2a_top\":{\"is_pinned_to\":[\"a2d3b917-7f07-46f1-991c-97273ee3275c_bottom\"]},\"999ff148-dd0a-4654-96fb-ec416264c291\":{\"has_axis\":[\"999ff148-dd0a-4654-96fb-ec416264c291_bottom\",\"999ff148-dd0a-4654-96fb-ec416264c291_bottom_offset_-32\",\"999ff148-dd0a-4654-96fb-ec416264c291_left\",\"999ff148-dd0a-4654-96fb-ec416264c291_right\",\"999ff148-dd0a-4654-96fb-ec416264c291_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"999ff148-dd0a-4654-96fb-ec416264c291_bottom\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"999ff148-dd0a-4654-96fb-ec416264c291_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"999ff148-dd0a-4654-96fb-ec416264c291_right\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"999ff148-dd0a-4654-96fb-ec416264c291_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"9b0f28ba-748a-4112-84e4-65335022c8de\":{\"has_axis\":[\"9b0f28ba-748a-4112-84e4-65335022c8de_bottom\",\"9b0f28ba-748a-4112-84e4-65335022c8de_left\",\"9b0f28ba-748a-4112-84e4-65335022c8de_right\",\"9b0f28ba-748a-4112-84e4-65335022c8de_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"9b0f28ba-748a-4112-84e4-65335022c8de_bottom\":{\"is_pinned_to\":[\"32fd34ec-3db9-4c63-98c8-f6edeb97505b_top\"]},\"9b0f28ba-748a-4112-84e4-65335022c8de_left\":{\"is_pinned_to\":[\"32fd34ec-3db9-4c63-98c8-f6edeb97505b_left\"]},\"9b0f28ba-748a-4112-84e4-65335022c8de_right\":{\"is_pinned_to\":[\"32fd34ec-3db9-4c63-98c8-f6edeb97505b_left\"]},\"9b0f28ba-748a-4112-84e4-65335022c8de_top\":{\"is_pinned_to\":[\"32fd34ec-3db9-4c63-98c8-f6edeb97505b_top\"]},\"9b62394d-e882-4b32-8673-9a6663063d0f\":{\"contains\":[\"4574aea6-3b0d-4e30-aa06-fdcb420a34d0\",\"640f3598-52e6-4d5d-929e-1357754b5b2a\",\"676d177d-0f68-4da3-9fff-575c0ca96cef\",\"7525a5d2-c947-401d-a8e1-48c943f17cfc\",\"7bcd56a6-c2e8-405a-81a1-e39e024c91b7\",\"9c8a5495-5726-4df4-b098-40a0456b8170\",\"9efd4120-5fef-4551-a1d0-cc41a3f0a930\",\"c9964581-93bf-4bcb-8513-060272c26759\"],\"has_axis\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_bottom\",\"9b62394d-e882-4b32-8673-9a6663063d0f_left\",\"9b62394d-e882-4b32-8673-9a6663063d0f_right\",\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"],\"has_role\":[\"agenda\"],\"is_a\":[\"slide\"]},\"9b6abe86-24f1-4829-9eb1-8b49293dc09b\":{\"has_axis\":[\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_bottom\",\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_left\",\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_right\",\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_top\"],\"is_a\":[\"shape\"]},\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"9b6abe86-24f1-4829-9eb1-8b49293dc09b_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"9c1f6c13-a362-42ef-907c-b9fec7b4041f\":{\"has_axis\":[\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_bottom\",\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_left\",\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_right\",\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_top\"],\"is_a\":[\"image\"]},\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"9c1f6c13-a362-42ef-907c-b9fec7b4041f_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"9c8a5495-5726-4df4-b098-40a0456b8170\":{\"has_axis\":[\"9c8a5495-5726-4df4-b098-40a0456b8170_bottom\",\"9c8a5495-5726-4df4-b098-40a0456b8170_left\",\"9c8a5495-5726-4df4-b098-40a0456b8170_right\",\"9c8a5495-5726-4df4-b098-40a0456b8170_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"9c8a5495-5726-4df4-b098-40a0456b8170_bottom\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"9c8a5495-5726-4df4-b098-40a0456b8170_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"9c8a5495-5726-4df4-b098-40a0456b8170_right\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"9c8a5495-5726-4df4-b098-40a0456b8170_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"9cc1b7db-35bb-4ad1-b4f2-47943e535418\":{\"contains\":[\"061bbcd0-e9c1-4988-a030-5f21b0570f76\",\"0e4730ae-e29b-4e31-9cde-682868356ae9\",\"1dc8a7d1-059f-4740-8ad8-5268f85ed647\",\"1f501127-fe01-4a44-afa6-4b53f5a40be4\",\"26c813bc-f7c7-46e4-9ad2-e002d07208d4\",\"3a6eb667-0bd1-462a-a3ff-63fadc096926\",\"3c81a404-ffbb-40ff-8a55-2d1a6a7de35d\",\"6413dc3d-e450-4649-9bc9-5b590d6ddd06\",\"6ddf3890-7cba-4470-bb02-2321ac7f7a77\",\"78d0caee-a319-44ee-8e7c-c15bac97cfac\",\"7c4b5d08-8553-45f3-9c92-ac37aa897690\",\"ae2d10d9-4a8a-41ed-bab2-447cd68009de\",\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43\",\"c5db5a31-0736-4a67-9d6d-4e7921a09d89\",\"cdf1a5fe-5790-4150-a208-8bdfc2381c10\",\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f\"],\"has_axis\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom\",\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\",\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_right\",\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"],\"has_role\":[\"content\"],\"is_a\":[\"slide\"]},\"9d9178a3-2555-4ff5-8b03-902fbf8aca69\":{\"has_attribute\":[\"text_auto_height\"],\"has_role\":[\"content\"],\"is_a\":[\"text\"]},\"9d9393e6-aad4-4eb9-8793-2332fadc592f\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"9d9393e6-aad4-4eb9-8793-2332fadc592f_bottom\",\"9d9393e6-aad4-4eb9-8793-2332fadc592f_left\",\"9d9393e6-aad4-4eb9-8793-2332fadc592f_right\",\"9d9393e6-aad4-4eb9-8793-2332fadc592f_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"9d9393e6-aad4-4eb9-8793-2332fadc592f_bottom\":{\"is_limited_by\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_bottom\"]},\"9d9393e6-aad4-4eb9-8793-2332fadc592f_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"9d9393e6-aad4-4eb9-8793-2332fadc592f_right\":{\"is_limited_by\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_right\"]},\"9d9393e6-aad4-4eb9-8793-2332fadc592f_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"9ea59f27-7ca5-47b3-aab2-727a7de631f7\":{\"contains\":[\"0e5c3389-b4ca-4ffe-9347-a5d1280df7db\",\"2c989e52-7716-43e9-85d9-d08dcd08cb43\",\"5f52d182-db39-48d5-9ea0-24d231fad72b\",\"7e257dc0-6bf2-425b-9156-290223f6981f\",\"badf6210-5022-4590-90b0-5961c1e0a0c8\",\"c953951d-3b19-443b-9c8d-a201eab6708e\",\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953\",\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871\",\"ecee4b97-e77a-4a46-9d81-e353eb45199b\",\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba\",\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d\",\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5\"],\"has_axis\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom\",\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\",\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_right\",\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"],\"has_role\":[\"custom:personaIntroduction\"],\"is_a\":[\"slide\"]},\"9efd4120-5fef-4551-a1d0-cc41a3f0a930\":{\"has_axis\":[\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_bottom\",\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_left\",\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_right\",\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_bottom\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_left\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_right\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"9efd4120-5fef-4551-a1d0-cc41a3f0a930_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"9fcc2418-7096-4121-afdc-9200591e4b47\":{\"has_axis\":[\"9fcc2418-7096-4121-afdc-9200591e4b47_bottom\",\"9fcc2418-7096-4121-afdc-9200591e4b47_left\",\"9fcc2418-7096-4121-afdc-9200591e4b47_right\",\"9fcc2418-7096-4121-afdc-9200591e4b47_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"9fcc2418-7096-4121-afdc-9200591e4b47_bottom\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"9fcc2418-7096-4121-afdc-9200591e4b47_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"9fcc2418-7096-4121-afdc-9200591e4b47_right\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"9fcc2418-7096-4121-afdc-9200591e4b47_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"a15c5b64-2636-47f3-8544-1ce6f29a62a7\":{\"has_axis\":[\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_bottom\",\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_left\",\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_right\",\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_top\"],\"is_a\":[\"shape\"]},\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"a15c5b64-2636-47f3-8544-1ce6f29a62a7_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"a2d3b917-7f07-46f1-991c-97273ee3275c\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"a2d3b917-7f07-46f1-991c-97273ee3275c_bottom\",\"a2d3b917-7f07-46f1-991c-97273ee3275c_left\",\"a2d3b917-7f07-46f1-991c-97273ee3275c_right\",\"a2d3b917-7f07-46f1-991c-97273ee3275c_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"a2d3b917-7f07-46f1-991c-97273ee3275c_bottom\":{\"is_limited_by\":[\"2342c752-7b06-4b38-84a8-6adc01291aed_top_offset_-32\"]},\"a2d3b917-7f07-46f1-991c-97273ee3275c_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"a2d3b917-7f07-46f1-991c-97273ee3275c_right\":{\"is_limited_by\":[\"60389d63-842f-48e8-9536-ce2404aaf2bf_left_offset_-32\"]},\"a2d3b917-7f07-46f1-991c-97273ee3275c_top\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"ab0eb597-2dcd-4869-b761-f22f2e514dd4\":{\"has_attribute\":[\"text_auto_height\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"ac2db977-a249-4092-9cdc-2e4893e64abd\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"ac2db977-a249-4092-9cdc-2e4893e64abd_bottom\",\"ac2db977-a249-4092-9cdc-2e4893e64abd_left\",\"ac2db977-a249-4092-9cdc-2e4893e64abd_right\",\"ac2db977-a249-4092-9cdc-2e4893e64abd_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"ac2db977-a249-4092-9cdc-2e4893e64abd_bottom\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom\"]},\"ac2db977-a249-4092-9cdc-2e4893e64abd_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"ac2db977-a249-4092-9cdc-2e4893e64abd_right\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_right\"]},\"ac2db977-a249-4092-9cdc-2e4893e64abd_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_bottom\",\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_left\",\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_right\",\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_top\"],\"is_a\":[\"text\"]},\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_bottom\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_bottom\"]},\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_right\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_right\"]},\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"ae2d10d9-4a8a-41ed-bab2-447cd68009de\":{\"has_attribute\":[\"text_auto_height\"],\"has_role\":[\"custom:personaName\"],\"is_a\":[\"text\"]},\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd\":{\"has_axis\":[\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_bottom\",\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_left\",\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_right\",\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f\":{\"contains\":[\"4b7caf30-116b-4384-9028-d352fefc571d\",\"6a2513b9-c09b-484e-896f-398b1a5e8a36\",\"6d8d7dd5-b88c-4f34-ab46-b28fc765d86d\",\"797017cb-2846-4bb7-b45a-ad16dc72fe4e\",\"8b29d36e-1120-43cc-9781-0354be720c2b\",\"965ef0ae-a185-4971-9193-c5ee4046085f\",\"cf642c3c-49b0-4db0-8733-4456bdb53802\",\"d196b390-2f75-4128-a6c7-cec47bfbe978\",\"e14cef1a-641e-4ea2-9516-ca9974f54082\",\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea\"],\"has_axis\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\",\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"],\"is_a\":[\"slide\"]},\"b1ce999b-d48a-4170-8b0f-13cc24f073c4\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_bottom\",\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_left\",\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_right\",\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_top\"],\"is_a\":[\"text\"]},\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_bottom\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_bottom\"]},\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_right\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_right\"]},\"b1ce999b-d48a-4170-8b0f-13cc24f073c4_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"b2721d84-2f2f-4d25-b8fa-92d013ef113a\":{\"has_axis\":[\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_bottom\",\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_left\",\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_right\",\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_bottom\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_right\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"b2721d84-2f2f-4d25-b8fa-92d013ef113a_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"b404b6c6-e93d-4fd2-acab-6acd258a6835\":{\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"b60587e5-64df-4c1c-849f-520a5a84c296\":{\"has_axis\":[\"b60587e5-64df-4c1c-849f-520a5a84c296_bottom\",\"b60587e5-64df-4c1c-849f-520a5a84c296_left\",\"b60587e5-64df-4c1c-849f-520a5a84c296_right\",\"b60587e5-64df-4c1c-849f-520a5a84c296_top\"],\"is_a\":[\"shape\"]},\"b60587e5-64df-4c1c-849f-520a5a84c296_bottom\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"]},\"b60587e5-64df-4c1c-849f-520a5a84c296_left\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\"]},\"b60587e5-64df-4c1c-849f-520a5a84c296_right\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\"]},\"b60587e5-64df-4c1c-849f-520a5a84c296_top\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"]},\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_bottom\",\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_left\",\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_right\",\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_top\"],\"has_role\":[\"content\"],\"is_a\":[\"text\"]},\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_bottom\":{\"is_limited_by\":[\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_top_offset_-32\"]},\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_right\":{\"is_limited_by\":[\"26c813bc-f7c7-46e4-9ad2-e002d07208d4_left_offset_-32\"]},\"b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_top\":{\"is_pinned_to\":[\"6ddf3890-7cba-4470-bb02-2321ac7f7a77_bottom\"]},\"b9a08d48-67d9-40b3-ad53-45a81895ab9b\":{\"has_axis\":[\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_bottom\",\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_left\",\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_right\",\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_bottom\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_right\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"b9a08d48-67d9-40b3-ad53-45a81895ab9b_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"ba4fd689-f519-411d-9f85-e7f440e22ec4\":{\"has_axis\":[\"ba4fd689-f519-411d-9f85-e7f440e22ec4_bottom\",\"ba4fd689-f519-411d-9f85-e7f440e22ec4_left\",\"ba4fd689-f519-411d-9f85-e7f440e22ec4_right\",\"ba4fd689-f519-411d-9f85-e7f440e22ec4_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"ba4fd689-f519-411d-9f85-e7f440e22ec4_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"ba4fd689-f519-411d-9f85-e7f440e22ec4_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"ba4fd689-f519-411d-9f85-e7f440e22ec4_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"ba4fd689-f519-411d-9f85-e7f440e22ec4_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"badf6210-5022-4590-90b0-5961c1e0a0c8\":{\"has_axis\":[\"badf6210-5022-4590-90b0-5961c1e0a0c8_bottom\",\"badf6210-5022-4590-90b0-5961c1e0a0c8_left\",\"badf6210-5022-4590-90b0-5961c1e0a0c8_right\",\"badf6210-5022-4590-90b0-5961c1e0a0c8_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"badf6210-5022-4590-90b0-5961c1e0a0c8_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"badf6210-5022-4590-90b0-5961c1e0a0c8_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"badf6210-5022-4590-90b0-5961c1e0a0c8_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"badf6210-5022-4590-90b0-5961c1e0a0c8_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"bce10be2-b9a8-4cca-91f5-8d7dc3141009\":{\"is_a\":[\"image\"]},\"bd369631-a068-494a-9084-0b4bdb7312f5\":{\"has_axis\":[\"bd369631-a068-494a-9084-0b4bdb7312f5_bottom\",\"bd369631-a068-494a-9084-0b4bdb7312f5_left\",\"bd369631-a068-494a-9084-0b4bdb7312f5_right\",\"bd369631-a068-494a-9084-0b4bdb7312f5_top\"],\"is_a\":[\"image\"]},\"bd369631-a068-494a-9084-0b4bdb7312f5_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"bd369631-a068-494a-9084-0b4bdb7312f5_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"bd369631-a068-494a-9084-0b4bdb7312f5_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"bd369631-a068-494a-9084-0b4bdb7312f5_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"c04a832d-36f6-400b-8fd5-fbff24acb317\":{\"has_axis\":[\"c04a832d-36f6-400b-8fd5-fbff24acb317_bottom\",\"c04a832d-36f6-400b-8fd5-fbff24acb317_left\",\"c04a832d-36f6-400b-8fd5-fbff24acb317_right\",\"c04a832d-36f6-400b-8fd5-fbff24acb317_top\"],\"is_a\":[\"image\"]},\"c04a832d-36f6-400b-8fd5-fbff24acb317_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"c04a832d-36f6-400b-8fd5-fbff24acb317_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"c04a832d-36f6-400b-8fd5-fbff24acb317_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"c04a832d-36f6-400b-8fd5-fbff24acb317_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"c1cb59a2-1fbd-400d-95da-2139af7f464d\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"c1cb59a2-1fbd-400d-95da-2139af7f464d_bottom\",\"c1cb59a2-1fbd-400d-95da-2139af7f464d_left\",\"c1cb59a2-1fbd-400d-95da-2139af7f464d_right\",\"c1cb59a2-1fbd-400d-95da-2139af7f464d_top\"],\"is_a\":[\"text\"]},\"c1cb59a2-1fbd-400d-95da-2139af7f464d_bottom\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_bottom\"]},\"c1cb59a2-1fbd-400d-95da-2139af7f464d_left\":{\"is_limited_by\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"c1cb59a2-1fbd-400d-95da-2139af7f464d_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"c1cb59a2-1fbd-400d-95da-2139af7f464d_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11\":{\"contains\":[\"0e3cc635-21ea-42f2-b03c-81d94dea1202\",\"105a38cf-643c-4c9e-9eb7-9a266559c7b5\",\"16f01b56-5e50-4aba-8a4d-04202d4aa796\",\"1b8e67c5-8972-4f37-bc8e-2431e93e627d\",\"4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0\",\"5feed6ff-1382-46bc-ae1f-713609ac0045\",\"7681e420-6306-46ca-beb7-01e412b24005\",\"8b77414d-a542-4222-acb0-a1b90d184d69\",\"8ee09d28-eea9-4088-a564-03a5a46f2f20\",\"9d9178a3-2555-4ff5-8b03-902fbf8aca69\",\"9d9393e6-aad4-4eb9-8793-2332fadc592f\",\"ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd\",\"b404b6c6-e93d-4fd2-acab-6acd258a6835\",\"cc630350-c0bc-4fd3-a93d-bc7d54d0c06f\",\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f\",\"f2161dbc-a064-46a0-aa86-4a848d9d3940\"],\"has_axis\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_bottom\",\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\",\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_right\",\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"],\"is_a\":[\"slide\"]},\"c403034c-0a73-49a8-9539-7e5352f740c5\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"c403034c-0a73-49a8-9539-7e5352f740c5_bottom\",\"c403034c-0a73-49a8-9539-7e5352f740c5_left\",\"c403034c-0a73-49a8-9539-7e5352f740c5_right\",\"c403034c-0a73-49a8-9539-7e5352f740c5_top\"],\"has_role\":[\"title\"],\"is_a\":[\"text\"]},\"c403034c-0a73-49a8-9539-7e5352f740c5_bottom\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_bottom\"]},\"c403034c-0a73-49a8-9539-7e5352f740c5_left\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_left\"]},\"c403034c-0a73-49a8-9539-7e5352f740c5_right\":{\"is_limited_by\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_right\"]},\"c403034c-0a73-49a8-9539-7e5352f740c5_top\":{\"is_pinned_to\":[\"3c566718-4899-439f-bac4-3c58a81f1aa7_top\"]},\"c5db5a31-0736-4a67-9d6d-4e7921a09d89\":{\"has_axis\":[\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_bottom\",\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_left\",\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_left_offset_-32\",\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_right\",\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_top\"],\"has_role\":[\"content\"],\"is_a\":[\"image\"]},\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom\"]},\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_right\":{\"is_limited_by\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_right\"]},\"c5db5a31-0736-4a67-9d6d-4e7921a09d89_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"c953951d-3b19-443b-9c8d-a201eab6708e\":{\"has_axis\":[\"c953951d-3b19-443b-9c8d-a201eab6708e_bottom\",\"c953951d-3b19-443b-9c8d-a201eab6708e_left\",\"c953951d-3b19-443b-9c8d-a201eab6708e_right\",\"c953951d-3b19-443b-9c8d-a201eab6708e_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"c953951d-3b19-443b-9c8d-a201eab6708e_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"c953951d-3b19-443b-9c8d-a201eab6708e_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"c953951d-3b19-443b-9c8d-a201eab6708e_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"c953951d-3b19-443b-9c8d-a201eab6708e_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"c9964581-93bf-4bcb-8513-060272c26759\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"c9964581-93bf-4bcb-8513-060272c26759_bottom\",\"c9964581-93bf-4bcb-8513-060272c26759_left\",\"c9964581-93bf-4bcb-8513-060272c26759_right\",\"c9964581-93bf-4bcb-8513-060272c26759_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"c9964581-93bf-4bcb-8513-060272c26759_bottom\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_bottom\"]},\"c9964581-93bf-4bcb-8513-060272c26759_left\":{\"is_limited_by\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"c9964581-93bf-4bcb-8513-060272c26759_right\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_left\"]},\"c9964581-93bf-4bcb-8513-060272c26759_top\":{\"is_pinned_to\":[\"9b62394d-e882-4b32-8673-9a6663063d0f_top\"]},\"cbf21645-b078-4812-b755-d8ecae9ef204\":{\"has_axis\":[\"cbf21645-b078-4812-b755-d8ecae9ef204_bottom\",\"cbf21645-b078-4812-b755-d8ecae9ef204_left\",\"cbf21645-b078-4812-b755-d8ecae9ef204_right\",\"cbf21645-b078-4812-b755-d8ecae9ef204_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"cbf21645-b078-4812-b755-d8ecae9ef204_bottom\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_top\"]},\"cbf21645-b078-4812-b755-d8ecae9ef204_left\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_left\"]},\"cbf21645-b078-4812-b755-d8ecae9ef204_right\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_left\"]},\"cbf21645-b078-4812-b755-d8ecae9ef204_top\":{\"is_pinned_to\":[\"731d57c9-7588-4ca3-a019-5618a436794a_top\"]},\"cc630350-c0bc-4fd3-a93d-bc7d54d0c06f\":{\"has_attribute\":[\"text_auto_height\"],\"has_role\":[\"content\"],\"is_a\":[\"text\"]},\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_bottom\",\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_left\",\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_right\",\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_bottom\":{\"is_limited_by\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_bottom\"]},\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_right\":{\"is_limited_by\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_right\"]},\"ccf00a0f-8a27-4c3b-8119-b2f8b7723469_top\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"cdf1a5fe-5790-4150-a208-8bdfc2381c10\":{\"has_axis\":[\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_bottom\",\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_left\",\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_right\",\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_top\",\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_top_offset_-32\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_right\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"cdf1a5fe-5790-4150-a208-8bdfc2381c10_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"cf642c3c-49b0-4db0-8733-4456bdb53802\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"content-f4d39f7f-eb69-4e8f-9c80-a0c479345826\":{\"has_role\":[\"content\"],\"is_a\":[\"list_item\"]},\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_bottom\",\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_left\",\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_right\",\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_top\"],\"is_a\":[\"text\"]},\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_bottom\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom\"]},\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_right\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_right\"]},\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"d196b390-2f75-4128-a6c7-cec47bfbe978\":{\"is_a\":[\"image\"]},\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2\":{\"has_axis\":[\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_bottom\",\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_left\",\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_right\",\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_top\"],\"has_role\":[\"background\"],\"is_a\":[\"image\"]},\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_bottom\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_right\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"d5e2ffce-71cb-44ea-90ca-99ac466c73a2_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"d8785e68-1271-4aac-8746-620d93c73b1e\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"d8785e68-1271-4aac-8746-620d93c73b1e_bottom\",\"d8785e68-1271-4aac-8746-620d93c73b1e_left\",\"d8785e68-1271-4aac-8746-620d93c73b1e_right\",\"d8785e68-1271-4aac-8746-620d93c73b1e_top\"],\"has_role\":[\"subtitle\"],\"is_a\":[\"text\"]},\"d8785e68-1271-4aac-8746-620d93c73b1e_bottom\":{\"is_limited_by\":[\"152bfeb9-aa0c-42cf-b639-d3f63556df80_bottom\"]},\"d8785e68-1271-4aac-8746-620d93c73b1e_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"d8785e68-1271-4aac-8746-620d93c73b1e_right\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_right\"]},\"d8785e68-1271-4aac-8746-620d93c73b1e_top\":{\"is_pinned_to\":[\"ac2db977-a249-4092-9cdc-2e4893e64abd_bottom\"]},\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_bottom\",\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_left\",\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_right\",\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_top\"],\"has_role\":[\"custom:title\"],\"is_a\":[\"text\"]},\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_bottom\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom\"]},\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_right\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_right\"]},\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"deddf272-f102-4a15-851b-57b446f88245\":{\"has_axis\":[\"deddf272-f102-4a15-851b-57b446f88245_bottom\",\"deddf272-f102-4a15-851b-57b446f88245_left\",\"deddf272-f102-4a15-851b-57b446f88245_right\",\"deddf272-f102-4a15-851b-57b446f88245_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"deddf272-f102-4a15-851b-57b446f88245_bottom\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"deddf272-f102-4a15-851b-57b446f88245_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"deddf272-f102-4a15-851b-57b446f88245_right\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"deddf272-f102-4a15-851b-57b446f88245_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"df831973-eb26-469e-8d5a-019a40bece41\":{\"has_axis\":[\"df831973-eb26-469e-8d5a-019a40bece41_bottom\",\"df831973-eb26-469e-8d5a-019a40bece41_left\",\"df831973-eb26-469e-8d5a-019a40bece41_right\",\"df831973-eb26-469e-8d5a-019a40bece41_top\"],\"is_a\":[\"shape\"]},\"df831973-eb26-469e-8d5a-019a40bece41_bottom\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"df831973-eb26-469e-8d5a-019a40bece41_left\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"df831973-eb26-469e-8d5a-019a40bece41_right\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\"]},\"df831973-eb26-469e-8d5a-019a40bece41_top\":{\"is_pinned_to\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"]},\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f\":{\"has_axis\":[\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_bottom\",\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_left\",\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_right\",\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"e00ca332-09bf-4da6-b1c4-31e1324b5b7f_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"e0d1b09f-cf75-4bb3-b4ff-74debcfefd7b\":{\"has_attribute\":[\"text_auto_height\"],\"is_a\":[\"text\"]},\"e14cef1a-641e-4ea2-9516-ca9974f54082\":{\"has_axis\":[\"e14cef1a-641e-4ea2-9516-ca9974f54082_bottom\",\"e14cef1a-641e-4ea2-9516-ca9974f54082_left\",\"e14cef1a-641e-4ea2-9516-ca9974f54082_right\",\"e14cef1a-641e-4ea2-9516-ca9974f54082_top\"],\"is_a\":[\"shape\"]},\"e14cef1a-641e-4ea2-9516-ca9974f54082_bottom\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"]},\"e14cef1a-641e-4ea2-9516-ca9974f54082_left\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\"]},\"e14cef1a-641e-4ea2-9516-ca9974f54082_right\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\"]},\"e14cef1a-641e-4ea2-9516-ca9974f54082_top\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"]},\"e216c9a2-fb09-4e7e-9e84-c2b37c715cdf\":{\"has_accent_color\":[\"accent0:#EB1000\",\"accent1:#EB1000\",\"accent2:#EB1000\"],\"has_primary_color\":[\"#000000\"],\"has_secondary_color\":[\"#8821F4\"],\"has_surface_color\":[\"#FFFFFF\"]},\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_bottom\",\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_left\",\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_right\",\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_bottom\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom\"]},\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_left\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_left\"]},\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_right\":{\"is_limited_by\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_right\"]},\"e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_top\":{\"is_pinned_to\":[\"8ca27b0f-d10e-4d35-912b-969e99e37aec_top\"]},\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_bottom\",\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_left\",\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_right\",\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_top\"],\"has_role\":[\"content\"],\"is_a\":[\"text\"]},\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_bottom\":{\"is_limited_by\":[\"083c6f6a-5f37-419d-947f-5f1aa0daae01_top_offset_-32\"]},\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_right\":{\"is_limited_by\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_right\"]},\"e75d149c-7ddd-4f4e-a151-14a59ea98ffb_top\":{\"is_pinned_to\":[\"315f7ad5-00c2-4fbb-8239-836b86a53ecc_bottom\"]},\"e87eb981-9025-4af3-8a9b-11525b18559d\":{\"has_axis\":[\"e87eb981-9025-4af3-8a9b-11525b18559d_bottom\",\"e87eb981-9025-4af3-8a9b-11525b18559d_left\",\"e87eb981-9025-4af3-8a9b-11525b18559d_right\",\"e87eb981-9025-4af3-8a9b-11525b18559d_top\"],\"is_a\":[\"image\"]},\"e87eb981-9025-4af3-8a9b-11525b18559d_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"e87eb981-9025-4af3-8a9b-11525b18559d_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"e87eb981-9025-4af3-8a9b-11525b18559d_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"e87eb981-9025-4af3-8a9b-11525b18559d_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"eb669744-64d3-4171-9b10-3784d7cb8a94\":{\"contains\":[\"0892589a-e09d-4d9b-bb9e-f48a76b0553d\",\"18099207-fd29-41eb-b50c-266787682802\",\"3eeacefe-1c84-4637-b4a5-d988c4411b34\",\"419fda32-2472-49ec-80a7-8bdd6b504d70\",\"85f25280-8989-4be3-b16c-6e9d22d9b6c1\",\"9b6abe86-24f1-4829-9eb1-8b49293dc09b\",\"9c1f6c13-a362-42ef-907c-b9fec7b4041f\",\"a15c5b64-2636-47f3-8544-1ce6f29a62a7\",\"ad3af027-0fdb-40dd-99de-93a1cc60f8bd\",\"b1ce999b-d48a-4170-8b0f-13cc24f073c4\",\"c1cb59a2-1fbd-400d-95da-2139af7f464d\",\"df831973-eb26-469e-8d5a-019a40bece41\"],\"has_axis\":[\"eb669744-64d3-4171-9b10-3784d7cb8a94_bottom\",\"eb669744-64d3-4171-9b10-3784d7cb8a94_left\",\"eb669744-64d3-4171-9b10-3784d7cb8a94_right\",\"eb669744-64d3-4171-9b10-3784d7cb8a94_top\"],\"is_a\":[\"slide\"]},\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9\":{\"has_axis\":[\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_bottom\",\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_left\",\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_right\",\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"ec9156be-f2e5-46c9-97b5-fe769bda3ed9_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_bottom\",\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_left\",\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_right\",\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_top\"],\"has_role\":[\"custom:subtitle\"],\"is_a\":[\"text\"]},\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_bottom\":{\"is_limited_by\":[\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_top\"]},\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_right\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_right\"]},\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_top\":{\"is_pinned_to\":[\"d9e49dd8-5249-49af-9b1a-d4be5e2e9953_bottom\"]},\"ecee4b97-e77a-4a46-9d81-e353eb45199b\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"ecee4b97-e77a-4a46-9d81-e353eb45199b_bottom\",\"ecee4b97-e77a-4a46-9d81-e353eb45199b_left\",\"ecee4b97-e77a-4a46-9d81-e353eb45199b_right\",\"ecee4b97-e77a-4a46-9d81-e353eb45199b_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"ecee4b97-e77a-4a46-9d81-e353eb45199b_bottom\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom\"]},\"ecee4b97-e77a-4a46-9d81-e353eb45199b_left\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"ecee4b97-e77a-4a46-9d81-e353eb45199b_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"ecee4b97-e77a-4a46-9d81-e353eb45199b_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"edde815a-a16e-4ca1-956d-494986896ef4\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"edde815a-a16e-4ca1-956d-494986896ef4_bottom\",\"edde815a-a16e-4ca1-956d-494986896ef4_left\",\"edde815a-a16e-4ca1-956d-494986896ef4_right\",\"edde815a-a16e-4ca1-956d-494986896ef4_top\"],\"is_a\":[\"text\"]},\"edde815a-a16e-4ca1-956d-494986896ef4_bottom\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom\"]},\"edde815a-a16e-4ca1-956d-494986896ef4_left\":{\"is_limited_by\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"edde815a-a16e-4ca1-956d-494986896ef4_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"edde815a-a16e-4ca1-956d-494986896ef4_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_bottom\",\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_left\",\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_right\",\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"text\"]},\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_bottom\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom\"]},\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_left\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_left\"]},\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_right\":{\"is_limited_by\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_right\"]},\"ee557a2e-b3e7-40ae-a78f-486bc1693d8f_top\":{\"is_pinned_to\":[\"9cc1b7db-35bb-4ad1-b4f2-47943e535418_top\"]},\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba\":{\"has_axis\":[\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_bottom\",\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_left\",\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_right\",\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"ef87ed0b-1977-45e7-9ce9-2bb509ceceba_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321\":{\"has_axis\":[\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_bottom\",\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_left\",\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_right\",\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_bottom\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_left\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_right\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_left\"]},\"efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_top\":{\"is_pinned_to\":[\"64358dd5-ae6a-4b59-9d2d-1b051def1d82_top\"]},\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea\":{\"has_axis\":[\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_bottom\",\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_left\",\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_right\",\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_top\"],\"is_a\":[\"shape\"]},\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_bottom\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"]},\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_left\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\"]},\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_right\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left\"]},\"f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_top\":{\"is_pinned_to\":[\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top\"]},\"f2161dbc-a064-46a0-aa86-4a848d9d3940\":{\"has_axis\":[\"f2161dbc-a064-46a0-aa86-4a848d9d3940_bottom\",\"f2161dbc-a064-46a0-aa86-4a848d9d3940_left\",\"f2161dbc-a064-46a0-aa86-4a848d9d3940_right\",\"f2161dbc-a064-46a0-aa86-4a848d9d3940_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"f2161dbc-a064-46a0-aa86-4a848d9d3940_bottom\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"f2161dbc-a064-46a0-aa86-4a848d9d3940_left\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"f2161dbc-a064-46a0-aa86-4a848d9d3940_right\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left\"]},\"f2161dbc-a064-46a0-aa86-4a848d9d3940_top\":{\"is_pinned_to\":[\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top\"]},\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d\":{\"has_axis\":[\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_bottom\",\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_left\",\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_right\",\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top\",\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top_offset_-32\"],\"has_role\":[\"decoration\"],\"is_a\":[\"image\"]},\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_bottom\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_right\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_top\"]},\"f471ccc2-8071-4df9-907f-f30b1f5dced9\":{\"contains\":[\"152bfeb9-aa0c-42cf-b639-d3f63556df80\",\"3dcae55c-5ebc-4a46-a381-a98ef638bfb4\",\"4f18efff-7c4e-4636-8d01-032d5e4c7a73\",\"58d1cbba-5637-48a1-b003-c6c585a07cfe\",\"ac2db977-a249-4092-9cdc-2e4893e64abd\",\"b9a08d48-67d9-40b3-ad53-45a81895ab9b\",\"d8785e68-1271-4aac-8746-620d93c73b1e\",\"f70c3d13-1804-4a07-84cb-253584ca556c\"],\"has_axis\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom\",\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\",\"f471ccc2-8071-4df9-907f-f30b1f5dced9_right\",\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"],\"has_role\":[\"chapter\"],\"is_a\":[\"slide\"]},\"f70c3d13-1804-4a07-84cb-253584ca556c\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"f70c3d13-1804-4a07-84cb-253584ca556c_bottom\",\"f70c3d13-1804-4a07-84cb-253584ca556c_left\",\"f70c3d13-1804-4a07-84cb-253584ca556c_right\",\"f70c3d13-1804-4a07-84cb-253584ca556c_top\"],\"has_role\":[\"context_title\"],\"is_a\":[\"text\"]},\"f70c3d13-1804-4a07-84cb-253584ca556c_bottom\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom\"]},\"f70c3d13-1804-4a07-84cb-253584ca556c_left\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_left\"]},\"f70c3d13-1804-4a07-84cb-253584ca556c_right\":{\"is_limited_by\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_right\"]},\"f70c3d13-1804-4a07-84cb-253584ca556c_top\":{\"is_pinned_to\":[\"f471ccc2-8071-4df9-907f-f30b1f5dced9_top\"]},\"f73574b9-71e0-42e7-99ea-70a35fcf09f0\":{\"contains\":[\"03d15d0c-e7ae-4383-b942-bef5af32b9d2\",\"10110498-84dd-4eac-a05f-1d6a6786cc39\",\"40802aad-299d-45e9-8c97-099453c995f8\",\"65712f61-cfc5-4c4e-9563-b6ab2eab5902\",\"6929c343-70aa-4324-b590-5bfafd176df0\",\"69b7a4e4-a179-46e0-8576-8a861a67e156\",\"8a56399c-4fc2-4e72-a798-bd90aeb417c9\",\"bd369631-a068-494a-9084-0b4bdb7312f5\",\"c04a832d-36f6-400b-8fd5-fbff24acb317\",\"d0ca6162-f9ca-4447-ac12-6c28c6f63c3a\",\"e87eb981-9025-4af3-8a9b-11525b18559d\",\"edde815a-a16e-4ca1-956d-494986896ef4\",\"feb8b24a-4955-43d8-8699-a325d3acf61d\"],\"has_axis\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom\",\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\",\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_right\",\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"],\"is_a\":[\"slide\"]},\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1\":{\"contains\":[\"2931e5d2-ce81-42e9-a4ad-66ddf0f449e6\",\"48f59b8a-ad78-4fbc-add6-9cb6a922c231\",\"506097e9-1862-4658-95e7-a9ce78273fca\",\"510134a1-8d81-4e98-8d68-0f5290eea590\",\"716445cb-1a99-4546-a262-990ce93f5b14\",\"7b210f71-5928-466e-aa4d-02ae284e2989\",\"825eca02-f797-4734-8db9-23a087f2ed2e\",\"b60587e5-64df-4c1c-849f-520a5a84c296\",\"bce10be2-b9a8-4cca-91f5-8d7dc3141009\",\"e0d1b09f-cf75-4bb3-b4ff-74debcfefd7b\",\"fed84f0e-4fa3-422a-9d65-c5ee63964554\"],\"has_axis\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\",\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"],\"is_a\":[\"slide\"]},\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5\":{\"has_attribute\":[\"text_auto_height\"],\"has_axis\":[\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_bottom\",\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_left\",\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_right\",\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_top\"],\"has_role\":[\"custom:content\"],\"is_a\":[\"text\"]},\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_bottom\":{\"is_limited_by\":[\"f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top_offset_-32\"]},\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_left\":{\"is_pinned_to\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_left\"]},\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_right\":{\"is_limited_by\":[\"9ea59f27-7ca5-47b3-aab2-727a7de631f7_right\"]},\"fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_top\":{\"is_pinned_to\":[\"ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_bottom\"]},\"fccda08f-b71b-4661-bdbd-157f12aca817\":{\"has_axis\":[\"fccda08f-b71b-4661-bdbd-157f12aca817_bottom\",\"fccda08f-b71b-4661-bdbd-157f12aca817_left\",\"fccda08f-b71b-4661-bdbd-157f12aca817_right\",\"fccda08f-b71b-4661-bdbd-157f12aca817_top\"],\"has_role\":[\"decoration\"],\"is_a\":[\"shape\"]},\"fccda08f-b71b-4661-bdbd-157f12aca817_bottom\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"fccda08f-b71b-4661-bdbd-157f12aca817_left\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"fccda08f-b71b-4661-bdbd-157f12aca817_right\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left\"]},\"fccda08f-b71b-4661-bdbd-157f12aca817_top\":{\"is_pinned_to\":[\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top\"]},\"feb8b24a-4955-43d8-8699-a325d3acf61d\":{\"has_axis\":[\"feb8b24a-4955-43d8-8699-a325d3acf61d_bottom\",\"feb8b24a-4955-43d8-8699-a325d3acf61d_left\",\"feb8b24a-4955-43d8-8699-a325d3acf61d_right\",\"feb8b24a-4955-43d8-8699-a325d3acf61d_top\"],\"is_a\":[\"image\"]},\"feb8b24a-4955-43d8-8699-a325d3acf61d_bottom\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"feb8b24a-4955-43d8-8699-a325d3acf61d_left\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"feb8b24a-4955-43d8-8699-a325d3acf61d_right\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_left\"]},\"feb8b24a-4955-43d8-8699-a325d3acf61d_top\":{\"is_pinned_to\":[\"f73574b9-71e0-42e7-99ea-70a35fcf09f0_top\"]},\"fed84f0e-4fa3-422a-9d65-c5ee63964554\":{\"has_axis\":[\"fed84f0e-4fa3-422a-9d65-c5ee63964554_bottom\",\"fed84f0e-4fa3-422a-9d65-c5ee63964554_left\",\"fed84f0e-4fa3-422a-9d65-c5ee63964554_right\",\"fed84f0e-4fa3-422a-9d65-c5ee63964554_top\"],\"is_a\":[\"shape\"]},\"fed84f0e-4fa3-422a-9d65-c5ee63964554_bottom\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"]},\"fed84f0e-4fa3-422a-9d65-c5ee63964554_left\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\"]},\"fed84f0e-4fa3-422a-9d65-c5ee63964554_right\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left\"]},\"fed84f0e-4fa3-422a-9d65-c5ee63964554_top\":{\"is_pinned_to\":[\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top\"]},\"root\":{\"contains\":[\"32fd34ec-3db9-4c63-98c8-f6edeb97505b\",\"3c566718-4899-439f-bac4-3c58a81f1aa7\",\"64358dd5-ae6a-4b59-9d2d-1b051def1d82\",\"6d4b04b8-5837-45fa-a49f-0d6a15e4348e\",\"731d57c9-7588-4ca3-a019-5618a436794a\",\"8ca27b0f-d10e-4d35-912b-969e99e37aec\",\"9b62394d-e882-4b32-8673-9a6663063d0f\",\"9cc1b7db-35bb-4ad1-b4f2-47943e535418\",\"9ea59f27-7ca5-47b3-aab2-727a7de631f7\",\"af8ab741-e916-43d1-9956-e1d0ab5d3a2f\",\"c39209f9-2bd4-4052-9c3c-5e18c5be0d11\",\"eb669744-64d3-4171-9b10-3784d7cb8a94\",\"f471ccc2-8071-4df9-907f-f30b1f5dced9\",\"f73574b9-71e0-42e7-99ea-70a35fcf09f0\",\"f9276da5-d611-4f2c-a2f0-96f7d79b4ed1\"],\"has_theme\":[\"e216c9a2-fb09-4e7e-9e84-c2b37c715cdf\"],\"is_a\":[\"presentation\"]}}");


/**
 * Generates the payload for the Adobe Express API request.
 *
 * @param {Object} options - Options for generating the payload.
 * @param {string} options.templateId - The template ID to use.
 * @param {string|null} options.themeId - The theme ID to use, or null for default.
 * @param {string} options.author - The author of the story.
 * @param {string} options.docName - The name of the document.
 * @param {string} options.locale - The locale for the document.
 * @param {Object} options.data - The data to include in the payload.
 *
 * @returns {Object} - The generated payload object.
 */ const $11367e19212b6f77$var$generatePayload = ({ templateId: // templateId = "urn:aaid:sc:VA6C2:05792d99-6795-5188-95e1-d38442e124dc",
// templateId = "urn:aaid:sc:VA6C2:ed993611-2f85-5e1a-b9b0-2badf1cba1b0",
templateId = "urn:aaid:sc:VA6C2:fc6a2c6b-c9cc-539c-a8ad-baa084dfa685", isUserTemplate: isUserTemplate = true, themeId: themeId = null, author: author = "Be Story", docName: docName = null, locale: locale = "en-US", data: data = {} } = options)=>({
        "sensei:invocation_mode": "asynchronous",
        "sensei:invocation_batch": false,
        "sensei:in_response": false,
        "sensei:control": true,
        "sensei:engines": [
            {
                "sensei:execution_info": {
                    "sensei:engine": "Classification:face-crop:Service-6c25a17a1c2f488485aeb09d0229fec4"
                },
                "sensei:inputs": {
                    content_fitting_in: {
                        requestType: "directContentInput",
                        outputType: "docUrl",
                        payload: {
                            templateId: templateId,
                            isUserTemplate: isUserTemplate,
                            themeId: themeId,
                            author: author,
                            docName: docName ?? `[Be Story] ${data.slides?.[0]?.title || "Presentation"}`,
                            mimetype: "application/vnd.adobe.hz.express+dcx",
                            locale: locale,
                            content: data,
                            knowledgeGraph: {
                                semantic_metadata: (0, (/*@__PURE__*/$parcel$interopDefault($7fc3a3cce38e3646$exports)))
                            },
                            authoringExperience: 2
                        }
                    }
                },
                "sensei:params": {
                    content_fitting_config: {}
                },
                "sensei:outputs": {
                    content_fitting_out: {
                        "dc:format": "application/json",
                        "sensei:multipart_field_name": "outfile"
                    }
                }
            }
        ]
    });
const $11367e19212b6f77$export$b44cc4411da85ae5 = async (data, docName = null)=>{
    const formData = new FormData();
    formData.append("contentAnalyzerRequests", JSON.stringify($11367e19212b6f77$var$generatePayload({
        data: data,
        docName: docName ? `[Be Story] ${docName}` : null,
        author: (0, $fmJ8d.store).getState().ims.profile.name
    })));
    const authHeaders = await (0, $fHV62.getAuthHeaders)((0, $fmJ8d.store).getState().ims);
    // IMPORTANT: Remove Content-Type if present - FormData sets it automatically with correct boundary
    const { "Content-Type": _, ...headersWithoutContentType } = authHeaders;
    const response = await fetch((0, $8Ogg5.actions)["exd-storyteller-ai/generatePresentation"], {
        method: "POST",
        body: formData,
        headers: headersWithoutContentType
    });
    console.log("Form Data:", {
        formData: formData
    });
    console.log("Response from Adobe Express:", {
        response: response
    });
    if (!response.ok) throw new Error("Failed to execute Adobe Express job", response);
    return response.json();
};




var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $5IZkx = parcelRequire("5IZkx");

var $4W5AG = parcelRequire("4W5AG");
var $f16Ml = parcelRequire("f16Ml");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $4UbTp = parcelRequire("4UbTp");
var $aVEhH = parcelRequire("aVEhH");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");


var $fmJ8d = parcelRequire("fmJ8d");

var $fHV62 = parcelRequire("fHV62");
const $37c4445ec21c8c5e$var$peopleGraphApi = (0, $fHV62.createApiClient)("https://pgc.adobe.io/api", null, 1, {
    "Content-Type": "application/json",
    "x-api-key": "bestory-prod",
    "X-Feature-CachingEnabled": true
});
const $37c4445ec21c8c5e$export$b0b3f4ef5d856594 = async (value, { relationship: relationship = "INVITE", resourceUrl: resourceUrl = new URL(window.location.pathname, "https://bestory.adobe.com").href } = {}, axiosConfig = {})=>{
    return $37c4445ec21c8c5e$var$peopleGraphApi.post("/suggestions", {
        relationship: relationship,
        resourceType: "application/vnd.adobe.bestory",
        resourceUrl: resourceUrl,
        query: {
            value: value,
            type: [
                "PERSON"
            ]
        }
    }, axiosConfig);
};
const $37c4445ec21c8c5e$export$73f57eecff448cc8 = async (tokens, axiosConfig = {})=>{
    return $37c4445ec21c8c5e$var$peopleGraphApi.post("/accept", {
        tokens: tokens
    }, axiosConfig);
};
const $37c4445ec21c8c5e$export$1935eb9cdd85a29d = async (email, axiosConfig = {})=>{
    const response = await $37c4445ec21c8c5e$export$b0b3f4ef5d856594(email, {}, axiosConfig);
    return response?.data?._embedded?.suggestions?.[0] || null;
};
const $37c4445ec21c8c5e$export$b9c97d5330cbe844 = async (emails, axiosConfig = {})=>{
    const suggestions = (await Promise.all(emails.map((email)=>$37c4445ec21c8c5e$export$1935eb9cdd85a29d(email, axiosConfig)))).filter(Boolean);
    if (!suggestions || suggestions.length === 0) return [];
    const accepted = await $37c4445ec21c8c5e$export$73f57eecff448cc8(suggestions.map((s)=>s.token), axiosConfig);
    const people = suggestions.map((suggestion, idx)=>({
            ...suggestion,
            email: accepted?.data?._embedded?.successes?.[idx]?.email || suggestion.caption
        }));
    return people;
};
var $37c4445ec21c8c5e$export$2e2bcd8739ae039 = {
    suggest: $37c4445ec21c8c5e$export$b0b3f4ef5d856594,
    accept: $37c4445ec21c8c5e$export$73f57eecff448cc8,
    getPerson: $37c4445ec21c8c5e$export$1935eb9cdd85a29d,
    getPeople: $37c4445ec21c8c5e$export$b9c97d5330cbe844
};



var $VXM1R = parcelRequire("VXM1R");

var $i8elj = parcelRequire("i8elj");

const $ec29ab645ba71613$var$listStyle = " sd182 _ta182 Uj182 qj182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182";
const $ec29ab645ba71613$var$UserListItem = ({ user: user, children: children })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 eb182 Ug182 qg182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                src: user?._links?.thumbnail?.href,
                alt: user?.title,
                size: 32
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 Ua182 qa182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 _Fd182 _FnuYUweb182 pt182",
                        children: user?.title
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pn182",
                        children: user?.email ?? user?.caption
                    })
                ]
            }),
            children
        ]
    });
};
$ec29ab645ba71613$var$UserListItem.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const $ec29ab645ba71613$export$704f41f51e589a1 = ({ story: story })=>{
    if (!story) return null;
    const ims = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.ims);
    const [users, setUsers] = (0, $eF4cA.useState)({});
    (0, $eF4cA.useEffect)(()=>{
        if (story?.createdBy) setUsers((prevUsers)=>({
                ...prevUsers,
                [story.createdBy]: {
                    email: story.createdBy
                }
            }));
    }, [
        story?.createdBy
    ]);
    const usersList = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        async load ({ signal: signal, filterText: filterText }) {
            try {
                const response = await (0, $37c4445ec21c8c5e$export$b0b3f4ef5d856594)(filterText, {}, {
                    signal: signal
                });
                console.log("Response from suggest:", response);
                if (response.ok) return {
                    items: response?.data?._embedded?.suggestions?.filter((user)=>selectedUsers.findIndex((selected)=>selected.caption === user.caption) === -1 && Object.values(users).findIndex((u)=>u.caption === user.caption) === -1)
                };
            } catch (error) {
                console.error("Error loading user suggestions:", error);
            }
            return {
                items: []
            };
        },
        getKey: (item)=>item.token
    });
    const [selectedUsers, setSelectedUsers] = (0, $eF4cA.useState)([]);
    const shareStory = (0, $VXM1R.useShareStory)(story.id);
    const unshareStory = (0, $VXM1R.useUnshareStory)(story.id);
    const [isSharePending, startShareTransition] = (0, $eF4cA.useTransition)();
    const handleSelectionClear = (0, $eF4cA.useCallback)(()=>{
        setSelectedUsers([]);
        usersList.setFilterText("");
        usersList.setSelectedKeys(new Set());
    }, [
        usersList
    ]);
    const handleShare = (0, $eF4cA.useCallback)(()=>{
        // Handle sharing the story via email
        startShareTransition(async ()=>{
            try {
                const accepted = await (0, $37c4445ec21c8c5e$export$73f57eecff448cc8)(selectedUsers.map((user)=>user.token));
                const emails = accepted?.data?._embedded?.successes?.map((success)=>success.email);
                await shareStory.mutateAsync({
                    email: emails
                });
                handleSelectionClear();
            } catch (error) {
                console.error("Error accepting user invitations:", error);
            }
        });
    }, [
        selectedUsers,
        story.id,
        handleSelectionClear
    ]);
    const handleUnshare = (email)=>{
        // Handle unsharing the story via email
        unshareStory.mutate({
            email: email
        });
    };
    const handleSelectionChange = (0, $eF4cA.useCallback)((selectedKey)=>{
        const selectedPerson = usersList.getItem(selectedKey);
        if (!selectedPerson) return;
        (0, $eF4cA.startTransition)(()=>{
            setSelectedUsers((prev)=>[
                    ...new Set(prev).add(selectedPerson)
                ]);
            usersList.setFilterText("");
            usersList.setSelectedKeys(new Set());
        });
    }, [
        usersList
    ]);
    (0, $eF4cA.useEffect)(()=>{
        const controller = new AbortController();
        const signal = controller.signal;
        const emails = [
            ...new Set([
                story?.createdBy,
                ...story?.sharedWith || []
            ].filter(Boolean))
        ];
        if (emails.length) (0, $eF4cA.startTransition)(async ()=>{
            try {
                const people = await (0, $37c4445ec21c8c5e$export$b9c97d5330cbe844)(emails, {
                    signal: signal
                });
                const usersMap = people.filter(Boolean).reduce((acc, person)=>{
                    acc[person.email] = person;
                    return acc;
                }, {});
                setUsers((prevUsers)=>({
                        ...prevUsers,
                        ...usersMap
                    }));
            } catch (error) {
                console.error("Error fetching people:", error);
            }
        });
        return ()=>{
            controller.abort();
        };
    }, [
        story?.createdBy,
        story?.sharedWith
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        isDismissible: true,
        isDisabled: isSharePending,
        styles: " ZILqIYb182",
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182",
                        children: !!selectedUsers.length ? /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 eb182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    "aria-label": "Cancel selection",
                                    isQuiet: true,
                                    onPress: handleSelectionClear,
                                    styles: " Ih182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8829c44c80cd9620$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Invite people"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Share story"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        styles: " sd182 _ta182 Ur182 qr182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBox), {
                                    label: "Add people",
                                    items: usersList.items,
                                    inputValue: usersList.filterText,
                                    onInputChange: usersList.setFilterText,
                                    selectedKeys: null,
                                    onSelectionChange: handleSelectionChange,
                                    loadingState: usersList.loadingState,
                                    autoComplete: "off",
                                    styles: " GG182",
                                    children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aVEhH.ComboBoxItem), {
                                            id: item.token,
                                            textValue: item.title,
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                                                    slot: "avatar",
                                                    src: item?._links?.thumbnail?.href,
                                                    alt: item?.title
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    slot: "label",
                                                    children: item?.title
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    slot: "description",
                                                    children: item?.email ?? item?.caption
                                                })
                                            ]
                                        })
                                }),
                                !!selectedUsers.length && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            className: $ec29ab645ba71613$var$listStyle,
                                            children: selectedUsers.filter(Boolean).map((user, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)($ec29ab645ba71613$var$UserListItem, {
                                                    user: user,
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                        "aria-label": "Remove user",
                                                        isQuiet: true,
                                                        isDisabled: isSharePending,
                                                        onPress: ()=>{
                                                            setSelectedUsers((prev)=>prev.filter((u)=>u?.token !== user.token));
                                                        },
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {})
                                                    })
                                                }, user.token ?? index))
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            className: " sd182 Ue182 qe182 JI182",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                                isDisabled: isSharePending,
                                                styles: " IM182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                        variant: "secondary",
                                                        onPress: handleSelectionClear,
                                                        children: "Cancel"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                        variant: "accent",
                                                        onPress: handleShare,
                                                        children: "Invite to edit"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                !selectedUsers.length && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " JG182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            className: " Gx182",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                                children: "Who has access"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: $ec29ab645ba71613$var$listStyle,
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)($ec29ab645ba71613$var$UserListItem, {
                                                    user: users[story.createdBy],
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                        className: " pn182",
                                                        children: ims?.profile?.email === story?.createdBy ? " (You)" : " (Owner)"
                                                    })
                                                }),
                                                story?.sharedWith?.map((userEmail, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)($ec29ab645ba71613$var$UserListItem, {
                                                        user: users[userEmail],
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                            "aria-label": "Remove user",
                                                            isQuiet: true,
                                                            onPress: ()=>handleUnshare(userEmail),
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {})
                                                        })
                                                    }, index))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};
$ec29ab645ba71613$export$704f41f51e589a1.propTypes = {
    story: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $4UbTp = parcelRequire("4UbTp");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");
var $7Vvqh = parcelRequire("7Vvqh");
var $8g9SZ = parcelRequire("8g9SZ");
var $fZShI = parcelRequire("fZShI");
var $91SAk = parcelRequire("91SAk");

var $cg9Gh = parcelRequire("cg9Gh");


var $5IZkx = parcelRequire("5IZkx");

var $dYPl9 = parcelRequire("dYPl9");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fmJ8d = parcelRequire("fmJ8d");

var $VXM1R = parcelRequire("VXM1R");

var $D7J7L = parcelRequire("D7J7L");

var $edFAP = parcelRequire("edFAP");

const $65266e976b2756c2$var$fetchDirectory = async (directory, imageReference)=>{
    try {
        const { urls: urls } = await (0, $D7J7L.batchPresignURLs)(directory);
        const currentImageReference = imageReference;
        return {
            items: urls.map((url)=>({
                    name: url.filePath.split("/").slice(-1)[0],
                    filePath: url.filePath,
                    url: url.presignURL,
                    internalUrl: url.internalURL
                })),
            selectedKeys: new Set(currentImageReference ? [
                currentImageReference?.filePath
            ] : [])
        };
    } catch (error) {
        console.error("Failed to load styles:", error);
        return {
            items: [],
            selectedKeys: new Set()
        };
    }
};
const $65266e976b2756c2$var$fetchBrandStyles = async (brand)=>{
    if (!brand?.libraryId) return [];
    try {
        const data = await (0, $dYPl9.getElements)({
            libraryId: brand.libraryId
        });
        return {
            items: data?.elements.map((element)=>({
                    name: element.name,
                    filePath: element?.thumbnail?.componentId,
                    url: (0, $8Ogg5.getPresignedImageUrlFromTemplatedLink)(element?.thumbnail?.templatedLink, element?.thumbnail?.componentId)
                })),
            selectedKeys: new Set([])
        };
    } catch (error) {
        console.error("Failed to fetch brand elements:", error);
        return [];
    }
};
const $65266e976b2756c2$var$ThumbnailList = ({ onImageSelect: onImageSelect, isUploading: isUploading, ...props })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cg9Gh.ListBox), {
        ...props,
        className: " ZJ182 se182 DpwD1Pb182 Ul182 ql182 La182",
        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxItem), {
                id: item.filePath,
                textValue: item.name,
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' fbvNfn182';
                    rules += ' oc182';
                    rules += ' nc182';
                    rules += ' kc182';
                    rules += ' jc182';
                    rules += ' _Nc182';
                    rules += ' Pc182';
                    if (props.isSelected) rules += ' O95Jo1182';
                    else if (props.isFocused) rules += ' OaeNnJ182';
                    else if (props.isHovered) rules += ' OcIrCFb182';
                    else rules += ' Oj182';
                    rules += ' _Kd182';
                    rules += ' _Lf182';
                    rules += ' _Mc182';
                    rules += ' Yg182';
                    rules += ' Xb182';
                    rules += ' _2b182';
                    rules += ' _8d182';
                    if (props.isPressed) rules += ' _Z6Lx70c182';
                    else rules += ' _Zh3TDrc182';
                    return rules;
                },
                children: item.name !== "NEW" ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                    src: item.url,
                    alt: item.name,
                    styles: " Za182 Fb182 _Hb182"
                }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                    acceptedFileTypes: "image/*",
                    onSelect: onImageSelect,
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        isDisabled: isUploading,
                        UNSAFE_className: " Za182 Fb182 sd182 _ta182 eb182 _Ca182 Ug182 qg182 Tf182 Qf182 Sf182 Rf182 ry182",
                        children: [
                            !isUploading ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c5c5c929122049b7$export$2e2bcd8739ae039), {
                                styles: " ZF182 Fz182"
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                isIndeterminate: true,
                                size: "L",
                                staticColor: "auto",
                                styles: " _dc182"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _Wa182",
                                children: !isUploading ? "Drag and drop or click to select" : "Uploading..."
                            })
                        ]
                    })
                })
            })
    });
};
const $65266e976b2756c2$export$647ee0aa075b90b8 = ({ storyId: storyId, onPrimaryAction: onPrimaryAction })=>{
    const [isUploading, startUploading] = (0, $eF4cA.useTransition)();
    const email = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.ims?.profile?.email);
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const isBrandSelected = (0, $eF4cA.useMemo)(()=>{
        return story?.brand?.libraryId;
    }, [
        story
    ]);
    const recommendedList = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        getKey: (item)=>item.filePath,
        async load () {
            return $65266e976b2756c2$var$fetchDirectory("/referenceStyle/", storyId);
        }
    });
    const userList = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        getKey: (item)=>item.filePath,
        async load () {
            try {
                const { items: items, selectedKeys: selectedKeys } = await $65266e976b2756c2$var$fetchDirectory(`/${email.split("@")[0]}/referenceStyle/`, storyId);
                items.push({
                    name: "NEW",
                    filePath: "NEW",
                    url: "",
                    internalURL: ""
                });
                return {
                    items: items,
                    selectedKeys: selectedKeys
                };
            } catch (error) {
                console.error("Failed to load user styles:", error);
                return {
                    items: [
                        {
                            name: "NEW",
                            filePath: "NEW",
                            url: "",
                            internalURL: ""
                        }
                    ],
                    selectedKeys: new Set()
                };
            }
        }
    });
    const brandsList = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        getKey: (item)=>item.filePath,
        async load () {
            try {
                const { items: items, selectedKeys: selectedKeys } = await $65266e976b2756c2$var$fetchBrandStyles(story?.brand);
                console.log("Brand styles:", items, story?.brand);
                return {
                    items: items,
                    selectedKeys: selectedKeys
                };
            } catch (error) {
                console.error("Failed to load brand styles:", error);
                return {
                    items: [],
                    selectedKeys: new Set()
                };
            }
        }
    });
    const isLoading = recommendedList.isLoading || userList.isLoading || brandsList.isLoading;
    const setImageReference = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setImageReference);
    const handleSelectionChange = (selectedKeys, list)=>{
        recommendedList.setSelectedKeys(new Set());
        userList.setSelectedKeys(new Set());
        brandsList.setSelectedKeys(new Set());
        list.setSelectedKeys(selectedKeys);
        const imageReference = list.getItem(selectedKeys.currentKey);
        setImageReference(storyId, imageReference ?? null);
    };
    const handleImageSelect = (0, $eF4cA.useCallback)((files)=>{
        if (files.length > 0) startUploading(async ()=>{
            const [file] = files;
            const filePath = `${email.split("@")[0]}/referenceStyle/${file.name}`;
            try {
                const response = await (0, $D7J7L.uploadFileByBlob)(filePath, file);
                if (response?.presignURL) {
                    // Create a new image reference object
                    const newImageReference = {
                        name: file.name,
                        filePath: filePath,
                        url: response.presignURL,
                        internalUrl: response.presignURL
                    };
                    // Insert the new item before the placeholder item where item.name === 'NEW'
                    const placeholderIndex = userList.items.findIndex((item)=>item.name === "NEW" || item.filePath === "NEW");
                    if (placeholderIndex >= 0) userList.insert(placeholderIndex, newImageReference);
                    else userList.append(newImageReference);
                    // Set it as the selected image reference
                    setImageReference(storyId, newImageReference);
                    // Select the new item
                    userList.setSelectedKeys(new Set([
                        filePath
                    ]));
                    // Clear other selections
                    recommendedList.setSelectedKeys(new Set());
                    brandsList.setSelectedKeys(new Set());
                }
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        });
    }, [
        storyId,
        email,
        userList,
        setImageReference,
        startUploading,
        recommendedList,
        brandsList
    ]);
    const renderEmptyState = (isLoading, children)=>{
        if (isLoading) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
            children: new Array(3).fill(null).map((_, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                    isLoading: true,
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        alt: "Loading style",
                        className: " fbvNfn182 oc182 nc182 kc182 jc182 _Nc182 Pc182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                            styles: " Za182 Fb182 _Hb182"
                        })
                    })
                }, index))
        });
        return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: " fbvNfn182 sd182 eb182 _Ca182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
            children: children || "No styles found"
        });
    };
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        isDismissable: true,
        styles: " Lc182 Za182 ZnvuBnEc182",
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " Za182 Fb182 se182 CiIfZo182 E7ABCf182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Select style"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 _ta182 Ul182 ql182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("h2", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Recommended"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($65266e976b2756c2$var$ThumbnailList, {
                                            "aria-label": "Select generated images visual style",
                                            items: recommendedList.items,
                                            selectionMode: "single",
                                            selectedKeys: recommendedList.selectedKeys,
                                            onSelectionChange: (keys)=>handleSelectionChange(keys, recommendedList),
                                            layout: "grid",
                                            renderEmptyState: ()=>renderEmptyState(recommendedList.isLoading)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("h2", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Brand styles"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($65266e976b2756c2$var$ThumbnailList, {
                                            "aria-label": "Select generated images visual style",
                                            items: brandsList.items,
                                            selectionMode: "single",
                                            selectedKeys: brandsList.selectedKeys,
                                            onSelectionChange: (keys)=>handleSelectionChange(keys, brandsList),
                                            layout: "grid",
                                            renderEmptyState: ()=>renderEmptyState(brandsList.isLoading, isBrandSelected ? null : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "No brand selected"
                                                }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("h2", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Your styles"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($65266e976b2756c2$var$ThumbnailList, {
                                            "aria-label": "Select generated images visual style",
                                            items: userList.items,
                                            selectionMode: "single",
                                            selectedKeys: userList.selectedKeys,
                                            onSelectionChange: (keys)=>handleSelectionChange(keys, userList),
                                            layout: "grid",
                                            renderEmptyState: ()=>renderEmptyState(userList.isLoading),
                                            onImageSelect: handleImageSelect,
                                            isUploading: isUploading
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                        styles: " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                        styles: " zmlKpq182 ymlKpq182 BmlKpq182 AmlKpq182 __Ac182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                            variant: "genai",
                            isDisabled: recommendedList.isLoading,
                            onPress: ()=>{
                                onPrimaryAction?.();
                                close();
                            },
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Generate images"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $f16Ml = parcelRequire("f16Ml");
var $4UbTp = parcelRequire("4UbTp");
var $88lL9 = parcelRequire("88lL9");
var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");
var $bTZtY = parcelRequire("bTZtY");
var $208Op = parcelRequire("208Op");



var $VXM1R = parcelRequire("VXM1R");

const $7f01d187ef6dba4b$var$detailStyles = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182 Jy182";
const $7f01d187ef6dba4b$export$aea39c4c1cfc661e = ({ storyId: storyId })=>{
    const [currentSlideIndex, setCurrentSlideIndex] = (0, $eF4cA.useState)(0);
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const slides = story?.script || [];
    const currentSlide = slides[currentSlideIndex];
    const currentPersonas = currentSlide?.personas?.map((idx)=>story.personas[idx]) ?? [];
    // Get the visual URL for the current slide
    const currentVisual = currentSlide?.visuals?.[currentSlide.visual || 0];
    const visualUrl = (0, $782edebb76e7c4bc$export$2427d38ef09c0c42)(currentVisual);
    const hasPreviousSlide = currentSlideIndex > 0;
    const hasNextSlide = currentSlideIndex < slides.length - 1;
    const goToPreviousSlide = ()=>{
        if (hasPreviousSlide) setCurrentSlideIndex(currentSlideIndex - 1);
    };
    const goToNextSlide = ()=>{
        if (hasNextSlide) setCurrentSlideIndex(currentSlideIndex + 1);
    };
    // Reset to first slide when story changes
    (0, $eF4cA.useEffect)(()=>{
        setCurrentSlideIndex(0);
    }, [
        storyId
    ]);
    // Handle keyboard navigation
    (0, $eF4cA.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            switch(event.key){
                case "ArrowLeft":
                    event.preventDefault();
                    goToPreviousSlide();
                    break;
                case "ArrowRight":
                    event.preventDefault();
                    goToNextSlide();
                    break;
                case "Escape":
                    break;
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        currentSlideIndex,
        hasPreviousSlide,
        hasNextSlide
    ]);
    if (!story) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        padding: "none",
        styles: " _9G1Ky182",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: " Tk182 Qk182 Sk182 Rk182 _Wa182",
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                isLoading: true,
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: "Loading story..."
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        padding: "none",
        styles: " _9G1Ky182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: " sd182 _ta182 Za182 Fb182 _Pc182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 eb182 Sf182 Rq182 Te182 Qe182 ir182 gH182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " _ub182 _vb182 _sa182 sd182 eb182 Ul182 ql182 Rq182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                children: story.title
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 Ug182 qg182 eb182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    isQuiet: true,
                                    isDisabled: !hasPreviousSlide,
                                    onPress: goToPreviousSlide,
                                    "aria-label": "Previous slide",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8829c44c80cd9620$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 eb182 Ua182 qa182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: currentSlideIndex + 1
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " pn182",
                                            children: "/"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: slides.length
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    isQuiet: true,
                                    isDisabled: !hasNextSlide,
                                    onPress: goToNextSlide,
                                    "aria-label": "Next slide",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $79846ac3e4f71e5a$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " _ub182 _vb182 _sa182"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 _ta182 _tnc182 _ub182 _Nc182 Pc182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " gH182 Za182 Fb182",
                            children: currentSlide?.visuals?.length > 0 ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                src: visualUrl,
                                alt: currentSlide.title,
                                styles: " fIDBNkb182 _Ha182 _4c182 _Ob182 _N40ub4c182 P40ub4c182"
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " Za182 fIDBNkb182"
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " Th182 Tnk182 Qh182 Qnk182 Sh182 Snk182 Rh182 Rnk182 sd182 _ta182 _sd182 _snft0rSc182 _va182 Uj182 Pa182",
                            children: currentSlide && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: currentSlide.section
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " Gx182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 _Fd182 _FnuYUweb182 po182",
                                            children: currentSlide.title
                                        })
                                    }),
                                    currentSlide.description && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " GC182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                            children: currentSlide.description
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7e182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: currentSlide.text
                                        })
                                    }),
                                    currentPersonas?.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " sd182 _ta182 Ue182 qe182 JG182",
                                        children: currentPersonas.map((persona, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: function anonymous(props) {
                                                    let rules = " ";
                                                    rules += ' sd182';
                                                    rules += ' eb182';
                                                    rules += ' Ug182';
                                                    rules += ' qg182';
                                                    if (props.isFirst) rules += ' Jy182';
                                                    else rules += ' Jc182';
                                                    return rules;
                                                }({
                                                    isFirst: idx === 0
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                                                        size: 32,
                                                        alt: persona?.name,
                                                        src: persona?.avatarUrl ?? "https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png",
                                                        isOverBackground: true,
                                                        styles: " _kc182 hc182 mc182 lc182"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        styles: $7f01d187ef6dba4b$var$detailStyles,
                                                        children: persona?.name
                                                    })
                                                ]
                                            }, `${persona.id}-${idx}`))
                                    }),
                                    !!currentSlide?.solutions?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.TagGroup), {
                                        selectionMode: "none",
                                        size: "S",
                                        "aria-label": "Solutions",
                                        styles: " JC182",
                                        children: currentSlide.solutions.map((solution, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.Tag), {
                                                children: solution
                                            }, `${solution}-${idx}`))
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                    styles: " _Pa182 Wt182 _zt182"
                })
            ]
        })
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $4UbTp = parcelRequire("4UbTp");
var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");
var $8g9SZ = parcelRequire("8g9SZ");
var $hSW0F = parcelRequire("hSW0F");


var $bEes0 = parcelRequire("bEes0");

parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $dYPl9 = parcelRequire("dYPl9");
parcelRequire("fmJ8d");

var $VXM1R = parcelRequire("VXM1R");

var $8Ogg5 = parcelRequire("8Ogg5");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $aa39d55291e68d80$var$$10760c6e29b075ec$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M18.207 3.897c-.406-.094-.809.15-.906.554l-.38 1.575C15.523 3.594 12.919 2.02 10 2.02c-3.685 0-6.875 2.5-7.76 6.08-.099.403.147.81.55.909.4.1.808-.147.907-.55.718-2.907 3.31-4.939 6.303-4.939 2.517 0 4.735 1.447 5.809 3.633l-2.102-.508c-.404-.094-.808.15-.906.553s.15.808.553.905l3.245.785c.125.088.274.142.432.142q.09 0 .18-.021c.048-.012.086-.041.13-.061.069-.019.142-.02.205-.058.17-.104.29-.27.338-.464l.875-3.624c.097-.403-.15-.808-.552-.906M17.21 11.032c-.396-.096-.807.147-.907.55-.718 2.908-3.31 4.94-6.303 4.94-2.517 0-4.735-1.447-5.81-3.634l2.103.508c.403.092.809-.15.906-.553s-.15-.808-.553-.905l-3.255-.787c-.171-.118-.385-.171-.602-.119-.015.004-.026.015-.04.02-.104.013-.205.044-.295.1-.17.103-.29.27-.338.463l-.875 3.624c-.097.403.15.808.552.906q.09.02.177.02c.339 0 .646-.23.729-.574l.38-1.575c1.398 2.432 4.002 4.005 6.921 4.005 3.685 0 6.876-2.5 7.76-6.08.099-.403-.147-.81-.549-.909"
        })
    });
const $aa39d55291e68d80$var$$10760c6e29b075ec$var$ForwardRef = (0, $eF4cA.forwardRef)($aa39d55291e68d80$var$$10760c6e29b075ec$var$SvgComponent);
var $aa39d55291e68d80$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($aa39d55291e68d80$var$$10760c6e29b075ec$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $8014a5fd27a400eb$var$$c485df8edab68e91$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M39 41.614c0-4.244 3.454-7.698 7.698-7.698h66.778c4.244 0 7.698 3.454 7.698 7.698V88.33c0 2.209 1.791 4 4 4s4-1.791 4-4V41.614c0-8.662-7.035-15.698-15.698-15.698H46.698C38.036 25.916 31 32.952 31 41.614v48.383c0 27.097 22 49.087 49.087 49.087 2.555 0 5.068-.196 7.522-.575 2.184-.336 3.68-2.379 3.344-4.562s-2.379-3.681-4.562-3.344c-2.053.316-4.158.481-6.304.481-22.67 0-41.087-18.409-41.087-41.088zM96.457 61.56c-3.041-5.27-10.644-5.27-13.684 0l3.463 1.999-3.464-1.998-12.244 21.222c-3.035 5.263.749 11.848 6.838 11.848h24.508c6.089 0 9.873-6.585 6.838-11.847l-.001-.002-12.253-21.22-3.465 1.998zM77.544 86.63l12.071-20.922 12.081 20.922zm-9.29-23.036c1.913 1.105 2.568 3.551 1.463 5.464L56.1 92.64c-1.105 1.913-3.552 2.569-5.465 1.464s-2.568-3.552-1.463-5.465L62.79 65.058c1.105-1.913 3.55-2.569 5.464-1.464m49.663 82.24c13.577 0 24.584-11.007 24.584-24.584s-11.007-24.583-24.584-24.583-24.583 11.006-24.583 24.583 11.006 24.584 24.583 24.584M122.334 110c0-2.209-1.791-4-4-4s-4 1.791-4 4v7.667h-7.667c-2.209 0-4 1.791-4 4s1.791 4 4 4h7.667v7.667c0 2.209 1.791 4 4 4s4-1.791 4-4v-7.667H130c2.209 0 4-1.791 4-4s-1.791-4-4-4h-7.666z"
        })
    });
const $8014a5fd27a400eb$var$$c485df8edab68e91$var$ForwardRef = (0, $eF4cA.forwardRef)($8014a5fd27a400eb$var$$c485df8edab68e91$var$SvgComponent);
var $8014a5fd27a400eb$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($8014a5fd27a400eb$var$$c485df8edab68e91$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $bce1a5be3ff730cd$var$$6ed04292ee6215a0$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M23 24.968c0-2.767 2.251-5.019 5.019-5.019h40.067c2.767 0 5.019 2.252 5.019 5.02v28.029c0 1.104.895 2 2 2s2-.896 2-2v-28.03c0-4.977-4.043-9.019-9.02-9.019H28.02c-4.977 0-9.019 4.042-9.019 9.02v29.029C19 70.035 32.021 83.05 48.052 83.05q2.241-.002 4.394-.331c1.092-.166 1.843-1.186 1.677-2.278s-1.186-1.843-2.278-1.677c-1.236.188-2.502.286-3.793.286C34.23 79.05 23 67.826 23 53.998zm34.528 12.167c-1.671-2.896-5.848-2.895-7.518 0l1.732 1-1.732-1-7.347 12.734c-1.668 2.892.412 6.509 3.756 6.509h14.705c3.345 0 5.424-3.617 3.756-6.509zl-1.732 1zm-4.053 1.999c.13-.227.457-.227.588 0l7.352 12.734c.134.232-.033.51-.29.51H46.418c-.258 0-.425-.279-.291-.51zm-12.723-.632c.957.553 1.285 1.776.732 2.733l-8.171 14.149c-.552.956-1.776 1.284-2.732.731-.957-.552-1.284-1.775-.732-2.732l8.171-14.149c.553-.956 1.776-1.284 2.732-.732M70.75 87.5c8.146 0 14.75-6.603 14.75-14.75S78.896 58 70.75 58 56 64.604 56 72.75 62.604 87.5 70.75 87.5M73 66c0-1.104-.895-2-2-2s-2 .896-2 2v5h-5c-1.105 0-2 .896-2 2s.895 2 2 2h5v5c0 1.105.895 2 2 2s2-.895 2-2v-5h5c1.105 0 2-.895 2-2s-.895-2-2-2h-5z"
        })
    });
const $bce1a5be3ff730cd$var$$6ed04292ee6215a0$var$ForwardRef = (0, $eF4cA.forwardRef)($bce1a5be3ff730cd$var$$6ed04292ee6215a0$var$SvgComponent);
var $bce1a5be3ff730cd$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($bce1a5be3ff730cd$var$$6ed04292ee6215a0$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $08288126745d2f14$var$$2f67d04597446d8f$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M11.75 12.484c0-1.246 1.014-2.26 2.26-2.26h20.033c1.245 0 2.26 1.014 2.26 2.26V26.5c0 .69.559 1.25 1.25 1.25.69 0 1.25-.56 1.25-1.25V12.484c0-2.626-2.134-4.76-4.76-4.76H14.01c-2.627 0-4.76 2.134-4.76 4.76V27c0 8.157 6.623 14.776 14.776 14.776q1.032 0 2.03-.139c.683-.094 1.162-.725 1.067-1.409-.094-.683-.725-1.161-1.408-1.067q-.829.115-1.689.115c-6.773 0-12.276-5.5-12.276-12.276zm17.23 5.959c-.931-1.615-3.26-1.615-4.192 0l-3.673 6.367c-.93 1.612.23 3.63 2.095 3.63h7.352c1.865 0 3.025-2.018 2.095-3.63zm1.442 7.496-3.538-6.127-3.534 6.127zm-7.142.12-.07-.041-1.012-.584 1.012.584zm-2.778-7.024c.598.345.802 1.11.457 1.707l-4.085 7.075c-.346.598-1.11.802-1.708.457s-.803-1.11-.457-1.707l4.085-7.075c.345-.598 1.11-.803 1.708-.457M35.375 43.75c4.073 0 7.375-3.302 7.375-7.375S39.448 29 35.375 29 28 32.302 28 36.375s3.302 7.375 7.375 7.375M36.75 33c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v2.25H32c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h2.25V40c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-2.25H39c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25h-2.25z"
        })
    });
const $08288126745d2f14$var$$2f67d04597446d8f$var$ForwardRef = (0, $eF4cA.forwardRef)($08288126745d2f14$var$$2f67d04597446d8f$var$SvgComponent);
var $08288126745d2f14$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($08288126745d2f14$var$$2f67d04597446d8f$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1ebcedde9624ee72$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $8014a5fd27a400eb$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $08288126745d2f14$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $bce1a5be3ff730cd$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $6d2ebe90de78fe1e$var$BrandCard = ({ item: item })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
        id: item.id,
        textValue: item.name,
        className: " Mb182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                children: item.type === "swatches" ? /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " _oa182 gH182 Za182 Fb182 fbvNfn182 sd182 _tc182 eb182 _Ca182 Th182 Qh182 Sh182 Rh182",
                    children: item.swatches.map((swatch, index)=>{
                        const rgbColor = swatch?.[0]?.value ? `rgba(${swatch?.[0]?.value.r}, ${swatch?.[0]?.value.g}, ${swatch?.[0]?.value.b}, ${swatch?.[0]?.alpha || 1})` : "#000000";
                        return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            style: {
                                backgroundColor: rgbColor
                            },
                            className: " Za182 Fb182"
                        }, index);
                    })
                }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                    src: item.url,
                    alt: item.name,
                    styles: " _oa182 fbvNfn182 _Ha182 Th182 Qh182 Sh182 Rh182"
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    slot: "title",
                    children: item.name
                })
            })
        ]
    });
};
const $6d2ebe90de78fe1e$export$64cd8ae7fa6d7c63 = ({ storyId: storyId, onPrimaryAction: onPrimaryAction })=>{
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const updateStory = (0, $VXM1R.useUpdateStory)(storyId);
    const listData = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        getKey: (item)=>item.id,
        async load () {
            try {
                // { description, id, name, tags }
                const brands = await (0, $dYPl9.getBrands)();
                const urls = await Promise.all((brands ?? []).map(async (brand)=>{
                    // Find the primary logo element
                    const logoToUse = await (0, $8Ogg5.findPrimaryLogo)(brand);
                    const brandData = {
                        name: brand.name,
                        libraryId: brand["library_urn"],
                        id: brand.id,
                        url: logoToUse?.url,
                        swatches: logoToUse?.swatches,
                        type: logoToUse?.type
                    };
                    return brandData;
                }));
                urls.splice(0, 0, {
                    name: "/NEW",
                    id: "/NEW",
                    url: ""
                });
                return {
                    items: urls,
                    selectedKeys: new Set(story?.brand ? [
                        story?.brand?.id
                    ] : [])
                };
            } catch (error) {
                console.error("Failed to load styles:", error);
                return {
                    items: [],
                    selectedKeys: new Set()
                };
            }
        }
    });
    const handleSelectionChange = (selectedKeys)=>{
        if (selectedKeys.has("/NEW")) {
            window.open("https://new.express.adobe.com/brands", "_blank");
            return;
        }
        listData.setSelectedKeys(selectedKeys);
        const brandReference = listData.getItem(selectedKeys.currentKey);
        // Save brandReference to story
        if (storyId && brandReference) updateStory.mutate({
            brand: {
                libraryId: brandReference.libraryId,
                id: brandReference.id,
                name: brandReference.name
            }
        });
    };
    const renderCreateNewBrand = ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: " Za182 Fb182 fbvNfn182 sd182 _ta182 eb182 _Ca182 Ug182 qg182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1ebcedde9624ee72$export$2e2bcd8739ae039), {
                    styles: " ZF182 Fz182"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _Wa182",
                    children: [
                        "Create new brand in ",
                        /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            styles: " xd182 _xa182 xX0cczbc182 _xX0cczba182",
                            children: "Zoltar Demo Pilot"
                        })
                    ]
                })
            ]
        });
    const { pressProps: pressProps } = (0, $bEes0.usePress)({
        onPress: ()=>{
            handleSelectionChange(new Set([
                "/NEW"
            ]));
        }
    });
    const renderEmptyState = ()=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            ...pressProps,
            className: " ZcTxjid182 ry182",
            children: renderCreateNewBrand()
        });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        isDismissable: true,
        styles: " Lc182 Za182 ZnvuBnEc182",
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " Za182 Fb182 se182 CiIfZo182 E7ABCf182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Header), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 sd182 eb182 Ug182 qg182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Select brand"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                        "aria-label": "Refresh brands",
                                        onPress: listData.reload,
                                        isQuiet: true,
                                        isDisabled: listData.isLoading,
                                        size: "S",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                        children: "Refresh brands"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                        selectionMode: "single",
                        selectionStyle: "highlight",
                        selectedKeys: listData.selectedKeys,
                        onSelectionChange: handleSelectionChange,
                        loadingState: listData.loadingState,
                        renderEmptyState: renderEmptyState,
                        variant: "quiet",
                        styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 KNJavrc182 Pa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                items: listData.items,
                                children: (item)=>item.name !== "/NEW" ? /*#__PURE__*/ (0, $dx4lB.jsx)($6d2ebe90de78fe1e$var$BrandCard, {
                                        item: item
                                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                        id: item.id,
                                        textValue: item.name,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                            children: renderCreateNewBrand()
                                        })
                                    })
                            }),
                            listData.isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                                children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)($6d2ebe90de78fe1e$var$BrandCard, {
                                        item: {
                                            id: Math.random(),
                                            name: "Loading...",
                                            url: ""
                                        }
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                        styles: " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                        styles: " zmlKpq182 ymlKpq182 BmlKpq182 AmlKpq182 __Ac182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "accent",
                            isDisabled: listData.selectedKeys.size === 0,
                            onPress: ()=>{
                                onPrimaryAction?.();
                                close();
                            },
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Select brand"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};
$6d2ebe90de78fe1e$var$BrandCard.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
    }).isRequired
};
$6d2ebe90de78fe1e$export$64cd8ae7fa6d7c63.propTypes = {
    storyId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    onPrimaryAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};



var $klXmP = parcelRequire("klXmP");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $c9f1948eb7dc5ff9$var$$9933edba4a0a2d28$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2M3.5 9h3v3h-3zM8 9h8.5v3H8zM3.5 4.25c0-.413.336-.75.75-.75h11.5c.414 0 .75.337.75.75V7.5h-13zm0 11.5V13.5h3v3H4.25c-.414 0-.75-.337-.75-.75m13 0c0 .413-.336.75-.75.75H8v-3h8.5z"
        })
    });
const $c9f1948eb7dc5ff9$var$$9933edba4a0a2d28$var$ForwardRef = (0, $eF4cA.forwardRef)($c9f1948eb7dc5ff9$var$$9933edba4a0a2d28$var$SvgComponent);
var $c9f1948eb7dc5ff9$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($c9f1948eb7dc5ff9$var$$9933edba4a0a2d28$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a5d11c0b9ffc2ba4$var$$88ce3ae90ebb3bae$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M18 4.75c0-2.134-4.024-3.25-8-3.25S2 2.616 2 4.75c0 .067.015.13.023.196C2.017 4.985 2 5.02 2 5.06V15c0 2.062 4.147 3 8 3s8-.938 8-3V5.06c0-.04-.017-.075-.023-.114.008-.066.023-.129.023-.196m-1.5 5.245c-.092.415-2.228 1.505-6.5 1.505S3.59 10.41 3.5 10V6.724C5.03 7.567 7.524 8 10 8s4.97-.433 6.5-1.276zM10 3c4.289 0 6.5 1.227 6.5 1.75S14.289 6.5 10 6.5 3.5 5.273 3.5 4.75 5.711 3 10 3m0 13.5c-4.273 0-6.41-1.09-6.5-1.5v-3.154C5.052 12.63 7.583 13 10 13s4.948-.37 6.5-1.154v3.148c-.09.415-2.227 1.506-6.5 1.506"
        })
    });
const $a5d11c0b9ffc2ba4$var$$88ce3ae90ebb3bae$var$ForwardRef = (0, $eF4cA.forwardRef)($a5d11c0b9ffc2ba4$var$$88ce3ae90ebb3bae$var$SvgComponent);
var $a5d11c0b9ffc2ba4$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($a5d11c0b9ffc2ba4$var$$88ce3ae90ebb3bae$var$ForwardRef);



var $9f9st = parcelRequire("9f9st");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $2487b8aecf1c0f59$var$$b2967572f8ede8d5$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M17.022 6H5.978C4.887 6 4 6.848 4 7.89v7.22C4 16.152 4.887 17 5.978 17h11.044C18.113 17 19 16.152 19 15.11V7.89C19 6.848 18.113 6 17.022 6M5.978 7.5h11.044c.26 0 .478.179.478.39v5.734l-1.333-1.346c-.757-.763-2.076-.762-2.831 0l-1.024 1.036h-.11l-2.69-2.716c-.755-.764-2.075-.762-2.83 0L5.5 11.792V7.89c0-.211.219-.39.478-.39m0 8c-.26 0-.478-.179-.478-.39v-1.185l2.247-2.271c.189-.189.51-.19.7 0l2.689 2.715c.596.604 1.642.607 2.242 0l1.024-1.035c.188-.189.511-.19.699 0l2.11 2.132q-.087.033-.189.034z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M1.75 14c-.414 0-.75-.336-.75-.75V4.89C1 3.848 1.866 3 2.932 3H14.75c.414 0 .75.336.75.75s-.336.75-.75.75H2.932c-.239 0-.432.175-.432.39v8.36c0 .414-.336.75-.75.75"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 14.29,
                cy: 9.75,
                r: 1.1,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            })
        ]
    });
const $2487b8aecf1c0f59$var$$b2967572f8ede8d5$var$ForwardRef = (0, $eF4cA.forwardRef)($2487b8aecf1c0f59$var$$b2967572f8ede8d5$var$SvgComponent);
var $2487b8aecf1c0f59$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($2487b8aecf1c0f59$var$$b2967572f8ede8d5$var$ForwardRef);



var $i8elj = parcelRequire("i8elj");


var $2t0pV = parcelRequire("2t0pV");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $272b40111ddc7a0d$var$$22831087424eefa8$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m19.28 18.222-1.973-1.974c.436-.64.693-1.414.693-2.246 0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c.833 0 1.605-.257 2.246-.693l1.974 1.973c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06m-7.78-4.22c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5-2.5-1.121-2.5-2.5"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m16.34 5.28-3.62-3.62c-.418-.42-.998-.66-1.591-.66H5.25C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18H9c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H5.25c-.413 0-.75-.337-.75-.75V3.25c0-.413.337-.75.75-.75H10v3.25C10 6.99 11.01 8 12.25 8h3.25v.5c0 .414.336.75.75.75s.75-.336.75-.75V6.871c0-.592-.24-1.172-.66-1.59m-4.84.47V2.614c.055.032.113.06.158.106l3.622 3.62c.046.046.074.105.106.16H12.25c-.413 0-.75-.337-.75-.75"
            })
        ]
    });
const $272b40111ddc7a0d$var$$22831087424eefa8$var$ForwardRef = (0, $eF4cA.forwardRef)($272b40111ddc7a0d$var$$22831087424eefa8$var$SvgComponent);
var $272b40111ddc7a0d$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($272b40111ddc7a0d$var$$22831087424eefa8$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $3e0d074d1f629986$var$$2488fa4c0a52847b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10.007 19q-.126 0-.253-.004c-4.422-.25-7.818-3.902-7.753-8.311V3.25c0-1.24 1.01-2.25 2.25-2.25H15.75C16.99 1 18 2.01 18 3.25l-.003 7.99c-.066 2.14-.959 4.123-2.516 5.587C13.985 18.233 12.05 19 10.007 19M4.25 2.5c-.413 0-.75.337-.75.75v7.445c-.054 3.615 2.722 6.598 6.32 6.802 1.706.052 3.367-.573 4.632-1.763s1.991-2.8 2.044-4.537L16.5 11V3.25c0-.413-.337-.75-.75-.75z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M14.25 12h-5.5c-.265 0-.51-.14-.645-.367-.135-.228-.14-.51-.013-.742l2.75-5.04c.133-.24.385-.39.659-.39s.527.15.658.39l2.75 5.04c.126.232.121.514-.014.742s-.38.367-.645.367m-4.236-1.5h2.972l-1.485-2.724zM5.749 12c-.121 0-.244-.03-.358-.092-.364-.198-.497-.654-.3-1.017l1.982-3.63c.198-.363.654-.497 1.018-.298.363.198.497.654.299 1.017l-1.982 3.63c-.136.248-.393.39-.659.39"
            })
        ]
    });
const $3e0d074d1f629986$var$$2488fa4c0a52847b$var$ForwardRef = (0, $eF4cA.forwardRef)($3e0d074d1f629986$var$$2488fa4c0a52847b$var$SvgComponent);
var $3e0d074d1f629986$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($3e0d074d1f629986$var$$2488fa4c0a52847b$var$ForwardRef);



var $edFAP = parcelRequire("edFAP");
const $1d11fe5bb754c8d9$export$a0d49a98a48fd658 = ({ storyId: storyId })=>{
    if (!storyId) return null;
    const navigate = (0, $dqZbZ.useNavigate)();
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    const ims = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.ims);
    const storyQuery = (0, $VXM1R.useStory)(storyId);
    const story = storyQuery.data;
    const createStory = (0, $VXM1R.useCreateStory)();
    const generateImages = (0, $VXM1R.useGenerateImages)(storyId);
    const deleteStory = (0, $VXM1R.useDeleteStory)(storyId);
    // const isGenerating = useStore(store, (state) => state.isGenerating);
    const isPromptPersonasPending = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isPromptPersonasPending);
    const isPromptVisualsPending = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isPromptVisualsPending);
    const isGenerating = isPromptPersonasPending || isPromptVisualsPending;
    const hasVisuals = (0, $eF4cA.useMemo)(()=>!!story?.script?.some((s)=>!!s.visuals?.length), [
        story
    ]);
    console.log(storyId, {
        hasVisuals: hasVisuals,
        isGenerating: isGenerating,
        isPromptPersonasPending: isPromptPersonasPending,
        isPromptVisualsPending: isPromptVisualsPending
    });
    const generateStoryImages = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.generateStoryImages);
    const handleDeleteStory = ()=>{
        deleteStory.mutate({}, {
            onSuccess: ()=>{
                (0, $fmJ8d.store).getState().addToast(`Story deleted`, {
                    variant: "positive",
                    duration: 3000
                });
                navigate("/stories");
            }
        });
    };
    const isDuplicatePending = createStory.isPending;
    const handleDuplicateStory = ()=>{
        const { id: id, _id: _id, title: title, ...copy } = story;
        createStory.mutate({
            ...copy,
            id: self.crypto.randomUUID(),
            title: `${story.title} (Copy)`
        }, {
            onSuccess: (data)=>{
                (0, $fmJ8d.store).getState().addToast(`Story duplicated`, {
                    variant: "positive",
                    duration: 3000
                });
                navigate(`/stories/${data.id}`);
            }
        });
    };
    const handleGenerateSimilarStory = ()=>{
        (0, $fmJ8d.store).getState().loadWizardData(story.data, story.prompt, story.promptTemplate);
        (0, $fmJ8d.store).getState().setPromptMinimized(false);
        navigate("/");
    };
    const handleGenerateImages = ()=>{
        generateImages.mutate({
            forceGenerate: true
        });
    };
    const scriptColumns = (0, $eF4cA.useMemo)(()=>{
        if (!story?.script) return [];
        return [
            {
                id: "id",
                name: "No",
                allowsResizing: true,
                width: 80
            },
            {
                id: "section",
                name: "Section",
                allowsResizing: true
            },
            {
                id: "title",
                name: "Title",
                isRowHeader: true,
                showDivider: true,
                allowsResizing: true
            },
            {
                id: "text",
                name: "Paragraph Text",
                allowsResizing: true
            },
            {
                id: "visual",
                name: "Visual",
                allowsResizing: true
            },
            {
                id: "visualMessaging",
                name: "Messaging",
                allowsResizing: true
            },
            {
                id: "template",
                name: "Template",
                allowsResizing: true
            },
            {
                id: "personas",
                name: "Personas",
                allowsResizing: true
            },
            {
                id: "solutions",
                name: "Solutions",
                allowsResizing: true
            },
            {
                id: "comments",
                name: "Comments",
                allowsResizing: true
            }
        ];
    }, [
        story?.script
    ]);
    const personasColumns = (0, $eF4cA.useMemo)(()=>{
        if (!story?.personas) return [];
        return [
            {
                id: "id",
                name: "No",
                allowsResizing: true,
                width: 80
            },
            {
                id: "name",
                name: "Name",
                allowsResizing: true,
                isRowHeader: true,
                width: 120
            },
            {
                id: "role",
                name: "Role",
                allowsResizing: true
            },
            {
                id: "description",
                name: "Description",
                allowsResizing: true
            },
            {
                id: "location",
                name: "Location",
                allowsResizing: true
            },
            {
                id: "age",
                name: "Age",
                allowsResizing: true,
                width: 100
            }
        ];
    }, [
        story?.personas
    ]);
    const storyImages = (0, $eF4cA.useMemo)(()=>{
        if (!story?.script || !story?.personas) return [];
        const scriptImages = story?.script?.flatMap((item, idx)=>item?.visuals?.map((v)=>({
                    ...v,
                    name: `Script-${`${idx + 1}`.padStart(3, "0")}-${item?.title?.replace?.(/[^a-zA-Z0-9]/g, "-") ?? "_"}`
                })) ?? []);
        const personaImages = story?.personas?.flatMap((persona, idx)=>({
                url: persona?.avatarUrl,
                name: `Persona-${`${idx + 1}`.padStart(3, "0")}-${persona.name.replace(/[^a-zA-Z0-9]/g, "-")}`
            }));
        return [
            ...scriptImages,
            ...personaImages
        ];
    }, [
        story?.script,
        story?.personas
    ]);
    const handleStoryDownloadExcel = (0, $eF4cA.useCallback)(()=>{
        (0, $3ea562484f813133$export$614788f8f473dbf7)({
            story: {
                ...story,
                script: {
                    columns: scriptColumns,
                    items: story.script
                },
                personas: {
                    columns: personasColumns,
                    items: story.personas
                }
            },
            user: ims.profile
        });
    }, [
        ims,
        story,
        scriptColumns,
        personasColumns
    ]);
    const [isDownloadingImages, startDownloadingImagesTransition] = (0, $eF4cA.useTransition)();
    const handleStoryDownloadImages = (0, $eF4cA.useCallback)(()=>{
        startDownloadingImagesTransition(async ()=>{
            try {
                await (0, $9lDhw.downloadImages)(storyImages, `be-story-images-${story.customer}-${story.industry}-${Date.now()}`);
            } catch (error) {
                console.error("Error downloading images:", error);
            }
        });
    }, [
        storyImages,
        story
    ]);
    const handleStoryDownloadJSON = (0, $eF4cA.useCallback)(()=>{
        (0, $9lDhw.downloadFile)(JSON.stringify(story, null, 4), `be-story-${story.customer}-${story.industry}-${Date.now()}.json`, "application/json");
    }, [
        story
    ]);
    const handleStoryCopyOutline = (0, $eF4cA.useCallback)(()=>{
        (0, $eac26b4c0577e2d0$export$244fcd8734d6281c)(story).then(()=>{
            (0, $fmJ8d.store).getState().addToast("Outline copied to clipboard", {
                variant: "positive",
                duration: 5000,
                actionLabel: "Open Express",
                shouldCloseOnAction: true,
                onAction: ()=>{
                    window.open("https://new.express.adobe.com/home/tools/generative-presentation", "_blank");
                }
            });
            console.log("Outline copied to clipboard");
        }).catch((error)=>{
            console.error("Error copying story outline:", error);
            (0, $fmJ8d.store).getState().addToast("Error copying story outline", {
                variant: "negative",
                duration: 5000,
                actionLabel: "Retry",
                shouldCloseOnAction: true,
                onAction: ()=>{
                    handleStoryCopyOutline();
                }
            });
        });
    }, [
        story
    ]);
    const [isGeneratingPresentation, startGeneratingTransition] = (0, $eF4cA.useTransition)();
    const handleGenPresentation = (0, $eF4cA.useCallback)(()=>{
        startGeneratingTransition(async ()=>{
            try {
                const presentationData = await (0, $1e082e4b7b205f21$export$20192bcc5d40f1c3)({
                    ...story
                });
                console.log("Generating presentation with data:", presentationData);
                const responseData = await (0, $11367e19212b6f77$export$b44cc4411da85ae5)(presentationData, story.title);
                console.log("Presentation generated successfully:", responseData);
                // await new Promise((resolve) => setTimeout(resolve, 3000));
                // const presentationId =
                //   "urn:aaid:sc:EU:006a6f75-e76b-4cc0-a246-20bb2c3a0d67";
                const projectUrl = new URL(`https://new.express.adobe.com/id/${responseData.docUrl}`);
                projectUrl.searchParams.set("category", "brands");
                if (story?.brand?.name) projectUrl.searchParams.set("q", story.brand.name);
                // if (responseData?.docUrl) {
                (0, $fmJ8d.store).getState().addToast("Presentation created", {
                    variant: "positive",
                    duration: 20000,
                    actionLabel: "Open in Express",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        window.open(projectUrl, "_blank");
                    }
                });
            // } else {
            //   throw new Error("No docUrl in response data", {
            //     cause: responseData,
            //   });
            // }
            } catch (error) {
                console.error("Error generating presentation:", error);
                (0, $fmJ8d.store).getState().addToast("Error generating presentation", {
                    variant: "negative",
                    duration: 5000,
                    actionLabel: "Retry",
                    shouldCloseOnAction: true,
                    onAction: ()=>{
                        handleGenPresentation();
                    }
                });
            }
        });
    }, [
        story
    ]);
    const handleStoryCopyStructure = (0, $eF4cA.useCallback)(()=>{
        (0, $eF4cA.startTransition)(async ()=>{
            const presentationData = await (0, $1e082e4b7b205f21$export$20192bcc5d40f1c3)({
                ...story
            });
            console.log("Generating presentation with data:", presentationData);
            await (0, $4a26ab9efb3777da$export$e84ab21a5791681d)({
                plain: JSON.stringify(presentationData, null, 2)
            });
            (0, $fmJ8d.store).getState().addToast("Presentation data copied to clipboard", {
                variant: "positive",
                duration: 5000
            });
        });
    }, [
        story
    ]);
    // const handleWindowMessage = useCallback(
    //   (e) => {
    //     // console.log("window message:", e.data, e.source);
    //     if (e.data?.type === "DOCUMENT_LOADED") {
    //       console.log("!!!!!!!!!!!", "Express ready");
    //       handleGenPresentation();
    //     } else if (e.data?.type === "SUCCESSFUL_GENERATION") {
    //       console.log("!!!!!!!!!!!", "Presentation generated");
    //     }
    //   },
    //   [handleGenPresentation],
    // );
    // useEffect(() => {
    //   window.onmessage = handleWindowMessage;
    // }, [handleWindowMessage]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 eb182 Ul182 ql182 St182 Rt182 Te182 Qe182 IM182 oc182 nc182 kc182 jc182 g_g182 _oa182 _Lf182 Of182 _Mb182 _Ka182 _nLeasBb182 _Pe182 Wu182 _Ru182 _9c182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                        variant: hasVisuals && !isGenerating ? "genai" : "secondary",
                        isDisabled: isGeneratingPresentation,
                        onPress: handleGenPresentation,
                        children: [
                            isGeneratingPresentation ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                isIndeterminate: true,
                                size: "S",
                                staticColor: "auto",
                                styles: " _dc182 Ib182"
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Create presentation"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                        orientation: "vertical"
                    }),
                    !hasVisuals && !isGenerating && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isDisabled: isGenerating,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Generate images"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $65266e976b2756c2$export$647ee0aa075b90b8), {
                                storyId: storyId,
                                onPrimaryAction: handleGenerateImages
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isDisabled: isGenerating,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3e0d074d1f629986$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Select brand"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $6d2ebe90de78fe1e$export$64cd8ae7fa6d7c63), {
                                storyId: storyId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isDisabled: isGenerating,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $272b40111ddc7a0d$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Preview"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7f01d187ef6dba4b$export$aea39c4c1cfc661e), {
                                storyId: storyId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                orientation: "vertical"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                styles: " IM182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        isQuiet: true,
                        isDisabled: isDownloadingImages,
                        children: [
                            isDownloadingImages ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                isIndeterminate: true,
                                size: "S",
                                staticColor: "auto",
                                styles: " _dc182 Ib182"
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Download"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.Menu), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                onPress: handleStoryDownloadExcel,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c9f1948eb7dc5ff9$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "as Excel file"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                onPress: handleStoryDownloadJSON,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a5d11c0b9ffc2ba4$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "as JSON"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                isDisabled: !hasVisuals,
                                onPress: handleStoryDownloadImages,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2487b8aecf1c0f59$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "All Images"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        slot: "description",
                                        children: "ZIP file with all images"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                onPress: handleStoryCopyOutline,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Copy Outline"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                        slot: "description",
                                        children: [
                                            "Copy outline to clipboard",
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                            "to use in Adobe Express"
                                        ]
                                    })
                                ]
                            }),
                            isDevMode && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                onPress: handleStoryCopyStructure,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Copy Presentation data"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        slot: "description",
                                        children: "Copy presentation data to clipboard"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                        "aria-label": "More options",
                        isQuiet: true,
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2t0pV.default), {})
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                        hideArrow: true,
                        placement: "bottom end",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 _ta182 Ua182 qa182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                            isQuiet: true,
                                            UNSAFE_style: {
                                                justifyContent: "start"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d17b0246a3955b22$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Share"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ec29ab645ba71613$export$704f41f51e589a1), {
                                            story: story
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                    isQuiet: true,
                                    isDisabled: isDuplicatePending,
                                    onPress: handleDuplicateStory,
                                    UNSAFE_style: {
                                        justifyContent: "start"
                                    },
                                    children: [
                                        isDuplicatePending ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                            isIndeterminate: true,
                                            size: "S",
                                            staticColor: "auto",
                                            styles: " _dc182 Ib182"
                                        }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {}),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Duplicate"
                                        })
                                    ]
                                }),
                                !!story?.promptTemplate && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                    isQuiet: true,
                                    UNSAFE_style: {
                                        justifyContent: "start"
                                    },
                                    onPress: handleGenerateSimilarStory,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fa92467499c79969$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Generate similar"
                                        })
                                    ]
                                }),
                                hasVisuals && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                            isQuiet: true,
                                            isDisabled: isGenerating,
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Re-generate images"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $65266e976b2756c2$export$647ee0aa075b90b8), {
                                            storyId: storyId,
                                            onPrimaryAction: handleGenerateImages
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                            isQuiet: true,
                                            isDisabled: deleteStory.isPending,
                                            UNSAFE_className: " pq182",
                                            UNSAFE_style: {
                                                justifyContent: "start"
                                            },
                                            children: [
                                                deleteStory.isPending ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                    isIndeterminate: true,
                                                    size: "S",
                                                    staticColor: "auto",
                                                    styles: " _dc182 Ib182"
                                                }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Delete story"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5NHyX.AlertDialog), {
                                            title: "Delete Story",
                                            variant: "destructive",
                                            primaryActionLabel: "Delete",
                                            cancelLabel: "Cancel",
                                            onPrimaryAction: handleDeleteStory,
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                children: [
                                                    "Are you sure you want to delete ",
                                                    story?.title ?? "this",
                                                    " ",
                                                    "story?"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
$1d11fe5bb754c8d9$export$a0d49a98a48fd658.propTypes = {
    storyId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



var $dx4lB = parcelRequire("dx4lB");

var $f16Ml = parcelRequire("f16Ml");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $4UbTp = parcelRequire("4UbTp");
var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $5mvex = parcelRequire("5mvex");
var $88lL9 = parcelRequire("88lL9");
var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");


var $7ClmI = parcelRequire("7ClmI");

var $9eyCh = parcelRequire("9eyCh");

var $8Ogg5 = parcelRequire("8Ogg5");

var $1WYFS = parcelRequire("1WYFS");
var $4kcQz = parcelRequire("4kcQz");

parcelRequire("fmJ8d");

var $8Ogg5 = parcelRequire("8Ogg5");

var $dYPl9 = parcelRequire("dYPl9");
parcelRequire("VXM1R");
const $1af3adc768376065$export$b057877b2954fb64 = (...keys)=>[
        "personas",
        ...keys
    ];
const $1af3adc768376065$export$288bb1936ddf2fdb = {
    all: [
        "personas"
    ],
    lists: ()=>[
            ...$1af3adc768376065$export$288bb1936ddf2fdb.all,
            "list"
        ],
    list: (filters)=>[
            ...$1af3adc768376065$export$288bb1936ddf2fdb.lists(),
            {
                filters: filters
            }
        ],
    details: ()=>[
            ...$1af3adc768376065$export$288bb1936ddf2fdb.all,
            "detail"
        ],
    detail: (id)=>[
            ...$1af3adc768376065$export$288bb1936ddf2fdb.details(),
            id
        ]
};
const $1af3adc768376065$export$b6847d9c8d146b1a = (options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $1af3adc768376065$export$288bb1936ddf2fdb.lists(),
        queryFn: (0, $8Ogg5.importAllPersonas),
        staleTime: Infinity,
        meta: {
            errorMessage: "Failed to load personas. Please try again."
        },
        ...options
    });
const $1af3adc768376065$export$e2cd20273dee1f5 = (libraryId, options = {})=>(0, $1WYFS.queryOptions)({
        queryKey: $1af3adc768376065$export$288bb1936ddf2fdb.detail(libraryId),
        queryFn: ({ signal: signal })=>(0, $dYPl9.getElements)({
                libraryId: libraryId
            }, {
                signal: signal
            }),
        staleTime: Infinity,
        enabled: !!libraryId,
        ...options
    });
const $1af3adc768376065$export$c9a70943180e9e89 = (options = {})=>{
    return (0, $4kcQz.useQuery)($1af3adc768376065$export$b6847d9c8d146b1a(options));
};
const $1af3adc768376065$export$69a13a860ad0fe7f = (libraryId, options = {})=>{
    return (0, $4kcQz.useQuery)($1af3adc768376065$export$e2cd20273dee1f5(libraryId, options));
};



const $9d1b84921b16398a$var$PersonaCard = ({ item: item })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
        id: item.id,
        textValue: item.name,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CollectionCardPreview), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                src: item.url,
                                alt: item.name
                            }),
                            !item?.images?.length && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $91SAk.Skeleton), {
                                isLoading: true,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                        alt: "Loading ..."
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                        alt: "Loading ..."
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                        alt: "Loading ..."
                                    })
                                ]
                            }),
                            item?.images?.filter((img)=>!img.name.includes("isolated"))?.slice(0, 3)?.map((img)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                    src: img.url,
                                    alt: item.name
                                }, img.id))
                        ]
                    }),
                    !!item?.imagesCount && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $geNzB.Badge), {
                        variant: "neutral",
                        size: "XS",
                        fillStyle: "subtle",
                        styles: " _Pa182 _lI182 _zI182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2487b8aecf1c0f59$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: item?.imagesCount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                    slot: "title",
                    styles: " sd182 eb182 Ue182 qe182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                            src: item.url,
                            name: item.name,
                            size: 24
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sd182 ea182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                    children: [
                                        item.role,
                                        item.age
                                    ].join(", ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5mvex.ContextualHelp), {
                            variant: "info",
                            styles: " IM182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Iv182",
                                            children: [
                                                item.role,
                                                item.age
                                            ].join(", ")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: item.description
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
const $9d1b84921b16398a$export$dd241c14d6403e0d = ({ defaultSelectedKeys: defaultSelectedKeys, onPrimaryAction: onPrimaryAction })=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    const personasQuery = (0, $1af3adc768376065$export$c9a70943180e9e89)({
        experimental_prefetchInRender: true
    });
    const listData = (0, $5a57d6761ce6fb25$export$bc3384a35de93d66)({
        getKey: (item)=>item.id,
        async load () {
            try {
                const personaModules = await personasQuery.promise;
                // Fetch all avatar URLs in parallel
                const personasWithUrls = await Promise.all(personaModules.map(async (persona)=>{
                    let url;
                    try {
                        // Use getAvatarUrl which has proper fallback logic
                        url = await (0, $8Ogg5.getAvatarUrl)(persona);
                    } catch (error) {
                        console.warn(`Failed to get avatar URL for ${persona.name}:`, error);
                        // Fallback to default avatar
                        url = "https://mir-s3-cdn-cf.behance.net/project_modules/disp/690bc6105945313.5f84bfc9de488.png";
                    }
                    return {
                        ...persona,
                        url: url
                    };
                }));
                // Fetch persona images asynchronously (don't block initial load)
                for (const persona of personasWithUrls)queryClient.query((0, $1af3adc768376065$export$e2cd20273dee1f5)(persona.id)).then(async ({ elements: elements, total_count: total_count })=>{
                    // Fetch all image URLs in parallel
                    const imagesWithUrls = await Promise.all((elements || []).map(async (element)=>{
                        let imageUrl;
                        try {
                            // Use getVisualUrl with proper visual object structure
                            imageUrl = await (0, $8Ogg5.getVisualUrl)({
                                id: element?.thumbnail?.componentId,
                                libraryId: persona.libraryId || persona.id,
                                url: element?.url
                            });
                        } catch (error) {
                            console.warn(`Failed to get image URL for ${element?.name}:`, error);
                            // Fallback to default visual image
                            imageUrl = "https://react-spectrum.adobe.com/s2/preview.c3b340d3.png";
                        }
                        return {
                            id: element?.thumbnail?.componentId,
                            name: element?.name,
                            url: imageUrl
                        };
                    }));
                    const update = {
                        ...persona,
                        images: imagesWithUrls,
                        imagesCount: total_count
                    };
                    // console.log("updated persona", persona, update);
                    listData.update(persona.id, update);
                }).catch((error)=>{
                    console.error(`Failed to fetch images for ${persona.name}:`, error);
                });
                return {
                    items: personasWithUrls,
                    selectedKeys: new Set(defaultSelectedKeys)
                };
            } catch (error) {
                console.error("Failed to load personas", error);
                return {
                    items: [],
                    selectedKeys: new Set()
                };
            }
        }
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        isDismissable: true,
        styles: " Lc182 Za182 ZnvuBnEc182",
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " Za182 Fb182 se182 CiIfZo182 E7ABCf182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 sd182 eb182 Ug182 qg182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Select persona"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                        selectionMode: "single",
                        selectionStyle: "highlight",
                        selectedKeys: listData.selectedKeys,
                        onSelectionChange: listData.setSelectedKeys,
                        loadingState: listData.loadingState,
                        //   renderEmptyState={renderEmptyState}
                        variant: "quiet",
                        styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 KNJavrc182 Pa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                items: listData.items,
                                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)($9d1b84921b16398a$var$PersonaCard, {
                                        item: item
                                    })
                            }),
                            listData.isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                                children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)($9d1b84921b16398a$var$PersonaCard, {
                                        item: {
                                            id: Math.random(),
                                            name: "Loading...",
                                            url: ""
                                        }
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                        styles: " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                        styles: " zmlKpq182 ymlKpq182 BmlKpq182 AmlKpq182 __Ac182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "accent",
                            isDisabled: listData.selectedKeys.size === 0 || listData.selectedKeys.values().next().value === defaultSelectedKeys[0],
                            onPress: ()=>{
                                onPrimaryAction?.(listData.getItem(listData.selectedKeys.values().next().value));
                                close();
                            },
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Select persona"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};
$9d1b84921b16398a$var$PersonaCard.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        role: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        age: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        images: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
            name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
        })),
        imagesCount: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number
    }).isRequired
};
$9d1b84921b16398a$export$dd241c14d6403e0d.propTypes = {
    defaultSelectedKeys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
    onPrimaryAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};




var $15xG7 = parcelRequire("15xG7");





var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $4ff77f483f4760d8$var$$cffafdff8b5ed39e$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M6.75 18h-2.5C3.01 18 2 16.99 2 15.75v-2.5C2 12.01 3.01 11 4.25 11h2.5C7.99 11 9 12.01 9 13.25v2.5C9 16.99 7.99 18 6.75 18m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM6.75 9h-2.5C3.01 9 2 7.99 2 6.75v-2.5C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v2.5C9 7.99 7.99 9 6.75 9m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM15.75 18h-2.5C12.01 18 11 16.99 11 15.75v-2.5c0-1.24 1.01-2.25 2.25-2.25h2.5c1.24 0 2.25 1.01 2.25 2.25v2.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM15.75 9h-2.5C12.01 9 11 7.99 11 6.75v-2.5C11 3.01 12.01 2 13.25 2h2.5C16.99 2 18 3.01 18 4.25v2.5C18 7.99 16.99 9 15.75 9m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75z"
        })
    });
const $4ff77f483f4760d8$var$$cffafdff8b5ed39e$var$ForwardRef = (0, $eF4cA.forwardRef)($4ff77f483f4760d8$var$$cffafdff8b5ed39e$var$SvgComponent);
var $4ff77f483f4760d8$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($4ff77f483f4760d8$var$$cffafdff8b5ed39e$var$ForwardRef);



const $7e0d57b7600d409b$var$CONTAINER_WIDTH = 800;
const $7e0d57b7600d409b$var$CONTAINER_PADDING = 24;
// Helper component to render table visual cell with hook
const $7e0d57b7600d409b$var$VisualCell = ({ visuals: visuals })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $960302d7ec1d1257$export$7245a73350102308), {
        visuals: visuals,
        styles: " fIDBNkb182"
    });
};
$7e0d57b7600d409b$var$VisualCell.propTypes = {
    visual: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
    ]),
    alt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const $7e0d57b7600d409b$var$storyCardStyles = function anonymous(props) {
    let rules = " ";
    rules += ' Fd182';
    rules += ' _va182';
    if (props.isFirst) rules += ' IYaKf5c182';
    else rules += ' Iy182';
    if (props.isLast) rules += ' HYaKf5c182';
    else rules += ' Hy182';
    return rules;
};
const $7e0d57b7600d409b$export$d77e5bb2c63f80a6 = ()=>{
    const params = (0, $dqZbZ.useParams)();
    const navigate = (0, $dqZbZ.useNavigate)();
    (0, $eF4cA.useEffect)(()=>{
        if (!params?.id) // TODO: Add 404 page
        navigate("/stories");
    }, [
        navigate,
        params?.id
    ]);
    const storyQuery = (0, $VXM1R.useStory)(params.id, {
        enabled: params?.id !== "generate"
    });
    const story = storyQuery.data;
    const updateStory = (0, $VXM1R.useUpdateStory)(params.id);
    const storyGenerationStatus = (0, $kQhl7.useMutationState)({
        filters: {
            mutationKey: (0, $VXM1R.getStoriesKey)("generate")
        },
        select: (mutation)=>mutation.state.status
    });
    const isGenerating = params.id === "generate" || storyGenerationStatus[storyGenerationStatus.length - 1] === "pending";
    if (storyQuery.isError) {
        // TODO: Show error state
        console.error(storyQuery.error);
        navigate("/stories");
    }
    (0, $eF4cA.useEffect)(()=>{
        if (!storyQuery.isPending && !story) {
            debugger;
            // TODO: Try to fetch the story again and show a loading state
            // If still not found, redirect to 404
            console.warn(`Story with id ${params.id} not found`);
            // TODO: Add 404 page
            navigate("/stories");
        } else if (story?.title) // If story is found, set the title
        document.title = `BeStory | ${story?.title}`;
    }, [
        story,
        params.id,
        navigate
    ]);
    const isLoading = !storyQuery || !story && !!storyQuery.isFetching || isGenerating;
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Stories",
            href: "/stories"
        },
        {
            label: story?.title ?? "Story",
            href: `/stories/${params.id}`,
            isLoading: isLoading || !story?.title
        }
    ]);
    const personas = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.personas);
    const isPersonasLoaded = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isPersonasLoaded);
    const generateStoryImages = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.generateStoryImages);
    // Load personas when component mounts
    // useEffect(() => {
    //   if (!isPersonasLoaded) {
    //     console.log("Loading personas...");
    //     importAllPersonas();
    //   }
    // }, [importAllPersonas, isPersonasLoaded]);
    (0, $eF4cA.useEffect)(()=>{
        console.log("isPersonasLoaded:", isPersonasLoaded);
    }, [
        personas,
        isPersonasLoaded
    ]);
    const sections = (0, $eF4cA.useMemo)(()=>{
        if (!story?.script) return [];
        return story.script.reduce((acc, item, idx)=>{
            const itemWithIndex = {
                ...item,
                index: idx + 1
            };
            if (item.section !== story.script[idx - 1]?.section) acc.push([
                itemWithIndex
            ]);
            else acc[acc.length - 1].push(itemWithIndex);
            return acc;
        }, []);
    }, [
        story?.script
    ]);
    const [scriptView, setScriptView] = (0, $eF4cA.useState)("cards");
    const tableColumns = [
        {
            name: "Idx",
            id: "idx",
            isRowHeader: true,
            width: 50,
            align: "end"
        },
        {
            name: "Visual",
            id: "visual",
            width: 180
        },
        {
            name: "Section",
            id: "section",
            width: 180
        },
        {
            name: "Title",
            id: "title",
            width: 320
        },
        {
            name: "Paragraph Text",
            id: "text"
        },
        {
            name: "Personas",
            id: "personas",
            width: 180
        }
    ];
    const [isTitleEditable, setTitleEditable] = (0, $eF4cA.useState)(false);
    const [title, setTitle] = (0, $eF4cA.useState)(story?.title || "");
    (0, $eF4cA.useEffect)(()=>{
        setTitle(story?.title || "");
    }, [
        story?.title
    ]);
    const handleTitleUpdate = (newTitle)=>{
        if (newTitle.trim() !== story.title) updateStory.mutate({
            title: newTitle.trim()
        });
        setTitleEditable(false);
        setTitle(story?.title || "");
    };
    const handlePersonaUpdate = (persona, selectedImage)=>{
        updateStory.mutate({
            personas: story.personas.map((p)=>{
                return p.id === persona.id ? {
                    ...p,
                    libraryId: selectedImage.id,
                    avatarId: selectedImage.avatarId
                } : p;
            })
        });
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " Z46M4le182 Fy182 _ua182 _va182"
            }),
            !isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1d11fe5bb754c8d9$export$a0d49a98a48fd658), {
                storyId: story?.id
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' sd182';
                    rules += ' _ta182';
                    rules += ' eb182';
                    if (props.isGenerating) rules += ' _Ca182';
                    else rules += ' _Cg182';
                    rules += ' La182';
                    rules += ' Za182';
                    rules += ' Sh182';
                    rules += ' Rh182';
                    rules += ' _oa182';
                    return rules;
                }({
                    isGenerating: isGenerating
                }),
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $91SAk.Skeleton), {
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' ZEmhfb182';
                                rules += ' La182';
                                if (props.isGenerating) rules += ' JK182';
                                else {
                                    rules += ' JG182';
                                    rules += ' Jpy182';
                                }
                                return rules;
                            }({
                                isGenerating: isGenerating
                            }),
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 eb182 Ue182 qe182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Title"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                                            density: "compact",
                                            size: "XS",
                                            children: [
                                                !isTitleEditable && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                    isQuiet: true,
                                                    "aria-label": "Edit title",
                                                    onPress: ()=>setTitleEditable(true),
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                                                }),
                                                isTitleEditable && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                            "aria-label": "Save title",
                                                            onPress: ()=>handleTitleUpdate(title),
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $72df7913f6af7862$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                            "aria-label": "Cancel title edit",
                                                            onPress: ()=>{
                                                                setTitleEditable(false);
                                                                setTitle(story?.title || "");
                                                            },
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0ca39120f8ac8a03$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 GA182 _7e182",
                                    children: [
                                        !isTitleEditable && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: story?.title || "\u2013"
                                        }),
                                        isTitleEditable && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                            autoFocus: true,
                                            value: title,
                                            size: "L",
                                            isQuiet: true,
                                            onChange: setTitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Story overview"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 GA182 _7e182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: story?.storyOverview || "\u2013"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Customer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 GA182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: story?.customer
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 sf182",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                    children: [
                                                        "(",
                                                        story?.industry || "\u2013",
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Business goals"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 GA182 _7e182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: story?.businessGoals || "\u2013"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Campaign focus"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 GA182 _7e182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: story?.businessGoals || "\u2013"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182 ZEmhfb182 La182 IM182 HM182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Personas"
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " Za182 Mo182 sd182 Uj182 qj182 ed182 _wa182 _Na182 GA182 Tt182 Qt182",
                            children: [
                                isLoading && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.UserCard), {
                                    styles: $7e0d57b7600d409b$var$storyCardStyles({
                                        isFirst: true,
                                        isLast: true
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                                            src: null
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " sd182 Ue182 qe182",
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _7e182",
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 _ta182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "description",
                                                            children: "Role: "
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Age:"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Location:"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                story?.personas?.map((persona, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.UserCard), {
                                        variant: "primary",
                                        styles: $7e0d57b7600d409b$var$storyCardStyles({
                                            isFirst: idx === 0,
                                            isLast: idx === story.personas.length - 1
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2bffda9db2261f28$export$3cf67ed17f3a3c34), {
                                                        persona: persona
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                isQuiet: true,
                                                                "aria-label": "Change personas",
                                                                size: "XS",
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $950c2e77523108c3$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d1b84921b16398a$export$dd241c14d6403e0d), {
                                                                defaultSelectedKeys: [
                                                                    persona.libraryId
                                                                ],
                                                                onPrimaryAction: (selectedImage)=>handlePersonaUpdate(persona, selectedImage)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                        className: " sd182 Ue182 qe182",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "title",
                                                            children: persona.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _7e182",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            children: persona.description
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                    className: " sd182 _ta182",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            slot: "description",
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                slot: "description",
                                                                children: [
                                                                    "Role: ",
                                                                    persona.role
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                            slot: "description",
                                                            children: [
                                                                "Age: ",
                                                                persona.age ? `${persona.age} yo` : "\u2013"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                            slot: "description",
                                                            children: [
                                                                "Location: ",
                                                                persona.location || "\u2013"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, `${persona.name}-${idx}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182 ZEmhfb182 La182 IM182 HM182 sd182 Ul182 ql182 eb182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Script"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4836215752023500$export$668709c620d0b8e2), {
                                    selectedKey: scriptView,
                                    onSelectionChange: setScriptView,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                            id: "cards",
                                            "aria-label": "Cards View",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4ff77f483f4760d8$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                            id: "table",
                                            "aria-label": "Table View",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c9f1948eb7dc5ff9$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        scriptView === "table" && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " Za182 L6AC4Sb182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b3c27e869d856b7), {
                                density: "spacious",
                                overflowMode: "wrap",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f850895b287ef28e), {
                                        children: tableColumns.map((column)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$816b5d811295e6bc), {
                                                ...column,
                                                children: column.name
                                            }, column.id))
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$76ccd210b9029917), {
                                        children: story.script.map((item, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$b59bdbef9ce70de2), {
                                                children: tableColumns.map((column)=>{
                                                    switch(column.id){
                                                        case "idx":
                                                            return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                                                align: "end",
                                                                children: idx
                                                            }, column.id);
                                                        case "visual":
                                                            return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)($7e0d57b7600d409b$var$VisualCell, {
                                                                    visuals: item?.visuals
                                                                })
                                                            }, column.id);
                                                        case "personas":
                                                            return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                    className: " sd182 Ue182 qe182 _ta182",
                                                                    children: item?.personas?.map((personaIdx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                            className: " sd182 eb182 Ue182 qe182",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2bffda9db2261f28$export$3cf67ed17f3a3c34), {
                                                                                    persona: story?.personas?.[personaIdx]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                    children: story.personas[personaIdx].name
                                                                                })
                                                                            ]
                                                                        }, personaIdx))
                                                                })
                                                            }, column.id);
                                                        default:
                                                            return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                    className: " Tt182 Qt182",
                                                                    children: item?.[column.id]
                                                                })
                                                            }, column.id);
                                                    }
                                                })
                                            }, item.id))
                                    })
                                ]
                            })
                        }),
                        scriptView === "cards" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " Za182 sd182 Uj182 qj182 _ta182 ed182",
                            children: [
                                isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " Za182 sd182 Uj182 qj182 ed182 _wa182 _Na182 Tt182 Qt182",
                                    children: new Array(3).fill(0).map((_, idx, arr)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $1352983b8972423b$export$a4842f11451d38bd), {
                                            item: {
                                                index: idx
                                            },
                                            styles: $7e0d57b7600d409b$var$storyCardStyles({
                                                isFirst: idx === 0,
                                                isLast: idx === arr.length - 1
                                            })
                                        }, idx))
                                }),
                                sections.map((section, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " Za182 sd182 Uj182 qj182 ed182 _wa182 _Na182 Tt182 Qt182",
                                        children: section.map((item, sdx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $1352983b8972423b$export$a4842f11451d38bd), {
                                                item: item,
                                                storyId: story.id,
                                                styles: $7e0d57b7600d409b$var$storyCardStyles({
                                                    isFirst: sdx === 0,
                                                    isLast: sdx === section.length - 1
                                                })
                                            }, sdx))
                                    }, idx))
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");

var $dqZbZ = parcelRequire("dqZbZ");

var $fK5Xl = parcelRequire("fK5Xl");

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $8g9SZ = parcelRequire("8g9SZ");

var $iKDEm = parcelRequire("iKDEm");
const $b5ede06b153482e9$export$ba340e850b866867 = ({ template: template, variant: variant = "quiet", onPress: onPress, children: children })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
        id: template.id,
        variant: variant,
        textValue: template.name,
        onPress: ()=>onPress?.(template.id),
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                        src: template.thumbnailUrl,
                        alt: template.name,
                        styles: " Za182 Fb182 _Ha182"
                    }),
                    variant === "quiet" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iKDEm.HoverState), {})
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    slot: "title",
                    children: template.name
                })
            }),
            children,
            variant !== "quiet" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iKDEm.HoverState), {})
        ]
    });
};
$b5ede06b153482e9$export$ba340e850b866867.propTypes = {
    template: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "primary",
        "secondary",
        "tertiary",
        "quiet"
    ]),
    onPress: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $16081c26c3cf99dd$var$$23862386e96bbe63$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "92ffa5__d",
                        x1: -32.728,
                        x2: 209.883,
                        y1: 133.353,
                        y2: -14.249,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "92ffa5__e",
                        x1: 161.965,
                        x2: 57.886,
                        y1: 27.487,
                        y2: 139.401,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "92ffa5__f",
                        x1: 35.482,
                        x2: 219.987,
                        y1: 154.848,
                        y2: 51.491,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "92ffa5__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 41.68 47.468)scale(64.9209)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "92ffa5__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 59.17 86.13)scale(64.9209)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "92ffa5__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 149.225,
                            height: 149.225,
                            x: 4.773,
                            fill: "#fff",
                            rx: 3.731
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "92ffa5__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M129.5 68v-4.364c0-7.38-5.992-13.363-13.385-13.363H69.269l-15.167-18.93C52.41 29.23 49.845 28 47.135 28H22.423c-4.928 0-8.923 3.989-8.923 8.91v81.726c0 1.264.176 2.487.504 3.646.1-1.703.47-3.442 1.147-5.174l.055-.138 15.788-38.276C33.586 72.16 39.949 68 46.876 68zm-98.435 64h98.059q.357 0 .71-.027c3.466-.265 6.498-2.453 7.752-5.66l15.811-38.333c2.119-5.42-1.597-11.207-7.297-11.909q-.57-.07-1.165-.071H46.876c-3.758 0-7.125 2.263-8.463 5.687L22.602 120.02c-2.26 5.782 2.118 11.98 8.462 11.98"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#92ffa5__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#92ffa5__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 149.225,
                            height: 149.225,
                            x: 4.773,
                            fill: "#FFECCF",
                            rx: 3.731
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M4.773 0h149.225v149.225H4.773z"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 89.148,
                            cy: 5.788,
                            r: 64.921,
                            fill: "url(#92ffa5__c)",
                            transform: "rotate(-.08 89.148 5.788)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#92ffa5__d)",
                            d: "M61.73-26.36c-11.46-7.091-25.98-7.135-37.484-.112l-115.05 70.246c-11.267 6.88-11.286 23.118-.034 30.024l114.29 70.146c11.486 7.049 26.006 7.04 37.482-.025l114.054-70.211c11.193-6.891 11.213-23.04.034-29.957z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#92ffa5__e)",
                            d: "M26.277 70.849c2.55-55.71 49.78-98.804 105.49-96.254s98.804 49.78 96.253 105.49c-2.55 55.71-49.779 98.804-105.489 96.254-55.71-2.551-98.805-49.78-96.254-105.49"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#92ffa5__f)",
                            d: "M-55.685 107.582c22.144-9.447 46.027-9.042 66.719-.779 41.404 16.576 65.496 6.327 82.206-34.982 8.323-20.729 24.573-38.284 46.743-47.742 44.324-18.88 95.496 1.606 114.349 45.8s-1.782 95.284-46.097 114.189c-22.219 9.479-46.148 9.035-66.871.698-41.337-16.488-65.383-6.2-82.072 35.158-8.344 20.68-24.59 38.175-46.735 47.622-44.29 18.895-95.461-1.592-114.304-45.761s1.772-95.309 46.062-114.203"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 145.301,
                            cy: 26.96,
                            r: 64.921,
                            fill: "url(#92ffa5__g)",
                            transform: "rotate(-.08 145.301 26.96)"
                        })
                    ]
                })
            })
        ]
    });
const $16081c26c3cf99dd$var$$23862386e96bbe63$var$ForwardRef = (0, $eF4cA.forwardRef)($16081c26c3cf99dd$var$$23862386e96bbe63$var$SvgComponent);
var $16081c26c3cf99dd$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($16081c26c3cf99dd$var$$23862386e96bbe63$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $eb4d6cedb6b9d0a4$var$$64b53175ff594f67$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "0c99d7__d",
                        x1: -19.632,
                        x2: 125.934,
                        y1: 80.012,
                        y2: -8.549,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "0c99d7__e",
                        x1: 97.184,
                        x2: 34.737,
                        y1: 16.492,
                        y2: 83.641,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "0c99d7__f",
                        x1: 21.293,
                        x2: 131.996,
                        y1: 92.908,
                        y2: 30.894,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "0c99d7__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 25.009 28.482)scale(38.9525)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "0c99d7__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 35.504 51.68)scale(38.9525)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "0c99d7__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 89.535,
                            height: 89.535,
                            x: 2.867,
                            fill: "#fff",
                            rx: 2.238
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "0c99d7__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M77.702 40.8v-2.618c0-4.429-3.596-8.019-8.031-8.019H41.563l-9.1-11.357c-1.016-1.268-2.554-2.006-4.18-2.006H13.454c-2.956 0-5.353 2.393-5.353 5.345v49.037c0 .757.105 1.49.302 2.186.06-1.021.281-2.064.688-3.104l.033-.082 9.472-22.966c1.556-3.92 5.374-6.416 9.53-6.416zm.536 38.348c1.938-.268 3.603-1.54 4.314-3.36l9.487-23c1.356-3.47-1.27-7.188-5.077-7.188H28.127c-2.255 0-4.275 1.357-5.078 3.412l-9.487 23c-1.353 3.462 1.26 7.172 5.053 7.188h58.861"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#0c99d7__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#0c99d7__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 89.535,
                            height: 89.535,
                            x: 2.867,
                            fill: "#FFECCF",
                            rx: 2.238
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M2.867 0h89.535v89.535H2.867z"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 53.491,
                            cy: 3.473,
                            r: 38.953,
                            fill: "url(#0c99d7__c)",
                            transform: "rotate(-.08 53.491 3.473)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#0c99d7__d)",
                            d: "M37.043-15.816c-6.877-4.255-15.589-4.28-22.49-.067l-69.03 42.147c-6.761 4.128-6.772 13.872-.02 18.015l68.573 42.088c6.891 4.229 15.603 4.224 22.489-.015l68.432-42.127c6.716-4.135 6.728-13.824.021-17.974z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#0c99d7__e)",
                            d: "M15.772 42.51c1.53-33.427 29.868-59.283 63.294-57.753s59.282 29.868 57.752 63.294c-1.531 33.426-29.868 59.283-63.294 57.752S14.24 75.935 15.772 42.509"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#0c99d7__f)",
                            d: "M-33.407 64.548c13.286-5.668 27.616-5.425 40.031-.467 24.843 9.946 39.298 3.797 49.324-20.989 4.994-12.437 14.744-22.97 28.045-28.645 26.595-11.328 57.298.963 68.61 27.48 11.312 26.516-1.069 57.17-27.658 68.513-13.331 5.688-27.689 5.421-40.123.419-24.802-9.893-39.23-3.72-49.243 21.095-5.006 12.408-14.754 22.905-28.041 28.573-26.574 11.337-57.276-.955-68.582-27.456s1.063-57.186 27.637-68.523"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 87.183,
                            cy: 16.175,
                            r: 38.953,
                            fill: "url(#0c99d7__g)",
                            transform: "rotate(-.08 87.183 16.175)"
                        })
                    ]
                })
            })
        ]
    });
const $eb4d6cedb6b9d0a4$var$$64b53175ff594f67$var$ForwardRef = (0, $eF4cA.forwardRef)($eb4d6cedb6b9d0a4$var$$64b53175ff594f67$var$SvgComponent);
var $eb4d6cedb6b9d0a4$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($eb4d6cedb6b9d0a4$var$$64b53175ff594f67$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $d7b92903923737c6$var$$b13faf629a84668a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsxs)("defs", {
                children: [
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "95b76e__d",
                        x1: -9.82,
                        x2: 62.963,
                        y1: 40.006,
                        y2: -4.275,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "95b76e__e",
                        x1: 48.588,
                        x2: 17.364,
                        y1: 8.246,
                        y2: 41.82,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("linearGradient", {
                        id: "95b76e__f",
                        x1: 10.645,
                        x2: 65.996,
                        y1: 46.455,
                        y2: 15.447,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "95b76e__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 12.503 14.239)scale(19.4763)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)("radialGradient", {
                        id: "95b76e__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 17.75 25.839)scale(19.4763)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $dx4lB.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            (0, $dx4lB.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)("clipPath", {
                        id: "95b76e__b",
                        children: (0, $dx4lB.jsx)("rect", {
                            width: 44.767,
                            height: 44.767,
                            x: 1.43,
                            fill: "#fff",
                            rx: 1.119
                        })
                    })
                ]
            }),
            (0, $dx4lB.jsx)("clipPath", {
                id: "95b76e__a",
                children: (0, $dx4lB.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M38.847 20.4v-1.309c0-2.214-1.798-4.009-4.016-4.009H20.778l-4.55-5.679C15.718 8.77 14.95 8.4 14.138 8.4H6.723c-1.479 0-2.677 1.197-2.677 2.673v24.518q.002.572.152 1.096c.03-.511.14-1.034.344-1.554q.007-.021.017-.042L9.296 23.61c.778-1.96 2.686-3.209 4.764-3.209zm4.63 2.4H14.06c-1.127 0-2.137.68-2.538 1.706l-4.744 11.5c-.676 1.731.63 3.586 2.527 3.594h29.428c1.128 0 2.138-.678 2.54-1.706l4.743-11.5c.652-1.666-.536-3.448-2.318-3.585q-.11-.009-.22-.009"
                })
            }),
            (0, $dx4lB.jsx)("g", {
                clipPath: "url(#95b76e__a)",
                children: (0, $dx4lB.jsxs)("g", {
                    clipPath: "url(#95b76e__b)",
                    children: [
                        (0, $dx4lB.jsx)("rect", {
                            width: 44.767,
                            height: 44.767,
                            x: 1.43,
                            fill: "#FFECCF",
                            rx: 1.119
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M1.43 0h44.767v44.767H1.43z"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 26.742,
                            cy: 1.736,
                            r: 19.476,
                            fill: "url(#95b76e__c)",
                            transform: "rotate(-.08 26.742 1.736)"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#95b76e__d)",
                            d: "M18.517-7.908c-3.438-2.127-7.794-2.14-11.245-.034l-34.515 21.074c-3.38 2.064-3.386 6.936-.01 9.008L7.034 43.183c3.446 2.115 7.802 2.112 11.245-.007l34.216-21.064c3.358-2.067 3.364-6.911.01-8.987z"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#95b76e__e)",
                            d: "M7.882 21.255C8.647 4.542 22.816-8.387 39.529-7.621S69.17 7.313 68.405 24.026s-14.934 29.64-31.647 28.876C20.045 52.136 7.117 37.968 7.882 21.255"
                        }),
                        (0, $dx4lB.jsx)("path", {
                            fill: "url(#95b76e__f)",
                            d: "M-16.706 32.275c6.644-2.834 13.809-2.713 20.016-.234 12.421 4.973 19.649 1.898 24.662-10.494 2.497-6.22 7.372-11.486 14.023-14.323 13.297-5.664 28.649.482 34.305 13.74s-.535 28.585-13.83 34.257c-6.665 2.843-13.844 2.71-20.06.209-12.402-4.946-19.616-1.86-24.622 10.548-2.504 6.203-7.377 11.452-14.02 14.286-13.288 5.668-28.64-.477-34.292-13.728s.532-28.593 13.818-34.261"
                        }),
                        (0, $dx4lB.jsx)("circle", {
                            cx: 43.589,
                            cy: 8.088,
                            r: 19.476,
                            fill: "url(#95b76e__g)",
                            transform: "rotate(-.08 43.59 8.088)"
                        })
                    ]
                })
            })
        ]
    });
const $d7b92903923737c6$var$$b13faf629a84668a$var$ForwardRef = (0, $eF4cA.forwardRef)($d7b92903923737c6$var$$b13faf629a84668a$var$SvgComponent);
var $d7b92903923737c6$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($d7b92903923737c6$var$$b13faf629a84668a$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $29c0e30494d16bf7$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $16081c26c3cf99dd$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $d7b92903923737c6$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $eb4d6cedb6b9d0a4$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $ffccd5089ec80d3f$export$c5a06aa0f041765d = ()=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const { data: data, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isFetching: isFetching, isFetchingNextPage: isFetchingNextPage, isError: isError } = (0, $fK5Xl.useExpressTemplates)();
    const templates = data?.pages?.flatMap((page)=>page.documents) || [];
    const loadingState = isError ? "error" : isLoading ? "loading" : isFetchingNextPage ? "loadingMore" : "idle";
    const renderEmptyState = ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
            size: "M",
            styles: " JJ182 GJ182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $29c0e30494d16bf7$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    children: "No templates found"
                })
            ]
        });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
        loadingState: loadingState,
        onLoadMore: fetchNextPage,
        isLoadingMore: isFetchingNextPage,
        hasMore: hasNextPage,
        selectionMode: "single",
        selectionStyle: "highlight",
        onSelectionChange: (selectedKeys)=>navigate([
                ...selectedKeys
            ][0]),
        renderEmptyState: renderEmptyState,
        "aria-label": "Template List",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: templates,
                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $b5ede06b153482e9$export$ba340e850b866867), {
                        template: item
                    })
            }),
            isFetching && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $b5ede06b153482e9$export$ba340e850b866867), {
                        template: {
                            id: "skeleton",
                            name: "Loading...",
                            thumbnailUrl: ""
                        }
                    })
            })
        ]
    });
};
$ffccd5089ec80d3f$export$c5a06aa0f041765d.propTypes = {};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $k6waQ = parcelRequire("k6waQ");

var $gc2oq = parcelRequire("gc2oq");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");
var $aQTiM = parcelRequire("aQTiM");
var $8Muzv = parcelRequire("8Muzv");
var $KXDAG = parcelRequire("KXDAG");
var $7Vvqh = parcelRequire("7Vvqh");
var $j3pTw = parcelRequire("j3pTw");
var $8g9SZ = parcelRequire("8g9SZ");
var $8wD3p = parcelRequire("8wD3p");

var $f16Ml = parcelRequire("f16Ml");

var $cxTG4 = parcelRequire("cxTG4");

var $8OJ2z = parcelRequire("8OJ2z");

var $8wD3p = parcelRequire("8wD3p");

var $lTVIu = parcelRequire("lTVIu");

var $hxsf4 = parcelRequire("hxsf4");

var $aVEhH = parcelRequire("aVEhH");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $5nTep = parcelRequire("5nTep");

var $2ffAV = parcelRequire("2ffAV");

var $i93Vd = parcelRequire("i93Vd");

var $fZShI = parcelRequire("fZShI");

var $3PqDc = parcelRequire("3PqDc");

var $e0Enh = parcelRequire("e0Enh");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $cg9Gh = parcelRequire("cg9Gh");


var $k5Pnh = parcelRequire("k5Pnh");

var $3g2oV = parcelRequire("3g2oV");

var $fDYaM = parcelRequire("fDYaM");

var $19ZgV = parcelRequire("19ZgV");




var $n0XBd = parcelRequire("n0XBd");

var $7aYcI = parcelRequire("7aYcI");

var $eF4cA = parcelRequire("eF4cA");

var $ed0Y6 = parcelRequire("ed0Y6");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $25dFS = parcelRequire("25dFS");

var $eF2II = parcelRequire("eF2II");
function $167b1d74632fc01a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $167b1d74632fc01a$export$b72b8dade9393cd5 = (0, $eF4cA.createContext)(null);
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$inputButton = function anonymous(props) {
    let rules = " ";
    if (props.isQuiet) rules += ' _Le182';
    else if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _oa182';
    rules += ' SMBFGYc182';
    rules += ' RfBFGYc182';
    if (props.size === "XL") rules += ' Nl182';
    else if (props.size === "L") rules += ' Nj182';
    else if (props.size === "S") rules += ' Nf182';
    else if (props.size === "XS") rules += ' Ne182';
    else rules += ' Nk182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' qc182';
    rules += ' qsd182';
    rules += ' -Qg41Lb-IAxCW0c182';
    rules += ' -Qg41Lb-gLWx3bIy182';
    rules += ' FRuFGYc182';
    rules += ' zXcEWr182';
    rules += ' yXcEWr182';
    rules += ' BXcEWr182';
    rules += ' AXcEWr182';
    if (props.isQuiet) rules += ' _qd182';
    else rules += ' _qtb182';
    if (props.size === "XL") rules += ' -Anxdcc-Zt182';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
    else if (props.size === "S") rules += ' -Anxdcc-Zr182';
    else rules += ' -Anxdcc-Z3fn9H182';
    rules += ' __v6TNLWb182';
    rules += ' _Pc182';
    rules += ' _Wd182';
    rules += ' _je182';
    rules += ' _jlf182';
    if (props.isDisabled) rules += ' ilc182';
    else rules += ' ilb182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    if (props.isQuiet) rules += ' g9182';
    else if (props.isDisabled) rules += ' gH182';
    else if (props.isOpen) rules += ' gF182';
    else {
        if (props.isPressed) rules += ' gF182';
        else if (props.isFocusVisible) rules += ' gF182';
        else if (props.isHovered) rules += ' gF182';
        else rules += ' gH182';
    }
    if (props.isQuiet) rules += ' Ln182';
    rules += ' __ca182';
    if (props.size === "XL") rules += ' -F_-Fz182';
    else if (props.size === "L") rules += ' -F_-Fv182';
    else if (props.size === "S") rules += ' -F_-Fp182';
    else if (props.size === "XS") rules += ' -F_-Fn182';
    else rules += ' -F_-Fx182';
    if (props.isQuiet) rules += ' -S_-Sd182';
    else rules += ' -S_-Sv182';
    if (props.isQuiet) rules += ' -R_-Rd182';
    else rules += ' -R_-Rv182';
    return rules;
};
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$quietFocusLine = " Za182 FLvNfn182 _Pa182 _lr182 og182 ng182 kg182 jg182 g_h182 gle182";
let $167b1d74632fc01a$export$b1e5508a851be14d = function anonymous(props) {
    let rules = " ";
    rules += ' _Le182';
    rules += ' se182';
    rules += ' Za182';
    if (props.size === "XL") rules += ' Dk92HIe182';
    else if (props.size === "L") rules += ' DyaX9Fb182';
    else if (props.size === "M") rules += ' Deb5jcb182';
    else if (props.size === "S") rules += ' DGTLJAe182';
    rules += ' _oa182';
    rules += ' K40ub4c182';
    rules += ' _Na182';
    rules += ' Pa182';
    rules += ' Tt182';
    rules += ' Qt182';
    rules += ' St182';
    rules += ' Rt182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    rules += ' __ya182';
    return rules;
};
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$invalidBorder = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-ob182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' _Pa182';
    rules += ' Wr182';
    rules += ' _Er182';
    rules += ' _lr182';
    rules += ' _Rr182';
    rules += ' _Ob182';
    rules += ' _jf182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    if (props.isPressed) rules += ' im182';
    else if (props.isFocusVisible) rules += ' im182';
    else if (props.isHovered) rules += ' im182';
    else rules += ' ip182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    return rules;
};
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$valueStyles = function anonymous(props) {
    let rules = " ";
    if (props.isQuiet) rules += ' _ua182';
    else rules += ' _ub182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' _Yb182';
    rules += ' _7c182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' Fb182';
    return rules;
};
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$iconStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _va182';
    rules += ' _Sd182';
    rules += ' -_8sjo0b-t5ZbAob182';
    if (props.isLoading) rules += ' pp182';
    return rules;
};
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$avatar = " z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182 Ht182 Hsu182";
let $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InternalPickerContext = (0, $eF4cA.createContext)({
    size: 'M'
});
let $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InsideSelectValueContext = (0, $eF4cA.createContext)(false);
const $167b1d74632fc01a$export$ba25329847403e11 = (0, $eF4cA.forwardRef)(function Picker(props1, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($167b1d74632fc01a$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $167b1d74632fc01a$export$b72b8dade9393cd5);
    let domRef = (0, $3PqDc.useFocusableRef)(ref);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props1 = (0, $j3pTw.useFormProps)(props1);
    let { direction: direction = 'bottom', align: align = 'start', shouldFlip: shouldFlip = true, menuWidth: menuWidth, label: label, description: descriptionMessage, errorMessage: errorMessage, children: children, items: items, size: size = 'M', labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', necessityIndicator: necessityIndicator, UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, placeholder: placeholder = stringFormatter.format('picker.placeholder'), isQuiet: isQuiet, loadingState: loadingState, renderValue: renderValue, onLoadMore: onLoadMore, ...pickerProps } = props1;
    // Better way to encode this into a style? need to account for flipping
    let menuOffset;
    if (size === 'S') menuOffset = 6;
    else if (size === 'M') menuOffset = 6;
    else if (size === 'L') menuOffset = 7;
    else menuOffset = 8;
    let renderer;
    let showButtonSpinner = (0, $eF4cA.useMemo)(()=>loadingState === 'loading', [
        loadingState
    ]);
    let spinnerId = (0, $25dFS.useSlotId)([
        showButtonSpinner
    ]);
    let listBoxLoadingCircle = (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxLoadMoreItem), {
        className: (0, $8wD3p.loadingWrapperStyles),
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        children: (0, $dx4lB.jsx)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$PickerProgressCircle, {
            size: size,
            "aria-label": stringFormatter.format('picker.loadingMore')
        })
    });
    if (typeof children === 'function' && items) renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                items: items,
                dependencies: props1.dependencies,
                children: children
            }),
            listBoxLoadingCircle
        ]
    });
    else renderer = (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            children,
            listBoxLoadingCircle
        ]
    });
    let scale = (0, $e0Enh.useScale)();
    let { direction: dir } = (0, $1ntKq.useLocale)();
    let RTLFlipOffset = dir === 'rtl' ? -1 : 1;
    return (0, $dx4lB.jsx)((0, $115cb651e37427c9$export$ef9b1a59e592288f), {
        ...pickerProps,
        "aria-describedby": spinnerId,
        placeholder: placeholder,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, props1.styles),
        children: ({ isDisabled: isDisabled, isOpen: isOpen, isFocusVisible: isFocusVisible, isInvalid: isInvalid, isRequired: isRequired })=>(0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: (0, $dx4lB.jsxs)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InternalPickerContext.Provider, {
                    value: {
                        size: size
                    },
                    children: [
                        (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                            includeNecessityIndicatorInAccessibilityName: true,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            size: size,
                            labelPosition: labelPosition,
                            labelAlign: labelAlign,
                            isQuiet: isQuiet,
                            necessityIndicator: necessityIndicator,
                            contextualHelp: props1.contextualHelp,
                            children: label
                        }),
                        (0, $dx4lB.jsx)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$PickerButton, {
                            loadingState: loadingState,
                            renderValue: renderValue,
                            isOpen: isOpen,
                            isQuiet: isQuiet,
                            isFocusVisible: isFocusVisible,
                            size: size,
                            isInvalid: isInvalid,
                            isDisabled: isDisabled,
                            buttonRef: domRef,
                            loadingCircle: (0, $dx4lB.jsx)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$PickerProgressCircle, {
                                id: spinnerId,
                                size: size,
                                "aria-label": stringFormatter.format('picker.loading')
                            })
                        }),
                        (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                            size: size,
                            isDisabled: isDisabled,
                            isInvalid: isInvalid,
                            description: descriptionMessage,
                            children: errorMessage
                        }),
                        (0, $dx4lB.jsx)((0, $eF2II.Virtualizer), {
                            layout: (0, $n0XBd.ListLayout),
                            layoutOptions: {
                                estimatedRowHeight: 32,
                                estimatedHeadingHeight: 50,
                                padding: 8,
                                loaderHeight: (0, $aVEhH.LOADER_ROW_HEIGHTS)[size][scale]
                            },
                            children: (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                hideArrow: true,
                                padding: "none",
                                offset: menuOffset,
                                crossOffset: isQuiet ? RTLFlipOffset * -12 : undefined,
                                placement: `${direction} ${align}`,
                                shouldFlip: shouldFlip,
                                UNSAFE_style: {
                                    width: menuWidth && !isQuiet ? `${menuWidth}px` : undefined
                                },
                                styles: function anonymous(props) {
                                    let rules = " ";
                                    if (props.isQuiet) rules += ' Nh182';
                                    else rules += ' NuHSBze182';
                                    if (props.isQuiet) rules += ' ZbWuche182';
                                    else rules += ' ZuHSBze182';
                                    return rules;
                                }(props1),
                                children: (0, $dx4lB.jsx)("div", {
                                    className: " sd182 Za182 Fb182",
                                    children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                        values: [
                                            [
                                                (0, $208Op.HeaderContext),
                                                {
                                                    styles: (0, $aVEhH.listboxHeader)({
                                                        size: size
                                                    })
                                                }
                                            ],
                                            [
                                                (0, $208Op.HeadingContext),
                                                {
                                                    // @ts-ignore
                                                    role: 'presentation',
                                                    styles: (0, $8wD3p.sectionHeading)
                                                }
                                            ],
                                            [
                                                (0, $208Op.TextContext),
                                                {
                                                    slots: {
                                                        description: {
                                                            styles: (0, $8wD3p.description)({
                                                                size: size,
                                                                isFocused: false,
                                                                isDisabled: false
                                                            })
                                                        }
                                                    }
                                                }
                                            ]
                                        ],
                                        children: (0, $dx4lB.jsx)((0, $cg9Gh.ListBox), {
                                            dependencies: props1.dependencies,
                                            items: items,
                                            className: (0, $aVEhH.listbox)({
                                                size: size
                                            }),
                                            children: renderer
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
    });
});
function $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$PickerProgressCircle(props) {
    let { id: id, 'aria-label': ariaLabel } = props;
    return (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
        id: id,
        isIndeterminate: true,
        size: "S",
        "aria-label": ariaLabel,
        styles: (0, $8wD3p.progressCircleStyles)
    });
}
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$avatarSize = {
    S: 16,
    M: 20,
    L: 22,
    XL: 26
};
// https://w3c.github.io/aria/#widget_roles
let $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$INTERACTIVE_ARIA_ROLES = new Set([
    'application',
    'button',
    'checkbox',
    'combobox',
    'gridcell',
    'link',
    'menuitem',
    'menuitemcheckbox',
    'menuitemradio',
    'option',
    'radio',
    'searchbox',
    'separator',
    'slider',
    'spinbutton',
    'switch',
    'tab',
    'textbox',
    'treeitem'
]);
// Needs to be hidable component or otherwise the PressResponder throws a warning when rendered in the fake DOM and tries to register
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$PickerButton = (0, $19ZgV.createHideableComponent)(function PickerButton(props) {
    let { isOpen: isOpen, isQuiet: isQuiet, isFocusVisible: isFocusVisible, size: size, isInvalid: isInvalid, isDisabled: isDisabled, loadingState: loadingState, loadingCircle: loadingCircle, buttonRef: buttonRef, renderValue: renderValue } = props;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($167b1d74632fc01a$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let renderValueRef = (0, $eF4cA.useRef)(null);
    let state = (0, $eF4cA.useContext)((0, $115cb651e37427c9$export$ef445b55be0601bd));
    (0, $eF4cA.useEffect)(()=>{
        return;
    }, [
        state.selectedItems,
        renderValue
    ]);
    // For mouse interactions, pickers open on press start. When the popover underlay appears
    // it covers the trigger button, causing onPressEnd to fire immediately and no press scaling
    // to occur. We override this by listening for pointerup on the document ourselves.
    let [isPressed, setPressed] = (0, $eF4cA.useState)(false);
    let { addGlobalListener: addGlobalListener } = (0, $ed0Y6.useGlobalListeners)();
    let onPressStart = (e)=>{
        if (e.pointerType !== 'mouse') return;
        setPressed(true);
        addGlobalListener(document, 'pointerup', ()=>{
            setPressed(false);
        }, {
            once: true,
            capture: true
        });
    };
    return (0, $dx4lB.jsx)((0, $7aYcI.PressResponder), {
        onPressStart: onPressStart,
        isPressed: isPressed,
        children: (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
            ref: buttonRef,
            style: (renderProps)=>(0, $i93Vd.pressScale)(buttonRef)(renderProps),
            // Prevent press scale from sticking while Picker is open.
            // @ts-ignore
            isPressed: false,
            className: (renderProps)=>$167b1d74632fc01a$var$$b41c15d27fbaff7d$var$inputButton({
                    ...renderProps,
                    size: size,
                    isOpen: isOpen,
                    isQuiet: isQuiet
                }),
            children: (renderProps)=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                    children: [
                        (0, $dx4lB.jsx)((0, $115cb651e37427c9$export$e288731fd71264f0), {
                            className: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$valueStyles({
                                isQuiet: isQuiet
                            }) + (renderValue ? '' : " pqYuhc"),
                            children: ({ selectedItems: selectedItems, defaultChildren: defaultChildren })=>{
                                const selectedValues = selectedItems.filter((item)=>item != null);
                                const defaultRenderedValue = selectedItems.length <= 1 ? defaultChildren : (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    slot: "label",
                                    children: stringFormatter.format('picker.selectedCount', {
                                        count: selectedItems.length
                                    })
                                });
                                const renderedValue = selectedItems.length > 0 && renderValue ? renderValue(selectedValues) : defaultRenderedValue;
                                return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                    values: [
                                        [
                                            (0, $dm5H1.IconContext),
                                            {
                                                slots: {
                                                    icon: {
                                                        render: (0, $8OJ2z.centerBaseline)({
                                                            slot: 'icon',
                                                            styles: (0, $8wD3p.iconCenterWrapper)
                                                        }),
                                                        styles: (0, $8wD3p.icon)
                                                    }
                                                }
                                            }
                                        ],
                                        [
                                            (0, $f16Ml.AvatarContext),
                                            {
                                                slots: {
                                                    avatar: {
                                                        size: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$avatarSize[size ?? 'M'],
                                                        styles: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$avatar
                                                    }
                                                }
                                            }
                                        ],
                                        [
                                            (0, $208Op.TextContext),
                                            {
                                                slots: {
                                                    description: {},
                                                    [(0, $fDYaM.DEFAULT_SLOT)]: {
                                                        styles: " sb182 _ub182 _Nc182 Pc182 _Yb182 _7c182",
                                                        // @ts-ignore
                                                        'data-slot': 'label'
                                                    },
                                                    label: {
                                                        styles: " sb182 _ub182 _Nc182 Pc182 _Yb182 _7c182",
                                                        // @ts-ignore not technically necessary, but good for consistency
                                                        'data-slot': 'label'
                                                    }
                                                }
                                            }
                                        ],
                                        [
                                            $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InsideSelectValueContext,
                                            true
                                        ]
                                    ],
                                    children: renderValue ? (0, $dx4lB.jsx)("div", {
                                        ref: renderValueRef,
                                        style: {
                                            display: 'contents'
                                        },
                                        children: renderedValue
                                    }) : renderedValue
                                });
                            }
                        }),
                        isInvalid && (0, $dx4lB.jsx)((0, $8w4Nl.FieldErrorIcon), {
                            isDisabled: isDisabled
                        }),
                        loadingState === 'loading' && !isOpen && loadingCircle,
                        (0, $dx4lB.jsx)((0, $hxsf4.default), {
                            size: size,
                            className: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$iconStyles({
                                isLoading: loadingState === 'loading'
                            })
                        }),
                        isFocusVisible && isQuiet && (0, $dx4lB.jsx)("span", {
                            className: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$quietFocusLine
                        }),
                        isInvalid && !isDisabled && !isQuiet && (0, $dx4lB.jsx)("div", {
                            className: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$invalidBorder({
                                ...renderProps,
                                size: size
                            })
                        })
                    ]
                })
        })
    });
});
const $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$checkmarkIconSize = {
    S: 'XS',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
function $167b1d74632fc01a$export$d601881f38163e28(props) {
    let ref = (0, $eF4cA.useRef)(null);
    let isLink = props.href != null;
    let { size: size } = (0, $eF4cA.useContext)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InternalPickerContext);
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxItem), {
        ...props,
        ref: ref,
        textValue: props.textValue || (typeof props.children === 'string' ? props.children : undefined),
        style: (0, $i93Vd.pressScale)(ref, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + (0, $aVEhH.listboxItem)({
                ...renderProps,
                size: size,
                isLink: isLink
            }, props.styles),
        children: (renderProps)=>{
            let { children: children } = props;
            let checkboxRenderProps = {
                ...renderProps,
                size: size,
                isFocused: false,
                isFocusVisible: false,
                isIndeterminate: false,
                isReadOnly: false,
                isInvalid: false,
                isRequired: false
            };
            return (0, $dx4lB.jsx)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$DefaultProvider, {
                context: (0, $dm5H1.IconContext),
                value: {
                    slots: {
                        icon: {
                            render: (0, $8OJ2z.centerBaseline)({
                                slot: 'icon',
                                styles: (0, $8wD3p.iconCenterWrapper)
                            }),
                            styles: (0, $8wD3p.icon)
                        }
                    }
                },
                children: (0, $dx4lB.jsx)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$DefaultProvider, {
                    context: (0, $f16Ml.AvatarContext),
                    value: {
                        slots: {
                            avatar: {
                                size: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$avatarSize[size],
                                styles: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$avatar
                            }
                        }
                    },
                    children: (0, $dx4lB.jsxs)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$DefaultProvider, {
                        context: (0, $208Op.TextContext),
                        value: {
                            slots: {
                                [(0, $fDYaM.DEFAULT_SLOT)]: {
                                    styles: (0, $8wD3p.label)({
                                        size: size
                                    })
                                },
                                label: {
                                    styles: (0, $8wD3p.label)({
                                        size: size
                                    })
                                },
                                description: {
                                    styles: (0, $8wD3p.description)({
                                        ...renderProps,
                                        size: size
                                    })
                                }
                            }
                        },
                        children: [
                            renderProps.selectionMode === 'single' && !isLink && (0, $dx4lB.jsx)((0, $lTVIu.default), {
                                size: $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$checkmarkIconSize[size],
                                className: (0, $8wD3p.checkmark)({
                                    ...renderProps,
                                    size: size
                                })
                            }),
                            renderProps.selectionMode === 'multiple' && !isLink && (0, $dx4lB.jsx)("div", {
                                className: (0, $5nTep.mergeStyles)((0, $8wD3p.checkbox), (0, $cxTG4.box)(checkboxRenderProps)),
                                children: (0, $dx4lB.jsx)((0, $lTVIu.default), {
                                    size: size,
                                    className: (0, $cxTG4.iconStyles)
                                })
                            }),
                            typeof children === 'string' ? (0, $dx4lB.jsx)((0, $208Op.Text), {
                                slot: "label",
                                children: children
                            }) : children
                        ]
                    })
                })
            });
        }
    });
// oxlint-enable react/react-compiler
}
// A Context.Provider that only sets a value if not inside SelectValue.
function $167b1d74632fc01a$var$$b41c15d27fbaff7d$var$DefaultProvider({ context: context, value: value, children: children }) {
    let inSelectValue = (0, $eF4cA.useContext)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InsideSelectValueContext);
    if (inSelectValue) return children;
    return (0, $dx4lB.jsx)(context.Provider, {
        value: value,
        children: children
    });
}
function $167b1d74632fc01a$export$a340772aca6155cd(props) {
    let { size: size } = (0, $eF4cA.useContext)($167b1d74632fc01a$var$$b41c15d27fbaff7d$var$InternalPickerContext);
    return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxSection), {
                ...props,
                children: props.children
            }),
            (0, $dx4lB.jsx)((0, $aVEhH.Divider), {
                size: size
            })
        ]
    });
}


var $fZShI = parcelRequire("fZShI");
var $91SAk = parcelRequire("91SAk");
var $j8RRT = parcelRequire("j8RRT");

var $5KhQr = parcelRequire("5KhQr");

var $fK5Xl = parcelRequire("fK5Xl");

var $D7J7L = parcelRequire("D7J7L");
// import CCEverywhere from "https://cc-embed.adobe.com/sdk/v4/CCEverywhere.js";
// const CCEverywhere = await import(
//   "https://cc-embed.adobe.com/sdk/v4/CCEverywhere.js"
// );

var $fmJ8d = parcelRequire("fmJ8d");

var $8PkOq = parcelRequire("8PkOq");
const $e3071733f15f65c0$var$CDN_URL = "https://cc-embed.adobe.com/sdk/1p/v4/CCEverywhere.js";
// let CCEverywhere = null;
let $e3071733f15f65c0$var$expressSDK;
let $e3071733f15f65c0$var$isInitializing = false;
const $e3071733f15f65c0$var$load = async ()=>{
    if (window.CCEverywhere) return window.CCEverywhere;
    await import($e3071733f15f65c0$var$CDN_URL);
    while(!window.CCEverywhere)// wait for CCEverywhere to be available
    await new Promise((resolve)=>setTimeout(resolve, 100));
    return window.CCEverywhere;
};
const $e3071733f15f65c0$export$2a47f398eeff8b01 = async ()=>{
    if ($e3071733f15f65c0$var$expressSDK) return $e3071733f15f65c0$var$expressSDK;
    if ($e3071733f15f65c0$var$isInitializing) {
        // Wait until the initialization is complete
        while(!$e3071733f15f65c0$var$expressSDK)await new Promise((resolve)=>setTimeout(resolve, 100));
        return $e3071733f15f65c0$var$expressSDK;
    }
    $e3071733f15f65c0$var$isInitializing = true;
    await $e3071733f15f65c0$var$load();
    const options = {
        clientId: "f2898953e7e04547b7b1854c02d2409b",
        appName: "Be Story",
        authProvider: async ()=>{
            // Get fresh access token from IMS (handles refresh if needed)
            const accessToken = await (0, $8PkOq.IMS).getAccessToken();
            const profile = (0, $fmJ8d.store).getState().ims.profile;
            return {
                mode: "ims-jump",
                config: {
                    accessToken: accessToken,
                    userId: profile?.userId || profile?.id
                }
            };
        }
    };
    $e3071733f15f65c0$var$expressSDK = await window.CCEverywhere.initialize(options, {
        skipBrowserSupportCheck: true
    });
    return $e3071733f15f65c0$var$expressSDK;
};
const $e3071733f15f65c0$export$d193da8733a2af56 = async ()=>{
    const { editor: editor } = await $e3071733f15f65c0$export$2a47f398eeff8b01();
    return editor;
};



var $9lDhw = parcelRequire("9lDhw");

var $fmJ8d = parcelRequire("fmJ8d");

var $6lZyT = parcelRequire("6lZyT");


var $klXmP = parcelRequire("klXmP");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $02a72d426008572f$var$$d27192f599dcdb96$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m13.527 10.491-3.002-2.998c-.293-.293-.767-.293-1.06 0l-2.998 2.998c-.293.293-.293.768 0 1.06.147.147.339.22.53.22s.384-.073.53-.22L9.25 9.83v8.18c0 .414.336.75.75.75s.75-.336.75-.75V9.837l1.718 1.715c.293.293.767.293 1.06 0s.293-.769 0-1.06"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 17h-2.799c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.799c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75H4.25c-.414 0-.75.337-.75.75v10.5c0 .413.336.75.75.75h2.726c.414 0 .75.336.75.75s-.336.75-.75.75H4.25C3.01 17 2 15.99 2 14.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v10.5c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const $02a72d426008572f$var$$d27192f599dcdb96$var$ForwardRef = (0, $eF4cA.forwardRef)($02a72d426008572f$var$$d27192f599dcdb96$var$SvgComponent);
var $02a72d426008572f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($02a72d426008572f$var$$d27192f599dcdb96$var$ForwardRef);




var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $b6545b9f6adb590a$var$$0c3094c068cd46d7$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M4.75 18h-.5C3.01 18 2 16.99 2 15.75v-2.5C2 12.01 3.01 11 4.25 11h.5C5.99 11 7 12.01 7 13.25v2.5C7 16.99 5.99 18 4.75 18m-.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75zM8.75 9h-4.5C3.01 9 2 7.99 2 6.75v-2.5C2 3.01 3.01 2 4.25 2h4.5C9.99 2 11 3.01 11 4.25v2.5C11 7.99 9.99 9 8.75 9m-4.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h4.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75zM15.75 18h-4.5C10.01 18 9 16.99 9 15.75v-2.5C9 12.01 10.01 11 11.25 11h4.5c1.24 0 2.25 1.01 2.25 2.25v2.5c0 1.24-1.01 2.25-2.25 2.25m-4.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h4.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75zM15.75 9h-.5C14.01 9 13 7.99 13 6.75v-2.5C13 3.01 14.01 2 15.25 2h.5C16.99 2 18 3.01 18 4.25v2.5C18 7.99 16.99 9 15.75 9m-.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75z"
        })
    });
const $b6545b9f6adb590a$var$$0c3094c068cd46d7$var$ForwardRef = (0, $eF4cA.forwardRef)($b6545b9f6adb590a$var$$0c3094c068cd46d7$var$SvgComponent);
var $b6545b9f6adb590a$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($b6545b9f6adb590a$var$$0c3094c068cd46d7$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $14ea9638054ff44c$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 24,
        height: 23.143,
        viewBox: "0 0 24 23.143",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("clipPath", {
                        id: "3db5af__a",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                            d: "M10.806 2.089a3.426 3.426 0 0 0-6.311.006L.17 12.395a2.134 2.134 0 0 0 1.961 2.966h4.817a2.147 2.147 0 0 0-.006-4.293l-.823.006a.487.487 0 0 1-.449-.677l1.535-3.658a.474.474 0 0 1 .88 0l3.137 7.322a2.07 2.07 0 0 0 1.971 1.3 2.134 2.134 0 0 0 1.966-2.967Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("clipPath", {
                        id: "3db5af__b",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                            d: "M0 0h20.614v20.643H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                fill: "#000b1d",
                d: "M4.247 0h15.506A4.247 4.247 0 0 1 24 4.247V18.9a4.247 4.247 0 0 1-4.247 4.247H4.247A4.247 4.247 0 0 1 0 18.9V4.247A4.247 4.247 0 0 1 4.247 0"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                    clipPath: "url(#3db5af__a)",
                    transform: "translate(4.335 3.892)",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                            clipPath: "url(#3db5af__b)",
                            transform: "translate(-2.641 -2.642)",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                                clipPath: "url(#3db5af__b)",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("image", {
                                    xlinkHref: "data:image/jpeg;base64,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",
                                    width: 21.053,
                                    height: 20.799,
                                    transform: "translate(-.217 -.031)"
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
const $14ea9638054ff44c$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($14ea9638054ff44c$var$SvgComponent);
var $14ea9638054ff44c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($14ea9638054ff44c$var$ForwardRef);



const $26efba7f609df70d$var$metadata = (parcelRequire("ccHAb"));
const $26efba7f609df70d$var$cropImagesInTags = async (tags, taggedElements)=>{
    const croppedTags = {};
    const cropPromises = tags.filter((tag)=>tag.type === "image").map(async (tag)=>{
        const element = taggedElements.find((el)=>el.name === tag.name);
        if (element) {
            const croppedBlob = await (0, $6lZyT.cropImageBlob)(tag.blob, element.size);
            croppedTags[tag.name] = croppedBlob;
            croppedTags[tag.name].name = `${crypto.randomUUID()}.${tag.blob?.type?.split("/")?.[1] ?? "jpg"}`;
        }
    });
    await Promise.all(cropPromises);
    return croppedTags;
};
const $26efba7f609df70d$export$85c5def18439af89 = ()=>{
    const params = (0, $dqZbZ.useParams)();
    const navigate = (0, $dqZbZ.useNavigate)();
    (0, $eF4cA.useEffect)(()=>{
        if (!params.id) navigate("/templates");
    }, [
        params.id,
        navigate
    ]);
    if (!params.id) return null;
    const { data: data, isLoading: isLoading, isFetching: isFetching, hasNextPage: hasNextPage, fetchNextPage: fetchNextPage, isError: isError } = (0, $fK5Xl.useExpressTemplate)(params.id);
    const template = (0, $eF4cA.useMemo)(()=>{
        return (data?.pages || []).reduce((acc, { id: id, name: name, documentPages: documentPages })=>{
            acc.id = id;
            acc.name = name;
            acc.documentPages = [
                ...acc.documentPages || [],
                ...documentPages || []
            ];
            return acc;
        }, {});
    }, [
        data
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!isFetching && hasNextPage) fetchNextPage();
    }, [
        isFetching,
        hasNextPage,
        fetchNextPage
    ]);
    (0, $eF4cA.useEffect)(()=>{
        (async ()=>{
            const ccEverywhere = await $e3071733f15f65c0$export$2a47f398eeff8b01();
            ccEverywhere.editor?.warmup({
                intent: "create-with-asset",
                mode: "minimal"
            });
        })();
    }, []);
    const [meta, setMeta] = (0, $eF4cA.useState)(null);
    const [isLoadingMeta, startLoadingMetaTransition] = (0, $eF4cA.useTransition)();
    (0, $eF4cA.useEffect)(()=>{
        startLoadingMetaTransition(async ()=>{
            try {
                const meta = $26efba7f609df70d$var$metadata[params.id.replaceAll(":", "_")];
                setMeta(meta.default);
            } catch (e) {
                setMeta(null);
            }
        });
    }, [
        params.id
    ]);
    const loadingState = isError ? "error" : isLoading || isLoadingMeta ? "loading" : "idle";
    const [tags, setTags] = (0, $eF4cA.useState)({});
    const taggedElements = (0, $eF4cA.useMemo)(()=>{
        if (!data?.pages?.length) return [];
        const _taggedElements = (template.documentPages?.flatMap((doc)=>doc.taggedElements) || [])?.filter((tag)=>!/#\d+$/.test(tag.name)).filter((tag, index, self)=>index === self.findIndex((t)=>t.name === tag.name)).map((tag)=>({
                id: crypto.randomUUID(),
                ...tag
            })) || [];
        if (meta) for (const [key, config] of Object.entries(meta)){
            const tag = _taggedElements.find((t)=>t.name === key);
            if (tag) {
                if (config.value instanceof URL) tag.url = config.value.href;
                else if (typeof config.value === "string") tag.defaultValue = config.value;
                if (config.objectFit) tag.objectFit = config.objectFit;
            }
        }
        if (tags) for (const [key, value] of Object.entries(tags)){
            const tag = _taggedElements.find((t)=>t.name === key);
            if (tag) Object.assign(tag, value);
        }
        return _taggedElements;
    }, [
        template,
        meta,
        tags
    ]);
    const taggedImages = (0, $eF4cA.useMemo)(()=>taggedElements.filter((el)=>el.type === "image"), [
        taggedElements
    ]);
    const [variationName, setVariationName] = (0, $eF4cA.useState)(template?.name + " \u2014 variation");
    const [variationFormat, setVariationFormat] = (0, $eF4cA.useState)("video/mp4");
    (0, $eF4cA.useEffect)(()=>{
        if (template?.name) setVariationName(template.name + " \u2014 variation");
    }, [
        template?.name
    ]);
    const handleTagChange = (0, $eF4cA.useCallback)((elementName, value)=>{
        setTags((prevTags)=>{
            const newTags = {
                ...prevTags
            };
            newTags[elementName] = value;
            return newTags;
        });
    }, []);
    const fileTriggerRefs = (0, $eF4cA.useRef)({});
    const handleFileSelect = (0, $eF4cA.useCallback)((itemId)=>{
        if (fileTriggerRefs.current[itemId]?.value) fileTriggerRefs.current[itemId].value = "";
        fileTriggerRefs.current[itemId]?.click();
    }, []);
    const handleDrop = (0, $eF4cA.useCallback)((filesPromises, elementName)=>{
        (0, $eF4cA.startTransition)(async ()=>{
            const files = await Promise.all(filesPromises);
            if (files && files.length > 0) {
                const file = files[0];
                if (file) {
                    const blobUrl = await (0, $6lZyT.imageBlobToDataUrl)(files[0]);
                    setTags((prevTags)=>{
                        const newTags = {
                            ...prevTags
                        };
                        newTags[elementName] = file;
                        newTags[elementName].url = blobUrl;
                        return newTags;
                    });
                }
            }
        });
    }, []);
    const handleEditImage = (0, $eF4cA.useCallback)((element)=>{
        (0, $eF4cA.startTransition)(async ()=>{
            const ccEverywhere = await $e3071733f15f65c0$export$2a47f398eeff8b01();
            console.log({
                ccEverywhere: ccEverywhere,
                element: element
            });
            const { blob: imageBlob } = await (0, $9lDhw.getImageBlob)(element);
            const imageDataUrl = await (0, $6lZyT.imageBlobToDataUrl)(imageBlob);
            const docConfig = element?.documentId ? {
                documentId: element.documentId
            } : {
                canvasSize: {
                    width: element.size.width,
                    height: element.size.height,
                    unit: "px"
                },
                asset: {
                    type: "image",
                    // dataType: "blob",
                    // data: imageBlob,
                    dataType: "base64",
                    data: imageDataUrl,
                    name: element.name
                }
            };
            const appConfig = {
                colorTheme: (0, $fmJ8d.store).getState().colorScheme,
                spectrumTheme: "spectrum-two",
                callbacks: {
                    onPublish: async (intent, publishParams)=>{
                        const asset = publishParams.asset[0];
                        const documentId = publishParams.documentId;
                        console.log({
                            intent: intent,
                            publishParams: publishParams
                        });
                        const blob = await (await fetch(asset.data)).blob();
                        blob.url = asset.data;
                        blob.documentId = documentId;
                        setTags((prevTags)=>{
                            const newTags = {
                                ...prevTags
                            };
                            newTags[element.name] = blob;
                            // Object.assign(newTags[element.name], {
                            //   url: asset.data,
                            //   documentId,
                            // });
                            return newTags;
                        });
                    },
                    onError: (error)=>{}
                },
                selectedCategory: "hidden",
                multiPage: false,
                allowedFileTypes: [
                    "image/png",
                    "image/jpeg",
                    "video/mp4"
                ]
            };
            const exportConfig = [
                {
                    id: "save-asset",
                    label: "Save to BeStory",
                    action: {
                        target: "publish",
                        outputType: "blob",
                        publishFileType: "image/png"
                    },
                    // action: { target: "download" },
                    style: {
                        uiType: "button"
                    }
                }
            ];
            const editorAction = element?.documentId ? ccEverywhere.editor.edit : ccEverywhere.editor.createWithAsset;
            editorAction.call(ccEverywhere.editor, docConfig, appConfig, exportConfig);
        });
    }, []);
    const handleExpressQuickAction = (0, $eF4cA.useCallback)((actionType, element)=>{
        (0, $eF4cA.startTransition)(async ()=>{
            const ccEverywhere = await $e3071733f15f65c0$export$2a47f398eeff8b01();
            console.log({
                ccEverywhere: ccEverywhere,
                element: element
            });
            const { blob: imageBlob } = await (0, $9lDhw.getImageBlob)(element);
            const imageDataUrl = await (0, $6lZyT.imageBlobToDataUrl)(imageBlob);
            const docConfig = {
                canvasSize: {
                    width: element.size.width,
                    height: element.size.height,
                    unit: "px"
                },
                asset: {
                    type: "image",
                    // dataType: "blob",
                    // data: imageBlob,
                    dataType: "base64",
                    data: imageDataUrl,
                    name: element.name
                }
            };
            const appConfig = {
                colorTheme: (0, $fmJ8d.store).getState().colorScheme,
                spectrumTheme: "spectrum-two",
                callbacks: {
                    onPublish: async (intent, publishParams)=>{
                        const asset = publishParams.asset[0];
                        const documentId = publishParams.documentId;
                        console.log({
                            intent: intent,
                            publishParams: publishParams
                        });
                        const blob = await (await fetch(asset.data)).blob();
                        blob.url = asset.data;
                        blob.documentId = documentId;
                        setTags((prevTags)=>{
                            const newTags = {
                                ...prevTags
                            };
                            newTags[element.name] = blob;
                            // Object.assign(newTags[element.name], {
                            //   url: asset.data,
                            //   documentId,
                            // });
                            return newTags;
                        });
                    },
                    onError: (error)=>{}
                },
                selectedCategory: "hidden",
                multiPage: false,
                allowedFileTypes: [
                    "image/png",
                    "image/jpeg",
                    "video/mp4"
                ]
            };
            const exportConfig = [
                {
                    id: "save-asset",
                    label: "Save to BeStory",
                    action: {
                        target: "publish",
                        outputType: "blob",
                        publishFileType: "image/png"
                    },
                    // action: { target: "download" },
                    style: {
                        uiType: "button"
                    }
                }
            ];
            switch(actionType){
                case "crop":
                    ccEverywhere.quickAction.cropImage(docConfig, appConfig, exportConfig);
                    break;
                default:
                    break;
            }
        });
    }, []);
    const isDownloadDisabled = Object.values(tags).filter(Boolean).length === 0;
    const generateVariation = (0, $fK5Xl.useGenerateVariation)();
    const exportRendition = (0, $fK5Xl.useExportRendition)();
    const pollStatus = (0, $fK5Xl.useExpressPollStatus)();
    const uploadFile = (0, $k6waQ.useMutation)({
        mutationFn: ({ filePath: filePath, fileBlob: fileBlob }, { signal: signal })=>(0, $D7J7L.uploadFileByBlob)(filePath, fileBlob, {
                signal: signal
            }),
        meta: {
            errorMessage: "Failed to upload file. Please try again."
        }
    });
    const { reset: resetFileUpload } = uploadFile;
    const resetAll = (0, $eF4cA.useCallback)(()=>{
        resetFileUpload();
        generateVariation.reset();
        exportRendition.reset();
        pollStatus.reset();
    }, [
        resetFileUpload,
        generateVariation,
        exportRendition,
        pollStatus
    ]);
    const [variationDoc, setVariationDoc] = (0, $eF4cA.useState)({});
    const status = uploadFile.isPending ? "Uploading assets\u2026" : generateVariation.isPending ? "Generating variation\u2026" : generateVariation.isSuccess && pollStatus.isPending && pollStatus.variables.jobId === generateVariation.data.jobId ? "Creating new document\u2026" : exportRendition.isPending ? "Exporting rendition\u2026" : exportRendition.isSuccess && pollStatus.isPending && pollStatus.variables.jobId === exportRendition.data.jobId ? "Generating rendition\u2026" : "Done";
    const handleGenerateVariation = (0, $eF4cA.useCallback)((callback)=>{
        (0, $eF4cA.startTransition)(async ()=>{
            const id = crypto.randomUUID();
            const ldap = (0, $fmJ8d.store).getState().ims?.profile?.email.split("@")[0];
            const folderPath = `${ldap}/express-templates/${template.id}/${id}`;
            const allTaggedElements = template?.documentPages?.flatMap((doc)=>doc.taggedElements);
            const tagsToCrop = Object.entries(tags).filter(([key, value])=>value instanceof Blob && taggedElements.some((el)=>el.name === key && el?.objectFit === "cover")).flatMap(([key, blob])=>{
                const elements = allTaggedElements.filter((tag)=>new RegExp(`^${key}(\\s#\\d+)?$`).test(tag.name))?.map((tag)=>Object.assign(tag, {
                        blob: blob
                    }));
                return elements;
            });
            const croppedTags = await $26efba7f609df70d$var$cropImagesInTags(tagsToCrop, allTaggedElements);
            const imageTagsPromises = Object.entries({
                ...tags,
                ...croppedTags
            }).filter(([_, value])=>value instanceof Blob).map(([key, file])=>Promise.all([
                    key,
                    uploadFile.mutateAsync({
                        filePath: `${folderPath}/${file.name}`,
                        fileBlob: file
                    }).then(({ presignURL: presignURL })=>presignURL)
                ]));
            const imageTags = await Promise.all(imageTagsPromises);
            const textTags = Object.entries(tags).filter(([_, { value: value }])=>typeof value === "string" && value.trim().length > 0).map(([key, { value: value }])=>[
                    key,
                    value.trim()
                ]);
            const allTags = [
                ...imageTags,
                ...textTags
            ];
            if (allTags.length === 0) return;
            const tagMappings = allTags.reduce((acc, [key, value])=>{
                acc[key] = value;
                return acc;
            }, {});
            template?.documentPages?.forEach((page)=>{
                page.taggedElements?.forEach((element)=>{
                    if (/\s#\d+$/.test(element.name)) {
                        const baseName = element.name.replace(/\s#\d+$/, "");
                        if (!tagMappings[element.name] && tagMappings[baseName]) tagMappings[element.name] = tagMappings[baseName];
                    }
                });
            });
            const variationPayload = {
                id: template.id,
                variationDetails: {
                    pages: "1-",
                    // projectId: null,
                    preferredDocumentName: variationName,
                    tagMappings: tagMappings
                }
            };
            const variationResult = await generateVariation.mutateAsync(variationPayload);
            const variationStatus = await pollStatus.mutateAsync({
                jobId: variationResult.jobId
            });
            setVariationDoc(variationStatus.document);
            // const exportPayload = {
            //   id: variationStatus.document.id,
            //   pages: "1",
            //   options: {
            //     format: variationFormat,
            //     // size: 1920
            //   },
            // };
            // const exportResult = await exportRendition.mutateAsync(exportPayload);
            // const exportStatus = await pollStatus.mutateAsync({
            //   jobId: exportResult.jobId,
            // });
            callback?.(variationResult);
        });
    }, [
        tags,
        taggedElements,
        template,
        variationName,
        variationFormat
    ]);
    const [renditionUrl, setRenditionUrl] = (0, $eF4cA.useState)(null);
    const handleExportRendition = (0, $eF4cA.useCallback)((callback)=>{
        (0, $eF4cA.startTransition)(async ()=>{
            const exportPayload = {
                id: variationDoc.id,
                pages: "1",
                options: {
                    format: variationFormat
                }
            };
            const exportResult = await exportRendition.mutateAsync(exportPayload);
            const exportStatus = await pollStatus.mutateAsync({
                jobId: exportResult.jobId
            });
            setRenditionUrl(exportStatus.data.pageRenditionsResult[0].renditionUrl);
        // callback?.(variationResult);
        });
    }, [
        variationDoc,
        variationFormat
    ]);
    const [galleryLayout, setGalleryLayout] = (0, $eF4cA.useState)("grid");
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " se182 E4w1sLc182 Za182 Fb182 LCGIbK182 IM182 HM182 _oa182 Ug182 qg182 Th182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: template?.name ?? "Loading template Name \u2026"
                    })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 Uj182 qj182 _Nc182 Pc182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 _ta182 _sb4QY4182 Uj182 qj182 Za182 Fb182 Nft0rSc182 _oa182 Pa182",
                            children: [
                                template?.documentPages?.map((page, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                                        children: [
                                            idx !== 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                                                styles: " z2mU182 yzZKy182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 eb182 Ug182 qg182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                        src: page.thumbnailUrl,
                                                        alt: page?.pageTitle || `Page ${page.pageNumber}`,
                                                        styles: " ZywElld182 FywElld182 fa182 _Ha182 oc182 nc182 kc182 jc182"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                                        children: [
                                                            page?.pageTitle || `Page ${page.pageNumber}`,
                                                            " ",
                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 _7c182",
                                                                children: [
                                                                    "(",
                                                                    `${page.size.width} \xd7 ${page.size.height}`,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j3pTw.Form), {
                                                isDisabled: generateVariation.isPending,
                                                styles: " Jv182",
                                                children: taggedElements?.filter((el)=>el.type !== "image" && page.taggedElements?.some((taggedEl)=>taggedEl.name === el.name))?.map((element, edx)=>{
                                                    const key = `${element.type}-${element.name}}`;
                                                    if (element.type === "text") {
                                                        const TextComponent = element.name.length > 40 ? (0, $j8RRT.TextArea) : (0, $j8RRT.TextField);
                                                        return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                    styles: " sd182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182 Gv182",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                                            children: [
                                                                                element.name,
                                                                                !!element?.defaultValue && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-a182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                                                                            children: [
                                                                                                "(",
                                                                                                `${element.defaultValue.length} characters`,
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                            styles: " IM182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-a182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                                                            children: `${tags?.[element.name]?.value?.length ?? 0} characters`
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                                                    "aria-label": element.name,
                                                                    value: tags[element.name]?.value ?? "",
                                                                    placeholder: element?.defaultValue ?? "",
                                                                    onChange: (value)=>handleTagChange(element.name, {
                                                                            value: value
                                                                        })
                                                                })
                                                            ]
                                                        }, key);
                                                    }
                                                    return null;
                                                })
                                            })
                                        ]
                                    }, page.pageNumber)),
                                isLoading && new Array(2).fill(null).map((_, index)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 eb182 Ug182 qg182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                        alt: "Loading",
                                                        styles: " ZywElld182 FywElld182 fa182 _Ha182 Jx182 oc182 nc182 kc182 jc182"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                                        children: "Loading"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " sd182 _ta182 Uj182 qj182",
                                                children: new Array(3).fill(null).map((_, index)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Gv182",
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                    children: "Loading..."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                                                    children: "Loading input tag..."
                                                                })
                                                            })
                                                        ]
                                                    }, index))
                                            })
                                        ]
                                    }, index))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 Ug182 qg182 Za182 Fb182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4836215752023500$export$668709c620d0b8e2), {
                                "aria-label": "Gallery layout",
                                isDisabled: !taggedImages.length,
                                onSelectionChange: setGalleryLayout,
                                styles: " IM182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                        id: "grid",
                                        "aria-label": "Grid",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4ff77f483f4760d8$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                        id: "waterfall",
                                        "aria-label": "Waterfall",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $b6545b9f6adb590a$export$2e2bcd8739ae039), {
                                            UNSAFE_className: " _Zb182"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                                layout: galleryLayout,
                                selectionMode: "none",
                                variant: "quiet",
                                loadingState: loadingState,
                                styles: " Za182 Fb182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                        items: taggedImages,
                                        dependencies: [
                                            galleryLayout
                                        ],
                                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
                                                textValue: item.name,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $KXDAG.DropZone), {
                                                            onDrop: (event)=>handleDrop(event.items.map((item)=>item.getFile()), item.name),
                                                            UNSAFE_className: " Tp182 Qp182 Sp182 Rp182",
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                                                                ref: (ref)=>fileTriggerRefs.current[item.id] = ref,
                                                                onSelect: (files)=>handleDrop(files, item.name),
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5KhQr.Pressable), {
                                                                    tabIndex: 1,
                                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                                        src: item?.url,
                                                                        alt: item.name,
                                                                        styles: " oa182 na182 ka182 ja182 _Ha182",
                                                                        UNSAFE_style: galleryLayout === "waterfall" ? {
                                                                            aspectRatio: `${item?.size?.width} / ${item?.size?.height}`
                                                                        } : {},
                                                                        renderError: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                                className: " sd182 eb182 _Ca182 Za182 Fb182",
                                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c5c5c929122049b7$export$2e2bcd8739ae039), {
                                                                                    styles: " ZF182 Fz182"
                                                                                })
                                                                            })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                slot: "title",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                                        styles: " Hv182",
                                                                        children: [
                                                                            item.name,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182 _7c182",
                                                                        children: `${parseInt(item?.size?.width, 10)} \xd7 ${parseInt(item?.size?.height, 10)} px`
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $gc2oq.ActionMenu), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                                        textValue: "Edit in Express",
                                                                        onPress: ()=>handleEditImage(item),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                children: "Edit in Express"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    item?.url && !item?.documentId && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                                        textValue: "Crop image",
                                                                        onPress: ()=>handleExpressQuickAction("crop", item),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                children: "Crop image"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                                        textValue: "Browse files",
                                                                        onPress: ()=>handleFileSelect(item.id),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $02a72d426008572f$export$2e2bcd8739ae039), {}),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                children: "Browse files"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                    }),
                                    loadingState === "loading" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                                        children: ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                slot: "title",
                                                                children: "Loading..."
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                slot: "description",
                                                                children: "Loading description..."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                styles: " Jx182 IM182",
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            isDisabled: isDownloadDisabled,
                            variant: "accent",
                            onPress: ()=>{
                                resetAll();
                            },
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Generate rendition"
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
                            size: "L",
                            children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 _ta182 Uj182 qj182",
                                    children: [
                                        uploadFile.isIdle && generateVariation.isIdle && exportRendition.isIdle && pollStatus.isIdle && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                                    slot: "title",
                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182",
                                                    children: "Generate rendition"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                            label: "Document name",
                                                            value: variationName,
                                                            onChange: setVariationName
                                                        }),
                                                        exportRendition.isSuccess && pollStatus.isSuccess && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                                            label: "File format",
                                                            value: variationFormat,
                                                            onChange: setVariationFormat,
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                                    id: "video/mp4",
                                                                    children: "MP4 (Best for video)"
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                                    id: "image/png",
                                                                    children: "PNG (Best for images)"
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                                    id: "image/jpeg",
                                                                    children: "JPG (Best for small file sizes)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                                    styles: " IM182",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                            variant: "secondary",
                                                            onPress: ()=>{
                                                                resetAll();
                                                                close();
                                                            },
                                                            children: "Cancel"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                            variant: "accent",
                                                            onPress: ()=>handleGenerateVariation(),
                                                            children: "Generate"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        (uploadFile.isPending || generateVariation.isPending || pollStatus.isPending && pollStatus.variables.jobId === generateVariation.data.jobId) && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: " sd182 _ta182 eb182 _Ca182 Uj182 qj182 JJ182 GJ182",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                    isIndeterminate: true,
                                                    "aria-label": status,
                                                    size: "M"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                                    children: status
                                                })
                                            ]
                                        }),
                                        generateVariation.isSuccess && pollStatus.isSuccess && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                                    styles: " sd182 _ta182 Ug182 qg182 eb182",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                            src: variationDoc?.thumbnailUrl,
                                                            alt: variationDoc?.name,
                                                            styles: " ZcTxjid182 ob182 nb182 kb182 jb182"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                                            children: variationDoc?.name.replace(".express", "")
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                                            variant: "secondary",
                                                            href: `https://new.express.adobe.com/id/${variationDoc?.id}`,
                                                            target: "_blank",
                                                            isDisabled: !variationDoc?.id,
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                    children: "Open in Express"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                                    isDisabled: exportRendition.isPending || pollStatus.isPending,
                                                    styles: " IM182",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                            variant: "secondary",
                                                            fillStyle: "outline",
                                                            onPress: ()=>{
                                                                resetAll();
                                                                close();
                                                            },
                                                            children: "Close"
                                                        }),
                                                        !exportRendition.isSuccess && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                            variant: "accent",
                                                            isPending: exportRendition.isPending || pollStatus.isPending,
                                                            onPress: ()=>handleExportRendition(),
                                                            children: "Export rendition"
                                                        }),
                                                        exportRendition.isSuccess && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                                            variant: "accent",
                                                            isPending: exportRendition.isPending || pollStatus.isPending,
                                                            isDisabled: !renditionUrl,
                                                            onPress: ()=>{
                                                                window.open(renditionUrl, "_blank");
                                                            // resetAll();
                                                            // close();
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                    children: "Download rendition"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                        })
                    ]
                })
            })
        ]
    });
};
$26efba7f609df70d$export$85c5def18439af89.propTypes = {};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $34HUQ = parcelRequire("34HUQ");

var $dqZbZ = parcelRequire("dqZbZ");



var $edFAP = parcelRequire("edFAP");


var $ikOQe = parcelRequire("ikOQe");

const $610ad9406709a690$export$bed2a88f4410ddab = ({ isQuiet: isQuiet = false })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Projects",
            href: "/projects"
        }
    ]);
    const handleCardPress = (0, $eF4cA.useCallback)(({ id: id, videoPath: videoPath, templateId: templateId })=>{
        if (!videoPath) {
            navigate((0, $ikOQe.getNewVideoPath)(id));
            return;
        }
        navigate(`/projects/${id}`);
    }, [
        navigate
    ]);
    const renderEmptyState = ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
            size: "L",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e76bf3a4cae7a571$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    children: "Nothing Created So Far"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                    children: "You haven't made any projects yet\u2014start your first one now!"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                        variant: "accent",
                        href: "/",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Get started"
                            })
                        ]
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: `Projects | BeStory`
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 FKPwxte182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 eb182 Ug182 qg182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "Projects"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                textValue: "New project",
                                isQuiet: true,
                                onPress: ()=>navigate("/projects/new"),
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $eb8f55a238917802$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " _ub182 _vb182 _sb182 Ma182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $08f113aefb328d35$export$99bffacbdbcb5195), {
                            isQuiet: isQuiet,
                            renderEmptyState: renderEmptyState,
                            onCardPress: handleCardPress,
                            styles: " Za182 Fb182"
                        })
                    })
                ]
            })
        ]
    });
};
$610ad9406709a690$export$bed2a88f4410ddab.propTypes = {
    isQuiet: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $aQTiM = parcelRequire("aQTiM");

var $4W5AG = parcelRequire("4W5AG");

var $8OJ2z = parcelRequire("8OJ2z");

var $hxsf4 = parcelRequire("hxsf4");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $58OnM = parcelRequire("58OnM");

var $25dFS = parcelRequire("25dFS");

var $hWe38 = parcelRequire("hWe38");

var $4skXn = parcelRequire("4skXn");

var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bfef181444ee5605$export$6e3e27031a30522f(props, state, ref) {
    let { isDisabled: isDisabled } = props;
    let triggerId = (0, $25dFS.useId)();
    let panelId = (0, $25dFS.useId)();
    let isSSR = (0, $hWe38.useIsSSR)();
    let raf = (0, $eF4cA.useRef)(null);
    let handleBeforeMatch = (0, $eF4cA.useCallback)(()=>{
        // Wait a frame to revert browser's removal of hidden attribute
        raf.current = requestAnimationFrame(()=>{
            if (ref.current) ref.current.setAttribute('hidden', 'until-found');
        });
        (0, $l19Vn.flushSync)(()=>{
            state.toggle();
        });
    }, [
        ref,
        state
    ]);
    (0, $58OnM.useEvent)(ref, 'beforematch', handleBeforeMatch);
    let isExpandedRef = (0, $eF4cA.useRef)(null);
    (0, $4skXn.useLayoutEffect)(()=>{
        // Cancel any pending RAF to prevent stale updates
        if (raf.current) cancelAnimationFrame(raf.current);
        if (ref.current && !isSSR) {
            let panel = ref.current;
            if (isExpandedRef.current == null || typeof panel.getAnimations !== 'function') {
                // On initial render (and in tests), set attributes without animation.
                if (state.isExpanded) {
                    panel.removeAttribute('hidden');
                    panel.style.setProperty('--disclosure-panel-width', 'auto');
                    panel.style.setProperty('--disclosure-panel-height', 'auto');
                } else {
                    panel.setAttribute('hidden', 'until-found');
                    panel.style.setProperty('--disclosure-panel-width', '0px');
                    panel.style.setProperty('--disclosure-panel-height', '0px');
                }
            } else if (state.isExpanded !== isExpandedRef.current) {
                if (state.isExpanded) {
                    panel.removeAttribute('hidden');
                    // Set the width and height as pixels so they can be animated.
                    panel.style.setProperty('--disclosure-panel-width', panel.scrollWidth + 'px');
                    panel.style.setProperty('--disclosure-panel-height', panel.scrollHeight + 'px');
                    Promise.all(panel.getAnimations().map((a)=>a.finished)).then(()=>{
                        // After the animations complete, switch back to auto so the content can resize.
                        panel.style.setProperty('--disclosure-panel-width', 'auto');
                        panel.style.setProperty('--disclosure-panel-height', 'auto');
                    }).catch(()=>{});
                } else {
                    panel.style.setProperty('--disclosure-panel-width', panel.scrollWidth + 'px');
                    panel.style.setProperty('--disclosure-panel-height', panel.scrollHeight + 'px');
                    // Force style re-calculation to trigger animations.
                    window.getComputedStyle(panel).height;
                    // Animate to zero size.
                    panel.style.setProperty('--disclosure-panel-width', '0px');
                    panel.style.setProperty('--disclosure-panel-height', '0px');
                    // Wait for animations to apply the hidden attribute.
                    Promise.all(panel.getAnimations().map((a)=>a.finished)).then(()=>panel.setAttribute('hidden', 'until-found')).catch(()=>{});
                }
            }
            isExpandedRef.current = state.isExpanded;
        }
    }, [
        isDisabled,
        ref,
        state.isExpanded,
        isSSR
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    return {
        buttonProps: {
            id: triggerId,
            'aria-expanded': state.isExpanded,
            'aria-controls': panelId,
            onPress: (e)=>{
                if (!isDisabled && e.pointerType !== 'keyboard') state.toggle();
            },
            isDisabled: isDisabled,
            onPressStart (e) {
                if (e.pointerType === 'keyboard' && !isDisabled) state.toggle();
            }
        },
        panelProps: {
            id: panelId,
            // This can be overridden at the panel element level.
            role: 'group',
            'aria-labelledby': triggerId,
            'aria-hidden': !state.isExpanded,
            hidden: isSSR ? !state.isExpanded : undefined
        }
    };
}



var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7553247eb0ddbdc4$export$f36461af0ef4707d(props) {
    let { allowsMultipleExpanded: allowsMultipleExpanded = false, isDisabled: isDisabled = false } = props;
    let [expandedKeys, setExpandedKeys] = (0, $iUErx.useControlledState)((0, $eF4cA.useMemo)(()=>props.expandedKeys ? new Set(props.expandedKeys) : undefined, [
        props.expandedKeys
    ]), (0, $eF4cA.useMemo)(()=>props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), [
        props.defaultExpandedKeys
    ]), props.onExpandedChange);
    (0, $eF4cA.useEffect)(()=>{
        // Ensure only one item is expanded if allowsMultipleExpanded is false.
        if (!allowsMultipleExpanded && expandedKeys.size > 1) {
            let firstKey = expandedKeys.values().next().value;
            if (firstKey != null) setExpandedKeys(new Set([
                firstKey
            ]));
        }
    });
    return {
        allowsMultipleExpanded: allowsMultipleExpanded,
        isDisabled: isDisabled,
        expandedKeys: expandedKeys,
        setExpandedKeys: setExpandedKeys,
        toggleKey (key) {
            let keys;
            if (allowsMultipleExpanded) {
                keys = new Set(expandedKeys);
                if (keys.has(key)) keys.delete(key);
                else keys.add(key);
            } else keys = new Set(expandedKeys.has(key) ? [] : [
                key
            ]);
            setExpandedKeys(keys);
        }
    };
}



var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f3de1939d2a38e08$export$3fcbf6e4407997e0(props) {
    let [isExpanded, setExpanded] = (0, $iUErx.useControlledState)(props.isExpanded, props.defaultExpanded || false, props.onExpandedChange);
    const expand = (0, $eF4cA.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    const collapse = (0, $eF4cA.useCallback)(()=>{
        setExpanded(false);
    }, [
        setExpanded
    ]);
    const toggle = (0, $eF4cA.useCallback)(()=>{
        setExpanded(!isExpanded);
    }, [
        setExpanded,
        isExpanded
    ]);
    return {
        isExpanded: isExpanded,
        setExpanded: setExpanded,
        expand: expand,
        collapse: collapse,
        toggle: toggle
    };
}



var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $bkjeZ = parcelRequire("bkjeZ");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");

var $25dFS = parcelRequire("25dFS");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1cff1fad781fe217$export$1d40e3e0cc4d5de = (0, $eF4cA.createContext)(null);
const $1cff1fad781fe217$export$944aceb4f8c89f10 = (0, $eF4cA.forwardRef)(function DisclosureGroup(props, ref) {
    let state = (0, $7553247eb0ddbdc4$export$f36461af0ef4707d)(props);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-DisclosureGroup',
        values: {
            isDisabled: state.isDisabled,
            state: state
        }
    });
    let domProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...domProps,
        ...renderProps,
        ref: ref,
        "data-disabled": props.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($1cff1fad781fe217$export$1d40e3e0cc4d5de.Provider, {
        value: state
    }, renderProps.children));
});
const $1cff1fad781fe217$export$d665dd135a51b28a = (0, $eF4cA.createContext)(null);
const $1cff1fad781fe217$export$dab3ea4a6ef094da = (0, $eF4cA.createContext)(null);
const $1cff1fad781fe217$var$$a3e16eab0ea4036c$var$InternalDisclosureContext = (0, $eF4cA.createContext)(null);
const $1cff1fad781fe217$export$74a362b31437ec83 = (0, $eF4cA.forwardRef)(function Disclosure(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $1cff1fad781fe217$export$d665dd135a51b28a);
    let groupState = (0, $eF4cA.useContext)($1cff1fad781fe217$export$1d40e3e0cc4d5de);
    let { id: id, ...otherProps } = props;
    // Generate an id if one wasn't provided.
    // (can't pass id into useId since it can also be a number)
    let defaultId = (0, $25dFS.useId)();
    id ||= defaultId;
    let isExpanded = groupState ? groupState.expandedKeys.has(id) : props.isExpanded;
    let state = (0, $f3de1939d2a38e08$export$3fcbf6e4407997e0)({
        ...props,
        isExpanded: isExpanded,
        onExpandedChange (isExpanded) {
            if (groupState) groupState.toggleKey(id);
            props.onExpandedChange?.(isExpanded);
        }
    });
    let panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useRef(null);
    let isDisabled = props.isDisabled || groupState?.isDisabled || false;
    let { buttonProps: buttonProps, panelProps: panelProps } = (0, $bfef181444ee5605$export$6e3e27031a30522f)({
        ...props,
        isExpanded: isExpanded,
        isDisabled: isDisabled
    }, state, panelRef);
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        id: undefined,
        defaultClassName: 'react-aria-Disclosure',
        values: {
            isExpanded: state.isExpanded,
            isDisabled: isDisabled,
            isFocusVisibleWithin: isFocusVisibleWithin,
            state: state
        }
    });
    let domProps = (0, $fVfXf.filterDOMProps)(otherProps, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        [(0, $fDYaM.DEFAULT_SLOT)]: {},
                        trigger: buttonProps
                    }
                }
            ],
            [
                $1cff1fad781fe217$var$$a3e16eab0ea4036c$var$InternalDisclosureContext,
                {
                    panelProps: panelProps,
                    panelRef: panelRef
                }
            ],
            [
                $1cff1fad781fe217$export$dab3ea4a6ef094da,
                state
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(domProps, renderProps, focusWithinProps),
        ref: ref,
        "data-expanded": state.isExpanded || undefined,
        "data-disabled": isDisabled || undefined,
        "data-focus-visible-within": isFocusVisibleWithin || undefined
    }, renderProps.children));
});
const $1cff1fad781fe217$export$feabaa331e1d464c = (0, $eF4cA.forwardRef)(function DisclosurePanel(props, ref) {
    let { role: role = 'group' } = props;
    let { panelProps: panelProps, panelRef: panelRef } = (0, $eF4cA.useContext)($1cff1fad781fe217$var$$a3e16eab0ea4036c$var$InternalDisclosureContext);
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-DisclosurePanel',
        values: {
            isFocusVisibleWithin: isFocusVisibleWithin
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true,
        labelable: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, panelProps, focusWithinProps),
        ref: (0, $bkjeZ.mergeRefs)(ref, panelRef),
        role: role,
        "data-focus-visible-within": isFocusVisibleWithin || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $k5Pnh.ButtonContext),
                null
            ]
        ]
    }, props.children));
});



var $fVfXf = parcelRequire("fVfXf");

var $1O9kP = parcelRequire("1O9kP");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a6bf03053d5f3ea4$export$d665dd135a51b28a = (0, $eF4cA.createContext)(null);
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$disclosure = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    rules += ' po182';
    if (props.isQuiet) rules += ' _ka182';
    else rules += ' _kb182';
    if (props.isInGroup) {
        rules += ' ha182';
        if (props.isQuiet) rules += ' hka182';
        else rules += ' hkb182';
    } else if (props.isQuiet) rules += ' ha182';
    else rules += ' hb182';
    rules += ' ma182';
    rules += ' la182';
    rules += ' _jf182';
    rules += ' ir182';
    if (!minWidth) rules += ' Ng182';
    return rules;
};
const $a6bf03053d5f3ea4$export$74a362b31437ec83 = (0, $eF4cA.forwardRef)(function Disclosure(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $a6bf03053d5f3ea4$export$d665dd135a51b28a);
    let { size: size = 'M', density: density = 'regular', isQuiet: isQuiet, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let isInGroup = (0, $eF4cA.useContext)($a6bf03053d5f3ea4$export$d665dd135a51b28a) !== null;
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                $a6bf03053d5f3ea4$export$d665dd135a51b28a,
                {
                    size: size,
                    isQuiet: isQuiet,
                    density: density
                }
            ]
        ],
        children: (0, $dx4lB.jsx)((0, $1cff1fad781fe217$export$74a362b31437ec83), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + $a6bf03053d5f3ea4$var$$cf1d656285911959$var$disclosure({
                isQuiet: isQuiet,
                isInGroup: isInGroup
            }, props.styles),
            children: props.children
        })
    });
});
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$headingStyle = " Jy182 Gy182 Iy182 Hy182 _ub182 sd182 _vb182 Na182";
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$buttonStyles = function anonymous(props, overrides) {
    let rules = " ";
    let fontFamily = false;
    let __fs = false;
    let fontSize = false;
    let fontWeight = false;
    let fontVariationSettings = false;
    let fontSynthesisWeight = false;
    let lineHeight = false;
    let flexGrow = false;
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|u|x|w|_x|_F|-_6BNtrc-|v)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "u") fontFamily = true;
        if (p[1] === "-_6BNtrc-") __fs = true;
        if (p[1] === "v") fontSize = true;
        if (p[1] === "x") fontWeight = true;
        if (p[1] === "w") fontVariationSettings = true;
        if (p[1] === "_x") fontSynthesisWeight = true;
        if (p[1] === "_F") lineHeight = true;
        if (p[1] === "_u") flexGrow = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kb182';
    if (!fontFamily) rules += ' uk182';
    if (!fontFamily) rules += ' ucJ9TBTb182';
    if (!fontFamily) rules += ' ud3Euai182';
    if (!fontFamily) rules += ' uea182';
    if (!fontFamily) rules += ' ugb182';
    if (!fontFamily) rules += ' uhd182';
    if (!fontFamily) rules += ' uje182';
    if (!fontFamily) rules += ' u2NhKxcl182';
    if (!fontFamily) rules += ' uic182';
    if (props.size === "XL") {
        if (!__fs) rules += ' -_6BNtrc-f182';
        if (!fontSize) rules += ' vx182';
    } else if (props.size === "L") {
        if (!__fs) rules += ' -_6BNtrc-e182';
        if (!fontSize) rules += ' vx182';
    } else if (props.size === "M") {
        if (!__fs) rules += ' -_6BNtrc-d182';
        if (!fontSize) rules += ' vx182';
    } else if (props.size === "S") {
        if (!__fs) rules += ' -_6BNtrc-c182';
        if (!fontSize) rules += ' vx182';
    }
    if (!fontWeight) rules += ' xd182';
    if (!fontSynthesisWeight) rules += ' _xa182';
    if (!fontWeight) rules += ' xX0cczbc182';
    if (!fontSynthesisWeight) rules += ' _xX0cczba182';
    if (!lineHeight) rules += ' _Fd182';
    if (!lineHeight) rules += ' _FnuYUweb182';
    if (props.isDisabled) {
        rules += ' pp182';
        rules += ' plc182';
    } else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
        rules += ' plb182';
    }
    rules += ' sd182';
    if (!flexGrow) rules += ' _ub182';
    rules += ' ea182';
    rules += ' S6FcKR182';
    rules += ' R6FcKR182';
    rules += ' Tu7Fubd182';
    rules += ' Qu7Fubd182';
    rules += ' U6FcKR182';
    rules += ' q6FcKR182';
    rules += ' MAyFGYc182';
    if (!width) rules += ' Za182';
    if (props.isPressed) rules += ' gnSjEFb182';
    else if (props.isHovered) rules += ' gabY4te182';
    else if (props.isFocusVisible) rules += ' gabY4te182';
    else rules += ' g9182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _kJ8iPYd182';
    rules += ' hXMFGYc182';
    rules += ' ma182';
    rules += ' la182';
    if (props.isQuiet) rules += ' ob182';
    else if (props.isFocusVisible) rules += ' ob182';
    else rules += ' od182';
    if (props.isQuiet) rules += ' nb182';
    else if (props.isFocusVisible) rules += ' nb182';
    else rules += ' nd182';
    if (props.isQuiet) rules += ' kb182';
    else if (props.isFocusVisible) rules += ' kb182';
    else rules += ' kd182';
    if (props.isQuiet) rules += ' jb182';
    else if (props.isFocusVisible) rules += ' jb182';
    else rules += ' jd182';
    rules += ' _Wd182';
    rules += ' __ca182';
    if (props.size === "XL") {
        if (props.density === "spacious") rules += ' -M_-Mj182';
        else if (props.density === "regular") rules += ' -M_-Mk182';
        else if (props.density === "compact") rules += ' -M_-Mh182';
    } else if (props.size === "L") {
        if (props.density === "spacious") rules += ' -M_-Mk182';
        else if (props.density === "regular") rules += ' -M_-Mh182';
        else if (props.density === "compact") rules += ' -M_-Mi182';
    } else if (props.size === "M") {
        if (props.density === "spacious") rules += ' -M_-Mh182';
        else if (props.density === "regular") rules += ' -M_-Mi182';
        else if (props.density === "compact") rules += ' -M_-Mg182';
    } else if (props.size === "S") {
        if (props.density === "spacious") rules += ' -M_-Mi182';
        else if (props.density === "regular") rules += ' -M_-Mg182';
        else if (props.density === "compact") rules += ' -M_-Me182';
    }
    rules += ' -_k_-_ka182';
    rules += ' -h_-ha182';
    return rules;
};
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Sd182';
    else if (props.isRTL) rules += ' _Sc182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' -_8sjo0b-t5ZbAob182';
    rules += ' _va182';
    return rules;
};
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$InternalDisclosureHeader = (0, $eF4cA.createContext)(null);
function $a6bf03053d5f3ea4$var$$cf1d656285911959$var$DisclosureHeaderWithForwardRef(props, ref) {
    let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, children: children } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { size: size, isQuiet: isQuiet, density: density } = (0, $fDYaM.useSlottedContext)($a6bf03053d5f3ea4$export$d665dd135a51b28a);
    // Shift button size down by 2 for compact density, 1 for regular/spacious to ensure there is space between the top and bottom of the action button and container
    let newSize = size;
    const sizes = [
        'XS',
        'S',
        'M',
        'L',
        'XL'
    ];
    const currentIndex = sizes.indexOf(size ?? 'M');
    const shift = density === 'compact' ? 2 : 1;
    newSize = sizes[Math.max(0, currentIndex - shift)];
    return (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
        values: [
            [
                (0, $4W5AG.ActionButtonContext),
                {
                    size: newSize,
                    isQuiet: isQuiet
                }
            ],
            [
                $a6bf03053d5f3ea4$var$$cf1d656285911959$var$InternalDisclosureHeader,
                {}
            ]
        ],
        children: (0, $dx4lB.jsx)("div", {
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + " sd182 eb182 Ub182 qb182",
            ref: domRef,
            children: children
        })
    });
}
const $a6bf03053d5f3ea4$export$1e037ddd32f5b8ac = (0, $eF4cA.forwardRef)($a6bf03053d5f3ea4$var$$cf1d656285911959$var$DisclosureHeaderWithForwardRef);
const $a6bf03053d5f3ea4$export$7843c6a5b3e340a2 = (0, $eF4cA.forwardRef)(function DisclosureTitle(props, ref) {
    let { level: level = 3, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', styles: styles, ...otherProps } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    const domProps = (0, $fVfXf.filterDOMProps)(otherProps);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { isExpanded: isExpanded } = (0, $eF4cA.useContext)((0, $1cff1fad781fe217$export$dab3ea4a6ef094da));
    let { size: size, density: density, isQuiet: isQuiet } = (0, $fDYaM.useSlottedContext)($a6bf03053d5f3ea4$export$d665dd135a51b28a);
    let isRTL = direction === 'rtl';
    let buttonTrigger = (0, $dx4lB.jsx)((0, $1O9kP.Heading), {
        ...domProps,
        level: level,
        ref: domRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + $a6bf03053d5f3ea4$var$$cf1d656285911959$var$headingStyle,
        children: (0, $dx4lB.jsxs)((0, $k5Pnh.Button), {
            className: (renderProps)=>$a6bf03053d5f3ea4$var$$cf1d656285911959$var$buttonStyles({
                    ...renderProps,
                    size: size,
                    density: density,
                    isQuiet: isQuiet
                }, styles),
            slot: "trigger",
            children: [
                (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                    children: (0, $dx4lB.jsx)((0, $hxsf4.default), {
                        size: size,
                        className: $a6bf03053d5f3ea4$var$$cf1d656285911959$var$chevronStyles({
                            isExpanded: isExpanded,
                            isRTL: isRTL
                        }),
                        "aria-hidden": "true"
                    })
                }),
                props.children
            ]
        })
    });
    let ctx = (0, $eF4cA.useContext)($a6bf03053d5f3ea4$var$$cf1d656285911959$var$InternalDisclosureHeader);
    if (ctx) return buttonTrigger;
    return (0, $dx4lB.jsx)($a6bf03053d5f3ea4$export$1e037ddd32f5b8ac, {
        children: buttonTrigger
    });
});
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$panelStyles = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 FfwmW1d182 _Nb182 Pb182 Ysgyfc182 Ydklsgce182 Xb182 Xdklsgcb182 _2b182 _2dklsgcb182";
const $a6bf03053d5f3ea4$var$$cf1d656285911959$var$panelInner = function anonymous(props) {
    let rules = " ";
    rules += ' Tt182';
    rules += ' Qf182';
    if (props.size === "XL") rules += ' Sz5EUbe182';
    else if (props.size === "L") rules += ' Se182';
    else if (props.size === "M") rules += ' SLabwmd182';
    else if (props.size === "S") rules += ' St182';
    if (props.size === "XL") rules += ' Rz5EUbe182';
    else if (props.size === "L") rules += ' Re182';
    else if (props.size === "M") rules += ' RLabwmd182';
    else if (props.size === "S") rules += ' Rt182';
    return rules;
};
const $a6bf03053d5f3ea4$export$feabaa331e1d464c = (0, $eF4cA.forwardRef)(function DisclosurePanel(props, ref) {
    let { UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', ...otherProps } = props;
    const domProps = (0, $fVfXf.filterDOMProps)(otherProps);
    let { size: size } = (0, $fDYaM.useSlottedContext)($a6bf03053d5f3ea4$export$d665dd135a51b28a);
    let panelRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $1cff1fad781fe217$export$feabaa331e1d464c), {
        ...domProps,
        ref: panelRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + $a6bf03053d5f3ea4$var$$cf1d656285911959$var$panelStyles,
        children: (0, $dx4lB.jsx)("div", {
            className: $a6bf03053d5f3ea4$var$$cf1d656285911959$var$panelInner({
                size: size
            }),
            children: props.children
        })
    });
});


var $8Muzv = parcelRequire("8Muzv");
var $c0XRK = parcelRequire("c0XRK");
var $8g9SZ = parcelRequire("8g9SZ");
var $3YPmU = parcelRequire("3YPmU");
var $91SAk = parcelRequire("91SAk");
var $j8RRT = parcelRequire("j8RRT");
var $hSW0F = parcelRequire("hSW0F");

var $15xG7 = parcelRequire("15xG7");

var $klXmP = parcelRequire("klXmP");

var $j7E4C = parcelRequire("j7E4C");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $88da991c28d9e725$var$$b76125e610607434$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M6.25 19q-.151 0-.294-.06c-.276-.118-.456-.39-.456-.69V15h-.75C2.683 15 1 13.317 1 11.25v-5.5C1 3.683 2.683 2 4.75 2h10.5C17.317 2 19 3.683 19 5.75v5.5c0 2.067-1.683 3.75-3.75 3.75h-4.543l-3.936 3.79c-.143.138-.33.21-.521.21M4.75 3.5C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.236l2.884-2.776c.14-.135.326-.21.52-.21h4.846c1.24 0 2.25-1.01 2.25-2.25v-5.5c0-1.24-1.01-2.25-2.25-2.25z"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 5.5,
                cy: 8.5,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 10,
                cy: 8.5,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            (0, $dx4lB.jsx)("circle", {
                cx: 14.5,
                cy: 8.5,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            })
        ]
    });
const $88da991c28d9e725$var$$b76125e610607434$var$ForwardRef = (0, $eF4cA.forwardRef)($88da991c28d9e725$var$$b76125e610607434$var$SvgComponent);
var $88da991c28d9e725$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($88da991c28d9e725$var$$b76125e610607434$var$ForwardRef);




var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $jBZxV = parcelRequire("jBZxV");

var $iLDMH = parcelRequire("iLDMH");
const $063f773168f4b77e$var$VIDEO_EXTENSIONS = new Set([
    "mp4",
    "webm",
    "mov",
    "m4v",
    "ogv"
]);
const $063f773168f4b77e$var$isVideoPath = (path)=>{
    if (!path) return false;
    const ext = path.split("?")[0].split("#")[0].split(".").pop()?.toLowerCase();
    return !!ext && $063f773168f4b77e$var$VIDEO_EXTENSIONS.has(ext);
};
const $063f773168f4b77e$export$b813e5a72f7fef2c = ({ filePath: filePath, alt: alt, src: src, type: type, color: color, width: width, height: height, isLoading: isLoading })=>{
    const resolvedType = type ?? ($063f773168f4b77e$var$isVideoPath(filePath) || $063f773168f4b77e$var$isVideoPath(src) ? "video" : undefined);
    if (resolvedType === "video") return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
        filePath: filePath,
        src: src,
        isLoading: isLoading,
        className: " sb182 _Hb182 Za182 fcJcitc182"
    });
    if (resolvedType === "color") return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        role: "img",
        "aria-label": alt,
        className: " sb182 Za182 fa182 ob182 nb182 kb182 jb182",
        style: {
            backgroundColor: color || undefined,
            backgroundImage: color ? undefined : "linear-gradient(to bottom right, transparent calc(50% - 1px), var(--spectrum-gray-400) calc(50% - 1px) calc(50% + 1px), transparent calc(50% + 1px))"
        }
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
        alt: alt,
        filePath: filePath,
        src: src,
        isLoading: isLoading,
        styles: " _Hb182",
        UNSAFE_style: width && height ? {
            aspectRatio: `${width} / ${height}`
        } : undefined
    });
};
$063f773168f4b77e$export$b813e5a72f7fef2c.propTypes = {
    filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    alt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "image",
        "video",
        "color"
    ]),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).number,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};



var $iKDEm = parcelRequire("iKDEm");



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $7uz0i = parcelRequire("7uz0i");
var $bsn7e = parcelRequire("bsn7e");
var $j8RRT = parcelRequire("j8RRT");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $23940436408f12ff$var$$a7caa8c8baef183c$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M5.506 18.63c-.36 0-.719-.112-1.027-.337-.594-.431-.854-1.168-.66-1.876l.977-3.577c.079-.29-.02-.596-.254-.783l-2.893-2.32c-.573-.459-.796-1.207-.57-1.906.228-.698.848-1.172 1.582-1.206l3.703-.176c.3-.014.56-.204.665-.483l1.313-3.469c.26-.687.902-1.131 1.637-1.131s1.376.444 1.636 1.13v.001l1.31 3.468c.107.28.369.47.667.484l3.704.176c.733.034 1.354.508 1.582 1.207.226.698.003 1.447-.57 1.906l-2.894 2.32c-.232.186-.333.493-.254.782l.977 3.574c.193.71-.067 1.448-.662 1.879-.598.434-1.38.447-1.994.041l-3.07-2.036c-.252-.166-.576-.166-.827-.002l-3.117 2.045c-.295.193-.628.29-.961.29M9.979 2.866c-.08 0-.184.028-.235.162L8.433 6.496c-.317.839-1.101 1.409-1.998 1.451l-3.704.176c-.142.006-.2.097-.225.172s-.03.183.08.273l2.893 2.319c.702.56 1.001 1.483.764 2.349l-.977 3.576c-.038.137.03.222.094.268.063.045.162.086.285.007l3.117-2.045c.753-.493 1.725-.492 2.476.005l3.072 2.037c.12.08.221.04.285-.006.064-.047.133-.13.094-.268l-.976-3.575c-.236-.866.063-1.787.764-2.348l2.893-2.32c.111-.088.106-.197.081-.272s-.083-.166-.225-.172l-3.705-.176c-.895-.042-1.68-.612-1.998-1.45l-1.31-3.47c-.05-.133-.155-.161-.234-.161"
        })
    });
const $23940436408f12ff$var$$a7caa8c8baef183c$var$ForwardRef = (0, $eF4cA.forwardRef)($23940436408f12ff$var$$a7caa8c8baef183c$var$SvgComponent);
var $23940436408f12ff$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($23940436408f12ff$var$$a7caa8c8baef183c$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $1a77093d8eb50e23$var$$3ac2bbc724cd4fd2$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M11.495 2.414 12.7 5.597c.211.56.735.94 1.332.968l3.4.161c1.492.07 2.103 1.951.937 2.886l-2.656 2.128c-.467.375-.667.99-.508 1.568l.896 3.26c.396 1.444-1.207 2.608-2.457 1.785l-2.819-1.858c-.5-.33-1.147-.33-1.648-.002l-2.867 1.88c-1.249.82-2.848-.342-2.454-1.783l.898-3.284c.158-.577-.042-1.192-.509-1.566L1.59 9.612c-1.167-.935-.556-2.815.937-2.886l3.4-.161c.597-.028 1.12-.409 1.332-.968L8.46 2.414c.529-1.398 2.506-1.398 3.034 0"
        })
    });
const $1a77093d8eb50e23$var$$3ac2bbc724cd4fd2$var$ForwardRef = (0, $eF4cA.forwardRef)($1a77093d8eb50e23$var$$3ac2bbc724cd4fd2$var$SvgComponent);
var $1a77093d8eb50e23$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($1a77093d8eb50e23$var$$3ac2bbc724cd4fd2$var$ForwardRef);



var $eF4cA = parcelRequire("eF4cA");

var $k6waQ = parcelRequire("k6waQ");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $8ab71db6e91bee4a$export$bb49354201e9807f = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/feedback"]);
const $8ab71db6e91bee4a$export$6643a635d46d8855 = async (feedback, options = {})=>{
    const response = await $8ab71db6e91bee4a$export$bb49354201e9807f.post("/", feedback, options);
    if (!response.ok) throw new Error("Failed to submit feedback", {
        cause: response
    });
    return response.data;
};



var $fmJ8d = parcelRequire("fmJ8d");
const $8fa124be32935d0d$export$85e10bda1d878417 = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: (feedback, { signal: signal })=>(0, $8ab71db6e91bee4a$export$6643a635d46d8855)(feedback, {
                signal: signal
            }),
        onSuccess: ()=>{
            (0, $fmJ8d.store).getState().addToast("Thanks for your feedback!", {
                variant: "positive",
                timeout: 5000
            });
        },
        meta: {
            errorMessage: "Failed to submit feedback. Please try again."
        },
        ...options
    });
};
const $8fa124be32935d0d$export$cb6c49bc277cb055 = ()=>{
    const [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    const open = (0, $eF4cA.useCallback)(()=>setIsOpen(true), []);
    const close = (0, $eF4cA.useCallback)(()=>setIsOpen(false), []);
    return {
        isOpen: isOpen,
        open: open,
        close: close,
        method: "manual"
    };
};


const $5e54d0a0882391be$var$MAX_RATING = 5;
const $5e54d0a0882391be$var$StarRating = ({ value: value, onChange: onChange })=>{
    const [hovered, setHovered] = (0, $eF4cA.useState)(0);
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        role: "group",
        "aria-label": "Rating",
        className: " sd182",
        children: Array.from({
            length: $5e54d0a0882391be$var$MAX_RATING
        }, (_, index)=>index + 1).map((star)=>{
            const filled = star <= (hovered || value);
            return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                isQuiet: true,
                "aria-label": `${star} star${star > 1 ? "s" : ""}`,
                onPress: ()=>onChange(star),
                onHoverStart: ()=>setHovered(star),
                onHoverEnd: ()=>setHovered(0),
                children: filled ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1a77093d8eb50e23$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $23940436408f12ff$export$2e2bcd8739ae039), {})
            }, star);
        })
    });
};
// Shared rating + comment fields used by both the dialog and inline layouts.
const $5e54d0a0882391be$var$FeedbackFields = ({ rating: rating, setRating: setRating, comment: comment, setComment: setComment, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Ul182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 Gv182",
                        children: "Rating"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)($5e54d0a0882391be$var$StarRating, {
                        value: rating,
                        onChange: setRating
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                label: "Comment",
                value: comment,
                onChange: setComment,
                isRequired: rating < 4,
                isDisabled: isDisabled
            })
        ]
    });
const $5e54d0a0882391be$export$ce3b880e766d1e30 = ({ video: video, variant: variant = "dialog", title: title = "Share your feedback", isOpen: isOpen, onClose: onClose, currentStep: currentStep, method: method, styles: styles })=>{
    const [rating, setRating] = (0, $eF4cA.useState)(0);
    const [comment, setComment] = (0, $eF4cA.useState)("");
    const [submitted, setSubmitted] = (0, $eF4cA.useState)(false);
    const submitFeedback = (0, $8fa124be32935d0d$export$85e10bda1d878417)();
    const isInline = variant === "inline";
    const isSubmitDisabled = rating < 1 || rating < 4 && !comment || submitFeedback.isPending;
    // Dialog mode: reset the form whenever it closes so it reopens fresh.
    (0, $eF4cA.useEffect)(()=>{
        if (!isInline && !isOpen) {
            setRating(0);
            setComment("");
        }
    }, [
        isInline,
        isOpen
    ]);
    const handleSubmit = ()=>{
        submitFeedback.mutate({
            videoId: video?.id,
            rating: rating,
            comment: comment,
            currentStep: currentStep,
            method: method
        }, {
            onSuccess: ()=>{
                if (isInline) setSubmitted(true);
                else onClose?.();
            }
        });
    };
    if (isInline) return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " _oa182 sd182 _ta182 Ul182 Th182 Tok182 Qh182 Qok182 Sh182 Sok182 Rh182 Rok182 oe182 ne182 ke182 je182 g_g182" + styles,
        children: submitted ? /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: " sd182 eb182 Ue182 qe182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1a77093d8eb50e23$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: "Thanks for your feedback!"
                })
            ]
        }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                    children: title
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)($5e54d0a0882391be$var$FeedbackFields, {
                    rating: rating,
                    setRating: setRating,
                    comment: comment,
                    setComment: setComment,
                    isDisabled: submitFeedback.isPending
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                    variant: "primary",
                    onPress: handleSubmit,
                    isDisabled: isSubmitDisabled,
                    styles: " IM182 JC182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "Submit"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
        onDismiss: ()=>onClose?.(),
        children: isOpen && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $7uz0i.Dialog), {
            size: "S",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    slot: "title",
                    children: title
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)($5e54d0a0882391be$var$FeedbackFields, {
                        rating: rating,
                        setRating: setRating,
                        comment: comment,
                        setComment: setComment,
                        isDisabled: submitFeedback.isPending
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "secondary",
                            onPress: ()=>onClose?.(),
                            isDisabled: submitFeedback.isPending,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "accent",
                            onPress: handleSubmit,
                            isDisabled: isSubmitDisabled,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Submit"
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $dqZbZ = parcelRequire("dqZbZ");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $7uz0i = parcelRequire("7uz0i");

var $klXmP = parcelRequire("klXmP");

var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");
const $d5b82dd9a55d3518$export$b8b2cd85c234bed = ({ videoId: videoId })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const video = (0, $ikOQe.useVideo)(videoId);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const videoUrlQuery = (0, $a8sj2.usePresignURL)(video.data?.videoPath);
    const handleEdit = ()=>{
        updateVideo.mutate({
            videoPath: null,
            jobId: null
        }, {
            onSuccess: ()=>{
                navigate(`/projects/new/${videoId}`);
            }
        });
    };
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7uz0i.Dialog), {
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                        slot: "title",
                        children: [
                            "Edit ",
                            video.data?.name ?? "",
                            " project"
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                children: "Editing project will overwrite existing data."
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                children: "Would you like to download a backup before proceeding?"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                href: videoUrlQuery.data?.presignURL,
                                download: true,
                                isDisabled: videoUrlQuery.isLoading,
                                fillStyle: "outline",
                                variant: "secondary",
                                size: "M",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Download video"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                onPress: close,
                                variant: "secondary",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                onPress: handleEdit,
                                variant: "primary",
                                isPending: updateVideo.isPending,
                                children: "Edit"
                            })
                        ]
                    })
                ]
            })
    });
};



var $ikOQe = parcelRequire("ikOQe");

var $CGZx1 = parcelRequire("CGZx1");

var $a8sj2 = parcelRequire("a8sj2");

var $fL0wx = parcelRequire("fL0wx");

var $lRNYL = parcelRequire("lRNYL");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $yuTTo = parcelRequire("yuTTo");
var $j8RRT = parcelRequire("j8RRT");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $42ffa0b30e8dec27$var$$8f8d341cb191e44e$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                stroke: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 8,
                d: "M43.904 93.334v46.91M34.523 140.244h18.765M20.451 93.334h46.91M20.451 93.334v9.382M67.361 93.334v9.382"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M135.987 20.165c-1.487-2.337-4.032-3.899-6.833-4.08Zm-6.833-4.08c-1.734-.313-3.281.29-4.126.71-1.111.555-2.166 1.372-2.977 2.309l-.005.006-20.54 23.904-.006.007c-1.83 2.14-2.557 5.035-1.964 7.795.588 2.736 2.423 5.116 5.043 6.286h.002l4.249 1.904-3.764 9.281-.002.005c-1.102 2.702-.858 5.807.729 8.287 1.591 2.498 4.38 4.087 7.379 4.087 2.555 0 4.892-1.132 6.533-3.03l20.427-23.572c1.873-2.156 2.59-5.081 2.001-7.839-.59-2.756-2.444-5.144-5.095-6.302l-.007-.003-4.245-1.867 3.919-9.59.003-.007c1.096-2.698.871-5.793-.72-8.29m-7.889 4.174L107.58 48.22l-.002.003c-.197.231-.292.578-.22.913.077.359.301.58.483.661l.005.002 11.299 5.06-6.669 16.444-.004.01c-.146.356-.09.72.06.954l.004.007.005.007c.168.264.45.385.631.385.122 0 .287-.037.483-.264l20.437-23.583c.187-.216.293-.566.217-.921-.075-.353-.292-.565-.473-.643l-.006-.003-11.397-5.013 6.864-16.795.001-.003c.153-.38.093-.74-.057-.976l-.003-.005c-.175-.276-.463-.393-.631-.393h-.195q-.04.03-.084.063c-.105.08-.182.156-.226.207zM71.207 36.667c0-5.154-4.179-9.333-9.333-9.333H24.999c-5.155 0-9.334 4.179-9.334 9.333v21.25q0 .398.033.787l10.006-15.459.001-.002c3.03-4.681 9.886-4.681 12.915 0v.002l9.146 14.127 4.448-6.725.017-.026c3.045-4.529 9.72-4.543 12.77 0l6.056 8.972q.15-.817.15-1.676zM32.163 47.99 20.458 66.073c1.344.75 2.892 1.178 4.54 1.178h16.234l1.718-2.598zm33.782 18.328c-1.23.598-2.612.933-4.071.933h-11.05l7.795-11.786zm-4.071-46.984c9.573 0 17.333 7.76 17.333 17.333v21.25c0 9.573-7.76 17.334-17.333 17.334H24.999c-9.573 0-17.334-7.76-17.334-17.334v-21.25c0-9.573 7.76-17.333 17.334-17.333zm-3.9 16.285c0 2.397 1.943 4.34 4.34 4.34s4.34-1.943 4.34-4.34c0-2.398-1.943-4.34-4.34-4.34s-4.34 1.942-4.34 4.34M148.5 106.667c0-5.154-4.179-9.333-9.333-9.333h-35.834c-5.154 0-9.333 4.179-9.333 9.333v21.25c0 5.155 4.179 9.334 9.333 9.334h35.834c5.154 0 9.333-4.179 9.333-9.334zm-9.333-17.333c9.573 0 17.333 7.76 17.333 17.333v21.25c0 9.573-7.76 17.334-17.333 17.334h-35.834C93.76 145.251 86 137.49 86 127.917v-21.25c0-9.573 7.76-17.333 17.333-17.333zm-21.375 19.08 12.296 7.019c1.377.786 1.375 2.747-.004 3.53l-12.314 6.99c-1.379.783-3.1-.199-3.098-1.768l.017-14.01c.002-1.569 1.726-2.548 3.103-1.761"
            })
        ]
    });
const $42ffa0b30e8dec27$var$$8f8d341cb191e44e$var$ForwardRef = (0, $eF4cA.forwardRef)($42ffa0b30e8dec27$var$$8f8d341cb191e44e$var$SvgComponent);
var $42ffa0b30e8dec27$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($42ffa0b30e8dec27$var$$8f8d341cb191e44e$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $e49e625e1cdc6b08$var$$899d7209fd5ddcdd$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                stroke: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 4,
                d: "M26.342 56v28.146M20.713 84.147H31.97M12.27 56h28.146M12.27 56v5.63M40.416 56v5.63"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M43.125 22c0-3.314-2.686-6-6-6H15c-3.314 0-6 2.686-6 6v12.75c0 .535.07 1.053.201 1.546l6.558-10.132c1.66-2.567 5.418-2.567 7.078-.001l5.82 8.99 3.006-4.545.008-.013c1.67-2.482 5.328-2.49 6.998 0l.002.004 4.126 6.112c.213-.615.328-1.274.328-1.961zm-24.007 6.337-7.402 11.435c.943.618 2.072.978 3.284.978h9.955l1.294-1.956-6.77-10.457v-.001c-.028-.042-.054-.061-.076-.073q-.041-.023-.105-.024-.064.002-.104.024c-.023.012-.049.03-.076.073m21.03 11.597c-.888.519-1.92.816-3.023.816H29.75l5.243-7.926c.089-.128.273-.12.354 0l.005.006zM37.124 12c5.523 0 10 4.477 10 10v12.75c0 5.523-4.477 10-10 10H15c-5.523 0-10-4.477-10-10V22c0-5.523 4.477-10 10-10zm-1.74 8.77c0 1.44 1.166 2.605 2.605 2.605 1.438 0 2.604-1.166 2.604-2.604s-1.166-2.604-2.605-2.604c-1.438 0-2.604 1.166-2.604 2.604"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m78.052 69.259-7.377-4.212c-.827-.471-1.86.116-1.862 1.057l-.01 8.406c-.001.941 1.031 1.53 1.859 1.061l7.388-4.194c.827-.47.829-1.646.002-2.118M67.9 47.995c-1.63 0-3.2-.87-4.09-2.27-.87-1.36-1.02-3.08-.4-4.61l2.4-5.93-2.9-1.3c-1.42-.63-2.46-1.94-2.8-3.49-.33-1.53.08-3.15 1.09-4.33l12.33-14.34c.9-1.03 2.46-1.94 3.91-1.68 1.53.09 2.97.94 3.82 2.27.87 1.36 1.02 3.08.4 4.61l-2.5 6.12 2.91 1.28c1.43.62 2.49 1.93 2.82 3.5.33 1.55-.08 3.17-1.11 4.36l-12.26 14.15c-.94 1.08-2.22 1.68-3.62 1.68zm9.03-33.96c-.11.06-.26.17-.38.3l-12.32 14.33c-.2.24-.29.57-.22.89.07.31.26.57.52.68l6.43 2.88-3.86 9.51c-.13.32-.1.68.07.95.3.46.94.56 1.31.13l12.26-14.15c.2-.24.29-.58.22-.9-.07-.31-.26-.56-.52-.67l-6.48-2.85 3.97-9.72c.13-.32.11-.68-.07-.95-.16-.25-.45-.42-.72-.42h-.23z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M83.5 86.746H62c-5.51 0-10-4.49-10-10v-12.75c0-5.51 4.49-10 10-10h21.5c5.51 0 10 4.49 10 10v12.75c0 5.51-4.49 10-10 10M62 57.996c-3.31 0-6 2.69-6 6v12.75c0 3.31 2.69 6 6 6h21.5c3.31 0 6-2.69 6-6v-12.75c0-3.31-2.69-6-6-6z"
            })
        ]
    });
const $e49e625e1cdc6b08$var$$899d7209fd5ddcdd$var$ForwardRef = (0, $eF4cA.forwardRef)($e49e625e1cdc6b08$var$$899d7209fd5ddcdd$var$SvgComponent);
var $e49e625e1cdc6b08$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($e49e625e1cdc6b08$var$$899d7209fd5ddcdd$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $40b501b85d13217e$var$$029a1cdffa7fef7b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                stroke: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.5,
                d: "M13.172 28v14.073M10.36 42.074h5.629M6.137 28H20.21M6.137 28v2.815M20.21 28v2.815"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M38.615 7.285c-.01.005-.036.021-.07.062l-6.163 7.24c-.075.089-.045.225.061.273l3.452 1.564-2.016 5.04c-.02.049-.021.078-.022.09q0 .017.005.03c.008.02.034.06.089.094.055.033.102.038.124.035q.014 0 .03-.009c.01-.006.035-.02.07-.061l6.168-7.138c.077-.09.045-.229-.064-.276l-3.546-1.516 2.107-5.186c.02-.05.022-.08.022-.092q0-.016-.005-.03c-.007-.02-.033-.06-.089-.094s-.103-.038-.125-.035q-.014 0-.028.009M36.64 5.727c1.97-2.314 5.66-.075 4.516 2.74l-1.183 2.912 1.29.552c1.665.712 2.156 2.838.971 4.209l-6.168 7.137c-1.974 2.284-5.629.06-4.508-2.742l1.128-2.82-1.275-.578c-1.62-.734-2.085-2.815-.933-4.17zM21.313 11c0-1.519-1.232-2.75-2.75-2.75H7.5c-1.519 0-2.75 1.231-2.75 2.75v6.375l.001.08 2.919-4.509c.928-1.435 3.03-1.435 3.958 0l2.703 4.174 1.292-1.954.005-.008c.933-1.388 2.98-1.392 3.914 0l1.746 2.586q.024-.18.024-.369zM9.649 14.489l-3.44 5.315c.385.205.824.321 1.291.321h4.843l.483-.73zm10.06 5.386c-.348.16-.737.25-1.146.25H15.34l2.245-3.396zM18.564 5.75c2.899 0 5.25 2.35 5.25 5.25v6.375c0 2.9-2.351 5.25-5.25 5.25H7.5c-2.9 0-5.25-2.35-5.25-5.25V11c0-2.9 2.35-5.25 5.25-5.25zm-.87 4.636c0 .719.583 1.302 1.302 1.302s1.302-.583 1.302-1.302-.583-1.302-1.302-1.302-1.302.582-1.302 1.302M44.5 32c0-1.519-1.231-2.75-2.75-2.75H31c-1.519 0-2.75 1.231-2.75 2.75v6.375c0 1.519 1.231 2.75 2.75 2.75h10.75c1.519 0 2.75-1.231 2.75-2.75zm-2.75-5.25c2.9 0 5.25 2.35 5.25 5.25v6.375c0 2.9-2.35 5.25-5.25 5.25H31c-2.9 0-5.25-2.35-5.25-5.25V32c0-2.9 2.35-5.25 5.25-5.25zm-6.413 5.774 3.69 2.106c.412.236.412.824-.002 1.059l-3.694 2.097c-.414.235-.93-.06-.93-.53l.005-4.203c.001-.471.518-.765.931-.529"
            })
        ]
    });
const $40b501b85d13217e$var$$029a1cdffa7fef7b$var$ForwardRef = (0, $eF4cA.forwardRef)($40b501b85d13217e$var$$029a1cdffa7fef7b$var$SvgComponent);
var $40b501b85d13217e$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($40b501b85d13217e$var$$029a1cdffa7fef7b$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ab17b54c80fc8a2e$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $42ffa0b30e8dec27$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $40b501b85d13217e$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $e49e625e1cdc6b08$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}






var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
parcelRequire("l19Vn");

var $4W5AG = parcelRequire("4W5AG");
var $fZShI = parcelRequire("fZShI");
var $208Op = parcelRequire("208Op");
var $hSW0F = parcelRequire("hSW0F");

var $9iR3a = parcelRequire("9iR3a");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $fdf9f573ae2779ee$var$$39749ed6ccdf5c60$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M6.75 18h-2.5C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v11.5C9 16.99 7.99 18 6.75 18M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75zM15.75 18h-2.5C12.01 18 11 16.99 11 15.75V4.25C11 3.01 12.01 2 13.25 2h2.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-14.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M6.75 18h-2.5C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v11.5C9 16.99 7.99 18 6.75 18M4.25 3.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75zM15.75 18h-2.5C12.01 18 11 16.99 11 15.75V4.25C11 3.01 12.01 2 13.25 2h2.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-14.5c-.414 0-.75.337-.75.75v11.5c0 .413.336.75.75.75h2.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75z"
            })
        ]
    });
const $fdf9f573ae2779ee$var$$39749ed6ccdf5c60$var$ForwardRef = (0, $eF4cA.forwardRef)($fdf9f573ae2779ee$var$$39749ed6ccdf5c60$var$SvgComponent);
var $fdf9f573ae2779ee$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($fdf9f573ae2779ee$var$$39749ed6ccdf5c60$var$ForwardRef);



function $419ca02d64eacc2f$var$t(t, e, i, n) {
    return new (i || (i = Promise))(function(s, r) {
        function o(t) {
            try {
                l(n.next(t));
            } catch (t) {
                r(t);
            }
        }
        function a(t) {
            try {
                l(n.throw(t));
            } catch (t) {
                r(t);
            }
        }
        function l(t) {
            var e;
            t.done ? s(t.value) : (e = t.value, e instanceof i ? e : new i(function(t) {
                t(e);
            })).then(o, a);
        }
        l((n = n.apply(t, e || [])).next());
    });
}
"function" == typeof SuppressedError && SuppressedError;
class $419ca02d64eacc2f$var$e {
    constructor(){
        this.listeners = {};
    }
    on(t, e, i) {
        if (this.listeners[t] || (this.listeners[t] = new Set), null == i ? void 0 : i.once) {
            const i = (...n)=>{
                this.un(t, i), e(...n);
            };
            return this.listeners[t].add(i), ()=>this.un(t, i);
        }
        return this.listeners[t].add(e), ()=>this.un(t, e);
    }
    un(t, e) {
        var i;
        null === (i = this.listeners[t]) || void 0 === i || i.delete(e);
    }
    once(t, e) {
        return this.on(t, e, {
            once: !0
        });
    }
    unAll() {
        this.listeners = {};
    }
    emit(t, ...e) {
        this.listeners[t] && this.listeners[t].forEach((t)=>t(...e));
    }
}
const $419ca02d64eacc2f$var$i = {
    decode: function(e, i) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            const t = new AudioContext({
                sampleRate: i
            });
            try {
                return yield t.decodeAudioData(e);
            } finally{
                "closed" !== t.state && (yield t.close().catch(()=>{}));
            }
        });
    },
    createBuffer: function(t, e) {
        if (!t || 0 === t.length) throw new Error("channelData must be a non-empty array");
        if (e <= 0) throw new Error("duration must be greater than 0");
        if ("number" == typeof t[0] && (t = [
            t
        ]), !t[0] || 0 === t[0].length) throw new Error("channelData must contain non-empty channel arrays");
        !function(t) {
            const e = t[0];
            if (e.some((t)=>t > 1 || t < -1)) {
                const i = e.length;
                let n = 0;
                for(let t = 0; t < i; t++){
                    const i = Math.abs(e[t]);
                    i > n && (n = i);
                }
                for (const e of t)for(let t = 0; t < i; t++)e[t] /= n;
            }
        }(t);
        const i = t.map((t)=>t instanceof Float32Array ? t : Float32Array.from(t));
        return {
            duration: e,
            length: i[0].length,
            sampleRate: i[0].length / e,
            numberOfChannels: i.length,
            getChannelData: (t)=>{
                const e = i[t];
                if (!e) throw new Error(`Channel ${t} not found`);
                return e;
            },
            copyFromChannel: AudioBuffer.prototype.copyFromChannel,
            copyToChannel: AudioBuffer.prototype.copyToChannel
        };
    }
};
function $419ca02d64eacc2f$var$n(t, e) {
    const i = e.xmlns ? document.createElementNS(e.xmlns, t) : document.createElement(t);
    for (const [t, s] of Object.entries(e))if ("children" === t && s) for (const [t, e] of Object.entries(s))e instanceof Node ? i.appendChild(e) : "string" == typeof e ? i.appendChild(document.createTextNode(e)) : i.appendChild($419ca02d64eacc2f$var$n(t, e));
    else "style" === t ? Object.assign(i.style, s) : "textContent" === t ? i.textContent = s : i.setAttribute(t, s.toString());
    return i;
}
function $419ca02d64eacc2f$var$s(t, e, i) {
    const s = $419ca02d64eacc2f$var$n(t, e || {});
    return null == i || i.appendChild(s), s;
}
function $419ca02d64eacc2f$var$r(t) {
    return t instanceof HTMLElement || "object" == typeof t && null !== t && t.nodeType === Node.ELEMENT_NODE && "object" == typeof t.style;
}
var $419ca02d64eacc2f$var$o = Object.freeze({
    __proto__: null,
    createElement: $419ca02d64eacc2f$var$s,
    default: $419ca02d64eacc2f$var$s,
    isHTMLElement: $419ca02d64eacc2f$var$r
});
const $419ca02d64eacc2f$var$a = {
    fetchBlob: function(e, i, n) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            var s;
            const r = yield fetch(e, n);
            if (r.status >= 400) throw new Error(`Failed to fetch ${e}: ${r.status} (${r.statusText})`);
            return function(e, i, n) {
                $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
                    var t;
                    if (!e.body || !e.headers) return;
                    const s = e.body.getReader(), r = Number(e.headers.get("Content-Length")) || 0;
                    let o = 0;
                    const a = ()=>{
                        s.cancel();
                    };
                    if (n) {
                        if (n.aborted) return void s.cancel();
                        n.addEventListener("abort", a, {
                            once: !0
                        });
                    }
                    try {
                        for(;;){
                            const e = yield s.read();
                            if (e.done) break;
                            if (o += (null === (t = e.value) || void 0 === t ? void 0 : t.length) || 0, r > 0) {
                                const t = Math.round(o / r * 100);
                                i(t);
                            }
                        }
                    } catch (t) {
                        if (t instanceof DOMException && "AbortError" === t.name) return;
                        console.warn("Progress tracking error:", t);
                    } finally{
                        n && n.removeEventListener("abort", a);
                    }
                });
            }(r.clone(), i, null !== (s = null == n ? void 0 : n.signal) && void 0 !== s ? s : void 0), r.blob();
        });
    }
};
function $419ca02d64eacc2f$var$l(t) {
    let e = t;
    const i = new Set;
    return {
        get value () {
            return e;
        },
        set (t) {
            Object.is(e, t) || (e = t, i.forEach((t)=>t(e)));
        },
        update (t) {
            this.set(t(e));
        },
        subscribe: (t)=>(i.add(t), ()=>i.delete(t))
    };
}
function $419ca02d64eacc2f$var$h(t, e) {
    const i = $419ca02d64eacc2f$var$l(t());
    return e.forEach((e)=>e.subscribe(()=>{
            const e = t();
            Object.is(i.value, e) || i.set(e);
        })), {
        get value () {
            return i.value;
        },
        subscribe: (t)=>i.subscribe(t)
    };
}
function $419ca02d64eacc2f$var$c(t, e) {
    let i;
    const n = ()=>{
        i && (i(), i = void 0), i = t();
    }, s = e.map((t)=>t.subscribe(n));
    return n(), ()=>{
        i && (i(), i = void 0), s.forEach((t)=>t());
    };
}
class $419ca02d64eacc2f$var$d extends $419ca02d64eacc2f$var$e {
    get isPlayingSignal() {
        return this._isPlaying;
    }
    get currentTimeSignal() {
        return this._currentTime;
    }
    get durationSignal() {
        return this._duration;
    }
    get volumeSignal() {
        return this._volume;
    }
    get mutedSignal() {
        return this._muted;
    }
    get playbackRateSignal() {
        return this._playbackRate;
    }
    get seekingSignal() {
        return this._seeking;
    }
    constructor(t){
        super(), this.isExternalMedia = !1, this._ownBlobUrl = null, this.reactiveMediaEventCleanups = [], t.media ? (this.media = t.media, this.isExternalMedia = !0) : this.media = document.createElement("audio"), this._isPlaying = $419ca02d64eacc2f$var$l(!1), this._currentTime = $419ca02d64eacc2f$var$l(0), this._duration = $419ca02d64eacc2f$var$l(0), this._volume = $419ca02d64eacc2f$var$l(this.media.volume), this._muted = $419ca02d64eacc2f$var$l(this.media.muted), this._playbackRate = $419ca02d64eacc2f$var$l(this.media.playbackRate || 1), this._seeking = $419ca02d64eacc2f$var$l(!1), this.setupReactiveMediaEvents(), t.mediaControls && (this.media.controls = !0), t.autoplay && (this.media.autoplay = !0), null != t.playbackRate && this.onMediaEvent("canplay", ()=>{
            null != t.playbackRate && (this.media.playbackRate = t.playbackRate);
        }, {
            once: !0
        });
    }
    setupReactiveMediaEvents() {
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("play", ()=>{
            this._isPlaying.set(!0);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("pause", ()=>{
            this._isPlaying.set(!1);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("ended", ()=>{
            this._isPlaying.set(!1);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("timeupdate", ()=>{
            this._currentTime.set(this.media.currentTime);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("durationchange", ()=>{
            this._duration.set(this.media.duration || 0);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("loadedmetadata", ()=>{
            this._duration.set(this.media.duration || 0);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("seeking", ()=>{
            this._seeking.set(!0);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("seeked", ()=>{
            this._seeking.set(!1);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("volumechange", ()=>{
            this._volume.set(this.media.volume), this._muted.set(this.media.muted);
        })), this.reactiveMediaEventCleanups.push(this.onMediaEvent("ratechange", ()=>{
            this._playbackRate.set(this.media.playbackRate);
        }));
    }
    onMediaEvent(t, e, i) {
        return this.media.addEventListener(t, e, i), ()=>this.media.removeEventListener(t, e, i);
    }
    getSrc() {
        return this.media.currentSrc || this.media.src || "";
    }
    revokeSrc() {
        this._ownBlobUrl && (URL.revokeObjectURL(this._ownBlobUrl), this._ownBlobUrl = null);
    }
    canPlayType(t) {
        return "" !== this.media.canPlayType(t);
    }
    setSrc(t, e) {
        const i = this.getSrc();
        if (t && i === t) return;
        this.revokeSrc();
        const n = e instanceof Blob && (this.canPlayType(e.type) || !t) ? URL.createObjectURL(e) : t;
        if (n !== t && (this._ownBlobUrl = n), i && this.media.removeAttribute("src"), n || t) try {
            this.media.src = n;
        } catch (e) {
            this.media.src = t;
        }
    }
    destroy() {
        this.reactiveMediaEventCleanups.forEach((t)=>t()), this.reactiveMediaEventCleanups = [], this.revokeSrc(), this.unAll(), this.isExternalMedia || (this.media.pause(), this.media.removeAttribute("src"), this.media.load(), this.media.remove());
    }
    setMediaElement(t) {
        this.reactiveMediaEventCleanups.forEach((t)=>t()), this.reactiveMediaEventCleanups = [], this.media = t, this.setupReactiveMediaEvents();
    }
    play() {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            try {
                return yield this.media.play();
            } catch (t) {
                if (t instanceof DOMException && "AbortError" === t.name) return;
                throw t;
            }
        });
    }
    pause() {
        this.media.pause();
    }
    isPlaying() {
        return !this.media.paused && !this.media.ended;
    }
    setTime(t) {
        this.media.currentTime = Math.max(0, Math.min(t, this.getDuration()));
    }
    getDuration() {
        return this.media.duration;
    }
    getCurrentTime() {
        return this.media.currentTime;
    }
    getVolume() {
        return this.media.volume;
    }
    setVolume(t) {
        this.media.volume = t;
    }
    getMuted() {
        return this.media.muted;
    }
    setMuted(t) {
        this.media.muted = t;
    }
    getPlaybackRate() {
        return this.media.playbackRate;
    }
    isSeeking() {
        return this.media.seeking;
    }
    setPlaybackRate(t, e) {
        null != e && (this.media.preservesPitch = e), this.media.playbackRate = t;
    }
    getMediaElement() {
        return this.media;
    }
    setSinkId(t) {
        return this.media.setSinkId(t);
    }
}
function $419ca02d64eacc2f$var$u({ maxTop: t, maxBottom: e, halfHeight: i, vScale: n, barMinHeight: s = 0, barAlign: r }) {
    let o = Math.round(t * i * n);
    let a = o + Math.round(e * i * n) || 1;
    return a < s && (a = s, r || (o = a / 2)), {
        topHeight: o,
        totalHeight: a
    };
}
function $419ca02d64eacc2f$var$p({ barAlign: t, halfHeight: e, topHeight: i, totalHeight: n, canvasHeight: s }) {
    return "top" === t ? 0 : "bottom" === t ? s - n : e - i;
}
function $419ca02d64eacc2f$var$m(t, e, i) {
    const n = e - t.left, s = i - t.top;
    return [
        n / t.width,
        s / t.height
    ];
}
function $419ca02d64eacc2f$var$g(t) {
    return Boolean(t.barWidth || t.barGap || t.barAlign);
}
function $419ca02d64eacc2f$var$f(t, e) {
    if (!$419ca02d64eacc2f$var$g(e)) return t;
    const i = e.barWidth || .5, n = i + (e.barGap || i / 2);
    return 0 === n ? t : Math.floor(t / n) * n;
}
function $419ca02d64eacc2f$var$v({ scrollLeft: t, totalWidth: e, numCanvases: i }) {
    if (0 === e) return [
        0
    ];
    const n = t / e, s = Math.floor(n * i);
    return [
        s - 1,
        s,
        s + 1
    ];
}
function $419ca02d64eacc2f$var$b(t) {
    const e = t._cleanup;
    "function" == typeof e && e();
}
function $419ca02d64eacc2f$var$y(t) {
    const e = $419ca02d64eacc2f$var$l({
        scrollLeft: t.scrollLeft,
        scrollWidth: t.scrollWidth,
        clientWidth: t.clientWidth
    }), i = $419ca02d64eacc2f$var$h(()=>(function(t) {
            const { scrollLeft: e, scrollWidth: i, clientWidth: n } = t;
            if (0 === i) return {
                startX: 0,
                endX: 1
            };
            const s = e / i, r = (e + n) / i;
            return {
                startX: Math.max(0, Math.min(1, s)),
                endX: Math.max(0, Math.min(1, r))
            };
        })(e.value), [
        e
    ]), n = $419ca02d64eacc2f$var$h(()=>(function(t) {
            return {
                left: t.scrollLeft,
                right: t.scrollLeft + t.clientWidth
            };
        })(e.value), [
        e
    ]), s = ()=>{
        e.set({
            scrollLeft: t.scrollLeft,
            scrollWidth: t.scrollWidth,
            clientWidth: t.clientWidth
        });
    };
    t.addEventListener("scroll", s, {
        passive: !0
    });
    return {
        scrollData: e,
        percentages: i,
        bounds: n,
        cleanup: ()=>{
            t.removeEventListener("scroll", s), $419ca02d64eacc2f$var$b(e);
        }
    };
}
class $419ca02d64eacc2f$var$C extends $419ca02d64eacc2f$var$e {
    constructor(t, e){
        super(), this.timeouts = [], this.isScrollable = !1, this.audioData = null, this.resizeObserver = null, this.lastContainerWidth = 0, this.isDragging = !1, this.subscriptions = [], this.unsubscribeOnScroll = [], this.dragStream = null, this.scrollStream = null, this.containerInlinePadding = 0, this.onClickWrapper = (t)=>{
            const e = this.wrapper.getBoundingClientRect(), [i, n] = $419ca02d64eacc2f$var$m(e, t.clientX, t.clientY);
            this.emit("click", i, n);
        }, this.onDblClickWrapper = (t)=>{
            const e = this.wrapper.getBoundingClientRect(), [i, n] = $419ca02d64eacc2f$var$m(e, t.clientX, t.clientY);
            this.emit("dblclick", i, n);
        }, this.subscriptions = [], this.options = t;
        const i = this.parentFromOptionsContainer(t.container);
        this.parent = i;
        const [n, s] = this.initHtml();
        i.appendChild(n), this.container = n, this.scrollContainer = s.querySelector(".scroll"), this.wrapper = s.querySelector(".wrapper"), this.canvasWrapper = s.querySelector(".canvases"), this.progressWrapper = s.querySelector(".progress"), this.cursor = s.querySelector(".cursor"), this.calculateInlinePadding(), e && s.appendChild(e), this.initEvents();
    }
    parentFromOptionsContainer(t) {
        let e;
        if ("string" == typeof t ? e = document.querySelector(t) : $419ca02d64eacc2f$var$r(t) && (e = t), !e) throw new Error("Container not found");
        return e;
    }
    initEvents() {
        this.wrapper.addEventListener("click", this.onClickWrapper), this.wrapper.addEventListener("dblclick", this.onDblClickWrapper), !0 !== this.options.dragToSeek && "object" != typeof this.options.dragToSeek || this.initDrag(), this.scrollStream = $419ca02d64eacc2f$var$y(this.scrollContainer);
        const t = $419ca02d64eacc2f$var$c(()=>{
            const { startX: t, endX: e } = this.scrollStream.percentages.value, { left: i, right: n } = this.scrollStream.bounds.value;
            this.emit("scroll", t, e, i, n);
        }, [
            this.scrollStream.percentages,
            this.scrollStream.bounds
        ]);
        if (this.subscriptions.push(t), "function" == typeof ResizeObserver) {
            const t = this.createDelay(100);
            this.resizeObserver = new ResizeObserver(()=>{
                t().then(()=>this.onContainerResize()).catch(()=>{});
            }), this.resizeObserver.observe(this.scrollContainer);
        }
    }
    onContainerResize() {
        const t = this.parent.clientWidth;
        this.calculateInlinePadding(), t === this.lastContainerWidth && "auto" !== this.options.height || (this.lastContainerWidth = t, this.reRender(), this.emit("resize"));
    }
    initDrag() {
        if (this.dragStream) return;
        this.dragStream = function(t, e = {}) {
            const { threshold: i = 3, mouseButton: n = 0, touchDelay: s = 100 } = e, r = $419ca02d64eacc2f$var$l(null), o = new Map, a = matchMedia("(pointer: coarse)").matches;
            let h = ()=>{};
            const c = (e)=>{
                if (e.button !== n) return;
                if (o.has(e.pointerId)) return;
                if (o.set(e.pointerId, e), o.size > 1) return;
                const l = e.pointerId;
                let c = e.clientX, d = e.clientY, u = !1;
                const p = Date.now(), m = t.getBoundingClientRect(), { left: g, top: f } = m, v = (t)=>{
                    if (t.pointerId !== l) return;
                    if (t.defaultPrevented || o.size > 1) return;
                    if (a && Date.now() - p < s) return;
                    const e = t.clientX, n = t.clientY, h = e - c, m = n - d;
                    (u || Math.abs(h) > i || Math.abs(m) > i) && (t.preventDefault(), t.stopPropagation(), u || (r.set({
                        type: "start",
                        x: c - g,
                        y: d - f
                    }), u = !0), r.set({
                        type: "move",
                        x: e - g,
                        y: n - f,
                        deltaX: h,
                        deltaY: m
                    }), c = e, d = n);
                }, b = (t)=>{
                    if (o.delete(t.pointerId)) {
                        if (t.pointerId === l && u) {
                            const e = t.clientX, i = t.clientY;
                            r.set({
                                type: "end",
                                x: e - g,
                                y: i - f
                            });
                        }
                        0 === o.size && h();
                    }
                }, y = (t)=>{
                    t.relatedTarget && t.relatedTarget !== document.documentElement || b(t);
                }, C = (t)=>{
                    u && (t.stopPropagation(), t.preventDefault());
                }, S = (t)=>{
                    t.defaultPrevented || o.size > 1 || u && t.preventDefault();
                };
                document.addEventListener("pointermove", v), document.addEventListener("pointerup", b), document.addEventListener("pointerout", y), document.addEventListener("pointercancel", y), document.addEventListener("touchmove", S, {
                    passive: !1
                }), document.addEventListener("click", C, {
                    capture: !0
                }), h = ()=>{
                    document.removeEventListener("pointermove", v), document.removeEventListener("pointerup", b), document.removeEventListener("pointerout", y), document.removeEventListener("pointercancel", y), document.removeEventListener("touchmove", S), setTimeout(()=>{
                        document.removeEventListener("click", C, {
                            capture: !0
                        });
                    }, 10);
                };
            };
            return t.addEventListener("pointerdown", c), {
                signal: r,
                cleanup: ()=>{
                    h(), t.removeEventListener("pointerdown", c), o.clear(), $419ca02d64eacc2f$var$b(r);
                }
            };
        }(this.wrapper);
        const t = $419ca02d64eacc2f$var$c(()=>{
            const t = this.dragStream.signal.value;
            if (!t) return;
            const e = this.wrapper.getBoundingClientRect().width, i = (n = t.x / e) < 0 ? 0 : n > 1 ? 1 : n;
            var n;
            "start" === t.type ? (this.isDragging = !0, this.emit("dragstart", i)) : "move" === t.type ? this.emit("drag", i) : "end" === t.type && (this.isDragging = !1, this.emit("dragend", i));
        }, [
            this.dragStream.signal
        ]);
        this.subscriptions.push(t);
    }
    calculateInlinePadding() {
        const { paddingLeft: t, paddingRight: e } = getComputedStyle(this.scrollContainer), i = parseFloat(t) + parseFloat(e);
        this.containerInlinePadding = Number.isNaN(i) ? 0 : i;
    }
    initHtml() {
        const t = document.createElement("div"), e = t.attachShadow({
            mode: "open"
        }), i = this.options.cspNonce && "string" == typeof this.options.cspNonce ? this.options.cspNonce.replace(/"/g, "") : "";
        return e.innerHTML = `\n      <style${i ? ` nonce="${i}"` : ""}>\n        :host {\n          user-select: none;\n          min-width: 1px;\n        }\n        :host audio {\n          display: block;\n          width: 100%;\n        }\n        :host .scroll {\n          overflow-x: auto;\n          overflow-y: hidden;\n          width: 100%;\n          position: relative;\n        }\n        :host .noScrollbar {\n          scrollbar-color: transparent;\n          scrollbar-width: none;\n        }\n        :host .noScrollbar::-webkit-scrollbar {\n          display: none;\n          -webkit-appearance: none;\n        }\n        :host .wrapper {\n          position: relative;\n          overflow: visible;\n          z-index: 2;\n        }\n        :host .canvases {\n          min-height: ${this.getHeight(this.options.height, this.options.splitChannels)}px;\n          pointer-events: none;\n        }\n        :host .canvases > div {\n          position: relative;\n        }\n        :host canvas {\n          display: block;\n          position: absolute;\n          top: 0;\n          image-rendering: pixelated;\n        }\n        :host .progress {\n          pointer-events: none;\n          position: absolute;\n          z-index: 2;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          overflow: hidden;\n        }\n        :host .progress > div {\n          position: relative;\n        }\n        :host .cursor {\n          pointer-events: none;\n          position: absolute;\n          z-index: 5;\n          top: 0;\n          left: 0;\n          height: 100%;\n          border-radius: 2px;\n        }\n      </style>\n\n      <div class="scroll" part="scroll">\n        <div class="wrapper" part="wrapper">\n          <div class="canvases" part="canvases"></div>\n          <div class="progress" part="progress"></div>\n          <div class="cursor" part="cursor"></div>\n        </div>\n      </div>\n    `, [
            t,
            e
        ];
    }
    setOptions(t) {
        var e;
        if (this.options.container !== t.container) {
            const e = this.parentFromOptionsContainer(t.container);
            e.appendChild(this.container), this.parent = e;
        }
        !0 === t.dragToSeek || "object" == typeof this.options.dragToSeek ? this.initDrag() : (null === (e = this.dragStream) || void 0 === e || e.cleanup(), this.dragStream = null), this.options = t, this.reRender();
    }
    getWrapper() {
        return this.wrapper;
    }
    getWidth() {
        return this.scrollContainer.clientWidth - this.containerInlinePadding;
    }
    getScroll() {
        return this.scrollContainer.scrollLeft;
    }
    setScroll(t) {
        this.scrollContainer.scrollLeft = t;
    }
    setScrollPercentage(t) {
        const { scrollWidth: e } = this.scrollContainer, i = e * t;
        this.setScroll(i);
    }
    destroy() {
        var t;
        this.wrapper.removeEventListener("click", this.onClickWrapper), this.wrapper.removeEventListener("dblclick", this.onDblClickWrapper), this.timeouts.forEach((t)=>t()), this.timeouts = [], this.subscriptions.forEach((t)=>t()), this.container.remove(), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null), null === (t = this.unsubscribeOnScroll) || void 0 === t || t.forEach((t)=>t()), this.unsubscribeOnScroll = [], this.dragStream && (this.dragStream.cleanup(), this.dragStream = null), this.scrollStream && (this.scrollStream.cleanup(), this.scrollStream = null);
    }
    createDelay(t = 10) {
        let e, i;
        const n = ()=>{
            e && (clearTimeout(e), e = void 0), i && (i(), i = void 0);
        };
        return this.timeouts.push(n), ()=>new Promise((s, r)=>{
                n(), i = r, e = setTimeout(()=>{
                    e = void 0, i = void 0, s();
                }, t);
            });
    }
    getHeight(t, e) {
        var i;
        const n = (null === (i = this.audioData) || void 0 === i ? void 0 : i.numberOfChannels) || 1;
        return function({ optionsHeight: t, optionsSplitChannels: e, parentHeight: i, numberOfChannels: n, defaultHeight: s = 128 }) {
            if (null == t) return s;
            const r = Number(t);
            if (!isNaN(r)) return r;
            if ("auto" === t) {
                const t = i || s;
                return (null == e ? void 0 : e.every((t)=>!t.overlay)) ? t / n : t;
            }
            return s;
        }({
            optionsHeight: t,
            optionsSplitChannels: e,
            parentHeight: this.parent.clientHeight,
            numberOfChannels: n,
            defaultHeight: 128
        });
    }
    convertColorValues(t, e) {
        return function(t, e, i) {
            if (!Array.isArray(t)) return t || "";
            if (0 === t.length) return "#999";
            if (t.length < 2) return t[0] || "";
            const n = document.createElement("canvas"), s = n.getContext("2d");
            if (!s) return t[0] || "";
            const r = i || n.height * e, o = s.createLinearGradient(0, 0, 0, r), a = 1 / (t.length - 1);
            return t.forEach((t, e)=>{
                o.addColorStop(e * a, t);
            }), o;
        }(t, this.getPixelRatio(), null == e ? void 0 : e.canvas.height);
    }
    getPixelRatio() {
        var t;
        return t = window.devicePixelRatio, Math.max(1, t || 1);
    }
    renderBarWaveform(t, e, i, n) {
        const { width: s, height: r } = i.canvas, { halfHeight: o, barWidth: a, barRadius: l, barIndexScale: h, barSpacing: c, barMinHeight: d } = function({ width: t, height: e, length: i, options: n, pixelRatio: s }) {
            const r = e / 2, o = n.barWidth ? n.barWidth * s : 1, a = n.barGap ? n.barGap * s : n.barWidth ? o / 2 : 0, l = o + a || 1;
            return {
                halfHeight: r,
                barWidth: o,
                barGap: a,
                barRadius: n.barRadius || 0,
                barMinHeight: n.barMinHeight ? n.barMinHeight * s : 0,
                barIndexScale: i > 0 ? t / l / i : 0,
                barSpacing: l
            };
        }({
            width: s,
            height: r,
            length: (t[0] || []).length,
            options: e,
            pixelRatio: this.getPixelRatio()
        }), m = function({ channelData: t, barIndexScale: e, barSpacing: i, barWidth: n, halfHeight: s, vScale: r, canvasHeight: o, barAlign: a, barMinHeight: l }) {
            const h = t[0] || [], c = t[1] || h, d = h.length, m = [];
            let g = 0, f = 0, v = 0;
            for(let t = 0; t <= d; t++){
                const d = Math.round(t * e);
                if (d > g) {
                    const { topHeight: t, totalHeight: e } = $419ca02d64eacc2f$var$u({
                        maxTop: f,
                        maxBottom: v,
                        halfHeight: s,
                        vScale: r,
                        barMinHeight: l,
                        barAlign: a
                    }), h = $419ca02d64eacc2f$var$p({
                        barAlign: a,
                        halfHeight: s,
                        topHeight: t,
                        totalHeight: e,
                        canvasHeight: o
                    });
                    m.push({
                        x: g * i,
                        y: h,
                        width: n,
                        height: e
                    }), g = d, f = 0, v = 0;
                }
                const b = Math.abs(h[t] || 0), y = Math.abs(c[t] || 0);
                b > f && (f = b), y > v && (v = y);
            }
            return m;
        }({
            channelData: t,
            barIndexScale: h,
            barSpacing: c,
            barWidth: a,
            halfHeight: o,
            vScale: n,
            canvasHeight: r,
            barAlign: e.barAlign,
            barMinHeight: d
        });
        i.beginPath();
        for (const t of m)l && "roundRect" in i ? i.roundRect(t.x, t.y, t.width, t.height, l) : i.rect(t.x, t.y, t.width, t.height);
        i.fill(), i.closePath();
    }
    renderLineWaveform(t, e, i, n) {
        const { width: s, height: r } = i.canvas, o = function({ channelData: t, width: e, height: i, vScale: n }) {
            const s = i / 2, r = t[0] || [];
            return [
                r,
                t[1] || r
            ].map((t, i)=>{
                const r = t.length, o = r ? e / r : 0, a = s, l = 0 === i ? -1 : 1, h = [
                    {
                        x: 0,
                        y: a
                    }
                ];
                let c = 0, d = 0;
                for(let e = 0; e <= r; e++){
                    const i = Math.round(e * o);
                    if (i > c) {
                        const t = a + (Math.round(d * s * n) || 1) * l;
                        h.push({
                            x: c,
                            y: t
                        }), c = i, d = 0;
                    }
                    const r = Math.abs(t[e] || 0);
                    r > d && (d = r);
                }
                return h.push({
                    x: c,
                    y: a
                }), h;
            });
        }({
            channelData: t,
            width: s,
            height: r,
            vScale: n
        });
        i.beginPath();
        for (const t of o)if (t.length) {
            i.moveTo(t[0].x, t[0].y);
            for(let e = 1; e < t.length; e++){
                const n = t[e];
                i.lineTo(n.x, n.y);
            }
        }
        i.fill(), i.closePath();
    }
    renderWaveform(t, e, i) {
        if (i.fillStyle = this.convertColorValues(e.waveColor, i), e.renderFunction) return void e.renderFunction(t, i);
        const n = function({ channelData: t, barHeight: e, normalize: i, maxPeak: n }) {
            var s;
            const r = e || 1;
            if (!i) return r;
            const o = t[0];
            if (!o || 0 === o.length) return r;
            let a = null != n ? n : 0;
            if (!n) for(let t = 0; t < o.length; t++){
                const e = null !== (s = o[t]) && void 0 !== s ? s : 0, i = Math.abs(e);
                i > a && (a = i);
            }
            return a ? r / a : r;
        }({
            channelData: t,
            barHeight: e.barHeight,
            normalize: e.normalize,
            maxPeak: e.maxPeak
        });
        $419ca02d64eacc2f$var$g(e) ? this.renderBarWaveform(t, e, i, n) : this.renderLineWaveform(t, e, i, n);
    }
    renderSingleCanvas(t, e, i, n, s, r, o) {
        const a = this.getPixelRatio(), l = document.createElement("canvas");
        l.width = Math.round(i * a), l.height = Math.round(n * a), l.style.width = `${i}px`, l.style.height = `${n}px`, l.style.left = `${Math.round(s)}px`, r.appendChild(l);
        const h = l.getContext("2d");
        if (e.renderFunction ? (h.fillStyle = this.convertColorValues(e.waveColor, h), e.renderFunction(t, h)) : this.renderWaveform(t, e, h), l.width > 0 && l.height > 0) {
            const t = l.cloneNode(), i = t.getContext("2d");
            i.drawImage(l, 0, 0), i.globalCompositeOperation = "source-in", i.fillStyle = this.convertColorValues(e.progressColor, i), i.fillRect(0, 0, l.width, l.height), o.appendChild(t);
        }
    }
    renderMultiCanvas(t, e, i, n, s, r) {
        const o = this.getPixelRatio(), { clientWidth: a } = this.scrollContainer, l = i / o, h = function({ clientWidth: t, totalWidth: e, options: i }) {
            return $419ca02d64eacc2f$var$f(Math.min(8e3, t, e), i);
        }({
            clientWidth: a,
            totalWidth: l,
            options: e
        });
        let c = {};
        if (0 === h) return;
        const d = (i)=>{
            if (i < 0 || i >= u) return;
            if (c[i]) return;
            c[i] = !0;
            const o = i * h;
            let a = Math.min(l - o, h);
            if (a = $419ca02d64eacc2f$var$f(a, e), a <= 0) return;
            const d = function({ channelData: t, offset: e, clampedWidth: i, totalWidth: n }) {
                return t.map((t)=>{
                    const s = Math.floor(e / n * t.length), r = Math.floor((e + i) / n * t.length);
                    return t.slice(s, r);
                });
            }({
                channelData: t,
                offset: o,
                clampedWidth: a,
                totalWidth: l
            });
            this.renderSingleCanvas(d, e, a, n, o, s, r);
        }, u = Math.ceil(l / h);
        if (!this.isScrollable) {
            for(let t = 0; t < u; t++)d(t);
            return;
        }
        if ($419ca02d64eacc2f$var$v({
            scrollLeft: this.scrollContainer.scrollLeft,
            totalWidth: l,
            numCanvases: u
        }).forEach((t)=>d(t)), u > 1) {
            const t = this.on("scroll", ()=>{
                const { scrollLeft: t } = this.scrollContainer;
                Object.keys(c).length > 10 && (s.innerHTML = "", r.innerHTML = "", c = {}), $419ca02d64eacc2f$var$v({
                    scrollLeft: t,
                    totalWidth: l,
                    numCanvases: u
                }).forEach((t)=>d(t));
            });
            this.unsubscribeOnScroll.push(t);
        }
    }
    renderChannel(t, e, i, n) {
        var { overlay: s } = e, r = function(t, e) {
            var i = {};
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
            if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                var s = 0;
                for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
            }
            return i;
        }(e, [
            "overlay"
        ]);
        const o = document.createElement("div"), a = this.getHeight(r.height, r.splitChannels);
        o.style.height = `${a}px`, s && n > 0 && (o.style.marginTop = `-${a}px`), this.canvasWrapper.style.minHeight = `${a}px`, this.canvasWrapper.appendChild(o);
        const l = o.cloneNode();
        this.progressWrapper.appendChild(l), this.renderMultiCanvas(t, r, i, a, o, l);
    }
    render(e) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            var t;
            this.timeouts.forEach((t)=>t()), this.timeouts = [], this.unsubscribeOnScroll.forEach((t)=>t()), this.unsubscribeOnScroll = [], this.canvasWrapper.innerHTML = "", this.progressWrapper.innerHTML = "", null != this.options.width && (this.scrollContainer.style.width = "number" == typeof this.options.width ? `${this.options.width}px` : this.options.width);
            const i = this.getPixelRatio(), n = this.scrollContainer.clientWidth - this.containerInlinePadding, { scrollWidth: s, isScrollable: r, useParentWidth: o, width: a } = function({ duration: t, minPxPerSec: e = 0, parentWidth: i, fillParent: n, pixelRatio: s }) {
                const r = Math.ceil(t * e), o = r > i, a = Boolean(n && !o);
                return {
                    scrollWidth: r,
                    isScrollable: o,
                    useParentWidth: a,
                    width: (a ? i : r) * s
                };
            }({
                duration: e.duration,
                minPxPerSec: this.options.minPxPerSec || 0,
                parentWidth: n,
                fillParent: this.options.fillParent,
                pixelRatio: i
            });
            if (this.isScrollable = r, this.wrapper.style.width = o ? "100%" : `${s}px`, this.scrollContainer.style.overflowX = this.isScrollable ? "auto" : "hidden", this.scrollContainer.classList.toggle("noScrollbar", !!this.options.hideScrollbar), this.cursor.style.backgroundColor = `${this.options.cursorColor || this.options.progressColor}`, this.cursor.style.width = `${this.options.cursorWidth}px`, this.audioData = e, this.emit("render"), this.options.splitChannels) for(let i = 0; i < e.numberOfChannels; i++){
                const n = Object.assign(Object.assign({}, this.options), null === (t = this.options.splitChannels) || void 0 === t ? void 0 : t[i]);
                this.renderChannel([
                    e.getChannelData(i)
                ], n, a, i);
            }
            else {
                const t = [
                    e.getChannelData(0)
                ];
                e.numberOfChannels > 1 && t.push(e.getChannelData(1)), this.renderChannel(t, this.options, a, 0);
            }
            Promise.resolve().then(()=>this.emit("rendered"));
        });
    }
    reRender() {
        if (this.unsubscribeOnScroll.forEach((t)=>t()), this.unsubscribeOnScroll = [], !this.audioData) return;
        const { scrollWidth: t } = this.scrollContainer, { right: e } = this.progressWrapper.getBoundingClientRect();
        if (this.render(this.audioData), !this.isScrollable && this.scrollContainer.scrollLeft) this.scrollContainer.scrollLeft = 0;
        else if (this.isScrollable && t !== this.scrollContainer.scrollWidth) {
            const { right: t } = this.progressWrapper.getBoundingClientRect(), i = function(t) {
                const e = 2 * t;
                return (e < 0 ? Math.floor(e) : Math.ceil(e)) / 2;
            }(t - e);
            this.scrollContainer.scrollLeft += i;
        }
    }
    zoom(t) {
        this.options.minPxPerSec = t, this.reRender();
    }
    scrollIntoView(t, e = !1) {
        var i;
        const { scrollLeft: n, scrollWidth: s, clientWidth: r } = this.scrollContainer, o = t * s, a = n, l = n + r, h = r / 2;
        if (this.isDragging) {
            const t = 30;
            o + t > l ? this.scrollContainer.scrollLeft += t : o - t < a && (this.scrollContainer.scrollLeft -= t);
        } else {
            (o < a || o > l) && (this.scrollContainer.scrollLeft = o - (this.options.autoCenter ? h : 0));
            const t = o - n - h;
            if (e && this.options.autoCenter && t > 0) {
                const e = null === (i = this.audioData) || void 0 === i ? void 0 : i.duration;
                if (void 0 === e || e <= 0) return void (this.scrollContainer.scrollLeft += t);
                const n = s / e;
                this.scrollContainer.scrollLeft += n <= 600 ? Math.min(t, 10) : t;
            }
        }
    }
    renderProgress(t, e) {
        if (isNaN(t)) return;
        const i = 100 * t;
        this.canvasWrapper.style.clipPath = `polygon(${i}% 0%, 100% 0%, 100% 100%, ${i}% 100%)`, this.progressWrapper.style.width = `${i}%`, this.cursor.style.left = `${i}%`, this.cursor.style.transform = this.options.cursorWidth ? `translateX(-${t * this.options.cursorWidth}px)` : "", this.isScrollable && this.options.autoScroll && this.audioData && this.audioData.duration > 0 && this.scrollIntoView(t, e);
    }
    exportImage(e, i, n) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            const t = this.canvasWrapper.querySelectorAll("canvas");
            if (!t.length) throw new Error("No waveform data");
            if ("dataURL" === n) {
                const n = Array.from(t).map((t)=>t.toDataURL(e, i));
                return Promise.resolve(n);
            }
            return Promise.all(Array.from(t).map((t)=>new Promise((n, s)=>{
                    t.toBlob((t)=>{
                        t ? n(t) : s(new Error("Could not export image"));
                    }, e, i);
                })));
        });
    }
}
class $419ca02d64eacc2f$var$S extends $419ca02d64eacc2f$var$e {
    constructor(){
        super(...arguments), this.animationFrameId = null, this.isRunning = !1;
    }
    start() {
        if (this.isRunning) return;
        this.isRunning = !0;
        const t = ()=>{
            this.isRunning && (this.emit("tick"), this.animationFrameId = requestAnimationFrame(t));
        };
        t();
    }
    stop() {
        this.isRunning = !1, null !== this.animationFrameId && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null);
    }
    destroy() {
        this.stop(), this.unAll();
    }
}
class $419ca02d64eacc2f$var$E extends $419ca02d64eacc2f$var$e {
    constructor(t){
        super(), this.bufferNode = null, this.playStartTime = 0, this.playbackPosition = 0, this._muted = !1, this._playbackRate = 1, this._duration = void 0, this.buffer = null, this.currentSrc = "", this.paused = !0, this.crossOrigin = null, this.seeking = !1, this.autoplay = !1, this.addEventListener = this.on, this.removeEventListener = this.un, this._destroyed = !1, function() {
            const t = globalThis.navigator;
            if (null == t ? void 0 : t.audioSession) try {
                t.audioSession.type = "playback";
            } catch (t) {
                console.warn("Setting navigator.audioSession.type failed:", t);
            }
        }(), this.audioContext = t || new AudioContext, this.gainNode = this.audioContext.createGain(), this.gainNode.connect(this.audioContext.destination);
    }
    load() {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {});
    }
    remove() {
        this.destroy();
    }
    destroy() {
        if (!this._destroyed) {
            if (this._destroyed = !0, this.currentSrc = "", this.bufferNode) {
                this.bufferNode.onended = null;
                try {
                    this.bufferNode.stop();
                } catch (t) {}
                this.bufferNode.disconnect(), this.bufferNode = null;
            }
            this.gainNode.disconnect(), "function" == typeof this.audioContext.close && Promise.resolve(this.audioContext.close.call(this.audioContext)).catch(()=>{}), this.buffer = null, this.unAll();
        }
    }
    get src() {
        return this.currentSrc;
    }
    set src(t) {
        if (this.currentSrc = t, this._duration = void 0, !t) return this.buffer = null, void this.emit("emptied");
        fetch(t).then((e)=>{
            if (e.status >= 400) throw new Error(`Failed to fetch ${t}: ${e.status} (${e.statusText})`);
            return e.arrayBuffer();
        }).then((e)=>this.currentSrc !== t ? null : this.audioContext.decodeAudioData(e)).then((e)=>{
            this.currentSrc === t && (this.buffer = e, this.emit("loadedmetadata"), this.emit("canplay"), this.autoplay && this.play());
        }).catch((t)=>{
            console.error("WebAudioPlayer load error:", t);
        });
    }
    _play() {
        if (!this.paused) return;
        this.paused = !1, this.bufferNode && (this.bufferNode.onended = null, this.bufferNode.disconnect()), this.bufferNode = this.audioContext.createBufferSource(), this.buffer && (this.bufferNode.buffer = this.buffer), this.bufferNode.playbackRate.value = this._playbackRate, this.bufferNode.connect(this.gainNode);
        let t = this.playbackPosition;
        (t >= this.duration || t < 0) && (t = 0, this.playbackPosition = 0), this.bufferNode.start(this.audioContext.currentTime, t), this.playStartTime = this.audioContext.currentTime, this.bufferNode.onended = ()=>{
            !this.paused && this.duration - this.currentTime < .01 && (this.pause(), this.emit("ended"));
        };
    }
    _pause() {
        if (this.paused = !0, this.bufferNode) {
            this.bufferNode.onended = null;
            try {
                this.bufferNode.stop();
            } catch (t) {}
        }
        this.playbackPosition += (this.audioContext.currentTime - this.playStartTime) * this._playbackRate;
    }
    play() {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            this.paused && (this._play(), this.emit("play"));
        });
    }
    pause() {
        this.paused || (this._pause(), this.emit("pause"));
    }
    stopAt(t) {
        const e = (t - this.currentTime) / this._playbackRate, i = this.bufferNode;
        null == i || i.stop(this.audioContext.currentTime + e), null == i || i.addEventListener("ended", ()=>{
            i === this.bufferNode && (this.bufferNode = null, this.pause(), this.playbackPosition = Math.min(t, this.duration), this.emit("timeupdate"));
        }, {
            once: !0
        });
    }
    setSinkId(e) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            return this.audioContext.setSinkId(e);
        });
    }
    get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(t) {
        const e = !this.paused;
        e && this._pause(), this._playbackRate = t, e && this._play(), this.bufferNode && (this.bufferNode.playbackRate.value = t);
    }
    get currentTime() {
        return this.paused ? this.playbackPosition : this.playbackPosition + (this.audioContext.currentTime - this.playStartTime) * this._playbackRate;
    }
    set currentTime(t) {
        const e = !this.paused;
        e && this._pause(), this.playbackPosition = t, e && this._play(), this.emit("seeking"), this.emit("timeupdate");
    }
    get duration() {
        var t, e;
        return null !== (t = this._duration) && void 0 !== t ? t : (null === (e = this.buffer) || void 0 === e ? void 0 : e.duration) || 0;
    }
    set duration(t) {
        this._duration = t;
    }
    get volume() {
        return this.gainNode.gain.value;
    }
    set volume(t) {
        this.gainNode.gain.value = t, this.emit("volumechange");
    }
    get muted() {
        return this._muted;
    }
    set muted(t) {
        this._muted !== t && (this._muted = t, this._muted ? this.gainNode.disconnect() : this.gainNode.connect(this.audioContext.destination));
    }
    canPlayType(t) {
        return /^(audio|video)\//.test(t);
    }
    getGainNode() {
        return this.gainNode;
    }
    getChannelData() {
        const t = [];
        if (!this.buffer) return t;
        const e = this.buffer.numberOfChannels;
        for(let i = 0; i < e; i++)t.push(this.buffer.getChannelData(i));
        return t;
    }
    removeAttribute(t) {
        switch(t){
            case "src":
                this.src = "";
                break;
            case "playbackRate":
                this.playbackRate = 0;
                break;
            case "currentTime":
                this.currentTime = 0;
                break;
            case "duration":
                this.duration = 0;
                break;
            case "volume":
                this.volume = 0;
                break;
            case "muted":
                this.muted = !1;
        }
    }
}
const $419ca02d64eacc2f$var$P = {
    waveColor: "#999",
    progressColor: "#555",
    cursorWidth: 1,
    minPxPerSec: 0,
    fillParent: !0,
    interact: !0,
    dragToSeek: !1,
    autoScroll: !0,
    autoCenter: !0,
    sampleRate: 8e3
};
class $419ca02d64eacc2f$export$2e2bcd8739ae039 extends $419ca02d64eacc2f$var$d {
    static create(t) {
        return new $419ca02d64eacc2f$export$2e2bcd8739ae039(t);
    }
    getState() {
        return this.wavesurferState;
    }
    getRenderer() {
        return this.renderer;
    }
    constructor(t){
        const e = t.media || ("WebAudio" === t.backend ? new $419ca02d64eacc2f$var$E : void 0);
        super({
            media: e,
            mediaControls: t.mediaControls,
            autoplay: t.autoplay,
            playbackRate: t.audioRate
        }), this.plugins = [], this.decodedData = null, this.stopAtPosition = null, this.subscriptions = [], this.mediaSubscriptions = [], this.abortController = null, this._isDestroyed = !1, this._loadVersion = 0, this.options = Object.assign({}, $419ca02d64eacc2f$var$P, t);
        const { state: i, actions: n } = function(t) {
            var e, i, n, s, r, o;
            const a = null !== (e = null == t ? void 0 : t.currentTime) && void 0 !== e ? e : $419ca02d64eacc2f$var$l(0), c = null !== (i = null == t ? void 0 : t.duration) && void 0 !== i ? i : $419ca02d64eacc2f$var$l(0), d = null !== (n = null == t ? void 0 : t.isPlaying) && void 0 !== n ? n : $419ca02d64eacc2f$var$l(!1), u = null !== (s = null == t ? void 0 : t.isSeeking) && void 0 !== s ? s : $419ca02d64eacc2f$var$l(!1), p = null !== (r = null == t ? void 0 : t.volume) && void 0 !== r ? r : $419ca02d64eacc2f$var$l(1), m = null !== (o = null == t ? void 0 : t.playbackRate) && void 0 !== o ? o : $419ca02d64eacc2f$var$l(1), g = $419ca02d64eacc2f$var$l(null), f = $419ca02d64eacc2f$var$l(null), v = $419ca02d64eacc2f$var$l(""), b = $419ca02d64eacc2f$var$l(0), y = $419ca02d64eacc2f$var$l(0), C = $419ca02d64eacc2f$var$h(()=>!d.value, [
                d
            ]), S = $419ca02d64eacc2f$var$h(()=>null !== g.value, [
                g
            ]), E = $419ca02d64eacc2f$var$h(()=>S.value && c.value > 0, [
                S,
                c
            ]), P = $419ca02d64eacc2f$var$h(()=>a.value, [
                a
            ]), w = $419ca02d64eacc2f$var$h(()=>c.value > 0 ? a.value / c.value : 0, [
                a,
                c
            ]);
            return {
                state: {
                    currentTime: a,
                    duration: c,
                    isPlaying: d,
                    isPaused: C,
                    isSeeking: u,
                    volume: p,
                    playbackRate: m,
                    audioBuffer: g,
                    peaks: f,
                    url: v,
                    zoom: b,
                    scrollPosition: y,
                    canPlay: S,
                    isReady: E,
                    progress: P,
                    progressPercent: w
                },
                actions: {
                    setCurrentTime: (t)=>{
                        const e = Math.max(0, Math.min(c.value || 1 / 0, t));
                        a.set(e);
                    },
                    setDuration: (t)=>{
                        c.set(Math.max(0, t));
                    },
                    setPlaying: (t)=>{
                        d.set(t);
                    },
                    setSeeking: (t)=>{
                        u.set(t);
                    },
                    setVolume: (t)=>{
                        const e = Math.max(0, Math.min(1, t));
                        p.set(e);
                    },
                    setPlaybackRate: (t)=>{
                        const e = Math.max(.1, Math.min(16, t));
                        m.set(e);
                    },
                    setAudioBuffer: (t)=>{
                        g.set(t), t && c.set(t.duration);
                    },
                    setPeaks: (t)=>{
                        f.set(t);
                    },
                    setUrl: (t)=>{
                        v.set(t);
                    },
                    setZoom: (t)=>{
                        b.set(Math.max(0, t));
                    },
                    setScrollPosition: (t)=>{
                        y.set(Math.max(0, t));
                    }
                }
            };
        }({
            isPlaying: this.isPlayingSignal,
            currentTime: this.currentTimeSignal,
            duration: this.durationSignal,
            volume: this.volumeSignal,
            playbackRate: this.playbackRateSignal,
            isSeeking: this.seekingSignal
        });
        this.wavesurferState = i, this.wavesurferActions = n, this.timer = new $419ca02d64eacc2f$var$S;
        const s = e ? void 0 : this.getMediaElement();
        this.renderer = new $419ca02d64eacc2f$var$C(this.options, s), this.initPlayerEvents(), this.initRendererEvents(), this.initTimerEvents(), this.initPlugins();
        const r = this.options.url || this.getSrc() || "";
        Promise.resolve().then(()=>{
            this.emit("init");
            const { peaks: t, duration: e } = this.options;
            (r || t && e) && this.load(r, t, e).catch(()=>{});
        });
    }
    updateProgress(t = this.getCurrentTime()) {
        return this.renderer.renderProgress(t / this.getDuration(), this.isPlaying()), t;
    }
    initTimerEvents() {
        this.subscriptions.push(this.timer.on("tick", ()=>{
            if (!this.isSeeking()) {
                const t = this.updateProgress();
                if (this.emit("timeupdate", t), this.emit("audioprocess", t), null != this.stopAtPosition && this.isPlaying() && t >= this.stopAtPosition) {
                    const t = this.stopAtPosition;
                    this.pause(), this.setTime(t);
                }
            }
        }));
    }
    initPlayerEvents() {
        this.isPlaying() && (this.emit("play"), this.timer.start()), this.mediaSubscriptions.push(this.onMediaEvent("timeupdate", ()=>{
            const t = this.updateProgress();
            this.emit("timeupdate", t);
        }), this.onMediaEvent("play", ()=>{
            this.emit("play"), this.timer.start();
        }), this.onMediaEvent("pause", ()=>{
            this.emit("pause"), this.timer.stop(), this.stopAtPosition = null;
        }), this.onMediaEvent("emptied", ()=>{
            this.timer.stop(), this.stopAtPosition = null;
        }), this.onMediaEvent("ended", ()=>{
            this.emit("timeupdate", this.getDuration()), this.emit("finish"), this.stopAtPosition = null;
        }), this.onMediaEvent("seeking", ()=>{
            this.emit("seeking", this.getCurrentTime());
        }), this.onMediaEvent("error", ()=>{
            var t;
            this.emit("error", null !== (t = this.getMediaElement().error) && void 0 !== t ? t : new Error("Media error")), this.stopAtPosition = null;
        }));
    }
    initRendererEvents() {
        this.subscriptions.push(this.renderer.on("click", (t, e)=>{
            this.options.interact && (this.seekTo(t), this.emit("interaction", t * this.getDuration()), this.emit("click", t, e));
        }), this.renderer.on("dblclick", (t, e)=>{
            this.emit("dblclick", t, e);
        }), this.renderer.on("scroll", (t, e, i, n)=>{
            const s = this.getDuration();
            this.emit("scroll", t * s, e * s, i, n);
        }), this.renderer.on("render", ()=>{
            this.emit("redraw");
        }), this.renderer.on("rendered", ()=>{
            this.emit("redrawcomplete");
        }), this.renderer.on("dragstart", (t)=>{
            this.emit("dragstart", t);
        }), this.renderer.on("dragend", (t)=>{
            this.emit("dragend", t);
        }), this.renderer.on("resize", ()=>{
            this.emit("resize");
        }));
        {
            let t;
            const e = this.renderer.on("drag", (e)=>{
                var i;
                if (!this.options.interact) return;
                this.renderer.renderProgress(e), clearTimeout(t);
                let n = 0;
                const s = this.options.dragToSeek;
                this.isPlaying() ? n = 0 : !0 === s ? n = 200 : s && "object" == typeof s && (n = null !== (i = s.debounceTime) && void 0 !== i ? i : 200), t = setTimeout(()=>{
                    this.seekTo(e);
                }, n), this.emit("interaction", e * this.getDuration()), this.emit("drag", e);
            });
            this.subscriptions.push(()=>{
                clearTimeout(t), e();
            });
        }
    }
    initPlugins() {
        var t;
        (null === (t = this.options.plugins) || void 0 === t ? void 0 : t.length) && this.options.plugins.forEach((t)=>{
            this.registerPlugin(t);
        });
    }
    unsubscribePlayerEvents() {
        this.mediaSubscriptions.forEach((t)=>t()), this.mediaSubscriptions = [];
    }
    setOptions(t) {
        this.options = Object.assign({}, this.options, t), t.duration && !t.peaks && (this.decodedData = $419ca02d64eacc2f$var$i.createBuffer(this.exportPeaks(), t.duration)), t.peaks && t.duration && (this.decodedData = $419ca02d64eacc2f$var$i.createBuffer(t.peaks, t.duration)), this.renderer.setOptions(this.options), t.audioRate && this.setPlaybackRate(t.audioRate), null != t.mediaControls && (this.getMediaElement().controls = t.mediaControls);
    }
    registerPlugin(t) {
        if (this.plugins.includes(t)) return t;
        t._init(this), this.plugins.push(t);
        const e = t.once("destroy", ()=>{
            this.plugins = this.plugins.filter((e)=>e !== t), this.subscriptions = this.subscriptions.filter((t)=>t !== e);
        });
        return this.subscriptions.push(e), t;
    }
    unregisterPlugin(t) {
        this.plugins = this.plugins.filter((e)=>e !== t), t.destroy();
    }
    getWrapper() {
        return this.renderer.getWrapper();
    }
    getWidth() {
        return this.renderer.getWidth();
    }
    getScroll() {
        return this.renderer.getScroll();
    }
    setScroll(t) {
        return this.renderer.setScroll(t);
    }
    setScrollTime(t) {
        const e = t / this.getDuration();
        this.renderer.setScrollPercentage(e);
    }
    getActivePlugins() {
        return this.plugins;
    }
    loadAudio(e, n, s, r) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            var t;
            const o = ++this._loadVersion;
            if (this._isDestroyed = !1, this.emit("load", e), !this.options.media && this.isPlaying() && this.pause(), this.decodedData = null, this.stopAtPosition = null, null === (t = this.abortController) || void 0 === t || t.abort(), this.abortController = null, !n && !s) {
                const t = this.options.fetchParams || {};
                window.AbortController && !t.signal && (this.abortController = new AbortController, t.signal = this.abortController.signal);
                const i = (t)=>this.emit("loading", t);
                if (n = yield $419ca02d64eacc2f$var$a.fetchBlob(e, i, t), this._isDestroyed || o !== this._loadVersion) return;
                const s = this.options.blobMimeType;
                s && (n = new Blob([
                    n
                ], {
                    type: s
                }));
            }
            if (this._isDestroyed || o !== this._loadVersion) return;
            this.setSrc(e, n);
            const l = yield new Promise((t)=>{
                const e = r || this.getDuration();
                e ? t(e) : this.mediaSubscriptions.push(this.onMediaEvent("loadedmetadata", ()=>t(this.getDuration()), {
                    once: !0
                }));
            });
            if (!this._isDestroyed && o === this._loadVersion) {
                if (!e && !n) {
                    const t = this.getMediaElement();
                    t instanceof $419ca02d64eacc2f$var$E && (t.duration = l);
                }
                if (s) this.decodedData = $419ca02d64eacc2f$var$i.createBuffer(s, l || 0);
                else if (n) {
                    const t = yield n.arrayBuffer();
                    if (this._isDestroyed || o !== this._loadVersion) return;
                    this.decodedData = yield $419ca02d64eacc2f$var$i.decode(t, this.options.sampleRate);
                }
                this._isDestroyed || o !== this._loadVersion || (this.decodedData && (this.emit("decode", this.getDuration()), this.renderer.render(this.decodedData)), this.emit("ready", this.getDuration()));
            }
        });
    }
    load(e, i, n) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            try {
                return yield this.loadAudio(e, void 0, i, n);
            } catch (t) {
                throw this.emit("error", t), t;
            }
        });
    }
    loadBlob(e, i, n) {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            try {
                return yield this.loadAudio("", e, i, n);
            } catch (t) {
                throw this.emit("error", t), t;
            }
        });
    }
    zoom(t) {
        if (!this.decodedData) throw new Error("No audio loaded");
        this.renderer.zoom(t), this.emit("zoom", t);
    }
    getDecodedData() {
        return this.decodedData;
    }
    exportPeaks({ channels: t = 2, maxLength: e = 8e3, precision: i = 1e4 } = {}) {
        if (!this.decodedData) throw new Error("The audio has not been decoded yet");
        const n = Math.min(t, this.decodedData.numberOfChannels), s = [];
        for(let t = 0; t < n; t++){
            const n = this.decodedData.getChannelData(t), r = [], o = n.length / e;
            for(let t = 0; t < e; t++){
                const e = n.slice(Math.floor(t * o), Math.ceil((t + 1) * o));
                let s = 0;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    Math.abs(i) > Math.abs(s) && (s = i);
                }
                r.push(Math.round(s * i) / i);
            }
            s.push(r);
        }
        return s;
    }
    getDuration() {
        let t = super.getDuration() || 0;
        return 0 !== t && t !== 1 / 0 || !this.decodedData || (t = this.decodedData.duration), t;
    }
    toggleInteraction(t) {
        this.options.interact = t;
    }
    setTime(t) {
        this.stopAtPosition = null, super.setTime(t), this.updateProgress(t), this.emit("timeupdate", t);
    }
    seekTo(t) {
        const e = this.getDuration() * t;
        this.setTime(e);
    }
    play(e, i) {
        const n = Object.create(null, {
            play: {
                get: ()=>super.play
            }
        });
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            null != e && this.setTime(e);
            const t = yield n.play.call(this);
            return null != i && (this.media instanceof $419ca02d64eacc2f$var$E ? this.media.stopAt(i) : this.stopAtPosition = i), t;
        });
    }
    playPause() {
        return $419ca02d64eacc2f$var$t(this, void 0, void 0, function*() {
            return this.isPlaying() ? this.pause() : this.play();
        });
    }
    stop() {
        this.pause(), this.setTime(0);
    }
    skip(t) {
        this.setTime(this.getCurrentTime() + t);
    }
    empty() {
        this.load("", [
            [
                0
            ]
        ], .001);
    }
    setMediaElement(t) {
        this.unsubscribePlayerEvents(), super.setMediaElement(t), this.initPlayerEvents();
    }
    exportImage() {
        return $419ca02d64eacc2f$var$t(this, arguments, void 0, function*(t = "image/png", e = 1, i = "dataURL") {
            return this.renderer.exportImage(t, e, i);
        });
    }
    destroy() {
        var t;
        this._isDestroyed = !0, this.emit("destroy"), null === (t = this.abortController) || void 0 === t || t.abort(), this.plugins.forEach((t)=>t.destroy()), this.subscriptions.forEach((t)=>t()), this.unsubscribePlayerEvents(), this.timer.destroy(), this.renderer.destroy(), super.destroy();
    }
}
$419ca02d64eacc2f$export$2e2bcd8739ae039.BasePlugin = class extends $419ca02d64eacc2f$var$e {
    constructor(t){
        super(), this.subscriptions = [], this.isDestroyed = !1, this.options = t;
    }
    onInit() {}
    _init(t) {
        this.isDestroyed && (this.subscriptions = [], this.isDestroyed = !1), this.wavesurfer = t, this.onInit();
    }
    destroy() {
        this.emit("destroy"), this.subscriptions.forEach((t)=>t()), this.subscriptions = [], this.isDestroyed = !0, this.wavesurfer = void 0;
    }
}, $419ca02d64eacc2f$export$2e2bcd8739ae039.dom = $419ca02d64eacc2f$var$o;


class $40bc790c1b97f9d3$var$t {
    constructor(){
        this.listeners = {};
    }
    on(t, e, i) {
        if (this.listeners[t] || (this.listeners[t] = new Set), null == i ? void 0 : i.once) {
            const i = (...n)=>{
                this.un(t, i), e(...n);
            };
            return this.listeners[t].add(i), ()=>this.un(t, i);
        }
        return this.listeners[t].add(e), ()=>this.un(t, e);
    }
    un(t, e) {
        var i;
        null === (i = this.listeners[t]) || void 0 === i || i.delete(e);
    }
    once(t, e) {
        return this.on(t, e, {
            once: !0
        });
    }
    unAll() {
        this.listeners = {};
    }
    emit(t, ...e) {
        this.listeners[t] && this.listeners[t].forEach((t)=>t(...e));
    }
}
class $40bc790c1b97f9d3$var$e extends $40bc790c1b97f9d3$var$t {
    constructor(t){
        super(), this.subscriptions = [], this.isDestroyed = !1, this.options = t;
    }
    onInit() {}
    _init(t) {
        this.isDestroyed && (this.subscriptions = [], this.isDestroyed = !1), this.wavesurfer = t, this.onInit();
    }
    destroy() {
        this.emit("destroy"), this.subscriptions.forEach((t)=>t()), this.subscriptions = [], this.isDestroyed = !0, this.wavesurfer = void 0;
    }
}
function $40bc790c1b97f9d3$var$i(t, e) {
    const n = e.xmlns ? document.createElementNS(e.xmlns, t) : document.createElement(t);
    for (const [t, s] of Object.entries(e))if ("children" === t && s) for (const [t, e] of Object.entries(s))e instanceof Node ? n.appendChild(e) : "string" == typeof e ? n.appendChild(document.createTextNode(e)) : n.appendChild($40bc790c1b97f9d3$var$i(t, e));
    else "style" === t ? Object.assign(n.style, s) : "textContent" === t ? n.textContent = s : n.setAttribute(t, s.toString());
    return n;
}
function $40bc790c1b97f9d3$var$n(t, e, n) {
    const s = $40bc790c1b97f9d3$var$i(t, e || {});
    return null == n || n.appendChild(s), s;
}
function $40bc790c1b97f9d3$var$s(t) {
    let e = t;
    const i = new Set;
    return {
        get value () {
            return e;
        },
        set (t) {
            Object.is(e, t) || (e = t, i.forEach((t)=>t(e)));
        },
        update (t) {
            this.set(t(e));
        },
        subscribe: (t)=>(i.add(t), ()=>i.delete(t))
    };
}
function $40bc790c1b97f9d3$var$r(t, e) {
    let i;
    const n = ()=>{
        i && (i(), i = void 0), i = t();
    }, s = e.map((t)=>t.subscribe(n));
    return n(), ()=>{
        i && (i(), i = void 0), s.forEach((t)=>t());
    };
}
function $40bc790c1b97f9d3$var$o(t, e) {
    const i = $40bc790c1b97f9d3$var$s(null), n = (t)=>{
        i.set(t);
    };
    return t.addEventListener(e, n), i._cleanup = ()=>{
        t.removeEventListener(e, n);
    }, i;
}
function $40bc790c1b97f9d3$var$l(t) {
    const e = t._cleanup;
    "function" == typeof e && e();
}
function $40bc790c1b97f9d3$var$h(t, e = {}) {
    const { threshold: i = 3, mouseButton: n = 0, touchDelay: r = 100 } = e, o = $40bc790c1b97f9d3$var$s(null), h1 = new Map, a = matchMedia("(pointer: coarse)").matches;
    let d = ()=>{};
    const c = (e)=>{
        if (e.button !== n) return;
        if (h1.has(e.pointerId)) return;
        if (h1.set(e.pointerId, e), h1.size > 1) return;
        const s = e.pointerId;
        let l = e.clientX, c = e.clientY, u = !1;
        const p = Date.now(), v = t.getBoundingClientRect(), { left: g, top: m } = v, f = (t)=>{
            if (t.pointerId !== s) return;
            if (t.defaultPrevented || h1.size > 1) return;
            if (a && Date.now() - p < r) return;
            const e = t.clientX, n = t.clientY, d = e - l, v = n - c;
            (u || Math.abs(d) > i || Math.abs(v) > i) && (t.preventDefault(), t.stopPropagation(), u || (o.set({
                type: "start",
                x: l - g,
                y: c - m
            }), u = !0), o.set({
                type: "move",
                x: e - g,
                y: n - m,
                deltaX: d,
                deltaY: v
            }), l = e, c = n);
        }, b = (t)=>{
            if (h1.delete(t.pointerId)) {
                if (t.pointerId === s && u) {
                    const e = t.clientX, i = t.clientY;
                    o.set({
                        type: "end",
                        x: e - g,
                        y: i - m
                    });
                }
                0 === h1.size && d();
            }
        }, E = (t)=>{
            t.relatedTarget && t.relatedTarget !== document.documentElement || b(t);
        }, C = (t)=>{
            u && (t.stopPropagation(), t.preventDefault());
        }, L = (t)=>{
            t.defaultPrevented || h1.size > 1 || u && t.preventDefault();
        };
        document.addEventListener("pointermove", f), document.addEventListener("pointerup", b), document.addEventListener("pointerout", E), document.addEventListener("pointercancel", E), document.addEventListener("touchmove", L, {
            passive: !1
        }), document.addEventListener("click", C, {
            capture: !0
        }), d = ()=>{
            document.removeEventListener("pointermove", f), document.removeEventListener("pointerup", b), document.removeEventListener("pointerout", E), document.removeEventListener("pointercancel", E), document.removeEventListener("touchmove", L), setTimeout(()=>{
                document.removeEventListener("click", C, {
                    capture: !0
                });
            }, 10);
        };
    };
    t.addEventListener("pointerdown", c);
    return {
        signal: o,
        cleanup: ()=>{
            d(), t.removeEventListener("pointerdown", c), h1.clear(), $40bc790c1b97f9d3$var$l(o);
        }
    };
}
class $40bc790c1b97f9d3$var$a extends $40bc790c1b97f9d3$var$t {
    constructor(t, e, i = 0){
        var n, s, r, o, l, h, a, d, c, u;
        super(), this.totalDuration = e, this.numberOfChannels = i, this.element = null, this.minLength = 0, this.maxLength = 1 / 0, this.contentEditable = !1, this.subscriptions = [], this.updatingSide = void 0, this.isRemoved = !1, this.subscriptions = [], this.id = t.id || `region-${Math.random().toString(32).slice(2)}`, this.start = this.clampPosition(t.start), this.end = this.clampPosition(null !== (n = t.end) && void 0 !== n ? n : t.start), this.drag = null === (s = t.drag) || void 0 === s || s, this.resize = null === (r = t.resize) || void 0 === r || r, this.resizeStart = null === (o = t.resizeStart) || void 0 === o || o, this.resizeEnd = null === (l = t.resizeEnd) || void 0 === l || l, this.color = null !== (h = t.color) && void 0 !== h ? h : "rgba(0, 0, 0, 0.1)", this.minLength = null !== (a = t.minLength) && void 0 !== a ? a : this.minLength, this.maxLength = null !== (d = t.maxLength) && void 0 !== d ? d : this.maxLength, this.channelIdx = null !== (c = t.channelIdx) && void 0 !== c ? c : -1, this.contentEditable = null !== (u = t.contentEditable) && void 0 !== u ? u : this.contentEditable, this.element = this.initElement(), this.setContent(t.content), this.setPart(), this.renderPosition(), this.initMouseEvents();
    }
    clampPosition(t) {
        return Math.max(0, Math.min(this.totalDuration, t));
    }
    setPart() {
        var t;
        const e = this.start === this.end;
        null === (t = this.element) || void 0 === t || t.setAttribute("part", `${e ? "marker" : "region"} ${this.id}`);
    }
    addResizeHandles(t) {
        const e = {
            position: "absolute",
            zIndex: "2",
            width: "6px",
            height: "100%",
            top: "0",
            cursor: "ew-resize",
            wordBreak: "keep-all"
        }, i = $40bc790c1b97f9d3$var$n("div", {
            part: "region-handle region-handle-left",
            style: Object.assign(Object.assign({}, e), {
                left: "0",
                borderLeft: "2px solid rgba(0, 0, 0, 0.5)",
                borderRadius: "2px 0 0 2px"
            })
        }, t), s = $40bc790c1b97f9d3$var$n("div", {
            part: "region-handle region-handle-right",
            style: Object.assign(Object.assign({}, e), {
                right: "0",
                borderRight: "2px solid rgba(0, 0, 0, 0.5)",
                borderRadius: "0 2px 2px 0"
            })
        }, t), o = $40bc790c1b97f9d3$var$h(i, {
            threshold: 1
        }), l = $40bc790c1b97f9d3$var$h(s, {
            threshold: 1
        }), a = $40bc790c1b97f9d3$var$r(()=>{
            const t = o.signal.value;
            t && ("move" === t.type && void 0 !== t.deltaX ? this.onResize(t.deltaX, "start") : "end" === t.type && this.onEndResizing("start"));
        }, [
            o.signal
        ]), d = $40bc790c1b97f9d3$var$r(()=>{
            const t = l.signal.value;
            t && ("move" === t.type && void 0 !== t.deltaX ? this.onResize(t.deltaX, "end") : "end" === t.type && this.onEndResizing("end"));
        }, [
            l.signal
        ]);
        this.subscriptions.push(()=>{
            a(), d(), o.cleanup(), l.cleanup();
        });
    }
    removeResizeHandles(t) {
        const e = t.querySelector('[part*="region-handle-left"]'), i = t.querySelector('[part*="region-handle-right"]');
        e && t.removeChild(e), i && t.removeChild(i);
    }
    initElement() {
        if (this.isRemoved) return null;
        const t = this.start === this.end;
        let e = 0, i = 100;
        this.channelIdx >= 0 && this.numberOfChannels > 0 && this.channelIdx < this.numberOfChannels && (i = 100 / this.numberOfChannels, e = i * this.channelIdx);
        const s = $40bc790c1b97f9d3$var$n("div", {
            style: {
                position: "absolute",
                top: `${e}%`,
                height: `${i}%`,
                backgroundColor: t ? "none" : this.color,
                borderLeft: t ? "2px solid " + this.color : "none",
                borderRadius: "2px",
                boxSizing: "border-box",
                transition: "background-color 0.2s ease",
                cursor: this.drag ? "grab" : "default",
                pointerEvents: "all"
            }
        });
        return !t && this.resize && this.addResizeHandles(s), s;
    }
    renderPosition() {
        if (!this.element) return;
        const t = this.start / this.totalDuration, e = (this.totalDuration - this.end) / this.totalDuration;
        this.element.style.left = 100 * t + "%", this.element.style.right = 100 * e + "%";
    }
    toggleCursor(t) {
        var e;
        this.drag && (null === (e = this.element) || void 0 === e ? void 0 : e.style) && (this.element.style.cursor = t ? "grabbing" : "grab");
    }
    initMouseEvents() {
        const { element: t } = this;
        if (!t) return;
        const e = $40bc790c1b97f9d3$var$o(t, "click"), i = $40bc790c1b97f9d3$var$o(t, "mouseenter"), n = $40bc790c1b97f9d3$var$o(t, "mouseleave"), s = $40bc790c1b97f9d3$var$o(t, "dblclick"), a = $40bc790c1b97f9d3$var$o(t, "pointerdown"), d = $40bc790c1b97f9d3$var$o(t, "pointerup"), c = e.subscribe((t)=>t && this.emit("click", t)), u = i.subscribe((t)=>t && this.emit("over", t)), p = n.subscribe((t)=>t && this.emit("leave", t)), v = s.subscribe((t)=>t && this.emit("dblclick", t)), g = a.subscribe((t)=>t && this.toggleCursor(!0)), m = d.subscribe((t)=>t && this.toggleCursor(!1));
        this.subscriptions.push(()=>{
            c(), u(), p(), v(), g(), m(), $40bc790c1b97f9d3$var$l(e), $40bc790c1b97f9d3$var$l(i), $40bc790c1b97f9d3$var$l(n), $40bc790c1b97f9d3$var$l(s), $40bc790c1b97f9d3$var$l(a), $40bc790c1b97f9d3$var$l(d);
        });
        const f = $40bc790c1b97f9d3$var$h(t), b = $40bc790c1b97f9d3$var$r(()=>{
            const t = f.signal.value;
            t && ("start" === t.type ? this.toggleCursor(!0) : "move" === t.type && void 0 !== t.deltaX ? this.onMove(t.deltaX) : "end" === t.type && (this.toggleCursor(!1), this.drag && this.emit("update-end")));
        }, [
            f.signal
        ]);
        this.subscriptions.push(()=>{
            b(), f.cleanup();
        }), this.contentEditable && this.content && (this.contentClickListener = (t)=>this.onContentClick(t), this.contentBlurListener = ()=>this.onContentBlur(), this.content.addEventListener("click", this.contentClickListener), this.content.addEventListener("blur", this.contentBlurListener));
    }
    _onUpdate(t, e, i) {
        var n;
        if (!(null === (n = this.element) || void 0 === n ? void 0 : n.parentElement)) return;
        const { width: s } = this.element.parentElement.getBoundingClientRect(), r = t / s * this.totalDuration;
        let o = e && "start" !== e ? this.start : this.start + r, l = e && "end" !== e ? this.end : this.end + r;
        const h = void 0 !== i;
        h && this.updatingSide && this.updatingSide !== e && ("start" === this.updatingSide ? o = i : l = i), o = Math.max(0, o), l = Math.min(this.totalDuration, l);
        const a = l - o;
        this.updatingSide = e;
        const d = a >= this.minLength && a <= this.maxLength;
        o <= l && (d || h) && (this.start = o, this.end = l, this.renderPosition(), this.emit("update", e));
    }
    onMove(t) {
        this.drag && this._onUpdate(t);
    }
    onResize(t, e) {
        this.resize && (this.resizeStart || "start" !== e) && (this.resizeEnd || "end" !== e) && this._onUpdate(t, e);
    }
    onEndResizing(t) {
        this.resize && (this.emit("update-end", t), this.updatingSide = void 0);
    }
    onContentClick(t) {
        t.stopPropagation();
        t.target.focus(), this.emit("click", t);
    }
    onContentBlur() {
        this.emit("update-end");
    }
    _setTotalDuration(t) {
        this.totalDuration = t, this.renderPosition();
    }
    play(t) {
        this.emit("play", t && this.end !== this.start ? this.end : void 0);
    }
    getContent(t = !1) {
        var e;
        return t ? this.content || void 0 : this.element instanceof HTMLElement ? (null === (e = this.content) || void 0 === e ? void 0 : e.innerHTML) || void 0 : "";
    }
    setContent(t) {
        var e;
        if (this.element) {
            if (this.content && this.contentEditable && (this.contentClickListener && this.content.removeEventListener("click", this.contentClickListener), this.contentBlurListener && this.content.removeEventListener("blur", this.contentBlurListener)), null === (e = this.content) || void 0 === e || e.remove(), t) {
                if ("string" == typeof t) {
                    const e = this.start === this.end;
                    this.content = $40bc790c1b97f9d3$var$n("div", {
                        style: {
                            padding: `0.2em ${e ? .2 : .4}em`,
                            display: "inline-block"
                        },
                        textContent: t
                    });
                } else this.content = t;
                this.contentEditable && (this.content.contentEditable = "true", this.contentClickListener = (t)=>this.onContentClick(t), this.contentBlurListener = ()=>this.onContentBlur(), this.content.addEventListener("click", this.contentClickListener), this.content.addEventListener("blur", this.contentBlurListener)), this.content.setAttribute("part", "region-content"), this.element.appendChild(this.content), this.emit("content-changed");
            } else this.content = void 0;
        }
    }
    setOptions(t) {
        var e, i;
        if (this.element) {
            if (t.color && (this.color = t.color, this.element.style.backgroundColor = this.color), void 0 !== t.drag && (this.drag = t.drag, this.element.style.cursor = this.drag ? "grab" : "default"), void 0 !== t.start || void 0 !== t.end) {
                const n = this.start === this.end;
                this.start = this.clampPosition(null !== (e = t.start) && void 0 !== e ? e : this.start), this.end = this.clampPosition(null !== (i = t.end) && void 0 !== i ? i : n ? this.start : this.end), this.renderPosition(), this.setPart(), this.emit("render");
            }
            if (t.content && this.setContent(t.content), t.id && (this.id = t.id, this.setPart()), void 0 !== t.resize && t.resize !== this.resize) {
                const e = this.start === this.end;
                this.resize = t.resize, this.resize && !e ? this.addResizeHandles(this.element) : this.removeResizeHandles(this.element);
            }
            void 0 !== t.resizeStart && (this.resizeStart = t.resizeStart), void 0 !== t.resizeEnd && (this.resizeEnd = t.resizeEnd);
        }
    }
    remove() {
        this.isRemoved = !0, this.emit("remove"), this.subscriptions.forEach((t)=>t()), this.subscriptions = [], this.content && this.contentEditable && (this.contentClickListener && (this.content.removeEventListener("click", this.contentClickListener), this.contentClickListener = void 0), this.contentBlurListener && (this.content.removeEventListener("blur", this.contentBlurListener), this.contentBlurListener = void 0)), this.element && (this.element.remove(), this.element = null), this.unAll();
    }
}
class $40bc790c1b97f9d3$export$2e2bcd8739ae039 extends $40bc790c1b97f9d3$var$e {
    constructor(t){
        super(t), this.regions = [], this.regionsContainer = this.initRegionsContainer();
    }
    static create(t) {
        return new $40bc790c1b97f9d3$export$2e2bcd8739ae039(t);
    }
    onInit() {
        if (!this.wavesurfer) throw Error("WaveSurfer is not initialized");
        this.wavesurfer.getWrapper().appendChild(this.regionsContainer), this.subscriptions.push(this.wavesurfer.on("ready", (t)=>{
            this.regions.forEach((e)=>e._setTotalDuration(t));
        }));
        let t = [];
        this.subscriptions.push(this.wavesurfer.on("timeupdate", (e)=>{
            const i = this.regions.filter((t)=>t.start <= e && (t.end === t.start ? t.start + .05 : t.end) >= e);
            i.forEach((e)=>{
                t.includes(e) || this.emit("region-in", e);
            }), t.forEach((t)=>{
                i.includes(t) || this.emit("region-out", t);
            }), t = i;
        }));
    }
    initRegionsContainer() {
        return $40bc790c1b97f9d3$var$n("div", {
            part: "regions-container",
            style: {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                zIndex: "5",
                pointerEvents: "none"
            }
        });
    }
    getRegions() {
        return this.regions;
    }
    avoidOverlapping(t) {
        t.content && !t.isRemoved && setTimeout(()=>{
            if (!t.content) return;
            const e = t.content;
            e.style.marginTop = "0";
            const i = e.getBoundingClientRect(), n = this.regions.indexOf(t);
            if (n < 0) return;
            const s = this.regions.slice(0, n).filter((t)=>!t.isRemoved).reduce((e, n)=>{
                if (n === t || !n.content) return e;
                const s = n.content.getBoundingClientRect();
                return i.left < s.right && s.left < i.right && e.push(s), e;
            }, []).sort((t, e)=>t.top - e.top).reduce((t, e)=>{
                const n = i.top + t, s = n + i.height;
                return n < e.bottom && e.top < s ? e.bottom - i.top + 2 : t;
            }, 0);
            e.style.marginTop = `${s}px`;
        }, 10);
    }
    avoidOverlappingAll() {
        this.regions.forEach((t)=>this.avoidOverlapping(t));
    }
    adjustScroll(t) {
        var e, i;
        if (!t.element) return;
        const n = null === (i = null === (e = this.wavesurfer) || void 0 === e ? void 0 : e.getWrapper()) || void 0 === i ? void 0 : i.parentElement;
        if (!n) return;
        const { clientWidth: s, scrollWidth: r } = n;
        if (r <= s) return;
        const o = n.getBoundingClientRect(), l = t.element.getBoundingClientRect(), h = l.left - o.left, a = l.right - o.left;
        h < 0 ? n.scrollLeft += h : a > s && (n.scrollLeft += a - s);
    }
    virtualAppend(t, e, i) {
        const n = ()=>{
            if (!this.wavesurfer) return;
            const n = this.wavesurfer.getWidth(), s = this.wavesurfer.getScroll(), r = e.clientWidth, o = this.wavesurfer.getDuration(), l = Math.round(t.start / o * r), h = l + (Math.round((t.end - t.start) / o * r) || 1) > s && l < s + n;
            h && !i.parentElement ? e.appendChild(i) : !h && i.parentElement && i.remove();
        };
        setTimeout(()=>{
            if (!this.wavesurfer || !t.element) return;
            n();
            const e = this.wavesurfer.on("scroll", n), i = this.wavesurfer.on("zoom", n), s = this.wavesurfer.on("resize", n), r = t.on("render", n), o = [
                e,
                i,
                s,
                r
            ];
            this.subscriptions.push(...o), t.once("remove", ()=>{
                e(), i(), s(), r(), this.subscriptions = this.subscriptions.filter((t)=>!o.includes(t));
            });
        }, 0);
    }
    saveRegion(t) {
        if (!t.element) return;
        this.virtualAppend(t, this.regionsContainer, t.element), this.avoidOverlapping(t), this.regions.push(t);
        const e = [
            t.on("update", (e)=>{
                e || this.adjustScroll(t), this.emit("region-update", t, e);
            }),
            t.on("update-end", (e)=>{
                this.avoidOverlappingAll(), this.emit("region-updated", t, e);
            }),
            t.on("play", (e)=>{
                var i;
                null === (i = this.wavesurfer) || void 0 === i || i.play(t.start, e);
            }),
            t.on("click", (e)=>{
                this.emit("region-clicked", t, e);
            }),
            t.on("dblclick", (e)=>{
                this.emit("region-double-clicked", t, e);
            }),
            t.on("content-changed", ()=>{
                this.emit("region-content-changed", t);
            }),
            t.once("remove", ()=>{
                e.forEach((t)=>t()), this.subscriptions = this.subscriptions.filter((t)=>!e.includes(t)), this.regions = this.regions.filter((e)=>e !== t), this.emit("region-removed", t);
            })
        ];
        this.subscriptions.push(...e), this.emit("region-created", t);
    }
    addRegion(t) {
        var e, i;
        if (!this.wavesurfer) throw Error("WaveSurfer is not initialized");
        const n = this.wavesurfer.getDuration(), s = null === (i = null === (e = this.wavesurfer) || void 0 === e ? void 0 : e.getDecodedData()) || void 0 === i ? void 0 : i.numberOfChannels, r = new $40bc790c1b97f9d3$var$a(t, n, s);
        if (this.emit("region-initialized", r), n) this.saveRegion(r);
        else {
            const t = this.wavesurfer.once("ready", (e)=>{
                r._setTotalDuration(e), this.saveRegion(r), this.subscriptions = this.subscriptions.filter((e)=>e !== t);
            });
            this.subscriptions.push(t);
        }
        return r;
    }
    enableDragSelection(t, e = 3) {
        var i;
        const n = null === (i = this.wavesurfer) || void 0 === i ? void 0 : i.getWrapper();
        if (!(n && n instanceof HTMLElement)) return ()=>{};
        let s = null, o = 0, l = 0;
        const d = $40bc790c1b97f9d3$var$h(n, {
            threshold: e
        }), c = $40bc790c1b97f9d3$var$r(()=>{
            var e, i;
            const n = d.signal.value;
            if (n) {
                if ("start" === n.type) {
                    if (o = n.x, !this.wavesurfer) return;
                    const r = this.wavesurfer.getDuration(), h = null === (i = null === (e = this.wavesurfer) || void 0 === e ? void 0 : e.getDecodedData()) || void 0 === i ? void 0 : i.numberOfChannels, { width: d } = this.wavesurfer.getWrapper().getBoundingClientRect();
                    l = o / d * r;
                    const c = n.x / d * r, u = (n.x + 5) / d * r;
                    s = new $40bc790c1b97f9d3$var$a(Object.assign(Object.assign({}, t), {
                        start: c,
                        end: u
                    }), r, h), this.emit("region-initialized", s), s.element && this.regionsContainer.appendChild(s.element);
                } else "move" === n.type && void 0 !== n.deltaX ? s && s._onUpdate(n.deltaX, n.x > o ? "end" : "start", l) : "end" === n.type && s && (this.saveRegion(s), s.updatingSide = void 0, s = null);
            }
        }, [
            d.signal
        ]);
        return ()=>{
            c(), d.cleanup();
        };
    }
    clearRegions() {
        this.regions.slice().forEach((t)=>t.remove()), this.regions = [];
    }
    destroy() {
        this.clearRegions(), super.destroy(), this.regionsContainer.remove();
    }
}



var $5IZkx = parcelRequire("5IZkx");

var $fmJ8d = parcelRequire("fmJ8d");
function $133e7baa0382ff89$export$e284421eae6e218(seconds) {
    const totalSeconds = Math.round(seconds);
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    // Format the time as 00:00
    const formattedTime = [
        minutes,
        secs
    ].map((val)=>val.toString().padStart(2, "0")).join(":");
    return formattedTime;
}
function $133e7baa0382ff89$export$88a5fd9752ff366c(source, options = {}) {
    const { silenceThreshold: silenceThreshold = 0.01, windowMs: windowMs = 20 } = options;
    const audioBuffer = typeof source?.getDecodedData === "function" ? source.getDecodedData() : source;
    if (!audioBuffer || typeof audioBuffer.getChannelData !== "function") return source?.getDuration?.() ?? 0;
    const { sampleRate: sampleRate, length: length, numberOfChannels: numberOfChannels } = audioBuffer;
    const windowSize = Math.max(1, Math.floor(windowMs / 1000 * sampleRate));
    const channels = [];
    for(let c = 0; c < numberOfChannels; c++)channels.push(audioBuffer.getChannelData(c));
    for(let end = length; end > 0; end -= windowSize){
        const start = Math.max(0, end - windowSize);
        let peakRms = 0;
        for(let c = 0; c < channels.length; c++){
            const data = channels[c];
            let sumSquares = 0;
            for(let i = start; i < end; i++)sumSquares += data[i] * data[i];
            const rms = Math.sqrt(sumSquares / (end - start));
            if (rms > peakRms) peakRms = rms;
        }
        if (peakRms > silenceThreshold) return end / sampleRate;
    }
    return 0;
}
/**
 * Default time display value in "mm:ss" format
 */ const $133e7baa0382ff89$var$DEFAULT_TIME = "00:00";
/**
 * WaveSurfer configuration constants
 */ const $133e7baa0382ff89$var$WAVE_CONFIG = {
    // WAVE_COLOR: "var(--wave-color)",
    // PROGRESS_COLOR: "var(--progress-color)",
    WAVE_COLOR: "#909090",
    PROGRESS_COLOR: "#0265dc",
    HEIGHT: 50,
    BAR_WIDTH: 2,
    BAR_GAP: 1,
    BAR_HEIGHT: 0.7,
    BAR_RADIUS: 3,
    CURSOR_WIDTH: 0,
    CHANNEL_HEIGHT: 50
};
const $133e7baa0382ff89$var$audioPlayerStyle = " sd182 _tc182 Za182 _Pc182 eb182 Ug182 qg182 NwHzgQe182";
const $133e7baa0382ff89$var$timeCodeStyle = " -LDX6Zb-Zv182 _Pc182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182 _4c182 NJ7BOdb182 _Wa182";
const $133e7baa0382ff89$var$waveformStyle = " _Pc182 _ub182 _I9Rz9ee182 Fb182 -ej5hI-pn182 -knGqbd-pg30vFd182 -l8bz2-p7B7Kwc182 -wd6Fsc-pSbZC3d182 -oRG0G-po182 -fV1Bgb-p3At3Td182 -KMJMmd-p9d4kQe182 -srhyqc-pxpQByd182";
const $133e7baa0382ff89$var$loadingContainerStyle = " -bVULOe-Fz182 Za182 F18q2yc182 sd182 eb182 _Ca182";
const $133e7baa0382ff89$var$loadingDotsStyle = " -_8P63Pe-FlAZvq182 Za182 FGSVisb182 _gYtJrVc182 _ec182 _hb182";
const $133e7baa0382ff89$export$832cc5475f11d8b4 = ({ ref: ref, url: url, isAudioJobScheduled: isAudioJobScheduled, onRegenerateAudio: onRegenerateAudio, needsRegeneration: needsRegeneration = false, isEditorEmpty: isEditorEmpty = false, isFirstAudioGeneration: isFirstAudioGeneration = false, videoRef: videoRef, segments: segments = [], duration: duration, onReady: onReady, onRegionPress: onRegionPress, onRegionIn: onRegionIn, onRegionOut: onRegionOut, onPreviewPlay: onPreviewPlay })=>{
    const id = (0, $eF4cA.useId)();
    const [isLoaded, setIsLoaded] = (0, $eF4cA.useState)(false);
    const [isPaused, setIsPaused] = (0, $eF4cA.useState)(true);
    const [currentTime, setCurrentTime] = (0, $eF4cA.useState)($133e7baa0382ff89$var$DEFAULT_TIME);
    // const { sendClickEvent, sendDragEvent } = useAnalytics();
    const audioRef = /*#__PURE__*/ (0, $eF4cA.createRef)();
    const waveformRef = (0, $eF4cA.useRef)();
    const regionsRef = (0, $eF4cA.useRef)();
    const segmentsRef = (0, $eF4cA.useRef)([]);
    const durationRef = (0, $eF4cA.useRef)($133e7baa0382ff89$var$DEFAULT_TIME);
    const waveformContainerRef = (0, $eF4cA.useRef)(null);
    const isUserDragging = (0, $eF4cA.useRef)(false);
    // const localize = useLocalize();
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const isDarkTheme = colorScheme === "dark";
    (0, $eF4cA.useEffect)(()=>{
        setIsPaused(true);
        setIsLoaded(false);
        setCurrentTime($133e7baa0382ff89$var$DEFAULT_TIME);
    }, [
        url
    ]);
    /**
   * Initializes the WaveSurfer instance and sets up event listeners for the audio player.
   *
   * @param url - The URL of the audio file.
   * @param isAudioJobScheduled - Whether an audio job is scheduled.
   */ (0, $eF4cA.useEffect)(()=>{
        if (url && !isAudioJobScheduled) initializeWaveform(url);
        return ()=>{
            waveformRef.current?.destroy();
        };
    }, [
        url,
        isAudioJobScheduled
    ]);
    const initializeWaveform = (audioUrl)=>{
        if (!waveformContainerRef.current || !audioUrl) return;
        if (waveformRef.current) waveformRef.current.destroy();
        waveformRef.current = (0, $419ca02d64eacc2f$export$2e2bcd8739ae039).create({
            container: `#audioPlayer-${id}`,
            waveColor: $133e7baa0382ff89$var$WAVE_CONFIG.WAVE_COLOR,
            progressColor: $133e7baa0382ff89$var$WAVE_CONFIG.PROGRESS_COLOR,
            height: $133e7baa0382ff89$var$WAVE_CONFIG.HEIGHT,
            barWidth: $133e7baa0382ff89$var$WAVE_CONFIG.BAR_WIDTH,
            barGap: $133e7baa0382ff89$var$WAVE_CONFIG.BAR_GAP,
            normalize: true,
            barHeight: $133e7baa0382ff89$var$WAVE_CONFIG.BAR_HEIGHT,
            dragToSeek: true,
            barRadius: $133e7baa0382ff89$var$WAVE_CONFIG.BAR_RADIUS,
            cursorWidth: $133e7baa0382ff89$var$WAVE_CONFIG.CURSOR_WIDTH,
            splitChannels: [
                {
                    height: $133e7baa0382ff89$var$WAVE_CONFIG.CHANNEL_HEIGHT,
                    container: "#audio-result"
                },
                {
                    height: 0,
                    container: "#audio-result"
                }
            ],
            url: audioUrl
        });
        if (typeof ref === "function") ref(waveformRef.current);
        else if (ref) ref.current = waveformRef.current;
        /**
     * Event listener for when the waveform is ready.
     * Sets the duration of the audio and marks it as loaded.
     */ waveformRef.current.on("ready", ()=>{
            if (!waveformRef.current) return;
            durationRef.current = $133e7baa0382ff89$export$e284421eae6e218(waveformRef.current.getDuration());
            if (videoRef?.current) {
                videoRef?.current?.pause?.();
                videoRef.current.currentTime = 0;
            }
            setIsLoaded(true);
            onReady?.(waveformRef.current);
        });
        /**
     * Event listener for when the audio finishes playing.
     * Marks the audio as paused.
     */ waveformRef.current.on("finish", ()=>{
            setIsPaused(true);
            isUserDragging.current = false;
        });
        waveformRef.current.on("play", ()=>{
            setIsPaused(false);
            videoRef?.current?.play?.();
        });
        waveformRef.current.on("seeking", (currentTime)=>{
            if (videoRef?.current) videoRef.current.currentTime = currentTime;
        });
        waveformRef.current.on("timeupdate", (currentTime)=>{
            if (videoRef?.current) {
                if (Math.abs(videoRef.current.currentTime - currentTime) > 0.2) videoRef.current.currentTime = currentTime;
            }
        });
        waveformRef.current.on("pause", ()=>{
            setIsPaused(true);
            videoRef?.current?.pause?.();
        });
        waveformRef.current.on("finish", ()=>{
            setIsPaused(true);
            videoRef?.current?.pause?.();
        });
        waveformRef.current.on("drag", ()=>{
            isUserDragging.current = true;
        });
        waveformRef.current.on("click", ()=>{
            isUserDragging.current = true;
        });
        /**
     * Event listener for when the audio time updates.
     * Updates the current time display.
     */ waveformRef.current.on("timeupdate", (currentTime)=>{
            setCurrentTime($133e7baa0382ff89$export$e284421eae6e218(currentTime));
            // Only send drag event if user is dragging
            if (isUserDragging.current) // sendDragEvent({
            //   subtype: AnalyticsEventSubtype.SLIDER,
            //   subcategory: AnalyticsSubcategory.CONTENT_MODULE,
            //   value: getFormattedTime(currentTime)
            // });
            isUserDragging.current = false;
        });
    };
    (0, $eF4cA.useEffect)(()=>{
        if (waveformRef.current && !isAudioJobScheduled && segments?.length > 0) {
            const regions = (0, $40bc790c1b97f9d3$export$2e2bcd8739ae039).create();
            waveformRef.current.registerPlugin(regions);
            waveformRef.current.on("decode", ()=>{
                segments.forEach((segment, index)=>{
                    const segmentElement = document.createElement("div");
                    segmentsRef.current[index] = segmentElement;
                    const region = regions.addRegion({
                        // id: `segment-${index}`,
                        content: segmentElement,
                        start: segment.start,
                        end: segment.end,
                        color: "transparent",
                        drag: false,
                        resize: false
                    });
                    if (segment.isInvalid) region.element.part.add("invalid");
                });
            });
            regions.on("region-clicked", (region, e)=>{
                if (segments.length > 1) e.stopPropagation();
                const index = regions.regions.indexOf(region);
                const segment = segments[index];
                onRegionPress?.({
                    segment: segment,
                    region: region,
                    waveform: waveformRef.current
                });
            });
            regions.on("region-in", (region)=>{
                const index = regions.regions.indexOf(region);
                const segment = segments[index];
                onRegionIn?.({
                    segment: segment,
                    region: region,
                    waveform: waveformRef.current
                });
            });
            regions.on("region-out", (region)=>{
                const index = regions.regions.indexOf(region);
                const segment = segments[index];
                onRegionOut?.({
                    segment: segment,
                    region: region,
                    waveform: waveformRef.current
                });
            });
        }
    }, [
        segments,
        isAudioJobScheduled
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!isLoaded || !waveformContainerRef.current) return;
        let waveColor, progressColor;
        try {
            const lightDarkRegexp = /light-dark\(([^,]+),\s*([^)]+)\)/;
            const waveColorTheme = getComputedStyle(waveformContainerRef.current).getPropertyValue("--wave-color");
            const progressColorTheme = getComputedStyle(waveformContainerRef.current).getPropertyValue("--progress-color");
            waveColor = waveColorTheme.match(lightDarkRegexp)?.[isDarkTheme ? 2 : 1];
            progressColor = progressColorTheme.match(lightDarkRegexp)?.[isDarkTheme ? 2 : 1];
        } catch (error) {
        /* ignore */ }
        const options = {
            waveColor: waveColor ?? $133e7baa0382ff89$var$WAVE_CONFIG.WAVE_COLOR,
            progressColor: progressColor ?? $133e7baa0382ff89$var$WAVE_CONFIG.PROGRESS_COLOR
        };
        waveformRef.current?.setOptions(options);
    }, [
        isLoaded,
        isDarkTheme
    ]);
    /**
   * Handler for the play/pause/regenerate button click event.
   */ const buttonClickHandler = ()=>{
        if ((needsRegeneration || isFirstAudioGeneration) && onRegenerateAudio) {
            // sendClickEvent({
            //   subtype: AnalyticsEventSubtype.GENERATE_AUDIO,
            //   subcategory: AnalyticsSubcategory.SCRIPT_MODULE
            // });
            onRegenerateAudio();
            return;
        }
        if (!waveformRef.current || !isLoaded) return;
        if (isPaused) onPreviewPlay?.();
        waveformRef.current.playPause();
    // if (waveformRef.current.isPlaying()) {
    //   waveformRef.current.pause();
    //   setIsPaused(true);
    // } else {
    //   // sendClickEvent({
    //   //   subtype: AnalyticsEventSubtype.PLAY_AUDIO,
    //   //   subcategory: AnalyticsSubcategory.SCRIPT_MODULE
    //   // });
    //   waveformRef.current.play();
    //   setIsPaused(false);
    // }
    };
    /**
   * Determines the appropriate button label based on the current state of the audio player.
   *
   * @returns A localized string for the button label that reflects the current state:
   *   - "Preview Audio" for first generation or when paused
   *   - "Generating" when an audio job is scheduled or loading
   *   - "Regenerate" when audio needs regeneration
   *   - "Pause" when audio is playing
   */ const buttonLabel = ()=>{
        if (isFirstAudioGeneration || isEditorEmpty) return "Preview Audio";
        if (isAudioJobScheduled || !isLoaded && !needsRegeneration) return "Generating";
        if (needsRegeneration) return "Regenerate";
        return isPaused ? "Preview Audio" : "Pause";
    };
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: $133e7baa0382ff89$var$audioPlayerStyle,
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)("audio", {
                    ref: audioRef,
                    src: url
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                    delay: 0,
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            onPress: buttonClickHandler,
                            // className={[
                            //   styles["play-button"],
                            //   needsRegeneration && !isEditorEmpty && styles["regenerate-button"],
                            //   needsRegeneration && !isEditorEmpty && isDarkTheme && styles["regenerate-button-dark"]
                            // ]}
                            isQuiet: true,
                            isDisabled: isAudioJobScheduled || isEditorEmpty || !isLoaded && !needsRegeneration && !isFirstAudioGeneration,
                            "aria-label": buttonLabel(),
                            children: isAudioJobScheduled || !isLoaded && !isEditorEmpty ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                size: "S",
                                isIndeterminate: true,
                                staticColor: "auto",
                                "aria-label": "loading",
                                styles: " z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182"
                            }) : isFirstAudioGeneration || isEditorEmpty ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9iR3a.default), {}) : needsRegeneration ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {}) : isPaused ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9iR3a.default), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fdf9f573ae2779ee$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: buttonLabel()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: $133e7baa0382ff89$var$timeCodeStyle,
                    role: "button",
                    "aria-label": currentTime,
                    children: currentTime
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: "waveform" + $133e7baa0382ff89$var$waveformStyle,
                    style: {
                        display: url && isLoaded && !isAudioJobScheduled && !needsRegeneration ? "block" : "none"
                    },
                    id: `audioPlayer-${id}`,
                    ref: waveformContainerRef,
                    role: "region",
                    tabIndex: 0
                }),
                (!isLoaded || isAudioJobScheduled || needsRegeneration) && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: $133e7baa0382ff89$var$loadingContainerStyle,
                    role: "region",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: $133e7baa0382ff89$var$loadingDotsStyle,
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: $133e7baa0382ff89$var$timeCodeStyle,
                    role: "button",
                    "aria-label": isLoaded && !isAudioJobScheduled ? durationRef.current : $133e7baa0382ff89$var$DEFAULT_TIME,
                    children: isLoaded && !isAudioJobScheduled ? durationRef.current : $133e7baa0382ff89$var$DEFAULT_TIME
                })
            ]
        })
    });
};



var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $fmJ8d = parcelRequire("fmJ8d");

var $lRNYL = parcelRequire("lRNYL");

var $lb17q = parcelRequire("lb17q");

var $6AUdR = parcelRequire("6AUdR");
const $761a0cbe5e797307$export$37384698541d4a2c = 5000;
const $761a0cbe5e797307$export$cf7813449d38d4ac = (enabled, project)=>!!enabled && project?.status === "completed";
const $761a0cbe5e797307$export$10e1c22dbeba3cd4 = ()=>{
    const isAdmin = (0, $lRNYL.useIsAdmin)({
        ignoreOverride: true
    });
    const enabled = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.demoMode);
    return isAdmin && !!enabled;
};
const $761a0cbe5e797307$export$b8c8ad5f5d6c886d = (step, template, project)=>{
    const campaign = project.campaigns?.find((item)=>item.id === project.selectedCampaignIds?.[0]);
    const linked = new Set((0, $lb17q.getStructureVariationKeys)(step?.campaignStructure));
    return (0, $lb17q.filterActiveVariations)(template.imageVariations, (0, $lb17q.isImagesStep)(step) ? step.stages : undefined, campaign).filter((variation)=>(0, $lb17q.isImagesStep)(step) || linked.has(variation.key)).map((variation)=>(0, $6AUdR.resolveVariation)(template, project, variation.key));
};
const $761a0cbe5e797307$export$5302b40eee42ebb0 = (project)=>({
        templateId: project.templateId,
        sfType: project.drNumber ? "drNumber" : project.accountName ? "accountName" : "none",
        accountName: project.accountName,
        drNumber: project.drNumber,
        customerName: project.customer?.name ?? project.customer?.["Company-name"],
        product: project.product,
        hint: project.hint,
        personaId: project.personaId,
        verticalKey: project.verticalKey,
        musicPath: project.musicPath,
        voiceoverMode: project.voiceoverMode ?? "original",
        include3DDigitalTwin: project.include3DDigitalTwin ?? project.campaigns?.find((campaign)=>campaign.id === project.selectedCampaignIds?.[0])?.["Include-3D-Digital-Twin"]
    });
const $761a0cbe5e797307$var$hasValue = (value)=>value != null && value !== "";
const $761a0cbe5e797307$export$e412b255a584263e = (project, template)=>{
    const [saved] = (0, $eF4cA.useState)(()=>structuredClone(project));
    const activeTemplateId = template.id ?? saved.templateId;
    const steps = (0, $eF4cA.useMemo)(()=>(0, $lb17q.resolveSteps)(activeTemplateId, template), [
        activeTemplateId,
        template
    ]);
    const [navigation, setNavigation] = (0, $eF4cA.useState)({
        index: 0,
        visit: 0
    });
    const [furthestStep, setFurthestStep] = (0, $eF4cA.useState)(0);
    const step = steps[navigation.index];
    const [finishedVisit, setFinishedVisit] = (0, $eF4cA.useState)(-1);
    const [revealedValues, setRevealedValues] = (0, $eF4cA.useState)(()=>new Set());
    const [revealedAssets, setRevealedAssets] = (0, $eF4cA.useState)(()=>new Set());
    const [uploadingKeys, setUploadingKeys] = (0, $eF4cA.useState)(()=>new Set());
    const [progressByKey, setProgressByKey] = (0, $eF4cA.useState)({});
    const timers = (0, $eF4cA.useRef)(new Set());
    const values = (0, $eF4cA.useMemo)(()=>$761a0cbe5e797307$export$5302b40eee42ebb0(saved), [
        saved
    ]);
    const variations = (0, $eF4cA.useMemo)(()=>$761a0cbe5e797307$export$b8c8ad5f5d6c886d(step, template, saved), [
        step,
        template,
        saved
    ]);
    const enterAction = (0, $lb17q.getStepEnterAction)(step, activeTemplateId);
    const hasLoader = typeof enterAction?.isPending === "function";
    const isStepPending = hasLoader && finishedVisit !== navigation.visit;
    const cancelTimers = (0, $eF4cA.useCallback)(()=>{
        timers.current.forEach(clearTimeout);
        timers.current.clear();
    }, []);
    const schedule = (0, $eF4cA.useCallback)((callback, delay)=>{
        const timer = setTimeout(()=>{
            timers.current.delete(timer);
            callback();
        }, delay);
        timers.current.add(timer);
    }, []);
    const unavailable = (0, $eF4cA.useCallback)((name)=>{
        (0, $fmJ8d.store).getState().addToast(`No saved result for "${name}" in this demo.`, {
            variant: "negative"
        });
    }, []);
    const savedAsset = (0, $eF4cA.useCallback)((name)=>saved.assets?.find((asset)=>asset.name === name), [
        saved
    ]);
    const hasSavedVariation = (0, $eF4cA.useCallback)((variation)=>{
        const asset = savedAsset(variation.key);
        const resolved = (0, $6AUdR.resolveFallbackAsset)(saved, variation, asset) ?? asset;
        return !!(resolved?.filePath || resolved?.src);
    }, [
        saved,
        savedAsset
    ]);
    const simulateVariations = (0, $eF4cA.useCallback)((keys, delay = 0)=>{
        const requested = variations.filter((variation)=>keys.includes(variation.key));
        const runnable = requested.filter(hasSavedVariation);
        requested.filter((variation)=>!hasSavedVariation(variation)).forEach((variation)=>unavailable(variation.label ?? variation.key));
        const byKey = new Map(runnable.map((variation)=>[
                variation.key,
                variation
            ]));
        const depth = (key, ancestors = new Set())=>{
            if (ancestors.has(key)) return 0;
            const next = new Set(ancestors).add(key);
            const references = (0, $lb17q.getVariationReferenceKeys)(byKey.get(key)).filter((reference)=>byKey.has(reference));
            return references.length ? 1 + Math.max(...references.map((reference)=>depth(reference, next))) : 0;
        };
        for (const variation of runnable){
            const key = variation.key;
            const start = delay + depth(key) * $761a0cbe5e797307$export$37384698541d4a2c;
            const phase = (stage, label)=>setProgressByKey((previous)=>({
                        ...previous,
                        [key]: {
                            stage: stage,
                            label: label
                        }
                    }));
            schedule(()=>{
                setRevealedAssets((previous)=>{
                    const next = new Set(previous);
                    next.delete(key);
                    return next;
                });
                phase((0, $lb17q.VARIATION_PROGRESS_STAGE).WAITING, "Waiting");
            }, delay);
            schedule(()=>phase((0, $lb17q.VARIATION_PROGRESS_STAGE).GENERATING, "Generating"), start + 1000);
            schedule(()=>phase((0, $lb17q.VARIATION_PROGRESS_STAGE).SAVING, "Saving"), start + 4000);
            schedule(()=>{
                setRevealedAssets((previous)=>new Set(previous).add(key));
                setProgressByKey((previous)=>{
                    const next = {
                        ...previous
                    };
                    delete next[key];
                    return next;
                });
            }, start + $761a0cbe5e797307$export$37384698541d4a2c);
        }
    }, [
        variations,
        hasSavedVariation,
        schedule,
        unavailable
    ]);
    (0, $eF4cA.useEffect)(()=>{
        const delay = hasLoader ? $761a0cbe5e797307$export$37384698541d4a2c : 0;
        if (hasLoader) schedule(()=>setFinishedVisit(navigation.visit), delay);
        if ((0, $lb17q.isImagesStep)(step) || (0, $lb17q.isCampaignVisualsStep)(step)) simulateVariations(variations.filter((variation)=>!revealedAssets.has(variation.key) && hasSavedVariation(variation)).map((variation)=>variation.key), delay);
        return cancelTimers;
    // Reveals survive a visit; only navigation starts a new simulation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        navigation.visit,
        step,
        hasLoader,
        schedule,
        cancelTimers
    ]);
    const goTo = (0, $eF4cA.useCallback)((index)=>{
        if (index < 0 || index >= steps.length || index === navigation.index) return;
        cancelTimers();
        setProgressByKey({});
        setUploadingKeys(new Set());
        setFurthestStep((previous)=>Math.max(previous, index));
        setNavigation((previous)=>({
                index: index,
                visit: previous.visit + 1
            }));
    }, [
        steps.length,
        navigation.index,
        cancelTimers
    ]);
    const chooseValue = (0, $eF4cA.useCallback)((key)=>{
        if (!$761a0cbe5e797307$var$hasValue(values[key])) {
            unavailable(key);
            return;
        }
        setRevealedValues((previous)=>new Set(previous).add(key));
    }, [
        values,
        unavailable
    ]);
    const chooseAsset = (0, $eF4cA.useCallback)((name)=>{
        const asset = savedAsset(name);
        if (!asset || !(asset.filePath || asset.src || asset.color)) {
            unavailable(name);
            return;
        }
        setRevealedAssets((previous)=>{
            const next = new Set(previous);
            next.delete(name);
            return next;
        });
        setUploadingKeys((previous)=>new Set(previous).add(name));
        schedule(()=>{
            setUploadingKeys((previous)=>{
                const next = new Set(previous);
                next.delete(name);
                return next;
            });
            setRevealedAssets((previous)=>new Set(previous).add(name));
        }, $761a0cbe5e797307$export$37384698541d4a2c);
    }, [
        savedAsset,
        unavailable,
        schedule
    ]);
    const managedNames = (0, $eF4cA.useMemo)(()=>new Set([
            ...(template.assets ?? []).filter((asset)=>[
                    "image",
                    "color"
                ].includes(asset.type)).map((asset)=>asset.name),
            ...(template.imageVariations ?? []).map((variation)=>variation.key)
        ]), [
        template
    ]);
    const visibleProject = {
        ...saved,
        currentStep: step?.id,
        assets: [
            ...(saved.assets ?? []).filter((asset)=>!managedNames.has(asset.name) || revealedAssets.has(asset.name)),
            ...[
                ...uploadingKeys
            ].map((name)=>({
                    name: name,
                    type: savedAsset(name)?.type,
                    isLoading: true
                }))
        ]
    };
    return {
        saved: saved,
        steps: steps,
        step: step,
        index: navigation.index,
        visit: navigation.visit,
        furthestStep: furthestStep,
        isStepPending: isStepPending,
        enterAction: enterAction,
        project: visibleProject,
        values: values,
        value: (key)=>revealedValues.has(key) ? values[key] : null,
        chooseValue: chooseValue,
        chooseAsset: chooseAsset,
        revealedAssets: revealedAssets,
        uploadingKeys: uploadingKeys,
        progressByKey: progressByKey,
        variations: variations,
        savedAsset: savedAsset,
        hasSavedVariation: hasSavedVariation,
        simulateVariations: simulateVariations,
        goTo: goTo,
        replayStep: ()=>{
            cancelTimers();
            setProgressByKey({});
            setUploadingKeys(new Set());
            setNavigation((previous)=>({
                    ...previous,
                    visit: previous.visit + 1
                }));
        }
    };
};



var $6AUdR = parcelRequire("6AUdR");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $KXDAG = parcelRequire("KXDAG");
var $7Vvqh = parcelRequire("7Vvqh");
var $yuTTo = parcelRequire("yuTTo");
var $3YPmU = parcelRequire("3YPmU");
var $5nTep = parcelRequire("5nTep");
var $208Op = parcelRequire("208Op");

var $j7E4C = parcelRequire("j7E4C");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $689e79a6adf3716c$var$$dc21471091428d8b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M15.05 7.2c0-.601-.235-1.167-.658-1.59-.849-.85-2.333-.852-3.183 0L9.388 7.43q-.033.034-.06.069-.037.029-.07.062l-7.599 7.598c-.425.425-.659.99-.659 1.591s.234 1.166.66 1.59.99.66 1.59.66 1.166-.234 1.59-.66l9.55-9.549c.425-.425.66-.99.66-1.59M3.78 17.28c-.283.283-.777.283-1.06 0-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l7.2-7.2 1.065 1.055zm9.55-9.55-1.284 1.285-1.066-1.056 1.29-1.29c.283-.282.777-.283 1.06.002.142.14.22.329.22.53s-.078.388-.22.53M18.706 10.832l-1.261-.499-.203-1.342c-.065-.428-.758-.505-.916-.104l-.499 1.262-1.342.202c-.213.032-.379.203-.403.418s.098.418.299.498l1.262.5.202 1.34c.032.213.203.38.418.404s.418-.098.498-.3l.5-1.26 1.34-.203c.215-.033.38-.204.404-.418s-.099-.42-.299-.498M14.336 3.642l1.262.5.202 1.341c.032.213.204.38.418.403.215.025.418-.097.498-.299l.5-1.26 1.341-.204c.214-.032.379-.203.403-.418s-.098-.419-.299-.498l-1.26-.498-.204-1.342c-.065-.428-.758-.505-.916-.105l-.498 1.263-1.342.201c-.213.032-.38.204-.404.418s.098.418.3.498M5.78 4.69l1.023.406.164 1.088c.026.173.166.307.34.327.173.02.339-.08.404-.243l.405-1.023 1.088-.165c.174-.026.308-.165.328-.339s-.08-.34-.243-.404l-1.023-.404-.165-1.09c-.053-.347-.615-.41-.743-.084l-.405 1.024-1.089.164c-.173.026-.308.165-.327.34-.02.173.079.338.242.403"
        })
    });
const $689e79a6adf3716c$var$$dc21471091428d8b$var$ForwardRef = (0, $eF4cA.forwardRef)($689e79a6adf3716c$var$$dc21471091428d8b$var$SvgComponent);
var $689e79a6adf3716c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($689e79a6adf3716c$var$$dc21471091428d8b$var$ForwardRef);



var $edFAP = parcelRequire("edFAP");

var $fmJ8d = parcelRequire("fmJ8d");

var $kekDO = parcelRequire("kekDO");

var $g42KE = parcelRequire("g42KE");
parcelRequire("8Xrlw");
var $6AUdR = parcelRequire("6AUdR");
var $44uR2 = parcelRequire("44uR2");

var $lRNYL = parcelRequire("lRNYL");

var $lb17q = parcelRequire("lb17q");

var $7nuM2 = parcelRequire("7nuM2");

var $3aLXY = parcelRequire("3aLXY");

var $gCdzD = parcelRequire("gCdzD");

var $lHGo8 = parcelRequire("lHGo8");

var $8ZsKk = parcelRequire("8ZsKk");

var $lfyDg = parcelRequire("lfyDg");
var $lb17q = parcelRequire("lb17q");

var $l1gUk = parcelRequire("l1gUk");
const $7cd28456b648eedc$var$PREVIEW_WIDTH = 480;
// Every row of a variations grid has this many columns, so its cards all share
// one size however many a row holds.
const $7cd28456b648eedc$var$VARIATIONS_GRID_COLUMNS = 5;
/** A preview card and its caption, `isFluid` filling its container's width. */ const $7cd28456b648eedc$var$PreviewFrame = ({ isFluid: isFluid = false, children: children })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd182';
            rules += ' _ta182';
            if (props.isFluid) rules += ' Za182';
            else rules += ' ZILqIYb182';
            rules += ' La182';
            rules += ' _va182';
            return rules;
        }({
            isFluid: isFluid
        }),
        children: children
    });
$7cd28456b648eedc$var$PreviewFrame.propTypes = {
    isFluid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
const $7cd28456b648eedc$var$FIELD_BOX_STYLE = function anonymous(props) {
    let rules = " ";
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' pt182';
    if (props.isOffset) rules += ' Jnk7VXb182';
    else rules += ' Jy182';
    rules += ' Sh182';
    rules += ' Rh182';
    rules += ' Te182';
    rules += ' Qe182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    rules += ' i7B7Kwc182';
    rules += ' _kb182';
    rules += ' hb182';
    rules += ' mb182';
    rules += ' lb182';
    rules += ' _jf182';
    rules += ' gqlRAZb182';
    return rules;
};
// Fills the subgrid cell it is in, passing its tracks on to its content.
const $7cd28456b648eedc$var$FIELD_BOX_SUBGRID_STYLE = function anonymous(props) {
    let rules = " ";
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    rules += ' pt182';
    if (props.isOffset) rules += ' Jnk7VXb182';
    else rules += ' Jy182';
    rules += ' Sh182';
    rules += ' Rh182';
    rules += ' Te182';
    rules += ' Qe182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    rules += ' i7B7Kwc182';
    rules += ' _kb182';
    rules += ' hb182';
    rules += ' mb182';
    rules += ' lb182';
    rules += ' _jf182';
    rules += ' gqlRAZb182';
    rules += ' se182';
    rules += ' DfQhdHc182';
    rules += ' DoLwlgod182';
    rules += ' z2mU182';
    rules += ' yzZKy182';
    return rules;
};
/**
 * The box campaign fields are shown in — a whole `fields` grid, or a single
 * text cell of a `variations` grid. `isSubgrid` makes it a subgrid of the
 * grid cell it fills, for fields laid out on that grid's tracks. `isOffset`
 * moves it below the label of the previews beside it.
 */ const $7cd28456b648eedc$var$CampaignFieldBox = ({ isSubgrid: isSubgrid = false, isOffset: isOffset = false, children: children })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: (isSubgrid ? $7cd28456b648eedc$var$FIELD_BOX_SUBGRID_STYLE : $7cd28456b648eedc$var$FIELD_BOX_STYLE)({
            isOffset: isOffset
        }),
        children: children
    });
$7cd28456b648eedc$var$CampaignFieldBox.propTypes = {
    isSubgrid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isOffset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};
/**
 * An image variation of the campaign structure — linked to a field, or a cell
 * of a variations grid: its preview, flagged like a failed generation when a
 * campaign value or reference image it was generated from has changed since (see
 * `variationDependencies`; `dependencies` is what the structure adds to them).
 * References and regeneration live in the `EditVariationDialog` the preview
 * opens, which checks the same live state.
 *
 * `label` heads the card, `description` captions it below — the latter defaulting to
 * the template variation's own, `null` hiding it — and `isFluid` fills the
 * width of its container rather than a fixed preview width.
 *
 * With `onUploadVariation`, an image dropped onto the card becomes the
 * variation's image — unless `isDropDisabled`, when the card is no drop zone
 * and the idle one offers to upload an image instead. A variation in
 * `idleKeys` was never generated: instead of its progress, it offers to
 * generate it (`onGenerateVariation`).
 */ const $7cd28456b648eedc$var$CampaignFieldVariation = ({ dependencies: dependencies, label: label, description: description, isFluid: isFluid = false, variation: variation, selectedCampaign: selectedCampaign, video: video, templateData: templateData, generatingKeys: generatingKeys, idleKeys: idleKeys, isLoading: isLoading, isGenerateDisabled: isGenerateDisabled = false, onEditVariation: onEditVariation, onGenerateVariation: onGenerateVariation, onUploadVariation: onUploadVariation, isDropDisabled: isDropDisabled = false })=>{
    const { progress: progress, isPromptEdited: isPromptEdited, isBusy: isBusy, regenerate: regenerate, regenerateFromCampaign: regenerateFromCampaign } = (0, $44uR2.useImageVariation)({
        projectId: video.data?.id,
        variationKey: variation.key,
        referenceKey: variation.referenceKey,
        video: video,
        templateData: templateData
    });
    const assets = video.data?.assets;
    const asset = assets?.find((a)=>a.name === variation.key);
    const isGenerating = !!generatingKeys?.has(variation.key) || !!progress;
    const isUploading = !!asset?.isLoading;
    // Never generated, and waiting for the user to generate it.
    const isIdle = !!idleKeys?.has(variation.key) && !asset?.filePath && !isGenerating;
    const { isOutdated: isOutdated, action: outdatedAction } = (0, $3aLXY.getVariationOutdatedState)({
        variation: variation,
        dependencies: dependencies,
        assets: assets,
        selectedCampaign: selectedCampaign,
        video: video,
        isPromptEdited: isPromptEdited,
        isBusy: isGenerating || isUploading
    });
    const { update: update, confirmDialog: confirmDialog } = (0, $gCdzD.useOutdatedUpdate)({
        action: outdatedAction,
        isPromptEdited: isPromptEdited,
        regenerateFromCampaign: regenerateFromCampaign,
        onKeepPrompt: ()=>regenerate()
    });
    const canDrop = !!onUploadVariation && !isDropDisabled;
    const card = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8ZsKk.ImageVariationCard), {
        variation: variation,
        asset: asset,
        assets: assets,
        isLoading: isLoading || isGenerating || isUploading,
        progress: progress ?? (!asset?.filePath && !variation.data?.visualPrompt ? {
            ...(0, $lfyDg.STAGES)[(0, $lb17q.VARIATION_PROGRESS_STAGE).WAITING],
            label: isUploading ? "Uploading" : undefined
        } : undefined),
        isOutdated: isOutdated,
        isIdle: isIdle && !isUploading,
        isInDropZone: canDrop,
        onEdit: isIdle ? undefined : (editedVariation)=>onEditVariation?.({
                ...editedVariation,
                dependencies: dependencies
            }),
        aspectRatio: "4 / 3",
        // Flat inside a drop zone, like `ImageAsset`'s preview.
        styles: canDrop ? " Za182 _nd182" : " Za182",
        children: isIdle && !isUploading && !!onGenerateVariation && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: " _Pa182 Wr182 _lr182 _Ar182 _zr182 sd182 _ta182 eb182 _Ca182 Uj182 qj182 Tf182 Qf182 Sf182 Rf182 _Wa182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 _ta182 Ub182 qb182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                            children: [
                                "Generate ",
                                (variation.label ?? variation.key).toLowerCase()
                            ]
                        }),
                        canDrop && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                            children: "or drag and drop an image"
                        }),
                        !!onUploadVariation && isDropDisabled && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                            children: [
                                "or",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                                    acceptedFileTypes: "image/*",
                                    onSelect: (files)=>onUploadVariation(files, variation.key),
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        variant: "secondary",
                                        isDisabled: isGenerateDisabled,
                                        styles: " Is182",
                                        children: "select a file"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                    variant: "primary",
                    size: "M",
                    isDisabled: isGenerateDisabled,
                    onPress: ()=>onGenerateVariation(variation),
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $689e79a6adf3716c$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Generate"
                        })
                    ]
                })
            ]
        })
    });
    const content = canDrop ? // The same drop zone as `ImageAsset`'s, dashed border included.
    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $KXDAG.DropZone), {
        "aria-label": `Drop an image for ${label ?? variation.label ?? variation.key}`,
        isFilled: !!asset?.filePath,
        // A generation still running would overwrite the dropped image.
        getDropOperation: (types)=>isGenerating || isUploading || isLoading ? "cancel" : (0, $kekDO.getImageDragOperation)(types),
        onDrop: (event)=>onUploadVariation(event.items, variation.key),
        styles: " Za182",
        UNSAFE_style: (0, $kekDO.IMAGE_DROP_ZONE_STYLE),
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: " Za182",
            children: card
        })
    }) : card;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)($7cd28456b648eedc$var$PreviewFrame, {
        isFluid: isFluid,
        children: [
            !!label && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: label,
                value: ""
            }),
            content,
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $g42KE.ThumbnailCaption), {
                description: (0, $g42KE.resolveCaptionText)(description, variation.description),
                actions: !!outdatedAction && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                    size: "XS",
                    isDisabled: isBusy || isLoading,
                    onPress: update,
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Update"
                        })
                    ]
                })
            }),
            confirmDialog
        ]
    });
};
$7cd28456b648eedc$var$CampaignFieldVariation.propTypes = {
    dependencies: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        keys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Map)
    }),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isFluid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    variation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    video: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    generatingKeys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Set),
    idleKeys: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).instanceOf(Set),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    isGenerateDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onEditVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onGenerateVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onUploadVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    isDropDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
/**
 * Catches every outdated variation of a grid up at once (`updates`, each its
 * `key`, `action` and whether its prompt `isPromptEdited`) through `onUpdate`
 * — asking first before overwriting prompts the user wrote.
 */ const $7cd28456b648eedc$var$UpdateOutdatedButton = ({ updates: updates, isDisabled: isDisabled = false, onUpdate: onUpdate })=>{
    const edited = updates.filter((u)=>u.action === (0, $7nuM2.OUTDATED_ACTION).PROMPT_AND_IMAGE && u.isPromptEdited);
    const { update: update, confirmDialog: confirmDialog } = (0, $gCdzD.useOutdatedUpdate)({
        action: (0, $7nuM2.OUTDATED_ACTION).PROMPT_AND_IMAGE,
        isPromptEdited: edited.length > 0,
        editedCount: edited.length,
        // Each as its own action asks.
        regenerateFromCampaign: ()=>onUpdate(updates),
        // The edited prompts kept: only their images are generated again.
        onKeepPrompt: ()=>onUpdate(updates.map((u)=>edited.includes(u) ? {
                    ...u,
                    action: (0, $7nuM2.OUTDATED_ACTION).IMAGE
                } : u))
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                size: "XS",
                isDisabled: isDisabled,
                onPress: update,
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "Update all"
                    })
                ]
            }),
            confirmDialog
        ]
    });
};
$7cd28456b648eedc$var$UpdateOutdatedButton.propTypes = {
    updates: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        action: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        isPromptEdited: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
    })).isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};
/**
 * The reference image(s) a campaign field or variations grid cell points at
 * (`referenceKey`), badged as references. A reference that does not exist yet
 * shows its loading state; opening one shows it in the `EditVariationDialog`.
 */ const $7cd28456b648eedc$var$CampaignFieldReference = ({ referenceKey: referenceKey, label: label, description: description, isFluid: isFluid = false, video: video, templateData: templateData, imageVariations: imageVariations, isLoading: isLoading, onEditVariation: onEditVariation, onUploadAsset: onUploadAsset })=>{
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const progressByKey = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.imageVariationProgress);
    const assets = (0, $6AUdR.resolveReferenceAssets)(video.data?.assets, {
        referenceKey: referenceKey
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)($7cd28456b648eedc$var$PreviewFrame, {
        isFluid: isFluid,
        children: [
            !!label && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: label,
                value: ""
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8ZsKk.ReferenceImages), {
                assets: assets,
                urlByPath: imageVariations?.referenceUrlByPath,
                isLoading: isLoading,
                progressByKey: progressByKey,
                skipImageLabeling: imageVariations?.skipImageLabeling,
                isLabeled: imageVariations?.labeling?.isLabeled,
                templateData: templateData,
                colorScheme: colorScheme,
                aspectRatio: "4 / 3",
                onUpload: onUploadAsset,
                onEdit: (asset)=>onEditVariation?.({
                        key: asset?.name,
                        referenceKey: asset?.name,
                        isReferenceAsset: true,
                        type: "original",
                        data: {
                            ...asset?.labeling
                        }
                    })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $g42KE.ThumbnailCaption), {
                description: description
            })
        ]
    });
};
$7cd28456b648eedc$var$CampaignFieldReference.propTypes = {
    referenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    ]).isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isFluid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    video: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    imageVariations: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onEditVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onUploadAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
/**
 * The link a campaign field or variations grid cell shows (`link`, see
 * `getCellLink`), as a `Link` or — `linkType: "button"` — a `LinkButton`, or
 * — `linkType: "embed"` — the page itself in a sandboxed frame, with a link to
 * open it on its own for the sites that refuse to be embedded. Captioned like
 * the other items.
 */ const $7cd28456b648eedc$var$CampaignFieldLink = ({ link: link, label: label, description: description, isFluid: isFluid = false })=>{
    const Component = link.type === "button" ? (0, $34HUQ.LinkButton) : (0, $3YPmU.Link);
    const isEmbed = link.type === "embed";
    return /*#__PURE__*/ (0, $dx4lB.jsxs)($7cd28456b648eedc$var$PreviewFrame, {
        isFluid: isFluid,
        children: [
            !!label && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: label,
                value: ""
            }),
            isEmbed && /*#__PURE__*/ (0, $dx4lB.jsx)("iframe", {
                src: link.href,
                title: link.label,
                sandbox: link.sandbox,
                referrerPolicy: "no-referrer",
                loading: "lazy",
                className: " sb182 Za182 _kb182 hb182 mb182 lb182 _jf182 i7B7Kwc182 oc182 nc182 kc182 jc182 gqlRAZb182",
                style: {
                    aspectRatio: link.aspectRatio
                }
            }),
            !isEmbed && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " sd182 ed182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)(Component, {
                    variant: "secondary",
                    isStandalone: true,
                    href: link.href,
                    target: link.target,
                    rel: link.rel,
                    children: link.label
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $g42KE.ThumbnailCaption), {
                description: description
            })
        ]
    });
};
$7cd28456b648eedc$var$CampaignFieldLink.propTypes = {
    link: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        href: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        target: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        rel: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        sandbox: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
    }).isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isFluid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
/**
 * The template asset a campaign field or variations grid cell points at
 * (`assetName`), filled right there as in `TemplateAssets` — without its
 * `context`. An image is framed like the variation cards; a color is the usual
 * swatch. Both are captioned like the variation cards by their `label` and
 * `description` (the asset's own by default, `null` hiding them).
 */ const $7cd28456b648eedc$var$CampaignFieldAsset = ({ asset: asset, selectedAsset: selectedAsset, label: label, description: description, isFluid: isFluid = false, scope: scope, colors: colors, onUploadAsset: onUploadAsset, onDeleteAsset: onDeleteAsset, onColorChange: onColorChange })=>asset.type === "color" ? // The label heads the frame and the caption spans it, as a variation
    // card's does; the swatch keeps its own size.
    /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$PreviewFrame, {
        isFluid: isFluid,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateColorAsset), {
            asset: asset,
            selectedAsset: selectedAsset,
            label: label,
            description: description,
            scope: scope,
            colors: colors,
            onChange: onColorChange,
            isCaptioned: true
        })
    }) : /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$PreviewFrame, {
        isFluid: isFluid,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateImageAsset), {
            // The merged asset, as `TemplateAssets` renders its images.
            asset: selectedAsset ?? asset,
            selectedAsset: selectedAsset,
            label: label,
            description: description,
            scope: scope,
            onDrop: onUploadAsset,
            onDelete: onDeleteAsset,
            aspectRatio: "4 / 3",
            isFluid: true,
            isCaptioned: true
        })
    });
$7cd28456b648eedc$var$CampaignFieldAsset.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    selectedAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isFluid: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    scope: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    onUploadAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onDeleteAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onColorChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
const $7cd28456b648eedc$export$2970d560d3520dd5 = ({ campaignStructure: campaignStructure = [], selectedCampaign: selectedCampaign = {}, selectedPersona: selectedPersona = {}, canEditCampaign: canEditCampaign = true, video: video, templateData: templateData, imageVariations: imageVariations, colors: colors, isGenerateDisabled: isGenerateDisabled = false, onEditVariation: onEditVariation, onGenerateVariation: onGenerateVariation, onUploadVariation: onUploadVariation, onUploadAsset: onUploadAsset, onDeleteAsset: onDeleteAsset, onColorChange: onColorChange, renderVariation: renderVariation, renderAsset: renderAsset, styles: styles })=>{
    const groups = imageVariations?.groups ?? [];
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    // Which variations are being generated, so they are not outdated meanwhile.
    const progressByKey = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.imageVariationProgress);
    // Dev only: regenerates the images of `keys`, even those that have one —
    // asking for the ones a manual pipeline is still waiting on, too.
    const regenerateVariations = (keys)=>{
        imageVariations?.generate?.(keys);
        imageVariations?.run?.({
            force: true,
            keys: keys
        });
    };
    // What the structure adds to its variations' dependencies, by key.
    const structureDependencies = (0, $eF4cA.useMemo)(()=>(0, $7nuM2.getStructureDependencies)(campaignStructure), [
        campaignStructure
    ]);
    const extendedAssets = (0, $eF4cA.useMemo)(()=>(0, $l1gUk.getExtendedTemplateAssets)(templateData?.assets, video.data?.assets), [
        templateData?.assets,
        video.data?.assets
    ]);
    // What the assets' use-case `condition`s are evaluated with.
    const scope = (0, $eF4cA.useMemo)(()=>({
            video: video,
            template: {
                data: templateData
            },
            selectedCampaign: selectedCampaign
        }), [
        video,
        templateData,
        selectedCampaign
    ]);
    const findAsset = (name)=>{
        const asset = name ? templateData?.assets?.find((a)=>a.name === name) : null;
        if (asset?.type === "image" && !!onUploadAsset || asset?.type === "color" && !!onColorChange) return {
            asset: asset
        };
        return null;
    };
    const findVariation = (key)=>{
        if (!key) return null;
        for (const group of groups){
            const variation = group.variations.find((v)=>v.key === key);
            if (variation) return {
                variation: variation
            };
        }
        return null;
    };
    // What a field or cell shows next to its text: its template asset, its
    // reference image(s), its variation, then its link. Each is left out when it is not
    // there to show — an asset or variation that is not in the template, or a
    // variation gated off by its `condition`.
    // Rows of a variations grid are laid out from these rather than the cells,
    // so each carries its cell's `colSpan` and `rowSpan` for `CampaignFieldRows`.
    const resolvePreviews = (cell, grid)=>!cell ? null : grid.type === (0, $lb17q.GRID_TYPE).VARIATIONS && (0, $lb17q.isTextCell)(cell) ? {
            cell: cell,
            colSpan: cell.colSpan,
            rowSpan: cell.rowSpan,
            isText: true
        } : {
            cell: cell,
            colSpan: cell.colSpan,
            rowSpan: cell.rowSpan,
            referenceKey: (0, $lb17q.getVariationReferenceKeys)(cell).length ? cell.referenceKey : null,
            ...findAsset(cell.assetName),
            ...findVariation(cell.variationKey),
            link: (0, $lb17q.getCellLink)(cell),
            isDropDisabled: (0, $lb17q.isCellDropDisabled)(cell, grid)
        };
    // A `null` cell stays, as an empty column.
    const hasPreviews = (previews)=>!previews || !!previews.isText || !!previews.asset || !!previews.referenceKey || !!previews.variation || !!previews.link;
    // A campaign field, as every grid shows one — a cell that is only a link
    // has no text to show.
    const renderField = (cell)=>{
        const { label: label, value: value, size: size = "L", disabled: disabled = false } = cell;
        return !(0, $lb17q.isTextCell)(cell) && (0, $lb17q.getCellLink)(cell) ? null : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignField), {
            selectedCampaign: selectedCampaign,
            selectedPersona: selectedPersona,
            label: label,
            value: value,
            size: size,
            isDisabled: disabled || !canEditCampaign
        });
    };
    const renderPreviews = ({ asset: asset, referenceKey: referenceKey, variation: variation, link: link, isDropDisabled: isDropDisabled }, { label: label, description: description, isFluid: isFluid } = {})=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
            children: [
                !!asset && (renderAsset ? renderAsset(asset, {
                    label: label,
                    description: description,
                    isFluid: isFluid
                }) : /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldAsset, {
                    asset: asset,
                    selectedAsset: extendedAssets[asset.name],
                    // The cell's caption is the variation's (or reference's) when it
                    // has one.
                    label: variation || referenceKey ? undefined : label,
                    description: variation || referenceKey ? undefined : description,
                    isFluid: isFluid,
                    scope: scope,
                    colors: colors,
                    onUploadAsset: onUploadAsset,
                    onDeleteAsset: onDeleteAsset,
                    onColorChange: onColorChange
                })),
                !!referenceKey && /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldReference, {
                    referenceKey: referenceKey,
                    label: variation ? undefined : label,
                    description: variation ? undefined : description,
                    isFluid: isFluid,
                    video: video,
                    templateData: templateData,
                    imageVariations: imageVariations,
                    isLoading: video.isLoading,
                    onEditVariation: onEditVariation,
                    onUploadAsset: onUploadAsset
                }),
                !!variation && (renderVariation ? renderVariation(variation, {
                    label: label,
                    description: description,
                    isFluid: isFluid
                }) : /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldVariation, {
                    dependencies: structureDependencies.get(variation.key),
                    label: label,
                    description: description,
                    isFluid: isFluid,
                    variation: variation,
                    selectedCampaign: selectedCampaign,
                    video: video,
                    templateData: templateData,
                    generatingKeys: imageVariations?.generatingKeys,
                    idleKeys: imageVariations?.idleKeys,
                    isLoading: video.isLoading,
                    isGenerateDisabled: isGenerateDisabled,
                    onEditVariation: onEditVariation,
                    onGenerateVariation: onGenerateVariation,
                    onUploadVariation: onUploadVariation,
                    isDropDisabled: isDropDisabled
                })),
                !!link && /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldLink, {
                    link: link,
                    // The cell's caption is its image's when it has one.
                    label: asset || referenceKey || variation ? undefined : label,
                    description: asset || referenceKey || variation ? undefined : description,
                    isFluid: isFluid
                })
            ]
        });
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: (0, $5nTep.mergeStyles)(" sd182 _ta182 Ut182 qt182 Za182 LvuBnEc182 IM182 HM182 __Wc182", styles),
        children: campaignStructure.map((group, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 Uj182 qj182 _oa182 Za182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignGroupHeader), {
                        title: group.title,
                        description: group.description
                    }),
                    (0, $lb17q.getGroupGrids)(group).map((grid, gridIdx)=>{
                        if (grid.type === (0, $lb17q.GRID_TYPE).VARIATIONS) {
                            // Cells with nothing to show are left out along with the rows
                            // they empty.
                            const rows = grid.rows.map((row)=>row.map((cell)=>resolvePreviews(cell, grid)).filter(hasPreviews)).filter((row)=>row.some(Boolean))// A text cell sharing its row with other kinds of items lines
                            // up with their previews.
                            .map((row)=>{
                                const hasOtherItems = row.some((cell)=>!!cell && !cell.isText);
                                return row.map((cell)=>cell?.isText ? {
                                        ...cell,
                                        isOffset: hasOtherItems
                                    } : cell);
                            });
                            if (!rows.length) return null;
                            // The grid's variations, for regenerating them all at once.
                            const gridVariations = Array.from(new Map(rows.flat().map((previews)=>previews?.variation).filter(Boolean).map((variation)=>[
                                    variation.key,
                                    variation
                                ])).values());
                            const gridVariationKeys = gridVariations.map((v)=>v.key);
                            // The outdated ones, and what catches each up.
                            const outdatedUpdates = gridVariations.map((variation)=>{
                                const isPromptEdited = !!variation.data?.promptEdited;
                                const { action: action } = (0, $3aLXY.getVariationOutdatedState)({
                                    variation: variation,
                                    dependencies: structureDependencies.get(variation.key),
                                    assets: video.data?.assets,
                                    selectedCampaign: selectedCampaign,
                                    video: video,
                                    isPromptEdited: isPromptEdited,
                                    isBusy: !!imageVariations?.generatingKeys?.has(variation.key) || !!progressByKey?.[variation.key] || !!video.data?.assets?.find((a)=>a.name === variation.key)?.isLoading
                                });
                                return action ? {
                                    key: variation.key,
                                    action: action,
                                    isPromptEdited: isPromptEdited
                                } : null;
                            }).filter(Boolean);
                            return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignGridHeader), {
                                        title: grid.title,
                                        description: grid.description,
                                        previewLinks: (0, $lb17q.getPreviewLinks)(grid.previewLinks, templateData?.previewUrl),
                                        previewPassword: templateData?.previewPassword,
                                        actions: (outdatedUpdates.length > 0 || isDevMode) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                            children: [
                                                outdatedUpdates.length > 0 && !!imageVariations?.updateVariations && /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$UpdateOutdatedButton, {
                                                    updates: outdatedUpdates,
                                                    isDisabled: video.isLoading,
                                                    onUpdate: imageVariations.updateVariations
                                                }),
                                                // Dev mode only — see useIsDevMode.
                                                isDevMode && gridVariationKeys.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                    size: "XS",
                                                    isQuiet: true,
                                                    "aria-label": "Regenerate all images (dev)",
                                                    isDisabled: isGenerateDisabled,
                                                    onPress: ()=>regenerateVariations(gridVariationKeys),
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j7E4C.default), {}),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            children: "Regenerate all"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " _oa182 JC182 GC182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignFieldRows), {
                                            rows: rows,
                                            columns: $7cd28456b648eedc$var$VARIATIONS_GRID_COLUMNS,
                                            rowGap: "variations",
                                            renderField: (previews)=>previews.isText ? /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldBox, {
                                                    isOffset: previews.isOffset,
                                                    children: renderField(previews.cell)
                                                }) : /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " sd182 _ta182 Ul182 ql182",
                                                    children: renderPreviews(previews, {
                                                        isFluid: true,
                                                        label: (0, $g42KE.resolveCaptionText)(previews.cell.label, previews.variation?.label),
                                                        description: previews.cell.description
                                                    })
                                                })
                                        })
                                    })
                                ]
                            }, gridIdx);
                        }
                        // One cell per linked image — asset, reference(s), variation — or
                        // link, field by field.
                        const linked = grid.rows.flat().map((cell)=>resolvePreviews(cell, grid)).filter(Boolean).filter(hasPreviews).flatMap(({ cell: cell, asset: asset, referenceKey: referenceKey, variation: variation, link: link, isDropDisabled: isDropDisabled })=>[
                                ...asset ? [
                                    {
                                        cell: cell,
                                        asset: asset
                                    }
                                ] : [],
                                ...referenceKey ? [
                                    {
                                        cell: cell,
                                        referenceKey: referenceKey
                                    }
                                ] : [],
                                ...variation ? [
                                    {
                                        cell: cell,
                                        variation: variation,
                                        isDropDisabled: isDropDisabled
                                    }
                                ] : [],
                                ...link ? [
                                    {
                                        cell: cell,
                                        link: link
                                    }
                                ] : []
                            ]);
                        const linkedColSpan = Math.min(Math.max(Number.isInteger(grid.linkedColSpan) ? grid.linkedColSpan : 2, 1), $7cd28456b648eedc$var$VARIATIONS_GRID_COLUMNS - 1);
                        const fieldsColSpan = $7cd28456b648eedc$var$VARIATIONS_GRID_COLUMNS - linkedColSpan;
                        // The images beside the fields, `linkedColSpan` to a line — a lone
                        // one filling the line. The fields span all of the lines.
                        const imageLines = [];
                        for(let idx = 0; idx < linked.length; idx += linkedColSpan)imageLines.push(linked.slice(idx, idx + linkedColSpan).map((previews)=>({
                                previews: previews,
                                colSpan: linked.length === 1 ? linkedColSpan : 1
                            })));
                        const fieldsCell = {
                            isFields: true,
                            isSubgrid: true,
                            colSpan: fieldsColSpan,
                            rowSpan: imageLines.length
                        };
                        return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: " sd182 _ta182 Ul182 ql182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignGridHeader), {
                                    title: grid.title,
                                    description: grid.description,
                                    previewLinks: (0, $lb17q.getPreviewLinks)(grid.previewLinks, templateData?.previewUrl),
                                    previewPassword: templateData?.previewPassword
                                }),
                                linked.length > 0 ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignFieldRows), {
                                    rows: imageLines.map((line, lineIdx)=>lineIdx === 0 ? [
                                            fieldsCell,
                                            ...line
                                        ] : line),
                                    columns: $7cd28456b648eedc$var$VARIATIONS_GRID_COLUMNS,
                                    rowGap: "variations",
                                    renderField: (cell)=>cell.isFields ? /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldBox, {
                                            isSubgrid: true,
                                            isOffset: true,
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignFieldRows), {
                                                rows: grid.rows,
                                                columns: fieldsColSpan,
                                                subgrid: true,
                                                renderField: renderField
                                            })
                                        }) : renderPreviews(cell.previews, {
                                            isFluid: true
                                        })
                                }) : /*#__PURE__*/ (0, $dx4lB.jsx)($7cd28456b648eedc$var$CampaignFieldBox, {
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignFieldRows), {
                                        rows: grid.rows,
                                        renderField: renderField
                                    })
                                })
                            ]
                        }, gridIdx);
                    })
                ]
            }, idx))
    });
};
$7cd28456b648eedc$export$2970d560d3520dd5.propTypes = {
    renderVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    renderAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    campaignStructure: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    selectedCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    selectedPersona: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    canEditCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    video: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    imageVariations: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    isGenerateDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onEditVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onGenerateVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onUploadVariation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onUploadAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onDeleteAsset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onColorChange: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



var $lHGo8 = parcelRequire("lHGo8");

var $8ZsKk = parcelRequire("8ZsKk");

var $l1gUk = parcelRequire("l1gUk");

var $lb17q = parcelRequire("lb17q");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $5nTep = parcelRequire("5nTep");
var $fZShI = parcelRequire("fZShI");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $29245059b0dc7172$var$$101e51411aa51192$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M84.97 28.9c-13.458 0-24.924 8.311-30.118 20.107-1.832-.442-3.74-.677-5.702-.677-14.112 0-25.25 11.897-25.25 26.19q.001 1.24.115 2.429C16.285 80.619 11 88.683 11 97.94c0 12.318 9.397 22.628 21.476 23.078q.253.032.514.032h54.63c2.21 0 4-1.79 4-4s-1.79-4-4-4H33.392q-.165-.016-.334-.019C25.431 112.901 19 106.352 19 97.941c0-7.062 4.571-12.85 10.561-14.565 2.027-.58 3.256-2.635 2.808-4.695-.299-1.373-.469-2.756-.469-4.16 0-10.207 7.882-18.19 17.25-18.19 2.305 0 4.496.48 6.514 1.351 1.044.451 2.23.437 3.263-.04s1.813-1.37 2.147-2.458C64.362 44.47 73.903 36.9 84.97 36.9c13.71 0 25.12 11.655 25.12 26.41l-.002.06-.004.075-.001.017c-.004.098-.013.287-.013.488 0 2.118 1.65 3.868 3.763 3.993 4.227.251 8.129 1.786 11.365 4.263 1.754 1.343 4.265 1.01 5.608-.744s1.01-4.265-.744-5.608c-3.505-2.683-7.616-4.585-12.088-5.44C116.562 42.897 102.466 28.9 84.97 28.9m11.02 73.69c0-13.53 10.97-24.5 24.5-24.5s24.5 10.97 24.5 24.5-10.97 24.5-24.5 24.5-24.5-10.97-24.5-24.5m24.5-15.58c-2.21 0-4 1.79-4 4v12.78c0 2.21 1.79 4 4 4s4-1.79 4-4V91.01c0-2.21-1.79-4-4-4m3.83 28.76c.11-.25.19-.52.24-.78.05-.27.08-.54.08-.81 0-1.1-.44-2.16-1.21-2.94-.97-.96-2.4-1.4-3.75-1.13-.26.05-.53.13-.78.24-.25.1-.49.23-.71.38q-.345.225-.63.51c-.78.78-1.22 1.85-1.22 2.94 0 .27.03.54.08.81.05.26.13.53.24.78.1.25.23.49.38.71.15.23.32.44.52.63.19.2.4.37.63.52.22.15.46.28.71.38.25.11.52.19.78.24.27.05.54.08.81.08 1.09 0 2.16-.44 2.94-1.22q.285-.285.51-.63c.15-.22.28-.46.38-.71"
        })
    });
const $29245059b0dc7172$var$$101e51411aa51192$var$ForwardRef = (0, $eF4cA.forwardRef)($29245059b0dc7172$var$$101e51411aa51192$var$SvgComponent);
var $29245059b0dc7172$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($29245059b0dc7172$var$$101e51411aa51192$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $6e00d5c6342862fd$var$$aebb551f4e8d726e$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M50.97 17.7c-8.029 0-14.862 5.03-17.857 12.148-1.17-.312-2.397-.479-3.664-.479-8.236 0-14.76 6.95-14.76 15.33q.001.87.095 1.705c-4.644 2.079-7.835 6.857-7.835 12.365 0 7.284 5.62 13.34 12.767 13.46h34.883c1.105 0 2-.895 2-2s-.895-2-2-2H19.767c-4.806-.089-8.818-4.21-8.818-9.46 0-4.424 2.854-8.06 6.63-9.137 1.02-.291 1.636-1.33 1.4-2.365-.188-.832-.29-1.684-.29-2.568 0-6.339 4.897-11.33 10.76-11.33 1.449 0 2.818.3 4.075.845.522.227 1.116.22 1.633-.018.516-.239.907-.686 1.074-1.23 2.024-6.592 7.9-11.267 14.738-11.267 8.474 0 15.49 7.202 15.49 16.27v.39c0 1.06.826 1.935 1.883 1.997 3.514.206 6.67 1.85 8.954 4.413.734.825 1.999.898 2.823.164.825-.735.898-2 .164-2.824-2.544-2.856-5.978-4.87-9.87-5.536-.687-10.472-9.056-18.874-19.444-18.874m6.629 43.87c0-8.13 6.59-14.72 14.72-14.72s14.72 6.59 14.72 14.72-6.59 14.72-14.72 14.72-14.72-6.59-14.72-14.72m14.72-8.96c-1.1 0-2 .9-2 2v7.68c0 1.1.9 2 2 2s2-.9 2-2v-7.68c0-1.1-.9-2-2-2m1.98 16.74c.06-.13.1-.26.13-.4.02-.14.04-.28.04-.42s-.02-.28-.04-.42c-.03-.14-.07-.27-.13-.4-.05-.13-.12-.26-.19-.38-.08-.11-.17-.22-.27-.32q-.15-.15-.33-.27c-.11-.08-.24-.14-.37-.2-.13-.05-.26-.09-.4-.12q-.42-.075-.84 0c-.14.03-.27.07-.4.12-.13.06-.26.12-.37.2q-.18.12-.33.27c-.1.1-.19.21-.27.32-.08.12-.14.25-.2.38-.05.13-.09.26-.12.4-.04.14-.04.28-.04.42s.01.28.04.42.07.27.12.4c.06.13.12.26.2.37q.12.18.27.33t.33.27c.11.07.24.14.37.19.13.06.26.1.4.13.14.04.28.04.42.04s.28-.01.42-.04.27-.07.4-.13c.13-.05.26-.12.37-.19q.18-.12.33-.27t.27-.33c.07-.11.14-.24.19-.37"
        })
    });
const $6e00d5c6342862fd$var$$aebb551f4e8d726e$var$ForwardRef = (0, $eF4cA.forwardRef)($6e00d5c6342862fd$var$$aebb551f4e8d726e$var$SvgComponent);
var $6e00d5c6342862fd$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($6e00d5c6342862fd$var$$aebb551f4e8d726e$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ef26cc5ba7358e33$var$$c14e05328e4ffc5b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M25.53 8.19c-4.164 0-7.703 2.57-9.317 6.209-.563-.136-1.151-.21-1.753-.21-4.37 0-7.82 3.682-7.82 8.11q0 .376.034.744C4.28 24.183 2.65 26.675 2.65 29.54c0 3.863 2.98 7.087 6.79 7.15H27.2c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25H9.471c-2.345-.044-4.32-2.057-4.32-4.65 0-2.177 1.404-3.957 3.255-4.49.634-.181 1.017-.825.875-1.47-.091-.415-.14-.845-.14-1.28 0-3.152 2.43-5.61 5.32-5.61.7 0 1.382.15 2.007.418.326.14.695.135 1.017-.014.321-.148.565-.427.67-.765 1.022-3.304 3.961-5.64 7.375-5.64 4.23 0 7.75 3.599 7.75 8.15v.2c0 .662.515 1.208 1.175 1.248 1.662.1 3.16.834 4.272 1.997.477.498 1.269.516 1.767.039.5-.477.517-1.269.04-1.768-1.273-1.33-2.931-2.265-4.79-2.62-.441-5.415-4.801-9.746-10.214-9.746m3.41 22.8c0-4.18 3.39-7.57 7.57-7.57s7.57 3.39 7.57 7.57-3.39 7.57-7.57 7.57-7.57-3.39-7.57-7.57m7.57-4.84c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25V27.4c0-.69-.56-1.25-1.25-1.25m1.29 8.95c.04-.09.08-.18.08-.27q.03-.135.03-.27t-.03-.27c-.01-.09-.04-.18-.08-.27-.03-.08-.07-.16-.13-.24-.05-.07-.11-.14-.17-.21-.06-.06-.14-.12-.21-.17-.08-.05-.16-.1-.24-.13-.09-.04-.18-.07-.26-.08-.18-.04-.37-.04-.55 0-.09.01-.18.04-.26.08-.09.03-.17.08-.24.13-.08.05-.15.11-.22.17-.06.07-.12.14-.17.21-.05.08-.1.16-.13.24-.04.09-.06.18-.08.27q-.03.135-.03.27t.03.27c.02.09.04.18.08.27.03.08.08.16.13.24.05.07.11.14.17.21.07.06.14.12.22.17.07.05.15.1.24.13.08.04.17.06.26.08.09.03.18.03.27.03s.19-.01.28-.03l.027-.007c.073-.018.153-.038.233-.074.08-.03.16-.08.24-.13.07-.05.15-.11.21-.17.06-.07.12-.14.17-.21.06-.08.1-.16.13-.24"
        })
    });
const $ef26cc5ba7358e33$var$$c14e05328e4ffc5b$var$ForwardRef = (0, $eF4cA.forwardRef)($ef26cc5ba7358e33$var$$c14e05328e4ffc5b$var$SvgComponent);
var $ef26cc5ba7358e33$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($ef26cc5ba7358e33$var$$c14e05328e4ffc5b$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df20166cf3c1e677$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $29245059b0dc7172$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $ef26cc5ba7358e33$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $6e00d5c6342862fd$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}




var $77tch = parcelRequire("77tch");
const $87bd91c06342e699$export$c24cc55c83d198aa = " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 eb182 JF182 GL182 L2o5UE182 IM182 HM182 __Wc182 _Wa182";
const $87bd91c06342e699$export$ae81d1082cb406fc = " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182 __Ac182 sd182 _ta182 Ug182 qg182 Za182 LhaAsze182 JA182 GA182 IM182 HM182 _Pe182 _lw182";
const $87bd91c06342e699$export$f612d38926f99775 = " _oa182 Za182 Tf182 Qf182 Sf182 Rf182 g_g182 oe182 ne182 ke182 je182 _nLeasBb182";
const $87bd91c06342e699$var$defaultContentStyle = " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Up182 qp182 Za182 Fb182";
const $87bd91c06342e699$export$fd55ce593607084a = ({ children: children, styles: styles })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: styles ?? $87bd91c06342e699$var$defaultContentStyle,
        children: children
    });
const $87bd91c06342e699$var$StepHeader = ({ title: title, subtitle: subtitle, children: children, styles: styles })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: (0, $5nTep.mergeStyles)($87bd91c06342e699$export$c24cc55c83d198aa, styles),
        children: [
            !!title && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-lcY1Ce182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182",
                children: title
            }),
            !!subtitle && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                children: subtitle
            }),
            children
        ]
    });
const $87bd91c06342e699$var$StepLoading = ({ title: title, subtitle: subtitle, icon: icon, ariaLabel: ariaLabel = "Loading" })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: (0, $5nTep.mergeStyles)($87bd91c06342e699$export$c24cc55c83d198aa, " _dc182"),
        children: [
            !!title && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-lcY1Ce182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182",
                children: title
            }),
            !!subtitle && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                children: subtitle
            }),
            !!icon && /*#__PURE__*/ (0, $eF4cA.cloneElement)(icon, {
                styles: " Zq182 Fr182 JC182"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                "aria-label": ariaLabel,
                isIndeterminate: true,
                staticColor: "auto",
                size: "L",
                styles: " _dc182 JG182 GG182"
            })
        ]
    });
const $87bd91c06342e699$var$StepError = ({ title: title, children: children, onRetry: onRetry, retryLabel: retryLabel = "Try again" })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
        size: "L",
        styles: " JL182 GL182 IM182 HM182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $df20166cf3c1e677$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                children: title
            }),
            !!children && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                children: children
            }),
            !!onRetry && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                    onPress: onRetry,
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: retryLabel
                    })
                })
            })
        ]
    });
/**
 * Renders the standard step actions bar (an optional Back button, optional
 * middle content, and an optional primary action) into the shared actions
 * container rendered by VideoWizard.
 *
 * Pass `onBack` to show the icon-only Back button and `onContinue` to show the
 * primary action. `continueLabel`/`continueVariant`/`isContinueDisabled`
 * customize the primary action; `children` renders between the two (e.g. a
 * consent checkbox). A mount effect forces a re-render so the portal attaches
 * even when the ref is still null on the step's first paint.
 */ const $87bd91c06342e699$var$StepActions = ({ onBack: onBack, backLabel: backLabel = "Back", onContinue: onContinue, continueLabel: continueLabel = "Continue", continueVariant: continueVariant, isContinueDisabled: isContinueDisabled = false, children: children })=>{
    const { actionsContainerRef: actionsContainerRef } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const [, setMounted] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(()=>{
        setMounted(true);
    }, []);
    if (!actionsContainerRef?.current) return null;
    return /*#__PURE__*/ (0, $l19Vn.createPortal)(/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
        children: [
            !!onBack && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                "aria-label": backLabel,
                variant: "secondary",
                onPress: onBack,
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8829c44c80cd9620$export$2e2bcd8739ae039), {})
            }),
            children,
            !!onContinue && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                variant: continueVariant,
                isDisabled: isContinueDisabled,
                onPress: onContinue,
                children: continueLabel
            })
        ]
    }), actionsContainerRef.current);
};
/**
 * Portals a footer element into the layout grid container so it can occupy the
 * `footer` grid area regardless of how deeply the step nests its content.
 */ const $87bd91c06342e699$var$StepFooter = ({ children: children })=>{
    const { contentContainerRef: contentContainerRef } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const [, setMounted] = (0, $eF4cA.useState)(false);
    (0, $eF4cA.useEffect)(()=>{
        setMounted(true);
    }, []);
    return contentContainerRef?.current ? /*#__PURE__*/ (0, $l19Vn.createPortal)(children, contentContainerRef.current) : null;
};
$87bd91c06342e699$export$fd55ce593607084a.Header = $87bd91c06342e699$var$StepHeader;
$87bd91c06342e699$export$fd55ce593607084a.Loading = $87bd91c06342e699$var$StepLoading;
$87bd91c06342e699$export$fd55ce593607084a.Error = $87bd91c06342e699$var$StepError;
$87bd91c06342e699$export$fd55ce593607084a.Actions = $87bd91c06342e699$var$StepActions;
$87bd91c06342e699$export$fd55ce593607084a.Footer = $87bd91c06342e699$var$StepFooter;


const $8102291d555c64a3$var$contentStyle = " sd182 _ta182 Up182 qp182 Za182 LvuBnEc182 IM182 HM182 Th182 Qh182 Sh182 Rh182";
const $8102291d555c64a3$var$assetGridStyle = " sd182 _wb182 ed182 _Ca182 Up182 qp182";
const $8102291d555c64a3$export$6af739b05d4b05ff = ({ children: children, isWizard: isWizard = false })=>{
    const { id: id } = (0, $dqZbZ.useParams)();
    const location = (0, $dqZbZ.useLocation)();
    const enabled = (0, $761a0cbe5e797307$export$10e1c22dbeba3cd4)();
    const video = (0, $ikOQe.useVideo)(id, {
        enabled: !!id && enabled
    });
    if (!id || !enabled) return children;
    if (video.isPending) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: "Loading your project"
    });
    if (video.isError) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
        title: "Failed to load project",
        onRetry: video.refetch
    });
    if (!(0, $761a0cbe5e797307$export$cf7813449d38d4ac)(enabled, video.data)) return children;
    if (!isWizard) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Navigate), {
        to: `/projects/new/${id}`,
        replace: true
    });
    const sessionKey = location.state?.wizardDemoSession ?? location.key;
    return /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$export$18001c1d992d9e7b, {
        project: video.data,
        sessionKey: sessionKey
    }, `${id}:${sessionKey}`);
};
const $8102291d555c64a3$var$DemoPicker = ({ demo: demo, field: field, label: label, items: items = [] })=>{
    const savedValue = demo.values[field];
    const options = items.map((item)=>({
            id: String(item.id ?? item.key),
            label: item.label ?? item.name ?? item.id ?? item.key
        }));
    if (savedValue != null && !options.some((item)=>item.id === String(savedValue))) options.push({
        id: String(savedValue),
        label: String(savedValue)
    });
    const available = savedValue != null && savedValue !== "";
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
        label: label,
        value: demo.value(field) == null ? null : String(demo.value(field)),
        onChange: (key)=>key != null && demo.chooseValue(field),
        isDisabled: !available,
        description: available ? "Select an option to reveal the project's saved value." : "No saved value is available in this project.",
        children: options.map((item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                id: item.id,
                textValue: String(item.label),
                children: String(item.label)
            }, item.id))
    });
};
const $8102291d555c64a3$var$DemoTextField = ({ demo: demo, field: field, label: label, isRequired: isRequired = false })=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
        label: label,
        isRequired: isRequired,
        value: demo.value(field) ?? "",
        onChange: (value)=>value && demo.chooseValue(field),
        isDisabled: !demo.values[field],
        description: demo.values[field] ? "Enter a value to reveal the project's saved value." : "No saved value is available in this project."
    });
const $8102291d555c64a3$var$DemoAudio = ({ asset: asset })=>{
    const url = (0, $a8sj2.usePresignURL)(asset.filePath);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                children: asset.label ?? asset.name
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $133e7baa0382ff89$export$832cc5475f11d8b4), {
                url: asset.src ?? url.data?.presignURL,
                isAudioJobScheduled: url.isLoading,
                isEditorEmpty: !asset.src && !url.data?.presignURL
            })
        ]
    });
};
const $8102291d555c64a3$var$DemoVariation = ({ demo: demo, variation: variation, label: label, description: description })=>{
    const available = demo.hasSavedVariation(variation);
    const progress = demo.progressByKey[variation.key];
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " ZoffTu182 La182",
        children: [
            !!label && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: label,
                value: ""
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8ZsKk.ImageVariationCard), {
                variation: variation,
                asset: demo.project.assets.find((asset)=>asset.name === variation.key),
                assets: demo.project.assets,
                progress: progress,
                isLoading: !!progress,
                isIdle: !demo.revealedAssets.has(variation.key) && !progress
            }),
            !!description && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: description
            }),
            !available && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "No saved image is available for this variation."
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                variant: "secondary",
                isDisabled: !available || !!progress,
                onPress: ()=>demo.simulateVariations([
                        variation.key
                    ]),
                children: demo.revealedAssets.has(variation.key) ? "Regenerate" : "Generate"
            })
        ]
    });
};
const $8102291d555c64a3$var$DemoTemplateAsset = ({ demo: demo, template: template, asset: asset, ...caption })=>{
    const saved = demo.savedAsset(asset.name);
    const selected = demo.project.assets.find((item)=>item.name === asset.name);
    const available = !!(saved?.filePath || saved?.src || saved?.color);
    const scope = {
        video: {
            data: demo.project
        },
        template: {
            data: template
        },
        selectedCampaign: demo.saved.campaigns?.find((campaign)=>campaign.id === demo.saved.selectedCampaignIds?.[0])
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " ZoffTu182",
        children: [
            asset.type === "color" && !available ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                label: asset.label ?? asset.name,
                value: ""
            }) : asset.type === "color" ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateColorAsset), {
                asset: asset,
                selectedAsset: selected ?? {
                    name: asset.name
                },
                scope: scope,
                ...caption,
                colors: saved?.color ? [
                    saved.color
                ] : [],
                onChange: ()=>demo.chooseAsset(asset.name)
            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $l1gUk.TemplateImageAsset), {
                asset: asset,
                selectedAsset: selected,
                scope: scope,
                ...caption,
                isDisabled: !available || demo.uploadingKeys.has(asset.name),
                onDrop: (_items, name)=>demo.chooseAsset(name)
            }),
            !available && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "No saved asset is available in this project."
            })
        ]
    });
};
const $8102291d555c64a3$var$DemoBranding = ({ demo: demo, template: template })=>/*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: $8102291d555c64a3$var$assetGridStyle,
        children: (template.assets ?? []).filter((asset)=>[
                "image",
                "color"
            ].includes(asset.type)).map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoTemplateAsset, {
                demo: demo,
                template: template,
                asset: asset
            }, asset.name))
    });
const $8102291d555c64a3$var$DemoCampaign = ({ demo: demo, template: template, campaign: campaign, persona: persona })=>{
    const groups = (0, $eF4cA.useMemo)(()=>{
        const result = new Map();
        for (const variation of demo.variations){
            const id = (0, $lb17q.getVariationReferenceGroupId)(variation);
            if (!result.has(id)) result.set(id, {
                id: id,
                variations: [],
                referenceAssets: (0, $6AUdR.resolveReferenceAssets)(demo.project.assets, variation)
            });
            result.get(id).variations.push(variation);
        }
        return [
            ...result.values()
        ];
    }, [
        demo.variations,
        demo.project.assets
    ]);
    if (!campaign) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
        children: "No saved campaign is available in this project."
    });
    if (demo.step.campaignStructure?.length) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7cd28456b648eedc$export$2970d560d3520dd5), {
        campaignStructure: demo.step.campaignStructure,
        selectedCampaign: campaign,
        selectedPersona: persona,
        canEditCampaign: false,
        video: {
            data: demo.project
        },
        templateData: template,
        imageVariations: {
            groups: groups,
            generate: (keys)=>demo.simulateVariations(keys)
        },
        isGenerateDisabled: !!Object.keys(demo.progressByKey).length || demo.variations.some((variation)=>!demo.hasSavedVariation(variation)),
        onUploadAsset: (_items, name)=>demo.chooseAsset(name),
        onColorChange: (_color, name)=>demo.chooseAsset(name),
        renderVariation: (variation, caption)=>/*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoVariation, {
                demo: demo,
                variation: variation,
                ...caption
            }, variation.key),
        renderAsset: (asset, caption)=>/*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoTemplateAsset, {
                demo: demo,
                template: template,
                asset: asset,
                ...caption
            })
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: $8102291d555c64a3$var$contentStyle,
        children: Object.entries(campaign).filter(([key, value])=>![
                "id",
                "createdAt",
                "updatedAt"
            ].includes(key) && typeof value === "string" && !!value).map(([key])=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $lHGo8.CampaignField), {
                label: key,
                value: key,
                selectedCampaign: campaign,
                selectedPersona: persona,
                isDisabled: true
            }, key))
    });
};
const $8102291d555c64a3$var$DemoStepLoading = ({ demo: demo })=>{
    const { step: step, enterAction: enterAction } = demo;
    const isCampaign = (0, $lb17q.isCampaignVisualsStep)(step) || step.id === (0, $lb17q.WIZARD_STEP).CAMPAIGN;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: enterAction?.pending?.title ?? (isCampaign ? `Preparing your ${step.contentLabel ?? "campaign"}` : step.id === (0, $lb17q.WIZARD_STEP).BRANDING ? "Setting up your project" : step.name),
        subtitle: enterAction?.pending?.subtitle ?? "This may take a few moments, so please keep this tab open.",
        ariaLabel: isCampaign ? "Generating campaign" : "Loading",
        icon: isCampaign ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ab17b54c80fc8a2e$export$2e2bcd8739ae039), {}) : undefined
    });
};
const $8102291d555c64a3$var$DemoStepContent = ({ demo: demo, template: template, campaign: campaign, persona: persona })=>{
    const { step: step, saved: saved } = demo;
    if (step.id === (0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE) return /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
        demo: demo,
        field: "templateId",
        label: "Template",
        items: [
            {
                id: saved.templateId,
                label: template.name
            }
        ]
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS) return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "sfType",
                label: "Account details",
                items: [
                    {
                        id: "accountName",
                        label: "DR Number / Account"
                    },
                    {
                        id: "drNumber",
                        label: "DR Number"
                    },
                    {
                        id: "none",
                        label: "None"
                    }
                ]
            }),
            demo.value("sfType") === "accountName" && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoTextField, {
                demo: demo,
                field: "accountName",
                label: "Account name",
                isRequired: true
            }),
            demo.value("sfType") === "drNumber" && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "drNumber",
                label: "DR Number"
            })
        ]
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS) return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoTextField, {
                demo: demo,
                field: "customerName",
                label: "Brand name",
                isRequired: true
            }),
            !!saved.product && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoTextField, {
                demo: demo,
                field: "product",
                label: "Product"
            }),
            !!saved.hint && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoTextField, {
                demo: demo,
                field: "hint",
                label: "Additional information"
            }),
            !!template.personas?.length && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "personaId",
                label: "Persona",
                items: template.personas
            }),
            !!template.verticals?.length && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "verticalKey",
                label: "Industry",
                items: template.verticals
            }),
            demo.values.include3DDigitalTwin != null && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "include3DDigitalTwin",
                label: "Include 3D digital twin",
                items: [
                    {
                        id: "true",
                        label: "Yes"
                    },
                    {
                        id: "false",
                        label: "No"
                    }
                ]
            })
        ]
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).BRANDING) return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoBranding, {
                demo: demo,
                template: template
            }),
            !!step.campaignStructure?.length && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoCampaign, {
                demo: demo,
                template: template,
                campaign: campaign,
                persona: persona
            })
        ]
    });
    if ((0, $lb17q.isCampaignVisualsStep)(step) || step.id === (0, $lb17q.WIZARD_STEP).CAMPAIGN) return /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoCampaign, {
        demo: demo,
        template: template,
        campaign: campaign,
        persona: persona
    });
    if ((0, $lb17q.isImagesStep)(step)) return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: $8102291d555c64a3$var$assetGridStyle,
        children: demo.variations.map((variation)=>/*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoVariation, {
                demo: demo,
                variation: variation
            }, variation.key))
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).AUDIO) return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "musicPath",
                label: "Music track",
                items: template.musicTracks
            }),
            !!demo.value("musicPath") && /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoAudio, {
                asset: {
                    name: "Music track",
                    filePath: saved.musicPath
                }
            })
        ]
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).VOICEOVER) return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoPicker, {
                demo: demo,
                field: "voiceoverMode",
                label: "Voiceover",
                items: [
                    {
                        id: "original",
                        label: "Original"
                    },
                    {
                        id: "edit",
                        label: "Customize"
                    },
                    {
                        id: "upload",
                        label: "Upload"
                    },
                    {
                        id: "none",
                        label: "None"
                    }
                ]
            }),
            !!demo.value("voiceoverMode") && (saved.assets ?? []).filter((asset)=>asset.type === "audio").map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoAudio, {
                    asset: asset
                }, asset.name))
        ]
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).SCENES) return campaign?.scenes?.length ? campaign.scenes.map((scene, index)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    children: scene.name ?? `Scene ${index + 1}`
                }),
                Object.entries(scene).filter(([key, value])=>key !== "id" && typeof value === "string").map(([key, value])=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                        label: key,
                        value: value
                    }, key))
            ]
        }, scene.id ?? index)) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
        children: "No saved scenes are available in this project."
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).GENERATE_VIDEO) return saved.videoPath ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $063f773168f4b77e$export$b813e5a72f7fef2c), {
                type: "video",
                filePath: saved.videoPath,
                alt: saved.name
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                variant: "secondary",
                onPress: demo.replayStep,
                children: "Regenerate video"
            })
        ]
    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
        children: "No saved video is available in this project."
    });
    if (step.id === (0, $lb17q.WIZARD_STEP).BANNERS) {
        const renditions = saved.templateAssetsRenditions ?? [];
        return renditions.length ? /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: $8102291d555c64a3$var$assetGridStyle,
            children: renditions.map((rendition, index)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                            label: "Saved banner document",
                            value: rendition.documentId ?? ""
                        }),
                        rendition.renditionUrl ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $063f773168f4b77e$export$b813e5a72f7fef2c), {
                            src: rendition.renditionUrl,
                            alt: `Banner ${index + 1}`
                        }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "No saved banner preview is available. Live export is disabled in demo mode."
                        })
                    ]
                }, rendition.documentId ?? index))
        }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
            children: "No saved banners are available in this project."
        });
    }
    if (step.id === (0, $lb17q.WIZARD_STEP).FIGMA_HANDOFF) return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "Creating or duplicating Figma files is disabled in demo mode."
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: $8102291d555c64a3$var$assetGridStyle,
                children: (saved.assets ?? []).filter((asset)=>asset.type === "image" && asset.filePath).map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " ZoffTu182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                label: asset.name,
                                value: ""
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $063f773168f4b77e$export$b813e5a72f7fef2c), {
                                filePath: asset.filePath,
                                alt: asset.name
                            })
                        ]
                    }, asset.name))
            })
        ]
    });
    if (step.viewless) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
        children: "No saved preview is available for this step."
    });
};
const $8102291d555c64a3$var$DemoReplay = ({ project: project, template: template, sessionKey: sessionKey })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const demo = (0, $761a0cbe5e797307$export$e412b255a584263e)(project, template);
    const { step: step, index: index, steps: steps, goTo: goTo, isStepPending: isStepPending } = demo;
    const campaign = demo.saved.campaigns?.find((item)=>item.id === demo.saved.selectedCampaignIds?.[0]);
    const persona = template.personas?.find((item)=>item.id === demo.saved.personaId);
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Projects",
            href: "/projects"
        },
        {
            label: `${project.name ?? "Project"} - Demo mode`
        }
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (step) navigate(`/projects/new/${project.id}/${step.id}`, {
            replace: true,
            state: {
                wizardDemoSession: sessionKey
            }
        });
    }, [
        navigate,
        project.id,
        step,
        sessionKey
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (step?.viewless && !isStepPending && index + 1 < steps.length) goTo(index + 1);
    }, [
        step,
        isStepPending,
        goTo,
        index,
        steps.length
    ]);
    if (!step) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
        title: "This template has no demo steps"
    });
    const requiredAssets = (template.assets ?? []).filter((asset)=>[
            "image",
            "color"
        ].includes(asset.type) && !asset.isOptional);
    let canContinue = !demo.isStepPending && !Object.keys(demo.progressByKey).length;
    if (step.id === (0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE) canContinue &&= !!demo.value("templateId");
    else if (step.id === (0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS) canContinue &&= !!demo.value("sfType") && (demo.value("sfType") === "none" || !!demo.value(demo.value("sfType")));
    else if (step.id === (0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS) canContinue &&= !!demo.value("customerName") && (!demo.values.personaId || !!demo.value("personaId")) && (!demo.values.verticalKey || !!demo.value("verticalKey")) && (demo.values.include3DDigitalTwin == null || demo.value("include3DDigitalTwin") != null);
    else if (step.id === (0, $lb17q.WIZARD_STEP).BRANDING) canContinue &&= requiredAssets.every((asset)=>demo.revealedAssets.has(asset.name)) && !demo.uploadingKeys.size;
    else if (step.id === (0, $lb17q.WIZARD_STEP).AUDIO) canContinue &&= !demo.values.musicPath || !!demo.value("musicPath");
    else if (step.id === (0, $lb17q.WIZARD_STEP).VOICEOVER) canContinue &&= !!demo.value("voiceoverMode");
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: $8102291d555c64a3$var$contentStyle,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: `${project.name ?? "Project"} | Demo mode | BeStory`
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1f7d28ef023026e3$export$edb76fdb8665f52), {
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                    children: [
                        project.name ?? "Project",
                        " - Demo mode"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "Demo mode: actions reveal saved content. This project will not be changed."
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                label: "Wizard step",
                value: step.id,
                onChange: (key)=>{
                    const next = steps.findIndex((entry)=>entry.id === key);
                    if (next <= demo.furthestStep) demo.goTo(next);
                },
                children: steps.filter((entry)=>!entry.viewless).map((entry)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                        id: entry.id,
                        isDisabled: steps.indexOf(entry) > demo.furthestStep,
                        children: entry.name
                    }, entry.id))
            }),
            demo.isStepPending ? /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoStepLoading, {
                demo: demo
            }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: $8102291d555c64a3$var$contentStyle,
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: step.name,
                        subtitle: step.description
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoStepContent, {
                        demo: demo,
                        template: template,
                        campaign: campaign,
                        persona: persona
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        variant: "secondary",
                        isDisabled: index === 0,
                        onPress: ()=>{
                            let previous = index - 1;
                            while(previous >= 0 && steps[previous].viewless)previous -= 1;
                            demo.goTo(previous);
                        },
                        children: "Back"
                    }),
                    index + 1 < steps.length ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        isDisabled: !canContinue,
                        onPress: ()=>demo.goTo(index + 1),
                        children: (0, $lb17q.getContinueLabel)(steps[index + 1])
                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        isDisabled: !canContinue,
                        onPress: ()=>navigate("/projects"),
                        children: "Back to projects"
                    })
                ]
            })
        ]
    });
};
const $8102291d555c64a3$export$18001c1d992d9e7b = ({ project: project, sessionKey: sessionKey })=>{
    const template = (0, $ikOQe.useVideoTemplate)(project.templateId);
    if (template.isPending) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: "Loading your template"
    });
    if (template.isError) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
        title: "Failed to load template",
        onRetry: template.refetch
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)($8102291d555c64a3$var$DemoReplay, {
        project: project,
        template: template.data,
        sessionKey: sessionKey
    });
};
$8102291d555c64a3$export$18001c1d992d9e7b.propTypes = {
    project: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    sessionKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
};
$8102291d555c64a3$export$6af739b05d4b05ff.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    isWizard: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
$8102291d555c64a3$var$DemoPicker.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    field: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array
};
$8102291d555c64a3$var$DemoTextField.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    field: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    isRequired: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
};
$8102291d555c64a3$var$DemoAudio.propTypes = {
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired
};
$8102291d555c64a3$var$DemoVariation.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    variation: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
$8102291d555c64a3$var$DemoTemplateAsset.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    template: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    asset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired
};
$8102291d555c64a3$var$DemoBranding.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    template: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired
};
$8102291d555c64a3$var$DemoCampaign.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    template: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    campaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    persona: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object
};
$8102291d555c64a3$var$DemoStepLoading.propTypes = {
    demo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired
};
$8102291d555c64a3$var$DemoStepContent.propTypes = $8102291d555c64a3$var$DemoCampaign.propTypes;
$8102291d555c64a3$var$DemoReplay.propTypes = {
    project: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    template: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    sessionKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
};


const $6161d14592537c19$export$a64da8fc8b9c1af9 = ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $8102291d555c64a3$export$6af739b05d4b05ff), {
        children: /*#__PURE__*/ (0, $dx4lB.jsx)($6161d14592537c19$var$EditableProjectView, {})
    });
const $6161d14592537c19$var$EditableProjectView = ()=>{
    const params = (0, $dqZbZ.useParams)();
    const navigate = (0, $dqZbZ.useNavigate)();
    const video = (0, $ikOQe.useVideo)(params?.id);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Projects",
            href: "/projects"
        },
        {
            label: video.data?.name ?? "Project",
            href: `/projects/${params?.id}`,
            isLoading: video.isLoading || !video.data?.name
        }
    ]);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(video.data?.id);
    const updateAssets = (0, $CGZx1.useUpdateAssets)(video.data?.id);
    const videoUrlQuery = (0, $a8sj2.usePresignURL)(video.data?.videoPath);
    const user = (0, $fL0wx.useUserProfile)();
    const isVideoEditor = (0, $lRNYL.useHasRole)("video-editor");
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    const feedback = (0, $8fa124be32935d0d$export$cb6c49bc277cb055)();
    const isAuthorized = (0, $eF4cA.useMemo)(()=>{
        if (!user?.email || !video.isSuccess) return false;
        const authors = Array.from(new Set([
            video.data?.createdBy,
            video.data?.updatedBy,
            ...video.data?.sharedWith ?? []
        ])).filter(Boolean);
        return authors.includes(user.email) || isVideoEditor;
    }, [
        user?.email,
        isVideoEditor,
        video.isSuccess,
        video.data?.createdBy,
        video.data?.updatedBy,
        video.data?.sharedWith
    ]);
    const selectedCampaign = (0, $eF4cA.useMemo)(()=>video.data?.campaigns?.find((campaign)=>campaign.id === video.data?.selectedCampaignIds?.[0]), [
        video.data?.campaigns,
        video.data?.selectedCampaignIds
    ]);
    const { assets: assets, isLoading: isAssetsLoading } = (0, $ikOQe.useVideoAssets)(params?.id);
    const expressDocumentId = video.data?.templateAssetsRenditions?.[0]?.documentId;
    const [shouldEditTitle, setShouldEditTitle] = (0, $eF4cA.useState)(false);
    const handleTitleChange = (0, $eF4cA.useCallback)((value)=>{
        const title = value.trim();
        if (!title || title === video.data?.name) return;
        updateVideo.mutate({
            name: title
        });
    }, [
        updateVideo.mutate,
        video.data?.name
    ]);
    const downloadAsset = (0, $ikOQe.useDownloadAsset)();
    const downloadAllAssets = (0, $ikOQe.useDownloadAllAssets)(params?.id);
    (0, $eF4cA.useEffect)(()=>{
        if (video.isError) navigate("/projects");
    }, [
        video.isError,
        navigate
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: `${video.data?.name ?? "Project"} | BeStory`
            }),
            video.data?.templateType === "modular" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1f7d28ef023026e3$export$223875819fd7cf93), {
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                    variant: "primary",
                    onPress: feedback.open,
                    styles: " IM182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88da991c28d9e725$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Share feedback"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5e54d0a0882391be$export$ce3b880e766d1e30), {
                video: video.data,
                isOpen: feedback.isOpen,
                onClose: feedback.close,
                currentStep: "video-view",
                method: feedback.method
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " LvuBnEc182 IM182 HM182 sd182 _ta182 eb182 _Cg182 Us182 qs182",
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $91SAk.Skeleton), {
                    isLoading: video.isLoading,
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' se182';
                                rules += ' Lq63t7c182';
                                if (props.isDetailsVisible) rules += ' CdIw5N182';
                                else rules += ' C2Q5gFc182';
                                rules += ' Eje865182';
                                rules += ' qr182';
                                rules += ' Up182';
                                return rules;
                            }({
                                isDetailsVisible: video.data?.templateType === "express"
                            }),
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Header), {
                                    styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 sd182 _ta182 eb182 Ue182 qe182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                            level: 1,
                                            styles: " sd182 eb182 Ug182 qg182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182 Iy182 Hy182",
                                            children: shouldEditTitle ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                autoFocus: true,
                                                defaultValue: video.data?.name,
                                                onBlur: (e)=>{
                                                    setShouldEditTitle(false);
                                                    handleTitleChange(e.target.value);
                                                },
                                                onKeyDown: (e)=>{
                                                    if (e.key === "Enter") {
                                                        setShouldEditTitle(false);
                                                        handleTitleChange(e.target.value);
                                                    } else if (e.key === "Escape") setShouldEditTitle(false);
                                                },
                                                styles: " ZwHzgQe182 Gr182"
                                            }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        styles: " Js182 Gs182",
                                                        children: video.data?.name
                                                    }),
                                                    isAuthorized && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                        "aria-label": "Edit title",
                                                        size: "S",
                                                        isQuiet: true,
                                                        isDisabled: video.isLoading,
                                                        onPress: ()=>setShouldEditTitle(!shouldEditTitle),
                                                        styles: " Hg182",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: new Date(Date.parse(video.data?.updatedAt)).toLocaleString("en-US", {
                                                year: "numeric",
                                                month: "numeric",
                                                day: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit"
                                            })
                                        }),
                                        isDevMode && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $waxwa.ActionButtonGroup), {
                                            children: video.data?.assets.some((asset)=>asset.name === "VO1") && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                size: "S",
                                                isQuiet: true,
                                                onPress: ()=>{
                                                    updateAssets.mutate({
                                                        toRemove: [
                                                            {
                                                                name: "VO1"
                                                            },
                                                            {
                                                                name: "VO1-V1"
                                                            }
                                                        ]
                                                    }, {
                                                        onSuccess: ()=>{
                                                            updateVideo.mutate({
                                                                videoPath: null
                                                            }, {
                                                                onSuccess: ()=>{
                                                                    navigate(`/projects/new/${video.data?.id}`);
                                                                }
                                                            });
                                                        }
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j7E4C.default), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Edit Voiceover"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    className: " ziAwYs182 yiAwYs182 BiAwYs182 AiAwYs182",
                                    children: videoUrlQuery.isSuccess ? /*#__PURE__*/ (0, $dx4lB.jsx)("video", {
                                        src: videoUrlQuery.data?.presignURL,
                                        controls: true,
                                        className: " sb182 Zq63t7c182 La182 Fb182 fcJcitc182 ob182 nb182 kb182 jb182 gF182"
                                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                                        isLoading: true,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                            alt: "",
                                            styles: " Za182 Fb182 fcJcitc182 ob182 nb182 kb182 jb182"
                                        })
                                    })
                                }),
                                video.data?.templateType === "express" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                    styles: " zpeBXk182 ypeBXk182 BpeBXk182 ApeBXk182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                        styles: " sd182 _ta182 Ul182 ql182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Customer name"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: video.data?.customer?.name
                                                    })
                                                ]
                                            }),
                                            !!video.data?.drNumber && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "DR number"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: video.data?.drNumber
                                                    })
                                                ]
                                            }),
                                            !!video.data?.accountName && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Account name"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: video.data?.accountName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Industry"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: video.data?.customer?.industry
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Website"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: video.data?.customer?.websiteURL ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                            href: video.data.customer.websiteURL,
                                                            target: "_blank",
                                                            staticColor: "auto",
                                                            UNSAFE_className: " xb182 _xa182 __Zc182 -nTSCV-cB9Fab182",
                                                            children: video.data.customer.websiteURL
                                                        }) : "\u2013"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Brand center"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: video.data?.customer?.brandCenterURL ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                            href: video.data.customer.brandCenterURL,
                                                            target: "_blank",
                                                            staticColor: "auto",
                                                            UNSAFE_className: " xb182 _xa182 __Zc182 -nTSCV-cB9Fab182",
                                                            children: video.data.customer.brandCenterURL
                                                        }) : "\u2013"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Campaign focus"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: selectedCampaign?.tagline ?? "\u2013"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Campaign website"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: selectedCampaign?.landingPageURL ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                            href: selectedCampaign?.landingPageURL,
                                                            target: "_blank",
                                                            staticColor: "auto",
                                                            UNSAFE_className: " xb182 _xa182 __Zc182 -nTSCV-cB9Fab182",
                                                            children: selectedCampaign?.landingPageURL
                                                        }) : "\u2013"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                    size: "L",
                                    styles: " zkG38H182 ykG38H182 BkG38H182 AkG38H182 IM182 HM182",
                                    children: [
                                        isAuthorized && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                    variant: "secondary",
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Edit"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d5b82dd9a55d3518$export$b8b2cd85c234bed), {
                                                    videoId: video.data?.id
                                                })
                                            ]
                                        }),
                                        video.data?.templateType === "express" && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                            href: `https://new.express.adobe.com/id/${video.data?.expressId}?category=none`,
                                            target: "_blank",
                                            isDisabled: video.isLoading || video.data?.templateType !== "express",
                                            variant: "secondary",
                                            fillStyle: "outline",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Open in Express"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                            href: videoUrlQuery.data?.presignURL || null,
                                            download: true,
                                            isDisabled: videoUrlQuery.isLoading,
                                            variant: "accent",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Download video"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        video.data?.id && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5e54d0a0882391be$export$ce3b880e766d1e30), {
                            variant: "inline",
                            title: "How did your video turn out?",
                            video: video.data,
                            currentStep: "video-view",
                            method: "inline",
                            styles: " Za182 L6Neosc182"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                            size: "S",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                    children: "Do you need help with your project?"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                    size: "S",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                                        variant: "secondary",
                                        href: "https://adobe.ly/ExperienceDesign-Request",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Request design assist"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $a6bf03053d5f3ea4$export$74a362b31437ec83), {
                            size: "XL",
                            isQuiet: true,
                            styles: " Za182 GK182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $a6bf03053d5f3ea4$export$1e037ddd32f5b8ac), {
                                    styles: " Za182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$7843c6a5b3e340a2), {
                                            children: "Assets"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                            className: " Zj182"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                            styles: " IM182",
                                            children: [
                                                !!template.data?.assetsTemplateId && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                                    href: expressDocumentId ? `https://new.express.adobe.com/id/${expressDocumentId}?category=none` : undefined,
                                                    target: "_blank",
                                                    variant: "secondary",
                                                    fillStyle: "outline",
                                                    isDisabled: !expressDocumentId,
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            children: "Open in Express"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                                    variant: "secondary",
                                                    onPress: ()=>downloadAllAssets.mutate(),
                                                    isPending: downloadAllAssets.isPending,
                                                    isDisabled: isAssetsLoading,
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            children: "Download all"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$feabaa331e1d464c), {
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                                        layout: "waterfall",
                                        variant: "quiet",
                                        size: "M",
                                        selectionMode: "none",
                                        "aria-label": "Assets variations",
                                        styles: " Fb182",
                                        children: assets.map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                                textValue: asset.name,
                                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $063f773168f4b77e$export$b813e5a72f7fef2c), {
                                                            src: asset.src,
                                                            filePath: asset.filePath,
                                                            type: asset?.type,
                                                            color: asset?.color ?? asset?.value,
                                                            width: asset?.size?.width ?? 1,
                                                            height: asset?.size?.height ?? 1,
                                                            alt: asset.name
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iKDEm.HoverState), {
                                                            showOutline: false,
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                        "aria-label": `Download ${asset.name}`,
                                                                        size: "M",
                                                                        // staticColor="auto"
                                                                        onPress: ()=>downloadAsset.mutate(asset),
                                                                        isPending: downloadAsset.isPending,
                                                                        styles: " _Pa182 WJ182 _zI182",
                                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.Tooltip), {
                                                                        children: [
                                                                            "Download ",
                                                                            asset.name
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, asset.name))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $k7O9T = parcelRequire("k7O9T");

var $dqZbZ = parcelRequire("dqZbZ");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $5nTep = parcelRequire("5nTep");
var $fZShI = parcelRequire("fZShI");
var $208Op = parcelRequire("208Op");


var $kQT4E = parcelRequire("kQT4E");




var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $k7O9T = parcelRequire("k7O9T");
var $7ClmI = parcelRequire("7ClmI");

var $4W5AG = parcelRequire("4W5AG");
var $208Op = parcelRequire("208Op");

var $cxTG4 = parcelRequire("cxTG4");

var $lTVIu = parcelRequire("lTVIu");

var $dm5H1 = parcelRequire("dm5H1");

var $i93Vd = parcelRequire("i93Vd");

var $208Op = parcelRequire("208Op");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $cg9Gh = parcelRequire("cg9Gh");

var $eF4cA = parcelRequire("eF4cA");

var $YxOvP = parcelRequire("YxOvP");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$SelectBoxContext = (0, $eF4cA.createContext)({
    orientation: 'vertical'
});
const $b0a461d8d3a700b8$export$cad91f7528e8dc08 = (0, $eF4cA.createContext)(null);
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$labelOnly = ':has([slot=label]):not(:has([slot=description]))';
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$noIllustration = ':not(:has([slot=illustration]))';
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$selectBoxStyles = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' se182';
    rules += ' __yM8Mfn182';
    if (!position) rules += ' _Pc182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.isDisabled) rules += ' pp182';
    rules += ' ri182';
    rules += ' _oa182';
    rules += ' _Nc182';
    rules += ' Pc182';
    if (props.orientation === "horizontal") {
        if (!width) rules += ' ZAK24ue182';
    } else if (!width) rules += ' Z75oWv182';
    if (props.orientation === "horizontal") rules += ' Fd182';
    else rules += ' F75oWv182';
    if (props.orientation === "horizontal") {
        if (!minWidth) rules += ' NBzUiud182';
    } else if (!minWidth) rules += ' NQGV3L182';
    if (props.orientation === "horizontal") rules += ' -_5yLdZ-ZILqIYb182';
    else rules += ' -_5yLdZ-Z75oWv182';
    if (!maxWidth) rules += ' Lqz07Zc182';
    if (props.orientation === "horizontal") rules += ' MKniM182';
    else rules += ' MQGV3L182';
    if (props.orientation === "horizontal") rules += ' KDvO7ld182';
    else rules += ' K75oWv182';
    if (props.orientation === "horizontal") rules += ' Tf182';
    else rules += ' Th182';
    if (props.orientation === "horizontal") rules += ' Qf182';
    else rules += ' Qh182';
    if (props.orientation === "horizontal") rules += ' Sk182';
    if (props.orientation === "horizontal") rules += ' Rh182';
    if (props.orientation === "horizontal") {
        rules += ' CtXiS9b182';
        rules += ' CbWiMddxbX3ib182';
    } else if (props.orientation === "vertical") rules += ' CfwsTtd182';
    if (props.orientation === "horizontal") {
        rules += ' E5HJqj182';
        rules += ' E1099pdfYMhHd182';
    } else if (props.orientation === "vertical") rules += ' EY7ZLHe182';
    if (props.orientation === "horizontal") rules += ' DJSAqje182';
    if (props.orientation === "vertical") rules += ' _cb182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    rules += ' _jf182';
    if (props.isDisabled) rules += ' iA182';
    else if (props.isSelected) rules += ' in182';
    else rules += ' iA182';
    if (props.isDisabled) rules += ' gH182';
    else rules += ' g_g182';
    if (props.isDisabled) rules += ' _nd182';
    else if (props.isSelected) rules += ' _nLeasBb182';
    else if (props.isHovered) rules += ' _nLeasBb182';
    else rules += ' _n4zCLMe182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    rules += ' Yd182';
    rules += ' Xb182';
    rules += ' _2b182';
    return rules;
};
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$illustrationContainer = function anonymous(props) {
    let rules = " ";
    rules += ' zTZ8xtd182';
    rules += ' yTZ8xtd182';
    rules += ' BTZ8xtd182';
    rules += ' ATZ8xtd182';
    rules += ' _dc182';
    rules += ' __Ab182';
    rules += ' Nl182';
    rules += ' Mk182';
    if (props.isDisabled) rules += ' -_8sjo0b-pp182';
    else {
        if (props.isPressed) rules += ' -_8sjo0b-po182';
        else if (props.isFocusVisible) rules += ' -_8sjo0b-po182';
        else if (props.isHovered) rules += ' -_8sjo0b-po182';
        else rules += ' -_8sjo0b-pt182';
    }
    return rules;
};
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$descriptionText = function anonymous(props) {
    let rules = " ";
    rules += ' z9u7zPc182';
    rules += ' y9u7zPc182';
    rules += ' B9u7zPc182';
    rules += ' A9u7zPc182';
    rules += ' _dc182';
    if (props.orientation === "vertical") rules += ' sk182';
    else rules += ' sb182';
    rules += ' _Nc182';
    rules += ' Pc182';
    if (props.orientation === "horizontal") rules += ' _Wd182';
    else rules += ' _Wa182';
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    return rules;
};
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$labelText = function anonymous(props) {
    let rules = " ";
    rules += ' zv6x9r182';
    rules += ' yv6x9r182';
    rules += ' Bv6x9r182';
    rules += ' Av6x9r182';
    rules += ' _dc182';
    if (props.orientation === "horizontal") rules += ' __Ad182';
    else rules += ' __Ab182';
    rules += ' Za182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' Na182';
    if (props.orientation === "horizontal") rules += ' _Wd182';
    else rules += ' _Wa182';
    rules += ' _7c182';
    rules += ' _Yb182';
    if (props.orientation === "horizontal") {
        rules += ' xd182';
        rules += ' _xa182';
        rules += ' xX0cczbc182';
        rules += ' _xX0cczba182';
    }
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    return rules;
};
const $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$gridStyles = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    rules += ' se182';
    rules += ' __yM8Mfn182';
    rules += ' Uj182';
    rules += ' qj182';
    rules += ' _Ca182';
    if (props.orientation === "vertical") rules += ' -kN2jP-Z75oWv182';
    else if (props.orientation === "horizontal") rules += ' -kN2jP-ZAK24ue182';
    if (props.orientation === "vertical") rules += ' -LWGJg-ZQGV3L182';
    else if (props.orientation === "horizontal") rules += ' -LWGJg-ZBzUiud182';
    if (props.orientation === "vertical") rules += ' DnG8gle182';
    else if (props.orientation === "horizontal") rules += ' DnG8gle182';
    return rules;
};
function $b0a461d8d3a700b8$export$ebde6d4e7862fe9d(props) {
    let { children: children, isDisabled: individualDisabled = false, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, ...otherProps } = props;
    let { orientation: orientation = 'vertical', isDisabled: groupDisabled = false } = (0, $eF4cA.useContext)($b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$SelectBoxContext);
    const isDisabled = individualDisabled || groupDisabled;
    const ref = (0, $eF4cA.useRef)(null);
    let { isFocusVisible: isFocusVisible } = (0, $YxOvP.useFocusVisible)();
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $cg9Gh.ListBoxItem), {
        isDisabled: isDisabled,
        ref: ref,
        className: (renderProps)=>(UNSAFE_className || '') + $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$selectBoxStyles({
                ...renderProps,
                isFocusVisible: isFocusVisible && renderProps.isFocused,
                orientation: orientation
            }, styles),
        style: (0, $i93Vd.pressScale)(ref, UNSAFE_style),
        ...otherProps,
        children: ({ isSelected: isSelected, isDisabled: isDisabled, isHovered: isHovered, selectionMode: selectionMode })=>{
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)("div", {
                        className: " _Pa182 WJ182 _AI182 _Ob182",
                        "aria-hidden": "true",
                        children: !isDisabled && selectionMode === 'multiple' && (0, $dx4lB.jsx)("div", {
                            className: (0, $cxTG4.box)({
                                isSelected: isSelected,
                                isDisabled: isDisabled,
                                size: 'M'
                            }),
                            children: (0, $dx4lB.jsx)((0, $lTVIu.default), {
                                size: "S",
                                className: (0, $cxTG4.iconStyles)
                            })
                        })
                    }),
                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $dm5H1.IllustrationContext),
                                {
                                    size: 'S',
                                    styles: $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$illustrationContainer({
                                        size: 'S',
                                        orientation: orientation,
                                        isDisabled: isDisabled,
                                        isHovered: isHovered
                                    })
                                }
                            ],
                            [
                                (0, $208Op.TextContext),
                                {
                                    slots: {
                                        [(0, $fDYaM.DEFAULT_SLOT)]: {
                                            styles: $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$labelText({
                                                orientation: orientation,
                                                isDisabled: isDisabled,
                                                isHovered: isHovered
                                            })
                                        },
                                        label: {
                                            styles: $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$labelText({
                                                orientation: orientation,
                                                isDisabled: isDisabled,
                                                isHovered: isHovered
                                            })
                                        },
                                        description: {
                                            styles: $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$descriptionText({
                                                orientation: orientation,
                                                isDisabled: isDisabled,
                                                isHovered: isHovered
                                            })
                                        }
                                    }
                                }
                            ]
                        ],
                        children: children
                    })
                ]
            });
        }
    });
// oxlint-enable react/react-compiler
}
const $b0a461d8d3a700b8$export$da87cf13fc2ef3d8 = (0, $eF4cA.forwardRef)(function SelectBoxGroup(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $b0a461d8d3a700b8$export$cad91f7528e8dc08);
    let { children: children, selectionMode: selectionMode = 'single', orientation: orientation = 'vertical', isDisabled: isDisabled = false, UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, styles: styles, ...otherProps } = props;
    const selectBoxContextValue = (0, $eF4cA.useMemo)(()=>({
            orientation: orientation,
            isDisabled: isDisabled
        }), [
        orientation,
        isDisabled
    ]);
    return (0, $dx4lB.jsx)($b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$SelectBoxContext.Provider, {
        value: selectBoxContextValue,
        children: (0, $dx4lB.jsx)((0, $cg9Gh.ListBox), {
            selectionMode: selectionMode,
            layout: "grid",
            orientation: orientation,
            className: (UNSAFE_className || '') + $b0a461d8d3a700b8$var$$e1ab128dc6578df7$var$gridStyles({
                orientation: orientation
            }, styles),
            style: UNSAFE_style,
            ...otherProps,
            children: children
        })
    });
});


var $33cDE = parcelRequire("33cDE");

var $iMKxE = parcelRequire("iMKxE");

var $eF4cA = parcelRequire("eF4cA");

var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");

var $5nqV3 = parcelRequire("5nqV3");

var $iMKxE = parcelRequire("iMKxE");

var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");

var $afIEk = parcelRequire("afIEk");

var $AkKc4 = parcelRequire("AkKc4");

var $a8sj2 = parcelRequire("a8sj2");
const $4230475195755126$export$3be8ada9e73093a8 = {
    FIREFLY: "firefly",
    ELEVENLABS: "elevenlabs"
};
const $4230475195755126$export$9f62b1d6f4591729 = $4230475195755126$export$3be8ada9e73093a8.FIREFLY;
const $4230475195755126$export$7490fa5691375129 = [
    {
        id: $4230475195755126$export$3be8ada9e73093a8.FIREFLY,
        label: "Firefly Speech"
    },
    {
        id: $4230475195755126$export$3be8ada9e73093a8.ELEVENLABS,
        label: "ElevenLabs"
    }
];
const $4230475195755126$export$15445f8d731a1c21 = {
    all: [
        "textToSpeech"
    ],
    voices: ()=>[
            ...$4230475195755126$export$15445f8d731a1c21.all,
            "voices"
        ],
    voices3p: ()=>[
            ...$4230475195755126$export$15445f8d731a1c21.all,
            "voices-3p"
        ]
};
const $4230475195755126$export$cacb176cdf71daba = (options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $4230475195755126$export$15445f8d731a1c21.voices(),
        queryFn: async ({ signal: signal })=>{
            const voicesResponse = await (0, $5nqV3.getVoices)({
                signal: signal
            });
            return (voicesResponse?.voices ?? []).filter((voice)=>voice?.status === "Active").reduce((acc, voice)=>{
                const prefix = voice.voiceId.replace(/_\d+$/, "");
                if (!acc.find((v)=>v.voiceId.replace(/_\d+$/, "") === prefix)) acc.push(voice);
                return acc;
            }, []);
        },
        meta: {
            errorMessage: "Failed to fetch voices. Please try again."
        },
        ...options
    });
};
const $4230475195755126$var$VOICE_GENDER_MAP = {
    female: "f",
    male: "m",
    "non-binary": "nb",
    "non_binary": "nb",
    nonbinary: "nb",
    neutral: "nb"
};
const $4230475195755126$var$prettifyLabel = (value)=>typeof value === "string" ? value.replace(/_/g, " ").replace(/^\w/, (c)=>c.toUpperCase()) : "";
const $4230475195755126$var$normalizeVoice3p = (item = {})=>{
    const voice = item.voice ?? item;
    const labels = voice.labels ?? {};
    const gender = (voice.gender ?? labels.gender ?? "").toLowerCase();
    return {
        voiceId: item.voiceId ?? item.voice_id ?? voice.voiceId ?? voice.id,
        displayName: voice.name ?? voice.displayName ?? item.voiceId,
        ageGroup: $4230475195755126$var$prettifyLabel(voice.ageGroup ?? labels.age ?? ""),
        gender: $4230475195755126$var$VOICE_GENDER_MAP[gender] ?? gender,
        sampleURL: voice.previewUrl ?? voice.preview_url ?? voice.sampleURL ?? "",
        status: voice.status ?? item.status ?? "Active"
    };
};
const $4230475195755126$export$8f0a67761de70dda = (options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $4230475195755126$export$15445f8d731a1c21.voices3p(),
        queryFn: async ({ signal: signal })=>{
            const voicesResponse = await (0, $5nqV3.getVoices3p)({
                signal: signal
            });
            return (voicesResponse?.voices ?? []).map($4230475195755126$var$normalizeVoice3p).filter((voice)=>voice.voiceId);
        },
        meta: {
            errorMessage: "Failed to fetch ElevenLabs voices. Please try again."
        },
        ...options
    });
};
const $4230475195755126$export$4dd5119b0a6060aa = (options = {})=>{
    const [progress, setProgress] = (0, $eF4cA.useState)(null);
    const renderStatus = (0, $iMKxE.useMogrtStatus)({
        retryDelay: 2000,
        onSettled: ()=>{
            setProgress(null);
        }
    }, {
        onStatus: (statusResponse)=>{
            if (statusResponse?.percentCompleted) {
                const percentCompleted = parseInt(statusResponse.percentCompleted, 10);
                setProgress((prev)=>{
                    if (prev === null) return percentCompleted;
                    else return Math.min(Math.max(prev, percentCompleted), 99);
                });
            }
        },
        getStatusFn: (0, $5nqV3.getAudioStatus)
    });
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { signal: signal })=>{
            const resolvedVoiceId = variables?.voiceId ?? variables?.voiceConfig?.voiceId ?? "v123";
            const voiceId = resolvedVoiceId?.split("_")?.[0];
            const voiceConfig = {
                pitch: variables?.voiceConfig?.pitch ?? 0,
                speed: variables?.voiceConfig?.speed ?? 0.95
            };
            const payload = {
                voiceId: voiceId,
                script: {
                    mediaType: "text/plain",
                    localeCode: "en-US"
                },
                output: {
                    mediaType: "audio/wav",
                    voiceConfig: voiceConfig,
                    metadata: {
                        name: "firefly:internal:text_to_speech_v2"
                    }
                }
            };
            if (variables?.text) payload.script.text = $4230475195755126$var$parseScriptText(variables.text, {
                voiceId: voiceId,
                localeCode: payload.script.localeCode,
                ...voiceConfig
            });
            else if (variables?.url) payload.script.source = {
                url: variables.url
            };
            else throw new Error("Either text or url must be provided");
            const generateResponse = await (0, $5nqV3.generateSpeech)(payload, {
                signal: signal
            });
            const statusResponse = await renderStatus.mutateAsync({
                jobId: generateResponse?.jobId ?? "",
                signal: signal
            });
            const outputUrl = statusResponse?.output?.destination?.url;
            if (!outputUrl) throw new Error("Render succeeded but no output URL returned", {
                cause: statusResponse
            });
            return outputUrl;
        },
        onError: (error, variables, onMutateResult, context)=>{
            if (error?.cause) context.meta.errorMessage = `${error.message}. ${error.cause?.error?.data?.message ?? ""}`;
        },
        meta: {
            errorMessage: "Failed to generate speech. Please try again."
        },
        ...options
    });
    return {
        ...mutation,
        progress: progress
    };
};
const $4230475195755126$var$ELEVENLABS_MIN_SPEED = 0.7;
const $4230475195755126$var$ELEVENLABS_MAX_SPEED = 1.2;
const $4230475195755126$var$extractAudio3pUrl = (data = {})=>{
    const outputs = data?.outputs ?? data?.result?.outputs ?? [];
    const audio = outputs?.[0]?.audio;
    return audio?.presignedUrl ?? audio?.url ?? outputs?.[0]?.destination?.url ?? data?.output?.destination?.url ?? data?.result?.source?.url ?? null;
};
const $4230475195755126$var$getAudio3pStatus = async (params, options = {})=>{
    const response = await (0, $AkKc4.pollStatus)(params, options);
    if (!response.ok && response.status !== 429) return {
        status: "failed",
        ...response.data
    };
    const data = response.data ?? {};
    if (data?.status === "failed") return {
        status: "failed",
        ...data
    };
    const url = $4230475195755126$var$extractAudio3pUrl(data);
    return {
        status: url ? "succeeded" : "in_progress",
        ...data
    };
};
const $4230475195755126$export$e5319d565e4187fe = (options = {})=>{
    const [progress, setProgress] = (0, $eF4cA.useState)(null);
    const renderStatus = (0, $afIEk.useFireflyStatus)({
        onSettled: ()=>{
            setProgress(null);
        }
    }, {
        onStatus: ()=>{
            setProgress((prev)=>prev === null ? 0 : prev);
        },
        getStatusFn: $4230475195755126$var$getAudio3pStatus
    });
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (variables, { signal: signal })=>{
            const voiceId = variables?.voiceId ?? variables?.voiceConfig?.voiceId;
            if (!voiceId) throw new Error("A voice must be selected to generate speech");
            const rawSpeed = variables?.voiceConfig?.speed ?? 1;
            const speed = Math.min(Math.max(rawSpeed, $4230475195755126$var$ELEVENLABS_MIN_SPEED), $4230475195755126$var$ELEVENLABS_MAX_SPEED);
            let prompt;
            if (variables?.text) prompt = $4230475195755126$export$e6f35026d50fc6fb(variables.text).reduce((acc, { match: match, key: key })=>acc.replaceAll(match, key), variables.text);
            else throw new Error("text must be provided");
            const payload = {
                prompt: prompt,
                voiceId: voiceId,
                modelId: "elevenlabs",
                modelVersion: "eleven_multilingual_v2",
                modelSpecificPayload: {
                    voice_settings: {
                        use_speaker_boost: true,
                        similarity_boost: 0.75,
                        style: 0,
                        speed: speed,
                        stability: 0.5
                    }
                }
            };
            const generateResponse = await (0, $5nqV3.generateAudio3p)(payload, {
                signal: signal
            });
            const statusUrl = generateResponse?.links?.result?.href ?? generateResponse?.statusUrl ?? "";
            if (!statusUrl) throw new Error("Generate succeeded but no status URL returned", {
                cause: generateResponse
            });
            const statusResponse = await renderStatus.mutateAsync({
                statusUrl: statusUrl,
                signal: signal
            });
            const outputUrl = $4230475195755126$var$extractAudio3pUrl(statusResponse);
            if (!outputUrl) throw new Error("Render succeeded but no output URL returned", {
                cause: statusResponse
            });
            return outputUrl;
        },
        onError: (error, variables, onMutateResult, context)=>{
            if (error?.cause) context.meta.errorMessage = `${error.message}. ${error.cause?.error?.data?.message ?? ""}`;
        },
        meta: {
            errorMessage: "Failed to generate speech. Please try again."
        },
        ...options
    });
    return {
        ...mutation,
        progress: progress
    };
};
const $4230475195755126$export$6f4d8fd3eda5e0ce = (options = {})=>{
    const fixPronunciation = (0, $4SSyx.useZoltarMutation)({
        onSuccess: (data, variables)=>{}
    }, (data)=>(0, $aKSBi.readZoltarGenerateJsonWithFallback)(data, '{"items":[]}', "Failed to fix pronunciation"));
    return (0, $k6waQ.useMutation)({
        mutationFn: async (variables)=>{
            const pronunciations = $4230475195755126$export$e6f35026d50fc6fb(variables.text);
            const text = pronunciations.reduce((acc, { match: match, key: key })=>acc.replaceAll(match, key), variables.text);
            const parts = Object.fromEntries(Object.entries(variables.parts ?? {}).map(([k, v])=>[
                    k,
                    pronunciations.reduce((acc, { match: match, key: key })=>acc.replaceAll(match, key), v)
                ]));
            const data = await fixPronunciation.mutateAsync({
                promptTemplate: [
                    {
                        role: "user",
                        prompt_template: text
                    }
                ],
                systemPromptId: "common-pronunciation",
                text: text
            });
            const utterance = (data?.items || []).toSorted((a, b)=>b.value?.length - a.value?.length);
            const partKeys = Object.keys(parts);
            const allTexts = [
                text,
                ...partKeys.map((k)=>parts[k])
            ];
            for (const { key: key, value: value } of utterance){
                const existingTagRegex = new RegExp(`\\[[\\w\\s]*${key}[\\w\\s]*\\|`);
                for(let i = 0; i < allTexts.length; i++)allTexts[i] = allTexts[i].replaceAll(key, (match)=>existingTagRegex.test(allTexts[i]) ? match : `[${key}|${value}]`);
            }
            const newText = allTexts[0];
            partKeys.forEach((k, i)=>{
                parts[k] = allTexts[i + 1];
            });
            return {
                text: newText,
                parts: parts,
                utterance: utterance
            };
        },
        meta: {
            errorMessage: "Failed to fix pronunciation. Please try again."
        },
        ...options
    });
};
const $4230475195755126$export$e53ae5d2f8687049 = (options = {})=>{
    const [progress, setProgress] = (0, $eF4cA.useState)(null);
    const renderStatus = (0, $afIEk.useFireflyStatus)({
        onStatus: (statusResponse)=>{
            if (statusResponse?.status === "succeeded") setProgress((prev)=>{
                if (prev === null) return 100;
                else return prev;
            });
        }
    });
    const mutation = (0, $k6waQ.useMutation)({
        mutationFn: async (audios, { signal: signal })=>{
            if (!Array.isArray(audios) || audios.length === 0) throw new Error("audios must be a non-empty array");
            const generateResponse = await (0, $5nqV3.audioMux)(audios, {
                signal: signal
            });
            const statusResponse = await renderStatus.mutateAsync({
                statusUrl: generateResponse?.statusUrl ?? "",
                signal: signal
            });
            const outputUrl = statusResponse?.result?.source?.url;
            if (!outputUrl) throw new Error("Render succeeded but no output URL returned", {
                cause: statusResponse
            });
            return outputUrl;
        },
        onError: (error, variables, onMutateResult, context)=>{
            if (error?.cause) context.meta.errorMessage = `${error.message}. ${error.cause?.error?.data?.message ?? ""}`;
        },
        meta: {
            errorMessage: "Failed to mux audio. Please try again."
        },
        ...options
    });
    return mutation;
};
const $4230475195755126$export$b9a3f411e7ca1c72 = (options = {})=>{
    const generateSpeech = $4230475195755126$export$4dd5119b0a6060aa();
    const audioMuxMutation = $4230475195755126$export$e53ae5d2f8687049();
    const uploadFile = (0, $a8sj2.useUploadFile)();
    return (0, $k6waQ.useMutation)({
        mutationFn: async ({ text: text, voiceId: voiceId, voiceConfig: voiceConfig, email: email, selectedFolder: selectedFolder }, { signal: signal })=>{
            const generateResult = await generateSpeech.mutateAsync({
                text: text,
                voiceId: voiceId,
                voiceConfig: voiceConfig
            }, {
                signal: signal
            });
            const muxResult = await audioMuxMutation.mutateAsync([
                {
                    source: {
                        url: generateResult
                    },
                    volume: 100,
                    inset: 34.0,
                    start: 0.0,
                    duration: 25.0
                }
            ], {
                signal: signal
            });
            const emailPrefix = email?.split("@")?.[0];
            const filePath = `${emailPrefix}/mogrt/${selectedFolder}/${selectedFolder}.wav`;
            const uploadResult = await uploadFile.mutateAsync({
                filePath: filePath,
                fileURL: muxResult
            }, {
                signal: signal
            });
            return uploadResult;
        },
        meta: {
            errorMessage: "Failed to generate and upload audio. Please try again."
        },
        ...options
    });
};
function $4230475195755126$export$e6f35026d50fc6fb(text) {
    const regex = /\[([^\|\[\]]+)\|([^\|\[\]]+)\]/g;
    const pronunciations = [];
    let match;
    while((match = regex.exec(text)) !== null){
        const [_, key, value] = match;
        pronunciations.push({
            match: _,
            key: key,
            value: value
        });
    }
    return pronunciations;
}
function $4230475195755126$var$parseScriptText(text, voiceConfig = {}) {
    const fragment = document.createElement("template");
    const speakNode = document.createElement("speak");
    const voiceNode = document.createElement("voice");
    voiceNode.setAttribute("name", voiceConfig.voiceId);
    voiceNode.setAttribute("language", voiceConfig.localeCode);
    const pitchNode = document.createElement("prosody");
    pitchNode.setAttribute("pitch_shift", `${voiceConfig.pitch}`);
    pitchNode.setAttribute("speaking_rate", `${voiceConfig.speed}`);
    const pronunciations = $4230475195755126$export$e6f35026d50fc6fb(text);
    let htmlText = text;
    pronunciations.forEach(({ match: match, key: key, value: value })=>{
        const phonemeNode = document.createElement("phoneme");
        phonemeNode.setAttribute("alphabet", "text");
        phonemeNode.setAttribute("ph", value);
        phonemeNode.textContent = key;
        htmlText = htmlText.replace(match, phonemeNode.outerHTML);
    });
    pitchNode.innerHTML = htmlText;
    fragment.appendChild(speakNode);
    speakNode.appendChild(voiceNode);
    voiceNode.appendChild(pitchNode);
    return fragment.innerHTML.replace(/"/g, "'").replace(/\n/g, "<s />").replace(/[\s]+/g, " ");
}



var $a8sj2 = parcelRequire("a8sj2");

var $ikOQe = parcelRequire("ikOQe");

var $fL0wx = parcelRequire("fL0wx");
parcelRequire("dFfaH");
var $hpQib = parcelRequire("hpQib");
var $kvWIh = parcelRequire("kvWIh");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $31fH3 = parcelRequire("31fH3");
const $5e0f375ff6d9a15c$export$439d29a4e110a164 = ({ isHidden: isHidden, children: children })=>{
    const Component = isHidden ? (0, $31fH3.VisuallyHidden) : (0, $eF4cA.Fragment);
    return /*#__PURE__*/ (0, $dx4lB.jsx)(Component, {
        children: children
    });
};



var $77tch = parcelRequire("77tch");

var $9lDhw = parcelRequire("9lDhw");
const $7da6076015242272$export$d434e5f09e6f67e5 = 100;
const $7da6076015242272$export$56127b7b51a9491b = 200;
const $7da6076015242272$export$4f8a6a1cc71d71e8 = 200;



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $fZShI = parcelRequire("fZShI");
var $208Op = parcelRequire("208Op");

var $ecbit = parcelRequire("ecbit");
var $h83Hu = parcelRequire("h83Hu");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $3b747bee3b8e9510$var$$8d1881faa8d577b8$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M2.75 11.75c-.414 0-.75-.336-.75-.75V8.5c0-.414.336-.75.75-.75s.75.336.75.75V11c0 .414-.336.75-.75.75M16.75 12.75c-.414 0-.75-.336-.75-.75V7.5c0-.414.336-.75.75-.75s.75.336.75.75V12c0 .414-.336.75-.75.75M6.25 16.5c-.414 0-.75-.336-.75-.75v-12c0-.414.336-.75.75-.75s.75.336.75.75v12c0 .414-.336.75-.75.75M9.75 14.5c-.414 0-.75-.336-.75-.75v-8c0-.414.336-.75.75-.75s.75.336.75.75v8c0 .414-.336.75-.75.75M13.25 19c-.414 0-.75-.336-.75-.75V1.75c0-.414.336-.75.75-.75s.75.336.75.75v16.5c0 .414-.336.75-.75.75"
        })
    });
const $3b747bee3b8e9510$var$$8d1881faa8d577b8$var$ForwardRef = (0, $eF4cA.forwardRef)($3b747bee3b8e9510$var$$8d1881faa8d577b8$var$SvgComponent);
var $3b747bee3b8e9510$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($3b747bee3b8e9510$var$$8d1881faa8d577b8$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $f15374bf21ad0dde$var$$704a534915a2569b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M17.203 5.3c-.244-.245-.622-.273-.873-.06-1.39 1.175-6.846 5.986-7.167 6.307-.462.478-.43 1.26.072 1.747.49.476 1.25.495 1.718.044.32-.322 5.133-5.776 6.31-7.165.212-.251.185-.63-.06-.874M16.488 15.25c-.128 0-.258-.032-.376-.102-.358-.207-.48-.666-.273-1.024.596-1.028.911-2.194.911-3.374 0-.36-.035-.737-.106-1.154-.07-.408.204-.796.612-.866.412-.066.796.204.866.612.086.502.128.962.128 1.408 0 1.443-.385 2.87-1.113 4.126-.139.24-.39.374-.65.374M3.512 15.25c-.259 0-.51-.134-.65-.374-.727-1.256-1.112-2.683-1.112-4.126C1.75 6.201 5.451 2.5 10 2.5c1.513 0 2.999.42 4.3 1.218.352.217.463.678.247 1.031-.216.354-.678.464-1.032.248C12.451 4.345 11.235 4 10 4c-3.722 0-6.75 3.028-6.75 6.75 0 1.18.315 2.346.91 3.374.208.358.086.817-.272 1.024-.118.07-.248.102-.376.102"
        })
    });
const $f15374bf21ad0dde$var$$704a534915a2569b$var$ForwardRef = (0, $eF4cA.forwardRef)($f15374bf21ad0dde$var$$704a534915a2569b$var$SvgComponent);
var $f15374bf21ad0dde$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($f15374bf21ad0dde$var$$704a534915a2569b$var$ForwardRef);




var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $8Muzv = parcelRequire("8Muzv");
var $j3pTw = parcelRequire("j3pTw");
var $8wD3p = parcelRequire("8wD3p");
var $2ffAV = parcelRequire("2ffAV");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $5nTep = parcelRequire("5nTep");

var $i93Vd = parcelRequire("i93Vd");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $8UElq = parcelRequire("8UElq");
const $2fd6a6743a73f0d2$export$d6c8d9636a3dc49c = new WeakMap();
function $2fd6a6743a73f0d2$export$68e648cbec363a18(state, index) {
    let data = $2fd6a6743a73f0d2$export$d6c8d9636a3dc49c.get(state);
    if (!data) throw new Error('Unknown slider state');
    return `${data.id}-${index}`;
}



var $lhKAD = parcelRequire("lhKAD");

var $YxOvP = parcelRequire("YxOvP");

var $ed0Y6 = parcelRequire("ed0Y6");

var $jrZXQ = parcelRequire("jrZXQ");

var $1ntKq = parcelRequire("1ntKq");


var $g8XbY = parcelRequire("g8XbY");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8cfd9daf40e24b5a$export$56b2c08e277f365(props, state, trackRef) {
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $jrZXQ.useLabel)(props);
    let isVertical = props.orientation === 'vertical';
    (0, $2fd6a6743a73f0d2$export$d6c8d9636a3dc49c).set(state, {
        id: labelProps.id ?? fieldProps.id,
        'aria-describedby': props['aria-describedby'],
        'aria-details': props['aria-details']
    });
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $ed0Y6.useGlobalListeners)();
    // When the user clicks or drags the track, we want the motion to set and drag the
    // closest thumb.  Hence we also need to install useMove() on the track element.
    // Here, we keep track of which index is the "closest" to the drag start point.
    // It is set onMouseDown/onTouchDown; see trackProps below.
    const realTimeTrackDraggingIndex = (0, $eF4cA.useRef)(null);
    const reverseX = direction === 'rtl';
    const currentPosition = (0, $eF4cA.useRef)(null);
    const { moveProps: moveProps } = (0, $03126158ef85403f$export$36da96379f79f245)({
        onMoveStart () {
            currentPosition.current = null;
        },
        onMove ({ deltaX: deltaX, deltaY: deltaY }) {
            if (!trackRef.current) return;
            let { height: height, width: width } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            if (currentPosition.current == null && realTimeTrackDraggingIndex.current != null) currentPosition.current = state.getThumbPercent(realTimeTrackDraggingIndex.current) * size;
            let delta = isVertical ? deltaY : deltaX;
            if (isVertical || reverseX) delta = -delta;
            currentPosition.current += delta;
            if (realTimeTrackDraggingIndex.current != null && trackRef.current) {
                const percent = (0, $g8XbY.clamp)(currentPosition.current / size, 0, 1);
                state.setThumbPercent(realTimeTrackDraggingIndex.current, percent);
            }
        },
        onMoveEnd () {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
        }
    });
    let currentPointer = (0, $eF4cA.useRef)(undefined);
    let onDownTrack = (e, id, clientX, clientY)=>{
        // We only trigger track-dragging if the user clicks on the track itself and nothing is currently being dragged.
        if (trackRef.current && !props.isDisabled && state.values.every((_, i)=>!state.isThumbDragging(i))) {
            let { height: height, width: width, top: top, left: left } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            // Find the closest thumb
            const trackPosition = isVertical ? top : left;
            const clickPosition = isVertical ? clientY : clientX;
            const offset = clickPosition - trackPosition;
            let percent = offset / size;
            if (direction === 'rtl' || isVertical) percent = 1 - percent;
            let value = state.getPercentValue(percent);
            // to find the closet thumb we split the array based on the first thumb position to the "right/end" of the click.
            let closestThumb;
            let split = state.values.findIndex((v)=>value - v < 0);
            if (split === 0) closestThumb = split;
            else if (split === -1) closestThumb = state.values.length - 1;
            else {
                let lastLeft = state.values[split - 1];
                let firstRight = state.values[split];
                // Pick the last left/start thumb, unless they are stacked on top of each other, then pick the right/end one
                if (Math.abs(lastLeft - value) < Math.abs(firstRight - value)) closestThumb = split - 1;
                else closestThumb = split;
            }
            // Confirm that the found closest thumb is editable, not disabled, and move it
            if (closestThumb >= 0 && state.isThumbEditable(closestThumb)) {
                // Don't unfocus anything
                e.preventDefault();
                realTimeTrackDraggingIndex.current = closestThumb;
                state.setFocusedThumb(closestThumb);
                currentPointer.current = id;
                state.setThumbDragging(realTimeTrackDraggingIndex.current, true);
                state.setThumbValue(closestThumb, value);
                addGlobalListener(window, 'mouseup', onUpTrack, false);
                addGlobalListener(window, 'touchend', onUpTrack, false);
                addGlobalListener(window, 'pointerup', onUpTrack, false);
            } else realTimeTrackDraggingIndex.current = null;
        }
    };
    let onUpTrack = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
            removeGlobalListener(window, 'mouseup', onUpTrack, false);
            removeGlobalListener(window, 'touchend', onUpTrack, false);
            removeGlobalListener(window, 'pointerup', onUpTrack, false);
        }
    };
    if ('htmlFor' in labelProps && labelProps.htmlFor) {
        // Ideally the `for` attribute should point to the first thumb, but VoiceOver on iOS
        // causes this to override the `aria-labelledby` on the thumb. This causes the first
        // thumb to only be announced as the slider label rather than its individual name as well.
        // See https://bugs.webkit.org/show_bug.cgi?id=172464.
        delete labelProps.htmlFor;
        labelProps.onClick = ()=>{
            // Safari does not focus <input type="range"> elements when clicking on an associated <label>,
            // so do it manually. In addition, make sure we show the focus ring.
            document.getElementById((0, $2fd6a6743a73f0d2$export$68e648cbec363a18)(state, 0))?.focus();
            (0, $YxOvP.setInteractionModality)('keyboard');
        };
    }
    return {
        labelProps: labelProps,
        // The root element of the Slider will have role="group" to group together
        // all the thumb inputs in the Slider.  The label of the Slider will
        // be used to label the group.
        groupProps: {
            role: 'group',
            ...fieldProps
        },
        trackProps: (0, $lhKAD.mergeProps)({
            onMouseDown (e) {
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onDownTrack(e, undefined, e.clientX, e.clientY);
            },
            onPointerDown (e) {
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onDownTrack(e, e.pointerId, e.clientX, e.clientY);
            },
            onTouchStart (e) {
                onDownTrack(e, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            },
            style: {
                position: 'relative',
                touchAction: 'none'
            }
        }, moveProps),
        outputProps: {
            htmlFor: state.values.map((_, index)=>(0, $2fd6a6743a73f0d2$export$68e648cbec363a18)(state, index)).join(' '),
            'aria-live': 'off'
        }
    };
}


var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");


var $lhKAD = parcelRequire("lhKAD");

var $8M8Qw = parcelRequire("8M8Qw");

var $3rgVl = parcelRequire("3rgVl");

var $ed0Y6 = parcelRequire("ed0Y6");

var $aGDvF = parcelRequire("aGDvF");

var $jrZXQ = parcelRequire("jrZXQ");

var $1ntKq = parcelRequire("1ntKq");


var $g8XbY = parcelRequire("g8XbY");

var $eF4cA = parcelRequire("eF4cA");
function $fe3b4eca04cedd05$export$8d15029008292ae(opts, state) {
    let { index: index = 0, isRequired: isRequired, validationState: validationState, isInvalid: isInvalid, trackRef: trackRef, inputRef: inputRef, orientation: orientation = state.orientation, name: name, form: form } = opts;
    let isDisabled = opts.isDisabled || state.isDisabled;
    let isVertical = orientation === 'vertical';
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $ed0Y6.useGlobalListeners)();
    let data = (0, $2fd6a6743a73f0d2$export$d6c8d9636a3dc49c).get(state);
    const { labelProps: labelProps, fieldProps: fieldProps } = (0, $jrZXQ.useLabel)({
        ...opts,
        id: (0, $2fd6a6743a73f0d2$export$68e648cbec363a18)(state, index),
        'aria-labelledby': `${data.id} ${opts['aria-labelledby'] ?? ''}`.trim()
    });
    const value = state.values[index];
    const focusInput = (0, $eF4cA.useCallback)(()=>{
        if (inputRef.current) (0, $2jk5s.focusWithoutScrolling)(inputRef.current);
    }, [
        inputRef
    ]);
    const isFocused = state.focusedThumb === index;
    (0, $eF4cA.useEffect)(()=>{
        if (isFocused) focusInput();
    }, [
        isFocused,
        focusInput
    ]);
    let reverseX = direction === 'rtl';
    let currentPosition = (0, $eF4cA.useRef)(null);
    let keyboardUpdate = (cb)=>{
        // remember to set this so that onChangeEnd is fired
        state.setThumbDragging(index, true);
        cb();
        state.setThumbDragging(index, false);
    };
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            PageUp: ()=>{
                return keyboardUpdate(()=>{
                    state.incrementThumb(index, state.pageSize);
                });
            },
            PageDown: ()=>{
                return keyboardUpdate(()=>{
                    state.decrementThumb(index, state.pageSize);
                });
            },
            Home: ()=>{
                return keyboardUpdate(()=>{
                    state.setThumbValue(index, state.getThumbMinValue(index));
                });
            },
            End: ()=>{
                return keyboardUpdate(()=>{
                    state.setThumbValue(index, state.getThumbMaxValue(index));
                });
            }
        },
        allowRepeats: true
    });
    let { moveProps: moveProps } = (0, $03126158ef85403f$export$36da96379f79f245)({
        onMoveStart () {
            currentPosition.current = null;
            state.setThumbDragging(index, true);
        },
        onMove ({ deltaX: deltaX, deltaY: deltaY, pointerType: pointerType, shiftKey: shiftKey }) {
            const { getThumbPercent: getThumbPercent, setThumbPercent: setThumbPercent, decrementThumb: decrementThumb, incrementThumb: incrementThumb, step: step, pageSize: pageSize } = state;
            if (!trackRef.current) return;
            let { width: width, height: height } = trackRef.current.getBoundingClientRect();
            let size = isVertical ? height : width;
            if (currentPosition.current == null) currentPosition.current = getThumbPercent(index) * size;
            if (pointerType === 'keyboard') {
                if (deltaX > 0 && reverseX || deltaX < 0 && !reverseX || deltaY > 0) decrementThumb(index, shiftKey ? pageSize : step);
                else incrementThumb(index, shiftKey ? pageSize : step);
            } else {
                let delta = isVertical ? deltaY : deltaX;
                if (isVertical || reverseX) delta = -delta;
                currentPosition.current += delta;
                setThumbPercent(index, (0, $g8XbY.clamp)(currentPosition.current / size, 0, 1));
            }
        },
        onMoveEnd () {
            state.setThumbDragging(index, false);
        }
    });
    // Immediately register editability with the state
    state.setThumbEditable(index, !isDisabled);
    const { focusableProps: focusableProps } = (0, $8M8Qw.useFocusable)((0, $lhKAD.mergeProps)(opts, {
        onFocus: ()=>state.setFocusedThumb(index),
        onBlur: ()=>state.setFocusedThumb(undefined)
    }), inputRef);
    let currentPointer = (0, $eF4cA.useRef)(undefined);
    let onDown = (id)=>{
        focusInput();
        currentPointer.current = id;
        state.setThumbDragging(index, true);
        addGlobalListener(window, 'mouseup', onUp, false);
        addGlobalListener(window, 'touchend', onUp, false);
        addGlobalListener(window, 'pointerup', onUp, false);
    };
    let onUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setThumbDragging(index, false);
            removeGlobalListener(window, 'mouseup', onUp, false);
            removeGlobalListener(window, 'touchend', onUp, false);
            removeGlobalListener(window, 'pointerup', onUp, false);
        }
    };
    let thumbPosition = state.getThumbPercent(index);
    if (isVertical || direction === 'rtl') thumbPosition = 1 - thumbPosition;
    let interactions = !isDisabled ? (0, $lhKAD.mergeProps)(keyboardProps, moveProps, {
        onMouseDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onDown();
        },
        onPointerDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onDown(e.pointerId);
        },
        onTouchStart: (e)=>{
            onDown(e.changedTouches[0].identifier);
        }
    }) : {};
    (0, $3rgVl.useFormReset)(inputRef, state.defaultValues[index], (v)=>{
        state.setThumbValue(index, v);
    });
    // We install mouse handlers for the drag motion on the thumb div, but
    // not the key handler for moving the thumb with the slider.  Instead,
    // we focus the range input, and let the browser handle the keyboard
    // interactions; we then listen to input's onChange to update state.
    return {
        inputProps: (0, $lhKAD.mergeProps)(focusableProps, fieldProps, {
            type: 'range',
            tabIndex: !isDisabled ? 0 : undefined,
            min: state.getThumbMinValue(index),
            max: state.getThumbMaxValue(index),
            step: state.step,
            value: value,
            name: name,
            form: form,
            disabled: isDisabled,
            'aria-orientation': orientation,
            'aria-valuetext': state.getThumbValueLabel(index),
            'aria-required': isRequired || undefined,
            'aria-invalid': isInvalid || validationState === 'invalid' || undefined,
            'aria-errormessage': opts['aria-errormessage'],
            'aria-describedby': [
                data['aria-describedby'],
                opts['aria-describedby']
            ].filter(Boolean).join(' '),
            'aria-details': [
                data['aria-details'],
                opts['aria-details']
            ].filter(Boolean).join(' '),
            onChange: (e)=>{
                state.setThumbValue(index, parseFloat((0, $fvyIQ.getEventTarget)(e).value));
            }
        }),
        thumbProps: {
            ...interactions,
            style: {
                position: 'absolute',
                [isVertical ? 'top' : 'left']: `${thumbPosition * 100}%`,
                transform: 'translate(-50%, -50%)',
                touchAction: 'none'
            }
        },
        labelProps: labelProps,
        isDragging: state.isThumbDragging(index),
        isDisabled: isDisabled,
        isFocused: isFocused
    };
}



var $g8XbY = parcelRequire("g8XbY");

var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $g8XbY = parcelRequire("g8XbY");

var $iUErx = parcelRequire("iUErx");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$DEFAULT_MIN_VALUE = 0;
const $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$DEFAULT_MAX_VALUE = 100;
const $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$DEFAULT_STEP_VALUE = 1;
function $0c450fa4e09c75fa$export$e5fda3247f5d67f9(props) {
    const { isDisabled: isDisabled = false, minValue: minValue = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$DEFAULT_MIN_VALUE, maxValue: maxValue = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$DEFAULT_MAX_VALUE, numberFormatter: formatter, step: step = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$DEFAULT_STEP_VALUE, orientation: orientation = 'horizontal' } = props;
    // Page step should be at least equal to step and always a multiple of the step.
    let pageSize = (0, $eF4cA.useMemo)(()=>{
        let calcPageSize = (maxValue - minValue) / 10;
        calcPageSize = (0, $g8XbY.snapValueToStep)(calcPageSize, 0, calcPageSize + step, step);
        return Math.max(calcPageSize, step);
    }, [
        step,
        maxValue,
        minValue
    ]);
    let restrictValues = (0, $eF4cA.useCallback)((values)=>values?.map((val, idx)=>{
            let min = idx === 0 ? minValue : values[idx - 1];
            let max = idx === values.length - 1 ? maxValue : values[idx + 1];
            return (0, $g8XbY.snapValueToStep)(val, min, max, step);
        }), [
        minValue,
        maxValue,
        step
    ]);
    let value = (0, $eF4cA.useMemo)(()=>restrictValues($0c450fa4e09c75fa$var$$d806310b82f07e9d$var$convertValue(props.value)), [
        props.value,
        restrictValues
    ]);
    let defaultValue = (0, $eF4cA.useMemo)(()=>restrictValues($0c450fa4e09c75fa$var$$d806310b82f07e9d$var$convertValue(props.defaultValue) ?? [
            minValue
        ]), [
        props.defaultValue,
        minValue,
        restrictValues
    ]);
    let onChange = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$createOnChange(props.value, props.defaultValue, props.onChange);
    let onChangeEnd = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$createOnChange(props.value, props.defaultValue, props.onChangeEnd);
    const [values, setValuesState] = (0, $iUErx.useControlledState)(value, defaultValue, onChange);
    let [initialValues] = (0, $eF4cA.useState)(values);
    const [isDraggings, setDraggingsState] = (0, $eF4cA.useState)(new Array(values.length).fill(false));
    const isEditablesRef = (0, $eF4cA.useRef)(new Array(values.length).fill(true));
    const [focusedIndex, setFocusedIndex] = (0, $eF4cA.useState)(undefined);
    const valuesRef = (0, $eF4cA.useRef)(values);
    const isDraggingsRef = (0, $eF4cA.useRef)(isDraggings);
    let setValues = (values)=>{
        valuesRef.current = values;
        setValuesState(values);
    };
    let setDraggings = (draggings)=>{
        isDraggingsRef.current = draggings;
        setDraggingsState(draggings);
    };
    function getValuePercent(value) {
        return (value - minValue) / (maxValue - minValue);
    }
    function getThumbMinValue(index) {
        return index === 0 ? minValue : values[index - 1];
    }
    function getThumbMaxValue(index) {
        return index === values.length - 1 ? maxValue : values[index + 1];
    }
    function isThumbEditable(index) {
        return isEditablesRef.current[index];
    }
    function setThumbEditable(index, editable) {
        isEditablesRef.current[index] = editable;
    }
    function updateValue(index, value) {
        if (isDisabled || !isThumbEditable(index)) return;
        const thisMin = getThumbMinValue(index);
        const thisMax = getThumbMaxValue(index);
        // Round value to multiple of step, clamp value between min and max
        value = (0, $g8XbY.snapValueToStep)(value, thisMin, thisMax, step);
        let newValues = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$replaceIndex(valuesRef.current, index, value);
        setValues(newValues);
    }
    function updateDragging(index, dragging) {
        if (isDisabled || !isThumbEditable(index)) return;
        if (dragging) valuesRef.current = values;
        const wasDragging = isDraggingsRef.current[index];
        isDraggingsRef.current = $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$replaceIndex(isDraggingsRef.current, index, dragging);
        setDraggings(isDraggingsRef.current);
        // Call onChangeEnd if no handles are dragging.
        if (onChangeEnd && wasDragging && !isDraggingsRef.current.some(Boolean)) onChangeEnd(valuesRef.current);
    }
    let listFormatRef = (0, $eF4cA.useRef)(null);
    function getFormattedValue(valueParam = values) {
        if (typeof valueParam === 'number') valueParam = [
            valueParam
        ];
        switch(valueParam.length){
            case 0:
                return '';
            case 1:
                return formatter.format(valueParam[0]);
            case 2:
                return formatter.formatRange(valueParam[0], valueParam[1]);
            default:
                {
                    let formatted = valueParam.map((value)=>formatter.format(value));
                    let listFormat = listFormatRef.current;
                    if (!listFormat || listFormat.resolvedOptions().locale !== formatter.resolvedOptions().locale) listFormat = listFormatRef.current = new Intl.ListFormat(formatter.resolvedOptions().locale, {
                        type: 'unit'
                    });
                    return listFormat.format(formatted);
                }
        }
    }
    function setThumbPercent(index, percent) {
        updateValue(index, getPercentValue(percent));
    }
    function getRoundedValue(value) {
        return Math.round((value - minValue) / step) * step + minValue;
    }
    function getPercentValue(percent) {
        const val = percent * (maxValue - minValue) + minValue;
        return (0, $g8XbY.clamp)(getRoundedValue(val), minValue, maxValue);
    }
    function incrementThumb(index, stepSize = 1) {
        let s = Math.max(stepSize, step);
        updateValue(index, (0, $g8XbY.snapValueToStep)(values[index] + s, minValue, maxValue, step));
    }
    function decrementThumb(index, stepSize = 1) {
        let s = Math.max(stepSize, step);
        updateValue(index, (0, $g8XbY.snapValueToStep)(values[index] - s, minValue, maxValue, step));
    }
    return {
        values: values,
        defaultValues: props.defaultValue !== undefined ? defaultValue : initialValues,
        getThumbValue: (index)=>values[index],
        setThumbValue: updateValue,
        setThumbPercent: setThumbPercent,
        isThumbDragging: (index)=>isDraggings[index],
        setThumbDragging: updateDragging,
        focusedThumb: focusedIndex,
        setFocusedThumb: setFocusedIndex,
        getThumbPercent: (index)=>getValuePercent(values[index]),
        getValuePercent: getValuePercent,
        getThumbValueLabel: (index)=>getFormattedValue(values[index]),
        getFormattedValue: getFormattedValue,
        getThumbMinValue: getThumbMinValue,
        getThumbMaxValue: getThumbMaxValue,
        getPercentValue: getPercentValue,
        isThumbEditable: isThumbEditable,
        setThumbEditable: setThumbEditable,
        incrementThumb: incrementThumb,
        decrementThumb: decrementThumb,
        step: step,
        pageSize: pageSize,
        orientation: orientation,
        isDisabled: isDisabled
    };
}
function $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$replaceIndex(array, index, value) {
    if (array[index] === value) return array;
    return [
        ...array.slice(0, index),
        value,
        ...array.slice(index + 1)
    ];
}
function $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$convertValue(value) {
    if (value == null) return undefined;
    return Array.isArray(value) ? value : [
        value
    ];
}
function $0c450fa4e09c75fa$var$$d806310b82f07e9d$var$createOnChange(value, defaultValue, onChange) {
    return (newValue)=>{
        if (typeof value === 'number' || typeof defaultValue === 'number') onChange?.(newValue[0]);
        else onChange?.(newValue);
    };
}



var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $e62p6 = parcelRequire("e62p6");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ababbd4eb9831649$export$e99164f0030f3bff = (0, $eF4cA.createContext)(null);
const $ababbd4eb9831649$export$1e7083018727fa60 = (0, $eF4cA.createContext)(null);
const $ababbd4eb9831649$export$f1fce0420cc6d8ee = (0, $eF4cA.createContext)(null);
const $ababbd4eb9831649$export$7ed6e0ce9ec48be7 = (0, $eF4cA.createContext)(null);
const $ababbd4eb9831649$export$6189c2744041d8f8 = (0, $eF4cA.createContext)(null);
const $ababbd4eb9831649$export$472062a354075cee = (0, $eF4cA.forwardRef)(function Slider(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $ababbd4eb9831649$export$e99164f0030f3bff);
    let trackRef = (0, $eF4cA.useRef)(null);
    let numberFormatter = (0, $e62p6.useNumberFormatter)(props.formatOptions);
    let state = (0, $0c450fa4e09c75fa$export$e5fda3247f5d67f9)({
        ...props,
        numberFormatter: numberFormatter
    });
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps: groupProps, trackProps: trackProps, labelProps: labelProps, outputProps: outputProps } = (0, $8cfd9daf40e24b5a$export$56b2c08e277f365)({
        ...props,
        label: label
    }, state, trackRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state: state
        },
        defaultClassName: 'react-aria-Slider'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $ababbd4eb9831649$export$1e7083018727fa60,
                state
            ],
            [
                $ababbd4eb9831649$export$f1fce0420cc6d8ee,
                {
                    ...trackProps,
                    ref: trackRef
                }
            ],
            [
                $ababbd4eb9831649$export$6189c2744041d8f8,
                outputProps
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": state.orientation,
        "data-disabled": state.isDisabled || undefined
    }));
});
const $ababbd4eb9831649$export$a590f758a961cb5b = (0, $eF4cA.forwardRef)(function SliderOutput(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $ababbd4eb9831649$export$6189c2744041d8f8);
    let { children: children, style: style, className: className, render: render, ...otherProps } = props;
    let state = (0, $eF4cA.useContext)($ababbd4eb9831649$export$1e7083018727fa60);
    let renderProps = (0, $fDYaM.useRenderProps)({
        className: className,
        style: style,
        children: children,
        render: render,
        defaultChildren: state.getFormattedValue(),
        defaultClassName: 'react-aria-SliderOutput',
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state: state
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).output, {
        ...otherProps,
        ...renderProps,
        ref: ref,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
});
const $ababbd4eb9831649$export$105594979f116971 = (0, $eF4cA.forwardRef)(function SliderTrack(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $ababbd4eb9831649$export$f1fce0420cc6d8ee);
    let state = (0, $eF4cA.useContext)($ababbd4eb9831649$export$1e7083018727fa60);
    let { onHoverStart: onHoverStart, onHoverEnd: onHoverEnd, onHoverChange: onHoverChange, ...otherProps } = props;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        onHoverStart: onHoverStart,
        onHoverEnd: onHoverEnd,
        onHoverChange: onHoverChange
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SliderTrack',
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            isHovered: isHovered,
            state: state
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(otherProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
});
const $ababbd4eb9831649$export$2c1b491743890dec = (0, $eF4cA.forwardRef)(function SliderThumb(props, ref) {
    let { inputRef: userInputRef = null } = props;
    let state = (0, $eF4cA.useContext)($ababbd4eb9831649$export$1e7083018727fa60);
    let { ref: trackRef } = (0, $fDYaM.useSlottedContext)($ababbd4eb9831649$export$f1fce0420cc6d8ee);
    let { index: index = 0 } = props;
    let defaultInputRef = (0, $eF4cA.useRef)(null);
    let inputRef = userInputRef || defaultInputRef;
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { thumbProps: thumbProps, inputProps: inputProps, labelProps: labelProps, isDragging: isDragging, isFocused: isFocused, isDisabled: isDisabled } = (0, $fe3b4eca04cedd05$export$8d15029008292ae)({
        ...props,
        index: index,
        trackRef: trackRef,
        inputRef: inputRef,
        label: label
    }, state);
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)(props);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SliderThumb',
        values: {
            state: state,
            isHovered: isHovered,
            isDragging: isDragging,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled
        }
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, thumbProps, hoverProps),
        ...renderProps,
        ref: ref,
        style: {
            ...thumbProps.style,
            ...renderProps.style
        },
        "data-hovered": isHovered || undefined,
        "data-dragging": isDragging || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", {
        ref: inputRef,
        ...(0, $lhKAD.mergeProps)(inputProps, focusProps)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ]
        ]
    }, renderProps.children));
});
const $ababbd4eb9831649$export$2ede0a3f7b0c0db = (0, $eF4cA.forwardRef)(function SliderFill(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $ababbd4eb9831649$export$7ed6e0ce9ec48be7);
    let state = (0, $eF4cA.useContext)($ababbd4eb9831649$export$1e7083018727fa60);
    let { onHoverStart: onHoverStart, onHoverEnd: onHoverEnd, onHoverChange: onHoverChange, ...otherProps } = props;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        onHoverStart: onHoverStart,
        onHoverEnd: onHoverEnd,
        onHoverChange: onHoverChange
    });
    let offset = props.offset != null ? (0, $g8XbY.clamp)(props.offset, state.getThumbMinValue(0), state.getThumbMaxValue(0)) : state.getThumbMinValue(0);
    let start = state.values.length > 1 ? state.getThumbPercent(0) * 100 : state.getValuePercent(offset) * 100;
    let end = state.values.length > 0 ? state.getThumbPercent(state.values.length - 1) * 100 : 0;
    let startPercent = Math.min(start, end);
    let endPercent = Math.max(start, end);
    let sizePercent = Math.max(0, endPercent - startPercent);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SliderFill',
        defaultStyle: state.orientation === 'vertical' ? {
            position: 'absolute',
            bottom: `${startPercent}%`,
            height: `${sizePercent}%`,
            width: '100%'
        } : {
            position: 'absolute',
            insetInlineStart: `${startPercent}%`,
            width: `${sizePercent}%`,
            height: '100%'
        },
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            isHovered: isHovered,
            state: state
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(otherProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-orientation": state.orientation || undefined,
        "data-disabled": state.isDisabled || undefined
    });
});



var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6341cc1a524cee31$export$e99164f0030f3bff = (0, $eF4cA.createContext)(null);
const $6341cc1a524cee31$var$$8128d8480e67c400$var$slider = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else {
        rules += ' pv182';
        rules += ' plb182';
    }
    if (props.labelPosition === "side") rules += ' eb182';
    if (props.isInForm) rules += ' qg182';
    else if (props.size === "XL") rules += ' qj182';
    else if (props.size === "L") rules += ' qi182';
    else if (props.size === "M") rules += ' ql182';
    else if (props.size === "S") rules += ' ql182';
    return rules;
};
const $6341cc1a524cee31$var$$8128d8480e67c400$var$labelContainer = function anonymous(props) {
    let rules = " ";
    if (props.labelPosition === "top") rules += ' se182';
    rules += ' zv6x9r182';
    rules += ' yv6x9r182';
    rules += ' Bv6x9r182';
    rules += ' Av6x9r182';
    rules += ' Za182';
    if (props.labelPosition === "top") rules += ' C09aAFd182';
    if (props.labelPosition === "top") rules += ' Dxumf9b182';
    if (props.labelPosition === "side") {
        if (props.labelAlign === "end") rules += ' _Wb182';
        else if (props.labelAlign === "start") rules += ' _Wd182';
    }
    rules += ' -AJjOLd-Qd182';
    return rules;
};
const $6341cc1a524cee31$var$$8128d8480e67c400$var$output = function anonymous(props) {
    let rules = " ";
    rules += ' zChk6v182';
    rules += ' yChk6v182';
    rules += ' BChk6v182';
    rules += ' AChk6v182';
    if (props.labelPosition === "side") {
        if (props.isInForm) rules += ' _Wb182';
        else if (props.direction === "rtl") rules += ' _Wb182';
        else if (props.direction === "ltr") rules += ' _Wd182';
    } else if (props.labelPosition === "top") {
        if (props.direction === "rtl") rules += ' _Wd182';
        else if (props.direction === "ltr") rules += ' _Wb182';
    }
    return rules;
};
let $6341cc1a524cee31$export$6b2a7d5132615086 = function anonymous(props) {
    let rules = " ";
    rules += ' zCPUPs182';
    rules += ' yCPUPs182';
    rules += ' BCPUPs182';
    rules += ' ACPUPs182';
    rules += ' _Pc182';
    rules += ' Za182';
    if (props.size === "XL") rules += ' Fz182';
    else if (props.size === "L") rules += ' Fv182';
    else if (props.size === "M") rules += ' Fx182';
    else if (props.size === "S") rules += ' Fp182';
    return rules;
};
let $6341cc1a524cee31$export$7814bee2738c4c3 = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' Zo182';
    else if (props.size === "L") rules += ' Zn182';
    else if (props.size === "M") rules += ' Zm182';
    else if (props.size === "S") rules += ' Zl182';
    if (props.size === "XL") rules += ' Fp182';
    else if (props.size === "L") rules += ' Fo182';
    else if (props.size === "M") rules += ' Fn182';
    else if (props.size === "S") rules += ' Fm182';
    rules += ' sg182';
    rules += ' _Pa182';
    rules += ' WF182';
    return rules;
};
let $6341cc1a524cee31$export$f120a3c6038107a5 = function anonymous(props) {
    let rules = " ";
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") rules += ' Zp182';
        else if (props.size === "L") rules += ' Zo182';
        else if (props.size === "M") rules += ' Zn182';
        else if (props.size === "S") rules += ' Zm182';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Zo182';
        else if (props.size === "L") rules += ' Zn182';
        else if (props.size === "M") rules += ' Zm182';
        else if (props.size === "S") rules += ' Zl182';
    }
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") rules += ' Fq182';
        else if (props.size === "L") rules += ' Fp182';
        else if (props.size === "M") rules += ' Fo182';
        else if (props.size === "S") rules += ' Fn182';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Fp182';
        else if (props.size === "L") rules += ' Fo182';
        else if (props.size === "M") rules += ' Fn182';
        else if (props.size === "S") rules += ' Fm182';
    }
    return rules;
};
let $6341cc1a524cee31$export$becc9140d0e846f8 = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' sg182';
    rules += ' _oa182';
    rules += ' _Pa182';
    rules += ' WF182';
    rules += ' _EF182';
    rules += ' _Zd182';
    if (props.thumbStyle === "precise") rules += ' Zg182';
    else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Zo182';
        else if (props.size === "L") rules += ' Zn182';
        else if (props.size === "M") rules += ' Zm182';
        else if (props.size === "S") rules += ' Zl182';
    }
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") rules += ' Fq182';
        else if (props.size === "L") rules += ' Fp182';
        else if (props.size === "M") rules += ' Fo182';
        else if (props.size === "S") rules += ' Fn182';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") rules += ' Fp182';
        else if (props.size === "L") rules += ' Fo182';
        else if (props.size === "M") rules += ' Fn182';
        else if (props.size === "S") rules += ' Fm182';
    }
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' _jf182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    if (props.isDisabled) rules += ' iq182';
    else if (props.isDragging) rules += ' in182';
    else if (props.isHovered) rules += ' in182';
    else rules += ' iv182';
    if (props.isDisabled) rules += ' ilc182';
    else rules += ' ila182';
    rules += ' gX182';
    rules += ' glb182';
    return rules;
};
const $6341cc1a524cee31$var$$8128d8480e67c400$var$trackStyling = {
    height: {
        trackStyle: {
            thin: 4,
            thick: 16
        }
    },
    top: '50%',
    borderRadius: {
        trackStyle: {
            thin: 'lg',
            thick: 'sm'
        }
    }
};
let $6341cc1a524cee31$export$1e1dc99b6e2204f1 = function anonymous(props) {
    let rules = " ";
    if (props.trackStyle === "thick") rules += ' Ft182';
    else if (props.trackStyle === "thin") rules += ' Fe182';
    rules += ' WF182';
    if (props.trackStyle === "thick") rules += ' oa182';
    else if (props.trackStyle === "thin") rules += ' oc182';
    if (props.trackStyle === "thick") rules += ' na182';
    else if (props.trackStyle === "thin") rules += ' nc182';
    if (props.trackStyle === "thick") rules += ' ka182';
    else if (props.trackStyle === "thin") rules += ' kc182';
    if (props.trackStyle === "thick") rules += ' ja182';
    else if (props.trackStyle === "thin") rules += ' jc182';
    rules += ' _Pa182';
    if (props.isDisabled) rules += ' gH182';
    else {
        if (props.isStaticColor) rules += ' gh182';
        else rules += ' gE182';
        rules += ' glb182';
    }
    rules += ' -_8PloMd-m182';
    rules += ' __Ya182';
    rules += ' Za182';
    rules += ' _oa182';
    rules += ' _Lf182';
    rules += ' _MEjZtrc182';
    rules += ' _KnkFfic182';
    rules += ' Oj182';
    if (props.isDisabled) rules += ' OldZOE7182';
    else rules += ' Olb182';
    return rules;
};
let $6341cc1a524cee31$export$847ceef3bc944d02 = function anonymous(props) {
    let rules = " ";
    if (props.trackStyle === "thick") rules += ' Ft182';
    else if (props.trackStyle === "thin") rules += ' Fe182';
    rules += ' WF182';
    if (props.trackStyle === "thick") rules += ' oa182';
    else if (props.trackStyle === "thin") rules += ' oc182';
    if (props.trackStyle === "thick") rules += ' na182';
    else if (props.trackStyle === "thin") rules += ' nc182';
    if (props.trackStyle === "thick") rules += ' ka182';
    else if (props.trackStyle === "thin") rules += ' kc182';
    if (props.trackStyle === "thick") rules += ' ja182';
    else if (props.trackStyle === "thin") rules += ' jc182';
    rules += ' _Pa182';
    if (props.isDisabled) rules += ' gH182';
    else if (props.isEmphasized) rules += ' g3182';
    else rules += ' g_i182';
    if (props.isDisabled) rules += ' gld182';
    else rules += ' gle182';
    rules += ' _oa182';
    rules += ' _jf182';
    rules += ' _kEjZtrc182';
    rules += ' hEjZtrc182';
    rules += ' mEjZtrc182';
    rules += ' lEjZtrc182';
    rules += ' iA182';
    if (props.isDisabled) rules += ' ilc182';
    else rules += ' ilb182';
    rules += ' -_8PloMd-m182';
    rules += ' __Ya182';
    return rules;
};
function $6341cc1a524cee31$export$9418495bb635ebde(props1) {
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    // oxlint-disable-next-line react/react-compiler
    props1 = (0, $j3pTw.useFormProps)(props1);
    let { label: label, labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', size: size = 'M', minValue: minValue = 0, maxValue: maxValue = 100 } = props1;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $ababbd4eb9831649$export$472062a354075cee), {
        ...props1,
        ref: props1.sliderRef,
        className: (renderProps)=>(props1.UNSAFE_className || '') + (0, $5nTep.mergeStyles)(function anonymous(props) {
                let rules = " ";
                rules += ' se182';
                if (props.isInForm) rules += ' z2mU182';
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' yvoofG182';
                }
                if (props.isInForm) rules += ' DLwlgod182';
                else {
                    if (props.labelPosition === "side") rules += ' DPlN5qb182';
                    else if (props.labelPosition === "top") rules += ' DM8Mfn182';
                }
                if (props.labelPosition === "side") rules += ' EPlN5qb182';
                else if (props.labelPosition === "top") rules += ' E4w1sLc182';
                if (props.labelPosition === "side") rules += ' CbRM95c182';
                else if (props.labelPosition === "top") rules += ' Cxaocre182';
                if (props.size === "XL") {
                    rules += ' -_6BNtrc-e182';
                    rules += ' vx182';
                } else if (props.size === "L") {
                    rules += ' -_6BNtrc-d182';
                    rules += ' vx182';
                } else if (props.size === "S") {
                    rules += ' -_6BNtrc-b182';
                    rules += ' vx182';
                } else if (props.size === "XS") {
                    rules += ' -_6BNtrc-a182';
                    rules += ' vx182';
                } else {
                    rules += ' -_6BNtrc-c182';
                    rules += ' vx182';
                }
                rules += ' ea182';
                rules += ' _Fd182';
                rules += ' _FnuYUweb182';
                if (props.size === "XL") rules += ' -BhX7R-Fz182';
                else if (props.size === "L") rules += ' -BhX7R-Fv182';
                else if (props.size === "S") rules += ' -BhX7R-Fp182';
                else if (props.size === "XS") rules += ' -BhX7R-Fn182';
                else rules += ' -BhX7R-Fx182';
                rules += ' -AJjOLd-UVkF0Db182';
                rules += ' qg182';
                rules += ' __ca182';
                return rules;
            }({
                labelPosition: labelPosition,
                isInForm: !!formContext
            }), $6341cc1a524cee31$var$$8128d8480e67c400$var$slider({
                ...renderProps,
                labelPosition: labelPosition,
                size: size,
                isInForm: !!formContext
            }, props1.styles)),
        children: ({ state: state })=>{
            let maxLabelLength = 0;
            switch(state.values.length){
                case 1:
                    maxLabelLength = Math.max([
                        ...state.getFormattedValue(minValue)
                    ].length, [
                        ...state.getFormattedValue(maxValue)
                    ].length);
                    break;
                case 2:
                    maxLabelLength = Math.max([
                        ...state.getFormattedValue([
                            minValue,
                            minValue + (props1.step || 1)
                        ])
                    ].length, [
                        ...state.getFormattedValue([
                            maxValue - (props1.step || 1),
                            maxValue
                        ])
                    ].length);
                    break;
                default:
                    throw new Error('Only sliders with 1 or 2 handles are supported!');
            }
            let outputValue = (0, $dx4lB.jsx)((0, $ababbd4eb9831649$export$a590f758a961cb5b), {
                style: {
                    width: `${maxLabelLength}ch`,
                    minWidth: `${maxLabelLength}ch`,
                    fontVariantNumeric: 'tabular-nums'
                },
                className: $6341cc1a524cee31$var$$8128d8480e67c400$var$output({
                    direction: direction,
                    labelPosition: labelPosition,
                    isInForm: !!formContext
                })
            });
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsxs)("div", {
                        className: $6341cc1a524cee31$var$$8128d8480e67c400$var$labelContainer({
                            labelPosition: labelPosition,
                            labelAlign: labelAlign
                        }),
                        children: [
                            (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                                isDisabled: props1.isDisabled,
                                size: props1.size,
                                labelPosition: labelPosition,
                                labelAlign: labelAlign,
                                contextualHelp: props1.contextualHelp,
                                children: label
                            }),
                            labelPosition === 'top' && outputValue
                        ]
                    }),
                    (0, $dx4lB.jsxs)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr182';
                            rules += ' yXcEWr182';
                            rules += ' BXcEWr182';
                            rules += ' AXcEWr182';
                            if (props.size === "XL") rules += ' Nl182';
                            else if (props.size === "L") rules += ' Nj182';
                            else if (props.size === "S") rules += ' Nf182';
                            else if (props.size === "XS") rules += ' Ne182';
                            else rules += ' Nk182';
                            if (props.isQuiet) rules += ' _qd182';
                            else rules += ' _qtb182';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt182';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr182';
                            else rules += ' -Anxdcc-Z3fn9H182';
                            rules += ' __v6TNLWb182';
                            rules += ' sh182';
                            rules += ' eb182';
                            if (props.size === "XL") rules += ' Uj182';
                            else if (props.size === "L") rules += ' Ui182';
                            else rules += ' Ul182';
                            if (props.size === "XL") rules += ' qj182';
                            else if (props.size === "L") rules += ' qi182';
                            else rules += ' ql182';
                            return rules;
                        }({
                            size: size
                        }),
                        children: [
                            props1.children,
                            labelPosition === 'side' && outputValue
                        ]
                    })
                ]
            });
        }
    });
// oxlint-enable react/react-compiler
}
const $6341cc1a524cee31$export$472062a354075cee = (0, $eF4cA.forwardRef)(function Slider(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $6341cc1a524cee31$export$e99164f0030f3bff);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props = (0, $j3pTw.useFormProps)(props);
    let { labelPosition: labelPosition = 'top', size: size = 'M', fillOffset: fillOffset, isEmphasized: isEmphasized, trackStyle: trackStyle = 'thin', thumbStyle: thumbStyle = 'default' } = props;
    let thumbRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null); // TODO: need to pass inputRef to SliderThumb when we release the next version of RAC 1.3.0
    let domRef = (0, $3PqDc.useFocusableRef)(ref, inputRef);
    let isStaticColor = props['PRIVATE_staticColor'];
    return (0, $dx4lB.jsx)($6341cc1a524cee31$export$9418495bb635ebde, {
        ...props,
        sliderRef: domRef,
        children: (0, $dx4lB.jsx)((0, $ababbd4eb9831649$export$105594979f116971), {
            className: $6341cc1a524cee31$export$6b2a7d5132615086({
                size: size,
                labelPosition: labelPosition,
                isInForm: !!formContext
            }),
            children: ({ isDisabled: isDisabled })=>{
                return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                    children: [
                        (0, $dx4lB.jsx)("div", {
                            className: $6341cc1a524cee31$export$1e1dc99b6e2204f1({
                                isDisabled: isDisabled,
                                isStaticColor: isStaticColor,
                                trackStyle: trackStyle
                            }),
                            children: (0, $dx4lB.jsx)((0, $ababbd4eb9831649$export$2ede0a3f7b0c0db), {
                                offset: fillOffset,
                                className: $6341cc1a524cee31$export$847ceef3bc944d02({
                                    isDisabled: isDisabled,
                                    isEmphasized: isEmphasized,
                                    trackStyle: trackStyle
                                })
                            })
                        }),
                        (0, $dx4lB.jsx)((0, $ababbd4eb9831649$export$2c1b491743890dec), {
                            className: $6341cc1a524cee31$export$7814bee2738c4c3,
                            index: 0,
                            name: props.name,
                            form: props.form,
                            ref: thumbRef,
                            style: (renderProps)=>(0, $i93Vd.pressScale)(thumbRef, {
                                    transform: 'translate(-50%, -50%)'
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>(0, $dx4lB.jsx)("div", {
                                    className: $6341cc1a524cee31$export$f120a3c6038107a5({
                                        size: size
                                    }),
                                    children: (0, $dx4lB.jsx)("div", {
                                        className: $6341cc1a524cee31$export$becc9140d0e846f8({
                                            ...renderProps,
                                            size: size,
                                            thumbStyle: thumbStyle
                                        })
                                    })
                                })
                        })
                    ]
                });
            }
        })
    });
});


var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");

var $iUErx = parcelRequire("iUErx");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $4c13205b8ba10c5c$var$$c4948cfebee06ce4$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M1.75 6.771h2.669c.34 1.43 1.621 2.5 3.154 2.5s2.813-1.07 3.154-2.5h7.523c.414 0 .75-.335.75-.75s-.336-.75-.75-.75h-7.523c-.34-1.43-1.621-2.5-3.154-2.5s-2.814 1.07-3.154 2.5H1.75c-.414 0-.75.336-.75.75s.336.75.75.75m5.823-2.5c.965 0 1.75.786 1.75 1.75s-.785 1.75-1.75 1.75-1.75-.785-1.75-1.75.785-1.75 1.75-1.75M18.25 13.271h-2.523c-.34-1.43-1.621-2.5-3.154-2.5s-2.814 1.07-3.154 2.5H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h7.669c.34 1.43 1.621 2.5 3.154 2.5s2.813-1.07 3.154-2.5h2.523c.414 0 .75-.335.75-.75s-.336-.75-.75-.75m-5.677 2.5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.786 1.75 1.75-.785 1.75-1.75 1.75"
        })
    });
const $4c13205b8ba10c5c$var$$c4948cfebee06ce4$var$ForwardRef = (0, $eF4cA.forwardRef)($4c13205b8ba10c5c$var$$c4948cfebee06ce4$var$SvgComponent);
var $4c13205b8ba10c5c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($4c13205b8ba10c5c$var$$c4948cfebee06ce4$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $bd789f65089562f2$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M7.965 5.178C7.978 5.118 8 5.061 8 5s-.021-.118-.034-.178c-.01-.05-.01-.102-.03-.15-.023-.058-.068-.107-.104-.16-.03-.042-.047-.09-.084-.127l-.004-.003-.003-.004L3.615.303c-.344-.34-.897-.337-1.237.007s-.337.898.007 1.237L5.88 5 2.385 8.453c-.344.339-.347.894-.007 1.237.17.173.396.26.622.26.222 0 .444-.084.615-.253L7.74 5.622l.003-.004.004-.003c.037-.038.055-.085.084-.127.036-.053.08-.102.104-.16.02-.048.02-.1.03-.15"
        })
    });
const $bd789f65089562f2$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($bd789f65089562f2$var$SvgComponent);
var $bd789f65089562f2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($bd789f65089562f2$var$ForwardRef);




var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $208Op = parcelRequire("208Op");

var $9iR3a = parcelRequire("9iR3a");



const $bf3d98caa3bea461$var$getGenderText = (gender)=>{
    switch(gender.toLowerCase()){
        case "f":
            return "Female";
        case "m":
            return "Male";
        case "nb":
            return "Non-binary";
        default:
            return "";
    }
};
const $bf3d98caa3bea461$export$e91df7bd251a2ec7 = ({ voices: voices = [], defaultVoiceId: defaultVoiceId = null, voiceId: voiceId = null, onVoiceSelect: onVoiceSelect, ...otherProps })=>{
    const audioRef = (0, $eF4cA.useRef)(new Audio());
    const [selectedVoiceId, setSelectedVoiceId] = (0, $eF4cA.useState)(defaultVoiceId);
    const [currentSampleVoiceId, setCurrentSampleVoiceId] = (0, $eF4cA.useState)(null);
    const [isPaused, setIsPaused] = (0, $eF4cA.useState)(true);
    const [favorites, setFavorites] = (0, $eF4cA.useState)(localStorage.getItem("BeStory__favoriteVoices")?.split(",") || []);
    const selectedVoice = (0, $eF4cA.useMemo)(()=>voices?.find((voice)=>voice.voiceId === (voiceId || selectedVoiceId)), [
        selectedVoiceId,
        voiceId,
        voices
    ]);
    const voiceItems = (0, $eF4cA.useMemo)(()=>{
        const sortedVoices = [
            ...voices
        ].sort((a, b)=>{
            const aFav = favorites.includes(a.voiceId);
            const bFav = favorites.includes(b.voiceId);
            if (aFav && !bFav) return -1;
            if (!aFav && bFav) return 1;
            return 0;
        });
        return sortedVoices.map((voice)=>({
                ...voice,
                isFavorite: favorites.includes(voice.voiceId)
            }));
    }, [
        voices,
        favorites
    ]);
    const handleVoiceSelect = (0, $eF4cA.useCallback)((key)=>{
        setSelectedVoiceId(key);
        onVoiceSelect?.(key);
    }, [
        onVoiceSelect
    ]);
    const handleToggleFavorite = (0, $eF4cA.useCallback)((key)=>{
        const newFavorites = favorites.includes(key) ? favorites.filter((id)=>id !== key) : [
            ...favorites,
            key
        ];
        setFavorites(newFavorites);
        localStorage.setItem("BeStory__favoriteVoices", newFavorites.join(","));
    }, [
        favorites
    ]);
    const handlePlaySample = (0, $eF4cA.useCallback)((voice)=>{
        if (audioRef.current) {
            // audioRef.current.addEventListener("canplaythrough", () => {
            //   audioRef.current.play();
            // }, { once: true });
            audioRef.current.src = voice.sampleURL;
            setCurrentSampleVoiceId(voice.voiceId);
        }
    }, []);
    const handlePauseSample = (0, $eF4cA.useCallback)(()=>{
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.src = "";
            setCurrentSampleVoiceId(null);
        }
    }, []);
    (0, $eF4cA.useEffect)(()=>{
        const audio = audioRef.current;
        const handleEnded = ()=>setIsPaused(true);
        const handlePlay = ()=>setIsPaused(false);
        const handlePause = ()=>setIsPaused(true);
        const handleCanPlayThrough = ()=>{
            audio.play();
        };
        audio.addEventListener("ended", handleEnded);
        audio.addEventListener("play", handlePlay);
        audio.addEventListener("pause", handlePause);
        audio.addEventListener("canplaythrough", handleCanPlayThrough);
        return ()=>{
            audio.removeEventListener("ended", handleEnded);
            audio.removeEventListener("play", handlePlay);
            audio.removeEventListener("pause", handlePause);
            audio.removeEventListener("canplaythrough", handleCanPlayThrough);
        };
    }, []);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5f873f6fe070b647$export$84d0dd190d551cd1), {
        label: "Voices",
        "aria-label": "Voices",
        items: voiceItems,
        dependencies: [
            currentSampleVoiceId,
            isPaused
        ],
        selectionMode: "single",
        selectionStyle: "highlight",
        selectedKeys: voiceId || selectedVoiceId ? [
            voiceId || selectedVoiceId
        ] : [],
        onSelectionChange: ([id])=>handleVoiceSelect(id),
        ...otherProps,
        styles: " _sa182 _ub182 _vb182" + (otherProps.styles || ""),
        children: (voice)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5f873f6fe070b647$export$c6bde0c04b033c0e), {
                id: voice.voiceId,
                textValue: voice.displayName,
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        slot: "label",
                        children: voice.displayName
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        slot: "description",
                        children: `${voice.ageGroup} \u{2022} ${$bf3d98caa3bea461$var$getGenderText(voice.gender)}`
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                "aria-label": "Toggle favorite",
                                onPress: ()=>handleToggleFavorite(voice.voiceId),
                                children: voice.isFavorite ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1a77093d8eb50e23$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $23940436408f12ff$export$2e2bcd8739ae039), {})
                            }),
                            currentSampleVoiceId === voice.voiceId && !isPaused ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                "aria-label": "Pause preview",
                                onPress: handlePauseSample,
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fdf9f573ae2779ee$export$2e2bcd8739ae039), {})
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                "aria-label": "Play preview",
                                onPress: ()=>handlePlaySample(voice),
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9iR3a.default), {})
                            })
                        ]
                    })
                ]
            })
    });
};



const $fd1b321f28e3a258$var$getPitchLabel = (pitch)=>{
    if (pitch < -1) return "Low";
    if (pitch > 1) return "High";
    return "Neutral";
};
const $fd1b321f28e3a258$var$MAX_CHARACTERS = 7500;
const $fd1b321f28e3a258$export$ca7dc72f8299f9d5 = (props)=>{
    const { audioUrl: audioUrl, voices: voices = [], segments: segments = [], models: models = (0, $4230475195755126$export$7490fa5691375129), onGenerate: onGenerate, isPending: isPending, isDisabled: isDisabled, isInvalid: isInvalid, maxCharacters: maxCharacters = $fd1b321f28e3a258$var$MAX_CHARACTERS, onReady: onReady, onPreviewPlay: onPreviewPlay, size: size = "M", styles: styles = "", children: children } = props;
    const hasModelSelect = props.model != null || props.defaultModel != null || typeof props.onModelChange === "function";
    const [model, setModel] = (0, $iUErx.useControlledState)(props.model, props.defaultModel ?? (0, $4230475195755126$export$9f62b1d6f4591729), props.onModelChange);
    const [voiceId, setVoiceId] = (0, $iUErx.useControlledState)(props.voiceId, props.defaultVoiceId, props.onVoiceSelect);
    const [text, setText] = (0, $iUErx.useControlledState)(props.text, props.defaultText, props.onTextChange);
    const [speed, setSpeed] = (0, $iUErx.useControlledState)(props.speed, props.defaultSpeed, props.onSpeedChange);
    const [pitch, setPitch] = (0, $iUErx.useControlledState)(props.pitch, props.defaultPitch, props.onPitchChange);
    const selectedVoice = (0, $eF4cA.useMemo)(()=>voices?.find((voice)=>voice.voiceId === voiceId), [
        voiceId,
        voices
    ]);
    const handleTextChange = (0, $eF4cA.useCallback)((value)=>{
        const newText = value.slice(0, maxCharacters).replace(/\s{2,}\n/g, " \n");
        setText(newText);
    }, [
        maxCharacters
    ]);
    const hasText = typeof text === "string";
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " _Pc182" + styles,
        children: [
            hasText && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                // {...inputProps}
                "aria-label": "Text to speech input",
                placeholder: "Start typing or paste text here\u2026",
                value: text,
                onChange: handleTextChange,
                isDisabled: isDisabled,
                // isInvalid={isInvalid}
                size: size,
                "data-custom-color": isInvalid,
                UNSAFE_className: "__PromptInputContainer __PromptInput" + function anonymous(props) {
                    let rules = " ";
                    if (props.isInvalid) rules += ' -EH8uVb-p3At3Td182';
                    else rules += ' -EH8uVb-pw182';
                    return rules;
                }({
                    isInvalid: isInvalid
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' _oa182';
                    rules += ' Tt182';
                    rules += ' Qt182';
                    rules += ' St182';
                    rules += ' Rt182';
                    rules += ' g_g182';
                    rules += ' ob182';
                    rules += ' nb182';
                    rules += ' kb182';
                    rules += ' jb182';
                    rules += ' _nLeasBb182';
                    rules += ' sd182';
                    rules += ' _ta182';
                    rules += ' Ug182';
                    rules += ' qg182';
                    if (props.isAbsolute) rules += ' Jx182';
                    else rules += ' Jy182';
                    if (props.isAbsolute) rules += ' Gx182';
                    else rules += ' Gy182';
                    if (props.isAbsolute) rules += ' Ix182';
                    else rules += ' Iy182';
                    if (props.isAbsolute) rules += ' Hx182';
                    else rules += ' Hy182';
                    if (props.isAbsolute) rules += ' _Pa182';
                    else rules += ' _Pc182';
                    if (props.isAbsolute) rules += ' _lI182';
                    else rules += ' _lr182';
                    if (props.isAbsolute) rules += ' _AI182';
                    else rules += ' _Ar182';
                    if (props.isAbsolute) rules += ' _zI182';
                    else rules += ' _zr182';
                    return rules;
                }({
                    isAbsolute: hasText
                }),
                children: [
                    (!!audioUrl || isPending) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $133e7baa0382ff89$export$832cc5475f11d8b4), {
                                url: audioUrl,
                                isAudioJobScheduled: isPending,
                                isEditorEmpty: !audioUrl,
                                segments: segments,
                                onReady: onReady,
                                onPreviewPlay: onPreviewPlay
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                                orientation: "horizontal",
                                size: "S"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 eb182 Ug182 qg182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                        "aria-label": "Voice settings",
                                        isQuiet: true,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4c13205b8ba10c5c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: " Tp182 sd182 _ta182 Ug182 qg182",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                                    styles: " Ix182 Hx182",
                                                    children: [
                                                        hasModelSelect && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                                            label: "Model",
                                                            selectedKey: model,
                                                            onSelectionChange: setModel,
                                                            isDisabled: isDisabled || isPending,
                                                            children: models.map((option)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                                    id: option.id,
                                                                    children: option.label
                                                                }, option.id))
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $6341cc1a524cee31$export$472062a354075cee), {
                                                            label: "Speed",
                                                            value: speed,
                                                            onChange: setSpeed,
                                                            minValue: 0.7,
                                                            maxValue: 1.5,
                                                            step: 0.05,
                                                            formatOptions: {
                                                                minimumFractionDigits: 2
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $6341cc1a524cee31$export$472062a354075cee), {
                                                            label: "Pitch",
                                                            value: pitch,
                                                            onChange: setPitch,
                                                            minValue: -3,
                                                            maxValue: 3,
                                                            step: 1
                                                        })
                                                    ]
                                                }),
                                                !!voices?.length && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                                                            styles: " Ix182 Hx182"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                                    textValue: "Voices",
                                                                    isQuiet: true,
                                                                    styles: " Za182",
                                                                    UNSAFE_style: {
                                                                        justifyContent: "stretch"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                            styles: " z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182 __Ad182",
                                                                            children: "Voices"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                            className: " zYoLErc182 yYoLErc182 BYoLErc182 AYoLErc182 __Ac182 sd182 Ue182 qe182",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                                                                    children: selectedVoice?.displayName
                                                                                }),
                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bd789f65089562f2$export$2e2bcd8739ae039), {
                                                                                    slot: null,
                                                                                    styles: " zXyb182 yXyb182 BXyb182 AXyb182 Zu182 Ft182",
                                                                                    UNSAFE_style: {
                                                                                        width: 10,
                                                                                        height: 10
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                                                    placement: "end top",
                                                                    offset: 0,
                                                                    crossOffset: -8,
                                                                    hideArrow: true,
                                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                        className: " Zy182",
                                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bf3d98caa3bea461$export$e91df7bd251a2ec7), {
                                                                            voices: voices,
                                                                            voiceId: voiceId,
                                                                            onVoiceSelect: setVoiceId,
                                                                            isQuiet: true,
                                                                            selectionStyle: "checkmark",
                                                                            disallowEmptySelection: true
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            children,
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " IM182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                children: hasText ? `${text?.length ?? 0}/${maxCharacters}` : ""
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "accent",
                                isDisabled: hasText && !text?.trim() || isPending || isDisabled /* ||
                      (text === generateSpeech.variables?.text &&
                        selectedVoice.voiceId ===
                          generateSpeech.variables?.voiceId) */ ,
                                onPress: ()=>onGenerate?.({
                                        text: text,
                                        voiceId: selectedVoice?.voiceId ?? voiceId,
                                        voiceConfig: {
                                            speed: speed,
                                            pitch: pitch,
                                            ...hasModelSelect ? {
                                                model: model
                                            } : {}
                                        }
                                    }),
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: !!audioUrl ? "Generate again" : "Generate"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $dx4lB = parcelRequire("dx4lB");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $76ec9e4990f14575$var$$88ac15c768e001f3$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M71.775 21.59c4.686-4.685 12.284-4.685 16.97 0l50.187 50.187c4.686 4.686 4.686 12.284 0 16.97l-50.186 50.187c-4.686 4.686-12.284 4.686-16.97 0L21.588 88.748c-4.686-4.687-4.686-12.285 0-16.97zm11.314 5.658c-1.562-1.562-4.095-1.562-5.657 0L27.246 77.434c-1.562 1.562-1.562 4.095 0 5.657l50.186 50.186c1.562 1.562 4.095 1.562 5.657 0l50.186-50.186c1.562-1.562 1.562-4.095 0-5.657zm-2.83 20.344c2.21 0 4 1.791 4 4v39c0 2.21-1.79 4-4 4-2.208 0-4-1.79-4-4v-39c0-2.209 1.792-4 4-4m6 60.17c0 3.314-2.686 6-6 6s-6-2.686-6-6 2.687-6 6-6 6 2.686 6 6"
        })
    });
const $76ec9e4990f14575$var$$88ac15c768e001f3$var$ForwardRef = (0, $eF4cA.forwardRef)($76ec9e4990f14575$var$$88ac15c768e001f3$var$SvgComponent);
var $76ec9e4990f14575$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($76ec9e4990f14575$var$$88ac15c768e001f3$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $2b35459dffd69dbc$var$$ffe649fcfebee163$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M39.515 14.657c4.687-4.686 12.284-4.686 16.97 0l24.359 24.358c4.686 4.687 4.686 12.284 0 16.97L56.486 80.345c-4.687 4.686-12.284 4.686-16.97 0L15.156 55.986c-4.686-4.687-4.686-12.284 0-16.97zm14.142 2.829c-3.124-3.125-8.19-3.125-11.313 0L17.986 41.844c-3.125 3.124-3.125 8.19 0 11.313l24.358 24.358c3.124 3.124 8.19 3.124 11.313 0l24.358-24.358c3.124-3.124 3.124-8.19 0-11.313zM48 28.8c1.105 0 2 .896 2 2V53c0 1.105-.895 2-2 2s-2-.895-2-2V30.8c0-1.104.896-2 2-2m3 34.48c0 1.657-1.343 3-3 3-1.656 0-3-1.343-3-3s1.344-3 3-3c1.657 0 3 1.343 3 3"
        })
    });
const $2b35459dffd69dbc$var$$ffe649fcfebee163$var$ForwardRef = (0, $eF4cA.forwardRef)($2b35459dffd69dbc$var$$ffe649fcfebee163$var$SvgComponent);
var $2b35459dffd69dbc$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($2b35459dffd69dbc$var$$ffe649fcfebee163$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $2210f61e44c8bb1c$var$$b93b839163b9a97f$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M20.287 7.444c2.05-2.05 5.375-2.05 7.425 0l12.843 12.843c2.05 2.05 2.05 5.375 0 7.425L27.712 40.555c-2.05 2.05-5.375 2.05-7.425 0L7.444 27.712c-2.05-2.05-2.05-5.375 0-7.425zm5.657 1.768c-1.074-1.074-2.815-1.074-3.89 0L9.213 22.055c-1.074 1.074-1.074 2.815 0 3.889l12.843 12.843c1.074 1.074 2.815 1.074 3.889 0l12.843-12.843c1.074-1.074 1.074-2.815 0-3.89zm-1.945 5.037c.69 0 1.25.56 1.25 1.25v11c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-11c0-.69.56-1.25 1.25-1.25M25.75 32c0 .967-.783 1.75-1.75 1.75-.966 0-1.75-.783-1.75-1.75 0-.966.784-1.75 1.75-1.75.967 0 1.75.784 1.75 1.75"
        })
    });
const $2210f61e44c8bb1c$var$$b93b839163b9a97f$var$ForwardRef = (0, $eF4cA.forwardRef)($2210f61e44c8bb1c$var$$b93b839163b9a97f$var$SvgComponent);
var $2210f61e44c8bb1c$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($2210f61e44c8bb1c$var$$b93b839163b9a97f$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $252ea4e48c6387ce$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $76ec9e4990f14575$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $2210f61e44c8bb1c$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $2b35459dffd69dbc$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $56df7bad94ab337a$export$64d954f58ddfdc47 = ({ errorMessage: errorMessage, children: children })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Ul182 ql182 LILqIYb182 IM182 HM182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ul182 ql182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $252ea4e48c6387ce$export$2e2bcd8739ae039), {
                        styles: " ZF182 Fz182 -_8sjo0b-tm182 Zl182 Fm182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " sd182 _ta182 Ub182 qb182",
                        children: errorMessage?.map((line, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: function anonymous(props) {
                                    let rules = " ";
                                    if (props.isIndex) {
                                        rules += ' uk182';
                                        rules += ' ucJ9TBTb182';
                                        rules += ' ud3Euai182';
                                        rules += ' uea182';
                                        rules += ' ugb182';
                                        rules += ' uhd182';
                                        rules += ' uje182';
                                        rules += ' u2NhKxcl182';
                                        rules += ' uic182';
                                    } else {
                                        rules += ' uk182';
                                        rules += ' ucJ9TBTb182';
                                        rules += ' ud3Euai182';
                                        rules += ' uea182';
                                        rules += ' ugb182';
                                        rules += ' uhd182';
                                        rules += ' uje182';
                                        rules += ' u2NhKxcl182';
                                        rules += ' uic182';
                                    }
                                    if (props.isIndex) {
                                        rules += ' -_6BNtrc-d182';
                                        rules += ' vx182';
                                    } else {
                                        rules += ' -_6BNtrc-c182';
                                        rules += ' vx182';
                                    }
                                    if (props.isIndex) {
                                        rules += ' xd182';
                                        rules += ' _xa182';
                                        rules += ' xX0cczbc182';
                                        rules += ' _xX0cczba182';
                                        rules += ' xfd182';
                                        rules += ' _xfa182';
                                        rules += ' xfX0cczbc182';
                                        rules += ' _xfX0cczba182';
                                    } else {
                                        rules += ' xb182';
                                        rules += ' _xa182';
                                    }
                                    if (props.isIndex) {
                                        rules += ' _Fd182';
                                        rules += ' _FnuYUweb182';
                                    } else {
                                        rules += ' _Fd182';
                                        rules += ' _FnuYUweb182';
                                    }
                                    if (props.isIndex) rules += ' po182';
                                    else rules += ' pt182';
                                    return rules;
                                }({
                                    isIndex: index === 0
                                }),
                                children: line
                            }, index))
                    })
                ]
            }),
            children
        ]
    });
};



var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");

var $77tch = parcelRequire("77tch");


var $fL0wx = parcelRequire("fL0wx");
parcelRequire("dFfaH");
var $hpQib = parcelRequire("hpQib");
var $kvWIh = parcelRequire("kvWIh");

const $d1074761a75a163a$var$inputWrapperStyle = " sh182 -EH8uVb-pxgjhZb182";
const $d1074761a75a163a$var$inputStyle = function anonymous(props) {
    let rules = " ";
    rules += ' ZK182';
    rules += ' Na182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-f182';
    rules += ' vx182';
    rules += ' xc182';
    rules += ' _xa182';
    rules += ' _Fb182';
    rules += ' _FnuYUwec182';
    rules += ' pt182';
    rules += ' g9182';
    rules += ' _ka182';
    rules += ' ha182';
    rules += ' ma182';
    rules += ' la182';
    if (props.isFocused) rules += ' _Xa182';
    else {
        rules += ' _Xb182';
        rules += ' __Va182';
    }
    if (props.isFocused) rules += ' O95Jo1182';
    else rules += ' Oj182';
    rules += ' _Mc182';
    rules += ' _Lf182';
    rules += ' _Kd182';
    rules += ' oa182';
    rules += ' na182';
    rules += ' ka182';
    rules += ' ja182';
    rules += ' _je182';
    rules += ' _Qc182';
    rules += ' _Nc182';
    return rules;
};
const $d1074761a75a163a$var$inputInlineStyle = {
    fieldSizing: "content",
    textUnderlineOffset: 4,
    textDecorationThickness: 1.5,
    textDecorationColor: "var(--borderColor)",
    textDecorationStyle: "dashed"
};
const $d1074761a75a163a$export$9e87bc6c16545701 = (duration)=>duration - 1.5;
const $d1074761a75a163a$export$f033fe09bfbbeb73 = (duration)=>duration + 0.1;
const $d1074761a75a163a$var$PLACEHOLDER_REGEX = /\{\{([\w\d\-]+)\}\}/g;
const $d1074761a75a163a$export$ca35df912b47239e = (text)=>Array.from(new Set(text?.match(/\{\{([\w\d\-]+)\}\}/g)?.map((match)=>match.replace(/\{\{|\}\}/g, "")) ?? []));
const $d1074761a75a163a$export$32c15f4ab4985540 = (text, { placeholders: placeholders = {}, parts: parts = {}, campaign: campaign = {} } = {})=>text?.replace($d1074761a75a163a$var$PLACEHOLDER_REGEX, (match, key)=>placeholders?.[key] ?? parts?.[key] ?? campaign?.[key] ?? "") ?? "";
const $d1074761a75a163a$export$ab28a3677dae0f8e = (duration, maxDuration, minDuration)=>{
    const _maxDuration = maxDuration ?? $d1074761a75a163a$export$f033fe09bfbbeb73(duration);
    const _minDuration = minDuration ?? $d1074761a75a163a$export$9e87bc6c16545701(duration);
    if (duration > _maxDuration) return {
        isInvalid: true,
        errorMessage: [
            `The generated voiceover is too long (${duration.toFixed(2)}s, max is ${_maxDuration}s)`,
            `Shorten the text and regenerate`
        ]
    };
    else if (duration < _minDuration) return {
        isInvalid: true,
        errorMessage: [
            `The generated voiceover is too short (${duration.toFixed(2)}s, min is ${_minDuration}s)`,
            `Lengthen the text and regenerate`
        ]
    };
    else return {
        isInvalid: false,
        errorMessage: null
    };
};
const $d1074761a75a163a$export$3cea9fb9794152bb = ({ videoId: videoId, assetName: assetName, isStandalone: isStandalone })=>{
    const user = (0, $fL0wx.useUserProfile)();
    const video = (0, $ikOQe.useVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const { uploadAssets: uploadAssets, updateAssets: updateAssets, editCampaign: editCampaign } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const asset = (0, $eF4cA.useMemo)(()=>video.data?.assets.find((a)=>a.name === assetName), [
        video.data?.assets,
        assetName
    ]);
    const s3Asset = (0, $a8sj2.usePresignURL)(asset?.filePath);
    const templateAsset = (0, $eF4cA.useMemo)(()=>template.data?.assets.find((a)=>a.name === assetName), [
        template.data?.assets,
        assetName
    ]);
    const defaultVoiceoverFilePath = (0, $eF4cA.useMemo)(()=>{
        const rootPath = video.data?.mogrtRootPath ?? template.data?.rootPath;
        if (!rootPath) return null;
        return `${rootPath.replace(/\/$/, "")}/vo/${assetName}.wav`;
    }, [
        video.data?.mogrtRootPath,
        template.data?.rootPath,
        assetName
    ]);
    const selectedCampaign = (0, $eF4cA.useMemo)(()=>video.data?.campaigns?.find((item)=>item.id === video.data?.selectedCampaignIds?.[0]), [
        video.data?.campaigns,
        video.data?.selectedCampaignIds
    ]);
    const placeholderKeys = (0, $eF4cA.useMemo)(()=>$d1074761a75a163a$export$ca35df912b47239e(templateAsset?.text), [
        templateAsset?.text
    ]);
    const textFragments = (0, $eF4cA.useMemo)(()=>(templateAsset?.text ?? "").split($d1074761a75a163a$var$PLACEHOLDER_REGEX), [
        templateAsset?.text
    ]);
    const [placeholders, setPlaceholders] = (0, $eF4cA.useState)({});
    const textParts = (0, $eF4cA.useMemo)(()=>placeholderKeys.reduce((acc, key)=>{
            acc[key] = placeholders?.[key] ?? asset?.parts?.[key] ?? selectedCampaign?.[key] ?? "";
            return acc;
        }, {}), [
        placeholderKeys,
        placeholders,
        asset?.parts,
        selectedCampaign
    ]);
    const hasTextParts = placeholderKeys.length > 0;
    const originalText = (0, $eF4cA.useMemo)(()=>{
        return $d1074761a75a163a$export$32c15f4ab4985540(asset?.text ?? templateAsset?.text ?? "", {
            placeholders: placeholders,
            parts: asset?.parts,
            campaign: selectedCampaign
        });
    }, [
        asset?.text,
        templateAsset?.text,
        placeholders,
        asset?.parts,
        selectedCampaign
    ]);
    const [_model, setModel] = (0, $eF4cA.useState)();
    const model = _model ?? asset?.voiceConfig?.model ?? templateAsset?.voiceConfig?.model ?? (0, $4230475195755126$export$9f62b1d6f4591729);
    const [_selectedVoiceId, setSelectedVoiceId] = (0, $eF4cA.useState)();
    const selectedVoiceId = _selectedVoiceId ?? asset?.voiceId ?? asset?.voiceConfig?.voiceId ?? templateAsset?.voiceConfig?.voiceId ?? "v123";
    const [_text, setText] = (0, $eF4cA.useState)();
    const text = _text ?? originalText;
    const [_speed, setSpeed] = (0, $eF4cA.useState)();
    const speed = _speed ?? asset?.voiceConfig?.speed ?? templateAsset?.voiceConfig?.speed ?? 1;
    const [_pitch, setPitch] = (0, $eF4cA.useState)();
    const pitch = _pitch ?? asset?.voiceConfig?.pitch ?? templateAsset?.voiceConfig?.pitch ?? 0;
    const [duration, setDuration] = (0, $eF4cA.useState)(0);
    const [_isInvalid, setInvalid] = (0, $eF4cA.useState)(null);
    const isInvalid = _isInvalid ?? asset?.isInvalid ?? false;
    const [errorMessage, setErrorMessage] = (0, $eF4cA.useState)(null);
    const isElevenLabs = model === (0, $4230475195755126$export$3be8ada9e73093a8).ELEVENLABS;
    const fireflyVoices = (0, $4230475195755126$export$cacb176cdf71daba)();
    const elevenLabsVoices = (0, $4230475195755126$export$8f0a67761de70dda)({
        enabled: isElevenLabs
    });
    const voices = isElevenLabs ? elevenLabsVoices : fireflyVoices;
    const pendingScriptRef = (0, $eF4cA.useRef)(null);
    const handleModelChange = (0, $eF4cA.useCallback)((nextModel)=>{
        setModel(nextModel);
        setSelectedVoiceId(null);
    }, []);
    const captureScriptSnapshot = (0, $eF4cA.useCallback)((overrides = {})=>{
        const snapshot = {
            text: hasTextParts ? templateAsset?.text ?? overrides.text : overrides.text ?? text ?? templateAsset?.text,
            voiceId: overrides.voiceId ?? selectedVoiceId,
            voiceConfig: overrides.voiceConfig ?? {
                speed: speed,
                pitch: pitch,
                model: model
            },
            parts: {
                ...overrides.parts ?? textParts
            }
        };
        pendingScriptRef.current = snapshot;
        return snapshot;
    }, [
        hasTextParts,
        templateAsset?.text,
        text,
        selectedVoiceId,
        speed,
        pitch,
        model,
        textParts
    ]);
    const buildVoiceoverAssetPayload = (0, $eF4cA.useCallback)((audioSrc, variables = {})=>{
        const snapshot = pendingScriptRef.current ?? {};
        return {
            name: assetName,
            type: "audio",
            src: audioSrc,
            text: hasTextParts ? templateAsset?.text ?? variables.text ?? snapshot.text : variables.text ?? snapshot.text ?? text ?? templateAsset?.text,
            voiceId: variables.voiceId ?? snapshot.voiceId ?? selectedVoiceId,
            voiceConfig: variables.voiceConfig ?? snapshot.voiceConfig ?? {
                speed: speed,
                pitch: pitch,
                model: model
            },
            parts: {
                ...variables.parts ?? snapshot.parts ?? textParts
            },
            generatedAt: Date.now(),
            isRegenerated: true
        };
    }, [
        assetName,
        hasTextParts,
        templateAsset?.text,
        text,
        selectedVoiceId,
        speed,
        pitch,
        model,
        textParts
    ]);
    const persistScriptMetadata = (0, $eF4cA.useCallback)(async (script)=>{
        if (!asset?.filePath) return;
        await updateAssets.mutateAsync({
            assets: [
                {
                    name: assetName,
                    type: "audio",
                    filePath: asset.filePath,
                    ...script
                }
            ]
        });
    }, [
        asset?.filePath,
        assetName,
        updateAssets
    ]);
    const handleUseDefaultVoiceover = (0, $eF4cA.useCallback)(async ()=>{
        if (!defaultVoiceoverFilePath) return;
        setInvalid(null);
        setErrorMessage(null);
        const script = captureScriptSnapshot();
        await uploadAssets.mutateAsync({
            assets: [
                {
                    name: assetName,
                    type: "audio",
                    filePath: defaultVoiceoverFilePath,
                    text: script.text,
                    voiceId: script.voiceId,
                    voiceConfig: script.voiceConfig,
                    parts: {
                        ...script.parts
                    },
                    generatedAt: Date.now(),
                    // Template default track — not a regeneration, so it keeps the whole
                    // voiceover on the pre-rendered preview.
                    isRegenerated: false
                }
            ]
        });
    }, [
        defaultVoiceoverFilePath,
        captureScriptSnapshot,
        uploadAssets,
        assetName
    ]);
    const generateSpeechCallbacks = {
        onMutate: ()=>{
            setInvalid(null);
            setErrorMessage(null);
        },
        onSuccess: async (audioSrc, variables)=>{
            return uploadAssets.mutateAsync({
                assets: [
                    buildVoiceoverAssetPayload(audioSrc, variables)
                ]
            });
        }
    };
    const generateSpeechFirefly = (0, $4230475195755126$export$4dd5119b0a6060aa)(generateSpeechCallbacks);
    const generateSpeech3p = (0, $4230475195755126$export$e5319d565e4187fe)(generateSpeechCallbacks);
    const generateSpeech = isElevenLabs ? generateSpeech3p : generateSpeechFirefly;
    const isGeneratingSpeech = generateSpeechFirefly.isPending || generateSpeech3p.isPending;
    const fixPronunciation = (0, $4230475195755126$export$6f4d8fd3eda5e0ce)({
        onSuccess: (data)=>{
            setText(data.text);
            setPlaceholders(data.parts);
        }
    });
    const handleFixPronounciation = (0, $eF4cA.useCallback)(()=>{
        fixPronunciation.mutate({
            text: originalText,
            parts: textParts
        });
        (0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).VOICEOVER_PRONUNCIATION_FIXED, {
            user: {
                email: user?.email
            },
            videoId: videoId,
            templateId: video.data?.templateId
        });
    }, [
        fixPronunciation
    ]);
    const selectedVoice = (0, $eF4cA.useMemo)(()=>{
        if (isElevenLabs) return voices.data?.find((voice)=>voice.voiceId === selectedVoiceId) ?? {};
        const voiceId = selectedVoiceId?.split("_")[0] + "_1";
        return voices.data?.find((voice)=>voice.voiceId === voiceId) ?? {};
    }, [
        selectedVoiceId,
        voices.data,
        isElevenLabs
    ]);
    const parts = (0, $eF4cA.useMemo)(()=>{
        if (!asset?.parts) return {};
        return Object.entries(asset.parts).reduce((acc, [key, value])=>{
            const pronunciations = (0, $4230475195755126$export$e6f35026d50fc6fb)(value);
            const text = pronunciations.reduce((acc, { match: match, key: key })=>acc.replaceAll(match, key), value);
            acc[key] = text;
            return acc;
        }, {});
    }, [
        asset?.parts
    ]);
    const hasChanged = (0, $eF4cA.useMemo)(()=>!!asset?.parts && Object.entries(parts).some(([key, value])=>{
            return value !== selectedCampaign?.[key];
        }), [
        parts,
        selectedCampaign
    ]);
    const handlePlayerReady = (0, $eF4cA.useCallback)((ws)=>{
        const _duration = (0, $133e7baa0382ff89$export$88a5fd9752ff366c)(ws);
        setDuration(_duration);
        const validation = $d1074761a75a163a$export$ab28a3677dae0f8e(_duration, templateAsset?.maxDuration, templateAsset?.minDuration);
        setInvalid(validation.isInvalid);
        setErrorMessage(validation.errorMessage);
    }, [
        templateAsset?.maxDuration,
        templateAsset?.minDuration
    ]);
    const handleGenerate = (0, $eF4cA.useCallback)(async (variables = {
        voiceConfig: {}
    })=>{
        const { voiceId: templateVoiceId, ...templateVoiceConfig } = templateAsset?.voiceConfig || {};
        const voiceId = isElevenLabs ? variables.voiceId ?? selectedVoice.voiceId ?? templateVoiceId ?? voices.data?.[0]?.voiceId : variables.voiceId ?? selectedVoiceId ?? selectedVoice.voiceId ?? templateVoiceId ?? "v123";
        const voiceConfig = {
            ...templateVoiceConfig,
            speed: speed,
            pitch: pitch,
            model: model,
            ...variables.voiceConfig
        };
        const script = captureScriptSnapshot({
            voiceId: voiceId,
            voiceConfig: voiceConfig,
            parts: variables.parts,
            text: variables.text
        });
        await persistScriptMetadata(script);
        generateSpeech.mutate({
            text: hasTextParts ? variables.text ?? originalText : variables.text ?? text,
            voiceId: voiceId,
            parts: {
                ...script.parts
            },
            voiceConfig: voiceConfig
        });
    }, [
        hasTextParts,
        originalText,
        text,
        captureScriptSnapshot,
        persistScriptMetadata,
        templateAsset?.voiceConfig,
        selectedVoice?.voiceId,
        selectedVoiceId,
        pitch,
        speed,
        model,
        isElevenLabs,
        voices.data,
        generateSpeech.mutate
    ]);
    const handleRegenerateWithSpeed = (0, $eF4cA.useCallback)(()=>{
        const newSpeed = speed + Math.ceil(duration - templateAsset.maxDuration) * 0.05;
        setSpeed(newSpeed);
        handleGenerate({
            voiceConfig: {
                speed: newSpeed
            }
        });
    }, [
        speed,
        handleGenerate,
        duration,
        templateAsset?.maxDuration
    ]);
    // useEffect(() => {
    //   if (video.isSuccess && template.isSuccess) {
    //     setSpeed(
    //       asset?.voiceConfig?.speed ?? templateAsset?.voiceConfig?.speed ?? 1,
    //     );
    //     setPitch(
    //       asset?.voiceConfig?.pitch ?? templateAsset?.voiceConfig?.pitch ?? 0,
    //     );
    //     if (asset?.voiceConfig?.voiceId ?? templateAsset?.voiceConfig?.voiceId) {
    //       setSelectedVoiceId(
    //         asset?.voiceConfig?.voiceId ?? templateAsset?.voiceConfig?.voiceId,
    //       );
    //     }
    //     if (
    //       typeof asset?.isInvalid !== "undefined" &&
    //       asset?.isInvalid !== isInvalid
    //     ) {
    //       setInvalid(asset.isInvalid);
    //     }
    //   }
    // }, [
    //   video.isSuccess,
    //   template.isSuccess,
    //   asset,
    //   templateAsset,
    //   pitch,
    //   speed,
    //   isInvalid,
    // ]);
    (0, $eF4cA.useEffect)(()=>{
        if (hasChanged && !editCampaign.isPending && !uploadAssets.isPending && !updateAssets.isPending && !isGeneratingSpeech) editCampaign.mutate({
            id: selectedCampaign?.id,
            ...parts
        });
    }, [
        hasChanged,
        editCampaign.isPending,
        editCampaign.mutate,
        selectedCampaign?.id,
        parts,
        uploadAssets.isPending,
        updateAssets.isPending,
        isGeneratingSpeech
    ]);
    const hasCampaignValues = !hasTextParts || placeholderKeys.every((key)=>Boolean(textParts[key]));
    const shouldGenerate = !asset && !voices.isLoading && !editCampaign.isPending && !fixPronunciation.isPending && !isGeneratingSpeech && !uploadAssets.isPending && hasCampaignValues;
    const isDefaultVoiceover = !hasTextParts && !!defaultVoiceoverFilePath && text === (templateAsset?.text ?? "");
    (0, $eF4cA.useEffect)(()=>{
        if (!shouldGenerate) return;
        if (isDefaultVoiceover) {
            handleUseDefaultVoiceover();
            return;
        }
        fixPronunciation.mutate({
            text: originalText,
            parts: textParts
        }, {
            onSuccess: (data)=>{
                handleGenerate({
                    text: data.text,
                    parts: data.parts
                });
            }
        });
    }, [
        shouldGenerate,
        isDefaultVoiceover,
        handleUseDefaultVoiceover,
        handleGenerate,
        originalText,
        textParts,
        fixPronunciation.mutate
    ]);
    // useEffect(() => {
    //   if (
    //     !!asset &&
    //     asset.isInvalid !== isInvalid &&
    //     !generateSpeech.isPending &&
    //     !updateAssets.isPending
    //   ) {
    //     updateAssets.mutate({
    //       assets: [{ ...asset, isInvalid, errorMessage }],
    //     });
    //   }
    // }, [
    //   asset,
    //   isInvalid,
    //   errorMessage,
    //   generateSpeech.isPending,
    //   updateAssets.isPending,
    // ]);
    if (!templateAsset || !asset) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: "Generating voiceover",
        subtitle: "This may take a few moments, so please keep this tab open.",
        ariaLabel: "Generating voiceover",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3b747bee3b8e9510$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Up182 qp182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                // title={templateAsset?.label}
                subtitle: templateAsset?.description
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 Up182 qp182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: hasTextParts ? function anonymous(props) {
                            let rules = " ";
                            rules += ' sd182';
                            rules += ' _ta182';
                            rules += ' Uj182';
                            rules += ' qj182';
                            rules += ' Te182';
                            rules += ' Qf182';
                            rules += ' Sf182';
                            rules += ' Rf182';
                            rules += ' gX182';
                            rules += ' _kc182';
                            rules += ' hc182';
                            rules += ' mc182';
                            rules += ' lc182';
                            rules += ' _jf182';
                            if (props.isInvalid) rules += ' is182';
                            else rules += ' i7B7Kwc182';
                            rules += ' oc182';
                            rules += ' nc182';
                            rules += ' kc182';
                            rules += ' jc182';
                            rules += ' Yc182';
                            rules += ' Xb182';
                            rules += ' _2b182';
                            return rules;
                        }({
                            isInvalid: isInvalid
                        }) : "",
                        children: [
                            !!hasTextParts && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " sf182 Ue182 qe182",
                                children: textFragments.map((key, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $eF4cA.Fragment), {
                                        children: index % 2 === 1 ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $h83Hu.TextField), {
                                            "aria-label": key,
                                            className: $d1074761a75a163a$var$inputWrapperStyle,
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ecbit.Input), {
                                                value: placeholders?.[key] ?? textParts?.[key] ?? selectedCampaign?.[key] ?? "",
                                                onChange: (e)=>setPlaceholders((prev)=>({
                                                            ...prev,
                                                            [key]: e.target.value
                                                        })),
                                                className: $d1074761a75a163a$var$inputStyle,
                                                style: $d1074761a75a163a$var$inputInlineStyle
                                            })
                                        }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pn182",
                                            children: key
                                        })
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fd1b321f28e3a258$export$ca7dc72f8299f9d5), {
                                audioUrl: s3Asset.data?.presignURL,
                                voiceId: selectedVoice.voiceId,
                                voices: voices.data,
                                model: model,
                                onModelChange: handleModelChange,
                                segments: templateAsset?.segments ?? [],
                                isInvalid: isInvalid,
                                text: hasTextParts ? undefined : text,
                                onTextChange: hasTextParts ? undefined : setText,
                                defaultSpeed: speed,
                                onSpeedChange: setSpeed,
                                defaultPitch: pitch,
                                onPitchChange: setPitch,
                                onGenerate: ({ text: text, voiceId: voiceId, voiceConfig: voiceConfig })=>{
                                    if (s3Asset.data?.presignURL) (0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).VOICEOVER_FRAGMENT_REGENERATED, {
                                        user: {
                                            email: user?.email
                                        },
                                        videoId: videoId,
                                        templateId: video.data?.templateId
                                    });
                                    handleGenerate({
                                        text: text,
                                        voiceId: voiceId,
                                        voiceConfig: voiceConfig
                                    });
                                },
                                onPreviewPlay: ()=>(0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).FRAGMENTED_AUDIO_PREVIEWED, {
                                        user: {
                                            email: user?.email
                                        },
                                        videoId: videoId,
                                        templateId: video.data?.templateId
                                    }),
                                onReady: handlePlayerReady,
                                isPending: isGeneratingSpeech,
                                isDisabled: fixPronunciation.isPending,
                                onVoiceSelect: setSelectedVoiceId,
                                maxCharacters: 650,
                                size: "XL",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $waxwa.ActionButtonGroup), {
                                    isQuiet: true,
                                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                        isDisabled: isGeneratingSpeech || fixPronunciation.isPending,
                                        onPress: handleFixPronounciation,
                                        children: [
                                            fixPronunciation.isPending ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                "aria-label": "Generating pronunciations",
                                                size: "S",
                                                staticColor: "auto",
                                                slot: "icon",
                                                isIndeterminate: true
                                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $689e79a6adf3716c$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Fix pronunciation"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    isInvalid && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $56df7bad94ab337a$export$64d954f58ddfdc47), {
                        errorMessage: errorMessage,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                            styles: " IJ182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                    children: "or"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                    variant: "secondary",
                                    onPress: handleRegenerateWithSpeed,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f15374bf21ad0dde$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Generate"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                    children: "with adjusted voice speed"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
var $ee7ce223742cf243$exports = {};
!function(e, t) {
    $ee7ce223742cf243$exports = t();
}("undefined" != typeof self ? self : $ee7ce223742cf243$exports, ()=>(()=>{
        "use strict";
        var e = {
            d: (t, n)=>{
                for(var r in n)e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
                    enumerable: !0,
                    get: n[r]
                });
            },
            o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t),
            r: (e)=>{
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            }
        }, t = {};
        function n(e) {
            return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, n(e);
        }
        function r(e) {
            return function(e) {
                if (Array.isArray(e)) return a(e);
            }(e) || function(e) {
                if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || function(e, t) {
                if (!e) return;
                if ("string" == typeof e) return a(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return a(e, t);
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function a(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
            return r;
        }
        function o(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
            for(var r = 0; r < t.length; r++){
                var a = t[r];
                a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, (o = a.key, i = void 0, i = function(e, t) {
                    if ("object" !== n(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var a = r.call(e, t || "default");
                        if ("object" !== n(a)) return a;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e);
                }(o, "string"), "symbol" === n(i) ? i : String(i)), a);
            }
            var o, i;
        }
        e.r(t), e.d(t, {
            default: ()=>u
        });
        var u = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = t.sampleRate;
                o(this, e), this._context = this._createContext(n), n || (n = this._context.sampleRate), this._sampleRate = n;
            }
            var t, n, a;
            return t = e, n = [
                {
                    key: "_createContext",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 44100;
                        return window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext, new AudioContext({
                            sampleRate: e
                        });
                    }
                },
                {
                    key: "context",
                    get: function() {
                        return this._context;
                    }
                },
                {
                    key: "fetchAudio",
                    value: async function() {
                        for(var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                        return await Promise.all(n.map(async function(t) {
                            var n;
                            return n = t instanceof File || t instanceof Blob ? await t.arrayBuffer() : await fetch(t).then(function(e) {
                                return e.headers.has("Content-Type") && !e.headers.get("Content-Type").includes("audio/") && console.warn("Crunker: Attempted to fetch an audio file, but its MIME type is `".concat(e.headers.get("Content-Type").split(";")[0], "`. We'll try and continue anyway. (file: \"").concat(t, '")')), e.arrayBuffer();
                            }), await e._context.decodeAudioData(n);
                        }));
                    }
                },
                {
                    key: "mergeAudio",
                    value: function(e) {
                        var t = this._context.createBuffer(this._maxNumberOfChannels(e), this._sampleRate * this._maxDuration(e), this._sampleRate);
                        return e.forEach(function(e) {
                            for(var n = 0; n < e.numberOfChannels; n++){
                                for(var r = t.getChannelData(n), a = e.getChannelData(n), o = e.getChannelData(n).length - 1; o >= 0; o--)r[o] += a[o];
                                t.getChannelData(n).set(r);
                            }
                        }), t;
                    }
                },
                {
                    key: "concatAudio",
                    value: function(e) {
                        var t = this._context.createBuffer(this._maxNumberOfChannels(e), this._totalLength(e), this._sampleRate), n = 0;
                        return e.forEach(function(e) {
                            for(var r = 0; r < e.numberOfChannels; r++)t.getChannelData(r).set(e.getChannelData(r), n);
                            n += e.length;
                        }), t;
                    }
                },
                {
                    key: "padAudio",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (0 === n) return e;
                        if (t < 0) throw new Error('Crunker: Parameter "padStart" in padAudio must be positive');
                        if (n < 0) throw new Error('Crunker: Parameter "seconds" in padAudio must be positive');
                        for(var r = this._context.createBuffer(e.numberOfChannels, Math.ceil(e.length + n * e.sampleRate), e.sampleRate), a = 0; a < e.numberOfChannels; a++){
                            var o = e.getChannelData(a);
                            r.getChannelData(a).set(o.subarray(0, Math.ceil(t * e.sampleRate) + 1), 0), r.getChannelData(a).set(o.subarray(Math.ceil(t * e.sampleRate) + 2, r.length + 1), Math.ceil((t + n) * e.sampleRate));
                        }
                        return r;
                    }
                },
                {
                    key: "sliceAudio",
                    value: function(e, t, n) {
                        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                        if (t >= n) throw new Error('Crunker: "start" time should be less than "end" time in sliceAudio method');
                        for(var o = Math.round((n - t) * this._sampleRate), i = Math.round(t * this._sampleRate), u = this._context.createBuffer(e.numberOfChannels, o, this._sampleRate), l = 0; l < e.numberOfChannels; l++)for(var s = e.getChannelData(l), f = u.getChannelData(l), c = 0; c < o; c++)f[c] = s[i + c], c < r * this._sampleRate && (f[c] *= c / (r * this._sampleRate)), c > o - a * this._sampleRate && (f[c] *= (o - c) / (a * this._sampleRate));
                        return u;
                    }
                },
                {
                    key: "play",
                    value: function(e) {
                        var t = this._context.createBufferSource();
                        return t.buffer = e, t.connect(this._context.destination), t.start(), t;
                    }
                },
                {
                    key: "export",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "audio/wav", n = this._interleave(e), r = this._writeHeaders(n, e.numberOfChannels, e.sampleRate), a = new Blob([
                            r
                        ], {
                            type: t
                        });
                        return {
                            blob: a,
                            url: this._renderURL(a),
                            element: this._renderAudioElement(a)
                        };
                    }
                },
                {
                    key: "download",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "crunker", n = document.createElement("a");
                        return n.style.display = "none", n.href = this._renderURL(e), n.download = "".concat(t, ".").concat(e.type.split("/")[1]), n.click(), n;
                    }
                },
                {
                    key: "notSupported",
                    value: function(e) {
                        return this._isSupported() ? void 0 : e();
                    }
                },
                {
                    key: "close",
                    value: function() {
                        return this._context.close(), this;
                    }
                },
                {
                    key: "_maxDuration",
                    value: function(e) {
                        return Math.max.apply(Math, r(e.map(function(e) {
                            return e.duration;
                        })));
                    }
                },
                {
                    key: "_maxNumberOfChannels",
                    value: function(e) {
                        return Math.max.apply(Math, r(e.map(function(e) {
                            return e.numberOfChannels;
                        })));
                    }
                },
                {
                    key: "_totalLength",
                    value: function(e) {
                        return e.map(function(e) {
                            return e.length;
                        }).reduce(function(e, t) {
                            return e + t;
                        }, 0);
                    }
                },
                {
                    key: "_isSupported",
                    value: function() {
                        return "AudioContext" in window || "webkitAudioContext" in window || "mozAudioContext" in window;
                    }
                },
                {
                    key: "_writeHeaders",
                    value: function(e, t, n) {
                        var r = 2 * t, a = 2 * e.length, o = 36 + a, i = new ArrayBuffer(8 + o), u = new DataView(i);
                        return this._writeString(u, 0, "RIFF"), u.setUint32(4, o, !0), this._writeString(u, 8, "WAVE"), this._writeString(u, 12, "fmt "), u.setUint32(16, 16, !0), u.setUint16(20, 1, !0), u.setUint16(22, t, !0), u.setUint32(24, n, !0), u.setUint32(28, n * r, !0), u.setUint16(32, r, !0), u.setUint16(34, 16, !0), this._writeString(u, 36, "data"), u.setUint32(40, a, !0), this._floatTo16BitPCM(u, e, 44);
                    }
                },
                {
                    key: "_floatTo16BitPCM",
                    value: function(e, t, n) {
                        for(var r = 0; r < t.length; r++, n += 2){
                            var a = Math.max(-1, Math.min(1, t[r]));
                            e.setInt16(n, a < 0 ? 32768 * a : 32767 * a, !0);
                        }
                        return e;
                    }
                },
                {
                    key: "_writeString",
                    value: function(e, t, n) {
                        for(var r = 0; r < n.length; r++)e.setUint8(t + r, n.charCodeAt(r));
                    }
                },
                {
                    key: "_interleave",
                    value: function(e) {
                        if (1 === e.numberOfChannels) return e.getChannelData(0);
                        for(var t = [], n = 0; n < e.numberOfChannels; n++)t.push(e.getChannelData(n));
                        for(var r = t.reduce(function(e, t) {
                            return e + t.length;
                        }, 0), a = new Float32Array(r), o = 0, i = 0; o < r;)t.forEach(function(e) {
                            a[o++] = e[i];
                        }), i++;
                        return a;
                    }
                },
                {
                    key: "_renderAudioElement",
                    value: function(e) {
                        var t = document.createElement("audio");
                        return t.controls = !0, t.src = this._renderURL(e), t;
                    }
                },
                {
                    key: "_renderURL",
                    value: function(e) {
                        return (window.URL || window.webkitURL).createObjectURL(e);
                    }
                }
            ], n && i(t.prototype, n), a && i(t, a), Object.defineProperty(t, "prototype", {
                writable: !1
            }), e;
        }();
        return t;
    })());



var $ittHc = parcelRequire("ittHc");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $208Op = parcelRequire("208Op");

var $j2JDe = parcelRequire("j2JDe");
var $bEes0 = parcelRequire("bEes0");

var $lhKAD = parcelRequire("lhKAD");

var $ikOQe = parcelRequire("ikOQe");

var $fL0wx = parcelRequire("fL0wx");
parcelRequire("dFfaH");
var $hpQib = parcelRequire("hpQib");
var $kvWIh = parcelRequire("kvWIh");

var $D7J7L = parcelRequire("D7J7L");

var $77tch = parcelRequire("77tch");


var $jBZxV = parcelRequire("jBZxV");



var $82YSg = parcelRequire("82YSg");

var $15xG7 = parcelRequire("15xG7");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $c8ca68bb4c148d98$var$$bb387f5afbf91e16$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M12.257 5H3.808l1.72-1.72c.293-.293.293-.767 0-1.06s-.768-.293-1.06 0L1.47 5.217c-.293.293-.293.767 0 1.06L4.466 9.28c.146.147.338.22.53.22s.384-.073.53-.22c.294-.292.294-.767.001-1.06L3.811 6.5h8.446c2.482 0 4.5 2.019 4.5 4.5s-2.018 4.5-4.5 4.5H8.52c-.415 0-.75.336-.75.75s.335.75.75.75h3.737c3.309 0 6-2.691 6-6s-2.691-6-6-6"
        })
    });
const $c8ca68bb4c148d98$var$$bb387f5afbf91e16$var$ForwardRef = (0, $eF4cA.forwardRef)($c8ca68bb4c148d98$var$$bb387f5afbf91e16$var$SvgComponent);
var $c8ca68bb4c148d98$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($c8ca68bb4c148d98$var$$bb387f5afbf91e16$var$ForwardRef);


const $772868ae45e107c4$var$crunker = new (0, (/*@__PURE__*/$parcel$interopDefault($ee7ce223742cf243$exports)))();
const $772868ae45e107c4$var$TranscriptSegment = ({ videoId: videoId, assetName: assetName, segment: segment, isSelected: isSelected, onPress: onPress, onDone: onDone, ref: ref })=>{
    const userProfile = (0, $fL0wx.useUserProfile)();
    const video = (0, $ikOQe.useVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const { updateAssets: updateAssets } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const templateAsset = template.data?.assets?.find((a)=>a.name === assetName);
    const audioVariation = template.data?.audioVariations?.find((v)=>v.referenceKey === assetName);
    const asset = video.data?.assets?.find((a)=>a.name === assetName) ?? {
        ...templateAsset,
        ...audioVariation
    };
    const selectedCampaign = video.data?.campaigns?.find((item)=>item.id === video.data?.selectedCampaignIds?.[0]);
    const defaultText = templateAsset?.text ?? audioVariation?.settings?.text ?? "";
    const hasTextParts = (0, $d1074761a75a163a$export$ca35df912b47239e)(defaultText).length > 0;
    const text = hasTextParts ? (0, $d1074761a75a163a$export$32c15f4ab4985540)(asset?.text ?? defaultText, {
        parts: asset?.parts,
        campaign: selectedCampaign
    }) : asset?.text ?? defaultText;
    const isModified = hasTextParts ? Object.entries(asset?.parts ?? {}).some(([key, value])=>value !== selectedCampaign?.[key]) : text !== defaultText;
    const [isEditing, setIsEditing] = (0, $eF4cA.useState)(false);
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    const { pressProps: pressProps } = (0, $bEes0.usePress)({
        onPress: ()=>onPress?.({
                segment: segment
            })
    });
    const handleReset = (defaultAsset)=>{
        updateAssets.mutate({
            assets: [
                defaultAsset
            ]
        });
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        ref: ref,
        ...(0, $lhKAD.mergeProps)(hoverProps, pressProps),
        className: function anonymous(props) {
            let rules = " ";
            rules += ' Yc182';
            rules += ' Xb182';
            rules += ' _2b182';
            rules += ' sd182';
            rules += ' _ta182';
            rules += ' Ub182';
            rules += ' qb182';
            rules += ' Sh182';
            rules += ' Rh182';
            rules += ' Tf182';
            rules += ' Qf182';
            rules += ' Js182';
            rules += ' Gs182';
            rules += ' Is182';
            rules += ' Hs182';
            rules += ' ob182';
            rules += ' nb182';
            rules += ' kb182';
            rules += ' jb182';
            if (props.isHovered) rules += ' _nLeasBb182';
            else rules += ' _nd182';
            if (props.isHovered) rules += ' gqlRAZb182';
            else rules += ' g9182';
            rules += ' _Mc182';
            if (props.isSelected) {
                if (props.isEditing) rules += ' ONqLR2b182';
                else if (props.isInvalid) rules += ' O9d4kQe182';
                else if (props.isSelected) rules += ' ONqLR2b182';
            } else if (props.isEditing) rules += ' Oj182';
            else if (props.isInvalid) rules += ' O3At3Td182';
            else rules += ' Oj182';
            rules += ' _Kb182';
            rules += ' _Lf182';
            rules += ' _Pc182';
            return rules;
        }({
            isHovered: isHovered,
            isInvalid: segment?.isInvalid,
            isEditing: isEditing,
            isSelected: isSelected
        }),
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                children: `${(0, $133e7baa0382ff89$export$e284421eae6e218)(segment?.start ?? 0)} - ${(0, $133e7baa0382ff89$export$e284421eae6e218)(segment?.end ?? 0)} `
            }),
            !isEditing && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 __Wc182 L2o5UE182",
                children: text
            }),
            !isEditing && segment?.isInvalid && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ub182 qb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pzM8ac182 Jv182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $82YSg.default), {
                        styles: " -_8sjo0b-tm182 Zl182 Fm182"
                    }),
                    segment?.errorMessage?.join(". ")
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5e0f375ff6d9a15c$export$439d29a4e110a164), {
                isHidden: !isEditing,
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    onKeyDown: (e)=>e.stopPropagation(),
                    onKeyUp: (e)=>e.stopPropagation(),
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d1074761a75a163a$export$3cea9fb9794152bb), {
                        videoId: videoId,
                        assetName: assetName,
                        selectedCampaign: selectedCampaign,
                        segments: asset?.segments ?? [],
                        editableScript: template
                    })
                })
            }),
            (isEditing || isHovered) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {}),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                staticColor: "auto",
                size: "S",
                styles: " _Pa182 Wt182 _zt182",
                children: [
                    isEditing && isModified && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        isQuiet: true,
                        isDisabled: updateAssets.isPending,
                        onPress: ()=>handleReset({
                                ...asset,
                                text: defaultText
                            }),
                        "aria-label": "Reset to default",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c8ca68bb4c148d98$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Reset to default"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        isQuiet: !isEditing,
                        onPress: ()=>{
                            const nextEditing = !isEditing;
                            setIsEditing(nextEditing);
                            if (nextEditing) (0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).VOICEOVER_FRAGMENT_EDIT, {
                                user: {
                                    email: userProfile?.email
                                },
                                videoId: videoId,
                                templateId: video.data?.templateId
                            });
                            else onDone?.({
                                assetName: assetName
                            });
                        },
                        "aria-label": isEditing ? "Done" : "Edit",
                        children: [
                            isEditing ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $72df7913f6af7862$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {}),
                            isEditing && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Done"
                            })
                        ]
                    })
                ]
            })
        ]
    }, asset.name);
};
const $772868ae45e107c4$export$3b651f8cf192f7f4 = ({ videoId: videoId, previewUrl: previewUrl })=>{
    const videoPlayerRef = (0, $eF4cA.useRef)(null);
    const waveformRef = (0, $eF4cA.useRef)(null);
    const transcriptsRef = (0, $eF4cA.useRef)([]);
    const userProfile = (0, $fL0wx.useUserProfile)();
    const video = (0, $ikOQe.useVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const [audioRefreshNonce, setAudioRefreshNonce] = (0, $eF4cA.useState)(0);
    const handleSegmentDone = (0, $eF4cA.useCallback)(()=>{
        setAudioRefreshNonce((nonce)=>nonce + 1);
    }, []);
    const templateAssets = template.data?.assets?.filter((asset)=>asset.type === "audio") ?? [];
    const audioAssets = (0, $eF4cA.useMemo)(()=>templateAssets?.map((templateAsset)=>video.data?.assets?.find((asset)=>asset.name === templateAsset.name)) ?? [], [
        templateAssets,
        video.data?.assets
    ]);
    const audioAssetsFingerprint = audioAssets.map((asset)=>`${asset?.filePath ?? ""}:${asset?.generatedAt ?? ""}`).join("|");
    const [...audioPresignQueries] = (0, $ittHc.useQueries)({
        queries: audioAssets.map((asset)=>({
                queryKey: [
                    "audioAssetPresignURL",
                    asset?.filePath,
                    asset?.generatedAt ?? 0,
                    audioRefreshNonce
                ],
                queryFn: ({ signal: signal })=>(0, $D7J7L.fetchPresignURL)(asset.filePath, {
                        signal: signal
                    }),
                enabled: !!asset?.filePath
            }))
    });
    const [...audioBuffers] = (0, $ittHc.useQueries)({
        queries: audioAssets.map((asset, index)=>{
            const generatedAt = asset?.generatedAt ?? 0;
            const presignURL = audioPresignQueries[index]?.data?.presignURL;
            return {
                queryKey: [
                    "audioBuffer",
                    asset?.filePath,
                    generatedAt,
                    audioRefreshNonce
                ],
                queryFn: async ({ signal: signal })=>{
                    const response = await fetch(presignURL, {
                        signal: signal,
                        cache: "no-store"
                    });
                    if (!response.ok) throw new Error(`Failed to fetch voiceover audio (${response.status})`);
                    const arrayBuffer = await response.arrayBuffer();
                    return arrayBuffer;
                },
                enabled: !!presignURL,
                retry: false
            };
        })
    });
    const audioBuffersReadyKey = audioBuffers.map((buffer)=>`${buffer.status}:${buffer.fetchStatus}:${buffer.dataUpdatedAt ?? 0}`).join("|");
    const [mergedAudioURL, setMergedAudioURL] = (0, $eF4cA.useState)(null);
    const mergedAudioURLRef = (0, $eF4cA.useRef)(null);
    const [segments, setSegments] = (0, $eF4cA.useState)([]);
    const [selectedSegmentIndex, setSelectedSegmentIndex] = (0, $eF4cA.useState)(null);
    const lastAudioAssetsFingerprintRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>()=>{
            if (mergedAudioURLRef.current) URL.revokeObjectURL(mergedAudioURLRef.current);
        }, []);
    (0, $eF4cA.useEffect)(()=>{
        if (lastAudioAssetsFingerprintRef.current === audioAssetsFingerprint) return;
        const isFirstRun = lastAudioAssetsFingerprintRef.current === null;
        lastAudioAssetsFingerprintRef.current = audioAssetsFingerprint;
        if (isFirstRun) return;
        if (mergedAudioURLRef.current) {
            URL.revokeObjectURL(mergedAudioURLRef.current);
            mergedAudioURLRef.current = null;
        }
        setMergedAudioURL(null);
    }, [
        audioAssetsFingerprint
    ]);
    (0, $eF4cA.useEffect)(()=>{
        (0, $eF4cA.startTransition)(async ()=>{
            if (!audioBuffers?.length) return;
            if (audioBuffers.some((buffer)=>buffer.isFetching)) return;
            try {
                const decodedBuffers = await Promise.all(audioBuffers.map(async (buffer)=>{
                    if (!buffer.data) return null;
                    try {
                        return await $772868ae45e107c4$var$crunker.context.decodeAudioData(buffer.data.slice(0));
                    } catch  {
                        return null;
                    }
                }));
                const _segments = templateAssets?.map((asset, index)=>{
                    const variation = template.data?.audioVariations?.find((audioVariation)=>audioVariation.referenceKey === asset.name);
                    const start = variation?.settings?.inset ?? 0;
                    const end = start + (variation?.settings?.duration ?? 0);
                    const buffer = decodedBuffers[index];
                    if (!buffer) {
                        if (!audioAssets[index]?.isRegenerated) return {
                            index: index,
                            label: variation?.label,
                            start: start,
                            end: end,
                            isInvalid: false,
                            errorMessage: null
                        };
                        return {
                            index: index,
                            label: variation?.label,
                            start: start,
                            end: end,
                            isInvalid: true,
                            errorMessage: [
                                "This voiceover segment hasn't been generated yet.",
                                "Generate it to continue."
                            ]
                        };
                    }
                    const { isInvalid: isInvalid, errorMessage: errorMessage } = (0, $d1074761a75a163a$export$ab28a3677dae0f8e)(buffer.duration, asset?.maxDuration, asset?.minDuration);
                    return {
                        index: index,
                        label: variation?.label,
                        start: start,
                        end: end,
                        isInvalid: isInvalid,
                        errorMessage: errorMessage
                    };
                });
                setSegments(_segments ?? []);
                const paddedBuffers = (await Promise.all(decodedBuffers.map(async (buffer, index)=>{
                    if (!buffer) return null;
                    const paddingStart = _segments?.[index]?.start ?? 0;
                    return paddingStart ? $772868ae45e107c4$var$crunker.padAudio(buffer, 0, paddingStart) : buffer;
                }))).filter(Boolean);
                if (mergedAudioURLRef.current) {
                    URL.revokeObjectURL(mergedAudioURLRef.current);
                    mergedAudioURLRef.current = null;
                }
                if (paddedBuffers.length === 0) {
                    setMergedAudioURL(null);
                    return;
                }
                const mergedAudioBuffer = await $772868ae45e107c4$var$crunker.mergeAudio(paddedBuffers);
                const mergedAudio = await $772868ae45e107c4$var$crunker.export(mergedAudioBuffer, "audio/wav");
                mergedAudioURLRef.current = mergedAudio.url;
                setMergedAudioURL(mergedAudio.url);
            } catch (error) {
                console.warn("Error merging audio buffers:", error);
            }
        });
    }, [
        audioBuffersReadyKey,
        audioAssetsFingerprint
    ]);
    const handleRegionPress = (0, $eF4cA.useCallback)(({ segment: segment, region: region, waveform: waveform })=>{
        // region.play(true);
        // waveform.play(region.start, region.end);
        // waveform.play(region.start);
        waveform.setTime(region.start);
    // transcriptsRef.current?.[segment.index]?.scrollIntoView({
    //   behavior: "smooth",
    //   block: "center",
    // });
    }, []);
    const handleRegionIn = (0, $eF4cA.useCallback)(({ segment: segment, region: region, waveform: waveform })=>{
        transcriptsRef.current?.[segment.index]?.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        setSelectedSegmentIndex(segment.index);
    }, []);
    const handleRegionOut = (0, $eF4cA.useCallback)(({ segment: segment, region: region, waveform: waveform })=>{
        setSelectedSegmentIndex((prev)=>prev === segment.index ? null : prev);
    }, []);
    const handleTranscriptSegmentPress = (0, $eF4cA.useCallback)(({ segment: segment })=>{
        waveformRef.current?.setTime(segment.start + 0.0001);
    }, []);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: " se182 CLgfHpc182 D53rtud182 EfQhdHc182 Uj182 qj182 Za182 Fb182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " zZKv3Id182 yZKv3Id182 BZKv3Id182 AZKv3Id182 sd182 _ta182 Uj182 qj182 F6x0Nod182 Th182 Qh182 _Pe182 WDUQwl182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 Ue182 qe182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " _Pc182 Za182 ob182 nb182 kb182 jb182 _Nc182 Pc182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
                                        ref: videoPlayerRef,
                                        filePath: previewUrl ?? undefined,
                                        muted: true,
                                        className: " sb182 fcJcitc182 Za182"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " _Pa182 _lr182 _Ar182 _zr182 Se182 Re182 Tt182 Qt182 g9teire182 _Ob182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Sample video preview \u2014 visuals for reference only"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " Tt182 Qt182 St182 Rt182 g_g182 ob182 nb182 kb182 jb182 _nLeasBb182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $133e7baa0382ff89$export$832cc5475f11d8b4), {
                                    ref: waveformRef,
                                    url: mergedAudioURL,
                                    segments: segments,
                                    videoRef: videoPlayerRef,
                                    onRegionPress: handleRegionPress,
                                    onRegionIn: handleRegionIn,
                                    // onRegionOut={handleRegionOut}
                                    onPreviewPlay: ()=>(0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).ENTIRE_AUDIO_PREVIEWED, {
                                            user: {
                                                email: userProfile?.email
                                            },
                                            videoId: video.data?.id,
                                            templateId: video.data?.templateId
                                        })
                                }, mergedAudioURL ?? "empty")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " z9nfjUc182 y9nfjUc182 B9nfjUc182 A9nfjUc182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " Za182 Fb182 Pa182 GR3sHn182",
                        children: templateAssets?.map((asset, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)($772868ae45e107c4$var$TranscriptSegment, {
                                ref: (ref)=>{
                                    transcriptsRef.current[idx] = ref;
                                },
                                videoId: video.data?.id,
                                assetName: asset.name,
                                segment: segments?.[idx],
                                isSelected: selectedSegmentIndex === idx,
                                onPress: handleTranscriptSegmentPress,
                                onDone: handleSegmentDone
                            }, asset.name))
                    })
                })
            ]
        })
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $KXDAG = parcelRequire("KXDAG");
var $7Vvqh = parcelRequire("7Vvqh");
var $c0XRK = parcelRequire("c0XRK");
var $fZShI = parcelRequire("fZShI");

var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");

var $77tch = parcelRequire("77tch");




var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $7cae4685ec7294aa$var$$2e2f80fba99c0659$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M58.355 40.065C63.548 28.3 74.992 20 88.43 20c17.478 0 31.545 13.98 32.954 31.468 13.808 2.669 24.036 15.462 24.036 30.012 0 15.805-11.646 29.025-26.808 30.404-2.2.2-4.145-1.422-4.345-3.622s1.421-4.146 3.621-4.346c10.799-.981 19.532-10.521 19.532-22.436 0-11.908-9.101-21.832-20.176-22.487-2.114-.125-3.764-1.876-3.764-3.993 0-.2.009-.39.014-.488v-.018l.006-.134C113.5 39.632 102.119 28 88.43 28c-11.046 0-20.568 7.56-23.857 18.246-.334 1.088-1.116 1.981-2.15 2.457s-2.22.49-3.265.037c-2.003-.87-4.192-1.35-6.498-1.35-9.348 0-17.21 7.963-17.21 18.15 0 1.393.17 2.776.469 4.15.448 2.062-.782 4.117-2.81 4.696-5.973 1.706-10.529 7.478-10.529 14.534 0 8.398 6.41 14.923 14.032 15.061q.166.003.33.019h4.438c2.21 0 4 1.791 4 4s-1.79 4-4 4h-4.84q-.263 0-.518-.033C23.96 111.505 14.58 101.231 14.58 88.92c0-9.242 5.263-17.299 12.984-20.963q-.113-1.186-.114-2.417c0-14.273 11.118-26.15 25.21-26.15 1.96 0 3.866.234 5.695.675M83.5 73.657l16.672 16.671c1.562 1.563 4.094 1.563 5.656 0 1.563-1.562 1.563-4.094 0-5.656l-23.5-23.5c-1.562-1.562-4.094-1.562-5.656 0l-23.5 23.5c-1.562 1.562-1.562 4.094 0 5.656 1.562 1.563 4.094 1.563 5.656 0L75.5 73.657V136c0 2.209 1.79 4 4 4s4-1.791 4-4z"
        })
    });
const $7cae4685ec7294aa$var$$2e2f80fba99c0659$var$ForwardRef = (0, $eF4cA.forwardRef)($7cae4685ec7294aa$var$$2e2f80fba99c0659$var$SvgComponent);
var $7cae4685ec7294aa$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($7cae4685ec7294aa$var$$2e2f80fba99c0659$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $95e9547a64538f4b$var$$b211eda84dd76f71$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M35.215 25.039C38.21 17.922 45.043 12.89 53.07 12.89c10.386 0 18.754 8.399 19.444 18.869 8.236 1.369 14.446 8.557 14.446 17.72 0 9.843-7.655 17.96-17.28 17.96h-.78c-1.105 0-2-.895-2-2s.895-2 2-2h.779c7.255 0 13.28-6.161 13.28-13.96 0-7.805-5.588-13.527-12.516-13.933-1.057-.062-1.883-.937-1.883-1.996v-.39c0-9.069-7.016-16.27-15.49-16.27-6.839 0-12.714 4.675-14.738 11.267-.167.544-.558.99-1.075 1.229-.517.238-1.11.245-1.632.019-1.257-.545-2.627-.845-4.075-.845-5.864 0-10.76 4.99-10.76 11.33 0 .884.101 1.735.29 2.567.235 1.036-.38 2.074-1.401 2.366-3.776 1.077-6.63 4.713-6.63 9.137 0 5.249 4.012 9.371 8.82 9.47h5.04c1.105 0 2 .895 2 2s-.895 2-2 2h-5.096c-7.144-.132-12.763-6.186-12.763-13.47 0-5.508 3.191-10.287 7.834-12.365q-.094-.837-.094-1.705c0-8.381 6.523-15.33 14.76-15.33 1.267 0 2.493.166 3.664.478M50 43.829l10.586 10.586c.78.78 2.047.78 2.828 0 .781-.781.781-2.048 0-2.829l-14-14c-.78-.78-2.047-.78-2.828 0l-14 14c-.781.781-.781 2.048 0 2.829.78.78 2.047.78 2.828 0L46 43.829v36.982c0 1.104.895 2 2 2s2-.896 2-2z"
        })
    });
const $95e9547a64538f4b$var$$b211eda84dd76f71$var$ForwardRef = (0, $eF4cA.forwardRef)($95e9547a64538f4b$var$$b211eda84dd76f71$var$SvgComponent);
var $95e9547a64538f4b$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($95e9547a64538f4b$var$$b211eda84dd76f71$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $9e0d3e82999c5a9f$var$$72ada17c2f4954c4$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M17.281 12.29c1.614-3.64 5.153-6.21 9.318-6.21 5.412 0 9.77 4.33 10.213 9.743 4.259.799 7.447 4.557 7.447 9.307 0 5.168-4.029 9.46-9.11 9.46h-.04c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25h.039c3.6 0 6.61-3.068 6.61-6.96 0-3.895-2.79-6.744-6.235-6.952-.66-.04-1.174-.587-1.174-1.248v-.199c0-4.552-3.521-8.15-7.75-8.15-3.414 0-6.353 2.335-7.376 5.639-.105.338-.348.616-.67.765-.322.148-.691.154-1.017.014-.624-.268-1.307-.419-2.007-.419-2.89 0-5.32 2.459-5.32 5.61 0 .436.05.866.14 1.281.142.645-.24 1.288-.875 1.47-1.851.533-3.255 2.313-3.255 4.49 0 2.592 1.975 4.606 4.32 4.65h2.39c.69 0 1.25.559 1.25 1.25 0 .69-.56 1.25-1.25 1.25h-2.4l-.02-.001c-3.811-.062-6.79-3.287-6.79-7.15 0-2.865 1.63-5.357 4.023-6.497q-.033-.368-.033-.743c0-4.429 3.449-8.11 7.82-8.11.601 0 1.19.074 1.752.21m7.969 10.728 4.866 4.866c.488.488 1.28.488 1.768 0s.488-1.28 0-1.768l-7-7c-.488-.488-1.28-.488-1.768 0l-7 7c-.488.488-.488 1.28 0 1.768s1.28.488 1.768 0l4.866-4.866V40.76c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25z"
        })
    });
const $9e0d3e82999c5a9f$var$$72ada17c2f4954c4$var$ForwardRef = (0, $eF4cA.forwardRef)($9e0d3e82999c5a9f$var$$72ada17c2f4954c4$var$SvgComponent);
var $9e0d3e82999c5a9f$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($9e0d3e82999c5a9f$var$$72ada17c2f4954c4$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5cb67e349b03860e$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $7cae4685ec7294aa$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $9e0d3e82999c5a9f$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $95e9547a64538f4b$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $0025d0fdccbcde07$var$ACCEPTED_AUDIO_TYPES = [
    "audio/wav",
    "audio/mpeg",
    "audio/mp3"
];
const $0025d0fdccbcde07$var$AUDIO_TYPE_OVERRIDES = {
    "audio/mpeg": "audio/mp3"
};
const $0025d0fdccbcde07$var$normalizeAudioFile = (file)=>{
    const overrideType = $0025d0fdccbcde07$var$AUDIO_TYPE_OVERRIDES[file?.type];
    if (!overrideType) return file;
    return new File([
        file
    ], file.name, {
        type: overrideType,
        lastModified: file.lastModified
    });
};
const $0025d0fdccbcde07$export$3739690d51777e3 = "upload";
const $0025d0fdccbcde07$export$a2fd4a4d4c54d2a1 = "uploaded-voiceover";
const $0025d0fdccbcde07$export$f3b30874829cfd0c = ({ videoId: videoId, file: file, onFileChange: onFileChange })=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const { uploadAssets: uploadAssets } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const templateAssets = template.data?.assets?.filter((asset)=>asset.type === "audio");
    const audioVariations = templateAssets?.map((asset)=>template.data?.audioVariations?.find((audioVariation)=>audioVariation.referenceKey === asset.name))?.filter(Boolean) ?? [];
    const maxDuration = audioVariations.reduce((max, asset)=>{
        return (asset?.settings?.inset ?? 0) + (asset?.settings?.duration ?? 0) > max ? (asset?.settings?.inset ?? 0) + (asset?.settings?.duration ?? 0) : max;
    }, 0);
    const [error, setError] = (0, $eF4cA.useState)(null);
    const [isUploading, setIsUploading] = (0, $eF4cA.useState)(false);
    const audioUrl = (0, $eF4cA.useMemo)(()=>file ? URL.createObjectURL(file) : null, [
        file
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!audioUrl) return;
        return ()=>URL.revokeObjectURL(audioUrl);
    }, [
        audioUrl
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!file) setError(null);
    }, [
        file
    ]);
    const uploadedAsset = video.data?.assets?.find((a)=>a.name === $0025d0fdccbcde07$export$a2fd4a4d4c54d2a1);
    const uploadedAssetPresign = (0, $a8sj2.usePresignURL)(uploadedAsset?.filePath);
    const hasUpload = !!file || !!uploadedAsset;
    const playerUrl = file ? audioUrl : uploadedAssetPresign.data?.presignURL;
    const isLoadingExisting = !file && !!uploadedAsset && !uploadedAssetPresign.data?.presignURL;
    const handleAudioReady = (waveform)=>{
        const duration = (0, $133e7baa0382ff89$export$88a5fd9752ff366c)(waveform);
        if (duration > (0, $d1074761a75a163a$export$f033fe09bfbbeb73)(maxDuration)) setError([
            `Audio is too long. Please upload an audio that is about ${(0, $133e7baa0382ff89$export$e284421eae6e218)(maxDuration)} minutes long.`
        ]);
        else if (duration < (0, $d1074761a75a163a$export$9e87bc6c16545701)(maxDuration)) setError([
            `Audio is too short. Please upload an audio that is about ${(0, $133e7baa0382ff89$export$e284421eae6e218)(maxDuration)} minutes long.`
        ]);
        else setError(null);
    };
    const handleFile = async (selectedFile)=>{
        onFileChange?.(selectedFile);
        if (!selectedFile) return;
        setError(null);
        setIsUploading(true);
        try {
            await uploadAssets.mutateAsync({
                assets: [
                    {
                        name: $0025d0fdccbcde07$export$a2fd4a4d4c54d2a1,
                        type: "audio",
                        blob: $0025d0fdccbcde07$var$normalizeAudioFile(selectedFile),
                        generatedAt: Date.now()
                    }
                ]
            });
        } catch (e) {
            setError([
                "Failed to upload audio. Please try again."
            ]);
        } finally{
            setIsUploading(false);
        }
    };
    const handleDrop = async (event)=>{
        let item = event.items.find((item)=>item.kind === "file" && $0025d0fdccbcde07$var$ACCEPTED_AUDIO_TYPES.includes(item.type));
        if (item?.kind === "file") {
            let file = await item.getFile();
            handleFile(file);
        }
    };
    const handleFileSelect = (files)=>{
        if (!files) return;
        handleFile(files[0]);
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $KXDAG.DropZone), {
                styles: " Lq63t7c182 Za182 IM182 HM182",
                isFilled: hasUpload,
                getDropOperation: (types)=>$0025d0fdccbcde07$var$ACCEPTED_AUDIO_TYPES.some((t)=>types.has(t)) ? "copy" : "cancel",
                onDrop: handleDrop,
                children: hasUpload ? isUploading || isLoadingExisting || !playerUrl ? /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 eb182 _Ca182 Ug182 qg182 Tf182 Qf182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                            "aria-label": isUploading ? "Uploading audio" : "Loading audio",
                            isIndeterminate: true,
                            size: "S"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: isUploading ? "Uploading audio\u2026" : "Loading audio\u2026"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $133e7baa0382ff89$export$832cc5475f11d8b4), {
                    url: playerUrl,
                    onReady: handleAudioReady
                }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5cb67e349b03860e$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                            children: "Drag and drop your file"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                            children: "Or, select a file from your computer"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                                acceptedFileTypes: $0025d0fdccbcde07$var$ACCEPTED_AUDIO_TYPES,
                                onSelect: handleFileSelect,
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                    variant: "accent",
                                    children: "Browse files"
                                })
                            })
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $56df7bad94ab337a$export$64d954f58ddfdc47), {
                errorMessage: error
            })
        ]
    });
};




var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $63e54e09219f64d3$var$$4bb0a5cb72e4fdd4$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M84 22.568c0-2.209-1.79-4-4-4s-4 1.791-4 4v114.863c0 2.209 1.791 4 4 4s4-1.791 4-4zM28.25 67.33c2.21 0 4 1.79 4 4v17.341c0 2.21-1.79 4-4 4s-4-1.79-4-4v-17.34c0-2.21 1.79-4 4-4m103.5 0c2.209 0 4 1.79 4 4v17.341c0 2.21-1.791 4-4 4s-4-1.79-4-4v-17.34c0-2.21 1.791-4 4-4m-69-20.898c2.21 0 4 1.79 4 4v59.137c0 2.209-1.79 4-4 4s-4-1.791-4-4V50.432c0-2.21 1.79-4 4-4m38.5 4c0-2.21-1.79-4-4-4s-4 1.79-4 4v59.137c0 2.209 1.79 4 4 4s4-1.791 4-4zM45.5 32.512c2.209 0 4 1.79 4 4v86.976c0 2.209-1.791 4-4 4s-4-1.791-4-4V36.512c0-2.21 1.79-4 4-4m73 4c0-2.21-1.791-4-4-4s-4 1.79-4 4v86.976c0 2.209 1.79 4 4 4s4-1.791 4-4z"
        })
    });
const $63e54e09219f64d3$var$$4bb0a5cb72e4fdd4$var$ForwardRef = (0, $eF4cA.forwardRef)($63e54e09219f64d3$var$$4bb0a5cb72e4fdd4$var$SvgComponent);
var $63e54e09219f64d3$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($63e54e09219f64d3$var$$4bb0a5cb72e4fdd4$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $64cc18b257d7fc1e$var$$38e43f25cc6fd001$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M50 14.984c0-1.104-.896-2-2-2s-2 .896-2 2v66.032c0 1.104.895 2 2 2s2-.896 2-2zM18.25 41.016c1.105 0 2 .895 2 2v9.968c0 1.105-.895 2-2 2s-2-.895-2-2v-9.968c0-1.105.895-2 2-2m59.499 0c1.105 0 2 .895 2 2v9.968c0 1.105-.895 2-2 2s-2-.895-2-2v-9.968c0-1.105.895-2 2-2M38.083 29.002c1.105 0 2 .895 2 2v33.996c0 1.105-.895 2-2 2s-2-.895-2-2V31.002c0-1.105.895-2 2-2m21.833 2c0-1.105-.895-2-2-2s-2 .895-2 2v33.996c0 1.105.895 2 2 2s2-.895 2-2zM28.166 21c1.105 0 2 .895 2 2v50c0 1.105-.895 2-2 2s-2-.895-2-2V23c0-1.105.896-2 2-2m41.667 2c0-1.105-.896-2-2-2s-2 .895-2 2v50c0 1.105.895 2 2 2s2-.895 2-2z"
        })
    });
const $64cc18b257d7fc1e$var$$38e43f25cc6fd001$var$ForwardRef = (0, $eF4cA.forwardRef)($64cc18b257d7fc1e$var$$38e43f25cc6fd001$var$SvgComponent);
var $64cc18b257d7fc1e$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($64cc18b257d7fc1e$var$$38e43f25cc6fd001$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $5d04a7d9794489e8$var$$f8ebd9a1f7109682$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M25.25 7.492c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v33.016c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25zM9.125 20.258c.69 0 1.25.56 1.25 1.25v4.984c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-4.984c0-.69.56-1.25 1.25-1.25m29.75 0c.69 0 1.25.56 1.25 1.25v4.984c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-4.984c0-.69.56-1.25 1.25-1.25M19.042 14.25c.69 0 1.25.56 1.25 1.25v16.998c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25V15.501c0-.69.56-1.25 1.25-1.25m11.166 1.25c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v16.998c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25zM14.084 10.25c.69 0 1.25.56 1.25 1.25v25c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25v-25c0-.69.56-1.25 1.25-1.25m21.083 1.25c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v25c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25z"
        })
    });
const $5d04a7d9794489e8$var$$f8ebd9a1f7109682$var$ForwardRef = (0, $eF4cA.forwardRef)($5d04a7d9794489e8$var$$f8ebd9a1f7109682$var$SvgComponent);
var $5d04a7d9794489e8$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($5d04a7d9794489e8$var$$f8ebd9a1f7109682$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $582f5bb145477570$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $63e54e09219f64d3$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $5d04a7d9794489e8$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $64cc18b257d7fc1e$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $69f3c495a707b104$var$$4915650eb5e57dd7$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M29.065 23.36c-1.562-1.563-4.095-1.563-5.657 0-1.562 1.561-1.562 4.094 0 5.656l107.526 107.526c1.562 1.562 4.095 1.562 5.657 0s1.562-4.095 0-5.657zm6.31 49.913c0 23.181 17.781 42.209 40.448 44.19v12.35H56.28c-2.209 0-4 1.79-4 4s1.791 4 4 4h47.086c2.209 0 4-1.791 4-4s-1.791-4-4-4H83.823v-12.368c2.327-.21 5.19-.64 8.24-1.504 2.126-.603 3.36-2.814 2.758-4.939s-2.814-3.361-4.939-2.758c-4.3 1.218-8.211 1.389-10.147 1.389-20.08 0-36.36-16.279-36.36-36.36V68.23c0-2.21-1.79-4-4-4s-4 1.79-4 4zm21.804-34.89C59.786 31.1 66.437 22.24 79.823 22.24c9.262 0 15.47 4.223 19.233 9.451 3.623 5.036 4.946 10.927 4.946 14.755v.03c-.06 8.063-.016 21.9-.003 26.105v.006l.003 1.212c0 1.859-.283 3.66-.714 5.325-.555 2.138-2.738 3.422-4.876 2.867-2.139-.554-3.423-2.737-2.868-4.876.296-1.141.458-2.26.458-3.316L96 72.691v-.003c-.013-4.068-.057-18.103.003-26.256-.003-2.348-.91-6.55-3.44-10.068-2.397-3.33-6.278-6.124-12.74-6.124-8.9 0-13.219 5.553-15.11 10.839-.745 2.08-3.035 3.162-5.115 2.417-2.08-.744-3.162-3.034-2.418-5.114m8.579 42.874c-1.121-1.904-3.573-2.538-5.477-1.416-1.903 1.121-2.537 3.573-1.416 5.477 2.013 3.415 5.017 6.699 8.88 8.968 1.905 1.12 4.356.482 5.475-1.422 1.12-1.905.483-4.356-1.422-5.475-2.546-1.496-4.627-3.734-6.04-6.132m58.424-13.029c0-2.209-1.791-4-4-4s-4 1.791-4 4c0 12.663-1.706 18.394-4.697 23.145-1.177 1.87-.615 4.34 1.254 5.516 1.87 1.177 4.339.615 5.516-1.254 4.125-6.553 5.927-14.007 5.927-27.407"
        })
    });
const $69f3c495a707b104$var$$4915650eb5e57dd7$var$ForwardRef = (0, $eF4cA.forwardRef)($69f3c495a707b104$var$$4915650eb5e57dd7$var$SvgComponent);
var $69f3c495a707b104$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($69f3c495a707b104$var$$4915650eb5e57dd7$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $c4594ec3477ee057$var$$a9d69aa95db07d6b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 97,
        height: 96,
        viewBox: "0 0 97 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M38.525 18.239c2.227-2.432 5.517-4.223 10.071-4.223 5.375 0 8.957 2.443 11.13 5.462 2.103 2.923 2.87 6.347 2.87 8.553v.015c-.036 4.801-.01 13.044-.002 15.535v.047l.002.669c0 2.009-.576 3.939-1.267 5.51-.445 1.01-1.625 1.469-2.636 1.024s-1.47-1.626-1.025-2.637c.552-1.253.928-2.62.928-3.897l-.002-.664c-.008-2.423-.034-10.764.002-15.609-.002-1.466-.56-4.046-2.117-6.21-1.49-2.07-3.908-3.798-7.883-3.798-3.385 0-5.619 1.284-7.12 2.924-1.553 1.697-2.392 3.86-2.72 5.589-.206 1.085-1.253 1.797-2.338 1.591s-1.798-1.253-1.592-2.338c.43-2.26 1.524-5.167 3.7-7.543m-20.388-3.638c-.781-.78-2.047-.78-2.829 0-.78.781-.78 2.048 0 2.829L79.25 81.37c.78.781 2.047.781 2.828 0s.781-2.047 0-2.828zm4.407 29.383c0 13.705 10.603 24.932 24.052 25.928v8.072h-12c-1.104 0-2 .896-2 2s.896 2 2 2h28c1.105 0 2-.895 2-2s-.895-2-2-2h-12v-8.08c1.957-.153 4.664-.57 7.426-1.676 1.026-.41 1.525-1.574 1.115-2.6-.41-1.025-1.575-1.524-2.6-1.114-3.273 1.31-6.532 1.47-7.993 1.47-12.15 0-22-9.85-22-22v-3c0-1.104-.896-2-2-2s-2 .896-2 2zm16.183 1.644c-.11-1.099-1.09-1.9-2.19-1.79s-1.9 1.09-1.79 2.19c.245 2.437 1.523 5.162 3.492 7.355 1.992 2.218 4.832 4.048 8.326 4.433 1.098.121 2.086-.67 2.207-1.769.12-1.098-.671-2.086-1.77-2.207-2.318-.255-4.306-1.48-5.787-3.13-1.503-1.674-2.342-3.629-2.488-5.082m35.87-4.644c0-1.104-.896-2-2-2s-2 .896-2 2c0 4.435-.351 7.45-1 9.769-.635 2.273-1.58 3.96-2.907 5.71-.667.88-.495 2.135.385 2.803.88.667 2.135.494 2.802-.386 1.564-2.062 2.775-4.195 3.573-7.05.786-2.812 1.146-6.233 1.146-10.846"
        })
    });
const $c4594ec3477ee057$var$$a9d69aa95db07d6b$var$ForwardRef = (0, $eF4cA.forwardRef)($c4594ec3477ee057$var$$a9d69aa95db07d6b$var$SvgComponent);
var $c4594ec3477ee057$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($c4594ec3477ee057$var$$a9d69aa95db07d6b$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $4ab2c9ebe92cade0$var$$4c6c8ede0ccee16d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M8.93 7.147c-.487-.488-1.279-.488-1.767 0-.488.489-.488 1.28 0 1.768l31.908 31.908c.488.489 1.28.489 1.768 0 .488-.488.488-1.28 0-1.767zm1.766 14.857c0 6.892 5.272 12.553 12.002 13.17v3.545h-5.736c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h13.973c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25h-5.737v-3.55c.816-.076 1.845-.245 2.922-.604.655-.218 1.01-.926.79-1.58-.217-.656-.925-1.01-1.58-.791-1.423.474-2.77.536-3.407.536-5.924 0-10.727-4.802-10.727-10.726v-1.497c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25zM19.07 8.648c1.15-1.094 2.759-1.851 4.88-1.851 2.77 0 4.631 1.264 5.758 2.83 1.084 1.507 1.48 3.268 1.48 4.416v.01c-.018 2.392-.005 6.5 0 7.746v.36c0 .788-.169 1.543-.398 2.202-.226.652-.939.997-1.59.77-.653-.226-.998-.938-.771-1.59.163-.471.26-.944.26-1.381l-.002-.328c-.004-1.205-.017-5.373.001-7.793-.001-.686-.267-1.92-1.009-2.951-.7-.974-1.834-1.791-3.73-1.791-1.471 0-2.465.505-3.156 1.162-.716.682-1.162 1.583-1.394 2.406-.187.665-.878 1.052-1.542.865-.665-.187-1.052-.878-.864-1.542.318-1.132.953-2.47 2.077-3.54m.368 14.855c-.226-.652-.938-.998-1.59-.772s-.998.938-.772 1.59c.634 1.828 2.259 3.843 4.637 4.585.659.206 1.36-.162 1.565-.821.206-.659-.162-1.36-.82-1.565-1.48-.462-2.593-1.788-3.02-3.017m17.739-2.996c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25c0 4.015-.578 5.68-1.6 7.16-.391.567-.249 1.346.32 1.738.568.392 1.346.25 1.738-.319 1.418-2.053 2.041-4.287 2.041-8.58"
        })
    });
const $4ab2c9ebe92cade0$var$$4c6c8ede0ccee16d$var$ForwardRef = (0, $eF4cA.forwardRef)($4ab2c9ebe92cade0$var$$4c6c8ede0ccee16d$var$SvgComponent);
var $4ab2c9ebe92cade0$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($4ab2c9ebe92cade0$var$$4c6c8ede0ccee16d$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $77276a99cc7f2047$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $69f3c495a707b104$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $4ab2c9ebe92cade0$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $c4594ec3477ee057$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}



var $dm5H1 = parcelRequire("dm5H1");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $92e8d75d3d37da74$var$$4e58d8502c5dddc0$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M24.23 40.268c0-8.837 7.164-16 16-16h15.338c8.836 0 16 7.163 16 16v15.337c0 8.837-7.164 16-16 16H40.23c-8.837 0-16-7.163-16-16zm16-8c-4.418 0-8 3.581-8 8v15.337c0 4.418 3.582 8 8 8h15.338c4.418 0 8-3.582 8-8V40.268c0-4.419-3.582-8-8-8zM91.974 26.2c-2.207-.075-4.058 1.654-4.133 3.862s1.654 4.058 3.862 4.133c4.874.165 9.865 1.57 13.628 5.21 3.247 3.141 6.031 8.386 6.675 17.199l-6.177-6.178c-1.562-1.562-4.095-1.562-5.657 0s-1.562 4.095 0 5.657l12.424 12.424c1.562 1.562 4.095 1.562 5.657 0l12.464-12.464c1.562-1.562 1.562-4.095 0-5.657s-4.095-1.562-5.657 0l-5.116 5.117c-.829-10.013-4.146-17.102-9.051-21.848-5.645-5.46-12.808-7.248-18.919-7.455M47.244 91.493c-1.562-1.562-4.094-1.562-5.657 0l-12.464 12.464c-1.562 1.562-1.562 4.095 0 5.657s4.095 1.562 5.657 0l5.116-5.116c.829 10.012 4.146 17.101 9.05 21.847 5.645 5.461 12.809 7.248 18.92 7.455 2.207.075 4.058-1.654 4.133-3.862s-1.655-4.058-3.862-4.133c-4.874-.165-9.865-1.57-13.628-5.21-3.247-3.141-6.032-8.387-6.676-17.199l6.179 6.178c1.562 1.562 4.094 1.562 5.656 0s1.562-4.095 0-5.657zm57.188-3.097c-8.836 0-16 7.163-16 16v15.337c0 8.836 7.164 16 16 16h15.338c8.836 0 16-7.164 16-16v-15.337c0-8.837-7.164-16-16-16zm-8 16c0-4.419 3.582-8 8-8h15.338c4.418 0 8 3.581 8 8v15.337c0 4.418-3.582 8-8 8h-15.338c-4.418 0-8-3.582-8-8z"
        })
    });
const $92e8d75d3d37da74$var$$4e58d8502c5dddc0$var$ForwardRef = (0, $eF4cA.forwardRef)($92e8d75d3d37da74$var$$4e58d8502c5dddc0$var$SvgComponent);
var $92e8d75d3d37da74$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($92e8d75d3d37da74$var$$4e58d8502c5dddc0$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $970b7e1d4088bb73$var$$cfb184157f360d43$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M16.229 24.25c0-4.418 3.581-8 8-8H34.85c4.419 0 8 3.582 8 8v10.622c0 4.418-3.581 8-8 8H24.228c-4.418 0-8-3.582-8-8zm8-4c-2.21 0-4 1.79-4 4v10.622c0 2.209 1.79 4 4 4H34.85c2.21 0 4-1.791 4-4V24.25c0-2.21-1.79-4-4-4zm30.646-2.889c-1.104-.037-2.03.828-2.067 1.932s.828 2.029 1.931 2.066c2.85.097 5.801.919 8.036 3.08 2.03 1.965 3.718 5.278 3.976 10.878l-4.111-4.111c-.781-.781-2.047-.781-2.828 0-.781.78-.781 2.047 0 2.828l7.144 7.145c.781.78 2.048.78 2.829 0l7.167-7.168c.781-.781.781-2.047 0-2.828-.78-.781-2.047-.781-2.828 0l-3.407 3.406c-.378-6.05-2.3-10.257-5.161-13.024-3.176-3.072-7.213-4.086-10.681-4.204M28.95 54.822c-.781-.78-2.048-.78-2.829 0l-7.167 7.168c-.781.781-.781 2.048 0 2.829.78.78 2.047.78 2.828 0l3.406-3.407c.378 6.051 2.302 10.257 5.162 13.024 3.175 3.072 7.213 4.086 10.68 4.203 1.105.038 2.03-.827 2.068-1.93.037-1.105-.828-2.03-1.932-2.067-2.849-.097-5.8-.919-8.035-3.08-2.03-1.965-3.718-5.278-3.977-10.878l4.112 4.111c.781.782 2.047.782 2.828 0 .782-.78.782-2.047 0-2.828zm32.198-1.693c-4.418 0-8 3.582-8 8V71.75c0 4.418 3.582 8 8 8H71.77c4.418 0 8-3.582 8-8V61.128c0-4.418-3.582-8-8-8zm-4 8c0-2.21 1.79-4 4-4H71.77c2.209 0 4 1.79 4 4V71.75c0 2.209-1.791 4-4 4H61.149c-2.21 0-4-1.791-4-4z"
        })
    });
const $970b7e1d4088bb73$var$$cfb184157f360d43$var$ForwardRef = (0, $eF4cA.forwardRef)($970b7e1d4088bb73$var$$cfb184157f360d43$var$SvgComponent);
var $970b7e1d4088bb73$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($970b7e1d4088bb73$var$$cfb184157f360d43$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $9d68a1f44c8f61c0$var$$5f4c475b7cbaf895$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M7.863 12.125c0-2.347 1.903-4.25 4.25-4.25h5.311c2.347 0 4.25 1.903 4.25 4.25v5.31c0 2.348-1.903 4.25-4.25 4.25h-5.31c-2.348 0-4.25-1.902-4.25-4.25zm4.25-1.75c-.966 0-1.75.784-1.75 1.75v5.31c0 .967.784 1.75 1.75 1.75h5.311c.967 0 1.75-.783 1.75-1.75v-5.31c0-.966-.783-1.75-1.75-1.75zm15.332-1.944c-.69-.023-1.268.517-1.291 1.207-.024.69.517 1.269 1.206 1.292 1.387.047 2.794.446 3.853 1.47.879.85 1.647 2.258 1.867 4.61l-1.584-1.584c-.488-.488-1.28-.488-1.768 0-.488.489-.488 1.28 0 1.768l3.573 3.573c.488.488 1.28.488 1.767 0l3.584-3.584c.488-.488.488-1.28 0-1.768s-1.28-.488-1.767 0l-1.32 1.32c-.27-2.785-1.218-4.78-2.614-6.132-1.646-1.593-3.733-2.112-5.506-2.172M14.652 27.234c-.488-.488-1.28-.488-1.768 0L9.3 30.818c-.488.488-.488 1.28 0 1.768s1.28.488 1.768 0l1.32-1.32c.268 2.785 1.217 4.78 2.613 6.132 1.647 1.593 3.734 2.111 5.506 2.172.69.023 1.268-.517 1.292-1.207.023-.69-.517-1.269-1.207-1.292-1.386-.047-2.794-.446-3.853-1.47-.878-.85-1.647-2.258-1.867-4.61l1.584 1.584c.488.488 1.28.488 1.768 0 .488-.489.488-1.28 0-1.768zm15.922-.92c-2.347 0-4.25 1.903-4.25 4.25v5.311c0 2.348 1.902 4.25 4.25 4.25h5.31c2.348 0 4.25-1.903 4.25-4.25v-5.31c0-2.348-1.902-4.25-4.25-4.25zm-1.75 4.25c0-.966.783-1.75 1.75-1.75h5.31c.967 0 1.75.784 1.75 1.75v5.311c0 .967-.783 1.75-1.75 1.75h-5.31c-.967 0-1.75-.783-1.75-1.75z"
        })
    });
const $9d68a1f44c8f61c0$var$$5f4c475b7cbaf895$var$ForwardRef = (0, $eF4cA.forwardRef)($9d68a1f44c8f61c0$var$$5f4c475b7cbaf895$var$SvgComponent);
var $9d68a1f44c8f61c0$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($9d68a1f44c8f61c0$var$$5f4c475b7cbaf895$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $094548f1328296b4$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $92e8d75d3d37da74$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $9d68a1f44c8f61c0$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $970b7e1d4088bb73$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}




var $klXmP = parcelRequire("klXmP");

var $i8elj = parcelRequire("i8elj");
const $be90f5e41d3f443a$export$16012be60f05d346 = {
    ORIGINAL: "original",
    EDIT: "edit",
    UPLOAD: "upload",
    NONE: "none"
};
const $be90f5e41d3f443a$export$ab5c0107fb2075da = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel })=>{
    const { videoId: videoId, video: video, template: template, updateVideo: updateVideo, uploadAssets: uploadAssets, updateAssets: updateAssets, stepActionCtx: stepActionCtx } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const queryClient = (0, $7ClmI.useQueryClient)();
    const userProfile = (0, $fL0wx.useUserProfile)();
    const audioMux = (0, $4230475195755126$export$e53ae5d2f8687049)();
    const voiceoverPreviewUrl = (0, $a8sj2.usePresignURL)(template.data?.voiceoverPreviewUrl);
    const customizeRef = (0, $eF4cA.useRef)(null);
    const didMountRef = (0, $eF4cA.useRef)(false);
    const [uploadedVoiceoverFile, setUploadedVoiceoverFile] = (0, $eF4cA.useState)(null);
    const [_hasCustomizedVoiceover, setHasCustomizedVoiceover] = (0, $eF4cA.useState)();
    const hasCustomizedVoiceover = _hasCustomizedVoiceover ?? (!!video.data?.voiceoverMode ? video.data?.voiceoverMode !== $be90f5e41d3f443a$export$16012be60f05d346.ORIGINAL : false);
    (0, $eF4cA.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (hasCustomizedVoiceover) customizeRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, [
        hasCustomizedVoiceover
    ]);
    const [_selectedKeys, setSelectedKeys] = (0, $eF4cA.useState)(new Set());
    const selectedKeys = _selectedKeys.size ? _selectedKeys : video.data?.voiceoverMode ? new Set([
        video.data?.voiceoverMode
    ]) : new Set();
    const templateAssets = template.data?.assets?.filter((asset)=>asset.type === "audio");
    const audioAssets = templateAssets?.map((templateAsset)=>video.data?.assets?.find((asset)=>asset.name === templateAsset.name))?.filter(Boolean) ?? [];
    const selectedCampaign = video.data?.campaigns?.find((item)=>item.id === video.data?.selectedCampaignIds?.[0]);
    const areAllAudioAssetsSelected = ((templateAssets?.length ?? 0) > 0 && templateAssets.every((asset)=>video.data?.assets?.some((a)=>a.name === asset.name && !a.isInvalid))) ?? false;
    const audioVariations = template.data?.audioVariations;
    const describeMogrtTemplate = (0, $iMKxE.useDescribeMogrtTemplate)(video.data?.mogrtRootPath, {
        enabled: hasCustomizedVoiceover && !!video.data?.mogrtRootPath && video.data?.templateType === "mogrt"
    });
    const musicPath = video.data?.musicPath ?? describeMogrtTemplate.data?.musicPath ?? "";
    const noVoMusicPath = describeMogrtTemplate.data?.musicNoVoPath ?? musicPath;
    const existingMuxAsset = video.data?.assets?.find((a)=>a.name === audioVariations?.[0]?.key);
    const isUpload = selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.UPLOAD);
    const uploadedRawAsset = video.data?.assets?.find((a)=>a.name === (0, $0025d0fdccbcde07$export$a2fd4a4d4c54d2a1));
    const uploadMuxKey = isUpload && uploadedRawAsset?.filePath ? `${0, $0025d0fdccbcde07$export$3739690d51777e3}:${uploadedRawAsset.filePath}:${uploadedRawAsset.generatedAt ?? 0}:${musicPath}` : null;
    const isUploadMuxReady = !!uploadMuxKey && existingMuxAsset?.muxSourceKey === uploadMuxKey;
    const isEdit = selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.EDIT);
    const uploadMuxKickedRef = (0, $eF4cA.useRef)(null);
    const runMusicOnlyMux = async ()=>{
        if (!audioVariations?.length || !noVoMusicPath) return;
        const muxKey = `none:${noVoMusicPath}`;
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        const existing = videoData?.assets?.find((a)=>a.name === audioVariations[0]?.key);
        if (existing?.muxSourceKey === muxKey) return;
        try {
            const outputDuration = audioVariations.reduce((max, v)=>Math.max(max, (v.settings?.inset ?? 0) + (v.settings?.duration ?? 0)), 0) + 5;
            const first = audioVariations[0];
            const firstSettings = first?.settings ?? {};
            await updateAssets.mutateAsync({
                assets: [
                    {
                        name: first.key,
                        type: first.type,
                        filePath: noVoMusicPath,
                        referenceKey: first.referenceKey,
                        volume: firstSettings.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                        inset: 0,
                        start: 0,
                        duration: outputDuration,
                        muxSourceKey: muxKey
                    }
                ]
            });
        } catch (e) {
            if ((0, $k7O9T.isCancelledError)(e)) return;
            console.error("Music-only audio assignment failed:", e);
        }
    };
    const runUploadMux = async ()=>{
        if (!audioVariations?.length || audioMux.isPending) return;
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        const rawAsset = videoData?.assets?.find((a)=>a.name === (0, $0025d0fdccbcde07$export$a2fd4a4d4c54d2a1));
        if (!rawAsset?.filePath) return;
        const muxKey = `${(0, $0025d0fdccbcde07$export$3739690d51777e3)}:${rawAsset.filePath}:${rawAsset.generatedAt ?? 0}:${musicPath}`;
        const existing = videoData?.assets?.find((a)=>a.name === audioVariations[0]?.key);
        if (existing?.muxSourceKey === muxKey) return;
        try {
            const outputDuration = audioVariations.reduce((max, v)=>Math.max(max, (v.settings?.inset ?? 0) + (v.settings?.duration ?? 0)), 0) + 5;
            const uploadPresign = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(rawAsset.filePath));
            if (!uploadPresign?.presignURL) return;
            const first = audioVariations[0];
            const firstSettings = first?.settings ?? {};
            const audios = [];
            if (musicPath) {
                const musicPresign = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(musicPath));
                if (!musicPresign?.presignURL) return;
                audios.push({
                    source: {
                        url: musicPresign.presignURL
                    },
                    volume: (0, $7da6076015242272$export$d434e5f09e6f67e5),
                    inset: 0,
                    start: 0,
                    duration: outputDuration
                });
            }
            audios.push({
                source: {
                    url: uploadPresign.presignURL
                },
                volume: firstSettings.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                inset: 0,
                start: 0,
                duration: outputDuration
            });
            const muxUrl = await audioMux.mutateAsync(audios);
            await uploadAssets.mutateAsync({
                assets: [
                    {
                        name: first.key,
                        type: first.type,
                        src: muxUrl,
                        referenceKey: first.referenceKey,
                        volume: firstSettings.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                        inset: 0,
                        start: 0,
                        duration: outputDuration,
                        muxSourceKey: muxKey,
                        generatedAt: Date.now()
                    }
                ]
            });
        } catch (e) {
            if ((0, $k7O9T.isCancelledError)(e)) return;
            console.error("Uploaded voiceover audio mux failed:", e);
        }
    };
    const isGenerating = template.data?.assets?.some((asset)=>asset.type === "audio" && !video.data?.assets?.find((a)=>a.name === asset.name));
    const uploadAudioKey = template.data?.audioVariations?.[0]?.key;
    const hasUploadedVoiceover = !!uploadedRawAsset;
    (0, $eF4cA.useEffect)(()=>{
        if (!isUpload || !hasUploadedVoiceover || !uploadMuxKey) return;
        if (isUploadMuxReady) {
            uploadMuxKickedRef.current = null;
            return;
        }
        if (uploadMuxKickedRef.current === uploadMuxKey || audioMux.isPending) return;
        uploadMuxKickedRef.current = uploadMuxKey;
        runUploadMux();
    }, [
        isUpload,
        hasUploadedVoiceover,
        uploadMuxKey,
        isUploadMuxReady,
        audioMux.isPending
    ]);
    const isNextDisabled = templateAssets?.length === 1 ? !areAllAudioAssetsSelected : hasCustomizedVoiceover ? selectedKeys.size < 1 || selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.EDIT) && !areAllAudioAssetsSelected || selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.UPLOAD) && !hasUploadedVoiceover : false;
    const handleSelectionChange = (keys)=>{
        setSelectedKeys(keys);
        const nextMode = Array.from(keys)[0];
        if (!keys.has(video.data?.voiceoverMode)) updateVideo.mutate({
            voiceoverMode: nextMode
        }, {
            onSuccess: ()=>{
                if (nextMode === $be90f5e41d3f443a$export$16012be60f05d346.NONE) runMusicOnlyMux();
            }
        });
        else if (nextMode === $be90f5e41d3f443a$export$16012be60f05d346.NONE) runMusicOnlyMux();
    };
    const handleCustomizeToggle = (isSelected)=>{
        setHasCustomizedVoiceover(isSelected);
        handleSelectionChange(new Set([
            isSelected ? $be90f5e41d3f443a$export$16012be60f05d346.EDIT : $be90f5e41d3f443a$export$16012be60f05d346.ORIGINAL
        ]));
    };
    const handleDeleteUploadedVoiceover = ()=>{
        setUploadedVoiceoverFile(null);
        const toRemove = [
            {
                name: (0, $0025d0fdccbcde07$export$a2fd4a4d4c54d2a1)
            }
        ];
        if (uploadAudioKey) toRemove.push({
            name: uploadAudioKey
        });
        updateAssets.mutate({
            toRemove: toRemove
        });
    };
    const handleDownloadScript = ()=>{
        const sections = (templateAssets ?? []).map((templateAsset)=>{
            const asset = video.data?.assets?.find((a)=>a.name === templateAsset.name);
            const resolvedText = (0, $d1074761a75a163a$export$32c15f4ab4985540)(asset?.text ?? templateAsset.text ?? "", {
                parts: asset?.parts,
                campaign: selectedCampaign
            }).trim();
            if (!resolvedText) return null;
            return `${resolvedText}\n`;
        }).filter(Boolean);
        if (!sections.length) return;
        const content = `# ${video.data?.name ?? video.data?.id ?? "Sizzle reel"} script\n\n${sections.join("\n")}\n`;
        const projectName = video.data?.name ?? video.data?.id ?? "sizzle-reel";
        (0, $9lDhw.downloadFile)(content, `${projectName}-script.md`, "text/markdown");
    };
    const handleOnContinue = (...args)=>{
        if (hasCustomizedVoiceover) (0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).VOICEOVER_CHOSEN, {
            user: {
                email: userProfile?.email
            },
            videoId: video.data?.id,
            templateId: video.data?.templateId,
            voiceoverTemplate: Array.from(selectedKeys)[0] ?? video.data?.voiceoverMode
        });
        if (isEdit) stepActionCtx?.runVoiceoverMux?.();
        onContinue(...args);
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Up182 qp182 Za182 Fb182",
                children: [
                    templateAssets?.length > 1 && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 Up182 qp182 Za182 Fb182 IM182 HM182 GJ182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                                title: template?.data.id === "ao-overview" ? "Your voiceover is ready" : "Voiceover",
                                subtitle: template?.data.id === "ao-overview" ? "We recommend checking the pronunciation of your brand and campaign names before continuing." : "Your video will use the default voiceover from the template"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                                isSelected: hasCustomizedVoiceover,
                                onChange: handleCustomizeToggle,
                                styles: " IM182 HM182",
                                children: template?.data.id === "ao-overview" ? "Review voiceover" : "Want to customize?"
                            }),
                            !!hasCustomizedVoiceover && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        ref: customizeRef,
                                        className: " sd182 _ta182 eb182 Gx182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182 Gy182",
                                                children: "These features are experimental"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 _Wa182",
                                                children: "Feel free to try them out, but keep in mind things might not work perfectly just yet."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $b0a461d8d3a700b8$export$da87cf13fc2ef3d8), {
                                        "aria-label": "Select voiceover assets to include in the video",
                                        selectionMode: "single",
                                        onSelectionChange: handleSelectionChange,
                                        selectedKeys: selectedKeys,
                                        styles: " GJ182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $b0a461d8d3a700b8$export$ebde6d4e7862fe9d), {
                                                id: $be90f5e41d3f443a$export$16012be60f05d346.EDIT,
                                                textValue: "Edit voiceover",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $582f5bb145477570$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "label",
                                                        children: "Edit voiceover"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $b0a461d8d3a700b8$export$ebde6d4e7862fe9d), {
                                                id: $be90f5e41d3f443a$export$16012be60f05d346.UPLOAD,
                                                textValue: "Upload voiceover",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $094548f1328296b4$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "label",
                                                        children: "Upload voiceover"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $b0a461d8d3a700b8$export$ebde6d4e7862fe9d), {
                                                id: $be90f5e41d3f443a$export$16012be60f05d346.NONE,
                                                textValue: "No voiceover",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $77276a99cc7f2047$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "label",
                                                        children: "No voiceover"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                                        children: [
                                            selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.EDIT) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _Wa182",
                                                children: [
                                                    "Check the voiceover audio, which will be used in the video.",
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                                    "Fix pronunciation and generate again if needed."
                                                ]
                                            }),
                                            selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.UPLOAD) && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 _ta182 eb182 Uj182 qj182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _Wa182",
                                                        children: [
                                                            "Upload your own voiceover audio file.",
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                                            "Match the script, timing, and volume of the sample below.",
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                                            "Background music will be added automatically."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                        className: " sd182 _ta182 eb182 Ue182 qe182",
                                                        children: [
                                                            voiceoverPreviewUrl.data?.presignURL && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                className: " sd182 _ta182 eb182 Ua182 qa182",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                                        isQuiet: true,
                                                                        onPress: ()=>window.open(voiceoverPreviewUrl.data?.presignURL, "_blank"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                children: "Download sample voiceover"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182 _Wa182",
                                                                        children: "Aim for a loudness similar to the sample (-23 LUFS, peak around -5 dB)"
                                                                    })
                                                                ]
                                                            }),
                                                            templateAssets?.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                                isQuiet: true,
                                                                onPress: handleDownloadScript,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                        children: "Download sizzle reel script"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.NONE) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _Wa182",
                                                children: [
                                                    "Exclude the voiceover from the video.",
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                                    "Only background music and sound effects will be included in the final video."
                                                ]
                                            })
                                        ]
                                    }),
                                    selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.EDIT) && isGenerating && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
                                        title: "Generating voiceover",
                                        subtitle: "This may take a few moments, so please keep this tab open.",
                                        ariaLabel: "Generating voiceover",
                                        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $582f5bb145477570$export$2e2bcd8739ae039), {
                                            styles: " Zq182 Fr182 JJ182"
                                        })
                                    }),
                                    selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.EDIT) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5e0f375ff6d9a15c$export$439d29a4e110a164), {
                                        isHidden: isGenerating,
                                        children: [
                                            templateAssets?.length > 1 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $772868ae45e107c4$export$3b651f8cf192f7f4), {
                                                videoId: video.data?.id,
                                                previewUrl: template.data?.timelinePreviewUrl
                                            }),
                                            templateAssets?.length === 1 && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " Lq63t7c182 IM182 HM182",
                                                children: audioAssets?.map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $d1074761a75a163a$export$3cea9fb9794152bb), {
                                                        videoId: video.data?.id,
                                                        assetName: asset.name,
                                                        selectedCampaign: selectedCampaign,
                                                        segments: asset?.segments ?? [],
                                                        editableScript: template
                                                    }, asset.name))
                                            })
                                        ]
                                    }),
                                    selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.UPLOAD) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0025d0fdccbcde07$export$f3b30874829cfd0c), {
                                        videoId: video.data?.id,
                                        file: uploadedVoiceoverFile,
                                        onFileChange: setUploadedVoiceoverFile
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 Ue182 qe182 IM182 HM182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                size: "S",
                                                onPress: ()=>{
                                                    (0, $kvWIh.trackVoiceoverEvent)((0, $hpQib.AnalyticsEventNames).VOICEOVER_RESET, {
                                                        user: {
                                                            email: userProfile?.email
                                                        },
                                                        videoId: video.data?.id,
                                                        templateId: video.data?.templateId
                                                    });
                                                    handleCustomizeToggle(false);
                                                },
                                                isQuiet: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c8ca68bb4c148d98$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Reset to default"
                                                    })
                                                ]
                                            }),
                                            selectedKeys.has($be90f5e41d3f443a$export$16012be60f05d346.UPLOAD) && (!!uploadedVoiceoverFile || hasUploadedVoiceover) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                size: "S",
                                                onPress: handleDeleteUploadedVoiceover,
                                                isQuiet: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Delete uploaded file"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    templateAssets?.length === 1 && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " sd182 _ta182 Up182 qp182 Za182 Fb182 IM182 HM182 GJ182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " Lq63t7c182 IM182 HM182",
                            children: templateAssets?.map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $d1074761a75a163a$export$3cea9fb9794152bb), {
                                    videoId: video.data?.id,
                                    assetName: asset.name,
                                    isStandalone: true
                                }, asset.name))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: (...args)=>handleOnContinue(...args),
                continueLabel: continueLabel,
                continueVariant: "primary",
                isContinueDisabled: isNextDisabled
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $fWQx3 = parcelRequire("fWQx3");
var $fUh73 = parcelRequire("fUh73");
var $208Op = parcelRequire("208Op");
var $5mvex = parcelRequire("5mvex");
var $aQTiM = parcelRequire("aQTiM");
var $8Muzv = parcelRequire("8Muzv");
var $7Vvqh = parcelRequire("7Vvqh");
var $2ffAV = parcelRequire("2ffAV");
var $hSW0F = parcelRequire("hSW0F");

var $j2JDe = parcelRequire("j2JDe");

var $lRNYL = parcelRequire("lRNYL");

var $77tch = parcelRequire("77tch");

var $fmJ8d = parcelRequire("fmJ8d");

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $5nTep = parcelRequire("5nTep");
function $cf8fa525369aaf1c$export$2e2bcd8739ae039() {
    return $cf8fa525369aaf1c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cf8fa525369aaf1c$export$2e2bcd8739ae039.apply(null, arguments);
}


function $ec7cb75b38e78640$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ec7cb75b38e78640$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec7cb75b38e78640$export$2e2bcd8739ae039(o);
}



function $baac0a4b95a43a23$export$2e2bcd8739ae039(t, e) {
    if ("object" != (0, $ec7cb75b38e78640$export$2e2bcd8739ae039)(t) || !t) return t;
    var r;
    if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) {
        var i = r.call(t, e || "default");
        if ("object" != (0, $ec7cb75b38e78640$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}


function $670ad0654372f5cc$export$2e2bcd8739ae039(t) {
    var i = (0, $baac0a4b95a43a23$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ec7cb75b38e78640$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $90deb5ff621c4278$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $670ad0654372f5cc$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $eF4cA = parcelRequire("eF4cA");
function $9644c80f8ced0992$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9644c80f8ced0992$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9644c80f8ced0992$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90deb5ff621c4278$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9644c80f8ced0992$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get all possible permutations of all power sets
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function $9644c80f8ced0992$var$powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var $9644c80f8ced0992$var$classNameCombinations = {};
function $9644c80f8ced0992$var$getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join('.');
    if (!$9644c80f8ced0992$var$classNameCombinations[key]) $9644c80f8ced0992$var$classNameCombinations[key] = $9644c80f8ced0992$var$powerSetPermutations(classNames);
    return $9644c80f8ced0992$var$classNameCombinations[key];
}
function $9644c80f8ced0992$export$28a8c6cb018dfadc(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== 'token';
    });
    var classNamesCombinations = $9644c80f8ced0992$var$getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return $9644c80f8ced0992$var$_objectSpread($9644c80f8ced0992$var$_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function $9644c80f8ced0992$export$d0f1f443a3b7b5(classNames) {
    return classNames.join(' ');
}
function $9644c80f8ced0992$export$86fb3c3a621e8db6(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return $9644c80f8ced0992$export$2e2bcd8739ae039({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function $9644c80f8ced0992$export$2e2bcd8739ae039(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === 'text') return value;
    else if (TagName) {
        var childrenCreator = $9644c80f8ced0992$export$86fb3c3a621e8db6(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = $9644c80f8ced0992$var$_objectSpread($9644c80f8ced0992$var$_objectSpread({}, properties), {}, {
            className: $9644c80f8ced0992$export$d0f1f443a3b7b5(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split('.').forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []);
            // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes('token') ? [
                'token'
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = $9644c80f8ced0992$var$_objectSpread($9644c80f8ced0992$var$_objectSpread({}, properties), {}, {
                className: $9644c80f8ced0992$export$d0f1f443a3b7b5(className) || undefined,
                style: $9644c80f8ced0992$export$28a8c6cb018dfadc(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(TagName, (0, $cf8fa525369aaf1c$export$2e2bcd8739ae039)({
            key: key
        }, props), children);
    }
}

function $1b9fa2426ab907fa$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $76ef80ff86d9385f$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1b9fa2426ab907fa$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $81d5fa47af8258e0$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $843076c86910c5c5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $81d5fa47af8258e0$export$2e2bcd8739ae039)(r);
}


function $347b8a22d656caef$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $3e22a02b99ee3a01$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $81d5fa47af8258e0$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $81d5fa47af8258e0$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $391f3cd2c076b3f8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f92b54c8d2758d9f$export$2e2bcd8739ae039(r) {
    return (0, $843076c86910c5c5$export$2e2bcd8739ae039)(r) || (0, $347b8a22d656caef$export$2e2bcd8739ae039)(r) || (0, $3e22a02b99ee3a01$export$2e2bcd8739ae039)(r) || (0, $391f3cd2c076b3f8$export$2e2bcd8739ae039)();
}




var $eF4cA = parcelRequire("eF4cA");

var $8a21c7d4ffad9138$export$2e2bcd8739ae039 = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};


var $9eb8246b3bcffd27$var$_excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function $9eb8246b3bcffd27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9eb8246b3bcffd27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9eb8246b3bcffd27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90deb5ff621c4278$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9eb8246b3bcffd27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9eb8246b3bcffd27$var$newLineRegex = /\n/g;
function $9eb8246b3bcffd27$var$getNewLines(str) {
    return str.match($9eb8246b3bcffd27$var$newLineRegex);
}
function $9eb8246b3bcffd27$var$getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === 'function' ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function $9eb8246b3bcffd27$var$AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": 'left',
        paddingRight: '10px'
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, $9eb8246b3bcffd27$var$getAllLineNumbers({
        lines: codeString.replace(/\n$/, '').split('\n'),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function $9eb8246b3bcffd27$var$getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function $9eb8246b3bcffd27$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                'comment',
                'linenumber',
                'react-syntax-highlighter-line-number'
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: 'text',
                value: lineNumber
            }
        ]
    };
}
function $9eb8246b3bcffd27$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: 'inline-block',
        minWidth: $9eb8246b3bcffd27$var$getEmWidthOfNumber(largestLineNumber),
        paddingRight: '1em',
        textAlign: 'right',
        userSelect: 'none'
    };
    // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === 'function' ? lineNumberStyle(lineNumber) : lineNumberStyle;
    // combine
    var assembledStyle = $9eb8246b3bcffd27$var$_objectSpread($9eb8246b3bcffd27$var$_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function $9eb8246b3bcffd27$var$createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines, _ref3$wrapLines = _ref3.wrapLines, wrapLines = _ref3$wrapLines === void 0 ? false : _ref3$wrapLines;
    var properties = wrapLines ? $9eb8246b3bcffd27$var$_objectSpread({}, typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) : {};
    properties['className'] = properties['className'] ? [].concat((0, $f92b54c8d2758d9f$export$2e2bcd8739ae039)(properties['className'].trim().split(/\s+/)), (0, $f92b54c8d2758d9f$export$2e2bcd8739ae039)(className)) : className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = $9eb8246b3bcffd27$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift($9eb8246b3bcffd27$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = $9eb8246b3bcffd27$var$_objectSpread({
        display: 'flex'
    }, properties.style);
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: children
    };
}
function $9eb8246b3bcffd27$var$flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (tree.length === undefined) tree = [
        tree
    ];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === 'text') newTree.push($9eb8246b3bcffd27$var$createLineElement({
            children: [
                node
            ],
            className: (0, $f92b54c8d2758d9f$export$2e2bcd8739ae039)(new Set(className))
        }));
        else if (node.children) {
            var _node$properties;
            var classNames = className.concat(((_node$properties = node.properties) === null || _node$properties === void 0 ? void 0 : _node$properties.className) || []);
            $9eb8246b3bcffd27$var$flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function $9eb8246b3bcffd27$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = $9eb8246b3bcffd27$var$flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $9eb8246b3bcffd27$var$createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines,
            wrapLines: wrapLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = $9eb8246b3bcffd27$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift($9eb8246b3bcffd27$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = $9eb8246b3bcffd27$var$getNewLines(value);
        if (newLines) {
            var splitValue = value.split('\n');
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: 'text',
                    value: "".concat(text, "\n")
                };
                // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat($9eb8246b3bcffd27$var$createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line);
                // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: 'text',
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = $9eb8246b3bcffd27$var$createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    }
                // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function $9eb8246b3bcffd27$var$defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, $9644c80f8ced0992$export$2e2bcd8739ae039)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segment-".concat(i)
        });
    });
}
// only highlight.js has the highlightAuto method
function $9eb8246b3bcffd27$var$isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== 'undefined';
}
function $9eb8246b3bcffd27$var$getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if ($9eb8246b3bcffd27$var$isHighlightJs(astGenerator)) {
        var hasLanguage = (0, $8a21c7d4ffad9138$export$2e2bcd8739ae039)(astGenerator, language);
        if (language === 'text') return {
            value: defaultCodeValue,
            language: 'text'
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    }
    // must be refractor/prism, then
    try {
        return language && language !== 'text' ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function $9eb8246b3bcffd27$export$2e2bcd8739ae039(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var _code$match$length, _code$match;
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: $9eb8246b3bcffd27$var$_objectSpread($9eb8246b3bcffd27$var$_objectSpread({}, style['code[class*="language-"]']), style["code[class*=\"language-".concat(language, "\"]")])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? 'pre' : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? 'code' : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || '' : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, $76ef80ff86d9385f$export$2e2bcd8739ae039)(_ref7, $9eb8246b3bcffd27$var$_excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($9eb8246b3bcffd27$var$AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: '#fff'
        };
        var generatorClassName = $9eb8246b3bcffd27$var$isHighlightJs(astGenerator) ? 'hljs' : 'prismjs';
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = $9eb8246b3bcffd27$var$_objectSpread({
            whiteSpace: 'pre-wrap'
        }, codeTagProps.style);
        else codeTagProps.style = $9eb8246b3bcffd27$var$_objectSpread({
            whiteSpace: 'pre'
        }, codeTagProps.style);
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || $9eb8246b3bcffd27$var$defaultRenderer;
        var defaultCodeValue = [
            {
                type: 'text',
                value: code
            }
        ];
        var codeTree = $9eb8246b3bcffd27$var$getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
        // pre-determine largest line number so that we can force minWidth on all linenumber elements
        var lineBreakCount = (_code$match$length = (_code$match = code.match(/\n/g)) === null || _code$match === void 0 ? void 0 : _code$match.length) !== null && _code$match$length !== void 0 ? _code$match$length : 0;
        var largestLineNumber = startingLineNumber + lineBreakCount;
        var rows = $9eb8246b3bcffd27$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}


/**
 * @import {Element, Root, Text} from 'hast'
 * @import {Grammar, Languages} from 'prismjs'
 */ /**
 * @typedef _Token
 *   Hidden Prism token.
 * @property {string} alias
 *   Alias.
 * @property {string} content
 *   Content.
 * @property {number} length
 *   Length.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef _Env
 *   Hidden Prism environment.
 * @property {Record<string, string>} attributes
 *   Attributes.
 * @property {Array<string>} classes
 *   Classes.
 * @property {Array<Element | Text> | Element | Text} content
 *   Content.
 * @property {string} language
 *   Language.
 * @property {string} tag
 *   Tag.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef {((prism: Refractor) => undefined | void) & {aliases?: Array<string> | undefined, displayName: string}} Syntax
 *   Refractor syntax function.
 */ /**
 * @typedef Refractor
 *   Virtual syntax highlighting
 * @property {typeof alias} alias
 * @property {Languages} languages
 * @property {typeof listLanguages} listLanguages
 * @property {typeof highlight} highlight
 * @property {typeof registered} registered
 * @property {typeof register} register
 */ // Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
// Register the JSX namespace on `h`.
/**
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 */ // Register the JSX namespace on `s`.
/**
 * @typedef {import('./jsx-classic.js').Element} s.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} s.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} s.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} s.JSX.IntrinsicElements
 */ // Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $78d2d6fbd6fb44cb$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$78d2d6fbd6fb44cb$export$19342e026b58ebb7.prototype.normal = {};
$78d2d6fbd6fb44cb$export$19342e026b58ebb7.prototype.property = {};
$78d2d6fbd6fb44cb$export$19342e026b58ebb7.prototype.space = undefined;


function $9b985d6ac375ddd8$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $78d2d6fbd6fb44cb$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ /**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $8b768d0884f2748d$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


/**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $49e4c708aa5b2b57$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.attribute = '';
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.booleanish = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.boolean = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.defined = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.number = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.property = '';
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$49e4c708aa5b2b57$export$c4868e4a24d48fad.prototype.space = undefined;


var $d539477cc980d5fd$exports = {};

$parcel$export($d539477cc980d5fd$exports, "boolean", () => $d539477cc980d5fd$export$4a21f16c33752377);
$parcel$export($d539477cc980d5fd$exports, "booleanish", () => $d539477cc980d5fd$export$55e9e1fbc638dc8f);
$parcel$export($d539477cc980d5fd$exports, "overloadedBoolean", () => $d539477cc980d5fd$export$242ac3d3042558aa);
$parcel$export($d539477cc980d5fd$exports, "number", () => $d539477cc980d5fd$export$98e628dec113755e);
$parcel$export($d539477cc980d5fd$exports, "spaceSeparated", () => $d539477cc980d5fd$export$ab8645c862eb5a3e);
$parcel$export($d539477cc980d5fd$exports, "commaSeparated", () => $d539477cc980d5fd$export$9c8d678629b3d3);
$parcel$export($d539477cc980d5fd$exports, "commaOrSpaceSeparated", () => $d539477cc980d5fd$export$2ad25cfebf36cacd);
let $d539477cc980d5fd$var$powers = 0;
const $d539477cc980d5fd$export$4a21f16c33752377 = $d539477cc980d5fd$var$increment();
const $d539477cc980d5fd$export$55e9e1fbc638dc8f = $d539477cc980d5fd$var$increment();
const $d539477cc980d5fd$export$242ac3d3042558aa = $d539477cc980d5fd$var$increment();
const $d539477cc980d5fd$export$98e628dec113755e = $d539477cc980d5fd$var$increment();
const $d539477cc980d5fd$export$ab8645c862eb5a3e = $d539477cc980d5fd$var$increment();
const $d539477cc980d5fd$export$9c8d678629b3d3 = $d539477cc980d5fd$var$increment();
const $d539477cc980d5fd$export$2ad25cfebf36cacd = $d539477cc980d5fd$var$increment();
function $d539477cc980d5fd$var$increment() {
    return 2 ** ++$d539477cc980d5fd$var$powers;
}


const $7b076dcd43973eb6$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($d539477cc980d5fd$exports);
class $7b076dcd43973eb6$export$ea6b9f0064e88c9b extends (0, $49e4c708aa5b2b57$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $7b076dcd43973eb6$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $7b076dcd43973eb6$var$checks.length){
            const check = $7b076dcd43973eb6$var$checks[index];
            $7b076dcd43973eb6$var$mark(this, $7b076dcd43973eb6$var$checks[index], (mask & $d539477cc980d5fd$exports[check]) === $d539477cc980d5fd$exports[check]);
        }
    }
}
$7b076dcd43973eb6$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $7b076dcd43973eb6$var$mark(values, key, value) {
    if (value) values[key] = value;
}



function $60953f643a19ad6b$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $7b076dcd43973eb6$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $8b768d0884f2748d$export$a3295358bff77e)(property)] = property;
        normals[(0, $8b768d0884f2748d$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $78d2d6fbd6fb44cb$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $47acb4538b6f1bd3$export$4d2d26490572750a = (0, $60953f643a19ad6b$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaColIndex: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaColSpan: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaControls: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaLevel: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaPressed: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaRowIndex: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaRowSpan: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaSelected: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaValueMin: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaValueNow: (0, $d539477cc980d5fd$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $3ede1e726678b454$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $e5f4e5aa9aa7465d$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $3ede1e726678b454$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $4e202f494767fd07$export$c0bb0b647f701bb5 = (0, $60953f643a19ad6b$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $d539477cc980d5fd$export$9c8d678629b3d3),
        acceptCharset: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        accessKey: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        allowPaymentRequest: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        allowUserMedia: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        alpha: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        autoFocus: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        autoPlay: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        blocking: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        cite: null,
        className: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $d539477cc980d5fd$export$98e628dec113755e),
        colSpan: (0, $d539477cc980d5fd$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        controls: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        controlsList: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        coords: (0, $d539477cc980d5fd$export$98e628dec113755e) | (0, $d539477cc980d5fd$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        defer: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        download: (0, $d539477cc980d5fd$export$242ac3d3042558aa),
        draggable: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        height: (0, $d539477cc980d5fd$export$98e628dec113755e),
        hidden: (0, $d539477cc980d5fd$export$242ac3d3042558aa),
        high: (0, $d539477cc980d5fd$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        httpEquiv: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        itemRef: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        itemScope: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        itemType: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        low: (0, $d539477cc980d5fd$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $d539477cc980d5fd$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $d539477cc980d5fd$export$98e628dec113755e),
        multiple: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        muted: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        noValidate: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        optimum: (0, $d539477cc980d5fd$export$98e628dec113755e),
        pattern: null,
        ping: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        required: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        reversed: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        rows: (0, $d539477cc980d5fd$export$98e628dec113755e),
        rowSpan: (0, $d539477cc980d5fd$export$98e628dec113755e),
        sandbox: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        seamless: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        selected: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        shadowRootClonable: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        shape: null,
        size: (0, $d539477cc980d5fd$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $d539477cc980d5fd$export$98e628dec113755e),
        spellCheck: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $d539477cc980d5fd$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $d539477cc980d5fd$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        useMap: null,
        value: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        width: (0, $d539477cc980d5fd$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $d539477cc980d5fd$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $d539477cc980d5fd$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        declare: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $d539477cc980d5fd$export$98e628dec113755e),
        leftMargin: (0, $d539477cc980d5fd$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $d539477cc980d5fd$export$98e628dec113755e),
        marginWidth: (0, $d539477cc980d5fd$export$98e628dec113755e),
        noResize: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        noHref: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        noShade: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        noWrap: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $d539477cc980d5fd$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $d539477cc980d5fd$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $d539477cc980d5fd$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $d539477cc980d5fd$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        disablePictureInPicture: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        disableRemotePlayback: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        exportParts: (0, $d539477cc980d5fd$export$9c8d678629b3d3),
        part: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $d539477cc980d5fd$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $e5f4e5aa9aa7465d$export$32b9e4cec9c208e1)
});





const $d66586f770ac78a5$export$7ed1367e7fa1ad68 = (0, $60953f643a19ad6b$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        accentHeight: (0, $d539477cc980d5fd$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $d539477cc980d5fd$export$98e628dec113755e),
        amplitude: (0, $d539477cc980d5fd$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $d539477cc980d5fd$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $d539477cc980d5fd$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $d539477cc980d5fd$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $d539477cc980d5fd$export$98e628dec113755e),
        className: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $d539477cc980d5fd$export$98e628dec113755e),
        diffuseConstant: (0, $d539477cc980d5fd$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $d539477cc980d5fd$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $d539477cc980d5fd$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $d539477cc980d5fd$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $d539477cc980d5fd$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $d539477cc980d5fd$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $d539477cc980d5fd$export$9c8d678629b3d3),
        g2: (0, $d539477cc980d5fd$export$9c8d678629b3d3),
        glyphName: (0, $d539477cc980d5fd$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $d539477cc980d5fd$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $d539477cc980d5fd$export$98e628dec113755e),
        horizOriginX: (0, $d539477cc980d5fd$export$98e628dec113755e),
        horizOriginY: (0, $d539477cc980d5fd$export$98e628dec113755e),
        id: null,
        ideographic: (0, $d539477cc980d5fd$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $d539477cc980d5fd$export$98e628dec113755e),
        k: (0, $d539477cc980d5fd$export$98e628dec113755e),
        k1: (0, $d539477cc980d5fd$export$98e628dec113755e),
        k2: (0, $d539477cc980d5fd$export$98e628dec113755e),
        k3: (0, $d539477cc980d5fd$export$98e628dec113755e),
        k4: (0, $d539477cc980d5fd$export$98e628dec113755e),
        kernelMatrix: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $d539477cc980d5fd$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $d539477cc980d5fd$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $d539477cc980d5fd$export$98e628dec113755e),
        overlineThickness: (0, $d539477cc980d5fd$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $d539477cc980d5fd$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $d539477cc980d5fd$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $d539477cc980d5fd$export$98e628dec113755e),
        pointsAtY: (0, $d539477cc980d5fd$export$98e628dec113755e),
        pointsAtZ: (0, $d539477cc980d5fd$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        rev: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        requiredFonts: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        requiredFormats: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $d539477cc980d5fd$export$98e628dec113755e),
        specularExponent: (0, $d539477cc980d5fd$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $d539477cc980d5fd$export$98e628dec113755e),
        strikethroughThickness: (0, $d539477cc980d5fd$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $d539477cc980d5fd$export$98e628dec113755e),
        strokeOpacity: (0, $d539477cc980d5fd$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $d539477cc980d5fd$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        tabIndex: (0, $d539477cc980d5fd$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $d539477cc980d5fd$export$98e628dec113755e),
        targetY: (0, $d539477cc980d5fd$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $d539477cc980d5fd$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $d539477cc980d5fd$export$98e628dec113755e),
        underlineThickness: (0, $d539477cc980d5fd$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $d539477cc980d5fd$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $d539477cc980d5fd$export$98e628dec113755e),
        vMathematical: (0, $d539477cc980d5fd$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $d539477cc980d5fd$export$98e628dec113755e),
        vIdeographic: (0, $d539477cc980d5fd$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $d539477cc980d5fd$export$98e628dec113755e),
        vertOriginX: (0, $d539477cc980d5fd$export$98e628dec113755e),
        vertOriginY: (0, $d539477cc980d5fd$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $d539477cc980d5fd$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $3ede1e726678b454$export$5b10b3bc32d7efbc)
});



const $c645f4cadc56e983$export$2bd1230ec7600845 = (0, $60953f643a19ad6b$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $9106239c5ba244e2$export$e20c24a128671213 = (0, $60953f643a19ad6b$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $e5f4e5aa9aa7465d$export$32b9e4cec9c208e1)
});



const $8e9f629ed14c7532$export$f2913fe8983302e = (0, $60953f643a19ad6b$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});



/**
 * @import {Schema} from 'property-information'
 */ 


const $55824376da81d347$var$cap = /[A-Z]/g;
const $55824376da81d347$var$dash = /-[a-z]/g;
const $55824376da81d347$var$valid = /^data[-\w.:]+$/i;
function $55824376da81d347$export$71aa6c912b956294(schema, value) {
    const normal = (0, $8b768d0884f2748d$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $49e4c708aa5b2b57$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $55824376da81d347$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($55824376da81d347$var$dash, $55824376da81d347$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$55824376da81d347$var$dash.test(rest)) {
                let dashes = rest.replace($55824376da81d347$var$cap, $55824376da81d347$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $7b076dcd43973eb6$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $55824376da81d347$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $55824376da81d347$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}



const $6a65a26ae39c41f8$export$c0bb0b647f701bb5 = (0, $9b985d6ac375ddd8$export$4950aa0f605343fb)([
    (0, $47acb4538b6f1bd3$export$4d2d26490572750a),
    (0, $4e202f494767fd07$export$c0bb0b647f701bb5),
    (0, $c645f4cadc56e983$export$2bd1230ec7600845),
    (0, $9106239c5ba244e2$export$e20c24a128671213),
    (0, $8e9f629ed14c7532$export$f2913fe8983302e)
], 'html');
const $6a65a26ae39c41f8$export$7ed1367e7fa1ad68 = (0, $9b985d6ac375ddd8$export$4950aa0f605343fb)([
    (0, $47acb4538b6f1bd3$export$4d2d26490572750a),
    (0, $d66586f770ac78a5$export$7ed1367e7fa1ad68),
    (0, $c645f4cadc56e983$export$2bd1230ec7600845),
    (0, $9106239c5ba244e2$export$e20c24a128671213),
    (0, $8e9f629ed14c7532$export$f2913fe8983302e)
], 'svg');


/**
 * @import {Element, Nodes, RootContent, Root} from 'hast'
 * @import {Info, Schema} from 'property-information'
 */ /**
 * @typedef {Array<Nodes | PrimitiveChild>} ArrayChildNested
 *   List of children (deep).
 */ /**
 * @typedef {Array<ArrayChildNested | Nodes | PrimitiveChild>} ArrayChild
 *   List of children.
 */ /**
 * @typedef {Array<number | string>} ArrayValue
 *   List of property values for space- or comma separated values (such as `className`).
 */ /**
 * @typedef {ArrayChild | Nodes | PrimitiveChild} Child
 *   Acceptable child value.
 */ /**
 * @typedef {number | string | null | undefined} PrimitiveChild
 *   Primitive children, either ignored (nullish), or turned into text nodes.
 */ /**
 * @typedef {boolean | number | string | null | undefined} PrimitiveValue
 *   Primitive property value.
 */ /**
 * @typedef {Record<string, PropertyValue | Style>} Properties
 *   Acceptable value for element properties.
 */ /**
 * @typedef {ArrayValue | PrimitiveValue} PropertyValue
 *   Primitive value or list value.
 */ /**
 * @typedef {Element | Root} Result
 *   Result from a `h` (or `s`) call.
 */ /**
 * @typedef {number | string} StyleValue
 *   Value for a CSS style field.
 */ /**
 * @typedef {Record<string, StyleValue>} Style
 *   Supported value of a `style` prop.
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $42c05a1787859cd9$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $42c05a1787859cd9$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 */ /**
 * @template {string} SimpleSelector
 *   Selector type.
 * @template {string} DefaultTagName
 *   Default tag name.
 * @typedef {(
 *   SimpleSelector extends ''
 *     ? DefaultTagName
 *     : SimpleSelector extends `${infer TagName}.${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends `${infer TagName}#${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends string
 *     ? SimpleSelector
 *     : DefaultTagName
 * )} ExtractTagName
 *   Extract tag name from a simple selector.
 */ const $1bf4ee753ab390d5$var$search = /[#.]/g;
function $1bf4ee753ab390d5$export$529769e360e2fa1b(selector, defaultTagName) {
    const value = selector || '';
    /** @type {Properties} */ const props = {};
    let start = 0;
    /** @type {string | undefined} */ let previous;
    /** @type {string | undefined} */ let tagName;
    while(start < value.length){
        $1bf4ee753ab390d5$var$search.lastIndex = start;
        const match = $1bf4ee753ab390d5$var$search.exec(value);
        const subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) tagName = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (Array.isArray(props.className)) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        // @ts-expect-error: tag name is parsed.
        tagName: tagName || defaultTagName || 'div',
        properties: props,
        children: []
    };
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $859229a9514acb56$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $859229a9514acb56$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


function $a3f4c4677f88398f$export$92ec6bcf7c3ee08c(schema, defaultTagName, caseSensitive) {
    const adjust = caseSensitive ? $a3f4c4677f88398f$var$createAdjustMap(caseSensitive) : undefined;
    /**
   * Hyperscript compatible DSL for creating virtual hast trees.
   *
   * @overload
   * @param {null | undefined} [selector]
   * @param {...Child} children
   * @returns {Root}
   *
   * @overload
   * @param {string} selector
   * @param {Properties} properties
   * @param {...Child} children
   * @returns {Element}
   *
   * @overload
   * @param {string} selector
   * @param {...Child} children
   * @returns {Element}
   *
   * @param {string | null | undefined} [selector]
   *   Selector.
   * @param {Child | Properties | null | undefined} [properties]
   *   Properties (or first child) (default: `undefined`).
   * @param {...Child} children
   *   Children.
   * @returns {Result}
   *   Result.
   */ function h(selector, properties, ...children) {
        /** @type {Result} */ let node;
        if (selector === null || selector === undefined) {
            node = {
                type: 'root',
                children: []
            };
            // Properties are not supported for roots.
            const child = /** @type {Child} */ properties;
            children.unshift(child);
        } else {
            node = (0, $1bf4ee753ab390d5$export$529769e360e2fa1b)(selector, defaultTagName);
            // Normalize the name.
            const lower = node.tagName.toLowerCase();
            const adjusted = adjust ? adjust.get(lower) : undefined;
            node.tagName = adjusted || lower;
            // Handle properties.
            if ($a3f4c4677f88398f$var$isChild(properties)) children.unshift(properties);
            else for (const [key, value] of Object.entries(properties))$a3f4c4677f88398f$var$addProperty(schema, node.properties, key, value);
        }
        // Handle children.
        for (const child of children)$a3f4c4677f88398f$var$addChild(node.children, child);
        if (node.type === 'element' && node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    return h;
}
/**
 * Check if something is properties or a child.
 *
 * @param {Child | Properties} value
 *   Value to check.
 * @returns {value is Child}
 *   Whether `value` is definitely a child.
 */ function $a3f4c4677f88398f$var$isChild(value) {
    // Never properties if not an object.
    if (value === null || typeof value !== 'object' || Array.isArray(value)) return true;
    // Never node without `type`; that’s the main discriminator.
    if (typeof value.type !== 'string') return false;
    // Slower check: never property value if object or array with
    // non-number/strings.
    const record = /** @type {Record<string, unknown>} */ value;
    const keys = Object.keys(value);
    for (const key of keys){
        const value = record[key];
        if (value && typeof value === 'object') {
            if (!Array.isArray(value)) return true;
            const list = /** @type {ReadonlyArray<unknown>} */ value;
            for (const item of list){
                if (typeof item !== 'number' && typeof item !== 'string') return true;
            }
        }
    }
    // Also see empty `children` as a node.
    if ('children' in value && Array.isArray(value.children)) return true;
    // Default to properties, someone can always pass an empty object,
    // put `data: {}` in a node,
    // or wrap it in an array.
    return false;
}
/**
 * @param {Schema} schema
 *   Schema.
 * @param {Properties} properties
 *   Properties object.
 * @param {string} key
 *   Property name.
 * @param {PropertyValue | Style} value
 *   Property value.
 * @returns {undefined}
 *   Nothing.
 */ function $a3f4c4677f88398f$var$addProperty(schema, properties, key, value) {
    const info = (0, $55824376da81d347$export$71aa6c912b956294)(schema, key);
    /** @type {PropertyValue} */ let result;
    // Ignore nullish and NaN values.
    if (value === null || value === undefined) return;
    if (typeof value === 'number') {
        // Ignore NaN.
        if (Number.isNaN(value)) return;
        result = value;
    } else if (typeof value === 'boolean') result = value;
    else if (typeof value === 'string') {
        if (info.spaceSeparated) result = (0, $859229a9514acb56$export$98e6a39c04603d36)(value);
        else if (info.commaSeparated) result = (0, $42c05a1787859cd9$export$98e6a39c04603d36)(value);
        else if (info.commaOrSpaceSeparated) result = (0, $859229a9514acb56$export$98e6a39c04603d36)((0, $42c05a1787859cd9$export$98e6a39c04603d36)(value).join(' '));
        else result = $a3f4c4677f88398f$var$parsePrimitive(info, info.property, value);
    } else if (Array.isArray(value)) result = [
        ...value
    ];
    else result = info.property === 'style' ? $a3f4c4677f88398f$var$style(value) : String(value);
    if (Array.isArray(result)) {
        /** @type {Array<number | string>} */ const finalResult = [];
        for (const item of result)// Assume no booleans in array.
        finalResult.push(/** @type {number | string} */ $a3f4c4677f88398f$var$parsePrimitive(info, info.property, item));
        result = finalResult;
    }
    // Class names (which can be added both on the `selector` and here).
    if (info.property === 'className' && Array.isArray(properties.className)) // Assume no booleans in `className`.
    result = properties.className.concat(/** @type {Array<number | string> | number | string} */ result);
    properties[info.property] = result;
}
/**
 * @param {Array<RootContent>} nodes
 *   Children.
 * @param {Child} value
 *   Child.
 * @returns {undefined}
 *   Nothing.
 */ function $a3f4c4677f88398f$var$addChild(nodes, value) {
    if (value === null || value === undefined) ;
    else if (typeof value === 'number' || typeof value === 'string') nodes.push({
        type: 'text',
        value: String(value)
    });
    else if (Array.isArray(value)) for (const child of value)$a3f4c4677f88398f$var$addChild(nodes, child);
    else if (typeof value === 'object' && 'type' in value) {
        if (value.type === 'root') $a3f4c4677f88398f$var$addChild(nodes, value.children);
        else nodes.push(value);
    } else throw new Error('Expected node, nodes, or string, got `' + value + '`');
}
/**
 * Parse a single primitives.
 *
 * @param {Info} info
 *   Property information.
 * @param {string} name
 *   Property name.
 * @param {PrimitiveValue} value
 *   Property value.
 * @returns {PrimitiveValue}
 *   Property value.
 */ function $a3f4c4677f88398f$var$parsePrimitive(info, name, value) {
    if (typeof value === 'string') {
        if (info.number && value && !Number.isNaN(Number(value))) return Number(value);
        if ((info.boolean || info.overloadedBoolean) && (value === '' || (0, $8b768d0884f2748d$export$a3295358bff77e)(value) === (0, $8b768d0884f2748d$export$a3295358bff77e)(name))) return true;
    }
    return value;
}
/**
 * Serialize a `style` object as a string.
 *
 * @param {Style} styles
 *   Style object.
 * @returns {string}
 *   CSS string.
 */ function $a3f4c4677f88398f$var$style(styles) {
    /** @type {Array<string>} */ const result = [];
    for (const [key, value] of Object.entries(styles))result.push([
        key,
        value
    ].join(': '));
    return result.join('; ');
}
/**
 * Create a map to adjust casing.
 *
 * @param {ReadonlyArray<string>} values
 *   List of properly cased keys.
 * @returns {Map<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */ function $a3f4c4677f88398f$var$createAdjustMap(values) {
    /** @type {Map<string, string>} */ const result = new Map();
    for (const value of values)result.set(value.toLowerCase(), value);
    return result;
}


/**
 * List of case-sensitive SVG tag names.
 *
 * @type {ReadonlyArray<string>}
 */ const $f0898e2639d0e8b9$export$5ec6e4ea2f9364a1 = [
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'solidColor',
    'textArea',
    'textPath'
];


const $fbc900b0910ebaeb$export$dda1d9f60106f0e9 = (0, $a3f4c4677f88398f$export$92ec6bcf7c3ee08c)((0, $6a65a26ae39c41f8$export$c0bb0b647f701bb5), 'div');
const $fbc900b0910ebaeb$export$2408f22a0fab9ae5 = (0, $a3f4c4677f88398f$export$92ec6bcf7c3ee08c)((0, $6a65a26ae39c41f8$export$7ed1367e7fa1ad68), 'g', (0, $f0898e2639d0e8b9$export$5ec6e4ea2f9364a1));


/**
 * @import {Point} from 'unist'
 * @import {Options} from '../index.js'
 */ /**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $f85a704f15ad9b04$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of invalid numeric character references to their replacements, according to HTML.
 *
 * @type {Record<number, string>}
 */ const $e886b9f30315dd74$export$18e663c9b25e3b2 = {
    0: "\uFFFD",
    128: "\u20AC",
    130: "\u201A",
    131: "\u0192",
    132: "\u201E",
    133: "\u2026",
    134: "\u2020",
    135: "\u2021",
    136: "\u02C6",
    137: "\u2030",
    138: "\u0160",
    139: "\u2039",
    140: "\u0152",
    142: "\u017D",
    145: "\u2018",
    146: "\u2019",
    147: "\u201C",
    148: "\u201D",
    149: "\u2022",
    150: "\u2013",
    151: "\u2014",
    152: "\u02DC",
    153: "\u2122",
    154: "\u0161",
    155: "\u203A",
    156: "\u0153",
    158: "\u017E",
    159: "\u0178"
};


/**
 * Check if the given character code, or the character code at the first
 * character, is decimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is a decimal
 */ function $f4c432f4e2afe4c4$export$2ad0182371401ea4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is hexadecimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is hexadecimal
 */ function $3f9f3b58086dafe4$export$8ec2d91f756e9f4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is alphabetical.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is alphabetical.
 */ function $296793a98698639f$export$1e381e1de5ace8e(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}



function $d44106a7ab41758f$export$176ed353558777b8(character) {
    return (0, $296793a98698639f$export$1e381e1de5ace8e)(character) || (0, $f4c432f4e2afe4c4$export$2ad0182371401ea4)(character);
}


/// <reference lib="dom" />
/* global document */ const $60664567fce6b3e5$var$element = document.createElement('i');
function $60664567fce6b3e5$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $60664567fce6b3e5$var$element.innerHTML = characterReference;
    const character = $60664567fce6b3e5$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


// Warning messages.
const $973030697e92923e$var$messages = [
    '',
    /* 1: Non terminated (named) */ 'Named character references must be terminated by a semicolon',
    /* 2: Non terminated (numeric) */ 'Numeric character references must be terminated by a semicolon',
    /* 3: Empty (named) */ 'Named character references cannot be empty',
    /* 4: Empty (numeric) */ 'Numeric character references cannot be empty',
    /* 5: Unknown (named) */ 'Named character references must be known',
    /* 6: Disallowed (numeric) */ 'Numeric character references cannot be disallowed',
    /* 7: Prohibited (numeric) */ 'Numeric character references cannot be outside the permissible Unicode range'
];
function $973030697e92923e$export$6c6c782be925911c(value, options) {
    const settings = options || {};
    const additional = typeof settings.additional === 'string' ? settings.additional.charCodeAt(0) : settings.additional;
    /** @type {Array<string>} */ const result = [];
    let index = 0;
    let lines = -1;
    let queue = '';
    /** @type {Point | undefined} */ let point;
    /** @type {Array<number>|undefined} */ let indent;
    if (settings.position) {
        if ('start' in settings.position || 'indent' in settings.position) {
            // @ts-expect-error: points don’t have indent.
            indent = settings.position.indent;
            // @ts-expect-error: points don’t have indent.
            point = settings.position.start;
        } else point = settings.position;
    }
    let line = (point ? point.line : 0) || 1;
    let column = (point ? point.column : 0) || 1;
    // Cache the current point.
    let previous = now();
    /** @type {number|undefined} */ let character;
    // Ensure the algorithm walks over the first character (inclusive).
    index--;
    while(++index <= value.length){
        // If the previous character was a newline.
        if (character === 10 /* `\n` */ ) column = (indent ? indent[lines] : 0) || 1;
        character = value.charCodeAt(index);
        if (character === 38 /* `&` */ ) {
            const following = value.charCodeAt(index + 1);
            // The behavior depends on the identity of the next character.
            if (following === 9 /* `\t` */  || following === 10 /* `\n` */  || following === 12 /* `\f` */  || following === 32 /* ` ` */  || following === 38 /* `&` */  || following === 60 /* `<` */  || Number.isNaN(following) || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += String.fromCharCode(character);
                column++;
                continue;
            }
            const start = index + 1;
            let begin = start;
            let end = start;
            /** @type {string} */ let type;
            if (following === 35 /* `#` */ ) {
                // Numerical reference.
                end = ++begin;
                // The behavior further depends on the next character.
                const following = value.charCodeAt(end);
                if (following === 88 /* `X` */  || following === 120 /* `x` */ ) {
                    // ASCII hexadecimal digits.
                    type = 'hexadecimal';
                    end = ++begin;
                } else // ASCII decimal digits.
                type = 'decimal';
            } else // Named reference.
            type = 'named';
            let characterReferenceCharacters = '';
            let characterReference = '';
            let characters = '';
            // Each type of character reference accepts different characters.
            // This test is used to detect whether a reference has ended (as the semicolon
            // is not strictly needed).
            const test = type === 'named' ? (0, $d44106a7ab41758f$export$176ed353558777b8) : type === 'decimal' ? (0, $f4c432f4e2afe4c4$export$2ad0182371401ea4) : (0, $3f9f3b58086dafe4$export$8ec2d91f756e9f4);
            end--;
            while(++end <= value.length){
                const following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += String.fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === 'named' && (0, $f85a704f15ad9b04$export$9545335bdecb4b8c).includes(characters)) {
                    characterReferenceCharacters = characters;
                    // @ts-expect-error: always able to decode.
                    characterReference = (0, $60664567fce6b3e5$export$289b6a6320f709b4)(characters);
                }
            }
            let terminated = value.charCodeAt(end) === 59 /* `;` */ ;
            if (terminated) {
                end++;
                const namedReference = type === 'named' ? (0, $60664567fce6b3e5$export$289b6a6320f709b4)(characters) : false;
                if (namedReference) {
                    characterReferenceCharacters = characters;
                    characterReference = namedReference;
                }
            }
            let diff = 1 + end - start;
            let reference = '';
            if (!terminated && settings.nonTerminated === false) ;
            else if (!characters) // An empty (possible) reference is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== 'named') warning(4 /* Empty (numeric) */ , diff);
            } else if (type === 'named') {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !characterReference) warning(5 /* Unknown (named) */ , 1);
                else {
                    // If there’s something after an named reference which is not known,
                    // cap the reference.
                    if (characterReferenceCharacters !== characters) {
                        end = begin + characterReferenceCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        const reason = characterReferenceCharacters ? 1 /* Non terminated (named) */  : 3 /* Empty (named) */ ;
                        if (settings.attribute) {
                            const following = value.charCodeAt(end);
                            if (following === 61 /* `=` */ ) {
                                warning(reason, diff);
                                characterReference = '';
                            } else if ((0, $d44106a7ab41758f$export$176ed353558777b8)(following)) characterReference = '';
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = characterReference;
            } else {
                if (!terminated) // All nonterminated numeric references are not rendered, and emit a
                // warning.
                warning(2 /* Non terminated (numeric) */ , diff);
                // When terminated and numerical, parse as either hexadecimal or
                // decimal.
                let referenceCode = Number.parseInt(characters, type === 'hexadecimal' ? 16 : 10);
                // Emit a warning when the parsed number is prohibited, and replace with
                // replacement character.
                if ($973030697e92923e$var$prohibited(referenceCode)) {
                    warning(7 /* Prohibited (numeric) */ , diff);
                    reference = String.fromCharCode(65533 /* `�` */ );
                } else if (referenceCode in (0, $e886b9f30315dd74$export$18e663c9b25e3b2)) {
                    // Emit a warning when the parsed number is disallowed, and replace by
                    // an alternative.
                    warning(6 /* Disallowed (numeric) */ , diff);
                    reference = (0, $e886b9f30315dd74$export$18e663c9b25e3b2)[referenceCode];
                } else {
                    // Parse the number.
                    let output = '';
                    // Emit a warning when the parsed number should not be used.
                    if ($973030697e92923e$var$disallowed(referenceCode)) warning(6 /* Disallowed (numeric) */ , diff);
                    // Serialize the number.
                    if (referenceCode > 0xffff) {
                        referenceCode -= 0x10000;
                        output += String.fromCharCode(referenceCode >>> 10 | 0xd800);
                        referenceCode = 0xdc00 | referenceCode & 0x3ff;
                    }
                    reference = output + String.fromCharCode(referenceCode);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat a reference.
            if (reference) {
                flush();
                previous = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                const next = now();
                next.offset++;
                if (settings.reference) settings.reference.call(settings.referenceContext || undefined, reference, {
                    start: previous,
                    end: next
                }, value.slice(start - 1, end));
                previous = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 /* `\n` */ ) {
                line++;
                lines++;
                column = 0;
            }
            if (Number.isNaN(character)) flush();
            else {
                queue += String.fromCharCode(character);
                column++;
            }
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + ((point ? point.offset : 0) || 0)
        };
    }
    /**
   * Handle the warning.
   *
   * @param {1|2|3|4|5|6|7} code
   * @param {number} offset
   */ function warning(code, offset) {
        /** @type {ReturnType<now>} */ let position;
        if (settings.warning) {
            position = now();
            position.column += offset;
            position.offset += offset;
            settings.warning.call(settings.warningContext || undefined, $973030697e92923e$var$messages[code], position, code);
        }
    }
    /**
   * Flush `queue` (normal text).
   * Macro invoked before each reference and at the end of `value`.
   * Does nothing when `queue` is empty.
   */ function flush() {
        if (queue) {
            result.push(queue);
            if (settings.text) settings.text.call(settings.textContext || undefined, queue, {
                start: previous,
                end: now()
            });
            queue = '';
        }
    }
}
/**
 * Check if `character` is outside the permissible unicode range.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $973030697e92923e$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
/**
 * Check if `character` is disallowed.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $973030697e92923e$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}


// @ts-nocheck
// This is a slimmed down version of `prism-core.js`, to remove globals,
// document, workers, `util.encode`, `Token.stringify`
// Private helper vars
var $a07a72074d5093fa$var$lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
var $a07a72074d5093fa$var$uniqueId = 0;
// The grammar object for plaintext
var $a07a72074d5093fa$var$plainTextGrammar = {};
var $a07a72074d5093fa$var$_ = {
    /**
   * A namespace for utility methods.
   *
   * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
   * change or disappear at any time.
   *
   * @namespace
   * @memberof Prism
   */ util: {
        /**
     * Returns the name of the type of the given value.
     *
     * @param {any} o
     * @returns {string}
     * @example
     * type(null)      === 'Null'
     * type(undefined) === 'Undefined'
     * type(123)       === 'Number'
     * type('foo')     === 'String'
     * type(true)      === 'Boolean'
     * type([1, 2])    === 'Array'
     * type({})        === 'Object'
     * type(String)    === 'Function'
     * type(/abc+/)    === 'RegExp'
     */ type: function(o) {
            return Object.prototype.toString.call(o).slice(8, -1);
        },
        /**
     * Returns a unique number for the given object. Later calls will still return the same number.
     *
     * @param {Object} obj
     * @returns {number}
     */ objId: function(obj) {
            if (!obj['__id']) Object.defineProperty(obj, '__id', {
                value: ++$a07a72074d5093fa$var$uniqueId
            });
            return obj['__id'];
        },
        /**
     * Creates a deep clone of the given object.
     *
     * The main intended use of this function is to clone language definitions.
     *
     * @param {T} o
     * @param {Record<number, any>} [visited]
     * @returns {T}
     * @template T
     */ clone: function deepClone(o, visited) {
            visited = visited || {};
            var clone;
            var id;
            switch($a07a72074d5093fa$var$_.util.type(o)){
                case 'Object':
                    id = $a07a72074d5093fa$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = /** @type {Record<string, any>} */ {};
                    visited[id] = clone;
                    for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                    return /** @type {any} */ clone;
                case 'Array':
                    id = $a07a72074d5093fa$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = [];
                    visited[id] = clone; /** @type {Array} */ 
                    /** @type {any} */ o.forEach(function(v, i) {
                        clone[i] = deepClone(v, visited);
                    });
                    return /** @type {any} */ clone;
                default:
                    return o;
            }
        }
    },
    /**
   * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
   *
   * @namespace
   * @memberof Prism
   * @public
   */ languages: {
        /**
     * The grammar for plain, unformatted text.
     */ plain: $a07a72074d5093fa$var$plainTextGrammar,
        plaintext: $a07a72074d5093fa$var$plainTextGrammar,
        text: $a07a72074d5093fa$var$plainTextGrammar,
        txt: $a07a72074d5093fa$var$plainTextGrammar,
        /**
     * Creates a deep copy of the language with the given id and appends the given tokens.
     *
     * If a token in `redef` also appears in the copied language, then the existing token in the copied language
     * will be overwritten at its original position.
     *
     * ## Best practices
     *
     * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
     * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
     * understand the language definition because, normally, the order of tokens matters in Prism grammars.
     *
     * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
     * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
     *
     * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
     * @param {Grammar} redef The new tokens to append.
     * @returns {Grammar} The new language created.
     * @public
     * @example
     * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
     *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
     *     // at its original position
     *     'comment': { ... },
     *     // CSS doesn't have a 'color' token, so this token will be appended
     *     'color': /\b(?:red|green|blue)\b/
     * });
     */ extend: function(id, redef) {
            var lang = $a07a72074d5093fa$var$_.util.clone($a07a72074d5093fa$var$_.languages[id]);
            for(var key in redef)lang[key] = redef[key];
            return lang;
        },
        /**
     * Inserts tokens _before_ another token in a language definition or any other grammar.
     *
     * ## Usage
     *
     * This helper method makes it easy to modify existing languages. For example, the CSS language definition
     * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
     * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
     * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
     * this:
     *
     * ```js
     * Prism.languages.markup.style = {
     *     // token
     * };
     * ```
     *
     * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
     * before existing tokens. For the CSS example above, you would use it like this:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'cdata', {
     *     'style': {
     *         // token
     *     }
     * });
     * ```
     *
     * ## Special cases
     *
     * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
     * will be ignored.
     *
     * This behavior can be used to insert tokens after `before`:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'comment', {
     *     'comment': Prism.languages.markup.comment,
     *     // tokens after 'comment'
     * });
     * ```
     *
     * ## Limitations
     *
     * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
     * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
     * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
     * deleting properties which is necessary to insert at arbitrary positions.
     *
     * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
     * Instead, it will create a new object and replace all references to the target object with the new one. This
     * can be done without temporarily deleting properties, so the iteration order is well-defined.
     *
     * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
     * you hold the target object in a variable, then the value of the variable will not change.
     *
     * ```js
     * var oldMarkup = Prism.languages.markup;
     * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
     *
     * assert(oldMarkup !== Prism.languages.markup);
     * assert(newMarkup === Prism.languages.markup);
     * ```
     *
     * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
     * object to be modified.
     * @param {string} before The key to insert before.
     * @param {Grammar} insert An object containing the key-value pairs to be inserted.
     * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
     * object to be modified.
     *
     * Defaults to `Prism.languages`.
     * @returns {Grammar} The new grammar object.
     * @public
     */ insertBefore: function(inside, before, insert, root) {
            root = root || /** @type {any} */ $a07a72074d5093fa$var$_.languages;
            var grammar = root[inside];
            /** @type {Grammar} */ var ret = {};
            for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                if (token == before) {
                    for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                }
                // Do not insert token which also occur in insert. See #1525
                if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
            }
            var old = root[inside];
            root[inside] = ret;
            // Update references in other language definitions
            $a07a72074d5093fa$var$_.languages.DFS($a07a72074d5093fa$var$_.languages, function(key, value) {
                if (value === old && key != inside) this[key] = ret;
            });
            return ret;
        },
        // Traverse a language definition with Depth First Search
        DFS: function DFS(o, callback, type, visited) {
            visited = visited || {};
            var objId = $a07a72074d5093fa$var$_.util.objId;
            for(var i in o)if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type || i);
                var property = o[i];
                var propertyType = $a07a72074d5093fa$var$_.util.type(property);
                if (propertyType === 'Object' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, null, visited);
                } else if (propertyType === 'Array' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, i, visited);
                }
            }
        }
    },
    plugins: {},
    /**
   * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
   * and the language definitions to use, and returns a string with the HTML produced.
   *
   * The following hooks will be run:
   * 1. `before-tokenize`
   * 2. `after-tokenize`
   * 3. `wrap`: On each {@link Token}.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @param {string} language The name of the language definition passed to `grammar`.
   * @returns {string} The highlighted HTML.
   * @memberof Prism
   * @public
   * @example
   * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
   */ highlight: function(text, grammar, language) {
        var env = {
            code: text,
            grammar: grammar,
            language: language
        };
        $a07a72074d5093fa$var$_.hooks.run('before-tokenize', env);
        if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
        env.tokens = $a07a72074d5093fa$var$_.tokenize(env.code, env.grammar);
        $a07a72074d5093fa$var$_.hooks.run('after-tokenize', env);
        return $a07a72074d5093fa$var$Token.stringify($a07a72074d5093fa$var$_.util.encode(env.tokens), env.language);
    },
    /**
   * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
   * and the language definitions to use, and returns an array with the tokenized code.
   *
   * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
   *
   * This method could be useful in other contexts as well, as a very crude parser.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @returns {TokenStream} An array of strings and tokens, a token stream.
   * @memberof Prism
   * @public
   * @example
   * let code = `var foo = 0;`;
   * let tokens = Prism.tokenize(code, Prism.languages.javascript);
   * tokens.forEach(token => {
   *     if (token instanceof Prism.Token && token.type === 'number') {
   *         console.log(`Found numeric literal: ${token.content}`);
   *     }
   * });
   */ tokenize: function(text, grammar) {
        var rest = grammar.rest;
        if (rest) {
            for(var token in rest)grammar[token] = rest[token];
            delete grammar.rest;
        }
        var tokenList = new $a07a72074d5093fa$var$LinkedList();
        $a07a72074d5093fa$var$addAfter(tokenList, tokenList.head, text);
        $a07a72074d5093fa$var$matchGrammar(text, tokenList, grammar, tokenList.head, 0);
        return $a07a72074d5093fa$var$toArray(tokenList);
    },
    /**
   * @namespace
   * @memberof Prism
   * @public
   */ hooks: {
        all: {},
        /**
     * Adds the given callback to the list of callbacks for the given hook.
     *
     * The callback will be invoked when the hook it is registered for is run.
     * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
     *
     * One callback function can be registered to multiple hooks and the same hook multiple times.
     *
     * @param {string} name The name of the hook.
     * @param {HookCallback} callback The callback function which is given environment variables.
     * @public
     */ add: function(name, callback) {
            var hooks = $a07a72074d5093fa$var$_.hooks.all;
            hooks[name] = hooks[name] || [];
            hooks[name].push(callback);
        },
        /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */ run: function(name, env) {
            var callbacks = $a07a72074d5093fa$var$_.hooks.all[name];
            if (!callbacks || !callbacks.length) return;
            for(var i = 0, callback; callback = callbacks[i++];)callback(env);
        }
    },
    Token: $a07a72074d5093fa$var$Token
};
// Typescript note:
// The following can be used to import the Token type in JSDoc:
//
//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
/**
 * Creates a new token.
 *
 * @param {string} type See {@link Token#type type}
 * @param {string | TokenStream} content See {@link Token#content content}
 * @param {string|string[]} [alias] The alias(es) of the token.
 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
 * @class
 * @global
 * @public
 */ function $a07a72074d5093fa$var$Token(type, content, alias, matchedStr) {
    /**
   * The type of the token.
   *
   * This is usually the key of a pattern in a {@link Grammar}.
   *
   * @type {string}
   * @see GrammarToken
   * @public
   */ this.type = type;
    /**
   * The strings or tokens contained by this token.
   *
   * This will be a token stream if the pattern matched also defined an `inside` grammar.
   *
   * @type {string | TokenStream}
   * @public
   */ this.content = content;
    /**
   * The alias(es) of the token.
   *
   * @type {string|string[]}
   * @see GrammarToken
   * @public
   */ this.alias = alias;
    // Copy of the full string this token was created from
    this.length = (matchedStr || '').length | 0;
}
/**
 * A token stream is an array of strings and {@link Token Token} objects.
 *
 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
 * them.
 *
 * 1. No adjacent strings.
 * 2. No empty strings.
 *
 *    The only exception here is the token stream that only contains the empty string and nothing else.
 *
 * @typedef {Array<string | Token>} TokenStream
 * @global
 * @public
 */ /**
 * @param {RegExp} pattern
 * @param {number} pos
 * @param {string} text
 * @param {boolean} lookbehind
 * @returns {RegExpExecArray | null}
 */ function $a07a72074d5093fa$var$matchPattern(pattern, pos, text, lookbehind) {
    pattern.lastIndex = pos;
    var match = pattern.exec(text);
    if (match && lookbehind && match[1]) {
        // change the match to remove the text matched by the Prism lookbehind group
        var lookbehindLength = match[1].length;
        match.index += lookbehindLength;
        match[0] = match[0].slice(lookbehindLength);
    }
    return match;
}
/**
 * @param {string} text
 * @param {LinkedList<string | Token>} tokenList
 * @param {any} grammar
 * @param {LinkedListNode<string | Token>} startNode
 * @param {number} startPos
 * @param {RematchOptions} [rematch]
 * @returns {void}
 * @private
 *
 * @typedef RematchOptions
 * @property {string} cause
 * @property {number} reach
 */ function $a07a72074d5093fa$var$matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
    for(var token in grammar){
        if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
        var patterns = grammar[token];
        patterns = Array.isArray(patterns) ? patterns : [
            patterns
        ];
        for(var j = 0; j < patterns.length; ++j){
            if (rematch && rematch.cause == token + ',' + j) return;
            var patternObj = patterns[j];
            var inside = patternObj.inside;
            var lookbehind = !!patternObj.lookbehind;
            var greedy = !!patternObj.greedy;
            var alias = patternObj.alias;
            if (greedy && !patternObj.pattern.global) {
                // Without the global flag, lastIndex won't work
                var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
            }
            /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
            for(// iterate the token list and keep track of the current token/string position
            var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                if (rematch && pos >= rematch.reach) break;
                var str = currentNode.value;
                if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                return;
                if (str instanceof $a07a72074d5093fa$var$Token) continue;
                var removeCount = 1 // this is the to parameter of removeBetween
                ;
                var match;
                if (greedy) {
                    match = $a07a72074d5093fa$var$matchPattern(pattern, pos, text, lookbehind);
                    if (!match || match.index >= text.length) break;
                    var from = match.index;
                    var to = match.index + match[0].length;
                    var p = pos;
                    // find the node that contains the match
                    p += currentNode.value.length;
                    while(from >= p){
                        currentNode = currentNode.next;
                        p += currentNode.value.length;
                    }
                    // adjust pos (and p)
                    p -= currentNode.value.length;
                    pos = p;
                    // the current node is a Token, then the match starts inside another Token, which is invalid
                    if (currentNode.value instanceof $a07a72074d5093fa$var$Token) continue;
                    // find the last node which is affected by this match
                    for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                        removeCount++;
                        p += k.value.length;
                    }
                    removeCount--;
                    // replace with the new match
                    str = text.slice(pos, p);
                    match.index -= pos;
                } else {
                    match = $a07a72074d5093fa$var$matchPattern(pattern, 0, str, lookbehind);
                    if (!match) continue;
                }
                // eslint-disable-next-line no-redeclare
                var from = match.index;
                var matchStr = match[0];
                var before = str.slice(0, from);
                var after = str.slice(from + matchStr.length);
                var reach = pos + str.length;
                if (rematch && reach > rematch.reach) rematch.reach = reach;
                var removeFrom = currentNode.prev;
                if (before) {
                    removeFrom = $a07a72074d5093fa$var$addAfter(tokenList, removeFrom, before);
                    pos += before.length;
                }
                $a07a72074d5093fa$var$removeRange(tokenList, removeFrom, removeCount);
                var wrapped = new $a07a72074d5093fa$var$Token(token, inside ? $a07a72074d5093fa$var$_.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                currentNode = $a07a72074d5093fa$var$addAfter(tokenList, removeFrom, wrapped);
                if (after) $a07a72074d5093fa$var$addAfter(tokenList, currentNode, after);
                if (removeCount > 1) {
                    // at least one Token object was removed, so we have to do some rematching
                    // this can only happen if the current pattern is greedy
                    /** @type {RematchOptions} */ var nestedRematch = {
                        cause: token + ',' + j,
                        reach: reach
                    };
                    $a07a72074d5093fa$var$matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                    // the reach might have been extended because of the rematching
                    if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                }
            }
        }
    }
}
/**
 * @typedef LinkedListNode
 * @property {T} value
 * @property {LinkedListNode<T> | null} prev The previous node.
 * @property {LinkedListNode<T> | null} next The next node.
 * @template T
 * @private
 */ /**
 * @template T
 * @private
 */ function $a07a72074d5093fa$var$LinkedList() {
    /** @type {LinkedListNode<T>} */ var head = {
        value: null,
        prev: null,
        next: null
    };
    /** @type {LinkedListNode<T>} */ var tail = {
        value: null,
        prev: head,
        next: null
    };
    head.next = tail;
    /** @type {LinkedListNode<T>} */ this.head = head;
    /** @type {LinkedListNode<T>} */ this.tail = tail;
    this.length = 0;
}
/**
 * Adds a new node with the given value to the list.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {T} value
 * @returns {LinkedListNode<T>} The added node.
 * @template T
 */ function $a07a72074d5093fa$var$addAfter(list, node, value) {
    // assumes that node != list.tail && values.length >= 0
    var next = node.next;
    var newNode = {
        value: value,
        prev: node,
        next: next
    };
    node.next = newNode;
    next.prev = newNode;
    list.length++;
    return newNode;
}
/**
 * Removes `count` nodes after the given node. The given node will not be removed.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {number} count
 * @template T
 */ function $a07a72074d5093fa$var$removeRange(list, node, count) {
    var next = node.next;
    for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
    node.next = next;
    next.prev = node;
    list.length -= i;
}
/**
 * @param {LinkedList<T>} list
 * @returns {T[]}
 * @template T
 */ function $a07a72074d5093fa$var$toArray(list) {
    var array = [];
    var node = list.head.next;
    while(node !== list.tail){
        array.push(node.value);
        node = node.next;
    }
    return array;
}
const $a07a72074d5093fa$export$dc7257ffb0972f87 = $a07a72074d5093fa$var$_;


// Inherit.
function $15eb5e2cbed3153e$var$Refractor() {}
$15eb5e2cbed3153e$var$Refractor.prototype = (0, $a07a72074d5093fa$export$dc7257ffb0972f87);
const $15eb5e2cbed3153e$export$1c6435d0b8e9f390 = new $15eb5e2cbed3153e$var$Refractor();
// Create.
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.highlight = $15eb5e2cbed3153e$var$highlight;
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.register = $15eb5e2cbed3153e$var$register;
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.alias = $15eb5e2cbed3153e$var$alias;
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.registered = $15eb5e2cbed3153e$var$registered;
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.listLanguages = $15eb5e2cbed3153e$var$listLanguages;
// @ts-expect-error Overwrite Prism.
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.util.encode = $15eb5e2cbed3153e$var$encode;
// @ts-expect-error Overwrite Prism.
$15eb5e2cbed3153e$export$1c6435d0b8e9f390.Token.stringify = $15eb5e2cbed3153e$var$stringify;
/**
 * Highlight `value` (code) as `language` (programming language).
 *
 * @param {string} value
 *   Code to highlight.
 * @param {Grammar | string} language
 *   Programming language name, alias, or grammar.
 * @returns {Root}
 *   Node representing highlighted code.
 */ function $15eb5e2cbed3153e$var$highlight(value, language) {
    if (typeof value !== 'string') throw new TypeError('Expected `string` for `value`, got `' + value + '`');
    /** @type {Grammar} */ let grammar;
    /** @type {string | undefined} */ let name;
    // `name` is a grammar object.
    // This was called internally by Prism.js before 1.28.0.
    /* c8 ignore next 2 */ if (language && typeof language === 'object') grammar = language;
    else {
        name = language;
        if (typeof name !== 'string') throw new TypeError('Expected `string` for `name`, got `' + name + '`');
        if (Object.hasOwn($15eb5e2cbed3153e$export$1c6435d0b8e9f390.languages, name)) grammar = $15eb5e2cbed3153e$export$1c6435d0b8e9f390.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return {
        type: 'root',
        // @ts-expect-error: we hacked Prism to accept and return the things we want.
        children: (0, $a07a72074d5093fa$export$dc7257ffb0972f87).highlight.call($15eb5e2cbed3153e$export$1c6435d0b8e9f390, value, grammar, name)
    };
}
/**
 * Register a syntax.
 *
 * @param {Syntax} syntax
 *   Language function made for refractor, as in, the files in
 *   `refractor/lang/*.js`.
 * @returns {undefined}
 *   Nothing.
 */ function $15eb5e2cbed3153e$var$register(syntax) {
    if (typeof syntax !== 'function' || !syntax.displayName) throw new Error('Expected `function` for `syntax`, got `' + syntax + '`');
    // Do not duplicate registrations.
    if (!Object.hasOwn($15eb5e2cbed3153e$export$1c6435d0b8e9f390.languages, syntax.displayName)) syntax($15eb5e2cbed3153e$export$1c6435d0b8e9f390);
}
/**
 * Register aliases for already registered languages.
 *
 * @param {Record<string, ReadonlyArray<string> | string> | string} language
 *   Language to alias.
 * @param {ReadonlyArray<string> | string | null | undefined} [alias]
 *   Aliases.
 * @returns {undefined}
 *   Nothing.
 */ function $15eb5e2cbed3153e$var$alias(language, alias) {
    const languages = $15eb5e2cbed3153e$export$1c6435d0b8e9f390.languages;
    /** @type {Record<string, ReadonlyArray<string> | string>} */ let map = {};
    if (typeof language === 'string') {
        if (alias) map[language] = alias;
    } else map = language;
    /** @type {string} */ let key;
    for(key in map)if (Object.hasOwn(map, key)) {
        const value = map[key];
        const list = typeof value === 'string' ? [
            value
        ] : value;
        let index = -1;
        while(++index < list.length)languages[list[index]] = languages[key];
    }
}
/**
 * Check whether an `alias` or `language` is registered.
 *
 * @param {string} aliasOrLanguage
 *   Language or alias to check.
 * @returns {boolean}
 *   Whether the language is registered.
 */ function $15eb5e2cbed3153e$var$registered(aliasOrLanguage) {
    if (typeof aliasOrLanguage !== 'string') throw new TypeError('Expected `string` for `aliasOrLanguage`, got `' + aliasOrLanguage + '`');
    return Object.hasOwn($15eb5e2cbed3153e$export$1c6435d0b8e9f390.languages, aliasOrLanguage);
}
/**
 * List all registered languages (names and aliases).
 *
 * @returns {Array<string>}
 *   List of language names.
 */ function $15eb5e2cbed3153e$var$listLanguages() {
    const languages = $15eb5e2cbed3153e$export$1c6435d0b8e9f390.languages;
    /** @type {Array<string>} */ const list = [];
    /** @type {string} */ let language;
    for(language in languages)if (Object.hasOwn(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
/**
 * @param {Array<_Token | string> | _Token | string} value
 *   Token to stringify.
 * @param {string} language
 *   Language of the token.
 * @returns {Array<Element | Text> | Element | Text}
 *   Node representing the token.
 */ function $15eb5e2cbed3153e$var$stringify(value, language) {
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if (Array.isArray(value)) {
        /** @type {Array<Element | Text>} */ const result = [];
        let index = -1;
        while(++index < value.length)if (value[index] !== null && value[index] !== undefined && value[index] !== '') // Cast because we assume no sub-arrays.
        result.push(/** @type {Element | Text} */ $15eb5e2cbed3153e$var$stringify(value[index], language));
        return result;
    }
    /** @type {_Env} */ const env = {
        attributes: {},
        classes: [
            'token',
            value.type
        ],
        content: $15eb5e2cbed3153e$var$stringify(value.content, language),
        language: language,
        tag: 'span',
        type: value.type
    };
    if (value.alias) env.classes.push(...typeof value.alias === 'string' ? [
        value.alias
    ] : value.alias);
    // @ts-expect-error Prism.
    $15eb5e2cbed3153e$export$1c6435d0b8e9f390.hooks.run('wrap', env);
    return (0, $fbc900b0910ebaeb$export$dda1d9f60106f0e9)(env.tag + '.' + env.classes.join('.'), $15eb5e2cbed3153e$var$attributes(env.attributes), env.content);
}
/**
 * @template {unknown} T
 *   Tokens.
 * @param {T} tokens
 *   Input.
 * @returns {T}
 *   Output, same as input.
 */ function $15eb5e2cbed3153e$var$encode(tokens) {
    return tokens;
}
/**
 * @param {Record<string, string>} record
 *   Attributes.
 * @returns {Record<string, string>}
 *   Attributes.
 */ function $15eb5e2cbed3153e$var$attributes(record) {
    /** @type {string} */ let key;
    for(key in record)if (Object.hasOwn(record, key)) record[key] = (0, $973030697e92923e$export$6c6c782be925911c)(record[key]);
    return record;
}


var $0c9dfd6cf9ab0903$var$SyntaxHighlighter = (0, $9eb8246b3bcffd27$export$2e2bcd8739ae039)((0, $15eb5e2cbed3153e$export$1c6435d0b8e9f390), {});
$0c9dfd6cf9ab0903$var$SyntaxHighlighter.registerLanguage = function(_, language) {
    return (0, $15eb5e2cbed3153e$export$1c6435d0b8e9f390).register(language);
};
$0c9dfd6cf9ab0903$var$SyntaxHighlighter.alias = function(name, aliases) {
    return (0, $15eb5e2cbed3153e$export$1c6435d0b8e9f390).alias(name, aliases);
};
var $0c9dfd6cf9ab0903$export$2e2bcd8739ae039 = $0c9dfd6cf9ab0903$var$SyntaxHighlighter;


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5835e84a7c3c119b$export$2e2bcd8739ae039.displayName = 'json';
$5835e84a7c3c119b$export$2e2bcd8739ae039.aliases = [
    'webmanifest'
];
function $5835e84a7c3c119b$export$2e2bcd8739ae039(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}


var $d6cf59d94d0f48cd$export$2e2bcd8739ae039 = (0, $5835e84a7c3c119b$export$2e2bcd8739ae039);


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ // @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0048e1ea1fc673d8$export$2e2bcd8739ae039.displayName = 'markup';
$0048e1ea1fc673d8$export$2e2bcd8739ae039.aliases = [
    'atom',
    'html',
    'mathml',
    'rss',
    'ssml',
    'svg',
    'xml'
];
function $0048e1ea1fc673d8$export$2e2bcd8739ae039(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
    // Plugin to make entity title show the real entity, idea by Roman Komarov
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}


$0f3fdc7351241567$export$2e2bcd8739ae039.displayName = 'markdown';
$0f3fdc7351241567$export$2e2bcd8739ae039.aliases = [
    'md'
];
function $0f3fdc7351241567$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0048e1ea1fc673d8$export$2e2bcd8739ae039));
    (function(Prism) {
        // Allow only one line break
        var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
        /**
     * This function is intended for the creation of the bold or italic pattern.
     *
     * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
     *
     * _Note:_ Keep in mind that this adds a capturing group.
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function createInline(pattern) {
            pattern = pattern.replace(/<inner>/g, function() {
                return inner;
            });
            return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
        }
        var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
        var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
            return tableCell;
        });
        var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
        Prism.languages.markdown = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('markdown', 'prolog', {
            'front-matter-block': {
                pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^---|---$/,
                    'front-matter': {
                        pattern: /\S+(?:\s+\S+)*/,
                        alias: [
                            'yaml',
                            'language-yaml'
                        ],
                        inside: Prism.languages.yaml
                    }
                }
            },
            blockquote: {
                // > ...
                pattern: /^>(?:[\t ]*>)*/m,
                alias: 'punctuation'
            },
            table: {
                pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
                inside: {
                    'table-data-rows': {
                        pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                        lookbehind: true,
                        inside: {
                            'table-data': {
                                pattern: RegExp(tableCell),
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    },
                    'table-line': {
                        pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                        lookbehind: true,
                        inside: {
                            punctuation: /\||:?-{3,}:?/
                        }
                    },
                    'table-header-row': {
                        pattern: RegExp('^' + tableRow + '$'),
                        inside: {
                            'table-header': {
                                pattern: RegExp(tableCell),
                                alias: 'important',
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    }
                }
            },
            code: [
                {
                    // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                    pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                {
                    // ```optional language
                    // code block
                    // ```
                    pattern: /^```[\s\S]*?^```$/m,
                    greedy: true,
                    inside: {
                        'code-block': {
                            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                            lookbehind: true
                        },
                        'code-language': {
                            pattern: /^(```).+/,
                            lookbehind: true
                        },
                        punctuation: /```/
                    }
                }
            ],
            title: [
                {
                    // title 1
                    // =======
                    // title 2
                    // -------
                    pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                    alias: 'important',
                    inside: {
                        punctuation: /==+$|--+$/
                    }
                },
                {
                    // # title 1
                    // ###### title 6
                    pattern: /(^\s*)#.+/m,
                    lookbehind: true,
                    alias: 'important',
                    inside: {
                        punctuation: /^#+|#+$/
                    }
                }
            ],
            hr: {
                // ***
                // ---
                // * * *
                // -----------
                pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            list: {
                // * item
                // + item
                // - item
                // 1. item
                pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            'url-reference': {
                // [id]: http://example.com "Optional title"
                // [id]: http://example.com 'Optional title'
                // [id]: http://example.com (Optional title)
                // [id]: <http://example.com> "Optional title"
                pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                inside: {
                    variable: {
                        pattern: /^(!?\[)[^\]]+/,
                        lookbehind: true
                    },
                    string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                    punctuation: /^[\[\]!:]|[<>]/
                },
                alias: 'url'
            },
            bold: {
                // **strong**
                // __strong__
                // allow one nested instance of italic text using the same delimiter
                pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^..)[\s\S]+(?=..$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /\*\*|__/
                }
            },
            italic: {
                // *em*
                // _em_
                // allow one nested instance of bold text using the same delimiter
                pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^.)[\s\S]+(?=.$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /[*_]/
                }
            },
            strike: {
                // ~~strike through~~
                // ~strike~
                // eslint-disable-next-line regexp/strict
                pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^~~?)[\s\S]+(?=\1$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /~~?/
                }
            },
            'code-snippet': {
                // `code`
                // ``code``
                pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                lookbehind: true,
                greedy: true,
                alias: [
                    'code',
                    'keyword'
                ]
            },
            url: {
                // [example](http://example.com "Optional title")
                // [example][id]
                // [example] [id]
                pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    operator: /^!/,
                    content: {
                        pattern: /(^\[)[^\]]+(?=\])/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    variable: {
                        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                        lookbehind: true
                    },
                    url: {
                        pattern: /(^\]\()[^\s)]+/,
                        lookbehind: true
                    },
                    string: {
                        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                        lookbehind: true
                    }
                }
            }
        });
        [
            'url',
            'bold',
            'italic',
            'strike'
        ].forEach(function(token) {
            [
                'url',
                'bold',
                'italic',
                'strike',
                'code-snippet'
            ].forEach(function(inside) {
                if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
            });
        });
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'markdown' && env.language !== 'md') return;
            function walkTokens(tokens) {
                if (!tokens || typeof tokens === 'string') return;
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (token.type !== 'code') {
                        walkTokens(token.content);
                        continue;
                    }
                    /*
           * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
           * is optional. But the grammar is defined so that there is only one case we have to handle:
           *
           * token.content = [
           *     <span class="punctuation">```</span>,
           *     <span class="code-language">xxxx</span>,
           *     '\n', // exactly one new lines (\r or \n or \r\n)
           *     <span class="code-block">...</span>,
           *     '\n', // exactly one new lines again
           *     <span class="punctuation">```</span>
           * ];
           */ var codeLang = token.content[1];
                    var codeBlock = token.content[3];
                    if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                        // this might be a language that Prism does not support
                        // do some replacements to support C++, C#, and F#
                        var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
                        // only use the first word
                        lang = (/[a-z][\w-]*/i.exec(lang) || [
                            ''
                        ])[0].toLowerCase();
                        var alias = 'language-' + lang;
                        // add alias
                        if (!codeBlock.alias) codeBlock.alias = [
                            alias
                        ];
                        else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                            codeBlock.alias,
                            alias
                        ];
                        else codeBlock.alias.push(alias);
                    }
                }
            }
            walkTokens(env.tokens);
        });
        Prism.hooks.add('wrap', function(env) {
            if (env.type !== 'code-block') return;
            var codeLang = '';
            for(var i = 0, l = env.classes.length; i < l; i++){
                var cls = env.classes[i];
                var match = /language-(.+)/.exec(cls);
                if (match) {
                    codeLang = match[1];
                    break;
                }
            }
            var grammar = Prism.languages[codeLang];
            if (!grammar) {
                if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                    var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                    env.attributes['id'] = id;
                    Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                        var ele = document.getElementById(id);
                        if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                    });
                }
            } else env.content = Prism.highlight(env.content.value, grammar, codeLang);
        });
        var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
        /**
     * A list of known entity names.
     *
     * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
     *
     * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
     */ var KNOWN_ENTITY_NAMES = {
            amp: '&',
            lt: '<',
            gt: '>',
            quot: '"'
        };
        // IE 11 doesn't support `String.fromCodePoint`
        var fromCodePoint = String.fromCodePoint || String.fromCharCode;
        /**
     * Returns the text content of a given HTML source code string.
     *
     * @param {string} html
     * @returns {string}
     */ function textContent(html) {
            // remove all tags
            var text = html.replace(tagPattern, '');
            // decode known entities
            text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                code = code.toLowerCase();
                if (code[0] === '#') {
                    var value;
                    if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                    else value = Number(code.slice(1));
                    return fromCodePoint(value);
                } else {
                    var known = KNOWN_ENTITY_NAMES[code];
                    if (known) return known;
                    // unable to decode
                    return m;
                }
            });
            return text;
        }
        Prism.languages.md = Prism.languages.markdown;
    })(Prism);
}


var $ac9ce1e4897eda61$export$2e2bcd8739ae039 = (0, $0f3fdc7351241567$export$2e2bcd8739ae039);


const $0347a5abd1c6cdfa$var$property = " pz2bZib182";
const $0347a5abd1c6cdfa$var$number = " pG3CxWc182";
const $0347a5abd1c6cdfa$var$fn = " p37ZLpd182";
const $0347a5abd1c6cdfa$var$variable = " p1gYRFc182";
const $0347a5abd1c6cdfa$var$comment = " pv182";
const $0347a5abd1c6cdfa$var$string = " p8wMsQe182";
const $0347a5abd1c6cdfa$var$content = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182";
const $0347a5abd1c6cdfa$var$code = " uj182";
const $0347a5abd1c6cdfa$var$title = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182";
const $0347a5abd1c6cdfa$var$bold = " xd182 _xa182 xX0cczbc182 _xX0cczba182";
const $0347a5abd1c6cdfa$export$5e5ebb8e12ca7518 = {
    keyword: " pplLfSc182",
    string: $0347a5abd1c6cdfa$var$string,
    number: $0347a5abd1c6cdfa$var$number,
    boolean: $0347a5abd1c6cdfa$var$number,
    property: $0347a5abd1c6cdfa$var$property,
    attribute: $0347a5abd1c6cdfa$var$property,
    function: $0347a5abd1c6cdfa$var$fn,
    tag: $0347a5abd1c6cdfa$var$fn,
    constructor: $0347a5abd1c6cdfa$var$fn,
    comment: $0347a5abd1c6cdfa$var$comment,
    linenumber: " pp182",
    variable: $0347a5abd1c6cdfa$var$variable,
    hex: $0347a5abd1c6cdfa$var$variable,
    regex: $0347a5abd1c6cdfa$var$variable,
    deliminator: $0347a5abd1c6cdfa$var$variable,
    url: " ps182",
    import: " sVKiwQd182",
    content: $0347a5abd1c6cdfa$var$content,
    code: $0347a5abd1c6cdfa$var$code,
    "code-language": $0347a5abd1c6cdfa$var$string,
    title: $0347a5abd1c6cdfa$var$title,
    bold: $0347a5abd1c6cdfa$var$bold,
    important: $0347a5abd1c6cdfa$var$bold,
    punctuation: " pv182 uj182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182",
    list: " s40ub4c182 pHg9ZFc182",
    hr: $0347a5abd1c6cdfa$var$bold,
    italic: "",
    blockquote: " sg182 Sf182 _jf182 _ka182 ha182 mc182 la182 io182",
    strike: " _X4WbDMd182"
};


(0, $0c9dfd6cf9ab0903$export$2e2bcd8739ae039).registerLanguage("json", (0, $d6cf59d94d0f48cd$export$2e2bcd8739ae039));
(0, $0c9dfd6cf9ab0903$export$2e2bcd8739ae039).registerLanguage("markdown", (0, $ac9ce1e4897eda61$export$2e2bcd8739ae039));
function $74d890f6f2a4f834$var$extendNode(node) {
    const styles = [];
    Object.entries((0, $0347a5abd1c6cdfa$export$5e5ebb8e12ca7518)).forEach(([type, className])=>{
        if (node?.properties?.className?.includes(type)) styles.push(className);
    });
    if (styles.length > 0) node.properties.className.push((0, $5nTep.mergeStyles)(...styles));
    node?.children?.forEach?.($74d890f6f2a4f834$var$extendNode);
    return node;
}
function $74d890f6f2a4f834$var$renderer({ rows: rows, stylesheet: stylesheet, useInlineStyles: useInlineStyles }) {
    return rows.map((node, i)=>(0, $9644c80f8ced0992$export$2e2bcd8739ae039)({
            node: $74d890f6f2a4f834$var$extendNode(node),
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: `code-segment-${i}`
        }));
}
const $74d890f6f2a4f834$export$61f100e67ffb6850 = ({ language: language = "json", code: code, ...otherProps })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0c9dfd6cf9ab0903$export$2e2bcd8739ae039), {
        language: language,
        useInlineStyles: false,
        wrapLongLines: true,
        codeTagProps: {
            className: function anonymous(props) {
                let rules = " ";
                if (props.isCode) rules += ' uj182';
                else {
                    rules += ' uk182';
                    rules += ' ucJ9TBTb182';
                    rules += ' ud3Euai182';
                    rules += ' uea182';
                    rules += ' ugb182';
                    rules += ' uhd182';
                    rules += ' uje182';
                    rules += ' u2NhKxcl182';
                    rules += ' uic182';
                }
                if (props.isCode) {
                    rules += ' -_6BNtrc-d182';
                    rules += ' vx182';
                } else {
                    rules += ' -_6BNtrc-d182';
                    rules += ' vx182';
                }
                if (props.isCode) ;
                else {
                    rules += ' xb182';
                    rules += ' _xa182';
                }
                if (props.isCode) rules += ' _FnuYUwec182';
                else {
                    rules += ' _Fb182';
                    rules += ' _FnuYUwec182';
                }
                if (props.isCode) rules += ' pt182';
                else rules += ' pt182';
                rules += ' _7f182';
                return rules;
            }({
                isCode: language !== "markdown"
            })
        },
        renderer: $74d890f6f2a4f834$var$renderer,
        ...otherProps,
        children: code
    });
};
$74d890f6f2a4f834$export$61f100e67ffb6850.propTypes = {
    language: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    code: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
};



var $jBZxV = parcelRequire("jBZxV");

var $iLDMH = parcelRequire("iLDMH");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $aQTiM = parcelRequire("aQTiM");
var $5nTep = parcelRequire("5nTep");
var $2ffAV = parcelRequire("2ffAV");
var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");
var $hSW0F = parcelRequire("hSW0F");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $620d818687964b54$var$$949155b2e8d57a06$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M18 15.5H3c-.414 0-.75-.336-.75-.75S2.586 14 3 14h15c.414 0 .75.336.75.75s-.336.75-.75.75M11 3.25c-3.777 0-6.926 2.816-7.609 6.528l-.858-1.44c-.212-.356-.673-.47-1.029-.26-.355.213-.472.673-.26 1.029l1.796 3.012c.104.173.273.298.47.345q.087.02.174.02c.141 0 .28-.04.402-.116l2.92-1.853c.349-.222.452-.685.23-1.035-.221-.35-.685-.453-1.034-.231l-1.344.852C5.392 7.061 7.94 4.75 11 4.75c3.446 0 6.25 2.931 6.25 6.534 0 .414.336.75.75.75s.75-.336.75-.75c0-4.43-3.477-8.034-7.75-8.034"
        })
    });
const $620d818687964b54$var$$949155b2e8d57a06$var$ForwardRef = (0, $eF4cA.forwardRef)($620d818687964b54$var$$949155b2e8d57a06$var$SvgComponent);
var $620d818687964b54$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($620d818687964b54$var$$949155b2e8d57a06$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $bfb594a68ec98b30$var$$472e95009b2b7283$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m18.031 10.701-3.497-3.503c-.293-.293-.768-.292-1.061 0s-.293.767-.001 1.06l2.216 2.22H8.493c-1.203 0-2.333-.467-3.182-1.317-.851-.85-1.319-1.98-1.319-3.182 0-.415-.336-.75-.75-.75s-.75.335-.75.75c0 1.602.624 3.109 1.758 4.243 1.133 1.132 2.64 1.757 4.243 1.757h7.2l-2.22 2.22c-.293.292-.293.767 0 1.06.146.146.338.22.53.22s.384-.074.53-.22l3.497-3.497c.293-.293.293-.768.001-1.06"
        })
    });
const $bfb594a68ec98b30$var$$472e95009b2b7283$var$ForwardRef = (0, $eF4cA.forwardRef)($bfb594a68ec98b30$var$$472e95009b2b7283$var$SvgComponent);
var $bfb594a68ec98b30$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($bfb594a68ec98b30$var$$472e95009b2b7283$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $1e8c01aabb4b1607$var$$c4b4942c9e7670b7$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M10 4c1.32 0 1.5-.18 1.5-1.5S11.32 1 10 1s-1.5.18-1.5 1.5S8.68 4 10 4M2.5 11.51c1.329 0 1.51-.181 1.51-1.51S3.83 8.49 2.5 8.49.99 8.67.99 10s.181 1.51 1.51 1.51M17.5 11.51c1.329 0 1.51-.181 1.51-1.51s-.181-1.51-1.51-1.51-1.51.181-1.51 1.51.181 1.51 1.51 1.51M10 19.01c1.329 0 1.51-.181 1.51-1.51s-.181-1.51-1.51-1.51-1.51.181-1.51 1.51.181 1.51 1.51 1.51M6.02 4.51C6.02 3.181 5.84 3 4.51 3S3 3.181 3 4.51s.181 1.51 1.51 1.51h.705c.523 0 .786.102.786.666v.704c0 1.228.161 1.39 1.39 1.39S8.78 8.618 8.78 7.39s-.162-1.389-1.39-1.389h-.704c-.383 0-.666-.263-.666-.786zM13.98 5.215c0 .523-.283.786-.666.786h-.704c-1.228 0-1.39.161-1.39 1.39 0 1.227.162 1.389 1.39 1.389s1.389-.162 1.389-1.39v-.704c0-.564.263-.666.786-.666h.705c1.329 0 1.51-.181 1.51-1.51S16.819 3 15.49 3s-1.51.181-1.51 1.51zM6.02 14.785c0-.523.283-.786.666-.786h.704c1.228 0 1.39-.161 1.39-1.39s-.162-1.389-1.39-1.389-1.389.162-1.389 1.39v.704c0 .564-.263.666-.786.666H4.51c-1.329 0-1.51.181-1.51 1.51S3.181 17 4.51 17s1.51-.181 1.51-1.51zM13.98 15.49c0 1.329.181 1.51 1.51 1.51S17 16.819 17 15.49s-.181-1.51-1.51-1.51h-.705c-.523 0-.786-.102-.786-.666v-.704c0-1.228-.161-1.39-1.39-1.39s-1.389.162-1.389 1.39.162 1.389 1.39 1.389h.704c.383 0 .666.263.666.786z"
        })
    });
const $1e8c01aabb4b1607$var$$c4b4942c9e7670b7$var$ForwardRef = (0, $eF4cA.forwardRef)($1e8c01aabb4b1607$var$$c4b4942c9e7670b7$var$SvgComponent);
var $1e8c01aabb4b1607$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($1e8c01aabb4b1607$var$$c4b4942c9e7670b7$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $90163e0817f0b54f$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M14.527 7.467 10.524 3.47c-.293-.294-.768-.292-1.06 0L5.467 7.467c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22l2.724-2.723v9.946c0 .414.336.75.75.75s.75-.336.75-.75V5.816l2.716 2.711c.294.294.768.292 1.06 0 .293-.293.293-.768 0-1.06"
        })
    });
const $90163e0817f0b54f$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($90163e0817f0b54f$var$SvgComponent);
var $90163e0817f0b54f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($90163e0817f0b54f$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $c53a17d754be91fd$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M13.75 4h-7.5C5.007 4 4 5.007 4 6.25v7.5C4 14.993 5.007 16 6.25 16h7.5c1.243 0 2.25-1.007 2.25-2.25v-7.5C16 5.007 14.993 4 13.75 4"
        })
    });
const $c53a17d754be91fd$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($c53a17d754be91fd$var$SvgComponent);
var $c53a17d754be91fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($c53a17d754be91fd$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $aQTiM = parcelRequire("aQTiM");

var $lK44Y = parcelRequire("lK44Y");

var $208Op = parcelRequire("208Op");

var $abeS0 = parcelRequire("abeS0");

var $3PqDc = parcelRequire("3PqDc");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $8gDpA = parcelRequire("8gDpA");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$heading = " zPCJngb182 yPCJngb182 BPCJngb182 APCJngb182 _ub182 Jy182 Gy182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182";
const $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$header = " z6Akec182 y6Akec182 B6Akec182 A6Akec182 InM182 HnM182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182";
const $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$content = " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 _ub182 Pa182 PJVVdVe182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182";
const $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$buttonGroup = " z4AkfTc182 y4AkfTc182 B4AkfTc182 A4AkfTc182 IM182 La182";
const $3de2bfc8b2173c59$export$6af31f836f9aa6f2 = " se182 CQpyMed182 Cns3y4td182 DM8Mfn182 Dn4w1sLc182 EfcKqZ182 EnFfvwed182 Th182 Tnk182 Qh182 Qnk182 Sh182 Snk182 Rh182 Rnk182 ql182 qnj182 K40ub4c182 Fb182 _oa182 _Le182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 oi182 ni182 ki182 ji182 _Na182 Pa182";
const $3de2bfc8b2173c59$export$7082b7e805d2626f = (0, $eF4cA.forwardRef)(function FullscreenDialog(props, ref) {
    let { variant: variant = 'fullscreen', isKeyboardDismissDisabled: isKeyboardDismissDisabled } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    return (0, $dx4lB.jsx)((0, $abeS0.Modal), {
        size: variant,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        children: (0, $dx4lB.jsx)((0, $8gDpA.Dialog), {
            ...props,
            ref: domRef,
            style: props.UNSAFE_style,
            className: (props.UNSAFE_className || '') + $3de2bfc8b2173c59$export$6af31f836f9aa6f2,
            children: (0, $fDYaM.composeRenderProps)(props.children, (children)=>(0, $dx4lB.jsx)((0, $8gDpA.OverlayTriggerStateContext).Provider, {
                    value: null,
                    children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $208Op.HeadingContext),
                                {
                                    styles: $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$heading
                                }
                            ],
                            [
                                (0, $208Op.HeaderContext),
                                {
                                    styles: $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$header
                                }
                            ],
                            [
                                (0, $208Op.ContentContext),
                                {
                                    styles: $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$content
                                }
                            ],
                            [
                                (0, $lK44Y.ButtonGroupContext),
                                {
                                    styles: $3de2bfc8b2173c59$var$$8e7a38ff5b9798e1$var$buttonGroup
                                }
                            ]
                        ],
                        children: children
                    })
                }))
        })
    });
});


var $aJzBQ = parcelRequire("aJzBQ");
var $j8RRT = parcelRequire("j8RRT");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $dd3ad2885d4dcb47$var$$bbb815dd8bf6645d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10.004 12.589c-.888 0-1.753-.46-2.228-1.283-.708-1.228-.286-2.801.94-3.51.593-.343 1.285-.433 1.949-.256.663.178 1.216.604 1.56 1.197.342.594.433 1.286.256 1.949-.178.663-.603 1.216-1.197 1.56-.403.233-.845.343-1.28.343m-.93-2.033c.295.508.949.683 1.46.39.247-.142.424-.373.498-.648s.036-.564-.107-.81c-.143-.248-.373-.425-.649-.499-.275-.073-.563-.035-.81.107-.51.295-.686.949-.391 1.46"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M6.907 18.318c-.34 0-.682-.085-.992-.264l-.82-.473c-.893-.514-1.25-1.65-.811-2.583l.58-1.233q-.398-.546-.672-1.161l-1.357-.113C1.806 12.406 1 11.531 1 10.5v-.946c0-1.033.805-1.91 1.833-1.994l1.354-.115q.138-.313.302-.6.165-.285.37-.564l-.581-1.23c-.441-.932-.087-2.068.807-2.584l.82-.474c.893-.516 2.054-.259 2.643.59l.777 1.118q.667-.074 1.341 0l.775-1.119c.59-.85 1.751-1.11 2.644-.594l.82.473c.894.516 1.25 1.651.81 2.584l-.58 1.232q.399.548.672 1.161l1.357.113c1.028.085 1.834.96 1.835 1.991v.947c.001 1.031-.803 1.907-1.832 1.994l-1.355.115q-.136.313-.303.6-.164.284-.368.563l.58 1.23c.441.93.087 2.067-.806 2.584l-.82.475c-.894.518-2.054.258-2.643-.591l-.778-1.118q-.67.073-1.34 0l-.777 1.12c-.384.555-1.012.857-1.65.857M6.904 3.225q-.13 0-.248.066l-.82.475c-.223.129-.312.412-.202.645l.78 1.65c.125.267.083.583-.108.807-.204.24-.373.477-.517.726q-.212.37-.368.81c-.098.278-.35.472-.644.496l-1.819.154c-.262.022-.458.236-.458.499v.946c0 .258.202.477.459.498l1.82.15c.293.025.546.22.644.498.2.56.497 1.076.887 1.532.192.223.234.54.109.806l-.778 1.653c-.11.233-.02.517.203.645l.82.474c.224.13.514.063.66-.148l1.041-1.502c.168-.242.46-.369.753-.31.588.108 1.184.11 1.77 0 .29-.055.585.066.753.31l1.042 1.499c.147.21.439.276.66.147l.821-.474c.226-.13.314-.409.201-.646l-.779-1.65c-.126-.267-.084-.583.108-.807.204-.24.373-.477.515-.725h.001c.143-.248.263-.512.369-.81.098-.279.35-.473.644-.497l1.819-.153c.256-.022.458-.24.458-.499l-.001-.947c0-.262-.197-.476-.459-.498l-1.819-.15c-.294-.025-.546-.22-.645-.498-.198-.56-.496-1.075-.887-1.532-.191-.224-.234-.54-.108-.806l.777-1.653c.11-.233.02-.517-.203-.646l-.82-.473c-.224-.127-.514-.061-.66.15l-1.04 1.5c-.168.243-.46.368-.753.31-.591-.11-1.188-.11-1.77 0-.292.052-.586-.067-.754-.31L7.316 3.439c-.096-.137-.253-.213-.412-.213"
            })
        ]
    });
const $dd3ad2885d4dcb47$var$$bbb815dd8bf6645d$var$ForwardRef = (0, $eF4cA.forwardRef)($dd3ad2885d4dcb47$var$$bbb815dd8bf6645d$var$SvgComponent);
var $dd3ad2885d4dcb47$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($dd3ad2885d4dcb47$var$$bbb815dd8bf6645d$var$ForwardRef);




var $ikOQe = parcelRequire("ikOQe");

var $dXYND = parcelRequire("dXYND");

var $aKSBi = parcelRequire("aKSBi");

var $lRNYL = parcelRequire("lRNYL");
const $fc63f18a1099e5ba$export$9dff1832a3608bc7 = ({ videoId: videoId, isOpen: isOpen, getPromptTemplate: getPromptTemplate, templateKey: templateKey })=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const videoTemplate = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    const systemPromptId = getPromptTemplate?.(video.data)?.systemPromptId ?? (0, $dXYND.getCustomerBrandingPromptTemplate)({
        templateId: video.data?.templateId,
        hint: ""
    }).systemPromptId;
    const _templateKey = templateKey ?? `customTemplate__${video.data?.templateId}`;
    const [_promptTemplate, setPromptTemplate] = (0, $eF4cA.useState)();
    const [document, setDocument] = (0, $eF4cA.useState)();
    const [loadError, setLoadError] = (0, $eF4cA.useState)("");
    (0, $eF4cA.useEffect)(()=>{
        setDocument(undefined);
        setLoadError("");
        setPromptTemplate(undefined);
        if (!isAdmin || !isOpen) return;
        if (!systemPromptId) {
            setLoadError("No system prompt is configured for this template.");
            return;
        }
        const controller = new AbortController();
        setPromptTemplate(localStorage.getItem(_templateKey) ?? undefined);
        (0, $aKSBi.getSystemPrompt)(systemPromptId, {
            signal: controller.signal
        }).then((result)=>{
            if (!controller.signal.aborted) setDocument(result);
        }).catch((error)=>{
            if (!controller.signal.aborted) setLoadError(error.message);
        });
        return ()=>controller.abort();
    }, [
        isAdmin,
        isOpen,
        systemPromptId,
        _templateKey
    ]);
    const defaultPromptTemplate = document?.prompt ?? "";
    const promptTemplate = _promptTemplate ?? defaultPromptTemplate;
    const isModified = promptTemplate !== defaultPromptTemplate;
    const hasCustomTemplate = !!localStorage.getItem(_templateKey);
    const handleSave = (text, close)=>{
        if (text === defaultPromptTemplate) localStorage.removeItem(_templateKey);
        else localStorage.setItem(_templateKey, text);
        close();
    };
    const handleCancel = (close)=>{
        setPromptTemplate(defaultPromptTemplate);
        close();
    };
    const handleReset = (close)=>{
        localStorage.removeItem(_templateKey);
        setPromptTemplate(defaultPromptTemplate);
        close();
    };
    if (!isAdmin) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3de2bfc8b2173c59$export$7082b7e805d2626f), {
        isOpen: isOpen,
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        slot: "title",
                        children: "Edit prompt template"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                        children: videoTemplate.data?.name ?? video.data?.templateId
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                        children: [
                            loadError ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: loadError
                            }) : !document && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Loading system prompt..."
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                "aria-label": "Edit prompt template",
                                value: promptTemplate,
                                onChange: setPromptTemplate,
                                isDisabled: !document || !!loadError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        children: [
                            !!hasCustomTemplate && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                onPress: ()=>handleReset(close),
                                variant: "secondary",
                                isQuiet: true,
                                isDisabled: !document || !!loadError,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c8ca68bb4c148d98$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Reset to default"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                onPress: ()=>handleCancel(close),
                                variant: "secondary",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                onPress: ()=>handleSave(promptTemplate, close),
                                variant: "accent",
                                isDisabled: !document || !!loadError || !isModified || !promptTemplate.trim(),
                                children: "Save Changes"
                            })
                        ]
                    })
                ]
            })
    });
};
const $fc63f18a1099e5ba$export$312ad8efc39e068e = ({ videoId: videoId, getPromptTemplate: getPromptTemplate, templateKey: templateKey, ...props })=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const _templateKey = templateKey ?? `customTemplate__${video.data?.templateId}`;
    const hasCustomTemplate = !!localStorage.getItem(_templateKey);
    const [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                "aria-label": "Edit prompt settings",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dd3ad2885d4dcb47$export$2e2bcd8739ae039), {}),
                    hasCustomTemplate && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aJzBQ.NotificationBadge), {
                        size: "L",
                        UNSAFE_className: " gQ182"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)($fc63f18a1099e5ba$export$9dff1832a3608bc7, {
                videoId: videoId,
                getPromptTemplate: getPromptTemplate,
                templateKey: templateKey,
                isOpen: isOpen
            })
        ]
    });
};



var $lRNYL = parcelRequire("lRNYL");

var $e9DCr = parcelRequire("e9DCr");

var $fmJ8d = parcelRequire("fmJ8d");
const $c176de8415da9d02$var$PromptCompletions = ({ completions: completions, isPending: isPending, onSelect: onSelect })=>{
    if (!completions?.length || isPending) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " _oa182 Za182 LEmhfb182 Se182 Re182",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
            variant: "secondary",
            size: "S",
            UNSAFE_className: " _wb182 _tc182",
            children: completions.map((completion, index)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                    "aria-label": `Use completion: ${completion}`,
                    onPress: ()=>onSelect(completion),
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bfb594a68ec98b30$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: completion
                        })
                    ]
                }, index))
        })
    });
};
$c176de8415da9d02$var$PromptCompletions.propTypes = {
    completions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
    isPending: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
};
const $c176de8415da9d02$var$PromptEditor = ({ inputRef: inputRef, prompt: prompt, setPrompt: setPrompt, placeholder: placeholder, isPending: isPending, onKeyDown: onKeyDown, onSubmit: onSubmit, onReset: onReset, onRedo: onRedo, videoId: videoId, getPromptTemplate: getPromptTemplate, templateKey: templateKey, actions: actions, styles: styles })=>{
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: (0, $5nTep.mergeStyles)(" sd182 _ta182 ec182", styles),
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " sd182 _ta182 Ub182 qb182 Za182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                    ref: inputRef,
                    "aria-label": "Prompt",
                    placeholder: placeholder,
                    prefix: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e9DCr.PixelLoader), {
                        isPlaying: isPending
                    }),
                    value: prompt,
                    isDisabled: isPending,
                    onChange: setPrompt,
                    onKeyDown: onKeyDown,
                    UNSAFE_className: "__PromptInput __PromptInput--quiet"
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ug182 qg182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                        size: "S",
                        isQuiet: true,
                        children: [
                            isAdmin && !!onRedo && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                        onPress: onRedo,
                                        "aria-label": "Generate",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $620d818687964b54$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                        children: "Regenerate"
                                    })
                                ]
                            }),
                            isAdmin && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fc63f18a1099e5ba$export$312ad8efc39e068e), {
                                        videoId: videoId,
                                        getPromptTemplate: getPromptTemplate,
                                        templateKey: templateKey
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                        children: "Edit prompt template"
                                    })
                                ]
                            }),
                            !!actions && actions
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                "aria-label": isPending ? "Cancel" : "Submit prompt",
                                variant: "primary",
                                isDisabled: !prompt,
                                onPress: ()=>isPending ? onReset?.() : onSubmit(prompt, setPrompt),
                                children: isPending ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c53a17d754be91fd$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $90163e0817f0b54f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                children: isPending ? "Cancel" : "Submit prompt"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$c176de8415da9d02$var$PromptEditor.propTypes = {
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).any
    }).isRequired,
    prompt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    setPrompt: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    isPending: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    onReset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onRedo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    getPromptTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    templateKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const $c176de8415da9d02$export$76f46df19ff2ecee = ({ videoId: videoId, placeholder: placeholder, completions: completions, getPromptTemplate: getPromptTemplate, templateKey: templateKey, isPending: isPending, onSubmit: onSubmit, onReset: onReset, onRedo: onRedo, actions: actions = null, styles: styles = "" })=>{
    const [prompt, setPrompt] = (0, $eF4cA.useState)("");
    const inputRef = (0, $eF4cA.useRef)(null);
    const promptHint = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.promptHint);
    const setPromptHint = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setPromptHint);
    const isMobile = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isMobile);
    (0, $eF4cA.useEffect)(()=>{
        if (promptHint && !prompt.includes(promptHint)) {
            setPrompt((prev)=>`${prev}${!!prev ? "\n" : ""}${promptHint}`);
            setPromptHint(null);
            if (inputRef.current) inputRef.current.focus();
        }
    }, [
        promptHint,
        prompt
    ]);
    const handlePromptKeyDown = (e)=>{
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (prompt.trim()) onSubmit(prompt, setPrompt);
        }
    };
    if (isMobile) return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " _de182 Te182 Qe182 Se182 Re182 g_g182 og182 ng182 kg182 jg182 _nLeasBb182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                    variant: "genai",
                    "aria-label": "Open prompt",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1e8c01aabb4b1607$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                    position: "bottom",
                    hideArrow: true,
                    offset: -64,
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " _oa182 Fb182 sd182 _ta182 _Cb182 Ug182 qg182 Te182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)($c176de8415da9d02$var$PromptCompletions, {
                                completions: completions,
                                isPending: isPending,
                                onSelect: setPrompt
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)($c176de8415da9d02$var$PromptEditor, {
                                inputRef: inputRef,
                                prompt: prompt,
                                setPrompt: setPrompt,
                                placeholder: placeholder,
                                isPending: isPending,
                                onKeyDown: handlePromptKeyDown,
                                onSubmit: onSubmit,
                                onReset: onReset,
                                onRedo: onRedo,
                                videoId: videoId,
                                getPromptTemplate: getPromptTemplate,
                                templateKey: templateKey,
                                actions: actions,
                                styles: (0, $5nTep.mergeStyles)(styles)
                            })
                        ]
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)($c176de8415da9d02$var$PromptCompletions, {
                completions: completions,
                isPending: isPending,
                onSelect: setPrompt
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)($c176de8415da9d02$var$PromptEditor, {
                inputRef: inputRef,
                prompt: prompt,
                setPrompt: setPrompt,
                placeholder: placeholder,
                isPending: isPending,
                onKeyDown: handlePromptKeyDown,
                onSubmit: onSubmit,
                onReset: onReset,
                onRedo: onRedo,
                videoId: videoId,
                getPromptTemplate: getPromptTemplate,
                templateKey: templateKey,
                actions: actions,
                styles: styles
            })
        ]
    });
};
$c176de8415da9d02$export$76f46df19ff2ecee.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    completions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string),
    getPromptTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    templateKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    onReset: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onRedo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    isPending: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $4UbTp = parcelRequire("4UbTp");
var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $88lL9 = parcelRequire("88lL9");
var $c0XRK = parcelRequire("c0XRK");

var $8OJ2z = parcelRequire("8OJ2z");

var $eTg8W = parcelRequire("eTg8W");

var $3PqDc = parcelRequire("3PqDc");

var $8w4Nl = parcelRequire("8w4Nl");

var $j3pTw = parcelRequire("j3pTw");

var $dm5H1 = parcelRequire("dm5H1");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ae302b20f9153083$var$$279039872474ccc7$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const $ae302b20f9153083$var$$279039872474ccc7$var$ForwardRef = (0, $eF4cA.forwardRef)($ae302b20f9153083$var$$279039872474ccc7$var$SvgComponent);
var $ae302b20f9153083$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($ae302b20f9153083$var$$279039872474ccc7$var$ForwardRef);



var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $9PmUB = parcelRequire("9PmUB");

var $i0SpD = parcelRequire("i0SpD");

var $cTXxz = parcelRequire("cTXxz");

var $ecbit = parcelRequire("ecbit");

var $8UElq = parcelRequire("8UElq");

var $c1ibQ = parcelRequire("c1ibQ");

var $lKBFz = parcelRequire("lKBFz");
var $17c483aaa21e1c81$export$2e2bcd8739ae039 = {};
$17c483aaa21e1c81$export$2e2bcd8739ae039 = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};


var $638906c873eed54c$export$2e2bcd8739ae039 = {};
$638906c873eed54c$export$2e2bcd8739ae039 = {
    "Clear search": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{442}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`
};


var $1774731c564dc39c$export$2e2bcd8739ae039 = {};
$1774731c564dc39c$export$2e2bcd8739ae039 = {
    "Clear search": `Vymazat hled\xe1n\xed`
};


var $b1e3f14e03406ab7$export$2e2bcd8739ae039 = {};
$b1e3f14e03406ab7$export$2e2bcd8739ae039 = {
    "Clear search": `Ryd s\xf8gning`
};


var $82ddb8b2d5c06281$export$2e2bcd8739ae039 = {};
$82ddb8b2d5c06281$export$2e2bcd8739ae039 = {
    "Clear search": `Suche zur\xfccksetzen`
};


var $db9b8c0ee1ca370f$export$2e2bcd8739ae039 = {};
$db9b8c0ee1ca370f$export$2e2bcd8739ae039 = {
    "Clear search": `\u{391}\u{3C0}\u{3B1}\u{3BB}\u{3BF}\u{3B9}\u{3C6}\u{3AE} \u{3B1}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}\u{3C2}`
};


var $a2828bcfea8c805e$export$2e2bcd8739ae039 = {};
$a2828bcfea8c805e$export$2e2bcd8739ae039 = {
    "Clear search": `Clear search`
};


var $222c6e6586158a42$export$2e2bcd8739ae039 = {};
$222c6e6586158a42$export$2e2bcd8739ae039 = {
    "Clear search": `Borrar b\xfasqueda`
};


var $6f82caf26eb513ca$export$2e2bcd8739ae039 = {};
$6f82caf26eb513ca$export$2e2bcd8739ae039 = {
    "Clear search": `T\xfchjenda otsing`
};


var $6eb022358b3ab303$export$2e2bcd8739ae039 = {};
$6eb022358b3ab303$export$2e2bcd8739ae039 = {
    "Clear search": `Tyhjenn\xe4 haku`
};


var $667f7028edc19a4f$export$2e2bcd8739ae039 = {};
$667f7028edc19a4f$export$2e2bcd8739ae039 = {
    "Clear search": `Effacer la recherche`
};


var $fcc48f20c45eebce$export$2e2bcd8739ae039 = {};
$fcc48f20c45eebce$export$2e2bcd8739ae039 = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};


var $440aa58dc92fe6ae$export$2e2bcd8739ae039 = {};
$440aa58dc92fe6ae$export$2e2bcd8739ae039 = {
    "Clear search": `Obri\u{161}i pretragu`
};


var $cf05ac3091718880$export$2e2bcd8739ae039 = {};
$cf05ac3091718880$export$2e2bcd8739ae039 = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};


var $de4c34a0b219441e$export$2e2bcd8739ae039 = {};
$de4c34a0b219441e$export$2e2bcd8739ae039 = {
    "Clear search": `Cancella ricerca`
};


var $a8cadf46e89f10ad$export$2e2bcd8739ae039 = {};
$a8cadf46e89f10ad$export$2e2bcd8739ae039 = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};


var $6ebaecb21e95e87a$export$2e2bcd8739ae039 = {};
$6ebaecb21e95e87a$export$2e2bcd8739ae039 = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};


var $45cb1a31553a5f3d$export$2e2bcd8739ae039 = {};
$45cb1a31553a5f3d$export$2e2bcd8739ae039 = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};


var $edc2818c45fedfd3$export$2e2bcd8739ae039 = {};
$edc2818c45fedfd3$export$2e2bcd8739ae039 = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};


var $14474593049533a1$export$2e2bcd8739ae039 = {};
$14474593049533a1$export$2e2bcd8739ae039 = {
    "Clear search": `T\xf8m s\xf8k`
};


var $962c1c311f96a6c1$export$2e2bcd8739ae039 = {};
$962c1c311f96a6c1$export$2e2bcd8739ae039 = {
    "Clear search": `Zoekactie wissen`
};


var $2b39ef5348202998$export$2e2bcd8739ae039 = {};
$2b39ef5348202998$export$2e2bcd8739ae039 = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};


var $79f6ceb63b4d49f1$export$2e2bcd8739ae039 = {};
$79f6ceb63b4d49f1$export$2e2bcd8739ae039 = {
    "Clear search": `Limpar pesquisa`
};


var $17aac967cc3fa096$export$2e2bcd8739ae039 = {};
$17aac967cc3fa096$export$2e2bcd8739ae039 = {
    "Clear search": `Limpar pesquisa`
};


var $0d45e55e7447af0f$export$2e2bcd8739ae039 = {};
$0d45e55e7447af0f$export$2e2bcd8739ae039 = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};


var $c90f60a4f932b63b$export$2e2bcd8739ae039 = {};
$c90f60a4f932b63b$export$2e2bcd8739ae039 = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};


var $b6a87d88d76218e9$export$2e2bcd8739ae039 = {};
$b6a87d88d76218e9$export$2e2bcd8739ae039 = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};


var $ce81feca9f377ca5$export$2e2bcd8739ae039 = {};
$ce81feca9f377ca5$export$2e2bcd8739ae039 = {
    "Clear search": `Po\u{10D}isti iskanje`
};


var $17a94a72bd0666a4$export$2e2bcd8739ae039 = {};
$17a94a72bd0666a4$export$2e2bcd8739ae039 = {
    "Clear search": `Obri\u{161}i pretragu`
};


var $42b51c9c198c45b5$export$2e2bcd8739ae039 = {};
$42b51c9c198c45b5$export$2e2bcd8739ae039 = {
    "Clear search": `Rensa s\xf6kning`
};


var $3c14a96f5223879b$export$2e2bcd8739ae039 = {};
$3c14a96f5223879b$export$2e2bcd8739ae039 = {
    "Clear search": `Aramay\u{131} temizle`
};


var $fd655965455c5abe$export$2e2bcd8739ae039 = {};
$fd655965455c5abe$export$2e2bcd8739ae039 = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};


var $c8c3d26208f4035a$export$2e2bcd8739ae039 = {};
$c8c3d26208f4035a$export$2e2bcd8739ae039 = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};


var $3662ebae1e25f43e$export$2e2bcd8739ae039 = {};
$3662ebae1e25f43e$export$2e2bcd8739ae039 = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};


var $7d31eda14d5f78f2$export$2e2bcd8739ae039 = {};
$7d31eda14d5f78f2$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $17c483aaa21e1c81$export$2e2bcd8739ae039),
    "bg-BG": (0, $638906c873eed54c$export$2e2bcd8739ae039),
    "cs-CZ": (0, $1774731c564dc39c$export$2e2bcd8739ae039),
    "da-DK": (0, $b1e3f14e03406ab7$export$2e2bcd8739ae039),
    "de-DE": (0, $82ddb8b2d5c06281$export$2e2bcd8739ae039),
    "el-GR": (0, $db9b8c0ee1ca370f$export$2e2bcd8739ae039),
    "en-US": (0, $a2828bcfea8c805e$export$2e2bcd8739ae039),
    "es-ES": (0, $222c6e6586158a42$export$2e2bcd8739ae039),
    "et-EE": (0, $6f82caf26eb513ca$export$2e2bcd8739ae039),
    "fi-FI": (0, $6eb022358b3ab303$export$2e2bcd8739ae039),
    "fr-FR": (0, $667f7028edc19a4f$export$2e2bcd8739ae039),
    "he-IL": (0, $fcc48f20c45eebce$export$2e2bcd8739ae039),
    "hr-HR": (0, $440aa58dc92fe6ae$export$2e2bcd8739ae039),
    "hu-HU": (0, $cf05ac3091718880$export$2e2bcd8739ae039),
    "it-IT": (0, $de4c34a0b219441e$export$2e2bcd8739ae039),
    "ja-JP": (0, $a8cadf46e89f10ad$export$2e2bcd8739ae039),
    "ko-KR": (0, $6ebaecb21e95e87a$export$2e2bcd8739ae039),
    "lt-LT": (0, $45cb1a31553a5f3d$export$2e2bcd8739ae039),
    "lv-LV": (0, $edc2818c45fedfd3$export$2e2bcd8739ae039),
    "nb-NO": (0, $14474593049533a1$export$2e2bcd8739ae039),
    "nl-NL": (0, $962c1c311f96a6c1$export$2e2bcd8739ae039),
    "pl-PL": (0, $2b39ef5348202998$export$2e2bcd8739ae039),
    "pt-BR": (0, $79f6ceb63b4d49f1$export$2e2bcd8739ae039),
    "pt-PT": (0, $17aac967cc3fa096$export$2e2bcd8739ae039),
    "ro-RO": (0, $0d45e55e7447af0f$export$2e2bcd8739ae039),
    "ru-RU": (0, $c90f60a4f932b63b$export$2e2bcd8739ae039),
    "sk-SK": (0, $b6a87d88d76218e9$export$2e2bcd8739ae039),
    "sl-SI": (0, $ce81feca9f377ca5$export$2e2bcd8739ae039),
    "sr-SP": (0, $17a94a72bd0666a4$export$2e2bcd8739ae039),
    "sv-SE": (0, $42b51c9c198c45b5$export$2e2bcd8739ae039),
    "tr-TR": (0, $3c14a96f5223879b$export$2e2bcd8739ae039),
    "uk-UA": (0, $fd655965455c5abe$export$2e2bcd8739ae039),
    "zh-CN": (0, $c8c3d26208f4035a$export$2e2bcd8739ae039),
    "zh-TW": (0, $3662ebae1e25f43e$export$2e2bcd8739ae039)
};



var $lhKAD = parcelRequire("lhKAD");

var $aGDvF = parcelRequire("aGDvF");

var $gI8Gw = parcelRequire("gI8Gw");
function $3e5bd6f9a98494ba$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3e5bd6f9a98494ba$export$9bb30bbe003b82e0(props, state, inputRef) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($3e5bd6f9a98494ba$var$$parcel$interopDefault((0, $7d31eda14d5f78f2$export$2e2bcd8739ae039)), '@react-aria/searchfield');
    let { isDisabled: isDisabled, isReadOnly: isReadOnly, onSubmit: onSubmit, onClear: onClear, type: type = 'search' } = props;
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        isDisabled: isDisabled || isReadOnly,
        shortcuts: {
            Enter: ()=>{
                if (onSubmit) {
                    // for backward compatibility;
                    // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
                    onSubmit(state.value);
                    return;
                }
                return false;
            },
            Escape: ()=>{
                // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
                // the hook
                if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) return false;
                state.setValue('');
                onClear?.();
            }
        }
    });
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current?.focus();
    };
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $lKBFz.useTextField)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: props.onKeyDown,
        onKeyUp: props.onKeyUp,
        type: type
    }, inputRef);
    return {
        labelProps: labelProps,
        // An edge case, in Autocomplete, if the keyboard hanlders are not in this order, then
        // Escape runs autocomplete/listbox first, then the search-field shortcut returns false and
        // continues propagation, leaking Escape to a parent Dialog.
        inputProps: (0, $lhKAD.mergeProps)(keyboardProps, {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        }),
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart: onPressStart
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        ...validation
    };
}



var $19ZgV = parcelRequire("19ZgV");

var $fVfXf = parcelRequire("fVfXf");

var $eF4cA = parcelRequire("eF4cA");

var $iUErx = parcelRequire("iUErx");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $983537b3cfa7f906$export$3f8be18b0f41eaf2(props) {
    let [value, setValue] = (0, $iUErx.useControlledState)($983537b3cfa7f906$var$$56baeede9f35e022$var$toString(props.value), $983537b3cfa7f906$var$$56baeede9f35e022$var$toString(props.defaultValue) || '', props.onChange);
    return {
        value: value,
        setValue: setValue
    };
}
function $983537b3cfa7f906$var$$56baeede9f35e022$var$toString(val) {
    if (val == null) return;
    return val.toString();
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $adfba034c57547f7$export$d1c4e4c63cb03a11 = (0, $eF4cA.createContext)(null);
const $adfba034c57547f7$export$b94867ecbd698f21 = (0, $19ZgV.createHideableComponent)(function SearchField(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $adfba034c57547f7$export$d1c4e4c63cb03a11);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, $eF4cA.useRef)(null);
    [props, inputRef] = (0, $fDYaM.useContextProps)(props, inputRef, (0, $9PmUB.FieldInputContext));
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let state = (0, $983537b3cfa7f906$export$3f8be18b0f41eaf2)({
        ...props,
        validationBehavior: validationBehavior
    });
    let { labelProps: labelProps, inputProps: inputProps, clearButtonProps: clearButtonProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $3e5bd6f9a98494ba$export$9bb30bbe003b82e0)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, inputRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false,
            state: state
        },
        defaultClassName: 'react-aria-SearchField'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                clearButtonProps
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});



var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9d93ff4dc67afc7e$export$d1c4e4c63cb03a11 = (0, $eF4cA.createContext)(null);
const $9d93ff4dc67afc7e$export$b94867ecbd698f21 = (0, $eF4cA.forwardRef)(function SearchField(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $9d93ff4dc67afc7e$export$d1c4e4c63cb03a11);
    let formContext = (0, $eF4cA.useContext)((0, $j3pTw.FormContext));
    props = (0, $j3pTw.useFormProps)(props);
    let { label: label, description: description, errorMessage: errorMessage, necessityIndicator: necessityIndicator, labelPosition: labelPosition = 'top', labelAlign: labelAlign = 'start', UNSAFE_className: UNSAFE_className = '', UNSAFE_style: UNSAFE_style, ...searchFieldProps } = props;
    let domRef = (0, $eF4cA.useRef)(null);
    let inputRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>({
            ...(0, $3PqDc.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return (0, $dx4lB.jsx)((0, $adfba034c57547f7$export$b94867ecbd698f21), {
        ...searchFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            rules += ' -Qg41Lb-JAxCW0c182';
            if (props.isDisabled) {
                rules += ' pp182';
                rules += ' plc182';
            } else {
                if (props.isPressed) rules += ' po182';
                else if (props.isFocusVisible) rules += ' po182';
                else if (props.isHovered) rules += ' po182';
                else rules += ' pt182';
            }
            return rules;
        }({
            size: props.size,
            labelPosition: labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid, isEmpty: isEmpty })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    label && (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                        isDisabled: isDisabled,
                        size: props.size,
                        styles: " og182 ng182 kg182 jg182 Sw182 Rd182",
                        children: [
                            (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                                values: [
                                    [
                                        (0, $dm5H1.IconContext),
                                        {
                                            render: (0, $8OJ2z.centerBaseline)({
                                                slot: 'icon',
                                                styles: " _va182 Ht182 Hsu182 -_8sjo0b-t5ZbAob182"
                                            }),
                                            styles: " ZObNfn182 FObNfn182 I67logd182"
                                        }
                                    ]
                                ],
                                children: (0, $dx4lB.jsx)((0, $ae302b20f9153083$export$2e2bcd8739ae039), {})
                            }),
                            (0, $dx4lB.jsx)((0, $8w4Nl.Input), {
                                ref: inputRef,
                                UNSAFE_className: "zc3JFe"
                            }),
                            !isEmpty && !searchFieldProps.isReadOnly && (0, $dx4lB.jsx)((0, $eTg8W.ClearButton), {
                                size: props.size
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});



var $j2JDe = parcelRequire("j2JDe");

var $9eyCh = parcelRequire("9eyCh");

var $jBZxV = parcelRequire("jBZxV");

var $iFK2s = parcelRequire("iFK2s");
var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $eac7c6493bd07884$export$f2ba18c2c14f4b04 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/footage"]);
const $eac7c6493bd07884$export$43042a09c53a67d5 = async (filters = {}, options = {})=>{
    const response = await $eac7c6493bd07884$export$f2ba18c2c14f4b04.get("/", filters, options);
    if (!response.ok) throw new Error("Failed to fetch footage", {
        cause: response
    });
    return {
        footage: response.data?.footage ?? [],
        pagination: response.data?.pagination ?? {}
    };
};
const $eac7c6493bd07884$export$64d9623b10d4c64 = async (options = {})=>{
    const response = await $eac7c6493bd07884$export$f2ba18c2c14f4b04.get("/industries", {}, options);
    if (!response.ok) throw new Error("Failed to fetch footage industries", {
        cause: response
    });
    return response.data?.industries ?? [];
};
const $eac7c6493bd07884$export$f9982c0a4772c0b4 = async (id, footageData, options = {})=>{
    if (!id) throw new Error("Footage ID is required to update footage");
    const response = await $eac7c6493bd07884$export$f2ba18c2c14f4b04.patch(`/${id}`, footageData, options);
    if (!response.ok) throw new Error("Failed to update footage", {
        cause: response
    });
    return response.data?.footage;
};


const $c888393e6da529dc$export$d2213c1df53371f3 = {
    all: [
        "footage"
    ],
    list: (filters)=>[
            ...$c888393e6da529dc$export$d2213c1df53371f3.all,
            "list",
            filters
        ],
    industries: ()=>[
            ...$c888393e6da529dc$export$d2213c1df53371f3.all,
            "industries"
        ]
};
const $c888393e6da529dc$export$86e3bf3696276128 = (filters = {}, options = {})=>{
    return (0, $iFK2s.useInfiniteQuery)({
        queryKey: $c888393e6da529dc$export$d2213c1df53371f3.list(filters),
        queryFn: ({ pageParam: pageParam, signal: signal })=>(0, $eac7c6493bd07884$export$43042a09c53a67d5)({
                ...filters,
                page: pageParam
            }, {
                signal: signal
            }),
        initialPageParam: 1,
        getNextPageParam: (lastPage)=>lastPage.pagination.page < lastPage.pagination.totalPages ? lastPage.pagination.page + 1 : undefined,
        meta: {
            errorMessage: "Failed to load footage. Please try again."
        },
        ...options
    });
};
const $c888393e6da529dc$export$942ee8a59110d867 = (options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $c888393e6da529dc$export$d2213c1df53371f3.industries(),
        queryFn: ({ signal: signal })=>(0, $eac7c6493bd07884$export$64d9623b10d4c64)({
                signal: signal
            }),
        meta: {
            errorMessage: "Failed to load industries. Please try again."
        },
        ...options
    });
};
const $c888393e6da529dc$export$c2f75e3e02fed40e = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ id: id, ...footageData }, { signal: signal })=>(0, $eac7c6493bd07884$export$f9982c0a4772c0b4)(id, footageData, {
                signal: signal
            }),
        onSuccess: (footage, variables, onMutateResult, { client: client })=>{
            client.setQueriesData({
                queryKey: $c888393e6da529dc$export$d2213c1df53371f3.all
            }, (data)=>{
                if (!data?.pages) return data;
                return {
                    ...data,
                    pages: data.pages.map((page)=>({
                            ...page,
                            footage: page.footage.map((item)=>item._id === footage._id ? footage : item)
                        }))
                };
            });
            if (variables.industry !== undefined) client.invalidateQueries({
                queryKey: $c888393e6da529dc$export$d2213c1df53371f3.industries()
            });
        },
        meta: {
            errorMessage: "Failed to update footage. Please try again."
        },
        ...options
    });
};



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $94a260b1f73086ed$var$$bdf63584ecd028de$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M124 38c6.627 0 12 5.373 12 12v60c0 6.627-5.373 12-12 12H36c-6.627 0-12-5.373-12-12V50c0-6.627 5.373-12 12-12zm20 12c0-11.046-8.954-20-20-20H36c-11.046 0-20 8.954-20 20v60c0 11.046 8.954 20 20 20h88c11.046 0 20-8.954 20-20zm-95 3c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm-15-2c-1.105 0-2 .895-2 2v5c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2zm15 51c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm-15-2c-1.105 0-2 .895-2 2v5c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2zm32-47c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm2 47c-1.105 0-2 .895-2 2v5c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2zm15-47c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm2 47c-1.105 0-2 .895-2 2v5c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2zm15-47c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm2 47c-1.105 0-2 .895-2 2v5c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2zm15-47c0-1.105.895-2 2-2h7c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-7c-1.105 0-2-.895-2-2zm2 47c-1.105 0-2 .895-2 2v5c0 1.105.895 2 2 2h7c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2z"
        })
    });
const $94a260b1f73086ed$var$$bdf63584ecd028de$var$ForwardRef = (0, $eF4cA.forwardRef)($94a260b1f73086ed$var$$bdf63584ecd028de$var$SvgComponent);
var $94a260b1f73086ed$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($94a260b1f73086ed$var$$bdf63584ecd028de$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a095b75a8dbf849f$var$$8a74d3a6d7aead6c$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M76 22.4c3.314 0 6 2.687 6 6v39.2c0 3.314-2.686 6-6 6H20c-3.314 0-6-2.686-6-6V28.4c0-3.313 2.686-6 6-6zm10 6c0-5.522-4.477-10-10-10H20c-5.523 0-10 4.478-10 10v39.2c0 5.523 4.477 10 10 10h56c5.523 0 10-4.477 10-10zm-56.598 3.4c0-.662.538-1.2 1.2-1.2h4.2c.663 0 1.2.538 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.662 0-1.2-.537-1.2-1.2zm-9-1.2c-.664 0-1.2.538-1.2 1.2v3c0 .663.536 1.2 1.2 1.2h4.2c.662 0 1.2-.537 1.2-1.2v-3c0-.662-.538-1.2-1.2-1.2zm9 30.6c0-.662.538-1.2 1.2-1.2h4.2c.663 0 1.2.538 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.662 0-1.2-.537-1.2-1.2zm-9-1.2c-.664 0-1.2.538-1.2 1.2v3c0 .663.536 1.2 1.2 1.2h4.2c.662 0 1.2-.537 1.2-1.2v-3c0-.662-.538-1.2-1.2-1.2zm19.2-28.2c0-.662.537-1.2 1.2-1.2h4.2c.662 0 1.2.538 1.2 1.2v3c0 .663-.538 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm1.2 28.2c-.663 0-1.2.538-1.2 1.2v3c0 .663.537 1.2 1.2 1.2h4.2c.662 0 1.2-.537 1.2-1.2v-3c0-.662-.538-1.2-1.2-1.2zM49.8 31.8c0-.662.537-1.2 1.2-1.2h4.2c.663 0 1.2.538 1.2 1.2v3c0 .663-.538 1.2-1.2 1.2H51c-.663 0-1.2-.537-1.2-1.2zM51 60c-.663 0-1.2.538-1.2 1.2v3c0 .663.537 1.2 1.2 1.2h4.2c.663 0 1.2-.537 1.2-1.2v-3c0-.662-.538-1.2-1.2-1.2zM60 31.8c0-.662.537-1.2 1.2-1.2h4.2c.663 0 1.2.538 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zM61.2 60c-.663 0-1.2.538-1.2 1.2v3c0 .663.537 1.2 1.2 1.2h4.2c.663 0 1.2-.537 1.2-1.2v-3c0-.662-.537-1.2-1.2-1.2zm9.001-28.2c0-.662.537-1.2 1.2-1.2h4.2c.663 0 1.2.538 1.2 1.2v3c0 .663-.537 1.2-1.2 1.2h-4.2c-.663 0-1.2-.537-1.2-1.2zm1.2 28.2c-.663 0-1.2.538-1.2 1.2v3c0 .663.537 1.2 1.2 1.2h4.2c.663 0 1.2-.537 1.2-1.2v-3c0-.662-.537-1.2-1.2-1.2z"
        })
    });
const $a095b75a8dbf849f$var$$8a74d3a6d7aead6c$var$ForwardRef = (0, $eF4cA.forwardRef)($a095b75a8dbf849f$var$$8a74d3a6d7aead6c$var$SvgComponent);
var $a095b75a8dbf849f$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($a095b75a8dbf849f$var$$8a74d3a6d7aead6c$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $8b2ad93c34d2e73a$var$$91289bc47dea8554$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M38 11.45c1.519 0 2.75 1.23 2.75 2.75v19.6c0 1.518-1.231 2.75-2.75 2.75H10c-1.519 0-2.75-1.232-2.75-2.75V14.2c0-1.52 1.231-2.75 2.75-2.75zm5.25 2.75c0-2.9-2.35-5.25-5.25-5.25H10c-2.9 0-5.25 2.35-5.25 5.25v19.6c0 2.899 2.35 5.25 5.25 5.25h28c2.9 0 5.25-2.351 5.25-5.25zM14.7 15.9c0-.332.268-.6.6-.6h2.1c.33 0 .6.268.6.6v1.5c0 .33-.27.6-.6.6h-2.1c-.332 0-.6-.27-.6-.6zm-4.502-.6c-.332 0-.6.268-.6.6v1.5c0 .33.268.6.6.6h2.1c.331 0 .6-.27.6-.6v-1.5c0-.332-.269-.6-.6-.6zm4.501 15.299c0-.331.269-.6.6-.6h2.1c.332 0 .6.269.6.6v1.5c0 .331-.268.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm-4.501-.6c-.332 0-.6.269-.6.6v1.5c0 .331.268.6.6.6h2.1c.331 0 .6-.269.6-.6v-1.5c0-.331-.269-.6-.6-.6zm9.6-14.1c0-.331.27-.6.6-.6h2.1c.332 0 .6.269.6.6v1.5c0 .331-.268.6-.6.6h-2.1c-.33 0-.6-.269-.6-.6zm.6 14.1c-.33 0-.6.269-.6.6v1.5c0 .331.27.6.6.6h2.1c.332 0 .6-.269.6-.6v-1.5c0-.331-.268-.6-.6-.6zm4.5-14.1c0-.331.27-.6.6-.6h2.1c.332 0 .6.269.6.6v1.5c0 .331-.268.6-.6.6h-2.1c-.33 0-.6-.269-.6-.6zm.6 14.1c-.33 0-.6.269-.6.6v1.5c0 .331.27.6.6.6h2.1c.332 0 .6-.269.6-.6v-1.5c0-.331-.268-.6-.6-.6zM30 15.899c0-.331.269-.6.6-.6h2.1c.331 0 .6.269.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.331 0-.6-.269-.6-.6zm.6 14.1c-.331 0-.6.269-.6.6v1.5c0 .331.269.6.6.6h2.1c.331 0 .6-.269.6-.6v-1.5c0-.331-.269-.6-.6-.6zm4.498-14.1c0-.331.268-.6.6-.6h2.1c.331 0 .6.269.6.6v1.5c0 .331-.269.6-.6.6h-2.1c-.332 0-.6-.269-.6-.6zm.6 14.1c-.332 0-.6.269-.6.6v1.5c0 .331.268.6.6.6h2.1c.331 0 .6-.269.6-.6v-1.5c0-.331-.269-.6-.6-.6z"
        })
    });
const $8b2ad93c34d2e73a$var$$91289bc47dea8554$var$ForwardRef = (0, $eF4cA.forwardRef)($8b2ad93c34d2e73a$var$$91289bc47dea8554$var$SvgComponent);
var $8b2ad93c34d2e73a$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($8b2ad93c34d2e73a$var$$91289bc47dea8554$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e11935d3675e886a$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $94a260b1f73086ed$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $8b2ad93c34d2e73a$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $a095b75a8dbf849f$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $c66292b379fabf51$var$PAGE_SIZE = 24;
const $c66292b379fabf51$var$SEARCH_DEBOUNCE_MS = 300;
const $c66292b379fabf51$var$ALL_INDUSTRIES = "__all__";
const $c66292b379fabf51$var$FootageCard = ({ id: id, item: item })=>{
    const videoRef = (0, $eF4cA.useRef)(null);
    const { hoverProps: hoverProps } = (0, $j2JDe.useHover)({
        onHoverChange: (isHovered)=>{
            const video = videoRef.current;
            if (!video) return;
            if (isHovered) video.play?.().catch(()=>{});
            else video.pause?.();
        }
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
        ...hoverProps,
        id: id ?? item.fileName,
        textValue: item.description || item.fileName,
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
                    ref: videoRef,
                    filePath: item.fileName,
                    isLoading: item.isPlaceholder,
                    autoPlay: false,
                    muted: true,
                    loop: true,
                    playsInline: true,
                    preload: "metadata",
                    className: " Za182 fcJcitc182 _Hb182 _Ob182"
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    slot: "description",
                    children: item.description || item.fileName
                })
            }),
            !!item.industry && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " z9u7zPc182 y9u7zPc182 B9u7zPc182 A9u7zPc182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                        size: "XS",
                        variant: "neutral",
                        fillStyle: "subtle",
                        children: item.industry
                    })
                })
            })
        ]
    });
};
$c66292b379fabf51$var$FootageCard.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        fileName: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        industry: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        isPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool
    }).isRequired
};
const $c66292b379fabf51$export$6b94db7098b5e02d = ({ defaultSelectedFilePath: defaultSelectedFilePath, onSelect: onSelect })=>{
    const [search, setSearch] = (0, $eF4cA.useState)("");
    const [industry, setIndustry] = (0, $eF4cA.useState)("");
    const [debouncedFilters, setDebouncedFilters] = (0, $eF4cA.useState)({
        q: "",
        industry: ""
    });
    const [selectedKeys, setSelectedKeys] = (0, $eF4cA.useState)(defaultSelectedFilePath ? new Set([
        defaultSelectedFilePath
    ]) : new Set());
    (0, $eF4cA.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setDebouncedFilters({
                q: search,
                industry: industry
            });
        }, $c66292b379fabf51$var$SEARCH_DEBOUNCE_MS);
        return ()=>clearTimeout(timeout);
    }, [
        search,
        industry
    ]);
    const filters = (0, $eF4cA.useMemo)(()=>({
            ...debouncedFilters.q && {
                q: debouncedFilters.q
            },
            ...debouncedFilters.industry && {
                industry: debouncedFilters.industry
            },
            pageSize: $c66292b379fabf51$var$PAGE_SIZE
        }), [
        debouncedFilters
    ]);
    const { data: industries = [] } = (0, $c888393e6da529dc$export$942ee8a59110d867)();
    const industryItems = (0, $eF4cA.useMemo)(()=>[
            {
                id: $c66292b379fabf51$var$ALL_INDUSTRIES,
                label: "All industries"
            },
            ...industries.map((name)=>({
                    id: name,
                    label: name
                }))
        ], [
        industries
    ]);
    const { data: data, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isFetchingNextPage: isFetchingNextPage, isError: isError, error: error } = (0, $c888393e6da529dc$export$86e3bf3696276128)(filters);
    const items = data?.pages?.flatMap((page)=>page.footage) ?? [];
    const total = data?.pages?.at(-1)?.pagination?.total ?? 0;
    const loadingState = isError ? "error" : isLoading ? "loading" : isFetchingNextPage ? "loadingMore" : "idle";
    const selectedKey = selectedKeys.values().next().value;
    const selectedItem = items.find((item)=>item.fileName === selectedKey);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
        isDismissable: true,
        styles: " Lc182 Za182 ZnvuBnEc182",
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " Za182 Fb182 se182 CbnCSD182 Er23pNc182 Ul182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 sd182 eb182 Ug182 qg182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 Jy182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Select footage"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " zmVcLjd182 ymVcLjd182 BmVcLjd182 AmVcLjd182 sd182 Ug182 qg182 _wb182 eb182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d93ff4dc67afc7e$export$b94867ecbd698f21), {
                                "aria-label": "Search footage",
                                placeholder: "Search description, key elements, attributes",
                                value: search,
                                onChange: setSearch,
                                onClear: ()=>setSearch(""),
                                styles: " Zy182"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                "aria-label": "Filter by industry",
                                items: industryItems,
                                value: industry || $c66292b379fabf51$var$ALL_INDUSTRIES,
                                onChange: (key)=>setIndustry(key === $c66292b379fabf51$var$ALL_INDUSTRIES ? "" : key),
                                styles: " ZftVFw182",
                                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                        id: item.id,
                                        textValue: item.label,
                                        children: item.label
                                    })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _dc182",
                                children: [
                                    total,
                                    " total"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                        "aria-label": "Available footage",
                        selectionMode: "single",
                        selectionStyle: "checkbox",
                        selectedKeys: selectedKeys,
                        onSelectionChange: setSelectedKeys,
                        loadingState: loadingState,
                        onLoadMore: ()=>{
                            if (hasNextPage && !isFetchingNextPage) fetchNextPage();
                        },
                        renderEmptyState: ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                size: "L",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e11935d3675e886a$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        children: isError ? "Failed to load footage" : "No footage found"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                        children: isError ? error?.message ?? "There was an error loading the footage. Please try again." : "Try adjusting your search or industry filter."
                                    })
                                ]
                            }),
                        styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 KNJavrc182 Pa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                items: loadingState === "loading" ? [] : items,
                                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)($c66292b379fabf51$var$FootageCard, {
                                        id: item.fileName,
                                        item: item
                                    })
                            }),
                            (loadingState === "loading" || loadingState === "loadingMore") && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb964fde0a813fcf$export$4365333b6bb1c86b), {
                                children: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)($c66292b379fabf51$var$FootageCard, {
                                        item: {
                                            fileName: `placeholder-${Math.random()}`,
                                            description: "Loading footage",
                                            isPlaceholder: true
                                        }
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                        styles: " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        styles: " zmlKpq182 ymlKpq182 BmlKpq182 AmlKpq182 __Ac182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "secondary",
                                onPress: close,
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "accent",
                                isDisabled: !selectedItem || selectedKey === defaultSelectedFilePath,
                                onPress: ()=>{
                                    onSelect?.(selectedItem);
                                    close();
                                },
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Use footage"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                        styles: " _Pa182 Wt182 _zt182"
                    })
                ]
            })
    });
};
$c66292b379fabf51$export$6b94db7098b5e02d.propTypes = {
    defaultSelectedFilePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};





var $HZG6L = parcelRequire("HZG6L");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $52a645c64397597a$var$$3a9d87b25ded7195$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.25 7h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.917 7h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M8.584 7h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M5.25 7h-.5C4.336 7 4 6.664 4 6.25s.336-.75.75-.75h.5c.414 0 .75.336.75.75S5.664 7 5.25 7M15.25 14.5h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.917 14.5h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M8.584 14.5h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M5.25 14.5h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-9.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v9.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.414 0-.75.337-.75.75v9.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-9.5c0-.413-.336-.75-.75-.75z"
            })
        ]
    });
const $52a645c64397597a$var$$3a9d87b25ded7195$var$ForwardRef = (0, $eF4cA.forwardRef)($52a645c64397597a$var$$3a9d87b25ded7195$var$SvgComponent);
var $52a645c64397597a$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($52a645c64397597a$var$$3a9d87b25ded7195$var$ForwardRef);





var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $cfc385dbd50373df$var$$928c7699c3e43baf$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M7.743 5h8.449l-1.72-1.72c-.293-.293-.293-.767 0-1.06s.768-.293 1.06 0l2.998 2.997c.293.293.293.767 0 1.06L15.534 9.28c-.146.147-.338.22-.53.22s-.384-.073-.53-.22c-.294-.292-.294-.767-.001-1.06l1.717-1.72H7.743c-2.482 0-4.5 2.019-4.5 4.5s2.018 4.5 4.5 4.5h3.737c.415 0 .75.336.75.75s-.335.75-.75.75H7.743c-3.309 0-6-2.691-6-6s2.691-6 6-6"
        })
    });
const $cfc385dbd50373df$var$$928c7699c3e43baf$var$ForwardRef = (0, $eF4cA.forwardRef)($cfc385dbd50373df$var$$928c7699c3e43baf$var$SvgComponent);
var $cfc385dbd50373df$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($cfc385dbd50373df$var$$928c7699c3e43baf$var$ForwardRef);



var $7ClmI = parcelRequire("7ClmI");

var $ikOQe = parcelRequire("ikOQe");

var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");

var $lRNYL = parcelRequire("lRNYL");
var $b3c1eb0a6591430d$exports = {};
var $58b094c1e2249862$exports = {};
$58b094c1e2249862$exports = JSON.parse('{"items":[{"fileName":"GENERIC-PeopleCorporate-01.mp4","description":"The video is a short, approximately three-second clip filmed in a modern corporate office environment, featuring a single woman as the primary subject who is captured walking slowly through an open-plan workspace. The woman appears to be in her late twenties to mid-thirties, with medium-brown skin tone, dark hair styled neatly in a low updo, and thin-framed rectangular glasses. She is dressed in a fitted white long-sleeve square-neck top tucked into a high-waisted, pleated midi skirt in a warm beige or blush tone. In her hands she holds two objects: a dark-covered tablet or small notebook pressed against her torso with one hand, and a disposable takeaway coffee cup with a black lid held in the other hand. Her expression is relaxed and subtly pleasant, with a soft smile directed slightly off-camera to her left. The color palette is predominantly neutral and muted, combining cool grays and steely blues from the office architecture with warm beige and white from the subject\'s clothing. The lighting is natural and diffused, sourced primarily from a large floor-to-ceiling window wall occupying the right side of the frame, which floods the space with soft, even ambient daylight and reveals an out-of-focus urban skyline beyond. The composition is centered and at a slight low angle, with the camera tracking the subject\'s forward movement through the space. The background includes glass partition walls to the left with visible reflections, rows of workstations and orange-upholstered office chairs arranged on both sides, small indoor plants providing occasional green accents, an exposed concrete-and-metal ceiling structure above, and the city skyline visible through the expansive windows. The depth of field is moderately shallow, keeping the subject in sharp focus while the surrounding office furniture and windows fall into soft blur. The visual style is photographic and cinematic with a clean, professional aesthetic, consistent with contemporary corporate or business lifestyle footage.","keyElements":["Background office layout and workstation arrangement","Orange-upholstered office chairs","Large floor-to-ceiling windows with city skyline view","Glass partition walls on the left side","Indoor potted plants providing green accents","Ambient natural lighting from windows","Exposed industrial ceiling structure","Disposable takeaway coffee cup","Tablet or small notebook held by subject","Overall cool-neutral color palette of the environment"],"attributes":["corporate professional","natural diffused lighting","neutral muted palette","cinematic shallow focus","clean modern aesthetic"]},{"fileName":"GENERIC-PeopleCorporate-02.mp4","description":"The video is a short clip set inside a corporate meeting room, depicting a group of five adults seated and engaged in a discussion around a conference table. The group includes both men and women of varying apparent ages, with visible diversity in appearance. One man on the far left has short cropped gray-streaked hair and a broad build; beside him sits a woman with dark hair and glasses wearing a warm tan or rust-colored top; next to her is a man with medium-length wavy brown hair and rectangular glasses dressed in an olive-toned casual jacket. On the opposite side of the table sits a woman with long silver-blonde hair wearing a dark top, her hand raised thoughtfully to her chin, and partially visible beside her is another individual in dark clothing. The table surface holds a disposable coffee cup and a laptop, with scattered papers visible. The color palette is cool and muted, combining dark charcoals, warm earth tones from clothing, and desaturated blues and grays from the architectural background. Lighting is ambient and diffuse, sourced from large windows with grid-pattern metal frames visible in the background, producing soft, even illumination across all subjects. The composition is framed at a mid-distance from a slightly elevated angle, capturing the full group in a single wide shot. Behind the subjects, glass partition walls and additional office space with exposed red structural beams are faintly visible. A woven pendant light hangs from the ceiling on the right side. The visual style is photographic and realistic, consistent with professional corporate stock footage, with a moderate depth of field keeping all participants reasonably sharp.","keyElements":["Glass partition walls in background","Large grid-frame windows","Woven pendant light fixture","Conference table surface","Laptop on table","Disposable coffee cup on table","Scattered papers on table","Ambient cool-toned office lighting","Warm earth-tone clothing colors of participants","Visible secondary office space through glass"],"attributes":["collaborative team setting","cool ambient lighting","muted earth tones","mid-distance wide framing","realistic corporate style"]},{"fileName":"GENERIC-PeopleCorporate-03.mp4","description":"The video is a short outdoor clip filmed on an urban sidewalk, featuring a single woman as the primary subject walking toward the camera. The woman has dark brown skin, long black box braids, and is wearing white wireless earbuds in both ears. She is dressed in a fitted black blazer over a white top and a vibrant red skirt, and she carries a white disposable coffee cup in one hand and a red smartphone in the other. Her expression is open and broadly smiling, directed toward the phone screen. The color palette is bold and high-contrast, anchored by the red and black of her outfit against a softly blurred warm-toned architectural backdrop. The lighting is bright and natural, appearing to be direct outdoor daylight that illuminates the subject warmly from the front and slightly to the right, casting soft shadows and creating a vivid, summery feel. The composition is a medium close-up centered on the subject, with the camera tracking her forward movement. The background consists of a blurred urban streetscape including a stone or stucco building facade on the left and a city sidewalk receding into the distance on the right, with out-of-focus pedestrians and parked vehicles faintly visible. The visual style is photographic and cinematic with a shallow depth of field that isolates the subject clearly against the blurred street environment.","keyElements":["Urban sidewalk and street background","Stone or stucco building facade on left","Out-of-focus background pedestrians and vehicles","Bright natural outdoor daylight","Disposable white coffee cup","Red smartphone held in hand","Warm blurred architectural backdrop","Bold red and black clothing color contrast","Shallow depth of field background blur"],"attributes":["bright outdoor daylight","bold high-contrast palette","urban street setting","energetic movement","shallow cinematic focus"]},{"fileName":"GENERIC-PeopleCorporate-04.mp4","description":"The video is a short clip filmed in a small office or studio workspace, featuring three adults interacting around a shared desk. The central subject is a woman seated in the foreground with long blonde hair, amber-tinted rectangular glasses, and a denim blue button-up shirt layered over a pink top. She is leaning slightly forward with her chin resting on her hand, her expression attentive and mildly amused, holding a pen near a notepad on the desk. Behind and to her right stands a man with short dark hair and a gray long-sleeve top, leaning over the desk and writing or holding a notepad and pen. To the left, partially cropped, is the torso and arm of a third person dressed in an olive or khaki jacket. On the desk in front of the subjects are a keyboard, a computer monitor turned to show only its side edge, a disposable coffee cup, and what appears to be a small plant or green object in the foreground right. The color palette is warm and muted, combining denim blues, soft pinks, grays, and warm wood desk tones. The lighting is soft and diffused, appearing to come from overhead ambient office sources, producing even illumination without strong shadows. The composition is a medium close-up framed at desk level, slightly off-center, with a shallow depth of field that keeps the seated woman in sharpest focus while the background figure and monitor are slightly softened. The visual style is naturalistic and professional.","keyElements":["Desk surface with keyboard and notepad","Computer monitor visible on right","Disposable coffee cup on desk","Small green plant or object in foreground","Soft overhead ambient office lighting","Warm wood desk tone","Background wall and second standing figure","Pen and notepad in use","Warm muted color palette of clothing"],"attributes":["warm muted tones","collaborative desk interaction","soft ambient lighting","naturalistic close-up framing","casual professional style"]},{"fileName":"GENERIC-PeopleCorporate-05.mp4","description":"The video is a short close-up clip featuring a single woman filmed from approximately chest height up, in what appears to be a bright, open-plan office environment. The woman has light skin, dark brown hair pulled back or partially styled away from her face, defined brows, and full lashes. She is wearing a light blue collared shirt and a black over-ear headset with a boom microphone positioned near her mouth, indicating she is engaged in a verbal call or communication task. Her expression shifts subtly across the clip \u2014 she is shown looking downward, speaking, and making small movements of her lips and head. The color palette is cool and pale, dominated by the light blue of her shirt, the black of the headset, and the soft white and gray tones of the blurred office background. The lighting is bright and diffused, appearing to be a combination of natural window light and artificial overhead lighting that creates a clean, evenly lit appearance on the subject with no harsh shadows. The composition is a tight close-up centered on the subject\'s face and upper chest, with a very shallow depth of field that renders the background as smooth, out-of-focus blur. In the background, indistinct shapes of office furniture, glass partitions, and greenery are faintly visible. The visual style is clean, bright, and professionally photographic.","keyElements":["Blurred open-plan office background","Faint glass partition and greenery in background","Bright natural and overhead combined lighting","Pale cool color palette of environment","Shallow depth of field background blur","Light blue collared shirt of subject","Office chair visible in soft background"],"attributes":["tight close-up framing","bright clean lighting","cool pale palette","customer service context","sharp subject isolation"]},{"fileName":"GENERIC-PeopleCorporate-06.mp4","description":"The video is a short clip filmed in a dimly lit office environment at what appears to be nighttime or late evening, featuring a single man as the primary subject seated at a workstation. The man has medium-brown skin, short dark hair, and is dressed in a dark navy blue button-up shirt. He is seated in front of a large desktop computer monitor that occupies the left portion of the frame, though the screen faces away from the camera and shows minimal reflected light. On the right side of the frame, a second monitor displays lines of green text or code on a dark background. The man is looking toward the screen and typing on a keyboard, with a subtle smile visible on his face. The overall color palette is very dark and cool, dominated by deep navy blues, dark grays, and teal-tinted shadows, with warm amber tones visible in the background from distant ceiling or wall lighting and faint red accent lights in the far background. The lighting is low-key and atmospheric, with the primary illumination appearing to come from the monitor screens themselves casting a cool blue-toned glow on the subject\'s face and hands. The composition is a medium shot slightly from the front and left of the subject, with moderate depth of field. The background reveals additional darkened office furniture, glass partitions, and ambient colored light sources faintly glowing in the distance. The visual style is cinematic and moody, consistent with a technology or developer-focused professional environment.","keyElements":["Darkened open-plan office background","Secondary monitor displaying code on right","Ambient warm and red accent lights in background","Glass partition walls in background","Low-key monitor-sourced lighting","Dark navy and teal color palette","Keyboard on desk surface","Office chair and desk setup","Nighttime or after-hours atmosphere"],"attributes":["low-key dark atmosphere","cool blue monitor lighting","nighttime office setting","tech developer aesthetic","cinematic moody tone"]},{"fileName":"GENERIC-PeopleCorporate-07.mp4","description":"The video is a short clip filmed at a creative workstation, featuring a single man viewed predominantly from behind and slightly to the right, seated in front of a dual-monitor setup. The man has light to medium skin, short dark curly hair, and is wearing a mustard-yellow short-sleeve t-shirt. He appears to be actively working at the keyboard and occasionally gestures toward the screens. The dual monitors display a video editing software interface: the left curved widescreen monitor shows a large cinematic still frame depicting an astronaut in a space suit against a reddish-brown landscape suggestive of a desert or planetary surface; the right monitor displays a video editing timeline with clip strips, preview thumbnails, and green audio waveform bars. Above the monitors, a horizontal LED tube light mounted on an arm or shelf casts a bright warm-white illumination downward, creating a distinct top lighting effect. The color palette is bold and mixed, combining the warm amber of the subject\'s shirt with the vivid orange and rust tones of the on-screen footage, the dark gray of the workspace, and the high-contrast greens of the editing timeline elements. The overall environment is dimly lit aside from the monitor glow and the overhead work light. To the right of the desk, a small white object resembling a compact clock or cube is visible. The composition is an over-the-shoulder medium shot that emphasizes the screens as the visual focal point. The visual style is photographic with a cinematic quality.","keyElements":["Dual monitor setup displaying video editing software","LED tube work light mounted above monitors","Cinematic sci-fi content visible on left monitor","Video editing timeline on right monitor","Small white desk object (clock or cube) on right","Dark ambient room environment","Keyboard on desk surface","Desk and shelving structure in background","Warm amber tones from subject\'s clothing and screen content"],"attributes":["dark creative workspace","dual-screen editing setup","warm amber accent tones","over-the-shoulder framing","cinematic production context"]},{"fileName":"GENERIC-PeopleCorporate-08.mp4","description":"The video is a short clip filmed inside a glass-walled conference or meeting room during what appears to be evening or nighttime, depicting three adults gathered closely around a rectangular white conference table in a collaborative standing huddle. The three subjects include a woman with dark skin and long natural or lightly curled dark hair wearing a dark navy top; a man with medium skin, dark curly hair, and a beard wearing glasses and a dark navy button-up shirt; and an older man with a shaved or closely cropped head and light skin wearing a light blue button-up shirt. All three are leaning over the table and interacting with documents and a laptop that is open on the table surface. Additional items on the table include water glasses and a disposable coffee cup. The glass wall at the back and sides of the room is heavily covered with colorful sticky notes in yellow, green, orange, and pink, creating a vivid mosaic pattern. Beyond the glass, a large darkened open-plan office space is visible, with the blurred warm glow of city lights and building illumination visible through floor-to-ceiling windows in the far background. The color palette contrasts the dark, moody blues and blacks of the environment with the bright multicolored sticky notes. The lighting is low-key and artificial, with cool overhead office lighting illuminating the table area while the background remains dim. The composition is a medium wide shot at approximately standing eye level, keeping all three subjects and the table in frame. The visual style is photographic and cinematic.","keyElements":["Glass partition walls covered in colorful sticky notes","Dark open-plan office visible beyond glass","City light glow through background windows","Conference table with laptop","Water glasses and disposable coffee cup on table","Documents or printed sheets on table","Low-key artificial overhead lighting","Dark cool-toned ambient color palette","Multicolored sticky notes (yellow, green, orange, pink)"],"attributes":["low-key evening atmosphere","vibrant sticky note color accents","collaborative standing huddle","dark cool-toned palette","glass-walled meeting room"]},{"fileName":"GENERIC-PeopleCorporate-09.mp4","description":"The video is a short clip filmed inside a glass-walled conference room, depicting four adults seated around a dark oval or rectangular meeting table in a formal discussion setting. Two individuals are viewed from behind in the foreground \u2014 one with long straight auburn-red hair and another with long straight blonde hair, both in dark-toned formal jackets \u2014 while two individuals face the camera across the table. Of the two facing forward, one is a man with short light brown hair wearing a dark suit and tie, and the other is a woman with long dark wavy hair wearing a dark blazer over a blue top. The woman facing the camera holds a pen and appears to be speaking. On the table surface are water glasses, a pen, a tablet device, and papers or documents. On the far right edge of the frame, a laptop screen with a bar chart is partially visible. The color palette is predominantly dark and cool, combining deep blacks, navy blues, and dark grays from the formal business attire and table, with cooler whites from the background office space. The lighting is bright artificial office fluorescent lighting visible through the glass partitions, creating an evenly lit background while the foreground subjects are illuminated by a mix of ambient room light. The background, visible through full glass walls, reveals a large open-plan office with rows of workstations, indoor plants, and people, creating a busy secondary layer of activity. The composition is a medium wide shot at seated eye level, with mild softening of the background. The visual style is clean, realistic, and professional.","keyElements":["Glass-walled conference room enclosure","Open-plan office with workstations visible through glass","Indoor plants in background office","Dark oval conference table","Water glasses on table","Tablet device on table","Laptop with bar chart partially visible on right","Documents or papers on table","Bright fluorescent background office lighting","Dark formal business attire color palette"],"attributes":["formal business setting","cool neutral palette","glass-walled transparency","even artificial lighting","professional mid-distance framing"]},{"fileName":"GENERIC-PeopleCorporate-10.mp4","description":"The video is a short clip filmed in a modern multi-story corporate atrium or interior corridor, featuring a group of four adults walking together toward the camera. The group consists of two men and two women of varied apparent ethnicities and ages, all dressed in smart-casual business attire. The leading man on the left has medium skin, dark hair, and is wearing a dark navy long-sleeve shirt with dark gray trousers. Beside and slightly behind him is a woman with medium-brown skin, dark hair pulled back, wearing a white top and dark navy trousers and carrying a small light blue handbag. Further back is another man with light-medium skin and a messenger bag worn across his body, dressed in a white collared shirt and dark trousers with brown shoes. A fourth figure, partially visible at the back, appears to be wearing a darker outfit. The subjects are walking along a raised interior walkway with silver metal railings on both sides. The architectural background is warm and contemporary, featuring visible stone-clad or wooden structural columns, open staircase railings on either side, greenery and plants visible below and to the sides, and bright overhead recessed lighting in the ceiling above. The color palette is warm and neutral, combining golden stone and wood tones of the architecture with the dark navy and white of the subjects\' clothing. The lighting is bright, clean, and artificial from above, producing even illumination across the corridor. The composition is a medium wide shot at a slightly low angle, with the camera tracking the group walking toward the lens. The visual style is photographic and dynamic.","keyElements":["Multi-level corporate atrium architecture","Silver metal corridor railings on both sides","Warm stone or wood structural columns","Visible greenery and plants below walkway","Bright recessed overhead ceiling lights","Open staircase structure visible at sides","Light blue handbag carried by subject","Messenger bag worn by background subject","Warm golden and navy color palette"],"attributes":["warm architectural tones","dynamic walking movement","bright overhead lighting","corporate atrium setting","clean wide-angle framing"]},{"fileName":"GENERIC-PeopleCorporate-11.mp4","description":"The video is a short outdoor clip featuring three women walking together side by side along what appears to be an exterior urban or corporate plaza area. The three women are of diverse apparent ethnicities: the leftmost woman has medium-brown skin and a voluminous natural afro hairstyle, wearing a sage green blazer and holding a black laptop or folder flat under one arm and a disposable coffee cup in the other hand; the center woman has light skin and short platinum blonde hair styled with a swept fringe, wearing glasses and a dark olive or forest green blazer over a white top, and carrying a disposable coffee cup; the rightmost woman has medium skin with dark auburn wavy hair pulled into a low ponytail, wearing a light gray or cream plaid blazer and carrying a smartphone in one hand and a brown leather shoulder bag. All three women are dressed in a coordinated palette of neutrals, muted greens, and warm tones. They are visibly engaged in conversation, with expressions ranging from broad smiles to attentive listening. The background is a smooth stone or concrete architectural facade with vertical pillar or column structures in a medium gray tone, providing a minimal and clean backdrop. The lighting is natural outdoor daylight, bright but soft and slightly diffused, illuminating the subjects evenly from the front. The composition is a low-angle medium shot, slightly below eye level, that frames all three women together within the width of the frame. The visual style is photographic, clean, and contemporary, consistent with professional lifestyle imagery.","keyElements":["Minimal concrete or stone architectural facade background","Vertical pillar or column structures in background","Natural outdoor daylight lighting","Disposable coffee cups held by two subjects","Black laptop or portfolio under one subject\'s arm","Brown leather shoulder bag","Smartphone held by right subject","Muted green, gray, and neutral clothing palette","Low-angle framing of outdoor setting"],"attributes":["natural outdoor daylight","muted green and neutral palette","minimal architectural backdrop","low-angle group framing","warm collaborative energy"]},{"fileName":"GENERIC-PeopleCorporate-12.mp4","description":"The video is a short clip filmed in a bright open-plan office environment, featuring a single man as the primary subject in a medium close-up profile view. The man has light skin, medium-length dark brown hair pulled back into a low bun, and light facial stubble. He is wearing a dark maroon or burgundy polo shirt and a black over-ear headset with a boom microphone extending near his mouth, indicating he is engaged in a spoken communication task. He is seated and appears to be looking slightly downward and forward at an unseen screen, with subtle mouth movements consistent with speaking. The color palette is composed of the deep burgundy of his shirt, the black of the headset, and the bright cool whites and pale grays of the overexposed window-lit background. The lighting is predominantly natural, sourced from large windows behind and to the right of the subject, creating a bright backlit halo effect and slightly overexposing the background while the subject is illuminated from the side with softer ambient fill light. In the background, a second individual is visible but significantly out of focus \u2014 a person of darker skin tone in a gray or white top seated at a workstation with a laptop open in front of them. Additional blurred elements suggest more desk surfaces and screens. The composition is a tight medium shot in profile, with a shallow depth of field that isolates the primary subject clearly from the background. The visual style is clean and photographic.","keyElements":["Bright large windows creating backlit background","Second background figure at laptop workstation","Blurred open-plan office desk surfaces","Strong natural backlighting from windows","Overexposed pale gray window background","Shallow depth of field background blur","Urban or neutral exterior visible through window","Burgundy and black clothing color contrast"],"attributes":["bright natural backlighting","profile close-up framing","cool pale background tones","customer support context","sharp subject isolation"]},{"fileName":"GENERIC-PeopleCorporate-13.mp4","description":"The video is a short clip filmed in a bright and airy open-plan office workspace with an industrial aesthetic, featuring a single woman as the primary subject in the foreground. The woman has dark brown skin, a very closely cropped bleached or natural platinum-gray buzz cut, and is wearing a vibrant red long-sleeve blouse with voluminous gathered sleeves and a smocked or textured neckline, along with a gold chain necklace and a watch on her wrist. She is holding a smartphone with both hands and looking down at it with a broad, open smile. The color palette is bold and warm, anchored by the striking red of her top set against the warm tones of exposed brick walls and light wood desk surfaces in the background. The lighting is bright and natural, sourced from large industrial-style grid windows in the background that flood the space with soft, even daylight and slightly overexpose the window areas. The composition is a medium shot centered on the subject, with the camera at approximately her chest level and a moderate depth of field that softly blurs the background. In the background, two other individuals are visible but out of focus: one older man to the left with gray hair seated at a desk holding printed papers, and one woman with dark curly hair to the lower left foreground edge in dark patterned clothing. Additional blurred background elements include desks with computer monitors, a small potted green plant, and the exposed brick and window architecture. The visual style is photographic with a bright, contemporary, and lively quality.","keyElements":["Exposed brick wall in background","Large industrial-style grid windows with daylight","Background desks with computer monitors","Small potted green plant in background","Out-of-focus secondary figures in background","Warm wood desk surface tones","Bright natural window lighting","Bold red and warm brick color palette","Smartphone held by subject"],"attributes":["bright natural daylight","bold warm red palette","industrial brick-and-window aesthetic","vibrant energetic mood","medium centered framing"]}]}');


var $668ebcf1d8bd628d$exports = {};
$668ebcf1d8bd628d$exports = JSON.parse('{"items":[{"fileName":"GENERIC-PeopleCraft-01.mp4","description":"The video presents an extreme close-up of a jeweler\'s hands working on a round brilliant-cut diamond solitaire ring held within a dark metallic ring clamp or engraving vise. The diamond, positioned prominently in the upper-left area of the frame, is set in a prong-style silver or white gold setting and catches the light to display vivid internal refractions and sparkle. The craftsperson\'s bare fingers are partially visible beneath and beside the clamp, providing a sense of scale and manual control. A small metal tool \u2014 likely a graver or pusher \u2014 is visible approaching the stone and setting from the right side of the frame. The color palette is dominated by cool steel grays and dark charcoal tones from the metallic tool and clamp, contrasted against the pale cream warmth of the skin tones and the bright, white-silver brilliance of the diamond itself. Lighting is close and directional, creating high contrast on the diamond\'s facets and casting soft shadows on the surrounding metalwork and fingers. The background shifts between deep black on the upper-left and warm beige-skin tones on the lower-right as the camera position changes between frames. The framing is extremely tight and shallow in depth of field, keeping the diamond sharply in focus while the clamp body and hand edges fall into gentle blur. The visual style is cinematic and documentary in quality, with a raw, tactile intimacy that emphasizes the material details of the craft.","keyElements":["Background color (black vs. warm beige)","Lighting direction and intensity on the diamond","Color temperature of overall scene","Tool type visible in frame","Skin tone warmth and contrast"],"attributes":["extreme macro","high contrast","artisan craftsmanship","dark and intimate","cinematic realism"]},{"fileName":"GENERIC-PeopleCraft-02.mp4","description":"The video shows a person working on a large-scale abstract canvas painting positioned vertically against a wall in what appears to be an indoor studio environment. The subject is seen from behind, standing and reaching upward and across the canvas with their right arm, applying paint directly with a sponge or cloth tool held in the hand. The person has dark hair pulled up in a bun, with one or two thin paintbrushes tucked into the hair accessory. They are wearing a mustard or burnt-orange long-sleeved jacket or coat that is belted or fitted at the waist, creating a silhouette with strong warm tones against the cooler-dominated canvas. The large canvas dominates the background and occupies the majority of the frame; it is painted in broad, gestural strokes of vivid cerulean and sky blue, interspersed with swirling passages of bright golden-yellow and orange, with additional accents of green at the lower portion and traces of pink and coral. The brushwork is loose and expressive, suggesting an abstract or semi-abstract compositional style. The studio setting is partially visible \u2014 a gray curtain hangs on the far right, and a glimpse of textured plaster or brick wall is visible on the left edge. Lighting in the studio is warm and diffused, emphasizing the richness of the pigments. The framing captures the subject from approximately mid-back to just below the knees, centering them against the vibrant canvas in a medium-wide shot with a relatively shallow depth of field that slightly softens the studio\'s peripheral details.","keyElements":["Canvas colors and painted pattern","Background studio wall and curtain","Room lighting warmth","Position and angle of the person relative to the canvas","Color of the artist\'s clothing"],"attributes":["bold color palette","expressive and gestural","studio creativity","dynamic movement","warm-toned atmosphere"]},{"fileName":"GENERIC-PeopleCraft-03.mp4","description":"The video depicts a woman working outside the entrance of a small retail shop on what appears to be a daytime street setting with overcast natural light. The subject has long brown hair pulled back loosely and is dressed in a denim blue short-sleeve top, dark slim-fit trousers, and a gray denim apron with brown leather shoulder straps. She is actively handling a light powder-blue folding bistro chair \u2014 lifting, positioning, or adjusting it \u2014 near a low wooden planter box filled with green foliage and bright pink geraniums. A second powder-blue bistro chair is visible to the right, and the overall outdoor seating arrangement suggests she is setting up or tidying the front terrace area. The shop facade behind her is white-painted with large display windows framed in white, through which the interior is visible: exposed brick walls, wall-mounted shelves displaying various jars and packaged goods, and a prominently readable yellow signboard. Above the entrance, a string of triangular bunting flags in pastel pink, yellow, blue, and white hangs festively across the storefront. To the right, the exterior wall of an adjacent brick building is partially visible, along with what appears to be a green-painted shop column or board. The image has a bright, airy, mildly overcast quality with soft shadows and a natural color rendering. The framing is a medium-wide shot that positions the subject centrally, with the storefront as the dominant background element filling the full width of the frame.","keyElements":["Bunting flag colors and style","Planterbox flowers and foliage","Storefront window display arrangement","Background building facade material and color","Bistro chair color"],"attributes":["bright and airy","small business charm","street-level setting","natural daylight","pastel color accents"]},{"fileName":"GENERIC-PeopleCraft-04.mp4","description":"The video shows a woman with long reddish-brown hair tied back in a low ponytail working at a pottery wheel in what appears to be a bright, naturally lit ceramics studio. She is seated and leaning forward with both hands actively shaping a small clay vessel on the spinning wheel, her fingers pressing into and around the form in a focused posture. She wears a short-sleeved light teal or sage green shirt and a beige or clay-colored apron; her hands and forearms show visible traces of wet clay. The pottery wheel itself is pale gray and wide, with a small water container visible at its edge. The studio environment surrounding her is warm and well-organized: wooden shelving units on both sides hold numerous unfired ceramic pieces in muted cream and white tones \u2014 bowls, vases, and various vessel forms at different stages. In the background, a large bright window provides soft, diffused backlight that illuminates the scene with a hazy, warm glow. Additional wheels and tools are softly visible in the mid-ground, slightly out of focus. The color palette throughout is warm and earthy \u2014 creams, tans, pale greens, and sandy beiges \u2014 unified by the soft natural window light. The framing is a medium shot at roughly eye level, with the wheel and the subject\'s hands centered in the lower portion of the frame. The depth of field is shallow enough to blur the background shelves softly while keeping the subject and the clay vessel in clear focus. The visual style is clean, warm, and cinematic.","keyElements":["Background shelving arrangement and ceramics","Window size and backlight intensity","Studio workspace layout","Apron color and material appearance","Overall warm vs. cool color grading"],"attributes":["warm and earthy tones","tactile craftsmanship","soft natural backlight","intimate studio setting","quiet focused mood"]},{"fileName":"GENERIC-PeopleCraft-05.mp4","description":"The video features a young woman smiling and looking downward while working at a kitchen counter or island, positioned in a medium-close shot that frames her from roughly mid-torso upward. She has medium-length wavy light brown or ash-blonde hair that falls loosely around her face, and she wears a light denim chambray shirt with the collar open, layered underneath a tan or caramel-brown leather apron that has text printed on it including the partial word \'KIT\' and a tagline, suggesting a culinary or kitchen-themed apron. She holds a head of fresh broccoli in both hands, positioned in front of her at counter level, while cut broccoli florets are visible scattered across a wooden cutting board to the right. In the foreground, slightly out of focus, a large stainless steel pot sits to the left, and a small black round object \u2014 possibly a trivet or spice container \u2014 rests on the counter. A white bowl is partially visible at the far right edge. The kitchen background is warm and modern \u2014 illuminated by warm point-source lighting visible in the mid-background, with reflective gold or brass backsplash panels and modern appliances including what appears to be a gray standing mixer. The overall color palette blends warm ambers and golds from the kitchen lighting with the cool blues of her shirt and green tones of the vegetables. The depth of field is moderately shallow, keeping the subject sharp while rendering the background and foreground objects in a soft cinematic blur. The expression visible on the subject\'s face is a broad, open smile directed downward toward the vegetable.","keyElements":["Kitchen background lighting and appliances","Counter surface and foreground cookware","Backsplash color and material","Cutting board arrangement and food items","Apron color and styling"],"attributes":["warm kitchen ambiance","candid and natural","lifestyle photography style","shallow depth of field","cheerful mood"]},{"fileName":"GENERIC-PeopleCraft-05.mp4","description":"The video features a young woman smiling and looking downward while working at a kitchen counter or island, positioned in a medium-close shot that frames her from roughly mid-torso upward. She has medium-length wavy light brown or ash-blonde hair that falls loosely around her face, and she wears a light denim chambray shirt with the collar open, layered underneath a tan or caramel-brown leather apron that has text printed on it including the partial word \'KIT\' and a tagline, suggesting a culinary or kitchen-themed apron. She holds a head of fresh broccoli in both hands, positioned in front of her at counter level, while cut broccoli florets are visible scattered across a wooden cutting board to the right. In the foreground, slightly out of focus, a large stainless steel pot sits to the left, and a small black round object \u2014 possibly a trivet or spice container \u2014 rests on the counter. A white bowl is partially visible at the far right edge. The kitchen background is warm and modern \u2014 illuminated by warm point-source lighting visible in the mid-background, with reflective gold or brass backsplash panels and modern appliances including what appears to be a gray standing mixer. The overall color palette blends warm ambers and golds from the kitchen lighting with the cool blues of her shirt and green tones of the vegetables. The depth of field is moderately shallow, keeping the subject sharp while rendering the background and foreground objects in a soft cinematic blur. The expression visible on the subject\'s face is a broad, open smile directed downward toward the vegetable.","keyElements":["Kitchen background lighting and appliances","Counter surface and foreground cookware","Backsplash color and material","Cutting board arrangement and food items","Apron color and styling"],"attributes":["warm kitchen ambiance","candid and natural","lifestyle photography style","shallow depth of field","cheerful mood"]},{"fileName":"GENERIC-PeopleCraft-07.mp4","description":"The video presents a macro-level, low-angle close-up shot of a piece of freshly planed or cut timber resting on a flat work surface, with curling wood shavings piled beside it. The camera is positioned at near-surface level, looking along the length of the wooden plank, making the sharp cut edge of the timber the primary focal point of the frame. The wood itself is pale blond in tone, and the curled shavings beside it reflect the same light honey-gold color. Sawdust and fine debris are scattered across the surface. In the strongly blurred background, a figure is faintly discernible \u2014 a person, possibly a woodworker, whose form and a metallic hand tool (visible as a small bright shape) can be detected in soft focus behind the timber. The background is rendered in muted warm grays and browns, consistent with a workshop or studio environment. A subtle atmospheric haze or airborne dust is perceptible in the scene, giving the background a slightly diffused quality. The lighting is warm and moderately low-key, with the primary illumination coming from a direction that highlights the grain and texture of the wood and the fine curl of the shavings. The depth of field is extremely shallow \u2014 only the near edge of the timber is in sharp focus, with everything else falling rapidly into bokeh. The overall color palette is warm amber, tan, and ochre from the wood, set against muted gray-brown workshop tones. The visual style is cinematic and craft-focused, emphasizing material texture and the human presence behind the work.","keyElements":["Background workshop environment lighting","Amount and arrangement of wood shavings","Depth of field and bokeh style","Visibility and clarity of background figure","Overall scene warmth and color grading"],"attributes":["macro and low-angle","warm artisan tones","shallow depth of field","tactile material focus","workshop atmosphere"]},{"fileName":"GENERIC-PeopleCraft-08.mp4","description":"The video shows two people working together at a counter or workbench in what appears to be a plant shop or botanical studio environment. The left subject is a man with short dark hair and a short beard, wearing a light beige or cream-colored long-sleeved shirt and a dark navy apron with brown leather straps; he is leaning forward with a pen or stylus in his hand, writing or sketching in a notebook or on paper laid on the surface in front of him. The right subject is a woman with short light-colored hair, wearing a black-and-white horizontal striped long-sleeved top under a matching dark apron with brown leather straps; she holds a tablet device in one hand while her other arm rests to the side, and she is visibly smiling. Both subjects appear engaged with the shared task at the counter. The counter surface holds papers, small tools or craft implements, a small wooden box or container, and other objects partially out of focus. The surrounding environment is densely populated with green plants of various types \u2014 large-leafed tropical plants, smaller succulents in pots, and trailing vines \u2014 which occupy the foreground edges of the frame (creating natural framing), the counter surface, and the background shelving. The shelving in the background is a dark metal or wood ladder-style unit holding more potted plants in white and terracotta pots. The background wall appears to be a light gray or muted tone. The lighting is warm and interior, creating a lush, layered visual environment. The framing is a medium shot centered on both subjects from roughly chest height, with the foreground plant leaves creating organic borders.","keyElements":["Background shelving and plant arrangement","Foreground plant framing density","Background wall color","Counter surface objects and tools","Lighting warmth and intensity"],"attributes":["lush botanical setting","collaborative activity","warm indoor lighting","layered depth and framing","natural and organic mood"]},{"fileName":"GENERIC-PeopleCraft-09.mp4","description":"The video shows a close-medium shot of a person\'s torso, arms, and hands engaged in chopping vegetables on a wooden cutting board in what appears to be a modern domestic kitchen. The subject is wearing a cream or off-white chunky knit sweater with visible texture and a light blue-and-white striped apron over it. Both hands are actively working with a large chef\'s knife \u2014 one hand gripping the handle and the other guiding the blade in a tucked-finger grip \u2014 slicing rounds of zucchini. The cutting board is wooden and positioned on a light-toned kitchen counter. Around the cutting board, various fresh vegetables are arranged: a red bell pepper, a small eggplant or purple onion, mushrooms, and already-sliced zucchini rounds are visible. To the left foreground, a white ceramic bowl holds dark leafy greens, and a glass bottle containing a clear liquid (likely oil or vinegar) sits beside it. On the right side of the board, a portion of a halved zucchini and sliced mushrooms are visible. The kitchen background features light gray-blue cabinetry, a natural wood countertop edge, and what appears to be a built-in oven or appliance partially visible in the upper right. The frame head is cropped at approximately shoulder level so the subject\'s face is not visible. The lighting is bright and even \u2014 likely a combination of natural and artificial sources \u2014 giving the scene a clean, fresh, and airy quality. The overall color palette is neutral and fresh, with the cream and blue of the clothing contrasting with the vivid greens and reds of the vegetables.","keyElements":["Counter surface material and color","Vegetable arrangement and variety","Background cabinetry color","Foreground bowl and bottle placement","Kitchen appliances and overall color scheme"],"attributes":["bright and clean","food preparation focus","close-medium framing","fresh color palette","everyday domestic setting"]},{"fileName":"GENERIC-PeopleCraft-10.mp4","description":"The video features a young woman painting on an upright canvas set on an easel outdoors on what appears to be a rooftop terrace or balcony, backlit by a low golden sunset or sunrise. The subject is positioned in profile, facing right, with long dark wavy hair falling loosely past her shoulders. She wears a loose pink-and-white vertical-striped shirt or blouse with the sleeves pushed to mid-forearm, and a thin red bracelet is visible on her right wrist. Her right hand holds a fine paintbrush raised toward the upper portion of the canvas, while her left arm supports a round palette that is dark and paint-stained. The canvas on the easel shows in-progress painted imagery \u2014 partially visible warm and colorful shapes, including what appear to be warm yellows, blues, and pinks. The rooftop setting behind her includes a metal railing, string lights (globe bulbs) strung along the railing, potted plants with small dried flower stalks, and small green shrubs. The urban skyline is visible in the background: low building rooftops in silhouette, with taller structures faintly visible against the sky. The sky itself is dominated by an extremely bright, warm golden-yellow glow at the horizon \u2014 the full sun is partially visible as a glowing orb \u2014 that bathes the entire scene in an intense, warm amber-orange light. This strong backlighting creates a rim-lit effect on the subject\'s profile and hair, while the palette and canvas catch strong reflected warm light. The overall color palette is deeply saturated in amber, gold, orange, and warm pink tones, with cooler blue-gray only faintly present in the distant buildings. The framing is a medium shot with the subject centered left-of-frame against the glowing backdrop.","keyElements":["Sky color and sun position/intensity","Background urban skyline silhouette","String light arrangement along railing","Rooftop plant and foliage styling","Canvas position and angle on easel"],"attributes":["golden hour backlighting","warm saturated palette","outdoor rooftop setting","painterly and atmospheric","silhouette rim lighting"]}]}');


var $c4c56e711d71045d$exports = {};
$c4c56e711d71045d$exports = JSON.parse('{"items":[{"fileName":"GENERIC-PeopleSports-01.mp4","description":"The video is shot from an extreme low angle at ground level on a bright green artificial turf football (soccer) field, with the camera positioned just centimeters above the surface. The frame is dominated by the lower legs and feet of two players in motion, captured in close-up with shallow depth of field. The foreground player wears white knee-high socks and dark cleated boots with subtle red accents, while the second player slightly behind wears blue knee-high socks and dark cleated boots with pink-red accents. Both players are mid-stride, conveying rapid movement. A white-and-black classic-paneled soccer ball sits on the turf in the right-center portion of the frame. The turf is vivid green with white line markings visible near the bottom of the frame. In the blurred background, the white metal frame of a goal post is faintly visible, along with dark green trees and a pale sky, suggesting daylight. Warm directional sunlight rakes across the scene from the right, casting long diagonal shadows across the turf and creating a golden warmth on the players\' legs. The visual style is cinematic and action-oriented, with strong motion blur on the players and a compressed, immersive ground-level perspective.","keyElements":["Sock colors (white vs. blue)","Cleat/boot color and style","Turf color and texture","Field line markings","Goal post in background","Background trees and sky","Lighting direction and warmth"],"attributes":["Ground-level perspective","High-energy action","Warm golden lighting","Shallow depth of field","Dynamic motion blur"]},{"fileName":"GENERIC-PeopleSports-02.mp4","description":"The video is set on a night football (American football) field illuminated by artificial floodlights, with a predominantly dark background that gives the scene a dramatic, high-contrast appearance. The main subject is a male American football player wearing a black helmet with a face guard, a black jersey with a partially visible white number, grey football pants, and a neon yellow wristband, who is carrying the ball tucked under his right arm and running forward. His face is clearly visible through the helmet\'s face mask, showing a focused expression. To his left and partially behind him, another player wearing a white jersey with the number 80 in black is leaning into him in a blocking or tackling motion. Additional players are visible in the lower-left corner, cropped out of frame. The football is a standard brown oblong ball gripped firmly. The field surface at the very bottom of the frame shows short green turf. The lighting is stark artificial floodlight from above, creating sharp highlights on the helmet and players\' faces while leaving the background nearly fully black. The composition is a medium-close shot, centered on the ball carrier, with vertical stadium light poles faintly visible in the dark background. The visual style is photographic and cinematic, conveying intensity and physicality.","keyElements":["Jersey colors (black vs. white)","Background darkness and stadium light poles","Field turf color","Wristband accent color","Helmet and face guard style","Lighting intensity and direction"],"attributes":["Night-time stadium setting","High dramatic contrast","Intense physical action","Artificial floodlight atmosphere","Close-up confrontational framing"]},{"fileName":"GENERIC-PeopleSports-03.mp4","description":"The video is captured from a very low water-level angle, looking across the surface of the ocean toward a breaking wave. Two surfers share a single long blue surfboard riding the crest of a wave. The taller figure, an adult male wearing red board shorts and no shirt, stands upright near the rear of the board with arms outstretched for balance. In front of him, a smaller figure \u2014 a child wearing dark swim shorts \u2014 crouches low on all fours on the board, still in the process of rising. The ocean water is a vivid turquoise-blue and sparkles with sunlight, creating bright glittering reflections across the entire foreground. The breaking wave\'s white foam is visible behind and beneath the surfboard. To the left of frame, a mountainous coastline with brown hillsides and a narrow strip of green vegetation is visible, bathed in warm light. The sky occupies the upper third of the frame and is bright blue with scattered white clouds, with strong lens flare from the sun positioned in the upper-left area. The overall color palette is dominated by blues, whites, and warm golden tones. The lighting is bright, natural daytime sunlight with a warm haze near the sun. The composition places the two surfers in the right-center of the frame against a sweeping seascape, creating an expansive, open feel.","keyElements":["Ocean water color and sparkle","Surfboard color (blue)","Sky color and cloud coverage","Coastline and mountain backdrop","Lens flare position and intensity","Board shorts colors","Wave foam and sea surface"],"attributes":["Bright natural sunlight","Expansive open seascape","Water-level camera angle","Warm tropical color palette","Multi-generational pairing"]},{"fileName":"GENERIC-PeopleSports-04.mp4","description":"The video is captured from an extremely low ground-level angle, positioned just behind and below a skateboard in motion, looking forward along a wide paved urban avenue. The lower legs and feet of a skater are visible in the upper-left portion of the frame, wearing light teal-blue canvas sneakers with red laces and dark navy jeans. The skateboard itself occupies the left-center of the frame, its four black polyurethane wheels and metal trucks clearly visible, along with the wooden deck edge and orange/red painted rails. The pavement is wide, textured red-brown paved stone that fills the majority of the lower frame, with motion blur applied to convey speed. The avenue stretches to a vanishing point in the middle distance, flanked on both sides by tall green trees in full leaf and mid-rise urban residential buildings with balconies. Pedestrians are faintly visible in the far background. Overhead, power or tram cables cross between the buildings. The sky is a clear bright blue with a soft sun glare visible. Lighting is bright natural daylight with warm tones, casting a sharp shadow from the skateboard on the pavement. The visual style is cinematic with heavy motion blur on the pavement for speed effect.","keyElements":["Pavement color and texture","Tree-lined avenue and buildings on both sides","Sky color and overhead cables","Sneaker color and lace color","Jeans color","Pavement motion blur intensity","Background pedestrians and urban density"],"attributes":["Ultra-low ground-level angle","Urban street environment","Strong motion blur speed effect","Bright natural daylight","Tree-canopied avenue"]},{"fileName":"GENERIC-PeopleSports-05.mp4","description":"The video depicts a female rock climber on a natural outdoor rock face, captured from a slightly elevated angle looking down at her as she scales a steep and overhanging section of grey and brown rock. The climber is a slender woman with light brown hair pulled back in a ponytail, wearing a dark purple or mauve sports bra top, dark shorts, a climbing harness in teal and white, and white climbing shoes. Her arms are extended upward gripping chalk-marked crevices in the rock, and a teal rope runs through carabiners attached to her harness. The rock surface is textured with multiple shades of grey, brown, and off-white, with chalk marks visible where her hands grip. The background below and behind her is softly out of focus, showing the ground far below with scattered rocks and earth tones, suggesting significant height. The lighting is soft and diffuse, with an overcast or shaded quality that minimizes harsh shadows, and the overall color palette is muted \u2014 dominated by grey stone, earthy browns, and accents of teal. The composition places the climber centrally in the frame against the rock face, with the rope line providing a strong diagonal visual element. The visual style is naturalistic and documentary, emphasizing physical exertion and verticality.","keyElements":["Rock surface texture and color","Climbing rope color (teal)","Background ground blur and earth tones","Sports top and shorts color","Lighting quality (diffuse vs. direct)","Chalk marks on rock","Harness color and style"],"attributes":["Overhead downward angle","Muted natural color palette","Soft diffuse lighting","Vertical compositional tension","Gritty outdoor texture"]},{"fileName":"GENERIC-PeopleSports-06.mp4","description":"The video shows a group of four hikers ascending a dry, grassy hillside in single file, silhouetted almost entirely against a bright sky with backlit sunlight coming from just behind the ridge they are approaching. The scene is shot from a low angle looking upward along the slope, with the golden-brown dried grass occupying the lower three-quarters of the frame. All four figures carry trekking poles and wear large backpacks; their clothing shows warm earth tones \u2014 checkered shirts, jeans, and outdoor gear in orange and teal \u2014 though many details are obscured by backlighting. The terrain is rough and sloped, covered in dry straw-colored grass and small rocks. The sun pierces through just over the ridge line creating strong lens flare and a warm golden halo around the hikers. Mountains or hills are faintly visible on the left side of the frame, and the sky transitions from pale near the horizon to a slightly deeper tone higher up, with some light cloud wisps. The color palette is dominated by warm amber and golden tones on the hillside, contrasted by the bright white light from the sun and the cool pale sky. The lighting is dramatic, with rim/backlight causing the figures to appear in semi-silhouette. The visual style is cinematic and expansive, evoking a sense of scale and remoteness.","keyElements":["Hillside grass color and texture","Sky color and cloud density","Backpack colors (orange, teal accents)","Sun position and lens flare","Mountain silhouette in background","Clothing colors and patterns","Lighting direction (backlit)"],"attributes":["Dramatic backlit silhouette","Warm golden-hour palette","Low upward camera angle","Vast open landscape","Group adventure mood"]},{"fileName":"GENERIC-PeopleSports-07.mp4","description":"The video is shot from directly above (overhead/bird\'s-eye view), looking straight down at a female boxer lying on a dark black padded mat surface. The subject is a Black woman with braided hair in two long plaits, wearing a white athletic sports bra top and red mouthguard, with dark boxing hand wraps visible at the wrists. Both arms are raised upward with boxing gloves extended \u2014 the gloves are a dark maroon/dark red with black trim \u2014 in a pose suggesting triumph or exertion. Her skin is glistening with perspiration, indicating intense physical activity. The mat surface fills the entire frame and is a very dark charcoal or near-black color with slightly reflective qualities. The only colors in the scene are the very dark background, the white of the top, the warm brown skin tones, the red mouthguard, and the dark red and black of the boxing gloves. The lighting is artificial and relatively flat, illuminating the subject clearly from above with soft shadows. The composition is tightly centered, placing the fighter\'s face and torso in the middle of the frame with her raised gloves creating a symmetrical or near-symmetrical framing on either side. The visual style is intimate, raw, and cinematic.","keyElements":["Mat surface color (near-black)","Boxing glove color and style","Sports top color","Lighting quality and source","Background mat texture","Hair style visible"],"attributes":["Overhead bird\'s-eye angle","High-contrast dark background","Intimate close-up framing","Raw athletic intensity","Stark minimalist setting"]},{"fileName":"GENERIC-PeopleSports-08.mp4","description":"The video depicts a field hockey scene on a bright green artificial turf pitch, captured from a low angle that emphasizes the playing surface. In the foreground and left side of the frame, a player wearing a white and green striped jersey, dark navy shorts, dark navy and green knee-high socks, and white athletic shoes is crouching forward, gripping a field hockey stick with both hands and preparing to make contact or dribble with a white field hockey ball. The stick is dark brown with a black curved end resting on the turf near the ball. In the background at mid-frame, a goalkeeper is positioned in front of the goal \u2014 wearing a blue long-sleeve shirt, a black helmet and face guard, and knee pads \u2014 crouching in a ready stance holding a goalkeeper\'s glove or blocker. Behind the goalkeeper, the white rectangular metal goal frame with a white net is visible. In the background, several tall palm trees in full green foliage are visible over a green grass bank beyond the pitch perimeter, alongside a clear pale sky. The lighting is warm natural sunlight from a low angle, creating golden highlights and some lens flare on the left edge of the frame, with the scene overall being bright and warm-toned. The color palette features vivid green turf, white goal structure, dark navy, white, green jersey, and the warm tones of the sky and palm trees.","keyElements":["Turf surface color","Goalkeeper jersey and equipment colors","Goal post and net structure","Palm trees and background vegetation","Sky color and light angle","Outfield player jersey color and pattern","Sock and shoe colors"],"attributes":["Low-angle field-level framing","Warm natural sunlight","Vivid green turf","Tropical palm tree backdrop","Sports gear-rich composition"]},{"fileName":"GENERIC-PeopleSports-09.mp4","description":"The video shows an elderly man exercising with a dumbbell in an indoor gym setting. The subject is a very old man, bald, with deeply lined skin and a slight visible smile, wearing a blue patterned short-sleeve polo shirt and dark shorts. He is seated on a gym bench or machine and is performing a dumbbell curl with his right hand, holding a round black dumbbell with a weight marking. His left arm rests on his leg. He is also wearing a silver wristwatch. The surrounding environment is a well-equipped gym interior, with various grey metal strength machines and cable stations visible in the soft-focus background, along with wall-mounted monitors or screens showing blue tones on the upper left. Fluorescent strip lighting illuminates the ceiling visible in the upper background. The color palette is dominated by grey and silver (machines), blue (his shirt and background screens), and the warm skin tones of the subject. The lighting is diffuse indoor artificial light, bright overall with soft shadows. The composition is a medium shot angled slightly upward and to the left, with the subject positioned to the right of center and the gym equipment filling the left background. The visual style is naturalistic and candid, resembling documentary photography.","keyElements":["Gym machine colors and density in background","Shirt color (blue polo)","Background monitor screen colors","Ceiling lighting type","Bench or equipment the subject sits on","Overall indoor gym color palette"],"attributes":["Indoor gym environment","Diffuse artificial lighting","Candid documentary style","Warm naturalistic tone","Subject-focused medium shot"]},{"fileName":"GENERIC-PeopleSports-10.mp4","description":"The video captures a close-up of hands coming together in a team huddle gesture on a volleyball court, set in an indoor gymnasium. Multiple people\'s arms are visible converging toward the center of the frame, their hands stacked or touching in a collective gesture. The players are wearing a variety of athletic clothing \u2014 a dark navy/black tank top with a white stripe on the left edge, a white athletic top in the center-right, a salmon/coral-pink top on the far right, and navy blue shorts. The hands meeting in the center are the primary visual focus, with shallow depth of field blurring the background. In the mid-ground, a smiling woman with dark long hair wearing a light grey or white sports top is visible, slightly out of focus, standing near the volleyball net, which is partially visible as a dark mesh with a white tape strip. Behind the players and net, the wooden gym floor planks in a warm honey-tan tone are visible, along with seating bleachers or benches and warm ambient interior lighting that gives the scene a soft glow. The color palette is neutral to warm \u2014 skin tones, navy, white, coral \u2014 against the warm wood and light background. The composition tightly frames the hands centrally with surrounding figures cropped at the edges. The visual style is cinematic with intentional blur to isolate the teamwork gesture.","keyElements":["Jersey and top colors (navy, white, coral/salmon)","Volleyball net visibility and color","Gym floor color and material","Background bleachers/seating","Interior ambient lighting warmth","Depth of field blurriness of background figures"],"attributes":["Intimate team huddle framing","Warm indoor gymnasium light","Shallow depth of field","Soft neutral color palette","Collaborative group gesture"]},{"fileName":"GENERIC-PeopleSports-11.mp4","description":"The video shows two young boys walking together outdoors at golden hour, seen from behind in a medium shot. The boy on the left is slightly taller and wears a green hoodie with black and white sleeves, dark blue shorts, and has light blond hair; his arm is around the shoulder of the second boy. He carries a worn black-and-white soccer ball tucked under his left arm. The boy on the right is shorter, wearing a blue short-sleeve T-shirt and red shorts, with light brown or blond hair. Both boys are walking away from the camera on a grassy area with dry yellow-gold grass in the foreground. The background is soft-focus and shows green trees on the left and right, and a large multi-story residential building with a red and white facade visible in the center-upper background. The entire scene is bathed in warm amber-golden light typical of late afternoon sun, which also creates a soft bokeh effect on the vegetation. The color palette is warm and saturated \u2014 golden grass, rich green trees, vivid blue, green, and red clothing against the warm light. The composition centers the two children walking away in the middle of the frame, with the sun-kissed landscape around them. The visual style is warm, naturalistic, and evocative.","keyElements":["Grass color (golden-dry vs green)","Tree foliage in background","Residential building facade color","Clothing colors (green hoodie, blue shirt, red shorts)","Lighting warmth and time of day","Bokeh and depth of focus"],"attributes":["Warm golden-hour backlight","Rear-view intimate framing","Lush bokeh background","Nostalgic childhood mood","Outdoor residential setting"]},{"fileName":"GENERIC-PeopleSports-12.mp4","description":"The video shows a female sprinter running on an outdoor athletics track, captured in a wide shot from a low side angle with significant motion blur on her lower body conveying high speed. The athlete is a slender woman with her hair pulled back, wearing a dark crop top, dark form-fitting shorts, and dark running shoes. She is mid-stride, leaning slightly forward, with her arms bent and pumping. The running track is a reddish-brown rubberized surface with white lane line markings that recede toward the background. To the left in the background sits an empty athletics stadium with tiered seating in sections of yellow, blue, red, and orange, along with a large black digital scoreboard and tall stadium floodlight poles. The green infield grass and a blue landing pad for field events are visible in the mid-ground. In the far background, city architecture is visible including what appears to be a mosque or domed building with minarets silhouetted on the horizon. The sky is a hazy warm overcast white-gold, suggesting early morning or late afternoon light. Strong backlight from behind the athlete creates a dramatic rim-lit silhouette effect, with her torso glowing with warm light. The color palette is warm and muted \u2014 reddish-brown track, golden sky, colorful stadium seats \u2014 with the dark figure of the athlete as the focal point.","keyElements":["Track surface color (reddish-brown)","Stadium seating colors (yellow, blue, red, orange)","Scoreboard and floodlight poles","Infield grass color","Skyline and background city architecture","Sky tone and haze","Lighting direction (backlit)"],"attributes":["Dramatic rim-lit silhouette","Wide stadium establishing shot","Warm hazy overcast sky","Strong motion blur on subject","Open architectural backdrop"]},{"fileName":"GENERIC-PeopleSports-13.mp4","description":"The video shows a male athlete running on a treadmill in an indoor home or gym setting, captured from a low-angle shot looking up at the subject. The man has short dark hair, a short beard, medium skin tone, and is wearing large over-ear headphones in dark grey with red accents, and a grey sleeveless hoodie. His face is turned slightly upward and forward with a neutral, focused expression. His right arm and hand are partially visible in motion at the lower frame. To the right, part of the treadmill\'s console is visible \u2014 it appears grey and black \u2014 with a blue sports water bottle resting in a holder on the right side. The background is a bright, airy white interior space with exposed ceiling beams or rafters visible, a hanging pendant light bulb, and white walls, suggesting a modern or loft-style home gym. The lighting is very bright and overexposed white from above, creating a high-key, clean atmosphere. The color palette is primarily white and grey, with the blue water bottle, and the red and grey headphones providing accent colors. The composition is an upward-looking shot centered on the man\'s face and chest, with the treadmill console and gym equipment on the right. The visual style is clean, modern, and aspirational.","keyElements":["Headphone color and style","Interior background color and architectural elements (beams, pendant light)","Treadmill console color","Water bottle color (blue)","Wall and ceiling color","Shirt color and style","Lighting brightness and quality"],"attributes":["High-key bright interior","Low upward camera angle","Modern minimalist gym aesthetic","Clean white color palette","Focused solo workout mood"]},{"fileName":"GENERIC-PeopleSports-14.mp4","description":"The video depicts a middle-aged East Asian woman meditating in a seated cross-legged lotus-adjacent position on a white sofa in a bright, clean domestic living room interior. The woman has short grey-streaked dark hair and wears a sleeveless lavender/light purple athletic tank top and dark grey or slate-blue shorts. Her eyes are closed and her hands rest open on her knees in a relaxed posture. The sofa is a large white fabric couch with a rectangular white throw pillow to the right of the subject. Behind and to the left, sheer white curtain panels diffuse daylight from a window, and a wall-mounted air conditioning unit is visible near the ceiling. To the right, a second window has wooden venetian blinds partially open, allowing warm daylight to filter in. A small round side table with a clear glass vase containing green leafy stems is visible in the far right background. A framed artwork with a blue and white coastal or abstract design hangs on the upper right wall. The color palette is soft and airy \u2014 predominantly white, lavender, and light grey, with warm natural light filling the room. The lighting is bright, diffuse natural daylight from multiple windows, creating a calm and peaceful atmosphere. The composition centers the woman slightly left of center in a full frontal medium shot with the interior surrounding her symmetrically. The visual style is clean, calm, and documentary-naturalistic.","keyElements":["Sofa color and fabric (white)","Curtain and window treatment style","Air conditioning unit visibility","Side table and vase with plant","Wall artwork color and style","Room wall and ceiling color","Blind and window light quality","Clothing color (lavender top, dark shorts)"],"attributes":["Bright airy domestic interior","Calm minimal composition","Soft diffuse natural light","Pastel muted color palette","Serene mindful atmosphere"]}]}');


var $ad0d12887e1e8a9b$exports = {};
$ad0d12887e1e8a9b$exports = JSON.parse('{"items":[{"fileName":"GENERIC-PeopleOutdoor-01.mp4","description":"The video features a group of four people \u2014 two adults and two children \u2014 walking together through a wide, open field of tall green grass that reaches approximately knee height in the foreground. The shot is taken from a low angle at ground level, causing the grass stalks to appear prominently in the foreground and frame the subjects from below. The adult on the left is a woman with long dark hair, dressed in a white dress, while the adult on the right is a man wearing a light blue or grey short-sleeve button-up shirt, carrying a small infant or toddler on his right arm. Between the two adults walks a young girl with long dark hair wearing a light pink top, holding hands with both adults. The figures are seen from behind and are silhouetted against a bright sky as they walk away from the camera toward the horizon. The lighting is strongly backlit with a low sun positioned to the left side of the frame, creating a warm, golden halo effect around the subjects and lens flare across the composition. The sky transitions from a bright white-gold near the sun to a clear blue on the right side, with scattered white clouds. The distant horizon reveals a dark tree line. The color palette is dominated by vibrant greens in the grass, cool blues in the sky, and warm golden tones from the backlighting. The visual style is cinematic and photographic, with a shallow depth of field and soft bokeh in the immediate foreground grass, giving the footage a polished, lifestyle quality.","keyElements":["Tall green grass field in foreground","Warm golden backlit sunset lighting","Blue sky with scattered white clouds","Dark tree line on the horizon","Grass color and density"],"attributes":["warm backlit","cinematic wide-open nature","golden hour palette","low-angle ground-level framing","silhouetted subjects"]},{"fileName":"GENERIC-PeopleOutdoor-02.mp4","description":"The video shows a young man seated on a grass lawn in what appears to be a public park or garden during golden hour. The subject is the sole focus of the frame, positioned centrally and filmed from a medium-close distance. He has short, light brown hair styled upward, and wears round, thin-framed circular glasses, with wired earbuds in his ears. He is dressed in an olive-green utility jacket with a patch on the upper left sleeve, layered over a white t-shirt, and appears to be resting against a dark backpack or bag on his left side. A light blue item of clothing or bag is visible beneath him. He holds a smartphone with both hands and looks down at the screen with a slight smile visible across multiple frames. The lighting is very warm, with a low sun positioned directly behind the subject, creating a strong golden backlight that illuminates his hair and gives the scene a glowing, hazy quality. The background is softly blurred with heavy bokeh, revealing a grassy park environment with trees bathed in orange-gold sunlight, a stone or concrete structure visible on the left (resembling a monument or pillar), and at least two other people seated or walking in the background. The color palette is rich with warm amber and green tones. The visual style is photographic and cinematic with a shallow depth of field.","keyElements":["Green grass lawn surface","Park background with trees and monument structure","Warm golden backlight","Other background park visitors","Dark backpack accessory"],"attributes":["golden hour glow","shallow depth of field","urban park setting","casual relaxed atmosphere","warm amber tones"]},{"fileName":"GENERIC-PeopleOutdoor-03.mp4","description":"The video features a single person seen from behind, standing at the rim of a large volcanic crater and facing outward over the landscape below. The subject is a woman with light-colored hair partially visible beneath a colorful knitted pompom beanie hat featuring a navy blue, red, and white Nordic-style pattern. She wears a bright cobalt blue hooded rain jacket and dark-colored pants or leggings, and has both arms raised outward and upward in a wide open gesture. The figure is positioned centrally in the frame at medium distance, occupying the middle third of the composition vertically. The surrounding environment is dramatic and rugged: steep crater walls made of dark reddish-brown volcanic rock with patches of green and yellow-gold moss or vegetation descend on both sides. At the bottom of the crater sits a circular turquoise-green lake with a calm surface. The overcast sky above is a pale, muted white-grey with diffuse cloud cover, providing flat, even natural lighting with no strong shadows or directional sunlight. The color palette contrasts the vibrant blue of the jacket and teal of the lake against the earthy reds, browns, and muted greens of the crater walls. The visual style is wide photographic with a moderate depth of field, placing the subject clearly in front of the expansive natural background.","keyElements":["Turquoise-green volcanic crater lake","Dark reddish-brown crater walls with mossy vegetation","Overcast grey-white sky","Flat diffuse natural lighting","Wide open landscape composition"],"attributes":["dramatic natural landscape","overcast muted palette","expansive wide framing","rugged volcanic terrain","bold color contrast"]},{"fileName":"GENERIC-PeopleOutdoor-04.mp4","description":"The video shows four people running along a sandy beach toward the camera in a dynamic, motion-filled shot. In the foreground are two children: a girl on the left with her hair in a ponytail, wearing a grey-and-white horizontal striped long-sleeve top over a denim skirt, and a boy in the center-right wearing a light blue short-sleeve t-shirt and grey pants, both appearing to be mid-run with slightly blurred motion. Behind them are two adults \u2014 a man on the left wearing a light blue or grey zip-up hoodie, with short dark hair and a beard, smiling broadly \u2014 and a woman on the right wearing a navy-and-white horizontal striped top and white pants, also smiling. All four figures are barefoot on the sandy beach. The background reveals a flat sandy shoreline, bright breaking ocean waves to the right with white surf and a clear light blue sky above that is intensely bright on the right side of the frame, suggesting a strong low sun or haze. The overall lighting is bright daylight with high key exposure creating near-overexposed areas on the right. The color palette consists of sandy beige, light blue, white, and soft blues. The visual style is photographic and lively, with slight motion blur on the foreground figures emphasizing movement.","keyElements":["Sandy beach surface","Breaking ocean waves to the right","Bright overexposed sky","Clear blue sky and natural daylight","Coastal horizon line"],"attributes":["bright daytime beach setting","high-key natural lighting","dynamic motion blur","casual coastal palette","energetic movement"]},{"fileName":"GENERIC-PeopleOutdoor-05.mp4","description":"The video features four people on a wide, flat, wet sandy beach during what appears to be an overcast day. Two adults and two children are positioned along the waterline, with ocean waves breaking and washing up behind them. The adult on the left is a man seen mostly from behind, wearing a light blue chambray shirt and patterned board shorts in earth tones; he holds a small child by the arms, appearing to swing them. The adult on the right is a woman with voluminous natural curly dark hair, wearing a loose teal or mint-green linen dress belted at the waist; she similarly holds a child in yellow shorts by the waist or arms, also in a swinging posture. The children are both airborne with legs lifted off the ground. The beach surface is reflective and wet, mirroring the figures. The background shows a wide expanse of overcast sky in pale grey-white tones, and mountainous silhouettes along the distant horizon partially obscured by low cloud or mist. The lighting is diffuse and flat with no visible directional sunlight, producing even, soft illumination across the scene. The color palette is muted and cool: sandy beige, grey sky, grey-green mountains, with the teal dress and yellow shorts providing the primary color accents. The visual style is wide and cinematic, with the subjects positioned in a horizontal arrangement across the mid-ground, giving a spacious, atmospheric feel.","keyElements":["Wet reflective sandy beach surface","Overcast pale grey sky","Misty mountain silhouettes in background","Breaking ocean waves","Diffuse flat overcast lighting"],"attributes":["overcast moody atmosphere","muted cool palette","wide cinematic framing","atmospheric misty backdrop","reflective wet sand"]},{"fileName":"GENERIC-PeopleOutdoor-06.mp4","description":"The video shows three people interacting outdoors on a grass lawn in what appears to be a park or open green space. Two older adults \u2014 a woman and a man \u2014 are seated on the grass facing the camera, and a young boy is leaping or jumping toward them with his arms outstretched. The older woman, positioned slightly left of center, has short brown hair and wears a bright red or magenta short-sleeve top with a gold or yellow bracelet on her wrist; she is smiling broadly with her arms reaching toward the child. The older man, seated to her right, has white hair and a white mustache, wears a light blue plaid or checkered button-up shirt and blue jeans, and is also smiling and laughing. The young boy, seen from behind in the left foreground, wears a beige-and-brown horizontal striped t-shirt and grey pants. A dark wicker picnic basket is partially visible on the lower left. The ground is covered in short, dry-looking pale green grass. The background is a blurred, open expanse of the same grass field, conveying a park setting. The lighting appears to be natural outdoor daylight with a warm, slightly golden quality, producing soft shadows and warm skin tones. The color palette includes warm reds, blues, neutral beiges, and muted greens. The visual style is photographic and candid-feeling, shot at a medium distance with a moderately shallow depth of field.","keyElements":["Dry grassy park lawn","Dark wicker picnic basket","Blurred open grassy background","Warm natural outdoor daylight","Green grass color and texture"],"attributes":["warm candid feel","outdoor picnic setting","natural daylight","shallow mid-range depth of field","earthy warm color palette"]},{"fileName":"GENERIC-PeopleOutdoor-07.mp4","description":"The video features a single young woman filmed outdoors against a wide mountainous landscape at what appears to be golden hour. She is positioned centrally to slightly left in the frame, shot from the waist up or chest up at close-to-medium range. The woman has voluminous, curly natural dark auburn or brown hair that moves slightly as she raises her hands to her head. She wears an oversized, flowing white long-sleeve blouse with wide cuffs and a bracelet on her wrist. Her face is partially tilted, with eyes partially closed in at least one frame. The background consists of soft-focus rolling hills or mountains covered in green and golden-brown vegetation, with a narrow strip of pale blue sky visible at the upper right of the frame. The lighting is warm, directional, and low-angled, consistent with late afternoon or early evening sun, which illuminates her skin with golden tones and creates a bright contrast against the white of her blouse. The color palette is warm and natural: golden yellows and oranges in the landscape, white of the garment, and deep greens in the hills. The visual style is cinematic and close-framed with a very shallow depth of field, placing the background in smooth bokeh and emphasizing the subject in sharp contrast to the environment.","keyElements":["Soft-focus mountainous green and golden-brown hills","Pale blue sky strip in background","Warm low-angle golden hour sunlight","Smooth bokeh background","Natural directional side lighting"],"attributes":["golden hour warmth","cinematic shallow focus","natural landscape backdrop","soft and airy aesthetic","close intimate framing"]},{"fileName":"GENERIC-PeopleOutdoor-08.mp4","description":"The video depicts a group of four young adults standing together outdoors on what appears to be a city street or urban plaza, engaged in conversation. The group is composed of two men and two women. On the far left, a man with dark curly hair is visible from the side, wearing a bright yellow jacket. Next to him is a young woman with long light brown hair, wearing a denim jacket over a white crop top with a circular pendant necklace. She is looking toward the others and appears to be gesturing with one hand. In the center-right stands a woman with a large natural afro hairstyle and hoop earrings, wearing a floral or patterned blouse in muted pinks and whites beneath a denim jacket. To the far right is a tall man with darker skin, wearing a dark navy jacket or coat, a dark beanie hat, and a deep red knit scarf. He appears to be speaking or gesturing with his hands near his chest. The background shows blurred multi-story building facades in warm salmon-pink and muted tones, consistent with European-style residential or commercial architecture. The lighting is intensely warm and golden, coming from a low angle behind and to the left of the group, suggesting late afternoon sun; it creates strong lens flare and a hazy, glowing quality throughout the left side of the frame. The color palette is warm amber, yellow, and pink. The visual style is photographic, with a shallow depth of field and a casual, candid quality.","keyElements":["Urban street or plaza setting","Warm salmon-pink building facades in background","Intense low-angle golden backlight with lens flare","Blurred architectural background","Warm amber and golden color wash"],"attributes":["urban golden hour","candid social atmosphere","strong backlight flare","diverse group framing","warm amber city palette"]},{"fileName":"GENERIC-PeopleOutdoor-09.mp4","description":"The video shows a family of four walking through what appears to be a modern airport terminal or transit walkway, filmed from behind at close range. The group consists of two adults and two young girls. The adult on the left is a man wearing a bright yellow crewneck sweatshirt and light tan or khaki pants, pulling a silver hard-shell rolling suitcase with his left hand. The adult in the center-right is a woman with long dark hair, wearing a light blue and white vertical striped button-up shirt, white pants, and a crossbody bag. Between the two adults walks a small girl with dark hair in two pigtails tied with red hair ties, wearing a striped skirt and carrying a yellow backpack on her back while also pulling a small teal hard-shell rolling suitcase. On the far right, a slightly older girl with long dark hair has a large navy blue backpack on her back and wears light blue overalls, turning her head slightly to the right so her face is partially visible. The background is a modern glass-and-steel structure with grey surfaces and large windows, with glimpses of greenery or a landscape visible through the glass. The lighting is bright, even, natural daylight filtered through the glass architecture. The color palette features bold accents of yellow and teal against neutral grey, white, and blue tones. The visual style is clean and photographic, shot at a medium-close distance from behind.","keyElements":["Modern glass and steel terminal architecture","Grey interior surfaces and large windows","Natural daylight from windows","Teal and silver hard-shell rolling suitcases","Yellow and navy backpacks"],"attributes":["clean modern architecture","bright neutral daylight","travel transit setting","bold color accent palette","rear-facing candid composition"]},{"fileName":"GENERIC-PeopleOutdoor-10.mp4","description":"The video features a family of four playing outdoors in a residential backyard lawn during golden hour, with a garden hose spraying a mist of water across the scene. The setting is a well-maintained grassy lawn in front of a modern two-story house with a wood-slat covered patio or pergola, large windows, and light-colored exterior walls. In the foreground, a girl with long blonde hair wears a light blue short-sleeve dress and is positioned at the center-left, appearing to step near a black-and-white soccer ball on the grass. To the left, a woman with blonde hair wears a light grey or beige long-sleeve button-up top; her face and expression are visible and animated as she runs. Toward the right, a boy with light hair wears a grey striped t-shirt and yellow or golden shorts. In the mid-background, a man with short dark hair wears a casual short-sleeve top and holds or directs a garden hose, which creates a wide spray of water droplets that catch the sunlight and glow brilliantly in amber and gold tones, forming the visual centerpiece of the scene. The lighting is intensely warm and directional, originating from a low sun positioned to the right-rear, illuminating the water spray into a luminous golden haze. Green birch or poplar trees are visible to the left. The color palette is vibrant with bright greens, blues, and warm golden amber from the backlight. The visual style is cinematic and photographic with a wide to medium framing.","keyElements":["Modern residential house facade with pergola in background","Green birch or poplar trees on the left","Garden hose water spray catching golden backlight","Well-maintained green grass lawn","Low angled golden hour sunlight"],"attributes":["backyard golden hour","luminous water spray effect","vibrant warm-cool contrast","suburban residential setting","cinematic wide framing"]},{"fileName":"GENERIC-PeopleOutdoor-11.mp4","description":"The video features a single woman walking along the center of a wide, empty two-lane asphalt road that stretches into the distance toward a dramatic alpine mountain landscape. The subject is seen from behind at a medium distance, positioned centrally in the frame. She has light brown hair pulled up into a loose bun and wears sunglasses, a bright yellow hooded puffer jacket, black fitted pants, and grey ankle boots. A large dark black or charcoal backpack is worn on her back. The road is grey asphalt with white edge markings on both sides, creating strong leading lines that draw the eye toward the vanishing point. On both sides of the road, dense rows of tall trees display vivid autumn foliage in shades of golden yellow, orange, and amber, with scattered bare rocky outcroppings and earthy brown ground visible at their bases. In the distant background, large snow-capped grey mountain peaks rise against a pale, slightly hazy blue-white sky. The lighting is natural, diffuse, and even, consistent with an overcast or mildly lit daylight, producing soft tones with no harsh shadows. The overall color palette is dominated by warm golden yellows and oranges of the autumn trees, contrasted against cool greys of the road and mountains and the vivid yellow of the jacket. The visual style is cinematic and wide, with a moderate depth of field showing the subject sharply against a detailed, expansive landscape.","keyElements":["Empty two-lane asphalt road with white markings","Dense autumn golden-yellow and orange trees on both sides","Snow-capped grey mountain peaks in background","Pale blue-white hazy sky","Diffuse flat natural daylight"],"attributes":["autumn color palette","wide cinematic road framing","dramatic alpine backdrop","cool-warm color contrast","solo traveler perspective"]},{"fileName":"GENERIC-PeopleOutdoor-12.mp4","description":"The video shows an older man with short silver-grey hair engaged in gardening activity in a lush, densely planted flower and herb garden. He is seen in profile on the left side of the frame, leaning forward with his arms extended downward toward the plants, wearing a light grey short-sleeve t-shirt and dark trousers. His face is turned downward, focused on the plants he is tending. The garden is richly layered with a variety of plants at multiple heights: in the immediate foreground and right side of the frame, tall slender grass-like stems and broad-leafed plants with a yellowish tint appear in soft focus, framing the composition. In the mid-ground around the man, there are rounded silvery-green woolly leaves (consistent with lamb\'s ear), small-leafed branching green shrubs, and distinctive dangling tubular red-pink flowers characteristic of fuchsia plants. Soft pink blooms are also visible near the man\'s head. The background is composed of lush green leafy vegetation and trees in deep, blurred bokeh. The lighting is natural, soft, and slightly diffuse with a faintly warm quality, suggesting overcast or lightly filtered daylight. The color palette is predominantly green with accents of red, pink, grey-green, and yellow. The visual style is photographic and naturalistic with a shallow depth of field and organic, layered framing created by foreground plants.","keyElements":["Dense layered garden with varied plant species","Red-pink fuchsia flowers in mid-ground","Soft pink blooms near the subject","Tall grass and yellow-tinted foreground plants in bokeh","Deep green blurred tree background"],"attributes":["lush garden setting","naturalistic shallow focus","rich green color palette","organic layered framing","soft diffuse natural light"]},{"fileName":"GENERIC-PeopleOutdoor-13.mp4","description":"The video features a close-up shot of a young girl leaning out of the open window of a moving car, with her face and upper body visible as the vehicle travels along a tree-lined road. The girl has dark hair and a warm skin tone; she rests her chin and arms on the lowered car window frame and appears to be smiling contentedly as she looks forward. She wears a dark top, and a red string bracelet is visible on her wrist. The car\'s exterior is dark-colored \u2014 black or very dark grey \u2014 and the window frame and chrome door handle are visible in the lower portion of the frame. The background behind her is a softly blurred road flanked by tall, lush trees bathed in warm, bright natural light, creating a sun-drenched, green-and-gold haze with smooth bokeh. The upper left of the frame is dominated by the dark reflective car body. The lighting is warm and bright, with sunlight filtering through the trees and creating a high-key, glowing environment around her. The color palette is warm golden-green from the sunlit foliage, dark near-black from the car body, and neutral skin and hair tones for the subject. The visual style is photographic, close-framed, and cinematic, with a very shallow depth of field placing the road and trees in gentle blur.","keyElements":["Dark car body and chrome window frame","Sunlit tree-lined road in blurred background","Warm golden-green bokeh foliage","Bright high-key backlighting through trees","Road surface visible in background"],"attributes":["warm sunlit road trip","close intimate framing","shallow bokeh background","golden-green natural light","motion and travel feel"]},{"fileName":"GENERIC-PeopleOutdoor-14.mp4","description":"The video shows a family of four walking through a spacious outdoor park setting dominated by a large, ancient-looking tree with wide, horizontally spreading branches and an extensive canopy of bright green leaves. The tree forms the primary background element, its thick gnarled branches spreading across the full width of the upper frame. In the foreground, two children are running toward the camera: a taller boy on the left wearing a light grey t-shirt and khaki shorts, and a younger girl in the center wearing a white short-sleeve henley top and blue shorts, her long dark hair flowing as she moves. Further back, two adults walk hand in hand along a low stone-edged path: a woman wearing a white sleeveless top, a straw hat, and a dark bag, and a man wearing a light blue long-sleeve shirt and khaki shorts with dark shoes. The ground is lush short green grass with dappled sunlight creating patches of light and shadow. The lighting is bright natural daylight filtered through the tree canopy, producing a warm, dappled effect with soft shadows and vivid greens. The color palette is predominantly bright green with neutral whites, blues, and khaki tones in the clothing. The visual style is wide, cinematic, and photographic, with natural movement and depth provided by the near-to-far positioning of the subjects.","keyElements":["Large ancient spreading tree with wide canopy","Bright green grass lawn with dappled sunlight","Low stone-edged pathway","Warm dappled filtered natural light","Deep shade and light contrast under the tree"],"attributes":["lush park canopy setting","dappled natural sunlight","bright vivid green palette","wide depth-of-field composition","natural dynamic movement"]},{"fileName":"GENERIC-PeopleOutdoor-15.mp4","description":"The video presents an extreme close-up of a small orange-brown moth or butterfly resting on a child\'s hand, with the insect as the sharp focal point and a young girl partially visible and blurred in the background. In the first frame, the insect is seen at close range on the knuckle area of a child\'s closed fist; it has distinctive orange and white-cream patterned wings with thin dark antennae, and appears to be partially opening or closing its wings. The background shows the very blurred outline of a young girl\'s face and shoulder, wearing a yellow top with a blue strap, set against a soft green and white bokeh environment suggesting an outdoor garden or park setting. In the second frame, the composition tightens further, with the girl\'s face \u2014 blonde hair, hazel eyes \u2014 moved closer to the insect, gazing at it intently, while the insect continues to move its wings. The lighting is warm and natural, producing a golden ambient quality. The color palette is warm amber, orange, and cream for the insect, golden skin tones, yellow clothing, and deep blurred greens in the background. The visual style is macro-like and highly cinematic, with an extremely shallow depth of field that isolates the insect against a smooth bokeh background.","keyElements":["Soft blurred outdoor green garden background","Warm golden natural ambient light","Yellow top and blue strap clothing visible on subject","Extreme shallow depth of field bokeh","Neutral skin-tone hand surface"],"attributes":["macro close-up framing","extreme shallow focus","warm amber natural light","intimate nature detail","soft green bokeh background"]},{"fileName":"GENERIC-PeopleOutdoor-16.mp4","description":"The video features four young women standing close together outdoors in what appears to be a park or garden setting, all smiling broadly and raising their arms. The group is arranged in a horizontal line facing the camera at medium range. From left to right: the first woman has dark straight hair pulled back and wears a white crew-neck t-shirt, with her left arm raised; the second woman has long wavy light brown hair and wears a dark brown or maroon short-sleeve top with a gold chain necklace; the third woman has dark natural hair pulled into a high bun and wears a white short-sleeve ruffled blouse; the fourth woman has long dark hair and wears a light blue sleeveless top, with her right arm partially raised. All four women are smiling and visibly animated. The background is composed of softly blurred lush green trees and foliage through which a bright light source \u2014 a low sun \u2014 shines intensely, creating a glowing haze and strong lens flare that washes across the upper right portion of the frame. The lighting is warm and bright with strong backlighting from the low sun producing a golden rim-light effect around the subjects and warm amber tones throughout the scene. The color palette is warm with greens, whites, brown, light blue, and golden sunlight. The visual style is photographic and lifestyle-oriented, with a shallow depth of field and a vibrant outdoor feel.","keyElements":["Lush green blurred tree background","Bright low sun creating strong backlighting and lens flare","Warm golden rim-light on subjects","Soft bokeh foliage environment","Natural outdoor warm lighting"],"attributes":["vibrant golden backlight","lifestyle group portrait","warm summer palette","energetic celebratory mood","park outdoor setting"]},{"fileName":"GENERIC-PeopleOutdoor-17.mp4","description":"The video shows an older woman tending to plants in a lush outdoor garden, surrounded on all sides by dense, vibrant green tropical and subtropical foliage. The subject is positioned centrally in the frame and filmed from a medium distance. She has short black hair and an East Asian appearance, and wears a straw hat with a rust-orange or terracotta band, a light blue and white plaid or checked loose long-sleeve shirt layered over a white inner top. She is reaching her right hand upward into the upper right of the frame, touching or examining leaves on a tall green shrub. The garden is extraordinarily lush, with large palm-like fronds on the left, broad tropical leaves in the upper frame, and a dense variety of smaller-leafed green shrubs filling the right side. A white building structure with windows is partially visible in the upper left background, suggesting a residential garden or courtyard setting. The lighting is bright natural daylight with a soft, slightly diffuse quality, producing vivid, saturated greens throughout. The color palette is dominated by multiple shades of green \u2014 lime, deep green, yellow-green \u2014 with the straw hat and terracotta band providing warm accent tones. The visual style is medium-framed and naturalistic, with moderate depth of field.","keyElements":["Dense tropical and subtropical garden foliage","White residential building visible in background","Bright natural daylight with vivid greens","Large palm fronds and broad tropical leaves","Variety of green shrubs and plant textures"],"attributes":["lush tropical garden","vivid saturated greens","bright natural daylight","dense immersive plant framing","residential garden setting"]},{"fileName":"GENERIC-PeopleOutdoor-18.mp4","description":"The video shows two women of different generations walking side by side outdoors in a park or garden setting, with their bodies angled slightly toward each other. The older woman on the left has short white-grey hair, wears dark-rimmed rectangular glasses, a teal or turquoise open cardigan over a cream or beige top, and a multi-strand necklace; she holds a thin walking stick or cane in her left hand and smiles broadly. The younger woman on the right has long dark brown hair pulled into a low ponytail, wears a sleeveless dark navy top and dark jeans, a small gold hoop earring, and a gold ring; her left arm is around the older woman\'s waist. Both are smiling and looking toward the left side of the frame. The foreground at the bottom of the frame contains blurred green foliage and scattered small pink, white, and yellow wildflowers. Behind the subjects, a wide green lawn extends to a dense tree line of mature leafy trees in full summer foliage. The sky above is pale, bright, and overcast. The lighting is soft and natural with diffuse even illumination, producing clean, gentle tones without strong shadows. The color palette is dominated by greens and the pop of teal from the cardigan, with neutral, soft tones throughout. The visual style is cinematic and lifestyle-oriented with a moderate depth of field.","keyElements":["Wide open green lawn in background","Dense summer-leafed tree line","Pale overcast bright sky","Scattered wildflowers (pink, white, yellow) in foreground","Soft diffuse even natural lighting"],"attributes":["soft natural park setting","diffuse overcast lighting","warm lifestyle tone","lush green summer palette","gentle intergenerational framing"]},{"fileName":"GENERIC-PeopleOutdoor-19.mp4","description":"The video depicts a group of four people playing with a soccer ball on a grassy field during golden hour, shot from a very low angle near ground level. The composition is framed tightly around the lower bodies and legs of the players, with the soccer ball \u2014 white with red pentagons \u2014 visible in the lower right foreground. The central figure is a tall adult seen from the waist down, wearing dark jeans and dark shoes, actively kicking or defending the ball. To the left is a boy in a teal or dark green t-shirt and light blue shorts, crouching low with arms out. To the right is a girl in a light blue or teal t-shirt and blue jeans, with long hair in a braid, also reaching for the ball with one leg raised. A smaller child in teal is partially visible crouching in the mid-background between the adult\'s legs. The ground is short golden-toned dry grass, warmly lit by strong low-angle sunlight from behind and to the left, creating long shadows and a glowing amber light that silhouettes parts of the figures and illuminates the grass in rich golden tones. The sky in the upper portion of the frame is a clear light blue transitioning to bright white near the low sun on the left. The color palette is warm gold, amber, light blue, and teal. The visual style is highly cinematic with a dramatic low ground-level perspective and strong backlighting.","keyElements":["Short golden grassy field surface","Clear blue sky with bright low sun on the left","Strong low-angle golden backlighting creating silhouettes","Long shadows across the ground","Distant flat horizon with faint tree line"],"attributes":["dramatic low ground-level angle","intense golden hour backlight","warm amber and blue contrast","dynamic action framing","open field sunset setting"]},{"fileName":"GENERIC-PeopleOutdoor-20.mp4","description":"The video features a close-up shot of two people \u2014 a man and a woman \u2014 outdoors, both smiling and laughing against a pale blue sky and faint mountain silhouette background. The man is the primary subject, positioned centrally and slightly left in the frame. He has a short beard, short dark hair mostly covered by a ribbed navy blue or indigo beanie hat, and wears a light grey-blue striped or textured collared shirt. He is visibly laughing in the first frame and in a subsequent frame reaches his hand up to touch his chin. A gold ring is visible on his hand. The woman is positioned to the right of frame and is partially cropped; she has auburn or reddish-brown braided hair pulled back, wears a rust-orange or terracotta collared button-up top and silver hoop earrings, and holds her hand up near her mouth in a laughing gesture. In the background, a very pale, clear light blue sky fills the upper two-thirds of the frame, and a faint dark mountain or hill silhouette is visible at the lower left. The lighting is bright and cool, consistent with clear outdoor daylight with soft directional light. The color palette is cool blue-grey in the background, warm rust-orange and navy in the clothing, with neutral skin tones. The visual style is close-framed and photographic, with a shallow depth of field.","keyElements":["Pale light blue clear sky background","Faint dark mountain silhouette at lower left","Bright cool natural outdoor daylight","Shallow depth of field background","Clean open sky framing"],"attributes":["close portrait framing","cool blue outdoor palette","bright clean daylight","joyful expressive faces","minimal background setting"]},{"fileName":"GENERIC-PeopleOutdoor-21.mp4","description":"The video depicts a multi-generational family group of at least six people gathered around a large wooden outdoor dining table set in a residential backyard during early evening. The table is laden with food and drink: visible items include a large glass salad bowl with green leafy salad being passed between guests, a bright yellow ceramic pitcher, red bell peppers, tomatoes, glasses of orange juice or lemonade, bread, and various other dishes and small bowls. People are actively passing food and engaging with one another across the table. From left to right: a young man in a white t-shirt and an orange baseball cap is partially visible at the far left edge; a woman with dark hair in a yellow-green or lime top is smiling and leaning forward; an older man with glasses is seated partially behind her; a young girl in a teal top sits in the middle; a woman in a light blue denim jacket holds the salad bowl up; and an older woman with reddish hair and glasses in a burgundy top is visible on the right. A young girl or woman with long blonde hair is also partially visible at the right edge. In the background, a dark navy-blue or charcoal house exterior is visible with a covered porch or pergola strung with warm globe string lights that glow amber-gold, adding a festive and intimate quality to the scene. The lighting is a blend of warm golden dusk daylight and the warm glow of the string lights. The color palette is warm with yellow, teal, blue, amber, and red. The visual style is candid and photographic.","keyElements":["Warm amber globe string lights on porch/pergola","Dark navy house exterior in background","Wooden outdoor dining table","Colorful food and drinks on the table (salad bowl, yellow pitcher, vegetables, glasses)","Warm dusk and string-light mixed lighting"],"attributes":["warm festive outdoor dining","ambient string light glow","candid multi-generational gathering","rich warm color palette","residential backyard setting"]},{"fileName":"GENERIC-PeopleOutdoor-22.mp4","description":"The video features a close-up profile shot of a young woman standing outdoors near a body of water at golden hour, with wind blowing her hair across her face. The subject is positioned on the right side of the frame, shown from the shoulders up, facing to the left. She has medium-length dark brown wavy hair that is visibly windswept and partially across her face, and a few strands are caught in the breeze. She wears a white or light-colored top visible at the bottom of the frame. Her eyes are partially closed and she has a faint expression consistent with being in bright sunlight and wind. The background to her left and center occupies the majority of the frame: a large, softly blurred body of water \u2014 a lake or sea \u2014 reflects a brilliantly bright golden sun, which creates a strong circular glow and golden rippled light path across the water surface. On the far left, a dark mountain or headland silhouette is visible. The sky above the water is pale and hazy with a warm golden-white tone near the sun transitioning to a light blue at the top. The lighting is entirely backlit from the left with a low golden sun, producing warm rim lighting on the subject\'s hair and profile. The color palette is warm gold and amber in the water reflection, pale sky blue, and dark neutral tones on the mountain silhouette. The visual style is cinematic, close-framed, and atmospheric.","keyElements":["Large softly blurred lake or sea body of water","Bright golden sun reflection on the water surface","Dark mountain or headland silhouette on the far left","Pale golden-white hazy sky","Strong low-angle golden backlighting"],"attributes":["golden hour lakeside","windswept atmospheric feel","warm golden backlight","cinematic profile framing","reflective water backdrop"]},{"fileName":"GENERIC-PeopleOutdoor-23.mp4","description":"The video shows a toddler and an adult in a sunlit park or garden setting, captured from a low angle near ground level. The toddler, seen from behind and slightly to the left, occupies the foreground of the frame. The child has short dark hair, wears a white short-sleeve t-shirt underneath light blue denim dungarees or overalls, and stands on a bright green lawn with arms slightly out for balance, appearing to walk or toddle forward. In the middle-distance background, an adult \u2014 a man \u2014 is crouched down low on the grass with arms stretched out toward the child in a welcoming or encouraging posture. He wears a grey t-shirt and blue jeans. The background behind the man is filled with a wide expanse of green lawn and dense, lush green trees bathed in warm sunlight, which creates a soft glowing bokeh and dappled light effect throughout. A warm low sun shines through the trees from behind, creating a strong golden-amber backlight and bright circular bokeh highlights scattered across the frame. The lighting is warm and golden, consistent with late afternoon sun. The color palette is rich green and warm golden amber, with the white and denim blue of the toddler providing the central contrast. The visual style is cinematic with a low ground perspective, a very shallow depth of field, and a soft, warm aesthetic.","keyElements":["Bright green grass lawn surface","Dense sunlit green trees in background with golden bokeh","Warm low-angle golden backlighting through the trees","Bright circular bokeh highlights scattered through the frame","Open park space between subjects"],"attributes":["warm golden park setting","low ground-level perspective","shallow focus bokeh","late afternoon sunlight","soft intimate scale"]},{"fileName":"GENERIC-PeopleOutdoor-24.mp4","description":"The video features three older women standing close together outdoors, all with white or silver-grey hair, smiling and laughing in a close-up medium shot. The three women are arranged horizontally across the frame with their arms around each other. On the left, a woman with very short white hair wears a teal green top and a long grey-and-white striped scarf, and laughs openly with her head tilted back and glasses hanging from her scarf. In the center, a woman with short grey hair wears a grey zip-up jacket over a white top and a loosely draped cream-white scarf. On the right, a woman with short silver hair wears a dark burgundy or wine-colored top and a white knitted scarf, smiling warmly at the camera. The background is blurred and shows a pale, overcast beige-grey sky with faint dark outlines suggesting a rooftop structure or low hills at the right edge. The lighting is diffuse and flat, consistent with an overcast outdoor day, producing even, soft tones with no strong directional shadows. The color palette consists of muted cool tones: grey, white, teal, cream, and burgundy. The visual style is photographic and close-framed, with a shallow depth of field placing the background entirely out of focus.","keyElements":["Pale overcast beige-grey blurred sky background","Faint rooftop or hill outline at right edge","Diffuse flat overcast natural lighting","Soft blurred neutral background","Cool muted grey and white color environment"],"attributes":["overcast soft lighting","close portrait framing","cool muted neutral palette","joyful expressive faces","minimal blurred background"]},{"fileName":"GENERIC-PeopleOutdoor-25.mp4","description":"The video shows four people lying on a green grass lawn, filmed from an overhead top-down angle, with all four faces visible and directed upward toward the camera. Their heads meet in the center of the frame, radiating outward like a pinwheel. In the center-bottom, a young girl with long straight dark brown hair wears a bright orange or yellow short-sleeve t-shirt and laughs with eyes squeezed shut. To the upper left, a man with short dark hair and a beard wears a white t-shirt and smiles broadly while raising one hand with fingers extended in a wave-like gesture. To the upper right, a woman with voluminous curly light auburn or dark blonde hair wears a light blue long-sleeve top and laughs while looking upward. At the very top center, only the top of a second child\'s head and forehead are visible, with light hair and what appears to be a yellow or golden top. The grass below them is short, bright green with small white clover flowers visible throughout. The lighting is warm and golden, consistent with late afternoon or early evening sun angled from above, casting a gentle warm glow across all faces and the grass. The color palette is vivid with bright green grass, white, orange/yellow, and light blue clothing. The visual style is photographic and playful, with the top-down perspective creating a symmetrical, radial composition.","keyElements":["Short bright green grass lawn with white clover flowers","Overhead top-down perspective","Warm golden late afternoon sunlight","Radial symmetrical composition of figures","Small white clover dots throughout the grass"],"attributes":["overhead top-down framing","vibrant bright green lawn","warm golden light","playful radial composition","vivid color palette"]}]}');


var $e4153d2b9913d6fb$exports = {};
$e4153d2b9913d6fb$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-PeopleFinancial-01.mp4\",\"description\":\"The video shows two adults seated together indoors at a table, engaged in a face-to-face conversation that appears to center on financial documents or paperwork placed on the table surface between them. Both individuals are dressed in casual-to-smart-casual indoor clothing, with visible skin tones, hair, and posture indicating an attentive, focused exchange, one gesturing occasionally with their hands as they speak. The setting is an interior space, likely a home or office room, furnished with a wooden or neutral-toned table and softly blurred background elements that suggest a lived-in or professional environment without any single object dominating the backdrop. The color palette is warm and neutral, dominated by beige, brown, and soft skin tones, with muted background hues that keep attention on the two people in the foreground. Lighting is soft and even, appearing to come from a diffused indoor source such as a window or ambient room lighting, producing gentle shadows and a naturalistic look without harsh contrast. The composition uses a medium shot framing both subjects from roughly the waist or chest up, positioned across from or beside one another, with shallow depth of field softly blurring the background to keep focus on the interaction in the foreground. The visual style is photographic and realistic, resembling typical corporate or lifestyle stock footage, with natural movement and no overlaid graphics, text, or animation visible in the frame.\",\"keyElements\":[\"background setting/environment\",\"table surface and furniture\",\"lighting warmth/tone\",\"background blur/depth of field\",\"clothing colors\",\"camera framing/angle\"],\"attributes\":[\"realistic\",\"warm-toned\",\"conversational\",\"softly lit\",\"professional\"]},{\"fileName\":\"GENERIC-PeopleFinancial-02.mp4\",\"description\":\"This video depicts an individual seated indoors at a desk or table, apparently occupied with a task involving paperwork, a laptop, or a handheld device such as a calculator, suggesting a personal financial or administrative activity. The person is shown in casual indoor attire, with visible hands, hair, and facial expression indicating concentration or calm focus on the task at hand. The surrounding environment appears to be a home or office interior, with softly out-of-focus background elements such as furniture, walls, or shelving visible but not sharply detailed, reinforcing a sense of an everyday domestic or workplace setting. The color scheme is muted and warm, featuring neutral wall tones, natural wood or light-colored furniture, and soft skin and clothing tones that blend cohesively across the frame. Lighting is soft and diffused, likely from a nearby window or ambient ceiling light, casting gentle shadows and avoiding strong highlights or dark areas. The framing is a medium or medium-close shot centered on the subject and their immediate work surface, with the camera positioned at approximately eye level, and the background gently blurred to emphasize the subject and their activity. The overall visual style is realistic and photographic, consistent with everyday lifestyle or corporate stock video, free of text overlays, animation, or graphic elements.\",\"keyElements\":[\"desk/table objects\",\"background environment\",\"lighting direction and softness\",\"clothing tone\",\"camera angle and framing\",\"background blur\"],\"attributes\":[\"realistic\",\"calm\",\"focused\",\"neutral-toned\",\"domestic\"]},{\"fileName\":\"GENERIC-PeopleFinancial-03.mp4\",\"description\":\"The video shows a small group of people, appearing to be two or more adults, seated or standing indoors in what resembles a meeting or consultation setting, with body language suggesting an active discussion. At least one person appears to be gesturing or pointing toward documents, a screen, or another object on a table, while others appear to be listening or reviewing material alongside them. The subjects wear casual or business-casual clothing in neutral tones, and their facial expressions suggest engagement and attentiveness rather than strong emotional display. The background consists of an indoor space with softly blurred furniture and wall elements, giving a sense of an office or meeting room without revealing sharp specific details. The color palette leans toward warm neutrals, with beige, gray, and muted tones dominating both clothing and environment, punctuated by natural skin tones. Lighting is soft and even, likely diffused from overhead or window sources, producing a flat, naturalistic look with minimal harsh shadow. The composition frames the group in a medium shot, capturing multiple people within the frame with the camera positioned to include both the subjects and the table or surface they are gathered around, while background details remain softly defocused. The visual style is realistic, photographic, and consistent with professional or corporate stock footage, with natural motion and no visible text, graphics, or animated overlays.\",\"keyElements\":[\"number of background/secondary people\",\"background room details\",\"table/surface objects\",\"lighting tone\",\"clothing colors\",\"camera framing and distance\"],\"attributes\":[\"realistic\",\"collaborative\",\"professional\",\"muted-toned\",\"attentive\"]},{\"fileName\":\"GENERIC-PeopleFinancial-04.mp4\",\"description\":\"The video shows one or two people indoors, positioned at a table or desk, appearing to review or discuss physical documents, a laptop screen, or similar materials associated with financial or administrative work. The subject(s) display calm, focused facial expressions, with visible hand movements suggesting note-taking, pointing, or typing. Clothing worn is casual to smart-casual, in neutral colors, consistent with an everyday indoor or home-office context. The background is softly blurred, showing indistinct furniture, wall surfaces, or windows that imply a residential or office interior without offering sharply defined identifying details. The overall color palette is warm and subdued, composed of beige, tan, soft brown, and neutral skin tones, with occasional cooler gray accents in the background. Lighting is soft and diffused, likely natural or simulated window light, creating gentle, even illumination across the subject with minimal harsh shadowing. The composition is a medium shot, framing the subject(s) from roughly the chest or waist upward, centered within the frame, with the background rendered out of focus to draw attention to the person and their activity in the foreground. The visual style is realistic and photographic, resembling typical stock video content used for financial, business, or lifestyle contexts, without any overlaid text, graphics, or animated elements.\",\"keyElements\":[\"desk/table surface objects\",\"background furniture/environment\",\"lighting softness and direction\",\"clothing tones\",\"camera framing and angle\",\"depth of field/background blur\"],\"attributes\":[\"realistic\",\"warm-toned\",\"calm\",\"softly lit\",\"domestic\"]},{\"fileName\":\"GENERIC-PeopleFinancial-05.mp4\",\"description\":\"This video depicts one or more individuals indoors, engaged in an activity that appears related to reviewing financial materials, using a device such as a laptop, tablet, or calculator, or conversing across a table or desk surface. The subject's posture and hand movements suggest active engagement with the material in front of them, while facial expressions remain calm and focused, without pronounced emotional display. Clothing is casual or business-casual in style, rendered in neutral, muted tones that blend with the overall scene. The background is an interior space, softly blurred to suggest a home or office environment, with indistinct furniture, wall textures, or light sources visible but not sharply defined. The color palette is warm and neutral overall, featuring soft beige, brown, and gray tones alongside natural skin tones, with no strong or saturated colors present. Lighting is soft and diffused, likely from a window or ambient indoor source, producing even illumination and minimal shadow contrast across the subject and immediate surroundings. The composition uses a medium shot, framing the subject centrally within the frame at approximately eye level, with the background gently defocused to keep visual emphasis on the person and their activity. The visual style is realistic and photographic, consistent with corporate or lifestyle stock footage, showing natural, unscripted-looking movement with no text overlays, graphics, or animated elements visible.\",\"keyElements\":[\"table/desk objects and devices\",\"background environment details\",\"lighting tone and direction\",\"clothing colors\",\"camera framing and distance\",\"background blur/depth of field\"],\"attributes\":[\"realistic\",\"neutral-toned\",\"focused\",\"softly lit\",\"professional\"]}]}");


var $0372304f611450de$exports = {};
$0372304f611450de$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-PeopleCity-01.mp4\",\"description\":\"The video presents a high-angle, top-down aerial view of a busy urban street intersection during daytime. The dark grey asphalt road runs diagonally across the frame, marked with a wide white-striped pedestrian crosswalk that pedestrians are using to cross from one side of the street to the other. Numerous small figures, seen only from directly above, are dispersed across the crossing and adjacent sidewalks; their bodies are rendered as compact shapes with visible shadows cast beside them, indicating strong, direct sunlight coming from one side. A few vehicles, including cars and what appears to be a delivery-style vehicle, are stationary or slow-moving at the edge of the intersection, their roofs visible as flat rectangular shapes in muted tones of white, black, and silver. The color palette is dominated by neutral urban tones: dark grey and black asphalt, white crosswalk markings, and muted earth-toned or grey rooftops of surrounding low-rise buildings visible at the frame's edges. Lighting is bright and even, characteristic of clear daylight, with hard-edged shadows extending from pedestrians and vehicles across the pavement, suggesting a midday or early-afternoon sun angle. The composition is centered on the crosswalk and intersection, framed symmetrically from directly overhead in a drone or elevated-camera perspective, giving the scene a graphic, pattern-like quality. The background consists of partial views of building rooftops, small trees, and additional road segments extending outward from the central intersection, situating the scene within a dense urban grid. The overall visual style is realistic and photographic, resembling stock aerial drone footage, with a documentary, observational quality and no stylization or artistic filtering applied.\",\"keyElements\":[\"color and material of the road surface\",\"vehicle colors and types\",\"surrounding building rooftops and background architecture\",\"lighting angle and time of day\",\"presence and density of trees or greenery\",\"camera height and angle of the aerial shot\"],\"attributes\":[\"aerial\",\"urban\",\"daylight\",\"photographic\",\"candid\"]},{\"fileName\":\"GENERIC-PeopleCity-02.mp4\",\"description\":\"The video shows a street-level view of a pedestrian shopping street or plaza lined with multi-story buildings featuring shopfronts, awnings, and balconies. Numerous people, shown as full-body figures from a moderate distance, walk in both directions along the paved street, dressed in ordinary casual clothing in varied but muted colors such as dark jackets, jeans, and neutral-toned tops. Strings of overhead lighting or decorative cabling stretch across the street between buildings, and storefront signage with awnings in darker tones lines both sides of the walkway. The color palette leans toward warm neutrals: beige and tan building facades, dark clothing on pedestrians, and warm-toned pavement, contrasted with patches of shadow. Lighting appears soft and diffused, consistent with an overcast day or late-afternoon light, producing gentle, low-contrast shadows and an even exposure across the scene. The composition is a straight-on, eye-level perspective looking down the length of the street, creating a strong sense of depth and perspective as the buildings converge toward a vanishing point in the distance. The background consists of receding rows of buildings, shop awnings, and additional pedestrians growing smaller with distance, reinforcing the depth of the urban corridor. The visual style is realistic and photographic, resembling handheld or steady-cam street-level footage typical of generic urban stock video, with a documentary and observational tone and no added stylization or graphic overlays.\",\"keyElements\":[\"building facade colors and architectural style\",\"awning and signage colors\",\"overhead lighting or cabling\",\"pedestrian clothing colors and styles\",\"pavement material and color\",\"weather and lighting conditions\"],\"attributes\":[\"street-level\",\"pedestrian\",\"overcast\",\"photographic\",\"candid\"]},{\"fileName\":\"GENERIC-PeopleCity-03.mp4\",\"description\":\"The video captures the interior of a large, ornate transit hall or station concourse with a grand, classical architectural style. The space features tall arched windows that allow soft, warm natural light to spill into the hall, illuminating a polished stone or marble floor. Numerous people are visible walking through the hall, shown as full or partial figures at a moderate distance, dressed in everyday casual clothing in dark and neutral tones such as black, grey, and navy. Architectural elements include ornate ceiling details, large support columns or archways, and what appears to be a staircase or escalator situated toward the center or side of the frame, adding vertical structure to the composition. The color palette is warm and golden overall, dominated by cream, beige, and tan stone surfaces, contrasted with the darker clothing of pedestrians and deeper shadow tones in recessed architectural areas. Lighting is soft and warm, likely a mix of natural daylight from the tall windows and ambient interior lighting, producing a glowing, atmospheric quality with gentle highlights on the stone floor and columns. The composition uses a wide, level, eye-line perspective that emphasizes the scale and grandeur of the interior space, with the ceiling and upper architecture occupying a significant portion of the upper frame. The background consists of the deep receding hall, additional arched windows, and architectural details fading into softer focus with distance. The visual style is realistic and photographic, resembling cinematic or stock footage of a historic public interior, with a calm, observational, documentary quality and no visible stylization or digital effects.\",\"keyElements\":[\"architectural style and ornamentation\",\"window and lighting configuration\",\"floor material and color\",\"pedestrian clothing colors\",\"presence of staircase or escalator\",\"overall warm color grading\"],\"attributes\":[\"grand interior\",\"architectural\",\"warm-toned\",\"photographic\",\"calm\"]},{\"fileName\":\"GENERIC-PeopleCity-04.mp4\",\"description\":\"The video depicts a street-level scene along a wide urban sidewalk lined with multi-story buildings featuring storefronts, awnings, and window displays. Several pedestrians, shown as full-body figures at a medium distance, walk along the sidewalk in both directions, wearing casual everyday clothing in a range of muted colors including dark jackets, denim, and neutral tops. Parked and slowly moving vehicles are visible along the adjacent roadway, their bodywork rendered in common car colors such as white, black, and grey. The color palette is dominated by neutral urban tones: grey pavement, muted building facades in tan, beige, or light grey, and darker accents from vehicle bodies and pedestrian clothing. Lighting is soft and even, consistent with daytime conditions under diffused or partly cloudy skies, resulting in low-contrast shadows and balanced exposure across the frame. The composition uses a steady, eye-level, forward-facing perspective looking down the sidewalk, with the buildings and street receding into the background to create depth. The background includes rows of storefronts, signage, parked cars, and additional pedestrians further down the street, all situated within a dense city block. The visual style is realistic and photographic, resembling typical handheld or gimbal-stabilized urban stock footage, with a candid, observational, documentary tone and no visible artistic filtering or graphic overlays.\",\"keyElements\":[\"building facade and storefront colors\",\"vehicle colors and positioning\",\"pedestrian clothing colors and styles\",\"pavement and sidewalk material\",\"signage and awning details\",\"weather and lighting conditions\"],\"attributes\":[\"street-level\",\"urban\",\"daylight\",\"photographic\",\"candid\"]},{\"fileName\":\"GENERIC-PeopleCity-05.mp4\",\"description\":\"The video shows a wide urban street or plaza scene captured from a street-level or slightly elevated angle, featuring numerous pedestrians crossing or walking across an open paved area. The figures are shown at a small to medium scale within the frame, dressed in ordinary casual clothing in muted colors such as black, grey, navy, and beige. Several vehicles, including cars in white, black, and silver tones, are visible moving along the roadway or parked at the periphery of the scene. Tall buildings with flat, modern facades rise in the background, their windows and surfaces rendered in neutral grey, glass, and concrete tones, situating the scene within a dense downtown district. The color palette overall is cool and neutral, dominated by grey pavement, muted building materials, and dark clothing, with occasional brighter highlights from vehicle bodywork or sky reflections in glass surfaces. Lighting is bright and even, suggesting daytime conditions under a clear or lightly overcast sky, producing soft shadows and consistent exposure throughout the frame. The composition is a wide, level shot capturing the full breadth of the street or plaza, with pedestrians and vehicles distributed across the foreground and midground and buildings framing the upper background. The background consists of the receding street, additional pedestrians and vehicles at varying distances, and the vertical lines of surrounding architecture. The visual style is realistic and photographic, consistent with generic urban stock footage, presenting a candid, observational, documentary quality without stylized color grading or graphic overlays.\",\"keyElements\":[\"building facade materials and colors\",\"vehicle colors and types\",\"pedestrian clothing colors\",\"pavement or plaza surface material\",\"sky and weather conditions\",\"camera angle and height\"],\"attributes\":[\"urban\",\"wide-shot\",\"daylight\",\"photographic\",\"candid\"]}]}");


var $562aaf79869f5626$exports = {};
$562aaf79869f5626$exports = JSON.parse('{"items":[{"fileName":"GENERIC-PeopleFun-01.mp4","description":"The video features a single person dressed in a full white astronaut costume walking and moving dynamically along an outdoor paved path in front of a large, circular modernist concrete building. The costume is a full-body white spacesuit with a white helmet featuring a reflective gold-tinted visor, blue and red circular buttons or controls on the chest panel, grey gloves, and white boots. On the right shoulder, a US flag patch is visible in one frame. A rectangular white backpack unit is attached to the suit\'s back. The figure is filmed at medium range from the front and three-quarter angles, and is visibly moving \u2014 arms outstretched, legs mid-step \u2014 suggesting a playful or dancing walk. The building behind the subject is a large multi-story circular structure with a ribbed concrete exterior, horizontal banded windows running around its circumference, and a brutalist architectural style; it appears institutional or civic in character. The ground is flat grey asphalt. On the right side of the frame, blue and green directional road signage and a metal gate or railing are partially visible. To the left, grey gravel or rubble mounds are visible. The lighting is bright, flat, natural daylight with a slightly hazy white sky, casting soft shadows on the ground. The color palette is dominated by white and grey with accents of gold from the visor and blue and red from the suit controls. The visual style is wide, photographic, and candid-feeling.","keyElements":["Large circular brutalist concrete building facade","Flat grey asphalt ground surface","Grey gravel or rubble mounds to the left","Blue and green directional signage on the right","Metal gate or railing structure on the right","Bright flat natural daylight with hazy sky"],"attributes":["wide architectural backdrop","flat bright daylight","bold white color contrast","playful dynamic movement","urban institutional setting"]},{"fileName":"GENERIC-PeopleFun-02.mp4","description":"The video shows a close-up of a young woman singing into a large-diaphragm condenser studio microphone equipped with a circular pop filter, filmed in what appears to be a recording studio environment. The subject is positioned on the right side of the frame, seen from the shoulders up, with the microphone and pop filter occupying the left and center of the frame in sharp or near-sharp focus. The woman has dark brown skin, and her hair is wrapped in a patterned dark headscarf with yellow, red, and black design elements; small yellow or golden natural curls are visible at the front. She wears large black over-ear studio headphones and gold hoop earrings. Her mouth is open wide in a singing or laughing expression across both frames, with eyes closed. The microphone stand and shock mount arm are visible at the lower left, rendered in dark grey metal. The pop filter is a large circular mesh screen mounted on a flexible gooseneck clip. The background in the first frame is a blurred warm neutral brown-grey, suggesting studio acoustic panels or walls. In the second frame, the background brightens significantly with a strong lens flare from a bright light source behind and to the left of the microphone, washing the frame in warm pink-orange-red tones. The lighting is intimate and warm, with a strong backlight creating a glow around the subject\'s head. The color palette is warm amber, gold, dark brown, and the muted grey-bronze of the microphone. The visual style is cinematic and close-framed with a shallow depth of field.","keyElements":["Large-diaphragm condenser studio microphone","Circular pop filter on metal mount","Blurred warm neutral studio background","Strong backlight lens flare in second frame","Warm amber and pink-orange lighting tones"],"attributes":["intimate studio recording setting","warm cinematic lighting","close expressive framing","strong backlight lens flare","rich warm amber palette"]},{"fileName":"GENERIC-PeopleFun-03.mp4","description":"The video features a young woman dancing energetically against a flat, solid dusty-rose or muted pink background, filmed in a studio or controlled environment. She is positioned centrally in the frame from approximately the waist up and is captured mid-movement, with her voluminous, naturally curly dark black hair dramatically swept and airborne to the right side of the frame, suggesting a vigorous head movement. Her face is slightly tilted downward, eyes partially closed, with a subtle smile. She wears large silver hoop earrings, a silver chain necklace, a pale yellow or cream long-sleeve top, and dark black denim dungarees or overalls over the top. The composition is clean and centered, with the solid-color background filling the entire frame behind her without any other visual elements. The lighting is studio-style with soft, even illumination that is slightly warmer on the subject, creating gentle dimension on her face and torso without harsh shadows. The color palette is simple and cohesive: muted pink background, cream-yellow clothing, dark denim, silver jewelry, and dark hair. The visual style is clean, fashion-editorial, and studio-shot with a moderately close crop.","keyElements":["Solid flat dusty-rose or muted pink background","Even soft studio lighting","Clean centered studio composition","No secondary environmental elements"],"attributes":["clean studio backdrop","fashion-editorial aesthetic","bold hair motion","soft even studio lighting","minimal color palette"]},{"fileName":"GENERIC-PeopleFun-04.mp4","description":"The video shows a young woman dancing outdoors in bright sunlight against a vivid, flat-painted bright green wall that fills the entire background. The wall is composed of horizontal ribbed or paneled sections, with a stepped ledge or plinth at the lower portion of the frame casting a strong shadow. The subject is positioned centrally and slightly to the right in the frame, shown from head to foot at a medium-wide distance. She has long straight dark auburn or dark brown hair with a blunt fringe, a light complexion, and wears round-frame sunglasses pushed up on her head in some frames. She is dressed in a loose beige or tan short-sleeve top, wide-leg light blue distressed denim jeans with frayed hems, and white low-top sneakers. Her arms are outstretched to the sides in a fluid dancing gesture, with her body weight shifted to one leg. A strong shadow is cast behind her and onto the stepped ledge, indicating direct overhead or slightly angled bright sunlight. The lighting is harsh and direct, consistent with strong midday or afternoon sun, producing sharp shadows and high-contrast illumination. The color palette is dominated by the saturated emerald green of the wall, contrasted against the neutral beige, denim blue, and white of the subject\'s clothing. The visual style is graphic, bold, and urban-editorial with a full-body wide framing.","keyElements":["Vivid flat emerald-green painted wall filling the background","Horizontal ribbed or paneled wall texture","Stepped green ledge at the base with cast shadow","Harsh direct sunlight casting strong shadows","Clean ground surface at the base of the wall"],"attributes":["bold monochrome background","graphic urban-editorial style","harsh direct sunlight","high-contrast color palette","full-body wide framing"]},{"fileName":"GENERIC-PeopleFun-05.mp4","description":"The video shows an older man dancing energetically on a cobblestone pavement in front of an ornate Victorian or Edwardian-style red brick building facade. The subject is positioned centrally in the frame at medium range, seen from head to foot. He has silver-grey hair, a light complexion, and wears a light beige or tan suit jacket, a white dress shirt with a loosened tie, matching beige or khaki trousers, and dark brown leather dress shoes. His posture is animated and mid-dance \u2014 knees bent, body low, arms out \u2014 suggesting a jive or swing-style movement, and he appears to be smiling. The building behind him is a detailed red brick structure featuring a large ornate wooden double door painted or stained in a warm amber-brown, with decorative stone-carved columns and arched detailing flanking the doorway, frosted or opaque glass panels in arched windows beside the door, and carved floral stone capitals on the pilasters. Two large square dark grey metal planters containing small bushy green trees or shrubs flank both sides of the entrance. Two ornate black iron lamp posts are visible at the upper corners of the frame. To the right, a grey wooden-shuttered window is partially visible. The ground is cobblestone paving in dark grey. The lighting is bright, directional sunlight from the left side, casting sharp shadows and creating high-contrast warm tones on the brick and subject. The color palette is warm red-brick, amber wood, beige, grey cobblestone, and green from the plants. The visual style is wide, photographic, and lively.","keyElements":["Red brick Victorian or Edwardian building facade","Large ornate amber-brown wooden double door with arched detailing","Decorative carved stone columns and floral capitals","Two large dark grey square planters with small green shrubs","Grey cobblestone pavement ground","Ornate black iron lamp posts at upper corners"],"attributes":["ornate architectural backdrop","warm red brick color palette","bright directional sunlight","wide full-body framing","playful dynamic movement"]},{"fileName":"GENERIC-PeopleFun-06.mp4","description":"The video features a young person dancing outdoors on what appears to be a rooftop or elevated urban terrace during golden hour or dusk. The subject is positioned centrally in a medium-close shot, seen from the chest up. They have very short-cropped dark hair, dark skin, and wear round silver-framed mirror or tinted sunglasses, large gold hoop earrings, a yellow knit vest layered under a grey, blue, and white large plaid or flannel overshirt, and a thin pink cable or cord hanging from the neck \u2014 likely connected to the headphones. They wear large bright yellow over-ear headphones with yellow ear cups, and their arms are extended to the sides in a dancing posture. The background shows a blurred urban cityscape of mid-rise residential or commercial buildings in warm orange-brick and beige tones, receding into a pale warm sky at the horizon that transitions from amber-orange near the bottom to a light cool grey-blue at the top, consistent with late dusk or sunset. The lighting is warm, low-angle, and directional, coming from behind and to the right of the subject, creating a warm rim-light effect on the left side of the face and headphones. The color palette is warm and vibrant: yellow headphones, plaid grey-blue shirt, yellow vest, pink cord, orange building tones, and gradient dusk sky. The visual style is cinematic and close-framed with a shallow depth of field.","keyElements":["Blurred urban cityscape of mid-rise buildings in warm brick tones","Pale warm gradient dusk or sunset sky","Warm low-angle directional backlight from behind","Shallow depth of field cityscape bokeh","Rooftop or elevated terrace setting implied"],"attributes":["urban rooftop golden hour","warm dusk color palette","close cinematic framing","vibrant color accents","shallow cityscape bokeh"]},{"fileName":"GENERIC-PeopleFun-07.mp4","description":"The video depicts a lively outdoor party or garden gathering with a group of people dancing. The primary subject is a young man in the foreground center of the frame, seen from approximately the waist up, laughing with his mouth wide open and his fists raised near his face. He has short dark hair, a beard, wears a grey bandana headband, round amber or yellow-tinted sunglasses, and a navy and white horizontal striped polo shirt with a half-zip. Behind him, three to four additional people are visible and slightly blurred, all also dancing or moving: a woman on the left in a pink short-sleeve knotted top with curly hair; a man behind the subject in the center in a light cream or white loose shirt; and a person or two on the right side partly cropped, including someone in a pink top. The setting is an outdoor enclosed space \u2014 a courtyard or backyard \u2014 with a dark striped wooden fence or wall running across the background. Strung overhead across the space are warm amber globe-shaped string lights on cables, and pastel-colored triangular bunting flags in pink, yellow, mint green, and pale blue are also strung across from side to side. Green trees or foliage are visible in the upper left beyond the fence. A white painted brick or stone wall is partially visible at the far right edge. The lighting is soft and warm, consistent with late afternoon or early evening outdoor light, with the string lights adding a festive amber glow. The color palette is warm and pastel: blush pink, cream, navy stripe, amber string light, and soft multicolor bunting. The visual style is candid, lively, and photographic.","keyElements":["Dark striped wooden fence or wall in background","Warm amber globe string lights strung overhead","Pastel triangular bunting flags (pink, yellow, mint, blue) strung overhead","Green trees or foliage visible beyond the fence upper left","White painted brick or stone wall at far right","Warm soft late-afternoon or early-evening outdoor light"],"attributes":["outdoor garden party setting","festive string light and bunting decor","warm pastel color palette","candid social energy","shallow focus foreground subject"]},{"fileName":"GENERIC-PeopleFun-08.mp4","description":"The video features a young woman at what appears to be an outdoor music festival, filmed in a handheld, slightly kinetic style. In the first frame, she is seen from behind at close range, shown from the waist up. She has auburn or reddish-brown hair styled in a thick braid that hangs down her back, and wears a sleeveless top in a vivid tie-dye or multicolored abstract pattern in shades of pink, orange, teal, purple, and blue. She also wears dark high-waisted shorts or trousers and carries a braided or woven multicolor crossbody strap bag. Her right arm is extended to the side in a dancing gesture. In the second frame, she has turned partially to show her profile and is visibly smiling, with her face caught mid-movement. A second woman is partially visible on the left edge in a white top. The background across both frames shows a colorful outdoor festival environment: large stretched fabric tent canopies in bright teal, blue, and purple are visible above and behind; large colorful inflatable or sculptural balloon-like forms in teal and multicolor appear in the mid-ground; wooden or metal poles support the tent structures; a crowd of festival-goers is visible in the soft-focus background; and a pale blue-grey dusk sky is visible above the canopy structures. The lighting is warm, low-angle, and consistent with dusk or late afternoon. The color palette is vivid and saturated: teal, pink, orange, purple, and blue. The visual style is dynamic, candid, and photographic.","keyElements":["Large teal, blue, and purple stretched fabric festival tent canopies","Large colorful inflatable or sculptural forms in mid-ground","Wooden or metal support poles for tent structures","Crowd of festival-goers visible in blurred background","Pale blue-grey dusk sky above the canopies","Warm low-angle dusk lighting"],"attributes":["outdoor music festival setting","vivid saturated color palette","candid handheld movement","dusk warm lighting","dynamic crowd environment"]},{"fileName":"GENERIC-PeopleFun-09.mp4","description":"The video features a young man laughing and dancing outdoors in a sunlit park or garden setting, filmed at medium-close range. He is positioned slightly left of center in the frame and is seen from approximately the chest up. He has short dark curly hair, a light-to-medium complexion, and wears clear or silver-framed rectangular glasses. He is dressed in a white open-collar short-sleeve linen or textured button-up shirt layered over a white t-shirt. His expression shows open, exuberant laughter with eyes slightly squinted. In the first frame, only his arms and parts of other people\'s hands are visible at the edges, suggesting interaction with others off-screen. In the second frame, a young woman is visible behind and slightly to his right, blurred in the background: she has shoulder-length auburn or brown hair with sunglasses perched on top, wears a bright pink or magenta top and a light skirt, and is also smiling and gesturing. At the far right edge, a denim-clad arm is partially visible. The background in both frames consists of deep green blurred tree foliage and a green grass lawn with a building or structure faintly visible in the distance. Strong sunlight comes from behind and to the upper right, creating a bright warm lens flare across the right side of the frame and a golden glow around the subjects. The color palette is white, pink, and bright green with warm golden backlight. The visual style is lifestyle-candid and cinematic with a shallow depth of field.","keyElements":["Lush blurred green tree foliage background","Green grass lawn with distant building","Strong golden backlight from upper right creating lens flare","Warm sunlit outdoor park environment","Shallow depth of field with green bokeh"],"attributes":["warm sunlit park setting","golden backlight lens flare","candid lifestyle energy","shallow green bokeh background","joyful expressive framing"]}]}');


var $de3e37e4efcd47db$exports = {};
$de3e37e4efcd47db$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-PeopleDiverseHome-01.mp4\",\"description\":\"The video shows one woman, a young adult female with an olive skin tone and dark brown hair styled up into a loose bun, or updo, with a few loose strands of hair framing her face. The woman has dark brown eyes, dark defined eyebrows, and is smiling broadly with her mouth open, showing her white teeth, giving her a warm, friendly, happy visible expression. The woman is wearing a top, a blue, navy blue, button up blouse or shirt patterned with small white polka dots, featuring a collar and a row of visible buttons down the front. The setting is an indoor home or office interior, blurred softly out of focus behind the woman, showing a shelving unit, a wood, light wood or oak colored bookcase, positioned on the left side of the frame holding indistinct light colored objects and books, a plain gray, light gray wall in the middle background, and a bright window on the right side of the frame letting in natural daylight, with a green houseplant, a potted plant with visible leaves, positioned near the window. The lighting is soft, bright, and neutral, appearing to be natural daylight supplemented by ambient indoor lighting, evenly illuminating the woman's face without harsh shadows. The color palette is neutral and muted overall, dominated by navy blue, white, light wood tan, and gray tones, with a small green accent from the houseplant. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or lifestyle stock video with a shallow depth of field, keeping the background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"shelving unit\",\"bookcase\",\"wall\",\"window\",\"potted plant\",\"houseplant\",\"polka dot pattern\",\"lighting\"],\"attributes\":[\"warm\",\"friendly\",\"smiling\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"neutral tone\",\"corporate\",\"lifestyle\",\"woman\",\"blue\",\"navy blue\",\"polka dot\",\"blouse\",\"shirt\",\"shelf\",\"shelving unit\",\"bookcase\",\"wood\",\"oak\",\"window\",\"plant\",\"houseplant\",\"green\",\"wall\",\"gray\",\"white\",\"indoor\",\"home office\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-02.mp4\",\"description\":\"The video shows one woman, a young adult female with a light olive or tan skin tone, wearing a hijab, a head covering or head scarf, in a blue, light blue, pale blue, and white, ivory color combination, wrapped around her head and neck. The woman has dark brown eyes accentuated with eyeliner, defined dark eyebrows, and pink lipstick, with a soft, gentle smile showing a calm, pleasant visible expression. The woman is wearing a jacket, a blue denim jacket or jean jacket, layered over the scarf fabric that drapes over her shoulders. The setting is an outdoor urban city environment, blurred softly out of focus behind the woman, showing tall city buildings, skyscrapers, and office towers in the background, along with green trees and foliage visible at street level, and a gray, light gray, overcast sky. The lighting is soft, natural, and diffused, consistent with an overcast or hazy daytime sky, evenly lighting the woman's face without strong shadows or highlights. The color palette is cool and muted, dominated by pale blue, ivory, white, gray, and denim blue tones, with green accents from the trees. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame and slightly turned, facing toward the camera. The visual style is photographic, realistic, and resembles a lifestyle or documentary style stock video with a shallow depth of field, keeping the city background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"city buildings\",\"skyscrapers\",\"sky\",\"trees\",\"foliage\",\"denim jacket\",\"scarf\",\"lighting\"],\"attributes\":[\"calm\",\"gentle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"overcast\",\"cool tone\",\"urban\",\"city\",\"lifestyle\",\"woman\",\"hijab\",\"head scarf\",\"headscarf\",\"blue\",\"pale blue\",\"ivory\",\"white\",\"denim\",\"jean jacket\",\"jacket\",\"buildings\",\"skyscraper\",\"trees\",\"foliage\",\"green\",\"sky\",\"gray\",\"outdoor\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-03.mp4\",\"description\":\"The video shows one man, an older adult male with fair, tan skin, short gray and light brown hair, and light colored eyes, smiling gently with a warm, calm, pleasant visible expression. The man is wearing a sweater, a gray, dark gray knit cardigan or shawl collar sweater with wood colored buttons, layered over a white, light gray t-shirt underneath. The setting is an outdoor natural environment, blurred softly out of focus behind the man, showing dense green foliage, trees, bushes, and leaves filling the entire background with a soft bokeh effect. The lighting is soft, natural, and diffused, consistent with an overcast or shaded outdoor setting, evenly lighting the man's face without harsh shadows. The color palette is earthy and muted, dominated by green, gray, and tan tones, with the man's gray cardigan blending tonally with the muted background. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or documentary style stock video with a shallow depth of field, keeping the green foliage background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"foliage\",\"trees\",\"bokeh\",\"cardigan\",\"sweater\",\"lighting\"],\"attributes\":[\"calm\",\"warm\",\"gentle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"bokeh\",\"soft lighting\",\"natural light\",\"earthy tone\",\"outdoor\",\"nature\",\"lifestyle\",\"man\",\"male\",\"older adult\",\"gray\",\"cardigan\",\"sweater\",\"knit\",\"buttons\",\"t-shirt\",\"tshirt\",\"green\",\"foliage\",\"trees\",\"bushes\",\"leaves\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-04.mp4\",\"description\":\"The video shows one woman, a young adult female with a tan or olive skin tone and long, dark brown curly hair worn loose past her shoulders. The woman has a nose ring, small gold hoop earrings, and a gold necklace with pearl and bead detailing around her neck, and pink or red colored lipstick. In one visible moment the woman closes her eyes and tilts her face upward with a peaceful, content visible expression, and in another visible moment she opens her eyes and smiles broadly, showing white teeth, looking off to the side with a happy, cheerful visible expression. The woman is wearing a cardigan, a green, mint green cardigan sweater tied at the front, layered over a white, cream colored top underneath. The woman is carrying a bag, a shoulder bag or tote bag with a tan, cream colored strap, and is holding books or notebooks close to her body. The setting is an outdoor urban environment, blurred softly out of focus behind the woman, showing buildings, a red, maroon colored building facade, a palm tree, greenery, and bright sunlight creating lens flare and warm bokeh highlights. The lighting is bright, warm, and natural, consistent with strong sunlight, creating glowing highlights on the woman's hair and skin. The color palette is warm and vibrant, dominated by mint green, cream, tan, gold, and warm brown tones, with red or maroon accents in the background. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a lifestyle or fashion style stock video with a shallow depth of field, keeping the urban background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"buildings\",\"palm tree\",\"greenery\",\"bag\",\"tote bag\",\"books\",\"notebooks\",\"cardigan\",\"lens flare\",\"bokeh\",\"lighting\"],\"attributes\":[\"peaceful\",\"content\",\"happy\",\"cheerful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"lens flare\",\"bokeh\",\"sunlight\",\"natural light\",\"warm tone\",\"vibrant\",\"urban\",\"lifestyle\",\"fashion\",\"woman\",\"curly hair\",\"mint green\",\"green\",\"cardigan\",\"sweater\",\"necklace\",\"earrings\",\"nose ring\",\"bag\",\"tote\",\"books\",\"palm tree\",\"building\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-05.mp4\",\"description\":\"The video shows one woman, an elderly adult female with a tan or fair skin tone showing visible wrinkles, fine lines, and light brown freckles or age spots across her face. The woman has short, wavy white and gray hair, dark brown eyes, pearl stud earrings, and pink, rose colored lipstick, with a warm, gentle smile giving a kind, friendly visible expression. The woman is wearing a top, a white sleeveless blouse or top, and has a bag with black straps visible over one shoulder. The setting is an outdoor environment, blurred softly out of focus behind the woman, showing indistinct warm toned buildings or walls on the left side of the frame and a cooler toned gray, blue surface on the right side of the frame, with soft glowing highlights suggesting bright sunlight. The lighting is warm, soft, and golden, consistent with late afternoon or early evening sunlight, creating a gentle glow on the woman's white hair and skin. The color palette is warm on one side and cool on the other, dominated by tan, gold, gray, and blue tones, with white from the woman's hair and blouse. The composition is an extreme close up, closeup, head and shoulders framing, with the woman's face filling most of the frame, positioned slightly off center. The visual style is photographic, realistic, and resembles a lifestyle or portrait style stock video with a shallow depth of field, keeping the background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"buildings\",\"wall\",\"bag straps\",\"blouse\",\"lighting\",\"golden light\"],\"attributes\":[\"warm\",\"kind\",\"friendly\",\"gentle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"golden light\",\"soft lighting\",\"natural light\",\"warm tone\",\"cool tone\",\"lifestyle\",\"elderly\",\"woman\",\"senior\",\"gray hair\",\"white hair\",\"wrinkles\",\"freckles\",\"pearl earrings\",\"earrings\",\"white\",\"blouse\",\"bag\",\"strap\",\"outdoor\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-06.mp4\",\"description\":\"The video shows one woman, a young adult female with a light olive skin tone and medium length, dark brown curly, wavy hair falling just past her shoulders. The woman has dark brown eyes, a small mole or beauty mark near her mouth, and a subtle, soft smile with closed lips, giving a calm, confident visible expression. The woman is wearing a top, a blue, light blue, pale blue crewneck sweater with ribbed detailing at the collar. The setting is an indoor home environment, blurred softly out of focus behind the woman, showing a white, off white wall decorated with several black framed picture frames or art prints displaying black and white photographs, and a red candle along with small decorative objects visible on a shelf or table to the right side of the frame. The lighting is soft, bright, and neutral, consistent with even indoor lighting, illuminating the woman's face evenly without harsh shadows. The color palette is cool and neutral overall, dominated by light blue, white, black, and gray tones, with a small red accent from the candle. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or portrait style stock video with a shallow depth of field, keeping the picture frames and background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"wall\",\"picture frames\",\"art prints\",\"photographs\",\"candle\",\"decorative objects\",\"shelf\",\"sweater\",\"lighting\"],\"attributes\":[\"calm\",\"confident\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"neutral tone\",\"cool tone\",\"indoor\",\"home\",\"lifestyle\",\"woman\",\"curly hair\",\"wavy hair\",\"light blue\",\"blue\",\"sweater\",\"crewneck\",\"picture frame\",\"frame\",\"art print\",\"photograph\",\"black and white\",\"candle\",\"red\",\"wall\",\"gallery wall\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-07.mp4\",\"description\":\"The video shows one woman, a young adult female with a tan or olive skin tone and dark hair pulled back away from her face. The woman is wearing sunglasses, black framed sunglasses, pushed up on top of her head, along with gold hoop earrings, a small pink heart shaped earring stud, and a pearl, beaded necklace around her neck. The woman has a confident, slightly serious visible expression with her lips closed and head tilted, looking directly toward the camera. The woman is wearing a sweater, a knit sweater in a color block, colorblock pattern of white, cream, orange, blue, and pink stripes, layered over an orange tank top underneath. The setting is an outdoor environment on a bridge or pier, blurred softly out of focus behind the woman, showing a concrete railing or barrier, distant city buildings, a tall pole or light post, and a bright, hazy white sky. The lighting is bright, warm, and sunny, with strong sunlight creating a glowing, hazy highlight effect around the woman's hair and shoulders. The color palette is bright and warm, dominated by orange, pink, light blue, cream, and white tones, with muted gray and tan tones in the distant buildings. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a fashion or lifestyle style stock video with a shallow depth of field, keeping the bridge and city background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"bridge\",\"railing\",\"buildings\",\"sky\",\"sweater pattern\",\"sunglasses\",\"lighting\",\"sun flare\"],\"attributes\":[\"confident\",\"serious\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"sun flare\",\"hazy\",\"bright lighting\",\"natural light\",\"warm tone\",\"vibrant\",\"fashion\",\"lifestyle\",\"woman\",\"sunglasses\",\"colorblock\",\"color block\",\"stripes\",\"orange\",\"pink\",\"blue\",\"cream\",\"white\",\"sweater\",\"knit\",\"tank top\",\"earrings\",\"necklace\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-08.mp4\",\"description\":\"The video shows one woman, a young adult female with a tan or olive skin tone and long, dark brown wavy, curly hair falling past her shoulders. The woman has dark brown eyes and is smiling broadly with her mouth open, showing white teeth, giving a joyful, happy, energetic visible expression. The woman is wearing a top, a yellow, bright yellow crewneck t-shirt. The setting is an outdoor city street environment, blurred softly out of focus behind the woman, showing light colored buildings, a white van or car parked along the street, and a paved road or sidewalk. The lighting is bright and natural, consistent with daytime sunlight, evenly illuminating the woman's face and creating warm highlights on her skin and hair. The color palette is warm and bright, dominated by yellow, tan, white, and beige tones. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a shallow depth of field, keeping the street and vehicle background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"buildings\",\"van\",\"car\",\"street\",\"sidewalk\",\"shirt\",\"lighting\"],\"attributes\":[\"joyful\",\"happy\",\"energetic\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"sunny\",\"warm tone\",\"casual\",\"lifestyle\",\"woman\",\"yellow\",\"t-shirt\",\"tshirt\",\"curly hair\",\"wavy hair\",\"van\",\"car\",\"vehicle\",\"street\",\"buildings\",\"outdoor\",\"city\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-09.mp4\",\"description\":\"The video shows one man, a young adult male with a tan or olive skin tone, short dark curly hair, and a thin mustache along with light stubble or a short goatee on his chin. The man is smiling broadly with his mouth open, showing white teeth, giving a joyful, happy, energetic visible expression, with visible smile lines near his eyes. The man is wearing a shirt, a blue denim button up shirt with a collar, layered over a plain white t-shirt underneath. The setting is an outdoor narrow street or alleyway environment, blurred softly out of focus behind the man, showing tan, beige colored buildings with columns or pillars lining the street, and a small green trash bin, waste bin visible on the left side of the frame. The lighting is soft and diffused, consistent with an overcast or shaded daytime setting, evenly illuminating the man's face without harsh shadows. The color palette is warm and neutral, dominated by tan, beige, blue denim, and white tones, with a small green accent from the trash bin. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a shallow depth of field, keeping the alleyway and buildings background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"buildings\",\"columns\",\"alleyway\",\"street\",\"trash bin\",\"waste bin\",\"shirt\",\"lighting\"],\"attributes\":[\"joyful\",\"happy\",\"energetic\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"overcast\",\"warm tone\",\"casual\",\"lifestyle\",\"man\",\"male\",\"mustache\",\"goatee\",\"stubble\",\"curly hair\",\"denim\",\"blue\",\"shirt\",\"t-shirt\",\"tshirt\",\"buildings\",\"columns\",\"alleyway\",\"trash bin\",\"green\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-10.mp4\",\"description\":\"The video shows two people, one woman and one girl, in an indoor home living room setting. The woman is an adult female with fair skin and long, wavy blonde hair, smiling broadly with her mouth open, showing white teeth, giving a joyful, cheerful, happy visible expression, and has one arm raised upward as if taking a selfie photograph or waving, revealing a small black line tattoo, a branch, floral tattoo design, on her forearm. The woman is wearing a top, a blue, light blue, gray button up shirt with a tie detail at the sleeve. The girl is a young child with fair skin, curly blonde hair, and light blue eyes, with a calm, neutral, serious visible expression, wearing a top, a white shirt with a small floral pattern, and small stud earrings. The girl is positioned in front of the woman, sitting closer to the camera, while the woman leans over her from behind. The setting is an indoor home living room, showing a gray sofa, couch with a yellow throw pillow and a white, cream colored throw pillow, blue, gray curtains hanging near a bright window on the left side of the frame, a white dresser, cabinet in the background, and a framed abstract art print hanging on the wall. The lighting is soft, bright, and natural, consistent with daylight coming through the window, evenly illuminating both the woman and the girl. The color palette is soft and neutral, dominated by light blue, gray, white, and cream tones, with a yellow accent from the throw pillow. The composition is a medium close up, closeup, upper body framing, shot from a slightly low selfie style angle, with both the woman and the girl positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a candid, lifestyle, family style stock video with a natural, unposed feel.\",\"keyElements\":[\"sofa\",\"couch\",\"throw pillow\",\"curtains\",\"window\",\"dresser\",\"cabinet\",\"art print\",\"wall\",\"lighting\"],\"attributes\":[\"joyful\",\"cheerful\",\"happy\",\"calm\",\"neutral\",\"candid\",\"selfie\",\"portrait\",\"medium close up\",\"closeup\",\"natural light\",\"soft lighting\",\"family\",\"lifestyle\",\"woman\",\"girl\",\"child\",\"mother\",\"daughter\",\"blonde hair\",\"curly hair\",\"wavy hair\",\"tattoo\",\"sofa\",\"couch\",\"throw pillow\",\"yellow\",\"cream\",\"curtains\",\"blue\",\"gray\",\"window\",\"dresser\",\"art print\",\"living room\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-11.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone, light freckles, and long, red, ginger colored curly, wavy hair that moves dynamically in the wind, catching bright backlight that creates a warm, glowing halo effect around her hair. The woman has light blue eyes, pink lipstick, and is smiling broadly with her mouth open, showing white teeth, giving a joyful, energetic, happy visible expression, with one hand raised near her shoulder in a clenched, playful gesture, revealing a black watch, bracelet on her wrist. The woman is wearing a top, a green, dark green ribbed turtleneck sweater. The setting is an outdoor city street environment, blurred softly out of focus behind the woman, showing a crowd of people, pedestrians walking along a wide street or plaza, tall city buildings, and a bright, hazy white sky with strong backlight sunlight creating lens flare. The lighting is bright, warm, and golden, consistent with strong sunlight shining from behind the woman, creating glowing highlights through her hair. The color palette is warm and vibrant, dominated by red, orange, gold, and green tones, with muted gray and tan tones from the distant buildings and crowd. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a lifestyle or fashion style stock video with a shallow depth of field, keeping the crowd and buildings background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"crowd\",\"pedestrians\",\"buildings\",\"street\",\"sky\",\"sweater\",\"lens flare\",\"watch\",\"bracelet\"],\"attributes\":[\"joyful\",\"energetic\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"lens flare\",\"backlight\",\"golden light\",\"bright lighting\",\"natural light\",\"warm tone\",\"vibrant\",\"urban\",\"city\",\"lifestyle\",\"fashion\",\"woman\",\"red hair\",\"ginger hair\",\"curly hair\",\"wavy hair\",\"freckles\",\"green\",\"turtleneck\",\"sweater\",\"watch\",\"bracelet\",\"crowd\",\"pedestrians\",\"buildings\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-12.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone, light hazel, green eyes, and long, straight, blonde, light brown hair that partially covers her face. The woman is wearing a hood, a brown, dark brown hooded garment or jacket pulled up over her head, framing her face closely. The woman has a soft, subtle smile with closed lips, giving a calm, gentle visible expression, and in one visible moment she closes her eyes, tilting her face slightly downward with a peaceful, relaxed visible expression. The setting is an outdoor urban environment, blurred heavily out of focus behind the woman, showing indistinct light colored buildings, warm toned architecture, and soft bokeh highlights suggesting distant lights or reflections. The lighting is soft and neutral, consistent with overcast or diffused daylight, evenly illuminating the woman's face without harsh shadows. The color palette is warm and muted, dominated by blonde, tan, brown, and beige tones, with soft warm bokeh highlights in the background. The composition is an extreme close up, closeup, tight face framing, with the woman's face filling nearly the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a beauty or lifestyle style stock video with a shallow depth of field, keeping the background heavily blurred while the woman's face remains in sharp focus.\",\"keyElements\":[\"buildings\",\"bokeh\",\"hood\",\"hooded garment\",\"lighting\"],\"attributes\":[\"calm\",\"gentle\",\"peaceful\",\"relaxed\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"bokeh\",\"soft lighting\",\"natural light\",\"overcast\",\"warm tone\",\"muted tone\",\"beauty\",\"lifestyle\",\"woman\",\"blonde hair\",\"light brown hair\",\"straight hair\",\"hazel eyes\",\"green eyes\",\"hood\",\"hooded jacket\",\"brown\",\"tan\",\"beige\",\"buildings\",\"outdoor\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-13.mp4\",\"description\":\"The video shows one man, a middle aged adult male with a tan or light skin tone, short dark hair styled upward, and dark brown eyes, smiling broadly with his mouth open, showing white teeth, and visible smile lines near his eyes, giving a warm, friendly, joyful visible expression. The man is wearing a top, a blue, navy blue button up shirt with a mandarin, stand up collar. The setting is an indoor home living room environment, blurred softly out of focus behind the man, showing wood paneling on the wall, a dark colored shelving unit or cabinet holding a round white plate, a green potted plant, books, and small decorative objects, along with a bright window on the left side of the frame with a green plant visible near the light, and a light colored sofa or couch in the foreground. The lighting is bright, warm, and natural, consistent with daylight streaming through the window, evenly illuminating the man's face and creating warm highlights. The color palette is warm and neutral, dominated by navy blue, tan, wood brown, and white tones, with green accents from the plants. The composition is a medium close up, closeup, upper body framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or lifestyle style stock video with a shallow depth of field, keeping the living room background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"wood paneling\",\"shelving unit\",\"cabinet\",\"plate\",\"potted plant\",\"books\",\"decorative objects\",\"window\",\"sofa\",\"couch\",\"lighting\"],\"attributes\":[\"warm\",\"friendly\",\"joyful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"neutral tone\",\"corporate\",\"lifestyle\",\"man\",\"male\",\"middle aged\",\"navy blue\",\"blue\",\"shirt\",\"mandarin collar\",\"wood paneling\",\"shelving unit\",\"cabinet\",\"plate\",\"plant\",\"books\",\"window\",\"sofa\",\"couch\",\"living room\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-14.mp4\",\"description\":\"The video shows one woman, a young adult female with a dark, deep brown skin tone and short, curly, coily afro hairstyle, styled naturally around her head. The woman has gold, yellow eye makeup applied around her eyes, and a calm, confident, slightly serious visible expression with her lips closed, looking downward and off to the side. The woman is wearing a jacket, an oversized blue, light blue denim jacket, layered over a cropped denim, dark colored top, revealing her midriff, along with yellow pants, a silver chain necklace, and rings on her fingers. The woman is holding a skateboard, a skateboard with a dark, patterned deck and pink wheels, positioned at her side. The setting is an outdoor environment, shot from a low angle looking upward, showing a bright blue sky with soft white clouds, and a tall white, cream colored cable stayed bridge with diagonal support cables radiating behind the woman. The lighting is bright and natural, consistent with clear daytime sunlight, creating strong contrast between the woman and the bright sky. The color palette is bright and bold, dominated by blue, denim blue, yellow, and gold tones, with white from the bridge and clouds. The composition is a low angle, wide shot, full body framing, with the woman positioned in the center left of the frame against the open sky. The visual style is photographic, realistic, and resembles a fashion or urban lifestyle style stock video with a sharp, high contrast look.\",\"keyElements\":[\"sky\",\"clouds\",\"bridge\",\"support cables\",\"skateboard\",\"denim jacket\",\"necklace\",\"rings\",\"lighting\"],\"attributes\":[\"confident\",\"calm\",\"serious\",\"candid\",\"portrait\",\"low angle\",\"wide shot\",\"full body\",\"high contrast\",\"bright lighting\",\"natural light\",\"bold color\",\"vibrant\",\"urban\",\"fashion\",\"lifestyle\",\"woman\",\"afro hair\",\"curly hair\",\"coily hair\",\"denim jacket\",\"denim\",\"blue\",\"yellow\",\"gold\",\"skateboard\",\"necklace\",\"chain\",\"rings\",\"sky\",\"clouds\",\"bridge\",\"cables\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-15.mp4\",\"description\":\"The video shows an extreme macro close up of one person's eyes and upper face, an elderly adult with a fair, tan skin tone showing deep set wrinkles, fine lines, and visible skin texture around the eyes and forehead. The person has light blue, gray eyes, and gray, white eyebrows and hair visible at the edges of the frame, with a calm, neutral, still visible expression, looking directly toward the camera. The setting is an indoor environment with a plain, muted gray background, blurred and softly out of focus, giving no additional visual context beyond the person's face. The lighting is soft, warm, and directional, coming from one side of the face, creating gentle shadows and highlights that emphasize the texture and depth of the skin and wrinkles. The color palette is warm and muted, dominated by tan, beige, gray, and light pink skin tones. The composition is an extreme close up, closeup, macro framing, with the eyes and upper face filling the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a documentary or beauty style stock video with a shallow depth of field and detailed macro focus on skin texture.\",\"keyElements\":[\"background\",\"lighting\",\"shadow\",\"highlight\"],\"attributes\":[\"calm\",\"neutral\",\"still\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"soft lighting\",\"warm tone\",\"muted tone\",\"documentary\",\"beauty\",\"elderly\",\"senior\",\"eyes\",\"gray eyes\",\"blue eyes\",\"wrinkles\",\"skin texture\",\"eyebrows\",\"gray hair\",\"white hair\",\"gray background\",\"shadow\",\"highlight\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-16.mp4\",\"description\":\"The video shows one woman, an elderly adult female with a fair skin tone and short, white, silver, gray bob hairstyle. The woman has dark brown eyes, visible wrinkles and fine lines, pearl stud earrings, and pink, rose colored lipstick, with a warm, gentle smile showing white teeth, giving a kind, friendly, happy visible expression. The woman is wearing a top, a blue, light blue denim button up shirt with small white polka dots and a collar. The setting is an indoor home environment, blurred softly out of focus behind the woman, showing a plain blue, gray wall, a green plant in a vase on the left side of the frame, and a wooden shelf or cabinet holding indistinct light colored objects and boxes on the right side of the frame. The lighting is soft, bright, and neutral, consistent with even indoor lighting, illuminating the woman's face evenly without harsh shadows. The color palette is cool and neutral overall, dominated by light blue, gray, white, and tan tones, with a green accent from the plant. The composition is a medium close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or portrait style stock video with a shallow depth of field, keeping the background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"wall\",\"plant\",\"vase\",\"shelf\",\"cabinet\",\"polka dot pattern\",\"lighting\"],\"attributes\":[\"warm\",\"kind\",\"friendly\",\"happy\",\"gentle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"neutral tone\",\"cool tone\",\"lifestyle\",\"elderly\",\"woman\",\"senior\",\"gray hair\",\"white hair\",\"silver hair\",\"bob hairstyle\",\"pearl earrings\",\"earrings\",\"denim\",\"blue\",\"polka dot\",\"shirt\",\"plant\",\"vase\",\"shelf\",\"cabinet\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-17.mp4\",\"description\":\"The video shows one woman, a young adult female with a light to medium brown skin tone and short, curly, coily afro hairstyle. The woman has dark brown eyes, large silver hoop earrings, and pink lipstick, with a broad, open mouthed smile showing white teeth, giving a joyful, warm, friendly visible expression. The woman is wearing a top, a blue denim button up shirt with a collar and front pockets. The setting is an indoor cafe or restaurant environment, blurred softly out of focus behind the woman, showing a tiled wall in tan, beige tones, wooden shelves holding indistinct bottles, jars, and small decorative objects, hanging pendant lights glowing warmly above, a small potted plant on the upper left, and a dark chalkboard sign with a coffee cup illustration on the right side of the frame. The lighting is warm and glowing, consistent with the hanging pendant lights and ambient indoor lighting, creating a cozy, warm atmosphere on the woman's face. The color palette is warm and rich, dominated by tan, beige, brown, and denim blue tones, with warm yellow and orange glowing light accents. The composition is a medium close up, closeup, upper body framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or hospitality style stock video with a shallow depth of field, keeping the cafe background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"tiled wall\",\"shelves\",\"pendant lights\",\"potted plant\",\"chalkboard sign\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"friendly\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"warm lighting\",\"cozy\",\"glowing light\",\"lifestyle\",\"hospitality\",\"cafe\",\"woman\",\"afro hair\",\"curly hair\",\"coily hair\",\"hoop earrings\",\"earrings\",\"denim\",\"blue\",\"shirt\",\"tiled wall\",\"shelves\",\"pendant light\",\"plant\",\"chalkboard\",\"coffee cup\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-18.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone, visible freckles across her face, and long, red, ginger colored curly hair that frames her face densely on both sides. The woman has her eyes closed, with dark eyelashes visible, and a calm, subtle, neutral visible expression with her lips closed, tilting her face slightly downward. The setting is an indoor or shaded outdoor environment with a dark teal, blue green blurred background, softly out of focus, giving no additional visual context beyond the woman's face and hair. The lighting is warm and directional, coming from one side of the face, creating a warm glow on the woman's skin and hair while the background remains cool toned and dim. The color palette contrasts warm and cool tones, dominated by red, orange, and warm skin tones in the foreground against a teal, dark blue green background. The composition is an extreme close up, closeup, tight face framing, with the woman's face and hair filling nearly the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a beauty or portrait style stock video with a shallow depth of field and soft, moody lighting.\",\"keyElements\":[\"background\",\"backlighting\",\"lighting\"],\"attributes\":[\"calm\",\"neutral\",\"subtle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"moody lighting\",\"warm tone\",\"cool tone\",\"teal background\",\"beauty\",\"portrait style\",\"woman\",\"red hair\",\"ginger hair\",\"curly hair\",\"freckles\",\"closed eyes\",\"eyelashes\",\"teal\",\"blue green\",\"warm light\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-19.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone, visible freckles across her face, and long, red, ginger colored curly hair that frames her face densely on both sides. The woman is smiling broadly with her mouth open, showing white teeth, and her eyes squinted, partially closed from smiling, giving a joyful, happy, cheerful visible expression. The setting is an indoor or shaded outdoor environment with a dark teal, blue green blurred background, softly out of focus, giving no additional visual context beyond the woman's face and hair. The lighting is warm and directional, coming from one side of the face, creating a warm glow on the woman's skin and hair while the background remains cool toned and dim. The color palette contrasts warm and cool tones, dominated by red, orange, and warm skin tones in the foreground against a teal, dark blue green background. The composition is an extreme close up, closeup, tight face framing, with the woman's face and hair filling nearly the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a beauty or portrait style stock video with a shallow depth of field and soft, warm lighting.\",\"keyElements\":[\"background\",\"backlighting\",\"lighting\"],\"attributes\":[\"joyful\",\"happy\",\"cheerful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"warm lighting\",\"warm tone\",\"cool tone\",\"teal background\",\"beauty\",\"portrait style\",\"woman\",\"red hair\",\"ginger hair\",\"curly hair\",\"freckles\",\"smiling\",\"teeth\",\"teal\",\"blue green\"]},{\"fileName\":\"GENERIC-PeopleDiverseHome-20.mp4\",\"description\":\"The video shows one woman, a young adult female with a medium brown skin tone and shoulder length, curly, coily dark brown hair. The woman is wearing eyeglasses, clear, transparent framed eyeglasses, and has green eye makeup applied around her eyes, with a broad, open mouthed smile showing white teeth, giving a joyful, happy, cheerful visible expression. The woman is wearing a top, a blue and white pinstripe, striped button up shirt layered over a white top underneath, along with a thin silver necklace. The setting is an outdoor park or plaza environment, showing tall, ornate sandstone, stone colored pillars, columns forming a gate or entrance structure, a black wrought iron fence, green trees in the distance, and a paved walkway or plaza surface, with a person riding a red bicycle blurred in the background on the left side of the frame. The lighting is soft and diffused, consistent with an overcast or early evening daylight setting, evenly illuminating the woman's face without harsh shadows. The color palette is muted and cool, dominated by tan, sandstone, green, blue, and white tones, with a small red accent from the bicycle in the background. The composition is a medium close up, closeup, upper body framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a moderate depth of field, keeping the background recognizable but softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"pillars\",\"columns\",\"fence\",\"trees\",\"walkway\",\"plaza\",\"bicycle\",\"eyeglasses\",\"lighting\"],\"attributes\":[\"joyful\",\"happy\",\"cheerful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"moderate depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"overcast\",\"muted tone\",\"cool tone\",\"casual\",\"lifestyle\",\"woman\",\"curly hair\",\"coily hair\",\"eyeglasses\",\"glasses\",\"green eye makeup\",\"striped shirt\",\"pinstripe\",\"blue\",\"white\",\"necklace\",\"pillars\",\"columns\",\"fence\",\"trees\",\"bicycle\",\"plaza\",\"park\"]}]}");


var $6e5e07098836d5c9$exports = {};
$6e5e07098836d5c9$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-PeopleDiverseCorporate-01.mp4\",\"description\":\"The video shows one woman, a young adult female of Asian descent with a fair skin tone and dark black hair pulled back neatly away from her face. The woman is wearing safety glasses, clear protective safety goggles, and a coat, a white lab coat, over a gray, light gray t-shirt, along with a blue lanyard holding an identification badge around her neck, and white protective gloves on her hands. The woman has a calm, confident, slightly smiling visible expression, with her arms crossed in front of her in one visible moment. The setting is an indoor science laboratory environment, blurred softly out of focus behind the woman, showing several other people, additional scientists or lab workers, wearing similar white lab coats and safety glasses, including a man on the left working with glass laboratory equipment, a funnel, and a metal stand, an older man with gray hair in the middle background holding a digital tablet, and a woman on the right handling a small glass vial. The laboratory contains various scientific instruments, a red toolbox, and small black and white robotic or model kits on a table on the right side of the frame. The lighting is bright, even, and cool toned, consistent with fluorescent or LED laboratory lighting, evenly illuminating the woman's face without harsh shadows. The color palette is cool and clean, dominated by white, light blue, and gray tones, with small accents of blue from the lanyard and red from the toolbox. The composition is a medium close up, closeup, upper body framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or scientific style stock video with a shallow depth of field, keeping the laboratory and additional people softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"laboratory equipment\",\"glass equipment\",\"funnel\",\"metal stand\",\"tablet\",\"vial\",\"toolbox\",\"robotic kits\",\"lab coat\",\"safety glasses\",\"lanyard\",\"lighting\"],\"attributes\":[\"calm\",\"confident\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"cool tone\",\"clean\",\"corporate\",\"scientific\",\"laboratory\",\"woman\",\"lab coat\",\"white coat\",\"safety glasses\",\"goggles\",\"gloves\",\"lanyard\",\"badge\",\"toolbox\",\"red\",\"blue\",\"white\",\"gray\",\"scientists\",\"robot kit\",\"vial\",\"tablet\"]},{\"fileName\":\"GENERIC-PeopleDiverseCorporate-02.mp4\",\"description\":\"The video shows one man, a middle aged adult male with a fair skin tone and short, gray, silver hair swept back and upward. The man is wearing eyeglasses, black round framed eyeglasses, and is smiling broadly with his mouth open, showing white teeth, giving a warm, confident, friendly visible expression. The man is wearing a jacket, a gray blazer or sport coat, layered over a black t-shirt, with a small dark pocket square visible in the breast pocket. The setting is an indoor industrial style environment, blurred softly out of focus behind the man, showing exposed ceiling ductwork, metal pipes, and structural beams overhead, dark black framed windows with a warm orange, red toned light glowing through from outside, and a wooden table with a chair and a small water bottle visible in the lower left of the frame. The lighting is dramatic and warm, consistent with a single directional light source illuminating the man's face while the surrounding space remains dim and shadowed. The color palette is dark and moody, dominated by black, gray, and dark brown tones, with warm orange and red accents from the window light. The composition is a medium close up, closeup, upper body framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or editorial style stock video with a shallow depth of field, keeping the industrial background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"ductwork\",\"pipes\",\"ceiling beams\",\"windows\",\"table\",\"chair\",\"water bottle\",\"blazer color\",\"lighting\"],\"attributes\":[\"warm\",\"confident\",\"friendly\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"dramatic lighting\",\"moody\",\"dark tone\",\"warm tone\",\"corporate\",\"editorial\",\"industrial\",\"man\",\"male\",\"gray hair\",\"silver hair\",\"eyeglasses\",\"glasses\",\"blazer\",\"jacket\",\"black\",\"gray\",\"pocket square\",\"ductwork\",\"pipes\",\"window\",\"table\",\"chair\"]},{\"fileName\":\"GENERIC-PeopleDiverseCorporate-03.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone, light freckles, and brown hair pulled back with a few loose strands framing her face. The woman is wearing drop earrings, gold teardrop shaped dangling earrings, and has hazel, green eyes, with a broad, open mouthed smile showing white teeth, giving a warm, confident, friendly visible expression. The woman is wearing a top, a dark navy blue or black blazer or jacket with a collar. The setting is an indoor modern office environment, blurred heavily out of focus behind the woman, showing glass walls, glass panels, and indistinct office furniture and lighting, with soft bokeh highlights and a bright lens flare visible across the frame in one visible moment. The lighting is bright, soft, and natural, consistent with daylight coming through the glass office walls, evenly illuminating the woman's face. The color palette is cool and neutral, dominated by white, gray, blue, and light tones, with warm skin tones on the woman's face. The composition is an extreme close up, closeup, tight face framing, with the woman's face filling most of the frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a corporate or professional portrait style stock video with a shallow depth of field, keeping the glass office background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"glass walls\",\"glass panels\",\"office furniture\",\"bokeh\",\"lens flare\",\"earrings\",\"blazer color\",\"lighting\"],\"attributes\":[\"warm\",\"confident\",\"friendly\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"bokeh\",\"lens flare\",\"bright lighting\",\"natural light\",\"cool tone\",\"corporate\",\"professional\",\"office\",\"woman\",\"freckles\",\"brown hair\",\"hazel eyes\",\"green eyes\",\"drop earrings\",\"earrings\",\"gold\",\"navy blue\",\"black\",\"blazer\",\"glass wall\"]},{\"fileName\":\"GENERIC-PeopleDiverseCorporate-04.mp4\",\"description\":\"The video shows one man, a young adult male with a dark skin tone and short, dark black hair, along with a light beard and mustache. The man has dark brown eyes and a gentle, soft smile with closed or slightly parted lips, giving a warm, calm, friendly visible expression. The man is wearing a sweater, a brown, tan colored v neck sweater, layered over a collared shirt, a blue, light blue button up shirt underneath. The man is seated on a sofa, a gray, light gray couch. The setting is an indoor home environment, blurred softly out of focus behind the man, showing dark framed glass doors or windows on either side of the frame, and a blurred modern kitchen in the background with white cabinets, hanging pendant lights, and open shelving. The lighting is soft, bright, and natural, consistent with daylight filling the room, evenly illuminating the man's face without harsh shadows. The color palette is warm and neutral, dominated by tan, brown, light blue, white, and gray tones. The composition is a medium close up, closeup, upper body framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or corporate style stock video with a shallow depth of field, keeping the kitchen and glass doors background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"glass doors\",\"windows\",\"kitchen\",\"cabinets\",\"pendant lights\",\"shelving\",\"sofa\",\"couch\",\"sweater color\",\"lighting\"],\"attributes\":[\"warm\",\"calm\",\"friendly\",\"gentle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"neutral tone\",\"lifestyle\",\"corporate\",\"home\",\"man\",\"male\",\"beard\",\"mustache\",\"sweater\",\"tan\",\"brown\",\"blue\",\"shirt\",\"sofa\",\"couch\",\"kitchen\",\"cabinets\",\"pendant light\",\"glass door\"]},{\"fileName\":\"GENERIC-PeopleDiverseCorporate-05.mp4\",\"description\":\"The video shows one man, a middle aged adult male of Asian descent with a fair skin tone and short, dark hair with visible gray strands. The man is wearing eyeglasses, dark tortoiseshell, brown thick framed eyeglasses, and has a light gray goatee and mustache, with a broad, open mouthed smile showing white teeth, giving a warm, friendly, joyful visible expression. The man is wearing a top, a blue, light blue button up collared shirt. The setting is an indoor home office environment, blurred softly out of focus behind the man, showing a white shelving unit or bookcase, a small potted plant on top of the shelf, and a bright window on the left side of the frame letting in soft natural light. The lighting is bright, soft, and even, consistent with natural daylight filling the room, evenly illuminating the man's face without harsh shadows. The color palette is bright and neutral, dominated by white, light blue, tan, and gray tones, with a small green accent from the potted plant. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or professional portrait style stock video with a shallow depth of field, keeping the background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"shelving unit\",\"bookcase\",\"potted plant\",\"window\",\"shirt color\",\"lighting\"],\"attributes\":[\"warm\",\"friendly\",\"joyful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"neutral tone\",\"corporate\",\"professional\",\"home office\",\"man\",\"male\",\"eyeglasses\",\"glasses\",\"tortoiseshell\",\"goatee\",\"mustache\",\"gray hair\",\"blue\",\"shirt\",\"shelving unit\",\"bookcase\",\"plant\",\"window\",\"white\"]},{\"fileName\":\"GENERIC-PeopleDiverseCorporate-06.mp4\",\"description\":\"The video shows one man, a young adult male with a tan or olive skin tone and short, dark black hair, along with a full, thick dark beard covering his jaw and chin. The man has dark brown eyes and a subtle, neutral, slightly closed lip smile, giving a calm, thoughtful visible expression, with his gaze directed slightly off to the side. The man is wearing a top, a gray button up collared shirt. The setting is an indoor office environment, blurred softly out of focus behind the man, showing a gray cubicle partition or wall panel on the left side of the frame, and a wood toned pegboard or shelving display holding small colorful objects on the right side of the frame, with a teal, green ceiling element visible in the upper right corner. The lighting is soft and diffused, consistent with overcast or even indoor lighting, evenly illuminating the man's face without harsh shadows. The color palette is neutral and muted, dominated by gray, tan, and wood brown tones, with small colorful accents from the objects on the pegboard and a teal accent from the ceiling. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or workplace style stock video with a shallow depth of field, keeping the office background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"cubicle partition\",\"wall panel\",\"pegboard\",\"shelving display\",\"ceiling\",\"shirt color\",\"lighting\"],\"attributes\":[\"calm\",\"thoughtful\",\"neutral\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"overcast\",\"neutral tone\",\"muted tone\",\"corporate\",\"workplace\",\"office\",\"man\",\"male\",\"beard\",\"gray\",\"shirt\",\"cubicle\",\"pegboard\",\"wood\",\"teal\",\"colorful\"]},{\"fileName\":\"GENERIC-PeopleDiverseCorporate-07.mp4\",\"description\":\"The video shows one woman, an elderly adult female with a fair skin tone and short, gray, silver hair. The woman is wearing eyeglasses, round wire framed eyeglasses, small stud earrings, and a silver choker necklace, with pink, rose colored lipstick, and a broad, open mouthed smile showing white teeth, giving a warm, joyful, friendly visible expression. The woman is wearing a top, a dark green button up shirt, along with bag straps visible over one shoulder. The setting is an outdoor city street intersection, blurred softly out of focus behind the woman, showing several cars, a black car, an orange car, and a yellow van or bus, parked or driving along the road, tall city buildings, a traffic light, and a pedestrian wearing a green shirt crossing the street. The lighting is warm and bright, consistent with low angle sunlight or sunset light shining from behind the woman, creating a warm glow around her hair and skin. The color palette is warm and vibrant, dominated by green, orange, yellow, and tan tones, with gray from the street and buildings. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a lifestyle or corporate style stock video with a shallow depth of field, keeping the street and vehicles background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"cars\",\"vehicles\",\"buildings\",\"traffic light\",\"street\",\"pedestrian\",\"bag straps\",\"shirt color\",\"backlight\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"friendly\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"backlight\",\"golden light\",\"bright lighting\",\"natural light\",\"warm tone\",\"vibrant\",\"urban\",\"city\",\"lifestyle\",\"corporate\",\"woman\",\"elderly\",\"senior\",\"gray hair\",\"silver hair\",\"eyeglasses\",\"glasses\",\"necklace\",\"choker\",\"green\",\"shirt\",\"bag\",\"strap\",\"cars\",\"traffic light\",\"street\",\"buildings\"]}]}");


var $3da96fca0ab4d60b$exports = {};
$3da96fca0ab4d60b$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-PeopleDiverseCity-01.mp4\",\"description\":\"The video shows one man, an adult male with a tan or olive skin tone, short dark black hair, and a full, thick dark beard and mustache covering his jaw and chin. The man is laughing broadly with his mouth wide open, showing white teeth, and visible smile lines and creases near his eyes, giving a joyful, energetic, happy visible expression. The man is wearing a top, a light blue, pale blue button up collared shirt with thin white pinstripes, a striped pattern. The setting is an outdoor residential street environment, blurred softly out of focus behind the man, showing parked cars, light colored buildings or houses, green trees and foliage, and a paved road or sidewalk. The lighting is bright and warm, consistent with strong backlight sunlight shining from behind the man, creating a warm glow around his head and shoulders and causing his ears to appear illuminated. The color palette is warm and bright, dominated by light blue, tan, beige, and white tones, with green accents from the trees. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a shallow depth of field, keeping the street and buildings background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"parked cars\",\"buildings\",\"houses\",\"trees\",\"foliage\",\"street\",\"sidewalk\",\"shirt pattern\",\"backlight\",\"lighting\"],\"attributes\":[\"joyful\",\"energetic\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"backlight\",\"bright lighting\",\"natural light\",\"warm tone\",\"casual\",\"lifestyle\",\"man\",\"male\",\"beard\",\"mustache\",\"striped shirt\",\"pinstripe\",\"blue\",\"light blue\",\"cars\",\"buildings\",\"trees\",\"foliage\",\"street\",\"residential\"]},{\"fileName\":\"GENERIC-PeopleDiverseCity-02.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone and short, straight, blonde hair styled in a bob haircut just above her shoulders. The woman has dark brown eyebrows, dark eyes, and pink, mauve colored lipstick, with a soft, gentle smile showing a hint of white teeth, giving a calm, warm, pleasant visible expression. The woman is wearing a top, a white button up collared shirt or blouse. The setting is an outdoor urban environment, blurred softly out of focus behind the woman, showing a red brick building facade, a dark green door or sign, and a paved sidewalk or plaza area. The lighting is soft, bright, and natural, consistent with daytime daylight, evenly illuminating the woman's face without harsh shadows. The color palette is warm and neutral, dominated by red brick, white, blonde, and dark green tones. The composition is an extreme close up, closeup, tight face framing, with the woman's face and shoulders filling most of the frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a lifestyle or corporate portrait style stock video with a shallow depth of field, keeping the brick building background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"brick building\",\"door\",\"sign\",\"sidewalk\",\"plaza\",\"shirt color\",\"lighting\"],\"attributes\":[\"calm\",\"warm\",\"gentle\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"neutral tone\",\"urban\",\"lifestyle\",\"corporate\",\"woman\",\"blonde hair\",\"bob haircut\",\"short hair\",\"straight hair\",\"white\",\"blouse\",\"shirt\",\"brick\",\"red brick\",\"building\",\"green door\"]},{\"fileName\":\"GENERIC-PeopleDiverseCity-03.mp4\",\"description\":\"The video shows one woman, an adult female with a dark brown skin tone and dark black hair pulled back tightly away from her face with a center part. The woman has dark brown eyes and purple, mauve colored lipstick, with a broad, open mouthed smile showing white teeth, giving a joyful, warm, confident visible expression. The woman is wearing a top, a gray, dark gray heather knit sweater with a mock neck or high collar. The setting is a busy outdoor city street environment, blurred softly out of focus behind the woman, showing multiple cars and vehicles, tall city buildings, a large round domed structure, possibly a water tower, string lights or banners, colorful signage, and pedestrians and street lights in the distance. The lighting is soft, bright, and natural, consistent with overcast or diffused daytime lighting, evenly illuminating the woman's face without harsh shadows. The color palette is neutral and muted, dominated by gray, tan, and beige tones, with colorful accents from the distant signage and vehicles. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or urban portrait style stock video with a shallow depth of field, keeping the busy city street background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"cars\",\"vehicles\",\"buildings\",\"domed structure\",\"water tower\",\"string lights\",\"signage\",\"pedestrians\",\"street lights\",\"sweater color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"confident\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"overcast\",\"neutral tone\",\"muted tone\",\"urban\",\"city\",\"lifestyle\",\"woman\",\"sweater\",\"mock neck\",\"gray\",\"knit\",\"cars\",\"buildings\",\"dome\",\"water tower\",\"signage\",\"colorful\"]},{\"fileName\":\"GENERIC-PeopleDiverseCity-04.mp4\",\"description\":\"The video shows one man, a young adult male with a tan or light skin tone, short dark wavy hair, and light stubble or a short goatee along his jawline. In one visible moment the man has a neutral, serious, still visible expression with his lips closed, looking directly at the camera, and in another visible moment he smiles broadly with his mouth open, showing white teeth, giving a joyful, warm, friendly visible expression. The man is wearing a jacket, a dark teal, gray blazer or sport coat, layered over a white, light blue collared shirt with no tie, left open at the collar. The setting is an outdoor city street environment, blurred softly out of focus behind the man, showing a red car and a white car parked or driving along the road, light colored buildings, green trees, and a pink, red painted bicycle lane on the sidewalk. The lighting is bright and natural, consistent with clear daytime sunlight, evenly illuminating the man's face and creating defined highlights. The color palette is cool and neutral, dominated by teal, gray, white, and green tones, with red accents from the car and bicycle lane. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or lifestyle style stock video with a shallow depth of field, keeping the street and vehicles background softly blurred while the man remains in sharp focus.\",\"keyElements\":[\"cars\",\"vehicles\",\"buildings\",\"trees\",\"bicycle lane\",\"street\",\"blazer color\",\"lighting\"],\"attributes\":[\"serious\",\"neutral\",\"joyful\",\"warm\",\"friendly\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"cool tone\",\"corporate\",\"lifestyle\",\"man\",\"male\",\"goatee\",\"stubble\",\"blazer\",\"jacket\",\"teal\",\"gray\",\"white\",\"shirt\",\"cars\",\"red car\",\"buildings\",\"trees\",\"bicycle lane\",\"street\"]},{\"fileName\":\"GENERIC-PeopleDiverseCity-05.mp4\",\"description\":\"The video shows one woman, an adult female with a tan or olive skin tone and long, dark brown wavy hair falling past her shoulders, moving dynamically in the wind. The woman has dark brown eyes, small pearl stud earrings, and pink lipstick, with a broad, open mouthed smile showing white teeth, giving a joyful, warm, cheerful visible expression, and appears to be looking slightly off to the side. The woman is wearing a coat, a tan, camel colored coat, along with a scarf, a navy blue, dark blue scarf wrapped around her neck. The setting is an outdoor urban storefront environment, blurred softly out of focus behind the woman, showing a building facade, a dark colored sign or doorway, a red decorative element or awning on the right side of the frame, and bright circular bokeh light spots scattered throughout the background. The lighting is bright and warm, consistent with strong sunlight, creating a glowing backlight effect through the woman's hair. The color palette is warm and rich, dominated by tan, camel, navy blue, and brown tones, with a red accent on the right side of the frame. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing slightly off camera. The visual style is photographic, realistic, and resembles a lifestyle or fashion style stock video with a shallow depth of field and warm, glowing bokeh, keeping the storefront background softly blurred while the woman remains in sharp focus.\",\"keyElements\":[\"building facade\",\"sign\",\"doorway\",\"awning\",\"bokeh lights\",\"coat color\",\"scarf color\",\"backlight\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"cheerful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"shallow depth of field\",\"blurred background\",\"bokeh\",\"backlight\",\"golden light\",\"bright lighting\",\"natural light\",\"warm tone\",\"urban\",\"fashion\",\"lifestyle\",\"woman\",\"wavy hair\",\"brown hair\",\"earrings\",\"coat\",\"tan\",\"camel\",\"scarf\",\"navy blue\",\"blue\",\"building\",\"storefront\",\"red accent\"]}]}");


var $27420d6f341c25dd$exports = {};
$27420d6f341c25dd$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-Family-01.mp4\",\"description\":\"The video shows three people, one man, one woman, and one baby, gathered indoors around a laptop computer. The woman is an adult female with a dark brown skin tone and long, dark black wavy hair, wearing a top, a blue denim button up shirt or blouse, smiling broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression, while holding the baby in her arms. The man is an adult male with a dark brown skin tone, a bald or shaved head, and a full dark beard, wearing a top, a mustard, orange yellow colored t-shirt, smiling and talking with his mouth open, pointing one finger toward the laptop screen, giving an animated, joyful, engaged visible expression. The baby is an infant with a light brown skin tone and light, thin hair, wearing a white, cream colored outfit or onesie patterned with small leaves and floral designs, with one fist near its mouth. The setting is an indoor modern living room and open kitchen environment, blurred softly out of focus behind the group, showing a wood paneled accent wall on the left side of the frame, a tall window with an orange, red colored awning visible outside, green potted plants, a light gray sofa, and a wooden side table. The lighting is bright, soft, and natural, consistent with daylight coming through the window, evenly illuminating the family without harsh shadows. The color palette is warm and vibrant, dominated by blue denim, mustard yellow, white, and wood brown tones, with green accents from the plants. The composition is a medium close up, closeup, upper body framing, with all three people positioned close together toward the center of the frame, facing toward a laptop computer, a white, silver colored laptop, visible in the foreground. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field, keeping the living room background softly blurred while the family remains in sharp focus.\",\"keyElements\":[\"wood paneled wall\",\"window\",\"awning\",\"potted plants\",\"sofa\",\"side table\",\"laptop\",\"onesie pattern\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"happy\",\"animated\",\"engaged\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"warm tone\",\"vibrant\",\"family\",\"lifestyle\",\"man\",\"woman\",\"baby\",\"infant\",\"father\",\"mother\",\"beard\",\"bald\",\"yellow\",\"mustard\",\"denim\",\"blue\",\"onesie\",\"laptop\",\"plants\",\"window\",\"sofa\",\"video call\"]},{\"fileName\":\"GENERIC-Family-02.mp4\",\"description\":\"The video shows three people, one man and two children, playing indoors in a living room. The man is an adult male with a dark brown skin tone, short dark curly hair, and a light beard, wearing a top, a plaid, checkered patterned button up shirt in black, white, and gray tones, along with blue denim jeans, kneeling on a sofa with a wide, open mouthed smile showing white teeth, giving an energetic, joyful, playful visible expression. The two children, one girl and one boy, both have curly dark brown hair and light brown skin tones, and are positioned on the man's back and shoulders with their arms stretched outward like airplane wings, both smiling and laughing, giving joyful, excited, playful visible expressions. The girl is wearing a white t-shirt, and the boy is wearing a plaid, checkered patterned button up shirt similar to the man's shirt. The setting is an indoor living room environment, blurred softly out of focus behind the group, showing a white sectional sofa, tall black framed windows or French doors with sheer white curtains, a green potted plant on the left side of the frame, and an open plan kitchen in the background with a white brick tile wall, wood shelving, hanging pendant lights, and a round wall clock. The lighting is bright and natural, consistent with daylight coming through the tall windows, evenly illuminating the family. The color palette is bright and neutral, dominated by white, gray, black, and denim blue tones, with green accents from the plant. The composition is a medium wide shot, full body framing, with the group positioned slightly off center in the frame, in motion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a bright, airy look and a moderate depth of field.\",\"keyElements\":[\"sofa\",\"windows\",\"french doors\",\"curtains\",\"potted plant\",\"kitchen\",\"tile wall\",\"shelving\",\"pendant lights\",\"wall clock\",\"shirt pattern\",\"lighting\"],\"attributes\":[\"energetic\",\"joyful\",\"playful\",\"excited\",\"candid\",\"action\",\"wide shot\",\"full body\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"neutral tone\",\"airy\",\"family\",\"lifestyle\",\"man\",\"children\",\"girl\",\"boy\",\"father\",\"curly hair\",\"beard\",\"plaid\",\"checkered\",\"shirt\",\"sofa\",\"windows\",\"curtains\",\"plant\",\"kitchen\",\"pendant light\",\"clock\"]},{\"fileName\":\"GENERIC-Family-03.mp4\",\"description\":\"The video shows one man, an elderly adult male with a fair skin tone and short, white, gray hair. The man is wearing eyeglasses, dark rimmed eyeglasses, and has a light gray goatee or stubble, wearing a top, a light blue and white floral patterned button up shirt, waving one hand toward a laptop computer with a warm, friendly, welcoming visible expression, and a soft smile showing a hint of teeth. The setting is an indoor kitchen environment, showing a silver refrigerator, a gray cabinet or shelf displaying framed pictures of a coffee cup and a tropical drink, a brown paper grocery bag containing red peppers and other vegetables, a wood paneled backsplash, a stainless steel range hood, and various kitchen utensils, pots, and pans on the counter. In the foreground on a white table, there are croissants and toast on a plate, a small dish of butter and jam, a glass French press coffee pot, glasses of a dark red beverage, a gray coffee mug, and a silver, white laptop computer. The lighting is bright, soft, and neutral, consistent with even indoor kitchen lighting, evenly illuminating the man's face without harsh shadows. The color palette is warm and neutral, dominated by white, light blue, tan, wood brown, and gray tones, with red accents from the peppers and beverage. The composition is a medium close up, closeup, upper body framing, with the man positioned slightly off center in the frame, facing toward the laptop. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a moderate depth of field, keeping the kitchen background recognizable but softly blurred.\",\"keyElements\":[\"refrigerator\",\"cabinet\",\"framed pictures\",\"grocery bag\",\"vegetables\",\"backsplash\",\"range hood\",\"utensils\",\"pots\",\"pans\",\"croissants\",\"toast\",\"butter\",\"jam\",\"coffee pot\",\"beverage glasses\",\"coffee mug\",\"laptop\",\"shirt pattern\",\"lighting\"],\"attributes\":[\"warm\",\"friendly\",\"welcoming\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"neutral tone\",\"warm tone\",\"family\",\"lifestyle\",\"man\",\"elderly\",\"senior\",\"gray hair\",\"white hair\",\"eyeglasses\",\"glasses\",\"goatee\",\"floral pattern\",\"shirt\",\"kitchen\",\"refrigerator\",\"grocery bag\",\"vegetables\",\"croissant\",\"toast\",\"coffee\",\"laptop\",\"video call\"]},{\"fileName\":\"GENERIC-Family-04.mp4\",\"description\":\"The video shows two people, one woman and one man, relaxing together indoors on a sofa in the evening. The woman is an adult female with a fair skin tone and long, blonde hair styled in a high ponytail, leaning over the man's shoulder from behind, wearing a top, a beige, tan colored oversized cardigan or sweater, smiling broadly with her mouth open, giving a joyful, warm, affectionate visible expression. The man is an adult male with a fair skin tone, short reddish brown hair, and a full beard, wearing a jacket, a blue, light blue denim jacket, layered over a white t-shirt, along with olive green pants, holding a phone, a black smartphone, in one hand, smiling broadly with his mouth open, showing white teeth, giving a joyful, happy, relaxed visible expression. The setting is an indoor living room and kitchen environment, showing dark gray kitchen cabinets, a wood toned accent wall or pillar, a small potted plant, a warm glowing light bulb or lamp on a wooden side table, and a cream, off white colored sofa or couch with a soft blanket. The lighting is warm and dim, consistent with evening ambient lighting from a single glowing lamp, creating a cozy, intimate atmosphere with soft shadows. The color palette is warm and muted, dominated by tan, beige, denim blue, olive green, and dark gray tones, with a warm orange glow from the lamp. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame, angled toward the phone screen. The visual style is photographic, realistic, and resembles a lifestyle or couple style stock video with a shallow depth of field and warm, cozy ambient lighting.\",\"keyElements\":[\"kitchen cabinets\",\"accent wall\",\"potted plant\",\"lamp\",\"side table\",\"sofa\",\"blanket\",\"phone\",\"cardigan color\",\"jacket color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"affectionate\",\"happy\",\"relaxed\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"warm lighting\",\"dim lighting\",\"cozy\",\"intimate\",\"ambient light\",\"lifestyle\",\"couple\",\"woman\",\"man\",\"blonde hair\",\"ponytail\",\"cardigan\",\"beard\",\"denim jacket\",\"blue\",\"olive green\",\"tan\",\"beige\",\"phone\",\"smartphone\",\"sofa\",\"couch\",\"lamp\",\"plant\"]}]}");


var $812c309d6b8d4b12$exports = {};
$812c309d6b8d4b12$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-FamilyHome-01.mp4\",\"description\":\"The video shows four people, one man, one woman, and two girls, playing indoors in a living room. The woman is an adult female with fair skin and long, dark brown wavy hair, wearing a top, a pink, dusty rose colored jacket or shirt, laughing broadly with her mouth open, showing white teeth, giving an energetic, joyful, playful visible expression, while pushing a cardboard box. The man is an adult male with fair skin and short dark hair, wearing a top, a white, cream colored sweater, along with tan pants, laughing and smiling broadly, also pushing a cardboard box, giving an energetic, joyful, playful visible expression. The two girls, both young children with fair skin and light brown hair, are seated inside open cardboard boxes, with their arms raised upward, laughing and shouting with open mouths, giving excited, joyful, playful visible expressions. One girl is wearing a tan, brown colored sweater, and the other girl is wearing a pink top. The setting is an indoor living room environment, showing white paneled walls, a gray sofa, tall windows with tan, beige colored curtains, a wood cabinet or console table, a small potted plant, and additional cardboard boxes stacked on the floor. The lighting is bright and natural, consistent with daylight coming through the tall windows, evenly illuminating the family. The color palette is warm and bright, dominated by white, tan, pink, and gray tones, with brown accents from the cardboard boxes and wood furniture. The composition is a medium wide shot, full body framing, with the family positioned across the frame in dynamic motion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a bright, energetic look and a moderate depth of field.\",\"keyElements\":[\"cardboard boxes\",\"walls\",\"sofa\",\"windows\",\"curtains\",\"cabinet\",\"console table\",\"potted plant\",\"jacket color\",\"sweater color\",\"lighting\"],\"attributes\":[\"energetic\",\"joyful\",\"playful\",\"excited\",\"candid\",\"action\",\"wide shot\",\"full body\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"warm tone\",\"family\",\"lifestyle\",\"moving\",\"man\",\"woman\",\"girls\",\"children\",\"father\",\"mother\",\"pink\",\"white\",\"tan\",\"cardboard box\",\"boxes\",\"sofa\",\"windows\",\"curtains\",\"plant\",\"console table\"]},{\"fileName\":\"GENERIC-FamilyHome-02.mp4\",\"description\":\"The video shows two people, one man and one woman, an elderly couple, sitting together indoors on a sofa reviewing documents. The man is an elderly adult male with a tan skin tone, short gray hair, and a gray beard and mustache, wearing eyeglasses, dark rimmed eyeglasses, and a top, a blue, denim blue button up shirt, holding a pen and a sheet of white paper, laughing broadly with his mouth open, showing white teeth, giving a joyful, warm, happy visible expression. The woman is an elderly adult female with a tan skin tone and short, gray, silver hair, wearing a top, a cream, beige colored blouse, along with a gold watch and a necklace, resting one hand on the man's shoulder, laughing broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression. The setting is an indoor living room environment, showing a light gray sofa, a teal, green patterned throw pillow, a white table in front of them holding an open notebook, papers, and a laptop computer, along with a black staircase with wood steps and floor to ceiling windows in the background showing green trees and foliage outside. The lighting is bright and natural, consistent with daylight coming through the large windows, evenly illuminating the couple. The color palette is warm and bright, dominated by blue, cream, gray, and green tones. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or financial planning style stock video with a bright, airy look and a shallow depth of field, keeping the staircase and windows background softly blurred.\",\"keyElements\":[\"sofa\",\"throw pillow\",\"table\",\"notebook\",\"papers\",\"laptop\",\"staircase\",\"windows\",\"trees\",\"foliage\",\"shirt color\",\"blouse color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"warm tone\",\"airy\",\"family\",\"lifestyle\",\"elderly\",\"senior\",\"couple\",\"man\",\"woman\",\"gray hair\",\"silver hair\",\"beard\",\"eyeglasses\",\"glasses\",\"blue\",\"cream\",\"sofa\",\"laptop\",\"papers\",\"staircase\",\"windows\",\"financial\",\"documents\"]},{\"fileName\":\"GENERIC-FamilyHome-03.mp4\",\"description\":\"The video shows one girl, a young child with a fair skin tone and dark black hair cut in a bob with straight bangs. The girl is wearing a top, a white sleeveless shirt or dress with a colorful, multicolored pattern including blue, pink, and orange sections, along with a thin necklace, holding a marker, a gray and black colored marker pen, and looking downward with a focused, calm, concentrated visible expression while writing or tracing letters. The setting is an indoor home environment, showing a gray, tufted leather sofa in the background, along with a pink, polka dot patterned blanket or piece of clothing draped over the sofa. In front of the girl is a colorful workbook or activity book with the alphabet, showing large letters such as A, B, C, D, E, and other letters in colorful squares of yellow, orange, purple, green, blue, and pink, along with a yellow toy visible on the left side of the frame and additional markers on the table. The lighting is soft and neutral, consistent with indoor ambient lighting, evenly illuminating the girl's face and the workbook. The color palette is bright and colorful, dominated by yellow, orange, purple, green, blue, and pink tones from the workbook, with gray from the sofa. The composition is a close up, closeup, downward angle framing, with the girl positioned in the upper portion of the frame and the workbook filling the lower portion. The visual style is photographic, realistic, and resembles an educational or lifestyle style stock video with a moderate depth of field.\",\"keyElements\":[\"sofa\",\"blanket\",\"workbook\",\"alphabet letters\",\"marker\",\"toy\",\"lighting\"],\"attributes\":[\"calm\",\"focused\",\"concentrated\",\"candid\",\"close up\",\"closeup\",\"moderate depth of field\",\"soft lighting\",\"colorful\",\"bright\",\"educational\",\"learning\",\"lifestyle\",\"girl\",\"child\",\"bangs\",\"dark hair\",\"marker\",\"workbook\",\"alphabet\",\"letters\",\"yellow\",\"orange\",\"purple\",\"green\",\"blue\",\"pink\",\"sofa\",\"polka dot\",\"toy\",\"activity book\"]},{\"fileName\":\"GENERIC-FamilyHome-04.mp4\",\"description\":\"The video shows four people, one man, one woman, and two children, a boy and a girl, sitting closely together indoors on a sofa. The man is an adult male with a tan skin tone and dark, curly hair, along with a beard, smiling gently with a warm, calm visible expression. The woman is an adult female with a tan skin tone and dark, curly hair pulled back, smiling broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression. The boy and girl, both young children with tan skin tones and dark curly hair, are nestled between the two adults, with soft, content, calm visible expressions, looking off to the side. The setting is an indoor living room environment, showing a bright window with wood framing in the background, allowing a strong backlight to filter through and create a soft, hazy glow around the family. The lighting is bright and warm, consistent with strong backlight sunlight, creating lens flare and a glowing halo effect around the family's hair and shoulders. The color palette is warm and soft, dominated by light green, tan, and warm skin tones, with a hazy white glow from the window light. The composition is a medium close up, closeup, upper body framing, with the family positioned closely together toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field and soft, warm backlighting.\",\"keyElements\":[\"window\",\"wood framing\",\"backlight\",\"lens flare\",\"lighting\"],\"attributes\":[\"warm\",\"calm\",\"joyful\",\"happy\",\"content\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"backlight\",\"lens flare\",\"hazy\",\"warm tone\",\"soft light\",\"family\",\"lifestyle\",\"man\",\"woman\",\"boy\",\"girl\",\"children\",\"curly hair\",\"beard\",\"window\",\"green\"]},{\"fileName\":\"GENERIC-FamilyHome-05.mp4\",\"description\":\"The video shows two people, one man and one boy, sitting together indoors on a sofa watching television. The man is an adult male with a dark brown skin tone and short dark hair, along with a light beard, wearing a top, a plaid, checkered patterned button up shirt in brown, white, and black tones, holding a football, a brown football with white stripes, close to his chest, smiling broadly with his mouth open, giving an excited, joyful, energetic visible expression. The boy is a young child with a dark brown skin tone and short dark hair, wearing a top, a blue t-shirt, with his hands raised and fingers spread, giving an excited, animated, joyful visible expression, looking upward and off to the side. The setting is an indoor living room environment, blurred softly out of focus behind the pair, showing a brown leather sofa, a red throw pillow, tall windows with gray curtains, a hanging chandelier, and an open doorway leading to another room. In the foreground is a white bowl containing popcorn. The lighting is bright and natural, consistent with daylight coming through the windows, evenly illuminating the pair. The color palette is warm and neutral, dominated by brown, blue, white, and gray tones, with a red accent from the throw pillow. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field, keeping the living room background softly blurred.\",\"keyElements\":[\"sofa\",\"throw pillow\",\"windows\",\"curtains\",\"chandelier\",\"doorway\",\"popcorn bowl\",\"football\",\"shirt pattern\",\"lighting\"],\"attributes\":[\"excited\",\"joyful\",\"energetic\",\"animated\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"warm tone\",\"family\",\"lifestyle\",\"man\",\"boy\",\"father\",\"son\",\"beard\",\"plaid\",\"checkered\",\"shirt\",\"football\",\"popcorn\",\"sofa\",\"pillow\",\"windows\",\"curtains\",\"chandelier\",\"blue\"]},{\"fileName\":\"GENERIC-FamilyHome-06.mp4\",\"description\":\"The video shows two people, one woman and one man, positioned closely together indoors. The woman is a young adult female of Asian descent with a fair skin tone and dark black hair with straight bangs, smiling broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression, looking slightly downward and off to the side. The man is an adult male of Asian descent with a tan skin tone and short dark hair, along with light facial hair, positioned behind the woman, smiling with his mouth open, giving a joyful, warm, engaged visible expression, with one hand raised and fingers extended in a pointing or gesturing motion near a dark colored object, possibly a phone or tablet, in the lower right of the frame. The setting is an indoor home environment with a plain, light colored, blurred background, softly out of focus, giving minimal additional visual context. The lighting is soft, bright, and neutral, consistent with even indoor lighting, illuminating both people's faces without harsh shadows. The color palette is neutral and warm, dominated by white, tan, and warm skin tones. The composition is an extreme close up, closeup, tight framing, with both faces positioned in the upper left portion of the frame and a hand and dark object extending into the lower right portion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field.\",\"keyElements\":[\"background\",\"phone\",\"tablet\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"happy\",\"engaged\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"neutral tone\",\"family\",\"lifestyle\",\"woman\",\"man\",\"bangs\",\"dark hair\",\"gesturing\",\"pointing\",\"phone\",\"tablet\",\"indoor\"]},{\"fileName\":\"GENERIC-FamilyHome-07.mp4\",\"description\":\"The video shows three people, one man, one woman, and one toddler, playing together indoors on a rug, filmed from a direct overhead angle. The woman is an adult female with a tan skin tone and long, dark brown hair, wearing a top, a yellow, mustard colored sweater, laughing with an open mouth, giving a joyful, warm, playful visible expression, while holding the toddler. The man is an adult male with a tan skin tone and short, dark curly hair, wearing a top, a gray, green colored shirt, smiling broadly, giving a joyful, warm, playful visible expression. The toddler is a young child with a fair skin tone and short dark hair, wearing a top, a striped, blue and white striped shirt, laughing broadly with an open mouth, giving an excited, joyful, playful visible expression, with bare feet visible. The setting is an indoor living room environment, viewed from above, showing a dark gray woven round rug, a red throw pillow, a wood plank floor, and scattered children's toys including a colorful wooden shape sorter and small toy blocks in orange, blue, pink, and yellow tones. The lighting is warm and soft, consistent with dim ambient indoor lighting, creating a cozy atmosphere. The color palette is warm and colorful, dominated by yellow, gray, blue, and red tones, with colorful accents from the scattered toys. The composition is an overhead, top down shot, full body framing, with all three people positioned diagonally across the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a cozy, warm look and a moderate depth of field.\",\"keyElements\":[\"rug\",\"throw pillow\",\"wood floor\",\"toys\",\"shape sorter\",\"blocks\",\"sweater color\",\"shirt color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"playful\",\"excited\",\"candid\",\"action\",\"overhead shot\",\"top down\",\"full body\",\"moderate depth of field\",\"warm lighting\",\"cozy\",\"dim lighting\",\"colorful\",\"family\",\"lifestyle\",\"man\",\"woman\",\"toddler\",\"child\",\"yellow\",\"mustard\",\"gray\",\"green\",\"striped shirt\",\"rug\",\"toys\",\"blocks\",\"shape sorter\",\"pillow\"]},{\"fileName\":\"GENERIC-FamilyHome-08.mp4\",\"description\":\"The video shows three people, one man and two boys, sitting together indoors on a sofa looking at a tablet computer. The man is an adult male with a dark brown skin tone and a bald or shaved head, wearing a top, a blue, teal colored polo shirt, smiling broadly, giving a joyful, warm, engaged visible expression, holding a tablet, a gray, dark colored tablet computer. The two boys, both young children with dark brown skin tones and curly dark hair, are seated on either side of the man, one wearing a striped, gray and white striped shirt with a soft, content, calm visible expression, and the other wearing a light green, striped shirt with a focused, curious, calm visible expression, both looking toward the tablet screen. The setting is an indoor living room and kitchen environment, showing a gray sofa, an olive green throw pillow and a tan, orange throw pillow, wood open shelving displaying dishes and small decorative objects, a dark arched cabinet with glass doors, and kitchen utensils in a holder on the counter. The lighting is soft, bright, and natural, consistent with even indoor lighting, evenly illuminating the family without harsh shadows. The color palette is warm and neutral, dominated by blue, tan, wood brown, and gray tones, with green accents from the throw pillow and shirt. The composition is a medium close up, closeup, upper body framing, with all three people positioned together toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field, keeping the kitchen background softly blurred.\",\"keyElements\":[\"sofa\",\"throw pillow\",\"shelving\",\"dishes\",\"cabinet\",\"kitchen utensils\",\"tablet\",\"shirt pattern\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"engaged\",\"content\",\"calm\",\"curious\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"family\",\"lifestyle\",\"man\",\"boys\",\"children\",\"father\",\"sons\",\"bald\",\"blue\",\"polo shirt\",\"tablet\",\"sofa\",\"pillow\",\"shelving\",\"cabinet\",\"kitchen\",\"striped shirt\"]},{\"fileName\":\"GENERIC-FamilyHome-09.mp4\",\"description\":\"The video shows four people, one man, one woman, and two girls, playing together indoors on a sofa. The man is an adult male with a fair skin tone and short dark hair, wearing a top, a white, cream colored sweater, laughing broadly, giving a joyful, warm, playful visible expression, while tickling or holding one girl. The woman is an adult female with a fair skin tone and long, dark brown wavy hair, wearing a top, a pink, mauve colored shirt, laughing with her mouth wide open, giving an excited, joyful, playful visible expression, while holding the other girl. Both girls are young children with fair skin tones and long light brown hair, wearing denim jeans, one wearing a tan, brown sweater and the other wearing a pink top, both laughing and smiling broadly, giving excited, joyful, playful visible expressions, with bare feet visible. The setting is an indoor living room environment, showing a light gray sofa, white paneled walls, a wood console table, tall windows with tan, beige curtains, and a small potted plant on the windowsill. The lighting is bright and natural, consistent with daylight coming through the windows, evenly illuminating the family. The color palette is bright and warm, dominated by white, tan, pink, and denim blue tones. The composition is a medium wide shot, full body framing, with the family positioned across the sofa in dynamic motion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a bright, energetic look and a moderate depth of field.\",\"keyElements\":[\"sofa\",\"walls\",\"console table\",\"windows\",\"curtains\",\"potted plant\",\"sweater color\",\"shirt color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"playful\",\"excited\",\"candid\",\"action\",\"wide shot\",\"full body\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"warm tone\",\"family\",\"lifestyle\",\"man\",\"woman\",\"girls\",\"children\",\"father\",\"mother\",\"tickling\",\"white\",\"pink\",\"tan\",\"denim\",\"sofa\",\"windows\",\"curtains\",\"console table\",\"plant\"]},{\"fileName\":\"GENERIC-FamilyHome-10.mp4\",\"description\":\"The video shows two people, one man and one woman, sitting closely together indoors on a sofa. The man is an adult male with a tan skin tone, short dark curly hair, and a full dark beard, wearing a top, a pink, coral colored button up collared shirt, smiling broadly with his mouth open, showing white teeth, giving a joyful, warm, affectionate visible expression, with one arm resting behind the woman. The woman is an adult female with a tan skin tone and long, dark brown hair, wearing a top, a white, cream colored knit sweater, along with a colorful, patterned headband in red, white, and blue tones, and gold stud earrings, laughing with her mouth open, giving a joyful, warm, happy visible expression. The setting is an indoor living room environment, blurred softly out of focus behind the couple, showing a green sofa, a wood bookshelf holding books, tall windows with sheer white curtains, and a framed picture on the wall. In the foreground is a dark colored laptop computer. The lighting is soft, bright, and natural, consistent with daylight coming through the windows, evenly illuminating the couple. The color palette is warm and neutral, dominated by pink, coral, white, green, and wood brown tones. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or couple style stock video with a shallow depth of field, keeping the background softly blurred.\",\"keyElements\":[\"sofa\",\"bookshelf\",\"books\",\"windows\",\"curtains\",\"framed picture\",\"laptop\",\"shirt color\",\"sweater color\",\"headband\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"affectionate\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"couple\",\"lifestyle\",\"man\",\"woman\",\"beard\",\"curly hair\",\"pink\",\"coral\",\"white\",\"headband\",\"earrings\",\"sofa\",\"green\",\"bookshelf\",\"windows\",\"curtains\",\"laptop\"]},{\"fileName\":\"GENERIC-FamilyHome-11.mp4\",\"description\":\"The video shows two people, one man and one woman, sitting together on the floor indoors, petting a dog. The man is an adult male with a fair skin tone and short dark hair, along with a beard, wearing a top, an orange, tan colored cardigan or sweater, smiling broadly, giving a warm, joyful, affectionate visible expression, while petting the dog. The woman is an adult female with a fair skin tone and dark hair pulled back, wearing a top, a white, cream colored sweater, smiling gently, giving a warm, content, affectionate visible expression, also petting the dog. The dog is a large animal with a dark brown, chocolate colored coat, standing on the floor between the two people. The setting is an indoor living room environment, showing a light gray woven rug on a wood plank floor, a green velvet sofa with a white throw blanket, a wood coffee table holding a plate with red tomatoes, a tall floor lamp with a yellow, mustard colored lampshade, floor to ceiling windows showing green trees outside, and a wood bookshelf on the right side of the frame. The lighting is warm and soft, consistent with natural daylight filtering through the windows combined with warm lamp light, creating a cozy, glowing atmosphere. The color palette is warm and rich, dominated by green, tan, brown, and yellow tones, with red accents from the tomatoes. The composition is a wide shot, full body framing, with both people and the dog positioned toward the center left of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a warm, cozy look and a moderate depth of field.\",\"keyElements\":[\"rug\",\"wood floor\",\"sofa\",\"throw blanket\",\"coffee table\",\"tomatoes\",\"floor lamp\",\"windows\",\"trees\",\"bookshelf\",\"cardigan color\",\"sweater color\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"affectionate\",\"content\",\"candid\",\"wide shot\",\"full body\",\"moderate depth of field\",\"warm lighting\",\"cozy\",\"natural light\",\"warm tone\",\"lifestyle\",\"pet\",\"couple\",\"man\",\"woman\",\"dog\",\"brown dog\",\"beard\",\"orange\",\"tan\",\"white\",\"green sofa\",\"rug\",\"lamp\",\"coffee table\",\"tomatoes\",\"windows\",\"trees\",\"bookshelf\"]}]}");


var $68e73aa430c018e6$exports = {};
$68e73aa430c018e6$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-HumanConnection-01.mp4\",\"description\":\"The video shows an extreme macro close up of one person's closed eye and eyelid, with a fair, tan skin tone showing fine wrinkles and skin texture, and dark eyelashes visible along the eyelid edge. The person's eye is fully closed, giving a calm, peaceful, still visible expression. The setting is an indoor environment with a plain, blurred background, softly out of focus, giving no additional visual context beyond the eye and skin. The lighting is warm and golden, coming from one side of the face, creating a gradient of warm highlights and darker shadow tones across the eyelid. The color palette is warm and golden, dominated by tan, amber, and brown tones, with darker shadow accents near the outer eye. The composition is an extreme close up, closeup, macro framing, with the eye and eyelid filling the entire frame. The visual style is photographic, realistic, and resembles a beauty or documentary style stock video with a shallow depth of field and detailed macro focus on skin texture and eyelashes.\",\"keyElements\":[\"background\",\"lighting\",\"shadow\",\"highlight\"],\"attributes\":[\"calm\",\"peaceful\",\"still\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"warm lighting\",\"golden light\",\"warm tone\",\"documentary\",\"beauty\",\"eye\",\"eyelid\",\"eyelashes\",\"wrinkles\",\"skin texture\",\"tan\",\"amber\",\"brown\",\"shadow\",\"highlight\"]},{\"fileName\":\"GENERIC-HumanConnection-02.mp4\",\"description\":\"The video shows five people, a group of adults, gathered indoors in a group embrace, hugging one another in a close circle, giving a warm, joyful, affectionate visible expression, with several arms wrapped around shoulders and one arm stretched outward. The people are wearing a variety of tops, including a gray, light gray sweater, a light blue, denim colored sweatshirt, a pink, coral colored sweater, and other casual clothing, along with a denim, blue skirt. The setting is an indoor entryway or hallway environment, showing a white door frame and an open white door leading outside to a view of green trees and foliage, a wall with floral patterned curtains, a coat rack holding a navy blue jacket, a light pink jacket, and a teal, green colored handbag, along with a beige sofa and a framed picture on the wall. The lighting is bright and natural, consistent with daylight coming through the open door, evenly illuminating the group. The color palette is warm and neutral, dominated by white, gray, denim blue, and pink tones, with green accents from the trees outside and the handbag. The composition is a wide shot, full body framing, with the group positioned in the center of the frame, viewed mostly from behind. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a moderate depth of field, keeping the outdoor greenery visible through the open door.\",\"keyElements\":[\"door\",\"door frame\",\"trees\",\"foliage\",\"curtains\",\"coat rack\",\"jackets\",\"handbag\",\"sofa\",\"framed picture\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"affectionate\",\"candid\",\"wide shot\",\"full body\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"warm tone\",\"family\",\"lifestyle\",\"group hug\",\"embrace\",\"gray\",\"denim blue\",\"pink\",\"coral\",\"jacket\",\"handbag\",\"coat rack\",\"door\",\"trees\",\"sofa\",\"reunion\"]},{\"fileName\":\"GENERIC-HumanConnection-03.mp4\",\"description\":\"The video shows a group of five women, young adult females with varying skin tones from fair to dark brown, gathered closely together outdoors, taking a selfie photograph. The women are smiling and laughing broadly with open mouths, showing white teeth, giving joyful, energetic, happy visible expressions. The women are wearing winter clothing, including a beige, tan colored knit hat, a black beanie, orange and brown jackets, and a light purple, lavender colored sweater, with one woman wearing sunglasses pushed up on her head. The setting is an outdoor environment, showing a bright, hazy sky with strong backlight sunlight creating a prominent lens flare and sun rays across the frame, and blurred green trees visible in the lower portion of the background. The lighting is very bright and strong, consistent with direct backlight sunlight, creating a hazy, glowing atmosphere and silhouetting some facial features. The color palette is bright and warm, dominated by tan, orange, brown, and lavender tones, with a bright white glow from the sun. The composition is a close up, closeup, group framing, with all five faces positioned across the frame at slightly varied heights, shot from a low angle as if from a handheld camera or phone. The visual style is photographic, realistic, and resembles a lifestyle or social media style stock video with strong lens flare and a moderate depth of field.\",\"keyElements\":[\"sky\",\"trees\",\"lens flare\",\"sun rays\",\"hat\",\"beanie\",\"jackets\",\"sunglasses\",\"lighting\"],\"attributes\":[\"joyful\",\"energetic\",\"happy\",\"candid\",\"close up\",\"closeup\",\"group\",\"selfie\",\"low angle\",\"lens flare\",\"backlight\",\"hazy\",\"bright lighting\",\"natural light\",\"warm tone\",\"social media\",\"lifestyle\",\"friends\",\"women\",\"tan\",\"orange\",\"brown\",\"lavender\",\"beanie\",\"hat\",\"sunglasses\",\"trees\",\"sky\"]},{\"fileName\":\"GENERIC-HumanConnection-04.mp4\",\"description\":\"The video shows two people, one man and one woman, a bride and groom, holding hands closely together outdoors. The woman is wearing a dress, a white, ivory colored lace wedding dress, along with a sheer white veil flowing in the wind, and a wedding ring visible on her finger. The man is wearing a suit, a blue, dark blue colored suit jacket, with his hand clasped around the woman's hand, also wearing a wedding ring. The setting is an outdoor environment, blurred heavily out of focus behind the couple, showing green trees and foliage, and a light colored car in the distance. The lighting is bright and soft, consistent with natural daylight, evenly illuminating the couple's hands without harsh shadows. The color palette is soft and neutral, dominated by white, ivory, blue, and green tones. The composition is an extreme close up, closeup, tight framing, focused entirely on the couple's clasped hands, with the veil visible flowing between their arms. The visual style is photographic, realistic, and resembles a wedding or romantic style stock video with a shallow depth of field, keeping the outdoor background softly blurred while the hands remain in sharp focus.\",\"keyElements\":[\"trees\",\"foliage\",\"car\",\"veil\",\"wedding ring\",\"suit color\",\"dress color\",\"lighting\"],\"attributes\":[\"romantic\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"soft tone\",\"wedding\",\"romance\",\"couple\",\"bride\",\"groom\",\"hands\",\"holding hands\",\"wedding ring\",\"veil\",\"white\",\"ivory\",\"blue\",\"suit\",\"dress\",\"lace\",\"trees\",\"outdoor\"]},{\"fileName\":\"GENERIC-HumanConnection-05.mp4\",\"description\":\"The video shows an extreme macro close up of one man's eye and upper face, an elderly adult with a tan skin tone showing deep wrinkles, fine lines, and visible skin texture around the eye and nose. The man has dark brown eyes with a light colored reflection visible in the eye, and gray and dark eyebrows and eyelashes, looking upward and off to the side with a thoughtful, contemplative, still visible expression. The setting is an indoor environment with a plain, dark, blurred background, softly out of focus, giving no additional visual context beyond the man's face. The lighting is dim and directional, coming from one side of the face, creating strong shadows and highlights that emphasize the depth and texture of the skin and wrinkles. The color palette is dark and warm, dominated by brown, tan, and dark gray tones, with a small bright highlight reflected in the eye. The composition is an extreme close up, closeup, macro framing, with the eye and upper face filling the entire frame, angled slightly upward. The visual style is photographic, realistic, and resembles a documentary or emotional portrait style stock video with a shallow depth of field and dramatic, moody lighting.\",\"keyElements\":[\"background\",\"lighting\",\"shadow\",\"highlight\"],\"attributes\":[\"thoughtful\",\"contemplative\",\"still\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"dim lighting\",\"dramatic lighting\",\"moody\",\"dark tone\",\"warm tone\",\"documentary\",\"elderly\",\"senior\",\"man\",\"eye\",\"eyebrow\",\"eyelashes\",\"wrinkles\",\"skin texture\",\"brown\",\"tan\",\"gray\",\"reflection\"]},{\"fileName\":\"GENERIC-HumanConnection-06.mp4\",\"description\":\"The video shows two people, one baby and one adult, with the baby's small hand, a fair skin toned infant hand, wrapped around and holding one adult finger tightly. The adult hand has a fair skin tone and light pink, lavender colored nail polish on the fingernails. The setting is an indoor environment, showing a white, soft fabric blanket or sheet draped and bunched around the hands, filling the background with soft folds and creases. The lighting is soft, bright, and diffused, consistent with gentle natural light, evenly illuminating the hands without harsh shadows. The color palette is soft and neutral, dominated by white and light skin tones, with a small lavender accent from the nail polish. The composition is an extreme close up, closeup, tight framing, focused entirely on the baby's hand and the adult's hand, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field and soft, gentle lighting.\",\"keyElements\":[\"blanket\",\"fabric\",\"nail polish\",\"lighting\"],\"attributes\":[\"gentle\",\"tender\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"soft lighting\",\"natural light\",\"neutral tone\",\"family\",\"lifestyle\",\"baby\",\"infant\",\"hand\",\"finger\",\"holding hands\",\"blanket\",\"white\",\"lavender\",\"nail polish\",\"newborn\"]},{\"fileName\":\"GENERIC-HumanConnection-07.mp4\",\"description\":\"The video shows two people, one man and one woman, a couple, embracing closely together outdoors. The woman is an adult female with a fair skin tone and long, reddish brown hair, wearing a top, a blue, denim colored jacket or shirt, along with a gray, patterned scarf, and carrying a brown leather bag over her shoulder, smiling broadly with her eyes closed, giving a warm, joyful, affectionate visible expression. The man is an adult male with a tan skin tone, curly gray and dark hair, and a gray beard, wearing eyeglasses, dark rimmed eyeglasses, and a jacket, a tan, beige colored jacket, along with a navy blue scarf, smiling broadly with an open mouth, showing white teeth, giving a warm, joyful, affectionate visible expression, with his hand holding the woman's hand. The setting is an outdoor urban street environment, blurred softly out of focus behind the couple, showing light colored buildings, storefronts, and architectural columns. The lighting is soft and natural, consistent with daytime outdoor lighting, evenly illuminating the couple. The color palette is warm and neutral, dominated by tan, blue, brown, and gray tones. The composition is a medium close up, closeup, upper body framing, with the couple positioned toward the center of the frame facing each other. The visual style is photographic, realistic, and resembles a lifestyle or romantic style stock video with a shallow depth of field, keeping the street background softly blurred.\",\"keyElements\":[\"buildings\",\"storefronts\",\"columns\",\"street\",\"scarf\",\"leather bag\",\"jacket color\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"affectionate\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"romantic\",\"couple\",\"lifestyle\",\"man\",\"woman\",\"gray hair\",\"beard\",\"eyeglasses\",\"glasses\",\"scarf\",\"leather bag\",\"blue\",\"tan\",\"beige\",\"buildings\",\"street\",\"embrace\"]},{\"fileName\":\"GENERIC-HumanConnection-08.mp4\",\"description\":\"The video shows two people's hands clasped together, one hand with a fair skin tone wearing a tan, beige colored sleeve with a light green cuff and a wristwatch, and the other hand with a dark brown skin tone wearing a white sleeve. The hands are clasped in a gentle, comforting hold, with fingers interlaced. The setting is an indoor environment, blurred softly out of focus behind the hands, showing indistinct light colored furniture, a dark object, and a green accent in the background. The lighting is soft, warm, and natural, evenly illuminating the hands without harsh shadows. The color palette is warm and neutral, dominated by tan, beige, white, and brown skin tones, with a green accent in the background. The composition is an extreme close up, closeup, tight framing, focused entirely on the clasped hands, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or caregiving style stock video with a shallow depth of field, keeping the background softly blurred while the hands remain in sharp focus.\",\"keyElements\":[\"furniture\",\"background\",\"wristwatch\",\"sleeve color\",\"lighting\"],\"attributes\":[\"gentle\",\"comforting\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"caregiving\",\"lifestyle\",\"hands\",\"holding hands\",\"wristwatch\",\"tan\",\"beige\",\"white\",\"green\",\"support\",\"comfort\"]},{\"fileName\":\"GENERIC-HumanConnection-09.mp4\",\"description\":\"The video shows an extreme macro close up of one person's closed eye and eyelid, with a dark brown skin tone and dark eyelashes visible along the eyelid edge, catching a bright highlight. The person's eye is fully closed, giving a calm, peaceful, still visible expression. The setting is an indoor environment with a plain, dark, blurred background, softly out of focus, giving no additional visual context beyond the eye and skin. The lighting is dim and directional, coming from one side of the face, creating a strong highlight along the upper eyelid while the surrounding skin remains in shadow. The color palette is dark and warm, dominated by deep brown and black tones, with a bright warm highlight along the eyelid. The composition is an extreme close up, closeup, macro framing, with the eye and eyelid filling the entire frame. The visual style is photographic, realistic, and resembles a beauty or documentary style stock video with a shallow depth of field and dramatic, moody lighting.\",\"keyElements\":[\"background\",\"lighting\",\"shadow\",\"highlight\"],\"attributes\":[\"calm\",\"peaceful\",\"still\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"dim lighting\",\"dramatic lighting\",\"moody\",\"dark tone\",\"warm tone\",\"documentary\",\"beauty\",\"eye\",\"eyelid\",\"eyelashes\",\"skin texture\",\"brown\",\"black\",\"highlight\",\"shadow\"]},{\"fileName\":\"GENERIC-HumanConnection-10.mp4\",\"description\":\"The video shows two people, one man and one woman, a couple, embracing closely together outdoors at a stadium or sports venue. The woman is a young adult female with a fair skin tone and long, reddish brown curly hair, wearing a top, a maroon, dark red colored t-shirt, laughing broadly with her eyes closed, giving a joyful, excited, happy visible expression, with one arm raised near her head. The man is a young adult male with a tan skin tone and short, dark curly hair, along with light facial hair, wearing a top, a white t-shirt, laughing broadly with an open mouth, showing white teeth, giving a joyful, excited, happy visible expression, with one arm wrapped around the woman. The setting is an outdoor stadium environment, blurred softly out of focus behind the couple, showing rows of stadium seating or bleachers, and other spectators, including a man wearing a beige cap and a woman wearing a red cap, clapping and cheering. The lighting is bright and natural, consistent with daytime outdoor lighting, evenly illuminating the couple. The color palette is warm and bright, dominated by maroon, white, tan, and beige tones. The composition is a medium close up, closeup, upper body framing, with the couple positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or sports event style stock video with a shallow depth of field, keeping the stadium background softly blurred.\",\"keyElements\":[\"stadium seating\",\"bleachers\",\"spectators\",\"cap\",\"shirt color\",\"lighting\"],\"attributes\":[\"joyful\",\"excited\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"warm tone\",\"sports\",\"stadium\",\"lifestyle\",\"couple\",\"man\",\"woman\",\"curly hair\",\"maroon\",\"white\",\"cap\",\"bleachers\",\"cheering\",\"celebration\"]},{\"fileName\":\"GENERIC-HumanConnection-11.mp4\",\"description\":\"The video shows two people's hands clasped together, resting on the leg of one person seated, with both hands showing a fair, tan skin tone and visible wrinkles suggesting an elderly age. One hand is folded and held by the other in a comforting, supportive grip. The people are wearing pants, tan, beige colored trousers, and a top, a blue, denim colored shirt. The setting is an indoor environment, showing additional seated people nearby, with a light gray chair visible in the background, suggesting a group or waiting room setting. The lighting is soft, bright, and neutral, consistent with even indoor lighting, evenly illuminating the hands without harsh shadows. The color palette is warm and neutral, dominated by tan, beige, blue, and gray tones. The composition is an extreme close up, closeup, tight framing, focused entirely on the clasped hands, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or support group style stock video with a shallow depth of field, keeping the background softly blurred while the hands remain in sharp focus.\",\"keyElements\":[\"chair\",\"background\",\"shirt color\",\"pants color\",\"lighting\"],\"attributes\":[\"comforting\",\"supportive\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"neutral tone\",\"elderly\",\"senior\",\"support group\",\"lifestyle\",\"hands\",\"holding hands\",\"wrinkles\",\"tan\",\"beige\",\"blue\",\"denim\",\"chair\",\"comfort\"]},{\"fileName\":\"GENERIC-HumanConnection-12.mp4\",\"description\":\"The video shows two people's hands, one hand with a fair skin tone reaching out to receive, and another hand with a fair skin tone holding and passing a set of keys, a silver, metal key attached to a pink and black colored keychain. The people are wearing tops, one wearing a tan, beige colored knit sweater, and the other wearing a dark brown colored sleeve and a white shirt underneath. The setting is an indoor environment, blurred softly out of focus behind the hands, showing stacked cardboard boxes in yellow and tan tones, and a tan colored sofa or couch. The lighting is warm and bright, consistent with natural indoor lighting, evenly illuminating the hands and keys. The color palette is warm and neutral, dominated by tan, beige, brown, and yellow tones, with a pink accent from the keychain. The composition is an extreme close up, closeup, tight framing, focused entirely on the hands and keys, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or real estate style stock video with a shallow depth of field, keeping the moving boxes background softly blurred.\",\"keyElements\":[\"cardboard boxes\",\"sofa\",\"couch\",\"keys\",\"keychain\",\"sweater color\",\"lighting\"],\"attributes\":[\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"warm lighting\",\"natural light\",\"warm tone\",\"real estate\",\"moving\",\"lifestyle\",\"hands\",\"keys\",\"keychain\",\"tan\",\"beige\",\"brown\",\"yellow\",\"pink\",\"cardboard box\",\"sofa\",\"new home\"]},{\"fileName\":\"GENERIC-HumanConnection-13.mp4\",\"description\":\"The video shows two people, one woman and one man, an elderly adult, sitting closely together indoors looking at a tablet or phone screen. The woman is a young adult female with a fair skin tone and long, dark brown hair, wearing a top, a gray, olive green knit sweater, waving one hand toward the screen, smiling broadly with an open mouth, showing white teeth, giving a joyful, warm, happy visible expression. The man is an elderly adult male with a fair skin tone and short, white, gray hair, along with light facial stubble, wearing a top, a navy blue and green plaid, checkered patterned shirt, smiling with his mouth open, giving a warm, joyful, engaged visible expression, looking toward the woman and the screen. The setting is an indoor home environment, blurred softly out of focus behind the pair, showing a plain dark wall and a light colored armrest or cushion. The lighting is soft and dim, consistent with warm indoor ambient lighting, creating a cozy atmosphere. The color palette is warm and muted, dominated by gray, green, navy blue, and tan tones. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame, facing a screen held in the foreground. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field and warm, cozy lighting.\",\"keyElements\":[\"wall\",\"armrest\",\"cushion\",\"tablet\",\"phone\",\"sweater color\",\"shirt pattern\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"happy\",\"engaged\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"dim lighting\",\"cozy\",\"warm tone\",\"family\",\"lifestyle\",\"woman\",\"man\",\"elderly\",\"senior\",\"gray hair\",\"white hair\",\"plaid\",\"checkered\",\"green\",\"navy blue\",\"tablet\",\"phone\",\"video call\",\"waving\"]},{\"fileName\":\"GENERIC-HumanConnection-14.mp4\",\"description\":\"The video shows two people, one man and one woman, embracing closely together outdoors. The man is an adult male with a dark brown skin tone and short, dark curly hair, wearing a top, a gray, olive green colored jacket or vest over a blue shirt, seen mostly from behind with his arms wrapped around the woman. The woman is an adult female with a tan skin tone and short, gray, silver hair, wearing a top, a blue, light blue colored scrub top, along with a rust, orange colored jacket draped over her shoulders, and small stud earrings, laughing broadly with an open mouth, showing white teeth, giving a joyful, warm, happy visible expression. The setting is an outdoor park environment, blurred softly out of focus behind the couple, showing tall green trees, dappled sunlight, and another person wearing a cap visible in the background. The lighting is bright and natural, consistent with dappled sunlight filtering through the trees, creating soft highlights on the couple. The color palette is warm and bright, dominated by green, blue, orange, and gray tones. The composition is a medium close up, closeup, upper body framing, with the couple positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or emotional reunion style stock video with a shallow depth of field, keeping the park background softly blurred.\",\"keyElements\":[\"trees\",\"sunlight\",\"park\",\"jacket\",\"scrub top\",\"earrings\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"dappled light\",\"warm tone\",\"reunion\",\"lifestyle\",\"man\",\"woman\",\"gray hair\",\"silver hair\",\"curly hair\",\"scrub top\",\"blue\",\"orange\",\"green\",\"trees\",\"park\",\"hug\",\"embrace\"]},{\"fileName\":\"GENERIC-HumanConnection-15.mp4\",\"description\":\"The video shows two people, one adult and one elderly man, indoors near a window. One hand, with a fair skin tone wearing a white sleeve, rests gently on the shoulder of the elderly man, giving a comforting, supportive gesture. The elderly man has a fair skin tone, short gray and white hair, and light facial stubble, wearing a top, a tan, beige colored sweater, seated in a wheelchair, with a black wheelchair armrest visible in the lower portion of the frame, looking off to the side with a calm, thoughtful visible expression, his mouth slightly open. The setting is an indoor environment near a window, showing a light colored wall, window blinds, and a blurred view of green foliage outside through the window. The lighting is soft and bright, consistent with natural daylight coming through the window, evenly illuminating the man and the comforting hand. The color palette is warm and neutral, dominated by tan, beige, white, and gray tones, with green accents from the foliage outside. The composition is an extreme close up, closeup, tight framing, focused on the shoulder, hand, and side of the man's face, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or caregiving style stock video with a shallow depth of field, keeping the window and foliage background softly blurred.\",\"keyElements\":[\"window\",\"blinds\",\"foliage\",\"wheelchair\",\"sweater color\",\"lighting\"],\"attributes\":[\"comforting\",\"supportive\",\"calm\",\"thoughtful\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"caregiving\",\"elderly\",\"senior\",\"lifestyle\",\"man\",\"wheelchair\",\"gray hair\",\"white hair\",\"tan\",\"beige\",\"hand on shoulder\",\"window\",\"foliage\",\"care\"]},{\"fileName\":\"GENERIC-HumanConnection-16.mp4\",\"description\":\"The video shows two people, one woman and one woman, two adult females, embracing closely together outdoors. One woman has a fair skin tone and long, dark brown hair, wearing a top, a tan, beige colored jacket, hugging the other woman with her back facing the camera and one arm raised outward. The other woman has a fair skin tone and long, dark brown hair, wearing a top, a navy blue colored shirt, smiling broadly with an open mouth, showing white teeth, giving a joyful, warm, happy visible expression, with her eyes nearly closed from smiling. The setting is an outdoor park environment, blurred softly out of focus behind the pair, showing tall green trees and bright, hazy backlight sunlight filtering through the leaves, creating a strong glow and soft lens flare around the women's hair. The lighting is bright and warm, consistent with strong backlight sunlight, creating a hazy, glowing atmosphere. The color palette is warm and bright, dominated by tan, beige, navy blue, and green tones, with a bright white glow from the sun. The composition is a medium close up, closeup, upper body framing, with both women positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or emotional reunion style stock video with a shallow depth of field, backlight, and lens flare, keeping the park background softly blurred.\",\"keyElements\":[\"trees\",\"park\",\"backlight\",\"lens flare\",\"jacket color\",\"shirt color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"happy\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"backlight\",\"lens flare\",\"hazy\",\"bright lighting\",\"natural light\",\"warm tone\",\"reunion\",\"lifestyle\",\"women\",\"friends\",\"tan\",\"beige\",\"navy blue\",\"trees\",\"park\",\"hug\",\"embrace\"]}]}");


var $cbda005732237afe$exports = {};
$cbda005732237afe$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-HumanNatureMacro-01.mp4\",\"description\":\"The video shows one person's hand and arm, with a fair skin tone, wearing a top, a white, cream colored knit sweater with ribbed cuffs, along with a gold ring visible on one finger. The hand is gently brushing through tall grass and wheat like plants, with fingers extended and moving through the greenery. The setting is an outdoor open field environment, showing tall green grass, wheat, and seed heads swaying, with additional blurred greenery and a hazy horizon line in the distance. The lighting is bright and warm, consistent with golden hour sunlight, with the sun visible as a bright glowing highlight in the upper right of the frame, creating a soft, hazy glow and warm highlights on the grass and hand. The color palette is warm and golden, dominated by green, tan, and gold tones, with a bright white glow from the sun. The composition is a close up, closeup, side angle framing, with the hand and arm positioned in the left portion of the frame and the grass filling the right portion. The visual style is photographic, realistic, and resembles a lifestyle or nature style stock video with a shallow depth of field and warm, golden backlighting.\",\"keyElements\":[\"grass\",\"wheat\",\"seed heads\",\"field\",\"horizon\",\"sweater color\",\"ring\",\"backlight\",\"lighting\"],\"attributes\":[\"peaceful\",\"serene\",\"candid\",\"close up\",\"closeup\",\"shallow depth of field\",\"golden hour\",\"backlight\",\"warm lighting\",\"natural light\",\"warm tone\",\"hazy\",\"nature\",\"lifestyle\",\"hand\",\"arm\",\"sweater\",\"white\",\"cream\",\"ring\",\"grass\",\"wheat\",\"field\",\"green\",\"gold\",\"sunlight\"]},{\"fileName\":\"GENERIC-HumanNatureMacro-02.mp4\",\"description\":\"The video shows one person's hand and arm, with a fair skin tone, reaching out and gently touching a patch of green moss growing on a tree trunk or rock surface. The fingers are extended, lightly brushing across the soft, textured moss. The setting is an outdoor forest or woodland environment, showing dense green moss covering a vertical surface, along with additional blurred green foliage and gray, stone colored rock in the background. The lighting is soft, cool, and diffused, consistent with shaded forest lighting, evenly illuminating the hand and moss without harsh shadows. The color palette is cool and rich, dominated by green tones in various shades, with gray accents from the rock and fair skin tones from the hand. The composition is a close up, closeup, side angle framing, with the hand positioned in the lower left portion of the frame and the moss covered surface filling the right portion. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field and a calm, natural look.\",\"keyElements\":[\"moss\",\"tree trunk\",\"rock\",\"foliage\",\"lighting\"],\"attributes\":[\"calm\",\"peaceful\",\"serene\",\"candid\",\"close up\",\"closeup\",\"shallow depth of field\",\"soft lighting\",\"cool tone\",\"natural light\",\"nature\",\"forest\",\"woodland\",\"lifestyle\",\"hand\",\"arm\",\"moss\",\"green\",\"gray\",\"rock\",\"tree\",\"foliage\",\"texture\"]},{\"fileName\":\"GENERIC-HumanNatureMacro-03.mp4\",\"description\":\"The video shows one person's hand and arm, appearing as a silhouette, reaching out and brushing through tall wildflowers and dried plants. The hand's fingers are spread and extended, moving gently through the golden colored vegetation. The setting is an outdoor open field or meadow environment, showing tall dried grass, wildflowers, and seed heads in golden and yellow tones, with additional blurred plants and a hazy, bright horizon in the background. The lighting is extremely bright and warm, consistent with strong backlight sunlight low on the horizon, creating a prominent lens flare and glowing highlight in the lower portion of the frame, and silhouetting the hand against the bright light. The color palette is warm and golden, dominated by yellow, gold, and amber tones, with a bright white and green glow from the sun and lens flare. The composition is a close up, closeup, framing, with the silhouetted hand positioned centrally in the frame against the bright, hazy field. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field, strong backlight, and lens flare.\",\"keyElements\":[\"wildflowers\",\"field\",\"meadow\",\"seed heads\",\"horizon\",\"backlight\",\"lens flare\",\"lighting\"],\"attributes\":[\"peaceful\",\"serene\",\"candid\",\"close up\",\"closeup\",\"silhouette\",\"shallow depth of field\",\"backlight\",\"lens flare\",\"golden hour\",\"warm lighting\",\"natural light\",\"warm tone\",\"hazy\",\"nature\",\"lifestyle\",\"hand\",\"arm\",\"wildflowers\",\"field\",\"meadow\",\"gold\",\"yellow\",\"amber\",\"sunlight\"]},{\"fileName\":\"GENERIC-HumanNatureMacro-04.mp4\",\"description\":\"The video shows one person's hand and arm, with a fair skin tone, wearing a top, a light blue, gray colored sleeve, reaching down from a boat and trailing fingers through calm water, creating small ripples and splashes. The setting is an outdoor lake or river environment, showing calm, rippling water reflecting warm golden light, a hazy tree lined shoreline in the distance, and the edge of a tan, beige colored boat visible on the right side of the frame with a black rope or fastening detail. The lighting is bright and warm, consistent with golden hour sunset or sunrise light, creating strong reflections, sparkling highlights on the water, and a glowing sun visible near the horizon. The color palette is warm and golden, dominated by yellow, gold, and amber tones, with cool blue gray tones in the shadowed water. The composition is a close up, closeup, side angle framing, with the hand and arm positioned in the upper right portion of the frame and the rippling water filling the rest of the frame. The visual style is photographic, realistic, and resembles a lifestyle or nature style stock video with a shallow depth of field and warm, glowing golden hour lighting.\",\"keyElements\":[\"water\",\"ripples\",\"lake\",\"shoreline\",\"trees\",\"boat\",\"rope\",\"sleeve color\",\"lighting\"],\"attributes\":[\"peaceful\",\"serene\",\"candid\",\"close up\",\"closeup\",\"shallow depth of field\",\"golden hour\",\"warm lighting\",\"natural light\",\"warm tone\",\"reflection\",\"sparkle\",\"nature\",\"lifestyle\",\"hand\",\"arm\",\"water\",\"lake\",\"ripples\",\"boat\",\"sunset\",\"sunrise\",\"gold\",\"amber\",\"blue gray\"]}]}");


var $9009528bfc17c99a$exports = {};
$9009528bfc17c99a$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-HumanAnimalMacro-01.mp4\",\"description\":\"The video shows one woman, a young adult female with dark hair, wearing a top, a gray, light gray long sleeve shirt, along with black pants, embracing a horse by wrapping her arms around its neck and resting her head against its mane, giving a calm, affectionate, peaceful visible expression. The horse is a large animal with a reddish brown, chestnut colored coat and a white blaze marking down its face, wearing a black leather halter or bridle with metal buckles. The setting is an outdoor rural countryside environment, showing an open grassy field, a wooden fence with posts in the distance, rolling hills covered in trees, and a hazy, sunlit sky. The lighting is extremely bright and warm, consistent with strong backlight sunlight low on the horizon, creating a glowing, hazy atmosphere and a soft lens flare near the horse's legs. The color palette is warm and golden, dominated by chestnut brown, tan, and gold tones, with a bright white glow from the sun. The composition is a medium shot, side angle framing, with the woman and horse positioned centrally in the frame against the open field. The visual style is photographic, realistic, and resembles a lifestyle or equestrian style stock video with a warm, golden hour glow and a moderate depth of field.\",\"keyElements\":[\"field\",\"fence\",\"hills\",\"trees\",\"sky\",\"halter\",\"bridle\",\"backlight\",\"lens flare\",\"lighting\"],\"attributes\":[\"calm\",\"affectionate\",\"peaceful\",\"candid\",\"medium shot\",\"golden hour\",\"backlight\",\"lens flare\",\"warm lighting\",\"natural light\",\"warm tone\",\"hazy\",\"equestrian\",\"lifestyle\",\"woman\",\"horse\",\"chestnut\",\"brown\",\"halter\",\"bridle\",\"field\",\"fence\",\"hills\",\"countryside\",\"embrace\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-02.mp4\",\"description\":\"The video shows one man, an adult male with a tan skin tone and short dark hair, along with light facial stubble, wearing eyeglasses, thin wire framed eyeglasses, and a top, a green, olive colored sweater, along with blue denim jeans, smiling gently and looking downward at a dog, giving a warm, affectionate, calm visible expression, while holding a tablet, a black colored tablet computer, on his lap. The dog is a small animal with a tan, cream colored coat and floppy ears, sitting on the man's lap and looking upward at the man's face. The setting is an indoor living room environment, showing a gray sofa, a tan and cream colored patterned throw pillow, a green potted plant with large leaves, and a plain light gray wall in the background. The lighting is soft, bright, and neutral, consistent with even indoor lighting, evenly illuminating the man and dog without harsh shadows. The color palette is warm and neutral, dominated by green, tan, gray, and cream tones. The composition is a medium close up, closeup, upper body framing, with the man and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.\",\"keyElements\":[\"sofa\",\"throw pillow\",\"potted plant\",\"wall\",\"tablet\",\"sweater color\",\"eyeglasses\",\"lighting\"],\"attributes\":[\"warm\",\"affectionate\",\"calm\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"pet\",\"lifestyle\",\"man\",\"dog\",\"eyeglasses\",\"glasses\",\"green\",\"sweater\",\"tablet\",\"sofa\",\"plant\",\"throw pillow\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-03.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone and long, dark brown curly hair, wearing a top, a yellow button up shirt, along with white pants, kneeling on the floor and playing with two dogs, giving a joyful, warm, playful visible expression, with her mouth open in a smile. The two dogs are animals with a reddish brown, ginger colored coat, pointed ears, and curled tails, characteristic of a Shiba Inu breed, standing on their hind legs and interacting with the woman, one wearing a red collar. The setting is an indoor living room environment, showing a dark blue, navy colored wall, a black bookshelf holding books and small decorative objects, a light blue sofa with patterned throw pillows, a floor lamp with a white lampshade, sheer white curtains, and a framed abstract art print on the wall. The lighting is soft, bright, and natural, consistent with daylight coming through the curtains, evenly illuminating the scene. The color palette is warm and rich, dominated by navy blue, yellow, orange, and tan tones. The composition is a medium wide shot, full body framing, with the woman and dogs positioned across the frame in dynamic motion. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a bright, playful look and a moderate depth of field.\",\"keyElements\":[\"wall\",\"bookshelf\",\"books\",\"sofa\",\"throw pillows\",\"floor lamp\",\"curtains\",\"framed art print\",\"collar\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"playful\",\"candid\",\"action\",\"wide shot\",\"full body\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"warm tone\",\"pet\",\"lifestyle\",\"woman\",\"dogs\",\"shiba inu\",\"curly hair\",\"yellow\",\"navy blue\",\"bookshelf\",\"sofa\",\"curtains\",\"lamp\",\"collar\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-04.mp4\",\"description\":\"The video shows one person, an adult with a fair skin tone, wearing a top, a white t-shirt, along with light blue denim jeans and white sneakers, walking through a grassy area while holding a leash attached to a dog, viewed from behind. The dog is a medium sized animal with a black and tan, brown colored coat and a white blaze on its face, walking ahead of the person through the tall grass. The setting is an outdoor pine forest or woodland environment, showing tall green grass and wild seed heads swaying, rows of tall, slender pine tree trunks, and a hazy, bright, sunlit clearing visible in the distance between the trees. The lighting is bright and warm, consistent with golden hour sunlight filtering through the trees, creating a hazy, glowing backlight effect. The color palette is warm and natural, dominated by green, tan, brown, and gold tones, with a bright white and gold glow from the sun. The composition is a medium shot, low angle framing, with the person and dog positioned in the upper right portion of the frame and the tall grass filling the foreground. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a warm, golden hour glow and a moderate depth of field.\",\"keyElements\":[\"grass\",\"seed heads\",\"pine trees\",\"forest\",\"clearing\",\"leash\",\"jeans color\",\"backlight\",\"lighting\"],\"attributes\":[\"peaceful\",\"candid\",\"medium shot\",\"low angle\",\"golden hour\",\"backlight\",\"warm lighting\",\"natural light\",\"warm tone\",\"hazy\",\"nature\",\"pet\",\"lifestyle\",\"dog\",\"leash\",\"walk\",\"pine trees\",\"forest\",\"grass\",\"green\",\"gold\",\"jeans\",\"denim\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-05.mp4\",\"description\":\"The video shows two people, one man and one girl, indoors interacting with a cat. The man is an adult male with a fair skin tone and short, gray and dark hair, along with light facial stubble, wearing a top, a green, teal colored sweater, smiling broadly, giving a warm, joyful, affectionate visible expression, while holding a treat up to the cat. The girl is a young child with a fair skin tone and light brown hair styled in a ponytail, wearing a top, a pink, white colored shirt patterned with small dogs, looking downward with a calm, curious visible expression. The cat is an animal with a long, fluffy white and gray colored coat, being held by the man, reaching toward the treat with one paw extended. The setting is an indoor home environment, showing a plain light gray wall, a framed picture partially visible on the left side of the frame, and a light colored blurred object in the foreground. The lighting is soft, bright, and neutral, consistent with even indoor lighting, evenly illuminating the group. The color palette is warm and neutral, dominated by teal, pink, white, and gray tones. The composition is a medium close up, closeup, upper body framing, with all three positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.\",\"keyElements\":[\"wall\",\"framed picture\",\"treat\",\"sweater color\",\"shirt pattern\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"affectionate\",\"curious\",\"calm\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"warm tone\",\"pet\",\"family\",\"lifestyle\",\"man\",\"girl\",\"cat\",\"fluffy\",\"white\",\"gray hair\",\"teal\",\"pink\",\"treat\",\"ponytail\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-06.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone and blonde hair, wearing a white wristwatch, reaching up and gently touching the nose and muzzle of a horse, giving a calm, affectionate, gentle visible expression, with her head tilted upward toward the animal. The horse is a large animal with a dark brown, chestnut colored coat and a black mane, along with a white blaze marking down its face and long white whiskers visible on its muzzle. The setting is an indoor stable or barn environment, showing a wooden stall structure, a tan colored wall, a bright window letting in natural light, and a light colored curtain or fabric hanging nearby. The lighting is soft and warm, consistent with natural light filtering through the window combined with ambient barn lighting, creating gentle highlights on the horse's coat. The color palette is warm and rich, dominated by chestnut brown, tan, and black tones. The composition is an extreme close up, closeup, tight framing, with the horse's head filling the left portion of the frame and the woman's hand and face visible on the right side. The visual style is photographic, realistic, and resembles a lifestyle or equestrian style stock video with a shallow depth of field and warm, natural lighting.\",\"keyElements\":[\"stall\",\"wall\",\"window\",\"curtain\",\"wristwatch\",\"lighting\"],\"attributes\":[\"calm\",\"affectionate\",\"gentle\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"soft lighting\",\"natural light\",\"warm tone\",\"equestrian\",\"lifestyle\",\"woman\",\"horse\",\"chestnut\",\"brown\",\"blonde hair\",\"stable\",\"barn\",\"muzzle\",\"wristwatch\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-07.mp4\",\"description\":\"The video shows one person's hand and arm, with a fair skin tone, wearing a top, a light gray, lavender colored ribbed knit sweater, gently stroking and holding a cat close to their body. The cat is an animal with a gray and black striped, tabby colored coat, with its eyes closed, giving a calm, relaxed, content visible expression, resting its head on the person's arm. The setting is an indoor home environment, showing a plain, blurred background with soft, muted tones. The lighting is soft, warm, and diffused, consistent with indoor ambient lighting, evenly illuminating the cat and the person's arm. The color palette is soft and neutral, dominated by gray, lavender, and white tones. The composition is an extreme close up, closeup, tight framing, focused on the cat's face and the person's arm and sweater sleeve, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field and soft, gentle lighting.\",\"keyElements\":[\"background\",\"sweater color\",\"lighting\"],\"attributes\":[\"calm\",\"relaxed\",\"content\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"soft lighting\",\"natural light\",\"warm tone\",\"pet\",\"lifestyle\",\"cat\",\"tabby\",\"gray\",\"lavender\",\"sweater\",\"knit\",\"sleeping\",\"stroking\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-08.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone and long, wavy light brown hair, wearing a top, a yellow, mustard colored knit sweater, along with a wristwatch and rings on her fingers, lying on a sofa and cuddling with a dog, giving a warm, joyful, affectionate visible expression, with a soft smile. The dog is a medium to large sized animal with a golden, cream colored coat, characteristic of a Golden Retriever breed, resting its head near the woman's face with its mouth slightly open. The setting is an indoor living room environment, showing a brown corduroy textured sofa, a light gray sofa with a teal, blue throw pillow and a red, orange throw pillow in the background, and a bright window letting in natural light with green foliage visible outside. The lighting is bright and natural, consistent with daylight coming through the window, evenly illuminating the woman and dog. The color palette is warm and rich, dominated by yellow, mustard, gold, and brown tones, with teal and red accents from the throw pillows. The composition is a medium close up, closeup, upper body framing, with the woman and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.\",\"keyElements\":[\"sofa\",\"throw pillow\",\"window\",\"foliage\",\"wristwatch\",\"rings\",\"sweater color\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"affectionate\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"warm tone\",\"pet\",\"lifestyle\",\"woman\",\"dog\",\"golden retriever\",\"yellow\",\"mustard\",\"gold\",\"sofa\",\"throw pillow\",\"teal\",\"red\",\"window\",\"wavy hair\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-09.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone, wearing a helmet, a gray colored riding helmet with a chin strap, and black leather gloves, reaching out and gently touching the nose of a horse with her gloved hand, giving a calm, affectionate, gentle visible expression, with a soft smile. The horse is a large animal with a reddish brown, chestnut colored coat, wearing a black leather bridle with a metal ring and buckle detail near its muzzle. The setting is an outdoor equestrian environment, blurred softly out of focus behind the pair, showing green pine trees and a light colored fence or barrier. The lighting is soft and natural, consistent with overcast outdoor daylight, evenly illuminating the woman and horse without harsh shadows. The color palette is warm and neutral, dominated by chestnut brown, black, gray, and green tones. The composition is an extreme close up, closeup, tight framing, with the horse's muzzle filling the left portion of the frame and the woman's hand and face visible on the right side. The visual style is photographic, realistic, and resembles a lifestyle or equestrian style stock video with a shallow depth of field, keeping the background softly blurred.\",\"keyElements\":[\"trees\",\"fence\",\"bridle\",\"helmet\",\"gloves\",\"lighting\"],\"attributes\":[\"calm\",\"affectionate\",\"gentle\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"blurred background\",\"soft lighting\",\"natural light\",\"overcast\",\"warm tone\",\"equestrian\",\"lifestyle\",\"woman\",\"horse\",\"chestnut\",\"brown\",\"helmet\",\"gloves\",\"bridle\",\"trees\",\"muzzle\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-10.mp4\",\"description\":\"The video shows a compilation of several distinct extreme macro nature shots edited together, with no people visible throughout. The video opens with pale pink and white flower blossoms, resembling apricot or cherry blossoms, with yellow stamens, dark red buds, and thin brown branches, set against a bright turquoise, blue colored background. The video transitions to a pair of orange, red colored ants walking along a dark brown tree branch against a blurred green background. The video then shows a time lapse of white, fuzzy mold or fungus growing and spreading across a dark brown surface. The video continues with a honeybee, an insect with a black and gold striped body and translucent wings, hovering near light purple, lavender colored daisy flowers with yellow centers, set against a blurred dark green background. The video then shows a backlit cross section of a kiwi fruit, displaying bright green flesh, a pale yellow center, and a ring of small black seeds. The video continues with raindrops falling and streaming off a bright green leaf against a dark green blurred background. The video then shows an extreme close up of a chameleon, a reptile with brightly colored scaled skin in red, green, orange, and turquoise patterns, gripping a branch with clawed feet. The video concludes with a backlit macro shot of a green leaf, displaying its intricate vein structure with small insects visible walking along the central vein. The lighting varies across segments, including bright natural daylight, soft diffused light, and strong backlighting that creates glowing, translucent effects on the flowers, fruit, and leaves. The color palette is vibrant and varied, spanning turquoise, pink, green, orange, gold, and red tones across the different segments. The composition is consistently an extreme close up, closeup, macro framing throughout, with each subject filling most of the frame. The visual style is photographic, realistic, and resembles a nature or wildlife documentary style stock video with a shallow depth of field and detailed macro focus throughout.\",\"keyElements\":[\"flower blossoms\",\"branch\",\"mold\",\"fungus\",\"bee\",\"daisy flowers\",\"kiwi fruit\",\"raindrops\",\"leaf\",\"chameleon\",\"leaf veins\",\"lighting\"],\"attributes\":[\"vibrant\",\"colorful\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"backlight\",\"natural light\",\"soft lighting\",\"time lapse\",\"documentary\",\"wildlife\",\"nature\",\"compilation\",\"montage\",\"flower\",\"blossom\",\"ant\",\"insect\",\"mold\",\"fungus\",\"bee\",\"honeybee\",\"daisy\",\"purple\",\"kiwi\",\"fruit\",\"seeds\",\"raindrops\",\"leaf\",\"chameleon\",\"reptile\",\"turquoise\",\"pink\",\"green\",\"gold\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-11.mp4\",\"description\":\"The video shows one man, an adult male with a fair skin tone and long, dark brown wavy hair, along with a full, thick dark beard, wearing eyeglasses, dark rimmed eyeglasses, and a top, a blue, teal colored button up shirt with rolled sleeves over a mustard, orange colored t-shirt, along with dark pants, sitting on a sofa and reaching out to pet a dog, giving a warm, joyful, affectionate visible expression, with a broad smile. The dog is a medium sized animal with a tan, cream colored coat and floppy ears, standing on the sofa cushions next to the man. The setting is an indoor living room environment, showing a light gray sofa with a teal, blue throw pillow, tall windows with sheer white curtains and brown drapes, a dark metal shelving unit holding stacked books and a small globe, vinyl records displayed on the wall, and a wood coffee table in the foreground. The lighting is bright and natural, consistent with daylight coming through the windows, evenly illuminating the man and dog. The color palette is warm and rich, dominated by teal, mustard, tan, and brown tones. The composition is a medium wide shot, full body framing, with the man and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a bright, casual look and a moderate depth of field.\",\"keyElements\":[\"sofa\",\"throw pillow\",\"windows\",\"curtains\",\"shelving unit\",\"books\",\"globe\",\"vinyl records\",\"coffee table\",\"shirt color\",\"eyeglasses\",\"lighting\"],\"attributes\":[\"warm\",\"joyful\",\"affectionate\",\"candid\",\"wide shot\",\"full body\",\"moderate depth of field\",\"bright lighting\",\"natural light\",\"warm tone\",\"casual\",\"pet\",\"lifestyle\",\"man\",\"dog\",\"beard\",\"eyeglasses\",\"glasses\",\"teal\",\"mustard\",\"sofa\",\"throw pillow\",\"windows\",\"shelving\",\"vinyl records\",\"coffee table\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-12.mp4\",\"description\":\"The video shows one woman, a young adult female with a fair skin tone and long, light brown wavy hair styled in a ponytail, wearing a top, a pink, blush colored long sleeve shirt, along with blue denim jeans, sitting on the floor and playing with a dog, giving a joyful, warm, playful visible expression, with her eyes closed and a broad smile. The dog is a medium sized animal with a reddish brown and white colored coat, characteristic of a Nova Scotia Duck Tolling Retriever breed, standing on its hind legs with its front paws resting on the woman's shoulders, mouth open. The setting is an indoor living room environment, blurred softly out of focus behind the pair, showing a light gray sectional sofa with tan throw pillows, a bright window with sheer curtains, a small vase of yellow flowers, and light wood flooring. The lighting is bright and natural, consistent with daylight coming through the window, evenly illuminating the woman and dog. The color palette is warm and bright, dominated by pink, reddish brown, white, and tan tones. The composition is a medium close up, closeup, upper body framing, with the woman and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.\",\"keyElements\":[\"sofa\",\"throw pillows\",\"window\",\"curtains\",\"vase\",\"flowers\",\"wood flooring\",\"shirt color\",\"lighting\"],\"attributes\":[\"joyful\",\"warm\",\"playful\",\"candid\",\"portrait\",\"close up\",\"closeup\",\"medium close up\",\"shallow depth of field\",\"blurred background\",\"bright lighting\",\"natural light\",\"warm tone\",\"pet\",\"lifestyle\",\"woman\",\"dog\",\"retriever\",\"pink\",\"reddish brown\",\"white\",\"sofa\",\"throw pillow\",\"window\",\"flowers\",\"ponytail\"]},{\"fileName\":\"GENERIC-HumanAnimalMacro-13.mp4\",\"description\":\"The video shows two animals, one dog and one cat, resting closely together indoors, with no people visible. The dog is an animal with a brown and white colored coat and long, floppy ears, resting its head near the cat, with dark brown eyes looking toward the camera, giving a calm, relaxed visible expression. The cat is an animal with a gray and white striped, tabby colored coat, lying with its eyes closed and one paw extended outward, giving a calm, peaceful, sleepy visible expression, resting its head against a woven basket edge. The setting is an indoor home environment, showing a brown and orange patterned fabric or blanket underneath the animals, a woven, wicker textured basket or bed frame, and a tan colored wall with visible texture or peeling paint in the background. The lighting is soft and warm, consistent with indoor ambient lighting, evenly illuminating the two animals. The color palette is warm and earthy, dominated by brown, tan, gray, and orange tones. The composition is an extreme close up, closeup, tight framing, with both animals filling most of the frame, positioned closely together. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field and soft, warm lighting.\",\"keyElements\":[\"blanket\",\"fabric\",\"basket\",\"wall\",\"lighting\"],\"attributes\":[\"calm\",\"relaxed\",\"peaceful\",\"sleepy\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"soft lighting\",\"warm tone\",\"earthy tone\",\"pet\",\"lifestyle\",\"dog\",\"cat\",\"tabby\",\"brown\",\"gray\",\"white\",\"basket\",\"blanket\",\"resting\",\"sleeping\"]}]}");


var $157600acb13f5ef9$exports = {};
$157600acb13f5ef9$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-NatureWater-01.mp4\",\"description\":\"The video shows an aerial view from above a thick layer of clouds at sunset or sunrise. The clouds are dense, white, and gray, with soft, billowing, cotton like textures filling the lower two thirds of the frame. The sun is positioned low on the horizon, partially hidden behind a cluster of clouds, creating a bright yellow, gold glow that radiates outward and illuminates the undersides of scattered clouds in the upper portion of the frame with pink, orange, and red tones. The sky above the cloud layer is a light blue, pale blue color, transitioning to soft pastel hues near the horizon. The lighting is bright and warm at the horizon, transitioning to cooler, softer tones higher in the sky, consistent with golden hour lighting during sunset or sunrise. The color palette is warm and vibrant near the horizon, dominated by gold, orange, pink, and red tones, transitioning to cool blue and gray tones in the upper sky and cloud layer. The composition is a wide, expansive aerial shot, with the horizon line positioned in the lower third of the frame and the sky filling the upper two thirds. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and dramatic, atmospheric lighting.\",\"keyElements\":[\"clouds\",\"sun\",\"horizon\",\"sky\",\"lighting\"],\"attributes\":[\"dramatic\",\"atmospheric\",\"peaceful\",\"serene\",\"aerial\",\"wide shot\",\"golden hour\",\"sunset\",\"sunrise\",\"warm lighting\",\"natural light\",\"warm tone\",\"cool tone\",\"nature\",\"travel\",\"sky\",\"clouds\",\"sun\",\"gold\",\"orange\",\"pink\",\"blue\",\"horizon\",\"above clouds\"]},{\"fileName\":\"GENERIC-NatureWater-02.mp4\",\"description\":\"The video shows an aerial view flying directly through a dense layer of billowing clouds. The clouds are thick, soft, and voluminous, filling almost the entire frame with rolling, cotton like formations. The clouds are illuminated with a soft pink, lavender, and peach colored glow, consistent with sunset or sunrise lighting, with brighter golden light visible in gaps between the cloud formations near the horizon line in the upper portion of the frame. The color palette is soft and pastel, dominated by lavender, pink, peach, and soft gold tones, with darker gray shadow areas within the deeper folds of the clouds. The lighting is soft and diffused, coming from a low sun angle, creating gentle highlights on the cloud tops and softer, shadowed tones within the cloud formations. The composition is a wide, immersive aerial shot, with clouds filling the entire frame and a small glimpse of a hazy horizon visible in the upper background. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a dreamy, atmospheric look and a wide depth of field.\",\"keyElements\":[\"clouds\",\"horizon\",\"lighting\"],\"attributes\":[\"dreamy\",\"atmospheric\",\"peaceful\",\"serene\",\"aerial\",\"wide shot\",\"sunset\",\"sunrise\",\"soft lighting\",\"natural light\",\"pastel tone\",\"warm tone\",\"nature\",\"travel\",\"clouds\",\"lavender\",\"pink\",\"peach\",\"gold\",\"sky\",\"immersive\"]},{\"fileName\":\"GENERIC-NatureWater-03.mp4\",\"description\":\"The video shows a close up view of the surface of open ocean water, with rolling waves and ripples moving across the frame. The water is a deep blue, navy colored tone in the shadowed areas, transitioning to a bright, warm gold and amber color where sunlight reflects off the crests of the waves in the lower right portion of the frame. The texture of the water is textured and choppy, showing small ripples and foam along the wave crests. The lighting is bright and warm where the sunlight hits the water directly, creating sparkling, glowing highlights, while the rest of the water remains in cooler, shadowed blue tones. The color palette contrasts warm and cool tones, dominated by navy blue, teal, and gold tones. The composition is a close up, closeup, high angle framing, looking down at the water's surface, with the frame filled entirely by the textured water. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a shallow depth of field and dramatic lighting contrast between warm and cool tones.\",\"keyElements\":[\"waves\",\"ripples\",\"foam\",\"sunlight reflection\",\"lighting\"],\"attributes\":[\"dramatic\",\"peaceful\",\"candid\",\"close up\",\"closeup\",\"high angle\",\"shallow depth of field\",\"warm lighting\",\"natural light\",\"warm tone\",\"cool tone\",\"contrast\",\"nature\",\"ocean\",\"sea\",\"water\",\"waves\",\"navy blue\",\"teal\",\"gold\",\"amber\",\"ripples\",\"sparkle\"]},{\"fileName\":\"GENERIC-NatureWater-04.mp4\",\"description\":\"The video shows a close up view of raindrops streaming down the outside of a glass window pane. Numerous individual water droplets of varying sizes cling to the glass, while thin, winding streaks of water trail downward from some droplets, forming vertical rivulets. The background visible through the glass is blurred and out of focus, showing a soft gradient from a light beige, cream colored glow in the upper portion of the frame to a dark, near black tone in the lower and side portions of the frame. The lighting is soft and diffused, consistent with an overcast or dim ambient light source behind the glass, creating a moody, atmospheric contrast between the bright upper area and the dark surroundings. The color palette is monochromatic and moody, dominated by black, gray, and cream tones. The composition is an extreme close up, closeup, full frame shot, with raindrops and water streaks covering the entire visible glass surface. The visual style is photographic, realistic, and resembles a moody or atmospheric weather style stock video with a shallow depth of field and dramatic, high contrast lighting.\",\"keyElements\":[\"glass window\",\"raindrops\",\"water streaks\",\"background glow\",\"lighting\"],\"attributes\":[\"moody\",\"atmospheric\",\"dramatic\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"shallow depth of field\",\"high contrast\",\"dim lighting\",\"monochromatic\",\"dark tone\",\"weather\",\"rain\",\"nature\",\"window\",\"glass\",\"raindrops\",\"water\",\"streaks\",\"black\",\"gray\",\"cream\"]},{\"fileName\":\"GENERIC-NatureWater-05.mp4\",\"description\":\"The video shows a dramatic sky filled with dense, dark storm clouds, viewed from below looking upward. The clouds are thick and voluminous, in varying shades of dark gray, blue gray, and white, with a small patch of deep blue sky visible breaking through the clouds in the upper portion of the frame. The clouds appear turbulent and heavy, suggesting an approaching storm, with darker, denser cloud formations in the lower portion of the frame and lighter, brighter cloud edges catching diffused sunlight in the middle and upper portions. The lighting is soft and diffused, filtering through the thick cloud cover, creating subtle highlights on the cloud edges while the overall scene remains moody and subdued. The color palette is cool and muted, dominated by gray, blue gray, and white tones, with a small patch of deep blue visible through the clouds. The composition is a wide, expansive shot, looking directly upward, with clouds filling the entire frame. The visual style is photographic, realistic, and resembles a weather or nature style stock video with a wide depth of field and a moody, dramatic atmosphere.\",\"keyElements\":[\"storm clouds\",\"sky\",\"lighting\"],\"attributes\":[\"dramatic\",\"moody\",\"turbulent\",\"wide shot\",\"low angle\",\"diffused lighting\",\"natural light\",\"cool tone\",\"muted tone\",\"weather\",\"storm\",\"nature\",\"clouds\",\"gray\",\"blue gray\",\"white\",\"blue sky\",\"atmospheric\"]},{\"fileName\":\"GENERIC-NatureWater-06.mp4\",\"description\":\"The video shows a top down view of calm, shallow water with a pale, light turquoise, blue green color. The water's surface displays subtle ripples and concentric circular rings expanding outward from a central point, suggesting something recently disturbed the water's surface. A small, dark, indistinct shape or shadow is visible beneath the surface near the center of the ripples. The lighting is bright and even, consistent with overhead natural daylight, creating a soft, glowing, uniform illumination across the water's surface with minimal shadow. The color palette is soft and pale, dominated by light turquoise, pale blue, and white tones. The composition is a direct overhead, top down shot, with the rippling water filling the entire frame. The visual style is photographic, realistic, and resembles a nature or wellness style stock video with a calm, serene, minimal aesthetic and a wide depth of field.\",\"keyElements\":[\"water surface\",\"ripples\",\"shadow shape\",\"lighting\"],\"attributes\":[\"calm\",\"peaceful\",\"serene\",\"minimal\",\"overhead\",\"top down\",\"bright lighting\",\"natural light\",\"pale tone\",\"soft tone\",\"nature\",\"wellness\",\"water\",\"ripples\",\"turquoise\",\"pale blue\",\"white\",\"shallow water\"]},{\"fileName\":\"GENERIC-NatureWater-07.mp4\",\"description\":\"The video shows an aerial drone view looking directly down at ocean water with active waves and white foam. The water is a rich teal, turquoise color, with multiple wave crests breaking and creating intricate patterns of white sea foam and bubbles that spread across the dark blue green water in swirling, lace like formations. The composition shows varying depths of water color, from lighter, brighter teal in areas of foam and turbulence to darker, deeper navy blue in calmer patches. The lighting is bright and even, consistent with overhead daylight, creating natural highlights on the wave crests and foam. The color palette is cool and vibrant, dominated by teal, turquoise, navy blue, and white tones. The composition is a direct overhead, top down aerial shot, with the textured, foamy ocean water filling the entire frame. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a dynamic, textured aesthetic.\",\"keyElements\":[\"ocean waves\",\"foam\",\"water texture\",\"lighting\"],\"attributes\":[\"dynamic\",\"textured\",\"aerial\",\"overhead\",\"top down\",\"bright lighting\",\"natural light\",\"cool tone\",\"vibrant\",\"nature\",\"travel\",\"ocean\",\"sea\",\"waves\",\"foam\",\"teal\",\"turquoise\",\"navy blue\",\"white\",\"water\"]}]}");


var $7230dc2917e24532$exports = {};
$7230dc2917e24532$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-NatureLandscape-01.mp4\",\"description\":\"The video shows an aerial drone view looking down at a winding mountain road that curves and loops through a valley. The road is a light gray, paved surface with visible lane markings, curving in sharp switchback turns through rolling hills covered in autumn colored vegetation, including orange, gold, and rust colored grass and shrubs, along with clusters of dark green pine trees and golden yellow larch trees. In the upper right portion of the frame, steep gray rock cliffs and mountainsides rise sharply, with patches of green pine trees clinging to the slopes. Small wood cabins or chalets with dark roofs are scattered across the landscape, along with a small pond visible on the right side. The lighting is warm and golden, consistent with early morning or late afternoon sunlight, with a bright lens flare visible in the upper left portion of the frame where the sun is positioned low near the horizon. The color palette is warm and rich, dominated by orange, gold, rust, and green tones, with gray from the road and rock cliffs. The composition is a wide, expansive aerial shot, looking down at an angle, with the winding road curving diagonally across the frame. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and warm, golden hour lighting.\",\"keyElements\":[\"road\",\"hills\",\"trees\",\"cliffs\",\"cabins\",\"pond\",\"lens flare\",\"lighting\"],\"attributes\":[\"scenic\",\"expansive\",\"aerial\",\"wide shot\",\"golden hour\",\"warm lighting\",\"natural light\",\"warm tone\",\"lens flare\",\"autumn\",\"fall\",\"travel\",\"nature\",\"road\",\"mountain\",\"winding road\",\"orange\",\"gold\",\"green\",\"cliffs\",\"cabins\",\"trees\",\"larch\",\"pine\"]},{\"fileName\":\"GENERIC-NatureLandscape-02.mp4\",\"description\":\"The video shows an aerial drone view of a steep, lush green mountain ridge overlooking the ocean. The ridge is covered in dense green vegetation, shrubs, and trees, with exposed gray, tan colored rock visible on a cliff face in the left foreground. The mountainside slopes steeply downward toward a flat coastal plain in the distance, showing patches of green agricultural fields and small structures near the shoreline. The ocean is visible in the upper right portion of the frame, a deep blue color with white waves breaking near the coastline. The sky above is light blue with soft white clouds scattered across it. The lighting is bright and natural, consistent with daytime sunlight, creating strong highlights on the ridge tops and softer shadows in the valleys between ridges. The color palette is vibrant and rich, dominated by green, blue, and tan tones. The composition is a wide, expansive aerial shot, with the mountain ridge filling the left and lower portions of the frame and the ocean and sky filling the upper right portion. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and bright, natural lighting.\",\"keyElements\":[\"ridge\",\"rock cliff\",\"vegetation\",\"ocean\",\"coastline\",\"fields\",\"clouds\",\"lighting\"],\"attributes\":[\"scenic\",\"expansive\",\"aerial\",\"wide shot\",\"bright lighting\",\"natural light\",\"vibrant\",\"tropical\",\"travel\",\"nature\",\"mountain\",\"ridge\",\"ocean\",\"green\",\"blue\",\"tan\",\"cliff\",\"coastline\",\"clouds\"]},{\"fileName\":\"GENERIC-NatureLandscape-03.mp4\",\"description\":\"The video shows an aerial drone view looking down at a dense pine forest filling a mountain valley, with thick fog or mist drifting between and above the treetops. The trees are tall, dark green pine and fir trees, densely packed together, with the tops of individual trees visible poking through patches of fog in the foreground. The fog is illuminated with a warm, golden, amber glow in the center of the frame, suggesting sunlight filtering through the mist, while the fog appears cooler and grayer toward the edges of the frame. Additional forested hills and ridges are visible in the background, partially obscured by haze. The lighting is soft and diffused, consistent with early morning light filtering through fog, creating a warm glow in the central valley area while the surrounding forest remains in cooler, muted tones. The color palette is moody and atmospheric, dominated by dark green, gray, and warm amber tones. The composition is a wide, expansive aerial shot, looking down at an angle, with fog and treetops filling the entire frame. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a moody, atmospheric look.\",\"keyElements\":[\"pine forest\",\"trees\",\"fog\",\"mist\",\"valley\",\"hills\",\"lighting\"],\"attributes\":[\"moody\",\"atmospheric\",\"scenic\",\"aerial\",\"wide shot\",\"soft lighting\",\"natural light\",\"warm tone\",\"cool tone\",\"misty\",\"foggy\",\"travel\",\"nature\",\"forest\",\"pine trees\",\"fog\",\"mist\",\"green\",\"amber\",\"gray\",\"valley\"]},{\"fileName\":\"GENERIC-NatureLandscape-04.mp4\",\"description\":\"The video shows an aerial view of several wind turbines positioned across rolling hills at sunset. The wind turbines are tall, white colored structures with three long blades each, standing atop grassy, green and brown colored hills covered in low shrubs and vegetation. One large wind turbine is positioned prominently in the right foreground, with its blades angled diagonally across the frame, while additional turbines are visible receding into the distance on the left side of the frame. The sky above is filled with dramatic clouds in gray and white tones, with the sun positioned low near the horizon on the right side, creating a bright golden glow and a strong lens flare that radiates across the lower right portion of the frame. The lighting is warm and dramatic, consistent with sunset lighting, creating silhouetted effects on the turbines and hills against the bright sky. The color palette is warm and rich, dominated by gold, orange, and amber tones near the horizon, transitioning to cooler gray and blue tones in the upper sky. The composition is a wide, expansive aerial shot, with the turbines positioned across the middle of the frame and the dramatic sky filling the upper portion. The visual style is photographic, realistic, and resembles an energy or environmental style stock video with a wide depth of field and dramatic, warm sunset lighting.\",\"keyElements\":[\"wind turbines\",\"hills\",\"clouds\",\"sky\",\"lens flare\",\"lighting\"],\"attributes\":[\"scenic\",\"dramatic\",\"expansive\",\"aerial\",\"wide shot\",\"sunset\",\"golden hour\",\"warm lighting\",\"natural light\",\"warm tone\",\"lens flare\",\"energy\",\"renewable energy\",\"environmental\",\"nature\",\"wind turbine\",\"windmill\",\"hills\",\"clouds\",\"sky\",\"gold\",\"orange\"]},{\"fileName\":\"GENERIC-NatureLandscape-05.mp4\",\"description\":\"The video shows an aerial drone view looking directly down at ocean waves washing onto a sandy beach. The ocean water is a rich turquoise, teal color in the upper portion of the frame, transitioning to a bright white as waves break and create sea foam along the shoreline. The wet sand is a light tan, beige color, showing dark, textured patterns and rivulets left behind by receding waves in the lower portion of the frame. The wave breaks in a long, curving line diagonally across the middle of the frame, separating the ocean from the beach. The lighting is bright and even, consistent with clear daytime sunlight, creating sparkling highlights on the water and foam. The color palette is vibrant and bright, dominated by turquoise, teal, white, and tan tones. The composition is a direct overhead, top down aerial shot, with the ocean filling the upper portion of the frame and the sandy beach filling the lower portion. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and bright, vibrant coastal lighting.\",\"keyElements\":[\"ocean\",\"waves\",\"foam\",\"beach\",\"sand\",\"lighting\"],\"attributes\":[\"scenic\",\"vibrant\",\"aerial\",\"overhead\",\"top down\",\"bright lighting\",\"natural light\",\"coastal\",\"travel\",\"nature\",\"ocean\",\"waves\",\"foam\",\"beach\",\"sand\",\"turquoise\",\"teal\",\"white\",\"tan\"]},{\"fileName\":\"GENERIC-NatureLandscape-06.mp4\",\"description\":\"The video shows an aerial drone view of a misty countryside landscape at sunrise, featuring a calm pond surrounded by grassy hills and trees. The pond has a smooth, glassy, gray green colored surface, reflecting the surrounding vegetation, and is bordered by tall grass and reeds. Rolling green hills covered in grass and clusters of trees extend into the background, with a dense forest visible along the edges of the frame. Thick fog or mist rises from the fields and drifts between the trees, illuminated by bright golden sunlight streaming through gaps in the tree line in the upper left portion of the frame, creating visible sun rays or god rays. The lighting is soft, warm, and atmospheric, consistent with early morning sunrise light filtering through mist, creating a glowing, hazy effect. The color palette is warm and soft, dominated by green, gold, and amber tones, with gray green from the pond water. The composition is a wide, expansive aerial shot, looking down at an angle, with the pond positioned in the lower right portion of the frame and the misty, sunlit fields filling the upper portion. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a warm, atmospheric, dreamy look.\",\"keyElements\":[\"pond\",\"hills\",\"trees\",\"fog\",\"mist\",\"sun rays\",\"lighting\"],\"attributes\":[\"scenic\",\"atmospheric\",\"dreamy\",\"expansive\",\"aerial\",\"wide shot\",\"sunrise\",\"golden hour\",\"soft lighting\",\"natural light\",\"warm tone\",\"misty\",\"foggy\",\"sun rays\",\"travel\",\"nature\",\"pond\",\"hills\",\"trees\",\"green\",\"gold\",\"fog\",\"mist\"]},{\"fileName\":\"GENERIC-NatureLandscape-07.mp4\",\"description\":\"The video shows a ground level view of a calm lake at sunrise, with a low lying layer of mist or fog hovering just above the water's surface. The lake water is a soft pink, peach colored tone, reflecting the warm sky above, with gentle ripples visible on the surface. A line of dense trees, including a drooping willow tree on the left side of the frame, borders the far shore of the lake, appearing as dark silhouettes against the warm, hazy sky. Rolling hills and distant mountains are visible in the background, softened by atmospheric haze. The lighting is warm and soft, consistent with early morning sunrise light, creating a glowing, hazy pink and gold atmosphere throughout the scene. The color palette is warm and soft, dominated by pink, peach, gold, and muted green tones. The composition is a wide, horizontal shot, with the tree line and mountains positioned in the upper third of the frame and the misty lake water filling the lower two thirds. The visual style is photographic, realistic, and resembles a nature or travel style stock video with a wide depth of field and a soft, dreamy, atmospheric look.\",\"keyElements\":[\"lake\",\"mist\",\"fog\",\"trees\",\"willow tree\",\"mountains\",\"lighting\"],\"attributes\":[\"scenic\",\"atmospheric\",\"dreamy\",\"peaceful\",\"serene\",\"wide shot\",\"sunrise\",\"soft lighting\",\"natural light\",\"warm tone\",\"misty\",\"foggy\",\"travel\",\"nature\",\"lake\",\"water\",\"mist\",\"fog\",\"trees\",\"willow\",\"mountains\",\"pink\",\"peach\",\"gold\"]},{\"fileName\":\"GENERIC-NatureLandscape-08.mp4\",\"description\":\"The video shows a close up view of tall, silhouetted grass stalks and seed heads swaying against a sunset sky. The grass stalks are thin and dark, appearing as silhouettes with feathery seed heads at the top, positioned in the foreground and out of focus in some areas. The sun is visible as a small, bright, glowing orb low on the horizon in the center of the frame, partially obscured by the grass stalks. The sky transitions from a warm orange and pink near the horizon to a cooler blue and teal higher in the frame, with a hazy silhouette of distant hills or mountains visible along the horizon line. The lighting is warm and soft, consistent with sunset lighting, creating a backlit, glowing effect on the grass and a gentle gradient across the sky. The color palette is warm and soft, dominated by orange, pink, and gold tones near the horizon, transitioning to blue and teal tones higher in the sky. The composition is a close up, closeup, wide angle framing, with the grass filling the foreground and the sunset sky filling the background. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field and warm, backlit sunset lighting.\",\"keyElements\":[\"grass\",\"seed heads\",\"sun\",\"sky\",\"hills\",\"backlight\",\"lighting\"],\"attributes\":[\"scenic\",\"peaceful\",\"serene\",\"close up\",\"closeup\",\"silhouette\",\"sunset\",\"backlight\",\"golden hour\",\"warm lighting\",\"natural light\",\"warm tone\",\"cool tone\",\"nature\",\"lifestyle\",\"grass\",\"seed heads\",\"sun\",\"sky\",\"orange\",\"pink\",\"blue\",\"teal\",\"hills\"]},{\"fileName\":\"GENERIC-NatureLandscape-09.mp4\",\"description\":\"The video shows an aerial drone view of a rugged, rocky ocean coastline, with waves crashing against dark, jagged rock formations. The ocean water displays varying shades of blue, from deep navy blue further from shore to bright turquoise and white sea foam where waves break against the rocks. The coastline features tall, layered rock cliffs in dark gray and brown tones, with patches of green and orange vegetation growing along the clifftops. A grassy, green and tan colored plateau extends along the top of the cliffs in the upper right portion of the frame. The lighting is bright and natural, consistent with clear daytime sunlight, creating sharp highlights on the wave crests and defined shadows within the rock formations. The color palette is vibrant and rich, dominated by navy blue, turquoise, white, and gray tones, with green and orange accents from the clifftop vegetation. The composition is a wide, expansive aerial shot, with the ocean filling the left portion of the frame and the rocky coastline and cliffs filling the right portion. The visual style is photographic, realistic, and resembles a travel or nature style stock video with a wide depth of field and bright, dramatic coastal lighting.\",\"keyElements\":[\"ocean\",\"waves\",\"rocks\",\"cliffs\",\"vegetation\",\"plateau\",\"lighting\"],\"attributes\":[\"scenic\",\"dramatic\",\"rugged\",\"expansive\",\"aerial\",\"wide shot\",\"bright lighting\",\"natural light\",\"vibrant\",\"coastal\",\"travel\",\"nature\",\"ocean\",\"waves\",\"rocks\",\"cliffs\",\"navy blue\",\"turquoise\",\"white\",\"gray\",\"green\"]},{\"fileName\":\"GENERIC-NatureLandscape-10.mp4\",\"description\":\"The video shows an aerial drone view flying low over a snow covered mountain ridge. The ridge is entirely blanketed in thick, white snow, with a narrow, jagged ridgeline running diagonally across the frame, featuring exposed patches of dark brown and reddish rock protruding through the snow near the top of the ridge. Additional snow covered mountain peaks are visible in the background, extending toward the horizon on the left side of the frame. The sky above is a deep blue color with wispy, streaking white clouds, and the sun is positioned high in the sky, partially obscured by clouds, creating a bright glow and subtle lens flare in the upper portion of the frame. The lighting is bright and crisp, consistent with clear high altitude daytime sunlight, creating strong highlights on the snow and defined shadows within the ridge's contours. The color palette is bright and cool, dominated by white, blue, and gray tones, with brown and reddish accents from the exposed rock. The composition is a wide, dynamic aerial shot, following the line of the ridge diagonally across the frame. The visual style is photographic, realistic, and resembles an adventure or travel style stock video with a wide depth of field and bright, crisp high altitude lighting.\",\"keyElements\":[\"mountain ridge\",\"snow\",\"peaks\",\"rock\",\"sky\",\"clouds\",\"lens flare\",\"lighting\"],\"attributes\":[\"scenic\",\"dramatic\",\"expansive\",\"aerial\",\"wide shot\",\"bright lighting\",\"natural light\",\"cool tone\",\"crisp\",\"adventure\",\"travel\",\"nature\",\"mountain\",\"ridge\",\"snow\",\"peaks\",\"rock\",\"white\",\"blue\",\"clouds\",\"sky\"]}]}");


var $5986dc58a2672d72$exports = {};
$5986dc58a2672d72$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-NatureMacro-01.mp4\",\"description\":\"The video shows an extreme macro close up of pale pink and white flower blossoms, resembling apricot or cherry blossoms, growing along a thin, dark brown branch. The flowers have delicate, rounded petals in soft pink and white tones, with clusters of thin, white filaments topped with small yellow pollen covered stamens visible at the center of each open blossom. Several unopened flower buds are visible along the branch, displaying deep red, maroon colored outer petals that have not yet unfurled. The setting is set against a bright, saturated turquoise, blue colored background, which appears smooth and out of focus, suggesting an artificial or sky backdrop. The lighting is soft and even, evenly illuminating the delicate petals and stamens without harsh shadows, allowing the pink and white tones to remain bright and vivid. The color palette is vibrant and fresh, dominated by pink, white, turquoise, and touches of yellow and red. The composition is an extreme close up, closeup, macro framing, with the flower cluster positioned in the right portion of the frame and additional blurred blossoms visible in the left background. The visual style is photographic, realistic, and resembles a nature or spring style stock video with a shallow depth of field and bright, saturated colors.\",\"keyElements\":[\"branch\",\"flower buds\",\"background\",\"lighting\"],\"attributes\":[\"fresh\",\"vibrant\",\"delicate\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"soft lighting\",\"natural light\",\"vibrant color\",\"spring\",\"nature\",\"blossom\",\"flower\",\"pink\",\"white\",\"turquoise\",\"yellow\",\"red\",\"petals\",\"stamens\",\"branch\",\"buds\"]},{\"fileName\":\"GENERIC-NatureMacro-02.mp4\",\"description\":\"The video shows an extreme macro close up of a single pink peony flower in full bloom. The flower displays numerous soft, ruffled, layered petals in varying shades of pink, from pale blush pink on the outer petals to a deeper, more saturated rose pink in the densely packed inner petals. The petals have a delicate, papery, slightly translucent texture, with visible soft folds and creases catching subtle highlights. The setting is a plain, softly blurred light gray background, giving no additional visual context beyond the flower itself. The lighting is soft, bright, and even, evenly illuminating the petals and creating gentle highlights and shadows within the folds of the flower, emphasizing its delicate texture. The color palette is soft and romantic, dominated by pale pink, rose pink, and light gray tones. The composition is an extreme close up, closeup, macro framing, with the peony flower filling almost the entire frame, centered directly in the composition. The visual style is photographic, realistic, and resembles a nature or lifestyle style stock video with a shallow depth of field and soft, romantic lighting.\",\"keyElements\":[\"background\",\"lighting\"],\"attributes\":[\"delicate\",\"romantic\",\"soft\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"soft lighting\",\"natural light\",\"pastel tone\",\"nature\",\"lifestyle\",\"flower\",\"peony\",\"pink\",\"rose\",\"blush\",\"petals\",\"bloom\"]},{\"fileName\":\"GENERIC-NatureMacro-03.mp4\",\"description\":\"The video shows an extreme macro close up of a pair of ants, insects with orange, red colored bodies and long, thin, golden yellow colored legs and antennae, walking along a dark brown tree branch. The ants are positioned with one ant in the foreground in sharp focus near the right side of the frame, and another ant slightly blurred in the background on the left side, both appearing to move along the curved surface of the branch. The setting is an outdoor natural environment, showing the textured, rough surface of the branch and a smooth, blurred dark green background, suggesting dense foliage. The lighting is bright and warm, creating glowing highlights along the translucent legs and antennae of the ants, with a slight golden backlit quality. The color palette is warm and rich, dominated by orange, red, gold, and dark green tones. The composition is an extreme close up, closeup, macro framing, with the branch curving horizontally across the middle of the frame and the ants positioned along its length. The visual style is photographic, realistic, and resembles a nature or wildlife documentary style stock video with a shallow depth of field and warm, detailed macro focus.\",\"keyElements\":[\"branch\",\"foliage\",\"background\",\"lighting\"],\"attributes\":[\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"warm lighting\",\"natural light\",\"warm tone\",\"backlight\",\"documentary\",\"wildlife\",\"nature\",\"ant\",\"insect\",\"orange\",\"red\",\"gold\",\"green\",\"branch\",\"antennae\"]},{\"fileName\":\"GENERIC-NatureMacro-04.mp4\",\"description\":\"The video shows a herd of horses, animals with white, gray colored coats and flowing white manes, running through shallow water. The horses are captured mid stride, with water splashing dramatically around their legs and hooves, creating white spray and ripples. Multiple horses are visible across the frame, with one horse in the foreground on the left side turning its head, and additional horses visible in the middle ground and on the right side of the frame, partially cropped. The setting is an outdoor coastal or wetland environment, showing a flat expanse of shallow water reflecting the sky, with a hazy, distant horizon line visible in the background. The lighting is warm and golden, consistent with early morning or late afternoon sunlight, creating a hazy, glowing atmosphere and warm highlights on the horses' coats and the splashing water. The color palette is warm and soft, dominated by white, gray, and golden tan tones, with a hazy cream colored sky. The composition is a wide, dynamic action shot, with the horses positioned across the frame in mid motion. The visual style is photographic, realistic, and resembles a nature or wildlife style stock video with a moderate depth of field and warm, golden hour lighting.\",\"keyElements\":[\"water\",\"splash\",\"horizon\",\"sky\",\"lighting\"],\"attributes\":[\"dynamic\",\"action\",\"energetic\",\"candid\",\"wide shot\",\"golden hour\",\"warm lighting\",\"natural light\",\"warm tone\",\"hazy\",\"wildlife\",\"nature\",\"horses\",\"white\",\"gray\",\"water\",\"splash\",\"running\",\"herd\",\"mane\"]},{\"fileName\":\"GENERIC-NatureMacro-05.mp4\",\"description\":\"The video shows an extreme macro close up of white, fuzzy mold or fungus growing and spreading across a dark brown surface. The mold displays a delicate, web like structure, with thin, thread like filaments, called hyphae, branching outward and terminating in small, round, light green and white colored spore clusters. The texture is soft, fluffy, and intricate, resembling tiny trees or coral formations. The setting is a plain, dark brown blurred background, giving no additional visual context beyond the mold's texture. The lighting is soft and diffused, creating gentle highlights on the pale, translucent filaments while the dark background remains subdued. The color palette is muted and cool, dominated by white, pale green, and dark brown tones. The composition is an extreme close up, closeup, macro framing, with the mold structure filling the entire frame in intricate detail. The visual style is photographic, realistic, and resembles a scientific or nature documentary style stock video with a shallow depth of field and detailed macro focus on texture.\",\"keyElements\":[\"background\",\"lighting\"],\"attributes\":[\"intricate\",\"delicate\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"soft lighting\",\"muted tone\",\"cool tone\",\"scientific\",\"documentary\",\"nature\",\"mold\",\"fungus\",\"spores\",\"white\",\"green\",\"brown\",\"texture\",\"growth\"]},{\"fileName\":\"GENERIC-NatureMacro-06.mp4\",\"description\":\"The video shows two honeybees, insects with black and gold striped bodies and translucent, veined wings, hovering and flying near a cluster of light purple, lavender colored daisy flowers with bright yellow centers. One bee is in sharp focus in the left portion of the frame, with its wings blurred from motion, while a second bee is visible slightly out of focus in the upper right background. The flowers have thin, pointed petals radiating outward from the yellow centers, with green stems and buds visible below. The setting is an outdoor garden environment, showing a smooth, blurred dark green background, suggesting dense foliage or grass. The lighting is soft and warm, consistent with natural outdoor lighting, creating gentle highlights on the bees' wings and the flower petals. The color palette is soft and vibrant, dominated by lavender, purple, yellow, and dark green tones. The composition is an extreme close up, closeup, macro framing, with the flowers positioned in the lower portion of the frame and the bees hovering above them. The visual style is photographic, realistic, and resembles a nature or wildlife documentary style stock video with a shallow depth of field and detailed macro focus.\",\"keyElements\":[\"flowers\",\"stems\",\"buds\",\"background\",\"lighting\"],\"attributes\":[\"vibrant\",\"delicate\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"soft lighting\",\"natural light\",\"warm tone\",\"documentary\",\"wildlife\",\"nature\",\"bee\",\"honeybee\",\"insect\",\"flower\",\"daisy\",\"lavender\",\"purple\",\"yellow\",\"green\",\"pollinator\"]},{\"fileName\":\"GENERIC-NatureMacro-07.mp4\",\"description\":\"The video shows a low angle view looking directly upward at the trunk and canopy of a large tree. The tree trunk has thick, rough, textured gray brown bark, with several large branches extending outward and upward from the top of the trunk. Bright green leaves cover the branches densely, filtering sunlight and creating a dappled pattern of light and shadow throughout the canopy. A single leaf cluster is visible in sharp focus near the center of the trunk, while patches of bright white sky are visible peeking through gaps in the leaves. The setting is an outdoor forest or park environment, with the tree filling almost the entire frame. The lighting is bright and natural, consistent with daytime sunlight filtering through the leaves, creating a dappled, glowing effect throughout the canopy. The color palette is rich and vibrant, dominated by green, brown, and tan tones, with bright white accents from the sky peeking through. The composition is a wide angle, low angle shot, looking directly upward, with the tree trunk centered and the canopy radiating outward toward the edges of the frame. The visual style is photographic, realistic, and resembles a nature or environmental style stock video with a deep depth of field and dappled natural lighting.\",\"keyElements\":[\"tree trunk\",\"branches\",\"canopy\",\"leaves\",\"sky\",\"lighting\"],\"attributes\":[\"scenic\",\"dappled\",\"low angle\",\"wide angle\",\"bright lighting\",\"natural light\",\"vibrant\",\"environmental\",\"nature\",\"tree\",\"trunk\",\"branches\",\"leaves\",\"canopy\",\"green\",\"brown\",\"bark\",\"sky\",\"forest\"]},{\"fileName\":\"GENERIC-NatureMacro-08.mp4\",\"description\":\"The video shows an extreme macro close up of a backlit cross section slice of a kiwi fruit. The fruit displays a bright, vivid green, translucent flesh with a pale, creamy yellow colored center core, from which thin, radiating white fibrous lines extend outward toward the edges of the slice. A ring of small, oval shaped black seeds is arranged around the perimeter of the yellow center, with tiny fibrous threads attached to some of the seeds. The setting has no additional background, as the kiwi slice fills the entire frame. The lighting is bright and strongly backlit, shining through the translucent flesh of the fruit and creating a vivid, glowing, luminous effect that highlights the internal structure and seeds. The color palette is vibrant and fresh, dominated by bright green, yellow, and black tones. The composition is an extreme close up, closeup, macro framing, with the kiwi slice filling the entire frame edge to edge. The visual style is photographic, realistic, and resembles a food or nature style stock video with a shallow depth of field and vivid, glowing backlight.\",\"keyElements\":[\"lighting\"],\"attributes\":[\"vivid\",\"vibrant\",\"glowing\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"backlight\",\"food\",\"nature\",\"kiwi\",\"fruit\",\"green\",\"yellow\",\"black\",\"seeds\",\"fresh\",\"slice\"]},{\"fileName\":\"GENERIC-NatureMacro-09.mp4\",\"description\":\"The video shows an extreme macro close up of a single bright green leaf with raindrops falling around it and collecting on its surface. A large, dark, glossy water droplet is forming and dripping from the pointed tip of the leaf, with smaller droplets scattered across the leaf's surface, reflecting light. Thin streaks of falling rain are visible as blurred vertical lines throughout the background. The setting is an outdoor environment, showing a deep, dark green blurred background suggesting dense foliage or a rainy garden. The lighting is soft and moody, consistent with overcast, rainy weather, creating subtle highlights on the wet leaf surface and the falling raindrops. The color palette is rich and cool, dominated by deep green and dark tones, with bright highlights from the water droplets. The composition is an extreme close up, closeup, macro framing, with the leaf positioned in the upper portion of the frame and the dripping water droplet extending downward toward the center. The visual style is photographic, realistic, and resembles a nature or weather style stock video with a shallow depth of field and moody, atmospheric lighting.\",\"keyElements\":[\"leaf\",\"raindrops\",\"background\",\"lighting\"],\"attributes\":[\"moody\",\"atmospheric\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"soft lighting\",\"cool tone\",\"rain\",\"weather\",\"nature\",\"leaf\",\"green\",\"raindrops\",\"water droplet\",\"wet\",\"dripping\"]},{\"fileName\":\"GENERIC-NatureMacro-10.mp4\",\"description\":\"The video shows an extreme macro close up of a chameleon, a reptile with brightly colored, intricately patterned scaled skin displaying a mix of red, orange, green, yellow, and turquoise tones arranged in a mosaic like pattern across its head and body. The chameleon has a prominent, round dark eye with a scaled eyelid, small pointed teeth visible along its jawline, and clawed feet gripping a dark, textured tree branch. The setting is an outdoor environment, showing a smooth, blurred blue gray background, suggesting an overcast sky or foliage out of focus. The lighting is bright and even, creating detailed highlights on the raised, bead like texture of the chameleon's scales. The color palette is vibrant and varied, dominated by red, orange, green, yellow, and turquoise tones, with a muted blue gray background. The composition is an extreme close up, closeup, macro framing, with the chameleon's head and upper body filling most of the frame, positioned toward the right side. The visual style is photographic, realistic, and resembles a nature or wildlife documentary style stock video with a shallow depth of field and vivid, detailed macro focus.\",\"keyElements\":[\"branch\",\"background\",\"lighting\"],\"attributes\":[\"vivid\",\"colorful\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"bright lighting\",\"vibrant\",\"documentary\",\"wildlife\",\"nature\",\"chameleon\",\"reptile\",\"scales\",\"red\",\"orange\",\"green\",\"yellow\",\"turquoise\",\"branch\",\"claws\"]},{\"fileName\":\"GENERIC-NatureMacro-11.mp4\",\"description\":\"The video shows an extreme macro close up of a backlit green leaf, displaying its intricate network of veins in fine detail. The leaf's surface shows a bright, glowing yellow green color along the thinner veins and translucent sections, transitioning to a deeper, richer green in the thicker sections of the leaf tissue. A thick, diagonal central vein or stem runs across the frame from the upper right to the lower left, showing small reddish brown, hair like structures and tiny dark insects walking along its length. The setting has no additional background, as the leaf fills the entire frame. The lighting is bright and strongly backlit, shining through the thin leaf tissue and creating a vivid, glowing, translucent effect that highlights the vein structure. The color palette is vibrant and rich, dominated by bright green, yellow green, and reddish brown tones. The composition is an extreme close up, closeup, macro framing, with the leaf and its vein pattern filling the entire frame edge to edge. The visual style is photographic, realistic, and resembles a nature or documentary style stock video with a shallow depth of field and vivid, glowing backlight.\",\"keyElements\":[\"leaf veins\",\"insects\",\"lighting\"],\"attributes\":[\"vivid\",\"vibrant\",\"glowing\",\"candid\",\"close up\",\"closeup\",\"extreme close up\",\"macro\",\"shallow depth of field\",\"backlight\",\"documentary\",\"nature\",\"leaf\",\"veins\",\"green\",\"yellow green\",\"insects\",\"translucent\",\"texture\"]}]}");


var $709441eda9f9f683$exports = {};
$709441eda9f9f683$exports = JSON.parse('{"items":[{"fileName":"GENERIC-CityDaytime-01.mp4","description":"The video presents a point-of-view driving shot moving along a wide urban boulevard in what appears to be a residential and mixed-use neighborhood, shot from a low camera position at street level. The road surface is a broad multi-lane grey asphalt boulevard that extends into the distance toward a vanishing point, with yellow center lane markings and white crosswalk markings visible at intersections. On the left side of the street, a row of mid-rise red brick buildings of three to five stories lines the sidewalk, with ground-floor commercial establishments including a restaurant or caf\xe9 with outdoor seating featuring folded parasols and red chairs visible on the pavement, alongside bicycle racks and small trees planted along the curb. On the right side, a large dense canopy of mature green trees \u2014 consistent with a park edge or median park \u2014 stretches along the road, accompanied by a tall modern grey residential tower partially visible above the tree line and a green directional street sign on a pole. Traffic lights and pedestrian crossing signals are visible at the intersection ahead. Several vehicles including a yellow taxi cab and dark SUVs are visible ahead on the road at a moderate distance. In the second frame, the scene progresses to a busier intersection with multiple pedestrians crossing the street, more vehicles present, additional tall residential tower buildings visible in the background, and street lamps and signage poles along the boulevard. The lighting is bright, clear natural daylight with a slightly hazy pale sky. The color palette is warm red brick, vibrant green foliage, grey asphalt, and neutral blue-white sky. The visual style is naturalistic, wide, and cinematic, consistent with a moving vehicle camera.","keyElements":["Wide multi-lane grey asphalt boulevard with yellow center markings","Red brick mid-rise buildings with ground-floor commercial frontage on the left","Outdoor caf\xe9 seating with folded parasols and red chairs","Dense mature green tree canopy along the right side","Traffic lights, crosswalk markings, and street signage poles","Pale hazy blue-white sky"],"attributes":["driving point-of-view perspective","urban residential boulevard","bright natural daylight","warm red-brick and green palette","wide street-level framing"]},{"fileName":"GENERIC-CityDaytime-02.mp4","description":"The video presents a wide elevated or aerial view of a major metropolitan cityscape built along both banks of a broad river that runs diagonally through the center of the frame from left to right. The skyline is densely populated with a variety of high-rise and mid-rise commercial and residential buildings spanning multiple architectural styles and eras. On the left bank, a cluster of tall modern skyscrapers is prominently visible: the tallest is a slender dark-glass and steel tower with a distinctive triangular or faceted top, rising above all others. Adjacent lower towers, including a brick-red mid-rise structure labeled \'QUAY W\' in red lettering, and a heritage-style domed or ornate gold-tiled building visible at the lower right corner of the frame, contribute to an architecturally diverse skyline. A large glass-roofed structure with a green glass canopy at ground level is visible at the bottom left. Along the near riverbank, a pedestrian promenade or riverside walkway is visible with tree-lined paths and a small arched pedestrian bridge spanning part of the river. Parallel to the river on the right bank, a series of elevated rail or tram tracks run along the waterfront with multiple lines visible. Across the far bank, further mid-rise and tall buildings extend into the distance. The sky is a clear, bright blue with a few scattered white clouds on the horizon. The lighting is bright natural daylight with no dominant shadow direction, suggesting midday sun. The color palette includes dark navy and silver glass towers, warm brick red, the blue-grey of the river water, bright sky blue, and green tree foliage along the banks. The visual style is wide, high-angle, and photographic.","keyElements":["Broad river running diagonally through the center of the frame","Dense mixed high-rise and mid-rise skyline on both banks","Tall dark-glass skyscraper with faceted or triangular top as dominant landmark","Elevated rail or tram tracks running along the right riverbank","Pedestrian promenade and arched bridge along the near waterfront","Clear bright blue sky with scattered white clouds on the horizon"],"attributes":["elevated aerial city view","bright clear midday light","river-divided skyline composition","diverse architectural styles","wide expansive cityscape framing"]},{"fileName":"GENERIC-CityDaytime-03.mp4","description":"The video shows a dense crowd of pedestrians walking along a wide busy city sidewalk in what appears to be a major urban commercial district during daytime. The shot is filmed from a slightly elevated position looking down and along the length of the pavement, creating a strong sense of depth with the crowd receding toward the distant vanishing point. The sidewalk is packed wall-to-wall with people of diverse appearances and clothing, moving primarily in the direction of the camera \u2014 toward the viewer. Clothing styles range from casual to business attire: white shirts with ties, backpacks, summer dresses, and dark jackets. The street on the right side of the frame is partially visible, showing motion-blurred yellow taxis and cars. The buildings flanking the sidewalk are tall stone-clad or terracotta-colored multi-story structures consistent with early-to-mid twentieth century commercial architecture. On the right side near an intersection, a large planting box or raised garden bed with bright red and yellow flowering plants and green foliage adds color. Multiple street signs, traffic lights, and directional signs on poles are visible at the intersection in the distance, as well as green leafy trees. The sky at the far end of the street is bright and hazy white-blue. The lighting is bright natural midday sunlight producing harsh shadows. The color palette is warm terracotta and beige from the architecture, with pops of red, yellow, and green from the garden, and a wide variety of neutral clothing tones. The visual style is photographic and telephoto-compressed, creating the impression of an even denser crowd through lens compression.","keyElements":["Wide busy city sidewalk with dense pedestrian crowd","Tall terracotta and stone-clad early-to-mid century commercial building facades","Raised garden planter with bright red and yellow flowering plants","Traffic signals, street signage, and poles at the intersection","Green leafy trees visible at the far intersection","Bright hazy white-blue sky at the vanishing point"],"attributes":["telephoto crowd compression","busy urban pedestrian street","bright harsh midday sunlight","warm stone and terracotta palette","deep street-level perspective"]},{"fileName":"GENERIC-CityDaytime-04.mp4","description":"The video presents a dramatic straight-down aerial or overhead drone perspective looking directly downward onto a dense urban city grid, capturing large modern skyscrapers and a major multi-lane intersection from directly above. The shot creates a near-abstract geometric composition with buildings seen from their rooftops and the streets far below reduced to thin corridors of traffic. The building rooftops visible from above include: a very long flat-roofed structure with a ribbed or louvered white facade running diagonally through the left half of the frame; a large domed or oval-shaped structure with a white ribbed roof in the upper center; a circular rooftop structure with a distinctive white concentric ring design resembling a turbine or helipad at the upper left; and a cylindrical glass-topped tower at the lower left showing a curved green-glass canopy at its crown. A small blue teardrop-shaped pool or water feature is visible on one building\'s terrace. Vehicles are visible as tiny colored forms in the deep canyon between buildings, and the intersection below shows a cross pattern of roads with multiple lanes, crosswalks, and median strips. The visual style is strikingly geometric, drone-shot, and graphically composed. The color palette is dominated by cool grey, white, and beige of the building structures, with small accents of blue from the pool and light from the sky. The lighting is flat, direct overhead daylight producing minimal shadows.","keyElements":["Long ribbed or louvered flat-roofed building running diagonally through the frame","Oval or domed white-ribbed roof structure in upper center","Circular concentric white ring rooftop structure at upper left","Cylindrical curved glass-canopy tower top at lower left","Small blue teardrop pool or water feature on a rooftop terrace","Multi-lane road intersection visible far below with tiny vehicle forms"],"attributes":["straight-down aerial drone perspective","abstract geometric rooftop composition","cool grey and white palette","flat direct overhead daylight","ultra-high-altitude urban framing"]},{"fileName":"GENERIC-CityDaytime-05.mp4","description":"The video features a ground-level upward-looking perspective from within a cluster of tall modern glass-and-steel skyscrapers, with the camera pointing directly skyward between the towers. The buildings\' glass curtain-wall facades fill the majority of the frame, their surfaces covered in a uniform grid of dark-framed rectangular glass panels reflecting a teal-blue and dark tone. The towers converge toward a central open corridor of sky visible at the top center of the frame, creating a strong radial perspective with converging diagonal lines. A bright white sun is visible at the lower left of the frame between two tower facades, producing a starburst or strong lens flare effect with green and red chromatic aberration streaks extending across the frame. A second multi-colored lens flare is visible at the upper right. The sky visible between the towers is a clear, pale light blue. The lighting is intensely backlit by the direct sun, which creates high contrast between the bright sky and the dark glass surfaces. The color palette is a cool teal-grey and near-black from the reflective glass, offset by the bright white-blue of the sky and the vivid lens flare colors of green and red. The visual style is architectural, highly graphic, and cinematic, with a worm\'s-eye perspective creating a sense of towering scale.","keyElements":["Multiple tall glass-and-steel skyscraper facades converging upward","Clear pale blue sky corridor visible between towers at top","Bright white sun producing a starburst lens flare at lower left","Green and red chromatic lens flare streaks across the frame","Uniform dark-framed glass curtain-wall grid pattern on facades"],"attributes":["worm\'s-eye upward perspective","graphic glass curtain-wall pattern","cool teal-blue and dark palette","intense backlit sun flare","towering architectural scale"]},{"fileName":"GENERIC-CityDaytime-06.mp4","description":"The video is a time-lapse or long-exposure shot of a busy multi-lane urban boulevard filmed from a stationary position at the center median or pedestrian island level, looking along the length of the street in both directions. The road is very wide \u2014 five or more lanes in total \u2014 with a brick or paved central median dividing opposing traffic. Yellow road marking lines and white crosswalk stripes are visible across the lanes. Cars, SUVs, buses, and other vehicles travel along the boulevard and appear motion-blurred in the time-lapse, conveying continuous traffic flow. Multiple traffic signals hang overhead on horizontal metal poles and are mounted on vertical poles at intervals along both sidewalks. A distinctive large orange sculptural element \u2014 resembling an abstract fish or curved form \u2014 is mounted on a pole or structure above the left sidewalk buildings. Purple, red, and blue vertical event banners or pennants labeled \'PHL\' and \'PITTCON\' line the left sidewalk on light posts. A green street sign reading \'ARCH ST\' is visible on the right at the near intersection. Additional signage including \'NO TURNS\' and green traffic signs are mounted on poles at the intersection. Tall commercial and civic buildings of varied heights line both sides of the street. A white city bus is visible at the right edge. The sky above the street corridor is pale, hazy, and flat \u2014 consistent with overcast or bright but diffuse winter or early spring daylight. The color palette is predominantly grey asphalt, warm beige and brick-toned building facades, the orange of the sculpture, and multicolored signage and banners. The visual style is photographic, wide, and frontal with a strong symmetrical road-corridor perspective.","keyElements":["Wide multi-lane boulevard with brick central median","Large abstract orange sculptural element on the left side","Purple, red, and blue event banners (\'PHL\', \'PITTCON\') on lamp posts","Multiple traffic lights and signals on poles at intersections","Green street sign (\'ARCH ST\') and \'NO TURNS\' signage","White city bus at the right edge","Pale hazy overcast sky above the street corridor"],"attributes":["time-lapse motion blur","symmetrical street corridor framing","overcast flat daytime light","cool grey urban palette","dense traffic signage environment"]},{"fileName":"GENERIC-CityDaytime-07.mp4","description":"The video shows a dynamic upward-looking perspective of a tall modern glass skyscraper with a distinctive curved or tapered form, filmed from ground level with the camera tilted steeply upward. The primary building dominates most of the frame, its facade covered in a large-scale uniform grid of square or rectangular glass panels with a light grey metal frame structure, reflecting a blue sky with scattered white clouds. The tower\'s silhouette tapers or curves toward the top, giving it a sleek, contemporary architectural character. At the lower left of the frame, a secondary building with a dark metallic or black glass facade and angled upper terrace with visible green vegetation is visible. At the lower center and right, additional ground-level architecture is visible: a large overhanging canopy or porte-coch\xe8re in dark metal extends over what appears to be an entrance area, with glazed facade panels below it. At the right edge, the top of another shorter glass tower is partially visible. The sky visible in the upper right is a rich bright blue with scattered white and grey clouds drifting across it. The lighting is bright natural daylight from above, with the clouds reflected prominently in the glass of the building\'s facade. The color palette is dominated by the cool blue-silver of the glass facade, bright blue sky, white cloud reflections, and dark grey of the secondary structures. The visual style is architectural and cinematic, with a dramatic low-angle perspective emphasizing the height and scale of the towers.","keyElements":["Tall curved or tapered glass skyscraper with uniform grid glass facade as primary subject","Dark metallic secondary building with angled terrace and green vegetation at lower left","Large dark metal overhanging canopy at lower center over an entrance area","Additional shorter glass tower partially visible at right edge","Bright blue sky with scattered white and grey clouds visible at upper right","Cloud reflections visible in the glass facade panels"],"attributes":["dramatic low-angle upward perspective","cool blue-silver glass facade palette","bright natural daylight with cloud reflections","sleek contemporary architecture","towering architectural scale"]}]}');


var $d882fc010ad9f5fb$exports = {};
$d882fc010ad9f5fb$exports = JSON.parse('{"items":[{"fileName":"GENERIC-CityNighttime-01.mp4","description":"The video presents a high-altitude aerial or drone shot looking down at a large multi-level highway interchange at night, captured in a long-exposure or time-lapse style that renders moving vehicles as streaks of white and blue-white light. The interchange is a complex stacked overpass structure with multiple elevated highway ramps curving, crossing, and overlapping at different levels. The road surfaces are composed of wide multi-lane concrete or asphalt spans in dark grey-blue tones, illuminated by sparse overhead streetlights that cast cool blue-white pools of light at intervals. The long-exposure effect causes the headlights and taillights of moving vehicles to register as continuous streaks of bright white light tracing the curvature and direction of each road segment. The interplay of these light trails creates a dynamic, almost abstract geometric pattern of intersecting lines, curves, and sweeping arcs across the frame. Several stationary vehicles are visible as discrete white dots on slower or stopped sections of road. The surrounding areas between the ramps are dark and unlit, punctuated only by sparse infrastructure lighting in blue-white tones. The overall atmosphere of the frame is deep blue-black with luminous white-blue light streaks. The visual style is aerial, graphic, and highly cinematic, with a moody, cool, monochromatic color palette of near-black, dark blue-grey, and cool white-blue.","keyElements":["Multiple stacked elevated highway ramps and overpasses","Long-exposure white-blue vehicle light trail streaks","Sparse cool blue-white streetlight pools on road surfaces","Dark unlit areas between road structures","Dark grey-blue concrete and asphalt road surfaces"],"attributes":["aerial highway interchange view","long-exposure light trails","cool blue-black night palette","abstract geometric road patterns","high-altitude drone framing"]},{"fileName":"GENERIC-CityNighttime-02.mp4","description":"The video shows a tilt-shift or shallow depth-of-field shot of a busy pedestrian crosswalk at night in an urban setting, with the scene rendered in a soft, heavily blurred aesthetic that gives it an almost miniature or dreamlike quality. A large group of pedestrians \u2014 approximately fifteen or more figures \u2014 are crossing a wide road at a marked crosswalk, their bodies in silhouette or near-silhouette against the warm and colorful ambient light of the street. Most figures are partially blurred, conveying motion, and are dressed in casual clothing including jeans and jackets. Two vehicles \u2014 both appearing to be light-coloured cars or taxis \u2014 are stopped at the crosswalk with their headlights on, creating two bright glowing orbs of warm white-blue light that backlight the scene. The road surface is dark and reflective, showing soft reflections of the car headlights and street illumination as glowing smears of orange and white on the wet or polished pavement. The background behind the pedestrians and vehicles shows a dense blur of building facades lit with warm amber and cool blue-purple tones, large glowing spherical light fixtures mounted on structures, and the general glow of urban nighttime lighting. The entire background is rendered in extreme bokeh, reducing the cityscape to abstract soft circles and washes of color. The color palette is warm amber and orange from street lighting, punctuated by cool blue-purple architectural illumination and bright white vehicle headlights. The visual style is tilt-shift, soft-focus, and cinematic.","keyElements":["Wide reflective wet or polished dark road surface","Two stopped vehicles with bright glowing headlights","Dense blurred urban building facade background with warm amber and blue-purple lighting","Large spherical light fixtures in the background rendered as bokeh orbs","Warm amber and orange street light reflections on the road"],"attributes":["tilt-shift shallow focus aesthetic","warm amber and cool blue-purple night palette","bokeh cityscape background","reflective wet night road","dreamlike miniature quality"]},{"fileName":"GENERIC-CityNighttime-03.mp4","description":"The video presents an extreme ground-level, near-surface perspective looking along a wet urban street or crosswalk at night, filmed from a camera positioned just a few centimeters above the pavement surface. The primary visual elements are the lower legs and feet of multiple pedestrians walking across a marked crosswalk, visible from the shins down, with the rest of their bodies extending above the frame. The pavement surface is dark grey-black asphalt that is visibly damp or wet, creating a reflective texture that catches and scatters the artificial light from vehicle headlights or street lamps above. The reflections appear as bright silvery-white or pale blue-white glistening patches and smears across the road surface, creating a luminous contrast against the dark ground. In the first frame, a pair of black sneakers or leather shoes with light rubber soles is in sharp focus at the center, while surrounding feet and pavement are rendered in soft blur. A diffuse bright light source is visible as a hazy glow in the upper center background between figures, contributing to the atmospheric quality. In the second frame, the composition shifts slightly with different shoes visible \u2014 cream-colored sneakers and black boots \u2014 and the glistening reflections on the pavement remain prominent. The color palette is almost entirely dark with punctuating warm amber-brown tones from the pavement material and cool silver-white from the wet reflections. The visual style is hyper-cinematic, low-angle, and highly atmospheric.","keyElements":["Dark wet or damp asphalt pavement surface","Bright silver-white light reflections on the wet road surface","Diffuse background light glow between pedestrian figures","Amber-brown tones in the dry pavement sections","Multiple pedestrian feet and lower legs partially in and out of focus"],"attributes":["extreme ground-level perspective","wet reflective night pavement","high-contrast dark and silver palette","hyper-cinematic shallow focus","atmospheric urban night texture"]},{"fileName":"GENERIC-CityNighttime-04.mp4","description":"The video presents a high-altitude aerial or drone view looking diagonally downward over a dense urban city district at night. The scene is viewed at an oblique angle rather than straight down, revealing building facades, rooftops, and street-level infrastructure simultaneously. On the left side of the frame, a tall modern glass-curtain-wall commercial tower is visible from the side, its grid of floor-by-floor windows glowing in a warm amber-gold from internal lighting and accented with vertical strips of teal-green and white illumination on its facade. The building\'s many lit windows create a dense grid of warm rectangular light against the dark building skin. At street level, a wide multi-lane road runs vertically through the center of the frame, filled with dense slow-moving traffic \u2014 cars, red buses, and other vehicles visible as small colored forms. A teal-green illuminated crosswalk or road surface marking creates a vivid accent at mid-frame on the road. Adjacent to the road, a large surface car park is visible with rows of parked vehicles illuminated by warm orange street lamps mounted on tall poles. In the lower-right portion of the frame, a large turquoise-blue illuminated structure or pool-like surface glows prominently, surrounded by darker low-rise structures. The surrounding urban grid is dense with buildings of varying heights, their rooftops rendered in dark flat tones. The overall color palette is a rich contrast of warm amber-orange street lighting, cool teal-green building accents, and the vivid turquoise glow of the lower-right feature against an overall dark blue-black night environment. The visual style is aerial, cinematic, and color-rich.","keyElements":["Tall glass-curtain-wall tower with warm amber window grids and teal vertical accent lighting on the left","Wide multi-lane road with dense traffic running vertically through the frame","Teal-green illuminated crosswalk or road surface marking on the road","Large surface car park with rows of parked vehicles under warm orange street lamps","Large vivid turquoise-blue illuminated structure in the lower right","Dense low-rise urban building grid with dark rooftops surrounding"],"attributes":["oblique aerial night city view","rich warm amber and cool teal color contrast","vivid artificial light palette","dense urban traffic and infrastructure","cinematic color-rich nighttime framing"]},{"fileName":"GENERIC-CityNighttime-05.mp4","description":"The video presents a worm\'s-eye or ground-level upward-looking perspective between multiple tall glass skyscrapers at night, with the camera positioned in the gap between the towers and pointed steeply upward toward the sky. The lower portions of at least four large glass-curtain-wall skyscrapers are visible from below, their facades lit from within by warm amber and gold tones of occupied office or residential floors, with individual rectangular windows glowing at varying intensities against the dark glass matrix. The two tallest towers are closest to the camera and visible on the left and right sides of the frame, their curved or angled lower facades rising steeply upward. In the central lower background, two additional towers of slightly shorter height are visible further away, their lit windows visible against the night sky. The sky between the towers is a deep blue-grey dusk or pre-midnight tone \u2014 not fully black \u2014 suggesting the shot was taken during civil or astronomical twilight or in a city with significant ambient sky glow. The color palette is the warm amber and gold of lit windows contrasted against the cool dark blue-grey glass facades and the deep blue-grey sky. There are no bright artificial light sources at street level; the illumination is entirely from building interiors. The visual style is dramatic, architectural, and cinematic, with a deep sense of vertical scale.","keyElements":["Deep blue-grey dusk or twilight sky visible between the towers","Warm amber and gold lit windows across multiple tower facades","Dark cool blue-grey glass curtain-wall surfaces of towers","Multiple towers at varying distances converging upward","No visible street-level lighting or ground elements"],"attributes":["worm\'s-eye upward night framing","warm amber window light against dark glass","deep blue-grey twilight sky","dramatic vertical architectural scale","cool and warm color contrast"]},{"fileName":"GENERIC-CityNighttime-06.mp4","description":"The video shows a detailed close-up frontal view of an office building\'s glass curtain-wall facade at night, filmed from a position directly opposite at medium range. The building facade fills the entire frame from edge to edge with no sky or ground visible, presenting an almost flat and graphic surface of regularly spaced rectangular glass panels divided by a uniform dark grey metal grid. Multiple office floors are visible simultaneously, each showing interior lit workspaces through the glass. Across the visible floors, office interiors are illuminated by rows of fluorescent or LED ceiling strip lights in warm white and neutral tones, revealing desks, office chairs, computer monitors, partition walls, and equipment. Some window sections are dark or partially lit, while others are fully illuminated, creating an irregular pattern of light and dark across the facade. In the top visible floor, a green accent wall or internal divider is visible through one lit section. The overall effect is a systematic grid of illuminated interior scenes alternating with dark opaque window panels, rendered through the night-time glass facade. The color palette is dominated by dark grey-blue glass and metal framework, with warm white-yellow interior light, accents of green and blue from individual office elements, and occasional bright monitor glows. The visual style is architectural, flat, and photographic with a moderate telephoto compression.","keyElements":["Uniform dark grey metal curtain-wall grid filling the entire frame","Multiple lit office floor interiors with fluorescent or LED ceiling strip lights","Office furniture and equipment silhouetted or visible through the glass panels","Dark or partially lit window sections creating an irregular light pattern","Green accent wall or divider visible through one lit top-floor section"],"attributes":["flat architectural facade framing","warm interior light against dark glass grid","urban office night interior visibility","systematic grid graphic composition","cool dark and warm interior color contrast"]},{"fileName":"GENERIC-CityNighttime-07.mp4","description":"The video presents a wide aerial drone view of a large circular highway roundabout or interchange lit with brilliant warm amber-orange sodium or LED street lighting at night, surrounded by an extensive urban road network extending in multiple directions. The interchange is a multi-level structure with an elevated overpass crossing diagonally over a circular ground-level roundabout, creating a complex geometric form of overlapping curves and straight sections. The road surfaces are bathed in intense warm amber-gold light from rows of street lamps installed along the central reservation and road edges, creating vivid golden glows that reflect on the road surface. Long-exposure or time-lapse capture renders moving vehicle headlights and taillights as continuous sweeping streaks of white and red light along all the road corridors. From the central interchange, multiple wide multi-lane roads radiate outward in at least four directions across the frame, each brightly lit with amber street lighting and carrying motion-blurred traffic. Large illuminated billboard structures \u2014 one displaying a bright backlit advertisement in the upper center background \u2014 are visible along the road corridors. The surrounding urban fabric outside the road corridors is dark, with scattered points of warm light from low-density buildings and street lighting. Teal-green accent lighting is visible on some road infrastructure edges. The color palette is dominated by warm amber-orange street lighting, white and red vehicle light trails, and isolated pops of teal and white signage. The visual style is aerial, cinematic, and graphically bold.","keyElements":["Large circular roundabout with elevated overpass crossing above it","Intense amber-gold sodium or LED street lighting on all road surfaces","Long-exposure white and red vehicle light trail streaks along road corridors","Multiple wide illuminated road corridors radiating from the interchange","Large backlit billboard advertisement visible in upper center background","Dark low-density urban surroundings with scattered warm light points"],"attributes":["aerial roundabout interchange view","intense warm amber street lighting","long-exposure light trail streaks","bold graphic road geometry","dark surroundings with vivid central glow"]},{"fileName":"GENERIC-CityNighttime-08.mp4","description":"The video presents a high-altitude aerial time-lapse or long-exposure view looking down at a very wide multi-lane urban expressway or highway carrying extremely heavy traffic at night. The expressway occupies the majority of the frame diagonally, running from the upper left to the lower right. It consists of at least eight to ten visible lanes in total \u2014 in some sections divided into elevated and ground-level carriageways \u2014 all densely packed with vehicles rendered as motion-blurred streaks of white headlights and red or orange taillights against the dark road surface. The elevated section of the expressway has a green-edged central reservation or barrier, with lanes running in both directions. At a central point in the frame, an on-ramp or interchange connector curves off from the expressway in a graceful arc, with its own stream of motion-blurred vehicles. Yellow chevron road markings and lane dividers are visible on the road surfaces. Surrounding the expressway on both sides are dense urban environments: dark buildings with warm interior window lights, large green-canopied trees illuminated from below by street lighting in teal-green tones, elevated rail or pedestrian walkways, and low-rise structures. A teal-blue illuminated circular structure or roundabout is visible near the lower center of the frame. The color palette is warm amber and orange from street lamps, white and red from vehicle lights, teal-green from tree canopy and edge lighting, and the overall deep dark blue-black of the night environment. The visual style is aerial, time-lapse, and graphically dense.","keyElements":["Very wide multi-lane expressway running diagonally across the frame","Motion-blurred white headlight and red taillight vehicle trail streaks","Yellow chevron road markings and green central reservation barriers","Teal-green illuminated large tree canopies flanking the road","Teal-blue circular structure or roundabout near lower center","Dense low-rise urban buildings and elevated rail or walkway structures on both sides"],"attributes":["aerial expressway time-lapse view","dense motion-blurred vehicle streams","warm amber and teal-green color contrast","high-density traffic night framing","complex layered urban infrastructure"]},{"fileName":"GENERIC-CityNighttime-09.mp4","description":"The video presents a near-vertical aerial drone view looking straight down at a wide urban boulevard or avenue at night, illuminated by intense warm amber-yellow street lighting. The road runs vertically through the center of the frame, occupying approximately one third of the width, and consists of multiple lanes in each direction separated by a central median. The road surface glows with a strong warm golden-yellow color from overhead street lamps, while vehicles on the road appear as small colored forms \u2014 white, silver, red, and dark \u2014 moving at varying speeds. A long bright white bus or coach is visible in one lane with motion blur. Yellow lane markings and directional arrows are clearly visible on the lit road surface. On both sides of the road, the rest of the frame is filled with the rooftops and facades of medium to tall urban buildings visible from above. On the left side, a large multi-story building with a teal-lit curtain-wall facade is prominent, its floors uniformly glowing in a vivid cyan-teal color with warm amber window accents. On the right side and across the background, further buildings show warm amber window grids and low-rise rooftop structures illuminated by scattered warm light. Pedestrians are faintly visible as tiny figures on the left sidewalk pavement. Tree canopy tops with some orange foliage are visible along the left sidewalk. The color palette is a vivid and graphic contrast of warm amber-yellow road lighting and cool teal-cyan building facades, with dark gaps between structures. The visual style is straight-down aerial, graphically composed, and cinematic with high color saturation.","keyElements":["Wide multi-lane urban boulevard with intense warm amber-yellow street lighting running vertically","Large teal-cyan curtain-wall building facade on the left side","Multiple medium and tall buildings with warm amber window grids on the right and background","Yellow road lane markings and directional arrows visible on the lit road","Tree canopy tops with orange foliage along the left sidewalk","Tiny pedestrian figures visible on the left pavement"],"attributes":["straight-down aerial night boulevard view","vivid amber-yellow and teal-cyan color contrast","graphic geometric road and building composition","high color saturation night palette","dense urban top-down framing"]}]}');


var $0dd17f1ba401c3ca$exports = {};
$0dd17f1ba401c3ca$exports = JSON.parse('{"items":[{"fileName":"GENERIC-TechEveryday-01.mp4","description":"The video features two adults positioned side by side against a tufted light gray upholstered headboard, suggesting a bedroom or lounge setting. The subject on the left is a woman with dark hair pulled back into a loose bun, wearing a light green spaghetti-strap top and small pearl stud earrings; she holds a black ceramic mug with both hands and faces slightly to the right with a visible smile. The subject on the right is a man with close-cropped hair wearing a white crew-neck t-shirt; he holds a dark-colored tablet in his right hand and gestures toward it with his left index finger, as if pointing at or navigating content on the screen. Both individuals are positioned close together in a medium close-up frame that captures them from roughly the waist or mid-torso upward. The color palette consists of soft, muted tones \u2014 off-white, light gray, pale green, and deep black from the mug \u2014 with a warm neutral background wall visible at the top right. Lighting is soft and diffused, appearing to come from the right side, creating gentle highlights on the subjects\' faces and a slightly cool undertone overall. The composition is horizontally balanced, with both subjects occupying roughly equal portions of the frame. The visual style is naturalistic and photographic, with a shallow depth of field that keeps both figures sharp while the background remains softly out of focus.","keyElements":["Bedroom or lounge background with gray headboard","Soft diffused lighting with warm-cool balance","Black ceramic mug","Light green spaghetti-strap top","White crew-neck t-shirt","Color palette of off-white, light gray, and pale green"],"attributes":["warm and casual","naturalistic lighting","intimate framing","soft muted palette","shallow depth of field"]},{"fileName":"GENERIC-TechEveryday-02.mp4","description":"The video presents a single male subject standing outdoors in an urban environment, framed from approximately the hips upward in a medium shot. The man has dark skin, a short beard, and wears thick-framed black rectangular eyeglasses. He is dressed in a white pullover sweatshirt layered over a dark collared shirt, and carries a gray crossbody bag strap visible diagonally across his chest. In one hand he holds a dark smartphone, which he appears to be looking at with a slight downward gaze and a subtle smile, while in his other hand he holds a corrugated kraft-paper takeaway coffee cup. The background consists of a modern glass-and-steel commercial building on the right, partially obscured by out-of-focus green-leafed trees on the left, conveying a bright daytime urban plaza setting. The color palette is neutral and clean \u2014 white, gray, black, and warm beige from the coffee cup \u2014 against the cool blues and greens of the background. Natural daylight illuminates the scene from the front-left, creating soft shadows on the subject\'s face. The composition places the subject centrally within the frame with a shallow depth of field that keeps him sharp while the architectural and natural background blurs into a soft bokeh. The visual style is photographic and lifestyle-oriented.","keyElements":["Modern glass-and-steel building in background","Out-of-focus green trees on left","Gray crossbody bag strap","Kraft-paper takeaway coffee cup","White pullover sweatshirt","Natural daytime outdoor lighting"],"attributes":["urban lifestyle","bright natural light","clean neutral palette","shallow depth of field","on-the-go tone"]},{"fileName":"GENERIC-TechEveryday-03.mp4","description":"The video is a close-up, torso-level shot focused on a pair of hands operating a dark smartphone, with the subject\'s body visible only from mid-chest to below the waist. The person is wearing a white or off-white long-sleeve sweatshirt layered over a dark collared shirt, with a dark watch visible on the left wrist and a crossbody bag strap running diagonally across the torso. Both hands are shown interacting with the phone screen \u2014 one hand holds the device from below while the other reaches from above, fingers slightly curved as if tapping or scrolling. The background is an out-of-focus urban exterior featuring a large multi-story building with a grid of windows rendered in warm brick and gray tones, along with blurred green foliage and metal bollards at street level. The color palette is muted and neutral \u2014 off-white fabric, dark charcoal phone, warm terracotta and gray building tones in the background. Lighting is natural and even, consistent with outdoor daylight, creating minimal shadow on the hands. The framing is tight and centered on the hands and device, with the depth of field rendering the background as a soft, indistinct blur. The visual style is photographic and detail-oriented, emphasizing the tactile interaction with the device.","keyElements":["Out-of-focus urban building background","Blurred green foliage","White/off-white long-sleeve sweatshirt","Dark crossbody bag strap","Dark watch on wrist","Natural daylight from outdoors"],"attributes":["tight close-up framing","hands-on detail focus","neutral muted tones","urban exterior setting","naturalistic lighting"]},{"fileName":"GENERIC-TechEveryday-04.mp4","description":"The video features a single female subject framed from approximately the upper chest upward in a medium close-up, positioned slightly left of center within the frame. The woman has long straight dark hair worn loosely, light skin, and is dressed in a light gray blazer over a white V-neck top. She is looking downward toward an open laptop computer, the top of which is visible in the lower portion of the frame in a light silver-gray color; her lips are slightly parted as if speaking or reacting. The background is an out-of-focus outdoor urban environment featuring deep teal-toned glass fa\xe7ades of modern buildings and blurred dark green foliage, creating a cool, sophisticated backdrop. The color palette is dominated by cool tones \u2014 slate gray, teal, dark green, and silver \u2014 with the subject\'s light complexion and white top providing contrast. Lighting appears to be natural outdoor light falling from the front-left, creating soft, even illumination on the subject\'s face with minimal harsh shadows. The depth of field is shallow, keeping the subject sharp while the background dissolves into smooth bokeh. The composition is clean and centered, with the laptop grounding the lower frame and drawing the eye upward to the subject\'s face. The visual style is professional and photographic.","keyElements":["Out-of-focus teal glass building facade in background","Blurred dark green foliage","Light gray blazer","White V-neck top","Silver-gray laptop top visible in lower frame","Cool-toned color palette"],"attributes":["professional outdoor setting","cool teal color grading","clean centered composition","shallow depth of field","soft natural lighting"]},{"fileName":"GENERIC-TechEveryday-05.mp4","description":"The video is set in a bright, spacious interior space that resembles a modern educational or computer lab environment, with rows of dark workstations, large circular skylights on the ceiling, and industrial-style exposed ductwork. The scene features two young people seated side by side at a white table in the foreground. The subject on the left, wearing a yellow short-sleeve top and denim overalls, has a black over-ear VR headset covering their eyes and is reaching one arm upward with an open hand, as if interacting with virtual content. On the table in front of them sits a dark tablet on a stand. The subject on the right, wearing a light gray V-neck t-shirt, sits with arms folded on the table surface, leaning slightly forward and looking toward the first subject with a relaxed expression. In the left background, a third person with light hair is partially visible, seated and facing away. The color palette is bright and clean \u2014 white, yellow, denim blue, gray, and black \u2014 with the overall scene dominated by cool whites and neutrals. Lighting is bright and even, likely a combination of overhead artificial light and natural light from the skylights, producing a well-lit, airy environment with minimal shadows. The framing is wide enough to place both foreground subjects in clear focus while the background blurs moderately.","keyElements":["Modern lab/classroom background with computer workstations","Circular skylights and industrial ceiling","White table surface","Dark tablet on a stand","Yellow short-sleeve top and denim overalls","Light gray V-neck t-shirt","Bright overhead and natural lighting"],"attributes":["bright institutional setting","clean white and neutral palette","wide medium shot framing","high-key even lighting","energetic and modern environment"]},{"fileName":"GENERIC-TechEveryday-06.mp4","description":"The video features a single young adult subject positioned centrally in a medium close-up frame, captured from approximately the upper chest upward. The person has short, voluminous curly dark brown hair, light skin, and wears round black-framed glasses with slightly blue-tinted lenses. They are dressed in a light teal or sage-green hoodie layered under a dark navy or black outer jacket, with a tan or beige backpack strap visible over one shoulder. In one hand they hold a dark smartphone, which they are looking down at with a broad, visible smile showing teeth. In the other hand they carry a kraft-paper disposable coffee cup with a white lid. The background is an out-of-focus urban street scene featuring the textured tan stone facade of a building with rectangular window frames visible, a vertical pipe or downspout along the right edge, and blurred green foliage at the far left. The color palette is warm and earthy \u2014 tan stone, sage green, navy, and warm brown \u2014 with natural daylight providing bright, even front illumination on the subject\'s face. The depth of field is shallow, keeping the subject sharp while the background dissolves into soft bokeh. The composition is straightforward and portrait-oriented, with the subject clearly dominating the frame.","keyElements":["Tan stone building facade in background","Blurred green foliage on left","Sage-green hoodie","Dark navy outer jacket","Tan beige backpack strap","Kraft-paper coffee cup with white lid","Natural daytime front lighting"],"attributes":["casual urban lifestyle","warm earthy palette","portrait-style framing","cheerful visible expression","shallow depth of field"]},{"fileName":"GENERIC-TechEveryday-07.mp4","description":"The video presents a tight close-up of a single female subject, framed from just below the chin to above the top of the head, with the face filling the majority of the frame. The woman has straight blonde hair worn loose, light skin, and wears cat-eye-shaped black-framed glasses with lenses that reflect green and teal screen content, suggesting she is looking at a monitor just off the bottom of the frame. She is dressed in a mustard-yellow or golden-yellow top visible only at the very bottom of the frame. Her expression is one of open, broad smiling with visible teeth, conveying an actively positive reaction. The background is very softly out of focus, showing vague warm beige and dark gray tones that suggest an interior space \u2014 possibly a home or office \u2014 with a faint circular white object (possibly a lamp or circular wall fixture) visible to the upper left. The color palette is warm \u2014 golden yellow clothing, warm skin tones, beige background \u2014 with a cool-teal accent from the screen reflection in the glasses. Lighting is soft and warm, appearing to come primarily from the front, creating even, flattering illumination across the subject\'s face. The composition is an extreme close-up portrait that centers on the glasses and expression, filling the frame almost entirely with the face.","keyElements":["Soft warm beige interior background","Faint circular white object upper left","Black cat-eye glasses with green/teal screen reflection","Mustard-yellow top visible at bottom of frame","Warm soft front lighting","Blurred dark gray background tones"],"attributes":["extreme close-up portrait","warm golden palette","high-contrast smile expression","soft interior lighting","screen-reflected accent color"]},{"fileName":"GENERIC-TechEveryday-08.mp4","description":"The video is a low-angle macro-style close-up focused on a pair of hands typing on a silver laptop keyboard, with no face or torso clearly visible in the frame. The hands appear to have light skin and are positioned mid-motion over the keys, fingers slightly raised and in contact with the keyboard surface, suggesting active typing. The laptop body is silver-gray with a backlit keyboard visible in detail. The background is a heavily blurred, bright, and airy environment \u2014 soft green bokeh on the left suggests nearby foliage or a window overlooking vegetation, while a warm cream or white shape in the upper-center area resembles the glow of a lamp or window diffuser, and the right edge fades to a dark out-of-focus tone. The color palette is light and fresh \u2014 silver, cream, soft green, and warm white \u2014 creating a clean, organic atmosphere. Lighting is bright and natural-feeling, likely diffused daylight from the left or a nearby window, producing a gentle glow across the keyboard surface with soft shadows between the keys. The composition is tightly cropped on the keyboard interaction, with no horizon line, making the hands the sole visual anchor. The visual style is photographic and detail-oriented.","keyElements":["Soft green foliage bokeh on left","Warm cream/white lamp or window glow in background","Dark blurred tones on right edge","Silver-gray laptop body","Bright diffused natural-feeling lighting","Low-angle tight framing"],"attributes":["macro close-up detail","fresh light palette","organic background bokeh","soft diffused lighting","minimalist composition"]},{"fileName":"GENERIC-TechEveryday-09.mp4","description":"The video focuses on a partial view of a person\'s arm and hand interacting with a large, thin, transparent or semi-transparent display panel, positioned at a slight diagonal angle across the frame. The person is visible only from the right side of the frame, showing a black jacket sleeve and a portion of a light gray top, with the face entirely out of frame. The hand is reaching forward and making contact with the smooth surface of the translucent panel, and a mirror-like reflection of the hand is visible on the panel\'s surface, creating a doubled, ghosted visual effect. The panel appears to be a frameless or thin-framed transparent screen, edge-lit with a soft blue-teal glow on the lower-left corner. The background, visible through and around the panel, is a brightly lit commercial interior space \u2014 white ceiling with grid lighting, white column, and in the mid-distance, blurred accents of teal, green, and yellow on walls or signage. The color palette is cool and clean \u2014 white, light blue-teal, black, and soft gray \u2014 with high ambient brightness. Lighting is bright and even, consistent with commercial fluorescent or LED overhead lighting, producing a crisp and airy atmosphere. The composition is asymmetric, with the panel dominating the center-left and the person entering from the right edge.","keyElements":["Bright commercial interior background with ceiling grid lighting","Teal, green, and yellow background accent colors","White column in midground","Black jacket sleeve","Light gray top","Cool blue-teal edge glow on panel","Reflective surface creating hand ghost image"],"attributes":["cool minimal palette","bright commercial setting","asymmetric composition","translucent reflective surface","crisp high-key lighting"]},{"fileName":"GENERIC-TechEveryday-10.mp4","description":"The video presents a single female subject standing outdoors on what appears to be an elevated walkway or bridge, framed in a medium shot from the knees upward. The woman has long straight dark hair worn loose, a light complexion, and wears an oversized light gray-green or sage-toned structured coat with large button details running down the front placket. She holds a dark-colored smartphone in both hands, looking downward at the screen with a slight expression of engagement. In the background, a busy multi-lane urban roadway is visible, filled with vehicles whose taillights and headlights create clusters of red and white bokeh circles against a cool blue-gray dusk sky. Tall modern glass-and-steel buildings and city blocks recede into the distance behind a horizontal metal railing that separates the foreground subject from the traffic below. The color palette is cool and cinematic \u2014 sage green, steel blue-gray, muted pinks and reds from the bokeh car lights, and white highlights \u2014 creating an atmospheric urban evening feel. Lighting is low-key and ambient, consistent with dusk or early evening, with the main illumination on the subject coming from soft diffused ambient city light, rendering her face and coat with gentle highlights and cool undertones. The depth of field is shallow, keeping the subject sharp while the traffic and cityscape dissolve into rich bokeh. The composition places the subject on the right side of the frame in a three-quarter profile, with the wide city background occupying the left two-thirds.","keyElements":["Busy multi-lane urban roadway with bokeh car lights","Modern glass-and-steel city buildings in background","Cool blue-gray dusk sky","Metal railing separating subject from traffic","Oversized sage-green structured coat","Red and white bokeh light clusters in background","Cool ambient evening lighting"],"attributes":["cinematic urban atmosphere","cool blue-sage palette","dusk ambient lighting","rich background bokeh","moody wide-city framing"]},{"fileName":"GENERIC-TechEveryday-11.mp4","description":"The video presents a close-up torso-level shot focused on a pair of hands holding and interacting with a dark-cased smartphone, with the subject\'s body visible from the mid-chest to just below the waist. The person is wearing a warm amber or caramel-toned ribbed knit sweater, and a silver analog watch is visible on the right wrist. A gold ring is visible on the left hand. Both hands grip the phone firmly \u2014 one from below, one from the top \u2014 as if typing or tapping. The phone is shown from the back, revealing its black matte case and rear camera module. In the lower right corner of the frame, the out-of-focus edge of a gray laptop is partially visible on a wooden table surface, suggesting a desk setting. The background is a dark, blurred interior with warm amber tones from the sweater dominating the left and upper portions of the frame, and a soft dark gray blur on the right. The color palette is warm and muted \u2014 amber, caramel, deep black, and warm gray \u2014 with a moody, low-key quality to the overall exposure. Lighting appears to be soft and directional, coming from the upper left, casting gentle shadows and highlighting the texture of the knitwear. The composition is tightly cropped with shallow depth of field, centering the interaction between the hands and the device.","keyElements":["Dark blurred interior background","Warm amber ribbed knit sweater","Partially visible gray laptop at bottom right","Wooden table surface","Silver analog watch","Soft directional low-key lighting"],"attributes":["warm moody tone","intimate close-up framing","low-key interior lighting","shallow depth of field","tactile hands-on detail"]},{"fileName":"GENERIC-TechEveryday-12.mp4","description":"The video features a single young female subject framed in a medium close-up from approximately the upper chest upward, positioned centrally within the frame. The woman has long straight dark brown hair with a fringe, light skin, and wears a light pink or dusty rose fine-knit sweater layered under a camel-toned open coat. A tan leather shoulder bag strap is visible over one shoulder. She holds a gold-toned smartphone in both hands, looking down at the screen with a wide, open smile and visibly squinted eyes suggesting genuine delight. The background is a brightly lit outdoor setting with soft teal and green tones from blurred foliage and architectural elements, along with a warm terracotta brick tone to the right, creating a colorful but indistinct backdrop. Natural daylight illuminates the scene brightly from the front, casting warm highlights on the subject\'s face and hair. The color palette is soft and warm \u2014 camel, blush pink, warm tan, and muted greens and teals in the background. The depth of field is shallow, keeping the subject in sharp focus while the background renders as smooth bokeh. The composition is portrait-oriented and centered, with the subject\'s expressive face as the dominant visual element.","keyElements":["Blurred teal and green foliage background","Warm terracotta brick tone on right","Camel-toned open coat","Dusty rose fine-knit sweater","Tan leather bag strap","Bright natural front daylight"],"attributes":["warm soft palette","bright natural daylight","expressive portrait framing","shallow depth of field","cheerful outdoor lifestyle"]},{"fileName":"GENERIC-TechEveryday-13.mp4","description":"The video is an extreme low-angle macro close-up of a dark laptop keyboard, filmed from nearly ground level so the keys recede dramatically into the background with strong perspective distortion. The keyboard has dark charcoal-black keycaps with white letter labels visible \u2014 characters including V, L, O, P, and others are legible in the foreground rows. The key surfaces are rounded and slightly concave, with subtle inter-key gaps catching shadow. In the very top-left of the frame, the out-of-focus blur of a human hand with pinkish fingers is partially visible, suggesting active typing. The background \u2014 the further rows of the keyboard and the area beyond \u2014 blurs quickly into a soft mix of warm cream, cool gray, and faint blue tones, with an indistinct white shape at the upper right suggesting a secondary object such as a cup or device. The color palette is dark and cool in the foreground \u2014 deep charcoal and black \u2014 transitioning to warm cream and neutral gray in the softly blurred background. Lighting appears directional and slightly cool, illuminating the key tops with a diffused gloss while the spaces between keys fall into shadow. The visual style is cinematic and highly stylized.","keyElements":["Warm cream and gray blurred background","Indistinct white shape at upper right","Partially visible blurred hand at top left","Cool directional lighting on keyboard","Strong low-angle perspective distortion","Soft color transition from dark foreground to warm background"],"attributes":["extreme low-angle perspective","dark cool foreground palette","cinematic macro framing","dramatic depth of field","stylized tech detail"]},{"fileName":"GENERIC-TechEveryday-14.mp4","description":"The video features a single female subject framed in a medium shot from approximately the upper chest upward, positioned in the right-center of the frame. The woman has a chin-length auburn bob haircut with a straight fringe, light freckled skin, and wears long dangling gold-and-pearl drop earrings along with a light blue-gray collarless shirt or blouse. She is looking down at a white or silver smartphone held in both hands, on which she appears to be typing with one finger, her lips slightly parted in a subtle expression. The background is a softly blurred interior environment in warm neutral tones \u2014 off-white walls, cream surfaces, and a dark rectangular element such as a door or cabinet visible to the left. A small blurred floral accent of yellow and purple is visible at the lower left corner, suggesting nearby flowers or a plant. The color palette is soft and muted \u2014 blue-gray clothing, warm cream background, amber hair tones, and delicate gold accessories. Lighting is warm and soft, appearing to come from the right side, casting gentle illumination on the subject\'s face and creating a calm, interior feel. The depth of field is shallow, with the background dissolving into smooth bokeh behind the in-focus subject.","keyElements":["Warm off-white blurred interior background","Dark door or cabinet element on left","Small blurred yellow-purple floral accent at lower left","Light blue-gray collarless shirt","Gold-and-pearl drop earrings","Warm soft interior lighting from right"],"attributes":["soft warm interior palette","elegant accessory detail","calm close-up framing","shallow depth of field","quiet lifestyle tone"]},{"fileName":"GENERIC-TechEveryday-15.mp4","description":"The video is a mid-level close-up focused on a pair of hands operating a dark gold-accented smartphone, with the subject visible from approximately the hips to just below the chin. The person is wearing a black crew-neck t-shirt and dark pants, and a black fitness tracker or smartwatch band is visible on the right wrist. Both hands grip and interact with the device \u2014 one holding from below and the other swiping or scrolling across the screen. A dark gray backpack or bag is partially visible lying on the seat to the lower left, suggesting the subject may be seated outdoors. The background is a blurred outdoor setting featuring soft green grass on the left, muted beige architectural columns or walls in the center, and blurred window openings suggesting a public or campus space. The color palette is dark and neutral \u2014 black clothing, dark device, muted green and beige background \u2014 with natural daylight providing bright, even illumination across the hands and device. The depth of field is shallow, with the background blurring uniformly behind the foreground subject. The composition is tightly cropped, centered on the hands and device, with the subject\'s torso providing a dark vertical anchor.","keyElements":["Blurred green grass on left","Muted beige architectural columns in background","Blurred window openings in background","Dark gray backpack visible lower left","Black fitness tracker or smartwatch","Black crew-neck t-shirt and dark pants","Bright natural daylight"],"attributes":["dark neutral palette","tight mid-level framing","outdoor campus setting","natural bright lighting","hands-on device focus"]},{"fileName":"GENERIC-TechEveryday-16.mp4","description":"The video features a single male subject framed in a medium shot from approximately the upper abdomen upward, positioned centrally within the frame. The man has short dark brown hair, a full beard, and wears a beige or camel trench coat over a white dress shirt with the collar open. He holds a dark smartphone in one hand, looking down at it with a visible open smile showing teeth and slightly squinted eyes. Behind him, wide shallow steps of light gray or white stone rise upward across the majority of the background, with a dark gray architectural fa\xe7ade and a glimpse of teal-toned glass visible at the top right corner. The color palette is clean and neutral \u2014 beige and white in the foreground clothing, cool light gray in the stepped stone background, and a hint of teal at the upper edge. Lighting is bright and directional, consistent with strong outdoor sunlight falling from the upper left, creating visible highlights on the subject\'s face and casting soft shadows on the stepped surface behind. The depth of field is moderate, keeping both the subject and the background stairs relatively visible, though with slight softening toward the edges. The composition is upright and centered, with the staircase providing a strong diagonal and geometric backdrop.","keyElements":["Wide light gray stone staircase in background","Dark gray architectural fa\xe7ade at top","Teal glass accent at upper right","Beige trench coat","White dress shirt with open collar","Strong directional outdoor sunlight"],"attributes":["clean neutral palette","geometric staircase backdrop","bright directional sunlight","professional urban tone","centered portrait composition"]},{"fileName":"GENERIC-TechEveryday-17.mp4","description":"The video presents a single female subject in a medium close-up framed from approximately the upper chest upward, facing slightly to the right of the camera. The woman has long straight dark hair worn loose, medium-to-dark skin tone, and wears a pink satin or silky blouse along with a delicate gold chain necklace and small gold stud earrings. A white wireless earbud is visible in her right ear. She faces to the right of the frame with a relaxed smile and a slightly upward gaze, suggesting she may be listening to something or engaged in a hands-free call. The background is a softly blurred interior setting showing a warm cream-toned wall on the right, and on the left, a blurred shelving unit with a cream or white panel and what appears to be teal-green and dark greenish items on shelves, along with a soft lamp glow at the upper left. The color palette is warm and soft \u2014 dusty pink, cream, gold, and muted teal-green \u2014 creating a cozy and feminine interior aesthetic. Lighting is warm and soft, appearing to emanate from the left side, creating gentle highlights on the subject\'s face and hair with no harsh shadows. The depth of field is shallow, with the background blurring smoothly behind the clearly defined subject.","keyElements":["Blurred shelving unit with teal-green accents on left","Soft lamp glow at upper left","Warm cream wall on right","Pink satin blouse","Gold chain necklace and gold stud earrings","White wireless earbud in right ear","Warm soft interior lighting from left"],"attributes":["warm cozy interior","soft feminine palette","close portrait framing","gentle side lighting","shallow background blur"]},{"fileName":"GENERIC-TechEveryday-18.mp4","description":"The video features a single female subject seated at a light wood desk in a bright, plant-filled interior space, framed in a medium shot from approximately the hips upward. The woman has long, loosely curled dark hair, light olive skin, and wears a mustard-yellow or golden-orange loose button-up blouse with a mandarin collar and wide sleeves. She is leaning slightly forward, hands on the keyboard of an open silver laptop positioned in front of her, with a focused, neutral expression directed toward the screen. On the desk surface around the laptop, several items are visible: papers or a notebook, a small stack of cards or documents, and on the right, a white ceramic mug and what appears to be a notebook or book. In the background, multiple green potted plants are arranged on the left and right sides, with large windows allowing bright diffused natural light to enter from the upper right, and white shelves with small objects are visible on the upper left. A blurred pink cushion is partially visible to the left mid-frame. The color palette is bright and botanical \u2014 mustard yellow, white, cream, and multiple shades of green \u2014 with a clean, airy feel. Lighting is bright and natural, predominantly from the right-side window, creating a soft and welcoming work-from-home atmosphere.","keyElements":["Multiple green potted plants in background","Large windows with diffused natural light on right","White shelves with objects on upper left","Light wood desk surface","White ceramic mug on right","Papers and notebook on desk","Blurred pink cushion on left","Mustard-yellow wide-sleeved blouse"],"attributes":["bright botanical interior","warm golden palette","wide lifestyle shot","natural window lighting","work-from-home aesthetic"]},{"fileName":"GENERIC-TechEveryday-19.mp4","description":"The video features a single female subject framed in a medium shot from approximately the hips upward, positioned centrally and slightly lower in the frame with the background occupying the upper half of the shot. The woman has shoulder-length wavy hair with warm highlights, medium-dark skin tone, and wears a light gray blazer over a white turtleneck top. A thin gold chain necklace and a small coin pendant are visible at the neckline, along with a round-faced analog watch on her left wrist and a caramel-toned crossbody bag strap over her shoulder. She holds a mint green smartphone case in both hands, looking down at the screen with a wide, open smile. Behind her, two large glass-and-steel commercial building facades create a bright urban backdrop \u2014 a teal-blue glazed building on the left and a white concrete and glass structure on the right, with a pale blue sky visible between them. Small green bushes appear at the lower left. The color palette is bright and fresh \u2014 mint green, light gray, white, teal-blue, and pale sky blue \u2014 creating a clean, sunlit daytime feel. Lighting is bright natural sunlight from above-front, creating strong but soft highlights on the subject\'s face and clothing.","keyElements":["Teal-blue glazed commercial building on left","White concrete and glass building on right","Pale blue sky in upper center","Small green bushes at lower left","Light gray blazer","White turtleneck top","Caramel crossbody bag strap","Mint green smartphone case"],"attributes":["bright urban daytime setting","clean fresh color palette","professional lifestyle tone","strong natural sunlight","wide medium portrait framing"]},{"fileName":"GENERIC-TechEveryday-20.mp4","description":"The video presents a single male subject framed in a medium close-up from approximately the upper chest upward, positioned centrally in the frame. The man has curly auburn or ginger hair, fair skin, a full reddish beard, and wears round dark-framed glasses. He is dressed in a dark navy or black overcoat with a gray-brown scarf wrapped around his neck. He holds a dark smartphone in one raised hand, looking down at it with a broad, wide-open smile and slightly squinted eyes suggesting a visibly positive reaction. The background is an out-of-focus urban exterior showing a weathered warm red-brick building fa\xe7ade with large window frames outlined in dark teal or dark green, creating a warm, rustic urban backdrop. The color palette is rich and warm \u2014 auburn hair, warm red-brick background, dark navy coat, and gray-brown scarf \u2014 with a golden quality to the lighting. Lighting appears to be warm directional sunlight from the upper left, creating strong golden highlights on the subject\'s face, hair, and coat against the darker background. The depth of field is moderate, keeping the subject sharp while the brick wall background softens slightly. The overall visual style is photographic and lifestyle-oriented with a warm autumnal feel.","keyElements":["Weathered red-brick building fa\xe7ade in background","Dark teal or green window frames in background","Dark navy overcoat","Gray-brown wrapped scarf","Round dark-framed glasses","Warm golden directional sunlight from upper left"],"attributes":["warm autumnal palette","rich textured backdrop","golden directional sunlight","casual urban lifestyle","expressive portrait framing"]},{"fileName":"GENERIC-TechEveryday-21.mp4","description":"The video features two young female subjects standing side by side outdoors in a medium shot, framed from approximately the hips upward. The subject on the left has long braided gray-blonde hair and wears a light gray or off-white hoodie, with a dark backpack strap visible over her shoulder; she is leaning in toward the right subject and pointing at the phone screen with one finger, her face showing a smile. The subject on the right has natural curly dark hair pulled into a high bun and wears a light gray hoodie, with large white over-ear headphones resting around her neck; she holds a dark smartphone in both hands and also smiles broadly. Both subjects are dressed in matching or closely similar light gray hooded sweatshirts, giving a coordinated appearance. The background is an urban exterior setting with a blurred dark gray wall or building surface on the right and a wider blurred scene on the left showing what appears to be an overpass or elevated structure in a muted gray tone, with a pale overcast sky above. The color palette is cool and monochromatic \u2014 light gray, off-white, and dark charcoal \u2014 with minimal color accent beyond the subjects\' skin tones. Lighting is soft and even, consistent with overcast outdoor daylight, producing minimal shadows and a flat, diffused quality across the scene.","keyElements":["Blurred dark gray building or wall on right","Blurred overpass or elevated structure on left","Pale overcast sky in background","Light gray matching hooded sweatshirts","Dark backpack strap on left subject","White over-ear headphones on right subject","Soft overcast diffused lighting"],"attributes":["cool monochromatic palette","urban overcast setting","coordinated casual styling","soft flat diffused light","shared-screen social moment"]},{"fileName":"GENERIC-TechEveryday-22.mp4","description":"The video features a single male subject framed in a medium shot from approximately the hips upward, positioned centrally within the frame. The man has short dark brown hair, a short beard, and wears a medium blue chambray or denim button-up shirt with the sleeves rolled to the forearm, layered over a white undershirt with the collar visible. He holds a dark smartphone in both hands at mid-chest height, looking down at it with a visible smile. Behind him, a large glass-and-steel commercial building fa\xe7ade occupies the right portion of the background, its glass panels reflecting greens and blues from the surroundings. To the left, blurred green trees and a lighter architectural structure are visible, along with a small red banner or sign partially visible at the lower right. The color palette is fresh and clean \u2014 denim blue, white, cool green, and glass-reflected blues \u2014 creating a bright daytime urban feel. Lighting is bright natural outdoor light from above, creating clear but soft illumination across the subject with mild shadows. The depth of field is moderate, with the subject in focus and the background softly blurred. The composition is wide enough to show both the subject and a substantial portion of the urban backdrop.","keyElements":["Large glass-and-steel building fa\xe7ade on right","Blurred green trees on left","Lighter architectural structure on left","Small red banner at lower right","Medium blue chambray button-up shirt","White undershirt with collar visible","Bright natural overhead daylight"],"attributes":["fresh clean urban palette","wide medium portrait framing","bright outdoor daylight","casual professional style","glass-and-green backdrop"]},{"fileName":"GENERIC-TechEveryday-23.mp4","description":"The video presents a single young male subject filmed from a low, slightly upward-looking angle in a wide medium shot that captures him from approximately the knees upward. The subject stands beneath a large concrete overpass or elevated structure, the beams of which create bold diagonal lines converging toward a strip of pale blue sky visible at the center top of the frame. The young man has medium-length wavy light brown hair, fair skin, and wears a rust-orange or terracotta beanie hat, a dark teal or forest green oversized hoodie layered over a white long-sleeve shirt with the cuffs visible, and dark pants. He holds a dark smartphone in one hand at mid-torso height, looking down at the screen with a neutral expression. In his other hand, partially behind his body, a skateboard is visible. To the left of the frame, bright yellow-green autumn trees are visible in the open space beyond the overpass pillars, and a modern gray-and-teal building facade is visible to the right. The color palette is rich and varied \u2014 deep green, terracotta orange, cool concrete gray, and bright autumn yellow-green \u2014 with warm late-afternoon daylight illuminating the scene. The composition is dramatic and wide, with the architectural beams framing the subject from above.","keyElements":["Large concrete overpass beams as dominant framing element","Pale blue sky strip at top center","Bright yellow-green autumn trees on left","Gray-and-teal modern building on right","Rust-orange terracotta beanie hat","Dark teal or forest green oversized hoodie","Skateboard partially visible","Warm late-afternoon daylight"],"attributes":["dramatic low-angle framing","rich autumnal color palette","urban architectural structure","wide environmental shot","youthful street aesthetic"]},{"fileName":"GENERIC-TechEveryday-24.mp4","description":"The video features two older adult subjects seated side by side on a light beige or cream upholstered sofa in a bright, airy interior living space, framed in a medium shot from approximately the hips upward. The subject on the left is a man with gray-white hair, a short gray beard, and rectangular framed glasses; he wears a medium blue denim button-up shirt and is looking down at an open dark laptop resting on his lap or a low surface in front of him. The subject on the right is a woman with straight gray-white hair cut to chin length, wearing a pale yellow-green or sage collared shirt under a light gray open cardigan; she holds a white ceramic mug in both hands and is turned slightly toward the man, her mouth slightly open as if speaking. Behind them, a bright interior is visible \u2014 large windows on the left allow abundant natural light to enter, and a white open staircase railing is visible on the upper right. A decorative beige throw pillow is visible on the far left of the sofa. The color palette is soft and neutral \u2014 cream, light gray, pale sage, denim blue, and white \u2014 with abundant natural daylight creating a bright, clean, and warm-toned interior atmosphere. Lighting is bright and soft, dominated by natural window light from the left.","keyElements":["Large windows with natural light on left","White open staircase railing on upper right","Beige upholstered sofa","Decorative beige throw pillow","Dark laptop on subject\'s lap","White ceramic mug","Pale sage shirt and light gray cardigan","Medium blue denim shirt"],"attributes":["bright airy home interior","soft neutral palette","natural window light","warm domestic lifestyle","wide two-person medium shot"]},{"fileName":"GENERIC-TechEveryday-25.mp4","description":"The video features a single female subject framed in a medium close-up from approximately the upper chest upward, positioned slightly left of center in the frame. The woman has long, loosely wavy dark hair, dark skin, and wears a cream or off-white structured jacket over a coral or salmon-toned top visible at the neckline. She holds a dark smartphone in one hand while the other arm is bent at the elbow with her fist raised in front of her chest in a celebratory gesture. Her expression is one of wide-open, full-toothed laughter or exclamation, with eyes squinted tightly, conveying a highly visible and emphatic reaction. The background is a softly blurred warm interior setting \u2014 a light beige or off-white wall on the right, blurred green foliage from houseplants visible on the left, and a blurred warm brownish-orange element in the upper right, suggesting a shelf or furniture. A soft white or cream light source is partially visible on the upper left. The color palette is warm and inviting \u2014 cream, coral, soft green, and warm amber tones in the background \u2014 with the bright, airy feel of a naturally lit indoor space. Lighting is warm and soft, appearing to come from the upper left, creating gentle highlights on the subject\'s face and a flattering, low-shadow quality.","keyElements":["Blurred green houseplants on left","Light beige or off-white wall on right","Blurred warm brownish-orange furniture or shelf at upper right","Soft white light source at upper left","Cream off-white structured jacket","Coral or salmon top at neckline","Warm soft interior lighting from upper left"],"attributes":["warm inviting interior","cream and coral palette","emphatic expressive reaction","soft natural-feel lighting","close portrait framing"]}]}');


var $cf4ed70b876ffabf$exports = {};
$cf4ed70b876ffabf$exports = JSON.parse('{"items":[{"fileName":"GENERIC-FinancialData-01.mp4","description":"The video is an extreme close-up composite shot in which a human face \u2014 specifically the area from the nose to just above the eyebrows \u2014 is overlaid with semi-transparent digital financial data, creating a double-exposure or screen-projection visual effect. The subject appears to be a male with dark skin and short hair, wearing thin black-framed glasses, with one eye clearly visible at the center-right of the frame, reflecting miniature chart data in its surface. The digital overlay covering the entire frame consists of two types of financial data: on the left portion, a dense candlestick chart with teal/green and red candles plotted against a dark background with curved blue trend lines running horizontally; on the right portion, a scrolling table of numerical values rendered in green and red text, indicating positive and negative market figures with decimal precision. The candles are rendered in a glowing neon teal and red, giving an energetic, high-contrast visual quality. The overall color palette is dark and cool \u2014 deep teal, neon cyan, red, and dark charcoal \u2014 with the warm brown skin tones of the subject partially visible beneath the data overlay. Lighting on the subject appears to be low-key and directional, creating dramatic shadows, while the overlay data itself acts as the primary light source across the frame. The visual style is cinematic and stylized, combining photographic portraiture with digital data visualization.","keyElements":["Candlestick chart overlay covering left half of frame","Numerical data table overlay on right half in green and red","Curved blue trend lines across chart area","Dark charcoal background behind overlaid data","Thin black-framed glasses","Low-key dramatic directional lighting on subject","Neon teal and red glow from chart elements"],"attributes":["cinematic double-exposure style","dark neon color palette","dramatic low-key lighting","data-overlaid portrait","high visual intensity"]},{"fileName":"GENERIC-FinancialData-02.mp4","description":"The video presents an outdoor urban night scene filmed in a wide, slightly low-angle perspective, dominated by a large LED ticker board or electronic display screen occupying the right half of the frame. The display panel is covered in a fine matrix of illuminated dots rendering teal-green, white, and blue text and numerals that appear to scroll or update \u2014 partially legible characters suggest stock ticker or market data. The left half of the frame shows a blurred nighttime city street scene: multiple pedestrians in dark winter clothing are walking along a wide pavement, their forms reduced to soft silhouettes and blue-tinted blurs by the shallow depth of field. The street is lined with vertical black poles and reflective glass surfaces, with numerous globe-shaped white street lamps creating chains of warm bokeh circles stretching into the distance. Further in the background, tall buildings with blue-tinted glass facades and signage glow with teal and cool white light. A small red rectangular element \u2014 possibly a sign or light \u2014 is visible in the mid-background. The color palette is almost entirely cool \u2014 deep teal, cyan, blue-gray, and white \u2014 with warm amber appearing only in the street lamp bokeh. Lighting is entirely artificial, atmospheric, and immersive, dominated by the glow of the LED panel and the ambient city light. The visual style is photographic with a cinematic, motion-blurred quality.","keyElements":["Large LED ticker display panel on right half of frame","Blurred city street pedestrians on left","Chain of globe-shaped white street lamps creating bokeh","Tall glass building facades with teal glow in background","Small red sign or light in mid-background","Cool teal-blue overall color grading","Vertical black street poles"],"attributes":["cool teal-blue night palette","urban nighttime atmosphere","motion-blurred street scene","LED display dominance","cinematic bokeh lighting"]},{"fileName":"GENERIC-FinancialData-03.mp4","description":"The video is a direct screen recording or close-up capture of a multi-panel financial trading platform interface displayed on a dark-background monitor. The upper portion of the frame shows a candlestick price chart with teal-green and red-orange candles plotted across a dark charcoal grid, accompanied by two curved indicator lines \u2014 one white and one pink-red \u2014 representing moving averages or similar overlays. Small white downward-pointing arrows are placed above the chart at intervals, marking signal or alert points. Vertical red dashed lines divide the chart into labeled date sections, with timestamps including dates such as 5/20/16, 6/17/16, 7/15/16, and 8/19/16 partially visible in red text. A volume bar histogram in teal and red columns runs along the bottom of the chart area. Below a thin horizontal divider, two additional sub-panels occupy the lower half of the frame: a MACD-style oscillator histogram panel with green and red bars and a curved line overlay in green, and a lower indicator panel with small red vertical bars and a flat dotted line. A bright blue-white lens flare or light streak sweeps diagonally from the upper right, adding a dynamic illuminated element to the otherwise data-dense composition. Text labels on the lower left include a partially visible label reading \'ENTIAL, no\' and a numerical value \'-0.911834\' along with \'10426\'. The color palette is dark and cool \u2014 deep charcoal, teal, red-orange, white, and green \u2014 consistent with a dark-themed trading terminal.","keyElements":["Candlestick price chart with teal and red-orange candles","White and pink-red moving average lines","White downward-pointing signal arrows on chart","Vertical red dashed date-section dividers","Volume histogram in teal and red","MACD-style oscillator sub-panel with green and red bars","Bright blue-white diagonal lens flare","Dark charcoal grid background"],"attributes":["dark trading terminal aesthetic","data-dense screen interface","cool charcoal and teal palette","multi-panel chart layout","dynamic lens flare accent"]},{"fileName":"GENERIC-FinancialData-04.mp4","description":"The video presents an animated or rendered three-dimensional financial chart scene on a deep royal blue background, filmed or rendered at a slight diagonal angle that gives the composition a tilted, dynamic perspective. The primary chart element is a candlestick chart rendered in a salmon-orange or coral color, with individual candle bodies and wicks clearly defined and distributed across the center of the frame in a slightly upward-trending pattern. Overlaying the candlestick data are three colored indicator lines: a bright neon cyan-blue line, a bright green line, and a bright pink-magenta line, each following a different oscillating path across the chart. The background is a uniform deep blue with a faint grid of thin white or light blue lines forming a square mesh pattern across the entire surface, giving the scene a graphical or data-dashboard quality. Scattered across the frame at various positions are small percentage labels in light blue text \u2014 values including 0.36%, 0.68%, 0.65%, 0.48%, and 0.18% \u2014 floating against the dark blue grid. In the lower portion of the frame, a faint ghost or secondary line chart in very light translucent blue is barely visible. The color palette is exclusively cool and saturated \u2014 deep navy blue, neon cyan, coral-orange, neon green, and hot pink \u2014 with no warm ambient tones. Lighting is self-illuminated and graphic, consistent with a digital render or animated data visualization. The visual style is modern, illustrative, and data-focused.","keyElements":["Deep royal blue grid background","Diagonal tilt of the entire chart composition","Coral-orange candlestick chart elements","Neon cyan-blue indicator line","Bright green indicator line","Hot pink-magenta indicator line","Floating percentage labels in light blue text","Faint secondary ghost line chart at bottom"],"attributes":["vibrant neon color palette","deep blue digital backdrop","animated data visualization style","dynamic diagonal composition","multi-line indicator overlay"]},{"fileName":"GENERIC-FinancialData-05.mp4","description":"The video presents a close-up overhead or tilted view of a tablet or digital device screen displaying a financial report or dashboard document, with two human hands interacting with the screen using a stylus pen. The hand on the left side of the frame holds the tablet from the edge, with the thumb and fingers visible along the left border. The right hand holds a slim silver or white stylus, positioned mid-frame and pointing at or drawing on the screen content. The screen content visible is a multi-section financial document with a white background: at the top, a heading beginning with \'Financial P-\' (partially cropped) and a body of small grey placeholder text in Latin-style lorem ipsum formatting. Below this is a data table labeled by month (Jan through Dec) with four quarterly columns (Q1, Q2, Q3, Q4) filled with large numerical values in the millions range. To the lower left of the table is a pie chart labeled \'Plan A\' in multiple shades of blue, with a large segment labeled 58%. To the upper right of the table, a partially visible line chart with orange and blue lines is visible. At the right edge of the frame, a partially visible second pie chart labeled \'Plan B\' appears. The surrounding physical environment is dark, with the glowing screen providing the only primary light source in the frame. The color palette of the screen is clean white, blue, and orange against a very dark physical background.","keyElements":["Dark surrounding environment contrasting with bright screen","Slim silver or white stylus held in right hand","Financial data table with quarterly columns on screen","Blue multi-segment pie chart labeled \'Plan A\' with 58% segment","Partially visible \'Plan B\' pie chart on right edge","Orange and blue line chart at upper right of screen","White document background on tablet screen"],"attributes":["high contrast dark-surround and bright screen","clean white financial document style","close overhead framing","blue and orange data visualization palette","stylus interaction detail"]},{"fileName":"GENERIC-FinancialData-06.mp4","description":"The video features a real-world workspace environment in which a person is interacting with two screens simultaneously. The scene is filmed from a medium-angle position, with the majority of the frame filled by a large dark-themed trading platform displayed on a wide monitor occupying the right and center portions of the frame. On the monitor, a candlestick chart with teal-cyan and pink-red candles is visible on the left portion of the screen, accompanied by numerical price axis values ranging from approximately 2882.5 to 2917.5, a volume histogram at the bottom, and interface elements labeled \'Compare\' and \'Save\' at the top. To the right of the chart on the monitor, a live order book panel is displayed with columns labeled \'Bid\', \'Bid Price\', and \'Ask\', populated with scrolling numerical values in white, green, and red text. A \'Market Trades\' section with \'Price\', \'Size\', and \'Time\' columns is visible at the bottom right of the monitor. A red downward arrow price indicator shows \'2903.7\' at the upper right of the screen. In the lower-left foreground, a dark laptop displaying the same or similar trading interface at smaller scale is visible on a light wood desk surface, with a human hand and forearm partially visible resting near the keyboard. A second hand holding a black pen is pointed toward the large monitor screen. Small yellow sticky notes are visible near the monitor base. The background behind the screens shows a bright, airy modern office or trading space with large floor-to-ceiling windows, warm wood-toned structural elements, and a white reflective floor, creating a contrast between the dark digital content and the bright physical environment. The color palette splits clearly between the dark blue, teal, and red of the screens and the warm beige, wood, and white of the office interior.","keyElements":["Large dark-themed monitor with candlestick chart and order book","Dark laptop with matching trading interface in lower-left foreground","Light wood desk surface","Small yellow sticky notes near monitor base","Black pen held pointing at screen","Large floor-to-ceiling office windows in background","Warm wood structural elements in background","White reflective office floor"],"attributes":["dual-screen trading workspace","dark digital interface on bright office backdrop","teal and red data palette","professional trading environment","wide medium shot with environmental context"]}]}');


var $5dfabec2e794b522$exports = {};
$5dfabec2e794b522$exports = JSON.parse('{"items":[{"fileName":"GENERIC-AbstractBackgrounds-01.mp4","description":"The video presents a fully abstract, digitally generated animated background composed of smooth, flowing gradient waves that move and shift continuously across the entire frame. The composition features broad, soft diagonal bands of color that blend seamlessly into one another without hard edges or defined shapes. The dominant colors are a deep violet-purple on the upper left, transitioning into warm coral-red and orange in the center and lower right, with bands of pale icy blue-white cutting diagonally from upper right to lower center. Secondary tones of muted lavender and pink-red emerge where colors blend. The motion across the video is slow and fluid \u2014 the color masses appear to undulate and shift as if viewed through a gently distorted lens, creating an impression of silk or liquid in slow movement. The surface has a soft, slightly glossy quality with subtle undulations that catch implied light. No recognizable objects, text, or environmental elements are present. The entire frame is filled edge-to-edge with the gradient composition, with no black, dark, or neutral zones. The color palette is vivid and saturated, with equal weight given to cool violet tones and warm red-coral tones. The visual style is smooth, synthetic, and digital \u2014 characteristic of motion-graphics background design with a contemporary aesthetic.","keyElements":["Dominant color hues and their proportional balance","Direction and angle of color band flow","Color saturation intensity","Speed and amplitude of wave motion","Presence or absence of dark or neutral zones"],"attributes":["smooth flowing gradient waves","vivid purple and coral contrast","soft liquid motion feel","fully digital abstract style","saturated color-field composition"]},{"fileName":"GENERIC-AbstractBackgrounds-02.mp4","description":"The video presents a digitally rendered abstract animated background depicting flowing, ribbon-like forms with an iridescent, holographic surface quality. The composition is filled with multiple overlapping curved bands or streams that twist and weave across the frame, each exhibiting a smooth, reflective surface that shifts between multiple colors simultaneously, creating a chromatic shimmer reminiscent of oil film or iridescent foil. The color range visible across the bands includes pastel lavender-blue, hot magenta-pink, warm peach-orange, bright yellow-gold, soft cyan, and white highlight zones where bands catch implied light at their crest. The background field \u2014 the areas between and behind the ribbons \u2014 is a warm pale peach and pink-gradient, gently luminous. The overall composition has a bright, high-key quality with no dark zones; even shadows within the ribbon folds appear as pastel rather than deep shadow. The forms flow in a dynamic, layered pattern from left to right and crossing diagonally, giving a sense of continuous movement and depth as near ribbons overlap far ones. No recognizable objects or text are present. The visual style is polished, modern, and decorative \u2014 consistent with premium motion-graphic design for cosmetics, fashion, or beauty applications.","keyElements":["Ribbon iridescence color range and shimmer intensity","Background base color behind ribbon forms","Density and layering of ribbon elements","Overall brightness and key-light level","Direction of ribbon flow across frame"],"attributes":["iridescent holographic ribbons","bright pastel high-key palette","flowing silk-like motion","premium beauty aesthetic","multicolor chromatic shimmer"]},{"fileName":"GENERIC-AbstractBackgrounds-03.mp4","description":"The video presents a digitally generated abstract animated background composed of a dense array of vertical bars or column-like forms that span the full height of the frame, arranged side by side across the full width. The bars have a three-dimensional, slightly rounded appearance suggesting cylindrical or prismatic columns illuminated from one side. On the left side of the frame, the bars are rendered in deep dark navy blue, appearing nearly black, with only subtle tonal variation distinguishing individual columns. Moving toward the right side of the frame, a gradient progression shifts the colors from near-black navy through dark teal into vivid electric teal-green and bright cyan, culminating in the rightmost columns glowing with an intense, saturated mint-green and electric blue. The transition creates a spectral fade from left-darkness to right-brightness. The video animates by shifting this gradient pattern horizontally, so the illuminated zone moves laterally across the columns over time, as if a light source is scanning across the surface from right to left. No background is visible; the columns fill the entire frame. No text, objects, or recognizable elements are present. The visual style is clean, geometric, and technical \u2014 evocative of data visualization, audio equalizer displays, or futuristic digital interfaces.","keyElements":["Column count density and width","Color gradient range from dark to bright","Direction and speed of gradient animation sweep","Background visibility between columns","Color temperature of illuminated zone"],"attributes":["geometric vertical column array","dark navy to bright cyan gradient","scanning light animation","technical data-viz aesthetic","high-contrast edge illumination"]},{"fileName":"GENERIC-AbstractBackgrounds-04.mp4","description":"The video presents a digitally generated abstract animated background composed of a dense array of vertical fin or blade-like forms that curve and undulate across the frame, rendered against a near-total black background. The fins have a three-dimensional curvature, each appearing as a narrow, elongated surface that twists and bends, with the illuminated inner or edge surfaces catching vivid neon light. The colors distributed across the fins vary dramatically from left to right and change over time through animation: on the left, fins display deep electric purple and dark violet tones; moving toward the center, vivid cobalt blue and sky blue appear; the central zone transitions into hot magenta-pink and deep crimson reds; and the right side returns to dark violet and deep red-maroon tones. Scattered throughout the composition, bright orange and amber flame-like color accents appear at the lower regions, and bright cyan or teal highlights touch the upper fin edges. The animation causes the wave pattern undulating through the fin array to move continuously, creating a rippling, curtain-like effect. The overall impression is of an illuminated pleated surface in motion. No text or recognizable elements are present. The visual style is dynamic, high-energy, and futuristic \u2014 suited to entertainment, nightlife, or technology visual contexts.","keyElements":["Dominant color zones and their distribution","Amplitude and frequency of wave undulation","Background darkness level","Brightness and saturation of neon accent colors","Direction of wave motion across frame"],"attributes":["neon-lit pleated fin array","deep dark background with vivid color","dynamic rippling wave motion","futuristic nightclub aesthetic","high-saturation multicolor neon palette"]},{"fileName":"GENERIC-AbstractBackgrounds-05.mp4","description":"The video presents a digitally generated abstract animated background depicting a soft, smooth gradient field of light in cool jewel tones, resembling an aurora or ambient light fog. The composition is dominated by a mid-field of medium cobalt blue occupying the central and right-center areas of the frame, blending upward into bright mint-green and teal at the upper edges, particularly in the upper left and upper right corners. The lower right transitions into a warm, deep violet-purple. On the left side, a bright vivid cyan point of light is visible \u2014 a small, intense glowing node surrounded by fine radiating tendrils or fluid wisps of brighter teal, suggesting a concentrated energy source or particle emission point. This point element creates the most structurally defined feature in the otherwise uniformly soft composition. The animation causes the color zones to slowly drift and pulse, with the gradient field shifting gently as if the light source beneath is moving slightly. The entire image has a smooth, out-of-focus quality with no sharp edges anywhere. No text, objects, or realistic elements are present. The color palette is cool and jewel-toned throughout \u2014 cyan, teal, cobalt, violet \u2014 with no warm hues. The visual style is ambient, ethereal, and atmospheric, suitable for technology, wellness, or music visualization contexts.","keyElements":["Color zone distribution across frame","Intensity and position of the bright cyan point element","Gradient softness and edge definition","Animation drift speed and direction","Overall color temperature warmth or coolness"],"attributes":["soft aurora gradient field","cool jewel-tone palette","ambient glowing light source","ethereal atmospheric quality","slow pulsing drift animation"]},{"fileName":"GENERIC-AbstractBackgrounds-06.mp4","description":"The video presents a digitally rendered three-dimensional animated abstract composition featuring multiple large, irregular organic shapes resembling crumpled or torn fabric fragments, floating and tumbling in a dark teal-blue void. The shapes are rendered with a dense, granular surface texture \u2014 appearing covered in fine particulate or bead-like micro-detail \u2014 suggesting a material somewhere between crumpled foil, dried organic tissue, or a heavily textured fabric. The forms are richly multicolored: prominent shapes display vivid yellow-orange and deep red-amber tones, others appear in bright emerald and teal green, and additional surfaces show electric blue, deep indigo-navy, and iridescent pink-lavender. The colors across each shape transition and blend, giving each form a painterly multicolored surface. Between the shapes, thin filament-like strands or tendrils connect and extend from their torn edges, rendered in teal and blue. The background environment is a consistent muted dark teal-blue fog, providing depth and context without additional complexity. The animation causes the shapes to slowly rotate, tumble, and drift as if weightless in fluid. No text or recognizable objects are present. The visual style is highly detailed, three-dimensional, and surrealistic \u2014 consistent with high-end generative CGI art or premium abstract motion design.","keyElements":["Background void color and depth","Shape surface texture type and density","Color distribution across individual shape surfaces","Number and scale of floating form elements","Filament or tendril color and visibility"],"attributes":["floating 3D organic forms","granular micro-textured surfaces","vivid multicolor painterly shapes","dark teal void environment","surrealistic CGI abstract style"]},{"fileName":"GENERIC-AbstractBackgrounds-07.mp4","description":"The video presents a digitally generated abstract animated background built from an extremely dense field of fine, hair-like or fiber-like particles \u2014 rendered as countless tiny filaments radiating and flowing in a radially symmetric pattern from a dark central void toward the frame\'s edges. The composition has a strong centripetal structure: at the very center, an irregularly shaped dark black-blue void or opening anchors the composition, surrounded by tightly packed radial fibers that point inward toward it, creating a vortex-like or eye-like visual impression. Moving outward from the center void, the fibers become progressively denser and brighter, shifting in color from deep midnight blue through medium electric blue to vivid bright cyan at the outer frame edges. The texture throughout the frame is extremely fine and particulate \u2014 thousands of individual micro-strands filling every area \u2014 creating a rich, fabric-like or biological surface quality, similar to microscopic imagery of velvet, feathers, or cellular structures. Scattered throughout the mid-zone, organic bubble-like or foam-like patches of pale translucent blue provide textural contrast. The animation causes the entire field to slowly pulse and shift radially, as if the surface is breathing. No text or recognizable elements are present. The color palette is entirely monochromatic blue \u2014 from near-black at the center to vivid electric cyan at the periphery. The visual style is highly detailed, biological in character, and deeply immersive.","keyElements":["Central void size, shape, and darkness","Fiber density and radial pattern orientation","Outer edge brightness and cyan saturation","Organic bubble-patch distribution","Animation pulse speed and amplitude"],"attributes":["radial fiber vortex structure","monochromatic blue micro-texture","dense particle filament field","biological microscopic aesthetic","dark center to bright cyan gradient"]},{"fileName":"GENERIC-AbstractBackgrounds-08.mp4","description":"The video presents a macro-photography or close-up film shot of real liquid paint or fluid pigments swirling and mixing on a flat surface, captured from directly above. The composition fills the entire frame with vividly colored fluid forms in a state of active, slow-motion mixing. Large zones of vivid colors are visible: a dominant area of intense saturated red-orange occupies roughly the upper center and left-center of the frame; bright neon yellow-green fills the lower center and right zones; royal blue and deep violet-blue appear in the left and upper-left portions; and bright teal-cyan emerges along the interface between the red and yellow zones. These color regions meet at flowing, irregular boundary lines that curve and intermingle, creating thin streaks where colors blend \u2014 teal at the edge of the red-yellow interface, purple-pink where blue meets red. The surface has a flat, liquid sheen \u2014 slightly reflective and uniformly matte, consistent with real fluid paint. Occasional small dark specks or air bubbles are visible at the very edges. The animation shows the colors slowly shifting and mixing as the fluid moves. No text, objects, or other elements are present. The color palette is fully saturated primary and secondary colors at maximum intensity. The visual style is physical, tactile, and raw \u2014 characteristic of acrylic or oil pour painting documentation.","keyElements":["Dominant color zones and their relative proportions","Boundary line curvature and mixing zone width","Surface sheen and reflectivity","Overall color saturation and brightness","Presence and color of thin blend-zone transition tones"],"attributes":["real fluid paint pour macro","maximum-saturation primary palette","organic liquid swirl motion","physical tactile surface quality","full-frame color field composition"]},{"fileName":"GENERIC-AbstractBackgrounds-09.mp4","description":"The video presents a close-up or macro shot of a physical painted surface that moves gradually through the frame \u2014 either from a slow camera pan or physical movement of the surface \u2014 revealing the textured layers and torn edges of a heavily painted canvas or board. The composition shows three primary colors applied in broad, overlapping strokes: a large zone of clean white paint occupies the lower-left quadrant, with rough, scraped-paint edges that reveal underlying layers; an intense, vivid red-orange covers the upper and right portions of the frame, applied in thick horizontal brushstroke textures with raised ridges visible; and a near-black dark color \u2014 visible through torn or scraped areas of the red paint layer \u2014 forms irregular blotchy patches across the red zone, exposing the underlying ground or textile beneath the red. The transitions between the white and red zones are sharp and irregular, with jagged torn-edge forms. The red zone shows visible brush-texture directionality \u2014 horizontal streaks with ridged, impasto-quality paint application. The dark zones appear where the red paint has been scraped away, revealing either a black base layer or the dark weave of a canvas support beneath. The motion across the video is a slow lateral or upward pan revealing new areas of the painted surface. No text or recognizable imagery is present. The color palette is stark and graphic: white, red, and black only. The visual style is boldly textural and raw \u2014 resembling abstract expressionist painting or contemporary art documentation.","keyElements":["Red paint brushstroke texture direction and ridge density","White zone edge sharpness and shape","Dark underlying layer visibility and distribution","Overall surface reflectivity and paint sheen","Camera or surface motion speed and direction"],"attributes":["abstract expressionist paint surface","stark red-white-black palette","heavy impasto texture visible","raw torn-edge composition","slow panning macro movement"]},{"fileName":"GENERIC-AbstractBackgrounds-10.mp4","description":"The video presents a digitally generated abstract animated background consisting of a smooth, featureless gradient that slowly shifts and pulses between deep dark tones in the blue-violet-magenta spectrum. At any given moment, the frame is filled with a single continuous radial or field gradient \u2014 entirely devoid of texture, shapes, or structural elements. Early in the video, the dominant tone is an extremely deep, near-black indigo-navy, with a faint purple glow concentrated along the upper center edge and a corresponding subtle glow at the lower center edge, forming a very gentle horizontal light band within an otherwise dark field. As the animation progresses, the gradient shifts: the purple component intensifies and spreads, and warm magenta-pink emerges in the lower right, transforming the overall tone from cold deep navy to a richer, warmer violet-magenta. The corners remain the darkest zones throughout, acting as a consistent vignette. The transition between states is extremely slow and seamless with no visible motion or directional shift \u2014 the color simply breathes and evolves. No text, geometry, or representational elements are present. The color palette is restricted to a deep, dark range of blue, indigo, violet, and magenta \u2014 with no bright accents or saturated highlights. The visual style is minimal, atmospheric, and meditative \u2014 suitable for ambient, wellness, or luxury background use.","keyElements":["Dominant hue range across animation states","Vignette darkness level at corners","Position and intensity of glow zone within gradient","Transition speed and smoothness","Overall brightness level from darkest to lightest state"],"attributes":["smooth breathing color gradient","deep dark indigo-violet palette","minimal featureless composition","slow meditative pulse animation","luxury ambient background style"]},{"fileName":"GENERIC-AbstractBackgrounds-11.mp4","description":"The video presents a digitally generated abstract animated background composed of densely packed vertical wavy bands that fill the entire frame edge-to-edge, animated to undulate and ripple continuously in a sinusoidal pattern. The bands are rendered in a fully saturated, maximally vivid chromatic palette \u2014 a continuous spectrum of neon colors running in vertical zones across the width of the frame: vivid green-yellow, bright magenta-pink, electric cyan-blue, and warm orange-yellow alternate in repeating patterns, separated by thin dark outlines where one color band meets another. The surface of each band is smooth but shows very subtle contour lines within each color, suggesting slight three-dimensional depth to each stripe. The wave animation causes the bands to ripple vertically in a slow, continuous flowing motion \u2014 each vertical stripe oscillating left and right in a slightly different phase, creating a sense of the entire surface breathing or shimmering as if made of flexible colored ribbons in wind. No background is visible; the bands fill 100% of the frame at all times. No text, objects, or non-abstract elements are present. The color palette is entirely neon and fully saturated with no dark, muted, or neutral tones. The visual style is psychedelic, maximalist, and digitally generated \u2014 reminiscent of holographic or thermochromatic visual effects.","keyElements":["Specific color sequence and band width proportion","Wave amplitude and frequency of vertical ripple","Phase offset between adjacent bands","Edge-line darkness and visibility between bands","Overall brightness and saturation level"],"attributes":["neon vertical wave bands","fully saturated psychedelic palette","dense holographic shimmer","continuous sinusoidal ripple animation","maximalist full-frame color field"]},{"fileName":"GENERIC-AbstractBackgrounds-12.mp4","description":"The video presents a digitally generated abstract animated background composed of a smooth, soft gradient of glowing color concentrated in a dark field, resembling the visual quality of colored neon light diffused through fog or frosted glass. The composition shows one or more distinct glowing zones floating within a predominantly deep black background: a concentrated central-left mass of vivid magenta-pink light gradually softens and blooms outward into warm deep crimson at its edges, while on the right side a separate, distinct zone of rich royal or cobalt blue glows with a cooler hue. At the upper left, a faint, dimmer glow of dark reddish-purple adds a third color presence. The black portions of the frame are consistent and deep, providing strong contrast against the glowing color zones. The animation causes the glow positions to drift very slightly and pulse in intensity \u2014 the magenta zone brightens and dims in a slow, smooth rhythm, and the blue zone shifts position slightly over time. There is no discernible structure, geometry, or texture \u2014 the entire composition is soft, blurred, and fully abstract. No text or representational elements are present. The color palette is dramatic and high-contrast: deep black against vivid saturated magenta and blue. The visual style is moody, modern, and atmospheric \u2014 suitable for nightlife, music, fashion, or premium brand visual contexts.","keyElements":["Primary glow color hues and their positions","Black field darkness and surrounding zone coverage","Secondary glow color hue and position","Glow pulse speed and intensity range","Overall contrast level between dark and lit zones"],"attributes":["glowing neon color in dark field","deep black high-contrast background","soft diffused light bloom quality","magenta and blue dual-tone palette","moody atmospheric nightlife style"]},{"fileName":"GENERIC-AbstractBackgrounds-13.mp4","description":"The video shows a real physical space \u2014 a narrow, corridor-like gallery or immersive experience installation \u2014 with floor-to-ceiling large-format LED video wall panels lining both sides and the far end of the corridor, all displaying vivid animated abstract digital art. The space is filmed from a ground-level forward-facing perspective, looking straight down the corridor toward the end wall. Two human figures \u2014 appearing small relative to the towering screen walls \u2014 stand near the far end: one figure wearing dark clothing, another in lighter clothing, both facing away from camera toward the end screen. The screens on the left wall display swirling liquid-abstract compositions in vivid magenta-pink, teal, white, and orange tones with bold, flowing organic shapes. The screens on the right wall display an explosion-like abstract composition dominated by vivid red, electric orange, gold, and electric green with energetic radiating forms. The end-wall screen shows a cooler, blue and lavender abstract composition. The corridor floor is a highly reflective dark material that mirrors the vivid colors of the screens in bright reflection puddles of magenta, blue, and orange. The ceiling is a dark industrial black, barely visible above the screens. The color palette is overwhelmingly saturated and multicolored \u2014 vivid magentas, reds, oranges, teals, blues \u2014 with the dark floor and ceiling providing contrast. The visual style is photographic documentation of a real immersive digital installation space.","keyElements":["Screen content color palette on left, right, and end walls","Floor reflectivity and reflected color pattern","Human figure scale relative to screens","Ceiling color and visibility","Corridor depth and spatial perspective"],"attributes":["immersive LED installation space","floor-to-ceiling multicolor screens","vivid reflective dark floor","human-scale perspective contrast","photographic real-space documentation"]}]}');


var $76ad3919f4fd4444$exports = {};
$76ad3919f4fd4444$exports = JSON.parse("{\"items\":[{\"fileName\":\"GENERIC-AbstractNaturalLight-01.mp4\",\"description\":\"This video is an extreme close up, macro abstract shot dominated entirely by soft, out of focus light shapes and bokeh, with no discernible solid subject in sharp focus. The frame is filled with large, rounded, blurred forms: a bright white circular light, a bright yellow circular light in the lower left corner, and a larger oval or round shape on the right side of the frame showing faint fine parallel lines or striations across its surface, suggesting a leaf or piece of foliage seen extremely out of focus and backlit by strong light. A small, sharp orange or red flare point appears near the top of the frame, resembling a lens flare artifact or a tiny sun glint. The color palette is warm and golden, moving through amber, honey yellow, burnt orange, and deep brown shadow tones, with the darkest area forming a soft, curved wedge shape in the middle of the frame. The lighting is strong, warm, natural sunlight, backlighting the scene and creating glowing highlights, soft bloom, and a hazy, dreamy quality throughout. There is no visible background detail, structure, or texture beyond the blurred light shapes; the entire composition is soft focus, gauzy, and impressionistic. The framing is tight and centered on the interplay of light and shadow rather than any object, and the visual style is abstract, atmospheric, warm, and painterly, evoking sunlight filtering through leaves, foliage, or a plant.\",\"keyElements\":[\"color palette\",\"lighting\",\"bokeh shapes\",\"background blur\",\"warm tones\",\"flare point\"],\"attributes\":[\"abstract\",\"macro\",\"close up\",\"closeup\",\"out of focus\",\"bokeh\",\"blurred\",\"soft focus\",\"warm lighting\",\"natural light\",\"backlit\",\"golden\",\"amber\",\"yellow\",\"orange\",\"brown\",\"white\",\"glow\",\"haze\",\"hazy\",\"dreamy\",\"sunlight\",\"sun flare\",\"lens flare\",\"leaf\",\"foliage\",\"circular light\",\"oval shape\",\"shallow depth of field\",\"atmospheric\",\"minimal\",\"texture\",\"striations\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-02.mp4\",\"description\":\"This video is an extreme close up, out of focus abstract shot built almost entirely from blurred light and soft shadow, with no clearly resolvable object in the frame. A bright yellow white circular light sits at the top of the frame, and a warm orange, glowing rounded shape occupies the left and center portion of the image, softly fading into dark brown and black shadow toward the right side. A thin, faint diagonal streak of light, resembling a fine strand, thread, or lens artifact, crosses the middle of the frame from upper right to lower left. Later in the shot the frame brightens considerably, filling almost entirely with warm golden yellow and amber tones, with a large soft edged, semi transparent oval or disc shape appearing in the upper right area, showing faint fine linear texture consistent with an out of focus leaf or petal lit from behind. The color palette moves from deep brown and black shadow into rich amber, gold, and pale yellow highlight. The lighting is warm, natural, and backlit, creating strong glow, bloom, and soft gradients rather than hard edges. The composition has no fixed subject in focus; framing is tight, close, and abstract, and the visual style is soft focus, glowing, and painterly, consistent with sunlight passing through or behind foliage.\",\"keyElements\":[\"color palette\",\"lighting\",\"background blur\",\"warm tones\",\"diagonal streak\",\"translucent shape\"],\"attributes\":[\"abstract\",\"macro\",\"close up\",\"closeup\",\"out of focus\",\"bokeh\",\"blurred\",\"soft focus\",\"warm lighting\",\"natural light\",\"backlit\",\"golden\",\"amber\",\"yellow\",\"orange\",\"brown\",\"black\",\"glow\",\"bloom\",\"haze\",\"hazy\",\"dreamy\",\"sunlight\",\"lens flare\",\"leaf\",\"foliage\",\"circular light\",\"oval shape\",\"disc shape\",\"thread\",\"strand\",\"shallow depth of field\",\"atmospheric\",\"minimal\",\"texture\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-03.mp4\",\"description\":\"This video is a soft focus, macro abstract shot centered on a large, glowing, semi transparent rounded shape positioned in the middle of the frame, showing faint fine parallel veining or striations across its surface, consistent with an out of focus leaf illuminated from behind by strong natural light. A bright warm light source glows in the upper left corner of the frame in golden yellow, while a second warm orange glowing area appears on the right side of the frame. Between these light areas, a dark brown and black triangular shadow region cuts down through the center top of the frame. As the shot progresses, the framing shifts slightly, revealing another large pale yellow rounded shape with faint linear texture in the lower right portion of the frame, alongside a smaller white triangular highlight at the top edge. The color palette is warm throughout, spanning golden yellow, honey, amber, burnt orange, and deep brown, with soft white highlights where light is most concentrated. The lighting is strong, warm, and backlit, producing glowing edges, soft bloom, and gentle gradients rather than crisp detail. The background has no discernible depth or structure beyond layered blurred light and shadow shapes. The composition is tightly framed and centered on the translucent rounded form, and the overall visual style is dreamy, atmospheric, and painterly, evoking sunlight glowing through a leaf or piece of foliage.\",\"keyElements\":[\"color palette\",\"lighting\",\"background blur\",\"warm tones\",\"translucent shape\",\"shadow region\"],\"attributes\":[\"abstract\",\"macro\",\"close up\",\"closeup\",\"out of focus\",\"bokeh\",\"blurred\",\"soft focus\",\"warm lighting\",\"natural light\",\"backlit\",\"golden\",\"amber\",\"yellow\",\"honey\",\"orange\",\"brown\",\"black\",\"white\",\"glow\",\"bloom\",\"haze\",\"hazy\",\"dreamy\",\"sunlight\",\"leaf\",\"foliage\",\"veining\",\"circular light\",\"oval shape\",\"translucent\",\"triangular shadow\",\"shallow depth of field\",\"atmospheric\",\"texture\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-04.mp4\",\"description\":\"This video shows a close up, partially focused nature shot of a thin green plant stem with several pointed, heart shaped leaves extending diagonally across the lower half of the frame, silhouetted in dark green and black against a bright backlit background. A strong, bright sun sits behind the foliage near the upper center of the frame, radiating a burst of white and warm yellow light directly through the gap between leaves, with a faint rainbow colored arc, showing red, orange, yellow, and light blue bands, curving across the upper right area of the frame as a lens flare artifact. The background beyond the stem is entirely out of focus, filled with countless small circular bokeh highlights in white, pale blue, and soft green, created by sunlight filtering through a dense canopy of distant leaves. The color palette combines deep green and black foliage silhouettes with bright white highlights, warm golden light, and soft blue and green background bokeh. The lighting is bright, direct, natural sunlight, positioned behind the subject to create strong backlighting, lens flare, and glowing highlights. The composition places the sharp leaves and stem in the lower foreground, with the blown out sun and blurred bokeh filling the upper and background areas, giving strong depth and layered spatial relationships between foreground foliage and background canopy. The visual style is photographic, naturalistic, and atmospheric, with shallow depth of field emphasizing the contrast between crisp foreground leaves and soft glowing background light.\",\"keyElements\":[\"background bokeh\",\"sun position\",\"lens flare\",\"color palette\",\"lighting\",\"canopy blur\"],\"attributes\":[\"nature\",\"outdoor\",\"close up\",\"closeup\",\"backlit\",\"sun flare\",\"lens flare\",\"rainbow flare\",\"chromatic aberration\",\"bokeh\",\"out of focus background\",\"shallow depth of field\",\"leaf\",\"leaves\",\"plant\",\"stem\",\"branch\",\"foliage\",\"green\",\"dark green\",\"black\",\"white\",\"yellow\",\"gold\",\"golden\",\"blue\",\"silhouette\",\"sunlight\",\"natural light\",\"warm lighting\",\"canopy\",\"tree\",\"photographic\",\"naturalistic\",\"atmospheric\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-05.mp4\",\"description\":\"This video is a fully abstract composition made entirely of soft, diffused color gradients with no recognizable object, subject, or texture visible anywhere in the frame. A large, bright white glowing area sits in the upper left portion of the frame, transitioning smoothly into pale cyan and light blue tones that spread across the center and right side of the image, resembling a soft prism or lens flare refraction. Thin vertical bands of color run along the left edge of the frame, showing streaks of pink, magenta, orange, and pale yellow, while the right edge carries subtle hints of green and rose. As the shot continues, the frame shifts into darker, moodier tones, with a deep slate blue and charcoal gray dominating the center, bordered by a warm orange and red glow in the upper right corner and a small rainbow colored arc, showing yellow, green, and blue bands, appearing in the lower right corner. The overall color palette spans white, pale blue, cyan, magenta, pink, orange, yellow, slate gray, and charcoal, with smooth, seamless blending between all tones. The lighting is entirely implied through gradient and glow rather than any depicted light source, giving a soft, diffused, glowing quality throughout. There is no background, foreground, or spatial depth in the traditional sense; the composition is a flat, full frame color field. The visual style is abstract, minimal, and painterly, resembling a light leak, prism refraction, or holographic gradient effect.\",\"keyElements\":[\"color gradient\",\"color palette\",\"glow intensity\",\"rainbow arc\",\"color bands\"],\"attributes\":[\"abstract\",\"gradient\",\"color gradient\",\"light leak\",\"prism\",\"prism effect\",\"holographic\",\"iridescent\",\"rainbow\",\"lens flare\",\"diffused light\",\"glow\",\"soft focus\",\"minimal\",\"white\",\"blue\",\"cyan\",\"pink\",\"magenta\",\"orange\",\"yellow\",\"green\",\"gray\",\"charcoal\",\"slate blue\",\"red\",\"flat composition\",\"no subject\",\"painterly\",\"dreamy\",\"smooth blend\",\"full frame color\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-06.mp4\",\"description\":\"This video is a fully abstract, soft focus composition built from glowing colored light with no recognizable object or texture visible. The shot opens with a warm coral pink and red glowing shape occupying the upper right and lower left portions of the frame, set against a dark, almost black background with a subtle deep green tint along the left edge. The pink and red glow gradually shifts and dissolves, transitioning through the middle of the shot into a bright teal and turquoise glowing form that rises vertically through the center of the frame, resembling a soft plume, cloud, or beam of colored light against the dark background. Toward the end of the shot, the teal glow fades and dims, leaving only faint traces of dark teal and deep maroon against an almost fully black frame. The color palette moves distinctly from coral, pink, and red into teal, turquoise, and dark green, all set against black and near black backgrounds. The lighting is entirely soft, diffused, and glowing, with no hard edges or defined light source, giving the impression of colored light, smoke, or gas illuminated from within. There is no discernible background structure, foreground object, or spatial depth; the frame is essentially a dark void punctuated by a shifting glowing color form. The visual style is abstract, moody, atmospheric, and painterly, with a strong color transition effect reminiscent of colored light, mist, or liquid ink dispersing in darkness.\",\"keyElements\":[\"color transition\",\"glow shape\",\"color palette\",\"background darkness\",\"glow intensity\"],\"attributes\":[\"abstract\",\"color transition\",\"glow\",\"glowing light\",\"soft focus\",\"diffused light\",\"dark background\",\"black\",\"pink\",\"coral\",\"red\",\"teal\",\"turquoise\",\"dark green\",\"maroon\",\"moody\",\"atmospheric\",\"minimal\",\"smoke\",\"mist\",\"ink\",\"plume\",\"cloud shape\",\"beam of light\",\"no subject\",\"painterly\",\"dreamy\",\"flat composition\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-07.mp4\",\"description\":\"This video is a fully abstract, soft focus composition dominated by glowing colored light with no recognizable object in the frame. The shot opens with a dark plum and maroon shadow in the upper left corner blending into a soft teal, blue, and green wash across the center of the frame, while a bright lime green and pale yellow glowing rounded shape sits in the lower right corner, resembling a soft bokeh highlight or light source. The colors blend smoothly with no hard edges, giving a hazy, luminous quality throughout the middle of the shot. Toward the end of the shot, the frame dims considerably, fading into a mostly black background with only faint traces of deep teal on the left and dark maroon and red on the right remaining visible. The overall color palette spans deep plum, maroon, teal, blue, green, lime green, pale yellow, and black, with smooth gradients connecting all tones. The lighting is entirely soft and diffused, implied through glow and gradient rather than any visible light source, giving the entire frame a glowing, atmospheric quality. There is no background structure, foreground subject, or spatial depth; the composition is a flat, full frame color field similar to a light leak or color wash effect. The visual style is abstract, moody, and painterly, consistent with colored light, gel lighting, or a prism style color gradient effect.\",\"keyElements\":[\"color gradient\",\"color palette\",\"glow shape\",\"background darkness\",\"glow intensity\"],\"attributes\":[\"abstract\",\"color gradient\",\"light leak\",\"color wash\",\"glow\",\"glowing light\",\"soft focus\",\"diffused light\",\"bokeh\",\"plum\",\"maroon\",\"teal\",\"blue\",\"green\",\"lime green\",\"yellow\",\"black\",\"red\",\"moody\",\"atmospheric\",\"minimal\",\"no subject\",\"painterly\",\"dreamy\",\"flat composition\",\"gel lighting\",\"prism effect\",\"smooth blend\"]},{\"fileName\":\"GENERIC-AbstractNaturalLight-08.mp4\",\"description\":\"This video is a fully abstract, soft focus lens flare composition dominated by warm glowing light with no recognizable object or texture visible anywhere in the frame. A bright white and pale yellow glowing light source sits in the upper right corner of the frame, radiating a thin diagonal streak of light downward toward the center, consistent with a direct sun flare or lens flare artifact. A soft curved band of warm coral and salmon light arcs across the upper right and right edge of the frame, while the majority of the composition is filled with warm olive, amber, and golden brown tones that blend smoothly with no hard edges. A small, soft, pale yellow circular bokeh highlight sits in the lower left quadrant of the frame. As the shot continues, the frame dims slightly and shifts into a more muted, hazy olive green and warm gray tone, with the light source in the upper right softening into a diffuse glow. The overall color palette spans white, pale yellow, gold, amber, olive, warm gray, coral, and salmon, entirely warm and sun washed. The lighting is soft, diffused, and glowing throughout, implied entirely through gradient and flare rather than any depicted object, giving the frame a hazy, dreamy, sun drenched quality. There is no background structure, foreground subject, or spatial depth; the composition is a flat, full frame warm light field. The visual style is abstract, warm, atmospheric, and painterly, closely resembling a sun flare or warm light leak effect.\",\"keyElements\":[\"color gradient\",\"light source position\",\"flare streak\",\"color palette\",\"glow intensity\"],\"attributes\":[\"abstract\",\"lens flare\",\"sun flare\",\"light leak\",\"glow\",\"glowing light\",\"soft focus\",\"diffused light\",\"bokeh\",\"warm lighting\",\"white\",\"yellow\",\"gold\",\"golden\",\"amber\",\"olive\",\"warm gray\",\"coral\",\"salmon\",\"brown\",\"hazy\",\"dreamy\",\"sun drenched\",\"atmospheric\",\"minimal\",\"no subject\",\"painterly\",\"flat composition\",\"smooth blend\",\"circular bokeh\"]}]}");


$b3c1eb0a6591430d$exports = {
    "01-PeopleCorporate": $58b094c1e2249862$exports,
    "02-PeopleCraft": $668ebcf1d8bd628d$exports,
    "03-PeopleSports": $c4c56e711d71045d$exports,
    "04-PeopleOutdoor": $ad0d12887e1e8a9b$exports,
    "05-PeopleFinancial": $e4153d2b9913d6fb$exports,
    "06-PeopleCity": $0372304f611450de$exports,
    "07-PeopleFun": $562aaf79869f5626$exports,
    "08-PeopleDiverseHome": $de3e37e4efcd47db$exports,
    "09-PeopleDiverseCorporate": $6e5e07098836d5c9$exports,
    "12-PeopleDiverseCity": $3da96fca0ab4d60b$exports,
    "13-Family": $27420d6f341c25dd$exports,
    "14-FamilyHome": $812c309d6b8d4b12$exports,
    "15-HumanConnection": $68e73aa430c018e6$exports,
    "16-HumanNatureMacro": $cbda005732237afe$exports,
    "17-HumanAnimalMacro": $9009528bfc17c99a$exports,
    "18-NatureWater": $157600acb13f5ef9$exports,
    "19-NatureLandscape": $7230dc2917e24532$exports,
    "20-NatureMacro": $5986dc58a2672d72$exports,
    "21-CityDaytime": $709441eda9f9f683$exports,
    "22-CityNighttime": $d882fc010ad9f5fb$exports,
    "23-TechEveryday": $0dd17f1ba401c3ca$exports,
    "24-FinancialData": $cf4ed70b876ffabf$exports,
    "25-AbstractBackgrounds": $5dfabec2e794b522$exports,
    "26-AbstractNaturalLight": $76ad3919f4fd4444$exports
};


const $80690ea71e31e9a7$var$allItems = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($b3c1eb0a6591430d$exports)))).sort().flatMap((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($b3c1eb0a6591430d$exports)))[key]?.items ?? []);
var $80690ea71e31e9a7$export$2e2bcd8739ae039 = {
    items: $80690ea71e31e9a7$var$allItems.map((item)=>({
            ...item,
            fileName: `mogrt/footage/generic/${item.fileName}`
        }))
};


var $9861ffc361224113$exports = {};
var $a61eed43935f0831$exports = {};
$a61eed43935f0831$exports = JSON.parse('{"items":[{"fileName":"AdobeSpecific-Set01-02.mp4","description":"The video is a 3-second, 1920\xd71080 abstract motion piece that opens on a light neutral-grey background displaying four large 3D-rendered torus (donut) shapes arranged across the frame in a 2\xd72 grid, each covered with a different multi-layered surface treatment: one shows a sandy, cracked-earth texture with patches of blue and green paint; another is painted with bold strokes of orange, purple, blue, and red; a third combines a beige metallic base with a blue hexagonal halftone dot pattern overlaid in teal, red, and magenta; and the fourth is a smooth rainbow gradient blending green, yellow, and pink. In the second and third phases the camera pushes in rapidly toward the toroidal forms as they rotate and collide with one another, causing the background to transition from neutral grey through a soft blurred pinkish haze to a fully saturated field of multicolored collision debris. In the final frames, large 3D letterforms spelling out what appears to be the word \'create\' in a rounded, chunky typeface dominate the frame, rendered with the same multi-texture, multi-color treatment as the tori \u2014 each letter carrying a different surface finish (matte clay, metallic, painted, halftone-patterned). Floating in the background are stylized botanical shapes, scattered angular color fragments, and a small red cube at lower left. The overall color palette is maximalist: orange, electric blue, violet, magenta, lime green, yellow, red, and coral all appear simultaneously. Lighting is dramatic and directional with strong specular highlights on metallic and glossy surfaces. The visual style is highly rendered, kinetic 3D with a tactile, art-direction-heavy aesthetic.","keyElements":["Neutral grey background (early frames)","Saturated multicolor collision debris background (mid and late frames)","Surface textures on tori: cracked earth, paint strokes, hexagonal halftone, gradient rainbow","Scattered angular color fragment shapes in background","Small red cube at lower left","Stylized botanical/leaf shapes in background","Typeface style and color treatment of \'create\' letterforms"],"attributes":["maximalist 3D render","kinetic tactile motion","explosive color palette","multi-texture surfaces","bold typographic reveal"],"productContext":{"visibleUIIndicators":["No UI chrome visible \u2014 pure motion/creative content"],"likelySuite":"Likely Adobe Firefly or Adobe Express creative asset / motion reel","adobeMarketingLanguage":{"generativeAI":["Generate images from a text prompt","AI-powered creative content","Turn ideas into high-quality content"],"contentProduction":["Campaign-ready visuals","High-impact creative assets","Scroll-stopping visuals","On-brand content generation"],"workflowAndProductivity":["Accelerate ideation","From concept to campaign-ready asset","Rapidly produce visuals"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as a high-energy opener for generative AI campaign reels targeting creative teams and designers","Pair with \'turn ideas into high-quality content\' messaging to showcase Firefly\'s expressive creative range","Highlight the multi-texture, multi-style rendering as a visual metaphor for Firefly\'s ability to iterate creative styles at scale","Position the \'create\' letterform reveal as a brand moment for Adobe Express or Firefly consumer-facing campaigns","Use as b-roll in content supply chain presentations to illustrate accelerated ideation and creative production"]}},{"fileName":"AdobeSpecific-Set01-04.mp4","description":"The video is a 3-second, 1920\xd71080 dark-themed motion piece built around a film-strip visual metaphor. Throughout the sequence, a solid black background is framed on both left and right edges by vertical strips designed to look like 35mm film sprocket borders \u2014 rendered with alternating black-and-white diagonal hatch marks and vivid multicolored sections displaying cyan, magenta, yellow, green, blue, and pink dot-matrix and wave patterns, simulating exposed film stock or light leaks. At the center of the frame sits a large square image panel framed in a thick, solid red border, which changes content across the sequence: in the first frames the panel is fully black, containing only a smaller red-bordered square at its center; as the video progresses, the inner panel fills with three distinct AI-rendered photographic images appearing in sequence \u2014 first a cyan-tinted elephant standing on a neon-lit runway with a dark blue city skyline and pink neon strip lighting behind it; then an astronaut in a full white spacesuit standing in a dramatic dark forest lit by a golden-orange burst of backlight from between towering trees; and finally a glowing incandescent light bulb surrounded by floating 3D abstract shapes including ribbons, spheres, and small gems on a dark radial-lit background. Each image is fully contained within the red-bordered square panel. The red border itself remains constant throughout as the primary framing device. The color palette of the outer frame elements is high-contrast black, white, and neon multicolor; the inner images have their own distinct palettes \u2014 deep blue neon, amber-forest, and dark cosmic purple respectively. The visual style is graphic, editorial, and cinematic.","keyElements":["Black background","Left and right film-strip border strips with diagonal hatch and multicolor dot-matrix patterns","Thick red square border frame around the central image panel","Background color within the image panel (black, dark blue, dark forest, dark purple)","Subject matter of each sequential image (elephant, astronaut, light bulb)","Neon floor/runway lighting color in the first image","Forest backlight color in the second image"],"attributes":["cinematic film-strip aesthetic","high-contrast dark palette","sequential image reveal","graphic red frame device","editorial AI imagery"],"productContext":{"visibleUIIndicators":["No UI chrome visible \u2014 pure motion/creative content"],"likelySuite":"Likely Adobe Firefly or Adobe Express creative asset / motion showcase reel","adobeMarketingLanguage":{"generativeAI":["Generate images from a text prompt","AI-generated imagery","Commercially safe generative AI"],"contentProduction":["Campaign-ready visuals","High-impact creative assets for multiple channels","Produce eye-catching images from a text prompt","Scroll-stopping visuals"],"workflowAndProductivity":["Accelerate ideation","Rapidly iterate on creative concepts","From prompt to finished asset"],"enterpriseAndScale":["Scale content production","Generate asset variations across formats","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as a showcase reel demonstrating the breadth of Firefly\'s AI image generation across diverse subjects and moods","Pair with \'turn ideas into high-quality content\' messaging \u2014 the three distinct images reinforce range and versatility","The film-strip format makes this ideal for video or social media campaign contexts around Adobe Premiere or Adobe Express","Use in \'generate images from a text prompt\' product demos where showcasing diverse output styles quickly is key","Position the red frame device as a brand-consistent visual motif for Adobe\'s commercially safe AI content messaging"]}},{"fileName":"AdobeSpecific-Set01-06.mp4","description":"The video is a 3-second, 1920\xd71080 live-action and motion-graphics hybrid sequence. The opening frame is heavily motion-blurred and shows a close-up of a human hand holding a white stylus or pen against a bright yellow background, with a white-and-blue UI tooltip visible reading \'Transform\' next to a small dashed-square icon, and partial views of additional background props including a dark green cylindrical object and red shapes at the lower edge. The scene transitions through a fast-rotating cut showing blue jeans-clad legs, a yellow circle outline, a white triangular shape, and additional blue fabric elements on an orange background \u2014 all in extreme motion blur \u2014 before resolving into a clear, stable medium shot. The resolved shot shows a young adult male figure crouching low on a flat blue background surface, centered in frame. He wears a grey-green oversized washed-leather overshirt open over a white t-shirt, a silver chain necklace, multiple bracelets, and a large digital watch on his left wrist; his lower half is dressed in grey-green frayed-hem denim shorts and white low-top sneakers with black and red accents. He wears a black cap and has a small chin beard and nose piercing. His posture is low and wide, looking slightly to camera-left. In the final frame the person is shown in a similar pose, now accompanied by a white rounded-square UI card in the lower-left of the frame displaying a paintbrush icon labeled \'Paint\', and yellow diagonal brushstroke-like marks are visible floating to the upper left. The overall color palette is dominated by bright cobalt blue, muted grey-green, white, and black with accent yellow. Lighting is flat and even, consistent with studio photography against a seamless backdrop.","keyElements":["Bright cobalt blue background","Yellow background in the opening transition frame","White rounded-square UI tooltip cards (\'Transform\', \'Paint\')","Yellow diagonal floating brushstroke graphic elements","Additional background props (green cylinder, red shapes) in opening frames","Background surface color and lighting style"],"attributes":["live-action studio shoot","fast motion-blur transition","bright flat background","UI overlay elements","streetwear editorial style"],"productContext":{"visibleUIIndicators":["White rounded-square tooltip card labeled \'Transform\' with dashed-square icon","White rounded-square tooltip card labeled \'Paint\' with paintbrush icon","Yellow floating brushstroke graphic elements suggesting active editing tools"],"likelySuite":"Likely Adobe Express or Adobe Firefly (editing tool overlays consistent with Express canvas UI)","adobeMarketingLanguage":{"generativeAI":["AI-powered image editing","Generate and edit images","Turn ideas into high-quality content"],"contentProduction":["Campaign-ready visuals","On-brand campaign content","Produce content for social media and digital channels","Empower non-designers to create compelling visual content"],"workflowAndProductivity":["Iterate using intuitive editing tools","Accelerate creative production","From shoot to finished campaign asset"],"enterpriseAndScale":["Personalization at scale","Create asset variations for audience segments","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as a social-media-forward creative asset showcasing Adobe Express\'s editing tools applied to real photography","Pair with \'empower non-designers to create compelling visual content\' messaging for an Express consumer or SMB campaign","The \'Transform\' and \'Paint\' tool overlays make this ideal for product UI demos showing editing capability on photographic subjects","Position as a streetwear / lifestyle audience segment example for personalization-at-scale messaging in enterprise campaigns","Use as b-roll in campaigns highlighting Adobe\'s ability to blend live photography with generative AI editing tools"]}},{"fileName":"AdobeSpecific-Set01-11.mp4","description":"The video is a 3-second, 1920\xd71080 screen-capture-style product demonstration set against a deep dark maroon-to-black gradient background with soft ambient glow. The sequence opens with a centered, rounded-rectangle card framed by a thin white border and overlaid with four dark icon buttons (a pencil in the top-left, a download arrow in the top-right, thumbs-up and thumbs-down in the bottom-left, and a star in the bottom-right). Inside this card is a vibrant 3D-rendered architectural scene: a flat-roofed pink structure occupies the center, featuring a circular aperture through which voluminous white cumulus clouds and a bright cyan sky are visible; the circular opening is rimmed in a deeper coral-pink. To the left of the structure stands a tall yellow wall, and to the right are additional pink and coral-red architectural volumes casting soft shadows. In the foreground sits a reflective shallow pool rendered in aqua-teal tones. Two spherical objects appear in the scene \u2014 a larger sphere with a mottled green, teal, and coral surface resting on a pink stepped platform to the left of the aperture, and a smaller teal-and-orange striped sphere partially submerged at the pool\'s edge. The overall color palette of this rendered scene is bold and saturated: coral pink, bright yellow, aqua blue, sky blue, red-coral, and white. Lighting is diffuse and even, suggesting an outdoor midday setting. In the second phase of the video, the card scales down and shifts left as the UI interface animates away \u2014 the icon buttons disappear and a wide dark pill-shaped text input bar appears below the image, containing white placeholder text reading \'Change it |\' alongside a blue rounded \'Generate\' button with a sparkle-star icon. The text in the input field animates to read \'Change it into a blizzard\' and a cursor arrow hovers over the Generate button. In the final phase, the original image card slides to the left and partially behind a new card that sweeps in from the right \u2014 first appearing as a vivid pink-to-purple gradient fill, then resolving into a new AI-generated 3D-rendered variation of the original scene: the architecture is now rendered in dark stone with heavy icicles hanging from the top, snow covering all surfaces, frost-covered tropical palm trees flanking the structure, and the two spheres replaced by smooth pale-blue ice-ball equivalents. Snow particles are visible falling throughout the scene. The transition demonstrates a before-and-after image generation workflow within a software UI. The overall visual style is clean, modern, and polished with smooth animation and a consistent dark ambient background.","keyElements":["Dark maroon-to-black gradient background","Rounded-rectangle card frame with white border and UI icon buttons","Cyan sky and white cumulus clouds visible through the circular aperture","Yellow wall panel on the left side of the scene","Coral-red and pink architectural volumes on the right side","Aqua-teal reflective pool in the foreground","Dark pill-shaped text input bar with white text","Blue \'Generate\' button with sparkle-star icon","Pink-to-purple gradient transition panel","Snow, icicles, and frost overlay in the generated variation","Frost-covered palm trees in the blizzard variation","Pale-blue ice spheres replacing the original colored spheres"],"attributes":["vibrant 3D render","sleek UI demo","bold saturated palette","smooth animated transition","modern minimal interface"],"productContext":{"visibleUIIndicators":["Pill-shaped text prompt input bar","Blue \'Generate\' button with sparkle-star icon","Before-and-after card transition animation","Thumbs-up / thumbs-down feedback buttons","Download and edit (pencil) action icons"],"likelySuite":"Adobe Firefly (Adobe Express or Firefly standalone app)","adobeMarketingLanguage":{"generativeAI":["Generative AI","Generate images from a text prompt","Prompt-based image generation","AI-powered image editing","Commercially safe generative AI"],"contentProduction":["Content supply chain","Accelerate content creation","Asset variations at scale","Campaign-ready visuals","On-brand content generation","Seasonal campaign updates"],"workflowAndProductivity":["Iterate using natural language prompts","From ideation to production","Accelerate ideation","Reduce time-to-market","Turn ideas into high-quality content"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale","Personalization at scale","Deliver content across channels and formats","Empower creative teams"]},"suggestedMarketingAngles":["Showcase how a single text prompt transforms a campaign visual in seconds \u2014 a core Adobe Firefly generative AI capability","Demonstrate accelerated ideation and content iteration for marketing and creative teams","Highlight seasonal asset variation generation (summer-to-blizzard) as a content supply chain use case","Position the before-and-after workflow as proof of reduced time-to-market for on-brand campaign visuals","Use as a reference clip for \'prompt-based image generation\' and \'generative AI for business\' messaging on business.adobe.com"]}},{"fileName":"AdobeSpecific-Set01-12.mp4","description":"The video is a 3-second, 1920\xd71080 collaborative digital workspace demonstration set against a deep dark navy-to-purple gradient background. Visible throughout is a two-column tool panel on the far left edge containing icons for a cursor/selection tool, crop tool, text tool, shape tool, and an add-image tool (with a sparkle icon suggesting AI); a corresponding right-side panel displays icons for search, filters, history, comments, and an AI/sparkle-star tool. These flanking panels frame a large, open infinite-canvas workspace in which multiple image cards are arranged in two loose groupings. The left grouping displays four interior design photographs \u2014 a colorful striped sofa, a minimalist white room with antler wall art, a bright pink armchair with orange vase, and a white sofa with a patterned throw pillow \u2014 while the right grouping contains six colorful 3D-rendered architectural images in pink, coral, blue, and sky tones featuring arched doorways, abstract geometric volumes, and dramatic staircases. Two user presence indicators are visible as colored dot-and-avatar pill badges: a cyan-blue badge labeled \'Amy\' with a circular portrait avatar, and an orange badge labeled \'Robert\' with a portrait avatar; a third pink badge labeled \'Aiden\' appears later in the sequence. Throughout the video the canvas animates \u2014 image cards shift position and scale upward, the groupings rearrange, and a dark rounded-rectangle context menu bar appears mid-canvas showing options including a sparkle icon labeled \'Remix\', a frame/crop icon, a grid/layout icon, an align icon, and an overflow menu. A cursor arrow is visible hovering over the layout icon. In the final frames the view zooms into the canvas and the cards fill more of the frame, now clearly showing two additional interior rooms \u2014 a colorful living space with large windows and vibrant furniture, and a purple-toned room with a decorative wall \u2014 as well as abstract pastel 3D shapes. The visual style is clean, modern, and polished dark-UI.","keyElements":["Dark navy-to-purple gradient canvas background","Left and right tool panel icon sets","Interior design photograph cards (sofa styles, room palettes)","3D-rendered architectural image cards (colors, arch styles)","User presence badge colors and labels (Amy, Robert, Aiden)","Dark context menu bar with icon options","Canvas zoom level and card arrangement layout"],"attributes":["collaborative dark UI workspace","multi-user canvas interface","editorial mood board layout","smooth animated card transitions","AI Remix tool visible"],"productContext":{"visibleUIIndicators":["Sparkle-star AI tool icon in the left tool panel","Sparkle-star AI tool icon in the right side panel","Context menu with \'Remix\' option and sparkle icon","Multi-user presence indicators (Amy, Robert, Aiden color-coded badges)","Infinite canvas layout with image card arrangement tools","Grid/layout, align, and crop icons in the context toolbar"],"likelySuite":"Likely Adobe Firefly Boards (collaborative AI-powered visual workspace on infinite canvas)","adobeMarketingLanguage":{"generativeAI":["AI-powered visual workspace","Generate and edit images","Remix content with generative AI","Accelerate ideation with AI"],"contentProduction":["Brainstorm, organize, and iterate on ideas","Mood boards and storyboards","Campaign-ready visuals","On-brand content generation"],"workflowAndProductivity":["Collaboratively visualize, test, and align on ideas","From ideation to production","Iterate using natural language prompts","Creative teams collaborating in real time"],"enterpriseAndScale":["Creative teams collaborating at scale","Align on ideas before moving to final production","Empower creative teams","Create with speed, scale, and brand intelligence"]},"suggestedMarketingAngles":["Use as a primary demo clip for Firefly Boards \u2014 showing multi-user collaboration, infinite canvas, and the Remix AI function simultaneously","Pair with \'collaboratively visualize, test, and align on ideas before moving to final production\' messaging for enterprise creative team audiences","Highlight the multi-user badges (Amy, Robert, Aiden) as proof of real-time collaboration for team-based content workflows","Position the \'Remix\' context menu as a shortcut to Firefly\'s generative AI iteration capability embedded directly in the canvas","Use in content supply chain presentations showing how creative teams plan, generate, and review campaign assets in a unified workspace"]}},{"fileName":"AdobeSpecific-Set01-21.mp4","description":"The video is a 3-second, 1920\xd71080 workflow diagram demonstration set on a clean white background. The sequence animates a left-to-right node graph \u2014 a visual pipeline \u2014 in which rectangular white cards are connected by thin curved black lines with circular dot connectors at each node junction. The pipeline begins at the far left with an \'Input\' card showing a photograph of a person standing in outdoor winter gear: a bright yellow quilted puffer jacket, black trousers, snow boots, and a grey knit beanie, with a backpack, set against a neutral grey background; two additional thumbnail variants of the same person in different jacket colors (yellow and a second view) are visible below the input image along with a plus-icon card for adding more. The first processing node is labeled \'Remove background\' and carries a blue Photoshop \'Ps\' icon; its output preview shows the same person cutout against a transparent (checkerboard-pattern) background. Simultaneously, a second node below is labeled \'Generate image\' and carries a red Firefly \'Fi\' icon; its output shows an AI-generated snowy mountain panorama with a pinkish-lavender sky. These two outputs converge via connecting lines into a third card labeled \'Composite image\' also carrying the blue Ps icon, which combines the cutout figure with the generated mountain background, producing a finished composited image of the person standing on a snowy mountain peak under a bright blue sky. The final node in the pipeline is a panel labeled \'Mountain Scene\' showing a thumbnail grid of five output image variants of the composited scene (the person in different mountain environments and jacket colors), alongside a prominently highlighted pink-and-purple gradient-bordered card labeled \'Generate variants\' with a sparkle icon. The animation zooms and pans rightward across the pipeline as the workflow builds. The overall visual style is minimal, diagrammatic, and documentation-like on a pure white ground.","keyElements":["White background","Curved black connecting lines and circular node connectors","Background environment behind the composited subject (mountain panorama color and style)","Mountain Scene thumbnail grid layout and variant images","Pink-purple gradient border on the \'Generate variants\' card","Additional input thumbnail jacket color variants"],"attributes":["minimal white workflow diagram","node-graph pipeline UI","multi-step AI automation","compositing workflow demo","clean diagrammatic style"],"productContext":{"visibleUIIndicators":["Blue Photoshop \'Ps\' app icon on \'Remove background\' node","Red Firefly \'Fi\' app icon on \'Generate image\' node","Blue Photoshop \'Ps\' app icon on \'Composite image\' node","Sparkle icon on \'Generate variants\' call-to-action card","Pink-purple gradient glowing border on \'Generate variants\' card","Node-graph pipeline layout connecting Input \u2192 Remove background \u2192 Composite image \u2192 Generate variants","\'Mountain Scene \u2014 86 Items\' label indicating batch output scale"],"likelySuite":"Adobe Firefly Services / Firefly Creative Production (automated multi-step pipeline combining Photoshop API and Firefly Generate Image API)","adobeMarketingLanguage":{"generativeAI":["Generate image from a text prompt","Generate variants at scale","AI-powered compositing","Commercially safe generative AI"],"contentProduction":["Content supply chain automation","Asset variations at scale","Remove background and composite in seconds","Generate product backgrounds for e-commerce and marketing","Campaign-ready visuals"],"workflowAndProductivity":["Transform creative production tasks into reusable workflows","Automate repetitive creative work","From ideation to production","Reduce time-to-market"],"enterpriseAndScale":["Scale content with enterprise generative AI","86 output variants from a single pipeline","Firefly Services APIs embedded in creative workflows","Produce personalized content for customer segments"]},"suggestedMarketingAngles":["Primary demo clip for Adobe Firefly Services / Firefly Creative Production \u2014 shows a full automated pipeline (background removal \u2192 AI image generation \u2192 compositing \u2192 variant generation) in one sequence","Use alongside \'transform creative production tasks into reusable workflows\' messaging for enterprise and agency audiences","The \'86 Items\' output label is a powerful scale proof point \u2014 pair with \'produce content at scale\' or \'reduce time-to-market\' copy","Highlight the Photoshop + Firefly icon combination to reinforce the connected Creative Cloud + Firefly Services ecosystem message","Use in e-commerce and product marketing contexts to showcase automated background generation and compositing for product imagery at scale"]}},{"fileName":"AdobeSpecific-Set01-22.mp4","description":"The video is a 3-second, 1920\xd71080 animated 3D motion sequence set against a continuously evolving gradient background that transitions from a soft purple-to-pink-to-red gradient in the opening frames through increasingly saturated pink-magenta tones, ending in a vivid hot pink-to-red field. The lower third of the frame throughout the mid and early sections features a bright horizontal flare or ground plane glow in soft white-lavender, giving the scene a staged, lit-floor appearance. The main subject is a pair of large, 3D-rendered typographic letterforms spelling \'AI\', which begin as a loose cluster of small, individually rendered spherical particles in pink and blue tones floating in the center of frame, then coalesce and assemble into fully formed, solid capital letters. By the final frames the letters are fully resolved: the \'A\' and \'I\' are constructed entirely from densely packed, overlapping spheres of varying sizes in blue, teal, pink, magenta, purple, and cyan, rendered with realistic subsurface scattering and specular highlights. As the letters solidify, additional 3D decorative elements animate in from the left and right edges: on the left, multiple illustrated flower stems with detailed blooms in pink (rose), yellow, and orange, plus small decorative black-and-white spiral spheres at the top corners and additional accent spheres in teal and green appear; on the right, matching flower groupings with orange and red blooms, additional black-and-white spiral spheres, and green geometric forms enter the frame. By the final frame the composition is full and symmetrical, with the AI letterforms centered and flanked by an elaborate floral arrangement. The letters also cast a soft reflection on the glossy floor plane. The visual style is vivid, decorative 3D with a celebratory, maximalist aesthetic.","keyElements":["Background gradient colors (purple-to-pink-to-red progression)","Lower-third ground plane flare/glow color","Decorative floral elements on left and right (bloom colors, stem styles)","Black-and-white spiral sphere accents at top corners","Teal and green accent spheres","Particle sphere color palette within the AI letterforms","Glossy reflective floor plane"],"attributes":["vibrant 3D typographic reveal","particle assembly animation","maximalist floral framing","celebratory AI branding","warm gradient backdrop"],"productContext":{"visibleUIIndicators":["No UI chrome visible \u2014 pure motion/creative content","Visible text: \'AI\' as the central typographic subject"],"likelySuite":"Likely Adobe Firefly brand/marketing creative asset or Adobe Express motion template","adobeMarketingLanguage":{"generativeAI":["Generative AI","AI-powered creative content","Turn ideas into high-quality content","Adobe Firefly generative AI"],"contentProduction":["Campaign-ready visuals","High-impact creative assets","Scroll-stopping visuals for social media","On-brand content generation"],"workflowAndProductivity":["Accelerate ideation","Rapidly produce on-brand campaign visuals","From concept to campaign asset"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as a hero opener for Adobe Firefly generative AI campaigns \u2014 the \'AI\' letterform reveal is a direct, bold visual statement","Pair with \'Adobe brought generative AI to business\' or \'Productivity will never be the same\' headline copy from business.adobe.com","The particle-assembly animation visually metaphorizes how Firefly models learn and generate \u2014 useful for explaining AI capability to non-technical audiences","Use as a social media motion asset to drive awareness of Adobe Firefly around major AI announcements (Adobe Summit, MAX)","Pair with floral and celebratory tone in seasonal or product-launch campaigns where Firefly\'s creative richness is the message"]}},{"fileName":"AdobeSpecific-Set01-24.mp4","description":"The video is a 3-second, 1920\xd71080 animated 3D flythrough sequence set in a surreal, fantastical landscape. The opening frame is overlaid with a warm magenta-to-purple color wash that desaturates the underlying scene; beneath it a wide coastal fantasy world is visible featuring a still reflective body of water in the center, sandy shores lined with coral-red, orange, and white coral-like plant forms, large rocky formations in lavender and blue at the left, and dense red and pink bushy vegetation at the right. Floating in the air above the scene is a large, organically shaped mass \u2014 rendered as layered, wavy geological strata in deep coral, orange, and pink-red tones \u2014 that appears to hover and descend toward the center. Dozens of spherical and cubic floating objects in pink, red, coral, and blue are scattered throughout the air at various scales. In the center distance, a narrow triangular form rises from the water alongside what appears to be a small dark structure. As the sequence progresses, the magenta wash lifts fully to reveal the scene in bright, clean daylight: the water turns aqua-teal, the sky becomes a vivid pastel blue with white clouds and soft pink-tinted cumulus, and the hovering mass above reveals its full palette of magenta, pink, beige, teal, golden-yellow, and orange layered waves resembling pulled taffy or geological rock strata. Floating geometric forms \u2014 cubes, spheres, and rectangular solids \u2014 in orange, pink, red, teal, and cobalt blue are now clearly visible throughout the air. Coral and plant life on the shores is fully saturated in orange, purple, magenta, and yellow. The camera continues a slow zoom toward the central hovering form. In the final frames the sequence cuts to a close-up of the hovering sculptural mass against a plain pink-to-red gradient background, now fully bright and fully resolved, showing its complete strata detail. The overall visual style is hyper-detailed 3D rendered fantasyscape with a painterly, surrealist aesthetic.","keyElements":["Opening magenta color wash / tinted filter overlay","Sky color (transitioning from muted to vivid pastel blue)","Water color (transitioning from muted to aqua-teal)","Shore coral and plant life colors (orange, purple, yellow, magenta)","Floating geometric object colors (cubes, spheres) scattered throughout the air","Background rocky formations color (lavender, blue)","Final close-up gradient background (pink-to-red)"],"attributes":["hyper-detailed 3D fantasyscape","surrealist floating landscape","painterly color reveal","maximalist saturated palette","dreamlike aerial flythrough"],"productContext":{"visibleUIIndicators":["No UI chrome visible \u2014 pure motion/creative content"],"likelySuite":"Likely Adobe Firefly creative asset / generative AI showcase reel","adobeMarketingLanguage":{"generativeAI":["Generate images from a text prompt","AI-powered image generation","Turn ideas into high-quality content","Commercially safe generative AI"],"contentProduction":["Campaign-ready visuals","High-impact creative assets","Scroll-stopping visuals","Eye-catching images generated with AI"],"workflowAndProductivity":["Accelerate ideation","From prompt to finished visual","Rapidly produce campaign visuals"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale for multiple channels","Deliver visually differentiated content"]},"suggestedMarketingAngles":["Use as a showreel asset demonstrating Firefly\'s ability to generate richly detailed, imaginative environments from a text prompt","Pair with \'turn ideas into high-quality content\' messaging \u2014 the fantasyscape illustrates creative ambition achievable with AI","The color-wash-to-vivid reveal is a strong before/after metaphor for what AI unlocks creatively; use in Firefly awareness campaigns","Position as evidence of Firefly\'s range in generating non-photographic, illustrated, and painterly 3D creative styles","Use as b-roll in enterprise or agency pitches where creative differentiation and visual richness of AI-generated content is the argument"]}},{"fileName":"AdobeSpecific-Set01-29.mp4","description":"The video is a 3-second, 1920\xd71080 advertising concept demo showing a transition from a raw AI-generated image to a finished branded marketing ad. The opening frame is a close-cropped, partially cut-off shot of a person mid-leap against a diffuse mountain landscape background: the figure wears a bright yellow quilted puffer jacket open over a white outfit with white baggy trousers and white sneakers; a thin horizontal pink line is visible in the upper left corner, suggesting a UI progress indicator or in-progress generation state. The background is a soft gradient blending purple-grey mountain silhouette at left with a warm yellow-white glow at center and soft blue-grey at right. As the video progresses, the view zooms out to reveal the full finished advertisement composition: the same leaping figure is now centered in a wide 16:9 frame with the mountain background fully visible. Overlaid on the image are four additional design elements \u2014 a pink-bordered rectangular logo lockup in the upper left reading \'TREQ\' in bold white sans-serif type with a circular padlock icon above it in black; large-scale bold white all-caps display text on the left side reading \'STAY WARM. STAY WILD.\' stacked across three lines; a white rounded pill CTA button at lower left reading \'SHOP NOW\'; and two white UI badge cards on the right side of the image, one displaying a green checkmark icon with the label \'Commercially safe\' and one showing a semicircular gauge graphic with the score \'92\' and label \'Brand score\' alongside a small icon. In the final frame the brand score gauge increments from 92 to 95. The figure\'s shadow is visible on the ground below. The overall color palette of the final ad is cool blue-grey, warm yellow-white, bright yellow, and white, with pink and green accents from the UI overlay elements. The visual style is polished, editorial advertising.","keyElements":["Mountain background gradient colors (purple-grey, warm yellow-white, blue-grey)","Pink progress indicator line in opening frame","TREQ logo lockup border color (pink) and text style","Large display headline text color and typeface","CTA button style and label text","\'Commercially safe\' badge with green checkmark","\'Brand score\' gauge color, numeric value (92\u219295)","Overall background lighting tone"],"attributes":["ad concept UI demo","branded campaign layout reveal","commercially safe badge overlay","brand score metric animation","editorial fashion advertising"],"productContext":{"visibleUIIndicators":["\'Commercially safe\' badge with green checkmark icon \u2014 directly references Adobe Firefly\'s commercial safety guarantee","\'Brand score: 92 / 95\' gauge \u2014 references Adobe GenStudio brand compliance scoring","Pink progress line in opening frame suggesting active AI generation in progress","TREQ logo lockup with padlock icon suggesting brand-lock or content credentials"],"likelySuite":"Adobe Firefly / Adobe GenStudio for Performance Marketing (brand score and commercially safe indicators are GenStudio-specific UI elements)","adobeMarketingLanguage":{"generativeAI":["Commercially safe generative AI","Content Credentials and content provenance","Firefly models trained on licensed content","IP indemnification for enterprise users"],"contentProduction":["On-brand campaign content","Campaign-ready visuals","Produce content that reflects your brand identity","Brand-safe training data and enterprise-grade outputs"],"workflowAndProductivity":["From AI-generated image to finished campaign ad","Reduce time-to-market for campaign production","Accelerate ideation and campaign-ready visual creation"],"enterpriseAndScale":["Deliver confident business results with generative AI","Brand score and brand compliance at scale","Adobe GenStudio for Performance Marketing","Ensure content is always on-brand"]},"suggestedMarketingAngles":["Primary demo asset for Adobe GenStudio for Performance Marketing \u2014 the \'Brand score\' and \'Commercially safe\' badges are direct product UI proof points","Use alongside \'deliver confident business results with generative AI\' and \'commercially safe\' messaging in enterprise marketing materials","The brand score animation (92\u219295) is a compelling data-driven proof point for brand compliance \u2014 pair with messaging about Custom Models and brand consistency","Position as a before/after showing how a raw AI-generated image becomes a complete, brand-compliant, market-ready advertisement","Use in CMO-targeted content to show how Adobe\'s AI tools reduce risk while accelerating campaign production across global markets"]}},{"fileName":"AdobeSpecific-Set01-30.mp4","description":"The video is a 3-second, 1920\xd71080 content localization showcase demonstrating a single advertising campaign rendered across multiple languages, formats, and layouts simultaneously. The opening frame is a dense, tightly packed mosaic grid of approximately twelve distinct marketing asset cards arranged across the full frame, all featuring variations of the same \'TREQ\' branded puffer jacket campaign. Cards visible in the grid include: a French-language banner reading \'FAIT POUR L\'AVENTURE / ACHETER MAINTENANT\' showing a yellow jacket hanging against a mountain backdrop; a white-background email mockup addressed \'\xc0: Amelia Smith\' with French body copy describing \'La nouvelle doudoune TREQ\' in a prominent yellow card with bold oversized 3D-inflated typography reading \'DOU / DOU / NE\' in yellow; an orange-background banner with Chinese characters reading \'\u5F81\u670D\u6BCF\u65E5\u901A\u52E4\' (Conquer the Daily Commute); a Spanish-language paragraph on a light background describing the jacket in detail; a Korean-language ad with a female model in yellow jacket reading \'\uB530\uB73B\uD558\uAC8C, \uC790\uC720\uB86D\uAC8C\' (Stay Warm. Stay Free.) with a \'Shop Now\' CTA in Korean; a card showing a male model in a green jacket with Japanese text \'\u65E5\u3005\u306E\u901A\u52E4\u3092\u4E57\u308A\u8D8A\u3048\u308D\' (Overcome the Daily Commute); a German-language card reading \'F\xdcR ABENTEUER GEMACHT / JETZT KAUFEN\'; a card showing a male model in a dark background; and additional landscape/product-only cards. The TREQ wordmark appears on every card. In the second phase the grid dissolves and the view zooms into a single card \u2014 a Korean-language ad with the female model in the yellow puffer jacket on a blue-grey mountain background \u2014 which now appears isolated on a clean white background alongside a small white performance analytics card to its right displaying \'Click-through rate: 0.612\' with a small purple area line chart. The analytics card then expands in the final phase to show three stacked metric panels: \'Click-through rate: 0.612\', \'Cost per click: $0.80\', and \'ROAS: 1.29M\', each with purple sparkline charts indicating performance trends. The visual style transitions from dense and mosaic to clean, minimal, and data-driven.","keyElements":["Language variants displayed on campaign cards (French, Chinese, Korean, Japanese, German, Spanish)","Background colors and textures of individual mosaic cards","Model variant used per card (jacket color: yellow, green, orange; gender; pose)","Email mockup card design and typography style","Performance metric values displayed (CTR, CPC, ROAS figures)","Purple sparkline chart colors in analytics cards","Clean white background of the final isolated card view"],"attributes":["multilingual campaign localization","dense mosaic asset grid","performance analytics overlay","ROAS and CTR metric reveal","global content at scale"],"productContext":{"visibleUIIndicators":["Performance analytics card with \'Click-through rate: 0.612\', \'Cost per click: $0.80\', \'ROAS: 1.29M\' metrics and purple sparkline charts","Multi-language ad variants in a single mosaic view (French, Chinese, Korean, Japanese, German, Spanish)","TREQ branding lockup appearing consistently across all localized variants","Email campaign mockup format alongside banner and social variants"],"likelySuite":"Adobe GenStudio for Performance Marketing + Adobe Firefly Services (multilingual content localization + campaign performance analytics)","adobeMarketingLanguage":{"generativeAI":["Adapting imagery, text, and layouts for markets, languages, and customer segments at scale","Localized assets across multiple languages and channels","Generate on-brand content for global audiences","Commercially safe generative AI"],"contentProduction":["Content supply chain from ideation to distribution","Produce on-brand campaign visuals at scale","Faster campaign production and content localization across markets and channels","More personalized content for customer segments"],"workflowAndProductivity":["Go global with fast, easy-to-use localization that scales","Save time creating local variants from scratch","Reduce time-to-market","From single asset to global campaign"],"enterpriseAndScale":["Personalization at scale","Deliver personalized experiences across every touchpoint","Adobe GenStudio for Performance Marketing","Speed up time to market and power highly relevant experiences across audiences, markets, channels, and formats"]},"suggestedMarketingAngles":["Primary demo asset for Adobe GenStudio for Performance Marketing \u2014 the multilingual mosaic directly visualizes content localization at scale across six languages and multiple formats","Use alongside \'adapting imagery, text, and layouts for markets, languages, and customer segments at scale\' messaging from business.adobe.com/firefly-services","The ROAS (1.29M) and CTR (0.612) performance metrics make this ideal for ROI-focused enterprise and CMO-level presentations","Position the transition from mosaic grid to single-market performance view as proof of how GenStudio enables both content scale and performance measurement in one platform","Use in agency or global brand presentations to demonstrate how a single campaign asset can be localized into six or more markets with consistent on-brand outputs"]}}]}');


var $9ba5877a3645b751$exports = {};
$9ba5877a3645b751$exports = JSON.parse('{"items":[{"fileName":"AdobeSpecific-Set01-01.mp4","description":"The video is a 3-second, 1920\xd71080 animated showcase that opens on a flat lavender-to-purple gradient background filled with a 3\xd75 grid of square image cards, each displaying a different piece of digital creative work: visible cards include a vivid blue-and-red abstract digital painting, a greyscale 3D geometric composition with spheres and angular forms, a white-background botanical line drawing of a leaf, a pink-background swirling painterly abstract form, a pink-background colorful paint-stroke ribbon, a photographic collage of bright wildflowers in orange and yellow on green, a black-and-white geometric mandala, a pink-background flat-design abstract composition with green, yellow, and black blobs, a yellow-background colorful 3D spheres arrangement, a cyan-background swirling sculpted torus, a dark composition with glowing neon shapes, pink-background multicolored brushstroke ribbons, and a vivid blue-purple textured coral or sponge-like photograph. A thick red rectangular border highlights one central card \u2014 a lavender-background illustration of a multi-petaled floral form in pink, magenta, black-and-white geometric patterns, and teal \u2014 with a white hand-cursor icon pointing at it. As the animation progresses, the red-bordered selection box transitions to a new card showing a pink-background flat-design composition with large green, yellow, black, and red organic blob shapes alongside the floral card, and then to a close-up of a blue-teal butterfly on a warm yellow-and-red gradient background \u2014 each card revealed inside the same red selection border. In the final phase the video zooms into the grid background and transitions to a close-up view of four 3D-rendered torus forms on a neutral grey background, each with a different surface treatment: a sandy cracked-earth texture, a colorful painted rainbow surface, a white/cream ceramic-like finish, and a multicolored paint-splatter surface. Throughout, a white hand-cursor icon remains visible near the active red selection frame. The color palette of the grid background is a consistent soft lavender-purple; the individual card images are maximally varied in hue and style. Visual style is polished, editorial, and digitally art-directed.","keyElements":["Lavender-to-purple gradient grid background color","Thick red selection border frame","White hand-cursor icon position","Individual image card content and styles within the grid","Neutral grey background in the final torus close-up phase","Torus surface textures and color treatments"],"attributes":["editorial creative showcase grid","bold red selection frame","maximally varied card imagery","animated zoom transition","mixed 2D and 3D styles"],"productContext":{"visibleUIIndicators":["Thick red rectangular selection border around active image card","White hand-cursor pointer icon indicating selection interaction","Grid layout of creative image cards suggesting a content library or asset browser"],"likelySuite":"Likely Adobe Express or Adobe Firefly asset library / content browser UI","adobeMarketingLanguage":{"generativeAI":["Generate images from a text prompt","AI-powered creative content","Turn ideas into high-quality content"],"contentProduction":["Campaign-ready visuals","High-impact creative assets","Scroll-stopping visuals for social media","On-brand content generation at scale"],"workflowAndProductivity":["Browse, select, and iterate on creative assets","Accelerate ideation","From concept to campaign-ready asset"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as a showcase reel demonstrating the breadth of creative styles achievable with Adobe Firefly or Express \u2014 the grid format visualizes creative range at a glance","Pair with \'turn ideas into high-quality content\' messaging to emphasize the diversity of AI-generated outputs","The red selection border and cursor interaction suggest an intuitive browsing and selection workflow \u2014 ideal for \'easy-to-use creative tools\' messaging","Use as b-roll in campaigns targeting designers, illustrators, and creative teams showing the variety of asset types available in Adobe\'s ecosystem","Position alongside \'accelerate ideation\' language for creative teams that need to rapidly explore and select visual directions"]}},{"fileName":"AdobeSpecific-Set01-03.mp4","description":"The video is a 3-second, 1920\xd71080 abstract motion piece built around a nested square tunnel visual system on a solid black background. Throughout the entire sequence the composition is centered on three concentric rectangular frames: the outermost is a broad square border rendered in a smooth gradient transitioning from cyan-blue at the top through blue-purple to cyan at the bottom; the middle layer is a black void; and at the center sits a persistent solid red square \u2014 a constant visual anchor that never changes across the entire clip. Between the outer cyan-gradient border and the inner red square, a second decorative rectangular band is filled with dense multicolored graphic patterns \u2014 diagonal stripe sections in magenta, purple, blue, and green alternating with halftone dot-matrix segments in the same palette, giving it a vivid printed textile or screen-print aesthetic. On the left and right edges of the full frame, vertical strips of the same halftone and diagonal-stripe multicolor patterning are visible, acting as side-panel decorations. The overall feel is that of a tunnel or portal perspective zooming toward the central red square. The animation introduces motion in the second phase by overlaying white diagonal hatching shapes (resembling the motion stripe pattern from a film clapboard or road hazard marking) that appear within the black void layer between the multicolor band and the red square, rotate, and then disappear, cycling the composition back to its original state. Left and right edge strips alternate between solid hot pink, solid yellow, and gradient cyan-to-white vertical bars across different frames, creating a pulsing color accent. The entire piece loops smoothly. The visual style is graphic, hypnotic, and pattern-driven with a retro screen-print aesthetic.","keyElements":["Outer square border gradient (cyan-blue to cyan)","Left and right edge vertical strip colors (hot pink, yellow, cyan-to-white)","Multicolor halftone and diagonal stripe band colors and pattern density","White diagonal hatch animation shapes in the black void layer","Black void area between the decorative band and the red square","Solid red central square (constant anchor \u2014 not replaceable)"],"attributes":["hypnotic tunnel loop","retro screen-print patterns","high-contrast nested frames","pulsing edge color accents","graphic motion design"],"productContext":{"visibleUIIndicators":["No UI chrome visible \u2014 pure motion/creative content"],"likelySuite":"Likely Adobe Express motion template or Adobe Firefly creative asset / brand motion reel","adobeMarketingLanguage":{"generativeAI":["AI-powered creative content","Generate eye-catching visuals","Turn ideas into high-quality content"],"contentProduction":["Scroll-stopping visuals for social media","High-impact motion creative assets","Campaign-ready visuals","On-brand content generation"],"workflowAndProductivity":["Accelerate creative production","Rapidly produce on-brand campaign visuals","From concept to motion asset"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as an attention-grabbing loop for social media placements \u2014 the hypnotic tunnel pattern is designed to stop scrolling","Pair with \'scroll-stopping visuals\' or \'high-impact creative assets\' messaging for Adobe Express social content campaigns","The pulsing color edge strips and screen-print aesthetic position this as a youth/creative-culture facing asset for Adobe Express","Use as b-roll transition footage between product demo segments in longer-form Adobe marketing videos","Position alongside messaging about Adobe\'s motion template library and easy-to-customize branded content tools"]}},{"fileName":"AdobeSpecific-Set01-07.mp4","description":"The video is a 3-second, 1920\xd71080 multi-scene editing and compositing demo that cycles through three distinct visual states. The opening and most prominent state shows a full-frame blue studio background with a young adult male subject crouching at center \u2014 the same figure from video 06, wearing a grey-green washed-leather overshirt, grey-green frayed denim shorts, white socks, white sneakers with red and black accents, a silver chain necklace, a digital watch, and multiple bracelets. Overlaid on the subject at mid-torso is a blue dotted selection handle and thin white dashed bounding box indicating an object is selected for editing. In the lower left of the frame, a white rounded-square UI tooltip card displays a paintbrush icon labeled \'Paint\'. The mid-sequence frames show the same scene in transition \u2014 a rapid zoom-out and rotation reveals the scene from a wider perspective as it is surrounded by a bright green blurred vignette (suggesting a 3D canvas or out-of-frame environment), with a large yellow toroidal ring shape appearing behind and around the male subject. The figure\'s jacket and shoes are fragmenting in motion blur. A third scene resolves in the final frames: the background transitions fully to a vivid aqua-teal-to-green gradient and a completely different female figure now stands at center-right \u2014 she wears a bright green sleeveless knit top, a pale blue flowing midi skirt, and orange-red Mary Jane shoes; she stands on top of a large realistic green mossy island floating above a calm blue ocean surface, adopting a casual seated-but-standing pose with one arm raised. Surrounding her are multiple semi-transparent yellow-green and teal soap bubbles of varying sizes floating through the frame. In the lower-left quadrant of this final state, a white rounded-square UI tooltip card displays a different icon labeled \'Apply as mask\'. The overall visual style transitions from flat studio editorial photography to a vivid fantasy composite.","keyElements":["Blue studio background (opening state)","Aqua-teal-to-green gradient background (final state)","Bright green blurred vignette transition environment","Large yellow torus ring shape behind the male subject","Floating green mossy island surface","Semi-transparent yellow-green and teal soap bubbles","Blue ocean surface below the island","White \'Paint\' tooltip UI card","White \'Apply as mask\' tooltip UI card","Blue dotted selection handle and dashed bounding box on the subject"],"attributes":["multi-scene compositing demo","studio-to-fantasy transformation","bold UI tool overlay","vivid saturated palette","dynamic zoom transition"],"productContext":{"visibleUIIndicators":["Blue dotted selection handle and white dashed bounding box on selected subject element","White rounded-square tooltip card labeled \'Paint\' with paintbrush icon","White rounded-square tooltip card labeled \'Apply as mask\' with mask-add icon","Green blurred out-of-canvas vignette suggesting 3D canvas workspace"],"likelySuite":"Likely Adobe Express (Paint and Apply as mask tool overlays are consistent with Express canvas editing interactions)","adobeMarketingLanguage":{"generativeAI":["AI-powered image editing","Generate and composite elements","Apply masks and paint with AI assistance"],"contentProduction":["Campaign-ready visuals","On-brand content for social and digital channels","Scroll-stopping visuals","Produce eye-catching images quickly"],"workflowAndProductivity":["Iterate using intuitive editing tools","From studio photo to finished fantasy composite","Accelerate creative production"],"enterpriseAndScale":["Empower non-designers to create compelling visual content","Deliver content across channels and formats","Produce creative content at scale"]},"suggestedMarketingAngles":["Use as an Adobe Express editing capability reel \u2014 showcasing Paint and Apply as mask tools applied to live photography","Pair with \'empower non-designers to create compelling visual content\' for Express SMB or prosumer campaigns","The studio-to-fantasy composite transformation is a strong before/after narrative for \'turn your photo into something extraordinary\' messaging","Highlight the \'Apply as mask\' UI card for campaigns targeting creators who want professional compositing results without Photoshop expertise","Use alongside social media content creation messaging \u2014 the bubble and floating island composite is aspirational scroll-stopping content"]}},{"fileName":"AdobeSpecific-Set01-08.mp4","description":"The video is a 3-second, 1920\xd71080 live-action and motion graphics hybrid piece that opens with a heavily motion-blurred close-up of two human hands holding a smartphone against a light periwinkle-blue fabric background \u2014 the left hand displays a dark sport watch on the wrist. The phone screen shows a small but visible app UI with a colorful thumbnail image (a person in green against a bright background with what appears to be social media editing interface elements including a pink-red generate button). The background fabric appears to be a crumpled or draped blue cloth or garment. As the camera rapidly zooms out from the phone and rotates, the mid-section frames show the phone in a transitional blur \u2014 the phone casing is silver/chrome and the screen is visible with a dark rectangle UI before the scene fully opens up. In the final third of the video the scene resolves into a fully clear, styled-product-photography-style composition: a silver retro-style flip phone (resembling a late-1990s or early-2000s clamshell mobile phone form factor) is centered on the same crumpled blue fabric background. The flip phone is open, revealing its small rectangular screen displaying a photograph of a young woman in a blue graphic t-shirt with a white flower motif, pink-tinted oval sunglasses, and short blonde hair. She appears to be in a home environment photographing herself in a mirror. The flip phone keypad is visible below the screen, showing a circular d-pad with green call, red end, and home buttons. Around the flip phone, decorative 3D graphic elements are composited onto the blue fabric: a large black outline star shape is visible at the left, a chrome metallic 3D heart is at the upper right, and small blue diamond emoji shapes are scattered at the upper left. The overall color palette is dominated by periwinkle-blue fabric, silver chrome, and white with accent red, green, and black. The visual style is contemporary editorial product photography with retro-nostalgia prop styling.","keyElements":["Periwinkle-blue crumpled fabric background","3D chrome metallic heart at upper right","Black outline star at left","Blue diamond emoji shapes at upper left","Flip phone screen image content","Blue fabric background lighting and texture","Decorative 3D graphic elements placement and style"],"attributes":["retro flip phone nostalgia","styled editorial product shot","periwinkle-blue fabric backdrop","3D decorative graphic overlays","zoom-reveal transition"],"productContext":{"visibleUIIndicators":["Modern smartphone screen visible in opening frames displaying a colorful editing/social UI with a pink-red generate button","Retro flip phone as a composited creative prop \u2014 suggests image placement or mockup workflow","3D decorative graphic elements (star, heart, diamonds) composited onto the background \u2014 consistent with Adobe Express sticker/element library"],"likelySuite":"Likely Adobe Express (decorative 3D sticker elements and phone mockup compositing are consistent with Express creative tools)","adobeMarketingLanguage":{"generativeAI":["AI-powered creative content","Generate eye-catching visuals","Turn ideas into high-quality content"],"contentProduction":["Scroll-stopping visuals for social media","On-brand content generation","Campaign-ready visuals","Creative assets for digital channels"],"workflowAndProductivity":["Rapidly produce on-brand campaign visuals","From photo to styled creative asset","Accelerate ideation"],"enterpriseAndScale":["Create with speed, scale, and brand intelligence","Produce content at scale","Deliver engaging visuals across audiences and channels"]},"suggestedMarketingAngles":["Use as a social-media-first creative asset targeting Gen Z and millennial audiences with Y2K / retro nostalgia aesthetics","Pair with Adobe Express messaging around easy-to-add graphic elements and stickers for non-designer creators","The zoom-from-phone reveal is a strong format for short-form social ads (Reels, TikTok) showing the Express mobile app experience","Position the 3D decorative overlays (heart, star, diamonds) as proof of Express\'s rich element library for creative content makers","Use alongside \'scroll-stopping visuals for social media\' messaging \u2014 the retro prop styling and saturated blue palette are highly shareable"]}},{"fileName":"AdobeSpecific-Set01-09.mp4","description":"The video is a 3-second, 1920\xd71080 color-adjustment tool demonstration set against an elaborate, densely layered composite scene. The background image throughout the video is a vivid, maximalist rock-concert-themed collage: at left a person wearing a patterned purple-and-blue top holds an electric guitar; at upper center a drum kit with a performer is rendered in green neon tones against a dark textured background; at right another guitarist plays in a bright blue-lit environment; at lower left a shiny disco ball sits partially visible; and at center a large American-style school bus rendered with an ornate hand-painted pattern on its body (showing abstract faces, flowers, and geometric shapes in magenta, teal, and orange) serves as the central scenic anchor, with its rear end facing the viewer showing tail lights and chrome bumper. The color palette of the scene in the opening frames is heavily stylized with pink-magenta gels on the left guitarist and blue-cyan on the right. As the video progresses, a white rounded-rectangle UI panel appears in the lower center of the frame, clearly labeled with three sliders: \'Hue\' with a full-spectrum rainbow gradient bar and a numeric value reading \'106\', \'Saturation\' with a yellow-to-orange gradient bar at value \'0\', and \'Lightness\' with a black-to-white gradient bar at value \'0\'. This is a color adjustment or HSL panel. The slider handle on the Hue bar is positioned toward the right (green region). In the final frames the Hue value changes to \'-93\' and the Lightness slider shows \'21\', and the scene\'s overall tones shift accordingly \u2014 the bus and background become more blue-shifted and lighter. The visual style is high-energy, maximalist concert collage with a clear photo-editing UI overlay.","keyElements":["Rock concert composite background image color palette","Left guitarist pink-magenta gel lighting","Right guitarist blue-cyan lighting","School bus body pattern colors (magenta, teal, orange)","Hue, Saturation, Lightness slider values and color range bars","Overall scene color temperature shift (warm to blue-shifted)"],"attributes":["HSL color adjustment UI demo","maximalist concert collage","vibrant neon color palette","live slider interaction","photo editing tool overlay"],"productContext":{"visibleUIIndicators":["White rounded-rectangle HSL panel with Hue (rainbow gradient bar, value 106\u2192-93), Saturation (yellow-orange bar, value 0), and Lightness (black-white bar, value 0\u219221) sliders","Slider handles with numeric value readouts indicating active color adjustment in progress"],"likelySuite":"Likely Adobe Express or Adobe Firefly (HSL color adjustment panel is consistent with Express image editing tools)","adobeMarketingLanguage":{"generativeAI":["AI-powered image editing","Precise controls to fine-tune settings","Turn ideas into high-quality content"],"contentProduction":["On-brand content generation","Adjust color to match your brand palette","Campaign-ready visuals","Produce consistent visual content across assets"],"workflowAndProductivity":["Fine-tune settings and prompts prior to generation","Iterate and refine existing content","Accelerate creative production with precision tools"],"enterpriseAndScale":["Ensure content is always on-brand","Apply professional-grade color adjustments across large batches of images","Deliver content across channels and formats"]},"suggestedMarketingAngles":["Use as a product UI demo for Adobe Express\'s color adjustment tools \u2014 the HSL panel is clearly readable and shows real-time color shift on a complex image","Pair with \'precision controls that allow users to fine-tune settings\' messaging from Adobe Firefly\'s product page to emphasize editorial control","The concert/music scene makes this ideal for creative-industry audiences (music marketing, entertainment, social content) where vivid color is critical","Position alongside \'apply professional-grade color adjustments\' language from Firefly Services for batch color correction use cases","Use in campaigns targeting photographers, social media creators, and music marketers who need fast, intuitive color grading tools"]}},{"fileName":"AdobeSpecific-Set01-10.mp4","description":"The video is a 3-second, 1920\xd71080 social media content creation and publishing workflow demo set on a solid black background. The sequence opens on a single portrait-orientation phone mockup displayed at center-left on the black background, showing a dark-themed recipe/food content post in a social feed format. The post is from an account named \'Iron\u2013Alice\' (shown with a red-and-white cross icon avatar and a verified badge). The phone screen displays a title card reading \'AUTUMN FAVORITES / CAST IRON COOKING\' in bold white uppercase stacked text over a dark autumnal fantasy background scene: a lush green forest floor with colorful wildflowers, red autumn leaves, and a cast iron skillet in the foreground with a small cube of butter melting inside it. A white four-directional move arrow icon is centered on this image. A typography editing toolbar is visible below the phone, showing font name \'Bungee\', font size \'500\', an alignment icon, and an overflow menu \u2014 all in a dark panel UI. A blue selection bounding box with corner handles frames the text element \'AUTUMN\', and a rotating handle (circular blue arrow) indicates the text is being actively manipulated. A cursor arrow icon and a circular user avatar thumbnail (showing a woman) are visible to the right, representing a collaborating user. As the video progresses, the scene zooms out and three phone mockups appear side by side on the black background. The central phone shows a different slide from the same \'Iron\u2013Alice\' post: \'CAMPFIRE CAST IRON STEAK / SIMPLE COOKING OVER THE FIRE\' in bold uppercase over a close-up photograph of a seasoned raw steak with a pat of butter. The right phone shows a text-only \'INGREDIENTS\' slide listing: Meat (Ribeye 2\u2033 thick), Salt, Black Pepper, Garlic, Butter, Fresh Herbs, High-heat oil, Flaky finishing salt. Floating around the three phones are social engagement elements: grey pill-shaped speech bubbles reading \'so sick \uD83E\uDE77\' and \'YESSS!!\', red heart emoji, a fire emoji, a blue diamond emoji, and a view counter label reading \'137K Views\' then \'147K Views\'. The overall visual style is social-content-creator editorial with dark-mode UI elements and vivid food photography.","keyElements":["Black background","Three portrait phone mockup frames and their relative sizing/positioning","Post background image (autumnal forest floor, wildflower colors, skillet)","Typography font (Bungee), size value (500), and color (white bold uppercase)","Dark typography editing toolbar below phone","Blue selection bounding box and rotation handle on text","Collaborating user avatar thumbnail","Social engagement floating elements (speech bubbles, heart, fire, diamond emojis)","View counter value (137K \u2192 147K)"],"attributes":["social content creator workflow","dark-mode typography editor","food photography editorial","multi-slide social post format","live collaboration indicator"],"productContext":{"visibleUIIndicators":["Typography editing toolbar with font selector (\'Bungee\'), size field (\'500\'), alignment and overflow menu","Blue selection bounding box with corner handles and rotation handle on active text element","Circular user avatar thumbnail with blue cursor arrow indicating real-time collaboration","Portrait phone mockups in a side-by-side multi-slide social post layout","Social engagement overlays (view count \'137K\u2192147K\', heart/fire/diamond emoji reactions, speech bubble comments)"],"likelySuite":"Likely Adobe Express (multi-slide social post builder with typography editing, collaboration indicators, and social-format phone previews are consistent with Express\'s social content creation workflow)","adobeMarketingLanguage":{"generativeAI":["AI-powered creative content for social media","Generate eye-catching social posts","Turn ideas into high-quality content"],"contentProduction":["Scroll-stopping visuals for social media","On-brand content for social platforms","Campaign-ready social posts","Produce content creators can publish instantly"],"workflowAndProductivity":["Collaboratively visualize, test, and align on content before publishing","Iterate on social post designs with intuitive text and layout tools","From ideation to social-ready asset"],"enterpriseAndScale":["Empower non-designers to create compelling visual content","Deliver content across social channels and formats","Create with speed, scale, and brand intelligence","Produce localized or multi-format social content at scale"]},"suggestedMarketingAngles":["Primary demo asset for Adobe Express\'s social content creation workflow \u2014 typography editing, multi-slide post builder, and collaboration features are all visible","Use alongside \'empower non-designers to create compelling visual content\' messaging for Express SMB and creator-economy campaigns","The \'147K Views\' engagement counter is a strong social proof element \u2014 pair with ROI or content performance messaging for marketing teams","Highlight the real-time collaboration cursor for team-based content creation messaging \u2014 positions Express as a collaborative tool for marketing and creative teams","Use for food, lifestyle, and creator-economy audience segments \u2014 the \'Iron\u2013Alice\' cast iron cooking content is a highly relatable, aspirational creator persona"]}},{"fileName":"AdobeSpecific-Set01-13.mp4","description":"The video is a 3-second, 1920\xd71080 video editing workflow demonstration set against a deep dark maroon-to-black gradient background. The sequence opens with a rapid pan and zoom-in through blurred footage of a person in an orange-red puffer jacket against a vivid blue sky, transitioning to a sharp, full-bleed preview of the same footage inside a rounded-corner editing panel. The main subject throughout is a close-up portrait of a young adult male with short dyed-yellow hair and orange-pink oversized square-frame sunglasses, wearing a bright yellow-gold layered top and a coral-orange jacket. He is photographed against a bright sky-blue background with a tall hot-pink rectangular block visible at the right side of the frame. The skin and scene are lit with warm ambient light. The composition is tight, centering on the subject\'s face and upper chest. Below the main preview panel, a horizontal video timeline strip is visible showing five thumbnail frames of the same footage in two separate clip segments, divided by a thin blue vertical playhead marker. Beneath the timeline sits a flat dark teal audio waveform bar stretching the full width of the panel. In the final frames the editing panel zooms out and a secondary blurred UI panel appears to the right, showing a partially readable card labeled \'First\' with an image-add icon and below it the text \'Firefly Video\' with specs \'1080p\' and \'16:9\'. The panel fully resolves in the last frame to show a dark floating dialog containing a dark text-input field (with a blinking cursor), two dashed-border image placeholder slots labeled \'First\' and \'Last\' with an arrow-swap icon between them, and a footer row showing the red Firefly \'Fi\' icon, \'Firefly Video\', \'1080p\', \'16:9\', and a blue \'Generate\' button with a sparkle-star icon. The overall visual style is polished, cinematic dark-mode UI.","keyElements":["Dark maroon-to-black gradient background","Blue sky color in the footage background","Hot-pink rectangular architectural block in the footage background","Dark teal audio waveform bar","Timeline thumbnail clip segments and playhead color (blue)","Firefly Video dialog dark text-input field","\'First\' and \'Last\' dashed placeholder card borders","Blue \'Generate\' button with sparkle-star icon"],"attributes":["dark-mode video editor UI","cinematic fashion footage","timeline scrubber demo","Firefly Video generation dialog","vibrant saturated color palette"],"productContext":{"visibleUIIndicators":["Video timeline strip with thumbnail frames and blue playhead marker","Dark teal audio waveform bar below the timeline","Red Firefly \'Fi\' icon labeled \'Firefly Video\' with \'1080p / 16:9\' specs","Firefly Video generation dialog with \'First\' and \'Last\' image input slots","Blue \'Generate\' button with sparkle-star icon","Dark text-input field with blinking cursor for prompt entry"],"likelySuite":"Adobe Firefly Video (standalone or within Adobe Express / Premiere) \u2014 the \'Firefly Video\' label, \'First/Last\' frame inputs, and Generate button are visible Firefly Video UI elements","adobeMarketingLanguage":{"generativeAI":["Firefly Video \u2014 generate video from a text prompt","AI-powered video generation","Generate video clips from First and Last frame inputs","Commercially safe generative AI for video"],"contentProduction":["Campaign-ready video content","Generate video clips for social media and digital channels","Produce video content at scale","Scroll-stopping video visuals"],"workflowAndProductivity":["From footage to AI-generated video in seconds","Iterate on video content with generative AI","Accelerate video content production","Reduce time-to-market for video campaigns"],"enterpriseAndScale":["Firefly Video for enterprise content teams","Generate 1080p 16:9 video at scale","Produce video asset variations for multiple channels","Deliver content across video platforms and formats"]},"suggestedMarketingAngles":["Primary demo clip for Adobe Firefly Video \u2014 the \'Firefly Video / First / Last / Generate\' dialog is the clearest on-screen product evidence in the entire set","Use alongside \'generate video from a text prompt\' or \'AI-powered video generation\' messaging for Firefly Video launch or awareness campaigns","The fashion-forward footage subject (yellow-haired model, pink architecture, vibrant palette) makes this ideal for creative-industry, fashion, or social media-facing Adobe campaigns","Position the First/Last frame workflow as a unique differentiator \u2014 \'bookend your vision, Firefly fills the middle\' \u2014 for creative teams and video producers","Use in enterprise video production messaging showing how AI reduces the time from footage to finished video campaign asset"]}},{"fileName":"AdobeSpecific-Set01-14.mp4","description":"The video is a 3-second, 1920\xd71080 design application demo set against a warm yellow-to-peach-to-orange soft gradient background. The sequence opens on a dense 3\xd73 mosaic grid of existing social media and marketing design templates, all centered on tropical fruit themes: visible cards include a black-background vertical poster reading \'TROPICAL FRUIT / THE GOOD FRUIT SHOP\' with a diced mango image; a bright yellow card with a bowl of mango sorbet scoops priced at \'$4.99\'; a pale yellow \'Mango Juice\' card with a mango illustration; a blue tropical-sky \'NEW SUMMER DRINK\' card; a yellow \'B-A-N-A-N-A-S\' banana-pattern card; a multi-illustrated \'Happy Fruits Lover\' card; a bright green \'Refreshing! NEW\' mango smoothie cup card; and a yellow \'Fresh Drink SUMMER SPLASH\' card with a lemon drink. From this mosaic the video zooms in on and isolates the green \'Refreshing!\' mango smoothie card, which enlarges to fill the center of the screen. To the right, a vertical panel of four thumbnail element chips appears \u2014 a yellow star \'NEW\' badge, a green \'Refreshing!\' text chip, a mango cup thumbnail, and a mango fruit thumbnail \u2014 functioning as a component picker or element library sidebar. In the final frame a new element has been placed onto the card: a tall yellow-green aluminum beverage can with green bubble decoration and the text \'FIZZY FIZZ\' in bold green letters on its body, positioned overlapping the right side of the card design. A blue selection bounding box with corner handles frames the newly placed can element, and a cursor arrow is visible near it. The overall visual style is bright, food-marketing editorial with a warm summery palette.","keyElements":["Warm yellow-to-peach-orange soft gradient background","Green smoothie card background color","Yellow starburst \'NEW\' badge","White rounded \'Refreshing!\' display text style","Element/component picker sidebar thumbnails","Yellow-green \'FIZZY FIZZ\' aluminum can design, color, and label text","Blue selection bounding box and corner handles","Initial mosaic grid card designs and color variety"],"attributes":["food and beverage design demo","warm summery color palette","drag-and-drop element placement","template mosaic opening","product mockup composition"],"productContext":{"visibleUIIndicators":["Vertical element/component picker sidebar with thumbnail chips (badge, text, product image, fruit image)","Blue selection bounding box with corner handles on newly placed can element","Cursor arrow indicating active element placement interaction","Mosaic template grid suggesting a content library or template browser"],"likelySuite":"Likely Adobe Express (template library, element sidebar, and component drag-and-drop placement are consistent with Express canvas editing)","adobeMarketingLanguage":{"generativeAI":["AI-powered creative content","Generate on-brand campaign visuals","Turn ideas into high-quality content"],"contentProduction":["Campaign-ready food and beverage marketing templates","On-brand content generation","Scroll-stopping visuals for social media","Produce creative assets from templates quickly"],"workflowAndProductivity":["Browse, select, and customize from a rich template library","Drag and drop elements into designs","Accelerate creative production with templates","From template to finished campaign asset"],"enterpriseAndScale":["Empower non-designers to create compelling visual content","Produce content at scale using reusable templates","Deliver on-brand content across channels and formats"]},"suggestedMarketingAngles":["Use as an Adobe Express template library and element placement demo for food, beverage, and FMCG brand audiences","Pair with \'empower non-designers to create compelling visual content\' \u2014 the template-to-custom workflow shows Express making professional design accessible","The product mockup (beverage can placement) positions this for e-commerce and digital merchandising use cases within Firefly Services messaging","Use alongside content supply chain messaging \u2014 the template mosaic opening demonstrates how Express enables rapid asset variation from existing designs","Position for SMB and marketing team audiences who need quick, on-brand social content without a full design team"]}},{"fileName":"AdobeSpecific-Set01-15.mp4","description":"The video is a 3-second, 1920\xd71080 photo effects editing demonstration. The scene throughout shows a close-up portrait of a young adult male subject with dreadlocked hair wearing an open blue denim jacket over a striped black-and-white t-shirt. The entire face and head of the subject are rendered with a stylized halftone dot effect \u2014 a grid of evenly-spaced circular dots applied over the subject\'s skin, hair, and clothing. The background behind the subject is a flat photographic pink-and-blue leopard-print pattern (large blue spots on a pink base). In the opening frame, a white rounded-rectangle \'Effects\' panel is overlaid at the left side of the frame. The panel has a search bar labeled \'Search effects\', a section header \'Stylize\', and six square effect thumbnail previews arranged in a 2\xd73 grid: \'Glitch\' (showing a colorful RGB-shifted portrait), \'Dither\' (pixelated blue portrait), \'Halftone\' (black-and-white dot portrait, currently appearing to be applied), \'Halftone color\' (colorful dot portrait), \'Comic\' (graphic novel style portrait with a cursor mouse icon), and \'Photocopy\' (black-and-white high-contrast portrait). As the video progresses the Effects panel transitions to a detailed \'Halftone\' parameter control panel, showing five sliders and controls: Size (value 50), Definition (value 95), Distort (value 50), Level (slider near the right end), a Highlight color picker (showing a white circle, then changing to a hot pink/magenta circle in the final frame), a Shadow color picker (showing a solid black circle), and an Angle dial set to 45. As the Highlight color shifts from white to magenta, the halftone dots on the subject\'s face and hair correspondingly change from a black-and-white rendering to a vivid hot-pink/magenta dot pattern. The visual style is graphic, bold, and pop-art-influenced.","keyElements":["Pink-and-blue leopard-print background","Halftone effect dot size, density, and angle","Highlight color picker value (white \u2192 hot pink/magenta transition)","Shadow color picker value (solid black \u2014 constant)","Effects panel thumbnail options for Glitch, Dither, Halftone, Halftone color, Comic, Photocopy","Subject clothing: blue denim jacket, black-and-white striped t-shirt"],"attributes":["pop-art halftone effect demo","live effect parameter sliders","bold graphic style treatment","effects library panel UI","real-time color highlight change"],"productContext":{"visibleUIIndicators":["White \'Effects\' panel with search bar and \'Stylize\' section header","Six effect thumbnail previews: Glitch, Dither, Halftone, Halftone color, Comic, Photocopy","\'Halftone\' parameter panel with Size (50), Definition (95), Distort (50), Level, Highlight/Shadow color pickers, and Angle (45) dial","Highlight color picker transition from white to hot pink/magenta updating live on the canvas"],"likelySuite":"Likely Adobe Express (stylize effects panel with Halftone, Glitch, Dither, Comic, Photocopy presets and live parameter controls are consistent with Express graphic effects tools)","adobeMarketingLanguage":{"generativeAI":["AI-powered creative effects","Stylize images with one click","Turn ideas into high-quality content"],"contentProduction":["On-brand content generation with creative effects","Scroll-stopping stylized visuals for social media","Campaign-ready graphic design assets","Produce eye-catching images quickly"],"workflowAndProductivity":["Apply and fine-tune effects with intuitive sliders","Rapidly iterate creative styles","From photo to stylized creative asset in seconds"],"enterpriseAndScale":["Empower creative teams with precision effect controls","Produce stylized content at scale","Deliver distinctive visual content across channels"]},"suggestedMarketingAngles":["Use as a demo of Adobe Express\'s Stylize effects library \u2014 the panel, thumbnail previews, and live parameter controls are all clearly visible and readable","Pair with \'precision controls that allow users to fine-tune settings\' messaging \u2014 the Halftone sliders (Size, Definition, Distort, Angle) demonstrate granular creative control","The pop-art halftone-to-magenta color transformation is a strong visual hook for social media campaigns targeting creative professionals and designers","Position alongside \'rapidly iterate creative styles\' messaging for creative teams who need to quickly explore and apply visual treatments to campaign imagery","Use in Express consumer or SMB campaigns \u2014 the intuitive effects panel shows professional results achievable without design expertise"]}},{"fileName":"AdobeSpecific-Set01-16.mp4","description":"The video is a 3-second, 1920\xd71080 layered photo effects editing demonstration, continuing directly from the visual context of video 15. The subject and background are identical: a close-up portrait of a young adult male with dreadlocked hair wearing a blue denim jacket and black-and-white striped t-shirt, set against a pink-and-blue leopard-print background. The entire portrait is rendered with a vivid hot-pink/magenta halftone dot effect applied to the face and upper body. As the video progresses the effect treatment on the clothing and lower body transitions: in the opening frame the denim jacket appears photorealistic but in subsequent frames transitions to a high-contrast black, purple-blue, and violet graphic treatment resembling a Photocopy or Comic effect \u2014 the jacket becomes predominantly black with strong white-highlight linework and the t-shirt stripes become bold purple-blue and white bands. A white rounded-rectangle UI parameter panel appears at the lower-left of the frame across the sequence, labeled \'Photocopy\', showing: a Highlight color swatch (white circle), a Shadow color swatch (solid black circle), a Strength slider, and a Contrast slider with value \'50%\'. A black cursor arrow is visible near the bottom of this panel. In the final frame the UI panel switches to a \'Layers\' panel, also white and rounded-rectangle, displaying four named layer rows each with a small thumbnail: \'Layer 4\' (showing a small pink halftone hair thumbnail), \'Layer 3\' (showing a transparent checkerboard thumbnail with a dark figure), \'Layer 2\' (showing a solid blue color swatch), and \'Layer 1\' (showing a leopard-print texture thumbnail, which is currently selected/highlighted and shows a small filter-adjustment icon). A black cursor arrow and small settings gear icon are visible next to Layer 1. The visual style is graphic, bold, and layered art-direction.","keyElements":["Pink-and-blue leopard-print background (Layer 1 thumbnail visible)","Hot-pink/magenta halftone dot effect on the subject\'s face and hair","Black, purple-blue, violet graphic treatment on jacket and t-shirt","Photocopy panel Highlight color swatch (white), Shadow color swatch (black)","Photocopy Strength and Contrast slider values","Layers panel: Layer 4 (halftone hair), Layer 3 (masked figure transparent), Layer 2 (solid blue swatch), Layer 1 (leopard texture, selected)"],"attributes":["layered effects editing demo","Photocopy effect with live controls","Layers panel UI","bold graphic pop-art treatment","multi-layer composition view"],"productContext":{"visibleUIIndicators":["White \'Photocopy\' parameter panel with Highlight/Shadow color swatches, Strength slider, Contrast slider (50%)","White \'Layers\' panel showing Layer 1\u20134 with thumbnails (halftone hair, transparent mask, blue fill, leopard texture)","Layer 1 (leopard-print texture) selected with filter-adjustment icon visible","Black cursor arrow indicating active layer selection interaction"],"likelySuite":"Likely Adobe Express (Photocopy effect parameter panel and multi-layer composition panel with named layers and thumbnails are consistent with Express\'s layered editing tools)","adobeMarketingLanguage":{"generativeAI":["AI-powered creative effects","Stylize images with layered effects","Turn ideas into high-quality content"],"contentProduction":["On-brand content generation with multi-layer effects","Scroll-stopping stylized visuals","Campaign-ready graphic design assets","Produce layered creative compositions quickly"],"workflowAndProductivity":["Work with layers for precise creative control","Apply Photocopy and Halftone effects with fine-tuned parameters","Iterate on layered compositions efficiently"],"enterpriseAndScale":["Empower creative teams with professional layer management","Produce stylized content at scale","Deliver consistent on-brand visual treatments across assets"]},"suggestedMarketingAngles":["Use as a demo of Adobe Express\'s Layers panel and multi-effect layering \u2014 the four-layer composition (background, figure mask, color fill, effect) shows professional creative depth","Pair with \'precision controls\' messaging \u2014 the Photocopy Strength/Contrast sliders alongside the visible Layers panel demonstrate Express\'s advanced but approachable layer editing","The bold graphic pop-art treatment (magenta halftone + black Photocopy) is visually striking for social media campaign assets targeting creative and design audiences","Position the Layers panel alongside messaging about building reusable, brand-consistent templates that creative teams can adapt across campaigns","Use alongside video 15 as a two-part editing demo showing the full effects and layers workflow within Adobe Express"]}},{"fileName":"AdobeSpecific-Set01-17.mp4","description":"The video is a 3-second, 1920\xd71080 analytics dashboard interface demonstration set on a clean, flat light-grey background. The sequence shows a two-panel web analytics dashboard UI with no decorative background \u2014 pure light grey fills the entire frame. The left panel, labeled \'Test for mobile\' at the top, contains a date range selector (\'Yesterday vs Same day last week\') with a dropdown arrow, a segment filter field reading \'No segments applied\' with a segments icon, and a 2\xd72 grid of four metric KPI cards: \'VISITS 41.7K (+7.9%)\', \'CONVERSION RA... 1.61% (-10.4%)\', \'REVENUE $55.4K (+0.8%)\', and \'ORDERS 673 (-3.3%)\'. Each KPI card shows a small sparkline trend chart. Below the four KPI cards sits a fifth card labeled \'NEW KPI / Drag and drop Metrics or Dimensions here\' with a placeholder sparkline and a partially visible \'Donut +\' drag handle from the left edge indicating a component is being dragged in. In the right panel, labeled \'Orders\', an area/line chart tracks order volume across a timeline (12 AM to 8 PM), with two overlapping line series in teal and grey, numerical axis labels (2, 28, 54), and date labels (\'Wed, Jun 1\' and \'Wed, May 25\'). Below the chart a \'Details\' table shows hourly order entries (Jun 1, 2022 12:00 AM: 24, +33.3%; 1:00 AM: 8, +60%; 2:00 AM: 9, -10%; 3:00 AM: 25, +25%). In later frames the right panel content changes: the \'Orders\' line chart is replaced by an \'Occurrences: 1,338,171 (+7.9%)\' donut chart panel showing a color-coded ring (teal, dark blue, orange, pink-magenta) with a legend listing time-slot segments (Jun 1 6PM, 7PM, 10AM, 5PM, Other). The \'OCCURRENCES\' KPI card also appears at the bottom of the left panel. A \'Preview\' button label is partially visible in the upper-right corner. The overall visual style is clean, minimal SaaS analytics UI with no visual ornamentation.","keyElements":["Light grey flat background","KPI card metric values (Visits 41.7K, Conversion 1.61%, Revenue $55.4K, Orders 673, Occurrences 1.34M)","Teal sparkline chart lines in KPI cards","Orders line chart teal and grey series colors","Occurrences donut chart segment colors (teal, dark blue, orange, pink-magenta)","Segment filter field and date range selector","\'Donut +\' drag handle component"],"attributes":["clean SaaS analytics dashboard","KPI card metric display","drag-and-drop component demo","donut chart segment visualization","minimal light-grey UI"],"productContext":{"visibleUIIndicators":["Analytics dashboard with KPI cards: Visits (41.7K), Conversion Rate (1.61%), Revenue ($55.4K), Orders (673), Occurrences (1.34M)","\'Drag and drop Metrics or Dimensions here\' placeholder card","\'Donut +\' drag handle indicating component drag-and-drop interaction","Orders line chart with teal and grey comparison series","Occurrences donut chart with color-coded segment legend","\'Preview\' button partially visible in upper-right corner"],"likelySuite":"Likely Adobe Customer Journey Analytics (CJA) \u2014 the interface, KPI card layout, drag-and-drop dimension/metric builder, \'Occurrences\' metric, donut chart, and \'Flow Pathing\' label in video 18 all match Adobe CJA\'s Analysis Workspace UI","adobeMarketingLanguage":{"generativeAI":["AI-powered analytics insights","Intelligent alerts and anomaly detection","Derive insights at scale with generative AI"],"contentProduction":["Data-driven content performance dashboards","Real-time marketing analytics","Customer journey analytics for informed decision-making"],"workflowAndProductivity":["Drag and drop metrics and dimensions to build custom dashboards","Accelerate insight discovery with intuitive analytics tools","From raw data to actionable dashboard in minutes"],"enterpriseAndScale":["Adobe Customer Journey Analytics","Personalized experiences at scale informed by data","Unified customer experience data across touchpoints","Drive differentiated and personalized interactions"]},"suggestedMarketingAngles":["Use as a demo clip for Adobe Customer Journey Analytics \u2014 the drag-and-drop KPI builder, donut chart, and multi-metric comparison are clearly legible analytics UI elements","Pair with \'derive insights at scale\' or \'intelligent alerts and anomaly detection\' messaging for analytics and data teams","The Visits/Conversion/Revenue/Orders KPI combination makes this immediately relatable for e-commerce and digital marketing analytics audiences","Position alongside \'unified customer experience data across touchpoints\' messaging \u2014 the Orders and Occurrences panels demonstrate multi-dimensional data visualization","Use in CMO or analytics team-facing content showing how Adobe CJA enables rapid, customizable performance dashboards without technical expertise"]}},{"fileName":"AdobeSpecific-Set01-18.mp4","description":"The video is a 3-second, 1920\xd71080 analytics dashboard scroll and panel expansion demo, presented on a clean white background. The sequence begins with a visible \'Flow Pathing\' panel \u2014 a Sankey-style funnel diagram labeled with \'Panel\' and \'Add Segment\' UI elements \u2014 showing a customer journey visualization. The left column lists action names and their event counts: \'View Item: 29,870\', \'Select Size: 13,169\', \'Change Color: 5,521\', \'Change Quantity: 3,783\', \'+16 More: 3,673\'. These flow into the right column where a conversion node labeled \'Action Name: Add to Cart: 100,016\' is visualized as a tall stacked color bar (blue, purple, pink-red, orange, lime-green segments from top to bottom), with curved Sankey-style flow paths connecting the left actions to the right destination. The dashboard then scrolls upward to reveal a second panel above the Flow Pathing panel. This new panel is titled \'Online Orders across Marketing Channel | Models: Last Touch, First Touch, Linear, J Curve, Inverse J | Lookback: Visitor\'. It contains two sub-panels: \'Total Online Orders\' (a large metric KPI area showing the number, which animates from a placeholder to \'52,110\' in green at the final frame, labeled \'All Visits: Online Orders\') and \'Online Orders Attribution Comparison\' showing a grouped bar chart with multiple colored series representing different attribution models (green/lime, dark blue/navy, magenta, teal/cyan, orange) grouped by marketing channel categories along the X-axis: Email Campaigns, Paid Search, Social Campaigns, Display, Unspecified, Text, Podcasts, Comparison Shopping, Other Websites, Mailers. The overall visual style is minimal, clean SaaS analytics UI on white.","keyElements":["White background","Flow Pathing Sankey diagram action names and event counts","Stacked color bar segments: blue, purple, pink-red, orange, lime-green","Curved Sankey flow path lines","Total Online Orders metric value (52,110) in green","Attribution model bar chart colored series (green, navy, magenta, teal, orange)","Marketing channel X-axis categories","Add Segment filter field"],"attributes":["Sankey flow pathing visualization","multi-attribution bar chart","clean white analytics UI","customer journey funnel demo","marketing channel comparison"],"productContext":{"visibleUIIndicators":["Flow Pathing panel with Sankey diagram: View Item (29,870) \u2192 Select Size, Change Color, Change Quantity \u2192 Add to Cart (100,016)","Stacked color bar at \'Add to Cart\' node with blue, purple, pink, orange, lime segments","Online Orders Attribution Comparison grouped bar chart with 5 attribution model series","Total Online Orders KPI metric: 52,110 (green)","Attribution panel label: \'Last Touch, First Touch, Linear, J Curve, Inverse J | Lookback: Visitor\'","\'Add Segment\' and \'Panel\' UI headers with \'Last 30 days\' date range label"],"likelySuite":"Likely Adobe Customer Journey Analytics (CJA) \u2014 Flow Pathing, Attribution Comparison panels, multi-model attribution (Last Touch, First Touch, Linear, J Curve, Inverse J), and Analysis Workspace layout are distinctive Adobe CJA features","adobeMarketingLanguage":{"generativeAI":["AI-powered analytics and attribution insights","Intelligent product recommendations and anomaly detection","Derive insights at scale"],"contentProduction":["Data-driven marketing channel performance dashboards","Attribution analysis for campaign optimization","Customer journey analytics for conversion improvement"],"workflowAndProductivity":["Visualize customer journeys with Flow Pathing","Compare attribution models side-by-side","From raw clickstream data to actionable funnel insight"],"enterpriseAndScale":["Adobe Customer Journey Analytics for enterprise marketing teams","Multi-touch attribution across marketing channels at scale","Unified customer experience data and journey orchestration","Drive personalized experiences informed by attribution data"]},"suggestedMarketingAngles":["Use as a demo clip for Adobe Customer Journey Analytics \u2014 the Flow Pathing Sankey diagram and Attribution Comparison bar chart are two of CJA\'s most distinctive and visible features","Pair with \'multi-touch attribution across marketing channels\' messaging for performance marketing, analytics, and data science audiences","The \'Add to Cart: 100,016\' conversion node is a strong e-commerce proof point \u2014 pair with \'drive conversion with customer journey insights\' messaging","Position the attribution model comparison (Last Touch vs First Touch vs Linear vs J Curve vs Inverse J) as a decision-support tool for budget allocation and media mix optimization","Use alongside video 17 as a two-part CJA analytics demo showing both the KPI dashboard builder and the advanced Flow Pathing and attribution workflows"]}},{"fileName":"AdobeSpecific-Set01-19.mp4","description":"The video is a 3-second, 1920\xd71080 generative video content showcase set on a solid black background. The sequence opens on a floating, 3D spatial arrangement of multiple media asset cards of varying sizes scattered across the dark canvas, each displaying different AI-generated or photographed content types. Visible cards include: a wide landscape card showing a dramatic pink-purple cloudscape at golden hour; a circular card showing a snowy mountain peak inside a glass globe against a pink sky; a dark rectangular card with what appears to be a human figure in a corridor; a card with red abstract shapes; a card partially showing a red puffer jacket; a small card showing a pink-magenta tropical sunset with palm trees; a card showing a spectral audio waveform visualization in red, pink, and blue; a card showing a close-up portrait of a white Bengal tiger; and a white prompt-text card with several lines of small type reading a scene prompt beginning \'A fish-eye lens 3D render of an animated character wearing a red, futuristic, puffy space suit, running toward the camera across a minimalistic white landscape\u2026\' with additional terms. Several cards also show a white circular play button icon overlaid, indicating they contain video rather than static images. As the sequence progresses and the camera zooms forward through the card arrangement, cards rearrange and new ones appear: a center card showing a 3D animated character in a red puffy space suit running toward camera on a white minimalist landscape with motion blur; a pink-sky cloudscape card; additional dark atmospheric cards; and a blurry waveform/audio card. In the final frame the sequence resolves on a single wide-frame card showing a 3D-animated tiger-headed character wearing a full red space suit, running toward camera across a snowy mountain valley landscape with warm peachy-pink atmospheric lighting and snow-covered rocky peaks in the background. The overall visual style is dark, cinematic, and AI-generative with a floating 3D card gallery aesthetic.","keyElements":["Solid black background","Floating card sizes, positions, and z-depth arrangement","Pink-purple cloudscape landscape card","Spectral audio waveform card colors (red, pink, blue)","White Bengal tiger portrait card","Red puffy space-suit animated character subject","Snowy mountain valley background in final generated video frame","Prompt text card content and styling"],"attributes":["dark floating 3D card gallery","generative video showcase","diverse AI content types","cinematic spatial layout","animated character video reveal"],"productContext":{"visibleUIIndicators":["Multiple floating content cards with white circular play button overlays (indicating video content)","Prompt text card visible with scene generation description: \'A fish-eye lens 3D render of an animated character wearing a red, futuristic, puffy space suit...\'","Audio waveform card alongside video and image cards suggesting multi-modal content generation","3D spatial floating card arrangement suggesting an infinite canvas or media browser workspace"],"likelySuite":"Likely Adobe Firefly Video or Adobe Firefly Boards (3D floating card gallery with mixed video/image/audio/text content types matches Firefly Boards\' infinite canvas; prompt text card and generated video output match Firefly Video workflow)","adobeMarketingLanguage":{"generativeAI":["Generate video from a text prompt","AI-powered video and image generation","Firefly Video \u2014 from text prompt to finished video clip","Commercially safe generative AI for creative teams"],"contentProduction":["Campaign-ready video and image assets","Generate eye-catching video clips for social media","Scroll-stopping AI-generated video content","Produce video and image variations at scale"],"workflowAndProductivity":["From text prompt to generated video in seconds","Brainstorm, organize, and iterate on video concepts","Accelerate video content production with generative AI"],"enterpriseAndScale":["Generate 3D animated video at scale","Produce video asset variations for multiple channels","Firefly Video for enterprise content teams","Deliver video content across platforms and formats"]},"suggestedMarketingAngles":["Use as a Firefly Video and Firefly Boards showcase demonstrating multi-modal AI generation \u2014 video, image, audio waveform, and prompt text cards all visible in one canvas","The tiger-headed space-suit character running through a snowy mountain valley is a visually arresting Firefly Video output \u2014 use as a hero creative asset in generative AI awareness campaigns","Pair the visible prompt text card with \'generate video from a text prompt\' messaging \u2014 the prompt-to-output relationship is shown directly on screen","Position the 3D floating card gallery format as Firefly Boards\' visual workspace \u2014 use alongside \'brainstorm, organize, and iterate on ideas with teammates on an infinite canvas\' messaging","Use for creative agency, animation, and entertainment industry audiences to demonstrate Firefly\'s capability for generating character-based animated video content"]}},{"fileName":"AdobeSpecific-Set01-20.mp4","description":"The video is a 3-second, 1920\xd71080 generative AI product variation demonstration set against a neutral warm greige (beige-grey) background. The sequence opens with a single product image card at the left-center of the frame: a square card with a dark forest-green gradient background displaying a 3D-rendered over-ear wireless headphone in olive-green and silver tones. In the upper-left corner of this card, a white tag reads \'Firefly Boards\' with the red Firefly \'Fi\' icon. To the right of the product card, a dark floating context menu has appeared, containing three options in white text: a wavy-lines icon followed by \'Vary\', a sparkle-image icon followed by \'More like this\', a circular Venn-like icon followed by \'Keep style\', and a person-icon followed by \'Keep subject\'. An orange cursor arrow and circular user avatar thumbnail (showing a smiling man) are visible at the lower right of this menu. As the video progresses the context menu disappears and the single card is replaced by a 3\xd72 grid of six square product image cards, each showing the same over-ear headphone in a different colorway and matching background color: forest green on dark green, slate grey on grey, deep red/burgundy on pink, deep purple on lavender, slate blue on light blue, and warm brown on peach. The bottom-right card is still generating (showing a pixelated/blurred in-progress state in the early frames, then resolving to the finished brown/peach version in the final frame). The arrangement fills most of the visible canvas on the neutral greige background. The overall visual style is clean, product photography editorial with a soft consistent lighting across all variants.","keyElements":["Neutral warm greige background","Six headphone colorway-background combinations: dark green/green, slate grey/grey, burgundy/pink, deep purple/lavender, slate blue/light blue, warm brown/peach","\'Firefly Boards\' white tag with red Fi icon on original card","Dark context menu with Vary, More like this, Keep style, Keep subject options","Orange cursor arrow and circular user avatar","Bottom-right card in-progress pixelated generating state"],"attributes":["product color variation generation","Firefly Boards context menu UI","clean neutral product photography","6-variant grid reveal","Keep style and Keep subject AI options"],"productContext":{"visibleUIIndicators":["\'Firefly Boards\' tag with red Firefly \'Fi\' icon on the source product card","Dark context menu with: \'Vary\' (wavy lines icon), \'More like this\' (sparkle-image icon), \'Keep style\' (Venn circles icon), \'Keep subject\' (person icon)","Orange cursor arrow and user avatar indicating a user-driven interaction","In-progress pixelated generation state on bottom-right variant card","6-card variant grid showing the headphone in 6 distinct color schemes"],"likelySuite":"Adobe Firefly Boards \u2014 the \'Firefly Boards\' tag, \'Vary / More like this / Keep style / Keep subject\' context menu, and generative product variant grid are specific Firefly Boards UI patterns","adobeMarketingLanguage":{"generativeAI":["Generate product image variations with Keep style and Keep subject","Vary and iterate on generated assets","More like this \u2014 generate similar on-brand product imagery","Commercially safe generative AI for product imagery"],"contentProduction":["Product image variations for e-commerce and digital merchandising","On-brand product imagery at scale","Campaign-ready product visuals across color variants","Generate lifestyle and product composite backgrounds"],"workflowAndProductivity":["From one product image to six color variants in seconds","Vary, iterate, and refine product imagery within Firefly Boards","Accelerate product photography production with AI"],"enterpriseAndScale":["Generate on-brand product imagery at scale for e-commerce","Product color variant generation for global markets","Firefly Boards for creative teams and product marketing","Deliver product asset variations across channels and formats"]},"suggestedMarketingAngles":["Primary demo clip for Adobe Firefly Boards\' \'Vary\' and \'Keep subject\' workflow \u2014 the context menu options and 6-variant product grid are clearly visible and immediately readable","Pair with e-commerce and digital merchandising messaging \u2014 \'generate product imagery variants for every colorway without a full photoshoot\' is the clear use case shown","Use alongside \'More like this\' and \'Keep style\' messaging to highlight how Firefly Boards enables rapid, brand-consistent product image iteration for marketing teams","Position for product marketing teams at consumer electronics, fashion, and lifestyle brands who need to generate multiple product colorway assets efficiently","Use in Firefly Boards awareness campaigns showing the platform\'s value for ideation, product visualization, and campaign asset generation from a single source image"]}},{"fileName":"AdobeSpecific-Set01-23.mp4","description":"The video is a 3-second, 1920\xd71080 marketing analytics intelligence dashboard reveal, set on a dark near-black background with a faint purple radial glow visible in the lower center. The sequence opens with several white rounded-rectangle UI panels partially visible at the edges of the frame \u2014 a panel at the upper left shows partial text and a number, and a panel at the lower right labeled \'June conversions\' shows a \'$20\' axis label \u2014 as the view zooms out. The dashboard fully resolves in the main frames: six white rounded-rectangle metric and visualization cards are arranged in a 2\xd73 grid layout centered on the dark background. The cards are: (1) \'Brand sentiment \u2014 Sentiment about your brand in LLM mentions?\' with a green-dominant donut gauge showing \'81% Positive\' and a small red arc representing negative; (2) \'New prospect detected \u2014 Target new prospects for this experience, You might increase the conversion rate\u2026\' with a line chart showing a current trend vs a projected trend line (+17%), and two action buttons: \'Dismiss\' and \'View\'; (3) \'Audience comparison\' with a teal and blue overlapping Venn diagram showing \'85% First time purchase\' and \'21% / 23% \u2014 21\u201325 year old women\'; (4) \'Revenue (Incremental) \u2014 +$1.7M \u21916.2%\' with a teal sparkline trend chart and a small button at lower left; (5) \'Experience A Click-through rate +45%\' with a blue dot indicator; and (6) \'June conversions\' with a dual-line chart (blue \'Total conversions\', pink/magenta \'Mobile app users\') with Y-axis values from 0 to $20. The animated metric in the Audience comparison card changes between frames from \'21%\' to \'23%\'. The overall visual style is clean, minimal dark-mode enterprise analytics dashboard.","keyElements":["Dark near-black background with faint purple radial glow","Brand sentiment donut gauge: 81% Positive (green arc, small red negative arc)","New prospect detected line chart trend colors (blue current, grey projected)","Audience comparison overlapping Venn diagram: teal circle and blue circle","Revenue sparkline teal line chart","June conversions dual-line chart: blue (Total) and pink/magenta (Mobile app users)","Animated percentage metric: 21% \u2192 23% (Audience comparison)"],"attributes":["dark-mode marketing intelligence dashboard","brand sentiment donut gauge","AI prospect detection alert","audience Venn comparison","incremental revenue sparkline"],"productContext":{"visibleUIIndicators":["Brand sentiment card: \'81% Positive \u2014 Sentiment about your brand in LLM mentions?\'","New prospect detected alert card with trend line chart (+17%), \'Dismiss\' and \'View\' action buttons","Audience comparison Venn diagram: 85% First time purchase / 21\u201323% 21\u201325 year old women","Revenue (Incremental): +$1.7M \u21916.2% with teal sparkline","Experience A Click-through rate: +45% with blue dot indicator","June conversions dual-line chart: Total conversions (blue) vs Mobile app users (pink/magenta)"],"likelySuite":"Likely Adobe Experience Platform (AEP) or Adobe Real-Time CDP \u2014 brand sentiment in LLM mentions, AI prospect detection, audience comparison Venn, incremental revenue, and experience A/B testing metrics match Adobe Experience Cloud\'s AI Agent and analytics dashboard patterns","adobeMarketingLanguage":{"generativeAI":["AI-powered marketing insights and prospect detection","Brand sentiment analysis in LLM mentions","AI agents that engage directly with customers and support marketing workflows","Intelligent alerts and anomaly detection"],"contentProduction":["Data-driven personalized customer experience optimization","Experience A/B testing and performance measurement","Audience comparison for targeted campaign delivery"],"workflowAndProductivity":["Real-time marketing intelligence dashboards","From AI-detected prospect to activated campaign experience","Accelerate insight-to-action with AI-powered alerts"],"enterpriseAndScale":["Adobe Experience Platform Agent Orchestrator","Adobe Real-Time CDP for audience activation at scale","Deliver personalized experiences across every touchpoint","Unified customer experience data and AI-driven orchestration"]},"suggestedMarketingAngles":["Use as a demo clip for Adobe Experience Platform / Real-Time CDP \u2014 the brand sentiment, prospect detection alert, audience Venn, and incremental revenue cards represent enterprise marketing intelligence capabilities","The \'New prospect detected\' card with \'Dismiss / View\' actions is a compelling visual metaphor for AI agent-powered marketing automation \u2014 pair with AEP Agent Orchestrator messaging","Position the \'Brand sentiment in LLM mentions\' card as forward-looking AI differentiation \u2014 measuring brand health in AI-generated content is a genuinely novel capability to highlight","Use the +45% click-through rate and +$1.7M incremental revenue metrics as outcome-focused proof points in enterprise ROI messaging for Adobe Experience Cloud","The dark dashboard aesthetic is strong for premium enterprise marketing \u2014 use in Adobe Summit, MAX, or executive audience presentations alongside Experience Cloud announcements"]}},{"fileName":"AdobeSpecific-Set01-25.mp4","description":"The video is a 3-second, 1920\xd71080 AI-driven ad set generation and campaign launch workflow demo, set on a clean white background with subtle light-grey panel areas. The sequence opens with the view partially showing a partially off-screen pill-shaped prompt completion message bar at the top of the frame, and below it a horizontal layout of three audience segment columns, each with a header label and a persona-tagged ad card below. The columns are labeled: \'Engaged Customers \u2014 Audience A\', \'Re-engaged Lapsed \u2014 Audience B\', and \'High Intent \u2014 Audience C\'. Below each label sits a social post preview card showing a styled B2B marketing advertisement for a brand called \'Altura\', each with a distinct tagline: \'From Vision to Acceleration.\' (Audience A, featuring a Black woman in a blue blazer against a sky background), \'Where Innovation Takes Off.\' (Audience B, featuring a minimal architectural image), and \'Powering Tomorrow, Today.\' (Audience C, featuring two professionals with a tablet). All three cards share the Altura logo in the upper-left corner and a consistent clean B2B visual style. A message bar above reads \'The ad set for your target audiences is ready\' next to a pink-and-red gradient icon resembling a chat/AI agent badge. As the video progresses the view zooms out to reveal a wider canvas beneath the three main ad cards, showing an expanding mosaic of additional Altura brand asset variations across different formats and languages: a large billboard-format \'ALTURA\' wordmark on a sky background with Hindi text \'???????????????? ?????? ???????? ???\'; a Spanish-language Instagram post reading \'De la visi\xf3n a la aceleraci\xf3n\' with the same Altura woman image; a pink-gradient LinkedIn ad \'Powering Tomorrow, Today.\' with two professionals; a white ad reading \'Where Digital Meets Reality.\'; and additional rows continuing below the visible area. A black rounded \'Launch\' button with a rocket-ship sparkle icon appears in the lower-right quadrant of the canvas. A blue cursor arrow and a circular female avatar are visible near the Launch button. In the final frame a Swedish-language card is also visible reading \'Fr\xe5n vision till acceleration\'. The overall visual style is clean, professional B2B marketing platform UI.","keyElements":["White background","Three audience column header labels: Engaged Customers / Audience A, Re-engaged Lapsed / Audience B, High Intent / Audience C","Altura brand ad visual imagery (Black woman in blue blazer, architectural image, two professionals)","Ad card taglines (From Vision to Acceleration, Where Innovation Takes Off, Powering Tomorrow Today, Where Digital Meets Reality)","Multi-language ad variants visible (Hindi, Spanish, Swedish, English)","Pink-red gradient AI agent icon and \'The ad set for your target audiences is ready\' message","Black rounded \'Launch\' button with rocket sparkle icon","Blue cursor arrow and circular female user avatar"],"attributes":["AI ad set generation workflow","multi-audience campaign canvas","B2B marketing platform UI","multilingual campaign variants","Launch button CTA reveal"],"productContext":{"visibleUIIndicators":["AI agent completion message: \'The ad set for your target audiences is ready\' with pink-red gradient badge icon","Three audience segment columns: Engaged Customers (A), Re-engaged Lapsed (B), High Intent (C)","Altura brand social post cards in LinkedIn, Instagram, and display ad formats","Multi-language ad variants: English, Spanish (\'De la visi\xf3n a la aceleraci\xf3n\'), Hindi, Swedish (\'Fr\xe5n vision till acceleration\')","Black rounded \'Launch\' button with rocket-sparkle icon","Blue cursor arrow and female user avatar indicating a user activating the campaign"],"likelySuite":"Likely Adobe GenStudio for Performance Marketing \u2014 the audience segment columns, AI-generated ad set message, multi-format and multilingual ad variants, and Launch button match GenStudio for Performance Marketing\'s campaign creation and activation workflow","adobeMarketingLanguage":{"generativeAI":["AI-generated ad sets for target audience segments","Generate on-brand campaign content for multiple audiences","Commercially safe generative AI for performance marketing","Adobe GenStudio for Performance Marketing"],"contentProduction":["Adapting imagery, text, and layouts for markets, languages, and customer segments at scale","Campaign-ready ad sets across LinkedIn, Instagram, and display formats","Faster campaign production and content localization across markets and channels","On-brand content generation for every audience segment"],"workflowAndProductivity":["From audience segmentation to launched ad set in one workflow","Reduce time-to-market for performance marketing campaigns","AI-driven campaign creation and activation"],"enterpriseAndScale":["Adobe GenStudio for Performance Marketing","Personalization at scale across audience segments","Deliver localized campaigns across markets, channels, and formats","Empower marketers to create on-brand campaign content"]},"suggestedMarketingAngles":["Primary demo clip for Adobe GenStudio for Performance Marketing \u2014 the audience segment columns, AI-ready message, multi-format ad cards, and Launch button are all clearly visible","Use alongside \'adapting imagery, text, and layouts for markets, languages, and customer segments at scale\' messaging \u2014 the English/Spanish/Hindi/Swedish ad variants directly show this","The \'Launch\' button reveal is a strong end-to-end workflow moment \u2014 pair with \'reduce time-to-market\' and \'from ideation to campaign activation in one platform\' messaging","Position the three audience segments (Engaged/Re-engaged/High Intent) as proof of AI-driven audience intelligence feeding directly into creative production","Use for performance marketing, media, and agency audiences who need to demonstrate campaign scale and speed across multiple markets and channels"]}},{"fileName":"AdobeSpecific-Set01-26.mp4","description":"The video is a 3-second, 1920\xd71080 generative AI multi-format content library showcase set on a solid black background. The sequence opens with a dark-state where multiple content cards and media asset thumbnails fade into view from black, gradually becoming visible across the canvas. The visible cards span a wide variety of real and AI-generated advertising formats and content types: a teal-background \'TOP 10 resorts\' travel listicle card; a yellow-background woman wearing large white sunglasses with a \'US MAKEUP\' logo in a cosmetics editorial style; a centered skateboarder on a road releasing pink smoke \u2014 a live-action video thumbnail with a play icon; an extreme close-up of a tiger\'s eyes and stripes; a dark silhouetted treeline landscape at dusk; a yellow background still-life of cosmetics brushes and palettes; a purple \'SecurFinancial \u2014 Banking built for you. Sign up for free\' banner ad; a teal-and-orange \'ZUVIA\' beverage brand card with citrus slices; a neon-pink cheetah illustration on a dark background; a FLY travel brand card with two people against the Sahara desert (\'Discover the magic of the Sahara Desert\'); a close-up couple selfie at sunset; a dark red-lit interior; a road cycling POV shot; a horse silhouette at dusk; a coffee product ad \'fr\u0113scopa \u2014 Coffee so good, you\'ll want to tip yourself. Find a store\' showing a tall iced coffee; a dirt bike motocross rider in orange gear launching off a jump; a healthcare/pharma ad with pills (\'How pre medical\u2026\'); a white sneaker product ad on pink-purple gradient; cherry blossom photography; and a hot air balloon festival at sunset over Cappadocia. The camera slowly drifts and pushes forward through the floating card arrangement. In the final frames the sequence fades and the camera closes in on the FLY desert travel card at center. The overall visual style is dark, cinematic, and content-library-showcase.","keyElements":["Solid black background","Card variety: travel, beauty, finance, beverage, automotive, cycling, wildlife, coffee, healthcare, fashion, outdoor advertising formats","Individual card background colors and visual styles across the mosaic","FLY travel Sahara Desert card (center focus in final frames)","SecurFinancial purple banner ad","ZUVIA teal-and-orange beverage card","fr\u0113scopa coffee product card","Neon-pink cheetah illustration card"],"attributes":["dark content library showcase","multi-industry ad format mosaic","cinematic floating card arrangement","diverse brand and category range","slow drift flythrough motion"],"productContext":{"visibleUIIndicators":["No explicit UI chrome \u2014 pure content showcase","Video play button overlays on certain cards (skateboarder) suggesting mixed video and image content types","Diverse advertising formats: banner, social post, product ad, editorial, listicle, display ad"],"likelySuite":"Likely Adobe Firefly or Adobe Stock / Adobe Express content library showcase \u2014 the diversity of branded ad formats, real photography, and AI-generated imagery suggests a demonstration of Firefly\'s or Stock\'s commercial content generation breadth","adobeMarketingLanguage":{"generativeAI":["Generate campaign-ready visuals across industries and formats","AI-powered content for any brand, any audience, any channel","Turn ideas into high-quality content at scale","Commercially safe generative AI for commercial content creation"],"contentProduction":["Campaign-ready visuals across travel, beauty, finance, food, automotive, and fashion","On-brand content generation at scale","Produce high-impact creative assets for any industry","Scroll-stopping visuals for social media and digital advertising"],"workflowAndProductivity":["Rapidly produce on-brand campaign visuals","Accelerate ideation across industries and content types","From brief to campaign-ready asset"],"enterpriseAndScale":["Scale content production across brands, markets, and channels","Produce personalized content for customer segments","Create with speed, scale, and brand intelligence","Deliver content across every format and touchpoint"]},"suggestedMarketingAngles":["Use as a showcase reel demonstrating Adobe Firefly\'s or Adobe Stock\'s breadth across industries \u2014 travel, beauty, finance, beverage, automotive, wildlife, coffee, fashion, and healthcare all appear","Pair with \'commercially safe generative AI for commercial content creation\' messaging \u2014 the diversity of branded ad formats reinforces real-world applicability across enterprise verticals","The dark floating card arrangement is cinematic and attention-grabbing \u2014 ideal as an opener or B-roll in Adobe MAX, Adobe Summit, or brand awareness video campaigns","Use for agency and enterprise audiences to demonstrate that Adobe\'s content generation tools span every industry, format, and visual style","Position alongside \'create with speed, scale, and brand intelligence\' \u2014 the volume and variety of content shown in 3 seconds makes scale viscerally apparent"]}},{"fileName":"AdobeSpecific-Set01-27.mp4","description":"The video is a 3-second, 1920\xd71080 campaign creation platform UI demonstration set on a clean white background with a soft pink-lavender ambient glow visible at the right edge. The sequence opens on a floating, partially tilted UI panel showing a product menu screen labeled \'Create\' at the top. Below the title, the panel is divided into three sections with heading labels: \'Owned media\' (containing two options: \'Emails \u2014 Compose optimized, on-brand messages using templates\' with a document-and-pen icon, and \'Banners \u2014 Create appealing on-brand content for your audiences\' with a layout icon), \'Paid media\' (containing two options: \'Meta \u2014 Craft brand cohesive Meta ads on-demand, in every size\' with the Meta infinity-loop icon in blue, and \'TikTok \u2014 Create compelling ads that capture your audience\'s attention\' with the TikTok icon), and \'Content\' (containing two options: \'Content Production Agent \u2014 Generate on-brand ad experiences tailored for maximum impact\' with a document icon, and \'On brand images \u2014 Match the style from a reference image and a text prompt to generate variations\' with a sparkle-image icon; two additional items are partially visible at the bottom labeled \'Translate and localize\' and \'Connected TV videos\', both with \'labs\' badges). A left sidebar navigation shows: Campaigns, Content, Create (currently selected with a star-sparkle icon), Activate, Insights, and below a divider: Brands, Personas, Products. A black cursor arrow is visible at the far right. As the video progresses the tilted panel resolves and zooms to show three portrait-format TikTok content preview cards side by side on the white canvas. Each card is a TikTok-style phone mockup with a \'Following | For You\' tab at the top, a content thumbnail, engagement icons (heart, comment, share, music), a username \'@TREQ\', a caption, and below: a card title, \'TikTok | 9:16\', and an overflow menu icon. The three cards show: \'Explore Q1\' (dark blue sky background with a smiling woman in a yellow puffer jacket and caption \'Conquer the cold with the new TREQ Puffer Jacket.\'), \'All things Q1\' (bright yellow background with a 3D puff-letter title \'All things PUFFY\' and caption \'Shop our newest PUFFY collection.\'), and \'Wilderness Q1\' (warm golden-hour light with a golden retriever dog on a lake deck and caption \'Awaken the senses #outdoorlife\'). The overall visual style transitions from a product UI menu to a clean white TikTok content preview layout.","keyElements":["White background with soft pink-lavender ambient right-edge glow","Create menu panel sections: Owned media, Paid media, Content","Meta and TikTok platform icons in Paid media section","Labs badges on Translate and localize, Connected TV videos","Left sidebar navigation icons and labels","Three TikTok phone mockup card content: Explore Q1 (dark blue sky), All things Q1 (bright yellow), Wilderness Q1 (warm golden hour)","TREQ brand captions and @TREQ handle on each card"],"attributes":["campaign creation platform UI","paid media channel selection menu","TikTok ad preview mockups","multi-format content workflow","clean white enterprise UI"],"productContext":{"visibleUIIndicators":["Create menu with Owned media (Emails, Banners), Paid media (Meta, TikTok), and Content (Content Production Agent, On brand images, Translate and localize [labs], Connected TV videos [labs]) sections","Left sidebar: Campaigns, Content, Create (selected), Activate, Insights | Brands, Personas, Products","Three TikTok 9:16 content preview cards with @TREQ brand, captions, and engagement icons","Card titles: \'Explore Q1\', \'All things Q1\', \'Wilderness Q1\' each labeled \'TikTok | 9:16\'"],"likelySuite":"Adobe GenStudio for Performance Marketing \u2014 the Create menu with Owned/Paid/Content sections, Meta and TikTok channel options, Content Production Agent, On brand images, Campaigns/Activate/Insights navigation, and Brands/Personas/Products sidebar are all specific GenStudio for Performance Marketing UI elements","adobeMarketingLanguage":{"generativeAI":["Content Production Agent \u2014 generate on-brand ad experiences for maximum impact","On brand images \u2014 match style from a reference image and text prompt to generate variations","AI-powered campaign content creation for Meta and TikTok","Commercially safe generative AI for performance marketing"],"contentProduction":["Craft brand cohesive Meta ads on-demand, in every size","Create compelling TikTok ads that capture your audience\'s attention","Compose optimized, on-brand messages using templates","Translate and localize content across languages and markets (labs)"],"workflowAndProductivity":["From Create to Activate in one platform","Reduce time-to-market for paid social campaigns","Generate TikTok and Meta ads at the speed of social"],"enterpriseAndScale":["Adobe GenStudio for Performance Marketing","Connected TV video content generation (labs)","Campaigns, Content, Activate, Insights \u2014 full content supply chain in one platform","Empower marketers to create on-brand campaign content across paid channels"]},"suggestedMarketingAngles":["Primary demo clip for Adobe GenStudio for Performance Marketing \u2014 the Create menu listing Emails, Banners, Meta, TikTok, Content Production Agent, and On brand images is a complete product feature showcase","Use alongside TikTok advertising campaign messaging \u2014 the three @TREQ TikTok content preview cards show real ad creative formats and captions that resonate with social-first marketing teams","The \'Translate and localize [labs]\' and \'Connected TV videos [labs]\' items signal upcoming capabilities \u2014 use in product roadmap communications and preview content for Adobe Summit or MAX","Position the Content Production Agent option alongside \'generate on-brand ad experiences tailored for maximum impact\' messaging for enterprise performance marketing teams","Use alongside video 28 as a two-part GenStudio TikTok campaign demo showing the Create workflow and the resulting TikTok ad previews"]}},{"fileName":"AdobeSpecific-Set01-28.mp4","description":"The video is a 3-second, 58-frame, 1920\xd71080 TikTok ad campaign preview demonstration. The sequence opens on a dark maroon-to-deep-purple gradient background \u2014 a vivid, high-contrast background distinct from the white used in other videos. Three portrait-format phone-mockup ad preview cards are arranged floating at center-left, center, and center-right of the frame, tilted at slight angles as if hovering in 3D space. They begin partially opaque and in motion, rotating into stable position as the sequence resolves. Each card displays a TikTok-style interface with a \'Following | For You\' tab at the top and social engagement icons on the right side (heart, comment, share, music note). The three cards show different TREQ puffer jacket campaign ads: the left card (\'Senses Q1\') shows a close-up portrait of a blonde woman with long hair wearing a bright orange puffer jacket and a green paisley/floral scarf, looking up with her mouth slightly open, against an orange-warm background; the center card (\'Urban puffer Q1\') shows a rear view of a white-clad figure wearing a fitted white mini puffer jacket and tall white furry platform boots standing against a neutral background, with caption \'Level up your street style and stay warm with the commuter puffer.\'; and the right card (\'Adventure Q1\') shows a close-up product shot of a shiny metallic light-blue puffer jacket against a snowy mountain environment, with caption \'The perfect jacket for adventure.\' The cards are each labeled \'@TREQ\' with a caption, and below each card a text panel shows the card name, \'TikTok | 9:16\'. Pink-and-purple gradient borders frame each card. The background throughout is the dark maroon-to-purple gradient. The overall visual style is dramatic, dark, and fashion-forward.","keyElements":["Dark maroon-to-deep-purple gradient background","Pink-and-purple gradient borders framing each TikTok card","Left card subject: blonde woman in orange puffer jacket, green floral scarf, warm orange background","Center card subject: rear-view figure in white mini puffer jacket and tall white furry platform boots, neutral background","Right card subject: shiny metallic light-blue puffer jacket product shot, snowy mountain environment","Three card tilt angles and 3D floating arrangement"],"attributes":["dark fashion TikTok ad preview","three-card 3D floating layout","TREQ puffer jacket campaign","dramatic maroon-purple backdrop","mixed lifestyle and product shots"],"productContext":{"visibleUIIndicators":["TikTok-style \'Following | For You\' tab at the top of each card","Social engagement icons (heart, comment, share, music) on the right of each card","@TREQ handle and caption text below the content area","Card title labels: \'Senses Q1\', \'Urban puffer Q1\', \'Adventure Q1\' each with \'TikTok | 9:16\'","Pink-and-purple gradient card borders matching GenStudio\'s audience-colored card border style"],"likelySuite":"Adobe GenStudio for Performance Marketing \u2014 the TikTok 9:16 ad preview cards, @TREQ brand, Q1 campaign naming, and pink-purple border style are consistent with the GenStudio content preview UI seen in video 27","adobeMarketingLanguage":{"generativeAI":["Generate compelling TikTok ads that capture your audience\'s attention","AI-generated campaign creative for paid social","On-brand TikTok content generation at scale","Commercially safe generative AI for performance marketing"],"contentProduction":["Campaign-ready TikTok ad creative across styles: lifestyle, street style, product","On-brand content for paid social at Q1 campaign scale","Produce TikTok ads across multiple creative directions quickly","Scroll-stopping paid social visuals"],"workflowAndProductivity":["Generate and preview TikTok ad variants in GenStudio","From campaign brief to TikTok-ready creative in one workflow","Reduce time-to-launch for paid social campaigns"],"enterpriseAndScale":["Adobe GenStudio for Performance Marketing","Scale TikTok ad production across campaign segments","Deliver on-brand creative across organic and paid social channels","Empower marketing teams to produce compelling ads at the speed of social"]},"suggestedMarketingAngles":["Use as a companion to video 27 \u2014 together they show the full GenStudio TikTok ad creation workflow (Create menu \u2192 TikTok preview cards \u2192 campaign launch)","The three distinct creative directions (lifestyle/Senses, street-style/Urban, product/Adventure) demonstrate how GenStudio generates multiple on-brand creative variants for different audience segments","Position the dark maroon-purple background as a premium, dramatic aesthetic contrast to the white-background planning UI \u2014 use in launch or awareness campaigns for GenStudio","The TREQ puffer jacket recurring across videos 27, 28, 29, 30, and 31 makes this part of a coherent brand use-case story \u2014 use the TREQ series together as a connected campaign demo narrative","Use in fashion, apparel, and lifestyle brand marketing contexts to show how GenStudio enables rapid, visually diverse TikTok ad creative for Q1 campaign launches"]}},{"fileName":"AdobeSpecific-Set01-31.mp4","description":"The video is a 3-second, 1920\xd71080 social media campaign publishing and performance tracking showcase set on a clean white-to-pale-pink-lavender gradient background. The sequence opens on a single centered social post mockup in an Instagram-style card format: the TREQ brand circular avatar and \'TREQ\' handle are shown at the top with a three-dot overflow menu; the post image shows the yellow TREQ puffer jacket female figure standing on a snowy mountain peak at dusk with a pink-orange sky horizon, overlaid with white bold all-caps text \'CONQUER THE COLD.\' and a dark rounded \'SHOP NOW\' pill button; the bottom of the card shows outline heart, comment, share (paper plane), and bookmark interaction icons. As the video progresses the view zooms out and the single card is replaced by an expanding mosaic of multiple TREQ brand social and display ad variations floating at different sizes and positions on the pale-pink-lavender background. The revealed cards include: a small square card with the same TREQ mountain scene; a large TikTok-format portrait card showing the woman in the yellow jacket on a snowy slope with a red heart interaction and \'@TREQ\' account badge; a wide landscape card \'STEP INTO THE WILD\' showing the yellow jacket against a blue sky; a dark teal portrait display banner \'LOOK SHARP. LIVE RUGGED. SHOP NOW\' with a silver-haired male model in yellow puffer jacket; a square Instagram card \'CONQUER THE COLD. SHOP NOW\'; a small square card \'BUILT FOR THE BOLD\'; a white-background email-style text card with caption \'There\'s more winter to explore. Get outside in the TREQ Puffer Hiking Jacket.\' (from \'TREQ\'); an Instagram sponsored ad card \'NO LIMITS. Shop now\' showing a woman in the yellow jacket in a mountain snowstorm; a square card with descriptive product copy text; and additional small cards at the edges. The TREQ brand identity (black circular logo with a mountain-peak-and-arrow mark) is consistent across all cards. The overall visual style transitions from a clean isolated post preview to a multi-format content distribution mosaic.","keyElements":["White-to-pale-pink-lavender gradient background","Central Instagram post card (mountain dusk image, \'CONQUER THE COLD.\' / \'SHOP NOW\')","TikTok portrait card (snowy slope, red heart, @TREQ badge)","Dark teal display banner (silver-haired male model, \'LOOK SHARP. LIVE RUGGED.\')","Instagram sponsored \'NO LIMITS. Shop now\' snowstorm card","Email-style text card caption format","TREQ black circular logo consistency across all cards","Card format variety: square, portrait, landscape, display banner, email"],"attributes":["multi-format social campaign mosaic","Instagram to TikTok format variety","clean pink-lavender brand background","TREQ campaign distribution showcase","single post to full campaign reveal"],"productContext":{"visibleUIIndicators":["Instagram-style post card with TREQ handle, image, \'CONQUER THE COLD.\' overlay text, \'SHOP NOW\' pill CTA, and interaction icons (heart, comment, share, bookmark)","TikTok portrait card with @TREQ badge, heart interaction, and snowstorm imagery","Display banner card \'LOOK SHARP. LIVE RUGGED. SHOP NOW\' with TREQ logo","Sponsored Instagram ad card \'NO LIMITS. Shop now\'","Email-style text card format: \'There\'s more winter to explore\u2026\'","Product description copy text card","TREQ black mountain-peak-and-arrow brand mark consistent across all card types"],"likelySuite":"Likely Adobe GenStudio for Performance Marketing \u2014 the multi-format TREQ campaign cards spanning Instagram posts, TikTok ads, display banners, email formats, and sponsored ads match GenStudio\'s content library and campaign activation workflow shown in videos 25, 27, 28, and 30","adobeMarketingLanguage":{"generativeAI":["Generate on-brand campaign content across channels and formats","AI-generated social, display, and email creative at scale","Campaign-ready visuals for every platform","Commercially safe generative AI for performance marketing"],"contentProduction":["Content supply chain from ideation to multi-channel distribution","On-brand content for Instagram, TikTok, display, and email","Faster campaign production across all owned and paid channels","Produce content variations for every format from one brand asset"],"workflowAndProductivity":["From single post to full multi-channel campaign in one platform","Reduce time-to-market for campaign distribution","Generate and activate content across social, display, and email"],"enterpriseAndScale":["Adobe GenStudio for Performance Marketing","Personalization at scale across channels, formats, and audiences","Deliver content across every touchpoint and distribution channel","Brand-consistent campaign content for global distribution"]},"suggestedMarketingAngles":["Use as the final piece of the TREQ brand campaign narrative across videos 27\u201331 \u2014 this video shows the complete campaign published and distributed across Instagram, TikTok, display, and email formats","The single-post-to-full-campaign-mosaic reveal is a powerful visual metaphor for GenStudio\'s content supply chain \u2014 \'one brief, many formats, all channels, on-brand\' \u2014 pair with content supply chain messaging","Use alongside \'deliver content across every touchpoint and distribution channel\' messaging for enterprise marketing and CMO audiences","The consistent TREQ brand identity across every card format makes this ideal for demonstrating on-brand content generation at scale \u2014 pair with Custom Models and brand consistency messaging","Position as the closer in a multi-video GenStudio demo sequence (videos 25, 27, 28, 30, 31) showing the complete journey from audience segmentation to multi-channel campaign distribution"]}}]}');


$9861ffc361224113$exports = {
    "01-PriorityBatch": $a61eed43935f0831$exports,
    "02-ReadyBatch": $9ba5877a3645b751$exports
};


const $519bb9418a2e00cf$var$allItems = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($9861ffc361224113$exports)))).sort().flatMap((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($9861ffc361224113$exports)))[key]?.items ?? []);
var $519bb9418a2e00cf$export$2e2bcd8739ae039 = {
    items: $519bb9418a2e00cf$var$allItems.map((item)=>({
            ...item,
            fileName: `mogrt/footage/adobe-specific/${item.fileName}`
        }))
};


const $ee75fb16cdfee19c$var$bRollData = [
    ...(0, $80690ea71e31e9a7$export$2e2bcd8739ae039)?.items ?? [],
    ...(0, $519bb9418a2e00cf$export$2e2bcd8739ae039)?.items ?? []
];
const $ee75fb16cdfee19c$export$e1840a17f04a93f3 = {
    all: [
        "videos"
    ],
    scenes: ()=>[
            ...(0, $ikOQe.videoKey).all,
            "scenes"
        ],
    scene: (id)=>[
            ...(0, $ikOQe.videoKey).scenes(),
            id
        ]
};
const $ee75fb16cdfee19c$export$6beda2ca340be073 = (videoData, hint)=>{
    const currentCampaign = videoData?.campaigns?.find((c)=>c.id === videoData.selectedCampaignIds?.[0]) ?? {};
    const brandColor = videoData?.customer?.["Brand-color"];
    const secondaryColor = videoData?.customer?.["Secondary-color"];
    const template = [
        {
            role: "user",
            prompt_template: `[Customer]: ${videoData?.customer?.name}${brandColor ? `
[Brand-colors]: ${[
                brandColor,
                secondaryColor
            ].filter(Boolean).join(", ")}` : ""}`
        },
        ...currentCampaign?.script ? [
            {
                role: "user",
                prompt_template: `[Script]:
${currentCampaign?.script}`
            }
        ] : [],
        ...currentCampaign?.scenes ? [
            {
                role: "user",
                prompt_template: `[Scenes]:
${JSON.stringify(currentCampaign?.scenes ?? [])}`
            }
        ] : []
    ];
    if (hint) template.push({
        role: "user",
        prompt_template: `[Hints]:
${hint}`
    });
    return {
        systemPromptId: "PV-scenes",
        template: template
    };
};
const $ee75fb16cdfee19c$export$5d18dccc07b33b21 = ({ videoId: videoId })=>{
    const isAdmin = (0, $lRNYL.useIsAdmin)();
    const queryClient = (0, $7ClmI.useQueryClient)();
    const updateVideo = (0, $ikOQe.useUpdateVideo)(videoId);
    const mutation = (0, $4SSyx.useZoltarMutation)({
        mutationKey: $ee75fb16cdfee19c$export$e1840a17f04a93f3.scenes(videoId),
        onSuccess: (data, variables, onMutateResult, context)=>{
            const videoData = context.client.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const campaigns = videoData?.campaigns ?? [];
            const currentCampaign = campaigns?.find((c)=>c.id === videoData.selectedCampaignIds?.[0]) ?? {};
            const updatedCampaign = {
                ...currentCampaign,
                scenes: (data?.scenes ?? []).map((scene)=>({
                        ...scene,
                        Color: scene?.Video?.length ? [
                            "#000000"
                        ] : scene?.Color
                    }))
            };
            if (data?.scenesPromptHints) updatedCampaign.scenesPromptHints = data?.scenesPromptHints;
            if (currentCampaign?.scenes?.length) // If the current campaign already has scenes, generate a new ID for the updated campaign for versioning purposes.
            updatedCampaign.id = crypto.randomUUID();
            const selectedCampaignIds = [
                updatedCampaign.id
            ];
            const updatedCampaigns = [
                ...campaigns.filter((c)=>c.id !== updatedCampaign.id),
                updatedCampaign
            ].slice(-10);
            return updateVideo.mutateAsync({
                campaigns: updatedCampaigns,
                selectedCampaignIds: selectedCampaignIds
            });
        },
        onError: (error, variables, onMutateResult, context)=>{
            if (error?.cause?.data?.error) {
                context.meta = context.meta || {};
                context.meta.errorMessage = error?.cause?.data?.error;
            }
        }
    }, (data)=>(0, $aKSBi.parseZoltarGenerateAssistantJson)(data, "Failed to generate content"));
    const regenerate = (hint = "", setPrompt)=>{
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        return mutation.mutateAsync({
            promptTemplate: $ee75fb16cdfee19c$export$6beda2ca340be073(videoData, hint).template,
            systemPromptId: "PV-scenes",
            promptOverrideKey: isAdmin ? `customTemplate__${videoData?.templateId}-scenes` : undefined,
            model: "gpt-5.6-sol",
            skills: [
                "bestory-mongodb-search"
            ]
        }, {
            onSuccess: ()=>{
                if (setPrompt) setPrompt("");
            }
        });
    };
    return {
        mutation: mutation,
        regenerate: regenerate,
        getScenesPromptTemplate: $ee75fb16cdfee19c$export$6beda2ca340be073
    };
};


const $7dcf871e8c209f6e$export$2756c2cc71347984 = ({ scene: scene, index: index, isDisabled: isDisabled })=>{
    const { addToast: addToast } = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state);
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({});
    const { selectedCampaign: selectedCampaign, video: video, editCampaign: editCampaign, handleUploadAssets: handleUploadAssets } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const isVideoEditor = (0, $lRNYL.useHasRole)("video-editor");
    const [...availableColors] = new Set([
        ...video.data?.assets?.filter((a)=>a.type === "color").map((a)=>a.color),
        "#FFFFFF",
        "#000000",
        "#EB1000"
    ].filter(Boolean));
    const handleVideoUpload = async (files)=>{
        if (isDisabled) return;
        const [file] = files;
        if (!file) {
            console.warn("No file selected for upload");
            return;
        }
        if (file.size > 20971520) {
            console.warn("File size exceeds 20MB limit", file.size);
            addToast("File size exceeds 20MB limit", {
                variant: "negative",
                timeout: 60000
            });
            return;
        }
        const { assets: assets = [] } = await handleUploadAssets([
            file
        ]);
        const [asset] = assets;
        if (!asset?.filePath) {
            console.warn("Failed to upload video asset", asset);
            return;
        }
        editCampaign.mutate({
            ...selectedCampaign,
            scenes: selectedCampaign?.scenes?.map((s, idx)=>idx === index - 1 ? {
                    ...s,
                    Video: [
                        asset?.filePath
                    ],
                    Color: [
                        "#000000"
                    ]
                } : s)
        });
    };
    const handleVideoSelect = (footage)=>{
        if (isDisabled) return;
        if (!footage?.fileName) return;
        editCampaign.mutate({
            ...selectedCampaign,
            scenes: selectedCampaign?.scenes?.map((s, idx)=>idx === index - 1 ? {
                    ...s,
                    Video: [
                        footage.fileName
                    ],
                    Color: [
                        "#000000"
                    ]
                } : s)
        });
    };
    const handleColorChange = (color)=>{
        if (isDisabled) return;
        editCampaign.mutate({
            ...selectedCampaign,
            scenes: selectedCampaign?.scenes?.map((s, idx)=>idx === index - 1 ? {
                    ...s,
                    Color: [
                        color.toString("hex")
                    ]
                } : s)
        });
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        ...hoverProps,
        className: " _Nc182 Pc182 sd182 _va182 eb182 _Ca182 Za182 fcJcitc182 gqlRAZb182 ob182 nb182 kb182 jb182 _nLeasBb182 _Wa182 _Pc182 _9b182",
        style: scene?.Color?.[0] ? {
            backgroundColor: scene?.Color?.[0],
            color: `contrast-color(color-mix(in srgb, ${scene?.Color?.[0]}, black 1%))`
        } : {},
        children: [
            !!scene?.Video?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
                filePath: scene?.Video?.[0],
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                className: " Za182 Fb182 _Hb182 _r4WTRRb182 _Pa182 Wr182 _lr182 _Ar182 _zr182 _9a182 _Ob182"
            }),
            !!scene?.Image?.length && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " Za182 Fb182 sd182 eb182 _Ca182 Uj182 qj182",
                children: scene?.Image?.map((imagePath, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                        children: [
                            idx > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0ca39120f8ac8a03$export$2e2bcd8739ae039), {
                                styles: " -_8sjo0b-tf182 Zm182 Fn182"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                filePath: imagePath,
                                styles: function anonymous(props) {
                                    let rules = " ";
                                    rules += ' g9182';
                                    rules += ' Z1YMfn182';
                                    rules += ' Fd182';
                                    rules += ' fNJKOn182';
                                    rules += ' _Ha182';
                                    if (props.isLast) rules += ' __Dc182';
                                    else if (props.isFirst) rules += ' __Df182';
                                    else rules += ' __Db182';
                                    return rules;
                                }({
                                    isFirst: idx === 0,
                                    isLast: idx === scene?.Image?.length - 1
                                })
                            })
                        ]
                    }, idx))
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 p40ub4c182",
                children: scene?.Text
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' Yc182';
                    rules += ' Xb182';
                    rules += ' _2b182';
                    rules += ' _Pa182';
                    rules += ' Wr182';
                    rules += ' _lr182';
                    rules += ' _Ar182';
                    rules += ' _zr182';
                    rules += ' Za182';
                    rules += ' Fb182';
                    if (props.isHovered) rules += ' g7UFYnb182';
                    else rules += ' g9182';
                    return rules;
                }({
                    isHovered: isHovered
                })
            }),
            !isDisabled && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                staticColor: "auto",
                styles: " _Pa182 WJ182 _zt182",
                UNSAFE_className: function anonymous(props) {
                    let rules = " ";
                    rules += ' Yf182';
                    rules += ' Xb182';
                    rules += ' _2b182';
                    if (props.isHovered) rules += ' _Ib182';
                    else rules += ' _Ia182';
                    return rules;
                }({
                    isHovered: isHovered
                }),
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                "aria-label": "Pick background color",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fWQx3.ColorSwatch), {
                                    slot: "icon",
                                    color: scene?.Color?.[0] ?? "#000000",
                                    size: "S"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 _ta182 Ue182 qe182 Tt182 Qt182 St182 Rt182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Pick a background color"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fUh73.ColorSwatchPicker), {
                                            defaultValue: scene?.Color?.[0] ?? "#000000",
                                            rounding: "default",
                                            onChange: handleColorChange,
                                            children: availableColors.map((color)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $fWQx3.ColorSwatch), {
                                                    color: color
                                                }, color))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    isVideoEditor && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                "aria-label": "Change scene footage",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $52a645c64397597a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c66292b379fabf51$export$6b94db7098b5e02d), {
                                defaultSelectedFilePath: scene?.Video?.[0],
                                onSelect: handleVideoSelect
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                        orientation: "vertical",
                        size: "S",
                        styles: " Iv182 Hv182 Js182 Gs182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                        acceptedFileTypes: [
                            "video/mp4"
                        ],
                        onSelect: handleVideoUpload,
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            "aria-label": "Upload video",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $HZG6L.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5mvex.ContextualHelp), {
                        styles: " _dc182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                children: "Upload a video background"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                children: [
                                    "Replaces the current scene's background with your video.",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                    "Only the first 2 seconds will be used."
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Max size:"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: " 20 MB \xb7 "
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Format:"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: " MP4 only"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: function anonymous(props) {
                    let rules = " ";
                    if (props.isHovered) rules += ' _Ixwfurc182';
                    else rules += ' _IStfurc182';
                    rules += ' uk182';
                    rules += ' ucJ9TBTb182';
                    rules += ' ud3Euai182';
                    rules += ' uea182';
                    rules += ' ugb182';
                    rules += ' uhd182';
                    rules += ' uje182';
                    rules += ' u2NhKxcl182';
                    rules += ' uic182';
                    rules += ' -_6BNtrc-e182';
                    rules += ' vx182';
                    rules += ' xb182';
                    rules += ' _xa182';
                    rules += ' _Fd182';
                    rules += ' _FnuYUweb182';
                    if (props.isHovered) rules += ' pBiVkX182';
                    else rules += ' p40ub4c182';
                    rules += ' Yc182';
                    rules += ' Xb182';
                    rules += ' _2b182';
                    rules += ' _Pa182';
                    rules += ' WJ182';
                    rules += ' _At182';
                    return rules;
                }({
                    isHovered: isHovered
                }),
                children: index
            })
        ]
    });
};
const $7dcf871e8c209f6e$export$e88b99a9b9512b56 = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel })=>{
    const { isStepPending: isStepPending, videoId: videoId, templateId: templateId, video: video, updateVideo: updateVideo, selectedCampaign: selectedCampaign, generateScenes: generateScenes, regenerateScenes: regenerateScenes, getScenesPromptTemplate: getScenesPromptTemplate } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    if (!videoId) {
        console.warn("ScenesStep component needs to be used within a VideoWizardContext provider");
        return null;
    }
    const customerLogo = video.data?.assets?.find((a)=>a.name === "Logo")?.filePath;
    const logotypes = [
        "public/adobe-wordmark-red-resize.svg",
        customerLogo
    ].filter(Boolean);
    const [isScriptVisible, setIsScriptVisible] = (0, $eF4cA.useState)(false);
    const isNextDisabled = generateScenes.isPending || !selectedCampaign?.scenes || selectedCampaign?.scenes?.length === 0;
    const isGenerating = generateScenes.isPending;
    const historicalCampaigns = video.data?.campaigns?.filter((c)=>!!c?.scenes?.length);
    const hasHistoricalCampaigns = historicalCampaigns?.length > 1;
    const currentCampaignIndex = historicalCampaigns?.findIndex((c)=>c.id === selectedCampaign?.id);
    const hasPreviousCampaign = currentCampaignIndex > 0;
    const hasNextCampaign = currentCampaignIndex < historicalCampaigns?.length - 1;
    const handleRegenerate = ()=>{
        const updatedCampaigns = [
            ...video.data?.campaigns
        ];
        const id = crypto.randomUUID();
        const updatedCampaign = {
            ...selectedCampaign,
            id: id,
            scenes: []
        };
        updatedCampaigns.push(updatedCampaign);
        updateVideo.mutate({
            campaigns: updatedCampaigns.slice(-10),
            selectedCampaignIds: [
                id
            ]
        }, {
            onSuccess: ()=>regenerateScenes()
        });
    };
    const handleUndo = ()=>{
        const previousCampaignIndex = historicalCampaigns?.findIndex((c)=>c.id === selectedCampaign?.id) - 1;
        if (previousCampaignIndex >= 0) {
            const previousCampaign = historicalCampaigns?.[previousCampaignIndex];
            updateVideo.mutate({
                selectedCampaignIds: [
                    previousCampaign.id
                ]
            });
        }
    };
    const handleRedo = ()=>{
        const nextCampaignIndex = historicalCampaigns?.findIndex((c)=>c.id === selectedCampaign?.id) + 1;
        if (nextCampaignIndex < historicalCampaigns?.length) {
            const nextCampaign = historicalCampaigns?.[nextCampaignIndex];
            updateVideo.mutate({
                selectedCampaignIds: [
                    nextCampaign.id
                ]
            });
        }
    };
    if (isStepPending) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: "Preparing your scenes",
        subtitle: "This may take a few moments, so please keep this tab open.",
        ariaLabel: "Generating campaign details",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e11935d3675e886a$export$2e2bcd8739ae039), {})
    });
    if (!selectedCampaign?.scenes?.length && generateScenes.isError) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
        title: "Failed to load scenes",
        onRetry: ()=>regenerateScenes(),
        children: "There was an error generating your scenes. Please try again."
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Up182 qp182 Za182 Fb182 IM182 HM182 GJ182",
                children: !!selectedCampaign?.scenes?.length && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                            title: "Review generated scenes",
                            subtitle: "You can adjust the details before moving to the next step."
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' Za182';
                                rules += ' Fb182';
                                rules += ' sd182';
                                rules += ' Uj182';
                                rules += ' qj182';
                                rules += ' _ta182';
                                rules += ' ed182';
                                if (props.isGenerating) rules += ' _IqmMfn182';
                                else rules += ' _Ib182';
                                if (props.isGenerating) rules += ' _rKkhbec182';
                                else rules += ' _rd182';
                                rules += ' _8Iz0IC182';
                                if (props.isGenerating) rules += ' _Ob182';
                                else rules += ' _Oa182';
                                return rules;
                            }({
                                isGenerating: isGenerating
                            }),
                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " Za182 se182 DXLwx8b182 _Ca182 Uj182 qj182 ed182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)($7dcf871e8c209f6e$export$2756c2cc71347984, {
                                        scene: {
                                            Color: [
                                                "#ffffff"
                                            ],
                                            Image: logotypes
                                        },
                                        index: "Intro",
                                        isDisabled: true
                                    }),
                                    selectedCampaign?.scenes?.map((scene, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)($7dcf871e8c209f6e$export$2756c2cc71347984, {
                                            scene: scene,
                                            index: idx + 1
                                        }, idx)),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)($7dcf871e8c209f6e$export$2756c2cc71347984, {
                                        scene: {
                                            Color: [
                                                "#ffffff"
                                            ],
                                            Image: logotypes
                                        },
                                        index: "Outro",
                                        isDisabled: true
                                    })
                                ]
                            })
                        }),
                        isScriptVisible && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $74d890f6f2a4f834$export$61f100e67ffb6850), {
                            code: JSON.stringify(selectedCampaign?.scenes ?? [], null, 2)
                        })
                    ]
                })
            }),
            !!selectedCampaign?.scenes?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Footer, {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: (0, $87bd91c06342e699$export$ae81d1082cb406fc),
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c176de8415da9d02$export$76f46df19ff2ecee), {
                        videoId: videoId,
                        placeholder: "Adjust scenes details",
                        completions: selectedCampaign?.scenesPromptHints,
                        getPromptTemplate: getScenesPromptTemplate,
                        templateKey: `customTemplate__${templateId}-scenes`,
                        onSubmit: regenerateScenes,
                        onReset: generateScenes.reset,
                        onRedo: handleRegenerate,
                        isPending: generateScenes.isPending,
                        styles: (0, $87bd91c06342e699$export$f612d38926f99775),
                        actions: hasHistoricalCampaigns && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                            onPress: handleUndo,
                                            isDisabled: updateVideo.isPending || !hasPreviousCampaign,
                                            "aria-label": "Undo",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c8ca68bb4c148d98$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                            children: "Undo last changes"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                            onPress: handleRedo,
                                            isDisabled: updateVideo.isPending || !hasNextCampaign,
                                            "aria-label": "Redo",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cfc385dbd50373df$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                            children: "Revert changes"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueLabel: continueLabel,
                continueVariant: "primary",
                isContinueDisabled: isNextDisabled
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $208Op = parcelRequire("208Op");

var $cnBj9 = parcelRequire("cnBj9");

var $cHCEM = parcelRequire("cHCEM");

var $208Op = parcelRequire("208Op");

var $dm5H1 = parcelRequire("dm5H1");

var $gUjW8 = parcelRequire("gUjW8");

var $fL4LX = parcelRequire("fL4LX");

var $82YSg = parcelRequire("82YSg");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $fDYaM = parcelRequire("fDYaM");

var $fVfXf = parcelRequire("fVfXf");

var $3h1XC = parcelRequire("3h1XC");

var $gI8Gw = parcelRequire("gI8Gw");
function $3ed97031b6108146$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3ed97031b6108146$export$c0de4eca0a8bf011 = (0, $eF4cA.createContext)(null);
const $3ed97031b6108146$var$$fc2cf6b397804b9c$var$inlineAlert = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    rules += ' sg182';
    if (!position) rules += ' _Pc182';
    rules += ' _oa182';
    rules += ' Th182';
    rules += ' Qh182';
    rules += ' Sh182';
    rules += ' Rh182';
    rules += ' oc182';
    rules += ' nc182';
    rules += ' kc182';
    rules += ' jc182';
    rules += ' _jf182';
    rules += ' _kc182';
    rules += ' hc182';
    rules += ' mc182';
    rules += ' lc182';
    if (props.fillStyle === "boldFill") rules += ' iA182';
    else if (props.fillStyle === "subtleFill") rules += ' iA182';
    else if (props.fillStyle === "border") {
        if (props.variant === "neutral") rules += ' iy182';
        else if (props.variant === "negative") rules += ' it182';
        else if (props.variant === "notice") rules += ' is182';
        else if (props.variant === "positive") rules += ' il182';
        else if (props.variant === "informative") rules += ' ix182';
    }
    if (props.variant === "neutral") {
        if (props.fillStyle === "boldFill") rules += ' g6182';
        else if (props.fillStyle === "subtleFill") rules += ' gI182';
        else if (props.fillStyle === "border") rules += ' gX182';
    } else if (props.variant === "negative") {
        if (props.fillStyle === "boldFill") rules += ' gB182';
        else if (props.fillStyle === "subtleFill") rules += ' gU182';
        else if (props.fillStyle === "border") rules += ' gX182';
    } else if (props.variant === "notice") {
        if (props.fillStyle === "boldFill") rules += ' gQ182';
        else if (props.fillStyle === "subtleFill") rules += ' gV182';
        else if (props.fillStyle === "border") rules += ' gX182';
    } else if (props.variant === "positive") {
        if (props.fillStyle === "boldFill") rules += ' g1182';
        else if (props.fillStyle === "subtleFill") rules += ' gA182';
        else if (props.fillStyle === "border") rules += ' gX182';
    } else if (props.variant === "informative") {
        if (props.fillStyle === "boldFill") rules += ' g2182';
        else if (props.fillStyle === "subtleFill") rules += ' gG182';
        else if (props.fillStyle === "border") rules += ' gX182';
    }
    return rules;
};
const $3ed97031b6108146$var$$fc2cf6b397804b9c$var$icon = function anonymous(props) {
    let rules = " ";
    rules += ' __wa182';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' -_8sjo0b-tcwrnr182';
        else rules += ' -_8sjo0b-tw182';
    } else if (props.fillStyle === "subtleFill") {
        if (props.variant === "neutral") rules += ' -_8sjo0b-tf182';
        else if (props.variant === "negative") rules += ' -_8sjo0b-tq182';
        else if (props.variant === "notice") rules += ' -_8sjo0b-tq182';
        else if (props.variant === "positive") rules += ' -_8sjo0b-tt182';
        else if (props.variant === "informative") rules += ' -_8sjo0b-tu182';
    } else if (props.fillStyle === "border") {
        if (props.variant === "neutral") rules += ' -_8sjo0b-tf182';
        else if (props.variant === "negative") rules += ' -_8sjo0b-tq182';
        else if (props.variant === "notice") rules += ' -_8sjo0b-tm182';
        else if (props.variant === "positive") rules += ' -_8sjo0b-tt182';
        else if (props.variant === "informative") rules += ' -_8sjo0b-tu182';
    }
    return rules;
};
let $3ed97031b6108146$var$$fc2cf6b397804b9c$var$ICONS = {
    informative: (0, $gUjW8.default),
    positive: (0, $cHCEM.default),
    notice: (0, $82YSg.default),
    negative: (0, $cnBj9.default),
    neutral: undefined
};
const $3ed97031b6108146$var$$fc2cf6b397804b9c$var$heading = function anonymous(props) {
    let rules = " ";
    rules += ' Jy182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xd182';
    rules += ' _xa182';
    rules += ' xX0cczbc182';
    rules += ' _xX0cczba182';
    rules += ' xfd182';
    rules += ' _xfa182';
    rules += ' xfX0cczbc182';
    rules += ' _xfX0cczba182';
    rules += ' _Fd182';
    rules += ' _FnuYUweb182';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' pg182';
        else rules += ' px182';
    } else rules += ' po182';
    return rules;
};
const $3ed97031b6108146$var$$fc2cf6b397804b9c$var$content = function anonymous(props) {
    let rules = " ";
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fb182';
    rules += ' _FnuYUwec182';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' pg182';
        else rules += ' px182';
    } else rules += ' pt182';
    return rules;
};
const $3ed97031b6108146$export$a3b2c96db9b0eb71 = (0, $eF4cA.forwardRef)(function InlineAlert(props, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($3ed97031b6108146$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $3ed97031b6108146$export$c0de4eca0a8bf011);
    let { children: children, variant: variant = 'neutral', fillStyle: fillStyle = 'border', autoFocus: autoFocus } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let Icon = null;
    let iconAlt = '';
    if (variant in $3ed97031b6108146$var$$fc2cf6b397804b9c$var$ICONS) {
        Icon = $3ed97031b6108146$var$$fc2cf6b397804b9c$var$ICONS[variant];
        if (Icon) iconAlt = stringFormatter.format(`inlinealert.${variant}`);
    }
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3h1XC.useFocusRing)({
        autoFocus: props.autoFocus
    });
    let autoFocusRef = (0, $eF4cA.useRef)(props.autoFocus);
    (0, $eF4cA.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) domRef.current.focus();
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return (0, $dx4lB.jsx)("div", {
        ...(0, $fVfXf.filterDOMProps)(props),
        ...focusProps,
        ref: domRef,
        tabIndex: autoFocus ? -1 : undefined,
        autoFocus: autoFocus,
        role: "alert",
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + $3ed97031b6108146$var$$fc2cf6b397804b9c$var$inlineAlert({
            variant: variant,
            fillStyle: fillStyle,
            isFocusVisible: isFocusVisible
        }, props.styles),
        children: (0, $dx4lB.jsxs)((0, $fDYaM.Provider), {
            values: [
                [
                    (0, $208Op.HeadingContext),
                    {
                        styles: $3ed97031b6108146$var$$fc2cf6b397804b9c$var$heading({
                            fillStyle: fillStyle
                        })
                    }
                ],
                [
                    (0, $208Op.ContentContext),
                    {
                        styles: $3ed97031b6108146$var$$fc2cf6b397804b9c$var$content({
                            fillStyle: fillStyle
                        })
                    }
                ],
                [
                    (0, $dm5H1.IconContext),
                    {
                        styles: $3ed97031b6108146$var$$fc2cf6b397804b9c$var$icon({
                            variant: variant,
                            fillStyle: fillStyle
                        })
                    }
                ]
            ],
            children: [
                Icon && (0, $dx4lB.jsx)(Icon, {
                    "aria-label": iconAlt
                }),
                children
            ]
        })
    });
});



var $77tch = parcelRequire("77tch");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");

var $4W5AG = parcelRequire("4W5AG");

var $j7E4C = parcelRequire("j7E4C");

var $lRNYL = parcelRequire("lRNYL");
const $2986841c3e3fe42c$export$7e239165428524d9 = /*#__PURE__*/ (0, $eF4cA.createContext)(null);
const $2986841c3e3fe42c$export$2e8c8acb7c299935 = ({ children: children })=>{
    // State (not a ref) so items re-render once the container mounts, e.g. after
    // dev mode is toggled on at runtime.
    const [container, setContainer] = (0, $eF4cA.useState)(null);
    const [counter, setCounter] = (0, $eF4cA.useState)(0);
    const register = ()=>{
        setCounter((prev)=>prev + 1);
    };
    const unregister = ()=>{
        setCounter((prev)=>Math.max(prev - 1, 0));
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)($2986841c3e3fe42c$export$7e239165428524d9.Provider, {
        value: {
            container: container,
            setContainer: setContainer,
            counter: counter,
            register: register,
            unregister: unregister
        },
        children: [
            children,
            /*#__PURE__*/ (0, $dx4lB.jsx)($2986841c3e3fe42c$export$8555dee96f998e9c, {})
        ]
    });
};
const $2986841c3e3fe42c$export$8555dee96f998e9c = ()=>{
    const context = (0, $eF4cA.useContext)($2986841c3e3fe42c$export$7e239165428524d9);
    const { setContainer: setContainer, counter: counter } = context;
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    if (!isDevMode) return null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        ref: setContainer,
        className: "__NotEmpty _IqmMfn182 zqggLs182 yqggLs182 BqggLs182 AqggLs182 Tp182 Qp182 Sp182 Rp182 _nLeasBb182 gf182 ob182 nb182 kb182 jb182 _dd182 IM182 _Pe182 WywElld182 _Ru182 _9G1Ky182 sd182 Ub182 qb182 eb182",
        children: counter > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j7E4C.default), {
            styles: " _JzZKy182 Is182 Ha182 _IStfurc182 Zu182 Ft182"
        })
    });
};
const $2986841c3e3fe42c$export$b8e94d7b6b59071b = (props)=>{
    const context = (0, $eF4cA.useContext)($2986841c3e3fe42c$export$7e239165428524d9);
    (0, $eF4cA.useEffect)(()=>{
        context?.register();
        return ()=>{
            context?.unregister();
        };
    }, [
        context
    ]);
    const isDevMode = (0, $lRNYL.useIsDevMode)();
    if (!context) throw new Error("DevToolbar must be used within a DevToolbarProvider");
    if (!isDevMode) return null;
    const { container: container } = context;
    if (!container) return null;
    return /*#__PURE__*/ (0, $l19Vn.createPortal)(/*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
        size: "S",
        isQuiet: true,
        staticColor: "auto",
        ...props
    }), container);
};



var $lb17q = parcelRequire("lb17q");



const $763589ebaaddc8ec$export$92e3969fbe070167 = ()=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const { currentStep: currentStep, templates: templates, template: template, selectedTemplateKey: selectedTemplateKey, handleTemplateSelectionChange: handleTemplateSelectionChange, handleTemplateContinue: handleTemplateContinue, handleNextStep: handleNextStep, sfType: sfType, setSfType: setSfType, drNumbers: drNumbers, drNumbersFilter: drNumbersFilter, setDrNumbersFilter: setDrNumbersFilter, drNumber: drNumber, handleDrNumbersSelectionChange: handleDrNumbersSelectionChange, accountName: accountName, setAccountName: setAccountName } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: "Select a template",
                        subtitle: "Select the template that best fits your message.",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 eb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 JC182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "or try out the new "
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    onPress: ()=>navigate("/projects/composer"),
                                    size: "M",
                                    staticColor: "auto",
                                    styles: " Iv182 Hs182",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                        styles: " HZ0Cnle182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Video Composer"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                size: "XS",
                                                variant: "yellow",
                                                styles: " Iv182",
                                                UNSAFE_className: " _5a182 oa182 na182 ka182 ja182",
                                                UNSAFE_style: {
                                                    paddingInlineStart: "calc(0.375rem * var(--s2-scale))",
                                                    paddingInlineEnd: "calc(0.375rem * var(--s2-scale))",
                                                    display: "inline-flex"
                                                },
                                                children: "Alpha"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $959bbd0e20257a0c$export$b768bbdb9877477), {
                        templates: templates,
                        selectedTemplateKey: selectedTemplateKey,
                        onSelectionChange: handleTemplateSelectionChange,
                        isDisabled: currentStep !== (0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $651056028f5b77ca$export$93a2459aafaa6512), {
                isOpen: currentStep === (0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS,
                sfType: sfType,
                onSfTypeChange: setSfType,
                accountName: accountName,
                onAccountNameChange: setAccountName,
                drNumbers: drNumbers,
                drNumbersFilter: drNumbersFilter,
                onDrNumbersFilterChange: setDrNumbersFilter,
                drNumber: drNumber,
                onDrNumbersSelectionChange: handleDrNumbersSelectionChange,
                onCancel: ()=>handleNextStep((0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE),
                onContinue: ()=>handleNextStep((0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS)
            }),
            currentStep === (0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: !!template.data?.disclaimer && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " ztX8Crc182 ytX8Crc182 BtX8Crc182 AtX8Crc182 __Ac182 _Pe182 _lH182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3ed97031b6108146$export$a3b2c96db9b0eb71), {
                        variant: "neutral",
                        styles: " Zb4QY4182 JA182 GA182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                children: template.data.disclaimer.heading
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                children: template.data.disclaimer.content
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: templates.isFetching,
                onPress: ()=>templates.refetch(),
                children: "Refetch template"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $geNzB = parcelRequire("geNzB");
var $208Op = parcelRequire("208Op");

var $77tch = parcelRequire("77tch");


var $lb17q = parcelRequire("lb17q");




const $24640b06381f3f5f$export$251da4712be96c6a = ()=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const { currentStep: currentStep, templates: templates, template: template, assetsTemplate: assetsTemplate, selectedTemplateKey: selectedTemplateKey, handleTemplateSelectionChange: handleTemplateSelectionChange, handleTemplateContinue: handleTemplateContinue, handleNextStep: handleNextStep, handleLink: handleLink, colorScheme: colorScheme, sfType: sfType, setSfType: setSfType, drNumbers: drNumbers, drNumbersFilter: drNumbersFilter, setDrNumbersFilter: setDrNumbersFilter, drNumber: drNumber, handleDrNumbersSelectionChange: handleDrNumbersSelectionChange, accountName: accountName, setAccountName: setAccountName } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Try out the new Video Composer"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                    size: "XS",
                                    variant: "yellow",
                                    styles: " Iv182",
                                    UNSAFE_className: " _5g182 oa182 na182 ka182 ja182",
                                    UNSAFE_style: {
                                        paddingInlineStart: "calc(0.375rem * var(--s2-scale))",
                                        paddingInlineEnd: "calc(0.375rem * var(--s2-scale))",
                                        display: "inline-flex"
                                    },
                                    children: "Alpha"
                                })
                            ]
                        }),
                        subtitle: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Brand new script, unique video. Made for your Customer."
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "It's experimental \u2014 try it, break it, shape what's next."
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                            isQuiet: true,
                            staticColor: "auto",
                            styles: " JG182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    onPress: ()=>window.open("https://f.io/0NSot_uj", "_blank"),
                                    children: "Watch demo video"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    onPress: ()=>window.open("https://f.io/TxN9A3Q4", "_blank"),
                                    children: "See output examples"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    onPress: ()=>window.open("slack://channel?team=E23RE8G4F&id=C095CSV0N0Z", "_blank"),
                                    children: "Share your thoughts"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $959bbd0e20257a0c$export$b768bbdb9877477), {
                        templates: templates,
                        selectedTemplateKey: selectedTemplateKey,
                        onSelectionChange: handleTemplateSelectionChange,
                        isDisabled: currentStep !== (0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE,
                        placeholder: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c82acbccad2c75af$export$595d810d6c5fe5a4), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $651056028f5b77ca$export$93a2459aafaa6512), {
                isOpen: currentStep === (0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS,
                sfType: sfType,
                onSfTypeChange: setSfType,
                accountName: accountName,
                onAccountNameChange: setAccountName,
                drNumbers: drNumbers,
                drNumbersFilter: drNumbersFilter,
                onDrNumbersFilterChange: setDrNumbersFilter,
                drNumber: drNumber,
                onDrNumbersSelectionChange: handleDrNumbersSelectionChange,
                onCancel: ()=>handleNextStep((0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE),
                onContinue: ()=>handleNextStep((0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS)
            }),
            currentStep === (0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: !!template.data?.disclaimer && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: " ztX8Crc182 ytX8Crc182 BtX8Crc182 AtX8Crc182 __Ac182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3ed97031b6108146$export$a3b2c96db9b0eb71), {
                        variant: "neutral",
                        styles: " Zb4QY4182 JA182 GA182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                children: template.data.disclaimer.heading
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                children: template.data.disclaimer.content
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: templates.isFetching,
                onPress: ()=>templates.refetch(),
                children: "Refetch template"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $j3pTw = parcelRequire("j3pTw");
var $208Op = parcelRequire("208Op");
var $3YPmU = parcelRequire("3YPmU");
var $j8RRT = parcelRequire("j8RRT");

var $77tch = parcelRequire("77tch");

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $68b9d6b3f9506984$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M8.125 1H3.741c-.483 0-.875.392-.875.875s.392.875.875.875h2.27l-4.88 4.88c-.341.343-.341.897 0 1.24.17.17.395.255.619.255s.448-.085.62-.256l4.88-4.88v2.27c0 .483.392.875.875.875S9 6.742 9 6.259V1.875C9 1.392 8.608 1 8.125 1"
        })
    });
const $68b9d6b3f9506984$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($68b9d6b3f9506984$var$SvgComponent);
var $68b9d6b3f9506984$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($68b9d6b3f9506984$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $4W5AG = parcelRequire("4W5AG");
var $f16Ml = parcelRequire("f16Ml");
var $208Op = parcelRequire("208Op");
var $3YPmU = parcelRequire("3YPmU");
var $8wD3p = parcelRequire("8wD3p");

var $iW1HQ = parcelRequire("iW1HQ");

const $553e4be01a219c58$export$e9ffbadc89ce6767 = ({ personas: personas, selectedPersona: selectedPersona, setSelectedPersona: setSelectedPersona, previewUrl: previewUrl })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " Z46M4le182 La182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: "Persona preset"
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("p", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 Jy182 GA182",
                children: [
                    "Pick one persona to shape your story's voice and perspective.",
                    /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                    "The photo is predefined for now."
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ue182 qe182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                        src: selectedPersona?.avatarUrl,
                        alt: "Persona photo",
                        size: 64,
                        isOverBackground: true
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                        direction: "bottom end",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                "aria-label": "Select persona type",
                                isQuiet: true,
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " zYoLErc182 yYoLErc182 BYoLErc182 AYoLErc182 sd182 Ug182 qg182 eb182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                            children: selectedPersona?.type
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iW1HQ.default), {
                                            slot: null
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                                items: personas,
                                selectionMode: "single",
                                selectedKeys: [
                                    selectedPersona?.id
                                ],
                                onSelectionChange: ([key])=>setSelectedPersona(key),
                                "aria-label": "Persona types preset",
                                children: (persona)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                        id: persona.id,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f16Ml.Avatar), {
                                                slot: "avatar",
                                                src: persona.avatarUrl,
                                                // size={32}
                                                alt: `${persona.type} photo`
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                slot: "label",
                                                children: persona.type
                                            })
                                        ]
                                    })
                            })
                        ]
                    })
                ]
            }),
            !!previewUrl && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 ec182 _Cg182 Ue182 qe182 Jv182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        slot: "description",
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                        children: "See how each persona looks"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3YPmU.Link), {
                        href: previewUrl,
                        target: "_blank",
                        isStandalone: true,
                        staticColor: "auto",
                        slot: "contextualHelp",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                slot: "description",
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                children: "Preview"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $68b9d6b3f9506984$export$2e2bcd8739ae039), {
                                styles: " Zh182 Fi182 Iv182"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");

var $208Op = parcelRequire("208Op");
var $3YPmU = parcelRequire("3YPmU");


var $ikOQe = parcelRequire("ikOQe");
const $09be9fc430d68a67$export$9ebdd3f6bc253ef2 = ({ templateId: templateId, verticals: verticals, selectedVertical: selectedVertical, setSelectedVertical: setSelectedVertical })=>{
    const template = (0, $ikOQe.useVideoTemplate)(templateId);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " Z46M4le182 La182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    children: "Vertical preset"
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 Jy182 GA182",
                children: "Pick one vertical to shape your story's perspective."
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                label: "Select vertical",
                description: !!template?.data?.verticalsPreviewUrl && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "description",
                            children: "See how each vertical looks"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3YPmU.Link), {
                            href: template.data.verticalsPreviewUrl,
                            target: "_blank",
                            isStandalone: true,
                            staticColor: "auto",
                            slot: "contextualHelp",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    slot: "description",
                                    children: "Preview"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $68b9d6b3f9506984$export$2e2bcd8739ae039), {
                                    styles: " Zh182 Fi182 Iv182"
                                })
                            ]
                        })
                    ]
                }),
                items: verticals,
                selectionMode: "single",
                value: selectedVertical?.key,
                onChange: setSelectedVertical,
                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                        id: item.key,
                        textValue: item.name,
                        isDisabled: item.isDisabled,
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            slot: "label",
                            children: item.name
                        })
                    })
            })
        ]
    });
};



const $abeab2336c434f94$export$99783913685e6ea4 = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel })=>{
    const { template: template, templateId: templateId, customerName: customerName, setCustomerName: setCustomerName, product: product, setProduct: setProduct, hint: hint, setHint: setHint, include3DDigitalTwin: include3DDigitalTwin, setInclude3DDigitalTwin: setInclude3DDigitalTwin, updateVideo: updateVideo, isCustomerDetailsDisabled: isCustomerDetailsDisabled, verticals: verticals, selectedVertical: selectedVertical, setSelectedVertical: setSelectedVertical, personas: personas, selectedPersona: selectedPersona, setSelectedPersona: setSelectedPersona } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: "Who is this story for?",
                        subtitle: `We\u{2019}ll generate brand-specific content for your ${template.data?.name ?? ""} story`
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _Ca182 ed182 Uu182 qu182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " se182 DX5wAvd182 _Ca182 eb182 Uu182 qu182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                    onSubmit: ()=>!isCustomerDetailsDisabled && onContinue?.(),
                                    UNSAFE_style: {
                                        rowGap: "calc(2rem * var(--s2-scale))"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                                                    children: "Brand name"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                    "aria-label": "Brand name",
                                                    placeholder: "e.g. Nike, Chase",
                                                    description: "Enter the name of an existing brand",
                                                    isRequired: true,
                                                    value: customerName,
                                                    onChange: setCustomerName
                                                })
                                            ]
                                        }),
                                        templateId === "one-adobe" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                                                    children: "Featured product or service (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                    "aria-label": "Featured product or service",
                                                    placeholder: "e.g. Nike Air Max, Chase Ultimate Rewards",
                                                    description: "Leave blank, and we'll suggest one",
                                                    necessityIndicator: "label",
                                                    value: product,
                                                    onChange: setProduct
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                                                    children: "Story direction hints (optional)"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                                    "aria-label": "Story direction hints",
                                                    placeholder: "e.g. Target Gen Z in the US, focus on holiday shopping, position the offering as a premium choice",
                                                    description: "Add any preferences for the campaign featured in the story, such as target audience, campaign topic, or product positioning.",
                                                    necessityIndicator: "label",
                                                    value: hint,
                                                    onChange: setHint
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            !!template.data?.verticals?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $09be9fc430d68a67$export$9ebdd3f6bc253ef2), {
                                templateId: templateId,
                                verticals: verticals,
                                selectedVertical: selectedVertical,
                                setSelectedVertical: setSelectedVertical
                            }),
                            !!template.data?.personas?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $553e4be01a219c58$export$e9ffbadc89ce6767), {
                                personas: personas,
                                selectedPersona: selectedPersona,
                                setSelectedPersona: setSelectedPersona,
                                previewUrl: template?.data?.personaPreviewUrl
                            }),
                            templateId === "firefly-enterprise" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " Z46M4le182 La182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gv182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "3D digital twin"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 Jy182 GA182",
                                        children: "Adds a 3D model preview of your product inside the animation. Turn off if your campaign isn't built around a physical product."
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                        label: "Include 3D digital twin",
                                        value: include3DDigitalTwin ? "yes" : "no",
                                        onChange: (value)=>setInclude3DDigitalTwin(value === "yes"),
                                        isDisabled: updateVideo.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                id: "yes",
                                                children: "Yes"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                id: "no",
                                                children: "No"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " sd182 _tc182 Ue182 qe182 Jx182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                        children: !!template.data?.include3DigitalTwinScenePreviewUrl && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "See what the 3D digital twin scene looks like "
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3YPmU.Link), {
                                                    href: template.data.include3DigitalTwinScenePreviewUrl,
                                                    target: "_blank",
                                                    isStandalone: true,
                                                    staticColor: "auto",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            children: "Preview"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $68b9d6b3f9506984$export$2e2bcd8739ae039), {
                                                            styles: " Zh182 Fi182 Iv182"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueLabel: continueLabel,
                isContinueDisabled: isCustomerDetailsDisabled
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");
var $aQTiM = parcelRequire("aQTiM");
var $c0XRK = parcelRequire("c0XRK");
var $yuTTo = parcelRequire("yuTTo");
var $3YPmU = parcelRequire("3YPmU");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $f60261a86d0e572f$var$$225180fb309f9684$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25m-1.5 0c0-.414-.336-.75-.75-.75H4.25c-.414 0-.75.336-.75.75v11.5c0 .414.336.75.75.75h11.5c.414 0 .75-.336.75-.75z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.763 10c0 .421-.342.763-.763.763h-2.237V13c0 .421-.342.763-.763.763s-.763-.342-.763-.763v-2.237H7c-.421 0-.763-.342-.763-.763s.342-.763.763-.763h2.237V7c0-.421.342-.763.763-.763s.763.342.763.763v2.237H13c.421 0 .763.342.763.763"
            })
        ]
    });
const $f60261a86d0e572f$var$$225180fb309f9684$var$ForwardRef = (0, $eF4cA.forwardRef)($f60261a86d0e572f$var$$225180fb309f9684$var$SvgComponent);
var $f60261a86d0e572f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($f60261a86d0e572f$var$$225180fb309f9684$var$ForwardRef);



var $15xG7 = parcelRequire("15xG7");

var $edFAP = parcelRequire("edFAP");

var $8Ogg5 = parcelRequire("8Ogg5");
parcelRequire("CGZx1");
var $lb17q = parcelRequire("lb17q");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $fZShI = parcelRequire("fZShI");
var $hSW0F = parcelRequire("hSW0F");

var $cHCEM = parcelRequire("cHCEM");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $b4e22b9c015b1044$var$$d5695c48c90e8c45$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m11.06 10 2.22-2.22c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0L10 8.94 7.78 6.72c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06L8.94 10l-2.22 2.22c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.06l2.22 2.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06z"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            })
        ]
    });
const $b4e22b9c015b1044$var$$d5695c48c90e8c45$var$ForwardRef = (0, $eF4cA.forwardRef)($b4e22b9c015b1044$var$$d5695c48c90e8c45$var$SvgComponent);
var $b4e22b9c015b1044$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($b4e22b9c015b1044$var$$d5695c48c90e8c45$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $cadaa07e9663cf9c$var$$1ae2b0951c2a9ab2$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.25 10.75h-6.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const $cadaa07e9663cf9c$var$$1ae2b0951c2a9ab2$var$ForwardRef = (0, $eF4cA.forwardRef)($cadaa07e9663cf9c$var$$1ae2b0951c2a9ab2$var$SvgComponent);
var $cadaa07e9663cf9c$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($cadaa07e9663cf9c$var$$1ae2b0951c2a9ab2$var$ForwardRef);



var $gUjW8 = parcelRequire("gUjW8");

var $4kcQz = parcelRequire("4kcQz");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $a7a2ae9275d04562$export$6d42fa1bc1da6c84 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/linkChecker"]);
const $a7a2ae9275d04562$export$5c0c748bb06567ad = async (url, options = {})=>{
    const response = await $a7a2ae9275d04562$export$6d42fa1bc1da6c84.post("", {
        url: url
    }, options);
    if (!response.ok) throw new Error("Failed to check link", {
        cause: response
    });
    return response.data;
};


const $a08d45745fe59208$export$a8cdb0ec9f4ed9e6 = (url, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: [
            "linkChecker",
            url
        ],
        queryFn: async ({ signal: signal })=>(0, $a7a2ae9275d04562$export$5c0c748bb06567ad)(url, {
                signal: signal
            }),
        throwOnError: false,
        // subscribed: false,
        onError: (error)=>{
            console.info("LinkChecker error:", error);
        },
        retry: 0,
        enabled: !!url,
        staleTime: 3600000,
        ...options
    });
};


const $be8e285b7bcfa47d$export$7d71619cfe2aecc1 = ({ url: url })=>{
    const deferredUrl = (0, $eF4cA.useDeferredValue)(url);
    const linkChecker = (0, $a08d45745fe59208$export$a8cdb0ec9f4ed9e6)(deferredUrl);
    if (!url) return null;
    if (linkChecker.isPending) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
        isIndeterminate: true,
        size: "S",
        staticColor: "auto",
        "aria-label": "Checking link...",
        UNSAFE_className: " sh182 _5c182 Hs182"
    });
    let icon;
    if (linkChecker.isError || linkChecker.data?.status === 403 || linkChecker.data?.error?.toLowerCase?.().startsWith?.("timeout")) icon = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cadaa07e9663cf9c$export$2e2bcd8739ae039), {
        styles: " -_8sjo0b-tm182 Zk182 Fl182",
        UNSAFE_className: " _5c182 Hs182",
        "aria-label": "Link status is unknown"
    });
    else if (linkChecker.data?.isRedirect) icon = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $gUjW8.default), {
        styles: " -_8sjo0b-tm182 Zk182 Fl182",
        UNSAFE_className: " _5c182 Hs182",
        "aria-label": "Link status is unknown"
    });
    else if (linkChecker.data?.exists && linkChecker.data?.status === 200) icon = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cHCEM.default), {
        styles: " -_8sjo0b-tt182 Zk182 Fl182",
        UNSAFE_className: " _5c182 Hs182",
        "aria-label": "Link is valid"
    });
    else if (!linkChecker.data?.exists || linkChecker.data?.status >= 400) icon = /*#__PURE__*/ (0, $dx4lB.jsx)((0, $b4e22b9c015b1044$export$2e2bcd8739ae039), {
        styles: " -_8sjo0b-tq182 Zk182 Fl182",
        UNSAFE_className: " _5c182 Hs182",
        "aria-label": "Link is invalid"
    });
    else return null;
    let tooltip;
    if (linkChecker.data?.isRedirect) tooltip = `Link redirects to ${linkChecker.data.redirectLocation}`;
    else if (linkChecker.data?.status === 403 || linkChecker.data?.error?.toLowerCase?.().startsWith?.("timeout")) tooltip = "Link status is unknown";
    else if (linkChecker.data?.exists && linkChecker.data?.status === 200) tooltip = "Link is valid";
    else if (!linkChecker.data?.exists || linkChecker.data?.status >= 400) tooltip = "Link is invalid";
    else if (linkChecker.isError) tooltip = "Link status is unknown";
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                isQuiet: true,
                size: "XS",
                "aria-label": tooltip,
                UNSAFE_className: " sh182",
                children: icon
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                children: tooltip
            })
        ]
    });
};
$be8e285b7bcfa47d$export$7d71619cfe2aecc1.propTypes = {
    url: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired
};




var $77tch = parcelRequire("77tch");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $7uz0i = parcelRequire("7uz0i");
var $j3pTw = parcelRequire("j3pTw");
var $j8RRT = parcelRequire("j8RRT");
const $8696adb541f50b0b$export$39bfae2e77a2708f = ({ defaultCampaign: defaultCampaign, onClose: onClose, onSuccess: onSuccess })=>{
    const [title, setTitle] = (0, $eF4cA.useState)(defaultCampaign?.title || "");
    const [description, setDescription] = (0, $eF4cA.useState)(defaultCampaign?.description || "");
    const [tagline, setTagline] = (0, $eF4cA.useState)(defaultCampaign?.tagline || "");
    const [landingPageUrl, setLandingPageUrl] = (0, $eF4cA.useState)(defaultCampaign?.landingPageURL || "");
    const isSubmitDisabled = !title.trim() || !tagline.trim();
    (0, $eF4cA.useEffect)(()=>{
        setTitle(defaultCampaign?.title || "");
        setDescription(defaultCampaign?.description || "");
        setTagline(defaultCampaign?.tagline || "");
        setLandingPageUrl(defaultCampaign?.landingPageURL || "");
    }, [
        defaultCampaign
    ]);
    const handleSubmit = (0, $eF4cA.useCallback)((close)=>{
        onSuccess?.({
            ...defaultCampaign ?? {},
            title: title,
            description: description,
            tagline: tagline,
            landingPageURL: landingPageUrl
        });
        setTitle("");
        setDescription("");
        setTagline("");
        setLandingPageUrl("");
        close();
    }, [
        onSuccess,
        title,
        description,
        tagline,
        landingPageUrl
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7uz0i.Dialog), {
        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        slot: "title",
                        children: defaultCampaign?.id ? "Edit campaign" : "Add new campaign"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                    label: "Title",
                                    value: title,
                                    isRequired: true,
                                    onChange: setTitle
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                    label: "Description",
                                    value: description,
                                    onChange: setDescription
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                    label: "Tagline",
                                    value: tagline,
                                    onChange: setTagline,
                                    isRequired: true
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                    label: "Landing Page URL",
                                    value: landingPageUrl,
                                    onChange: setLandingPageUrl
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        styles: " JG182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "secondary",
                                onPress: ()=>onClose ? onClose?.(close) : close(),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                type: "submit",
                                isDisabled: isSubmitDisabled,
                                onPress: ()=>handleSubmit(close),
                                children: !!defaultCampaign ? "Edit" : "Add"
                            })
                        ]
                    })
                ]
            })
    });
};
$8696adb541f50b0b$export$39bfae2e77a2708f.propTypes = {
    defaultCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        tagline: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        landingPageURL: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
    }),
    onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};



var $m1itB = parcelRequire("m1itB");

var $lHGo8 = parcelRequire("lHGo8");

var $eF4cA = parcelRequire("eF4cA");

var $7ClmI = parcelRequire("7ClmI");

var $ikOQe = parcelRequire("ikOQe");

var $77tch = parcelRequire("77tch");
const $d97b7fdd6e65a0cf$export$4fd07134d60a1d69 = (videoData, defaultTemplate)=>{
    const currentCampaign = videoData?.campaigns?.[videoData.campaigns.length - 1];
    if (currentCampaign && Object.keys(currentCampaign).length > 0) return defaultTemplate.toSpliced(0, 0, {
        role: "user",
        prompt_template: `Current data:
${JSON.stringify(currentCampaign)}`
    });
    return defaultTemplate;
};
const $d97b7fdd6e65a0cf$var$getSelectedCampaign = (videoData)=>videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0]);
const $d97b7fdd6e65a0cf$export$53b64dcdb9d79359 = ({ withScriptHistory: withScriptHistory = false, editScope: editScope, onEdited: onEdited } = {})=>{
    const { video: video, selectedCampaign: selectedCampaign, updateVideo: updateVideo, customerBranding: customerBranding } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const queryClient = (0, $7ClmI.useQueryClient)();
    const historicalCampaigns = withScriptHistory ? video.data?.campaigns?.filter((c)=>!!c?.script).filter((c, idx, arr)=>idx === arr.length - 1 || c.script !== arr[idx + 1].script) : video.data?.campaigns;
    const hasHistoricalCampaigns = historicalCampaigns?.length > 1;
    const currentCampaignIndex = historicalCampaigns?.findIndex((c)=>c.id === selectedCampaign?.id);
    const hasPreviousCampaign = currentCampaignIndex > 0;
    const hasNextCampaign = currentCampaignIndex < historicalCampaigns?.length - 1;
    // Reports the selected campaign before and after an edit, read from the
    // cache once the edited campaign has been persisted and selected.
    const notifyEdited = (previousCampaign)=>{
        const nextCampaign = $d97b7fdd6e65a0cf$var$getSelectedCampaign(queryClient.getQueryData((0, $ikOQe.videoKey).detail(video.data?.id)));
        if (previousCampaign && nextCampaign) onEdited?.(previousCampaign, nextCampaign);
    };
    const handleSubmit = (prompt, setPrompt, videoData)=>{
        const data = videoData ?? video.data;
        const previousCampaign = $d97b7fdd6e65a0cf$var$getSelectedCampaign(data);
        return customerBranding.refetch({
            ...data,
            hint: prompt,
            // Only an edit of an existing campaign has a section to target — not a
            // regeneration from scratch.
            editScope: prompt && previousCampaign ? editScope : undefined
        }, null, {
            onSuccess: ()=>{
                setPrompt?.("");
                notifyEdited(previousCampaign);
            }
        });
    };
    // Awaitable `handleSubmit`: resolves once the adjusted campaign has been
    // persisted and selected, rejects when the generation fails. `options`
    // overrides the step's `editScope`.
    const handleSubmitAsync = async (prompt, videoData, options = {})=>{
        const data = videoData ?? video.data;
        const previousCampaign = $d97b7fdd6e65a0cf$var$getSelectedCampaign(data);
        const result = await customerBranding.refetchAsync({
            ...data,
            hint: prompt,
            editScope: options.editScope ?? editScope
        }, null);
        notifyEdited(previousCampaign);
        return result;
    };
    const handleUndo = ()=>{
        const previousCampaignIndex = historicalCampaigns?.findIndex((c)=>c.id === selectedCampaign?.id) - 1;
        if (previousCampaignIndex >= 0) {
            const previousCampaign = historicalCampaigns?.[previousCampaignIndex];
            updateVideo.mutate({
                selectedCampaignIds: [
                    previousCampaign.id
                ]
            });
        }
    };
    const handleRedo = ()=>{
        const nextCampaignIndex = historicalCampaigns?.findIndex((c)=>c.id === selectedCampaign?.id) + 1;
        if (nextCampaignIndex < historicalCampaigns?.length) {
            const nextCampaign = historicalCampaigns?.[nextCampaignIndex];
            updateVideo.mutate({
                selectedCampaignIds: [
                    nextCampaign.id
                ]
            });
        }
    };
    const handleFieldChange = (fieldKey, value)=>{
        if (!fieldKey || value === undefined) return;
        if (selectedCampaign?.[fieldKey] === value) return;
        const updatedCampaigns = [
            ...video.data?.campaigns
        ];
        const id = crypto.randomUUID();
        const updatedCampaign = {
            ...selectedCampaign,
            id: id,
            scenes: [],
            [fieldKey]: value
        };
        updatedCampaigns.push(updatedCampaign);
        updateVideo.mutate({
            campaigns: updatedCampaigns.slice(-10),
            selectedCampaignIds: [
                id
            ]
        });
    };
    return {
        historicalCampaigns: historicalCampaigns,
        hasHistoricalCampaigns: hasHistoricalCampaigns,
        hasPreviousCampaign: hasPreviousCampaign,
        hasNextCampaign: hasNextCampaign,
        handleSubmit: handleSubmit,
        handleSubmitAsync: handleSubmitAsync,
        handleUndo: handleUndo,
        handleRedo: handleRedo,
        handleFieldChange: handleFieldChange
    };
};




var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $hSW0F = parcelRequire("hSW0F");



var $77tch = parcelRequire("77tch");


const $70280e225bd4b5f5$export$b786868802aef0be = ({ editing: editing, placeholder: placeholder, promptHintsKey: promptHintsKey = "promptHints" })=>{
    const { video: video, selectedCampaign: selectedCampaign, updateVideo: updateVideo, customerBranding: customerBranding, handleRegenerateScript: handleRegenerateScript } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const { hasHistoricalCampaigns: hasHistoricalCampaigns, hasPreviousCampaign: hasPreviousCampaign, hasNextCampaign: hasNextCampaign, handleSubmit: handleSubmit, handleUndo: handleUndo, handleRedo: handleRedo } = editing;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Footer, {
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: (0, $87bd91c06342e699$export$ae81d1082cb406fc),
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c176de8415da9d02$export$76f46df19ff2ecee), {
                videoId: video.data?.id,
                placeholder: placeholder,
                completions: selectedCampaign?.[promptHintsKey] ?? selectedCampaign?.promptHints,
                getPromptTemplate: customerBranding.getPromptTemplate,
                onSubmit: handleSubmit,
                onReset: customerBranding.reset,
                isPending: customerBranding.isPending,
                onRedo: ()=>handleRegenerateScript({
                        onSuccess: (videoData)=>handleSubmit(undefined, undefined, videoData)
                    }),
                styles: (0, $87bd91c06342e699$export$f612d38926f99775),
                actions: hasHistoricalCampaigns && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    onPress: handleUndo,
                                    isDisabled: updateVideo.isPending || !hasPreviousCampaign,
                                    "aria-label": "Undo",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c8ca68bb4c148d98$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                    children: "Undo last changes"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                    onPress: handleRedo,
                                    isDisabled: updateVideo.isPending || !hasNextCampaign,
                                    "aria-label": "Redo",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cfc385dbd50373df$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                                    children: "Revert changes"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
$70280e225bd4b5f5$export$b786868802aef0be.propTypes = {
    editing: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        hasHistoricalCampaigns: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
        hasPreviousCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
        hasNextCampaign: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).bool,
        handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
        handleUndo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired,
        handleRedo: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func.isRequired
    }).isRequired,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    promptHintsKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};



const $e898dbb69e4bcf47$var$renderEmptyState = (message = "No campaigns found")=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $c0XRK.IllustratedMessage), {
        size: "M",
        styles: " JJ182 GJ182",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
            children: message
        })
    });
const $e898dbb69e4bcf47$export$856ee0b7e08de6c2 = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel, preview: preview = "partnership-value", contentLabel: contentLabel = "script", canEditCampaign: canEditCampaign = true })=>{
    const { isStepPending: isStepPending, video: video, customerBranding: customerBranding, selectedCampaign: selectedCampaign, selectedPersona: selectedPersona, template: template, updateVideo: updateVideo, editCampaign: editCampaign, editedCampaign: editedCampaign, setEditedCampaign: setEditedCampaign, setPromptHint: setPromptHint, customerName: customerName, colorScheme: colorScheme } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const PreviewComponent = preview === "campaign" ? (0, $lHGo8.CampaignPreview) : (0, $m1itB.PartnershipValuePreview);
    const editing = (0, $d97b7fdd6e65a0cf$export$53b64dcdb9d79359)({
        withScriptHistory: preview !== "campaign"
    });
    const { handleFieldChange: handleFieldChange } = editing;
    if (isStepPending || template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE && !selectedCampaign) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: `Preparing your ${contentLabel}`,
        subtitle: "This may take a few moments, so please keep this tab open.",
        ariaLabel: "Generating script",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ab17b54c80fc8a2e$export$2e2bcd8739ae039), {})
    });
    if (customerBranding.isError) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
        title: "Failed to load script details",
        onRetry: ()=>customerBranding.refetch(),
        children: "There was an error generating your script. Please try again."
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Up182 qp182",
                children: [
                    !!video.data?.campaigns?.length && template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).SINGLE && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                                title: "Choose campaign focus",
                                subtitle: "You can adjust the details before moving to the next step.",
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                    styles: " JA182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                            variant: "secondary",
                                            fillStyle: "outline",
                                            onPress: ()=>setPromptHint("Add a campaign with focus on "),
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f60261a86d0e572f$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Add new"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                            variant: "secondary",
                                            fillStyle: "outline",
                                            onPress: ()=>setPromptHint("Propose more campaign ideas"),
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $edFAP.default), {}),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Generate more"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$a7bfbda1311ca015), {
                                loadingState: (0, $8Ogg5.getQueryLoadingState)(customerBranding),
                                selectionMode: "single",
                                selectionStyle: "highlight",
                                selectedKeys: video.data?.selectedCampaignIds,
                                onSelectionChange: (keys)=>updateVideo.mutate({
                                        selectedCampaignIds: Array.from(keys)
                                    }),
                                renderEmptyState: ()=>$e898dbb69e4bcf47$var$renderEmptyState("No campaigns found"),
                                "aria-label": "Select a campaign",
                                layout: "grid",
                                className: " se182 Dr9Cjk182 __yqD9aYc182 _Ca182 eb182 Uj182 qj182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                    items: video.data?.campaigns,
                                    dependencies: [],
                                    children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0c1b7b025fb75d97$export$e96fc9a8407faa6b), {
                                            className: ({ isSelected: isSelected })=>(function anonymous(props) {
                                                    let rules = " ";
                                                    rules += ' _Pc182';
                                                    rules += ' ZJ182';
                                                    rules += ' _Md182';
                                                    rules += ' _Kb182';
                                                    rules += ' _Lf182';
                                                    if (props.isSelected) {
                                                        if (props.colorScheme === "dark") rules += ' O6Lc5Le182';
                                                        else if (props.colorScheme === "light") rules += ' OYTfire182';
                                                    } else rules += ' Oj182';
                                                    rules += ' oc182';
                                                    rules += ' nc182';
                                                    rules += ' kc182';
                                                    rules += ' jc182';
                                                    return rules;
                                                })({
                                                    isSelected: isSelected,
                                                    colorScheme: colorScheme
                                                }),
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
                                                id: item?.id ?? item.index,
                                                textValue: item.title,
                                                variant: "tertiary",
                                                size: "XL",
                                                UNSAFE_style: {
                                                    outlineColor: "transparent"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                                        styles: " _ch182",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                                                children: item.title
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _de182",
                                                                children: item.description
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                "aria-label": "Edit campaign",
                                                                variant: "primary",
                                                                isQuiet: true,
                                                                onPress: ()=>setPromptHint(`Edit "${item.title}" campaign:\n`),
                                                                styles: " zgSHDrc182 ygSHDrc182 BgSHDrc182 AgSHDrc182 JTnYEIe182 GTnYEIe182 Hc182",
                                                                "data-slot": "menu",
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Footer), {
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                            className: " sd182 _ta182 Uj182 qj182",
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                                                    label: "Tagline",
                                                                    value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                                                        children: item.tagline
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                                                    label: "Landing page",
                                                                    contextualHelp: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $be8e285b7bcfa47d$export$7d71619cfe2aecc1), {
                                                                        url: item.landingPageURL
                                                                    }),
                                                                    value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                                        variant: "secondary",
                                                                        href: item.landingPageURL,
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer",
                                                                        UNSAFE_className: " __Zc182 -nTSCV-cB9Fab182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                                                        children: item.landingPageURL
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                                                    label: "Audiences",
                                                                    value: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                        className: " sd182 _ta182 Ub182 qb182",
                                                                        children: item.audiences?.map((audience, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                                                                children: audience
                                                                            }, idx))
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }, item.id)
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aQTiM.DialogTrigger), {
                                isOpen: !!editedCampaign,
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8696adb541f50b0b$export$39bfae2e77a2708f), {
                                    defaultCampaign: editedCampaign,
                                    onSuccess: (campaign)=>{
                                        editCampaign.mutate(campaign);
                                        setEditedCampaign(null);
                                    },
                                    onClose: (close)=>{
                                        close();
                                        setEditedCampaign(null);
                                    }
                                })
                            })
                        ]
                    }),
                    !!video.data?.campaigns?.length && template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                                title: `Review your ${contentLabel}`,
                                subtitle: "You can adjust the details before moving to the next step."
                            }),
                            !!template.data?.campaignStructure?.length && /*#__PURE__*/ (0, $dx4lB.jsx)(PreviewComponent, {
                                selectedCampaign: selectedCampaign,
                                selectedPersona: selectedPersona,
                                campaignStructure: template.data?.campaignStructure,
                                templateData: template.data,
                                canEditCampaign: canEditCampaign,
                                onFieldChange: handleFieldChange
                            }),
                            !template.data?.campaignStructure?.length && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $74d890f6f2a4f834$export$61f100e67ffb6850), {
                                code: JSON.stringify(selectedCampaign, null, 2)
                            })
                        ]
                    })
                ]
            }),
            (!!selectedCampaign || !!video.data?.campaigns?.length) && !customerBranding.isError && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $70280e225bd4b5f5$export$b786868802aef0be), {
                editing: editing,
                placeholder: preview === "partnership-value" ? "Adjust script details" : "Adjust campaign details"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueLabel: continueLabel,
                isContinueDisabled: template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).SINGLE ? !customerName || !video.data?.selectedCampaignIds?.length : !video.data?.campaigns?.length || customerBranding.isEnabled && customerBranding.isPending
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: template.isPending,
                onPress: ()=>template.refetch(),
                children: "Refetch template"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

parcelRequire("CGZx1");
var $lb17q = parcelRequire("lb17q");


var $77tch = parcelRequire("77tch");

var $lb17q = parcelRequire("lb17q");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $bsn7e = parcelRequire("bsn7e");

var $77tch = parcelRequire("77tch");

var $iXKEI = parcelRequire("iXKEI");
const $3f4d439a6fe8254f$export$603e5e66da0ddcd1 = ()=>{
    const { video: video, editVariation: editVariation, setEditVariation: setEditVariation, handleUploadAssets: handleUploadAssets } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
        onDismiss: ()=>setEditVariation(null),
        children: !!editVariation && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iXKEI.EditVariationDialog), {
            videoId: video.data?.id,
            variationKey: editVariation.key,
            referenceKey: editVariation.referenceKey,
            isReferenceAsset: !!editVariation.isReferenceAsset,
            dependencies: editVariation.dependencies,
            onUpload: handleUploadAssets
        }, JSON.stringify([
            video.data?.id,
            editVariation.key
        ]))
    });
};





const $24065f2fdd88e010$export$c5e92a6b6e0b7aa0 = ({ name: name, description: description, onContinue: onContinue, onBack: onBack, continueLabel: continueLabel, contentLabel: contentLabel = "campaign", canEditCampaign: canEditCampaign = true, showPromptFooter: showPromptFooter = true, campaignStructure: campaignStructure, promptHintsKey: promptHintsKey, editScope: editScope })=>{
    const { isStepPending: isStepPending, video: video, updateVideo: updateVideo, customerBranding: customerBranding, selectedCampaign: selectedCampaign, selectedPersona: selectedPersona, template: template, customerName: customerName, setEditVariation: setEditVariation, handleUploadAssets: handleUploadAssets, handleAssetMenuAction: handleAssetMenuAction, handleColorChange: handleColorChange, scrapedColors: scrapedColors, stepActionCtx: stepActionCtx } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const imageVariations = stepActionCtx?.imageVariations;
    // An edit targets the step's story section; the images of the step it
    // changed the source of are then generated anew.
    const editing = (0, $d97b7fdd6e65a0cf$export$53b64dcdb9d79359)({
        editScope: editScope,
        onEdited: (previousCampaign, nextCampaign)=>{
            imageVariations?.regenerateFromCampaignChange?.(previousCampaign, nextCampaign);
        }
    });
    // Landing on the step directly — a reload, or a resumed project — never goes
    // through the step action, so the pipeline is armed here too; arming twice
    // is a no-op.
    const { run: run, variations: stageVariations } = imageVariations ?? {};
    (0, $eF4cA.useEffect)(()=>{
        run?.();
    }, [
        run
    ]);
    // Only the linked variations the template actually defines (and enables for
    // this campaign) are waited for.
    const isVisualsPending = (0, $eF4cA.useMemo)(()=>(0, $lb17q.hasPendingStructureVariations)(campaignStructure, imageVariations?.variations, video.data?.assets), [
        campaignStructure,
        imageVariations?.variations,
        video.data?.assets
    ]);
    // As are the required template assets it shows.
    const isAssetsPending = (0, $eF4cA.useMemo)(()=>(0, $lb17q.hasPendingStructureAssets)(campaignStructure, template.data?.assets, video.data?.assets), [
        campaignStructure,
        template.data?.assets,
        video.data?.assets
    ]);
    if (isStepPending || template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).NONE && !selectedCampaign) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: `Preparing your ${contentLabel}`,
        subtitle: "This may take a few moments, so please keep this tab open.",
        ariaLabel: "Generating campaign",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ab17b54c80fc8a2e$export$2e2bcd8739ae039), {})
    });
    if (customerBranding.isError) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
        title: "Failed to load campaign details",
        onRetry: ()=>customerBranding.refetch(),
        children: "There was an error generating your campaign. Please try again."
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Up182 qp182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: name ?? `Review your ${contentLabel}`,
                        subtitle: description ?? "You can adjust the details and regenerate the visuals before moving to the next step.",
                        styles: " Ue182 qe182 ed182 Za182 LvuBnEc182 GJ182 _Wd182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7cd28456b648eedc$export$2970d560d3520dd5), {
                        campaignStructure: campaignStructure,
                        selectedCampaign: selectedCampaign,
                        selectedPersona: selectedPersona,
                        canEditCampaign: canEditCampaign,
                        video: video,
                        templateData: template.data,
                        imageVariations: imageVariations,
                        onEditVariation: setEditVariation,
                        onUploadVariation: handleUploadAssets,
                        colors: scrapedColors,
                        onUploadAsset: handleUploadAssets,
                        onDeleteAsset: (asset)=>handleAssetMenuAction("delete", asset),
                        onColorChange: handleColorChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3f4d439a6fe8254f$export$603e5e66da0ddcd1), {}),
            showPromptFooter && (!!selectedCampaign || !!video.data?.campaigns?.length) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $70280e225bd4b5f5$export$b786868802aef0be), {
                editing: editing,
                placeholder: `Adjust ${contentLabel} details`,
                promptHintsKey: promptHintsKey
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueLabel: continueLabel,
                isContinueDisabled: (template.data?.campaignSelectionType === (0, $lb17q.SELECTION_TYPE).SINGLE ? !customerName || !video.data?.selectedCampaignIds?.length : !video.data?.campaigns?.length || customerBranding.isEnabled && customerBranding.isPending) || isVisualsPending || isAssetsPending
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: template.isPending,
                onPress: ()=>template.refetch(),
                children: "Refetch template"
            }),
            stageVariations.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isDisabled: updateVideo.isPending || !!imageVariations?.generatingKeys?.size,
                onPress: ()=>run?.({
                        force: true
                    }),
                children: "Regenerate all variations"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");

var $4W5AG = parcelRequire("4W5AG");
var $5NHyX = parcelRequire("5NHyX");
var $34HUQ = parcelRequire("34HUQ");
var $cxTG4 = parcelRequire("cxTG4");
var $4UbTp = parcelRequire("4UbTp");
var $208Op = parcelRequire("208Op");
var $5mvex = parcelRequire("5mvex");
var $88lL9 = parcelRequire("88lL9");
var $bsn7e = parcelRequire("bsn7e");
var $aQTiM = parcelRequire("aQTiM");
var $5nTep = parcelRequire("5nTep");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $abd917d017e8b03f$var$$c5989679e1591201$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "m19.636 9.47-3-3c-.293-.293-.768-.293-1.06 0s-.294.767 0 1.06l1.719 1.72h-9.15c-.415 0-.75.336-.75.75s.335.75.75.75h9.15l-1.72 1.72c-.293.293-.293.767 0 1.06.147.147.338.22.53.22s.384-.073.53-.22l3-3c.294-.293.294-.767 0-1.06"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.047 12.956c-.414 0-.75.336-.75.75v2.044c0 .413-.337.75-.75.75H3.25c-.413 0-.75-.337-.75-.75V4.25c0-.413.337-.75.75-.75h8.5c.413 0 .75.337.75.75v1.968c0 .414.336.75.75.75s.75-.336.75-.75V4.25C14 3.01 12.99 2 11.75 2h-8.5C2.01 2 1 3.01 1 4.25v11.5C1 16.99 2.01 18 3.25 18h8.297c1.24 0 2.25-1.01 2.25-2.25v-2.044c0-.414-.336-.75-.75-.75"
            })
        ]
    });
const $abd917d017e8b03f$var$$c5989679e1591201$var$ForwardRef = (0, $eF4cA.forwardRef)($abd917d017e8b03f$var$$c5989679e1591201$var$SvgComponent);
var $abd917d017e8b03f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($abd917d017e8b03f$var$$c5989679e1591201$var$ForwardRef);



var $HZG6L = parcelRequire("HZG6L");

var $klXmP = parcelRequire("klXmP");




var $fmJ8d = parcelRequire("fmJ8d");
parcelRequire("CGZx1");
var $lb17q = parcelRequire("lb17q");

var $77tch = parcelRequire("77tch");

var $eF4cA = parcelRequire("eF4cA");

var $8u8Xx = parcelRequire("8u8Xx");

var $k7O9T = parcelRequire("k7O9T");
var $k6waQ = parcelRequire("k6waQ");
var $7ClmI = parcelRequire("7ClmI");

var $fmJ8d = parcelRequire("fmJ8d");

var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");

var $4SSyx = parcelRequire("4SSyx");

parcelRequire("8Xrlw");
var $bfC2s = parcelRequire("bfC2s");

var $34B61 = parcelRequire("34B61");


var $77tch = parcelRequire("77tch");

var $7nuM2 = parcelRequire("7nuM2");

var $lb17q = parcelRequire("lb17q");
/** No stage at all — the images pipeline is idle outside an images step. */ const $358fce2ffba1b379$var$NO_STAGES = [];
const $358fce2ffba1b379$var$filterAssetsForBannerRegeneration = (assets)=>assets?.filter((asset)=>{
        if ([
            "Logo_cropped"
        ].includes(asset.name)) return false;
        if (asset.name.includes(" #")) return false;
        return true;
    });
const $358fce2ffba1b379$var$AUDIO_MUX_DOWNLOAD_TEMPLATE_IDS = new Set([
    "ucx",
    "ao-overview"
]);
const $358fce2ffba1b379$export$6e3cfba39daf22d3 = (templateId)=>$358fce2ffba1b379$var$AUDIO_MUX_DOWNLOAD_TEMPLATE_IDS.has(templateId);
const $358fce2ffba1b379$var$getAudioMuxSourcesKey = (sourceAssets, musicPath)=>{
    const voiceKey = sourceAssets.map((a)=>{
        const cfg = a?.voiceConfig ?? {};
        const parts = a?.parts ?? {};
        const cfgStr = JSON.stringify(cfg);
        const partsStr = JSON.stringify(parts);
        return [
            a?.filePath ?? "",
            String(a?.generatedAt ?? ""),
            a?.voiceId ?? "",
            cfgStr,
            partsStr
        ].join("_");
    }).join(",");
    return `${voiceKey}\${musicPath ?? ""}`;
};
const $358fce2ffba1b379$var$getSelectedCampaign = (videoData)=>videoData?.campaigns?.find((campaign)=>campaign.id === videoData?.selectedCampaignIds?.[0]);
const $358fce2ffba1b379$var$getKeyVisualChangedPrompt = (asset)=>`The campaign's key visual (KV-primary) has been replaced, so the current \`KV-description\` no longer describes it. Update \`KV-description\` to describe the new key visual and adjust the other parts of the campaign (\`KV-theme\`, \`KV-theme-short\`, \`KV-location\`, \`KV-character\`, \`KV-product\`, \`KV-alternative-version-description\`, \`KV-without-campaign-theme\`, \`Additional-prompt-Foundry\`, \`Custom-model-prompt\` and any copy that refers to the visual) so the whole campaign stays consistent with it.

New key visual prompt:
${asset?.prompt || "(none \u2014 the key visual was uploaded manually)"}

New key visual description:
${JSON.stringify(asset?.labeling ?? {})}`;
const $358fce2ffba1b379$export$908544b14d170f6e = ()=>{
    const { setSelectedTemplateKey: setSelectedTemplateKey, video: video, template: template, assetsTemplate: assetsTemplate, createVideo: createVideo, createVideoIfNeeded: createVideoIfNeeded, updateVideo: updateVideo, updateAssets: updateAssets, uploadAssets: uploadAssets, customerBranding: customerBranding, editCampaign: editCampaign, generateBanners: generateBanners, exportBanners: exportBanners, generateVideo: generateVideo, describeMogrtTemplate: describeMogrtTemplate, generateScenes: generateScenes, regenerateScenes: regenerateScenes, checkCustomer: checkCustomer, audioMux: audioMux, videoId: videoId, setProjectId: setProjectId, templateId: templateId, selectedCampaign: selectedCampaign, selectedPersona: selectedPersona, customerName: customerName, hint: hint, taglinesData: taglinesData, assetsFingerprint: assetsFingerprint, bannersAssetsFingerprintRef: bannersAssetsFingerprintRef, audioMuxRanForSourcesKeyRef: audioMuxRanForSourcesKeyRef, setAudioMuxDownloadUrl: setAudioMuxDownloadUrl, runStepEnteringActionRef: runStepEnteringActionRef, runStepLeavingActionRef: runStepLeavingActionRef, currentStep: currentStep, activeSteps: activeSteps } = (0, $eF4cA.use)((0, $77tch.VideoWizardContext));
    const queryClient = (0, $7ClmI.useQueryClient)();
    const activeTemplateId = template.data?.id ?? templateId;
    // ---------------------------------------------------------------------------
    // Key visual sync — one mutation, so the step after the key visuals can wait
    // on a single `isPending`: describe the key visual when it has not been yet,
    // then — when it is not the one the campaign's `KV-description` describes —
    // have the LLM adjust the campaign to it.
    // ---------------------------------------------------------------------------
    const { handleSubmitAsync: handleSubmitAsync } = (0, $d97b7fdd6e65a0cf$export$53b64dcdb9d79359)();
    const keyVisualLabeling = (0, $4SSyx.useImageLabeling)();
    const labelKeyVisual = async (asset)=>{
        const id = (0, $34B61.labelingId)(videoId, asset.name);
        if ((0, $34B61.loadingImageLabeling).has(id)) return;
        (0, $34B61.loadingImageLabeling).add(id);
        try {
            const presign = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(asset.filePath));
            if (!presign?.presignURL) return;
            const labeling = await keyVisualLabeling.mutateAsync({
                key: asset.name,
                imageUrl: presign.presignURL,
                systemPromptId: "common-image-description"
            });
            const latestAsset = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId))?.assets?.find((a)=>a?.name === asset.name) ?? asset;
            await updateAssets.mutateAsync({
                assets: [
                    {
                        ...latestAsset,
                        labeling: {
                            ...latestAsset.labeling,
                            ...labeling
                        }
                    }
                ]
            });
        } finally{
            (0, $34B61.loadingImageLabeling).delete(id);
        }
    };
    const syncKeyVisual = (0, $k6waQ.useMutation)({
        mutationFn: async ()=>{
            const getVideoData = ()=>queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
            const initial = (0, $lb17q.getKeyVisualSyncState)(getVideoData(), $358fce2ffba1b379$var$getSelectedCampaign(getVideoData()));
            if (initial.needsLabeling) await labelKeyVisual(initial.asset);
            const videoData = getVideoData();
            const sourceCampaign = $358fce2ffba1b379$var$getSelectedCampaign(videoData);
            const { asset: asset, effectiveDescription: effectiveDescription, isOutOfSync: isOutOfSync } = (0, $lb17q.getKeyVisualSyncState)(videoData, sourceCampaign);
            if (!isOutOfSync) return;
            const previousCampaignIds = new Set(videoData?.campaigns?.map((campaign)=>campaign.id));
            await handleSubmitAsync($358fce2ffba1b379$var$getKeyVisualChangedPrompt(asset), videoData, {
                editScope: "key-visuals"
            });
            // Pin the adjusted campaign to the key visual it was written for, so the
            // next time the step is left it reads as in sync.
            const updatedVideoData = getVideoData();
            const adjustedCampaign = updatedVideoData?.campaigns?.findLast((campaign)=>!previousCampaignIds.has(campaign.id)) ?? $358fce2ffba1b379$var$getSelectedCampaign(updatedVideoData);
            if (!adjustedCampaign) return;
            await updateVideo.mutateAsync({
                campaigns: updatedVideoData.campaigns.map((campaign)=>campaign.id === adjustedCampaign.id ? {
                        ...campaign,
                        "KV-description": effectiveDescription
                    } : campaign),
                selectedCampaignIds: [
                    adjustedCampaign.id
                ]
            });
        },
        meta: {
            errorMessage: "Failed to adjust the campaign to the new key visual. Please try again."
        }
    });
    const runSyncKeyVisual = ()=>{
        if (!syncKeyVisual.isPending) syncKeyVisual.mutate();
    };
    // ---------------------------------------------------------------------------
    // Image variations — owned here rather than by the step's view, so the
    // pipeline is reachable from `enter.run()` at the moment the step is entered
    // (its view is not mounted yet) and keeps running while it is displayed.
    // ---------------------------------------------------------------------------
    const currentStepEntry = (0, $eF4cA.useMemo)(()=>activeSteps?.find((step)=>step.id === currentStep), [
        activeSteps,
        currentStep
    ]);
    const isOnImagesStep = (0, $lb17q.isImagesStep)(currentStepEntry ?? currentStep);
    // There may be several campaign visuals steps, each with its own structure.
    const isOnCampaignVisualsStep = (0, $lb17q.isCampaignVisualsStep)(currentStepEntry);
    // The branding step may show variations of its own, generated on demand.
    const isOnBrandingVariationsStep = (0, $lb17q.isBrandingVariationsStep)(currentStepEntry);
    const ownsStructureVariations = isOnCampaignVisualsStep || isOnBrandingVariationsStep;
    // An images step may cover a subset of the template's stages — or all of
    // them, when it declares no `stages` at all.
    const imagesStepStages = (0, $eF4cA.useMemo)(()=>{
        if (!isOnImagesStep) return $358fce2ffba1b379$var$NO_STAGES;
        return currentStepEntry?.stages;
    }, [
        isOnImagesStep,
        currentStepEntry
    ]);
    // The campaign visuals step (and a branding step with variations) owns the
    // variations its campaign structure shows, by key, whatever stage they
    // belong to.
    const campaignVisualsStructure = (0, $eF4cA.useMemo)(()=>ownsStructureVariations ? currentStepEntry?.campaignStructure : null, [
        ownsStructureVariations,
        currentStepEntry
    ]);
    const campaignVisualsDependencies = (0, $eF4cA.useMemo)(()=>ownsStructureVariations ? (0, $7nuM2.getStructureDependencies)(campaignVisualsStructure) : null, [
        ownsStructureVariations,
        campaignVisualsStructure
    ]);
    const campaignVisualsKeys = (0, $eF4cA.useMemo)(()=>ownsStructureVariations ? (0, $lb17q.getStructureVariationKeys)(campaignVisualsStructure) : null, [
        ownsStructureVariations,
        campaignVisualsStructure
    ]);
    const imageVariations = (0, $bfC2s.useImageVariations)({
        projectId: videoId,
        video: video,
        templateData: template.data,
        stages: imagesStepStages,
        keys: campaignVisualsKeys ?? undefined,
        sourceDependencies: campaignVisualsDependencies ?? undefined,
        selectedCampaign: selectedCampaign,
        // The visuals are written for the campaign, so they wait for one — and for
        // it to be adjusted to a changed key visual.
        enabled: !syncKeyVisual.isPending && (isOnImagesStep || ownsStructureVariations && !!selectedCampaign?.id),
        manual: isOnBrandingVariationsStep
    });
    // Generating the images & text takes a while — tell the user for as long as
    // some variations are still to be generated. The effect cleanup closes the
    // toast when the step is left or the generation is done. Once the "assets
    // ready" email has been sent there is nothing left to wait for.
    const shouldShowImagesAndTextToast = currentStep === (0, $lb17q.WIZARD_STEP).IMAGES_AND_TEXT && !!video.isSuccess && !video.data?.assetsReadyEmailSent && !!template.data && template.data?.id === "one-adobe" && !!selectedCampaign?.id && !syncKeyVisual.isPending && imageVariations.pendingVariations.length > 0;
    (0, $eF4cA.useEffect)(()=>{
        if (!shouldShowImagesAndTextToast) return undefined;
        // No timeout, so the toast is persistent.
        return (0, $8u8Xx.ToastQueue).info("This will take around 15 minutes. We\u2019ll email you when everything\u2019s ready!");
    }, [
        shouldShowImagesAndTextToast
    ]);
    // ---------------------------------------------------------------------------
    // Callbacks — each mirrors its former position in VideoWizard.js
    // ---------------------------------------------------------------------------
    const ensureProjectId = (0, $eF4cA.useCallback)(()=>{
        if (videoId) return videoId;
        const id = crypto.randomUUID();
        setProjectId(id);
        return id;
    }, [
        videoId,
        setProjectId
    ]);
    const resetPersonaCampaigns = (0, $eF4cA.useCallback)(()=>{
        if (!!video.data?.id && !!template.data?.personas?.length && selectedPersona?.id !== video.data?.personaId) updateVideo.mutate({
            personaId: selectedPersona?.id,
            customer: {
                name: video.data?.customer?.name
            },
            assets: [],
            campaigns: [],
            selectedCampaignIds: []
        });
    }, [
        template.data?.personas?.length,
        selectedPersona?.id,
        video.data?.id,
        video.data?.personaId,
        video.data?.customer?.name,
        updateVideo.mutate
    ]);
    const runGenerateBranding = (0, $eF4cA.useCallback)((_videoData)=>{
        const customerName = _videoData?.customer?.name ?? video.data?.customer?.name;
        const fullCustomerName = _videoData?.customer?.["Company-name"] ?? video.data?.customer?.["Company-name"];
        const hasCustomerOrHintChanged = video.isSuccess && (!!customerName && video.data?.customer?.name !== customerName || !!hint && video.data?.hint !== hint);
        const shouldGenerateBranding = !checkCustomer.isPending && !!customerName && !fullCustomerName || hasCustomerOrHintChanged;
        if (shouldGenerateBranding) checkCustomer.mutate({
            customerName: _videoData?.customer?.name ?? video.data?.customer?.name,
            hint: _videoData?.hint ?? video.data?.hint
        }, {
            onSuccess: async (data, variables, onMutateResult, { client: client })=>{
                const videoData = client.getQueryData((0, $ikOQe.videoKey).detail(videoId ?? _videoData?.id));
                const updatePromises = [];
                const { "Company-name": name, "Brand-color": brandColor, "Secondary-color": secondaryColor, "Company-website-URL": websiteURL } = data;
                updatePromises.push(updateVideo.mutateAsync({
                    customer: {
                        ...videoData?.customer ?? {},
                        name: name,
                        websiteURL: websiteURL,
                        ...data
                    }
                }));
                const assetsUpdate = new Map();
                if (brandColor && !videoData?.assets?.some((asset)=>asset.name === "Brand-color")) assetsUpdate.set("Brand-color", {
                    name: "Brand-color",
                    type: "color",
                    color: brandColor
                });
                if (secondaryColor && !videoData?.assets?.some((asset)=>asset.name === "Secondary-color")) assetsUpdate.set("Secondary-color", {
                    name: "Secondary-color",
                    type: "color",
                    color: secondaryColor
                });
                if (assetsUpdate.size) updatePromises.push(updateAssets.mutateAsync({
                    assets: Array.from(assetsUpdate.values())
                }));
                return await Promise.all(updatePromises);
            }
        });
    }, [
        videoId,
        video.isSuccess,
        video.data?.customer?.name,
        video.data?.hint,
        customerName,
        hint,
        updateVideo.mutateAsync,
        updateAssets.mutateAsync,
        checkCustomer.isPending,
        checkCustomer.mutate
    ]);
    const { isPending: isCustomerBrandingPending, refetch: refetchCustomerBranding } = customerBranding;
    const runCreateCampaign = (0, $eF4cA.useCallback)((videoData)=>{
        const hasCustomerOrHintChanged = video.isSuccess && (video.data?.customer?.name !== customerName || video.data?.hint !== hint);
        const shouldCreateCampaign = !isCustomerBrandingPending && videoData ? !videoData?.campaigns?.length : video.isSuccess && !video.data?.campaigns?.length || hasCustomerOrHintChanged;
        if (shouldCreateCampaign) refetchCustomerBranding(videoData);
    }, [
        isCustomerBrandingPending,
        video.isSuccess,
        video.data?.campaigns?.length,
        video.data?.customer?.name,
        video.data?.hint,
        customerName,
        hint,
        refetchCustomerBranding
    ]);
    const runGenerateScenes = (0, $eF4cA.useCallback)(()=>{
        if (!generateScenes.isPending && video.isSuccess && !!selectedCampaign?.script && !selectedCampaign?.scenes?.length) regenerateScenes();
    }, [
        generateScenes,
        regenerateScenes,
        video.isSuccess,
        selectedCampaign?.script,
        selectedCampaign?.scenes?.length
    ]);
    const regenerateBannersFromCurrentAssets = (0, $eF4cA.useCallback)(async ()=>{
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        await updateVideo.mutateAsync({
            assets: $358fce2ffba1b379$var$filterAssetsForBannerRegeneration(videoData?.assets)
        });
        if (!generateBanners.isPending) generateBanners.mutate({
            videoId: videoId
        });
    }, [
        videoId,
        queryClient,
        updateVideo.mutateAsync,
        generateBanners.isPending,
        generateBanners.mutate
    ]);
    const runBannersTransition = (0, $eF4cA.useCallback)(()=>{
        const taglinesChanged = JSON.stringify(selectedCampaign?.taglines ?? [
            {},
            {},
            {}
        ]) !== JSON.stringify(taglinesData);
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        const visualsChanged = bannersAssetsFingerprintRef.current !== null && bannersAssetsFingerprintRef.current !== assetsFingerprint;
        const isFirstBannerGeneration = !videoData?.templateAssetsRenditions?.length;
        if (isFirstBannerGeneration && !taglinesChanged && !visualsChanged) {
            if (!generateBanners.isPending) generateBanners.mutate({
                videoId: videoId
            });
            return;
        }
        (0, $eF4cA.startTransition)(async ()=>{
            if (taglinesChanged) {
                const editedTaglines = selectedCampaign?.taglines?.map((tagline, index)=>({
                        ...tagline,
                        ...taglinesData?.[index] || {}
                    })) ?? [];
                await editCampaign.mutateAsync({
                    ...selectedCampaign,
                    taglines: editedTaglines
                });
            }
            const shouldRegenerateBanners = isFirstBannerGeneration || taglinesChanged || visualsChanged;
            if (!shouldRegenerateBanners) return;
            await regenerateBannersFromCurrentAssets();
        });
    }, [
        selectedCampaign,
        taglinesData,
        editCampaign.mutateAsync,
        queryClient,
        videoId,
        assetsFingerprint,
        generateBanners,
        regenerateBannersFromCurrentAssets
    ]);
    // ---------------------------------------------------------------------------
    // Voiceover mux
    // ---------------------------------------------------------------------------
    const computeVoiceoverMuxKey = (0, $eF4cA.useCallback)((videoData)=>{
        const audioVariations = template.data?.audioVariations;
        if (!audioVariations?.length) return null;
        if (videoData?.mogrtRootPath && videoData?.templateType === "mogrt" && describeMogrtTemplate.isLoading) return null;
        const voiceoverMode = videoData?.voiceoverMode;
        const musicPath = videoData?.musicPath ?? describeMogrtTemplate.data?.musicPath ?? "";
        if (voiceoverMode === "none") {
            const noVoMusicPath = describeMogrtTemplate.data?.musicNoVoPath ?? musicPath;
            return noVoMusicPath ? `none:${noVoMusicPath}` : null;
        }
        if (voiceoverMode === "upload") return null;
        const sourceAssets = audioVariations.map((v)=>videoData?.assets?.find((a)=>a.type === "audio" && a.name === v.referenceKey));
        if (sourceAssets.some((a)=>!a?.filePath)) return null;
        return $358fce2ffba1b379$var$getAudioMuxSourcesKey(sourceAssets, musicPath);
    }, [
        template.data?.audioVariations,
        describeMogrtTemplate.isLoading,
        describeMogrtTemplate.data?.musicPath,
        describeMogrtTemplate.data?.musicNoVoPath
    ]);
    const isVoiceoverMuxReady = (0, $eF4cA.useCallback)(()=>{
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        const muxPathsKey = computeVoiceoverMuxKey(videoData);
        if (!muxPathsKey) return true;
        const audioVariations = template.data?.audioVariations;
        const existingMuxAsset = videoData?.assets?.find((a)=>a.name === audioVariations?.[0]?.key);
        return existingMuxAsset?.muxSourceKey === muxPathsKey;
    }, [
        queryClient,
        videoId,
        computeVoiceoverMuxKey,
        template.data?.audioVariations
    ]);
    const runVoiceoverMux = (0, $eF4cA.useCallback)(async ()=>{
        if (audioMux.isPending) return;
        const videoData = queryClient.getQueryData((0, $ikOQe.videoKey).detail(videoId));
        const audioVariations = template.data?.audioVariations;
        const muxPathsKey = computeVoiceoverMuxKey(videoData);
        if (!muxPathsKey || !audioVariations?.length) return;
        const existingMuxAsset = videoData?.assets?.find((a)=>a.name === audioVariations[0]?.key);
        if (existingMuxAsset?.muxSourceKey === muxPathsKey) {
            audioMuxRanForSourcesKeyRef.current = muxPathsKey;
            return;
        }
        if (audioMuxRanForSourcesKeyRef.current === muxPathsKey) return;
        const voiceoverMode = videoData?.voiceoverMode;
        const musicPath = videoData?.musicPath ?? describeMogrtTemplate.data?.musicPath ?? "";
        const noVoMusicPath = describeMogrtTemplate.data?.musicNoVoPath ?? musicPath;
        const sourceAssets = voiceoverMode !== "none" ? audioVariations.map((v)=>videoData?.assets?.find((a)=>a.type === "audio" && a.name === v.referenceKey)) : [];
        if (voiceoverMode !== "none" && sourceAssets.some((a)=>!a?.filePath)) return;
        try {
            const settingsDuration = audioVariations.reduce((max, v)=>Math.max(max, (v.settings?.inset ?? 0) + (v.settings?.duration ?? 0)), 0) + 5;
            if (voiceoverMode === "none") {
                if (!noVoMusicPath) return;
                const noVoFirst = audioVariations[0];
                const noVoSettings = noVoFirst?.settings ?? {};
                await uploadAssets.mutateAsync({
                    assets: [
                        {
                            name: noVoFirst.key,
                            type: noVoFirst.type,
                            filePath: noVoMusicPath,
                            referenceKey: noVoFirst.referenceKey,
                            volume: noVoSettings.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                            inset: 0,
                            start: 0,
                            duration: settingsDuration,
                            muxSourceKey: muxPathsKey
                        }
                    ]
                });
                audioMuxRanForSourcesKeyRef.current = muxPathsKey;
                return;
            }
            const voiceoverPreviewPath = template.data?.voiceoverPreviewUrl;
            const hasRegeneratedSegment = sourceAssets.some((a)=>a?.isRegenerated);
            const isDefaultVoiceoverScript = !!voiceoverPreviewPath && !hasRegeneratedSegment;
            if (isDefaultVoiceoverScript) {
                const first = audioVariations[0];
                const firstSettings = first?.settings ?? {};
                await uploadAssets.mutateAsync({
                    assets: [
                        {
                            name: first.key,
                            type: first.type,
                            filePath: voiceoverPreviewPath,
                            referenceKey: first.referenceKey,
                            volume: firstSettings.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                            inset: 0,
                            start: 0,
                            duration: settingsDuration,
                            muxSourceKey: muxPathsKey
                        }
                    ]
                });
                audioMuxRanForSourcesKeyRef.current = muxPathsKey;
                return;
            }
            let voiceAudios = [];
            let outputDuration = settingsDuration;
            if (voiceoverMode !== "none") {
                voiceAudios = await Promise.all(audioVariations.map(async (variation, i)=>{
                    const s = variation?.settings ?? {};
                    const presign = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(sourceAssets[i].filePath));
                    if (!presign?.presignURL) return null;
                    return {
                        source: {
                            url: presign.presignURL
                        },
                        volume: s.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                        inset: s.inset ?? 0,
                        start: s.start ?? 0,
                        duration: s.duration ?? 0
                    };
                }));
                if (voiceAudios.some((a)=>a == null)) return;
                const reachability = await Promise.all(voiceAudios.map(async (track)=>{
                    try {
                        const res = await fetch(track.source.url);
                        res.body?.cancel?.();
                        return res.ok;
                    } catch  {
                        return false;
                    }
                }));
                const missingLabels = reachability.map((ok, i)=>ok ? null : audioVariations[i]?.label ?? `Segment ${i + 1}`).filter(Boolean);
                if (missingLabels.length > 0) {
                    (0, $fmJ8d.store).getState().addToast(`Some voiceover segments haven't been generated yet: ${missingLabels.join(", ")}. Generate them before continuing.`, {
                        variant: "negative",
                        timeout: 10000
                    });
                    return;
                }
                outputDuration = voiceAudios.reduce((max, tr)=>Math.max(max, (tr.inset ?? 0) + (tr.duration ?? 0)), 0) + 5;
            }
            const audios = [];
            if (musicPath) {
                const musicPresign = await queryClient.query((0, $a8sj2.presignURLQueryOptions)(musicPath));
                if (!musicPresign?.presignURL) return;
                audios.push({
                    source: {
                        url: musicPresign.presignURL
                    },
                    volume: (0, $7da6076015242272$export$d434e5f09e6f67e5),
                    inset: 0,
                    start: 0,
                    duration: outputDuration
                });
            }
            audios.push(...voiceAudios);
            const muxUrl = await audioMux.mutateAsync(audios);
            if ($358fce2ffba1b379$export$6e3cfba39daf22d3(template.data?.id)) setAudioMuxDownloadUrl(muxUrl);
            const first = audioVariations[0];
            const firstSettings = first?.settings ?? {};
            const sourceAsset = sourceAssets[0];
            await uploadAssets.mutateAsync({
                assets: [
                    {
                        name: first.key,
                        type: first.type,
                        src: muxUrl,
                        referenceKey: first.referenceKey,
                        text: sourceAsset?.text,
                        parts: sourceAsset?.parts ? {
                            ...sourceAsset.parts
                        } : undefined,
                        voiceId: sourceAsset?.voiceId,
                        voiceConfig: sourceAsset?.voiceConfig,
                        volume: firstSettings.volume ?? (0, $7da6076015242272$export$4f8a6a1cc71d71e8),
                        inset: 0,
                        start: 0,
                        duration: outputDuration,
                        muxSourceKey: muxPathsKey
                    }
                ]
            });
            audioMuxRanForSourcesKeyRef.current = muxPathsKey;
        } catch (e) {
            if ((0, $k7O9T.isCancelledError)(e)) return;
            console.error("Audio mux failed:", e);
        }
    }, [
        audioMux,
        uploadAssets,
        queryClient,
        videoId,
        template.data,
        describeMogrtTemplate.data?.musicPath,
        describeMogrtTemplate.data?.musicNoVoPath,
        computeVoiceoverMuxKey
    ]);
    const runGenerateVideo = (0, $eF4cA.useCallback)(async ()=>{
        const deadline = Date.now() + 180000;
        while(!isVoiceoverMuxReady() && Date.now() < deadline)await new Promise((resolve)=>setTimeout(resolve, 250));
        generateVideo.mutate({
            videoId: videoId,
            templateAssetsRenditions: exportBanners.data
        });
    }, [
        isVoiceoverMuxReady,
        generateVideo.mutate,
        videoId,
        exportBanners.data
    ]);
    // ---------------------------------------------------------------------------
    // Unified ctx — every step action receives the same object
    // ---------------------------------------------------------------------------
    const stepActionCtx = {
        setSelectedTemplateKey: setSelectedTemplateKey,
        video: video,
        template: template,
        assetsTemplate: assetsTemplate,
        createVideo: createVideo,
        checkCustomer: checkCustomer,
        customerBranding: customerBranding,
        generateScenes: generateScenes,
        generateBanners: generateBanners,
        editCampaign: editCampaign,
        audioMux: audioMux,
        uploadAssets: uploadAssets,
        selectedCampaign: selectedCampaign,
        imageVariations: imageVariations,
        ensureProjectId: ensureProjectId,
        runCreateVideo: createVideoIfNeeded,
        runCreateCampaign: runCreateCampaign,
        runGenerateBranding: runGenerateBranding,
        runGenerateScenes: runGenerateScenes,
        runBannersTransition: runBannersTransition,
        runGenerateVideo: runGenerateVideo,
        resetPersonaCampaigns: resetPersonaCampaigns,
        isVoiceoverMuxReady: isVoiceoverMuxReady,
        runVoiceoverMux: runVoiceoverMux,
        computeVoiceoverMuxKey: computeVoiceoverMuxKey,
        syncKeyVisual: syncKeyVisual,
        runSyncKeyVisual: runSyncKeyVisual
    };
    // ---------------------------------------------------------------------------
    // Dispatch — assign to refs from context so handleNextStep (in the parent)
    // can call these without a direct dependency on the hook output.
    // ---------------------------------------------------------------------------
    // `handleNextStep` dispatches by step id; the actions are resolved from the
    // step's configuration (its `type` decides its family).
    const findActiveStep = (stepId)=>activeSteps?.find((step)=>step.id === stepId) ?? stepId;
    runStepEnteringActionRef.current = (stepId)=>{
        (0, $lb17q.getStepEnterAction)(findActiveStep(stepId), activeTemplateId)?.run(stepActionCtx);
    };
    runStepLeavingActionRef.current = (stepId)=>{
        const action = (0, $lb17q.getStepLeaveAction)(findActiveStep(stepId), activeTemplateId);
        if (!action) return;
        if (!action.isReady(stepActionCtx) && !action.isPending(stepActionCtx)) action.run(stepActionCtx);
    };
    return {
        stepActionCtx: stepActionCtx,
        regenerateBannersFromCurrentAssets: regenerateBannersFromCurrentAssets,
        computeVoiceoverMuxKey: computeVoiceoverMuxKey
    };
};



var $lb17q = parcelRequire("lb17q");

var $8jegM = parcelRequire("8jegM");



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $l19Vn = parcelRequire("l19Vn");

var $9eyCh = parcelRequire("9eyCh");

var $dqZbZ = parcelRequire("dqZbZ");



var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");


var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $672bd86de9b2e48d$var$$e0a5d45f488fa6ba$var$accordion = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g) || []).join('');
    rules += ' sd182';
    rules += ' _ta182';
    return rules;
};
const $672bd86de9b2e48d$export$6bd5bb82c987ab74 = (0, $eF4cA.createContext)(null);
const $672bd86de9b2e48d$export$a766cd26d0d69044 = (0, $eF4cA.forwardRef)(function Accordion(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $672bd86de9b2e48d$export$6bd5bb82c987ab74);
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '', size: size = 'M', density: density = 'regular', isQuiet: isQuiet } = props;
    return (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$d665dd135a51b28a).Provider, {
        value: {
            size: size,
            isQuiet: isQuiet,
            density: density
        },
        children: (0, $dx4lB.jsx)((0, $1cff1fad781fe217$export$944aceb4f8c89f10), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + $672bd86de9b2e48d$var$$e0a5d45f488fa6ba$var$accordion(null, props.styles),
            children: props.children
        })
    });
});
const $672bd86de9b2e48d$export$d99097c13d4dac9f = (0, $eF4cA.forwardRef)(function AccordionItem(props, ref) {
    return (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$74a362b31437ec83), {
        ...props,
        ref: ref
    });
});
const $672bd86de9b2e48d$export$c30e8bcae12973af = (0, $eF4cA.forwardRef)(function AccordionItemTitle(props, ref) {
    return (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$7843c6a5b3e340a2), {
        ...props,
        ref: ref
    });
});
const $672bd86de9b2e48d$export$96fae341779b6372 = (0, $eF4cA.forwardRef)(function AccordionItemHeader(props, ref) {
    return (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$1e037ddd32f5b8ac), {
        ...props,
        ref: ref
    });
});
const $672bd86de9b2e48d$export$d60a3c6bf8395a37 = (0, $eF4cA.forwardRef)(function AccordionItemPanel(props, ref) {
    return (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$feabaa331e1d464c), {
        ...props,
        ref: ref
    });
});


var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $5NHyX = parcelRequire("5NHyX");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $7uz0i = parcelRequire("7uz0i");
var $bsn7e = parcelRequire("bsn7e");
var $j3pTw = parcelRequire("j3pTw");
var $3YPmU = parcelRequire("3YPmU");

var $8w4Nl = parcelRequire("8w4Nl");

var $5nTep = parcelRequire("5nTep");

var $3PqDc = parcelRequire("3PqDc");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $lrZgx = parcelRequire("lrZgx");

var $eF4cA = parcelRequire("eF4cA");

var $1ntKq = parcelRequire("1ntKq");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $41e172257332f72e$export$e9f3bf65a26ce129 = (0, $eF4cA.createContext)(null);
const $41e172257332f72e$var$$b847b7cd294eafba$var$indeterminateLTR = "VHPsfc";
const $41e172257332f72e$var$$b847b7cd294eafba$var$indeterminateRTL = "reCXe";
const $41e172257332f72e$var$$b847b7cd294eafba$var$wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr182';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s182';
    if (!position) rules += ' _Pc182';
    rules += ' se182';
    if (props.isIndeterminate) {
        if (props.labelPosition === "side") rules += ' DPlN5qb182';
        else if (props.labelPosition === "top") rules += ' DM8Mfn182';
    } else {
        if (props.labelPosition === "side") rules += ' DPlN5qb182';
        else if (props.labelPosition === "top") rules += ' Dxumf9b182';
    }
    if (props.isIndeterminate) {
        if (props.labelPosition === "side") rules += ' C2Yfxtb182';
        else if (props.labelPosition === "top") rules += ' C0J5Chb182';
    } else {
        if (props.labelPosition === "side") rules += ' Cvv4gue182';
        else if (props.labelPosition === "top") rules += ' CC0Gyo182';
    }
    rules += ' ea182';
    rules += ' _Bb182';
    if (!minWidth) rules += ' Nl182';
    if (!maxWidth) rules += ' Lk182';
    if (props.size === "XL") rules += ' -BhX7R-Fz182';
    else if (props.size === "L") rules += ' -BhX7R-Fv182';
    else if (props.size === "S") rules += ' -BhX7R-Fp182';
    else if (props.size === "XS") rules += ' -BhX7R-Fn182';
    else rules += ' -BhX7R-Fx182';
    rules += ' -dTMmze-Fe182';
    rules += ' -AJjOLd-UCwrhQe182';
    rules += ' qg182';
    return rules;
};
const $41e172257332f72e$var$$b847b7cd294eafba$var$valueStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "XS") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a182';
        rules += ' vx182';
    } else {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "XS") {
        rules += ' xb182';
        rules += ' _xa182';
    } else {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "XS") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isStaticColor) rules += ' pl182';
    else if (props.isDisabled) rules += ' pp182';
    else rules += ' pv182';
    rules += ' plb182';
    rules += ' ri182';
    rules += ' z8bmXs182';
    rules += ' y8bmXs182';
    rules += ' B8bmXs182';
    rules += ' A8bmXs182';
    return rules;
};
const $41e172257332f72e$var$$b847b7cd294eafba$var$trackStyles = function anonymous(props) {
    let rules = " ";
    rules += ' zMY0fn182';
    rules += ' yMY0fn182';
    rules += ' BMY0fn182';
    rules += ' AMY0fn182';
    if (props.size === "XL") rules += ' Nl182';
    else if (props.size === "L") rules += ' Nj182';
    else if (props.size === "S") rules += ' Nf182';
    else if (props.size === "XS") rules += ' Ne182';
    else rules += ' Nk182';
    if (props.isQuiet) rules += ' _qd182';
    else rules += ' _qtb182';
    if (props.size === "XL") rules += ' -Anxdcc-Zt182';
    else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
    else if (props.size === "S") rules += ' -Anxdcc-Zr182';
    else rules += ' -Anxdcc-Z3fn9H182';
    rules += ' __v6TNLWb182';
    rules += ' _Nc182';
    rules += ' Pc182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    if (props.isStaticColor) rules += ' gh182';
    else rules += ' gE182';
    rules += ' glb182';
    rules += ' _Ma182';
    rules += ' _Mlb182';
    rules += ' _Le182';
    rules += ' _Llf182';
    rules += ' Oj182';
    rules += ' Olb182';
    rules += ' _9c182';
    if (props.size === "XL") rules += ' Fj182';
    else if (props.size === "L") rules += ' Fi182';
    else if (props.size === "M") rules += ' Fg182';
    else if (props.size === "S") rules += ' Fe182';
    else rules += ' Fg182';
    return rules;
};
const $41e172257332f72e$var$$b847b7cd294eafba$var$fill = function anonymous(props) {
    let rules = " ";
    rules += ' Fb182';
    rules += ' _je182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    if (props.isStaticColor) rules += ' gj182';
    else rules += ' g2182';
    rules += ' glc182';
    if (props.isIndeterminate) rules += ' Za182';
    if (props.isIndeterminate) rules += ' _0e182';
    return rules;
};
const $41e172257332f72e$var$$b847b7cd294eafba$var$indeterminateAnimation = function anonymous(props) {
    let rules = " ";
    if (props.direction === "rtl") rules += ' _g2FRDs182';
    else if (props.direction === "ltr") rules += ' _gXZ1Q4d182';
    rules += ' _ea182';
    rules += ' _hb182';
    rules += ' __ea182';
    rules += ' _8d182';
    rules += ' _Pc182';
    return rules;
};
const $41e172257332f72e$export$c17561cb55d4db30 = (0, $eF4cA.forwardRef)(function ProgressBar(props, ref) {
    // oxlint-disable-next-line react/react-compiler
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $41e172257332f72e$export$e9f3bf65a26ce129);
    let { label: label, size: size = 'M', staticColor: staticColor, isIndeterminate: isIndeterminate, labelPosition: labelPosition = 'top', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className = '' } = props;
    let domRef = (0, $3PqDc.useDOMRef)(ref);
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let isStaticColor = !!staticColor;
    return (0, $dx4lB.jsx)((0, $lrZgx.ProgressBar), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + $41e172257332f72e$var$$b847b7cd294eafba$var$wrapper({
            ...props,
            size: size,
            labelPosition: labelPosition,
            staticColor: staticColor
        }, props.styles),
        children: ({ percentage: percentage, valueText: valueText })=>(0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    label && (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        size: size,
                        labelAlign: "start",
                        labelPosition: labelPosition,
                        staticColor: staticColor,
                        children: label
                    }),
                    label && !isIndeterminate && (0, $dx4lB.jsx)("span", {
                        className: $41e172257332f72e$var$$b847b7cd294eafba$var$valueStyles({
                            size: size,
                            labelAlign: 'end',
                            isStaticColor: isStaticColor
                        }),
                        children: valueText
                    }),
                    (0, $dx4lB.jsx)("div", {
                        className: $41e172257332f72e$var$$b847b7cd294eafba$var$trackStyles({
                            isStaticColor: isStaticColor,
                            size: size
                        }),
                        children: (0, $dx4lB.jsx)("div", {
                            className: (0, $5nTep.mergeStyles)($41e172257332f72e$var$$b847b7cd294eafba$var$fill({
                                ...props,
                                isStaticColor: isStaticColor
                            }), isIndeterminate ? $41e172257332f72e$var$$b847b7cd294eafba$var$indeterminateAnimation({
                                direction: direction
                            }) : null),
                            style: {
                                width: isIndeterminate ? undefined : percentage + '%'
                            }
                        })
                    })
                ]
            })
    });
});


var $fZShI = parcelRequire("fZShI");
var $j8RRT = parcelRequire("j8RRT");
var $hSW0F = parcelRequire("hSW0F");


var $grJ6Y = parcelRequire("grJ6Y");

var $kOxgB = parcelRequire("kOxgB");

var $4Dyny = parcelRequire("4Dyny");

var $grJ6Y = parcelRequire("grJ6Y");

var $kOxgB = parcelRequire("kOxgB");

var $aOXCq = parcelRequire("aOXCq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d62d112eefdf931b$export$f7b0c5d28b66b6a5(options, state, ref) {
    let { dropProps: dropProps } = (0, $aOXCq.useVirtualDrop)();
    let droppableCollectionRef = (0, $kOxgB.getDroppableCollectionRef)(state);
    (0, $eF4cA.useEffect)(()=>{
        if (ref.current) return (0, $grJ6Y.registerDropItem)({
            element: ref.current,
            target: options.target,
            getDropOperation (types, allowedOperations) {
                let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
                let isInternal = (0, $kOxgB.isInternalDropOperation)(droppableCollectionRef);
                return state.getDropOperation({
                    target: options.target,
                    types: types,
                    allowedOperations: allowedOperations,
                    isInternal: isInternal,
                    draggingKeys: draggingKeys
                });
            },
            activateButtonRef: options.activateButtonRef
        });
    }, [
        ref,
        options.target,
        state,
        droppableCollectionRef,
        options.activateButtonRef
    ]);
    let dragSession = (0, $grJ6Y.useDragSession)();
    let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
    let isInternal = (0, $kOxgB.isInternalDropOperation)(droppableCollectionRef);
    let isValidDropTarget = dragSession && state.getDropOperation({
        target: options.target,
        types: (0, $kOxgB.getTypes)(dragSession.dragTarget.items),
        allowedOperations: dragSession.dragTarget.allowedDropOperations,
        isInternal: isInternal,
        draggingKeys: draggingKeys
    }) !== 'cancel';
    let isDropTarget = state.isDropTarget(options.target);
    (0, $eF4cA.useEffect)(()=>{
        if (dragSession && isDropTarget && ref.current) ref.current.focus();
    }, [
        isDropTarget,
        dragSession,
        ref
    ]);
    return {
        dropProps: {
            ...dropProps,
            'aria-hidden': !dragSession || isValidDropTarget ? undefined : 'true'
        },
        isDropTarget: isDropTarget
    };
}



var $25dFS = parcelRequire("25dFS");

var $gI8Gw = parcelRequire("gI8Gw");
function $79bc9727ca6c1ff4$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $79bc9727ca6c1ff4$export$8d0e41d2815afac5(props, state, ref) {
    let { target: target } = props;
    let { collection: collection } = state;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($79bc9727ca6c1ff4$var$$parcel$interopDefault((0, $4Dyny.default)), '@react-aria/dnd');
    let dragSession = (0, $grJ6Y.useDragSession)();
    let { dropProps: dropProps } = (0, $d62d112eefdf931b$export$f7b0c5d28b66b6a5)(props, state, ref);
    let id = (0, $25dFS.useId)();
    let getText = (key)=>{
        if (key == null) return '';
        else return collection.getTextValue?.(key) ?? collection.getItem(key)?.textValue ?? '';
    };
    let label = '';
    let labelledBy;
    if (target.type === 'root') {
        label = stringFormatter.format('dropOnRoot');
        labelledBy = `${id} ${(0, $kOxgB.getDroppableCollectionId)(state)}`;
    } else if (target.dropPosition === 'on') label = stringFormatter.format('dropOnItem', {
        itemText: getText(target.key)
    });
    else {
        let before;
        let after;
        if (target.dropPosition === 'before') {
            let prevKey = collection.getItem(target.key)?.prevKey;
            let prevNode = prevKey != null ? collection.getItem(prevKey) : null;
            before = prevNode?.type === 'item' ? prevNode.key : null;
        } else before = target.key;
        if (target.dropPosition === 'after') {
            let nextKey = collection.getItem(target.key)?.nextKey;
            let nextNode = nextKey != null ? collection.getItem(nextKey) : null;
            after = nextNode?.type === 'item' ? nextNode.key : null;
        } else after = target.key;
        if (before != null && after != null) label = stringFormatter.format('insertBetween', {
            beforeItemText: getText(before),
            afterItemText: getText(after)
        });
        else if (before != null) label = stringFormatter.format('insertAfter', {
            itemText: getText(before)
        });
        else if (after != null) label = stringFormatter.format('insertBefore', {
            itemText: getText(after)
        });
    }
    let isDropTarget = state.isDropTarget(target);
    let ariaHidden = !dragSession ? 'true' : dropProps['aria-hidden'];
    return {
        dropIndicatorProps: {
            ...dropProps,
            id: id,
            'aria-roledescription': stringFormatter.format('dropIndicator'),
            'aria-label': label,
            'aria-labelledby': labelledBy,
            'aria-hidden': ariaHidden,
            tabIndex: -1
        },
        isDropTarget: isDropTarget,
        // If aria-hidden, we are either not in a drag session or the drop target is invalid.
        // In that case, there's no need to render anything at all unless we need to show the indicator visually.
        // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
        isHidden: !isDropTarget && !!ariaHidden
    };
}


var $kOxgB = parcelRequire("kOxgB");

var $grJ6Y = parcelRequire("grJ6Y");

var $lhKAD = parcelRequire("lhKAD");
function $acd3895d6e9fd45b$export$ff7962acd6052c28(keyboardDelegate, collection, target, direction, rtl = false, wrap = false) {
    switch(direction){
        case 'left':
            return rtl ? $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$nextDropTarget(keyboardDelegate, collection, target, wrap, 'left') : $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$previousDropTarget(keyboardDelegate, collection, target, wrap, 'left');
        case 'right':
            return rtl ? $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$previousDropTarget(keyboardDelegate, collection, target, wrap, 'right') : $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$nextDropTarget(keyboardDelegate, collection, target, wrap, 'right');
        case 'up':
            return $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$previousDropTarget(keyboardDelegate, collection, target, wrap);
        case 'down':
            return $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$nextDropTarget(keyboardDelegate, collection, target, wrap);
    }
}
function $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$nextDropTarget(keyboardDelegate, collection, target, wrap = false, horizontal = null) {
    if (!target) return {
        type: 'root'
    };
    if (target.type === 'root') {
        let nextKey = keyboardDelegate.getFirstKey?.() ?? null;
        if (nextKey != null) return {
            type: 'item',
            key: nextKey,
            dropPosition: 'before'
        };
        return null;
    }
    if (target.type === 'item') {
        let nextKey = null;
        if (horizontal) nextKey = horizontal === 'right' ? keyboardDelegate.getKeyRightOf?.(target.key, {
            includeDisabled: true
        }) : keyboardDelegate.getKeyLeftOf?.(target.key, {
            includeDisabled: true
        });
        else nextKey = keyboardDelegate.getKeyBelow?.(target.key, {
            includeDisabled: true
        });
        let nextCollectionKey = $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getNextItem(collection, target.key, (key)=>collection.getKeyAfter(key));
        // If the keyboard delegate did not move to the next key in the collection,
        // jump to that key with the same drop position. Otherwise, try the other
        // drop positions on the current key first.
        if (nextKey != null && nextKey !== nextCollectionKey) return {
            type: 'item',
            key: nextKey,
            dropPosition: target.dropPosition
        };
        switch(target.dropPosition){
            case 'before':
                return {
                    type: 'item',
                    key: target.key,
                    dropPosition: 'on'
                };
            case 'on':
                {
                    // If there are nested items, traverse to them prior to the "after" position of this target.
                    // If the next key is on the same level, then its "before" position is equivalent to this item's "after" position.
                    let targetNode = collection.getItem(target.key);
                    let nextNode = nextKey != null ? collection.getItem(nextKey) : null;
                    if (targetNode && nextNode && nextNode.level >= targetNode.level) return {
                        type: 'item',
                        key: nextNode.key,
                        dropPosition: 'before'
                    };
                    return {
                        type: 'item',
                        key: target.key,
                        dropPosition: 'after'
                    };
                }
            case 'after':
                {
                    // If this is the last sibling in a level, traverse to the parent.
                    let targetNode = collection.getItem(target.key);
                    let nextItemInSameLevel = targetNode?.nextKey != null ? collection.getItem(targetNode.nextKey) : null;
                    while(nextItemInSameLevel != null && nextItemInSameLevel.type !== 'item')nextItemInSameLevel = nextItemInSameLevel.nextKey != null ? collection.getItem(nextItemInSameLevel.nextKey) : null;
                    if (targetNode && nextItemInSameLevel == null && targetNode.parentKey != null) {
                        // If the parent item has an item after it, use the "before" position.
                        let parentNode = collection.getItem(targetNode.parentKey);
                        const nextNode = parentNode?.nextKey != null ? collection.getItem(parentNode.nextKey) : null;
                        if (nextNode?.type === 'item') return {
                            type: 'item',
                            key: nextNode.key,
                            dropPosition: 'before'
                        };
                        if (parentNode?.type === 'item') return {
                            type: 'item',
                            key: parentNode.key,
                            dropPosition: 'after'
                        };
                    }
                    if (nextItemInSameLevel) return {
                        type: 'item',
                        key: nextItemInSameLevel.key,
                        dropPosition: 'on'
                    };
                }
        }
    }
    if (wrap) return {
        type: 'root'
    };
    return null;
}
function $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$previousDropTarget(keyboardDelegate, collection, target, wrap = false, horizontal = null) {
    // Start after the last root-level item.
    if (!target || wrap && target.type === 'root') {
        // Keyboard delegate gets the deepest item but we want the shallowest.
        let prevKey = null;
        let lastKey = keyboardDelegate.getLastKey?.();
        while(lastKey != null){
            let node = collection.getItem(lastKey);
            if (node?.type !== 'item') break;
            prevKey = lastKey;
            lastKey = node?.parentKey;
        }
        if (prevKey != null) return {
            type: 'item',
            key: prevKey,
            dropPosition: 'after'
        };
        return null;
    }
    if (target.type === 'item') {
        let prevKey = null;
        if (horizontal) prevKey = horizontal === 'left' ? keyboardDelegate.getKeyLeftOf?.(target.key, {
            includeDisabled: true
        }) : keyboardDelegate.getKeyRightOf?.(target.key, {
            includeDisabled: true
        });
        else prevKey = keyboardDelegate.getKeyAbove?.(target.key, {
            includeDisabled: true
        });
        let prevCollectionKey = $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getNextItem(collection, target.key, (key)=>collection.getKeyBefore(key));
        // If the keyboard delegate did not move to the next key in the collection,
        // jump to that key with the same drop position. Otherwise, try the other
        // drop positions on the current key first.
        if (prevKey != null && prevKey !== prevCollectionKey) return {
            type: 'item',
            key: prevKey,
            dropPosition: target.dropPosition
        };
        switch(target.dropPosition){
            case 'before':
                {
                    // Move after the last child of the previous item.
                    let targetNode = collection.getItem(target.key);
                    if (targetNode && targetNode.prevKey != null) {
                        let lastChild = $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getLastChild(collection, targetNode.prevKey);
                        if (lastChild) return lastChild;
                    }
                    if (prevKey != null) return {
                        type: 'item',
                        key: prevKey,
                        dropPosition: 'on'
                    };
                    return {
                        type: 'root'
                    };
                }
            case 'on':
                return {
                    type: 'item',
                    key: target.key,
                    dropPosition: 'before'
                };
            case 'after':
                {
                    // Move after the last child of this item.
                    let lastChild = $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getLastChild(collection, target.key);
                    if (lastChild) return lastChild;
                    return {
                        type: 'item',
                        key: target.key,
                        dropPosition: 'on'
                    };
                }
        }
    }
    if (target.type !== 'root') return {
        type: 'root'
    };
    return null;
}
function $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getLastChild(collection, key) {
    // getChildNodes still returns child tree items even when the item is collapsed.
    // Checking if the next item has a greater level is a silly way to determine if the item is expanded.
    let targetNode = collection.getItem(key);
    let nextKey = $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getNextItem(collection, key, (key)=>collection.getKeyAfter(key));
    let nextNode = nextKey != null ? collection.getItem(nextKey) : null;
    if (targetNode && nextNode && nextNode.level > targetNode.level) {
        let lastChild = null;
        if ('lastChildKey' in targetNode) {
            lastChild = targetNode.lastChildKey != null ? collection.getItem(targetNode.lastChildKey) : null;
            while(lastChild && lastChild.type !== 'item' && lastChild.prevKey != null)lastChild = collection.getItem(lastChild.prevKey);
        } else lastChild = Array.from(targetNode.childNodes).findLast((item)=>item.type === 'item') || null;
        if (lastChild) return {
            type: 'item',
            key: lastChild.key,
            dropPosition: 'after'
        };
    }
    return null;
}
// Find the next or previous item in a collection, skipping over other types of nodes (e.g. content).
function $acd3895d6e9fd45b$var$$4ba715d4c7df8887$var$getNextItem(collection, key, getNextKey) {
    let nextCollectionKey = getNextKey(key);
    let nextCollectionNode = nextCollectionKey != null ? collection.getItem(nextCollectionKey) : null;
    while(nextCollectionNode && nextCollectionNode.type !== 'item'){
        nextCollectionKey = getNextKey(nextCollectionNode.key);
        nextCollectionNode = nextCollectionKey != null ? collection.getItem(nextCollectionKey) : null;
    }
    return nextCollectionKey;
}



var $YxOvP = parcelRequire("YxOvP");

var $5AGOf = parcelRequire("5AGOf");

var $11FxZ = parcelRequire("11FxZ");

var $fSNAA = parcelRequire("fSNAA");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $38c69f1c9b7e394b$var$$aa7c06e7625d1455$var$AUTOSCROLL_AREA_SIZE = 20;
function $38c69f1c9b7e394b$export$6323452ca4533ed8(ref) {
    let scrollableRef = (0, $eF4cA.useRef)(null);
    let scrollableX = (0, $eF4cA.useRef)(true);
    let scrollableY = (0, $eF4cA.useRef)(true);
    (0, $eF4cA.useEffect)(()=>{
        if (ref.current) {
            scrollableRef.current = (0, $fSNAA.isScrollable)(ref.current) ? ref.current : (0, $5AGOf.getScrollParent)(ref.current);
            let style = window.getComputedStyle(scrollableRef.current);
            scrollableX.current = /(auto|scroll)/.test(style.overflowX);
            scrollableY.current = /(auto|scroll)/.test(style.overflowY);
        }
    }, [
        ref
    ]);
    // oxlint-disable-next-line react/react-compiler
    let state = (0, $eF4cA.useRef)({
        timer: undefined,
        dx: 0,
        dy: 0
    }).current;
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (state.timer) {
                cancelAnimationFrame(state.timer);
                state.timer = undefined;
            }
        };
    // state will become a new object, so it's ok to use in the dependency array for unmount
    }, [
        state
    ]);
    let scroll = (0, $eF4cA.useCallback)(()=>{
        if (scrollableX.current && scrollableRef.current) scrollableRef.current.scrollLeft += state.dx;
        if (scrollableY.current && scrollableRef.current) scrollableRef.current.scrollTop += state.dy;
        if (state.timer) state.timer = requestAnimationFrame(scroll);
    }, [
        scrollableRef,
        state
    ]);
    return {
        move (x, y) {
            // Most browsers auto scroll natively, but WebKit on macOS does not (iOS does 🤷‍♂️).
            // https://bugs.webkit.org/show_bug.cgi?id=222636
            if (!(0, $11FxZ.isWebKit)() || (0, $11FxZ.isIOS)() || !scrollableRef.current) return;
            let box = scrollableRef.current.getBoundingClientRect();
            let left = $38c69f1c9b7e394b$var$$aa7c06e7625d1455$var$AUTOSCROLL_AREA_SIZE;
            let top = $38c69f1c9b7e394b$var$$aa7c06e7625d1455$var$AUTOSCROLL_AREA_SIZE;
            let bottom = box.height - $38c69f1c9b7e394b$var$$aa7c06e7625d1455$var$AUTOSCROLL_AREA_SIZE;
            let right = box.width - $38c69f1c9b7e394b$var$$aa7c06e7625d1455$var$AUTOSCROLL_AREA_SIZE;
            if (x < left || x > right || y < top || y > bottom) {
                if (x < left) state.dx = x - left;
                else if (x > right) state.dx = x - right;
                if (y < top) state.dy = y - top;
                else if (y > bottom) state.dy = y - bottom;
                if (!state.timer) state.timer = requestAnimationFrame(scroll);
            } else this.stop();
        },
        stop () {
            if (state.timer) {
                cancelAnimationFrame(state.timer);
                state.timer = undefined;
            }
        }
    };
}



var $OwH9B = parcelRequire("OwH9B");

var $25dFS = parcelRequire("25dFS");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b0d7ca4f5fb8e6b3$export$f4e2f423c21f7b04(props, state, ref) {
    // oxlint-disable-next-line react/react-compiler
    let localState = (0, $eF4cA.useRef)({
        props: props,
        state: state,
        nextTarget: null,
        dropOperation: null
    }).current;
    localState.props = props;
    localState.state = state;
    let defaultOnDrop = (0, $eF4cA.useCallback)(async (e)=>{
        let { onInsert: onInsert, onRootDrop: onRootDrop, onItemDrop: onItemDrop, onReorder: onReorder, onMove: onMove, acceptedDragTypes: acceptedDragTypes = 'all', shouldAcceptItemDrop: shouldAcceptItemDrop } = localState.props;
        let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
        let isInternal = (0, $kOxgB.isInternalDropOperation)(ref);
        let { target: target, dropOperation: dropOperation, items: items } = e;
        let filteredItems = items;
        if (acceptedDragTypes !== 'all' || shouldAcceptItemDrop) filteredItems = items.filter((item)=>{
            let itemTypes;
            if (item.kind === 'directory') itemTypes = new Set([
                (0, $kOxgB.DIRECTORY_DRAG_TYPE)
            ]);
            else itemTypes = item.kind === 'file' ? new Set([
                item.type
            ]) : item.types;
            // oxlint-disable-next-line react/react-compiler
            if (acceptedDragTypes === 'all' || acceptedDragTypes.some((type)=>itemTypes.has(type))) {
                // If we are performing a on item drop, check if the item in question accepts the dropped item since the item may have heavier restrictions
                // than the droppable collection itself
                if (target.type === 'item' && target.dropPosition === 'on' && shouldAcceptItemDrop) return shouldAcceptItemDrop(target, itemTypes);
                return true;
            }
            return false;
        });
        if (filteredItems.length > 0) {
            if (target.type === 'root' && onRootDrop) await onRootDrop({
                items: filteredItems,
                dropOperation: dropOperation
            });
            if (target.type === 'item') {
                if (target.dropPosition === 'on' && onItemDrop) await onItemDrop({
                    items: filteredItems,
                    dropOperation: dropOperation,
                    isInternal: isInternal,
                    target: target
                });
                if (onMove && isInternal) await onMove({
                    keys: draggingKeys,
                    dropOperation: dropOperation,
                    target: target
                });
                if (target.dropPosition !== 'on') {
                    if (!isInternal && onInsert) await onInsert({
                        items: filteredItems,
                        dropOperation: dropOperation,
                        target: target
                    });
                    if (isInternal && onReorder) await onReorder({
                        keys: draggingKeys,
                        dropOperation: dropOperation,
                        target: target
                    });
                }
            }
        }
    }, [
        localState,
        ref
    ]);
    let autoScroll = (0, $38c69f1c9b7e394b$export$6323452ca4533ed8)(ref);
    let { dropProps: dropProps } = (0, $OwH9B.useDrop)({
        ref: ref,
        onDropEnter () {
            if (localState.nextTarget != null) state.setTarget(localState.nextTarget);
        },
        onDropMove (e) {
            if (localState.nextTarget != null) state.setTarget(localState.nextTarget);
            autoScroll.move(e.x, e.y);
        },
        getDropOperationForPoint (types, allowedOperations, x, y) {
            let { draggingKeys: draggingKeys, dropCollectionRef: dropCollectionRef } = (0, $kOxgB.globalDndState);
            let isInternal = (0, $kOxgB.isInternalDropOperation)(ref);
            let isValidDropTarget = (target)=>state.getDropOperation({
                    target: target,
                    types: types,
                    allowedOperations: allowedOperations,
                    isInternal: isInternal,
                    draggingKeys: draggingKeys
                }) !== 'cancel';
            let target = props.dropTargetDelegate.getDropTargetFromPoint(x, y, isValidDropTarget);
            if (!target) {
                localState.dropOperation = 'cancel';
                localState.nextTarget = null;
                return 'cancel';
            }
            localState.dropOperation = state.getDropOperation({
                target: target,
                types: types,
                allowedOperations: allowedOperations,
                isInternal: isInternal,
                draggingKeys: draggingKeys
            });
            // If the target doesn't accept the drop, see if the root accepts it instead.
            if (localState.dropOperation === 'cancel') {
                let rootTarget = {
                    type: 'root'
                };
                let dropOperation = state.getDropOperation({
                    target: rootTarget,
                    types: types,
                    allowedOperations: allowedOperations,
                    isInternal: isInternal,
                    draggingKeys: draggingKeys
                });
                if (dropOperation !== 'cancel') {
                    target = rootTarget;
                    localState.dropOperation = dropOperation;
                }
            }
            // Only set dropCollectionRef if there is a valid drop target since we cleanup dropCollectionRef in onDropExit
            // which only runs when leaving a valid drop target or if the dropEffect become none (mouse dnd only).
            if (target && localState.dropOperation !== 'cancel' && ref?.current !== dropCollectionRef?.current) (0, $kOxgB.setDropCollectionRef)(ref);
            localState.nextTarget = localState.dropOperation === 'cancel' ? null : target;
            return localState.dropOperation;
        },
        onDropExit () {
            (0, $kOxgB.setDropCollectionRef)(undefined);
            state.setTarget(null);
            autoScroll.stop();
        },
        onDropActivate (e) {
            if (state.target?.type === 'item' && typeof props.onDropActivate === 'function') props.onDropActivate({
                type: 'dropactivate',
                x: e.x,
                y: e.y,
                target: state.target
            });
        },
        onDrop (e) {
            (0, $kOxgB.setDropCollectionRef)(ref);
            if (state.target) onDrop(e, state.target);
            // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
            // RSP collection and thus we don't need to preserve the global DnD state for onDragEnd
            let { draggingCollectionRef: draggingCollectionRef } = (0, $kOxgB.globalDndState);
            if (draggingCollectionRef == null) (0, $kOxgB.clearGlobalDnDState)();
        }
    });
    let droppingState = (0, $eF4cA.useRef)(null);
    let updateFocusAfterDrop = (0, $eF4cA.useCallback)(()=>{
        let { state: state } = localState;
        if (droppingState.current) {
            let { target: target, collection: prevCollection, selectedKeys: prevSelectedKeys, focusedKey: prevFocusedKey, isInternal: isInternal, draggingKeys: draggingKeys } = droppingState.current;
            // If an insert occurs during a drop, we want to immediately select these items to give
            // feedback to the user that a drop occurred. Only do this if the selection didn't change
            // since the drop started so we don't override if the user or application did something.
            if (state.collection.size > prevCollection.size && state.selectionManager.isSelectionEqual(prevSelectedKeys)) {
                let newKeys = new Set();
                let key = state.collection.getFirstKey();
                while(key != null){
                    let item = state.collection.getItem(key);
                    if (item?.type === 'item' && !prevCollection.getItem(item.key)) newKeys.add(item.key);
                    if (item?.hasChildNodes && state.collection.getItem(item.lastChildKey)?.type === 'item') key = item.firstChildKey;
                    else key = state.collection.getKeyAfter(key);
                }
                state.selectionManager.setSelectedKeys(newKeys);
                // If the focused item didn't change since the drop occurred, also focus the first
                // inserted item. If selection is disabled, then also show the focus ring so there
                // is some indication that items were added.
                if (state.selectionManager.focusedKey === prevFocusedKey) {
                    let first = newKeys.keys().next().value;
                    if (first != null) {
                        let item = state.collection.getItem(first);
                        let dropTarget = droppingState.current.target;
                        let isParentRowExpanded = state.collection['expandedKeys'] ? state.collection['expandedKeys'].has(item?.parentKey) : false;
                        // If this is a cell, focus the parent row.
                        // eslint-disable-next-line max-depth
                        if (item && (item?.type === 'cell' || dropTarget.type === 'item' && dropTarget.dropPosition === 'on' && !isParentRowExpanded)) first = item.parentKey;
                        // eslint-disable-next-line max-depth
                        if (first != null) state.selectionManager.setFocusedKey(first);
                        // eslint-disable-next-line max-depth
                        if (state.selectionManager.selectionMode === 'none') (0, $YxOvP.setInteractionModality)('keyboard');
                    }
                }
            } else if (prevFocusedKey != null && state.selectionManager.focusedKey === prevFocusedKey && isInternal && target.type === 'item' && target.dropPosition !== 'on' && draggingKeys.has(state.collection.getItem(prevFocusedKey)?.parentKey)) {
                // Focus row instead of cell when reordering.
                state.selectionManager.setFocusedKey(state.collection.getItem(prevFocusedKey)?.parentKey ?? null);
                (0, $YxOvP.setInteractionModality)('keyboard');
            } else if (state.selectionManager.focusedKey === prevFocusedKey && target.type === 'item' && target.dropPosition === 'on' && state.collection.getItem(target.key) != null) {
                // If focus didn't move already (e.g. due to an insert), and the user dropped on an item,
                // focus that item and show the focus ring to give the user feedback that the drop occurred.
                // Also show the focus ring if the focused key is not selected, e.g. in case of a reorder.
                state.selectionManager.setFocusedKey(target.key);
                (0, $YxOvP.setInteractionModality)('keyboard');
            } else if (state.selectionManager.focusedKey != null && !state.selectionManager.isSelected(state.selectionManager.focusedKey)) (0, $YxOvP.setInteractionModality)('keyboard');
            state.selectionManager.setFocused(true);
        }
    }, [
        localState
    ]);
    let onDrop = (0, $eF4cA.useCallback)((e, target)=>{
        let { state: state } = localState;
        // Save some state of the collection/selection before the drop occurs so we can compare later.
        droppingState.current = {
            timeout: undefined,
            focusedKey: state.selectionManager.focusedKey,
            collection: state.collection,
            selectedKeys: state.selectionManager.selectedKeys,
            draggingKeys: (0, $kOxgB.globalDndState).draggingKeys,
            isInternal: (0, $kOxgB.isInternalDropOperation)(ref),
            target: target
        };
        let onDropFn = localState.props.onDrop || defaultOnDrop;
        onDropFn({
            type: 'drop',
            x: e.x,
            y: e.y,
            target: target,
            items: e.items,
            dropOperation: e.dropOperation
        });
        // Wait for a short time period after the onDrop is called to allow the data to be read asynchronously
        // and for React to re-render. If the collection didn't already change during this time (handled below),
        // update the focused key here.
        droppingState.current.timeout = setTimeout(()=>{
            updateFocusAfterDrop();
            droppingState.current = null;
        }, 50);
    }, [
        localState,
        defaultOnDrop,
        ref,
        updateFocusAfterDrop
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (droppingState.current) clearTimeout(droppingState.current.timeout);
        };
    }, []);
    (0, $4skXn.useLayoutEffect)(()=>{
        // If the collection changed after a drop, update the focused key.
        if (droppingState.current && state.collection !== droppingState.current.collection) updateFocusAfterDrop();
    });
    let { direction: direction } = (0, $1ntKq.useLocale)();
    (0, $eF4cA.useEffect)(()=>{
        if (!ref.current) return;
        let getNextTarget = (target, wrap = true, key = 'down')=>{
            return (0, $acd3895d6e9fd45b$export$ff7962acd6052c28)(localState.props.keyboardDelegate, localState.state.collection, target, key, direction === 'rtl', wrap);
        };
        let getPreviousTarget = (target, wrap = true)=>{
            return getNextTarget(target, wrap, 'up');
        };
        let nextValidTarget = (target, types, allowedDropOperations, getNextTarget, wrap = true)=>{
            let seenRoot = 0;
            let operation;
            let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
            let isInternal = (0, $kOxgB.isInternalDropOperation)(ref);
            do {
                let nextTarget = getNextTarget(target, wrap);
                if (!nextTarget) return null;
                target = nextTarget;
                operation = localState.state.getDropOperation({
                    target: nextTarget,
                    types: types,
                    allowedOperations: allowedDropOperations,
                    isInternal: isInternal,
                    draggingKeys: draggingKeys
                });
                if (target.type === 'root') seenRoot++;
            }while (operation === 'cancel' && !localState.state.isDropTarget(target) && seenRoot < 2);
            if (operation === 'cancel') return null;
            return target;
        };
        return (0, $grJ6Y.registerDropTarget)({
            element: ref.current,
            preventFocusOnDrop: true,
            getDropOperation (types, allowedOperations) {
                if (localState.state.target) {
                    let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
                    let isInternal = (0, $kOxgB.isInternalDropOperation)(ref);
                    return localState.state.getDropOperation({
                        target: localState.state.target,
                        types: types,
                        allowedOperations: allowedOperations,
                        isInternal: isInternal,
                        draggingKeys: draggingKeys
                    });
                }
                // Check if any of the targets accept the drop.
                // TODO: should we have a faster way of doing this or e.g. for pagination?
                let target = nextValidTarget(null, types, allowedOperations, getNextTarget);
                return target ? 'move' : 'cancel';
            },
            onDropEnter (e, drag) {
                let types = (0, $kOxgB.getTypes)(drag.items);
                let selectionManager = localState.state.selectionManager;
                let target = null;
                (0, $kOxgB.setDropCollectionRef)(ref);
                // When entering the droppable collection for the first time, the default drop target
                // is after the focused key.
                let key = selectionManager.focusedKey;
                let dropPosition = 'after';
                // If the focused key is a cell, get the parent item instead.
                // For now, we assume that individual cells cannot be dropped on.
                let item = key != null ? localState.state.collection.getItem(key) : null;
                if (item?.type === 'cell') key = item.parentKey;
                // If the focused item is also selected, the default drop target is after the last selected item.
                // But if the focused key is the first selected item, then default to before the first selected item.
                // This is to make reordering lists slightly easier. If you select top down, we assume you want to
                // move the items down. If you select bottom up, we assume you want to move the items up.
                if (key != null && selectionManager.isSelected(key)) {
                    if (selectionManager.selectedKeys.size > 1 && selectionManager.firstSelectedKey === key) dropPosition = 'before';
                    else key = selectionManager.lastSelectedKey;
                }
                if (key != null) {
                    target = {
                        type: 'item',
                        key: key,
                        dropPosition: dropPosition
                    };
                    let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
                    let isInternal = (0, $kOxgB.isInternalDropOperation)(ref);
                    // If the default target is not valid, find the next one that is.
                    if (localState.state.getDropOperation({
                        target: target,
                        types: types,
                        allowedOperations: drag.allowedDropOperations,
                        isInternal: isInternal,
                        draggingKeys: draggingKeys
                    }) === 'cancel') target = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false) ?? nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
                }
                // If no focused key, then start from the root.
                if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
                localState.state.setTarget(target);
            },
            onDropExit () {
                (0, $kOxgB.setDropCollectionRef)(undefined);
                localState.state.setTarget(null);
            },
            onDropTargetEnter (target) {
                localState.state.setTarget(target);
            },
            onDropActivate (e, target) {
                if (target?.type === 'item' && target?.dropPosition === 'on' && typeof localState.props.onDropActivate === 'function') localState.props.onDropActivate({
                    type: 'dropactivate',
                    x: e.x,
                    y: e.y,
                    target: target
                });
            },
            onDrop (e, target) {
                (0, $kOxgB.setDropCollectionRef)(ref);
                if (localState.state.target) onDrop(e, target || localState.state.target);
            },
            onKeyDown (e, drag) {
                let { keyboardDelegate: keyboardDelegate } = localState.props;
                let types = (0, $kOxgB.getTypes)(drag.items);
                switch(e.key){
                    case 'ArrowDown':
                        if (keyboardDelegate.getKeyBelow) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap)=>getNextTarget(target, wrap, 'down'));
                            localState.state.setTarget(target);
                        }
                        break;
                    case 'ArrowUp':
                        if (keyboardDelegate.getKeyAbove) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap)=>getNextTarget(target, wrap, 'up'));
                            localState.state.setTarget(target);
                        }
                        break;
                    case 'ArrowLeft':
                        if (keyboardDelegate.getKeyLeftOf) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap)=>getNextTarget(target, wrap, 'left'));
                            localState.state.setTarget(target);
                        }
                        break;
                    case 'ArrowRight':
                        if (keyboardDelegate.getKeyRightOf) {
                            let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap)=>getNextTarget(target, wrap, 'right'));
                            localState.state.setTarget(target);
                        }
                        break;
                    case 'Home':
                        if (keyboardDelegate.getFirstKey) {
                            let target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
                            localState.state.setTarget(target);
                        }
                        break;
                    case 'End':
                        if (keyboardDelegate.getLastKey) {
                            let target = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
                            localState.state.setTarget(target);
                        }
                        break;
                    case 'PageDown':
                        if (keyboardDelegate.getKeyPageBelow) {
                            let target = localState.state.target;
                            if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
                            else {
                                // If on the root, go to the item a page below the top. Otherwise a page below the current item.
                                let targetKey = keyboardDelegate.getFirstKey?.();
                                if (target.type === 'item') targetKey = target.key;
                                let nextKey = null;
                                if (targetKey != null) nextKey = keyboardDelegate.getKeyPageBelow(targetKey);
                                let dropPosition = target.type === 'item' ? target.dropPosition : 'after';
                                // If there is no next key, or we are starting on the last key, jump to the last possible position.
                                if (nextKey == null || target.type === 'item' && target.key === keyboardDelegate.getLastKey?.()) {
                                    nextKey = keyboardDelegate.getLastKey?.() ?? null;
                                    dropPosition = 'after';
                                }
                                if (nextKey == null) break;
                                target = {
                                    type: 'item',
                                    key: nextKey,
                                    dropPosition: dropPosition
                                };
                                // If the target does not accept the drop, find the next valid target.
                                // If no next valid target, find the previous valid target.
                                let { draggingCollectionRef: draggingCollectionRef, draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
                                let isInternal = draggingCollectionRef?.current === ref?.current;
                                let operation = localState.state.getDropOperation({
                                    target: target,
                                    types: types,
                                    allowedOperations: drag.allowedDropOperations,
                                    isInternal: isInternal,
                                    draggingKeys: draggingKeys
                                });
                                if (operation === 'cancel') target = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false) ?? nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
                            }
                            localState.state.setTarget(target ?? localState.state.target);
                        }
                        break;
                    case 'PageUp':
                        {
                            if (!keyboardDelegate.getKeyPageAbove) break;
                            let target = localState.state.target;
                            if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
                            else if (target.type === 'item') {
                                // If at the top already, switch to the root. Otherwise navigate a page up.
                                if (target.key === keyboardDelegate.getFirstKey?.()) target = {
                                    type: 'root'
                                };
                                else {
                                    let nextKey = keyboardDelegate.getKeyPageAbove(target.key);
                                    let dropPosition = target.dropPosition;
                                    if (nextKey == null) {
                                        nextKey = keyboardDelegate.getFirstKey?.();
                                        dropPosition = 'before';
                                    }
                                    if (nextKey == null) break;
                                    target = {
                                        type: 'item',
                                        key: nextKey,
                                        dropPosition: dropPosition
                                    };
                                }
                                // If the target does not accept the drop, find the previous valid target.
                                // If no next valid target, find the next valid target.
                                let { draggingKeys: draggingKeys } = (0, $kOxgB.globalDndState);
                                let isInternal = (0, $kOxgB.isInternalDropOperation)(ref);
                                let operation = localState.state.getDropOperation({
                                    target: target,
                                    types: types,
                                    allowedOperations: drag.allowedDropOperations,
                                    isInternal: isInternal,
                                    draggingKeys: draggingKeys
                                });
                                if (operation === 'cancel') target = nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false) ?? nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false);
                            }
                            localState.state.setTarget(target ?? localState.state.target);
                            break;
                        }
                }
                localState.props.onKeyDown?.(e);
            }
        });
    // oxlint-disable-next-line react/react-compiler
    }, [
        localState,
        ref,
        onDrop,
        direction
    ]);
    let id = (0, $25dFS.useId)();
    (0, $kOxgB.droppableCollectionMap).set(state, {
        id: id,
        ref: ref
    });
    return {
        collectionProps: (0, $lhKAD.mergeProps)(dropProps, {
            id: id,
            // Remove description from collection element. If dropping on the entire collection,
            // there should be a drop indicator that has this description, so no need to double announce.
            'aria-describedby': null
        })
    };
}



var $l19Vn = parcelRequire("l19Vn");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $789b02091692ade5$export$905ab40ac2179daa = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).forwardRef(function DragPreview(props, ref) {
    let render = props.children;
    let [children, setChildren] = (0, $eF4cA.useState)(null);
    let domRef = (0, $eF4cA.useRef)(null);
    let raf = (0, $eF4cA.useRef)(undefined);
    (0, $eF4cA.useImperativeHandle)(ref, ()=>(items, callback)=>{
            // This will be called during the onDragStart event by useDrag. We need to render the
            // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
            let result = render(items);
            let element;
            let offsetX;
            let offsetY;
            if (result && typeof result === 'object' && 'element' in result) {
                element = result.element;
                offsetX = result.x;
                offsetY = result.y;
            } else element = result;
            (0, $l19Vn.flushSync)(()=>{
                setChildren(element);
            });
            // Yield back to useDrag to set the drag image.
            callback(domRef.current, offsetX, offsetY);
            // Remove the preview from the DOM after a frame so the browser has time to paint.
            raf.current = requestAnimationFrame(()=>{
                setChildren(null);
            });
        }, [
        render
    ]);
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        style: {
            zIndex: -100,
            position: 'fixed',
            top: 0,
            left: -100000
        },
        ref: domRef
    }, children);
});


var $kOxgB = parcelRequire("kOxgB");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8093d795b94b5335$export$2962a7984b2f0a80(props, state, ref) {
    // Update global DnD state if this keys within this collection are dragged
    let { draggingCollectionRef: draggingCollectionRef } = (0, $kOxgB.globalDndState);
    if (state.draggingKeys.size > 0 && draggingCollectionRef?.current !== ref.current) (0, $kOxgB.setDraggingCollectionRef)(ref);
}


var $kOxgB = parcelRequire("kOxgB");

var $4Dyny = parcelRequire("4Dyny");

var $lXRQr = parcelRequire("lXRQr");

var $grJ6Y = parcelRequire("grJ6Y");

var $gEvlw = parcelRequire("gEvlw");

var $fvyIQ = parcelRequire("fvyIQ");

var $kOxgB = parcelRequire("kOxgB");

var $4Dyny = parcelRequire("4Dyny");

var $11FxZ = parcelRequire("11FxZ");

var $9J8wU = parcelRequire("9J8wU");

var $lXRQr = parcelRequire("lXRQr");

var $ed0Y6 = parcelRequire("ed0Y6");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $434bcc9dbe50c529$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $434bcc9dbe50c529$var$$74812c42150b3de8$var$MESSAGES = {
    keyboard: {
        start: 'dragDescriptionKeyboard',
        end: 'endDragKeyboard'
    },
    touch: {
        start: 'dragDescriptionTouch',
        end: 'endDragTouch'
    },
    virtual: {
        start: 'dragDescriptionVirtual',
        end: 'endDragVirtual'
    }
};
function $434bcc9dbe50c529$export$7941f8aafa4b6021(options) {
    let { hasDragButton: hasDragButton, isDisabled: isDisabled } = options;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($434bcc9dbe50c529$var$$parcel$interopDefault((0, $4Dyny.default)), '@react-aria/dnd');
    // oxlint-disable-next-line react/react-compiler
    let state = (0, $eF4cA.useRef)({
        options: options,
        x: 0,
        y: 0
    }).current;
    state.options = options;
    let isDraggingRef = (0, $eF4cA.useRef)(null);
    let [isDragging, setDraggingState] = (0, $eF4cA.useState)(false);
    let setDragging = (element)=>{
        isDraggingRef.current = element;
        setDraggingState(!!element);
    };
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $ed0Y6.useGlobalListeners)();
    let modalityOnPointerDown = (0, $eF4cA.useRef)(null);
    let onDragStart = (e)=>{
        if (e.defaultPrevented) return;
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
        if (modalityOnPointerDown.current === 'virtual') {
            e.preventDefault();
            startDragging((0, $fvyIQ.getEventTarget)(e));
            modalityOnPointerDown.current = null;
            return;
        }
        if (typeof options.onDragStart === 'function') options.onDragStart({
            type: 'dragstart',
            x: e.clientX,
            y: e.clientY
        });
        let items = options.getItems();
        // Clear existing data (e.g. selected text on the page would be included in some browsers)
        e.dataTransfer.clearData?.();
        (0, $kOxgB.writeToDataTransfer)(e.dataTransfer, items);
        let allowed = (0, $gEvlw.DROP_OPERATION).all;
        if (typeof options.getAllowedDropOperations === 'function') {
            let allowedOperations = options.getAllowedDropOperations();
            allowed = (0, $gEvlw.DROP_OPERATION).none;
            for (let operation of allowedOperations)allowed |= (0, $gEvlw.DROP_OPERATION)[operation] || (0, $gEvlw.DROP_OPERATION).none;
        }
        (0, $kOxgB.setGlobalAllowedDropOperations)(allowed);
        let effectAllowed = (0, $gEvlw.EFFECT_ALLOWED)[allowed] || 'none';
        e.dataTransfer.effectAllowed = effectAllowed === 'cancel' ? 'none' : effectAllowed;
        // If there is a preview option, use it to render a custom preview image that will
        // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
        if (typeof options.preview?.current === 'function') options.preview.current(items, (node, userX, userY)=>{
            if (!node) return;
            // Compute the offset that the preview will appear under the mouse.
            // If possible, this is based on the point the user clicked on the target.
            // If the preview is much smaller, then just use the center point of the preview.
            let size = node.getBoundingClientRect();
            let rect = e.currentTarget.getBoundingClientRect();
            let defaultX = e.clientX - rect.x;
            let defaultY = e.clientY - rect.y;
            if (defaultX > size.width || defaultY > size.height) {
                defaultX = size.width / 2;
                defaultY = size.height / 2;
            }
            // Start with default offsets.
            let offsetX = defaultX;
            let offsetY = defaultY;
            // If the preview renderer supplied explicit offsets, use those.
            if (typeof userX === 'number' && typeof userY === 'number') {
                offsetX = userX;
                offsetY = userY;
            }
            // Clamp the offset so it stays within the preview bounds. Browsers
            // automatically clamp out-of-range values, but doing it ourselves
            // prevents the visible "snap" that can occur when the browser adjusts
            // them after the first drag update.
            offsetX = Math.max(0, Math.min(offsetX, size.width));
            offsetY = Math.max(0, Math.min(offsetY, size.height));
            // Rounding height to an even number prevents blurry preview seen on some screens
            let height = 2 * Math.round(size.height / 2);
            node.style.height = `${height}px`;
            e.dataTransfer.setDragImage(node, offsetX, offsetY);
        });
        // Enforce that drops are handled by useDrop.
        addGlobalListener(window, 'drop', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            console.warn('Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.');
        }, {
            once: true
        });
        state.x = e.clientX;
        state.y = e.clientY;
        // Wait a frame before we set dragging to true so that the browser has time to
        // render the preview image before we update the element that has been dragged.
        let target = (0, $fvyIQ.getEventTarget)(e);
        requestAnimationFrame(()=>{
            setDragging(target);
        });
    };
    let onDrag = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (e.clientX === state.x && e.clientY === state.y) return;
        if (typeof options.onDragMove === 'function') options.onDragMove({
            type: 'dragmove',
            x: e.clientX,
            y: e.clientY
        });
        state.x = e.clientX;
        state.y = e.clientY;
    };
    let onDragEnd = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (typeof options.onDragEnd === 'function') {
            let event = {
                type: 'dragend',
                x: e.clientX,
                y: e.clientY,
                dropOperation: (0, $gEvlw.DROP_EFFECT_TO_DROP_OPERATION)[e.dataTransfer.dropEffect]
            };
            // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
            // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
            if (0, $kOxgB.globalDropEffect) event.dropOperation = (0, $gEvlw.DROP_EFFECT_TO_DROP_OPERATION)[0, $kOxgB.globalDropEffect];
            options.onDragEnd(event);
        }
        setDragging(null);
        removeAllGlobalListeners();
        (0, $kOxgB.setGlobalAllowedDropOperations)((0, $gEvlw.DROP_OPERATION).none);
        (0, $kOxgB.setGlobalDropEffect)(undefined);
    };
    (0, $eF4cA.useEffect)(()=>{
        return ()=>{
            // Check that the dragged element has actually unmounted from the DOM and not a React Strict Mode false positive.
            // https://github.com/facebook/react/issues/29585
            // React 16 ran effect cleanups before removing elements from the DOM but did not have this issue.
            if (isDraggingRef.current && (!isDraggingRef.current.isConnected || parseInt((0, $eF4cA.version), 10) < 17)) {
                if (typeof state.options.onDragEnd === 'function') {
                    let event = {
                        type: 'dragend',
                        x: 0,
                        y: 0,
                        dropOperation: (0, $gEvlw.DROP_EFFECT_TO_DROP_OPERATION)[(0, $kOxgB.globalDropEffect) || 'none']
                    };
                    state.options.onDragEnd(event);
                }
                setDragging(null);
                (0, $kOxgB.setGlobalAllowedDropOperations)((0, $gEvlw.DROP_OPERATION).none);
                (0, $kOxgB.setGlobalDropEffect)(undefined);
            }
        };
    }, [
        state
    ]);
    let onPress = (e)=>{
        if (e.pointerType !== 'keyboard' && e.pointerType !== 'virtual') return;
        startDragging(e.target);
    };
    let startDragging = (target)=>{
        if (typeof state.options.onDragStart === 'function') {
            let rect = target.getBoundingClientRect();
            state.options.onDragStart({
                type: 'dragstart',
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            });
        }
        (0, $grJ6Y.beginDragging)({
            element: target,
            items: state.options.getItems(),
            allowedDropOperations: typeof state.options.getAllowedDropOperations === 'function' ? state.options.getAllowedDropOperations() : [
                'move',
                'copy',
                'link'
            ],
            onDragEnd (e) {
                setDragging(null);
                if (typeof state.options.onDragEnd === 'function') state.options.onDragEnd(e);
            }
        }, stringFormatter);
        setDragging(target);
    };
    let modality = (0, $kOxgB.useDragModality)();
    let message = !isDragging ? $434bcc9dbe50c529$var$$74812c42150b3de8$var$MESSAGES[modality].start : $434bcc9dbe50c529$var$$74812c42150b3de8$var$MESSAGES[modality].end;
    let descriptionProps = (0, $lXRQr.useDescription)(stringFormatter.format(message));
    let interactions = {};
    if (!hasDragButton) // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = {
        ...descriptionProps,
        onPointerDown (e) {
            modalityOnPointerDown.current = (0, $9J8wU.isVirtualPointerEvent)(e.nativeEvent) ? 'virtual' : e.pointerType;
            // Try to detect virtual drag passthrough gestures.
            if (e.width < 1 && e.height < 1 && (0, $11FxZ.isIOS)() && (0, $11FxZ.isWebKit)()) modalityOnPointerDown.current = 'virtual';
            else {
                let rect = e.currentTarget.getBoundingClientRect();
                let offsetX = e.clientX - rect.x;
                let offsetY = e.clientY - rect.y;
                let centerX = rect.width / 2;
                let centerY = rect.height / 2;
                if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5) modalityOnPointerDown.current = 'virtual';
                else modalityOnPointerDown.current = e.pointerType;
            }
        },
        onKeyDownCapture (e) {
            if ((0, $fvyIQ.getEventTarget)(e) === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        onKeyUpCapture (e) {
            if ((0, $fvyIQ.getEventTarget)(e) === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                startDragging((0, $fvyIQ.getEventTarget)(e));
            }
        },
        onClick (e) {
            // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
            if ((0, $9J8wU.isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === 'virtual') {
                e.preventDefault();
                e.stopPropagation();
                startDragging((0, $fvyIQ.getEventTarget)(e));
            }
        }
    };
    if (isDisabled) return {
        dragProps: {
            draggable: 'false'
        },
        dragButtonProps: {},
        isDragging: false
    };
    return {
        dragProps: {
            ...interactions,
            draggable: 'true',
            onDragStart: onDragStart,
            onDrag: onDrag,
            onDragEnd: onDragEnd
        },
        dragButtonProps: {
            ...descriptionProps,
            onPress: onPress
        },
        isDragging: isDragging
    };
}



var $gI8Gw = parcelRequire("gI8Gw");
function $b6c20cf365ec563b$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b6c20cf365ec563b$var$$54210e90bb2105d5$var$MESSAGES = {
    keyboard: {
        selected: 'dragSelectedKeyboard',
        notSelected: 'dragDescriptionKeyboard'
    },
    touch: {
        selected: 'dragSelectedLongPress',
        notSelected: 'dragDescriptionLongPress'
    },
    virtual: {
        selected: 'dragDescriptionVirtual',
        notSelected: 'dragDescriptionVirtual'
    }
};
function $b6c20cf365ec563b$export$b35afafff42da2d9(props, state) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($b6c20cf365ec563b$var$$parcel$interopDefault((0, $4Dyny.default)), '@react-aria/dnd');
    let isDisabled = state.isDisabled || state.selectionManager.isDisabled(props.key);
    let { dragProps: dragProps, dragButtonProps: dragButtonProps } = (0, $434bcc9dbe50c529$export$7941f8aafa4b6021)({
        getItems () {
            return state.getItems(props.key);
        },
        preview: state.preview,
        getAllowedDropOperations: state.getAllowedDropOperations,
        hasDragButton: props.hasDragButton,
        onDragStart (e) {
            state.startDrag(props.key, e);
            (0, $kOxgB.setDraggingKeys)(state.draggingKeys);
        },
        onDragMove (e) {
            state.moveDrag(e);
        },
        onDragEnd (e) {
            let { dropOperation: dropOperation } = e;
            let isInternal = dropOperation === 'cancel' ? false : (0, $kOxgB.isInternalDropOperation)();
            state.endDrag({
                ...e,
                keys: state.draggingKeys,
                isInternal: isInternal
            });
            (0, $kOxgB.clearGlobalDnDState)();
        }
    });
    let item = state.collection.getItem(props.key);
    let numKeysForDrag = state.getKeysForDrag(props.key).size;
    let isSelected = numKeysForDrag > 1 && state.selectionManager.isSelected(props.key);
    let dragButtonLabel;
    let description;
    // Override description to include selected item count.
    let modality = (0, $kOxgB.useDragModality)();
    if (!props.hasDragButton && state.selectionManager.selectionMode !== 'none') {
        let msg = $b6c20cf365ec563b$var$$54210e90bb2105d5$var$MESSAGES[modality][isSelected ? 'selected' : 'notSelected'];
        if (props.hasAction && modality === 'keyboard') msg += 'Alt';
        if (isSelected) description = stringFormatter.format(msg, {
            count: numKeysForDrag
        });
        else description = stringFormatter.format(msg);
        // Remove the onClick handler from useDrag. Long pressing will be required on touch devices,
        // and NVDA/JAWS are always in forms mode within collection components.
        // oxlint-disable-next-line react/react-compiler
        delete dragProps.onClick;
    } else if (isSelected) dragButtonLabel = stringFormatter.format('dragSelectedItems', {
        count: numKeysForDrag
    });
    else {
        let itemText = state.collection.getTextValue?.(props.key) ?? item?.textValue ?? '';
        dragButtonLabel = stringFormatter.format('dragItem', {
            itemText: itemText
        });
    }
    let descriptionProps = (0, $lXRQr.useDescription)(description);
    if (description) Object.assign(dragProps, descriptionProps);
    if (!props.hasDragButton && props.hasAction) {
        let { onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture } = dragProps;
        if (modality === 'touch') // oxlint-disable-next-line react/react-compiler
        delete dragProps['aria-describedby'];
        // Require Alt key if there is a conflicting action.
        // oxlint-disable-next-line react/react-compiler
        dragProps.onKeyDownCapture = (e)=>{
            if (e.altKey) onKeyDownCapture?.(e);
        };
        // oxlint-disable-next-line react/react-compiler
        dragProps.onKeyUpCapture = (e)=>{
            if (e.altKey) onKeyUpCapture?.(e);
        };
    }
    return {
        dragProps: isDisabled ? {} : dragProps,
        dragButtonProps: {
            ...dragButtonProps,
            isDisabled: isDisabled,
            'aria-label': dragButtonLabel
        }
    };
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1268d37dd6d82e4e$export$29efd034f1d79f81(props) {
    let { getItems: getItems, isDisabled: isDisabled, collection: collection, selectionManager: selectionManager, onDragStart: onDragStart, onDragMove: onDragMove, onDragEnd: onDragEnd, preview: preview, getAllowedDropOperations: getAllowedDropOperations } = props;
    let [, setDragging] = (0, $eF4cA.useState)(false);
    let draggingKeys = (0, $eF4cA.useRef)(new Set());
    let draggedKey = (0, $eF4cA.useRef)(null);
    let getKeys = (key)=>{
        // The clicked item is always added to the drag. If it is selected, then all of the
        // other selected items are also dragged. If it is not selected, then only the clicked
        // item is dragged. This matches native macOS behavior.
        // Additionally, we filter out any keys that are children of any of the other selected keys
        let keys = new Set();
        if (selectionManager.isSelected(key)) for (let currentKey of selectionManager.selectedKeys){
            let node = collection.getItem(currentKey);
            if (node) {
                let isChild = false;
                let parentKey = node.parentKey;
                while(parentKey != null){
                    // eslint-disable-next-line max-depth
                    if (selectionManager.selectedKeys.has(parentKey)) {
                        isChild = true;
                        break;
                    }
                    let parentNode = collection.getItem(parentKey);
                    parentKey = parentNode ? parentNode.parentKey : null;
                }
                if (!isChild) keys.add(currentKey);
            }
        }
        else keys.add(key);
        return keys;
    };
    return {
        collection: collection,
        selectionManager: selectionManager,
        get draggedKey () {
            return draggedKey.current;
        },
        get draggingKeys () {
            return draggingKeys.current;
        },
        isDragging (key) {
            return draggingKeys.current.has(key);
        },
        getKeysForDrag: getKeys,
        getItems (key) {
            let keys = getKeys(key);
            let items = [];
            for (let key of keys){
                let value = collection.getItem(key)?.value;
                if (value != null) items.push(value);
            }
            return getItems(getKeys(key), items);
        },
        isDisabled: isDisabled,
        preview: preview,
        getAllowedDropOperations: getAllowedDropOperations,
        startDrag (key, event) {
            let keys = getKeys(key);
            draggingKeys.current = keys;
            draggedKey.current = key;
            selectionManager.setFocused(false);
            setDragging(true);
            if (typeof onDragStart === 'function') onDragStart({
                ...event,
                keys: keys
            });
        },
        moveDrag (event) {
            if (typeof onDragMove === 'function') onDragMove({
                ...event,
                keys: draggingKeys.current
            });
        },
        endDrag (event) {
            let { isInternal: isInternal } = event;
            if (typeof onDragEnd === 'function') onDragEnd({
                ...event,
                keys: draggingKeys.current,
                isInternal: isInternal
            });
            draggingKeys.current = new Set();
            draggedKey.current = null;
            setDragging(false);
        }
    };
}



var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $27053df8e86ffac9$export$926850f6ecef79d0(props) {
    let { acceptedDragTypes: acceptedDragTypes = 'all', isDisabled: isDisabled, onInsert: onInsert, onRootDrop: onRootDrop, onItemDrop: onItemDrop, onReorder: onReorder, onMove: onMove, shouldAcceptItemDrop: shouldAcceptItemDrop, collection: collection, selectionManager: selectionManager, onDropEnter: onDropEnter, getDropOperation: getDropOperation, onDrop: onDrop } = props;
    let [target, setTarget] = (0, $eF4cA.useState)(null);
    let targetRef = (0, $eF4cA.useRef)(null);
    let getOppositeTarget = (target)=>{
        if (target.dropPosition === 'before') {
            let node = collection.getItem(target.key);
            return node && node.prevKey != null ? {
                type: 'item',
                key: node.prevKey,
                dropPosition: 'after'
            } : null;
        } else if (target.dropPosition === 'after') {
            let node = collection.getItem(target.key);
            return node && node.nextKey != null ? {
                type: 'item',
                key: node.nextKey,
                dropPosition: 'before'
            } : null;
        }
        return null;
    };
    let defaultGetDropOperation = (0, $eF4cA.useCallback)((e)=>{
        let { target: target, types: types, allowedOperations: allowedOperations, isInternal: isInternal, draggingKeys: draggingKeys } = e;
        if (isDisabled || !target) return 'cancel';
        if (acceptedDragTypes === 'all' || acceptedDragTypes.some((type)=>types.has(type))) {
            let isValidInsert = onInsert && target.type === 'item' && !isInternal && (target.dropPosition === 'before' || target.dropPosition === 'after');
            let isValidReorder = onReorder && target.type === 'item' && isInternal && (target.dropPosition === 'before' || target.dropPosition === 'after') && $27053df8e86ffac9$var$$e279703d7ed26e75$var$isDraggingWithinParent(collection, target, draggingKeys);
            let isItemDropAllowed = target.type !== 'item' || target.dropPosition !== 'on' || !shouldAcceptItemDrop || shouldAcceptItemDrop(target, types);
            let isValidMove = onMove && target.type === 'item' && isInternal && isItemDropAllowed;
            // Feedback was that internal root drop was weird so preventing that from happening
            let isValidRootDrop = onRootDrop && target.type === 'root' && !isInternal;
            // Automatically prevent items (i.e. folders) from being dropped on themselves.
            let isValidOnItemDrop = onItemDrop && target.type === 'item' && target.dropPosition === 'on' && !(isInternal && target.key != null && draggingKeys.has(target.key)) && isItemDropAllowed;
            if (onDrop || isValidInsert || isValidReorder || isValidMove || isValidRootDrop || isValidOnItemDrop) {
                if (getDropOperation) return getDropOperation(target, types, allowedOperations);
                else return allowedOperations[0];
            }
        }
        return 'cancel';
    }, [
        isDisabled,
        collection,
        acceptedDragTypes,
        getDropOperation,
        onInsert,
        onRootDrop,
        onItemDrop,
        shouldAcceptItemDrop,
        onReorder,
        onMove,
        onDrop
    ]);
    return {
        collection: collection,
        selectionManager: selectionManager,
        isDisabled: isDisabled,
        target: target,
        setTarget (newTarget) {
            if (this.isDropTarget(newTarget)) return;
            let target = targetRef.current;
            if (target && typeof props.onDropExit === 'function') props.onDropExit({
                type: 'dropexit',
                x: 0,
                y: 0,
                target: target
            });
            if (newTarget && typeof onDropEnter === 'function') onDropEnter({
                type: 'dropenter',
                x: 0,
                y: 0,
                target: newTarget
            });
            targetRef.current = newTarget ?? null;
            setTarget(newTarget ?? null);
        },
        isDropTarget (dropTarget) {
            let target = targetRef.current;
            if (!target || !dropTarget) return false;
            if ($27053df8e86ffac9$var$$e279703d7ed26e75$var$isEqualDropTarget(dropTarget, target)) return true;
            // Check if the targets point at the same point between two items, one referring before, and the other after.
            if (dropTarget?.type === 'item' && target?.type === 'item' && dropTarget.key !== target.key && dropTarget.dropPosition !== target.dropPosition && dropTarget.dropPosition !== 'on' && target.dropPosition !== 'on') return $27053df8e86ffac9$var$$e279703d7ed26e75$var$isEqualDropTarget(getOppositeTarget(dropTarget), target) || $27053df8e86ffac9$var$$e279703d7ed26e75$var$isEqualDropTarget(dropTarget, getOppositeTarget(target));
            return false;
        },
        getDropOperation (e) {
            let { target: target, isInternal: isInternal, draggingKeys: draggingKeys } = e;
            // Prevent dropping items onto themselves or their descendants
            if (isInternal && target.type === 'item' && draggingKeys.size > 0) {
                if (draggingKeys.has(target.key) && target.dropPosition === 'on') return 'cancel';
                let currentKey = target.key;
                while(currentKey != null){
                    let item = collection.getItem(currentKey);
                    let parentKey = item?.parentKey;
                    if (parentKey != null && draggingKeys.has(parentKey)) return 'cancel';
                    currentKey = parentKey ?? null;
                }
            }
            return defaultGetDropOperation(e);
        }
    };
}
function $27053df8e86ffac9$var$$e279703d7ed26e75$var$isEqualDropTarget(a, b) {
    if (!a) return !b;
    switch(a.type){
        case 'root':
            return b?.type === 'root';
        case 'item':
            return b?.type === 'item' && b?.key === a.key && b?.dropPosition === a.dropPosition;
    }
}
function $27053df8e86ffac9$var$$e279703d7ed26e75$var$isDraggingWithinParent(collection, target, draggingKeys) {
    let targetNode = collection.getItem(target.key);
    for (let key of draggingKeys){
        let node = collection.getItem(key);
        if (node?.parentKey !== targetNode?.parentKey) return false;
    }
    return true;
}



var $grJ6Y = parcelRequire("grJ6Y");

var $eF4cA = parcelRequire("eF4cA");
class $e9c18193e19585ee$export$fbd65d14c79e28cc {
    constructor(collection, ref, options){
        this.collection = collection;
        this.ref = ref;
        this.layout = options?.layout || 'stack';
        this.orientation = options?.orientation || 'vertical';
        this.direction = options?.direction || 'ltr';
    }
    getPrimaryStart(rect) {
        return this.orientation === 'horizontal' ? rect.left : rect.top;
    }
    getPrimaryEnd(rect) {
        return this.orientation === 'horizontal' ? rect.right : rect.bottom;
    }
    getSecondaryStart(rect) {
        return this.orientation === 'horizontal' ? rect.top : rect.left;
    }
    getSecondaryEnd(rect) {
        return this.orientation === 'horizontal' ? rect.bottom : rect.right;
    }
    getFlowStart(rect) {
        return this.layout === 'stack' ? this.getPrimaryStart(rect) : this.getSecondaryStart(rect);
    }
    getFlowEnd(rect) {
        return this.layout === 'stack' ? this.getPrimaryEnd(rect) : this.getSecondaryEnd(rect);
    }
    getFlowSize(rect) {
        return this.getFlowEnd(rect) - this.getFlowStart(rect);
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.collection[Symbol.iterator]().next().done || !this.ref.current) return {
            type: 'root'
        };
        let rect = this.ref.current.getBoundingClientRect();
        let primary = this.orientation === 'horizontal' ? x : y;
        let secondary = this.orientation === 'horizontal' ? y : x;
        primary += this.getPrimaryStart(rect);
        secondary += this.getSecondaryStart(rect);
        let flow = this.layout === 'stack' ? primary : secondary;
        let isPrimaryRTL = this.orientation === 'horizontal' && this.direction === 'rtl';
        let isSecondaryRTL = this.layout === 'grid' && this.orientation === 'vertical' && this.direction === 'rtl';
        let isFlowRTL = this.layout === 'stack' ? isPrimaryRTL : isSecondaryRTL;
        let collection = this.ref.current?.dataset.collection;
        let elements = this.ref.current.querySelectorAll(collection ? `[data-collection="${CSS.escape(collection)}"]` : '[data-key]');
        let elementMap = new Map();
        for (let item of elements)if (item instanceof HTMLElement && item.dataset.key != null) elementMap.set(item.dataset.key, item);
        // TODO: assume that only item type items are valid drop targets. This is to prevent a crash when dragging over the loader
        // row since it doesn't have a data-key set on it. Will eventually need to handle the case with drag and drop and loaders located between rows aka tree.
        // Can see https://github.com/adobe/react-spectrum/pull/4210/files#diff-21e555e0c597a28215e36137f5be076a65a1e1456c92cd0fdd60f866929aae2a for additional logic
        // that may need to happen then
        let items = [
            ...this.collection
        ].filter((item)=>item.type === 'item');
        if (items.length < 1) return {
            type: 'root'
        };
        let low = 0;
        let high = items.length;
        while(low < high){
            let mid = Math.floor((low + high) / 2);
            let item = items[mid];
            let element = elementMap.get(String(item.key));
            if (!element) break;
            let rect = element.getBoundingClientRect();
            let update = (isGreater)=>{
                if (isGreater) low = mid + 1;
                else high = mid;
            };
            if (primary < this.getPrimaryStart(rect)) update(isPrimaryRTL);
            else if (primary > this.getPrimaryEnd(rect)) update(!isPrimaryRTL);
            else if (secondary < this.getSecondaryStart(rect)) update(isSecondaryRTL);
            else if (secondary > this.getSecondaryEnd(rect)) update(!isSecondaryRTL);
            else {
                let target = {
                    type: 'item',
                    key: item.key,
                    dropPosition: 'on'
                };
                if (isValidDropTarget(target)) {
                    // Otherwise, if dropping on the item is accepted, try the before/after positions if within 5px
                    // of the start or end of the item.
                    if (flow <= this.getFlowStart(rect) + 5 && isValidDropTarget({
                        ...target,
                        dropPosition: 'before'
                    })) target.dropPosition = isFlowRTL ? 'after' : 'before';
                    else if (flow >= this.getFlowEnd(rect) - 5 && isValidDropTarget({
                        ...target,
                        dropPosition: 'after'
                    })) target.dropPosition = isFlowRTL ? 'before' : 'after';
                } else {
                    // If dropping on the item isn't accepted, try the target before or after depending on the position.
                    let mid = this.getFlowStart(rect) + this.getFlowSize(rect) / 2;
                    if (flow <= mid && isValidDropTarget({
                        ...target,
                        dropPosition: 'before'
                    })) target.dropPosition = isFlowRTL ? 'after' : 'before';
                    else if (flow >= mid && isValidDropTarget({
                        ...target,
                        dropPosition: 'after'
                    })) target.dropPosition = isFlowRTL ? 'before' : 'after';
                }
                return target;
            }
        }
        let item = items[Math.min(low, items.length - 1)];
        let element = elementMap.get(String(item.key));
        rect = element?.getBoundingClientRect();
        if (rect && (primary < this.getPrimaryStart(rect) || Math.abs(flow - this.getFlowStart(rect)) < Math.abs(flow - this.getFlowEnd(rect)))) return {
            type: 'item',
            key: item.key,
            dropPosition: isFlowRTL ? 'after' : 'before'
        };
        return {
            type: 'item',
            key: item.key,
            dropPosition: isFlowRTL ? 'before' : 'after'
        };
    }
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b41c722a36712a52$export$2cfc5be7a55829f6(options) {
    let dragAndDropHooks = (0, $eF4cA.useMemo)(()=>{
        let { onDrop: onDrop, onInsert: onInsert, onItemDrop: onItemDrop, onReorder: onReorder, onMove: onMove, onRootDrop: onRootDrop, getItems: getItems, renderDragPreview: renderDragPreview, renderDropIndicator: renderDropIndicator, dropTargetDelegate: dropTargetDelegate } = options;
        let isDraggable = !!getItems;
        let isDroppable = !!(onDrop || onInsert || onItemDrop || onReorder || onMove || onRootDrop);
        let hooks = {};
        if (isDraggable) {
            hooks.useDraggableCollectionState = function useDraggableCollectionStateOverride(props) {
                // oxlint-disable-next-line react/react-compiler
                return (0, $1268d37dd6d82e4e$export$29efd034f1d79f81)({
                    ...props,
                    ...options
                });
            };
            // oxlint-disable-next-line react/react-compiler
            hooks.useDraggableCollection = (0, $8093d795b94b5335$export$2962a7984b2f0a80);
            // oxlint-disable-next-line react/react-compiler
            hooks.useDraggableItem = (0, $b6c20cf365ec563b$export$b35afafff42da2d9);
            hooks.DragPreview = (0, $789b02091692ade5$export$905ab40ac2179daa);
            hooks.renderDragPreview = renderDragPreview;
            hooks.isVirtualDragging = (0, $grJ6Y.isVirtualDragging);
        }
        if (isDroppable) {
            hooks.useDroppableCollectionState = function useDroppableCollectionStateOverride(props) {
                // oxlint-disable-next-line react/react-compiler
                return (0, $27053df8e86ffac9$export$926850f6ecef79d0)({
                    ...props,
                    ...options
                });
            };
            // oxlint-disable-next-line react/react-compiler
            hooks.useDroppableItem = (0, $d62d112eefdf931b$export$f7b0c5d28b66b6a5);
            hooks.useDroppableCollection = function useDroppableCollectionOverride(props, state, ref) {
                // oxlint-disable-next-line react/react-compiler
                return (0, $b0d7ca4f5fb8e6b3$export$f4e2f423c21f7b04)({
                    ...props,
                    ...options
                }, state, ref);
            };
            // oxlint-disable-next-line react/react-compiler
            hooks.useDropIndicator = (0, $79bc9727ca6c1ff4$export$8d0e41d2815afac5);
            hooks.renderDropIndicator = renderDropIndicator;
            hooks.dropTargetDelegate = dropTargetDelegate;
            hooks.ListDropTargetDelegate = (0, $e9c18193e19585ee$export$fbd65d14c79e28cc);
        }
        return hooks;
    }, [
        options
    ]);
    return {
        dragAndDropHooks: dragAndDropHooks
    };
}



var $d51mJ = parcelRequire("d51mJ");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $326fbe58e88b2802$var$$9c47b795029a2a80$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("defs", {
                children: (0, $dx4lB.jsx)("clipPath", {
                    id: "c9b2ce__a",
                    children: (0, $dx4lB.jsx)("path", {
                        fill: "#fff",
                        d: "M160 0H0v160h160z"
                    })
                })
            }),
            (0, $dx4lB.jsxs)("g", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                clipPath: "url(#c9b2ce__a)",
                children: [
                    (0, $dx4lB.jsx)("path", {
                        d: "M132.49 93.09c-13.53 0-24.5 10.97-24.5 24.5s10.97 24.5 24.5 24.5 24.5-10.97 24.5-24.5-10.97-24.5-24.5-24.5m10.92 29.77c1.56 1.56 1.56 4.09 0 5.66-.78.78-1.8 1.17-2.83 1.17s-2.05-.39-2.83-1.17l-5.26-5.26-5.26 5.26c-.78.78-1.8 1.17-2.83 1.17s-2.05-.39-2.83-1.17c-1.56-1.56-1.56-4.09 0-5.66l5.26-5.26-5.26-5.26c-1.56-1.56-1.56-4.09 0-5.66 1.56-1.56 4.1-1.56 5.66 0l5.26 5.26 5.26-5.26c1.56-1.56 4.1-1.56 5.66 0s1.56 4.09 0 5.66l-5.26 5.26z"
                    }),
                    (0, $dx4lB.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M124 30c11.046 0 20 8.954 20 20v32.875c0 2.21-1.791 4-4 4s-4-1.79-4-4V50c0-6.627-5.373-12-12-12H36c-6.627 0-12 5.373-12 12v60c0 .862.09 1.703.264 2.513l24.781-38.286c4.365-6.75 14.252-6.75 18.618-.002l.001.002 20.529 31.71 11.745-17.491v-.002c3.292-4.895 9.488-6.105 14.216-3.719 1.972.995 2.764 3.401 1.769 5.373s-3.401 2.764-5.373 1.77c-1.348-.681-3.067-.306-3.972 1.039L87.043 122H98c2.209 0 4 1.791 4 4s-1.791 4-4 4H36c-11.046 0-20-8.954-20-20V50c0-11.046 8.954-20 20-20zM55.762 78.573l-26.686 41.229C31.032 121.186 33.42 122 36 122h41.407l5.934-8.837-22.393-34.59-.002-.002c-1.213-1.876-3.97-1.876-5.183 0zM108 58c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8"
                    })
                ]
            })
        ]
    });
const $326fbe58e88b2802$var$$9c47b795029a2a80$var$ForwardRef = (0, $eF4cA.forwardRef)($326fbe58e88b2802$var$$9c47b795029a2a80$var$SvgComponent);
var $326fbe58e88b2802$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($326fbe58e88b2802$var$$9c47b795029a2a80$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $36eeb8a37605fa4b$var$$1a1920d7957529de$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M76.2 18c5.522 0 10 4.477 10 10v23.125c0 1.105-.896 2-2 2s-2-.895-2-2V28c0-3.314-2.687-6-6-6H19c-3.315 0-6 2.686-6 6v39.2c0 .678.112 1.33.32 1.939l16.042-24.785v-.001c2.462-3.806 8.038-3.806 10.5 0l12.702 19.621 7.322-11.072.009-.012c2.478-3.687 7.91-3.693 10.384.003.615.918.369 2.16-.55 2.775-.917.614-2.16.368-2.774-.55-.885-1.323-2.839-1.33-3.737-.002L51.258 73.2h8.96c1.104 0 2 .895 2 2s-.896 2-2 2H18.999c-5.523 0-10-4.477-10-10V28c0-5.523 4.477-10 10-10zM32.72 46.526 15.983 72.387c.886.517 1.917.813 3.017.813h27.463l3.694-5.585-13.653-21.088v-.001c-.886-1.37-2.896-1.37-3.782 0M65.5 33c0 2.761 2.239 5 5 5s5-2.239 5-5-2.239-5-5-5-5 2.239-5 5"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M79.688 55.875c-8.147 0-14.75 6.603-14.75 14.75s6.603 14.75 14.75 14.75 14.75-6.603 14.75-14.75-6.604-14.75-14.75-14.75m6.292 18.207c.782.782.782 2.054 0 2.836-.39.39-.901.591-1.413.591-.51 0-1.022-.2-1.412-.591l-3.457-3.457-3.457 3.457c-.391.39-.902.591-1.413.591s-1.023-.2-1.413-.591c-.782-.782-.782-2.054 0-2.836l3.457-3.457-3.457-3.457c-.782-.782-.782-2.054 0-2.836.781-.781 2.054-.781 2.835 0l3.457 3.457 3.458-3.457c.781-.781 2.054-.781 2.835 0 .782.782.782 2.054 0 2.836l-3.457 3.457L86 74.082z"
            })
        ]
    });
const $36eeb8a37605fa4b$var$$1a1920d7957529de$var$ForwardRef = (0, $eF4cA.forwardRef)($36eeb8a37605fa4b$var$$1a1920d7957529de$var$SvgComponent);
var $36eeb8a37605fa4b$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($36eeb8a37605fa4b$var$$1a1920d7957529de$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $0bdcdd0ad438e31e$var$$f3d1298daad95ea5$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M38 8.75c2.9 0 5.25 2.35 5.25 5.25v11.563c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25V14c0-1.519-1.231-2.75-2.75-2.75H10c-1.519 0-2.75 1.231-2.75 2.75v19.97l7.722-11.93c1.33-2.055 4.34-2.055 5.669 0l6.144 9.49 3.45-5.217.005-.008c1.17-1.739 3.545-1.956 5.022-.665.52.454.572 1.244.118 1.763-.454.52-1.244.573-1.764.119-.38-.333-.997-.27-1.299.175L26.33 36.75h3.264c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25H10c-2.9 0-5.25-2.35-5.25-5.25V14c0-2.9 2.35-5.25 5.25-5.25zM17.07 23.399l-8.414 13c.397.224.856.351 1.344.351h13.354q.043-.097.104-.19l1.822-2.754-6.738-10.407c-.344-.533-1.127-.533-1.471 0M32 17.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M39.516 27.984c-4.142 0-7.5 3.359-7.5 7.5 0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5-3.359-7.5-7.5-7.5m3.358 9.105c.486.486.486 1.269 0 1.754-.238.238-.555.367-.872.367s-.634-.12-.871-.367l-1.605-1.605-1.606 1.605c-.237.238-.554.367-.871.367s-.634-.12-.872-.367c-.486-.485-.486-1.268 0-1.754l1.605-1.605-1.605-1.605c-.486-.485-.486-1.268 0-1.753.485-.486 1.268-.486 1.753 0l1.605 1.605 1.606-1.605c.485-.486 1.268-.486 1.753 0 .486.485.486 1.268 0 1.753l-1.605 1.605 1.605 1.605z"
            })
        ]
    });
const $0bdcdd0ad438e31e$var$$f3d1298daad95ea5$var$ForwardRef = (0, $eF4cA.forwardRef)($0bdcdd0ad438e31e$var$$f3d1298daad95ea5$var$SvgComponent);
var $0bdcdd0ad438e31e$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($0bdcdd0ad438e31e$var$$f3d1298daad95ea5$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $198532ef5d0da7a3$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $326fbe58e88b2802$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $0bdcdd0ad438e31e$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $36eeb8a37605fa4b$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}





var $15xG7 = parcelRequire("15xG7");

var $i8elj = parcelRequire("i8elj");



var $iLDMH = parcelRequire("iLDMH");

var $dx4lB = parcelRequire("dx4lB");

var $9eyCh = parcelRequire("9eyCh");

var $4W5AG = parcelRequire("4W5AG");
var $gc2oq = parcelRequire("gc2oq");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $8wD3p = parcelRequire("8wD3p");
var $fZShI = parcelRequire("fZShI");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $30dcf987ca223a67$var$$1f4496c0a145ef13$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M14.25 12.75h-5.5c-.265 0-.51-.14-.645-.367s-.14-.51-.013-.742l2.75-5.04c.132-.24.385-.39.659-.39s.527.15.658.39l2.75 5.04c.126.232.121.514-.014.742s-.38.367-.645.367m-4.236-1.5h2.972l-1.485-2.724zM5.75 12.75c-.122 0-.245-.03-.36-.092-.363-.198-.497-.654-.298-1.017l1.981-3.63c.199-.363.655-.497 1.018-.298.364.198.497.654.299 1.017l-1.982 3.63c-.136.248-.393.39-.658.39"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-.115 0-.23-.026-.336-.08l-7.73-3.874c-.255-.128-.415-.387-.415-.671v-8.25c0-.284.16-.543.414-.67l7.731-3.876c.211-.105.461-.105.672 0l7.73 3.875c.255.128.415.387.415.671v8.25c0 .284-.16.543-.414.67l-7.731 3.876q-.16.08-.336.079m-6.981-5.088 6.981 3.5 6.981-3.5V6.338L10 2.838l-6.981 3.5z"
            })
        ]
    });
const $30dcf987ca223a67$var$$1f4496c0a145ef13$var$ForwardRef = (0, $eF4cA.forwardRef)($30dcf987ca223a67$var$$1f4496c0a145ef13$var$SvgComponent);
var $30dcf987ca223a67$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($30dcf987ca223a67$var$$1f4496c0a145ef13$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $54ea0c2db6b24081$var$$20dbb14f424466ba$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M14.5 7.521c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M3.25 4.5h13.5c.413 0 .75.337.75.75v8.21l-1.91-1.908c-.876-.877-2.304-.877-3.18 0l-1.232 1.231c-.1.098-.257.097-.355.001L7.591 9.552c-.85-.85-2.332-.85-3.182 0L2.5 11.46V5.25c0-.413.337-.75.75-.75m0 11c-.413 0-.75-.337-.75-.75v-1.168l2.97-2.97c.293-.293.767-.293 1.06 0l3.234 3.234c.681.68 1.792.68 2.473-.001l1.233-1.233c.293-.293.767-.293 1.06 0l2.701 2.701c-.131.112-.296.187-.481.187z"
            })
        ]
    });
const $54ea0c2db6b24081$var$$20dbb14f424466ba$var$ForwardRef = (0, $eF4cA.forwardRef)($54ea0c2db6b24081$var$$20dbb14f424466ba$var$SvgComponent);
var $54ea0c2db6b24081$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($54ea0c2db6b24081$var$$20dbb14f424466ba$var$ForwardRef);



var $i8elj = parcelRequire("i8elj");

var $dx4lB = parcelRequire("dx4lB");

var $dm5H1 = parcelRequire("dm5H1");

var $eF4cA = parcelRequire("eF4cA");
"use client";
const $c18715cf2cd0366b$var$SvgComponent = (props, ref)=>/*#__PURE__*/ (0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        fill: "none",
        viewBox: "0 0 10 10",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M3 10c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1M3 6c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1M3 2c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1M7 10c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1M7 6c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1M7 2c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1"
        })
    });
const $c18715cf2cd0366b$var$ForwardRef = /*#__PURE__*/ (0, $eF4cA.forwardRef)($c18715cf2cd0366b$var$SvgComponent);
var $c18715cf2cd0366b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dm5H1.createIcon)($c18715cf2cd0366b$var$ForwardRef);



var $iLDMH = parcelRequire("iLDMH");

var $iKDEm = parcelRequire("iKDEm");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");


var $a8sj2 = parcelRequire("a8sj2");
const $c2212a7d2d143775$export$c5ae10d7c88c4d3e = ({ url: url, filePath: filePath })=>{
    const [fileType, setFileType] = (0, $eF4cA.useState)("\u2013");
    const urlQuery = (0, $a8sj2.usePresignURL)(filePath, {
        enabled: !url && !!filePath,
        staleTime: 3600000
    });
    const urlToCheck = urlQuery.data?.presignURL || url;
    const linkChecker = (0, $a08d45745fe59208$export$a8cdb0ec9f4ed9e6)(urlToCheck, {
        enabled: !!urlToCheck && !urlToCheck.startsWith("data:")
    });
    (0, $eF4cA.useEffect)(()=>{
        if (linkChecker.isSuccess) {
            let type;
            switch(linkChecker.data.contentType){
                case "image/jpeg":
                case "image/jpg":
                    type = "JPG";
                    break;
                case "image/png":
                    type = "PNG";
                    break;
                case "image/gif":
                    type = "GIF";
                    break;
                case "image/webp":
                    type = "WEBP";
                    break;
                case "image/svg+xml":
                    type = "SVG";
                    break;
                case "video/mp4":
                    type = "MP4";
                    break;
                case "video/quicktime":
                    type = "MOV";
                    break;
                default:
                    type = "\u2013";
            }
            setFileType(type);
        }
    }, [
        linkChecker.isSuccess
    ]);
    return fileType;
};
$c2212a7d2d143775$export$c5ae10d7c88c4d3e.propTypes = {
    url: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    filePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};


const $e844c92960c35b6a$var$AssetActionMenu = ({ item: item = {}, templateData: templateData, onMenuAction: onMenuAction, ...props })=>{
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $gc2oq.ActionMenu), {
        onAction: (action)=>onMenuAction(action, item),
        ...props,
        children: [
            !!item?.isDisabled && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    slot: "description",
                    children: "Low\u2011resolution image"
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuSection), {
                children: templateData?.assets.filter((asset)=>asset.type === "image").map((asset)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                        id: asset.name,
                        "aria-label": `Use as ${(asset?.label ?? asset.name).toLowerCase()}`,
                        children: [
                            [
                                "Logo",
                                "App-icon"
                            ].includes(asset.name) ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $30dcf987ca223a67$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $54ea0c2db6b24081$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: `Use as ${(asset?.label ?? asset.name).toLowerCase()}`
                            })
                        ]
                    }, asset.name))
            }),
            !!item?.filePath && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuSection), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                        id: "delete",
                        "aria-label": "Delete asset",
                        UNSAFE_className: " pq182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 pq182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    slot: null,
                                    styles: " Jr182",
                                    children: "Delete"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
$e844c92960c35b6a$var$AssetActionMenu.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    onMenuAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};
const $e844c92960c35b6a$export$eff93e4e59ccc3b8 = (props)=>{
    const { item: item = {}, templateData: templateData, onMenuAction: onMenuAction, children: children } = props;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.CardPreview), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                        filePath: item?.filePath,
                        src: (item?.thumb ?? item?.src) || "",
                        alt: item?.alt || item.id,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' _Ha182';
                            rules += ' Za182';
                            rules += ' Fb182';
                            if (props.isDisabled) rules += ' _IStfurc182';
                            else rules += ' _Ib182';
                            return rules;
                        }({
                            isDisabled: item.isDisabled
                        })
                    }),
                    !!item?.isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                        "aria-label": "Loading",
                        isIndeterminate: true,
                        staticColor: "auto",
                        styles: " _Pa182 WF182 _A3MNfn182",
                        UNSAFE_className: " _Zc182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " se4mUs182 sok182 _Pa182 Wr182 _lr182 _Ar182 _zr182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)($e844c92960c35b6a$var$AssetActionMenu, {
                            item: item,
                            templateData: templateData,
                            onMenuAction: onMenuAction,
                            isQuiet: false,
                            staticColor: "auto",
                            styles: " _Pa182 Wx182 _zI182"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $iKDEm.HoverState), {
                showOutline: false,
                isTinted: true,
                renderBehavior: "always",
                styles: " sk182 soe4mUs182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        slot: "title",
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182 _Pa182 _lI182 _At182",
                        children: `${Math.round(item?.width ?? item?.size?.width ?? 0)} \xd7 ${Math.round(item?.height ?? item?.size?.height ?? 0)} px`
                    }),
                    children,
                    typeof onMenuAction === "function" && /*#__PURE__*/ (0, $dx4lB.jsx)($e844c92960c35b6a$var$AssetActionMenu, {
                        item: item,
                        templateData: templateData,
                        onMenuAction: onMenuAction,
                        isQuiet: false,
                        styles: " _Pa182 Wx182 _zI182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                        slot: "drag",
                        isQuiet: true,
                        size: "XS",
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' _Pa182';
                            rules += ' WE182';
                            rules += ' _AE182';
                            rules += ' rl182';
                            if (props.isDisabled) rules += ' _6b182';
                            else rules += ' _6c182';
                            return rules;
                        }({
                            isDisabled: item.isDisabled
                        }),
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c18715cf2cd0366b$export$2e2bcd8739ae039), {
                            UNSAFE_style: {
                                width: 10,
                                height: 10
                            }
                        })
                    }),
                    !!item?.isDisabled && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 _Pa182 WJ182 _At182",
                        children: "Low\u2011res image"
                    })
                ]
            })
        ]
    });
};
$e844c92960c35b6a$export$eff93e4e59ccc3b8.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    templateData: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object,
    onMenuAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).node
};



var $ikOQe = parcelRequire("ikOQe");
const $5062bdc91dde1356$var$illustratedStateStyle = " se182 CinfL3182 DPlN5qb182 EZQmDFe182 qg182 Ua182 eb182 _Ca182 ZoffTu182 IM182 HM182";
const $5062bdc91dde1356$var$fullTextStyle = " La182 Za182 _Nc182 Pc182 _Yb182 _7c182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182";
const $5062bdc91dde1356$var$shrinkTextStyle = " _ub182 _vb182 _sa182 La182 _Nc182 Pc182 _Yb182 _7c182";
const $5062bdc91dde1356$export$76ab5d8aecc34fb6 = ({ videoId: videoId, queries: queries = [], onMenuAction: onMenuAction })=>{
    const params = (0, $dqZbZ.useParams)();
    const projectId = videoId || params?.id;
    const video = (0, $ikOQe.useVideo)(projectId);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(projectId);
    const { urls: urls = [] } = video.data || {};
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const templateData = template.data;
    const [expandedKeys, setExpandedKeys] = (0, $eF4cA.useState)(new Set());
    const [editAction, setEditAction] = (0, $eF4cA.useState)(null);
    const { dragAndDropHooks: dragAndDropHooks } = (0, $b41c722a36712a52$export$2cfc5be7a55829f6)({
        getItems: (keys, items)=>{
            return items.map((item)=>({
                    "image/scrapped": JSON.stringify(item)
                }));
        },
        renderDragPreview: (items)=>{
            const [item] = items.map((it)=>JSON.parse(it["image/scrapped"]));
            if (!item) return null;
            return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " Z5Hidqd182 fIDBNkb182 oc182 nc182 kc182 jc182 _Nc182 Pc182 _n5O4L6182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                    src: item?.thumb ?? item.src,
                    alt: item.alt || item.id,
                    styles: " Za182 Fb182 _Ha182"
                })
            });
        }
    });
    const filteredQueries = (0, $eF4cA.useMemo)(()=>[
            ...queries
        ]// .filter((q) => q.isSuccess)
        .map((q)=>({
                ...q,
                data: q.data?.filter((asset)=>asset.type === "image") || []
            })), [
        queries
    ]);
    const handleEditUrl = (0, $eF4cA.useCallback)((url, title, index)=>{
        const newUrls = [
            ...urls
        ];
        newUrls[index] = [
            url,
            title
        ];
        updateVideo.mutate({
            urls: newUrls
        });
        setExpandedKeys((oldKeys)=>new Set(oldKeys).add(url));
    }, [
        urls,
        updateVideo.mutate
    ]);
    const handleAddUrl = (0, $eF4cA.useCallback)((url, title)=>{
        const newUrls = [
            [
                url,
                title
            ],
            ...urls.filter(([u])=>u !== url)
        ];
        updateVideo.mutate({
            urls: newUrls
        }, {
            onSuccess: ()=>{
                // Expand the newly added URL
                setExpandedKeys((oldKeys)=>new Set(oldKeys).add(url));
            }
        });
    }, [
        urls,
        updateVideo.mutate
    ]);
    const handleDeleteUrl = (0, $eF4cA.useCallback)((url)=>{
        const newUrls = urls.filter(([u])=>u !== url);
        updateVideo.mutate({
            urls: newUrls
        });
        setExpandedKeys((oldKeys)=>{
            const newSet = new Set(oldKeys);
            newSet.delete(url);
            return newSet;
        });
    }, [
        urls,
        updateVideo.mutate
    ]);
    const allSources = urls;
    (0, $eF4cA.useEffect)(()=>{
        if (video.isSuccess) {
            const incomingUrls = new Set([
                `${queries[0]?.query ?? queries[0]?.url ?? ""}-0`
            ]);
            if (incomingUrls.size !== expandedKeys.size || [
                ...incomingUrls
            ].some((url)=>!expandedKeys.has(url))) setExpandedKeys(incomingUrls);
        }
    }, [
        video.isSuccess,
        urls
    ]);
    const renderEmptyState = ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: $5062bdc91dde1356$var$illustratedStateStyle,
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $198532ef5d0da7a3$export$2e2bcd8739ae039), {
                    styles: " ZF182 Fz182 z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 zPCJngb182 yPCJngb182 BPCJngb182 APCJngb182 _dd182",
                    children: "No images found"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 _de182",
                    children: "We couldn't find any images for this URL"
                })
            ]
        });
    const renderLoadingState = ()=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
            className: $5062bdc91dde1356$var$illustratedStateStyle,
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d51mJ.default), {
                    styles: " ZF182 Fz182 z2U5Crc182 y2U5Crc182 B2U5Crc182 A2U5Crc182"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 zPCJngb182 yPCJngb182 BPCJngb182 APCJngb182 _dd182",
                    children: "Importing images"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $41e172257332f72e$export$c17561cb55d4db30), {
                    "aria-label": "Importing images...",
                    size: "S",
                    isIndeterminate: true,
                    staticColor: "auto",
                    styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 _de182 Js182 Gv182"
                })
            ]
        });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Uj182 qj182 Js182",
        children: [
            /*#__PURE__*/ (0, $l19Vn.createPortal)(/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $hSW0F.TooltipTrigger), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        "aria-label": "Add new URL",
                        isQuiet: true,
                        size: "S",
                        onPress: ()=>setEditAction({
                                type: "add",
                                url: "",
                                title: ""
                            }),
                        styles: " IM182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $eb8f55a238917802$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "Add link"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $hSW0F.Tooltip), {
                        children: "Add new URL for image extraction"
                    })
                ]
            }), document.getElementById("assets-menu")),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $672bd86de9b2e48d$export$a766cd26d0d69044), {
                // allowsMultipleExpanded
                expandedKeys: expandedKeys,
                onExpandedChange: setExpandedKeys,
                density: "spacious",
                children: filteredQueries.map((query, idx)=>{
                    const id = `${query?.query ?? query?.url ?? ""}-${idx}`;
                    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $a6bf03053d5f3ea4$export$74a362b31437ec83), {
                        id: id,
                        size: query?.label?.startsWith("[Search]") ? "S" : "M",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $a6bf03053d5f3ea4$export$1e037ddd32f5b8ac), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$7843c6a5b3e340a2), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: " sh182 _tc182 _wb182 Ub182 qb182 ed182 _Nc182 Pc182",
                                            children: [
                                                !!query?.label && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    styles: $5062bdc91dde1356$var$shrinkTextStyle,
                                                    children: query?.label
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    styles: !!query?.label ? $5062bdc91dde1356$var$fullTextStyle : $5062bdc91dde1356$var$shrinkTextStyle,
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                        href: query?.url,
                                                        target: "_blank",
                                                        variant: "secondary",
                                                        children: query?.url
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                                        size: "S",
                                        isQuiet: true,
                                        styles: " _va182",
                                        children: [
                                            !!query.data && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                isDisabled: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2487b8aecf1c0f59$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        styles: " _Ye4mUs182",
                                                        children: query.data?.length
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                "aria-label": "Reload",
                                                onPress: ()=>query.refetch(),
                                                isDisabled: query.isFetching,
                                                children: query.isFetching ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                    slot: "icon",
                                                    "aria-label": `Extracting images from ${query?.url}`,
                                                    isIndeterminate: true,
                                                    size: "S",
                                                    staticColor: "auto"
                                                }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {})
                                            }),
                                            !!query.isEditable && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                        "aria-label": "Delete link",
                                                        onPress: ()=>setEditAction({
                                                                type: "delete",
                                                                url: query?.url
                                                            }),
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                        "aria-label": "Edit link",
                                                        onPress: ()=>setEditAction({
                                                                type: "edit",
                                                                url: query?.url,
                                                                title: query?.label,
                                                                index: idx
                                                            }),
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $a6bf03053d5f3ea4$export$feabaa331e1d464c), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                                        "aria-label": `Scraped images from ${query?.url}`,
                                        textValue: `Scraped images from ${query?.url}`,
                                        items: query.data || [],
                                        dependencies: [],
                                        disabledKeys: new Set(query.data?.filter?.((item)=>item.isDisabled).map((item)=>item.id) ?? []),
                                        dragAndDropHooks: dragAndDropHooks,
                                        layout: "grid",
                                        variant: "quiet",
                                        size: "S",
                                        styles: " KILqIYb182 _oa182",
                                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                                id: item.id,
                                                textValue: item.alt || item.id,
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e844c92960c35b6a$export$eff93e4e59ccc3b8), {
                                                    item: item,
                                                    templateData: templateData,
                                                    onMenuAction: onMenuAction,
                                                    children: !!item?.sourceUrl && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3YPmU.Link), {
                                                        href: item.sourceUrl,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        staticColor: "auto",
                                                        isStandalone: true,
                                                        isQuiet: true,
                                                        styles: " _Pa182 _lI182 _zt182",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                                                children: "Source"
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $68b9d6b3f9506984$export$2e2bcd8739ae039), {
                                                                styles: " Zh182 Fi182 Is182"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                    }),
                                    !query.isFetching && !query.data?.length && renderEmptyState(),
                                    query.isLoading && renderLoadingState()
                                ]
                            })
                        ]
                    }, id);
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $bsn7e.DialogContainer), {
                onDismiss: ()=>setEditAction(null),
                children: [
                    [
                        "edit",
                        "add"
                    ].includes(editAction?.type) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7uz0i.Dialog), {
                        children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        slot: "title",
                                        children: editAction.type === "add" ? "Add link" : "Edit link"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                        children: [
                                            editAction.type === "add" && /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                                children: "Add new URL for image extraction"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                        label: "URL",
                                                        type: "url",
                                                        defaultValue: editAction.url,
                                                        placeholder: "https://",
                                                        onChange: (url)=>setEditAction((oldValue)=>({
                                                                    ...oldValue,
                                                                    url: url
                                                                })),
                                                        isRequired: true
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                        label: "Title",
                                                        defaultValue: editAction.title,
                                                        necessityIndicator: "label",
                                                        onChange: (title)=>setEditAction((oldValue)=>({
                                                                    ...oldValue,
                                                                    title: title
                                                                }))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                onPress: close,
                                                variant: "secondary",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                onPress: ()=>{
                                                    if (editAction.type === "add") handleAddUrl(editAction.url, editAction.title);
                                                    else if (editAction.type === "edit") handleEditUrl(editAction.url, editAction.title, editAction.index);
                                                    close();
                                                },
                                                variant: "accent",
                                                children: "Save"
                                            })
                                        ]
                                    })
                                ]
                            })
                    }),
                    editAction?.type === "delete" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5NHyX.AlertDialog), {
                        variant: "destructive",
                        title: "Delete link",
                        primaryActionLabel: "Delete",
                        cancelLabel: "Cancel",
                        onPrimaryAction: ()=>{
                            handleDeleteUrl(editAction.url);
                            setEditAction(null);
                        },
                        onCancel: ()=>setEditAction(null),
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Are you sure you want to delete this URL?"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                    href: editAction.url,
                                    target: "_blank",
                                    variant: "secondary",
                                    isStandalone: true,
                                    children: editAction.url
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
$5062bdc91dde1356$export$76ab5d8aecc34fb6.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    queries: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array,
    onMenuAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $9eyCh = parcelRequire("9eyCh");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $KXDAG = parcelRequire("KXDAG");
var $7Vvqh = parcelRequire("7Vvqh");
var $c0XRK = parcelRequire("c0XRK");



var $iLDMH = parcelRequire("iLDMH");


var $ikOQe = parcelRequire("ikOQe");
const $49de88ae0db24967$var$ACCEPTED_FILE_TYPES = [
    "image/jpeg",
    "image/png",
    "image/svg+xml"
];
const $49de88ae0db24967$export$a1eb6fa2125ad52f = ({ videoId: videoId, onDrop: onDrop = ()=>{}, onMenuAction: onMenuAction })=>{
    const params = (0, $dqZbZ.useParams)();
    const projectId = videoId || params?.id;
    const video = (0, $ikOQe.useVideo)(projectId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const templateData = template.data;
    const { dragAndDropHooks: dragAndDropHooks } = (0, $b41c722a36712a52$export$2cfc5be7a55829f6)({
        getItems: (keys, items)=>{
            return items.map((item)=>({
                    "image/asset": JSON.stringify(item)
                }));
        },
        renderDragPreview: (items)=>{
            const [item] = items.map((it)=>JSON.parse(it["image/asset"]));
            if (!item) return null;
            return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " Z5Hidqd182 fIDBNkb182 oc182 nc182 kc182 jc182 _Nc182 Pc182 _n5O4L6182",
                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                    filePath: item.filePath,
                    src: item.src,
                    alt: item.alt || item.name,
                    styles: " Za182 Fb182 _Ha182"
                })
            });
        }
    });
    const items = (0, $eF4cA.useMemo)(()=>video.data?.assets.filter((asset)=>asset?.name?.startsWith("upload__")) || [], [
        video.data?.assets
    ]);
    const handleDragOperation = (0, $eF4cA.useCallback)(({ types: types })=>{
        if (Array.from(types)[0]?.startsWith("image/") && !types.has("image/asset")) return "copy";
        return "cancel";
    }, []);
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " Te182 Qe182",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $KXDAG.DropZone), {
            getDropOperation: handleDragOperation,
            onDrop: (event)=>onDrop(event.items),
            replaceMessage: "Drop files to upload",
            UNSAFE_className: " Tt182 Qt182 St182 Rt182",
            children: items.length ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                "aria-label": "Uploaded images",
                textValue: "Uploaded images",
                items: items,
                disabledKeys: new Set(items?.filter?.((item)=>item.isDisabled).map((item)=>item.id) ?? []),
                dragAndDropHooks: dragAndDropHooks,
                layout: "grid",
                variant: "quiet",
                size: "S",
                styles: " Za182 Fb182",
                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                        id: item.name,
                        textValue: item.alt || item.id,
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e844c92960c35b6a$export$eff93e4e59ccc3b8), {
                            item: item,
                            templateData: templateData,
                            onMenuAction: onMenuAction
                        })
                    })
            }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                size: "S",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c5c5c929122049b7$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        children: "Drag and drop your file"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        children: "Or, select a file from your computer"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                            acceptedFileTypes: $49de88ae0db24967$var$ACCEPTED_FILE_TYPES,
                            allowsMultiple: true,
                            onSelect: onDrop,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "secondary",
                                children: "Browse files"
                            })
                        })
                    })
                ]
            })
        })
    });
};
$49de88ae0db24967$export$a1eb6fa2125ad52f.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
    onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func,
    onMenuAction: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).func
};




const $0989c34268e3b06a$var$FIREFLY_TERMS_TITLE = "Confirm use of images with Adobe Firefly";
const $0989c34268e3b06a$var$FIREFLY_TERMS_BODY = "A new set of image variations will be generated using Adobe Firefly. To use this service, you must have the rights or permission to use any third-party images as reference. You are responsible for ensuring compliance with all copyright and licensing requirements.";
// Generating every variation, as opposed to a list of keys.
const $0989c34268e3b06a$var$GENERATE_ALL = "all";
const $0989c34268e3b06a$var$ImageLibrary = ({ styles: styles, videoId: videoId, queries: queries, onDrop: onDrop, onMenuAction: onMenuAction })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: (0, $5nTep.mergeStyles)(" sd182 _ta182 Ug182 qg182", styles),
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                id: "assets-menu",
                className: " IM182 _Pa182 Wt182 _Au182 _Aoe4mUs182 _zow182 _9G1Ky182"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2da3e6a4b40eb90e$export$b2539bed5023c21c), {
                "aria-label": "Image library",
                density: "compact",
                styles: " Za182 Fb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2da3e6a4b40eb90e$export$e51a686c67fdaa2d), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2da3e6a4b40eb90e$export$3e41faf802a29e71), {
                                id: "extracted",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $abd917d017e8b03f$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Extracted images"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2da3e6a4b40eb90e$export$3e41faf802a29e71), {
                                id: "uploaded",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $HZG6L.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Your assets"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2da3e6a4b40eb90e$export$3d96ec278d3efce4), {
                        id: "extracted",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " Za182 Fb182 Pa182 If182 Hf182 Sh182 Rh182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5062bdc91dde1356$export$76ab5d8aecc34fb6), {
                                videoId: videoId,
                                queries: queries,
                                onMenuAction: onMenuAction
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2da3e6a4b40eb90e$export$3d96ec278d3efce4), {
                        id: "uploaded",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " Za182 Fb182 Pa182 If182 Hf182 Sh182 Rh182",
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $49de88ae0db24967$export$a1eb6fa2125ad52f), {
                                videoId: videoId,
                                onDrop: onDrop,
                                onMenuAction: onMenuAction,
                                styles: " If182 Hf182 Sh182 Rh182"
                            })
                        })
                    })
                ]
            })
        ]
    });
const $0989c34268e3b06a$export$1a81d946ea2efb55 = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel, campaignStructure: campaignStructure, name: name, description: description })=>{
    const { isStepPending: isStepPending, videoId: videoId, template: template, video: video, createVideo: createVideo, updateVideo: updateVideo, customerBranding: customerBranding, selectedCampaign: selectedCampaign, selectedPersona: selectedPersona, selectedAssets: selectedAssets = [], allScrapedQueries: allScrapedQueries, areAllVisualsSelected: areAllVisualsSelected, handleUploadAssets: handleUploadAssets, handleAssetMenuAction: handleAssetMenuAction, handleDownloadAudioMux: handleDownloadAudioMux, audioMuxDownloadUrl: audioMuxDownloadUrl, audioMuxDownloadPending: audioMuxDownloadPending, agreeToTerms: agreeToTerms, setAgreeToTerms: setAgreeToTerms, setEditVariation: setEditVariation, stepActionCtx: stepActionCtx, scrapedColors: scrapedColors, handleColorChange: handleColorChange } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const hasVariations = (0, $eF4cA.useMemo)(()=>(0, $lb17q.getStructureVariationKeys)(campaignStructure).length > 0, [
        campaignStructure
    ]);
    // Rendered by the campaign structure rather than `TemplateAssets`.
    const structureAssetNames = (0, $eF4cA.useMemo)(()=>(0, $lb17q.getStructureAssetNames)(campaignStructure), [
        campaignStructure
    ]);
    const hasStructure = hasVariations || structureAssetNames.length > 0;
    const imageVariations = hasVariations ? stepActionCtx?.imageVariations : null;
    // Arms the pipeline so a variation that was already generated keeps
    // regenerating from the edit dialog; one that never was waits for
    // `generate()`.
    const { run: run } = imageVariations ?? {};
    (0, $eF4cA.useEffect)(()=>{
        run?.();
    }, [
        run
    ]);
    const isVisualsPending = hasVariations && (0, $lb17q.hasPendingStructureVariations)(campaignStructure, imageVariations?.variations, video.data?.assets);
    const isMobile = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isMobile);
    const requiresFireflyTerms = (0, $lb17q.hasImageVariationsStep)(template.data) || hasVariations;
    // Generation needs a campaign to write the prompts for.
    const isGenerateDisabled = !selectedCampaign?.id;
    // A generation waiting for the Firefly terms to be agreed to: the keys to
    // generate, or `GENERATE_ALL`.
    const [pendingGenerate, setPendingGenerate] = (0, $eF4cA.useState)(null);
    const [pendingContinue, setPendingContinue] = (0, $eF4cA.useState)(false);
    const dismissFireflyTerms = ()=>{
        setPendingGenerate(null);
        setPendingContinue(false);
    };
    const handleContinue = ()=>{
        if (isMobile && requiresFireflyTerms && !agreeToTerms) setPendingContinue(true);
        else onContinue();
    };
    const requestGenerate = (keys = $0989c34268e3b06a$var$GENERATE_ALL)=>{
        if (agreeToTerms === true) imageVariations?.generate(keys === $0989c34268e3b06a$var$GENERATE_ALL ? undefined : keys);
        else setPendingGenerate(keys);
    };
    const templateAssets = template.data?.assets || [];
    // The image variations the campaign structure shows count as selected once
    // they have an image, like the assets.
    const variationProgress = hasVariations ? (0, $lb17q.getStructureVariationProgress)(campaignStructure, imageVariations?.variations, video.data?.assets, templateAssets.map((asset)=>asset.name)) : {
        total: 0,
        selected: 0
    };
    const countedAssets = (assets)=>assets?.filter((asset)=>asset.type !== "audio")?.length ?? 0;
    const brandFetchUrl = (()=>{
        try {
            if (video.data?.customer?.["Company-website-URL"]) {
                const companyWebsiteUrl = new URL(video.data?.customer?.["Company-website-URL"]);
                return new URL(companyWebsiteUrl.hostname.replace(/^www\./, ""), "https://brandfetch.com");
            }
            return null;
        } catch (error) {
            return null;
        }
    })();
    if (isStepPending) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
        title: "Setting up your project",
        subtitle: "This may take a few moments, so please keep this tab open.",
        ariaLabel: "Setting up your project",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ab17b54c80fc8a2e$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 _oa182 sd182 _ta182 Uj182 qj182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-h182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gy182",
                                children: name || "Branding & visuals"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 L6kvVdc182 __Wc182",
                                    children: description || "Select images that represent the customer's brand and visual identity. These images will be used to generate tailored content for the video. You can upload images directly or drag and drop images scraped from the customer's website and brand center."
                                })
                            }),
                            (0, $358fce2ffba1b379$export$6e3cfba39daf22d3)(template.data?.id) && !!audioMuxDownloadUrl && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isPending: audioMuxDownloadPending,
                                onPress: ()=>{
                                    handleDownloadAudioMux();
                                },
                                isQuiet: true,
                                size: "S",
                                styles: " Jx182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Download muxed audio"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 ea182 Ue182 qe182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                children: `${countedAssets(selectedAssets) + variationProgress.selected}/${countedAssets(templateAssets) + variationProgress.total} selected`
                            }),
                            !!brandFetchUrl && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                href: brandFetchUrl,
                                target: "_blank",
                                variant: "secondary",
                                staticColor: "auto",
                                size: "S",
                                styles: " Is182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3e0d074d1f629986$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Check brand info"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8jegM.TemplateAssets), {
                        excludedAssetNames: structureAssetNames
                    }),
                    hasStructure && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " sd182 _ta182 Ul182 ql182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7cd28456b648eedc$export$2970d560d3520dd5), {
                            campaignStructure: campaignStructure,
                            selectedCampaign: selectedCampaign,
                            selectedPersona: selectedPersona,
                            // Without the campaign prompt footer, there is nothing to edit
                            // the fields with.
                            canEditCampaign: false,
                            video: video,
                            templateData: template.data,
                            imageVariations: imageVariations,
                            isGenerateDisabled: isGenerateDisabled,
                            onEditVariation: setEditVariation,
                            onGenerateVariation: (variation)=>requestGenerate([
                                    variation.key
                                ]),
                            onUploadVariation: handleUploadAssets,
                            colors: scrapedColors,
                            onUploadAsset: handleUploadAssets,
                            onDeleteAsset: (asset)=>handleAssetMenuAction("delete", asset),
                            onColorChange: handleColorChange,
                            styles: " La182"
                        })
                    })
                ]
            }),
            hasVariations && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3f4d439a6fe8254f$export$603e5e66da0ddcd1), {}),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
                onDismiss: dismissFireflyTerms,
                children: (pendingGenerate !== null || pendingContinue) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5NHyX.AlertDialog), {
                    title: $0989c34268e3b06a$var$FIREFLY_TERMS_TITLE,
                    primaryActionLabel: "Agree",
                    cancelLabel: "Cancel",
                    onPrimaryAction: ()=>{
                        setAgreeToTerms(true);
                        dismissFireflyTerms();
                        if (pendingContinue) onContinue();
                        else imageVariations?.generate(pendingGenerate === $0989c34268e3b06a$var$GENERATE_ALL ? undefined : pendingGenerate);
                    },
                    onCancel: dismissFireflyTerms,
                    children: $0989c34268e3b06a$var$FIREFLY_TERMS_BODY
                })
            }),
            !isMobile && /*#__PURE__*/ (0, $dx4lB.jsx)($0989c34268e3b06a$var$ImageLibrary, {
                videoId: videoId,
                queries: allScrapedQueries,
                onDrop: handleUploadAssets,
                onMenuAction: handleAssetMenuAction,
                styles: " zLpqDSc182 yLpqDSc182 BLpqDSc182 ALpqDSc182 _oa182 _dd182 Nft0rSc182 LhR8Hv182 FCVOBBe182 II182 g_g182 oc182 nc182 kc182 jc182 Tt182 Qh182 Sh182 Rh182 _n4zCLMe182 _Pe182 _lozpine182"
            }),
            isMobile && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Footer, {
                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                    className: (0, $5nTep.mergeStyles)((0, $87bd91c06342e699$export$ae81d1082cb406fc), " Zd182 Te182 Qe182 Se182 Re182 g_g182 oh182 nh182 kh182 jh182 _nLeasBb182"),
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "premium",
                                "aria-label": "Open image library",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2487b8aecf1c0f59$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88lL9.CustomDialog), {
                                size: "fullscreenTakeover",
                                children: ({ close: close })=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)($0989c34268e3b06a$var$ImageLibrary, {
                                                videoId: videoId,
                                                queries: allScrapedQueries,
                                                onDrop: handleUploadAssets,
                                                onMenuAction: handleAssetMenuAction,
                                                styles: " Fb182 JA182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4UbTp.CloseButton), {
                                                styles: " _Pa182 Wt182 _zt182"
                                            })
                                        ]
                                    })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: handleContinue,
                continueLabel: continueLabel,
                continueVariant: "primary",
                isContinueDisabled: !areAllVisualsSelected || !isMobile && requiresFireflyTerms && !agreeToTerms || isVisualsPending,
                children: !isMobile && requiresFireflyTerms && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 Ue182 qe182 eb182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cxTG4.Checkbox), {
                            isSelected: agreeToTerms,
                            isRequired: true,
                            onChange: (isSelected)=>setAgreeToTerms(isSelected),
                            children: $0989c34268e3b06a$var$FIREFLY_TERMS_TITLE
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $5mvex.ContextualHelp), {
                            variant: "info",
                            size: "S",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                    children: $0989c34268e3b06a$var$FIREFLY_TERMS_TITLE
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                    children: $0989c34268e3b06a$var$FIREFLY_TERMS_BODY
                                })
                            ]
                        })
                    ]
                })
            }),
            hasStructure && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: template.isPending,
                onPress: ()=>template.refetch(),
                children: "Refetch template"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: updateVideo.isPending,
                onPress: ()=>{
                    const keys = Array.from((template.data?.imageVariations ?? []).reduce((acc, variation)=>acc.add(variation.key), new Set()));
                    const assetsToRemove = video.data?.assets?.filter((asset)=>keys.includes(asset.name));
                    assetsToRemove?.forEach((asset)=>{
                        if (asset.referenceKey) assetsToRemove.push({
                            name: asset.referenceKey
                        });
                    });
                    const assets = video.data?.assets?.filter((asset)=>!keys.includes(asset.name))?.map(({ labeling: labeling, ...asset })=>asset);
                    updateVideo.mutate({
                        audiencesVariations: null,
                        abstractVariations: null,
                        imageVariations: [],
                        assets: assets
                    });
                },
                children: "Regenerate visuals"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $3g2oV = parcelRequire("3g2oV");
var $208Op = parcelRequire("208Op");


var $77tch = parcelRequire("77tch");

const $2f940d38c0367f4f$export$6ed35711dca5c597 = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel })=>{
    const { video: video, selectedMusicTrackId: selectedMusicTrackId, setSelectedMusicTrackId: setSelectedMusicTrackId, selectedMusicTrackURL: selectedMusicTrackURL, groupedMusicTracks: groupedMusicTracks, updateVideo: updateVideo, customerBranding: customerBranding } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 eb182 Up182 qp182 Za182 Fb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: "Select a music track",
                        subtitle: "Choose the track that sets the tone for your video."
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 eb182 Uj182 qj182 Za182 LEmhfb182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                label: "Music track",
                                labelPosition: "side",
                                items: groupedMusicTracks,
                                selectedKey: video.data?.musicPath ?? selectedMusicTrackId,
                                onSelectionChange: (key)=>{
                                    if (key != null) {
                                        setSelectedMusicTrackId(key);
                                        updateVideo.mutate({
                                            musicPath: key
                                        });
                                    }
                                },
                                children: (group)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$a340772aca6155cd), {
                                        id: group.section,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Header), {
                                                children: group.label
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                                                items: group.items,
                                                children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                        id: item.id,
                                                        textValue: item.label,
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                slot: "label",
                                                                children: item.label
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                slot: "description",
                                                                children: item.description
                                                            })
                                                        ]
                                                    })
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " Za182 Sf182 Rf182 Te182 Qe182 gqlRAZb182 ob182 nb182 kb182 jb182 _n4zCLMe182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $133e7baa0382ff89$export$832cc5475f11d8b4), {
                                    url: selectedMusicTrackURL.data?.presignURL,
                                    isAudioJobScheduled: selectedMusicTrackURL.isLoading,
                                    isEditorEmpty: !selectedMusicTrackURL.data?.presignURL
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueLabel: continueLabel,
                isContinueDisabled: !video.data?.campaigns?.length || customerBranding.isEnabled && customerBranding.isPending
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $bsn7e = parcelRequire("bsn7e");
var $j3pTw = parcelRequire("j3pTw");
var $fZShI = parcelRequire("fZShI");
var $j8RRT = parcelRequire("j8RRT");

var $lb17q = parcelRequire("lb17q");

var $77tch = parcelRequire("77tch");

var $8ZsKk = parcelRequire("8ZsKk");

var $iXKEI = parcelRequire("iXKEI");


/** Stable empty fallback, so the memos below don't see a new array each render. */ const $79ba6d1f584cc93a$var$NONE = [];
const $79ba6d1f584cc93a$export$abd911c5be1a3132 = ({ name: name, onContinue: onContinue, onBack: onBack, continueLabel: continueLabel })=>{
    const { template: template, video: video, updateVideo: updateVideo, selectedCampaign: selectedCampaign, customerName: customerName, taglinesData: taglinesData, handleTaglineChange: handleTaglineChange, editVariation: editVariation, setEditVariation: setEditVariation, handleUploadAssets: handleUploadAssets, stepActionCtx: stepActionCtx } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    // Generation is owned by the wizard (see `useImageVariations`), so it starts
    // when the step is entered and keeps going while it is displayed. Everything
    // rendered below — the reference groups of this step's stages, their
    // variations and their progress — comes from there.
    const imageVariations = stepActionCtx?.imageVariations;
    const stageGroups = imageVariations?.groups ?? $79ba6d1f584cc93a$var$NONE;
    const stageVariations = imageVariations?.variations ?? $79ba6d1f584cc93a$var$NONE;
    // Entering the step arms the pipeline through the step action. Landing on it
    // directly — a reload, or a resumed project — never goes through that, so it
    // is armed here too; arming twice is a no-op.
    const { run: run } = imageVariations ?? {};
    (0, $eF4cA.useEffect)(()=>{
        run?.();
    }, [
        run
    ]);
    const isContinueDisabled = (0, $eF4cA.useMemo)(()=>!stageVariations.length || stageVariations.some((variation)=>!video.data?.assets?.find?.((img)=>img.name === variation.key)), [
        stageVariations,
        video.data?.assets
    ]);
    const isFireflyKeyVisuals = (0, $eF4cA.useMemo)(()=>{
        console.log("step", stepActionCtx);
        return video.data?.templateId === "firefly-enterprise" && video.data?.currentStep === (0, $lb17q.WIZARD_STEP).IMAGES_PLANNING;
    }, [
        video.data?.templateId,
        video.data?.currentStep
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: name ?? "Images variations",
                        subtitle: isFireflyKeyVisuals ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                "Confirm the cleaned, upscaled version of your reference photo.",
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                "Once confirmed, it's split into a background and an isolated subject, then generated into variations."
                            ]
                        }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                "Review the generated image variations for each campaign.",
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                "You can edit the variations or generate new ones if needed."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " sd182 _ta182 eb182 Uj182 qj182",
                        children: stageGroups.map((group, idx)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 Ur182 qr182 _n4zCLMe182 _oa182 La182 IM182 HM182 Th182 Qh182 Sh182 Rh182 oc182 nc182 kc182 jc182 gX182",
                                children: [
                                    video.data?.templateId === "csc-overview" && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                            size: "XL",
                                            variant: "quiet",
                                            styles: " Zt182",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "title",
                                                        children: `Campaign variation ${idx + 1}`
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                                        styles: " Jz182",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                                label: "Campaign name",
                                                                value: taglinesData[idx]?.name ?? selectedCampaign?.taglines?.[idx]?.name ?? `${customerName} ${template.data?.campaignLines?.[idx] || `${idx + 1} campaign`}`,
                                                                onChange: (value)=>handleTaglineChange(idx, "name", value)
                                                            }),
                                                            !!selectedCampaign?.taglines?.length ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                                        label: "Tagline",
                                                                        defaultValue: taglinesData[idx]?.en ?? selectedCampaign?.taglines?.[idx]?.en,
                                                                        onChange: (value)=>handleTaglineChange(idx, "en", value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                                                        label: "Tagline",
                                                                        contextualHelp: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                            slot: "description",
                                                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                                                            children: "(ES)"
                                                                        }),
                                                                        defaultValue: taglinesData[idx]?.es ?? selectedCampaign?.taglines?.[idx]?.es,
                                                                        onChange: (value)=>handleTaglineChange(idx, "es", value)
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                className: " sd182 eb182 Ue182 qe182 Iv182",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                                        isIndeterminate: true,
                                                                        size: "S",
                                                                        staticColor: "auto",
                                                                        "aria-label": "Generating taglines"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                                                        children: "Generating taglines"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    typeof selectedCampaign?.id !== "undefined" ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8ZsKk.ImageVariations), {
                                        group: group,
                                        assets: video.data?.assets,
                                        referenceUrlByPath: imageVariations?.referenceUrlByPath,
                                        generatingKeys: imageVariations?.generatingKeys,
                                        skipImageLabeling: imageVariations?.skipImageLabeling,
                                        isLabeled: imageVariations?.labeling?.isLabeled,
                                        templateData: template.data,
                                        isLoading: video.isLoading,
                                        onEditVariation: setEditVariation,
                                        onUploadReference: handleUploadAssets,
                                        onRegenerate: ()=>run?.({
                                                force: true,
                                                keys: group.keys
                                            })
                                    }, group.id) : null
                                ]
                            }, group.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bsn7e.DialogContainer), {
                onDismiss: ()=>setEditVariation(null),
                children: !!editVariation && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iXKEI.EditVariationDialog), {
                    videoId: video.data?.id,
                    variationKey: editVariation.key,
                    referenceKey: editVariation.referenceKey,
                    isReferenceAsset: !!editVariation.isReferenceAsset,
                    onUpload: handleUploadAssets
                }, JSON.stringify([
                    video.data?.id,
                    editVariation.key
                ]))
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueVariant: "primary",
                continueLabel: continueLabel,
                isContinueDisabled: isContinueDisabled
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: updateVideo.isPending,
                onPress: ()=>{
                    const keys = Array.from(stageVariations.filter((variation)=>!!variation.type).reduce((acc, variation)=>acc.add(variation.key), new Set()));
                    const assets = video.data?.assets?.filter((asset)=>!keys.includes(asset.name))?.map(({ labeling: labeling, ...asset })=>asset);
                    updateVideo.mutate({
                        audiencesVariations: null,
                        abstractVariations: null,
                        // Keep the variations belonging to the other stages intact.
                        imageVariations: video.data?.imageVariations?.filter((variation)=>!keys.includes(variation.key)) ?? [],
                        templateAssetsRenditions: [],
                        templateAssetsRenditionFiles: [],
                        assets: assets
                    });
                },
                children: "Regenerate visuals"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isPending: template.isPending,
                onPress: ()=>template.refetch(),
                children: "Refetch template"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $8g9SZ = parcelRequire("8g9SZ");
var $34HUQ = parcelRequire("34HUQ");
var $fZShI = parcelRequire("fZShI");
var $91SAk = parcelRequire("91SAk");



var $klXmP = parcelRequire("klXmP");


var $77tch = parcelRequire("77tch");


const $78c0aabe26c22ad2$export$75eed4f7b66b4e2e = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel })=>{
    const { template: template, video: video, updateVideo: updateVideo, assetsTemplate: assetsTemplate, bannersStatus: bannersStatus, generateBanners: generateBanners, exportBanners: exportBanners, downloadAllAssets: downloadAllAssets, regenerateBannersFromCurrentAssets: regenerateBannersFromCurrentAssets } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Za182 Fb182 LvuBnEc182 IM182 HM182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: "Final campaign assets",
                        subtitle: "These banners combine your brand, message, and generated visuals."
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Heading), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 sd182 ea182 Ue182 qe182 Js182 Gy182",
                        children: [
                            !!bannersStatus && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ue182 qe182 Iv182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                        isIndeterminate: true,
                                        size: "S",
                                        staticColor: "auto",
                                        "aria-label": "Generating assets renditions"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                        children: bannersStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $waxwa.ActionButtonGroup), {
                                isQuiet: true,
                                staticColor: "auto",
                                styles: " IM182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                        isDisabled: generateBanners.isPending || exportBanners.isFetching,
                                        onPress: ()=>exportBanners.refetch(),
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Refresh"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                        isPending: downloadAllAssets.isPending,
                                        isDisabled: !!bannersStatus,
                                        onPress: ()=>downloadAllAssets.mutate(),
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Download all"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                        isDisabled: !video.data?.templateAssetsRenditions?.[0]?.documentId,
                                        href: `https://new.express.adobe.com/id/${video.data?.templateAssetsRenditions?.[0]?.documentId}`,
                                        target: "_blank",
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Edit in Express"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e5c03cbecd05b517$export$7e52c821f7b6f422), {
                        layout: "waterfall",
                        variant: "quiet",
                        size: "L",
                        selectionMode: "none",
                        "aria-label": "Assets variations",
                        children: assetsTemplate.data?.pages?.map((apiPage)=>apiPage.documentPages.map((page)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.Card), {
                                    textValue: page.pageTitle || `Page ${page.pageNumber}`,
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                                            isLoading: generateBanners.isPending || exportBanners.isFetching,
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                src: exportBanners.data?.find((rendition)=>rendition.pageNumber === page.pageNumber)?.renditionUrl,
                                                alt: page.pageTitle || `Page ${page.pageNumber}`,
                                                styles: " _He182",
                                                UNSAFE_style: {
                                                    aspectRatio: `${page.size.width} / ${page.size.height}`
                                                }
                                            })
                                        })
                                    })
                                }, page.pageTitle + page.pageNumber)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueVariant: "genai",
                continueLabel: continueLabel,
                isContinueDisabled: !!template.data?.assetsTemplateId ? !exportBanners.isSuccess || exportBanners.isFetching || generateBanners.isPending : false
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isDisabled: !video.data?.videoPath && !video.data?.expressId || updateVideo.isPending,
                onPress: ()=>{
                    updateVideo.mutate({
                        status: null,
                        expressId: null,
                        videoPath: null
                    });
                },
                children: "Clear video data"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isDisabled: updateVideo.isPending || generateBanners.isPending || exportBanners.isFetching,
                onPress: regenerateBannersFromCurrentAssets,
                children: "Regenerate"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $k7O9T = parcelRequire("k7O9T");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $fZShI = parcelRequire("fZShI");



var $77tch = parcelRequire("77tch");


var $dx4lB = parcelRequire("dx4lB");

var $ittHc = parcelRequire("ittHc");

var $fZShI = parcelRequire("fZShI");
var $208Op = parcelRequire("208Op");

var $iMKxE = parcelRequire("iMKxE");
const $55e8506727102aab$var$cardStyle = " sd182 _ta182 eb182 Ug182 qg182";
const $55e8506727102aab$var$mediaStyle = " sb182 ZILqIYb182 flgmljb182 ob182 nb182 kb182 jb182";
const $55e8506727102aab$var$placeholderStyle = " ZILqIYb182 flgmljb182 sd182 eb182 _Ca182 ob182 nb182 kb182 jb182 glJKI8182";
const $55e8506727102aab$var$ModularVideoCard = ({ name: name, videoUrl: videoUrl, isFailed: isFailed })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: $55e8506727102aab$var$cardStyle,
        children: [
            videoUrl ? /*#__PURE__*/ (0, $dx4lB.jsx)("video", {
                src: videoUrl,
                controls: true,
                className: $55e8506727102aab$var$mediaStyle
            }) : /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: $55e8506727102aab$var$placeholderStyle,
                children: isFailed ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pq182",
                    children: "Render failed"
                }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                    isIndeterminate: true,
                    size: "L",
                    staticColor: "auto",
                    "aria-label": `Generating ${name}\u{2026}`
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                children: name
            })
        ]
    });
const $55e8506727102aab$export$a75bf8f75bdfeb9e = ({ jobs: jobs = [] })=>{
    const results = (0, $ittHc.useQueries)({
        queries: jobs.map((job)=>(0, $iMKxE.jobStatusQueryOptions)(job.jobId))
    });
    const cards = jobs.map((job, i)=>({
            jobId: job.jobId,
            name: `${job.name} ${i + 1}`,
            videoUrl: results[i]?.data?.outputs?.[0]?.destination?.url,
            isFailed: results[i]?.data?.status === "failed" || results[i]?.isError
        }));
    const allReady = cards.length > 0 && cards.every((c)=>!!c.videoUrl);
    const total = cards.length;
    const doneCount = cards.filter((c)=>!!c.videoUrl || c.isFailed).length;
    const failedCount = cards.filter((c)=>c.isFailed).length;
    const statusText = allReady ? "Merging videos\u2026" : doneCount === 0 ? "Starting video generation\u2026" : `Rendering video ${doneCount} of ${total}\u{2026}`;
    const progressValue = allReady ? total + 1 : doneCount;
    const progressMax = total + 1 + 2;
    var card;
    return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " Zb4QY4182 IM182 HM182 Jq182 flgmljb182 sd182 eb182 _Ca182 ob182 nb182 kb182 jb182 glJKI8182",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
            isIndeterminate: progressValue === 0,
            value: progressValue,
            maxValue: progressMax,
            size: "L",
            staticColor: "auto",
            "aria-label": "Generating video\u2026"
        })
    });
};




const $a9a34fc87401f425$export$d4f6825887bd71a1 = ()=>{
    const { videoId: videoId, template: template, video: video, generateVideo: generateVideo, exportVideo: exportVideo, exportBanners: exportBanners, updateVideo: updateVideo, isVideoRendered: isVideoRendered, downloadVideoUrl: downloadVideoUrl, renderProgress: renderProgress, generateStatusText: generateStatusText, statusTextIndex: statusTextIndex } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const generateError = generateVideo.error;
    const hasExpressError = video.data?.templateType === "express" && generateVideo.isError && !generateVideo.isPending && !(0, $k7O9T.isCancelledError)(generateError) && generateError?.cause?.problem !== "CANCEL_ERROR";
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Us182 qs182",
                children: [
                    !hasExpressError && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: "We're crafting your branded video",
                        children: template.data?.type === "express" ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _Wa182",
                            children: [
                                "This may take a few minutes - don't close this tab.",
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                "Once your video is ready, we will send you an email with the link."
                            ]
                        }) : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _Wa182",
                            children: [
                                "This can take up to 35 minutes.",
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                "You don't need to keep this tab open \u2014 we'll email you a link as soon as it's ready."
                            ]
                        })
                    }),
                    hasExpressError ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
                        title: "Video generation failed",
                        onRetry: ()=>generateVideo.mutate({
                                videoId: videoId,
                                templateAssetsRenditions: exportBanners.data
                            }),
                        children: generateError?.message || "Something went wrong. Please try again."
                    }) : video.data?.templateType === "modular" && !video.data?.videoPath ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $55e8506727102aab$export$a75bf8f75bdfeb9e), {
                        jobs: video.data?.modularJobs ?? []
                    }) : /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 eb182 _Ca182 Ur182 qr182 Jq182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                styles: " Lb4QY4182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " zTZ8xtd182 yTZ8xtd182 BTZ8xtd182 ATZ8xtd182 sd182 _ta182 eb182 _Ca182 Ug182 qg182 IM182 HM182 Gx182",
                                        children: [
                                            isVideoRendered ? /*#__PURE__*/ (0, $dx4lB.jsx)("video", {
                                                src: downloadVideoUrl ?? undefined,
                                                poster: generateVideo?.data?.document?.thumbnailUrl || "",
                                                controls: true,
                                                className: " sb182 Zb4QY4182 flgmljb182 ob182 nb182 kb182 jb182"
                                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " Zb4QY4182 flgmljb182 sd182 eb182 _Ca182 ob182 nb182 kb182 jb182 glJKI8182",
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                    isIndeterminate: !renderProgress,
                                                    value: renderProgress,
                                                    size: "L",
                                                    staticColor: "auto",
                                                    "aria-label": "Generating video\u2026"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                                children: isVideoRendered ? generateVideo?.data?.document?.name?.replace?.(/\.express$/, "") : generateStatusText[statusTextIndex] || "Generating video\u2026"
                                            })
                                        ]
                                    }),
                                    isVideoRendered ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        children: "Your video is ready"
                                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        children: "Generating your video"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                        children: isVideoRendered ? video.data?.templateType === "express" ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "Download the video file directly or open in Adobe Express to review and edit."
                                        }) : null : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: "We're crafting your new branded video. This may take a few moments."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                        styles: " JA182",
                                        children: [
                                            video.data?.templateType === "express" && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                                isDisabled: !video.data?.expressId || generateVideo.isPending,
                                                variant: "secondary",
                                                fillStyle: "outline",
                                                href: `https://new.express.adobe.com/id/${video?.data?.expressId}?category=none`,
                                                target: "_blank",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Open in Express"
                                                    })
                                                ]
                                            }),
                                            downloadVideoUrl ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                                                variant: "accent",
                                                href: downloadVideoUrl,
                                                download: `${video.data.name}.mp4`,
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Download video"
                                                })
                                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                                variant: "accent",
                                                isDisabled: true,
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Download video"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isVideoRendered && video.data?.id && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5e54d0a0882391be$export$ce3b880e766d1e30), {
                                variant: "inline",
                                title: "How did your video turn out?",
                                video: video.data,
                                currentStep: "video-view",
                                method: "inline",
                                styles: " Za182 L6Neosc182"
                            }),
                            isVideoRendered && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                size: "XS",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        children: "Do you need help with your project?"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                        size: "S",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                                            variant: "secondary",
                                            href: "https://adobe.ly/ExperienceDesign-Request",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Request design assist"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2986841c3e3fe42c$export$b8e94d7b6b59071b), {
                isDisabled: !exportVideo.data?.presignURL,
                onPress: ()=>{
                    updateVideo.mutate({
                        expressId: null,
                        videoPath: null
                    }, {
                        onSuccess: ()=>generateVideo.mutateAsync({
                                videoId: videoId,
                                templateAssetsRenditions: exportBanners.data
                            })
                    });
                },
                children: "Regenerate"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $9eyCh = parcelRequire("9eyCh");

var $ittHc = parcelRequire("ittHc");

var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $8OJ2z = parcelRequire("8OJ2z");
var $aQTiM = parcelRequire("aQTiM");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $3YPmU = parcelRequire("3YPmU");

var $k5Pnh = parcelRequire("k5Pnh");

var $klXmP = parcelRequire("klXmP");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $be36e41d00ea636f$var$$8a2c1345cf946c3a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M18 15.75V4.25C18 3.01 16.99 2 15.75 2H4.25C3.01 2 2 3.01 2 4.25v3.718c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.414.336-.75.75-.75h11.5c.414 0 .75.336.75.75v11.5c0 .414-.336.75-.75.75h-3.811c-.414 0-.75.336-.75.75s.336.75.75.75h3.811c1.24 0 2.25-1.01 2.25-2.25"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M11 9.75v4.243c0 .414-.336.75-.75.75s-.75-.336-.75-.75V11.56l-6.47 6.47c-.146.146-.338.219-.53.219s-.384-.073-.53-.22c-.293-.293-.293-.767 0-1.06l6.47-6.47H6.006c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.243c.414 0 .75.336.75.75"
            })
        ]
    });
const $be36e41d00ea636f$var$$8a2c1345cf946c3a$var$ForwardRef = (0, $eF4cA.forwardRef)($be36e41d00ea636f$var$$8a2c1345cf946c3a$var$SvgComponent);
var $be36e41d00ea636f$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($be36e41d00ea636f$var$$8a2c1345cf946c3a$var$ForwardRef);



var $cHCEM = parcelRequire("cHCEM");

var $77tch = parcelRequire("77tch");


var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");

var $fmJ8d = parcelRequire("fmJ8d");


var $iLDMH = parcelRequire("iLDMH");

const $66902db9f886f3ac$var$tabButtonStyle = function anonymous(props) {
    let rules = " ";
    rules += ' sh182';
    rules += ' ea182';
    rules += ' UssxDec182';
    rules += ' qssxDec182';
    rules += ' SclxKNe182';
    rules += ' SoIgU9fe182';
    rules += ' RclxKNe182';
    rules += ' RoIgU9fe182';
    rules += ' Tt182';
    rules += ' Qt182';
    rules += ' oc182';
    rules += ' ooh182';
    rules += ' nc182';
    rules += ' noh182';
    rules += ' kc182';
    rules += ' koh182';
    rules += ' jc182';
    rules += ' joh182';
    rules += ' _ka182';
    rules += ' ha182';
    rules += ' ma182';
    rules += ' la182';
    if (props.variant === "active") rules += ' gf182';
    else if (props.isHovered) rules += ' g2clXAd182';
    else rules += ' g9182';
    rules += ' Yc182';
    rules += ' Xb182';
    rules += ' _2b182';
    rules += ' _Wd182';
    return rules;
};
const $66902db9f886f3ac$var$TabButton = ({ variant: variant, onPress: onPress, children: children })=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        variant: variant === "active" ? "active" : "quiet",
        onPress: onPress,
        className: (renderProps)=>$66902db9f886f3ac$var$tabButtonStyle({
                ...renderProps,
                variant: variant,
                staticColor: "auto"
            }),
        children: children
    });
const $66902db9f886f3ac$var$FigmaDeckDuplicate = ({ video: video, assets: assets, figmaTemplatePath: figmaTemplatePath, variant: variant = "accent" })=>{
    const figmaTemplateUrl = figmaTemplatePath ? `https://www.figma.com/${figmaTemplatePath}/duplicate` : undefined;
    const [figmaLicense, setFigmaLicense] = (0, $eF4cA.useState)("collab");
    const s3AssetsQueries = (0, $ittHc.useQueries)({
        queries: assets.map((asset)=>(0, $a8sj2.presignURLQueryOptions)(asset?.filePath))
    });
    const brandColor = video.data?.customer?.["Brand-color"];
    const secondaryColor = video.data?.customer?.["Secondary-color"];
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " _dc182 sd182 _ta182 eb182 Up182 qp182 Za182 _oa182 LHkcGle182 Th182 Tok182 Qh182 Qok182 Sh182 Sok182 Rh182 Rok182 g_g182 _n4zCLMe182 oe182 ne182 ke182 je182 IM182 HM182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182 Gx182 _Wa182",
                        children: "You need a Figma Collab license to proceed"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 _toc182 _vb182 Na182 Ub182 qb182 Tt182 Qt182 St182 Rt182 oe182 ooh182 ne182 noh182 ke182 koh182 je182 joh182 gqlRAZb182 _kb182 hb182 mb182 lb182 _jf182 i0slXAd182 GC182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)($66902db9f886f3ac$var$TabButton, {
                                variant: figmaLicense === "collab" ? "active" : "quiet",
                                onPress: ()=>setFigmaLicense("collab"),
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8OJ2z.CenterBaseline), {
                                        styles: " sh182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $cHCEM.default), {
                                            styles: " Zl182 Fm182"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 uok182 uocJ9TBTb182 uod3Euai182 uoea182 uogb182 uohd182 uoje182 uo2NhKxcl182 uoic182 -_6BNtrc-b182 vx182 -_6BNtrc-oc182 vox182 xb182 _xa182 xob182 _xoa182 _Fd182 _FnuYUweb182 _Fod182 _FonuYUweb182 pt182 pot182",
                                        children: "I have a Collab or Full Figma license"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)($66902db9f886f3ac$var$TabButton, {
                                variant: figmaLicense === "restricted" ? "active" : "quiet",
                                onPress: ()=>setFigmaLicense("restricted"),
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 uok182 uocJ9TBTb182 uod3Euai182 uoea182 uogb182 uohd182 uoje182 uo2NhKxcl182 uoic182 -_6BNtrc-b182 vx182 -_6BNtrc-oc182 vox182 xb182 _xa182 xob182 _xoa182 _Fd182 _FnuYUweb182 _Fod182 _FonuYUweb182 pt182 pot182",
                                    children: "I only have Viewer license (or none)"
                                })
                            })
                        ]
                    })
                ]
            }),
            figmaLicense === "collab" && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 603 211",
                        className: " Za182 LEmhfb182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "222.226",
                                height: "135.195",
                                x: "359.83",
                                y: "75.579",
                                fill: "#000",
                                fillOpacity: ".25",
                                rx: "5.273"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("mask", {
                                id: "a",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                    d: "M572.021 87.625c1.126.594 1.126 2.206 0 2.799l-4.121 2.173a1.582 1.582 0 0 1-2.32-1.4v-4.345a1.582 1.582 0 0 1 2.32-1.4z"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                stroke: "#fff",
                                strokeOpacity: ".5",
                                strokeWidth: "1.055",
                                d: "M565.58 86.852v4.345a1.582 1.582 0 0 0 2.32 1.4l4.121-2.173c1.126-.593 1.126-2.205 0-2.799l-4.121-2.172a1.582 1.582 0 0 0-2.32 1.399Z",
                                mask: "url(#a)"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "39.714",
                                height: "28.729",
                                x: "314.201",
                                y: "75.579",
                                fill: "#000",
                                fillOpacity: ".25",
                                rx: "2.636"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "39.714",
                                height: "28.729",
                                x: "314.201",
                                y: "111.068",
                                fill: "#000",
                                fillOpacity: ".25",
                                rx: "2.636"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "39.714",
                                height: "28.729",
                                x: "314.201",
                                y: "146.557",
                                fill: "#000",
                                fillOpacity: ".25",
                                rx: "2.636"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "39.714",
                                height: "28.729",
                                x: "314.201",
                                y: "182.045",
                                fill: "#000",
                                fillOpacity: ".25",
                                rx: "2.636"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                fill: "#fff",
                                d: "M418.236 137.578h3.246c.133 0 .171.019.209.133.911 2.847 1.31 4.878 1.557 5.676a270 270 0 0 1 1.613-5.657c.038-.114.095-.152.209-.152h2.79c.095 0 .152.038.114.171-1.253 3.967-3.208 9.225-4.688 12.661-.038.114-.076.171-.304.19l-2.98.209c-.133 0-.19-.095-.133-.209a262 262 0 0 0 1.727-3.626c.057-.133.076-.209.019-.36-.626-1.481-2.581-6.378-3.511-8.903-.038-.095 0-.133.132-.133m-7.26 0h2.6c.152 0 .209.057.266.209.114.228.209.778.247 1.215.683-.949 1.86-1.557 3.056-1.614.152 0 .19.057.19.171v2.999c0 .114-.038.171-.209.171-1.063-.038-2.297.285-2.885.892v5.296c0 .133-.057.171-.19.171h-2.904c-.152 0-.228-.038-.228-.19v-6.472c0-.855-.019-1.975-.095-2.715 0-.095.038-.133.152-.133m-6.512-.19c3.284 0 4.859 2.392 4.859 4.879 0 3.151-2.031 5.011-4.935 5.011-3.455 0-4.955-2.392-4.955-4.935 0-2.848 1.975-4.955 5.031-4.955m-.095 2.544c-.93 0-1.576.835-1.576 2.373 0 1.518.646 2.429 1.633 2.429.949 0 1.575-.816 1.575-2.391 0-1.443-.531-2.411-1.632-2.411m-5.915 4.878v1.88c0 .113-.038.208-.152.265-.588.247-1.176.323-1.936.323-1.841 0-2.885-.892-2.885-2.866v-4.271h-1.101c-.114-.019-.152-.076-.152-.209v-2.183c0-.133.038-.171.19-.171h1.082c.038-.626.095-1.632.228-2.221.019-.114.076-.17.19-.189l2.809-.342c.095-.019.171-.019.171.133-.038.569-.076 1.67-.095 2.619h1.556c.133 0 .171.038.171.152v2.24c0 .133-.038.152-.152.171h-1.594v3.492c0 .817.209 1.101.949 1.101.19 0 .285-.019.569-.076.076-.019.152.019.152.152m-11.946 2.468c-1.442 0-2.6-.228-3.473-.645-.133-.057-.171-.152-.171-.342v-2.696c0-.113.076-.189.189-.113a7.2 7.2 0 0 0 3.702.987c1.196 0 1.613-.323 1.613-.779 0-.455-.322-.702-1.594-1.214l-.854-.323c-2.145-.873-3.056-2.012-3.056-3.702 0-1.955 1.423-3.872 4.897-3.872 1.177 0 2.316.171 3.056.475.114.038.133.133.133.265v2.601c0 .076-.057.171-.19.095-.835-.456-2.012-.684-3.132-.684-1.177 0-1.556.399-1.556.817 0 .379.17.664 1.613 1.196l.759.284c2.677.987 3.265 2.221 3.265 3.797 0 2.543-2.183 3.853-5.201 3.853m48.195-22.081h-3.474c.095.74.797 1.442 2.43 1.442.911 0 1.613-.151 2.334-.398.057-.019.133-.019.133.114v2.069c0 .19-.057.228-.152.284-.816.361-1.727.532-3.056.532-3.72 0-5.049-2.43-5.049-4.802 0-2.582 1.595-5.031 4.765-5.031 3.075 0 4.27 2.202 4.27 4.271 0 .494-.037.987-.094 1.31-.019.076-.076.133-.171.152a26 26 0 0 1-1.936.057m-3.493-2.088h1.803c.418 0 .722-.019.797-.038v-.076c-.019-.645-.455-1.253-1.252-1.253-.911 0-1.329.721-1.348 1.367m-13.781-7.346h2.943c.17 0 .208.038.208.19l-.019 3.587a6.4 6.4 0 0 1 1.519-.152c2.866 0 4.594 2.05 4.594 4.575 0 3.189-2.601 5.315-5.809 5.315-1.499 0-2.543-.19-3.474-.513-.075-.019-.132-.113-.132-.208v-12.623q0-.171.17-.171m5.866 8.485c0-1.822-.987-2.297-2.012-2.297-.209 0-.494.038-.703.076v4.65c.171.038.361.057.589.057 1.177 0 2.126-.816 2.126-2.486m-12.492-4.86c3.284 0 4.86 2.392 4.86 4.879 0 3.151-2.031 5.011-4.936 5.011-3.454 0-4.954-2.392-4.954-4.935 0-2.848 1.974-4.955 5.03-4.955m-.095 2.544c-.93 0-1.575.835-1.575 2.373 0 1.518.645 2.429 1.632 2.429.949 0 1.576-.816 1.576-2.391 0-1.443-.532-2.411-1.633-2.411m-10.877 7.346c-2.923 0-5.087-1.689-5.087-4.878 0-2.658 1.879-5.012 5.58-5.012.266 0 .399 0 .532.019v-3.492c0-.095.038-.152.133-.152h3.056c.095 0 .114.038.114.133v10.611c0 .55.019 1.271.057 1.689.019.133 0 .171-.114.228a11.7 11.7 0 0 1-4.271.854m1.025-2.62v-4.669c-.114-.019-.304-.076-.589-.076-1.063 0-2.126.702-2.126 2.354 0 1.632.836 2.467 2.069 2.467.285 0 .475-.038.646-.076m-10.893-.038h-3.91l-.722 2.278c-.038.152-.114.19-.246.19h-2.772c-.171 0-.209-.076-.171-.228l3.607-10.554c.076-.208.152-.512.209-1.366 0-.114.038-.171.133-.171h3.758c.095 0 .133.019.171.114l4.214 11.996c.038.152 0 .209-.133.209h-3.113c-.114 0-.171-.038-.228-.152zm-3.189-2.809h2.43c-.361-1.272-.836-2.885-1.215-4.309h-.019c-.304 1.348-.835 3.132-1.196 4.309m27.204-17.614h-3.473c.095.74.797 1.442 2.429 1.442.911 0 1.614-.151 2.335-.398.057-.019.133-.019.133.114v2.069c0 .19-.057.228-.152.284-.816.361-1.727.532-3.056.532-3.72 0-5.049-2.43-5.049-4.802 0-2.582 1.594-5.031 4.764-5.031 3.075 0 4.271 2.202 4.271 4.271 0 .494-.038.987-.095 1.31-.019.076-.076.133-.171.152-.227.019-.892.057-1.936.057m-3.492-2.088h1.803c.418 0 .721-.019.797-.038v-.076c-.019-.645-.455-1.253-1.253-1.253-.911 0-1.328.721-1.347 1.367m-13.896 5.77v-7.08c0-.626-.038-1.556-.076-2.05-.019-.114.019-.171.133-.171h2.524c.19 0 .247.038.304.171.095.171.133.323.171.513a4.13 4.13 0 0 1 2.6-.874c1.538 0 3.303.874 3.303 3.911v5.599c0 .133-.057.19-.189.19h-2.905c-.133 0-.209-.057-.209-.19v-5.523c0-.836-.417-1.31-1.176-1.31-.437 0-.798.152-1.177.436v6.416q0 .171-.171.171h-2.942c-.114 0-.19-.038-.19-.209m-7.652-12.299c3.891 0 6.036 2.998 6.036 6.263 0 3.834-2.335 6.435-6.093 6.435s-6.036-2.601-6.036-6.359c0-3.493 2.315-6.34 6.093-6.34m-2.677 6.339c0 2.069.968 3.569 2.715 3.569 1.632 0 2.581-1.253 2.581-3.55 0-2.145-.911-3.55-2.676-3.55-1.689 0-2.62 1.424-2.62 3.531",
                                opacity: ".5"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("foreignObject", {
                                x: "383",
                                y: "181",
                                width: "185.6",
                                height: "22.7",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                    xmlns: "http://www.w3.org/1999/xhtml",
                                    className: "customer-name",
                                    style: {
                                        fontSize: "12.13px",
                                        lineHeight: "18.45px",
                                        fontWeight: 900,
                                        fontFamily: "Adobe Clean",
                                        color: "#fff",
                                        textAlign: "left",
                                        display: "inline-block",
                                        opacity: 0.5
                                    },
                                    children: video.data?.customer?.name
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "83.648",
                                height: "56.952",
                                x: "51.633",
                                y: "49.833",
                                fill: "url(#b)",
                                opacity: ".25",
                                rx: "4.746"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                width: "43.307",
                                height: "29.662",
                                y: "34.776",
                                fill: "url(#c)",
                                opacity: ".1",
                                rx: "4.746"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                                filter: "url(#d)",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                    width: "177.974",
                                    height: "121.615",
                                    x: "126.668",
                                    y: "25.509",
                                    fill: "url(#e)",
                                    rx: "4.746",
                                    shapeRendering: "crispEdges"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                                filter: "url(#f)",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                    width: "61.104",
                                    height: "59.325",
                                    x: "263.113",
                                    y: "108.564",
                                    fill: "url(#g)",
                                    rx: "4.746",
                                    shapeRendering: "crispEdges"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                                filter: "url(#h)",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                    width: "27.883",
                                    height: "27.883",
                                    x: "118.363",
                                    y: "17.797",
                                    fill: brandColor,
                                    rx: "2.966"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("g", {
                                filter: "url(#i)",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                    width: "27.883",
                                    height: "27.883",
                                    x: "84.547",
                                    y: "31.442",
                                    fill: secondaryColor,
                                    rx: "2.966"
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("g", {
                                clipPath: "url(#j)",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                        fill: "#00B6FF",
                                        d: "M596.539 196.598c0-1.313 1.084-2.376 2.42-2.376h.35l.03-.001c1.499 0 2.715 1.195 2.715 2.667s-1.216 2.667-2.715 2.667l-.03-.001-.35.001c-1.336 0-2.42-1.065-2.42-2.377z"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                        fill: "#24CB71",
                                        d: "M591.055 202.222c0-1.473 1.215-2.667 2.715-2.667h2.77v2.639c0 1.488-1.242 2.694-2.757 2.694-1.499 0-2.728-1.194-2.728-2.666"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                        fill: "#FF7237",
                                        d: "M596.539 188.888v5.334h2.8c1.499 0 2.715-1.195 2.715-2.667 0-1.473-1.216-2.667-2.715-2.667z"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                        fill: "#FF3737",
                                        d: "M591.055 191.555c0 1.473 1.215 2.667 2.715 2.667h2.77v-5.333h-2.771c-1.499 0-2.714 1.194-2.714 2.666"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                        fill: "#874FFF",
                                        d: "M591.055 196.888c0 1.473 1.215 2.667 2.715 2.667h2.77v-5.333h-2.771c-1.499 0-2.714 1.194-2.714 2.666"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("pattern", {
                                        id: "b",
                                        width: "1",
                                        height: "1",
                                        patternContentUnits: "objectBoundingBox",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                                width: "1",
                                                height: "1",
                                                className: " tBulXAd182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("use", {
                                                href: "#k",
                                                transform: "matrix(.00083 0 0 .00122 0 -.048)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("pattern", {
                                        id: "c",
                                        width: "1",
                                        height: "1",
                                        patternContentUnits: "objectBoundingBox",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                                width: "1",
                                                height: "1",
                                                className: " tBulXAd182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("use", {
                                                href: "#l",
                                                transform: "matrix(.00083 0 0 .00122 0 -.045)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("pattern", {
                                        id: "e",
                                        width: "1",
                                        height: "1",
                                        patternContentUnits: "objectBoundingBox",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                                width: "1",
                                                height: "1",
                                                className: " tBulXAd182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("use", {
                                                href: "#m",
                                                transform: "matrix(.00083 0 0 .00122 0 -.046)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("pattern", {
                                        id: "g",
                                        width: "1",
                                        height: "1",
                                        patternContentUnits: "objectBoundingBox",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("rect", {
                                                width: "1",
                                                height: "1",
                                                className: " tBulXAd182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("use", {
                                                href: "#n",
                                                transform: "matrix(.0025 0 0 .00258 0 -.015)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("filter", {
                                        id: "d",
                                        width: "230.178",
                                        height: "173.821",
                                        x: "100.565",
                                        y: "1.78",
                                        colorInterpolationFilters: "sRGB",
                                        filterUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feFlood", {
                                                floodOpacity: "0",
                                                result: "BackgroundImageFix"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                in: "SourceAlpha",
                                                result: "hardAlpha",
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feOffset", {
                                                dy: "2.373"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feGaussianBlur", {
                                                stdDeviation: "13.051"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feComposite", {
                                                in2: "hardAlpha",
                                                operator: "out"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in2: "BackgroundImageFix",
                                                result: "effect1_dropShadow_150_2942"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in: "SourceGraphic",
                                                in2: "effect1_dropShadow_150_2942",
                                                result: "shape"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("filter", {
                                        id: "f",
                                        width: "125.174",
                                        height: "123.395",
                                        x: "231.078",
                                        y: "78.901",
                                        colorInterpolationFilters: "sRGB",
                                        filterUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feFlood", {
                                                floodOpacity: "0",
                                                result: "BackgroundImageFix"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                in: "SourceAlpha",
                                                result: "hardAlpha",
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feOffset", {
                                                dy: "2.373"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feGaussianBlur", {
                                                stdDeviation: "16.018"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feComposite", {
                                                in2: "hardAlpha",
                                                operator: "out"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in2: "BackgroundImageFix",
                                                result: "effect1_dropShadow_150_2942"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in: "SourceGraphic",
                                                in2: "effect1_dropShadow_150_2942",
                                                result: "shape"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("filter", {
                                        id: "h",
                                        width: "68.224",
                                        height: "68.223",
                                        x: "98.193",
                                        y: "0",
                                        colorInterpolationFilters: "sRGB",
                                        filterUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feFlood", {
                                                floodOpacity: "0",
                                                result: "BackgroundImageFix"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                in: "SourceAlpha",
                                                result: "hardAlpha",
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feOffset", {
                                                dy: "2.373"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feGaussianBlur", {
                                                stdDeviation: "10.085"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feComposite", {
                                                in2: "hardAlpha",
                                                operator: "out"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in2: "BackgroundImageFix",
                                                result: "effect1_dropShadow_150_2942"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in: "SourceGraphic",
                                                in2: "effect1_dropShadow_150_2942",
                                                result: "shape"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("filter", {
                                        id: "i",
                                        width: "68.224",
                                        height: "68.223",
                                        x: "64.376",
                                        y: "13.645",
                                        colorInterpolationFilters: "sRGB",
                                        filterUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feFlood", {
                                                floodOpacity: "0",
                                                result: "BackgroundImageFix"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                in: "SourceAlpha",
                                                result: "hardAlpha",
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feOffset", {
                                                dy: "2.373"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feGaussianBlur", {
                                                stdDeviation: "10.085"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feComposite", {
                                                in2: "hardAlpha",
                                                operator: "out"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feColorMatrix", {
                                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in2: "BackgroundImageFix",
                                                result: "effect1_dropShadow_150_2942"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("feBlend", {
                                                in: "SourceGraphic",
                                                in2: "effect1_dropShadow_150_2942",
                                                result: "shape"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("image", {
                                        id: "k",
                                        width: "1200",
                                        height: "896",
                                        "data-name": "Ideation-primary.png",
                                        href: s3AssetsQueries?.[3]?.data?.presignURL,
                                        preserveAspectRatio: "none"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("image", {
                                        id: "l",
                                        width: "1200",
                                        height: "896",
                                        "data-name": "KV-alternative.png",
                                        href: s3AssetsQueries?.[2]?.data?.presignURL,
                                        preserveAspectRatio: "none"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("image", {
                                        id: "m",
                                        width: "1200",
                                        height: "896",
                                        "data-name": "KV-primary.png",
                                        href: s3AssetsQueries?.[1]?.data?.presignURL,
                                        preserveAspectRatio: "none"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("image", {
                                        id: "n",
                                        width: "400",
                                        height: "400",
                                        "data-name": "App-icon.jpg",
                                        href: s3AssetsQueries?.[0]?.data?.presignURL,
                                        preserveAspectRatio: "none"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("clipPath", {
                                        id: "j",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("path", {
                                            fill: "#fff",
                                            d: "M591.055 188.888h11v16h-11z"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 eb182 Uj182 qj182 _Wa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                children: [
                                    "Use the BeStory plugin in Figma Slides to fill your One Adobe deck with the ",
                                    video.data?.customer?.name,
                                    " assets."
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                variant: variant,
                                size: "XL",
                                href: figmaTemplateUrl,
                                target: "_blank",
                                isDisabled: !figmaTemplatePath,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $be36e41d00ea636f$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Complete my deck in Figma Slides"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                children: [
                                    "Note: In case of issues with Figma Collab license activation, please reach out to the Figma license management team:",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        href: "mailto:cesarc@adobe.com",
                                        children: "cesarc@adobe.com"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        href: "mailto:mmaithani@adobe.com",
                                        children: "mmaithani@adobe.com"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        href: "mailto:cnikam@adobe.com",
                                        children: "cnikam@adobe.com"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            figmaLicense === "restricted" && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                        filePath: "assets/Figma-collab-license-request.jpg",
                        styles: " Za182 LpfEyn182 f1dYB9d182 ob182 nb182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 eb182 Uj182 qj182 _Wa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                children: [
                                    "The Figma Collab license gives you full access to Figma Slides and custom plugins (like BeStory plugin). You\u2019ll need it to fill your One Adobe deck with the ",
                                    video.data?.customer?.name,
                                    " assets."
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                variant: variant,
                                size: "XL",
                                href: "https://adobe.service-now.com/esc?id=sc_cat_item&sys_id=4bb74fb2c3e34f507412d6df0501319c",
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $be36e41d00ea636f$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Request Figma Collab license"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                children: "License cost: $60/y, requires CC manager's approval"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                children: [
                                    "Note: In case of issues with Figma Collab license activation, please reach out to the Figma license management team:",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        href: "mailto:cesarc@adobe.com",
                                        children: "cesarc@adobe.com"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        href: "mailto:mmaithani@adobe.com",
                                        children: "mmaithani@adobe.com"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                        href: "mailto:cnikam@adobe.com",
                                        children: "cnikam@adobe.com"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$66902db9f886f3ac$var$FigmaDeckDuplicate.propTypes = {
    assets: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).array.isRequired,
    video: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).object.isRequired,
    figmaTemplatePath: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string.isRequired,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
const $66902db9f886f3ac$export$98766ba73f701eaf = ({ onContinue: onContinue, onBack: onBack, continueLabel: continueLabel, preview: preview = "partnership-value", contentLabel: contentLabel = "script", canEditCampaign: canEditCampaign = true })=>{
    const { template: template, video: video, downloadAllAssets: downloadAllAssets } = (0, $eF4cA.useContext)((0, $77tch.VideoWizardContext));
    const { isLoading: isAssetsLoading } = (0, $ikOQe.useVideoAssets)(video.data?.id);
    const updateVideo = (0, $ikOQe.useUpdateVideo)(video.data?.id);
    const { figmaTemplatePath: figmaTemplatePath } = template.data ?? {};
    const figmaUrl = video.data?.figmaUrls?.[0]?.url;
    const hasFigmaLink = Boolean(figmaUrl);
    const assets = [
        video.data?.assets?.find((asset)=>asset.name === "App-icon"),
        video.data?.assets?.find((asset)=>asset.name === "KV-primary"),
        video.data?.assets?.find((asset)=>asset.name === "KV-alternative"),
        video.data?.assets?.find((asset)=>asset.name === "Ideation-primary")
    ];
    const brandColor = video.data?.customer?.["Brand-color"];
    const secondaryColor = video.data?.customer?.["Secondary-color"];
    const handleVideoShare = async (emails)=>{
        try {
            if (!video.data?.id) throw new Error("Project not found");
            const current = video.data.sharedWith ?? [];
            const currentLower = new Set(current.map((item)=>item.toLowerCase()));
            const added = emails.filter((item)=>!currentLower.has(item));
            if (added.length === 0) {
                (0, $fmJ8d.store).getState().addToast("Project is already shared with these users", {
                    variant: "info",
                    timeout: 3000
                });
                return;
            }
            await updateVideo.mutateAsync({
                id: video.data.id,
                sharedWith: [
                    ...current,
                    ...added
                ]
            });
            (0, $fmJ8d.store).getState().addToast(`Project shared with ${added.join(", ")}`, {
                variant: "positive",
                timeout: 3000
            });
        } catch (error) {
            (0, $fmJ8d.store).getState().addToast(error.message || "Failed to share project", {
                variant: "negative",
                timeout: 3000
            });
            throw error;
        }
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                styles: function anonymous(props) {
                    let rules = " ";
                    rules += ' zk52g2d182';
                    rules += ' yk52g2d182';
                    rules += ' Bk52g2d182';
                    rules += ' Ak52g2d182';
                    rules += ' se182';
                    rules += ' Cyt4afb182';
                    if (props.isCompleted) rules += ' Cpyt4afb182';
                    else rules += ' Cp8Rh7db182';
                    rules += ' CqEXeHWb182';
                    rules += ' DM8Mfn182';
                    if (props.isCompleted) rules += ' DpM8Mfn182';
                    else rules += ' DpyG4cd182';
                    rules += ' Dq7LKWic182';
                    rules += ' Up182';
                    rules += ' qp182';
                    return rules;
                }({
                    isCompleted: hasFigmaLink
                }),
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Header, {
                        title: hasFigmaLink ? `Your ${video.data?.customer?.name} presentation is ready!` : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                    children: [
                                        "Let\u2019s apply your ",
                                        video.data?.customer?.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "assets to the One Adobe deck"
                                })
                            ]
                        }),
                        subtitle: hasFigmaLink ? `Review the deck and present in Figma Slides` : `Almost there!`,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' z6Akec182';
                            rules += ' y6Akec182';
                            rules += ' B6Akec182';
                            rules += ' A6Akec182';
                            if (props.isCompleted) rules += ' _ta182';
                            else rules += ' _tb182';
                            return rules;
                        }({
                            isCompleted: hasFigmaLink
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 sd182 _ta182 Ur182 qr182",
                        children: [
                            hasFigmaLink && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " _Pc182 Za182 L6kvVdc182 IM182 HM182 fiYejn182 _rgr5H3d182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                                filePath: assets[1]?.filePath,
                                                styles: " _Pa182 Wr182 _lr182 _Ar182 _zr182 Za182 Fb182 _Hb182 oe182 ne182 ke182 je182 gg182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                                filePath: assets[0]?.filePath,
                                                styles: " fa182 _Ha182 ZsHMfn182 _Pa182 _Ad182 Wd182 ob182 nb182 kb182 jb182 gg182"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " Ze5Ky182 Qe5Ky182 _Pa182 _zBxLfn182 _l62Ky182 ob182 nb182 kb182 jb182 gg182",
                                                style: !!brandColor ? {
                                                    backgroundColor: brandColor
                                                } : {}
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " Ze5Ky182 Qe5Ky182 _Pa182 _zJzLfn182 _lBxLfn182 ob182 nb182 kb182 jb182 gg182",
                                                style: !!secondaryColor ? {
                                                    backgroundColor: secondaryColor
                                                } : {}
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 _ta182 _toc182 ed182 Ug182 qg182 _dc182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 _ta182 eb182 Ug182 qg182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.LinkButton), {
                                                        variant: "accent",
                                                        size: "XL",
                                                        href: figmaUrl,
                                                        target: "_blank",
                                                        isDisabled: !figmaUrl,
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $be36e41d00ea636f$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Open in Figma Slides"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                                        children: "Required: Collab or Full license"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                                variant: "primary",
                                                size: "XL",
                                                onPress: ()=>downloadAllAssets.mutate(),
                                                isPending: downloadAllAssets.isPending,
                                                isDisabled: isAssetsLoading,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Download all assets"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !hasFigmaLink && /*#__PURE__*/ (0, $dx4lB.jsx)($66902db9f886f3ac$var$FigmaDeckDuplicate, {
                                video: video,
                                assets: assets,
                                figmaTemplatePath: figmaTemplatePath
                            }),
                            hasFigmaLink && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $a6bf03053d5f3ea4$export$74a362b31437ec83), {
                                density: "spacious",
                                size: "L",
                                isQuiet: true,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$7843c6a5b3e340a2), {
                                        UNSAFE_style: {
                                            flexBasis: "300px",
                                            flexGrow: 0,
                                            margin: "0 auto"
                                        },
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " IM182 HM182",
                                            children: "Want to create a new deck?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a6bf03053d5f3ea4$export$feabaa331e1d464c), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)($66902db9f886f3ac$var$FigmaDeckDuplicate, {
                                            video: video,
                                            assets: assets,
                                            figmaTemplatePath: figmaTemplatePath,
                                            variant: "primary"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !hasFigmaLink && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                        size: "L",
                        styles: " zLpqDSc182 yLpqDSc182 BLpqDSc182 ALpqDSc182 _dpe182 __Ab182 __Apd182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                        variant: "primary",
                                        isPending: updateVideo.isPending,
                                        isDisabled: !video.data?.id,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d17b0246a3955b22$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Share project"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5a97d3ace48abbdb$export$26b082ba192e616), {
                                        videoId: video.data?.id,
                                        onAccept: handleVideoShare
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                variant: "primary",
                                onPress: ()=>downloadAllAssets.mutate(),
                                isPending: downloadAllAssets.isPending,
                                isDisabled: isAssetsLoading,
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Download all assets"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " zyw6qOe182 yyw6qOe182 Byw6qOe182 Ayw6qOe182 sd182 _ta182 _Ca182 __Ab182 Ur182 qr182",
                        children: [
                            video.data?.id && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5e54d0a0882391be$export$ce3b880e766d1e30), {
                                variant: "inline",
                                title: "How did your project turn out?",
                                video: video.data,
                                currentStep: "figma-handoff",
                                method: "inline",
                                styles: " Za182 L6Neosc182"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                size: hasFigmaLink ? "M" : "M",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        children: "Do you need help with your project?"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                        size: "L",
                                        styles: " z2mU182 y5mU182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                                            variant: "secondary",
                                            href: "https://adobe.ly/ExperienceDesign-Request",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Request design assist"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                onBack: onBack,
                onContinue: onContinue,
                continueLabel: continueLabel,
                isContinueDisabled: false
            })
        ]
    });
};




var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $dqZbZ = parcelRequire("dqZbZ");

var $9eyCh = parcelRequire("9eyCh");

var $gc2oq = parcelRequire("gc2oq");
var $5NHyX = parcelRequire("5NHyX");
var $bsn7e = parcelRequire("bsn7e");
var $8wD3p = parcelRequire("8wD3p");
var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $bb3571c0241a6f98$var$$e481e485175547e3$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.75 2.75c0-.414-.336-.75-.75-.75H4.25C3.01 2 2 3.01 2 4.25V13c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.414.336-.75.75-.75H13c.414 0 .75-.336.75-.75M14.75 11.5c0 .414-.336.75-.75.75h-1.75V14c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.75H9c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.75V9c0-.414.336-.75.75-.75s.75.336.75.75v1.75H14c.414 0 .75.336.75.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 5h-8.5C6.01 5 5 6.01 5 7.25v8.5C5 16.99 6.01 18 7.25 18h8.5c1.24 0 2.25-1.01 2.25-2.25v-8.5C18 6.01 16.99 5 15.75 5m.75 10.75c0 .414-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75v-8.5c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75z"
            })
        ]
    });
const $bb3571c0241a6f98$var$$e481e485175547e3$var$ForwardRef = (0, $eF4cA.forwardRef)($bb3571c0241a6f98$var$$e481e485175547e3$var$SvgComponent);
var $bb3571c0241a6f98$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($bb3571c0241a6f98$var$$e481e485175547e3$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $5711784642ece667$var$$fbe1f0c496b0617a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M15 10.502c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.123h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625M2.275 18.752q-.079 0-.16-.018c-.405-.088-.662-.487-.573-.892.595-2.73 3.312-5.025 6.607-5.58.423-.076.796.208.865.615.069.41-.206.796-.615.864-2.707.456-4.924 2.274-5.392 4.421-.076.35-.387.59-.732.59M10 10.852c-2.485 0-4.507-2.154-4.507-4.8s2.022-4.8 4.507-4.8 4.507 2.153 4.507 4.8-2.022 4.8-4.507 4.8m0-8.1c-1.658 0-3.007 1.48-3.007 3.3s1.349 3.3 3.007 3.3 3.007-1.48 3.007-3.3-1.349-3.3-3.007-3.3"
        })
    });
const $5711784642ece667$var$$fbe1f0c496b0617a$var$ForwardRef = (0, $eF4cA.forwardRef)($5711784642ece667$var$$fbe1f0c496b0617a$var$SvgComponent);
var $5711784642ece667$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($5711784642ece667$var$$fbe1f0c496b0617a$var$ForwardRef);



var $i8elj = parcelRequire("i8elj");

var $ikOQe = parcelRequire("ikOQe");


var $fmJ8d = parcelRequire("fmJ8d");
const $8114da46d8533f15$export$a650b5679edb7ec5 = ({ size: size = "M", item: item })=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const [dialog, setDialog] = (0, $eF4cA.useState)(null);
    const [tempName, setTempName] = (0, $eF4cA.useState)("");
    const updateVideo = (0, $ikOQe.useUpdateVideo)(item?.id);
    const deleteVideo = (0, $ikOQe.useDeleteVideo)(item?.id);
    const duplicateVideo = (0, $ikOQe.useDuplicateVideo)(item?.id);
    const handleShare = async (emails)=>{
        try {
            const current = item.sharedWith ?? [];
            const currentLower = new Set(current.map((email)=>email.toLowerCase()));
            const added = emails.filter((email)=>!currentLower.has(email.toLowerCase()));
            if (added.length === 0) {
                (0, $fmJ8d.store).getState().addToast("Project is already shared with these users", {
                    variant: "info",
                    timeout: 3000
                });
                return;
            }
            await updateVideo.mutateAsync({
                id: item.id,
                sharedWith: [
                    ...current,
                    ...added
                ]
            });
            (0, $fmJ8d.store).getState().addToast(`Project shared with ${added.join(", ")}`, {
                variant: "positive",
                timeout: 3000
            });
        } catch (error) {
            (0, $fmJ8d.store).getState().addToast("Unable to share project. Please try again.", {
                variant: "negative",
                timeout: 5000
            });
            throw error;
        }
    };
    const handleAction = (key)=>{
        if (!item?.id) return;
        switch(key){
            case "share":
                setDialog("share");
                break;
            case "rename":
                setTempName(item.name ?? "");
                setDialog("rename");
                break;
            case "duplicate":
                duplicateVideo.mutate({
                    id: item.id
                }, {
                    onSuccess: ()=>{
                        (0, $fmJ8d.store).getState().addToast("Project duplicated successfully", {
                            variant: "positive",
                            timeout: 3000
                        });
                        navigate("/projects");
                    }
                });
                break;
            case "delete":
                deleteVideo.mutate({
                    id: item.id
                }, {
                    onSuccess: ()=>{
                        (0, $fmJ8d.store).getState().addToast("Project deleted successfully", {
                            variant: "positive",
                            timeout: 3000
                        });
                        navigate("/projects");
                    }
                });
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $gc2oq.ActionMenu), {
                isQuiet: true,
                isDisabled: !item?.id || deleteVideo.isPending,
                size: size,
                "aria-label": "Project actions",
                styles: " Is182",
                onAction: handleAction,
                disabledKeys: duplicateVideo.isPending ? [
                    "duplicate"
                ] : [],
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuSection), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                            id: "share",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5711784642ece667$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Share"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuSection), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                id: "rename",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a500bb283462013d$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Rename"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                id: "duplicate",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb3571c0241a6f98$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: duplicateVideo.isPending ? "Duplicating..." : "Duplicate"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuSection), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                            id: "delete",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Delete"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $bsn7e.DialogContainer), {
                onDismiss: ()=>setDialog(null),
                children: [
                    dialog === "share" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5a97d3ace48abbdb$export$26b082ba192e616), {
                        videoId: item.id,
                        onAccept: handleShare
                    }),
                    dialog === "rename" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5NHyX.AlertDialog), {
                        title: "Rename Project",
                        primaryActionLabel: "Rename",
                        cancelLabel: "Cancel",
                        onPrimaryAction: ()=>{
                            updateVideo.mutate({
                                id: item.id,
                                name: tempName
                            });
                            setTempName("");
                        },
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                            label: "Title",
                            value: tempName,
                            onChange: setTempName
                        })
                    })
                ]
            })
        ]
    });
};
$8114da46d8533f15$export$a650b5679edb7ec5.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOf([
        "S",
        "M",
        "L"
    ]),
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        sharedWith: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    })
};


parcelRequire("CGZx1");
var $lb17q = parcelRequire("lb17q");
var $CGZx1 = parcelRequire("CGZx1");



var $lb17q = parcelRequire("lb17q");


var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");



var $77tch = parcelRequire("77tch");

var $6lZyT = parcelRequire("6lZyT");

var $9lDhw = parcelRequire("9lDhw");

var $fmJ8d = parcelRequire("fmJ8d");

const $a17caf9b7a820813$var$getAssetsFingerprint = (templateAssets, imageVariations, assets)=>[
        ...(templateAssets ?? []).map((asset)=>asset.name),
        ...(imageVariations ?? []).map((variation)=>variation.key)
    ].map((key)=>{
        const asset = assets?.find((a)=>a.name === key);
        return `${key}:${asset?.filePath ?? ""}`;
    }).sort().join("|");
const $a17caf9b7a820813$var$getExternalHref = (url)=>typeof url === "string" && url.trim() ? url.trim() : null;
// Maps a step id to the component that renders it. The two pre-flow entry
// steps (template selection + the account-details dialog) share TemplateStep.
const $a17caf9b7a820813$var$DEFAULT_STEP_COMPONENTS = {
    [(0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE]: (0, $763589ebaaddc8ec$export$92e3969fbe070167),
    [(0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS]: (0, $763589ebaaddc8ec$export$92e3969fbe070167),
    [(0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS]: (0, $abeab2336c434f94$export$99783913685e6ea4),
    [(0, $lb17q.WIZARD_STEP).CAMPAIGN]: (0, $e898dbb69e4bcf47$export$856ee0b7e08de6c2),
    [(0, $lb17q.WIZARD_STEP).CAMPAIGN_VISUALS]: (0, $24065f2fdd88e010$export$c5e92a6b6e0b7aa0),
    [(0, $lb17q.WIZARD_STEP).SCENES]: (0, $7dcf871e8c209f6e$export$e88b99a9b9512b56),
    [(0, $lb17q.WIZARD_STEP).VOICEOVER]: (0, $be90f5e41d3f443a$export$ab5c0107fb2075da),
    [(0, $lb17q.WIZARD_STEP).BRANDING]: (0, $0989c34268e3b06a$export$1a81d946ea2efb55),
    [(0, $lb17q.WIZARD_STEP).AUDIO]: (0, $2f940d38c0367f4f$export$6ed35711dca5c597),
    [(0, $lb17q.WIZARD_STEP).BANNERS]: (0, $78c0aabe26c22ad2$export$75eed4f7b66b4e2e),
    [(0, $lb17q.WIZARD_STEP).GENERATE_VIDEO]: (0, $a9a34fc87401f425$export$d4f6825887bd71a1),
    [(0, $lb17q.WIZARD_STEP).FIGMA_HANDOFF]: (0, $66902db9f886f3ac$export$98766ba73f701eaf)
};
const $a17caf9b7a820813$var$MODULAR_STEP_COMPONENTS = {
    [(0, $lb17q.WIZARD_STEP).SELECT_TEMPLATE]: (0, $24640b06381f3f5f$export$251da4712be96c6a),
    [(0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS]: (0, $24640b06381f3f5f$export$251da4712be96c6a),
    [(0, $lb17q.WIZARD_STEP).CUSTOMER_DETAILS]: (0, $abeab2336c434f94$export$99783913685e6ea4),
    [(0, $lb17q.WIZARD_STEP).CAMPAIGN]: (0, $e898dbb69e4bcf47$export$856ee0b7e08de6c2),
    [(0, $lb17q.WIZARD_STEP).CAMPAIGN_VISUALS]: (0, $24065f2fdd88e010$export$c5e92a6b6e0b7aa0),
    [(0, $lb17q.WIZARD_STEP).SCENES]: (0, $7dcf871e8c209f6e$export$e88b99a9b9512b56),
    [(0, $lb17q.WIZARD_STEP).VOICEOVER]: (0, $be90f5e41d3f443a$export$ab5c0107fb2075da),
    [(0, $lb17q.WIZARD_STEP).BRANDING]: (0, $0989c34268e3b06a$export$1a81d946ea2efb55),
    [(0, $lb17q.WIZARD_STEP).AUDIO]: (0, $2f940d38c0367f4f$export$6ed35711dca5c597),
    [(0, $lb17q.WIZARD_STEP).BANNERS]: (0, $78c0aabe26c22ad2$export$75eed4f7b66b4e2e),
    [(0, $lb17q.WIZARD_STEP).GENERATE_VIDEO]: (0, $a9a34fc87401f425$export$d4f6825887bd71a1)
};
const $a17caf9b7a820813$var$STEP_COMPONENTS_CONFIG = {
    modular: $a17caf9b7a820813$var$MODULAR_STEP_COMPONENTS
};
// Steps that opt into a family through their `type`, whatever their id.
const $a17caf9b7a820813$var$STEP_TYPE_COMPONENTS = {
    [(0, $lb17q.STEP_TYPE).CAMPAIGN_VISUALS]: (0, $24065f2fdd88e010$export$c5e92a6b6e0b7aa0),
    [(0, $lb17q.STEP_TYPE).IMAGES]: (0, $79ba6d1f584cc93a$export$abd911c5be1a3132)
};
const $a17caf9b7a820813$var$getTemplateStepComponents = (templateId)=>$a17caf9b7a820813$var$STEP_COMPONENTS_CONFIG[templateId] ?? $a17caf9b7a820813$var$DEFAULT_STEP_COMPONENTS;
const $a17caf9b7a820813$export$e9d66656d090d4fb = (props)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $8102291d555c64a3$export$6af739b05d4b05ff), {
        isWizard: true,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)($a17caf9b7a820813$var$EditableVideoWizard, {
            ...props
        })
    });
const $a17caf9b7a820813$var$EditableVideoWizard = ({ type: type, selectedTemplateKey: defaultSelectedTemplateKey = null })=>{
    const params = (0, $dqZbZ.useParams)();
    const navigate = (0, $dqZbZ.useNavigate)();
    const [searchParams] = (0, $dqZbZ.useSearchParams)();
    const routeStep = params?.step;
    const contentContainerRef = (0, $eF4cA.useRef)(null);
    const actionsContainerRef = (0, $eF4cA.useRef)(null);
    const audioMuxRanForSourcesKeyRef = (0, $eF4cA.useRef)(null);
    const prevAudioMuxDownloadSourcesKeyRef = (0, $eF4cA.useRef)(null);
    const bannersAssetsFingerprintRef = (0, $eF4cA.useRef)(null);
    const runStepEnteringActionRef = (0, $eF4cA.useRef)(null);
    const runStepLeavingActionRef = (0, $eF4cA.useRef)(null);
    const [projectId, setProjectId] = (0, $eF4cA.useState)(params?.id);
    const [customerName, setCustomerName] = (0, $eF4cA.useState)("");
    const deferredCustomerName = (0, $eF4cA.useDeferredValue)(customerName);
    const [hint, setHint] = (0, $eF4cA.useState)("");
    const [product, setProduct] = (0, $eF4cA.useState)("");
    const [customerWebsiteURL, setCustomerWebsiteURL] = (0, $eF4cA.useState)("");
    const [customerBrandCenterURL, setCustomerBrandCenterURL] = (0, $eF4cA.useState)("");
    const [customerColor, setCustomerColor] = (0, $eF4cA.useState)("");
    const [industry, setIndustry] = (0, $eF4cA.useState)("");
    // Seed the template + account details from the URL query params so a flow
    // started elsewhere (e.g. the home page) can be resumed / deep-linked. The
    // explicit prop still wins when provided.
    const [selectedTemplateKey, setSelectedTemplateKey] = (0, $eF4cA.useState)(defaultSelectedTemplateKey ?? searchParams.get("template") ?? null);
    const [sfType, setSfType] = (0, $eF4cA.useState)(searchParams.get("sfType") ?? "accountName");
    const [drNumbersFilter, setDrNumbersFilter] = (0, $eF4cA.useState)("");
    const [drNumber, setDrNumber] = (0, $eF4cA.useState)(searchParams.get("drNumber") ?? "");
    const [accountName, setAccountName] = (0, $eF4cA.useState)(searchParams.get("accountName") ?? "");
    const [campaignView, setCampaignView] = (0, $eF4cA.useState)("preview");
    const [selectedMusicTrackId, setSelectedMusicTrackId] = (0, $eF4cA.useState)(null);
    const [demoPilotProjectId, setDemoPilotProjectId] = (0, $eF4cA.useState)(null);
    const [audioMuxDownloadUrl, setAudioMuxDownloadUrl] = (0, $eF4cA.useState)(null);
    const [audioMuxDownloadPending, setAudioMuxDownloadPending] = (0, $eF4cA.useState)(false);
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const isLargeViewport = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isLargeViewport);
    const isMobile = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isMobile);
    const setPromptHint = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.setPromptHint);
    const audioMux = (0, $4230475195755126$export$e53ae5d2f8687049)();
    const { currentStep: currentStep, setCurrentStep: setCurrentStep, video: video, createVideo: createVideo, createVideoIfNeeded: createVideoIfNeeded, updateVideo: updateVideo, updateCustomer: updateCustomer, updateAssets: updateAssets, uploadAssets: uploadAssets, templates: templates, template: template, assetsTemplate: assetsTemplate, drNumbers: drNumbers, accounts: accounts, personas: personas, selectedPersona: selectedPersona, setSelectedPersona: setSelectedPersona, verticals: verticals, selectedVertical: selectedVertical, setSelectedVertical: setSelectedVertical, include3DDigitalTwin: include3DDigitalTwin, setInclude3DDigitalTwin: setInclude3DDigitalTwin, customerBranding: customerBranding, addCampaign: addCampaign, editCampaign: editCampaign, scrapeQueries: scrapeQueries, searchImagesQueries: searchImagesQueries, appStoreQuery: appStoreQuery, productSearchQuery: productSearchQuery, bannersStatus: // taglines,
    bannersStatus, generateBanners: generateBanners, exportBanners: exportBanners, generateVideo: generateVideo, exportVideo: exportVideo, renderProgress: renderProgress, generateStatusText: generateStatusText, describeMogrtTemplate: describeMogrtTemplate } = (0, $CGZx1.useVideoWizard)({
        videoId: projectId,
        routeStep: routeStep,
        customerName: deferredCustomerName,
        hint: hint,
        product: product,
        templateType: type,
        templateId: selectedTemplateKey,
        sfType: sfType,
        drNumbersFilter: drNumbersFilter,
        drNumber: drNumber,
        accountName: accountName,
        demoPilotProjectId: demoPilotProjectId,
        onCreateProject: (data)=>{
            navigate(`./${data.id}`);
        },
        onSuccess: (data)=>{
            navigate(`../${data.id}`);
        }
    });
    // Destructured out of the mutation objects above (rather than referenced as
    // e.g. `updateAssets.mutate` at the call site) so they're stable identifiers
    const { mutate: updateAssetsMutate, mutateAsync: updateAssetsMutateAsync } = updateAssets;
    const { mutateAsync: uploadAssetsMutateAsync } = uploadAssets;
    const { mutate: editCampaignMutate } = editCampaign;
    const { mutate: updateCustomerMutate } = updateCustomer;
    const { mutate: updateVideoMutate } = updateVideo;
    const { mutate: generateVideoMutate } = generateVideo;
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Projects",
            href: "/projects"
        },
        {
            label: video.data?.name ?? (type === "modular" ? "Video Composer" : "New project"),
            isLoading: projectId ? !video.data?.name : false
        }
    ]);
    const [_agreeToTerms, _setAgreeToTerms] = (0, $eF4cA.useState)(null);
    const agreeToTerms = _agreeToTerms ?? video.data?.agreeToFFUsageTerms ?? false;
    const setAgreeToTerms = (value)=>{
        _setAgreeToTerms(value);
        updateVideoMutate({
            agreeToFFUsageTerms: value
        });
    };
    const s3VideoURL = (0, $a8sj2.usePresignURL)(video.data?.videoPath);
    const selectedMusicTrackURL = (0, $a8sj2.usePresignURL)(video.data?.musicPath ?? selectedMusicTrackId);
    const checkCustomer = (0, $CGZx1.useCustomerCheck)();
    const sceneGeneration = (0, $ee75fb16cdfee19c$export$5d18dccc07b33b21)({
        videoId: projectId
    });
    const feedback = (0, $8fa124be32935d0d$export$cb6c49bc277cb055)();
    // The template driving the current flow — used to resolve per-template step
    // configuration (flow + entering/leaving actions).
    const activeTemplateId = template.data?.id ?? selectedTemplateKey;
    // Keep the URL's `:step` segment in sync with the current step. Only active
    // once the project id is in the URL (`/projects/new/:id/:step`); before that the
    // pre-flow steps run at `/projects/new` without a step segment. This also serves
    // the "no `:step` in the path → redirect to the current step" case, since the
    // current step differs from the (undefined) route step.
    (0, $eF4cA.useEffect)(()=>{
        if (!activeTemplateId || !params?.id || !currentStep || currentStep === routeStep) return;
        const stepEntry = (0, $lb17q.getTemplateSteps)(activeTemplateId).find((s)=>s.id === currentStep);
        if (stepEntry?.viewless) return;
        navigate(`/projects/new/${params.id}/${stepEntry?.id ?? currentStep}`, {
            replace: true
        });
    }, [
        params?.id,
        currentStep,
        routeStep,
        navigate,
        activeTemplateId
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (template.data?.musicTracks?.length > 0) {
            const defaultTrackId = template.data?.musicTracks[0].id;
            setSelectedMusicTrackId(defaultTrackId);
            if (video.data?.id && video.data?.musicPath == null) updateVideoMutate({
                musicPath: defaultTrackId
            });
        }
    }, [
        template.data?.musicTracks,
        video.data?.id,
        video.data?.musicPath,
        updateVideoMutate
    ]);
    const groupedMusicTracks = (0, $eF4cA.useMemo)(()=>{
        const tracks = template.data?.musicTracks ?? [];
        const groups = [];
        const groupsBySection = new Map();
        for (const track of tracks){
            const section = track.section ?? "";
            let group = groupsBySection.get(section);
            if (!group) {
                const label = section ? section.replace(/\b\w/g, (c)=>c.toUpperCase()) : "Other";
                group = {
                    section: section,
                    label: label,
                    items: []
                };
                groupsBySection.set(section, group);
                groups.push(group);
            }
            group.items.push(track);
        }
        return groups;
    }, [
        template.data?.musicTracks
    ]);
    const handleDrNumbersSelectionChange = (0, $eF4cA.useCallback)((key)=>{
        const keyItem = drNumbers.data?.find((item)=>item.id === key);
        setDrNumber(key?.drNumber ?? key);
        if (keyItem?.name) setDrNumbersFilter(keyItem.name);
    }, [
        drNumbers.data
    ]);
    const [editedCampaign, setEditedCampaign] = (0, $eF4cA.useState)(null);
    const selectedCampaign = template.data?.campaignSelectionType !== (0, $lb17q.SELECTION_TYPE).MULTIPLE ? video.data?.campaigns?.find((item)=>item.id === video.data?.selectedCampaignIds?.[0]) : video.data?.selectedCampaignIds?.map((id)=>video.data?.campaigns?.find((item)=>item.id === id));
    const allScrapedQueries = (0, $eF4cA.useMemo)(()=>[
            productSearchQuery,
            ...scrapeQueries,
            ...searchImagesQueries,
            appStoreQuery
        ].filter((q)=>q.isEnabled), [
        productSearchQuery,
        scrapeQueries,
        searchImagesQueries,
        appStoreQuery
    ]);
    const scrapedColors = (0, $eF4cA.useMemo)(()=>Array.from(new Set((!!video.data?.customer?.color && (0, $kQT4E.parseColor)(video.data?.customer?.color), scrapeQueries.flatMap((query)=>query.data || [])?.filter((asset)=>asset.type === "color").flatMap(({ color: color })=>color?.toUpperCase()) || []).flat().filter(Boolean))), [
        video.data?.customer?.color,
        scrapeQueries
    ]);
    const selectedAssets = template.data?.assets?.filter((asset)=>video.data?.assets?.some((a)=>a.name === asset.name)) ?? [];
    const areAllVisualsSelected = (0, $eF4cA.useMemo)(()=>{
        const brandingAssets = template.data?.assets?.filter((asset)=>(asset.type === "image" || asset.type === "color") && // Optional assets never block progressing to the next step.
            !asset.isOptional);
        if (brandingAssets == null) return false;
        return brandingAssets.every((asset)=>video.data?.assets?.some((a)=>a.name === asset.name && !a.isInvalid));
    }, [
        template.data?.assets,
        video.data?.assets
    ]);
    const assetsFingerprint = (0, $eF4cA.useMemo)(()=>$a17caf9b7a820813$var$getAssetsFingerprint(template.data?.assets, template.data?.imageVariations, video.data?.assets), [
        template.data?.assets,
        template.data?.imageVariations,
        video.data?.assets
    ]);
    const [editVariation, setEditVariation] = (0, $eF4cA.useState)(null);
    const [taglinesData, setTaglinesData] = (0, $eF4cA.useState)(new Array(3).fill({}));
    const handleTaglineChange = (0, $eF4cA.useCallback)((index, key, value)=>{
        setTaglinesData((prev)=>prev.map((item, idx)=>idx === index ? {
                    ...item,
                    [key]: value
                } : item));
    }, []);
    // After refresh, resume mogrt job polling via generateVideo (poll-only path in render hook)
    (0, $eF4cA.useEffect)(()=>{
        const jobId = video.data?.jobId;
        const videoPath = video.data?.videoPath;
        if (videoPath || generateVideo.isPending || !projectId || video.data?.templateType !== "mogrt" || !video.isSuccess || !jobId) return;
        generateVideoMutate({
            videoId: projectId,
            resumeMogrtJob: true
        }, {
            onError: (error)=>{
                if ((0, $k7O9T.isCancelledError)(error) || error?.cause?.problem === "CANCEL_ERROR") return;
                updateVideoMutate({
                    status: null,
                    jobId: null
                });
                setCurrentStep((0, $lb17q.hasBannersStep)(template.data) ? (0, $lb17q.WIZARD_STEP).BANNERS : (0, $lb17q.getImagesSteps)(activeTemplateId, template.data).at(-1)?.id ?? (0, $lb17q.WIZARD_STEP).BRANDING);
            }
        });
        return;
    }, [
        projectId,
        activeTemplateId,
        video.data?.videoPath,
        video.data?.templateType,
        video.data?.jobId,
        video.isSuccess,
        template.data,
        generateVideo.isPending,
        updateVideoMutate,
        generateVideoMutate,
        setCurrentStep
    ]);
    // Redirect to video view if video already has videoPath (completed)
    // useEffect(() => {
    //   if (params?.id && video.isSuccess && video.data?.videoPath) {
    //     navigate(`/projects/${params.id}`, { replace: true });
    //   }
    // }, [
    //   params?.id,
    //   video.isSuccess,
    //   video.data?.videoPath,
    //   location.pathname,
    //   navigate,
    // ]);
    // Initialize taglines data with selected campaign taglines
    (0, $eF4cA.useEffect)(()=>{
        if (!!selectedCampaign?.taglines?.length && taglinesData.every((tagline)=>!Object.keys(tagline).length)) setTaglinesData(selectedCampaign?.taglines ?? new Array(3).fill({}));
    }, [
        taglinesData,
        selectedCampaign?.taglines
    ]);
    const handleUploadAssets = (0, $eF4cA.useCallback)((items, fileName)=>new Promise((resolve, reject)=>{
            const getFileName = (name)=>name ? `upload__${name.substr(0, 50)}__${crypto.randomUUID()}` : `upload__${crypto.randomUUID()}`;
            const getAssetTypeFromBlob = (blob, originalName = "")=>{
                const mime = blob?.type ?? "";
                if (mime.startsWith("video/")) return "video";
                if (!mime && typeof originalName === "string" && /\.(mp4|webm|mov|m4v|mkv|avi)(\?|$)/i.test(originalName)) return "video";
                return "image";
            };
            (0, $eF4cA.startTransition)(async ()=>{
                const assets = await Promise.all(Array.from(items).map(async (item)=>{
                    if (item instanceof File) {
                        const type = getAssetTypeFromBlob(item, item.name);
                        return {
                            name: getFileName(item.name),
                            blob: item,
                            ...type ? {
                                type: type
                            } : {}
                        };
                    } else if (typeof item.getFile === "function") {
                        const file = await item.getFile();
                        const type = getAssetTypeFromBlob(file, file.name);
                        return {
                            name: getFileName(file.name),
                            blob: file,
                            ...type ? {
                                type: type
                            } : {}
                        };
                    } else if (item?.kind === "text" && item.types.has("image/scrapped")) {
                        const text = await item.getText("image/scrapped");
                        const content = JSON.parse(text);
                        const imageBlob = await (0, $9lDhw.getImageBlob)({
                            url: content.src
                        });
                        return {
                            name: getFileName(imageBlob.image.name),
                            blob: imageBlob.blob
                        };
                    } else if (item?.src) {
                        const imageBlob = await (0, $9lDhw.getImageBlob)({
                            url: item.src
                        });
                        return {
                            name: getFileName(imageBlob.image.name),
                            blob: imageBlob.blob
                        };
                    }
                }));
                await Promise.all(assets.filter(Boolean).map(async (asset)=>{
                    if (asset.type === "video") return asset;
                    try {
                        const dimensions = await (0, $6lZyT.getImageBlobDimensions)(asset.blob);
                        asset.size = dimensions;
                        return asset;
                    } catch (e) {
                        console.warn("Failed to get image dimensions for asset", asset, e);
                        return asset;
                    }
                }));
                if (typeof fileName === "string" && Array.from(items).some((item)=>item?.types?.has("image/asset"))) try {
                    const [item] = Array.from(items);
                    const text = await item.getText("image/asset");
                    const { presignURL: presignURL, ...asset } = JSON.parse(text);
                    await updateAssetsMutateAsync({
                        assets: [
                            {
                                ...asset,
                                name: fileName
                            }
                        ]
                    });
                    resolve({
                        assets: [
                            asset
                        ],
                        fileName: fileName
                    });
                } catch (e) {
                    console.error("Failed to parse asset from dropped item", e);
                    reject(new Error("Failed to parse asset from dropped item"));
                }
                else {
                    const updatedVideoData = await uploadAssetsMutateAsync({
                        assets: assets,
                        fileName: fileName
                    });
                    const uploadedAssetNames = assets.map((asset)=>asset.name);
                    resolve({
                        assets: updatedVideoData?.assets?.filter((a)=>uploadedAssetNames.includes(a.name)) ?? assets,
                        fileName: fileName
                    });
                }
                resolve({
                    assets: assets
                });
            });
        }), [
        uploadAssetsMutateAsync,
        updateAssetsMutateAsync
    ]);
    const handleColorChange = (0, $eF4cA.useCallback)(({ color: color, name: name })=>{
        if (!color || !name) return;
        const hex = color.toString("hex");
        updateAssetsMutate({
            assets: [
                {
                    name: name,
                    type: "color",
                    color: hex
                }
            ]
        }, {
            onSuccess: (data, variables)=>{
                const oldColor = selectedCampaign?.[name];
                const newColor = variables.assets.find((a)=>a.name === name)?.color;
                if (oldColor === newColor) return;
                const scenes = (selectedCampaign?.scenes ?? []).map((scene)=>{
                    const updatedScene = {
                        ...scene
                    };
                    if (scene?.Color?.includes(oldColor) && !!newColor) updatedScene.Color = scene.Color.map((c)=>c === oldColor ? newColor : c);
                    return updatedScene;
                });
                editCampaignMutate({
                    id: selectedCampaign?.id,
                    [name]: hex,
                    scenes: scenes
                }, {
                    onSuccess: ()=>{
                        // TODO: remove after refactoring
                        updateCustomerMutate({
                            customer: {
                                [name]: hex,
                                [name === "Brand-color" ? "color" : "secondaryColor"]: hex
                            }
                        });
                    }
                });
            }
        });
    }, [
        updateAssetsMutate,
        updateCustomerMutate,
        editCampaignMutate,
        selectedCampaign
    ]);
    const handleAssetMenuAction = (0, $eF4cA.useCallback)((action, asset)=>{
        if (action === "delete") updateAssetsMutate({
            toRemove: [
                asset
            ]
        });
        else if (asset?.filePath) updateAssetsMutate({
            assets: [
                {
                    ...asset,
                    name: action
                }
            ]
        });
        else handleUploadAssets([
            asset
        ], action);
    }, [
        updateAssetsMutate,
        handleUploadAssets
    ]);
    const [statusTextIndex, setStatusTextIndex] = (0, $eF4cA.useState)(0);
    // Cycle through status text while generating video or banners
    (0, $eF4cA.useEffect)(()=>{
        let intervalId = null;
        if (generateVideo.isPending || exportVideo.isFetching) intervalId = setInterval(()=>{
            setStatusTextIndex((prevIndex)=>(prevIndex + 1) % generateStatusText.length);
        }, 5000);
        else setStatusTextIndex(0);
        return ()=>{
            if (intervalId) clearInterval(intervalId);
        };
    }, [
        generateVideo.isPending,
        exportVideo.isFetching,
        generateStatusText.length
    ]);
    const handleNextStep = (0, $eF4cA.useCallback)((step)=>{
        const fromStep = currentStep;
        setCurrentStep(step);
        document.getElementById("beStory-content")?.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Run the step-we're-leaving's background action (e.g. voiceover mux).
        if (fromStep && fromStep !== step) runStepLeavingActionRef.current?.(fromStep);
        // Run the entered step's action (create video, generate scenes/banners,
        // start the render, …) — all configured per step in `STEP_ACTIONS`.
        runStepEnteringActionRef.current?.(step);
    }, [
        currentStep,
        setCurrentStep
    ]);
    const handleTemplateContinue = (0, $eF4cA.useCallback)(()=>{
        handleNextStep((0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS);
    }, [
        handleNextStep
    ]);
    const handleTemplateSelectionChange = (0, $eF4cA.useCallback)((keys)=>{
        const [key] = keys;
        setSelectedTemplateKey(key);
        handleTemplateContinue();
    }, [
        handleTemplateContinue
    ]);
    const handleLink = (url)=>{
        window.open(url, "_blank", "noopener,noreferrer");
    };
    const handleRegenerateScript = (options = {})=>{
        updateVideo.mutate({
            customer: {
                name: video.data?.customer?.name
            },
            assets: [],
            campaigns: [],
            selectedCampaignIds: []
        }, options);
    };
    const isCustomerDetailsDisabled = !customerName || activeTemplateId === "firefly-enterprise" && updateVideo.isPending || sfType === "drNumber" && !drNumber || sfType === "accountName" && !accountName;
    const downloadAllAssets = (0, $ikOQe.useDownloadAllAssets)(projectId);
    (0, $eF4cA.useEffect)(()=>{
        bannersAssetsFingerprintRef.current = null;
    }, [
        projectId
    ]);
    // Baseline variation assets for an existing project that already has banners
    (0, $eF4cA.useEffect)(()=>{
        if (!video.isSuccess || !video.data?.templateAssetsRenditions?.length || bannersAssetsFingerprintRef.current !== null) return;
        bannersAssetsFingerprintRef.current = assetsFingerprint;
    }, [
        video.isSuccess,
        video.data?.templateAssetsRenditions,
        assetsFingerprint
    ]);
    // Remember variation assets after banners are successfully exported
    (0, $eF4cA.useEffect)(()=>{
        if (currentStep !== (0, $lb17q.WIZARD_STEP).BANNERS || !exportBanners.isSuccess || exportBanners.isFetching || generateBanners.isPending) return;
        bannersAssetsFingerprintRef.current = assetsFingerprint;
    }, [
        currentStep,
        exportBanners.isSuccess,
        exportBanners.isFetching,
        generateBanners.isPending,
        assetsFingerprint
    ]);
    // Set customer details
    (0, $eF4cA.useEffect)(()=>{
        if (video.isEnabled && video.data?.customer) {
            setCustomerName(video.data?.customer?.name || "");
            setIndustry(video.data?.customer?.industry || "");
            setCustomerWebsiteURL(video.data?.customer?.websiteURL || "");
            setCustomerBrandCenterURL(video.data?.customer?.brandCenterURL || "");
            setCustomerColor(video.data?.customer?.color || "");
        }
    }, [
        video.isEnabled,
        video.data?.customer
    ]);
    // Set project details
    (0, $eF4cA.useEffect)(()=>{
        if (video.isEnabled && video.isSuccess) {
            const _sfType = !!video.data?.drNumber ? "drNumber" : !!video.data?.accountName ? "accountName" : "none";
            if (video.data?.templateId !== selectedTemplateKey) setSelectedTemplateKey(video.data?.templateId);
            if (video.data?.accountName !== accountName) setAccountName(video.data?.accountName || "");
            if (video.data?.drNumber !== drNumber) setDrNumber(video.data?.drNumber || "");
            if (_sfType !== sfType) setSfType(_sfType);
            if (video.data?.hint != null && video.data.hint !== hint) setHint(video.data.hint);
            if (video.data?.product != null && video.data.product !== product) setProduct(video.data.product);
            if (video.data?.musicPath != null && video.data.musicPath !== selectedMusicTrackId) setSelectedMusicTrackId(video.data.musicPath);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        video.isEnabled,
        video.isSuccess
    ]);
    // Generate banners when entering the step if not generated yet — handled by
    // the BANNERS entering action (`runBannersTransition`) via `handleNextStep`,
    // and by the unified missing-data placeholder after a refresh. No effect.
    (0, $eF4cA.useEffect)(()=>{
        setAudioMuxDownloadUrl(null);
        prevAudioMuxDownloadSourcesKeyRef.current = null;
    }, [
        projectId
    ]);
    const handleDownloadAudioMux = (0, $eF4cA.useCallback)(async ()=>{
        if (!audioMuxDownloadUrl) return;
        setAudioMuxDownloadPending(true);
        try {
            const contentType = "audio/wav";
            const { blob: blob } = await (0, $9lDhw.getImageBlob)({
                url: audioMuxDownloadUrl,
                contentType: contentType
            });
            (0, $9lDhw.downloadFile)(blob, `${projectId}-mux-audio`, contentType);
        } catch (e) {
            console.error("Audio mux download failed:", e);
        } finally{
            setAudioMuxDownloadPending(false);
        }
    }, [
        audioMuxDownloadUrl,
        projectId
    ]);
    const activeSteps = (0, $eF4cA.useMemo)(()=>(0, $lb17q.resolveSteps)(activeTemplateId, template.data), [
        activeTemplateId,
        template.data
    ]);
    // While a (re)generation is in flight, the previous run's video must not show.
    // `generateVideo` stays pending until its chained export resolves.
    const downloadVideoUrl = generateVideo.isPending ? null : $a17caf9b7a820813$var$getExternalHref(s3VideoURL.data?.presignURL || exportVideo.data?.presignURL);
    const isVideoRendered = !generateVideo.isPending && !!(downloadVideoUrl || exportVideo.isSuccess);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $77tch.VideoWizardContext).Provider, {
        value: {
            // identifiers & refs
            videoId: projectId,
            templateId: selectedTemplateKey,
            actionsContainerRef: actionsContainerRef,
            contentContainerRef: contentContainerRef,
            currentStep: // wizard state / navigation
            currentStep,
            setCurrentStep: setCurrentStep,
            handleNextStep: handleNextStep,
            activeSteps: activeSteps,
            activeTemplateId: activeTemplateId,
            setSelectedTemplateKey: setSelectedTemplateKey,
            runStepEnteringActionRef: // step action dispatch refs (assigned by useWizardStepActions)
            runStepEnteringActionRef,
            runStepLeavingActionRef: runStepLeavingActionRef,
            video: // core queries & mutations (from useVideoWizard)
            video,
            template: template,
            templates: templates,
            assetsTemplate: assetsTemplate,
            createVideo: createVideo,
            createVideoIfNeeded: createVideoIfNeeded,
            updateVideo: updateVideo,
            updateCustomer: updateCustomer,
            updateAssets: updateAssets,
            uploadAssets: uploadAssets,
            addCampaign: addCampaign,
            editCampaign: editCampaign,
            generateScenes: sceneGeneration.mutation,
            regenerateScenes: sceneGeneration.regenerate,
            getScenesPromptTemplate: sceneGeneration.getScenesPromptTemplate,
            customerBranding: customerBranding,
            drNumbers: drNumbers,
            accounts: accounts,
            personas: personas,
            selectedPersona: selectedPersona,
            setSelectedPersona: setSelectedPersona,
            verticals: verticals,
            selectedVertical: selectedVertical,
            setSelectedVertical: setSelectedVertical,
            scrapeQueries: scrapeQueries,
            searchImagesQueries: searchImagesQueries,
            appStoreQuery: appStoreQuery,
            bannersStatus: bannersStatus,
            generateBanners: generateBanners,
            exportBanners: exportBanners,
            generateVideo: generateVideo,
            exportVideo: exportVideo,
            renderProgress: renderProgress,
            generateStatusText: generateStatusText,
            describeMogrtTemplate: describeMogrtTemplate,
            checkCustomer: checkCustomer,
            audioMux: audioMux,
            customerName: // wizard-input state + setters
            customerName,
            setCustomerName: setCustomerName,
            hint: hint,
            setHint: setHint,
            product: product,
            setProduct: setProduct,
            include3DDigitalTwin: include3DDigitalTwin,
            setInclude3DDigitalTwin: setInclude3DDigitalTwin,
            sfType: sfType,
            setSfType: setSfType,
            drNumber: drNumber,
            drNumbersFilter: drNumbersFilter,
            setDrNumbersFilter: setDrNumbersFilter,
            accountName: accountName,
            setAccountName: setAccountName,
            selectedTemplateKey: selectedTemplateKey,
            handleTemplateSelectionChange: handleTemplateSelectionChange,
            setProjectId: setProjectId,
            agreeToTerms: // step-local UI state owned by the parent (referenced by effects/handlers)
            agreeToTerms,
            setAgreeToTerms: setAgreeToTerms,
            editedCampaign: editedCampaign,
            setEditedCampaign: setEditedCampaign,
            editVariation: editVariation,
            setEditVariation: setEditVariation,
            taglinesData: taglinesData,
            handleTaglineChange: handleTaglineChange,
            selectedMusicTrackId: selectedMusicTrackId,
            setSelectedMusicTrackId: setSelectedMusicTrackId,
            selectedMusicTrackURL: selectedMusicTrackURL,
            groupedMusicTracks: groupedMusicTracks,
            statusTextIndex: statusTextIndex,
            audioMuxDownloadUrl: audioMuxDownloadUrl,
            audioMuxDownloadPending: audioMuxDownloadPending,
            setAudioMuxDownloadUrl: setAudioMuxDownloadUrl,
            prevAudioMuxDownloadSourcesKeyRef: prevAudioMuxDownloadSourcesKeyRef,
            handleUploadAssets: // shared handlers
            handleUploadAssets,
            handleColorChange: handleColorChange,
            handleAssetMenuAction: handleAssetMenuAction,
            handleDrNumbersSelectionChange: handleDrNumbersSelectionChange,
            handleTemplateContinue: handleTemplateContinue,
            handleRegenerateScript: handleRegenerateScript,
            handleDownloadAudioMux: handleDownloadAudioMux,
            handleLink: handleLink,
            selectedCampaign: // derived values
            selectedCampaign,
            selectedAssets: selectedAssets,
            scrapedColors: scrapedColors,
            allScrapedQueries: allScrapedQueries,
            areAllVisualsSelected: areAllVisualsSelected,
            isCustomerDetailsDisabled: isCustomerDetailsDisabled,
            downloadAllAssets: downloadAllAssets,
            downloadVideoUrl: downloadVideoUrl,
            isVideoRendered: isVideoRendered,
            assetsFingerprint: assetsFingerprint,
            bannersAssetsFingerprintRef: // refs for step action hook
            bannersAssetsFingerprintRef,
            audioMuxRanForSourcesKeyRef: audioMuxRanForSourcesKeyRef,
            colorScheme: // misc app state
            colorScheme,
            isLargeViewport: isLargeViewport,
            isMobile: isMobile,
            setPromptHint: setPromptHint,
            feedback: feedback
        },
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: `${!!video.data?.name ? `${video.data?.name} | ` : ""}New video | BeStory`
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)($a17caf9b7a820813$var$VideoWizardContent, {
                type: type
            })
        ]
    });
};
$a17caf9b7a820813$export$e9d66656d090d4fb.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    ]),
    // Optional preselected template. Seeds `selectedTemplateKey` so the wizard can
    // be started from outside (e.g. the home page) skipping template selection.
    selectedTemplateKey: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string
};
// ---------------------------------------------------------------------------
// Inner component — renders inside the provider so it can consume context.
// Calls useWizardStepActions (which reads from VideoWizardContext) and
// overrides context with the computed step-action values.
// ---------------------------------------------------------------------------
const $a17caf9b7a820813$var$VideoWizardContent = ({ type: type })=>{
    const ctx = (0, $eF4cA.use)((0, $77tch.VideoWizardContext));
    const { stepActionCtx: stepActionCtx, regenerateBannersFromCurrentAssets: regenerateBannersFromCurrentAssets, computeVoiceoverMuxKey: computeVoiceoverMuxKey } = (0, $358fce2ffba1b379$export$908544b14d170f6e)();
    const { currentStep: currentStep, handleNextStep: handleNextStep, activeSteps: activeSteps, activeTemplateId: activeTemplateId, template: template, video: video, isLargeViewport: isLargeViewport, isMobile: isMobile, feedback: feedback, contentContainerRef: contentContainerRef, actionsContainerRef: actionsContainerRef, setAudioMuxDownloadUrl: setAudioMuxDownloadUrl, prevAudioMuxDownloadSourcesKeyRef: prevAudioMuxDownloadSourcesKeyRef, runStepEnteringActionRef: runStepEnteringActionRef } = ctx;
    const stepperSteps = (0, $eF4cA.useMemo)(()=>activeSteps.filter((step)=>!(0, $lb17q.PRE_FLOW_STEPS).includes(step.id) && !step.viewless), [
        activeSteps
    ]);
    const currentIndex = activeSteps.findIndex((step)=>step.id === currentStep);
    const currentStepEntry = activeSteps[currentIndex];
    const nextStep = currentIndex >= 0 ? activeSteps[currentIndex + 1] : undefined;
    let prevStep;
    for(let i = currentIndex - 1; i >= 0; i--)if (!activeSteps[i].viewless) {
        prevStep = activeSteps[i];
        break;
    }
    const enterAction = (0, $lb17q.getStepEnterAction)(currentStepEntry ?? currentStep, activeTemplateId);
    const isStepPending = enterAction?.isPending(stepActionCtx);
    const showStepPlaceholder = !!enterAction?.placeholder && !enterAction.isReady(stepActionCtx) && !isStepPending;
    const isViewlessStep = !!currentStepEntry?.viewless;
    const isViewlessStepReady = isViewlessStep && !!enterAction?.isReady(stepActionCtx) && !!nextStep;
    (0, $eF4cA.useEffect)(()=>{
        if (isViewlessStepReady) handleNextStep(nextStep.id);
    }, [
        isViewlessStepReady,
        nextStep?.id,
        handleNextStep
    ]);
    // Invalidate the audio-mux download URL when the voiceover source changes.
    const audioMuxSourcePathsKey = (0, $eF4cA.useMemo)(()=>computeVoiceoverMuxKey(video.data), [
        computeVoiceoverMuxKey,
        video.data
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!(0, $358fce2ffba1b379$export$6e3cfba39daf22d3)(template.data?.id)) {
            setAudioMuxDownloadUrl(null);
            prevAudioMuxDownloadSourcesKeyRef.current = null;
            return;
        }
        if (!audioMuxSourcePathsKey) return;
        if (prevAudioMuxDownloadSourcesKeyRef.current !== audioMuxSourcePathsKey) {
            setAudioMuxDownloadUrl(null);
            prevAudioMuxDownloadSourcesKeyRef.current = audioMuxSourcePathsKey;
        }
    }, [
        template.data?.id,
        audioMuxSourcePathsKey
    ]);
    if (currentStep === null) return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
        className: " Za182 Fb182 sd182 eb182 _Ca182",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
            "aria-label": "Loading",
            isIndeterminate: true,
            size: "L",
            staticColor: "auto"
        })
    });
    const goNext = nextStep ? ()=>handleNextStep(nextStep.id) : undefined;
    const goBack = prevStep && !(0, $lb17q.PRE_FLOW_STEPS).includes(prevStep.id) ? ()=>handleNextStep(prevStep.id) : undefined;
    const continueLabel = (0, $lb17q.getContinueLabel)(nextStep);
    const ActiveStepComponent = $a17caf9b7a820813$var$STEP_TYPE_COMPONENTS[(0, $lb17q.getStepType)(currentStepEntry ?? currentStep)] ?? $a17caf9b7a820813$var$getTemplateStepComponents(type)[currentStep];
    const shouldShowWizardSteps = (0, $lb17q.isStepAfter)(currentStepEntry ?? currentStep, (0, $lb17q.WIZARD_STEP).ACCOUNT_DETAILS) && !isViewlessStep;
    const WizardSteps = (props)=>shouldShowWizardSteps ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$668709c620d0b8e2), {
            selectedKey: currentStep,
            onSelectionChange: handleNextStep,
            ...props,
            children: stepperSteps.map((step, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                    id: step.id,
                    isDisabled: video.data?.status === "completed" ? false : activeSteps.findIndex((s)=>s.id === step.id) > currentIndex,
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                        styles: " sh182 Ue182 qe182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: String.fromCodePoint(10112 + idx)
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: step.name
                            })
                        ]
                    })
                }, step.id))
        }) : null;
    const MobileWizardSteps = (props)=>shouldShowWizardSteps ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
            selectionMode: "single",
            value: currentStep,
            onChange: handleNextStep,
            ...props,
            children: stepperSteps.map((step, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                    id: step.id,
                    isDisabled: video.data?.status === "completed" ? false : activeSteps.findIndex((s)=>s.id === step.id) > currentIndex,
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: `${String.fromCodePoint(10112 + idx)}\xA0\xA0${step.name}`
                    })
                }, step.id))
        }) : null;
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $77tch.VideoWizardContext).Provider, {
        value: {
            ...ctx,
            isStepPending: isStepPending,
            stepActionCtx: stepActionCtx,
            regenerateBannersFromCurrentAssets: regenerateBannersFromCurrentAssets
        },
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            ref: contentContainerRef,
            className: " _oa182 se182 CzFW76b182 DsGZ7Nd182 EImJNYb182 Za182 Soh182 Roh182",
            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2986841c3e3fe42c$export$2e8c8acb7c299935), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1f7d28ef023026e3$export$edb76fdb8665f52), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8114da46d8533f15$export$a650b5679edb7ec5), {
                            item: video.data
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1f7d28ef023026e3$export$78a558edcc066ec2), {
                        children: isLargeViewport && /*#__PURE__*/ (0, $dx4lB.jsx)(WizardSteps, {
                            styles: " IM182 HM182 zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182"
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1f7d28ef023026e3$export$223875819fd7cf93), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                            variant: "primary",
                            onPress: feedback.open,
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' zkG38H182';
                                rules += ' ykG38H182';
                                rules += ' BkG38H182';
                                rules += ' AkG38H182';
                                if (props.isLargeViewport) rules += ' IM182';
                                else rules += ' IM182';
                                return rules;
                            }({
                                isLargeViewport: isLargeViewport,
                                shouldShowWizardSteps: shouldShowWizardSteps
                            }),
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $88da991c28d9e725$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Share feedback"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5e54d0a0882391be$export$ce3b880e766d1e30), {
                        video: video.data,
                        isOpen: feedback.isOpen,
                        onClose: feedback.close,
                        method: feedback.method
                    }),
                    !isLargeViewport && !isMobile && /*#__PURE__*/ (0, $dx4lB.jsx)(WizardSteps, {
                        UNSAFE_className: " zqggLs182 yqggLs182 BqggLs182 AqggLs182 IM182 HM182 _nLeasBb182 _Pe182 Ww182 _9G1Ky182",
                        UNSAFE_style: {
                            backgroundColor: "lch(from var(--s2-container-bg) calc((49.44 - l) * infinity) 0 0 / 0.11)",
                            backdropFilter: `blur(${"calc(0.25rem * var(--s2-scale))"})`
                        }
                    }),
                    isMobile && /*#__PURE__*/ (0, $dx4lB.jsx)(MobileWizardSteps, {
                        styles: " zqggLs182 yqggLs182 BqggLs182 AqggLs182 Za182"
                    }),
                    isViewlessStep ? showStepPlaceholder ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
                                    title: enterAction.placeholder.title,
                                    retryLabel: enterAction.placeholder.action,
                                    onRetry: ()=>runStepEnteringActionRef.current?.(currentStep),
                                    children: enterAction.placeholder.body
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                                onBack: goBack
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Loading, {
                        title: enterAction?.pending?.title,
                        subtitle: enterAction?.pending?.subtitle,
                        icon: enterAction?.pending?.icon
                    }) : ActiveStepComponent && (showStepPlaceholder ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Error, {
                                    title: enterAction.placeholder.title,
                                    retryLabel: enterAction.placeholder.action,
                                    onRetry: ()=>runStepEnteringActionRef.current?.(currentStep),
                                    children: enterAction.placeholder.body
                                })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87bd91c06342e699$export$fd55ce593607084a).Actions, {
                                onBack: goBack
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)(ActiveStepComponent, {
                        name: currentStepEntry?.name,
                        description: currentStepEntry?.description,
                        preview: currentStepEntry?.preview,
                        contentLabel: currentStepEntry?.contentLabel,
                        canEditCampaign: currentStepEntry?.canEditCampaign,
                        showPromptFooter: currentStepEntry?.showPromptFooter,
                        stages: currentStepEntry?.stages,
                        campaignStructure: currentStepEntry?.campaignStructure,
                        promptHintsKey: currentStepEntry?.promptHintsKey,
                        editScope: currentStepEntry?.editScope,
                        continueLabel: continueLabel,
                        onContinue: goNext,
                        onBack: goBack
                    })),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        ref: actionsContainerRef,
                        className: (0, $5nTep.mergeStyles)(" zkG38H182 ykG38H182 BkG38H182 AkG38H182 _dd182 __Ac182 Te182 Qe182 Se182 Re182 g_g182 oh182 nh182 kh182 jh182 _nLeasBb182 _Pe182 _lw182", "PBHkad")
                    })
                ]
            })
        })
    });
};
$a17caf9b7a820813$var$VideoWizardContent.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9eyCh))).string)
    ])
};



var $dx4lB = parcelRequire("dx4lB");

var $dqZbZ = parcelRequire("dqZbZ");

var $5IZkx = parcelRequire("5IZkx");

var $208Op = parcelRequire("208Op");

var $fmJ8d = parcelRequire("fmJ8d");


var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $66fca662a6716d8d$var$$06140f8ad6738efd$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M130.329 22.103c2.886 1.738 4.783 5.246 3.927 9.223v.002l-2.121 9.84-.001.006c-.052.24.024.47.137.598l.002.001 6.548 7.415h.001c2.712 3.07 2.672 7.073 1.074 9.961-1.608 2.906-5.053 5.092-9.162 4.13l-.001-.001-9.43-2.213-.007-.002q-.043-.011-.096.003c-.036.01-.084.033-.135.082h-.001l-7.106 6.834h-.001c-3.017 2.903-7.075 2.896-9.988 1.141-2.886-1.739-4.783-5.246-3.927-9.223v-.002l2.121-9.84.001-.006c.052-.24-.024-.47-.137-.598h-.001l-6.549-7.416c-2.713-3.07-2.673-7.073-1.075-9.961 1.608-2.906 5.053-5.092 9.162-4.13l.001.001 9.43 2.214.007.001q.043.011.096-.003c.036-.01.084-.033.135-.082h.001l7.106-6.834h.001c3.017-2.903 7.075-2.896 9.988-1.141m-4.302 6.8c-.011.005-.06.029-.14.106h-.001l-7.106 6.834c-2.011 1.935-4.863 2.755-7.615 2.106h-.004l-9.422-2.212h-.001c-.081-.02-.118-.015-.121-.014q-.004-.001-.016.005c-.026.013-.116.072-.199.222s-.112.307-.102.428c.007.092.035.208.172.363h.001l6.548 7.415.001.001c1.831 2.073 2.542 4.91 1.961 7.59l-.001.003-2.119 9.833c-.055.253-.011.385.019.45.041.091.117.179.215.238.099.06.16.056.162.056h.002q0 .001.01-.004c.011-.005.06-.029.14-.106h.001l7.106-6.834h.001c2.011-1.935 4.862-2.755 7.613-2.107l.005.002 9.422 2.211h.002c.081.02.117.015.12.014h.004q.004 0 .012-.005c.026-.013.116-.072.199-.222s.112-.307.103-.428c-.008-.092-.036-.208-.173-.363h-.001l-6.548-7.415-.001-.001c-1.831-2.073-2.542-4.91-1.961-7.59l.001-.003 2.119-9.833c.055-.253.011-.385-.019-.45-.041-.091-.117-.179-.215-.238-.099-.06-.16-.056-.162-.056h-.002zM24.25 49.021c0-9.06 7.492-16.04 16.43-16.04h41.695c2.21 0 4 1.792 4 4 0 2.21-1.79 4-4 4H40.679c-4.791 0-8.429 3.666-8.429 8.04v39.66c0 4.375 3.638 8.04 8.43 8.04h14.569l.017 3.983c.024 5.739.047 13.973 0 20.253v.003q.015.014.052.031c.057.026.106.028.13.026l.024-.007c.006-.002.028-.012.063-.042l.006-.005.005-.005 27.667-23.297 1.117-.94h35.062c4.792 0 8.429-3.665 8.429-8.04V74.896c0-2.21 1.791-4 4-4s4 1.79 4 4V88.68c0 9.06-7.491 16.04-16.429 16.04H87.25l-26.54 22.347-.006.006c-5.166 4.374-13.49.909-13.438-6.176.036-4.894.03-11.001.015-16.177h-6.602c-8.937 0-16.429-6.98-16.429-16.04zm66.108 35.04-6.93-1.562c-.919-.205-1.87.052-2.56.684L75.647 88c-2.058 1.898-5.33.006-4.714-2.719l1.561-6.931c.206-.918-.05-1.87-.684-2.56l-4.816-5.22c-1.898-2.058-.006-5.33 2.719-4.715l6.931 1.562c.918.205 1.87-.051 2.56-.684l5.22-4.816c2.058-1.898 5.33-.006 4.715 2.718l-1.562 6.932c-.206.917.051 1.87.684 2.559l4.816 5.221c1.898 2.058.006 5.33-2.719 4.714"
        })
    });
const $66fca662a6716d8d$var$$06140f8ad6738efd$var$ForwardRef = (0, $eF4cA.forwardRef)($66fca662a6716d8d$var$$06140f8ad6738efd$var$SvgComponent);
var $66fca662a6716d8d$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($66fca662a6716d8d$var$$06140f8ad6738efd$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $92a3fa1b8095d99a$var$$9bd638fc000dccce$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M76.972 14.651c1.564.943 2.594 2.843 2.128 5.005l-1.229 5.701v.003c-.051.236.018.472.152.624l3.794 4.296c1.472 1.666 1.452 3.836.583 5.407-.874 1.58-2.737 2.757-4.958 2.237l-5.463-1.282-.003-.001c-.135-.032-.294.001-.427.129l-4.118 3.96c-1.634 1.571-3.825 1.568-5.403.617-1.564-.942-2.593-2.843-2.128-5.005l1.229-5.7v-.004c.051-.235-.018-.472-.152-.624l-3.794-4.296c-1.472-1.666-1.452-3.836-.583-5.407.874-1.58 2.737-2.757 4.957-2.236h.001l5.463 1.282h.003c.135.032.294 0 .427-.129l4.118-3.959c1.634-1.572 3.825-1.569 5.403-.618m-2.348 3.35c-.055.004-.15.024-.282.15v.001l-4.117 3.958v.001c-1.09 1.048-2.632 1.49-4.119 1.14h-.002l-5.46-1.282c-.148-.035-.233-.01-.292.02-.078.038-.175.12-.252.259-.156.28-.133.58.08.822l3.794 4.295c.994 1.125 1.38 2.665 1.065 4.12v.002l-1.229 5.697c-.046.214-.013.359.033.46.051.112.14.21.25.277.11.066.211.083.283.077.055-.005.15-.025.282-.151l4.117-3.96c1.09-1.047 2.632-1.49 4.119-1.14l.002.001 5.459 1.281c.149.035.233.01.293-.02.078-.038.175-.12.252-.259.155-.28.133-.58-.08-.821l-3.794-4.296c-.993-1.124-1.38-2.664-1.065-4.12v-.002l1.229-5.696zM16 29.973c0-5.063 4.187-8.975 9.2-8.975H51c1.105 0 2 .896 2 2s-.895 2-2 2H25.2c-2.94 0-5.2 2.255-5.2 4.975v22.975c0 2.72 2.26 4.975 5.2 4.975h8.125l.008 1.991c.014 3.325.027 8.094 0 11.73 0 .09.022.14.047.176.031.045.087.097.17.135.084.037.17.049.243.04.064-.007.136-.031.219-.1l.005-.006 16.028-13.496.558-.47H70.8c2.94 0 5.2-2.255 5.2-4.975V43c0-1.104.895-2 2-2s2 .896 2 2v9.95c0 5.063-4.187 8.975-9.2 8.975H52.063L36.6 74.945l-.003.003c-2.796 2.368-7.291.487-7.263-3.333.022-2.937.018-6.627.008-9.691H25.2c-5.014 0-9.201-3.912-9.201-8.975zm37.98 20.299-4.015-.905c-.532-.119-1.083.03-1.483.396l-3.025 2.79c-1.192 1.1-3.087.004-2.73-1.575l.904-4.015c.12-.532-.03-1.083-.396-1.483l-2.79-3.024c-1.1-1.193-.004-3.088 1.575-2.731l4.015.904c.532.12 1.083-.03 1.483-.396l3.025-2.79c1.192-1.1 3.087-.003 2.73 1.575l-.904 4.015c-.12.532.03 1.084.396 1.483l2.79 3.025c1.1 1.192.004 3.087-1.575 2.73"
        })
    });
const $92a3fa1b8095d99a$var$$9bd638fc000dccce$var$ForwardRef = (0, $eF4cA.forwardRef)($92a3fa1b8095d99a$var$$9bd638fc000dccce$var$SvgComponent);
var $92a3fa1b8095d99a$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($92a3fa1b8095d99a$var$$9bd638fc000dccce$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $8d9b47f9cb84583c$var$$e35b3b4c208ea36f$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M38.615 7.111c.867.523 1.436 1.576 1.18 2.77l-.615 2.85v.002q-.006.028 0 .057.01.027.019.036l1.897 2.149c.814.922.802 2.124.323 2.99-.483.871-1.519 1.53-2.755 1.24l-2.718-.638-2.057 1.978c-.907.872-2.129.87-3.004.343-.867-.523-1.436-1.576-1.18-2.77l.615-2.85v-.002q.006-.028 0-.057-.01-.027-.019-.036l-1.897-2.149c-.814-.921-.802-2.124-.323-2.99.483-.871 1.519-1.53 2.755-1.24l2.718.638 2.057-1.978c.907-.872 2.129-.87 3.004-.343m-1.278 2.151-2.051 1.973c-.605.582-1.463.829-2.29.634h-.002l-2.716-.638-.01.014c-.015.028-.019.056-.018.073q0 .01.004.017.002.007.023.034l1.897 2.148c.55.623.764 1.474.59 2.278v.001l-.614 2.848q-.008.047-.005.057 0 .012.004.017.003.009.014.018l2.051-1.972c.605-.582 1.463-.829 2.29-.633h.002l2.716.637.01-.014c.015-.028.019-.056.018-.073q0-.01-.004-.017-.002-.007-.024-.034l-1.896-2.148c-.55-.622-.764-1.474-.59-2.278v-.002l.614-2.847q.008-.046.005-.057 0-.011-.004-.017-.003-.009-.014-.019M7.75 14.987c0-2.678 2.214-4.738 4.85-4.738h12.431c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25h-12.43c-1.341 0-2.351 1.024-2.351 2.238v11.487c0 1.214 1.01 2.238 2.35 2.238h4.311l.006 1.244c.006 1.624.013 3.937 0 5.739l7.944-6.69.35-.293H35.4c1.34 0 2.35-1.024 2.35-2.238v-4.6c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25v4.6c0 2.678-2.214 4.738-4.85 4.738h-9.277l-7.662 6.451-.002.002c-1.553 1.315-4.058.275-4.042-1.86.01-1.388.009-3.114.004-4.593h-1.82c-2.637 0-4.851-2.06-4.851-4.738zm19.24 10.15-2.008-.453c-.265-.06-.541.015-.74.198l-1.513 1.395c-.596.55-1.544.002-1.366-.788l.453-2.007c.06-.266-.015-.542-.198-.741l-1.396-1.513c-.55-.596-.001-1.544.788-1.365l2.008.452c.265.06.541-.015.74-.198l1.513-1.395c.596-.55 1.544-.002 1.366.787l-.453 2.008c-.06.266.015.542.198.741l1.396 1.513c.55.596.001 1.543-.788 1.365"
        })
    });
const $8d9b47f9cb84583c$var$$e35b3b4c208ea36f$var$ForwardRef = (0, $eF4cA.forwardRef)($8d9b47f9cb84583c$var$$e35b3b4c208ea36f$var$SvgComponent);
var $8d9b47f9cb84583c$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($8d9b47f9cb84583c$var$$e35b3b4c208ea36f$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $90d7955cd72decdd$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $66fca662a6716d8d$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $8d9b47f9cb84583c$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $92a3fa1b8095d99a$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $302ac13943472358$var$$b4d74829879d5387$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M47.136 24C38.267 24 31 31.12 31 40v80c0 8.879 7.267 16 16.136 16h64.728c8.869 0 16.136-7.121 16.136-16V72.97c0-4.258-1.711-8.332-4.742-11.33L89.913 28.67c-3.03-2.995-7.13-4.67-11.395-4.67zM39 40c0-4.376 3.6-8 8.136-8h31.382c2.173 0 4.247.854 5.77 2.36l33.345 32.97c1.521 1.504 2.367 3.534 2.367 5.64V120c0 4.376-3.6 8-8.136 8H47.136C42.6 128 39 124.376 39 120zm30.811 32.94 20.933 12.12c2.344 1.357 2.34 4.743-.007 6.094l-20.962 12.069c-2.348 1.352-5.278-.344-5.275-3.053l.029-24.189c.003-2.709 2.938-4.398 5.282-3.04"
        })
    });
const $302ac13943472358$var$$b4d74829879d5387$var$ForwardRef = (0, $eF4cA.forwardRef)($302ac13943472358$var$$b4d74829879d5387$var$SvgComponent);
var $302ac13943472358$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($302ac13943472358$var$$b4d74829879d5387$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $58639cbc0aa61e93$var$$af8f208254589130$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M30.09 16C25.117 16 21 19.95 21 24.923v46.154C21 76.05 25.116 80 30.09 80h37.82c4.974 0 9.09-3.95 9.09-8.923V43.945c0-2.383-.97-4.657-2.68-6.327L54.838 18.597C53.129 16.929 50.822 16 48.426 16zM25 24.923C25 22.25 27.234 20 30.09 20h18.336c1.366 0 2.666.53 3.617 1.459L71.526 40.48c.95.927 1.474 2.175 1.474 3.465v27.132C73 73.75 70.766 76 67.91 76H30.09C27.235 76 25 73.751 25 71.077zm19.345 20.542 11.214 6.432c1.256.72 1.254 2.517-.003 3.235l-11.23 6.406c-1.258.717-2.828-.183-2.826-1.621l.016-12.838c.001-1.438 1.573-2.335 2.83-1.614"
        })
    });
const $58639cbc0aa61e93$var$$af8f208254589130$var$ForwardRef = (0, $eF4cA.forwardRef)($58639cbc0aa61e93$var$$af8f208254589130$var$SvgComponent);
var $58639cbc0aa61e93$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($58639cbc0aa61e93$var$$af8f208254589130$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $cdddc56bc0cd9988$var$$0cddd9bebb2f3e5f$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M10.25 12.462c0-2.631 2.176-4.712 4.796-4.712h9.167c1.262 0 2.479.49 3.38 1.37l9.742 9.51c.902.881 1.415 2.083 1.415 3.342v13.566c0 2.631-2.176 4.712-4.795 4.712h-18.91c-2.62 0-4.795-2.081-4.795-4.712zm4.796-2.212c-1.296 0-2.296 1.018-2.296 2.211v23.077c0 1.195 1 2.212 2.296 2.212h18.909c1.295 0 2.295-1.017 2.295-2.212V21.972c0-.577-.234-1.136-.662-1.553l-9.741-9.51c-.428-.419-1.016-.659-1.634-.659zm6.816 11.947 6.355 3.645c.712.408.71 1.426-.002 1.833l-6.364 3.63c-.712.406-1.602-.104-1.601-.919l.009-7.275c0-.814.892-1.323 1.603-.914"
        })
    });
const $cdddc56bc0cd9988$var$$0cddd9bebb2f3e5f$var$ForwardRef = (0, $eF4cA.forwardRef)($cdddc56bc0cd9988$var$$0cddd9bebb2f3e5f$var$SvgComponent);
var $cdddc56bc0cd9988$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($cdddc56bc0cd9988$var$$0cddd9bebb2f3e5f$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9c26f322cb0cf44c$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $302ac13943472358$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $cdddc56bc0cd9988$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $58639cbc0aa61e93$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}




var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $7d05df60b6637bcb$var$$b0b4020c6d4d1657$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M53.446 24.063c0-2.21-1.791-4-4-4s-4 1.79-4 4v21.262H24.063c-2.21 0-4 1.791-4 4s1.79 4 4 4h21.383v41.35c0 11.046 8.954 20 20 20h41.108v21.263c0 2.209 1.791 4 4 4s4-1.791 4-4v-21.263h21.384c2.209 0 4-1.791 4-4s-1.791-4-4-4H65.446c-6.628 0-12-5.372-12-12V24.063m8.613 21.262c-2.209 0-4 1.791-4 4s1.791 4 4 4h32.496c6.627 0 11.999 5.373 11.999 12v32.72c0 2.209 1.791 4 4 4s4-1.791 4-4v-32.72c0-11.046-8.954-20-20-20z"
        })
    });
const $7d05df60b6637bcb$var$$b0b4020c6d4d1657$var$ForwardRef = (0, $eF4cA.forwardRef)($7d05df60b6637bcb$var$$b0b4020c6d4d1657$var$SvgComponent);
var $7d05df60b6637bcb$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($7d05df60b6637bcb$var$$b0b4020c6d4d1657$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $83a51d249d6e0e3b$var$$6254e954814bde00$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M31.974 15c0-1.105-.895-2-2-2s-2 .895-2 2v12.903H15c-1.105 0-2 .896-2 2s.895 2 2 2h12.974v26.193c0 5.523 4.478 10 10 10h26.05v12.903c0 1.105.896 2 2 2s2-.895 2-2V68.096H81c1.105 0 2-.895 2-2s-.895-2-2-2H37.974c-3.313 0-6-2.686-6-6V15m5.442 12.903c-1.105 0-2 .896-2 2s.895 2 2 2h20.609c3.314 0 6 2.687 6 6v20.742c0 1.104.895 2 2 2s2-.896 2-2V37.903c0-5.523-4.477-10-10-10z"
        })
    });
const $83a51d249d6e0e3b$var$$6254e954814bde00$var$ForwardRef = (0, $eF4cA.forwardRef)($83a51d249d6e0e3b$var$$6254e954814bde00$var$SvgComponent);
var $83a51d249d6e0e3b$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($83a51d249d6e0e3b$var$$6254e954814bde00$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $00ee588c66f4b3fd$var$$07fb6aef5ee0af3a$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M16.237 7.5c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v6.202H7.5c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h6.237v12.846c0 2.9 2.35 5.25 5.25 5.25h12.775V40.5c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25v-6.202H40.5c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25H18.987c-1.519 0-2.75-1.231-2.75-2.75V7.5M19 13.702c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h10.012c1.52 0 2.75 1.23 2.75 2.75v10.063c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25V18.952c0-2.9-2.35-5.25-5.25-5.25z"
        })
    });
const $00ee588c66f4b3fd$var$$07fb6aef5ee0af3a$var$ForwardRef = (0, $eF4cA.forwardRef)($00ee588c66f4b3fd$var$$07fb6aef5ee0af3a$var$SvgComponent);
var $00ee588c66f4b3fd$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($00ee588c66f4b3fd$var$$07fb6aef5ee0af3a$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e5762da11b7e03f0$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $7d05df60b6637bcb$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $00ee588c66f4b3fd$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $83a51d249d6e0e3b$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}




var $dm5H1 = parcelRequire("dm5H1");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $282fbb403a6217f1$var$$d80214ad185890e6$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M93.84 28c-10.26 0-19 8.936-19 20.5s8.74 20.5 19 20.5 19-8.936 19-20.5-8.741-20.5-19-20.5m-27 20.5c0-15.498 11.854-28.5 27-28.5s27 13.002 27 28.5-11.854 28.5-27 28.5-27-13.002-27-28.5m-3.453-20.308c2.185-.324 3.694-2.358 3.37-4.543s-2.359-3.694-4.544-3.37C48.907 22.252 39 34.306 39 48.5c0 14.243 9.977 26.333 23.352 28.242 2.187.312 4.212-1.208 4.525-3.395.312-2.187-1.208-4.213-3.395-4.525C54.368 67.522 47 59.092 47 48.5c0-10.554 7.317-18.963 16.387-20.308m-9.255 62.54c2.119-.626 3.33-2.85 2.705-4.969-.626-2.119-2.85-3.33-4.969-2.705-17.788 5.249-31.655 20.01-35.592 38.311-1.602 7.446 3.967 14.621 11.72 14.621H33.5c2.21 0 4-1.791 4-4s-1.79-4-4-4h-5.504c-2.526 0-4.457-2.345-3.9-4.939 3.316-15.409 15.03-27.892 30.036-32.32M51.79 123.05C55.955 103.693 73.346 89 93.84 89s37.885 14.693 42.049 34.051c.558 2.594-1.373 4.939-3.899 4.939h-76.3c-2.527 0-4.458-2.345-3.9-4.939M93.84 81c-24.367 0-44.935 17.427-49.87 40.369-1.603 7.446 3.966 14.621 11.72 14.621h76.3c7.753 0 13.322-7.175 11.72-14.621C138.775 98.427 118.206 81 93.84 81"
        })
    });
const $282fbb403a6217f1$var$$d80214ad185890e6$var$ForwardRef = (0, $eF4cA.forwardRef)($282fbb403a6217f1$var$$d80214ad185890e6$var$SvgComponent);
var $282fbb403a6217f1$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($282fbb403a6217f1$var$$d80214ad185890e6$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $e0cdf5f32a5f8f73$var$$a69ec9145c53dc41$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M56.31 16.83c-6.23 0-11.49 5.417-11.49 12.37s5.26 12.37 11.49 12.37c6.228 0 11.49-5.418 11.49-12.37 0-6.953-5.262-12.37-11.49-12.37M40.82 29.2c0-8.92 6.817-16.37 15.49-16.37 8.671 0 15.49 7.45 15.49 16.37S64.98 45.57 56.31 45.57c-8.673 0-15.49-7.45-15.49-16.37m-2.423-12.253c1.092-.162 1.847-1.18 1.685-2.272-.162-1.093-1.18-1.847-2.272-1.685-7.62 1.13-13.32 8.042-13.32 16.21 0 8.196 5.739 15.128 13.4 16.222 1.093.156 2.106-.604 2.262-1.698s-.604-2.106-1.698-2.262c-5.53-.79-9.964-5.892-9.964-12.262 0-6.348 4.404-11.437 9.907-12.253m-5.476 36.69c1.06-.312 1.665-1.424 1.352-2.484-.312-1.059-1.424-1.664-2.484-1.352-10.313 3.043-18.353 11.602-20.635 22.21-.894 4.158 2.215 8.157 6.536 8.157h3.228c1.105 0 2-.895 2-2s-.895-2-2-2H17.69c-1.708 0-2.998-1.584-2.626-3.315C17.037 63.69 24 56.27 32.922 53.638m-1.613 19.216c2.476-11.51 12.813-20.245 25-20.245 12.188 0 22.526 8.736 25.002 20.245l1.955-.42-1.955.42c.372 1.73-.917 3.315-2.626 3.315H33.933c-1.708 0-2.998-1.584-2.625-3.315m25-24.245c-14.123 0-26.05 10.103-28.91 23.403-.895 4.158 2.214 8.157 6.535 8.157h44.752c4.32 0 7.43-3.999 6.535-8.157-2.86-13.3-14.787-23.403-28.911-23.403"
        })
    });
const $e0cdf5f32a5f8f73$var$$a69ec9145c53dc41$var$ForwardRef = (0, $eF4cA.forwardRef)($e0cdf5f32a5f8f73$var$$a69ec9145c53dc41$var$SvgComponent);
var $e0cdf5f32a5f8f73$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($e0cdf5f32a5f8f73$var$$a69ec9145c53dc41$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ea9cafcdd6b291e8$var$$bd1fbb23a7964d55$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M28.235 8c-3.019 0-5.598 2.63-5.598 6.045s2.58 6.044 5.598 6.044 5.598-2.63 5.598-6.044S31.253 8 28.235 8m-8.098 6.045c0-4.644 3.552-8.545 8.098-8.545 4.545 0 8.098 3.901 8.098 8.545 0 4.643-3.553 8.544-8.098 8.544s-8.098-3.9-8.098-8.544m-.96-5.988c.683-.102 1.155-.737 1.053-1.42-.1-.683-.737-1.155-1.42-1.053-3.992.592-6.961 4.208-6.961 8.46 0 4.268 2.99 7.895 7.003 8.468.683.097 1.317-.378 1.414-1.061.098-.684-.377-1.317-1.06-1.414-2.683-.383-4.857-2.866-4.857-5.992 0-3.116 2.159-5.593 4.828-5.988M16.43 26.675c.662-.195 1.04-.89.845-1.552s-.89-1.04-1.552-.846c-5.317 1.57-9.462 5.981-10.639 11.451-.484 2.253 1.2 4.425 3.548 4.425h1.639c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25H8.63c-.713 0-1.26-.663-1.102-1.399.982-4.567 4.454-8.266 8.901-9.579m-.656 9.579c1.234-5.737 6.389-10.092 12.462-10.092s11.228 4.355 12.462 10.092c.158.736-.39 1.399-1.104 1.399H16.876c-.713 0-1.26-.663-1.102-1.399m12.462-12.592c-7.284 0-13.431 5.209-14.906 12.066-.485 2.253 1.2 4.425 3.547 4.425h22.718c2.347 0 4.032-2.172 3.547-4.425-1.475-6.857-7.623-12.066-14.906-12.066"
        })
    });
const $ea9cafcdd6b291e8$var$$bd1fbb23a7964d55$var$ForwardRef = (0, $eF4cA.forwardRef)($ea9cafcdd6b291e8$var$$bd1fbb23a7964d55$var$SvgComponent);
var $ea9cafcdd6b291e8$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($ea9cafcdd6b291e8$var$$bd1fbb23a7964d55$var$ForwardRef);



var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b90b18fbfa9dd6b6$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $282fbb403a6217f1$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $ea9cafcdd6b291e8$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $e0cdf5f32a5f8f73$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}




var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $43f222d4b678cb51$var$$17b4cc971dcd782b$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M135.133 32.356c1.371 1.733 1.078 4.249-.655 5.62L94.274 69.78c-1.238.98-2.936 1.139-4.334.408L64.63 56.963 30.59 85.835c-1.685 1.43-4.21 1.222-5.639-.463-1.428-1.684-1.221-4.209.464-5.638L61.509 49.12c1.241-1.053 2.997-1.249 4.44-.495l25.396 13.272 38.17-30.196c1.732-1.37 4.248-1.077 5.618.655M114.041 72.51c0-6.007 4.87-10.877 10.877-10.877s10.877 4.87 10.877 10.877v45.777c0 6.007-4.87 10.877-10.877 10.877s-10.877-4.87-10.877-10.877zm10.877-2.877c-1.589 0-2.877 1.288-2.877 2.877v45.777c0 1.589 1.288 2.877 2.877 2.877s2.877-1.288 2.877-2.877V72.51c0-1.589-1.288-2.877-2.877-2.877M54.156 87.516c0-6.007 4.87-10.877 10.877-10.877s10.877 4.87 10.877 10.877v30.771c0 6.007-4.87 10.877-10.877 10.877s-10.877-4.87-10.877-10.877zm10.877-2.877c-1.589 0-2.877 1.288-2.877 2.877v30.771c0 1.589 1.288 2.877 2.877 2.877 1.59 0 2.877-1.288 2.877-2.877V87.516c0-1.59-1.288-2.877-2.877-2.877m29.943-2.04c-6.007 0-10.877 4.87-10.877 10.878v24.81c0 6.007 4.87 10.877 10.877 10.877s10.877-4.87 10.877-10.877v-24.81c0-6.008-4.87-10.877-10.877-10.877m-2.877 10.878c0-1.59 1.288-2.877 2.877-2.877s2.877 1.288 2.877 2.877v24.81c0 1.589-1.288 2.877-2.877 2.877-1.59 0-2.877-1.288-2.877-2.877zm-57.008.914c-6.007 0-10.877 4.87-10.877 10.877v13.019c0 6.007 4.87 10.877 10.877 10.877s10.877-4.87 10.877-10.877v-13.019c0-6.007-4.87-10.877-10.877-10.877m-2.877 10.877c0-1.589 1.288-2.877 2.877-2.877s2.877 1.288 2.877 2.877v13.019c0 1.589-1.288 2.877-2.877 2.877s-2.877-1.288-2.877-2.877z"
        })
    });
const $43f222d4b678cb51$var$$17b4cc971dcd782b$var$ForwardRef = (0, $eF4cA.forwardRef)($43f222d4b678cb51$var$$17b4cc971dcd782b$var$SvgComponent);
var $43f222d4b678cb51$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($43f222d4b678cb51$var$$17b4cc971dcd782b$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $84ddfb15bf809dab$var$$77360214bd432b16$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 97,
        viewBox: "0 0 96 97",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M79.44 21.306c.686.866.539 2.124-.328 2.81L56.016 42.387c-.619.49-1.468.57-2.167.204l-14.718-7.69-19.708 16.716c-.843.714-2.105.61-2.82-.232s-.61-2.104.232-2.819L37.571 30.98c.62-.527 1.498-.624 2.22-.247l14.76 7.713 22.08-17.467c.866-.685 2.124-.538 2.81.328M33.76 52.35c0-3.032 2.457-5.49 5.49-5.49 3.032 0 5.49 2.458 5.49 5.49v18.597c0 3.032-2.459 5.49-5.49 5.49-3.033 0-5.49-2.458-5.49-5.49zm5.49-1.49c-.824 0-1.49.667-1.49 1.49v18.597c0 .822.666 1.49 1.49 1.49.822 0 1.49-.668 1.49-1.49V52.35c0-.823-.668-1.49-1.49-1.49m17.508-.577c-3.032 0-5.49 2.458-5.49 5.49V70.95c0 3.032 2.458 5.49 5.49 5.49s5.49-2.458 5.49-5.49V55.773c0-3.032-2.458-5.49-5.49-5.49m-1.49 5.49c0-.823.667-1.49 1.49-1.49s1.49.667 1.49 1.49V70.95c0 .823-.667 1.49-1.49 1.49s-1.49-.667-1.49-1.49zm13.508-12.045c0-3.032 2.458-5.49 5.49-5.49s5.49 2.458 5.49 5.49v27.22c0 3.032-2.458 5.49-5.49 5.49s-5.49-2.458-5.49-5.49zm5.49-1.49c-.823 0-1.49.668-1.49 1.49v27.22c0 .823.667 1.49 1.49 1.49s1.49-.667 1.49-1.49v-27.22c0-.822-.667-1.49-1.49-1.49M21.741 57.057c-3.032 0-5.49 2.458-5.49 5.49v8.4c0 3.032 2.457 5.49 5.49 5.49 3.032 0 5.49-2.458 5.49-5.49v-8.4c0-3.032-2.458-5.49-5.49-5.49m-1.49 5.49c0-.823.667-1.49 1.49-1.49s1.49.667 1.49 1.49v8.4c0 .823-.667 1.49-1.49 1.49s-1.49-.667-1.49-1.49z"
        })
    });
const $84ddfb15bf809dab$var$$77360214bd432b16$var$ForwardRef = (0, $eF4cA.forwardRef)($84ddfb15bf809dab$var$$77360214bd432b16$var$SvgComponent);
var $84ddfb15bf809dab$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($84ddfb15bf809dab$var$$77360214bd432b16$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $7aab962e2a56647d$var$$f6fc0abe9f11f40d$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M39.916 10.252c.428.541.337 1.327-.205 1.756l-11.548 9.136c-.387.306-.917.356-1.354.127l-7.21-3.768-9.726 8.25c-.526.447-1.315.382-1.762-.145-.446-.526-.382-1.315.145-1.762l10.368-8.793c.388-.33.936-.39 1.387-.155l7.237 3.782 10.912-8.633c.542-.428 1.328-.337 1.756.205M16.48 26.184c0-1.795 1.455-3.25 3.25-3.25s3.25 1.455 3.25 3.25v8.788c0 1.795-1.456 3.25-3.25 3.25s-3.25-1.455-3.25-3.25zm3.25-.75c-.415 0-.75.335-.75.75v8.788c0 .414.335.75.75.75.414 0 .75-.336.75-.75v-8.788c0-.415-.336-.75-.75-.75m8.603-.79c-1.795 0-3.25 1.456-3.25 3.25v7.078c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25v-7.077c0-1.795-1.455-3.25-3.25-3.25m-.75 3.25c0-.414.336-.75.75-.75s.75.336.75.75v7.078c0 .414-.336.75-.75.75s-.75-.336-.75-.75zm6.104-6.02c0-1.796 1.455-3.25 3.25-3.25s3.25 1.454 3.25 3.25v13.099c0 1.795-1.456 3.25-3.25 3.25s-3.25-1.455-3.25-3.25zm3.25-.75c-.415 0-.75.335-.75.75v13.099c0 .414.335.75.75.75.414 0 .75-.336.75-.75v-13.1c0-.414-.336-.75-.75-.75m-25.811 6.91c-1.795 0-3.25 1.454-3.25 3.25v3.69c0 1.794 1.455 3.25 3.25 3.25s3.25-1.456 3.25-3.25v-3.69c0-1.796-1.455-3.25-3.25-3.25m-.75 3.25c0-.415.336-.75.75-.75s.75.335.75.75v3.69c0 .414-.336.75-.75.75s-.75-.336-.75-.75z"
        })
    });
const $7aab962e2a56647d$var$$f6fc0abe9f11f40d$var$ForwardRef = (0, $eF4cA.forwardRef)($7aab962e2a56647d$var$$f6fc0abe9f11f40d$var$SvgComponent);
var $7aab962e2a56647d$export$2e2bcd8739ae039 = (0, $dm5H1.createIllustration)($7aab962e2a56647d$var$$f6fc0abe9f11f40d$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fc15935221eead18$export$2e2bcd8739ae039(props) {
    [props] = (0, $fDYaM.useContextProps)(props, null, (0, $dm5H1.IllustrationContext));
    let { size: size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return (0, $dx4lB.jsx)((0, $43f222d4b678cb51$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'S':
            return (0, $dx4lB.jsx)((0, $7aab962e2a56647d$export$2e2bcd8739ae039), {
                ...otherProps
            });
        case 'M':
            return (0, $dx4lB.jsx)((0, $84ddfb15bf809dab$export$2e2bcd8739ae039), {
                ...otherProps
            });
    }
}


const $46bd48a5027fc8f9$var$features = [
    {
        name: "Users",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $b90b18fbfa9dd6b6$export$2e2bcd8739ae039), {}),
        path: "./users"
    },
    {
        name: "Projects",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $87458d3f73b0e664$export$2e2bcd8739ae039), {}),
        path: "./projects"
    },
    {
        name: "Zoltar Prompts",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $90d7955cd72decdd$export$2e2bcd8739ae039), {}),
        path: "./prompts"
    },
    {
        name: "Dynamic Graphics Render",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9c26f322cb0cf44c$export$2e2bcd8739ae039), {}),
        path: "./mogrt"
    },
    {
        name: "Text-to-speech",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $582f5bb145477570$export$2e2bcd8739ae039), {}),
        path: "./text-to-speech"
    },
    {
        name: "Image Crop",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e5762da11b7e03f0$export$2e2bcd8739ae039), {}),
        path: "./image-crop"
    },
    {
        name: "FluffyJaws",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $90d7955cd72decdd$export$2e2bcd8739ae039), {}),
        path: "./fluffyjaws"
    },
    {
        name: "Footage",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e11935d3675e886a$export$2e2bcd8739ae039), {}),
        path: "./footage"
    },
    {
        name: "API Status",
        icon: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fc15935221eead18$export$2e2bcd8739ae039), {}),
        path: "./integrations"
    }
];
const $46bd48a5027fc8f9$export$7043b2aa75252c56 = ({})=>{
    const navigate = (0, $dqZbZ.useNavigate)();
    const isMobile = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.isMobile);
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        }
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: "Admin tools | BeStory"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $b0a461d8d3a700b8$export$da87cf13fc2ef3d8), {
                "aria-label": "Admin tools",
                onSelectionChange: ([key])=>navigate(key),
                orientation: isMobile ? "horizontal" : "vertical",
                children: $46bd48a5027fc8f9$var$features.map((feature)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $b0a461d8d3a700b8$export$ebde6d4e7862fe9d), {
                        id: feature.path,
                        children: [
                            feature.icon,
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                slot: "label",
                                children: feature.name
                            })
                        ]
                    }, feature.path))
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $7Vvqh = parcelRequire("7Vvqh");
var $j3pTw = parcelRequire("j3pTw");
var $208Op = parcelRequire("208Op");
var $8wD3p = parcelRequire("8wD3p");
var $fZShI = parcelRequire("fZShI");
var $j8RRT = parcelRequire("j8RRT");

var $HZG6L = parcelRequire("HZG6L");


var $D7J7L = parcelRequire("D7J7L");

var $fmJ8d = parcelRequire("fmJ8d");

var $5IZkx = parcelRequire("5IZkx");

var $iLDMH = parcelRequire("iLDMH");

var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");

var $iMKxE = parcelRequire("iMKxE");


var $a8sj2 = parcelRequire("a8sj2");

var $8oFcj = parcelRequire("8oFcj");

const $e939fd3c2dbc7623$var$MOGRT_ROOT_DIR = "mogrt/templates/";
const $e939fd3c2dbc7623$var$ACCEPTED_MEDIA_TYPES = [
    "image/jpeg",
    "image/png",
    "image/svg+xml"
];
function $e939fd3c2dbc7623$var$getMogrtJobResultVideoUrl(job) {
    const outputs = job?.result?.outputs;
    if (!Array.isArray(outputs)) return null;
    for (const o of outputs){
        const url = o?.destination?.url;
        if (typeof url === "string" && url.length > 0) return url;
    }
    return null;
}
const $e939fd3c2dbc7623$export$476f585032a02a7 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Dynamic Graphics Render"
        }
    ]);
    const [folders, setFolders] = (0, $eF4cA.useState)([]);
    const [foldersStatus, setFoldersStatus] = (0, $eF4cA.useState)("idle");
    const [foldersError, setFoldersError] = (0, $eF4cA.useState)("");
    const [selectedFolder, setSelectedFolder] = (0, $eF4cA.useState)(null);
    const [formValues, setFormValues] = (0, $eF4cA.useState)({});
    const [uploadingMedia, setUploadingMedia] = (0, $eF4cA.useState)({});
    const [currentStep, setCurrentStep] = (0, $eF4cA.useState)(0);
    const [customerName, setCustomerName] = (0, $eF4cA.useState)("");
    const [campaignHint, setCampaignHint] = (0, $eF4cA.useState)("");
    const [myMogrtJobs, setMyMogrtJobs] = (0, $eF4cA.useState)([]);
    const [myMogrtJobsStatus, setMyMogrtJobsStatus] = (0, $eF4cA.useState)("idle");
    const [myMogrtJobsError, setMyMogrtJobsError] = (0, $eF4cA.useState)("");
    const email = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.ims?.profile?.email);
    const mogrtRootPath = selectedFolder ? `${$e939fd3c2dbc7623$var$MOGRT_ROOT_DIR}${selectedFolder}` : null;
    const describeMogrtTemplate = (0, $iMKxE.useDescribeMogrtTemplate)(mogrtRootPath, {
        enabled: !!mogrtRootPath
    });
    const renderMogrtTemplate = (0, $iMKxE.useRenderMogrtTemplate)({
        jobSuccessStatuses: [
            "completed",
            "generated"
        ]
    });
    const uploadFile = (0, $a8sj2.useUploadFile)();
    const { data: voices } = (0, $4230475195755126$export$cacb176cdf71daba)();
    const generateAudio = (0, $4230475195755126$export$b9a3f411e7ca1c72)();
    const hasAudioStep = selectedFolder === "AO";
    const renderStepIndex = hasAudioStep ? 4 : 3;
    (0, $eF4cA.useEffect)(()=>{
        const fetchFolders = async ()=>{
            try {
                setFoldersStatus("loading");
                setFoldersError("");
                const response = await (0, $D7J7L.listFoldersInDirectory)($e939fd3c2dbc7623$var$MOGRT_ROOT_DIR);
                const nextFolders = (response?.folders ?? []).sort((a, b)=>a.localeCompare(b));
                setFolders(nextFolders);
                setFoldersStatus("success");
            } catch (error) {
                setFoldersStatus("error");
                setFoldersError(error?.message || "Failed to load folders");
            }
        };
        fetchFolders();
    }, []);
    const fetchMyMogrtJobs = (0, $eF4cA.useCallback)(async ()=>{
        if (!email) {
            setMyMogrtJobs([]);
            setMyMogrtJobsStatus("idle");
            setMyMogrtJobsError("");
            return;
        }
        setMyMogrtJobsStatus("loading");
        setMyMogrtJobsError("");
        try {
            const data = await (0, $8oFcj.listJobs)({
                limit: 10
            });
            setMyMogrtJobs(Array.isArray(data?.jobs) ? data.jobs : []);
            setMyMogrtJobsStatus("success");
        } catch (err) {
            setMyMogrtJobsError(err?.message || "Failed to load mogrt jobs");
            setMyMogrtJobsStatus("error");
        }
    }, [
        email
    ]);
    (0, $eF4cA.useEffect)(()=>{
        fetchMyMogrtJobs();
    }, [
        fetchMyMogrtJobs
    ]);
    // Initialise formValues from describe data, keyed by variableId
    (0, $eF4cA.useEffect)(()=>{
        if (!describeMogrtTemplate.isSuccess || !describeMogrtTemplate.data) return;
        const { controls: controls, mediaFiles: mediaFiles } = describeMogrtTemplate.data;
        const getMediaSourceForLabel = (label)=>{
            if (!label) return null;
            const found = mediaFiles.find((filePath)=>{
                const fileName = filePath.split("/").pop() || "";
                return fileName === label || fileName.split(".")[0] === label;
            });
            return found ? {
                path: found
            } : null;
        };
        const initialFormValues = controls.reduce((acc, control)=>{
            if (control?.type === "text") acc[control.variableId] = control?.defaultData?.text ?? "";
            else if (control?.type === "media") acc[control.variableId] = getMediaSourceForLabel(control?.label) ?? null;
            else if (control?.type === "dropdown") acc[control.variableId] = control?.defaultData?.selectedDropdownValue ?? "";
            else if (control?.type === "slider") {
                const range = control?.range ?? {};
                acc[control.variableId] = control?.defaultData?.selectedSliderValue ?? range?.minimum ?? 0;
            }
            return acc;
        }, {});
        setFormValues(initialFormValues);
    }, [
        describeMogrtTemplate.isSuccess,
        describeMogrtTemplate.data
    ]);
    const folderOptions = (0, $eF4cA.useMemo)(()=>folders.map((folder)=>({
                id: folder,
                label: folder
            })), [
        folders
    ]);
    const handleFolderChange = (0, $eF4cA.useCallback)((value)=>{
        setSelectedFolder(value);
        setFormValues({});
        setUploadingMedia({});
        setCurrentStep(0);
        uploadFile.reset();
    }, [
        uploadFile
    ]);
    const handleRender = (0, $eF4cA.useCallback)(()=>{
        if (!describeMogrtTemplate.data) return;
        const emailPrefix = email?.split("@")?.[0];
        uploadFile.reset();
        renderMogrtTemplate.mutate({
            ...describeMogrtTemplate.data,
            formValues: formValues
        }, {
            onSuccess: (outputUrl)=>{
                fetchMyMogrtJobs();
                if (!emailPrefix || !selectedFolder) return;
                const filePath = `${emailPrefix}/mogrt/${selectedFolder}/${selectedFolder}.mp4`;
                uploadFile.mutate({
                    filePath: filePath,
                    fileURL: outputUrl
                });
            }
        });
    }, [
        describeMogrtTemplate.data,
        formValues,
        renderMogrtTemplate,
        uploadFile,
        email,
        selectedFolder,
        fetchMyMogrtJobs
    ]);
    const handleSelectMedia = (0, $eF4cA.useCallback)((controlId, filePath)=>{
        setFormValues((prev)=>({
                ...prev,
                [controlId]: {
                    path: filePath
                }
            }));
    }, []);
    const handleUploadMedia = (0, $eF4cA.useCallback)(async (controlId, files)=>{
        if (!files?.length) return;
        const [file] = files;
        const emailPrefix = email?.split("@")?.[0];
        if (!emailPrefix) return;
        try {
            setUploadingMedia((prev)=>({
                    ...prev,
                    [controlId]: true
                }));
            const filePath = `${emailPrefix}/mogrt/${selectedFolder}/media/${file.name}`;
            await (0, $D7J7L.uploadFileByBlob)(filePath, file);
            setFormValues((prev)=>({
                    ...prev,
                    [controlId]: {
                        path: filePath
                    }
                }));
        } catch  {
        // upload errors surface via the UI
        } finally{
            setUploadingMedia((prev)=>({
                    ...prev,
                    [controlId]: false
                }));
        }
    }, [
        email,
        selectedFolder
    ]);
    const zoltar = (0, $4SSyx.useZoltarMutation)();
    const zoltarData = (0, $eF4cA.useMemo)(()=>{
        try {
            if (!(0, $aKSBi.isZoltarGenerateOk)(zoltar.data)) return {};
            return (0, $aKSBi.parseZoltarGenerateJson)(zoltar.data, "{}");
        } catch  {
            return {};
        }
    }, [
        zoltar.data
    ]);
    const handleCampaignGeneration = (0, $eF4cA.useCallback)(()=>{
        const promptTemplate = [
            {
                role: "user",
                prompt_template: `Customer name: ${customerName}${!!campaignHint ? `\n\[Hints]:\n${campaignHint}` : ""}`
            },
            {
                role: "user",
                prompt_template: "Return only valid JSON response."
            }
        ];
        zoltar.mutate({
            promptTemplate: promptTemplate,
            systemPromptId: "UCX-texts"
        });
    }, [
        customerName,
        campaignHint,
        zoltar.mutate
    ]);
    const handleVoiceOverGeneration = (0, $eF4cA.useCallback)(async ({ text: text, voiceId: voiceId, voiceConfig: voiceConfig })=>{
        const uploadResult = await generateAudio.mutateAsync({
            text: text,
            voiceId: voiceId,
            voiceConfig: voiceConfig,
            email: email,
            selectedFolder: selectedFolder
        });
        const audioControl = describeMogrtTemplate.data?.controls?.find((c)=>c?.type === "audio");
        if (audioControl) setFormValues((prev)=>({
                ...prev,
                [audioControl.variableId]: {
                    url: uploadResult.presignURL
                }
            }));
    }, [
        generateAudio.mutateAsync,
        email,
        selectedFolder,
        describeMogrtTemplate.data?.controls
    ]);
    (0, $eF4cA.useEffect)(()=>{
        if (!Object.keys(zoltarData).length) return;
        const data = {
            ...zoltarData,
            "Company-name": customerName
        };
        const controls = describeMogrtTemplate.data?.controls ?? [];
        for (const [key, value] of Object.entries(data)){
            const control = controls.find((ctrl)=>ctrl.label === key);
            if (control) setFormValues((prev)=>({
                    ...prev,
                    [control.variableId]: value
                }));
        }
    }, [
        zoltarData,
        customerName,
        describeMogrtTemplate.data?.controls
    ]);
    const controls = describeMogrtTemplate.data?.controls ?? [];
    const mediaFiles = describeMogrtTemplate.data?.mediaFiles ?? [];
    const describeStatus = describeMogrtTemplate.isLoading ? "loading" : describeMogrtTemplate.isError ? "error" : describeMogrtTemplate.isSuccess ? "success" : "idle";
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " se182 CykSns182 Epsv7fe182 Uj182 qj182 Za182 Fb182 Sh182 Rh182 Te182 Qe182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4836215752023500$export$668709c620d0b8e2), {
                selectedKey: currentStep,
                onSelectionChange: setCurrentStep,
                disabledKeys: [
                    1,
                    2,
                    ...hasAudioStep ? [
                        3,
                        4
                    ] : [
                        3
                    ]
                ].filter((step)=>!selectedFolder || describeStatus !== "success"),
                styles: " IM182 HM182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                        id: 0,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "\u2460"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Select folder"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                        id: 1,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "\u2461"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Project details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                        id: 2,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "\u2461"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Controls"
                                })
                            ]
                        })
                    }),
                    hasAudioStep && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                        id: 3,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "\u2462"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Audio"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                        id: renderStepIndex,
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                            styles: " sh182 Ue182 qe182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: hasAudioStep ? "\u2463" : "\u2462"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                    children: "Render"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 Ue182 qe182 Za182 Ll182 IM182 HM182",
                children: [
                    currentStep === 0 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "Select template to inspect and render controls."
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 Ug182 qg182 Lb4QY4182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                        label: "Mogrt folders",
                                        value: selectedFolder,
                                        onChange: handleFolderChange,
                                        isDisabled: foldersStatus === "loading",
                                        children: folderOptions.map((folder)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                id: folder.id,
                                                children: folder.label
                                            }, folder.id))
                                    }),
                                    foldersStatus === "loading" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 eb182 Ue182 qe182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                "aria-label": "Loading folders",
                                                size: "S"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Loading folders\u2026"
                                            })
                                        ]
                                    }),
                                    foldersStatus === "error" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: foldersError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "Your mogrt jobs"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182",
                                children: "Jobs you started from this app (newest first). Links use the Mogrt output URL when available."
                            }),
                            myMogrtJobsStatus === "loading" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ue182 qe182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                        "aria-label": "Loading jobs",
                                        size: "S"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Loading jobs\u2026"
                                    })
                                ]
                            }),
                            myMogrtJobsStatus === "error" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: myMogrtJobsError
                            }),
                            myMogrtJobsStatus === "success" && myMogrtJobs.length === 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "No mogrt jobs yet."
                            }),
                            myMogrtJobsStatus === "success" && myMogrtJobs.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)("ul", {
                                className: " Td182 Qd182 Sd182 Rd182 Jy182 Gy182 Iy182 Hy182 sd182 _ta182 Ue182 qe182",
                                children: myMogrtJobs.map((job)=>{
                                    const resultUrl = $e939fd3c2dbc7623$var$getMogrtJobResultVideoUrl(job);
                                    return /*#__PURE__*/ (0, $dx4lB.jsxs)("li", {
                                        className: " sd182 _wb182 eb182 Ug182 qg182 Te182 Qe182 Se182 Re182 gH182 ob182 nb182 kb182 jb182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _ub182 Na182 __Za182",
                                                title: job.jobId,
                                                children: job.jobId
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                                children: job.status ?? "\u2014"
                                            }),
                                            resultUrl ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                                                href: resultUrl,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                variant: "secondary",
                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    children: "Open result"
                                                })
                                            }) : null
                                        ]
                                    }, job.jobId);
                                })
                            })
                        ]
                    }),
                    currentStep === 1 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-lcY1Ce182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                        children: "Build your campaign story"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                        children: [
                                            "Give us context about your company, audience and goal.",
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                            "We'll generate the entire journey - personas, offers, channels and next actions."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                styles: " LhR8Hv182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                        children: "Customer information"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                        label: "Brand name",
                                        description: "Use the real client or brand name, not an internal project title.",
                                        placeholder: "SecurFinancial",
                                        isRequired: true,
                                        value: customerName,
                                        onChange: setCustomerName
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                        label: "Hint",
                                        necessityIndicator: "label",
                                        description: "Share any context that might shape the message \u2014 audience, market, tone, or situation.",
                                        placeholder: "B2B software; APAC; procurement manager; sustainability angle; trade shows; 45-year-old father in Singapore.",
                                        value: campaignHint,
                                        onChange: setCampaignHint
                                    })
                                ]
                            })
                        ]
                    }),
                    currentStep === 2 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            zoltar.isPending && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $41e172257332f72e$export$c17561cb55d4db30), {
                                label: "Generating campaign story",
                                isIndeterminate: true
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "Update controls and media files."
                            }),
                            describeStatus === "loading" && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ue182 qe182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                        "aria-label": "Loading controls",
                                        size: "S"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Loading controls\u2026"
                                    })
                                ]
                            }),
                            describeStatus === "error" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: describeMogrtTemplate.error?.message
                            }),
                            describeStatus === "success" && controls.length === 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: "No controls found."
                            }),
                            controls.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $j3pTw.Form), {
                                labelPosition: "top",
                                labelAlign: "start",
                                styles: " Za182",
                                children: [
                                    controls.filter((control)=>control?.type === "text").map((control)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                            label: control.label,
                                            value: formValues[control.variableId] ?? "",
                                            onChange: (nextValue)=>setFormValues((prev)=>({
                                                        ...prev,
                                                        [control.variableId]: nextValue
                                                    }))
                                        }, control.variableId)),
                                    controls.filter((control)=>control?.type === "dropdown").map((control)=>{
                                        const options = control?.options ?? {};
                                        const optionItems = Object.entries(options).map(([id, label])=>({
                                                id: id,
                                                label: label
                                            }));
                                        return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                            label: control.label,
                                            selectedKey: formValues[control.variableId] ?? "",
                                            onSelectionChange: (key)=>setFormValues((prev)=>({
                                                        ...prev,
                                                        [control.variableId]: key
                                                    })),
                                            children: optionItems.map((item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                    id: item.id,
                                                    children: item.label
                                                }, item.id))
                                        }, control.variableId);
                                    }),
                                    controls.filter((control)=>control?.type === "slider").map((control)=>{
                                        const range = control?.range ?? {};
                                        const min = range?.minimum ?? 0;
                                        const max = range?.maximum ?? 100;
                                        return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $6341cc1a524cee31$export$472062a354075cee), {
                                            label: control.label,
                                            value: formValues[control.variableId] ?? min,
                                            onChange: (value)=>setFormValues((prev)=>({
                                                        ...prev,
                                                        [control.variableId]: value
                                                    })),
                                            minValue: min,
                                            maxValue: max
                                        }, control.variableId);
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " se182 DZGmAlc182 Ug182 qg182 ed182 _Cg182 Za182",
                                        children: controls.filter((control)=>control?.type === "media").map((control)=>{
                                            const selectedMediaPath = formValues[control.variableId]?.path ?? "";
                                            const isUploadingMedia = uploadingMedia[control.variableId];
                                            return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 _ta182 Ue182 qe182 Na182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: control.label
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                        className: " sd182 eb182 Ug182 qg182 _wb182",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                className: " ZcTxjid182 Fozpine182 ob182 nb182 kb182 jb182 _Nc182 Pc182 gH182",
                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iLDMH.S3Image), {
                                                                    filePath: selectedMediaPath,
                                                                    alt: control.label,
                                                                    isLoading: describeStatus === "loading" || isUploadingMedia,
                                                                    styles: function anonymous(props) {
                                                                        let rules = " ";
                                                                        rules += ' Za182';
                                                                        rules += ' Fb182';
                                                                        rules += ' _Ha182';
                                                                        if (props.isLoading) rules += ' _IpmMfn182';
                                                                        else rules += ' _Ib182';
                                                                        return rules;
                                                                    }({
                                                                        isLoading: describeStatus === "loading" || isUploadingMedia
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                                "aria-label": "Select media from S3",
                                                                                isDisabled: describeStatus === "loading" || mediaFiles.length === 0,
                                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2487b8aecf1c0f59$export$2e2bcd8739ae039), {})
                                                                            }),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                                                                                "aria-label": "Select media file",
                                                                                onAction: (filePath)=>handleSelectMedia(control.variableId, filePath),
                                                                                children: mediaFiles.map((filePath)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                                                                        id: filePath,
                                                                                        children: filePath.split("/").pop()
                                                                                    }, filePath))
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7Vvqh.FileTrigger), {
                                                                        acceptedFileTypes: $e939fd3c2dbc7623$var$ACCEPTED_MEDIA_TYPES,
                                                                        onSelect: (files)=>handleUploadMedia(control.variableId, files),
                                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                            "aria-label": "Upload media from computer",
                                                                            isDisabled: isUploadingMedia,
                                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $HZG6L.default), {})
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, control.variableId);
                                        })
                                    }),
                                    describeStatus === "success" && mediaFiles.length === 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "No media files found."
                                    })
                                ]
                            })
                        ]
                    }),
                    hasAudioStep && currentStep === 3 && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 _ta182 Ul182 ql182 LhaAsze182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "Audio"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fd1b321f28e3a258$export$ca7dc72f8299f9d5), {
                                audioUrl: generateAudio.data?.presignURL,
                                defaultText: `Please help me plan the ${formValues["0_10_text"]} campaign. Use last year\u{2019}s campaign performance as the baseline. I\u{2019}d like to target ${formValues["0_11_text"]}. Make sure the audience is at least ${formValues["0_12_slider"]} people. I\u{2019}d like to test two new message variants for this campaign geared towards ${formValues["0_13_text"]}. Summarize results for me after a month and suggest improvements.`,
                                voiceId: "v123",
                                voices: voices ?? [],
                                onGenerate: handleVoiceOverGeneration,
                                isPending: generateAudio.isPending,
                                onVoiceSelect: ()=>{}
                            })
                        ]
                    }),
                    currentStep === renderStepIndex && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                        children: [
                            renderMogrtTemplate.isPending && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $41e172257332f72e$export$c17561cb55d4db30), {
                                label: "Rendering video",
                                isIndeterminate: !renderMogrtTemplate.progress,
                                value: renderMogrtTemplate.progress
                            }),
                            uploadFile.isPending && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $41e172257332f72e$export$c17561cb55d4db30), {
                                label: "Uploading to S3",
                                isIndeterminate: true
                            }),
                            renderMogrtTemplate.isError && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ug182 qg182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: renderMogrtTemplate.error?.message
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                            variant: "secondary",
                                            onPress: handleRender,
                                            isDisabled: describeStatus !== "success",
                                            children: "Retry"
                                        })
                                    })
                                ]
                            }),
                            uploadFile.isError && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ug182 qg182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: uploadFile.error?.message
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                            variant: "secondary",
                                            onPress: ()=>uploadFile.mutate({
                                                    filePath: `${email?.split("@")?.[0]}/mogrt/${selectedFolder}/${selectedFolder}.mp4`,
                                                    fileURL: renderMogrtTemplate.data
                                                }),
                                            children: "Retry upload"
                                        })
                                    })
                                ]
                            }),
                            (uploadFile.data?.presignURL || renderMogrtTemplate.data) && /*#__PURE__*/ (0, $dx4lB.jsx)("video", {
                                src: uploadFile.data?.presignURL ?? renderMogrtTemplate.data,
                                controls: true,
                                className: " Za182 Fb182 fcJcitc182 ob182 nb182 kb182 jb182 gF182"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " sd182 _Ca182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $lK44Y.ButtonGroup), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                    variant: "secondary",
                                    onPress: ()=>setCurrentStep((prev)=>Math.max(prev - 1, 0)),
                                    isDisabled: currentStep === 0,
                                    children: "Previous"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                    onPress: ()=>{
                                        if (currentStep === 1) handleCampaignGeneration();
                                        if (currentStep === 2 && !hasAudioStep) {
                                            handleRender();
                                            setCurrentStep(renderStepIndex);
                                            return;
                                        }
                                        if (currentStep === 3 && hasAudioStep) {
                                            handleRender();
                                            setCurrentStep(renderStepIndex);
                                            return;
                                        }
                                        setCurrentStep((prev)=>Math.min(prev + 1, renderStepIndex));
                                    },
                                    isDisabled: currentStep === 0 && !selectedFolder || currentStep === 1 && customerName.trim() === "" || currentStep === 2 && describeStatus !== "success" || currentStep === renderStepIndex,
                                    children: "Next"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $2RdeM = parcelRequire("2RdeM");
var $208Op = parcelRequire("208Op");
var $8g9SZ = parcelRequire("8g9SZ");
var $91SAk = parcelRequire("91SAk");
var $j8RRT = parcelRequire("j8RRT");

var $a8sj2 = parcelRequire("a8sj2");

var $dyJFE = parcelRequire("dyJFE");

var $984R8 = parcelRequire("984R8");

var $6lZyT = parcelRequire("6lZyT");

var $9lDhw = parcelRequire("9lDhw");

var $kekDO = parcelRequire("kekDO");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $0213f057d10aa9ce$var$$11d98b49a67a39ee$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.25 13.191c-.414 0-.75-.336-.75-.75V6.25c0-.413-.337-.75-.75-.75H7.513c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.237C14.99 4 16 5.01 16 6.25v6.191c0 .414-.336.75-.75.75"
            }),
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M18.602 14.5H6.25c-.413 0-.75-.337-.75-.75V1.398c0-.414-.336-.75-.75-.75S4 .984 4 1.398V4H1.398c-.414 0-.75.336-.75.75s.336.75.75.75H4v8.25C4 14.99 5.01 16 6.25 16h8.25v2.623c0 .414.336.75.75.75s.75-.336.75-.75V16h2.602c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
            })
        ]
    });
const $0213f057d10aa9ce$var$$11d98b49a67a39ee$var$ForwardRef = (0, $eF4cA.forwardRef)($0213f057d10aa9ce$var$$11d98b49a67a39ee$var$SvgComponent);
var $0213f057d10aa9ce$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($0213f057d10aa9ce$var$$11d98b49a67a39ee$var$ForwardRef);


const $99909ca2e3efdc55$var$TEST_FILE_PATH = "temp/image-crop/original";
const $99909ca2e3efdc55$var$sizes = [
    {
        label: "Square",
        width: 512,
        height: 512
    },
    {
        label: "Fullscreen",
        width: 1920,
        height: 1080
    },
    {
        label: "Fb post",
        width: 1200,
        height: 630
    },
    {
        label: "Ig post",
        width: 1080,
        height: 1350
    },
    {
        label: "Reel",
        width: 1080,
        height: 1920
    },
    {
        label: "Banner",
        width: 320,
        height: 1024
    },
    {
        label: "Wide",
        width: 1080,
        height: 240
    },
    {
        label: "Narrow",
        width: 240,
        height: 1080
    }
];
const $99909ca2e3efdc55$export$18c2f789cd09859b = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Image Crop"
        }
    ]);
    const [images, setImages] = (0, $eF4cA.useState)([]);
    const [objects, setObjects] = (0, $eF4cA.useState)((0, $984R8.DEFAULT_CROP_OBJECTS));
    const presignURL = (0, $a8sj2.usePresignURL)($99909ca2e3efdc55$var$TEST_FILE_PATH);
    const uploadFile = (0, $a8sj2.useUploadFile)();
    const cropImage = (0, $dyJFE.useCropImage)({
        onSuccess: async (data)=>{
            const imageBlob = await (0, $9lDhw.getImageBlob)({
                url: uploadFile.data?.presignURL ?? presignURL.data?.presignURL
            });
            for (const bbox of data.crops[0].bboxes){
                const croppedBlob = await (0, $6lZyT.cropImageBlobToBbox)(imageBlob.blob, {
                    bbox: bbox
                });
                setImages((prev)=>[
                        ...prev || [],
                        URL.createObjectURL(croppedBlob)
                    ]);
            }
        }
    });
    const getImageDragOperation = (0, $eF4cA.useCallback)(({ types: types })=>{
        if (Array.from(types)[0].startsWith("image/")) return "copy";
        return "cancel";
    }, []);
    const handleDrop = (0, $eF4cA.useCallback)(async (items, name)=>{
        const file = items[0] instanceof File ? items[0] : await items[0].getFile();
        if (file) {
            const { width: width, height: height } = await (0, $6lZyT.getImageBlobDimensions)(file);
            const imgFile = await (0, $6lZyT.convertImageBlobToType)(file, "jpeg");
            // setSize({ width: width / 2, height: height * 3 });
            uploadFile.mutate({
                fileBlob: imgFile,
                filePath: $99909ca2e3efdc55$var$TEST_FILE_PATH
            }, {
                onSuccess: (data, variables, onMutateResult, { client: client })=>{
                    client.setQueryData((0, $a8sj2.s3Key).presignURL($99909ca2e3efdc55$var$TEST_FILE_PATH), data);
                }
            });
        }
    }, [
        uploadFile.mutate
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Ul182 ql182 Za182 Fb182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                children: "Crop image"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 Up182 qp182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $kekDO.ImageAsset), {
                        name: "test",
                        label: "Test",
                        contextualHelp: null,
                        filePath: presignURL.data?.filePath,
                        src: presignURL.data?.presignURL,
                        isFilled: true,
                        isLoading: uploadFile.isPending,
                        onDrop: handleDrop,
                        getImageDragOperation: getImageDragOperation
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                            label: "Crop focus",
                            placeholder: (0, $984R8.DEFAULT_CROP_OBJECTS),
                            description: `Accepts arbitrary natural-language labels (e.g. "person", "car.shoe", "red sports car")`,
                            value: objects,
                            onChange: setObjects
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                isDisabled: !presignURL.data || cropImage.isPending,
                onPress: ()=>cropImage.mutate({
                        items: [
                            [
                                presignURL.data?.presignURL,
                                $99909ca2e3efdc55$var$sizes,
                                objects.trim()
                            ]
                        ]
                    }),
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0213f057d10aa9ce$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "Crop"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " se182 DRDc8Qd182 Ul182 ql182 JC182 eb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
                            variant: "quiet",
                            styles: " Za182 Fb182",
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                        src: presignURL.data?.presignURL,
                                        alt: `original image`,
                                        styles: " fa182 _Ha182"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        slot: "title",
                                        children: "Original image"
                                    })
                                })
                            ]
                        })
                    }),
                    $99909ca2e3efdc55$var$sizes.map((size, idx)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $91SAk.Skeleton), {
                            isLoading: cropImage.isPending,
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $2RdeM.Card), {
                                    variant: "quiet",
                                    styles: " Za182 Fb182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2RdeM.CardPreview), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8g9SZ.Image), {
                                                src: images[idx],
                                                alt: `cropped image ${size.width}x${size.height}`,
                                                styles: " fa182 _Ha182",
                                                UNSAFE_style: {
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                slot: "title",
                                                children: `${size.label} \u{2013} ${size.width} x ${size.height}`
                                            })
                                        })
                                    ]
                                })
                            })
                        }, `${size.width}x${size.height}`))
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $waxwa = parcelRequire("waxwa");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $yuTTo = parcelRequire("yuTTo");
var $fZShI = parcelRequire("fZShI");





const $e0ddec1a8a315d02$var$getGenderText = (gender)=>{
    switch(gender.toLowerCase()){
        case "f":
            return "Female";
        case "m":
            return "Male";
        case "nb":
            return "Non-binary";
        default:
            return "";
    }
};
const $e0ddec1a8a315d02$export$ca7dc72f8299f9d5 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Text-to-speech"
        }
    ]);
    const [selectedVoiceId, setSelectedVoiceId] = (0, $eF4cA.useState)(null);
    const [text, setText] = (0, $eF4cA.useState)("");
    const [favorites, setFavorites] = (0, $eF4cA.useState)(localStorage.getItem("BeStory__favoriteVoices")?.split(",") || []);
    (0, $eF4cA.useEffect)(()=>{
        if (!favorites.includes("v123_1")) {
            setFavorites((prev)=>[
                    ...prev,
                    "v123_1"
                ]);
            localStorage.setItem("BeStory__favoriteVoices", [
                ...favorites,
                "v123_1"
            ].join(","));
        }
    }, []);
    const { data: voices, isLoading: isLoading, isError: isError } = (0, $4230475195755126$export$cacb176cdf71daba)();
    const generateSpeech = (0, $4230475195755126$export$4dd5119b0a6060aa)();
    const fixPronunciation = (0, $4230475195755126$export$6f4d8fd3eda5e0ce)();
    const selectedVoice = (0, $eF4cA.useMemo)(()=>voices?.find((voice)=>voice.voiceId === selectedVoiceId), [
        selectedVoiceId,
        voices
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: "Text-to-speech | BeStory"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " se182 Uj182 qj182 Za182 FKPwxte182 Sh182 Rh182 _oa182 CxzpWPc182 DnR6NS182 EuxCDJd182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " zPCJngb182 yPCJngb182 BPCJngb182 APCJngb182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 GC182",
                        children: "Text-to-speech"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " zoSc8N182 yoSc8N182 BoSc8N182 AoSc8N182 sd182 _ta182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                label: "Voices",
                                value: ""
                            }),
                            isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                children: "Loading voices..."
                            }),
                            isError && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                children: "Failed to load voices."
                            }),
                            voices && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bf3d98caa3bea461$export$e91df7bd251a2ec7), {
                                voices: voices,
                                voiceId: selectedVoiceId,
                                onVoiceSelect: setSelectedVoiceId,
                                styles: " Fb182"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 _9b182",
                        children: [
                            !!selectedVoice && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 Uj182 qj182 LhaAsze182 IM182 HM182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        className: " sd182 Ue182 qe182 ea182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                                children: selectedVoice.displayName
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pv182",
                                                children: `${selectedVoice.ageGroup} \u{2022} ${$e0ddec1a8a315d02$var$getGenderText(selectedVoice.gender)} \u{2022} ${selectedVoice.ethnicity}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fd1b321f28e3a258$export$ca7dc72f8299f9d5), {
                                        audioUrl: generateSpeech.data,
                                        voiceId: selectedVoice.voiceId,
                                        voices: voices,
                                        text: text,
                                        onTextChange: setText,
                                        onGenerate: generateSpeech.mutate,
                                        isPending: generateSpeech.isPending,
                                        isDisabled: fixPronunciation.isPending,
                                        onVoiceSelect: setSelectedVoiceId,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $waxwa.ActionButtonGroup), {
                                            isQuiet: true,
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                isDisabled: !text.trim() || generateSpeech.isPending || fixPronunciation.isPending,
                                                onPress: ()=>fixPronunciation.mutate({
                                                        text: text
                                                    }),
                                                children: [
                                                    fixPronunciation.isPending ? /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                                        "aria-label": "Generating pronunciations",
                                                        size: "S",
                                                        staticColor: "auto",
                                                        slot: "icon",
                                                        isIndeterminate: true
                                                    }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $689e79a6adf3716c$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        children: "Fix pronunciation"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            !selectedVoice && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " sd182 eb182 _Ca182 Za182 Fb182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                    orientation: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $582f5bb145477570$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                            children: "Select a voice"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                            children: "Choose a voice from the list to preview its sample and view details."
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $3g2oV = parcelRequire("3g2oV");
var $aQTiM = parcelRequire("aQTiM");
var $8Muzv = parcelRequire("8Muzv");
var $8wD3p = parcelRequire("8wD3p");
var $2ffAV = parcelRequire("2ffAV");


var $4W5AG = parcelRequire("4W5AG");



var $208Op = parcelRequire("208Op");

var $8w4Nl = parcelRequire("8w4Nl");

var $fL4LX = parcelRequire("fL4LX");

var $i93Vd = parcelRequire("i93Vd");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $1O9kP = parcelRequire("1O9kP");

var $c1ibQ = parcelRequire("c1ibQ");

var $4HiHF = parcelRequire("4HiHF");

var $fVfXf = parcelRequire("fVfXf");
var $3f775e9165803f6a$export$2e2bcd8739ae039 = {};
$3f775e9165803f6a$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{625}\u{644}\u{649} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "finishRangeSelectionPrompt": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{625}\u{646}\u{647}\u{627}\u{621} \u{639}\u{645}\u{644}\u{64A}\u{629} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{646}\u{637}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    "maximumDate": `\u{622}\u{62E}\u{631} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62A}\u{627}\u{62D}`,
    "minimumDate": `\u{623}\u{648}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62A}\u{627}\u{62D}`,
    "next": `\u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}`,
    "previous": `\u{627}\u{644}\u{633}\u{627}\u{628}\u{642}`,
    "selectedDateDescription": (args)=>`\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62D}\u{62F}\u{62F}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{627}\u{644}\u{645}\u{62F}\u{649} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{627}\u{646}\u{642}\u{631} \u{644}\u{628}\u{62F}\u{621} \u{639}\u{645}\u{644}\u{64A}\u{629} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{646}\u{637}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    "todayDate": (args)=>`\u{627}\u{644}\u{64A}\u{648}\u{645}\u{60C} ${args.date}`,
    "todayDateSelected": (args)=>`\u{627}\u{644}\u{64A}\u{648}\u{645}\u{60C} ${args.date} \u{645}\u{62D}\u{62F}\u{62F}`
};


var $df318b661f2d38cc$export$2e2bcd8739ae039 = {};
$df318b661f2d38cc$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{434}\u{43E} ${args.endDate}`,
    "dateSelected": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435}, \u{437}\u{430} \u{434}\u{430} \u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{438}\u{442}\u{435} \u{438}\u{437}\u{431}\u{43E}\u{440}\u{430} \u{43D}\u{430} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{432}\u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}`,
    "maximumDate": `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{430} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "minimumDate": `\u{41F}\u{44A}\u{440}\u{432}\u{430} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "next": `\u{41D}\u{430}\u{43F}\u{440}\u{435}\u{434}`,
    "previous": `\u{41D}\u{430}\u{437}\u{430}\u{434}`,
    "selectedDateDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435}, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{440}\u{438}\u{441}\u{442}\u{44A}\u{43F}\u{438}\u{442}\u{435} \u{43A}\u{44A}\u{43C} \u{438}\u{437}\u{431}\u{43E}\u{440}\u{430} \u{43D}\u{430} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{432}\u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}`,
    "todayDate": (args)=>`\u{414}\u{43D}\u{435}\u{441}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{414}\u{43D}\u{435}\u{441}, ${args.date} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};


var $2ac9ac44b5dcd90f$export$2e2bcd8739ae039 = {};
$2ac9ac44b5dcd90f$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} a\u{17E} ${args.endDate}`,
    "dateSelected": (args)=>`Vybr\xe1no ${args.date}`,
    "finishRangeSelectionPrompt": `Kliknut\xedm dokon\u{10D}\xedte v\xfdb\u{11B}r rozsahu dat`,
    "maximumDate": `Posledn\xed dostupn\xe9 datum`,
    "minimumDate": `Prvn\xed dostupn\xe9 datum`,
    "next": `Dal\u{161}\xed`,
    "previous": `P\u{159}edchoz\xed`,
    "selectedDateDescription": (args)=>`Vybran\xe9 datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybran\xe9 obdob\xed: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknut\xedm zah\xe1j\xedte v\xfdb\u{11B}r rozsahu dat`,
    "todayDate": (args)=>`Dnes, ${args.date}`,
    "todayDateSelected": (args)=>`Dnes, vybr\xe1no ${args.date}`
};


var $5a04694e57711a5b$export$2e2bcd8739ae039 = {};
$5a04694e57711a5b$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} til ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valgt`,
    "finishRangeSelectionPrompt": `Klik for at fuldf\xf8re valg af datoomr\xe5de`,
    "maximumDate": `Sidste ledige dato`,
    "minimumDate": `F\xf8rste ledige dato`,
    "next": `N\xe6ste`,
    "previous": `Forrige`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt interval: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klik for at starte valg af datoomr\xe5de`,
    "todayDate": (args)=>`I dag, ${args.date}`,
    "todayDateSelected": (args)=>`I dag, ${args.date} valgt`
};


var $9ca901e2334fa18f$export$2e2bcd8739ae039 = {};
$9ca901e2334fa18f$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} bis ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} ausgew\xe4hlt`,
    "finishRangeSelectionPrompt": `Klicken, um die Auswahl des Datumsbereichs zu beenden`,
    "maximumDate": `Letztes verf\xfcgbares Datum`,
    "minimumDate": `Erstes verf\xfcgbares Datum`,
    "next": `Weiter`,
    "previous": `Zur\xfcck`,
    "selectedDateDescription": (args)=>`Ausgew\xe4hltes Datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Ausgew\xe4hlter Bereich: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klicken, um die Auswahl des Datumsbereichs zu beginnen`,
    "todayDate": (args)=>`Heute, ${args.date}`,
    "todayDateSelected": (args)=>`Heute, ${args.date} ausgew\xe4hlt`
};


var $7be0f317ecc26ebd$export$2e2bcd8739ae039 = {};
$7be0f317ecc26ebd$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{3AD}\u{3C9}\u{3C2} ${args.endDate}`,
    "dateSelected": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BF}\u{3BB}\u{3BF}\u{3BA}\u{3BB}\u{3B7}\u{3C1}\u{3CE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C5}\u{3C2} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3B9}\u{3CE}\u{3BD}`,
    "maximumDate": `\u{3A4}\u{3B5}\u{3BB}\u{3B5}\u{3C5}\u{3C4}\u{3B1}\u{3AF}\u{3B1} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}`,
    "minimumDate": `\u{3A0}\u{3C1}\u{3CE}\u{3C4}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}`,
    "next": `\u{395}\u{3C0}\u{3CC}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "previous": `\u{3A0}\u{3C1}\u{3BF}\u{3B7}\u{3B3}\u{3BF}\u{3CD}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "selectedDateDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C2}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{39A}\u{3AC}\u{3BD}\u{3C4}\u{3B5} \u{3BA}\u{3BB}\u{3B9}\u{3BA} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C5}\u{3C2} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3B9}\u{3CE}\u{3BD}`,
    "todayDate": (args)=>`\u{3A3}\u{3AE}\u{3BC}\u{3B5}\u{3C1}\u{3B1}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{3A3}\u{3AE}\u{3BC}\u{3B5}\u{3C1}\u{3B1}, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3C4}\u{3B7}\u{3BA}\u{3B5} ${args.date}`
};


var $58086bd8774f0048$export$2e2bcd8739ae039 = {};
$58086bd8774f0048$export$2e2bcd8739ae039 = {
    "previous": `Previous`,
    "next": `Next`,
    "selectedDateDescription": (args)=>`Selected Date: ${args.date}`,
    "selectedRangeDescription": (args)=>`Selected Range: ${args.dateRange}`,
    "todayDate": (args)=>`Today, ${args.date}`,
    "todayDateSelected": (args)=>`Today, ${args.date} selected`,
    "dateSelected": (args)=>`${args.date} selected`,
    "startRangeSelectionPrompt": `Click to start selecting date range`,
    "finishRangeSelectionPrompt": `Click to finish selecting date range`,
    "minimumDate": `First available date`,
    "maximumDate": `Last available date`,
    "dateRange": (args)=>`${args.startDate} to ${args.endDate}`
};


var $8c9b7dee7420c837$export$2e2bcd8739ae039 = {};
$8c9b7dee7420c837$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} seleccionado`,
    "finishRangeSelectionPrompt": `Haga clic para terminar de seleccionar rango de fechas`,
    "maximumDate": `\xdaltima fecha disponible`,
    "minimumDate": `Primera fecha disponible`,
    "next": `Siguiente`,
    "previous": `Anterior`,
    "selectedDateDescription": (args)=>`Fecha seleccionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo seleccionado: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Haga clic para comenzar a seleccionar un rango de fechas`,
    "todayDate": (args)=>`Hoy, ${args.date}`,
    "todayDateSelected": (args)=>`Hoy, ${args.date} seleccionado`
};


var $f587c8328dbeed80$export$2e2bcd8739ae039 = {};
$f587c8328dbeed80$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} kuni ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valitud`,
    "finishRangeSelectionPrompt": `Kl\xf5psake kuup\xe4evavahemiku valimise l\xf5petamiseks`,
    "maximumDate": `Viimane saadaolev kuup\xe4ev`,
    "minimumDate": `Esimene saadaolev kuup\xe4ev`,
    "next": `J\xe4rgmine`,
    "previous": `Eelmine`,
    "selectedDateDescription": (args)=>`Valitud kuup\xe4ev: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valitud vahemik: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kl\xf5psake kuup\xe4evavahemiku valimiseks`,
    "todayDate": (args)=>`T\xe4na, ${args.date}`,
    "todayDateSelected": (args)=>`T\xe4na, ${args.date} valitud`
};


var $00fb2e43f7101f96$export$2e2bcd8739ae039 = {};
$00fb2e43f7101f96$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{2013} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valittu`,
    "finishRangeSelectionPrompt": `Lopeta p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.`,
    "maximumDate": `Viimeinen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4`,
    "minimumDate": `Ensimm\xe4inen varattavissa oleva p\xe4iv\xe4m\xe4\xe4r\xe4`,
    "next": `Seuraava`,
    "previous": `Edellinen`,
    "selectedDateDescription": (args)=>`Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valittu aikav\xe4li: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Aloita p\xe4iv\xe4m\xe4\xe4r\xe4alueen valinta napsauttamalla t\xe4t\xe4.`,
    "todayDate": (args)=>`T\xe4n\xe4\xe4n, ${args.date}`,
    "todayDateSelected": (args)=>`T\xe4n\xe4\xe4n, ${args.date} valittu`
};


var $484b13a4db222c16$export$2e2bcd8739ae039 = {};
$484b13a4db222c16$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \xe0 ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} s\xe9lectionn\xe9`,
    "finishRangeSelectionPrompt": `Cliquer pour finir de s\xe9lectionner la plage de dates`,
    "maximumDate": `Derni\xe8re date disponible`,
    "minimumDate": `Premi\xe8re date disponible`,
    "next": `Suivant`,
    "previous": `Pr\xe9c\xe9dent`,
    "selectedDateDescription": (args)=>`Date s\xe9lectionn\xe9e\xa0: ${args.date}`,
    "selectedRangeDescription": (args)=>`Plage s\xe9lectionn\xe9e\xa0: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Cliquer pour commencer \xe0 s\xe9lectionner la plage de dates`,
    "todayDate": (args)=>`Aujourd'hui, ${args.date}`,
    "todayDateSelected": (args)=>`Aujourd\u{2019}hui, ${args.date} s\xe9lectionn\xe9`
};


var $b5a3f09b4076889f$export$2e2bcd8739ae039 = {};
$b5a3f09b4076889f$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{5E2}\u{5D3} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
    "finishRangeSelectionPrompt": `\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E1}\u{5D9}\u{5D9}\u{5DD} \u{5D0}\u{5EA} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5EA} \u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DB}\u{5D9}\u{5DD}`,
    "maximumDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E4}\u{5E0}\u{5D5}\u{5D9} \u{5D0}\u{5D7}\u{5E8}\u{5D5}\u{5DF}`,
    "minimumDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E4}\u{5E0}\u{5D5}\u{5D9} \u{5E8}\u{5D0}\u{5E9}\u{5D5}\u{5DF}`,
    "next": `\u{5D4}\u{5D1}\u{5D0}`,
    "previous": `\u{5D4}\u{5E7}\u{5D5}\u{5D3}\u{5DD}`,
    "selectedDateDescription": (args)=>`\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{5DC}\u{5D7}\u{5E5} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1}\u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5EA} \u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DB}\u{5D9}\u{5DD}`,
    "todayDate": (args)=>`\u{5D4}\u{5D9}\u{5D5}\u{5DD}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{5D4}\u{5D9}\u{5D5}\u{5DD}, ${args.date} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`
};


var $d1e62461084cd065$export$2e2bcd8739ae039 = {};
$d1e62461084cd065$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} odabran`,
    "finishRangeSelectionPrompt": `Kliknite da dovr\u{161}ite raspon odabranih datuma`,
    "maximumDate": `Posljednji raspolo\u{17E}ivi datum`,
    "minimumDate": `Prvi raspolo\u{17E}ivi datum`,
    "next": `Sljede\u{107}i`,
    "previous": `Prethodni`,
    "selectedDateDescription": (args)=>`Odabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Odabrani raspon: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknite da zapo\u{10D}nete raspon odabranih datuma`,
    "todayDate": (args)=>`Danas, ${args.date}`,
    "todayDateSelected": (args)=>`Danas, odabran ${args.date}`
};


var $758d0be47a46c193$export$2e2bcd8739ae039 = {};
$758d0be47a46c193$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate}\u{2013}${args.endDate}`,
    "dateSelected": (args)=>`${args.date} kiv\xe1lasztva`,
    "finishRangeSelectionPrompt": `Kattintson a d\xe1tumtartom\xe1ny kijel\xf6l\xe9s\xe9nek befejez\xe9s\xe9hez`,
    "maximumDate": `Utols\xf3 el\xe9rhet\u{151} d\xe1tum`,
    "minimumDate": `Az els\u{151} el\xe9rhet\u{151} d\xe1tum`,
    "next": `K\xf6vetkez\u{151}`,
    "previous": `El\u{151}z\u{151}`,
    "selectedDateDescription": (args)=>`Kijel\xf6lt d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Kijel\xf6lt tartom\xe1ny: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kattintson a d\xe1tumtartom\xe1ny kijel\xf6l\xe9s\xe9nek ind\xedt\xe1s\xe1hoz`,
    "todayDate": (args)=>`Ma, ${args.date}`,
    "todayDateSelected": (args)=>`Ma, ${args.date} kijel\xf6lve`
};


var $59809060b160eebe$export$2e2bcd8739ae039 = {};
$59809060b160eebe$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`Da ${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selezionata`,
    "finishRangeSelectionPrompt": `Fai clic per completare la selezione dell\u{2019}intervallo di date`,
    "maximumDate": `Ultima data disponibile`,
    "minimumDate": `Prima data disponibile`,
    "next": `Successivo`,
    "previous": `Precedente`,
    "selectedDateDescription": (args)=>`Data selezionata: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervallo selezionato: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Fai clic per selezionare l\u{2019}intervallo di date`,
    "todayDate": (args)=>`Oggi, ${args.date}`,
    "todayDateSelected": (args)=>`Oggi, ${args.date} selezionata`
};


var $5ccab62494cd1447$export$2e2bcd8739ae039 = {};
$5ccab62494cd1447$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{304B}\u{3089} ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{3092}\u{9078}\u{629E}`,
    "finishRangeSelectionPrompt": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306E}\u{9078}\u{629E}\u{3092}\u{7D42}\u{4E86}`,
    "maximumDate": `\u{6700}\u{7D42}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{65E5}`,
    "minimumDate": `\u{6700}\u{521D}\u{306E}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{65E5}`,
    "next": `\u{6B21}\u{3078}`,
    "previous": `\u{524D}\u{3078}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8} : ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{629E}\u{7BC4}\u{56F2} : ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{30AF}\u{30EA}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306E}\u{9078}\u{629E}\u{3092}\u{958B}\u{59CB}`,
    "todayDate": (args)=>`\u{672C}\u{65E5}\u{3001}${args.date}`,
    "todayDateSelected": (args)=>`\u{672C}\u{65E5}\u{3001}${args.date} \u{3092}\u{9078}\u{629E}`
};


var $fda86a5799c7c921$export$2e2bcd8739ae039 = {};
$fda86a5799c7c921$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} ~ ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} \u{C120}\u{D0DD}\u{B428}`,
    "finishRangeSelectionPrompt": `\u{B0A0}\u{C9DC} \u{BC94}\u{C704} \u{C120}\u{D0DD}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    "maximumDate": `\u{B9C8}\u{C9C0}\u{B9C9}\u{C73C}\u{B85C} \u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C77C}\u{C790}`,
    "minimumDate": `\u{CC98}\u{C74C}\u{C73C}\u{B85C} \u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C77C}\u{C790}`,
    "next": `\u{B2E4}\u{C74C}`,
    "previous": `\u{C774}\u{C804}`,
    "selectedDateDescription": (args)=>`\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{B0A0}\u{C9DC} \u{BC94}\u{C704} \u{C120}\u{D0DD}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    "todayDate": (args)=>`\u{C624}\u{B298}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{C624}\u{B298}, ${args.date} \u{C120}\u{D0DD}\u{B428}`
};


var $b023ced0249cc757$export$2e2bcd8739ae039 = {};
$b023ced0249cc757$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`Nuo ${args.startDate} iki ${args.endDate}`,
    "dateSelected": (args)=>`Pasirinkta ${args.date}`,
    "finishRangeSelectionPrompt": `Spustel\u{117}kite, kad baigtum\u{117}te pasirinkti dat\u{173} interval\u{105}`,
    "maximumDate": `Paskutin\u{117} galima data`,
    "minimumDate": `Pirmoji galima data`,
    "next": `Paskesnis`,
    "previous": `Ankstesnis`,
    "selectedDateDescription": (args)=>`Pasirinkta data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Pasirinktas intervalas: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Spustel\u{117}kite, kad prad\u{117}tum\u{117}te pasirinkti dat\u{173} interval\u{105}`,
    "todayDate": (args)=>`\u{160}iandien, ${args.date}`,
    "todayDateSelected": (args)=>`\u{160}iandien, pasirinkta ${args.date}`
};


var $588e4a0e7b972e51$export$2e2bcd8739ae039 = {};
$588e4a0e7b972e51$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`No ${args.startDate} l\u{12B}dz ${args.endDate}`,
    "dateSelected": (args)=>`Atlas\u{12B}ts: ${args.date}`,
    "finishRangeSelectionPrompt": `Noklik\u{161}\u{137}iniet, lai pabeigtu datumu diapazona atlasi`,
    "maximumDate": `P\u{113}d\u{113}jais pieejamais datums`,
    "minimumDate": `Pirmais pieejamais datums`,
    "next": `T\u{101}l\u{101}k`,
    "previous": `Atpaka\u{13C}`,
    "selectedDateDescription": (args)=>`Atlas\u{12B}tais datums: ${args.date}`,
    "selectedRangeDescription": (args)=>`Atlas\u{12B}tais diapazons: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Noklik\u{161}\u{137}iniet, lai s\u{101}ktu datumu diapazona atlasi`,
    "todayDate": (args)=>`\u{160}odien, ${args.date}`,
    "todayDateSelected": (args)=>`Atlas\u{12B}ta \u{161}odiena, ${args.date}`
};


var $270852ca5b5e0275$export$2e2bcd8739ae039 = {};
$270852ca5b5e0275$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} til ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} valgt`,
    "finishRangeSelectionPrompt": `Klikk for \xe5 fullf\xf8re valg av datoomr\xe5de`,
    "maximumDate": `Siste tilgjengelige dato`,
    "minimumDate": `F\xf8rste tilgjengelige dato`,
    "next": `Neste`,
    "previous": `Forrige`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt omr\xe5de: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klikk for \xe5 starte valg av datoomr\xe5de`,
    "todayDate": (args)=>`I dag, ${args.date}`,
    "todayDateSelected": (args)=>`I dag, ${args.date} valgt`
};


var $08602f4e29141b66$export$2e2bcd8739ae039 = {};
$08602f4e29141b66$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} tot ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} geselecteerd`,
    "finishRangeSelectionPrompt": `Klik om de selectie van het datumbereik te voltooien`,
    "maximumDate": `Laatste beschikbare datum`,
    "minimumDate": `Eerste beschikbare datum`,
    "next": `Volgende`,
    "previous": `Vorige`,
    "selectedDateDescription": (args)=>`Geselecteerde datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Geselecteerd bereik: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klik om het datumbereik te selecteren`,
    "todayDate": (args)=>`Vandaag, ${args.date}`,
    "todayDateSelected": (args)=>`Vandaag, ${args.date} geselecteerd`
};


var $6114c035a8e75d4f$export$2e2bcd8739ae039 = {};
$6114c035a8e75d4f$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`Wybrano ${args.date}`,
    "finishRangeSelectionPrompt": `Kliknij, aby zako\u{144}czy\u{107} wyb\xf3r zakresu dat`,
    "maximumDate": `Ostatnia dost\u{119}pna data`,
    "minimumDate": `Pierwsza dost\u{119}pna data`,
    "next": `Dalej`,
    "previous": `Wstecz`,
    "selectedDateDescription": (args)=>`Wybrana data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Wybrany zakres: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknij, aby rozpocz\u{105}\u{107} wyb\xf3r zakresu dat`,
    "todayDate": (args)=>`Dzisiaj, ${args.date}`,
    "todayDateSelected": (args)=>`Dzisiaj wybrano ${args.date}`
};


var $9d6843c13658f839$export$2e2bcd8739ae039 = {};
$9d6843c13658f839$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selecionado`,
    "finishRangeSelectionPrompt": `Clique para concluir a sele\xe7\xe3o do intervalo de datas`,
    "maximumDate": `\xdaltima data dispon\xedvel`,
    "minimumDate": `Primeira data dispon\xedvel`,
    "next": `Pr\xf3ximo`,
    "previous": `Anterior`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Clique para iniciar a sele\xe7\xe3o do intervalo de datas`,
    "todayDate": (args)=>`Hoje, ${args.date}`,
    "todayDateSelected": (args)=>`Hoje, ${args.date} selecionado`
};


var $7f90c6ada2fda70b$export$2e2bcd8739ae039 = {};
$7f90c6ada2fda70b$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} a ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selecionado`,
    "finishRangeSelectionPrompt": `Clique para terminar de selecionar o intervalo de datas`,
    "maximumDate": `\xdaltima data dispon\xedvel`,
    "minimumDate": `Primeira data dispon\xedvel`,
    "next": `Pr\xf3ximo`,
    "previous": `Anterior`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Clique para come\xe7ar a selecionar o intervalo de datas`,
    "todayDate": (args)=>`Hoje, ${args.date}`,
    "todayDateSelected": (args)=>`Hoje, ${args.date} selecionado`
};


var $55893009da74372b$export$2e2bcd8739ae039 = {};
$55893009da74372b$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`De la ${args.startDate} p\xe2n\u{103} la ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} selectat\u{103}`,
    "finishRangeSelectionPrompt": `Ap\u{103}sa\u{163}i pentru a finaliza selec\u{163}ia razei pentru dat\u{103}`,
    "maximumDate": `Ultima dat\u{103} disponibil\u{103}`,
    "minimumDate": `Prima dat\u{103} disponibil\u{103}`,
    "next": `Urm\u{103}torul`,
    "previous": `\xcenainte`,
    "selectedDateDescription": (args)=>`Dat\u{103} selectat\u{103}: ${args.date}`,
    "selectedRangeDescription": (args)=>`Interval selectat: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Ap\u{103}sa\u{163}i pentru a \xeencepe selec\u{163}ia razei pentru dat\u{103}`,
    "todayDate": (args)=>`Ast\u{103}zi, ${args.date}`,
    "todayDateSelected": (args)=>`Azi, ${args.date} selectat\u{103}`
};


var $3d6602a923f94276$export$2e2bcd8739ae039 = {};
$3d6602a923f94276$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`\u{421} ${args.startDate} \u{43F}\u{43E} ${args.endDate}`,
    "dateSelected": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{430} \u{434}\u{430}\u{442}`,
    "maximumDate": `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{44F}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}`,
    "minimumDate": `\u{41F}\u{435}\u{440}\u{432}\u{430}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}`,
    "next": `\u{414}\u{430}\u{43B}\u{435}\u{435}`,
    "previous": `\u{41D}\u{430}\u{437}\u{430}\u{434}`,
    "selectedDateDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{429}\u{435}\u{43B}\u{43A}\u{43D}\u{438}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{430} \u{434}\u{430}\u{442}`,
    "todayDate": (args)=>`\u{421}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{421}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`
};


var $0cf1bb2e8274956c$export$2e2bcd8739ae039 = {};
$0cf1bb2e8274956c$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`Od ${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`Vybrat\xfd d\xe1tum ${args.date}`,
    "finishRangeSelectionPrompt": `Kliknut\xedm dokon\u{10D}\xedte v\xfdber rozsahu d\xe1tumov`,
    "maximumDate": `Posledn\xfd dostupn\xfd d\xe1tum`,
    "minimumDate": `Prv\xfd dostupn\xfd d\xe1tum`,
    "next": `Nasleduj\xface`,
    "previous": `Predch\xe1dzaj\xface`,
    "selectedDateDescription": (args)=>`Vybrat\xfd d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybrat\xfd rozsah: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknut\xedm spust\xedte v\xfdber rozsahu d\xe1tumov`,
    "todayDate": (args)=>`Dnes ${args.date}`,
    "todayDateSelected": (args)=>`Vybrat\xfd dne\u{161}n\xfd d\xe1tum ${args.date}`
};


var $9aa6fff6e8939591$export$2e2bcd8739ae039 = {};
$9aa6fff6e8939591$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} izbrano`,
    "finishRangeSelectionPrompt": `Kliknite za dokon\u{10D}anje izbire datumskega obsega`,
    "maximumDate": `Zadnji razpolo\u{17E}ljivi datum`,
    "minimumDate": `Prvi razpolo\u{17E}ljivi datum`,
    "next": `Naprej`,
    "previous": `Nazaj`,
    "selectedDateDescription": (args)=>`Izbrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izbrano obmo\u{10D}je: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknite za za\u{10D}etek izbire datumskega obsega`,
    "todayDate": (args)=>`Danes, ${args.date}`,
    "todayDateSelected": (args)=>`Danes, ${args.date} izbrano`
};


var $73c0d60c9c7192fe$export$2e2bcd8739ae039 = {};
$73c0d60c9c7192fe$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} do ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} izabran`,
    "finishRangeSelectionPrompt": `Kliknite da dovr\u{161}ite opseg izabranih datuma`,
    "maximumDate": `Zadnji raspolo\u{17E}ivi datum`,
    "minimumDate": `Prvi raspolo\u{17E}ivi datum`,
    "next": `Slede\u{107}i`,
    "previous": `Prethodni`,
    "selectedDateDescription": (args)=>`Izabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izabrani period: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Kliknite da zapo\u{10D}nete opseg izabranih datuma`,
    "todayDate": (args)=>`Danas, ${args.date}`,
    "todayDateSelected": (args)=>`Danas, izabran ${args.date}`
};


var $a556410302e170d9$export$2e2bcd8739ae039 = {};
$a556410302e170d9$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} till ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} har valts`,
    "finishRangeSelectionPrompt": `Klicka f\xf6r att avsluta val av datumintervall`,
    "maximumDate": `Sista tillg\xe4ngliga datum`,
    "minimumDate": `F\xf6rsta tillg\xe4ngliga datum`,
    "next": `N\xe4sta`,
    "previous": `F\xf6reg\xe5ende`,
    "selectedDateDescription": (args)=>`Valt datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valt intervall: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Klicka f\xf6r att v\xe4lja datumintervall`,
    "todayDate": (args)=>`Idag, ${args.date}`,
    "todayDateSelected": (args)=>`Idag, ${args.date} har valts`
};


var $0584eb971db64fed$export$2e2bcd8739ae039 = {};
$0584eb971db64fed$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} - ${args.endDate}`,
    "dateSelected": (args)=>`${args.date} se\xe7ildi`,
    "finishRangeSelectionPrompt": `Tarih aral\u{131}\u{11F}\u{131} se\xe7imini tamamlamak i\xe7in t\u{131}klay\u{131}n`,
    "maximumDate": `Son m\xfcsait tarih`,
    "minimumDate": `\u{130}lk m\xfcsait tarih`,
    "next": `Sonraki`,
    "previous": `\xd6nceki`,
    "selectedDateDescription": (args)=>`Se\xe7ilen Tarih: ${args.date}`,
    "selectedRangeDescription": (args)=>`Se\xe7ilen Aral\u{131}k: ${args.dateRange}`,
    "startRangeSelectionPrompt": `Tarih aral\u{131}\u{11F}\u{131} se\xe7imini ba\u{15F}latmak i\xe7in t\u{131}klay\u{131}n`,
    "todayDate": (args)=>`Bug\xfcn, ${args.date}`,
    "todayDateSelected": (args)=>`Bug\xfcn, ${args.date} se\xe7ildi`
};


var $e10d4b8646366ef8$export$2e2bcd8739ae039 = {};
$e10d4b8646366ef8$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{2014} ${args.endDate}`,
    "dateSelected": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{438} \u{432}\u{438}\u{431}\u{456}\u{440} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{443} \u{434}\u{430}\u{442}`,
    "maximumDate": `\u{41E}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "minimumDate": `\u{41F}\u{435}\u{440}\u{448}\u{430} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "next": `\u{41D}\u{430}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{438}\u{439}`,
    "previous": `\u{41F}\u{43E}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{43D}\u{456}\u{439}`,
    "selectedDateDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C}, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{432}\u{438}\u{431}\u{456}\u{440} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{443} \u{434}\u{430}\u{442}`,
    "todayDate": (args)=>`\u{421}\u{44C}\u{43E}\u{433}\u{43E}\u{434}\u{43D}\u{456}, ${args.date}`,
    "todayDateSelected": (args)=>`\u{421}\u{44C}\u{43E}\u{433}\u{43E}\u{434}\u{43D}\u{456}, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} ${args.date}`
};


var $30fb8aa8e5ea970b$export$2e2bcd8739ae039 = {};
$30fb8aa8e5ea970b$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{81F3} ${args.endDate}`,
    "dateSelected": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{5355}\u{51FB}\u{4EE5}\u{5B8C}\u{6210}\u{9009}\u{62E9}\u{65E5}\u{671F}\u{8303}\u{56F4}`,
    "maximumDate": `\u{6700}\u{540E}\u{4E00}\u{4E2A}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "minimumDate": `\u{7B2C}\u{4E00}\u{4E2A}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "next": `\u{4E0B}\u{4E00}\u{9875}`,
    "previous": `\u{4E0A}\u{4E00}\u{9875}`,
    "selectedDateDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{8303}\u{56F4}\u{FF1A}${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{5355}\u{51FB}\u{4EE5}\u{5F00}\u{59CB}\u{9009}\u{62E9}\u{65E5}\u{671F}\u{8303}\u{56F4}`,
    "todayDate": (args)=>`\u{4ECA}\u{5929}\u{FF0C}\u{5373} ${args.date}`,
    "todayDateSelected": (args)=>`\u{5DF2}\u{9009}\u{62E9}\u{4ECA}\u{5929}\u{FF0C}\u{5373} ${args.date}`
};


var $e88076dc00730805$export$2e2bcd8739ae039 = {};
$e88076dc00730805$export$2e2bcd8739ae039 = {
    "dateRange": (args)=>`${args.startDate} \u{81F3} ${args.endDate}`,
    "dateSelected": (args)=>`\u{5DF2}\u{9078}\u{53D6} ${args.date}`,
    "finishRangeSelectionPrompt": `\u{6309}\u{4E00}\u{4E0B}\u{4EE5}\u{5B8C}\u{6210}\u{9078}\u{53D6}\u{65E5}\u{671F}\u{7BC4}\u{570D}`,
    "maximumDate": `\u{6700}\u{5F8C}\u{4E00}\u{500B}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "minimumDate": `\u{7B2C}\u{4E00}\u{500B}\u{53EF}\u{7528}\u{65E5}\u{671F}`,
    "next": `\u{4E0B}\u{4E00}\u{9801}`,
    "previous": `\u{4E0A}\u{4E00}\u{9801}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{7BC4}\u{570D}\u{FF1A}${args.dateRange}`,
    "startRangeSelectionPrompt": `\u{6309}\u{4E00}\u{4E0B}\u{4EE5}\u{958B}\u{59CB}\u{9078}\u{53D6}\u{65E5}\u{671F}\u{7BC4}\u{570D}`,
    "todayDate": (args)=>`\u{4ECA}\u{5929}\u{FF0C}${args.date}`,
    "todayDateSelected": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{4ECA}\u{5929}\u{FF0C}${args.date}`
};


var $d88b78df0c2992e6$export$2e2bcd8739ae039 = {};
$d88b78df0c2992e6$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $3f775e9165803f6a$export$2e2bcd8739ae039),
    "bg-BG": (0, $df318b661f2d38cc$export$2e2bcd8739ae039),
    "cs-CZ": (0, $2ac9ac44b5dcd90f$export$2e2bcd8739ae039),
    "da-DK": (0, $5a04694e57711a5b$export$2e2bcd8739ae039),
    "de-DE": (0, $9ca901e2334fa18f$export$2e2bcd8739ae039),
    "el-GR": (0, $7be0f317ecc26ebd$export$2e2bcd8739ae039),
    "en-US": (0, $58086bd8774f0048$export$2e2bcd8739ae039),
    "es-ES": (0, $8c9b7dee7420c837$export$2e2bcd8739ae039),
    "et-EE": (0, $f587c8328dbeed80$export$2e2bcd8739ae039),
    "fi-FI": (0, $00fb2e43f7101f96$export$2e2bcd8739ae039),
    "fr-FR": (0, $484b13a4db222c16$export$2e2bcd8739ae039),
    "he-IL": (0, $b5a3f09b4076889f$export$2e2bcd8739ae039),
    "hr-HR": (0, $d1e62461084cd065$export$2e2bcd8739ae039),
    "hu-HU": (0, $758d0be47a46c193$export$2e2bcd8739ae039),
    "it-IT": (0, $59809060b160eebe$export$2e2bcd8739ae039),
    "ja-JP": (0, $5ccab62494cd1447$export$2e2bcd8739ae039),
    "ko-KR": (0, $fda86a5799c7c921$export$2e2bcd8739ae039),
    "lt-LT": (0, $b023ced0249cc757$export$2e2bcd8739ae039),
    "lv-LV": (0, $588e4a0e7b972e51$export$2e2bcd8739ae039),
    "nb-NO": (0, $270852ca5b5e0275$export$2e2bcd8739ae039),
    "nl-NL": (0, $08602f4e29141b66$export$2e2bcd8739ae039),
    "pl-PL": (0, $6114c035a8e75d4f$export$2e2bcd8739ae039),
    "pt-BR": (0, $9d6843c13658f839$export$2e2bcd8739ae039),
    "pt-PT": (0, $7f90c6ada2fda70b$export$2e2bcd8739ae039),
    "ro-RO": (0, $55893009da74372b$export$2e2bcd8739ae039),
    "ru-RU": (0, $3d6602a923f94276$export$2e2bcd8739ae039),
    "sk-SK": (0, $0cf1bb2e8274956c$export$2e2bcd8739ae039),
    "sl-SI": (0, $9aa6fff6e8939591$export$2e2bcd8739ae039),
    "sr-SP": (0, $73c0d60c9c7192fe$export$2e2bcd8739ae039),
    "sv-SE": (0, $a556410302e170d9$export$2e2bcd8739ae039),
    "tr-TR": (0, $0584eb971db64fed$export$2e2bcd8739ae039),
    "uk-UA": (0, $e10d4b8646366ef8$export$2e2bcd8739ae039),
    "zh-CN": (0, $30fb8aa8e5ea970b$export$2e2bcd8739ae039),
    "zh-TW": (0, $e88076dc00730805$export$2e2bcd8739ae039)
};



var $eZSya = parcelRequire("eZSya");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $1qrul = parcelRequire("1qrul");

var $eF4cA = parcelRequire("eF4cA");
function $7daf924aef66f353$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7daf924aef66f353$export$653eddfc964b0f8a = new WeakMap();
function $7daf924aef66f353$export$134cbb7fb09a9522(date) {
    return date?.calendar.identifier === 'gregory' && date.era === 'BC' ? 'short' : undefined;
}
function $7daf924aef66f353$export$b6df97c887c38e1a(state) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($7daf924aef66f353$var$$parcel$interopDefault((0, $d88b78df0c2992e6$export$2e2bcd8739ae039)), '@react-aria/calendar');
    let start, end;
    if ('highlightedRange' in state) ({ start: start, end: end } = state.highlightedRange || {});
    else {
        start = Array.isArray(state.value) ? state.value[0] : state.value ?? undefined;
        end = Array.isArray(state.value) ? state.value.at(-1) : state.value ?? undefined;
    }
    let dateFormatter = (0, $eZSya.useDateFormatter)({
        weekday: 'long',
        month: 'long',
        year: 'numeric',
        day: 'numeric',
        era: $7daf924aef66f353$export$134cbb7fb09a9522(start) || $7daf924aef66f353$export$134cbb7fb09a9522(end),
        timeZone: state.timeZone
    });
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let listFormatter = (0, $eF4cA.useMemo)(()=>new Intl.ListFormat(locale), [
        locale
    ]);
    let anchorDate = 'anchorDate' in state ? state.anchorDate : null;
    return (0, $eF4cA.useMemo)(()=>{
        // No message if currently selecting a range, or there is nothing highlighted.
        if (!anchorDate && start && end) {
            // Use a single date message if the start and end dates are the same day,
            // otherwise include both dates.
            if ((0, $1qrul.isSameDay)(start, end)) {
                let date = dateFormatter.format(start.toDate(state.timeZone));
                return stringFormatter.format('selectedDateDescription', {
                    date: date
                });
            } else if ('highlightedRange' in state) {
                let dateRange = $7daf924aef66f353$var$$9bac9bf03b87f160$var$formatRange(dateFormatter, stringFormatter, start, end, state.timeZone);
                return stringFormatter.format('selectedRangeDescription', {
                    dateRange: dateRange
                });
            } else if (Array.isArray(state.value)) {
                let dates = state.value.map((date)=>dateFormatter.format(date.toDate(state.timeZone)));
                let formatted = listFormatter.format(dates);
                return stringFormatter.format('selectedDateDescription', {
                    date: formatted
                });
            }
        }
        return '';
    }, [
        start,
        end,
        anchorDate,
        state,
        stringFormatter,
        dateFormatter,
        listFormatter
    ]);
}
function $7daf924aef66f353$export$31afe65d91ef6e8(startDate, endDate, timeZone, isAria) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($7daf924aef66f353$var$$parcel$interopDefault((0, $d88b78df0c2992e6$export$2e2bcd8739ae039)), '@react-aria/calendar');
    let era = $7daf924aef66f353$export$134cbb7fb09a9522(startDate) || $7daf924aef66f353$export$134cbb7fb09a9522(endDate);
    let monthFormatter = (0, $eZSya.useDateFormatter)({
        month: 'long',
        year: 'numeric',
        era: era,
        calendar: startDate.calendar.identifier,
        timeZone: timeZone
    });
    let dateFormatter = (0, $eZSya.useDateFormatter)({
        month: 'long',
        year: 'numeric',
        day: 'numeric',
        era: era,
        calendar: startDate.calendar.identifier,
        timeZone: timeZone
    });
    return (0, $eF4cA.useMemo)(()=>{
        // Special case for month granularity. Format as a single month if only a
        // single month is visible, otherwise format as a range of months.
        if ((0, $1qrul.isSameDay)(startDate, (0, $1qrul.startOfMonth)(startDate))) {
            let startMonth = startDate;
            let endMonth = endDate;
            if (startDate.calendar.getFormattableMonth) startMonth = startDate.calendar.getFormattableMonth(startDate);
            if (endDate.calendar.getFormattableMonth) endMonth = endDate.calendar.getFormattableMonth(endDate);
            if ((0, $1qrul.isSameDay)(endDate, (0, $1qrul.endOfMonth)(startDate))) return monthFormatter.format(startMonth.toDate(timeZone));
            else if ((0, $1qrul.isSameDay)(endDate, (0, $1qrul.endOfMonth)(endDate))) return isAria ? $7daf924aef66f353$var$$9bac9bf03b87f160$var$formatRange(monthFormatter, stringFormatter, startMonth, endMonth, timeZone) : monthFormatter.formatRange(startMonth.toDate(timeZone), endMonth.toDate(timeZone));
        }
        return isAria ? $7daf924aef66f353$var$$9bac9bf03b87f160$var$formatRange(dateFormatter, stringFormatter, startDate, endDate, timeZone) : dateFormatter.formatRange(startDate.toDate(timeZone), endDate.toDate(timeZone));
    }, [
        startDate,
        endDate,
        monthFormatter,
        dateFormatter,
        stringFormatter,
        timeZone,
        isAria
    ]);
}
function $7daf924aef66f353$var$$9bac9bf03b87f160$var$formatRange(dateFormatter, stringFormatter, start, end, timeZone) {
    let parts = dateFormatter.formatRangeToParts(start.toDate(timeZone), end.toDate(timeZone));
    // Find the separator between the start and end date. This is determined
    // by finding the last shared literal before the end range.
    let separatorIndex = -1;
    for(let i = 0; i < parts.length; i++){
        let part = parts[i];
        if (part.source === 'shared' && part.type === 'literal') separatorIndex = i;
        else if (part.source === 'endRange') break;
    }
    // Now we can combine the parts into start and end strings.
    let startValue = '';
    let endValue = '';
    for(let i = 0; i < parts.length; i++){
        if (i < separatorIndex) startValue += parts[i].value;
        else if (i > separatorIndex) endValue += parts[i].value;
    }
    return stringFormatter.format('dateRange', {
        startDate: startValue,
        endDate: endValue
    });
}




var $lhKAD = parcelRequire("lhKAD");

var $dkaC0 = parcelRequire("dkaC0");

var $gI8Gw = parcelRequire("gI8Gw");

var $25dFS = parcelRequire("25dFS");

var $lXemd = parcelRequire("lXemd");

var $eF4cA = parcelRequire("eF4cA");
function $300e5733f4d7a2d7$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $300e5733f4d7a2d7$export$d652b3ea2d672d5b(props, state) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($300e5733f4d7a2d7$var$$parcel$interopDefault((0, $d88b78df0c2992e6$export$2e2bcd8739ae039)), '@react-aria/calendar');
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    let title = (0, $7daf924aef66f353$export$31afe65d91ef6e8)(state.visibleRange.start, state.visibleRange.end, state.timeZone, false);
    let visibleRangeDescription = (0, $7daf924aef66f353$export$31afe65d91ef6e8)(state.visibleRange.start, state.visibleRange.end, state.timeZone, true);
    (0, $lXemd.useUpdateEffect)(()=>{
        // only when pressing the Previous or Next button
        if (!state.isFocused) (0, $4HiHF.announce)(visibleRangeDescription);
    }, [
        visibleRangeDescription
    ]);
    // Announce when the selected value changes
    let selectedDateDescription = (0, $7daf924aef66f353$export$b6df97c887c38e1a)(state);
    (0, $lXemd.useUpdateEffect)(()=>{
        if (selectedDateDescription) (0, $4HiHF.announce)(selectedDateDescription, 'polite', 4000);
    // handle an update to the caption that describes the currently selected range, to announce the new value
    }, [
        selectedDateDescription
    ]);
    let errorMessageId = (0, $25dFS.useSlotId)([
        Boolean(props.errorMessage),
        props.isInvalid,
        props.validationState
    ]);
    (0, $7daf924aef66f353$export$653eddfc964b0f8a).set(state, {
        ariaLabel: props['aria-label'],
        ariaLabelledBy: props['aria-labelledby'],
        errorMessageId: errorMessageId,
        selectedDateDescription: selectedDateDescription
    });
    // If the next or previous buttons become disabled while they are focused, move focus to the calendar body.
    let [nextFocused, setNextFocused] = (0, $eF4cA.useState)(false);
    let nextDisabled = props.isDisabled || state.isNextVisibleRangeInvalid();
    if (nextDisabled && nextFocused) {
        setNextFocused(false);
        state.setFocused(true);
    }
    let [previousFocused, setPreviousFocused] = (0, $eF4cA.useState)(false);
    let previousDisabled = props.isDisabled || state.isPreviousVisibleRangeInvalid();
    if (previousDisabled && previousFocused) {
        setPreviousFocused(false);
        state.setFocused(true);
    }
    let labelProps = (0, $dkaC0.useLabels)({
        id: props['id'],
        'aria-label': [
            props['aria-label'],
            visibleRangeDescription
        ].filter(Boolean).join(', '),
        'aria-labelledby': props['aria-labelledby']
    });
    return {
        calendarProps: (0, $lhKAD.mergeProps)(domProps, labelProps, {
            role: 'application',
            'aria-details': props['aria-details'] || undefined,
            'aria-describedby': props['aria-describedby'] || undefined
        }),
        nextButtonProps: {
            onPress: ()=>state.focusNextPage(),
            'aria-label': stringFormatter.format('next'),
            isDisabled: nextDisabled,
            onFocusChange: setNextFocused
        },
        prevButtonProps: {
            onPress: ()=>state.focusPreviousPage(),
            'aria-label': stringFormatter.format('previous'),
            isDisabled: previousDisabled,
            onFocusChange: setPreviousFocused
        },
        errorMessageProps: {
            id: errorMessageId
        },
        title: title
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $010999b093711aee$export$3ee915f8151bd4f1(props, state) {
    return (0, $300e5733f4d7a2d7$export$d652b3ea2d672d5b)(props, state);
}


var $2jk5s = parcelRequire("2jk5s");

var $fvyIQ = parcelRequire("fvyIQ");


var $YxOvP = parcelRequire("YxOvP");

var $5AGOf = parcelRequire("5AGOf");


var $lhKAD = parcelRequire("lhKAD");

var $3lc2m = parcelRequire("3lc2m");

var $eZSya = parcelRequire("eZSya");

var $gCYb4 = parcelRequire("gCYb4");

var $lXRQr = parcelRequire("lXRQr");

var $gI8Gw = parcelRequire("gI8Gw");

var $bEes0 = parcelRequire("bEes0");

var $1qrul = parcelRequire("1qrul");

var $eF4cA = parcelRequire("eF4cA");
function $68bad6c104c3e7cd$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $68bad6c104c3e7cd$export$136073280381448e(props, state, ref) {
    let { date: date, isDisabled: isDisabled } = props;
    let { errorMessageId: errorMessageId, selectedDateDescription: selectedDateDescription } = (0, $7daf924aef66f353$export$653eddfc964b0f8a).get(state);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($68bad6c104c3e7cd$var$$parcel$interopDefault((0, $d88b78df0c2992e6$export$2e2bcd8739ae039)), '@react-aria/calendar');
    let dateFormatter = (0, $eZSya.useDateFormatter)({
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        era: (0, $7daf924aef66f353$export$134cbb7fb09a9522)(date),
        timeZone: state.timeZone
    });
    let isFocused = state.isCellFocused(date) && !props.isOutsideMonth;
    isDisabled = isDisabled || state.isCellDisabled(date) || !!props.isOutsideMonth;
    let isUnavailable = state.isCellUnavailable(date);
    let isSelectable = !isDisabled && !isUnavailable;
    let isSelected = state.isSelected(date) && isSelectable;
    let isInvalid = false;
    if (state.isValueInvalid) {
        if ('highlightedRange' in state) isInvalid = !state.anchorDate && state.highlightedRange != null && date.compare(state.highlightedRange.start) >= 0 && date.compare(state.highlightedRange.end) <= 0;
        else if (Array.isArray(state.value)) isInvalid = state.value.some((value)=>(0, $1qrul.isSameDay)(value, date));
        else if (state.value) isInvalid = (0, $1qrul.isSameDay)(state.value, date);
    }
    if (isInvalid && !isDisabled) isSelected = true;
    // For performance, reuse the same date object as before if the new date prop is the same.
    // This allows subsequent useMemo results to be reused.
    date = (0, $gCYb4.useDeepMemo)(date, (0, $1qrul.isEqualDay));
    // oxlint-disable-next-line react/react-compiler
    let nativeDate = (0, $eF4cA.useMemo)(()=>date.toDate(state.timeZone), [
        date,
        state.timeZone
    ]);
    // aria-label should be localize Day of week, Month, Day and Year without Time.
    let isDateToday = (0, $1qrul.isToday)(date, state.timeZone);
    let label = (0, $eF4cA.useMemo)(()=>{
        let label = '';
        // If this is a range calendar, add a description of the full selected range
        // to the first and last selected date.
        if ('highlightedRange' in state && state.value && !state.anchorDate && ((0, $1qrul.isSameDay)(date, state.value.start) || (0, $1qrul.isSameDay)(date, state.value.end))) label = selectedDateDescription + ', ';
        label += dateFormatter.format(nativeDate);
        if (isDateToday) label = stringFormatter.format(isSelected ? 'todayDateSelected' : 'todayDate', {
            date: label
        });
        else if (isSelected) label = stringFormatter.format('dateSelected', {
            date: label
        });
        if (state.minValue && (0, $1qrul.isSameDay)(date, state.minValue)) label += ', ' + stringFormatter.format('minimumDate');
        else if (state.maxValue && (0, $1qrul.isSameDay)(date, state.maxValue)) label += ', ' + stringFormatter.format('maximumDate');
        return label;
    }, [
        dateFormatter,
        nativeDate,
        stringFormatter,
        // oxlint-disable-next-line react/react-compiler
        isSelected,
        isDateToday,
        // oxlint-disable-next-line react/react-compiler
        date,
        state,
        selectedDateDescription
    ]);
    // When a cell is focused and this is a range calendar, add a prompt to help
    // screenreader users know that they are in a range selection mode.
    let rangeSelectionPrompt = '';
    if ('anchorDate' in state && isFocused && !state.isReadOnly && isSelectable) {
        // If selection has started add "click to finish selecting range"
        if (state.anchorDate) rangeSelectionPrompt = stringFormatter.format('finishRangeSelectionPrompt');
        else rangeSelectionPrompt = stringFormatter.format('startRangeSelectionPrompt');
    }
    let descriptionProps = (0, $lXRQr.useDescription)(rangeSelectionPrompt);
    let isAnchorPressed = (0, $eF4cA.useRef)(false);
    let isRangeBoundaryPressed = (0, $eF4cA.useRef)(false);
    let touchDragTimerRef = (0, $eF4cA.useRef)(undefined);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $bEes0.usePress)({
        // When dragging to select a range, we don't want dragging over the original anchor
        // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
        shouldCancelOnPointerExit: 'anchorDate' in state && !!state.anchorDate,
        preventFocusOnPress: true,
        isDisabled: !isSelectable || state.isReadOnly,
        onPressStart (e) {
            if (state.isReadOnly) {
                state.setFocusedDate(date);
                state.setFocused(true);
                return;
            }
            if ('highlightedRange' in state && !state.anchorDate && (e.pointerType === 'mouse' || e.pointerType === 'touch')) {
                // Allow dragging the start or end date of a range to modify it
                // rather than starting a new selection.
                // Don't allow dragging when invalid, or weird jumping behavior may occur as date ranges
                // are constrained to available dates. The user will need to select a new range in this case.
                if (state.highlightedRange && !isInvalid) {
                    if ((0, $1qrul.isSameDay)(date, state.highlightedRange.start)) {
                        state.setAnchorDate(state.highlightedRange.end);
                        state.setFocusedDate(date);
                        state.setFocused(true);
                        state.setDragging(true);
                        isRangeBoundaryPressed.current = true;
                        return;
                    } else if ((0, $1qrul.isSameDay)(date, state.highlightedRange.end)) {
                        state.setAnchorDate(state.highlightedRange.start);
                        state.setFocusedDate(date);
                        state.setFocused(true);
                        state.setDragging(true);
                        isRangeBoundaryPressed.current = true;
                        return;
                    }
                }
                let startDragging = ()=>{
                    state.setDragging(true);
                    touchDragTimerRef.current = undefined;
                    state.selectDate(date);
                    state.setFocusedDate(date);
                    state.setFocused(true);
                    isAnchorPressed.current = true;
                };
                // Start selection on mouse/touch down so users can drag to select a range.
                // On touch, delay dragging to determine if the user really meant to scroll.
                if (e.pointerType === 'touch') touchDragTimerRef.current = setTimeout(startDragging, 200);
                else startDragging();
            }
        },
        onPressEnd () {
            isRangeBoundaryPressed.current = false;
            isAnchorPressed.current = false;
            clearTimeout(touchDragTimerRef.current);
            touchDragTimerRef.current = undefined;
        },
        onPress () {
            // For non-range selection, always select on press up.
            if (!('anchorDate' in state) && !state.isReadOnly) {
                state.selectDate(date);
                state.setFocusedDate(date);
                state.setFocused(true);
            }
        },
        onPressUp (e) {
            if (state.isReadOnly) return;
            // If the user tapped quickly, the date won't be selected yet and the
            // timer will still be in progress. In this case, select the date on touch up.
            // Timer is cleared in onPressEnd.
            if ('anchorDate' in state && touchDragTimerRef.current) {
                state.selectDate(date);
                state.setFocusedDate(date);
                state.setFocused(true);
            }
            if ('anchorDate' in state) {
                if (isRangeBoundaryPressed.current) // start a new selection on press up to also allow dragging the date to
                // change the existing range.
                state.setAnchorDate(date);
                else if (state.anchorDate && !isAnchorPressed.current) {
                    // When releasing a drag or pressing the end date of a range, select it.
                    state.selectDate(date);
                    state.setFocusedDate(date);
                    state.setFocused(true);
                } else if (e.pointerType === 'keyboard' && !state.anchorDate) {
                    // For range selection, auto-advance the focused date by one if using keyboard.
                    // This gives an indication that you're selecting a range rather than a single date.
                    // For mouse, this is unnecessary because users will see the indication on hover. For screen readers,
                    // there will be an announcement to "click to finish selecting range" (above).
                    state.selectDate(date);
                    state.focusNearestAvailableDate(date);
                } else if (e.pointerType === 'virtual') {
                    // For screen readers, just select the date on click.
                    state.selectDate(date);
                    state.setFocusedDate(date);
                    state.setFocused(true);
                }
            }
        }
    });
    let tabIndex = undefined;
    if (!isDisabled) tabIndex = (0, $1qrul.isSameDay)(date, state.focusedDate) ? 0 : -1;
    (0, $eF4cA.useEffect)(()=>{
        if (isFocused && ref.current) {
            (0, $2jk5s.focusWithoutScrolling)(ref.current);
            // Scroll into view if navigating with a keyboard, otherwise
            // try not to shift the view under the user's mouse/finger.
            // If in a overlay, scrollIntoViewport will only cause scrolling
            // up to the overlay scroll body to prevent overlay shifting.
            // Also only scroll into view if the cell actually got focused.
            // There are some cases where the cell might be disabled or inside,
            // an inert container and we don't want to scroll then.
            if ((0, $YxOvP.getInteractionModality)() !== 'pointer' && (0, $fvyIQ.getActiveElement)() === ref.current) (0, $3lc2m.scrollIntoViewport)(ref.current, {
                containingElement: (0, $5AGOf.getScrollParent)(ref.current)
            });
        }
    }, [
        isFocused,
        ref
    ]);
    let cellDateFormatter = (0, $eZSya.useDateFormatter)({
        day: 'numeric',
        timeZone: state.timeZone,
        calendar: date.calendar.identifier
    });
    let formattedDate = (0, $eF4cA.useMemo)(()=>cellDateFormatter.formatToParts(nativeDate).find((part)=>part.type === 'day').value, [
        cellDateFormatter,
        nativeDate
    ]);
    return {
        cellProps: {
            role: 'gridcell',
            'aria-disabled': !isSelectable || undefined,
            'aria-selected': isSelected || undefined,
            'aria-invalid': isInvalid || undefined
        },
        buttonProps: (0, $lhKAD.mergeProps)(pressProps, {
            onFocus () {
                if (!isDisabled) {
                    state.setFocusedDate(date);
                    state.setFocused(true);
                }
            },
            tabIndex: tabIndex,
            role: 'button',
            'aria-disabled': !isSelectable || undefined,
            'aria-label': label,
            'aria-invalid': isInvalid || undefined,
            'aria-describedby': [
                isInvalid ? errorMessageId : undefined,
                descriptionProps['aria-describedby']
            ].filter(Boolean).join(' ') || undefined,
            onPointerEnter (e) {
                // Highlight the date on hover or drag over a date when selecting a range.
                if ('highlightDate' in state && (e.pointerType !== 'touch' || state.isDragging) && isSelectable) state.highlightDate(date);
            },
            onPointerDown (e) {
                // This is necessary on touch devices to allow dragging
                // outside the original pressed element.
                // (JSDOM does not support this)
                let target = (0, $fvyIQ.getEventTarget)(e);
                if (target instanceof HTMLElement && 'releasePointerCapture' in target) {
                    if ('hasPointerCapture' in target) {
                        if (target.hasPointerCapture(e.pointerId)) target.releasePointerCapture(e.pointerId);
                    } else target.releasePointerCapture(e.pointerId);
                }
            },
            onContextMenu (e) {
                // Prevent context menu on long press.
                e.preventDefault();
            }
        }),
        isPressed: isPressed,
        isFocused: isFocused,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isUnavailable: isUnavailable,
        isOutsideVisibleRange: date.compare(state.visibleRange.start) < 0 || date.compare(state.visibleRange.end) > 0,
        isInvalid: isInvalid,
        formattedDate: formattedDate
    };
}



var $lhKAD = parcelRequire("lhKAD");

var $eZSya = parcelRequire("eZSya");

var $aGDvF = parcelRequire("aGDvF");

var $dkaC0 = parcelRequire("dkaC0");

var $1ntKq = parcelRequire("1ntKq");

var $1qrul = parcelRequire("1qrul");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5042815b51a67641$export$cb95147730a423f5(props, state) {
    let { startDate: startDate = state.visibleRange.start, endDate: endDate = state.visibleRange.end, firstDayOfWeek: firstDayOfWeek } = props;
    let { direction: direction } = (0, $1ntKq.useLocale)();
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            End: ()=>{
                state.focusSectionEnd();
            },
            Home: ()=>{
                state.focusSectionStart();
            },
            Escape: ()=>{
                // Cancel the selection.
                if ('setAnchorDate' in state) state.setAnchorDate(null);
                return false; // TODO: is this really correct? or should it return true when we cancel and only propagate if there's nothing to do
            }
        }
    });
    let { keyboardProps: repeatKeyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            Enter: ()=>{
                state.selectFocusedDate();
            },
            ' ': ()=>{
                state.selectFocusedDate();
            },
            PageUp: ()=>{
                state.focusPreviousSection();
            },
            'Shift+PageUp': ()=>{
                state.focusPreviousSection(true);
            },
            PageDown: ()=>{
                state.focusNextSection();
            },
            'Shift+PageDown': ()=>{
                state.focusNextSection(true);
            },
            ArrowLeft: ()=>{
                if (direction === 'rtl') state.focusNextDay();
                else state.focusPreviousDay();
            },
            ArrowUp: ()=>{
                state.focusPreviousRow();
            },
            ArrowRight: ()=>{
                if (direction === 'rtl') state.focusPreviousDay();
                else state.focusNextDay();
            },
            ArrowDown: ()=>{
                state.focusNextRow();
            }
        },
        allowRepeats: true
    });
    let visibleRangeDescription = (0, $7daf924aef66f353$export$31afe65d91ef6e8)(startDate, endDate, state.timeZone, true);
    let { ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = (0, $7daf924aef66f353$export$653eddfc964b0f8a).get(state);
    let labelProps = (0, $dkaC0.useLabels)({
        'aria-label': [
            ariaLabel,
            visibleRangeDescription
        ].filter(Boolean).join(', '),
        'aria-labelledby': ariaLabelledBy
    });
    let dayFormatter = (0, $eZSya.useDateFormatter)({
        weekday: props.weekdayStyle || 'narrow',
        timeZone: state.timeZone
    });
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let weekDays = (0, $eF4cA.useMemo)(()=>{
        let isDayView = state.visibleDuration.days && state.visibleDuration.days < 7;
        let weekStart = isDayView ? startDate : (0, $1qrul.startOfWeek)((0, $1qrul.today)(state.timeZone), locale, firstDayOfWeek);
        let days = isDayView ? state.visibleDuration.days : 7;
        return [
            ...new Array(days).keys()
        ].map((index)=>{
            let date = weekStart.add({
                days: index
            });
            let dateDay = date.toDate(state.timeZone);
            return dayFormatter.format(dateDay);
        });
    }, [
        locale,
        state.timeZone,
        dayFormatter,
        firstDayOfWeek,
        startDate,
        state.visibleDuration.days
    ]);
    let weeksInMonth = state.getWeeksInMonth(startDate);
    return {
        gridProps: (0, $lhKAD.mergeProps)(labelProps, {
            role: 'grid',
            'aria-readonly': state.isReadOnly || undefined,
            'aria-disabled': state.isDisabled || undefined,
            'aria-multiselectable': 'highlightedRange' in state || state.selectionMode === 'multiple' || undefined,
            onFocus: ()=>state.setFocused(true),
            onBlur: ()=>state.setFocused(false)
        }, keyboardProps, repeatKeyboardProps),
        headerProps: {
            // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
            // The day names are already included in the label of each cell, so there's no need to announce them twice.
            'aria-hidden': true
        },
        weekDays: weekDays,
        weeksInMonth: weeksInMonth
    };
}


var $eZSya = parcelRequire("eZSya");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cfef76f6881c4261$export$72ad8e10aa105341(props, state) {
    let startDate = (0, $eF4cA.useMemo)(()=>{
        let currentMonth = state.visibleRange.start;
        if (props.offset) currentMonth = currentMonth.add(props.offset);
        return currentMonth;
    }, [
        state.visibleRange.start,
        props.offset
    ]);
    let isDays = state.visibleDuration.days || state.visibleDuration.weeks;
    let formatter = (0, $eZSya.useDateFormatter)({
        day: props.format?.day || (isDays ? 'numeric' : undefined),
        month: props.format?.month || 'long',
        year: props.format?.year || 'numeric',
        era: props.format?.era || startDate && startDate.calendar.identifier === 'gregory' && startDate.era === 'BC' ? 'short' : undefined,
        calendar: state.visibleRange?.start.calendar.identifier,
        timeZone: state.timeZone
    });
    return (0, $eF4cA.useMemo)(()=>{
        if (isDays) return formatter.formatRange(startDate.toDate(state.timeZone), state.visibleRange.end.toDate(state.timeZone));
        // Custom calendars like the 4-5-4 fiscal calendar use getFormattableMonth to map
        // their internal month back to the Gregorian month that should be displayed.
        let displayDate = startDate.calendar.getFormattableMonth ? startDate.calendar.getFormattableMonth(startDate) : startDate;
        return formatter.format(displayDate.toDate(state.timeZone));
    }, [
        formatter,
        isDays,
        startDate,
        state.timeZone,
        state.visibleRange.end
    ]);
}


var $eZSya = parcelRequire("eZSya");

var $1ntKq = parcelRequire("1ntKq");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $22a090653636bc46$export$cf412bf5dcbe1065(props, state) {
    let formatter = (0, $eZSya.useDateFormatter)({
        month: props.format || 'short',
        calendar: state.focusedDate.calendar.identifier,
        timeZone: state.timeZone
    });
    // Format the name of each month in the year according to the
    // current locale and calendar system. Note that in some calendar
    // systems, such as the Hebrew, the number of months may differ
    // between years.
    let months = [];
    let numMonths = state.focusedDate.calendar.getMonthsInYear(state.focusedDate);
    for(let i = 1; i <= numMonths; i++){
        let date = state.focusedDate.set({
            month: i
        });
        // Calendars like the 4-5-4 fiscal calendar use getFormattableMonth to map
        // their internal month back to the Gregorian month that should be displayed.
        let displayDate = date.calendar.getFormattableMonth ? date.calendar.getFormattableMonth(date) : date;
        months.push({
            id: i,
            date: date,
            formatted: formatter.format(displayDate.toDate(state.timeZone))
        });
    }
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let ariaLabel = (0, $eF4cA.useMemo)(()=>new Intl.DisplayNames(locale, {
            type: 'dateTimeField'
        }).of('month'), [
        locale
    ]);
    return {
        'aria-label': ariaLabel,
        value: state.focusedDate.month,
        onChange: (key)=>{
            if (key != null) state.setFocusedDate(months[Number(key) - 1].date);
        },
        items: months
    };
}


var $eZSya = parcelRequire("eZSya");

var $1ntKq = parcelRequire("1ntKq");

var $1qrul = parcelRequire("1qrul");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d9a69bad6030b2b3$export$89757cae093b4b95(props, state) {
    let formatter = (0, $eZSya.useDateFormatter)({
        year: props.format?.year || 'numeric',
        era: props.format?.era || (state.focusedDate.calendar.identifier === 'gregory' && state.focusedDate.era === 'BC' ? 'short' : undefined),
        calendar: state.focusedDate.calendar.identifier,
        timeZone: state.timeZone
    });
    // Determine the minimum and maximum date. By default, show an equal number of years on each side of the current year.
    // However, this can be constrained by the calendar's minimum and maximum date.
    let visibleYears = props.visibleYears || 20;
    let minDate = state.focusedDate.subtract({
        years: Math.floor(visibleYears / 2)
    });
    let maxDate = state.focusedDate.add({
        years: Math.ceil(visibleYears / 2) - 1
    });
    if (state.maxValue && maxDate.compare(state.maxValue) > 0) {
        maxDate = (0, $8jDkV.toCalendarDate)(state.maxValue);
        minDate = maxDate.subtract({
            years: visibleYears - 1
        });
    }
    if (state.minValue && minDate.compare(state.minValue) < 0) {
        minDate = (0, $8jDkV.toCalendarDate)(state.minValue);
        maxDate = minDate.add({
            years: visibleYears - 1
        });
        if (state.maxValue && maxDate.compare(state.maxValue) > 0) maxDate = (0, $8jDkV.toCalendarDate)(state.maxValue);
    }
    let years = [];
    let date = minDate;
    let value = 0;
    while(date.compare(maxDate) <= 0 || (0, $1qrul.isSameYear)(date, maxDate)){
        let itemDate = date.compare(maxDate) > 0 ? maxDate : date;
        if ((0, $1qrul.isSameYear)(itemDate, state.focusedDate)) value = years.length;
        years.push({
            // Use the index as the id so we can retrieve the full
            // date object from the list in onChange. We cannot only
            // store the year number, because in some calendars, such
            // as the Japanese, the era may also change.
            id: years.length,
            date: itemDate,
            formatted: formatter.format(itemDate.toDate(state.timeZone))
        });
        date = date.add({
            years: 1
        });
    }
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let ariaLabel = (0, $eF4cA.useMemo)(()=>new Intl.DisplayNames(locale, {
            type: 'dateTimeField'
        }).of('year'), [
        locale
    ]);
    return {
        'aria-label': ariaLabel,
        value: value,
        onChange: (key)=>{
            if (key != null) state.setFocusedDate(years[key].date);
        },
        items: years
    };
}




var $fvyIQ = parcelRequire("fvyIQ");

var $58OnM = parcelRequire("58OnM");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e7fae66e50d3549$export$87e0539f600c24e5(props, state, ref) {
    let { commitBehavior: commitBehavior = 'select', ...otherProps } = props;
    let res = (0, $300e5733f4d7a2d7$export$d652b3ea2d672d5b)(otherProps, state);
    // We need to ignore virtual pointer events from VoiceOver due to these bugs.
    // https://bugs.webkit.org/show_bug.cgi?id=222627
    // https://bugs.webkit.org/show_bug.cgi?id=223202
    // usePress also does this and waits for the following click event before firing.
    // We need to match that here otherwise this will fire before the press event in
    // useCalendarCell, causing range selection to not work properly.
    let isVirtualClick = (0, $eF4cA.useRef)(false);
    let windowRef = (0, $eF4cA.useRef)(typeof window !== 'undefined' ? window : null);
    (0, $58OnM.useEvent)(windowRef, 'pointerdown', (e)=>{
        isVirtualClick.current = e.width === 0 && e.height === 0;
    });
    const commitBehaviorMapping = {
        clear: ()=>state.clearSelection(),
        reset: ()=>state.setAnchorDate(null),
        select: ()=>state.commitSelection()
    };
    // Execute method corresponding to `commitBehavior` when pressing or releasing a pointer outside the calendar body,
    // except when pressing the next or previous buttons to switch months.
    let endDragging = (e)=>{
        if (isVirtualClick.current) {
            isVirtualClick.current = false;
            return;
        }
        state.setDragging(false);
        if (!state.anchorDate) return;
        let target = (0, $fvyIQ.getEventTarget)(e);
        if (ref.current && (0, $fvyIQ.isFocusWithin)(ref.current) && (!(0, $fvyIQ.nodeContains)(ref.current, target) || !target.closest('button, [role="button"]'))) commitBehaviorMapping[commitBehavior]();
    };
    (0, $58OnM.useEvent)(windowRef, 'pointerup', endDragging);
    // Also execute method corresponding to `commitBehavior` on blur,
    // e.g. tabbing away from the calendar.
    // oxlint-disable-next-line react/react-compiler
    res.calendarProps.onBlur = (e)=>{
        if (!ref.current) return;
        if ((!e.relatedTarget || !(0, $fvyIQ.nodeContains)(ref.current, e.relatedTarget)) && state.anchorDate) commitBehaviorMapping[commitBehavior]();
    };
    (0, $58OnM.useEvent)(ref, 'touchmove', (e)=>{
        if (state.isDragging) e.preventDefault();
    }, {
        passive: false,
        capture: true
    });
    return res;
}



var $tKwj1 = parcelRequire("tKwj1");

var $1k26k = parcelRequire("1k26k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $21f302e1483e7b9d$var$$63d4eafd4d826996$var$BUDDHIST_ERA_START = -543;
class $21f302e1483e7b9d$export$42d20a78301dee44 extends (0, $1k26k.GregorianCalendar) {
    fromJulianDay(jd) {
        let gregorianDate = super.fromJulianDay(jd);
        let year = (0, $1k26k.getExtendedYear)(gregorianDate.era, gregorianDate.year);
        return new (0, $tKwj1.CalendarDate)(this, year - $21f302e1483e7b9d$var$$63d4eafd4d826996$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($21f302e1483e7b9d$var$$63d4eafd4d826996$var$toGregorian(date));
    }
    getEras() {
        return [
            'BE'
        ];
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($21f302e1483e7b9d$var$$63d4eafd4d826996$var$toGregorian(date));
    }
    balanceDate() {}
    constructor(...args){
        super(...args), this.identifier = 'buddhist';
    }
}
function $21f302e1483e7b9d$var$$63d4eafd4d826996$var$toGregorian(date) {
    let [era, year] = (0, $1k26k.fromExtendedYear)(date.year + $21f302e1483e7b9d$var$$63d4eafd4d826996$var$BUDDHIST_ERA_START);
    return new (0, $tKwj1.CalendarDate)(era, year, date.month, date.day);
}



var $tKwj1 = parcelRequire("tKwj1");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ETHIOPIC_EPOCH = 1723856;
const $a113713dcaeafa5e$var$$97cfca9efd59523d$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
const $a113713dcaeafa5e$var$$97cfca9efd59523d$var$AMETE_MIHRET_DELTA = 5500;
function $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ceToJulianDay(epoch, year, month, day) {
    return epoch + // difference from Julian epoch to 1,1,1
    365 * year + // number of days from years
    Math.floor(year / 4) + // extra day of leap year
    30 * (month - 1) + // number of days from months (1 based)
    day - 1 // number of days for present month (1 based)
    ;
}
function $a113713dcaeafa5e$var$$97cfca9efd59523d$var$julianDayToCE(epoch, jd) {
    let year = Math.floor(4 * (jd - epoch) / 1461);
    // Years are 365 * year + floor(year / 4) days long, slightly less than the
    // 365.25 day average assumed by the estimate above. As a result, the estimate
    // can be one year too low on the first day of a year (3 of every 4 years).
    if (jd >= $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ceToJulianDay(epoch, year + 1, 1, 1)) year++;
    let month = 1 + Math.floor((jd - $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    let day = jd + 1 - $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function $a113713dcaeafa5e$var$$97cfca9efd59523d$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $a113713dcaeafa5e$var$$97cfca9efd59523d$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $a113713dcaeafa5e$var$$97cfca9efd59523d$var$getLeapDay(year) + 5;
}
class $a113713dcaeafa5e$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $a113713dcaeafa5e$var$$97cfca9efd59523d$var$julianDayToCE($a113713dcaeafa5e$var$$97cfca9efd59523d$var$ETHIOPIC_EPOCH, jd);
        let era = 'AM';
        if (year <= 0) {
            era = 'AA';
            year += $a113713dcaeafa5e$var$$97cfca9efd59523d$var$AMETE_MIHRET_DELTA;
        }
        return new (0, $tKwj1.CalendarDate)(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === 'AA') year -= $a113713dcaeafa5e$var$$97cfca9efd59523d$var$AMETE_MIHRET_DELTA;
        return $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ceToJulianDay($a113713dcaeafa5e$var$$97cfca9efd59523d$var$ETHIOPIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $a113713dcaeafa5e$var$$97cfca9efd59523d$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear() {
        return 13;
    }
    getDaysInYear(date) {
        return 365 + $a113713dcaeafa5e$var$$97cfca9efd59523d$var$getLeapDay(date.year);
    }
    getMaximumMonthsInYear() {
        return 13;
    }
    getMaximumDaysInMonth() {
        return 30;
    }
    getYearsInEra(date) {
        // 9999-12-31 gregorian is 9992-20-02 ethiopic.
        // Round down to 9991 for the last full year.
        // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
        return date.era === 'AA' ? 9999 : 9991;
    }
    getEras() {
        return [
            'AA',
            'AM'
        ];
    }
    constructor(){
        this.identifier = 'ethiopic';
    }
}
class $a113713dcaeafa5e$export$d72e0c37005a4914 extends $a113713dcaeafa5e$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $a113713dcaeafa5e$var$$97cfca9efd59523d$var$julianDayToCE($a113713dcaeafa5e$var$$97cfca9efd59523d$var$ETHIOPIC_EPOCH, jd);
        year += $a113713dcaeafa5e$var$$97cfca9efd59523d$var$AMETE_MIHRET_DELTA;
        return new (0, $tKwj1.CalendarDate)(this, 'AA', year, month, day);
    }
    getEras() {
        return [
            'AA'
        ];
    }
    getYearsInEra() {
        // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
        return 9999;
    }
    constructor(...args){
        super(...args), this.identifier = 'ethioaa' // also known as 'ethiopic-amete-alem' in ICU
        ;
    }
}
class $a113713dcaeafa5e$export$fe6243cbe1a4b7c1 extends $a113713dcaeafa5e$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $a113713dcaeafa5e$var$$97cfca9efd59523d$var$julianDayToCE($a113713dcaeafa5e$var$$97cfca9efd59523d$var$COPTIC_EPOCH, jd);
        let era = 'CE';
        if (year <= 0) {
            era = 'BCE';
            year = 1 - year;
        }
        return new (0, $tKwj1.CalendarDate)(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === 'BCE') year = 1 - year;
        return $a113713dcaeafa5e$var$$97cfca9efd59523d$var$ceToJulianDay($a113713dcaeafa5e$var$$97cfca9efd59523d$var$COPTIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === 'BCE') year = 1 - year;
        return $a113713dcaeafa5e$var$$97cfca9efd59523d$var$getDaysInMonth(year, date.month);
    }
    isInverseEra(date) {
        return date.era === 'BCE';
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === 'BCE' ? 'CE' : 'BCE';
            date.year = 1 - date.year;
        }
    }
    getEras() {
        return [
            'BCE',
            'CE'
        ];
    }
    getYearsInEra(date) {
        // 9999-12-30 gregorian is 9716-02-20 coptic.
        // Round down to 9715 for the last full year.
        // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
        return date.era === 'BCE' ? 9999 : 9715;
    }
    constructor(...args){
        super(...args), this.identifier = 'coptic';
    }
}



var $1k26k = parcelRequire("1k26k");

var $tKwj1 = parcelRequire("tKwj1");

var $execq = parcelRequire("execq");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $b654eb225c804bd8$var$$f39495b96f9dbac6$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
const $b654eb225c804bd8$var$$f39495b96f9dbac6$var$HOUR_PARTS = 1080;
const $b654eb225c804bd8$var$$f39495b96f9dbac6$var$DAY_PARTS = 24 * $b654eb225c804bd8$var$$f39495b96f9dbac6$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
const $b654eb225c804bd8$var$$f39495b96f9dbac6$var$MONTH_DAYS = 29;
const $b654eb225c804bd8$var$$f39495b96f9dbac6$var$MONTH_FRACT = 12 * $b654eb225c804bd8$var$$f39495b96f9dbac6$var$HOUR_PARTS + 793;
const $b654eb225c804bd8$var$$f39495b96f9dbac6$var$MONTH_PARTS = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$MONTH_DAYS * $b654eb225c804bd8$var$$f39495b96f9dbac6$var$DAY_PARTS + $b654eb225c804bd8$var$$f39495b96f9dbac6$var$MONTH_FRACT;
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(year) {
    return (0, $execq.mod)(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay1(year) {
    let months = Math.floor((235 * year - 234) / 19);
    let parts = 12084 + 13753 * months;
    let day = months * 29 + Math.floor(parts / 25920);
    if ((0, $execq.mod)(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay2(year) {
    let last = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay1(year - 1);
    let present = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay1(year);
    let next = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$startOfYear(year) {
    return $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay1(year) + $b654eb225c804bd8$var$$f39495b96f9dbac6$var$hebrewDelay2(year);
}
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInYear(year) {
    return $b654eb225c804bd8$var$$f39495b96f9dbac6$var$startOfYear(year + 1) - $b654eb225c804bd8$var$$f39495b96f9dbac6$var$startOfYear(year);
}
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getYearType(year) {
    let yearLength = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    let yearType = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
class $b654eb225c804bd8$export$ca405048b8fb5af {
    fromJulianDay(jd) {
        let d = jd - $b654eb225c804bd8$var$$f39495b96f9dbac6$var$HEBREW_EPOCH;
        let m = d * $b654eb225c804bd8$var$$f39495b96f9dbac6$var$DAY_PARTS / $b654eb225c804bd8$var$$f39495b96f9dbac6$var$MONTH_PARTS; // Months (approx)
        let year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
        let ys = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$startOfYear(year); // 1st day of year
        let dayOfYear = Math.floor(d - ys);
        // Because of the postponement rules, it's possible to guess wrong.  Fix it.
        while(dayOfYear < 1){
            year--;
            ys = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$startOfYear(year);
            dayOfYear = Math.floor(d - ys);
        }
        // Now figure out which month we're in, and the date within that month
        let month = 1;
        let monthStart = 0;
        while(monthStart < dayOfYear){
            monthStart += $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInMonth(year, month);
            month++;
        }
        month--;
        monthStart -= $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInMonth(year, month);
        let day = dayOfYear - monthStart;
        return new (0, $tKwj1.CalendarDate)(this, year, month, day);
    }
    toJulianDay(date) {
        let jd = $b654eb225c804bd8$var$$f39495b96f9dbac6$var$startOfYear(date.year);
        for(let month = 1; month < date.month; month++)jd += $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInMonth(date.year, month);
        return jd + date.day + $b654eb225c804bd8$var$$f39495b96f9dbac6$var$HEBREW_EPOCH;
    }
    getDaysInMonth(date) {
        return $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear(date) {
        return $b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(date.year) ? 13 : 12;
    }
    getDaysInYear(date) {
        return $b654eb225c804bd8$var$$f39495b96f9dbac6$var$getDaysInYear(date.year);
    }
    getMaximumMonthsInYear() {
        return 13;
    }
    getMaximumDaysInMonth() {
        return 30;
    }
    getYearsInEra() {
        // 6239 gregorian
        return 9999;
    }
    getEras() {
        return [
            'AM'
        ];
    }
    balanceYearMonth(date, previousDate) {
        // Keep date in the same month when switching between leap years and non leap years
        if (previousDate.year !== date.year) {
            if ($b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(previousDate.year) && !$b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
            else if (!$b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(previousDate.year) && $b654eb225c804bd8$var$$f39495b96f9dbac6$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
        }
    }
    constructor(){
        this.identifier = 'hebrew';
    }
}



var $tKwj1 = parcelRequire("tKwj1");

var $1k26k = parcelRequire("1k26k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
// Starts in 78 AD,
const $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
const $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_YEAR_START = 80;
class $df36416836289ade$export$39f31c639fa15726 extends (0, $1k26k.GregorianCalendar) {
    fromJulianDay(jd) {
        // Gregorian date for Julian day
        let date = super.fromJulianDay(jd);
        // Year in Saka era
        let indianYear = date.year - $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_ERA_START;
        // Day number in Gregorian year (starting from 0)
        let yDay = jd - (0, $1k26k.gregorianToJulianDay)(date.era, date.year, 1, 1);
        let leapMonth;
        if (yDay < $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_YEAR_START) {
            //  Day is at the end of the preceding Saka year
            indianYear--;
            // Days in leapMonth this year, previous Gregorian year
            leapMonth = (0, $1k26k.isLeapYear)(date.year - 1) ? 31 : 30;
            yDay += leapMonth + 155 + 90 + 10;
        } else {
            // Days in leapMonth this year
            leapMonth = (0, $1k26k.isLeapYear)(date.year) ? 31 : 30;
            yDay -= $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_YEAR_START;
        }
        let indianMonth;
        let indianDay;
        if (yDay < leapMonth) {
            indianMonth = 1;
            indianDay = yDay + 1;
        } else {
            let mDay = yDay - leapMonth;
            if (mDay < 155) {
                indianMonth = Math.floor(mDay / 31) + 2;
                indianDay = mDay % 31 + 1;
            } else {
                mDay -= 155;
                indianMonth = Math.floor(mDay / 30) + 7;
                indianDay = mDay % 30 + 1;
            }
        }
        return new (0, $tKwj1.CalendarDate)(this, indianYear, indianMonth, indianDay);
    }
    toJulianDay(date) {
        let extendedYear = date.year + $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_ERA_START;
        let [era, year] = (0, $1k26k.fromExtendedYear)(extendedYear);
        let leapMonth;
        let jd;
        if ((0, $1k26k.isLeapYear)(year)) {
            leapMonth = 31;
            jd = (0, $1k26k.gregorianToJulianDay)(era, year, 3, 21);
        } else {
            leapMonth = 30;
            jd = (0, $1k26k.gregorianToJulianDay)(era, year, 3, 22);
        }
        if (date.month === 1) return jd + date.day - 1;
        jd += leapMonth + Math.min(date.month - 2, 5) * 31;
        if (date.month >= 8) jd += (date.month - 7) * 30;
        jd += date.day - 1;
        return jd;
    }
    getDaysInMonth(date) {
        if (date.month === 1 && (0, $1k26k.isLeapYear)(date.year + $df36416836289ade$var$$11fa67a177e45470$var$INDIAN_ERA_START)) return 31;
        if (date.month >= 2 && date.month <= 6) return 31;
        return 30;
    }
    getYearsInEra() {
        // 9999-12-31 gregorian is 9920-10-10 indian.
        // Round down to 9919 for the last full year.
        return 9919;
    }
    getEras() {
        return [
            'saka'
        ];
    }
    balanceDate() {}
    constructor(...args){
        super(...args), this.identifier = 'indian';
    }
}



var $tKwj1 = parcelRequire("tKwj1");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
const $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
const $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START = 1300;
const $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END = 1600;
const $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_START_DAYS = 460322;
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$julianDayToIslamic(calendar, epoch, jd) {
    let year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    let month = Math.min(12, Math.ceil((jd - (29 + $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    let day = jd - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new (0, $tKwj1.CalendarDate)(calendar, year, month, day);
}
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
class $6647524f562a85c6$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$julianDayToIslamic(this, $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$CIVIL_EPOC, jd);
    }
    toJulianDay(date) {
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$islamicToJulianDay($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let length = 29 + date.month % 2;
        if (date.month === 12 && $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$isLeapYear(date.year)) length++;
        return length;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInYear(date) {
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$isLeapYear(date.year) ? 355 : 354;
    }
    getMaximumMonthsInYear() {
        return 12;
    }
    getMaximumDaysInMonth() {
        return 30;
    }
    getYearsInEra() {
        // 9999 gregorian
        return 9665;
    }
    getEras() {
        return [
            'AH'
        ];
    }
    constructor(){
        this.identifier = 'islamic-civil';
    }
}
class $6647524f562a85c6$export$37f0887f2f9d22f7 extends $6647524f562a85c6$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$julianDayToIslamic(this, $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$ASTRONOMICAL_EPOC, jd);
    }
    toJulianDay(date) {
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$islamicToJulianDay($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
    constructor(...args){
        super(...args), this.identifier = 'islamic-tbla';
    }
}
// Generated by scripts/generate-umalqura.js
const $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_DATA = 'qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=';
let $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_MONTHLENGTH;
let $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE;
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearStart(year) {
    return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_START_DAYS + $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE[year - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START];
}
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthLength(year, month) {
    let idx = year - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START;
    let mask = 0x01 << 11 - (month - 1);
    if (($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthStart(year, month) {
    let day = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearStart(year);
    for(let i = 1; i < month; i++)day += $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthLength(year, i);
    return day;
}
function $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearLength(year) {
    return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE[year + 1 - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START] - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE[year - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START];
}
class $6647524f562a85c6$export$5baab4758c231076 extends $6647524f562a85c6$export$2066795aadd37bfc {
    constructor(){
        super(), this.identifier = 'islamic-umalqura';
        if (!$6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_MONTHLENGTH) $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_DATA), (c)=>c.charCodeAt(0)).buffer);
        if (!$6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE) {
            $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START + 1);
            let yearStart = 0;
            for(let year = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START; year <= $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END; year++){
                $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START_TABLE[year - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START] = yearStart;
                for(let i = 1; i <= 12; i++)yearStart += $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthLength(year, i);
            }
        }
    }
    fromJulianDay(jd) {
        let days = jd - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$CIVIL_EPOC;
        let startDays = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearStart($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START);
        let endDays = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearStart($6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END);
        if (days < startDays || days > endDays) return super.fromJulianDay(jd);
        else {
            let y = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START - 1;
            let m = 1;
            let d = 1;
            while(d > 0){
                y++;
                d = days - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearStart(y) + 1;
                let yearLength = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearLength(y);
                if (d === yearLength) {
                    m = 12;
                    break;
                } else if (d < yearLength) {
                    let monthLength = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthLength(y, m);
                    m = 1;
                    while(d > monthLength){
                        d -= monthLength;
                        m++;
                        monthLength = $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthLength(y, m);
                    }
                    break;
                }
            }
            return new (0, $tKwj1.CalendarDate)(this, y, m, days - $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthStart(y, m) + 1);
        }
    }
    toJulianDay(date) {
        if (date.year < $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START || date.year > $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END) return super.toJulianDay(date);
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$CIVIL_EPOC + $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
    getDaysInMonth(date) {
        if (date.year < $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START || date.year > $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END) return super.getDaysInMonth(date);
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraMonthLength(date.year, date.month);
    }
    getDaysInYear(date) {
        if (date.year < $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_START || date.year > $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$UMALQURA_YEAR_END) return super.getDaysInYear(date);
        return $6647524f562a85c6$var$$fd4f9bc1ba0e49a8$var$umalquraYearLength(date.year);
    }
}



var $tKwj1 = parcelRequire("tKwj1");

var $1k26k = parcelRequire("1k26k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
const $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
const $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
const $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES = [
    'meiji',
    'taisho',
    'showa',
    'heisei',
    'reiwa'
];
function $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$findEraFromGregorianDate(date) {
    const idx = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES.findIndex(([year, month, day])=>{
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$toGregorian(date) {
    let eraAddend = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_ADDENDS[$c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error('Unknown era: ' + date.era);
    return new (0, $tKwj1.CalendarDate)(date.year + eraAddend, date.month, date.day);
}
class $c1d1e57dcebfb33d$export$b746ab2b60cdffbf extends (0, $1k26k.GregorianCalendar) {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let era = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$findEraFromGregorianDate(date);
        return new (0, $tKwj1.CalendarDate)(this, $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES[era], date.year - $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_ADDENDS[era], date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($c1d1e57dcebfb33d$var$$34b940b49ba042df$var$toGregorian(date));
    }
    balanceDate(date) {
        let gregorianDate = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$toGregorian(date);
        let era = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$findEraFromGregorianDate(gregorianDate);
        if ($c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES[era] !== date.era) {
            date.era = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES[era];
            date.year = gregorianDate.year - $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_ADDENDS[era];
        }
        // Constrain in case we went before the first supported era.
        this.constrainDate(date);
    }
    constrainDate(date) {
        let idx = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES.indexOf(date.era);
        let end = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_END_DATES[idx];
        if (end != null) {
            let [endYear, endMonth, endDay] = end;
            // Constrain the year to the maximum possible value in the era.
            // Then constrain the month and day fields within that.
            let maxYear = endYear - $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_ADDENDS[idx];
            date.year = Math.max(1, Math.min(maxYear, date.year));
            if (date.year === maxYear) {
                date.month = Math.min(endMonth, date.month);
                if (date.month === endMonth) date.day = Math.min(endDay, date.day);
            }
        }
        if (date.year === 1 && idx >= 0) {
            let [, startMonth, startDay] = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES[idx];
            date.month = Math.max(startMonth, date.month);
            if (date.month === startMonth) date.day = Math.max(startDay, date.day);
        }
    }
    getEras() {
        return $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES;
    }
    getYearsInEra(date) {
        // Get the number of years in the era, taking into account the date's month and day fields.
        let era = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES.indexOf(date.era);
        let cur = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES[era];
        let next = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES[era + 1];
        if (next == null) return 9999 - cur[0] + 1;
        let years = next[0] - cur[0];
        if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
        return years;
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($c1d1e57dcebfb33d$var$$34b940b49ba042df$var$toGregorian(date));
    }
    getMinimumMonthInYear(date) {
        let start = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$getMinimums(date);
        return start ? start[1] : 1;
    }
    getMinimumDayInMonth(date) {
        let start = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$getMinimums(date);
        return start && date.month === start[1] ? start[2] : 1;
    }
    constructor(...args){
        super(...args), this.identifier = 'japanese';
    }
}
function $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$getMinimums(date) {
    if (date.year === 1) {
        let idx = $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_NAMES.indexOf(date.era);
        return $c1d1e57dcebfb33d$var$$34b940b49ba042df$var$ERA_START_DATES[idx];
    }
}



var $tKwj1 = parcelRequire("tKwj1");

var $execq = parcelRequire("execq");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $a50f34fa734b32e5$var$$a0cc0739a536c3b1$var$PERSIAN_EPOCH = 1948320;
// Number of days from the start of the year to the start of each month.
const $a50f34fa734b32e5$var$$a0cc0739a536c3b1$var$MONTH_START = [
    0,
    31,
    62,
    93,
    124,
    155,
    186,
    216,
    246,
    276,
    306,
    336 // Esfand
];
class $a50f34fa734b32e5$export$37fccdbfd14c5939 {
    fromJulianDay(jd) {
        let daysSinceEpoch = jd - $a50f34fa734b32e5$var$$a0cc0739a536c3b1$var$PERSIAN_EPOCH;
        let year = 1 + Math.floor((33 * daysSinceEpoch + 3) / 12053);
        let farvardin1 = 365 * (year - 1) + Math.floor((8 * year + 21) / 33);
        let dayOfYear = daysSinceEpoch - farvardin1;
        let month = dayOfYear < 216 ? Math.floor(dayOfYear / 31) : Math.floor((dayOfYear - 6) / 30);
        let day = dayOfYear - $a50f34fa734b32e5$var$$a0cc0739a536c3b1$var$MONTH_START[month] + 1;
        return new (0, $tKwj1.CalendarDate)(this, year, month + 1, day);
    }
    toJulianDay(date) {
        let jd = $a50f34fa734b32e5$var$$a0cc0739a536c3b1$var$PERSIAN_EPOCH - 1 + 365 * (date.year - 1) + Math.floor((8 * date.year + 21) / 33);
        jd += $a50f34fa734b32e5$var$$a0cc0739a536c3b1$var$MONTH_START[date.month - 1];
        jd += date.day;
        return jd;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInMonth(date) {
        if (date.month <= 6) return 31;
        if (date.month <= 11) return 30;
        let isLeapYear = (0, $execq.mod)(25 * date.year + 11, 33) < 8;
        return isLeapYear ? 30 : 29;
    }
    getMaximumMonthsInYear() {
        return 12;
    }
    getMaximumDaysInMonth() {
        return 31;
    }
    getEras() {
        return [
            'AP'
        ];
    }
    getYearsInEra() {
        // 9378-10-10 persian is 9999-12-31 gregorian.
        // Round down to 9377 to set the maximum full year.
        return 9377;
    }
    constructor(){
        this.identifier = 'persian';
    }
}



var $tKwj1 = parcelRequire("tKwj1");

var $1k26k = parcelRequire("1k26k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $745cbd53a5fe3f79$var$$c009cc5f64923054$var$TAIWAN_ERA_START = 1911;
function $745cbd53a5fe3f79$var$$c009cc5f64923054$var$gregorianYear(date) {
    return date.era === 'minguo' ? date.year + $745cbd53a5fe3f79$var$$c009cc5f64923054$var$TAIWAN_ERA_START : 1 - date.year + $745cbd53a5fe3f79$var$$c009cc5f64923054$var$TAIWAN_ERA_START;
}
function $745cbd53a5fe3f79$var$$c009cc5f64923054$var$gregorianToTaiwan(year) {
    let y = year - $745cbd53a5fe3f79$var$$c009cc5f64923054$var$TAIWAN_ERA_START;
    if (y > 0) return [
        'minguo',
        y
    ];
    else return [
        'before_minguo',
        1 - y
    ];
}
class $745cbd53a5fe3f79$export$65e01080afcb0799 extends (0, $1k26k.GregorianCalendar) {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let extendedYear = (0, $1k26k.getExtendedYear)(date.era, date.year);
        let [era, year] = $745cbd53a5fe3f79$var$$c009cc5f64923054$var$gregorianToTaiwan(extendedYear);
        return new (0, $tKwj1.CalendarDate)(this, era, year, date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($745cbd53a5fe3f79$var$$c009cc5f64923054$var$toGregorian(date));
    }
    getEras() {
        return [
            'before_minguo',
            'minguo'
        ];
    }
    balanceDate(date) {
        let [era, year] = $745cbd53a5fe3f79$var$$c009cc5f64923054$var$gregorianToTaiwan($745cbd53a5fe3f79$var$$c009cc5f64923054$var$gregorianYear(date));
        date.era = era;
        date.year = year;
    }
    isInverseEra(date) {
        return date.era === 'before_minguo';
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($745cbd53a5fe3f79$var$$c009cc5f64923054$var$toGregorian(date));
    }
    getYearsInEra(date) {
        return date.era === 'before_minguo' ? 9999 : 9999 - $745cbd53a5fe3f79$var$$c009cc5f64923054$var$TAIWAN_ERA_START;
    }
    constructor(...args){
        super(...args), this.identifier = 'roc' // Republic of China
        ;
    }
}
function $745cbd53a5fe3f79$var$$c009cc5f64923054$var$toGregorian(date) {
    let [era, year] = (0, $1k26k.fromExtendedYear)($745cbd53a5fe3f79$var$$c009cc5f64923054$var$gregorianYear(date));
    return new (0, $tKwj1.CalendarDate)(era, year, date.month, date.day);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3a199efecdda72a1$export$dd0bbc9b26defe37(name) {
    switch(name){
        case 'buddhist':
            return new (0, $21f302e1483e7b9d$export$42d20a78301dee44)();
        case 'ethiopic':
            return new (0, $a113713dcaeafa5e$export$26ba6eab5e20cd7d)();
        case 'ethioaa':
            return new (0, $a113713dcaeafa5e$export$d72e0c37005a4914)();
        case 'coptic':
            return new (0, $a113713dcaeafa5e$export$fe6243cbe1a4b7c1)();
        case 'hebrew':
            return new (0, $b654eb225c804bd8$export$ca405048b8fb5af)();
        case 'indian':
            return new (0, $df36416836289ade$export$39f31c639fa15726)();
        case 'islamic-civil':
            return new (0, $6647524f562a85c6$export$2066795aadd37bfc)();
        case 'islamic-tbla':
            return new (0, $6647524f562a85c6$export$37f0887f2f9d22f7)();
        case 'islamic-umalqura':
            return new (0, $6647524f562a85c6$export$5baab4758c231076)();
        case 'japanese':
            return new (0, $c1d1e57dcebfb33d$export$b746ab2b60cdffbf)();
        case 'persian':
            return new (0, $a50f34fa734b32e5$export$37fccdbfd14c5939)();
        case 'roc':
            return new (0, $745cbd53a5fe3f79$export$65e01080afcb0799)();
        case 'gregory':
        default:
            return new (0, $1k26k.GregorianCalendar)();
    }
}


var $1qrul = parcelRequire("1qrul");

var $1qrul = parcelRequire("1qrul");
var $8jDkV = parcelRequire("8jDkV");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fdf4691d7b2848cb$export$eac50920cf2fd59a(date, minValue, maxValue) {
    return minValue != null && date.compare(minValue) < 0 || maxValue != null && date.compare(maxValue) > 0;
}
function $fdf4691d7b2848cb$export$f4a51ff076cc9a09(date, duration, locale, minValue, maxValue) {
    let halfDuration = {};
    for(let key in duration){
        halfDuration[key] = Math.floor(duration[key] / 2);
        if (halfDuration[key] > 0 && duration[key] % 2 === 0) halfDuration[key]--;
    }
    let aligned = $fdf4691d7b2848cb$export$144a00ba6044eb9(date, duration, locale).subtract(halfDuration);
    return $fdf4691d7b2848cb$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue);
}
function $fdf4691d7b2848cb$export$144a00ba6044eb9(date, duration, locale, minValue, maxValue) {
    // align to the start of the largest unit
    let aligned = date;
    if (duration.years) aligned = (0, $1qrul.startOfYear)(date);
    else if (duration.months) aligned = (0, $1qrul.startOfMonth)(date);
    else if (duration.weeks || duration.days && duration.days > 7) aligned = (0, $1qrul.startOfWeek)(date, locale);
    return $fdf4691d7b2848cb$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue);
}
function $fdf4691d7b2848cb$export$530edbfc915b2b04(date, duration, locale, minValue, maxValue) {
    let d = {
        ...duration
    };
    // subtract 1 from the smallest unit
    if (d.days) d.days--;
    else if (d.weeks) d.weeks--;
    else if (d.months) d.months--;
    else if (d.years) d.years--;
    let aligned = $fdf4691d7b2848cb$export$144a00ba6044eb9(date, duration, locale).subtract(d);
    return $fdf4691d7b2848cb$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue);
}
function $fdf4691d7b2848cb$export$5bb865b12696a77d(date, aligned, duration, locale, minValue, maxValue) {
    if (minValue && date.compare(minValue) >= 0) {
        let newDate = (0, $1qrul.maxDate)(aligned, $fdf4691d7b2848cb$export$144a00ba6044eb9((0, $8jDkV.toCalendarDate)(minValue), duration, locale));
        if (newDate) aligned = newDate;
    }
    if (maxValue && date.compare(maxValue) <= 0) {
        let newDate = (0, $1qrul.minDate)(aligned, $fdf4691d7b2848cb$export$530edbfc915b2b04((0, $8jDkV.toCalendarDate)(maxValue), duration, locale));
        if (newDate) aligned = newDate;
    }
    return aligned;
}
function $fdf4691d7b2848cb$export$4f5203c0d889109e(date, minValue, maxValue) {
    if (minValue) {
        let newDate = (0, $1qrul.maxDate)(date, (0, $8jDkV.toCalendarDate)(minValue));
        if (newDate) date = newDate;
    }
    if (maxValue) {
        let newDate = (0, $1qrul.minDate)(date, (0, $8jDkV.toCalendarDate)(maxValue));
        if (newDate) date = newDate;
    }
    return date;
}
function $fdf4691d7b2848cb$export$a1d3911297b952d7(date, minValue, isDateUnavailable) {
    if (!isDateUnavailable) return date;
    while(date.compare(minValue) >= 0 && isDateUnavailable(date))date = date.subtract({
        days: 1
    });
    if (date.compare(minValue) >= 0) return date;
    return null;
}
function $fdf4691d7b2848cb$export$6595e603c409b4b8(a, b) {
    if (a === b) return true;
    return a.days === b.days && a.weeks === b.weeks && a.months === b.months && a.years === b.years;
}




var $iUErx = parcelRequire("iUErx");

var $MHwAo = parcelRequire("MHwAo");
var $1qrul = parcelRequire("1qrul");
var $1k26k = parcelRequire("1k26k");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6488e56da5e0e3cf$export$6d095e787d2b5e1f(props) {
    let defaultFormatter = (0, $eF4cA.useMemo)(()=>new (0, $MHwAo.DateFormatter)(props.locale), [
        props.locale
    ]);
    let resolvedOptions = (0, $eF4cA.useMemo)(()=>defaultFormatter.resolvedOptions(), [
        defaultFormatter
    ]);
    let { locale: locale, createCalendar: createCalendar, visibleDuration: visibleDuration = {
        months: 1
    }, minValue: minValue, maxValue: maxValue, selectionAlignment: selectionAlignment, isDateUnavailable: isDateUnavailable, pageBehavior: pageBehavior = 'visible', selectionMode: selectionMode = 'single', firstDayOfWeek: firstDayOfWeek, weeksInMonth: weeksInMonth } = props;
    let calendar = (0, $eF4cA.useMemo)(()=>createCalendar(resolvedOptions.calendar), [
        createCalendar,
        resolvedOptions.calendar
    ]);
    let [value, setControlledValue] = (0, $iUErx.useControlledState)(props.value, props.defaultValue ?? null, props.onChange);
    let calendarDateValue = (0, $eF4cA.useMemo)(()=>{
        if (Array.isArray(value)) return value.map((value)=>(0, $8jDkV.toCalendar)((0, $8jDkV.toCalendarDate)(value), calendar));
        else return value ? (0, $8jDkV.toCalendar)((0, $8jDkV.toCalendarDate)(value), calendar) : null;
    }, [
        value,
        calendar
    ]);
    let timeZone = (0, $eF4cA.useMemo)(()=>{
        let val = Array.isArray(value) ? value[0] : value;
        return val && 'timeZone' in val ? val.timeZone : resolvedOptions.timeZone;
    }, [
        value,
        resolvedOptions.timeZone
    ]);
    let focusedCalendarDate = (0, $eF4cA.useMemo)(()=>props.focusedValue ? (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)((0, $8jDkV.toCalendar)((0, $8jDkV.toCalendarDate)(props.focusedValue), calendar), minValue, maxValue) : undefined, [
        props.focusedValue,
        calendar,
        minValue,
        maxValue
    ]);
    let defaultFocusedCalendarDate = (0, $eF4cA.useMemo)(()=>{
        if (props.defaultFocusedValue) return (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)((0, $8jDkV.toCalendar)((0, $8jDkV.toCalendarDate)(props.defaultFocusedValue), calendar), minValue, maxValue);
        if (calendarDateValue) return (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(Array.isArray(calendarDateValue) ? calendarDateValue[0] : calendarDateValue, minValue, maxValue);
        return (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)((0, $8jDkV.toCalendar)((0, $1qrul.today)(timeZone), calendar), minValue, maxValue);
    }, [
        props.defaultFocusedValue,
        calendarDateValue,
        timeZone,
        calendar,
        minValue,
        maxValue
    ]);
    let [focusedDate, setFocusedDate] = (0, $iUErx.useControlledState)(focusedCalendarDate, defaultFocusedCalendarDate, props.onFocusChange);
    let getStartDate = ()=>{
        switch(selectionAlignment){
            case 'start':
                return (0, $fdf4691d7b2848cb$export$144a00ba6044eb9)(focusedDate, visibleDuration, locale, minValue, maxValue);
            case 'end':
                return (0, $fdf4691d7b2848cb$export$530edbfc915b2b04)(focusedDate, visibleDuration, locale, minValue, maxValue);
            case 'center':
            default:
                return (0, $fdf4691d7b2848cb$export$f4a51ff076cc9a09)(focusedDate, visibleDuration, locale, minValue, maxValue);
        }
    };
    let [startDate, setStartDate] = (0, $eF4cA.useState)(getStartDate);
    let [isFocused, setFocused] = (0, $eF4cA.useState)(props.autoFocus || false);
    let [lastVisibleDuration, setLastVisibleDuration] = (0, $eF4cA.useState)(visibleDuration);
    if (!(0, $fdf4691d7b2848cb$export$6595e603c409b4b8)(visibleDuration, lastVisibleDuration)) {
        setLastVisibleDuration(visibleDuration);
        setStartDate(getStartDate());
    }
    let endDate = (0, $eF4cA.useMemo)(()=>{
        let duration = {
            ...visibleDuration
        };
        if (duration.days) duration.days--;
        else duration.days = -1;
        return startDate.add(duration);
    }, [
        startDate,
        visibleDuration
    ]);
    // Reset focused date and visible range when calendar changes.
    let [lastCalendar, setLastCalendar] = (0, $eF4cA.useState)(calendar);
    if (!(0, $1qrul.isEqualCalendar)(calendar, lastCalendar)) {
        let newFocusedDate = (0, $8jDkV.toCalendar)(focusedDate, calendar);
        setStartDate((0, $fdf4691d7b2848cb$export$f4a51ff076cc9a09)(newFocusedDate, visibleDuration, locale, minValue, maxValue));
        setFocusedDate(newFocusedDate);
        setLastCalendar(calendar);
    }
    if ((0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(focusedDate, minValue, maxValue)) setFocusedDate((0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(focusedDate, minValue, maxValue));
    else if (focusedDate.compare(startDate) < 0) setStartDate((0, $fdf4691d7b2848cb$export$530edbfc915b2b04)(focusedDate, visibleDuration, locale, minValue, maxValue));
    else if (focusedDate.compare(endDate) > 0) setStartDate((0, $fdf4691d7b2848cb$export$144a00ba6044eb9)(focusedDate, visibleDuration, locale, minValue, maxValue));
    // Sets focus to a specific cell date
    function focusCell(date) {
        date = (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(date, minValue, maxValue);
        setFocusedDate(date);
    }
    function normalizeValue(newValue) {
        let constrained = (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(newValue, minValue, maxValue);
        let lowerBound = minValue ?? (0, $1qrul.minDate)(constrained, startDate);
        let prev = (0, $fdf4691d7b2848cb$export$a1d3911297b952d7)(constrained, lowerBound, isDateUnavailable);
        if (!prev) return null;
        // The display calendar should not have any effect on the emitted value.
        // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
        let baseValue = Array.isArray(value) ? value[0] : value;
        let calendarValue = (0, $8jDkV.toCalendar)(prev, baseValue?.calendar || new (0, $1k26k.GregorianCalendar)());
        // Preserve time if the input value had one.
        if (baseValue && 'hour' in baseValue) return baseValue.set(calendarValue);
        return calendarValue;
    }
    function setValue(newValue) {
        if (!props.isDisabled && !props.isReadOnly) {
            if (newValue === null) {
                setControlledValue(selectionMode === 'multiple' ? [] : null);
                return;
            }
            if (Array.isArray(newValue)) setControlledValue(newValue.map(normalizeValue).filter(Boolean));
            else {
                let localValue = normalizeValue(newValue);
                if (localValue) setControlledValue(localValue);
            }
        }
    }
    let isUnavailable = (0, $eF4cA.useMemo)(()=>{
        if (!calendarDateValue) return false;
        if (Array.isArray(calendarDateValue)) return calendarDateValue.some((date)=>isDateUnavailable?.(date) || (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(date, minValue, maxValue));
        return isDateUnavailable?.(calendarDateValue) || (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(calendarDateValue, minValue, maxValue);
    }, [
        calendarDateValue,
        isDateUnavailable,
        minValue,
        maxValue
    ]);
    let isValueInvalid = props.isInvalid || props.validationState === 'invalid' || isUnavailable;
    let validationState = isValueInvalid ? 'invalid' : null;
    let pageDuration = (0, $eF4cA.useMemo)(()=>{
        if (pageBehavior === 'visible') return visibleDuration;
        return $6488e56da5e0e3cf$var$$ea0ea6e62ae0d7ca$var$unitDuration(visibleDuration);
    }, [
        pageBehavior,
        visibleDuration
    ]);
    return {
        isDisabled: props.isDisabled ?? false,
        isReadOnly: props.isReadOnly ?? false,
        value: calendarDateValue,
        setValue: setValue,
        selectionMode: selectionMode,
        visibleDuration: visibleDuration,
        visibleRange: {
            start: startDate,
            end: endDate
        },
        minValue: minValue,
        maxValue: maxValue,
        focusedDate: focusedDate,
        timeZone: timeZone,
        validationState: validationState,
        isValueInvalid: isValueInvalid,
        setFocusedDate (date) {
            focusCell(date);
        },
        focusNextDay () {
            focusCell(focusedDate.add({
                days: 1
            }));
        },
        focusPreviousDay () {
            focusCell(focusedDate.subtract({
                days: 1
            }));
        },
        focusNextRow () {
            if (visibleDuration.days) this.focusNextPage();
            else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
                weeks: 1
            }));
        },
        focusPreviousRow () {
            if (visibleDuration.days) this.focusPreviousPage();
            else if (visibleDuration.weeks || visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
                weeks: 1
            }));
        },
        focusNextPage () {
            let start = startDate.add(pageDuration);
            setFocusedDate((0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(focusedDate.add(pageDuration), minValue, maxValue));
            setStartDate((0, $fdf4691d7b2848cb$export$144a00ba6044eb9)((0, $fdf4691d7b2848cb$export$5bb865b12696a77d)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
        },
        focusPreviousPage () {
            let start = startDate.subtract(pageDuration);
            setFocusedDate((0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(focusedDate.subtract(pageDuration), minValue, maxValue));
            setStartDate((0, $fdf4691d7b2848cb$export$144a00ba6044eb9)((0, $fdf4691d7b2848cb$export$5bb865b12696a77d)(focusedDate, start, pageDuration, locale, minValue, maxValue), pageDuration, locale));
        },
        focusSectionStart () {
            if (visibleDuration.days) focusCell(startDate);
            else if (visibleDuration.weeks) focusCell((0, $1qrul.startOfWeek)(focusedDate, locale));
            else if (visibleDuration.months || visibleDuration.years) focusCell((0, $1qrul.startOfMonth)(focusedDate));
        },
        focusSectionEnd () {
            if (visibleDuration.days) focusCell(endDate);
            else if (visibleDuration.weeks) focusCell((0, $1qrul.endOfWeek)(focusedDate, locale));
            else if (visibleDuration.months || visibleDuration.years) focusCell((0, $1qrul.endOfMonth)(focusedDate));
        },
        focusNextSection (larger) {
            if (!larger && !visibleDuration.days) {
                focusCell(focusedDate.add($6488e56da5e0e3cf$var$$ea0ea6e62ae0d7ca$var$unitDuration(visibleDuration)));
                return;
            }
            if (visibleDuration.days) this.focusNextPage();
            else if (visibleDuration.weeks) focusCell(focusedDate.add({
                months: 1
            }));
            else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.add({
                years: 1
            }));
        },
        focusPreviousSection (larger) {
            if (!larger && !visibleDuration.days) {
                focusCell(focusedDate.subtract($6488e56da5e0e3cf$var$$ea0ea6e62ae0d7ca$var$unitDuration(visibleDuration)));
                return;
            }
            if (visibleDuration.days) this.focusPreviousPage();
            else if (visibleDuration.weeks) focusCell(focusedDate.subtract({
                months: 1
            }));
            else if (visibleDuration.months || visibleDuration.years) focusCell(focusedDate.subtract({
                years: 1
            }));
        },
        selectFocusedDate () {
            if (!(isDateUnavailable && isDateUnavailable(focusedDate))) this.selectDate(focusedDate);
        },
        selectDate (date) {
            if (props.isDisabled || props.isReadOnly) return;
            if (selectionMode === 'multiple' && date != null) {
                let newDate = normalizeValue(date);
                if (!newDate) return;
                let baseValue = [];
                if (Array.isArray(value)) baseValue = value;
                else if (value != null) baseValue = [
                    value
                ];
                let index = baseValue.findIndex((value)=>(0, $1qrul.isSameDay)(value, newDate));
                let newValue = index >= 0 ? baseValue.slice(0, index).concat(baseValue.slice(index + 1)) : [
                    ...baseValue,
                    newDate
                ];
                setControlledValue(newValue);
            } else setValue(date);
        },
        isFocused: isFocused,
        setFocused: setFocused,
        isInvalid (date) {
            return (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(date, minValue, maxValue);
        },
        isSelected (date) {
            if (!calendarDateValue || this.isCellDisabled(date) || this.isCellUnavailable(date)) return false;
            return Array.isArray(calendarDateValue) ? calendarDateValue.some((value)=>(0, $1qrul.isSameDay)(value, date)) : (0, $1qrul.isSameDay)(date, calendarDateValue);
        },
        isCellFocused (date) {
            return isFocused && focusedDate && (0, $1qrul.isSameDay)(date, focusedDate);
        },
        isCellDisabled (date) {
            return props.isDisabled || date.compare(startDate) < 0 || date.compare(endDate) > 0 || this.isInvalid(date);
        },
        isCellUnavailable (date) {
            return props.isDateUnavailable ? props.isDateUnavailable(date) : false;
        },
        isPreviousVisibleRangeInvalid () {
            let prev = startDate.subtract({
                days: 1
            });
            return (0, $1qrul.isSameDay)(prev, startDate) || this.isInvalid(prev);
        },
        isNextVisibleRangeInvalid () {
            // Adding may return the same date if we reached the end of time
            // according to the calendar system (e.g. 9999-12-31).
            let next = endDate.add({
                days: 1
            });
            return (0, $1qrul.isSameDay)(next, endDate) || this.isInvalid(next);
        },
        getDatesInWeek (weekIndex, from = startDate) {
            let date = from.add({
                weeks: weekIndex
            });
            let dates = [];
            let days = visibleDuration.days && visibleDuration.days < 7 ? visibleDuration.days : 7;
            if (days === 7) {
                date = (0, $1qrul.startOfWeek)(date, locale, firstDayOfWeek);
                // startOfWeek will clamp dates within the calendar system's valid range, which may
                // start in the middle of a week. In this case, add null placeholders.
                let dayOfWeek = (0, $1qrul.getDayOfWeek)(date, locale, firstDayOfWeek);
                for(let i = 0; i < dayOfWeek; i++)dates.push(null);
            }
            while(dates.length < days){
                dates.push(date);
                let nextDate = date.add({
                    days: 1
                });
                if ((0, $1qrul.isSameDay)(date, nextDate)) break;
                date = nextDate;
            }
            // Add null placeholders if at the end of the calendar system.
            while(dates.length < days)dates.push(null);
            return dates;
        },
        getWeeksInMonth (date = startDate) {
            let weeks = weeksInMonth || (0, $1qrul.getWeeksInMonth)(date, locale, firstDayOfWeek);
            if (visibleDuration.weeks || visibleDuration.days) {
                weeks = visibleDuration.weeks ?? 0;
                if (visibleDuration.days) weeks += Math.ceil(visibleDuration.days / 7);
            }
            return weeks;
        }
    };
}
function $6488e56da5e0e3cf$var$$ea0ea6e62ae0d7ca$var$unitDuration(duration) {
    let unit = {
        ...duration
    };
    for(let key in duration)unit[key] = 1;
    return unit;
}



var $iUErx = parcelRequire("iUErx");

var $1k26k = parcelRequire("1k26k");
var $1qrul = parcelRequire("1qrul");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b00173e075ea86be$export$9a987164d97ecc90(props) {
    let { value: valueProp, defaultValue: defaultValue, onChange: onChange, createCalendar: createCalendar, locale: locale, visibleDuration: visibleDuration = {
        months: 1
    }, minValue: minValue, maxValue: maxValue, ...calendarProps } = props;
    let [value, setValue] = (0, $iUErx.useControlledState)(valueProp, defaultValue || null, onChange);
    let [anchorDate, setAnchorDate] = (0, $eF4cA.useState)(null);
    let alignment = 'center';
    if (value && value.start && value.end) {
        let start = (0, $fdf4691d7b2848cb$export$f4a51ff076cc9a09)((0, $8jDkV.toCalendarDate)(value.start), visibleDuration, locale, minValue, maxValue);
        let end = start.add(visibleDuration).subtract({
            days: 1
        });
        if (value.end.compare(end) > 0) alignment = 'start';
    }
    let isDateUnavailable = (0, $eF4cA.useMemo)(()=>{
        let isDateUnavailable = props.isDateUnavailable;
        if (!isDateUnavailable) return undefined;
        return (date)=>isDateUnavailable(date, anchorDate);
    }, [
        props.isDateUnavailable,
        anchorDate
    ]);
    let getAvailableRange = (0, $eF4cA.useCallback)((anchorDate)=>{
        if (anchorDate && isDateUnavailable && !props.allowsNonContiguousRanges) {
            const nextAvailableStartDate = $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$nextUnavailableDate(anchorDate, isDateUnavailable, visibleDuration, -1);
            const nextAvailableEndDate = $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$nextUnavailableDate(anchorDate, isDateUnavailable, visibleDuration, 1);
            return {
                start: nextAvailableStartDate,
                end: nextAvailableEndDate
            };
        } else return null;
    }, [
        isDateUnavailable,
        visibleDuration,
        props.allowsNonContiguousRanges
    ]);
    let availableRange = (0, $eF4cA.useMemo)(()=>getAvailableRange(anchorDate), [
        getAvailableRange,
        anchorDate
    ]);
    let min = (0, $eF4cA.useMemo)(()=>(0, $1qrul.maxDate)(minValue, availableRange?.start), [
        minValue,
        availableRange
    ]);
    let max = (0, $eF4cA.useMemo)(()=>(0, $1qrul.minDate)(maxValue, availableRange?.end), [
        maxValue,
        availableRange
    ]);
    let calendar = (0, $6488e56da5e0e3cf$export$6d095e787d2b5e1f)({
        ...calendarProps,
        value: value && value.start,
        createCalendar: createCalendar,
        locale: locale,
        visibleDuration: visibleDuration,
        minValue: min,
        maxValue: max,
        selectionAlignment: props.selectionAlignment || alignment,
        isDateUnavailable: isDateUnavailable
    });
    let highlightedRange = anchorDate ? $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$makeRange(anchorDate, calendar.focusedDate) : value && $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$makeRange(value.start, value.end);
    let selectDate = (date)=>{
        if (props.isReadOnly) return;
        const constrainedDate = (0, $fdf4691d7b2848cb$export$4f5203c0d889109e)(date, min, max);
        const previousAvailableConstrainedDate = (0, $fdf4691d7b2848cb$export$a1d3911297b952d7)(constrainedDate, calendar.visibleRange.start, isDateUnavailable);
        if (!previousAvailableConstrainedDate) return;
        if (!anchorDate) setAnchorDate(previousAvailableConstrainedDate);
        else {
            let range = $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$makeRange(anchorDate, previousAvailableConstrainedDate);
            if (range) setValue({
                start: $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$convertValue(range.start, value?.start),
                end: $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$convertValue(range.end, value?.end)
            });
            setAnchorDate(null);
        }
    };
    let [isDragging, setDragging] = (0, $eF4cA.useState)(false);
    let isInvalidSelection = (0, $eF4cA.useMemo)(()=>{
        if (!value || anchorDate) return false;
        if (isDateUnavailable && (isDateUnavailable(value.start) || isDateUnavailable(value.end))) return true;
        return (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(value.start, minValue, maxValue) || (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(value.end, minValue, maxValue);
    }, [
        isDateUnavailable,
        value,
        anchorDate,
        minValue,
        maxValue
    ]);
    let isValueInvalid = props.isInvalid || props.validationState === 'invalid' || isInvalidSelection;
    let validationState = isValueInvalid ? 'invalid' : null;
    return {
        ...calendar,
        value: value,
        setValue: setValue,
        anchorDate: anchorDate,
        setAnchorDate: setAnchorDate,
        highlightedRange: highlightedRange,
        validationState: validationState,
        isValueInvalid: isValueInvalid,
        selectFocusedDate () {
            if (!calendar.isCellUnavailable(calendar.focusedDate)) selectDate(calendar.focusedDate);
        },
        commitSelection () {
            selectDate(calendar.focusedDate);
        },
        selectDate: selectDate,
        highlightDate (date) {
            if (anchorDate) calendar.setFocusedDate(date);
        },
        isSelected (date) {
            return Boolean(highlightedRange && date.compare(highlightedRange.start) >= 0 && date.compare(highlightedRange.end) <= 0 && !calendar.isCellDisabled(date) && !calendar.isCellUnavailable(date));
        },
        isInvalid (date) {
            return calendar.isInvalid(date) || (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(date, availableRange?.start, availableRange?.end);
        },
        isDragging: isDragging,
        setDragging: setDragging,
        clearSelection () {
            setAnchorDate(null);
            setValue(null);
        },
        focusNearestAvailableDate (anchorDate) {
            let availableRange = getAvailableRange(anchorDate);
            let isDateInvalid = (date)=>this.isInvalid(date) || (0, $fdf4691d7b2848cb$export$eac50920cf2fd59a)(date, availableRange?.start, availableRange?.end);
            let nextDay = anchorDate.add({
                days: 1
            });
            if (isDateInvalid(nextDay)) nextDay = anchorDate.subtract({
                days: 1
            });
            if (!isDateInvalid(nextDay)) {
                this.setFocusedDate(nextDay);
                this.setFocused(true);
            }
        }
    };
}
function $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$makeRange(start, end) {
    if (!start || !end) return null;
    if (end.compare(start) < 0) [start, end] = [
        end,
        start
    ];
    return {
        start: (0, $8jDkV.toCalendarDate)(start),
        end: (0, $8jDkV.toCalendarDate)(end)
    };
}
function $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$convertValue(newValue, oldValue) {
    // The display calendar should not have any effect on the emitted value.
    // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
    newValue = (0, $8jDkV.toCalendar)(newValue, oldValue?.calendar || new (0, $1k26k.GregorianCalendar)());
    // Preserve time if the input value had one.
    if (oldValue && 'hour' in oldValue) return oldValue.set(newValue);
    return newValue;
}
function $b00173e075ea86be$var$$a0a87fb6fcfb22ec$var$nextUnavailableDate(anchorDate, isDateUnavailable, visibleDuration, dir) {
    let nextDate = anchorDate.add({
        days: dir
    });
    let minDate = anchorDate.subtract(visibleDuration);
    let maxDate = anchorDate.add(visibleDuration);
    while((dir < 0 ? nextDate.compare(minDate) >= 0 : nextDate.compare(maxDate) <= 0) && !isDateUnavailable(nextDate))nextDate = nextDate.add({
        days: dir
    });
    if (isDateUnavailable(nextDate)) return nextDate.add({
        days: -dir
    });
}



var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");


var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $1ntKq = parcelRequire("1ntKq");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e283c5f3c36f6582$export$3b805cea1f178355 = (0, $eF4cA.createContext)(null);
const $e283c5f3c36f6582$export$233dd9682e1ad64b = (0, $eF4cA.createContext)(null);
const $e283c5f3c36f6582$export$9e31dcedda1dadc7 = (0, $eF4cA.createContext)(null);
const $e283c5f3c36f6582$export$5e0fc348c00f87a0 = (0, $eF4cA.createContext)(null);
const $e283c5f3c36f6582$export$e1aef45b828286de = (0, $eF4cA.forwardRef)(function Calendar(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $e283c5f3c36f6582$export$3b805cea1f178355);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let state = (0, $6488e56da5e0e3cf$export$6d095e787d2b5e1f)({
        ...props,
        locale: locale,
        createCalendar: props.createCalendar || (0, $3a199efecdda72a1$export$dd0bbc9b26defe37)
    });
    let { calendarProps: calendarProps, prevButtonProps: prevButtonProps, nextButtonProps: nextButtonProps, errorMessageProps: errorMessageProps, title: title } = (0, $010999b093711aee$export$3ee915f8151bd4f1)(props, state);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            state: state,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isValueInvalid
        },
        defaultClassName: 'react-aria-Calendar'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, calendarProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": state.isValueInvalid || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        previous: prevButtonProps,
                        next: nextButtonProps
                    }
                }
            ],
            [
                (0, $1O9kP.HeadingContext),
                {
                    'aria-hidden': true,
                    level: 2,
                    children: title
                }
            ],
            [
                $e283c5f3c36f6582$export$9e31dcedda1dadc7,
                state
            ],
            [
                $e283c5f3c36f6582$export$3b805cea1f178355,
                props
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("h2", null, calendarProps['aria-label'])), renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("button", {
        "aria-label": nextButtonProps['aria-label'],
        disabled: nextButtonProps.isDisabled,
        onClick: ()=>state.focusNextPage(),
        tabIndex: -1
    }))));
});
const $e283c5f3c36f6582$export$a4f5c8b89d277a8d = (0, $eF4cA.forwardRef)(function RangeCalendar(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $e283c5f3c36f6582$export$233dd9682e1ad64b);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let state = (0, $b00173e075ea86be$export$9a987164d97ecc90)({
        ...props,
        locale: locale,
        createCalendar: props.createCalendar || (0, $3a199efecdda72a1$export$dd0bbc9b26defe37)
    });
    let { calendarProps: calendarProps, prevButtonProps: prevButtonProps, nextButtonProps: nextButtonProps, errorMessageProps: errorMessageProps, title: title } = (0, $1e7fae66e50d3549$export$87e0539f600c24e5)(props, state, ref);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            state: state,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isValueInvalid
        },
        defaultClassName: 'react-aria-RangeCalendar'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(renderProps, DOMProps, calendarProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": state.isValueInvalid || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                (0, $k5Pnh.ButtonContext),
                {
                    slots: {
                        previous: prevButtonProps,
                        next: nextButtonProps
                    }
                }
            ],
            [
                (0, $1O9kP.HeadingContext),
                {
                    'aria-hidden': true,
                    level: 2,
                    children: title
                }
            ],
            [
                $e283c5f3c36f6582$export$5e0fc348c00f87a0,
                state
            ],
            [
                $e283c5f3c36f6582$export$233dd9682e1ad64b,
                props
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("h2", null, calendarProps['aria-label'])), renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $31fH3.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("button", {
        "aria-label": nextButtonProps['aria-label'],
        disabled: nextButtonProps.isDisabled,
        onClick: ()=>state.focusNextPage(),
        tabIndex: -1
    }))));
});
const $e283c5f3c36f6582$var$$6f9a1820b787aac7$var$InternalCalendarGridContext = (0, $eF4cA.createContext)(null);
const $e283c5f3c36f6582$export$5bd780d491cfc46c = (0, $eF4cA.forwardRef)(function CalendarGrid(props, ref) {
    let calendarState = (0, $eF4cA.useContext)($e283c5f3c36f6582$export$9e31dcedda1dadc7);
    let rangeCalendarState = (0, $eF4cA.useContext)($e283c5f3c36f6582$export$5e0fc348c00f87a0);
    let calenderProps = (0, $fDYaM.useSlottedContext)($e283c5f3c36f6582$export$3b805cea1f178355);
    let rangeCalenderProps = (0, $fDYaM.useSlottedContext)($e283c5f3c36f6582$export$233dd9682e1ad64b);
    let state = calendarState ?? rangeCalendarState;
    let startDate = state.visibleRange.start;
    if (props.offset) startDate = startDate.add(props.offset);
    let firstDayOfWeek = calenderProps?.firstDayOfWeek ?? rangeCalenderProps?.firstDayOfWeek;
    let { gridProps: gridProps, headerProps: headerProps, weekDays: weekDays, weeksInMonth: weeksInMonth } = (0, $5042815b51a67641$export$cb95147730a423f5)({
        startDate: startDate,
        endDate: (0, $1qrul.endOfMonth)(startDate),
        weekdayStyle: props.weekdayStyle,
        firstDayOfWeek: firstDayOfWeek
    }, state);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$InternalCalendarGridContext.Provider, {
        value: {
            headerProps: headerProps,
            weekDays: weekDays,
            startDate: startDate,
            weeksInMonth: weeksInMonth
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).table, {
        render: props.render,
        ...(0, $lhKAD.mergeProps)(DOMProps, gridProps),
        ref: ref,
        style: props.style,
        cellPadding: 0,
        className: props.className ?? 'react-aria-CalendarGrid'
    }, typeof props.children !== 'function' ? props.children : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($e283c5f3c36f6582$export$22e2d15eaa4d2377, null, (day)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($e283c5f3c36f6582$export$ad2135cac3a11b3d, null, day)), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($e283c5f3c36f6582$export$e11f8ba65d857bff, null, props.children))));
});
function $e283c5f3c36f6582$var$$6f9a1820b787aac7$var$CalendarGridHeader(props, ref) {
    let { children: children, style: style, className: className } = props;
    let { headerProps: headerProps, weekDays: weekDays } = (0, $eF4cA.useContext)($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$InternalCalendarGridContext);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).thead, {
        render: props.render,
        ...(0, $lhKAD.mergeProps)(DOMProps, headerProps),
        ref: ref,
        style: style,
        className: className ?? 'react-aria-CalendarGridHeader'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("tr", null, weekDays.map((day, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).cloneElement(children(day), {
            key: key
        }))));
}
/**
 * A calendar grid header displays a row of week day names at the top of a month.
 */ const $e283c5f3c36f6582$export$22e2d15eaa4d2377 = (0, $eF4cA.forwardRef)($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$CalendarGridHeader);
function $e283c5f3c36f6582$var$$6f9a1820b787aac7$var$CalendarHeaderCell(props, ref) {
    let { children: children, style: style, className: className } = props;
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).th, {
        render: props.render,
        ...DOMProps,
        ref: ref,
        style: style,
        className: className || 'react-aria-CalendarHeaderCell'
    }, children);
}
/**
 * A calendar header cell displays a week day name at the top of a column within a calendar.
 */ const $e283c5f3c36f6582$export$ad2135cac3a11b3d = (0, $eF4cA.forwardRef)($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$CalendarHeaderCell);
function $e283c5f3c36f6582$var$$6f9a1820b787aac7$var$CalendarGridBody(props, ref) {
    let { children: children, style: style, className: className } = props;
    let calendarState = (0, $eF4cA.useContext)($e283c5f3c36f6582$export$9e31dcedda1dadc7);
    let rangeCalendarState = (0, $eF4cA.useContext)($e283c5f3c36f6582$export$5e0fc348c00f87a0);
    let state = calendarState ?? rangeCalendarState;
    let { startDate: startDate, weeksInMonth: weeksInMonth } = (0, $eF4cA.useContext)($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$InternalCalendarGridContext);
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).tbody, {
        render: props.render,
        ...DOMProps,
        ref: ref,
        style: style,
        className: className ?? 'react-aria-CalendarGridBody'
    }, [
        ...new Array(weeksInMonth).keys()
    ].map((weekIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("tr", {
            key: weekIndex
        }, state.getDatesInWeek(weekIndex, startDate).map((date, i)=>date ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).cloneElement(children(date), {
                key: i
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("td", {
                key: i
            })))));
}
/**
 * A calendar grid body displays a grid of calendar cells within a month.
 */ const $e283c5f3c36f6582$export$e11f8ba65d857bff = (0, $eF4cA.forwardRef)($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$CalendarGridBody);
const $e283c5f3c36f6582$export$5d847498420df57b = (0, $eF4cA.forwardRef)(function CalendarCell({ date: date, ...otherProps }, ref) {
    let calendarState = (0, $eF4cA.useContext)($e283c5f3c36f6582$export$9e31dcedda1dadc7);
    let rangeCalendarState = (0, $eF4cA.useContext)($e283c5f3c36f6582$export$5e0fc348c00f87a0);
    let state = calendarState ?? rangeCalendarState;
    let { startDate: currentMonth } = (0, $eF4cA.useContext)($e283c5f3c36f6582$var$$6f9a1820b787aac7$var$InternalCalendarGridContext) ?? {
        startDate: state.visibleRange.start
    };
    let isOutsideMonth = state.visibleDuration.days || state.visibleDuration.weeks ? false : !(0, $1qrul.isSameMonth)(currentMonth, date);
    let istoday = (0, $1qrul.isToday)(date, state.timeZone);
    let buttonRef = (0, $eF4cA.useRef)(null);
    let { cellProps: cellProps, buttonProps: buttonProps, ...states } = (0, $68bad6c104c3e7cd$export$136073280381448e)({
        date: date,
        isOutsideMonth: isOutsideMonth
    }, state, buttonRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...otherProps,
        isDisabled: states.isDisabled || states.isUnavailable
    });
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    isFocusVisible &&= states.isFocused;
    let isSelectionStart = false;
    let isSelectionEnd = false;
    if ('highlightedRange' in state && state.highlightedRange) {
        isSelectionStart = (0, $1qrul.isSameDay)(date, state.highlightedRange.start);
        isSelectionEnd = (0, $1qrul.isSameDay)(date, state.highlightedRange.end);
    }
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        defaultChildren: states.formattedDate,
        defaultClassName: 'react-aria-CalendarCell',
        values: {
            date: date,
            isHovered: isHovered,
            isOutsideMonth: isOutsideMonth,
            isFocusVisible: isFocusVisible,
            isSelectionStart: isSelectionStart,
            isSelectionEnd: isSelectionEnd,
            isToday: istoday,
            ...states
        }
    });
    let dataAttrs = {
        'data-focused': states.isFocused || undefined,
        'data-hovered': isHovered || undefined,
        'data-pressed': states.isPressed || undefined,
        'data-unavailable': states.isUnavailable || undefined,
        'data-disabled': states.isDisabled || undefined,
        'data-focus-visible': isFocusVisible || undefined,
        'data-outside-visible-range': states.isOutsideVisibleRange || undefined,
        'data-outside-month': isOutsideMonth || undefined,
        'data-selected': states.isSelected || undefined,
        'data-selection-start': isSelectionStart || undefined,
        'data-selection-end': isSelectionEnd || undefined,
        'data-invalid': states.isInvalid || undefined,
        'data-today': istoday || undefined
    };
    let DOMProps = (0, $fVfXf.filterDOMProps)(otherProps, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("td", {
        ...cellProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, buttonProps, focusProps, hoverProps, dataAttrs, renderProps),
        ref: buttonRef
    }));
});
function $e283c5f3c36f6582$export$f0ed7ae5d49afb95(props) {
    let calendarState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($e283c5f3c36f6582$export$9e31dcedda1dadc7);
    let rangeCalendarState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($e283c5f3c36f6582$export$5e0fc348c00f87a0);
    let state = calendarState || rangeCalendarState;
    let aria = (0, $d9a69bad6030b2b3$export$89757cae093b4b95)(props, state);
    return props.children(aria);
}
function $e283c5f3c36f6582$export$76806186243e9de6(props) {
    let calendarState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($e283c5f3c36f6582$export$9e31dcedda1dadc7);
    let rangeCalendarState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($e283c5f3c36f6582$export$5e0fc348c00f87a0);
    let state = calendarState || rangeCalendarState;
    let aria = (0, $22a090653636bc46$export$cf412bf5dcbe1065)(props, state);
    return props.children(aria);
}
const $e283c5f3c36f6582$export$77af08ed164baa7 = (0, $eF4cA.forwardRef)(function CalendarHeading(props, ref) {
    let { offset: offset, format: format, className: className = 'react-aria-CalendarHeading', ...headingProps } = props;
    let calendarState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($e283c5f3c36f6582$export$9e31dcedda1dadc7);
    let rangeCalendarState = (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).useContext($e283c5f3c36f6582$export$5e0fc348c00f87a0);
    let state = calendarState || rangeCalendarState;
    let aria = (0, $cfef76f6881c4261$export$72ad8e10aa105341)({
        offset: offset,
        format: format
    }, state);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $1O9kP.Heading), {
        ...headingProps,
        className: className,
        ref: ref
    }, aria);
});



var $1qrul = parcelRequire("1qrul");

var $fDYaM = parcelRequire("fDYaM");


var $eF4cA = parcelRequire("eF4cA");

var $c1ibQ = parcelRequire("c1ibQ");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");
function $ecefd708045a9721$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ecefd708045a9721$export$3b805cea1f178355 = (0, $eF4cA.createContext)(null);
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$calendarStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' sd182';
    if (props.isMultiMonth) rules += ' -_4DHzJc-e4mUs182';
    else rules += ' -_4DHzJc-0u6p5b182';
    rules += ' _ta182';
    rules += ' Uj182';
    rules += ' qj182';
    rules += ' __ca182';
    rules += ' -uq4sQ-Sp182';
    rules += ' -LnVzy-ZC182';
    if (props.isMultiMonth) rules += ' -cYDWLb-ZFFQGNb182';
    else rules += ' -cYDWLb-ZnqRBTd182';
    if (props.isMultiMonth) {
        if (!width) rules += ' ZJ182';
    } else if (!width) rules += ' ZRqDA2c182';
    if (props.isMultiMonth) {
        if (!maxWidth) rules += ' Le4mUs182';
    } else if (!maxWidth) rules += ' La182';
    return rules;
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$headerStyles = " sd182 eb182 _Ce182 qj182";
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$headingStyles = " sd182 eb182 _Ce182 Jy182 Gy182 Iy182 Hy182 _ub182 Za182";
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$titleStyles = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-e182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 _Wa182 _ub182 _va182 Jy182 Gy182";
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$headerCellStyles = " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182 ri182 _Wa182 Sp182 Sbd182 Rp182 Rkd182 Qe182";
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$cellStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Le182';
    rules += ' _ob182';
    if (props.isFirstChild) rules += ' Sd182';
    else rules += ' Sp182';
    if (props.isLastChild) rules += ' Rd182';
    else rules += ' Rp182';
    if (props.isFirstWeek) rules += ' Td182';
    else rules += ' Tj182';
    if (props.isLastWeek) rules += ' Qd182';
    else rules += ' Qj182';
    rules += ' _Pc182';
    if (props.isOutsideMonth) rules += ' sk182';
    else rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' __ca182';
    rules += ' Z0q26ub182';
    rules += ' F0q26ub182';
    return rules;
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$cellInnerStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    if (props.isSelectionEnd) rules += ' _Kd182';
    else if (props.isSelectionStart) rules += ' _Kd182';
    else if (props.isSelected) {
        if (props.selectionMode === "range") rules += ' _Kb182';
        else if (props.selectionMode === "single") rules += ' _Kd182';
    } else rules += ' _Kb182';
    rules += ' Yd182';
    rules += ' Yle182';
    rules += ' Xb182';
    rules += ' Xlb182';
    rules += ' _2b182';
    rules += ' _2lb182';
    rules += ' _Pc182';
    rules += ' uk182';
    rules += ' ucJ9TBTb182';
    rules += ' ud3Euai182';
    rules += ' uea182';
    rules += ' ugb182';
    rules += ' uhd182';
    rules += ' uje182';
    rules += ' u2NhKxcl182';
    rules += ' uic182';
    rules += ' -_6BNtrc-c182';
    rules += ' vx182';
    rules += ' xb182';
    rules += ' _xa182';
    rules += ' _Fb182';
    rules += ' _FnuYUwec182';
    if (props.isDisabled) rules += ' pp182';
    else if (props.isSelectionEnd) rules += ' px182';
    else if (props.isSelectionStart) rules += ' px182';
    else if (props.isSelected) {
        if (props.selectionMode === "range") rules += ' pt182';
        else rules += ' px182';
    } else rules += ' pt182';
    if (props.isDisabled) rules += ' plc182';
    else if (props.isSelectionEnd) rules += ' ple182';
    else if (props.isSelectionStart) rules += ' ple182';
    else if (props.isSelected) rules += ' ple182';
    else rules += ' plb182';
    rules += ' ri182';
    rules += ' Za182';
    rules += ' Fb182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' sd182';
    rules += ' eb182';
    rules += ' _Ca182';
    rules += ' _yb182';
    if (props.isSelectionEnd) {
        if (props.isInvalid) {
            if (props.isFocusVisible) {
                if (props.isUnavailable) rules += ' g7aei8182';
                else rules += ' gYvV9s182';
            } else if (props.isPressed) rules += ' gYvV9s182';
            else if (props.isHovered) {
                if (props.isUnavailable) rules += ' g7aei8182';
                else rules += ' gYvV9s182';
            } else rules += ' g7aei8182';
        } else if (props.isDisabled) rules += ' g9182';
        else if (props.isFocusVisible) rules += ' gUgARdd182';
        else if (props.isPressed) rules += ' gUgARdd182';
        else if (props.isHovered) rules += ' gUgARdd182';
        else rules += ' g5qAiPc182';
    } else if (props.isSelectionStart) {
        if (props.isInvalid) {
            if (props.isFocusVisible) {
                if (props.isUnavailable) rules += ' g7aei8182';
                else rules += ' gYvV9s182';
            } else if (props.isPressed) rules += ' gYvV9s182';
            else if (props.isHovered) {
                if (props.isUnavailable) rules += ' g7aei8182';
                else rules += ' gYvV9s182';
            } else rules += ' g7aei8182';
        } else if (props.isDisabled) rules += ' g9182';
        else if (props.isFocusVisible) rules += ' gUgARdd182';
        else if (props.isPressed) rules += ' gUgARdd182';
        else if (props.isHovered) rules += ' gUgARdd182';
        else rules += ' g5qAiPc182';
    } else if (props.isSelected) {
        if (props.selectionMode === "range") {
            if (props.isHovered) {
                if (props.isInvalid) {
                    if (props.isUnavailable) rules += ' g9182';
                    else rules += ' gJj9Tpd182';
                } else rules += ' gNAacne182';
            }
        } else if (props.selectionMode === "single") {
            if (props.isInvalid) {
                if (props.isFocusVisible) rules += ' gYvV9s182';
                else if (props.isPressed) rules += ' gYvV9s182';
                else if (props.isHovered) rules += ' gYvV9s182';
                else rules += ' g7aei8182';
            } else if (props.isDisabled) rules += ' g9182';
            else if (props.isFocusVisible) rules += ' gUgARdd182';
            else if (props.isPressed) rules += ' gUgARdd182';
            else if (props.isHovered) rules += ' gUgARdd182';
            else rules += ' g5qAiPc182';
        }
    } else if (props.isDisabled) rules += ' g9182';
    else if (props.isPressed) rules += ' gH182';
    else if (props.isHovered) {
        if (props.isUnavailable) rules += ' g9182';
        else rules += ' gH182';
    } else rules += ' g9182';
    if (props.isUnavailable) rules += ' gl9182';
    else if (props.isSelectionEnd) rules += ' gle182';
    else if (props.isSelectionStart) rules += ' gle182';
    else if (props.isSelected) {
        if (props.selectionMode === "range") {
            if (props.isHovered) rules += ' gle182';
        } else if (props.selectionMode === "single") rules += ' gle182';
    } else if (props.isHovered) rules += ' gle182';
    else rules += ' gl9182';
    return rules;
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$todayStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' _lakDin182';
    rules += ' _EF182';
    rules += ' _ZRWeLS182';
    rules += ' ZS16uu182';
    rules += ' Fe182';
    rules += ' og182';
    rules += ' ng182';
    rules += ' kg182';
    rules += ' jg182';
    rules += ' g5ZbAob182';
    if (props.isToday) rules += ' sb182';
    else rules += ' sk182';
    return rules;
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$unavailableStyles = " _Pa182 WzErnCb182 _EjhYzGc182 _RjhYzGc182 FlAZvq182 _ZN7ydnb182 og182 ng182 kg182 jg182 g5ZbAob182";
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$selectionBackgroundStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' _9a182';
    rules += ' Wr182';
    if (props.isPreviousDayNotSelected) rules += ' _Ar182';
    else if (props.isSelectionStart) rules += ' _Ar182';
    else if (props.isFirstDayInWeek) rules += ' _Ar182';
    else rules += ' _Al182';
    if (props.isNextDayNotSelected) rules += ' _zr182';
    else if (props.isSelectionEnd) rules += ' _zr182';
    else if (props.isLastDayInWeek) rules += ' _zr182';
    else rules += ' _zl182';
    rules += ' _lr182';
    if (props.isPreviousDayNotSelected) rules += ' og182';
    else if (props.isSelectionStart) rules += ' og182';
    else if (props.isFirstDayInWeek) rules += ' og182';
    else rules += ' od182';
    if (props.isPreviousDayNotSelected) rules += ' kg182';
    else if (props.isSelectionStart) rules += ' kg182';
    else if (props.isFirstDayInWeek) rules += ' kg182';
    else rules += ' kd182';
    if (props.isNextDayNotSelected) rules += ' ng182';
    else if (props.isSelectionEnd) rules += ' ng182';
    else if (props.isLastDayInWeek) rules += ' ng182';
    else rules += ' nd182';
    if (props.isNextDayNotSelected) rules += ' jg182';
    else if (props.isSelectionEnd) rules += ' jg182';
    else if (props.isLastDayInWeek) rules += ' jg182';
    else rules += ' jd182';
    if (props.isInvalid) rules += ' gZbQnx182';
    else rules += ' gG182';
    rules += ' gle182';
    rules += ' _yb182';
    return rules;
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$selectionBorderStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa182';
    rules += ' _9c182';
    rules += ' Wr182';
    if (props.isPreviousDayNotSelected) rules += ' _Ar182';
    else if (props.isSelectionStart) rules += ' _Ar182';
    else if (props.isFirstDayInWeek) rules += ' _Ar182';
    else rules += ' _Al182';
    if (props.isNextDayNotSelected) rules += ' _zr182';
    else if (props.isSelectionEnd) rules += ' _zr182';
    else if (props.isLastDayInWeek) rules += ' _zr182';
    else rules += ' _zl182';
    rules += ' _lr182';
    if (props.isPreviousDayNotSelected) rules += ' mb182';
    else if (props.isSelectionStart) rules += ' mb182';
    else if (props.isFirstDayInWeek) rules += ' mb182';
    else rules += ' ma182';
    rules += ' _kb182';
    if (props.isNextDayNotSelected) rules += ' lb182';
    else if (props.isSelectionEnd) rules += ' lb182';
    else if (props.isLastDayInWeek) rules += ' lb182';
    else rules += ' la182';
    rules += ' hb182';
    rules += ' _jf182';
    if (props.isInvalid) rules += ' ip182';
    else rules += ' ix182';
    rules += ' ilb182';
    if (props.isPreviousDayNotSelected) rules += ' og182';
    else if (props.isSelectionStart) rules += ' og182';
    else if (props.isFirstDayInWeek) rules += ' og182';
    else rules += ' od182';
    if (props.isPreviousDayNotSelected) rules += ' kg182';
    else if (props.isSelectionStart) rules += ' kg182';
    else if (props.isFirstDayInWeek) rules += ' kg182';
    else rules += ' kd182';
    if (props.isNextDayNotSelected) rules += ' ng182';
    else if (props.isSelectionEnd) rules += ' ng182';
    else if (props.isLastDayInWeek) rules += ' ng182';
    else rules += ' nd182';
    if (props.isNextDayNotSelected) rules += ' jg182';
    else if (props.isSelectionEnd) rules += ' jg182';
    else if (props.isLastDayInWeek) rules += ' jg182';
    else rules += ' jd182';
    return rules;
};
const $ecefd708045a9721$export$e1aef45b828286de = (0, $eF4cA.forwardRef)(function Calendar(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $ecefd708045a9721$export$3b805cea1f178355);
    let { visibleMonths: visibleMonths = 1, errorMessage: errorMessage, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, ...otherProps } = props;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($ecefd708045a9721$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let isMultiMonth = visibleMonths > 1;
    return (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$e1aef45b828286de), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + $ecefd708045a9721$var$$f06f4d5597ad704c$var$calendarStyles({
            isMultiMonth: isMultiMonth
        }, styles),
        children: ({ isInvalid: isInvalid, isDisabled: isDisabled })=>{
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $208Op.HeaderContext),
                                null
                            ],
                            [
                                (0, $208Op.HeadingContext),
                                null
                            ]
                        ],
                        children: (0, $dx4lB.jsx)($ecefd708045a9721$export$9c75275274db0b56, {
                            visibleMonths: visibleMonths
                        })
                    }),
                    (0, $dx4lB.jsx)("div", {
                        className: " sd182 _tc182 Uj182 qj182 Za182 ed182",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>(0, $dx4lB.jsx)($ecefd708045a9721$export$5bd780d491cfc46c, {
                                months: i
                            }, i))
                    }),
                    isInvalid && (0, $dx4lB.jsx)((0, $c1ibQ.Text), {
                        slot: "errorMessage",
                        className: (0, $8w4Nl.helpTextStyles)({
                            isInvalid: isInvalid,
                            isDisabled: isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 1
                        })
                    })
                ]
            });
        }
    });
});
const $ecefd708045a9721$export$9c75275274db0b56 = ({ visibleMonths: visibleMonths })=>{
    return (0, $dx4lB.jsx)((0, $208Op.Header), {
        styles: $ecefd708045a9721$var$$f06f4d5597ad704c$var$headerStyles,
        children: Array.from({
            length: visibleMonths
        }).map((_, i)=>(0, $dx4lB.jsxs)("div", {
                className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$headingStyles,
                children: [
                    i === 0 && (0, $dx4lB.jsx)($ecefd708045a9721$export$adb29da0ac001538, {
                        slot: "previous",
                        children: (0, $dx4lB.jsx)((0, $8829c44c80cd9620$export$2e2bcd8739ae039), {})
                    }),
                    (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$77af08ed164baa7), {
                        offset: {
                            months: i
                        },
                        className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$titleStyles
                    }),
                    i === visibleMonths - 1 && (0, $dx4lB.jsx)($ecefd708045a9721$export$adb29da0ac001538, {
                        slot: "next",
                        children: (0, $dx4lB.jsx)((0, $79846ac3e4f71e5a$export$2e2bcd8739ae039), {})
                    })
                ]
            }, i))
    });
};
const $ecefd708045a9721$export$5bd780d491cfc46c = (props)=>{
    let rangeCalendarProps = (0, $fDYaM.useSlottedContext)((0, $e283c5f3c36f6582$export$233dd9682e1ad64b));
    let calendarProps = (0, $fDYaM.useSlottedContext)((0, $e283c5f3c36f6582$export$3b805cea1f178355));
    let firstDayOfWeek = rangeCalendarProps?.firstDayOfWeek ?? calendarProps?.firstDayOfWeek;
    // use isolation to start a new stacking context so that we can use zIndex -1 for the selection span.
    return (0, $dx4lB.jsxs)((0, $e283c5f3c36f6582$export$5bd780d491cfc46c), {
        className: " __na182 __oe182 _Bb182",
        offset: {
            months: props.months
        },
        children: [
            (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$22e2d15eaa4d2377), {
                className: "",
                children: (day)=>(0, $dx4lB.jsx)($ecefd708045a9721$var$$f06f4d5597ad704c$var$CalendarHeaderCell, {
                        children: day
                    })
            }),
            (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$e11f8ba65d857bff), {
                className: "",
                children: (date)=>(0, $dx4lB.jsx)($ecefd708045a9721$var$$f06f4d5597ad704c$var$CalendarCell, {
                        date: date,
                        firstDayOfWeek: firstDayOfWeek
                    })
            })
        ]
    });
};
const $ecefd708045a9721$export$adb29da0ac001538 = (props1)=>{
    let { direction: direction } = (0, $1ntKq.useLocale)();
    return (0, $dx4lB.jsx)("div", {
        className: function anonymous(props) {
            let rules = " ";
            if (props.direction === "rtl") {
                rules += ' -Z4Pn4c-a182';
                rules += ' __Ha182';
            }
            if (props.direction === "rtl") {
                rules += ' -_04Pn4c-a182';
                rules += ' __Ha182';
            }
            return rules;
        }({
            direction: direction
        }),
        children: (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
            ...props1,
            isQuiet: true,
            children: props1.children
        })
    });
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$CalendarHeaderCell = (props)=>{
    return (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$ad2135cac3a11b3d), {
        className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$headerCellStyles,
        children: props.children
    });
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$CalendarCell = (props)=>{
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let firstDayOfWeek = props.firstDayOfWeek;
    // Calculate the day and week index based on the date.
    let { dayIndex: dayIndex, weekIndex: weekIndex, lastWeekIndex: lastWeekIndex } = $ecefd708045a9721$var$$f06f4d5597ad704c$var$useWeekAndDayIndices(props.date, locale, firstDayOfWeek);
    let calendarStateContext = (0, $eF4cA.useContext)((0, $e283c5f3c36f6582$export$9e31dcedda1dadc7));
    let rangeCalendarStateContext = (0, $eF4cA.useContext)((0, $e283c5f3c36f6582$export$5e0fc348c00f87a0));
    let state = calendarStateContext ?? rangeCalendarStateContext;
    let isFirstWeek = weekIndex === 0;
    let isLastWeek = weekIndex === lastWeekIndex;
    let isFirstChild = dayIndex === 0;
    let isLastChild = dayIndex === 6;
    return (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$5d847498420df57b), {
        date: props.date,
        className: (renderProps)=>$ecefd708045a9721$var$$f06f4d5597ad704c$var$cellStyles({
                ...renderProps,
                isFirstChild: isFirstChild,
                isLastChild: isLastChild,
                isFirstWeek: isFirstWeek,
                isLastWeek: isLastWeek
            }),
        children: (renderProps)=>(0, $dx4lB.jsx)($ecefd708045a9721$var$$f06f4d5597ad704c$var$CalendarCellInner, {
                ...props,
                weekIndex: weekIndex,
                dayIndex: dayIndex,
                state: state,
                isRangeSelection: !!rangeCalendarStateContext,
                renderProps: renderProps
            })
    });
};
const $ecefd708045a9721$var$$f06f4d5597ad704c$var$CalendarCellInner = (props)=>{
    let { dayIndex: dayIndex, date: date, renderProps: renderProps, state: state, isRangeSelection: isRangeSelection } = props;
    let ref = (0, $eF4cA.useRef)(null);
    let { isUnavailable: isUnavailable, formattedDate: formattedDate, isSelected: isSelected, isSelectionStart: isSelectionStart, isSelectionEnd: isSelectionEnd, isInvalid: isInvalid } = renderProps;
    // only apply the selection start/end styles if the start/end date is actually selectable (aka not unavailable)
    // or if the range is invalid and thus we still want to show the styles even if the start/end date is an unavailable one
    isSelectionStart = isSelectionStart && (!isUnavailable || isInvalid);
    isSelectionEnd = isSelectionEnd && (!isUnavailable || isInvalid);
    let isDateInRange = (checkDate)=>{
        if (!('highlightedRange' in state) || !state.highlightedRange) return state.isSelected(checkDate);
        // if invalid, check if date is within the full range boundaries
        if (isInvalid) return checkDate.compare(state.highlightedRange.start) >= 0 && checkDate.compare(state.highlightedRange.end) <= 0;
        return state.isSelected(checkDate);
    };
    let prevDay = date.subtract({
        days: 1
    });
    let nextDay = date.add({
        days: 1
    });
    let isFirstDayInWeek = dayIndex === 0;
    let isLastDayInWeek = dayIndex === 6;
    let isPreviousDayNotSelected = !prevDay || !isDateInRange(prevDay) || prevDay.month !== props.date.month;
    let isNextDayNotSelected = !nextDay || !isDateInRange(nextDay) || nextDay.month !== props.date.month;
    // when invalid, show background for all selected dates (including unavailable) to make continuous range appearance
    // when valid, only show background for available selected dates
    let isBackgroundStyleApplied = isSelected && isRangeSelection && (isInvalid || !isUnavailable) && (isDateInRange(prevDay) || nextDay.month === date.month && isDateInRange(nextDay));
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsxs)("div", {
        className: " _Pc182 Za182 Fb182",
        children: [
            (0, $dx4lB.jsxs)("div", {
                ref: ref,
                style: (0, $i93Vd.pressScale)(ref, {})(renderProps),
                className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$cellInnerStyles({
                    ...renderProps,
                    isSelectionStart: isSelectionStart,
                    isSelectionEnd: isSelectionEnd,
                    selectionMode: isRangeSelection ? 'range' : 'single'
                }),
                children: [
                    (0, $dx4lB.jsx)("div", {
                        className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$todayStyles(renderProps),
                        role: "presentation"
                    }),
                    (0, $dx4lB.jsx)("div", {
                        children: formattedDate
                    }),
                    isUnavailable && (0, $dx4lB.jsx)("div", {
                        className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$unavailableStyles,
                        role: "presentation"
                    })
                ]
            }),
            isBackgroundStyleApplied && (0, $dx4lB.jsx)("div", {
                className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$selectionBackgroundStyles({
                    isInvalid: isInvalid,
                    isFirstDayInWeek: isFirstDayInWeek,
                    isLastDayInWeek: isLastDayInWeek,
                    isSelectionStart: isSelectionStart,
                    isSelectionEnd: isSelectionEnd,
                    isPreviousDayNotSelected: isPreviousDayNotSelected,
                    isNextDayNotSelected: isNextDayNotSelected
                }),
                role: "presentation"
            }),
            isBackgroundStyleApplied && (0, $dx4lB.jsx)("div", {
                className: $ecefd708045a9721$var$$f06f4d5597ad704c$var$selectionBorderStyles({
                    isInvalid: isInvalid,
                    isFirstDayInWeek: isFirstDayInWeek,
                    isLastDayInWeek: isLastDayInWeek,
                    isSelectionStart: isSelectionStart,
                    isSelectionEnd: isSelectionEnd,
                    isPreviousDayNotSelected: isPreviousDayNotSelected,
                    isNextDayNotSelected: isNextDayNotSelected
                }),
                role: "presentation"
            })
        ]
    });
// oxlint-enable react/react-compiler
};
/**
 * Calculate the week index (0-based) and day index (0-based) for a given date within a month in a
 * calendar.
 *
 * @param date - The date to calculate indices for.
 * @param locale - The locale string (e.g., 'en-US', 'fr-FR', 'hi-IN-u-ca-indian').
 * @param firstDayOfWeek - Optional override for the first day of the week ('sun', 'mon', 'tue',
 *   etc.).
 * @returns Object with weekIndex and dayIndex.
 */ function $ecefd708045a9721$var$$f06f4d5597ad704c$var$useWeekAndDayIndices(date, locale, firstDayOfWeek) {
    let result = (0, $eF4cA.useMemo)(()=>{
        // Get the day index within the week (0-6)
        const dayIndex = (0, $1qrul.getDayOfWeek)(date, locale, firstDayOfWeek);
        const monthStart = (0, $1qrul.startOfMonth)(date);
        // Calculate the week index by finding which week this date falls into
        // within the month's calendar grid
        const monthStartDayOfWeek = (0, $1qrul.getDayOfWeek)(monthStart, locale, firstDayOfWeek);
        const dayOfMonth = date.day;
        const weekIndex = Math.floor((dayOfMonth + monthStartDayOfWeek - 1) / 7);
        const lastDayOfMonth = (0, $1qrul.startOfMonth)(date).add({
            months: 1
        }).subtract({
            days: 1
        });
        const lastWeekIndex = Math.floor((lastDayOfMonth.day + monthStartDayOfWeek - 1) / 7);
        return {
            weekIndex: weekIndex,
            lastWeekIndex: lastWeekIndex,
            dayIndex: dayIndex
        };
    }, [
        date,
        locale,
        firstDayOfWeek
    ]);
    return result;
}



var $208Op = parcelRequire("208Op");

var $8w4Nl = parcelRequire("8w4Nl");

var $fL4LX = parcelRequire("fL4LX");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");


var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $c1ibQ = parcelRequire("c1ibQ");

var $gI8Gw = parcelRequire("gI8Gw");
function $f1fd172007905092$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f1fd172007905092$export$233dd9682e1ad64b = (0, $eF4cA.createContext)(null);
const $f1fd172007905092$var$$ecdee84c2f0ddfb5$var$calendarStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' sd182';
    if (props.isMultiMonth) rules += ' -_4DHzJc-e4mUs182';
    else rules += ' -_4DHzJc-0u6p5b182';
    rules += ' _ta182';
    rules += ' Uj182';
    rules += ' qj182';
    rules += ' __ca182';
    rules += ' -uq4sQ-Sp182';
    rules += ' -LnVzy-ZC182';
    if (props.isMultiMonth) rules += ' -cYDWLb-ZFFQGNb182';
    else rules += ' -cYDWLb-ZnqRBTd182';
    if (props.isMultiMonth) {
        if (!width) rules += ' ZJ182';
    } else if (!width) rules += ' ZRqDA2c182';
    if (props.isMultiMonth) {
        if (!maxWidth) rules += ' Le4mUs182';
    } else if (!maxWidth) rules += ' La182';
    return rules;
};
const $f1fd172007905092$export$a4f5c8b89d277a8d = (0, $eF4cA.forwardRef)(function RangeCalendar(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $f1fd172007905092$export$233dd9682e1ad64b);
    let { visibleMonths: visibleMonths = 1, errorMessage: errorMessage, UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, ...otherProps } = props;
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($f1fd172007905092$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let isMultiMonth = visibleMonths > 1;
    return (0, $dx4lB.jsx)((0, $e283c5f3c36f6582$export$a4f5c8b89d277a8d), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: {
            ...UNSAFE_style,
            '--num-calendars': visibleMonths
        },
        className: (UNSAFE_className || '') + $f1fd172007905092$var$$ecdee84c2f0ddfb5$var$calendarStyles({
            isMultiMonth: isMultiMonth
        }, styles),
        children: ({ isInvalid: isInvalid, isDisabled: isDisabled })=>{
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                        values: [
                            [
                                (0, $208Op.HeaderContext),
                                null
                            ],
                            [
                                (0, $208Op.HeadingContext),
                                null
                            ]
                        ],
                        children: (0, $dx4lB.jsx)((0, $ecefd708045a9721$export$9c75275274db0b56), {
                            visibleMonths: visibleMonths
                        })
                    }),
                    (0, $dx4lB.jsx)("div", {
                        className: " sd182 _tc182 Uj182 qj182 ed182",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>(0, $dx4lB.jsx)((0, $ecefd708045a9721$export$5bd780d491cfc46c), {
                                months: i
                            }, i))
                    }),
                    isInvalid && (0, $dx4lB.jsx)((0, $c1ibQ.Text), {
                        slot: "errorMessage",
                        className: (0, $8w4Nl.helpTextStyles)({
                            isInvalid: isInvalid,
                            isDisabled: isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 2
                        })
                    })
                ]
            });
        }
    });
});


var $33cDE = parcelRequire("33cDE");
var $bTZtY = parcelRequire("bTZtY");
var $208Op = parcelRequire("208Op");

var $1qrul = parcelRequire("1qrul");
var $gbmcw = parcelRequire("gbmcw");

var $eZSya = parcelRequire("eZSya");




var $klXmP = parcelRequire("klXmP");

var $k6waQ = parcelRequire("k6waQ");
var $4kcQz = parcelRequire("4kcQz");
var $7ClmI = parcelRequire("7ClmI");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $f73d2268895379e0$export$9b6f0d7b123aae64 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/admin"]);
const $f73d2268895379e0$export$925a4945a6cd0f3e = async (options = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.get("/users", {}, options);
    if (!response.ok) throw new Error("Failed to fetch users", {
        cause: response
    });
    return response.data.users ?? [];
};
const $f73d2268895379e0$export$d3b1530fc79b0967 = async (filters = {}, options = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.get("/stats", filters, options);
    if (!response.ok) throw new Error("Failed to fetch admin stats", {
        cause: response
    });
    return response.data ?? {};
};
const $f73d2268895379e0$export$40b21af10e19b644 = async (filters = {}, options = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.get("/videos-report", filters, options);
    if (!response.ok) throw new Error("Failed to fetch videos report", {
        cause: response
    });
    return response.data?.videos ?? [];
};
const $f73d2268895379e0$export$ba47b317c4a36d95 = async (filters = {}, options = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.get("/videos", filters, options);
    if (!response.ok) throw new Error("Failed to fetch admin videos", {
        cause: response
    });
    return response.data?.videos ?? [];
};
const $f73d2268895379e0$export$940154dcb3e46230 = async (id, comment, options = {})=>{
    if (!id) throw new Error("Video ID is required to update comment");
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.patch(`/videos/${encodeURIComponent(id)}`, {
        comment: comment
    }, {}, options);
    if (!response.ok) throw new Error("Failed to update project comment", {
        cause: response
    });
    return response.data?.video ?? null;
};
const $f73d2268895379e0$export$ebd51bbfef36defd = async (id, options = {})=>{
    if (!id) throw new Error("Video ID is required to fetch jobs");
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.get(`/videos/${encodeURIComponent(id)}/jobs`, {}, options);
    if (!response.ok) throw new Error("Failed to fetch project jobs", {
        cause: response
    });
    return response.data?.jobs ?? [];
};
const $f73d2268895379e0$export$2da355f7b2dd6afa = async (jobId, options = {})=>{
    if (!jobId) throw new Error("Job ID is required to generate cURL");
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.post(`/jobs/${encodeURIComponent(jobId)}/curl`, {}, options);
    if (!response.ok) {
        const message = response.data?.error?.body?.message || response.data?.message || "Failed to generate cURL for job";
        throw new Error(message, {
            cause: response
        });
    }
    return response.data?.curl ?? "";
};
const $f73d2268895379e0$var$postJobAction = async (jobId, action, fallbackMessage, options)=>{
    if (!jobId) throw new Error("Job ID is required");
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.post(`/jobs/${encodeURIComponent(jobId)}/${action}`, {}, options);
    if (!response.ok) {
        const message = response.data?.error?.body?.message || response.data?.message || fallbackMessage;
        throw new Error(message, {
            cause: response
        });
    }
    return response.data;
};
const $f73d2268895379e0$export$760563377abe0162 = (jobId, options = {})=>$f73d2268895379e0$var$postJobAction(jobId, "retry-upload", "Failed to retry upload", options);
const $f73d2268895379e0$export$6515816325a6d1d9 = (jobId, options = {})=>$f73d2268895379e0$var$postJobAction(jobId, "rerender", "Failed to re-render job", options);
const $f73d2268895379e0$export$9a08864d2743e2a5 = async ({ complex: complex = false, ...options } = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.get("/integrations", {
        complex: complex
    }, options);
    if (!response.ok) throw new Error("Failed to fetch integrations status", {
        cause: response
    });
    return response.data ?? {
        checkedAt: null,
        integrations: []
    };
};
const $f73d2268895379e0$export$84c5acf69a4e2e99 = async ({ complex: complex = false, ...options } = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.post("/integrations/refresh", {}, {
        params: {
            complex: complex
        },
        ...options
    });
    if (!response.ok) throw new Error("Failed to refresh integrations status", {
        cause: response
    });
    return response.data ?? {
        checkedAt: null,
        integrations: []
    };
};
const $f73d2268895379e0$export$a0fe494885eff22a = async (userID, role, options = {})=>{
    const response = await $f73d2268895379e0$export$9b6f0d7b123aae64.patch(`/users/${encodeURIComponent(userID)}/roles`, {
        role: role
    }, {}, options);
    if (!response.ok) throw new Error("Failed to add user role", {
        cause: response
    });
    return response.data?.user ?? null;
};




var $9lDhw = parcelRequire("9lDhw");
const $cc166234f1099697$var$XLSX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const $cc166234f1099697$var$REPORT_COLUMNS = [
    {
        header: "templateId",
        width: 40,
        get: (v)=>v.templateId
    },
    {
        header: "templateType",
        width: 16,
        get: (v)=>v.templateType
    },
    {
        header: "name",
        width: 32,
        get: (v)=>v.name
    },
    {
        header: "id",
        width: 32,
        get: (v)=>v.id
    },
    {
        header: "accountName",
        width: 24,
        get: (v)=>v.accountName
    },
    {
        header: "drNumber",
        width: 16,
        get: (v)=>v.drNumber
    },
    {
        header: "customer.name",
        width: 24,
        get: (v)=>v.customer?.name
    },
    {
        header: "createdBy",
        width: 26,
        get: (v)=>v.createdBy
    },
    {
        header: "createdAt",
        width: 22,
        get: (v)=>v.createdAt
    },
    {
        header: "updatedAt",
        width: 22,
        get: (v)=>v.updatedAt
    },
    {
        header: "videoPath",
        width: 50,
        get: (v)=>v.videoPath
    }
];
const $cc166234f1099697$var$PROJECTS_LIST_COLUMNS = [
    {
        header: "Project",
        width: 32,
        get: (v)=>v.name
    },
    {
        header: "ID",
        width: 36,
        get: (v)=>v.id
    },
    {
        header: "Status",
        width: 14,
        get: (v)=>v.status
    },
    {
        header: "Current Step",
        width: 22,
        get: (v)=>v.currentStepLabel ?? v.currentStep
    },
    {
        header: "Created Date",
        width: 22,
        get: (v)=>v.createdAt
    },
    {
        header: "Last Action Date",
        width: 22,
        get: (v)=>v.updatedAt
    },
    {
        header: "Customer",
        width: 24,
        get: (v)=>v.customerName ?? v.customer?.name
    },
    {
        header: "Account",
        width: 24,
        get: (v)=>v.accountName
    },
    {
        header: "DR Number",
        width: 16,
        get: (v)=>v.drNumber
    },
    {
        header: "Template",
        width: 24,
        get: (v)=>v.templateId
    },
    {
        header: "Template Type",
        width: 16,
        get: (v)=>v.templateType
    },
    {
        header: "Created By",
        width: 28,
        get: (v)=>v.createdBy
    },
    {
        header: "Rate",
        width: 10,
        get: (v)=>v.rating
    },
    {
        header: "Feedback Message",
        width: 40,
        get: (v)=>v.feedbackMessage
    },
    {
        header: "Comment",
        width: 40,
        get: (v)=>v.comment
    },
    {
        header: "Video Path",
        width: 50,
        get: (v)=>v.videoPath
    }
];
const $cc166234f1099697$var$DATE_HEADERS = new Set([
    "createdAt",
    "updatedAt",
    "Created Date",
    "Last Action Date"
]);
const $cc166234f1099697$var$toDate = (value)=>{
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
};
const $cc166234f1099697$var$formatCell = (column, video)=>{
    const value = column.get(video);
    if ($cc166234f1099697$var$DATE_HEADERS.has(column.header)) return $cc166234f1099697$var$toDate(value);
    return value ?? "";
};
const $cc166234f1099697$export$d25a01bf48ae092e = async (videos = [], fileName)=>{
    const workbook = new (0, (/*@__PURE__*/$parcel$interopDefault($1877ffdb17d7d631$exports))).Workbook();
    workbook.created = new Date();
    const sheet = workbook.addWorksheet("Videos");
    sheet.addTable({
        name: "Videos",
        ref: "A1",
        headerRow: true,
        totalsRow: false,
        style: {
            theme: "TableStyleMedium2",
            showRowStripes: true
        },
        columns: $cc166234f1099697$var$REPORT_COLUMNS.map(({ header: header })=>({
                name: header,
                filterButton: true
            })),
        rows: videos.map((video)=>$cc166234f1099697$var$REPORT_COLUMNS.map((column)=>$cc166234f1099697$var$formatCell(column, video)))
    });
    $cc166234f1099697$var$REPORT_COLUMNS.forEach((column, index)=>{
        sheet.getColumn(index + 1).width = column.width;
    });
    const buffer = await workbook.xlsx.writeBuffer();
    (0, $9lDhw.downloadFile)(buffer, fileName ?? `videos-${Date.now()}.xlsx`, $cc166234f1099697$var$XLSX_MIME_TYPE);
};
const $cc166234f1099697$export$b9876c2ab81af0f7 = async (projects = [], fileName)=>{
    const workbook = new (0, (/*@__PURE__*/$parcel$interopDefault($1877ffdb17d7d631$exports))).Workbook();
    workbook.created = new Date();
    const sheet = workbook.addWorksheet("Projects");
    if (projects.length > 0) sheet.addTable({
        name: "Projects",
        ref: "A1",
        headerRow: true,
        totalsRow: false,
        style: {
            theme: "TableStyleMedium2",
            showRowStripes: true
        },
        columns: $cc166234f1099697$var$PROJECTS_LIST_COLUMNS.map(({ header: header })=>({
                name: header,
                filterButton: true
            })),
        rows: projects.map((project)=>$cc166234f1099697$var$PROJECTS_LIST_COLUMNS.map((column)=>$cc166234f1099697$var$formatCell(column, project)))
    });
    else sheet.addRow($cc166234f1099697$var$PROJECTS_LIST_COLUMNS.map(({ header: header })=>header));
    $cc166234f1099697$var$PROJECTS_LIST_COLUMNS.forEach((column, index)=>{
        sheet.getColumn(index + 1).width = column.width;
    });
    const buffer = await workbook.xlsx.writeBuffer();
    (0, $9lDhw.downloadFile)(buffer, fileName ?? `projects-${Date.now()}.xlsx`, $cc166234f1099697$var$XLSX_MIME_TYPE);
};



var $ikOQe = parcelRequire("ikOQe");
const $b3b2a8c2d9d2a080$export$20540e1f21686c96 = {
    all: [
        "admin"
    ],
    users: ()=>[
            ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
            "users"
        ],
    stats: (filters)=>[
            ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
            "stats",
            filters
        ],
    videos: (filters = {})=>[
            ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
            "videos",
            filters
        ],
    videoJobs: (videoId)=>[
            ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
            "videoJobs",
            videoId
        ],
    integrations: (complex = false)=>[
            ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
            "integrations",
            {
                complex: complex
            }
        ]
};
const $b3b2a8c2d9d2a080$export$7867f80ccc6b00d2 = (options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $b3b2a8c2d9d2a080$export$20540e1f21686c96.users(),
        queryFn: ({ signal: signal })=>(0, $f73d2268895379e0$export$925a4945a6cd0f3e)({
                signal: signal
            }),
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$b6bb12715c2552b1 = (filters = {}, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $b3b2a8c2d9d2a080$export$20540e1f21686c96.stats(filters),
        queryFn: ({ signal: signal })=>(0, $f73d2268895379e0$export$d3b1530fc79b0967)(filters, {
                signal: signal
            }),
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$9d31f53e121cae5 = (filters = {}, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $b3b2a8c2d9d2a080$export$20540e1f21686c96.videos(filters),
        queryFn: ({ signal: signal })=>(0, $f73d2268895379e0$export$ba47b317c4a36d95)(filters, {
                signal: signal
            }),
        meta: {
            errorMessage: "Failed to load videos. Please try again."
        },
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$cdaa0a1daefb901d = (options = {})=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ id: id, comment: comment }, { signal: signal })=>(0, $f73d2268895379e0$export$940154dcb3e46230)(id, comment, {
                signal: signal
            }),
        onSuccess: (updatedVideo, variables)=>{
            const targetId = updatedVideo?.id ?? variables?.id;
            const nextComment = updatedVideo?.comment ?? variables?.comment ?? "";
            queryClient.setQueriesData({
                queryKey: [
                    ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
                    "videos"
                ]
            }, (videos)=>Array.isArray(videos) ? videos.map((video)=>video.id === targetId ? {
                        ...video,
                        comment: nextComment
                    } : video) : videos);
            if (targetId) queryClient.invalidateQueries({
                queryKey: (0, $ikOQe.videoKey).detail(targetId)
            });
        },
        meta: {
            errorMessage: "Failed to save comment. Please try again."
        },
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$87a82d4f2e1ff95a = (complex = false, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $b3b2a8c2d9d2a080$export$20540e1f21686c96.integrations(complex),
        queryFn: ({ signal: signal })=>(0, $f73d2268895379e0$export$9a08864d2743e2a5)({
                complex: complex,
                signal: signal
            }),
        staleTime: 60000,
        refetchInterval: 60000,
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$c6c5aa14c771926e = (complex = false, options = {})=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ signal: signal } = {})=>(0, $f73d2268895379e0$export$84c5acf69a4e2e99)({
                complex: complex,
                signal: signal
            }),
        onSuccess: (data)=>{
            queryClient.setQueryData($b3b2a8c2d9d2a080$export$20540e1f21686c96.integrations(complex), data);
        },
        meta: {
            errorMessage: "Failed to refresh integration status. Please try again."
        },
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$c711995d69ba8768 = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: async (filters = {})=>{
            const reportName = filters.fromDate && filters.toDate ? `videos-${filters.fromDate}-${filters.toDate}.xlsx` : "videos-all.xlsx";
            const videos = await (0, $f73d2268895379e0$export$40b21af10e19b644)(filters);
            await (0, $cc166234f1099697$export$d25a01bf48ae092e)(videos, reportName);
            return videos.length;
        },
        meta: {
            errorMessage: "Failed to download report. Please try again."
        },
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$da5023b041d9e2d = ()=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ userID: userID, role: role })=>(0, $f73d2268895379e0$export$a0fe494885eff22a)(userID, role),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: $b3b2a8c2d9d2a080$export$20540e1f21686c96.users()
            });
        }
    });
};
const $b3b2a8c2d9d2a080$export$19a586ee513475f7 = (videoId, options = {})=>{
    return (0, $4kcQz.useQuery)({
        queryKey: $b3b2a8c2d9d2a080$export$20540e1f21686c96.videoJobs(videoId),
        queryFn: ({ signal: signal })=>(0, $f73d2268895379e0$export$ebd51bbfef36defd)(videoId, {
                signal: signal
            }),
        enabled: Boolean(videoId),
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$c3bced76471346a3 = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ jobId: jobId }, { signal: signal })=>(0, $f73d2268895379e0$export$2da355f7b2dd6afa)(jobId, {
                signal: signal
            }),
        ...options
    });
};
const $b3b2a8c2d9d2a080$export$834a3f48213c79d1 = (options = {})=>{
    const queryClient = (0, $7ClmI.useQueryClient)();
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ jobId: jobId, action: action }, { signal: signal })=>action === "rerender" ? (0, $f73d2268895379e0$export$6515816325a6d1d9)(jobId, {
                signal: signal
            }) : (0, $f73d2268895379e0$export$760563377abe0162)(jobId, {
                signal: signal
            }),
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    ...$b3b2a8c2d9d2a080$export$20540e1f21686c96.all,
                    "videos"
                ]
            });
        },
        ...options
    });
};


const $b2ed56c0a3f09afd$var$columns = [
    {
        name: "Email",
        id: "userID",
        isRowHeader: true,
        allowsSorting: true
    },
    {
        name: "Role",
        id: "roles",
        allowsSorting: true,
        width: 152
    },
    {
        name: "Videos\u00a0\u00a0\u00a0\u00a0",
        id: "videos",
        align: "end",
        allowsSorting: true,
        width: 120
    }
];
const $b2ed56c0a3f09afd$var$ASSIGNABLE_ROLES = [
    {
        id: "foundry",
        label: "Foundry"
    }
];
const $b2ed56c0a3f09afd$var$Stat = ({ label: label, value: value, size: size = "L" })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    if (props.size === "default") {
                        rules += ' uocJ9TBTb182';
                        rules += ' uod3Euai182';
                        rules += ' uoea182';
                        rules += ' uogb182';
                        rules += ' uohd182';
                        rules += ' uoje182';
                        rules += ' uo2NhKxcl182';
                        rules += ' uoic182';
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "L") {
                        rules += ' uocJ9TBTb182';
                        rules += ' uod3Euai182';
                        rules += ' uoea182';
                        rules += ' uogb182';
                        rules += ' uohd182';
                        rules += ' uoje182';
                        rules += ' uo2NhKxcl182';
                        rules += ' uoic182';
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "M") {
                        rules += ' uocJ9TBTb182';
                        rules += ' uod3Euai182';
                        rules += ' uoea182';
                        rules += ' uogb182';
                        rules += ' uohd182';
                        rules += ' uoje182';
                        rules += ' uo2NhKxcl182';
                        rules += ' uoic182';
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.size === "default") {
                        rules += ' -_6BNtrc-oc182';
                        rules += ' vox182';
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    } else if (props.size === "L") {
                        rules += ' -_6BNtrc-oc182';
                        rules += ' vox182';
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    } else if (props.size === "M") {
                        rules += ' -_6BNtrc-ob182';
                        rules += ' vox182';
                        rules += ' -_6BNtrc-b182';
                        rules += ' vx182';
                    }
                    if (props.size === "default") {
                        rules += ' xofX0cczbc182';
                        rules += ' _xofX0cczba182';
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "L") {
                        rules += ' xofX0cczbc182';
                        rules += ' _xofX0cczba182';
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "M") {
                        rules += ' xofX0cczbc182';
                        rules += ' _xofX0cczba182';
                        rules += ' xc182';
                        rules += ' _xa182';
                        rules += ' xfd182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbc182';
                        rules += ' _xfX0cczba182';
                    }
                    if (props.size === "default") {
                        rules += ' _FonuYUweb182';
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "L") {
                        rules += ' _FonuYUweb182';
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    } else if (props.size === "M") {
                        rules += ' _FonuYUweb182';
                        rules += ' _Fd182';
                        rules += ' _FnuYUweb182';
                    }
                    if (props.size === "default") {
                        rules += ' pon182';
                        rules += ' pn182';
                    } else if (props.size === "L") {
                        rules += ' pon182';
                        rules += ' pn182';
                    } else if (props.size === "M") {
                        rules += ' pon182';
                        rules += ' pn182';
                    }
                    return rules;
                }({
                    size: size
                }),
                children: label
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    if (props.size === "default") {
                        rules += ' uocJ9TBTb182';
                        rules += ' uod3Euai182';
                        rules += ' uoea182';
                        rules += ' uogb182';
                        rules += ' uohd182';
                        rules += ' uoje182';
                        rules += ' uo2NhKxcl182';
                        rules += ' uoic182';
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "L") {
                        rules += ' uocJ9TBTb182';
                        rules += ' uod3Euai182';
                        rules += ' uoea182';
                        rules += ' uogb182';
                        rules += ' uohd182';
                        rules += ' uoje182';
                        rules += ' uo2NhKxcl182';
                        rules += ' uoic182';
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    } else if (props.size === "M") {
                        rules += ' uocJ9TBTb182';
                        rules += ' uod3Euai182';
                        rules += ' uoea182';
                        rules += ' uogb182';
                        rules += ' uohd182';
                        rules += ' uoje182';
                        rules += ' uo2NhKxcl182';
                        rules += ' uoic182';
                        rules += ' uk182';
                        rules += ' ucJ9TBTb182';
                        rules += ' ud3Euai182';
                        rules += ' uea182';
                        rules += ' ugb182';
                        rules += ' uhd182';
                        rules += ' uje182';
                        rules += ' u2NhKxcl182';
                        rules += ' uic182';
                    }
                    if (props.size === "default") {
                        rules += ' -_6BNtrc-owoabcc182';
                        rules += ' vox182';
                        rules += ' -_6BNtrc-lcY1Ce182';
                        rules += ' vx182';
                    } else if (props.size === "L") {
                        rules += ' -_6BNtrc-owoabcc182';
                        rules += ' vox182';
                        rules += ' -_6BNtrc-lcY1Ce182';
                        rules += ' vx182';
                    } else if (props.size === "M") {
                        rules += ' -_6BNtrc-olcY1Ce182';
                        rules += ' vox182';
                        rules += ' -_6BNtrc-g182';
                        rules += ' vx182';
                    }
                    if (props.size === "default") {
                        rules += ' xoX0cczbd182';
                        rules += ' _xoX0cczba182';
                        rules += ' xofX0cczbd182';
                        rules += ' _xofX0cczba182';
                        rules += ' xe182';
                        rules += ' _xa182';
                        rules += ' xX0cczbd182';
                        rules += ' _xX0cczba182';
                        rules += ' xfe182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbd182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "L") {
                        rules += ' xoX0cczbd182';
                        rules += ' _xoX0cczba182';
                        rules += ' xofX0cczbd182';
                        rules += ' _xofX0cczba182';
                        rules += ' xe182';
                        rules += ' _xa182';
                        rules += ' xX0cczbd182';
                        rules += ' _xX0cczba182';
                        rules += ' xfe182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbd182';
                        rules += ' _xfX0cczba182';
                    } else if (props.size === "M") {
                        rules += ' xoX0cczbd182';
                        rules += ' _xoX0cczba182';
                        rules += ' xofX0cczbd182';
                        rules += ' _xofX0cczba182';
                        rules += ' xe182';
                        rules += ' _xa182';
                        rules += ' xX0cczbd182';
                        rules += ' _xX0cczba182';
                        rules += ' xfe182';
                        rules += ' _xfa182';
                        rules += ' xfX0cczbd182';
                        rules += ' _xfX0cczba182';
                    }
                    rules += ' _F2mU182';
                    if (props.size === "default") {
                        rules += ' poo182';
                        rules += ' po182';
                    } else if (props.size === "L") {
                        rules += ' poo182';
                        rules += ' po182';
                    } else if (props.size === "M") {
                        rules += ' poo182';
                        rules += ' po182';
                    }
                    return rules;
                }({
                    size: size
                }),
                children: value
            })
        ]
    });
const $b2ed56c0a3f09afd$var$datePresets = {
    "FY26 Q1": {
        start: (0, $gbmcw.parseDate)("2025-11-29"),
        end: (0, $gbmcw.parseDate)("2026-02-27")
    },
    "FY26 Q2": {
        start: (0, $gbmcw.parseDate)("2026-02-28"),
        end: (0, $gbmcw.parseDate)("2026-05-29")
    },
    "FY26 Q3": {
        start: (0, $gbmcw.parseDate)("2026-05-30"),
        end: (0, $gbmcw.parseDate)("2026-08-28")
    },
    "FY26 Q4": {
        start: (0, $gbmcw.parseDate)("2026-08-29"),
        end: (0, $gbmcw.parseDate)("2026-11-27")
    },
    "FY27 Q1": {
        start: (0, $gbmcw.parseDate)("2026-11-28"),
        end: (0, $gbmcw.parseDate)("2027-03-05")
    },
    "FY27 Q2": {
        start: (0, $gbmcw.parseDate)("2027-03-06"),
        end: (0, $gbmcw.parseDate)("2027-06-04")
    },
    "FY27 Q3": {
        start: (0, $gbmcw.parseDate)("2027-06-05"),
        end: (0, $gbmcw.parseDate)("2027-09-03")
    },
    "FY27 Q4": {
        start: (0, $gbmcw.parseDate)("2027-09-04"),
        end: (0, $gbmcw.parseDate)("2027-12-03")
    }
};
const $b2ed56c0a3f09afd$var$currentQuarter = Object.entries($b2ed56c0a3f09afd$var$datePresets).find(([key, { start: start, end: end }])=>{
    const now = new Date();
    return now >= start.toDate((0, $1qrul.getLocalTimeZone)()) && now <= end.toDate((0, $1qrul.getLocalTimeZone)());
})?.reduce((acc, val)=>typeof val === "string" ? {
        ...acc,
        key: val
    } : {
        ...acc,
        ...val
    }, {});
const $b2ed56c0a3f09afd$export$533df511bb77d595 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Users"
        }
    ]);
    const [isTotalRange, setTotalRange] = (0, $eF4cA.useState)(false);
    const [range, setRange] = (0, $eF4cA.useState)({
        start: $b2ed56c0a3f09afd$var$currentQuarter?.start ?? $b2ed56c0a3f09afd$var$datePresets["FY26 Q2"].start,
        end: $b2ed56c0a3f09afd$var$currentQuarter?.end ?? $b2ed56c0a3f09afd$var$datePresets["FY26 Q2"].end
    });
    const reportFilters = isTotalRange ? {} : {
        fromDate: range.start.toString(),
        toDate: range.end.toString()
    };
    const adminStats = (0, $b3b2a8c2d9d2a080$export$b6bb12715c2552b1)(reportFilters);
    const adminUsers = (0, $b3b2a8c2d9d2a080$export$7867f80ccc6b00d2)();
    const addUserRoleMutation = (0, $b3b2a8c2d9d2a080$export$da5023b041d9e2d)();
    const downloadReport = (0, $b3b2a8c2d9d2a080$export$c711995d69ba8768)();
    const [sortDescriptor, setSortDescriptor] = (0, $eF4cA.useState)(null);
    const [filter, setFilter] = (0, $eF4cA.useState)({});
    const deferredFilter = (0, $eF4cA.useDeferredValue)(filter);
    const [hoveredUserId, setHoveredUserId] = (0, $eF4cA.useState)(null);
    const [openMenuUserId, setOpenMenuUserId] = (0, $eF4cA.useState)(null);
    const formatter = (0, $eZSya.useDateFormatter)({
        dateStyle: "long"
    });
    const rows = (0, $eF4cA.useMemo)(()=>{
        let sortedRows = [
            ...adminUsers.data ?? []
        ];
        if (sortDescriptor) sortedRows = adminUsers.data?.toSorted((a, b)=>{
            let [first, second] = [
                a[sortDescriptor.column],
                b[sortDescriptor.column]
            ].map((field)=>{
                if (typeof field === "string") field = field.toLowerCase();
                else if (Array.isArray(field)) field = field.join(" ").toLowerCase();
                return field;
            });
            if (!second) return -1;
            let cmp = first < second ? -1 : 1;
            if (sortDescriptor.direction === "descending") cmp = -cmp;
            return cmp;
        }) ?? [];
        let filteredRows = [
            ...sortedRows
        ];
        if (Object.keys(filter).length > 0) filteredRows = sortedRows.filter((row)=>{
            return Object.entries(deferredFilter).every(([key, value])=>{
                if (!value) return true;
                const field = row[key];
                if (typeof field === "string") return field.toLowerCase().includes(value.toLowerCase());
                else if (Array.isArray(field)) return field.some((item)=>item.toLowerCase().includes(value.toLowerCase()));
                return false;
            });
        });
        return filteredRows;
    }, [
        adminUsers.data,
        sortDescriptor,
        deferredFilter
    ]);
    const [presetValue, setPresetValue] = (0, $eF4cA.useState)($b2ed56c0a3f09afd$var$currentQuarter?.key ?? null);
    const quarterOptions = (0, $eF4cA.useMemo)(()=>{
        return Object.entries($b2ed56c0a3f09afd$var$datePresets).map(([key, { start: start, end: end }])=>({
                key: key,
                label: `${formatter.formatRange(start.toDate((0, $1qrul.getLocalTimeZone)()), end.toDate((0, $1qrul.getLocalTimeZone)()))}`,
                start: start,
                end: end
            }));
    }, [
        formatter
    ]);
    const handlePresetChange = (key)=>{
        const preset = $b2ed56c0a3f09afd$var$datePresets[key];
        if (preset) {
            setRange({
                start: preset.start,
                end: preset.end
            });
            setPresetValue(key);
            setTotalRange(false);
        }
    };
    const handleRangeChange = (newRange)=>{
        setRange(newRange);
        setPresetValue(null);
        setTotalRange(false);
    };
    const handleTotalRangeChange = (isTotal)=>{
        setTotalRange(isTotal);
        if (isTotal) setPresetValue(null);
        else if ($b2ed56c0a3f09afd$var$currentQuarter) {
            setRange({
                start: $b2ed56c0a3f09afd$var$currentQuarter.start,
                end: $b2ed56c0a3f09afd$var$currentQuarter.end
            });
            setPresetValue($b2ed56c0a3f09afd$var$currentQuarter.key);
        }
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " se182 CoLnOtVc182 CylJrL182 DoVrjvOd182 DfQhdHc182 EoVlEZSb182 EIDldwc182 _ch182 qr182 Uj182 Za182 Fb182 KobujWCd182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                children: "Users"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " zOdHsPe182 yOdHsPe182 BOdHsPe182 AOdHsPe182",
                children: Object.values(deferredFilter).filter(Boolean).length > 0 && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bTZtY.TagGroup), {
                    label: "Filters",
                    size: "S",
                    onRemove: ([key])=>setFilter((old)=>({
                                ...old,
                                [key]: ""
                            })),
                    children: Object.entries(deferredFilter).map(([key, value])=>!!value && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $bTZtY.Tag), {
                            id: key,
                            children: [
                                key,
                                ": ",
                                value
                            ]
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b3c27e869d856b7), {
                "aria-label": "All users",
                sortDescriptor: sortDescriptor ?? undefined,
                onSortChange: setSortDescriptor,
                renderEmptyState: ()=>"No users found",
                overflowMode: "wrap",
                styles: " zbgmNs182 ybgmNs182 BbgmNs182 AbgmNs182 Ka182 Foe4mUs182 F1PF0Dd182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f850895b287ef28e), {
                        columns: $b2ed56c0a3f09afd$var$columns,
                        children: (column)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$816b5d811295e6bc), {
                                showDivider: column.showDivider,
                                align: column.align,
                                isRowHeader: column.isRowHeader,
                                allowsSorting: column.allowsSorting,
                                width: column.width,
                                menuItems: column.id === "userID" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dx4lB.Fragment), {
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuSection), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.SubmenuTrigger), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                                    children: "Filter"
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d93ff4dc67afc7e$export$b94867ecbd698f21), {
                                                        placeholder: `Filter by ${column.name.toLowerCase()}`,
                                                        defaultValue: filter[column.id],
                                                        onChange: (value)=>setFilter((old)=>({
                                                                    ...old,
                                                                    [column.id]: value
                                                                })),
                                                        autoFocus: true,
                                                        styles: " Zd4Eyud182"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                children: column.name
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$76ccd210b9029917), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                            items: rows,
                            dependencies: [],
                            children: (user)=>{
                                const userRoles = user.roles ?? [];
                                const missingRoles = $b2ed56c0a3f09afd$var$ASSIGNABLE_ROLES.filter((r)=>!userRoles.includes(r.id));
                                const canAddRole = missingRoles.length > 0;
                                const showAddTrigger = canAddRole && (hoveredUserId === user.userID || openMenuUserId === user.userID);
                                const isSavingRole = addUserRoleMutation.isPending && addUserRoleMutation.variables?.userID === user.userID;
                                const rowPointerProps = {
                                    onPointerEnter: ()=>setHoveredUserId(user.userID),
                                    onPointerLeave: (e)=>{
                                        const tr = e.currentTarget?.closest?.("tr") ?? null;
                                        if (tr && e.relatedTarget instanceof Node && tr.contains(e.relatedTarget)) return;
                                        setHoveredUserId((id)=>id === user.userID ? null : id);
                                    }
                                };
                                return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b59bdbef9ce70de2), {
                                    id: user.userID,
                                    href: `/projects/user/${user.userID}`,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            ...rowPointerProps,
                                            children: user.userID
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            ...rowPointerProps,
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 Ub182 qb182 _wb182 eb182",
                                                children: [
                                                    user.roles?.map((role)=>/*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                            className: " sh182",
                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                                size: "S",
                                                                variant: "accent",
                                                                fillStyle: "subtle",
                                                                children: role
                                                            })
                                                        }, role)),
                                                    canAddRole && /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                        onPointerDown: (e)=>e.stopPropagation(),
                                                        onClick: (e)=>e.stopPropagation(),
                                                        className: " sh182 eb182 N8KB0xb182 _Ca182",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuTrigger), {
                                                            isOpen: openMenuUserId === user.userID,
                                                            onOpenChange: (open)=>setOpenMenuUserId(open ? user.userID : null),
                                                            children: [
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                    isQuiet: true,
                                                                    size: "S",
                                                                    "aria-label": `Add role for ${user.userID}`,
                                                                    isDisabled: isSavingRole,
                                                                    UNSAFE_style: {
                                                                        opacity: showAddTrigger ? 1 : 0,
                                                                        pointerEvents: showAddTrigger ? "auto" : "none",
                                                                        transition: "opacity 150ms ease"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $eb8f55a238917802$export$2e2bcd8739ae039), {})
                                                                }),
                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.Menu), {
                                                                    "aria-label": `Add role for ${user.userID}`,
                                                                    onAction: (key)=>{
                                                                        addUserRoleMutation.mutate({
                                                                            userID: user.userID,
                                                                            role: String(key)
                                                                        });
                                                                    },
                                                                    children: missingRoles.map((r)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $8wD3p.MenuItem), {
                                                                            id: r.id,
                                                                            textValue: r.label,
                                                                            isDisabled: isSavingRole,
                                                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                children: r.label
                                                                            })
                                                                        }, r.id))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            align: "end",
                                            children: [
                                                user.videos?.length ?? 0,
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $68b9d6b3f9506984$export$2e2bcd8739ae039), {
                                                    styles: " Zh182 Fi182 Iv182"
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " ziafLs182 yiafLs182 BiafLs182 AiafLs182 sd182 _ta182 Uj182 qj182 Poa182 Pe4mUs182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " sd182 Uj182 qj182 ec182",
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                            label: "Total users",
                            value: adminStats.data?.totalUsers ?? 0
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 Ue182 qe182 eb182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fd182 _FnuYUweb182 pt182",
                                children: "Date range:"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                        isQuiet: true,
                                        staticColor: "auto",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            children: isTotalRange ? "All time" : formatter.formatRange(range.start.toDate((0, $1qrul.getLocalTimeZone)()), range.end.toDate((0, $1qrul.getLocalTimeZone)()))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                            className: " Tf182 Qf182 Sf182 Rf182 sd182 _ta182 Ul182 ql182",
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $f1fd172007905092$export$a4f5c8b89d277a8d), {
                                                    value: range,
                                                    onChange: handleRangeChange,
                                                    visibleMonths: 2,
                                                    selectionAlignment: "end",
                                                    defaultFocusedValue: range.end,
                                                    isDisabled: isTotalRange
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                    className: " sd182 eb182 _Ce182",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                                                            isSelected: isTotalRange,
                                                            onChange: handleTotalRangeChange,
                                                            children: "Show all time data"
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                                            label: "Presets",
                                                            items: quarterOptions,
                                                            value: presetValue,
                                                            onChange: handlePresetChange,
                                                            labelPosition: "side",
                                                            menuWidth: 280,
                                                            children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                                    textValue: item.label,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                            slot: "label",
                                                                            children: item.key
                                                                        }),
                                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                            slot: "description",
                                                                            children: item.label
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 Ug182 qg182 eb182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-f182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isQuiet: true,
                                size: "S",
                                staticColor: "auto",
                                isDisabled: downloadReport.isPending,
                                onPress: ()=>downloadReport.mutate(reportFilters),
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: downloadReport.isPending ? "Preparing\u2026" : "Download report"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 Uj182 qj182 ec182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                label: "Created videos",
                                value: adminStats.data?.totalVideos ?? 0
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                label: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                    children: [
                                        "Created videos",
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "(w/ account or DR)"
                                        })
                                    ]
                                }),
                                value: adminStats.data?.generatedVideos ?? 0
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                label: "# DR numbers",
                                value: adminStats.data?.totalDrNumbers ?? 0
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                label: "# Account names",
                                value: adminStats.data?.totalAccountNames ?? 0
                            })
                        ]
                    }),
                    adminStats.data?.templateTypes?.map((template)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $eF4cA.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8Muzv.Divider), {
                                    size: "M"
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xd182 _xa182 xX0cczbc182 _xX0cczba182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                                            children: "Template:"
                                        }),
                                        " ",
                                        template.templateId
                                    ]
                                }),
                                /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 Uj182 qj182 ec182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                            label: "Created videos",
                                            value: template.total,
                                            size: "M"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                            label: `(w/ account or DR)`,
                                            value: template.withDR,
                                            size: "M"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                            label: "# DR numbers",
                                            value: template.drNumbers ?? 0,
                                            size: "M"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)($b2ed56c0a3f09afd$var$Stat, {
                                            label: "# Account names",
                                            value: template.accountNames ?? 0,
                                            size: "M"
                                        })
                                    ]
                                })
                            ]
                        }, template.templateId))
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $7ClmI = parcelRequire("7ClmI");


var $4W5AG = parcelRequire("4W5AG");
var $gc2oq = parcelRequire("gc2oq");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $3g2oV = parcelRequire("3g2oV");



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $a33b5e56e66e3f74$var$$2d13361ea962c695$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            (0, $dx4lB.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.337.75.75V7h-13V5.25c0-.413.336-.75.75-.75m11.5 12H4.25c-.414 0-.75-.337-.75-.75V8.5h13v7.25c0 .413-.336.75-.75.75"
            }),
            (0, $dx4lB.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 10,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            (0, $dx4lB.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 10,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            (0, $dx4lB.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 10,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            (0, $dx4lB.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 13,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            (0, $dx4lB.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 13,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            (0, $dx4lB.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 13,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            })
        ]
    });
const $a33b5e56e66e3f74$var$$2d13361ea962c695$var$ForwardRef = (0, $eF4cA.forwardRef)($a33b5e56e66e3f74$var$$2d13361ea962c695$var$SvgComponent);
var $a33b5e56e66e3f74$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($a33b5e56e66e3f74$var$$2d13361ea962c695$var$ForwardRef);




var $8w4Nl = parcelRequire("8w4Nl");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $fDYaM = parcelRequire("fDYaM");

var $4kYL7 = parcelRequire("4kYL7");

var $i0SpD = parcelRequire("i0SpD");

var $cTXxz = parcelRequire("cTXxz");

var $gbmcw = parcelRequire("gbmcw");
var $8jDkV = parcelRequire("8jDkV");

var $fvyIQ = parcelRequire("fvyIQ");

var $eF4cA = parcelRequire("eF4cA");

var $31fH3 = parcelRequire("31fH3");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0f0c58a9d2f73818$var$$5a15223dacad897a$var$dateSegments = [
    'day',
    'month',
    'year'
];
const $0f0c58a9d2f73818$var$$5a15223dacad897a$var$granularityMap = {
    hour: 1,
    minute: 2,
    second: 3
};
function $0f0c58a9d2f73818$export$f6a685cd1acbd1fa(props, state) {
    let { autoComplete: autoComplete, isDisabled: isDisabled, name: name } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $31fH3.useVisuallyHidden)({
        style: {
            // Prevent page scrolling.
            position: 'fixed',
            top: 0,
            left: 0
        }
    });
    let inputStep = 60;
    if (state.granularity === 'second') inputStep = 1;
    else if (state.granularity === 'hour') inputStep = 3600;
    let dateValue = '';
    if (state.value) {
        if (state.granularity === 'day') dateValue = (0, $8jDkV.toCalendarDate)(state.value).toString();
        else dateValue = (0, $8jDkV.toCalendarDateTime)('timeZone' in state.value ? (0, $8jDkV.toLocalTimeZone)(state.value) : state.value).toString();
    }
    let inputType = state.granularity === 'day' ? 'date' : 'datetime-local';
    let timeSegments = [
        'hour',
        'minute',
        'second'
    ];
    // Depending on the granularity, we only want to validate certain time segments
    let end = 0;
    if (timeSegments.includes(state.granularity)) {
        end = $0f0c58a9d2f73818$var$$5a15223dacad897a$var$granularityMap[state.granularity];
        timeSegments = timeSegments.slice(0, end);
    }
    return {
        containerProps: {
            ...visuallyHiddenProps,
            'aria-hidden': true,
            // @ts-ignore
            ['data-react-aria-prevent-focus']: true,
            // @ts-ignore
            ['data-a11y-ignore']: 'aria-hidden-focus'
        },
        inputProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            type: inputType,
            // We set the form prop to an empty string to prevent the hidden date input's value from being submitted
            form: '',
            name: name,
            step: inputStep,
            value: dateValue,
            onChange: (e)=>{
                let targetString = (0, $fvyIQ.getEventTarget)(e).value.toString();
                if (targetString) try {
                    let targetValue = (0, $gbmcw.parseDateTime)(targetString);
                    if (state.granularity === 'day') targetValue = (0, $gbmcw.parseDate)(targetString);
                    // We check to to see if setSegment exists in the state since it only exists in DateFieldState and not DatePickerState.
                    // The setValue method has different behavior depending on if it's coming from DateFieldState or DatePickerState.
                    // In DateFieldState, setValue firsts checks to make sure that each segment is filled before committing the newValue
                    // which is why in the code below we first set each segment to validate it before committing the new value.
                    // However, in DatePickerState, since we have to be able to commit values from the Calendar popover, we are also able to
                    // set a new value when the field itself is empty.
                    if ('setSegment' in state) for(let type in targetValue){
                        // eslint-disable-next-line max-depth
                        if ($0f0c58a9d2f73818$var$$5a15223dacad897a$var$dateSegments.includes(type)) state.setSegment(type, targetValue[type]);
                        // eslint-disable-next-line max-depth
                        if (timeSegments.includes(type)) state.setSegment(type, targetValue[type]);
                    }
                    state.setValue(targetValue);
                } catch  {
                // ignore
                }
            }
        }
    };
}
function $0f0c58a9d2f73818$export$eefa3e19139f00f3(props) {
    let { state: state } = props;
    let { containerProps: containerProps, inputProps: inputProps } = $0f0c58a9d2f73818$export$f6a685cd1acbd1fa({
        ...props
    }, state);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("div", {
        ...containerProps,
        "data-testid": "hidden-dateinput-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement("input", inputProps));
}



var $ecbit = parcelRequire("ecbit");

var $8UElq = parcelRequire("8UElq");

var $c1ibQ = parcelRequire("c1ibQ");

var $6pgkA = parcelRequire("6pgkA");

var $fVfXf = parcelRequire("fVfXf");
var $d66b55eb8c7a5938$export$2e2bcd8739ae039 = {};
$d66b55eb8c7a5938$export$2e2bcd8739ae039 = {
    "calendar": `\u{627}\u{644}\u{62A}\u{642}\u{648}\u{64A}\u{645}`,
    "day": `\u{64A}\u{648}\u{645}`,
    "dayPeriod": `\u{635}/\u{645}`,
    "endDate": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    "era": `\u{627}\u{644}\u{639}\u{635}\u{631}`,
    "hour": `\u{627}\u{644}\u{633}\u{627}\u{639}\u{627}\u{62A}`,
    "minute": `\u{627}\u{644}\u{62F}\u{642}\u{627}\u{626}\u{642}`,
    "month": `\u{627}\u{644}\u{634}\u{647}\u{631}`,
    "second": `\u{627}\u{644}\u{62B}\u{648}\u{627}\u{646}\u{64A}`,
    "selectedDateDescription": (args)=>`\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62D}\u{62F}\u{62F}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{627}\u{644}\u{645}\u{62F}\u{649} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.startDate} \u{625}\u{644}\u{649} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.time}`,
    "startDate": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    "timeZoneName": `\u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{62A}`,
    "weekday": `\u{627}\u{644}\u{64A}\u{648}\u{645}`,
    "year": `\u{627}\u{644}\u{633}\u{646}\u{629}`
};


var $6bb7a65c49df9f6d$export$2e2bcd8739ae039 = {};
$6bb7a65c49df9f6d$export$2e2bcd8739ae039 = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}`,
    "day": `\u{434}\u{435}\u{43D}`,
    "dayPeriod": `\u{43F}\u{440}.\u{43E}\u{431}./\u{441}\u{43B}.\u{43E}\u{431}.`,
    "endDate": `\u{41A}\u{440}\u{430}\u{439}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{447}\u{430}\u{441}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
    "month": `\u{43C}\u{435}\u{441}\u{435}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.startDate} \u{434}\u{43E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}: ${args.time}`,
    "startDate": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{430} \u{437}\u{43E}\u{43D}\u{430}`,
    "weekday": `\u{434}\u{435}\u{43D} \u{43E}\u{442} \u{441}\u{435}\u{434}\u{43C}\u{438}\u{446}\u{430}\u{442}\u{430}`,
    "year": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`
};


var $3d40de3255047bca$export$2e2bcd8739ae039 = {};
$3d40de3255047bca$export$2e2bcd8739ae039 = {
    "calendar": `Kalend\xe1\u{159}`,
    "day": `den`,
    "dayPeriod": `\u{10D}\xe1st dne`,
    "endDate": `Kone\u{10D}n\xe9 datum`,
    "era": `letopo\u{10D}et`,
    "hour": `hodina`,
    "minute": `minuta`,
    "month": `m\u{11B}s\xedc`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Vybran\xe9 datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybran\xe9 obdob\xed: ${args.startDate} a\u{17E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vybran\xfd \u{10D}as: ${args.time}`,
    "startDate": `Po\u{10D}\xe1te\u{10D}n\xed datum`,
    "timeZoneName": `\u{10D}asov\xe9 p\xe1smo`,
    "weekday": `den v t\xfddnu`,
    "year": `rok`
};


var $39741969291761ec$export$2e2bcd8739ae039 = {};
$39741969291761ec$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `AM/PM`,
    "endDate": `Slutdato`,
    "era": `\xe6ra`,
    "hour": `time`,
    "minute": `minut`,
    "month": `m\xe5ned`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt interval: ${args.startDate} til ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valgt tidspunkt: ${args.time}`,
    "startDate": `Startdato`,
    "timeZoneName": `tidszone`,
    "weekday": `ugedag`,
    "year": `\xe5r`
};


var $eed20e58bf0f36cc$export$2e2bcd8739ae039 = {};
$eed20e58bf0f36cc$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `Tag`,
    "dayPeriod": `Tagesh\xe4lfte`,
    "endDate": `Enddatum`,
    "era": `Epoche`,
    "hour": `Stunde`,
    "minute": `Minute`,
    "month": `Monat`,
    "second": `Sekunde`,
    "selectedDateDescription": (args)=>`Ausgew\xe4hltes Datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Ausgew\xe4hlter Bereich: ${args.startDate} bis ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ausgew\xe4hlte Zeit: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `Zeitzone`,
    "weekday": `Wochentag`,
    "year": `Jahr`
};


var $eb0257a12e6eb700$export$2e2bcd8739ae039 = {};
$eb0257a12e6eb700$export$2e2bcd8739ae039 = {
    "calendar": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BB}\u{3CC}\u{3B3}\u{3B9}\u{3BF}`,
    "day": `\u{3B7}\u{3BC}\u{3AD}\u{3C1}\u{3B1}`,
    "dayPeriod": `\u{3C0}.\u{3BC}./\u{3BC}.\u{3BC}.`,
    "endDate": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}`,
    "era": `\u{3C0}\u{3B5}\u{3C1}\u{3AF}\u{3BF}\u{3B4}\u{3BF}\u{3C2}`,
    "hour": `\u{3CE}\u{3C1}\u{3B1}`,
    "minute": `\u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3CC}`,
    "month": `\u{3BC}\u{3AE}\u{3BD}\u{3B1}\u{3C2}`,
    "second": `\u{3B4}\u{3B5}\u{3C5}\u{3C4}\u{3B5}\u{3C1}\u{3CC}\u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3BF}`,
    "selectedDateDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C2}: ${args.startDate} \u{3AD}\u{3C9}\u{3C2} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3CE}\u{3C1}\u{3B1}: ${args.time}`,
    "startDate": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2}`,
    "timeZoneName": `\u{3B6}\u{3CE}\u{3BD}\u{3B7} \u{3CE}\u{3C1}\u{3B1}\u{3C2}`,
    "weekday": `\u{3BA}\u{3B1}\u{3B8}\u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3B9}\u{3BD}\u{3AE}`,
    "year": `\u{3AD}\u{3C4}\u{3BF}\u{3C2}`
};


var $aaed5d594d467ccf$export$2e2bcd8739ae039 = {};
$aaed5d594d467ccf$export$2e2bcd8739ae039 = {
    "era": `era`,
    "year": `year`,
    "month": `month`,
    "day": `day`,
    "hour": `hour`,
    "minute": `minute`,
    "second": `second`,
    "dayPeriod": `AM/PM`,
    "calendar": `Calendar`,
    "startDate": `Start Date`,
    "endDate": `End Date`,
    "weekday": `day of the week`,
    "timeZoneName": `time zone`,
    "selectedDateDescription": (args)=>`Selected Date: ${args.date}`,
    "selectedRangeDescription": (args)=>`Selected Range: ${args.startDate} to ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Selected Time: ${args.time}`
};


var $8d2f807d578e7d23$export$2e2bcd8739ae039 = {};
$8d2f807d578e7d23$export$2e2bcd8739ae039 = {
    "calendar": `Calendario`,
    "day": `d\xeda`,
    "dayPeriod": `a.\xa0m./p.\xa0m.`,
    "endDate": `Fecha final`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `mes`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Fecha seleccionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Rango seleccionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora seleccionada: ${args.time}`,
    "startDate": `Fecha de inicio`,
    "timeZoneName": `zona horaria`,
    "weekday": `d\xeda de la semana`,
    "year": `a\xf1o`
};


var $b4603fb3e32c714a$export$2e2bcd8739ae039 = {};
$b4603fb3e32c714a$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `p\xe4ev`,
    "dayPeriod": `enne/p\xe4rast l\xf5unat`,
    "endDate": `L\xf5ppkuup\xe4ev`,
    "era": `ajastu`,
    "hour": `tund`,
    "minute": `minut`,
    "month": `kuu`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valitud kuup\xe4ev: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valitud vahemik: ${args.startDate} kuni ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valitud aeg: ${args.time}`,
    "startDate": `Alguskuup\xe4ev`,
    "timeZoneName": `ajav\xf6\xf6nd`,
    "weekday": `n\xe4dalap\xe4ev`,
    "year": `aasta`
};


var $56082e10b9d34397$export$2e2bcd8739ae039 = {};
$56082e10b9d34397$export$2e2bcd8739ae039 = {
    "calendar": `Kalenteri`,
    "day": `p\xe4iv\xe4`,
    "dayPeriod": `vuorokaudenaika`,
    "endDate": `P\xe4\xe4ttymisp\xe4iv\xe4`,
    "era": `aikakausi`,
    "hour": `tunti`,
    "minute": `minuutti`,
    "month": `kuukausi`,
    "second": `sekunti`,
    "selectedDateDescription": (args)=>`Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valittu aikav\xe4li: ${args.startDate} \u{2013} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valittu aika: ${args.time}`,
    "startDate": `Alkamisp\xe4iv\xe4`,
    "timeZoneName": `aikavy\xf6hyke`,
    "weekday": `viikonp\xe4iv\xe4`,
    "year": `vuosi`
};


var $b5dde0d609798e83$export$2e2bcd8739ae039 = {};
$b5dde0d609798e83$export$2e2bcd8739ae039 = {
    "calendar": `Calendrier`,
    "day": `jour`,
    "dayPeriod": `cadran`,
    "endDate": `Date de fin`,
    "era": `\xe8re`,
    "hour": `heure`,
    "minute": `minute`,
    "month": `mois`,
    "second": `seconde`,
    "selectedDateDescription": (args)=>`Date s\xe9lectionn\xe9e\xa0: ${args.date}`,
    "selectedRangeDescription": (args)=>`Plage s\xe9lectionn\xe9e\xa0: ${args.startDate} au ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Heure choisie\xa0: ${args.time}`,
    "startDate": `Date de d\xe9but`,
    "timeZoneName": `fuseau horaire`,
    "weekday": `jour de la semaine`,
    "year": `ann\xe9e`
};


var $d2d48bf1bb4030a4$export$2e2bcd8739ae039 = {};
$d2d48bf1bb4030a4$export$2e2bcd8739ae039 = {
    "calendar": `\u{5DC}\u{5D5}\u{5D7} \u{5E9}\u{5E0}\u{5D4}`,
    "day": `\u{5D9}\u{5D5}\u{5DD}`,
    "dayPeriod": `\u{5DC}\u{5E4}\u{5E0}\u{5D4}\u{5F4}\u{5E6}/\u{5D0}\u{5D7}\u{5D4}\u{5F4}\u{5E6}`,
    "endDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "era": `\u{5EA}\u{5E7}\u{5D5}\u{5E4}\u{5D4}`,
    "hour": `\u{5E9}\u{5E2}\u{5D4}`,
    "minute": `\u{5D3}\u{5E7}\u{5D4}`,
    "month": `\u{5D7}\u{5D5}\u{5D3}\u{5E9}`,
    "second": `\u{5E9}\u{5E0}\u{5D9}\u{5D9}\u{5D4}`,
    "selectedDateDescription": (args)=>`\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.startDate} \u{5E2}\u{5D3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{5D6}\u{5DE}\u{5DF} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.time}`,
    "startDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "timeZoneName": `\u{5D0}\u{5D6}\u{5D5}\u{5E8} \u{5D6}\u{5DE}\u{5DF}`,
    "weekday": `\u{5D9}\u{5D5}\u{5DD} \u{5D1}\u{5E9}\u{5D1}\u{5D5}\u{5E2}`,
    "year": `\u{5E9}\u{5E0}\u{5D4}`
};


var $3873daa72ddb9382$export$2e2bcd8739ae039 = {};
$3873daa72ddb9382$export$2e2bcd8739ae039 = {
    "calendar": `Kalendar`,
    "day": `dan`,
    "dayPeriod": `AM/PM`,
    "endDate": `Datum zavr\u{161}etka`,
    "era": `era`,
    "hour": `sat`,
    "minute": `minuta`,
    "month": `mjesec`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Odabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Odabrani raspon: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Odabrano vrijeme: ${args.time}`,
    "startDate": `Datum po\u{10D}etka`,
    "timeZoneName": `vremenska zona`,
    "weekday": `dan u tjednu`,
    "year": `godina`
};


var $0a90ccbf0b516b65$export$2e2bcd8739ae039 = {};
$0a90ccbf0b516b65$export$2e2bcd8739ae039 = {
    "calendar": `Napt\xe1r`,
    "day": `nap`,
    "dayPeriod": `napszak`,
    "endDate": `Befejez\u{151} d\xe1tum`,
    "era": `\xe9ra`,
    "hour": `\xf3ra`,
    "minute": `perc`,
    "month": `h\xf3nap`,
    "second": `m\xe1sodperc`,
    "selectedDateDescription": (args)=>`Kijel\xf6lt d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Kijel\xf6lt tartom\xe1ny: ${args.startDate}\u{2013}${args.endDate}`,
    "selectedTimeDescription": (args)=>`Kijel\xf6lt id\u{151}: ${args.time}`,
    "startDate": `Kezd\u{151} d\xe1tum`,
    "timeZoneName": `id\u{151}z\xf3na`,
    "weekday": `h\xe9t napja`,
    "year": `\xe9v`
};


var $3608073526dd80c2$export$2e2bcd8739ae039 = {};
$3608073526dd80c2$export$2e2bcd8739ae039 = {
    "calendar": `Calendario`,
    "day": `giorno`,
    "dayPeriod": `AM/PM`,
    "endDate": `Data finale`,
    "era": `era`,
    "hour": `ora`,
    "minute": `minuto`,
    "month": `mese`,
    "second": `secondo`,
    "selectedDateDescription": (args)=>`Data selezionata: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervallo selezionato: da ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ora selezionata: ${args.time}`,
    "startDate": `Data iniziale`,
    "timeZoneName": `fuso orario`,
    "weekday": `giorno della settimana`,
    "year": `anno`
};


var $45968a10f60613ac$export$2e2bcd8739ae039 = {};
$45968a10f60613ac$export$2e2bcd8739ae039 = {
    "calendar": `\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{5348}\u{524D}/\u{5348}\u{5F8C}`,
    "endDate": `\u{7D42}\u{4E86}\u{65E5}`,
    "era": `\u{6642}\u{4EE3}`,
    "hour": `\u{6642}`,
    "minute": `\u{5206}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8} : ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{629E}\u{7BC4}\u{56F2} : ${args.startDate} \u{304B}\u{3089} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{6642}\u{9593} : ${args.time}`,
    "startDate": `\u{958B}\u{59CB}\u{65E5}`,
    "timeZoneName": `\u{30BF}\u{30A4}\u{30E0}\u{30BE}\u{30FC}\u{30F3}`,
    "weekday": `\u{66DC}\u{65E5}`,
    "year": `\u{5E74}`
};


var $520184c579b62257$export$2e2bcd8739ae039 = {};
$520184c579b62257$export$2e2bcd8739ae039 = {
    "calendar": `\u{B2EC}\u{B825}`,
    "day": `\u{C77C}`,
    "dayPeriod": `\u{C624}\u{C804}/\u{C624}\u{D6C4}`,
    "endDate": `\u{C885}\u{B8CC}\u{C77C}`,
    "era": `\u{C5F0}\u{D638}`,
    "hour": `\u{C2DC}`,
    "minute": `\u{BD84}`,
    "month": `\u{C6D4}`,
    "second": `\u{CD08}`,
    "selectedDateDescription": (args)=>`\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.startDate} ~ ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{C120}\u{D0DD} \u{C2DC}\u{AC04}: ${args.time}`,
    "startDate": `\u{C2DC}\u{C791}\u{C77C}`,
    "timeZoneName": `\u{C2DC}\u{AC04}\u{B300}`,
    "weekday": `\u{C694}\u{C77C}`,
    "year": `\u{B144}`
};


var $bdb5428c7b0ac170$export$2e2bcd8739ae039 = {};
$bdb5428c7b0ac170$export$2e2bcd8739ae039 = {
    "calendar": `Kalendorius`,
    "day": `diena`,
    "dayPeriod": `iki piet\u{173} / po piet\u{173}`,
    "endDate": `Pabaigos data`,
    "era": `era`,
    "hour": `valanda`,
    "minute": `minut\u{117}`,
    "month": `m\u{117}nuo`,
    "second": `sekund\u{117}`,
    "selectedDateDescription": (args)=>`Pasirinkta data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Pasirinktas intervalas: nuo ${args.startDate} iki ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Pasirinktas laikas: ${args.time}`,
    "startDate": `Prad\u{17E}ios data`,
    "timeZoneName": `laiko juosta`,
    "weekday": `savait\u{117}s diena`,
    "year": `metai`
};


var $36317cfb1421aacd$export$2e2bcd8739ae039 = {};
$36317cfb1421aacd$export$2e2bcd8739ae039 = {
    "calendar": `Kalend\u{101}rs`,
    "day": `diena`,
    "dayPeriod": `priek\u{161}pusdien\u{101}/p\u{113}cpusdien\u{101}`,
    "endDate": `Beigu datums`,
    "era": `\u{113}ra`,
    "hour": `stundas`,
    "minute": `min\u{16B}tes`,
    "month": `m\u{113}nesis`,
    "second": `sekundes`,
    "selectedDateDescription": (args)=>`Atlas\u{12B}tais datums: ${args.date}`,
    "selectedRangeDescription": (args)=>`Atlas\u{12B}tais diapazons: no ${args.startDate} l\u{12B}dz ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Atlas\u{12B}tais laiks: ${args.time}`,
    "startDate": `S\u{101}kuma datums`,
    "timeZoneName": `laika josla`,
    "weekday": `ned\u{113}\u{13C}as diena`,
    "year": `gads`
};


var $82e1c09485b73acd$export$2e2bcd8739ae039 = {};
$82e1c09485b73acd$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `a.m./p.m.`,
    "endDate": `Sluttdato`,
    "era": `tidsalder`,
    "hour": `time`,
    "minute": `minutt`,
    "month": `m\xe5ned`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt omr\xe5de: ${args.startDate} til ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valgt tid: ${args.time}`,
    "startDate": `Startdato`,
    "timeZoneName": `tidssone`,
    "weekday": `ukedag`,
    "year": `\xe5r`
};


var $9f28f923dc5fd3b8$export$2e2bcd8739ae039 = {};
$9f28f923dc5fd3b8$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `a.m./p.m.`,
    "endDate": `Einddatum`,
    "era": `tijdperk`,
    "hour": `uur`,
    "minute": `minuut`,
    "month": `maand`,
    "second": `seconde`,
    "selectedDateDescription": (args)=>`Geselecteerde datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Geselecteerd bereik: ${args.startDate} tot ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Geselecteerde tijd: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `tijdzone`,
    "weekday": `dag van de week`,
    "year": `jaar`
};


var $ccc688a417edb66b$export$2e2bcd8739ae039 = {};
$ccc688a417edb66b$export$2e2bcd8739ae039 = {
    "calendar": `Kalendarz`,
    "day": `dzie\u{144}`,
    "dayPeriod": `rano / po po\u{142}udniu / wieczorem`,
    "endDate": `Data ko\u{144}cowa`,
    "era": `era`,
    "hour": `godzina`,
    "minute": `minuta`,
    "month": `miesi\u{105}c`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Wybrana data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Wybrany zakres: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Wybrany czas: ${args.time}`,
    "startDate": `Data pocz\u{105}tkowa`,
    "timeZoneName": `strefa czasowa`,
    "weekday": `dzie\u{144} tygodnia`,
    "year": `rok`
};


var $9d15d267ab935747$export$2e2bcd8739ae039 = {};
$9d15d267ab935747$export$2e2bcd8739ae039 = {
    "calendar": `Calend\xe1rio`,
    "day": `dia`,
    "dayPeriod": `AM/PM`,
    "endDate": `Data final`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `m\xeas`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora selecionada: ${args.time}`,
    "startDate": `Data inicial`,
    "timeZoneName": `fuso hor\xe1rio`,
    "weekday": `dia da semana`,
    "year": `ano`
};


var $2cf54378ded3c96d$export$2e2bcd8739ae039 = {};
$2cf54378ded3c96d$export$2e2bcd8739ae039 = {
    "calendar": `Calend\xe1rio`,
    "day": `dia`,
    "dayPeriod": `am/pm`,
    "endDate": `Data de T\xe9rmino`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `m\xeas`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora selecionada: ${args.time}`,
    "startDate": `Data de In\xedcio`,
    "timeZoneName": `fuso hor\xe1rio`,
    "weekday": `dia da semana`,
    "year": `ano`
};


var $be8129db440ad59f$export$2e2bcd8739ae039 = {};
$be8129db440ad59f$export$2e2bcd8739ae039 = {
    "calendar": `Calendar`,
    "day": `zi`,
    "dayPeriod": `a.m/p.m.`,
    "endDate": `Dat\u{103} final`,
    "era": `er\u{103}`,
    "hour": `or\u{103}`,
    "minute": `minut`,
    "month": `lun\u{103}`,
    "second": `secund\u{103}`,
    "selectedDateDescription": (args)=>`Dat\u{103} selectat\u{103}: ${args.date}`,
    "selectedRangeDescription": (args)=>`Interval selectat: de la ${args.startDate} p\xe2n\u{103} la ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ora selectat\u{103}: ${args.time}`,
    "startDate": `Dat\u{103} \xeenceput`,
    "timeZoneName": `fus orar`,
    "weekday": `ziua din s\u{103}pt\u{103}m\xe2n\u{103}`,
    "year": `an`
};


var $d0502cbf79cab258$export$2e2bcd8739ae039 = {};
$d0502cbf79cab258$export$2e2bcd8739ae039 = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}\u{44C}`,
    "day": `\u{434}\u{435}\u{43D}\u{44C}`,
    "dayPeriod": `AM/PM`,
    "endDate": `\u{414}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    "era": `\u{44D}\u{440}\u{430}`,
    "hour": `\u{447}\u{430}\u{441}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
    "month": `\u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: \u{441} ${args.startDate} \u{43F}\u{43E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F}: ${args.time}`,
    "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
    "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438}`,
    "year": `\u{433}\u{43E}\u{434}`
};


var $1e176a0be28cb74b$export$2e2bcd8739ae039 = {};
$1e176a0be28cb74b$export$2e2bcd8739ae039 = {
    "calendar": `Kalend\xe1r`,
    "day": `de\u{148}`,
    "dayPeriod": `AM/PM`,
    "endDate": `D\xe1tum ukon\u{10D}enia`,
    "era": `letopo\u{10D}et`,
    "hour": `hodina`,
    "minute": `min\xfata`,
    "month": `mesiac`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Vybrat\xfd d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybrat\xfd rozsah: od ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vybrat\xfd \u{10D}as: ${args.time}`,
    "startDate": `D\xe1tum za\u{10D}atia`,
    "timeZoneName": `\u{10D}asov\xe9 p\xe1smo`,
    "weekday": `de\u{148} t\xfd\u{17E}d\u{148}a`,
    "year": `rok`
};


var $2521cf79dc49980d$export$2e2bcd8739ae039 = {};
$2521cf79dc49980d$export$2e2bcd8739ae039 = {
    "calendar": `Koledar`,
    "day": `dan`,
    "dayPeriod": `dop/pop`,
    "endDate": `Datum konca`,
    "era": `doba`,
    "hour": `ura`,
    "minute": `minuta`,
    "month": `mesec`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Izbrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izbrano obmo\u{10D}je: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Izbrani \u{10D}as: ${args.time}`,
    "startDate": `Datum za\u{10D}etka`,
    "timeZoneName": `\u{10D}asovni pas`,
    "weekday": `dan v tednu`,
    "year": `leto`
};


var $4e9df55b55585a8f$export$2e2bcd8739ae039 = {};
$4e9df55b55585a8f$export$2e2bcd8739ae039 = {
    "calendar": `Kalendar`,
    "day": `\u{434}\u{430}\u{43D}`,
    "dayPeriod": `\u{43F}\u{440}\u{435} \u{43F}\u{43E}\u{434}\u{43D}\u{435}/\u{43F}\u{43E} \u{43F}\u{43E}\u{434}\u{43D}\u{435}`,
    "endDate": `Datum zavr\u{161}etka`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{441}\u{430}\u{442}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}`,
    "month": `\u{43C}\u{435}\u{441}\u{435}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}`,
    "selectedDateDescription": (args)=>`Izabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izabrani opseg: od ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Izabrano vreme: ${args.time}`,
    "startDate": `Datum po\u{10D}etka`,
    "timeZoneName": `\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{441}\u{43A}\u{430} \u{437}\u{43E}\u{43D}\u{430}`,
    "weekday": `\u{434}\u{430}\u{43D} \u{443} \u{43D}\u{435}\u{434}\u{435}\u{459}\u{438}`,
    "year": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`
};


var $9eef103c5f2aaaa7$export$2e2bcd8739ae039 = {};
$9eef103c5f2aaaa7$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `fm/em`,
    "endDate": `Slutdatum`,
    "era": `era`,
    "hour": `timme`,
    "minute": `minut`,
    "month": `m\xe5nad`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valt datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valt intervall: ${args.startDate} till ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vald tid: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `tidszon`,
    "weekday": `veckodag`,
    "year": `\xe5r`
};


var $816047c9494488c6$export$2e2bcd8739ae039 = {};
$816047c9494488c6$export$2e2bcd8739ae039 = {
    "calendar": `Takvim`,
    "day": `g\xfcn`,
    "dayPeriod": `\xd6\xd6/\xd6S`,
    "endDate": `Biti\u{15F} Tarihi`,
    "era": `\xe7a\u{11F}`,
    "hour": `saat`,
    "minute": `dakika`,
    "month": `ay`,
    "second": `saniye`,
    "selectedDateDescription": (args)=>`Se\xe7ilen Tarih: ${args.date}`,
    "selectedRangeDescription": (args)=>`Se\xe7ilen Aral\u{131}k: ${args.startDate} - ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Se\xe7ilen Zaman: ${args.time}`,
    "startDate": `Ba\u{15F}lang\u{131}\xe7 Tarihi`,
    "timeZoneName": `saat dilimi`,
    "weekday": `haftan\u{131}n g\xfcn\xfc`,
    "year": `y\u{131}l`
};


var $82dadb5073296ef6$export$2e2bcd8739ae039 = {};
$82dadb5073296ef6$export$2e2bcd8739ae039 = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}`,
    "day": `\u{434}\u{435}\u{43D}\u{44C}`,
    "dayPeriod": `\u{434}\u{43F}/\u{43F}\u{43F}`,
    "endDate": `\u{414}\u{430}\u{442}\u{430} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`,
    "minute": `\u{445}\u{432}\u{438}\u{43B}\u{438}\u{43D}\u{430}`,
    "month": `\u{43C}\u{456}\u{441}\u{44F}\u{446}\u{44C}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.startDate} \u{2014} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{447}\u{430}\u{441}: ${args.time}`,
    "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{438}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
    "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{442}\u{438}\u{436}\u{43D}\u{44F}`,
    "year": `\u{440}\u{456}\u{43A}`
};


var $879a0f308e1cc91d$export$2e2bcd8739ae039 = {};
$879a0f308e1cc91d$export$2e2bcd8739ae039 = {
    "calendar": `\u{65E5}\u{5386}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{4E0A}\u{5348}/\u{4E0B}\u{5348}`,
    "endDate": `\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "era": `\u{7EAA}\u{5143}`,
    "hour": `\u{5C0F}\u{65F6}`,
    "minute": `\u{5206}\u{949F}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{8303}\u{56F4}\u{FF1A}${args.startDate} \u{81F3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65F6}\u{95F4}\u{FF1A}${args.time}`,
    "startDate": `\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    "timeZoneName": `\u{65F6}\u{533A}`,
    "weekday": `\u{5DE5}\u{4F5C}\u{65E5}`,
    "year": `\u{5E74}`
};


var $0ea419259d1b9678$export$2e2bcd8739ae039 = {};
$0ea419259d1b9678$export$2e2bcd8739ae039 = {
    "calendar": `\u{65E5}\u{66C6}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{4E0A}\u{5348}/\u{4E0B}\u{5348}`,
    "endDate": `\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    "era": `\u{7EAA}\u{5143}`,
    "hour": `\u{5C0F}\u{65F6}`,
    "minute": `\u{5206}\u{949F}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{7BC4}\u{570D}\u{FF1A}${args.startDate} \u{81F3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{6642}\u{9593}\u{FF1A}${args.time}`,
    "startDate": `\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    "timeZoneName": `\u{65F6}\u{533A}`,
    "weekday": `\u{5DE5}\u{4F5C}\u{65E5}`,
    "year": `\u{5E74}`
};


var $31eb57338bef8038$export$2e2bcd8739ae039 = {};
$31eb57338bef8038$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $d66b55eb8c7a5938$export$2e2bcd8739ae039),
    "bg-BG": (0, $6bb7a65c49df9f6d$export$2e2bcd8739ae039),
    "cs-CZ": (0, $3d40de3255047bca$export$2e2bcd8739ae039),
    "da-DK": (0, $39741969291761ec$export$2e2bcd8739ae039),
    "de-DE": (0, $eed20e58bf0f36cc$export$2e2bcd8739ae039),
    "el-GR": (0, $eb0257a12e6eb700$export$2e2bcd8739ae039),
    "en-US": (0, $aaed5d594d467ccf$export$2e2bcd8739ae039),
    "es-ES": (0, $8d2f807d578e7d23$export$2e2bcd8739ae039),
    "et-EE": (0, $b4603fb3e32c714a$export$2e2bcd8739ae039),
    "fi-FI": (0, $56082e10b9d34397$export$2e2bcd8739ae039),
    "fr-FR": (0, $b5dde0d609798e83$export$2e2bcd8739ae039),
    "he-IL": (0, $d2d48bf1bb4030a4$export$2e2bcd8739ae039),
    "hr-HR": (0, $3873daa72ddb9382$export$2e2bcd8739ae039),
    "hu-HU": (0, $0a90ccbf0b516b65$export$2e2bcd8739ae039),
    "it-IT": (0, $3608073526dd80c2$export$2e2bcd8739ae039),
    "ja-JP": (0, $45968a10f60613ac$export$2e2bcd8739ae039),
    "ko-KR": (0, $520184c579b62257$export$2e2bcd8739ae039),
    "lt-LT": (0, $bdb5428c7b0ac170$export$2e2bcd8739ae039),
    "lv-LV": (0, $36317cfb1421aacd$export$2e2bcd8739ae039),
    "nb-NO": (0, $82e1c09485b73acd$export$2e2bcd8739ae039),
    "nl-NL": (0, $9f28f923dc5fd3b8$export$2e2bcd8739ae039),
    "pl-PL": (0, $ccc688a417edb66b$export$2e2bcd8739ae039),
    "pt-BR": (0, $9d15d267ab935747$export$2e2bcd8739ae039),
    "pt-PT": (0, $2cf54378ded3c96d$export$2e2bcd8739ae039),
    "ro-RO": (0, $be8129db440ad59f$export$2e2bcd8739ae039),
    "ru-RU": (0, $d0502cbf79cab258$export$2e2bcd8739ae039),
    "sk-SK": (0, $1e176a0be28cb74b$export$2e2bcd8739ae039),
    "sl-SI": (0, $2521cf79dc49980d$export$2e2bcd8739ae039),
    "sr-SP": (0, $4e9df55b55585a8f$export$2e2bcd8739ae039),
    "sv-SE": (0, $9eef103c5f2aaaa7$export$2e2bcd8739ae039),
    "tr-TR": (0, $816047c9494488c6$export$2e2bcd8739ae039),
    "uk-UA": (0, $82dadb5073296ef6$export$2e2bcd8739ae039),
    "zh-CN": (0, $879a0f308e1cc91d$export$2e2bcd8739ae039),
    "zh-TW": (0, $0ea419259d1b9678$export$2e2bcd8739ae039)
};



var $lhKAD = parcelRequire("lhKAD");

var $6pgkA = parcelRequire("6pgkA");

var $fvyIQ = parcelRequire("fvyIQ");

var $lhKAD = parcelRequire("lhKAD");

var $aGDvF = parcelRequire("aGDvF");

var $1ntKq = parcelRequire("1ntKq");

var $bEes0 = parcelRequire("bEes0");

var $eF4cA = parcelRequire("eF4cA");
function $06349090e062b7a8$export$4a931266a3838b86(state, ref, disableArrowNavigation) {
    let { direction: direction } = (0, $1ntKq.useLocale)();
    // oxlint-disable-next-line react/react-compiler
    let focusManager = (0, $eF4cA.useMemo)(()=>(0, $6pgkA.createFocusManager)(ref), [
        ref
    ]);
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            'Alt+ArrowDown': ()=>{
                if ('setOpen' in state) {
                    state.setOpen(true);
                    return;
                }
                return false;
            },
            'Alt+ArrowUp': ()=>{
                if ('setOpen' in state) {
                    state.setOpen(true);
                    return;
                }
                return false;
            },
            ArrowLeft: (e)=>{
                if (disableArrowNavigation) return false;
                if (direction === 'rtl') {
                    if (ref.current) {
                        let target = (0, $fvyIQ.getEventTarget)(e);
                        let prev = $06349090e062b7a8$var$$6a440d0e2d99dd46$var$findNextSegment(ref.current, target.getBoundingClientRect().left, -1);
                        if (prev) {
                            prev.focus();
                            return;
                        }
                    }
                } else {
                    focusManager.focusPrevious();
                    return;
                }
                return false;
            },
            ArrowRight: (e)=>{
                if (disableArrowNavigation) return false;
                if (direction === 'rtl') {
                    if (ref.current) {
                        let target = (0, $fvyIQ.getEventTarget)(e);
                        let next = $06349090e062b7a8$var$$6a440d0e2d99dd46$var$findNextSegment(ref.current, target.getBoundingClientRect().left, 1);
                        if (next) {
                            next.focus();
                            return;
                        }
                    }
                } else {
                    focusManager.focusNext();
                    return;
                }
                return false;
            }
        },
        allowRepeats: true
    });
    // Focus the first placeholder segment from the end on mouse down/touch up in the field.
    let focusLast = ()=>{
        if (!ref.current) return;
        // Try to find the segment prior to the element that was clicked on.
        let target = window.event ? (0, $fvyIQ.getEventTarget)(window.event) : null;
        let walker = (0, $6pgkA.getFocusableTreeWalker)(ref.current, {
            tabbable: true
        });
        if (target) {
            walker.currentNode = target;
            target = walker.previousNode();
        }
        // If no target found, find the last element from the end.
        if (!target) {
            let last;
            do {
                last = walker.lastChild();
                if (last) target = last;
            }while (last);
        }
        // Now go backwards until we find an element that is not a placeholder.
        while(target?.hasAttribute('data-placeholder')){
            let prev = walker.previousNode();
            if (prev && prev.hasAttribute('data-placeholder')) target = prev;
            else break;
        }
        if (target) target.focus();
    };
    let { pressProps: pressProps } = (0, $bEes0.usePress)({
        preventFocusOnPress: true,
        allowTextSelectionOnPress: true,
        onPressStart (e) {
            if (e.pointerType === 'mouse') focusLast();
        },
        onPress (e) {
            if (e.pointerType === 'touch' || e.pointerType === 'pen') focusLast();
        }
    });
    // oxlint-disable-next-line react/react-compiler
    return (0, $lhKAD.mergeProps)(pressProps, keyboardProps);
}
function $06349090e062b7a8$var$$6a440d0e2d99dd46$var$findNextSegment(group, fromX, direction) {
    let walker = (0, $6pgkA.getFocusableTreeWalker)(group, {
        tabbable: true
    });
    let node = walker.nextNode();
    let closest = null;
    let closestDistance = Infinity;
    while(node){
        let x = node.getBoundingClientRect().left;
        let distance = x - fromX;
        let absoluteDistance = Math.abs(distance);
        if (Math.sign(distance) === direction && absoluteDistance < closestDistance) {
            closest = node;
            closestDistance = absoluteDistance;
        }
        node = walker.nextNode();
    }
    return closest;
}



var $lXRQr = parcelRequire("lXRQr");

var $cI1qR = parcelRequire("cI1qR");

var $i1DSg = parcelRequire("i1DSg");

var $3rgVl = parcelRequire("3rgVl");

var $56aMA = parcelRequire("56aMA");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $bd66c7cff007706a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bd66c7cff007706a$export$653eddfc964b0f8a = new WeakMap();
const $bd66c7cff007706a$export$300019f83c56d282 = '__reactAriaDateFieldRole';
const $bd66c7cff007706a$export$7b3062cd49e80452 = '__reactAriaDateFieldFocusManager';
function $bd66c7cff007706a$export$5591b0b878c1a989(props, state, ref) {
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let valueOnFocus = (0, $eF4cA.useRef)(null);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        ...props,
        onFocusWithin (e) {
            valueOnFocus.current = state.value;
            props.onFocus?.(e);
        },
        onBlurWithin: (e)=>{
            state.confirmPlaceholder();
            if (state.value !== valueOnFocus.current) state.commitValidation();
            props.onBlur?.(e);
        },
        onFocusWithinChange: props.onFocusChange
    });
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($bd66c7cff007706a$var$$parcel$interopDefault((0, $31eb57338bef8038$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    let message = state.maxGranularity === 'hour' ? 'selectedTimeDescription' : 'selectedDateDescription';
    let field = state.maxGranularity === 'hour' ? 'time' : 'date';
    let description = state.value ? stringFormatter.format(message, {
        [field]: state.formatValue({
            month: 'long'
        })
    }) : '';
    let descProps = (0, $lXRQr.useDescription)(description);
    // If within a date picker or date range picker, the date field will have role="presentation" and an aria-describedby
    // will be passed in that references the value (e.g. entire range). Otherwise, add the field's value description.
    let describedBy = props[$bd66c7cff007706a$export$300019f83c56d282] === 'presentation' ? fieldProps['aria-describedby'] : [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    let propsFocusManager = props[$bd66c7cff007706a$export$7b3062cd49e80452];
    let focusManager = (0, $eF4cA.useMemo)(()=>propsFocusManager || (0, $6pgkA.createFocusManager)(ref), [
        propsFocusManager,
        ref
    ]);
    let groupProps = (0, $06349090e062b7a8$export$4a931266a3838b86)(state, ref, props[$bd66c7cff007706a$export$300019f83c56d282] === 'presentation');
    // Pass labels and other information to segments.
    $bd66c7cff007706a$export$653eddfc964b0f8a.set(state, {
        ariaLabel: props['aria-label'],
        ariaLabelledBy: [
            labelProps.id,
            props['aria-labelledby']
        ].filter(Boolean).join(' ') || undefined,
        ariaDescribedBy: describedBy,
        focusManager: focusManager
    });
    let autoFocusRef = (0, $eF4cA.useRef)(props.autoFocus);
    // When used within a date picker or date range picker, the field gets role="presentation"
    // rather than role="group". Since the date picker/date range picker already has a role="group"
    // with a label and description, and the segments are already labeled by this as well, this
    // avoids very verbose duplicate announcements.
    let fieldDOMProps;
    if (props[$bd66c7cff007706a$export$300019f83c56d282] === 'presentation') fieldDOMProps = {
        role: 'presentation'
    };
    else fieldDOMProps = (0, $lhKAD.mergeProps)(fieldProps, {
        role: 'group',
        'aria-disabled': props.isDisabled || undefined,
        'aria-describedby': describedBy
    });
    (0, $eF4cA.useEffect)(()=>{
        if (autoFocusRef.current) focusManager.focusFirst();
        autoFocusRef.current = false;
    }, [
        focusManager
    ]);
    (0, $3rgVl.useFormReset)(props.inputRef, state.defaultValue, state.setValue);
    (0, $56aMA.useFormValidation)({
        ...props,
        focus () {
            focusManager.focusFirst();
        }
    }, state, props.inputRef);
    let inputProps = {
        type: 'hidden',
        name: props.name,
        form: props.form,
        value: state.value?.toString() || '',
        disabled: props.isDisabled
    };
    if (props.validationBehavior === 'native') {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = 'text';
        inputProps.hidden = true;
        inputProps.required = props.isRequired;
        // Ignore react warning.
        inputProps.onChange = ()=>{};
    }
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        fieldProps: (0, $lhKAD.mergeProps)(domProps, fieldDOMProps, groupProps, focusWithinProps, {
            onKeyDown: props.onKeyDown,
            onKeyUp: props.onKeyUp,
            style: {
                unicodeBidi: 'isolate'
            }
        }),
        inputProps: inputProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
function $bd66c7cff007706a$export$4c842f6a241dc825(props, state, ref) {
    let res = $bd66c7cff007706a$export$5591b0b878c1a989(props, state, ref);
    // oxlint-disable-next-line react/react-compiler
    res.inputProps.value = state.timeValue?.toString() || '';
    return res;
}


var $fvyIQ = parcelRequire("fvyIQ");

var $5AGOf = parcelRequire("5AGOf");


var $11FxZ = parcelRequire("11FxZ");

var $lhKAD = parcelRequire("lhKAD");

var $3lc2m = parcelRequire("3lc2m");

var $eZSya = parcelRequire("eZSya");


var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $eF4cA = parcelRequire("eF4cA");
function $e34c64d69fd16f26$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e34c64d69fd16f26$export$d42c60378c8168f8() {
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let dictionary = (0, $gI8Gw.useLocalizedStringDictionary)($e34c64d69fd16f26$var$$parcel$interopDefault((0, $31eb57338bef8038$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    return (0, $eF4cA.useMemo)(()=>{
        // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
        // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
        try {
            return new Intl.DisplayNames(locale, {
                type: 'dateTimeField'
            });
        } catch  {
            return new $e34c64d69fd16f26$var$$40cf8faa4dad0740$var$DisplayNamesPolyfill(locale, dictionary);
        }
    }, [
        locale,
        dictionary
    ]);
}
class $e34c64d69fd16f26$var$$40cf8faa4dad0740$var$DisplayNamesPolyfill {
    constructor(locale, dictionary){
        this.locale = locale;
        this.dictionary = dictionary;
    }
    of(field) {
        return this.dictionary.getStringForLocale(field, this.locale);
    }
}



var $58OnM = parcelRequire("58OnM");

var $5oIDw = parcelRequire("5oIDw");

var $25dFS = parcelRequire("25dFS");

var $aGDvF = parcelRequire("aGDvF");

var $dkaC0 = parcelRequire("dkaC0");

var $4skXn = parcelRequire("4skXn");

var $1ntKq = parcelRequire("1ntKq");

var $eHcWW = parcelRequire("eHcWW");

var $tKwj1 = parcelRequire("tKwj1");
var $8jDkV = parcelRequire("8jDkV");

var $9LpUQ = parcelRequire("9LpUQ");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8d3c90cc7f8fe79f$export$1315d136e6f7581(segment, state, ref) {
    let enteredKeys = (0, $eF4cA.useRef)('');
    let { locale: locale, direction: direction } = (0, $1ntKq.useLocale)();
    let displayNames = (0, $e34c64d69fd16f26$export$d42c60378c8168f8)();
    let { ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, focusManager: focusManager } = (0, $bd66c7cff007706a$export$653eddfc964b0f8a).get(state);
    let textValue = segment.isPlaceholder ? '' : segment.text;
    let options = (0, $eF4cA.useMemo)(()=>state.dateFormatter.resolvedOptions(), [
        state.dateFormatter
    ]);
    let monthDateFormatter = (0, $eZSya.useDateFormatter)({
        month: 'long',
        timeZone: options.timeZone
    });
    let hourDateFormatter = (0, $eZSya.useDateFormatter)({
        hour: 'numeric',
        hour12: options.hour12,
        timeZone: options.timeZone
    });
    if (segment.type === 'month' && !segment.isPlaceholder) {
        let monthTextValue = monthDateFormatter.format(state.dateValue);
        textValue = monthTextValue !== textValue ? `${textValue} \u{2013} ${monthTextValue}` : monthTextValue;
    } else if (segment.type === 'hour' && !segment.isPlaceholder) textValue = hourDateFormatter.format(state.dateValue);
    let { spinButtonProps: spinButtonProps } = (0, $eHcWW.useSpinButton)({
        // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
        // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
        // https://github.com/dequelabs/axe-core/issues/3505
        value: segment.value ?? undefined,
        textValue: textValue,
        minValue: segment.minValue,
        maxValue: segment.maxValue,
        isDisabled: state.isDisabled,
        isReadOnly: state.isReadOnly || !segment.isEditable,
        isRequired: state.isRequired,
        onIncrement: ()=>{
            enteredKeys.current = '';
            state.increment(segment.type);
        },
        onDecrement: ()=>{
            enteredKeys.current = '';
            state.decrement(segment.type);
        },
        onIncrementPage: ()=>{
            enteredKeys.current = '';
            state.incrementPage(segment.type);
        },
        onDecrementPage: ()=>{
            enteredKeys.current = '';
            state.decrementPage(segment.type);
        },
        onIncrementToMax: ()=>{
            enteredKeys.current = '';
            state.incrementToMax(segment.type);
        },
        onDecrementToMin: ()=>{
            enteredKeys.current = '';
            state.decrementToMin(segment.type);
        }
    });
    let parser = (0, $eF4cA.useMemo)(()=>new (0, $9LpUQ.NumberParser)(locale, {
            maximumFractionDigits: 0
        }), [
        locale
    ]);
    let backspace = ()=>{
        if (segment.text === segment.placeholder) focusManager.focusPrevious();
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
            let newValue = segment.text.slice(0, -1);
            let parsed = parser.parse(newValue);
            newValue = parsed === 0 ? '' : newValue;
            if (newValue.length === 0 || parsed === 0) state.clearSegment(segment.type);
            else state.setSegment(segment.type, parsed);
            enteredKeys.current = newValue;
        } else if (segment.type === 'dayPeriod' || segment.type === 'era') state.clearSegment(segment.type);
    };
    let { keyboardProps: keyboardProps } = (0, $aGDvF.useKeyboard)({
        shortcuts: {
            Backspace: ()=>{
                backspace();
            },
            Delete: ()=>{
                backspace();
            },
            'Mod+a': ()=>{
            // Firefox does not fire selectstart for Ctrl/Cmd + A
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1742153
            }
        },
        allowRepeats: true
    });
    // Safari dayPeriod option doesn't work...
    let { startsWith: startsWith } = (0, $5oIDw.useFilter)({
        sensitivity: 'base'
    });
    let amPmFormatter = (0, $eZSya.useDateFormatter)({
        hour: 'numeric',
        hour12: true
    });
    let am = (0, $eF4cA.useMemo)(()=>{
        let date = new Date();
        date.setHours(0);
        return amPmFormatter.formatToParts(date).find((part)=>part.type === 'dayPeriod').value;
    }, [
        amPmFormatter
    ]);
    let pm = (0, $eF4cA.useMemo)(()=>{
        let date = new Date();
        date.setHours(12);
        return amPmFormatter.formatToParts(date).find((part)=>part.type === 'dayPeriod').value;
    }, [
        amPmFormatter
    ]);
    // Get a list of formatted era names so users can type the first character to choose one.
    let eraFormatter = (0, $eZSya.useDateFormatter)({
        year: 'numeric',
        era: 'narrow',
        timeZone: 'UTC'
    });
    let eras = (0, $eF4cA.useMemo)(()=>{
        if (segment.type !== 'era') return [];
        let date = (0, $8jDkV.toCalendar)(new (0, $tKwj1.CalendarDate)(1, 1, 1), state.calendar);
        let eras = state.calendar.getEras().map((era)=>{
            let eraDate = date.set({
                year: 1,
                month: 1,
                day: 1,
                era: era
            }).toDate('UTC');
            let parts = eraFormatter.formatToParts(eraDate);
            // Some eras have no localized name in CLDR (e.g. the Coptic 'BCE' era), in which case
            // Intl omits the era part entirely. Fall back to the era identifier so it stays typeable.
            let formatted = parts.find((p)=>p.type === 'era')?.value ?? era;
            return {
                era: era,
                formatted: formatted
            };
        });
        // Remove the common prefix from formatted values. This is so that in calendars with eras like
        // ERA0 and ERA1 (e.g. Ethiopic), users can press "0" and "1" to select an era. In other cases,
        // the first letter is used.
        let prefixLength = $8d3c90cc7f8fe79f$var$$d51706f903be7eab$var$commonPrefixLength(eras.map((era)=>era.formatted));
        if (prefixLength) for (let era of eras)era.formatted = era.formatted.slice(prefixLength);
        return eras;
    }, [
        eraFormatter,
        state.calendar,
        segment.type
    ]);
    let onInput = (key)=>{
        if (state.isDisabled || state.isReadOnly) return;
        let newValue = enteredKeys.current + key;
        switch(segment.type){
            case 'dayPeriod':
                if (startsWith(am, key)) state.setSegment('dayPeriod', 0);
                else if (startsWith(pm, key)) state.setSegment('dayPeriod', 1);
                else break;
                focusManager.focusNext();
                break;
            case 'era':
                {
                    let matched = eras.find((e)=>startsWith(e.formatted, key));
                    if (matched) {
                        state.setSegment('era', matched.era);
                        focusManager.focusNext();
                    }
                    break;
                }
            case 'day':
            case 'hour':
            case 'minute':
            case 'second':
            case 'month':
            case 'year':
                {
                    if (!parser.isValidPartialNumber(newValue)) return;
                    let numberValue = parser.parse(newValue);
                    let segmentValue = numberValue;
                    if (segment.maxValue !== undefined && numberValue > segment.maxValue) segmentValue = parser.parse(key);
                    if (isNaN(numberValue)) return;
                    state.setSegment(segment.type, segmentValue);
                    if (segment.maxValue !== undefined && (Number(numberValue + '0') > segment.maxValue || newValue.length >= String(segment.maxValue).length)) {
                        enteredKeys.current = '';
                        focusManager.focusNext();
                    } else enteredKeys.current = newValue;
                    break;
                }
        }
    };
    let onFocus = ()=>{
        enteredKeys.current = '';
        if (ref.current) (0, $3lc2m.scrollIntoViewport)(ref.current, {
            containingElement: (0, $5AGOf.getScrollParent)(ref.current)
        });
        // Collapse selection to start or Chrome won't fire input events.
        let selection = window.getSelection();
        selection?.collapse(ref.current);
    };
    let documentRef = (0, $eF4cA.useRef)(typeof document !== 'undefined' ? document : null);
    (0, $58OnM.useEvent)(documentRef, 'selectionchange', ()=>{
        // Enforce that the selection is collapsed when inside a date segment.
        // Otherwise, when tapping on a segment in Android Chrome and then entering text,
        // composition events will be fired that break the DOM structure and crash the page.
        let selection = window.getSelection();
        // Only collapse while focused, otherwise a stale anchor left in the segment (e.g. on Firefox)
        // steals focus back into it on selectionchange. See #10259.
        if (selection?.anchorNode && (0, $fvyIQ.nodeContains)(ref.current, selection?.anchorNode) && (0, $fvyIQ.getActiveElement)() === ref.current) selection.collapse(ref.current);
    });
    let compositionRef = (0, $eF4cA.useRef)('');
    (0, $58OnM.useEvent)(ref, 'beforeinput', (e)=>{
        if (!ref.current) return;
        e.preventDefault();
        switch(e.inputType){
            case 'deleteContentBackward':
            case 'deleteContentForward':
                if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly) backspace();
                break;
            case 'insertCompositionText':
                // insertCompositionText cannot be canceled.
                // Record the current state of the element so we can restore it in the `input` event below.
                compositionRef.current = ref.current.textContent;
                // Safari gets stuck in a composition state unless we also assign to the value here.
                // eslint-disable-next-line no-self-assign
                ref.current.textContent = ref.current.textContent;
                break;
            default:
                if (e.data != null) onInput(e.data);
                break;
        }
    });
    (0, $58OnM.useEvent)(ref, 'input', (e)=>{
        let { inputType: inputType, data: data } = e;
        switch(inputType){
            case 'insertCompositionText':
                // Reset the DOM to how it was in the beforeinput event.
                if (ref.current) ref.current.textContent = compositionRef.current;
                // Android sometimes fires key presses of letters as composition events. Need to handle am/pm keys here too.
                // Can also happen e.g. with Pinyin keyboard on iOS.
                if (data != null && (startsWith(am, data) || startsWith(pm, data))) onInput(data);
                break;
        }
    });
    (0, $4skXn.useLayoutEffect)(()=>{
        let element = ref.current;
        return ()=>{
            // If the focused segment is removed, focus the previous one, or the next one if there was no previous one.
            if ((0, $fvyIQ.getActiveElement)() === element) {
                let prev = focusManager.focusPrevious();
                if (!prev) focusManager.focusNext();
            }
        };
    }, [
        ref,
        focusManager
    ]);
    // spinbuttons cannot be focused with VoiceOver on iOS.
    let touchPropOverrides = (0, $11FxZ.isIOS)() || segment.type === 'timeZoneName' ? {
        role: 'textbox',
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuetext': null,
        'aria-valuenow': null
    } : {};
    // Only apply aria-describedby to the first segment, unless the field is invalid. This avoids it being
    // read every time the user navigates to a new segment.
    let firstSegment = (0, $eF4cA.useMemo)(()=>state.segments.find((s)=>s.isEditable), [
        state.segments
    ]);
    if (segment !== firstSegment && !state.isInvalid) ariaDescribedBy = undefined;
    let id = (0, $25dFS.useId)();
    let isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
    // Prepend the label passed from the field to each segment name.
    // This is needed because VoiceOver on iOS does not announce groups.
    let name = segment.type === 'literal' ? '' : displayNames.of(segment.type);
    let labelProps = (0, $dkaC0.useLabels)({
        'aria-label': `${name}${ariaLabel ? `, ${ariaLabel}` : ''}${ariaLabelledBy ? ', ' : ''}`,
        'aria-labelledby': ariaLabelledBy
    });
    // Literal segments should not be visible to screen readers. We don't really need any of the above,
    // but the rules of hooks mean hooks cannot be conditional so we have to put this condition here.
    if (segment.type === 'literal') return {
        segmentProps: {
            'aria-hidden': true
        }
    };
    let segmentStyle = {
        caretColor: 'transparent'
    };
    if (direction === 'rtl') {
        // While the bidirectional algorithm seems to work properly on inline elements with actual values, it returns different results for placeholder strings.
        // To ensure placeholder render in correct format, we apply the CSS equivalent of LRE (left-to-right embedding). See https://www.unicode.org/reports/tr9/#Explicit_Directional_Embeddings.
        // However, we apply this to both placeholders and date segments with an actual value because the date segments will shift around when deleting otherwise.
        segmentStyle.unicodeBidi = 'embed';
        let format = options[segment.type];
        if (format === 'numeric' || format === '2-digit') segmentStyle.direction = 'ltr';
    }
    return {
        // oxlint-disable-next-line react/react-compiler
        segmentProps: (0, $lhKAD.mergeProps)(spinButtonProps, labelProps, {
            id: id,
            ...touchPropOverrides,
            ...keyboardProps,
            'aria-invalid': state.isInvalid ? 'true' : undefined,
            'aria-describedby': ariaDescribedBy,
            'aria-readonly': state.isReadOnly || !segment.isEditable ? 'true' : undefined,
            'data-placeholder': segment.isPlaceholder || undefined,
            contentEditable: isEditable,
            suppressContentEditableWarning: isEditable,
            spellCheck: isEditable ? 'false' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            // Capitalization was changed in React 17...
            [parseInt((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: isEditable ? 'next' : undefined,
            inputMode: state.isDisabled || segment.type === 'dayPeriod' || segment.type === 'era' || !isEditable ? undefined : 'numeric',
            tabIndex: state.isDisabled ? undefined : 0,
            onFocus: onFocus,
            style: segmentStyle,
            // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
            onPointerDown (e) {
                e.stopPropagation();
            },
            onMouseDown (e) {
                e.stopPropagation();
            }
        })
    };
}
function $8d3c90cc7f8fe79f$var$$d51706f903be7eab$var$commonPrefixLength(strings) {
    // Sort the strings, and compare the characters in the first and last to find the common prefix.
    strings.sort();
    let first = strings[0];
    let last = strings[strings.length - 1];
    for(let i = 0; i < first.length; i++){
        if (first[i] !== last[i]) return i;
    }
    return 0;
}




var $2d7f329a31b3711f$export$2e2bcd8739ae039 = {};
$2d7f329a31b3711f$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${args.maxValue} \u{623}\u{648} \u{642}\u{628}\u{644} \u{630}\u{644}\u{643}.`,
    "rangeReversed": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621} \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{642}\u{628}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}.`,
    "rangeUnderflow": (args)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${args.minValue} \u{623}\u{648} \u{628}\u{639}\u{62F} \u{630}\u{644}\u{643}.`,
    "unavailableDate": `\u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`
};


var $993c9be1413e94d4$export$2e2bcd8739ae039 = {};
$993c9be1413e94d4$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${args.maxValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{440}\u{430}\u{43D}\u{43D}\u{430}.`,
    "rangeReversed": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} \u{43F}\u{440}\u{435}\u{434}\u{438} \u{43A}\u{440}\u{430}\u{439}\u{43D}\u{430}\u{442}\u{430}.`,
    "rangeUnderflow": (args)=>`\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${args.minValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{43A}\u{44A}\u{441}\u{43D}\u{43E}.`,
    "unavailableDate": `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435} \u{435} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430}.`
};


var $063de34e400fdc4e$export$2e2bcd8739ae039 = {};
$063de34e400fdc4e$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Hodnota mus\xed b\xfdt ${args.maxValue} nebo d\u{159}\xedv\u{11B}j\u{161}\xed.`,
    "rangeReversed": `Datum zah\xe1jen\xed mus\xed p\u{159}edch\xe1zet datu ukon\u{10D}en\xed.`,
    "rangeUnderflow": (args)=>`Hodnota mus\xed b\xfdt ${args.minValue} nebo pozd\u{11B}j\u{161}\xed.`,
    "unavailableDate": `Vybran\xe9 datum nen\xed k dispozici.`
};


var $8a07dfbe6fe013b8$export$2e2bcd8739ae039 = {};
$8a07dfbe6fe013b8$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\xe6rdien skal v\xe6re ${args.maxValue} eller tidligere.`,
    "rangeReversed": `Startdatoen skal v\xe6re f\xf8r slutdatoen.`,
    "rangeUnderflow": (args)=>`V\xe6rdien skal v\xe6re ${args.minValue} eller nyere.`,
    "unavailableDate": `Den valgte dato er ikke tilg\xe6ngelig.`
};


var $c7baf07e4115aaf4$export$2e2bcd8739ae039 = {};
$c7baf07e4115aaf4$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Der Wert muss ${args.maxValue} oder fr\xfcher sein.`,
    "rangeReversed": `Das Startdatum muss vor dem Enddatum liegen.`,
    "rangeUnderflow": (args)=>`Der Wert muss ${args.minValue} oder sp\xe4ter sein.`,
    "unavailableDate": `Das ausgew\xe4hlte Datum ist nicht verf\xfcgbar.`
};


var $76af38e00d9cc454$export$2e2bcd8739ae039 = {};
$76af38e00d9cc454$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${args.maxValue} \u{3AE} \u{3C0}\u{3B1}\u{3BB}\u{3B1}\u{3B9}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
    "rangeReversed": `\u{397} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3B1}\u{3C0}\u{3CC} \u{3C4}\u{3B7}\u{3BD} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}.`,
    "rangeUnderflow": (args)=>`\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${args.minValue} \u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3B3}\u{3B5}\u{3BD}\u{3AD}\u{3C3}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
    "unavailableDate": `\u{397} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7}.`
};


var $cf889f13250b527d$export$2e2bcd8739ae039 = {};
$cf889f13250b527d$export$2e2bcd8739ae039 = {
    "rangeUnderflow": (args)=>`Value must be ${args.minValue} or later.`,
    "rangeOverflow": (args)=>`Value must be ${args.maxValue} or earlier.`,
    "rangeReversed": `Start date must be before end date.`,
    "unavailableDate": `Selected date unavailable.`
};


var $0ab2b7fdf3a72841$export$2e2bcd8739ae039 = {};
$0ab2b7fdf3a72841$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`El valor debe ser ${args.maxValue} o anterior.`,
    "rangeReversed": `La fecha de inicio debe ser anterior a la fecha de finalizaci\xf3n.`,
    "rangeUnderflow": (args)=>`El valor debe ser ${args.minValue} o posterior.`,
    "unavailableDate": `Fecha seleccionada no disponible.`
};


var $be1ce1a7ae636b06$export$2e2bcd8739ae039 = {};
$be1ce1a7ae636b06$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\xe4\xe4rtus peab olema ${args.maxValue} v\xf5i varasem.`,
    "rangeReversed": `Alguskuup\xe4ev peab olema enne l\xf5ppkuup\xe4eva.`,
    "rangeUnderflow": (args)=>`V\xe4\xe4rtus peab olema ${args.minValue} v\xf5i hilisem.`,
    "unavailableDate": `Valitud kuup\xe4ev pole saadaval.`
};


var $dd3a7f8f06948933$export$2e2bcd8739ae039 = {};
$dd3a7f8f06948933$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Arvon on oltava ${args.maxValue} tai sit\xe4 aikaisempi.`,
    "rangeReversed": `Aloitusp\xe4iv\xe4n on oltava ennen lopetusp\xe4iv\xe4\xe4.`,
    "rangeUnderflow": (args)=>`Arvon on oltava ${args.minValue} tai sit\xe4 my\xf6h\xe4isempi.`,
    "unavailableDate": `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole k\xe4ytett\xe4viss\xe4.`
};


var $cc78dfbc454bf006$export$2e2bcd8739ae039 = {};
$cc78dfbc454bf006$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`La valeur doit \xeatre ${args.maxValue} ou ant\xe9rieure.`,
    "rangeReversed": `La date de d\xe9but doit \xeatre ant\xe9rieure \xe0 la date de fin.`,
    "rangeUnderflow": (args)=>`La valeur doit \xeatre ${args.minValue} ou ult\xe9rieure.`,
    "unavailableDate": `La date s\xe9lectionn\xe9e n\u{2019}est pas disponible.`
};


var $34c48df9a28ce496$export$2e2bcd8739ae039 = {};
$34c48df9a28ce496$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${args.maxValue} \u{5D0}\u{5D5} \u{5DE}\u{5D5}\u{5E7}\u{5D3}\u{5DD} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
    "rangeReversed": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5E4}\u{5E0}\u{5D9} \u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5E1}\u{5D9}\u{5D5}\u{5DD}.`,
    "rangeUnderflow": (args)=>`\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${args.minValue} \u{5D0}\u{5D5} \u{5DE}\u{5D0}\u{5D5}\u{5D7}\u{5E8} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
    "unavailableDate": `\u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5E0}\u{5D1}\u{5D7}\u{5E8} \u{5D0}\u{5D9}\u{5E0}\u{5D5} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`
};


var $771fa86170b58815$export$2e2bcd8739ae039 = {};
$771fa86170b58815$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Vrijednost mora biti ${args.maxValue} ili ranije.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti prije datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrijednost mora biti ${args.minValue} ili kasnije.`,
    "unavailableDate": `Odabrani datum nije dostupan.`
};


var $18967f6b9872bae1$export$2e2bcd8739ae039 = {};
$18967f6b9872bae1$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Az \xe9rt\xe9knek ${args.maxValue} vagy kor\xe1bbinak kell lennie.`,
    "rangeReversed": `A kezd\u{151} d\xe1tumnak a befejez\u{151} d\xe1tumn\xe1l kor\xe1bbinak kell lennie.`,
    "rangeUnderflow": (args)=>`Az \xe9rt\xe9knek ${args.minValue} vagy k\xe9s\u{151}bbinek kell lennie.`,
    "unavailableDate": `A kiv\xe1lasztott d\xe1tum nem \xe9rhet\u{151} el.`
};


var $9b664c06c5bc9fa4$export$2e2bcd8739ae039 = {};
$9b664c06c5bc9fa4$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Il valore deve essere ${args.maxValue} o precedente.`,
    "rangeReversed": `La data di inizio deve essere antecedente alla data di fine.`,
    "rangeUnderflow": (args)=>`Il valore deve essere ${args.minValue} o successivo.`,
    "unavailableDate": `Data selezionata non disponibile.`
};


var $78733c9687421d81$export$2e2bcd8739ae039 = {};
$78733c9687421d81$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{5024}\u{306F} ${args.maxValue} \u{4EE5}\u{4E0B}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "rangeReversed": `\u{958B}\u{59CB}\u{65E5}\u{306F}\u{7D42}\u{4E86}\u{65E5}\u{3088}\u{308A}\u{524D}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{5024}\u{306F} ${args.minValue} \u{4EE5}\u{4E0A}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "unavailableDate": `\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8}\u{306F}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`
};


var $80a8f63fed469042$export$2e2bcd8739ae039 = {};
$80a8f63fed469042$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{AC12}\u{C740} ${args.maxValue} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "rangeReversed": `\u{C2DC}\u{C791}\u{C77C}\u{C740} \u{C885}\u{B8CC}\u{C77C} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "rangeUnderflow": (args)=>`\u{AC12}\u{C740} ${args.minValue} \u{C774}\u{D6C4}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "unavailableDate": `\u{C120}\u{D0DD}\u{D55C} \u{B0A0}\u{C9DC}\u{B97C} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`
};


var $d8d4c93a20ba2b7e$export$2e2bcd8739ae039 = {};
$d8d4c93a20ba2b7e$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Reik\u{161}m\u{117} turi b\u{16B}ti ${args.maxValue} arba ankstesn\u{117}.`,
    "rangeReversed": `Prad\u{17E}ios data turi b\u{16B}ti ankstesn\u{117} nei pabaigos data.`,
    "rangeUnderflow": (args)=>`Reik\u{161}m\u{117} turi b\u{16B}ti ${args.minValue} arba naujesn\u{117}.`,
    "unavailableDate": `Pasirinkta data nepasiekiama.`
};


var $e3c7ccf1666024e4$export$2e2bcd8739ae039 = {};
$e3c7ccf1666024e4$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.maxValue} vai agr\u{101}kai.`,
    "rangeReversed": `S\u{101}kuma datumam ir j\u{101}b\u{16B}t pirms beigu datuma.`,
    "rangeUnderflow": (args)=>`V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.minValue} vai v\u{113}l\u{101}kai.`,
    "unavailableDate": `Atlas\u{12B}tais datums nav pieejams.`
};


var $082c1b5fb9a117e1$export$2e2bcd8739ae039 = {};
$082c1b5fb9a117e1$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Verdien m\xe5 v\xe6re ${args.maxValue} eller tidligere.`,
    "rangeReversed": `Startdatoen m\xe5 v\xe6re f\xf8r sluttdatoen.`,
    "rangeUnderflow": (args)=>`Verdien m\xe5 v\xe6re ${args.minValue} eller senere.`,
    "unavailableDate": `Valgt dato utilgjengelig.`
};


var $43bb8ecf9b86de31$export$2e2bcd8739ae039 = {};
$43bb8ecf9b86de31$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Waarde moet ${args.maxValue} of eerder zijn.`,
    "rangeReversed": `De startdatum moet voor de einddatum liggen.`,
    "rangeUnderflow": (args)=>`Waarde moet ${args.minValue} of later zijn.`,
    "unavailableDate": `Geselecteerde datum niet beschikbaar.`
};


var $0234818d5793bbcc$export$2e2bcd8739ae039 = {};
$0234818d5793bbcc$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${args.maxValue} lub wcze\u{15B}niejsz\u{105}.`,
    "rangeReversed": `Data rozpocz\u{119}cia musi by\u{107} wcze\u{15B}niejsza ni\u{17C} data zako\u{144}czenia.`,
    "rangeUnderflow": (args)=>`Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${args.minValue} lub p\xf3\u{17A}niejsz\u{105}.`,
    "unavailableDate": `Wybrana data jest niedost\u{119}pna.`
};


var $4eed8c0be470f5ba$export$2e2bcd8739ae039 = {};
$4eed8c0be470f5ba$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`O valor deve ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data inicial deve ser anterior \xe0 data final.`,
    "rangeUnderflow": (args)=>`O valor deve ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};


var $be93c475f10428bb$export$2e2bcd8739ae039 = {};
$be93c475f10428bb$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`O valor tem de ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data de in\xedcio deve ser anterior \xe0 data de fim.`,
    "rangeUnderflow": (args)=>`O valor tem de ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};


var $64e58eb49539d236$export$2e2bcd8739ae039 = {};
$64e58eb49539d236$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Valoarea trebuie s\u{103} fie ${args.maxValue} sau anterioar\u{103}.`,
    "rangeReversed": `Data de \xeenceput trebuie s\u{103} fie anterioar\u{103} datei de sf\xe2r\u{219}it.`,
    "rangeUnderflow": (args)=>`Valoarea trebuie s\u{103} fie ${args.minValue} sau ulterioar\u{103}.`,
    "unavailableDate": `Data selectat\u{103} nu este disponibil\u{103}.`
};


var $eb7f31723fc20c40$export$2e2bcd8739ae039 = {};
$eb7f31723fc20c40$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{43F}\u{43E}\u{437}\u{436}\u{435} ${args.maxValue}.`,
    "rangeReversed": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{448}\u{435}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{430}\u{442}\u{435} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}.`,
    "rangeUnderflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{44C}\u{448}\u{435} ${args.minValue}.`,
    "unavailableDate": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`
};


var $02e715864a092929$export$2e2bcd8739ae039 = {};
$02e715864a092929$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Hodnota mus\xed by\u{165} ${args.maxValue} alebo skor\u{161}ia.`,
    "rangeReversed": `D\xe1tum za\u{10D}iatku mus\xed by\u{165} skor\u{161}\xed ako d\xe1tum konca.`,
    "rangeUnderflow": (args)=>`Hodnota mus\xed by\u{165} ${args.minValue} alebo neskor\u{161}ia.`,
    "unavailableDate": `Vybrat\xfd d\xe1tum je nedostupn\xfd.`
};


var $d0bcaa7e92ea6572$export$2e2bcd8739ae039 = {};
$d0bcaa7e92ea6572$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Vrednost mora biti ${args.maxValue} ali starej\u{161}a.`,
    "rangeReversed": `Za\u{10D}etni datum mora biti pred kon\u{10D}nim datumom.`,
    "rangeUnderflow": (args)=>`Vrednost mora biti ${args.minValue} ali novej\u{161}a.`,
    "unavailableDate": `Izbrani datum ni na voljo.`
};


var $3e1eb3f93a31495c$export$2e2bcd8739ae039 = {};
$3e1eb3f93a31495c$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Vrednost mora da bude ${args.maxValue} ili starija.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti pre datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrednost mora da bude ${args.minValue} ili novija.`,
    "unavailableDate": `Izabrani datum nije dostupan.`
};


var $44237429ef0e286b$export$2e2bcd8739ae039 = {};
$44237429ef0e286b$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\xe4rdet m\xe5ste vara ${args.maxValue} eller tidigare.`,
    "rangeReversed": `Startdatumet m\xe5ste vara f\xf6re slutdatumet.`,
    "rangeUnderflow": (args)=>`V\xe4rdet m\xe5ste vara ${args.minValue} eller senare.`,
    "unavailableDate": `Det valda datumet \xe4r inte tillg\xe4ngligt.`
};


var $add322dd5f39c01d$export$2e2bcd8739ae039 = {};
$add322dd5f39c01d$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`De\u{11F}er, ${args.maxValue} veya \xf6ncesi olmal\u{131}d\u{131}r.`,
    "rangeReversed": `Ba\u{15F}lang\u{131}\xe7 tarihi biti\u{15F} tarihinden \xf6nce olmal\u{131}d\u{131}r.`,
    "rangeUnderflow": (args)=>`De\u{11F}er, ${args.minValue} veya sonras\u{131} olmal\u{131}d\u{131}r.`,
    "unavailableDate": `Se\xe7ilen tarih kullan\u{131}lam\u{131}yor.`
};


var $25de2c1a61c0c6c6$export$2e2bcd8739ae039 = {};
$25de2c1a61c0c6c6$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{43F}\u{456}\u{437}\u{43D}\u{456}\u{448}\u{435} ${args.maxValue}.`,
    "rangeReversed": `\u{414}\u{430}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443} \u{43C}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{434}\u{443}\u{432}\u{430}\u{442}\u{438} \u{434}\u{430}\u{442}\u{456} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}.`,
    "rangeUnderflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{456}\u{448}\u{435} ${args.minValue}.`,
    "unavailableDate": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`
};


var $80d41c419f0955cf$export$2e2bcd8739ae039 = {};
$80d41c419f0955cf$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{503C}\u{5FC5}\u{987B}\u{662F} ${args.maxValue} \u{6216}\u{66F4}\u{65E9}\u{65E5}\u{671F}\u{3002}`,
    "rangeReversed": `\u{5F00}\u{59CB}\u{65E5}\u{671F}\u{5FC5}\u{987B}\u{65E9}\u{4E8E}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{503C}\u{5FC5}\u{987B}\u{662F} ${args.minValue} \u{6216}\u{66F4}\u{665A}\u{65E5}\u{671F}\u{3002}`,
    "unavailableDate": `\u{6240}\u{9009}\u{65E5}\u{671F}\u{4E0D}\u{53EF}\u{7528}\u{3002}`
};


var $321976d718efce54$export$2e2bcd8739ae039 = {};
$321976d718efce54$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{503C}\u{5FC5}\u{9808}\u{662F} ${args.maxValue} \u{6216}\u{66F4}\u{65E9}\u{3002}`,
    "rangeReversed": `\u{958B}\u{59CB}\u{65E5}\u{671F}\u{5FC5}\u{9808}\u{5728}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{4E4B}\u{524D}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{503C}\u{5FC5}\u{9808}\u{662F} ${args.minValue} \u{6216}\u{66F4}\u{665A}\u{3002}`,
    "unavailableDate": `\u{6240}\u{9078}\u{65E5}\u{671F}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{3002}`
};


var $bd44fc096c803043$export$2e2bcd8739ae039 = {};
$bd44fc096c803043$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $2d7f329a31b3711f$export$2e2bcd8739ae039),
    "bg-BG": (0, $993c9be1413e94d4$export$2e2bcd8739ae039),
    "cs-CZ": (0, $063de34e400fdc4e$export$2e2bcd8739ae039),
    "da-DK": (0, $8a07dfbe6fe013b8$export$2e2bcd8739ae039),
    "de-DE": (0, $c7baf07e4115aaf4$export$2e2bcd8739ae039),
    "el-GR": (0, $76af38e00d9cc454$export$2e2bcd8739ae039),
    "en-US": (0, $cf889f13250b527d$export$2e2bcd8739ae039),
    "es-ES": (0, $0ab2b7fdf3a72841$export$2e2bcd8739ae039),
    "et-EE": (0, $be1ce1a7ae636b06$export$2e2bcd8739ae039),
    "fi-FI": (0, $dd3a7f8f06948933$export$2e2bcd8739ae039),
    "fr-FR": (0, $cc78dfbc454bf006$export$2e2bcd8739ae039),
    "he-IL": (0, $34c48df9a28ce496$export$2e2bcd8739ae039),
    "hr-HR": (0, $771fa86170b58815$export$2e2bcd8739ae039),
    "hu-HU": (0, $18967f6b9872bae1$export$2e2bcd8739ae039),
    "it-IT": (0, $9b664c06c5bc9fa4$export$2e2bcd8739ae039),
    "ja-JP": (0, $78733c9687421d81$export$2e2bcd8739ae039),
    "ko-KR": (0, $80a8f63fed469042$export$2e2bcd8739ae039),
    "lt-LT": (0, $d8d4c93a20ba2b7e$export$2e2bcd8739ae039),
    "lv-LV": (0, $e3c7ccf1666024e4$export$2e2bcd8739ae039),
    "nb-NO": (0, $082c1b5fb9a117e1$export$2e2bcd8739ae039),
    "nl-NL": (0, $43bb8ecf9b86de31$export$2e2bcd8739ae039),
    "pl-PL": (0, $0234818d5793bbcc$export$2e2bcd8739ae039),
    "pt-BR": (0, $4eed8c0be470f5ba$export$2e2bcd8739ae039),
    "pt-PT": (0, $be93c475f10428bb$export$2e2bcd8739ae039),
    "ro-RO": (0, $64e58eb49539d236$export$2e2bcd8739ae039),
    "ru-RU": (0, $eb7f31723fc20c40$export$2e2bcd8739ae039),
    "sk-SK": (0, $02e715864a092929$export$2e2bcd8739ae039),
    "sl-SI": (0, $d0bcaa7e92ea6572$export$2e2bcd8739ae039),
    "sr-SP": (0, $3e1eb3f93a31495c$export$2e2bcd8739ae039),
    "sv-SE": (0, $44237429ef0e286b$export$2e2bcd8739ae039),
    "tr-TR": (0, $add322dd5f39c01d$export$2e2bcd8739ae039),
    "uk-UA": (0, $25de2c1a61c0c6c6$export$2e2bcd8739ae039),
    "zh-CN": (0, $80d41c419f0955cf$export$2e2bcd8739ae039),
    "zh-TW": (0, $321976d718efce54$export$2e2bcd8739ae039)
};



var $iEwfj = parcelRequire("iEwfj");

var $MHwAo = parcelRequire("MHwAo");
var $1qrul = parcelRequire("1qrul");
var $tKwj1 = parcelRequire("tKwj1");
var $8jDkV = parcelRequire("8jDkV");

var $4EK5Y = parcelRequire("4EK5Y");
var $aLZXd = parcelRequire("aLZXd");

var $eF4cA = parcelRequire("eF4cA");
function $bba69d502ef9723a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bba69d502ef9723a$var$$8b141f2f71e88f85$var$dictionary = new (0, $4EK5Y.LocalizedStringDictionary)($bba69d502ef9723a$var$$parcel$interopDefault((0, $bd44fc096c803043$export$2e2bcd8739ae039)));
function $bba69d502ef9723a$var$$8b141f2f71e88f85$var$getLocale() {
    // Match browser language setting here, NOT react-aria's I18nProvider, so that we match other browser-provided
    // validation messages, which to not respect our provider's language.
    let locale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return locale;
}
function $bba69d502ef9723a$export$f18627323ab57ac0(value, minValue, maxValue, isDateUnavailable, options) {
    let rangeOverflow = value != null && maxValue != null && value.compare(maxValue) > 0;
    let rangeUnderflow = value != null && minValue != null && value.compare(minValue) < 0;
    let isUnavailable = value != null && isDateUnavailable?.(value) || false;
    let isInvalid = rangeOverflow || rangeUnderflow || isUnavailable;
    let errors = [];
    if (isInvalid) {
        let locale = $bba69d502ef9723a$var$$8b141f2f71e88f85$var$getLocale();
        let strings = (0, $4EK5Y.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/datepicker') || $bba69d502ef9723a$var$$8b141f2f71e88f85$var$dictionary;
        let formatter = new (0, $aLZXd.LocalizedStringFormatter)(locale, strings);
        let dateFormatter = new (0, $MHwAo.DateFormatter)(locale, $bba69d502ef9723a$export$7e319ea407e63bc0({}, options));
        let timeZone = dateFormatter.resolvedOptions().timeZone;
        if (rangeUnderflow && minValue != null) errors.push(formatter.format('rangeUnderflow', {
            minValue: dateFormatter.format(minValue.toDate(timeZone))
        }));
        if (rangeOverflow && maxValue != null) errors.push(formatter.format('rangeOverflow', {
            maxValue: dateFormatter.format(maxValue.toDate(timeZone))
        }));
        if (isUnavailable) errors.push(formatter.format('unavailableDate'));
    }
    return {
        isInvalid: isInvalid,
        validationErrors: errors,
        validationDetails: {
            badInput: isUnavailable,
            customError: false,
            patternMismatch: false,
            rangeOverflow: rangeOverflow,
            rangeUnderflow: rangeUnderflow,
            stepMismatch: false,
            tooLong: false,
            tooShort: false,
            typeMismatch: false,
            valueMissing: false,
            valid: !isInvalid
        }
    };
}
function $bba69d502ef9723a$export$80ff8fc0ae339c13(value, minValue, maxValue, isDateUnavailable, options) {
    let startValidation = $bba69d502ef9723a$export$f18627323ab57ac0(value?.start ?? null, minValue, maxValue, isDateUnavailable, options);
    let endValidation = $bba69d502ef9723a$export$f18627323ab57ac0(value?.end ?? null, minValue, maxValue, isDateUnavailable, options);
    let result = (0, $iEwfj.mergeValidation)(startValidation, endValidation);
    if (value?.end != null && value.start != null && value.end.compare(value.start) < 0) {
        let strings = (0, $4EK5Y.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/datepicker') || $bba69d502ef9723a$var$$8b141f2f71e88f85$var$dictionary;
        result = (0, $iEwfj.mergeValidation)(result, {
            isInvalid: true,
            validationErrors: [
                strings.getStringForLocale('rangeReversed', $bba69d502ef9723a$var$$8b141f2f71e88f85$var$getLocale())
            ],
            validationDetails: {
                ...(0, $iEwfj.VALID_VALIDITY_STATE),
                rangeUnderflow: true,
                rangeOverflow: true,
                valid: false
            }
        });
    }
    return result;
}
const $bba69d502ef9723a$var$$8b141f2f71e88f85$var$DEFAULT_FIELD_OPTIONS = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit'
};
const $bba69d502ef9723a$var$$8b141f2f71e88f85$var$TWO_DIGIT_FIELD_OPTIONS = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
};
function $bba69d502ef9723a$export$7e319ea407e63bc0(fieldOptions, options) {
    let defaultFieldOptions = options.shouldForceLeadingZeros ? $bba69d502ef9723a$var$$8b141f2f71e88f85$var$TWO_DIGIT_FIELD_OPTIONS : $bba69d502ef9723a$var$$8b141f2f71e88f85$var$DEFAULT_FIELD_OPTIONS;
    fieldOptions = {
        ...defaultFieldOptions,
        ...fieldOptions
    };
    let granularity = options.granularity || 'minute';
    let keys = Object.keys(fieldOptions);
    let startIdx = keys.indexOf(options.maxGranularity ?? 'year');
    if (startIdx < 0) startIdx = 0;
    let endIdx = keys.indexOf(granularity);
    if (endIdx < 0) endIdx = 2;
    if (startIdx > endIdx) throw new Error('maxGranularity must be greater than granularity');
    let opts = keys.slice(startIdx, endIdx + 1).reduce((opts, key)=>{
        opts[key] = fieldOptions[key];
        return opts;
    }, {});
    if (options.hourCycle != null) opts.hour12 = options.hourCycle === 12;
    opts.timeZone = options.timeZone || 'UTC';
    let hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    if (hasTime && options.timeZone && !options.hideTimeZone) opts.timeZoneName = 'short';
    if (options.showEra && startIdx === 0) opts.era = 'short';
    return opts;
}
function $bba69d502ef9723a$export$c5221a78ef73c5e9(placeholderValue) {
    if (placeholderValue && 'hour' in placeholderValue) return placeholderValue;
    return new (0, $tKwj1.Time)();
}
function $bba69d502ef9723a$export$61a490a80c552550(value, calendar) {
    if (value === null) return null;
    if (!value) return undefined;
    return (0, $8jDkV.toCalendar)(value, calendar);
}
function $bba69d502ef9723a$export$66aa2b09de4b1ea5(placeholderValue, granularity, calendar, timeZone) {
    if (placeholderValue) return $bba69d502ef9723a$export$61a490a80c552550(placeholderValue, calendar);
    let date = (0, $8jDkV.toCalendar)((0, $1qrul.now)(timeZone ?? (0, $1qrul.getLocalTimeZone)()).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
    }), calendar);
    if (granularity === 'year' || granularity === 'month' || granularity === 'day') return (0, $8jDkV.toCalendarDate)(date);
    if (!timeZone) return (0, $8jDkV.toCalendarDateTime)(date);
    return date;
}
function $bba69d502ef9723a$export$2440da353cedad43(v, granularity) {
    // Compute default granularity and time zone from the value. If the value becomes null, keep the last values.
    let defaultTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
    let defaultGranularity = v && 'minute' in v ? 'minute' : 'day';
    // props.granularity must actually exist in the value if one is provided.
    if (v && granularity && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    let [lastValue, setLastValue] = (0, $eF4cA.useState)([
        defaultGranularity,
        defaultTimeZone
    ]);
    // If the granularity or time zone changed, update the last value.
    if (v && (lastValue[0] !== defaultGranularity || lastValue[1] !== defaultTimeZone)) setLastValue([
        defaultGranularity,
        defaultTimeZone
    ]);
    if (!granularity) granularity = v ? defaultGranularity : lastValue[0];
    let timeZone = v ? defaultTimeZone : lastValue[1];
    return [
        granularity,
        timeZone
    ];
}



var $iEwfj = parcelRequire("iEwfj");

var $4EK5Y = parcelRequire("4EK5Y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // These placeholders are based on the strings used by the <input type="date">
// implementations in Chrome and Firefox. Additional languages are supported
// here than React Spectrum's typical translations.
const $3e1a6d06f039011e$var$$8e5fbb9a25791ca0$var$placeholders = new (0, $4EK5Y.LocalizedStringDictionary)({
    ach: {
        year: 'mwaka',
        month: 'dwe',
        day: 'nino'
    },
    af: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    am: {
        year: "\u12D3\u12D3\u12D3\u12D3",
        month: "\u121A\u121C",
        day: "\u1240\u1240"
    },
    an: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    ar: {
        year: "\u0633\u0646\u0629",
        month: "\u0634\u0647\u0631",
        day: "\u064A\u0648\u0645"
    },
    ast: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    az: {
        year: 'iiii',
        month: 'aa',
        day: 'gg'
    },
    be: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bg: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bn: {
        year: 'yyyy',
        month: "\u09AE\u09BF\u09AE\u09BF",
        day: 'dd'
    },
    br: {
        year: 'bbbb',
        month: 'mm',
        day: 'dd'
    },
    bs: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    ca: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    cak: {
        year: 'jjjj',
        month: 'ii',
        day: "q'q'"
    },
    ckb: {
        year: "\u0633\u0627\u06B5",
        month: "\u0645\u0627\u0646\u06AF",
        day: "\u0695\u06C6\u0698"
    },
    cs: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    cy: {
        year: 'bbbb',
        month: 'mm',
        day: 'dd'
    },
    da: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    de: {
        year: 'jjjj',
        month: 'mm',
        day: 'tt'
    },
    dsb: {
        year: 'llll',
        month: 'mm',
        day: "\u017A\u017A"
    },
    el: {
        year: "\u03B5\u03B5\u03B5\u03B5",
        month: "\u03BC\u03BC",
        day: "\u03B7\u03B7"
    },
    en: {
        year: 'yyyy',
        month: 'mm',
        day: 'dd'
    },
    eo: {
        year: 'jjjj',
        month: 'mm',
        day: 'tt'
    },
    es: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    et: {
        year: 'aaaa',
        month: 'kk',
        day: 'pp'
    },
    eu: {
        year: 'uuuu',
        month: 'hh',
        day: 'ee'
    },
    fa: {
        year: "\u0633\u0627\u0644",
        month: "\u0645\u0627\u0647",
        day: "\u0631\u0648\u0632"
    },
    ff: {
        year: 'hhhh',
        month: 'll',
        day: "\xf1\xf1"
    },
    fi: {
        year: 'vvvv',
        month: 'kk',
        day: 'pp'
    },
    fr: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    fy: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    ga: {
        year: 'bbbb',
        month: 'mm',
        day: 'll'
    },
    gd: {
        year: 'bbbb',
        month: 'mm',
        day: 'll'
    },
    gl: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    he: {
        year: "\u05E9\u05E0\u05D4",
        month: "\u05D7\u05D5\u05D3\u05E9",
        day: "\u05D9\u05D5\u05DD"
    },
    hr: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    hsb: {
        year: 'llll',
        month: 'mm',
        day: 'dd'
    },
    hu: {
        year: "\xe9\xe9\xe9\xe9",
        month: 'hh',
        day: 'nn'
    },
    ia: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    id: {
        year: 'tttt',
        month: 'bb',
        day: 'hh'
    },
    is: {
        year: "\xe1\xe1\xe1\xe1",
        month: 'mm',
        day: 'dd'
    },
    it: {
        year: 'aaaa',
        month: 'mm',
        day: 'gg'
    },
    ja: {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    ka: {
        year: "\u10EC\u10EC\u10EC\u10EC",
        month: "\u10D7\u10D7",
        day: "\u10E0\u10E0"
    },
    kk: {
        year: "\u0436\u0436\u0436\u0436",
        month: "\u0430\u0430",
        day: "\u043A\u043A"
    },
    kn: {
        year: "\u0CB5\u0CB5\u0CB5\u0CB5",
        month: "\u0CAE\u0CBF\u0CAE\u0CC0",
        day: "\u0CA6\u0CBF\u0CA6\u0CBF"
    },
    ko: {
        year: "\uC5F0\uB3C4",
        month: "\uC6D4",
        day: "\uC77C"
    },
    lb: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    lo: {
        year: "\u0E9B\u0E9B\u0E9B\u0E9B",
        month: "\u0E94\u0E94",
        day: "\u0EA7\u0EA7"
    },
    lt: {
        year: 'mmmm',
        month: 'mm',
        day: 'dd'
    },
    lv: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    meh: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    ml: {
        year: "\u0D35\u0D7C\u0D37\u0D02",
        month: "\u0D2E\u0D3E\u0D38\u0D02",
        day: "\u0D24\u0D40\u0D2F\u0D24\u0D3F"
    },
    ms: {
        year: 'tttt',
        month: 'mm',
        day: 'hh'
    },
    nb: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    nl: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    nn: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    no: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    oc: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    pl: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    pt: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    rm: {
        year: 'oooo',
        month: 'mm',
        day: 'dd'
    },
    ro: {
        year: 'aaaa',
        month: 'll',
        day: 'zz'
    },
    ru: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sc: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    scn: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    sk: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    sl: {
        year: 'llll',
        month: 'mm',
        day: 'dd'
    },
    sr: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    'sr-Latn': {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    sv: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    szl: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    tg: {
        year: "\u0441\u0441\u0441\u0441",
        month: "\u043C\u043C",
        day: "\u0440\u0440"
    },
    th: {
        year: "\u0E1B\u0E1B\u0E1B\u0E1B",
        month: "\u0E14\u0E14",
        day: "\u0E27\u0E27"
    },
    tr: {
        year: 'yyyy',
        month: 'aa',
        day: 'gg'
    },
    uk: {
        year: "\u0440\u0440\u0440\u0440",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    'zh-CN': {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    'zh-TW': {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    }
}, 'en');
function $3e1a6d06f039011e$export$d3f5c5e0a5023fa0(field, value, locale) {
    // Use the actual placeholder value for the era and day period fields.
    if (field === 'era' || field === 'dayPeriod') return value;
    if (field === 'year' || field === 'month' || field === 'day') return $3e1a6d06f039011e$var$$8e5fbb9a25791ca0$var$placeholders.getStringForLocale(field, locale);
    // For time fields (e.g. hour, minute, etc.), use two dashes as the placeholder.
    return "\u2013\u2013";
}



var $tKwj1 = parcelRequire("tKwj1");
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $56b3e2b50d5202f3$export$ae165b50d181e1ef {
    constructor(calendar, hourCycle, dateValue){
        this.era = dateValue?.era ?? null;
        this.calendar = calendar;
        this.year = dateValue?.year ?? null;
        this.month = dateValue?.month ?? null;
        this.day = dateValue?.day ?? null;
        this.hour = dateValue?.hour ?? null;
        this.hourCycle = hourCycle;
        this.dayPeriod = null;
        this.minute = dateValue?.minute ?? null;
        this.second = dateValue?.second ?? null;
        this.millisecond = dateValue?.millisecond ?? null;
        this.offset = 'offset' in (dateValue ?? {}) ? dateValue.offset : null;
        // Convert the hour from 24 hour time to the given hour cycle.
        if (this.hour != null) {
            let [dayPeriod, hour] = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(this.hour, hourCycle);
            this.dayPeriod = dayPeriod;
            this.hour = hour;
        }
    }
    copy() {
        let res = new $56b3e2b50d5202f3$export$ae165b50d181e1ef(this.calendar, this.hourCycle);
        res.era = this.era;
        res.year = this.year;
        res.month = this.month;
        res.day = this.day;
        res.hour = this.hour;
        res.dayPeriod = this.dayPeriod;
        res.minute = this.minute;
        res.second = this.second;
        res.millisecond = this.millisecond;
        res.offset = this.offset;
        return res;
    }
    /** Checks whether all the specified segments have a value. */ isComplete(segments) {
        return segments.every((segment)=>this[segment] != null);
    }
    /** Checks whether the given date value matches this value for the specified segments. */ validate(dt, segments) {
        return segments.every((segment)=>{
            if ((segment === 'hour' || segment === 'dayPeriod') && 'hour' in dt) {
                let [dayPeriod, hour] = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(dt.hour, this.hourCycle);
                return this.dayPeriod === dayPeriod && this.hour === hour;
            }
            return this[segment] === dt[segment];
        });
    }
    /** Checks if the date is empty (i.e. all specified segments are null). */ isCleared(segments) {
        return segments.every((segment)=>this[segment] === null);
    }
    /** Sets the given field. */ set(field, value, placeholder) {
        let result = this.copy();
        result[field] = value;
        if (field === 'hour' && result.dayPeriod == null && 'hour' in placeholder) result.dayPeriod = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(placeholder.hour, this.hourCycle)[0];
        if (field === 'year' && result.era == null) result.era = placeholder.era;
        // clear offset when a date/time field changes since it may no longer be valid
        if (field !== 'second' && field !== 'literal' && field !== 'timeZoneName') result.offset = null;
        return result;
    }
    /** Sets the given field to null. */ clear(field) {
        let result = this.copy();
        // @ts-ignore
        result[field] = null;
        if (field === 'year') result.era = null;
        // clear offset when a field is cleared since it may no longer be valid
        result.offset = null;
        return result;
    }
    /**
   * Increments or decrements the given field. If it is null, then it is set to the placeholder
   * value.
   */ cycle(field, amount, placeholder, displaySegments) {
        let res = this.copy();
        // If field is null, default to placeholder.
        if (res[field] == null && field !== 'dayPeriod' && field !== 'era') {
            if (field === 'hour' && 'hour' in placeholder) {
                let [dayPeriod, hour] = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(placeholder.hour, this.hourCycle);
                res.dayPeriod = dayPeriod;
                res.hour = hour;
            } else res[field] = placeholder[field];
            if (field === 'year' && res.era == null) res.era = placeholder.era;
            return res;
        }
        switch(field){
            case 'era':
                {
                    let eras = this.calendar.getEras();
                    let index = eras.indexOf(res.era);
                    index = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(index, amount, 0, eras.length - 1);
                    res.era = eras[index];
                    break;
                }
            case 'year':
                {
                    // Use CalendarDate to cycle so that we update the era when going between 1 AD and 1 BC.
                    let date = new (0, $tKwj1.CalendarDate)(this.calendar, this.era ?? placeholder.era, this.year ?? placeholder.year, this.month ?? 1, this.day ?? 1);
                    date = date.cycle(field, amount, {
                        round: field === 'year'
                    });
                    res.era = date.era;
                    res.year = date.year;
                    break;
                }
            case 'month':
                res.month = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(res.month ?? 1, amount, 1, this.calendar.getMaximumMonthsInYear());
                break;
            case 'day':
                // Allow incrementing up to the maximum number of days in any month.
                res.day = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(res.day ?? 1, amount, 1, this.calendar.getMaximumDaysInMonth());
                break;
            case 'hour':
                {
                    // if date is fully defined or it is just a time field, and we have a time zone, use toValue to get a ZonedDateTime to cycle
                    // so DST fallback is properly handled
                    let hasDateSegements = displaySegments.some((s)=>[
                            'year',
                            'month',
                            'day'
                        ].includes(s));
                    if ('timeZone' in placeholder && (!hasDateSegements || res.year != null && res.month != null && res.day != null)) {
                        let date = this.toValue(placeholder);
                        date = date.cycle('hour', amount, {
                            hourCycle: this.hourCycle === 'h12' ? 12 : 24,
                            round: false
                        });
                        let [dayPeriod, adjustedHour] = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(date.hour, this.hourCycle);
                        res.hour = adjustedHour;
                        res.dayPeriod = dayPeriod;
                        res.offset = date.offset;
                    } else {
                        let hours = res.hour ?? 0;
                        let limits = this.getSegmentLimits('hour');
                        res.hour = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(hours, amount, limits.minValue, limits.maxValue);
                        if (res.dayPeriod == null && 'hour' in placeholder) res.dayPeriod = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(placeholder.hour, this.hourCycle)[0];
                    }
                    break;
                }
            case 'dayPeriod':
                res.dayPeriod = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(res.dayPeriod ?? 0, amount, 0, 1);
                break;
            case 'minute':
                res.minute = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(res.minute ?? 0, amount, 0, 59, true);
                break;
            case 'second':
                res.second = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(res.second ?? 0, amount, 0, 59, true);
                break;
        }
        return res;
    }
    /**
   * Converts the incomplete date to a full date value, using the provided value for any unset
   * fields.
   */ toValue(value) {
        if ('hour' in value) {
            let hour = this.hour;
            if (hour != null) hour = $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$fromHourCycle(hour, this.dayPeriod ?? 0, this.hourCycle);
            else if (this.hourCycle === 'h12' || this.hourCycle === 'h11') hour = this.dayPeriod === 1 ? 12 : 0;
            let res = value.set({
                era: this.era ?? value.era,
                year: this.year ?? value.year,
                month: this.month ?? value.month,
                day: this.day ?? value.day,
                hour: hour ?? value.hour,
                minute: this.minute ?? value.minute,
                second: this.second ?? value.second,
                millisecond: this.millisecond ?? value.millisecond
            });
            if ('offset' in res && this.offset != null && res.offset !== this.offset) res = res.add({
                milliseconds: res.offset - this.offset
            });
            return res;
        } else return value.set({
            era: this.era ?? value.era,
            year: this.year ?? value.year,
            month: this.month ?? value.month,
            day: this.day ?? value.day
        });
    }
    getSegmentLimits(type) {
        switch(type){
            case 'era':
                {
                    let eras = this.calendar.getEras();
                    return {
                        value: this.era != null ? eras.indexOf(this.era) : eras.length - 1,
                        minValue: 0,
                        maxValue: eras.length - 1
                    };
                }
            case 'year':
                return {
                    value: this.year,
                    minValue: 1,
                    maxValue: 9999
                };
            case 'month':
                return {
                    value: this.month,
                    minValue: 1,
                    maxValue: this.calendar.getMaximumMonthsInYear()
                };
            case 'day':
                return {
                    value: this.day,
                    minValue: 1,
                    maxValue: this.calendar.getMaximumDaysInMonth()
                };
            case 'dayPeriod':
                return {
                    value: this.dayPeriod,
                    minValue: 0,
                    maxValue: 1
                };
            case 'hour':
                {
                    let minValue = 0;
                    let maxValue = 23;
                    if (this.hourCycle === 'h12') {
                        minValue = 1;
                        maxValue = 12;
                    } else if (this.hourCycle === 'h11') {
                        minValue = 0;
                        maxValue = 11;
                    }
                    return {
                        value: this.hour,
                        minValue: minValue,
                        maxValue: maxValue
                    };
                }
            case 'minute':
                return {
                    value: this.minute,
                    minValue: 0,
                    maxValue: 59
                };
            case 'second':
                return {
                    value: this.second,
                    minValue: 0,
                    maxValue: 59
                };
        }
    }
}
function $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$toHourCycle(hour, hourCycle) {
    let dayPeriod = hour >= 12 ? 1 : 0;
    switch(hourCycle){
        case 'h11':
            // Hours are numbered from 0 to 11. Used in Japan.
            if (hour >= 12) hour -= 12;
            break;
        case 'h12':
            // Hours are numbered from 12 (representing 0) to 11.
            if (hour === 0) hour = 12;
            else if (hour > 12) hour -= 12;
            break;
        case 'h23':
            // 24 hour time, numbered 0 to 23.
            dayPeriod = null;
            break;
        case 'h24':
            // 24 hour time numbered 24 to 23. Unused but supported by Intl.DateTimeFormat.
            hour += 1;
            dayPeriod = null;
    }
    return [
        dayPeriod,
        hour
    ];
}
function $56b3e2b50d5202f3$var$$0e8931c783099b4f$var$fromHourCycle(hour, dayPeriod, hourCycle) {
    switch(hourCycle){
        case 'h11':
            if (dayPeriod === 1) hour += 12;
            break;
        case 'h12':
            if (hour === 12) hour = 0;
            if (dayPeriod === 1) hour += 12;
            break;
        case 'h24':
            hour -= 1;
            break;
    }
    return hour;
}



var $iUErx = parcelRequire("iUErx");

var $MHwAo = parcelRequire("MHwAo");
var $1k26k = parcelRequire("1k26k");
var $1qrul = parcelRequire("1qrul");
var $8jDkV = parcelRequire("8jDkV");

var $l3v5Z = parcelRequire("l3v5Z");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9c601541af601cce$var$$8e7461aabf74661f$var$EDITABLE_SEGMENTS = {
    year: true,
    month: true,
    day: true,
    hour: true,
    minute: true,
    second: true,
    dayPeriod: true,
    era: true
};
const $9c601541af601cce$var$$8e7461aabf74661f$var$PAGE_STEP = {
    year: 5,
    month: 2,
    day: 7,
    hour: 2,
    minute: 15,
    second: 15
};
const $9c601541af601cce$var$$8e7461aabf74661f$var$TYPE_MAPPING = {
    // Node seems to convert everything to lowercase...
    dayperiod: 'dayPeriod',
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts#named_years
    relatedYear: 'year',
    yearName: 'literal',
    unknown: 'literal'
};
function $9c601541af601cce$export$60e84778edff6d26(props) {
    let { locale: locale, createCalendar: createCalendar, hideTimeZone: hideTimeZone, isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, minValue: minValue, maxValue: maxValue, isDateUnavailable: isDateUnavailable } = props;
    let v = props.value || props.defaultValue || props.placeholderValue || null;
    let [granularity, defaultTimeZone] = (0, $bba69d502ef9723a$export$2440da353cedad43)(v, props.granularity);
    let timeZone = defaultTimeZone || 'UTC';
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    // Resolve default hour cycle and calendar system.
    let [calendar, hourCycle] = (0, $eF4cA.useMemo)(()=>{
        let formatter = new (0, $MHwAo.DateFormatter)(locale, {
            dateStyle: 'short',
            timeStyle: 'short',
            hour12: props.hourCycle != null ? props.hourCycle === 12 : undefined
        });
        let opts = formatter.resolvedOptions();
        let calendar = createCalendar(opts.calendar);
        return [
            calendar,
            opts.hourCycle
        ];
    }, [
        locale,
        props.hourCycle,
        createCalendar
    ]);
    let [value, setDate] = (0, $iUErx.useControlledState)(props.value, props.defaultValue ?? null, props.onChange);
    let [initialValue] = (0, $eF4cA.useState)(value);
    let calendarValue = (0, $eF4cA.useMemo)(()=>(0, $bba69d502ef9723a$export$61a490a80c552550)(value, calendar) ?? null, [
        value,
        calendar
    ]);
    let [displayValue, setDisplayValue] = (0, $eF4cA.useState)(()=>new (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef)(calendar, hourCycle, calendarValue));
    let showEra = calendar.identifier === 'gregory' && displayValue.era === 'BC';
    let formatOpts = (0, $eF4cA.useMemo)(()=>({
            granularity: granularity,
            maxGranularity: props.maxGranularity ?? 'year',
            timeZone: defaultTimeZone,
            hideTimeZone: hideTimeZone,
            hourCycle: props.hourCycle,
            showEra: showEra,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros
        }), [
        props.maxGranularity,
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        hideTimeZone,
        showEra
    ]);
    let opts = (0, $eF4cA.useMemo)(()=>(0, $bba69d502ef9723a$export$7e319ea407e63bc0)({}, formatOpts), [
        formatOpts
    ]);
    let dateFormatter = (0, $eF4cA.useMemo)(()=>new (0, $MHwAo.DateFormatter)(locale, opts), [
        locale,
        opts
    ]);
    let resolvedOptions = (0, $eF4cA.useMemo)(()=>dateFormatter.resolvedOptions(), [
        dateFormatter
    ]);
    let placeholder = (0, $eF4cA.useMemo)(()=>(0, $bba69d502ef9723a$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone), [
        props.placeholderValue,
        granularity,
        calendar,
        defaultTimeZone
    ]);
    let displaySegments = (0, $eF4cA.useMemo)(()=>{
        let is12HourClock = hourCycle === 'h11' || hourCycle === 'h12';
        let segments = [
            'era',
            'year',
            'month',
            'day',
            'hour',
            ...is12HourClock ? [
                'dayPeriod'
            ] : [],
            'minute',
            'second'
        ];
        let minIndex = segments.indexOf(props.maxGranularity || 'era');
        let maxIndex = segments.indexOf(granularity === 'hour' && is12HourClock ? 'dayPeriod' : granularity);
        return segments.slice(minIndex, maxIndex + 1);
    }, [
        props.maxGranularity,
        granularity,
        hourCycle
    ]);
    let [lastValue, setLastValue] = (0, $eF4cA.useState)(calendarValue);
    let [lastCalendar, setLastCalendar] = (0, $eF4cA.useState)(calendar);
    let [lastHourCycle, setLastHourCycle] = (0, $eF4cA.useState)(hourCycle);
    if (calendarValue !== lastValue || hourCycle !== lastHourCycle || !(0, $1qrul.isEqualCalendar)(calendar, lastCalendar)) {
        displayValue = new (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef)(calendar, hourCycle, calendarValue);
        setLastValue(calendarValue);
        setLastCalendar(calendar);
        setLastHourCycle(hourCycle);
        setDisplayValue(displayValue);
    }
    let setValue = (newValue)=>{
        if (props.isDisabled || props.isReadOnly) return;
        if (newValue == null || newValue instanceof (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef) && newValue.isCleared(displaySegments)) {
            setDisplayValue(new (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef)(calendar, hourCycle, calendarValue));
            setDate(null);
        } else if (!(newValue instanceof (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef))) {
            // The display calendar should not have any effect on the emitted value.
            // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
            newValue = (0, $8jDkV.toCalendar)(newValue, v?.calendar || new (0, $1k26k.GregorianCalendar)());
            setDisplayValue(new (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef)(calendar, hourCycle, calendarValue));
            setDate(newValue);
        } else {
            // If the new value is complete and valid, trigger onChange eagerly.
            // If it represents an incomplete or invalid value (e.g. February 30th),
            // wait until the field is blurred to trigger onChange.
            if (newValue.isComplete(displaySegments)) {
                let dateValue = newValue.toValue(calendarValue ?? placeholder);
                if (newValue.validate(dateValue, displaySegments)) {
                    let newDateValue = (0, $8jDkV.toCalendar)(dateValue, v?.calendar || new (0, $1k26k.GregorianCalendar)());
                    if (!value || newDateValue.compare(value) !== 0) {
                        setDisplayValue(new (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef)(calendar, hourCycle, calendarValue)); // reset in case prop isn't updated
                        setDate(newDateValue);
                        return;
                    }
                }
            }
            // Incomplete/invalid value. Set temporary display override.
            setDisplayValue(newValue);
        }
    };
    let dateValue = (0, $eF4cA.useMemo)(()=>{
        let v = displayValue.toValue(calendarValue ?? placeholder);
        return v.toDate(timeZone);
    }, [
        displayValue,
        timeZone,
        calendarValue,
        placeholder
    ]);
    let segments = (0, $eF4cA.useMemo)(()=>$9c601541af601cce$var$$8e7461aabf74661f$var$processSegments(dateValue, displayValue, dateFormatter, resolvedOptions, calendar, locale, granularity), [
        dateValue,
        dateFormatter,
        resolvedOptions,
        displayValue,
        calendar,
        locale,
        granularity
    ]);
    let adjustSegment = (type, amount)=>{
        setValue(displayValue.cycle(type, amount, placeholder, displaySegments));
    };
    let builtinValidation = (0, $eF4cA.useMemo)(()=>(0, $bba69d502ef9723a$export$f18627323ab57ac0)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: value,
        builtinValidation: builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    return {
        ...validation,
        value: calendarValue,
        defaultValue: props.defaultValue ?? initialValue,
        dateValue: dateValue,
        calendar: calendar,
        setValue: setValue,
        segments: segments,
        dateFormatter: dateFormatter,
        validationState: validationState,
        isInvalid: isValueInvalid,
        granularity: granularity,
        maxGranularity: props.maxGranularity ?? 'year',
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        increment (part) {
            adjustSegment(part, 1);
        },
        decrement (part) {
            adjustSegment(part, -1);
        },
        incrementPage (part) {
            adjustSegment(part, $9c601541af601cce$var$$8e7461aabf74661f$var$PAGE_STEP[part] || 1);
        },
        decrementPage (part) {
            adjustSegment(part, -($9c601541af601cce$var$$8e7461aabf74661f$var$PAGE_STEP[part] || 1));
        },
        incrementToMax (part) {
            let maxValue = part === 'hour' && hourCycle === 'h12' ? 11 : displayValue.getSegmentLimits(part).maxValue;
            setValue(displayValue.set(part, maxValue, placeholder));
        },
        decrementToMin (part) {
            let minValue = part === 'hour' && hourCycle === 'h12' ? 12 : displayValue.getSegmentLimits(part).minValue;
            setValue(displayValue.set(part, minValue, placeholder));
        },
        setSegment (part, v) {
            setValue(displayValue.set(part, v, placeholder));
        },
        confirmPlaceholder () {
            if (props.isDisabled || props.isReadOnly) return;
            // If the display value is complete but invalid, we need to constrain it and emit onChange on blur.
            if (displayValue.isComplete(displaySegments)) {
                let dateValue = displayValue.toValue(calendarValue ?? placeholder);
                let newDateValue = (0, $8jDkV.toCalendar)(dateValue, v?.calendar || new (0, $1k26k.GregorianCalendar)());
                if (!value || newDateValue.compare(value) !== 0) setDate(newDateValue);
                setDisplayValue(new (0, $56b3e2b50d5202f3$export$ae165b50d181e1ef)(calendar, hourCycle, calendarValue));
            }
        },
        clearSegment (part) {
            let value = displayValue;
            if (part !== 'timeZoneName' && part !== 'literal') value = displayValue.clear(part);
            setValue(value);
        },
        formatValue (fieldOptions) {
            if (!calendarValue) return '';
            let formatOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)(fieldOptions, formatOpts);
            let formatter = new (0, $MHwAo.DateFormatter)(locale, formatOptions);
            return formatter.format(dateValue);
        },
        getDateFormatter (locale, formatOptions) {
            let newOptions = {
                ...formatOpts,
                ...formatOptions
            };
            let newFormatOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $MHwAo.DateFormatter)(locale, newFormatOptions);
        }
    };
}
function $9c601541af601cce$var$$8e7461aabf74661f$var$processSegments(dateValue, displayValue, dateFormatter, resolvedOptions, calendar, locale, granularity) {
    let timeValue = [
        'hour',
        'minute',
        'second'
    ];
    let segments = dateFormatter.formatToParts(dateValue);
    // In order to allow formatting temporarily invalid dates during editing (e.g. February 30th),
    // use a NumberFormatter to manually format segments directly from raw numbers.
    // When the user blurs the date field, the invalid segments will be constrained.
    let numberFormatter = new (0, $l3v5Z.NumberFormatter)(locale, {
        useGrouping: false
    });
    let twoDigitFormatter = new (0, $l3v5Z.NumberFormatter)(locale, {
        useGrouping: false,
        minimumIntegerDigits: 2
    });
    for (let segment of segments)if (segment.type === 'year' || segment.type === 'month' || segment.type === 'day' || segment.type === 'hour') {
        let value = displayValue[segment.type] ?? 0;
        if (resolvedOptions[segment.type] === '2-digit') segment.value = twoDigitFormatter.format(value);
        else segment.value = numberFormatter.format(value);
    }
    let processedSegments = [];
    for (let segment of segments){
        let type = $9c601541af601cce$var$$8e7461aabf74661f$var$TYPE_MAPPING[segment.type] || segment.type;
        let isEditable = $9c601541af601cce$var$$8e7461aabf74661f$var$EDITABLE_SEGMENTS[type];
        if (type === 'era' && calendar.getEras().length === 1) isEditable = false;
        let isPlaceholder = $9c601541af601cce$var$$8e7461aabf74661f$var$EDITABLE_SEGMENTS[type] && displayValue[segment.type] == null;
        let placeholder = $9c601541af601cce$var$$8e7461aabf74661f$var$EDITABLE_SEGMENTS[type] ? (0, $3e1a6d06f039011e$export$d3f5c5e0a5023fa0)(type, segment.value, locale) : null;
        let dateSegment = {
            type: type,
            text: isPlaceholder ? placeholder : segment.value,
            ...displayValue.getSegmentLimits(type),
            isPlaceholder: isPlaceholder,
            placeholder: placeholder,
            isEditable: isEditable
        };
        // There is an issue in RTL languages where time fields render (minute:hour) instead of (hour:minute).
        // To force an LTR direction on the time field since, we wrap the time segments in LRI (left-to-right) isolate unicode. See https://www.w3.org/International/questions/qa-bidi-unicode-controls.
        // These unicode characters will be added to the array of processed segments as literals and will mark the start and end of the embedded direction change.
        if (type === 'hour') {
            // This marks the start of the embedded direction change.
            processedSegments.push({
                type: 'literal',
                text: '\u2066',
                isPlaceholder: false,
                placeholder: '',
                isEditable: false
            });
            processedSegments.push(dateSegment);
            // This marks the end of the embedded direction change in the case that the granularity it set to "hour".
            if (type === granularity) processedSegments.push({
                type: 'literal',
                text: '\u2069',
                isPlaceholder: false,
                placeholder: '',
                isEditable: false
            });
        } else if (timeValue.includes(type) && type === granularity) {
            processedSegments.push(dateSegment);
            // This marks the end of the embedded direction change.
            processedSegments.push({
                type: 'literal',
                text: '\u2069',
                isPlaceholder: false,
                placeholder: '',
                isEditable: false
            });
        } else processedSegments.push(dateSegment);
    }
    return processedSegments;
}



var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");


var $iUErx = parcelRequire("iUErx");

var $1qrul = parcelRequire("1qrul");
var $1k26k = parcelRequire("1k26k");
var $tKwj1 = parcelRequire("tKwj1");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e98120c2b2c2f6a4$export$fd53cef0cc796101(props) {
    let { placeholderValue: placeholderValue = new (0, $tKwj1.Time)(), minValue: minValue, maxValue: maxValue, defaultValue: defaultValue, granularity: granularity, validate: validate } = props;
    let [value, setValue] = (0, $iUErx.useControlledState)(props.value, defaultValue ?? null, props.onChange);
    let v = value || placeholderValue;
    let day = v && 'day' in v ? v : undefined;
    let defaultValueTimeZone = defaultValue && 'timeZone' in defaultValue ? defaultValue.timeZone : undefined;
    let placeholderDate = (0, $eF4cA.useMemo)(()=>{
        let valueTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
        return (valueTimeZone || defaultValueTimeZone) && placeholderValue ? (0, $8jDkV.toZoned)($e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(placeholderValue), valueTimeZone || defaultValueTimeZone) : $e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(placeholderValue);
    }, [
        placeholderValue,
        v,
        defaultValueTimeZone
    ]);
    let minDate = (0, $eF4cA.useMemo)(()=>$e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(minValue, day), [
        minValue,
        day
    ]);
    let maxDate = (0, $eF4cA.useMemo)(()=>$e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(maxValue, day), [
        maxValue,
        day
    ]);
    let timeValue = (0, $eF4cA.useMemo)(()=>value && 'day' in value ? (0, $8jDkV.toTime)(value) : value, [
        value
    ]);
    let dateTime = (0, $eF4cA.useMemo)(()=>value == null ? null : $e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(value), [
        value
    ]);
    let defaultDateTime = (0, $eF4cA.useMemo)(()=>defaultValue == null ? null : $e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(defaultValue), [
        defaultValue
    ]);
    let onChange = (newValue)=>{
        setValue(day || defaultValueTimeZone ? newValue : newValue && (0, $8jDkV.toTime)(newValue));
    };
    let state = (0, $9c601541af601cce$export$60e84778edff6d26)({
        ...props,
        value: dateTime,
        defaultValue: defaultDateTime,
        minValue: minDate,
        maxValue: maxDate,
        onChange: onChange,
        granularity: granularity || 'minute',
        maxGranularity: 'hour',
        placeholderValue: placeholderDate ?? undefined,
        // Calendar should not matter for time fields.
        createCalendar: ()=>new (0, $1k26k.GregorianCalendar)(),
        validate: (0, $eF4cA.useCallback)(()=>validate?.(value), [
            validate,
            value
        ])
    });
    return {
        ...state,
        timeValue: timeValue
    };
}
function $e98120c2b2c2f6a4$var$$b822555cf9fe955c$var$convertValue(value, date = (0, $1qrul.today)((0, $1qrul.getLocalTimeZone)())) {
    if (!value) return null;
    if ('day' in value) return value;
    return (0, $8jDkV.toCalendarDateTime)(date, value);
}



var $3h1XC = parcelRequire("3h1XC");

var $j2JDe = parcelRequire("j2JDe");

var $1ntKq = parcelRequire("1ntKq");

var $26CkO = parcelRequire("26CkO");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eea9b8bf34c05b45$export$7b3e670c86da5fe8 = (0, $eF4cA.createContext)(null);
const $eea9b8bf34c05b45$export$8e17ddc448e87c1e = (0, $eF4cA.createContext)(null);
const $eea9b8bf34c05b45$export$3b08bebcf796eea0 = (0, $eF4cA.createContext)(null);
const $eea9b8bf34c05b45$export$5d8dc44abd10a920 = (0, $eF4cA.createContext)(null);
const $eea9b8bf34c05b45$export$d9781c7894a82487 = (0, $eF4cA.forwardRef)(function DateField(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $eea9b8bf34c05b45$export$7b3e670c86da5fe8);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let state = (0, $9c601541af601cce$export$60e84778edff6d26)({
        ...props,
        locale: locale,
        createCalendar: (0, $3a199efecdda72a1$export$dd0bbc9b26defe37),
        validationBehavior: validationBehavior
    });
    let fieldRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let inputRef = (0, $eF4cA.useRef)(null);
    let { labelProps: labelProps, fieldProps: fieldProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $bd66c7cff007706a$export$5591b0b878c1a989)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        inputRef: inputRef,
        validationBehavior: validationBehavior
    }, state, fieldRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        values: {
            state: state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-DateField'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $eea9b8bf34c05b45$export$3b08bebcf796eea0,
                state
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                }
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $0f0c58a9d2f73818$export$eefa3e19139f00f3), {
        autoComplete: props.autoComplete,
        name: props.name,
        isDisabled: props.isDisabled,
        state: state
    }));
});
const $eea9b8bf34c05b45$export$5eaee2322dd727eb = (0, $eF4cA.forwardRef)(function TimeField(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $eea9b8bf34c05b45$export$8e17ddc448e87c1e);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let state = (0, $e98120c2b2c2f6a4$export$fd53cef0cc796101)({
        ...props,
        locale: locale,
        validationBehavior: validationBehavior
    });
    let fieldRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let inputRef = (0, $eF4cA.useRef)(null);
    let { labelProps: labelProps, fieldProps: fieldProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $bd66c7cff007706a$export$4c842f6a241dc825)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        inputRef: inputRef,
        validationBehavior: validationBehavior
    }, state, fieldRef);
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            state: state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-TimeField'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $eea9b8bf34c05b45$export$5d8dc44abd10a920,
                state
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                }
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }));
});
const $eea9b8bf34c05b45$export$7edc06cf1783b30f = (0, $eF4cA.forwardRef)(function DateInput(props, ref) {
    // If state is provided by DateField/TimeField, just render.
    // Otherwise (e.g. in DatePicker), we need to call hooks and create state ourselves.
    let dateFieldState = (0, $eF4cA.useContext)($eea9b8bf34c05b45$export$3b08bebcf796eea0);
    let timeFieldState = (0, $eF4cA.useContext)($eea9b8bf34c05b45$export$5d8dc44abd10a920);
    return dateFieldState || timeFieldState ? (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($eea9b8bf34c05b45$var$$5400c097f4765e59$var$DateInputInner, {
        ...props,
        ref: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($eea9b8bf34c05b45$var$$5400c097f4765e59$var$DateInputStandalone, {
        ...props,
        ref: ref
    });
});
const $eea9b8bf34c05b45$var$$5400c097f4765e59$var$DateInputStandalone = (0, $eF4cA.forwardRef)((props, ref)=>{
    let [dateFieldProps, fieldRef] = (0, $fDYaM.useContextProps)({
        slot: props.slot
    }, ref, $eea9b8bf34c05b45$export$7b3e670c86da5fe8);
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let state = (0, $9c601541af601cce$export$60e84778edff6d26)({
        ...dateFieldProps,
        locale: locale,
        createCalendar: (0, $3a199efecdda72a1$export$dd0bbc9b26defe37)
    });
    let inputRef = (0, $eF4cA.useRef)(null);
    let { fieldProps: fieldProps, inputProps: inputProps } = (0, $bd66c7cff007706a$export$5591b0b878c1a989)({
        ...dateFieldProps,
        inputRef: inputRef
    }, state, fieldRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $eea9b8bf34c05b45$export$3b08bebcf796eea0,
                state
            ],
            [
                (0, $ecbit.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement($eea9b8bf34c05b45$var$$5400c097f4765e59$var$DateInputInner, props));
});
const $eea9b8bf34c05b45$var$$5400c097f4765e59$var$DateInputInner = (0, $eF4cA.forwardRef)((props, ref)=>{
    let { className: className, children: children } = props;
    let dateFieldState = (0, $eF4cA.useContext)($eea9b8bf34c05b45$export$3b08bebcf796eea0);
    let timeFieldState = (0, $eF4cA.useContext)($eea9b8bf34c05b45$export$5d8dc44abd10a920);
    let state = dateFieldState ?? timeFieldState;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $cTXxz.Group), {
        ...props,
        ref: ref,
        slot: props.slot || undefined,
        className: className ?? 'react-aria-DateInput',
        isReadOnly: state.isReadOnly,
        isInvalid: state.isInvalid,
        isDisabled: state.isDisabled
    }, state.segments.map((segment, i)=>(0, $eF4cA.cloneElement)(children(segment), {
            key: i
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $ecbit.Input), {
        className: ""
    }));
});
const $eea9b8bf34c05b45$export$336ab7fa954c4b5f = (0, $eF4cA.forwardRef)(function DateSegment({ segment: segment, ...otherProps }, ref) {
    let dateFieldState = (0, $eF4cA.useContext)($eea9b8bf34c05b45$export$3b08bebcf796eea0);
    let timeFieldState = (0, $eF4cA.useContext)($eea9b8bf34c05b45$export$5d8dc44abd10a920);
    let state = dateFieldState ?? timeFieldState;
    let domRef = (0, $26CkO.useObjectRef)(ref);
    let { segmentProps: segmentProps } = (0, $8d3c90cc7f8fe79f$export$1315d136e6f7581)(segment, state, domRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j2JDe.useHover)({
        ...otherProps,
        isDisabled: state.isDisabled || segment.type === 'literal'
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...otherProps,
        values: {
            ...segment,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        },
        defaultChildren: segment.text,
        defaultClassName: 'react-aria-DateSegment'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).span, {
        ...(0, $lhKAD.mergeProps)((0, $fVfXf.filterDOMProps)(otherProps, {
            global: true
        }), segmentProps, focusProps, hoverProps),
        ...renderProps,
        style: segmentProps.style,
        ref: domRef,
        "data-placeholder": segment.isPlaceholder || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-type": segment.type,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
});



var $eF4cA = parcelRequire("eF4cA");

var $i0SpD = parcelRequire("i0SpD");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $10ea02fe077a2e60$export$7b3e670c86da5fe8 = (0, $eF4cA.createContext)(null);
const $10ea02fe077a2e60$var$$0e78e2b1ea2e947e$var$segmentContainer = " _ub182 _vb182 Na182 Fb182 _Na182 Pc182 -dLGswc-h3TDrc182 sd182 eb182 __Wb182";
const $10ea02fe077a2e60$var$$0e78e2b1ea2e947e$var$dateSegment = function anonymous(props) {
    let rules = " ";
    rules += ' _Le182';
    rules += ' -zNggOc-RWHrbc182';
    if (props.isFocused) rules += ' g_h182';
    else rules += ' g9182';
    if (props.isFocused) rules += ' gle182';
    else rules += ' gl9182';
    if (props.isFocused) rules += ' px182';
    if (props.isFocused) rules += ' ple182';
    rules += ' oLvNfn182';
    rules += ' nLvNfn182';
    rules += ' kLvNfn182';
    rules += ' jLvNfn182';
    if (props.isPunctuation) rules += ' Sd182';
    else rules += ' Sj182';
    if (props.isPunctuation) rules += ' Rd182';
    else rules += ' Rj182';
    rules += ' Tj182';
    rules += ' Qj182';
    rules += ' _yb182';
    return rules;
};
const $10ea02fe077a2e60$var$$0e78e2b1ea2e947e$var$iconStyles = " sd182 eb182 _Cb182";
const $10ea02fe077a2e60$export$d9781c7894a82487 = (0, $eF4cA.forwardRef)(function DateField(props1, ref) {
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $10ea02fe077a2e60$export$7b3e670c86da5fe8);
    let { label: label, contextualHelp: contextualHelp, description: descriptionMessage, errorMessage: errorMessage, isRequired: isRequired, size: size = 'M', labelPosition: labelPosition = 'top', necessityIndicator: necessityIndicator, labelAlign: labelAlign = 'start', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, ...dateFieldProps } = props1;
    let formContext = (0, $eF4cA.useContext)((0, $i0SpD.FormContext));
    return (0, $dx4lB.jsx)((0, $eea9b8bf34c05b45$export$d9781c7894a82487), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid })=>{
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr182';
                            rules += ' yXcEWr182';
                            rules += ' BXcEWr182';
                            rules += ' AXcEWr182';
                            if (props.size === "XL") rules += ' Nl182';
                            else if (props.size === "L") rules += ' Nj182';
                            else if (props.size === "S") rules += ' Nf182';
                            else if (props.size === "XS") rules += ' Ne182';
                            else rules += ' Nk182';
                            if (props.isQuiet) rules += ' _qd182';
                            else rules += ' _qtb182';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt182';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr182';
                            else rules += ' -Anxdcc-Z3fn9H182';
                            rules += ' __v6TNLWb182';
                            rules += ' __Wb182';
                            rules += ' SMBFGYc182';
                            rules += ' RfBFGYc182';
                            rules += ' -S_-Sv182';
                            rules += ' -R_-Rv182';
                            return rules;
                        }({
                            size: size
                        }),
                        children: [
                            (0, $dx4lB.jsx)($10ea02fe077a2e60$export$3f08d3c48fa697, {
                                children: (0, $dx4lB.jsx)($10ea02fe077a2e60$export$7edc06cf1783b30f, {})
                            }),
                            (0, $dx4lB.jsx)($10ea02fe077a2e60$export$19696856283ab185, {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});
function $10ea02fe077a2e60$export$3f08d3c48fa697(props) {
    return (0, $dx4lB.jsx)("div", {
        className: $10ea02fe077a2e60$var$$0e78e2b1ea2e947e$var$segmentContainer,
        children: props.children
    });
}
function $10ea02fe077a2e60$export$7edc06cf1783b30f(props) {
    return (0, $dx4lB.jsx)((0, $eea9b8bf34c05b45$export$7edc06cf1783b30f), {
        className: "",
        ...props,
        children: (segment)=>(0, $dx4lB.jsx)((0, $eea9b8bf34c05b45$export$336ab7fa954c4b5f), {
                segment: segment,
                className: (renderProps)=>$10ea02fe077a2e60$var$$0e78e2b1ea2e947e$var$dateSegment({
                        ...renderProps,
                        isPunctuation: segment.type === 'literal'
                    })
            })
    });
}
function $10ea02fe077a2e60$export$19696856283ab185(props) {
    return props.isInvalid ? (0, $dx4lB.jsx)("div", {
        className: $10ea02fe077a2e60$var$$0e78e2b1ea2e947e$var$iconStyles,
        children: (0, $dx4lB.jsx)((0, $8w4Nl.FieldErrorIcon), {
            isDisabled: props.isDisabled
        })
    }) : null;
}



var $8w4Nl = parcelRequire("8w4Nl");

var $dm5H1 = parcelRequire("dm5H1");

var $fL4LX = parcelRequire("fL4LX");

var $2ffAV = parcelRequire("2ffAV");

var $i93Vd = parcelRequire("i93Vd");



var $8w4Nl = parcelRequire("8w4Nl");

var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");


var $eF4cA = parcelRequire("eF4cA");

var $i0SpD = parcelRequire("i0SpD");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ceb1b68e63d6ccde$export$8e17ddc448e87c1e = (0, $eF4cA.createContext)(null);
const $ceb1b68e63d6ccde$export$5eaee2322dd727eb = (0, $eF4cA.forwardRef)(function TimeField(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $ceb1b68e63d6ccde$export$8e17ddc448e87c1e);
    let { label: label, contextualHelp: contextualHelp, description: descriptionMessage, errorMessage: errorMessage, isRequired: isRequired, size: size = 'M', labelPosition: labelPosition = 'top', necessityIndicator: necessityIndicator, labelAlign: labelAlign = 'start', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, ...timeFieldProps } = props;
    let formContext = (0, $eF4cA.useContext)((0, $i0SpD.FormContext));
    return (0, $dx4lB.jsx)((0, $eea9b8bf34c05b45$export$5eaee2322dd727eb), {
        ref: ref,
        isRequired: isRequired,
        ...timeFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid })=>{
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr182';
                            rules += ' yXcEWr182';
                            rules += ' BXcEWr182';
                            rules += ' AXcEWr182';
                            if (props.size === "XL") rules += ' Nl182';
                            else if (props.size === "L") rules += ' Nj182';
                            else if (props.size === "S") rules += ' Nf182';
                            else if (props.size === "XS") rules += ' Ne182';
                            else rules += ' Nk182';
                            if (props.isQuiet) rules += ' _qd182';
                            else rules += ' _qtb182';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt182';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr182';
                            else rules += ' -Anxdcc-Z3fn9H182';
                            rules += ' __v6TNLWb182';
                            rules += ' SMBFGYc182';
                            rules += ' RfBFGYc182';
                            rules += ' -S_-Sv182';
                            rules += ' -R_-Rv182';
                            return rules;
                        }({
                            size: size
                        }),
                        children: [
                            (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$3f08d3c48fa697), {
                                children: (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$7edc06cf1783b30f), {})
                            }),
                            (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$19696856283ab185), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});



var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");

var $k5Pnh = parcelRequire("k5Pnh");


var $fDYaM = parcelRequire("fDYaM");


var $8gDpA = parcelRequire("8gDpA");

var $4kYL7 = parcelRequire("4kYL7");

var $i0SpD = parcelRequire("i0SpD");

var $cTXxz = parcelRequire("cTXxz");


var $8UElq = parcelRequire("8UElq");

var $f8UJ0 = parcelRequire("f8UJ0");

var $c1ibQ = parcelRequire("c1ibQ");

var $6pgkA = parcelRequire("6pgkA");

var $fVfXf = parcelRequire("fVfXf");


var $lhKAD = parcelRequire("lhKAD");

var $fvyIQ = parcelRequire("fvyIQ");



var $lXRQr = parcelRequire("lXRQr");

var $cI1qR = parcelRequire("cI1qR");

var $i1DSg = parcelRequire("i1DSg");

var $25dFS = parcelRequire("25dFS");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $iEwfj = parcelRequire("iEwfj");

var $eF4cA = parcelRequire("eF4cA");
function $69742f1850232e94$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $69742f1850232e94$export$42df105a73306d51(props, state, ref) {
    let buttonId = (0, $25dFS.useId)();
    let dialogId = (0, $25dFS.useId)();
    let fieldId = (0, $25dFS.useId)();
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($69742f1850232e94$var$$parcel$interopDefault((0, $31eb57338bef8038$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let groupProps = (0, $06349090e062b7a8$export$4a931266a3838b86)(state, ref);
    let labelledBy = fieldProps['aria-labelledby'] || fieldProps.id;
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let date = state.formatValue(locale, {
        month: 'long'
    });
    let description = date ? stringFormatter.format('selectedDateDescription', {
        date: date
    }) : '';
    let descProps = (0, $lXRQr.useDescription)(description);
    let ariaDescribedBy = [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    let focusManager = (0, $eF4cA.useMemo)(()=>(0, $6pgkA.createFocusManager)(ref), [
        ref
    ]);
    let isFocused = (0, $eF4cA.useRef)(false);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        ...props,
        isDisabled: state.isOpen,
        onBlurWithin: (e)=>{
            // Ignore when focus moves into the popover.
            let dialog = document.getElementById(dialogId);
            if (!(0, $fvyIQ.nodeContains)(dialog, e.relatedTarget)) {
                isFocused.current = false;
                props.onBlur?.(e);
                props.onFocusChange?.(false);
            }
        },
        onFocusWithin: (e)=>{
            if (!isFocused.current) {
                isFocused.current = true;
                props.onFocus?.(e);
                props.onFocusChange?.(true);
            }
        }
    });
    return {
        groupProps: (0, $lhKAD.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: 'group',
            'aria-disabled': props.isDisabled || null,
            'aria-labelledby': labelledBy,
            'aria-describedby': ariaDescribedBy,
            onKeyDown (e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        fieldProps: {
            ...fieldProps,
            id: fieldId,
            [(0, $bd66c7cff007706a$export$300019f83c56d282)]: 'presentation',
            'aria-describedby': ariaDescribedBy,
            value: state.value,
            defaultValue: state.defaultValue,
            onChange: state.setValue,
            placeholderValue: props.placeholderValue,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            granularity: props.granularity,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isRequired: props.isRequired,
            validationBehavior: props.validationBehavior,
            // DatePicker owns the validation state for the date field.
            [(0, $iEwfj.privateValidationStateProp)]: state,
            autoFocus: props.autoFocus,
            name: props.name,
            form: props.form
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        buttonProps: {
            ...descProps,
            id: buttonId,
            'aria-haspopup': 'dialog',
            'aria-label': stringFormatter.format('calendar'),
            'aria-labelledby': `${buttonId} ${labelledBy}`,
            'aria-describedby': ariaDescribedBy,
            'aria-expanded': state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: ()=>state.setOpen(true)
        },
        dialogProps: {
            id: dialogId,
            'aria-labelledby': `${buttonId} ${labelledBy}`
        },
        calendarProps: {
            autoFocus: true,
            value: state.dateValue,
            onChange: state.setDateValue,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            defaultFocusedValue: state.dateValue ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === 'function' ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(' '),
            firstDayOfWeek: props.firstDayOfWeek,
            pageBehavior: props.pageBehavior
        },
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}



var $6pgkA = parcelRequire("6pgkA");

var $fVfXf = parcelRequire("fVfXf");



var $lhKAD = parcelRequire("lhKAD");

var $fvyIQ = parcelRequire("fvyIQ");


var $lXRQr = parcelRequire("lXRQr");

var $cI1qR = parcelRequire("cI1qR");

var $i1DSg = parcelRequire("i1DSg");

var $25dFS = parcelRequire("25dFS");

var $1ntKq = parcelRequire("1ntKq");

var $gI8Gw = parcelRequire("gI8Gw");

var $iEwfj = parcelRequire("iEwfj");

var $eF4cA = parcelRequire("eF4cA");
function $4d2c41f8ebd12d73$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4d2c41f8ebd12d73$export$12fd5f0e9f4bb192(props, state, ref) {
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($4d2c41f8ebd12d73$var$$parcel$interopDefault((0, $31eb57338bef8038$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $cI1qR.useField)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let labelledBy = fieldProps['aria-labelledby'] || fieldProps.id;
    let { locale: locale } = (0, $1ntKq.useLocale)();
    let range = state.formatValue(locale, {
        month: 'long'
    });
    let description = range ? stringFormatter.format('selectedRangeDescription', {
        startDate: range.start,
        endDate: range.end
    }) : '';
    let descProps = (0, $lXRQr.useDescription)(description);
    let startFieldProps = {
        'aria-label': stringFormatter.format('startDate'),
        'aria-labelledby': labelledBy
    };
    let endFieldProps = {
        'aria-label': stringFormatter.format('endDate'),
        'aria-labelledby': labelledBy
    };
    let buttonId = (0, $25dFS.useId)();
    let dialogId = (0, $25dFS.useId)();
    let groupProps = (0, $06349090e062b7a8$export$4a931266a3838b86)(state, ref);
    let ariaDescribedBy = [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    let focusManager = (0, $eF4cA.useMemo)(()=>(0, $6pgkA.createFocusManager)(ref, {
            // Exclude the button from the focus manager.
            accept: (element)=>element.id !== buttonId
        }), [
        ref,
        buttonId
    ]);
    let commonFieldProps = {
        [(0, $bd66c7cff007706a$export$7b3062cd49e80452)]: focusManager,
        [(0, $bd66c7cff007706a$export$300019f83c56d282)]: 'presentation',
        'aria-describedby': ariaDescribedBy,
        placeholderValue: props.placeholderValue,
        hideTimeZone: props.hideTimeZone,
        hourCycle: props.hourCycle,
        granularity: props.granularity,
        shouldForceLeadingZeros: props.shouldForceLeadingZeros,
        isDisabled: props.isDisabled,
        isReadOnly: props.isReadOnly,
        isRequired: props.isRequired,
        validationBehavior: props.validationBehavior
    };
    let domProps = (0, $fVfXf.filterDOMProps)(props);
    let isFocused = (0, $eF4cA.useRef)(false);
    let { focusWithinProps: focusWithinProps } = (0, $i1DSg.useFocusWithin)({
        ...props,
        isDisabled: state.isOpen,
        onBlurWithin: (e)=>{
            // Ignore when focus moves into the popover.
            let dialog = document.getElementById(dialogId);
            if (!(0, $fvyIQ.nodeContains)(dialog, e.relatedTarget)) {
                isFocused.current = false;
                props.onBlur?.(e);
                props.onFocusChange?.(false);
            }
        },
        onFocusWithin: (e)=>{
            if (!isFocused.current) {
                isFocused.current = true;
                props.onFocus?.(e);
                props.onFocusChange?.(true);
            }
        }
    });
    let startFieldValidation = (0, $eF4cA.useRef)((0, $iEwfj.DEFAULT_VALIDATION_RESULT));
    let endFieldValidation = (0, $eF4cA.useRef)((0, $iEwfj.DEFAULT_VALIDATION_RESULT));
    return {
        groupProps: (0, $lhKAD.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: 'group',
            'aria-disabled': props.isDisabled || null,
            'aria-describedby': ariaDescribedBy,
            onKeyDown (e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        buttonProps: {
            ...descProps,
            id: buttonId,
            'aria-haspopup': 'dialog',
            'aria-label': stringFormatter.format('calendar'),
            'aria-labelledby': `${buttonId} ${labelledBy}`,
            'aria-describedby': ariaDescribedBy,
            'aria-expanded': state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: ()=>state.setOpen(true)
        },
        dialogProps: {
            id: dialogId,
            'aria-labelledby': `${buttonId} ${labelledBy}`
        },
        startFieldProps: {
            ...startFieldProps,
            ...commonFieldProps,
            value: state.value?.start ?? null,
            defaultValue: state.defaultValue?.start,
            onChange: (start)=>state.setDateTime('start', start),
            autoFocus: props.autoFocus,
            name: props.startName,
            form: props.form,
            [(0, $iEwfj.privateValidationStateProp)]: {
                realtimeValidation: state.realtimeValidation,
                displayValidation: state.displayValidation,
                updateValidation (e) {
                    startFieldValidation.current = e;
                    state.updateValidation((0, $iEwfj.mergeValidation)(e, endFieldValidation.current));
                },
                resetValidation: state.resetValidation,
                commitValidation: state.commitValidation
            }
        },
        endFieldProps: {
            ...endFieldProps,
            ...commonFieldProps,
            value: state.value?.end ?? null,
            defaultValue: state.defaultValue?.end,
            onChange: (end)=>state.setDateTime('end', end),
            name: props.endName,
            form: props.form,
            [(0, $iEwfj.privateValidationStateProp)]: {
                realtimeValidation: state.realtimeValidation,
                displayValidation: state.displayValidation,
                updateValidation (e) {
                    endFieldValidation.current = e;
                    state.updateValidation((0, $iEwfj.mergeValidation)(startFieldValidation.current, e));
                },
                resetValidation: state.resetValidation,
                commitValidation: state.commitValidation
            }
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        calendarProps: {
            autoFocus: true,
            value: state.dateRange?.start && state.dateRange.end ? state.dateRange : null,
            onChange: state.setDateRange,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            allowsNonContiguousRanges: props.allowsNonContiguousRanges,
            defaultFocusedValue: state.dateRange ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === 'function' ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(' '),
            firstDayOfWeek: props.firstDayOfWeek,
            pageBehavior: props.pageBehavior
        },
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}




var $iEwfj = parcelRequire("iEwfj");

var $lIr3v = parcelRequire("lIr3v");

var $iUErx = parcelRequire("iUErx");

var $MHwAo = parcelRequire("MHwAo");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $00da5c3d0d79640f$export$87194bb378cc3ac2(props) {
    let overlayState = (0, $lIr3v.useOverlayTriggerState)(props);
    let [value, setValue] = (0, $iUErx.useControlledState)(props.value, props.defaultValue || null, props.onChange);
    let [initialValue] = (0, $eF4cA.useState)(value);
    let v = value || props.placeholderValue || null;
    let [granularity, defaultTimeZone] = (0, $bba69d502ef9723a$export$2440da353cedad43)(v, props.granularity);
    let dateValue = value != null ? value.toDate(defaultTimeZone ?? 'UTC') : null;
    let hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    let shouldCloseOnSelect = props.shouldCloseOnSelect ?? true;
    let [selectedDate, setSelectedDate] = (0, $eF4cA.useState)(null);
    let [selectedTime, setSelectedTime] = (0, $eF4cA.useState)(null);
    if (value) {
        selectedDate = value;
        if ('hour' in value) selectedTime = value;
    }
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    let showEra = value?.calendar.identifier === 'gregory' && value.era === 'BC';
    let formatOpts = (0, $eF4cA.useMemo)(()=>({
            granularity: granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra: showEra
        }), [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    let { minValue: minValue, maxValue: maxValue, isDateUnavailable: isDateUnavailable } = props;
    let builtinValidation = (0, $eF4cA.useMemo)(()=>(0, $bba69d502ef9723a$export$f18627323ab57ac0)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: value,
        builtinValidation: builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    let commitValue = (date, time)=>{
        setValue('timeZone' in time ? time.set((0, $8jDkV.toCalendarDate)(date)) : (0, $8jDkV.toCalendarDateTime)(date, time));
        setSelectedDate(null);
        setSelectedTime(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    let selectDate = (newValue)=>{
        let shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            if (selectedTime || shouldClose) commitValue(newValue, selectedTime || (0, $bba69d502ef9723a$export$c5221a78ef73c5e9)(props.defaultValue || props.placeholderValue));
            else setSelectedDate(newValue);
        } else {
            setValue(newValue);
            validation.commitValidation();
        }
        if (shouldClose) overlayState.setOpen(false);
    };
    let selectTime = (newValue)=>{
        if (selectedDate && newValue) commitValue(selectedDate, newValue);
        else setSelectedTime(newValue);
    };
    return {
        ...validation,
        value: value,
        defaultValue: props.defaultValue ?? initialValue,
        setValue: setValue,
        dateValue: selectedDate,
        timeValue: selectedTime,
        setDateValue: selectDate,
        setTimeValue: selectTime,
        granularity: granularity,
        hasTime: hasTime,
        ...overlayState,
        setOpen (isOpen) {
            // Commit the selected date when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time was set and not the date, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !value && selectedDate && hasTime) commitValue(selectedDate, selectedTime || (0, $bba69d502ef9723a$export$c5221a78ef73c5e9)(props.defaultValue || props.placeholderValue));
            overlayState.setOpen(isOpen);
        },
        validationState: validationState,
        isInvalid: isValueInvalid,
        formatValue (locale, fieldOptions) {
            if (!dateValue) return '';
            let formatOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)(fieldOptions, formatOpts);
            let formatter = new (0, $MHwAo.DateFormatter)(locale, formatOptions);
            return formatter.format(dateValue);
        },
        getDateFormatter (locale, formatOptions) {
            let newOptions = {
                ...formatOpts,
                ...formatOptions
            };
            let newFormatOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $MHwAo.DateFormatter)(locale, newFormatOptions);
        }
    };
}




var $iEwfj = parcelRequire("iEwfj");

var $lIr3v = parcelRequire("lIr3v");

var $iUErx = parcelRequire("iUErx");

var $MHwAo = parcelRequire("MHwAo");
var $8jDkV = parcelRequire("8jDkV");

var $eF4cA = parcelRequire("eF4cA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5afbd2a77f3bf93a$export$e50a61c1de9f574(props) {
    let overlayState = (0, $lIr3v.useOverlayTriggerState)(props);
    let [controlledValue, setControlledValue] = (0, $iUErx.useControlledState)(props.value, props.defaultValue || null, props.onChange);
    let [initialValue] = (0, $eF4cA.useState)(controlledValue);
    let [placeholderValue, setPlaceholderValue] = (0, $eF4cA.useState)(()=>controlledValue || {
            start: null,
            end: null
        });
    // Reset the placeholder if the value prop is set to null.
    if (controlledValue == null && placeholderValue.start && placeholderValue.end) {
        placeholderValue = {
            start: null,
            end: null
        };
        setPlaceholderValue(placeholderValue);
    }
    let value = controlledValue || placeholderValue;
    let setValue = (newValue)=>{
        // oxlint-disable-next-line react/react-compiler
        value = newValue || {
            start: null,
            end: null
        };
        setPlaceholderValue(value);
        if ($5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(value)) setControlledValue(value);
        else setControlledValue(null);
    };
    let v = value?.start || value?.end || props.placeholderValue || null;
    let [granularity, defaultTimeZone] = (0, $bba69d502ef9723a$export$2440da353cedad43)(v, props.granularity);
    let hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    let shouldCloseOnSelect = props.shouldCloseOnSelect ?? true;
    let [dateRange, setSelectedDateRange] = (0, $eF4cA.useState)(null);
    let [timeRange, setSelectedTimeRange] = (0, $eF4cA.useState)(null);
    if (value && $5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(value)) {
        dateRange = value;
        if ('hour' in value.start) timeRange = value;
    }
    let commitValue = (dateRange, timeRange)=>{
        setValue({
            start: 'timeZone' in timeRange.start ? timeRange.start.set((0, $8jDkV.toCalendarDate)(dateRange.start)) : (0, $8jDkV.toCalendarDateTime)(dateRange.start, timeRange.start),
            end: 'timeZone' in timeRange.end ? timeRange.end.set((0, $8jDkV.toCalendarDate)(dateRange.end)) : (0, $8jDkV.toCalendarDateTime)(dateRange.end, timeRange.end)
        });
        setSelectedDateRange(null);
        setSelectedTimeRange(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    let setDateRange = (range)=>{
        let shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            // Set a placeholder time if the popover is closing so we don't leave the field in an incomplete state.
            if ($5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(range) && (shouldClose || timeRange?.start && timeRange?.end)) commitValue(range, {
                start: timeRange?.start || (0, $bba69d502ef9723a$export$c5221a78ef73c5e9)(props.placeholderValue),
                end: timeRange?.end || (0, $bba69d502ef9723a$export$c5221a78ef73c5e9)(props.placeholderValue)
            });
            else setSelectedDateRange(range);
        } else if ($5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(range)) {
            setValue(range);
            validation.commitValidation();
        } else setSelectedDateRange(range);
        if (shouldClose) overlayState.setOpen(false);
    };
    let setTimeRange = (range)=>{
        if ($5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(dateRange) && $5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(range)) commitValue(dateRange, range);
        else setSelectedTimeRange(range);
    };
    let showEra = value?.start?.calendar.identifier === 'gregory' && value.start.era === 'BC' || value?.end?.calendar.identifier === 'gregory' && value.end.era === 'BC';
    let formatOpts = (0, $eF4cA.useMemo)(()=>({
            granularity: granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra: showEra
        }), [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    let { minValue: minValue, maxValue: maxValue, isDateUnavailable: isDateUnavailable } = props;
    let builtinValidation = (0, $eF4cA.useMemo)(()=>(0, $bba69d502ef9723a$export$80ff8fc0ae339c13)(value, minValue, maxValue, isDateUnavailable ? (date)=>isDateUnavailable(date, null) : undefined, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, $iEwfj.useFormValidationState)({
        ...props,
        value: controlledValue,
        name: (0, $eF4cA.useMemo)(()=>[
                props.startName,
                props.endName
            ].filter((n)=>n != null), [
            props.startName,
            props.endName
        ]),
        builtinValidation: builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    return {
        ...validation,
        value: value,
        defaultValue: props.defaultValue ?? initialValue,
        setValue: setValue,
        dateRange: dateRange,
        timeRange: timeRange,
        granularity: granularity,
        hasTime: hasTime,
        setDate (part, date) {
            if (part === 'start') setDateRange({
                start: date,
                end: dateRange?.end ?? null
            });
            else setDateRange({
                start: dateRange?.start ?? null,
                end: date
            });
        },
        setTime (part, time) {
            if (part === 'start') setTimeRange({
                start: time,
                end: timeRange?.end ?? null
            });
            else setTimeRange({
                start: timeRange?.start ?? null,
                end: time
            });
        },
        setDateTime (part, dateTime) {
            if (part === 'start') setValue({
                start: dateTime,
                end: value?.end ?? null
            });
            else setValue({
                start: value?.start ?? null,
                end: dateTime
            });
        },
        setDateRange: setDateRange,
        setTimeRange: setTimeRange,
        ...overlayState,
        setOpen (isOpen) {
            // Commit the selected date range when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time range was set and not the date range, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !(value?.start && value?.end) && $5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(dateRange) && hasTime) commitValue(dateRange, {
                start: timeRange?.start || (0, $bba69d502ef9723a$export$c5221a78ef73c5e9)(props.placeholderValue),
                end: timeRange?.end || (0, $bba69d502ef9723a$export$c5221a78ef73c5e9)(props.placeholderValue)
            });
            overlayState.setOpen(isOpen);
        },
        validationState: validationState,
        isInvalid: isValueInvalid,
        formatValue (locale, fieldOptions) {
            if (!value || !value.start || !value.end) return null;
            let startTimeZone = 'timeZone' in value.start ? value.start.timeZone : undefined;
            let startGranularity = props.granularity || (value.start && 'minute' in value.start ? 'minute' : 'day');
            let endTimeZone = 'timeZone' in value.end ? value.end.timeZone : undefined;
            let endGranularity = props.granularity || (value.end && 'minute' in value.end ? 'minute' : 'day');
            let startOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)(fieldOptions, {
                granularity: startGranularity,
                timeZone: startTimeZone,
                hideTimeZone: props.hideTimeZone,
                hourCycle: props.hourCycle,
                showEra: value.start.calendar.identifier === 'gregory' && value.start.era === 'BC' || value.end.calendar.identifier === 'gregory' && value.end.era === 'BC'
            });
            let startDate = value.start.toDate(startTimeZone || 'UTC');
            let endDate = value.end.toDate(endTimeZone || 'UTC');
            let startFormatter = new (0, $MHwAo.DateFormatter)(locale, startOptions);
            let endFormatter;
            if (startTimeZone === endTimeZone && startGranularity === endGranularity && value.start.compare(value.end) !== 0) {
                // Use formatRange, as it results in shorter output when some of the fields
                // are shared between the start and end dates (e.g. the same month).
                // Formatting will fail if the end date is before the start date. Fall back below when that happens.
                try {
                    let parts = startFormatter.formatRangeToParts(startDate, endDate);
                    // Find the separator between the start and end date. This is determined
                    // by finding the last shared literal before the end range.
                    let separatorIndex = -1;
                    for(let i = 0; i < parts.length; i++){
                        let part = parts[i];
                        if (part.source === 'shared' && part.type === 'literal') separatorIndex = i;
                        else if (part.source === 'endRange') break;
                    }
                    // Now we can combine the parts into start and end strings.
                    let start = '';
                    let end = '';
                    for(let i = 0; i < parts.length; i++){
                        if (i < separatorIndex) start += parts[i].value;
                        else if (i > separatorIndex) end += parts[i].value;
                    }
                    return {
                        start: start,
                        end: end
                    };
                } catch  {
                // ignore
                }
                endFormatter = startFormatter;
            } else {
                let endOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)(fieldOptions, {
                    granularity: endGranularity,
                    timeZone: endTimeZone,
                    hideTimeZone: props.hideTimeZone,
                    hourCycle: props.hourCycle
                });
                endFormatter = new (0, $MHwAo.DateFormatter)(locale, endOptions);
            }
            return {
                start: startFormatter.format(startDate),
                end: endFormatter.format(endDate)
            };
        },
        getDateFormatter (locale, formatOptions) {
            let newOptions = {
                ...formatOpts,
                ...formatOptions
            };
            let newFormatOptions = (0, $bba69d502ef9723a$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $MHwAo.DateFormatter)(locale, newFormatOptions);
        }
    };
}
function $5afbd2a77f3bf93a$var$$6de3e3f1a7663217$var$isCompleteRange(value) {
    return value?.start != null && value.end != null;
}



var $fVfXf = parcelRequire("fVfXf");

var $lhKAD = parcelRequire("lhKAD");

var $eF4cA = parcelRequire("eF4cA");

var $3h1XC = parcelRequire("3h1XC");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f925882e3f051847$export$cf316c7f3b44c11e = (0, $eF4cA.createContext)(null);
const $f925882e3f051847$export$8282edba42ee28a = (0, $eF4cA.createContext)(null);
const $f925882e3f051847$export$50a10c048fdcdee9 = (0, $eF4cA.createContext)(null);
const $f925882e3f051847$export$80d7ae1f804790be = (0, $eF4cA.createContext)(null);
// Contexts to clear inside the popover.
const $f925882e3f051847$var$$e539d00f123fdfd8$var$CLEAR_CONTEXTS = [
    (0, $cTXxz.GroupContext),
    (0, $k5Pnh.ButtonContext),
    (0, $8UElq.LabelContext),
    (0, $c1ibQ.TextContext)
];
const $f925882e3f051847$export$5109c6dd95d8fb00 = (0, $eF4cA.forwardRef)(function DatePicker(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $f925882e3f051847$export$cf316c7f3b44c11e);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $00da5c3d0d79640f$export$87194bb378cc3ac2)({
        ...props,
        validationBehavior: validationBehavior
    });
    let groupRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps: groupProps, labelProps: labelProps, fieldProps: fieldProps, buttonProps: buttonProps, dialogProps: dialogProps, calendarProps: calendarProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $69742f1850232e94$export$42df105a73306d51)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, groupRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            state: state,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-DatePicker'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $f925882e3f051847$export$50a10c048fdcdee9,
                state
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    ...groupProps,
                    ref: groupRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, $eea9b8bf34c05b45$export$7b3e670c86da5fe8),
                fieldProps
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    ...buttonProps,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $e283c5f3c36f6582$export$3b805cea1f178355),
                calendarProps
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                state
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    trigger: 'DatePicker',
                    triggerRef: groupRef,
                    placement: 'bottom start',
                    clearContexts: $f925882e3f051847$var$$e539d00f123fdfd8$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $8gDpA.DialogContext),
                dialogProps
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-open": state.isOpen || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $0f0c58a9d2f73818$export$eefa3e19139f00f3), {
        autoComplete: props.autoComplete,
        name: props.name,
        isDisabled: props.isDisabled,
        state: state
    }));
});
const $f925882e3f051847$export$17334619f3ac2224 = (0, $eF4cA.forwardRef)(function DateRangePicker(props, ref) {
    [props, ref] = (0, $fDYaM.useContextProps)(props, ref, $f925882e3f051847$export$8282edba42ee28a);
    let { validationBehavior: formValidationBehavior } = (0, $fDYaM.useSlottedContext)((0, $i0SpD.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, $5afbd2a77f3bf93a$export$e50a61c1de9f574)({
        ...props,
        validationBehavior: validationBehavior
    });
    let groupRef = (0, $eF4cA.useRef)(null);
    let [labelRef, label] = (0, $fDYaM.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps: groupProps, labelProps: labelProps, startFieldProps: startFieldProps, endFieldProps: endFieldProps, buttonProps: buttonProps, dialogProps: dialogProps, calendarProps: calendarProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $4d2c41f8ebd12d73$export$12fd5f0e9f4bb192)({
        ...(0, $fDYaM.removeDataAttributes)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, groupRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3h1XC.useFocusRing)({
        within: true
    });
    let renderProps = (0, $fDYaM.useRenderProps)({
        ...props,
        values: {
            state: state,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-DateRangePicker'
    });
    let DOMProps = (0, $fVfXf.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.Provider), {
        values: [
            [
                $f925882e3f051847$export$80d7ae1f804790be,
                state
            ],
            [
                (0, $cTXxz.GroupContext),
                {
                    ...groupProps,
                    ref: groupRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, $k5Pnh.ButtonContext),
                {
                    ...buttonProps,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, $8UElq.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $e283c5f3c36f6582$export$233dd9682e1ad64b),
                calendarProps
            ],
            [
                (0, $8gDpA.OverlayTriggerStateContext),
                state
            ],
            [
                (0, $f8UJ0.PopoverContext),
                {
                    trigger: 'DateRangePicker',
                    triggerRef: groupRef,
                    placement: 'bottom start',
                    clearContexts: $f925882e3f051847$var$$e539d00f123fdfd8$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $8gDpA.DialogContext),
                dialogProps
            ],
            [
                (0, $eea9b8bf34c05b45$export$7b3e670c86da5fe8),
                {
                    slots: {
                        start: startFieldProps,
                        end: endFieldProps
                    }
                }
            ],
            [
                (0, $c1ibQ.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $4kYL7.FieldErrorContext),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eF4cA))).createElement((0, $fDYaM.dom).div, {
        ...(0, $lhKAD.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-open": state.isOpen || undefined
    }));
});



var $k5Pnh = parcelRequire("k5Pnh");

var $fDYaM = parcelRequire("fDYaM");

var $eF4cA = parcelRequire("eF4cA");

var $8gDpA = parcelRequire("8gDpA");

var $i0SpD = parcelRequire("i0SpD");

var $gI8Gw = parcelRequire("gI8Gw");
function $2c3f2c4ee9806aac$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2c3f2c4ee9806aac$export$cf316c7f3b44c11e = (0, $eF4cA.createContext)(null);
const $2c3f2c4ee9806aac$var$$1196aa313ab37be1$var$inputButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf182';
    else rules += ' _Le182';
    rules += ' Oh182';
    rules += ' Olc182';
    rules += ' _Mc182';
    rules += ' _Kd182';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec182';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn182';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b182';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd182';
    else rules += ' -SFnbic-_Jb182';
    rules += ' -Bu7z1c-oa182';
    rules += ' oj182';
    rules += ' nj182';
    rules += ' kj182';
    rules += ' jj182';
    rules += ' _Pc182';
    if (props.size === "XL") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "L") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "M") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    } else if (props.size === "S") {
        rules += ' uk182';
        rules += ' ucJ9TBTb182';
        rules += ' ud3Euai182';
        rules += ' uea182';
        rules += ' ugb182';
        rules += ' uhd182';
        rules += ' uje182';
        rules += ' u2NhKxcl182';
        rules += ' uic182';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e182';
        rules += ' vx182';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d182';
        rules += ' vx182';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c182';
        rules += ' vx182';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b182';
        rules += ' vx182';
    }
    if (props.size === "XL") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "L") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "M") {
        rules += ' xb182';
        rules += ' _xa182';
    } else if (props.size === "S") {
        rules += ' xb182';
        rules += ' _xa182';
    }
    if (props.size === "XL") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "L") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "M") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    } else if (props.size === "S") {
        rules += ' _Fd182';
        rules += ' _FnuYUweb182';
    }
    if (props.isDisabled) rules += ' pp182';
    else {
        if (props.isPressed) rules += ' po182';
        else if (props.isFocusVisible) rules += ' po182';
        else if (props.isHovered) rules += ' po182';
        else rules += ' pt182';
    }
    rules += ' pla182';
    rules += ' ri182';
    rules += ' sd182';
    rules += ' _Wa182';
    rules += ' _je182';
    rules += ' eb182';
    rules += ' _Ca182';
    if (props.size === "XL") rules += ' ZC182';
    else if (props.size === "L") rules += ' Zo182';
    else if (props.size === "M") rules += ' Zm182';
    else if (props.size === "S") rules += ' Zu182';
    rules += ' Fd182';
    rules += ' Iw182';
    rules += ' fa182';
    rules += ' _va182';
    rules += ' Yd182';
    rules += ' Yle182';
    rules += ' Xb182';
    rules += ' Xlb182';
    rules += ' _2b182';
    rules += ' _2lb182';
    if (props.isDisabled) rules += ' gH182';
    else if (props.isOpen) rules += ' gF182';
    else {
        if (props.isPressed) rules += ' gF182';
        else if (props.isFocusVisible) rules += ' gF182';
        else if (props.isHovered) rules += ' gF182';
        else rules += ' gH182';
    }
    if (props.isDisabled) rules += ' gld182';
    else if (props.isOpen) rules += ' gle182';
    else if (props.isHovered) rules += ' gle182';
    else rules += ' glc182';
    return rules;
};
const $2c3f2c4ee9806aac$export$5320dd0e349ed44d = " _vb182 _ua182 Na182 Ze4mUs182";
const $2c3f2c4ee9806aac$export$5109c6dd95d8fb00 = (0, $eF4cA.forwardRef)(function DatePicker(props1, ref) {
    [props1, ref] = (0, $5t6Bv.useSpectrumContextProps)(props1, ref, $2c3f2c4ee9806aac$export$cf316c7f3b44c11e);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($2c3f2c4ee9806aac$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { label: label, contextualHelp: contextualHelp, description: descriptionMessage, errorMessage: errorMessage, isRequired: isRequired, size: size = 'M', labelPosition: labelPosition = 'top', necessityIndicator: necessityIndicator, labelAlign: labelAlign = 'start', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, placeholderValue: placeholderValue, maxVisibleMonths: maxVisibleMonths = 1, createCalendar: createCalendar, ...dateFieldProps } = props1;
    let formContext = (0, $eF4cA.useContext)((0, $i0SpD.FormContext));
    let [buttonHasFocus, setButtonHasFocus] = (0, $eF4cA.useState)(false);
    return (0, $dx4lB.jsx)((0, $f925882e3f051847$export$5109c6dd95d8fb00), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid, isOpen: isOpen, state: state })=>{
            let placeholder = placeholderValue ?? undefined;
            let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : undefined;
            let timeMinValue = props1.minValue && 'hour' in props1.minValue ? props1.minValue : undefined;
            let timeMaxValue = props1.maxValue && 'hour' in props1.maxValue ? props1.maxValue : undefined;
            let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : undefined;
            let showTimeField = !!timeGranularity;
            // Ideally, we could omit errorMessage here and let S2 Calendar read it from RAC's CalendarContext which already contains the resolved value via calendarProps from useDatePicker.
            // However, RAC's CalendarProps omits errorMessage, so reading it back from the context would require an unsafe cast. Instead, we resolve it here using the same logic as useDatePicker.
            let resolvedErrorMessage = typeof errorMessage === 'function' ? errorMessage(state.displayValidation) : errorMessage || state.displayValidation.validationErrors.join(' ');
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                        role: "presentation",
                        shouldTurnOffFocusRing: buttonHasFocus,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr182';
                            rules += ' yXcEWr182';
                            rules += ' BXcEWr182';
                            rules += ' AXcEWr182';
                            if (props.size === "XL") rules += ' Nl182';
                            else if (props.size === "L") rules += ' Nj182';
                            else if (props.size === "S") rules += ' Nf182';
                            else if (props.size === "XS") rules += ' Ne182';
                            else rules += ' Nk182';
                            if (props.isQuiet) rules += ' _qd182';
                            else rules += ' _qtb182';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt182';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr182';
                            else rules += ' -Anxdcc-Z3fn9H182';
                            rules += ' __v6TNLWb182';
                            rules += ' __Wb182';
                            rules += ' SMBFGYc182';
                            rules += ' RfBFGYc182';
                            rules += ' -S_-Sv182';
                            if (props.size === "XL") rules += ' -R_-RWJpoB182';
                            else if (props.size === "L") rules += ' -R_-RWJpoB182';
                            else if (props.size === "M") rules += ' -R_-Rp182';
                            else if (props.size === "S") rules += ' -R_-Rj182';
                            return rules;
                        }({
                            size: size
                        }),
                        children: [
                            (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$3f08d3c48fa697), {
                                children: (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$7edc06cf1783b30f), {})
                            }),
                            (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$19696856283ab185), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            }),
                            (0, $dx4lB.jsx)($2c3f2c4ee9806aac$export$adb29da0ac001538, {
                                isOpen: isOpen,
                                size: size,
                                setButtonHasFocus: setButtonHasFocus
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)($2c3f2c4ee9806aac$export$f3ce207574a3cffe, {
                        shouldFlip: props1.shouldFlip,
                        children: [
                            (0, $dx4lB.jsx)((0, $ecefd708045a9721$export$e1aef45b828286de), {
                                visibleMonths: maxVisibleMonths,
                                createCalendar: createCalendar,
                                errorMessage: resolvedErrorMessage
                            }),
                            showTimeField && (0, $dx4lB.jsx)("div", {
                                className: " sd182 Ul182 ql182 _qb182",
                                children: (0, $dx4lB.jsx)((0, $ceb1b68e63d6ccde$export$5eaee2322dd727eb), {
                                    styles: $2c3f2c4ee9806aac$export$5320dd0e349ed44d,
                                    label: stringFormatter.format('datepicker.time'),
                                    value: state.timeValue,
                                    // TODO: why do i need the cast?
                                    onChange: (v)=>state.setTimeValue(v),
                                    placeholderValue: timePlaceholder,
                                    granularity: timeGranularity,
                                    minValue: timeMinValue,
                                    maxValue: timeMaxValue,
                                    hourCycle: props1.hourCycle,
                                    hideTimeZone: props1.hideTimeZone
                                })
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: resolvedErrorMessage
                    })
                ]
            });
        }
    });
});
function $2c3f2c4ee9806aac$export$f3ce207574a3cffe(props) {
    return (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
        ...props,
        hideArrow: true,
        padding: "none",
        children: (0, $dx4lB.jsx)("div", {
            className: " Sf182 Rf182 Th182 Qh182 _Na182 Pa182 sd182 _ta182 Ul182 ql182 _oa182 Za182 Fb182",
            children: (0, $dx4lB.jsx)((0, $8gDpA.Dialog), {
                children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
                    values: [
                        [
                            (0, $8gDpA.OverlayTriggerStateContext),
                            null
                        ]
                    ],
                    children: props.children
                })
            })
        })
    });
}
function $2c3f2c4ee9806aac$export$adb29da0ac001538(props) {
    let buttonRef = (0, $eF4cA.useRef)(null);
    let { isOpen: isOpen, size: size, setButtonHasFocus: setButtonHasFocus } = props;
    // oxlint-disable react/react-compiler
    return (0, $dx4lB.jsx)((0, $k5Pnh.Button), {
        ref: buttonRef,
        // Prevent press scale from sticking while DatePicker is open.
        // @ts-ignore
        isPressed: false,
        onFocusChange: setButtonHasFocus,
        style: (0, $i93Vd.pressScale)(buttonRef),
        className: (renderProps)=>$2c3f2c4ee9806aac$var$$1196aa313ab37be1$var$inputButton({
                ...renderProps,
                size: size,
                isOpen: isOpen
            }),
        children: (0, $dx4lB.jsx)((0, $fDYaM.Provider), {
            values: [
                [
                    (0, $dm5H1.IconContext),
                    {
                        styles: " -_8sjo0b-t5ZbAob182 Za8Mfn182 Fa8Mfn182"
                    }
                ]
            ],
            children: (0, $dx4lB.jsx)((0, $a33b5e56e66e3f74$export$2e2bcd8739ae039), {})
        })
    });
// oxlint-enable react/react-compiler
}




var $8w4Nl = parcelRequire("8w4Nl");

var $fL4LX = parcelRequire("fL4LX");



var $5t6Bv = parcelRequire("5t6Bv");

var $dx4lB = parcelRequire("dx4lB");


var $eF4cA = parcelRequire("eF4cA");

var $i0SpD = parcelRequire("i0SpD");

var $gI8Gw = parcelRequire("gI8Gw");
function $dfd3f82baeea819d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dfd3f82baeea819d$export$8282edba42ee28a = (0, $eF4cA.createContext)(null);
const $dfd3f82baeea819d$export$17334619f3ac2224 = (0, $eF4cA.forwardRef)(function DateRangePicker(props, ref) {
    [props, ref] = (0, $5t6Bv.useSpectrumContextProps)(props, ref, $dfd3f82baeea819d$export$8282edba42ee28a);
    let stringFormatter = (0, $gI8Gw.useLocalizedStringFormatter)($dfd3f82baeea819d$var$$parcel$interopDefault((0, $fL4LX.default)), '@react-spectrum/s2');
    let { label: label, contextualHelp: contextualHelp, description: descriptionMessage, errorMessage: errorMessage, isRequired: isRequired, size: size = 'M', labelPosition: labelPosition = 'top', necessityIndicator: necessityIndicator, labelAlign: labelAlign = 'start', UNSAFE_style: UNSAFE_style, UNSAFE_className: UNSAFE_className, styles: styles, placeholderValue: placeholderValue, maxVisibleMonths: maxVisibleMonths = 1, createCalendar: createCalendar, commitBehavior: commitBehavior, ...dateFieldProps } = props;
    let formContext = (0, $eF4cA.useContext)((0, $i0SpD.FormContext));
    let [buttonHasFocus, setButtonHasFocus] = (0, $eF4cA.useState)(false);
    return (0, $dx4lB.jsx)((0, $f925882e3f051847$export$17334619f3ac2224), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se182';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU182';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG182';
                }
            }
            if (props.isInForm) rules += ' DLwlgod182';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb182';
                else if (props.labelPosition === "top") rules += ' DM8Mfn182';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb182';
            else if (props.labelPosition === "top") rules += ' E4w1sLc182';
            if (props.labelPosition === "side") rules += ' CbRM95c182';
            else if (props.labelPosition === "top") rules += ' Cxaocre182';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e182';
                rules += ' vx182';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d182';
                rules += ' vx182';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b182';
                rules += ' vx182';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a182';
                rules += ' vx182';
            } else {
                rules += ' -_6BNtrc-c182';
                rules += ' vx182';
            }
            rules += ' ea182';
            rules += ' _Fd182';
            rules += ' _FnuYUweb182';
            if (props.size === "XL") rules += ' -BhX7R-Fz182';
            else if (props.size === "L") rules += ' -BhX7R-Fv182';
            else if (props.size === "S") rules += ' -BhX7R-Fp182';
            else if (props.size === "XS") rules += ' -BhX7R-Fn182';
            else rules += ' -BhX7R-Fx182';
            rules += ' -AJjOLd-UVkF0Db182';
            rules += ' qg182';
            rules += ' __ca182';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition: labelPosition,
            size: size
        }, styles),
        children: ({ isDisabled: isDisabled, isInvalid: isInvalid, isOpen: isOpen, state: state })=>{
            let placeholder = placeholderValue || undefined;
            let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : undefined;
            let timeMinValue = props.minValue && 'hour' in props.minValue ? props.minValue : undefined;
            let timeMaxValue = props.maxValue && 'hour' in props.maxValue ? props.maxValue : undefined;
            let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : undefined;
            let showTimeField = !!timeGranularity;
            // Ideally, we could omit errorMessage here and let S2 Calendar read it from RAC's CalendarContext which already contains the resolved value via calendarProps from useDatePicker.
            // However, RAC's CalendarProps omits errorMessage, so reading it back from the context would require an unsafe cast. Instead, we resolve it here using the same logic as useDatePicker.
            let resolvedErrorMessage = typeof errorMessage === 'function' ? errorMessage(state.displayValidation) : errorMessage || state.displayValidation.validationErrors.join(' ');
            return (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                children: [
                    (0, $dx4lB.jsx)((0, $8w4Nl.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    (0, $dx4lB.jsxs)((0, $8w4Nl.FieldGroup), {
                        role: "presentation",
                        shouldTurnOffFocusRing: buttonHasFocus,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr182';
                            rules += ' yXcEWr182';
                            rules += ' BXcEWr182';
                            rules += ' AXcEWr182';
                            if (props.size === "XL") rules += ' Nl182';
                            else if (props.size === "L") rules += ' Nj182';
                            else if (props.size === "S") rules += ' Nf182';
                            else if (props.size === "XS") rules += ' Ne182';
                            else rules += ' Nk182';
                            if (props.isQuiet) rules += ' _qd182';
                            else rules += ' _qtb182';
                            if (props.size === "XL") rules += ' -Anxdcc-Zt182';
                            else if (props.size === "L") rules += ' -Anxdcc-ZStdtne182';
                            else if (props.size === "S") rules += ' -Anxdcc-Zr182';
                            else rules += ' -Anxdcc-Z3fn9H182';
                            rules += ' __v6TNLWb182';
                            rules += ' __Wb182';
                            rules += ' SMBFGYc182';
                            rules += ' RfBFGYc182';
                            rules += ' -S_-Sv182';
                            rules += ' -R_-Rp182';
                            return rules;
                        }({
                            size: size
                        }),
                        children: [
                            (0, $dx4lB.jsxs)((0, $10ea02fe077a2e60$export$3f08d3c48fa697), {
                                children: [
                                    (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$7edc06cf1783b30f), {
                                        slot: "start"
                                    }),
                                    (0, $dx4lB.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: " _va182 _ua182 Sj182 Rj182",
                                        children: "\u2013"
                                    }),
                                    (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$7edc06cf1783b30f), {
                                        slot: "end"
                                    })
                                ]
                            }),
                            (0, $dx4lB.jsx)((0, $10ea02fe077a2e60$export$19696856283ab185), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            }),
                            (0, $dx4lB.jsx)("div", {
                                className: " _va182 _ub182 sd182 _Cb182",
                                children: (0, $dx4lB.jsx)((0, $2c3f2c4ee9806aac$export$adb29da0ac001538), {
                                    isOpen: isOpen,
                                    size: size,
                                    setButtonHasFocus: setButtonHasFocus
                                })
                            })
                        ]
                    }),
                    (0, $dx4lB.jsxs)((0, $2c3f2c4ee9806aac$export$f3ce207574a3cffe), {
                        shouldFlip: props.shouldFlip,
                        children: [
                            (0, $dx4lB.jsx)((0, $f1fd172007905092$export$a4f5c8b89d277a8d), {
                                visibleMonths: maxVisibleMonths,
                                createCalendar: createCalendar,
                                commitBehavior: commitBehavior,
                                errorMessage: resolvedErrorMessage
                            }),
                            showTimeField && (0, $dx4lB.jsxs)("div", {
                                className: " sd182 Ul182 ql182 _qb182 JA182",
                                children: [
                                    (0, $dx4lB.jsx)((0, $ceb1b68e63d6ccde$export$5eaee2322dd727eb), {
                                        styles: (0, $2c3f2c4ee9806aac$export$5320dd0e349ed44d),
                                        label: stringFormatter.format('datepicker.startTime'),
                                        value: state.timeRange?.start || null,
                                        onChange: (v)=>state.setTime('start', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    }),
                                    (0, $dx4lB.jsx)((0, $ceb1b68e63d6ccde$export$5eaee2322dd727eb), {
                                        styles: (0, $2c3f2c4ee9806aac$export$5320dd0e349ed44d),
                                        label: stringFormatter.format('datepicker.endTime'),
                                        value: state.timeRange?.end || null,
                                        onChange: (v)=>state.setTime('end', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $dx4lB.jsx)((0, $8w4Nl.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: resolvedErrorMessage
                    })
                ]
            });
        }
    });
});


var $aQTiM = parcelRequire("aQTiM");
var $3YPmU = parcelRequire("3YPmU");
var $8wD3p = parcelRequire("8wD3p");
var $2ffAV = parcelRequire("2ffAV");
var $33cDE = parcelRequire("33cDE");
var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");
var $8u8Xx = parcelRequire("8u8Xx");

var $1qrul = parcelRequire("1qrul");

var $eZSya = parcelRequire("eZSya");

var $iW1HQ = parcelRequire("iW1HQ");

var $9f9st = parcelRequire("9f9st");

var $klXmP = parcelRequire("klXmP");


var $15xG7 = parcelRequire("15xG7");





var $ikOQe = parcelRequire("ikOQe");

var $a8sj2 = parcelRequire("a8sj2");


var $8Ogg5 = parcelRequire("8Ogg5");

var $lb17q = parcelRequire("lb17q");
const $d9e8854f231f3155$var$ALL_STATUSES = "all";
const $d9e8854f231f3155$var$ALL_STEPS = "all";
const $d9e8854f231f3155$var$ALL_TEMPLATES = "all";
const $d9e8854f231f3155$var$NO_VALUE = "__none__";
const $d9e8854f231f3155$var$STATUS_OPTIONS = [
    {
        id: $d9e8854f231f3155$var$ALL_STATUSES,
        label: "All statuses"
    },
    {
        id: "completed",
        label: "Completed"
    },
    {
        id: "processing",
        label: "Processing"
    },
    {
        id: "draft",
        label: "Draft"
    },
    {
        id: "failed",
        label: "Failed"
    }
];
const $d9e8854f231f3155$var$STATUS_BADGE = {
    completed: {
        variant: "positive",
        label: "Completed"
    },
    processing: {
        variant: "informative",
        label: "Processing"
    },
    draft: {
        variant: "yellow",
        label: "Draft"
    },
    failed: {
        variant: "negative",
        label: "Failed"
    }
};
const $d9e8854f231f3155$var$JOB_STATUS_BADGE = {
    completed: {
        variant: "positive",
        label: "Completed"
    },
    succeeded: {
        variant: "positive",
        label: "Succeeded"
    },
    generated: {
        variant: "informative",
        label: "Generated"
    },
    running: {
        variant: "informative",
        label: "Running"
    },
    pending: {
        variant: "yellow",
        label: "Pending"
    },
    failed: {
        variant: "negative",
        label: "Failed"
    }
};
const $d9e8854f231f3155$var$columns = [
    {
        name: "Actions",
        id: "actions",
        width: 80
    },
    {
        name: "Status",
        id: "status",
        allowsSorting: true,
        width: 130
    },
    {
        name: "Template",
        id: "templateId",
        allowsSorting: true,
        width: 140
    },
    {
        name: "Current Step",
        id: "currentStep",
        allowsSorting: true,
        width: 160
    },
    {
        name: "Project",
        id: "name",
        isRowHeader: true,
        allowsSorting: true,
        minWidth: 200
    },
    {
        name: "Jobs",
        id: "jobs",
        width: 130
    },
    {
        name: "Created Date",
        id: "createdAt",
        allowsSorting: true,
        width: 180
    },
    {
        name: "Last Action",
        id: "updatedAt",
        allowsSorting: true,
        width: 140
    },
    {
        name: "Customer / Account",
        id: "customerName",
        allowsSorting: true,
        minWidth: 160
    },
    {
        name: "Created By",
        id: "createdBy",
        allowsSorting: true,
        minWidth: 180
    },
    {
        name: "Rate",
        id: "rating",
        allowsSorting: true,
        width: 100
    },
    {
        name: "Feedback Message",
        id: "feedbackMessage",
        allowsSorting: true,
        minWidth: 220
    },
    {
        name: "Comment",
        id: "comment",
        minWidth: 260
    }
];
const $d9e8854f231f3155$var$getCustomerOrAccountLabel = (video)=>{
    const parts = [
        video?.customerName,
        video?.accountName && video?.accountName !== video?.customerName ? video.accountName : null,
        video?.drNumber ? `DR: ${video.drNumber}` : null
    ].filter(Boolean);
    return parts.join(" \u2022 ");
};
const $d9e8854f231f3155$var$getProjectHref = (video)=>{
    if (!video?.id) return "/projects";
    if (video.videoPath || video.status === "completed") return `/projects/${video.id}`;
    return (0, $ikOQe.getNewVideoPath)(video.id);
};
const $d9e8854f231f3155$var$getProjectStepLabel = (video, templatesById)=>{
    const stepId = typeof video?.currentStep === "string" ? video.currentStep.trim() : "";
    if (!stepId) return "";
    const templateData = video?.templateId ? templatesById?.get(video.templateId) : undefined;
    return (0, $lb17q.getStepName)(video?.templateId, stepId, templateData) ?? (0, $lb17q.getStepName)("one-adobe", stepId) ?? (0, $lb17q.getStepName)("partnership-value", stepId) ?? stepId;
};
const $d9e8854f231f3155$var$getDefaultDateRange = ()=>{
    const end = (0, $1qrul.today)((0, $1qrul.getLocalTimeZone)());
    const start = end.subtract({
        days: 30
    });
    return {
        start: start,
        end: end
    };
};
const $d9e8854f231f3155$var$formatDuration = (ms)=>{
    if (!Number.isFinite(ms) || ms < 0) return null;
    const totalSeconds = Math.round(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const seconds = totalSeconds % 60;
    if (hours) return `${hours}h ${minutes}m`;
    if (minutes) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
};
// Older jobs predate generationTimeMs; fall back to their timestamps.
const $d9e8854f231f3155$var$getJobDurationLabel = (job)=>{
    const fallbackMs = job.createdAt && job.completedAt ? new Date(job.completedAt) - new Date(job.createdAt) : null;
    const duration = $d9e8854f231f3155$var$formatDuration(job.generationTimeMs ?? fallbackMs);
    if (!duration) return null;
    const render = $d9e8854f231f3155$var$formatDuration(job.renderTimeMs);
    return render && job.generationTimeMs != null ? `Took ${duration} (render ${render})` : `Took ${duration}`;
};
// Newest first; includes the current video if it predates history tracking.
const $d9e8854f231f3155$var$getVideoHistory = (video)=>{
    const jobs = Array.isArray(video?.jobs) ? video.jobs : [];
    const entries = Array.isArray(video?.videoHistory) ? video.videoHistory.filter((entry)=>entry?.videoPath) : [];
    if (video?.videoPath && !entries.some((entry)=>entry.videoPath === video.videoPath)) entries.push({
        videoPath: video.videoPath,
        jobId: video.jobId ?? video.modularRenderJobId ?? null
    });
    // Legacy entries have no timestamps; borrow them from the job that rendered the file.
    const enriched = entries.map((entry)=>{
        if (entry.completedAt) return entry;
        const job = jobs.find((j)=>j.videoPath && j.videoPath === entry.videoPath) ?? (entry.jobId ? jobs.find((j)=>j.jobId === entry.jobId) : undefined);
        if (!job) return entry;
        return {
            ...entry,
            jobId: entry.jobId ?? job.jobId,
            createdBy: entry.createdBy ?? job.createdBy,
            completedAt: job.completedAt,
            generationTimeMs: entry.generationTimeMs ?? job.generationTimeMs ?? (job.createdAt && job.completedAt ? new Date(job.completedAt) - new Date(job.createdAt) : undefined)
        };
    });
    const time = (entry)=>new Date(entry.completedAt ?? entry.archivedAt ?? 0).getTime() || 0;
    return enriched.sort((a, b)=>(b.videoPath === video.videoPath) - (a.videoPath === video.videoPath) || time(b) - time(a));
};
// Mirrors the backend checks in POST /admin/jobs/:jobId/{retry-upload,rerender}.
const $d9e8854f231f3155$var$UPLOAD_IN_PROGRESS_MS = 600000;
const $d9e8854f231f3155$var$isPresignedUrlExpired = (rawUrl)=>{
    try {
        const params = new URL(rawUrl).searchParams;
        const match = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/.exec(params.get("X-Amz-Date") ?? "");
        const expiresIn = Number(params.get("X-Amz-Expires"));
        if (!match || !Number.isFinite(expiresIn)) return false;
        const [, y, mo, d, h, mi, s] = match.map(Number);
        return Date.UTC(y, mo - 1, d, h, mi, s) + expiresIn * 1000 <= Date.now();
    } catch  {
        return false;
    }
};
const $d9e8854f231f3155$var$isRetryableRender = (job)=>job.type === "mogrt_render" && job.modular !== true && !!job.videoId;
const $d9e8854f231f3155$var$canRetryUpload = (job)=>{
    if (!$d9e8854f231f3155$var$isRetryableRender(job) || !job.outputUrl) return false;
    if ($d9e8854f231f3155$var$isPresignedUrlExpired(job.outputUrl)) return false;
    if (job.status === "failed") return true;
    return job.status === "generated" && Date.now() - new Date(job.updatedAt).getTime() > $d9e8854f231f3155$var$UPLOAD_IN_PROGRESS_MS;
};
const $d9e8854f231f3155$var$canRerender = (job)=>$d9e8854f231f3155$var$isRetryableRender(job) && job.status === "failed" && job.hasRawRenderRequest;
const $d9e8854f231f3155$var$getJobErrorMessage = (job)=>(Array.isArray(job.errors) ? job.errors : []).map((error)=>error?.message ?? error?.error_code).filter(Boolean).join("; ");
const $d9e8854f231f3155$var$getExpressUrl = (video)=>{
    const id = video?.templateType === "express" ? video?.expressId : video?.expressDocumentId;
    return id ? `https://new.express.adobe.com/id/${id}?category=none` : null;
};
// Mounted on demand so the per-video asset queries only run for the chosen row.
const $d9e8854f231f3155$var$AssetsDownloader = ({ videoId: videoId, onDone: onDone })=>{
    const video = (0, $ikOQe.useVideo)(videoId);
    const template = (0, $ikOQe.useVideoTemplate)(video.data?.templateId);
    const { isLoading: isAssetsLoading } = (0, $ikOQe.useVideoAssets)(videoId);
    const downloadAllAssets = (0, $ikOQe.useDownloadAllAssets)(videoId);
    const startedRef = (0, $eF4cA.useRef)(false);
    (0, $eF4cA.useEffect)(()=>{
        if (video.isError) {
            (0, $8u8Xx.ToastQueue).negative("Failed to load project assets", {
                timeout: 5000
            });
            onDone();
            return;
        }
        if (startedRef.current || !video.isSuccess || template.isLoading || isAssetsLoading) return;
        startedRef.current = true;
        downloadAllAssets.mutate(undefined, {
            onError: ()=>(0, $8u8Xx.ToastQueue).negative("Failed to download assets", {
                    timeout: 5000
                }),
            onSettled: onDone
        });
    }, [
        video.isError,
        video.isSuccess,
        template.isLoading,
        isAssetsLoading,
        downloadAllAssets,
        onDone
    ]);
    return null;
};
const $d9e8854f231f3155$export$9bd3fdad9c942af4 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Projects"
        }
    ]);
    const [statusFilter, setStatusFilter] = (0, $eF4cA.useState)($d9e8854f231f3155$var$ALL_STATUSES);
    const [stepFilter, setStepFilter] = (0, $eF4cA.useState)($d9e8854f231f3155$var$ALL_STEPS);
    const [templateFilter, setTemplateFilter] = (0, $eF4cA.useState)($d9e8854f231f3155$var$ALL_TEMPLATES);
    const [range, setRange] = (0, $eF4cA.useState)($d9e8854f231f3155$var$getDefaultDateRange);
    const [isAllTime, setIsAllTime] = (0, $eF4cA.useState)(false);
    const [search, setSearch] = (0, $eF4cA.useState)("");
    const [isDownloading, setIsDownloading] = (0, $eF4cA.useState)(false);
    const deferredSearch = (0, $eF4cA.useDeferredValue)(search);
    const [sortDescriptor, setSortDescriptor] = (0, $eF4cA.useState)({
        column: "createdAt",
        direction: "descending"
    });
    const queryFilters = (0, $eF4cA.useMemo)(()=>{
        const filters = {};
        if (statusFilter !== $d9e8854f231f3155$var$ALL_STATUSES) filters.status = statusFilter;
        if (!isAllTime && range?.start && range?.end) {
            filters.fromDate = range.start.toString();
            filters.toDate = range.end.toString();
        }
        return filters;
    }, [
        statusFilter,
        isAllTime,
        range
    ]);
    const { data: videos = [], isLoading: isLoading, isError: isError, isFetching: isFetching, error: error, refetch: refetch } = (0, $b3b2a8c2d9d2a080$export$9d31f53e121cae5)(queryFilters);
    const { data: templates = [] } = (0, $ikOQe.useVideoTemplates)();
    const templatesById = (0, $eF4cA.useMemo)(()=>new Map(templates.filter((template)=>!!template?.id).map((template)=>[
                template.id,
                template
            ])), [
        templates
    ]);
    const updateCommentMutation = (0, $b3b2a8c2d9d2a080$export$cdaa0a1daefb901d)();
    const jobCurlMutation = (0, $b3b2a8c2d9d2a080$export$c3bced76471346a3)();
    const jobRetry = (0, $b3b2a8c2d9d2a080$export$834a3f48213c79d1)();
    const handleJobRetry = (jobId, action)=>{
        jobRetry.mutate({
            jobId: jobId,
            action: action
        }, {
            onSuccess: (data)=>{
                (0, $8u8Xx.ToastQueue).positive(action === "rerender" ? `Re-render started (job ${data?.jobId ?? ""})` : "Upload retry started", {
                    timeout: 4000
                });
            },
            onError: (err)=>{
                (0, $8u8Xx.ToastQueue).negative(err?.message || "Retry failed", {
                    timeout: 6000
                });
            }
        });
    };
    const duplicateVideo = (0, $ikOQe.useDuplicateVideo)();
    const queryClient = (0, $7ClmI.useQueryClient)();
    const [downloadingAssetsVideoId, setDownloadingAssetsVideoId] = (0, $eF4cA.useState)(null);
    const clearDownloadingAssets = (0, $eF4cA.useCallback)(()=>setDownloadingAssetsVideoId(null), []);
    const handleDownloadVideo = async (item, videoPath = item.videoPath)=>{
        try {
            const { presignURL: presignURL } = await queryClient.fetchQuery((0, $a8sj2.presignURLQueryOptions)(videoPath));
            const link = document.createElement("a");
            link.href = presignURL;
            link.download = `${item.name || item.id}.mp4`;
            link.rel = "noopener";
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch  {
            (0, $8u8Xx.ToastQueue).negative("Failed to download video", {
                timeout: 5000
            });
        }
    };
    const handleDuplicate = (item)=>{
        duplicateVideo.mutate({
            id: item.id
        }, {
            onSuccess: ()=>{
                (0, $8u8Xx.ToastQueue).positive(`Duplicated "${item.name || item.id}" into your projects`, {
                    timeout: 3000
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        ...(0, $b3b2a8c2d9d2a080$export$20540e1f21686c96).all,
                        "videos"
                    ]
                });
            }
        });
    };
    const getTemplateKey = (item)=>item.templateId || item.templateType || $d9e8854f231f3155$var$NO_VALUE;
    const getStepKey = (item)=>$d9e8854f231f3155$var$getProjectStepLabel(item, templatesById) || $d9e8854f231f3155$var$NO_VALUE;
    const templateOptions = (0, $eF4cA.useMemo)(()=>{
        const keys = new Set(videos.map(getTemplateKey));
        return [
            {
                id: $d9e8854f231f3155$var$ALL_TEMPLATES,
                label: "All templates"
            },
            ...[
                ...keys
            ].map((key)=>({
                    id: key,
                    label: key === $d9e8854f231f3155$var$NO_VALUE ? "No template" : templatesById.get(key)?.name ?? key
                })).sort((a, b)=>a.label.localeCompare(b.label))
        ];
    }, [
        videos,
        templatesById
    ]);
    const stepOptions = (0, $eF4cA.useMemo)(()=>{
        const keys = new Set(videos.map(getStepKey));
        return [
            {
                id: $d9e8854f231f3155$var$ALL_STEPS,
                label: "All steps"
            },
            ...[
                ...keys
            ].map((key)=>({
                    id: key,
                    label: key === $d9e8854f231f3155$var$NO_VALUE ? "No step" : key
                })).sort((a, b)=>a.label.localeCompare(b.label))
        ];
    }, [
        videos,
        templatesById
    ]);
    const [curlByJobId, setCurlByJobId] = (0, $eF4cA.useState)({});
    const [pendingCurlJobId, setPendingCurlJobId] = (0, $eF4cA.useState)(null);
    const handleCopyJobId = async (jobId)=>{
        try {
            await navigator.clipboard.writeText(jobId);
            (0, $8u8Xx.ToastQueue).positive("Job ID copied", {
                timeout: 3000
            });
        } catch  {
            (0, $8u8Xx.ToastQueue).negative("Could not copy job ID", {
                timeout: 5000
            });
        }
    };
    const handleProduceCurl = async (jobId)=>{
        if (!jobId) return;
        setPendingCurlJobId(jobId);
        try {
            const curl = await jobCurlMutation.mutateAsync({
                jobId: jobId
            });
            setCurlByJobId((prev)=>({
                    ...prev,
                    [jobId]: curl
                }));
            try {
                await navigator.clipboard.writeText(curl);
                (0, $8u8Xx.ToastQueue).positive("cURL copied", {
                    timeout: 3000
                });
            } catch  {
                (0, $8u8Xx.ToastQueue).neutral("cURL generated", {
                    timeout: 3000
                });
            }
        } catch (err) {
            (0, $8u8Xx.ToastQueue).negative(err?.message || "Failed to generate cURL", {
                timeout: 5000
            });
        } finally{
            setPendingCurlJobId((current)=>current === jobId ? null : current);
        }
    };
    const formatter = (0, $eZSya.useDateFormatter)({
        dateStyle: "medium",
        timeStyle: "short"
    });
    const isSavingComment = (item)=>updateCommentMutation.isPending && updateCommentMutation.variables?.id === item.id;
    const submitComment = (item)=>(e)=>{
            e.preventDefault();
            const formData = new FormData(e.currentTarget);
            const nextComment = String(formData.get("comment") ?? "").trim();
            updateCommentMutation.mutate({
                id: item.id,
                comment: nextComment
            });
        };
    const rows = (0, $eF4cA.useMemo)(()=>{
        let filtered = [
            ...videos
        ];
        if (statusFilter !== $d9e8854f231f3155$var$ALL_STATUSES) filtered = filtered.filter((item)=>item.status === statusFilter);
        if (templateFilter !== $d9e8854f231f3155$var$ALL_TEMPLATES) filtered = filtered.filter((item)=>getTemplateKey(item) === templateFilter);
        if (stepFilter !== $d9e8854f231f3155$var$ALL_STEPS) filtered = filtered.filter((item)=>getStepKey(item) === stepFilter);
        const q = deferredSearch.trim().toLowerCase();
        if (q) filtered = filtered.filter((item)=>{
            const stepLabel = $d9e8854f231f3155$var$getProjectStepLabel(item, templatesById);
            const searchable = [
                item.name,
                item.id,
                item.status,
                stepLabel,
                item.currentStep,
                item.customerName,
                item.accountName,
                item.drNumber,
                item.templateId,
                item.templateType,
                item.createdBy,
                item.feedbackMessage,
                item.comment
            ].filter(Boolean).join(" ").toLowerCase();
            return searchable.includes(q);
        });
        if (sortDescriptor?.column) {
            const { column: column, direction: direction } = sortDescriptor;
            const dir = direction === "descending" ? -1 : 1;
            filtered.sort((a, b)=>{
                if (column === "createdAt" || column === "updatedAt") {
                    const timeA = a[column] ? new Date(a[column]).getTime() : 0;
                    const timeB = b[column] ? new Date(b[column]).getTime() : 0;
                    return (timeA - timeB) * dir;
                }
                if (column === "rating") {
                    const rateA = typeof a.rating === "number" ? a.rating : -1;
                    const rateB = typeof b.rating === "number" ? b.rating : -1;
                    return (rateA - rateB) * dir;
                }
                const getSortValue = (item)=>{
                    if (column === "customerName") return $d9e8854f231f3155$var$getCustomerOrAccountLabel(item);
                    if (column === "currentStep") return $d9e8854f231f3155$var$getProjectStepLabel(item, templatesById);
                    if (column === "templateId") return templatesById.get(item.templateId)?.name ?? item.templateId ?? item.templateType ?? "";
                    return item[column] ?? "";
                };
                const valA = String(getSortValue(a)).toLowerCase();
                const valB = String(getSortValue(b)).toLowerCase();
                if (!valA && valB) return 1;
                if (valA && !valB) return -1;
                return valA.localeCompare(valB) * dir;
            });
        }
        return filtered;
    }, [
        videos,
        statusFilter,
        templateFilter,
        stepFilter,
        deferredSearch,
        sortDescriptor,
        templatesById
    ]);
    const loadingState = isError ? "error" : isLoading ? "loading" : "idle";
    const handleDownloadExcel = async ()=>{
        setIsDownloading(true);
        try {
            const datePart = !isAllTime && range?.start && range?.end ? `${range.start.toString()}-${range.end.toString()}` : "all-time";
            const fileName = `projects-${statusFilter}-${datePart}.xlsx`;
            const exportRows = rows.map((item)=>({
                    ...item,
                    currentStepLabel: $d9e8854f231f3155$var$getProjectStepLabel(item, templatesById)
                }));
            await (0, $cc166234f1099697$export$b9876c2ab81af0f7)(exportRows, fileName);
        } finally{
            setIsDownloading(false);
        }
    };
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Uj182 qj182 Za182 Fb182 KbujWCd182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: "Projects | BeStory"
            }),
            downloadingAssetsVideoId && /*#__PURE__*/ (0, $dx4lB.jsx)($d9e8854f231f3155$var$AssetsDownloader, {
                videoId: downloadingAssetsVideoId,
                onDone: clearDownloadingAssets
            }, downloadingAssetsVideoId),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 eb182 Ue182 qe182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                        children: "Projects"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                        isQuiet: true,
                        "aria-label": "Refresh projects",
                        isPending: isFetching && !isLoading,
                        isDisabled: isLoading,
                        onPress: ()=>refetch(),
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 Ug182 qg182 _wb182 eb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                        "aria-label": "Filter by status",
                        items: $d9e8854f231f3155$var$STATUS_OPTIONS,
                        value: statusFilter,
                        onChange: (key)=>setStatusFilter(String(key ?? $d9e8854f231f3155$var$ALL_STATUSES)),
                        styles: " Zd4Eyud182",
                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                id: item.id,
                                textValue: item.label,
                                children: item.label
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                        "aria-label": "Filter by template",
                        items: templateOptions,
                        value: templateFilter,
                        onChange: (key)=>setTemplateFilter(String(key ?? $d9e8854f231f3155$var$ALL_TEMPLATES)),
                        styles: " Zd4Eyud182",
                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                id: item.id,
                                textValue: item.label,
                                children: item.label
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                        "aria-label": "Filter by current step",
                        items: stepOptions,
                        value: stepFilter,
                        onChange: (key)=>setStepFilter(String(key ?? $d9e8854f231f3155$var$ALL_STEPS)),
                        styles: " Zd4Eyud182",
                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                id: item.id,
                                textValue: item.label,
                                children: item.label
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dfd3f82baeea819d$export$17334619f3ac2224), {
                        "aria-label": "Filter by created date",
                        value: range,
                        onChange: (newRange)=>{
                            if (newRange) {
                                setRange(newRange);
                                setIsAllTime(false);
                            }
                        },
                        isDisabled: isAllTime,
                        maxVisibleMonths: 2,
                        styles: " ZpVWeVc182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                        isSelected: isAllTime,
                        onChange: (selected)=>{
                            setIsAllTime(selected);
                            if (!selected && (!range?.start || !range?.end)) setRange($d9e8854f231f3155$var$getDefaultDateRange());
                        },
                        children: "All time"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d93ff4dc67afc7e$export$b94867ecbd698f21), {
                        "aria-label": "Search projects",
                        placeholder: "Search project, user, customer, feedback, comment",
                        value: search,
                        onChange: setSearch,
                        onClear: ()=>setSearch(""),
                        styles: " Zy182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _dc182",
                        children: [
                            rows.length,
                            " total"
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                        variant: "secondary",
                        isDisabled: rows.length === 0 || isDownloading || isLoading,
                        onPress: handleDownloadExcel,
                        styles: " IM182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: isDownloading ? "Preparing\u2026" : "Download"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b3c27e869d856b7), {
                "aria-label": "All projects",
                loadingState: loadingState,
                sortDescriptor: sortDescriptor,
                onSortChange: setSortDescriptor,
                renderEmptyState: ()=>isError ? error?.message ?? "Failed to load projects" : "No projects found",
                overflowMode: "wrap",
                density: "spacious",
                styles: " Ka182 Fb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f850895b287ef28e), {
                        columns: $d9e8854f231f3155$var$columns,
                        children: (column)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$816b5d811295e6bc), {
                                isRowHeader: column.isRowHeader,
                                allowsSorting: column.allowsSorting,
                                width: column.width,
                                minWidth: column.minWidth,
                                align: column.align,
                                children: column.name
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$76ccd210b9029917), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                            items: rows,
                            dependencies: [
                                templatesById,
                                updateCommentMutation.isPending,
                                updateCommentMutation.variables,
                                duplicateVideo.isPending,
                                duplicateVideo.variables,
                                downloadingAssetsVideoId,
                                pendingCurlJobId,
                                jobRetry.isPending,
                                jobRetry.variables,
                                curlByJobId
                            ],
                            children: (item)=>{
                                const badge = $d9e8854f231f3155$var$STATUS_BADGE[item.status] ?? $d9e8854f231f3155$var$STATUS_BADGE.draft;
                                const stepLabel = $d9e8854f231f3155$var$getProjectStepLabel(item, templatesById) || "\u2014";
                                const createdDate = item.createdAt ? new Date(item.createdAt) : null;
                                const formattedDate = createdDate && !Number.isNaN(createdDate.getTime()) ? formatter.format(createdDate) : "\u2014";
                                const lastAction = item.updatedAt ? (0, $8Ogg5.getRelativeTime)(item.updatedAt) || "\u2014" : "\u2014";
                                const customerLabel = $d9e8854f231f3155$var$getCustomerOrAccountLabel(item) || "\u2014";
                                const jobs = Array.isArray(item.jobs) ? item.jobs : [];
                                const history = $d9e8854f231f3155$var$getVideoHistory(item);
                                return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b59bdbef9ce70de2), {
                                    id: item.id,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $gc2oq.ActionMenu), {
                                                isQuiet: true,
                                                size: "S",
                                                "aria-label": `Actions for ${item.name || item.id}`,
                                                disabledKeys: [
                                                    ...duplicateVideo.isPending && duplicateVideo.variables?.id === item.id ? [
                                                        "duplicate"
                                                    ] : [],
                                                    ...$d9e8854f231f3155$var$getExpressUrl(item) ? [] : [
                                                        "express"
                                                    ],
                                                    ...downloadingAssetsVideoId ? [
                                                        "assets"
                                                    ] : [],
                                                    ...item.videoPath ? [] : [
                                                        "video"
                                                    ]
                                                ],
                                                onAction: (key)=>{
                                                    if (key === "duplicate") handleDuplicate(item);
                                                    if (key === "express") window.open($d9e8854f231f3155$var$getExpressUrl(item), "_blank", "noopener,noreferrer");
                                                    if (key === "assets") setDownloadingAssetsVideoId(item.id);
                                                    if (key === "video") handleDownloadVideo(item);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                        id: "express",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $14ea9638054ff44c$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Open in Express"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                        id: "assets",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: downloadingAssetsVideoId === item.id ? "Preparing assets\u2026" : "Download assets"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                        id: "video",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: "Download video"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $8wD3p.MenuItem), {
                                                        id: "duplicate",
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $bb3571c0241a6f98$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: duplicateVideo.isPending && duplicateVideo.variables?.id === item.id ? "Duplicating\u2026" : "Duplicate"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                size: "S",
                                                variant: badge.variant,
                                                children: badge.label
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: templatesById.get(item.templateId)?.name || item.templateId || item.templateType || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: stepLabel
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3YPmU.Link), {
                                                href: $d9e8854f231f3155$var$getProjectHref(item),
                                                isQuiet: true,
                                                children: item.name || item.id
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: jobs.length === 0 && history.length === 0 ? "\u2014" : /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                        size: "S",
                                                        isQuiet: true,
                                                        "aria-label": `Show jobs and video history for ${item.name || item.id}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $iW1HQ.default), {}),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                children: jobs.length > 0 ? `Jobs (${jobs.length})` : `Videos (${history.length})`
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                                                        placement: "bottom start",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                            className: " sd182 _ta182 Ue182 qe182 ZILqIYb182 KILqIYb182 Pa182",
                                                            children: [
                                                                history.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                                            className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                                                            children: [
                                                                                "Video history (",
                                                                                history.length,
                                                                                ")"
                                                                            ]
                                                                        }),
                                                                        history.map((entry)=>{
                                                                            const isCurrent = entry.videoPath === item.videoPath;
                                                                            const date = entry.completedAt ?? entry.archivedAt;
                                                                            return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                                className: " sd182 eb182 _Ce182 Ue182 qe182 Tt182 Qt182 St182 Rt182 ob182 nb182 kb182 jb182 gqlRAZb182",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                                        className: " sd182 _ta182 Ub182 qb182 Na182",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                                                                                children: [
                                                                                                    date ? formatter.format(new Date(date)) : "Before history tracking",
                                                                                                    entry.generationTimeMs != null && ` \xb7 took ${$d9e8854f231f3155$var$formatDuration(entry.generationTimeMs)}`
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                                                                title: entry.videoPath,
                                                                                                className: " uj182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182 -nTSCV-cB9Fab182",
                                                                                                children: [
                                                                                                    entry.jobId ? `job ${entry.jobId}` : entry.videoPath,
                                                                                                    entry.createdBy && ` \xb7 ${entry.createdBy}`
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                                        className: " sh182 eb182 Ue182 qe182 _va182",
                                                                                        children: [
                                                                                            isCurrent && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                                                                size: "S",
                                                                                                variant: "positive",
                                                                                                children: "Current"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                                                size: "XS",
                                                                                                "aria-label": `Download video ${entry.videoPath}`,
                                                                                                onPress: ()=>handleDownloadVideo(item, entry.videoPath),
                                                                                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $klXmP.default), {})
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }, entry.videoPath);
                                                                        })
                                                                    ]
                                                                }),
                                                                jobs.length > 0 && /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                                    className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                                                    children: [
                                                                        "Jobs (",
                                                                        jobs.length,
                                                                        ")"
                                                                    ]
                                                                }),
                                                                jobs.map((job)=>{
                                                                    const jobBadge = $d9e8854f231f3155$var$JOB_STATUS_BADGE[job.status] ?? {
                                                                        variant: "neutral",
                                                                        label: job.status || "Unknown"
                                                                    };
                                                                    const isGeneratingJobCurl = pendingCurlJobId === job.jobId;
                                                                    const generatedCurl = curlByJobId[job.jobId];
                                                                    const isRetryingJob = jobRetry.isPending && jobRetry.variables?.jobId === job.jobId;
                                                                    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                        className: " sd182 _ta182 Ub182 qb182 Tt182 Qt182 St182 Rt182 ob182 nb182 kb182 jb182 gqlRAZb182 Za182 _oa182",
                                                                        children: [
                                                                            job.moduleName && /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                                                                children: job.moduleName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                                className: " sd182 eb182 Ub182 qb182",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                                                        className: " uj182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182 _4a182 -nTSCV-cB9Fab182",
                                                                                        children: job.jobId
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                                                        size: "XS",
                                                                                        isQuiet: true,
                                                                                        "aria-label": `Copy job ID ${job.jobId}`,
                                                                                        onPress: ()=>handleCopyJobId(job.jobId),
                                                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {})
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182",
                                                                                children: [
                                                                                    job.createdAt ? `Created ${formatter.format(new Date(job.createdAt))}` : null,
                                                                                    $d9e8854f231f3155$var$getJobDurationLabel(job)
                                                                                ].filter(Boolean).join(" \xb7 ")
                                                                            }),
                                                                            job.retryOf && /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182 -nTSCV-cB9Fab182",
                                                                                children: [
                                                                                    "Retry of ",
                                                                                    job.retryOf
                                                                                ]
                                                                            }),
                                                                            job.status === "failed" && $d9e8854f231f3155$var$getJobErrorMessage(job) && /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pq182 -nTSCV-cB9Fab182",
                                                                                children: $d9e8854f231f3155$var$getJobErrorMessage(job)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                                                className: " sd182 eb182 _Cb182 Ue182 qe182",
                                                                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                                                    className: " sh182 eb182 Ue182 qe182",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                                                            size: "S",
                                                                                            variant: jobBadge.variant,
                                                                                            children: jobBadge.label
                                                                                        }),
                                                                                        $d9e8854f231f3155$var$canRetryUpload(job) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                                                            size: "XS",
                                                                                            "aria-label": `Retry upload for job ${job.jobId}`,
                                                                                            isDisabled: isRetryingJob,
                                                                                            onPress: ()=>handleJobRetry(job.jobId, "retry-upload"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {}),
                                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                                    children: "Retry upload"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        $d9e8854f231f3155$var$canRerender(job) && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                                                            size: "XS",
                                                                                            "aria-label": `Re-render job ${job.jobId}`,
                                                                                            isDisabled: isRetryingJob,
                                                                                            onPress: ()=>handleJobRetry(job.jobId, "rerender"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {}),
                                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                                    children: "Re-render"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        job.hasRawRenderRequest && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                                                                            size: "XS",
                                                                                            "aria-label": `Produce cURL for job ${job.jobId}`,
                                                                                            isDisabled: isGeneratingJobCurl,
                                                                                            onPress: ()=>handleProduceCurl(job.jobId),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9f9st.default), {}),
                                                                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                                                    children: isGeneratingJobCurl ? "Generating\u2026" : "cURL"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            generatedCurl && /*#__PURE__*/ (0, $dx4lB.jsx)("code", {
                                                                                className: " uj182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 -nTSCV-cB9Fab182 K5Hidqd182 Pa182 sb182",
                                                                                children: generatedCurl
                                                                            })
                                                                        ]
                                                                    }, job.jobId);
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: formattedDate
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: lastAction
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: customerLabel
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: item.createdBy || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: typeof item.rating === "number" ? /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                className: " sh182 eb182 Ub182 qb182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1a77093d8eb50e23$export$2e2bcd8739ae039), {
                                                        styles: " Zk182 Fl182"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsxs)("span", {
                                                        children: [
                                                            item.rating,
                                                            "/5"
                                                        ]
                                                    })
                                                ]
                                            }) : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)("span", {
                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182",
                                                children: item.feedbackMessage || "\u2014"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$d27c35c47f085992), {
                                            isSaving: isSavingComment(item),
                                            onSubmit: submitComment(item),
                                            renderEditing: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                                    autoFocus: true,
                                                    "aria-label": "Comment",
                                                    name: "comment",
                                                    defaultValue: item.comment ?? "",
                                                    styles: " Za182 N46M4le182"
                                                }),
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 eb182 Ue182 qe182 _Ce182 Za182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 Jy182 Gy182 Iy182 Hy182 _7f182",
                                                        children: item.comment || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                        slot: "edit",
                                                        "aria-label": `Edit comment for ${item.name || item.id}`,
                                                        size: "S",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $208Op = parcelRequire("208Op");
var $c0XRK = parcelRequire("c0XRK");
var $fZShI = parcelRequire("fZShI");



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $11d466c244606276$var$$065eddfee5f293c7$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 9.25h-5.5v-5.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v5.5h-5.5c-.414 0-.75.336-.75.75s.336.75.75.75h5.5v5.5c0 .414.336.75.75.75s.75-.336.75-.75v-5.5h5.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const $11d466c244606276$var$$065eddfee5f293c7$var$ForwardRef = (0, $eF4cA.forwardRef)($11d466c244606276$var$$065eddfee5f293c7$var$SvgComponent);
var $11d466c244606276$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($11d466c244606276$var$$065eddfee5f293c7$var$ForwardRef);



var $k6waQ = parcelRequire("k6waQ");

var $8Ogg5 = parcelRequire("8Ogg5");

var $fHV62 = parcelRequire("fHV62");
const $5017d95d00562306$export$e79d6dbc05c72a58 = (0, $fHV62.createApiClient)((0, $8Ogg5.actions)["exd-storyteller-ai/fluffyjaws"]);
const $5017d95d00562306$export$559bd27b98ea2ba6 = async (body, options = {})=>{
    const response = await $5017d95d00562306$export$e79d6dbc05c72a58.post("/ask", {
        query: body.query,
        ...body.sessionId ? {
            sessionId: body.sessionId
        } : {},
        ...body.autoInitialize !== undefined ? {
            autoInitialize: body.autoInitialize
        } : {},
        ...body.fluffyPackUuid ? {
            fluffyPackUuid: body.fluffyPackUuid
        } : {}
    }, options);
    if (!response.ok) throw new Error("Failed to ask FluffyJaws", {
        cause: response
    });
    return response.data;
};


const $98f0372548f86699$export$8179b00644e9564d = (options = {})=>{
    return (0, $k6waQ.useMutation)({
        mutationFn: ({ query: query, sessionId: sessionId, autoInitialize: autoInitialize, fluffyPackUuid: fluffyPackUuid }, { signal: signal })=>(0, $5017d95d00562306$export$559bd27b98ea2ba6)({
                query: query,
                sessionId: sessionId,
                autoInitialize: autoInitialize,
                fluffyPackUuid: fluffyPackUuid
            }, {
                signal: signal
            }),
        ...options
    });
};


const $9d3717861dbccb56$var$buildContextualQuery = (history, newQuestion)=>{
    if (!history.length) return newQuestion;
    const transcript = history.map((m)=>`${m.role === "user" ? "User" : "Assistant"}: ${m.text}`).join("\n");
    return `Continue this conversation. Use the prior turns as context and answer the final question.\n\n${transcript}\n\nUser: ${newQuestion}`;
};
const $9d3717861dbccb56$export$8f6dd57b7b2b1b34 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "FluffyJaws"
        }
    ]);
    const [query, setQuery] = (0, $eF4cA.useState)("");
    const [messages, setMessages] = (0, $eF4cA.useState)([]);
    const [sessionId, setSessionId] = (0, $eF4cA.useState)(null);
    const ask = (0, $98f0372548f86699$export$8179b00644e9564d)();
    const scrollRef = (0, $eF4cA.useRef)(null);
    (0, $eF4cA.useEffect)(()=>{
        if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, [
        messages,
        ask.isPending
    ]);
    const handleSubmit = (value)=>{
        const trimmed = (value ?? query).trim();
        if (!trimmed || ask.isPending) return;
        const contextualQuery = $9d3717861dbccb56$var$buildContextualQuery(messages, trimmed);
        setMessages((prev)=>[
                ...prev,
                {
                    role: "user",
                    text: trimmed
                }
            ]);
        setQuery("");
        ask.mutate({
            query: contextualQuery,
            sessionId: sessionId || undefined,
            autoInitialize: !sessionId
        }, {
            onSuccess: (data)=>{
                if (data?.sessionId) setSessionId(data.sessionId);
                setMessages((prev)=>[
                        ...prev,
                        {
                            role: "assistant",
                            text: data?.text || "No text content returned."
                        }
                    ]);
            }
        });
    };
    const handleReset = ()=>{
        setSessionId(null);
        setMessages([]);
        setQuery("");
        ask.reset();
    };
    const hasConversation = messages.length > 0;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: "FluffyJaws | BeStory"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 Uj182 qj182 Za182 LhaAsze182 FKPwxte182 IM182 HM182 Sh182 Rh182 _oa182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 eb182 Ug182 qg182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                                children: "FluffyJaws"
                            }),
                            hasConversation && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                isQuiet: true,
                                onPress: handleReset,
                                styles: " IM182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $11d466c244606276$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "New conversation"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        ref: scrollRef,
                        className: " _ub182 Pa182 Ma182 sd182 _ta182 Ug182 qg182",
                        children: [
                            !hasConversation && !ask.isPending && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " sd182 eb182 _Ca182 Za182 Fb182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                                    orientation: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $90d7955cd72decdd$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                            children: "Ask FluffyJaws"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                            children: "Type a question below and press Enter. Follow-up questions stay in the same conversation."
                                        })
                                    ]
                                })
                            }),
                            messages.map((message, index)=>{
                                const isUser = message.role === "user";
                                return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' sd182';
                                        rules += ' _ta182';
                                        rules += ' Ub182';
                                        rules += ' qb182';
                                        rules += ' ZJ182';
                                        rules += ' LpGOfn182';
                                        rules += ' _oa182';
                                        rules += ' g_g182';
                                        rules += ' _nLeasBb182';
                                        rules += ' oe182';
                                        rules += ' ne182';
                                        rules += ' ke182';
                                        rules += ' je182';
                                        rules += ' Sf182';
                                        rules += ' Rf182';
                                        rules += ' Te182';
                                        rules += ' Qe182';
                                        if (props.isUser) rules += ' _dd182';
                                        else rules += ' _de182';
                                        return rules;
                                    }({
                                        isUser: isUser
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                            styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                            children: isUser ? "You" : "FluffyJaws"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $74d890f6f2a4f834$export$61f100e67ffb6850), {
                                            language: "markdown",
                                            code: message.text
                                        })
                                    ]
                                }, index);
                            }),
                            ask.isPending && /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 eb182 Ue182 qe182 _de182 Sf182 Rf182 Te182 Qe182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                                        "aria-label": "Asking FluffyJaws",
                                        size: "S",
                                        isIndeterminate: true
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182",
                                        children: "Thinking..."
                                    })
                                ]
                            }),
                            ask.isError && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $3ed97031b6108146$export$a3b2c96db9b0eb71), {
                                variant: "negative",
                                styles: " Za182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                                        children: "Failed to ask FluffyJaws"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                                        children: ask.error?.message || "Something went wrong."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 Ug182 qg182 ec182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d93ff4dc67afc7e$export$b94867ecbd698f21), {
                                "aria-label": "Ask FluffyJaws",
                                placeholder: sessionId ? "Ask a follow-up..." : "Ask FluffyJaws a question...",
                                value: query,
                                onChange: setQuery,
                                onSubmit: handleSubmit,
                                isDisabled: ask.isPending,
                                styles: " _ub182"
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                variant: "accent",
                                isDisabled: ask.isPending || !query.trim(),
                                onPress: ()=>handleSubmit(),
                                children: "Ask"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $34HUQ = parcelRequire("34HUQ");
var $lK44Y = parcelRequire("lK44Y");
var $3g2oV = parcelRequire("3g2oV");
var $aVEhH = parcelRequire("aVEhH");
var $aQTiM = parcelRequire("aQTiM");
var $yuTTo = parcelRequire("yuTTo");
var $2ffAV = parcelRequire("2ffAV");
var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");

var $i8elj = parcelRequire("i8elj");

var $15xG7 = parcelRequire("15xG7");

var $jBZxV = parcelRequire("jBZxV");

const $c4ef23ecc47e93fb$var$PAGE_SIZE = 20;
const $c4ef23ecc47e93fb$var$SEARCH_DEBOUNCE_MS = 300;
const $c4ef23ecc47e93fb$var$ALL_INDUSTRIES = "__all__";
const $c4ef23ecc47e93fb$var$columns = [
    {
        name: "Preview",
        id: "preview",
        isRowHeader: true,
        minWidth: 320
    },
    {
        name: "Description",
        id: "description"
    },
    {
        name: "Details",
        id: "details",
        minWidth: 360
    }
];
const $c4ef23ecc47e93fb$var$EditableListFields = ({ "aria-label": ariaLabel, value: value, onChange: onChange })=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Ue182 qe182",
        children: [
            value.map((item, index)=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                    className: " sd182 Ub182 qb182 eb182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                            autoFocus: index === 0,
                            "aria-label": `${ariaLabel} ${index + 1}`,
                            value: item,
                            onChange: (newValue)=>onChange(value.map((v, i)=>i === index ? newValue : v))
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                            "aria-label": `Remove ${ariaLabel} ${index + 1}`,
                            isQuiet: true,
                            onPress: ()=>onChange(value.filter((_, i)=>i !== index)),
                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $i8elj.default), {})
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                variant: "secondary",
                onPress: ()=>onChange([
                        ...value,
                        ""
                    ]),
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                    children: [
                        "Add ",
                        ariaLabel.toLowerCase()
                    ]
                })
            })
        ]
    });
const $c4ef23ecc47e93fb$var$EditableIndustryValue = ({ item: item, options: options, isSaving: isSaving, onSave: onSave })=>{
    const [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
        label: "Industry",
        // size="S"
        contextualHelp: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
            isOpen: isOpen,
            onOpenChange: setIsOpen,
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                    isQuiet: true,
                    isPending: isSaving,
                    "aria-label": "Edit industry",
                    size: "XS",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                    size: "S",
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)("form", {
                        className: " sd182 _ta182 Ue182 qe182 Te182 Qe182 Se182 Re182 Ng182",
                        onSubmit: (e)=>{
                            e.preventDefault();
                            const formData = new FormData(e.currentTarget);
                            const value = formData.get("industry")?.trim();
                            setIsOpen(false);
                            if (value) onSave(value);
                        },
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBox), {
                                autoFocus: true,
                                label: "Industry",
                                name: "industry",
                                items: options,
                                defaultInputValue: item.industry,
                                allowsCustomValue: true,
                                menuTrigger: "focus",
                                children: (option)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $aVEhH.ComboBoxItem), {
                                        id: option.id,
                                        textValue: option.label,
                                        children: option.label
                                    })
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                    variant: "accent",
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Save"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        }),
        value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
            children: item.industry || "\u2014"
        })
    });
};
const $c4ef23ecc47e93fb$var$EditableListValue = ({ label: label, values: values, isSaving: isSaving, onSave: onSave })=>{
    const [isOpen, setIsOpen] = (0, $eF4cA.useState)(false);
    const [draft, setDraft] = (0, $eF4cA.useState)(values);
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
        label: label,
        // size="S"
        contextualHelp: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $aQTiM.DialogTrigger), {
            isOpen: isOpen,
            onOpenChange: (open)=>{
                setIsOpen(open);
                if (open) setDraft(values);
            },
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                    isQuiet: true,
                    isPending: isSaving,
                    "aria-label": `Edit ${label.toLowerCase()}`,
                    size: "XS",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2ffAV.Popover), {
                    size: "S",
                    children: /*#__PURE__*/ (0, $dx4lB.jsxs)("form", {
                        className: " sd182 _ta182 Ue182 qe182 Te182 Qe182 Se182 Re182 NoffTu182",
                        onSubmit: (e)=>{
                            e.preventDefault();
                            setIsOpen(false);
                            onSave(draft.map((v)=>v.trim()).filter(Boolean));
                        },
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)($c4ef23ecc47e93fb$var$EditableListFields, {
                                "aria-label": label,
                                value: draft,
                                onChange: setDraft
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                                    variant: "accent",
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                        children: "Save"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        }),
        value: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: " sd182 Ub182 qb182 _wb182",
            children: values.length ? values.map((value)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                    fillStyle: "outline",
                    children: value
                }, value)) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                children: "\u2014"
            })
        })
    });
};
const $c4ef23ecc47e93fb$export$8f89b0858164f318 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Footage"
        }
    ]);
    const [search, setSearch] = (0, $eF4cA.useState)("");
    const [industry, setIndustry] = (0, $eF4cA.useState)("");
    const [debouncedFilters, setDebouncedFilters] = (0, $eF4cA.useState)({
        q: "",
        industry: ""
    });
    (0, $eF4cA.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setDebouncedFilters({
                q: search,
                industry: industry
            });
        }, $c4ef23ecc47e93fb$var$SEARCH_DEBOUNCE_MS);
        return ()=>clearTimeout(timeout);
    }, [
        search,
        industry
    ]);
    const filters = (0, $eF4cA.useMemo)(()=>({
            ...debouncedFilters.q && {
                q: debouncedFilters.q
            },
            ...debouncedFilters.industry && {
                industry: debouncedFilters.industry
            },
            pageSize: $c4ef23ecc47e93fb$var$PAGE_SIZE
        }), [
        debouncedFilters
    ]);
    const { data: industries = [] } = (0, $c888393e6da529dc$export$942ee8a59110d867)();
    const industryItems = (0, $eF4cA.useMemo)(()=>[
            {
                id: $c4ef23ecc47e93fb$var$ALL_INDUSTRIES,
                label: "All industries"
            },
            ...industries.map((name)=>({
                    id: name,
                    label: name
                }))
        ], [
        industries
    ]);
    const industryOptions = (0, $eF4cA.useMemo)(()=>industries.map((name)=>({
                id: name,
                label: name
            })), [
        industries
    ]);
    const updateFootageMutation = (0, $c888393e6da529dc$export$c2f75e3e02fed40e)();
    const isSavingField = (item, field)=>updateFootageMutation.isPending && updateFootageMutation.variables?.id === item._id && field in updateFootageMutation.variables;
    const submitField = (item, field)=>(e)=>{
            e.preventDefault();
            const formData = new FormData(e.currentTarget);
            updateFootageMutation.mutate({
                id: item._id,
                [field]: formData.get(field)
            });
        };
    const { data: data, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isFetchingNextPage: isFetchingNextPage, isError: isError, error: error } = (0, $c888393e6da529dc$export$86e3bf3696276128)(filters);
    const rows = data?.pages?.flatMap((page)=>page.footage) ?? [];
    const total = data?.pages?.at(-1)?.pagination?.total ?? 0;
    const loadingState = isError ? "error" : isLoading ? "loading" : isFetchingNextPage ? "loadingMore" : "idle";
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Uj182 qj182 Za182 Fb182 KbujWCd182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: "Footage | BeStory"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                children: "Footage"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 Ug182 qg182 _wb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d93ff4dc67afc7e$export$b94867ecbd698f21), {
                        "aria-label": "Search footage",
                        placeholder: "Search description, key elements, attributes",
                        value: search,
                        onChange: setSearch,
                        onClear: ()=>setSearch(""),
                        styles: " Zy182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                        "aria-label": "Filter by industry",
                        items: industryItems,
                        value: industry || $c4ef23ecc47e93fb$var$ALL_INDUSTRIES,
                        onChange: (key)=>setIndustry(key === $c4ef23ecc47e93fb$var$ALL_INDUSTRIES ? "" : key),
                        styles: " ZftVFw182",
                        children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                id: item.id,
                                textValue: item.label,
                                children: item.label
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _dc182",
                        children: [
                            total,
                            " total"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b3c27e869d856b7), {
                "aria-label": "Footage",
                loadingState: loadingState,
                onLoadMore: ()=>{
                    if (hasNextPage && !isFetchingNextPage) fetchNextPage();
                },
                renderEmptyState: ()=>isError ? error?.message ?? "Failed to load footage" : "No footage found",
                overflowMode: "wrap",
                density: "spacious",
                styles: " Ka182 Fb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f850895b287ef28e), {
                        columns: $c4ef23ecc47e93fb$var$columns,
                        children: (column)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$816b5d811295e6bc), {
                                isRowHeader: column.isRowHeader,
                                width: column.width,
                                minWidth: column.minWidth,
                                children: column.name
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$76ccd210b9029917), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                            items: rows,
                            children: (item)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b59bdbef9ce70de2), {
                                    id: item.fileName,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $jBZxV.S3Video), {
                                                filePath: item.fileName,
                                                autoPlay: false,
                                                controls: true,
                                                loading: "lazy",
                                                muted: true,
                                                loop: true,
                                                preload: "metadata",
                                                className: " sb182 Za182 fcJcitc182 ob182 nb182 kb182 jb182 _Hb182"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$d27c35c47f085992), {
                                            isSaving: isSavingField(item, "description"),
                                            onSubmit: submitField(item, "description"),
                                            renderEditing: ()=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                                    autoFocus: true,
                                                    "aria-label": "Description",
                                                    name: "description",
                                                    defaultValue: item.description,
                                                    styles: " Za182 Nb4QY4182"
                                                }),
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 eb182 Ue182 qe182 _Ce182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                                                        children: item.description
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                                        slot: "edit",
                                                        "aria-label": "Edit description",
                                                        size: "S",
                                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $15xG7.default), {})
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                                className: " sd182 _ta182 Ug182 qg182 Tt182 Qt182",
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)($c4ef23ecc47e93fb$var$EditableIndustryValue, {
                                                        item: item,
                                                        options: industryOptions,
                                                        isSaving: isSavingField(item, "industry"),
                                                        onSave: (value)=>updateFootageMutation.mutate({
                                                                id: item._id,
                                                                industry: value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)($c4ef23ecc47e93fb$var$EditableListValue, {
                                                        label: "Key elements",
                                                        values: item.keyElements ?? [],
                                                        isSaving: isSavingField(item, "keyElements"),
                                                        onSave: (value)=>updateFootageMutation.mutate({
                                                                id: item._id,
                                                                keyElements: value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)($c4ef23ecc47e93fb$var$EditableListValue, {
                                                        label: "Attributes",
                                                        values: item.attributes ?? [],
                                                        isSaving: isSavingField(item, "attributes"),
                                                        onSave: (value)=>updateFootageMutation.mutate({
                                                                id: item._id,
                                                                attributes: value
                                                            })
                                                    }),
                                                    !!item.productContext && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $yuTTo.LabeledValue), {
                                                        label: "Product context",
                                                        value: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                            styles: " uj182 -_6BNtrc-b182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182",
                                                            children: JSON.stringify(item.productContext, null, 2)
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                        })
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $geNzB = parcelRequire("geNzB");
var $3g2oV = parcelRequire("3g2oV");
var $33cDE = parcelRequire("33cDE");
var $208Op = parcelRequire("208Op");

var $eZSya = parcelRequire("eZSya");


const $49c9b312c3fd29bf$var$columns = [
    {
        name: "Integration",
        id: "name",
        isRowHeader: true
    },
    {
        name: "Status",
        id: "status",
        width: 160
    },
    {
        name: "Latency\xa0\xa0",
        id: "latencyMs",
        align: "end",
        width: 120
    },
    {
        name: "Detail",
        id: "message"
    }
];
// Maps a probe status to a Spectrum Badge variant + human label.
const $49c9b312c3fd29bf$var$STATUS_BADGE = {
    operational: {
        variant: "positive",
        label: "Operational"
    },
    degraded: {
        variant: "notice",
        label: "Degraded"
    },
    down: {
        variant: "negative",
        label: "Down"
    },
    not_configured: {
        variant: "neutral",
        label: "Not configured"
    }
};
const $49c9b312c3fd29bf$export$81a8d757b4fb2689 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "API Status"
        }
    ]);
    const [complexMode, setComplexMode] = (0, $eF4cA.useState)(false);
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $b3b2a8c2d9d2a080$export$87a82d4f2e1ff95a)(complexMode);
    const refresh = (0, $b3b2a8c2d9d2a080$export$c6c5aa14c771926e)(complexMode);
    const isRefreshing = refresh.isPending;
    const formatter = (0, $eZSya.useDateFormatter)({
        dateStyle: "medium",
        timeStyle: "medium"
    });
    const rows = data?.integrations ?? [];
    const loadingState = isError || refresh.isError ? "error" : isLoading || isRefreshing ? "loading" : "idle";
    const checkedAt = data?.checkedAt ? new Date(data.checkedAt) : null;
    return /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
        className: " sd182 _ta182 Uj182 qj182 Za182 Fb182 KbujWCd182",
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: "API status | BeStory"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                isSelected: complexMode,
                onChange: setComplexMode,
                children: "Complex mode"
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 Ug182 qg182 eb182 _wb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-g182 vx182 xe182 _xa182 xX0cczbd182 _xX0cczba182 xfe182 _xfa182 xfX0cczbd182 _xfX0cczba182 _Fd182 _FnuYUweb182 po182",
                        children: "API Status"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                        isQuiet: true,
                        size: "S",
                        staticColor: "auto",
                        "aria-label": "Refresh integration status",
                        isDisabled: isRefreshing,
                        onPress: ()=>refresh.mutate(),
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $aa39d55291e68d80$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                children: isRefreshing ? "Checking\u2026" : "Refresh"
                            })
                        ]
                    }),
                    checkedAt ? /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                        children: [
                            "Last checked ",
                            formatter.format(checkedAt)
                        ]
                    }) : !isLoading && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182",
                        children: "Never checked \u2014 press Refresh to run the test"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b3c27e869d856b7), {
                "aria-label": "External API status",
                loadingState: loadingState,
                renderEmptyState: ()=>isError ? error?.message ?? "Failed to load integration status" : "No integrations found",
                overflowMode: "wrap",
                density: "spacious",
                styles: " Ka182 Fb182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f850895b287ef28e), {
                        columns: $49c9b312c3fd29bf$var$columns,
                        children: (column)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$816b5d811295e6bc), {
                                align: column.align,
                                isRowHeader: column.isRowHeader,
                                width: column.width,
                                minWidth: column.minWidth,
                                children: column.name
                            })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$76ccd210b9029917), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $3g2oV.Collection), {
                            items: rows,
                            children: (integration)=>{
                                const badge = $49c9b312c3fd29bf$var$STATUS_BADGE[integration.status] ?? $49c9b312c3fd29bf$var$STATUS_BADGE.down;
                                return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0a7fba920f0e9b9f$export$b59bdbef9ce70de2), {
                                    id: integration.id,
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: integration.name
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $geNzB.Badge), {
                                                size: "S",
                                                variant: badge.variant,
                                                children: badge.label
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            align: "end",
                                            children: integration.status === "not_configured" ? "\u2014" : `${integration.latencyMs} ms`
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a7fba920f0e9b9f$export$f6f0c3fe4ec306ea), {
                                            children: integration.message
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");

var $5IZkx = parcelRequire("5IZkx");


var $4W5AG = parcelRequire("4W5AG");
var $34HUQ = parcelRequire("34HUQ");
var $33cDE = parcelRequire("33cDE");
var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");
var $8u8Xx = parcelRequire("8u8Xx");

var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $d98385a72966f675$var$$99a4f3a7b9cda72c$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M18.649 9.974c0-.295-.172-.563-.443-.683L4.058 2.933c-.257-.115-.557-.077-.776.098-.22.177-.323.46-.267.736l1.272 6.241-1.222 6.23c-.049.247.03.5.205.675q.031.03.065.058c.221.174.52.211.776.095l14.098-6.408c.268-.122.44-.39.44-.684m-4.243-.747-8.742.027L4.777 4.9zm-9.589 5.87.852-4.344 8.763-.027z"
        })
    });
const $d98385a72966f675$var$$99a4f3a7b9cda72c$var$ForwardRef = (0, $eF4cA.forwardRef)($d98385a72966f675$var$$99a4f3a7b9cda72c$var$SvgComponent);
var $d98385a72966f675$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($d98385a72966f675$var$$99a4f3a7b9cda72c$var$ForwardRef);



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $ed6a757eee09667b$var$$7cd619eef1b10f40$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M5.5 14.5c-.192 0-.384-.073-.53-.22l-3.75-3.75c-.293-.293-.293-.767 0-1.06l3.75-3.75c.293-.293.767-.293 1.06 0s.293.767 0 1.06L2.81 10l3.22 3.22c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22M14.5 14.5c-.192 0-.384-.073-.53-.22-.293-.293-.293-.767 0-1.06L17.19 10l-3.22-3.22c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0l3.75 3.75c.293.293.293.767 0 1.06l-3.75 3.75c-.146.147-.338.22-.53.22M8.229 18q-.09 0-.177-.02c-.404-.098-.65-.503-.554-.906l3.5-14.5c.098-.403.51-.645.905-.553.404.097.65.502.554.905l-3.5 14.5c-.083.344-.39.574-.728.574"
        })
    });
const $ed6a757eee09667b$var$$7cd619eef1b10f40$var$ForwardRef = (0, $eF4cA.forwardRef)($ed6a757eee09667b$var$$7cd619eef1b10f40$var$SvgComponent);
var $ed6a757eee09667b$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($ed6a757eee09667b$var$$7cd619eef1b10f40$var$ForwardRef);



var $fmJ8d = parcelRequire("fmJ8d");

var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");


var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");


var $4W5AG = parcelRequire("4W5AG");
var $33cDE = parcelRequire("33cDE");
var $208Op = parcelRequire("208Op");
var $j8RRT = parcelRequire("j8RRT");



var $dm5H1 = parcelRequire("dm5H1");

var $dx4lB = parcelRequire("dx4lB");

var $eF4cA = parcelRequire("eF4cA");
const $659c47d1b1d2e378$var$$f0d0dd0d03847be4$var$SvgComponent = (props, ref)=>(0, $dx4lB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: (0, $dx4lB.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 8.5H3.75c-.414 0-.75-.336-.75-.75S3.336 7 3.75 7h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 16.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const $659c47d1b1d2e378$var$$f0d0dd0d03847be4$var$ForwardRef = (0, $eF4cA.forwardRef)($659c47d1b1d2e378$var$$f0d0dd0d03847be4$var$SvgComponent);
var $659c47d1b1d2e378$export$2e2bcd8739ae039 = (0, $dm5H1.createIcon)($659c47d1b1d2e378$var$$f0d0dd0d03847be4$var$ForwardRef);



var $4SSyx = parcelRequire("4SSyx");

var $aKSBi = parcelRequire("aKSBi");

const $5b0c4518d80e0b7e$export$371a00b150cf7e24 = [
    {
        id: "gpt-5.6-luna",
        name: "GPT 5.6 Luna",
        description: "Low cost"
    },
    {
        id: "gpt-5.6-terra",
        name: "GPT 5.6 Terra",
        description: "Medium cost"
    },
    {
        id: "gpt-5.6-sol",
        name: "GPT 5.6 Sol",
        description: "High cost"
    }
];
const $5b0c4518d80e0b7e$export$5d6d3a208ad4c963 = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Copilot"
        }
    ]);
    const [shouldIncludeContext, setShouldIncludeContext] = (0, $eF4cA.useState)(true);
    const [model, setModel] = (0, $eF4cA.useState)($5b0c4518d80e0b7e$export$371a00b150cf7e24[0].id);
    const useAgent = !model.includes("-standalone");
    const [view, setView] = (0, $eF4cA.useState)(localStorage.getItem("BeStory_copilotView") || "code");
    const [systemPrompt, setSystemPrompt] = (0, $eF4cA.useState)(localStorage.getItem("BeStory_copilotSystemPrompt") || "");
    const [userPrompt, setUserPrompt] = (0, $eF4cA.useState)("");
    const zoltar = (0, $4SSyx.useZoltarMutation)();
    const zoltarData = (0, $eF4cA.useMemo)(()=>{
        try {
            if (!(0, $aKSBi.isZoltarGenerateOk)(zoltar.data)) return {};
            return (0, $aKSBi.parseZoltarGenerateJson)(zoltar.data, "{}");
        } catch (error) {
            console.warn("Failed to parse Zoltar response:", error, zoltar.data);
            return zoltar?.data?.envelope?.text ?? {};
        }
    }, [
        zoltar.data
    ]);
    const getPromptTemplate = (0, $eF4cA.useCallback)(()=>{
        const template = [];
        if (shouldIncludeContext && zoltar.data?.messages?.length) {
            template.push(...(0, $aKSBi.zoltarLangchainMessagesToPromptTemplate)(zoltar.data.messages));
            template.push({
                role: "user",
                prompt_template: userPrompt
            });
        } else {
            if (systemPrompt) template.push({
                role: "system",
                prompt_template: systemPrompt
            });
            else // if (!useAgent) {
            // Had to add this to get responses from zoltar for simple questions
            template.splice(0, 0, {
                role: "system",
                prompt_template: "You are a helpful assistant that returns valid JSON responses."
            });
            if (userPrompt) template.push({
                role: "user",
                prompt_template: userPrompt
            });
        }
        return template;
    }, [
        systemPrompt,
        userPrompt,
        shouldIncludeContext,
        zoltar.data,
        useAgent
    ]);
    const handleSend = (0, $eF4cA.useCallback)(()=>{
        const promptTemplate = getPromptTemplate();
        zoltar.mutate({
            useAgent: useAgent,
            promptTemplate: promptTemplate,
            model: model,
            skills: "all"
        }, {
            onSuccess: ()=>{
                setUserPrompt("");
            }
        });
    }, [
        zoltar.mutate,
        useAgent,
        getPromptTemplate,
        model
    ]);
    (0, $eF4cA.useEffect)(()=>{
        localStorage.setItem("BeStory_copilotSystemPrompt", systemPrompt);
    }, [
        systemPrompt
    ]);
    (0, $eF4cA.useEffect)(()=>{
        localStorage.setItem("BeStory_copilotView", view);
    }, [
        view
    ]);
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: `Copilot | BeStory`
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " sd182 _ta182 Ur182 qr182 _oa182 Za182 FKPwxte182 LvuBnEc182 IM182 HM182",
                children: [
                    zoltar.isSuccess && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4836215752023500$export$668709c620d0b8e2), {
                        selectedKey: view,
                        onSelectionChange: setView,
                        styles: " IM182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                id: "preview",
                                "aria-label": "Preview view",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $659c47d1b1d2e378$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                id: "code",
                                "aria-label": "Code view",
                                children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ed6a757eee09667b$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " _ub182 Pa182",
                        children: [
                            zoltar.isPending && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " Za182 Fb182 sd182 eb182 _Ca182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 ec182 Uj182 qj182 IM182 HM182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $41e172257332f72e$export$c17561cb55d4db30), {
                                            isIndeterminate: true,
                                            label: "Generating response"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                            onPress: zoltar.reset,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            }),
                            zoltar.isSuccess && view === "preview" && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " sd182 _ta182 Za182 Ul182 ql182",
                                children: Object.entries(zoltarData).map(([key, value])=>/*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                        id: key,
                                        className: " sd182 _ta182 Ue182 qe182 Za182 _oa182 g_g182 _nLeasBb182 oe182 ne182 ke182 je182 Sf182 Rf182 Te182 Qe182",
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                                children: key
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182",
                                                children: Array.isArray(value) ? value.map((item, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                                                        children: typeof item === "object" ? JSON.stringify(item, null, 2) : String(item)
                                                    }, index)) : typeof value === "object" ? JSON.stringify(value, null, 2) : String(value)
                                            })
                                        ]
                                    }, key))
                            }),
                            zoltar.isSuccess && view === "code" && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $74d890f6f2a4f834$export$61f100e67ffb6850), {
                                language: "json",
                                code: JSON.stringify(zoltarData, null, 2)
                            }),
                            zoltar.isSuccess && !view && /*#__PURE__*/ (0, $dx4lB.jsx)("code", {
                                className: " uj182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 _de182",
                                children: JSON.stringify(zoltarData, null, 2)
                            }),
                            zoltar.isError && /*#__PURE__*/ (0, $dx4lB.jsx)("code", {
                                className: " uj182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 _de182",
                                children: JSON.stringify(zoltar.error, null, 2)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " sd182 Uj182 qj182 ec182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 Uj182 qj182 _ub182",
                                children: [
                                    !(zoltar.isPending || zoltar.isSuccess && shouldIncludeContext) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                        label: "System prompt",
                                        value: systemPrompt,
                                        onChange: setSystemPrompt,
                                        styles: " _ub182 Td182 Qd182 Sd182 Rd182",
                                        UNSAFE_className: "__PromptInput"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                        label: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    slot: "description",
                                                    children: "User prompt"
                                                }),
                                                zoltar.isSuccess && shouldIncludeContext && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                    slot: "description",
                                                    styles: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-b182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pn182 Iv182",
                                                    children: "Previous conversation context will be included."
                                                })
                                            ]
                                        }),
                                        placeholder: "Explain the concept of React hooks in simple terms.",
                                        value: userPrompt,
                                        onChange: setUserPrompt,
                                        isDisabled: zoltar.isPending,
                                        styles: " _ub182 Td182 Qd182 Sd182 Rd182",
                                        UNSAFE_className: "__PromptInput"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 Ul182 ql182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                        label: "Model",
                                        selectedKey: model,
                                        onSelectionChange: setModel,
                                        isDisabled: shouldIncludeContext && zoltar.isSuccess,
                                        children: $5b0c4518d80e0b7e$export$371a00b150cf7e24.map((m)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                id: m.id,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "label",
                                                        children: m.name
                                                    }),
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: m.description
                                                    })
                                                ]
                                            }, m.id))
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                                        isSelected: shouldIncludeContext,
                                        onChange: setShouldIncludeContext,
                                        children: "Include context"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                        "aria-label": "Send",
                                        onPress: handleSend,
                                        isDisabled: zoltar.isPending,
                                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d98385a72966f675$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $0db46de21849ea3f$export$9c997c4cbc6c218b = ()=>{
    (0, $0de8615f62ba4b65$export$8cefe241bd876ca0)([
        {
            label: "Admin",
            href: "/admin"
        },
        {
            label: "Zoltar Prompts"
        }
    ]);
    const prompts = (0, $4SSyx.useSystemPrompts)();
    const zoltar = (0, $4SSyx.useZoltarMutation)();
    const labeling = (0, $4SSyx.useImageLabeling)();
    const [mode, setMode] = (0, $eF4cA.useState)("generate");
    const [promptId, setPromptId] = (0, $eF4cA.useState)(null);
    const [promptText, setPromptText] = (0, $eF4cA.useState)("");
    const [userInput, setUserInput] = (0, $eF4cA.useState)("");
    const [imageUrl, setImageUrl] = (0, $eF4cA.useState)("");
    const [model, setModel] = (0, $eF4cA.useState)((0, $5b0c4518d80e0b7e$export$371a00b150cf7e24)[0].id);
    const [useSchema, setUseSchema] = (0, $eF4cA.useState)(true);
    const [curl, setCurl] = (0, $eF4cA.useState)("");
    const [isCurlPending, setIsCurlPending] = (0, $eF4cA.useState)(false);
    const userEmail = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.ims?.profile?.email);
    const isImageMode = mode === "image";
    const request = isImageMode ? labeling : zoltar;
    const selectedPrompt = (0, $eF4cA.useMemo)(()=>prompts.data?.find((p)=>p._id === promptId), [
        prompts.data,
        promptId
    ]);
    const hasSchema = Boolean(selectedPrompt?.schema);
    const handlePromptChange = (0, $eF4cA.useCallback)((id)=>{
        setPromptId(id);
        setPromptText(prompts.data?.find((p)=>p._id === id)?.prompt ?? "");
        setMode((0, $aKSBi.IMAGE_LABELING_PROMPT_IDS).includes(id) ? "image" : "generate");
    }, [
        prompts.data
    ]);
    const result = (0, $eF4cA.useMemo)(()=>{
        if (isImageMode) return labeling.data ?? {};
        try {
            if (!(0, $aKSBi.isZoltarGenerateOk)(zoltar.data)) return {};
            return (0, $aKSBi.parseZoltarGenerateJson)(zoltar.data, "{}");
        } catch (error) {
            console.warn("Failed to parse Zoltar response:", error, zoltar.data);
            return zoltar?.data?.envelope?.text ?? {};
        }
    }, [
        isImageMode,
        labeling.data,
        zoltar.data
    ]);
    const variables = (0, $eF4cA.useMemo)(()=>{
        // An unedited stored prompt is sent by ID, exactly like the app does.
        const isStoredPrompt = selectedPrompt && promptText === selectedPrompt.prompt;
        if (isImageMode) return {
            imageUrl: imageUrl.trim(),
            ...isStoredPrompt ? {
                systemPromptId: selectedPrompt._id
            } : {
                promptTemplate: promptText
            },
            ...userInput.trim() ? {
                userInput: userInput
            } : {}
        };
        const userMessages = userInput.trim() ? [
            {
                role: "user",
                prompt_template: userInput
            }
        ] : [];
        // The stored-prompt path always applies the stored schema.
        if (isStoredPrompt && (useSchema || !hasSchema)) return {
            systemPromptId: selectedPrompt._id,
            promptTemplate: userMessages,
            model: model
        };
        return {
            promptTemplate: [
                {
                    role: "system",
                    prompt_template: promptText
                },
                ...userMessages
            ],
            model: model,
            schema: useSchema && hasSchema ? selectedPrompt.schema : undefined
        };
    }, [
        isImageMode,
        imageUrl,
        promptText,
        userInput,
        model,
        useSchema,
        hasSchema,
        selectedPrompt
    ]);
    // A fresh object per run: useZoltarMutation keys the agent thread by variables identity.
    const handleRun = (0, $eF4cA.useCallback)(()=>request.mutate({
            ...variables
        }), [
        request.mutate,
        variables
    ]);
    const handleCurl = (0, $eF4cA.useCallback)(async ()=>{
        setIsCurlPending(true);
        try {
            const command = await (0, $aKSBi.getZoltarCurl)(isImageMode ? {
                endpoint: "imageLabeling",
                imageUrl: variables.imageUrl,
                prompt_template: variables.promptTemplate,
                systemPromptId: variables.systemPromptId,
                user_input: variables.userInput
            } : {
                endpoint: "generateContent",
                useAgent: true,
                user: userEmail,
                prompt_template: variables.promptTemplate,
                systemPromptId: variables.systemPromptId,
                model: variables.model,
                schema: variables.schema
            });
            setCurl(command);
            try {
                await navigator.clipboard.writeText(command);
                (0, $8u8Xx.ToastQueue).positive("cURL copied", {
                    timeout: 3000
                });
            } catch  {
                (0, $8u8Xx.ToastQueue).neutral("cURL generated", {
                    timeout: 3000
                });
            }
        } catch (error) {
            (0, $8u8Xx.ToastQueue).negative(error.message, {
                timeout: 5000
            });
        } finally{
            setIsCurlPending(false);
        }
    }, [
        isImageMode,
        variables,
        userEmail
    ]);
    const isRunDisabled = request.isPending || !promptText.trim() || isImageMode && !imageUrl.trim();
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsx)("title", {
                children: `Zoltar Prompts | BeStory`
            }),
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: " se182 D53rtud182 Up182 qp182 _oa182 Za182 FKPwxte182 IM182 HM182",
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " z3mU182 B2mU182 sd182 _ta182 Ul182 ql182 Ma182 Pa182 _oa182 Tf182 Qf182 Sf182 Rf182 oe182 ne182 ke182 je182 gqlRAZb182",
                        children: [
                            curl && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                        children: "cURL"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("code", {
                                        className: " uj182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 -nTSCV-cB9Fab182",
                                        children: curl
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-c182 vx182 xc182 _xa182 xfd182 _xfa182 xfX0cczbc182 _xfX0cczba182 _Fd182 _FnuYUweb182 pv182",
                                children: "Response"
                            }),
                            request.isIdle && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " Za182 Fb182 sd182 eb182 _Ca182 uk182 ucJ9TBTb182 ud3Euai182 uea182 ugb182 uhd182 uje182 u2NhKxcl182 uic182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pv182",
                                children: "Pick a prompt, adjust it, add user input and hit Run."
                            }),
                            request.isPending && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " Za182 Fb182 sd182 eb182 _Ca182",
                                children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                    className: " sd182 ec182 Uj182 qj182 IM182 HM182",
                                    children: [
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $41e172257332f72e$export$c17561cb55d4db30), {
                                            isIndeterminate: true,
                                            label: "Generating response"
                                        }),
                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4W5AG.ActionButton), {
                                            onPress: request.reset,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            }),
                            request.isSuccess && (typeof result === "string" ? /*#__PURE__*/ (0, $dx4lB.jsx)("code", {
                                className: " uj182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 _de182",
                                children: result
                            }) : /*#__PURE__*/ (0, $dx4lB.jsx)((0, $74d890f6f2a4f834$export$61f100e67ffb6850), {
                                language: "json",
                                code: JSON.stringify(result, null, 2)
                            })),
                            request.isError && /*#__PURE__*/ (0, $dx4lB.jsxs)("code", {
                                className: " uj182 -_6BNtrc-d182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182 _7f182 _de182",
                                children: [
                                    request.error?.message,
                                    "\n",
                                    JSON.stringify(request.error?.cause?.data ?? request.error, null, 2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        className: " z2mU182 B2mU182 sd182 _ta182 Uj182 qj182 Ma182 Pa182",
                        children: [
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _ta182 Uj182 qj182 _ub182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                        label: "Zoltar prompt",
                                        placeholder: prompts.isLoading ? "Loading prompts\u2026" : "Select a prompt",
                                        selectedKey: promptId,
                                        onSelectionChange: handlePromptChange,
                                        isDisabled: prompts.isLoading || request.isPending,
                                        isInvalid: prompts.isError,
                                        errorMessage: prompts.error?.message,
                                        styles: " Za182",
                                        children: (prompts.data ?? []).map((p)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                id: p._id,
                                                children: [
                                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "label",
                                                        children: p._id
                                                    }),
                                                    (0, $aKSBi.IMAGE_LABELING_PROMPT_IDS).includes(p._id) && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                        slot: "description",
                                                        children: "Image labeling"
                                                    })
                                                ]
                                            }, p._id))
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                        label: "System prompt",
                                        value: promptText,
                                        onChange: setPromptText,
                                        isDisabled: request.isPending,
                                        styles: " _ub182 Td182 Qd182 Sd182 Rd182",
                                        UNSAFE_className: "__PromptInput"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextArea), {
                                        label: "User input",
                                        placeholder: "COMPANY_NAME: Adobe\nPRODUCT: Photoshop",
                                        value: userInput,
                                        onChange: setUserInput,
                                        isDisabled: request.isPending,
                                        styles: " _ub182 Td182 Qd182 Sd182 Rd182",
                                        UNSAFE_className: "__PromptInput __PromptInput--narrow"
                                    }),
                                    isImageMode && /*#__PURE__*/ (0, $dx4lB.jsx)((0, $j8RRT.TextField), {
                                        label: "Image URL",
                                        type: "url",
                                        placeholder: "https://\u2026",
                                        value: imageUrl,
                                        onChange: setImageUrl,
                                        isDisabled: request.isPending,
                                        isRequired: true,
                                        styles: " Za182"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: " sd182 _wb182 ec182 Ul182 ql182",
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4836215752023500$export$668709c620d0b8e2), {
                                        "aria-label": "Endpoint",
                                        selectedKey: mode,
                                        onSelectionChange: setMode,
                                        isDisabled: request.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                                id: "generate",
                                                children: "Generate"
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $4836215752023500$export$4fc12f2742e8cf3f), {
                                                id: "image",
                                                children: "Image labeling"
                                            })
                                        ]
                                    }),
                                    !isImageMode && /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dx4lB.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $167b1d74632fc01a$export$ba25329847403e11), {
                                                label: "Model",
                                                selectedKey: model,
                                                onSelectionChange: setModel,
                                                isDisabled: request.isPending,
                                                children: (0, $5b0c4518d80e0b7e$export$371a00b150cf7e24).map((m)=>/*#__PURE__*/ (0, $dx4lB.jsxs)((0, $167b1d74632fc01a$export$d601881f38163e28), {
                                                        id: m.id,
                                                        children: [
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                slot: "label",
                                                                children: m.name
                                                            }),
                                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                                slot: "description",
                                                                children: m.description
                                                            })
                                                        ]
                                                    }, m.id))
                                            }),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $33cDE.Switch), {
                                                isSelected: useSchema && hasSchema,
                                                onChange: setUseSchema,
                                                isDisabled: !hasSchema,
                                                children: "Use prompt schema"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $34HUQ.Button), {
                                        variant: "accent",
                                        onPress: handleRun,
                                        isDisabled: isRunDisabled,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d98385a72966f675$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "Run"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $4W5AG.ActionButton), {
                                        size: "S",
                                        onPress: handleCurl,
                                        isDisabled: isRunDisabled || isCurlPending,
                                        children: [
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ed6a757eee09667b$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                                                children: "cURL"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


var $6f1dace0654fa166$exports = {};
$6f1dace0654fa166$exports = import.meta.resolve("aMYQZ");


const $421114b3a8240f3f$var$darkVideoURL = new URL($6f1dace0654fa166$exports).href;
var $8ae2270504c37b2f$exports = {};
$8ae2270504c37b2f$exports = import.meta.resolve("aywcZ");


const $421114b3a8240f3f$var$lightVideoURL = new URL($8ae2270504c37b2f$exports).href;
// Legacy `/videos/*` URLs (bookmarks, emails, shared links) now live under `/projects/*`.
const $421114b3a8240f3f$var$VideosRedirect = ()=>{
    const { "*": rest } = (0, $dqZbZ.useParams)();
    const { search: search, hash: hash } = (0, $dqZbZ.useLocation)();
    const target = rest ? `/projects/${rest}` : "/projects";
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Navigate), {
        to: `${target}${search}${hash}`,
        replace: true
    });
};
const $421114b3a8240f3f$export$c84671f46d6a1ca = ()=>{
    const isIndex = (0, $dqZbZ.useMatch)("/");
    const isStory = (0, $dqZbZ.useMatch)("/stories/:id");
    (0, $dSkgb.usePageTracking)();
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const videoURL = colorScheme === "dark" ? $421114b3a8240f3f$var$darkVideoURL : $421114b3a8240f3f$var$lightVideoURL;
    const padding = !isStory ? "default" : "none";
    const { data: alerts } = (0, $1b214b7de04dc547$export$5190ebb7bea2fe30)();
    return /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $0de8615f62ba4b65$export$5eb09e7a134d225e), {
        children: [
            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' se182';
                    rules += ' C9WVyzc182';
                    rules += ' CpnBfxn182';
                    rules += ' DQgYBrc182';
                    rules += ' DpnIuDcd182';
                    if (props.isIndex) rules += ' ET4FrIb182';
                    else rules += ' E824MJc182';
                    if (props.isIndex) rules += ' EpQBbwE182';
                    else rules += ' Ep5zARFb182';
                    rules += ' _Ch182';
                    rules += ' _Dd182';
                    rules += ' _oa182';
                    rules += ' Zb182';
                    rules += ' Fc182';
                    return rules;
                }({
                    isIndex: false
                }),
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $74d8869ffd4e0558$export$494cf78290fbe4c7), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $1f7d28ef023026e3$export$8b251419efc915eb), {
                        styles: " z6Akec182 y6Akec182 B6Akec182 A6Akec182 sk182 spe182 eb182 Ue182 qe182 Tt182 Qt182 St182 Rh182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8378bdc454a470ad$export$1a35787d6353cf6a), {
                        styles: " sk182 spd182 zCn4fn182 yCn4fn182 BCn4fn182 ACn4fn182 _oa182 Tf182 Qf182 Ix182 Hx182"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                        id: "beStory-content",
                        className: " zk52g2d182 yk52g2d182 Bk52g2d182 Ak52g2d182 Pa182 Lb182 sd182 _ta182 _Cg182 gX182 oc182 nc182 kd182 jd182 _n4zCLMe182 _Pc182 _9b182",
                        children: [
                            !!alerts?.length && /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                className: " _Pe182 Wr182 _9c182",
                                children: alerts?.map((alert, index)=>/*#__PURE__*/ (0, $dx4lB.jsx)((0, $747531ddbc1c9a67$export$40137d14c0f88992), {
                                        variant: alert.variant,
                                        children: alert.message
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                                className: function anonymous(props) {
                                    let rules = " ";
                                    rules += ' _ub182';
                                    rules += ' _vb182';
                                    rules += ' _sb182';
                                    rules += ' Ma182';
                                    rules += ' sd182';
                                    rules += ' _ta182';
                                    rules += ' _Cg182';
                                    if (props.padding === "none") rules += ' Sd182';
                                    else if (props.padding === "default") rules += ' Sh182';
                                    if (props.padding === "none") rules += ' Rd182';
                                    else if (props.padding === "default") rules += ' Rh182';
                                    rules += ' _Pc182';
                                    rules += ' _9b182';
                                    return rules;
                                }({
                                    padding: padding
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0a53e8d7a144b92d$export$3c7591733da6b830), {
                                        src: videoURL,
                                        variant: isIndex ? "default" : "faded"
                                    }),
                                    /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                                        className: " _oa182 _ub182 _vb182 _sb182 Ma182 Za182 Fb182 IM182 HM182 Th182 Qh182 sd182 _ta182 _9c182",
                                        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dqZbZ.Routes), {
                                            children: [
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                    index: true,
                                                    element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e1b5010755d49b5f$export$318ffe1a9c370f63), {})
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dqZbZ.Route), {
                                                    path: "stories",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5d122a3a98a3c1bc$export$2bd3254512ec27f), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "new/:id?/:step?",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a17caf9b7a820813$export$e9d66656d090d4fb), {
                                                                type: [
                                                                    "html"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: ":id",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7e0d57b7600d409b$export$d77e5bb2c63f80a6), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dqZbZ.Route), {
                                                    path: "templates",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $ffccd5089ec80d3f$export$c5a06aa0f041765d), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: ":id",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $26efba7f609df70d$export$85c5def18439af89), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dqZbZ.Route), {
                                                    path: "projects",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $610ad9406709a690$export$bed2a88f4410ddab), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "user/:email",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $610ad9406709a690$export$bed2a88f4410ddab), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "composer/:id?/:step?",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a17caf9b7a820813$export$e9d66656d090d4fb), {
                                                                type: "modular"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "new/:id?/:step?",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a17caf9b7a820813$export$e9d66656d090d4fb), {
                                                                type: [
                                                                    "express",
                                                                    "mogrt"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: ":id",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $6161d14592537c19$export$a64da8fc8b9c1af9), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                    path: "videos/*",
                                                    element: /*#__PURE__*/ (0, $dx4lB.jsx)($421114b3a8240f3f$var$VideosRedirect, {})
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dqZbZ.Route), {
                                                    path: "admin",
                                                    children: [
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $46bd48a5027fc8f9$export$7043b2aa75252c56), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "prompts",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $0db46de21849ea3f$export$9c997c4cbc6c218b), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "mogrt",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e939fd3c2dbc7623$export$476f585032a02a7), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "text-to-speech",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $e0ddec1a8a315d02$export$ca7dc72f8299f9d5), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "image-crop",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $99909ca2e3efdc55$export$18c2f789cd09859b), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "users",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $b2ed56c0a3f09afd$export$533df511bb77d595), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "projects",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $d9e8854f231f3155$export$9bd3fdad9c942af4), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "videos",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Navigate), {
                                                                to: "/admin/projects",
                                                                replace: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "fluffyjaws",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $9d3717861dbccb56$export$8f6dd57b7b2b1b34), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "footage",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c4ef23ecc47e93fb$export$8f89b0858164f318), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                            path: "integrations",
                                                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $49c9b312c3fd29bf$export$81a8d757b4fb2689), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Navigate), {
                                                        to: "/",
                                                        replace: true
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8u8Xx.ToastContainer), {
                placement: "bottom center"
            })
        ]
    });
};



var $dx4lB = parcelRequire("dx4lB");

var $dqZbZ = parcelRequire("dqZbZ");
/*
 * Registry of standalone views mounted under `/view/:viewId`.
 *
 * Views listed here render OUTSIDE the default app layout (no header, side nav,
 * background grid, etc.). Each view is responsible for defining its own main
 * layout. To add a view, map its `viewId` to a component:
 *
 *   import { MyView } from "./my-view/MyView";
 *
 *   export const views = {
 *     "my-view": MyView,
 *   };
 *
 * The matched component is rendered under `/view/:viewId/*`, so a view may
 * declare its own nested `<Routes>` relative to `/view/:viewId`.
 */ const $b4f2c8d373210b14$export$d0079916fe6800ac = {};


const $2c4536f1225dbeb2$export$27a5bd065ad55220 = ()=>{
    const { viewId: viewId } = (0, $dqZbZ.useParams)();
    const ViewComponent = (0, $b4f2c8d373210b14$export$d0079916fe6800ac)[viewId];
    if (!ViewComponent) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $dx4lB.jsx)(ViewComponent, {});
};



function $5cd1093c543210ac$var$App() {
    const locale = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.locale);
    const colorScheme = (0, $5IZkx.useStore)((0, $fmJ8d.store), (state)=>state.colorScheme);
    const navigate = (0, $dqZbZ.useNavigate)();
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8b4a29f41b68dc46$export$e926676385687eaf), {
        onError: onError,
        FallbackComponent: fallbackComponent,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $70d036432997ba9c$export$9d736f54481e482f), {
            client: (0, $1B1zl.queryClient),
            persistOptions: {
                persister: (0, $1B1zl.asyncStoragePersister)
            },
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $arisx.Provider), {
                colorScheme: colorScheme,
                locale: locale,
                router: {
                    navigate: navigate
                },
                background: "layer-1",
                children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $dqZbZ.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                            path: "/view/:viewId/*",
                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $2c4536f1225dbeb2$export$27a5bd065ad55220), {})
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.Route), {
                            path: "/*",
                            element: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $421114b3a8240f3f$export$c84671f46d6a1ca), {})
                        })
                    ]
                })
            })
        })
    });
    // Methods
    // error handler on UI rendering failure
    function onError(e, componentStack) {}
    // component to show if UI fails rendering
    function fallbackComponent({ error: error, resetErrorBoundary: resetErrorBoundary }) {
        console.warn(error);
        return /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            className: " sd182 eb182 _Ca182 Zb182 Fc182",
            children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $7ba0028f406a9726$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                        children: "Oops, something went wrong"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
                            className: " uj182 -_6BNtrc-c182 vx182 xb182 _xa182 _Fb182 _FnuYUwec182 pt182",
                            children: error?.message ?? "But no worries. Let's give it another go."
                        })
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                            variant: "primary",
                            onPress: resetErrorBoundary,
                            children: "Try again"
                        })
                    })
                ]
            })
        });
    }
}
var $5cd1093c543210ac$export$2e2bcd8739ae039 = $5cd1093c543210ac$var$App;



var $dx4lB = parcelRequire("dx4lB");
parcelRequire("eF4cA");

var $fZShI = parcelRequire("fZShI");
var $arisx = parcelRequire("arisx");

function $c2547c749e0b58ee$var$LoadingSpinner() {
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $arisx.Provider), {
        background: "layer-2",
        children: /*#__PURE__*/ (0, $dx4lB.jsx)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100vw",
                height: "100vh",
                flexDirection: "column",
                gap: "12px"
            },
            children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fZShI.ProgressCircle), {
                size: "L",
                "aria-label": "Loading authentication status",
                isIndeterminate: true,
                staticColor: true
            })
        })
    });
}
var $c2547c749e0b58ee$export$2e2bcd8739ae039 = $c2547c749e0b58ee$var$LoadingSpinner;


const $fb17d53d5093097c$var$IMS_CONFIG = {
    clientId: "bestory-prod",
    scope: "openid,email,profile,AdobeID,org.read,read_organizations,ab.manage,express_api,ee.express_api,firefly_api,additional_info.ownerOrg",
    adobeIncOrgId: "EE9332B3547CC74E0A4C98A1@AdobeOrg",
    environment: "prod"
};
const $fb17d53d5093097c$var$parseAllowedEmails = ()=>{
    var email;
    return [];
};
let $fb17d53d5093097c$var$imsBootstrapStarted = false;
function $fb17d53d5093097c$var$AuthWrapper({ locale: locale = "en-US" }) {
    const [isAuthenticated, setIsAuthenticated] = (0, $eF4cA.useState)(false);
    const [isAdobeIncMember, setIsAdobeIncMember] = (0, $eF4cA.useState)(false);
    const [isAuthorized, setIsAuthorized] = (0, $eF4cA.useState)(false);
    const [error, setError] = (0, $eF4cA.useState)(null);
    const [isInitializing, setIsInitializing] = (0, $eF4cA.useState)(true);
    const [allowedEmails] = (0, $eF4cA.useState)($fb17d53d5093097c$var$parseAllowedEmails());
    const navigate = (0, $dqZbZ.useNavigate)();
    const initializeIMS = async ()=>{
        try {
            setError(null);
            setIsInitializing(true);
            await (0, $8PkOq.IMS).initialize($fb17d53d5093097c$var$IMS_CONFIG);
            // Check authentication status
            await checkAuthStatus();
        } catch (err) {
            console.error("IMS initialization failed:", err);
            setError(err.message || "IMS initialization failed");
            setIsAuthenticated(false);
        } finally{
            setIsInitializing(false);
        }
    };
    /**
   * Check if email is in the allowed list
   */ const isEmailAllowed = (0, $eF4cA.useCallback)((email)=>{
        if (!email) return false;
        // Allow all users
        if (allowedEmails.length === 0) return true;
        const normalizedEmail = email.toLowerCase().trim();
        const isAllowed = allowedEmails.some((allowedEmail)=>allowedEmail.toLowerCase().trim() === normalizedEmail);
        console.log("Is Allowed", isAllowed);
        return isAllowed;
    }, [
        allowedEmails
    ]);
    const checkUserAuthorization = (0, $eF4cA.useCallback)((profile)=>{
        const isAdobeInc = profile?.ownerOrg === $fb17d53d5093097c$var$IMS_CONFIG.adobeIncOrgId;
        console.log("Is Adobe Inc", isAdobeInc);
        return {
            isAdobeIncMember: isAdobeInc === true,
            isEmailAllowed: isEmailAllowed(profile?.email)
        };
    }, []);
    /**
   * Check authentication status
   */ const checkAuthStatus = async ()=>{
        try {
            // Check if user is signed in
            const isSignedIn = (0, $8PkOq.IMS).isSignedIn;
            if (isSignedIn) {
                const profile = await (0, $8PkOq.IMS).getUserProfile();
                const { isAdobeIncMember: isAdobeIncMember, isEmailAllowed: isEmailAllowed } = checkUserAuthorization(profile);
                setIsAuthenticated(true);
                setIsAdobeIncMember(isAdobeIncMember);
                setIsAuthorized(isEmailAllowed);
                const token = await (0, $8PkOq.IMS).getAccessToken();
                (0, $fmJ8d.store).getState().setIms({
                    ims: {
                        profile: {
                            id: profile.id,
                            email: profile.email,
                            fullName: profile.fullName,
                            firstName: profile.firstName,
                            lastName: profile.lastName,
                            ownerOrg: profile.ownerOrg,
                            ldap: profile.ldap,
                            avatar: `https://ab.adobe-identity.com/api/avatars/50/${profile.id}`
                        },
                        token: token ?? null,
                        org: null,
                        isLoggedIn: true
                    },
                    locale: "en-US"
                });
                // Handle redirect if needed
                const redirectPath = (0, $fmJ8d.store).getState().redirectPath;
                if (redirectPath) {
                    (0, $fmJ8d.store).getState().setRedirectPath(null);
                    navigate(redirectPath);
                }
            } else {
                // Not authenticated, trigger sign in
                setIsAuthenticated(false);
                setIsAuthorized(false);
                await handleLogin();
            }
        } catch (err) {
            console.error("Authentication check failed:", err);
            const needsForcedPicker = err?.message?.startsWith("401:");
            const needsSignIn = needsForcedPicker || err?.message === "User is not signed in!";
            if (needsSignIn) {
                (0, $fmJ8d.store).getState().clearIms();
                setIsAuthenticated(false);
                setIsAuthorized(false);
                setError(null);
                if (needsForcedPicker) (0, $8PkOq.markNextImsSignInForceAccountPicker)();
                await handleLogin();
                return;
            }
            setError(err.message || "Authentication failed");
            setIsAuthenticated(false);
            setIsAuthorized(false);
        }
    };
    /**
   * Handle login
   */ const handleLogin = async ()=>{
        try {
            const currentPath = window.location.pathname + window.location.search + window.location.hash;
            (0, $fmJ8d.store).getState().setRedirectPath(currentPath);
            await (0, $8PkOq.IMS).signIn(false);
        } catch (err) {
            console.error("Login failed:", err);
            setError(err.message || "Login failed");
        }
    };
    /**
   * Sign out and force account picker
   */ const handleSwitchAccount = async ()=>{
        (0, $8PkOq.markNextImsSignInForceAccountPicker)();
        await handleLogout();
    };
    /**
   * Handle logout
   */ const handleLogout = async ()=>{
        try {
            await (0, $8PkOq.IMS).signOut();
            setIsAuthenticated(false);
            setIsAdobeIncMember(false);
            setIsAuthorized(false);
        } catch (err) {
            console.error("Logout failed:", err);
            // Even if logout fails, clear local state
            (0, $fmJ8d.store).getState().clearIms();
            setIsAuthenticated(false);
            setIsAdobeIncMember(false);
            setIsAuthorized(false);
        }
    };
    const handleRetry = ()=>{
        window.location.reload();
    };
    (0, $eF4cA.useEffect)(()=>{
        if ($fb17d53d5093097c$var$imsBootstrapStarted) return;
        $fb17d53d5093097c$var$imsBootstrapStarted = true;
        initializeIMS();
    }, []);
    if (isInitializing) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c2547c749e0b58ee$export$2e2bcd8739ae039), {});
    if (error) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $arisx.Provider), {
        styles: " sd182 eb182 _Ca182 Fc182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
            size: "L",
            styles: " Lb4QY4182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a7459e5f3808edd1$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    children: "BeStory"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                    styles: " sd182 _ta182 eb182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "Authentication Error"
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        onPress: handleRetry,
                        variant: "secondary",
                        children: "Retry"
                    })
                })
            ]
        })
    });
    // Not authenticated yet — IMS redirect should be in flight
    if (!isAuthenticated) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $c2547c749e0b58ee$export$2e2bcd8739ae039), {});
    // Show error state if user is authenticated but email is not authorized
    if (isAuthenticated && !isAuthorized) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $arisx.Provider), {
        styles: " sd182 eb182 _Ca182 Fc182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
            size: "L",
            styles: " Lb4QY4182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a7459e5f3808edd1$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    children: "BeStory"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Content), {
                    styles: " sd182 _ta182 eb182",
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                        children: "You are not authorized to access this application."
                    })
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.LinkButton), {
                        href: "https://bestory.adobe.com",
                        variant: "secondary",
                        children: "Proceed to BeStory"
                    })
                })
            ]
        })
    });
    // Show error state if user is authenticated but not Adobe Inc member
    if (isAuthenticated && !isAdobeIncMember) return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $arisx.Provider), {
        styles: " sd182 eb182 _Ca182 Fc182",
        children: /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $c0XRK.IllustratedMessage), {
            size: "L",
            styles: " Lb4QY4182",
            children: [
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $a7459e5f3808edd1$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Heading), {
                    children: "BeStory"
                }),
                /*#__PURE__*/ (0, $dx4lB.jsxs)((0, $208Op.Content), {
                    styles: " sd182 _ta182 eb182",
                    children: [
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Authentication Error"
                        }),
                        /*#__PURE__*/ (0, $dx4lB.jsx)((0, $208Op.Text), {
                            children: "Please use the Adobe Inc. profile (@adobe.com)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dx4lB.jsx)((0, $lK44Y.ButtonGroup), {
                    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $34HUQ.Button), {
                        onPress: handleSwitchAccount,
                        variant: "secondary",
                        children: "Sign in with different account"
                    })
                })
            ]
        })
    });
    // Show main app if authenticated, authorized, and Adobe Inc member
    return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $8b4a29f41b68dc46$export$e926676385687eaf), {
        onError: onError,
        FallbackComponent: fallbackComponent,
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $5cd1093c543210ac$export$2e2bcd8739ae039), {
            locale: locale,
            onLogout: handleLogout
        })
    });
    // Error handling methods
    function onError(e, componentStack) {
        console.error("App error:", e, componentStack);
    }
    function fallbackComponent({ error: error, resetErrorBoundary: resetErrorBoundary }) {
        return /*#__PURE__*/ (0, $dx4lB.jsx)((0, $arisx.Provider), {
            locale: locale,
            background: "layer-2",
            children: /*#__PURE__*/ (0, $dx4lB.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    flexDirection: "column",
                    gap: "16px"
                },
                children: [
                    /*#__PURE__*/ (0, $dx4lB.jsx)("h2", {
                        children: "Something went wrong"
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("p", {
                        children: error.message
                    }),
                    /*#__PURE__*/ (0, $dx4lB.jsx)("button", {
                        onClick: resetErrorBoundary,
                        children: "Try again"
                    })
                ]
            })
        });
    }
}
var $fb17d53d5093097c$export$2e2bcd8739ae039 = $fb17d53d5093097c$var$AuthWrapper;



console.log("@bestory/ui version: 0.13.0");
// Render the application with AuthWrapper to handle OAuth authentication
const $96651837e6303057$var$root = (0, $215fd4c42096d4b2$exports.createRoot)(document.getElementById("root"), {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: $dcc25ca60a79753f$export$1e6f045b27b3cfb1((error, errorInfo)=>{
        console.warn("Uncaught error", error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: $dcc25ca60a79753f$export$1e6f045b27b3cfb1(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: $dcc25ca60a79753f$export$1e6f045b27b3cfb1()
});
$96651837e6303057$var$root.render(/*#__PURE__*/ (0, $dx4lB.jsx)((0, $eF4cA.StrictMode), {
    children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $dqZbZ.BrowserRouter), {
        children: /*#__PURE__*/ (0, $dx4lB.jsx)((0, $fb17d53d5093097c$export$2e2bcd8739ae039), {
            locale: "en-US"
        })
    })
}));


//# sourceMappingURL=web-src.8fbaa925.js.map
